
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("VVnlL", function(module, exports) {

$parcel$export(module.exports, "getSpaRoutes", () => $ef6e862e848d08e0$export$10439de9ce871f28);
/*
 * This file is generated. Do not modify manually
 * If you are adding or deleting a route, please run "yarn dev routes:generate-route-assets"
 * to re-generate this SPA route map and RouteName/RouteGroup types then commit the changes.
 * @generated SignedSource<<4fbdbb2387b6f85df0b43e6490e22742>>
 * @codegen-command: yarn dev routes:generate-route-map --filter spa
 */ 
var $UuOK7 = parcelRequire("UuOK7");

var $iTGOF = parcelRequire("iTGOF");

var $3Ro2a = parcelRequire("3Ro2a");

var $lLZ8x = parcelRequire("lLZ8x");

var $hHcn9 = parcelRequire("hHcn9");

var $vDjHk = parcelRequire("vDjHk");

var $9CxHM = parcelRequire("9CxHM");

var $eaKG5 = parcelRequire("eaKG5");

var $9wv3p = parcelRequire("9wv3p");

var $6DvyY = parcelRequire("6DvyY");

var $lGElM = parcelRequire("lGElM");

var $3bc6l = parcelRequire("3bc6l");

var $fpGzf = parcelRequire("fpGzf");

var $aVGYm = parcelRequire("aVGYm");

var $2DH60 = parcelRequire("2DH60");

var $7gypr = parcelRequire("7gypr");

var $cwKGx = parcelRequire("cwKGx");

var $jZMnM = parcelRequire("jZMnM");

var $dfdSu = parcelRequire("dfdSu");

var $ieqGd = parcelRequire("ieqGd");

var $JQ5Vt = parcelRequire("JQ5Vt");

var $eOPb5 = parcelRequire("eOPb5");

var $a5XVU = parcelRequire("a5XVU");

var $lUhpq = parcelRequire("lUhpq");

var $gktyQ = parcelRequire("gktyQ");

var $cmklJ = parcelRequire("cmklJ");

var $ca1Zm = parcelRequire("ca1Zm");

var $6GNmk = parcelRequire("6GNmk");

var $3T2Ye = parcelRequire("3T2Ye");

var $9CT95 = parcelRequire("9CT95");

var $6fdEz = parcelRequire("6fdEz");

var $8WMR9 = parcelRequire("8WMR9");

var $hSl7U = parcelRequire("hSl7U");

var $7kGnZ = parcelRequire("7kGnZ");

var $elyxq = parcelRequire("elyxq");

var $9F4ID = parcelRequire("9F4ID");

var $18W8Q = parcelRequire("18W8Q");

var $3ss0y = parcelRequire("3ss0y");

var $bNtXI = parcelRequire("bNtXI");

var $eAlzO = parcelRequire("eAlzO");

var $3KtPD = parcelRequire("3KtPD");

var $hkNW0 = parcelRequire("hkNW0");

var $1B0QU = parcelRequire("1B0QU");

var $igqAf = parcelRequire("igqAf");

var $h3WYk = parcelRequire("h3WYk");

var $dUuHj = parcelRequire("dUuHj");

var $eiK9n = parcelRequire("eiK9n");

var $4KinX = parcelRequire("4KinX");

var $d6K18 = parcelRequire("d6K18");

var $lIfPP = parcelRequire("lIfPP");

var $6IB0N = parcelRequire("6IB0N");

var $1sFpf = parcelRequire("1sFpf");

var $a2wNz = parcelRequire("a2wNz");

var $eghTD = parcelRequire("eghTD");

var $huQRU = parcelRequire("huQRU");

var $ajYJ1 = parcelRequire("ajYJ1");

var $47CVY = parcelRequire("47CVY");

var $hF0nU = parcelRequire("hF0nU");

var $ejDmq = parcelRequire("ejDmq");

var $difFp = parcelRequire("difFp");

var $anDMO = parcelRequire("anDMO");

var $dYbYB = parcelRequire("dYbYB");

var $dH2Tp = parcelRequire("dH2Tp");

var $ffFBX = parcelRequire("ffFBX");

var $1IKX7 = parcelRequire("1IKX7");

var $1K27j = parcelRequire("1K27j");

var $8DQ40 = parcelRequire("8DQ40");

var $hdWS0 = parcelRequire("hdWS0");

var $9MTKv = parcelRequire("9MTKv");

var $2XQq2 = parcelRequire("2XQq2");

var $58Cy7 = parcelRequire("58Cy7");

var $e1cjg = parcelRequire("e1cjg");

var $4t69d = parcelRequire("4t69d");

var $hu1w9 = parcelRequire("hu1w9");

var $akFeA = parcelRequire("akFeA");

var $cjFCA = parcelRequire("cjFCA");

var $8E1dI = parcelRequire("8E1dI");

var $3GuHG = parcelRequire("3GuHG");

var $WsHyA = parcelRequire("WsHyA");

var $6xRe5 = parcelRequire("6xRe5");

var $5eLaE = parcelRequire("5eLaE");

var $gnGkU = parcelRequire("gnGkU");

var $c74Xp = parcelRequire("c74Xp");

var $4Zw1h = parcelRequire("4Zw1h");

var $dqjth = parcelRequire("dqjth");

var $aw22a = parcelRequire("aw22a");

var $yVbxa = parcelRequire("yVbxa");

var $lYzgn = parcelRequire("lYzgn");

var $dAmDY = parcelRequire("dAmDY");

var $3MI0Z = parcelRequire("3MI0Z");

var $iYfXI = parcelRequire("iYfXI");

var $3kqBW = parcelRequire("3kqBW");

var $79qCU = parcelRequire("79qCU");

var $8brgy = parcelRequire("8brgy");

var $2fNbh = parcelRequire("2fNbh");

var $56moC = parcelRequire("56moC");

var $aNsRz = parcelRequire("aNsRz");

var $cmvi5 = parcelRequire("cmvi5");

var $hfMX7 = parcelRequire("hfMX7");

var $1zhx7 = parcelRequire("1zhx7");

var $dxMNj = parcelRequire("dxMNj");

var $hwgIz = parcelRequire("hwgIz");

var $d4tTc = parcelRequire("d4tTc");

var $Dkaoj = parcelRequire("Dkaoj");

var $hs0Ni = parcelRequire("hs0Ni");

var $8m0RN = parcelRequire("8m0RN");

var $dt3ZS = parcelRequire("dt3ZS");

var $GJOha = parcelRequire("GJOha");

var $hDU7Y = parcelRequire("hDU7Y");

var $dHqTd = parcelRequire("dHqTd");

var $9KhdI = parcelRequire("9KhdI");

var $6q1hh = parcelRequire("6q1hh");

var $7LUIt = parcelRequire("7LUIt");

var $3EMmS = parcelRequire("3EMmS");

var $4Ykyz = parcelRequire("4Ykyz");

var $4Yh3B = parcelRequire("4Yh3B");

var $5H5Rm = parcelRequire("5H5Rm");

var $dQtRM = parcelRequire("dQtRM");

var $iDxTp = parcelRequire("iDxTp");

var $75Ues = parcelRequire("75Ues");

var $jAB8i = parcelRequire("jAB8i");

var $5KvQp = parcelRequire("5KvQp");

var $3Yng9 = parcelRequire("3Yng9");

var $2B61u = parcelRequire("2B61u");

var $e04XT = parcelRequire("e04XT");

var $hGFnn = parcelRequire("hGFnn");

var $bAN0d = parcelRequire("bAN0d");

var $cLm5J = parcelRequire("cLm5J");

var $dbAmH = parcelRequire("dbAmH");

var $jPcas = parcelRequire("jPcas");

var $k7VEf = parcelRequire("k7VEf");

var $i27Sx = parcelRequire("i27Sx");

var $qjJTn = parcelRequire("qjJTn");

var $5xt55 = parcelRequire("5xt55");

var $4yINJ = parcelRequire("4yINJ");

var $bubms = parcelRequire("bubms");

var $fOrUU = parcelRequire("fOrUU");

var $dYoht = parcelRequire("dYoht");

var $9bLSq = parcelRequire("9bLSq");

var $01Za6 = parcelRequire("01Za6");

var $fMVEG = parcelRequire("fMVEG");

var $8fgeg = parcelRequire("8fgeg");

var $f7gaE = parcelRequire("f7gaE");

var $g5rwu = parcelRequire("g5rwu");

var $5fBQK = parcelRequire("5fBQK");

var $hxYI0 = parcelRequire("hxYI0");

var $dzSy7 = parcelRequire("dzSy7");

var $eKguf = parcelRequire("eKguf");

var $7vXQn = parcelRequire("7vXQn");

var $kCn5T = parcelRequire("kCn5T");

var $90Rrp = parcelRequire("90Rrp");

var $86qmt = parcelRequire("86qmt");

var $fH16o = parcelRequire("fH16o");

var $q3duL = parcelRequire("q3duL");

var $4iFpq = parcelRequire("4iFpq");

var $kvJxs = parcelRequire("kvJxs");

var $kxvlX = parcelRequire("kxvlX");

var $0e4yJ = parcelRequire("0e4yJ");

var $4mhUQ = parcelRequire("4mhUQ");

var $lcAQi = parcelRequire("lcAQi");

var $68ycU = parcelRequire("68ycU");

var $6HuHg = parcelRequire("6HuHg");

var $hxK6L = parcelRequire("hxK6L");

var $adI0E = parcelRequire("adI0E");

var $aNke7 = parcelRequire("aNke7");

var $9jp5b = parcelRequire("9jp5b");

var $1mByb = parcelRequire("1mByb");

var $izUuJ = parcelRequire("izUuJ");

var $4BdYV = parcelRequire("4BdYV");

var $69iY3 = parcelRequire("69iY3");

var $ipR0U = parcelRequire("ipR0U");

var $jovMq = parcelRequire("jovMq");

var $2UvYl = parcelRequire("2UvYl");

var $laDqO = parcelRequire("laDqO");

var $2pvey = parcelRequire("2pvey");

var $427L2 = parcelRequire("427L2");

var $jWVY2 = parcelRequire("jWVY2");

var $gCfQs = parcelRequire("gCfQs");

var $81ZCL = parcelRequire("81ZCL");

var $lgfw1 = parcelRequire("lgfw1");

var $4x45G = parcelRequire("4x45G");

var $a4nP2 = parcelRequire("a4nP2");

var $dtLGm = parcelRequire("dtLGm");

var $f6OBR = parcelRequire("f6OBR");

var $dRexn = parcelRequire("dRexn");

var $b952b = parcelRequire("b952b");

var $aZXhs = parcelRequire("aZXhs");

var $ktEDA = parcelRequire("ktEDA");

var $caoz4 = parcelRequire("caoz4");

var $5BlCA = parcelRequire("5BlCA");

var $3Hflx = parcelRequire("3Hflx");

var $bUOZo = parcelRequire("bUOZo");

var $bC98V = parcelRequire("bC98V");

var $ew7DI = parcelRequire("ew7DI");

var $dTwSZ = parcelRequire("dTwSZ");

var $hH7Cb = parcelRequire("hH7Cb");

var $2krv1 = parcelRequire("2krv1");

var $8wIny = parcelRequire("8wIny");

var $6pwY1 = parcelRequire("6pwY1");

var $gQABM = parcelRequire("gQABM");

var $9sgxL = parcelRequire("9sgxL");

var $alZMU = parcelRequire("alZMU");

var $lVyEk = parcelRequire("lVyEk");

var $6u3qv = parcelRequire("6u3qv");

var $j2SDi = parcelRequire("j2SDi");

var $e48vl = parcelRequire("e48vl");

var $jSJ1v = parcelRequire("jSJ1v");

var $fdHNd = parcelRequire("fdHNd");

var $guURi = parcelRequire("guURi");

var $6RCDC = parcelRequire("6RCDC");

var $9aEQn = parcelRequire("9aEQn");

var $gZQLD = parcelRequire("gZQLD");

var $kzcqd = parcelRequire("kzcqd");

var $duVOn = parcelRequire("duVOn");

var $lDuCa = parcelRequire("lDuCa");

var $f7vKZ = parcelRequire("f7vKZ");

var $k826a = parcelRequire("k826a");

var $avQ9D = parcelRequire("avQ9D");

var $7xmCI = parcelRequire("7xmCI");

var $h82Z7 = parcelRequire("h82Z7");

var $9qXuz = parcelRequire("9qXuz");

var $3HGg1 = parcelRequire("3HGg1");

var $4nXyN = parcelRequire("4nXyN");

var $jrl3R = parcelRequire("jrl3R");

var $bvhAI = parcelRequire("bvhAI");

var $3B53X = parcelRequire("3B53X");

var $anGpc = parcelRequire("anGpc");

var $glkO2 = parcelRequire("glkO2");

var $04Vlk = parcelRequire("04Vlk");

var $aI01j = parcelRequire("aI01j");

var $flsjf = parcelRequire("flsjf");

var $gm7fA = parcelRequire("gm7fA");

var $8gEiV = parcelRequire("8gEiV");

var $gbj7F = parcelRequire("gbj7F");

var $dhiyM = parcelRequire("dhiyM");

var $21AP4 = parcelRequire("21AP4");

var $infHq = parcelRequire("infHq");

var $9yqzH = parcelRequire("9yqzH");

var $gxVJf = parcelRequire("gxVJf");

var $c1v6Y = parcelRequire("c1v6Y");

var $bZEI9 = parcelRequire("bZEI9");

var $ilKWG = parcelRequire("ilKWG");

var $1EihZ = parcelRequire("1EihZ");

var $2IdR0 = parcelRequire("2IdR0");

var $cZPPs = parcelRequire("cZPPs");

var $frUin = parcelRequire("frUin");

var $1hbMK = parcelRequire("1hbMK");

var $c2KPY = parcelRequire("c2KPY");

var $6mo9H = parcelRequire("6mo9H");

var $eoIQt = parcelRequire("eoIQt");

var $kTgg2 = parcelRequire("kTgg2");

var $agsO7 = parcelRequire("agsO7");

var $9y8sW = parcelRequire("9y8sW");

var $825dq = parcelRequire("825dq");

var $h8swE = parcelRequire("h8swE");

var $gGQIR = parcelRequire("gGQIR");

var $01hnS = parcelRequire("01hnS");

var $8jDeK = parcelRequire("8jDeK");

var $64Uyh = parcelRequire("64Uyh");

var $1T4J3 = parcelRequire("1T4J3");

var $8hATp = parcelRequire("8hATp");

var $lrPAp = parcelRequire("lrPAp");

var $ceMKm = parcelRequire("ceMKm");

var $43Rln = parcelRequire("43Rln");

var $6Z4jF = parcelRequire("6Z4jF");

var $d2uL5 = parcelRequire("d2uL5");

var $2ubrr = parcelRequire("2ubrr");

var $iz3gR = parcelRequire("iz3gR");

var $ghGCX = parcelRequire("ghGCX");

var $7MpwB = parcelRequire("7MpwB");

var $pRrpu = parcelRequire("pRrpu");

var $ZVu1m = parcelRequire("ZVu1m");

var $5YggO = parcelRequire("5YggO");

var $6p9ik = parcelRequire("6p9ik");

var $SvIen = parcelRequire("SvIen");

var $g3kqr = parcelRequire("g3kqr");

var $frn0U = parcelRequire("frn0U");

var $gjuAo = parcelRequire("gjuAo");

var $lPLcB = parcelRequire("lPLcB");

var $eyDhF = parcelRequire("eyDhF");

var $bFlFq = parcelRequire("bFlFq");

var $eLT92 = parcelRequire("eLT92");

var $5nA0V = parcelRequire("5nA0V");

var $bQ0RK = parcelRequire("bQ0RK");

var $cgOe5 = parcelRequire("cgOe5");

var $2d9QY = parcelRequire("2d9QY");

var $jj70V = parcelRequire("jj70V");

var $cmIyb = parcelRequire("cmIyb");

var $4AqA1 = parcelRequire("4AqA1");

var $5qx9W = parcelRequire("5qx9W");

var $5dqn2 = parcelRequire("5dqn2");

var $3L1EU = parcelRequire("3L1EU");

var $g5olQ = parcelRequire("g5olQ");

var $ecUH3 = parcelRequire("ecUH3");

var $6okEU = parcelRequire("6okEU");

var $9vMJ0 = parcelRequire("9vMJ0");

var $gAq9g = parcelRequire("gAq9g");

var $9YDUs = parcelRequire("9YDUs");

var $6ElYx = parcelRequire("6ElYx");

var $h3JFI = parcelRequire("h3JFI");

var $5uMDF = parcelRequire("5uMDF");

var $3RvJ0 = parcelRequire("3RvJ0");

var $3rBGh = parcelRequire("3rBGh");

var $tdrXl = parcelRequire("tdrXl");

var $5EloX = parcelRequire("5EloX");

var $7p4oW = parcelRequire("7p4oW");

var $4PsEV = parcelRequire("4PsEV");

var $GIsnE = parcelRequire("GIsnE");

var $MSc9t = parcelRequire("MSc9t");

var $bpbCg = parcelRequire("bpbCg");

var $5X0aC = parcelRequire("5X0aC");

var $fkWQj = parcelRequire("fkWQj");

var $7NO6v = parcelRequire("7NO6v");

var $gtJvE = parcelRequire("gtJvE");

var $hMqu9 = parcelRequire("hMqu9");

var $7YRoH = parcelRequire("7YRoH");

var $i0b8q = parcelRequire("i0b8q");

var $734Wz = parcelRequire("734Wz");

var $jKCJe = parcelRequire("jKCJe");

var $iJIU8 = parcelRequire("iJIU8");

var $64qpc = parcelRequire("64qpc");

var $87aC7 = parcelRequire("87aC7");

var $aAF0I = parcelRequire("aAF0I");

var $4Aamz = parcelRequire("4Aamz");

var $hPrN5 = parcelRequire("hPrN5");

var $kKEWZ = parcelRequire("kKEWZ");

var $ljItG = parcelRequire("ljItG");

var $fQyGL = parcelRequire("fQyGL");

var $ifEj3 = parcelRequire("ifEj3");

var $4CGuj = parcelRequire("4CGuj");

var $6VvYi = parcelRequire("6VvYi");

var $dSrOC = parcelRequire("dSrOC");

var $j0BAb = parcelRequire("j0BAb");

var $d7mi1 = parcelRequire("d7mi1");

var $5HfC7 = parcelRequire("5HfC7");

var $6JQwt = parcelRequire("6JQwt");

var $icwb1 = parcelRequire("icwb1");

var $egxSq = parcelRequire("egxSq");

var $lhZGg = parcelRequire("lhZGg");

var $jr5gb = parcelRequire("jr5gb");

var $7lZOe = parcelRequire("7lZOe");

var $9rVvQ = parcelRequire("9rVvQ");

var $au6vg = parcelRequire("au6vg");

var $cLamq = parcelRequire("cLamq");

var $2vHPs = parcelRequire("2vHPs");

var $hztdR = parcelRequire("hztdR");

var $6cSNh = parcelRequire("6cSNh");

var $lIPtt = parcelRequire("lIPtt");

var $cWKD0 = parcelRequire("cWKD0");

var $d0eOH = parcelRequire("d0eOH");

var $bxg3m = parcelRequire("bxg3m");

var $e6Vbw = parcelRequire("e6Vbw");

var $7LwJB = parcelRequire("7LwJB");

var $66HfJ = parcelRequire("66HfJ");

var $aDZxG = parcelRequire("aDZxG");

var $lkwO5 = parcelRequire("lkwO5");

var $7QAza = parcelRequire("7QAza");

var $5MiVl = parcelRequire("5MiVl");

var $ee5pi = parcelRequire("ee5pi");

var $hWZAC = parcelRequire("hWZAC");

var $2kXpo = parcelRequire("2kXpo");

var $fhlje = parcelRequire("fhlje");

var $8to5X = parcelRequire("8to5X");

var $9eiXm = parcelRequire("9eiXm");

var $D5QBq = parcelRequire("D5QBq");

var $hRMW9 = parcelRequire("hRMW9");

var $7B6VF = parcelRequire("7B6VF");

var $5W0wg = parcelRequire("5W0wg");

var $4eKYR = parcelRequire("4eKYR");

var $1aB8Z = parcelRequire("1aB8Z");

var $a2PeW = parcelRequire("a2PeW");

var $gsEXA = parcelRequire("gsEXA");

var $cONlw = parcelRequire("cONlw");

var $627LR = parcelRequire("627LR");

var $amBHA = parcelRequire("amBHA");

var $1XqXD = parcelRequire("1XqXD");

var $gXApH = parcelRequire("gXApH");

var $jjqkz = parcelRequire("jjqkz");

var $h4Pr8 = parcelRequire("h4Pr8");

var $28AFT = parcelRequire("28AFT");

var $dyGLN = parcelRequire("dyGLN");

var $7xqQs = parcelRequire("7xqQs");

var $g3Gvc = parcelRequire("g3Gvc");

var $3wbIE = parcelRequire("3wbIE");

var $7fwfr = parcelRequire("7fwfr");

var $peO7W = parcelRequire("peO7W");

var $gUdrp = parcelRequire("gUdrp");

var $3M4hq = parcelRequire("3M4hq");

var $drVWM = parcelRequire("drVWM");

var $f1JiD = parcelRequire("f1JiD");

var $138gn = parcelRequire("138gn");

var $gwCoT = parcelRequire("gwCoT");

var $kkXdG = parcelRequire("kkXdG");

var $bl8cB = parcelRequire("bl8cB");

var $i8buc = parcelRequire("i8buc");

var $gpVZm = parcelRequire("gpVZm");

var $1ods3 = parcelRequire("1ods3");

var $hqIff = parcelRequire("hqIff");

var $ljDIh = parcelRequire("ljDIh");

var $lAnjX = parcelRequire("lAnjX");

var $bCnWj = parcelRequire("bCnWj");

var $aQ85T = parcelRequire("aQ85T");

var $6kvQ5 = parcelRequire("6kvQ5");

var $9Dd5o = parcelRequire("9Dd5o");

var $kci7Q = parcelRequire("kci7Q");

var $5XbrB = parcelRequire("5XbrB");

var $72XXS = parcelRequire("72XXS");

var $bbdey = parcelRequire("bbdey");

var $t2WaR = parcelRequire("t2WaR");

var $yVmHw = parcelRequire("yVmHw");

var $26BGc = parcelRequire("26BGc");

var $dseRA = parcelRequire("dseRA");

var $fCX78 = parcelRequire("fCX78");

var $6NqDk = parcelRequire("6NqDk");

var $bERWs = parcelRequire("bERWs");

var $gPxpf = parcelRequire("gPxpf");

var $fLbia = parcelRequire("fLbia");

var $1Y5eu = parcelRequire("1Y5eu");

var $3FG4O = parcelRequire("3FG4O");

var $dDzIU = parcelRequire("dDzIU");

var $3SReJ = parcelRequire("3SReJ");

var $aLuho = parcelRequire("aLuho");

var $3YX4q = parcelRequire("3YX4q");

var $kEFGH = parcelRequire("kEFGH");

var $kwWQ0 = parcelRequire("kwWQ0");

var $7F7I9 = parcelRequire("7F7I9");

var $2OQWG = parcelRequire("2OQWG");

var $4eRSO = parcelRequire("4eRSO");

var $b9Dpn = parcelRequire("b9Dpn");

var $eitw0 = parcelRequire("eitw0");

var $14ooS = parcelRequire("14ooS");

var $lWR9T = parcelRequire("lWR9T");

var $6DlqX = parcelRequire("6DlqX");

var $jCfr4 = parcelRequire("jCfr4");

var $kRn5i = parcelRequire("kRn5i");

var $3NIY8 = parcelRequire("3NIY8");

var $fjYA2 = parcelRequire("fjYA2");

var $qdq3O = parcelRequire("qdq3O");

var $aY70k = parcelRequire("aY70k");

var $2wF9u = parcelRequire("2wF9u");

var $feDOq = parcelRequire("feDOq");

var $cqk4B = parcelRequire("cqk4B");

var $d66ag = parcelRequire("d66ag");

var $84EwA = parcelRequire("84EwA");

var $7dYbE = parcelRequire("7dYbE");

var $dRm2C = parcelRequire("dRm2C");

var $1Ps9S = parcelRequire("1Ps9S");

var $bRRmd = parcelRequire("bRRmd");

var $1XAMa = parcelRequire("1XAMa");

var $aA0rC = parcelRequire("aA0rC");

var $hjVS0 = parcelRequire("hjVS0");

var $jss6V = parcelRequire("jss6V");

var $1iYkP = parcelRequire("1iYkP");

var $4XUsE = parcelRequire("4XUsE");

var $bbDvZ = parcelRequire("bbDvZ");

var $e7GI8 = parcelRequire("e7GI8");

var $4Xzif = parcelRequire("4Xzif");

var $7mf3n = parcelRequire("7mf3n");

var $4VMm4 = parcelRequire("4VMm4");

var $gMkpP = parcelRequire("gMkpP");

var $gtcNN = parcelRequire("gtcNN");

var $jr7ke = parcelRequire("jr7ke");

var $hhRES = parcelRequire("hhRES");

var $8VY8F = parcelRequire("8VY8F");

var $aApqk = parcelRequire("aApqk");

var $dTkCg = parcelRequire("dTkCg");

var $eTL4x = parcelRequire("eTL4x");

var $lzLcy = parcelRequire("lzLcy");

var $cJoBA = parcelRequire("cJoBA");

var $SBgrM = parcelRequire("SBgrM");

var $cVgRQ = parcelRequire("cVgRQ");

var $8XfJX = parcelRequire("8XfJX");

var $5o5UE = parcelRequire("5o5UE");

var $2OBp2 = parcelRequire("2OBp2");

var $29XA4 = parcelRequire("29XA4");

var $aNc7A = parcelRequire("aNc7A");

var $4e4nJ = parcelRequire("4e4nJ");

var $5nU8P = parcelRequire("5nU8P");

var $kHVIE = parcelRequire("kHVIE");

var $eHeAh = parcelRequire("eHeAh");

var $9R3is = parcelRequire("9R3is");

var $lKkaY = parcelRequire("lKkaY");

var $brWuf = parcelRequire("brWuf");

var $iXsus = parcelRequire("iXsus");

var $xwXfC = parcelRequire("xwXfC");

var $3lpLH = parcelRequire("3lpLH");

var $iLmKH = parcelRequire("iLmKH");

var $kNZj9 = parcelRequire("kNZj9");

var $dCGUp = parcelRequire("dCGUp");

var $4KLVz = parcelRequire("4KLVz");

var $lYrmE = parcelRequire("lYrmE");

var $6YHWn = parcelRequire("6YHWn");

var $awOZa = parcelRequire("awOZa");

var $kZgpC = parcelRequire("kZgpC");

var $auP5Z = parcelRequire("auP5Z");

var $6un8I = parcelRequire("6un8I");

var $l1PfI = parcelRequire("l1PfI");

var $cvYE5 = parcelRequire("cvYE5");

var $2cpS3 = parcelRequire("2cpS3");

var $iuWOh = parcelRequire("iuWOh");

var $2r2Gu = parcelRequire("2r2Gu");

var $80PF8 = parcelRequire("80PF8");

var $aAIWh = parcelRequire("aAIWh");

var $5fOtJ = parcelRequire("5fOtJ");

var $gfz2f = parcelRequire("gfz2f");

var $gfW60 = parcelRequire("gfW60");

var $h51Kg = parcelRequire("h51Kg");

var $fEAJ2 = parcelRequire("fEAJ2");

var $1rMUU = parcelRequire("1rMUU");

var $36qRE = parcelRequire("36qRE");

var $2QFEo = parcelRequire("2QFEo");

var $fQGIH = parcelRequire("fQGIH");

var $c0JOH = parcelRequire("c0JOH");

var $rsO8k = parcelRequire("rsO8k");

var $5JkxV = parcelRequire("5JkxV");

var $jIBei = parcelRequire("jIBei");

var $3oSi6 = parcelRequire("3oSi6");

var $96BnX = parcelRequire("96BnX");

var $fP1EY = parcelRequire("fP1EY");

var $2yO8h = parcelRequire("2yO8h");

var $c97hk = parcelRequire("c97hk");

var $7sSEm = parcelRequire("7sSEm");

var $eaXgt = parcelRequire("eaXgt");

var $moUwl = parcelRequire("moUwl");

var $7D3Yv = parcelRequire("7D3Yv");

var $dgneZ = parcelRequire("dgneZ");

var $hRN7l = parcelRequire("hRN7l");

var $cU5zd = parcelRequire("cU5zd");

var $fSktp = parcelRequire("fSktp");

var $5TKdO = parcelRequire("5TKdO");

var $4zSYf = parcelRequire("4zSYf");

var $j175z = parcelRequire("j175z");

var $gQWOR = parcelRequire("gQWOR");

var $zaQdk = parcelRequire("zaQdk");

var $4UU5H = parcelRequire("4UU5H");

var $izdjx = parcelRequire("izdjx");

var $eWSeK = parcelRequire("eWSeK");

var $6agOS = parcelRequire("6agOS");

var $2ytxj = parcelRequire("2ytxj");

var $16Svt = parcelRequire("16Svt");

var $7m5aN = parcelRequire("7m5aN");

var $kDimk = parcelRequire("kDimk");

var $9z1Wd = parcelRequire("9z1Wd");

var $2FVZu = parcelRequire("2FVZu");

var $fQCGk = parcelRequire("fQCGk");

var $1EVpW = parcelRequire("1EVpW");

var $azyVo = parcelRequire("azyVo");

var $7wXr4 = parcelRequire("7wXr4");

var $wwgc5 = parcelRequire("wwgc5");

var $eAw5v = parcelRequire("eAw5v");

var $djlm6 = parcelRequire("djlm6");

var $3J8Cl = parcelRequire("3J8Cl");

var $kutfD = parcelRequire("kutfD");

var $2z6Z2 = parcelRequire("2z6Z2");

var $knZRG = parcelRequire("knZRG");

var $hUUCw = parcelRequire("hUUCw");

var $6B4GJ = parcelRequire("6B4GJ");

var $1kSIj = parcelRequire("1kSIj");

var $bi9fZ = parcelRequire("bi9fZ");

var $jvZP3 = parcelRequire("jvZP3");

var $711QI = parcelRequire("711QI");

var $03taV = parcelRequire("03taV");

var $kQjkp = parcelRequire("kQjkp");

var $6KvsG = parcelRequire("6KvsG");

var $efYyQ = parcelRequire("efYyQ");

var $gcVUu = parcelRequire("gcVUu");

var $dG6DF = parcelRequire("dG6DF");

var $kg7GL = parcelRequire("kg7GL");

var $aviVh = parcelRequire("aviVh");

var $i0tax = parcelRequire("i0tax");

var $1IhKQ = parcelRequire("1IhKQ");

var $dl9zj = parcelRequire("dl9zj");

var $iQsfj = parcelRequire("iQsfj");

var $3gU47 = parcelRequire("3gU47");

var $4Mj46 = parcelRequire("4Mj46");

var $9MSQj = parcelRequire("9MSQj");

var $6FBN4 = parcelRequire("6FBN4");

var $bhft0 = parcelRequire("bhft0");

var $8Yag1 = parcelRequire("8Yag1");

var $2toxI = parcelRequire("2toxI");

var $dBV2a = parcelRequire("dBV2a");

var $5xsFH = parcelRequire("5xsFH");

var $7Db7a = parcelRequire("7Db7a");

var $eFYGV = parcelRequire("eFYGV");

var $lGnoq = parcelRequire("lGnoq");

var $6cMQO = parcelRequire("6cMQO");

var $lxXtu = parcelRequire("lxXtu");

var $2l6sh = parcelRequire("2l6sh");

var $1C9Ha = parcelRequire("1C9Ha");

var $cChHY = parcelRequire("cChHY");

var $1oew5 = parcelRequire("1oew5");

var $d1sI7 = parcelRequire("d1sI7");

var $gksya = parcelRequire("gksya");

var $l0UsI = parcelRequire("l0UsI");

var $bdHl5 = parcelRequire("bdHl5");

var $5hvg3 = parcelRequire("5hvg3");

var $6oWts = parcelRequire("6oWts");

var $76RJj = parcelRequire("76RJj");

var $ikfu9 = parcelRequire("ikfu9");

var $g7fao = parcelRequire("g7fao");

var $8s6qp = parcelRequire("8s6qp");

var $qruNQ = parcelRequire("qruNQ");

var $4chTT = parcelRequire("4chTT");

var $2LfmF = parcelRequire("2LfmF");

var $gzdNI = parcelRequire("gzdNI");

var $ghTLp = parcelRequire("ghTLp");

var $ickyX = parcelRequire("ickyX");

var $cQer4 = parcelRequire("cQer4");

var $eL5iv = parcelRequire("eL5iv");

var $7MlOX = parcelRequire("7MlOX");

var $lHzMh = parcelRequire("lHzMh");

var $kYzjv = parcelRequire("kYzjv");

var $jK6bT = parcelRequire("jK6bT");

var $jbAAG = parcelRequire("jbAAG");

var $7dbQR = parcelRequire("7dbQR");

var $hvbE3 = parcelRequire("hvbE3");

var $3Jvzv = parcelRequire("3Jvzv");

var $CY8KI = parcelRequire("CY8KI");

var $glwG4 = parcelRequire("glwG4");

var $lcFGc = parcelRequire("lcFGc");

var $03CAy = parcelRequire("03CAy");

var $056cU = parcelRequire("056cU");

var $kxlGk = parcelRequire("kxlGk");

var $fMbaV = parcelRequire("fMbaV");

var $cyZLC = parcelRequire("cyZLC");

var $7PtTb = parcelRequire("7PtTb");

var $iwgxt = parcelRequire("iwgxt");

var $e99fJ = parcelRequire("e99fJ");

var $45nsl = parcelRequire("45nsl");

var $9EGBH = parcelRequire("9EGBH");

var $heIfC = parcelRequire("heIfC");

var $jejF3 = parcelRequire("jejF3");

var $eKEYN = parcelRequire("eKEYN");

var $fwjnc = parcelRequire("fwjnc");

var $1KC4N = parcelRequire("1KC4N");

var $7ApVe = parcelRequire("7ApVe");

var $41tjC = parcelRequire("41tjC");

var $3I1TD = parcelRequire("3I1TD");

var $h0ilo = parcelRequire("h0ilo");

var $k1TyW = parcelRequire("k1TyW");

var $3av4N = parcelRequire("3av4N");

var $4BuRo = parcelRequire("4BuRo");

var $6SWMv = parcelRequire("6SWMv");

var $jFY66 = parcelRequire("jFY66");

var $jPXYO = parcelRequire("jPXYO");

var $ktYro = parcelRequire("ktYro");

var $7UDCM = parcelRequire("7UDCM");

var $hDCtq = parcelRequire("hDCtq");

var $2vUs2 = parcelRequire("2vUs2");

var $bCHhM = parcelRequire("bCHhM");

var $g6Mf9 = parcelRequire("g6Mf9");

var $dR9Nr = parcelRequire("dR9Nr");

var $goreX = parcelRequire("goreX");

var $jqbKy = parcelRequire("jqbKy");

var $3eN7Y = parcelRequire("3eN7Y");

var $hjvN4 = parcelRequire("hjvN4");

var $6fHM1 = parcelRequire("6fHM1");

var $1GAqb = parcelRequire("1GAqb");

var $V3Ey7 = parcelRequire("V3Ey7");
const $ef6e862e848d08e0$export$10439de9ce871f28 = ()=>[
        (0, $UuOK7.aiAnswersRouteEntry),
        (0, $iTGOF.alertPoliciesRouteEntry),
        (0, $3Ro2a.applinksExtraAuthHealthcheckRouteEntry),
        (0, $lLZ8x.appRequestsRouteEntry),
        (0, $hHcn9.archivedIssuesRedirectRouteEntry),
        (0, $vDjHk.archivedPlansRouteEntry),
        (0, $9CxHM.archivedProjectDirectLinkRouteEntry),
        (0, $eaKG5.archivedProjectsDirectoryRouteEntry),
        (0, $9wv3p.archivedWorkItemsJsmRouteEntry),
        (0, $6DvyY.archivedWorkItemsJswCompanyRouteEntry),
        (0, $lGElM.archivedWorkItemsJswRouteEntry),
        (0, $3bc6l.archivedWorkItemsJwmRouteEntry),
        (0, $fpGzf.arjCalendarEmbedRouteEntry),
        (0, $aVGYm.arjDependenciesEmbedRouteEntry),
        (0, $2DH60.arjIncrementEmbedRouteEntry),
        (0, $7gypr.arjSettingsDependenciesLegacyRedirectRouteEntry),
        (0, $cwKGx.arjSettingsDependenciesRouteEntry),
        (0, $jZMnM.arjSettingsFinancialYearPageRouteEntry),
        (0, $dfdSu.arjSettingsLoadingLimitsLegacyRedirectRouteEntry),
        (0, $ieqGd.arjSettingsLoadingLimitsRouteEntry),
        (0, $JQ5Vt.arjSettingsPermissionsRouteEntry),
        (0, $eOPb5.arjSettingsPermissionsRouteLegacyRedirectRouteEntry),
        (0, $a5XVU.arjSummaryEmbedRouteEntry),
        (0, $lUhpq.arjTimelineEmbedRouteEntry),
        (0, $gktyQ.assetsConfigurationRouteEntry),
        (0, $cmklJ.assetsDataManagerDataSourceRouteEntry),
        (0, $ca1Zm.assetsDataManagerGettingStartedRouteEntry),
        (0, $6GNmk.assetsDataManagerObjectClassesRouteEntry),
        (0, $3T2Ye.assetsObjectRouteEntry),
        (0, $9CT95.assetsObjectTypeConfigurationRouteEntry),
        (0, $6fdEz.assetsReportsRouteEntry),
        (0, $8WMR9.assetsReportsTemplateRouteEntry),
        (0, $hSl7U.assetsReportsUnsubscribeRouteEntry),
        (0, $7kGnZ.assetsRouteEntry),
        (0, $elyxq.assetsSchemaConfigurationRouteEntry),
        (0, $9F4ID.assetsSchemaRouteEntry),
        (0, $18W8Q.assetsSearchRouteEntry),
        (0, $3ss0y.boardsDirectoryRedirectRouteEntry),
        (0, $bNtXI.boardsDirectoryRouteEntry),
        (0, $eAlzO.browseConversationsRouteEntry),
        (0, $3KtPD.browseIntentsRouteEntry),
        (0, $hkNW0.browseIssueEmbedRouteEntry),
        (0, $1B0QU.browseIssueRouteEntry),
        (0, $igqAf.browseProjectRedirectRouteEntry),
        (0, $h3WYk.browseStandardFlowsRouteEntry),
        (0, $dUuHj.classicBusinessOverviewCalendarRouteEntry),
        (0, $eiK9n.classicBusinessOverviewSummaryRouteEntry),
        (0, $4KinX.classicBusinessOverviewTimelineRouteEntry),
        (0, $d6K18.classicBusinessProformaIssueFormsDirectEmbedRouteEntry),
        (0, $lIfPP.classicBusinessProformaIssueFormsDirectRouteEntry),
        (0, $6IB0N.classicBusinessProjectApprovalsRouteEntry),
        (0, $1sFpf.classicBusinessProjectFormBuilderRouteEntry),
        (0, $a2wNz.classicBusinessProjectFormRouteEntry),
        (0, $eghTD.classicBusinessProjectFormSubmitEmbedRouteEntry),
        (0, $huQRU.classicBusinessProjectFormSubmitPublicRouteEntry),
        (0, $ajYJ1.classicBusinessProjectFormSubmitRouteEntry),
        (0, $47CVY.classicBusinessProjectPagesRouteEntry),
        (0, $hF0nU.classicBusinessProjectShortcutRouteEntry),
        (0, $ejDmq.classicBusinessProjectViewNotFoundRouteEntry),
        (0, $difFp.classicProjectSettingsDataClassificationsRouteEntry),
        (0, $anDMO.classicProjectSettingsDetailsRouteEntry),
        (0, $dYbYB.classicProjectSettingsFeaturesRouteEntry),
        (0, $dH2Tp.classicProjectSettingsIssueLayoutRouteEntry),
        (0, $ffFBX.classicProjectSettingsOpsgenieRouteEntry),
        (0, $1IKX7.classicProjectSettingsSoftwareNotificationsIssueLogsRouteEntry),
        (0, $1K27j.classicProjectSettingsSoftwareProformaEditFormsRouteEntry),
        (0, $8DQ40.classicProjectSettingsSoftwareProformaFormsRouteEntry),
        (0, $hdWS0.classicProjectSettingsSoftwareRedirectRouteEntry),
        (0, $9MTKv.classicProjectSettingsToolchainRouteEntry),
        (0, $2XQq2.classicSoftwareBacklogEmbedRouteEntry),
        (0, $58Cy7.classicSoftwareBacklogRouteEntry),
        (0, $e1cjg.classicSoftwareBoardEmbedRouteEntry),
        (0, $4t69d.classicSoftwareBoardRouteEntry),
        (0, $hu1w9.classicSoftwareBoardSettingsInsightsRapidboardBacklogRouteEntry),
        (0, $akFeA.classicSoftwareBoardSettingsInsightsRapidboardBoardRouteEntry),
        (0, $cjFCA.classicSoftwareBoardSettingsRouteEntry),
        (0, $8E1dI.cmpVelocityRouteEntry),
        (0, $3GuHG.communicationsStakeholderGroupsRouteEntry),
        (0, $WsHyA.communicationsStakeholdersRouteEntry),
        (0, $6xRe5.compassProductSettingsRouteEntry),
        (0, $5eLaE.connectGeneralInvalidRouteEntry),
        (0, $gnGkU.connectGeneralRouteEntry),
        (0, $c74Xp.connectGeneralServiceDeskProjectRouteEntry),
        (0, $4Zw1h.connectProjectRouteEntry),
        (0, $dqjth.createProjectRouteEntry),
        (0, $aw22a.customerServiceEscalationsRouteEntry),
        (0, $yVbxa.customerServiceProductsRouteEntry),
        (0, $lYzgn.customIssueRouteEntry),
        (0, $dAmDY.customPracticeQueueBoardRouteEntry),
        (0, $3MI0Z.customPracticeQueueCalendarRouteEntry),
        (0, $iYfXI.customPracticeQueueRouteEntry),
        (0, $3kqBW.customQueueBoardRouteEntry),
        (0, $79qCU.customQueueCalendarRouteEntry),
        (0, $8brgy.customQueueRouteEntry),
        (0, $2fNbh.dashboardEditRouteEntry),
        (0, $56moC.dashboardRouteEntry),
        (0, $aNsRz.dashboardsDirectoryRedirectRouteEntry),
        (0, $cmvi5.dashboardsDirectoryRouteEntry),
        (0, $hfMX7.dashboardViewEmbedRouteEntry),
        (0, $1zhx7.dashboardViewRouteEntry),
        (0, $dxMNj.dashboardWallboardRouteEntry),
        (0, $hwgIz.devopsConnectedProjectRouteEntry),
        (0, $d4tTc.digestsNotificationsPersonalSettingsRouteEntry),
        (0, $Dkaoj.emailNotificationsLogAccessRouteEntry),
        (0, $hs0Ni.eocAlertIssueSyncingCreateRouteEntry),
        (0, $8m0RN.eocAlertIssueSyncingDetailRouteEntry),
        (0, $dt3ZS.eocAlertIssueSyncingRouteEntry),
        (0, $GJOha.eocApiKeyManagementRouteEntry),
        (0, $hDU7Y.eocAssignCustomRolesRouteEntry),
        (0, $dHqTd.eocAutomationsRouteEntry),
        (0, $9KhdI.eocCustomRolesRouteEntry),
        (0, $6q1hh.eocGlobalAlertListRedirectRouteEntry),
        (0, $7LUIt.eocGlobalAlertListRouteEntry),
        (0, $3EMmS.eocGlobalAlertsDetailRouteEntry),
        (0, $4Ykyz.eocGlobalGroupDetailRouteEntry),
        (0, $4Yh3B.eocGlobalHeartbeatsRouteEntry),
        (0, $5H5Rm.eocGlobalMaintenanceRouteEntry),
        (0, $dQtRM.eocGlobalReportsHomePageNav4RouteEntry),
        (0, $iDxTp.eocGlobalReportsNav4RouteEntry),
        (0, $75Ues.eocHeartbeatsRouteEntry),
        (0, $jAB8i.eocMaintenanceRouteEntry),
        (0, $5KvQp.eocOnCallRedirectRouteEntry),
        (0, $3Yng9.eocOnCallRouteEntry),
        (0, $2B61u.eocOverviewAllTeamsRouteEntry),
        (0, $e04XT.eocOverviewRouteEntry),
        (0, $hGFnn.eocPermissionsRouteEntry),
        (0, $bAN0d.eocReportsTeamRedirectRouteEntry),
        (0, $cLm5J.eocReportsTeamRouteEntry),
        (0, $dbAmH.eocReportsUnsubscribeRouteEntry),
        (0, $jPcas.eocScheduleGlobalRouteEntry),
        (0, $k7VEf.eocTeamAlertDetailRouteEntry),
        (0, $i27Sx.eocTeamAlertIssueSyncingCreateRouteEntry),
        (0, $qjJTn.eocTeamAlertIssueSyncingDetailRouteEntry),
        (0, $5xt55.eocTeamAlertIssueSyncingRouteEntry),
        (0, $4yINJ.eocTeamAlertListRouteEntry),
        (0, $bubms.eocTeamCustomerLogsDownloadRouteEntry),
        (0, $fOrUU.eocTeamCustomerLogsRouteEntry),
        (0, $dYoht.eocTeamGroupDetailRouteEntry),
        (0, $9bLSq.eocUserNotificationsRouteEntry),
        (0, $01Za6.errorsNotFoundRouteEntry),
        (0, $fMVEG.externalImportRouteEntry),
        (0, $8fgeg.filtersDirectoryRedirectRouteEntry),
        (0, $f7gaE.filtersDirectoryRouteEntry),
        (0, $g5rwu.findAppsRouteEntry),
        (0, $5fBQK.forgeAdminRouteEntry),
        (0, $hxYI0.forgeAdminSettingsRouteEntry),
        (0, $dzSy7.forgeFieldContextualConfigurationRouteEntry),
        (0, $eKguf.forgeGlobalRouteEntry),
        (0, $7vXQn.forgePersonalSettingsRouteEntry),
        (0, $kCn5T.forgeProjectRouteEntry),
        (0, $90Rrp.forgeProjectServicedeskRouteEntry),
        (0, $86qmt.forgeServicedeskQueueRouteEntry),
        (0, $fH16o.generalPersonalSettingsRouteEntry),
        (0, $q3duL.globalEscalationsRouteEntry),
        (0, $4iFpq.globalIncomingCallDetailRouteEntry),
        (0, $kvJxs.globalIncomingCallRouteEntry),
        (0, $kxvlX.globalIntegrationCreateRouteEntry),
        (0, $0e4yJ.globalIntegrationDetailRouteEntry),
        (0, $4mhUQ.globalIntegrationListRouteEntry),
        (0, $lcAQi.globalIntegrationLogRouteEntry),
        (0, $68ycU.globalIntegrationsRouteEntry),
        (0, $6HuHg.globalIssueNavigatorBrowseIssueRedirectRouteEntry),
        (0, $hxK6L.globalMailSettingsRouteEntry),
        (0, $adI0E.globalPoliciesRouteEntry),
        (0, $aNke7.globalSettingsContactAdministratorRouteEntry),
        (0, $9jp5b.globalSettingsCustomFieldsRouteEntry),
        (0, $1mByb.globalSettingsEditPermissionSchemesRouteEntry),
        (0, $izUuJ.globalSettingsFormDataConnectionsRouteEntry),
        (0, $4BdYV.globalSettingsGlobalPermissionsRouteEntry),
        (0, $69iY3.globalSettingsIssueFieldConfigurationSchemesRouteEntry),
        (0, $ipR0U.globalSettingsIssueFieldSchemesRouteEntry),
        (0, $jovMq.globalSettingsIssueFieldScreensRouteEntry),
        (0, $2UvYl.globalSettingsIssueFieldsManagementRouteEntry),
        (0, $laDqO.globalSettingsIssueHierarchyRedirectRouteEntry),
        (0, $2pvey.globalSettingsIssueHierarchyRouteEntry),
        (0, $427L2.globalSettingsIssuesExplicitFieldAssociationRouteEntry),
        (0, $jWVY2.globalSettingsIssuesNewIssueSearchRouteEntry),
        (0, $gCfQs.globalSettingsIssuesPrioritiesRouteEntry),
        (0, $81ZCL.globalSettingsIssuesPrioritySchemesRouteEntry),
        (0, $lgfw1.globalSettingsIssueTypesRouteEntry),
        (0, $4x45G.globalSettingsIssueTypesSchemesRouteEntry),
        (0, $a4nP2.globalSettingsIssueTypesScreenSchemesRouteEntry),
        (0, $dtLGm.globalSettingsIssueWorkflow1RouteEntry),
        (0, $f6OBR.globalSettingsIssueWorkflowEditRouteEntry),
        (0, $dRexn.globalSettingsLegacyFieldLayoutRouteEntry),
        (0, $b952b.globalSettingsOptimizeFieldConfigurationSchemeRouteEntry),
        (0, $aZXhs.globalSettingsOptimizeWorkTypeSchemeRouteEntry),
        (0, $ktEDA.globalSettingsPerformanceCustomFieldRouteEntry),
        (0, $caoz4.globalSettingsPerformanceIssueArchivalRouteEntry),
        (0, $5BlCA.globalSettingsPerformanceMetricDetailRouteEntry),
        (0, $3Hflx.globalSettingsPerformanceOverviewRouteEntry),
        (0, $bUOZo.globalSettingsPerformanceProjectCleanupRouteEntry),
        (0, $bC98V.globalSettingsPerformanceProjectRoleActorRouteEntry),
        (0, $ew7DI.globalSettingsPermissionSchemesRouteEntry),
        (0, $dTwSZ.globalSettingsSystemBulkMailRouteEntry),
        (0, $hH7Cb.globalSettingsSystemUiAnnouncementBannerRouteEntry),
        (0, $2krv1.helpCenterSettingsAgentStudioActionsRouteEntry),
        (0, $8wIny.helpCenterSettingsAgentStudioChatSimulatorRouteEntry),
        (0, $6pwY1.helpCenterSettingsAgentStudioConversationReviewRouteEntry),
        (0, $gQABM.helpCenterSettingsAgentStudioHandoffRouteEntry),
        (0, $9sgxL.helpCenterSettingsAgentStudioKnowledgeRouteEntry),
        (0, $alZMU.helpCenterSettingsAgentStudioRouteEntry),
        (0, $lVyEk.helpCenterSettingsAnalyticsRouteEntry),
        (0, $6u3qv.helpCenterSettingsArticlesRouteEntry),
        (0, $j2SDi.helpCenterSettingsArticlesViewArticleRouteEntry),
        (0, $e48vl.helpCenterSettingsCreateArticleRouteEntry),
        (0, $jSJ1v.helpCenterSettingsCustomerAccessRouteEntry),
        (0, $fdHNd.helpCenterSettingsCustomerNotificationsRouteEntry),
        (0, $guURi.helpCenterSettingsDetailsRouteEntry),
        (0, $6RCDC.helpCenterSettingsEmailRouteEntry),
        (0, $9aEQn.helpCenterSettingsFormEditRouteEntry),
        (0, $gZQLD.helpCenterSettingsFormsRouteEntry),
        (0, $kzcqd.helpCenterSettingsKbRouteEntry),
        (0, $duVOn.helpCenterSettingsNotFoundRouteEntry),
        (0, $lDuCa.helpCenterSettingsServiceHubsRouteEntry),
        (0, $f7vKZ.helpCenterSettingsSupportWebsiteOverviewRouteEntry),
        (0, $k826a.helpCenterSettingsSupportWebsitePagesRouteEntry),
        (0, $avQ9D.helpCenterSettingsSupportWebsiteRouteEntry),
        (0, $7xmCI.helpCenterSettingsWidgetConfigurationRouteEntry),
        (0, $h82Z7.homeOnboardingRedirectRouteEntry),
        (0, $9qXuz.homeRedirectRouteEntry),
        (0, $3HGg1.issueCreateEmbedRouteEntry),
        (0, $4nXyN.issueNavigatorGlobalJiraRouteEntry),
        (0, $jrl3R.issueNavigatorGlobalRouteEntry),
        (0, $bvhAI.issueNavigatorProjectBusinessEmbedRouteEntry),
        (0, $3B53X.issueNavigatorProjectBusinessRouteEntry),
        (0, $anGpc.issueNavigatorProjectClassicEmbedRouteEntry),
        (0, $glkO2.issueNavigatorProjectClassicRouteEntry),
        (0, $04Vlk.issueNavigatorProjectServicedeskRouteEntry),
        (0, $aI01j.issueNavigatorProjectSoftwareEmbedRouteEntry),
        (0, $flsjf.issueNavigatorProjectSoftwareRouteEntry),
        (0, $gm7fA.jiraBusinessAttachmentsRouteEntry),
        (0, $8gEiV.jiraBusinessBoardCustomEmbedRouteEntry),
        (0, $gbj7F.jiraBusinessBoardEmbedRouteEntry),
        (0, $dhiyM.jiraBusinessBoardRouteEntry),
        (0, $21AP4.jiraBusinessCalendarEmbedRouteEntry),
        (0, $infHq.jiraBusinessCalendarRouteEntry),
        (0, $9yqzH.jiraBusinessListEmbedRouteEntry),
        (0, $gxVJf.jiraBusinessListRouteEntry),
        (0, $c1v6Y.jiraBusinessOverviewRedirectRouteEntry),
        (0, $bZEI9.jiraBusinessProjectRedirectRouteEntry),
        (0, $ilKWG.jiraBusinessReportsOverviewRouteEntry),
        (0, $1EihZ.jiraBusinessSummaryEmbedRouteEntry),
        (0, $2IdR0.jiraBusinessSummaryRouteEntry),
        (0, $cZPPs.jiraBusinessTimelineEmbedRouteEntry),
        (0, $frUin.jiraBusinessTimelineRouteEntry),
        (0, $1hbMK.jiraHomeRouteEntry),
        (0, $c2KPY.jiraSearchRouteEntry),
        (0, $6mo9H.jsmBoardRouteEntry),
        (0, $eoIQt.knowledgeHubAllArticlesRouteEntry),
        (0, $kTgg2.knowledgeHubArticleEmbedEditorRouteEntry),
        (0, $agsO7.knowledgeHubArticleInCategoryRouteEntry),
        (0, $9y8sW.knowledgeHubBrowseAllArticlesRouteEntry),
        (0, $825dq.knowledgeHubBrowseAllCategoriesRouteEntry),
        (0, $h8swE.knowledgeHubBrowseViewArticleRouteEntry),
        (0, $gGQIR.knowledgeHubCategoryPageRouteEntry),
        (0, $01hnS.knowledgeHubCategoryRouteEntry),
        (0, $8jDeK.knowledgeHubDraftsRouteEntry),
        (0, $64Uyh.knowledgeHubLandingRouteEntry),
        (0, $1T4J3.knowledgeHubSearchRouteEntry),
        (0, $8hATp.knowledgeHubSetupRouteEntry),
        (0, $lrPAp.knowledgeHubSuggestedArticlesRouteEntry),
        (0, $ceMKm.landingPageRouteEntry),
        (0, $43Rln.legacyPlanPageRedirectRouteEntry),
        (0, $6Z4jF.legacyPlanReportPageRedirectRouteEntry),
        (0, $d2uL5.legacyProjectReleasesNoteConfigRouteEntry),
        (0, $2ubrr.legacyProjectReleasesNoteRouteEntry),
        (0, $iz3gR.legacyRapidBoardRouteEntry),
        (0, $ghGCX.legacyRedirectRouteEntry),
        (0, $7MpwB.loginEmbedRouteEntry),
        (0, $pRrpu.manageProjectsDirectoryRouteEntry),
        (0, $ZVu1m.notificationLogsRouteEntry),
        (0, $5YggO.notificationsPersonalSettingsRouteEntry),
        (0, $6p9ik.opsgenieScheduleRedirectRouteEntry),
        (0, $SvIen.opsgenieScheduleRouteEntry),
        (0, $g3kqr.opsNotificationsPersonalSettingsRouteEntry),
        (0, $frn0U.peopleProfilesRouteEntry),
        (0, $gjuAo.performanceRouteEntry),
        (0, $lPLcB.personalSettingsRouteEntry),
        (0, $eyDhF.piCreateIssueEmbedRouteEntry),
        (0, $bFlFq.piEditIssueEmbedRouteEntry),
        (0, $eLT92.planExportPageRouteEntry),
        (0, $5nA0V.planIncrementRouteEntry),
        (0, $bQ0RK.planIncrementsRouteEntry),
        (0, $cgOe5.planPageRouteEntry),
        (0, $2d9QY.planPageWithoutScenarioIdRouteEntry),
        (0, $jj70V.planReportPageRouteEntry),
        (0, $cmIyb.plansDirectoryRouteEntry),
        (0, $4AqA1.planSetupPageRouteEntry),
        (0, $5qx9W.planUpsellRouteEntry),
        (0, $5dqn2.planViewNotFoundRouteEntry),
        (0, $3L1EU.polarisCollectionsRouteEntry),
        (0, $g5olQ.polarisIdeasRouteEntry),
        (0, $ecUH3.polarisOnboardingRouteEntry),
        (0, $6okEU.polarisSettingsAccessRouteEntry),
        (0, $9vMJ0.polarisSettingsDatesRouteEntry),
        (0, $gAq9g.polarisSettingsEarlyAccessFeaturesRouteEntry),
        (0, $9YDUs.polarisSettingsGlobalFieldsRouteEntry),
        (0, $6ElYx.polarisSettingsViewBlueprintsRouteEntry),
        (0, $h3JFI.polarisUnlicensedRouteEntry),
        (0, $5uMDF.productsJcsCustomerAccessRouteEntry),
        (0, $3RvJ0.productsJcsFormFieldsRouteEntry),
        (0, $3rBGh.productsJsmAuthenticationSettingsRouteEntry),
        (0, $tdrXl.productsJsmChatopsAndVideosToolsRouteEntry),
        (0, $5EloX.productsJsmComplianceRouteEntry),
        (0, $7p4oW.productsJsmConfigurationRouteEntry),
        (0, $4PsEV.productsJsmCustomerAccessRouteEntry),
        (0, $GIsnE.productsJsmEmailRequestsRouteEntry),
        (0, $MSc9t.productsJsmFeatureUsageRouteEntry),
        (0, $bpbCg.productsJsmGlobalOpsReportsRedirectRouteEntry),
        (0, $5X0aC.productsJsmGlobalOpsReportsRouteEntry),
        (0, $fkWQj.productsJsmIncidentManagementToolsRouteEntry),
        (0, $7NO6v.productsJsmKbPermissionsRouteEntry),
        (0, $gtJvE.productsJsmOrganizationsDetailsRouteEntry),
        (0, $hMqu9.productsJsmOrganizationsRouteEntry),
        (0, $7YRoH.productsJswConfigurationRouteEntry),
        (0, $i0b8q.productsJswStorageManagementRouteEntry),
        (0, $734Wz.productsOnboardingHubRouteEntry),
        (0, $jKCJe.proformaExportRouteEntry),
        (0, $iJIU8.proformaIssueFormsGeneralRouteEntry),
        (0, $64qpc.projectComponentsRedirectRouteEntry),
        (0, $87aC7.projectComponentsRouteEntry),
        (0, $aAF0I.projectDirectoryRedirectRouteEntry),
        (0, $4Aamz.projectIssueNavigatorRouteEntry),
        (0, $hPrN5.projectNotFoundRouteEntry),
        (0, $kKEWZ.projectPagesLegacyRouteEntry),
        (0, $ljItG.projectPagesRouteEntry),
        (0, $fQyGL.projectsDirectoryLegacyPathRedirectRouteEntry),
        (0, $ifEj3.projectsDirectoryManageRedirectRouteEntry),
        (0, $4CGuj.projectsDirectoryManageRootRedirectRouteEntry),
        (0, $6VvYi.projectsDirectoryRedirectRouteEntry),
        (0, $dSrOC.projectsDirectoryRouteEntry),
        (0, $j0BAb.projectServiceDeskRouteEntry),
        (0, $d7mi1.projectSettingsAutomationCRouteEntry),
        (0, $5HfC7.projectSettingsAutomationRouteEntry),
        (0, $6JQwt.projectSettingsComponentsRouteEntry),
        (0, $icwb1.projectSettingsCoreAccessRedirectRouteEntry),
        (0, $egxSq.projectSettingsCoreAccessRouteEntry),
        (0, $lhZGg.projectSettingsCoreApprovalsRouteEntry),
        (0, $jr5gb.projectSettingsCoreAppsFieldsRouteEntry),
        (0, $7lZOe.projectSettingsCoreAppsRouteEntry),
        (0, $9rVvQ.projectSettingsCoreAutomationRouteEntry),
        (0, $au6vg.projectSettingsCoreAutomationV2RouteEntry),
        (0, $cLamq.projectSettingsCoreDataClassificationsRouteEntry),
        (0, $2vHPs.projectSettingsCoreDefaultRedirectRouteEntry),
        (0, $hztdR.projectSettingsCoreDetailsRouteEntry),
        (0, $6cSNh.projectSettingsCoreFieldsRouteEntry),
        (0, $lIPtt.projectSettingsCoreForgeAppsRouteEntry),
        (0, $cWKD0.projectSettingsCoreIssueTypesRouteEntry),
        (0, $d0eOH.projectSettingsCoreIssueTypesWorkflowRouteEntry),
        (0, $bxg3m.projectSettingsCoreNotificationsEmailRouteEntry),
        (0, $e6Vbw.projectSettingsCoreNotificationsIssueLogsRouteEntry),
        (0, $7LwJB.projectSettingsCoreNotificationsRouteEntry),
        (0, $66HfJ.projectSettingsCoreProformaJiraFormBuilderRouteEntry),
        (0, $aDZxG.projectSettingsCoreProformaProjectFormsRouteEntry),
        (0, $lkwO5.projectSettingsCustomerServiceFeaturesRouteEntry),
        (0, $7QAza.projectSettingsForgeAppsNextgenRouteEntry),
        (0, $5MiVl.projectSettingsForgeAppsRouteEntry),
        (0, $ee5pi.projectSettingsOpsgenieRouteEntry),
        (0, $hWZAC.projectSettingsServicedeskAccessRedirectRouteEntry),
        (0, $2kXpo.projectSettingsServicedeskAccessRouteEntry),
        (0, $fhlje.projectSettingsServicedeskAppsFieldsRouteEntry),
        (0, $8to5X.projectSettingsServicedeskAppsRouteEntry),
        (0, $9eiXm.projectSettingsServicedeskAutomationCopyRuleRouteEntry),
        (0, $D5QBq.projectSettingsServicedeskAutomationCreateRouteEntry),
        (0, $hRMW9.projectSettingsServicedeskAutomationEditRuleRouteEntry),
        (0, $7B6VF.projectSettingsServicedeskAutomationRouteEntry),
        (0, $5W0wg.projectSettingsServicedeskAutomationSummaryRouteEntry),
        (0, $4eKYR.projectSettingsServicedeskAutomationViewLogRouteEntry),
        (0, $1aB8Z.projectSettingsServicedeskChangeManagementRouteEntry),
        (0, $a2PeW.projectSettingsServicedeskChannelsChatRouteEntry),
        (0, $gsEXA.projectSettingsServicedeskChannelsEmailNextGenRouteEntry),
        (0, $cONlw.projectSettingsServicedeskChannelsPermissionsNextGenRouteEntry),
        (0, $627LR.projectSettingsServicedeskChannelsPortalRouteEntry),
        (0, $amBHA.projectSettingsServicedeskChannelsRouteEntry),
        (0, $1XqXD.projectSettingsServicedeskChannelsWidgetRouteEntry),
        (0, $gXApH.projectSettingsServicedeskChatRouteEntry),
        (0, $jjqkz.projectSettingsServicedeskClassicAppsRouteEntry),
        (0, $h4Pr8.projectSettingsServicedeskCustomerNotificationsRouteEntry),
        (0, $28AFT.projectSettingsServicedeskCustomerPermissionsRouteEntry),
        (0, $dyGLN.projectSettingsServicedeskDataClassificationsRouteEntry),
        (0, $7xqQs.projectSettingsServicedeskDetailsRouteEntry),
        (0, $g3Gvc.projectSettingsServicedeskEmailRouteEntry),
        (0, $3wbIE.projectSettingsServicedeskExternalLinksRouteEntry),
        (0, $7fwfr.projectSettingsServicedeskFeedbackRouteEntry),
        (0, $peO7W.projectSettingsServicedeskFieldsRouteEntry),
        (0, $gUdrp.projectSettingsServicedeskForgeAppsRouteEntry),
        (0, $3M4hq.projectSettingsServicedeskIncidentManagementRouteEntry),
        (0, $drVWM.projectSettingsServicedeskInternalNotificationsNextGenRouteEntry),
        (0, $f1JiD.projectSettingsServicedeskIssuetypesRouteEntry),
        (0, $138gn.projectSettingsServicedeskIssuetypesWorkflowRouteEntry),
        (0, $gwCoT.projectSettingsServicedeskItsmFeaturesRouteEntry),
        (0, $kkXdG.projectSettingsServicedeskItsmTicketTypeFieldsRouteEntry),
        (0, $bl8cB.projectSettingsServicedeskItsmTicketTypesConfigRouteEntry),
        (0, $i8buc.projectSettingsServicedeskJourneyConfigurationEditRouteEntry),
        (0, $gpVZm.projectSettingsServicedeskJourneyConfigurationRouteEntry),
        (0, $1ods3.projectSettingsServicedeskJourneysRouteEntry),
        (0, $hqIff.projectSettingsServicedeskKbRouteEntry),
        (0, $ljDIh.projectSettingsServicedeskLanguageKeyRouteEntry),
        (0, $lAnjX.projectSettingsServicedeskLanguageRouteEntry),
        (0, $bCnWj.projectSettingsServicedeskLegacyAutomationRedirectCopyRouteEntry),
        (0, $aQ85T.projectSettingsServicedeskLegacyAutomationRedirectCreateRouteEntry),
        (0, $6kvQ5.projectSettingsServicedeskLegacyAutomationRedirectEditRouteEntry),
        (0, $9Dd5o.projectSettingsServicedeskLegacyAutomationRedirectSummaryRouteEntry),
        (0, $kci7Q.projectSettingsServicedeskLegacyAutomationRedirectViewLogRouteEntry),
        (0, $5XbrB.projectSettingsServicedeskNotificationsCustomerNotificationsRouteEntry),
        (0, $72XXS.projectSettingsServicedeskNotificationsEmailRouteEntry),
        (0, $bbdey.projectSettingsServicedeskNotificationsInternalNotificationsRouteEntry),
        (0, $t2WaR.projectSettingsServicedeskNotificationsNotificationEmailRouteEntry),
        (0, $yVmHw.projectSettingsServicedeskNotificationsRouteEntry),
        (0, $26BGc.projectSettingsServicedeskOverviewRouteEntry),
        (0, $dseRA.projectSettingsServicedeskPortalSettingsRouteEntry),
        (0, $fCX78.projectSettingsServicedeskProformaJiraFormBuilderRouteEntry),
        (0, $6NqDk.projectSettingsServicedeskProformaProjectFormsRouteEntry),
        (0, $bERWs.projectSettingsServicedeskRedirectRouteEntry),
        (0, $gPxpf.projectSettingsServicedeskTicketTypeFieldsRouteEntry),
        (0, $fLbia.projectSettingsServicedeskTicketTypesConfigRouteEntry),
        (0, $1Y5eu.projectSettingsServicedeskUnassignedTicketTypeFieldsRouteEntry),
        (0, $3FG4O.projectSettingsServicedeskUnassignedTicketTypesConfigRouteEntry),
        (0, $dDzIU.projectSettingsServicedeskWidgetRouteEntry),
        (0, $3SReJ.projectSettingsSoftwareAccessRedirectRouteEntry),
        (0, $aLuho.projectSettingsSoftwareAccessRouteEntry),
        (0, $3YX4q.projectSettingsSoftwareAppsFieldsRouteEntry),
        (0, $kEFGH.projectSettingsSoftwareAppsRouteEntry),
        (0, $kwWQ0.projectSettingsSoftwareAutomationRouteEntry),
        (0, $7F7I9.projectSettingsSoftwareBoardsCardRouteEntry),
        (0, $2OQWG.projectSettingsSoftwareBoardsCsmRouteEntry),
        (0, $4eRSO.projectSettingsSoftwareBoardsCustomFiltersRouteEntry),
        (0, $b9Dpn.projectSettingsSoftwareBoardsRedirectRouteEntry),
        (0, $eitw0.projectSettingsSoftwareBoardsRoadmapRouteEntry),
        (0, $14ooS.projectSettingsSoftwareBoardsTimelineRouteEntry),
        (0, $lWR9T.projectSettingsSoftwareDataClassificationsRouteEntry),
        (0, $6DlqX.projectSettingsSoftwareDetailsRouteEntry),
        (0, $jCfr4.projectSettingsSoftwareFieldsRouteEntry),
        (0, $kRn5i.projectSettingsSoftwareIssuetypesRouteEntry),
        (0, $3NIY8.projectSettingsSoftwareIssuetypesWorkflowRouteEntry),
        (0, $fjYA2.projectSettingsSoftwareNextGenFeaturesRouteEntry),
        (0, $qdq3O.projectSettingsSoftwareNotificationEmailCRouteEntry),
        (0, $aY70k.projectSettingsSoftwareNotificationEmailRouteEntry),
        (0, $2wF9u.projectSettingsSoftwareNotificationsIssueLogsRouteEntry),
        (0, $feDOq.projectSettingsSoftwareNotificationsRouteEntry),
        (0, $cqk4B.projectSettingsSoftwareProformaJiraFormBuilderRouteEntry),
        (0, $d66ag.projectSettingsSoftwareProformaProjectFormsRouteEntry),
        (0, $84EwA.projectSettingsSoftwareRedirectRouteEntry),
        (0, $7dYbE.projectSettingsToolchainRouteEntry),
        (0, $dRm2C.projectSettingsVersionsRouteEntry),
        (0, $1Ps9S.projectsRedirectRouteEntry),
        (0, $bRRmd.projectVersionsRouteEntry),
        (0, $1XAMa.promotionsRouteEntry),
        (0, $aA0rC.rapidboardBacklog1RouteEntry),
        (0, $hjVS0.rapidboardLastVisitedProjectRedirectRouteEntry),
        (0, $jss6V.rapidboardReport1RouteEntry),
        (0, $1iYkP.rapidboardReportRouteEntry),
        (0, $4XUsE.rapidboardUserBacklogRouteEntry),
        (0, $bbDvZ.rapidboardUserReportRouteEntry),
        (0, $e7GI8.rapidboardUserReportsOverviewRouteEntry),
        (0, $4Xzif.roleBasedNotificationDetailRouteEntry),
        (0, $7mf3n.roleBasedNotificationsRouteEntry),
        (0, $4VMm4.rovoSearchRouteEntry),
        (0, $gMkpP.sandboxBundlerBifrostEntrypointsRouteEntry),
        (0, $gtcNN.sandboxBundlerBifrostRLLRouteEntry),
        (0, $jr7ke.sandboxBundlerRouteEntry),
        (0, $hhRES.sandboxRelayEchoPageUsingEntryPointRouteEntry),
        (0, $8VY8F.sandboxRelayEchoPageUsingRLLRouteEntry),
        (0, $aApqk.sandboxRelayJiraPageRouteEntry),
        (0, $dTkCg.secureFiltersDirectoryRedirectRouteEntry),
        (0, $eTL4x.selectedDashboardRouteEntry),
        (0, $lzLcy.servicedeskAtlassianAnalyticsRouteEntry),
        (0, $cJoBA.servicedeskCalendarRouteEntry),
        (0, $SBgrM.servicedeskChangeCalendarRouteEntry),
        (0, $cVgRQ.servicedeskCmdbAssetsGlobalConfigurationRouteEntry),
        (0, $8XfJX.servicedeskCmdbAssetsObjectRouteEntry),
        (0, $5o5UE.servicedeskCmdbAssetsObjectSchemaConfigurationRouteEntry),
        (0, $2OBp2.servicedeskCmdbAssetsObjectSchemaRouteEntry),
        (0, $29XA4.servicedeskCmdbAssetsObjectTypeConfigurationRouteEntry),
        (0, $aNc7A.servicedeskCmdbAssetsReportsRouteEntry),
        (0, $4e4nJ.servicedeskCmdbAssetsReportsTemplateRouteEntry),
        (0, $5nU8P.servicedeskCmdbAssetsReportsUnsubscribeRouteEntry),
        (0, $kHVIE.servicedeskCmdbAssetsSchemasRouteEntry),
        (0, $eHeAh.servicedeskCmdbInsightConfigureGlobalRouteEntry),
        (0, $9R3is.servicedeskCmdbInsightConfigureRouteEntry),
        (0, $lKkaY.servicedeskCmdbInsightObject4RouteEntry),
        (0, $brWuf.servicedeskCmdbInsightObjectSchemaConfigurationRouteEntry),
        (0, $iXsus.servicedeskCmdbInsightObjectSchemaRouteEntry),
        (0, $xwXfC.servicedeskCmdbInsightObjectTypeConfigurationRouteEntry),
        (0, $3lpLH.servicedeskCmdbInsightRouteEntry),
        (0, $iLmKH.servicedeskConnectProjectRouteEntry),
        (0, $kNZj9.servicedeskCreateProjectRouteEntry),
        (0, $dCGUp.servicedeskCustomerDetailsRouteEntry),
        (0, $4KLVz.servicedeskCustomersV2RouteEntry),
        (0, $lYrmE.servicedeskGettingStartedRouteEntry),
        (0, $6YHWn.servicedeskIssueRouteEntry),
        (0, $awOZa.servicedeskItsmSampleSpaceRouteEntry),
        (0, $kZgpC.servicedeskKbRequestsReports2RouteEntry),
        (0, $auP5Z.servicedeskKbRequestsReportsIssueRouteEntry),
        (0, $6un8I.servicedeskKbRequestsReportsTimeScaleRouteEntry),
        (0, $l1PfI.servicedeskOncallScheduleRouteEntry),
        (0, $cvYE5.servicedeskOrganizationDetailsRouteEntry),
        (0, $2cpS3.servicedeskOrganizationsRouteEntry),
        (0, $iuWOh.servicedeskOrganizationV2RouteEntry),
        (0, $2r2Gu.servicedeskPlaybooksEditRouteEntry),
        (0, $80PF8.servicedeskPlaybooksListRouteEntry),
        (0, $aAIWh.servicedeskPracticeEditRouteEntry),
        (0, $5fOtJ.servicedeskPracticeIssueRouteEntry),
        (0, $gfz2f.servicedeskPracticeLandingRouteEntry),
        (0, $gfW60.servicedeskPracticeManageViewRouteEntry),
        (0, $h51Kg.servicedeskPracticeNewRouteEntry),
        (0, $fEAJ2.servicedeskPracticeViewsConfigRouteEntry),
        (0, $1rMUU.servicedeskProformaIssueFormsDirectEmbedRouteEntry),
        (0, $36qRE.servicedeskProformaIssueFormsDirectRouteEntry),
        (0, $2QFEo.servicedeskProjectDashboardsEditableRouteEntry),
        (0, $fQGIH.servicedeskProjectDashboardsListRouteEntry),
        (0, $c0JOH.servicedeskProjectSummaryRouteEntry),
        (0, $rsO8k.servicedeskQueuesAddonRouteEntry),
        (0, $5JkxV.servicedeskQueuesEditRouteEntry),
        (0, $jIBei.servicedeskQueuesIssueRouteEntry),
        (0, $3oSi6.servicedeskQueuesLandingRouteEntry),
        (0, $96BnX.servicedeskQueuesManageViewRouteEntry),
        (0, $fP1EY.servicedeskQueuesNewRouteEntry),
        (0, $2yO8h.servicedeskQueuesViewsConfigRouteEntry),
        (0, $c97hk.servicedeskReports1RouteEntry),
        (0, $7sSEm.servicedeskReportsCustom4RouteEntry),
        (0, $eaXgt.servicedeskReportsCustomCreateRouteEntry),
        (0, $moUwl.servicedeskReportsCustomEditRouteEntry),
        (0, $7D3Yv.servicedeskReportsCustomIssueRouteEntry),
        (0, $dgneZ.servicedeskReportsCustomTimeScaleRouteEntry),
        (0, $hRN7l.servicedeskReportsSatisfaction2RouteEntry),
        (0, $cU5zd.servicedeskReportsSatisfactionIssueRouteEntry),
        (0, $fSktp.servicedeskReportsSatisfactionTimeScaleRouteEntry),
        (0, $5TKdO.servicedeskReportsTypeRouteEntry),
        (0, $4zSYf.servicedeskReportsWorkloadRouteEntry),
        (0, $j175z.servicedeskServiceDetailsRouteEntry),
        (0, $gQWOR.serviceDeskServiceDetailsWithoutProjectRouteEntry),
        (0, $zaQdk.servicedeskServiceModalEditRouteEntry),
        (0, $4UU5H.servicedeskServiceModalNewRouteEntry),
        (0, $izdjx.servicedeskServicesRouteEntry),
        (0, $eWSeK.serviceDeskServicesWithoutProjectRouteEntry),
        (0, $6agOS.servicedeskSlaSettingsRouteEntry),
        (0, $2ytxj.servicedeskWorkflowConfigRouteEntry),
        (0, $16Svt.settingsAutomationRouteEntry),
        (0, $7m5aN.settingsCmdbFieldConfigRouteEntry),
        (0, $kDimk.settingsOauthCredentialsRouteEntry),
        (0, $9z1Wd.settingsRouteEntry),
        (0, $2FVZu.softwareAdvancedRoadmapsGettingStartedRedirectRouteEntry),
        (0, $fQCGk.softwareBacklogEmbedRouteEntry),
        (0, $1EVpW.softwareBacklogRouteEntry),
        (0, $azyVo.softwareBoardEmbedRouteEntry),
        (0, $7wXr4.softwareBoardRouteEntry),
        (0, $wwgc5.softwareBoardViewNotFoundClassicRouteEntry),
        (0, $eAw5v.softwareBoardViewNotFoundRouteEntry),
        (0, $djlm6.softwareCalendarClassicEmbedRouteEntry),
        (0, $3J8Cl.softwareCalendarClassicRouteEntry),
        (0, $kutfD.softwareCalendarEmbedRouteEntry),
        (0, $2z6Z2.softwareCalendarRouteEntry),
        (0, $knZRG.softwareClassicProformaIssueFormsDirectEmbedRouteEntry),
        (0, $hUUCw.softwareClassicProformaIssueFormsDirectRouteEntry),
        (0, $6B4GJ.softwareCodeClassicRouteEntry),
        (0, $1kSIj.softwareCodeRouteEntry),
        (0, $bi9fZ.softwareDeploymentsClassicRouteEntry),
        (0, $jvZP3.softwareDeploymentsNextGenRouteEntry),
        (0, $711QI.softwareFormBuilderClassicRouteEntry),
        (0, $03taV.softwareFormBuilderRouteEntry),
        (0, $kQjkp.softwareFormClassicRouteEntry),
        (0, $6KvsG.softwareFormRouteEntry),
        (0, $efYyQ.softwareFormSubmitClassicPublicRouteEntry),
        (0, $gcVUu.softwareFormSubmitClassicRouteEntry),
        (0, $dG6DF.softwareFormSubmitEmbedClassicRouteEntry),
        (0, $kg7GL.softwareFormSubmitEmbedRouteEntry),
        (0, $aviVh.softwareFormSubmitPublicRouteEntry),
        (0, $i0tax.softwareFormSubmitRouteEntry),
        (0, $1IhKQ.softwareGoalsClassicRouteEntry),
        (0, $dl9zj.softwareGoalsRouteEntry),
        (0, $iQsfj.softwareInboxClassicRouteEntry),
        (0, $3gU47.softwareInboxNextGenRouteEntry),
        (0, $4Mj46.softwareIncidentsClassicRouteEntry),
        (0, $9MSQj.softwareIncidentsNextGenRouteEntry),
        (0, $6FBN4.softwareListClassicRouteEntry),
        (0, $bhft0.softwareListEmbedClassicRouteEntry),
        (0, $8Yag1.softwareListEmbedRouteEntry),
        (0, $2toxI.softwareListRouteEntry),
        (0, $dBV2a.softwareNextgenRedirectRouteEntry),
        (0, $5xsFH.softwareOnboardingRouteEntry),
        (0, $7Db7a.softwarePeriscopeClassicRouteEntry),
        (0, $eFYGV.softwarePeriscopeNextGenRouteEntry),
        (0, $lGnoq.softwarePlanCalendarRouteEntry),
        (0, $6cMQO.softwarePlanDependenciesRouteEntry),
        (0, $lxXtu.softwarePlanReleasesRouteEntry),
        (0, $2l6sh.softwarePlanSettingsAutoSchedulerRouteEntry),
        (0, $1C9Ha.softwarePlanSettingsCustomFieldsRouteEntry),
        (0, $cChHY.softwarePlanSettingsExclusionRulesRouteEntry),
        (0, $1oew5.softwarePlanSettingsFeaturesRouteEntry),
        (0, $d1sI7.softwarePlanSettingsFindYourIssueRouteEntry),
        (0, $gksya.softwarePlanSettingsIssueSourcesRouteEntry),
        (0, $l0UsI.softwarePlanSettingsPermissionsRouteEntry),
        (0, $bdHl5.softwarePlanSettingsPlanInfoRouteEntry),
        (0, $5hvg3.softwarePlanSettingsProgramBoardsRouteEntry),
        (0, $6oWts.softwarePlanSettingsRemovedIssuesRouteEntry),
        (0, $76RJj.softwarePlanSettingsSavedViewsRouteEntry),
        (0, $ikfu9.softwarePlanSettingsScenariosRouteEntry),
        (0, $g7fao.softwarePlanSettingsSchedulingRouteEntry),
        (0, $8s6qp.softwarePlanSummaryRouteEntry),
        (0, $qruNQ.softwarePlanTeamsRouteEntry),
        (0, $4chTT.softwarePlanTimelineRouteEntry),
        (0, $2LfmF.softwareProformaIssueFormsDirectEmbedRouteEntry),
        (0, $gzdNI.softwareProformaIssueFormsDirectRouteEntry),
        (0, $ghTLp.softwareReleaseNotesRouteEntry),
        (0, $ickyX.softwareReportsBurndownRouteEntry),
        (0, $cQer4.softwareReportsBurnupRouteEntry),
        (0, $eL5iv.softwareReportsControlRouteEntry),
        (0, $7MlOX.softwareReportsCumulativeRouteEntry),
        (0, $lHzMh.softwareReportsCycleTimeClassicBoardRouteEntry),
        (0, $kYzjv.softwareReportsCycleTimeClassicRouteEntry),
        (0, $jK6bT.softwareReportsCycleTimeRouteEntry),
        (0, $jbAAG.softwareReportsDeploymentFrequencyClassicBoardRouteEntry),
        (0, $7dbQR.softwareReportsDeploymentFrequencyClassicRouteEntry),
        (0, $hvbE3.softwareReportsDeploymentFrequencyRouteEntry),
        (0, $3Jvzv.softwareReportsOverviewBoardlessRouteEntry),
        (0, $CY8KI.softwareReportsOverviewRouteEntry),
        (0, $glwG4.softwareReportsRouteEntry),
        (0, $lcFGc.softwareReportsVelocityRouteEntry),
        (0, $03CAy.softwareRoadmapClassicRouteEntry),
        (0, $056cU.softwareRoadmapRedirectRouteEntry),
        (0, $kxlGk.softwareRoadmapRouteEntry),
        (0, $fMbaV.softwareSecurityClassicRouteEntry),
        (0, $cyZLC.softwareSecurityNextGenRouteEntry),
        (0, $7PtTb.softwareStaffingRouteEntry),
        (0, $iwgxt.softwareSummaryClassicRouteEntry),
        (0, $e99fJ.softwareSummaryEmbedClassicRouteEntry),
        (0, $45nsl.softwareSummaryEmbedRouteEntry),
        (0, $9EGBH.softwareSummaryRouteEntry),
        (0, $heIfC.softwareTimelineClassicRouteEntry),
        (0, $jejF3.softwareTimelineRouteEntry),
        (0, $eKEYN.softwareVersionDetailEmbedRouteEntry),
        (0, $fwjnc.softwareVersionDetailLegacyRedirectRouteEntry),
        (0, $1KC4N.softwareVersionDetailNoTabPathRedirectRouteEntry),
        (0, $7ApVe.softwareVersionDetailRouteEntry),
        (0, $41tjC.softwareViewNotFoundClassicRouteEntry),
        (0, $3I1TD.softwareViewNotFoundRouteEntry),
        (0, $h0ilo.systemConfigurationRedirectRouteEntry),
        (0, $k1TyW.systemConfigurationRouteEntry),
        (0, $3av4N.systemDashboardEditRouteEntry),
        (0, $4BuRo.teamIntegrationCreateRouteEntry),
        (0, $6SWMv.teamIntegrationDetailRouteEntry),
        (0, $jFY66.teamIntegrationListRouteEntry),
        (0, $jPXYO.teamIntegrationLogRouteEntry),
        (0, $ktYro.teamIntegrationsRouteEntry),
        (0, $7UDCM.trashedPlanDirectLinkRouteEntry),
        (0, $hDCtq.trashPlansRouteEntry),
        (0, $2vUs2.trashProjectsDirectoryRedirectRouteEntry),
        (0, $bCHhM.trashProjectsDirectoryRouteEntry),
        (0, $g6Mf9.unlockOperationsRouteEntry),
        (0, $dR9Nr.userBoardRouteEntry),
        (0, $goreX.userBoardSettingsRouteEntry),
        (0, $jqbKy.userBoardVelocityRouteEntry),
        (0, $3eN7Y.userBoardViewNotFoundRouteEntry),
        (0, $hjvN4.userSegmentationRouteEntry),
        (0, $6fHM1.viewIntentRouteEntry),
        (0, $1GAqb.viewStandardFlowRouteEntry),
        (0, $V3Ey7.whoIsOnCallRouteEntry)
    ];

});
parcelRegister("UuOK7", function(module, exports) {

$parcel$export(module.exports, "aiAnswersRouteEntry", () => $6c5c5fc65aabbb89$export$7aab6c3a99455d30);

var $c04PQ = parcelRequire("c04PQ");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $e9zsZ = parcelRequire("e9zsZ");

var $aGFv5 = parcelRequire("aGFv5");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $9PZqh = parcelRequire("9PZqh");

var $mOeIa = parcelRequire("mOeIa");

var $lkFvK = parcelRequire("lkFvK");

var $k6R7C = parcelRequire("k6R7C");
const $6c5c5fc65aabbb89$var$aiAnswersPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $mOeIa.aiAnswersEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $6c5c5fc65aabbb89$export$7aab6c3a99455d30 = (0, $7NszV.createEntry)((0, $aGFv5.aiAnswersRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $c04PQ.isFedRamp)()) return undefined;
            return $6c5c5fc65aabbb89$var$aiAnswersPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $k6R7C.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $9PZqh.VirtualAgentAiAnswersSkeleton),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $e9zsZ.servicedeskVirtualAgentAiAnswersKbResource)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_AI_ANSWERS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_AI_ANSWERS),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }));

});
parcelRegister("lmyls", function(module, exports) {

$parcel$export(module.exports, "ADDON_ID", () => $ee51d260cb059727$export$6c4866a933650d1d);
$parcel$export(module.exports, "MENU_ID", () => $ee51d260cb059727$export$d4cd258d01c03112);
$parcel$export(module.exports, "SIDEBAR_ID", () => $ee51d260cb059727$export$adf978edbdfaf080);
const $ee51d260cb059727$export$6c4866a933650d1d = {
    DISCOVER: 'com.atlassian.jira.emcee__enduser-discover'
};
const $ee51d260cb059727$export$d4cd258d01c03112 = {
    ADDONS: 'ADDONS',
    APP_SWITCHER: 'APP_SWITCHER',
    COMMUNICATIONS: 'COMMUNICATIONS',
    DASHBOARDS: 'DASHBOARDS',
    FILTERS: 'FILTERS',
    HELP: 'HELP',
    HOME: 'HOME',
    INSIGHT: 'INSIGHT',
    NOTIFICATIONS: 'NOTIFICATIONS',
    PEOPLE: 'PEOPLE',
    PLANS: 'PLANS',
    PROFILE: 'PROFILE',
    PROJECTS: 'PROJECTS',
    ROADMAPS: 'ROADMAPS',
    SEARCH: 'SEARCH',
    SERVICE_HUB: 'SERVICE_HUB',
    SETTINGS: 'SETTINGS',
    HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS'
};
const $ee51d260cb059727$export$adf978edbdfaf080 = {
    BOARD_SETTINGS: 'BOARD_SETTINGS',
    CONTENT: 'CONTENT',
    GLOBAL_APPS_SETTINGS: 'GLOBAL_APPS_SETTINGS',
    GLOBAL_ISSUES_SETTINGS: 'GLOBAL_ISSUES_SETTINGS',
    GLOBAL_PRODUCTS_SETTINGS: 'GLOBAL_PRODUCTS_SETTINGS',
    GLOBAL_PROJECTS_SETTINGS: 'GLOBAL_PROJECTS_SETTINGS',
    GLOBAL_SYSTEM_SETTINGS: 'GLOBAL_SYSTEM_SETTINGS',
    HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS',
    PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
    PLAN_SETTINGS: 'PLAN_SETTINGS',
    PROJECT_SETTINGS: 'PROJECT_SETTINGS',
    OPERATIONS_GENERAL_CONFIGURATION: 'OPERATIONS_GENERAL_CONFIGURATION'
};

});

parcelRegister("h0bZU", function(module, exports) {

$parcel$export(module.exports, "ForPaintServicedeskSidebar", () => $ca3f1b5dd616f02b$export$c72ea37d21335def);
$parcel$export(module.exports, "default", () => $ca3f1b5dd616f02b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

var $lODMY = parcelRequire("lODMY");

var $4R6GH = parcelRequire("4R6GH");

var $6lAw8 = parcelRequire("6lAw8");
const $ca3f1b5dd616f02b$var$routesUsingLazyForPaint = new Set([
    'servicedesk-queues-custom-view',
    'servicedesk-practice-custom-view',
    'issue'
]);

const $ca3f1b5dd616f02b$export$4553575c70a669bf = (0, $kxZPA.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("h8ZLT")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/servicedesk/src/index.tsx"
});
const $ca3f1b5dd616f02b$var$AfterPaintServicedeskSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "servicedeskProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ca3f1b5dd616f02b$export$4553575c70a669bf, null)));
const $ca3f1b5dd616f02b$export$c72ea37d21335def = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "servicedeskProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6lAw8.LazyForPaintServicedeskSidebar), null)));
const $ca3f1b5dd616f02b$var$ServicedeskSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    const isLazyForPaintRoute = (0, $lODMY.useIsActiveRoute)((0, $4R6GH.fg)('queues_sidebar_lazyafterpaint_to_lazyforpaint') ? $ca3f1b5dd616f02b$var$routesUsingLazyForPaint : 'issue');
    return isLazyForPaintRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ca3f1b5dd616f02b$export$c72ea37d21335def, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ca3f1b5dd616f02b$var$AfterPaintServicedeskSidebar, null);
});
$ca3f1b5dd616f02b$var$ServicedeskSidebar.displayName = 'ServicedeskSidebar';
$ca3f1b5dd616f02b$export$c72ea37d21335def.displayName = 'ServicedeskSidebar';
var $ca3f1b5dd616f02b$export$2e2bcd8739ae039 = $ca3f1b5dd616f02b$var$ServicedeskSidebar;

});
parcelRegister("dZQxE", function(module, exports) {

$parcel$export(module.exports, "SidebarBoundary", () => $e39fc1e1d73100a0$export$1edc778464f08256);

var $5uXOq = parcelRequire("5uXOq");

var $5e7oM = parcelRequire("5e7oM");

var $azzrO = parcelRequire("azzrO");

var $lfTZh = parcelRequire("lfTZh");

var $5Hj3V = parcelRequire("5Hj3V");

var $acDan = parcelRequire("acDan");

var $lGo7j = parcelRequire("lGo7j");
const $e39fc1e1d73100a0$export$1edc778464f08256 = ({ children: children, id: id })=>{
    const onFail = (0, $acDan.useSidebarFail)();
    const onSuccess = (0, $acDan.useSidebarSuccess)();
    const onError = (0, $5uXOq.useCallback)((location, error)=>{
        // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error'.
        const { statusCode: statusCode } = error;
        if (statusCode != null && statusCode >= 400 && statusCode < 500) onSuccess();
        else onFail(location, error);
    }, [
        onFail,
        onSuccess
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Hj3V.SidebarErrorBoundary), {
        id: id,
        packageName: "jiraSpaAppsSidebarCommon",
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavSidebarPerformanceMark), {
        metricKey: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderAttempt
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav-sidebar",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lGo7j.Skeleton), {
            isFull: true
        })
    }, children));
};

});
parcelRegister("5e7oM", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_TOP_SEGMENT_NAME", () => $83022b592d1d8567$export$6635720e40ea7a7a);
$parcel$export(module.exports, "NAVIGATION_SIDEBAR_SEGMENT_NAME", () => $83022b592d1d8567$export$1d3c3cb357af0e86);
$parcel$export(module.exports, "NAVIGATION_SSR_MARK_PREFIX", () => $83022b592d1d8567$export$e7a14fa81b3c6488);
$parcel$export(module.exports, "NAVIGATION_TOP_MARKS", () => $83022b592d1d8567$export$ad760bb9734bf93f);
$parcel$export(module.exports, "NAVIGATION_SIDEBAR_MARKS", () => $83022b592d1d8567$export$1d10ee0c85c3cb21);
const $83022b592d1d8567$export$6635720e40ea7a7a = 'navigation.top';
const $83022b592d1d8567$export$1d3c3cb357af0e86 = 'navigation.sidebar';
const $83022b592d1d8567$export$e7a14fa81b3c6488 = 'nav-ssr-mark';
const $83022b592d1d8567$export$ad760bb9734bf93f = {
    renderStart: 'navigation-top.render.start',
    renderEnd: 'navigation-top.render.end',
    renderSsrStart: 'navigation-top.render.ssr.start',
    renderSsrEnd: 'navigation-top.render.ssr.end',
    bundleLoadStart: 'navigation-top.bundle-load.start'
};
const $83022b592d1d8567$export$1d10ee0c85c3cb21 = {
    renderAttempt: 'navigation-sidebar.render.attempt',
    renderStart: 'navigation-sidebar.render.start',
    renderEnd: 'navigation-sidebar.render.end',
    renderSsrStart: 'navigation-sidebar.render.ssr.start',
    renderSsrEnd: 'navigation-sidebar.render.ssr.end',
    loadStart: 'navigation-sidebar.load.start',
    loadEnd: 'navigation-sidebar.load.end'
};

});

parcelRegister("azzrO", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_TOP_DROPDOWN_MARKS", () => $4d07bc740e316cc0$export$8df02628d98cae7e);
$parcel$export(module.exports, "pageSegmentStore", () => $4d07bc740e316cc0$export$26cadbe0bcaabcde);
$parcel$export(module.exports, "useNavPerformanceMetrics", () => $4d07bc740e316cc0$export$906025848d54198d);
$parcel$export(module.exports, "NavTopPerformanceMark", () => $4d07bc740e316cc0$export$b7f4caa65b0906fc);
$parcel$export(module.exports, "NavTopPerformanceReport", () => $4d07bc740e316cc0$export$c64b31449a6177d);
$parcel$export(module.exports, "NavSidebarPerformanceMark", () => $4d07bc740e316cc0$export$35b2aeea5cbc963e);
$parcel$export(module.exports, "NavSidebarPerformanceReport", () => $4d07bc740e316cc0$export$a018e347341b3640);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $dGrdR = parcelRequire("dGrdR");

var $cfDZ3 = parcelRequire("cfDZ3");

var $5M3R9 = parcelRequire("5M3R9");

var $5e7oM = parcelRequire("5e7oM");

const $4d07bc740e316cc0$var$createTopNavPageSegment = ()=>(0, $dGrdR.metrics).pageSegmentLoad({
        key: (0, $5e7oM.NAVIGATION_TOP_SEGMENT_NAME),
        timings: [
            {
                key: 'ttic',
                startMark: (0, $5e7oM.NAVIGATION_TOP_MARKS).renderStart,
                endMark: (0, $5e7oM.NAVIGATION_TOP_MARKS).renderEnd
            },
            {
                key: 'tti',
                endMark: (0, $5e7oM.NAVIGATION_TOP_MARKS).renderEnd
            },
            {
                key: 'ttr',
                endMark: (0, $5e7oM.NAVIGATION_TOP_MARKS).renderSsrEnd
            },
            {
                key: 'ttrc',
                startMark: (0, $5e7oM.NAVIGATION_TOP_MARKS).renderSsrStart,
                endMark: (0, $5e7oM.NAVIGATION_TOP_MARKS).renderSsrEnd
            },
            {
                key: 'bundle-load',
                startMark: (0, $5e7oM.NAVIGATION_TOP_MARKS).bundleLoadStart,
                endMark: (0, $5e7oM.NAVIGATION_TOP_MARKS).renderStart
            }
        ],
        histogram: {
            initial: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '4000_4500_5000_6000_7000_8000_9000'
            },
            transition: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '2500_3000_3500_4000_5000_6000'
            }
        }
    });
const $4d07bc740e316cc0$export$8df02628d98cae7e = {
    ADDONS: (0, $dGrdR.metrics).interaction({
        key: 'navigation-top.addons-dropdown-opened'
    })
};
const $4d07bc740e316cc0$var$createSidebarPageSegment = ()=>(0, $dGrdR.metrics).pageSegmentLoad({
        key: (0, $5e7oM.NAVIGATION_SIDEBAR_SEGMENT_NAME),
        timings: [
            {
                key: 'renderAttempt',
                startMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderAttempt,
                endMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderAttempt
            },
            {
                key: 'ttic',
                startMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderStart,
                endMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderEnd
            },
            {
                key: 'tti',
                endMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderEnd
            },
            {
                key: 'ttr',
                endMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
            },
            {
                key: 'ttrc',
                startMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderSsrStart,
                endMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
            },
            {
                key: 'load',
                startMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).loadStart,
                endMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).loadEnd
            }
        ],
        histogram: {
            initial: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '4000_4500_5000_6000_7000_8000_9000'
            },
            transition: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '2500_3000_3500_4000_5000_6000'
            }
        }
    });
const $4d07bc740e316cc0$export$26cadbe0bcaabcde = (()=>{
    const segmentConstructors = {
        [(0, $5e7oM.NAVIGATION_TOP_SEGMENT_NAME)]: $4d07bc740e316cc0$var$createTopNavPageSegment,
        [(0, $5e7oM.NAVIGATION_SIDEBAR_SEGMENT_NAME)]: $4d07bc740e316cc0$var$createSidebarPageSegment
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const segments = {};
    return {
        getSegment: (key)=>{
            if (!segments[key]) {
                if (!segmentConstructors[key]) throw new Error(`Segment constructor for ${key} is not defined.`);
                segments[key] = segmentConstructors[key]();
            }
            return segments[key];
        }
    };
})();
const $4d07bc740e316cc0$export$906025848d54198d = (segmentKey = (0, $5e7oM.NAVIGATION_TOP_SEGMENT_NAME))=>{
    const startedRef = (0, $5uXOq.useRef)(false);
    const segment = (0, $5uXOq.useRef)($4d07bc740e316cc0$export$26cadbe0bcaabcde.getSegment(segmentKey)).current;
    if (!false && !startedRef.current) {
        segment && segment.startFromPageLoad();
        startedRef.current = true;
    }
    return (0, $5uXOq.useMemo)(()=>// object assign here to extend origianl segment object and save prototypes
        Object.assign(segment, {
            markSSR: (metricKey)=>{
                const tmpSsrMetricKey = `${(0, $5e7oM.NAVIGATION_SSR_MARK_PREFIX)}.${metricKey}`;
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                if (window.SPA_STATE) {
                    // @ts-expect-error - TS2339 - Property 'startTime' does not exist on type 'unknown'. | TS2339 - Property 'duration' does not exist on type 'unknown'.
                    const { startTime: startTime = 0, duration: duration = 0 } = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))((0, $5M3R9.getRenderTraceFromSSRGlobal)(), [
                        'traces',
                        `render/${tmpSsrMetricKey}`
                    ]) || {};
                    const markTime = startTime + duration;
                    markTime && markTime > 0 && segment.mark(metricKey, markTime);
                }
            }
        }), [
        segment
    ]);
};
const $4d07bc740e316cc0$var$NavigationPerformanceMark = ({ segmentKey: segmentKey, metricKey: metricKey })=>{
    const navSegment = $4d07bc740e316cc0$export$906025848d54198d(segmentKey);
    (0, $5uXOq.useEffect)(()=>navSegment.mark(metricKey), // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return null;
};
const $4d07bc740e316cc0$var$NavigationPerformanceReport = ({ segmentKey: segmentKey, customData: customData })=>{
    const navSegment = $4d07bc740e316cc0$export$906025848d54198d(segmentKey);
    (0, $5uXOq.useEffect)(()=>{
        navSegment.stop({
            customData: {
                ...customData,
                userLocation: (0, $cfDZ3.getUserLocation)()
            }
        });
        navSegment.clear();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
const $4d07bc740e316cc0$export$b7f4caa65b0906fc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationPerformanceMark, {
        ...props,
        segmentKey: (0, $5e7oM.NAVIGATION_TOP_SEGMENT_NAME)
    });
const $4d07bc740e316cc0$export$c64b31449a6177d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationPerformanceReport, {
        ...props,
        segmentKey: (0, $5e7oM.NAVIGATION_TOP_SEGMENT_NAME)
    });
const $4d07bc740e316cc0$export$35b2aeea5cbc963e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationPerformanceMark, {
        ...props,
        segmentKey: (0, $5e7oM.NAVIGATION_SIDEBAR_SEGMENT_NAME)
    });
const $4d07bc740e316cc0$export$a018e347341b3640 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationPerformanceReport, {
        ...props,
        segmentKey: (0, $5e7oM.NAVIGATION_SIDEBAR_SEGMENT_NAME)
    });

});
parcelRegister("5M3R9", function(module, exports) {

$parcel$export(module.exports, "RenderTracerMark", () => $ca67b9a5090b457c$export$54c89059bb435049);
$parcel$export(module.exports, "getRenderTraceFromSSRGlobal", () => $ca67b9a5090b457c$export$345f21b0287f67e5);

var $5uXOq = parcelRequire("5uXOq");

var $6Csk1 = parcelRequire("6Csk1");

var $9XE6b = parcelRequire("9XE6b");

var $jR67t = parcelRequire("jR67t");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

const $ca67b9a5090b457c$var$initialState = {
    start: undefined,
    traces: {}
};
let $ca67b9a5090b457c$var$currentTraces = {};
const $ca67b9a5090b457c$export$2365ecd8218e21c7 = ()=>$ca67b9a5090b457c$var$currentTraces;
const $ca67b9a5090b457c$export$5c757eaa1990d0d7 = (key)=>{
    if ($ca67b9a5090b457c$var$currentTraces[key]) return;
    $ca67b9a5090b457c$var$currentTraces[key] = {
        startTime: (0, $jR67t.performance).now()
    };
};
const $ca67b9a5090b457c$export$16854dc18f8d976 = (key)=>{
    if (!$ca67b9a5090b457c$var$currentTraces[key] || $ca67b9a5090b457c$var$currentTraces[key].duration != null) return;
    $ca67b9a5090b457c$var$currentTraces[key].duration = (0, $jR67t.performance).now() - $ca67b9a5090b457c$var$currentTraces[key].startTime;
};
const $ca67b9a5090b457c$var$actions = {
    startTrace: (name, time)=>({ setState: setState, getState: getState }, { startKey: startKey })=>{
            const { start: start, traces: traces } = getState();
            // If <RenderTracerContainer /> has not been setup with a startKey and startTime, return
            if (start === undefined) return;
            const key = name === startKey ? name : `${startKey}/${name}`;
            if (traces[key]) return;
            setState({
                traces: (0, (/*@__PURE__*/$parcel$interopDefault($6Csk1)))({}, traces, {
                    [key]: {
                        startTime: time
                    }
                })
            });
        },
    endTrace: (name, time)=>({ setState: setState, getState: getState }, { startKey: startKey })=>{
            const { start: start, traces: traces } = getState();
            if (start === undefined) return;
            const key = name === startKey ? name : `${startKey}/${name}`;
            const trace = traces[key] || {
                startTime: 0
            };
            setState({
                traces: (0, (/*@__PURE__*/$parcel$interopDefault($6Csk1)))({}, traces, {
                    [key]: {
                        ...trace,
                        duration: time - trace.startTime
                    }
                })
            });
            $ca67b9a5090b457c$var$currentTraces = Object.assign($ca67b9a5090b457c$var$currentTraces, getState().traces);
        }
};
const $ca67b9a5090b457c$var$Store = (0, $iXqE5.createStore)({
    name: 'jira-render-tracer',
    initialState: $ca67b9a5090b457c$var$initialState,
    actions: $ca67b9a5090b457c$var$actions
});
const $ca67b9a5090b457c$var$RenderTracerActions = (0, $51nlc.createSubscriber)($ca67b9a5090b457c$var$Store, {
    selector: null
});
const $ca67b9a5090b457c$export$719a95758870be58 = (0, $3sQ5x.createHook)($ca67b9a5090b457c$var$Store, {
    selector: null
});
const $ca67b9a5090b457c$var$RenderTracerContainerBase = (0, $gg7kZ.createContainer)($ca67b9a5090b457c$var$Store, {
    onInit: ()=>({ setState: setState }, { startKey: startKey, startTime: startTime })=>{
            setState({
                start: startTime,
                traces: {
                    [startKey]: {
                        startTime: (0, $jR67t.performance).now()
                    }
                }
            });
        }
});
const $ca67b9a5090b457c$export$37d31bee41ca1401 = ({ children: children, startKey: startKey, startTime: startTime })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ca67b9a5090b457c$var$RenderTracerContainerBase, {
        startKey: startKey,
        startTime: startTime
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ca67b9a5090b457c$export$54c89059bb435049, {
        traceKey: startKey,
        type: "end"
    }));
const $ca67b9a5090b457c$export$54c89059bb435049 = ({ traceKey: traceKey, type: type })=>// @ts-expect-error - TS2745 - This JSX tag's 'children' prop expects type 'never' which requires multiple children, but only a single child was provided.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ca67b9a5090b457c$var$RenderTracerActions, null, (_, { startTrace: startTrace, endTrace: endTrace })=>{
        if (type === 'start') startTrace(traceKey, (0, $jR67t.performance).now());
        else if (type === 'end') endTrace(traceKey, (0, $jR67t.performance).now());
        return null;
    });
const $ca67b9a5090b457c$export$cba8addc8743389c = (appName = 'unknown', traces = $ca67b9a5090b457c$var$currentTraces)=>({
        [(0, $eb0760a6ada94ab6$export$3c96fa14fb694e11)]: {
            data: {
                traces: traces,
                routeName: appName
            }
        }
    });
const $ca67b9a5090b457c$export$345f21b0287f67e5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.SPA_STATE || window.SKELETON_NAVIGATION || {}, [
        (0, $eb0760a6ada94ab6$export$3c96fa14fb694e11),
        'data'
    ], {});

});
parcelRegister("jR67t", function(module, exports) {

$parcel$export(module.exports, "performance", () => $c026bc7061377d6e$export$f2d2284f5fec51f8);
const $c026bc7061377d6e$var$now = ()=>false ? Date.now() : $parcel$global.performance.now();
class $c026bc7061377d6e$export$9a0dbed22cbf63be {
    start() {
        if (false) this.startAt = $c026bc7061377d6e$var$now();
    }
    now() {
        if (false) return $c026bc7061377d6e$var$now() - this.startAt;
        return $c026bc7061377d6e$var$now();
    }
    constructor(){
        this.startAt = $c026bc7061377d6e$var$now();
    }
}
const $c026bc7061377d6e$export$f2d2284f5fec51f8 = new $c026bc7061377d6e$export$9a0dbed22cbf63be();

});

const $eb0760a6ada94ab6$export$3c96fa14fb694e11 = 'ssr/detail_render_trace';



parcelRegister("5Hj3V", function(module, exports) {

$parcel$export(module.exports, "SidebarErrorBoundary", () => $c3958cf153a091e2$export$62853c5766dad0c4);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $cfDZ3 = parcelRequire("cfDZ3");

var $kqzba = parcelRequire("kqzba");
const $c3958cf153a091e2$export$62853c5766dad0c4 = (props)=>{
    const userLocation = (0, $cfDZ3.getUserLocation)();
    const extraEventData = (0, $5uXOq.useMemo)(()=>({
            ...props.extraEventData,
            userLocation: userLocation
        }), [
        props.extraEventData,
        userLocation
    ]);
    const fallback = (0, $5uXOq.useCallback)(({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kqzba.Fallback), {
            error: error
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        ...props,
        extraEventData: extraEventData,
        fallback: fallback
    });
};

});
parcelRegister("kqzba", function(module, exports) {

$parcel$export(module.exports, "Fallback", () => $790c5d1c3d335eca$export$fb8d7f40caaeea67);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $kobfu = parcelRequire("kobfu");

var $koVbs = parcelRequire("koVbs");

var $bkXzF = parcelRequire("bkXzF");

var $h8OaL = parcelRequire("h8OaL");
const $790c5d1c3d335eca$var$styles = {
    wrapper: "_zulpu2gc _bfhk1jdc _syaz1mjl _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _y3gn1h6o _4cvr1h6o _1e0c1txw _2lx21bp4",
    error: "_2rko9j3y _11c8dcr7 _syaz131l _bfhk1v33 _ca0qv77o _n3tdv77o _19bv1b66 _u5f31b66",
    image: "_4t3i12am"
};
const $790c5d1c3d335eca$export$fb8d7f40caaeea67 = (props)=>{
    const { error: error } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $790c5d1c3d335eca$var$styles.wrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        alt: "",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bkXzF))),
        className: (0, $bwpsq.default)([
            $790c5d1c3d335eca$var$styles.image
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall"
    }, formatMessage((0, $h8OaL.default).errorHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $h8OaL.default).errorBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("code", {
        className: (0, $bwpsq.default)([
            $790c5d1c3d335eca$var$styles.error
        ])
    }, "ERROR: ", (0, $kobfu.getErrorHash)(error)));
};

});
parcelRegister("bkXzF", function(module, exports) {
module.exports = new URL("generic-error.76ff7c6a.svg", import.meta.url).toString();

});

parcelRegister("h8OaL", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7c8a71ff5065c1e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e7c8a71ff5065c1e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorHeading: {
        "id": "spa-apps-sidebar-common.common.error-boundary.fallback.error-heading",
        "defaultMessage": "Something went wrong"
    },
    errorBody: {
        "id": "spa-apps-sidebar-common.common.error-boundary.fallback.error-body",
        "defaultMessage": "Try refreshing or navigating to another page."
    }
});

});



parcelRegister("acDan", function(module, exports) {

$parcel$export(module.exports, "SidebarStart", () => $b5a3a4467dac2130$export$6738d1299dc79710);
$parcel$export(module.exports, "SidebarRenderStart", () => $b5a3a4467dac2130$export$ba19e3624956e66);
$parcel$export(module.exports, "SidebarReady", () => $b5a3a4467dac2130$export$a06ecbbe5820282);
$parcel$export(module.exports, "useSidebarFail", () => $b5a3a4467dac2130$export$661ed14c8f75da9f);
$parcel$export(module.exports, "useSidebarSuccess", () => $b5a3a4467dac2130$export$ddb17534fdfb7dc6);

var $5uXOq = parcelRequire("5uXOq");

var $5e7oM = parcelRequire("5e7oM");

var $azzrO = parcelRequire("azzrO");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $4QcD9 = parcelRequire("4QcD9");

var $6jY6G = parcelRequire("6jY6G");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $6IzHB = parcelRequire("6IzHB");

var $doZTA = parcelRequire("doZTA");

var $kvHKs = parcelRequire("kvHKs");
// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
const { useValue: $b5a3a4467dac2130$var$useSidebarId } = (0, $4QcD9.createValueController)('sidebar-id');
const $b5a3a4467dac2130$var$EXPERIENCE_SUCCESS_ATTRIBUTES = {
    experience: (0, $kvHKs.SIDEBAR_EXPERIENCE),
    attributes: {
        sidebar: 'v3'
    }
};
const $b5a3a4467dac2130$export$6738d1299dc79710 = ()=>{
    const [{ route: route, match: match }] = (0, $doZTA.useRouter)();
    const pageId = (0, $6IzHB.usePageId)();
    const startRef = (0, $5uXOq.useRef)(Date.now());
    const onStartExperience = (0, $kaHBi.useExperienceStart)({
        experienceId: pageId,
        experience: (0, $kvHKs.SIDEBAR_EXPERIENCE),
        analyticsSource: 'Sidebar'
    });
    (0, $5uXOq.useMemo)(()=>{
        if (route.isRedirect ?? false) return;
        onStartExperience();
        startRef.current = Date.now();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route,
        match
    ]);
    return null;
};
const $b5a3a4467dac2130$export$ba19e3624956e66 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavSidebarPerformanceMark), {
        metricKey: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderStart
    });
const $b5a3a4467dac2130$export$a06ecbbe5820282 = ({ id: id })=>{
    const [, setSidebarId] = $b5a3a4467dac2130$var$useSidebarId();
    const route = (0, $6jY6G.useCurrentRoute)();
    const routeName = route.name ?? route.group ?? 'UNKNOWN';
    const onSuccess = (0, $3bQtK.useExperienceSuccess)($b5a3a4467dac2130$var$EXPERIENCE_SUCCESS_ATTRIBUTES);
    (0, $5uXOq.useEffect)(()=>{
        setSidebarId(id);
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
        return ()=>setSidebarId();
    }, [
        setSidebarId,
        id
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (route.isRedirect ?? false) return;
        onSuccess();
    }, [
        onSuccess,
        route
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        // Why are we injecting the route name into the global window state?
        // We currently don't have any way to get the route name when the sidenav is rendered OUTSIDE of the SPA
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__POLLINATOR__ = {
            ...window.__POLLINATOR__,
            routeName: routeName
        };
        const event = createAnalyticsEvent({
            action: 'ready',
            actionSubject: 'sidebar',
            meta: {
                teamName: 'endeavour'
            }
        });
        (0, $8zOmE.fireUIAnalytics)(event, 'Sidebar Ready', {
            route: routeName
        });
    }, [
        createAnalyticsEvent,
        routeName
    ]);
    const customData = (0, $5uXOq.useMemo)(()=>({
            route: routeName,
            sidebarId: id
        }), [
        routeName,
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavSidebarPerformanceMark), {
        metricKey: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderEnd
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavSidebarPerformanceReport), {
        customData: customData
    }));
};
const $b5a3a4467dac2130$export$661ed14c8f75da9f = ()=>{
    const onFail = (0, $93jKl.useExperienceFail)({
        experience: (0, $kvHKs.SIDEBAR_EXPERIENCE)
    });
    return (0, $5uXOq.useCallback)((location, error)=>{
        onFail(location, error);
    }, [
        onFail
    ]);
};
const $b5a3a4467dac2130$export$ddb17534fdfb7dc6 = ()=>(0, $3bQtK.useExperienceSuccess)($b5a3a4467dac2130$var$EXPERIENCE_SUCCESS_ATTRIBUTES);

});
parcelRegister("93jKl", function(module, exports) {

$parcel$export(module.exports, "useExperienceFail", () => $e2626e1ab0692489$export$606da7704d8eaf06);

var $5uXOq = parcelRequire("5uXOq");

var $fZneA = parcelRequire("fZneA");

var $bCf8q = parcelRequire("bCf8q");

var $j8DrX = parcelRequire("j8DrX");

var $l9g16 = parcelRequire("l9g16");
const $e2626e1ab0692489$export$606da7704d8eaf06 = ({ experience: experience, attributes: attributes })=>{
    const experienceTracker = (0, $l9g16.useExperienceContext)();
    const self = (0, $5uXOq.useRef)({
        name: experience,
        attributes: attributes,
        experienceTracker: experienceTracker
    });
    self.current.name = experience;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    return (0, $5uXOq.useCallback)((location, error, extraAttributes = {})=>{
        const { current: current } = self;
        // ignore client side errors from impacting experience metrics
        if ((0, $bCf8q.isLoaderError)(error) && error.name === 'ChunkLoadError' || (0, $fZneA.isClientFetchError)(error)) return;
        const shardAndRegionAttributes = {
            shard: (0, $j8DrX.default)('ajs-shard'),
            region: (0, $j8DrX.default)('ajs-region')
        };
        current.experienceTracker.fail({
            name: current.name,
            error: error,
            attributes: {
                ...current.attributes,
                ...extraAttributes,
                ...shardAndRegionAttributes,
                location: location
            }
        });
    }, [
        self
    ]);
};

});
parcelRegister("l9g16", function(module, exports) {

$parcel$export(module.exports, "useExperienceContext", () => $79f23c22d88dd8d5$export$be8ec22ac9208049);

var $5uXOq = parcelRequire("5uXOq");

var $bSOOm = parcelRequire("bSOOm");
const $79f23c22d88dd8d5$export$be8ec22ac9208049 = ()=>{
    const context = (0, $5uXOq.useContext)((0, $bSOOm.ExperienceTrackerContext));
    return context;
};

});


parcelRegister("kaHBi", function(module, exports) {

$parcel$export(module.exports, "useExperienceStart", () => $e1187df33c58b997$export$675e0d25df38d426);
$parcel$export(module.exports, "ExperienceStart", () => $e1187df33c58b997$export$f20b867e738a222c);

var $5uXOq = parcelRequire("5uXOq");

var $6jY6G = parcelRequire("6jY6G");

var $l9g16 = parcelRequire("l9g16");
const $e1187df33c58b997$export$675e0d25df38d426 = ({ experienceId: experienceId, experience: experience, timeout: timeout, analyticsSource: analyticsSource, application: application, edition: edition, disableSli: disableSli = false, collect: collect = ()=>undefined })=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const experienceTracker = (0, $l9g16.useExperienceContext)();
    const userLocation = `${route.group ?? 'unknown'}:${route.name}`;
    const self = (0, $5uXOq.useRef)({
        experienceId: experienceId,
        experience: experience,
        timeout: timeout,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        experienceTracker: experienceTracker,
        disableSli: disableSli,
        userLocation: userLocation,
        collect: collect
    });
    self.current.experienceId = experienceId;
    self.current.experience = experience;
    self.current.timeout = timeout;
    self.current.analyticsSource = analyticsSource;
    self.current.application = application;
    self.current.edition = edition;
    self.current.experienceTracker = experienceTracker;
    self.current.userLocation = userLocation;
    self.current.collect = collect;
    return (0, $5uXOq.useCallback)(()=>{
        const { current: current } = self;
        current.experienceTracker.start({
            // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string'.
            id: current.experienceId,
            name: current.experience,
            timeout: current.timeout,
            attributes: {
                analyticsSource: current.analyticsSource,
                experience: current.experience,
                experienceId: current.experienceId,
                application: current.application,
                edition: current.edition,
                disableSli: current.disableSli,
                userLocation: current.userLocation
            },
            collect: current.collect,
            onSuccess: ()=>undefined
        });
    }, [
        self
    ]);
};
const $e1187df33c58b997$export$f20b867e738a222c = ({ experienceId: experienceId, experience: experience, timeout: timeout, analyticsSource: analyticsSource, application: application, edition: edition, disableSli: disableSli = false, collect: collect })=>{
    const onStart = $e1187df33c58b997$export$675e0d25df38d426({
        experienceId: experienceId,
        experience: experience,
        timeout: timeout,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        disableSli: disableSli,
        collect: collect
    });
    (0, $5uXOq.useMemo)(()=>{
        onStart();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onStart,
        experienceId,
        experience,
        timeout,
        analyticsSource,
        application,
        edition,
        disableSli,
        collect
    ]);
    return null;
};

});
parcelRegister("6jY6G", function(module, exports) {

$parcel$export(module.exports, "useCurrentRoute", () => $dda4cada2257eb1d$export$c4b7ea2942f2d0e);
$parcel$export(module.exports, "useRouteByName", () => $dda4cada2257eb1d$export$d69a946e2d0a1c12);
$parcel$export(module.exports, "usePreviousRouterState", () => $dda4cada2257eb1d$export$1e5fb68306bd0b92);

var $lODMY = parcelRequire("lODMY");
var $doZTA = parcelRequire("doZTA");

var $cfDZ3 = parcelRequire("cfDZ3");

const $dda4cada2257eb1d$export$c4b7ea2942f2d0e = (0, $lODMY.createRouterSelector)((state)=>state.route);
const $dda4cada2257eb1d$export$d69a946e2d0a1c12 = (0, $lODMY.createRouterSelector)((state, routeName)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    state.routes.find(({ name: name })=>name === routeName) ?? null);
const $dda4cada2257eb1d$export$94b319d3d90420ae = ({ name: name, path: path, query: query, exact: exact })=>({
        name: name,
        path: path,
        query: query,
        exact: exact
    });
const $dda4cada2257eb1d$export$1e5fb68306bd0b92 = ()=>{
    // Force updates whenever the current route changes
    (0, $doZTA.useRouter)();
    return (0, $cfDZ3.getPreviousRouterState)();
};

});


parcelRegister("3bQtK", function(module, exports) {

$parcel$export(module.exports, "useExperienceSuccess", () => $f46ca4b214d7cdb6$export$e94f0da4fc0603c6);
$parcel$export(module.exports, "ExperienceSuccess", () => $f46ca4b214d7cdb6$export$4962f3898bd5c829);

var $5uXOq = parcelRequire("5uXOq");

var $6jY6G = parcelRequire("6jY6G");

var $j8DrX = parcelRequire("j8DrX");

var $l9g16 = parcelRequire("l9g16");
const $f46ca4b214d7cdb6$var$STABLE_EMPTY_OBJECT = {};
const $f46ca4b214d7cdb6$export$e94f0da4fc0603c6 = ({ experience: experience, attributes: attributes = $f46ca4b214d7cdb6$var$STABLE_EMPTY_OBJECT })=>{
    const experienceTracker = (0, $l9g16.useExperienceContext)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const self = (0, $5uXOq.useRef)({
        experience: experience,
        attributes: attributes,
        experienceTracker: experienceTracker,
        route: route
    });
    self.current.route = route;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    self.current.experience = experience;
    return (0, $5uXOq.useCallback)((extraAttributes = {})=>{
        const { current: current } = self;
        if (current.route && current.route.isRedirect === true) return;
        const shardAndRegionAttributes = {
            shard: (0, $j8DrX.default)('ajs-shard'),
            region: (0, $j8DrX.default)('ajs-region')
        };
        current.experienceTracker.succeed({
            name: current.experience,
            attributes: {
                ...current.attributes,
                ...extraAttributes,
                ...shardAndRegionAttributes
            }
        });
    }, [
        self
    ]);
};
const $f46ca4b214d7cdb6$export$4962f3898bd5c829 = ({ experience: experience, attributes: attributes = $f46ca4b214d7cdb6$var$STABLE_EMPTY_OBJECT })=>{
    const onExperienceSuccess = $f46ca4b214d7cdb6$export$e94f0da4fc0603c6({
        experience: experience,
        attributes: attributes
    });
    (0, $5uXOq.useEffect)(()=>{
        onExperienceSuccess();
    }, [
        attributes,
        onExperienceSuccess
    ]);
    (0, $5uXOq.useMemo)(()=>{
        if (false) onExperienceSuccess();
    }, [
        onExperienceSuccess
    ]);
    return null;
};

});

parcelRegister("4QcD9", function(module, exports) {

$parcel$export(module.exports, "createValueController", () => $3f293f209341d999$export$ff0ab9dd4ceb4a93);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $3f293f209341d999$export$ff0ab9dd4ceb4a93 = (name, defaultValue)=>{
    const actions = {
        setValue: (value)=>({ setState: setState })=>setState({
                    value: value
                })
    };
    const initialState = {
        value: defaultValue
    };
    const store = (0, $iXqE5.createStore)({
        name: name,
        initialState: initialState,
        actions: actions
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const ValueContainer = (0, $gg7kZ.createContainer)(store);
    const selector = (state)=>state.value;
    const useValueInternal = (0, $3sQ5x.createHook)(store, {
        selector: selector
    });
    const useValue = ()=>{
        const [value, { setValue: setValue }] = useValueInternal();
        return [
            value,
            setValue
        ];
    };
    return {
        ValueContainer: ValueContainer,
        useValue: useValue
    };
};

});

parcelRegister("6IzHB", function(module, exports) {

$parcel$export(module.exports, "usePageId", () => $57184c749af08735$export$3434ba5eadb360dc);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");

var $7w9eZ = parcelRequire("7w9eZ");
const $57184c749af08735$var$useSweetStatePageId = (0, $3sQ5x.createHook)((0, $7w9eZ.default), {
    selector: (state)=>state.currentPage.uuid
});
const $57184c749af08735$export$3434ba5eadb360dc = ()=>{
    const [pageId] = $57184c749af08735$var$useSweetStatePageId();
    return pageId;
};

});
parcelRegister("7w9eZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $85db42238a8acf29$export$2e2bcd8739ae039);

var $7Jxgt = parcelRequire("7Jxgt");

var $iXqE5 = parcelRequire("iXqE5");

var $6Bj8c = parcelRequire("6Bj8c");
const $85db42238a8acf29$export$d4c72bab9d6cc13a = {
    transitionCheckTimestamp: -1,
    currentPage: {
        uuid: false ? '' : (0, $7Jxgt.v4)(),
        startTime: typeof performance !== 'undefined' && performance.timing !== undefined && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        performance.timing.navigationStart || 0,
        apps: {},
        userLocation: ''
    },
    visitedPages: [],
    navigation: {
        isCollapsed: false,
        viewId: 'noView',
        viewType: '',
        projectType: null,
        isInitialEventSent: false,
        pageId: null,
        nextViewId: ''
    }
};
const $85db42238a8acf29$var$store = (0, $iXqE5.createStore)({
    name: 'spa-state',
    initialState: $85db42238a8acf29$export$d4c72bab9d6cc13a,
    actions: $6Bj8c
});
var $85db42238a8acf29$export$2e2bcd8739ae039 = $85db42238a8acf29$var$store;

});
parcelRegister("6Bj8c", function(module, exports) {

$parcel$export(module.exports, "setAppStart", () => (parcelRequire("fI6Pg")).setAppStart);
$parcel$export(module.exports, "setAppReady", () => (parcelRequire("fI6Pg")).setAppReady);
$parcel$export(module.exports, "setAppStartWithAppId", () => (parcelRequire("fI6Pg")).setAppStartWithAppId);
$parcel$export(module.exports, "setAppReadyWithAppId", () => (parcelRequire("fI6Pg")).setAppReadyWithAppId);
$parcel$export(module.exports, "setAppErrorReady", () => (parcelRequire("fI6Pg")).setAppErrorReady);
$parcel$export(module.exports, "setTimeoutReady", () => (parcelRequire("fI6Pg")).setTimeoutReady);
$parcel$export(module.exports, "setTimeoutReadyWithAppId", () => (parcelRequire("fI6Pg")).setTimeoutReadyWithAppId);
$parcel$export(module.exports, "resetCurrentPage", () => (parcelRequire("fI6Pg")).resetCurrentPage);
$parcel$export(module.exports, "setResourceMetrics", () => (parcelRequire("fI6Pg")).setResourceMetrics);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $fI6Pg = parcelRequire("fI6Pg");

});
parcelRegister("fI6Pg", function(module, exports) {

$parcel$export(module.exports, "resetCurrentPage", () => $4a986cd3487bf863$export$5639685a1fb81722);
$parcel$export(module.exports, "setTimeoutReadyWithAppId", () => $4a986cd3487bf863$export$8a98548dad2fa97b);
$parcel$export(module.exports, "setTimeoutReady", () => $4a986cd3487bf863$export$b9cc4378ea785421);
$parcel$export(module.exports, "setAppStartWithAppId", () => $4a986cd3487bf863$export$9d528722f2ff2999);
$parcel$export(module.exports, "setAppStart", () => $4a986cd3487bf863$export$71192061050856ad);
$parcel$export(module.exports, "setAppReadyWithAppId", () => $4a986cd3487bf863$export$6a25429a42d30f9a);
$parcel$export(module.exports, "setAppReady", () => $4a986cd3487bf863$export$fc59cc4ed9bba7cd);
$parcel$export(module.exports, "setAppErrorReady", () => $4a986cd3487bf863$export$aff63c1e41443b6a);
$parcel$export(module.exports, "setResourceMetrics", () => $4a986cd3487bf863$export$8ad155d489dcf34d);

var $7Jxgt = parcelRequire("7Jxgt");

var $1ciso = parcelRequire("1ciso");

var $21pfT = parcelRequire("21pfT");

var $cfDZ3 = parcelRequire("cfDZ3");

var $1AZST = parcelRequire("1AZST");
const $4a986cd3487bf863$export$7bd623b29ec8e1eb = 10000;
const $4a986cd3487bf863$export$5639685a1fb81722 = (nextRouteUfoName, nextRouteName)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        performance.mark('resetCurrentPage');
        (0, $21pfT.browserMetrics).startPageLoad({
            isInitial: false
        });
        (0, $1ciso.default)(nextRouteUfoName, nextRouteName);
        (0, $1AZST.GlobalPageLoadExperience).abort({
            force: true
        });
        (0, $1AZST.GlobalPageLoadExperience).startPageLoad('UNKNOWN', false);
        if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) setState({
            currentPage: {
                uuid: (0, $7Jxgt.v4)(),
                apps: {},
                startTime: Date.now(),
                userLocation: ''
            },
            visitedPages: [
                ...currentState.visitedPages,
                {
                    ...currentState.currentPage
                }
            ],
            transitionCheckTimestamp: 0
        });
    };
const $4a986cd3487bf863$export$8a98548dad2fa97b = (appId, timeoutTime = Date.now())=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].timeoutTime)) {
            const apps = {
                ...currentPage.apps
            };
            if (apps[appId] && apps[appId].expectingTimeout) {
                const updatedPage = {
                    ...currentPage,
                    apps: {
                        ...apps,
                        [appId]: {
                            ...apps[appId],
                            timeoutTime: timeoutTime,
                            expectingTimeout: 0
                        }
                    }
                };
                setState({
                    currentPage: updatedPage
                });
            }
        }
    };
const $4a986cd3487bf863$export$b9cc4378ea785421 = (timeoutTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($4a986cd3487bf863$export$8a98548dad2fa97b(appId, timeoutTime));
    };
const $4a986cd3487bf863$export$9d528722f2ff2999 = (appId, startTime = Date.now())=>({ dispatch: dispatch, getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].startTime)) {
            const timeoutId = setTimeout(()=>{
                dispatch($4a986cd3487bf863$export$8a98548dad2fa97b(appId));
            }, $4a986cd3487bf863$export$7bd623b29ec8e1eb);
            const updatedPage = {
                ...currentPage,
                userLocation: (0, $cfDZ3.getUserLocation)(),
                apps: {
                    ...currentPage.apps,
                    [appId]: {
                        startTime: startTime,
                        expectingTimeout: timeoutId
                    }
                }
            };
            setState({
                // @ts-expect-error - TS2322 - Type '{ userLocation: string; apps: { [x: string]: AppState | { startTime: number; expectingTimeout: NodeJS.Timeout; }; }; uuid: string; startTime: number; resources?: ResourceMetrics[] | undefined; }' is not assignable to type 'PageTiming'.
                currentPage: updatedPage
            });
        }
    };
const $4a986cd3487bf863$export$71192061050856ad = (startTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($4a986cd3487bf863$export$9d528722f2ff2999(appId, startTime));
    };
const $4a986cd3487bf863$export$6a25429a42d30f9a = (appId, endTime = Date.now())=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && currentPage.apps[appId] && currentPage.apps[appId].endTime === undefined) {
            const apps = {
                ...currentPage.apps
            };
            // @ts-expect-error - TS2769 - No overload matches this call.
            clearTimeout(currentPage.apps[appId].expectingTimeout);
            const updatedPage = {
                ...currentPage,
                apps: {
                    ...apps,
                    [appId]: {
                        ...apps[appId],
                        endTime: endTime,
                        expectingTimeout: 0
                    }
                }
            };
            setState({
                currentPage: updatedPage
            });
        }
    };
const $4a986cd3487bf863$export$fc59cc4ed9bba7cd = (endTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($4a986cd3487bf863$export$6a25429a42d30f9a(appId, endTime));
    };
const $4a986cd3487bf863$export$aff63c1e41443b6a = ()=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) {
            const updatedPage = {
                ...currentPage,
                apps: {
                    'error-page': {
                        endTime: Date.now()
                    }
                }
            };
            setState({
                currentPage: updatedPage
            });
        }
    };
const $4a986cd3487bf863$export$8ad155d489dcf34d = (resourceMetrics)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            currentPage: {
                ...currentState.currentPage,
                resources: [
                    ...currentState.currentPage.resources ? currentState.currentPage.resources : [],
                    resourceMetrics
                ]
            }
        });
    };

});




parcelRegister("kvHKs", function(module, exports) {

$parcel$export(module.exports, "REPO_TYPE", () => $f1419662a60c783a$export$399c7e6858236b4);
$parcel$export(module.exports, "LINK_TYPE", () => $f1419662a60c783a$export$58125ce2bb1c3378);
$parcel$export(module.exports, "EMOJI_REGEX", () => $f1419662a60c783a$export$c79ed2783644934c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES", () => $f1419662a60c783a$export$25ae65041c800c9);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES", () => $f1419662a60c783a$export$e03c9beea817d44b);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES", () => $f1419662a60c783a$export$3d575bdf28c0d17c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES", () => $f1419662a60c783a$export$af84baced6970a17);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES", () => $f1419662a60c783a$export$c767f253046b1ea7);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES", () => $f1419662a60c783a$export$265b9384cc2dfbd4);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES", () => $f1419662a60c783a$export$2de77b357e71c7a7);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES", () => $f1419662a60c783a$export$7de7abb92169d6c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES", () => $f1419662a60c783a$export$fd7df8bd7600c65c);
$parcel$export(module.exports, "GLOBAL_NAV_CREATE_BUTTON_SPOTLIGHT_ID", () => $f1419662a60c783a$export$dde074e512e80dff);
$parcel$export(module.exports, "REPORTS_IDS", () => $f1419662a60c783a$export$1f70a76cb421b107);
$parcel$export(module.exports, "SIDEBAR_EXPERIENCE", () => $f1419662a60c783a$export$71aaf2625ee54d10);
$parcel$export(module.exports, "staticLegacyIds", () => $f1419662a60c783a$export$f57650e6e7be03dc);
const $f1419662a60c783a$export$399c7e6858236b4 = 'source.code.link';
const $f1419662a60c783a$export$58125ce2bb1c3378 = 'project.shortcut.default.link';
const $f1419662a60c783a$export$c79ed2783644934c = /^(?:[\u2600-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?)*/;
const $f1419662a60c783a$export$25ae65041c800c9 = 'pin-filter-myopenissues';
const $f1419662a60c783a$export$e03c9beea817d44b = 'pin-filter-reportedbyme';
const $f1419662a60c783a$export$3d575bdf28c0d17c = 'pin-filter-allissues';
const $f1419662a60c783a$export$af84baced6970a17 = 'pin-filter-allopenissues';
const $f1419662a60c783a$export$c767f253046b1ea7 = 'pin-filter-doneissues';
const $f1419662a60c783a$export$265b9384cc2dfbd4 = 'pin-filter-recentlyviewed';
const $f1419662a60c783a$export$2de77b357e71c7a7 = 'pin-filter-addedrecently';
const $f1419662a60c783a$export$7de7abb92169d6c = 'pin-filter-resolvedrecently';
const $f1419662a60c783a$export$fd7df8bd7600c65c = 'pin-filter-updatedrecently';
const $f1419662a60c783a$export$dde074e512e80dff = 'global-create-spotlight';
const $f1419662a60c783a$export$1f70a76cb421b107 = {
    REPORTS_ADDONS: 'sd-reports-addons'
};
const $f1419662a60c783a$export$71aaf2625ee54d10 = 'viewSidebarNavigation';
const $f1419662a60c783a$export$f57650e6e7be03dc = [
    // Global Settings Static Legacy Ids
    'general_configuration',
    'dark_features',
    'troubleshooting_and_support',
    'view_auditing',
    'pluginViewer',
    'pluginViewer',
    'system_info',
    'integrity_checker',
    'logging_profiling',
    'scheduler_details',
    'security_section',
    'project_role_browser',
    'global_permissions',
    'collectors',
    'user_interface',
    'user_defaults',
    'edit_default_dashboard',
    'lookandfeel',
    'com.atlassian.pas:pas-admin-link-jira',
    'import_export_section',
    'vertigo_export',
    'external_import',
    'vertigo_import',
    'vertigo_import_jira_cloud',
    'vertigo_import_jira_server',
    'mail_section',
    'global_mail_settings',
    'outgoing_mail',
    'incoming_mail',
    'send_email',
    'admin-helper-admin-section',
    'permissionhelper-admin-page',
    'notificationhelper-admin-page',
    'shared_section',
    'shared_filters',
    'shared_dashboards',
    'advanced_section',
    'attachments',
    'eventtypes',
    'webhooks-admin',
    'services',
    'manage_dashboards',
    'manage_filters',
    'greenhopper-lexorank-manage',
    // Project Settings Static Legacy Ids
    'jira.webfragments.view.project.operations:edit_project',
    'com.atlassian.jira.jira-project-config-plugin:users-and-roles',
    'com.atlassian.jira.jira-project-config-plugin:view_project_summary',
    'com.atlassian.jira.jira-project-config-plugin:view_delete_project',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuetypes',
    'com.atlassian.jira.jira-project-config-plugin:view_project_workflows',
    'com.atlassian.jira.jira-project-config-plugin:view_project_screens',
    'com.atlassian.jira.jira-project-config-plugin:view_project_fields',
    'com.atlassian.jira.jira-projects-plugin:administer_project_versions',
    'com.atlassian.jira.jira-projects-plugin:administer_project_components',
    'com.atlassian.jira.jira-project-config-plugin:view_project_permissions',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuesecurity',
    'com.atlassian.jira.jira-project-config-plugin:view_project_notifications',
    'com.atlassian.jira.jira-project-config-plugin:project-opsgenie-association',
    'com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:view_issue_collectors',
    'com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-admin-page-link',
    'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation__cb-automation-project-config',
    'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation.moderate__cb-automation-project-config',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuelayout',
    'com.atlassian.jira.jira-projects-plugin:administer_project_code',
    'com.atlassian.jira.jira-projects-plugin:administer_project_deployments',
    'com.atlassian.servicedesk.project-ui:sd-project-change-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-request-types-item',
    'com.atlassian.servicedesk.project-ui:sd-project-customer-permissions-item',
    'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-project-language-support-settings-item-adg3',
    'com.atlassian.servicedesk.project-ui:sd-project-portal-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-email-settings-item',
    'com.atlassian.servicedesk.servicedesk-notifications-plugin:sd-project-outgoing-email-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-widget-addon-installer-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded__settings',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded-dev__settings',
    'com.atlassian.servicedesk.project-ui:sd-project-assets-ad-item',
    'com.atlassian.servicedesk.project-ui:sd-project-feedback-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-confluence-kb-item',
    'com.atlassian.servicedesk.project-ui:sd-project-sla-item',
    'com.atlassian.servicedesk.project-ui:sd-project-automation-item',
    'com.atlassian.servicedesk.project-ui:sd-project-app-discovery-item',
    'com.atlassian.servicedesk.project-ui:sd-project-incident-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-itsm-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-external-links-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.atlas.jira__goals-project-page',
    // Automation connect item
    'com.codebarrel.addons.automation__cb-automation',
    'com.codebarrel.addons.automation.moderate__cb-automation'
];

});


parcelRegister("lGo7j", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $0c703bf4651638aa$export$8f31e4c4a37b8e9c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fNobW = parcelRequire("fNobW");

var $gjTBi = parcelRequire("gjTBi");
var $bWqXX = parcelRequire("bWqXX");
const $0c703bf4651638aa$export$8f31e4c4a37b8e9c = ({ isFull: isFull = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "sidebar-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0c703bf4651638aa$var$BackgroundedWrapper, null, isFull && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0c703bf4651638aa$var$HeadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), {
        hasIcon: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), {
        hasIcon: isFull
    }))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c703bf4651638aa$var$BackgroundedWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1tem _ca0qidpf _u5f31ejb _n3tdidpf _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $0c703bf4651638aa$var$HeadingWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt41k9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gjTBi", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab78cae21894a64c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $9UCCQ = parcelRequire("9UCCQ");

var $j9VTE = parcelRequire("j9VTE");
// Type needed on props to extract types with extract react types.
/**
 * __Section__
 *
 * Used to separate items into sections. Using the title prop makes a section
 * implicitly group the items for screen readers with no additional work required.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#section)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $ab78cae21894a64c$var$Section = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { shouldRender: shouldRender } = (0, $j9VTE.useShouldNestedElementRender)();
    if (!shouldRender) return props.children;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9UCCQ.default), {
        ...props,
        ref: ref,
        isSideNavSection: true
    });
});
var $ab78cae21894a64c$export$2e2bcd8739ae039 = $ab78cae21894a64c$var$Section;

});

parcelRegister("bWqXX", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c4e822429ecf69c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $iwwXK = parcelRequire("iwwXK");

var $j9VTE = parcelRequire("j9VTE");
/**
 * __Skeleton item__
 *
 * A skeleton item can be used to reduce the perceived loading time.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#loading)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $9c4e822429ecf69c$var$SkeletonItem = (props)=>{
    const { shouldRender: shouldRender } = (0, $j9VTE.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwwXK.default), {
        isSideNavSkeleton: true,
        ...props
    });
};
var $9c4e822429ecf69c$export$2e2bcd8739ae039 = $9c4e822429ecf69c$var$SkeletonItem;

});



parcelRegister("gbGmI", function(module, exports) {

$parcel$export(module.exports, "setPerformanceMarkLoadStart", () => $46c186c6902de7dc$export$4166241bf9111f66);
$parcel$export(module.exports, "setPerformanceMarkLoadEnd", () => $46c186c6902de7dc$export$edbd543f308bbef5);

var $5e7oM = parcelRequire("5e7oM");

var $azzrO = parcelRequire("azzrO");
const $46c186c6902de7dc$export$4166241bf9111f66 = ()=>{
    const sideBarSegment = (0, $azzrO.pageSegmentStore).getSegment((0, $5e7oM.NAVIGATION_SIDEBAR_SEGMENT_NAME));
    sideBarSegment.mark((0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).loadStart);
};
const $46c186c6902de7dc$export$edbd543f308bbef5 = ()=>{
    const sideBarSegment = (0, $azzrO.pageSegmentStore).getSegment((0, $5e7oM.NAVIGATION_SIDEBAR_SEGMENT_NAME));
    sideBarSegment.mark((0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).loadEnd);
};

});

parcelRegister("6lAw8", function(module, exports) {

$parcel$export(module.exports, "LazyForPaintServicedeskSidebar", () => $92268c024c398c0d$export$15e3805736f2222d);

var $kxZPA = parcelRequire("kxZPA");

var $gbGmI = parcelRequire("gbGmI");

const $92268c024c398c0d$export$15e3805736f2222d = (0, $kxZPA.lazyForPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("h8ZLT")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/servicedesk/src/index.tsx"
});

});
parcelRegister("h8ZLT", function(module, exports) {

let $c7b319896f60e174$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c7b319896f60e174$var$load("3yAl4"),
    $c7b319896f60e174$var$load("7mIf9"),
    $c7b319896f60e174$var$load("jXweD"),
    $c7b319896f60e174$var$load("ffQaD"),
    $c7b319896f60e174$var$load("kvRbA"),
    $c7b319896f60e174$var$load("kVX56"),
    $c7b319896f60e174$var$load("kNFvF"),
    $c7b319896f60e174$var$load("76n7a"),
    $c7b319896f60e174$var$load("l253H"),
    $c7b319896f60e174$var$load("7mxxY")
]).then(()=>parcelRequire('eufGV'));

});



parcelRegister("7NszV", function(module, exports) {

$parcel$export(module.exports, "createEntry", () => $82f1a9156abf3836$export$344b9c9ab5e66c9a);

var $hwKYN = parcelRequire("hwKYN");
const $82f1a9156abf3836$export$344b9c9ab5e66c9a = (0, $hwKYN.createRouteEntry);

});
parcelRegister("hwKYN", function(module, exports) {

$parcel$export(module.exports, "createRouteEntry", () => $d530719601daee4d$export$136cc45b1cabb43);
/**
 * Create route entry with entrypoint, resources, etc. override
 *
 * @param baseRoute Base route object that contains matching info
 * @param opts Route definition to fill and override
 */ function $d530719601daee4d$export$136cc45b1cabb43(baseRoute, opts) {
    // @ts-expect-error Re-using baseRoute to become the full route Object allows us to optimize
    // route transitions as RRR can directly use the route instead of comparing a separate InvariantRoute
    // against the full route list
    // eslint-disable-next-line no-param-reassign
    baseRoute.lazyOpts = opts;
    // @ts-expect-error TODO
    return baseRoute;
}

});


parcelRegister("bHhiy", function(module, exports) {

$parcel$export(module.exports, "getConsolidationStateResource", () => $cd33a435a46904ef$export$a6cf5054d4f9f5dd);
// eoc-fetch is already being used in eoc resources, so there is no reason not
// to override the whitelist here.
// eslint-disable-next-line jira/import-whitelist

var $j74qU = parcelRequire("j74qU");

var $4R6GH = parcelRequire("4R6GH");

var $2M1hQ = parcelRequire("2M1hQ");

var $e5wyW = parcelRequire("e5wyW");

var $bgC2H = parcelRequire("bgC2H");

const $cd33a435a46904ef$export$de6c19ae237c1eb9 = (cloudId, atlassianAccountId, isAnonymous, appPermissions)=>{
    let url = (0, $4R6GH.fg)('operations-tenant-info-endpoint-update') ? '/internal/v1/users/ops-user-info' : '/internal/v1/customers/tenant-info';
    if (cloudId) url = `${url}/${cloudId}`;
    else throw new Error('No tenant info exists.');
    let promise;
    if (appPermissions && appPermissions.hasServiceDeskAccess === false || isAnonymous) {
        promise = new Promise((resolve)=>{
            resolve({
                consolidationState: (0, $bgC2H.ConsolidationState).NOT_CONSOLIDATED,
                ...(0, $4R6GH.fg)('operations-tenant-info-endpoint-update') ? {
                    isAdmin: false
                } : {}
            });
        });
        return promise;
    }
    if ((0, $4R6GH.fg)('operations-tenant-info-endpoint-update')) url = `${url}/${atlassianAccountId}`;
    if (false) promise = (0, $j74qU.eocFetch)(url, {
        exactUrl: true,
        headers: {
            'x-ssr-service-name': (0, $4R6GH.fg)('operations-tenant-info-endpoint-update') ? 'og-apps-user-int-api' : 'og-customer-int-api'
        }
    });
    else {
        const clientUrl = (0, $4R6GH.fg)('operations-tenant-info-endpoint-update') ? '/v1/users/ops-user-info' : '/v1/customers/tenant-info';
        promise = (0, $j74qU.eocFetch)(clientUrl).then(({ data: data })=>data);
    }
    return promise;
};
const $cd33a435a46904ef$var$getConsolidationStateResourceFactory = (forceBrowser = false)=>(0, $2M1hQ.createResource)({
        type: (0, $5a94e356f9d5e220$export$25ee35b01de9d734),
        getKey: ()=>'tenantInformation',
        getData: (_, { tenantContext: { cloudId: cloudId, appPermissions: appPermissions, atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>$cd33a435a46904ef$export$de6c19ae237c1eb9(cloudId, atlassianAccountId, isAnonymous, appPermissions),
        maxAge: Infinity,
        isBrowserOnly: forceBrowser
    });
const $cd33a435a46904ef$var$consolidationResourceForceBrowser = $cd33a435a46904ef$var$getConsolidationStateResourceFactory(true);
const $cd33a435a46904ef$var$consolidationResourceDontForceBrowser = $cd33a435a46904ef$var$getConsolidationStateResourceFactory(false);
const $cd33a435a46904ef$var$getConsolidationStateResourceNew = (forceBrowser = false)=>{
    /**
	 * This needs to return the same resource instance each time (based on args) or else we end up with many unnecessary re-renders
	 */ return forceBrowser ? $cd33a435a46904ef$var$consolidationResourceForceBrowser : $cd33a435a46904ef$var$consolidationResourceDontForceBrowser;
};
const $cd33a435a46904ef$export$a6cf5054d4f9f5dd = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1'), $cd33a435a46904ef$var$getConsolidationStateResourceNew, $cd33a435a46904ef$var$getConsolidationStateResourceFactory);

});
parcelRegister("bgC2H", function(module, exports) {

$parcel$export(module.exports, "ConsolidationState", () => $927cd31b0e0ee4e8$export$9ef498b0a11fd37d);
const $927cd31b0e0ee4e8$export$9ef498b0a11fd37d = {
    NOT_CONSOLIDATED: 'NOT_CONSOLIDATED',
    TRANSITIONING: 'TRANSITIONING',
    TRANSITIONED: 'TRANSITIONED',
    CONSOLIDATED: 'CONSOLIDATED'
};

});

const $5a94e356f9d5e220$export$25ee35b01de9d734 = 'EOC_TENANT';


parcelRegister("fpjJX", function(module, exports) {

$parcel$export(module.exports, "getServiceDeskNavigationResources", () => $491f4fde535ee8ab$export$bc0bd65e6da57c1f);
$parcel$export(module.exports, "getServiceDeskNavigationSingleResources", () => $491f4fde535ee8ab$export$41a9145ddbba28e5);
$parcel$export(module.exports, "getServiceDeskSharedNavigationSingleResources", () => $491f4fde535ee8ab$export$2c543d6accc1eb9b);
$parcel$export(module.exports, "getServiceDeskSettingsResources", () => $491f4fde535ee8ab$export$7bb3c4a2f6b127fb);
$parcel$export(module.exports, "getServicedeskPageContextResources", () => $491f4fde535ee8ab$export$a8b852f03a310dc0);
$parcel$export(module.exports, "getQueuesResources", () => $491f4fde535ee8ab$export$70b97995f4d5ef9f);
$parcel$export(module.exports, "getIssueListSsrResource", () => $491f4fde535ee8ab$export$e1016cce62543991);
$parcel$export(module.exports, "getKnowledgeBaseResources", () => $491f4fde535ee8ab$export$ed87d3b71544c4ef);
$parcel$export(module.exports, "getInsightResources", () => $491f4fde535ee8ab$export$9e0cf1fab0581096);
$parcel$export(module.exports, "getQueueConfigResource", () => $491f4fde535ee8ab$export$5f7bcaa978a3e51);
$parcel$export(module.exports, "getQueueViewConfigResource", () => $491f4fde535ee8ab$export$54079077c6768752);

var $c04PQ = parcelRequire("c04PQ");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $5bkvv = parcelRequire("5bkvv");

var $b2pl3 = parcelRequire("b2pl3");

var $gS5PF = parcelRequire("gS5PF");

var $jYeNO = parcelRequire("jYeNO");

var $6zFAI = parcelRequire("6zFAI");

var $gcI3W = parcelRequire("gcI3W");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $3HwlS = parcelRequire("3HwlS");

var $bjZiV = parcelRequire("bjZiV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $8H3A4 = parcelRequire("8H3A4");

var $cAofY = parcelRequire("cAofY");

var $aNLeB = parcelRequire("aNLeB");

var $eUvlM = parcelRequire("eUvlM");

var $lbaDt = parcelRequire("lbaDt");

var $1WlLE = parcelRequire("1WlLE");

var $2Zfed = parcelRequire("2Zfed");

var $2cxgG = parcelRequire("2cxgG");

var $6sNnq = parcelRequire("6sNnq");

var $7GnDe = parcelRequire("7GnDe");

var $gNStA = parcelRequire("gNStA");

var $gRzZD = parcelRequire("gRzZD");

var $6s1PB = parcelRequire("6s1PB");

var $lfnsv = parcelRequire("lfnsv");

var $f5kpo = parcelRequire("f5kpo");

var $f7Y15 = parcelRequire("f7Y15");

var $lJ1FP = parcelRequire("lJ1FP");
const $491f4fde535ee8ab$var$getPriorityGroupsResource = ()=>(0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_flash_priority_group_api_optimisation'), (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('queues-prioritygroups-relay'), (0, $1WlLE.priorityGroupByProjectIdResourceSsr), (0, $1WlLE.priorityGroupByProjectIdResource)), (0, $1WlLE.priorityGroupResource));
const $491f4fde535ee8ab$var$getProjectContextResource = ()=>(0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_flash_priority_group_api_optimisation'), (0, $dxCvy.projectContextResource));
const $491f4fde535ee8ab$var$getQueueSidebarViewAllQueuesResource = ()=>(0, $gNStA.resourceWithCondition2)(()=>!(0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('migrate_queue_sidebar_all_queues_expansion_to_be'), (0, $1WlLE.queueSidebarViewAllQueuesResource));
const $491f4fde535ee8ab$export$bc0bd65e6da57c1f = ()=>[
        ...(0, $3RJkv.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $7GnDe.incidentExperimentTraitResource),
        (0, $dxCvy.projectContextResource),
        (0, $5bkvv.forgeProjectModuleResource),
        (0, $iEUaw.staticSidebarShortcutsResource),
        (0, $ggg5j.staticProjectSidebarNavigationResource),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...$491f4fde535ee8ab$export$41a9145ddbba28e5()
    ];
const $491f4fde535ee8ab$export$41a9145ddbba28e5 = ()=>[
        // projectContextResource is a dependency to the priorityGroupsResource
        $491f4fde535ee8ab$var$getProjectContextResource(),
        $491f4fde535ee8ab$var$getQueueSidebarViewAllQueuesResource(),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('jsm_queue_nav4_sidebar_queue_selection_new_logic'), (0, $1WlLE.queueNav4SidebarSelectionResource)),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('jsm_queue_nav4_sidebar_queue_selection_new_logic'), (0, $1WlLE.queueSidebarQueuesCategoryStateResource)),
        ...$491f4fde535ee8ab$export$9c1c5e389bd00e56(),
        ...$491f4fde535ee8ab$export$2c543d6accc1eb9b()
    ];
const $491f4fde535ee8ab$var$isNav4ResourcesFixEnabled = ()=>(0, $3HwlS.getWillShowNav4)() && (0, $6s1PB.expVal)('hot-113350-ssr-jsm-project-menu-fix', 'isEnabled', false);
const $491f4fde535ee8ab$export$9c1c5e389bd00e56 = ()=>[
        $491f4fde535ee8ab$var$getPriorityGroupsResource(),
        (0, $6sNnq.featuresResource),
        (0, $gS5PF.staticSidebarJsmReportsResource),
        (0, $gNStA.resourceWithCondition2)($491f4fde535ee8ab$var$isNav4ResourcesFixEnabled, (0, $bHhiy.getConsolidationStateResource)()),
        (0, $gNStA.resourceWithCondition2)($491f4fde535ee8ab$var$isNav4ResourcesFixEnabled, (0, $aNLeB.servicedeskIsItsmProjectResource)),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('fe-move-nav3-selected-queue-fu'), (0, $2Zfed.nav3QueueGroupsStateResource))
    ];
const $491f4fde535ee8ab$export$2c543d6accc1eb9b = ()=>[
        (0, $1WlLE.queuesNavigationItems),
        (0, $lbaDt.requiredProjectProperties),
        (0, $lbaDt.requiredFrontendProperties),
        (0, $5bkvv.forgeServiceDeskQueueModuleResource),
        (0, $b2pl3.staticJSMProjectConnectAddonsNavigationResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource),
        // for Getting Started menu item
        // resourceWithCondition2(isNav4ResourcesFixEnabled, requiredFrontendProperties),
        (0, $gNStA.resourceWithCondition2)($491f4fde535ee8ab$var$isNav4ResourcesFixEnabled, (0, $dxCvy.projectContextResourceWithCache)),
        (0, $gNStA.resourceWithCondition2)($491f4fde535ee8ab$var$isNav4ResourcesFixEnabled, (0, $lbaDt.firstProjectResource))
    ];
const $491f4fde535ee8ab$export$7bb3c4a2f6b127fb = ()=>[
        ...(0, $3RJkv.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $7GnDe.incidentExperimentTraitResource),
        (0, $dxCvy.projectContextResource),
        (0, $5bkvv.forgeProjectModuleResource),
        (0, $iEUaw.staticSidebarShortcutsResource),
        (0, $ggg5j.staticProjectSidebarNavigationResource),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
        (0, $eUvlM.servicedeskPracticesResource),
        (0, $cAofY.serviceDeskContextResource),
        (0, $8H3A4.serviceDeskAnalyticsContextResource),
        (0, $gNStA.resourceWithCondition2)(()=>!(0, $c04PQ.isFedRamp)(), (0, $2cxgG.virtualAgentOnboardingResource)),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('fix_getting_started_panel_in_settings'), (0, $lbaDt.firstProjectResource))
    ];
const $491f4fde535ee8ab$export$a8b852f03a310dc0 = ()=>[
        (0, $dxCvy.projectContextResourceWithCache),
        (0, $cAofY.serviceDeskContextResource),
        (0, $8H3A4.serviceDeskAnalyticsContextResource)
    ];
const $491f4fde535ee8ab$export$70b97995f4d5ef9f = ()=>[
        ...$491f4fde535ee8ab$export$a8b852f03a310dc0(),
        ...$491f4fde535ee8ab$export$bc0bd65e6da57c1f(),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $co1wz.ff)('automation-templates-team-types-refactor-m1_isj0e'), (0, $eUvlM.servicedeskPracticesResource)),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('corcap-2944-add-jqlbuilder-to-jsm-queues'), (0, $jYeNO.getCalendarFilterFieldsResource)())
    ];
const $491f4fde535ee8ab$export$e1016cce62543991 = ()=>[
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('ssr_view_queues_issuelist'), (0, $1WlLE.issueListSsrResource))
    ];
const $491f4fde535ee8ab$export$ed87d3b71544c4ef = ()=>[
        (0, $bjZiV.kbConfluenceContextResource)
    ];
const $491f4fde535ee8ab$export$9e0cf1fab0581096 = ()=>[
        (0, $gRzZD.workspaceResource)
    ];
const $491f4fde535ee8ab$export$5f7bcaa978a3e51 = ()=>[
        (0, $gNStA.resourceWithCondition2)(()=>!(0, $4R6GH.fg)('jsm-views-inside-queues-fastfollow') && (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), $491f4fde535ee8ab$var$getPriorityGroupsResource()),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $dxCvy.projectContextResource))
    ];
const $491f4fde535ee8ab$export$54079077c6768752 = ()=>[
        (0, $gNStA.resourceWithCondition2)(()=>!(0, $4R6GH.fg)('jsm-views-inside-queues-fastfollow') && (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $f5kpo.getRapidBoardDataResource)()),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $lJ1FP.getEditModelResource)()),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $lfnsv.getBoardDetailsResource)()),
        (0, $gNStA.resourceWithCondition2)(()=>!(0, $4R6GH.fg)('jsm-views-inside-queues-fastfollow') && (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), $491f4fde535ee8ab$var$getPriorityGroupsResource()),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $dxCvy.projectContextResource)),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $f7Y15.uifBoardResource)),
        ...(0, $f5kpo.getRapidboardResources)().map((resource)=>(0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), resource))
    ];

});
parcelRegister("co1wz", function(module, exports) {

$parcel$export(module.exports, "ff", () => $f06ca7674c5de753$export$f59495b1b7502b33);
$parcel$export(module.exports, "getMultivariateFeatureFlag", () => $f06ca7674c5de753$export$757bc67afadef4a0);
$parcel$export(module.exports, "getFeatureFlagValue", () => $f06ca7674c5de753$export$7064bb599f663d7e);

var $gSA3s = parcelRequire("gSA3s");

var $f9Owr = parcelRequire("f9Owr");

var $6b6Tk = parcelRequire("6b6Tk");

var $5vjD3 = parcelRequire("5vjD3");
function $f06ca7674c5de753$export$a6dcfcb59016e126(featureFlagName, defaultValue) {
    const client = (0, $5vjD3.getFeatureFlagClient)();
    const flag = client.getFlagEvaluation(featureFlagName, {
        default: defaultValue
    });
    if (!flag) return defaultValue;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return flag.value;
}
const $f06ca7674c5de753$var$getBooleanFeatureFlagUsingClient = (featureFlagName, defaultValue)=>{
    const client = (0, $5vjD3.getFeatureFlagClient)();
    return client.getBooleanValue(featureFlagName, {
        default: defaultValue,
        shouldTrackExposureEvent: false
    });
};
const $f06ca7674c5de753$var$getMultivariateFeatureFlagUsingClient = (featureFlagName, defaultValue, possibleValues)=>{
    const client = (0, $5vjD3.getFeatureFlagClient)();
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'T'.
    return client.getVariantValue(featureFlagName, {
        default: defaultValue,
        // @ts-expect-error - TS2322 - Type 'T[]' is not assignable to type 'string[]'.
        oneOf: possibleValues,
        shouldTrackExposureEvent: false
    });
};
/**
 * The feature flag client can be configured to fire automatic exposure events when evaluating
 * feature flag values. For the Track All Changes project, we need all flag evaluations to go
 * through this client so that we can collect these events for all feature flags.
 * See https://hello.atlassian.net/browse/FD-18145 for more information.
 */ const $f06ca7674c5de753$var$isFeatureFlagClientUsedForAllEvaluations = ()=>(0, $6b6Tk.isAutomaticExposureCollectionEnabled)();
const $f06ca7674c5de753$export$f59495b1b7502b33 = (featureFlagName, defaultValue = false)=>{
    const impl = $f06ca7674c5de753$var$isFeatureFlagClientUsedForAllEvaluations() ? $f06ca7674c5de753$var$getBooleanFeatureFlagUsingClient : (0, $f9Owr.ff);
    const value = impl(featureFlagName, defaultValue);
    (0, $gSA3s.addFeatureFlagAccessed)(featureFlagName, value);
    return value;
};
function $f06ca7674c5de753$export$757bc67afadef4a0(featureFlagName, defaultValue, possibleValues) {
    const impl = $f06ca7674c5de753$var$isFeatureFlagClientUsedForAllEvaluations() ? $f06ca7674c5de753$var$getMultivariateFeatureFlagUsingClient : (0, $f9Owr.getMultivariateFeatureFlag);
    const value = impl(featureFlagName, defaultValue, possibleValues);
    (0, $gSA3s.addFeatureFlagAccessed)(featureFlagName, value);
    return value;
}
function $f06ca7674c5de753$export$7064bb599f663d7e(featureFlagName, defaultValue) {
    const impl = $f06ca7674c5de753$var$isFeatureFlagClientUsedForAllEvaluations() ? $f06ca7674c5de753$export$a6dcfcb59016e126 : (0, $f9Owr.getFeatureFlagValue);
    const value = impl(featureFlagName, defaultValue);
    (0, $gSA3s.addFeatureFlagAccessed)(featureFlagName, value);
    return impl(featureFlagName, defaultValue);
}

});
parcelRegister("f9Owr", function(module, exports) {

$parcel$export(module.exports, "getFeatureFlagValue", () => $132d3c81dd7dc6d5$export$7064bb599f663d7e);
$parcel$export(module.exports, "ff", () => $132d3c81dd7dc6d5$export$f59495b1b7502b33);
$parcel$export(module.exports, "getMultivariateFeatureFlag", () => $132d3c81dd7dc6d5$export$757bc67afadef4a0);

var $y7eb2 = parcelRequire("y7eb2");

var $i3F9x = parcelRequire("i3F9x");
function $132d3c81dd7dc6d5$export$7064bb599f663d7e(featureFlagName, defaultValue) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    if (typeof (0, $y7eb2._haveValuesArrived) !== 'undefined' && !(0, $y7eb2._haveValuesArrived)() && globalVar.__SSR_IS_FAST_META_ENABLED__ && typeof globalVar.__SSR_SYNC_FF__ === 'function') {
        const flagInSSR = globalVar.__SSR_SYNC_FF__(featureFlagName, defaultValue);
        return flagInSSR;
    }
    return (0, $i3F9x.parseFeatureFlagValue)((0, $y7eb2.default)(), featureFlagName, defaultValue);
}
const $132d3c81dd7dc6d5$export$f59495b1b7502b33 = (featureFlagName, defaultValue = false)=>{
    const flagValue = $132d3c81dd7dc6d5$export$7064bb599f663d7e(featureFlagName, defaultValue);
    const isValid = typeof flagValue === 'boolean';
    return isValid ? flagValue : defaultValue;
};
const $132d3c81dd7dc6d5$export$757bc67afadef4a0 = (featureFlagName, defaultValue, possibleValues)=>{
    const flagValue = $132d3c81dd7dc6d5$export$7064bb599f663d7e(featureFlagName, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    defaultValue);
    const isValid = typeof flagValue === 'string' && possibleValues.includes(flagValue);
    return isValid ? flagValue : defaultValue;
};

});
parcelRegister("i3F9x", function(module, exports) {

$parcel$export(module.exports, "parseFeatureFlagValue", () => $065a28307d89ac77$export$cd8c68e04b9439b5);
function $065a28307d89ac77$export$cd8c68e04b9439b5(featureFlags, featureFlagName, defaultValue) {
    const flagValue = featureFlags[featureFlagName];
    if (flagValue === undefined) return defaultValue;
    if (typeof flagValue === 'object' && 'value' in flagValue) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return flagValue.value;
    // This _should never happen_, but we need to validate it to remove
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    return flagValue;
}

});


parcelRegister("6b6Tk", function(module, exports) {

$parcel$export(module.exports, "isAutomaticExposureCollectionEnabled", () => $e664a6eb1eff6089$export$cf2aaf3c58e46848);
const $e664a6eb1eff6089$export$c9c75778ebadb3f1 = ()=>100;
const $e664a6eb1eff6089$export$cf2aaf3c58e46848 = ()=>true;

});

parcelRegister("5vjD3", function(module, exports) {

$parcel$export(module.exports, "getFeatureFlagClient", () => $c8a65b90bf0928c3$export$43a6e0552eef5ca9);

var $8QpSo = parcelRequire("8QpSo");
parcelRequire("kRatU");
var $9PqPj = parcelRequire("9PqPj");

var $y7eb2 = parcelRequire("y7eb2");

var $fjcgS = parcelRequire("fjcgS");
const $c8a65b90bf0928c3$var$getAnalyticsClientInstance = ()=>(0, $fjcgS.getAnalyticsWebClientPromise)().then((analyticsClient)=>analyticsClient.getInstance());
const $c8a65b90bf0928c3$var$createFeatureFlagClient = ()=>{
    const client = new (0, $9PqPj.default)({
        analyticsHandler: {
            sendOperationalEvent: async (event)=>{
                if (!false) $c8a65b90bf0928c3$var$getAnalyticsClientInstance().then((analyticsClient)=>{
                    // SSR doesn't have an analytics client
                    if (!analyticsClient) return;
                    // customize event data here if needed
                    analyticsClient.sendOperationalEvent(event);
                });
            }
        },
        flags: undefined
    });
    return client;
};
const $c8a65b90bf0928c3$var$featureFlagClient = $c8a65b90bf0928c3$var$createFeatureFlagClient();
const $c8a65b90bf0928c3$var$getFeatureFlags = ()=>{
    const flags = (0, $y7eb2.default)();
    if (Object.keys(flags).length === 0) {
        if (false) {
            const err = new Error("Feature flags are not available yet. The feature flag client can't be initialized");
            // print out the stack trace for SSR, so we can have better understanding on
            // which module is using the client too early.
            // in SSR, we use bunyan to replace the console.error, so we can use the standard
            // log format for apps.
            // eslint-disable-next-line no-console
            console.error({
                err: err
            });
        } else // eslint-disable-next-line no-console
        console.error("Feature flags are not available yet. The feature flag client can't be initialized");
    }
    return flags;
};
const $c8a65b90bf0928c3$var$configureFeatureFlagClient = ()=>{
    const flags = $c8a65b90bf0928c3$var$getFeatureFlags();
    // @ts-expect-error - TS2345 - Argument of type 'import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/utils/feature-flagging-using-meta/src/common/types").Flags' is not assignable to parameter of type 'import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/node_modules/@atlaskit/feature-flag-client/dist/types/types").Flags'.
    $c8a65b90bf0928c3$var$featureFlagClient.setFlags(flags);
    if (!false) $c8a65b90bf0928c3$var$featureFlagClient.setIsAutomaticExposuresEnabled(true);
    return $c8a65b90bf0928c3$var$featureFlagClient;
};
// NOTE: `memoizeOne` is doing unnecessary checks, what we need in this file is
// a simple local variable implementation, if local variable doesn't exist then
// create it.
const $c8a65b90bf0928c3$var$getMemoizedFeatureFlagClient = (0, $8QpSo.default)($c8a65b90bf0928c3$var$configureFeatureFlagClient);
let $c8a65b90bf0928c3$var$builtFeatureFlagClient;
const $c8a65b90bf0928c3$export$43a6e0552eef5ca9 = ()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    if (globalVar.isReorderEarlyScriptsEnabled === true) {
        if (typeof $c8a65b90bf0928c3$var$builtFeatureFlagClient === 'undefined' || globalVar.invalidateFeatureFlagsClient_DO_NOT_USE === true) {
            globalVar.invalidateFeatureFlagsClient_DO_NOT_USE = false;
            $c8a65b90bf0928c3$var$builtFeatureFlagClient = (0, $8QpSo.default)($c8a65b90bf0928c3$var$configureFeatureFlagClient);
        }
        return $c8a65b90bf0928c3$var$builtFeatureFlagClient();
    }
    return $c8a65b90bf0928c3$var$getMemoizedFeatureFlagClient();
};

});
parcelRegister("kRatU", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("9PqPj")).default);

var $9PqPj = parcelRequire("9PqPj");

var $bECnN = parcelRequire("bECnN");

});
parcelRegister("9PqPj", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0fec51a21ec5a78$export$2e2bcd8739ae039);

var $bECnN = parcelRequire("bECnN");

var $jSerw = parcelRequire("jSerw");

var $furey = parcelRequire("furey");

var $bo3Uw = parcelRequire("bo3Uw");
class $b0fec51a21ec5a78$export$2e2bcd8739ae039 {
    constructor(options){
        (0, $jSerw.enforceAttributes)(options, [
            'analyticsHandler'
        ], 'Feature Flag Client');
        const { flags: flags, analyticsHandler: analyticsHandler, isAutomaticExposuresEnabled: isAutomaticExposuresEnabled, ignoreTypes: ignoreTypes } = options;
        this.flags = new Map();
        this.flagWrapperCache = new Map();
        this.customAttributesExposuresCache = new Set();
        this.trackedFlags = new Set();
        this.isAutomaticExposuresEnabled = isAutomaticExposuresEnabled || false;
        this.ignoreTypes = ignoreTypes || false;
        this.setFlags(flags || {});
        this.setAnalyticsHandler(analyticsHandler);
    }
    setFlags(flags) {
        if (!(0, $jSerw.isObject)(flags)) return;
        Object.entries(flags).forEach(([flagKey, flag])=>{
            this.flags.set(flagKey, flag);
        });
        // Clear any cached data for flags that have been passed in again,
        // in case they have different values or explanations
        for (const flagKey of this.flagWrapperCache.keys())if (flags.hasOwnProperty(flagKey)) this.flagWrapperCache.delete(flagKey);
    }
    setAnalyticsHandler(analyticsHandler) {
        this.analyticsHandler = analyticsHandler;
    }
    setIsAutomaticExposuresEnabled(isEnabled) {
        this.isAutomaticExposuresEnabled = isEnabled;
    }
    /**
	 * This method returns the wrapper object for the given flag key.
	 * If the flag does not exist, this will return a stubbed flag following the null-object pattern,
	 * so it is always guaranteed to return an object.
	 */ getFlagWrapper(flagKey) {
        let wrapper = this.flagWrapperCache.get(flagKey);
        if (wrapper !== undefined) return wrapper;
        const flag = this.flags.get(flagKey);
        if (flag) wrapper = new (0, $bo3Uw.default)(flagKey, flag, this._trackExposure.bind(this), this.sendAutomaticExposure.bind(this), this.ignoreTypes);
        else wrapper = new (0, $furey.default)();
        this.flagWrapperCache.set(flagKey, wrapper);
        return wrapper;
    }
    clear() {
        this.flags.clear();
        this.flagWrapperCache.clear();
        this.trackedFlags.clear();
    }
    getBooleanValue(flagKey, options) {
        (0, $jSerw.enforceAttributes)(options, [
            'default'
        ], 'getBooleanValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getBooleanValue(options);
    }
    getVariantValue(flagKey, options) {
        (0, $jSerw.enforceAttributes)(options, [
            'default',
            'oneOf'
        ], 'getVariantValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getVariantValue(options);
    }
    getJSONValue(flagKey) {
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getJSONValue();
    }
    getRawValue(flagKey, options) {
        (0, $jSerw.enforceAttributes)(options, [
            'default'
        ], 'getRawValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getRawValue(options);
    }
    getFlagEvaluation(flagKey, options) {
        (0, $jSerw.enforceAttributes)(options, [
            'default'
        ], 'getRawValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getFlagEvaluation(options);
    }
    /**
	 * This method combines both the trackExposure and sendAutomaticExposure flows into
	 * one endpoint. Depending on the passed in trigger reason a manual or automatic exposure
	 * is sent.
	 **/ trackFeatureFlag(flagKey, options = {}) {
        const triggerReason = options?.triggerReason ? options.triggerReason : (0, $bECnN.ExposureTriggerReason).Manual;
        const isValueSet = this.flags.has(flagKey) || 'value' in options;
        if (!isValueSet) {
            // eslint-disable-next-line no-console
            console.warn(`No value associated with the flagKey: ${flagKey} with an exposure trigger reason of: ${triggerReason}`);
            return;
        }
        // if no values for flagValue and explanation supplied then retrieve them from the flags map
        const flagValue = 'value' in options ? options.value : this.flags.get(flagKey)?.value;
        const flagExplanation = options?.explanation ? options.explanation : this.flags.get(flagKey)?.explanation;
        if (triggerReason === (0, $bECnN.ExposureTriggerReason).AutoExposure) this.sendAutomaticExposure(flagKey, flagValue, flagExplanation);
        else // default to fire a manual track exposure
        this._trackExposure(flagKey, {
            value: flagValue,
            explanation: flagExplanation
        }, triggerReason);
    }
    trackExposure(flagKey, flag, exposureData = {}) {
        return this._trackExposure(flagKey, flag, (0, $bECnN.ExposureTriggerReason).Manual, exposureData);
    }
    _trackExposure(flagKey, flag, exposureTriggerReason, exposureData) {
        if (!(flag && flag.explanation && this.shouldSendEvent(flagKey, exposureData))) return;
        (0, $jSerw.checkForReservedAttributes)(exposureData);
        const flagAttributes = {
            flagKey: flagKey,
            reason: flag.explanation.kind,
            ruleId: flag.explanation.ruleId,
            value: flag.value
        };
        this.sendExposureEvent(flagAttributes, exposureTriggerReason, exposureData);
    }
    shouldSendEvent(flagKey, customAttributes) {
        return this.analyticsHandler !== undefined && (!this.trackedFlags.has(flagKey) || !(0, $jSerw.isObjectEmptyOrUndefined)(customAttributes) && !this.customAttributesExposuresCache.has(flagKey));
    }
    sendAutomaticExposure(flagKey, value, flagExplanation) {
        if (!(flagExplanation && this.isAutomaticExposuresEnabled && this.shouldSendEvent(flagKey))) return;
        const flagAttributes = {
            flagKey: flagKey,
            value: value,
            reason: flagExplanation.kind || 'SIMPLE_EVAL',
            ruleId: flagExplanation.ruleId,
            errorKind: flagExplanation.errorKind
        };
        this.sendExposureEvent(flagAttributes, (0, $bECnN.ExposureTriggerReason).AutoExposure);
    }
    sendExposureEvent(attributes, exposureTriggerReason, customAttributes) {
        if (!this.trackedFlags.has(attributes.flagKey)) {
            const exposureEvent = {
                action: 'exposed',
                actionSubject: 'feature',
                attributes: attributes,
                tags: [
                    'measurement',
                    exposureTriggerReason
                ],
                highPriority: false,
                source: '@atlaskit/feature-flag-client'
            };
            this.analyticsHandler?.sendOperationalEvent(exposureEvent);
            this.trackedFlags.add(attributes.flagKey);
        }
        // Due to the way we've simplified our pipeline, custom attributes are dropped from exposure
        // events. In order not to break existing users of this feature immediately, we're sending an
        // extra event that won't be consumed by our pipeline, but will end up in the `cloud.*` tables.
        // See: https://hello.atlassian.net/wiki/spaces/MEASURE/pages/1838596497/AtlasKit+TAC
        if (!(0, $jSerw.isObjectEmptyOrUndefined)(customAttributes)) {
            const customeAttributesExposureEvent = {
                action: 'exposed',
                actionSubject: 'feature',
                attributes: Object.assign({}, attributes, customAttributes),
                tags: [
                    'measurement',
                    (0, $bECnN.ExposureTriggerReason).hasCustomAttributes,
                    exposureTriggerReason
                ],
                highPriority: true,
                source: '@atlaskit/feature-flag-client'
            };
            this.analyticsHandler?.sendOperationalEvent(customeAttributesExposureEvent);
            this.customAttributesExposuresCache.add(attributes.flagKey);
        }
    }
    getFlagStats() {
        const flagStats = {};
        for (const [flagKey, wrapper] of this.flagWrapperCache){
            const { evaluationCount: evaluationCount } = wrapper;
            flagStats[flagKey] = {
                evaluationCount: evaluationCount
            };
        }
        return flagStats;
    }
}

});
parcelRegister("bECnN", function(module, exports) {

$parcel$export(module.exports, "ExposureTriggerReason", () => $0ceddc1f24830f6f$export$2c20ffeba7dbc068);
var $0ceddc1f24830f6f$export$2c20ffeba7dbc068 = /*#__PURE__*/ function(ExposureTriggerReason) {
    ExposureTriggerReason["OptIn"] = "optInExposure";
    ExposureTriggerReason["Manual"] = "manualExposure";
    ExposureTriggerReason["Default"] = "defaultExposure";
    ExposureTriggerReason["AutoExposure"] = "autoExposure";
    ExposureTriggerReason["hasCustomAttributes"] = "hasCustomAttributes";
    return ExposureTriggerReason;
}({});

});

parcelRegister("jSerw", function(module, exports) {

$parcel$export(module.exports, "isObject", () => $8918e231cb30b34e$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isObjectEmptyOrUndefined", () => $8918e231cb30b34e$export$8ed1df9dbe2e9a7d);
$parcel$export(module.exports, "enforceAttributes", () => $8918e231cb30b34e$export$c7d37910dd25ecbf);
$parcel$export(module.exports, "checkForReservedAttributes", () => $8918e231cb30b34e$export$891630e169ca14a4);
const $8918e231cb30b34e$export$a6cdc56e425d0d0a = (value)=>typeof value === 'object';
const $8918e231cb30b34e$export$8ed1df9dbe2e9a7d = (obj)=>{
    return obj ? Object.keys(obj).length === 0 : true;
};
const $8918e231cb30b34e$export$c7d37910dd25ecbf = (obj, attributes, identifier)=>{
    attributes.forEach((attribute)=>{
        if (!(attribute in obj)) {
            const title = identifier ? `${identifier}: ` : '';
            throw new Error(`${title}Missing ${attribute}`);
        }
    });
};
const $8918e231cb30b34e$export$891630e169ca14a4 = (customAttributes)=>{
    const reservedAttributes = [
        'flagKey',
        'ruleId',
        'reason',
        'value',
        'errorKind'
    ];
    const keys = customAttributes ? Object.keys(customAttributes) : [];
    if (reservedAttributes.some((attribute)=>keys.includes(attribute))) throw new TypeError(`exposureData contains a reserved attribute. Reserved attributes are: ${reservedAttributes.join(', ')}`);
};
const $8918e231cb30b34e$var$validateFlag = (flagKey, flag)=>{
    if ($8918e231cb30b34e$export$a6cdc56e425d0d0a(flag) && 'value' in flag) return true;
};
const $8918e231cb30b34e$export$410eec87ab950965 = (flags)=>{
    Object.keys(flags).forEach((key)=>$8918e231cb30b34e$var$validateFlag(key, flags[key]));
};

});

parcelRegister("furey", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c7101c4822b75c1$export$2e2bcd8739ae039);
const $7c7101c4822b75c1$export$933245d8afcc8872 = {
    kind: 'ERROR',
    errorKind: 'FLAG_NOT_FOUND'
};
class $7c7101c4822b75c1$export$2e2bcd8739ae039 {
    evaluate(defaultValue) {
        return defaultValue;
    }
    getBooleanValue(options) {
        return this.evaluate(options.default);
    }
    getVariantValue(options) {
        return this.evaluate(options.default);
    }
    getJSONValue() {
        return this.evaluate({});
    }
    getRawValue(options) {
        return this.evaluate(options.default);
    }
    getFlagEvaluation(options) {
        const value = this.evaluate(options.default);
        return {
            value: value,
            explanation: $7c7101c4822b75c1$export$933245d8afcc8872
        };
    }
    constructor(){
        // Unused but required for type
        this.evaluationCount = -1;
    }
}

});

parcelRegister("bo3Uw", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b7d7cbcbf7ac517$export$2e2bcd8739ae039);

var $bECnN = parcelRequire("bECnN");
class $9b7d7cbcbf7ac517$export$2e2bcd8739ae039 {
    constructor(flagKey, flag, trackExposure, sendAutomaticExposure, ignoreTypes){
        this.flagKey = flagKey;
        this.flag = flag;
        this.evaluationCount = 0;
        this.trackExposure = trackExposure;
        this.sendAutomaticExposure = sendAutomaticExposure;
        this.ignoreTypes = ignoreTypes;
    }
    getCachedResultOrCompute(defaultValue, { shouldTrackExposureEvent: shouldTrackExposureEvent, exposureData: exposureData, oneOf: oneOf, ignoreTypes: ignoreTypes }) {
        let exposureTriggerReason = (0, $bECnN.ExposureTriggerReason).OptIn;
        if (shouldTrackExposureEvent === undefined) {
            shouldTrackExposureEvent = true;
            exposureTriggerReason = (0, $bECnN.ExposureTriggerReason).Default;
        }
        // It is very common for products to call this method many times for the same flag key,
        // as flag evaluations are often done inside action callbacks and/or inside components with many instances.
        // We can cache the result of the first evaluation to avoid doing the same validation checks on every call.
        if (this.evaluationResult === undefined) this.evaluationResult = this.computeWithValidation(defaultValue, {
            oneOf: oneOf,
            ignoreTypes: ignoreTypes
        });
        let value = this.evaluationResult.value;
        if (this.evaluationResult.didFallbackToDefaultValue) // Use the default that was passed in, just in case it's different to what it was in the initial evaluation
        value = defaultValue;
        else if (shouldTrackExposureEvent) // For backwards compability, only fire the opt-in exposure event in valid evaluations.
        this.trackExposure(this.flagKey, this.flag, exposureTriggerReason, exposureData);
        this.sendAutomaticExposure(this.flagKey, value, this.evaluationResult.explanation);
        this.evaluationCount++;
        return {
            value: value,
            explanation: this.evaluationResult.explanation
        };
    }
    computeWithValidation(defaultValue, { oneOf: oneOf, ignoreTypes: ignoreTypes }) {
        let result = {
            value: this.flag.value,
            explanation: this.flag.explanation,
            didFallbackToDefaultValue: false
        };
        if (!ignoreTypes && typeof this.flag.value !== typeof defaultValue) {
            result.value = defaultValue;
            result.didFallbackToDefaultValue = true;
            result.explanation = {
                ...result.explanation || {},
                kind: 'ERROR',
                errorKind: 'WRONG_TYPE'
            };
        } else if (oneOf !== undefined && !oneOf.includes(this.flag.value)) {
            result.value = defaultValue;
            result.didFallbackToDefaultValue = true;
            result.explanation = {
                ...result.explanation || {},
                kind: 'ERROR',
                errorKind: 'VALIDATION_ERROR'
            };
        }
        return result;
    }
    getBooleanValue(options) {
        const flag = this.getCachedResultOrCompute(options.default, {
            exposureData: options.exposureData,
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            oneOf: undefined,
            ignoreTypes: this.ignoreTypes || false
        });
        return flag.value;
    }
    getVariantValue(options) {
        const flag = this.getCachedResultOrCompute(options.default, {
            exposureData: options.exposureData,
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            oneOf: options.oneOf,
            ignoreTypes: this.ignoreTypes || false
        });
        return flag.value;
    }
    getJSONValue() {
        return this.getCachedResultOrCompute({}, {
            shouldTrackExposureEvent: false,
            ignoreTypes: this.ignoreTypes
        }).value;
    }
    getRawValue(options) {
        return this.getCachedResultOrCompute(options.default, {
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            exposureData: options.exposureData,
            oneOf: undefined,
            ignoreTypes: true
        }).value;
    }
    getFlagEvaluation(options) {
        return this.getCachedResultOrCompute(options.default, {
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            exposureData: options.exposureData,
            ignoreTypes: this.ignoreTypes || false
        });
    }
}

});





parcelRegister("5bkvv", function(module, exports) {

$parcel$export(module.exports, "forgeAdminModuleResource", () => $3d515a0fe8e87c81$export$b9489d8c5c5e3626);
$parcel$export(module.exports, "getNavigationSidebarGlobalSettingsResources", () => $3d515a0fe8e87c81$export$dcc98f4b36ce9223);
$parcel$export(module.exports, "forgeProjectModuleResource", () => $3d515a0fe8e87c81$export$72db683c2914a65e);
$parcel$export(module.exports, "forgeProjectModuleResourceOnNav3Only", () => $3d515a0fe8e87c81$export$9f19b684a7493211);
$parcel$export(module.exports, "forgeBacklogModuleResource", () => $3d515a0fe8e87c81$export$7523db37432ba090);
$parcel$export(module.exports, "forgeBoardModuleResource", () => $3d515a0fe8e87c81$export$cfd99f451b423d3a);
$parcel$export(module.exports, "forgeSprintModuleResource", () => $3d515a0fe8e87c81$export$7b639f33f086f9f1);
$parcel$export(module.exports, "forgePersonalSettingsPageModuleResource", () => $3d515a0fe8e87c81$export$8a5aed164e925eb6);
$parcel$export(module.exports, "getNavigationForgePersonalSettingsPageResources", () => $3d515a0fe8e87c81$export$ec3265610584f9ce);
$parcel$export(module.exports, "forgeProjectSettingsModuleResource", () => $3d515a0fe8e87c81$export$7a928d209faf75f);
$parcel$export(module.exports, "useForgeProjectSettingsModuleResource", () => $3d515a0fe8e87c81$export$e81e11bbc3239153);
$parcel$export(module.exports, "forgeGlobalModuleResource", () => $3d515a0fe8e87c81$export$97b0827022fdafe3);
$parcel$export(module.exports, "getNavigationForgeGlobalPageResources", () => $3d515a0fe8e87c81$export$80b2f91dabb3dd65);
$parcel$export(module.exports, "forgeServiceDeskQueueModuleResource", () => $3d515a0fe8e87c81$export$ebf5369e4dcfad00);
$parcel$export(module.exports, "forgeCustomFieldTypeResource", () => $3d515a0fe8e87c81$export$e6be2f0ca0849869);

var $8O7FC = parcelRequire("8O7FC");

var $4R6GH = parcelRequire("4R6GH");

var $k2DRb = parcelRequire("k2DRb");

var $iVaKa = parcelRequire("iVaKa");

var $3HwlS = parcelRequire("3HwlS");

var $dK8AG = parcelRequire("dK8AG");

var $gNStA = parcelRequire("gNStA");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $1yLrr = parcelRequire("1yLrr");
const $3d515a0fe8e87c81$export$eb46cc3d7c1a6649 = (params, moduleName)=>{
    const isModuleWithAccessNarrowing = [
        (0, $k2DRb.SERVICEDESK_QUEUE_PAGE_MODULE),
        (0, $k2DRb.PROJECT_PAGE_MODULE),
        (0, $k2DRb.PROJECT_SETTINGS_PAGE_MODULE)
    ] // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .includes(moduleName);
    const projectIdOrKey = (0, $dK8AG.getProjectKeyOrId)(params);
    if (typeof projectIdOrKey === 'string' && projectIdOrKey !== '' && isModuleWithAccessNarrowing) return {
        projectIdOrKey: projectIdOrKey
    };
    return null;
};
const $3d515a0fe8e87c81$export$b9489d8c5c5e3626 = (0, $2M1hQ.createResource)({
    type: 'FORGE_ADMIN_MODULE',
    getKey: ()=>'extensions',
    getData: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.ADMIN_PAGE_MODULE)
            ],
            context: {},
            includeHidden: true,
            source: (0, $k2DRb.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.ADMIN_PAGE_MODULE], (0, $1yLrr.adminPageFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$dcc98f4b36ce9223 = ()=>[
        $3d515a0fe8e87c81$export$b9489d8c5c5e3626
    ];
const $3d515a0fe8e87c81$export$72db683c2914a65e = (0, $2M1hQ.createResource)({
    type: 'FORGE_PROJECT_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $dK8AG.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.PROJECT_PAGE_MODULE)
            ],
            context: {
                projectKey: (0, $dK8AG.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: true,
            source: (0, $k2DRb.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.PROJECT_PAGE_MODULE], (0, $1yLrr.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$9f19b684a7493211 = (0, $gNStA.resourceWithCondition2)(()=>!((0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('perf-push-big-components-nav-remove-resources')), $3d515a0fe8e87c81$export$72db683c2914a65e);
const $3d515a0fe8e87c81$export$7523db37432ba090 = (0, $2M1hQ.createResource)({
    type: 'FORGE_BACKLOG_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $dK8AG.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.BACKLOG_ACTION_MODULE)
            ],
            context: {
                projectKey: (0, $dK8AG.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: false,
            source: (0, $k2DRb.SOURCE_ROUTER)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.BACKLOG_ACTION_MODULE], (0, $1yLrr.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$cfd99f451b423d3a = (0, $2M1hQ.createResource)({
    type: 'FORGE_BOARD_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $dK8AG.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.BOARD_ACTION_MODULE)
            ],
            context: {
                projectKey: (0, $dK8AG.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: false,
            source: (0, $k2DRb.SOURCE_ROUTER)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.BOARD_ACTION_MODULE], (0, $1yLrr.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$7b639f33f086f9f1 = (0, $2M1hQ.createResource)({
    type: 'FORGE_SPRINT_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $dK8AG.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.SPRINT_ACTION_MODULE)
            ],
            context: {
                projectKey: (0, $dK8AG.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: false,
            source: (0, $k2DRb.SOURCE_ROUTER)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.SPRINT_ACTION_MODULE], (0, $1yLrr.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$8a5aed164e925eb6 = (0, $2M1hQ.createResource)({
    type: 'FORGE_PERSONAL_SETTINGS_MODULE',
    getKey: ()=>'extensions',
    getData: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE)
            ],
            context: {},
            includeHidden: false,
            source: (0, $k2DRb.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE], (0, $1yLrr.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$ec3265610584f9ce = ()=>[
        $3d515a0fe8e87c81$export$8a5aed164e925eb6
    ];
const $3d515a0fe8e87c81$export$7a928d209faf75f = (0, $2M1hQ.createResource)({
    type: 'FORGE_PROJECT_SETTINGS_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $dK8AG.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.PROJECT_SETTINGS_PAGE_MODULE)
            ],
            context: {
                projectKey: (0, $dK8AG.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: true,
            source: (0, $k2DRb.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.PROJECT_SETTINGS_PAGE_MODULE], (0, $1yLrr.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$e81e11bbc3239153 = ()=>(0, $2YP9W.useResource)($3d515a0fe8e87c81$export$7a928d209faf75f);
const $3d515a0fe8e87c81$export$97b0827022fdafe3 = (0, $2M1hQ.createResource)({
    type: 'FORGE_GLOBAL_MODULE',
    getKey: ()=>'extensions',
    getData: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.GLOBAL_PAGE_MODULE)
            ],
            context: {},
            includeHidden: true,
            source: (0, $k2DRb.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.GLOBAL_PAGE_MODULE], (0, $1yLrr.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$80b2f91dabb3dd65 = ()=>[
        $3d515a0fe8e87c81$export$97b0827022fdafe3
    ];
const $3d515a0fe8e87c81$export$ebf5369e4dcfad00 = (0, $2M1hQ.createResource)({
    type: 'FORGE_SERVICEDESK_QUEUE_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $dK8AG.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.SERVICEDESK_QUEUE_PAGE_MODULE)
            ],
            context: {
                projectKey: (0, $dK8AG.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: true,
            source: (0, $k2DRb.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.SERVICEDESK_QUEUE_PAGE_MODULE], (0, $1yLrr.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$e6be2f0ca0849869 = (0, $2M1hQ.createResource)({
    type: 'FORGE_CUSTOM_FIELD_TYPE_MODULE',
    getKey: ()=>'extensions',
    getData: (_route, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.CUSTOM_FIELD_TYPE_MODULE)
            ],
            context: {},
            includeHidden: false,
            source: (0, $k2DRb.SOURCE_NAVIGATION)
        }).then(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (modules)=>modules[0, $k2DRb.CUSTOM_FIELD_TYPE_MODULE]),
    maxAge: Number.MAX_SAFE_INTEGER
});
/**
 * Makes sure modules are filtered out depending on the predicate and sorted alphabetically by title.
 */ function $3d515a0fe8e87c81$var$normalizeModules(modules, filter) {
    return filter(modules).sort((a, b)=>(0, $8O7FC.alphabeticalSort)(a.properties.title, b.properties.title));
}

});
parcelRegister("8O7FC", function(module, exports) {

$parcel$export(module.exports, "alphabeticalSort", () => $7c4745a46edf6307$export$89a1f01f2a7cb2a1);

var $2YZCu = parcelRequire("2YZCu");
const $7c4745a46edf6307$export$89a1f01f2a7cb2a1 = (a, b)=>{
    // @ts-expect-error This condition will always return true since this function is always defined. Did you mean to call it instead?ts(2774)
    if (a && b && a.localeCompare && b.localeCompare) return a.localeCompare(b, 'en', {
        numeric: true,
        caseFirst: 'upper'
    });
    const typeOfA = a === null ? 'null' : typeof a;
    const typeOfB = b === null ? 'null' : typeof b;
    const error = new Error(`type of a: ${typeOfA}. type of b: ${typeOfB}`);
    (0, $2YZCu.default).safeErrorWithoutCustomerData('software.board.filter', 'localeCompare is not a function', error);
    return 1;
};

});

parcelRegister("k2DRb", function(module, exports) {

$parcel$export(module.exports, "STAGING_ENVIRONMENT", () => $e80aa4d4aac5b0dc$export$71acbd662c478c42);
$parcel$export(module.exports, "DEVELOPMENT_ENVIRONMENT", () => $e80aa4d4aac5b0dc$export$978072fd3fd149);
$parcel$export(module.exports, "DEFAULT_ENVIRONMENT_KEY", () => $e80aa4d4aac5b0dc$export$ebc15d9cebfd6063);
$parcel$export(module.exports, "BACKLOG_ACTION_MODULE", () => $e80aa4d4aac5b0dc$export$516a8fb49ad5d50e);
$parcel$export(module.exports, "BOARD_ACTION_MODULE", () => $e80aa4d4aac5b0dc$export$6cc3a1f2111dee11);
$parcel$export(module.exports, "SPRINT_ACTION_MODULE", () => $e80aa4d4aac5b0dc$export$cfb15d127f20a01f);
$parcel$export(module.exports, "ISSUE_ACTION_MODULE", () => $e80aa4d4aac5b0dc$export$fcc4a18f46f80f16);
$parcel$export(module.exports, "COMMAND_PALETTE_MODULE", () => $e80aa4d4aac5b0dc$export$65ebd2e1f63d2992);
$parcel$export(module.exports, "ISSUE_GLANCE_MODULE", () => $e80aa4d4aac5b0dc$export$259bab989b0129d0);
$parcel$export(module.exports, "ISSUE_CONTEXT_MODULE", () => $e80aa4d4aac5b0dc$export$75f224942f595e13);
$parcel$export(module.exports, "ISSUE_PANEL_MODULE", () => $e80aa4d4aac5b0dc$export$ba0968f9752844);
$parcel$export(module.exports, "ISSUE_NAVIGATOR_ACTION_MODULE", () => $e80aa4d4aac5b0dc$export$7e2136b4285d29f5);
$parcel$export(module.exports, "ISSUE_ACTIVITY_MODULE", () => $e80aa4d4aac5b0dc$export$cc20a5638825fbb0);
$parcel$export(module.exports, "ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE", () => $e80aa4d4aac5b0dc$export$9069d4b945c3d532);
$parcel$export(module.exports, "UI_MODIFICATIONS_MODULE", () => $e80aa4d4aac5b0dc$export$811b7f067a43b422);
$parcel$export(module.exports, "CUSTOM_FIELD_MODULE", () => $e80aa4d4aac5b0dc$export$e3887d6bafe8a17);
$parcel$export(module.exports, "CUSTOM_FIELD_TYPE_MODULE", () => $e80aa4d4aac5b0dc$export$7b7866c04a2ad947);
$parcel$export(module.exports, "ADMIN_PAGE_MODULE", () => $e80aa4d4aac5b0dc$export$52e4945e96bd2aa0);
$parcel$export(module.exports, "PERSONAL_SETTINGS_PAGE_MODULE", () => $e80aa4d4aac5b0dc$export$a8cd23a3cbda9d58);
$parcel$export(module.exports, "PROJECT_PAGE_MODULE", () => $e80aa4d4aac5b0dc$export$151b03356f566603);
$parcel$export(module.exports, "PROJECT_SETTINGS_PAGE_MODULE", () => $e80aa4d4aac5b0dc$export$ea0d6ac082b0d636);
$parcel$export(module.exports, "GLOBAL_PAGE_MODULE", () => $e80aa4d4aac5b0dc$export$31ac745ab2add7cc);
$parcel$export(module.exports, "DASHBOARD_BACKGROUND_SCRIPT_MODULE", () => $e80aa4d4aac5b0dc$export$353acf28daa75c79);
$parcel$export(module.exports, "DASHBOARD_GADGET_MODULE", () => $e80aa4d4aac5b0dc$export$25627f012b21b0b9);
$parcel$export(module.exports, "WORKFLOW_VALIDATOR_MODULE", () => $e80aa4d4aac5b0dc$export$42d6a8740fd42e58);
$parcel$export(module.exports, "WORKFLOW_CONDITION_MODULE", () => $e80aa4d4aac5b0dc$export$a7186e5a73395db4);
$parcel$export(module.exports, "WORKFLOW_POST_FUNCTION_MODULE", () => $e80aa4d4aac5b0dc$export$8fbcfe84dc845d17);
$parcel$export(module.exports, "SERVICEDESK_QUEUE_PAGE_MODULE", () => $e80aa4d4aac5b0dc$export$8af4cb794979f60d);
$parcel$export(module.exports, "SERVICEDESK_ORGANIZATION_PANEL_MODULE", () => $e80aa4d4aac5b0dc$export$5592ab836d562168);
$parcel$export(module.exports, "SERVICEDESK_ASSETS_IMPORT_TYPE_MODULE", () => $e80aa4d4aac5b0dc$export$842eb4236828ac9);
$parcel$export(module.exports, "SUPPORTED_MODULES", () => $e80aa4d4aac5b0dc$export$9b1a91242ce2a1b7);
$parcel$export(module.exports, "ENTRY_POINT_EDIT", () => $e80aa4d4aac5b0dc$export$2b8aeda236486576);
$parcel$export(module.exports, "ENTRY_POINT_VIEW", () => $e80aa4d4aac5b0dc$export$c41ce1ec1ea6e73d);
$parcel$export(module.exports, "ENTRY_POINT_CREATE", () => $e80aa4d4aac5b0dc$export$b37d58c3ed77c139);
$parcel$export(module.exports, "ENTRY_POINT_CONTEXT_CONFIG", () => $e80aa4d4aac5b0dc$export$ab94dbd1d02ac251);
$parcel$export(module.exports, "NONE_PANEL_INSTANCE_ID", () => $e80aa4d4aac5b0dc$export$b6a67a3131c6c48d);
$parcel$export(module.exports, "ISSUE_PANEL_MULTIPLE_LIMIT", () => $e80aa4d4aac5b0dc$export$b75dc2bfd20898fe);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_NATIVE", () => $e80aa4d4aac5b0dc$export$8e96118a698216cb);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_BASIC", () => $e80aa4d4aac5b0dc$export$9b72a8e9b92658fb);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_BLANK", () => $e80aa4d4aac5b0dc$export$2d6539e7d0553ae7);
$parcel$export(module.exports, "SOURCE_UNKNOWN", () => $e80aa4d4aac5b0dc$export$ecbd7135d66cb322);
$parcel$export(module.exports, "SOURCE_GLOBAL_ISSUE_CREATE", () => $e80aa4d4aac5b0dc$export$61d882aa7aba51c);
$parcel$export(module.exports, "SOURCE_ISSUE_VIEW", () => $e80aa4d4aac5b0dc$export$46cb92762d68a048);
$parcel$export(module.exports, "SOURCE_NAVIGATION", () => $e80aa4d4aac5b0dc$export$fe90e46aea58e30b);
$parcel$export(module.exports, "SOURCE_FULL_PAGE_APP", () => $e80aa4d4aac5b0dc$export$c5ccbdb9893f2a6a);
$parcel$export(module.exports, "SOURCE_ROUTER", () => $e80aa4d4aac5b0dc$export$eae46a3c13473a8d);
$parcel$export(module.exports, "SOURCE_LEGACY", () => $e80aa4d4aac5b0dc$export$ac11ee191d09688f);
$parcel$export(module.exports, "SOURCE_ORGANIZATION_PANEL", () => $e80aa4d4aac5b0dc$export$4346e4e240c84319);
$parcel$export(module.exports, "SOURCE_ASSETS_IMPORT_TYPE", () => $e80aa4d4aac5b0dc$export$d719bb340dc354e4);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JIRA", () => $e80aa4d4aac5b0dc$export$4b6228758e800433);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JSM", () => $e80aa4d4aac5b0dc$export$70495c8cc141a7a4);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_CMDB", () => $e80aa4d4aac5b0dc$export$bc3d408418fdf9d2);
$parcel$export(module.exports, "getEmptyExtensionsObject", () => $e80aa4d4aac5b0dc$export$218a328f66b86f7d);
$parcel$export(module.exports, "FORGE_FIELD_TYPE_PREFIX", () => $e80aa4d4aac5b0dc$export$3193d714ab54ee26);
$parcel$export(module.exports, "PARTIAL_LEGACY_FORGE_FIELD_TYPE_PREFIX", () => $e80aa4d4aac5b0dc$export$df7774a415710cce);
$parcel$export(module.exports, "LEGACY_FORGE_FIELD_TYPE_PREFIX", () => $e80aa4d4aac5b0dc$export$51ab2784839ce348);
const $e80aa4d4aac5b0dc$export$9af0088c49bdedb = 'PRODUCTION';
const $e80aa4d4aac5b0dc$export$71acbd662c478c42 = 'STAGING';
const $e80aa4d4aac5b0dc$export$978072fd3fd149 = 'DEVELOPMENT';
const $e80aa4d4aac5b0dc$export$ebc15d9cebfd6063 = 'default';
const $e80aa4d4aac5b0dc$export$516a8fb49ad5d50e = 'jira:backlogAction';
const $e80aa4d4aac5b0dc$export$6cc3a1f2111dee11 = 'jira:boardAction';
const $e80aa4d4aac5b0dc$export$cfb15d127f20a01f = 'jira:sprintAction';
const $e80aa4d4aac5b0dc$export$fcc4a18f46f80f16 = 'jira:issueAction';
const $e80aa4d4aac5b0dc$export$65ebd2e1f63d2992 = 'jira:command';
const $e80aa4d4aac5b0dc$export$259bab989b0129d0 = 'jira:issueGlance';
const $e80aa4d4aac5b0dc$export$75f224942f595e13 = 'jira:issueContext';
const $e80aa4d4aac5b0dc$export$ba0968f9752844 = 'jira:issuePanel';
const $e80aa4d4aac5b0dc$export$7e2136b4285d29f5 = 'jira:issueNavigatorAction';
const $e80aa4d4aac5b0dc$export$cc20a5638825fbb0 = 'jira:issueActivity';
const $e80aa4d4aac5b0dc$export$9069d4b945c3d532 = 'jira:issueViewBackgroundScript';
const $e80aa4d4aac5b0dc$export$811b7f067a43b422 = 'jira:uiModifications';
const $e80aa4d4aac5b0dc$export$e3887d6bafe8a17 = 'jira:customField';
const $e80aa4d4aac5b0dc$export$7b7866c04a2ad947 = 'jira:customFieldType';
const $e80aa4d4aac5b0dc$export$52e4945e96bd2aa0 = 'jira:adminPage';
const $e80aa4d4aac5b0dc$export$a8cd23a3cbda9d58 = 'jira:personalSettingsPage';
const $e80aa4d4aac5b0dc$export$151b03356f566603 = 'jira:projectPage';
const $e80aa4d4aac5b0dc$export$ea0d6ac082b0d636 = 'jira:projectSettingsPage';
const $e80aa4d4aac5b0dc$export$31ac745ab2add7cc = 'jira:globalPage';
const $e80aa4d4aac5b0dc$export$353acf28daa75c79 = 'jira:dashboardBackgroundScript';
const $e80aa4d4aac5b0dc$export$25627f012b21b0b9 = 'jira:dashboardGadget';
const $e80aa4d4aac5b0dc$export$42d6a8740fd42e58 = 'jira:workflowValidator';
const $e80aa4d4aac5b0dc$export$a7186e5a73395db4 = 'jira:workflowCondition';
const $e80aa4d4aac5b0dc$export$8fbcfe84dc845d17 = 'jira:workflowPostFunction';
const $e80aa4d4aac5b0dc$export$8af4cb794979f60d = 'jiraServiceManagement:queuePage';
const $e80aa4d4aac5b0dc$export$5592ab836d562168 = 'jiraServiceManagement:organizationPanel';
const $e80aa4d4aac5b0dc$export$842eb4236828ac9 = 'jiraServiceManagement:assetsImportType';
const $e80aa4d4aac5b0dc$export$9b1a91242ce2a1b7 = [
    $e80aa4d4aac5b0dc$export$516a8fb49ad5d50e,
    $e80aa4d4aac5b0dc$export$65ebd2e1f63d2992,
    $e80aa4d4aac5b0dc$export$6cc3a1f2111dee11,
    $e80aa4d4aac5b0dc$export$cfb15d127f20a01f,
    $e80aa4d4aac5b0dc$export$fcc4a18f46f80f16,
    $e80aa4d4aac5b0dc$export$259bab989b0129d0,
    $e80aa4d4aac5b0dc$export$75f224942f595e13,
    $e80aa4d4aac5b0dc$export$7e2136b4285d29f5,
    $e80aa4d4aac5b0dc$export$ba0968f9752844,
    $e80aa4d4aac5b0dc$export$cc20a5638825fbb0,
    $e80aa4d4aac5b0dc$export$9069d4b945c3d532,
    $e80aa4d4aac5b0dc$export$811b7f067a43b422,
    $e80aa4d4aac5b0dc$export$e3887d6bafe8a17,
    $e80aa4d4aac5b0dc$export$7b7866c04a2ad947,
    $e80aa4d4aac5b0dc$export$52e4945e96bd2aa0,
    $e80aa4d4aac5b0dc$export$a8cd23a3cbda9d58,
    $e80aa4d4aac5b0dc$export$151b03356f566603,
    $e80aa4d4aac5b0dc$export$ea0d6ac082b0d636,
    $e80aa4d4aac5b0dc$export$31ac745ab2add7cc,
    $e80aa4d4aac5b0dc$export$353acf28daa75c79,
    $e80aa4d4aac5b0dc$export$25627f012b21b0b9,
    $e80aa4d4aac5b0dc$export$8af4cb794979f60d,
    $e80aa4d4aac5b0dc$export$5592ab836d562168,
    $e80aa4d4aac5b0dc$export$842eb4236828ac9,
    $e80aa4d4aac5b0dc$export$42d6a8740fd42e58,
    $e80aa4d4aac5b0dc$export$a7186e5a73395db4,
    $e80aa4d4aac5b0dc$export$8fbcfe84dc845d17
];
const $e80aa4d4aac5b0dc$export$2b8aeda236486576 = 'edit';
const $e80aa4d4aac5b0dc$export$c41ce1ec1ea6e73d = 'view';
const $e80aa4d4aac5b0dc$export$b37d58c3ed77c139 = 'create';
const $e80aa4d4aac5b0dc$export$ab94dbd1d02ac251 = 'contextConfig';
const $e80aa4d4aac5b0dc$export$b6a67a3131c6c48d = 'none';
const $e80aa4d4aac5b0dc$export$b75dc2bfd20898fe = 5;
const $e80aa4d4aac5b0dc$export$8e96118a698216cb = 'native';
const $e80aa4d4aac5b0dc$export$9b72a8e9b92658fb = 'basic';
const $e80aa4d4aac5b0dc$export$2d6539e7d0553ae7 = 'blank';
const $e80aa4d4aac5b0dc$export$ecbd7135d66cb322 = 'unknownSource';
const $e80aa4d4aac5b0dc$export$61d882aa7aba51c = 'global-issue-create';
const $e80aa4d4aac5b0dc$export$46cb92762d68a048 = 'issue-view';
const $e80aa4d4aac5b0dc$export$fe90e46aea58e30b = 'navigation';
const $e80aa4d4aac5b0dc$export$c5ccbdb9893f2a6a = 'full-page-app';
const $e80aa4d4aac5b0dc$export$eae46a3c13473a8d = 'router';
const $e80aa4d4aac5b0dc$export$ac11ee191d09688f = 'legacy';
const $e80aa4d4aac5b0dc$export$4346e4e240c84319 = 'organization-panel';
const $e80aa4d4aac5b0dc$export$d719bb340dc354e4 = 'assets-import-type';
const $e80aa4d4aac5b0dc$export$4b6228758e800433 = 'jira';
const $e80aa4d4aac5b0dc$export$70495c8cc141a7a4 = 'jsm';
const $e80aa4d4aac5b0dc$export$bc3d408418fdf9d2 = 'cmdb';
const $e80aa4d4aac5b0dc$export$a48dade1864725a = {
    jiraBacklogAction: [],
    jiraBoardAction: [],
    jiraSprintAction: [],
    jiraIssueAction: [],
    jiraIssueContext: [],
    jiraIssueGlance: [],
    jiraIssuePanel: [],
    jiraIssueNavigatorAction: [],
    jiraIssueActivity: [],
    jiraIssueViewBackgroundScript: [],
    jiraCustomField: [],
    jiraCustomFieldType: [],
    jiraUiModifications: [],
    jiraAdminPage: [],
    jiraGlobalPage: [],
    jiraPersonalSettingsPage: [],
    jiraProjectPage: [],
    jiraProjectSettingsPage: [],
    jiraDashboardBackgroundScript: [],
    jiraDashboardGadget: [],
    jiraServiceManagementQueuePage: [],
    jiraServiceManagementOrganizationPanel: [],
    jiraServiceManagementAssetsImportType: [],
    jiraWorkflowValidator: [],
    jiraWorkflowCondition: [],
    jiraWorkflowPostFunction: [],
    jiraCommand: []
};
/**
 * The above EMPTY_EXTENSIONS_OBJECT sometimes is mutated.
 * @see getEmptyExtensionsObject
 */ const $e80aa4d4aac5b0dc$var$STABLE_EMPTY_EXTENSIONS_OBJECT = {
    ...$e80aa4d4aac5b0dc$export$a48dade1864725a
};
const $e80aa4d4aac5b0dc$export$218a328f66b86f7d = ()=>({
        ...$e80aa4d4aac5b0dc$var$STABLE_EMPTY_EXTENSIONS_OBJECT
    });
const $e80aa4d4aac5b0dc$export$3193d714ab54ee26 = 'ari:cloud:ecosystem::extension/';
const $e80aa4d4aac5b0dc$export$df7774a415710cce = 'com.atlassian.forge:';
const $e80aa4d4aac5b0dc$export$51ab2784839ce348 = `${$e80aa4d4aac5b0dc$export$df7774a415710cce}${$e80aa4d4aac5b0dc$export$3193d714ab54ee26}`;

});

parcelRegister("iVaKa", function(module, exports) {

$parcel$export(module.exports, "fetchModules", () => $1b1a9656c7bb4ee4$export$24d8e11b15325c53);

var $gPjkL = parcelRequire("gPjkL");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $bPtOr = parcelRequire("bPtOr");

var $dYScp = parcelRequire("dYScp");

var $hBuqR = parcelRequire("hBuqR");

var $bOLUk = parcelRequire("bOLUk");

var $k2DRb = parcelRequire("k2DRb");

var $5yJb9 = parcelRequire("5yJb9");

var $gPjkL = parcelRequire("gPjkL");

var $d5W4H = parcelRequire("d5W4H");

var $h8M2b = parcelRequire("h8M2b");

var $ioGTN = parcelRequire("ioGTN");
const $1b1a9656c7bb4ee4$export$24d8e11b15325c53 = async (params)=>{
    const { types: types, cloudId: cloudId, isAnonymous: isAnonymous, source: source = (0, $k2DRb.SOURCE_UNKNOWN) } = params;
    if (!(0, $d5W4H.canFetchForgeModules)({
        cloudId: cloudId,
        isAnonymous: isAnonymous
    })) return (0, $h8M2b.toMappedExtensions)(types, []);
    try {
        const extensions = await (0, $dYScp.measureExecutionTimeMetrics)(()=>$1b1a9656c7bb4ee4$export$9f9fdbce0829073d(params));
        if (Math.random() * 100 < (0, $hBuqR.FORGE_SAMPLING_RATE)) (0, $bOLUk.fireInitializationFetchFinishedEvent)(source);
        return (0, $h8M2b.toMappedExtensions)(types, extensions);
    } catch (error) {
        const errorType = (0, $bPtOr.getErrorType)(error);
        (0, $bOLUk.fireInitializationFetchFailedEvent)(source, {
            isSSR: false,
            errorType: errorType,
            error: error
        });
        if ($1b1a9656c7bb4ee4$export$458cbcb6374269d2.includes(errorType)) return (0, $h8M2b.toMappedExtensions)(types, []);
        throw error;
    }
};
function $1b1a9656c7bb4ee4$export$9f9fdbce0829073d(props) {
    const { cloudId: cloudId, types: types, context: context, includeHidden: includeHidden, includeScopes: includeScopes = false } = props;
    if (types.length === 0) throw new Error('No modules to fetch provided');
    const operationName = (0, $gPjkL.default).params.name;
    const { stopGraphQLErrorTracking: stopGraphQLErrorTracking, getGraphQLError: getGraphQLError } = (0, $ioGTN.trackGraphQLErrors)(operationName);
    let extensions;
    return new Promise((resolve, reject)=>{
        const subscription = (0, $8Uumt.fetchQuery)((0, $5yJb9.default)(), /* eslint-disable @atlassian/relay/unused-fields */ (0, $gPjkL.default), /* eslint-enable @atlassian/relay/unused-fields */ {
            cloudId: cloudId,
            context: context,
            types: types,
            includeHidden: includeHidden,
            includeScopes: includeScopes,
            includeUserAccess: (0, $4R6GH.fg)('forge_query_include_user_access'),
            includeUserAccessEnabledForge: (0, $4R6GH.fg)('forge_query_include_user_access_enabled'),
            includeModuleId: (0, $4R6GH.fg)('forge-extensions-module-id-for-relay')
        }).subscribe({
            next: (response)=>{
                stopGraphQLErrorTracking();
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const responseExtensions = response.jira?.forge?.extensions;
                // @ts-expect-error - TODO: new genereated type is incompatible with it
                extensions = responseExtensions?.concat().map((ext)=>({
                        ...ext,
                        moduleId: ext.moduleId ?? null
                    })) || null;
            },
            error: (error)=>{
                stopGraphQLErrorTracking();
                reject(error);
                subscription.unsubscribe();
            },
            complete: ()=>{
                // If there is a GraphQL error and extensions are `null`, it means a critical error has happened, and we have to reject the promise.
                // However, if the list of extensions is present in the response, it shouldn't be considered an error.
                const graphQLError = getGraphQLError();
                if (graphQLError) extensions != null ? resolve(extensions || []) : reject(graphQLError);
                else resolve(extensions || []);
                subscription.unsubscribe();
            }
        });
    });
}
const $1b1a9656c7bb4ee4$export$458cbcb6374269d2 = [
    (0, $bPtOr.FAILED_TO_FETCH),
    (0, $bPtOr.AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS),
    (0, $bPtOr.DATA_CLASSIFICATION_NO_ACCESS)
];

});
parcelRegister("gPjkL", function(module, exports) {

$parcel$export(module.exports, "default", () => $13cd104237d48c31$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7cbef78f2ae550694049980b5e2cc2aa>>
 * @relayHash 2d6560d84aa6596469b9dd81b24ef07e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f9d8d592fe8b8e5de669d8f6a1ab2f3e55c3e8c061caa1d6ba7456c8f2695cc9
const $13cd104237d48c31$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "context"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeHidden"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeModuleId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeScopes"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeUserAccess"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeUserAccessEnabledForge"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "types"
    }, v8 = {
        "kind": "ScalarField",
        "name": "type"
    }, v9 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraForgeQuery",
                    "kind": "LinkedField",
                    "name": "forge",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "context",
                                    "variableName": "context"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "includeHidden",
                                    "variableName": "includeHidden"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "types",
                                    "variableName": "types"
                                }
                            ],
                            "concreteType": "JiraForgeExtension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": [
                                {
                                    "condition": "includeHidden",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hiddenBy"
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeScopes",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopes"
                                        }
                                    ]
                                },
                                v8 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "condition": "includeModuleId",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "moduleId"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "environmentId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "environmentKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "environmentType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "installationId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "appVersion"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "consentUrl"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "properties"
                                },
                                {
                                    "condition": "includeUserAccess",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraUserAppAccess",
                                            "kind": "LinkedField",
                                            "name": "userAccess",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasAccess"
                                                },
                                                {
                                                    "condition": "includeUserAccessEnabledForge",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "enabled"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraForgeAppEgressDeclaration",
                                    "kind": "LinkedField",
                                    "name": "egress",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "addresses"
                                        },
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "category"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "inScopeEUD"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraForgeInstallationConfigExtension",
                                    "kind": "LinkedField",
                                    "name": "installationConfig",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraForgeExtensionLicense",
                                    "kind": "LinkedField",
                                    "name": "license",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "active"
                                        },
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "supportEntitlementNumber"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "trialEndDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "subscriptionEndDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEvaluation"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "billingPeriod"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "ccpEntitlementId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "ccpEntitlementSlug"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "capabilitySet"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "fetchModulesV2Query",
            "selections": v9 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v7 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "fetchModulesV2Query",
            "selections": v9 /*: any*/ 
        },
        "params": {
            "id": "f9d8d592fe8b8e5de669d8f6a1ab2f3e55c3e8c061caa1d6ba7456c8f2695cc9",
            "metadata": {},
            "name": "fetchModulesV2Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$13cd104237d48c31$var$node.hash = "2cdc4603de194c6335a878d1d75105d1";
var $13cd104237d48c31$export$2e2bcd8739ae039 = $13cd104237d48c31$var$node;

});

parcelRegister("bPtOr", function(module, exports) {

$parcel$export(module.exports, "DATA_CLASSIFICATION_NO_ACCESS", () => $e4bddb38a31390d9$export$23de3198bfe70090);
$parcel$export(module.exports, "FAILED_TO_FETCH", () => $e4bddb38a31390d9$export$f52aa41ccd776f01);
$parcel$export(module.exports, "AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS", () => $e4bddb38a31390d9$export$31d2ab0be67934f0);
$parcel$export(module.exports, "INVOKE_VALUE_FUNCTION_FAILED", () => $e4bddb38a31390d9$export$89a175d4190df42e);
$parcel$export(module.exports, "userConsentErrorRegex", () => $e4bddb38a31390d9$export$dddade71b333c01d);
$parcel$export(module.exports, "getErrorType", () => $e4bddb38a31390d9$export$e19f9f08a6d79fd2);


var $fZneA = parcelRequire("fZneA");

var $bvblX = parcelRequire("bvblX");

var $bCf8q = parcelRequire("bCf8q");
const $e4bddb38a31390d9$var$commonErrors = {
    MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
    OPERATION_ABORTED: 'The operation was aborted. ',
    CANCELLED: 'cancelled',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    TIMEOUT: 'The request timed out.',
    AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
    GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504'
};
const $e4bddb38a31390d9$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
const $e4bddb38a31390d9$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
const $e4bddb38a31390d9$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
const $e4bddb38a31390d9$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
const $e4bddb38a31390d9$export$89a175d4190df42e = 'Invoke value functions failed:';
const $e4bddb38a31390d9$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
const $e4bddb38a31390d9$export$8a5d666d6e5b82fc = (error)=>{
    // React loosely lazy chunk load error type
    if ((0, $bCf8q.isLoaderError)(error) || typeof error === 'object' && error.name === 'ChunkLoadError') return true;
    // Other chunk load error types
    // In theory it should be handled by a common isClientFetchError, but it ignores TypeError error types
    const KNOWN_NETWORK_ERRORS = [
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        'Importing a module script failed',
        'Cannot find module'
    ];
    const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
            // are sometimes wrapped to provide additional context, e.g.
            // "Something went wrong: ${error.message}"
            message.includes(networkErrorMessage));
    return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
};
const $e4bddb38a31390d9$export$e19f9f08a6d79fd2 = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    const isTimeoutError = (timedOutResource)=>Boolean(typeof error === 'object' && error.name === 'TimeoutError' && error.stack?.includes(timedOutResource));
    if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
    const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
    if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
    const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
    const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
    if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $e4bddb38a31390d9$export$7a1bd8c001e7e9c;
    const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
    if (serverErrorRegex.test(message)) {
        const match = message.match(serverErrorRegex);
        const statusCode = match ? match[1] : 'NO_STATUS_CODE';
        return `ERROR_SERVER_RESPONSE_${statusCode}`;
    }
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    // Tracked GraphQL errors contain useful info about internal errors like status codes
    // We want to categorize them more precisely, because some error types aren't SLO critical.
    if (error instanceof (0, $bvblX.TrackedGraphQLError)) {
        if (error.statusCode && error.statusCode >= 400) return error.statusCode === 429 ? $e4bddb38a31390d9$export$7a1bd8c001e7e9c : `ERROR_SERVER_RESPONSE_${error.statusCode}`;
        return 'TRACKED_GRAPHQL_ERROR';
    }
    const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
    const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
    if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $e4bddb38a31390d9$export$23de3198bfe70090;
    // Add here errors related to a broken app configuration/manifest
    if (message.startsWith('Function definition is invalid.') || /Extension ".*" could not be invoked as it does not reference a function or an endpoint/i.test(message)) return 'APP_DEV_ERROR';
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ($e4bddb38a31390d9$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
    const appValueFunction = new RegExp("The app's value function failed", 'i');
    const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
    const invokeValueFunctionFailed = new RegExp($e4bddb38a31390d9$export$89a175d4190df42e, 'i');
    /**
   * In case when we get bad request(400) from the BE it should be treated as an app error as there
   * are many ways to fail the value function
   */ const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === (0, $3cd8a0ece36fbae5$export$9de493bcd9b1d977);
    /**
   * In case when we get request timeout(408) from the XIS invocation it should be treated as an app error.
   * Error occurs when invocation exceeds 25s threshold e.g.too long time to execute request to external API
   */ const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === (0, $3cd8a0ece36fbae5$export$fa405bbf47d510e2);
    if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
    /*
   * 	Whole message:
   *	Fetching formatted value after edit failed: FetchError: Fetch call failed with status code: 429
   */ const valueFunctionEditRateLimitedRegex = new RegExp('Fetch call failed with status code: 429', 'i');
    /*
   * 	Whole message:
   *	Invoke value functions failed: Error server response: 429
   */ const valueFunctionInvokeRateLimitedRegex = new RegExp('Error server response: 429', 'i');
    if (valueFunctionEditRateLimitedRegex.test(message) || valueFunctionInvokeRateLimitedRegex.test(message)) return $e4bddb38a31390d9$export$7a1bd8c001e7e9c;
    // The full message states:
    // Extension "extension name" does not exist, the app may have changed or no longer be installed in this context
    const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
    if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
    // In case of React error message:
    // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
    const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
    if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
    if ($e4bddb38a31390d9$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
    if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
    if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
    if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
    const entry = Object.entries($e4bddb38a31390d9$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    if (entry) return entry[0];
    if ((0, $fZneA.isClientFetchError)(error)) return $e4bddb38a31390d9$export$f52aa41ccd776f01;
    if (error != null && 'statusCode' in error && error.statusCode === 429) return 'RATE_LIMITING';
    return 'OTHER';
};

});
const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;

parcelRegister("bvblX", function(module, exports) {

$parcel$export(module.exports, "TrackedGraphQLError", () => $b1b2278e9c04b70b$export$f2062ad173e74c75);
class $b1b2278e9c04b70b$export$f2062ad173e74c75 extends Error {
    constructor(errorMessage, errors, traceIds){
        super(errorMessage), this.errorMessage = errorMessage, this.errors = errors, this.traceIds = traceIds;
        this.errors = errors;
        // Get first trace id
        this.traceId = traceIds?.[0];
        // Get first status code
        this.statusCode = errors?.map((graphQLError)=>graphQLError && 'extensions' in graphQLError ? graphQLError?.extensions?.statusCode : null).filter(Boolean)?.[0];
        // Combine error messages
        this.message = errors?.map((graphQLError)=>graphQLError?.message).filter(Boolean).join('; ') ?? errorMessage;
    }
}

});


parcelRegister("dYScp", function(module, exports) {

$parcel$export(module.exports, "measureExecutionTimeMetrics", () => $d79aabebae5ffeb3$export$a859f6866f4653e0);

var $7Jxgt = parcelRequire("7Jxgt");

var $hBuqR = parcelRequire("hBuqR");

var $8kVg1 = parcelRequire("8kVg1");
const $d79aabebae5ffeb3$export$a859f6866f4653e0 = async (action)=>{
    const concurrentId = (0, $7Jxgt.v4)();
    const shouldSendTimeMetric = Math.random() * 100 < (0, $hBuqR.FORGE_SAMPLING_RATE);
    try {
        if (shouldSendTimeMetric) (0, $8kVg1.forgeModulesConcurrentFetchTime)(concurrentId).start({
            startTime: performance.now()
        });
        const result = await action();
        if (shouldSendTimeMetric) (0, $8kVg1.forgeModulesConcurrentFetchTime)(concurrentId).stop({
            stopTime: performance.now()
        });
        return result;
    } catch (error) {
        if (shouldSendTimeMetric) (0, $8kVg1.forgeModulesConcurrentFetchTime)(concurrentId).cancel();
        throw error;
    }
};

});
parcelRegister("hBuqR", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME_GASV3", () => $bbc089ab376d4a7b$export$f892f621fb508154);
$parcel$export(module.exports, "MODULE_TYPE_TRIGGER", () => $bbc089ab376d4a7b$export$ed63b053e04e26df);
$parcel$export(module.exports, "MODULE_TYPE_EXTENSION", () => $bbc089ab376d4a7b$export$725bacc669333eef);
$parcel$export(module.exports, "FORGE_SAMPLING_RATE", () => $bbc089ab376d4a7b$export$d920cee73ec094d0);
$parcel$export(module.exports, "PERFORMANCE_KEYS", () => $bbc089ab376d4a7b$export$f048d91ccaf92408);
$parcel$export(module.exports, "UI_ACTIONS", () => $bbc089ab376d4a7b$export$2b7367f125154866);
$parcel$export(module.exports, "OPERATIONAL_ACTIONS", () => $bbc089ab376d4a7b$export$42bcca5cae2ce90b);
$parcel$export(module.exports, "TRACK_ACTIONS", () => $bbc089ab376d4a7b$export$2af0438304d7c4b2);
// TODO ARKEN-359: uniformise GASv3/BM3 keys to use kebab lowercase
const $bbc089ab376d4a7b$export$f892f621fb508154 = 'jiraForgeUi';
const $bbc089ab376d4a7b$export$273f5980517336e2 = 'jiraforgeui';
const $bbc089ab376d4a7b$export$ed63b053e04e26df = 'trigger';
const $bbc089ab376d4a7b$export$725bacc669333eef = 'extension';
const $bbc089ab376d4a7b$export$d920cee73ec094d0 = 10;
const $bbc089ab376d4a7b$export$f048d91ccaf92408 = {
    FORGE_MODULES: {
        FETCH_TIME: `${$bbc089ab376d4a7b$export$273f5980517336e2}.forge-modules.fetch-time`,
        LOAD_TIME: `${$bbc089ab376d4a7b$export$273f5980517336e2}.forge-modules.load-time`
    },
    REAL_TIME_ISSUE_EVENTS: {
        INVOKE_TIME: `${$bbc089ab376d4a7b$export$273f5980517336e2}.real-time-issue-events.invoke-time`
    },
    MARKS: {
        TTI_START: 'ECOSYSTEM_FORGE_MODULE_TTI_BEGIN_MARK',
        TTI_END: 'ECOSYSTEM_FORGE_MODULE_TTI_END_MARK',
        ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END'
    }
};
const $bbc089ab376d4a7b$export$2b7367f125154866 = {
    CLICKED: 'clicked',
    SELECTED: 'selected',
    CANCELED: 'canceled',
    ACTION_CLICKED: 'action clicked',
    COLLAPSE_EXPAND_CLICKED: 'collapse-expand clicked',
    PIN_UNPIN_CLICKED: 'pin-unpin clicked',
    REMOVE_CLICKED: 'remove clicked'
};
const $bbc089ab376d4a7b$export$42bcca5cae2ce90b = {
    FAILED: 'failed',
    INITIALIZED: 'initialized',
    EDIT_FAILED: 'edit failed',
    ACTION_FAILED: 'action failed',
    SAVE_FAILED: 'save failed',
    REMOVE_FAILED: 'remove failed',
    UPDATE_FAILED: 'update failed'
};
const $bbc089ab376d4a7b$export$2af0438304d7c4b2 = {
    EDITED: 'edited',
    SAVED: 'saved',
    REMOVED: 'removed',
    ACTION_SUCCEED: 'action succeed',
    UPDATE_SUCCEED: 'update succeed'
};

});

parcelRegister("8kVg1", function(module, exports) {

$parcel$export(module.exports, "forgeModulesConcurrentFetchTime", () => $f1fed22795d0c676$export$c3d8833fbea3e976);
$parcel$export(module.exports, "forgeModulesConcurrentLoadTime", () => $f1fed22795d0c676$export$292f3b557281044f);
$parcel$export(module.exports, "realTimeIssueEventInvokeTime", () => $f1fed22795d0c676$export$89ace7e2bb7d7685);
$parcel$export(module.exports, "measureInitialPageLoadAsyncResourcesTiming", () => $f1fed22795d0c676$export$94f65f3b2556df23);
$parcel$export(module.exports, "markAdditionalTimingsFromWindowPerformance", () => $f1fed22795d0c676$export$116d5e25caf0018d);
$parcel$export(module.exports, "customFieldPageSegmentLoadMetric", () => $f1fed22795d0c676$export$3bd38623c2543fc0);
$parcel$export(module.exports, "customFieldInteractionMetric", () => $f1fed22795d0c676$export$a318f99472db73c8);

var $dGrdR = parcelRequire("dGrdR");

var $6RCeq = parcelRequire("6RCeq");

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");

var $hBuqR = parcelRequire("hBuqR");
const $f1fed22795d0c676$export$c3d8833fbea3e976 = (0, $dGrdR.metrics).concurrent.custom({
    key: (0, $hBuqR.PERFORMANCE_KEYS).FORGE_MODULES.FETCH_TIME
});
const $f1fed22795d0c676$export$292f3b557281044f = (0, $dGrdR.metrics).concurrent.custom({
    key: (0, $hBuqR.PERFORMANCE_KEYS).FORGE_MODULES.LOAD_TIME
});
const $f1fed22795d0c676$export$89ace7e2bb7d7685 = new (0, $duUGa.UFOExperience)((0, $hBuqR.PERFORMANCE_KEYS).REAL_TIME_ISSUE_EVENTS.INVOKE_TIME, {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult
});
async function $f1fed22795d0c676$export$94f65f3b2556df23(startMark, endMark, fn) {
    if (false || (0, $6RCeq.default).getEntriesByName(startMark).length > 0 || (0, $6RCeq.default).getEntriesByName(endMark).length > 0) return fn();
    (0, $6RCeq.default).mark(startMark);
    const result = await fn();
    (0, $6RCeq.default).mark(endMark);
    return result;
}
const $f1fed22795d0c676$export$116d5e25caf0018d = (metric, additionalTimings)=>{
    additionalTimings.flatMap(({ startMark: startMark, endMark: endMark, cleanStart: cleanStart, cleanEnd: cleanEnd })=>[
            ...(0, $6RCeq.default).getEntriesByName(startMark).map((entry)=>({
                    name: entry.name,
                    startTime: entry.startTime,
                    cleanStart: cleanStart,
                    cleanEnd: undefined
                })),
            ...(0, $6RCeq.default).getEntriesByName(endMark).map((entry)=>({
                    name: entry.name,
                    startTime: entry.startTime,
                    cleanStart: undefined,
                    cleanEnd: cleanEnd
                }))
        ]).forEach(({ name: name, startTime: startTime, cleanStart: cleanStart, cleanEnd: cleanEnd })=>{
        metric.mark(name, startTime);
        if (cleanStart || cleanEnd) (0, $6RCeq.default).clearMarks(name);
    });
};
const $f1fed22795d0c676$export$3bd38623c2543fc0 = (additionalTimings = [])=>(0, $dGrdR.metrics).pageSegmentLoad({
        key: 'forge-custom-field',
        timings: [
            ...additionalTimings,
            {
                key: 'tti',
                startMark: (0, $hBuqR.PERFORMANCE_KEYS).MARKS.TTI_START,
                endMark: (0, $hBuqR.PERFORMANCE_KEYS).MARKS.TTI_END
            }
        ]
    });
const $f1fed22795d0c676$export$a318f99472db73c8 = (additionalTimings = [])=>(0, $dGrdR.metrics).interaction({
        key: 'forge-custom-field',
        timings: [
            ...additionalTimings
        ]
    });

});


parcelRegister("bOLUk", function(module, exports) {

$parcel$export(module.exports, "fireInitializationFetchFinishedEvent", () => $2f4555f4bd0f0eef$export$132ca822850e455f);
$parcel$export(module.exports, "fireInitializationFetchFailedEvent", () => $2f4555f4bd0f0eef$export$b5ca88b1053f1ad0);
$parcel$export(module.exports, "fireInitializationIssueViewFinishedEvent", () => $2f4555f4bd0f0eef$export$e914f7df1e4ad79b);
$parcel$export(module.exports, "fireInitializationIssueViewFailedEvent", () => $2f4555f4bd0f0eef$export$b274c658390b491b);

var $6yg2S = parcelRequire("6yg2S");

var $8uOa6 = parcelRequire("8uOa6");
const $2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS = {
    STARTED: 'started',
    FINISHED: 'finished',
    FAILED: 'failed'
};
const $2f4555f4bd0f0eef$export$917d0643b0111a02 = (0, $6yg2S.toEventId)('issueViewInitialization');
const $2f4555f4bd0f0eef$export$43e875fd63e64525 = (0, $6yg2S.toEventId)('fetchModulesInitialization');
const $2f4555f4bd0f0eef$export$132ca822850e455f = (source, attributes)=>(0, $8uOa6.fireInitializationEvent)($2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS.FINISHED, {
        id: $2f4555f4bd0f0eef$export$43e875fd63e64525,
        source: source,
        attributes: attributes
    });
const $2f4555f4bd0f0eef$export$b5ca88b1053f1ad0 = (source, attributes)=>(0, $8uOa6.fireInitializationEvent)($2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS.FAILED, {
        id: $2f4555f4bd0f0eef$export$43e875fd63e64525,
        source: source,
        attributes: attributes
    });
const $2f4555f4bd0f0eef$export$e914f7df1e4ad79b = (source, attributes)=>(0, $8uOa6.fireInitializationEvent)($2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS.FINISHED, {
        id: $2f4555f4bd0f0eef$export$917d0643b0111a02,
        source: source,
        attributes: attributes
    });
const $2f4555f4bd0f0eef$export$b274c658390b491b = (source, attributes)=>(0, $8uOa6.fireInitializationEvent)($2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS.FAILED, {
        id: $2f4555f4bd0f0eef$export$917d0643b0111a02,
        source: source,
        attributes: attributes
    });

});
parcelRegister("6yg2S", function(module, exports) {

$parcel$export(module.exports, "toEventId", () => $cb46d7d052e3d68d$export$75e84ef5a3771f9a);
const $cb46d7d052e3d68d$export$75e84ef5a3771f9a = (value)=>value;

});

parcelRegister("8uOa6", function(module, exports) {

$parcel$export(module.exports, "fireOperationalEvent", () => $73635d33815c9f98$export$a1fb57756f0de62b);
$parcel$export(module.exports, "fireUiEvent", () => $73635d33815c9f98$export$bed7f228c94e5f2a);
$parcel$export(module.exports, "fireTrackEvent", () => $73635d33815c9f98$export$574d2f19a52d67ca);
$parcel$export(module.exports, "fireInitializationEvent", () => $73635d33815c9f98$export$390a62413962e4f0);

var $fjcgS = parcelRequire("fjcgS");

var $hBuqR = parcelRequire("hBuqR");

var $6MtPV = parcelRequire("6MtPV");

var $7yD9b = parcelRequire("7yD9b");

var $eGXs2 = parcelRequire("eGXs2");
const $73635d33815c9f98$var$createAnalyticsProps = ({ id: id, source: // Since source is required in sendOperationalEvent and sendUIEvent we need to pass here a fallback
// in case source is not provided
source = 'unknownSource', action: action, attributes: attributes })=>({
        actionSubject: `${0, $hBuqR.PACKAGE_NAME_GASV3}.${id}`,
        attributes: (0, $6MtPV.createAttributes)(attributes),
        source: source,
        action: action
    });
const $73635d33815c9f98$var$getAnalyticsClient = async ()=>(await (0, $fjcgS.getAnalyticsWebClientPromise)()).getInstance();
const $73635d33815c9f98$var$sendOperationalEvent = async (props)=>(await $73635d33815c9f98$var$getAnalyticsClient()).sendOperationalEvent($73635d33815c9f98$var$createAnalyticsProps(props));
const $73635d33815c9f98$var$sendUiEvent = async (props)=>(await $73635d33815c9f98$var$getAnalyticsClient()).sendUIEvent($73635d33815c9f98$var$createAnalyticsProps(props));
const $73635d33815c9f98$var$sendTrackEvent = async (props)=>(await $73635d33815c9f98$var$getAnalyticsClient()).sendTrackEvent($73635d33815c9f98$var$createAnalyticsProps(props));
const $73635d33815c9f98$export$a1fb57756f0de62b = async (action, { source: source, ...eventProps })=>$73635d33815c9f98$var$sendOperationalEvent({
        ...eventProps,
        source: (0, $6MtPV.parseSource)(source),
        action: action
    });
const $73635d33815c9f98$export$bed7f228c94e5f2a = async (action, { source: source, ...eventProps })=>$73635d33815c9f98$var$sendUiEvent({
        ...eventProps,
        source: (0, $6MtPV.parseSource)(source),
        action: action
    });
const $73635d33815c9f98$export$574d2f19a52d67ca = async (action, { source: source, ...eventProps })=>$73635d33815c9f98$var$sendTrackEvent({
        ...eventProps,
        source: (0, $6MtPV.parseSource)(source),
        action: action
    });
const $73635d33815c9f98$export$390a62413962e4f0 = async (action, { id: id, attributes: attributes, source: source })=>Promise.all([
        $73635d33815c9f98$export$a1fb57756f0de62b(action, {
            id: id,
            attributes: attributes,
            source: source
        }),
        attributes?.error && (0, $7yD9b.logError)((0, $7yD9b.ANALYTICS_UTIL), `Something went wrong with Forge initialization, isSynthetic=${(0, $eGXs2.isSynthetic)().toString()}, id=${id}, source=${(0, $6MtPV.parseSource)(source)}, action=${action}`, attributes.error) || Promise.resolve()
    ]);

});
parcelRegister("6MtPV", function(module, exports) {

$parcel$export(module.exports, "parseSource", () => $31dca5b0e1651a2f$export$e98201ef9a88ba70);
$parcel$export(module.exports, "createAttributes", () => $31dca5b0e1651a2f$export$c7c9603a6b1fd815);

var $84Tib = parcelRequire("84Tib");

var $j8DrX = parcelRequire("j8DrX");

var $9uiWt = parcelRequire("9uiWt");

var $bPtOr = parcelRequire("bPtOr");

var $eGXs2 = parcelRequire("eGXs2");
const $31dca5b0e1651a2f$export$e98201ef9a88ba70 = (source)=>source != null ? source.toString() : 'unknownSource';
const $31dca5b0e1651a2f$export$78c6267359db7e73 = (error)=>({
        ...error,
        stack: error.stack,
        message: error?.message
    });
const $31dca5b0e1651a2f$export$c7c9603a6b1fd815 = (rawAttributes)=>{
    const attributes = {
        isSynthetic: (0, $eGXs2.isSynthetic)(),
        isOverridingFragments: (0, $9uiWt.isOverridingFragments)(),
        isSSR: false,
        shard: (0, $j8DrX.default)('ajs-shard') || '',
        region: (0, $j8DrX.default)('ajs-region') || ''
    };
    if (rawAttributes) {
        const { source: source, error: error, hasForgeAccess: hasForgeAccess } = rawAttributes;
        if (source) attributes.source = $31dca5b0e1651a2f$export$e98201ef9a88ba70(source);
        if (error) {
            attributes.error = $31dca5b0e1651a2f$export$78c6267359db7e73(error);
            attributes.errorType = (0, $bPtOr.getErrorType)(error);
        }
        if ((0, (/*@__PURE__*/$parcel$interopDefault($84Tib)))(hasForgeAccess)) attributes.hasForgeAccess = hasForgeAccess;
    }
    return {
        ...rawAttributes,
        ...attributes
    };
};

});
parcelRegister("9uiWt", function(module, exports) {

$parcel$export(module.exports, "isOverridingFragments", () => $c677f4c9cc5e982f$export$1d1321d2b374d697);
const $c677f4c9cc5e982f$export$1d1321d2b374d697 = ()=>{
    if (typeof window !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+|MRJF-BB\d+-\d+)$/.test(window?.BUILD_KEY);
    if (typeof globalThis !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+|MRJF-BB\d+-\d+)$/.test(globalThis.BUILD_KEY);
    return false;
};

});

parcelRegister("eGXs2", function(module, exports) {

$parcel$export(module.exports, "isSynthetic", () => $58ae13ec31f88266$export$947749d756ccb0a);

var $4R6GH = parcelRequire("4R6GH");

var $j8DrX = parcelRequire("j8DrX");
const $58ae13ec31f88266$export$947749d756ccb0a = ()=>// Filter out synthetic tests using all known ways
    (0, $j8DrX.default)('ajs-is-synthetic') === 'true' || (0, $4R6GH.fg)('forge_ui_synthetic_check');

});


parcelRegister("7yD9b", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_UTIL", () => $187fc325525eefe3$export$d1e4f308040bb0d5);
$parcel$export(module.exports, "CUSTOM_FIELD_OBJECT_TYPE", () => $187fc325525eefe3$export$36f315a5c6daf40b);
$parcel$export(module.exports, "logError", () => $187fc325525eefe3$export$58da9968c3170cb1);

var $2YZCu = parcelRequire("2YZCu");

var $hBuqR = parcelRequire("hBuqR");
const $187fc325525eefe3$export$e31edcd35abe3bb1 = 'environment-mapping';
const $187fc325525eefe3$export$d1e4f308040bb0d5 = 'analytics';
const $187fc325525eefe3$export$36f315a5c6daf40b = 'custom-field-object-type';
const $187fc325525eefe3$export$6ee8198f29fffdb4 = {
    [$187fc325525eefe3$export$d1e4f308040bb0d5]: `${(0, $hBuqR.PACKAGE_NAME_GASV3)}.error.utils.analytics`,
    [$187fc325525eefe3$export$e31edcd35abe3bb1]: `${(0, $hBuqR.PACKAGE_NAME_GASV3)}.error.utils.environment-mapping`,
    [$187fc325525eefe3$export$36f315a5c6daf40b]: `${(0, $hBuqR.PACKAGE_NAME_GASV3)}.error.custom-field.object-type`
};
const $187fc325525eefe3$export$58da9968c3170cb1 = (key, message, event)=>{
    (0, $2YZCu.default).safeErrorWithoutCustomerData($187fc325525eefe3$export$6ee8198f29fffdb4[key], message, event);
};

});



parcelRegister("5yJb9", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dfb67cb8d2ba29a$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/relay-runtime

var $eiowN = parcelRequire("eiowN");

var $aWXMn = parcelRequire("aWXMn");
let $0dfb67cb8d2ba29a$var$relayEnvironment;
function $0dfb67cb8d2ba29a$export$2e2bcd8739ae039() {
    if (!$0dfb67cb8d2ba29a$var$relayEnvironment) {
        const environmentConfig = (0, $aWXMn.getRelayEnvironmentConfig)();
        $0dfb67cb8d2ba29a$var$relayEnvironment = new (0, $eiowN.Environment)(environmentConfig);
    }
    return $0dfb67cb8d2ba29a$var$relayEnvironment;
}

});
parcelRegister("aWXMn", function(module, exports) {

$parcel$export(module.exports, "getRelayEnvironmentConfig", () => $eb7981c11bea2531$export$a451c85db2d1cda3);

var $4XQuR = parcelRequire("4XQuR");

var $d89yU = parcelRequire("d89yU");

var $6LmWt = parcelRequire("6LmWt");
const $eb7981c11bea2531$export$a451c85db2d1cda3 = ()=>(0, $6LmWt.getDefaultRelayEnvironmentConfig)({
        network: (0, $d89yU.getNetwork)(),
        log: (0, $4XQuR.default),
        requiredFieldLogger: $4XQuR.requiredFieldLogger
    });

});
parcelRegister("4XQuR", function(module, exports) {

$parcel$export(module.exports, "requiredFieldLogger", () => $50b0aa0805b37d6d$export$1ab8b98d209afe85);
$parcel$export(module.exports, "default", () => $50b0aa0805b37d6d$export$2e2bcd8739ae039);

var $bFU4G = parcelRequire("bFU4G");

var $2YZCu = parcelRequire("2YZCu");

var $jp5kW = parcelRequire("jp5kW");
const $50b0aa0805b37d6d$var$RELAY_CLIENT_ID = 'AGG';
const $50b0aa0805b37d6d$var$LOG_NAMESPACE = `relay.${$50b0aa0805b37d6d$var$RELAY_CLIENT_ID}.error.graphql`;
const $50b0aa0805b37d6d$var$requests = {};
const $50b0aa0805b37d6d$var$queries = {};
const $50b0aa0805b37d6d$var$resources = {};
const $50b0aa0805b37d6d$var$executes = {};
const $50b0aa0805b37d6d$var$CLEANUP_TIMEOUT = 300000; // 5 minutes
const $50b0aa0805b37d6d$export$1ab8b98d209afe85 = (event)=>{
    (0, $2YZCu.default).safeErrorWithoutCustomerData($50b0aa0805b37d6d$var$LOG_NAMESPACE, '[relay required field error]', {
        kind: event.kind,
        owner: event.owner,
        fieldPath: event.fieldPath,
        message: event.kind === 'relay_resolver.error' ? event.error?.message : null
    });
};
const $50b0aa0805b37d6d$var$getResponseSize = (resp)=>{
    if (resp.data === undefined) return 0;
    try {
        return JSON.stringify(resp.data).length;
    } catch (e) {
        return 0;
    }
};
function $50b0aa0805b37d6d$export$2e2bcd8739ae039(event) {
    if ((0, $jp5kW.default)('relay_log')) return;
    switch(event.name){
        // NETWORK
        case 'network.start':
            {
                const networkStart = performance.now();
                const { networkRequestId: networkRequestId } = event;
                const { name: name } = event.params;
                const requestInfo = $50b0aa0805b37d6d$var$requests[networkRequestId];
                if (requestInfo == null) {
                    const newRequestInfo = {
                        name: name,
                        flushes: [],
                        start: networkStart,
                        networkStart: networkStart
                    };
                    $50b0aa0805b37d6d$var$queries[name] = newRequestInfo;
                    $50b0aa0805b37d6d$var$requests[networkRequestId] = newRequestInfo;
                    setTimeout(()=>{
                        delete $50b0aa0805b37d6d$var$requests[networkRequestId];
                        delete $50b0aa0805b37d6d$var$queries[name];
                    }, $50b0aa0805b37d6d$var$CLEANUP_TIMEOUT);
                } else requestInfo.networkStart = networkStart;
                break;
            }
        case 'network.next':
            {
                const requestInfo = $50b0aa0805b37d6d$var$requests[event.networkRequestId];
                if (requestInfo != null) {
                    const { response: response } = event;
                    const addFlush = (resp)=>{
                        if (resp.data !== null) {
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            const res = resp;
                            const flush = {
                                label: res.label != null ? res.label : 'root',
                                time: performance.now(),
                                size: $50b0aa0805b37d6d$var$getResponseSize(res)
                            };
                            requestInfo.flushes?.push(flush);
                        }
                    };
                    Array.isArray(response) ? response.forEach(addFlush) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    addFlush(response);
                }
                break;
            }
        case 'network.error':
            {
                const info = $50b0aa0805b37d6d$var$requests[event.networkRequestId];
                if (info != null) info.error = event.error;
                break;
            }
        case 'network.info':
            break;
        case 'network.complete':
            {
                const requestInfo = $50b0aa0805b37d6d$var$requests[event.networkRequestId];
                const networkComplete = performance.now();
                if (requestInfo != null) {
                    const size = requestInfo.flushes.map((f)=>f.size).reduce((p, c)=>p + c, 0);
                    requestInfo.size = size;
                    requestInfo.networkComplete = networkComplete;
                    requestInfo.flushes = [];
                    (0, $bFU4G.addSpanToAll)('relay', requestInfo.name, [
                        {
                            name: 'network'
                        }
                    ], requestInfo.start, requestInfo.networkComplete, size);
                }
                break;
            }
        case 'network.unsubscribe':
            break;
        // SUSPENSE
        case 'suspense.fragment':
            break;
        case 'suspense.query':
            break;
        // QUERY
        case 'queryresource.fetch':
            {
                const { node: node } = event.operation.root;
                const fetchStart = performance.now();
                // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                if (node.name != null) {
                    // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                    const { name: name } = node;
                    const requestInfo = $50b0aa0805b37d6d$var$queries[name];
                    if (requestInfo != null) {
                        requestInfo.fetchStart = fetchStart;
                        $50b0aa0805b37d6d$var$resources[event.resourceID] = requestInfo;
                    } else {
                        const newRequestInfo = {
                            name: name,
                            flushes: [],
                            start: fetchStart,
                            fetchStart: fetchStart
                        };
                        $50b0aa0805b37d6d$var$queries[name] = newRequestInfo;
                        $50b0aa0805b37d6d$var$resources[event.resourceID] = newRequestInfo;
                        setTimeout(()=>{
                            // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                            delete $50b0aa0805b37d6d$var$queries[node.name];
                        }, $50b0aa0805b37d6d$var$CLEANUP_TIMEOUT);
                    }
                    setTimeout(()=>{
                        delete $50b0aa0805b37d6d$var$resources[event.resourceID];
                    }, $50b0aa0805b37d6d$var$CLEANUP_TIMEOUT);
                }
                break;
            }
        case 'queryresource.retain':
            {
                const requestInfo = $50b0aa0805b37d6d$var$resources[event.resourceID];
                if (requestInfo != null && event.profilerContext != null) {
                    requestInfo.end = performance.now();
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    const context = event.profilerContext;
                    context?.retainQuery?.(requestInfo);
                }
                break;
            }
        // EXECUTE
        case 'execute.start':
            $50b0aa0805b37d6d$var$executes[event.executeId] = {
                name: event.params.name,
                kind: event.params.operationKind,
                start: performance.now(),
                duration: 0
            };
            break;
        case 'execute.next.start':
            $50b0aa0805b37d6d$var$executes[event.executeId].start = performance.now();
            break;
        case 'execute.next.end':
            {
                const now = performance.now();
                const duration = now - $50b0aa0805b37d6d$var$executes[event.executeId].start;
                $50b0aa0805b37d6d$var$executes[event.executeId].end = now;
                $50b0aa0805b37d6d$var$executes[event.executeId].duration = duration;
                break;
            }
        case 'execute.async.module':
            break;
        case 'execute.error':
            delete $50b0aa0805b37d6d$var$executes[event.executeId];
            break;
        case 'execute.complete':
            {
                const op = $50b0aa0805b37d6d$var$executes[event.executeId];
                if (op != null) {
                    op.end = performance.now();
                    delete $50b0aa0805b37d6d$var$executes[event.executeId];
                }
                break;
            }
        // STORE
        case 'store.publish':
            break;
        case 'store.snapshot':
            break;
        case 'store.restore':
            break;
        case 'store.gc.start':
            break;
        case 'store.gc.end':
            break;
        case 'store.gc.interrupted':
            break;
        // FLUSH
        case 'store.notify.start':
            break;
        case 'store.notify.complete':
            break;
        case 'store.notify.subscription':
            break;
        // ENTRYPOINT
        case 'entrypoint.root.consume':
            break;
        default:
            break;
    }
}

});

parcelRegister("d89yU", function(module, exports) {

$parcel$export(module.exports, "getNetwork", () => $7997274d03790a98$export$7de4970ebfd8206d);

var $eiowN = parcelRequire("eiowN");

var $gIJXH = parcelRequire("gIJXH");

var $k1TrK = parcelRequire("k1TrK");

var $fwvto = parcelRequire("fwvto");
const $7997274d03790a98$export$7de4970ebfd8206d = ()=>{
    if ((0, $fwvto.isSSR)()) (0, $eiowN.Network).create((0, $gIJXH.fetch));
    return (0, $eiowN.Network).create((0, $gIJXH.fetch), (0, $k1TrK.subscribe));
};

});
parcelRegister("gIJXH", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $2963ed038d5e3581$export$e7aa7bc5c1b3cfb3);

var $4R6GH = parcelRequire("4R6GH");

var $9XhfI = parcelRequire("9XhfI");

var $dMryf = parcelRequire("dMryf");
const $2963ed038d5e3581$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig)=>{
    return (0, $4R6GH.fg)('jfp-magma-support-defer') ? (0, $9XhfI.fetch)(request, variables, cacheConfig) : (0, $dMryf.fetch)(request, variables, cacheConfig);
};

});
parcelRegister("9XhfI", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $1ea431952d5687e8$export$e7aa7bc5c1b3cfb3);

var $hGgHi = parcelRequire("hGgHi");

var $eiowN = parcelRequire("eiowN");

var $4R6GH = parcelRequire("4R6GH");

var $6b2ko = parcelRequire("6b2ko");

var $5a0Nh = parcelRequire("5a0Nh");

var $kipqU = parcelRequire("kipqU");

var $7pVV3 = parcelRequire("7pVV3");

var $ajjqZ = parcelRequire("ajjqZ");

var $4pgHP = parcelRequire("4pgHP");

var $eCZ6m = parcelRequire("eCZ6m");

var $5Wobd = parcelRequire("5Wobd");

var $jlPGx = parcelRequire("jlPGx");

var $gNb1N = parcelRequire("gNb1N");

var $jJZqs = parcelRequire("jJZqs");

var $jCRE8 = parcelRequire("jCRE8");

var $lKFKm = parcelRequire("lKFKm");

var $7isEg = parcelRequire("7isEg");

var $aLyyN = parcelRequire("aLyyN");
// @ts-expect-error the global is placed there by bifrost SSR. See src/entry-fs/util/render.tsx
const $1ea431952d5687e8$var$isSsrHandoverIncrementsEnabled = ()=>Boolean(globalThis.__SSR_HANDOVER_INCREMENTS);
const $1ea431952d5687e8$var$moduleID = 'relay-fetch';
const $1ea431952d5687e8$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig)=>{
    if (!(0, $4R6GH.fg)('remove_heartbeat_service_from_jira_relay_fetch')) {
        const redirecting = (0, $aLyyN.checkAuthentication)();
        if (redirecting) // Hang the request if we are redirecting - should be cleared on redirect
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return (0, $eiowN.Observable).from(new Promise(()=>{}));
    }
    const { name: queryName, operationKind: operationKind } = request;
    const loggingMetadata = {
        queryName: queryName,
        operationKind: operationKind
    };
    const loggingAndMetrics = (0, $7isEg.getLoggingAndMetricsHelper)(loggingMetadata);
    function augmentResponse(response) {
        (0, $5Wobd.addTraceId)(queryName, (0, $aLyyN.getTraceIdFromExtensions)(response));
        (0, $4pgHP.putExtensions)(queryName, response.extensions);
    }
    function validateResponse(response) {
        // @ts-expect-error - TS2339 - Property 'errors' does not exist on type 'GraphQLSingularResponse'.
        const errors = response.errors || undefined;
        if (errors != null) {
            const requestId = response?.extensions?.gateway?.request_id;
            if (!(0, $aLyyN.blocklist).includes(queryName)) loggingAndMetrics.logNonBreakingErrors(errors, requestId);
            (0, $5a0Nh.captureErrors)(errors, {
                operationName: queryName,
                requestId: requestId
            });
            if ((0, $5a0Nh.isUnauthenticated)(errors)) return false;
        }
        return true;
    }
    function enforceNonNullability(response) {
        if (response.data && (response.data.jira === null || response.data.customerService === null)) // Enforce non-nullability of the jira and customerService namespaces. This is an intermediary solution to
        // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
        // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
        // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Data
        response.data = null;
    }
    const earlyScriptPromise = !false && (0, $ajjqZ.claimEarlyScriptPromise)((0, $ajjqZ.getEarlyScriptPromiseKey)(request, variables)) || undefined;
    return (0, $eiowN.Observable).create((sink)=>{
        try {
            const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
            // Unique identifier for the server-to-client channel.
            const sinkID = `${$1ea431952d5687e8$var$moduleID}-${requestID}`;
            let resolveCompletedResponse;
            const completedResponse = new Promise((resolve)=>{
                resolveCompletedResponse = resolve;
            });
            const finalise = ()=>{
                resolveCompletedResponse();
                sink.complete();
            };
            const handleResponse = (response)=>{
                let payload = null;
                if ('incremental' in response && response.incremental) {
                    if (response.incremental.length) // Relay is expecting the contents of this array rather than the entire array itself. Also, Relay doesn't really care about tracking
                    // the pending versus completed values, so we can just return the array without the extra account keeping.
                    // @ts-expect-error It's hard to type this correctly because the payload sometimes has errors, sometimes not. Relay accounts for it,
                    // TypeScript can't handle the polymorphism.
                    payload = response.incremental;
                    else if (response.hasNext === false) // It's possible for the server to send back an empty final increment.
                    // Attempt to make Relay happy.
                    payload = {
                        data: null,
                        extensions: {
                            is_final: true
                        }
                    };
                } else // @ts-expect-error Typescript isn't happy that sometimes errors is undefined, but relay will manage just fine.
                payload = response;
                // Notify observers that we have more data!
                if (payload) {
                    sink.next(payload);
                    // write cache query response on SSR
                    if (false && requestID != null) (0, $7pVV3.getQueryResponseCache)().appendWithMetadata(requestID, variables, payload, loggingMetadata);
                }
                // Close the stream if there are no more responses.
                if ('hasNext' in response && response.hasNext === false) finalise();
            };
            // On client...
            if (!false && requestID != null) {
                // read cache from window.SPA_STATE if available
                const ssrCache = (0, $7pVV3.getQueryResponseCache)().get(requestID, variables);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(ssrCache)) {
                    (0, $7pVV3.getQueryResponseCache)().delete(requestID, variables);
                    sink.next(ssrCache);
                    if ($1ea431952d5687e8$var$isSsrHandoverIncrementsEnabled() && 'hasNext' in ssrCache && ssrCache.hasNext) {
                        // TODO MAGMA-3017: what about SSR fallback mode, or scenarios where SSR has partially failed?
                        // TODO MAGMA-3204: improve robustness. Should be using a middle-man module rather than client dispatcher directly.
                        // Receive response events as they are streamed from the server.
                        (0, $gNb1N.getClientDispatcher)().register(sinkID, handleResponse);
                        (0, $gNb1N.getClientDispatcher)().onAbort(sinkID, ({ reason: reason })=>{
                            if (!sink.closed) {
                                // We didn't receive everything!
                                const err = new (0, $jJZqs.default)(424, `Incomplete handover for relay fetch: ${reason}`);
                                err.name = 'ServerToClientError';
                                loggingAndMetrics.logError(err);
                                sink.error(err, false);
                            }
                        });
                    } else finalise();
                    return;
                }
            }
            const endpoint = (0, $eCZ6m.getAggEndpoint)(request, cacheConfig);
            const body = (0, $eCZ6m.getRequestBody)(request, variables);
            const fetchOverNetwork = (0, $jCRE8.buildGraphqlFetch)(endpoint, (0, $aLyyN.generateOptions)({
                body: body
            }, endpoint));
            const initialSource = ()=>!false && earlyScriptPromise ? (0, $jCRE8.withErrorHandling)(earlyScriptPromise) : (0, $jCRE8.withErrorHandling)(fetchOverNetwork());
            const responses = (0, $jCRE8.processMultipartPromise)(()=>(0, $6b2ko.retryOnError)(initialSource, {
                    retryFunc: ()=>(0, $jCRE8.withErrorHandling)(fetchOverNetwork()),
                    retryPredicate: (0, $aLyyN.shouldRetry),
                    retryAttempts: (0, $aLyyN.getRetryAttemptsForQuery)(queryName, operationKind),
                    onRetry: loggingAndMetrics.logErrorRetry
                }));
            // Recreate a bizarre behaviour that will cause the observable to hang indefinitely when the user is not authenticated, presumably because we redirect the user to log in...
            // This should be revised; see https://jplat.atlassian.net/browse/MAGMA-3087
            let responseShouldHang = false;
            let firstResponseUsed = false;
            let resolveFirstResponse;
            const firstResponse = new Promise((resolve)=>{
                resolveFirstResponse = resolve;
            });
            responses.subscribe({
                start: ()=>{
                    if (requestID != null) {
                        if (false) {
                            // so that SSR SPA knows it is safe to render
                            const renderAfterThisResponse = $1ea431952d5687e8$var$isSsrHandoverIncrementsEnabled() ? firstResponse : completedResponse;
                            (0, $kipqU.QueryPromisesMap).set(requestID, renderAfterThisResponse);
                        } else (0, $kipqU.QueryPromisesMap).set(requestID, firstResponse);
                        (0, $kipqU.CompletedQueryPromisesMap).set(requestID, completedResponse);
                    }
                },
                next: (response)=>{
                    if (false && $1ea431952d5687e8$var$isSsrHandoverIncrementsEnabled() && firstResponseUsed) {
                        // Send the response payload to a side-channel.
                        // TODO MAGMA-3204: improve robustness. Should be sending ID of module to communicate with, sinkID should be an argument.
                        (0, $jlPGx.registerEvent)({
                            id: sinkID,
                            name: 'default',
                            args: [
                                response
                            ]
                        });
                        if ('hasNext' in response && response.hasNext === false) finalise();
                        // Don't send any further responses to the fetch subscriber, since we'll be sending them through a side-channel.
                        return;
                    }
                    if (!firstResponseUsed) {
                        firstResponseUsed = true;
                        // according to spec, we can assume the first response is a GraphQLSingularResponse.
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        const singularResponse = response;
                        augmentResponse(singularResponse);
                        if (!validateResponse(singularResponse)) {
                            //  Short circuit operation and handle the unauthorized errors.
                            (0, $lKFKm.showUnauthenticatedFlag)(queryName);
                            responseShouldHang = true;
                            return;
                        }
                        enforceNonNullability(singularResponse);
                    }
                    handleResponse(response);
                    // signal that the initial response has been received
                    resolveFirstResponse();
                    // After the initial response, further responses are sent through a side-channel.
                    if (false && $1ea431952d5687e8$var$isSsrHandoverIncrementsEnabled()) sink.complete();
                },
                error: (error)=>{
                    if (!firstResponseUsed) firstResponseUsed = true;
                    loggingAndMetrics.logError(error);
                    sink.error(error);
                },
                complete: ()=>{
                    if (responseShouldHang) return;
                    finalise();
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            loggingAndMetrics.logError(error);
            sink.error(error);
        }
    });
};

});
parcelRegister("6b2ko", function(module, exports) {

$parcel$export(module.exports, "RETRY_ATTEMPTS_LIMIT", () => $6910b563ec955346$export$81189edc9b923717);
$parcel$export(module.exports, "retryOnError", () => $6910b563ec955346$export$f859c88bfac2cf2c);
const $6910b563ec955346$export$81189edc9b923717 = 1;
const $6910b563ec955346$export$f859c88bfac2cf2c = (initialPromiseGetter, { retryFunc: retryFunc, retryPredicate: retryPredicate, retryAttempts: retryAttempts = $6910b563ec955346$export$81189edc9b923717, onRetry: onRetry })=>{
    // Eventually we might like to make max attempts configurable.
    // To do so, we'll need to support jitter & exponential back-off
    const maxAttempts = retryAttempts > $6910b563ec955346$export$81189edc9b923717 ? $6910b563ec955346$export$81189edc9b923717 : retryAttempts;
    const execute = async (getPromise, retryAttempt = 0)=>{
        try {
            return await getPromise();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // If no retry predicate is passed, retry on every error
            const shouldAttemptRetry = retryPredicate ? retryPredicate(error) : true;
            if (retryAttempt < maxAttempts && shouldAttemptRetry) {
                onRetry && onRetry(error, retryAttempt + 1);
                return execute(retryFunc, retryAttempt + 1);
            }
            throw error;
        }
    };
    return execute(initialPromiseGetter);
};

});

parcelRegister("5a0Nh", function(module, exports) {

$parcel$export(module.exports, "startCaptureGraphQlErrors", () => $cf86a52470c84b66$export$c211170518c6d0f6);
$parcel$export(module.exports, "stopCaptureGraphQlErrors", () => $cf86a52470c84b66$export$e0491a0d974dadfa);
$parcel$export(module.exports, "captureErrors", () => $cf86a52470c84b66$export$7a973c0ff390eb47);
$parcel$export(module.exports, "isUnauthenticated", () => $cf86a52470c84b66$export$1724ecfee73c4768);
/**
 * Utility methods to capture GraphQl errors and expose them to the frontend for reporting.
 * ```
 * Sample usage:
 * const id = startErrorCapture();
 * ...
 * const errors = stopErrorCapture(id);
 * ```
 */ 
var $7Jxgt = parcelRequire("7Jxgt");
const $cf86a52470c84b66$var$errorCollector = new Map();
const $cf86a52470c84b66$export$da396ad2a542b095 = 120000; // 2min
const $cf86a52470c84b66$var$scheduleCleanup = (key)=>{
    setTimeout(()=>{
        $cf86a52470c84b66$var$errorCollector.delete(key);
    }, $cf86a52470c84b66$export$da396ad2a542b095);
};
const $cf86a52470c84b66$export$c211170518c6d0f6 = (key = (0, $7Jxgt.v4)())=>{
    $cf86a52470c84b66$var$errorCollector.set(key, []);
    $cf86a52470c84b66$var$scheduleCleanup(key);
    return key;
};
const $cf86a52470c84b66$export$e0491a0d974dadfa = (key)=>{
    const errors = $cf86a52470c84b66$var$errorCollector.get(key);
    $cf86a52470c84b66$var$errorCollector.delete(key);
    return errors || [];
};
const $cf86a52470c84b66$export$7a973c0ff390eb47 = (errors, meta)=>{
    if (errors) $cf86a52470c84b66$var$errorCollector.forEach((value, key)=>{
        $cf86a52470c84b66$var$errorCollector.set(key, [
            ...value,
            {
                errors: errors,
                meta: meta
            }
        ]);
    });
};
const $cf86a52470c84b66$export$1724ecfee73c4768 = (errors)=>{
    if (errors.length > 0) return errors.some((error)=>error.message.startsWith('Auth category: UNAUTHENTICATED'));
    return false;
};

});

parcelRegister("kipqU", function(module, exports) {

$parcel$export(module.exports, "QueryPromisesMap", () => $f428f7f15822f637$export$607b80f5bc6e396d);
$parcel$export(module.exports, "CompletedQueryPromisesMap", () => $f428f7f15822f637$export$cdadce6ed6361a2c);
/**
 * A map of signals that the initial response from the network has been received for a given relay query.
 *
 * This signal is used on the server-side during SSR to prevent React from running a render pass
 * until we can guarantee the data has arrived and is cached in the relay-client.
 *
 * This allows us to make a meaningful an initial render pass, avoiding needless suspense boundaries
 * and avoiding adding noncritical work to the JS call stack.
 */ const $f428f7f15822f637$export$607b80f5bc6e396d = new Map();
const $f428f7f15822f637$export$cdadce6ed6361a2c = new Map();

});

parcelRegister("7pVV3", function(module, exports) {

$parcel$export(module.exports, "getQueryResponseCache", () => $675c7f0a9d659efe$export$3233e692a93c0cfd);

var $jqONe = parcelRequire("jqONe");

var $9XE6b = parcelRequire("9XE6b");

var $8QpSo = parcelRequire("8QpSo");

var $eiowN = parcelRequire("eiowN");

var $2YZCu = parcelRequire("2YZCu");

var $jJZqs = parcelRequire("jJZqs");

var $kizcd = parcelRequire("kizcd");
function $675c7f0a9d659efe$export$611736262b635f8d(queryID, variables) {
    return JSON.stringify((0, $eiowN.stableCopy)({
        queryID: queryID,
        variables: variables
    }));
}
function $675c7f0a9d659efe$export$1e65e863cf3a0f21(cacheKey) {
    return JSON.parse(cacheKey).queryID;
}
const $675c7f0a9d659efe$export$da2711d74cd28aed = [
    'fetchModulesV2Query'
];
class $675c7f0a9d659efe$export$be21c283b097d175 extends (0, $eiowN.QueryResponseCache) {
    constructor({ cacheName: cacheName, size: size, ttl: ttl }){
        super({
            size: size,
            ttl: ttl
        });
        const cachedData = false ? {} : window?.SPA_STATE?.[cacheName] || window?.SKELETON_NAVIGATION?.[cacheName] || {};
        this.cacheName = cacheName;
        this.requestMetadata = new Map(cachedData.requestMetadata);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        this._responses = new Map(cachedData.responses);
        if (!false) setTimeout(()=>{
            this.logUnusedPayloadErrors();
            // cleanup leftover data to reduce unnecessary memory usage
            this.requestMetadata.clear();
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            this._responses.clear();
        }, 60000 /* 1 minute */ );
    }
    logUnusedPayloadErrors() {
        const loggedQueries = new Set();
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'. | TS7006 - Parameter 'response' implicitly has an 'any' type. | TS7006 - Parameter 'key' implicitly has an 'any' type.
        this._responses.forEach((response, key)=>{
            const queryID = $675c7f0a9d659efe$export$1e65e863cf3a0f21(key);
            const metadata = this.requestMetadata.get(queryID);
            const { queryName: queryName = 'unknown', operationKind: operationKind = 'unknown' } = metadata ?? {
                queryName: 'unknown',
                operationKind: 'unknown'
            };
            if (!loggedQueries.has(queryName) && !$675c7f0a9d659efe$export$da2711d74cd28aed.includes(queryName)) {
                loggedQueries.add(queryName);
                const error = new (0, $kizcd.UnusedRelayResponseError)(queryID);
                const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                    'statusCode'
                ], null);
                const errorType = error instanceof (0, $jJZqs.default) ? 'network' : 'unknown';
                // Log any errors even in SSR
                (0, $2YZCu.default).safeErrorWithoutCustomerData('relay.AGG.error.graphql', `[${errorType} error]`, {
                    message: `[${(0, (/*@__PURE__*/$parcel$interopDefault($jqONe)))(errorType)} error]: ${error?.message ?? ''}`,
                    errorType: errorType,
                    statusCode: statusCode,
                    queryName: queryName,
                    operationKind: operationKind,
                    errorName: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                        'name'
                    ], null)
                });
            }
        });
    }
    /**
	 * @deprecated only sets a single response; does not work well if requests use defer or stream.
	 *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/jira-s2c-server-dispatcher/src/index.tsx"}.
	 */ setWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        this.set(queryID, variables, payload);
    }
    /**
	 * Stores a GraphQLRepsonse along with metadata about the call.
	 * If called multiple times (such as when incremental payloads are received),
	 * will update the stored response to be an array of GraphQLSingularResponse objects,
	 * which Relay is happy to handle.
	 * @deprecated works, but does not work well if requests use defer or stream.
	 *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/jira-s2c-server-dispatcher/src/index.tsx"}.
	 */ appendWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        const currentResponse = this.get(queryID, variables);
        if (!currentResponse) this.set(queryID, variables, payload);
        else if (currentResponse instanceof Array) {
            const newResponse = [
                ...currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        } else {
            const newResponse = [
                currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        }
    }
    /**
	 * Deletes a request from the store, if found.
	 *
	 * IMPORTANT: Make sure DELETE method always has tests that include get/set
	 * to ensure our `getCacheKey` matches Relay's.
	 *
	 * @returns {boolean} indicating if an entry in the cache was deleted
	 */ delete(queryID, variables) {
        const cacheKey = $675c7f0a9d659efe$export$611736262b635f8d(queryID, variables);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        return this._responses.delete(cacheKey);
    }
    serialize() {
        return {
            [this.cacheName]: {
                // @ts-expect-error - TS2322 - Type '{ [x: string]: { requestMetadata: [string, RequestMetadata][]; responses: unknown[]; }; }' is not assignable to type 'Partial<Record<string, [string, GraphQLResponse][]>>'.
                requestMetadata: Array.from(this.requestMetadata.entries()),
                // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
                responses: Array.from(this._responses.entries())
            }
        };
    }
}
const $675c7f0a9d659efe$export$3233e692a93c0cfd = (0, $8QpSo.default)(()=>new $675c7f0a9d659efe$export$be21c283b097d175({
        cacheName: 'relay-cache/v2/AGG',
        size: Infinity,
        ttl: Infinity
    }));
const $675c7f0a9d659efe$export$94e535e06b7ade61 = ()=>$675c7f0a9d659efe$export$3233e692a93c0cfd().serialize();

});
parcelRegister("kizcd", function(module, exports) {

$parcel$export(module.exports, "UnusedRelayResponseError", () => $f174935352f053b0$export$8431e42d062de453);
class $f174935352f053b0$export$8431e42d062de453 extends Error {
    constructor(queryID){
        super(`Relay Query ${queryID} was made during SSR but never used in the browser`), this.name = 'UnusedRelayResponseError';
    }
}

});


parcelRegister("ajjqZ", function(module, exports) {

$parcel$export(module.exports, "getEarlyScriptPromiseKey", () => $383b599fde987e1e$export$1102c06c7da91223);
$parcel$export(module.exports, "claimEarlyScriptPromise", () => $383b599fde987e1e$export$828ac0325bce4536);
$parcel$export(module.exports, "earlyFetch", () => $383b599fde987e1e$export$5b55058781674413);

var $tcn7E = parcelRequire("tcn7E");

var $l83Uu = parcelRequire("l83Uu");

var $eKonk = parcelRequire("eKonk");

var $eCZ6m = parcelRequire("eCZ6m");
const $383b599fde987e1e$var$CAPABILITY_HEADER_NAME = 'X-Atlassian-Capability';
const $383b599fde987e1e$export$b5fbc1430cbfd6e1 = (value)=>value;
const $383b599fde987e1e$export$6d670d323806bb37 = new Map();
const $383b599fde987e1e$export$1102c06c7da91223 = (params, variables)=>{
    if (params.name === 'mainIssueAggQuery') return `${params.name}|${params.id}|${variables?.cloudId}|${variables?.issueKey}`;
    const queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
    const serializedVariables = variables != null ? JSON.stringify(variables, Object.keys(variables).sort()) : '';
    return `${params.name}|${String(queryId)}|${serializedVariables}`;
};
const $383b599fde987e1e$export$828ac0325bce4536 = (key)=>{
    const result = $383b599fde987e1e$export$6d670d323806bb37.get(key);
    if (result != null) $383b599fde987e1e$export$6d670d323806bb37.delete(key);
    return result;
};
const $383b599fde987e1e$export$e1336d32be02faf4 = (key, promise)=>{
    if (!$383b599fde987e1e$export$6d670d323806bb37.has(key)) $383b599fde987e1e$export$6d670d323806bb37.set(key, promise);
};
const $383b599fde987e1e$export$5b55058781674413 = (compiledQuery, variables, experimentalApis = [], capability)=>{
    (0, $l83Uu.setMark)('jira.fe-spa.early-preload:start');
    const endpoint = (0, $eCZ6m.getAggEndpoint)(compiledQuery.params);
    const body = (0, $eCZ6m.getRequestBody)(compiledQuery.params, variables);
    const capabilityHeader = (0, $eKonk.getEnhancedCapabilityHeader)(capability ?? null);
    $383b599fde987e1e$export$e1336d32be02faf4($383b599fde987e1e$export$1102c06c7da91223(compiledQuery.params, variables), fetch(endpoint, {
        credentials: 'same-origin',
        headers: {
            'atl-client-name': 'jira-frontend',
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'Content-Type': 'application/json',
            Accept: 'application/json,text/javascript,*/*',
            'X-ExperimentalApi': experimentalApis.join(','),
            ...(0, $tcn7E.getActiveTraceHttpRequestHeaders)(),
            ...capabilityHeader ? {
                [$383b599fde987e1e$var$CAPABILITY_HEADER_NAME]: capabilityHeader
            } : {}
        },
        method: 'POST',
        body: body
    }).then((response)=>{
        (0, $l83Uu.setMark)('jira.fe-spa.early-preload:end');
        return response;
    }));
};

});
parcelRegister("l83Uu", function(module, exports) {

$parcel$export(module.exports, "setMark", () => $ef655a7b07a35675$export$f7a1fb90d8604165);
$parcel$export(module.exports, "getTraceId", () => $ef655a7b07a35675$export$e88cb5bfb57ce9c4);

const $ef655a7b07a35675$export$f7a1fb90d8604165 = (mark)=>{
    if (typeof performance !== 'object' || typeof performance.mark !== 'function') return;
    performance.mark(mark);
};
const $ef655a7b07a35675$var$TRACE_ID_HEADER = 'atl-traceid';
const $ef655a7b07a35675$var$TRACE_ID_HEADER_MICROS = 'x-trace-id';
const $ef655a7b07a35675$export$e88cb5bfb57ce9c4 = (response)=>response.headers.get($ef655a7b07a35675$var$TRACE_ID_HEADER) || response.headers.get($ef655a7b07a35675$var$TRACE_ID_HEADER_MICROS);

});


parcelRegister("jlPGx", function(module, exports) {

$parcel$export(module.exports, "registerEvent", () => $8c8d2c511a52b5a9$export$bd50bc4cd3c601ee);
const $8c8d2c511a52b5a9$var$events = [];
const $8c8d2c511a52b5a9$export$bd50bc4cd3c601ee = (event)=>{
    $8c8d2c511a52b5a9$var$events.push(event);
};
/**
 * Take all events registered so far, return them, and clear the list.
 */ const $8c8d2c511a52b5a9$export$3c7145db84d4587c = ()=>{
    return $8c8d2c511a52b5a9$var$events.splice(0, $8c8d2c511a52b5a9$var$events.length);
};

});

parcelRegister("gNb1N", function(module, exports) {

$parcel$export(module.exports, "getClientDispatcher", () => $08daf01a02e1f157$export$5bb012cf9b3a5452);


var $ifOJ4 = parcelRequire("ifOJ4");
let $08daf01a02e1f157$var$dispatcher;
const $08daf01a02e1f157$export$5bb012cf9b3a5452 = ()=>{
    if (!$08daf01a02e1f157$var$dispatcher) {
        $08daf01a02e1f157$var$dispatcher = new (0, $ifOJ4.ClientDispatcher)();
        // Handle the server hangup scenarios
        $08daf01a02e1f157$var$dispatcher.register((0, $f5236820edf41c5d$export$eb5d9c90d65c7fea), $08daf01a02e1f157$var$dispatcher._abort.bind($08daf01a02e1f157$var$dispatcher));
    }
    return $08daf01a02e1f157$var$dispatcher;
};

});
const $f5236820edf41c5d$export$eb5d9c90d65c7fea = 'ClientDispatcher';

parcelRegister("ifOJ4", function(module, exports) {

$parcel$export(module.exports, "ClientDispatcher", () => $c402b43f217e880b$export$3f5ba18eb97af725);
class $c402b43f217e880b$export$3f5ba18eb97af725 {
    #handlers;
    #queuedPayloads;
    #abortReason;
    #abortHandlers;
    constructor(){
        this.#handlers = new Map();
        this.#abortHandlers = new Map();
        this.#queuedPayloads = new Map();
    }
    /**
	 * Ingest a payload from the server.
	 * This will trigger a callback to the component that registered for this event, otherwise the payload will be queued to do so later.
	 * @param payload - The payload to ingest.
	 */ ingest(payload) {
        const handler = this.#handlers.get(payload.id);
        if (handler) this.#exec(handler, payload);
        else {
            const queue = this.#queuedPayloads.get(payload.id) || [];
            queue.push(payload);
            this.#queuedPayloads.set(payload.id, queue);
        }
    }
    /**
	 * Register a callback for a given event. If any payloads were queued for this event, they will be processed immediately.
	 * @param id - The event ID to register for.
	 * @param callback - The callback to trigger when the event is ingested.
	 */ register(id, callback) {
        this.#handlers.set(id, callback);
        // Process any queued payloads for this handler
        const queuedPayloads = this.#queuedPayloads.get(id) || [];
        if (queuedPayloads.length > 0) {
            queuedPayloads.forEach((payload)=>this.#exec(callback, payload));
            this.#queuedPayloads.delete(id);
        }
    }
    /**
	 * Register an abort handler that will get called if exceptional circmstances arise (such as SSR hanging up due to deadline exceeded)
	 * @param id - The event ID to register for.
	 * @param callback - The callback to trigger when abort detected.
	 */ onAbort(id, callback) {
        if (this.#abortReason) this.#exec(callback, {
            args: [
                this.#abortReason
            ]
        });
        else this.#abortHandlers.set(id, callback);
    }
    /**
	 * Notify any registered abort handlers that the server exceeded its deadline before finishing, so we may not have received all events.
	 * @private
	 * @param props
	 */ _abort(props) {
        this.#abortReason = props;
        this.#abortHandlers.forEach((handler)=>{
            this.#exec(handler, {
                args: [
                    props
                ]
            });
        });
        // We can delete these now that we've handled the case and remainder will be dealt with immediately.
        this.#abortHandlers = new Map();
    }
    /**
	 * Execute a callback with the given payload.
	 * @param callback - The callback to execute.
	 * @param payload - The payload to execute the callback with.
	 */ #exec(callback, payload) {
        const { args: args, error: error } = payload;
        try {
            if (error) throw error;
            callback(...args);
        } catch (err) {
        // TODO: log error
        // console.error(err);
        }
    }
}

});


parcelRegister("jCRE8", function(module, exports) {

$parcel$export(module.exports, "processMultipartPromise", () => $263b59cc260a85be$export$f76505a7f2969e4e);
$parcel$export(module.exports, "withErrorHandling", () => $263b59cc260a85be$export$c874c20f7c9f97c);
$parcel$export(module.exports, "buildGraphqlFetch", () => $263b59cc260a85be$export$744180da2870332e);
/**
 * @fileOverview Implements a fetch function that can handle multipart/mixed responses.
 * The multipart response is expected to follow the GraphQL multipart request spec.
 *
 * See https://github.com/graphql/graphql-over-http/blob/main/rfcs/IncrementalDelivery.md#content-type-multipartmixed
 * See https://github.com/graphql/graphql-over-http/blob/main/spec/GraphQLOverHTTP.md#multipart-request-format
 */ 
var $1UikQ = parcelRequire("1UikQ");

var $eiowN = parcelRequire("eiowN");

var $8KpGl = parcelRequire("8KpGl");

var $51xpa = parcelRequire("51xpa");

var $5HnTq = parcelRequire("5HnTq");


var $eusud = parcelRequire("eusud");
function $263b59cc260a85be$var$getBoundary(contentType) {
    const parts = contentType.split('boundary=');
    if (parts.length < 2) return null;
    return parts[1].trim();
}
/**
 * Processes a chunk of multipart data and emits parsed JSON payloads to the observer
 * Uses a more memory-efficient approach by processing chunks directly
 */ function $263b59cc260a85be$var$processChunk(chunk, boundaryString, observer) {
    const parts = chunk.split(boundaryString);
    // Process all complete parts (except the last one which might be incomplete)
    for(let i = 0; i < parts.length - 1; i++){
        const part = parts[i].trim();
        // Skip empty parts and encapsulation boundaries
        if (part && !part.startsWith('--')) {
            // Split content-type header and body
            const [, body] = part.split(/\r?\n\r?\n/);
            if (body) try {
                const jsonData = JSON.parse(body.trim());
                observer.next(jsonData);
            } catch (error) {
                observer.error(new Error(`Invalid JSON: ${error instanceof Error ? error.message : String(error)}`));
            }
        }
    }
    // Return the last part which might be incomplete
    return parts[parts.length - 1];
}
/**
 * Processes a ReadableStream of multipart data with improved memory efficiency
 */ async function $263b59cc260a85be$var$processStream(reader, boundary, observer) {
    const boundaryString = `--${boundary}`;
    let incompleteChunk = '';
    // Process chunks until the stream is done
    for await (const newText of reader){
        const combinedChunk = incompleteChunk + newText;
        // Process the combined chunk and get any incomplete part
        incompleteChunk = $263b59cc260a85be$var$processChunk(combinedChunk, boundaryString, observer);
    }
    // Process any remaining data
    if (incompleteChunk.length > 0) $263b59cc260a85be$var$processChunk(incompleteChunk, boundaryString, observer);
    observer.complete();
}
function $263b59cc260a85be$var$handleMultipartResponse(response, observer) {
    const contentType = response.headers.get('content-type');
    const boundary = $263b59cc260a85be$var$getBoundary(contentType || '');
    if (!boundary) {
        observer.error(new Error('Invalid multipart boundary'));
        return;
    }
    const decoder = new TextDecoder('utf-8');
    try {
        // Depending on the version of Node we're running in, the Response object may not implement ReadableStream.
        // Here, we treat the response as an async iterator, since both node-fetch and browser implement the response body as a stream.
        // We wrap that iteration in an async generator, which lets us
        async function* streamReader() {
            // @ts-expect-error a Response object in Node is streamable
            for await (const chunk of response.body){
                const newText = decoder.decode(chunk, {
                    stream: true
                });
                yield newText;
            }
        }
        $263b59cc260a85be$var$processStream(streamReader(), boundary, observer).catch((error)=>observer.error(error));
    } catch (e) {
        observer.error(new Error('Failed to read from response body', {
            cause: e
        }));
    }
}
function $263b59cc260a85be$var$handleJsonResponse(response, observer) {
    response.json().then((data)=>observer.next(data)).catch((error)=>observer.error(error)).finally(()=>observer.complete());
}
function $263b59cc260a85be$var$handleTextResponse(response, observer) {
    response.text().then((data)=>{
        const maybeJson = data ? JSON.parse(data) : null;
        observer.next(maybeJson);
        observer.complete();
    }).catch((error)=>observer.error(error));
}
function $263b59cc260a85be$export$f76505a7f2969e4e(source) {
    // Cache the result of the source promise to avoid calling it multiple times.
    const result = source();
    // Wrap an observer around the result to handle the response.
    return (0, $eiowN.Observable).create((observer)=>{
        result.then((response)=>{
            if (response.status === (0, $3cd8a0ece36fbae5$export$3288b14b6745c572)) {
                observer.complete();
                return;
            }
            const contentType = response.headers.get('content-type') || '';
            if (contentType.includes('application/json') || contentType.includes('application/graphql-response+json')) $263b59cc260a85be$var$handleJsonResponse(response, observer);
            else if (contentType.includes('text/plain')) $263b59cc260a85be$var$handleTextResponse(response, observer);
            else if (contentType.includes('multipart/mixed')) $263b59cc260a85be$var$handleMultipartResponse(response, observer);
            else observer.error(new Error(`Unsupported content type: ${contentType}`));
        }).catch((error)=>observer.error(error));
    });
}
function $263b59cc260a85be$export$c874c20f7c9f97c(source) {
    return source.then((0, $eusud.handleErrors)).catch((0, $eusud.handleNetworkErrors));
}
function $263b59cc260a85be$export$744180da2870332e(url, options) {
    const acceptableFormats = [
        'application/graphql-response+json',
        'application/json',
        'multipart/mixed; deferSpec=20220824'
    ];
    const postOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: acceptableFormats.join(', ')
        }
    };
    const composedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))((0, $5HnTq.getDefaultOptions)(url), options, postOptions);
    const fetchUrl = (0, $8KpGl.getReroutableURL)(url);
    const fetchHeaders = (0, $51xpa.applyObservabilityHeaders)(url, composedOptions);
    return ()=>fetch(fetchUrl, fetchHeaders);
}
function $263b59cc260a85be$export$2586da7b5f4b5763(url, options) {
    const fetchFn = $263b59cc260a85be$export$744180da2870332e(url, options);
    return $263b59cc260a85be$export$f76505a7f2969e4e(()=>$263b59cc260a85be$export$c874c20f7c9f97c(fetchFn()));
}

});
parcelRegister("8KpGl", function(module, exports) {

$parcel$export(module.exports, "getReroutableURL", () => $e8054b634989671a$export$23769875e8eebaf6);

var $g96Vw = parcelRequire("g96Vw");
// FIXME: Pillar to define entire URL, not just hostname.
const $e8054b634989671a$var$LOCAL_URL = new URL(`${'http'}://${(0, $g96Vw.getDevHostname)()}:${(0, $g96Vw.getProxyServerPort)()}`);
function $e8054b634989671a$export$23769875e8eebaf6(pathOrURL) {
    var e;
    return pathOrURL;
}

});
parcelRegister("g96Vw", function(module, exports) {

$parcel$export(module.exports, "getDevHostname", () => $e257580e5f260c28$export$a6aba27c4797e08b);
$parcel$export(module.exports, "getProxyServerPort", () => $e257580e5f260c28$export$6819122a922c6aaf);
/**
 * Get the hostname for the Pillar development server.
 *
 * In the always-on RDE, it will have a proper DNS name. In local development, it
 * will default to `localhost`.
 *
 * @returns The hostname for the development server.
 */ const $e257580e5f260c28$export$a6aba27c4797e08b = ()=>{
    const envDns = undefined;
    return typeof envDns === 'string' && envDns.trim() ? envDns.trim() : 'localhost';
};
function $e257580e5f260c28$export$6819122a922c6aaf() {
    return 9000;
}

});


parcelRegister("eusud", function(module, exports) {

$parcel$export(module.exports, "transformValidationErrorFromServer", () => $3637c0f7edbd2bb4$export$8e9baed7697e4959);
$parcel$export(module.exports, "handleNetworkErrors", () => $3637c0f7edbd2bb4$export$b47ad9bdf9122b88);
$parcel$export(module.exports, "handleErrors", () => $3637c0f7edbd2bb4$export$1e36de371b2e3d5a);
$parcel$export(module.exports, "applyErrorHandling", () => $3637c0f7edbd2bb4$export$e174dc943a170ff);
$parcel$export(module.exports, "performGetRequest", () => $3637c0f7edbd2bb4$export$4a53ae1be8ec80c7);
$parcel$export(module.exports, "performPutRequest", () => $3637c0f7edbd2bb4$export$9ead1f9103e6de6b);
$parcel$export(module.exports, "performPostRequest", () => $3637c0f7edbd2bb4$export$692a4d9808143175);
$parcel$export(module.exports, "performDeleteRequest", () => $3637c0f7edbd2bb4$export$8ef51cba9d28f819);
$parcel$export(module.exports, "performPatchRequest", () => $3637c0f7edbd2bb4$export$52be6ab13d7e758d);
$parcel$export(module.exports, "performGetRequestWithRetry", () => $3637c0f7edbd2bb4$export$659b5ee69e6eb976);
$parcel$export(module.exports, "performPutRequestWithRetry", () => $3637c0f7edbd2bb4$export$d7b48b2904a5d812);
$parcel$export(module.exports, "performPostRequestWithRetry", () => $3637c0f7edbd2bb4$export$a5717cbee13f28b7);


var $jp5kW = parcelRequire("jp5kW");

var $5HnTq = parcelRequire("5HnTq");

var $jJZqs = parcelRequire("jJZqs");

var $8KpGl = parcelRequire("8KpGl");

var $51xpa = parcelRequire("51xpa");

var $6b2ko = parcelRequire("6b2ko");

var $iwPwz = parcelRequire("iwPwz");
/**
 * Transform object with field errors from JIRA to an array of FieldValidationErrors
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3637c0f7edbd2bb4$var$transformFieldErrorsFromServer = (fieldErrors)=>Object.keys(fieldErrors).map((field)=>({
            field: field,
            error: fieldErrors[field]
        }));
const $3637c0f7edbd2bb4$export$8e9baed7697e4959 = (json, statusCode, traceId)=>{
    const message = json.errorMessages ? json.errorMessages.join('; ') : 'validation failed';
    const fieldErrorsJson = json.errors ?? json.fieldErrors;
    const fieldErrors = fieldErrorsJson ? $3637c0f7edbd2bb4$var$transformFieldErrorsFromServer(fieldErrorsJson) : [];
    return new (0, $jJZqs.ValidationError)(message, fieldErrors, statusCode, traceId, json);
};
const $3637c0f7edbd2bb4$var$putOptions = {
    ...(0, $5HnTq.defaultOptions),
    method: 'PUT'
};
const $3637c0f7edbd2bb4$var$postOptions = {
    ...(0, $5HnTq.defaultOptions),
    method: 'POST'
};
const $3637c0f7edbd2bb4$var$deleteOptions = {
    ...(0, $5HnTq.defaultOptions),
    method: 'DELETE'
};
const $3637c0f7edbd2bb4$var$patchOptions = {
    ...(0, $5HnTq.defaultOptions),
    method: 'PATCH'
};
const $3637c0f7edbd2bb4$export$b47ad9bdf9122b88 = (err)=>{
    if (err instanceof TypeError) throw new Error('Failed to fetch', {
        cause: err
    });
    throw err;
};
const $3637c0f7edbd2bb4$export$1e36de371b2e3d5a = (response)=>{
    const traceId = (0, $iwPwz.getTraceId)(response);
    // CONTENT_TOO_LARGE errorMessage is used for Hard Limits and, we don't want to override the error message
    if ((0, $3cd8a0ece36fbae5$export$9de493bcd9b1d977) === response.status || (0, $3cd8a0ece36fbae5$export$f90ac1df0b60853d) === response.status) return response.json().then((errorContent)=>{
        throw $3637c0f7edbd2bb4$export$8e9baed7697e4959(errorContent, response.status, traceId);
    });
    if (!response.ok) {
        if (traceId !== undefined && traceId.length > 0) throw new (0, $jJZqs.default)(response.status, `Error server response: ${response.status}`, traceId, response);
        else throw new (0, $jJZqs.default)(response.status, `Error server response: ${response.status}`, undefined, response);
    }
    return response;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3637c0f7edbd2bb4$var$processResponseFromServer = (response)=>{
    if (response.status === (0, $3cd8a0ece36fbae5$export$3288b14b6745c572)) return Promise.resolve(null);
    return response.text().then((text)=>text ? JSON.parse(text) : null);
};
const $3637c0f7edbd2bb4$export$e174dc943a170ff = (responsePromise)=>responsePromise.then($3637c0f7edbd2bb4$export$1e36de371b2e3d5a).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$export$b47ad9bdf9122b88);
const $3637c0f7edbd2bb4$export$22411cbfb09a5c5c = (url, options)=>{
    const { retryPredicate: retryPredicate, retryAttempts: retryAttempts, onRetry: onRetry, ...requestOptions } = options;
    const executeRequest = ()=>$3637c0f7edbd2bb4$export$e174dc943a170ff(fetch((0, $8KpGl.getReroutableURL)(url), (0, $51xpa.applyObservabilityHeaders)(url, requestOptions)));
    if ((0, $jp5kW.default)('platform_fetch_retries')) return executeRequest();
    return (0, $6b2ko.retryOnError)(executeRequest, {
        retryFunc: executeRequest,
        retryPredicate: retryPredicate,
        retryAttempts: retryAttempts,
        onRetry: onRetry
    });
};
const $3637c0f7edbd2bb4$export$4a53ae1be8ec80c7 = (url, options = {})=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $51xpa.applyObservabilityHeaders)(url, {
        ...(0, $5HnTq.defaultOptions),
        ...options
    })).then($3637c0f7edbd2bb4$export$1e36de371b2e3d5a).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$export$b47ad9bdf9122b88);
const $3637c0f7edbd2bb4$export$9ead1f9103e6de6b = (url, options = {})=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $51xpa.applyObservabilityHeaders)(url, {
        ...$3637c0f7edbd2bb4$var$putOptions,
        ...options
    })).then($3637c0f7edbd2bb4$export$1e36de371b2e3d5a).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$export$b47ad9bdf9122b88);
const $3637c0f7edbd2bb4$export$692a4d9808143175 = (url, options = {})=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $51xpa.applyObservabilityHeaders)(url, {
        ...$3637c0f7edbd2bb4$var$postOptions,
        ...options
    })).then($3637c0f7edbd2bb4$export$1e36de371b2e3d5a).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$export$b47ad9bdf9122b88);
const $3637c0f7edbd2bb4$export$8ef51cba9d28f819 = (url, options = {})=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $51xpa.applyObservabilityHeaders)(url, {
        ...$3637c0f7edbd2bb4$var$deleteOptions,
        ...options
    })).then($3637c0f7edbd2bb4$export$1e36de371b2e3d5a).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$export$b47ad9bdf9122b88);
const $3637c0f7edbd2bb4$export$52be6ab13d7e758d = (url, options = {})=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $51xpa.applyObservabilityHeaders)(url, {
        ...$3637c0f7edbd2bb4$var$patchOptions,
        ...options
    })).then($3637c0f7edbd2bb4$export$1e36de371b2e3d5a).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$export$b47ad9bdf9122b88);
const $3637c0f7edbd2bb4$export$659b5ee69e6eb976 = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
        ...(0, $5HnTq.defaultOptions),
        ...options
    });
const $3637c0f7edbd2bb4$export$d7b48b2904a5d812 = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
        ...$3637c0f7edbd2bb4$var$putOptions,
        ...options
    });
const $3637c0f7edbd2bb4$export$a5717cbee13f28b7 = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
        ...$3637c0f7edbd2bb4$var$postOptions,
        ...options
    });
const $3637c0f7edbd2bb4$export$6d01bf1146815b9b = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
        ...$3637c0f7edbd2bb4$var$deleteOptions,
        ...options
    });
const $3637c0f7edbd2bb4$export$560989ee94ad2a20 = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
        ...$3637c0f7edbd2bb4$var$patchOptions,
        ...options
    });

});
parcelRegister("iwPwz", function(module, exports) {

$parcel$export(module.exports, "getTraceId", () => $19a21974d2ff6598$export$e88cb5bfb57ce9c4);
$parcel$export(module.exports, "getTraceIdJq", () => $19a21974d2ff6598$export$b569b31eebca952d);

var $fnyT4 = parcelRequire("fnyT4");
const $19a21974d2ff6598$export$e88cb5bfb57ce9c4 = (response)=>{
    const traceIdHeader = (0, $fnyT4.KNOWN_TRACE_ID_HEADERS).find((header)=>response.headers.has(header));
    return traceIdHeader === undefined ? undefined : response.headers.get(traceIdHeader) ?? undefined;
};
const $19a21974d2ff6598$export$b569b31eebca952d = (jqxhr)=>{
    if (!jqxhr || !jqxhr.getResponseHeader) // prefer a silent fail, so we don't accidentally swallow the original error being built
    return undefined;
    const traceIdHeader = (0, $fnyT4.KNOWN_TRACE_ID_HEADERS).find((header)=>jqxhr.getResponseHeader(header) != null);
    return traceIdHeader === undefined ? undefined : jqxhr.getResponseHeader(traceIdHeader);
};

});
parcelRegister("fnyT4", function(module, exports) {

$parcel$export(module.exports, "TRACE_ID_HEADER", () => $5d3410503b671c4b$export$4b69438fb7c7b9b2);
$parcel$export(module.exports, "KNOWN_TRACE_ID_HEADERS", () => $5d3410503b671c4b$export$830a89e935012abe);
const $5d3410503b671c4b$export$4b69438fb7c7b9b2 = 'atl-traceid';
const $5d3410503b671c4b$var$TRACE_ID_HEADER_MICROS = 'x-trace-id';
const $5d3410503b671c4b$export$830a89e935012abe = [
    $5d3410503b671c4b$export$4b69438fb7c7b9b2,
    $5d3410503b671c4b$var$TRACE_ID_HEADER_MICROS
];

});




parcelRegister("lKFKm", function(module, exports) {

$parcel$export(module.exports, "showUnauthenticatedFlag", () => $42cb6e1c2fdc593e$export$758fcc357484571e);

var $pa9q9 = parcelRequire("pa9q9");

var $fjcgS = parcelRequire("fjcgS");

var $8iiwm = parcelRequire("8iiwm");
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $42cb6e1c2fdc593e$var$reloadPage = ()=>window.location.reload();
const $42cb6e1c2fdc593e$var$sendAnalyticEvent = (operationName)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        const analyticsClient = client.getInstance();
        if (!analyticsClient) return;
        analyticsClient.sendTrackEvent({
            action: 'showed',
            actionSubject: 'unauthorizedFlag',
            attributes: {
                operation: operationName
            },
            source: 'jiraRelayFetch'
        });
    });
};
const $42cb6e1c2fdc593e$var$sendLoginClickEvent = (operationName)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        const analyticsClient = client.getInstance();
        if (!analyticsClient) return;
        analyticsClient.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'loginButton',
            attributes: {
                operation: operationName,
                source: globalThis.window?.location?.pathname ?? '',
                referrer: globalThis.document?.referrer ?? '',
                timestamp: new Date().toISOString(),
                userAgent: globalThis.navigator?.userAgent ?? ''
            },
            source: 'jiraRelayFetch'
        });
    });
};
const $42cb6e1c2fdc593e$export$758fcc357484571e = (operationName)=>{
    (0, $pa9q9.showFlag)({
        type: 'error',
        title: (0, $8iiwm.default).title,
        description: (0, $8iiwm.default).description,
        messageId: 'relay-fetch.services.error-flags.show-flag.error.show-unauthenticated-flag',
        messageType: 'transactional',
        actions: [
            {
                content: (0, $8iiwm.default).login,
                onClick: ()=>{
                    $42cb6e1c2fdc593e$var$sendLoginClickEvent(operationName);
                    $42cb6e1c2fdc593e$var$reloadPage();
                }
            }
        ]
    });
    $42cb6e1c2fdc593e$var$sendAnalyticEvent(operationName);
};

});
parcelRegister("pa9q9", function(module, exports) {

$parcel$export(module.exports, "showFlag", () => $00ff685527f9e8c1$export$e12b2cc6b75b006b);
$parcel$export(module.exports, "dismissFlag", () => $00ff685527f9e8c1$export$900a08a292ad23cd);
$parcel$export(module.exports, "flagService", () => $00ff685527f9e8c1$export$dbb055af53fd81a0);
$parcel$export(module.exports, "useFlagsService", () => $00ff685527f9e8c1$export$eee61a1aafe3884);
$parcel$export(module.exports, "useFlagService", () => $00ff685527f9e8c1$export$dc4f8132c3090b32);
$parcel$export(module.exports, "isDismissFlag", () => $00ff685527f9e8c1$export$14b1864d9cf0809f);
$parcel$export(module.exports, "isFlagComponent", () => $00ff685527f9e8c1$export$d84ce5adcee46025);
$parcel$export(module.exports, "isBatchAction", () => $00ff685527f9e8c1$export$c126d8b307b8ab86);

var $fHfPB = parcelRequire("fHfPB");

var $gEdnQ = parcelRequire("gEdnQ");

var $01A9Z = parcelRequire("01A9Z");

var $7HGHK = parcelRequire("7HGHK");
const $00ff685527f9e8c1$export$e12b2cc6b75b006b = (0, $gEdnQ.default)((0, $01A9Z.store).dispatch);
const $00ff685527f9e8c1$export$900a08a292ad23cd = (0, $fHfPB.default)((0, $01A9Z.store).dispatch);
const $00ff685527f9e8c1$var$dismissFlagById = (id)=>{
    $00ff685527f9e8c1$export$900a08a292ad23cd((0, $fHfPB.dismissFlag)(id));
};
const $00ff685527f9e8c1$var$hasFlag = (id)=>Boolean((0, $01A9Z.store).getState().flags.find((flagInstance)=>'id' in flagInstance.flag && flagInstance.flag.id === id));
const $00ff685527f9e8c1$export$dbb055af53fd81a0 = {
    showFlag: $00ff685527f9e8c1$export$e12b2cc6b75b006b,
    dismissFlag: $00ff685527f9e8c1$export$900a08a292ad23cd
};
const $00ff685527f9e8c1$export$eee61a1aafe3884 = ()=>({
        showFlag: $00ff685527f9e8c1$export$e12b2cc6b75b006b,
        dismissFlag: $00ff685527f9e8c1$var$dismissFlagById,
        hasFlag: $00ff685527f9e8c1$var$hasFlag
    });
const $00ff685527f9e8c1$export$dc4f8132c3090b32 = ()=>$00ff685527f9e8c1$export$dbb055af53fd81a0;
const $00ff685527f9e8c1$export$14b1864d9cf0809f = (flag)=>typeof flag === 'object' && 'command' in flag && flag.command === (0, $7HGHK.DISMISS_COMMAND);
const $00ff685527f9e8c1$export$d84ce5adcee46025 = (flag)=>typeof flag === 'function' && !('type' in flag) && !('render' in flag);
const $00ff685527f9e8c1$export$cd5f9f2b991b82d9 = (flag)=>typeof flag === 'object' && 'render' in flag && typeof flag.render === 'function';
const $00ff685527f9e8c1$export$63ffd7d99470afd4 = (flag)=>!$00ff685527f9e8c1$export$14b1864d9cf0809f(flag) && !$00ff685527f9e8c1$export$d84ce5adcee46025(flag) && !$00ff685527f9e8c1$export$cd5f9f2b991b82d9(flag);
const $00ff685527f9e8c1$export$c126d8b307b8ab86 = (action)=>'meta' in action && action.meta && action.meta.batch && 'payload' in action && Array.isArray(action.payload);

});
parcelRegister("fHfPB", function(module, exports) {

$parcel$export(module.exports, "dismissFlag", () => $8eb241d1a1f5d9b7$export$900a08a292ad23cd);
$parcel$export(module.exports, "default", () => $8eb241d1a1f5d9b7$export$2e2bcd8739ae039);

var $d6YjM = parcelRequire("d6YjM");

var $7HGHK = parcelRequire("7HGHK");
const $8eb241d1a1f5d9b7$export$900a08a292ad23cd = (flagId)=>({
        command: (0, $7HGHK.DISMISS_COMMAND),
        id: flagId
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8eb241d1a1f5d9b7$export$2e2bcd8739ae039 = (dispatch)=>(action)=>{
        dispatch((0, $d6YjM.dismissFlagAction)(action.id));
    };

});
parcelRegister("d6YjM", function(module, exports) {

$parcel$export(module.exports, "SHOW", () => $07f19e2fef34903b$export$9d04158a25ce4cd);
$parcel$export(module.exports, "show", () => $07f19e2fef34903b$export$57bf213be019eeb0);
$parcel$export(module.exports, "DISMISS_INSTANCE", () => $07f19e2fef34903b$export$b31a07d2e6382678);
$parcel$export(module.exports, "dismiss", () => $07f19e2fef34903b$export$abf286bbe7073aba);
$parcel$export(module.exports, "DISMISS_FLAG", () => $07f19e2fef34903b$export$1eb56620df104bf);
$parcel$export(module.exports, "dismissFlagAction", () => $07f19e2fef34903b$export$4818b3c52448050d);
$parcel$export(module.exports, "RESET", () => $07f19e2fef34903b$export$4a991c87e640ef77);
$parcel$export(module.exports, "reset", () => $07f19e2fef34903b$export$aad8462122ac592b);
const $07f19e2fef34903b$export$9d04158a25ce4cd = 'state.SHOW';
const $07f19e2fef34903b$export$57bf213be019eeb0 = (payload)=>({
        type: $07f19e2fef34903b$export$9d04158a25ce4cd,
        payload: payload
    });
const $07f19e2fef34903b$export$b31a07d2e6382678 = 'state.DISMISS_INSTANCE';
const $07f19e2fef34903b$export$abf286bbe7073aba = (payload)=>({
        type: $07f19e2fef34903b$export$b31a07d2e6382678,
        payload: payload
    });
const $07f19e2fef34903b$export$1eb56620df104bf = 'state.DISMISS_FLAG';
const $07f19e2fef34903b$export$4818b3c52448050d = (payload)=>({
        type: $07f19e2fef34903b$export$1eb56620df104bf,
        payload: payload
    });
const $07f19e2fef34903b$export$4a991c87e640ef77 = 'state.RESET';
const $07f19e2fef34903b$export$aad8462122ac592b = ()=>({
        type: $07f19e2fef34903b$export$4a991c87e640ef77
    });

});

parcelRegister("7HGHK", function(module, exports) {

$parcel$export(module.exports, "DISMISS_COMMAND", () => $9deb2cdefe93babb$export$e705274c5e156b93);
$parcel$export(module.exports, "toFlagId", () => $9deb2cdefe93babb$export$8184bc29de2aea90);
$parcel$export(module.exports, "fromFlagId", () => $9deb2cdefe93babb$export$188cdb77b72629d7);
const $9deb2cdefe93babb$export$e705274c5e156b93 = 'DISMISS';
const $9deb2cdefe93babb$export$8184bc29de2aea90 = (flagId)=>new String(flagId);
const $9deb2cdefe93babb$export$188cdb77b72629d7 = (flagId)=>flagId.valueOf();

});


parcelRegister("gEdnQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c019df33694ffbe1$export$2e2bcd8739ae039);

var $7Jxgt = parcelRequire("7Jxgt");

var $d6YjM = parcelRequire("d6YjM");

var $7HGHK = parcelRequire("7HGHK");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c019df33694ffbe1$export$2e2bcd8739ae039 = (dispatch)=>(flag)=>{
        // Flag is of type FlagComponent
        if (typeof flag === 'function') {
            dispatch((0, $d6YjM.show)(flag));
            return undefined;
        }
        const flagId = flag.id || (0, $7HGHK.toFlagId)((0, $7Jxgt.v4)());
        const newFlag = {
            ...flag,
            id: flagId
        };
        dispatch((0, $d6YjM.show)(newFlag));
        return flagId;
    };

});

parcelRegister("01A9Z", function(module, exports) {

$parcel$export(module.exports, "store", () => $5787309a6ab0ba9c$export$6f57813fe9f31bf9);

var $imvpl = parcelRequire("imvpl");
const $5787309a6ab0ba9c$export$6f57813fe9f31bf9 = (0, $imvpl.createStore)();

});
parcelRegister("imvpl", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $6bbcd4b408b9a94e$export$f51a9068ac82ea43);

var $F2Mxm = parcelRequire("F2Mxm");

var $gG398 = parcelRequire("gG398");
const $6bbcd4b408b9a94e$export$f51a9068ac82ea43 = (rootEpic)=>(0, $F2Mxm.default)({
        appName: 'flags',
        rootReducer: $gG398.default,
        rootEpic: rootEpic
    });

});
parcelRegister("F2Mxm", function(module, exports) {

$parcel$export(module.exports, "default", () => $fca77440264e922e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3f2cs = parcelRequire("3f2cs");

var $aB8eX = parcelRequire("aB8eX");

var $e1AU2 = parcelRequire("e1AU2");

var $iGv2H = parcelRequire("iGv2H");

var $hkadP = parcelRequire("hkadP");

var $i9gPl = parcelRequire("i9gPl");

var /**
 * Initializes a Redux store with configurations for state management and middleware integration.
 * It addresses serialization challenges with non-serializable entities and enhances debugging capabilities.
 * The custom action listener middleware offers additional control over action dispatches.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$fca77440264e922e$export$2e2bcd8739ae039 = ({ appName: appName, rootReducer: rootReducer, initialState: initialState, rootEpic: rootEpic, rootEpicDependencies: rootEpicDependencies, middlewares: middlewares = [], enhancers: enhancers = [] })=>{
    const actionListenerMiddleware = new (0, $i9gPl.default)();
    middlewares.push(actionListenerMiddleware.perform);
    if ((0, $iGv2H.debugEnabled)('redux-logger')) {
        // include logger only for development environment
        // eslint-disable-next-line @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires
        const { logger: logger } = (parcelRequire("korqb"));
        middlewares.push(logger);
    }
    if (rootEpic) middlewares.push((0, $e1AU2.createEpicMiddleware)(rootEpic, rootEpicDependencies ? {
        dependencies: rootEpicDependencies
    } : undefined));
    const store = (0, $3f2cs.createStore)((0, $aB8eX.enableBatching)(rootReducer), initialState, (0, $hkadP.default)({
        name: appName,
        // @ts-expect-error - TS2345 - Argument of type '{ name: string; serialize: { replacer: (key: any, value: any) => any; }; }' is not assignable to parameter of type 'DevtoolsConfig'.
        serialize: {
            // Replacer function is necessary to fix redux-devtools because some actions and state are React Elements
            // and the default serialization gets into a loop in a circular dependency somewhere in internal React properties.
            // https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Arguments.md#serialize
            // @ts-expect-error - TS7006 - Parameter 'key' implicitly has an 'any' type. | TS7006 - Parameter 'value' implicitly has an 'any' type.
            replacer: (key, value)=>{
                if (/*#__PURE__*/ (0, $5uXOq.isValidElement)(value)) {
                    // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'string | JSXElementConstructor<any>'.
                    if (value.type && value.type.displayName) // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'string | JSXElementConstructor<any>'.
                    return `React Element <${value.type.displayName}>`;
                    return 'React Element';
                }
                // The benefit of using React + Redux + declarative API is that there is no more need to save DOM elements in store!
                // ... yet we still do. So when that happens, Redux devtools sometimes crashes because it tries to serialize circular DOM structure.
                if (typeof HTMLElement !== 'undefined' && value instanceof HTMLElement) return `HTMLElement<${value.tagName}>`;
                return value;
            }
        }
    })((0, $3f2cs.compose)(...enhancers, (0, $3f2cs.applyMiddleware)(...middlewares))));
    store.addActionListener = actionListenerMiddleware.add;
    store.removeActionListener = actionListenerMiddleware.remove;
    return store;
};

});
parcelRegister("iGv2H", function(module, exports) {

$parcel$export(module.exports, "debugEnabled", () => $a4079cece44c0fab$export$342c99cc1e9bc5c6);
const $a4079cece44c0fab$export$342c99cc1e9bc5c6 = (flag)=>''.split(',').includes(flag);

});

parcelRegister("hkadP", function(module, exports) {

$parcel$export(module.exports, "default", () => $607c98afd3082218$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");
var // An extended version of redux's 'compose' method, that
// will use redux devtools chrome extension if available
// https://github.com/zalmoxisus/redux-devtools-extension
//
// The 'devtoolsConfig' parameter is an object adhering to the following API:
// https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Arguments.md
// eslint-disable-next-line jira/import/no-anonymous-default-export
$607c98afd3082218$export$2e2bcd8739ae039 = (devtoolsConfig = {})=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const devtoolsEnhancer = false ? null : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    const config = {
        ...devtoolsConfig
    };
    if (config.name != null && config.instanceId == null) config.instanceId = config.name;
    return 0, $3f2cs.compose;
};

});

parcelRegister("i9gPl", function(module, exports) {

$parcel$export(module.exports, "default", () => $330df53c22ed8aaf$export$2e2bcd8739ae039);
class $330df53c22ed8aaf$export$2e2bcd8739ae039 {
    constructor(){
        this.listeners = [];
        this.add = (listener)=>{
            this.listeners.push(listener);
        };
        this.remove = (listener)=>{
            this.listeners = this.listeners.filter((l)=>l !== listener);
        };
        // @ts-expect-error - TS2315 - Type 'Middleware' is not generic.
        this.perform = (api)=>(next)=>(action)=>{
                    const result = next(action);
                    this.listeners.forEach((listener)=>listener(action, api.getState()));
                    return result;
                };
    }
}

});


parcelRegister("gG398", function(module, exports) {

$parcel$export(module.exports, "default", () => $1feeabef4760da78$export$2e2bcd8739ae039);

var $ifg6x = parcelRequire("ifg6x");

var $7Jxgt = parcelRequire("7Jxgt");

var $d6YjM = parcelRequire("d6YjM");
const $1feeabef4760da78$var$defaultState = {
    flags: []
};
var /**
 * Manages the state transitions of a notification system by handling actions such as showing
 * new notifications, dismissing notifications (either individually or by type), and
 * resetting to the default state. It uniquely prioritizes high-priority notifications,
 * ensuring they are displayed before low-priority ones, enhancing the user's
 * attention to critical alerts.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$1feeabef4760da78$export$2e2bcd8739ae039 = (state = $1feeabef4760da78$var$defaultState, action)=>{
    switch(action.type){
        case 0, $d6YjM.SHOW:
            {
                // If flag is of type FlagComponent, it is treated as high priority
                const [lowPriorityFlags, highPriorityFlags] = (0, (/*@__PURE__*/$parcel$interopDefault($ifg6x)))([
                    {
                        id: (0, $7Jxgt.v4)(),
                        flag: action.payload
                    },
                    ...state.flags
                ], ({ flag: flag })=>typeof flag !== 'function' && flag?.isLowPriority);
                const flags = [
                    ...highPriorityFlags,
                    ...lowPriorityFlags
                ];
                return {
                    ...state,
                    flags: flags
                };
            }
        case 0, $d6YjM.DISMISS_INSTANCE:
            {
                const id = action.payload;
                return {
                    ...state,
                    flags: state.flags.filter((flagInstance)=>flagInstance.id !== id)
                };
            }
        case 0, $d6YjM.DISMISS_FLAG:
            {
                const id = action.payload;
                return {
                    ...state,
                    flags: state.flags.filter((flagInstance)=>{
                        // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'Flag'.
                        if (flagInstance.flag.id) // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'Flag'.
                        return flagInstance.flag.id !== id;
                        return true;
                    })
                };
            }
        case 0, $d6YjM.RESET:
            return $1feeabef4760da78$var$defaultState;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});




parcelRegister("8iiwm", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c7ec0f26423b786$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2c7ec0f26423b786$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "relay-fetch.services.error-flags.title",
        "defaultMessage": "Something's gone wrong"
    },
    description: {
        "id": "relay-fetch.services.error-flags.description",
        "defaultMessage": "Looks like you've been signed out. Try logging in again. "
    },
    login: {
        "id": "relay-fetch.services.error-flags.login",
        "defaultMessage": "Log in"
    }
});

});


parcelRegister("7isEg", function(module, exports) {

$parcel$export(module.exports, "getLoggingAndMetricsHelper", () => $6c554999a424d172$export$726e1df8186bb981);

var $jqONe = parcelRequire("jqONe");

var $9XE6b = parcelRequire("9XE6b");

var $hGgHi = parcelRequire("hGgHi");

var $2YZCu = parcelRequire("2YZCu");

var $jJZqs = parcelRequire("jJZqs");
const $6c554999a424d172$var$LOG_NAMESPACE = 'relay.AGG.error.graphql';
const $6c554999a424d172$export$726e1df8186bb981 = (graphqlDetails)=>{
    const { queryName: queryName, operationKind: operationKind } = graphqlDetails;
    const logErrorRetry = (error, retryAttempt)=>{
        const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
            'statusCode'
        ], null);
        const errorType = error instanceof (0, $jJZqs.default) ? 'network' : 'unknown';
        // Log any errors even in SSR
        (0, $2YZCu.default).safeErrorWithoutCustomerData($6c554999a424d172$var$LOG_NAMESPACE, `[${errorType} error]`, {
            message: `[${(0, (/*@__PURE__*/$parcel$interopDefault($jqONe)))(errorType)} error]: ${error?.message ?? ''}`,
            errorType: errorType,
            statusCode: statusCode,
            queryName: queryName,
            operationKind: operationKind,
            errorName: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                'name'
            ], null),
            retryAttempt: retryAttempt
        });
    };
    return {
        logNonBreakingErrors: (errors, requestId)=>{
            if (false || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(errors) || !Array.isArray(errors)) return;
            errors.forEach((error)=>{
                error && (0, $2YZCu.default).safeErrorWithoutCustomerData($6c554999a424d172$var$LOG_NAMESPACE, '[graphql error]', {
                    queryName: queryName,
                    operationKind: operationKind,
                    errorType: 'graphql',
                    message: error.message,
                    requestId: requestId
                });
            });
        },
        logError: logErrorRetry,
        logErrorRetry: logErrorRetry
    };
};

});

parcelRegister("aLyyN", function(module, exports) {

$parcel$export(module.exports, "checkAuthentication", () => $00bea5ba58fba29b$export$b8dbb7d6029c5413);
$parcel$export(module.exports, "blocklist", () => $00bea5ba58fba29b$export$c5c28c9e707bcda1);
$parcel$export(module.exports, "getRetryAttemptsForQuery", () => $00bea5ba58fba29b$export$9dec0f42cc67f6ab);
$parcel$export(module.exports, "getTraceIdFromExtensions", () => $00bea5ba58fba29b$export$eefb7f54c3b07211);
$parcel$export(module.exports, "generateOptions", () => $00bea5ba58fba29b$export$c21133b4499f5374);
$parcel$export(module.exports, "shouldRetry", () => $00bea5ba58fba29b$export$7bfea3c3d460ecd8);

var $hGgHi = parcelRequire("hGgHi");

var $1UikQ = parcelRequire("1UikQ");

var $4R6GH = parcelRequire("4R6GH");

var $5euJh = parcelRequire("5euJh");

var $2I8bw = parcelRequire("2I8bw");

var $jJZqs = parcelRequire("jJZqs");

var $5HnTq = parcelRequire("5HnTq");

var $6b2ko = parcelRequire("6b2ko");

var $4tcSU = parcelRequire("4tcSU");

var $gwtGO = parcelRequire("gwtGO");

var $4Pf62 = parcelRequire("4Pf62");
let $00bea5ba58fba29b$var$redirecting = false;
const $00bea5ba58fba29b$export$ae8f795c4c44d494 = ()=>{
    $00bea5ba58fba29b$var$redirecting = false;
};
const $00bea5ba58fba29b$var$markAsRedirecting = ()=>{
    $00bea5ba58fba29b$var$redirecting = true;
};
if (typeof window !== 'undefined') // Mark as redirecting, when we're unloading the page to prevent double/unwatend redirection.
window.addEventListener('beforeunload', ()=>{
    if ((0, $4R6GH.fg)('hot-117634-firefox-redirection-issue-fix')) $00bea5ba58fba29b$var$markAsRedirecting();
});
const $00bea5ba58fba29b$var$redirect = ()=>{
    const identity = (0, $5euJh.getATLContextDomain)('id');
    // Hardcoding to Jira as this will be the only adopter of this service for now.
    const redirectUrl = `https://${identity}/login?application=jira&continue=${encodeURIComponent(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href)}`;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href = redirectUrl;
};
const $00bea5ba58fba29b$export$b8dbb7d6029c5413 = ()=>{
    if (!false && !$00bea5ba58fba29b$var$redirecting) {
        const heartbeatService = (0, $2I8bw.getInstance)();
        if (heartbeatService.isInitialized() && !heartbeatService.isAuthenticated()) {
            if ((0, $4R6GH.fg)('hot-117634-firefox-redirection-issue-fix')) {
                if (!$00bea5ba58fba29b$var$redirecting) $00bea5ba58fba29b$var$redirect();
            } else $00bea5ba58fba29b$var$redirect();
            // Set flag to prevent multiple redirects
            $00bea5ba58fba29b$var$markAsRedirecting();
        }
    }
    return $00bea5ba58fba29b$var$redirecting;
};
const $00bea5ba58fba29b$export$c5c28c9e707bcda1 = [
    'issueAggQuery'
];
const $00bea5ba58fba29b$export$9dec0f42cc67f6ab = (queryName, operationKind)=>{
    if (operationKind === 'query') return 0, $6b2ko.RETRY_ATTEMPTS_LIMIT;
    return 0;
};
const $00bea5ba58fba29b$export$eefb7f54c3b07211 = ({ extensions: extensions })=>{
    if (extensions !== undefined && extensions.gateway !== undefined && extensions.gateway !== null && typeof extensions.gateway.trace_id === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return extensions.gateway.trace_id;
    return undefined;
};
const $00bea5ba58fba29b$export$c21133b4499f5374 = (options = {}, url = null)=>{
    // the token fetcher returns undefined if no cookie value was found, also in SSR cookies are unavailable
    const csrfToken = !false ? (0, $4tcSU.default)() : undefined;
    // If we don't get a token, there is no point trying to add the csrf header
    const csrfTokenHeader = (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(csrfToken) ? {} : {
        'atl-xsrf-token': csrfToken
    };
    let atlAttribution = {};
    if ((0, $4R6GH.fg)('pass_extra_headers_to_agg')) {
        const tenantContext = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
        atlAttribution = {
            atlWorkspaceId: tenantContext.avpWorkspaceId,
            tenantId: tenantContext.cloudId,
            product: 'Atlassian Jira',
            businessUnit: 'Engineering-Atlassian Jira',
            service: 'afm-frontend',
            team: 'Atlassian Jira'
        };
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, {
        // We have to provide general options here or the headers we provide will override the default ones found
        // here /src/packages/platform/utils/fetch/src/utils/requests.js due to a shallow merge
        ...(0, $5HnTq.getDefaultOptions)(url),
        ...options
    }, {
        headers: {
            'atl-client-name': 'jira-frontend',
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'X-ExperimentalApi': (0, $gwtGO.default).join(','),
            'atl-attribution': JSON.stringify(atlAttribution),
            ...csrfTokenHeader
        }
    });
};
const $00bea5ba58fba29b$export$7bfea3c3d460ecd8 = (error)=>{
    if (error instanceof (0, $jJZqs.default)) return [
        502,
        503,
        504
    ].includes(error.statusCode);
    return false;
};

});
parcelRegister("gwtGO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1019e315ad42f34a$export$2e2bcd8739ae039);
// Please add your Experimental API name below
// You do not need to wait for approval to add to this list
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $1019e315ad42f34a$export$2e2bcd8739ae039 = [
    'ariGraph',
    'boardCardMove',
    'deleteCard',
    'JiraJqlBuilder',
    'SoftwareCardTypeTransitions',
    'jira-releases-v0',
    'JiraDevOps',
    'JiraDevOpsProviders',
    'createCustomFilter',
    'updateCustomFilter',
    'deleteCustomFilter',
    'customFilters',
    'PermissionScheme',
    'JiraIssue',
    'projectStyle',
    'startSprintPrototype',
    'AddIssuesToFixVersion',
    'JiraVersionResult',
    'JiraIssueConnectionJql',
    'JiraFieldOptionSearching',
    'JiraIssueFieldMutations',
    'JiraIssueDevInfoDetails',
    'JiraIssueDevSummaryCache',
    'JiraVersionWarningConfig',
    'JiraReleaseNotesConfiguration',
    'JiraUpdateReleaseNotesConfiguration',
    'ReleaseNotes',
    'ReleaseNotesOptions',
    'DeploymentsFeaturePrecondition',
    'UpdateVersionWarningConfig',
    'UpdateVersionName',
    'UpdateVersionDescription',
    'UpdateVersionStartDate',
    'UpdateVersionReleaseDate',
    'VersionsForProject',
    'RelatedWork',
    'SuggestedRelatedWorkCategories',
    'setIssueMediaVisibility',
    'toggleBoardFeature',
    'DevOpsProvider',
    'DevOpsSummarisedDeployments',
    'JiraProject',
    'DevOpsSummarisedEntities',
    'RoadmapsMutation',
    'RoadmapsQuery',
    'JiraApplicationProperties',
    'JiraIssueSearch',
    'JiraFilter',
    'featureGroups',
    'setBoardEstimationType',
    'devOps',
    'softwareBoards',
    'name',
    'AddRelatedWorkToVersion',
    'RemoveRelatedWorkFromVersion',
    'admins',
    'canAdministerBoard',
    'jql',
    'globalCardCreateAdditionalFields',
    'GlobalTimeTrackingSettings',
    'ReleaseNotesOptions',
    'search-experience',
    'MoveOrRemoveIssuesToFixVersion',
    'compass-beta',
    'JiraIssueSearchStatus',
    'Townsquare',
    'JiraNavigationItems',
    'JiraVersionsForProjects',
    'columnConfigs'
];

});



parcelRegister("dMryf", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $cad88c39422b51e7$export$e7aa7bc5c1b3cfb3);

var $hGgHi = parcelRequire("hGgHi");

var $eiowN = parcelRequire("eiowN");

var $eusud = parcelRequire("eusud");

var $4R6GH = parcelRequire("4R6GH");

var $6b2ko = parcelRequire("6b2ko");

var $5a0Nh = parcelRequire("5a0Nh");

var $kipqU = parcelRequire("kipqU");

var $7pVV3 = parcelRequire("7pVV3");

var $ajjqZ = parcelRequire("ajjqZ");

var $4pgHP = parcelRequire("4pgHP");

var $eCZ6m = parcelRequire("eCZ6m");

var $5Wobd = parcelRequire("5Wobd");

var $lKFKm = parcelRequire("lKFKm");

var $7isEg = parcelRequire("7isEg");

var $aLyyN = parcelRequire("aLyyN");
const $cad88c39422b51e7$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig)=>{
    if (!(0, $4R6GH.fg)('remove_heartbeat_service_from_jira_relay_fetch')) {
        const redirecting = (0, $aLyyN.checkAuthentication)();
        if (redirecting) // Hang the request if we are redirecting - should be cleared on redirect
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return (0, $eiowN.Observable).from(new Promise(()=>{}));
    }
    const { name: queryName, operationKind: operationKind } = request;
    const earlyScriptPromise = !false && (0, $ajjqZ.claimEarlyScriptPromise)((0, $ajjqZ.getEarlyScriptPromiseKey)(request, variables)) || undefined;
    const loggingMetadata = {
        queryName: queryName,
        operationKind: operationKind
    };
    const loggingAndMetrics = (0, $7isEg.getLoggingAndMetricsHelper)(loggingMetadata);
    return (0, $eiowN.Observable).create((sink)=>{
        try {
            const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
            const endpoint = (0, $eCZ6m.getAggEndpoint)(request, cacheConfig);
            const body = (0, $eCZ6m.getRequestBody)(request, variables);
            let ssrCache = null;
            if (!false && requestID != null) ssrCache = (0, $7pVV3.getQueryResponseCache)().get(requestID, variables);
            // On client read cache from window.SPA_STATE if available
            if (!false && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(ssrCache)) {
                sink.next(ssrCache);
                if (requestID != null) (0, $7pVV3.getQueryResponseCache)().delete(requestID, variables);
                sink.complete();
                return;
            }
            const wrappedEarlyScriptPromise = earlyScriptPromise && (0, $6b2ko.retryOnError)(()=>(0, $eusud.applyErrorHandling)(earlyScriptPromise), {
                retryFunc: ()=>(0, $eusud.performPostRequest)(endpoint, (0, $aLyyN.generateOptions)({
                        body: body
                    }, endpoint)),
                retryPredicate: (0, $aLyyN.shouldRetry),
                retryAttempts: (0, $aLyyN.getRetryAttemptsForQuery)(queryName, operationKind),
                onRetry: loggingAndMetrics.logErrorRetry
            });
            // Throws HttpError
            const promise = !false && wrappedEarlyScriptPromise !== undefined ? wrappedEarlyScriptPromise : Promise.resolve((0, $eusud.performPostRequestWithRetry)(endpoint, {
                ...(0, $aLyyN.generateOptions)({
                    body: body
                }, endpoint),
                retryPredicate: (0, $aLyyN.shouldRetry),
                retryAttempts: (0, $aLyyN.getRetryAttemptsForQuery)(queryName, operationKind),
                onRetry: (error, attempt)=>{
                    loggingAndMetrics.logErrorRetry(error, attempt);
                }
            }));
            promise.then((response)=>{
                (0, $5Wobd.addTraceId)(queryName, (0, $aLyyN.getTraceIdFromExtensions)(response));
                (0, $4pgHP.putExtensions)(queryName, response.extensions);
                // @ts-expect-error - TS2339 - Property 'errors' does not exist on type 'GraphQLSingularResponse'.
                const errors = response.errors || undefined;
                if (errors != null) {
                    const requestId = response?.extensions?.gateway?.request_id;
                    if (!(0, $aLyyN.blocklist).includes(queryName)) loggingAndMetrics.logNonBreakingErrors(errors, requestId);
                    (0, $5a0Nh.captureErrors)(errors, {
                        operationName: queryName,
                        requestId: requestId
                    });
                    if ((0, $5a0Nh.isUnauthenticated)(errors)) {
                        //  Short circuit operation and handle the unauthorized errors.
                        (0, $lKFKm.showUnauthenticatedFlag)(queryName);
                        // Surprise behaviour: the observable should hang indefinitely here!
                        // At least, that is the expectation of existing code; see src/packages/issue/issue-view/src/integration-tests/experience-tracking/view.cy-integration.tsx
                        // Which assumes that the operation never completes, so relay never receives a (null) response, so it never complains about the data.
                        // This should be revised; see https://jplat.atlassian.net/browse/MAGMA-3087
                        return;
                    }
                }
                if (response.data && (response.data.jira === null || response.data.customerService === null)) // Enforce non-nullability of the jira and customerService namespaces. This is an intermediary solution to
                // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
                // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
                // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Data
                response.data = null;
                // cache query response on SSR
                if (false && requestID != null) (0, $7pVV3.getQueryResponseCache)().setWithMetadata(requestID, variables, response, loggingMetadata);
                sink.next(response);
                sink.complete();
            })// We don't await the promise so the catch block below is never
            // triggered so we need an independent catch on the promise
            .catch((error)=>{
                loggingAndMetrics.logError(error);
                sink.error(error);
            });
            if (requestID != null) // todo: stop sending the value of the promise to QueryPromisesMap. Might happen as part of cleaning up the feature gate for defer support writ large.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $kipqU.QueryPromisesMap).set(requestID, promise);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            loggingAndMetrics.logError(error);
            sink.error(error);
        }
    });
};

});


parcelRegister("k1TrK", function(module, exports) {

$parcel$export(module.exports, "subscribe", () => $4ced6779db298dc0$export$ec068583843480e7);

var $eiowN = parcelRequire("eiowN");

var $jcw0u = parcelRequire("jcw0u");

var $lWhTC = parcelRequire("lWhTC");

var $1Uhm6 = parcelRequire("1Uhm6");

var $cfDZ3 = parcelRequire("cfDZ3");
const $4ced6779db298dc0$export$ec068583843480e7 = ({ id: id, name: operationName }, variables)=>(0, $eiowN.Observable).create((sink)=>{
        const client = (0, $lWhTC.getClient)();
        if (!client) return sink.error(new Error('Unable to create subscription client'));
        const payload = {
            query: '',
            operationName: operationName,
            variables: variables,
            extensions: {
                pq: id
            }
        };
        let requestId;
        return client.subscribe(payload, {
            ...sink,
            next: (value)=>{
                // @ts-expect-error agg prop is missing on generic "extensions" type
                const aggRequestId = value?.extensions?.gateway?.request_id;
                requestId = aggRequestId ?? requestId;
                // @ts-expect-error incompatible types between two libraries
                sink.next(value);
            },
            error: (sinkError)=>{
                const errorInfo = (0, $1Uhm6.getSinkError)(sinkError);
                const attributes = {
                    operationName: operationName,
                    requestId: requestId,
                    userLocation: (0, $cfDZ3.getUserLocation)()
                };
                sink.error(errorInfo);
                (0, $jcw0u.default)({
                    meta: {
                        id: 'subscription',
                        packageName: 'jiraRelaySubscription',
                        teamName: 'uip-graphql'
                    },
                    error: errorInfo,
                    attributes: attributes,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
    });

});
parcelRegister("lWhTC", function(module, exports) {

$parcel$export(module.exports, "getClient", () => $2a46eca1e9133707$export$6bb76d6eba7e258c);

var $4U1PW = parcelRequire("4U1PW");

var $jp5kW = parcelRequire("jp5kW");

var $gwtGO = parcelRequire("gwtGO");


var $hoQbP = parcelRequire("hoQbP");
let $2a46eca1e9133707$var$client;
const $2a46eca1e9133707$export$6bb76d6eba7e258c = ()=>{
    if ((0, $hoQbP.isSSR)() || (0, $jp5kW.default)('graphql_subscriptions')) return null;
    if (!$2a46eca1e9133707$var$client) $2a46eca1e9133707$var$client = (0, $4U1PW.createClient)({
        url: (0, $hoQbP.getAggSubscriptionEndpoint)(),
        lazy: true,
        keepAlive: (0, $37d1b046897e548f$export$8b012b965402e06a),
        retryAttempts: (0, $37d1b046897e548f$export$bf6cd96e19b2987f),
        connectionParams: {
            'atl-client-name': 'jira-frontend',
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'X-ExperimentalApi': (0, $gwtGO.default).join(',')
        }
    });
    return $2a46eca1e9133707$var$client;
};
const $2a46eca1e9133707$export$2f0afd443356d36f = ()=>{
    $2a46eca1e9133707$var$client = null;
};

});
const $37d1b046897e548f$export$8b012b965402e06a = 580000; // 9m 40 - timeframe needed for UCT token refresh: https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
const $37d1b046897e548f$export$bf6cd96e19b2987f = 100;
const $37d1b046897e548f$export$1ad8434180c5936c = 300000; // 5m

parcelRegister("hoQbP", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $9e6d9986231c3fe5$export$48d7c418edadb60c);
$parcel$export(module.exports, "getAggSubscriptionEndpoint", () => $9e6d9986231c3fe5$export$29a72e89601dfc59);
const $9e6d9986231c3fe5$export$48d7c418edadb60c = ()=>false ?? false;
const $9e6d9986231c3fe5$export$29a72e89601dfc59 = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    `${window.location.origin.replace('http', 'ws')}/gateway/api/graphql/subscriptions`;

});


parcelRegister("1Uhm6", function(module, exports) {

$parcel$export(module.exports, "getSinkError", () => $db2d4e9951ebaa0f$export$ece4736473c28965);
const $db2d4e9951ebaa0f$export$ece4736473c28965 = (error)=>{
    let errorInfo;
    if (Array.isArray(error)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    [errorInfo] = error;
    else if (error instanceof Error) errorInfo = error;
    else if (typeof error === 'object' && 'type' in error && error.type === 'close') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`CloseEvent: ${error.reason}`);
    else if (typeof error === 'object' && 'type' in error && error.type === 'error') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`ErrorEvent: "${error.error}"`);
    else if (error instanceof Event) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`Event: ${error.type}`);
    else errorInfo = new Error(`Unknown sink error: ${error}`);
    if (error instanceof Error && error.stack) errorInfo.stack = error.stack;
    return errorInfo;
};

});


parcelRegister("fwvto", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $c5bf640417859136$export$48d7c418edadb60c);
const $c5bf640417859136$export$48d7c418edadb60c = ()=>false ?? false;

});




parcelRegister("d5W4H", function(module, exports) {

$parcel$export(module.exports, "canFetchForgeModules", () => $f4d6ea2b45e6b20f$export$bb3a4a3b8e654c08);
const $f4d6ea2b45e6b20f$export$bb3a4a3b8e654c08 = ({ isAnonymous: isAnonymous, cloudId: cloudId })=>{
    /**
	 * SMT-1142
	 * A tenant named `bob` is most likely a local/ci instance started with `./jmake run ci`.
	 * It wasn't possible to find the hostname in a reasonable timeframe so this is the most feasible solution.
	 * In case more tenants like this spawn in the future we'd need to mark these instances instead and block here.
	 */ if (String(cloudId) === 'bob') return false;
    /**
	 * Similarly to the `bob` tenant situation above, we don't want to fetch Forge modules on monolith webdriver tests,
	 * that are also started with `./jmake run ci`, but this time with a valid `cloudId`.
	 * The reason for that is the heartbeat service that is not available in there, which leads to the login page redirects.
	 */ if (!false && $f4d6ea2b45e6b20f$export$489a82a1efc4cd04().endsWith('.atl-test.space')) return false;
    // There is no anonymous access for now
    return !isAnonymous;
};
const $f4d6ea2b45e6b20f$export$489a82a1efc4cd04 = ()=>window.location.hostname;

});

parcelRegister("h8M2b", function(module, exports) {

$parcel$export(module.exports, "toMappedExtensions", () => $cb129cf486f6f6f7$export$e073e0c0d1c23345);

var $4R6GH = parcelRequire("4R6GH");
function $cb129cf486f6f6f7$export$e073e0c0d1c23345(requestedModules, returnedExtensions) {
    const result = Object.fromEntries(requestedModules.map((type)=>[
            type,
            []
        ]));
    const extensions = (0, $4R6GH.fg)('forge-extensions-module-id-for-relay') ? $cb129cf486f6f6f7$export$acd8ca2c14bd2aa4(returnedExtensions) : returnedExtensions;
    extensions.forEach((extension)=>{
        result[extension.type]?.push(extension);
    });
    // There is no better way to work this out and preserve a generic object response
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return result;
}
function $cb129cf486f6f6f7$export$acd8ca2c14bd2aa4(extensions) {
    return extensions.map(({ moduleId: moduleId, ...rest })=>({
            ...rest,
            id: moduleId ?? rest.id.replace(/-+\d+$/, ''),
            moduleId: moduleId
        }));
}

});

parcelRegister("ioGTN", function(module, exports) {

$parcel$export(module.exports, "trackGraphQLErrors", () => $03e8a2344fd340fa$export$a5c00ff206a4c88b);

var $5a0Nh = parcelRequire("5a0Nh");

var $bvblX = parcelRequire("bvblX");

var $5Wobd = parcelRequire("5Wobd");
function $03e8a2344fd340fa$export$a5c00ff206a4c88b(operationName) {
    const queryId = (0, $5a0Nh.startCaptureGraphQlErrors)();
    (0, $5Wobd.startCapturingTraceIds)(operationName);
    return {
        stopGraphQLErrorTracking: ()=>(0, $5Wobd.stopCapturingTraceIds)(operationName),
        getGraphQLError: ()=>$03e8a2344fd340fa$var$getGraphQLError(queryId, operationName)
    };
}
function $03e8a2344fd340fa$var$getGraphQLError(key, operationName) {
    const errors = (0, $5a0Nh.stopCaptureGraphQlErrors)(key).filter((errorWrapper)=>errorWrapper.meta.operationName === operationName).flatMap((errorWrapper)=>errorWrapper.errors);
    if (errors.length) return new (0, $bvblX.TrackedGraphQLError)(`Query ${operationName} had graphql errors`, errors, (0, $5Wobd.getTraceIds)(operationName));
    return undefined;
}

});


parcelRegister("dK8AG", function(module, exports) {

$parcel$export(module.exports, "getProjectKeyOrId", () => $9ffe1ab8f180b628$export$43cde151f667c69e);
$parcel$export(module.exports, "getProjectKeyOrIdFromMatchAndQuery", () => $9ffe1ab8f180b628$export$b87af5b274141bd6);

var $1nb22 = parcelRequire("1nb22");
const $9ffe1ab8f180b628$export$43cde151f667c69e = (match)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, match.query);
    return projectKey || projectId || '';
};
const $9ffe1ab8f180b628$export$b87af5b274141bd6 = ({ match: match, query: query })=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    return projectKey || projectId;
};

});
parcelRegister("1nb22", function(module, exports) {

$parcel$export(module.exports, "getProjectKey", () => $061afadfbcc74f44$export$667f2a0f99c75faa);
$parcel$export(module.exports, "getProjectIdOrKey", () => $061afadfbcc74f44$export$c072f183553fb7ea);
$parcel$export(module.exports, "getProjectKeyId", () => $061afadfbcc74f44$export$1f7213d0f9054f06);
const $061afadfbcc74f44$export$89040d072f281f85 = (query)=>query?.selectedProjectId || query?.pid || query?.projectId || query?.['project.id'];
const $061afadfbcc74f44$export$667f2a0f99c75faa = (match, query)=>match?.params.projectKey || query?.projectKey || query?.['project.key'] || (match.params?.issueKey || '').split('-')[0];
const $061afadfbcc74f44$export$c072f183553fb7ea = (match, query)=>$061afadfbcc74f44$export$89040d072f281f85(query) || $061afadfbcc74f44$export$667f2a0f99c75faa(match, query);
const $061afadfbcc74f44$export$1f7213d0f9054f06 = (match, query)=>{
    // handle reports legacy url or project settings details
    const projectId = $061afadfbcc74f44$export$89040d072f281f85(query);
    const projectKey = $061afadfbcc74f44$export$667f2a0f99c75faa(match, query);
    return {
        projectKey: projectKey,
        projectId: projectId
    };
};

});


parcelRegister("gNStA", function(module, exports) {

$parcel$export(module.exports, "resourceWithCondition", () => $4fbc57fe7e788209$export$cac04afc5a06c544);
$parcel$export(module.exports, "resourceWithCondition2", () => $4fbc57fe7e788209$export$78488a529a07cd46);
$parcel$export(module.exports, "browserOnlyResourceWithCondition", () => $4fbc57fe7e788209$export$5284559c6d2f1a7b);

var $kbVA4 = parcelRequire("kbVA4");
const $4fbc57fe7e788209$export$cac04afc5a06c544 = (conditionGetter, resourceTrue)=>resourceTrue && {
        get type () {
            return conditionGetter() ? resourceTrue.type : (0, $kbVA4.RESOURCE_TYPE_NOOP);
        },
        getKey: resourceTrue.getKey,
        get maxAge () {
            return conditionGetter() ? resourceTrue.maxAge : Number.MAX_SAFE_INTEGER;
        },
        getData: (routerContext, customContext)=>conditionGetter() ? resourceTrue.getData(routerContext, customContext) : Promise.resolve(null),
        maxCache: resourceTrue.maxCache,
        get isBrowserOnly () {
            return resourceTrue.isBrowserOnly;
        },
        get depends () {
            return resourceTrue.depends;
        },
        get skipBrowser () {
            return resourceTrue.skipBrowser;
        }
    };
const $4fbc57fe7e788209$export$fbf6681b373be4c4 = (resource, amendments = {})=>// @ts-expect-error - TS2322 - Type 'Partial<RouteResource<any>>' is not assignable to type 'RouteResource<any>'.
    resource && // IMPORTANT - resources can be falsy in SSR "routes" build
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.defineProperties({}, {
        ...Object.getOwnPropertyDescriptors(resource),
        ...Object.getOwnPropertyDescriptors(amendments)
    });
const $4fbc57fe7e788209$export$78488a529a07cd46 = (conditionGetter, itemTrue, itemFalse = $4fbc57fe7e788209$export$fbf6681b373be4c4(itemTrue, {
    getKey: ()=>'DEGENERATE_KEY',
    getData: ()=>null,
    maxAge: Number.MAX_SAFE_INTEGER
}))=>// @ts-expect-error - TS2740 - Type '{}' is missing the following properties from type 'RouteResource<any>': type, getKey, maxAge, getData, and 3 more.
    itemTrue && // IMPORTANT - resources can be falsy in SSR "routes" build
    Object.defineProperties({}, Object.fromEntries([
        ...Object.keys(itemTrue),
        ...Object.keys(itemFalse)
    ].filter((v, i, a)=>a.indexOf(v) === i).map((key)=>[
            key,
            {
                configurable: false,
                enumerable: true,
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'RouteResource<any>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'RouteResource<any>'.
                get: ()=>conditionGetter() ? itemTrue[key] : itemFalse[key]
            }
        ])));
const $4fbc57fe7e788209$export$5284559c6d2f1a7b = (conditionGetter, resource)=>resource && {
        ...resource,
        get isBrowserOnly () {
            return !!conditionGetter();
        }
    };

});
parcelRegister("kbVA4", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_NOOP", () => $513d12eeb22c04a1$export$eb37f5d331ea4de4);
$parcel$export(module.exports, "MIN_MAX_AGE", () => $513d12eeb22c04a1$export$5664a170ac5a9781);
const $513d12eeb22c04a1$export$eb37f5d331ea4de4 = 'NOOP';
const $513d12eeb22c04a1$export$5664a170ac5a9781 = 5000;

});


parcelRegister("1yLrr", function(module, exports) {

$parcel$export(module.exports, "uniqueExtensionsFilter", () => $8bb90f56b7c2b78a$export$2b91ba95eded67f6);
$parcel$export(module.exports, "adminPageFilter", () => $8bb90f56b7c2b78a$export$1eefd1d9cde49fd5);

var $3JOCw = parcelRequire("3JOCw");

var $e0AC8 = parcelRequire("e0AC8");
const $8bb90f56b7c2b78a$export$2b91ba95eded67f6 = (extensions)=>(0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(extensions, (extension)=>{
        const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
        return `${appId}_${envId}`;
    });
const $8bb90f56b7c2b78a$export$1eefd1d9cde49fd5 = (extensions)=>{
    const configPageFilter = (extension)=>extension.properties.useAsConfig;
    const getStartedPageFilter = (extension)=>extension.properties.useAsGetStarted;
    const mainPageFilter = (extension)=>!configPageFilter(extension) && !getStartedPageFilter(extension);
    return [
        ...$8bb90f56b7c2b78a$export$2b91ba95eded67f6(extensions.filter(mainPageFilter)),
        ...$8bb90f56b7c2b78a$export$2b91ba95eded67f6(extensions.filter(configPageFilter)),
        ...$8bb90f56b7c2b78a$export$2b91ba95eded67f6(extensions.filter(getStartedPageFilter))
    ];
};

});
parcelRegister("3JOCw", function(module, exports) {

var $bxDef = parcelRequire("bxDef");

var $7CoLY = parcelRequire("7CoLY");
/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $2b8cd72f1d3e4fca$var$uniqBy(array, iteratee) {
    return array && array.length ? $7CoLY(array, $bxDef(iteratee, 2)) : [];
}
module.exports = $2b8cd72f1d3e4fca$var$uniqBy;

});

parcelRegister("e0AC8", function(module, exports) {

$parcel$export(module.exports, "parseExtensionId", () => $d4c89d40e0b3eaac$export$bae42cbaf7fa3e1b);
$parcel$export(module.exports, "getSameEnvAppIdFromExtensionId", () => $d4c89d40e0b3eaac$export$a92b17288693d366);
const $d4c89d40e0b3eaac$export$bae42cbaf7fa3e1b = (extensionId)=>{
    const [, appId, envId] = extensionId.split('/');
    return {
        appId: appId,
        envId: envId
    };
};
const $d4c89d40e0b3eaac$export$a92b17288693d366 = (extensionId)=>extensionId.split('/').slice(1, 3).join('/');

});



parcelRegister("b2pl3", function(module, exports) {

$parcel$export(module.exports, "staticJSMProjectConnectAddonsNavigationResource", () => $565682b770797f58$export$fab84295e18e9246);

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");

var $jAGOQ = parcelRequire("jAGOQ");
const $565682b770797f58$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $565682b770797f58$export$fab84295e18e9246 = (0, $2M1hQ.createResource)({
    type: 'NAVIGATION_SIDEBAR_JSM_PROJECT_CONNECT_ADDONS_QUEUES_RESOURCE',
    getKey: ({ match: match, query: query })=>$565682b770797f58$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $565682b770797f58$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $jAGOQ.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'jsm_queues');
        return navInfo;
    },
    maxAge: 300000
});

});
parcelRegister("jAGOQ", function(module, exports) {

$parcel$export(module.exports, "fetchProjectSidebarConnectNavigationInfo", () => $45e9310ad65e3e88$export$b15f9f5cf6db359e);

var $eusud = parcelRequire("eusud");
const $45e9310ad65e3e88$export$b15f9f5cf6db359e = (projectKeyOrId, sidebarType)=>{
    if (projectKeyOrId == null) throw new Error('invalid identifier specified');
    return (0, $eusud.performGetRequest)(`/rest/navigation/4/sidebar/project/${projectKeyOrId}/addons?type=${sidebarType}`);
};

});


parcelRegister("gS5PF", function(module, exports) {

$parcel$export(module.exports, "staticSidebarJsmReportsResource", () => $e7e607725980fdf6$export$ec28065a31cce4ce);

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");

var $cQGRH = parcelRequire("cQGRH");
const $e7e607725980fdf6$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $e7e607725980fdf6$export$ec28065a31cce4ce = (0, $2M1hQ.createResource)({
    type: 'NAVIGATION_SIDEBAR_JIRA_SERVICE_MANAGEMENT_REPORTS',
    getKey: ({ match: match, query: query })=>$e7e607725980fdf6$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $e7e607725980fdf6$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        return (0, $cQGRH.fetchJsmReportsSidebarNavInfo)(projectKeyOrId);
    },
    maxAge: 300000
});

});
parcelRegister("cQGRH", function(module, exports) {

$parcel$export(module.exports, "fetchJsmReportsSidebarNavInfo", () => $ed2ba0d649a8d8eb$export$c1dd51127051647d);

var $eusud = parcelRequire("eusud");
const $ed2ba0d649a8d8eb$export$c1dd51127051647d = (projectIdOrKey)=>{
    if (projectIdOrKey == null) throw new Error('invalid project id or key');
    return (0, $eusud.performGetRequest)(`/rest/navigation/4/servicedesk/project/${projectIdOrKey}/reports`);
};

});


parcelRegister("jYeNO", function(module, exports) {

$parcel$export(module.exports, "getCalendarFilterFieldsResource", () => $4dc70aab7904ddfa$export$5f02bf5f04197ed7);
$parcel$export(module.exports, "useCalendarFilterResource", () => $4dc70aab7904ddfa$export$70361b748d216408);

var $5uXOq = parcelRequire("5uXOq");

var $fZneA = parcelRequire("fZneA");

var $eusud = parcelRequire("eusud");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $4R6GH = parcelRequire("4R6GH");

var $3ezTL = parcelRequire("3ezTL");


var $30Hlr = parcelRequire("30Hlr");
const $4dc70aab7904ddfa$var$fetchFilterFieldsOld = async (cloudId, jqlContext)=>{
    try {
        const response = await (0, $eusud.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $8c2713286c62bdd7$export$546e90157aa718d4),
                variables: {
                    cloudId: cloudId,
                    contextFieldsFilter: (0, $4R6GH.fg)('corcap-3439-support-sdorigin-jqlbuilder-queue') ? {
                        jqlTerms: [
                            (0, $3ezTL.REQUEST_TYPE_FILTER),
                            (0, $3ezTL.SERVICE_DESK_ORIGIN_FILTER),
                            (0, $3ezTL.SERVICE_DESK_ORIGIN_DUPLICATE_FILTER)
                        ]
                    } : {
                        searchString: (0, $3ezTL.REQUEST_TYPE_FILTER)
                    },
                    jqlContext: jqlContext
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'JiraJqlBuilder'
            }
        });
        return (0, $30Hlr.transformAndReport)(response);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!(0, $fZneA.isHttpClientErrorResponse)(error)) (0, $30Hlr.reportError)(error);
        return 0, $3ezTL.DEFAULT_CALENDAR_FILTER_FIELDS;
    }
};
const $4dc70aab7904ddfa$var$fetchFilterFields = async (cloudId)=>{
    try {
        const requestTypeFieldResponse = await (0, $eusud.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $8c2713286c62bdd7$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        const requestTypeField = requestTypeFieldResponse.data?.jira?.requestTypeField;
        if (!requestTypeField) return 0, $3ezTL.DEFAULT_CALENDAR_FILTER_FIELDS;
        return [
            {
                ...requestTypeField,
                searchTemplate: requestTypeField.searchTemplate.key,
                fieldType: requestTypeField.type
            },
            ...(0, $3ezTL.DEFAULT_CALENDAR_FILTER_FIELDS)
        ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!(0, $fZneA.isHttpClientErrorResponse)(error)) (0, $30Hlr.reportError)(error);
        return 0, $3ezTL.DEFAULT_CALENDAR_FILTER_FIELDS;
    }
};
const $4dc70aab7904ddfa$var$filterFieldsResource = (0, $2M1hQ.createResource)({
    type: (0, $3ezTL.RESOURCE_TYPE_FILTER_FIELD),
    getKey: ({ match: match, query: query })=>{
        if ((0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag')) {
            const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
            const projectIdOrKey = projectKey || projectId;
            return (0, $3ezTL.RESOURCE_TYPE_FILTER_FIELD) + projectIdOrKey;
        }
        return 0, $3ezTL.RESOURCE_TYPE_FILTER_FIELD;
    },
    getData: ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        const projectIdOrKey = projectKey || projectId;
        const jqlContext = `project = '${projectIdOrKey}'`;
        return (0, $4R6GH.fg)('move_jsm_views_rt_filter_to_new_query') ? $4dc70aab7904ddfa$var$fetchFilterFields(cloudId) : $4dc70aab7904ddfa$var$fetchFilterFieldsOld(cloudId, jqlContext);
    },
    maxAge: Infinity
});
const $4dc70aab7904ddfa$export$5f02bf5f04197ed7 = ()=>$4dc70aab7904ddfa$var$filterFieldsResource;
const $4dc70aab7904ddfa$export$70361b748d216408 = ({ isSimplified: isSimplified })=>{
    const resource = (0, $2YP9W.useResource)($4dc70aab7904ddfa$var$filterFieldsResource);
    (0, $5uXOq.useEffect)(()=>{
        if (((0, $4R6GH.fg)('corcap-3439-support-sdorigin-jqlbuilder-queue') || (0, $4R6GH.fg)('move_jsm_views_rt_filter_to_new_query')) && !isSimplified && !resource.loading && !resource.error && !resource.data?.find((field)=>typeof field === 'object' && Object.values(field).includes((0, $30Hlr.TARGET_FILTER_TYPE)))) (0, $30Hlr.reportError)(new Error('Unable to prefetch request type'));
    }, [
        isSimplified,
        resource.data,
        resource.error,
        resource.loading
    ]);
    return resource;
};

});
parcelRegister("3ezTL", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_NAME", () => $2fdfca9bb2287268$export$186e93e8ef3f9358);
$parcel$export(module.exports, "PACKAGE_NAME", () => $2fdfca9bb2287268$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $2fdfca9bb2287268$export$d57b6b390e78d90f);
$parcel$export(module.exports, "REQUEST_TYPE_FILTER", () => $2fdfca9bb2287268$export$2c388650eabddf5e);
$parcel$export(module.exports, "SERVICE_DESK_ORIGIN_FILTER", () => $2fdfca9bb2287268$export$2fcf90614ee15858);
$parcel$export(module.exports, "SERVICE_DESK_ORIGIN_DUPLICATE_FILTER", () => $2fdfca9bb2287268$export$43482ff574598f59);
$parcel$export(module.exports, "RESOURCE_TYPE_FILTER_FIELD", () => $2fdfca9bb2287268$export$2019de80301f1da);
$parcel$export(module.exports, "DEFAULT_CALENDAR_FILTER_FIELDS", () => $2fdfca9bb2287268$export$2912f30d4328fc00);
const $2fdfca9bb2287268$export$186e93e8ef3f9358 = 'calendarFilterFieldResource';
const $2fdfca9bb2287268$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesServicedeskCalendar';
const $2fdfca9bb2287268$export$d57b6b390e78d90f = 'jsd-shield';
const $2fdfca9bb2287268$export$2c388650eabddf5e = 'request type';
const $2fdfca9bb2287268$export$2fcf90614ee15858 = 'service desk origin';
const $2fdfca9bb2287268$export$43482ff574598f59 = 'cf[10010]';
const $2fdfca9bb2287268$export$2019de80301f1da = 'RESOURCE_TYPE_FILTER_FIELD';
const $2fdfca9bb2287268$export$2912f30d4328fc00 = [
    'status',
    'assignee'
];

});

const $8c2713286c62bdd7$export$546e90157aa718d4 = `
query findRequestTypeCustomFieldQuery($cloudId: ID!, $contextFieldsFilter: JiraJQLContextFieldsFilter!, $jqlContext: String!) {
  jira {
    jqlBuilder(cloudId: $cloudId) {
        fields(jqlContextFieldsFilter: $contextFieldsFilter, jqlContext: $jqlContext) {
          ... on JiraJqlFieldConnection {
            __typename
            edges {
              node {
                jqlTerm
                displayName
                type
                searchTemplate {
                  key
                }
                operators
              }
            }
          }
          ... on QueryError {
            __typename
          }
        }
      }
  }
}
`;
const $8c2713286c62bdd7$export$2b91517d6d5b4365 = `
query requestTypeFieldQuery($cloudId: ID!) {
  jira {
    requestTypeField(cloudId: $cloudId) {
      displayName
      jqlTerm
      operators
      searchTemplate {
        key
      }
      type
    }
  }
}
`;

parcelRegister("30Hlr", function(module, exports) {

$parcel$export(module.exports, "TARGET_FILTER_TYPE", () => $f86becf4a18b4f1f$export$64f54b13b7aea793);
$parcel$export(module.exports, "reportError", () => $f86becf4a18b4f1f$export$b33b857ad1d9900e);
$parcel$export(module.exports, "transformAndReport", () => $f86becf4a18b4f1f$export$af2aa11c88c551af);

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $3ezTL = parcelRequire("3ezTL");
const $f86becf4a18b4f1f$export$64f54b13b7aea793 = 'com.atlassian.servicedesk:vp-origin';
const $f86becf4a18b4f1f$var$TARGET_FILTER_SEARCH_TEMPLATE = 'com.atlassian.servicedesk:vp-origin-searcher';
const $f86becf4a18b4f1f$export$b33b857ad1d9900e = (error)=>{
    (0, $jcw0u.default)({
        error: error,
        sendToPrivacyUnsafeSplunk: true,
        meta: {
            id: (0, $3ezTL.RESOURCE_TYPE_NAME),
            packageName: (0, $3ezTL.PACKAGE_NAME),
            teamName: (0, $3ezTL.TEAM_NAME)
        }
    });
};
const $f86becf4a18b4f1f$export$af2aa11c88c551af = (response)=>{
    const edges = response.data?.jira?.jqlBuilder?.fields?.edges;
    // There may be ambigious custom fields with same name, so find the correct one and pass to JQLBuilder
    const requestType = edges?.find((edge)=>edge?.node?.type === $f86becf4a18b4f1f$export$64f54b13b7aea793 && edge?.node?.searchTemplate?.key === $f86becf4a18b4f1f$var$TARGET_FILTER_SEARCH_TEMPLATE)?.node;
    if (!requestType && !(0, $4R6GH.fg)('corcap-3439-support-sdorigin-jqlbuilder-queue')) $f86becf4a18b4f1f$export$b33b857ad1d9900e(new Error('Unable to prefetch request type'));
    // if requestType field found, add it to existing default calendar filter fields
    return requestType ? [
        {
            ...requestType,
            searchTemplate: requestType.searchTemplate.key,
            fieldType: requestType.type
        },
        ...(0, $3ezTL.DEFAULT_CALENDAR_FILTER_FIELDS)
    ] : (0, $3ezTL.DEFAULT_CALENDAR_FILTER_FIELDS);
};

});


parcelRegister("6zFAI", function(module, exports) {

$parcel$export(module.exports, "staticProjectSidebarConnectAddonsNavigationResource", () => $ee61b377cbb3343f$export$b8c6e2666f12f4bb);
$parcel$export(module.exports, "staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only", () => $ee61b377cbb3343f$export$a799c58e7bee6de4);

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");

var $1nb22 = parcelRequire("1nb22");

var $gNStA = parcelRequire("gNStA");

var $2M1hQ = parcelRequire("2M1hQ");

var $jAGOQ = parcelRequire("jAGOQ");
const $ee61b377cbb3343f$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $ee61b377cbb3343f$export$b8c6e2666f12f4bb = (0, $2M1hQ.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$ee61b377cbb3343f$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $ee61b377cbb3343f$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const projectHomeAddonNavInfo = await (0, $jAGOQ.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'home');
        return projectHomeAddonNavInfo;
    },
    maxAge: 300000
});
const $ee61b377cbb3343f$export$a799c58e7bee6de4 = (0, $gNStA.resourceWithCondition2)(()=>!((0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('perf-push-big-components-nav-remove-resources')), $ee61b377cbb3343f$export$b8c6e2666f12f4bb);

});

parcelRegister("gcI3W", function(module, exports) {

$parcel$export(module.exports, "staticProjectReportsSidebarConnectAddonsNavigationResource", () => $e60f9280597d4f0e$export$b662f3f877add30d);

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");

var $jAGOQ = parcelRequire("jAGOQ");
const $e60f9280597d4f0e$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $e60f9280597d4f0e$export$b662f3f877add30d = (0, $2M1hQ.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_REPORTS_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$e60f9280597d4f0e$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $e60f9280597d4f0e$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $jAGOQ.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'reports');
        return navInfo;
    },
    maxAge: 300000
});

});

parcelRegister("ggg5j", function(module, exports) {

$parcel$export(module.exports, "getIdentifier", () => $3ec7290d9b237c27$export$adb27ddab077e944);
$parcel$export(module.exports, "staticProjectSidebarNavigationResource", () => $3ec7290d9b237c27$export$f2dfc0f7b2d92691);
$parcel$export(module.exports, "useSidebarNavigationResource", () => $3ec7290d9b237c27$export$b692cfadccf4e047);

var $4R6GH = parcelRequire("4R6GH");

var $95bh0 = parcelRequire("95bh0");

var $8YTna = parcelRequire("8YTna");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $gDyED = parcelRequire("gDyED");
const $3ec7290d9b237c27$export$adb27ddab077e944 = (routeName, match, query)=>{
    /**
	 * `boardId` as an identifier should not be returned for JSM boards route,
	 * skip boards on `SERVICEDESK_BOARDS` or `SERVICEDESK_CALENDAR` route.
	 */ if (routeName === 'servicedesk-boards' || routeName === 'servicedesk-calendar' || query['servicedesk.serviceDeskId'] || (routeName === 'servicedesk-queues-custom-board' || routeName === 'servicedesk-queues-custom-calendar' || routeName === 'servicedesk-queues-practice-custom-board' || routeName === 'servicedesk-queues-practice-custom-calendar' || routeName === 'servicedesk-queues-views-config' || routeName === 'servicedesk-practice-views-config') && (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag')) {
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        return (0, $95bh0.getScopeIdentifier)({
            projectKey: projectKey,
            projectId: projectId
        });
    }
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    const boardId = (0, $8YTna.getBoardId)(match, query);
    return (0, $95bh0.getScopeIdentifier)({
        projectKey: projectKey,
        projectId: projectId,
        boardId: boardId
    });
};
const $3ec7290d9b237c27$var$getRouterKey = (routeName, match, query)=>{
    const { identifierType: identifierType, identifierValue: identifierValue } = $3ec7290d9b237c27$export$adb27ddab077e944(routeName, match, query);
    // Next-Gen software projects contain only one board. Hence, using the project key itself
    if (match.url.includes('/software/projects/')) return `projectKey-${match.params.projectKey || ''}`;
    return identifierType == null || identifierValue == null ? 'none' : `${identifierType}-${identifierValue}`;
};
const $3ec7290d9b237c27$export$f2dfc0f7b2d92691 = (0, $2M1hQ.createResource)({
    type: 'NAVIGATION_SIDEBAR_JIRA_PROJECT',
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    getKey: ({ match: match, query: query, route: { name: name } })=>$3ec7290d9b237c27$var$getRouterKey(name, match, query),
    /**
	 * is called on resource's init fetch, or .refresh()
	 */ getData: async ({ match: match, query: query, route: { name: name } })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const scopeIdentifier = $3ec7290d9b237c27$export$adb27ddab077e944(name, match, query);
        if (scopeIdentifier.identifierType == null || scopeIdentifier.identifierValue == null) return null;
        const navInfo = await (0, $gDyED.fetchProjectSidebarNavInfo)(scopeIdentifier);
        return navInfo;
    },
    maxAge: 300000
});
const $3ec7290d9b237c27$export$b692cfadccf4e047 = ()=>(0, $2YP9W.useResource)($3ec7290d9b237c27$export$f2dfc0f7b2d92691);

});
parcelRegister("95bh0", function(module, exports) {

$parcel$export(module.exports, "getScopeIdentifier", () => $4cc145d0cf66273c$export$68278f7cf66944f9);

const $4cc145d0cf66273c$export$68278f7cf66944f9 = (scope)=>{
    // We check for identifiers in order of specificity first. A board ID is more specific than a project key and so on
    const identifierValue = scope.boardId || scope.projectKey || scope.projectId;
    let identifierType = null;
    if (scope.boardId) identifierType = (0, $87844bbe4c23d937$export$929d50f83189406c);
    else if (scope.projectKey) identifierType = (0, $87844bbe4c23d937$export$b5a308a17bc991f3);
    else if (scope.projectId) identifierType = (0, $87844bbe4c23d937$export$da6f46390e1a426f);
    return {
        identifierValue: identifierValue,
        identifierType: identifierType
    };
};

});
const $87844bbe4c23d937$export$b5a308a17bc991f3 = 'projectKey';
const $87844bbe4c23d937$export$929d50f83189406c = 'boardId';
const $87844bbe4c23d937$export$da6f46390e1a426f = 'projectId';


parcelRegister("8YTna", function(module, exports) {

$parcel$export(module.exports, "getBoardId", () => $f7f12dfb24bc320d$export$557c2f222778cea6);
const $f7f12dfb24bc320d$export$557c2f222778cea6 = (match, query)=>match.params.boardId || query.rapidView || query['board.id'];

});

parcelRegister("gDyED", function(module, exports) {

$parcel$export(module.exports, "fetchProjectSidebarNavInfo", () => $b6d61a4c2e3b518c$export$8a51470472777e11);

var $eusud = parcelRequire("eusud");
const $b6d61a4c2e3b518c$export$8a51470472777e11 = (scopeIdentifier)=>{
    const { identifierType: identifierType, identifierValue: identifierValue } = scopeIdentifier;
    if (identifierType == null || identifierValue == null) throw new Error('invalid identifier specified');
    let queryParam = '';
    switch(identifierType){
        case 'boardId':
            queryParam = `boardId=${identifierValue}`;
            break;
        case 'projectKey':
        case 'projectId':
            queryParam = `projectIdOrKey=${identifierValue}`;
            break;
        default:
            break;
    }
    return (0, $eusud.performGetRequest)(`/rest/navigation/4/sidebar?${queryParam}`);
};

});


parcelRegister("iEUaw", function(module, exports) {

$parcel$export(module.exports, "staticSidebarShortcutsResource", () => $681ca3c44ff39b04$export$4847c29b4786b3b4);

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");

var $bskkv = parcelRequire("bskkv");
const $681ca3c44ff39b04$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $681ca3c44ff39b04$export$4847c29b4786b3b4 = (0, $2M1hQ.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_SHORTCUTS',
    getKey: ({ match: match, query: query })=>$681ca3c44ff39b04$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $681ca3c44ff39b04$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const shortcuts = await (0, $bskkv.fetchShortcuts)(projectKeyOrId);
        return shortcuts;
    },
    maxAge: 300000
});

});
parcelRegister("bskkv", function(module, exports) {

$parcel$export(module.exports, "fetchShortcuts", () => $b1e90e13aab5fe84$export$49d696bf2525d700);

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");
const $b1e90e13aab5fe84$export$49d696bf2525d700 = (projectKeyOrId)=>{
    try {
        return (0, $7f4tk.default)(`/rest/projects/1.0/project/${projectKeyOrId}/shortcut`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.trackFetchErrors)({
            error: error,
            id: 'fetchProjectShortcuts',
            packageName: 'jiraNavigationAppsResources'
        });
        throw error;
    }
};

});
parcelRegister("7f4tk", function(module, exports) {

$parcel$export(module.exports, "default", () => $00a56387884fedf0$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $5HnTq = parcelRequire("5HnTq");

var $jJZqs = parcelRequire("jJZqs");

var $8KpGl = parcelRequire("8KpGl");

var $51xpa = parcelRequire("51xpa");

var $iwPwz = parcelRequire("iwPwz");
var /**
 * Fetch from the given URL, returning the json response.
 * <p>
 * If there are any HTTP errors the promise is rejected with a {@link FetchError}.
 *
 * @param {string} url - to fetch the JSON from
 * @param {object} options - for the fetch call
 * @returns promise containing the JSON
 * @throws {@link FetchError} if there was an HTTP Error. This will reject the promise.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$00a56387884fedf0$export$2e2bcd8739ae039 = (url, options = {})=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $51xpa.applyObservabilityHeaders)(url, (0, $7uUwQ.merge)((0, $5HnTq.defaultOptions), options))).then((response)=>{
        if (!response.ok) {
            const traceId = (0, $iwPwz.getTraceId)(response);
            if (traceId !== undefined && traceId.length > 0) throw new (0, $jJZqs.default)(response.status, `Fetch call failed with status code: ${response.status}`, traceId, response);
            else throw new (0, $jJZqs.default)(response.status, undefined, undefined, response);
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return response.json();
    });

});



parcelRegister("bjZiV", function(module, exports) {

$parcel$export(module.exports, "kbConfluenceContextResource", () => $450040dc63d5cc0e$export$8b58be1423986d17);

var $2M1hQ = parcelRequire("2M1hQ");


const $450040dc63d5cc0e$var$getDataLoader = ()=>(parcelRequire("kEPDU"));
const $450040dc63d5cc0e$export$8b58be1423986d17 = (0, $2M1hQ.createResource)({
    type: (0, $3139e13cdf89be01$export$54b5a0d1e8c78de6),
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: $450040dc63d5cc0e$var$getDataLoader,
    maxAge: Infinity
});

});
const $3139e13cdf89be01$export$54b5a0d1e8c78de6 = 'KB_CONFLUENCE_CONTEXT';

parcelRegister("kEPDU", function(module, exports) {

let $f09f9a3692f167b2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f09f9a3692f167b2$var$load("34Ulx").then(()=>parcelRequire('2SeLy'));

});


parcelRegister("3RJkv", function(module, exports) {

$parcel$export(module.exports, "getModernIssueTransitionResources", () => $4f455891fb36bf50$export$e1afa08027b1e44b);
$parcel$export(module.exports, "getNavigationResources", () => $4f455891fb36bf50$export$75cffd1aaecf4a2c);
$parcel$export(module.exports, "getUserBoardNavigationResources", () => $4f455891fb36bf50$export$c57dc1ea7f76f91f);
$parcel$export(module.exports, "getNavigationSidebarPlanResources", () => $4f455891fb36bf50$export$af2259a87f79645d);
$parcel$export(module.exports, "getNavigationSidebarProductsSettingResource", () => $4f455891fb36bf50$export$a103e99ad51f7bc3);
$parcel$export(module.exports, "getNavigationSidebarProjectSettingsResource", () => $4f455891fb36bf50$export$808691f5a412afa3);
// eslint-disable-next-line jira/import-whitelist

var $5kYzp = parcelRequire("5kYzp");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $5bkvv = parcelRequire("5bkvv");

var $7xTO3 = parcelRequire("7xTO3");

var $c1N9v = parcelRequire("c1N9v");

var $loy04 = parcelRequire("loy04");

var $2fwuR = parcelRequire("2fwuR");

var $gEccW = parcelRequire("gEccW");

var $fwzEJ = parcelRequire("fwzEJ");

var $3HwlS = parcelRequire("3HwlS");

var $h9iZl = parcelRequire("h9iZl");

var $2eyDn = parcelRequire("2eyDn");

var $drGWM = parcelRequire("drGWM");

var $kMiZJ = parcelRequire("kMiZJ");

var $bHhiy = parcelRequire("bHhiy");


var $aA974 = parcelRequire("aA974");

var $f5nIZ = parcelRequire("f5nIZ");

var $hZhhj = parcelRequire("hZhhj");

var $9MiT2 = parcelRequire("9MiT2");

var $fNOVA = parcelRequire("fNOVA");

var $kJQXA = parcelRequire("kJQXA");

var $atU1t = parcelRequire("atU1t");

var $c34Wf = parcelRequire("c34Wf");

var $eOlBz = parcelRequire("eOlBz");

var $3X1Xr = parcelRequire("3X1Xr");

var $dxCvy = parcelRequire("dxCvy");

var $4dc0x = parcelRequire("4dc0x");

var $51Yl2 = parcelRequire("51Yl2");

var $lXNZG = parcelRequire("lXNZG");

var $kkNtb = parcelRequire("kkNtb");

var $2Ql51 = parcelRequire("2Ql51");

var $9vlEn = parcelRequire("9vlEn");

var $gNStA = parcelRequire("gNStA");

var $5pSYQ = parcelRequire("5pSYQ");

var $2M1hQ = parcelRequire("2M1hQ");
const $4f455891fb36bf50$var$inExperimentCohortJiraSideNavMSRExperiment = ()=>{
    // We need to use UNSAFE_noExposureExp to check if jira-side-nav experiment is enabled without firing exposure events
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [sideNavExpConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('post_office_jira_side_nav_exp_msr_vs_no_rec');
    return sideNavExpConfig.get('isEnabled', false);
};
const $4f455891fb36bf50$var$conditionalPostOfficeJiraSideNavResource = (0, $gNStA.resourceWithCondition2)(()=>!(0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('post_office_ssr_jira_side_nav_enabled') && $4f455891fb36bf50$var$inExperimentCohortJiraSideNavMSRExperiment(), (0, $5pSYQ.postOfficeJiraSideNavResource));
const $4f455891fb36bf50$var$conditionalPostOfficeJiraSideNav4Resource = (0, $gNStA.resourceWithCondition2)(()=>// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('post_office_ssr_jira_side_nav_enabled') && (0, $4R6GH.fg)('post-office-jira-side-nav-in-nav4'), (0, $5pSYQ.postOfficeJiraSideNavResource));
const $4f455891fb36bf50$var$isModernIssueTransitionSettingEnabled = ()=>{
    return (0, $6s1PB.expVal)('jira_issue_transition_screen_modernisation_toggle', 'value', 'OFF') !== 'OFF';
};
const $4f455891fb36bf50$var$conditionalGicOptInStatusResource = (0, $gNStA.resourceWithCondition)(()=>(0, $4R6GH.fg)('render_modern_global_issue_create_modal_experience'), (0, $f5nIZ.gicOptInStatusResources));
const $4f455891fb36bf50$var$conditionalIssueTransitionOptInStatusResource = (0, $gNStA.resourceWithCondition)($4f455891fb36bf50$var$isModernIssueTransitionSettingEnabled, (0, $fNOVA.issueTransitionOptInStatusResource));
const $4f455891fb36bf50$export$e1afa08027b1e44b = ()=>[
        $4f455891fb36bf50$var$conditionalIssueTransitionOptInStatusResource,
        (0, $9MiT2.issueTransitionChangeboardingPreferencesResource)
    ];
const $4f455891fb36bf50$var$getConditionalOperationsJiraSideNavResource = ()=>(0, $gNStA.resourceWithCondition2)(()=>(0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('operations_ssr_jira_side_nav_enabled'), (0, $bHhiy.getConsolidationStateResource)(), (0, $2M1hQ.createResource)({
        type: `${(0, $5a94e356f9d5e220$export$25ee35b01de9d734)}_NOOP`,
        getKey: ()=>`${0, $5a94e356f9d5e220$export$25ee35b01de9d734}_NOOP`,
        getData: async ()=>null,
        maxAge: Number.MAX_SAFE_INTEGER,
        isBrowserOnly: false
    }));
// There is a best effort duplicate removal in the `getRoutes` function but it
// only works if the resources have the same instance. b/c resourceWithCondition2
// will create a new reference each time it is run, by keeping this outside the
// route factory, we can ensure that the duplicate removal works when it is used
// in multiple places.
const $4f455891fb36bf50$var$getDedupableConditionalResources = (isUsingSidebarEntrypoint)=>{
    const resources = [
        (0, $gNStA.resourceWithCondition2)((0, $3HwlS.getWillShowNav4), (0, $2fwuR.sidebarNav4UiStateResource)),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('blu-7584-replace-nav4-profile-query'), (0, $fwzEJ.topNav4UIStateResourceNew)),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $3HwlS.getWillShowNav4)() && !(0, $4R6GH.fg)('blu-7584-replace-nav4-profile-query'), (0, $fwzEJ.topNav4UIStateResource)),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('navx-global-side-nav'), (0, $gEccW.navPlatformSidebarResource)),
        $4f455891fb36bf50$var$getConditionalOperationsJiraSideNavResource()
    ];
    if (isUsingSidebarEntrypoint) // We don't want sidebarNav4Resource loaded for entrypoints otherwise we end up with a client side api call
    // when we don't need it as SSR will have loaded the data already.
    return resources;
    resources.push((0, $gNStA.resourceWithCondition2)((0, $3HwlS.getWillShowNav4), (0, $2fwuR.sidebarNav4Resource)));
    return resources;
};
const $4f455891fb36bf50$export$75cffd1aaecf4a2c = ({ isUsingSidebarEntrypoint: isUsingSidebarEntrypoint } = {})=>[
        (0, $c34Wf.navigationUiStateResource),
        (0, $h9iZl.navigationPlansVisibilityResource),
        (0, $9vlEn.userHomepageResource),
        $4f455891fb36bf50$var$conditionalGicOptInStatusResource,
        (0, $5kYzp.announcementBannerSettingsV4Resource),
        (0, $2eyDn.consentBannerUserPreferencesResource),
        (0, $kMiZJ.consolidationUserStateResource),
        ...$4f455891fb36bf50$var$getDedupableConditionalResources(isUsingSidebarEntrypoint),
        (0, $2Ql51.themePreferenceResource),
        ...$4f455891fb36bf50$export$e1afa08027b1e44b(),
        (0, $3X1Xr.persistentIssueCreateModalViewResource),
        (0, $aA974.gicSmartFieldsFeatureResource),
        (0, $hZhhj.incomingMailServerExpiryStatusResource),
        (0, $kkNtb.rovoEntitlementResource),
        (0, $lXNZG.jpdRecommendationDismissedResource),
        (0, $51Yl2.fetchUserTraitsResource),
        (0, $4dc0x.fetchSiteTraitsResource),
        $4f455891fb36bf50$var$conditionalPostOfficeJiraSideNavResource,
        $4f455891fb36bf50$var$conditionalPostOfficeJiraSideNav4Resource
    ];
const $4f455891fb36bf50$export$c57dc1ea7f76f91f = ()=>[
        (0, $7xTO3.staticJSWUserBoardSidebarNavigationResource)
    ];
const $4f455891fb36bf50$export$af2259a87f79645d = ()=>[
        (0, $c1N9v.staticPlanSidebarNavigationResource)
    ];
const $4f455891fb36bf50$export$a103e99ad51f7bc3 = ()=>[
        (0, $atU1t.navigationSidebarGlobalResource),
        (0, $bHhiy.getConsolidationStateResource)(),
        (0, $drGWM.checkApiKeyManagementKeysResource)()
    ];
const $4f455891fb36bf50$export$808691f5a412afa3 = ()=>[
        (0, $eOlBz.newIssueViewTransitionLockInStatusResource),
        (0, $kJQXA.navigationSidebarAutomationLegacyEnabledResource),
        (0, $dxCvy.projectContextResourceWithCache),
        (0, $5bkvv.forgeProjectSettingsModuleResource),
        (0, $loy04.staticProjectSettingsSidebarConnectAddonsNavigationResource)
    ];

});
parcelRegister("5kYzp", function(module, exports) {

$parcel$export(module.exports, "announcementBannerSettingsV4Resource", () => $76a68e4d8702ab58$export$8fbe7f8de07afffd);
$parcel$export(module.exports, "useAnnouncementBannerSettingsV4Resource", () => $76a68e4d8702ab58$export$6fb72f4a0c177494);
// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $4AdUG = parcelRequire("4AdUG");

var $2EmJy = parcelRequire("2EmJy");

var $9UEf0 = parcelRequire("9UEf0");
const $76a68e4d8702ab58$export$2a421cd16fa9a95a = (0, $2M1hQ.createResource)({
    type: 'ANNOUNCEMENT_BANNER_SETTINGS',
    getKey: ()=>'settings',
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
        const [settings, hashIdLastDimissed] = await Promise.all([
            (0, $2EmJy.get)(),
            (0, $9UEf0.get)(atlassianAccountId)
        ]);
        return {
            ...settings,
            isDismissable: isAnonymous ? false : settings?.isDismissable,
            isDismissed: isAnonymous ? false : settings?.hashId === hashIdLastDimissed
        };
    },
    maxAge: 900000
});
const $76a68e4d8702ab58$export$8fbe7f8de07afffd = (0, $2M1hQ.createResource)({
    type: 'ANNOUNCEMENT_BANNER_SETTINGS_V4',
    getKey: ()=>'settings',
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
        const [settings, hashIdLastDimissed] = await Promise.all([
            (0, $4AdUG.get)(),
            (0, $9UEf0.get)(atlassianAccountId)
        ]);
        return {
            ...settings,
            isDismissable: isAnonymous ? false : settings?.isDismissable,
            isDismissed: isAnonymous ? false : settings?.hashId === hashIdLastDimissed
        };
    },
    maxAge: 900000
});
const $76a68e4d8702ab58$export$43d4950a3e443fd3 = ()=>(0, $2YP9W.useResource)($76a68e4d8702ab58$export$2a421cd16fa9a95a);
const $76a68e4d8702ab58$export$6fb72f4a0c177494 = ()=>(0, $2YP9W.useResource)($76a68e4d8702ab58$export$8fbe7f8de07afffd);

});
parcelRegister("4AdUG", function(module, exports) {

$parcel$export(module.exports, "get", () => $90a9ae99ea774144$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $90a9ae99ea774144$export$adaa4cf7ef1b65be);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $90a9ae99ea774144$export$3988ae62b71be9a3 = async ()=>{
    try {
        return await (0, $eusud.performGetRequest)('/rest/internal/4/announcement-banner');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 403 - banner is set to private and user is anonymous
        if (error.statusCode === 403) return {
            content: '',
            bgColor: 'grey',
            isEnabled: false,
            isDismissable: false,
            visibility: 'private',
            hashId: ''
        };
        (0, $jcw0u.default)({
            meta: {
                id: 'settingsV4Get',
                packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
                teamName: 'jira-cosmos'
            },
            error: error
        });
        throw error;
    }
};
const $90a9ae99ea774144$export$adaa4cf7ef1b65be = async (body)=>{
    try {
        return await (0, $eusud.performPostRequest)('/rest/internal/4/announcement-banner', {
            body: JSON.stringify(body)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'settingsV4Set',
                packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
                teamName: 'jira-cosmos'
            },
            error: error
        });
        throw error;
    }
};

});

parcelRegister("2EmJy", function(module, exports) {

$parcel$export(module.exports, "get", () => $02ac2f2e29fd92e6$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $02ac2f2e29fd92e6$export$adaa4cf7ef1b65be);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

const $02ac2f2e29fd92e6$export$3988ae62b71be9a3 = async ()=>{
    try {
        return await (0, $eusud.performGetRequest)('/rest/internal/3/announcement-banner');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 403 - banner is set to private and user is anonymous
        if (error.statusCode === 403) return {
            message: '',
            isEnabled: false,
            isDismissable: false,
            visibility: 'private',
            hashId: ''
        };
        (0, $jcw0u.trackFetchErrors)({
            error: error,
            id: 'settingsGet',
            packageName: (0, $981adbf91eeefd26$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};
const $02ac2f2e29fd92e6$export$adaa4cf7ef1b65be = async (body)=>{
    try {
        return await (0, $eusud.performPostRequest)('/rest/internal/3/announcement-banner', {
            body: JSON.stringify(body)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.trackFetchErrors)({
            error: error,
            id: 'settingsSet',
            packageName: (0, $981adbf91eeefd26$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};

});
const $981adbf91eeefd26$export$b8b9d90f9e5bd72b = '@atlassian/jira-admin-pages-system-ui-announcement-banner-resources';
const $981adbf91eeefd26$export$5e0c0e8c940630f8 = 'private';
const $981adbf91eeefd26$export$1d5a5b6462188eb3 = 'public';


parcelRegister("9UEf0", function(module, exports) {

$parcel$export(module.exports, "get", () => $0fff4d2d98ff5692$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $0fff4d2d98ff5692$export$adaa4cf7ef1b65be);

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

const $0fff4d2d98ff5692$var$key = 'announcementBannerDismissedLast';
const $0fff4d2d98ff5692$export$3988ae62b71be9a3 = async (accoundId)=>{
    try {
        return accoundId != null ? (await (0, $89SaW.getUserProperty)(accoundId, $0fff4d2d98ff5692$var$key)).hashId : null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 404 - property has not been previously set
        if (error.statusCode === 404) return null;
        (0, $jcw0u.trackFetchErrors)({
            error: error,
            id: 'userDismissGet',
            packageName: (0, $981adbf91eeefd26$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};
const $0fff4d2d98ff5692$export$adaa4cf7ef1b65be = async (accoundId, hashId)=>{
    try {
        return await (0, $89SaW.setUserProperties)(accoundId, $0fff4d2d98ff5692$var$key, JSON.stringify({
            hashId: hashId
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.trackFetchErrors)({
            error: error,
            id: 'userDismissSet',
            packageName: (0, $981adbf91eeefd26$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};

});
parcelRegister("89SaW", function(module, exports) {

$parcel$export(module.exports, "getUserPropertiesUrl", () => $646571db30c23ce6$export$f474e53c8191800a);
$parcel$export(module.exports, "setUserProperties", () => $646571db30c23ce6$export$d0e176862bf869b8);
$parcel$export(module.exports, "getUserProperty", () => $646571db30c23ce6$export$b3126db2ef6e34ed);

var $jJZqs = parcelRequire("jJZqs");

var $6no39 = parcelRequire("6no39");

var $8KpGl = parcelRequire("8KpGl");

var $4R6GH = parcelRequire("4R6GH");
const $646571db30c23ce6$export$f474e53c8191800a = (accountId, propertyKey)=>`/rest/api/latest/user/properties/${propertyKey}?accountId=${encodeURIComponent(accountId)}`;
const $646571db30c23ce6$var$getUserPropertiesUrlWithReroute = (accountId, propertyKey)=>{
    const path = $646571db30c23ce6$export$f474e53c8191800a(accountId, propertyKey);
    return (0, $4R6GH.fg)('magma-3429_banners_in_modern_ssr') ? (0, $8KpGl.getReroutableURL)(path) : path;
};
const $646571db30c23ce6$export$d0e176862bf869b8 = async (accountId, propertyKey, data)=>{
    const url = $646571db30c23ce6$var$getUserPropertiesUrlWithReroute(accountId, propertyKey);
    return fetch(url, {
        ...(0, $6no39.getDefaultOptions)(url),
        method: 'PUT',
        body: data
    });
};
const $646571db30c23ce6$export$b3126db2ef6e34ed = (accountId, propertyKey)=>{
    const url = $646571db30c23ce6$var$getUserPropertiesUrlWithReroute(accountId, propertyKey);
    return fetch(url, (0, $6no39.getDefaultOptions)(url)).then((res)=>{
        if (res.status === 200) return res.json();
        return res.text().then((errResp)=>{
            throw new (0, $jJZqs.default)(res.status, errResp);
        });
    }).then((data)=>data.value);
};
const $646571db30c23ce6$export$4c4183b491dea321 = (accountId, propertyKey)=>{
    const url = $646571db30c23ce6$var$getUserPropertiesUrlWithReroute(accountId, propertyKey);
    return fetch(url, {
        ...(0, $6no39.getDefaultOptions)(url),
        method: 'DELETE'
    });
};

});
parcelRegister("6no39", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", () => $b41761551f5f2353$export$430a3269e24b912e);

var $51xpa = parcelRequire("51xpa");
function $b41761551f5f2353$export$430a3269e24b912e(url) {
    const options = {
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-force-account-id': 'true',
            // Flow's RequestOptions type doesn't allow an array here, but it works in practice ¯\_(ツ)_/¯
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            Accept: [
                'application/json',
                'text/javascript',
                '*/*'
            ]
        }
    };
    return url ? (0, $51xpa.applyObservabilityHeaders)(url, options) : options;
}
const $b41761551f5f2353$export$ba43bf67f3d48107 = {
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json',
        'x-atlassian-force-account-id': 'true',
        // Flow's RequestOptions type doesn't allow an array here, but it works in practice ¯\_(ツ)_/¯
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        Accept: [
            'application/json',
            'text/javascript',
            '*/*'
        ]
    }
};

});




parcelRegister("7xTO3", function(module, exports) {

$parcel$export(module.exports, "staticJSWUserBoardSidebarNavigationResource", () => $7371ef5d04dd1248$export$5839dd8142de842e);

var $2YZCu = parcelRequire("2YZCu");

var $8YTna = parcelRequire("8YTna");

var $2M1hQ = parcelRequire("2M1hQ");

var $55UpE = parcelRequire("55UpE");
const $7371ef5d04dd1248$export$5839dd8142de842e = (0, $2M1hQ.createResource)({
    type: 'JIRA_USER_BOARD_NAVIGATION_RESOURCE',
    getKey: ({ match: match, query: query })=>{
        const boardId = (0, $8YTna.getBoardId)(match, query);
        return boardId ? `board-${boardId}` : 'none';
    },
    getData: async ({ match: match, query: query })=>{
        const boardId = (0, $8YTna.getBoardId)(match, query);
        if (boardId == null) return null;
        try {
            const response = await (0, $55UpE.fetchUserBoardNavigationData)(boardId);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('navigation-apps.resources.static-jsw-userboard-sidebar', 'Fail to fetch user board', e);
            return null;
        }
    },
    maxAge: 300000
});

});
parcelRegister("55UpE", function(module, exports) {

$parcel$export(module.exports, "fetchUserBoardNavigationData", () => $e577b36e40c022cb$export$306fb49fca60b34);

var $eusud = parcelRequire("eusud");
const $e577b36e40c022cb$export$306fb49fca60b34 = (boardId)=>{
    if (boardId == null) throw new Error('invalid boardId');
    return (0, $eusud.performGetRequest)(`/rest/navigation/4/sidebar/people/boards/${boardId}`);
};

});


parcelRegister("c1N9v", function(module, exports) {

$parcel$export(module.exports, "staticPlanSidebarNavigationResource", () => $4a8a43738dc54d5c$export$e7e6c1b9d8d5ea7);
// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router

var $2M1hQ = parcelRequire("2M1hQ");

var $ijN6s = parcelRequire("ijN6s");
const $4a8a43738dc54d5c$var$getRouterKey = (match)=>{
    if (match.url.includes('/plans/')) return `planId-${match.params.planId || ''}-scenarioId-${match.params.scenarioId || ''}`;
    return 'none';
};
const $4a8a43738dc54d5c$export$e7e6c1b9d8d5ea7 = (0, $2M1hQ.createResource)({
    type: 'NAVIGATION_SIDEBAR_JIRA_PLAN',
    getKey: ({ match: match })=>$4a8a43738dc54d5c$var$getRouterKey(match),
    getData: async ({ match: { params: { planId: planId, scenarioId: scenarioId } } })=>{
        if (planId == null || scenarioId == null) return null;
        return (0, $ijN6s.fetchPlanSidebarNavInfo)(planId, scenarioId);
    },
    maxAge: 300000
});

});
parcelRegister("ijN6s", function(module, exports) {

$parcel$export(module.exports, "fetchPlanSidebarNavInfo", () => $b2d0559c1bc2bb35$export$a49729698cfc5310);

var $eusud = parcelRequire("eusud");
const $b2d0559c1bc2bb35$var$requestSideBarInfo = (planId, scenarioId)=>(0, $eusud.performGetRequest)(`/rest/jpo/1.0/navigation/plans/${planId}/scenarios/${scenarioId}`);
const $b2d0559c1bc2bb35$export$a49729698cfc5310 = (planId, scenarioId)=>{
    if (planId == null || planId.trim() === '') throw new Error('Plan cannot be loaded without a planId');
    if (scenarioId == null || scenarioId.trim() === '') throw new Error('Plan cannot be loaded without a scenarioId');
    return $b2d0559c1bc2bb35$var$requestSideBarInfo(planId, scenarioId);
};

});


parcelRegister("loy04", function(module, exports) {

$parcel$export(module.exports, "staticProjectSettingsSidebarConnectAddonsNavigationResource", () => $c5a0b9808c0c3182$export$e4bf33528101348c);
$parcel$export(module.exports, "useProjectSettingsSidebarConnectAddonsNavigationResource", () => $c5a0b9808c0c3182$export$2d5a704ae6f6b050);

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $jAGOQ = parcelRequire("jAGOQ");
const $c5a0b9808c0c3182$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $c5a0b9808c0c3182$export$e4bf33528101348c = (0, $2M1hQ.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_SETTINGS_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$c5a0b9808c0c3182$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $c5a0b9808c0c3182$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $jAGOQ.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'settings');
        return navInfo;
    },
    maxAge: 300000
});
const $c5a0b9808c0c3182$export$2d5a704ae6f6b050 = ()=>(0, $2YP9W.useResource)($c5a0b9808c0c3182$export$e4bf33528101348c);

});

parcelRegister("2fwuR", function(module, exports) {

$parcel$export(module.exports, "sidebarNav4Resource", () => $692dbcae1edae2a1$export$7648dc6f76f4f83d);
$parcel$export(module.exports, "sidebarNav4UiStateResource", () => $692dbcae1edae2a1$export$a46129bd512544d7);

var $jhS4y = parcelRequire("jhS4y");

var $3Jbkp = parcelRequire("3Jbkp");

var $fMcVX = parcelRequire("fMcVX");

var $ao2h1 = parcelRequire("ao2h1");

var $2OeZv = parcelRequire("2OeZv");

var $fZBia = parcelRequire("fZBia");

var $gdtac = parcelRequire("gdtac");

var $95KxO = parcelRequire("95KxO");
const $692dbcae1edae2a1$var$RESOURCE_TYPE_SIDEBAR_V2_RELAY = 'SIDEBAR_V2_RELAY';
const $692dbcae1edae2a1$export$7648dc6f76f4f83d = (0, $ao2h1.createRelayResource)({
    type: `${(0, $ao2h1.RELAY_RESOURCE_TYPE)}_${$692dbcae1edae2a1$var$RESOURCE_TYPE_SIDEBAR_V2_RELAY}`,
    getQuery: (routerContext, { tenantContext: { cloudId: cloudId, activationId: activationId, atlassianAccountId: atlassianAccountId } })=>{
        const initialSelectedPath = (0, $3Jbkp.getInitialSelectedPath)(routerContext);
        return {
            parameters: (0, $2OeZv.default),
            variables: {
                cloudId: cloudId,
                isAppsExpanded: (0, $fMcVX.isSelectedPath)(initialSelectedPath, (0, $jhS4y.MENU_ID_APPS)),
                isFiltersExpanded: (0, $fMcVX.isSelectedPath)(initialSelectedPath, (0, $jhS4y.MENU_ID_FILTERS)),
                isPlansExpanded: (0, $fMcVX.isSelectedPath)(initialSelectedPath, (0, $jhS4y.MENU_ID_PLANS)),
                isProjectsExpanded: (0, $fMcVX.isSelectedPath)(initialSelectedPath, (0, $jhS4y.MENU_ID_PROJECTS)),
                isOperationsExpanded: (0, $fMcVX.isSelectedPath)(initialSelectedPath, (0, $jhS4y.MENU_ID_OPERATIONS)),
                isOverviewsExpanded: (0, $fMcVX.isSelectedPath)(initialSelectedPath, (0, $jhS4y.MENU_ID_OVERVIEWS)),
                entityAriProjects: (0, $gdtac.JiraNavigationSettingsAri).create({
                    siteId: cloudId,
                    activationId: activationId,
                    navigationSettingScope: 'projects'
                }).toString(),
                ownerAri: atlassianAccountId && (0, $95KxO.IdentityUserAri).create({
                    userId: atlassianAccountId
                }).toString()
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    }
});
const $692dbcae1edae2a1$export$a46129bd512544d7 = (0, $ao2h1.createRelayResource)({
    type: `${(0, $ao2h1.RELAY_RESOURCE_TYPE)}_SIDEBAR_V2_UI_STATE_RELAY`,
    getQuery: (_, { tenantContext: { cloudId: cloudId } })=>({
            parameters: (0, $fZBia.default),
            variables: {
                cloudId: cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("jhS4y", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_APP_MENU_ID", () => $d66e3a3484b422c6$export$1bb3d16bc95080e3);
$parcel$export(module.exports, "GLOBAL_APP_MENU_ID_TO_APS_KEY", () => $d66e3a3484b422c6$export$3b4ca8d4d769a311);
$parcel$export(module.exports, "CONFIGURABLE_MENU_ID", () => $d66e3a3484b422c6$export$7838b734e4cd5e8d);
$parcel$export(module.exports, "ENTITY_ID", () => $d66e3a3484b422c6$export$103ff18fe29ee1b);
$parcel$export(module.exports, "MENU_ID_APPS", () => $d66e3a3484b422c6$export$441cd608ea3204f4);
$parcel$export(module.exports, "MENU_ID_APP_MARKETPLACE_DISCOVER", () => $d66e3a3484b422c6$export$5baa9c2e3c3931c5);
$parcel$export(module.exports, "MENU_ID_ASSETS", () => $d66e3a3484b422c6$export$75c65bfc98b3a6e1);
$parcel$export(module.exports, "MENU_ID_ASSETS_SCHEMAS", () => $d66e3a3484b422c6$export$8a0af92d49f1d13d);
$parcel$export(module.exports, "MENU_ID_ASSETS_REPORTS", () => $d66e3a3484b422c6$export$a09300d15acc958a);
$parcel$export(module.exports, "MENU_ID_BOARDS_VIEW_ALL", () => $d66e3a3484b422c6$export$4d718fbd418eef5c);
$parcel$export(module.exports, "MENU_ID_DASHBOARDS", () => $d66e3a3484b422c6$export$dd009509c2dabb5e);
$parcel$export(module.exports, "MENU_ID_DASHBOARDS_VIEW_ALL", () => $d66e3a3484b422c6$export$d3da0455b4200fb2);
$parcel$export(module.exports, "MENU_ID_DASHBOARDS_VIEW_ALL_STARRED", () => $d66e3a3484b422c6$export$b9dd2b5309d19763);
$parcel$export(module.exports, "MENU_ID_FILTERS", () => $d66e3a3484b422c6$export$3d81af172a8e3c57);
$parcel$export(module.exports, "MENU_ID_FILTERS_SEARCH", () => $d66e3a3484b422c6$export$1e2599eaf0039a97);
$parcel$export(module.exports, "MENU_ID_FILTERS_VIEW_ALL", () => $d66e3a3484b422c6$export$53d274d993c9d5b5);
$parcel$export(module.exports, "MENU_ID_FILTERS_VIEW_ALL_STARRED", () => $d66e3a3484b422c6$export$7661ea763be69cfa);
$parcel$export(module.exports, "MENU_ID_GOALS", () => $d66e3a3484b422c6$export$47c6ce6a83a59eab);
$parcel$export(module.exports, "MENU_ID_OPERATIONS", () => $d66e3a3484b422c6$export$ef89639b7d9c162a);
$parcel$export(module.exports, "MENU_ID_OPS_ALERTS", () => $d66e3a3484b422c6$export$af4ab6d4e920522a);
$parcel$export(module.exports, "MENU_ID_OPS_OVERVIEW", () => $d66e3a3484b422c6$export$25c40acb2c53a294);
$parcel$export(module.exports, "MENU_ID_OPS_REPORTS", () => $d66e3a3484b422c6$export$c7d8892f1628b844);
$parcel$export(module.exports, "MENU_ID_OPS_ON_CALL", () => $d66e3a3484b422c6$export$bb19a52e3df99541);
$parcel$export(module.exports, "MENU_ID_OVERVIEWS", () => $d66e3a3484b422c6$export$3bd12c092f8db11b);
$parcel$export(module.exports, "MENU_ID_COMMUNICATION", () => $d66e3a3484b422c6$export$feed0c05fb1a4af);
$parcel$export(module.exports, "MENU_ID_PLANS", () => $d66e3a3484b422c6$export$f2533da33c749933);
$parcel$export(module.exports, "MENU_ID_PLANS_VIEW_ALL", () => $d66e3a3484b422c6$export$8468c5b6648f4f1f);
$parcel$export(module.exports, "MENU_ID_PROJECT_APPS", () => $d66e3a3484b422c6$export$fed17b4c0866b97d);
$parcel$export(module.exports, "MENU_ID_PROJECTS", () => $d66e3a3484b422c6$export$9c5278bd360a285);
$parcel$export(module.exports, "MENU_ID_PROJECTS_VIEW_ALL", () => $d66e3a3484b422c6$export$85389c606bb641dd);
$parcel$export(module.exports, "MENU_ID_PROJECTS_VIEW_ALL_STARRED", () => $d66e3a3484b422c6$export$4a1974b63c858e9c);
$parcel$export(module.exports, "MENU_ID_RECENT", () => $d66e3a3484b422c6$export$692b796030a796f3);
$parcel$export(module.exports, "MENU_ID_ROADMAPS", () => $d66e3a3484b422c6$export$cdc80d4b5ce0c6a);
$parcel$export(module.exports, "MENU_ID_ROADMAPS_VIEW_ALL", () => $d66e3a3484b422c6$export$7606c0134aabf3d7);
$parcel$export(module.exports, "MENU_ID_STARRED", () => $d66e3a3484b422c6$export$5637ca42a4d77f32);
$parcel$export(module.exports, "MENU_ID_TEAMS", () => $d66e3a3484b422c6$export$d4f6fcf571f9c50);
$parcel$export(module.exports, "MENU_ID_CUSTOMER_SERVICE", () => $d66e3a3484b422c6$export$11fcdf33179ef88e);
$parcel$export(module.exports, "MENU_ID_CUSTOMER_HUBS", () => $d66e3a3484b422c6$export$d69bec513af84431);
$parcel$export(module.exports, "MENU_ID_CUSTOMER_SERVICE_ANALYTICS", () => $d66e3a3484b422c6$export$1d260f51eeaab73d);
$parcel$export(module.exports, "MENU_ID_YOUR_WORK", () => $d66e3a3484b422c6$export$80dc576e446bdb6b);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_ASSETS", () => $d66e3a3484b422c6$export$5aa3e4dd37f372d5);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_GOALS", () => $d66e3a3484b422c6$export$7986b535c183c592);
$parcel$export(module.exports, "MENU_ID_COMMUNICATIONS_STAKEHOLDERS", () => $d66e3a3484b422c6$export$784c436fb3f51c19);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_CONFLUENCE", () => $d66e3a3484b422c6$export$c093b87743053085);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_LOOM", () => $d66e3a3484b422c6$export$e316a54b33dbe500);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_PROJECTS", () => $d66e3a3484b422c6$export$8ceb414d866f12fc);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_TEAMS", () => $d66e3a3484b422c6$export$804187987544d0f8);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_OPSGENIE", () => $d66e3a3484b422c6$export$83352ab9064f1723);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_ACCESS", () => $d66e3a3484b422c6$export$79c15668ed799a1b);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT", () => $d66e3a3484b422c6$export$e299bb06c4370c0d);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT_REQUEST_TYPES", () => $d66e3a3484b422c6$export$713b9b0a69a79cf9);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_AUTOMATION", () => $d66e3a3484b422c6$export$f1d9c0f27216aa1c);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_CHANNELS_AND_SELF_SERVICE", () => $d66e3a3484b422c6$export$45763fa331781074);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_NOTIFICATIONS", () => $d66e3a3484b422c6$export$6ee20c845dbab3e3);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_APPS", () => $d66e3a3484b422c6$export$b3815dd180ce5e61);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_OPERATIONS", () => $d66e3a3484b422c6$export$100a1a639a0db980);
const $d66e3a3484b422c6$export$1bb3d16bc95080e3 = {
    GLOBAL_APP_GOALS: 'jira.sidebar.globalApp.goals',
    GLOBAL_APP_ASSETS: 'jira.sidebar.globalApp.assets',
    // Global App Shortcuts for Platform Component
    GLOBAL_APP_CONFLUENCE: 'jira.sidebar.globalApp.confluence',
    GLOBAL_APP_LOOM: 'jira.sidebar.globalApp.loom',
    GLOBAL_APP_PROJECTS: 'jira.sidebar.globalApp.projects',
    GLOBAL_APP_TEAMS: 'jira.sidebar.globalApp.teams',
    GLOBAL_APP_OPSGENIE: 'jira.sidebar.globalApp.opsgenie'
};
const $d66e3a3484b422c6$export$3b4ca8d4d769a311 = {
    [$d66e3a3484b422c6$export$1bb3d16bc95080e3.GLOBAL_APP_CONFLUENCE]: 'CONFLUENCE',
    [$d66e3a3484b422c6$export$1bb3d16bc95080e3.GLOBAL_APP_LOOM]: 'LOOM',
    [$d66e3a3484b422c6$export$1bb3d16bc95080e3.GLOBAL_APP_GOALS]: 'GOALS',
    [$d66e3a3484b422c6$export$1bb3d16bc95080e3.GLOBAL_APP_PROJECTS]: 'PROJECTS',
    [$d66e3a3484b422c6$export$1bb3d16bc95080e3.GLOBAL_APP_TEAMS]: 'TEAMS',
    [$d66e3a3484b422c6$export$1bb3d16bc95080e3.GLOBAL_APP_OPSGENIE]: 'OPSGENIE'
};
const $d66e3a3484b422c6$export$7838b734e4cd5e8d = {
    APPS: 'jira.sidebar.apps',
    ASSETS: 'jira.sidebar.assets',
    DASHBOARDS: 'jira.sidebar.dashboards',
    FILTERS: 'jira.sidebar.filters',
    GOALS: 'jira.sidebar.goals',
    OPERATIONS: 'jira.sidebar.operations',
    COMMUNICATION: 'jira.sidebar.communication',
    OVERVIEWS: 'jira.sidebar.overviews',
    PLANS: 'jira.sidebar.plans',
    PROJECTS: 'jira.sidebar.projects',
    RECENT: 'jira.sidebar.recent',
    STARRED: 'jira.sidebar.starred',
    TEAMS: 'jira.sidebar.teams',
    ROADMAPS: 'jira.sidebar.roadmaps',
    CUSTOMER_SERVICE: 'jira.sidebar.customerService',
    CUSTOMER_HUBS: 'jira.sidebar.customerHubs',
    CUSTOMER_SERVICE_ANALYTICS: 'jira.sidebar.customerServiceAnalytics',
    ...$d66e3a3484b422c6$export$1bb3d16bc95080e3
};
const $d66e3a3484b422c6$export$103ff18fe29ee1b = {
    ALARM_QUEUE: (id)=>`alrm_${id}`,
    APP: (id)=>`app_${id}`,
    BOARD: (id)=>`boar_${id}`,
    DASHBOARD: (id)=>`dash_${id}`,
    FILTER: (id)=>`filt_${id}`,
    FORM: (id)=>`form_${id}`,
    OVERVIEW: (id)=>`over_${id}`,
    PLAN: (id)=>`plan_${id}`,
    PROJECT: (id)=>`proj_${id}`,
    PROJECT_CALENDAR: (projectKey)=>`proj-${projectKey}-cal`,
    PROJECT_CHANGE_CALENDAR: (projectKey)=>`proj-${projectKey}-chgcal`,
    PROJECT_ESCALATIONS: (projectKey)=>`proj-${projectKey}-escl`,
    PROJECT_DIRECTORY: (projectKey)=>`proj-${projectKey}-dir`,
    PROJECT_FILTERS: (projectKey)=>`proj-${projectKey}-filters`,
    PROJECT_ISSUE_FILTER: (projectKey, filterId)=>`proj-${projectKey}-issf-${filterId}`,
    PROJECT_JSM_GETTING_STARTED: (projectKey)=>`proj-${projectKey}-jsm-gtst`,
    PROJECT_KNOWLEDGE_BASE: (projectKey)=>`proj-${projectKey}-kb`,
    PROJECT_OPERATIONS: (projectKey)=>`proj-${projectKey}-ops`,
    PROJECT_NOTIFICATION_LOGS: (projectKey)=>`proj-${projectKey}-nlog`,
    PROJECT_ONCALL_SCHEDULE: (projectKey)=>`proj-${projectKey}-oncs`,
    PROJECT_PRACTICE_QUEUE: (projectKey, practice)=>`proj-${projectKey}-pract-${practice}`,
    PROJECT_QUEUES: (projectKey)=>`proj-${projectKey}-queues`,
    PROJECT_REPORTS: (projectKey)=>`proj-${projectKey}-rprt`,
    PROJECT_DASHBOARDS: (projectKey)=>`proj-${projectKey}-dashboards`,
    PROJECT_SERVICES: (projectKey)=>`proj-${projectKey}-srvc`,
    PROJECT_SUMMARY: (projectKey)=>`proj-${projectKey}-summary`,
    PROJECT_VIEWS: (projectKey)=>`proj-${projectKey}-views`,
    ROADMAP: (id)=>`roadmap_${id}`,
    QUEUE: (id)=>`queu_${id}`,
    ISSUE: (id)=>`issue_${id}`,
    ARCHIVED_WORK_ITEMS: (id)=>`archived_work_items_${id}`
}; // We MUST use the same IDs for the same components, otherwise we run into trouble (especially with peeking / more-menu)
const $d66e3a3484b422c6$export$441cd608ea3204f4 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.APPS;
const $d66e3a3484b422c6$export$5baa9c2e3c3931c5 = 'app_mrkt';
const $d66e3a3484b422c6$export$75c65bfc98b3a6e1 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.ASSETS;
const $d66e3a3484b422c6$export$8a0af92d49f1d13d = 'asst_schm';
const $d66e3a3484b422c6$export$a09300d15acc958a = 'asst_rprt';
const $d66e3a3484b422c6$export$4d718fbd418eef5c = 'board-view-all';
const $d66e3a3484b422c6$export$dd009509c2dabb5e = $d66e3a3484b422c6$export$7838b734e4cd5e8d.DASHBOARDS;
const $d66e3a3484b422c6$export$d3da0455b4200fb2 = 'dash-view';
const $d66e3a3484b422c6$export$b9dd2b5309d19763 = 'dash-view-starred';
const $d66e3a3484b422c6$export$3d81af172a8e3c57 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.FILTERS;
const $d66e3a3484b422c6$export$1e2599eaf0039a97 = 'filt-search';
const $d66e3a3484b422c6$export$53d274d993c9d5b5 = 'filt-view-all';
const $d66e3a3484b422c6$export$7661ea763be69cfa = 'filt-view-starred';
const $d66e3a3484b422c6$export$47c6ce6a83a59eab = $d66e3a3484b422c6$export$7838b734e4cd5e8d.GOALS;
const $d66e3a3484b422c6$export$ef89639b7d9c162a = $d66e3a3484b422c6$export$7838b734e4cd5e8d.OPERATIONS;
const $d66e3a3484b422c6$export$af4ab6d4e920522a = 'ops-alrt';
const $d66e3a3484b422c6$export$25c40acb2c53a294 = 'ops-over';
const $d66e3a3484b422c6$export$c7d8892f1628b844 = 'ops-rprt';
const $d66e3a3484b422c6$export$bb19a52e3df99541 = 'ops-oncl';
const $d66e3a3484b422c6$export$3bd12c092f8db11b = $d66e3a3484b422c6$export$7838b734e4cd5e8d.OVERVIEWS;
const $d66e3a3484b422c6$export$feed0c05fb1a4af = $d66e3a3484b422c6$export$7838b734e4cd5e8d.COMMUNICATION;
const $d66e3a3484b422c6$export$f2533da33c749933 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.PLANS;
const $d66e3a3484b422c6$export$8468c5b6648f4f1f = 'plan-view-all';
const $d66e3a3484b422c6$export$fed17b4c0866b97d = 'proj-app';
const $d66e3a3484b422c6$export$9c5278bd360a285 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.PROJECTS;
const $d66e3a3484b422c6$export$85389c606bb641dd = 'proj-view-all';
const $d66e3a3484b422c6$export$4a1974b63c858e9c = 'proj-view-starred';
const $d66e3a3484b422c6$export$692b796030a796f3 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.RECENT;
const $d66e3a3484b422c6$export$cdc80d4b5ce0c6a = $d66e3a3484b422c6$export$7838b734e4cd5e8d.ROADMAPS;
const $d66e3a3484b422c6$export$7606c0134aabf3d7 = 'roadmaps-view-all';
const $d66e3a3484b422c6$export$5637ca42a4d77f32 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.STARRED;
const $d66e3a3484b422c6$export$d4f6fcf571f9c50 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.TEAMS;
const $d66e3a3484b422c6$export$11fcdf33179ef88e = $d66e3a3484b422c6$export$7838b734e4cd5e8d.CUSTOMER_SERVICE;
const $d66e3a3484b422c6$export$d69bec513af84431 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.CUSTOMER_HUBS;
const $d66e3a3484b422c6$export$1d260f51eeaab73d = $d66e3a3484b422c6$export$7838b734e4cd5e8d.CUSTOMER_SERVICE_ANALYTICS;
const $d66e3a3484b422c6$export$80dc576e446bdb6b = 'yrwk';
const $d66e3a3484b422c6$export$5aa3e4dd37f372d5 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.GLOBAL_APP_ASSETS;
const $d66e3a3484b422c6$export$7986b535c183c592 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.GLOBAL_APP_GOALS;
const $d66e3a3484b422c6$export$784c436fb3f51c19 = 'comm-stkhldr';
const $d66e3a3484b422c6$export$205988f610130417 = 'comm-stkhldr-grp';
const $d66e3a3484b422c6$export$c093b87743053085 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.GLOBAL_APP_CONFLUENCE;
const $d66e3a3484b422c6$export$e316a54b33dbe500 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.GLOBAL_APP_LOOM;
const $d66e3a3484b422c6$export$8ceb414d866f12fc = $d66e3a3484b422c6$export$7838b734e4cd5e8d.GLOBAL_APP_PROJECTS;
const $d66e3a3484b422c6$export$804187987544d0f8 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.GLOBAL_APP_TEAMS;
const $d66e3a3484b422c6$export$83352ab9064f1723 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.GLOBAL_APP_OPSGENIE;
const $d66e3a3484b422c6$export$79c15668ed799a1b = 'sd-sett-acc';
const $d66e3a3484b422c6$export$e299bb06c4370c0d = 'sd-sett-req-man';
const $d66e3a3484b422c6$export$713b9b0a69a79cf9 = 'sd-sett-req-typs';
const $d66e3a3484b422c6$export$f1d9c0f27216aa1c = 'sd-sett-aut';
const $d66e3a3484b422c6$export$45763fa331781074 = 'sd-sett-ch-slf-srv';
const $d66e3a3484b422c6$export$6ee20c845dbab3e3 = 'sd-sett-not';
const $d66e3a3484b422c6$export$b3815dd180ce5e61 = 'sd-sett-apps';
const $d66e3a3484b422c6$export$100a1a639a0db980 = 'sd-sett-ops';

});

parcelRegister("3Jbkp", function(module, exports) {

$parcel$export(module.exports, "getInitialSelectedPath", () => $e52131b0b61339d3$export$39f409bc5f59c5e);
/**
 * Why do we need the initialSelectedPath? It all stems from the workaround that Nav4 uses
 * to SSR the initial sidebar semi-correctly, while pretending to lazy-load everything else.
 *
 * Ideally we would be able to pre-load entrypoints that we know we need to load, and lazy-load
 * the rest. This would support SSR and be performant.
 * Unfortunately, unless all of the Jira routes are loaded via entry-points, we cannot use this approach.
 *
 * The workaround is to use Relay variables to tell Relay what data to preload, and then load
 * the corresponding UI component directly (not via an entrypoint) when we have the data for it.
 * When we don't have the preloaded data, we lazy load __the same component via an entrypoint__.
 * In other words, we sacrifice bundle size (by directly including the component for the data-available
 * case), in order to get SSR benefits.
 *
 * A consequence of this approach is we have two versions of the top-level menu item components - the
 * regular version (called *Landing) and the entrypoint version (called *Default). When navigating,
 * the router's state would change, causing the components to switch around. In the UI, this would
 * cause ExpandableMenuItem components to collapse, when they were open before navigating.
 *
 * To work around THIS problem, we store a computed-version of the initial state of the router, and
 * then query this value when deciding which component to show (the *Landing or the *Default). Because if
 * the initial state doesn't change, our components won't switch around after the first render.
 */ 
var $bxYf9 = parcelRequire("bxYf9");

var $7Ckoi = parcelRequire("7Ckoi");
const $e52131b0b61339d3$export$39f409bc5f59c5e = (0, (/*@__PURE__*/$parcel$interopDefault($bxYf9)))((0, $7Ckoi.routeToSelectedPath));

});
parcelRegister("7Ckoi", function(module, exports) {

$parcel$export(module.exports, "routeToSelectedPath", () => $551cdf5d088747a1$export$a92474c098a1fd13);
$parcel$export(module.exports, "useRouteToSelectedPath", () => $551cdf5d088747a1$export$a086f1986cac3253);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $4R6GH = parcelRequire("4R6GH");

var $lODMY = parcelRequire("lODMY");

var $fBDpl = parcelRequire("fBDpl");

var $ezq2z = parcelRequire("ezq2z");

var $j3mSh = parcelRequire("j3mSh");

var $1RoZ2 = parcelRequire("1RoZ2");

var $hdJn1 = parcelRequire("hdJn1");

var $194uG = parcelRequire("194uG");

var $2m3Yb = parcelRequire("2m3Yb");

var $3weqe = parcelRequire("3weqe");

var $c6hlO = parcelRequire("c6hlO");

var $3lNyZ = parcelRequire("3lNyZ");

var $8bXrC = parcelRequire("8bXrC");

var $eReVn = parcelRequire("eReVn");

var $djX45 = parcelRequire("djX45");
function $551cdf5d088747a1$export$a92474c098a1fd13(routeContext) {
    const routeName = routeContext.route.name;
    if ((0, $2m3Yb.topLevelConverter).routes.has(routeName)) return (0, $2m3Yb.topLevelConverter).convert(routeContext);
    if ((0, $fBDpl.appsConverter).routes.has(routeName)) return (0, $fBDpl.appsConverter).convert(routeContext);
    if ((0, $ezq2z.assetsConverter).routes.has(routeName)) return (0, $ezq2z.assetsConverter).convert(routeContext);
    if ((0, $j3mSh.dashboardsConverter).routes.has(routeName)) return (0, $j3mSh.dashboardsConverter).convert(routeContext);
    if ((0, $1RoZ2.filtersConverter).routes.has(routeName)) return (0, $1RoZ2.filtersConverter).convert(routeContext);
    if ((0, $hdJn1.operationsConverter).routes.has(routeName)) return (0, $hdJn1.operationsConverter).convert(routeContext);
    if ((0, $194uG.communicationsConverter).routes.has(routeName)) return (0, $194uG.communicationsConverter).convert(routeContext);
    if ((0, $3weqe.overviewsConverter).routes.has(routeName)) return (0, $3weqe.overviewsConverter).convert(routeContext);
    if ((0, $3weqe.overviewsConverter).routes.has(routeName)) return (0, $3weqe.overviewsConverter).convert(routeContext);
    if ((0, $c6hlO.plansConverter).routes.has(routeName)) return (0, $c6hlO.plansConverter).convert(routeContext);
    if ((0, $3lNyZ.projectsConverter).routes.has(routeName)) return (0, $3lNyZ.projectsConverter).convert(routeContext);
    if ((0, $8bXrC.roadmapsConverter).routes.has(routeName)) return (0, $8bXrC.roadmapsConverter).convert(routeContext);
    if ((0, $eReVn.serviceManagementProjectSettingsConverter).routes.has(routeName)) return (0, $eReVn.serviceManagementProjectSettingsConverter).convert(routeContext);
    if ((0, $4R6GH.fg)('jcs_master_flag')) {
        if ((0, $djX45.customerServiceConverter).routes.has(routeName)) return (0, $djX45.customerServiceConverter).convert(routeContext);
    }
    return [];
}
function $551cdf5d088747a1$export$216c13b87ae41e0b(state) {
    const routeName = state.route.name;
    const match = state.match;
    const query = state.query;
    if ((0, $2m3Yb.topLevelConverter).routes.has(routeName)) return (0, $2m3Yb.topLevelConverter).convertNew({
        routeName: routeName
    });
    if ((0, $fBDpl.appsConverter).routes.has(routeName)) return (0, $fBDpl.appsConverter).convertNew({
        routeName: routeName,
        match: match,
        query: query
    });
    if ((0, $ezq2z.assetsConverter).routes.has(routeName)) return (0, $ezq2z.assetsConverter).convertNew({
        routeName: routeName
    });
    if ((0, $j3mSh.dashboardsConverter).routes.has(routeName)) return (0, $j3mSh.dashboardsConverter).convertNew({
        routeName: routeName,
        match: match,
        query: query
    });
    if ((0, $1RoZ2.filtersConverter).routes.has(routeName)) return (0, $1RoZ2.filtersConverter).convertNew({
        routeName: routeName,
        match: match,
        query: query
    });
    if ((0, $hdJn1.operationsConverter).routes.has(routeName)) return (0, $hdJn1.operationsConverter).convertNew({
        routeName: routeName,
        query: query
    });
    if ((0, $194uG.communicationsConverter).routes.has(routeName)) return (0, $194uG.communicationsConverter).convertNew({
        routeName: routeName,
        query: query
    });
    if ((0, $3weqe.overviewsConverter).routes.has(routeName)) return (0, $3weqe.overviewsConverter).convertNew({
        routeName: routeName,
        match: match
    });
    if ((0, $c6hlO.plansConverter).routes.has(routeName)) return (0, $c6hlO.plansConverter).convertNew({
        routeName: routeName,
        match: match
    });
    if ((0, $3lNyZ.projectsConverter).routes.has(routeName)) return (0, $3lNyZ.projectsConverter).convertNew({
        routeName: routeName,
        match: match,
        query: query
    });
    if ((0, $8bXrC.roadmapsConverter).routes.has(routeName)) return (0, $8bXrC.roadmapsConverter).convertNew({
        routeName: routeName,
        match: match
    });
    if ((0, $eReVn.serviceManagementProjectSettingsConverter).routes.has(routeName)) return (0, $eReVn.serviceManagementProjectSettingsConverter).convertNew({
        routeName: routeName
    });
    if ((0, $4R6GH.fg)('jcs_master_flag')) {
        if ((0, $djX45.customerServiceConverter).routes.has(routeName)) return (0, $djX45.customerServiceConverter).convertNew({
            routeName: routeName
        });
    }
    return [];
}
function $551cdf5d088747a1$export$8eb45058a3aef67f() {
    return (0, $5uXOq.useState)(()=>{
        const selectedPath = $551cdf5d088747a1$export$216c13b87ae41e0b((0, $lODMY.getRouterState)());
        return {
            initialSelectedPath: selectedPath,
            selectedPath: selectedPath
        };
    });
}
function $551cdf5d088747a1$export$a086f1986cac3253() {
    const [selectedPathData, setSelectedPathData] = $551cdf5d088747a1$export$8eb45058a3aef67f();
    (0, $5uXOq.useEffect)(()=>(0, $lODMY.addRouteListener)((state)=>{
            const nextSelectedPath = $551cdf5d088747a1$export$216c13b87ae41e0b(state);
            const pathIsDifferent = (0, $4R6GH.fg)('jira-concurrent-nav4-fix-selected-path') ? !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(nextSelectedPath, selectedPathData.selectedPath) // Since this is an array and not a primitive, we need to do an isEqual check
             : nextSelectedPath !== selectedPathData.selectedPath;
            if (pathIsDifferent) setSelectedPathData({
                initialSelectedPath: selectedPathData.initialSelectedPath,
                selectedPath: nextSelectedPath
            });
        }), [
        selectedPathData.initialSelectedPath,
        selectedPathData.selectedPath,
        setSelectedPathData
    ]);
    return selectedPathData;
}

});
parcelRegister("fBDpl", function(module, exports) {

$parcel$export(module.exports, "appsConverter", () => $55a8ac7f9c56fb94$export$d017a63045c88c47);

var $jhS4y = parcelRequire("jhS4y");
// TODO: verify these routes
const $55a8ac7f9c56fb94$var$UNCERTAIN_APPS_SECTION_ROUTES = [
    'connect-general',
    'connect-general-invalid',
    'legacy-connect-general',
    'legacy-connect-project',
    /**
	 * This one tricky, and I wish it was documented somewhere, so here you go:
	 * Among different Connect app types, there are global Connect apps and JSM Connect apps (project apps).
	 * The URL of the global app looks like this:
	 *   `/plugins/servlet/ac/catlassian/catlassian-page?project.key=IP&project.id=10154`
	 * The URL of the JSM project app looks like this (there is also another URL pattern, but it is not relevant to this case):
	 *   `/plugins/servlet/ac/catlassian/catlassian-page-A?project.key=IP&project.id=10154&servicedesk.serviceDeskId=31`
	 * They have different route names and differ only by the `servicedesk.serviceDeskId` query parameter.
	 * But here's the catch: the global app URL can also contain a `servicedesk.serviceDeskId` query parameter,
	 * it is enough for the user to navigate to a specific JSM route in order for that JSM project to be saved as the most recent project,
	 * and it looks like Connect adds that most recent project context to the URL.
	 * Once that happens, the global app route is no longer matched, the JSM one is, which brings a lot of confusion since at this point
	 * we have no idea whether the "Apps" section should be expanded or the "Projects" one, since it is possible the app lives in either of those.
	 * You can navigate to the JSW project in order to override the JSM one and that query param will disappear from the global app URL.
	 * So what we are doing here? We are adding the route to the list of global Connect apps (just like its route name suggests) and potentially return a false positive value.
	 * Later on in the code we are going to check whether the app is global or not based on the data we have (the list of apps) and fix that.
	 */ 'connect-general-service-desk-project',
    'connect-project'
];
const $55a8ac7f9c56fb94$var$CERTAIN_APPS_SECTION_ROUTES = [
    'forge-spa-global',
    'marketplace-index',
    'forge-spa-personal-settings'
];
const $55a8ac7f9c56fb94$export$66b32f6f30eb4b4 = new Set([
    ...$55a8ac7f9c56fb94$var$UNCERTAIN_APPS_SECTION_ROUTES,
    ...$55a8ac7f9c56fb94$var$CERTAIN_APPS_SECTION_ROUTES
]);
function $55a8ac7f9c56fb94$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match, query: query } = routeContext;
    const path = [
        (0, $jhS4y.MENU_ID_APPS)
    ];
    return $55a8ac7f9c56fb94$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $55a8ac7f9c56fb94$var$convertNew(args) {
    const { routeName: routeName, match: match, query: query } = args;
    const path = [
        (0, $jhS4y.MENU_ID_APPS)
    ];
    return $55a8ac7f9c56fb94$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $55a8ac7f9c56fb94$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, query: query, path: path } = args;
    switch(routeName){
        case 'marketplace-index':
            path.push((0, $jhS4y.MENU_ID_APP_MARKETPLACE_DISCOVER));
            break;
        case 'connect-general':
        case 'connect-general-invalid':
        case 'forge-spa-global':
        case 'forge-spa-personal-settings':
        case 'legacy-connect-general':
            path.push((0, $jhS4y.ENTITY_ID).APP(match.url.replace(/\/$/, '')));
            break;
        case 'connect-project':
        case 'legacy-connect-project':
            {
                const { projectKey: projectKey } = match.params;
                return [
                    (0, $jhS4y.MENU_ID_PROJECTS),
                    (0, $jhS4y.ENTITY_ID).PROJECT(projectKey || '')
                ];
            }
        case 'connect-general-service-desk-project':
            {
                const { projectKey: projectKey } = query;
                return [
                    (0, $jhS4y.MENU_ID_PROJECTS),
                    (0, $jhS4y.ENTITY_ID).PROJECT(projectKey || '')
                ];
            }
        default:
            break;
    }
    return path;
}
const $55a8ac7f9c56fb94$export$d017a63045c88c47 = {
    routes: $55a8ac7f9c56fb94$export$66b32f6f30eb4b4,
    convert: $55a8ac7f9c56fb94$var$convert,
    convertNew: $55a8ac7f9c56fb94$var$convertNew
};

});

parcelRegister("ezq2z", function(module, exports) {

$parcel$export(module.exports, "assetsConverter", () => $bdd6509d07f3cefb$export$6cfeba0849032a84);

var $jhS4y = parcelRequire("jhS4y");
const $bdd6509d07f3cefb$var$routes = new Set([
    'assets',
    'assets-configure',
    'assets-data-manager-getting-started',
    'assets-data-manager-object-classes',
    'assets-data-manager-data-source',
    'assets-object',
    'assets-schema',
    'assets-schema-configuration',
    'assets-object-type-configuration',
    'assets-reports',
    'assets-reports-default-redirect',
    'assets-reports-unsubscribe',
    'servicedesk-cmdb-assets',
    'servicedesk-cmdb-configure',
    'servicedesk-cmdb-object',
    'servicedesk-cmdb-object-schema',
    'servicedesk-cmdb-object-schema-configuration',
    'servicedesk-cmdb-object-type-configuration',
    'servicedesk-cmdb-assets-reports',
    'servicedesk-cmdb-assets-reports-default-redirect',
    'servicedesk-cmdb-assets-reports-unsubscribe',
    'servicedesk-cmdb-insight',
    'servicedesk-cmdb-configure',
    'servicedesk-cmdb-object',
    'servicedesk-cmdb-object-schema',
    'servicedesk-cmdb-object-schema-configuration',
    'servicedesk-cmdb-object-type-configuration'
]);
function $bdd6509d07f3cefb$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [
        (0, $jhS4y.MENU_ID_ASSETS)
    ];
    return $bdd6509d07f3cefb$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $bdd6509d07f3cefb$var$convertNew(args) {
    const { routeName: routeName } = args;
    const path = [
        (0, $jhS4y.MENU_ID_ASSETS)
    ];
    return $bdd6509d07f3cefb$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $bdd6509d07f3cefb$var$convertRouteToPath(args) {
    const { routeName: routeName, path: path } = args;
    switch(routeName){
        case 'servicedesk-cmdb-assets':
        case 'servicedesk-cmdb-object':
        case 'servicedesk-cmdb-object-schema':
        case 'servicedesk-cmdb-object-schema-configuration':
        case 'servicedesk-cmdb-object-type-configuration':
            path.push((0, $jhS4y.MENU_ID_ASSETS_SCHEMAS));
            break;
        // Duplicate route-names of the above routes
        // eslint-disable-next-line no-duplicate-case
        case 'servicedesk-cmdb-object':
        // eslint-disable-next-line no-duplicate-case, no-fallthrough
        case 'servicedesk-cmdb-object-schema':
        // eslint-disable-next-line no-duplicate-case, no-fallthrough
        case 'servicedesk-cmdb-object-schema-configuration':
        // eslint-disable-next-line no-duplicate-case, no-fallthrough
        case 'servicedesk-cmdb-object-type-configuration':
            path.push((0, $jhS4y.MENU_ID_ASSETS_SCHEMAS));
            break;
        case 'servicedesk-cmdb-assets-reports':
        case 'servicedesk-cmdb-assets-reports-default-redirect':
        case 'servicedesk-cmdb-assets-reports-unsubscribe':
            path.push((0, $jhS4y.MENU_ID_ASSETS_REPORTS));
            break;
        default:
            break;
    }
    return path;
}
const $bdd6509d07f3cefb$export$6cfeba0849032a84 = {
    routes: $bdd6509d07f3cefb$var$routes,
    convert: $bdd6509d07f3cefb$var$convert,
    convertNew: $bdd6509d07f3cefb$var$convertNew
};

});

parcelRegister("j3mSh", function(module, exports) {

$parcel$export(module.exports, "dashboardsConverter", () => $257dabfdf8711aa2$export$6468819b4be328b1);

var $jhS4y = parcelRequire("jhS4y");
const $257dabfdf8711aa2$var$routes = new Set([
    'dashboards-directory',
    'dashboard-edit',
    'dashboard-view',
    'dashboard-wallboard'
]);
function $257dabfdf8711aa2$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match, query: query } = routeContext;
    const path = [
        (0, $jhS4y.MENU_ID_DASHBOARDS)
    ];
    return $257dabfdf8711aa2$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $257dabfdf8711aa2$var$convertNew(args) {
    const { routeName: routeName, match: match, query: query } = args;
    const path = [
        (0, $jhS4y.MENU_ID_DASHBOARDS)
    ];
    return $257dabfdf8711aa2$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $257dabfdf8711aa2$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, query: query, path: path } = args;
    switch(routeName){
        case 'dashboards-directory':
            path.push((0, $jhS4y.MENU_ID_DASHBOARDS_VIEW_ALL));
            break;
        case 'dashboard-wallboard':
            query.dashboardId && path.push((0, $jhS4y.ENTITY_ID).DASHBOARD(query.dashboardId));
            break;
        default:
            {
                const dashboardId = match.params.dashboardId;
                if (dashboardId === 'last-visited') // This is not really correct. The problem is we cannot tell what the true dashboardId is in this case.
                path.push((0, $jhS4y.MENU_ID_DASHBOARDS_VIEW_ALL));
                else dashboardId && path.push((0, $jhS4y.ENTITY_ID).DASHBOARD(dashboardId));
                break;
            }
    }
    return path;
}
const $257dabfdf8711aa2$export$6468819b4be328b1 = {
    routes: $257dabfdf8711aa2$var$routes,
    convert: $257dabfdf8711aa2$var$convert,
    convertNew: $257dabfdf8711aa2$var$convertNew
};

});

parcelRegister("1RoZ2", function(module, exports) {

$parcel$export(module.exports, "filtersConverter", () => $c2ae3b230f933dc6$export$6e91331b5debb7c8);

var $jhS4y = parcelRequire("jhS4y");
const $c2ae3b230f933dc6$var$routes = new Set([
    'filters-directory',
    'global-issue-navigator',
    'global-issue-navigator-browse-issue-redirect',
    'issue',
    'legacy-gin',
    'legacy-gin-issue',
    'legacy-gin-subscriptions'
]);
function $c2ae3b230f933dc6$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { query: query, match: match } = routeContext;
    const path = [
        (0, $jhS4y.MENU_ID_FILTERS)
    ];
    return $c2ae3b230f933dc6$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $c2ae3b230f933dc6$var$convertNew(args) {
    const { routeName: routeName, match: match, query: query } = args;
    const path = [
        (0, $jhS4y.MENU_ID_FILTERS)
    ];
    return $c2ae3b230f933dc6$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $c2ae3b230f933dc6$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, query: query, path: path } = args;
    switch(routeName){
        case 'filters-directory':
            path.push((0, $jhS4y.MENU_ID_FILTERS_VIEW_ALL));
            break;
        case 'issue':
            {
                const filterId = query.filter || query.filterId;
                if (filterId) path.push((0, $jhS4y.ENTITY_ID).FILTER(filterId));
                else if (match.params?.issueKey) {
                    const [projectKey] = (match.params?.issueKey || '').split('-'); // For this route to match, the issueKey will never be blank
                    return [
                        (0, $jhS4y.MENU_ID_PROJECTS),
                        (0, $jhS4y.ENTITY_ID).PROJECT(projectKey)
                    ];
                }
                break;
            }
        default:
            {
                const filterId = query.filter || query.filterId;
                // Search filters URL
                if (filterId === undefined) path.push((0, $jhS4y.MENU_ID_FILTERS_SEARCH));
                else // The rest of the URLs are using a filter ID.
                // Test this case: https://buglow-jsw.jira-dev.com/secure/ViewSubscriptions.jspa?filterId=10007
                path.push((0, $jhS4y.ENTITY_ID).FILTER(filterId));
                break;
            }
    }
    return path;
}
const $c2ae3b230f933dc6$export$6e91331b5debb7c8 = {
    routes: $c2ae3b230f933dc6$var$routes,
    convert: $c2ae3b230f933dc6$var$convert,
    convertNew: $c2ae3b230f933dc6$var$convertNew
};

});

parcelRegister("hdJn1", function(module, exports) {

$parcel$export(module.exports, "operationsConverter", () => $9b181cf5d70a46b3$export$7fc92455d5020e1);

var $4R6GH = parcelRequire("4R6GH");

var $jhS4y = parcelRequire("jhS4y");
const $9b181cf5d70a46b3$var$routes = new Set([
    'eoc-automations',
    'eoc-custom-roles',
    'eoc-global-alerts',
    'eoc-global-alerts-redirect',
    'eoc-global-alert-detail',
    'eoc-global-group-detail',
    'eoc-global-reports',
    'eoc-global-report-dashboard',
    'eoc-heartbeats',
    'eoc-global-heartbeats',
    'eoc-maintenance',
    'eoc-on-call',
    'eoc-on-call-redirect',
    'eoc-overview',
    'eoc-overview-all-teams',
    'eoc-permissions',
    'eoc-reports',
    'eoc-reports-team',
    'eoc-reports-unsubscribe',
    'eoc-schedules',
    'eoc-team-alerts',
    'eoc-team-alert-detail',
    'eoc-team-alert-issue-syncing',
    'eoc-team-alert-issue-syncing-create',
    'eoc-team-alert-issue-syncing-detail',
    'eoc-team-group-detail',
    'eoc-team-integrations',
    'eoc-team-integration-create',
    'eoc-team-integration-detail',
    'eoc-team-integration-list',
    'eoc-team-integration-log',
    'eoc-team-policies',
    'eoc-who-is-on-call',
    'eoc-global-escalations'
]);
function $9b181cf5d70a46b3$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { query: query } = routeContext;
    const path = [
        (0, $jhS4y.MENU_ID_OPERATIONS)
    ];
    return $9b181cf5d70a46b3$var$convertRouteToPath({
        routeName: routeName,
        query: query,
        path: path
    });
}
function $9b181cf5d70a46b3$var$convertNew(args) {
    const { routeName: routeName, query: query } = args;
    const path = [
        (0, $jhS4y.MENU_ID_OPERATIONS)
    ];
    return $9b181cf5d70a46b3$var$convertRouteToPath({
        routeName: routeName,
        query: query,
        path: path
    });
}
function $9b181cf5d70a46b3$var$convertRouteToPath(args) {
    const { routeName: routeName, query: query, path: path } = args;
    switch(routeName){
        case 'eoc-who-is-on-call':
            path.push((0, $jhS4y.MENU_ID_OPS_ON_CALL));
            break;
        case 'eoc-global-alerts':
        case 'eoc-global-alerts-redirect':
        case 'eoc-global-alert-detail':
            {
                path.push((0, $jhS4y.MENU_ID_OPS_ALERTS));
                if ((0, $4R6GH.fg)('operations_nav4_remaining_items')) {
                    const { query: alarmQueue = '', view: view, filter: savedSearchId } = query;
                    view && path.push((0, $jhS4y.ENTITY_ID).ALARM_QUEUE(savedSearchId || alarmQueue));
                    break;
                }
                const { query: alarmQueue = '', view: view } = query;
                view && path.push((0, $jhS4y.ENTITY_ID).ALARM_QUEUE(alarmQueue));
                break;
            }
        case 'eoc-global-reports':
        case 'eoc-global-report-dashboard':
        case 'eoc-reports-unsubscribe':
            path.push((0, $jhS4y.MENU_ID_OPS_REPORTS));
            break;
        case 'eoc-automations':
        case 'eoc-global-group-detail':
        case 'eoc-heartbeats':
        case 'eoc-maintenance':
        case 'eoc-permissions':
        case 'eoc-on-call':
        case 'eoc-on-call-redirect':
        case 'eoc-overview':
        case 'eoc-overview-all-teams':
        case 'eoc-reports':
        case 'eoc-reports-team':
        case 'eoc-schedules':
        case 'eoc-team-group-detail':
        case 'eoc-team-alerts':
        case 'eoc-team-alert-detail':
        case 'eoc-team-policies':
        case 'eoc-team-alert-issue-syncing':
        case 'eoc-team-alert-issue-syncing-create':
        case 'eoc-team-alert-issue-syncing-detail':
        case 'eoc-team-integrations':
        case 'eoc-team-integration-create':
        case 'eoc-team-integration-detail':
        case 'eoc-team-integration-list':
        case 'eoc-team-integration-log':
            path.push((0, $jhS4y.MENU_ID_OPS_OVERVIEW));
            break;
        default:
            break;
    }
    return path;
}
const $9b181cf5d70a46b3$export$7fc92455d5020e1 = {
    routes: $9b181cf5d70a46b3$var$routes,
    convert: $9b181cf5d70a46b3$var$convert,
    convertNew: $9b181cf5d70a46b3$var$convertNew
};

});

parcelRegister("194uG", function(module, exports) {

$parcel$export(module.exports, "communicationsConverter", () => $f2bd9469d6756282$export$e136020d3142ef55);

var $jhS4y = parcelRequire("jhS4y");
const $f2bd9469d6756282$var$routes = new Set([
    'communications-stakeholder-groups',
    'communications-stakeholders'
]);
function $f2bd9469d6756282$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { query: query } = routeContext;
    const path = [
        (0, $jhS4y.MENU_ID_COMMUNICATION)
    ];
    return $f2bd9469d6756282$var$convertRouteToPath({
        routeName: routeName,
        query: query,
        path: path
    });
}
function $f2bd9469d6756282$var$convertNew(args) {
    const { routeName: routeName, query: query } = args;
    const path = [
        (0, $jhS4y.MENU_ID_COMMUNICATION)
    ];
    return $f2bd9469d6756282$var$convertRouteToPath({
        routeName: routeName,
        query: query,
        path: path
    });
}
function $f2bd9469d6756282$var$convertRouteToPath(args) {
    const { routeName: routeName, path: path } = args;
    switch(routeName){
        case 'communications-stakeholder-groups':
            path.push((0, $jhS4y.MENU_ID_COMMUNICATIONS_STAKEHOLDERS));
            break;
        case 'communications-stakeholders':
            path.push((0, $jhS4y.MENU_ID_COMMUNICATIONS_STAKEHOLDERS));
            break;
        default:
            break;
    }
    return path;
}
const $f2bd9469d6756282$export$e136020d3142ef55 = {
    routes: $f2bd9469d6756282$var$routes,
    convert: $f2bd9469d6756282$var$convert,
    convertNew: $f2bd9469d6756282$var$convertNew
};

});

parcelRegister("2m3Yb", function(module, exports) {

$parcel$export(module.exports, "topLevelConverter", () => $c60c27b55fbcd9c5$export$a33f2d74a674bf8a);

var $jhS4y = parcelRequire("jhS4y");
const $c60c27b55fbcd9c5$var$routes = new Set([
    'your-work',
    'people-index'
]);
function $c60c27b55fbcd9c5$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [];
    return $c60c27b55fbcd9c5$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $c60c27b55fbcd9c5$var$convertNew(args) {
    const { routeName: routeName } = args;
    const path = [];
    return $c60c27b55fbcd9c5$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $c60c27b55fbcd9c5$var$convertRouteToPath(args) {
    const { routeName: routeName, path: path } = args;
    switch(routeName){
        case 'your-work':
            path.push((0, $jhS4y.MENU_ID_YOUR_WORK));
            break;
        case 'people-index':
            path.push((0, $jhS4y.MENU_ID_TEAMS));
            break;
        default:
    }
    return path;
}
const $c60c27b55fbcd9c5$export$a33f2d74a674bf8a = {
    routes: $c60c27b55fbcd9c5$var$routes,
    convert: $c60c27b55fbcd9c5$var$convert,
    convertNew: $c60c27b55fbcd9c5$var$convertNew
};

});

parcelRegister("3weqe", function(module, exports) {

$parcel$export(module.exports, "overviewsConverter", () => $b8a10fc0a37e731b$export$5469f6c6536ca9c5);

var $jhS4y = parcelRequire("jhS4y");
const $b8a10fc0a37e731b$var$routes = new Set([
    'classic-business-overview-calendar',
    'classic-business-overview-redirect',
    'classic-business-overview-summary',
    'classic-business-overview-timeline'
]);
function $b8a10fc0a37e731b$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match } = routeContext;
    const path = [
        (0, $jhS4y.MENU_ID_OVERVIEWS)
    ];
    return $b8a10fc0a37e731b$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $b8a10fc0a37e731b$var$convertNew(args) {
    const { routeName: routeName, match: match } = args;
    const path = [
        (0, $jhS4y.MENU_ID_OVERVIEWS)
    ];
    return $b8a10fc0a37e731b$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $b8a10fc0a37e731b$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, path: path } = args;
    routeName;
    {
        const { overviewId: overviewId } = match.params;
        overviewId && path.push((0, $jhS4y.ENTITY_ID).OVERVIEW(overviewId));
    }
    return path;
}
const $b8a10fc0a37e731b$export$5469f6c6536ca9c5 = {
    routes: $b8a10fc0a37e731b$var$routes,
    convert: $b8a10fc0a37e731b$var$convert,
    convertNew: $b8a10fc0a37e731b$var$convertNew
};

});

parcelRegister("c6hlO", function(module, exports) {

$parcel$export(module.exports, "plansConverter", () => $a783e1b6f52291a3$export$3bde637b58016d1);

var $jhS4y = parcelRequire("jhS4y");
const $a783e1b6f52291a3$var$routes = new Set([
    'plans-directory',
    'software-advanced-roadmaps',
    'software-advanced-roadmaps-getting-started-redirect',
    'software-advanced-roadmaps-setup',
    'software-plan-calendar',
    'software-plan-dependencies',
    'software-plan-increment',
    'software-plan-increments',
    'software-plan-releases',
    'software-plan-summary',
    'software-plan-teams',
    'software-plan-timeline',
    'trashed-plan-direct-link',
    'software-plan-upsell'
]);
function $a783e1b6f52291a3$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match } = routeContext;
    const path = [
        (0, $jhS4y.MENU_ID_PLANS)
    ];
    return $a783e1b6f52291a3$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $a783e1b6f52291a3$var$convertNew(args) {
    const { routeName: routeName, match: match } = args;
    const path = [
        (0, $jhS4y.MENU_ID_PLANS)
    ];
    return $a783e1b6f52291a3$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $a783e1b6f52291a3$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, path: path } = args;
    switch(routeName){
        case 'plans-directory':
        case 'software-advanced-roadmaps-getting-started-redirect':
            path.push((0, $jhS4y.MENU_ID_PLANS_VIEW_ALL));
            break;
        case 'trashed-plan-direct-link':
            break;
        default:
            {
                const { planId: planId } = match.params;
                planId && path.push((0, $jhS4y.ENTITY_ID).PLAN(planId));
            }
    }
    return path;
}
const $a783e1b6f52291a3$export$3bde637b58016d1 = {
    routes: $a783e1b6f52291a3$var$routes,
    convert: $a783e1b6f52291a3$var$convert,
    convertNew: $a783e1b6f52291a3$var$convertNew
};

});

parcelRegister("3lNyZ", function(module, exports) {

$parcel$export(module.exports, "projectsConverter", () => $6eaade1a69d23d1d$export$c41b724886e5872b);

var $4R6GH = parcelRequire("4R6GH");

var $jhS4y = parcelRequire("jhS4y");
const $6eaade1a69d23d1d$var$routes = new Set([
    'browse-project-redirect',
    'legacy-all-reports',
    'projects-directory',
    'issue-navigator',
    'issue-navigator-core',
    'project-components',
    'project-not-found',
    'project-versions',
    'software-version-detail',
    'software-version-detail-no-tab-path',
    'forge-spa-project',
    'forge-spa-project-servicedesk',
    'forge-spa-servicedesk-queue',
    'polaris-ideas',
    'polaris-onboarding',
    'opsgenie-schedule',
    'issue-navigator-classic',
    'project-pages',
    'rapidboard-backlog',
    'rapidboard-board',
    'rapidboard-report',
    'software-backlog',
    'software-boards',
    'software-calendar',
    'software-calendar-classic',
    'classic-software-proforma-issue-forms-direct',
    'software-code',
    'software-code-classic',
    'software-deployments',
    'software-deployments-classic',
    'software-form',
    'software-form-classic',
    'software-form-builder',
    'software-form-builder-classic',
    'software-form-submit',
    'software-form-submit-classic',
    'software-form-submit-embed',
    'software-form-submit-public',
    'software-form-submit-classic-embed',
    'software-form-submit-classic-public',
    'software-goals',
    'software-goals-classic',
    'software-incidents',
    'software-incidents-classic',
    'software-issue-navigator',
    'software-list',
    'software-list-classic',
    'software-periscope',
    'software-periscope-classic',
    'software-reports',
    'software-reports-boardless',
    'software-reports-burndown',
    'software-reports-burnup',
    'software-reports-control',
    'software-reports-cumulative',
    'software-reports-cycle-time',
    'software-reports-cycle-time-classic',
    'software-reports-deployment-frequency',
    'software-reports-deployment-frequency-classic',
    'software-reports-velocity',
    'software-reports-velocity-cmp',
    'software-security',
    'software-security-classic',
    'software-summary',
    'software-summary-embed',
    'software-summary-classic',
    'software-summary-classic-embed',
    'software-timeline',
    'software-timeline-classic',
    'software-view-not-found',
    'software-view-not-found-classic',
    'software-board-view-not-found',
    'software-board-view-not-found-classic',
    'knowledge-hub-all-articles',
    'kb-article-embed-editor',
    'knowledge-hub-article-in-category',
    'knowledge-hub-browse-all-articles',
    'knowledge-hub-browse-all-categories',
    'knowledge-hub-browse-view-article',
    'knowledge-hub-category',
    'knowledge-hub-category-page',
    'knowledge-hub-drafts',
    'knowledge-hub-suggested-topics',
    'knowledge-hub-landing',
    'knowledge-hub-search',
    'knowledge-hub-setup',
    'notification-logs',
    'servicedesk-atlassian-analytics',
    'servicedesk-boards',
    'servicedesk-calendar',
    'servicedesk-project-summary',
    'servicedesk-change-calendar',
    'servicedesk-connect-project',
    'servicedesk-customers-v2',
    'servicedesk-customer-details',
    'servicedesk-customer-service-escalations',
    'servicedesk-customer-service-products',
    'servicedesk-getting-started-page',
    'servicedesk-issue',
    'servicedesk-issues',
    'servicedesk-kb-requests-reports',
    'servicedesk-kb-requests-reports-time-scale-issue',
    'servicedesk-kb-requests-reports-time-scale',
    'servicedesk-oncall-schedule',
    'servicedesk-organizations',
    'servicedesk-organization-details',
    'servicedesk-organization_v2',
    'servicedesk-queues-practice-custom-board',
    'servicedesk-queues-practice-custom-calendar',
    'servicedesk-practice-custom-and-issue',
    'servicedesk-practice-edit',
    'servicedesk-practice-issue',
    'servicedesk-practice-landing',
    'servicedesk-practice-manage-view',
    'servicedesk-practice-new',
    'servicedesk-queues-addon',
    'servicedesk-queues-custom-board',
    'servicedesk-queues-custom-calendar',
    'servicedesk-queues-custom-view',
    'servicedesk-queues-custom-issue-detail',
    'servicedesk-queues-edit',
    'servicedesk-practice-views-config',
    'servicedesk-queues-views-config',
    'servicedesk-queues-issue',
    'servicedesk-queues-manage-view',
    'servicedesk-queues-new',
    'servicedesk-reports',
    'servicedesk-reports-custom',
    'servicedesk-reports-custom-create',
    'servicedesk-reports-custom-edit',
    'servicedesk-reports-custom-time-scale-issue',
    'servicedesk-reports-custom-time-scale',
    'servicedesk-reports-satisfaction',
    'servicedesk-reports-satisfaction-time-scale-issue',
    'servicedesk-reports-satisfaction-time-scale',
    'servicedesk-reports-type',
    'servicedesk-reports-workload',
    'servicedesk-avp-project-dashboards-editable',
    'servicedesk-avp-project-dashboards-list',
    'servicedesk-services',
    'servicedesk-service-details',
    'classic-business-approvals',
    'classic-business-attachments',
    'classic-business-board',
    'classic-business-calendar',
    'classic-business-form',
    'classic-business-form-builder',
    'classic-business-form-submit',
    'classic-business-form-submit-public',
    'classic-business-list',
    'classic-business-shortcut',
    'classic-business-summary',
    'classic-business-timeline',
    'classic-business-view-not-found',
    'classic-business-redirect',
    'inbox',
    'inbox-classic'
]);
const $6eaade1a69d23d1d$var$routesWithArchivedWorkItemsRoute = new Set($6eaade1a69d23d1d$var$routes);
$6eaade1a69d23d1d$var$routesWithArchivedWorkItemsRoute.add('archived-issues-directory').add('classic-business-archived-work-items').add('servicedesk-archived-work-items').add('software-archived-work-items-classic').add('software-archived-work-items');
function $6eaade1a69d23d1d$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match, query: query } = routeContext;
    const path = [
        (0, $jhS4y.MENU_ID_PROJECTS)
    ];
    return $6eaade1a69d23d1d$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $6eaade1a69d23d1d$var$convertNew(args) {
    const { routeName: routeName, match: match, query: query } = args;
    const path = [
        (0, $jhS4y.MENU_ID_PROJECTS)
    ];
    return $6eaade1a69d23d1d$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $6eaade1a69d23d1d$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, query: query, path: path } = args;
    switch(routeName){
        case 'polaris-onboarding':
            break;
        case 'projects-directory':
            path.push((0, $jhS4y.MENU_ID_PROJECTS_VIEW_ALL));
            break;
        case 'forge-spa-project':
        case 'forge-spa-project-servicedesk':
        case 'forge-spa-servicedesk-queue':
            {
                const { projectKey: projectKey, appId: appId } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                path.push((0, $jhS4y.MENU_ID_PROJECT_APPS));
                appId && path.push((0, $jhS4y.ENTITY_ID).APP(appId));
                break;
            }
        case 'knowledge-hub-all-articles':
        case 'kb-article-embed-editor':
        case 'knowledge-hub-article-in-category':
        case 'knowledge-hub-browse-all-articles':
        case 'knowledge-hub-browse-all-categories':
        case 'knowledge-hub-browse-view-article':
        case 'knowledge-hub-category':
        case 'knowledge-hub-category-page':
        case 'knowledge-hub-drafts':
        case 'knowledge-hub-suggested-topics':
        case 'knowledge-hub-landing':
        case 'knowledge-hub-search':
        case 'knowledge-hub-setup':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_KNOWLEDGE_BASE(projectKey));
                break;
            }
        case 'servicedesk-getting-started-page':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_JSM_GETTING_STARTED(projectKey));
                break;
            }
        case 'notification-logs':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_NOTIFICATION_LOGS(projectKey));
                break;
            }
        case 'servicedesk-project-summary':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_SUMMARY(projectKey));
                break;
            }
        case 'servicedesk-boards':
            {
                const { projectKey: projectKey, boardId: boardId } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_VIEWS(projectKey));
                boardId && path.push((0, $jhS4y.ENTITY_ID).BOARD(boardId));
                break;
            }
        case 'servicedesk-calendar':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_VIEWS(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_CALENDAR(projectKey));
                break;
            }
        case 'servicedesk-change-calendar':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_CHANGE_CALENDAR(projectKey));
                break;
            }
        case 'servicedesk-organizations':
        case 'servicedesk-organization-details':
        case 'servicedesk-organization_v2':
        case 'servicedesk-customers-v2':
        case 'servicedesk-customer-details':
        case 'servicedesk-customer-service-products':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_DIRECTORY(projectKey));
                break;
            }
        case 'servicedesk-customer-service-escalations':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_ESCALATIONS(projectKey));
                break;
            }
        case 'servicedesk-kb-requests-reports':
        case 'servicedesk-kb-requests-reports-time-scale-issue':
        case 'servicedesk-kb-requests-reports-time-scale':
        case 'servicedesk-reports':
        case 'servicedesk-reports-custom':
        case 'servicedesk-reports-custom-create':
        case 'servicedesk-reports-custom-edit':
        case 'servicedesk-reports-custom-time-scale-issue':
        case 'servicedesk-reports-custom-time-scale':
        case 'servicedesk-reports-satisfaction':
        case 'servicedesk-reports-satisfaction-time-scale-issue':
        case 'servicedesk-reports-satisfaction-time-scale':
        case 'servicedesk-reports-type':
        case 'servicedesk-reports-workload':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_REPORTS(projectKey));
                break;
            }
        case 'servicedesk-avp-project-dashboards-editable':
        case 'servicedesk-avp-project-dashboards-list':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_DASHBOARDS(projectKey));
                break;
            }
        case 'servicedesk-oncall-schedule':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_ONCALL_SCHEDULE(projectKey));
                break;
            }
        case 'servicedesk-issues':
            {
                const { projectKey: projectKey } = match.params;
                const filterId = query.filter || query.filterId;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                if (projectKey && filterId) {
                    path.push((0, $jhS4y.ENTITY_ID).PROJECT_FILTERS(projectKey));
                    path.push((0, $jhS4y.ENTITY_ID).PROJECT_ISSUE_FILTER(projectKey, filterId));
                }
                break;
            }
        case 'servicedesk-queues-practice-custom-board':
        case 'servicedesk-queues-practice-custom-calendar':
        case 'servicedesk-practice-custom-and-issue':
        case 'servicedesk-practice-edit':
        case 'servicedesk-practice-issue':
        case 'servicedesk-practice-landing':
        case 'servicedesk-practice-manage-view':
        case 'servicedesk-practice-views-config':
        case 'servicedesk-practice-new':
            {
                const { projectKey: projectKey, practiceType: practiceType, queueId: queueId } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && practiceType && path.push((0, $jhS4y.ENTITY_ID).PROJECT_PRACTICE_QUEUE(projectKey, practiceType));
                queueId && path.push((0, $jhS4y.ENTITY_ID).QUEUE(queueId));
                break;
            }
        case 'servicedesk-queues-addon':
        case 'servicedesk-queues-custom-board':
        case 'servicedesk-queues-custom-calendar':
        case 'servicedesk-queues-custom-view':
        case 'servicedesk-queues-edit':
        case 'servicedesk-queues-issue':
        case 'servicedesk-queues-manage-view':
        case 'servicedesk-queues-views-config':
        case 'servicedesk-queues-new':
            {
                const { projectKey: projectKey, queueId: queueId } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_QUEUES(projectKey));
                queueId && path.push((0, $jhS4y.ENTITY_ID).QUEUE(queueId));
                break;
            }
        case 'servicedesk-queues-custom-issue-detail':
            {
                const { projectKey: projectKey, queueId: queueId, issueKey: issueKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_QUEUES(projectKey));
                queueId && path.push((0, $jhS4y.ENTITY_ID).QUEUE(queueId));
                issueKey && path.push((0, $jhS4y.ENTITY_ID).ISSUE(issueKey));
                break;
            }
        case 'servicedesk-services':
        case 'servicedesk-service-details':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_SERVICES(projectKey));
                break;
            }
        default:
            {
                const { projectKey: projectKey, boardId: boardId, formId: formId } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                boardId && path.push((0, $jhS4y.ENTITY_ID).BOARD(boardId));
                formId && path.push((0, $jhS4y.ENTITY_ID).FORM(formId));
            }
    }
    if ((0, $4R6GH.fg)('fix-operations-menu-item-deselected-bug')) {
        const { projectKey: projectKey } = match.params;
        if ((routeName === 'servicedesk-change-calendar' || routeName === 'servicedesk-services' || routeName === 'servicedesk-service-details') && projectKey) path.push((0, $jhS4y.ENTITY_ID).PROJECT_OPERATIONS(projectKey));
    }
    return path;
}
const $6eaade1a69d23d1d$export$c41b724886e5872b = {
    get routes () {
        return (0, $4R6GH.fg)('ken_1984_archive_route_support_sidebar') ? $6eaade1a69d23d1d$var$routesWithArchivedWorkItemsRoute : $6eaade1a69d23d1d$var$routes;
    },
    convert: $6eaade1a69d23d1d$var$convert,
    convertNew: $6eaade1a69d23d1d$var$convertNew
};

});

parcelRegister("8bXrC", function(module, exports) {

$parcel$export(module.exports, "roadmapsConverter", () => $8c39d6aa787bb969$export$5761942b1e0c2dd0);

var $jhS4y = parcelRequire("jhS4y");
const $8c39d6aa787bb969$var$routes = new Set([
    'polaris-collections'
]);
function $8c39d6aa787bb969$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match } = routeContext;
    const path = [
        (0, $jhS4y.MENU_ID_ROADMAPS)
    ];
    return $8c39d6aa787bb969$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $8c39d6aa787bb969$var$convertNew(args) {
    const { routeName: routeName, match: match } = args;
    const path = [
        (0, $jhS4y.MENU_ID_ROADMAPS)
    ];
    return $8c39d6aa787bb969$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $8c39d6aa787bb969$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, path: path } = args;
    switch(routeName){
        case 'polaris-collections':
            {
                const collectionId = match.params.collectionUUID;
                if (collectionId) path.push((0, $jhS4y.ENTITY_ID).ROADMAP(collectionId));
                else path.push((0, $jhS4y.MENU_ID_ROADMAPS_VIEW_ALL));
                break;
            }
        default:
    }
    return path;
}
const $8c39d6aa787bb969$export$5761942b1e0c2dd0 = {
    routes: $8c39d6aa787bb969$var$routes,
    convert: $8c39d6aa787bb969$var$convert,
    convertNew: $8c39d6aa787bb969$var$convertNew
};

});

parcelRegister("eReVn", function(module, exports) {

$parcel$export(module.exports, "serviceManagementProjectSettingsConverter", () => $59806d8088c642c3$export$dd307ede503fe0e);

var $7HDop = parcelRequire("7HDop");

var $9ujoJ = parcelRequire("9ujoJ");

var $buwAo = parcelRequire("buwAo");

var $ji59e = parcelRequire("ji59e");

var $cAtSX = parcelRequire("cAtSX");

var $g49yz = parcelRequire("g49yz");

var $aBfqj = parcelRequire("aBfqj");

var $9wUes = parcelRequire("9wUes");

var $8pE1n = parcelRequire("8pE1n");

var $cfj3a = parcelRequire("cfj3a");

var $d9ukL = parcelRequire("d9ukL");

var $2I1zE = parcelRequire("2I1zE");

var $4P4Lq = parcelRequire("4P4Lq");

var $fdCkK = parcelRequire("fdCkK");

var $i62iX = parcelRequire("i62iX");

var $eObGp = parcelRequire("eObGp");

var $6z8e6 = parcelRequire("6z8e6");

var $coidL = parcelRequire("coidL");

var $jHXos = parcelRequire("jHXos");

var $h6YNW = parcelRequire("h6YNW");

var $6EgCy = parcelRequire("6EgCy");

var $2CYtL = parcelRequire("2CYtL");

var $bveQD = parcelRequire("bveQD");

var $59iBR = parcelRequire("59iBR");

var $b7dWt = parcelRequire("b7dWt");

var $8qmAq = parcelRequire("8qmAq");

var $fQ161 = parcelRequire("fQ161");

var $9sAYT = parcelRequire("9sAYT");

var $jJkuR = parcelRequire("jJkuR");

var $kuaoc = parcelRequire("kuaoc");

var $ieCBx = parcelRequire("ieCBx");

var $iXFkh = parcelRequire("iXFkh");

var $gvZrS = parcelRequire("gvZrS");

var $6oHoX = parcelRequire("6oHoX");

var $1r8X1 = parcelRequire("1r8X1");

var $1XuFh = parcelRequire("1XuFh");

var $3BQ4q = parcelRequire("3BQ4q");

var $2m3cT = parcelRequire("2m3cT");

var $hewRX = parcelRequire("hewRX");

var $cmEH1 = parcelRequire("cmEH1");

var $9xhY2 = parcelRequire("9xhY2");

var $043ka = parcelRequire("043ka");

var $4R6GH = parcelRequire("4R6GH");

var $jhS4y = parcelRequire("jhS4y");
const $59806d8088c642c3$var$routes = new Set([
    'legacy-project-settings-fields',
    'legacy-project-settings-issue-security',
    'legacy-project-settings-issue-types',
    'legacy-project-settings-notifications',
    'legacy-project-settings-people',
    'legacy-project-settings-permissions',
    'legacy-project-settings-screens',
    'legacy-project-settings-workflows',
    'legacy-project-settings-workflows-associate',
    'project-settings-automation',
    'servicedesk-sla-settings',
    (0, $ji59e.projectSettingsLegacyAutomationRoute).name,
    (0, $cAtSX.projectSettingsServicedeskAccessRoute).name,
    (0, $8pE1n.projectSettingsServicedeskChannelsPermissionsNextGenRoute).name,
    (0, $fdCkK.projectSettingsServicedeskCustomerPermissionsRoute).name,
    (0, $6z8e6.projectSettingsServicedeskFeedbackRoute).name,
    (0, $coidL.projectSettingsServicedeskFieldsRoute).name,
    (0, $59iBR.projectSettingsServicedeskProformaProjectFormsRoute).name,
    (0, $b7dWt.projectSettingsServicedeskRequestTypesWorkCategoryRoute).name,
    (0, $2I1zE.projectSettingsServicedeskChatRoute).name,
    (0, $i62iX.projectSettingsServicedeskEmailRoute).name,
    (0, $eObGp.projectSettingsServicedeskExternalLinksRoute).name,
    (0, $bveQD.projectSettingsServicedeskPortalSettingsRoute).name,
    (0, $8qmAq.projectSettingsServicedeskWidgetRoute).name,
    (0, $aBfqj.projectSettingsServicedeskChangeManagementRoute).name,
    (0, $jHXos.projectSettingsServicedeskIncidentManagementRoute).name,
    (0, $4P4Lq.projectSettingsServicedeskClassicAppsRoute).name,
    (0, $9wUes.projectSettingsServicedeskChannelsChatRoute).name,
    (0, $d9ukL.projectSettingsServicedeskChannelsWidgetRoute).name,
    (0, $9ujoJ.projectSettingsServicedeskNotificationsEmailRoute).name,
    (0, $buwAo.projectSettingsServicedeskNotificationsNotificationEmailRoute).name,
    (0, $2CYtL.projectSettingsServicedeskNotificationsInternalNotificationsRoute).name,
    (0, $g49yz.projectSettingsServicedeskAppsFieldsRoute).name,
    (0, $1XuFh.projectSettingsServicedeskCustomerNotificationsRoute).name,
    (0, $3BQ4q.projectSettingsServicedeskNotificationsCustomerNotificationsRoute).name,
    (0, $2m3cT.projectSettingsServicedeskKbRoute).name,
    (0, $cmEH1.projectSettingsServicedeskTicketTypesConfigRoute).name,
    (0, $9xhY2.projectSettingsServicedeskUnassignedTicketTypesConfigRoute).name,
    (0, $043ka.servicedeskWorkflowConfigRoute).name,
    (0, $6EgCy.projectSettingsServicedeskIssuetypesRoute).name,
    (0, $cfj3a.projectSettingsServicedeskChannelsPortalRoute).name,
    (0, $7HDop.projectSettingsServicedeskAutomationRoute).name,
    (0, $hewRX.servicedeskSlaSettingsRoute).name,
    (0, $h6YNW.projectSettingsServicedeskInternalNotificationsNextGenRoute).name,
    (0, $iXFkh.landingPageRoute).name,
    (0, $gvZrS.browseConversationsRoute).name,
    (0, $6oHoX.browseIntentsRoute).name,
    (0, $1r8X1.browseStandardFlowsRoute).name,
    (0, $fQ161.projectSettingsVirtualAgentSettingsRoute).name,
    (0, $9sAYT.virtualAgentConversationsRoute).name,
    (0, $jJkuR.virtualAgentIntentsRoute).name,
    (0, $ieCBx.virtualAgentStandardFlowsRoute).name,
    (0, $kuaoc.virtualAgentSettingsRoute).name
]);
function $59806d8088c642c3$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [];
    return $59806d8088c642c3$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $59806d8088c642c3$var$convertNew(args) {
    const { routeName: routeName } = args;
    const path = [];
    return $59806d8088c642c3$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $59806d8088c642c3$var$convertRouteToPath(args) {
    const { routeName: routeName, path: path } = args;
    const newVirtualAgentRoutes = [
        (0, $iXFkh.landingPageRoute).name,
        (0, $gvZrS.browseConversationsRoute).name,
        (0, $6oHoX.browseIntentsRoute).name,
        (0, $1r8X1.browseStandardFlowsRoute).name
    ];
    const oldVirtualAgentRoutes = [
        (0, $fQ161.projectSettingsVirtualAgentSettingsRoute).name,
        (0, $9sAYT.virtualAgentConversationsRoute).name,
        (0, $jJkuR.virtualAgentIntentsRoute).name,
        (0, $ieCBx.virtualAgentStandardFlowsRoute).name
    ];
    const virtualAgentRoutes = (0, $4R6GH.fg)('delete_duplicate_vsa_routes') ? newVirtualAgentRoutes : oldVirtualAgentRoutes;
    if (virtualAgentRoutes.includes(routeName)) {
        path.push((0, $jhS4y.MENU_ID_SD_SETTINGS_CHANNELS_AND_SELF_SERVICE));
        return path;
    }
    switch(routeName){
        // Access Menu
        case 'legacy-project-settings-people':
        case (0, $cAtSX.projectSettingsServicedeskAccessRoute).name:
        case (0, $fdCkK.projectSettingsServicedeskCustomerPermissionsRoute).name:
        case (0, $8pE1n.projectSettingsServicedeskChannelsPermissionsNextGenRoute).name:
        case 'legacy-project-settings-permissions':
        case 'legacy-project-settings-issue-security':
            path.push((0, $jhS4y.MENU_ID_SD_SETTINGS_ACCESS));
            break;
        // Request Management -> Request types menu
        case (0, $b7dWt.projectSettingsServicedeskRequestTypesWorkCategoryRoute).name:
        case (0, $9xhY2.projectSettingsServicedeskUnassignedTicketTypesConfigRoute).name:
            path.push((0, $jhS4y.MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT), (0, $jhS4y.MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT_REQUEST_TYPES));
            break;
        // Request Management
        case (0, $cmEH1.projectSettingsServicedeskTicketTypesConfigRoute).name:
        case (0, $59iBR.projectSettingsServicedeskProformaProjectFormsRoute).name:
        case 'legacy-project-settings-workflows':
        case (0, $043ka.servicedeskWorkflowConfigRoute).name:
        case 'legacy-project-settings-workflows-associate':
        case 'servicedesk-sla-settings':
        case (0, $hewRX.servicedeskSlaSettingsRoute).name:
        case (0, $6z8e6.projectSettingsServicedeskFeedbackRoute).name:
        case 'legacy-project-settings-issue-types':
        case (0, $6EgCy.projectSettingsServicedeskIssuetypesRoute).name:
        case 'legacy-project-settings-fields':
        case (0, $coidL.projectSettingsServicedeskFieldsRoute).name:
        case 'legacy-project-settings-screens':
            path.push((0, $jhS4y.MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT));
            break;
        // Automation
        case 'project-settings-automation':
        case (0, $ji59e.projectSettingsLegacyAutomationRoute).name:
        case (0, $7HDop.projectSettingsServicedeskAutomationRoute).name:
            path.push((0, $jhS4y.MENU_ID_SD_SETTINGS_AUTOMATION));
            break;
        // Channels and self-service
        case (0, $bveQD.projectSettingsServicedeskPortalSettingsRoute).name:
        case (0, $cfj3a.projectSettingsServicedeskChannelsPortalRoute).name:
        case (0, $i62iX.projectSettingsServicedeskEmailRoute).name:
        case (0, $2I1zE.projectSettingsServicedeskChatRoute).name:
        case (0, $8qmAq.projectSettingsServicedeskWidgetRoute).name:
        case (0, $2m3cT.projectSettingsServicedeskKbRoute).name:
        case (0, $eObGp.projectSettingsServicedeskExternalLinksRoute).name:
        case (0, $9wUes.projectSettingsServicedeskChannelsChatRoute).name:
        case (0, $d9ukL.projectSettingsServicedeskChannelsWidgetRoute).name:
        case (0, $kuaoc.virtualAgentSettingsRoute).name:
            path.push((0, $jhS4y.MENU_ID_SD_SETTINGS_CHANNELS_AND_SELF_SERVICE));
            break;
        // Operations
        case (0, $aBfqj.projectSettingsServicedeskChangeManagementRoute).name:
        case (0, $jHXos.projectSettingsServicedeskIncidentManagementRoute).name:
            path.push((0, $jhS4y.MENU_ID_SD_SETTINGS_OPERATIONS));
            break;
        // Notifications
        case 'legacy-project-settings-notifications':
        case (0, $1XuFh.projectSettingsServicedeskCustomerNotificationsRoute).name:
        case (0, $2CYtL.projectSettingsServicedeskNotificationsInternalNotificationsRoute).name:
        case (0, $3BQ4q.projectSettingsServicedeskNotificationsCustomerNotificationsRoute).name:
        case (0, $9ujoJ.projectSettingsServicedeskNotificationsEmailRoute).name:
        case (0, $buwAo.projectSettingsServicedeskNotificationsNotificationEmailRoute).name:
        case (0, $h6YNW.projectSettingsServicedeskInternalNotificationsNextGenRoute).name:
            path.push((0, $jhS4y.MENU_ID_SD_SETTINGS_NOTIFICATIONS));
            break;
        // Apps
        case (0, $4P4Lq.projectSettingsServicedeskClassicAppsRoute).name:
        case (0, $g49yz.projectSettingsServicedeskAppsFieldsRoute).name:
            // ADD rest of the apps here
            path.push((0, $jhS4y.MENU_ID_SD_SETTINGS_APPS));
            break;
        default:
            break;
    }
    return path;
}
const $59806d8088c642c3$export$dd307ede503fe0e = {
    routes: $59806d8088c642c3$var$routes,
    convert: $59806d8088c642c3$var$convert,
    convertNew: $59806d8088c642c3$var$convertNew
};

});
parcelRegister("7HDop", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationRoute", () => $a850596cfe5a4de7$export$1a2228d5e07202a0);
const $a850596cfe5a4de7$export$1a2228d5e07202a0 = {
    name: 'project-settings-automation',
    path: '/jira/servicedesk/projects/:projectKey/settings/automate'
};

});

parcelRegister("9ujoJ", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsEmailRoute", () => $0bae5d3040b6efcd$export$1f37a1aff4f594af);
const $0bae5d3040b6efcd$export$1f37a1aff4f594af = {
    name: 'project-settings-servicedesk-notification-email',
    path: '/jira/servicedesk/projects/:projectKey/settings/notification-email',
    exact: true
};

});

parcelRegister("buwAo", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsNotificationEmailRoute", () => $a41537dc6d61dc3d$export$40539cb16771014e);
const $a41537dc6d61dc3d$export$40539cb16771014e = {
    name: 'project-settings-servicedesk-notifications-notification-email',
    path: '/jira/servicedesk/projects/:projectKey/settings/notifications/notification-email',
    exact: true
};

});

parcelRegister("ji59e", function(module, exports) {

$parcel$export(module.exports, "projectSettingsLegacyAutomationRoute", () => $8a393a176348cc6a$export$5f0797185fc4e6fe);
const $8a393a176348cc6a$export$5f0797185fc4e6fe = {
    name: 'project-settings-servicedesk-automation',
    path: '/jira/servicedesk/projects/:projectKey/settings/automation',
    exact: true
};

});

parcelRegister("cAtSX", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAccessRoute", () => $6b0529072d4abe8e$export$6473a81f1ee460ef);
const $6b0529072d4abe8e$export$6473a81f1ee460ef = {
    name: 'project-settings-servicedesk-access',
    path: '/jira/servicedesk/projects/:projectKey/settings/access',
    exact: true
};

});

parcelRegister("g49yz", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAppsFieldsRoute", () => $3fe31df45b0dec62$export$bb46672b3fb14eec);
const $3fe31df45b0dec62$export$bb46672b3fb14eec = {
    name: 'project-settings-servicedesk-apps-fields',
    path: '/jira/servicedesk/projects/:projectKey/settings/apps/app-fields',
    exact: true
};

});

parcelRegister("aBfqj", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChangeManagementRoute", () => $f0657cd63f2eea62$export$1444ee3eb63a2ffc);
const $f0657cd63f2eea62$export$1444ee3eb63a2ffc = {
    name: 'project-settings-servicedesk-change-management',
    path: '/jira/servicedesk/projects/:projectKey/settings/change-management',
    exact: true
};

});

parcelRegister("9wUes", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsChatRoute", () => $6368b0346b5f497d$export$be5ad475040cd044);
const $6368b0346b5f497d$export$be5ad475040cd044 = {
    name: 'project-settings-servicedesk-channels-chat',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/chat',
    exact: true
};

});

parcelRegister("8pE1n", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsPermissionsNextGenRoute", () => $7daacba204902bb9$export$5fb39a9d3820886c);
const $7daacba204902bb9$export$5fb39a9d3820886c = {
    name: 'project-settings-servicedesk-channels-permissions-next-gen',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/customer-permissions',
    exact: true
};

});

parcelRegister("cfj3a", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsPortalRoute", () => $6736aa15bea6eefc$export$8f4234e4e79e03);
const $6736aa15bea6eefc$export$8f4234e4e79e03 = {
    name: 'project-settings-servicedesk-channels-portal',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/portal-settings',
    exact: true
};

});

parcelRegister("d9ukL", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsWidgetRoute", () => $1c3cc396f5e3294d$export$c66db54872d3b51c);
const $1c3cc396f5e3294d$export$c66db54872d3b51c = {
    name: 'project-settings-servicedesk-channels-widget',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/widget',
    exact: true
};

});

parcelRegister("2I1zE", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChatRoute", () => $2f07a87a169fe062$export$b22ac188582d1dbd);
const $2f07a87a169fe062$export$b22ac188582d1dbd = {
    name: 'project-settings-servicedesk-chat',
    path: '/jira/servicedesk/projects/:projectKey/settings/chat',
    exact: true
};

});

parcelRegister("4P4Lq", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskClassicAppsRoute", () => $e517d51ddd605d2d$export$2b65324bb87228c5);
const $e517d51ddd605d2d$export$2b65324bb87228c5 = {
    name: 'project-settings-servicedesk-classic-apps',
    path: '/jira/servicedesk/projects/:projectKey/settings/apps',
    exact: true
};

});

parcelRegister("fdCkK", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskCustomerPermissionsRoute", () => $b0729515e1c8c770$export$d8ed4a1eb0c01b5a);
const $b0729515e1c8c770$export$d8ed4a1eb0c01b5a = {
    name: 'project-settings-servicedesk-customer-permissions',
    path: '/jira/servicedesk/projects/:projectKey/settings/customer-permissions',
    exact: true
};

});

parcelRegister("i62iX", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskEmailRoute", () => $6c48c7782385d153$export$d7d111417bfcd900);
const $6c48c7782385d153$export$d7d111417bfcd900 = {
    name: 'project-settings-servicedesk-email',
    path: '/jira/servicedesk/projects/:projectKey/settings/email',
    exact: true
};

});

parcelRegister("eObGp", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskExternalLinksRoute", () => $9ab5fd15e07cb29b$export$2ec1a0d49a1f6ac2);
const $9ab5fd15e07cb29b$export$2ec1a0d49a1f6ac2 = {
    name: 'project-settings-servicedesk-external-links',
    path: '/jira/servicedesk/projects/:projectKey/settings/external-links',
    exact: true
};

});

parcelRegister("6z8e6", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskFeedbackRoute", () => $a459da1dd0fd4437$export$f21485e31d7839aa);
const $a459da1dd0fd4437$export$f21485e31d7839aa = {
    name: 'project-settings-servicedesk-feedback',
    path: '/jira/servicedesk/projects/:projectKey/settings/feedback-settings'
};

});

parcelRegister("coidL", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskFieldsRoute", () => $60fa813ddf92723e$export$44f665a50373c681);
const $60fa813ddf92723e$export$44f665a50373c681 = {
    name: 'project-settings-servicedesk-fields',
    path: '/jira/servicedesk/projects/:projectKey/settings/fields',
    exact: true
};

});

parcelRegister("jHXos", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskIncidentManagementRoute", () => $5158d983285fb183$export$f91bd0bb0d4783ff);
const $5158d983285fb183$export$f91bd0bb0d4783ff = {
    name: 'project-settings-servicedesk-incident-management',
    path: '/jira/servicedesk/projects/:projectKey/settings/incident-management',
    exact: true
};

});

parcelRegister("h6YNW", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskInternalNotificationsNextGenRoute", () => $35c040ff370a690c$export$5db62792327950b4);
const $35c040ff370a690c$export$5db62792327950b4 = {
    name: 'project-settings-servicedesk-internal-notifications-nextGen',
    path: '/jira/servicedesk/projects/:projectKey/settings/internal-notifications'
};

});

parcelRegister("6EgCy", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskIssuetypesRoute", () => $62f1cfaa37e848ed$export$2ffcb2e92bb4950b);
const $62f1cfaa37e848ed$export$2ffcb2e92bb4950b = {
    name: 'project-settings-servicedesk-issuetypes',
    path: '/jira/servicedesk/projects/:projectKey/settings/issuetypes/:issueTypeId?',
    exact: true
};

});

parcelRegister("2CYtL", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsInternalNotificationsRoute", () => $944b1aaf3a971594$export$5108e41f558ecf03);
const $944b1aaf3a971594$export$5108e41f558ecf03 = {
    name: 'project-settings-servicedesk-notifications-internal-notifications',
    path: '/jira/servicedesk/projects/:projectKey/settings/notifications/internal-notifications'
};

});

parcelRegister("bveQD", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskPortalSettingsRoute", () => $110f0f2897157711$export$7593a7e4a6fc0aaf);
const $110f0f2897157711$export$7593a7e4a6fc0aaf = {
    name: 'project-settings-servicedesk-portal-settings',
    path: '/jira/servicedesk/projects/:projectKey/settings/portal-settings/:subPath(portal-groups)?',
    exact: true
};

});

parcelRegister("59iBR", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskProformaProjectFormsRoute", () => $7ab6606893b01740$export$ee87e5f9754e3600);
const $7ab6606893b01740$export$ee87e5f9754e3600 = {
    name: 'project-settings-servicedesk-proforma-project-forms',
    path: '/jira/servicedesk/projects/:projectKey/settings/forms',
    exact: true
};

});

parcelRegister("b7dWt", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskRequestTypesWorkCategoryRoute", () => $5256905c61d3ff71$export$a0d1982e8b6c6462);
const $5256905c61d3ff71$export$a0d1982e8b6c6462 = {
    name: 'project-settings-servicedesk-request-types-work-category',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types/category/:practice',
    exact: true
};

});

parcelRegister("8qmAq", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskWidgetRoute", () => $bf2d8be8b98d574c$export$ac674ffd39608325);
const $bf2d8be8b98d574c$export$ac674ffd39608325 = {
    name: 'project-settings-servicedesk-widget',
    path: '/jira/servicedesk/projects/:projectKey/settings/widget',
    exact: true
};

});

parcelRegister("fQ161", function(module, exports) {

$parcel$export(module.exports, "projectSettingsVirtualAgentSettingsRoute", () => $6114f059a1e6649c$export$22dd8d5d0c04aa51);
const $6114f059a1e6649c$export$22dd8d5d0c04aa51 = {
    name: 'project-settings-servicedesk-virtual-agent',
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent',
    exact: true
};

});

parcelRegister("9sAYT", function(module, exports) {

$parcel$export(module.exports, "virtualAgentConversationsRoute", () => $411142b46ae04f14$export$837f003bb6f40f9);
const $411142b46ae04f14$export$837f003bb6f40f9 = {
    name: 'project-settings-servicedesk-virtual-agent-conversations',
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/conversations',
    exact: true
};

});

parcelRegister("jJkuR", function(module, exports) {

$parcel$export(module.exports, "virtualAgentIntentsRoute", () => $0338de7d8107d11d$export$1e70273fc2a407f5);
const $0338de7d8107d11d$export$1e70273fc2a407f5 = {
    name: 'project-settings-servicedesk-virtual-agent-intents',
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/intents',
    exact: true
};

});

parcelRegister("kuaoc", function(module, exports) {

$parcel$export(module.exports, "virtualAgentSettingsRoute", () => $bc551cda135ca5dc$export$80422a49e17dfd6b);
const $bc551cda135ca5dc$export$80422a49e17dfd6b = {
    name: 'project-settings-servicedesk-virtual-agent-settings',
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/settings',
    exact: true
};

});

parcelRegister("ieCBx", function(module, exports) {

$parcel$export(module.exports, "virtualAgentStandardFlowsRoute", () => $b2e651b968a46995$export$f45c942ecfcc5682);
const $b2e651b968a46995$export$f45c942ecfcc5682 = {
    name: 'project-settings-servicedesk-virtual-agent-standard-flows',
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/standard-flows',
    exact: true
};

});

parcelRegister("iXFkh", function(module, exports) {

$parcel$export(module.exports, "landingPageRoute", () => $f5084469ecd7a21e$export$8c051c399fd812a5);
const $f5084469ecd7a21e$export$8c051c399fd812a5 = {
    // We name this virtualagentonboarding without the "-" as otherwise it would trigger
    // the nesting stack, which we don't want for onboarding
    name: 'project-settings-servicedesk-virtualagentonboarding',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent'
};

});

parcelRegister("gvZrS", function(module, exports) {

$parcel$export(module.exports, "browseConversationsRoute", () => $3541a643aa509b4d$export$c8ff4cf64e5540ec);
const $3541a643aa509b4d$export$c8ff4cf64e5540ec = {
    name: 'project-settings-servicedesk-virtualagent-browseconversations',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/conversations'
};

});

parcelRegister("6oHoX", function(module, exports) {

$parcel$export(module.exports, "browseIntentsRoute", () => $2004c35d63b7590d$export$3e227412713bc57f);
const $2004c35d63b7590d$export$3e227412713bc57f = {
    name: 'project-settings-servicedesk-virtualagent-browse-intents',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/intents'
};

});

parcelRegister("1r8X1", function(module, exports) {

$parcel$export(module.exports, "browseStandardFlowsRoute", () => $929ca13d8a48533c$export$fd091ba8fa858397);
const $929ca13d8a48533c$export$fd091ba8fa858397 = {
    name: 'project-settings-servicedesk-virtualagent-standard-flows',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/standard-flows'
};

});

parcelRegister("1XuFh", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskCustomerNotificationsRoute", () => $312a1d56c159c7b3$export$176d388c5b23978e);
const $312a1d56c159c7b3$export$176d388c5b23978e = {
    name: 'project-settings-servicedesk-customer-notifications',
    path: '/jira/servicedesk/projects/:projectKey/settings/customer-notifications'
};

});

parcelRegister("3BQ4q", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsCustomerNotificationsRoute", () => $767b3fa8d0e3f22f$export$6ce57d409e1934f2);
const $767b3fa8d0e3f22f$export$6ce57d409e1934f2 = {
    name: 'project-settings-servicedesk-notifications-customer-notifications',
    path: '/jira/servicedesk/projects/:projectKey/settings/notifications/customer-notifications'
};

});

parcelRegister("2m3cT", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskKbRoute", () => $4098af05e7cf1529$export$725fadff9ae82302);
const $4098af05e7cf1529$export$725fadff9ae82302 = {
    name: 'project-settings-servicedesk-kb',
    path: '/jira/servicedesk/projects/:projectKey/settings/confluence-kb',
    exact: true
};

});

parcelRegister("hewRX", function(module, exports) {

$parcel$export(module.exports, "servicedeskSlaSettingsRoute", () => $e50829694a27cbc2$export$bfbf66468910573e);
const $e50829694a27cbc2$export$bfbf66468910573e = {
    name: 'servicedesk-sla-settings',
    path: '/jira/servicedesk/projects/:projectKey/settings/sla/(custom|new)?/:id?/(edit)?'
};

});

parcelRegister("cmEH1", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskTicketTypesConfigRoute", () => $f379cc48bbcca18e$export$31f95ad4356ce017);
const $f379cc48bbcca18e$export$31f95ad4356ce017 = {
    exact: true,
    name: 'project-settings-servicedesk-ticket-types-config',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types'
};

});

parcelRegister("9xhY2", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskUnassignedTicketTypesConfigRoute", () => $5bf710cc844476bb$export$8c897f53ff36fa6b);
const $5bf710cc844476bb$export$8c897f53ff36fa6b = {
    exact: true,
    name: 'project-settings-servicedesk-unassigned-ticket-types-config',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types/unassigned'
};

});

parcelRegister("043ka", function(module, exports) {

$parcel$export(module.exports, "servicedeskWorkflowConfigRoute", () => $e90f1285b1062fcf$export$ecc771c0ee86ccb8);
const $e90f1285b1062fcf$export$ecc771c0ee86ccb8 = {
    name: 'project-settings-servicedesk-workflow-scheme-config',
    path: '/jira/servicedesk/projects/:projectKey/settings/workflows',
    exact: true
};

});


parcelRegister("djX45", function(module, exports) {

$parcel$export(module.exports, "customerServiceConverter", () => $5d3cd05ec71a5c6d$export$8e632ccd3e33c9f1);

var $4R6GH = parcelRequire("4R6GH");

var $jhS4y = parcelRequire("jhS4y");
const $5d3cd05ec71a5c6d$var$routes = new Set([
    'customer-service-helpcenter'
]);
function $5d3cd05ec71a5c6d$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [];
    return $5d3cd05ec71a5c6d$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $5d3cd05ec71a5c6d$var$convertNew(args) {
    const { routeName: routeName } = args;
    const path = [];
    return $5d3cd05ec71a5c6d$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $5d3cd05ec71a5c6d$var$convertRouteToPath(args) {
    const { routeName: routeName, path: path } = args;
    switch(routeName){
        case 'customer-service-helpcenter':
            path.push((0, $4R6GH.fg)('jcs_project_type_m3') ? (0, $jhS4y.MENU_ID_CUSTOMER_HUBS) : (0, $jhS4y.MENU_ID_CUSTOMER_SERVICE));
            break;
        default:
    }
    return path;
}
const $5d3cd05ec71a5c6d$export$8e632ccd3e33c9f1 = {
    routes: $5d3cd05ec71a5c6d$var$routes,
    convert: $5d3cd05ec71a5c6d$var$convert,
    convertNew: $5d3cd05ec71a5c6d$var$convertNew
};

});



parcelRegister("fMcVX", function(module, exports) {

$parcel$export(module.exports, "isSelectedPath", () => $ad785f9726254880$export$cdcd6885320eec31);

var $lhMtU = parcelRequire("lhMtU");
function $ad785f9726254880$export$cdcd6885320eec31(path, ...args) {
    const next = (menuId)=>{
        return (0, $lhMtU.isMenuIdList)(menuId) ? (0, $lhMtU.toMenuIdList)(menuId).some((id)=>path.includes(id)) : path.includes(menuId);
    };
    if (args.length === 0) return next;
    return next(args[0]);
}

});
parcelRegister("lhMtU", function(module, exports) {

$parcel$export(module.exports, "toMenuIdFromMenuIdList", () => $dc9d941dfadd4b5a$export$253323efd0c41e72);
$parcel$export(module.exports, "isMenuIdList", () => $dc9d941dfadd4b5a$export$abdb8aa7ce9ed1ed);
$parcel$export(module.exports, "toMenuIdList", () => $dc9d941dfadd4b5a$export$d8e017f58178e379);
const $dc9d941dfadd4b5a$var$MENU_ID_DELIM = '   '; // Three spaces
function $dc9d941dfadd4b5a$export$253323efd0c41e72(menuIds) {
    return menuIds.join($dc9d941dfadd4b5a$var$MENU_ID_DELIM);
}
function $dc9d941dfadd4b5a$export$abdb8aa7ce9ed1ed(maybeMenuIdList) {
    return maybeMenuIdList.indexOf($dc9d941dfadd4b5a$var$MENU_ID_DELIM) !== -1;
}
function $dc9d941dfadd4b5a$export$d8e017f58178e379(menuIdList) {
    return menuIdList.split($dc9d941dfadd4b5a$var$MENU_ID_DELIM);
}

});


parcelRegister("ao2h1", function(module, exports) {

$parcel$export(module.exports, "RELAY_RESOURCE_TYPE", () => $5f6ac21695ec30bb$export$c6c8c12c0f1d8e54);
$parcel$export(module.exports, "createRelayResource", () => $5f6ac21695ec30bb$export$1cc887c62079ea32);
$parcel$export(module.exports, "useRelayResource", () => $5f6ac21695ec30bb$export$42ca7b248c7aaee);

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");

var $x9xyg = parcelRequire("x9xyg");

var $5yJb9 = parcelRequire("5yJb9");

var $5a0Nh = parcelRequire("5a0Nh");

var $kipqU = parcelRequire("kipqU");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $5Wobd = parcelRequire("5Wobd");
const $5f6ac21695ec30bb$export$c6c8c12c0f1d8e54 = 'RELAY_RESOURCE_TYPE';
const $5f6ac21695ec30bb$var$getData = ({ routerContext: routerContext, customContext: customContext, type: type, getQuery: getQuery, captureErrors: captureErrors, captureTraceIds: captureTraceIds })=>{
    const measureName = `relay_resource_get_data:${type}`;
    const startMark = `relay_resource_get_data:${type}:start`;
    const endMark = `relay_resource_get_data:${type}:end`;
    (0, $x9xyg.setMark)(startMark);
    const { parameters: parameters, variables: variables, options: options } = getQuery(routerContext, customContext);
    // loadQuery returns not a Promise, but Observable.
    // Resource waits until query Observable is completed and returns a queryReference
    // later queryReference could be used by usePreloadedQuery
    const queryReference = (0, $x9xyg.measureFunc)(`relay_resource_load_query:${type}`, ()=>(0, $8Uumt.loadQuery)((0, $5yJb9.default)(), parameters, variables || {}, options));
    if (false && queryReference.id != null) {
        const promise = (0, $kipqU.QueryPromisesMap).get(queryReference.id);
        if (promise) return promise.then(()=>{
            (0, $x9xyg.setMark)(endMark);
            (0, $x9xyg.setMeasure)(measureName, startMark, endMark);
            /**
				 * We want to store HTTP codes from fetch response so that we can use it to report SLA correctly.
				 * (Unfortunately errors thrown by relay client validation doesn't include HTTP codes at the moment, so we have to store it ourselves)
				 * Starting to capture errors here ensures we capture errors for the early fetch of the query on initial page load,
				 * as well as subsequent fetches made by route transitions between spa-apps.
				 */ if (captureErrors) (0, $5a0Nh.startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
            if (captureTraceIds) (0, $5Wobd.startCapturingTraceIds)(queryReference.name);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return queryReference;
        });
    }
    if (queryReference.id != null) (0, $kipqU.QueryPromisesMap).get(queryReference.id)?.then(()=>{
        (0, $x9xyg.setMark)(endMark);
        (0, $x9xyg.setMeasure)(measureName, startMark, endMark);
    });
    /**
	 * We want to store HTTP codes from fetch response so that we can use it to report SLA correctly.
	 * (Unfortunately errors thrown by relay client validation doesn't include HTTP codes at the moment, so we have to store it ourselves)
	 * Starting to capture errors here ensures we capture errors for the early fetch of the query on initial page load,
	 * as well as subsequent fetches made by route transitions between spa-apps.
	 */ if (captureErrors) (0, $5a0Nh.startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
    if (captureTraceIds) (0, $5Wobd.startCapturingTraceIds)(queryReference.name);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return queryReference;
};
const $5f6ac21695ec30bb$var$createRelayResourceImpl = ({ type: type, isBrowserOnly: isBrowserOnly, getQuery: getQuery, captureErrors: captureErrors = false, captureTraceIds: captureTraceIds = false })=>(0, $2M1hQ.createResource)({
        type: `${$5f6ac21695ec30bb$export$c6c8c12c0f1d8e54}_${type}`,
        getKey: (routerContext, customContext)=>{
            const { parameters: preloadableRequest, variables: variables } = getQuery(routerContext, customContext);
            // When providing an async query via `loadParameters` instead of getQuery's config, the query ID is not known upfront and so cannot be contributed to the resource key
            if (!preloadableRequest) return JSON.stringify(variables || {});
            let queryId;
            let params;
            // sources: https://github.com/facebook/relay/blob/4b78c7dd27b286f9ee8f5b993ccb160163956999/packages/react-relay/relay-hooks/loadQuery.js#L273
            // @ts-expect-error - TS2339 - Property 'kind' does not exist on type 'GraphQLTaggedNode | PreloadableConcreteRequest<TQuery>'.
            if (preloadableRequest.kind === 'PreloadableConcreteRequest') {
                const preloadableConcreteRequest = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                preloadableRequest;
                ({ params: params } = preloadableConcreteRequest);
                ({ id: queryId } = params);
            } else {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                const graphQlTaggedNode = preloadableRequest;
                const request = (0, $eiowN.getRequest)(graphQlTaggedNode);
                params = request.params;
                queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
            }
            return `${String(queryId)}${JSON.stringify(variables || {})}`;
        },
        getData: (routerContext, customContext)=>{
            return $5f6ac21695ec30bb$var$getData({
                routerContext: routerContext,
                customContext: customContext,
                type: type,
                getQuery: getQuery,
                captureErrors: captureErrors,
                captureTraceIds: captureTraceIds
            });
        },
        maxAge: 0,
        isBrowserOnly: isBrowserOnly
    });
const $5f6ac21695ec30bb$export$1cc887c62079ea32 = $5f6ac21695ec30bb$var$createRelayResourceImpl;
const $5f6ac21695ec30bb$export$bbe949b85c06f763 = $5f6ac21695ec30bb$var$createRelayResourceImpl;
const $5f6ac21695ec30bb$export$42ca7b248c7aaee = (resource, options)=>{
    const { data: queryReference, loading: loading, promise: promise } = (0, $2YP9W.useResource)(resource);
    if (options?.suspendWhenLoading && loading) throw promise;
    return {
        queryReference: queryReference
    };
};

});

parcelRegister("2OeZv", function(module, exports) {

$parcel$export(module.exports, "default", () => $70949048397986dd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<453d237bcf42b8b66cea51c7e55142a2>>
 * @relayHash d2712ec3430165f5e1cb38a09c1a2ddb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9a8d8311023de0a673285a1a9e3345924dbaac1ae48657e565c2fdc7c447742a

var $apPdj = parcelRequire("apPdj");

var $bozkj = parcelRequire("bozkj");

var $2in5a = parcelRequire("2in5a");

var $57dih = parcelRequire("57dih");

var $kXP4b = parcelRequire("kXP4b");

var $cN96Q = parcelRequire("cN96Q");

var $95Z36 = parcelRequire("95Z36");

var $i2tXg = parcelRequire("i2tXg");

var $gDHWC = parcelRequire("gDHWC");
const $70949048397986dd$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriProjects"
    }, v2 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isAppsExpanded"
    }, v3 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isFiltersExpanded"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isOperationsExpanded"
    }, v5 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isOverviewsExpanded"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isPlansExpanded"
    }, v7 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isProjectsExpanded"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ownerAri"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v11 = [
        v10 /*: any*/ 
    ], v12 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v13 = {
        "kind": "ScalarField",
        "name": "label"
    }, v14 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v15 = {
        "kind": "ScalarField",
        "name": "url"
    }, v16 = {
        "order": "DESC"
    }, v17 = {
        "kind": "Literal",
        "name": "first",
        "value": 15
    }, v18 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v19 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v20 = {
        "kind": "ScalarField",
        "name": "status"
    }, v21 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v22 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "large"
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "name"
    }, v24 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v25 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v26 = [
        v15 /*: any*/ 
    ], v27 = {
        "kind": "InlineFragment",
        "selections": [
            v9 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v28 = {
        "kind": "LinkedField",
        "name": "defaultNavigationItem",
        "plural": false,
        "selections": [
            v12 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": v26 /*: any*/ ,
                "type": "JiraNavigationItem",
                "abstractKey": "__isJiraNavigationItem"
            },
            v27 /*: any*/ 
        ]
    }, v29 = [
        {
            "kind": "Literal",
            "name": "type",
            "value": "EDIT_PROJECT_CONFIG"
        }
    ], v30 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ], v31 = {
        "alias": "editProjectConfig",
        "args": v29 /*: any*/ ,
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": v30 /*: any*/ ,
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v32 = {
        "args": v29 /*: any*/ ,
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": v30 /*: any*/ ,
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v33 = {
        "kind": "ScalarField",
        "name": "projectStyle"
    }, v34 = {
        "alias": "editPermission",
        "args": v29 /*: any*/ ,
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": v30 /*: any*/ ,
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v35 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v36 = {
        "kind": "ScalarField",
        "name": "softwareBoardCount"
    }, v37 = [
        v9 /*: any*/ ,
        v19 /*: any*/ ,
        v20 /*: any*/ ,
        v21 /*: any*/ ,
        v22 /*: any*/ ,
        v23 /*: any*/ ,
        v24 /*: any*/ ,
        v25 /*: any*/ ,
        v28 /*: any*/ ,
        v31 /*: any*/ ,
        v32 /*: any*/ ,
        v33 /*: any*/ ,
        v34 /*: any*/ ,
        v35 /*: any*/ ,
        v36 /*: any*/ 
    ], v38 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v39 = {
        "kind": "Literal",
        "name": "first",
        "value": 20
    }, v40 = {
        "concreteType": "JiraProjectEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": v37 /*: any*/ 
            }
        ]
    }, v41 = [
        v40 /*: any*/ ,
        v38 /*: any*/ 
    ], v42 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v43 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v44 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                    v12 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v9 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCustomFilter"
    }, v45 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v12 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v9 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "planId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isReadOnly"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "planStatus"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                v25 /*: any*/ ,
                                v9 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "JiraScenario",
                            "kind": "LinkedField",
                            "name": "scenario",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "scenarioId"
                                },
                                v9 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "defaultNavigationItem",
                                    "plural": false,
                                    "selections": [
                                        v12 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v26 /*: any*/ ,
                                            "type": "JiraSoftwareBuiltInNavigationItem"
                                        },
                                        v27 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ],
                    "type": "JiraPlan"
                },
                v27 /*: any*/ 
            ]
        }
    ], v46 = [
        v9 /*: any*/ ,
        v23 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "alertSearchQuery"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "L1MenuItemsQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ConfigurableMenuItems"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v1 /*: any*/ ,
                v8 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu7436separategrowthrecrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "L1MenuItemsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudID",
                                    "variableName": "cloudId"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "navKey",
                                    "value": "NAV_SIDEBAR"
                                }
                            ],
                            "concreteType": "JiraUserNavigationConfiguration",
                            "kind": "LinkedField",
                            "name": "userNavigationConfiguration",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraConfigurableNavigationItem",
                                    "kind": "LinkedField",
                                    "name": "navItems",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "menuId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isVisible"
                                        }
                                    ]
                                },
                                v9 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isProjectsExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "hasIsProjectsExpanded",
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        },
                        {
                            "alias": "canCreateProject",
                            "args": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "CREATE_PROJECT"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "canPerform"
                        },
                        {
                            "condition": "isFiltersExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "hasIsFiltersExpanded",
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        },
                        {
                            "condition": "isAppsExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "JiraNavigationItemConnection",
                                    "kind": "LinkedField",
                                    "name": "globalAppNavigationItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNavigationItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v13 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "appId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "appType"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "envLabel"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "iconUrl"
                                                                },
                                                                v14 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAppSection",
                                                                    "kind": "LinkedField",
                                                                    "name": "sections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v13 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraAppNavigationItemNestedLink",
                                                                            "kind": "LinkedField",
                                                                            "name": "links",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v13 /*: any*/ ,
                                                                                v15 /*: any*/ ,
                                                                                v14 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "settingsUrl"
                                                                },
                                                                v15 /*: any*/ 
                                                            ],
                                                            "type": "JiraAppNavigationItem"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v11 /*: any*/ ,
                            "concreteType": "JiraWorkManagementGiraOverviewConnection",
                            "kind": "LinkedField",
                            "name": "jwmOverviews",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "totalCount"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isPlansExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "hasIsPlansExpanded",
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        },
                        {
                            "args": v11 /*: any*/ ,
                            "concreteType": "JiraAdvancedRoadmapsNavigation",
                            "kind": "LinkedField",
                            "name": "advancedRoadmapsNavigation",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasEditPermissions"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasCreateSamplePlanPermissions"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasGlobalPlansAdminPermissions"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isProjectsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "JiraWorkManagementLicensing",
                                    "kind": "LinkedField",
                                    "name": "jwmLicensing",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "currentUserSeatEdition"
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "alias": "favouriteProjects",
                                            "args": [
                                                v10 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "filter",
                                                    "value": {
                                                        "sort": v16 /*: any*/ ,
                                                        "type": "PROJECT"
                                                    }
                                                },
                                                v17 /*: any*/ 
                                            ],
                                            "concreteType": "JiraFavouriteConnection",
                                            "kind": "LinkedField",
                                            "name": "favourites",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraFavouriteEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v12 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v37 /*: any*/ ,
                                                                    "type": "JiraProject"
                                                                },
                                                                v27 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v38 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": [
                                                v10 /*: any*/ ,
                                                v39 /*: any*/ 
                                            ],
                                            "concreteType": "JiraProjectConnection",
                                            "kind": "LinkedField",
                                            "name": "recentProjects",
                                            "plural": false,
                                            "selections": v41 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu7436separategrowthrecrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "GrowthRecQuery",
                                            "kind": "LinkedField",
                                            "name": "growthRecommendations",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": [
                                                        {
                                                            "fields": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "product",
                                                                    "value": "jira"
                                                                },
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "tenantId",
                                                                    "variableName": "cloudId"
                                                                },
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "useCase",
                                                                    "value": "jiraProjectMenuRecommendations"
                                                                }
                                                            ],
                                                            "kind": "ObjectValue",
                                                            "name": "context"
                                                        },
                                                        {
                                                            "kind": "Literal",
                                                            "name": "first",
                                                            "value": 2
                                                        }
                                                    ],
                                                    "kind": "LinkedField",
                                                    "name": "recommendations",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v12 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "entityId"
                                                                                }
                                                                            ],
                                                                            "type": "GrowthRecJiraTemplateRecommendation"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "GrowthRecRecommendations"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "entityAri",
                                                    "variableName": "entityAriProjects"
                                                },
                                                {
                                                    "kind": "Variable",
                                                    "name": "ownerAri",
                                                    "variableName": "ownerAri"
                                                }
                                            ],
                                            "concreteType": "SettingsNavigationCustomisation",
                                            "kind": "LinkedField",
                                            "name": "settings_navigationCustomisation",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "SettingsDisplayPropertyConnection",
                                                    "kind": "LinkedField",
                                                    "name": "properties",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "SettingsDisplayProperty",
                                                            "kind": "LinkedField",
                                                            "name": "nodes",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "key"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "JiraProjectsSidebarMenu",
                                    "kind": "LinkedField",
                                    "name": "jira_projectsSidebarMenu",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "mostRecent",
                                            "plural": false,
                                            "selections": v37 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "mostRecentFromHistory",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                v25 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                v22 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                v24 /*: any*/ ,
                                                v28 /*: any*/ ,
                                                v31 /*: any*/ ,
                                                v32 /*: any*/ ,
                                                v33 /*: any*/ ,
                                                v34 /*: any*/ ,
                                                v35 /*: any*/ ,
                                                v36 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": [
                                                v17 /*: any*/ 
                                            ],
                                            "concreteType": "JiraProjectConnection",
                                            "kind": "LinkedField",
                                            "name": "favourites",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                v40 /*: any*/ ,
                                                v38 /*: any*/ 
                                            ],
                                            "storageKey": "favourites(first:15)"
                                        },
                                        {
                                            "args": [
                                                v39 /*: any*/ 
                                            ],
                                            "concreteType": "JiraProjectConnection",
                                            "kind": "LinkedField",
                                            "name": "recents",
                                            "plural": false,
                                            "selections": v41 /*: any*/ ,
                                            "storageKey": "recents(first:20)"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasMore"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "favouriteLimit"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "recentLimit"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "displayMode"
                                        },
                                        v9 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isFiltersExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "favouriteFilters",
                                    "args": [
                                        v10 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": v16 /*: any*/ ,
                                                "type": "FILTER"
                                            }
                                        },
                                        v17 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v18 /*: any*/ ,
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v42 /*: any*/ ,
                                                                v23 /*: any*/ ,
                                                                v9 /*: any*/ ,
                                                                v25 /*: any*/ ,
                                                                v43 /*: any*/ ,
                                                                v44 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        },
                                                        v27 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v38 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "recentFilters",
                                    "args": [
                                        v10 /*: any*/ ,
                                        v39 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "FILTER"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v42 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v23 /*: any*/ ,
                                                                        v9 /*: any*/ ,
                                                                        v25 /*: any*/ ,
                                                                        v43 /*: any*/ ,
                                                                        v44 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraFilter",
                                                                    "abstractKey": "__isJiraFilter"
                                                                }
                                                            ],
                                                            "type": "JiraCustomFilter"
                                                        },
                                                        v27 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v38 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "JiraSystemFilterConnection",
                                    "kind": "LinkedField",
                                    "name": "systemFilters",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSystemFilterEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSystemFilter",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v42 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v23 /*: any*/ ,
                                                                v12 /*: any*/ ,
                                                                v25 /*: any*/ ,
                                                                v43 /*: any*/ ,
                                                                v44 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isPlansExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "favouritePlans",
                                    "args": [
                                        v10 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": v16 /*: any*/ ,
                                                "type": "PLAN"
                                            }
                                        },
                                        v17 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v45 /*: any*/ 
                                        },
                                        v38 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "recentPlans",
                                    "args": [
                                        v10 /*: any*/ ,
                                        v39 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "PLAN"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v45 /*: any*/ 
                                        },
                                        v38 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isOperationsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "OpsgenieQuery",
                            "kind": "LinkedField",
                            "name": "opsgenie",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "OpsgenieSavedSearches",
                                    "kind": "LinkedField",
                                    "name": "savedSearches",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "sharedWithMe",
                                            "plural": true,
                                            "selections": v46 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "createdByMe",
                                            "plural": true,
                                            "selections": v46 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isOverviewsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "JiraWorkManagementGiraOverviewConnection",
                                    "kind": "LinkedField",
                                    "name": "jwmOverviews",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraWorkManagementGiraOverviewEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraWorkManagementGiraOverview",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v23 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9a8d8311023de0a673285a1a9e3345924dbaac1ae48657e565c2fdc7c447742a",
            "metadata": {},
            "name": "L1MenuItemsQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider": (0, $apPdj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider": (0, $bozkj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider": (0, $gDHWC.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu7436separategrowthrecrelayprovider": (0, $2in5a.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider": (0, $57dih.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider": (0, $kXP4b.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": (0, $cN96Q.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider": (0, $i2tXg.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider": (0, $95Z36.default)
            }
        }
    };
}();
$70949048397986dd$var$node.hash = "2c0d42ef2bd0d870f4c048210d79296f";
var $70949048397986dd$export$2e2bcd8739ae039 = $70949048397986dd$var$node;

});
parcelRegister("apPdj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3cb5e5a280f36f0$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");
var $e3cb5e5a280f36f0$export$2e2bcd8739ae039 = {
    get () {
        return (0, $6s1PB.expVal)('blu-6315-display-settings-a-part-1', 'isEnabled', false);
    }
};

});

parcelRegister("bozkj", function(module, exports) {

$parcel$export(module.exports, "default", () => $45ae0acd0b32b8d9$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");
var $45ae0acd0b32b8d9$export$2e2bcd8739ae039 = {
    get () {
        return (0, $6s1PB.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false);
    }
};

});

parcelRegister("2in5a", function(module, exports) {

$parcel$export(module.exports, "default", () => $2669c68569279684$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $2669c68569279684$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('blu-7436-separate-growth-rec');
    }
};

});

parcelRegister("57dih", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd89b8ac04e69345$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $fd89b8ac04e69345$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('blu-3929-sidebar-menu-recommended');
    }
};

});

parcelRegister("kXP4b", function(module, exports) {

$parcel$export(module.exports, "default", () => $78c7049d0eb61e95$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $78c7049d0eb61e95$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jcs_project_type_m3');
    }
};

});

parcelRegister("cN96Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $832303d9c03ac1c0$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $832303d9c03ac1c0$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jsm_aiiy_for_nav_item_sidebar');
    }
};

});

parcelRegister("95Z36", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0e06dd4ba5c9950$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $f0e06dd4ba5c9950$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('migrate_plans_navigation_to_relay');
    }
};

});

parcelRegister("i2tXg", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e03361a011c2812$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $1e03361a011c2812$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('project-actions-sync-iv-llc');
    }
};

});

parcelRegister("gDHWC", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1b1dfadfffc61a2$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");
var $d1b1dfadfffc61a2$export$2e2bcd8739ae039 = {
    get () {
        return (0, $6s1PB.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false) || (0, $6s1PB.expVal)('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false);
    }
};

});


parcelRegister("fZBia", function(module, exports) {

$parcel$export(module.exports, "default", () => $79c8513a288fea00$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5115ff33a71779ea2998875f4e37eb58>>
 * @relayHash 2166d8d37d2e3ef4bf77f06d60ad7574
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b9bc3c19d8a70692e667edf5f8ab33de07cbacfb0efd83cfedbe8b4e1690d6c3
const $79c8513a288fea00$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "isLeftSidebarCollapsed"
    }, v3 = {
        "kind": "ScalarField",
        "name": "leftSidebarWidth"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "sidebarSelectorQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraNavigationUIStateUserProperty",
                            "kind": "LinkedField",
                            "name": "navigationUIState",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "sidebarSelectorQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraNavigationUIStateUserProperty",
                            "kind": "LinkedField",
                            "name": "navigationUIState",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b9bc3c19d8a70692e667edf5f8ab33de07cbacfb0efd83cfedbe8b4e1690d6c3",
            "metadata": {},
            "name": "sidebarSelectorQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$79c8513a288fea00$var$node.hash = "87261aab5010f6e217d4869107282805";
var $79c8513a288fea00$export$2e2bcd8739ae039 = $79c8513a288fea00$var$node;

});

parcelRegister("gdtac", function(module, exports) {

$parcel$export(module.exports, "JiraNavigationSettingsAri", () => $bce47b7f048991b3$export$d53f27b41a9a02bb);

var $jkf7e = parcelRequire("jkf7e");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/navigation-settings/manifest.ts
var $bce47b7f048991b3$var$jiraNavigationSettingsAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $jkf7e.JiraNavigationSettingsAriResourceOwner),
    resourceType: (0, $jkf7e.JiraNavigationSettingsAriResourceType),
    resourceIdSlug: "activation/{activationId}/{navigationSettingScope}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        navigationSettingScope: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/navigation-settings/index.ts
var $bce47b7f048991b3$export$d53f27b41a9a02bb = class _JiraNavigationSettingsAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._navigationSettingScope = opts.resourceIdSegmentValues.navigationSettingScope;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get navigationSettingScope() {
        return this._navigationSettingScope;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $bce47b7f048991b3$var$jiraNavigationSettingsAriStaticOpts.qualifier,
            platformQualifier: $bce47b7f048991b3$var$jiraNavigationSettingsAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $bce47b7f048991b3$var$jiraNavigationSettingsAriStaticOpts.resourceOwner,
            resourceType: $bce47b7f048991b3$var$jiraNavigationSettingsAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.navigationSettingScope}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                navigationSettingScope: opts.navigationSettingScope
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $bce47b7f048991b3$var$jiraNavigationSettingsAriStaticOpts);
        return new _JiraNavigationSettingsAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $bce47b7f048991b3$var$jiraNavigationSettingsAriStaticOpts);
        return new _JiraNavigationSettingsAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            navigationSettingScope: this.navigationSettingScope
        };
    }
};

});
parcelRegister("jkf7e", function(module, exports) {

$parcel$export(module.exports, "JiraNavigationSettingsAriResourceOwner", () => $e11b9c3acd7c102a$export$a71eb7f052c3a8f1);
$parcel$export(module.exports, "JiraNavigationSettingsAriResourceType", () => $e11b9c3acd7c102a$export$8c9eb6c30d1db6dc);
// src/jira/navigation-settings/types.ts
var $e11b9c3acd7c102a$export$a71eb7f052c3a8f1 = "jira", $e11b9c3acd7c102a$export$8c9eb6c30d1db6dc = "navigation-settings";

});


parcelRegister("95KxO", function(module, exports) {

$parcel$export(module.exports, "IdentityUserAri", () => $69e8af67517f3cce$export$1e9d09c2be53e55e);

var $agYNt = parcelRequire("agYNt");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/identity/user/manifest.ts
var $69e8af67517f3cce$var$identityUserAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $agYNt.IdentityUserAriResourceOwner),
    resourceType: (0, $agYNt.IdentityUserAriResourceType),
    resourceIdSlug: "{userId}",
    resourceIdSegmentFormats: {
        userId: /[a-zA-Z0-9_\-\:]{1,128}/
    }
};
// src/identity/user/index.ts
var $69e8af67517f3cce$export$1e9d09c2be53e55e = class _IdentityUserAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._userId = opts.resourceIdSegmentValues.userId;
    }
    get userId() {
        return this._userId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $69e8af67517f3cce$var$identityUserAriStaticOpts.qualifier,
            platformQualifier: $69e8af67517f3cce$var$identityUserAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $69e8af67517f3cce$var$identityUserAriStaticOpts.resourceOwner,
            resourceType: $69e8af67517f3cce$var$identityUserAriStaticOpts.resourceType,
            resourceId: `${opts.userId}`,
            resourceIdSegmentValues: {
                userId: opts.userId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $69e8af67517f3cce$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $69e8af67517f3cce$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(opts);
    }
    getVariables() {
        return {
            userId: this.userId
        };
    }
};

});
parcelRegister("agYNt", function(module, exports) {

$parcel$export(module.exports, "IdentityUserAriResourceOwner", () => $77aa8f07d2cc15ee$export$b4c14c54282a779d);
$parcel$export(module.exports, "IdentityUserAriResourceType", () => $77aa8f07d2cc15ee$export$e9b50e20f4fbfb71);
// src/identity/user/types.ts
var $77aa8f07d2cc15ee$export$b4c14c54282a779d = "identity", $77aa8f07d2cc15ee$export$e9b50e20f4fbfb71 = "user";

});



parcelRegister("gEccW", function(module, exports) {

$parcel$export(module.exports, "navPlatformSidebarResource", () => $8623711c8c97c510$export$b22e51bad3fbae1b);

var $jhS4y = parcelRequire("jhS4y");

var $3Jbkp = parcelRequire("3Jbkp");

var $fMcVX = parcelRequire("fMcVX");

var $ao2h1 = parcelRequire("ao2h1");

var $gdtac = parcelRequire("gdtac");

var $95KxO = parcelRequire("95KxO");

var $81zXP = parcelRequire("81zXP");

var $iWisO = parcelRequire("iWisO");
const $8623711c8c97c510$var$RESOURCE_TYPE_SIDEBAR_NAV_PLATFORM = 'RESOURCE_TYPE_SIDEBAR_NAV_PLATFORM';
const $8623711c8c97c510$export$b22e51bad3fbae1b = (0, $ao2h1.createRelayResource)({
    type: $8623711c8c97c510$var$RESOURCE_TYPE_SIDEBAR_NAV_PLATFORM,
    getQuery: (routerContext, { tenantContext: { cloudId: cloudId, activationId: activationId, atlassianAccountId: atlassianAccountId } })=>{
        const initialSelectedPath = (0, $3Jbkp.getInitialSelectedPath)(routerContext);
        return {
            parameters: (0, $iWisO.default),
            variables: {
                cloudId: cloudId,
                entityAriUserSideNavSettings: (0, $81zXP.JiraWorkspaceAri).create({
                    siteId: cloudId,
                    activationId: activationId
                }).toString(),
                isAppsExpanded: (0, $fMcVX.isSelectedPath)(initialSelectedPath, (0, $jhS4y.MENU_ID_APPS)),
                isFiltersExpanded: (0, $fMcVX.isSelectedPath)(initialSelectedPath, (0, $jhS4y.MENU_ID_FILTERS)),
                isPlansExpanded: (0, $fMcVX.isSelectedPath)(initialSelectedPath, (0, $jhS4y.MENU_ID_PLANS)),
                isProjectsExpanded: (0, $fMcVX.isSelectedPath)(initialSelectedPath, (0, $jhS4y.MENU_ID_PROJECTS)),
                isOperationsExpanded: (0, $fMcVX.isSelectedPath)(initialSelectedPath, (0, $jhS4y.MENU_ID_OPERATIONS)),
                isOverviewsExpanded: (0, $fMcVX.isSelectedPath)(initialSelectedPath, (0, $jhS4y.MENU_ID_OVERVIEWS)),
                entityAriProjects: (0, $gdtac.JiraNavigationSettingsAri).create({
                    siteId: cloudId,
                    activationId: activationId,
                    navigationSettingScope: 'projects'
                }).toString(),
                ownerAri: atlassianAccountId && (0, $95KxO.IdentityUserAri).create({
                    userId: atlassianAccountId
                }).toString()
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    }
});

});
parcelRegister("81zXP", function(module, exports) {

$parcel$export(module.exports, "JiraWorkspaceAri", () => $5d7a507154b2c7d6$export$d4d0794234e3fd53);

var $b1EkX = parcelRequire("b1EkX");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/workspace/manifest.ts
var $5d7a507154b2c7d6$var$jiraWorkspaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $b1EkX.JiraWorkspaceAriResourceOwner),
    resourceType: (0, $b1EkX.JiraWorkspaceAriResourceType),
    resourceIdSlug: "{activationId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/
    }
};
// src/jira/workspace/index.ts
var $5d7a507154b2c7d6$export$d4d0794234e3fd53 = class _JiraWorkspaceAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $5d7a507154b2c7d6$var$jiraWorkspaceAriStaticOpts.qualifier,
            platformQualifier: $5d7a507154b2c7d6$var$jiraWorkspaceAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $5d7a507154b2c7d6$var$jiraWorkspaceAriStaticOpts.resourceOwner,
            resourceType: $5d7a507154b2c7d6$var$jiraWorkspaceAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $5d7a507154b2c7d6$var$jiraWorkspaceAriStaticOpts);
        return new _JiraWorkspaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $5d7a507154b2c7d6$var$jiraWorkspaceAriStaticOpts);
        return new _JiraWorkspaceAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId
        };
    }
};

});
parcelRegister("b1EkX", function(module, exports) {

$parcel$export(module.exports, "JiraWorkspaceAriResourceOwner", () => $806f13cc47cff352$export$e52ccdf6abac8896);
$parcel$export(module.exports, "JiraWorkspaceAriResourceType", () => $806f13cc47cff352$export$669cd5f7b3746bb);
// src/jira/workspace/types.ts
var $806f13cc47cff352$export$e52ccdf6abac8896 = "jira", $806f13cc47cff352$export$669cd5f7b3746bb = "workspace";

});


parcelRegister("iWisO", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d34f0b14b459b38$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<484d755674c6a8b91ab2514d3b2a8773>>
 * @relayHash 8eae3e48f1146f5dd14aa84ccb662ec0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 37a3700feae5021ad4db10d3ae0688bb429dd59a5f2197617725b32258b14034

var $apPdj = parcelRequire("apPdj");

var $bozkj = parcelRequire("bozkj");

var $2in5a = parcelRequire("2in5a");

var $57dih = parcelRequire("57dih");

var $kXP4b = parcelRequire("kXP4b");

var $cN96Q = parcelRequire("cN96Q");

var $95Z36 = parcelRequire("95Z36");

var $i2tXg = parcelRequire("i2tXg");

var $gDHWC = parcelRequire("gDHWC");
const $6d34f0b14b459b38$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriProjects"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriUserSideNavSettings"
    }, v3 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isAppsExpanded"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isFiltersExpanded"
    }, v5 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isOperationsExpanded"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isOverviewsExpanded"
    }, v7 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isPlansExpanded"
    }, v8 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isProjectsExpanded"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ownerAri"
    }, v10 = {
        "kind": "Variable",
        "name": "ownerAri",
        "variableName": "ownerAri"
    }, v11 = {
        "concreteType": "SettingsDisplayPropertyConnection",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "SettingsDisplayProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "id"
    }, v13 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v14 = [
        v13 /*: any*/ 
    ], v15 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v16 = {
        "kind": "ScalarField",
        "name": "label"
    }, v17 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v18 = {
        "kind": "ScalarField",
        "name": "url"
    }, v19 = {
        "order": "DESC"
    }, v20 = {
        "kind": "Literal",
        "name": "first",
        "value": 15
    }, v21 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v23 = {
        "kind": "ScalarField",
        "name": "name"
    }, v24 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v25 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                    v15 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v12 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCustomFilter"
    }, v27 = {
        "kind": "InlineFragment",
        "selections": [
            v12 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v28 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v29 = {
        "kind": "Literal",
        "name": "first",
        "value": 20
    }, v30 = [
        v12 /*: any*/ ,
        v23 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "alertSearchQuery"
        }
    ], v31 = [
        v18 /*: any*/ 
    ], v32 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v15 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v12 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "planId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isReadOnly"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "planStatus"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                v24 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "JiraScenario",
                            "kind": "LinkedField",
                            "name": "scenario",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "scenarioId"
                                },
                                v12 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "defaultNavigationItem",
                                    "plural": false,
                                    "selections": [
                                        v15 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v31 /*: any*/ ,
                                            "type": "JiraSoftwareBuiltInNavigationItem"
                                        },
                                        v27 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ],
                    "type": "JiraPlan"
                },
                v27 /*: any*/ 
            ]
        }
    ], v33 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v34 = {
        "kind": "ScalarField",
        "name": "status"
    }, v35 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v36 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "large"
            }
        ]
    }, v37 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v38 = {
        "kind": "LinkedField",
        "name": "defaultNavigationItem",
        "plural": false,
        "selections": [
            v15 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": v31 /*: any*/ ,
                "type": "JiraNavigationItem",
                "abstractKey": "__isJiraNavigationItem"
            },
            v27 /*: any*/ 
        ]
    }, v39 = [
        {
            "kind": "Literal",
            "name": "type",
            "value": "EDIT_PROJECT_CONFIG"
        }
    ], v40 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ], v41 = {
        "alias": "editProjectConfig",
        "args": v39 /*: any*/ ,
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": v40 /*: any*/ ,
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v42 = {
        "args": v39 /*: any*/ ,
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": v40 /*: any*/ ,
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v43 = {
        "kind": "ScalarField",
        "name": "projectStyle"
    }, v44 = {
        "alias": "editPermission",
        "args": v39 /*: any*/ ,
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": v40 /*: any*/ ,
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v45 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v46 = {
        "kind": "ScalarField",
        "name": "softwareBoardCount"
    }, v47 = [
        v12 /*: any*/ ,
        v33 /*: any*/ ,
        v34 /*: any*/ ,
        v35 /*: any*/ ,
        v36 /*: any*/ ,
        v23 /*: any*/ ,
        v37 /*: any*/ ,
        v24 /*: any*/ ,
        v38 /*: any*/ ,
        v41 /*: any*/ ,
        v42 /*: any*/ ,
        v43 /*: any*/ ,
        v44 /*: any*/ ,
        v45 /*: any*/ ,
        v46 /*: any*/ 
    ], v48 = {
        "concreteType": "JiraProjectEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": v47 /*: any*/ 
            }
        ]
    }, v49 = [
        v48 /*: any*/ ,
        v28 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "GSNForContentSidebarQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "useNetworkSideNavUserData"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4Apps"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4Filters"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4Operations"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4Overviews"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4Plans"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4Projects"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v9 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu7436separategrowthrecrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "GSNForContentSidebarQuery",
            "selections": [
                {
                    "alias": "userSideNavSettings",
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "entityAri",
                            "variableName": "entityAriUserSideNavSettings"
                        },
                        v10 /*: any*/ 
                    ],
                    "concreteType": "SettingsNavigationCustomisation",
                    "kind": "LinkedField",
                    "name": "settings_navigationCustomisation",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SettingsMenuItemConnection",
                            "kind": "LinkedField",
                            "name": "sidebar",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "SettingsMenuItem",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "menuId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "visible"
                                        }
                                    ]
                                }
                            ]
                        },
                        v11 /*: any*/ ,
                        v12 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isAppsExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v14 /*: any*/ ,
                                    "concreteType": "JiraNavigationItemConnection",
                                    "kind": "LinkedField",
                                    "name": "globalAppNavigationItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNavigationItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v15 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v16 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "appId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "appType"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "envLabel"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "iconUrl"
                                                                },
                                                                v17 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAppSection",
                                                                    "kind": "LinkedField",
                                                                    "name": "sections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v16 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraAppNavigationItemNestedLink",
                                                                            "kind": "LinkedField",
                                                                            "name": "links",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v16 /*: any*/ ,
                                                                                v18 /*: any*/ ,
                                                                                v17 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "settingsUrl"
                                                                },
                                                                v18 /*: any*/ 
                                                            ],
                                                            "type": "JiraAppNavigationItem"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isFiltersExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "hasIsFiltersExpanded",
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        },
                        {
                            "args": v14 /*: any*/ ,
                            "concreteType": "JiraWorkManagementGiraOverviewConnection",
                            "kind": "LinkedField",
                            "name": "jwmOverviews",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "totalCount"
                                }
                            ]
                        },
                        {
                            "condition": "isProjectsExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "hasIsProjectsExpanded",
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        },
                        {
                            "alias": "canCreateProject",
                            "args": [
                                v13 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "CREATE_PROJECT"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "canPerform"
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isPlansExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "hasIsPlansExpanded",
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        },
                        {
                            "args": v14 /*: any*/ ,
                            "concreteType": "JiraAdvancedRoadmapsNavigation",
                            "kind": "LinkedField",
                            "name": "advancedRoadmapsNavigation",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasEditPermissions"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasCreateSamplePlanPermissions"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasGlobalPlansAdminPermissions"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isFiltersExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "favouriteFilters",
                                    "args": [
                                        v13 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": v19 /*: any*/ ,
                                                "type": "FILTER"
                                            }
                                        },
                                        v20 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v21 /*: any*/ ,
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v15 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v22 /*: any*/ ,
                                                                v23 /*: any*/ ,
                                                                v12 /*: any*/ ,
                                                                v24 /*: any*/ ,
                                                                v25 /*: any*/ ,
                                                                v26 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        },
                                                        v27 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v28 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "recentFilters",
                                    "args": [
                                        v13 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "FILTER"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v15 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v22 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v23 /*: any*/ ,
                                                                        v12 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        v25 /*: any*/ ,
                                                                        v26 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraFilter",
                                                                    "abstractKey": "__isJiraFilter"
                                                                }
                                                            ],
                                                            "type": "JiraCustomFilter"
                                                        },
                                                        v27 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v28 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v14 /*: any*/ ,
                                    "concreteType": "JiraSystemFilterConnection",
                                    "kind": "LinkedField",
                                    "name": "systemFilters",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSystemFilterEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSystemFilter",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v22 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v23 /*: any*/ ,
                                                                v15 /*: any*/ ,
                                                                v24 /*: any*/ ,
                                                                v25 /*: any*/ ,
                                                                v26 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isOperationsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "OpsgenieQuery",
                            "kind": "LinkedField",
                            "name": "opsgenie",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v14 /*: any*/ ,
                                    "concreteType": "OpsgenieSavedSearches",
                                    "kind": "LinkedField",
                                    "name": "savedSearches",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "sharedWithMe",
                                            "plural": true,
                                            "selections": v30 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "createdByMe",
                                            "plural": true,
                                            "selections": v30 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isOverviewsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v14 /*: any*/ ,
                                    "concreteType": "JiraWorkManagementGiraOverviewConnection",
                                    "kind": "LinkedField",
                                    "name": "jwmOverviews",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraWorkManagementGiraOverviewEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraWorkManagementGiraOverview",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        v23 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isPlansExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "favouritePlans",
                                    "args": [
                                        v13 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": v19 /*: any*/ ,
                                                "type": "PLAN"
                                            }
                                        },
                                        v20 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v32 /*: any*/ 
                                        },
                                        v28 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "recentPlans",
                                    "args": [
                                        v13 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "PLAN"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v32 /*: any*/ 
                                        },
                                        v28 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isProjectsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v14 /*: any*/ ,
                                    "concreteType": "JiraWorkManagementLicensing",
                                    "kind": "LinkedField",
                                    "name": "jwmLicensing",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "currentUserSeatEdition"
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "alias": "favouriteProjects",
                                            "args": [
                                                v13 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "filter",
                                                    "value": {
                                                        "sort": v19 /*: any*/ ,
                                                        "type": "PROJECT"
                                                    }
                                                },
                                                v20 /*: any*/ 
                                            ],
                                            "concreteType": "JiraFavouriteConnection",
                                            "kind": "LinkedField",
                                            "name": "favourites",
                                            "plural": false,
                                            "selections": [
                                                v21 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraFavouriteEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v15 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v47 /*: any*/ ,
                                                                    "type": "JiraProject"
                                                                },
                                                                v27 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v28 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": [
                                                v13 /*: any*/ ,
                                                v29 /*: any*/ 
                                            ],
                                            "concreteType": "JiraProjectConnection",
                                            "kind": "LinkedField",
                                            "name": "recentProjects",
                                            "plural": false,
                                            "selections": v49 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu7436separategrowthrecrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "GrowthRecQuery",
                                            "kind": "LinkedField",
                                            "name": "growthRecommendations",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": [
                                                        {
                                                            "fields": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "product",
                                                                    "value": "jira"
                                                                },
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "tenantId",
                                                                    "variableName": "cloudId"
                                                                },
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "useCase",
                                                                    "value": "jiraProjectMenuRecommendations"
                                                                }
                                                            ],
                                                            "kind": "ObjectValue",
                                                            "name": "context"
                                                        },
                                                        {
                                                            "kind": "Literal",
                                                            "name": "first",
                                                            "value": 2
                                                        }
                                                    ],
                                                    "kind": "LinkedField",
                                                    "name": "recommendations",
                                                    "plural": false,
                                                    "selections": [
                                                        v15 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v15 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "entityId"
                                                                                }
                                                                            ],
                                                                            "type": "GrowthRecJiraTemplateRecommendation"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "GrowthRecRecommendations"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "entityAri",
                                                    "variableName": "entityAriProjects"
                                                },
                                                v10 /*: any*/ 
                                            ],
                                            "concreteType": "SettingsNavigationCustomisation",
                                            "kind": "LinkedField",
                                            "name": "settings_navigationCustomisation",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v14 /*: any*/ ,
                                    "concreteType": "JiraProjectsSidebarMenu",
                                    "kind": "LinkedField",
                                    "name": "jira_projectsSidebarMenu",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "mostRecent",
                                            "plural": false,
                                            "selections": v47 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "mostRecentFromHistory",
                                            "plural": false,
                                            "selections": [
                                                v12 /*: any*/ ,
                                                v33 /*: any*/ ,
                                                v24 /*: any*/ ,
                                                v34 /*: any*/ ,
                                                v35 /*: any*/ ,
                                                v36 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                v37 /*: any*/ ,
                                                v38 /*: any*/ ,
                                                v41 /*: any*/ ,
                                                v42 /*: any*/ ,
                                                v43 /*: any*/ ,
                                                v44 /*: any*/ ,
                                                v45 /*: any*/ ,
                                                v46 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": [
                                                v20 /*: any*/ 
                                            ],
                                            "concreteType": "JiraProjectConnection",
                                            "kind": "LinkedField",
                                            "name": "favourites",
                                            "plural": false,
                                            "selections": [
                                                v21 /*: any*/ ,
                                                v48 /*: any*/ ,
                                                v28 /*: any*/ 
                                            ],
                                            "storageKey": "favourites(first:15)"
                                        },
                                        {
                                            "args": [
                                                v29 /*: any*/ 
                                            ],
                                            "concreteType": "JiraProjectConnection",
                                            "kind": "LinkedField",
                                            "name": "recents",
                                            "plural": false,
                                            "selections": v49 /*: any*/ ,
                                            "storageKey": "recents(first:20)"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasMore"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "favouriteLimit"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "recentLimit"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "displayMode"
                                        },
                                        v12 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "37a3700feae5021ad4db10d3ae0688bb429dd59a5f2197617725b32258b14034",
            "metadata": {},
            "name": "GSNForContentSidebarQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider": (0, $95Z36.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider": (0, $apPdj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider": (0, $bozkj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider": (0, $gDHWC.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu7436separategrowthrecrelayprovider": (0, $2in5a.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider": (0, $57dih.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider": (0, $kXP4b.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": (0, $cN96Q.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider": (0, $i2tXg.default)
            }
        }
    };
}();
$6d34f0b14b459b38$var$node.hash = "1f851aebed21c153d2ce5eab4dad43e3";
var $6d34f0b14b459b38$export$2e2bcd8739ae039 = $6d34f0b14b459b38$var$node;

});


parcelRegister("fwzEJ", function(module, exports) {

$parcel$export(module.exports, "topNav4UIStateResource", () => $92bcd9e21d74460f$export$2d81c2e40eea9fba);
$parcel$export(module.exports, "topNav4UIStateResourceNew", () => $92bcd9e21d74460f$export$46c598422973ded2);

var $ao2h1 = parcelRequire("ao2h1");

var $9ZLcT = parcelRequire("9ZLcT");

var $dBV7w = parcelRequire("dBV7w");
const $92bcd9e21d74460f$export$2d81c2e40eea9fba = (0, $ao2h1.createRelayResource)({
    type: `${(0, $ao2h1.RELAY_RESOURCE_TYPE)}_TOPNAV_UI_STATE_RELAY`,
    getQuery: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>({
            parameters: (0, $9ZLcT.default),
            variables: {
                cloudId: cloudId,
                isAnonymous: isAnonymous
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});
const $92bcd9e21d74460f$export$46c598422973ded2 = (0, $ao2h1.createRelayResource)({
    type: `${(0, $ao2h1.RELAY_RESOURCE_TYPE)}_TOPNAV_UI_STATE_RELAY_NEW`,
    getQuery: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous, atlassianAccountId: atlassianAccountId } })=>({
            parameters: (0, $dBV7w.default),
            variables: {
                cloudId: cloudId,
                isAnonymous: isAnonymous,
                atlassianAccountId: atlassianAccountId ?? ''
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("9ZLcT", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b5c5aa00eda199b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<245ebf530f6456785ef52df1f858d8d6>>
 * @relayHash 06c1fd144d99d35ba67bae790f1f7cd8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9c018ab68e9ab932f455b13c0b303051efc04cecd57d328ba9d319c75a095053
const $3b5c5aa00eda199b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isAnonymous"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "isLeftSidebarCollapsed"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AtlaskitAtlassianNavigationNav4UIQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "condition": "isAnonymous",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "args": v1 /*: any*/ ,
                                        "concreteType": "JiraNavigationUIStateUserProperty",
                                        "kind": "LinkedField",
                                        "name": "navigationUIState",
                                        "plural": false,
                                        "selections": [
                                            v2 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4Profile"
                },
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "Nav4NotificationsData"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AtlaskitAtlassianNavigationNav4UIQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isAnonymous",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraNavigationUIStateUserProperty",
                                    "kind": "LinkedField",
                                    "name": "navigationUIState",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "picture"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "email"
                                        }
                                    ],
                                    "type": "AtlassianAccountUser"
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "InfluentsNotificationQuery",
                            "kind": "LinkedField",
                            "name": "notifications",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "unseenNotificationCount"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9c018ab68e9ab932f455b13c0b303051efc04cecd57d328ba9d319c75a095053",
            "metadata": {},
            "name": "AtlaskitAtlassianNavigationNav4UIQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3b5c5aa00eda199b$var$node.hash = "680aa6f9a11f8a3c8a9e33f783e3ed43";
var $3b5c5aa00eda199b$export$2e2bcd8739ae039 = $3b5c5aa00eda199b$var$node;

});

parcelRegister("dBV7w", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5f0d8f2ac167e71$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<264207a5ad98a30400b6c0fbb8d87aa5>>
 * @relayHash 8f9c361f57a482d2fd1ae8b97dfd02ab
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4a16a377373b87104566d0532d02a99583753947e8664be248de87caed9b33b2
const $d5f0d8f2ac167e71$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "atlassianAccountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isAnonymous"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "isLeftSidebarCollapsed"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "AtlassianNavigationNav4Query",
            "selections": [
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraNavigationUIStateUserProperty",
                                    "kind": "LinkedField",
                                    "name": "navigationUIState",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "Nav4ProfileNew"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "Nav4NotificationsData"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "AtlassianNavigationNav4Query",
            "selections": [
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraNavigationUIStateUserProperty",
                                    "kind": "LinkedField",
                                    "name": "navigationUIState",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "accountId",
                                    "variableName": "atlassianAccountId"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "picture"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "email"
                                        }
                                    ],
                                    "type": "AtlassianAccountUser"
                                },
                                v5 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "InfluentsNotificationQuery",
                            "kind": "LinkedField",
                            "name": "notifications",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "unseenNotificationCount"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4a16a377373b87104566d0532d02a99583753947e8664be248de87caed9b33b2",
            "metadata": {},
            "name": "AtlassianNavigationNav4Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d5f0d8f2ac167e71$var$node.hash = "8e821b0a7bdc9bc7696f44ec70106ec7";
var $d5f0d8f2ac167e71$export$2e2bcd8739ae039 = $d5f0d8f2ac167e71$var$node;

});


parcelRegister("h9iZl", function(module, exports) {

$parcel$export(module.exports, "navigationPlansVisibilityResource", () => $66eb980ebca35ddf$export$fa475a9581133779);
$parcel$export(module.exports, "useNavigationPlansVisibility", () => $66eb980ebca35ddf$export$4524245d4e74edb2);
$parcel$export(module.exports, "useNavigationViewPlansPermission", () => $66eb980ebca35ddf$export$98eef08fd4586a4);
$parcel$export(module.exports, "useNavigationEditPlansPermission", () => $66eb980ebca35ddf$export$525db876ed776e0d);
$parcel$export(module.exports, "useIsAdvancedRoadmapsTrial", () => $66eb980ebca35ddf$export$54805a2120a31ad0);

var $2YZCu = parcelRequire("2YZCu");

var $7f4tk = parcelRequire("7f4tk");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

const $66eb980ebca35ddf$export$fa475a9581133779 = (0, $2M1hQ.createResource)({
    type: (0, $94526093207618a3$export$9260ddb6dfeafd7b),
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        try {
            if (tenantContext.isAnonymous) return false;
            const response = await (0, $7f4tk.default)('/rest/jpo/1.0/navigation/simple');
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData((0, $94526093207618a3$export$87d0ca22edb7493a), 'Error while fetching plans visibility', error);
        }
        return false;
    },
    maxAge: Infinity
});
const $66eb980ebca35ddf$export$4524245d4e74edb2 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)($66eb980ebca35ddf$export$fa475a9581133779);
    let isVisible = false;
    if (!error && !loading && data !== null && typeof data === 'object') isVisible = data.isVisible;
    return [
        isVisible
    ];
};
const $66eb980ebca35ddf$export$98eef08fd4586a4 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)($66eb980ebca35ddf$export$fa475a9581133779);
    let hasEditOrViewPermissions = false;
    if (!error && !loading && data !== null && typeof data === 'object') hasEditOrViewPermissions = data.hasEditOrViewPermissions;
    return [
        hasEditOrViewPermissions
    ];
};
const $66eb980ebca35ddf$export$525db876ed776e0d = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)($66eb980ebca35ddf$export$fa475a9581133779);
    let canEditPlans = false;
    if (!error && !loading && data !== null && typeof data === 'object') canEditPlans = data.hasEditPermissions || false;
    return canEditPlans;
};
const $66eb980ebca35ddf$export$54805a2120a31ad0 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)($66eb980ebca35ddf$export$fa475a9581133779);
    let isAdvancedRoadmapsTrial = false;
    if (!error && !loading && data !== null && typeof data === 'object') isAdvancedRoadmapsTrial = data.isAdvancedRoadmapsTrial || false;
    return isAdvancedRoadmapsTrial;
};

});
const $94526093207618a3$export$9260ddb6dfeafd7b = 'NAVIGATION_PLANS_VISIBILITY';
const $94526093207618a3$export$87d0ca22edb7493a = 'portfolio.services.plan-item-visibility';


parcelRegister("2eyDn", function(module, exports) {

$parcel$export(module.exports, "consentBannerUserPreferencesResource", () => $7912ae5bd04d670f$export$785c22104b6f2285);
$parcel$export(module.exports, "useConsentBannerUserPreferencesResource", () => $7912ae5bd04d670f$export$5bc7e83e85567fb4);
// eslint-disable-next-line jira/import-whitelist

var $21KEY = parcelRequire("21KEY");

var $3TzYp = parcelRequire("3TzYp");

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

const $7912ae5bd04d670f$export$785c22104b6f2285 = (0, $2M1hQ.createResource)({
    type: (0, $f92ba51f7e46c4ce$export$c5397b7748ed6c7b),
    getKey: ()=>(0, $f92ba51f7e46c4ce$export$4a9dd42dbc707155),
    getData: async ()=>{
        const consentToken = (0, $3TzYp.getCookie)((0, $21KEY.ATLASSIAN_CONSENT_COOKIE_KEY));
        const fallbackConsentToken = (0, $3TzYp.getCookie)((0, $21KEY.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
        // If we have cached cookie data, bundle it up, with a potential fallback token
        if (consentToken) return {
            consentToken: consentToken,
            fallbackConsentToken: fallbackConsentToken
        };
        const data = await (0, $eusud.performGetRequest)('/gateway/api/consenthub/session/user/consents/cookies');
        return data;
    },
    maxAge: 900000,
    isBrowserOnly: true
});
const $7912ae5bd04d670f$export$5bc7e83e85567fb4 = ()=>(0, $2YP9W.useResource)($7912ae5bd04d670f$export$785c22104b6f2285);

});
parcelRegister("3TzYp", function(module, exports) {

$parcel$export(module.exports, "getCookie", () => $7ade243d7fa91fea$export$4be65e66cfa2648a);

var $4uHy1 = parcelRequire("4uHy1");
function $7ade243d7fa91fea$export$4be65e66cfa2648a(key) {
    return key ? (0, $4uHy1.getCookie)(key) : (0, $4uHy1.getCookie)();
}

});

const $f92ba51f7e46c4ce$export$c5397b7748ed6c7b = 'CONSENT_BANNER_USER_PREFERENCES';
const $f92ba51f7e46c4ce$export$4a9dd42dbc707155 = 'CONSENT_BANNER_USER_PREFERENCES_KEY';


parcelRegister("drGWM", function(module, exports) {

$parcel$export(module.exports, "checkApiKeyManagementKeysResource", () => $ea67ffb8a72e0299$export$b16eaa5246afc9b6);
// eoc-fetch is already being used in eoc resources, so there is no reason not
// to override the whitelist here.
// eslint-disable-next-line jira/import-whitelist

var $j74qU = parcelRequire("j74qU");

var $3H5ry = parcelRequire("3H5ry");


var $2M1hQ = parcelRequire("2M1hQ");

const $ea67ffb8a72e0299$var$fetchCheckApiKeyManagementKeys = async (accountId, isSiteAdmin, isTransitioning, appPermissions)=>{
    if (!isTransitioning || !isSiteAdmin || appPermissions && appPermissions.hasServiceDeskAccess === false) return Promise.resolve(false);
    return (0, $j74qU.eocFetch)(`/api-keys/web/check?accountId=${accountId}`).then(({ data: data })=>data);
};
const $ea67ffb8a72e0299$var$resource = (0, $2M1hQ.createResource)({
    type: (0, $9b8f6422d397a375$export$5879151f0d972f18),
    getKey: ()=>'check-api-key-management-keys',
    getData: async ({ dependencies: dependencies }, { tenantContext: { atlassianAccountId: atlassianAccountId, appPermissions: appPermissions, isSiteAdmin: isSiteAdmin } })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const tenantInfo = await dependencies[0, $5a94e356f9d5e220$export$25ee35b01de9d734]?.promise;
        const isTransitioning = (0, $3H5ry.checkIsTransitioning)(tenantInfo);
        return $ea67ffb8a72e0299$var$fetchCheckApiKeyManagementKeys(atlassianAccountId, isSiteAdmin, isTransitioning, appPermissions);
    },
    maxAge: Infinity,
    isBrowserOnly: true,
    depends: [
        (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
    ]
});
const $ea67ffb8a72e0299$export$b16eaa5246afc9b6 = ()=>$ea67ffb8a72e0299$var$resource;

});
parcelRegister("3H5ry", function(module, exports) {

$parcel$export(module.exports, "checkShouldUseJSM", () => $bc03080c674ccba2$export$5e0f3a0d8463fa21);
$parcel$export(module.exports, "checkIsTransitioning", () => $bc03080c674ccba2$export$d2f281fd4bf10855);
$parcel$export(module.exports, "checkIsConsolidated", () => $bc03080c674ccba2$export$57f75aebff17dd1e);
$parcel$export(module.exports, "checkIsTransitioned", () => $bc03080c674ccba2$export$b6461b23ee0e1471);
$parcel$export(module.exports, "checkIsTransitionEligible", () => $bc03080c674ccba2$export$24040115cac5fdc3);
$parcel$export(module.exports, "checkShouldAccessUnlockOperations", () => $bc03080c674ccba2$export$cd227238525e8d57);
$parcel$export(module.exports, "checkIsOpsAdmin", () => $bc03080c674ccba2$export$66a96ac2f07f6730);

var $bgC2H = parcelRequire("bgC2H");

const $bc03080c674ccba2$export$5e0f3a0d8463fa21 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState !== (0, $bgC2H.ConsolidationState).NOT_CONSOLIDATED;
};
const $bc03080c674ccba2$export$d2f281fd4bf10855 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState === (0, $bgC2H.ConsolidationState).TRANSITIONING;
};
const $bc03080c674ccba2$export$57f75aebff17dd1e = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return typeof tenantInfo === 'string' ? tenantInfo === (0, $bgC2H.ConsolidationState).CONSOLIDATED : tenantInfo.consolidationState === (0, $bgC2H.ConsolidationState).CONSOLIDATED;
};
const $bc03080c674ccba2$export$b6461b23ee0e1471 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState === (0, $bgC2H.ConsolidationState).TRANSITIONED;
};
const $bc03080c674ccba2$export$24040115cac5fdc3 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState === (0, $bgC2H.ConsolidationState).NOT_CONSOLIDATED && tenantInfo.cohortInfo === (0, $47a35bf911de1c9b$export$650f6934db1290c1);
};
const $bc03080c674ccba2$export$cd227238525e8d57 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState !== (0, $bgC2H.ConsolidationState).CONSOLIDATED && (tenantInfo.cohortInfo === (0, $47a35bf911de1c9b$export$650f6934db1290c1) || tenantInfo.cohortInfo === (0, $47a35bf911de1c9b$export$a101f3562b5f0742));
};
const $bc03080c674ccba2$export$66a96ac2f07f6730 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return typeof tenantInfo === 'string' ? false : Boolean(tenantInfo.isAdmin);
};

});
const $47a35bf911de1c9b$export$650f6934db1290c1 = 'cohort3';
const $47a35bf911de1c9b$export$a101f3562b5f0742 = 'cohort3.5';


const $9b8f6422d397a375$export$5879151f0d972f18 = 'EOC_CHECK_API_KEY';


parcelRegister("kMiZJ", function(module, exports) {

$parcel$export(module.exports, "consolidationUserStateResource", () => $1e0457dbe68ab17d$export$4b870505c49999ef);

var $jcw0u = parcelRequire("jcw0u");

var $2M1hQ = parcelRequire("2M1hQ");

var $9QTNT = parcelRequire("9QTNT");

const $1e0457dbe68ab17d$var$RESOURCE_KEY = 'RESOURCE_TYPE_EOC_OG_CONSOLIDATION_USER_STATE';
const $1e0457dbe68ab17d$export$4b870505c49999ef = (0, $2M1hQ.createResource)({
    type: $1e0457dbe68ab17d$var$RESOURCE_KEY,
    getKey: ()=>$1e0457dbe68ab17d$var$RESOURCE_KEY,
    getData: (_, { tenantContext: { atlassianAccountId: accountId } })=>(0, $9QTNT.getOgConsolidationUserState)(accountId).catch((error)=>{
            (0, $jcw0u.default)({
                meta: {
                    id: 'consolidationUserStateResource',
                    packageName: 'jiraRouterResourcesEocOgConsolidationUserState',
                    teamName: 'alexstrasza'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }),
    maxAge: Infinity
});

});
parcelRegister("9QTNT", function(module, exports) {

$parcel$export(module.exports, "getOgConsolidationUserState", () => $1a9945d1ee35f024$export$df7594d56c9ebe57);

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $iXaZ3 = parcelRequire("iXaZ3");
const $1a9945d1ee35f024$export$df7594d56c9ebe57 = (accountId)=>{
    if (!accountId) return Promise.resolve((0, $iXaZ3.ERROR_CONSOLIDATION_USER_STATE));
    return (0, $89SaW.getUserProperty)(accountId, (0, $iXaZ3.OG_CONSOLIDATION_USER_STATE_STORAGE_KEY)).then((val)=>{
        if (!val || typeof val !== 'object') {
            (0, $jcw0u.default)({
                meta: {
                    id: 'getUserProperty',
                    packageName: 'jiraRouterResourcesEocOgConsolidationUserState',
                    teamName: 'alexstrasza'
                },
                error: new (0, $jJZqs.ValidationError)('User property is not an object. It must be changed outside of the automated flow.'),
                sendToPrivacyUnsafeSplunk: true
            });
            return 0, $iXaZ3.DEFAULT_CONSOLIDATION_USER_STATE;
        }
        if (!Object.keys(val).every((key)=>Object.prototype.hasOwnProperty.call((0, $iXaZ3.DEFAULT_CONSOLIDATION_USER_STATE), key))) return {
            ...(0, $iXaZ3.DEFAULT_CONSOLIDATION_USER_STATE),
            ...Object.fromEntries(Object.entries(val).filter(([key])=>Object.prototype.hasOwnProperty.call((0, $iXaZ3.DEFAULT_CONSOLIDATION_USER_STATE), key)))
        };
        if (!Object.keys((0, $iXaZ3.DEFAULT_CONSOLIDATION_USER_STATE)).every((key)=>Object.prototype.hasOwnProperty.call(val, key))) // Missing properties will happen when adding new properties to the type,
        // we are making sure they are filled in from the defaults
        return {
            ...(0, $iXaZ3.DEFAULT_CONSOLIDATION_USER_STATE),
            ...val
        };
        return val;
    }).catch((error)=>{
        // Property not saved yet, so we return the default values
        if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) return 0, $iXaZ3.DEFAULT_CONSOLIDATION_USER_STATE;
        throw error;
    });
};

});
parcelRegister("iXaZ3", function(module, exports) {

$parcel$export(module.exports, "OG_CONSOLIDATION_USER_STATE_STORAGE_KEY", () => $58f10b27bad0d860$export$1980758e2622af02);
$parcel$export(module.exports, "DEFAULT_CONSOLIDATION_USER_STATE", () => $58f10b27bad0d860$export$51d9907e9d716d);
$parcel$export(module.exports, "ERROR_CONSOLIDATION_USER_STATE", () => $58f10b27bad0d860$export$23da4710c3a29eae);
const $58f10b27bad0d860$export$1980758e2622af02 = 'eoc_consolidation_user_state';
const $58f10b27bad0d860$export$51d9907e9d716d = {
    isPromotionBannerDismissed: false,
    isWelcomeModalDisplayed: false,
    isTransitionHomeHidden: false,
    isTransitionBannerDismissed: false,
    isBroadcastWidgetDismissed: false,
    transitionBannerDismissedAt: null,
    isBenefitModalDismissed: false
};
const $58f10b27bad0d860$export$23da4710c3a29eae = {
    isPromotionBannerDismissed: true,
    isWelcomeModalDisplayed: true,
    isTransitionHomeHidden: true,
    isTransitionBannerDismissed: true,
    isBroadcastWidgetDismissed: true,
    transitionBannerDismissedAt: null,
    isBenefitModalDismissed: true
};

});



parcelRegister("aA974", function(module, exports) {

$parcel$export(module.exports, "gicSmartFieldsFeatureResource", () => $d18db694553f5610$export$ee94bb1f59b07e35);
$parcel$export(module.exports, "useIsSmartFieldsOptIn", () => $d18db694553f5610$export$3870b1ff1b155c73);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $aHuqL = parcelRequire("aHuqL");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

const $d18db694553f5610$export$ee94bb1f59b07e35 = (0, $2M1hQ.createResource)({
    type: (0, $814b0a0376a60368$export$6f0555de4f60e84e),
    getKey: ()=>(0, $814b0a0376a60368$export$7e7d7930e22ba39f),
    getData: async ()=>{
        try {
            const data = await (0, $aHuqL.userPreferenceAPI).get((0, $814b0a0376a60368$export$b94951a11282ae6a));
            if (!data) return {
                hasUserOptedOut: false,
                hasUserDismissedReadMore: false,
                hasUserDismissedGicOnboarding: false
            };
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // If value has never been set, we expect a 404
            if (error.statusCode === 404) return {
                hasUserOptedOut: false,
                hasUserDismissedReadMore: false,
                hasUserDismissedGicOnboarding: false
            };
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'gicSmartFieldsFeatureResource',
                    packageName: (0, $814b0a0376a60368$export$b8b9d90f9e5bd72b),
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            hasUserOptedOut: false,
            hasUserDismissedReadMore: false,
            hasUserDismissedGicOnboarding: false
        };
    },
    maxAge: Number.MAX_VALUE
});
const $d18db694553f5610$export$3870b1ff1b155c73 = ()=>{
    const { data: data, update: update, loading: loading } = (0, $2YP9W.useResource)($d18db694553f5610$export$ee94bb1f59b07e35);
    const currentOptInStatus = typeof data?.hasUserOptedOut === 'boolean' ? !data.hasUserOptedOut : true;
    const currentDismissedReadMore = typeof data?.hasUserDismissedReadMore === 'boolean' ? data.hasUserDismissedReadMore : false;
    const currentDismissedGicOnboarding = typeof data?.hasUserDismissedGicOnboarding === 'boolean' ? data.hasUserDismissedGicOnboarding : false;
    const dismissReadMore = (0, $5uXOq.useCallback)(()=>{
        update((previousData)=>({
                ...previousData?.hasUserOptedOut ? {
                    hasUserOptedOut: previousData.hasUserOptedOut
                } : {
                    hasUserOptedOut: false
                },
                hasUserDismissedReadMore: true,
                ...previousData?.hasUserDismissedGicOnboarding ? {
                    hasUserDismissedGicOnboarding: previousData.hasUserDismissedGicOnboarding
                } : {
                    hasUserDismissedGicOnboarding: false
                }
            }));
    }, [
        update
    ]);
    const dismissGicOnboarding = (0, $5uXOq.useCallback)(()=>{
        update((previousData)=>({
                ...previousData?.hasUserOptedOut ? {
                    hasUserOptedOut: previousData.hasUserOptedOut
                } : {
                    hasUserOptedOut: false
                },
                ...previousData?.hasUserDismissedReadMore ? {
                    hasUserDismissedReadMore: previousData.hasUserDismissedReadMore
                } : {
                    hasUserDismissedReadMore: false
                },
                hasUserDismissedGicOnboarding: true
            }));
    }, [
        update
    ]);
    return {
        isSmartFieldsOptIn: loading ? null : currentOptInStatus,
        isSmartFieldDismissedReadMore: loading ? null : currentDismissedReadMore,
        isSmartFieldsGicOnboardingDismissed: loading ? null : currentDismissedGicOnboarding,
        dismissReadMore: dismissReadMore,
        dismissGicOnboarding: dismissGicOnboarding,
        loading: loading
    };
};

});
parcelRegister("aHuqL", function(module, exports) {

$parcel$export(module.exports, "userPreferenceAPI", () => $0f87ed1c6d708024$export$4f7929ca6b50a436);


var $eusud = parcelRequire("eusud");
const $0f87ed1c6d708024$var$url = (key)=>`/rest/api/3/mypreferences?key=${key}`;
const $0f87ed1c6d708024$var$get = async (key)=>{
    try {
        const result = await (0, $eusud.performGetRequest)($0f87ed1c6d708024$var$url(key));
        return result?.value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef)) return null;
        throw error;
    }
};
const $0f87ed1c6d708024$var$set = (key, value)=>(0, $eusud.performPutRequest)($0f87ed1c6d708024$var$url(key), {
        body: JSON.stringify({
            value: value
        })
    });
const $0f87ed1c6d708024$var$remove = (key)=>(0, $eusud.performDeleteRequest)($0f87ed1c6d708024$var$url(key));
const $0f87ed1c6d708024$export$4f7929ca6b50a436 = {
    get: $0f87ed1c6d708024$var$get,
    set: $0f87ed1c6d708024$var$set,
    remove: $0f87ed1c6d708024$var$remove
};

});

const $814b0a0376a60368$export$6f0555de4f60e84e = 'RESOURCE_TYPE_GIC_SMART_FIELDS';
const $814b0a0376a60368$export$7e7d7930e22ba39f = 'gsf-opt-out-resource-key'; // value is global for user
const $814b0a0376a60368$export$b94951a11282ae6a = 'gic-smart-fields-feature';
const $814b0a0376a60368$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesGicSmartFields';


parcelRegister("f5nIZ", function(module, exports) {

$parcel$export(module.exports, "gicOptInStatusResources", () => $1dd3138bca6cac05$export$14c89b6b6a261524);

var $2YZCu = parcelRequire("2YZCu");

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");


const $1dd3138bca6cac05$export$14c89b6b6a261524 = (0, $2M1hQ.createResource)({
    type: (0, $8e5bc4e5db4905c7$export$fe522736b61f6709),
    getKey: ()=>'gic_optin_status',
    getData: async ()=>{
        let gicOptInStatus = null;
        try {
            gicOptInStatus = await (0, $eusud.performGetRequest)('/rest/greenhopper/1.0/profile/labs-panel/modern-gic-visibility');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e.statusCode !== 404) (0, $2YZCu.default).safeErrorWithoutCustomerData('spa.router.resources.navigation.gicVisibility', 'getGICVisibility', e);
        }
        return {
            gicOptInStatus: gicOptInStatus ?? {
                isEnabled: false
            }
        };
    },
    maxAge: Number.MAX_VALUE
});

});
const $8e5bc4e5db4905c7$export$fe522736b61f6709 = 'RESOURCE_TYPE_GIC_OPTIN_STATUS';


parcelRegister("hZhhj", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RESPONSE", () => $0f1ada479bbc578a$export$32d9db53927095d3);
$parcel$export(module.exports, "incomingMailServerExpiryStatusResource", () => $0f1ada479bbc578a$export$369caf52ed1ad2b1);
$parcel$export(module.exports, "useIncomingMailExpiryStatus", () => $0f1ada479bbc578a$export$283aa034b7d4e2a0);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

const $0f1ada479bbc578a$var$fetchGetIncomingMailServerExpiryStatus = async ()=>(0, $eusud.performGetRequest)((0, $b9c933d7a799fa71$export$5bf8eb915287f5f4));
const $0f1ada479bbc578a$export$32d9db53927095d3 = {
    isAdmin: false,
    showBanner: true,
    OauthTypes: [
        'GMAIL_OAUTH'
    ]
};
const $0f1ada479bbc578a$export$369caf52ed1ad2b1 = (0, $2M1hQ.createResource)({
    type: (0, $b9c933d7a799fa71$export$3b9494e0dfc4de09),
    getKey: ()=>(0, $b9c933d7a799fa71$export$f2f2f265ccc09f82),
    getData: async ()=>{
        let incomingMailServerExpiryStatus = null;
        try {
            incomingMailServerExpiryStatus = await $0f1ada479bbc578a$var$fetchGetIncomingMailServerExpiryStatus();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === 404) (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'incomingMailServerExpiryStatus',
                    packageName: 'jiraRouterResourcesIncomingMailExpiryStatus',
                    teamName: 'maverick'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            incomingMailServerExpiryStatus: incomingMailServerExpiryStatus ?? $0f1ada479bbc578a$export$32d9db53927095d3
        };
    },
    maxAge: 3600000
});
const $0f1ada479bbc578a$export$283aa034b7d4e2a0 = ()=>{
    const { data: data, loading: loadingGetResource, error: errorGetResource } = (0, $2YP9W.useResource)($0f1ada479bbc578a$export$369caf52ed1ad2b1);
    const [incomingMailServerExpiryStatus, setIncomingMailServerExpiryStatus] = (0, $5uXOq.useState)(()=>{
        if (data?.incomingMailServerExpiryStatus) return data.incomingMailServerExpiryStatus;
        return $0f1ada479bbc578a$export$32d9db53927095d3;
    });
    const [responseStatusGet, setResponseStatusGet] = (0, $5uXOq.useState)('not started');
    (0, $5uXOq.useEffect)(()=>{
        if (loadingGetResource) {
            setResponseStatusGet('loading');
            return;
        }
        if (errorGetResource) {
            setResponseStatusGet('error');
            return;
        }
        if (data?.incomingMailServerExpiryStatus) {
            setResponseStatusGet('success');
            setIncomingMailServerExpiryStatus(data.incomingMailServerExpiryStatus);
        }
    }, [
        loadingGetResource,
        errorGetResource,
        data?.incomingMailServerExpiryStatus
    ]);
    return {
        responseStatus: responseStatusGet,
        state: incomingMailServerExpiryStatus
    };
};

});
const $b9c933d7a799fa71$export$3b9494e0dfc4de09 = 'mail_server_expiring';
const $b9c933d7a799fa71$export$f2f2f265ccc09f82 = 'is_oauth_mail_server_expiring';
const $b9c933d7a799fa71$export$5bf8eb915287f5f4 = '/rest/internal/3/incomingMailServers/isOauthMailServersExpiring';


parcelRegister("9MiT2", function(module, exports) {

$parcel$export(module.exports, "issueTransitionChangeboardingPreferencesResource", () => $2d6f7831c4394a60$export$1b6468a6eb7d9b09);
$parcel$export(module.exports, "useIssueTransitionChangeboardingPreferences", () => $2d6f7831c4394a60$export$e21c345b2538e96e);

var $5uXOq = parcelRequire("5uXOq");

var $561FV = parcelRequire("561FV");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $erLlC = parcelRequire("erLlC");
const $2d6f7831c4394a60$export$1b6468a6eb7d9b09 = (0, $2M1hQ.createResource)({
    type: (0, $erLlC.RESOURCE_TYPE_ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES),
    getKey: ()=>(0, $erLlC.ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_STATUS_RESOURCE_KEY),
    getData: async ()=>{
        let modalViewCount = 0;
        try {
            const apiResult = await (0, $eusud.performGetRequest)((0, $erLlC.ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API));
            if ((0, $4R6GH.fg)('modern_issue_transition_enable_benefits_modal')) {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(apiResult, 'value') || !(0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(apiResult, 'benefitsModalValue')) {
                    const error = new Error('Invalid preference value');
                    (0, $jcw0u.default)({
                        meta: {
                            id: 'issueTransitionChangeboardingPreferencesResource',
                            packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                            teamName: 'gryffindor'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
                return {
                    numberOfTimesUserHasSeenChangeboarding: Number(apiResult.value) || 0,
                    benefitsModal: {
                        isDisabled: apiResult?.benefitsModal?.isDisabled || false,
                        nextDateToShowBenefitsModal: apiResult?.benefitsModal?.nextDateToShowBenefitsModal || null
                    }
                };
            }
            if (typeof apiResult !== 'object' || !(0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(apiResult, 'value')) {
                const error = new Error('Invalid preference value');
                (0, $jcw0u.default)({
                    meta: {
                        id: 'issueTransitionChangeboardingPreferencesResource',
                        packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            } else {
                modalViewCount = Number(apiResult.value);
                return {
                    numberOfTimesUserHasSeenChangeboarding: modalViewCount
                };
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === 404) {
                if ((0, $4R6GH.fg)('modern_issue_transition_enable_benefits_modal')) return {
                    numberOfTimesUserHasSeenChangeboarding: 0,
                    benefitsModal: {
                        isDisabled: false,
                        nextDateToShowBenefitsModal: null
                    }
                };
                return {
                    numberOfTimesUserHasSeenChangeboarding: 0
                };
            }
            (0, $jcw0u.default)({
                meta: {
                    id: 'issueTransitionChangeboardingPreferencesResource',
                    packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            numberOfTimesUserHasSeenChangeboarding: modalViewCount,
            benefitsModal: {
                isDisabled: true,
                nextDateToShowBenefitsModal: null
            }
        };
    }
});
const $2d6f7831c4394a60$export$e21c345b2538e96e = ()=>{
    const { data: data, loading: loadingGetResource, error: errorGetResource, update: update } = (0, $2YP9W.useResource)($2d6f7831c4394a60$export$1b6468a6eb7d9b09);
    const [issueTransitionChangeboardingPreference, setIssueTransitionChangeboardingPreference] = (0, $5uXOq.useState)(()=>{
        if ((0, $4R6GH.fg)('modern_issue_transition_enable_benefits_modal')) return {
            numberOfTimesUserHasSeenChangeboarding: Number(data?.numberOfTimesUserHasSeenChangeboarding),
            benefitsModal: {
                isDisabled: Boolean(data?.benefitsModal?.isDisabled),
                nextDateToShowBenefitsModal: String(data?.benefitsModal?.nextDateToShowBenefitsModal) || null
            }
        };
        if (typeof data?.numberOfTimesUserHasSeenChangeboarding === 'number') return data.numberOfTimesUserHasSeenChangeboarding;
        return 0, $erLlC.USER_SEEN_CARDINALITY_UNKNOWN;
    });
    const [responseStatusGet, setResponseStatusGet] = (0, $5uXOq.useState)('not started');
    const [responseStatusPut, setResponseStatusPut] = (0, $5uXOq.useState)('not started');
    const updateIssueTranstitionChangeboardingPreferences = (0, $5uXOq.useCallback)(async (updates)=>{
        let response = 'loading';
        setResponseStatusPut('loading');
        const body = typeof updates !== 'number' && (0, $4R6GH.fg)('modern_issue_transition_enable_benefits_modal') ? {
            value: updates?.numberOfTimesUserHasSeenChangeboarding,
            benefitsModal: {
                isDisabled: updates?.benefitsModal?.isDisabled,
                nextDateToShowBenefitsModal: updates?.benefitsModal?.nextDateToShowBenefitsModal
            }
        } : {
            value: updates
        };
        try {
            await (0, $eusud.performPutRequest)((0, $erLlC.ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API), {
                body: JSON.stringify(body)
            });
            setResponseStatusPut('success');
            let updateData;
            if (typeof updates !== 'number' && (0, $4R6GH.fg)('modern_issue_transition_enable_benefits_modal')) updateData = {
                numberOfTimesUserHasSeenChangeboarding: updates?.numberOfTimesUserHasSeenChangeboarding,
                benefitsModal: {
                    isDisabled: updates?.benefitsModal?.isDisabled || false,
                    nextDateToShowBenefitsModal: String(updates?.benefitsModal?.nextDateToShowBenefitsModal) || null
                }
            };
            if (typeof updates === 'number') updateData = {
                numberOfTimesUserHasSeenChangeboarding: updates
            };
            update(()=>updateData);
            response = 'success';
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'issueTransitionChangeboardingPreferencesUpdate',
                    packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            setResponseStatusPut('error');
            response = 'error';
        }
        return response;
    }, [
        update
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (loadingGetResource) {
            setResponseStatusGet('loading');
            return;
        }
        if (errorGetResource) {
            setResponseStatusGet('error');
            return;
        }
        if ((0, $4R6GH.fg)('modern_issue_transition_enable_benefits_modal')) {
            setResponseStatusGet('success');
            setIssueTransitionChangeboardingPreference({
                numberOfTimesUserHasSeenChangeboarding: Number(data?.numberOfTimesUserHasSeenChangeboarding),
                benefitsModal: {
                    isDisabled: data?.benefitsModal?.isDisabled || false,
                    nextDateToShowBenefitsModal: String(data?.benefitsModal?.nextDateToShowBenefitsModal) || null
                }
            });
            return;
        }
        if (typeof data?.numberOfTimesUserHasSeenChangeboarding === 'number') {
            setResponseStatusGet('success');
            setIssueTransitionChangeboardingPreference(data?.numberOfTimesUserHasSeenChangeboarding);
        }
    }, [
        loadingGetResource,
        errorGetResource,
        data?.numberOfTimesUserHasSeenChangeboarding,
        data?.benefitsModal?.isDisabled,
        data?.benefitsModal?.nextDateToShowBenefitsModal
    ]);
    return {
        stateGet: {
            responseStatus: responseStatusGet,
            state: issueTransitionChangeboardingPreference
        },
        stateUpdate: {
            responseStatus: responseStatusPut,
            setState: updateIssueTranstitionChangeboardingPreferences
        }
    };
};

});
parcelRegister("561FV", function(module, exports) {

var $kBZUL = parcelRequire("kBZUL");

var $abMfl = parcelRequire("abMfl");
/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */ function $3b5ecfeebeaba989$var$has(object, path) {
    return object != null && $abMfl(object, path, $kBZUL);
}
module.exports = $3b5ecfeebeaba989$var$has;

});
parcelRegister("kBZUL", function(module, exports) {
/** Used for built-in method references. */ var $f0174a4434851129$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f0174a4434851129$var$hasOwnProperty = $f0174a4434851129$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $f0174a4434851129$var$baseHas(object, key) {
    return object != null && $f0174a4434851129$var$hasOwnProperty.call(object, key);
}
module.exports = $f0174a4434851129$var$baseHas;

});


parcelRegister("erLlC", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES", () => $ca7314633d486db1$export$d66d4b761db3d20f);
$parcel$export(module.exports, "ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_STATUS_RESOURCE_KEY", () => $ca7314633d486db1$export$79fd70b908f71ddd);
$parcel$export(module.exports, "ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API", () => $ca7314633d486db1$export$e5007258addba8aa);
$parcel$export(module.exports, "USER_SEEN_CARDINALITY_UNKNOWN", () => $ca7314633d486db1$export$91880069e7e73b18);
$parcel$export(module.exports, "DURATION_IN_DAYS_DEFAULT", () => $ca7314633d486db1$export$9ccdfd91f2512a27);
const $ca7314633d486db1$export$d66d4b761db3d20f = 'issue_transition_changeboarding_preferences';
const $ca7314633d486db1$export$79fd70b908f71ddd = 'issue_transition_changeboarding_preferences_status';
const $ca7314633d486db1$export$e5007258addba8aa = '/rest/api/3/mypreferences?key=jira.its.changeboarding.preferences';
const $ca7314633d486db1$export$91880069e7e73b18 = -1;
const $ca7314633d486db1$export$9ccdfd91f2512a27 = 14;

});


parcelRegister("fNOVA", function(module, exports) {

$parcel$export(module.exports, "issueTransitionOptInStatusResource", () => $cf959888902c771b$export$5fbcf4d7a6d9c477);
$parcel$export(module.exports, "useIssueTransitionLabsOptIn", () => $cf959888902c771b$export$bc11d4816053db5c);

var $5uXOq = parcelRequire("5uXOq");

var $c04PQ = parcelRequire("c04PQ");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


var $dO2g2 = parcelRequire("dO2g2");
/*
 * API Contract: https://hello.atlassian.net/wiki/spaces/JIE/pages/2983777277/Issue+Transition+Jira+Labs+Toggle+for+Legacy+Experience+Backend+API#API-Contract
 */ const $cf959888902c771b$var$fetchGetIssueTransitionOptInState = async ()=>(0, $eusud.performGetRequest)((0, $267ed65766cf1bd0$export$466b1c60da56c8ca));
const $cf959888902c771b$export$5fbcf4d7a6d9c477 = (0, $2M1hQ.createResource)({
    type: (0, $267ed65766cf1bd0$export$eb01e12fc3db65c0),
    getKey: ()=>(0, $267ed65766cf1bd0$export$a964df7bc15d81e),
    getData: async ()=>{
        let issueTransitionOptInStatus = null;
        const isModernIssueTransitionSRBCohort = (0, $4R6GH.fg)('issue-transition-customisation-for-srb') || (0, $c04PQ.isFedRamp)();
        const isModernITSRenderEnabled = (0, $4R6GH.fg)('render-modern-issue-transition') || (0, $c04PQ.isFedRamp)();
        if (!isModernITSRenderEnabled) return {
            issueTransitionOptInStatus: {
                isEnabled: false,
                expiryTime: -1
            }
        };
        if (isModernIssueTransitionSRBCohort) return {
            issueTransitionOptInStatus: {
                isEnabled: true
            }
        };
        try {
            issueTransitionOptInStatus = await $cf959888902c771b$var$fetchGetIssueTransitionOptInState();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === 404) (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'issueTransitionOptInStatusResource',
                    packageName: 'jiraRouterResourcesIssueTransitionLabsOptIn',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            issueTransitionOptInStatus: issueTransitionOptInStatus ?? (0, $dO2g2.default)()
        };
    },
    maxAge: Number.MAX_VALUE
});
const $cf959888902c771b$var$fetchModifyIssueTransitionOptInState = async (payload)=>(0, $eusud.performPutRequest)((0, $267ed65766cf1bd0$export$466b1c60da56c8ca), {
        body: JSON.stringify(payload)
    });
const $cf959888902c771b$export$bc11d4816053db5c = ()=>{
    const { data: data, loading: loadingGetResource, error: errorGetResource, update: update } = (0, $2YP9W.useResource)($cf959888902c771b$export$5fbcf4d7a6d9c477);
    const [issueTransitionLabsOptInState, setIssueTransitionOptInState] = (0, $5uXOq.useState)(()=>{
        if (data?.issueTransitionOptInStatus) return data.issueTransitionOptInStatus;
        return (0, $dO2g2.default)();
    });
    const [responseStatusGet, setResponseStatusGet] = (0, $5uXOq.useState)('not started');
    const [responseStatusPut, setResponseStatusPut] = (0, $5uXOq.useState)('not started');
    const updateIssueTransitionOptInStatus = (0, $5uXOq.useCallback)(async (updates)=>{
        let response = 'loading';
        setResponseStatusPut('loading');
        try {
            const updatedPreferences = await $cf959888902c771b$var$fetchModifyIssueTransitionOptInState(updates);
            setResponseStatusPut('success');
            update(()=>({
                    issueTransitionOptInStatus: updatedPreferences
                }));
            response = 'success';
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $jcw0u.default)({
                error: err,
                meta: {
                    id: 'issueTransitionOptInStatusUpdate',
                    packageName: 'jiraRouterResourcesIssueTransitionLabsOptIn',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            setResponseStatusPut('error');
            response = 'error';
        }
        return response;
    }, [
        update
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (loadingGetResource) {
            setResponseStatusGet('loading');
            return;
        }
        if (errorGetResource) {
            setResponseStatusGet('error');
            return;
        }
        if (data?.issueTransitionOptInStatus) {
            setResponseStatusGet('success');
            setIssueTransitionOptInState(data.issueTransitionOptInStatus);
        }
    }, [
        loadingGetResource,
        errorGetResource,
        data?.issueTransitionOptInStatus
    ]);
    return {
        stateGet: {
            responseStatus: responseStatusGet,
            state: issueTransitionLabsOptInState
        },
        stateUpdate: {
            responseStatus: responseStatusPut,
            setState: updateIssueTransitionOptInStatus
        }
    };
};

});
const $267ed65766cf1bd0$export$eb01e12fc3db65c0 = 'issue_transition_opt_in';
const $267ed65766cf1bd0$export$a964df7bc15d81e = 'issue_transition_labs_opt_in_status';
const $267ed65766cf1bd0$export$466b1c60da56c8ca = '/rest/greenhopper/1.0/profile/labs-panel/modern-its-visibility';
const $267ed65766cf1bd0$export$880a78695d76498e = 8;

parcelRegister("dO2g2", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fa107364a5021d3$export$2e2bcd8739ae039);

var $c04PQ = parcelRequire("c04PQ");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");
const $8fa107364a5021d3$var$getDefaultIssueTransitionLabsOptInState = ()=>{
    const isModernITSRenderEnabled = (0, $4R6GH.fg)('render-modern-issue-transition') || (0, $c04PQ.isFedRamp)();
    if (!isModernITSRenderEnabled) return {
        isEnabled: false,
        expiryTime: -1
    };
    const isModernIssueTransitionSRBCohort = (0, $4R6GH.fg)('issue-transition-customisation-for-srb') || (0, $c04PQ.isFedRamp)();
    if (isModernIssueTransitionSRBCohort) return {
        isEnabled: true
    };
    return (0, $6s1PB.expValEquals)('jira_issue_transition_screen_modernisation_toggle', 'value', 'BY_DEFAULT_USER_OPT_OUT') ? {
        isEnabled: false,
        expiryTime: -1
    } : {
        isEnabled: true
    };
};
var $8fa107364a5021d3$export$2e2bcd8739ae039 = $8fa107364a5021d3$var$getDefaultIssueTransitionLabsOptInState;

});


parcelRegister("kJQXA", function(module, exports) {

$parcel$export(module.exports, "navigationSidebarAutomationLegacyEnabledResource", () => $273ba0463e1e3cac$export$fa191d7d71460a98);

var $4Pf62 = parcelRequire("4Pf62");

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");

const $273ba0463e1e3cac$export$fa191d7d71460a98 = (0, $2M1hQ.createResource)({
    type: (0, $b830026e722fc8e6$export$fd4fc70ec71927d1),
    getKey: ({ query: query })=>`jsm-legacy-automation-enabled-${query.projectKey}`,
    getData: async (_, { tenantContext: { licensedProducts: licensedProducts } })=>{
        const defaultValue = {
            enabled: true
        };
        if (!licensedProducts || !licensedProducts[(0, $4Pf62.LICENSED_PRODUCTS).JIRA_SERVICEDESK]) return defaultValue;
        const { enabled: enabled } = await (0, $eusud.performGetRequest)('/rest/servicedesk/automation/1/legacy/state');
        return {
            enabled: enabled
        };
    },
    maxAge: Infinity
});

});
const $b830026e722fc8e6$export$fd4fc70ec71927d1 = 'AUTOMATION_IS_LEGACY_ENABLED';


parcelRegister("atU1t", function(module, exports) {

$parcel$export(module.exports, "navigationSidebarGlobalResource", () => $587727b78e9bd173$export$44e7ad3c66a3f25f);

var $02g8e = parcelRequire("02g8e");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");

const $587727b78e9bd173$export$44e7ad3c66a3f25f = (0, $2M1hQ.createResource)({
    type: (0, $f9d36ddc532997a4$export$fa5743fc6a1da5d8),
    getKey: ({ match: match, query: query })=>{
        // Refresh the data if the project key or id changes
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        return projectKey || projectId || '__state';
    },
    getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { baseUrl: baseUrl } = tenantContext;
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        const scope = {
            projectKey: projectKey,
            projectId: projectId
        };
        const response = await (0, $02g8e.fetchSidebarConfig)(baseUrl, scope, false);
        return {
            response: response,
            scope: scope
        };
    },
    maxAge: 300000
});

});
parcelRegister("02g8e", function(module, exports) {

$parcel$export(module.exports, "fetchSidebarConfig", () => $5da99daaa007f26b$export$d1d13c4b972a22f1);

var $2YZCu = parcelRequire("2YZCu");

var $7f4tk = parcelRequire("7f4tk");
const $5da99daaa007f26b$var$LOGGER_LOCATION = 'navigation-next.baskets.navigation.utils';

const $5da99daaa007f26b$var$fetchUsingProtobuf = async (url)=>{
    try {
        const fetchProtobuf = await (parcelRequire("dXOFN"));
        if (!fetchProtobuf) (0, $2YZCu.default).safeErrorWithoutCustomerData($5da99daaa007f26b$var$LOGGER_LOCATION, 'Error dynamically loading protobuf fetch function');
        return fetchProtobuf.default(url);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData($5da99daaa007f26b$var$LOGGER_LOCATION, 'Error fetching Sidebar Configuration protocol buffer message', err);
        throw err;
    }
};
const $5da99daaa007f26b$export$94e808b2557f52e = (baseUrl, requestQuery, version = '2', queryParams)=>{
    const { pageType: pageType, identifierValue: identifierValue, identifierType: identifierType, exclude: exclude } = requestQuery || {};
    const params = {
        exclude: [
            'webItems.reports',
            'webItems.home',
            'webItems.gin',
            exclude
        ].filter(Boolean).join(',')
    };
    let path = '';
    if (pageType && identifierValue != null) path = `${pageType}/${identifierValue}`;
    else if (identifierType === 'boardId' && identifierValue != null) path = `board/${identifierValue}`;
    else if (identifierValue != null) path = `project/${identifierValue}`;
    else {
        path = 'product';
        const { projectId: projectId, projectKey: projectKey } = requestQuery || {};
        // Connect apps rely on project context even for the global/product scoped webItems
        const projectIdOrKey = projectId || projectKey;
        if (projectIdOrKey) params.projectIdOrKey = projectIdOrKey;
    }
    const queryString = [
        new URLSearchParams(params).toString(),
        queryParams
    ].filter(Boolean).join('&');
    return `/rest/navigation/${version}/${path}?${queryString}`;
};
const $5da99daaa007f26b$export$d1d13c4b972a22f1 = async (baseUrl, requestQuery, isServer, queryParams)=>{
    if (isServer) {
        const protoUrl = $5da99daaa007f26b$export$94e808b2557f52e(baseUrl, requestQuery, '2.1', queryParams);
        return $5da99daaa007f26b$var$fetchUsingProtobuf(protoUrl);
    }
    const sidebarUrl = $5da99daaa007f26b$export$94e808b2557f52e(baseUrl, requestQuery, undefined, queryParams);
    return (0, $7f4tk.default)(sidebarUrl);
};

});
parcelRegister("dXOFN", function(module, exports) {

let $a2a817ae21745b94$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a2a817ae21745b94$var$load("5p0ab").then(()=>parcelRequire('g4I8Z'));

});


const $f9d36ddc532997a4$export$fa5743fc6a1da5d8 = 'NAVIGATION_SIDEBAR_GLOBAL';


parcelRegister("c34Wf", function(module, exports) {

$parcel$export(module.exports, "navigationUiStateResource", () => $976a0f933d5d0ba8$export$14c178691841b423);
// eslint-disable-next-line jira/import-whitelist

var $8QpSo = parcelRequire("8QpSo");

var $2M1hQ = parcelRequire("2M1hQ");

var $kJPyG = parcelRequire("kJPyG");

const $976a0f933d5d0ba8$var$getNavigationUiStateMemoized = (0, $8QpSo.default)((atlassianAccountId)=>(0, $kJPyG.getNavigationUiState)({
        tenantContext: {
            atlassianAccountId: atlassianAccountId
        }
    }));
const $976a0f933d5d0ba8$export$14c178691841b423 = (0, $2M1hQ.createResource)({
    type: 'RESOURCE_TYPE_NAVIGATION_UI',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>$976a0f933d5d0ba8$var$getNavigationUiStateMemoized(atlassianAccountId),
    maxAge: Infinity
});

});
parcelRegister("kJPyG", function(module, exports) {

$parcel$export(module.exports, "getNavigationUiState", () => $a5efaf793a61ef5e$export$29999268b070c9bd);

var $89SaW = parcelRequire("89SaW");


var $1yqku = parcelRequire("1yqku");
const $a5efaf793a61ef5e$export$29999268b070c9bd = async ({ tenantContext: tenantContext })=>{
    const { atlassianAccountId: accountId } = tenantContext;
    let uiState = await (0, $1yqku.queryLocalStorage)();
    if (uiState || !accountId) return uiState;
    try {
        uiState = await (0, $89SaW.getUserProperty)(accountId, (0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8));
        // @ts-expect-error - TS2345 - Argument of type 'UIControllerShape | undefined' is not assignable to parameter of type 'UIControllerShape'.
        (0, $1yqku.updateLocalStorageData)(uiState);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // Don't log the error on purpose. This is very frequent for some reason :(
    }
    return uiState;
};

});
const $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8 = 'navigation_next_ui_state';
const $2ed2f0cf8ecb933e$export$c63f561360bafed1 = 'navigation-next.providers.ui-state-cache-provider';

parcelRegister("1yqku", function(module, exports) {

$parcel$export(module.exports, "queryLocalStorage", () => $fa4273588466a1c1$export$e192dcb908272d5);
$parcel$export(module.exports, "updateLocalStorageData", () => $fa4273588466a1c1$export$ec13c725e067146a);

var $8Rkzz = parcelRequire("8Rkzz");

var $4R6GH = parcelRequire("4R6GH");

var $2YZCu = parcelRequire("2YZCu");

var $bSSG7 = parcelRequire("bSSG7");

const $fa4273588466a1c1$var$localStorageProvider = (0, $bSSG7.createLocalStorageProvider)('', false);
const $fa4273588466a1c1$export$e7db3fa51c63bc5c = ()=>{
    if (typeof window !== 'undefined' && typeof window.localStorage !== 'undefined') return window.localStorage;
    return {
        setItem: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        getItem: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    };
};
const $fa4273588466a1c1$var$queryLocalStorageSync = ()=>{
    const localStorage = $fa4273588466a1c1$export$e7db3fa51c63bc5c();
    const item = (0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $fa4273588466a1c1$var$localStorageProvider.get((0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8)) : localStorage.getItem((0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8));
    if (!false && item) try {
        return JSON.parse(item);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData((0, $2ed2f0cf8ecb933e$export$c63f561360bafed1), 'Fail to parse sync local storage data', e);
    }
};
const $fa4273588466a1c1$export$e192dcb908272d5 = ()=>new Promise((resolve)=>{
        const item = $fa4273588466a1c1$var$queryLocalStorageSync();
        resolve(item);
    });
const $fa4273588466a1c1$export$ec13c725e067146a = (data)=>{
    const localStorage = $fa4273588466a1c1$export$e7db3fa51c63bc5c();
    (0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $fa4273588466a1c1$var$localStorageProvider.set((0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8), JSON.stringify(data)) : localStorage.setItem((0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8), JSON.stringify(data));
};

});
parcelRegister("bSSG7", function(module, exports) {

$parcel$export(module.exports, "createLocalStorageProvider", () => $63804f80e89e547d$export$697e65b1658f821b);
$parcel$export(module.exports, "createLocalExpirableStorageProvider", () => $63804f80e89e547d$export$59acef2b3ab1df90);

var $gJBT6 = parcelRequire("gJBT6");

var $fNVZf = parcelRequire("fNVZf");

var $dEJQ9 = parcelRequire("dEJQ9");
const $63804f80e89e547d$export$697e65b1658f821b = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((appPrefix, shouldSerialize = true)=>(0, $fNVZf.createStorageProvider)((0, $fNVZf.WebStorageType).LocalStorage, appPrefix, (0, $dEJQ9.makeLocalStore)(), shouldSerialize));
const $63804f80e89e547d$export$59acef2b3ab1df90 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((appPrefix)=>{
    return (0, $fNVZf.createExpirableStorageProvider)((0, $fNVZf.WebStorageType).LocalStorage, appPrefix, (0, $dEJQ9.makeLocalExpirableStore)());
});

});
parcelRegister("fNVZf", function(module, exports) {

$parcel$export(module.exports, "plugins", () => $04caddce42518619$export$8b3ca321c77fdea6);
$parcel$export(module.exports, "WebStorageType", () => $04caddce42518619$export$259e3a861f28589b);
$parcel$export(module.exports, "createStorageProvider", () => $04caddce42518619$export$8441605555fbd60c);
$parcel$export(module.exports, "createExpirableStorageProvider", () => $04caddce42518619$export$b793a81cf479272a);

var $fKgem = parcelRequire("fKgem");

var $bHibm = parcelRequire("bHibm");

var $4R6GH = parcelRequire("4R6GH");

var $c7J1U = parcelRequire("c7J1U");
const $04caddce42518619$export$8b3ca321c77fdea6 = [
    (0, (/*@__PURE__*/$parcel$interopDefault($fKgem))),
    (0, $c7J1U.default)
];
const $04caddce42518619$export$259e3a861f28589b = {
    LocalStorage: 'LocalStorage',
    SessionStorage: 'SessionStorage'
};
const $04caddce42518619$export$8441605555fbd60c = (storageType, appPrefix = '', // eslint-disable-next-line @typescript-eslint/no-explicit-any
store, shouldSerialize = true)=>{
    const namespacedStore = store.namespace(appPrefix);
    const getKeyWithPrefix = (key)=>appPrefix?.trim().length ? `${appPrefix}.${key}` : key;
    const storageAPI = storageType === $04caddce42518619$export$259e3a861f28589b.LocalStorage ? (0, $bHibm.AtlBrowserStorageLocal) : (0, $bHibm.AtlBrowserStorageSession);
    const browserStorage = storageType === $04caddce42518619$export$259e3a861f28589b.LocalStorage ? globalThis.localStorage : globalThis.sessionStorage;
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        set: (key, value)=>{
            try {
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) {
                    const prefixedKey = getKeyWithPrefix(key);
                    const storageValue = shouldSerialize ? JSON.stringify(value) : value;
                    storageAPI.setItem(prefixedKey, storageValue);
                } else namespacedStore.set(key, value);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error setting item in storage:', err);
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setStrictlyNecessaryItem: (key, value)=>{
            try {
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) {
                    const prefixedKey = getKeyWithPrefix(key);
                    const storageValue = shouldSerialize ? JSON.stringify(value) : value;
                    storageAPI.setStrictlyNecessaryItem(prefixedKey, storageValue);
                } else // this has to be done when setStrictlyNecessaryItem comes into usage, and it should have a fallback when FG is turned off
                namespacedStore.set(key, value);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error setting item in storage:', err);
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        get: (key)=>{
            try {
                let item;
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) {
                    const prefixedKey = getKeyWithPrefix(key);
                    // When the feature flag is enabled
                    if (appPrefix?.trim().length) {
                        // Case 1: App prefix exists (all the existing usages of jira-browser-storage-providers had app prefix)
                        item = storageAPI.getItem(prefixedKey);
                        if (typeof item === 'undefined' || item === null) {
                            // Check old store when data not found in new storage
                            const itemFromOldStore = namespacedStore.get(key);
                            if (typeof itemFromOldStore !== 'undefined' && itemFromOldStore !== null) {
                                // Migrate data from old store to new storage
                                const stringValue = JSON.stringify(itemFromOldStore);
                                storageAPI.setItem(prefixedKey, stringValue);
                                return itemFromOldStore;
                            }
                        }
                        if (typeof item === 'string') // If data found in new storage, return it
                        return shouldSerialize ? JSON.parse(item) : item;
                    }
                    // Case 2: No app prefix
                    item = storageAPI.getItem(prefixedKey);
                    if (typeof item === 'undefined' || item === null) {
                        // Check browser's localStorage for the key
                        const itemFromNativeBrowserStorage = browserStorage?.getItem(key);
                        if (typeof itemFromNativeBrowserStorage !== 'undefined' && itemFromNativeBrowserStorage !== null) {
                            // Migrate data to new storage
                            storageAPI.setItem(prefixedKey, itemFromNativeBrowserStorage);
                            return itemFromNativeBrowserStorage;
                        }
                    }
                    if (typeof item === 'string') // If data found in new storage, return it
                    return shouldSerialize ? JSON.parse(item) : item;
                } else return namespacedStore.get(key);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error getting item from storage:', err);
            }
        },
        remove: (key)=>{
            try {
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) {
                    const prefixedKey = getKeyWithPrefix(key);
                    storageAPI.removeItem(prefixedKey); // remove data from new store
                    namespacedStore.remove(key); // remove data from old store as well
                } else namespacedStore.remove(key);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error removing item from storage:', err);
            }
        },
        // Clears the complete storage
        clearAll: ()=>{
            try {
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) {
                    storageAPI.clear();
                    // clean up old keys too
                    namespacedStore.clearAll();
                } else namespacedStore.clearAll();
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error clearing storage:', err);
            }
        },
        // Clears all the keys specific to the appPrefix
        clearStorageValues: ()=>{
            if (!appPrefix) throw Error('appPrefix is necessary to access clearStorageValues method.');
            try {
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) for(let i = 0; i < storageAPI.length(); i++){
                    const key = storageAPI.key(i);
                    if (key && key.startsWith(`${appPrefix}.`)) {
                        storageAPI.removeItem(key);
                        i--;
                    }
                }
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error clearing storage:', err);
            }
        },
        length: ()=>{
            try {
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) return storageAPI.length();
                return browserStorage?.length || 0;
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error getting storage length:', err);
                return 0;
            }
        },
        // unstable use it only if its absolutely necessary
        getPrefixedKeysLength: ()=>{
            if (!appPrefix) throw Error('appPrefix is necessary to access getNamespaceKeysLength method.');
            try {
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) {
                    // For browser storage API
                    let count = 0;
                    const totalLength = storageAPI.length() || 0;
                    for(let i = 0; i < totalLength; i++){
                        const key = storageAPI.key(i);
                        if (key && key.startsWith(`${appPrefix}.`)) count++;
                    }
                    return count;
                }
                // For store library using native storage
                let count = 0;
                const totalLength = browserStorage?.length || 0;
                const namespacePrefix = `__storejs_${appPrefix}_`;
                for(let i = 0; i < totalLength; i++){
                    const key = browserStorage?.key(i);
                    if (key && key.startsWith(namespacePrefix)) count++;
                }
                return count;
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Error counting namespace keys:', error);
                return 0;
            }
        }
    };
};
const $04caddce42518619$export$b793a81cf479272a = (storageType, appPrefix, // eslint-disable-next-line @typescript-eslint/no-explicit-any
store)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const namespacedStore = store.namespace(appPrefix);
    const getKeyWithPrefix = (key)=>`${appPrefix}.${key}`;
    const storageAPI = storageType === $04caddce42518619$export$259e3a861f28589b.LocalStorage ? (0, $bHibm.AtlBrowserStorageLocal) : (0, $bHibm.AtlBrowserStorageSession);
    const browserStorage = storageType === $04caddce42518619$export$259e3a861f28589b.LocalStorage ? globalThis.localStorage : globalThis.sessionStorage;
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        set: (key, value, expiration)=>{
            try {
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) {
                    const prefixedKey = getKeyWithPrefix(key);
                    const item = {
                        value: value,
                        expiration: expiration
                    };
                    const serializedValue = JSON.stringify(item);
                    storageAPI.setItem(prefixedKey, serializedValue);
                } else namespacedStore.set(key, value, expiration);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error setting item with key=${key}:`, error);
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setStrictlyNecessaryItem: (key, value, expiration)=>{
            try {
                const prefixedKey = getKeyWithPrefix(key);
                const item = {
                    value: value,
                    expiration: expiration
                };
                const serializedValue = JSON.stringify(item);
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) storageAPI.setStrictlyNecessaryItem(prefixedKey, serializedValue);
                else // this has to be done when setStrictlyNecessaryItem comes into usage, and it should have a fallback when FG is turned off
                namespacedStore.set(key, value, expiration);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error setting item with key=${key}:`, error);
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        get: (key)=>{
            try {
                let itemStr;
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) {
                    const prefixedKey = getKeyWithPrefix(key);
                    itemStr = storageAPI.getItem(prefixedKey);
                    if (!itemStr) {
                        // check in the old store
                        const itemFromOldStore = namespacedStore.get(key);
                        if (typeof itemFromOldStore !== 'undefined' && itemFromOldStore !== null) {
                            const item = {
                                value: itemFromOldStore,
                                expiration: namespacedStore.getExpiration(key)
                            };
                            storageAPI.setItem(prefixedKey, JSON.stringify(item)); // migrate to new store with new key
                            return itemFromOldStore;
                        }
                    } else {
                        // check if the item is expired
                        const item = JSON.parse(itemStr);
                        if (item.expiration && item.expiration < Date.now()) {
                            storageAPI.removeItem(prefixedKey);
                            return;
                        }
                        return item.value;
                    }
                } else {
                    itemStr = namespacedStore.get(key);
                    return itemStr;
                }
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error getting item with key=${key}:`, error);
            }
        },
        getExpiration: (key)=>{
            try {
                const prefixedKey = getKeyWithPrefix(key);
                let itemStr;
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) {
                    itemStr = storageAPI.getItem(prefixedKey);
                    if (!itemStr) {
                        // check in the old store
                        const itemFromOldStore = namespacedStore.get(key);
                        if (typeof itemFromOldStore !== 'undefined' && itemFromOldStore !== null) {
                            const expiration = namespacedStore.getExpiration(key);
                            const item = {
                                value: itemFromOldStore,
                                expiration: expiration
                            };
                            storageAPI.setItem(prefixedKey, JSON.stringify(item)); // migrate to new store with new key
                            return expiration;
                        }
                    } else {
                        // check if the item is expired
                        const item = JSON.parse(itemStr);
                        if (item.expiration && item.expiration < Date.now()) {
                            storageAPI.removeItem(prefixedKey);
                            return undefined;
                        }
                        return item.expiration;
                    }
                } else return namespacedStore.getExpiration(key);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error getting expiration for item with key=${key}:`, error);
                return undefined;
            }
        },
        remove: (key)=>{
            try {
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) {
                    const prefixedKey = getKeyWithPrefix(key);
                    storageAPI.removeItem(prefixedKey);
                    namespacedStore.remove(key);
                } else namespacedStore.remove(key);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error removing item with key=${key}:`, error);
            }
        },
        removeExpiredKeys: ()=>{
            try {
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) {
                    for(let i = 0; i < storageAPI.length(); i++){
                        const key = storageAPI.key(i);
                        if (key && key.startsWith(`${appPrefix}.`)) {
                            const itemStr = storageAPI.getItem(key);
                            if (itemStr) {
                                const item = JSON.parse(itemStr);
                                if (item.expiration && item.expiration < Date.now()) {
                                    storageAPI.removeItem(key);
                                    i--;
                                }
                            }
                        }
                    }
                    namespacedStore.removeExpiredKeys(); // clean up old keys too
                } else namespacedStore.removeExpiredKeys();
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Error removing expired keys:', error);
            }
        },
        // Clears all the keys specific to the appPrefix
        clearStorageValues: ()=>{
            try {
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) for(let i = 0; i < storageAPI.length(); i++){
                    const key = storageAPI.key(i);
                    if (key && key.startsWith(`${appPrefix}.`)) {
                        storageAPI.removeItem(key);
                        i--;
                    }
                }
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error clearing storage values:', err);
            }
        },
        // Clears the complete storage
        clearAll: ()=>{
            try {
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) {
                    storageAPI.clear();
                    // clean up old keys too
                    namespacedStore.clearAll();
                } else namespacedStore.clearAll();
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error clearing storage:', err);
            }
        },
        length: ()=>{
            try {
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) return storageAPI.length();
                return browserStorage?.length || 0;
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error getting storage length:', err);
                return 0;
            }
        },
        // unstable use it only if its absolutely necessary
        getPrefixedKeysLength: ()=>{
            try {
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) {
                    // For browser storage API
                    let count = 0;
                    const totalLength = storageAPI.length() || 0;
                    for(let i = 0; i < totalLength; i++){
                        const key = storageAPI.key(i);
                        if (key && key.startsWith(`${appPrefix}.`)) count++;
                    }
                    return count;
                }
                // For store library using native storage
                let count = 0;
                const totalLength = browserStorage?.length || 0;
                const namespacePrefix = `__storejs_${appPrefix}_`;
                for(let i = 0; i < totalLength; i++){
                    const key = browserStorage?.key(i);
                    if (key && key.startsWith(namespacePrefix)) count++;
                }
                return count;
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Error counting namespace keys:', error);
                return 0;
            }
        }
    };
};

});
parcelRegister("c7J1U", function(module, exports) {

$parcel$export(module.exports, "default", () => $99d922a6a243a194$export$2e2bcd8739ae039);

var $jcw0u = parcelRequire("jcw0u");

var $cuNKJ = parcelRequire("cuNKJ");
/**
 * Enhances storage operations with automated cleanup capabilities. This includes tracking
 * item timestamps for age-based cleanup, handling storage limits by removing older items,
 * and providing utility functions for managing storage contents. Designed to ensure
 * efficient use of storage space without manual intervention.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $99d922a6a243a194$var$cleanUpPlugin() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const timestamps = self.createStore(self.storage, null, self._namespacePrefix + (0, $cuNKJ.NAMESPACE));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function set(superFn, key, val) {
        try {
            if (!self.hasNamespace((0, $cuNKJ.NAMESPACE))) timestamps.set(key, Date.now());
            superFn();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            // storage is full. Relevant only for localStorage
            if (e.code === (0, $cuNKJ.LOCAL_STORAGE_FULL_ERROR_CODE) || e.code === (0, $cuNKJ.LOCAL_STORAGE_FULL_FF_ERROR_CODE)) {
                // 22 - the correct code most browsers use
                // 1014 - Firefox's code
                (0, $jcw0u.default)({
                    meta: {
                        id: 'browserLocalStorageFullError',
                        packageName: 'jiraBrowserStorageProviders',
                        teamName: 'magma'
                    },
                    attributes: {
                        namespace: self._namespacePrefix
                    },
                    error: e,
                    skipSentry: true
                });
                if (self.cleanWhenFull()) self.set(superFn, key, val);
            } else {
                (0, $jcw0u.default)({
                    meta: {
                        id: 'storageCleanupPluginError',
                        packageName: 'jiraBrowserStorageProviders',
                        teamName: 'magma'
                    },
                    attributes: {
                        isLegacyFunction: false
                    },
                    error: e
                });
                throw e;
            }
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function remove(superFn, key) {
        if (!self.hasNamespace((0, $cuNKJ.NAMESPACE))) timestamps.remove(key);
        return superFn();
    }
    // quite stupid way of getting totals, but current library supports only this.each()
    function getTotalCount() {
        let count = 0;
        self.each(()=>{
            count += 1;
        });
        return count;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function cleanWhenFull(superFn, minAge = (0, $cuNKJ.FOUR_WEEKS)) {
        const currTime = Date.now();
        const numKeysBefore = self.getTotalCount();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        self.each((_value, key)=>{
            // return correct value for current collection
            // and return null for timestamps collection
            const created = !self.hasNamespace((0, $cuNKJ.NAMESPACE)) ? timestamps.get(key) : null;
            if (typeof created === 'number' && currTime - created > minAge) self.remove(key);
        });
        const itemsRemovedCount = numKeysBefore - self.getTotalCount();
        if (!itemsRemovedCount && minAge - (0, $cuNKJ.ONE_WEEK) >= (0, $cuNKJ.ONE_WEEK)) return self.cleanWhenFull(minAge - (0, $cuNKJ.ONE_WEEK));
        return itemsRemovedCount === 0;
    }
    return {
        set: set,
        remove: remove,
        cleanWhenFull: cleanWhenFull,
        getTotalCount: getTotalCount
    };
}
var $99d922a6a243a194$export$2e2bcd8739ae039 = $99d922a6a243a194$var$cleanUpPlugin;

});
parcelRegister("cuNKJ", function(module, exports) {

$parcel$export(module.exports, "NAMESPACE", () => $d21613ddd27d5bbf$export$6aad947bda0f3f46);
$parcel$export(module.exports, "ONE_WEEK", () => $d21613ddd27d5bbf$export$8187f416f1cc43d8);
$parcel$export(module.exports, "FOUR_WEEKS", () => $d21613ddd27d5bbf$export$6e952fa7d47190cf);
$parcel$export(module.exports, "LOCAL_STORAGE_FULL_ERROR_CODE", () => $d21613ddd27d5bbf$export$da99ebca8f453abd);
$parcel$export(module.exports, "LOCAL_STORAGE_FULL_FF_ERROR_CODE", () => $d21613ddd27d5bbf$export$ea28dfd9333cda2d);
const $d21613ddd27d5bbf$export$6aad947bda0f3f46 = 'timestamps';
const $d21613ddd27d5bbf$export$8187f416f1cc43d8 = 604800000;
const $d21613ddd27d5bbf$export$6e952fa7d47190cf = 4 * $d21613ddd27d5bbf$export$8187f416f1cc43d8;
const $d21613ddd27d5bbf$export$da99ebca8f453abd = 22;
const $d21613ddd27d5bbf$export$ea28dfd9333cda2d = 1014;

});



parcelRegister("dEJQ9", function(module, exports) {

$parcel$export(module.exports, "makeLocalStore", () => $dcae70c06981fc99$export$b2631085fe8db7af);
$parcel$export(module.exports, "isLocalStorageAvailable", () => $dcae70c06981fc99$export$117a30df0da2af20);
$parcel$export(module.exports, "makeLocalExpirableStore", () => $dcae70c06981fc99$export$cf816b43e73de947);

var $fKgem = parcelRequire("fKgem");

var $kzObv = parcelRequire("kzObv");

var $c4CII = parcelRequire("c4CII");

var $4Zgux = parcelRequire("4Zgux");

var $2NjNT = parcelRequire("2NjNT");

var $fNVZf = parcelRequire("fNVZf");
const $dcae70c06981fc99$export$b2631085fe8db7af = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($c4CII))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($4Zgux))),
        (0, (/*@__PURE__*/$parcel$interopDefault($2NjNT)))
    ], (0, $fNVZf.plugins));
const $dcae70c06981fc99$export$117a30df0da2af20 = ()=>typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
const $dcae70c06981fc99$export$cf816b43e73de947 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($c4CII))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($4Zgux))),
        (0, (/*@__PURE__*/$parcel$interopDefault($2NjNT)))
    ], [
        (0, (/*@__PURE__*/$parcel$interopDefault($fKgem))),
        (0, (/*@__PURE__*/$parcel$interopDefault($kzObv)))
    ]);

});





parcelRegister("eOlBz", function(module, exports) {

$parcel$export(module.exports, "newIssueViewTransitionLockInStatusResource", () => $4e2e5fcdbf62dfaf$export$babbf5bfbc4d268c);
$parcel$export(module.exports, "DEFAULT_TO_OLD_ISSUE_VIEW", () => $4e2e5fcdbf62dfaf$export$f269c0bf10ad77e2);
$parcel$export(module.exports, "useNewIssueViewLockedInStatus", () => $4e2e5fcdbf62dfaf$export$3b09097f2a423abd);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


const $4e2e5fcdbf62dfaf$export$babbf5bfbc4d268c = (0, $2M1hQ.createResource)({
    type: (0, $103a13dfd187b85c$export$fdb92aeacda42553),
    getKey: ()=>'newIssueViewTransitionLockingStatus',
    getDataLoader: ()=>(parcelRequire("1Xolj")),
    maxAge: Number.MAX_VALUE
});
const $4e2e5fcdbf62dfaf$export$7a0204710d322de6 = 'LOCK_IN_NEW_ISSUE_VIEW';
const $4e2e5fcdbf62dfaf$export$83f9ac2d887bd06a = 'DEFAULT_TO_NEW_ISSUE_VIEW';
const $4e2e5fcdbf62dfaf$export$f269c0bf10ad77e2 = 'DEFAULT_TO_OLD_ISSUE_VIEW';
const $4e2e5fcdbf62dfaf$export$3b09097f2a423abd = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $2YP9W.useResource)($4e2e5fcdbf62dfaf$export$babbf5bfbc4d268c);

});
const $103a13dfd187b85c$export$fdb92aeacda42553 = 'NEW_ISSUE_VIEW_LOCK_IN_STATUS';

parcelRegister("1Xolj", function(module, exports) {

let $16ce2f1b94b77a88$var$load = (parcelRequire("28QjX"))(4);
module.exports = $16ce2f1b94b77a88$var$load("lAOYP").then(()=>parcelRequire('2RVA3'));

});


parcelRegister("3X1Xr", function(module, exports) {

$parcel$export(module.exports, "persistentIssueCreateModalViewResource", () => $950f2f2a5a65ba3f$export$266a039a005e8314);

var $2M1hQ = parcelRequire("2M1hQ");


const $950f2f2a5a65ba3f$export$266a039a005e8314 = (0, $2M1hQ.createResource)({
    type: (0, $fa76c7a777da2375$export$f658cfd591eb583e),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("9Rsyb")),
    maxAge: Number.MAX_VALUE
});

});
const $fa76c7a777da2375$export$15187a597cef02df = 'jira.user.gic.persistent.modal.view.state';
const $fa76c7a777da2375$export$8977f91a75d8d265 = 'jira.user.gic.mini.modal.discoverability';
const $fa76c7a777da2375$export$f658cfd591eb583e = 'RESOURCE_PERSISTENT_ISSUE_CREATE_MODAL_VIEW';

parcelRegister("9Rsyb", function(module, exports) {

let $72df35ceb79a1fab$var$load = (parcelRequire("28QjX"))(4);
module.exports = $72df35ceb79a1fab$var$load("3zoIf").then(()=>parcelRequire('8FYIq'));

});


parcelRegister("dxCvy", function(module, exports) {

$parcel$export(module.exports, "projectContextResource", () => $fb0493b5a465ed74$export$27ad0d75c619be68);
$parcel$export(module.exports, "projectContextResourceWithCache", () => $fb0493b5a465ed74$export$d75816e37af81473);

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");


const $fb0493b5a465ed74$var$getDataLoader = ()=>(parcelRequire("jRjO9"));
const $fb0493b5a465ed74$export$27ad0d75c619be68 = (0, $2M1hQ.createResource)({
    type: (0, $0f463a88567f1621$export$80a60a092d9ab81),
    getKey: (matchedRoute)=>(0, $1nb22.getProjectIdOrKey)(matchedRoute.match, matchedRoute.query),
    getDataLoader: $fb0493b5a465ed74$var$getDataLoader,
    maxAge: 1800000
});
const $fb0493b5a465ed74$export$d75816e37af81473 = $fb0493b5a465ed74$export$27ad0d75c619be68;

});
const $0f463a88567f1621$export$80a60a092d9ab81 = 'PROJECT_CONTEXT';

parcelRegister("jRjO9", function(module, exports) {

let $e75254fb7ab94c74$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e75254fb7ab94c74$var$load("cBAfA").then(()=>parcelRequire('fsLhR'));

});


parcelRegister("4dc0x", function(module, exports) {

$parcel$export(module.exports, "fetchSiteTraitsResource", () => $6bcb8e2c3d1b4192$export$379923e7c903a55d);

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");

var $3HwlS = parcelRequire("3HwlS");

var $gNStA = parcelRequire("gNStA");

var $2M1hQ = parcelRequire("2M1hQ");

var $e5wyW = parcelRequire("e5wyW");

var $jX0pr = parcelRequire("jX0pr");


const $6bcb8e2c3d1b4192$var$getDataOld = async (_, { tenantContext: tenantContext })=>{
    try {
        if (tenantContext.isAnonymous) return null;
        const cloudId = tenantContext.cloudId;
        const ssrUrl = `/api/v3/personalization/site/${cloudId}`;
        const clientUrl = `/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
        const response = false ? await (0, $eusud.performGetRequest)(ssrUrl, {
            headers: {
                'x-ssr-service-name': 'tap-delivery'
            }
        }) : await (0, $eusud.performGetRequest)(clientUrl);
        if (response?.attributes) return response.attributes;
        return null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: (0, $ecc0251f1d9f8566$export$7f111648ca05f056),
                packageName: (0, $2ffc5f2215c16253$export$b8b9d90f9e5bd72b)
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};
const $6bcb8e2c3d1b4192$var$getDataNew = async (_, { tenantContext: tenantContext })=>{
    try {
        if (tenantContext.isAnonymous) return null;
        const cloudId = tenantContext.cloudId;
        const ssrUrl = `/api/v3/personalization/site/${cloudId}`;
        const response = false ? (await (0, $eusud.performGetRequest)(ssrUrl, {
            headers: {
                'x-ssr-service-name': 'tap-delivery'
            }
        }))?.attributes : await (0, $jX0pr.memoizedFetchSitePersonalization)({
            cloudId: cloudId
        });
        if (response) return response;
        return null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: (0, $ecc0251f1d9f8566$export$7f111648ca05f056),
                packageName: (0, $2ffc5f2215c16253$export$b8b9d90f9e5bd72b)
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};
const $6bcb8e2c3d1b4192$export$379923e7c903a55d = (0, $gNStA.resourceWithCondition2)(()=>(0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('blu-3929-sidebar-menu-recommended'), (0, $2M1hQ.createResource)({
    type: (0, $ecc0251f1d9f8566$export$6f0555de4f60e84e),
    getKey: ()=>(0, $ecc0251f1d9f8566$export$7e7d7930e22ba39f),
    getData: (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('site-trait-iv-llc-unnecessary-api'), $6bcb8e2c3d1b4192$var$getDataNew, $6bcb8e2c3d1b4192$var$getDataOld),
    maxAge: Number.MAX_VALUE
}));

});
parcelRegister("jX0pr", function(module, exports) {

$parcel$export(module.exports, "memoizedFetchSitePersonalization", () => $7b32fa3ce5d65e32$export$671fb03be30194c3);
$parcel$export(module.exports, "useSitePersonalization", () => $7b32fa3ce5d65e32$export$58982988039b926f);

var $8QpSo = parcelRequire("8QpSo");

var $ld2hZ = parcelRequire("ld2hZ");

var $7f4tk = parcelRequire("7f4tk");
const $7b32fa3ce5d65e32$var$getPersonalizationSiteTraitsUrl = (cloudId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
const $7b32fa3ce5d65e32$export$ddf4964d2a406b6a = async ({ cloudId: cloudId })=>{
    if (!cloudId) throw new Error('empty cloudId');
    const { attributes: attributes } = await (0, $7f4tk.default)($7b32fa3ce5d65e32$var$getPersonalizationSiteTraitsUrl(cloudId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true'
        }
    });
    return attributes;
};
const $7b32fa3ce5d65e32$export$671fb03be30194c3 = (0, $8QpSo.default)($7b32fa3ce5d65e32$export$ddf4964d2a406b6a, ([{ cloudId: newCloudId }], [{ cloudId: lastCloudId }])=>newCloudId === lastCloudId);
const $7b32fa3ce5d65e32$export$58982988039b926f = ()=>(0, $ld2hZ.useService)($7b32fa3ce5d65e32$export$671fb03be30194c3);

});
parcelRegister("ld2hZ", function(module, exports) {

$parcel$export(module.exports, "useService", () => $b3ad55f76ff82cb6$export$6de4685a6c88b4e9);
$parcel$export(module.exports, "useLoadingStatusService", () => $b3ad55f76ff82cb6$export$c963713a27525aaf);

var $5uXOq = parcelRequire("5uXOq");
const $b3ad55f76ff82cb6$export$6de4685a6c88b4e9 = (request, initialState = {})=>{
    const [state, setState] = (0, $5uXOq.useState)({
        loading: false,
        data: undefined,
        error: undefined,
        ...initialState
    });
    const fetch = (0, $5uXOq.useCallback)(async (requestData)=>{
        setState({
            loading: true,
            error: undefined,
            data: undefined
        });
        try {
            const data = await request(requestData);
            setState({
                loading: false,
                error: undefined,
                data: data
            });
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                loading: false,
                error: error,
                data: undefined
            });
            return undefined;
        }
    }, [
        request
    ]);
    return {
        ...state,
        fetch: fetch
    };
};
const $b3ad55f76ff82cb6$export$c963713a27525aaf = (request, initialState = {})=>{
    const [loadingStatus, setLoadingStatus] = (0, $5uXOq.useState)('idle');
    const { data: data, loading: loading, error: error, fetch: fetch } = $b3ad55f76ff82cb6$export$6de4685a6c88b4e9(request, initialState);
    (0, $5uXOq.useEffect)(()=>{
        if (loading) setLoadingStatus('started');
        else if (error) setLoadingStatus('error');
        else if (data) setLoadingStatus('success');
    }, [
        data,
        loading,
        error
    ]);
    return {
        data: data,
        loadingStatus: loadingStatus,
        error: error,
        fetch: fetch
    };
};

});


const $2ffc5f2215c16253$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesGrowthRecommendations';

const $ecc0251f1d9f8566$export$6f0555de4f60e84e = 'RESOURCE_TYPE_RECOMMENDATIONS_FETCH_SITE_TRAITS';
const $ecc0251f1d9f8566$export$7e7d7930e22ba39f = 'recommendations-fetch-site-traits-resource-key';
const $ecc0251f1d9f8566$export$7f111648ca05f056 = 'useResource.fetchRecommendationsSiteTraits';


parcelRegister("51Yl2", function(module, exports) {

$parcel$export(module.exports, "fetchUserTraitsResource", () => $7ddcc0e078ed27cf$export$d5198d02e9089545);

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");

var $3HwlS = parcelRequire("3HwlS");

var $gNStA = parcelRequire("gNStA");

var $2M1hQ = parcelRequire("2M1hQ");

var $8ilPk = parcelRequire("8ilPk");


const $7ddcc0e078ed27cf$var$getData = async (_, { tenantContext: tenantContext })=>{
    try {
        if (tenantContext.isAnonymous) return null;
        const accountId = tenantContext.atlassianAccountId ?? '';
        const cloudId = tenantContext.cloudId;
        const ssrUrl = `/api/v3/personalization/site/${cloudId}/user/${accountId}`;
        const response = false ? (await (0, $eusud.performGetRequest)(ssrUrl, {
            headers: {
                'x-ssr-service-name': 'tap-delivery'
            }
        }))?.attributes : await (0, $8ilPk.memoizedFetchSiteUserPersonalization)({
            cloudId: cloudId,
            userId: accountId
        });
        if (response) return response;
        return null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: (0, $e07bc74223fe458d$export$7f111648ca05f056),
                packageName: (0, $2ffc5f2215c16253$export$b8b9d90f9e5bd72b)
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};
const $7ddcc0e078ed27cf$export$d5198d02e9089545 = (0, $gNStA.resourceWithCondition2)(()=>(0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('blu-3929-sidebar-menu-recommended'), (0, $2M1hQ.createResource)({
    type: (0, $e07bc74223fe458d$export$6f0555de4f60e84e),
    getKey: ()=>(0, $e07bc74223fe458d$export$7e7d7930e22ba39f),
    getData: $7ddcc0e078ed27cf$var$getData,
    maxAge: Number.MAX_VALUE
}));

});
parcelRegister("8ilPk", function(module, exports) {

$parcel$export(module.exports, "memoizedFetchSiteUserPersonalization", () => $4ab23cf8c5a935d6$export$de93ec54b11be450);
$parcel$export(module.exports, "useSiteUserPersonalization", () => $4ab23cf8c5a935d6$export$8dc79ff315095801);

var $8QpSo = parcelRequire("8QpSo");

var $ld2hZ = parcelRequire("ld2hZ");

var $7f4tk = parcelRequire("7f4tk");
const $4ab23cf8c5a935d6$var$getPersonalizationSiteUserTraitsUrl = (cloudId, userId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`;
const $4ab23cf8c5a935d6$export$8f40704723ec6690 = async ({ cloudId: cloudId, userId: userId })=>{
    if (!cloudId) throw new Error('empty cloudId');
    if (!userId) throw new Error('empty userId');
    const { attributes: attributes } = await (0, $7f4tk.default)($4ab23cf8c5a935d6$var$getPersonalizationSiteUserTraitsUrl(cloudId, userId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true'
        }
    });
    return attributes;
};
const $4ab23cf8c5a935d6$export$de93ec54b11be450 = (0, $8QpSo.default)($4ab23cf8c5a935d6$export$8f40704723ec6690, ([{ cloudId: newCloudId, userId: newUserId }], [{ cloudId: lastCloudId, userId: lastUserId }])=>newCloudId === lastCloudId && newUserId === lastUserId);
const $4ab23cf8c5a935d6$export$8dc79ff315095801 = ()=>(0, $ld2hZ.useService)($4ab23cf8c5a935d6$export$de93ec54b11be450);

});

const $e07bc74223fe458d$export$6f0555de4f60e84e = 'RESOURCE_TYPE_RECOMMENDATIONS_FETCH_USER_TRAITS';
const $e07bc74223fe458d$export$7e7d7930e22ba39f = 'recommendations-fetch-traits-resource-key';
const $e07bc74223fe458d$export$7f111648ca05f056 = 'useResource.fetchRecommendationsUserTraits';


parcelRegister("lXNZG", function(module, exports) {

$parcel$export(module.exports, "jpdRecommendationDismissedResource", () => $5630a429b63403f9$export$5db7c4562b672f52);

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");

var $3HwlS = parcelRequire("3HwlS");

var $gNStA = parcelRequire("gNStA");

var $2M1hQ = parcelRequire("2M1hQ");


const $5630a429b63403f9$export$5db7c4562b672f52 = (0, $gNStA.resourceWithCondition2)(()=>(0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('blu-3929-sidebar-menu-recommended'), (0, $2M1hQ.createResource)({
    type: (0, $2a8d22514dc25dbd$export$6f0555de4f60e84e),
    getKey: ()=>(0, $2a8d22514dc25dbd$export$7e7d7930e22ba39f),
    getData: async (_, { tenantContext: tenantContext })=>{
        try {
            if (tenantContext.isAnonymous) return {
                hasDismissed: true
            };
            const accountId = tenantContext.atlassianAccountId;
            const response = await (0, $eusud.performGetRequest)(`/rest/api/latest/user/properties/JpdRecommendationDismissed?accountId=${accountId}`);
            return {
                hasDismissed: response?.value ?? false
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const initialValueNeverSet = error.statusCode === 404;
            if (initialValueNeverSet) /**
					 * If the user has never set the preference, they have never dismissed.
					 */ return {
                hasDismissed: false
            };
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: (0, $2a8d22514dc25dbd$export$7f111648ca05f056),
                    packageName: (0, $2ffc5f2215c16253$export$b8b9d90f9e5bd72b)
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        /* on error return true - this ensures we don't show the recommendation if we don't know if they have dismissed */ return {
            hasDismissed: true
        };
    },
    maxAge: Number.MAX_VALUE
}));

});
const $2a8d22514dc25dbd$export$6f0555de4f60e84e = 'RESOURCE_TYPE_RECOMMENDATIONS_DISMISSED_JPD';
const $2a8d22514dc25dbd$export$7e7d7930e22ba39f = 'recommendations-dismissed-jpd-resource-key';
const $2a8d22514dc25dbd$export$7f111648ca05f056 = 'useResource.fetchRecommendationsDismissedJpd';


parcelRegister("kkNtb", function(module, exports) {

$parcel$export(module.exports, "rovoEntitlementResource", () => $10274390833bf523$export$a0974cf24d16bc5d);
$parcel$export(module.exports, "useRovoEntitlementResource", () => $10274390833bf523$export$b9cee3799212b85a);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");

const $10274390833bf523$var$RESOURCE_TYPE_ROVO_ENTITLEMENT = 'ROVO_ENTITLEMENT';
const $10274390833bf523$var$getRovoEnabledBasedOnExperiment = ({ isRovoEnabled: isRovoEnabled, isRovoLLMEnabled: isRovoLLMEnabled })=>{
    // if Rovo is not enabled, we don't need to check the experiment
    if (!isRovoEnabled) return {
        isRovoEnabled: isRovoEnabled,
        isRovoLLMEnabled: isRovoLLMEnabled
    };
    // If a user is in the Control cohort we're overriding the entitlement check with false to NOT serve Rovo experience.
    // Test cohort: users who get the new Rovo experience -> do NOT override the TCS entitlement.
    // Control cohort: users who get the legacy experience (the baseline) -> override the TCS entitlement with false.
    if ((0, $6s1PB.expValEquals)('rovo_team25_rollout_performance_exp', 'cohort', 'control', 'test')) return {
        isRovoEnabled: false,
        isRovoLLMEnabled: false
    };
    // A repeat of the above as a second expeirmenet
    // Tenants should only be in one or the other, controlled by the targetting gate
    if ((0, $6s1PB.expValEquals)('rovo_team25_rollout_perf_b3a_exp', 'cohort', 'control', 'test')) return {
        isRovoEnabled: false,
        isRovoLLMEnabled: false
    };
    return {
        isRovoEnabled: isRovoEnabled,
        isRovoLLMEnabled: isRovoLLMEnabled
    };
};
const $10274390833bf523$var$fetchRovoEntitlement = async (cloudId)=>{
    try {
        const response = await (0, $eusud.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $34f68d752b7fdd6c$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId,
                    shouldShowRovoLLMEnabled: (0, $4R6GH.fg)('rovo_use_rovo_llm_enabled_check')
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        // handle GraphQL errors
        if (response.errors) (0, $jcw0u.default)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRouterResourcesRovoEntitlement',
                teamName: 'ai-mate'
            },
            error: new Error(`RovoEntitlement Error. ${response.errors.map((error)=>error.message).join('; ')}; IsDataEmpty=${response.data?.jira === null || response.data?.jira === undefined}`),
            sendToPrivacyUnsafeSplunk: true
        });
        const isRovoEnabled = response.data?.jira?.isRovoEnabled ?? null;
        // defaulting to isRovoEnabled if the feature flag is not enabled
        const isRovoLLMEnabled = (0, $4R6GH.fg)('rovo_use_rovo_llm_enabled_check') ? response.data?.jira_isRovoLLMEnabled ?? null : isRovoEnabled;
        return $10274390833bf523$var$getRovoEnabledBasedOnExperiment({
            isRovoEnabled: isRovoEnabled,
            isRovoLLMEnabled: isRovoLLMEnabled
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRouterResourcesRovoEntitlement',
                teamName: 'ai-mate'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return {
        isRovoEnabled: null,
        isRovoLLMEnabled: undefined
    };
};
const $10274390833bf523$export$a0974cf24d16bc5d = (0, $2M1hQ.createResource)({
    type: $10274390833bf523$var$RESOURCE_TYPE_ROVO_ENTITLEMENT,
    getKey: ()=>$10274390833bf523$var$RESOURCE_TYPE_ROVO_ENTITLEMENT,
    getData: (_, { tenantContext: { cloudId: cloudId } })=>$10274390833bf523$var$fetchRovoEntitlement(cloudId),
    maxAge: Infinity
});
const $10274390833bf523$export$b9cee3799212b85a = ()=>(0, $2YP9W.useResource)($10274390833bf523$export$a0974cf24d16bc5d);

});
const $34f68d752b7fdd6c$export$2b91517d6d5b4365 = `
query isRovoEnabledQuery($cloudId: ID!, $shouldShowRovoLLMEnabled: Boolean!) {
  jira {
    isRovoEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence")
	}

	jira_isRovoLLMEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence") @include(if: $shouldShowRovoLLMEnabled)
}
`;


parcelRegister("2Ql51", function(module, exports) {

$parcel$export(module.exports, "themePreferenceResource", () => $14feb59df5995657$export$e5a423d1eb1cf1d0);
$parcel$export(module.exports, "useThemePreference", () => $14feb59df5995657$export$3416635c8aeb5bab);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


var $Y0b1l = parcelRequire("Y0b1l");

const $14feb59df5995657$var$getDataLoader = ()=>(parcelRequire("dK4Sf"));
const $14feb59df5995657$export$e5a423d1eb1cf1d0 = (0, $2M1hQ.createResource)({
    type: 'RESOURCE_THEME_PREFERENCE',
    getKey: ()=>'state',
    getDataLoader: $14feb59df5995657$var$getDataLoader,
    maxAge: 300000
});
const $14feb59df5995657$export$3416635c8aeb5bab = ()=>{
    const { data: data, update: updateThemePreferenceResource } = (0, $2YP9W.useResource)($14feb59df5995657$export$e5a423d1eb1cf1d0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireThemeAnalytics = (0, $5uXOq.useCallback)((current, next)=>{
        const OStheme = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        const analyticsEvent = createAnalyticsEvent({
            action: (0, $d0956fbcd917153f$export$89c5cf64ad15c3ea),
            actionSubject: (0, $d0956fbcd917153f$export$9e2cc65718a61846)
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, {
            newPreference: next,
            oldPreference: current,
            OStheme: OStheme
        });
    }, [
        createAnalyticsEvent
    ]);
    const setTheme = (0, $5uXOq.useCallback)(async (theme)=>{
        updateThemePreferenceResource(()=>({
                theme: theme
            }));
        if (data?.theme !== theme) {
            fireThemeAnalytics(data?.theme, theme);
            await (0, $Y0b1l.setThemePreference)(theme);
        }
    }, [
        data?.theme,
        updateThemePreferenceResource,
        fireThemeAnalytics
    ]);
    return {
        theme: data?.theme,
        setTheme: setTheme
    };
};

});
const $d0956fbcd917153f$export$40bd77e1c9f49c27 = 'jira.user.theme.preference';
const $d0956fbcd917153f$export$9e2cc65718a61846 = 'themePreference';
const $d0956fbcd917153f$export$89c5cf64ad15c3ea = 'changed';

parcelRegister("Y0b1l", function(module, exports) {

$parcel$export(module.exports, "setThemePreference", () => $fb319b2ef1da4e47$export$a6b84eebd33787e2);
$parcel$export(module.exports, "getThemePreference", () => $fb319b2ef1da4e47$export$2f7a12048d96237);

var $b9op4 = parcelRequire("b9op4");

var $jcw0u = parcelRequire("jcw0u");

var $aHuqL = parcelRequire("aHuqL");

const $fb319b2ef1da4e47$export$a6b84eebd33787e2 = (theme)=>{
    const promise = (0, $aHuqL.userPreferenceAPI).set((0, $d0956fbcd917153f$export$40bd77e1c9f49c27), theme);
    promise.catch((error)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: error,
            attributes: {
                op: 'put',
                errName: String(error.name),
                statusCode: error.statusCode,
                param: `to:${theme}`
            }
        });
    });
    return promise;
};
const $fb319b2ef1da4e47$export$2f7a12048d96237 = async ()=>{
    const promise = (0, $aHuqL.userPreferenceAPI).get((0, $d0956fbcd917153f$export$40bd77e1c9f49c27));
    promise.catch((error)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: error,
            attributes: {
                op: 'get',
                errName: String(error.name),
                statusCode: error.statusCode
            }
        });
    });
    promise.then((theme)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (theme && !(0, $b9op4.ThemeOptions).includes(theme)) // very unlikely but…
        (0, $jcw0u.default)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: new Error('Unrecognized theme!'),
            attributes: {
                op: 'get',
                theme: theme,
                errName: 'unrecognized value!'
            }
        });
    });
    const theme = await promise;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return theme && (0, $b9op4.ThemeOptions).includes(theme) ? theme : undefined;
};

});
parcelRegister("b9op4", function(module, exports) {

$parcel$export(module.exports, "ThemeOptions", () => $a1d11c8212b90b3e$export$abe7936539cefefe);
$parcel$export(module.exports, "DEFAULT_THEME", () => $a1d11c8212b90b3e$export$2faeed762aac6741);
// This type inlined to reduce TS Complexity - Please reach out to #help-jfp-squads if you need more information.
const $a1d11c8212b90b3e$export$abe7936539cefefe = [
    'light',
    'dark',
    'auto'
];
const $a1d11c8212b90b3e$export$2faeed762aac6741 = 'light';

});


parcelRegister("dK4Sf", function(module, exports) {

let $a0135a222dc45898$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $a0135a222dc45898$var$load("ffQaD"),
    $a0135a222dc45898$var$load("kvRbA"),
    $a0135a222dc45898$var$load("8iXY3")
]).then(()=>parcelRequire('jyeNt'));

});


parcelRegister("9vlEn", function(module, exports) {

$parcel$export(module.exports, "userHomepageResource", () => $ea929e6a42e03883$export$16320dd0d1e6c145);

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");

const $ea929e6a42e03883$export$16320dd0d1e6c145 = (0, $2M1hQ.createResource)({
    type: (0, $a4d0f361741078de$export$2026a6db44b15de7),
    getKey: ()=>'state',
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getData: async (_, { tenantContext: { baseUrl: baseUrl } })=>{
        const { homepagePreference: homepagePreference } = await (0, $eusud.performGetRequest)('/rest/internal/3/homepage/');
        return {
            homepagePreference: homepagePreference
        };
    },
    maxAge: Infinity
});

});
const $a4d0f361741078de$export$2026a6db44b15de7 = 'USER_HOMEPAGE';


parcelRegister("5pSYQ", function(module, exports) {

$parcel$export(module.exports, "postOfficeJiraSideNavResource", () => $e6f7d661dd665dbf$export$5fd5ab86e70497f7);
$parcel$export(module.exports, "postOfficeJiraYourWorkResource", () => $e6f7d661dd665dbf$export$5969dfe9b3b29cd3);
$parcel$export(module.exports, "postOfficeJiraTopBannerResource", () => $e6f7d661dd665dbf$export$af242b8c8ffaab42);
$parcel$export(module.exports, "conditionalPostOfficeJiraTopBannerResource", () => $e6f7d661dd665dbf$export$d1df0b3b482d298d);
// eslint-disable-next-line jira/import-whitelist

var $fyLzM = parcelRequire("fyLzM");

var $2M1hQ = parcelRequire("2M1hQ");

var $gNStA = parcelRequire("gNStA");

var $4R6GH = parcelRequire("4R6GH");
const $e6f7d661dd665dbf$export$fd097948b42db8d3 = (0, $2M1hQ.createResource)({
    type: 'POST_OFFICE_PLACEMENT__SCREEN_SPACE_FLAGS',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        return (0, $fyLzM.preloadPostOfficePlacementWithTenantContext)('screen-space-flags', tenantContext);
    },
    maxAge: Infinity
});
const $e6f7d661dd665dbf$export$5fd5ab86e70497f7 = (0, $2M1hQ.createResource)({
    type: 'POST_OFFICE_PLACEMENT__JIRA_SIDE_NAV',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isAnonymous: isAnonymous } = tenantContext;
        if (isAnonymous) return null;
        return (0, $fyLzM.preloadPostOfficePlacementWithTenantContext)('jira-side-nav', tenantContext);
    },
    maxAge: Infinity
});
const $e6f7d661dd665dbf$export$5969dfe9b3b29cd3 = (0, $2M1hQ.createResource)({
    type: 'POST_OFFICE_PLACEMENT__JIRA_YOUR_WORK',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isAnonymous: isAnonymous } = tenantContext;
        if (isAnonymous) return null;
        return (0, $fyLzM.preloadPostOfficePlacementWithTenantContext)('jira-your-work', tenantContext);
    },
    maxAge: Infinity
});
const $e6f7d661dd665dbf$export$af242b8c8ffaab42 = (0, $2M1hQ.createResource)({
    type: 'POST_OFFICE_PLACEMENT__JIRA_TOP_BANNER',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isSiteAdmin: isSiteAdmin } = tenantContext;
        if (isSiteAdmin) return (0, $fyLzM.preloadPostOfficePlacementWithTenantContext)('jira-top-banner', tenantContext);
        return null;
    },
    maxAge: Infinity
});
const $e6f7d661dd665dbf$export$d1df0b3b482d298d = (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jira-issue-term-refresh-banner'), $e6f7d661dd665dbf$export$af242b8c8ffaab42);

});
parcelRegister("fyLzM", function(module, exports) {

$parcel$export(module.exports, "usePlacementSSRFetch", () => $121a6aea82ff4ae0$export$420f2f91a928b3b6);
$parcel$export(module.exports, "preloadPostOfficePlacementWithTenantContext", () => $121a6aea82ff4ae0$export$65b5eab182e1ca6f);

var $5uXOq = parcelRequire("5uXOq");

var $87o4H = parcelRequire("87o4H");

var $i3PqM = parcelRequire("i3PqM");

var $2YP9W = parcelRequire("2YP9W");

var $adncp = parcelRequire("adncp");
const $121a6aea82ff4ae0$export$18a0019e5439b209 = ({ status: status, statusText: statusText })=>JSON.stringify({
        status: status,
        statusText: statusText
    });
const $121a6aea82ff4ae0$export$b3732c8ff6f9c463 = (res)=>{
    if (typeof res === 'undefined') throw new Error('No response from server');
    if (res.ok) return res;
    throw new Error($121a6aea82ff4ae0$export$18a0019e5439b209(res));
};
/**
 * Common method for setting up the Post Office placement request URL with the environment and product context
 *
 * @param placementId
 * @param contextOptions
 * @returns
 */ const $121a6aea82ff4ae0$var$preloadPostOfficePlacement = async (placementId, contextOptions)=>{
    const { postOfficeContext: postOfficeContext, environment: environment } = contextOptions;
    const jiraFetcherWithS2SHeaders = async (url)=>{
        let hostEnv = 'prod';
        if (environment.currentEnv !== 'production') hostEnv = 'staging';
        const fetchHeaders = {
            'x-ssr-service-name': 'post-office',
            'x-ssr-service-env': hostEnv
        };
        return (0, $i3PqM.defaultFetcher)(url.replace('gateway/api/post-office/', ''), fetchHeaders);
    };
    return (0, $i3PqM.requestInitialData)(placementId, postOfficeContext, false ? jiraFetcherWithS2SHeaders : undefined, (0, $87o4H.buildBasePath)(environment.currentEnv, environment.envConfigs)).then($121a6aea82ff4ae0$export$b3732c8ff6f9c463).then((res)=>res.json());
};
const $121a6aea82ff4ae0$export$420f2f91a928b3b6 = (resource)=>{
    const { data: data } = (0, $2YP9W.useResource)(resource);
    return (0, $5uXOq.useCallback)(()=>{
        if (data) {
            /**
			 * Preloaded data must be serialized, however our initialData is expected to be in the form of a Response promise.
			 * TODO: Remove this workaround once the Post Office placement API is updated to handle flat data.
			 */ const init = {
                status: 200,
                statusText: 'ok!'
            };
            return Promise.resolve(new Response(JSON.stringify(data), init));
        }
    }, [
        data
    ]);
};
const $121a6aea82ff4ae0$export$65b5eab182e1ca6f = async (placementId, preloadedTenantContext)=>{
    return $121a6aea82ff4ae0$var$preloadPostOfficePlacement(placementId, {
        postOfficeContext: (0, $adncp.tenantToPostOfficeContext)(preloadedTenantContext),
        environment: {
            currentEnv: (0, $adncp.transformJiraEnvToPostOfficeEnvironment)(preloadedTenantContext.environment)
        }
    });
};

});
parcelRegister("87o4H", function(module, exports) {

$parcel$export(module.exports, "buildBasePath", () => $e673525439adf1a3$export$e8b30f9c4a80230f);


var $5MYiV = parcelRequire("5MYiV");
const $e673525439adf1a3$export$e8b30f9c4a80230f = (currentEnv, envConfigs = (0, $5MYiV.defaultEnvironmentValues).envConfigs)=>{
    const baseUrl = envConfigs[currentEnv].api.origin;
    // TypeScript & Safety reasons: Final default to staging-prod API path in case path got overriden somewhere to be undefined, but this should not be the case
    const path = envConfigs[currentEnv].api.pathname ?? (0, $154d3acab0ca1f4d$export$d4fe3482c88e73a8);
    return {
        baseUrl: baseUrl,
        path: path
    };
};

});
var $154d3acab0ca1f4d$exports = {};

$parcel$export($154d3acab0ca1f4d$exports, "API_ORIGIN_TEST_SERVER", () => $154d3acab0ca1f4d$export$5ca004be156a127a);
$parcel$export($154d3acab0ca1f4d$exports, "API_ORIGIN_LOCAL", () => $154d3acab0ca1f4d$export$1e9fed4c0197724c);
$parcel$export($154d3acab0ca1f4d$exports, "API_PATHNAME_LOCAL", () => $154d3acab0ca1f4d$export$919a9569bce66f17);
$parcel$export($154d3acab0ca1f4d$exports, "API_PATHNAME_STG_PROD", () => $154d3acab0ca1f4d$export$d4fe3482c88e73a8);
$parcel$export($154d3acab0ca1f4d$exports, "REMOTE_MODULE_URI_LOCAL", () => $154d3acab0ca1f4d$export$67be2569ef5d7666);
$parcel$export($154d3acab0ca1f4d$exports, "REMOTE_MODULE_URI_STG", () => $154d3acab0ca1f4d$export$b49738b89db261cd);
$parcel$export($154d3acab0ca1f4d$exports, "REMOTE_MODULE_URI_PROD", () => $154d3acab0ca1f4d$export$bbd96cd490b0df63);
const $154d3acab0ca1f4d$export$5ca004be156a127a = 'http://localhost:4224';
const $154d3acab0ca1f4d$export$a5c5394c951a9848 = '/gateway/api/post-office/api/v1/placements/';
const $154d3acab0ca1f4d$export$1e9fed4c0197724c = 'http://localhost:8081';
const $154d3acab0ca1f4d$export$919a9569bce66f17 = '/api/v1/placements/';
const $154d3acab0ca1f4d$export$d4fe3482c88e73a8 = '/gateway/api/post-office/api/v1/placements/';
const $154d3acab0ca1f4d$export$67be2569ef5d7666 = 'http://localhost:9009';
const $154d3acab0ca1f4d$export$b49738b89db261cd = 'https://post-office-rml-frontend.stg-east.frontend.public.atl-paas.net';
const $154d3acab0ca1f4d$export$bbd96cd490b0df63 = 'https://post-office-rml-frontend.prod-east.frontend.public.atl-paas.net';

parcelRegister("5MYiV", function(module, exports) {

$parcel$export(module.exports, "defaultEnvironmentValues", () => $d283dbd21f6fbc74$export$b4ede87479bfcf09);
$parcel$export(module.exports, "PostOfficeEnvironmentProvider", () => $d283dbd21f6fbc74$export$604607f913ef367c);
$parcel$export(module.exports, "usePostOfficeEnvironment", () => $d283dbd21f6fbc74$export$877b97169cc75e8b);

var $5uXOq = parcelRequire("5uXOq");

const $d283dbd21f6fbc74$export$b4ede87479bfcf09 = {
    currentEnv: 'local',
    envConfigs: {
        'test-server': {
            remoteModule: {
                origin: (0, $154d3acab0ca1f4d$export$67be2569ef5d7666),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $154d3acab0ca1f4d$export$5ca004be156a127a),
                pathname: (0, $154d3acab0ca1f4d$export$5ca004be156a127a),
                searchParams: undefined
            }
        },
        test: {
            remoteModule: {
                origin: (0, $154d3acab0ca1f4d$export$67be2569ef5d7666),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $154d3acab0ca1f4d$export$1e9fed4c0197724c),
                pathname: (0, $154d3acab0ca1f4d$export$919a9569bce66f17),
                searchParams: undefined
            }
        },
        local: {
            remoteModule: {
                origin: (0, $154d3acab0ca1f4d$export$67be2569ef5d7666),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $154d3acab0ca1f4d$export$1e9fed4c0197724c),
                pathname: (0, $154d3acab0ca1f4d$export$919a9569bce66f17),
                searchParams: undefined
            }
        },
        dev: {
            remoteModule: {
                origin: (0, $154d3acab0ca1f4d$export$67be2569ef5d7666),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $154d3acab0ca1f4d$export$1e9fed4c0197724c),
                pathname: (0, $154d3acab0ca1f4d$export$919a9569bce66f17),
                searchParams: undefined
            }
        },
        staging: {
            remoteModule: {
                origin: (0, $154d3acab0ca1f4d$export$b49738b89db261cd),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $154d3acab0ca1f4d$export$d4fe3482c88e73a8),
                searchParams: undefined
            }
        },
        'stg-fedm-east': {
            remoteModule: {
                origin: (0, $154d3acab0ca1f4d$export$b49738b89db261cd),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $154d3acab0ca1f4d$export$d4fe3482c88e73a8),
                searchParams: undefined
            }
        },
        production: {
            remoteModule: {
                origin: (0, $154d3acab0ca1f4d$export$bbd96cd490b0df63),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $154d3acab0ca1f4d$export$d4fe3482c88e73a8),
                searchParams: undefined
            }
        },
        'prod-fedm-east': {
            remoteModule: {
                origin: (0, $154d3acab0ca1f4d$export$bbd96cd490b0df63),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $154d3acab0ca1f4d$export$d4fe3482c88e73a8),
                searchParams: undefined
            }
        }
    }
};
const $d283dbd21f6fbc74$export$fceca2c399b32565 = (0, $5uXOq.createContext)($d283dbd21f6fbc74$export$b4ede87479bfcf09);
const $d283dbd21f6fbc74$export$604607f913ef367c = $d283dbd21f6fbc74$export$fceca2c399b32565.Provider;
const $d283dbd21f6fbc74$export$877b97169cc75e8b = ()=>(0, $5uXOq.useContext)($d283dbd21f6fbc74$export$fceca2c399b32565);

});


parcelRegister("i3PqM", function(module, exports) {

$parcel$export(module.exports, "defaultFetcher", () => $897b9e921cef5759$export$77754e0ac9f8aba3);
$parcel$export(module.exports, "requestInitialData", () => $897b9e921cef5759$export$c4c39037cc4b06ab);
const $897b9e921cef5759$export$77754e0ac9f8aba3 = (url, headers, fetchOptions)=>fetch(url, {
        ...fetchOptions,
        headers: {
            credentials: 'include',
            mode: 'cors',
            'Content-Type': 'application/json',
            ...headers,
            ...fetchOptions?.headers
        }
    });
const $897b9e921cef5759$export$c4c39037cc4b06ab = async (placementId, context, fetcher = $897b9e921cef5759$export$77754e0ac9f8aba3, options)=>{
    const baseUrl = options.baseUrl;
    const path = options.path;
    const requestUrl = baseUrl ? new URL(path, baseUrl).toString() : path;
    const requestResource = options.resource ? options.resource : '';
    function stringifyObjectValues(input) {
        const entries = Object.entries(input);
        const stringifiedEntries = entries.filter(([, v])=>typeof v !== 'undefined' && v !== null).map(([key, value])=>[
                key,
                String(value)
            ]);
        return Object.fromEntries(stringifiedEntries);
    }
    const contextAsSearchParams = new URLSearchParams(stringifyObjectValues(context));
    contextAsSearchParams.sort();
    const url = encodeURI(`${requestUrl}${placementId}${requestResource}?${contextAsSearchParams.toString()}`);
    // Response will be handled inside the component
    return fetcher(url);
};

});

parcelRegister("adncp", function(module, exports) {

$parcel$export(module.exports, "tenantToPostOfficeContext", () => $8d0bdd2f51e19696$export$d8f2c334a0924146);
$parcel$export(module.exports, "subproductToEdition", () => $8d0bdd2f51e19696$export$2d690d13b91ea44f);
$parcel$export(module.exports, "transformJiraEnvToPostOfficeEnvironment", () => $8d0bdd2f51e19696$export$cfacfecb20987ff1);

var $81zXP = parcelRequire("81zXP");
const $8d0bdd2f51e19696$var$JIRA_PRODUCT = 'jira';
const $8d0bdd2f51e19696$var$DEFAULT_POST_OFFICE_CONTEXT = {
    product: $8d0bdd2f51e19696$var$JIRA_PRODUCT,
    locale: 'en'
};
const $8d0bdd2f51e19696$var$getWorkspaceARI = ({ cloudId: cloudId, activationId: activationId })=>{
    return (0, $81zXP.JiraWorkspaceAri).create({
        activationId: activationId,
        siteId: cloudId
    }).toString();
};
const $8d0bdd2f51e19696$export$d8f2c334a0924146 = (tenantData)=>{
    const { activationId: activationId, cloudId: cloudId, isSiteAdmin: isSiteAdmin, locale: locale, isAdmin: isAdmin } = tenantData;
    const workspaceAri = $8d0bdd2f51e19696$var$getWorkspaceARI({
        activationId: activationId,
        cloudId: cloudId
    });
    return {
        ...$8d0bdd2f51e19696$var$DEFAULT_POST_OFFICE_CONTEXT,
        locale: locale,
        isSiteAdmin: isSiteAdmin,
        tenantId: cloudId,
        workspaceAri: workspaceAri,
        workspaceId: activationId,
        isAdmin: isAdmin,
        orgId: undefined,
        subproduct: undefined,
        productEdition: undefined
    };
};
const $8d0bdd2f51e19696$export$2d690d13b91ea44f = (subproduct, editions)=>{
    switch(subproduct){
        case 'core':
            return editions.core;
        case 'software':
            return editions.software;
        case 'customerService':
            return editions.customerService;
        case 'serviceDesk':
            return editions.serviceDesk;
        default:
            undefined;
    }
};
const $8d0bdd2f51e19696$export$cfacfecb20987ff1 = (environment)=>{
    switch(environment){
        case 'dev':
        case 'staging':
            return 'staging';
        case 'prod':
            return 'production';
        case 'local':
            return 'local';
        default:
            return 'local';
    }
};

});




parcelRegister("8H3A4", function(module, exports) {

$parcel$export(module.exports, "serviceDeskAnalyticsContextResource", () => $4d76b3bac8f2b7c8$export$d6f4f0483916919f);
$parcel$export(module.exports, "useServiceDeskAnalyticsContext", () => $4d76b3bac8f2b7c8$export$bc2de1c42df30b10);

var $5uXOq = parcelRequire("5uXOq");

var $dK8AG = parcelRequire("dK8AG");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


const $4d76b3bac8f2b7c8$var$getDataLoader = ()=>(parcelRequire("2efkr"));
const $4d76b3bac8f2b7c8$var$ONE_DAY_IN_MILLIS = 86400000;
const $4d76b3bac8f2b7c8$export$d6f4f0483916919f = (0, $2M1hQ.createResource)({
    type: (0, $3b4b6bf0bbdfa955$export$285b47583a5bdd0f),
    getKey: ({ match: match })=>(0, $dK8AG.getProjectKeyOrId)(match),
    getDataLoader: $4d76b3bac8f2b7c8$var$getDataLoader,
    maxAge: $4d76b3bac8f2b7c8$var$ONE_DAY_IN_MILLIS
});
const $4d76b3bac8f2b7c8$export$bc2de1c42df30b10 = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)($4d76b3bac8f2b7c8$export$d6f4f0483916919f);
    (0, $5uXOq.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        error,
        refresh
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            data: data,
            loading: loading,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error
        }), [
        data,
        loading,
        error
    ]);
};

});
const $3b4b6bf0bbdfa955$export$285b47583a5bdd0f = 'SERVICEDESK_ANALYTICS_CONTEXT';

parcelRegister("2efkr", function(module, exports) {

let $19f8c78c957ed4ee$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $19f8c78c957ed4ee$var$load("kVX56"),
    $19f8c78c957ed4ee$var$load("fZrr5")
]).then(()=>parcelRequire('btHFe'));

});


parcelRegister("cAofY", function(module, exports) {

$parcel$export(module.exports, "serviceDeskContextResource", () => $9c517de0cdc23225$export$5eaaf465969a9171);

var $dK8AG = parcelRequire("dK8AG");

var $2M1hQ = parcelRequire("2M1hQ");


const $9c517de0cdc23225$var$getDataLoader = ()=>(parcelRequire("2G0Nq"));
const $9c517de0cdc23225$export$5eaaf465969a9171 = (0, $2M1hQ.createResource)({
    type: (0, $4595635dbd9fca21$export$ac01662d5287bc5c),
    getKey: ({ match: match, query: query })=>(0, $dK8AG.getProjectKeyOrIdFromMatchAndQuery)({
            match: match,
            query: query
        }),
    getDataLoader: $9c517de0cdc23225$var$getDataLoader,
    maxAge: Infinity
});

});
const $4595635dbd9fca21$export$ac01662d5287bc5c = 'SERVICEDESK_CONTEXT';

parcelRegister("2G0Nq", function(module, exports) {

let $1f301f1e17d99558$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1f301f1e17d99558$var$load("5yC81").then(()=>parcelRequire('g4PUK'));

});


parcelRegister("aNLeB", function(module, exports) {

$parcel$export(module.exports, "servicedeskIsItsmProjectResource", () => $31e43d0718118496$export$920308cef4e291b1);
$parcel$export(module.exports, "useIsItsmTemplateProject", () => $31e43d0718118496$export$7bb46948fb84f164);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $dK8AG = parcelRequire("dK8AG");

var $2M1hQ = parcelRequire("2M1hQ");


const $31e43d0718118496$var$getDataLoader = ()=>(parcelRequire("9GeOA"));
const $31e43d0718118496$var$ONE_DAY_IN_MILLIS = 86400000;
const $31e43d0718118496$export$920308cef4e291b1 = (0, $2M1hQ.createResource)({
    type: (0, $6249ccfa4eeeb82a$export$543a8644640f4092),
    getKey: ({ match: match })=>(0, $dK8AG.getProjectKeyOrId)(match),
    getDataLoader: $31e43d0718118496$var$getDataLoader,
    maxAge: $31e43d0718118496$var$ONE_DAY_IN_MILLIS
});
const $31e43d0718118496$export$7bb46948fb84f164 = (projectKey)=>{
    const { data: data, loading: loading, error: error } = (0, $324W5.useResourceWithCustomRouterContext)($31e43d0718118496$export$920308cef4e291b1, projectKey ? {
        matchParams: {
            projectKey: projectKey
        }
    } : undefined, {
        shouldPrefetch: true
    });
    return (0, $5uXOq.useMemo)(()=>({
            data: data,
            loading: loading,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error
        }), [
        data,
        loading,
        error
    ]);
};

});
parcelRegister("324W5", function(module, exports) {

$parcel$export(module.exports, "useResourceWithCustomRouterContext", () => $0c2698427b7aacc1$export$61dad767cf446185);

var $jNUyg = parcelRequire("jNUyg");
var $2YP9W = parcelRequire("2YP9W");

var $geWXd = parcelRequire("geWXd");
/**
 * DUMMY_ROUTE needs to be used by default, because `route` must not be undefined, it is required/used internally by RRR, e.g. in findRouterContext() on createRouterContext() call.
 * If `route` is undefined, those will throw runtime exceptions.
 * `project-sidebar-navigation-resource/software-cmp-nav-synchronizer/index.tsx` uses dummy route as well.
 *
 * Jfyi, createProjectRouteRouterContext() function in JSW uses dummy route, with :projectKey in its path (that resource fetch function uses)
 */ const $0c2698427b7aacc1$var$DUMMY_ROUTE = {
    name: 'DUMMY_ROUTE_NAME',
    path: '/projects/:projectKey/dummyroute'
};
function $0c2698427b7aacc1$export$61dad767cf446185(resource, customRouterContext, options = {}) {
    let resourceOptions;
    if (customRouterContext) {
        // NOTE: `route` must include /.../:paramKey/... in its url for all `matchParams` passed to the `createRouterContext`, otherwise they will be ignored. createRouterContext will throw an error if route is undefined: `route.path` is used in the library code at least.
        const { route: route = $0c2698427b7aacc1$var$DUMMY_ROUTE, matchParams: matchParams } = customRouterContext;
        if (matchParams && Object.keys(matchParams).length > 0) resourceOptions = {
            routerContext: (0, $jNUyg.createRouterContext)(route, {
                params: matchParams
            })
        };
    }
    const { shouldPrefetch: shouldPrefetch } = options;
    const resourceResponse = (0, $2YP9W.useResource)(resource, resourceOptions);
    // we must call "fetch data" / refresh() manually, because react-resource-router will not fetch resources which are not defined in the current route's required resources.
    (0, $geWXd.usePrefetchableResource)(resourceResponse, shouldPrefetch ?? Boolean(customRouterContext));
    return resourceResponse;
}

});
parcelRegister("geWXd", function(module, exports) {

$parcel$export(module.exports, "usePrefetchableResource", () => $b632b0c18495344b$export$99f17ace416cfe75);

var $5uXOq = parcelRequire("5uXOq");
function $b632b0c18495344b$export$99f17ace416cfe75(resource, shouldPrefetch) {
    (0, $5uXOq.useEffect)(()=>{
        if (!shouldPrefetch) return;
        // "false" is a valid value for data here. We only want to trigger a refresh if data is null or undefined.
        if ((resource.data === null || resource.data === undefined) && !resource.loading && !resource.error) resource.refresh();
    // we only need this to happen only once at initial time. In addition, some resources return `data` = null when user does not have permissions etc., which makes all `data`, `loading` and `error` have falsy values.
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});


const $6249ccfa4eeeb82a$export$543a8644640f4092 = 'SERVICEDESK_IS_ITSM_PROJECT';

parcelRegister("9GeOA", function(module, exports) {

let $70c38737053f6be9$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $70c38737053f6be9$var$load("kVX56"),
    $70c38737053f6be9$var$load("ijWsV")
]).then(()=>parcelRequire('k9PUn'));

});


parcelRegister("eUvlM", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticesResource", () => $9479f477b801290f$export$2ae319305481e7de);
$parcel$export(module.exports, "useWorkCategoriesQueueSupported", () => $9479f477b801290f$export$a86ac771006f14b3);
$parcel$export(module.exports, "useWorkCategoriesAllSupported", () => $9479f477b801290f$export$fe081b1a59d3c818);
$parcel$export(module.exports, "useWorkCategoriesAllSupportedWithForceRefreshOnMount", () => $9479f477b801290f$export$4d46346ef0bdc6b9);

var $5uXOq = parcelRequire("5uXOq");

var $dK8AG = parcelRequire("dK8AG");

var $oCMSG = parcelRequire("oCMSG");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


const $9479f477b801290f$var$getDataLoader = ()=>(parcelRequire("1Sd5S"));
const $9479f477b801290f$var$ONE_DAY_IN_MILLIS = 86400000;
const $9479f477b801290f$export$2ae319305481e7de = (0, $2M1hQ.createResource)({
    type: (0, $990f0449915d93bf$export$45919c8f50bb1db5),
    getKey: ({ match: match })=>(0, $dK8AG.getProjectKeyOrId)(match),
    getDataLoader: $9479f477b801290f$var$getDataLoader,
    maxAge: $9479f477b801290f$var$ONE_DAY_IN_MILLIS
});
const $9479f477b801290f$var$queuesOrder = [
    ...(0, $oCMSG.WORK_CATEGORIES_QUEUE_SUPPORTED)
];
const $9479f477b801290f$var$workCategoryOrder = [
    ...$9479f477b801290f$var$queuesOrder,
    (0, $oCMSG.DEVELOPER_ESCALATION)
];
const $9479f477b801290f$var$transformItsmPracticesList = (data)=>{
    if (!data?.practices) return null;
    return $9479f477b801290f$var$queuesOrder.filter((practice)=>data.practices.some((practiceInData)=>practiceInData.key === practice));
};
const $9479f477b801290f$var$transformServiceDeskPracticesList = (data)=>{
    if (!data?.practices) return null;
    return $9479f477b801290f$var$workCategoryOrder.filter((practice)=>data.practices.some((practiceInData)=>practiceInData.key === practice));
};
const $9479f477b801290f$export$a86ac771006f14b3 = ()=>{
    const { data: data, loading: loading, ...resource } = (0, $2YP9W.useResource)($9479f477b801290f$export$2ae319305481e7de);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = resource.error;
    return (0, $5uXOq.useMemo)(()=>({
            data: $9479f477b801290f$var$transformItsmPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};
const $9479f477b801290f$export$fe081b1a59d3c818 = ()=>{
    const { data: data, loading: loading, ...resource } = (0, $2YP9W.useResource)($9479f477b801290f$export$2ae319305481e7de);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = resource.error;
    return (0, $5uXOq.useMemo)(()=>({
            data: $9479f477b801290f$var$transformServiceDeskPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};
const $9479f477b801290f$export$4d46346ef0bdc6b9 = ()=>{
    const { data: data, loading: loading, refresh: refreshPractices, ...resource } = (0, $2YP9W.useResource)($9479f477b801290f$export$2ae319305481e7de);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = resource.error;
    (0, $5uXOq.useEffect)(()=>{
        if (!loading && !data && !error) refreshPractices();
    }, [
        data,
        error,
        loading,
        refreshPractices
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            data: $9479f477b801290f$var$transformServiceDeskPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};

});
parcelRegister("oCMSG", function(module, exports) {

$parcel$export(module.exports, "CHANGES", () => $4f9c4406e75c8aa5$export$8598196f74460271);
$parcel$export(module.exports, "INCIDENTS", () => $4f9c4406e75c8aa5$export$a50b49a533b5f7bc);
$parcel$export(module.exports, "PROBLEMS", () => $4f9c4406e75c8aa5$export$ceba70db1edb1def);
$parcel$export(module.exports, "SERVICE_REQUEST", () => $4f9c4406e75c8aa5$export$3d1cda9bd50505e8);
$parcel$export(module.exports, "POST_INCIDENT_REVIEWS", () => $4f9c4406e75c8aa5$export$6ebf7b6bf1c580f);
$parcel$export(module.exports, "DEVELOPER_ESCALATION", () => $4f9c4406e75c8aa5$export$81e62964cc725098);
$parcel$export(module.exports, "NO_CATEGORY", () => $4f9c4406e75c8aa5$export$485b1216c42d8d4);
$parcel$export(module.exports, "NO_PRACTICE", () => $4f9c4406e75c8aa5$export$52bf3f16b7812704);
$parcel$export(module.exports, "SHORT_FORM_CHANGES", () => $4f9c4406e75c8aa5$export$a50185c8e9fb007e);
$parcel$export(module.exports, "SHORT_FORM_INCIDENTS", () => $4f9c4406e75c8aa5$export$a54a30a3c3cce634);
$parcel$export(module.exports, "SHORT_FORM_PROBLEMS", () => $4f9c4406e75c8aa5$export$354f3a4c6ac0c903);
$parcel$export(module.exports, "SHORT_FORM_SERVICE_REQUEST", () => $4f9c4406e75c8aa5$export$335d3ac0c367f03f);
$parcel$export(module.exports, "SHORT_FORM_POST_INCIDENT_REVIEWS", () => $4f9c4406e75c8aa5$export$7ffd7f2c2ae96b6f);
$parcel$export(module.exports, "SHORT_FORM_DEVELOPER_ESCALATION", () => $4f9c4406e75c8aa5$export$cb41b99ca54e6bd);
$parcel$export(module.exports, "WORK_CATEGORIES_QUEUE_SUPPORTED", () => $4f9c4406e75c8aa5$export$a2b1f8f055150f02);
$parcel$export(module.exports, "ItsmPracticeToShortForm", () => $4f9c4406e75c8aa5$export$56c57f7ad650c45c);
$parcel$export(module.exports, "PRACTICE_LABEL_MAP", () => $4f9c4406e75c8aa5$export$fbf0dfd01228e38d);
$parcel$export(module.exports, "PRACTICE_LABEL_MAP_LOWER_CASE", () => $4f9c4406e75c8aa5$export$45ba5f49e9509c4d);
$parcel$export(module.exports, "WORK_CATEGORIES_QUEUE_SUPPORTED_LABELS", () => $4f9c4406e75c8aa5$export$45952424a7f29b99);
$parcel$export(module.exports, "CHANGES_JQL_NAME", () => $4f9c4406e75c8aa5$export$6c24c440228eac9c);
$parcel$export(module.exports, "DEVELOPER_ESCALATION_JQL_NAME", () => $4f9c4406e75c8aa5$export$3f757c5e00588ffd);
$parcel$export(module.exports, "practiceKeyJqlNameMapping", () => $4f9c4406e75c8aa5$export$b78213db77524b5b);

var $7c0in = parcelRequire("7c0in");

var $kVZSN = parcelRequire("kVZSN");
const $4f9c4406e75c8aa5$export$8598196f74460271 = 'change-management';
const $4f9c4406e75c8aa5$export$a50b49a533b5f7bc = 'incident-management';
const $4f9c4406e75c8aa5$export$ceba70db1edb1def = 'problem-management';
const $4f9c4406e75c8aa5$export$3d1cda9bd50505e8 = 'service-request';
const $4f9c4406e75c8aa5$export$6ebf7b6bf1c580f = 'post-incident-review';
const $4f9c4406e75c8aa5$export$81e62964cc725098 = 'developer-escalation';
const $4f9c4406e75c8aa5$export$485b1216c42d8d4 = 'no-category';
const $4f9c4406e75c8aa5$var$NO_CATEGORY_NEW = 'no-category-new';
const $4f9c4406e75c8aa5$export$52bf3f16b7812704 = 'no-practice'; // BERRY-1358 should consolidate into NO_CATEGORY
const $4f9c4406e75c8aa5$export$a50185c8e9fb007e = 'changes';
const $4f9c4406e75c8aa5$export$a54a30a3c3cce634 = 'incidents';
const $4f9c4406e75c8aa5$export$354f3a4c6ac0c903 = 'problems';
const $4f9c4406e75c8aa5$export$335d3ac0c367f03f = 'service-requests';
const $4f9c4406e75c8aa5$export$7ffd7f2c2ae96b6f = 'post-incident-reviews';
const $4f9c4406e75c8aa5$export$cb41b99ca54e6bd = 'developer-escalations';
const $4f9c4406e75c8aa5$export$a613d808168c7b25 = [
    $4f9c4406e75c8aa5$export$8598196f74460271,
    $4f9c4406e75c8aa5$export$a50b49a533b5f7bc,
    $4f9c4406e75c8aa5$export$ceba70db1edb1def,
    $4f9c4406e75c8aa5$export$3d1cda9bd50505e8,
    $4f9c4406e75c8aa5$export$6ebf7b6bf1c580f,
    $4f9c4406e75c8aa5$export$81e62964cc725098
]; // /!\ defines WorkCategoryApiResource type
const $4f9c4406e75c8aa5$export$a2b1f8f055150f02 = [
    $4f9c4406e75c8aa5$export$3d1cda9bd50505e8,
    $4f9c4406e75c8aa5$export$a50b49a533b5f7bc,
    $4f9c4406e75c8aa5$export$ceba70db1edb1def,
    $4f9c4406e75c8aa5$export$8598196f74460271,
    $4f9c4406e75c8aa5$export$6ebf7b6bf1c580f
]; // /!\ defines WorkCategoryQueueSupported type
const $4f9c4406e75c8aa5$export$5a9122a4028fb8ef = [
    ...$4f9c4406e75c8aa5$export$a2b1f8f055150f02,
    $4f9c4406e75c8aa5$export$485b1216c42d8d4
];
const $4f9c4406e75c8aa5$export$f1b813cd23817ade = [
    $4f9c4406e75c8aa5$export$a50185c8e9fb007e,
    $4f9c4406e75c8aa5$export$a54a30a3c3cce634,
    $4f9c4406e75c8aa5$export$354f3a4c6ac0c903,
    $4f9c4406e75c8aa5$export$335d3ac0c367f03f,
    $4f9c4406e75c8aa5$export$7ffd7f2c2ae96b6f,
    $4f9c4406e75c8aa5$export$cb41b99ca54e6bd
]; // /!\ defines WorkCategoryShortForm type
const $4f9c4406e75c8aa5$export$56c57f7ad650c45c = {
    [$4f9c4406e75c8aa5$export$8598196f74460271]: $4f9c4406e75c8aa5$export$a50185c8e9fb007e,
    [$4f9c4406e75c8aa5$export$a50b49a533b5f7bc]: $4f9c4406e75c8aa5$export$a54a30a3c3cce634,
    [$4f9c4406e75c8aa5$export$ceba70db1edb1def]: $4f9c4406e75c8aa5$export$354f3a4c6ac0c903,
    [$4f9c4406e75c8aa5$export$3d1cda9bd50505e8]: $4f9c4406e75c8aa5$export$335d3ac0c367f03f,
    [$4f9c4406e75c8aa5$export$6ebf7b6bf1c580f]: $4f9c4406e75c8aa5$export$7ffd7f2c2ae96b6f,
    [$4f9c4406e75c8aa5$export$485b1216c42d8d4]: $4f9c4406e75c8aa5$var$NO_CATEGORY_NEW
};
const $4f9c4406e75c8aa5$export$fbf0dfd01228e38d = {
    [$4f9c4406e75c8aa5$export$8598196f74460271]: (0, $kVZSN.default).changes,
    [$4f9c4406e75c8aa5$export$3d1cda9bd50505e8]: (0, $kVZSN.default).serviceRequests,
    [$4f9c4406e75c8aa5$export$ceba70db1edb1def]: (0, $kVZSN.default).problems,
    [$4f9c4406e75c8aa5$export$a50b49a533b5f7bc]: (0, $kVZSN.default).incidents,
    [$4f9c4406e75c8aa5$export$6ebf7b6bf1c580f]: (0, $kVZSN.default).postIncidentReviews,
    [$4f9c4406e75c8aa5$export$485b1216c42d8d4]: (0, $kVZSN.default).queues,
    [$4f9c4406e75c8aa5$export$81e62964cc725098]: (0, $kVZSN.default).developerEscalation,
    [$4f9c4406e75c8aa5$export$52bf3f16b7812704]: (0, $kVZSN.default).noCategory
};
const $4f9c4406e75c8aa5$export$45ba5f49e9509c4d = {
    [$4f9c4406e75c8aa5$export$8598196f74460271]: (0, $kVZSN.default).changesLower,
    [$4f9c4406e75c8aa5$export$3d1cda9bd50505e8]: (0, $kVZSN.default).serviceRequestsLower,
    [$4f9c4406e75c8aa5$export$ceba70db1edb1def]: (0, $kVZSN.default).problemsLower,
    [$4f9c4406e75c8aa5$export$a50b49a533b5f7bc]: (0, $kVZSN.default).incidentsLower,
    [$4f9c4406e75c8aa5$export$6ebf7b6bf1c580f]: (0, $kVZSN.default).postIncidentReviewsLower,
    [$4f9c4406e75c8aa5$export$485b1216c42d8d4]: (0, $kVZSN.default).queuesLower,
    [$4f9c4406e75c8aa5$export$81e62964cc725098]: (0, $kVZSN.default).developerEscalationLower,
    [$4f9c4406e75c8aa5$export$52bf3f16b7812704]: (0, $kVZSN.default).noCategoryLower
};
const $4f9c4406e75c8aa5$export$45952424a7f29b99 = (0, $7c0in.getTypedKeys)($4f9c4406e75c8aa5$export$fbf0dfd01228e38d).reduce((acc, labelMapKey)=>{
    // cannot type .indexOf() as not-string in Ts, therefore need to use .find(). And shows error if `key` in acc[key] being of wider type than the result (than ItsmPracticeCategory), therefore, need to use different keys in the `acc[queueKey] =` line
    const queueKey = $4f9c4406e75c8aa5$export$a2b1f8f055150f02.find((key)=>key === labelMapKey);
    if (queueKey) acc[queueKey] = $4f9c4406e75c8aa5$export$fbf0dfd01228e38d[labelMapKey];
    return acc;
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
}, {});
const $4f9c4406e75c8aa5$export$6c24c440228eac9c = 'Changes';
const $4f9c4406e75c8aa5$export$5b65d27ec2d28d18 = 'Incidents';
const $4f9c4406e75c8aa5$var$PROBLEMS_JQL_NAME = 'Problems';
const $4f9c4406e75c8aa5$var$SERVICE_REQUEST_JQL_NAME = 'Service requests';
const $4f9c4406e75c8aa5$var$POST_INCIDENT_REVIEWS_JQL_NAME = 'Post-incident reviews';
const $4f9c4406e75c8aa5$export$3f757c5e00588ffd = 'Developer escalation';
const $4f9c4406e75c8aa5$export$b78213db77524b5b = {
    [$4f9c4406e75c8aa5$export$8598196f74460271]: $4f9c4406e75c8aa5$export$6c24c440228eac9c,
    [$4f9c4406e75c8aa5$export$a50b49a533b5f7bc]: $4f9c4406e75c8aa5$export$5b65d27ec2d28d18,
    [$4f9c4406e75c8aa5$export$ceba70db1edb1def]: $4f9c4406e75c8aa5$var$PROBLEMS_JQL_NAME,
    [$4f9c4406e75c8aa5$export$3d1cda9bd50505e8]: $4f9c4406e75c8aa5$var$SERVICE_REQUEST_JQL_NAME,
    [$4f9c4406e75c8aa5$export$6ebf7b6bf1c580f]: $4f9c4406e75c8aa5$var$POST_INCIDENT_REVIEWS_JQL_NAME,
    [$4f9c4406e75c8aa5$export$81e62964cc725098]: $4f9c4406e75c8aa5$export$3f757c5e00588ffd
};

});
parcelRegister("7c0in", function(module, exports) {

$parcel$export(module.exports, "hasProp", () => $2dc9189f096b533d$export$dd642ef726dcde21);
$parcel$export(module.exports, "getTypedKeys", () => $2dc9189f096b533d$export$5206d47972fefe20);
/**
 * Use to remove `TS2339: Property 'id' does not exist on type 'object'` errors, e.g. when checking/refining variable of `unknown' type
 */ const $2dc9189f096b533d$export$dd642ef726dcde21 = (data, prop)=>prop in data;
const $2dc9189f096b533d$export$5206d47972fefe20 = (obj)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(obj);
};

});

parcelRegister("kVZSN", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d218b9a030da8fd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5d218b9a030da8fd$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    queues: {
        "id": "work-category.common.queues",
        "defaultMessage": "Queues"
    },
    serviceRequests: {
        "id": "work-category.common.service-requests",
        "defaultMessage": "Service requests"
    },
    incidents: {
        "id": "work-category.common.incidents",
        "defaultMessage": "Incidents"
    },
    changes: {
        "id": "work-category.common.changes",
        "defaultMessage": "Changes"
    },
    problems: {
        "id": "work-category.common.problems",
        "defaultMessage": "Problems"
    },
    postIncidentReviews: {
        "id": "work-category.common.post-incident-reviews",
        "defaultMessage": "Post-incident reviews"
    },
    noCategory: {
        "id": "work-category.common.no-category",
        "defaultMessage": "General"
    },
    queuesLower: {
        "id": "work-category.common.queues-lower",
        "defaultMessage": "queues"
    },
    serviceRequestsLower: {
        "id": "work-category.common.service-requests-lower",
        "defaultMessage": "service requests"
    },
    incidentsLower: {
        "id": "work-category.common.incidents-lower",
        "defaultMessage": "incidents"
    },
    changesLower: {
        "id": "work-category.common.changes-lower",
        "defaultMessage": "changes"
    },
    problemsLower: {
        "id": "work-category.common.problems-lower",
        "defaultMessage": "problems"
    },
    postIncidentReviewsLower: {
        "id": "work-category.common.post-incident-reviews-lower",
        "defaultMessage": "post-incident reviews"
    },
    noCategoryLower: {
        "id": "work-category.common.no-category-lower",
        "defaultMessage": "general"
    },
    developerEscalation: {
        "id": "work-category.common.developer-escalation",
        "defaultMessage": "Developer escalations"
    },
    developerEscalationLower: {
        "id": "work-category.common.developer-escalation-lower",
        "defaultMessage": "developer escalations"
    }
});

});


const $990f0449915d93bf$export$45919c8f50bb1db5 = 'SERVICEDESK_PRACTICES';

parcelRegister("1Sd5S", function(module, exports) {

let $15d4fdbed587eaa7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $15d4fdbed587eaa7$var$load("e7Uqc").then(()=>parcelRequire('8khb6'));

});


parcelRegister("lbaDt", function(module, exports) {

$parcel$export(module.exports, "requiredProjectProperties", () => $3477ceb4f9b98b2e$export$fbeae45a65f4a5a6);
$parcel$export(module.exports, "requiredFrontendProperties", () => $3477ceb4f9b98b2e$export$47241956725e3029);
$parcel$export(module.exports, "firstProjectResource", () => $3477ceb4f9b98b2e$export$f620cebb7e8eeeae);

var $9XE6b = parcelRequire("9XE6b");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
const $3477ceb4f9b98b2e$var$getKey = ({ match: match, query: query })=>// projectKey from url path/query or browse/{issueKey}
    (0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0];

const $3477ceb4f9b98b2e$var$getRequiredProjectPropertiesDataLoader = ()=>(parcelRequire("1rucY"));
const $3477ceb4f9b98b2e$export$fbeae45a65f4a5a6 = (0, $2M1hQ.createResource)({
    type: 'SERVICEDESK_REQUIRED_PROJECT_PROPERTIES',
    getKey: $3477ceb4f9b98b2e$var$getKey,
    getDataLoader: $3477ceb4f9b98b2e$var$getRequiredProjectPropertiesDataLoader,
    maxAge: 300000
});

const $3477ceb4f9b98b2e$var$getRequiredFrontendPropertiesDataLoader = ()=>(parcelRequire("kKV8g"));
const $3477ceb4f9b98b2e$var$ONE_DAY_IN_MILLIS = 86400000;
const $3477ceb4f9b98b2e$export$47241956725e3029 = (0, $2M1hQ.createResource)({
    type: 'SERVICEDESK_REQUIRED_FRONTEND_PROPERTIES',
    getKey: $3477ceb4f9b98b2e$var$getKey,
    getDataLoader: $3477ceb4f9b98b2e$var$getRequiredFrontendPropertiesDataLoader,
    maxAge: $3477ceb4f9b98b2e$var$ONE_DAY_IN_MILLIS
});

const $3477ceb4f9b98b2e$var$getFirstProjectDataLoader = ()=>(parcelRequire("gOkZi"));
const $3477ceb4f9b98b2e$var$TWELVE_HOURS_IN_MILLIS = 43200000;
const $3477ceb4f9b98b2e$export$f620cebb7e8eeeae = (0, $2M1hQ.createResource)({
    type: 'JSM_FIRST_PROJECT_RESOURCE',
    // first project is the same for the tenantId (there is also no per-project arg in request url). Therefore, only 1 key value is used.
    getKey: ()=>'none',
    getDataLoader: $3477ceb4f9b98b2e$var$getFirstProjectDataLoader,
    maxAge: $3477ceb4f9b98b2e$var$TWELVE_HOURS_IN_MILLIS
});

});
parcelRegister("1rucY", function(module, exports) {

let $10cfbecfee1abb90$var$load = (parcelRequire("28QjX"))(4);
module.exports = $10cfbecfee1abb90$var$load("3tedP").then(()=>parcelRequire('d4USv'));

});

parcelRegister("kKV8g", function(module, exports) {

let $03e643cdaa37a894$var$load = (parcelRequire("28QjX"))(4);
module.exports = $03e643cdaa37a894$var$load("5zkTp").then(()=>parcelRequire('7UDgf'));

});

parcelRegister("gOkZi", function(module, exports) {

let $c3d1989583b4dc61$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c3d1989583b4dc61$var$load("j1TMu").then(()=>parcelRequire('KbkKO'));

});


parcelRegister("1WlLE", function(module, exports) {

$parcel$export(module.exports, "queuesNavigationItems", () => $c68314f43531feff$export$4fed8be571897bef);
$parcel$export(module.exports, "priorityGroupResource", () => $c68314f43531feff$export$1f9ab301771fe42e);
$parcel$export(module.exports, "priorityGroupByProjectIdResource", () => $c68314f43531feff$export$f6133a181a1ec201);
$parcel$export(module.exports, "priorityGroupByProjectIdResourceSsr", () => $c68314f43531feff$export$b55fde45b61f13f4);
$parcel$export(module.exports, "issueListSsrResource", () => $c68314f43531feff$export$3d03cbaac8581e65);
$parcel$export(module.exports, "queueSidebarViewAllQueuesResource", () => $c68314f43531feff$export$5b6f88b653545aa1);
$parcel$export(module.exports, "queueNav4SidebarSelectionResource", () => $c68314f43531feff$export$dead630ba04fdfe4);
$parcel$export(module.exports, "queueSidebarQueuesCategoryStateResource", () => $c68314f43531feff$export$9e9033d678058efa);

var $9XE6b = parcelRequire("9XE6b");

var $4R6GH = parcelRequire("4R6GH");

var $jcw0u = parcelRequire("jcw0u");


var $jthxb = parcelRequire("jthxb");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");

var $89SaW = parcelRequire("89SaW");

var $8w6CZ = parcelRequire("8w6CZ");

var $fRrvi = parcelRequire("fRrvi");

const $c68314f43531feff$var$getDataLoader = ()=>(parcelRequire("a2czB"));

const $c68314f43531feff$var$getPriorityGroupDataLoader = ()=>(parcelRequire("dY0qY"));

const $c68314f43531feff$var$fetchIssueListDataLoader = ()=>(parcelRequire("jyyvg"));
const $c68314f43531feff$var$getCombinedProjectKeyAndQueueId = ({ match: match, query: query })=>`${(0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0]}-${(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.queueId', '')}`;
const $c68314f43531feff$var$getResourceKeyFromProjectKey = ({ match: match, query: query })=>`${(0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0]}`;
const $c68314f43531feff$export$4fed8be571897bef = (0, $2M1hQ.createResource)({
    type: (0, $8w6CZ.RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS),
    getKey: $c68314f43531feff$var$getResourceKeyFromProjectKey,
    getDataLoader: $c68314f43531feff$var$getDataLoader,
    maxAge: (0, $8w6CZ.ONE_DAY_IN_MILLIS)
});
const $c68314f43531feff$export$1f9ab301771fe42e = (0, $2M1hQ.createResource)({
    type: (0, $8w6CZ.RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS),
    getKey: $c68314f43531feff$var$getResourceKeyFromProjectKey,
    getDataLoader: $c68314f43531feff$var$getPriorityGroupDataLoader,
    maxAge: (0, $8w6CZ.ONE_DAY_IN_MILLIS),
    /**
	 * This resource will not load in SSR. Because priority group data resides in the JSM Kukama microservice.
	 * If we wanna fetch this resource during SSR, the request we're making from Tesseract -> Kukama is S2S, where Tesseract needs to know cookies information.
	 * We initially skipped SSR for fetching this resource, because we couldn’t retrieve the request cookie from JFE.
	 * Iiuc, the Jira team doesnt doesnt support this due to security concerns (the info is from JSM Queues team).
	 */ isBrowserOnly: true
});
const $c68314f43531feff$var$priorityGroupByProjectIdResourcePayload = {
    type: (0, $8w6CZ.RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS),
    getKey: $c68314f43531feff$var$getResourceKeyFromProjectKey,
    getData: async ({ match: match, query: query, dependencies: dependencies }, { tenantContext: { cloudId: cloudId } })=>{
        if ((0, $4R6GH.fg)('better_logging_for_priority_groups_by_project_id')) {
            // temporary logging of FAMA events to better understand what's going on in prod, no logic change really
            (0, $jcw0u.default)({
                meta: {
                    id: 'priorityGroupByProjectIdStart',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(match, query);
            if (!projectKey) (0, $jcw0u.default)({
                meta: {
                    id: 'priorityGroupByProjectIdNoProjectKey',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            if (!cloudId) (0, $jcw0u.default)({
                meta: {
                    id: 'priorityGroupByProjectIdNoCloudId',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            let data;
            try {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                data = await (0, $jthxb.consumeDependency)(dependencies, (0, $0f463a88567f1621$export$80a60a092d9ab81));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $jcw0u.default)({
                    meta: {
                        id: 'priorityGroupByProjectIdProjectContextError',
                        packageName: 'jiraRouterResourcesServiceDeskQueues',
                        teamName: 'jsm-flash'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            if (!data) (0, $jcw0u.default)({
                meta: {
                    id: 'priorityGroupByProjectIdNoProjectContextData',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            const projectId = data?.projectId;
            if (!projectId) (0, $jcw0u.default)({
                meta: {
                    id: 'priorityGroupByProjectIdNoProjectContextProjectId',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            try {
                return (0, $fRrvi.getPriorityGroupDataByProjectId)(projectId, projectKey, cloudId);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $jcw0u.default)({
                    meta: {
                        id: 'priorityGroupByProjectIdGettingPriorityGroupsDataError',
                        packageName: 'jiraRouterResourcesServiceDeskQueues',
                        teamName: 'jsm-flash'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                return (0, $fRrvi.getPriorityGroupDataByProjectId)(undefined, projectKey, cloudId);
            }
        }
        const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(match, query);
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const { projectId: projectId } = await (0, $jthxb.consumeDependency)(dependencies, (0, $0f463a88567f1621$export$80a60a092d9ab81));
            return (0, $fRrvi.getPriorityGroupDataByProjectId)(projectId, projectKey, cloudId);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'fetchProjectContextError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            return (0, $fRrvi.getPriorityGroupDataByProjectId)(undefined, projectKey, cloudId);
        }
    },
    maxAge: (0, $8w6CZ.ONE_DAY_IN_MILLIS),
    depends: [
        (0, $0f463a88567f1621$export$80a60a092d9ab81)
    ]
};
const $c68314f43531feff$export$f6133a181a1ec201 = (0, $2M1hQ.createResource)({
    ...$c68314f43531feff$var$priorityGroupByProjectIdResourcePayload,
    isBrowserOnly: true
});
const $c68314f43531feff$export$b55fde45b61f13f4 = (0, $2M1hQ.createResource)($c68314f43531feff$var$priorityGroupByProjectIdResourcePayload);
const $c68314f43531feff$export$3d03cbaac8581e65 = (0, $2M1hQ.createResource)({
    type: (0, $8w6CZ.RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR),
    getKey: $c68314f43531feff$var$getCombinedProjectKeyAndQueueId,
    getDataLoader: $c68314f43531feff$var$fetchIssueListDataLoader,
    maxAge: 0,
    // run this resource from server only
    skipBrowser: true
});
const $c68314f43531feff$export$5b6f88b653545aa1 = (0, $2M1hQ.createResource)({
    type: (0, $8w6CZ.SERVICEDESK_QUEUES_SIDEBAR_VIEW_ALL_QUEUES),
    getKey: $c68314f43531feff$var$getResourceKeyFromProjectKey,
    getData: async ({ match: match, query: query }, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>{
        const projectKey = $c68314f43531feff$var$getResourceKeyFromProjectKey({
            match: match,
            query: query
        });
        try {
            if (!atlassianAccountId) throw new Error('accountId is missing.');
            const response = await (0, $89SaW.getUserProperty)(atlassianAccountId, `jsm-all-queues-state_is-open-${projectKey}`);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'fetchJsmQueueSidebarViewAllQueuesResourceError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    },
    maxAge: (0, $8w6CZ.ONE_DAY_IN_MILLIS)
});
const $c68314f43531feff$export$dead630ba04fdfe4 = (0, $2M1hQ.createResource)({
    type: (0, $8w6CZ.SERVICEDESK_QUEUES_NAV_4_SIDEBAR_SELECTION),
    getKey: $c68314f43531feff$var$getResourceKeyFromProjectKey,
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>{
        try {
            if (!atlassianAccountId) throw new Error('accountId is missing.');
            const response = await (0, $89SaW.getUserProperty)(atlassianAccountId, (0, $8w6CZ.LOCAL_STORAGE_KEY_NAV_LOCATION));
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'fetchQueueNav4SidebarSelectionResourceError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    },
    maxAge: (0, $8w6CZ.ONE_DAY_IN_MILLIS)
});
const $c68314f43531feff$export$9e9033d678058efa = (0, $2M1hQ.createResource)({
    type: (0, $8w6CZ.SERVICEDESK_QUEUES_SIDEBAR_QUEUES_CATEGORY),
    getKey: $c68314f43531feff$var$getResourceKeyFromProjectKey,
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>{
        try {
            if (!atlassianAccountId) throw new Error('accountId is missing.');
            const response = await (0, $89SaW.getUserProperty)(atlassianAccountId, (0, $8w6CZ.LOCAL_STORAGE_KEY_CATEGORY));
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'fetchJsmQueueSidebarQueuesCategoryStateResourceError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    },
    maxAge: (0, $8w6CZ.ONE_DAY_IN_MILLIS)
});

});
parcelRegister("jthxb", function(module, exports) {

$parcel$export(module.exports, "consumeDependency", () => $c406e66b8b597668$export$a973ef9e17a326f);
async function $c406e66b8b597668$export$a973ef9e17a326f(dependencies, key) {
    // There is an inflight request, the response is source of truth
    if (dependencies[key]?.loading) return dependencies[key]?.promise;
    if (dependencies[key]?.error) // Our dependency errored out the last time it ran, we don't have the data
    throw dependencies[key]?.error;
    // Last response is what we want
    return dependencies[key]?.data;
}

});

parcelRegister("8w6CZ", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS", () => $a4c66eaf20e13a4d$export$a401e6d6b205c72b);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS", () => $a4c66eaf20e13a4d$export$2064262c540606ba);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR", () => $a4c66eaf20e13a4d$export$2733615da5b906f0);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_NAV3_QUEUE_GROUPS_STATE", () => $a4c66eaf20e13a4d$export$f510a6e9fec0630a);
$parcel$export(module.exports, "SERVICEDESK_QUEUES_SIDEBAR_VIEW_ALL_QUEUES", () => $a4c66eaf20e13a4d$export$94bda82b7db2173c);
$parcel$export(module.exports, "SERVICEDESK_QUEUES_NAV_4_SIDEBAR_SELECTION", () => $a4c66eaf20e13a4d$export$7e07da72de89b61c);
$parcel$export(module.exports, "SERVICEDESK_QUEUES_SIDEBAR_QUEUES_CATEGORY", () => $a4c66eaf20e13a4d$export$5b3a0c7c3b3456f);
$parcel$export(module.exports, "LOCAL_STORAGE_KEY_NAV_LOCATION", () => $a4c66eaf20e13a4d$export$3c59a089fdd2614a);
$parcel$export(module.exports, "LOCAL_STORAGE_KEY_CATEGORY", () => $a4c66eaf20e13a4d$export$9b99689db482a6bb);
$parcel$export(module.exports, "ONE_DAY_IN_MILLIS", () => $a4c66eaf20e13a4d$export$5a00268156ea5027);
const $a4c66eaf20e13a4d$export$a401e6d6b205c72b = 'SERVICEDESK_QUEUES_NAVIGATION_ITEMS';
const $a4c66eaf20e13a4d$export$2064262c540606ba = 'SERVICEDESK_QUEUES_PRIORITY_GROUPS';
const $a4c66eaf20e13a4d$export$2733615da5b906f0 = 'SERVICEDESK_QUEUES_ISSUE_LIST_SSR';
const $a4c66eaf20e13a4d$export$f510a6e9fec0630a = 'SERVICEDESK_NAV3_QUEUE_GROUPS_STATE';
const $a4c66eaf20e13a4d$export$94bda82b7db2173c = 'SERVICEDESK_QUEUES_SIDEBAR_VIEW_ALL_QUEUES';
const $a4c66eaf20e13a4d$export$7e07da72de89b61c = 'SERVICEDESK_QUEUES_NAV_4_SIDEBAR_SELECTION';
const $a4c66eaf20e13a4d$export$5b3a0c7c3b3456f = 'SERVICEDESK_QUEUES_SIDEBAR_QUEUES_CATEGORY';
const $a4c66eaf20e13a4d$export$3c59a089fdd2614a = 'queue-groups-nav-state';
const $a4c66eaf20e13a4d$export$9b99689db482a6bb = 'queues-category-state';
const $a4c66eaf20e13a4d$export$5a00268156ea5027 = 86400000;

});

parcelRegister("fRrvi", function(module, exports) {

$parcel$export(module.exports, "getPriorityGroupDataByProjectId", () => $2d01df2d1057a1ad$export$cf2bd2ec601ed920);

var $aymwz = parcelRequire("aymwz");

var $fn8B5 = parcelRequire("fn8B5");

var $8Uumt = parcelRequire("8Uumt");

var $bFU4G = parcelRequire("bFU4G");

var $5yJb9 = parcelRequire("5yJb9");

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $4R6GH = parcelRequire("4R6GH");
const $2d01df2d1057a1ad$var$fetchGroupsByKey = async (projectKey, cloudId)=>{
    return (0, $7f4tk.default)(`/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/groups?projectIdOrKey=${projectKey}${(0, $4R6GH.fg)('add-operation-query-param-to-queues-endpoints') ? '&operation=fetchPriorityGroups' : ''}`);
};
const $2d01df2d1057a1ad$var$fetchGroupsById = async (projectId, cloudId)=>{
    return (0, $7f4tk.default)(`/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/groups?projectId=${projectId}${(0, $4R6GH.fg)('add-operation-query-param-to-queues-endpoints') ? '&operation=fetchPriorityGroupsByProjectId' : ''}`);
};
const $2d01df2d1057a1ad$var$fetchGroupsByIdGraphql = async (projectId, cloudId)=>{
    const projectAri = `ari:cloud:jira:${cloudId}:project/${projectId}`;
    const result = await (0, $8Uumt.fetchQuery)((0, $5yJb9.default)(), (0, $aymwz.default), {
        projectAri: projectAri
    }).toPromise();
    if ((0, $4R6GH.fg)('better_logging_for_priority_groups_by_project_id')) // temporary logging of FAMA events to better understand what's going on in prod, no logic change really
    {
        if (!result?.queuesprioritygroups_priorityGroups?.results) (0, $jcw0u.default)({
            meta: {
                id: 'priorityGroupByProjectIdNoPriorityGroupsGraphql',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return {
        results: result?.queuesprioritygroups_priorityGroups?.results?.reduce((priorityGroups, priorityGroup)=>{
            // this mapping function is to make types happy
            if (priorityGroup && priorityGroup.id && priorityGroup.name && priorityGroup.category && priorityGroup.queueIds) priorityGroups.push({
                id: priorityGroup.id,
                name: priorityGroup.name,
                category: priorityGroup.category,
                queueIds: priorityGroup.queueIds.reduce((queueIds, queueId)=>{
                    if (queueId !== null && queueId !== undefined) queueIds.push(queueId);
                    return queueIds;
                // we need the below, otherwise reduce things the type is never[]
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                }, []),
                ...priorityGroup.version ? {
                    version: priorityGroup.version
                } : {},
                ...priorityGroup.creationMethod ? {
                    creationMethod: priorityGroup.creationMethod
                } : {}
            });
            return priorityGroups;
        }, // we need the below, otherwise reduce things the type is never[]
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        []) ?? []
    };
};
const $2d01df2d1057a1ad$export$cf2bd2ec601ed920 = async (projectId, projectKey, cloudId)=>{
    const fetchStartTime = performance.now();
    let data;
    if (projectId) {
        (0, $4R6GH.fg)('queues-prioritygroups-relay') ? data = await $2d01df2d1057a1ad$var$fetchGroupsByIdGraphql(projectId, cloudId) : data = await $2d01df2d1057a1ad$var$fetchGroupsById(projectId, cloudId);
        if (!(0, $4R6GH.fg)('add-operation-query-param-to-queues-endpoints')) (0, $bFU4G.addSpanToAll)('fetch', 'fetchPriorityGroupsByProjectId', [
            {
                name: 'network'
            }
        ], fetchStartTime, performance.now());
        if (!(0, $4R6GH.fg)('queues-prioritygroups-relay') && (0, $4R6GH.fg)('better_logging_for_priority_groups_by_project_id')) {
            // temporary logging of FAMA events to better understand what's going on in prod, no logic change really
            if (!data) (0, $jcw0u.default)({
                meta: {
                    id: 'priorityGroupByProjectIdNoPriorityGroupsRestData',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            if (!data.results) (0, $jcw0u.default)({
                meta: {
                    id: 'priorityGroupByProjectIdNoPriorityGroupsRestDataResults',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    } else {
        (0, $jcw0u.default)({
            meta: {
                id: 'fetchPriorityGroupsProjectIdUndefined',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        data = await $2d01df2d1057a1ad$var$fetchGroupsByKey(projectKey, cloudId);
        if (!(0, $4R6GH.fg)('add-operation-query-param-to-queues-endpoints')) (0, $bFU4G.addSpanToAll)('fetch', 'fetchPriorityGroups', [
            {
                name: 'network'
            }
        ], fetchStartTime, performance.now());
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const processedData = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(data.results.map((group)=>({
            ...group,
            queues: group.queueIds || []
        })), 'category');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return processedData;
};

});
parcelRegister("aymwz", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ee8e4029fc17578$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<509a54dc797b22dc5439dcc947ec5646>>
 * @relayHash aa856b961b835b1f9323042c281fa03b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a06f924d3b993614f20cc99cb824d0a15370bb2745568a6f165c081ee7493530
const $2ee8e4029fc17578$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "projectId",
                    "variableName": "projectAri"
                }
            ],
            "concreteType": "QueuesPriorityGroupsResults",
            "kind": "LinkedField",
            "name": "queuesprioritygroups_priorityGroups",
            "plural": false,
            "selections": [
                {
                    "concreteType": "QueuesPriorityGroupsResultsGroup",
                    "kind": "LinkedField",
                    "name": "results",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "category"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "queueIds"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "version"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "creationMethod"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "getPriorityGroupDataByProjectIdQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "getPriorityGroupDataByProjectIdQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "a06f924d3b993614f20cc99cb824d0a15370bb2745568a6f165c081ee7493530",
            "metadata": {},
            "name": "getPriorityGroupDataByProjectIdQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$2ee8e4029fc17578$var$node.hash = "e99dcef5a507344c549819dcfbf09d31";
var $2ee8e4029fc17578$export$2e2bcd8739ae039 = $2ee8e4029fc17578$var$node;

});

parcelRegister("fn8B5", function(module, exports) {

var $1m3dq = parcelRequire("1m3dq");

var $4CZTG = parcelRequire("4CZTG");
/** Used for built-in method references. */ var $b30fac385487af61$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b30fac385487af61$var$hasOwnProperty = $b30fac385487af61$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $b30fac385487af61$var$groupBy = $4CZTG(function(result, value, key) {
    if ($b30fac385487af61$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else $1m3dq(result, key, [
        value
    ]);
});
module.exports = $b30fac385487af61$var$groupBy;

});


parcelRegister("a2czB", function(module, exports) {

let $74e3d816256db699$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $74e3d816256db699$var$load("kVX56"),
    $74e3d816256db699$var$load("aG1rf")
]).then(()=>parcelRequire('lini2'));

});

parcelRegister("dY0qY", function(module, exports) {

let $a2b13728cd2933bf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a2b13728cd2933bf$var$load("dg10h").then(()=>parcelRequire('etJR3'));

});

parcelRegister("jyyvg", function(module, exports) {

let $e3cbf4eb1d60bd0a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e3cbf4eb1d60bd0a$var$load("3pKue").then(()=>parcelRequire('bmzqI'));

});


parcelRegister("2Zfed", function(module, exports) {

$parcel$export(module.exports, "nav3QueueGroupsStateResource", () => $9aaf4a7b4f3d3895$export$53d0e5294221581);

var $9XE6b = parcelRequire("9XE6b");

var $2M1hQ = parcelRequire("2M1hQ");

var $jcw0u = parcelRequire("jcw0u");

var $1nb22 = parcelRequire("1nb22");

var $8w6CZ = parcelRequire("8w6CZ");

var $1FAuA = parcelRequire("1FAuA");
const $9aaf4a7b4f3d3895$var$getProjectKey = ({ match: match, query: query })=>// projectKey from url path or browse/{issueKey}
    (0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0];
const $9aaf4a7b4f3d3895$export$53d0e5294221581 = (0, $2M1hQ.createResource)({
    type: (0, $8w6CZ.RESOURCE_TYPE_SERVICEDESK_NAV3_QUEUE_GROUPS_STATE),
    getKey: $9aaf4a7b4f3d3895$var$getProjectKey,
    getData: async ({ match: match, query: query }, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>{
        if (!atlassianAccountId) return undefined;
        const projectKey = $9aaf4a7b4f3d3895$var$getProjectKey({
            match: match,
            query: query
        });
        try {
            return await (0, $1FAuA.getQueueGroupsStateFromUserProperty)(projectKey, atlassianAccountId);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'getQueueGroupsStateInUserPropertyResourceError'
                }
            });
            return undefined;
        }
    },
    maxAge: (0, $8w6CZ.ONE_DAY_IN_MILLIS)
});

});
parcelRegister("1FAuA", function(module, exports) {

$parcel$export(module.exports, "setQueueGroupsStateInUserProperty", () => $ebaf9bc45b7e52ed$export$e316bbc9b5e5100d);
$parcel$export(module.exports, "getQueueGroupsStateFromUserProperty", () => $ebaf9bc45b7e52ed$export$87bc602eb5671315);

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");
const $ebaf9bc45b7e52ed$export$bb10a02fc2feb574 = 'jsm-queue-groups-state-selected-group-id';
const $ebaf9bc45b7e52ed$export$e316bbc9b5e5100d = async (projectKey, value, accountId)=>{
    try {
        (0, $89SaW.setUserProperties)(accountId, `${$ebaf9bc45b7e52ed$export$bb10a02fc2feb574}_${projectKey}`, JSON.stringify(value));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'setQueueGroupsStateInUserPropertyError'
            }
        });
        throw error;
    }
};
const $ebaf9bc45b7e52ed$export$87bc602eb5671315 = async (projectKey, accountId)=>{
    try {
        return await (0, $89SaW.getUserProperty)(accountId, `${$ebaf9bc45b7e52ed$export$bb10a02fc2feb574}_${projectKey}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'getQueueGroupsStateFromUserPropertyError'
            }
        });
        throw error;
    }
};

});


parcelRegister("2cxgG", function(module, exports) {

$parcel$export(module.exports, "virtualAgentOnboardingResource", () => $e9d51fb7135f5412$export$d39827c053fda3aa);

var $4R6GH = parcelRequire("4R6GH");

var $ao2h1 = parcelRequire("ao2h1");

var $2j6fy = parcelRequire("2j6fy");
const $e9d51fb7135f5412$export$d39827c053fda3aa = (0, $ao2h1.createRelayResource)({
    type: 'SERVICEDESK_VIRTUAL_AGENT_ONBOARDING',
    isBrowserOnly: true,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $2j6fy.default),
            variables: {
                cloudId: tenantContext.cloudId,
                key: match.params.projectKey || '',
                checkForAiEnabledFF: (0, $4R6GH.fg)('require_ai_enabled_for_jsm_virtual_agent')
            }
        })
});

});
parcelRegister("2j6fy", function(module, exports) {

$parcel$export(module.exports, "default", () => $45b605658e5ce20d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8391836c727c96074b367b5cee339a0d>>
 * @relayHash a752dde009c93b4975b47e740db8b1bd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 43c453bca1e65ebbd87f7974bea4d6b5c78178b9b9507ff8b40972a4e4fe9ecf

var $7oHmH = parcelRequire("7oHmH");
const $45b605658e5ce20d$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "43c453bca1e65ebbd87f7974bea4d6b5c78178b9b9507ff8b40972a4e4fe9ecf",
        "metadata": {},
        "name": "mainVirtualAgentSidebarQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $7oHmH.default)
        }
    }
};
var $45b605658e5ce20d$export$2e2bcd8739ae039 = $45b605658e5ce20d$var$node;

});
parcelRegister("7oHmH", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f0ef421b1798a33$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $3f0ef421b1798a33$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('require_ai_enabled_for_jsm_virtual_agent');
    }
};

});



parcelRegister("6sNnq", function(module, exports) {

$parcel$export(module.exports, "featuresResource", () => $d0a02e466fb63798$export$16f81cc9da2c6c47);

var $9XE6b = parcelRequire("9XE6b");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");


const $d0a02e466fb63798$var$getDataLoader = ()=>Promise.resolve((parcelRequire("frQmB")));
const $d0a02e466fb63798$var$ONE_DAY_IN_MILLIS = 86400000;
const $d0a02e466fb63798$export$16f81cc9da2c6c47 = (0, $2M1hQ.createResource)({
    type: (0, $68b2e6d16c6e9952$export$3441b129810f29ed),
    getKey: ({ match: match, query: query })=>// projectKey from url path or browse/{issueKey}
        (0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0],
    getDataLoader: $d0a02e466fb63798$var$getDataLoader,
    maxAge: $d0a02e466fb63798$var$ONE_DAY_IN_MILLIS
});

});
const $68b2e6d16c6e9952$export$3441b129810f29ed = 'SERVICEDESK_FEATURES';


parcelRegister("7GnDe", function(module, exports) {

$parcel$export(module.exports, "incidentsInitialPageChecksResource", () => $08a008dcde68e650$export$b2b94ce8ba590cc8);
$parcel$export(module.exports, "incidentsCustomFieldIdResource", () => $08a008dcde68e650$export$e81d7afef87ae597);
$parcel$export(module.exports, "incidentExperimentTraitResource", () => $08a008dcde68e650$export$31c6945718067be3);
$parcel$export(module.exports, "incidentExperimentTraitResourceOnNav3Only", () => $08a008dcde68e650$export$6fc19cf1d90e9453);
$parcel$export(module.exports, "incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes", () => $08a008dcde68e650$export$2e6b9e6402ff1d9b);

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");

var $gNStA = parcelRequire("gNStA");

var $2M1hQ = parcelRequire("2M1hQ");


const $08a008dcde68e650$export$b2b94ce8ba590cc8 = (0, $2M1hQ.createResource)({
    type: (0, $0ec4f2aa733ae93d$export$9018fdf9116edd9b),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("eA3vK"))
});

const $08a008dcde68e650$export$e81d7afef87ae597 = (0, $2M1hQ.createResource)({
    type: (0, $0ec4f2aa733ae93d$export$508a7d8e5c6b1bf),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("2QXl3"))
});

const $08a008dcde68e650$export$31c6945718067be3 = (0, $2M1hQ.createResource)({
    type: (0, $0ec4f2aa733ae93d$export$1d954e05e596a51e),
    getKey: ()=>'incident_experiment_traits',
    getDataLoader: ()=>(parcelRequire("1tPE5")),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $08a008dcde68e650$export$6fc19cf1d90e9453 = (0, $gNStA.resourceWithCondition2)(()=>!((0, $3HwlS.getWillShowNav4)() && ((0, $4R6GH.fg)('perf-push-big-components-remove-incidents-resource') || (0, $4R6GH.fg)('perf-push-big-components-nav-remove-resources'))), $08a008dcde68e650$export$31c6945718067be3);
const $08a008dcde68e650$export$2e6b9e6402ff1d9b = (0, $gNStA.resourceWithCondition2)(()=>!((0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('blu-5573-remove-incident-resouce')), $08a008dcde68e650$export$31c6945718067be3);

});
const $0ec4f2aa733ae93d$export$9018fdf9116edd9b = 'INCIDENTS_PAGE_INITIAL_CHECKS';
const $0ec4f2aa733ae93d$export$508a7d8e5c6b1bf = 'INCIDENTS_PAGE_CUSTOM_FIELD_ID';
const $0ec4f2aa733ae93d$export$1d954e05e596a51e = 'INCIDENT_EXPERIMENT_TRAITS';

parcelRegister("eA3vK", function(module, exports) {

let $a9d726b5ee8125b7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a9d726b5ee8125b7$var$load("g5RXm").then(()=>parcelRequire('8lQN4'));

});

parcelRegister("2QXl3", function(module, exports) {

let $213e777c9e548445$var$load = (parcelRequire("28QjX"))(4);
module.exports = $213e777c9e548445$var$load("aq0V6").then(()=>parcelRequire('i0mY9'));

});

parcelRegister("1tPE5", function(module, exports) {

let $11408f9e8be4e3bd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $11408f9e8be4e3bd$var$load("7YGJS").then(()=>parcelRequire('iwLnj'));

});


parcelRegister("gRzZD", function(module, exports) {

$parcel$export(module.exports, "workspaceResource", () => $d68afc54033ea939$export$2f02c3f971168d17);

var $2M1hQ = parcelRequire("2M1hQ");

var $ahEft = parcelRequire("ahEft");
const $d68afc54033ea939$export$9b3a4d71d46e5ee7 = 'JSM_INSIGHT_WORKSPACE_CONTEXT';
const $d68afc54033ea939$export$2f02c3f971168d17 = (0, $2M1hQ.createResource)({
    type: $d68afc54033ea939$export$9b3a4d71d46e5ee7,
    getKey: ()=>'state',
    getData: async (_, routerContext)=>{
        const workspaceId = await (0, $ahEft.default)(_, routerContext);
        return workspaceId;
    },
    maxAge: Infinity
});

});
parcelRegister("ahEft", function(module, exports) {

$parcel$export(module.exports, "getUserJsmLicenceState", () => $b8bed038f2dce149$export$65bf73aad2afa39);
$parcel$export(module.exports, "isPremiumInstance", () => $b8bed038f2dce149$export$abb609d3bcbb74f6);
$parcel$export(module.exports, "isLicensedPremiumUser", () => $b8bed038f2dce149$export$d7b4c32773b1c643);
$parcel$export(module.exports, "default", () => $b8bed038f2dce149$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");

var $4VpwK = parcelRequire("4VpwK");

var $ktP1V = parcelRequire("ktP1V");

var $5Ny9E = parcelRequire("5Ny9E");

var $ldyPw = parcelRequire("ldyPw");

const $b8bed038f2dce149$export$530f260cc76f04ff = (_baseUrl)=>'/rest/servicedesk/cmdb/latest/workspace';
const $b8bed038f2dce149$export$65bf73aad2afa39 = (tenantContext)=>{
    const { licensedProducts: licensedProducts, appPermissions: appPermissions } = tenantContext;
    const hasJsmLicence = licensedProducts && licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61];
    const isJsmLicensedUser = appPermissions && appPermissions.hasServiceDeskAccess;
    if (!hasJsmLicence) return {
        siteHasJsmInstalled: false
    };
    return {
        siteHasJsmInstalled: true,
        siteIsPremium: $b8bed038f2dce149$export$abb609d3bcbb74f6(tenantContext),
        userLicensed: isJsmLicensedUser
    };
};
const $b8bed038f2dce149$export$abb609d3bcbb74f6 = (tenantContext)=>{
    const { appEditions: { serviceDesk: serviceDeskAppEdition } } = tenantContext;
    const isPremium = serviceDeskAppEdition === (0, $ldyPw.PREMIUM_EDITION);
    return isPremium;
};
const $b8bed038f2dce149$export$d7b4c32773b1c643 = (tenantContext)=>{
    const { appPermissions: appPermissions } = tenantContext;
    const isPremium = $b8bed038f2dce149$export$abb609d3bcbb74f6(tenantContext);
    const isLicensedUser = appPermissions && appPermissions.hasServiceDeskAccess;
    return isPremium && isLicensedUser;
};
const $b8bed038f2dce149$var$transformResponse = (response)=>{
    const ids = response.results ?? [];
    return ids.length ? (0, $5Ny9E.toWorkspaceId)(ids[0].id) : null;
};
const $b8bed038f2dce149$export$e1d718dfe6dad973 = (routerContext, { tenantContext: tenantContext })=>{
    const { baseUrl: baseUrl } = tenantContext;
    if ($b8bed038f2dce149$export$d7b4c32773b1c643(tenantContext) === false || !(0, $ktP1V.isCMDBEnabledInEnvironment)(tenantContext.cmdbDisabledInFedRAMP)) return null;
    return (0, $4VpwK.performCmdbGetRequest)($b8bed038f2dce149$export$530f260cc76f04ff(baseUrl)).then($b8bed038f2dce149$var$transformResponse).catch((error)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('spa.view.routes.servicedesk.workspace-id', 'Error while fetching servicedesk Insight workspace id', error);
        return null;
    });
};
var $b8bed038f2dce149$export$2e2bcd8739ae039 = $b8bed038f2dce149$export$e1d718dfe6dad973;

});
parcelRegister("4VpwK", function(module, exports) {

$parcel$export(module.exports, "performCmdbGetRequest", () => $270bf98960acb19c$export$a252413f43ec7247);
$parcel$export(module.exports, "performCmdbPostRequest", () => $270bf98960acb19c$export$d68a9f67166d25a2);
$parcel$export(module.exports, "performCmdbPutRequest", () => $270bf98960acb19c$export$326b7407f501f98b);
$parcel$export(module.exports, "performCmdbDeleteRequest", () => $270bf98960acb19c$export$b198eb14f22c12e6);

var $4R6GH = parcelRequire("4R6GH");

var $5HnTq = parcelRequire("5HnTq");

var $eusud = parcelRequire("eusud");
const $270bf98960acb19c$export$d5e211a0106aa636 = {
    'X-Request-Source': 'cmdb-frontend'
};
const $270bf98960acb19c$export$a252413f43ec7247 = (url, options)=>(0, $eusud.performGetRequest)(url, $270bf98960acb19c$export$235b7fc70b9fc359(url, options));
const $270bf98960acb19c$export$d68a9f67166d25a2 = (url, options)=>(0, $eusud.performPostRequest)(url, $270bf98960acb19c$export$235b7fc70b9fc359(url, options));
const $270bf98960acb19c$export$326b7407f501f98b = (url, options)=>(0, $eusud.performPutRequest)(url, $270bf98960acb19c$export$235b7fc70b9fc359(url, options));
const $270bf98960acb19c$export$b198eb14f22c12e6 = (url, options)=>(0, $eusud.performDeleteRequest)(url, $270bf98960acb19c$export$235b7fc70b9fc359(url, options));
const $270bf98960acb19c$export$235b7fc70b9fc359 = (url, options)=>{
    const defaultOptions = (0, $5HnTq.getDefaultOptions)(url);
    return (0, $4R6GH.fg)('fly-2529-cmdb-client-send-request-source-header') ? {
        ...defaultOptions,
        ...options,
        headers: {
            ...defaultOptions.headers,
            ...options?.headers,
            ...$270bf98960acb19c$export$d5e211a0106aa636
        }
    } : options;
};

});

parcelRegister("ktP1V", function(module, exports) {

$parcel$export(module.exports, "isCMDBEnabledInEnvironment", () => $84a32a7226f836c4$export$6dbfb62369f79a64);

var $c04PQ = parcelRequire("c04PQ");

var $4R6GH = parcelRequire("4R6GH");
const $84a32a7226f836c4$export$6dbfb62369f79a64 = (cmdbDisabledInFedRAMPForTenant)=>!(0, $c04PQ.isFedRamp)() || (0, $c04PQ.isFedRamp)() && ((0, $4R6GH.fg)('use_cmdb_scr12_enabled') ? cmdbDisabledInFedRAMPForTenant != null && !cmdbDisabledInFedRAMPForTenant : (0, $4R6GH.fg)('jsm-assets-fedramp-ui'));

});

parcelRegister("5Ny9E", function(module, exports) {

$parcel$export(module.exports, "toSchemaId", () => $a330a4171d28d64c$export$d577b7f3b832f656);
$parcel$export(module.exports, "toCmdbObjectId", () => $a330a4171d28d64c$export$1ba342595bc7be13);
$parcel$export(module.exports, "toCmdbObjectTypeId", () => $a330a4171d28d64c$export$b46e25afa2bab6a);
$parcel$export(module.exports, "toObjectCommentId", () => $a330a4171d28d64c$export$ece2917434bb0a8c);
$parcel$export(module.exports, "toWorkspaceId", () => $a330a4171d28d64c$export$d002b8d7821b6b59);
$parcel$export(module.exports, "toObjectTypeAttributeId", () => $a330a4171d28d64c$export$cfd92c18cee8add7);
const $a330a4171d28d64c$export$d577b7f3b832f656 = (id)=>id;
const $a330a4171d28d64c$export$1ba342595bc7be13 = (id)=>id;
const $a330a4171d28d64c$export$b46e25afa2bab6a = (id)=>id;
const $a330a4171d28d64c$export$ece2917434bb0a8c = (id)=>id;
const $a330a4171d28d64c$export$d002b8d7821b6b59 = (id)=>id;
const $a330a4171d28d64c$export$cfd92c18cee8add7 = (id)=>id;

});

const $c06e1abca7c13910$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $c06e1abca7c13910$export$e9c56aa3b027d98f = 'jira-customer-service';
const $c06e1abca7c13910$export$1346c9aa3cbb477d = 'jira-software';
const $c06e1abca7c13910$export$202f50ee62667e32 = 'jira-product-discovery';
const $c06e1abca7c13910$export$db515c8cec1e6f79 = 'jira-core';
const $c06e1abca7c13910$export$c811f21c9ad05dc2 = 'confluence';
const $c06e1abca7c13910$export$961148c98d198270 = 'opsgenie';



parcelRegister("lfnsv", function(module, exports) {

$parcel$export(module.exports, "boardDetailsResource", () => $d78990d38f225e07$export$6c6984c55b171c5d);
$parcel$export(module.exports, "getBoardDetailsResource", () => $d78990d38f225e07$export$b67eabcfc08e7c62);

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $2M1hQ = parcelRequire("2M1hQ");

var $PK2Tm = parcelRequire("PK2Tm");
const $d78990d38f225e07$export$90ce361a5838e31e = async (boardId)=>{
    try {
        return await (0, $7f4tk.default)(`/rest/agile/1.0/board/${boardId}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'getBoardDetailsRequest',
                packageName: 'jiraRouterResourcesClassicProjects',
                teamName: 'a4t-pandora'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $d78990d38f225e07$export$6c6984c55b171c5d = (0, $2M1hQ.createResource)({
    type: 'CLASSIC_BOARD_SETTING_BOARD_DETAILS',
    getKey: (routerContext)=>(0, $PK2Tm.getConfigFromRouterContext)(routerContext) ? 'cmp-board-settings' : 'not-cmp-board-setting',
    getData: async (routerContext)=>{
        const boardId = routerContext.match.params?.boardId ?? '';
        if ((0, $PK2Tm.getConfigFromRouterContext)(routerContext)) return $d78990d38f225e07$export$90ce361a5838e31e(boardId);
        return null;
    }
});
const $d78990d38f225e07$export$b67eabcfc08e7c62 = ()=>$d78990d38f225e07$export$6c6984c55b171c5d;

});
parcelRegister("PK2Tm", function(module, exports) {

$parcel$export(module.exports, "buildAllDataQueryParams", () => $df00ee708c57537c$export$487708debaea6de3);
$parcel$export(module.exports, "getInlineScriptData", () => $df00ee708c57537c$export$7bd4b867b9305f97);
$parcel$export(module.exports, "getRapidViewConfigFromRouteName", () => $df00ee708c57537c$export$62c86c4062215346);
$parcel$export(module.exports, "getRequiredResourceList", () => $df00ee708c57537c$export$7bff98a3d459b1b8);
$parcel$export(module.exports, "getConfigFromRouterContext", () => $df00ee708c57537c$export$1705c550e5b835bf);

var $4R6GH = parcelRequire("4R6GH");

var $1odlY = parcelRequire("1odlY");

var $9hNId = parcelRequire("9hNId");
const $df00ee708c57537c$export$487708debaea6de3 = (query, match)=>{
    const { rapidView: rapidView, quickFilter: quickFilter, projectKey: queryProjectKey, etag: etag } = query;
    const boardId = match.params.boardId || rapidView;
    const projectKey = match.params.projectKey || queryProjectKey;
    let activeQuickFilters = '';
    if (quickFilter) activeQuickFilters = Array.isArray(quickFilter) ? quickFilter.reduce((prevFilter, nextFilter)=>`${prevFilter}&activeQuickFilters=${nextFilter}`, activeQuickFilters) : `&activeQuickFilters=${quickFilter}`;
    const etagParam = etag ? `&etag=${etag}` : '';
    const projectKeyParam = projectKey ? `&selectedProjectKey=${projectKey}` : '';
    const { GH: GH } = window;
    const forceConsistency = '&forceConsistency=true';
    GH?.RapidBoard?.State?.setRapidViewIdForEventuallyConsistentBoard(undefined);
    return `rapidViewId=${boardId}${projectKeyParam}${activeQuickFilters}${etagParam}${forceConsistency}`;
};
const $df00ee708c57537c$var$cleanUpInlineScript = (dataName)=>{
    // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    delete window[dataName];
};
const $df00ee708c57537c$export$7bd4b867b9305f97 = (dataName)=>{
    // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const req = window[dataName];
    if (!req) return null;
    if (req.readyState === req.DONE && req.status !== 200) {
        $df00ee708c57537c$var$cleanUpInlineScript(dataName);
        return null;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new Promise((r)=>{
        if (req.readyState === req.DONE && req.status === 200) {
            $df00ee708c57537c$var$cleanUpInlineScript(dataName);
            r(JSON.parse(req.response));
        } else req.addEventListener('load', ()=>{
            $df00ee708c57537c$var$cleanUpInlineScript(dataName);
            r(JSON.parse(req.response));
        });
    });
};
const $df00ee708c57537c$export$62c86c4062215346 = (routeName)=>{
    for (const routeConfig of Object.values((0, $9hNId.RAPID_VIEW_ROUTE_CONFIG))){
        if (routeConfig.routes?.includes(routeName)) return routeConfig;
    }
    return (0, $9hNId.RAPID_VIEW_ROUTE_CONFIG).DEFAULT;
};
const $df00ee708c57537c$export$7bff98a3d459b1b8 = (view)=>{
    let rapidboardResources = (0, $1odlY.WRM_RESOURCES_ARRAY);
    if ((0, $4R6GH.fg)('reports-overview-page-migration')) {
        if (view) {
            const routeConfig = $df00ee708c57537c$export$62c86c4062215346(view);
            return [
                ...(0, $1odlY.WRM_HERITAGE_RESOURCES_FHD_ARRAY),
                ...routeConfig.resources
            ];
        }
        return [
            ...(0, $1odlY.WRM_HERITAGE_RESOURCES_FHD_ARRAY),
            ...(0, $9hNId.RAPID_VIEW_ROUTE_CONFIG).DEFAULT.resources
        ];
    }
    // eslint-disable-next-line default-case
    switch(view){
        case 'rapidboard-board':
        case 'rapidboard-board-embed':
        case 'rapidboard-user-board':
        case 'servicedesk-boards':
        case 'servicedesk-queues-custom-board':
        case 'servicedesk-queues-practice-custom-board':
            rapidboardResources = (0, $1odlY.WRM_BOARD_RESOURCES_FHD_ARRAY);
            break;
        case 'rapidboard-backlog':
        case 'rapidboard-user-backlog':
        case 'rapidboard-backlog-embed':
            rapidboardResources = (0, $1odlY.WRM_BACKLOG_RESOURCES_FHD_ARRAY);
            break;
    }
    return [
        ...(0, $1odlY.WRM_HERITAGE_RESOURCES_FHD_ARRAY),
        ...rapidboardResources
    ];
};
function $df00ee708c57537c$export$1705c550e5b835bf(routerContext) {
    return routerContext.match?.params.config || routerContext.query?.config || '';
}

});
parcelRegister("1odlY", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_BOARD_CONFIG", () => $fa7f7a1583a8dcf1$export$88e2a0b89be042c1);
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA", () => $fa7f7a1583a8dcf1$export$ba075d0985968d1c);
$parcel$export(module.exports, "RESOURCE_TYPE_PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS", () => $fa7f7a1583a8dcf1$export$395f77888d07f2e0);
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_RESOURCE", () => $fa7f7a1583a8dcf1$export$4f7c4e3508fd2a07);
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_WRM_BUNDLE", () => $fa7f7a1583a8dcf1$export$3328c8e71fda97bb);
$parcel$export(module.exports, "WRM_RESOURCES_ARRAY", () => $fa7f7a1583a8dcf1$export$ef21257df3d71188);
$parcel$export(module.exports, "WRM_HERITAGE_RESOURCES_FHD_ARRAY", () => $fa7f7a1583a8dcf1$export$ccd0929652c235de);
$parcel$export(module.exports, "WRM_BOARD_RESOURCES_FHD_ARRAY", () => $fa7f7a1583a8dcf1$export$1d16bdcc94a40107);
$parcel$export(module.exports, "WRM_BACKLOG_RESOURCES_FHD_ARRAY", () => $fa7f7a1583a8dcf1$export$1f599d2eef0a7281);
const $fa7f7a1583a8dcf1$export$88e2a0b89be042c1 = 'RESOURCE_RAPIDBOARDS_BOARD_CONFIG';
const $fa7f7a1583a8dcf1$export$ba075d0985968d1c = 'RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA';
const $fa7f7a1583a8dcf1$export$395f77888d07f2e0 = 'PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS';
const $fa7f7a1583a8dcf1$export$4f7c4e3508fd2a07 = 'RESOURCE_TYPE_RAPIDBOARDS_RESOURCE';
const $fa7f7a1583a8dcf1$export$3328c8e71fda97bb = 'RESOURCE_RAPIDBOARDS_WRM_BUNDLE';
const $fa7f7a1583a8dcf1$export$ef21257df3d71188 = [
    '_super',
    'wrc!greenhopper-rapid-non-gadget',
    'wrc!gh-rapid',
    'wrc!jira.global',
    'wrc!jira.general',
    'wrc!atl.global',
    // Required to prevent an error on initial loading of reports
    'wrc!jira.webresources:header',
    // Required for Control Chart report page
    'wrc!jira.webresources:calendar',
    'wrc!jira.webresources:calendar-en',
    'wrc!jira.webresources:jira.webresources:calendar-localisation-moment',
    // Required for explicit usage of jQuery
    'wrc!com.atlassian.jira.project-templates-plugin:project-templates-plugin-resources',
    // Required for the styles of the toggle button when transitioning from reports to board settings
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-aui-toggle',
    // Required for the profile card in board settings, that doesn't really render because it has wrong
    // parameters and it has been broken for ages, but at least prevents noisy errors
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:profilecard',
    'wrc!gh-rapid-config',
    'wrc!gh-rapid-analytics',
    'wrc!gh-rapid-charts',
    'wrc!jira.webresources:mentions-feature',
    'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-dialog-resources-ctx'
];
const $fa7f7a1583a8dcf1$export$ccd0929652c235de = [];
const $fa7f7a1583a8dcf1$export$1d16bdcc94a40107 = [
    'wrc!gh-rapid-lwf-board-fhd',
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:feature-flags',
    'wrc!com.atlassian.auiplugin:aui-spinner',
    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
    'wrc!com.atlassian.analytics.analytics-client:js-events'
];
const $fa7f7a1583a8dcf1$export$1f599d2eef0a7281 = [
    'wrc!gh-rapid-backlog-fhd',
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:header',
    'wrc!jira.webresources:feature-flags',
    'wrc!com.atlassian.auiplugin:aui-spinner',
    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
    'wrc!com.atlassian.analytics.analytics-client:js-events'
];

});

parcelRegister("9hNId", function(module, exports) {

$parcel$export(module.exports, "RAPID_VIEW_ROUTE_CONFIG", () => $f34cebd5a04e9077$export$99d0df2f58f37dfe);

var $1odlY = parcelRequire("1odlY");
const $f34cebd5a04e9077$export$99d0df2f58f37dfe = {
    BOARD: {
        routes: [
            'rapidboard-board',
            'rapidboard-board-embed',
            'rapidboard-user-board',
            'servicedesk-boards',
            'servicedesk-queues-custom-board',
            'servicedesk-queues-practice-custom-board'
        ],
        resources: (0, $1odlY.WRM_BOARD_RESOURCES_FHD_ARRAY),
        stateKey: 'board-state'
    },
    BACKLOG: {
        routes: [
            'rapidboard-backlog',
            'rapidboard-user-backlog',
            'rapidboard-backlog-embed'
        ],
        resources: (0, $1odlY.WRM_BACKLOG_RESOURCES_FHD_ARRAY),
        stateKey: 'backlog-state'
    },
    DEFAULT: {
        resources: (0, $1odlY.WRM_RESOURCES_ARRAY),
        stateKey: 'report-state'
    }
};

});



parcelRegister("f5kpo", function(module, exports) {

$parcel$export(module.exports, "shouldLoadUIFBoardResources", () => $e96bf35f407138bb$export$d8d4641986a9ac7f);
$parcel$export(module.exports, "getRapidboardResources", () => $e96bf35f407138bb$export$3a5e56bd5231a56b);
$parcel$export(module.exports, "getRapidBoardDataResource", () => $e96bf35f407138bb$export$1c63de7f548f965f);
$parcel$export(module.exports, "getUIFBacklogDataResource", () => $e96bf35f407138bb$export$ee826506b3baa13a);

var $4R6GH = parcelRequire("4R6GH");

var $5Nutl = parcelRequire("5Nutl");

var $gNStA = parcelRequire("gNStA");

var $i6CNv = parcelRequire("i6CNv");

var $kdyVI = parcelRequire("kdyVI");

var $gQ2J4 = parcelRequire("gQ2J4");

var $fox5Q = parcelRequire("fox5Q");
const $e96bf35f407138bb$export$d8d4641986a9ac7f = ()=>!false;
const $e96bf35f407138bb$export$462ca08d6ce67848 = ()=>!$e96bf35f407138bb$export$d8d4641986a9ac7f();
const $e96bf35f407138bb$export$3a5e56bd5231a56b = ()=>[
        (0, $fox5Q.wrmBundleResource),
        (0, $gNStA.resourceWithCondition2)(()=>!(0, $4R6GH.fg)('tanuki-stop-load-of-config-json'), (0, $i6CNv.boardConfigApiResource)),
        (0, $gNStA.resourceWithCondition2)($e96bf35f407138bb$export$462ca08d6ce67848, (0, $gQ2J4.rapidboardResource))
    ];
const $e96bf35f407138bb$export$1c63de7f548f965f = ()=>(0, $kdyVI.boardDataResource);
const $e96bf35f407138bb$export$ee826506b3baa13a = ()=>[
        (0, $gNStA.resourceWithCondition2)(()=>$e96bf35f407138bb$export$d8d4641986a9ac7f() && !(0, $4R6GH.fg)('indexeddb_cache_for_backlog'), (0, $5Nutl.uifBacklogResourceOld)),
        (0, $gNStA.resourceWithCondition2)(()=>$e96bf35f407138bb$export$d8d4641986a9ac7f() && (0, $4R6GH.fg)('indexeddb_cache_for_backlog'), (0, $5Nutl.uifBacklogResource))
    ];

});
parcelRegister("5Nutl", function(module, exports) {

$parcel$export(module.exports, "uifBacklogResourceOld", () => $9905b3c28d313f7e$export$db83ef0443397b85);
$parcel$export(module.exports, "uifBacklogResource", () => $9905b3c28d313f7e$export$c182dffb98985208);

var $2M1hQ = parcelRequire("2M1hQ");


const $9905b3c28d313f7e$export$db83ef0443397b85 = (0, $2M1hQ.createResource)({
    type: (0, $2fdbe99f6cbea4f1$export$8f9824ba4409b537),
    getKey: ({ match: { params: { boardId: boardId } }, query: { config: config } })=>/*
            When navigating to and from the board settings page we need
            the data to get reloaded. So we are updating the key to force a refresh
        */ [
            'uif-backlog-data'
        ].concat(boardId ?? '').concat(config ? `config-${config}` : '').filter(Boolean).join('-'),
    getDataLoader: ()=>(parcelRequire("glMKd")),
    // Setting mexAge to 0 so it will get the data again after coming back from a config page
    maxAge: 0
});

const $9905b3c28d313f7e$export$c182dffb98985208 = (0, $2M1hQ.createResource)({
    type: (0, $2fdbe99f6cbea4f1$export$d15ce4feabd76ea),
    getKey: ({ match: { params: { boardId: boardId } }, query: { config: config } })=>/*
            When navigating to and from the board settings page we need
            the data to get reloaded. So we are updating the key to force a refresh
        */ [
            'uif-backlog-data'
        ].concat(boardId ?? '').concat(config ? `config-${config}` : '').filter(Boolean).join('-'),
    getDataLoader: ()=>(parcelRequire("5qsLS")),
    // Setting mexAge to 0 so it will get the data again after coming back from a config page
    maxAge: 0
});

});
const $2fdbe99f6cbea4f1$export$d15ce4feabd76ea = 'NEXTGEN_BACKLOG_REST';
const $2fdbe99f6cbea4f1$export$8f9824ba4409b537 = 'NEXTGEN_BACKLOG_REST_OLD';

parcelRegister("glMKd", function(module, exports) {

let $be746b218be133f7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $be746b218be133f7$var$load("dZxlR").then(()=>parcelRequire('gTjY8'));

});

parcelRegister("5qsLS", function(module, exports) {

let $3f35b2d6dd480d8c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3f35b2d6dd480d8c$var$load("5ODd0").then(()=>parcelRequire('cpSf8'));

});


parcelRegister("i6CNv", function(module, exports) {

$parcel$export(module.exports, "boardConfigApiResource", () => $8a55ba0bef7e0e2a$export$dd9dec064acb0c4e);
// eslint-disable-next-line jira/import-whitelist

var $6s1PB = parcelRequire("6s1PB");

var $2M1hQ = parcelRequire("2M1hQ");

var $1odlY = parcelRequire("1odlY");
const $8a55ba0bef7e0e2a$var$getMaxAge = ()=>false ? 0 : (0, $6s1PB.expVal)('jsw-classic-board-api-calls-config-cache-time', 'value', 0) * 1000;

const $8a55ba0bef7e0e2a$export$dd9dec064acb0c4e = (0, $2M1hQ.createResource)({
    type: (0, $1odlY.RESOURCE_TYPE_RAPIDBOARDS_BOARD_CONFIG),
    getKey: ({ match: match, query: query })=>{
        const boardId = match.params.boardId != null ? match.params.boardId : query.rapidView;
        return `rapidViewConfig-${boardId}`; // Should Also have a mode but for now lets use only id
    },
    getDataLoader: ()=>(parcelRequire("6Pdur")),
    maxAge: $8a55ba0bef7e0e2a$var$getMaxAge(),
    isBrowserOnly: true
});

});
parcelRegister("6Pdur", function(module, exports) {

let $4f81f859a98e0dfd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4f81f859a98e0dfd$var$load("4Iwhy").then(()=>parcelRequire('aCQV9'));

});


parcelRegister("kdyVI", function(module, exports) {

$parcel$export(module.exports, "boardDataResource", () => $18aa0ee73b651f62$export$138fa635416978f7);

var $2M1hQ = parcelRequire("2M1hQ");

var $1odlY = parcelRequire("1odlY");

var $9g2vH = parcelRequire("9g2vH");

const $18aa0ee73b651f62$export$138fa635416978f7 = (0, $2M1hQ.createResource)({
    type: (0, $1odlY.RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA),
    getKey: ({ match: match, query: query, route: route })=>{
        const { name: name = '' } = route || {};
        const boardId = match.params.boardId != null ? match.params.boardId : query.rapidView;
        const { config: config } = query;
        const hasConfig = Boolean(config);
        let key = 'rapidBoardData';
        if ((0, $9g2vH.isBoardRoute)(name)) key = `boardData-${boardId}::hasConfig=${hasConfig}`;
        else if ((0, $9g2vH.isBacklogRoute)(name)) key = `backlogData-${boardId}::hasConfig=${hasConfig}`;
        return key;
    },
    getDataLoader: ()=>(parcelRequire("66t2H")),
    maxAge: 0,
    isBrowserOnly: true
});

});
parcelRegister("9g2vH", function(module, exports) {

$parcel$export(module.exports, "isBoardRoute", () => $ccbac8c858ea0da2$export$437d4d6e25681588);
$parcel$export(module.exports, "isBacklogRoute", () => $ccbac8c858ea0da2$export$bcb853db5e3e8054);
const $ccbac8c858ea0da2$export$437d4d6e25681588 = (routeName)=>routeName === 'rapidboard-board' || routeName === 'rapidboard-board-embed' || routeName === 'rapidboard-board-settings' || routeName === 'rapidboard-user-board' || routeName === 'rapidboard-user-board-settings' || routeName === 'servicedesk-boards' || routeName === 'servicedesk-queues-custom-board' || routeName === 'servicedesk-queues-practice-custom-board';
const $ccbac8c858ea0da2$export$bcb853db5e3e8054 = (routeName)=>routeName === 'rapidboard-backlog' || routeName === 'rapidboard-user-backlog' || routeName === 'rapidboard-backlog-embed';

});

parcelRegister("66t2H", function(module, exports) {

let $4719d4de18488d94$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4719d4de18488d94$var$load("8SZ65").then(()=>parcelRequire('iW9CS'));

});


parcelRegister("gQ2J4", function(module, exports) {

$parcel$export(module.exports, "rapidboardResource", () => $b172ecb4db4f1d22$export$d0f42a55e7c5752c);

var $2M1hQ = parcelRequire("2M1hQ");

var $1odlY = parcelRequire("1odlY");

const $b172ecb4db4f1d22$export$d0f42a55e7c5752c = (0, $2M1hQ.createResource)({
    type: (0, $1odlY.RESOURCE_TYPE_RAPIDBOARDS_RESOURCE),
    getKey: ({ match: match })=>match.query.rapidView || '',
    getDataLoader: ()=>(parcelRequire("3B60s")),
    maxAge: Number.MAX_VALUE,
    isBrowserOnly: true
});

});
parcelRegister("3B60s", function(module, exports) {

let $29e97c844d21e36b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $29e97c844d21e36b$var$load("6irVr").then(()=>parcelRequire('LP66E'));

});


parcelRegister("fox5Q", function(module, exports) {

$parcel$export(module.exports, "wrmBundleResource", () => $bb15c3971b88e6fc$export$f199d15b7cd18df1);

var $2M1hQ = parcelRequire("2M1hQ");

var $4R6GH = parcelRequire("4R6GH");

var $1odlY = parcelRequire("1odlY");

var $PK2Tm = parcelRequire("PK2Tm");

const $bb15c3971b88e6fc$export$f199d15b7cd18df1 = (0, $2M1hQ.createResource)({
    type: (0, $1odlY.RESOURCE_TYPE_RAPIDBOARDS_WRM_BUNDLE),
    getKey: ({ route: route })=>{
        if ((0, $4R6GH.fg)('reports-overview-page-migration')) return (0, $PK2Tm.getRapidViewConfigFromRouteName)(route.name).stateKey;
        return 'state';
    },
    getDataLoader: ()=>(parcelRequire("4ntFd")),
    maxAge: Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});

});
parcelRegister("4ntFd", function(module, exports) {

let $33005208967f2911$var$load = (parcelRequire("28QjX"))(4);
module.exports = $33005208967f2911$var$load("iNwux").then(()=>parcelRequire('bdOyr'));

});



parcelRegister("f7Y15", function(module, exports) {

$parcel$export(module.exports, "uifBoardResource", () => $6f8724e78df4e830$export$b65bcbbccad354ac);

var $2M1hQ = parcelRequire("2M1hQ");


const $6f8724e78df4e830$export$b65bcbbccad354ac = (0, $2M1hQ.createResource)({
    type: (0, $16d4c226f5e6f5f8$export$cfae566ecf2855f8),
    getKey: ({ match: { params: { boardId: boardId } }, route: { name: routeName }, query: { config: config } })=>{
        if (config) return `uif-board::${routeName}::config`;
        if (boardId == null) return `uif-board::${routeName}::not-found`;
        return `uif-board::${routeName}::${boardId}`;
    },
    getDataLoader: ()=>(parcelRequire("jjilt")),
    maxAge: 0
});

});
const $16d4c226f5e6f5f8$export$cfae566ecf2855f8 = 'UIF_BOARD';

parcelRegister("jjilt", function(module, exports) {

let $e0ee05ab20857320$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e0ee05ab20857320$var$load("kAOBH").then(()=>parcelRequire('1HjYz'));

});


parcelRegister("lJ1FP", function(module, exports) {

$parcel$export(module.exports, "editModelResource", () => $16cc53c7df259df5$export$ab9a4786826fd2d);
$parcel$export(module.exports, "getEditModelResource", () => $16cc53c7df259df5$export$5b9bac2cc4bf4511);

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $7f4tk = parcelRequire("7f4tk");

var $gNStA = parcelRequire("gNStA");

var $2M1hQ = parcelRequire("2M1hQ");

var $PK2Tm = parcelRequire("PK2Tm");
const $16cc53c7df259df5$export$ddbb511f9111736a = async (boardId)=>{
    try {
        return await (0, $7f4tk.default)(`/rest/greenhopper/1.0/rapidviewconfig/editmodel.json?cardLayoutConfig=false&rapidViewId=${boardId}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'getEditModelRequest',
                packageName: 'jiraRouterResourcesClassicProjects',
                teamName: 'a4t-pandora'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $16cc53c7df259df5$export$ab9a4786826fd2d = (0, $2M1hQ.createResource)({
    type: 'CLASSIC_BOARD_SETTING_EDIT_MODEL',
    getKey: (routerContext)=>(0, $PK2Tm.getConfigFromRouterContext)(routerContext) ? 'edit-model' : 'not-edit-model',
    getData: async (routerContext)=>{
        if ((0, $PK2Tm.getConfigFromRouterContext)(routerContext)) {
            const boardId = routerContext.match.params?.boardId ?? '';
            return $16cc53c7df259df5$export$ddbb511f9111736a(boardId);
        }
        return null;
    }
});
const $16cc53c7df259df5$export$5b9bac2cc4bf4511 = ()=>(0, $gNStA.resourceWithCondition2)(()=>!(0, $4R6GH.fg)('board-settings-graphql-refactor_cyvz9'), $16cc53c7df259df5$export$ab9a4786826fd2d);

});


parcelRegister("e9zsZ", function(module, exports) {

$parcel$export(module.exports, "servicedeskVirtualAgentAiAnswersKbResource", () => $adb9f25d3efd6c0f$export$6aecd43ca01da0d9);

var $2M1hQ = parcelRequire("2M1hQ");

const $adb9f25d3efd6c0f$var$getDataLoader = ()=>(parcelRequire("dQRfZ"));
const $adb9f25d3efd6c0f$export$6aecd43ca01da0d9 = (0, $2M1hQ.createResource)({
    type: 'SERVICEDESK_VIRTUAL_AGENT_AI_ANSWERS_KB_RESOURCE',
    getKey: ({ match: { params: params } })=>params.projectKey || '',
    getDataLoader: $adb9f25d3efd6c0f$var$getDataLoader,
    isBrowserOnly: true
});

});
parcelRegister("dQRfZ", function(module, exports) {

let $a1597164afd006a2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a1597164afd006a2$var$load("jAYFl").then(()=>parcelRequire('cJzMU'));

});


parcelRegister("aGFv5", function(module, exports) {

$parcel$export(module.exports, "aiAnswersRoute", () => $945f4c839611ad80$export$57dc115194d72385);
const $945f4c839611ad80$export$57dc115194d72385 = {
    name: 'project-settings-servicedesk-virtualagent-ai-answers',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/ai-answers'
};

});

parcelRegister("6Z2mh", function(module, exports) {

$parcel$export(module.exports, "serviceProjectLayout", () => $0836cf39cca1e468$export$e321cb31c875d1ba);
$parcel$export(module.exports, "rightSidebarsLayout", () => $0836cf39cca1e468$export$820f9bb834280408);

var $2vSU6 = parcelRequire("2vSU6");

var $2BrOV = parcelRequire("2BrOV");

var $i90UH = parcelRequire("i90UH");

var $1Du13 = parcelRequire("1Du13");

var $aPfsS = parcelRequire("aPfsS");

var $ln7rs = parcelRequire("ln7rs");

var $kxZPA = parcelRequire("kxZPA");
// TODO Remove this whenever all service project route paths are no longer ambiguous
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0836cf39cca1e468$var$withServiceProjectContext = (Component)=>(0, $aPfsS.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $2vSU6.SERVICE_DESK_PROJECT)
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0836cf39cca1e468$var$ProjectBuilder = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("hKk8D")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/project-builder/ProjectBuilderWithQueryParam.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0836cf39cca1e468$var$Onboarding = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("3keC1")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/onboarding/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0836cf39cca1e468$var$RightSidebars = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("b0uMO")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/right-sidebars/RightSidebars.tsx"
});
const $0836cf39cca1e468$export$e321cb31c875d1ba = (0, $aPfsS.composeLayouts)((0, $1Du13.projectLayout), {
    globalComponents: [
        $0836cf39cca1e468$var$withServiceProjectContext($0836cf39cca1e468$var$Onboarding),
        ...(0, $ln7rs.serviceProjectFirstImpressionsLayout).globalComponents.map($0836cf39cca1e468$var$withServiceProjectContext),
        $0836cf39cca1e468$var$withServiceProjectContext((0, $i90UH.AsyncJsmCustomDomainChangeBoardingFlag)),
        $0836cf39cca1e468$var$ProjectBuilder
    ],
    rightSidebars: [
        $0836cf39cca1e468$var$withServiceProjectContext($0836cf39cca1e468$var$RightSidebars),
        ...(0, $ln7rs.serviceProjectFirstImpressionsLayout).rightSidebars.map($0836cf39cca1e468$var$withServiceProjectContext)
    ]
});
const $0836cf39cca1e468$export$820f9bb834280408 = (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), {
    rightSidebars: [
        $0836cf39cca1e468$var$RightSidebars
    ]
});

});
parcelRegister("2BrOV", function(module, exports) {

$parcel$export(module.exports, "globalLayout", () => $6d4ecb0834e594e8$export$929cb72e7acb7fd9);

var $aPfsS = parcelRequire("aPfsS");
const $6d4ecb0834e594e8$var$rightSidebars = ()=>[];
const $6d4ecb0834e594e8$export$929cb72e7acb7fd9 = (0, $aPfsS.createLayout)({
    rightSidebars: $6d4ecb0834e594e8$var$rightSidebars()
});

});
parcelRegister("aPfsS", function(module, exports) {

$parcel$export(module.exports, "coalesce", () => $ba604ddd48a07730$export$6e5538615c060df7);
$parcel$export(module.exports, "renderGlobalComponents", () => $ba604ddd48a07730$export$fc28c9563350e5b8);
$parcel$export(module.exports, "createLayout", () => $ba604ddd48a07730$export$3dd437ade36ede40);
$parcel$export(module.exports, "composeLayouts", () => $ba604ddd48a07730$export$6c041b39c370853f);
$parcel$export(module.exports, "withProjectContext", () => $ba604ddd48a07730$export$e97a7da67a5b8ce4);

var $5uXOq = parcelRequire("5uXOq");

var $lpwtK = parcelRequire("lpwtK");

var $lfTZh = parcelRequire("lfTZh");

const $ba604ddd48a07730$export$6e5538615c060df7 = (maybeString)=>maybeString == null || maybeString === '' ? undefined : maybeString;
const $ba604ddd48a07730$export$fc28c9563350e5b8 = (components)=>components.map((Component, i)=>{
        const { displayName: displayName, name: name } = Component;
        const key = $ba604ddd48a07730$export$6e5538615c060df7(displayName) ?? $ba604ddd48a07730$export$6e5538615c060df7(name) ?? i;
        return(// TODO Only add suspense if lazy component, otherwise add suspense within component array
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: key?.toString(),
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
            key: key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, null)));
    });
const $ba604ddd48a07730$export$3dd437ade36ede40 = ({ globalComponents: globalComponents = [], rightSidebars: rightSidebars = [], isChromeless: isChromeless = false } = {})=>({
        isChromeless: isChromeless,
        globalComponents: Array.from(new Set(globalComponents)),
        rightSidebars: Array.from(new Set(rightSidebars))
    });
const $ba604ddd48a07730$export$6c041b39c370853f = (...layouts)=>{
    if (layouts.length === 1) return $ba604ddd48a07730$export$3dd437ade36ede40(layouts[0]);
    const layout = layouts.reduce((l, { globalComponents: globalComponents = [], rightSidebars: rightSidebars = [], isChromeless: isChromeless = false })=>({
            isChromeless: isChromeless,
            globalComponents: [
                ...l.globalComponents,
                ...globalComponents
            ],
            rightSidebars: [
                ...l.rightSidebars,
                ...rightSidebars
            ]
        }), {
        globalComponents: [],
        rightSidebars: [],
        isChromeless: false
    });
    return $ba604ddd48a07730$export$3dd437ade36ede40(layout);
};
const $ba604ddd48a07730$var$capitalize = (str)=>`${str.charAt(0).toUpperCase()}${str.slice(1)}`;
const $ba604ddd48a07730$var$formatPrefix = (style, type)=>{
    if (!style && !type) return 'Empty';
    if (style === 'any' && type === 'any') return 'Any';
    const formattedStyle = $ba604ddd48a07730$var$capitalize(style === 'next-gen' ? 'nextGen' : style ?? '');
    if (type === 'any') return formattedStyle;
    const formattedType = $ba604ddd48a07730$var$capitalize(type === 'service_desk' ? 'service' : type ?? '');
    if (style === 'any') return formattedType;
    return `${formattedStyle}${formattedType}`;
};
const $ba604ddd48a07730$export$e97a7da67a5b8ce4 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
Component, options)=>{
    const { project: expectedProject } = options;
    const ScopedComponent = ()=>{
        const { data: project, loading: loading } = (0, $lpwtK.useProject)();
        if (loading) return null;
        if ((expectedProject?.type === 'any' ? !project : project?.type !== expectedProject?.type) || (expectedProject?.style === 'any' ? !project : project?.style !== expectedProject?.style)) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, null);
    };
    const name = $ba604ddd48a07730$export$6e5538615c060df7(Component.displayName) ?? $ba604ddd48a07730$export$6e5538615c060df7(Component.name) ?? 'Component';
    const prefix = $ba604ddd48a07730$var$formatPrefix(expectedProject?.style, expectedProject?.type);
    ScopedComponent.displayName = `with${prefix}ProjectContext(${name})`;
    return ScopedComponent;
};

});
parcelRegister("lpwtK", function(module, exports) {

$parcel$export(module.exports, "useProject", () => $f3d7644b5666677d$export$51b1383ef8844a7);

var $5uXOq = parcelRequire("5uXOq");

var $bsuuc = parcelRequire("bsuuc");

var $1J3t1 = parcelRequire("1J3t1");
const $f3d7644b5666677d$export$51b1383ef8844a7 = (customContext)=>{
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useProjectSidebarNavigation)(customContext);
    const project = (0, $5uXOq.useMemo)(()=>data && (0, $bsuuc.extractData)(data), [
        data
    ]);
    return {
        data: project,
        loading: loading,
        error: error
    };
};

});
parcelRegister("bsuuc", function(module, exports) {

$parcel$export(module.exports, "getStyle", () => $36c780ae7e3dc8c8$export$3d2f074408bd1b82);
$parcel$export(module.exports, "extractData", () => $36c780ae7e3dc8c8$export$9df5fa0a366163d2);

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");
const $36c780ae7e3dc8c8$export$3d2f074408bd1b82 = (isSimplifiedProject)=>isSimplifiedProject ? (0, $2vSU6.ProjectStyle).NEXT_GEN : (0, $2vSU6.ProjectStyle).CLASSIC;
const $36c780ae7e3dc8c8$var$getProject = (project)=>({
        avatarUrl: project.avatarUrls['48x48'],
        id: Number(project.id),
        isSimplified: project.simplified,
        key: project.key,
        name: project.name,
        style: $36c780ae7e3dc8c8$export$3d2f074408bd1b82(project.simplified),
        type: project.projectTypeKey,
        ...typeof project.isLiveTemplate === 'boolean' && (0, $4R6GH.fg)('jira_custom_templates_ux') && {
            isLiveTemplate: project.isLiveTemplate
        }
    });
const $36c780ae7e3dc8c8$export$9df5fa0a366163d2 = (data)=>{
    const { projectType: projectType, jiraWorkManagementNavData: jiraWorkManagementNavData, jiraSoftwareNavData: jiraSoftwareNavData, jiraServiceManagementNavData: jiraServiceManagementNavData, jiraProductDiscoveryNavData: jiraProductDiscoveryNavData } = data || {};
    switch(projectType){
        case 'jira_work_management':
            return jiraWorkManagementNavData?.project ? $36c780ae7e3dc8c8$var$getProject(jiraWorkManagementNavData.project) : null;
        case 'jira_software':
            return jiraSoftwareNavData?.project ? $36c780ae7e3dc8c8$var$getProject(jiraSoftwareNavData.project) : null;
        case 'jira_service_management':
        case 'jira_customer_service':
            return jiraServiceManagementNavData?.project ? $36c780ae7e3dc8c8$var$getProject(jiraServiceManagementNavData.project) : null;
        case 'jira_product_discovery':
            return jiraProductDiscoveryNavData?.project ? $36c780ae7e3dc8c8$var$getProject(jiraProductDiscoveryNavData.project) : null;
        case null:
        default:
            return null;
    }
};

});

parcelRegister("1J3t1", function(module, exports) {

$parcel$export(module.exports, "useProjectSidebarNavigation", () => $bb292f58b8ec7804$export$5a85006c180fb373);
$parcel$export(module.exports, "useProjectSidebarConnectNavigation", () => $bb292f58b8ec7804$export$2bed15cd7d167db5);
$parcel$export(module.exports, "useProjectReportsSidebarConnectNavigation", () => $bb292f58b8ec7804$export$a9d05fc2c1d94895);
$parcel$export(module.exports, "useProjectSettingsSidebarConnectNavigation", () => $bb292f58b8ec7804$export$d48e3c3556894533);
$parcel$export(module.exports, "useJSMProjectConnectQueuesNavigation", () => $bb292f58b8ec7804$export$24a781cd863077aa);
$parcel$export(module.exports, "useJiraWorkmanagementProjectNavigation", () => $bb292f58b8ec7804$export$e16ecd2512eb0dc7);
$parcel$export(module.exports, "useJiraSoftwareProjectNavigation", () => $bb292f58b8ec7804$export$68dc0ecbea8211d2);
$parcel$export(module.exports, "useJiraServiceManagementProjectNavigation", () => $bb292f58b8ec7804$export$5cf90b625d0e1248);
$parcel$export(module.exports, "useJiraProductDiscoveryProjectNavigation", () => $bb292f58b8ec7804$export$d63d92edebe543d9);

var $5uXOq = parcelRequire("5uXOq");

var $b2pl3 = parcelRequire("b2pl3");

var $6zFAI = parcelRequire("6zFAI");

var $gcI3W = parcelRequire("gcI3W");

var $loy04 = parcelRequire("loy04");

var $ggg5j = parcelRequire("ggg5j");

var $324W5 = parcelRequire("324W5");

var $2YP9W = parcelRequire("2YP9W");

var $727Q1 = parcelRequire("727Q1");
const $bb292f58b8ec7804$export$5a85006c180fb373 = (customContext)=>{
    const { data: navResponse, loading: loading, error: error, refresh: refresh, clearAll: clearAll, ...rest } = (0, $324W5.useResourceWithCustomRouterContext)((0, $ggg5j.staticProjectSidebarNavigationResource), customContext);
    const memoizedResponse = (0, $5uXOq.useMemo)(()=>navResponse, [
        navResponse
    ]);
    (0, $727Q1.useJiraSoftwareCMPNavigationSynchronizer)(memoizedResponse);
    return {
        data: memoizedResponse,
        loading: memoizedResponse != null ? false : loading,
        refresh: refresh,
        clearAll: clearAll,
        error: error,
        ...rest
    };
};
const $bb292f58b8ec7804$export$2bed15cd7d167db5 = ()=>(0, $2YP9W.useResource)((0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource));
const $bb292f58b8ec7804$export$a9d05fc2c1d94895 = ()=>(0, $2YP9W.useResource)((0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource));
const $bb292f58b8ec7804$export$d48e3c3556894533 = ()=>(0, $2YP9W.useResource)((0, $loy04.staticProjectSettingsSidebarConnectAddonsNavigationResource));
const $bb292f58b8ec7804$export$24a781cd863077aa = ()=>(0, $2YP9W.useResource)((0, $b2pl3.staticJSMProjectConnectAddonsNavigationResource));
const $bb292f58b8ec7804$export$e16ecd2512eb0dc7 = ()=>{
    const { data: data, ...rest } = $bb292f58b8ec7804$export$5a85006c180fb373();
    const response = data?.jiraWorkManagementNavData || null;
    return {
        data: response,
        ...rest
    };
};
const $bb292f58b8ec7804$export$68dc0ecbea8211d2 = ()=>{
    const { data: data, ...rest } = $bb292f58b8ec7804$export$5a85006c180fb373();
    const response = data?.jiraSoftwareNavData || null;
    return {
        data: response,
        ...rest
    };
};
const $bb292f58b8ec7804$export$5cf90b625d0e1248 = (customContext)=>{
    const { data: data, ...rest } = $bb292f58b8ec7804$export$5a85006c180fb373(customContext);
    const response = data?.jiraServiceManagementNavData || null;
    return {
        data: response,
        ...rest
    };
};
const $bb292f58b8ec7804$export$d63d92edebe543d9 = ()=>{
    const { data: data, ...rest } = $bb292f58b8ec7804$export$5a85006c180fb373();
    const response = data?.jiraProductDiscoveryNavData || null;
    return {
        data: response,
        ...rest
    };
};

});
parcelRegister("727Q1", function(module, exports) {

$parcel$export(module.exports, "useJiraSoftwareCMPNavigationSynchronizer", () => $5300bc04c6e3c00f$export$780174995da89d60);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $ggg5j = parcelRequire("ggg5j");

var $jNUyg = parcelRequire("jNUyg");
var $lODMY = parcelRequire("lODMY");
var $2YP9W = parcelRequire("2YP9W");
const $5300bc04c6e3c00f$export$90dbde7e33e6e21 = ()=>null;
const $5300bc04c6e3c00f$export$d647718555c2fdd8 = (projectKey)=>projectKey ? (0, $jNUyg.createRouterContext)({
        name: 'software',
        path: '/dummyroute/c/projects/:projectKey/dummyroute',
        component: $5300bc04c6e3c00f$export$90dbde7e33e6e21
    }, {
        params: {
            projectKey: projectKey
        }
    }) : undefined;
const $5300bc04c6e3c00f$export$19001bab9e4b7f8f = (projectKey)=>{
    const { data: data, update: update } = (0, $2YP9W.useResource)((0, $ggg5j.staticProjectSidebarNavigationResource), {
        routerContext: $5300bc04c6e3c00f$export$d647718555c2fdd8(projectKey)
    });
    return {
        data: data,
        update: update
    };
};
const $5300bc04c6e3c00f$export$23dc6491016cabdc = (boardId)=>boardId != null ? (0, $jNUyg.createRouterContext)({
        name: 'software',
        path: '/dummyroute/c/projects/boards/:boardId/dummyroute',
        component: $5300bc04c6e3c00f$export$90dbde7e33e6e21
    }, {
        params: {
            boardId: `${boardId}`
        }
    }) : undefined;
const $5300bc04c6e3c00f$export$e2bb7877e6cec3eb = (boardId)=>{
    const { data: data, update: update } = (0, $2YP9W.useResource)((0, $ggg5j.staticProjectSidebarNavigationResource), {
        routerContext: $5300bc04c6e3c00f$export$23dc6491016cabdc(boardId)
    });
    return {
        data: data,
        update: update
    };
};
const $5300bc04c6e3c00f$var$useIsOnBoardBasedRoute = (0, $lODMY.createRouterSelector)(({ route: route, query: query, match: match })=>(0, $ggg5j.getIdentifier)(route.name, match, query)?.identifierType === 'boardId');
const $5300bc04c6e3c00f$export$780174995da89d60 = (latestNavInfo)=>{
    const isOnBoardBasedRoute = $5300bc04c6e3c00f$var$useIsOnBoardBasedRoute();
    const isSoftwareCMP = latestNavInfo?.jiraSoftwareNavData?.project?.simplified === false;
    const pKey = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.project?.key || null;
    const boardId = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.boardInfo?.id || null;
    // explicitly get project data by forcing key to be project
    const { data: projectRouteNavInfo, update: updateProjectRoute } = $5300bc04c6e3c00f$export$19001bab9e4b7f8f(pKey);
    // explicitly get board data by forcing key to be board
    const { data: boardRouteNavInfo, update: updateBoardRoute } = $5300bc04c6e3c00f$export$e2bb7877e6cec3eb(boardId);
    // if software CMP project or board data is not in sync, then force update
    (0, $5uXOq.useEffect)(()=>{
        if (latestNavInfo != null && isSoftwareCMP) {
            if (isOnBoardBasedRoute && !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(latestNavInfo, projectRouteNavInfo)) updateProjectRoute(()=>latestNavInfo);
            else if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(latestNavInfo, boardRouteNavInfo)) updateBoardRoute(()=>latestNavInfo);
        }
    }, [
        isOnBoardBasedRoute,
        latestNavInfo,
        updateProjectRoute,
        updateBoardRoute,
        projectRouteNavInfo,
        boardRouteNavInfo,
        isSoftwareCMP
    ]);
};

});





parcelRegister("i90UH", function(module, exports) {

$parcel$export(module.exports, "AsyncJsmCustomDomainChangeBoardingFlag", () => $3ba5f01428db990d$export$b1ef5e3da6e1959d);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3ba5f01428db990d$var$LazyJsmCustomDomainChangeBoardingFlag = (0, $kxZPA.lazy)(()=>(parcelRequire("lMgFf")), {
    moduleId: "./src/packages/servicedesk/custom-domain-change-boarding/src/ui/index.tsx"
});
const $3ba5f01428db990d$export$b1ef5e3da6e1959d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async-jsm-custom-domain-change-boarding-flag",
        packageName: "jira-help-center-custom-domain-change-boarding"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-custom-domain-change-boarding-flag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ba5f01428db990d$var$LazyJsmCustomDomainChangeBoardingFlag, null)));

});
parcelRegister("lMgFf", function(module, exports) {

let $fdab01deb3f0b2a6$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $fdab01deb3f0b2a6$var$load("ffQaD"),
    $fdab01deb3f0b2a6$var$load("kvRbA"),
    $fdab01deb3f0b2a6$var$load("6l1Sn")
]).then(()=>parcelRequire('9d42Z'));

});


parcelRegister("1Du13", function(module, exports) {

$parcel$export(module.exports, "projectLayout", () => $08491b76212b7395$export$204149bac601d20c);

var $fpzhz = parcelRequire("fpzhz");

var $aPfsS = parcelRequire("aPfsS");

var $kxZPA = parcelRequire("kxZPA");

var $hMrxB = parcelRequire("hMrxB");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $08491b76212b7395$var$withAnyProjectContext = (Component)=>(0, $aPfsS.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: 'any'
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $08491b76212b7395$var$ProjectTrackers = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("2bckt")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/project-layout/src/ui/trackers/index.tsx"
});
const $08491b76212b7395$var$ProjectFavicon = ()=>{
    (0, $hMrxB.useProjectFavicon)();
    return null;
};
const $08491b76212b7395$var$rightSidebars = ()=>[];
const $08491b76212b7395$var$globalComponents = [
    $08491b76212b7395$var$withAnyProjectContext($08491b76212b7395$var$ProjectFavicon),
    $08491b76212b7395$var$withAnyProjectContext($08491b76212b7395$var$ProjectTrackers),
    $08491b76212b7395$var$withAnyProjectContext((0, $fpzhz.ProjectRouteListener))
];
const $08491b76212b7395$export$204149bac601d20c = (0, $aPfsS.createLayout)({
    globalComponents: $08491b76212b7395$var$globalComponents,
    rightSidebars: $08491b76212b7395$var$rightSidebars()
});

});
parcelRegister("fpzhz", function(module, exports) {

$parcel$export(module.exports, "ProjectRouteListener", () => $a96b9050ddfb05f9$export$159f09d701320911);

var $5uXOq = parcelRequire("5uXOq");

var $dxCvy = parcelRequire("dxCvy");

var $itmJb = parcelRequire("itmJb");

var $2YP9W = parcelRequire("2YP9W");

var $hVf1M = parcelRequire("hVf1M");
const $a96b9050ddfb05f9$export$159f09d701320911 = ()=>{
    const isSiteAdmin = (0, $itmJb.useIsAdmin)();
    const { data: data, loading: loading } = (0, $2YP9W.useResource)((0, $dxCvy.projectContextResource));
    (0, $5uXOq.useEffect)(()=>{
        if (isSiteAdmin) (0, $hVf1M.setIsProjectAdmin)({
            loading: false,
            isProjectAdmin: true
        });
        else if (data != null) (0, $hVf1M.setIsProjectAdmin)({
            loading: false,
            isProjectAdmin: data.isProjectAdmin
        });
        else (0, $hVf1M.setIsProjectAdmin)({
            loading: loading,
            isProjectAdmin: null
        });
    }, [
        data,
        loading,
        isSiteAdmin
    ]);
    // Cleanup when component is unmounted. This means we are no longer in a project route
    (0, $5uXOq.useEffect)(()=>()=>(0, $hVf1M.setIsProjectAdmin)({
                loading: false,
                isProjectAdmin: null
            }), []);
    return null;
};

});
parcelRegister("itmJb", function(module, exports) {

$parcel$export(module.exports, "useIsAdmin", () => $dfb6d33a8a8c98ed$export$99a5e4bc80d231ca);

var $9OXo1 = parcelRequire("9OXo1");
const $dfb6d33a8a8c98ed$export$99a5e4bc80d231ca = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.isAdmin || false;
};

});

parcelRegister("hVf1M", function(module, exports) {

$parcel$export(module.exports, "getIsProjectAdmin", () => $d8c128d9b214e073$export$34ff06260ad17f2b);
$parcel$export(module.exports, "setIsProjectAdmin", () => $d8c128d9b214e073$export$d53e6d79d3fa5f31);
let $d8c128d9b214e073$var$projectAdmin = null;
const $d8c128d9b214e073$export$34ff06260ad17f2b = ()=>{
    // Initialised as null, this likely means we aren't in a
    // project route and the listener hasn't been rendered
    if ($d8c128d9b214e073$var$projectAdmin == null || !$d8c128d9b214e073$var$projectAdmin.loading && $d8c128d9b214e073$var$projectAdmin.isProjectAdmin == null) return 'UNKNOWN';
    if ($d8c128d9b214e073$var$projectAdmin.loading === true) return 'LOADING';
    return Boolean($d8c128d9b214e073$var$projectAdmin.isProjectAdmin);
};
const $d8c128d9b214e073$export$d53e6d79d3fa5f31 = (projectAdminState)=>{
    $d8c128d9b214e073$var$projectAdmin = projectAdminState;
};

});


parcelRegister("hMrxB", function(module, exports) {

$parcel$export(module.exports, "useProjectFavicon", () => $6ee68e956a566e2d$export$32abcb1f939de016);

var $5uXOq = parcelRequire("5uXOq");

var $j8DrX = parcelRequire("j8DrX");

var $lpwtK = parcelRequire("lpwtK");

var $4R6GH = parcelRequire("4R6GH");
const $6ee68e956a566e2d$export$32abcb1f939de016 = false ? ()=>undefined : ()=>{
    const { data: project } = (0, $lpwtK.useProject)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const iconEle = document.querySelector("link[rel='shortcut icon']");
    // Keep a copy of the default favicon
    const defaultFavicon = (0, $5uXOq.useMemo)(()=>iconEle instanceof HTMLLinkElement ? iconEle.href : '', [
        iconEle
    ]);
    const enabled = (0, $5uXOq.useMemo)(()=>(0, $j8DrX.default)('ajs-favicon-use-projecticon') === 'true', []);
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $4R6GH.fg)('blu-7193-new-jira-favicons')) {
            const favicon = project ? project.avatarUrl : defaultFavicon;
            if (enabled && iconEle instanceof HTMLLinkElement) iconEle.href = favicon;
            // Switch back to default favicon
            return ()=>{
                if (enabled && iconEle instanceof HTMLLinkElement) iconEle.href = defaultFavicon;
            };
        }
    }, [
        project,
        iconEle,
        defaultFavicon,
        enabled
    ]);
};

});

parcelRegister("2bckt", function(module, exports) {

let $19662c29308a8340$var$load = (parcelRequire("28QjX"))(4);
module.exports = $19662c29308a8340$var$load("adefN").then(()=>parcelRequire('8DuT4'));

});


parcelRegister("ln7rs", function(module, exports) {

$parcel$export(module.exports, "serviceProjectFirstImpressionsLayout", () => $f6f2168537ade4c7$export$2562b2d784eadc10);

var $5uXOq = parcelRequire("5uXOq");

var $ctjgZ = parcelRequire("ctjgZ");

var $aPfsS = parcelRequire("aPfsS");

var $kxZPA = parcelRequire("kxZPA");
const $f6f2168537ade4c7$var$withServiceProjectAccess = (Component)=>{
    const ScopedComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctjgZ.default), {
            hasServiceDeskAccess: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, null));
    const name = (0, $aPfsS.coalesce)(Component.displayName) ?? (0, $aPfsS.coalesce)(Component.name) ?? 'Component';
    ScopedComponent.displayName = `withServiceProjectAccess(${name})`;
    return ScopedComponent;
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f6f2168537ade4c7$var$Onboarding = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("3wGaf")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-first-impressions-layout/src/ui/onboarding/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f6f2168537ade4c7$var$RightSidebars = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("2WJ1Q")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-first-impressions-layout/src/ui/right-sidebars/RightSidebars.tsx"
});
const $f6f2168537ade4c7$export$2562b2d784eadc10 = (0, $aPfsS.createLayout)({
    globalComponents: [
        $f6f2168537ade4c7$var$withServiceProjectAccess($f6f2168537ade4c7$var$Onboarding)
    ],
    rightSidebars: [
        $f6f2168537ade4c7$var$withServiceProjectAccess($f6f2168537ade4c7$var$RightSidebars)
    ]
});

});
parcelRegister("ctjgZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ead1b5a586c4cb4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9OXo1 = parcelRequire("9OXo1");

var $1Yett = parcelRequire("1Yett");
/**
 * Manages the visibility of child components based on user permissions within a multi-tenant environment.
 * It leverages the application's permission settings to determine access rights, ensuring components are only accessible to users with the appropriate permissions.
 * In development environments, it issues a warning when no access-related properties are provided, aiding in debug and development processes.
 */ const $4ead1b5a586c4cb4$var$AppPermissionsCheck = (props)=>{
    const { appPermissions: appPermissions } = (0, $9OXo1.useTenantContext)();
    if (props.hasServiceDeskAccess !== undefined && appPermissions.hasServiceDeskAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children);
    if (props.hasCoreAccess !== undefined && appPermissions.hasCoreAccess === props.hasCoreAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children);
    if (props.hasSoftwareAccess !== undefined && appPermissions.hasSoftwareAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children);
    if (props.hasServiceDeskAccess === undefined && props.hasCoreAccess === undefined && props.hasSoftwareAccess === undefined) {
        if ((0, $1Yett.isDevelopmentEnv)()) // eslint-disable-next-line no-console
        console.warn('AppPermissionsCheck should have defined at least one of access prop');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children);
    }
    return null;
};
$4ead1b5a586c4cb4$var$AppPermissionsCheck.defaultProps = {
    hasCoreAccess: undefined,
    hasSoftwareAccess: undefined,
    hasServiceDeskAccess: undefined
};
var $4ead1b5a586c4cb4$export$2e2bcd8739ae039 = $4ead1b5a586c4cb4$var$AppPermissionsCheck;

});
parcelRegister("1Yett", function(module, exports) {

$parcel$export(module.exports, "isDevelopmentEnv", () => $7b47955f7b675219$export$48e5fb80244b95c5);
const $7b47955f7b675219$export$48e5fb80244b95c5 = ()=>false;

});


parcelRegister("3wGaf", function(module, exports) {

let $291511380aa48c14$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $291511380aa48c14$var$load("kVX56"),
    $291511380aa48c14$var$load("76n7a"),
    $291511380aa48c14$var$load("l253H"),
    $291511380aa48c14$var$load("kGW3K")
]).then(()=>parcelRequire('fY1ne'));

});

parcelRegister("2WJ1Q", function(module, exports) {

let $2253ed54b080939a$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $2253ed54b080939a$var$load("kVX56"),
    $2253ed54b080939a$var$load("76n7a"),
    $2253ed54b080939a$var$load("l253H"),
    $2253ed54b080939a$var$load("25kxa")
]).then(()=>parcelRequire('71Xxe'));

});


parcelRegister("hKk8D", function(module, exports) {

let $ceb65a9174daa7c7$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ceb65a9174daa7c7$var$load("kVX56"),
    $ceb65a9174daa7c7$var$load("dSxO1")
]).then(()=>parcelRequire('ekO4Z'));

});

parcelRegister("3keC1", function(module, exports) {

let $26be9310fa82205b$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $26be9310fa82205b$var$load("kVX56"),
    $26be9310fa82205b$var$load("ffQaD"),
    $26be9310fa82205b$var$load("kvRbA"),
    $26be9310fa82205b$var$load("76n7a"),
    $26be9310fa82205b$var$load("l253H"),
    $26be9310fa82205b$var$load("6iFUR")
]).then(()=>parcelRequire('dOvA3'));

});

parcelRegister("b0uMO", function(module, exports) {

let $803793501d5f35ba$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $803793501d5f35ba$var$load("kVX56"),
    $803793501d5f35ba$var$load("ffQaD"),
    $803793501d5f35ba$var$load("kvRbA"),
    $803793501d5f35ba$var$load("76n7a"),
    $803793501d5f35ba$var$load("l253H"),
    $803793501d5f35ba$var$load("7aqbD")
]).then(()=>parcelRequire('islsJ'));

});


parcelRegister("e9YVH", function(module, exports) {

$parcel$export(module.exports, "APP_NAMES", () => $26ff993b947c317f$export$4116f3d0d9d6bed7);
$parcel$export(module.exports, "toPackageName", () => $26ff993b947c317f$export$f31a652635bd75fe);
const $26ff993b947c317f$export$4116f3d0d9d6bed7 = {
    ACCOUNTS: 'servicedesk.accounts',
    APP_DISCOVERY: 'servicedesk.app-discovery',
    ATLASSIAN_ANALYTICS: 'servicedesk.atlassian-analytics',
    AUTOMATION_EDIT_RULE: 'servicedesk.automation.edit-rule',
    AUTOMATION_SUMMARY: 'servicedesk.automation.summary',
    AUTOMATION_VIEW_LOG: 'servicedesk.automation.view-log',
    BOARD: 'servicedesk.board',
    BOARD_SETTINGS: 'servicedesk.board-settings',
    CALENDAR: 'servicedesk.calendar',
    PROJECT_SUMMARY: 'servicedesk.project-summary',
    CHANGE_CALENDAR: 'servicedesk.change-calendar',
    CHANGE_MANAGEMENT_SETTINGS: 'servicedesk.change-management.settings',
    CREATE_PROJECT: 'servicedesk.create-project',
    CSAT_CONFIG: 'servicedesk.csat-configuration',
    CUSTOMER_PERMISSIONS: 'servicedesk.customer-permissions',
    CONTACTS: 'servicedesk.contacts',
    CUSTOMERS: 'servicedesk.customers',
    CUSTOMER_DETAILS: 'servicedesk.customer-details',
    CUSTOMER_SERVICE_ESCALATIONS: 'servicedesk.customer-service-escalations',
    CUSTOMER_SERVICE_PRODUCTS: 'servicedesk.customer-service-products',
    CUSTOMER_SERVICE_HELP_CENTER: 'servicedesk.customer-service-help-center',
    INVITE_TEAM_DIALOG: 'servicedesk.invite-team-dialog',
    ISSUE_SCHEDULE_CHANGE: 'servicedesk.issue.schedule-change',
    ITSM_FEATURES_SETTINGS: 'servicedesk.itsm-features.settings',
    ITSM_OVERVIEW_SETTINGS: 'servicedesk.itsm-overview.settings',
    ITSM_SAMPLE_SPACE: 'servicedesk.itsm-sample-space',
    JOURNEYS: 'servicedesk.journeys',
    JOURNEY_CONFIG: 'servicedesk.journey-config',
    GETTING_STARTED_PAGE: 'servicedesk.getting-started-page',
    KB_BROWSE_ARTICLES: 'servicedesk.knowledge-base.browse-articles',
    KB_CATEGORY: 'servicedesk.knowledge-base.category',
    KB_DRAFTS: 'servicedesk.knowledge-base.drafts',
    KB_BROWSE_CATEGORIES: 'servicedesk.knowledge-base.browse-categories',
    KB_SUGGESTED_ARTICLES: 'servicedesk.knowledge-base.suggested-articles',
    KB_EMBED_EDITOR: 'servicedesk.knowledge-article.embed-editor',
    KB_LANDING: 'servicedesk.knowledge-base.landing',
    KB_REPORTS_REQUESTS: 'servicedesk.kb-requests.reports',
    KB_SEARCH: 'servicedesk.knowledge-base.search',
    KB_SETTINGS: 'servicedesk.knowledge.settings',
    KB_SETUP: 'servicedesk.knowledge-base.setup',
    KB_VIEW_ARTICLE: 'servicedesk.knowledge-base.view-article',
    ORGANIZATION: 'servicedesk.organization',
    ORGANIZATIONS: 'servicedesk.organizations',
    ORGANIZATION_DETAILS: 'servicedesk.organization-details',
    PORTAL_SETTINGS: 'servicedesk.portal-settings',
    QUEUES_AGENT_VIEW: 'servicedesk.queues.agent-view',
    QUEUES_EDIT_VIEW: 'servicedesk.queues.edit-view',
    QUEUES_MAIN: 'servicedesk.queues.main',
    REPORTS_CUSTOM: 'servicedesk.reports.custom',
    REPORTS_CUSTOM_CREATE: 'servicedesk.reports.custom-create',
    REPORTS_CUSTOM_EDIT: 'servicedesk.reports.custom-edit',
    REPORTS_HOME_PAGE: 'servicedesk.reports.home-page',
    REPORTS_SATISFACTION: 'servicedesk.reports.satisfaction',
    REPORTS_WORKLOAD: 'servicedesk.reports.workload',
    PROJECT_DASHBOARDS_DASHBOARD_LIST: 'servicedesk.project-dashboards.dashboard-list',
    PROJECT_DASHBOARDS_DASHBOARD_EDITABLE: 'servicedesk.project-dashboards.dashboard-editable',
    REQUEST_TYPES_CONFIG: 'servicedesk.request-types-config',
    REQUEST_TYPE_FIELDS: 'servicedesk.request-type-fields',
    SLA_SETTINGS: 'servicedesk.sla-settings',
    VIRTUAL_AGENT_BROWSE_CONVERSATIONS: 'servicedesk.virtual-agent.browse-conversations',
    VIRTUAL_AGENT_BROWSE_INTENTS: 'servicedesk.virtual-agent.browse-intents',
    VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS: 'servicedesk.virtual-agent.browse-standard-flows',
    VIRTUAL_AGENT_LANDING: 'servicedesk.virtual-agent.landing',
    VIRTUAL_AGENT_SETTINGS: 'servicedesk.virtual-agent.settings',
    VIRTUAL_AGENT_VIEW_INTENT: 'servicedesk.virtual-agent.view-intent',
    VIRTUAL_AGENT_VIEW_STANDARD_FLOW: 'servicedesk.virtual-agent.view-standard-flow',
    VIRTUAL_AGENT_AI_ANSWERS: 'servicedesk.virtual-agent.ai-answers',
    VIRTUAL_AGENT_PERFORMANCE: 'servicedesk.virtual-agent.performance',
    PRACTICE_CONFIG_MODULE: 'servicedesk.practice-config-module',
    CREATE_SERVICE_MODAL: 'servicedesk.create-service-modal',
    UPDATE_SERVICE_MODAL: 'servicedesk.update-service-modal',
    LANGUAGE_SETTINGS: 'servicedesk.language-settings',
    LINKED_ALERTS_MODAL: 'servicedesk.link-alerts-modal',
    INSIGHT_ASSETS_REPORTS: 'servicedesk.insight-cmdb-assets_reports',
    INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT: 'servicedesk.insight-cmdb-assets_reports_default_redirect',
    INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE: 'servicedesk.insight-cmdb-assets_reports_unsubscribe',
    INSIGHT_OBJECT_VIEW: 'servicedesk.insight-cmdb-object',
    INSIGHT_OBJECT_SCHEMA: 'servicedesk.insight-cmdb-object-schema',
    INSIGHT_OBJECT_SCHEMA_CONFIGURATION: 'servicedesk.insight-cmdb-object-schema-configuration',
    INSIGHT_OBJECT_TYPE_CONFIGURATION: 'servicedesk.insight-object-type-configuration',
    INSIGHT_GLOBAL_CONFIGURATION: 'servicedesk.insight-cmdb-global-configuration',
    INSIGHT_LANDING_PAGE: 'servicedesk.insight-cmdb-landing-page',
    CUSTOMER_NOTIFICATIONS_MAIN_VIEW: 'servicedesk.customer-notifications-settings.main-view',
    CUSTOMER_NOTIFICATIONS_INVITE_CUSTOMER_VIEW: 'servicedesk.customer-notifications-settings.invite-customer-view',
    CUSTOMER_NOTIFICATIONS_RULE_VIEW: 'servicedesk.customer-notifications-settings.rule-view',
    CUSTOMER_NOTIFICATIONS_TEMPLATE_VIEW: 'servicedesk.customer-notifications-settings.template-view',
    CUSTOMER_NOTIFICATIONS_UNKNOWN_VIEW: 'servicedesk.customer-notifications-settings.unknown-view',
    SERVICES_WITHOUT_PROJECT_VIEW: 'servicedesk.services-without-project-view',
    SERVICE_DETAIL_WITHOUT_PROJECT_VIEW: 'servicedesk.service-detail-without-project-view',
    WIDGET_SETTINGS: 'servicedesk.widget-settings',
    ASSETS_APP_SEARCH_RESULTS: 'assets-app.search-results-page',
    ASSETS_APP_DATA_MANAGER_GETTING_STARTED_PAGE: 'assets-app.data-manager.getting-started-page',
    ASSETS_APP_DATA_MANAGER_OBJECT_CLASSES_PAGE: 'assets-app.data-manager.object-classes-page',
    ASSETS_APP_DATA_MANAGER_DATA_SOURCE_PAGE: 'assets-app.data-manager.data-source'
};
// To match the FE error analytics pipeline convention
const $26ff993b947c317f$var$ANALYTICS_PACKAGE_NAMES = {
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.ACCOUNTS]: 'servicedeskAccounts',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.APP_DISCOVERY]: 'serviceDeskAppDiscovery',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.ATLASSIAN_ANALYTICS]: 'serviceDeskAtlassianAnalytics',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.AUTOMATION_EDIT_RULE]: 'servicedeskAutomationEditView',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.AUTOMATION_SUMMARY]: 'servicedeskAutomationEditRule',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.AUTOMATION_VIEW_LOG]: 'servicedeskAutomationViewLog',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.BOARD]: 'servicedeskBoard',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.BOARD_SETTINGS]: 'servicedeskBoardSettings',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CALENDAR]: 'servicedeskCalendar',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.PROJECT_SUMMARY]: 'servicedeskProjectSummary',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CHANGE_CALENDAR]: 'servicedeskChangeCalendar',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CHANGE_MANAGEMENT_SETTINGS]: 'servicedeskChangeManagementSettings',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CREATE_PROJECT]: 'servicedeskCreateProject',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CSAT_CONFIG]: 'servicedeskCsatConfig',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CONTACTS]: 'servicedeskContacts',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_PERMISSIONS]: 'servicedeskCustomerPermissions',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMERS]: 'servicedeskCustomers',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_DETAILS]: 'servicedeskCustomerDetails',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_SERVICE_ESCALATIONS]: 'servicedeskCustomerServiceEscalations',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_SERVICE_PRODUCTS]: 'servicedeskCustomerServiceProducts',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_SERVICE_HELP_CENTER]: 'servicedeskCustomerServiceHelpCenter',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.INVITE_TEAM_DIALOG]: 'servicedeskInviteTeamDialog',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.ISSUE_SCHEDULE_CHANGE]: 'servicedeskIssueScheduleChange',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.ITSM_FEATURES_SETTINGS]: 'servicedeskItsmFeaturesSettings',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.ITSM_OVERVIEW_SETTINGS]: 'servicedeskItsmOverviewSettings',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.ITSM_SAMPLE_SPACE]: 'servicedeskItsmSampleSpace',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.JOURNEYS]: 'servicedeskJourneys',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.JOURNEY_CONFIG]: 'servicedeskJourneyConfig',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_BROWSE_ARTICLES]: 'servicedeskKnowledgeBaseBrowseArticles',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_BROWSE_CATEGORIES]: 'servicedeskKnowledgeBaseBrowseCategories',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_CATEGORY]: 'servicedeskKnowledgeBaseCategory',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_DRAFTS]: 'servicedeskKnowledgeBaseDrafts',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_SUGGESTED_ARTICLES]: 'servicedeskKnowledgeBaseSuggestedArticles',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_EMBED_EDITOR]: 'servicedeskKnowledgeBaseEmbedEditor',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_LANDING]: 'servicedeskKnowledgeBaseLanding',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_REPORTS_REQUESTS]: 'servicedeskKbRequestsReports',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_SEARCH]: 'servicedeskKnowledgeBaseSearch',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_SETTINGS]: 'servicedeskKnowledgeSettings',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_SETUP]: 'servicedeskKnowledgeBaseSetup',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_VIEW_ARTICLE]: 'servicedeskKnowledgeBaseViewArticle',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.LANGUAGE_SETTINGS]: 'servicedeskLanguageSettingsTranslations',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.ORGANIZATION]: 'servicedeskOrganization',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.ORGANIZATIONS]: 'servicedeskOrganizations',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.ORGANIZATION_DETAILS]: 'servicedeskOrganizationDetails',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.PORTAL_SETTINGS]: 'servicedeskPortalSettings',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.QUEUES_AGENT_VIEW]: 'servicedeskQueuesAgentView',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.QUEUES_EDIT_VIEW]: 'servicedeskQueuesEditView',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.QUEUES_MAIN]: 'servicedeskQueuesMain',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.REPORTS_CUSTOM]: 'servicedeskReportsCustom',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.REPORTS_CUSTOM_CREATE]: 'servicedeskReportsCustomCreate',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.REPORTS_CUSTOM_EDIT]: 'servicedeskReportsCustomEdit',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.REPORTS_HOME_PAGE]: 'servicedeskReportsHomePage',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.REPORTS_SATISFACTION]: 'servicedeskReportsSatisfaction',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.REPORTS_WORKLOAD]: 'servicedeskReportsWorkload',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.PROJECT_DASHBOARDS_DASHBOARD_EDITABLE]: 'servicedeskProjectDashboardsEditable',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.PROJECT_DASHBOARDS_DASHBOARD_LIST]: 'servicedeskProjectDashboardsList',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.REQUEST_TYPES_CONFIG]: 'servicedeskRequestTypesConfig',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.REQUEST_TYPE_FIELDS]: 'servicedeskRequestTypeFields',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.SLA_SETTINGS]: 'servicedeskSlaSettings',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_BROWSE_CONVERSATIONS]: 'servicedeskVirtualAgentBrowseConversations',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_BROWSE_INTENTS]: 'servicedeskVirtualAgentBrowseIntents',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS]: 'servicedeskVirtualAgentBrowseStandardFlows',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_LANDING]: 'servicedeskVirtualAgentLanding',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_SETTINGS]: 'servicedeskVirtualAgentSettings',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_VIEW_INTENT]: 'servicedeskVirtualAgentViewIntent',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_VIEW_STANDARD_FLOW]: 'servicedeskVirtualAgentViewStandardFlow',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_AI_ANSWERS]: 'servicedeskVirtualAgentAiAnswers',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_PERFORMANCE]: 'servicedeskVirtualAgentPerformance',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.PRACTICE_CONFIG_MODULE]: 'servicedeskPracticeConfigModule',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CREATE_SERVICE_MODAL]: 'servicedeskCreateServiceModal',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.UPDATE_SERVICE_MODAL]: 'servicedeskUpdateServiceModal',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.LINKED_ALERTS_MODAL]: 'servicedeskLinkAlertsModal',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_ASSETS_REPORTS]: 'servicedeskAssetsReports',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT]: 'servicedeskAssetsReportsDefaultRedirect',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE]: 'servicedeskAssetsReportsUnsubscribe',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_VIEW]: 'servicedeskObjectView',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_SCHEMA]: 'servicedeskObjectSchema',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_SCHEMA_CONFIGURATION]: 'servicedeskObjectSchemaConfiguration',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_TYPE_CONFIGURATION]: 'servicedeskObjectTypeConfiguration',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_GLOBAL_CONFIGURATION]: 'servicedeskInsightGlobalConfiguration',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_LANDING_PAGE]: 'servicedeskInsightLandingPage',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_MAIN_VIEW]: 'servicedeskCustomerNotificationsMainView',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_INVITE_CUSTOMER_VIEW]: 'servicedeskCustomerNotificationsInviteCustomerView',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_RULE_VIEW]: 'servicedeskCustomerNotificationsRuleView',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_TEMPLATE_VIEW]: 'servicedeskCustomerNotificationsTemplateView',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_UNKNOWN_VIEW]: 'servicedeskCustomerNotificationsUnknownView',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.GETTING_STARTED_PAGE]: 'servicedeskGettingStartedPage',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.SERVICES_WITHOUT_PROJECT_VIEW]: 'servicedeskServicesWithoutProjectView',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.SERVICE_DETAIL_WITHOUT_PROJECT_VIEW]: 'servicedeskServiceDetailWithoutProjectView',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.WIDGET_SETTINGS]: 'servicedeskWidgetSettings',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.ASSETS_APP_SEARCH_RESULTS]: 'assetsAppSearchResultsPage',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.ASSETS_APP_DATA_MANAGER_GETTING_STARTED_PAGE]: 'assetsAppDataManagerGettingStartedPage',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.ASSETS_APP_DATA_MANAGER_OBJECT_CLASSES_PAGE]: 'assetsAppDataManagerObjectClassesPage',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.ASSETS_APP_DATA_MANAGER_DATA_SOURCE_PAGE]: 'assetsAppDataManagerDataSource'
};
const $26ff993b947c317f$export$f31a652635bd75fe = (appName)=>$26ff993b947c317f$var$ANALYTICS_PACKAGE_NAMES[appName];

});

parcelRegister("9PZqh", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentAiAnswersSkeleton", () => $72ea56917d7c23c3$export$5fe1280883d32350);
/* VirtualAgentAiAnswersSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $hKurF = parcelRequire("hKurF");
const $72ea56917d7c23c3$var$customCssStyles = null;
const $72ea56917d7c23c3$export$5fe1280883d32350 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hKurF))),
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("hCy6k", function(module, exports) {

$parcel$export(module.exports, "AppSkeletonImage", () => $a2cd0a6153845fd0$export$45b107c5dc7b51a5);
/* AppSkeletonImage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fNobW = parcelRequire("fNobW");


var $koVbs = parcelRequire("koVbs");

var $d0Ozr = parcelRequire("d0Ozr");
const $a2cd0a6153845fd0$var$skeletonImageStyles = null;
const $a2cd0a6153845fd0$export$45b107c5dc7b51a5 = /*#__PURE__*/ (0, $5uXOq.memo)(({ src: src, className: className, containerStyles: containerStyles, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "app-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2cd0a6153845fd0$var$SkeletonWrapper // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    , {
        style: containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: src,
        "data-testid": testId,
        alt: `${formatMessage((0, $d0Ozr.default).loading)}...`,
        className: (0, $bwpsq.default)([
            "_1dqonqa1 _1h6d3acm _1e0c1ule _vchhusvi _1bsb1osq _t6vd1ylp _hr4j1ylp _l82tgktf _j7o0gktf",
            className
        ])
    })));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a2cd0a6153845fd0$var$SkeletonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bsb1osq _4t3i1osq _yksp1ssb _1b421ssb _s8ks18ws _u1wz1nty",
            __cmplp.className
        ])
    });
});

});
parcelRegister("d0Ozr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6abc81adadf77f72$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6abc81adadf77f72$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    loading: {
        "id": "skeletons.common.loading",
        "defaultMessage": "Loading"
    }
});

});


parcelRegister("hKurF", function(module, exports) {
module.exports = new URL("virtual-agent-ai-answers-app-skeleton.tpl.283eb0a3.svg", import.meta.url).toString();

});


parcelRegister("mOeIa", function(module, exports) {

$parcel$export(module.exports, "aiAnswersEntryPoint", () => $a4434f7c7bc24d2f$export$5dcf9a7e1076ac6);

var $dBV63 = parcelRequire("dBV63");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $a4434f7c7bc24d2f$export$5dcf9a7e1076ac6 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("eR4kL")), {
        moduleId: "b474af7a",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $dBV63.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("dBV63", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b39bedd89e67c64$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<228f2239cbae33d00d8e63897f96750c>>
 * @relayHash b317a486cf818716fa955809174baed6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID aecb078bb42ac99789f2aa91d508e1d81d4288e8ceb828b1c9f3c03242f8f76f

var $7oHmH = parcelRequire("7oHmH");

var $eiowN = parcelRequire("eiowN");
const $8b39bedd89e67c64$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v2 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v3 = [
        v2 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = [
        v2 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = [
        v8 /*: any*/ 
    ], v10 = [
        {
            "kind": "ScalarField",
            "name": "isAiEnabledInAdminHub"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "srcVirtualAgentAiAnswersQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "virtualAgentPageWrapper_servicedeskSettingsVirtualAgentCommon_projectRef"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "virtualAgentConfiguration",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "ui_servicedeskSettingsVirtualAgentAiAnswers_VirtualAgentAiAnswers_virtualAgentConfiguration"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ui_servicedeskSettingsVirtualAgentAiAnswers_VirtualAgentAiAnswers_jiraProjectRef"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "VirtualAgentQueryApi",
                        "kind": "LinkedField",
                        "name": "virtualAgent",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "VirtualAgentFeatures",
                                    "kind": "LinkedField",
                                    "name": "virtualAgentEntitlements",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ui_servicedeskSettingsVirtualAgentAiAnswers_VirtualAgentAiAnswers_virtualAgentFeatures"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "virtualAgent.virtualAgentEntitlements"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "virtualAgent"
                },
                {
                    "args": v7 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "virtualAgentPageWrapper_servicedeskSettingsVirtualAgentCommon_featuresRef"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "srcVirtualAgentAiAnswersQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "virtualAgentConfiguration",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isAiResponsesEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "defaultJiraRequestTypeId"
                                                }
                                            ],
                                            "type": "VirtualAgentConfiguration"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v9 /*: any*/ ,
                                            "type": "VirtualAgentQueryError"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v9 /*: any*/ ,
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                },
                                v4 /*: any*/ ,
                                {
                                    "args": v7 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "knowledgeBaseArticlesCount",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "count"
                                                }
                                            ],
                                            "type": "KnowledgeBaseArticleCountSource"
                                        }
                                    ]
                                },
                                v8 /*: any*/ ,
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "VirtualAgentQueryApi",
                    "kind": "LinkedField",
                    "name": "virtualAgent",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "VirtualAgentFeatures",
                            "kind": "LinkedField",
                            "name": "virtualAgentEntitlements",
                            "plural": false,
                            "selections": v10 /*: any*/ 
                        }
                    ]
                },
                {
                    "concreteType": "VirtualAgentQueryApi",
                    "kind": "LinkedField",
                    "name": "virtualAgent",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "VirtualAgentFeatures",
                            "kind": "LinkedField",
                            "name": "virtualAgentEntitlements",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isVirtualAgentAvailable"
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": v10 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "aecb078bb42ac99789f2aa91d508e1d81d4288e8ceb828b1c9f3c03242f8f76f",
            "metadata": {},
            "name": "srcVirtualAgentAiAnswersQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $7oHmH.default)
            }
        }
    };
}();
$8b39bedd89e67c64$var$node.hash = "19529bb28005c693e530427ab6ca9cc6";
(0, $eiowN.PreloadableQueryRegistry).set($8b39bedd89e67c64$var$node.params.id, $8b39bedd89e67c64$var$node);
var $8b39bedd89e67c64$export$2e2bcd8739ae039 = $8b39bedd89e67c64$var$node;

});

parcelRegister("eR4kL", function(module, exports) {

let $ad09608848544a8f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ad09608848544a8f$var$load("cz9Ah").then(()=>parcelRequire('64AA8'));

});


parcelRegister("lkFvK", function(module, exports) {

$parcel$export(module.exports, "createChromelessEntryPoint", () => $6a0b20679c309df7$export$56ea489e9d4bfa04);
$parcel$export(module.exports, "createPageEntryPoint", () => $6a0b20679c309df7$export$955a7619d2679b4c);

var $adY3A = parcelRequire("adY3A");


var $3HwlS = parcelRequire("3HwlS");

var $4R6GH = parcelRequire("4R6GH");
const $6a0b20679c309df7$export$56ea489e9d4bfa04 = (page)=>({
        root: page.main.root,
        getPreloadProps: (entryPointParams)=>({
                entryPoints: {
                    [(0, $6d6ccf8a2b2c5b3c$export$900ddb492c628f48)]: {
                        entryPoint: page.main,
                        entryPointParams: entryPointParams
                    }
                }
            }),
        toString: ()=>'ChromelessEntryPoint'
    });
const $6a0b20679c309df7$export$955a7619d2679b4c = (page)=>({
        root: page.main.root,
        getPreloadProps: (entryPointParams)=>({
                entryPoints: {
                    [(0, $6d6ccf8a2b2c5b3c$export$900ddb492c628f48)]: {
                        entryPoint: page.main,
                        entryPointParams: entryPointParams
                    },
                    [(0, $6d6ccf8a2b2c5b3c$export$bec6dca2e63de4ae)]: {
                        entryPoint: (0, $adY3A.topNavigationEntryPoint),
                        entryPointParams: {
                            menuId: page.topNavigationMenuId
                        }
                    },
                    ...page.leftSidebar && (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route') ? {
                        [(0, $6d6ccf8a2b2c5b3c$export$50ea883ba6f28ff5)]: {
                            entryPoint: page.leftSidebar.sidebar,
                            entryPointParams: {
                                ...entryPointParams,
                                entryPoints: {
                                    ...page.leftSidebar.entryPoints ? $6a0b20679c309df7$var$injectEntryPointParams(page.leftSidebar.entryPoints, entryPointParams) : undefined
                                },
                                isAppsExpanded: page.leftSidebar.isAppsExpanded ?? false,
                                isFiltersExpanded: page.leftSidebar.isFiltersExpanded ?? false,
                                isPlansExpanded: page.leftSidebar.isPlansExpanded ?? false,
                                isProjectsExpanded: page.leftSidebar.isProjectsExpanded ?? false,
                                isOperationsExpanded: page.leftSidebar.isOperationsExpanded ?? false,
                                isOverviewsExpanded: page.leftSidebar.isOverviewsExpanded ?? false
                            }
                        }
                    } : undefined,
                    ...page.horizontalNavigation && (0, $3HwlS.getWillShowNav4)() ? {
                        [(0, $6d6ccf8a2b2c5b3c$export$948d4d345566aed3)]: {
                            entryPoint: page.horizontalNavigation,
                            entryPointParams: {
                                ...entryPointParams,
                                fallback: page.horizontalNavigationFallback
                            }
                        }
                    } : undefined,
                    ...page.rightSidebar ? {
                        [(0, $6d6ccf8a2b2c5b3c$export$7bf43119a6b49ddb)]: {
                            entryPoint: page.rightSidebar,
                            entryPointParams: {
                                ...entryPointParams,
                                fallback: page.rightSidebarFallback
                            }
                        }
                    } : undefined
                }
            }),
        toString: ()=>'PageEntryPoint'
    });
function $6a0b20679c309df7$var$injectEntryPointParams(obj, entryPointParams) {
    const newParams = {};
    // https://stackoverflow.com/a/16735184
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) newParams[prop] = {
        entryPoint: obj[prop].entryPoint,
        entryPointParams: entryPointParams
    };
    return newParams;
}

});
parcelRegister("adY3A", function(module, exports) {

$parcel$export(module.exports, "topNavigationEntryPoint", () => $e6a45c27809ae082$export$f780be9e138f456f);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $e6a45c27809ae082$export$f780be9e138f456f = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>Promise.resolve((parcelRequire("9DfkH"))).then(({ AtlassianNavigation: AtlassianNavigation })=>AtlassianNavigation), {
        moduleId: "1f1265b4",
        priority: "userVisible"
    }),
    getPreloadProps: (extraProps)=>({
            extraProps: extraProps
        })
});

});
parcelRegister("2OZhN", function(module, exports) {

$parcel$export(module.exports, "JSResourceForUserVisible", () => $ca4f44207dc12143$export$58f934f3d33a84b6);

var $eIMrK = parcelRequire("eIMrK");

var $ce6VA = parcelRequire("ce6VA");

var $iyWSs = parcelRequire("iyWSs");
const $ca4f44207dc12143$var$cache = (0, $eIMrK.createCache)(new Map());
function $ca4f44207dc12143$export$58f934f3d33a84b6(loader, opts) {
    return $ca4f44207dc12143$var$cache.get(opts.moduleId, ()=>(0, $ce6VA.PreloadableJSResource)(()=>(0, $iyWSs.postTask)(loader, {
                priority: 'user-blocking'
            }), opts));
}

});


const $6d6ccf8a2b2c5b3c$export$948d4d345566aed3 = '__pageLayoutHorizontalNavigation';
const $6d6ccf8a2b2c5b3c$export$50ea883ba6f28ff5 = '__pageLayoutLeftSidebar';
const $6d6ccf8a2b2c5b3c$export$900ddb492c628f48 = '__pageLayoutMainContent';
const $6d6ccf8a2b2c5b3c$export$bec6dca2e63de4ae = '__pageLayoutTopNavigation';
const $6d6ccf8a2b2c5b3c$export$7bf43119a6b49ddb = '__pageLayoutRightSidebar';


parcelRegister("k6R7C", function(module, exports) {

$parcel$export(module.exports, "FedRAMPFallbackRedirectToProjectSettings", () => $91741b5f92b89992$export$3b12aad1f47d85f8);

var $3AXtK = parcelRequire("3AXtK");
const $91741b5f92b89992$export$3b12aad1f47d85f8 = (0, $3AXtK.defaultRedirectForSettings)((0, $3AXtK.SERVICE_DESK_PRODUCT));

});
parcelRegister("3AXtK", function(module, exports) {

$parcel$export(module.exports, "SERVICE_DESK_PRODUCT", () => $a6392627f74f3006$export$5575497f0592ee94);
$parcel$export(module.exports, "defaultRedirectForSettings", () => $a6392627f74f3006$export$c9b0516439c55d7a);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
const $a6392627f74f3006$export$5575497f0592ee94 = 'servicedesk';
const $a6392627f74f3006$export$c9b0516439c55d7a = (product)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: `/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`
        });

});



parcelRegister("iTGOF", function(module, exports) {

$parcel$export(module.exports, "alertPoliciesRouteEntry", () => $1722f4808fc919d6$export$eb1e2324ca2031e2);

var $f4VN0 = parcelRequire("f4VN0");

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $ep3S0 = parcelRequire("ep3S0");

var $jyzx5 = parcelRequire("jyzx5");
const $1722f4808fc919d6$export$eb1e2324ca2031e2 = (0, $7NszV.createEntry)((0, $ep3S0.alertPoliciesRoute), ()=>({
        group: 'eoc',
        component: (0, $jyzx5.AlertPoliciesComponent),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $f4VN0.resources)(),
            ...(0, $2r8fH.resources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jyzx5.LazyAlertPolicies),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("f4VN0", function(module, exports) {

$parcel$export(module.exports, "teamPolicyResource", () => $f22ff5b7b8e8fefe$export$10d7fa513f08ef83);
$parcel$export(module.exports, "notificationPolicyResource", () => $f22ff5b7b8e8fefe$export$6d5f23d9118ad678);
$parcel$export(module.exports, "globalPolicyResource", () => $f22ff5b7b8e8fefe$export$7aed80da979a5112);
$parcel$export(module.exports, "resources", () => $f22ff5b7b8e8fefe$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $11dmp = parcelRequire("11dmp");
const $f22ff5b7b8e8fefe$export$10d7fa513f08ef83 = (0, $2M1hQ.createResource)({
    type: 'teamPolicyResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `team-policy/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        // if there is no teamId, this means that we are on the global policy page.
        // so we can return null directly, instead of sending fetch request.
        if (!teamId) return null;
        return (0, $11dmp.getTeamPolicies)(teamId);
    },
    isBrowserOnly: true
});
const $f22ff5b7b8e8fefe$export$6d5f23d9118ad678 = (0, $2M1hQ.createResource)({
    type: 'notificationPolicyResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `notification-policy/${teamId}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        if (!teamId) return;
        return (0, $11dmp.getNotificationPolicies)(teamId);
    },
    isBrowserOnly: true
});
const $f22ff5b7b8e8fefe$export$7aed80da979a5112 = (0, $2M1hQ.createResource)({
    type: 'globalPolicyResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        if (teamId) return `global-policy/${teamId}`;
        return 'global-policy';
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return (0, $11dmp.getGlobalPolicies)(teamId);
    },
    isBrowserOnly: true
});
const $f22ff5b7b8e8fefe$export$4cb385c2db8b1e99 = (0, $2M1hQ.createResource)({
    type: 'policyMaintenanceRightsResource',
    getKey: ()=>'policy-maintenance-rights-resource',
    getData: async ()=>{
        return (0, $11dmp.getPolicyMaintenanceRights)();
    },
    isBrowserOnly: true
});
const $f22ff5b7b8e8fefe$export$bc99aaabaf7b70a7 = ()=>[
        $f22ff5b7b8e8fefe$export$10d7fa513f08ef83,
        $f22ff5b7b8e8fefe$export$7aed80da979a5112,
        $f22ff5b7b8e8fefe$export$4cb385c2db8b1e99,
        $f22ff5b7b8e8fefe$export$6d5f23d9118ad678
    ];

});
parcelRegister("11dmp", function(module, exports) {

$parcel$export(module.exports, "getTeamPolicies", () => $970bb189ad752795$export$fead0944caa1c797);
$parcel$export(module.exports, "getGlobalPolicies", () => $970bb189ad752795$export$17fc7fbef061a8c3);
$parcel$export(module.exports, "getNotificationPolicies", () => $970bb189ad752795$export$342525d9423e55ad);
$parcel$export(module.exports, "getPolicyMaintenanceRights", () => $970bb189ad752795$export$f630cbf5586dce0a);
$parcel$export(module.exports, "updateUIPreferenceEndpoint", () => $970bb189ad752795$export$6a437b43ab11275d);
$parcel$export(module.exports, "changePolicyOrderEndpoint", () => $970bb189ad752795$export$57186d786c96b52a);
$parcel$export(module.exports, "enablePolicyEndpoint", () => $970bb189ad752795$export$6fecd226d8e55346);
$parcel$export(module.exports, "disablePolicyEndpoint", () => $970bb189ad752795$export$8c0cd218e00b7d9b);
$parcel$export(module.exports, "deletePolicyEndpoint", () => $970bb189ad752795$export$f9feac6c1dcc516f);
$parcel$export(module.exports, "createPolicyEndpoint", () => $970bb189ad752795$export$b0108c51b962e788);
$parcel$export(module.exports, "updatePolicyEndpoint", () => $970bb189ad752795$export$8eabce250a2dd205);

var $j74qU = parcelRequire("j74qU");
const $970bb189ad752795$export$fead0944caa1c797 = (teamId)=>{
    return (0, $j74qU.eocFetch)(`/v1/teams/${teamId}/policies?type=alert`);
};
const $970bb189ad752795$export$17fc7fbef061a8c3 = (teamId)=>{
    if (teamId) return (0, $j74qU.eocFetch)(`/v1/alerts/policies?preferredUITeamId=${teamId}`);
    return (0, $j74qU.eocFetch)(`/v1/alerts/policies`);
};
const $970bb189ad752795$export$342525d9423e55ad = (teamId)=>{
    return (0, $j74qU.eocFetch)(`/v1/teams/${teamId}/policies?type=notification`);
};
const $970bb189ad752795$export$f630cbf5586dce0a = ()=>{
    return (0, $j74qU.eocFetch)(`/v1/alerts/ui-preferences/policy-maintenance-rights`);
};
const $970bb189ad752795$export$6a437b43ab11275d = ({ teamId: teamId, ...payload })=>{
    let url = `/v1/alerts/ui-preferences/policies`;
    if (teamId) url = `${url}?teamId=${teamId}`;
    return (0, $j74qU.eocFetch)(url, {
        method: 'PATCH',
        body: payload,
        responseType: 'headers'
    });
};
const $970bb189ad752795$export$57186d786c96b52a = (payload)=>{
    return (0, $j74qU.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}/order`, {
        method: 'PATCH',
        body: {
            after: payload.after
        },
        responseType: 'headers'
    });
};
const $970bb189ad752795$export$6fecd226d8e55346 = (payload)=>{
    return (0, $j74qU.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}/enable`, {
        method: 'POST',
        responseType: 'headers'
    });
};
const $970bb189ad752795$export$8c0cd218e00b7d9b = (payload)=>{
    return (0, $j74qU.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}/disable`, {
        method: 'POST',
        responseType: 'headers'
    });
};
const $970bb189ad752795$export$f9feac6c1dcc516f = (payload)=>{
    return (0, $j74qU.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}`, {
        method: 'DELETE',
        responseType: 'headers'
    });
};
const $970bb189ad752795$export$b0108c51b962e788 = (payload)=>{
    return (0, $j74qU.eocFetch)(`/v1/teams/${payload.teamId}/policies`, {
        method: 'POST',
        body: payload
    });
};
const $970bb189ad752795$export$8eabce250a2dd205 = (payload)=>{
    return (0, $j74qU.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}`, {
        method: 'PUT',
        body: payload
    });
};

});


parcelRegister("2r8fH", function(module, exports) {

$parcel$export(module.exports, "teamResource", () => $77662e91dfb33ae6$export$87453d709b90ccdf);
$parcel$export(module.exports, "sidebarRightsResource", () => $77662e91dfb33ae6$export$3b3b9a5b0eddde66);
$parcel$export(module.exports, "resources", () => $77662e91dfb33ae6$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $5iPTg = parcelRequire("5iPTg");
const $77662e91dfb33ae6$export$87453d709b90ccdf = (0, $2M1hQ.createResource)({
    type: 'teamResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `team-dashboard/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $hmVmJ.assert)(!!teamId, new (0, $dH6Pi.AssertionError)('teamSidebarResource', 'teamId should be set to fetch team-dashboard'));
        return (0, $5iPTg.getTeamByIdEndpoint)(teamId).catch((e)=>{
            e.skipSentry = true;
            throw e;
        });
    },
    maxAge: 300000,
    isBrowserOnly: true
});
const $77662e91dfb33ae6$export$3b3b9a5b0eddde66 = (0, $2M1hQ.createResource)({
    type: 'sidebarRightsResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `team-dashboard/${teamId ?? ''}/sidebar-rights`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $hmVmJ.assert)(!!teamId, new (0, $dH6Pi.AssertionError)('teamSidebarResource', 'teamId should be set to fetch sidebar rights'));
        return (0, $5iPTg.getSidebarRightsEndpoint)(teamId).catch((e)=>{
            e.skipSentry = true;
            throw e;
        });
    },
    isBrowserOnly: true,
    maxAge: Infinity
});
const $77662e91dfb33ae6$export$bc99aaabaf7b70a7 = ()=>[
        $77662e91dfb33ae6$export$87453d709b90ccdf,
        $77662e91dfb33ae6$export$3b3b9a5b0eddde66
    ];

});
parcelRegister("hmVmJ", function(module, exports) {

$parcel$export(module.exports, "assert", () => $e903ea4af1073086$export$a7a9523472993e97);

var $dH6Pi = parcelRequire("dH6Pi");
/**
 * Throws when the condition is true
 * @param condition Condition to assert - can use type assertions thanks to ts's "asserts condition"
 * @param err An AssertionError object extending js error object
 */ const $e903ea4af1073086$export$a7a9523472993e97 = function(condition, err) {
    if (!condition) throw err;
};

});
parcelRegister("dH6Pi", function(module, exports) {

$parcel$export(module.exports, "AssertionError", () => $51d685c1b4e62326$export$7750cdfb4db2c3d);
class $51d685c1b4e62326$export$7750cdfb4db2c3d extends Error {
    constructor(id, message){
        super(`[${id}] ${message}`), this.id = id;
    }
}

});


parcelRegister("5iPTg", function(module, exports) {

$parcel$export(module.exports, "getTeamByIdEndpoint", () => $03a26ab2fa346c2e$export$bcb25b347f39b3f3);
$parcel$export(module.exports, "getSidebarRightsEndpoint", () => $03a26ab2fa346c2e$export$6f1f62156c62eb91);

var $j74qU = parcelRequire("j74qU");
const $03a26ab2fa346c2e$export$bcb25b347f39b3f3 = (teamId)=>(0, $j74qU.eocFetch)(`/v1/teams/${teamId}?includeImageUrls=true`);
const $03a26ab2fa346c2e$export$6f1f62156c62eb91 = (teamId)=>{
    return (0, $j74qU.eocFetch)(`/v1/teams/${teamId}/menu-rights`);
};

});


parcelRegister("ffza4", function(module, exports) {

$parcel$export(module.exports, "LazyAtlassianNavigation", () => $772c987a24839dcf$export$4caed23aa0274abb);

var $fDtbf = parcelRequire("fDtbf");

var $2SVPM = parcelRequire("2SVPM");

var $kxZPA = parcelRequire("kxZPA");

const $772c987a24839dcf$export$4caed23aa0274abb = (0, $kxZPA.lazyForPaint)(()=>{
    const bundleReady = Promise.resolve((parcelRequire("9DfkH"))).then(({ AtlassianNavigation: AtlassianNavigation })=>AtlassianNavigation);
    if (!false) bundleReady.then(()=>{
        (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.bundle-ready', 'jira-spa.js:eval-stop');
        const resources = performance.getEntriesByType('mark');
        for(let i = resources.length - 1; i >= 0; i -= 1)if ((resources[i].name.startsWith('async-navigation') || resources[i].name.startsWith('async-atlassian-navigation')) && resources[i].name.endsWith((0, $fDtbf.JS_EVAL_START))) {
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.eval', resources[i].name);
            break;
        }
    });
    return bundleReady;
}, {
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/index.tsx"
});

});
parcelRegister("2SVPM", function(module, exports) {

$parcel$export(module.exports, "setInitialPageLoadTimingFromPerformanceMarks", () => $b3ae4dfcfbbe07cd$export$15ca6669ae356831);
$parcel$export(module.exports, "stopInitialPageLoadTimingFromPerformanceMarkStart", () => $b3ae4dfcfbbe07cd$export$ab75d59423c060f4);
$parcel$export(module.exports, "measureInitialPageLoadTiming", () => $b3ae4dfcfbbe07cd$export$e18462760bac553c);
$parcel$export(module.exports, "setProductBundleReadyForInitialRender", () => $b3ae4dfcfbbe07cd$export$de1b4cf109d9ab65);

var $jI6pi = parcelRequire("jI6pi");

var $21pfT = parcelRequire("21pfT");
/**
 * `performance.measure` will throw if start/stop aren't set.
 *
 * This call sets a user-timing on the profiler timelines so we can see sections of the load.
 */ const $b3ae4dfcfbbe07cd$var$safeMeasure = (name, start, stop)=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        performance.measure(name, start, stop);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-empty
    } catch (_err) {}
};
const $b3ae4dfcfbbe07cd$export$15ca6669ae356831 = (name, start, stop, cleanStart = false, cleanStop = false)=>{
    if (false) return;
    $b3ae4dfcfbbe07cd$var$safeMeasure(name, start, stop);
    (0, $21pfT.browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, start, stop);
    (0, $jI6pi.addTimingFromPerformanceMark)(name, start, stop, cleanStart, cleanStop);
};
const $b3ae4dfcfbbe07cd$export$ab75d59423c060f4 = (name, start, cleanStart = false)=>{
    if (false) return;
    const stopMark = `${name}__stop_mark$`;
    performance.mark(stopMark);
    $b3ae4dfcfbbe07cd$var$safeMeasure(name, start, stopMark);
    (0, $21pfT.browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, start, stopMark);
    (0, $jI6pi.addTimingFromPerformanceMark)(name, start, stopMark, cleanStart, true);
};
const $b3ae4dfcfbbe07cd$export$e18462760bac553c = (name, fn)=>{
    if (false) return fn();
    const startMark = `${name}__start_mark$`;
    const stopMark = `${name}__stop_mark$`;
    performance.mark(startMark);
    const result = fn();
    performance.mark(stopMark);
    $b3ae4dfcfbbe07cd$var$safeMeasure(name, startMark, stopMark);
    (0, $21pfT.browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, startMark, stopMark);
    (0, $jI6pi.addTimingFromPerformanceMark)(name, startMark, stopMark, true, true);
    return result;
};
const $b3ae4dfcfbbe07cd$export$53038a2e9d597818 = async (name, fn)=>{
    if (false) return fn();
    const startMark = `${name}__start_mark$`;
    const stopMark = `${name}__stop_mark$`;
    performance.mark(startMark);
    const result = await fn();
    performance.mark(stopMark);
    (0, $21pfT.browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, startMark, stopMark);
    (0, $jI6pi.addTimingFromPerformanceMark)(name, startMark, stopMark, true, true);
    return result;
};
const $b3ae4dfcfbbe07cd$export$de1b4cf109d9ab65 = ()=>{
    if (false) return;
    $b3ae4dfcfbbe07cd$export$ab75d59423c060f4('product.bundle-ready', 'jira-spa.js:eval-stop');
};

});


parcelRegister("3Dk1Z", function(module, exports) {

$parcel$export(module.exports, "LazyTeamDashboardSidebar", () => $d15151561c6a9349$export$a1b7c53ff39475a6);
$parcel$export(module.exports, "default", () => $d15151561c6a9349$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

const $d15151561c6a9349$export$a1b7c53ff39475a6 = (0, $kxZPA.lazyForPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("f6Yqt")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/eoc-team-dashboard/src/index.tsx"
});
const $d15151561c6a9349$var$TeamDashboardSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "eocTeamDashboard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d15151561c6a9349$export$a1b7c53ff39475a6, null));
$d15151561c6a9349$var$TeamDashboardSidebar.displayName = 'TeamDashboardSidebar';
var $d15151561c6a9349$export$2e2bcd8739ae039 = $d15151561c6a9349$var$TeamDashboardSidebar;

});
parcelRegister("f6Yqt", function(module, exports) {

let $b00649e58234d29a$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $b00649e58234d29a$var$load("ffQaD"),
    $b00649e58234d29a$var$load("kvRbA"),
    $b00649e58234d29a$var$load("jMJzP")
]).then(()=>parcelRequire('hMnGK'));

});


parcelRegister("bh0Pj", function(module, exports) {

$parcel$export(module.exports, "LazyHorizontalOperationsNav", () => $79488f04c14a3737$export$409c821653bbc63b);
$parcel$export(module.exports, "LazyHorizontalOperationsOverviewNav", () => $79488f04c14a3737$export$82108adf6887e32e);
$parcel$export(module.exports, "AsyncHorizontalOperationsNav", () => $79488f04c14a3737$export$1eb785f071697cc5);
$parcel$export(module.exports, "AsyncHorizontalOperationsOverviewNav", () => $79488f04c14a3737$export$27e50c09ebb514f);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $79488f04c14a3737$export$409c821653bbc63b = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("7pzgA")).then(({ HorizontalOperationsNav: HorizontalOperationsNav })=>HorizontalOperationsNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/horizontal-nav-operations/src/ui/index.tsx"
});

const $79488f04c14a3737$export$82108adf6887e32e = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("7pzgA")).then(({ OverviewNav: OverviewNav })=>OverviewNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/horizontal-nav-operations/src/ui/index.tsx"
});
const $79488f04c14a3737$export$1eb785f071697cc5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "horizontal-operations-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "asyncHorizontalOperationsNav",
        packageName: "jiraOperationsHorizontalNav",
        fallback: "flag",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($79488f04c14a3737$export$409c821653bbc63b, null)));
const $79488f04c14a3737$export$27e50c09ebb514f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "horizontal-operations-overview-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "asyncHorizontalOperationsOverviewNav",
        packageName: "jiraOperationsHorizontalNav",
        fallback: "flag",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($79488f04c14a3737$export$82108adf6887e32e, null)));

});
parcelRegister("7pzgA", function(module, exports) {

let $5656396291d2cf5a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5656396291d2cf5a$var$load("fkutI").then(()=>parcelRequire('kQ8Dl'));

});


parcelRegister("h3Ix2", function(module, exports) {

$parcel$export(module.exports, "opsTeamLayout", () => $687f5bad65d17575$export$53dd27149810df73);

var $aPfsS = parcelRequire("aPfsS");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $687f5bad65d17575$var$RightSidebars = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("bZQnm")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/ops-team-layout/src/ui/right-sidebars/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $687f5bad65d17575$var$Onboarding = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("lIfla")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/ops-team-layout/src/ui/onboarding/index.tsx"
});
const $687f5bad65d17575$export$53dd27149810df73 = (0, $aPfsS.createLayout)({
    get globalComponents () {
        return [
            $687f5bad65d17575$var$Onboarding
        ];
    },
    rightSidebars: [
        $687f5bad65d17575$var$RightSidebars
    ]
});

});
parcelRegister("bZQnm", function(module, exports) {

let $8bbe04f4a42e0584$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8bbe04f4a42e0584$var$load("9CYYI").then(()=>parcelRequire('c3FF8'));

});

parcelRegister("lIfla", function(module, exports) {

let $fce99b55901c06fa$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fce99b55901c06fa$var$load("1Ol4g").then(()=>parcelRequire('dSHkM'));

});


parcelRegister("ep3S0", function(module, exports) {

$parcel$export(module.exports, "alertPoliciesRoute", () => $5c0bbcca2f2afa78$export$eab7ea9e54b67f16);
const $5c0bbcca2f2afa78$export$eab7ea9e54b67f16 = {
    name: 'eoc-team-policies',
    path: '/jira/ops/teams/:teamId/policies',
    exact: true
};

});

parcelRegister("jyzx5", function(module, exports) {

$parcel$export(module.exports, "LazyAlertPolicies", () => $d64c9c110834b4a3$export$3079046c31ee50f7);
$parcel$export(module.exports, "AlertPoliciesComponent", () => $d64c9c110834b4a3$export$882bdfb7e45bd440);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $d64c9c110834b4a3$export$3079046c31ee50f7 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("9h0j1")), {
    moduleId: "./src/packages/eoc/policies/src/index.tsx"
});
const $d64c9c110834b4a3$export$882bdfb7e45bd440 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d64c9c110834b4a3$export$3079046c31ee50f7,
        pageId: "async-jira-eoc-alert-policies",
        shouldShowSpinner: false
    });

});
parcelRegister("5j7Th", function(module, exports) {

$parcel$export(module.exports, "LazyPage", () => $63937a96c08aaddb$export$a18c9c3dd309b8e6);

var $5uXOq = parcelRequire("5uXOq");

var $kb4zh = parcelRequire("kb4zh");

var $2YZCu = parcelRequire("2YZCu");

var $lfTZh = parcelRequire("lfTZh");

var $6jY6G = parcelRequire("6jY6G");

var $7LpuY = parcelRequire("7LpuY");

var $dZw8H = parcelRequire("dZw8H");

var $egPYN = parcelRequire("egPYN");
const $63937a96c08aaddb$var$LOCATION = 'lazy-page';
const $63937a96c08aaddb$export$fb85bbdbfb3e6869 = ()=>null;
const $63937a96c08aaddb$export$a18c9c3dd309b8e6 = ({ pageId: pageId, Page: Page, shouldShowSpinner: shouldShowSpinner = true })=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const Skeleton = route.skeleton || (shouldShowSpinner ? (0, $kb4zh.default) : $63937a96c08aaddb$export$fb85bbdbfb3e6869);
    (0, $5uXOq.useEffect)(()=>{
        if (route.isRedirect) (0, $2YZCu.default).safeWarnWithoutCustomerData($63937a96c08aaddb$var$LOCATION, `LazyPage was used inside a redirect component: ${route.name}`);
    }, [
        route.isRedirect,
        route.name
    ]);
    const fallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Skeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $egPYN.ReportSSRFailOnUse), {
        pageId: pageId
    }));
    return route.isRedirect ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "lazy_page_redirect",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Skeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Page, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7LpuY.default), {
        pageId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStateContainer), {
        isGlobal: true,
        appId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStateAppStartWithMatchCheck), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "lazy_page",
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $egPYN.DisableSSRFailDetection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Page, null)))));
};

});
parcelRegister("kb4zh", function(module, exports) {

$parcel$export(module.exports, "default", () => $c26967b2e10d397c$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fNobW = parcelRequire("fNobW");

var $eZJjh = parcelRequire("eZJjh");
function $c26967b2e10d397c$export$2e2bcd8739ae039({ testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "legacy-spinner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c26967b2e10d397c$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c26967b2e10d397c$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "large",
        testId: testId
    }))));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c26967b2e10d397c$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _ae4v1h6o _4t3i1osq",
            __cmplp.className
        ])
    });
});
const $c26967b2e10d397c$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1wpz1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("7LpuY", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c62dfc18679e80c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kUU4G = parcelRequire("kUU4G");

var $x9xyg = parcelRequire("x9xyg");

var $5h5Fg = parcelRequire("5h5Fg");

var $7N30e = parcelRequire("7N30e");

var $6b6Tk = parcelRequire("6b6Tk");


var $8Qrwl = parcelRequire("8Qrwl");

var $hXKq5 = parcelRequire("hXKq5");
class $6c62dfc18679e80c$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    render() {
        const { children: children, pageId: pageId } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Qrwl.default).Provider, {
            // @ts-expect-error - TS2322 - Type '{ pageId: string; onReady: (metricKeyForInitialRender: string, metricKeyForTransition: string, extra: { [key: string]: string | number | boolean; } | undefined, metric: BM3Metric) => void; onCustomMark: (markName: string) => void; }' is not assignable to type 'string'.
            value: {
                pageId: pageId,
                onReady: this.onReady,
                onCustomMark: this.onCustomMark
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
            op: this.onStart,
            args: [
                pageId
            ]
        }), children));
    }
    constructor(...args){
        super(...args), this.customMarks = [], this.onStart = ()=>{
            (0, $kUU4G.default)((0, $ce556f125dee8174$export$56940a9488e85199));
            (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$45c4b6bf7935c69a));
        }, this.onCustomMark = (markName)=>{
            (0, $x9xyg.setMark)((0, $hXKq5.getPrefixedMarkName)(markName));
            // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
            this.customMarks.push(markName);
        }, this.onReady = (metricKeyForInitialRender, metricKeyForTransition, extra = {}, metric)=>{
            metric.stop({
                customData: extra
            });
            if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.stopLowPriorityEventDelay)();
        };
    }
}

});
parcelRegister("kUU4G", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cb4d2f8b5a69f79$export$2e2bcd8739ae039);

var $6RCeq = parcelRequire("6RCeq");
var /*
 * This utility finds all performance entries that is prefixed
 * with the `prefix` and does clearMarks on each entry.
 * All the entries that are cleared will be returned
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$6cb4d2f8b5a69f79$export$2e2bcd8739ae039 = (prefix)=>{
    // @ts-expect-error - TS2339 - Property 'getEntries' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'.
    if ((0, $6RCeq.default) && (0, $6RCeq.default).getEntries && (0, $6RCeq.default).clearMarks) return (0, $6RCeq.default)// @ts-expect-error - TS2339 - Property 'getEntries' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'.
    .getEntries()// @ts-expect-error - TS7006 - Parameter 'mark' implicitly has an 'any' type.
    .filter((mark)=>mark.name.startsWith(prefix))// @ts-expect-error - TS7006 - Parameter 'mark' implicitly has an 'any' type.
    .map((mark)=>{
        (0, $6RCeq.default).clearMarks(mark.name);
        return mark;
    });
    return [];
};

});

parcelRegister("5h5Fg", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec2154d63d4be857$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");
// eslint-disable-next-line jira/react/no-class-components
class $ec2154d63d4be857$var$OpTrigger extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            args: []
        };
    }
    componentDidMount() {
        this.props.op(...this.props.args);
    }
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(this.props.args, nextProps.args);
    }
    componentDidUpdate() {
        this.props.op(...this.props.args);
    }
    render() {
        return null;
    }
}
var $ec2154d63d4be857$export$2e2bcd8739ae039 = $ec2154d63d4be857$var$OpTrigger;

});

parcelRegister("7N30e", function(module, exports) {

$parcel$export(module.exports, "stopLowPriorityEventDelay", () => $5d68e3874efadecb$export$a928755af449867);
$parcel$export(module.exports, "startLowPriorityEventDelay", () => $5d68e3874efadecb$export$8bb8df5a93e9525);
$parcel$export(module.exports, "default", () => $5d68e3874efadecb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kUU4G = parcelRequire("kUU4G");

var $x9xyg = parcelRequire("x9xyg");

var $3vBBc = parcelRequire("3vBBc");

var $fjcgS = parcelRequire("fjcgS");

var $lsa9q = parcelRequire("lsa9q");

var $6b6Tk = parcelRequire("6b6Tk");

const $5d68e3874efadecb$var$STOP_DELAY_TIMEOUT = 10000;
let $5d68e3874efadecb$var$stopDelayTimeout;
let $5d68e3874efadecb$var$lastDelayActionPromise = (0, $fjcgS.getAnalyticsWebClientPromise)().then((clientWrapper)=>clientWrapper.getInstance());
const $5d68e3874efadecb$export$a928755af449867 = ()=>{
    $5d68e3874efadecb$var$lastDelayActionPromise = $5d68e3874efadecb$var$lastDelayActionPromise.then((client)=>{
        if (!(0, $3vBBc.isEventDelayActive)()) return client;
        clearTimeout($5d68e3874efadecb$var$stopDelayTimeout);
        // stopLowPriorityEventDelay performs a flush of the delayed events,
        // so the delayed period needs to be marked as ended _before_ calling that method.
        (0, $x9xyg.setMark)((0, $2eb1df3f82c48b0d$export$2d91d3eed1108e72));
        (0, $3vBBc.setEventDelayActive)(false);
        client.stopLowPriorityEventDelay();
        return client;
    });
};
const $5d68e3874efadecb$export$8bb8df5a93e9525 = ()=>{
    $5d68e3874efadecb$var$lastDelayActionPromise = $5d68e3874efadecb$var$lastDelayActionPromise.then((client)=>{
        // If startLowPriorityEventDelay is called when it's already active, then we are just extending
        // the delay period, so we don't want to reset any metadata we have captured about the original start.
        if (!(0, $3vBBc.isEventDelayActive)()) {
            (0, $kUU4G.default)((0, $2eb1df3f82c48b0d$export$358721a9d6125914));
            (0, $x9xyg.setMark)((0, $2eb1df3f82c48b0d$export$b2122dce85a27912));
        }
        client.startLowPriorityEventDelay();
        (0, $3vBBc.setEventDelayActive)(true);
        clearTimeout($5d68e3874efadecb$var$stopDelayTimeout);
        $5d68e3874efadecb$var$stopDelayTimeout = setTimeout($5d68e3874efadecb$export$a928755af449867, $5d68e3874efadecb$var$STOP_DELAY_TIMEOUT);
        return client;
    });
};
const $5d68e3874efadecb$export$778ebe2a4fab1ba7 = ()=>$5d68e3874efadecb$var$lastDelayActionPromise;
const $5d68e3874efadecb$var$EventDelayController = ()=>{
    const [loadedState] = (0, $lsa9q.default)();
    (0, $5uXOq.useEffect)(()=>{
        /**
		 * The delay mechanism is currently locked so that only automatic exposure events
		 * can leverage it.
		 * We can remove the performance overhead of starting and stopping critical sections when
		 * these events won't be getting fired.
		 */ if (!loadedState.hasLoaded && (0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) $5d68e3874efadecb$export$8bb8df5a93e9525();
    }, [
        loadedState.hasLoaded
    ]);
    return null;
};
var $5d68e3874efadecb$export$2e2bcd8739ae039 = $5d68e3874efadecb$var$EventDelayController;

});
parcelRegister("3vBBc", function(module, exports) {

$parcel$export(module.exports, "setEventDelayActive", () => $63f3b8c0745d0500$export$9a4add6d6ddcc1a);
$parcel$export(module.exports, "isEventDelayActive", () => $63f3b8c0745d0500$export$3536b0184fa98d19);
let $63f3b8c0745d0500$var$eventDelayActive = false;
const $63f3b8c0745d0500$export$9a4add6d6ddcc1a = (isEventDelayActive)=>{
    $63f3b8c0745d0500$var$eventDelayActive = isEventDelayActive;
};
const $63f3b8c0745d0500$export$3536b0184fa98d19 = ()=>$63f3b8c0745d0500$var$eventDelayActive;

});

parcelRegister("lsa9q", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f20cb56a66aca22$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");


var $7w9eZ = parcelRequire("7w9eZ");
const $4f20cb56a66aca22$export$4a361c7505f72f5c = ({ currentPage: currentPage })=>{
    const { apps: apps } = currentPage;
    const appIds = Object.keys(apps);
    const determineHasLoaded = ()=>{
        /*
		 * During a transition, the top navigation is the only app loading. Additionally, legacy pages generally
		 * render a LegacyPage component, analytics, or nothing at all.
		 *
		 * This code ensures that the page is considered loaded when the content has finished loading in the
		 * SPA, or when the top navigation has finished loading for legacy pages.
		 *
		 * Ideally the LegacyPage component should include an app for the content, but the usage of route components
		 * in legacy routes is inconsistent and would need thorough testing. This should be good enough for now.
		 */ if (appIds.length === 1 && appIds[0] === (0, $146ecce9d079a34d$export$3a54edb6ba4daa82)) return !__SPA__;
        return appIds.length ? appIds.filter((id)=>id !== (0, $146ecce9d079a34d$export$2ee9e5a3556c1e43)).every((id)=>apps[id].endTime != null || apps[id].timeoutTime) : false;
    };
    const hasLoaded = determineHasLoaded();
    return {
        hasLoaded: hasLoaded
    };
};
const $4f20cb56a66aca22$var$usePageLoadedSubscriber = (0, $3sQ5x.createHook)((0, $7w9eZ.default), {
    selector: $4f20cb56a66aca22$export$4a361c7505f72f5c
});
var $4f20cb56a66aca22$export$2e2bcd8739ae039 = $4f20cb56a66aca22$var$usePageLoadedSubscriber;

});
const $146ecce9d079a34d$export$3a54edb6ba4daa82 = 'TOP_NAV';
const $146ecce9d079a34d$export$2ee9e5a3556c1e43 = 'SIDEBAR';


const $2eb1df3f82c48b0d$export$358721a9d6125914 = 'event-delay-controller.';
const $2eb1df3f82c48b0d$export$b2122dce85a27912 = `${$2eb1df3f82c48b0d$export$358721a9d6125914}start`;
const $2eb1df3f82c48b0d$export$2d91d3eed1108e72 = `${$2eb1df3f82c48b0d$export$358721a9d6125914}end`;


const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';

parcelRegister("8Qrwl", function(module, exports) {

$parcel$export(module.exports, "default", () => $d87d05828c384551$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $d87d05828c384551$var$contextName = 'SpaApdexAnalytics';
var $d87d05828c384551$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.createContext)($d87d05828c384551$var$contextName);

});

parcelRegister("hXKq5", function(module, exports) {

$parcel$export(module.exports, "getPrefixedMarkName", () => $f6cddc52a08e036c$export$c8f0e9837e7e9425);

const $f6cddc52a08e036c$export$c8f0e9837e7e9425 = (name)=>`${0, $ce556f125dee8174$export$56940a9488e85199}${name}`;

});


parcelRegister("dZw8H", function(module, exports) {

$parcel$export(module.exports, "SpaStateContainer", () => $b1cd152eb196251c$export$e9a92b877fe80e80);
$parcel$export(module.exports, "SpaStateAppStart", () => $b1cd152eb196251c$export$d18dd27183a635c);
$parcel$export(module.exports, "SpaStateAppStartWithMatchCheck", () => $b1cd152eb196251c$export$95a2912d76fb5433);
$parcel$export(module.exports, "SpaStatePageReady", () => $b1cd152eb196251c$export$c34439f945fccbdf);
$parcel$export(module.exports, "SpaStatePageReadyOnUpdate", () => $b1cd152eb196251c$export$41e70078eeddaddc);
$parcel$export(module.exports, "SpaStatePageErrorReady", () => $b1cd152eb196251c$export$2583aa269898885c);
$parcel$export(module.exports, "getSpaStateLastUserLocation", () => $b1cd152eb196251c$export$6e9ab893e97cccef);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $lODMY = parcelRequire("lODMY");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $bKpgX = parcelRequire("bKpgX");

var $4oDnX = parcelRequire("4oDnX");

var $7w9eZ = parcelRequire("7w9eZ");
const $b1cd152eb196251c$export$e9a92b877fe80e80 = (0, $gg7kZ.createContainer)((0, $7w9eZ.default));
const $b1cd152eb196251c$export$d18dd27183a635c = ()=>{
    const startRef = (0, $5uXOq.useRef)(Date.now());
    const [{ visitedPages: visitedPages }, { setAppStart: setAppStart }] = (0, $4oDnX.useSpaState)();
    (0, $5uXOq.useMemo)(()=>{
        startRef.current = Date.now();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        visitedPages
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        setAppStart(startRef.current);
    }, [
        setAppStart,
        visitedPages
    ]);
    return null;
};
const $b1cd152eb196251c$var$useRouterMatchSelector = (0, $lODMY.createRouterSelector)((state)=>state.match);
const $b1cd152eb196251c$var$useSpaStatePagesCount = (0, $3sQ5x.createHook)((0, $7w9eZ.default), {
    selector: ({ visitedPages: visitedPages })=>visitedPages.length
});
const $b1cd152eb196251c$export$95a2912d76fb5433 = ()=>{
    const match = $b1cd152eb196251c$var$useRouterMatchSelector();
    const [count, { setAppStart: setAppStart }] = $b1cd152eb196251c$var$useSpaStatePagesCount();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b1cd152eb196251c$export$ada7e0ec445851a2, {
        visitedPagesLength: count,
        onSetAppStart: setAppStart,
        match: match
    });
};
const $b1cd152eb196251c$export$c34439f945fccbdf = ()=>/* TODO - this should be using only the actions subscriber not state+actions subscriber */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4oDnX.SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
            op: setAppReady
        }));
const $b1cd152eb196251c$export$41e70078eeddaddc = ({ comparer: comparer } /* TODO - this should be using only the actions subscriber not state+actions subscriber */ )=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4oDnX.SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
            op: setAppReady,
            args: comparer
        }));
const $b1cd152eb196251c$export$2583aa269898885c = ()=>/* TODO - this should be using only the actions subscriber not state+actions subscriber */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4oDnX.SpaStateSubscriber), null, (_, { setAppErrorReady: setAppErrorReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
            op: setAppErrorReady
        }));
class $b1cd152eb196251c$export$ada7e0ec445851a2 extends (0, $5uXOq.Component) {
    static getDerivedStateFromProps(props, state) {
        const visitedPageLengthHasChanged = props.visitedPagesLength !== state.visitedPagesLength;
        const matchHasChanged = props.match !== state.match;
        const setAppStart = !state.started || visitedPageLengthHasChanged && matchHasChanged;
        if (setAppStart) props.onSetAppStart(Date.now());
        // On transition visitedPageLength will always change before match, the only exception is when there is page
        // ids (e.g. issue types). When redirecting, the length doesn't change while the match changes (from issuetype to issuetype/xxxxx).
        // so if match changed without visitedPageLength changing, cache the new match and wait for both to update.
        if (setAppStart || !visitedPageLengthHasChanged) return {
            started: true,
            visitedPagesLength: props.visitedPagesLength,
            match: props.match
        };
        // if visitedPageLength changed, ignore and wait for update in match (which will trigger setAppStart next)
        return state;
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args), /** so the challenge we are facing is that, we need to reset page when there's a visitedPagesLength change and a route change,
	 * but they don't always happen at the the same time during the current spa router situation. The following code does this:
	 *
	 * if first render: set app start
	 *
	 * if subsequently render with only visitedPagesLength change, ignore this updates, cache the old visitedPagesLength,
	 * wait for incoming match change
	 *
	 * if subsequently render with only match change, ignore this updates, cache the old match, wait for incoming
	 * visitedPagesLength change
	 *
	 *  if incoming changes contain both route and length change, we update state and start app
	 *
	 */ this.state = {
            visitedPagesLength: 0,
            started: false,
            match: null
        };
    }
}
const $b1cd152eb196251c$export$6e9ab893e97cccef = ()=>{
    const { visitedPages: visitedPages } = (0, $bKpgX.defaultRegistry).getStore((0, $7w9eZ.default)).storeState.getState();
    return visitedPages.length ? visitedPages[visitedPages.length - 1].userLocation : '';
};

});
parcelRegister("4oDnX", function(module, exports) {

$parcel$export(module.exports, "SpaStateSubscriber", () => $363cd3235a9267e4$export$fd52daf2a3c1ec68);
$parcel$export(module.exports, "SpaStateActionsSubscriber", () => $363cd3235a9267e4$export$3dfa91988c213fbc);
$parcel$export(module.exports, "useSpaState", () => $363cd3235a9267e4$export$a57865516f6345d1);
$parcel$export(module.exports, "useSpaStateActions", () => $363cd3235a9267e4$export$b134752525935b78);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $51nlc = parcelRequire("51nlc");

var $7w9eZ = parcelRequire("7w9eZ");
const $363cd3235a9267e4$export$fd52daf2a3c1ec68 = (0, $51nlc.createSubscriber)((0, $7w9eZ.default));
const $363cd3235a9267e4$export$3dfa91988c213fbc = (0, $51nlc.createSubscriber)((0, $7w9eZ.default), {
    selector: null
});
const $363cd3235a9267e4$export$a57865516f6345d1 = (0, $3sQ5x.createHook)((0, $7w9eZ.default));
const $363cd3235a9267e4$export$b134752525935b78 = (0, $3sQ5x.createHook)((0, $7w9eZ.default), {
    selector: null
});

});


parcelRegister("egPYN", function(module, exports) {

$parcel$export(module.exports, "ReportSSRFailOnUse", () => $a8140c02a0336fa9$export$daa3f09a96683b19);
$parcel$export(module.exports, "DisableSSRFailDetection", () => $a8140c02a0336fa9$export$420f5a45dbda6a67);

var $5uXOq = parcelRequire("5uXOq");
const $a8140c02a0336fa9$export$daa3f09a96683b19 = ()=>{
    // this component does nothing. Its .server. version does
    return null;
};
const $a8140c02a0336fa9$export$420f5a45dbda6a67 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);

});


parcelRegister("9h0j1", function(module, exports) {

let $6c05f0530dadc81c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6c05f0530dadc81c$var$load("ffQaD"),
    $6c05f0530dadc81c$var$load("kvRbA"),
    $6c05f0530dadc81c$var$load("jl4Ih")
]).then(()=>parcelRequire('3IgJn'));

});



parcelRegister("3Ro2a", function(module, exports) {

$parcel$export(module.exports, "applinksExtraAuthHealthcheckRouteEntry", () => $cbeddb358fe83012$export$cd4854d613a2c404);

var $jwnr0 = parcelRequire("jwnr0");

var $3A9DP = parcelRequire("3A9DP");

var $ffza4 = parcelRequire("ffza4");

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $5lsNZ = parcelRequire("5lsNZ");

var $5pSYQ = parcelRequire("5pSYQ");
const $cbeddb358fe83012$export$cd4854d613a2c404 = (0, $7NszV.createEntry)((0, $3A9DP.applinksExtraAuthHealthcheckRoute), ()=>({
        group: 'global-settings',
        ufoName: 'applinks-extra-auth-healthcheck',
        component: (0, $cSD7y.componentWithFG)('applinks-789-extra-auth-healthcheck-frontend', (0, $jwnr0.default), (0, $5lsNZ.default)),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        canTransitionIn: ()=>(0, $4R6GH.fg)('applinks-789-extra-auth-healthcheck-frontend'),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ],
        meta: {
            reporting: {
                id: 'Applinks',
                packageName: 'jiraAdminPagesApplinks',
                teamName: 'olympus'
            }
        }
    }));

});
parcelRegister("jwnr0", function(module, exports) {

$parcel$export(module.exports, "default", () => $e07161e92ae94550$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZw8H = parcelRequire("dZw8H");

var $l8ruj = parcelRequire("l8ruj");

var $9NiTW = parcelRequire("9NiTW");

var $lJ7oK = parcelRequire("lJ7oK");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e07161e92ae94550$var$HealthcheckPage = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "applinks-extra-auth-healthcheck-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9NiTW.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lJ7oK.default), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageReady), null)));
var $e07161e92ae94550$export$2e2bcd8739ae039 = $e07161e92ae94550$var$HealthcheckPage;

});
parcelRegister("l8ruj", function(module, exports) {

$parcel$export(module.exports, "default", () => $6056b4460d0127e0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $1tcYS = parcelRequire("1tcYS");

var $bFU4G = parcelRequire("bFU4G");

var $8Ec39 = parcelRequire("8Ec39");

var $cEm1b = parcelRequire("cEm1b");

var $4R6GH = parcelRequire("4R6GH");

var $c1haS = parcelRequire("c1haS");

var $aJOZ3 = parcelRequire("aJOZ3");
/** A portion of the page we apply measurement to */ function $6056b4460d0127e0$var$JiraUFOSegmentWrapper({ children: children }) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const interactionContext = (0, $1tcYS.useInteractionContext)();
    const relayProfilerContext = (0, $5uXOq.useMemo)(()=>({
            getInteractionContext: ()=>interactionContext,
            wrapPrepareQueryResource (cb) {
                return cb();
            },
            retainQuery (info) {
                this.getInteractionContext().retainQuery(info);
            }
        }), [
        interactionContext
    ]);
    const reactLooselyLazyContext = (0, $5uXOq.useMemo)(()=>{
        const moduleLoadingRequests = {};
        return {
            current: {
                getInteractionContext () {
                    return interactionContext;
                },
                onPreload (moduleId, _priority) {
                    if ((0, $c1haS.getIsConcurrentEnabled)() && (0, $4R6GH.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    this.getInteractionContext().addPreload((0, $bFU4G.extractModuleName)(moduleId), performance.now());
                },
                onLoadStart (info) {
                    if ((0, $c1haS.getIsConcurrentEnabled)() && (0, $4R6GH.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    const timeoutId = setTimeout(()=>{
                        delete moduleLoadingRequests[info.identifier];
                    }, 30000);
                    const request = {
                        start: performance.now(),
                        timeoutId: timeoutId
                    };
                    moduleLoadingRequests[info.identifier] = request;
                },
                onLoadComplete (info) {
                    if ((0, $c1haS.getIsConcurrentEnabled)() && (0, $4R6GH.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    const request = moduleLoadingRequests[info.identifier];
                    if (request) {
                        clearTimeout(request.timeoutId);
                        delete moduleLoadingRequests[info.identifier];
                        this.getInteractionContext()?.addLoad((0, $bFU4G.extractModuleName)(info.identifier), request.start, performance.now());
                    }
                },
                placeholderFallBackMounted (id, name, lazyWait) {
                    if ((name === 'nav4-ignore.sidebar' || name === 'nav4-ignore.sidebar.anonymous') && (0, $4R6GH.fg)('afo-3421-remove-sidebar-nav4-suspense')) return;
                    if (lazyWait) return;
                    this.getInteractionContext().addHoldByID(this.getInteractionContext().labelStack, id, name);
                },
                placeholderFallBackUnmounted (id, name, lazyWait) {
                    if ((name === 'nav4-ignore.sidebar' || name === 'nav4-ignore.sidebar.anonymous') && (0, $4R6GH.fg)('afo-3421-remove-sidebar-nav4-suspense')) return;
                    if (lazyWait) return;
                    this.getInteractionContext().removeHoldByID(this.getInteractionContext().labelStack, id, name);
                }
            }
        };
    }, [
        interactionContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.ProfilerContext).Provider, {
        value: relayProfilerContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aJOZ3.default), {
        labelStack: interactionContext.labelStack,
        onRender: (...args)=>interactionContext.onRender(...args)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cEm1b.ProfilerContext).Provider, {
        value: reactLooselyLazyContext
    }, children)));
}
function $6056b4460d0127e0$export$2e2bcd8739ae039({ name: segmentName, children: children, mode: mode = 'single' }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Ec39.default), {
        name: segmentName,
        mode: mode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6056b4460d0127e0$var$JiraUFOSegmentWrapper, null, children));
}

});
parcelRegister("aJOZ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $37d596e34a54eb72$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $37d596e34a54eb72$var$SsrRenderProfiler = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
var $37d596e34a54eb72$export$2e2bcd8739ae039 = $37d596e34a54eb72$var$SsrRenderProfiler;

});


parcelRegister("9NiTW", function(module, exports) {

$parcel$export(module.exports, "checkAuthentication", () => $ad297a7f2ce81084$export$b8dbb7d6029c5413);
$parcel$export(module.exports, "AuthenticationCheck", () => $ad297a7f2ce81084$export$e9b9096e887386fe);

var $5uXOq = parcelRequire("5uXOq");

var $9OXo1 = parcelRequire("9OXo1");

var $38Y30 = parcelRequire("38Y30");
const $ad297a7f2ce81084$export$b8dbb7d6029c5413 = (tenantContext)=>Boolean(tenantContext.atlassianAccountId);
const $ad297a7f2ce81084$export$e9b9096e887386fe = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        if ($ad297a7f2ce81084$export$b8dbb7d6029c5413(tenantContext)) return children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38Y30.RedirectToLoginPage), null);
    });

});
parcelRegister("38Y30", function(module, exports) {

$parcel$export(module.exports, "RedirectToLoginPage", () => $08f8c3f776d557a9$export$938182bd3fddc3a8);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
var $ieDtd = parcelRequire("ieDtd");
var $doZTA = parcelRequire("doZTA");
const $08f8c3f776d557a9$export$3da29de62ed7a388 = ({ to: to })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("script", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `window.location.assign("${to}")`
        }
    });
$08f8c3f776d557a9$export$3da29de62ed7a388.displayName = 'InlineRedirect';
const $08f8c3f776d557a9$export$938182bd3fddc3a8 = ()=>{
    const [{ location: { pathname: pathname, search: search } }] = (0, $doZTA.useRouter)();
    const redirectUrl = pathname + search;
    const encodedRedirectUrl = encodeURIComponent(redirectUrl);
    let path = `/login.jsp?os_destination=${encodedRedirectUrl}`;
    const parentProductQueryName = 'parentProduct';
    const [parentProduct] = (0, $ieDtd.useQueryParam)(parentProductQueryName);
    if (pathname.endsWith('/embed')) {
        const searchParams = new URLSearchParams(search);
        // We need to remove parentProduct param as it is only used in embed urls
        searchParams.delete(parentProductQueryName);
        /**
		 * encodedLink is the link to the non embedded version of the embed url.
		 * So, we strip out the /embed suffix from path
		 */ let encodedLink = encodeURIComponent(`${pathname.slice(0, -6)}?${searchParams}`);
        /**
		 * this is the specific case for create issue embed, where we need to redirect
		 * user to your-work page with create issue as true to open GIC by default.
		 * We will remove this when we FPIC exp implemented for GIC
		 */ if (pathname.includes('/issues/create')) encodedLink = encodeURIComponent('/jira/your-work?createissue=true');
        const encodedParentProduct = encodeURIComponent(parentProduct || '');
        path = `/jira-login/embed?destination=${encodedRedirectUrl}&link=${encodedLink}&parentProduct=${encodedParentProduct}`;
    }
    return false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08f8c3f776d557a9$export$3da29de62ed7a388, {
        to: path
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: path
    });
};

});


parcelRegister("lJ7oK", function(module, exports) {

$parcel$export(module.exports, "default", () => $a46c08b21138da0f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1bQGJ = parcelRequire("1bQGJ");

var $2YZCu = parcelRequire("2YZCu");

var $ismUQ = parcelRequire("ismUQ");


var $jJPaN = parcelRequire("jJPaN");
const $a46c08b21138da0f$export$7955d5fe058be414 = ()=>{
    const [healthcheck, setHealthcheck] = (0, $5uXOq.useState)(null);
    (0, $5uXOq.useEffect)(()=>{
        (0, $ismUQ.getHealthcheck)().then((data)=>{
            setHealthcheck(data);
        }).catch((err)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData((0, $3afa7e74a551cd1c$export$25a759e49d5049db), 'Failed to fetch healthcheck data', err);
            setHealthcheck(null);
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jJPaN.default), {
        healthcheck: healthcheck
    });
};
var $a46c08b21138da0f$export$2e2bcd8739ae039 = (0, $1bQGJ.withRouter)($a46c08b21138da0f$export$7955d5fe058be414);

});
parcelRegister("ismUQ", function(module, exports) {

$parcel$export(module.exports, "getHealthcheck", () => $b7c49ceb2b91f3bc$export$47b0be97eea80dc5);

var $7f4tk = parcelRequire("7f4tk");
const $b7c49ceb2b91f3bc$export$47b0be97eea80dc5 = ()=>(0, $7f4tk.default)('/rest/applinks/latest/applicationlink/extraAuth/healthcheck');

});

const $3afa7e74a551cd1c$export$25a759e49d5049db = 'applinks.extra-auth.healthcheck';

parcelRegister("jJPaN", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fe5bef83d0b878b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $7CMCs = parcelRequire("7CMCs");

var $6imks = parcelRequire("6imks");

var $426ZA = parcelRequire("426ZA");
const $0fe5bef83d0b878b$var$HealthcheckPageContents = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "applinks-extra-auth-healthcheck-page",
        teamName: "olympus",
        packageName: "applinksExtraAuthHealthcheckPage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200",
        xcss: $0fe5bef83d0b878b$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $426ZA.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.800"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6imks.default), {
        title: "Prerequisites",
        description: "Ensure that the following prerequisites are met before beginning the setup process.",
        healthcheckEntries: props.healthcheck?.healthcheckPreconditions ?? null
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6imks.default), {
        title: "OAuth 2.0 Provider Configuration",
        description: "Extra Authentication uses an external OAuth 2.0 provider, shared by all products within your organization. The provider must be configured correctly before Application Links can be created.",
        healthcheckEntries: props.healthcheck?.healthcheckEntries ?? null
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6imks.default), {
        title: "Applink Status",
        description: "Once the authentication provider is configured, you can now create Application Links. All links configured to use Extra Authentication for this site are displayed below.",
        healthcheckEntries: props.healthcheck?.healthcheckStatuses ?? null
    })))));
};
var $0fe5bef83d0b878b$export$2e2bcd8739ae039 = $0fe5bef83d0b878b$var$HealthcheckPageContents;
const $0fe5bef83d0b878b$var$styles = (0, $8CUq3.xcss)({
    padding: 'space.200'
});

});
parcelRegister("6imks", function(module, exports) {

$parcel$export(module.exports, "default", () => $12bdc979066f02a9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $2iqNv = parcelRequire("2iqNv");
var $6o3Pm = parcelRequire("6o3Pm");
var $8L11u = parcelRequire("8L11u");
var $4klZJ = parcelRequire("4klZJ");
var $bJ8bc = parcelRequire("bJ8bc");
var $ciNvy = parcelRequire("ciNvy");

var $4fTUQ = parcelRequire("4fTUQ");

var $hI6SY = parcelRequire("hI6SY");

var $cuJs9 = parcelRequire("cuJs9");

var $l1N8i = parcelRequire("l1N8i");

var $bmSXq = parcelRequire("bmSXq");
const $12bdc979066f02a9$var$HealthcheckIcon = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.status.statusType === 'SUCCESS' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fTUQ))), {
        color: "var(--ds-icon-success, #22A06B)",
        label: "Success"
    }), props.status.statusType === 'FAILURE' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hI6SY))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "Unsuccessful"
    }), props.status.statusType === 'NOT_TRIED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cuJs9))), {
        color: "var(--ds-icon, #44546F)",
        label: "Not Tried"
    }));
};
const $12bdc979066f02a9$var$getColorFromStatus = (status)=>{
    if (status.statusType === 'NOT_TRIED') return 'color.text.disabled';
    return 'color.text';
};
const $12bdc979066f02a9$var$HealthcheckTitle = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: $12bdc979066f02a9$var$getColorFromStatus(props.status)
    }, props.name);
};
const $12bdc979066f02a9$var$HealthcheckComment = (props)=>{
    const message = 'message' in props.status ? props.status.message : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: $12bdc979066f02a9$var$getColorFromStatus(props.status)
    }, message);
};
const $12bdc979066f02a9$var$convertToArray = (healthcheckEntries)=>{
    const wrapWithItem = (id, content, hasChildren, children)=>{
        return {
            id: id,
            content: content,
            hasChildren: hasChildren,
            children: children
        };
    };
    return healthcheckEntries.map((entry, index)=>{
        return wrapWithItem(`entry-${index}`, entry, false);
    });
};
const $12bdc979066f02a9$var$HealthcheckTable = (props)=>{
    const healthcheckItems = props.healthcheckEntries ? $12bdc979066f02a9$var$convertToArray(props.healthcheckEntries) : undefined; // Loading state
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "medium"
    }, props.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, props.description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6o3Pm.default), {
        label: "Healthcheck Table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4klZJ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8L11u.default), {
        width: "100px"
    }, "Status"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8L11u.default), {
        width: "50%"
    }, "Item"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8L11u.default), {
        width: "50%"
    }, "Details")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ciNvy.default), {
        items: healthcheckItems,
        render: (item)=>{
            const { content: content } = item;
            const row = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bJ8bc.default), {
                key: item.id,
                itemId: item.id,
                hasChildren: item.hasChildren
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2iqNv.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12bdc979066f02a9$var$HealthcheckIcon, content)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2iqNv.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12bdc979066f02a9$var$HealthcheckTitle, content)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2iqNv.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12bdc979066f02a9$var$HealthcheckComment, content)));
            if (content.status.statusType === 'FAILURE') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, row, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bJ8bc.default), {
                key: `${item.id}-suggested-action`,
                itemId: `${item.id}-suggested-action`,
                hasChildren: false
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $12bdc979066f02a9$var$suggestedActionCellStyles,
                role: "cell"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bmSXq.default), {
                error: `Step "${content.name}" failed due to reason: "${content.status.message}".`,
                action: content.suggestedAction ?? null,
                link: content.suggestedActionLink ?? null
            }))));
            return row;
        }
    })));
};
var $12bdc979066f02a9$export$2e2bcd8739ae039 = $12bdc979066f02a9$var$HealthcheckTable;
const $12bdc979066f02a9$var$suggestedActionCellStyles = (0, $8CUq3.xcss)({
    width: '100%',
    padding: 'space.200'
});

});
parcelRegister("2iqNv", function(module, exports) {

$parcel$export(module.exports, "default", () => $92bd75f432ed306e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7GpC8 = parcelRequire("7GpC8");

var $j4H2b = parcelRequire("j4H2b");

var $4FjHP = parcelRequire("4FjHP");
const $92bd75f432ed306e$var$CellComponent = ({ children: children, singleLine: singleLine, indentLevel: indentLevel, width: width, className: className, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $7GpC8.default), {
        indent: indentLevel ? `calc(${"var(--ds-space-300, 25px)"} * ${indentLevel})` : undefined,
        width: width,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j4H2b.default), {
            isSingleLine: singleLine,
            children: children
        })
    });
const $92bd75f432ed306e$var$Cell = (0, $4FjHP.default)($92bd75f432ed306e$var$CellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$92bd75f432ed306e$export$2e2bcd8739ae039 = $92bd75f432ed306e$var$Cell;

});
parcelRegister("7GpC8", function(module, exports) {

$parcel$export(module.exports, "default", () => $10bc859ac0cd4c5d$export$2e2bcd8739ae039);
/* common-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $10bc859ac0cd4c5d$var$commonStyles = null;
/**
 * __Common cell__
 */ const $10bc859ac0cd4c5d$var$CommonCell = ({ indent: indent, width: width, className: className, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "gridcell",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_1yt413wy _11c82smr _1e0c1txw _vchhusvi _1tke1ylp _kqswh2mm _4cvr1h6o _syaz1fxt _ct361wug _1nmz1hna",
            className
        ]),
        ...props,
        style: {
            '--indent': indent,
            width: width
        }
    });
var $10bc859ac0cd4c5d$export$2e2bcd8739ae039 = $10bc859ac0cd4c5d$var$CommonCell;

});

parcelRegister("j4H2b", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dc1ffb24ef9838b$export$2e2bcd8739ae039);
/* overflow-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $3dc1ffb24ef9838b$var$overflowContainerStyles = null;
/**
 * __Overflow container__
 */ const $3dc1ffb24ef9838b$var$OverflowContainer = ({ isSingleLine: isSingleLine, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props,
        className: (0, $bwpsq.default)([
            isSingleLine && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
        ])
    });
var $3dc1ffb24ef9838b$export$2e2bcd8739ae039 = $3dc1ffb24ef9838b$var$OverflowContainer;

});

parcelRegister("4FjHP", function(module, exports) {

$parcel$export(module.exports, "default", () => $b855ad5734447a55$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $d2azQ = parcelRequire("d2azQ");
function $b855ad5734447a55$export$2e2bcd8739ae039(Cell) {
    return (props)=>{
        const { setColumnWidth: setColumnWidth, getColumnWidth: getColumnWidth } = (0, $5uXOq.useContext)((0, $d2azQ.TableTreeContext));
        const { width: width, columnIndex: columnIndex, ...other } = props;
        (0, $5uXOq.useEffect)(()=>{
            if (width !== undefined && columnIndex !== undefined) setColumnWidth(columnIndex, width);
        }, [
            width,
            columnIndex,
            setColumnWidth
        ]);
        let columnWidth;
        if (width !== null && width !== undefined) columnWidth = width;
        else if (columnIndex !== undefined) columnWidth = getColumnWidth(columnIndex);
        return /*#__PURE__*/ (0, $2OMIu.jsx)(Cell, {
            width: columnWidth,
            ...other
        });
    };
}

});
parcelRegister("d2azQ", function(module, exports) {

$parcel$export(module.exports, "TableTreeContext", () => $f9c36597fac53fcf$export$662c2d348d8b71af);

var $5uXOq = parcelRequire("5uXOq");
const $f9c36597fac53fcf$export$662c2d348d8b71af = /*#__PURE__*/ (0, $5uXOq.createContext)({
    setColumnWidth: ()=>{},
    getColumnWidth: ()=>null
});

});



parcelRegister("6o3Pm", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3356b60828ab4f6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2iqNv = parcelRequire("2iqNv");

var $8L11u = parcelRequire("8L11u");

var $4klZJ = parcelRequire("4klZJ");

var $d2azQ = parcelRequire("d2azQ");

var $bJ8bc = parcelRequire("bJ8bc");

var $ciNvy = parcelRequire("ciNvy");
const $d3356b60828ab4f6$var$emptyColumnWidths = [];
function $d3356b60828ab4f6$var$TableTree({ children: children, columns: columns, columnWidths: defaultColumnWidths = $d3356b60828ab4f6$var$emptyColumnWidths, headers: headers, shouldExpandOnClick: shouldExpandOnClick, items: items, mainColumnForExpandCollapseLabel: mainColumnForExpandCollapseLabel, label: label, referencedLabel: referencedLabel }) {
    const [columnWidths, setColumnWidths] = (0, $5uXOq.useState)(defaultColumnWidths);
    const setColumnWidth = (0, $5uXOq.useCallback)((columnIndex, width)=>{
        if (width === columnWidths[columnIndex]) return;
        setColumnWidths((columnWidths)=>{
            const newColumnWidths = [
                ...columnWidths
            ];
            newColumnWidths[columnIndex] = width;
            return newColumnWidths;
        });
    }, [
        columnWidths
    ]);
    const getColumnWidth = (0, $5uXOq.useCallback)((columnIndex)=>{
        return columnWidths[columnIndex] || null;
    }, [
        columnWidths
    ]);
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            setColumnWidth: setColumnWidth,
            getColumnWidth: getColumnWidth
        }), [
        setColumnWidth,
        getColumnWidth
    ]);
    const heads = headers && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4klZJ.default), {
        children: headers.map((header, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $8L11u.default), {
                columnIndex: index,
                width: columnWidths[index],
                children: header
            }, index))
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d2azQ.TableTreeContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            role: "treegrid",
            "aria-readonly": true,
            "aria-label": label,
            "aria-labelledby": referencedLabel,
            children: [
                heads,
                columns && items && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ciNvy.default), {
                    items: items,
                    render: ({ id: id, children: children, content: content })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $bJ8bc.default), {
                            itemId: id,
                            items: children,
                            hasChildren: !!children && children.length > 0,
                            shouldExpandOnClick: shouldExpandOnClick,
                            mainColumnForExpandCollapseLabel: mainColumnForExpandCollapseLabel,
                            children: columns.map((CellContent, index)=>{
                                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2iqNv.default), {
                                    columnIndex: index,
                                    width: columnWidths[index],
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(CellContent, {
                                        ...content
                                    })
                                }, `cell-${index}`);
                            })
                        })
                }),
                children
            ]
        })
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d3356b60828ab4f6$export$2e2bcd8739ae039 = $d3356b60828ab4f6$var$TableTree;

});
parcelRegister("8L11u", function(module, exports) {

$parcel$export(module.exports, "default", () => $dff9faceee2cad8f$export$2e2bcd8739ae039);
/* header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7GpC8 = parcelRequire("7GpC8");

var $4FjHP = parcelRequire("4FjHP");
const $dff9faceee2cad8f$var$headerStyles = null;
const $dff9faceee2cad8f$var$HeaderComponent = ({ width: width, children: children, onClick: onClick, id: id, role: role = 'columnheader' })=>{
    // TODO: Determine whether proper `th` elements can be used instead of
    // roles (DSP-11588)
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7GpC8.default), {
        role: role,
        width: width,
        id: id,
        onClick: onClick,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _syaz1n3s _k48pmoej"
        ]),
        children: children
    });
};
const $dff9faceee2cad8f$var$Header = (0, $4FjHP.default)($dff9faceee2cad8f$var$HeaderComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$dff9faceee2cad8f$export$2e2bcd8739ae039 = $dff9faceee2cad8f$var$Header;

});

parcelRegister("4klZJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $541b343154ef9600$export$2e2bcd8739ae039);
/* headers.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
/* eslint-disable @repo/internal/react/no-clone-element */ const $541b343154ef9600$var$containerStyles = null;
/**
 * __Headers__
 *
 * Headers component for advanced composition of data, allowing custom data structures.
 *
 * - [Examples](https://atlassian.design/components/table-tree/examples#advanced)
 * - [Code](https://atlassian.design/components/table-tree/code#headers-props)
 */ const $541b343154ef9600$var$Headers = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "row",
        className: (0, $bwpsq.default)([
            "_179r17qy _1e0c1txw"
        ]),
        children: (0, $5uXOq.Children).map(children, (header, index)=>/*#__PURE__*/ (0, $5uXOq.cloneElement)(header, {
                key: index,
                columnIndex: index
            }))
    });
var $541b343154ef9600$export$2e2bcd8739ae039 = $541b343154ef9600$var$Headers;

});

parcelRegister("bJ8bc", function(module, exports) {

$parcel$export(module.exports, "default", () => $66a5e6ea936beeef$export$2e2bcd8739ae039);
/* row.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $aaC5W = parcelRequire("aaC5W");

var $bToof = parcelRequire("bToof");

var $hwWh4 = parcelRequire("hwWh4");
const $66a5e6ea936beeef$var$treeRowClickableStyles = null;
const $66a5e6ea936beeef$var$getExtendedLabel = (cellContent, cellIndex, mainColumnForExpandCollapseLabel)=>{
    /**
   * First condition - when we pass data via `items` property in `<TableTree />`
   * Second condition - when we pass data via `<Rows />` as children in `<TableTree />`.
   */ if (cellContent.hasOwnProperty('props')) return cellContent?.props[mainColumnForExpandCollapseLabel?.toLowerCase()];
    else if (cellIndex === mainColumnForExpandCollapseLabel) return cellContent;
    return undefined;
};
function $66a5e6ea936beeef$var$Row({ shouldExpandOnClick: shouldExpandOnClick, hasChildren: hasChildren, depth: depth, renderChildren: renderChildren, isDefaultExpanded: isDefaultExpanded, data: data, onExpand: providedOnExpand, onCollapse: providedOnCollapse, mainColumnForExpandCollapseLabel: mainColumnForExpandCollapseLabel, expandLabel: expandLabel, collapseLabel: collapseLabel, itemId: itemId, children: children, isExpanded: isProvidedExpanded }) {
    const [isExpandedState, setIsExpandedState] = (0, $5uXOq.useState)(isDefaultExpanded || false);
    (0, $5uXOq.useEffect)(()=>{
        if (isProvidedExpanded === undefined && isDefaultExpanded !== undefined) setIsExpandedState(isDefaultExpanded);
    }, [
        isDefaultExpanded,
        isProvidedExpanded
    ]);
    const onExpand = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (value)=>providedOnExpand && providedOnExpand(value),
        action: 'expanded',
        actionSubject: 'tableTree',
        componentName: 'row',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onCollapse = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (value)=>providedOnCollapse && providedOnCollapse(value),
        action: 'collapsed',
        actionSubject: 'tableTree',
        componentName: 'row',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    }); /**
       * This ensures a user won't trigger a click event and expand the accordion
       * when making a text selection.
       */ 
    const onClickHandler = (e)=>{
        const selection = window.getSelection()?.toString() || '';
        if (selection?.length === 0) onExpandToggle(e);
    };
    const onExpandStateChange = (isExpanded)=>{
        if (data) {
            if (isExpanded && onExpand) onExpand(data);
            else if (!isExpanded && onCollapse) onCollapse(data);
        }
    };
    const onExpandToggle = (e)=>{
        e.stopPropagation();
        if (isProvidedExpanded !== undefined) onExpandStateChange(!isProvidedExpanded);
        else setIsExpandedState((prevState)=>{
            onExpandStateChange(!prevState);
            return !prevState;
        });
    };
    const renderCell = (cell, cellIndex)=>{
        const isFirstCell = cellIndex === 0;
        const indentLevel = isFirstCell ? depth : 0;
        let cellContent = cell.props.children || [];
        const extendedLabel = $66a5e6ea936beeef$var$getExtendedLabel(cellContent, cellIndex, mainColumnForExpandCollapseLabel);
        if (isFirstCell && hasChildren) cellContent = [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bToof.default), {
                expandLabel: expandLabel,
                collapseLabel: collapseLabel,
                extendedLabel: extendedLabel,
                isExpanded: isProvidedExpanded !== undefined ? isProvidedExpanded : isExpandedState,
                onExpandToggle: onExpandToggle,
                ariaControls: !!itemId ? (0, $aaC5W.default)(itemId) : undefined,
                rowId: !!itemId ? itemId : ''
            }, "chevron")
        ].concat(cellContent);
         // eslint-disable-next-line @repo/internal/react/no-clone-element
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(cell, {
            key: cellIndex,
            columnIndex: cellIndex,
            indentLevel: indentLevel
        }, cellContent);
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hwWh4.TreeRowContainer), {
                onClick: hasChildren && shouldExpandOnClick ? onClickHandler : undefined,
                "aria-expanded": hasChildren ? isExpandedState : undefined,
                "aria-level": depth ? depth : undefined,
                className: (0, $bwpsq.default)([
                    hasChildren && shouldExpandOnClick && "_80omtlke"
                ]),
                children: (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children, (cell, index)=>renderCell(cell, index))
            }),
            hasChildren && (isProvidedExpanded !== undefined ? isProvidedExpanded : isExpandedState) && renderChildren && renderChildren()
        ]
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$66a5e6ea936beeef$export$2e2bcd8739ae039 = $66a5e6ea936beeef$var$Row;

});
parcelRegister("aaC5W", function(module, exports) {

$parcel$export(module.exports, "default", () => $004643d57fa9d692$export$2e2bcd8739ae039);
function $004643d57fa9d692$export$2e2bcd8739ae039(id) {
    return `tabletreeitem-${id}`.replace(/[^-_a-zA-Z0-9]/g, '');
}

});

parcelRegister("bToof", function(module, exports) {

$parcel$export(module.exports, "default", () => $8907d8a97de1d2f1$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/consistent-props-definitions */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $eGmKJ = parcelRequire("eGmKJ");

var $kEVMo = parcelRequire("kEVMo");

var $3uzfU = parcelRequire("3uzfU");

var $hwWh4 = parcelRequire("hwWh4");
/**
 * Internal chevron component.
 */ const $8907d8a97de1d2f1$var$Chevron = ({ isExpanded: isExpanded, ariaControls: ariaControls, collapseLabel: collapseLabel = 'Collapse', expandLabel: expandLabel = 'Expand', rowId: rowId, extendedLabel: extendedLabel, onExpandToggle: onExpandToggle = (0, $eGmKJ.default) })=>{
    const getLabel = (defaultLabel)=>extendedLabel ? `${defaultLabel} ${extendedLabel} row` : `${defaultLabel} row ${rowId}`;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hwWh4.ChevronContainer), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
            appearance: "subtle",
            onClick: onExpandToggle,
            spacing: "compact",
            icon: (iconProps)=>isExpanded ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kEVMo))), {
                    ...iconProps,
                    size: "small"
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3uzfU))), {
                    ...iconProps,
                    size: "small"
                }),
            "aria-controls": isExpanded ? ariaControls : undefined,
            label: isExpanded ? getLabel(collapseLabel) : getLabel(expandLabel)
        })
    });
};
var $8907d8a97de1d2f1$export$2e2bcd8739ae039 = $8907d8a97de1d2f1$var$Chevron;

});
parcelRegister("hwWh4", function(module, exports) {

$parcel$export(module.exports, "TreeRowContainer", () => $95c9625625cd9bb5$export$802d2031792f9e4);
$parcel$export(module.exports, "ChevronContainer", () => $95c9625625cd9bb5$export$f25bd028f55b3d30);
$parcel$export(module.exports, "LoaderItemContainer", () => $95c9625625cd9bb5$export$94ae573de7227397);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $95c9625625cd9bb5$var$treeRowContainerStyles = null;
const $95c9625625cd9bb5$export$802d2031792f9e4 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "row",
        ...props,
        className: (0, $bwpsq.default)([
            "_179r1l7n _1e0c1txw"
        ])
    });
const $95c9625625cd9bb5$var$commonCellElementStyles = null;
const $95c9625625cd9bb5$var$commonChevronContainerStyles = null;
const $95c9625625cd9bb5$export$f25bd028f55b3d30 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswstnw _4cvr1h6o _ahbqf2s7",
            "_1pfhj39m"
        ])
    });
const $95c9625625cd9bb5$var$loadingItemContainerStyles = null;
const $95c9625625cd9bb5$var$paddingLeftStyles = null;
const $95c9625625cd9bb5$export$94ae573de7227397 = ({ isRoot: isRoot, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswstnw _4cvr1h6o _ahbqf2s7",
            "_1bsb1osq",
            isRoot && "_bozg1ssb"
        ])
    });

});



parcelRegister("ciNvy", function(module, exports) {

$parcel$export(module.exports, "default", () => $762c24e6d842b023$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ephf8 = parcelRequire("ephf8");
function $762c24e6d842b023$var$Rows({ items: items, render: render, loadingLabel: loadingLabel = 'Loading' }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "rowgroup",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ephf8.default), {
            items: items,
            loadingLabel: loadingLabel,
            render: render
        })
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$762c24e6d842b023$export$2e2bcd8739ae039 = $762c24e6d842b023$var$Rows;

});
parcelRegister("ephf8", function(module, exports) {

$parcel$export(module.exports, "default", () => $8669f6c312abfec5$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gru3E = parcelRequire("gru3E");

var $cvRdN = parcelRequire("cvRdN");
function $8669f6c312abfec5$var$Items({ depth: depth = 0, items: items, loadingLabel: loadingLabel, render: render }) {
    const [isLoaderShown, setIsLoaderShown] = (0, $5uXOq.useState)(false);
    const handleLoaderComplete = ()=>setIsLoaderShown(false);
    return !items || isLoaderShown ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cvRdN.default), {
        isCompleting: !!(items && items.length),
        onComplete: handleLoaderComplete,
        depth: depth + 1,
        loadingLabel: loadingLabel
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: items.map((data)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $gru3E.default), {
                data: data,
                depth: depth + 1,
                render: render,
                loadingLabel: loadingLabel
            }, data.id))
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8669f6c312abfec5$export$2e2bcd8739ae039 = $8669f6c312abfec5$var$Items;

});
parcelRegister("gru3E", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e08717fdca9a271$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-clone-element */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $aaC5W = parcelRequire("aaC5W");

var $ephf8 = parcelRequire("ephf8");
/**
 * __Item__
 * Internal item component.
 */ function $3e08717fdca9a271$var$Item({ depth: depth = 0, data: data, render: render, loadingLabel: loadingLabel }) {
    const renderedRow = render(data);
    if (!renderedRow) return null;
    // itemId exists on RowProps, but not on RowsProps
    const itemId = 'itemId' in renderedRow.props ? renderedRow.props.itemId : undefined;
    const items = renderedRow.props.items;
    return /*#__PURE__*/ (0, $5uXOq.cloneElement)(renderedRow, {
        depth: depth,
        data: data,
        loadingLabel: loadingLabel,
        renderChildren: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                id: !!itemId ? (0, $aaC5W.default)(itemId) : undefined,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ephf8.default), {
                    depth: depth,
                    items: items,
                    render: render,
                    loadingLabel: loadingLabel
                })
            })
    });
}
var $3e08717fdca9a271$export$2e2bcd8739ae039 = $3e08717fdca9a271$var$Item;

});

parcelRegister("cvRdN", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b92a4bcbfea61f3$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eZJjh = parcelRequire("eZJjh");

var $7GpC8 = parcelRequire("7GpC8");

var $hwWh4 = parcelRequire("hwWh4");
const $9b92a4bcbfea61f3$var$LoaderItem = ({ depth: depth = 1, loadingLabel: loadingLabel, isCompleting: isCompleting, onComplete: onComplete })=>{
    const [phase, setPhase] = (0, $5uXOq.useState)('loading');
    (0, $5uXOq.useEffect)(()=>{
        if (phase === 'loading' && isCompleting) setPhase(()=>{
            onComplete();
            return 'complete';
        });
    }, [
        isCompleting,
        onComplete,
        phase
    ]);
    return phase === 'loading' ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hwWh4.TreeRowContainer), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7GpC8.default), {
            indent: `calc(${"var(--ds-space-300, 25px)"} * ${depth})`,
            width: "100%",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hwWh4.LoaderItemContainer), {
                isRoot: depth === 1,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
                    size: "small",
                    testId: "table-tree-spinner",
                    label: loadingLabel
                })
            })
        })
    }) : null;
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9b92a4bcbfea61f3$export$2e2bcd8739ae039 = $9b92a4bcbfea61f3$var$LoaderItem;

});




parcelRegister("4fTUQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8cc756abdbbefcea85e2842ee2eda39e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3193efd97e755f1c$var$_react = $3193efd97e755f1c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3193efd97e755f1c$var$_baseNew = $3193efd97e755f1c$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3193efd97e755f1c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3193efd97e755f1c$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $3193efd97e755f1c$var$_react.default.createElement($3193efd97e755f1c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$3193efd97e755f1c$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $3193efd97e755f1c$var$_default = module.exports.default = $3193efd97e755f1c$var$StatusSuccessIcon;

});

parcelRegister("cuJs9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8514ab409cdd1786faf0e15acb24fff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $918b8b64efc9a190$var$_react = $918b8b64efc9a190$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $918b8b64efc9a190$var$_baseNew = $918b8b64efc9a190$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $918b8b64efc9a190$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TaskToDo".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for to-do task status. Used in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $918b8b64efc9a190$var$TaskToDoIcon = (props)=>/*#__PURE__*/ $918b8b64efc9a190$var$_react.default.createElement($918b8b64efc9a190$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.028 1.5H8V0h.034c1.957.008 3.75.72 5.135 1.894L12.2 3.04A6.47 6.47 0 0 0 8.03 1.5m-2.278.4a6.52 6.52 0 0 0-3.395 2.875l-1.302-.746A8.02 8.02 0 0 1 5.23.493zM14.5 8a6.47 6.47 0 0 0-.856-3.227l1.301-.745A7.97 7.97 0 0 1 16 8q0 .727-.126 1.42l-1.476-.264A6.6 6.6 0 0 0 14.5 8M1.593 6.895A6.6 6.6 0 0 0 1.5 8c0 1.194.321 2.31.882 3.27l-1.296.757A7.97 7.97 0 0 1 0 8q.001-.694.115-1.358zm8.605 7.224a6.52 6.52 0 0 0 3.419-2.845l1.295.757a8.02 8.02 0 0 1-4.208 3.5zm-6.344-1.113A6.47 6.47 0 0 0 8 14.5V16a7.97 7.97 0 0 1-5.104-1.84z" clip-rule="evenodd"/>`
    }, props));
$918b8b64efc9a190$var$TaskToDoIcon.displayName = 'TaskToDoIcon';
var $918b8b64efc9a190$var$_default = module.exports.default = $918b8b64efc9a190$var$TaskToDoIcon;

});

parcelRegister("bmSXq", function(module, exports) {

$parcel$export(module.exports, "default", () => $2146cc344dbb357b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $92Z2l = parcelRequire("92Z2l");
var $ctz0s = parcelRequire("ctz0s");

var $414Wj = parcelRequire("414Wj");
var $dS3PR = parcelRequire("dS3PR");
const $2146cc344dbb357b$var$HealthcheckSuggestedAction = (props)=>{
    const actions = props.link ? [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctz0s.default), {
            key: "action",
            href: props.link.link
        }, props.link.name)
    ] : [];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        title: "Step Failed",
        appearance: "error",
        actions: actions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $414Wj.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), null, props.error), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), null, props.action))));
};
var $2146cc344dbb357b$export$2e2bcd8739ae039 = $2146cc344dbb357b$var$HealthcheckSuggestedAction;

});
parcelRegister("92Z2l", function(module, exports) {

$parcel$export(module.exports, "default", () => $a97355a0cc6aeb06$export$2e2bcd8739ae039);
/* section-message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
var $414Wj = parcelRequire("414Wj");

var $3HeRx = parcelRequire("3HeRx");
const $a97355a0cc6aeb06$var$sectionMessageStyles = {
    container: "_2rkoglpi _1nmz1hna",
    bleed: "_1mou1i6y _1e0c1txw",
    content: "_11c82smr _syaz1fxt",
    actionsContainer: "_11c82smr"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $a97355a0cc6aeb06$var$SectionMessage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, testId: testId }, ref) {
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $3HeRx.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment ? actions.props.children : actions;
    const actionsArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(actionElements);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "section",
        backgroundColor: $a97355a0cc6aeb06$var$appearanceMap[appearance],
        padding: "space.200",
        testId: testId,
        ref: ref,
        xcss: $a97355a0cc6aeb06$var$sectionMessageStyles.container,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
            space: "space.200",
            alignBlock: "stretch",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    xcss: $a97355a0cc6aeb06$var$sectionMessageStyles.bleed,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                        size: "medium",
                        primaryColor: primaryColor,
                        secondaryColor: secondaryColor,
                        // props for new icon
                        LEGACY_size: "medium",
                        color: primaryColor,
                        spacing: "spacious"
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
                    space: "space.100",
                    testId: testId && `${testId}--content`,
                    children: [
                        !!title && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                            as: "h2",
                            size: "small",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            xcss: $a97355a0cc6aeb06$var$sectionMessageStyles.content,
                            children: children
                        }),
                        actionsArray.length > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                            shouldWrap: true,
                            testId: testId && `${testId}--actions`,
                            separator: "\xb7",
                            space: "space.100",
                            rowSpace: "space.0",
                            // Only use a list role if more than one action is present
                            role: actionsArray.length > 1 ? 'list' : undefined,
                            xcss: (0, $VSDnB.fg)('platform_ads_explicit_font_styles') && $a97355a0cc6aeb06$var$sectionMessageStyles.actionsContainer,
                            children: actionsArray.map((action, id)=>// Only use a listitem role if more than one action is present
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                                    role: actionsArray.length > 1 ? 'listitem' : undefined,
                                    children: action
                                }, id))
                        })
                    ]
                })
            ]
        })
    });
});
const $a97355a0cc6aeb06$var$appearanceMap = {
    information: 'color.background.information',
    warning: 'color.background.warning',
    error: 'color.background.danger',
    success: 'color.background.success',
    discovery: 'color.background.discovery'
};
$a97355a0cc6aeb06$var$SectionMessage.displayName = 'SectionMessage';
var $a97355a0cc6aeb06$export$2e2bcd8739ae039 = $a97355a0cc6aeb06$var$SectionMessage;

});
parcelRegister("3HeRx", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", () => $d1d7dced94bb00f5$export$e9b82d2e21ac0c1f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dD7Zc = parcelRequire("dD7Zc");

var $1jWct = parcelRequire("1jWct");

var $dg0Fl = parcelRequire("dg0Fl");

var $c2i4s = parcelRequire("c2i4s");

var $bU3PY = parcelRequire("bU3PY");

const $d1d7dced94bb00f5$var$appearanceIconSchema = {
    information: {
        backgroundColor: `var(--ds-background-information, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($1jWct))),
        primaryIconColor: `var(--ds-icon-information, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`
    },
    warning: {
        backgroundColor: `var(--ds-background-warning, ${(0, $829f609a65d26a98$export$8d9596b529bbb9cf)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))),
        primaryIconColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$874739ea9e379ab6)})`
    },
    error: {
        backgroundColor: `var(--ds-background-danger, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))),
        primaryIconColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`
    },
    success: {
        backgroundColor: `var(--ds-background-success, ${(0, $829f609a65d26a98$export$8a6341c32b6a3ee6)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))),
        primaryIconColor: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$6fa04827ac68a4fb)})`
    },
    discovery: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $829f609a65d26a98$export$363e4475840015bb)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dg0Fl))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $829f609a65d26a98$export$147899de772240ec)})`
    }
};
function $d1d7dced94bb00f5$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $d1d7dced94bb00f5$var$appearanceIconSchema[appearance] || $d1d7dced94bb00f5$var$appearanceIconSchema.information;
    const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, $2OMIu.jsx)(appearanceIconStyles.Icon, {
            LEGACY_size: size,
            color: primaryColor,
            spacing: "spacious",
            LEGACY_primaryColor: primaryColor,
            LEGACY_secondaryColor: secondaryColor,
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});
parcelRegister("dg0Fl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b4f7ab8b5658b8ac17876b86421aa64>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9a6d49390b09b82e$var$_react = $9a6d49390b09b82e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9a6d49390b09b82e$var$_questionCircle = $9a6d49390b09b82e$var$_interopRequireDefault((parcelRequire("8nk07")));

var $9a6d49390b09b82e$var$_questionCircle2 = $9a6d49390b09b82e$var$_interopRequireDefault((parcelRequire("eJS47")));
function $9a6d49390b09b82e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for QuestionCircleIcon.
 * This component is QuestionCircleIcon, with `UNSAFE_fallbackIcon` set to "QuestionCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9a6d49390b09b82e$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $9a6d49390b09b82e$var$_react.default.createElement($9a6d49390b09b82e$var$_questionCircle.default, Object.assign({
        LEGACY_fallbackIcon: $9a6d49390b09b82e$var$_questionCircle2.default
    }, props));
$9a6d49390b09b82e$var$QuestionCircleIcon.Name = 'QuestionCircleIconMigration';
var $9a6d49390b09b82e$var$_default = module.exports.default = $9a6d49390b09b82e$var$QuestionCircleIcon;

});
parcelRegister("8nk07", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63dc429f33c9470dc156b62d0ec66db5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $618ffc7dfbf067c7$var$_react = $618ffc7dfbf067c7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $618ffc7dfbf067c7$var$_baseNew = $618ffc7dfbf067c7$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $618ffc7dfbf067c7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $618ffc7dfbf067c7$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $618ffc7dfbf067c7$var$_react.default.createElement($618ffc7dfbf067c7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3c-.586 0-1 .414-1 1H5.5c0-1.414 1.086-2.5 2.5-2.5s2.5 1.086 2.5 2.5c0 1.133-.713 1.706-1.162 2.058-.511.402-.588.494-.588.692v.75h-1.5v-.75c0-.977.689-1.507 1.078-1.806l.084-.065C8.838 6.544 9 6.367 9 6c0-.586-.414-1-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$618ffc7dfbf067c7$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $618ffc7dfbf067c7$var$_default = module.exports.default = $618ffc7dfbf067c7$var$QuestionCircleIcon;

});

parcelRegister("eJS47", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $abaf34f2ab9c61b9$var$_react = $abaf34f2ab9c61b9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $abaf34f2ab9c61b9$var$_questionCircle = $abaf34f2ab9c61b9$var$_interopRequireDefault((parcelRequire("8nk07")));
function $abaf34f2ab9c61b9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $abaf34f2ab9c61b9$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $abaf34f2ab9c61b9$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><circle cx="12" cy="18" r="1" fill="inherit"/><path fill="inherit" d="M15.89 9.05a3.98 3.98 0 0 0-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.99.99 0 0 0 .982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 0 1 4.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 0 0-1 .987v2.014a1.001 1.001 0 0 0 2.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0 0 15.89 9.05"/></g></svg>`
    }, props, {
        newIcon: $abaf34f2ab9c61b9$var$_questionCircle.default
    }));
$abaf34f2ab9c61b9$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $abaf34f2ab9c61b9$var$_default = module.exports.default = $abaf34f2ab9c61b9$var$QuestionCircleIcon;

});


var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';



parcelRegister("ctz0s", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e844da07d79ea04$export$2e2bcd8739ae039);
/* section-message-action.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $5McnS = parcelRequire("5McnS");
var $MHKc7 = parcelRequire("MHKc7");
var $3Lty3 = parcelRequire("3Lty3");
const $2e844da07d79ea04$var$styles = {
    common: "_11c82smr _syaz14q2 _k48p1wq8 _30l314q2 _9h8h16c2",
    anchor: "_1053w7te _9oik18uv _1bnx8stv _jf4cnqa1 _n0fxw7te _1vhvg3x0",
    pressable: "_bfhk1w7a _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik18uv _1bnx8stv _jf4cnqa1"
};
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ const $2e844da07d79ea04$var$SectionMessageAction = /*#__PURE__*/ (0, $5uXOq.memo)(function SectionMessageAction({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent }) {
    if (!linkComponent && (0, $VSDnB.fg)('platform_section_message_action_migration')) {
        if (href) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5McnS.default), {
            testId: testId,
            onClick: onClick,
            href: href,
            xcss: (0, $3JT92.cx)($2e844da07d79ea04$var$styles.common, $2e844da07d79ea04$var$styles.anchor),
            children: children
        });
        if (onClick) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
            testId: testId,
            onClick: onClick,
            xcss: (0, $3JT92.cx)($2e844da07d79ea04$var$styles.common, $2e844da07d79ea04$var$styles.pressable),
            children: children
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            as: "span",
            testId: testId,
            children: children
        });
    }
    return onClick || href ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined,
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
});
var $2e844da07d79ea04$export$2e2bcd8739ae039 = $2e844da07d79ea04$var$SectionMessageAction;

});



parcelRegister("426ZA", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ae4fabdb7582137$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $414Wj = parcelRequire("414Wj");
var $dS3PR = parcelRequire("dS3PR");
const $5ae4fabdb7582137$var$HealthcheckHeader = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $414Wj.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "large"
    }, "Extra Auth Healthcheck"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), null, "Status of Extra Authenticated Application Links for your Jira Cloud site.")));
};
var $5ae4fabdb7582137$export$2e2bcd8739ae039 = $5ae4fabdb7582137$var$HealthcheckHeader;

});




parcelRegister("3A9DP", function(module, exports) {

$parcel$export(module.exports, "applinksExtraAuthHealthcheckRoute", () => $1566be2cb38c0d94$export$c92684a6af97ae19);
const $1566be2cb38c0d94$export$c92684a6af97ae19 = {
    name: 'global-settings-products-applinks-extra-auth',
    path: '/jira/settings/applinks/extra-auth/healthcheck',
    exact: true
};

});

parcelRegister("ibkIl", function(module, exports) {

$parcel$export(module.exports, "globalSettingsLayout", () => $3eb51436f6201a33$export$e6aef6083548e882);

var $2BrOV = parcelRequire("2BrOV");

var $aPfsS = parcelRequire("aPfsS");
const $3eb51436f6201a33$export$e6aef6083548e882 = (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout));

});

parcelRegister("cOg46", function(module, exports) {

$parcel$export(module.exports, "default", () => $18dc7dd640caeb91$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

const $18dc7dd640caeb91$var$LazyGlobalSystemSettingsSidebar = (0, $kxZPA.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("xDFM0")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-system/src/index.tsx"
});
const $18dc7dd640caeb91$var$GlobalSystemSettingsSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "globalSystemSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($18dc7dd640caeb91$var$LazyGlobalSystemSettingsSidebar, null)));
$18dc7dd640caeb91$var$GlobalSystemSettingsSidebar.displayName = 'GlobalSystemSettingsSidebar';
var $18dc7dd640caeb91$export$2e2bcd8739ae039 = $18dc7dd640caeb91$var$GlobalSystemSettingsSidebar;

});
parcelRegister("xDFM0", function(module, exports) {

let $0651db5dcfe52ec8$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0651db5dcfe52ec8$var$load("ffQaD"),
    $0651db5dcfe52ec8$var$load("kvRbA"),
    $0651db5dcfe52ec8$var$load("76n7a"),
    $0651db5dcfe52ec8$var$load("l253H"),
    $0651db5dcfe52ec8$var$load("aYwRc")
]).then(()=>parcelRequire('6Pefo'));

});


parcelRegister("5lsNZ", function(module, exports) {

$parcel$export(module.exports, "LazyNotFoundErrorPage", () => $5ed1828a3f7dd5a7$export$57c5c0b5a0cdb5b7);
$parcel$export(module.exports, "default", () => $5ed1828a3f7dd5a7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $5ed1828a3f7dd5a7$export$57c5c0b5a0cdb5b7 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("khFxT")), {
    moduleId: "./src/packages/spa-apps/error-pages/not-found/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5ed1828a3f7dd5a7$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $5ed1828a3f7dd5a7$export$57c5c0b5a0cdb5b7,
        pageId: "errors-404",
        shouldShowSpinner: false
    });

});
parcelRegister("khFxT", function(module, exports) {

let $ec459f427279e3d5$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ec459f427279e3d5$var$load("7mIf9"),
    $ec459f427279e3d5$var$load("jXweD"),
    $ec459f427279e3d5$var$load("jbxE1"),
    $ec459f427279e3d5$var$load("7imUH"),
    $ec459f427279e3d5$var$load("ffQaD"),
    $ec459f427279e3d5$var$load("kvRbA"),
    $ec459f427279e3d5$var$load("kVX56"),
    $ec459f427279e3d5$var$load("76n7a"),
    $ec459f427279e3d5$var$load("l253H"),
    $ec459f427279e3d5$var$load("kNFvF"),
    $ec459f427279e3d5$var$load("lCGtA")
]).then(()=>parcelRequire('6iSaB'));

});



parcelRegister("lLZ8x", function(module, exports) {

$parcel$export(module.exports, "appRequestsRouteEntry", () => $3506fc2f26a58302$export$423a1c80bb2f8b9a);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $iHiHz = parcelRequire("iHiHz");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $dCM35 = parcelRequire("dCM35");

var $10giJ = parcelRequire("10giJ");
const $3506fc2f26a58302$export$423a1c80bb2f8b9a = (0, $7NszV.createEntry)((0, $dCM35.appRequestsRoute), ()=>({
        group: 'marketplace',
        component: (0, $10giJ.MarketplaceComponent),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).ADDONS,
            sidebar: (0, $iHiHz.default)
        },
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $5bkvv.getNavigationSidebarGlobalSettingsResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $10giJ.LazyMarketplace)
        ],
        ufoName: 'embedded-marketplace'
    }));

});
parcelRegister("iHiHz", function(module, exports) {

$parcel$export(module.exports, "default", () => $883820dc444dc59c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

const $883820dc444dc59c$var$LazyGlobalAppsSettingsSidebar = (0, $kxZPA.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("75p2g")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-apps/src/index.tsx"
});
const $883820dc444dc59c$var$GlobalAppsSettingsSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "globalAppsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($883820dc444dc59c$var$LazyGlobalAppsSettingsSidebar, null)));
$883820dc444dc59c$var$GlobalAppsSettingsSidebar.displayName = 'GlobalAppsSettingsSidebar';
var $883820dc444dc59c$export$2e2bcd8739ae039 = $883820dc444dc59c$var$GlobalAppsSettingsSidebar;

});
parcelRegister("75p2g", function(module, exports) {

let $528c6b8bc486fb23$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $528c6b8bc486fb23$var$load("ffQaD"),
    $528c6b8bc486fb23$var$load("kvRbA"),
    $528c6b8bc486fb23$var$load("76n7a"),
    $528c6b8bc486fb23$var$load("l253H"),
    $528c6b8bc486fb23$var$load("k9adH")
]).then(()=>parcelRequire('kO26e'));

});


parcelRegister("dCM35", function(module, exports) {

$parcel$export(module.exports, "appRequestsRoute", () => $03b80971c24766dc$export$df12e2a94e0a971b);
const $03b80971c24766dc$export$df12e2a94e0a971b = {
    name: 'marketplace-app-requests',
    path: '/jira/marketplace/manage/app-requests'
};

});

parcelRegister("10giJ", function(module, exports) {

$parcel$export(module.exports, "LazyMarketplace", () => $32349631214f0add$export$5919da4c9ee4707e);
$parcel$export(module.exports, "MarketplaceComponent", () => $32349631214f0add$export$f0d733b7012e9031);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $32349631214f0add$export$5919da4c9ee4707e = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("9qN0K"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/marketplace/src/index.tsx"
});
const $32349631214f0add$export$f0d733b7012e9031 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $32349631214f0add$export$5919da4c9ee4707e,
        pageId: "marketplace",
        shouldShowSpinner: true
    });

});
parcelRegister("7yO8g", function(module, exports) {

$parcel$export(module.exports, "markAsProductBundleReady", () => $beda9c6123873bbb$export$ff83c57004505abd);

var $2SVPM = parcelRequire("2SVPM");
const $beda9c6123873bbb$export$ff83c57004505abd = (importedBundle)=>{
    if (!false) importedBundle.then(()=>{
        (0, $2SVPM.setProductBundleReadyForInitialRender)();
    });
    return importedBundle;
};

});

parcelRegister("9qN0K", function(module, exports) {

let $6ddc8f528705d8e9$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6ddc8f528705d8e9$var$load("kNFvF"),
    $6ddc8f528705d8e9$var$load("ffQaD"),
    $6ddc8f528705d8e9$var$load("kvRbA"),
    $6ddc8f528705d8e9$var$load("75upj")
]).then(()=>parcelRequire('lA7ML'));

});



parcelRegister("hHcn9", function(module, exports) {

$parcel$export(module.exports, "archivedIssuesRedirectRouteEntry", () => $eb7a8f12766dfa01$export$f7d3667678a21360);

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $bkxko = parcelRequire("bkxko");

var $gDHR4 = parcelRequire("gDHR4");
const $eb7a8f12766dfa01$export$f7d3667678a21360 = (0, $7NszV.createEntry)((0, $bkxko.archivedIssuesRedirectRoute), ()=>({
        group: 'archive-issues',
        layout: (0, $gyYxw.genericProjectLayout),
        entryPoint: ()=>(0, $gDHR4.archivedIssuesPageEntryPoint),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ]
    }));

});
parcelRegister("gyYxw", function(module, exports) {

$parcel$export(module.exports, "genericProjectLayout", () => $177735c975452188$export$85dad8e9886563f6);

var $18N1t = parcelRequire("18N1t");

var $aPfsS = parcelRequire("aPfsS");

var $6Z2mh = parcelRequire("6Z2mh");

var $e7bC3 = parcelRequire("e7bC3");

var $9Y3Lc = parcelRequire("9Y3Lc");
const $177735c975452188$export$85dad8e9886563f6 = (0, $aPfsS.composeLayouts)((0, $e7bC3.classicSoftwareProjectLayout), (0, $18N1t.coreProjectLayout), (0, $6Z2mh.serviceProjectLayout), (0, $e7bC3.softwareProjectLayout), (0, $9Y3Lc.userBoardLayout));

});
parcelRegister("18N1t", function(module, exports) {

$parcel$export(module.exports, "coreProjectLayout", () => $32b20434a17da609$export$3c06ced9943ca671);

var $1Du13 = parcelRequire("1Du13");

var $aPfsS = parcelRequire("aPfsS");
const $32b20434a17da609$export$3c06ced9943ca671 = (0, $aPfsS.composeLayouts)((0, $1Du13.projectLayout));

});

parcelRegister("e7bC3", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareProjectLayout", () => $43d4c7537a1fee65$export$3791efdd32024063);
$parcel$export(module.exports, "softwareProjectLayout", () => $43d4c7537a1fee65$export$9a918616afa3328c);
$parcel$export(module.exports, "softwareProjectLayoutNoOnboarding", () => $43d4c7537a1fee65$export$ada52b1309832862);
$parcel$export(module.exports, "classicSoftwareProjectLayoutNoOnboarding", () => $43d4c7537a1fee65$export$6c1958653c44ba37);
$parcel$export(module.exports, "softwareProjectLayoutCode", () => $43d4c7537a1fee65$export$ab7e607e8441dc61);

var $2vSU6 = parcelRequire("2vSU6");

var $1Du13 = parcelRequire("1Du13");

var $aPfsS = parcelRequire("aPfsS");

var $kxZPA = parcelRequire("kxZPA");

var $cSD7y = parcelRequire("cSD7y");
// TODO Remove this whenever all software project route paths are no longer ambiguous
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $43d4c7537a1fee65$var$withAnySoftwareProjectContext = (Component)=>(0, $aPfsS.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $2vSU6.SOFTWARE_PROJECT)
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $43d4c7537a1fee65$var$OnboardingOld = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("2rCbT")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/onboarding/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $43d4c7537a1fee65$var$OnboardingNew = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("2rCbT")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/onboarding/index.tsx"
});
const $43d4c7537a1fee65$var$Onboarding = (0, $cSD7y.componentWithFG)('onboarding-forpaint-migration-iv-llc', $43d4c7537a1fee65$var$OnboardingNew, $43d4c7537a1fee65$var$OnboardingOld);
$43d4c7537a1fee65$var$Onboarding.displayName = 'Lazy(ui/onboarding/index.tsx)';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $43d4c7537a1fee65$var$OnboardingCode = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("g5ffn")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/onboarding-code/OnboardingCode.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $43d4c7537a1fee65$var$RightSidebarsOld = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("a7AYY")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/right-sidebars/RightSidebars.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $43d4c7537a1fee65$var$RightSidebarsNew = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("a7AYY")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/right-sidebars/RightSidebars.tsx"
});
const $43d4c7537a1fee65$var$RightSidebars = (0, $cSD7y.componentWithFG)('onboarding-forpaint-migration-iv-llc', $43d4c7537a1fee65$var$RightSidebarsNew, $43d4c7537a1fee65$var$RightSidebarsOld);
$43d4c7537a1fee65$var$RightSidebars.displayName = 'Lazy(ui/right-sidebars/RightSidebars.tsx)';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $43d4c7537a1fee65$var$RightSidebarsCode = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("e4vG2")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/right-sidebars-code/RightSidebarsCode.tsx"
});
const $43d4c7537a1fee65$var$SoftWareOnboarding = $43d4c7537a1fee65$var$withAnySoftwareProjectContext($43d4c7537a1fee65$var$Onboarding);
const $43d4c7537a1fee65$var$SoftWareOnboardingCode = $43d4c7537a1fee65$var$withAnySoftwareProjectContext($43d4c7537a1fee65$var$OnboardingCode);
const $43d4c7537a1fee65$var$nonSettingsRightSidebars = [
    $43d4c7537a1fee65$var$withAnySoftwareProjectContext($43d4c7537a1fee65$var$RightSidebars)
];
const $43d4c7537a1fee65$var$nonSettingsRightSidebarsCode = [
    $43d4c7537a1fee65$var$withAnySoftwareProjectContext($43d4c7537a1fee65$var$RightSidebarsCode)
];
const $43d4c7537a1fee65$var$sharedSoftwareProjectLayout = (0, $aPfsS.composeLayouts)((0, $1Du13.projectLayout), {});
const $43d4c7537a1fee65$export$3791efdd32024063 = (0, $aPfsS.composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout, {
    rightSidebars: $43d4c7537a1fee65$var$nonSettingsRightSidebars,
    globalComponents: [
        $43d4c7537a1fee65$var$SoftWareOnboarding
    ]
});
const $43d4c7537a1fee65$export$9a918616afa3328c = (0, $aPfsS.composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout, {
    rightSidebars: $43d4c7537a1fee65$var$nonSettingsRightSidebars,
    globalComponents: [
        $43d4c7537a1fee65$var$SoftWareOnboarding
    ]
});
const $43d4c7537a1fee65$export$ada52b1309832862 = (0, $aPfsS.composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout);
const $43d4c7537a1fee65$export$6c1958653c44ba37 = (0, $aPfsS.composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout);
const $43d4c7537a1fee65$export$ab7e607e8441dc61 = (0, $aPfsS.composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout, {
    rightSidebars: $43d4c7537a1fee65$var$nonSettingsRightSidebarsCode,
    globalComponents: [
        $43d4c7537a1fee65$var$SoftWareOnboardingCode
    ]
});

});
parcelRegister("2rCbT", function(module, exports) {

let $1c7bba4d940649cf$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $1c7bba4d940649cf$var$load("kVX56"),
    $1c7bba4d940649cf$var$load("ffQaD"),
    $1c7bba4d940649cf$var$load("kvRbA"),
    $1c7bba4d940649cf$var$load("76n7a"),
    $1c7bba4d940649cf$var$load("l253H"),
    $1c7bba4d940649cf$var$load("2Op1P")
]).then(()=>parcelRequire('67mQl'));

});

parcelRegister("g5ffn", function(module, exports) {

let $bb58f0b5049ed1b8$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $bb58f0b5049ed1b8$var$load("kVX56"),
    $bb58f0b5049ed1b8$var$load("ffQaD"),
    $bb58f0b5049ed1b8$var$load("kvRbA"),
    $bb58f0b5049ed1b8$var$load("76n7a"),
    $bb58f0b5049ed1b8$var$load("l253H"),
    $bb58f0b5049ed1b8$var$load("jUiL7")
]).then(()=>parcelRequire('g03yq'));

});

parcelRegister("a7AYY", function(module, exports) {

let $75e73ec5cc4c018d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $75e73ec5cc4c018d$var$load("kVX56"),
    $75e73ec5cc4c018d$var$load("ffQaD"),
    $75e73ec5cc4c018d$var$load("kvRbA"),
    $75e73ec5cc4c018d$var$load("76n7a"),
    $75e73ec5cc4c018d$var$load("l253H"),
    $75e73ec5cc4c018d$var$load("6sXEe")
]).then(()=>parcelRequire('jorgl'));

});

parcelRegister("e4vG2", function(module, exports) {

let $a3ea02cd5e6a20fd$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $a3ea02cd5e6a20fd$var$load("kVX56"),
    $a3ea02cd5e6a20fd$var$load("ffQaD"),
    $a3ea02cd5e6a20fd$var$load("kvRbA"),
    $a3ea02cd5e6a20fd$var$load("76n7a"),
    $a3ea02cd5e6a20fd$var$load("l253H"),
    $a3ea02cd5e6a20fd$var$load("3buPh")
]).then(()=>parcelRequire('egnL1'));

});


parcelRegister("9Y3Lc", function(module, exports) {

$parcel$export(module.exports, "userBoardLayout", () => $1760a1663e36faa5$export$7092b4ee86ae0b71);

var $aPfsS = parcelRequire("aPfsS");
const $1760a1663e36faa5$export$7092b4ee86ae0b71 = (0, $aPfsS.createLayout)();

});


parcelRegister("koWFd", function(module, exports) {

$parcel$export(module.exports, "ForPaintSoftwareProjectSidebar", () => $73e9a7a50d60fc40$export$16261c6a2217f29d);
$parcel$export(module.exports, "default", () => $73e9a7a50d60fc40$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

var $lODMY = parcelRequire("lODMY");

const $73e9a7a50d60fc40$var$LazyAfterPaintClassicSoftwareProjectSidebar = (0, $kxZPA.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("igTyT")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/next-gen/src/index.tsx"
});

const $73e9a7a50d60fc40$var$LazyForPaintClassicSoftwareProjectSidebar = (0, $kxZPA.lazyForPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    // eslint-disable-next-line jira/import/webpack-magic-comment-entries
    return (parcelRequire("igTyT")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/next-gen/src/index.tsx"
});
const $73e9a7a50d60fc40$var$AfterPaintSoftwareProjectSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "softwareProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($73e9a7a50d60fc40$var$LazyAfterPaintClassicSoftwareProjectSidebar, null)));
const $73e9a7a50d60fc40$export$16261c6a2217f29d = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "softwareProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($73e9a7a50d60fc40$var$LazyForPaintClassicSoftwareProjectSidebar, null)));
const $73e9a7a50d60fc40$var$SoftwareProjectSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    const isIssueRoute = (0, $lODMY.useIsActiveRoute)('issue');
    return isIssueRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($73e9a7a50d60fc40$export$16261c6a2217f29d, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($73e9a7a50d60fc40$var$AfterPaintSoftwareProjectSidebar, null);
});
$73e9a7a50d60fc40$var$SoftwareProjectSidebar.displayName = 'SoftwareProjectSidebar';
$73e9a7a50d60fc40$export$16261c6a2217f29d.displayName = 'SoftwareProjectSidebar';
var $73e9a7a50d60fc40$export$2e2bcd8739ae039 = $73e9a7a50d60fc40$var$SoftwareProjectSidebar;

});
parcelRegister("igTyT", function(module, exports) {

let $d4d4d206633159a7$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d4d4d206633159a7$var$load("7mIf9"),
    $d4d4d206633159a7$var$load("jXweD"),
    $d4d4d206633159a7$var$load("ffQaD"),
    $d4d4d206633159a7$var$load("kvRbA"),
    $d4d4d206633159a7$var$load("kVX56"),
    $d4d4d206633159a7$var$load("76n7a"),
    $d4d4d206633159a7$var$load("l253H"),
    $d4d4d206633159a7$var$load("kqP6y")
]).then(()=>parcelRequire('4WgKv'));

});


parcelRegister("bkxko", function(module, exports) {

$parcel$export(module.exports, "archivedIssuesRedirectRoute", () => $65e0e6d0c8ec9fed$export$1bfee70ca366d995);
const $65e0e6d0c8ec9fed$export$1bfee70ca366d995 = {
    name: 'archived-issues-directory',
    path: '/jira/issues/archive',
    exact: true
};

});

parcelRegister("gDHR4", function(module, exports) {

$parcel$export(module.exports, "archivedIssuesPageEntryPoint", () => $64109391b810c516$export$e2fa7de87c15a81d);
$parcel$export(module.exports, "archivedIssuesWithoutHorizontalNavPageEntryPoint", () => $64109391b810c516$export$c001d316b1f89101);
$parcel$export(module.exports, "getCommonProjectLayout", () => $64109391b810c516$export$3dbe917a4c13b1e);

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $aPfsS = parcelRequire("aPfsS");

var $fo6b8 = parcelRequire("fo6b8");

var $lmyls = parcelRequire("lmyls");

var $1Qr8L = parcelRequire("1Qr8L");
const $64109391b810c516$export$e2fa7de87c15a81d = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1Qr8L.archivedIssuesEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $64109391b810c516$export$c001d316b1f89101 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1Qr8L.archivedIssuesEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $64109391b810c516$export$3dbe917a4c13b1e = ()=>(0, $aPfsS.createLayout)((0, $gyYxw.genericProjectLayout));

});
parcelRegister("fo6b8", function(module, exports) {

$parcel$export(module.exports, "jiraHorizontalNavEntrypoint", () => $a30042c3f693dfff$export$e9ee9fa1097f370e);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $LjVkh = parcelRequire("LjVkh");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $kV9ss = parcelRequire("kV9ss");

var $1nb22 = parcelRequire("1nb22");

var $ktofH = parcelRequire("ktofH");

const $a30042c3f693dfff$export$e9ee9fa1097f370e = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("7GbVW")), {
        moduleId: "99477251",
        moduleName: "HorizontalNavJiraInner",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: { match: match, query: query }, tenantContext: { cloudId: cloudId } })=>{
        const boardId = match.params.boardId;
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        const projectIdOrKey = projectId || projectKey;
        const isTMPBoardRoute = boardId ? match.url.includes('/software/projects/') : false;
        const boardAri = boardId ? `ari:cloud:jira-software:${cloudId}:board/${boardId}` : '';
        const projectAri = projectId ? (0, $kV9ss.JiraProjectAri).create({
            siteId: cloudId,
            projectId: projectId
        }).toString() : '';
        let containerNavigationInput;
        if (isTMPBoardRoute) containerNavigationInput = projectAri ? {
            scopeId: boardAri
        } : {
            projectKeyQuery: {
                cloudId: cloudId,
                projectKey: projectKey
            }
        };
        else containerNavigationInput = boardAri || projectAri ? {
            scopeId: boardAri || projectAri
        } : {
            projectKeyQuery: {
                cloudId: cloudId,
                projectKey: projectKey
            }
        };
        return {
            queries: {
                horizontalNavQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $LjVkh.default,
                    variables: {
                        cloudId: cloudId,
                        projectIdOrKey: projectIdOrKey,
                        withProject: Boolean(projectIdOrKey),
                        boardId: boardAri,
                        withBoard: Boolean(boardAri),
                        containerNavigationInput: containerNavigationInput,
                        isTMPBoardRoute: isTMPBoardRoute,
                        first: (0, $ktofH.NAVIGATION_ITEMS_PAGE_SIZE)
                    }
                }
            }
        };
    }
});

});
parcelRegister("LjVkh", function(module, exports) {

$parcel$export(module.exports, "default", () => $153fec52554cdddf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f0b559e22087fade0c6b58cddec0e0b7>>
 * @relayHash 803bd2411b5ccfb7091d5aac3095a48a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6d9f5406464f687f1985513ff8a0101826fc3041b4f0dee81c75ab40777cf9e2

var $58v9Y = parcelRequire("58v9Y");

var $i536Z = parcelRequire("i536Z");

var $9pmwJ = parcelRequire("9pmwJ");
const $153fec52554cdddf$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "6d9f5406464f687f1985513ff8a0101826fc3041b4f0dee81c75ab40777cf9e2",
        "metadata": {},
        "name": "HorizontalNavJiraInnerQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider": (0, $58v9Y.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider": (0, $9pmwJ.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider": (0, $i536Z.default)
        }
    }
};
var $153fec52554cdddf$export$2e2bcd8739ae039 = $153fec52554cdddf$var$node;

});
parcelRegister("58v9Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a08f169582fc62e$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $2a08f169582fc62e$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jira_custom_templates_ux');
    }
};

});

parcelRegister("i536Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $68f76f028187f307$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");
const $68f76f028187f307$var$JiraTeamButtonTeamCountRelayProvider = {
    get () {
        return !(0, $4R6GH.fg)('team-bi-directional-container-connection-gate') || !(0, $6s1PB.expVal)('team-bi-directional-container-connection', 'isEnabled', false);
    }
};
var $68f76f028187f307$export$2e2bcd8739ae039 = $68f76f028187f307$var$JiraTeamButtonTeamCountRelayProvider;

});

parcelRegister("9pmwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $979d1b4861d86eeb$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");
const $979d1b4861d86eeb$var$JiraTeamButtonRelayProvider = {
    get () {
        return(// eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4R6GH.fg)('team-connection-visibility-in-jira') && (0, $6s1PB.expVal)('team_and_container_m1', 'isEnabled', false));
    }
};
var $979d1b4861d86eeb$export$2e2bcd8739ae039 = $979d1b4861d86eeb$var$JiraTeamButtonRelayProvider;

});


parcelRegister("kV9ss", function(module, exports) {

$parcel$export(module.exports, "JiraProjectAri", () => $f3b077b345ad4318$export$75a0a0a7cb0a58ae);

var $FYyiD = parcelRequire("FYyiD");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/project/manifest.ts
var $f3b077b345ad4318$var$jiraProjectAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $FYyiD.JiraProjectAriResourceOwner),
    resourceType: (0, $FYyiD.JiraProjectAriResourceType),
    resourceIdSlug: "{projectId}",
    resourceIdSegmentFormats: {
        projectId: /[0-9]+/
    }
};
// src/jira/project/index.ts
var $f3b077b345ad4318$export$75a0a0a7cb0a58ae = class _JiraProjectAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._projectId = opts.resourceIdSegmentValues.projectId;
    }
    get siteId() {
        return this._siteId;
    }
    get projectId() {
        return this._projectId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $f3b077b345ad4318$var$jiraProjectAriStaticOpts.qualifier,
            platformQualifier: $f3b077b345ad4318$var$jiraProjectAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $f3b077b345ad4318$var$jiraProjectAriStaticOpts.resourceOwner,
            resourceType: $f3b077b345ad4318$var$jiraProjectAriStaticOpts.resourceType,
            resourceId: `${opts.projectId}`,
            resourceIdSegmentValues: {
                projectId: opts.projectId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $f3b077b345ad4318$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $f3b077b345ad4318$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectId: this.projectId
        };
    }
};

});
parcelRegister("FYyiD", function(module, exports) {

$parcel$export(module.exports, "JiraProjectAriResourceOwner", () => $07e2ccdc15c7364e$export$99d538a3b04916b1);
$parcel$export(module.exports, "JiraProjectAriResourceType", () => $07e2ccdc15c7364e$export$736763838d3aa22e);
// src/jira/project/types.ts
var $07e2ccdc15c7364e$export$99d538a3b04916b1 = "jira", $07e2ccdc15c7364e$export$736763838d3aa22e = "project";

});


parcelRegister("ktofH", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_ITEMS_PAGE_SIZE", () => $e6d4097fc653a273$export$4653cda61a4943d6);
$parcel$export(module.exports, "TAB_UNDERLINE_HEIGHT", () => $e6d4097fc653a273$export$d1b9ea3245b6a5de);
$parcel$export(module.exports, "TAB_HEIGHT", () => $e6d4097fc653a273$export$d07bba395c9390f1);
$parcel$export(module.exports, "TAB_GAP", () => $e6d4097fc653a273$export$b61e6f89a9db76de);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports


const $e6d4097fc653a273$export$4653cda61a4943d6 = 75;
const $e6d4097fc653a273$export$d1b9ea3245b6a5de = 2;
const $e6d4097fc653a273$export$d07bba395c9390f1 = 36;
const $e6d4097fc653a273$export$29911ec08ab2ca2d = 5;
const $e6d4097fc653a273$export$b61e6f89a9db76de = 12;
const $e6d4097fc653a273$export$7fd2e391116c6ef5 = 9;
const $e6d4097fc653a273$export$e1633e494d305bfb = 'MORE';

});

parcelRegister("7GbVW", function(module, exports) {

let $5975b6605b351c33$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $5975b6605b351c33$var$load("kNFvF"),
    $5975b6605b351c33$var$load("ffQaD"),
    $5975b6605b351c33$var$load("kvRbA"),
    $5975b6605b351c33$var$load("kVX56"),
    $5975b6605b351c33$var$load("76n7a"),
    $5975b6605b351c33$var$load("l253H"),
    $5975b6605b351c33$var$load("lON4s")
]).then(()=>parcelRequire('l7ScM'));

});


parcelRegister("1Qr8L", function(module, exports) {

$parcel$export(module.exports, "archivedIssuesEntrypoint", () => $c1768d5987ec2034$export$3f35189530920ce3);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $c1768d5987ec2034$export$3f35189530920ce3 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("6VoTJ")), {
        moduleId: "c61780dd",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("6VoTJ", function(module, exports) {

let $50ab612d0bea8185$var$load = (parcelRequire("28QjX"))(4);

module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $50ab612d0bea8185$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $50ab612d0bea8185$var$load("k6g9p")
        ]);
    }),
    $50ab612d0bea8185$var$load("BEB1L")
]).then(()=>parcelRequire('f45ZV'));

});
parcelRegister("avM1e", function(module, exports) {
"use strict";
module.exports = function(cond, ifTrue, ifFalse) {
    return globalThis.__MCOND && globalThis.__MCOND(cond) ? ifTrue() : ifFalse();
};

});





parcelRegister("vDjHk", function(module, exports) {

$parcel$export(module.exports, "archivedPlansRouteEntry", () => $2934b1049cdc0b54$export$b9921058a8a65710);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $ixtmm = parcelRequire("ixtmm");

var $7kSGc = parcelRequire("7kSGc");
const $2934b1049cdc0b54$export$b9921058a8a65710 = (0, $7NszV.createEntry)((0, $ixtmm.archivedPlansRoute), ()=>({
        group: 'global-settings',
        component: (0, $7kSGc.ArchivedPlansDirectory),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7kSGc.LazyArchivedPlans)
        ]
    }));

});
parcelRegister("2Fj5v", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9ddf603830cf6c5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

const $a9ddf603830cf6c5$var$LazyGlobalProductsSettingsSidebar = (0, $kxZPA.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("1DM5p")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-products/src/index.tsx"
});
const $a9ddf603830cf6c5$var$GlobalProductsSettingsSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "globalProductsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a9ddf603830cf6c5$var$LazyGlobalProductsSettingsSidebar, null)));
$a9ddf603830cf6c5$var$GlobalProductsSettingsSidebar.displayName = 'GlobalProductsSettingsSidebar';
var $a9ddf603830cf6c5$export$2e2bcd8739ae039 = $a9ddf603830cf6c5$var$GlobalProductsSettingsSidebar;

});
parcelRegister("1DM5p", function(module, exports) {

let $131ebbe0f4c244ca$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $131ebbe0f4c244ca$var$load("kVX56"),
    $131ebbe0f4c244ca$var$load("ffQaD"),
    $131ebbe0f4c244ca$var$load("kvRbA"),
    $131ebbe0f4c244ca$var$load("76n7a"),
    $131ebbe0f4c244ca$var$load("l253H"),
    $131ebbe0f4c244ca$var$load("1WuYN")
]).then(()=>parcelRequire('hTSvC'));

});


parcelRegister("ixtmm", function(module, exports) {

$parcel$export(module.exports, "archivedPlansRoute", () => $8d4bd95d29fd1b87$export$29647353386ad146);
const $8d4bd95d29fd1b87$export$29647353386ad146 = {
    name: 'archived-plans-directory',
    path: '/jira/plans/settings/archive',
    exact: true
};

});

parcelRegister("7kSGc", function(module, exports) {

$parcel$export(module.exports, "LazyArchivedPlans", () => $e8a09ac95de555a1$export$cf676f47aba10db8);
$parcel$export(module.exports, "ArchivedPlansDirectory", () => $e8a09ac95de555a1$export$ed59bbc59461c00f);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $e8a09ac95de555a1$export$cf676f47aba10db8 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("jrnuK")).then((module)=>module.ArchivedPlans)), {
    moduleId: "./src/packages/spa-apps/admin-pages/archived-plans/src/index.tsx"
});
const $e8a09ac95de555a1$export$ed59bbc59461c00f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e8a09ac95de555a1$export$cf676f47aba10db8,
        pageId: "archived-plans",
        shouldShowSpinner: true
    });

});
parcelRegister("jrnuK", function(module, exports) {

let $e272c38651aa7997$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e272c38651aa7997$var$load("kLYDM").then(()=>parcelRequire('14EEk'));

});



parcelRegister("9CxHM", function(module, exports) {

$parcel$export(module.exports, "archivedProjectDirectLinkRouteEntry", () => $83811b47cb2e3e0c$export$45e68d450757a753);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $lQihQ = parcelRequire("lQihQ");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $83811b47cb2e3e0c$var$LazyArchivedDirectLink = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("eChrF"))), {
    moduleId: "./src/packages/project-pages/project-archive/project-archived-direct-link/src/index.tsx"
});
const $83811b47cb2e3e0c$var$ArchivedProjectDirectLink = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $83811b47cb2e3e0c$var$LazyArchivedDirectLink,
        pageId: "archived-project-direct-link",
        shouldShowSpinner: false
    });
const $83811b47cb2e3e0c$export$45e68d450757a753 = (0, $7NszV.createEntry)((0, $lQihQ.archivedProjectDirectLinkRoute), ()=>({
        group: 'redirects',
        component: $83811b47cb2e3e0c$var$ArchivedProjectDirectLink,
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $83811b47cb2e3e0c$var$LazyArchivedDirectLink
        ],
        ufoName: 'project-archived'
    }));

});
parcelRegister("lQihQ", function(module, exports) {

$parcel$export(module.exports, "archivedProjectDirectLinkRoute", () => $fcb9d046350a5535$export$cd3fc26cf9f696e6);
const $fcb9d046350a5535$export$cd3fc26cf9f696e6 = {
    name: 'archived-project-direct-link',
    path: '/jira/errors/project-archived',
    exact: true
};

});

parcelRegister("eChrF", function(module, exports) {

let $aa42259292dabe0f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $aa42259292dabe0f$var$load("kjQ1f").then(()=>parcelRequire('hCnfn'));

});


parcelRegister("eaKG5", function(module, exports) {

$parcel$export(module.exports, "archivedProjectsDirectoryRouteEntry", () => $e0db3e001ba4740c$export$dc5f9e3c3931cc36);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $4jMkc = parcelRequire("4jMkc");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $hxN3x = parcelRequire("hxN3x");

var $5I9ar = parcelRequire("5I9ar");
const $e0db3e001ba4740c$export$dc5f9e3c3931cc36 = (0, $7NszV.createEntry)((0, $hxN3x.archivedProjectsDirectoryRoute), ()=>({
        group: 'global-settings',
        component: (0, $5I9ar.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $4jMkc.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5I9ar.LazyArchivedProjectsAdmin)
        ],
        ufoName: 'admin.archived-projects'
    }));

});
parcelRegister("4jMkc", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb7b1354cffbd527$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

const $bb7b1354cffbd527$var$LazyGlobalProjectsSettingsSidebar = (0, $kxZPA.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("d3AdC")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-projects/src/index.tsx"
});
const $bb7b1354cffbd527$var$GlobalProjectsSettingsSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "globalProjectsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bb7b1354cffbd527$var$LazyGlobalProjectsSettingsSidebar, null)));
$bb7b1354cffbd527$var$GlobalProjectsSettingsSidebar.displayName = 'GlobalProjectsSettingsSidebar';
var $bb7b1354cffbd527$export$2e2bcd8739ae039 = $bb7b1354cffbd527$var$GlobalProjectsSettingsSidebar;

});
parcelRegister("d3AdC", function(module, exports) {

let $9817a66fb94471fb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9817a66fb94471fb$var$load("kMEyC").then(()=>parcelRequire('1tunp'));

});


parcelRegister("hxN3x", function(module, exports) {

$parcel$export(module.exports, "archivedProjectsDirectoryRoute", () => $cdb39a82bf3cd9b0$export$b60634d0fa43f719);
const $cdb39a82bf3cd9b0$export$b60634d0fa43f719 = {
    name: 'archived-projects-directory',
    path: '/jira/settings/projects/archive',
    exact: true
};

});

parcelRegister("5I9ar", function(module, exports) {

$parcel$export(module.exports, "LazyArchivedProjectsAdmin", () => $7076addc4fa02bdc$export$b220ffb582ee39aa);
$parcel$export(module.exports, "default", () => $7076addc4fa02bdc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $7076addc4fa02bdc$export$b220ffb582ee39aa = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("jNGTv"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/archived-projects/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7076addc4fa02bdc$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $7076addc4fa02bdc$export$b220ffb582ee39aa,
        pageId: "archived-projects",
        shouldShowSpinner: true
    });

});
parcelRegister("jNGTv", function(module, exports) {

let $e6a3ddd469e432b7$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e6a3ddd469e432b7$var$load("fliVL"),
    $e6a3ddd469e432b7$var$load("hPxUI")
]).then(()=>parcelRequire('jOclj'));

});



parcelRegister("9wv3p", function(module, exports) {

$parcel$export(module.exports, "archivedWorkItemsJsmRouteEntry", () => $0ef8f8fd7220fcba$export$cdfe13bfc51ce940);

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $7547l = parcelRequire("7547l");

var $6Z2mh = parcelRequire("6Z2mh");

var $gDHR4 = parcelRequire("gDHR4");
const $0ef8f8fd7220fcba$export$cdfe13bfc51ce940 = (0, $7NszV.createEntry)((0, $7547l.archivedWorkItemsJsmRoute), ()=>({
        group: 'archived-work-items',
        // Refer: issueNavigatorProjectServicedeskRoute from issue-navigator
        layout: (0, $6Z2mh.serviceProjectLayout),
        entryPoint: ()=>(0, $gDHR4.archivedIssuesWithoutHorizontalNavPageEntryPoint),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("7547l", function(module, exports) {

$parcel$export(module.exports, "archivedWorkItemsJsmRoute", () => $ae80b44a428c958a$export$36e9c9de963d9a4f);
const $ae80b44a428c958a$export$36e9c9de963d9a4f = {
    name: 'servicedesk-archived-work-items',
    path: '/jira/servicedesk/projects/:projectKey/archived-work-items',
    exact: true
};

});


parcelRegister("6DvyY", function(module, exports) {

$parcel$export(module.exports, "archivedWorkItemsJswCompanyRouteEntry", () => $63d198414831365c$export$5555f344b15f5187);

var $5f2bR = parcelRequire("5f2bR");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $4xUlD = parcelRequire("4xUlD");

var $gDHR4 = parcelRequire("gDHR4");
const $63d198414831365c$export$5555f344b15f5187 = (0, $7NszV.createEntry)((0, $4xUlD.archivedWorkItemsJswCompanyRoute), ()=>({
        group: 'archived-work-items',
        // Refer: issueNavigatorProjectClassicRoute from issue-navigator
        layout: (0, $gDHR4.getCommonProjectLayout)(),
        entryPoint: ()=>(0, $gDHR4.archivedIssuesPageEntryPoint),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("5f2bR", function(module, exports) {

$parcel$export(module.exports, "AsyncHorizontalNavJira", () => $8a898ce31719feb2$export$ea83697d960a1a23);

var $5uXOq = parcelRequire("5uXOq");

var $kxZPA = parcelRequire("kxZPA");

var $3HwlS = parcelRequire("3HwlS");

var $7XYc4 = parcelRequire("7XYc4");

var $5NiYd = parcelRequire("5NiYd");

var $l71WK = parcelRequire("l71WK");

var $lfTZh = parcelRequire("lfTZh");

const $8a898ce31719feb2$var$LazyHorizontalNavJira = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("iAMLB")).then((HorizontalNavJira)=>HorizontalNavJira), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jira/src/ui/HorizontalNavJira.tsx"
});
const $8a898ce31719feb2$var$AsyncHorizontalNav = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "horizontal-nav-jira",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5NiYd.HorizontalNavSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8a898ce31719feb2$var$LazyHorizontalNavJira, null));
const $8a898ce31719feb2$export$ea83697d960a1a23 = (0, $7XYc4.componentWithCondition)(()=>(0, $3HwlS.getWillShowNav4)(), $8a898ce31719feb2$var$AsyncHorizontalNav, (0, $l71WK.AsyncHorizontalProjectNav));

});
parcelRegister("5NiYd", function(module, exports) {

$parcel$export(module.exports, "TabsSkeleton", () => $0a3d218ca404c936$export$807fef2beb9debc2);
$parcel$export(module.exports, "HorizontalNavSkeleton", () => $0a3d218ca404c936$export$e29d51df5420bf39);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");
const $0a3d218ca404c936$export$807fef2beb9debc2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: [
            $0a3d218ca404c936$var$tabsWrapperSkeletonStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $0a3d218ca404c936$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $0a3d218ca404c936$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $0a3d218ca404c936$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $0a3d218ca404c936$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $0a3d218ca404c936$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $0a3d218ca404c936$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $0a3d218ca404c936$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $0a3d218ca404c936$var$tabSkeletonStyles
    }));
const $0a3d218ca404c936$export$e29d51df5420bf39 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.050",
        alignBlock: "end",
        xcss: [
            $0a3d218ca404c936$var$horizontalNavWrapperStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $0a3d218ca404c936$var$baseSkeletonStyles,
            $0a3d218ca404c936$var$breadcrumbStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        spread: "space-between",
        xcss: $0a3d218ca404c936$var$headerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $0a3d218ca404c936$var$primaryContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $0a3d218ca404c936$var$baseSkeletonStyles,
            $0a3d218ca404c936$var$squareStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $0a3d218ca404c936$var$baseSkeletonStyles,
            $0a3d218ca404c936$var$projectTitleStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $0a3d218ca404c936$var$baseSkeletonStyles,
            $0a3d218ca404c936$var$squareStyles
        ]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.150",
        xcss: $0a3d218ca404c936$var$actionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $0a3d218ca404c936$var$baseSkeletonStyles,
            $0a3d218ca404c936$var$squareStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $0a3d218ca404c936$var$baseSkeletonStyles,
            $0a3d218ca404c936$var$squareStyles
        ]
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a3d218ca404c936$export$807fef2beb9debc2, null));
const $0a3d218ca404c936$var$tabsWrapperSkeletonStyles = (0, $8CUq3.xcss)({
    gap: 'space.150',
    height: '32px',
    paddingInlineStart: 'space.300',
    paddingInlineEnd: 'space.300',
    paddingBlockEnd: 'space.150',
    marginBlockStart: 'space.100',
    position: 'relative',
    '::after': {
        content: '""',
        position: 'absolute',
        bottom: '0',
        backgroundColor: 'color.skeleton',
        height: '2px',
        left: '0',
        right: '0'
    }
});
const $0a3d218ca404c936$var$tabSkeletonStyles = (0, $8CUq3.xcss)({
    minWidth: "var(--ds-space-1000, 80px)",
    backgroundColor: 'color.skeleton',
    borderRadius: "var(--ds-border-radius, 4px)"
});
const $0a3d218ca404c936$var$horizontalNavWrapperStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.300',
    minBlockSize: '130px'
});
const $0a3d218ca404c936$var$baseSkeletonStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.skeleton',
    borderRadius: 'border.radius'
});
const $0a3d218ca404c936$var$breadcrumbStyles = (0, $8CUq3.xcss)({
    blockSize: "var(--ds-space-300, 24px)",
    inlineSize: '60px',
    marginInlineStart: 'space.300',
    marginBlockEnd: 'space.025'
});
const $0a3d218ca404c936$var$primaryContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    gap: 'space.100',
    marginInlineStart: 'space.300'
});
const $0a3d218ca404c936$var$squareStyles = (0, $8CUq3.xcss)({
    blockSize: "var(--ds-space-300, 24px)",
    inlineSize: "var(--ds-space-300, 24px)"
});
const $0a3d218ca404c936$var$headerWrapperStyles = (0, $8CUq3.xcss)({
    marginBlockStart: 'space.050'
});
const $0a3d218ca404c936$var$projectTitleStyles = (0, $8CUq3.xcss)({
    blockSize: "var(--ds-space-300, 24px)",
    inlineSize: '180px'
});
const $0a3d218ca404c936$var$actionStyles = (0, $8CUq3.xcss)({
    marginInlineEnd: 'space.300'
});

});

parcelRegister("l71WK", function(module, exports) {

$parcel$export(module.exports, "AsyncHorizontalProjectNav", () => $7e6dac351b79a914$export$862dd1c0126bb181);
$parcel$export(module.exports, "AsyncHorizontalOverviewNav", () => $7e6dac351b79a914$export$beabdf5c49f01377);
/* eslint-disable jira/import/webpack-magic-comment-entries */ 
var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $7e6dac351b79a914$var$LazyHorizontalProjectNav = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("lwcdq")), {
    moduleId: "./src/packages/business/navigation/horizontal-nav/src/ui/project-navigation/index.tsx"
});
const $7e6dac351b79a914$export$862dd1c0126bb181 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "horizontal-project-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7e6dac351b79a914$var$LazyHorizontalProjectNav, null));

const $7e6dac351b79a914$var$LazyHorizontalOverviewNav = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("48rOL")), {
    moduleId: "./src/packages/business/navigation/horizontal-nav/src/ui/overview-navigation/index.tsx"
});
const $7e6dac351b79a914$export$beabdf5c49f01377 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "horizontal-overview-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7e6dac351b79a914$var$LazyHorizontalOverviewNav, null));

});
parcelRegister("lwcdq", function(module, exports) {

let $faa60fe746fff96a$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $faa60fe746fff96a$var$load("7mIf9"),
    $faa60fe746fff96a$var$load("jXweD"),
    $faa60fe746fff96a$var$load("kNFvF"),
    $faa60fe746fff96a$var$load("ffQaD"),
    $faa60fe746fff96a$var$load("kvRbA"),
    $faa60fe746fff96a$var$load("kVX56"),
    $faa60fe746fff96a$var$load("76n7a"),
    $faa60fe746fff96a$var$load("l253H"),
    $faa60fe746fff96a$var$load("dfDLo")
]).then(()=>parcelRequire('bwmXM'));

});

parcelRegister("48rOL", function(module, exports) {

let $302d7ccf9255be35$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $302d7ccf9255be35$var$load("kNFvF"),
    $302d7ccf9255be35$var$load("ffQaD"),
    $302d7ccf9255be35$var$load("kvRbA"),
    $302d7ccf9255be35$var$load("kVX56"),
    $302d7ccf9255be35$var$load("76n7a"),
    $302d7ccf9255be35$var$load("l253H"),
    $302d7ccf9255be35$var$load("8Zw7g")
]).then(()=>parcelRequire('bNzBR'));

});


parcelRegister("iAMLB", function(module, exports) {

let $d8916ade9b0cc230$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d8916ade9b0cc230$var$load("kNFvF"),
    $d8916ade9b0cc230$var$load("ffQaD"),
    $d8916ade9b0cc230$var$load("kvRbA"),
    $d8916ade9b0cc230$var$load("kVX56"),
    $d8916ade9b0cc230$var$load("76n7a"),
    $d8916ade9b0cc230$var$load("l253H"),
    $d8916ade9b0cc230$var$load("cvEmx")
]).then(()=>parcelRequire('5zGmz'));

});


parcelRegister("9s3j1", function(module, exports) {

$parcel$export(module.exports, "ForPaintClassicSoftwareProjectSidebar", () => $ed71aad279526f75$export$a70fda37b3fc5365);
$parcel$export(module.exports, "default", () => $ed71aad279526f75$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

var $lODMY = parcelRequire("lODMY");

const $ed71aad279526f75$var$LazyAfterPaintClassicSoftwareProjectSidebar = (0, $kxZPA.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("l5KqF")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/software-classic/src/index.tsx"
});

const $ed71aad279526f75$var$LazyForPaintClassicSoftwareProjectSidebar = (0, $kxZPA.lazyForPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    // eslint-disable-next-line jira/import/webpack-magic-comment-entries
    return (parcelRequire("l5KqF")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/software-classic/src/index.tsx"
});
const $ed71aad279526f75$var$AfterPaintClassicSoftwareProjectSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "classicSoftwareProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed71aad279526f75$var$LazyAfterPaintClassicSoftwareProjectSidebar, null)));
const $ed71aad279526f75$export$a70fda37b3fc5365 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "classicSoftwareProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed71aad279526f75$var$LazyForPaintClassicSoftwareProjectSidebar, null)));
const $ed71aad279526f75$var$ClassicSoftwareProjectSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    const isIssueRoute = (0, $lODMY.useIsActiveRoute)('issue');
    return isIssueRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed71aad279526f75$export$a70fda37b3fc5365, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed71aad279526f75$var$AfterPaintClassicSoftwareProjectSidebar, null);
});
$ed71aad279526f75$var$ClassicSoftwareProjectSidebar.displayName = 'ClassicSoftwareProjectSidebar';
$ed71aad279526f75$export$a70fda37b3fc5365.displayName = 'ClassicSoftwareProjectSidebar';
var $ed71aad279526f75$export$2e2bcd8739ae039 = $ed71aad279526f75$var$ClassicSoftwareProjectSidebar;

});
parcelRegister("l5KqF", function(module, exports) {

let $f5ae147b8b5d91cd$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f5ae147b8b5d91cd$var$load("7mIf9"),
    $f5ae147b8b5d91cd$var$load("jXweD"),
    $f5ae147b8b5d91cd$var$load("kNFvF"),
    $f5ae147b8b5d91cd$var$load("ffQaD"),
    $f5ae147b8b5d91cd$var$load("kvRbA"),
    $f5ae147b8b5d91cd$var$load("kVX56"),
    $f5ae147b8b5d91cd$var$load("76n7a"),
    $f5ae147b8b5d91cd$var$load("l253H"),
    $f5ae147b8b5d91cd$var$load("7sOCh")
]).then(()=>parcelRequire('dydBa'));

});


parcelRegister("4xUlD", function(module, exports) {

$parcel$export(module.exports, "archivedWorkItemsJswCompanyRoute", () => $de918103ba1f7179$export$d370de0c0b8dc61b);
const $de918103ba1f7179$export$d370de0c0b8dc61b = {
    name: 'software-archived-work-items-classic',
    path: '/jira/software/c/projects/:projectKey/archived-work-items',
    exact: true
};

});


parcelRegister("lGElM", function(module, exports) {

$parcel$export(module.exports, "archivedWorkItemsJswRouteEntry", () => $3663668a4efe06cf$export$2686cd22a3691dbf);

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $iyeDq = parcelRequire("iyeDq");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $gDHR4 = parcelRequire("gDHR4");
const $3663668a4efe06cf$export$2686cd22a3691dbf = (0, $7NszV.createEntry)((0, $iyeDq.archivedWorkItemsJswRoute), ()=>({
        group: 'archived-work-items',
        // Refer: issueNavigatorProjectSoftwareRoute from issue-navigator
        layout: (0, $aPfsS.createLayout)((0, $e7bC3.softwareProjectLayoutNoOnboarding)),
        entryPoint: ()=>(0, $gDHR4.archivedIssuesPageEntryPoint),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("iyeDq", function(module, exports) {

$parcel$export(module.exports, "archivedWorkItemsJswRoute", () => $55b26223cd3592ce$export$356fe8859732c01b);
const $55b26223cd3592ce$export$356fe8859732c01b = {
    name: 'software-archived-work-items',
    path: '/jira/software/projects/:projectKey/archived-work-items',
    exact: true
};

});


parcelRegister("3bc6l", function(module, exports) {

$parcel$export(module.exports, "archivedWorkItemsJwmRouteEntry", () => $139836b65d693ac3$export$a243ee53747084d5);

var $5f2bR = parcelRequire("5f2bR");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $7nQyj = parcelRequire("7nQyj");

var $gDHR4 = parcelRequire("gDHR4");
const $139836b65d693ac3$export$a243ee53747084d5 = (0, $7NszV.createEntry)((0, $7nQyj.archivedWorkItemsJwmRoute), ()=>({
        group: 'archived-work-items',
        // Refer: issueNavigatorProjectBusinessRoute from issue-navigator
        layout: (0, $gDHR4.getCommonProjectLayout)(),
        entryPoint: ()=>(0, $gDHR4.archivedIssuesPageEntryPoint),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $lNicp.getBusinessProjectResources)()
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("dmKXV", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac63d95d52d9688b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

const $ac63d95d52d9688b$var$LazyCoreProjectSidebar = (0, $kxZPA.lazyForPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("7xnFc")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/business/navigation/sidebar/src/ui/index.tsx"
});
// delete when cleaning up getWillShowNav4
const $ac63d95d52d9688b$var$CoreProjectSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "coreProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ac63d95d52d9688b$var$LazyCoreProjectSidebar, null));
var $ac63d95d52d9688b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($ac63d95d52d9688b$var$CoreProjectSidebar);

});
parcelRegister("7xnFc", function(module, exports) {

let $016a8c446237b6c4$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $016a8c446237b6c4$var$load("ffQaD"),
    $016a8c446237b6c4$var$load("kvRbA"),
    $016a8c446237b6c4$var$load("kVX56"),
    $016a8c446237b6c4$var$load("76n7a"),
    $016a8c446237b6c4$var$load("l253H"),
    $016a8c446237b6c4$var$load("1CxlJ")
]).then(()=>parcelRequire('8rIQt'));

});


parcelRegister("lNicp", function(module, exports) {

$parcel$export(module.exports, "getBusinessProjectResources", () => $492115de1a4c9f28$export$20e8c2951e444b08);
$parcel$export(module.exports, "getProjectViewResources", () => $492115de1a4c9f28$export$fcbe882e18ee4a35);
$parcel$export(module.exports, "getOverviewViewResources", () => $492115de1a4c9f28$export$21c5527b459d56fe);

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $g4ZHz = parcelRequire("g4ZHz");

var $3HwlS = parcelRequire("3HwlS");

var $1E3vT = parcelRequire("1E3vT");

var $iNzEe = parcelRequire("iNzEe");

var $jrO9m = parcelRequire("jrO9m");

var $l2N2a = parcelRequire("l2N2a");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $cSUZZ = parcelRequire("cSUZZ");

var $aFVvc = parcelRequire("aFVvc");

var $9V5k0 = parcelRequire("9V5k0");
const $492115de1a4c9f28$export$20e8c2951e444b08 = ()=>(0, $3HwlS.getWillShowNav4)() ? [
        // eslint-disable-next-line camelcase
        (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource),
        (0, $9V5k0.projectThemeResource)
    ] : [
        (0, $aFVvc.projectCreatePermissionsResource),
        (0, $iNzEe.navigationResource),
        // eslint-disable-next-line camelcase
        (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource),
        (0, $1E3vT.businessHorizontalNav3Resource),
        (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
        (0, $9V5k0.projectThemeResource)
    ];
const $492115de1a4c9f28$export$fcbe882e18ee4a35 = ()=>[
        ...$492115de1a4c9f28$export$20e8c2951e444b08(),
        ...(0, $3RJkv.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $dxCvy.projectContextResource),
        (0, $5bkvv.forgeProjectModuleResource),
        (0, $iEUaw.staticSidebarShortcutsResource),
        (0, $ggg5j.staticProjectSidebarNavigationResource),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        (0, $g4ZHz.fieldsResource)
    ];
const $492115de1a4c9f28$export$46471673e66df5c1 = ()=>[
        (0, $aFVvc.projectCreatePermissionsResource),
        (0, $iNzEe.navigationResource),
        (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
        (0, $jrO9m.overviewDetailsResource),
        (0, $9V5k0.projectThemeResource)
    ];
const $492115de1a4c9f28$export$21c5527b459d56fe = ()=>[
        ...$492115de1a4c9f28$export$46471673e66df5c1(),
        ...(0, $3RJkv.getNavigationResources)(),
        (0, $g4ZHz.fieldsResource)
    ];

});
parcelRegister("g4ZHz", function(module, exports) {

$parcel$export(module.exports, "fieldsResource", () => $410efef54f79d33f$export$8bca6c1954ae9308);
$parcel$export(module.exports, "useFieldsResource", () => $410efef54f79d33f$export$c0cd85886917fe89);

var $7S1v3 = parcelRequire("7S1v3");

var $jlq4V = parcelRequire("jlq4V");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


var $ljySl = parcelRequire("ljySl");

var $kig09 = parcelRequire("kig09");
const $410efef54f79d33f$var$RESOURCE_TYPE_KEY = 'BUSINESS_FIELDS';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $410efef54f79d33f$var$handleProjectResponse = async (promise)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const response = await promise;
    if (response.data?.jira?.jqlBuilder?.fields?.edges == null) throw new (0, $jlq4V.GraphQLErrors)(response.errors);
    return (0, $kig09.transformData)(response.data?.jira?.jqlBuilder?.fields?.edges);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $410efef54f79d33f$var$handleOverviewResponse = async (promise)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const response = await promise;
    if (response.data?.jira?.jwmOverview?.fields?.edges == null) throw new (0, $jlq4V.GraphQLErrors)(response.errors);
    return (0, $kig09.transformData)(response.data?.jira?.jwmOverview?.fields?.edges);
};
const $410efef54f79d33f$export$8bca6c1954ae9308 = (0, $2M1hQ.createResource)({
    type: $410efef54f79d33f$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        if (matchedRoute.match.params.overviewId) return `${$410efef54f79d33f$var$RESOURCE_TYPE_KEY}_overview_${matchedRoute.match.params.overviewId}`;
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        const projectIdOrKey = projectKey || projectId;
        return `${$410efef54f79d33f$var$RESOURCE_TYPE_KEY}_project_${projectIdOrKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        if (match.params.overviewId) return (0, $ljySl.fetchFields)((0, $8441414a9e015afb$export$c378ca4a0e2c9fec), $410efef54f79d33f$var$handleOverviewResponse, {
            overviewAri: (0, $7S1v3.JiraProjectOverviewAri).create({
                siteId: cloudId,
                activationId: activationId,
                overviewId: match.params.overviewId
            }).toString()
        });
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        const projectIdOrKey = projectKey || projectId;
        return (0, $ljySl.fetchFields)((0, $8441414a9e015afb$export$4d41378da3f70f0f), $410efef54f79d33f$var$handleProjectResponse, {
            cloudId: cloudId,
            jqlContext: `project = '${projectIdOrKey}'`
        });
    },
    maxAge: 3600000
});
const $410efef54f79d33f$export$c0cd85886917fe89 = ()=>(0, $2YP9W.useResource)($410efef54f79d33f$export$8bca6c1954ae9308);

});
parcelRegister("7S1v3", function(module, exports) {

$parcel$export(module.exports, "JiraProjectOverviewAri", () => $5baebd5f34579c96$export$714879003922a622);

var $gPEvR = parcelRequire("gPEvR");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/project-overview/manifest.ts
var $5baebd5f34579c96$var$jiraProjectOverviewAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $gPEvR.JiraProjectOverviewAriResourceOwner),
    resourceType: (0, $gPEvR.JiraProjectOverviewAriResourceType),
    resourceIdSlug: "activation/{activationId}/{overviewId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        overviewId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/jira/project-overview/index.ts
var $5baebd5f34579c96$export$714879003922a622 = class _JiraProjectOverviewAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._overviewId = opts.resourceIdSegmentValues.overviewId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get overviewId() {
        return this._overviewId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $5baebd5f34579c96$var$jiraProjectOverviewAriStaticOpts.qualifier,
            platformQualifier: $5baebd5f34579c96$var$jiraProjectOverviewAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $5baebd5f34579c96$var$jiraProjectOverviewAriStaticOpts.resourceOwner,
            resourceType: $5baebd5f34579c96$var$jiraProjectOverviewAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.overviewId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                overviewId: opts.overviewId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $5baebd5f34579c96$var$jiraProjectOverviewAriStaticOpts);
        return new _JiraProjectOverviewAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $5baebd5f34579c96$var$jiraProjectOverviewAriStaticOpts);
        return new _JiraProjectOverviewAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            overviewId: this.overviewId
        };
    }
};

});
parcelRegister("gPEvR", function(module, exports) {

$parcel$export(module.exports, "JiraProjectOverviewAriResourceOwner", () => $c410d5ca87dd2023$export$d68ef32d028cea3e);
$parcel$export(module.exports, "JiraProjectOverviewAriResourceType", () => $c410d5ca87dd2023$export$491d1b3b0151dbc4);
// src/jira/project-overview/types.ts
var $c410d5ca87dd2023$export$d68ef32d028cea3e = "jira", $c410d5ca87dd2023$export$491d1b3b0151dbc4 = "project-overview";

});


parcelRegister("jlq4V", function(module, exports) {

$parcel$export(module.exports, "GraphQLErrors", () => $503bc83696833cc0$export$89c202e66b2de2b6);

var $7hpBk = parcelRequire("7hpBk");

var $8LQ84 = parcelRequire("8LQ84");
// Sets the error message on this error according to the
// the GraphQL errors that are present.
const $503bc83696833cc0$var$generateErrorMessage = (err)=>{
    let message = '';
    // If we have GraphQL errors present, add that to the error message.
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8LQ84)))(err.graphQLErrors) && err.graphQLErrors.length > 0) err.graphQLErrors.forEach((graphQLError)=>{
        const errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += `${errorMessage}\n`;
    });
    // strip newline from the end of the message
    message = message.replace(/\n$/, '');
    return message;
};
class $503bc83696833cc0$export$89c202e66b2de2b6 extends Error {
    constructor(graphQLErrors){
        super();
        this.graphQLErrors = graphQLErrors != null ? (0, (/*@__PURE__*/$parcel$interopDefault($7hpBk)))(graphQLErrors) : [];
        this.message = $503bc83696833cc0$var$generateErrorMessage(this);
        this.cause = this.graphQLErrors?.[0];
        this.statusCode = this.cause?.extensions?.statusCode ?? this.cause?.extensions?.[0]?.statusCode ?? -1;
        this.errorType = this.cause?.extensions?.errorType ?? this.cause?.extensions?.[0]?.errorType ?? null;
    }
}

});
parcelRegister("7hpBk", function(module, exports) {

var $8LQ84 = parcelRequire("8LQ84");
/**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */ function $54cdfac2bc83c2a9$var$castArray() {
    if (!arguments.length) return [];
    var value = arguments[0];
    return $8LQ84(value) ? value : [
        value
    ];
}
module.exports = $54cdfac2bc83c2a9$var$castArray;

});


const $8441414a9e015afb$export$4d41378da3f70f0f = `
query JWMProjectFields($cloudId: ID!, $jqlContext: String!, $first: Int) {
  jira {
    jqlBuilder(cloudId: $cloudId) {
      fields (jqlContext: $jqlContext, forClause: WHERE, viewContext: JWM, first: $first) {
        ... on JiraJqlFieldConnection {
          edges {
            node {
              jqlTerm
              type
              displayName,
            }
          }
        }
      }
    }
  }
}`;
const $8441414a9e015afb$export$c378ca4a0e2c9fec = `
query JWMOverviewFields($overviewAri: ID!, $first: Int) {
  jira {
    jwmOverview(id: $overviewAri) {
      ... on JiraWorkManagementGiraOverview {
        fields (first: $first) {
          ... on JiraJqlFieldConnection {
            edges {
              node {
                jqlTerm
                type
                displayName,
              }
            }
          }
        }
      }
    }
  }
}`;

parcelRegister("ljySl", function(module, exports) {

$parcel$export(module.exports, "fetchFields", () => $90e7c5e5920e8507$export$f3ddd735c360919);

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $90e7c5e5920e8507$var$PAGE_SIZE = 100;
const $90e7c5e5920e8507$export$f3ddd735c360919 = async (query, handler, params)=>{
    try {
        const promise = (0, $eusud.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: {
                    first: $90e7c5e5920e8507$var$PAGE_SIZE,
                    ...params
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'JiraJqlBuilder'
            }
        });
        return await handler(promise);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessFields', 'Something went wrong while fetching fields');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $jcw0u.default)({
            meta: {
                id: 'fieldsResource',
                packageName: 'jiraRouterResourcesBusinessFields',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};

});

parcelRegister("kig09", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $3d209f684c72dca4$export$3ceb62baab058c6b);
const $3d209f684c72dca4$export$3ceb62baab058c6b = (data)=>data.map((edge)=>edge.node);

});


parcelRegister("1E3vT", function(module, exports) {

$parcel$export(module.exports, "businessHorizontalNav3Resource", () => $4f364072ed560b43$export$b3359003584ee2b0);

var $kV9ss = parcelRequire("kV9ss");

var $2YZCu = parcelRequire("2YZCu");

var $4R6GH = parcelRequire("4R6GH");

var $6YG83 = parcelRequire("6YG83");

var $ktofH = parcelRequire("ktofH");

var $ao2h1 = parcelRequire("ao2h1");

var $6SGt4 = parcelRequire("6SGt4");

var $1nb22 = parcelRequire("1nb22");
const $4f364072ed560b43$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_HORIZONTAL_NAVIGATION';
const $4f364072ed560b43$var$getProjectAri = (projectId, cloudId)=>{
    try {
        return projectId ? (0, $kV9ss.JiraProjectAri).create({
            siteId: cloudId,
            projectId: projectId
        }).toString() : '';
    } catch (err) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jiraRouterResourcesNavigationItems', 'Failed to get project ari');
        return '';
    }
};
const $4f364072ed560b43$export$b3359003584ee2b0 = (0, $6YG83.withGiraAggAnonSsrFix)((0, $ao2h1.createRelayResource)({
    type: $4f364072ed560b43$var$RESOURCE_TYPE_KEY,
    getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        const { cloudId: cloudId } = tenantContext;
        const projectIdOrKey = projectKey || projectId;
        const scopeId = $4f364072ed560b43$var$getProjectAri(projectId, cloudId);
        return {
            parameters: (0, $6SGt4.default),
            variables: {
                cloudId: cloudId,
                projectIdOrKey: projectIdOrKey,
                first: (0, $ktofH.NAVIGATION_ITEMS_PAGE_SIZE),
                isConsolidatedQuery: false,
                containerNavigationInput: scopeId ? {
                    scopeId: scopeId
                } : {
                    projectKeyQuery: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                useContainerNavigation: false,
                useNewProjectHeader: false,
                projectKey: projectKey,
                projectAri: scopeId,
                useProjectKey: Boolean(projectKey),
                isJiraCustomTemplatesUxEnabled: (0, $4R6GH.fg)('jira_custom_templates_ux')
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    }
}));

});
parcelRegister("6YG83", function(module, exports) {

$parcel$export(module.exports, "withGiraAggAnonSsrFix", () => $895edd6ed19f0aa8$export$f4b29e78f4c0a526);
const $895edd6ed19f0aa8$export$f4b29e78f4c0a526 = (resource)=>{
    if (!resource || !resource.getData) return resource;
    const originalGetData = resource.getData;
    // @ts-expect-error types in the relay resource don't allow null, but the react-resource-router types do
    // eslint-disable-next-line no-param-reassign
    resource.getData = (routerContext, customContext)=>{
        if (false && customContext.tenantContext.isAnonymous) return Promise.resolve(null);
        return originalGetData(routerContext, customContext);
    };
    return resource;
};

});

parcelRegister("6SGt4", function(module, exports) {

$parcel$export(module.exports, "default", () => $fed7f561d3a05da6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<820042db950ffe26b91d34ffe7050138>>
 * @relayHash bef16a6db03ecc4506e2c317ed3ec3dc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4c6a8fb0afe8804c6d8b040f3b4ccf6926f7a96b57ad873204c81c3a0ee4ada5
const $fed7f561d3a05da6$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isJiraCustomTemplatesUxEnabled"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectAri"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIdOrKey"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "useProjectKey"
    }, v7 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v8 = [
        v7 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v9 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "large"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v11 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v12 = {
        "kind": "ScalarField",
        "name": "name"
    }, v13 = {
        "alias": "canEditProjectConfig",
        "args": [
            {
                "kind": "Literal",
                "name": "type",
                "value": "EDIT_PROJECT_CONFIG"
            }
        ],
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ],
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v14 = {
        "condition": "isJiraCustomTemplatesUxEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "customTemplateBusinessProjectBanner_businessHorizontalNav"
            }
        ]
    }, v15 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "projectAri"
        }
    ], v16 = [
        v7 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "projectIdOrKey",
            "variableName": "projectIdOrKey"
        }
    ], v17 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v18 = {
        "kind": "ScalarField",
        "name": "id"
    }, v19 = [
        v9 /*: any*/ ,
        v10 /*: any*/ ,
        v11 /*: any*/ ,
        v12 /*: any*/ ,
        v13 /*: any*/ ,
        {
            "condition": "isJiraCustomTemplatesUxEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isLiveTemplate"
                }
            ]
        },
        v18 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "projectNavigation_horizontalNavigationQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "tabs_businessHorizontalNav_TabsContent"
                            },
                            {
                                "condition": "useProjectKey",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "alias": "projectDataByKey",
                                        "args": v8 /*: any*/ ,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProjectByKey",
                                        "plural": false,
                                        "selections": [
                                            v9 /*: any*/ ,
                                            {
                                                "kind": "RequiredField",
                                                "field": v10 /*: any*/ ,
                                                "action": "THROW",
                                                "path": "jira.projectDataByKey.projectId"
                                            },
                                            v11 /*: any*/ ,
                                            v12 /*: any*/ ,
                                            v13 /*: any*/ ,
                                            v14 /*: any*/ 
                                        ]
                                    }
                                ]
                            },
                            {
                                "condition": "useProjectKey",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "alias": "projectDataById",
                                        "args": v15 /*: any*/ ,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProject",
                                        "plural": false,
                                        "selections": [
                                            v9 /*: any*/ ,
                                            {
                                                "kind": "RequiredField",
                                                "field": v10 /*: any*/ ,
                                                "action": "THROW",
                                                "path": "jira.projectDataById.projectId"
                                            },
                                            v11 /*: any*/ ,
                                            v12 /*: any*/ ,
                                            v13 /*: any*/ ,
                                            v14 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ ,
                v6 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "projectNavigation_horizontalNavigationQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "navigationItems",
                            "args": v16 /*: any*/ ,
                            "concreteType": "JiraNavigationItemConnection",
                            "kind": "LinkedField",
                            "name": "jwmSavedViewsByProject",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraNavigationItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isDefault"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "typeKey"
                                                },
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isJiraNavigationItem"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "label"
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canRemove"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canSetAsDefault"
                                                }
                                            ]
                                        },
                                        v17 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "QueryError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "navigationItems",
                            "args": v16 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "projectIdOrKey"
                            ],
                            "handle": "connection",
                            "key": "tabs_jiraNavigation__navigationItems",
                            "kind": "LinkedHandle",
                            "name": "jwmSavedViewsByProject"
                        },
                        {
                            "condition": "useProjectKey",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "projectDataByKey",
                                    "args": v8 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": v19 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "condition": "useProjectKey",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "projectDataById",
                                    "args": v15 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProject",
                                    "plural": false,
                                    "selections": v19 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4c6a8fb0afe8804c6d8b040f3b4ccf6926f7a96b57ad873204c81c3a0ee4ada5",
            "metadata": {},
            "name": "projectNavigation_horizontalNavigationQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$fed7f561d3a05da6$var$node.hash = "73d9509696eb943ac9eaa2deb0444981";
var $fed7f561d3a05da6$export$2e2bcd8739ae039 = $fed7f561d3a05da6$var$node;

});


parcelRegister("iNzEe", function(module, exports) {

$parcel$export(module.exports, "navigationResource", () => $6b942b0827824c4b$export$62940941ee574cdc);
$parcel$export(module.exports, "useNavigationResource", () => $6b942b0827824c4b$export$c17011c09e042a31);

var $gccSB = parcelRequire("gccSB");

var $kV9ss = parcelRequire("kV9ss");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


var $geiy6 = parcelRequire("geiy6");

const $6b942b0827824c4b$export$62940941ee574cdc = (0, $2M1hQ.createResource)({
    type: 'BUSINESS_NAVIGATION',
    getKey: ()=>'BUSINESS_NAVIGATION',
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
        // do not fetch the resource for anonymous access
        if (isAnonymous) return null;
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(projectKey)) return (0, $geiy6.fetchNavigation)((0, $77516b48757f52de$export$a40c5d12b8a53ba2), {
            cloudId: cloudId,
            projectKey: projectKey
        });
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(projectId)) return (0, $geiy6.fetchNavigation)((0, $77516b48757f52de$export$7c9197b656229b53), {
            cloudId: cloudId,
            projectId: (0, $kV9ss.JiraProjectAri).create({
                siteId: cloudId,
                projectId: projectId
            }).toString()
        });
        return (0, $geiy6.fetchNavigation)((0, $77516b48757f52de$export$c378ca4a0e2c9fec), {
            cloudId: cloudId
        });
    },
    maxAge: Infinity
});
const $6b942b0827824c4b$export$c17011c09e042a31 = ()=>(0, $2YP9W.useResource)($6b942b0827824c4b$export$62940941ee574cdc);

});
const $77516b48757f52de$var$ProjectFragment = `
fragment ProjectFragment on JiraProject {
  key
  projectId
  avatar {
    large
  }
  name
  projectStyle
  projectType
  isFavourite
  viewIssues: action(type: VIEW_ISSUES) {
    canPerform
  }
  defaultView: jwmDefaultSavedView {
    ... on JiraNavigationItem {
      typeKey
    }
  }
}
`;
const $77516b48757f52de$var$ProjectConnectionFragment = `
fragment ProjectConnectionFragment on JiraProjectConnection {
  pageInfo {
    hasNextPage
  }
  edges {
    node {
      ...ProjectFragment
    }
  }
}
`;
const $77516b48757f52de$var$OverviewFragment = `
fragment OverviewFragment on JiraWorkManagementGiraOverview {
  id
  name
  theme
}
`;
const $77516b48757f52de$var$OverviewConnectionFragment = `
fragment OverviewConnectionFragment on JiraWorkManagementGiraOverviewConnection {
  pageInfo {
    hasNextPage
  }
  edges {
    node {
      ...OverviewFragment
    }
  }
}
`;
const $77516b48757f52de$var$NavigationDataFragment = `
fragment NavigationFragment on JiraWorkManagementNavigation {
  jwmLicensing {
    currentUserSeatEdition
  }
  recentProjects(first: $first) {
    ...ProjectConnectionFragment
  }
  favoriteProjects(first: $first) {
    ...ProjectConnectionFragment
  }
  overviews: jwmOverviews(cloudId: $cloudId, first: $first) @optIn(to: "JiraWorkManagementGiraOverviews") {
    __typename
    ... on JiraWorkManagementGiraOverviewConnection {
      ...OverviewConnectionFragment
    }
  }
}
`;
const $77516b48757f52de$export$7c9197b656229b53 = `
query JiraBusinessProjectNavigation($cloudId: ID!, $projectId: ID!, $first: Int!) {
  jira {
    navigation: jwmNavigationByProjectId(projectId: $projectId) {
      ...NavigationFragment
    }
  }
}
${$77516b48757f52de$var$ProjectFragment}
${$77516b48757f52de$var$ProjectConnectionFragment}
${$77516b48757f52de$var$NavigationDataFragment}
${$77516b48757f52de$var$OverviewFragment}
${$77516b48757f52de$var$OverviewConnectionFragment}
`;
const $77516b48757f52de$export$a40c5d12b8a53ba2 = `
query JiraBusinessProjectNavigation($cloudId: ID!, $projectKey: String!, $first: Int!) {
  jira {
    navigation: jwmNavigationByProjectKey(cloudId: $cloudId, projectKey: $projectKey) {
      ...NavigationFragment
    }
  }
}
${$77516b48757f52de$var$ProjectFragment}
${$77516b48757f52de$var$ProjectConnectionFragment}
${$77516b48757f52de$var$NavigationDataFragment}
${$77516b48757f52de$var$OverviewFragment}
${$77516b48757f52de$var$OverviewConnectionFragment}
`;
const $77516b48757f52de$export$c378ca4a0e2c9fec = `
query JiraBusinessOverviewNavigation($cloudId: ID!, $first: Int!) {
  jira {
    navigation: jwmNavigation(cloudId: $cloudId) {
      ...NavigationFragment
    }
  }
}
${$77516b48757f52de$var$ProjectFragment}
${$77516b48757f52de$var$ProjectConnectionFragment}
${$77516b48757f52de$var$NavigationDataFragment}
${$77516b48757f52de$var$OverviewFragment}
${$77516b48757f52de$var$OverviewConnectionFragment}
`;

parcelRegister("geiy6", function(module, exports) {

$parcel$export(module.exports, "fetchNavigation", () => $446f8b979bebb841$export$1fc5fff73d9a570c);

var $jlq4V = parcelRequire("jlq4V");

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");


var $ifwpM = parcelRequire("ifwpM");
const $446f8b979bebb841$var$EMPTY_RESPONSE = {
    recents: [],
    favorites: [],
    hasMoreFavorite: false,
    overviews: [],
    overviewsError: null,
    isPremiumUserSeat: false,
    shouldHideOverviews: false
};
const $446f8b979bebb841$export$1fc5fff73d9a570c = async (query, params)=>{
    try {
        const response = await (0, $eusud.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: {
                    first: (0, $4ee2cfa1c76e72ed$export$3349219a88ac77cd),
                    ...params
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'projectStyle'
            }
        });
        // checking only for undefined, as null is a valid value (not applicable)
        if (response.data?.jira?.navigation === undefined) throw new (0, $jlq4V.GraphQLErrors)(response.errors);
        let areOverviewsGone = false;
        if (Array.isArray(response.errors)) // Overviews have been migrated to plans and should no longer be shown to the user
        areOverviewsGone = response.errors.some((error)=>error.extensions?.statusCode === 410);
        return (0, $ifwpM.transformData)(response.data.jira.navigation, areOverviewsGone);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessNavigation', 'Something went wrong while fetching the navigation items');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $jcw0u.default)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRouterResourcesBusinessNavigation',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return $446f8b979bebb841$var$EMPTY_RESPONSE;
};

});
const $4ee2cfa1c76e72ed$export$3349219a88ac77cd = 10;
const $4ee2cfa1c76e72ed$export$e8958a6508ec5b71 = 'NOT_APPLICABLE';

parcelRegister("ifwpM", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $9031e5290b70d3d6$export$3ceb62baab058c6b);

var $6cG4N = parcelRequire("6cG4N");


var $027FQ = parcelRequire("027FQ");
const $9031e5290b70d3d6$var$SIMPLIFIED_PROJECT_STYLE = 'TEAM_MANAGED_PROJECT';
const $9031e5290b70d3d6$var$PREMIUM = 'PREMIUM';
const $9031e5290b70d3d6$var$mapProjectNode = (node)=>({
        key: node.key,
        id: Number(node.projectId),
        avatarUrl: node.avatar?.large ?? '',
        name: node.name,
        type: node.projectType.toLowerCase(),
        isSimplified: node.projectStyle === $9031e5290b70d3d6$var$SIMPLIFIED_PROJECT_STYLE,
        isFavorite: node.isFavourite,
        permissions: {
            viewIssues: node.viewIssues.canPerform
        },
        defaultView: node.defaultView?.typeKey?.toLowerCase()
    });
const $9031e5290b70d3d6$var$mapOverviewNode = (node)=>({
        id: node.id,
        name: node.name,
        theme: node?.theme ?? (0, $6cG4N.DEFAULT_BACKGROUND_CONFIG).name
    });
const $9031e5290b70d3d6$export$3ceb62baab058c6b = (navigation, areOverviewsGone)=>{
    if (navigation == null) // not a JWM context
    return 0, $4ee2cfa1c76e72ed$export$e8958a6508ec5b71;
    let overviews = [];
    let overviewsError = null;
    const isPremiumUserSeat = navigation.jwmLicensing?.currentUserSeatEdition === $9031e5290b70d3d6$var$PREMIUM;
    if (isPremiumUserSeat) {
        if (navigation.overviews?.__typename === (0, $027FQ.OVERVIEWS_SUCCESS_RESPONSE_TYPE)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        overviews = navigation.overviews.edges.map((edge)=>$9031e5290b70d3d6$var$mapOverviewNode(edge.node));
        else overviewsError = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        navigation.overviews ?? new Error('Unknown overviews error');
    }
    let recents = navigation.recentProjects?.edges?.map((edge)=>$9031e5290b70d3d6$var$mapProjectNode(edge.node)) ?? [];
    const favorites = navigation.favoriteProjects?.edges?.map((edge)=>$9031e5290b70d3d6$var$mapProjectNode(edge.node)) ?? [];
    // Remove favorited projects from the recent projects list
    recents = recents.filter((recentProject)=>!favorites.some((favProject)=>favProject.id === recentProject.id));
    return {
        recents: recents,
        favorites: favorites,
        hasMoreFavorite: navigation.favoriteProjects?.pageInfo?.hasNextPage ?? false,
        overviews: overviews,
        overviewsError: overviewsError,
        isPremiumUserSeat: isPremiumUserSeat,
        shouldHideOverviews: areOverviewsGone
    };
};

});
parcelRegister("6cG4N", function(module, exports) {

$parcel$export(module.exports, "STAR_ICON_COLOR", () => $cd302866fea6f361$export$9e0962e0cb41695d);
$parcel$export(module.exports, "Variables", () => $cd302866fea6f361$export$8bb9d79ea938efc9);
$parcel$export(module.exports, "Tokens", () => $cd302866fea6f361$export$8e1e81ac145e31be);
$parcel$export(module.exports, "BASE_THEME", () => $cd302866fea6f361$export$8a6e9b3370a0f87a);
$parcel$export(module.exports, "HIGH_BRIGHTNESS_THEME", () => $cd302866fea6f361$export$f286efa6bd1e8f9d);
$parcel$export(module.exports, "LOW_BRIGHTNESS_THEME", () => $cd302866fea6f361$export$97cb21c6432e07e8);
$parcel$export(module.exports, "GRADIENT_THEME", () => $cd302866fea6f361$export$b124f62a6aab972);
$parcel$export(module.exports, "IMAGE_BACKGROUND_CONFIG", () => $cd302866fea6f361$export$9441e0d8f766c59a);
$parcel$export(module.exports, "NO_BACKGROUND_CONFIG", () => $cd302866fea6f361$export$4c351ec1dc290344);
$parcel$export(module.exports, "ADAPTIVE_IMAGE_BACKGROUND_CONFIG", () => $cd302866fea6f361$export$c8033614bd64480d);
$parcel$export(module.exports, "BACKGROUND_CONFIGS_OLD", () => $cd302866fea6f361$export$34373eced7ee212e);
$parcel$export(module.exports, "FIXED_COLOR_BACKGROUND_CONFIGS", () => $cd302866fea6f361$export$bc16bf654619d060);
$parcel$export(module.exports, "ADAPTIVE_COLOR_BACKGROUND_CONFIGS", () => $cd302866fea6f361$export$4b188262dd47f902);
$parcel$export(module.exports, "GRADIENT_BACKGROUND_CONFIGS", () => $cd302866fea6f361$export$242b2d2213fedf27);
$parcel$export(module.exports, "ADAPTIVE_GRADIENT_BACKGROUND_CONFIGS", () => $cd302866fea6f361$export$8a6c8dd4a86d3f7d);
$parcel$export(module.exports, "OLD_TO_NEW_BACKGROUND_CONFIG_MAP", () => $cd302866fea6f361$export$fe05a238062e2c3d);
$parcel$export(module.exports, "DEFAULT_BACKGROUND_CONFIG", () => $cd302866fea6f361$export$cab9d853866386f2);
$parcel$export(module.exports, "BUSINESS_WRAPPER_PADDING", () => $cd302866fea6f361$export$8e357501548afe78);
$parcel$export(module.exports, "HORIZONTAL_NAV_HEIGHT", () => $cd302866fea6f361$export$baaf8255c30ea280);
$parcel$export(module.exports, "BUSINESS_NAV_HEIGHT", () => $cd302866fea6f361$export$d9035bc768f8226d);
$parcel$export(module.exports, "BUSINESS_WRAPPER_HEIGHT", () => $cd302866fea6f361$export$4810531e30462f89);
$parcel$export(module.exports, "BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT", () => $cd302866fea6f361$export$1c0b806722927549);
$parcel$export(module.exports, "NAV4_HORIZONTAL_NAV_HEIGHT", () => $cd302866fea6f361$export$2af5673c2fa63c55);
$parcel$export(module.exports, "NAV4_BUSINESS_NAV_HEIGHT", () => $cd302866fea6f361$export$5771162cdeebfb85);
$parcel$export(module.exports, "NAV4_BUSINESS_WRAPPER_HEIGHT", () => $cd302866fea6f361$export$a1626d6d785092a2);
$parcel$export(module.exports, "NAV4_BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT", () => $cd302866fea6f361$export$410e3d6221a052e);
$parcel$export(module.exports, "BUSINESS_WRAPPER_WIDTH", () => $cd302866fea6f361$export$77cdace62a821419);
$parcel$export(module.exports, "BUSINESS_WRAPPER_WITH_BACKGROUND_WIDTH", () => $cd302866fea6f361$export$3efe68325dd9dc02);
// This doesn't use @atlassian/jira-navigation-system as it results in a hard-to-debug cycle.
// We need to move away from using these variables directly as it results in a brittle hard to evolve system.
// eslint-disable-next-line jira/restricted/@atlaskit+page-layout



const $cd302866fea6f361$export$9e0962e0cb41695d = '#FFAB00';
const $cd302866fea6f361$export$8bb9d79ea938efc9 = {
    BACKDROP_FILTER: '--project-backdrop-filter',
    // Delete when business projects are migrated to the new theming
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED_CONTRAST: '--project-color-background-neutral-subtle-hovered-contrast',
    COLOR_BACKGROUND_ACCENT_SELECTED: '--project-color-background-accent-selected',
    COLOR_BACKGROUND_BRAND_BOLD: '--project-color-background-brand-bold',
    COLOR_BACKGROUND_BRAND_BOLD_HOVERED: '--project-color-background-brand-bold-hovered',
    COLOR_BACKGROUND_BRAND_BOLD_PRESSED: '--project-color-background-brand-bold-pressed',
    COLOR_BACKGROUND_DISABLED: '--project-color-background-disabled',
    COLOR_BACKGROUND_INPUT: '--project-background-input',
    COLOR_BACKGROUND_NEUTRAL: '--project-background-neutral',
    COLOR_BACKGROUND_NEUTRAL_HOVERED: '--project-background-neutral-hovered',
    COLOR_BACKGROUND_NEUTRAL_PRESSED: '--project-background-neutral-pressed',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED: '--project-background-neutral-subtle-hovered',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED: '--project-background-neutral-subtle-pressed',
    COLOR_BACKGROUND_SELECTED: '--project-background-selected',
    COLOR_BORDER: '--project-color-border',
    COLOR_BORDER_INPUT: '--project-color-border-input',
    COLOR_BORDER_INVERSE: '--project-color-border-inverse',
    COLOR_BORDER_SELECTED: '--project-color-border-selected',
    COLOR_ELEVATION_SURFACE: '--project-color-elevation-surface',
    COLOR_ELEVATION_SURFACE_SUNKEN: '--project-color-elevation-surface-sunken',
    COLOR_ICON_DANGER: '--project-color-icon-danger',
    COLOR_ICON_INFORMATION: '--project-color-icon-information',
    COLOR_ICON_SUCCESS: '--project-color-icon-success',
    COLOR_ICON_WARNING: '--project-color-icon-warning',
    COLOR_LINK: '--project-color-link',
    COLOR_LINK_PRESSED: '--project-color-link-pressed',
    COLOR_SKELETON: '--project-skeleton',
    COLOR_TEXT: '--project-color-text',
    COLOR_TEXT_ACCENT_SELECTED: '--project-text-accent-selected',
    COLOR_TEXT_DISABLED: '--project-color-text-disabled',
    COLOR_TEXT_INVERSE: '--project-color-text-inverse',
    COLOR_TEXT_SELECTED: '--project-color-text-selected',
    COLOR_TEXT_SUBTLE: '--project-color-text-subtle',
    COLOR_TEXT_SUBTLEST: '--project-color-text-subtlest',
    CONTENT_HEIGHT: '--project-content-height',
    CONTENT_WIDTH: '--project-content-width',
    ELEVATION_SURFACE: '--project-elevation-surface',
    ELEVATION_SURFACE_CONTRAST: '--project-elevation-surface-contrast',
    ELEVATION_SURFACE_CONTRAST_BOLDER: '--project-elevation-surface-contrast-bolder',
    ELEVATION_SURFACE_BLEND_MODE: '--project-elevation-surface-blend-mode',
    WRAPPER_BACKGROUND: '--project-wrapper-background',
    WRAPPER_BORDER_RADIUS: '--project-wrapper-border-radius',
    WRAPPER_HEIGHT: '--project-wrapper-height',
    WRAPPER_PADDING: '--project-wrapper-padding',
    WRAPPER_WIDTH: '--project-wrapper-width'
};
const $cd302866fea6f361$export$8e1e81ac145e31be = {
    BACKDROP_FILTER: 'var(--project-backdrop-filter)',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED_CONTRAST: 'var(--project-color-background-neutral-subtle-hovered-contrast)',
    COLOR_BACKGROUND_ACCENT_SELECTED: 'var(--project-color-background-accent-selected)',
    COLOR_BACKGROUND_BRAND_BOLD: 'var(--project-color-background-brand-bold)',
    COLOR_BACKGROUND_BRAND_BOLD_HOVERED: 'var(--project-color-background-brand-bold-hovered)',
    COLOR_BACKGROUND_BRAND_BOLD_PRESSED: 'var(--project-color-background-brand-bold-pressed)',
    COLOR_BACKGROUND_DISABLED: 'var(--project-color-background-disabled)',
    COLOR_BACKGROUND_INPUT: 'var(--project-background-input)',
    COLOR_BACKGROUND_NEUTRAL: 'var(--project-background-neutral)',
    COLOR_BACKGROUND_NEUTRAL_HOVERED: 'var(--project-background-neutral-hovered)',
    COLOR_BACKGROUND_NEUTRAL_PRESSED: 'var(--project-background-neutral-pressed)',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED: 'var(--project-background-neutral-subtle-hovered)',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED: 'var(--project-background-neutral-subtle-pressed)',
    COLOR_BACKGROUND_SELECTED: 'var(--project-background-selected)',
    COLOR_BORDER: 'var(--project-color-border)',
    COLOR_BORDER_INPUT: 'var(--project-color-border-input)',
    COLOR_BORDER_INVERSE: 'var(--project-color-border-inverse)',
    COLOR_BORDER_SELECTED: 'var(--project-color-border-selected)',
    COLOR_ELEVATION_SURFACE: 'var(--project-color-elevation-surface)',
    COLOR_ELEVATION_SURFACE_SUNKEN: 'var(--project-color-elevation-surface-sunken)',
    COLOR_ICON_DANGER: 'var(--project-color-icon-danger)',
    COLOR_ICON_INFORMATION: 'var(--project-color-icon-information)',
    COLOR_ICON_SUCCESS: 'var(--project-color-icon-success)',
    COLOR_ICON_WARNING: 'var(--project-color-icon-warning)',
    COLOR_LINK: 'var(--project-color-link)',
    COLOR_LINK_PRESSED: 'var(--project-color-link-pressed)',
    COLOR_SKELETON: 'var(--project-skeleton)',
    COLOR_TEXT: 'var(--project-color-text)',
    COLOR_TEXT_ACCENT_SELECTED: 'var(--project-text-accent-selected)',
    COLOR_TEXT_DISABLED: 'var(--project-color-text-disabled)',
    COLOR_TEXT_INVERSE: 'var(--project-color-text-inverse)',
    COLOR_TEXT_SELECTED: 'var(--project-color-text-selected)',
    COLOR_TEXT_SUBTLE: 'var(--project-color-text-subtle)',
    COLOR_TEXT_SUBTLEST: 'var(--project-color-text-subtlest)',
    CONTENT_HEIGHT: 'var(--project-content-height)',
    CONTENT_WIDTH: 'var(--project-content-width)',
    ELEVATION_SURFACE: 'var(--project-elevation-surface)',
    ELEVATION_SURFACE_CONTRAST: 'var(--project-elevation-surface-contrast)',
    ELEVATION_SURFACE_CONTRAST_BOLDER: 'var(--project-elevation-surface-contrast-bolder)',
    ELEVATION_SURFACE_BLEND_MODE: 'var(--project-elevation-surface-blend-mode)',
    WRAPPER_BACKGROUND: 'var(--project-wrapper-background)',
    WRAPPER_BORDER_RADIUS: 'var(--project-wrapper-border-radius)',
    WRAPPER_HEIGHT: 'var(--project-wrapper-height)',
    WRAPPER_PADDING: 'var(--project-wrapper-padding)',
    WRAPPER_WIDTH: 'var(--project-wrapper-width)'
};
const $cd302866fea6f361$export$8a6e9b3370a0f87a = {
    'color.background.neutral.subtle.hovered.contrast': "var(--ds-background-neutral-subtle-hovered, #091E420F)",
    'color.background.accent.selected': (0, $829f609a65d26a98$exports).B700,
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0C66E4)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0055CC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #09326C)",
    'color.background.disabled': "var(--ds-background-disabled, #091E4208)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.neutral': "var(--ds-background-neutral, #091E420F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091E4224)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #091E424F)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091E420F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #091E4224)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FF)",
    'color.elevation.surface': "var(--ds-surface, #FFFFFF)",
    'color.elevation.surface.sunken': "var(--ds-surface-sunken, #F7F8F9)",
    'color.border': "var(--ds-border, #091E4224)",
    'color.border.input': "var(--ds-border-input, #8590A2)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0C66E4)",
    'color.icon.danger': "var(--ds-icon-danger, #C9372C)",
    'color.icon.information': "var(--ds-icon-information, #1D7AFC)",
    'color.icon.success': "var(--ds-icon-success, #22A06B)",
    'color.icon.warning': "var(--ds-icon-warning, #E56910)",
    'color.link': "var(--ds-link, #0C66E4)",
    'color.link.pressed': "var(--ds-link-pressed, #0055CC)",
    'color.skeleton': "var(--ds-background-neutral, #091E420F)",
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.selected': "var(--ds-text, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #091E424F)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0C66E4)",
    'color.text.subtle': "var(--ds-text-subtle, #44546F)",
    'color.text.subtlest': "var(--ds-text-subtlest, #626F86)",
    'elevation.surface.contrast': 'transparent',
    'elevation.surface.contrast.bolder': 'transparent',
    'elevation.surface.blend.mode': 'darken'
};
const $cd302866fea6f361$export$f286efa6bd1e8f9d = {
    'color.background.accent.selected': "var(--ds-background-neutral-hovered, #091E4224)",
    'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
    'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
    'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
    'color.background.disabled': "var(--ds-background-neutral, #091E420F)",
    'color.background.input': 'rgba(255, 255, 255, 0.8)',
    'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
    'color.text.selected': "var(--ds-text-inverse, #FFFFFF)"
};
const $cd302866fea6f361$export$97cb21c6432e07e8 = {
    'color.background.neutral.subtle.hovered.contrast': 'rgba(255, 255, 255, 0.08)',
    'color.background.accent.selected': "var(--ds-background-neutral-hovered, #091E4224)",
    'color.background.brand.bold': 'rgba(255, 255, 255, 0.8)',
    'color.background.brand.bold.hovered': 'rgba(255, 255, 255, 0.6)',
    'color.background.brand.bold.pressed': 'rgba(255, 255, 255, 0.4)',
    'color.background.disabled': 'rgba(255, 255, 255, 0.08)',
    'color.background.input': 'rgba(255, 255, 255, 0.08)',
    'color.background.neutral': 'rgba(255, 255, 255, 0.08)',
    'color.background.neutral.hovered': 'rgba(255, 255, 255, 0.16)',
    'color.background.neutral.pressed': 'rgba(255, 255, 255, 0.28)',
    'color.background.neutral.subtle.hovered': 'rgba(255, 255, 255, 0.08)',
    'color.background.neutral.subtle.pressed': 'rgba(255, 255, 255, 0.16)',
    'color.background.selected': 'rgba(255, 255, 255, 0.6)',
    'color.elevation.surface': '#172b4d',
    'color.border': 'rgba(255, 255, 255, 0.14)',
    'color.border.input': 'rgba(255, 255, 255, 0.3)',
    'color.border.inverse': 'rgba(255, 255, 255, 0.3)',
    'color.border.selected': (0, $829f609a65d26a98$exports).N0,
    'color.icon.danger': (0, $829f609a65d26a98$exports).N0,
    'color.icon.information': (0, $829f609a65d26a98$exports).N0,
    'color.icon.success': (0, $829f609a65d26a98$exports).N0,
    'color.icon.warning': (0, $829f609a65d26a98$exports).N0,
    'color.skeleton': 'rgba(255,255,255,0.08)',
    'color.text': (0, $829f609a65d26a98$exports).N0,
    'color.text.disabled': 'rgba(255, 255, 255, 0.6)',
    'color.text.inverse': '#172B4D',
    // Neutral 1000
    'color.text.selected': '#172B4D',
    // Neutral 1000
    'color.text.subtle': 'rgba(255, 255, 255, 0.8)',
    'color.text.subtlest': 'rgba(255, 255, 255, 0.8)'
};
const $cd302866fea6f361$export$b124f62a6aab972 = {
    'color.link': '#CCE0FF',
    // Blue 200
    'color.link.pressed': '#E9F2FF' // Blue 100
};
const $cd302866fea6f361$export$9441e0d8f766c59a = {
    name: 'image',
    brightness: 'high',
    theme: {
        light: {
            'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
            'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
            'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
            'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
            'color.link': "var(--ds-text-accent-blue-bolder, #09326C)",
            'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
            'color.text.selected': "var(--ds-text-inverse, #FFFFFF)",
            'elevation.surface.contrast': 'rgba(255,255,255,0.82)',
            'elevation.surface.contrast.bolder': "var(--ds-surface, #FFFFFF)"
        },
        dark: {
            'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
            'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
            'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
            'color.background.input': 'rgba(34, 39, 43, 0.8)',
            'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
            'color.elevation.surface': '#172b4d',
            'color.border': 'rgba(255, 255, 255, 0.14)',
            'color.border.input': 'rgba(255, 255, 255, 0.3)',
            'color.border.inverse': 'rgba(255, 255, 255, 0.3)',
            'color.icon.danger': (0, $829f609a65d26a98$exports).N0,
            'color.icon.information': (0, $829f609a65d26a98$exports).N0,
            'color.icon.success': (0, $829f609a65d26a98$exports).N0,
            'color.icon.warning': (0, $829f609a65d26a98$exports).N0,
            'color.link': "var(--ds-text-accent-blue-bolder, #09326C)",
            'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
            'color.skeleton': 'rgba(255,255,255,0.8)',
            'color.text': (0, $829f609a65d26a98$exports).N0,
            'color.text.selected': "var(--ds-text-inverse, #FFFFFF)",
            'elevation.surface.contrast': 'rgba(29, 33, 37, 0.82)',
            'elevation.surface.contrast.bolder': "var(--ds-surface, #FFFFFF)"
        }
    }
};
// Old Colors
const $cd302866fea6f361$var$WHITE_BACKGROUND_CONFIG = {
    name: 'white'
};
const $cd302866fea6f361$var$LIGHT_PURPLE_BACKGROUND_CONFIG = {
    name: 'light-purple'
};
const $cd302866fea6f361$var$LIGHT_BLUE_BACKGROUND_CONFIG = {
    name: 'light-blue'
};
const $cd302866fea6f361$var$LIGHT_TEAL_BACKGROUND_CONFIG = {
    name: 'light-teal'
};
const $cd302866fea6f361$var$LIGHT_GREEN_BACKGROUND_CONFIG = {
    name: 'light-green'
};
const $cd302866fea6f361$var$LIGHT_YELLOW_BACKGROUND_CONFIG = {
    name: 'light-yellow'
};
const $cd302866fea6f361$var$LIGHT_RED_BACKGROUND_CONFIG = {
    name: 'light-red'
};
const $cd302866fea6f361$var$LIGHT_MAGENTA_BACKGROUND_CONFIG = {
    name: 'light-magenta'
};
const $cd302866fea6f361$var$LIGHT_ORANGE_BACKGROUND_CONFIG = {
    name: 'light-orange'
};
const $cd302866fea6f361$var$DARK_BACKGROUND_CONFIG = {
    name: 'dark'
};
const $cd302866fea6f361$var$PURPLE_BACKGROUND_CONFIG = {
    name: 'purple'
};
const $cd302866fea6f361$var$BLUE_BACKGROUND_CONFIG = {
    name: 'blue'
};
const $cd302866fea6f361$var$TEAL_BACKGROUND_CONFIG = {
    name: 'teal'
};
const $cd302866fea6f361$var$GREEN_BACKGROUND_CONFIG = {
    name: 'green'
};
const $cd302866fea6f361$var$YELLOW_BACKGROUND_CONFIG = {
    name: 'yellow'
};
const $cd302866fea6f361$var$RED_BACKGROUND_CONFIG = {
    name: 'red'
};
const $cd302866fea6f361$var$MAGENTA_BACKGROUND_CONFIG = {
    name: 'magenta'
};
const $cd302866fea6f361$var$ORANGE_BACKGROUND_CONFIG = {
    name: 'orange'
};
// New Colors
const $cd302866fea6f361$var$DARKER_GRAY_BACKGROUND_CONFIG = {
    name: 'darker-gray',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $cd302866fea6f361$var$DARKER_PURPLE_BACKGROUND_CONFIG = {
    name: 'darker-purple',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#5E4DB2',
            // Purple 800
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        },
        dark: {
            'color.elevation.surface': '#5E4DB2',
            // Purple 800
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $cd302866fea6f361$var$DARKER_BLUE_BACKGROUND_CONFIG = {
    name: 'darker-blue',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#0055CC',
            // Blue 800
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        },
        dark: {
            'color.elevation.surface': '#0055CC',
            // Blue 800
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $cd302866fea6f361$var$DARKER_TEAL_BACKGROUND_CONFIG = {
    name: 'darker-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#206A83',
            // Teal 800
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        },
        dark: {
            'color.elevation.surface': '#206A83',
            // Teal 800
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $cd302866fea6f361$var$DARKER_GREEN_BACKGROUND_CONFIG = {
    name: 'darker-green',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#216E4E',
            // Green 800
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        },
        dark: {
            'color.elevation.surface': '#216E4E',
            // Green 800
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $cd302866fea6f361$var$DARKER_LIME_BACKGROUND_CONFIG = {
    name: 'darker-lime',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#4C6B1F',
            // Lime 800
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        },
        dark: {
            'color.elevation.surface': '#4C6B1F',
            // Lime 800
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $cd302866fea6f361$var$DARKER_YELLOW_BACKGROUND_CONFIG = {
    name: 'darker-yellow',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#7F5F01',
            // Yellow 800
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        },
        dark: {
            'color.elevation.surface': '#7F5F01',
            // Yellow 800
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $cd302866fea6f361$var$DARKER_ORANGE_BACKGROUND_CONFIG = {
    name: 'darker-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#A54800',
            // Orange 800
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        },
        dark: {
            'color.elevation.surface': '#A54800',
            // Orange 800
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $cd302866fea6f361$var$DARKER_RED_BACKGROUND_CONFIG = {
    name: 'darker-red',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#AE2E24',
            // Red 800
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        },
        dark: {
            'color.elevation.surface': '#AE2E24',
            // Red 800
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $cd302866fea6f361$var$DARKER_MAGENTA_BACKGROUND_CONFIG = {
    name: 'darker-magenta',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#943D73',
            // Magenta 800
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        },
        dark: {
            'color.elevation.surface': '#943D73',
            // Magenta 800
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_GRAY_BACKGROUND_CONFIG = {
    name: 'darkest-gray',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#172B4D',
            // Neutral 1000
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        },
        dark: {
            'color.elevation.surface': '#172B4D',
            // Neutral 1000
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_PURPLE_BACKGROUND_CONFIG = {
    name: 'darkest-purple',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#352C63',
            // Purple 900
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        },
        dark: {
            'color.elevation.surface': '#352C63',
            // Purple 900
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_BLUE_BACKGROUND_CONFIG = {
    name: 'darkest-blue',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#09326C',
            // Blue 900
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        },
        dark: {
            'color.elevation.surface': '#09326C',
            // Blue 900
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_TEAL_BACKGROUND_CONFIG = {
    name: 'darkest-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#164555',
            // Teal 900
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        },
        dark: {
            'color.elevation.surface': '#164555',
            // Teal 900
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_GREEN_BACKGROUND_CONFIG = {
    name: 'darkest-green',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#164B35',
            // Green 900
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        },
        dark: {
            'color.elevation.surface': '#164B35',
            // Green 900
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_LIME_BACKGROUND_CONFIG = {
    name: 'darkest-lime',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#37471F',
            // Lime 900
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        },
        dark: {
            'color.elevation.surface': '#37471F',
            // Lime 900
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_YELLOW_BACKGROUND_CONFIG = {
    name: 'darkest-yellow',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#533F04',
            // Yellow 900
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        },
        dark: {
            'color.elevation.surface': '#533F04',
            // Yellow 900
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_ORANGE_BACKGROUND_CONFIG = {
    name: 'darkest-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#702E00',
            // Orange 900
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        },
        dark: {
            'color.elevation.surface': '#702E00',
            // Orange 900
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_RED_BACKGROUND_CONFIG = {
    name: 'darkest-red',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#5D1F1A',
            // Red 900
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        },
        dark: {
            'color.elevation.surface': '#5D1F1A',
            // Red 900
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_MAGENTA_BACKGROUND_CONFIG = {
    name: 'darkest-magenta',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#50253F',
            // Magenta 900
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        },
        dark: {
            'color.elevation.surface': '#50253F',
            // Magenta 900
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_GRAY_BACKGROUND_CONFIG = {
    name: 'lightest-gray',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#F1F2F4',
            // Neutral 200
            'color.link': '#44546F',
            // Neutral 800
            'color.link.pressed': '#091E42' // Neutral 1100
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG = {
    name: 'lightest-purple',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#F3F0FF',
            // Purple 100
            'color.link': '#5E4DB2',
            // Purple 800
            'color.link.pressed': '#352C63' // Purple 900
        },
        dark: {
            'color.elevation.surface': '#5E4DB2',
            // Purple 800
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_BLUE_BACKGROUND_CONFIG = {
    name: 'lightest-blue',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#E9F2FF',
            // Blue 100
            'color.link': '#0055CC',
            // Blue 800
            'color.link.pressed': '#09326C' // Blue 900
        },
        dark: {
            'color.elevation.surface': '#0055CC',
            // Blue 800
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_TEAL_BACKGROUND_CONFIG = {
    name: 'lightest-teal',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#E7F9FF',
            // Teal 100
            'color.link': '#206A83',
            // Teal 800
            'color.link.pressed': '#164555' // Teal 900
        },
        dark: {
            'color.elevation.surface': '#206A83',
            // Teal 800
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_GREEN_BACKGROUND_CONFIG = {
    name: 'lightest-green',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#DCFFF1',
            // Green 100
            'color.link': '#216E4E',
            // Green 800
            'color.link.pressed': '#164B35' // Green 900
        },
        dark: {
            'color.elevation.surface': '#216E4E',
            // Green 800
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_LIME_BACKGROUND_CONFIG = {
    name: 'lightest-lime',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#EFFFD6',
            // Lime 100
            'color.link': '#4C6B1F',
            // Lime 800
            'color.link.pressed': '#37471F' // Lime 900
        },
        dark: {
            'color.elevation.surface': '#4C6B1F',
            // Lime 800
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG = {
    name: 'lightest-yellow',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFF7D6',
            // Yellow 100
            'color.link': '#7F5F01',
            // Yellow 800
            'color.link.pressed': '#533F04' // Yellow 900
        },
        dark: {
            'color.elevation.surface': '#7F5F01',
            // Yellow 800
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG = {
    name: 'lightest-orange',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFF3EB',
            // Orange 100
            'color.link': '#A54800',
            // Orange 800
            'color.link.pressed': '#702E00' // Orange 900
        },
        dark: {
            'color.elevation.surface': '#A54800',
            // Orange 800
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_RED_BACKGROUND_CONFIG = {
    name: 'lightest-red',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFECEB',
            // Red 100
            'color.link': '#AE2E24',
            // Red 800
            'color.link.pressed': '#5D1F1A' // Red 900
        },
        dark: {
            'color.elevation.surface': '#AE2E24',
            // Red 800
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG = {
    name: 'lightest-magenta',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFECF8',
            // Magenta 100
            'color.link': '#943D73',
            // Magenta 800
            'color.link.pressed': '#50253F' // Magenta 900
        },
        dark: {
            'color.elevation.surface': '#943D73',
            // Magenta 800
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_GRAY_BACKGROUND_CONFIG = {
    name: 'lighter-gray',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#DCDFE4',
            // Neutral 200
            'color.link': '#44546F',
            // Neutral 800
            'color.link.pressed': '#091E42' // Neutral 1100
        },
        dark: {
            'color.elevation.surface': '#172B4D',
            // Neutral 1000
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_PURPLE_BACKGROUND_CONFIG = {
    name: 'lighter-purple',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#DFD8FD',
            // Purple 200
            'color.link': '#5E4DB2',
            // Purple 800
            'color.link.pressed': '#352C63' // Purple 900
        },
        dark: {
            'color.elevation.surface': '#352C63',
            // Purple 900
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_BLUE_BACKGROUND_CONFIG = {
    name: 'lighter-blue',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#CCE0FF',
            // Blue 200
            'color.link': '#0055CC',
            // Blue 800
            'color.link.pressed': '#09326C' // Blue 900
        },
        dark: {
            'color.elevation.surface': '#09326C',
            // Blue 900
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_TEAL_BACKGROUND_CONFIG = {
    name: 'lighter-teal',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#C6EDFB',
            // Teal 200
            'color.link': '#206A83',
            // Teal 800
            'color.link.pressed': '#164555' // Teal 900
        },
        dark: {
            'color.elevation.surface': '#164555',
            // Teal 900
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_GREEN_BACKGROUND_CONFIG = {
    name: 'lighter-green',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#BAF3DB',
            // Green 200
            'color.link': '#216E4E',
            // Green 800
            'color.link.pressed': '#164B35' // Green 900
        },
        dark: {
            'color.elevation.surface': '#164B35',
            // Green 900
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_LIME_BACKGROUND_CONFIG = {
    name: 'lighter-lime',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#D3F1A7',
            // Lime 200
            'color.link': '#4C6B1F',
            // Lime 800
            'color.link.pressed': '#37471F' // Lime 900
        },
        dark: {
            'color.elevation.surface': '#37471F',
            // Lime 900
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_YELLOW_BACKGROUND_CONFIG = {
    name: 'lighter-yellow',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#F8E6A0',
            // Yellow 200
            'color.link': '#7F5F01',
            // Yellow 800
            'color.link.pressed': '#533F04' // Yellow 900
        },
        dark: {
            'color.elevation.surface': '#533F04',
            // Yellow 900
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_ORANGE_BACKGROUND_CONFIG = {
    name: 'lighter-orange',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FEDEC8',
            // Orange 200
            'color.link': '#A54800',
            // Orange 800
            'color.link.pressed': '#702E00' // Orange 900
        },
        dark: {
            'color.elevation.surface': '#702E00',
            // Orange 900
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_RED_BACKGROUND_CONFIG = {
    name: 'lighter-red',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFD5D2',
            // Red 200
            'color.link': '#AE2E24',
            // Red 800
            'color.link.pressed': '#5D1F1A' // Red 900
        },
        dark: {
            'color.elevation.surface': '#5D1F1A',
            // Red 900
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_MAGENTA_BACKGROUND_CONFIG = {
    name: 'lighter-magenta',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FDD0EC',
            // Magenta 200
            'color.link': '#943D73',
            // Magenta 800
            'color.link.pressed': '#50253F' // Magenta 900
        },
        dark: {
            'color.elevation.surface': '#50253F',
            // Magenta 900
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $cd302866fea6f361$export$4c351ec1dc290344 = {
    name: 'no-background',
    brightness: 'high',
    theme: {
        light: $cd302866fea6f361$export$8a6e9b3370a0f87a,
        dark: {
            ...$cd302866fea6f361$export$8a6e9b3370a0f87a,
            'color.text.accent.selected': "var(--ds-text-inverse, #FFFFFF)"
        }
    }
};
const $cd302866fea6f361$var$ADAPTIVE_CONFIG_BASE = {
    'color.elevation.surface': "var(--ds-surface-hovered, #F1F2F4)",
    'color.background.input': "var(--ds-background-neutral, #091E420F)",
    'color.link': "var(--ds-text, #172B4D)",
    'color.link.pressed': "var(--ds-text, #172B4D)",
    'color.elevation.surface.sunken': "var(--ds-surface-sunken, #F7F8F9)",
    'color.background.selected': "var(--ds-background-neutral-hovered, #091E4224)",
    'color.background.neutral.subtle.hovered.contrast': "var(--ds-surface-hovered, #F1F2F4)",
    'color.border.selected': "var(--ds-border-bold, #758195)",
    'color.text.selected': "var(--ds-text, #172B4D)",
    'color.text': "var(--ds-text, #172B4D)",
    'color.background.brand.bold': "var(--ds-background-neutral-bold, #44546F)",
    'color.background.brand.bold.hovered': "var(--ds-background-neutral-bold-hovered, #2C3E5D)",
    'color.background.brand.bold.pressed': "var(--ds-background-neutral-bold-pressed, #172B4D)"
};
const $cd302866fea6f361$export$2ccb37bafb938d85 = ({ name: name, overrides: overrides })=>{
    const adaptiveColorTheme = {
        ...$cd302866fea6f361$var$ADAPTIVE_CONFIG_BASE,
        ...overrides
    };
    return {
        name: name,
        brightness: 'high',
        theme: {
            light: adaptiveColorTheme,
            dark: adaptiveColorTheme
        }
    };
};
const $cd302866fea6f361$export$18621b73983ebf62 = ({ name: name, overridesAllThemes: overridesAllThemes, overridesLightTheme: overridesLightTheme, overridesDarkTheme: overridesDarkTheme })=>{
    const adaptiveGradientTheme = {
        'elevation.surface': "var(--ds-surface, #FFFFFF)",
        ...$cd302866fea6f361$var$ADAPTIVE_CONFIG_BASE,
        ...overridesAllThemes
    };
    return {
        name: name,
        brightness: 'high',
        theme: {
            light: {
                ...adaptiveGradientTheme,
                ...overridesLightTheme
            },
            dark: {
                ...adaptiveGradientTheme,
                ...overridesDarkTheme
            }
        }
    };
};
const $cd302866fea6f361$export$c8033614bd64480d = {
    name: 'image',
    brightness: 'high',
    theme: {
        light: {
            ...$cd302866fea6f361$var$ADAPTIVE_CONFIG_BASE,
            'elevation.surface.blend.mode': 'normal',
            'elevation.surface.contrast': 'rgba(255,255,255,0.82)'
        },
        dark: {
            ...$cd302866fea6f361$var$ADAPTIVE_CONFIG_BASE,
            'elevation.surface.blend.mode': 'darken',
            'elevation.surface.contrast': 'rgba(29, 33, 37, 0.82)'
        }
    }
};
const $cd302866fea6f361$export$dbb791a784a1373b = $cd302866fea6f361$export$2ccb37bafb938d85({
    name: 'adaptive-gray',
    overrides: {
        'color.elevation.surface.sunken': "var(--ds-surface-pressed, #DCDFE4)"
    }
});
const $cd302866fea6f361$export$e013fca1233b4f7f = $cd302866fea6f361$export$2ccb37bafb938d85({
    name: 'adaptive-purple',
    overrides: {
        'color.elevation.surface': "var(--ds-background-accent-purple-subtlest, #F3F0FF)",
        'color.link': "var(--ds-text-accent-purple, #5E4DB2)",
        'color.link.pressed': "var(--ds-text-accent-purple, #5E4DB2)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-purple-subtler, #DFD8FD)"
    }
});
const $cd302866fea6f361$export$81ad18a6866e27ad = $cd302866fea6f361$export$2ccb37bafb938d85({
    name: 'adaptive-blue',
    overrides: {
        'color.elevation.surface': "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
        'color.link': "var(--ds-text-accent-blue, #0055CC)",
        'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-blue-subtler, #CCE0FF)"
    }
});
const $cd302866fea6f361$export$e41eaa7177d56baf = $cd302866fea6f361$export$2ccb37bafb938d85({
    name: 'adaptive-teal',
    overrides: {
        'color.elevation.surface': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
        'color.link': "var(--ds-text-accent-teal, #206A83)",
        'color.link.pressed': "var(--ds-text-accent-teal, #206A83)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-teal-subtler, #C6EDFB)"
    }
});
const $cd302866fea6f361$export$31b6c9185eea93be = $cd302866fea6f361$export$2ccb37bafb938d85({
    name: 'adaptive-green',
    overrides: {
        'color.elevation.surface': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
        'color.link': "var(--ds-text-accent-green, #216E4E)",
        'color.link.pressed': "var(--ds-text-accent-green, #216E4E)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-green-subtler, #BAF3DB)"
    }
});
const $cd302866fea6f361$export$3214417ed3fa0b58 = $cd302866fea6f361$export$2ccb37bafb938d85({
    name: 'adaptive-magenta',
    overrides: {
        'color.elevation.surface': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
        'color.link': "var(--ds-text-accent-magenta, #943D73)",
        'color.link.pressed': "var(--ds-text-accent-magenta, #943D73)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-magenta-subtler, #FDD0EC)"
    }
});
// Gradients
const $cd302866fea6f361$var$GRADIENT_GRAY_TO_BLACK_META = {
    name: 'gradient-gray-to-black',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #0B1D3A 0%, #505F79 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #0B1D3A 0%, #505F79 100%)'
        }
    }
};
const $cd302866fea6f361$var$GRADIENT_DARK_TO_MEDIUM_PURPLE_META = {
    name: 'gradient-dark-to-medium-purple',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #002D6D 0%, #61013C 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #002D6D 0%, #61013C 100%)'
        }
    }
};
const $cd302866fea6f361$var$GRADIENT_LIGHT_TO_DARK_BLUE_META = {
    name: 'gradient-light-to-dark-blue',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #001F4A 0%, #0033B7 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #001F4A 0%, #0033B7 100%)'
        }
    }
};
const $cd302866fea6f361$var$GRADIENT_BLUE_TO_TEAL_META = {
    name: 'gradient-blue-to-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #000D81 0%, #1492A3 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #000D81 0%, #1492A3 100%)'
        }
    }
};
const $cd302866fea6f361$var$GRADIENT_PURPLE_TO_MAGENTA_META = {
    name: 'gradient-purple-to-magenta',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #13006F 0%, #CD519D 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #13006F 0%, #CD519D 100%)'
        }
    }
};
const $cd302866fea6f361$var$GRADIENT_MAGENTA_TO_ORANGE_META = {
    name: 'gradient-magenta-to-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #7D004B 28.5%, #BF3900 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #7D004B 28.5%, #BF3900 100%)'
        }
    }
};
const $cd302866fea6f361$var$GRADIENT_DARK_TO_LIGHT_RED_META = {
    name: 'gradient-dark-to-light-red',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #150000 0%, #CA0000 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #150000 0%, #CA0000 100%)'
        }
    }
};
const $cd302866fea6f361$var$GRADIENT_DARK_TO_LIGHT_ORANGE_META = {
    name: 'gradient-dark-to-light-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #650101 0%, #C75300 99.75%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #650101 0%, #C75300 99.75%)'
        }
    }
};
const $cd302866fea6f361$var$GRADIENT_DARK_GREEN_TO_LIME_META = {
    name: 'gradient-dark-green-to-lime',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#133911',
            'elevation.surface': 'linear-gradient(135deg, #072C14 0%, #457200 100%)'
        },
        dark: {
            'color.elevation.surface': '#133911',
            'elevation.surface': 'linear-gradient(135deg, #072C14 0%, #457200 100%)'
        }
    }
};
const $cd302866fea6f361$var$GRADIENT_DARK_TO_MEDIUM_TEAL_META = {
    name: 'gradient-dark-to-medium-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#01233D',
            'elevation.surface': 'linear-gradient(135deg, #00152D 0%, #02607E 100%)'
        },
        dark: {
            'color.elevation.surface': '#01233D',
            'elevation.surface': 'linear-gradient(135deg, #00152D 0%, #02607E 100%)'
        }
    }
};
const $cd302866fea6f361$var$ADAPTIVE_GRADIENT_GRAY_META = $cd302866fea6f361$export$18621b73983ebf62({
    name: 'adaptive-gradient-gray',
    overridesAllThemes: {},
    overridesLightTheme: {
        'elevation.surface': 'linear-gradient(135deg, #F8F8F8 0%, #B7B9BE 100%)'
    },
    overridesDarkTheme: {
        'elevation.surface': 'linear-gradient(135deg, #292A2E 0%, #6B6E76 100%)'
    }
});
const $cd302866fea6f361$var$ADAPTIVE_GRADIENT_PURPLE_META = $cd302866fea6f361$export$18621b73983ebf62({
    name: 'adaptive-gradient-purple',
    overridesAllThemes: {
        'color.link': "var(--ds-text-accent-blue, #0055CC)",
        'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
        'color.elevation.surface': "var(--ds-background-accent-blue-subtlest-hovered, #CCE0FF)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-blue-subtlest, #E9F2FF)"
    },
    overridesLightTheme: {
        'elevation.surface': 'linear-gradient(135deg, #CFE1FD 0%, #EED7FC 100%)'
    },
    overridesDarkTheme: {
        'elevation.surface': 'linear-gradient(135deg, #123263 0%, #48245D 100%)'
    }
});
const $cd302866fea6f361$var$ADAPTIVE_GRADIENT_BLUE_META = $cd302866fea6f361$export$18621b73983ebf62({
    name: 'adaptive-gradient-blue',
    overridesAllThemes: {
        'color.link': "var(--ds-text-accent-blue, #0055CC)",
        'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
        'color.elevation.surface': "var(--ds-background-accent-blue-subtlest-hovered, #CCE0FF)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-blue-subtlest, #E9F2FF)"
    },
    overridesLightTheme: {
        'elevation.surface': 'linear-gradient(135deg, #E9F2FE 0%, #669DF1 100%)'
    },
    overridesDarkTheme: {
        'elevation.surface': 'linear-gradient(135deg, #1C2B42 0%, #1868DB 100%)'
    }
});
const $cd302866fea6f361$var$ADAPTIVE_GRADIENT_TEAL_META = $cd302866fea6f361$export$18621b73983ebf62({
    name: 'adaptive-gradient-teal',
    overridesAllThemes: {
        'color.link': "var(--ds-text-accent-teal, #206A83)",
        'color.link.pressed': "var(--ds-text-accent-teal, #206A83)",
        'color.elevation.surface': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-teal-subtlest, #E7F9FF)"
    },
    overridesLightTheme: {
        'elevation.surface': 'linear-gradient(135deg, #E7F9FF 0%, #6CC3E0 100%)'
    },
    overridesDarkTheme: {
        'elevation.surface': 'linear-gradient(135deg, #1E3137 0%, #227D9B 100%)'
    }
});
const $cd302866fea6f361$var$ADAPTIVE_GRADIENT_GREEN_META = $cd302866fea6f361$export$18621b73983ebf62({
    name: 'adaptive-gradient-green',
    overridesAllThemes: {
        'color.link': "var(--ds-text-accent-green, #216E4E)",
        'color.link.pressed': "var(--ds-text-accent-green, #216E4E)",
        'color.elevation.surface': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-green-subtlest, #DCFFF1)"
    },
    overridesLightTheme: {
        'elevation.surface': 'linear-gradient(135deg, #DCFFF1 0%, #4BCE97 100%)'
    },
    overridesDarkTheme: {
        'elevation.surface': 'linear-gradient(135deg, #1C3329 0%, #1F845A 100%)'
    }
});
const $cd302866fea6f361$var$ADAPTIVE_GRADIENT_MAGENTA_META = $cd302866fea6f361$export$18621b73983ebf62({
    name: 'adaptive-gradient-magenta',
    overridesAllThemes: {
        'color.link': "var(--ds-text-accent-magenta, #943D73)",
        'color.link.pressed': "var(--ds-text-accent-magenta, #943D73)",
        'color.elevation.surface': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-magenta-subtlest, #FFECF8)"
    },
    overridesLightTheme: {
        'elevation.surface': 'linear-gradient(135deg, #FDD0EC 28.5%, #FD9891 100%)'
    },
    overridesDarkTheme: {
        'elevation.surface': 'linear-gradient(135deg, #50253F 28.5%, #AE2E24 100%)'
    }
});
const $cd302866fea6f361$export$34373eced7ee212e = [
    $cd302866fea6f361$var$WHITE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHT_PURPLE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHT_BLUE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHT_TEAL_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHT_GREEN_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHT_YELLOW_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHT_ORANGE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHT_RED_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHT_MAGENTA_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARK_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$PURPLE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$BLUE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$TEAL_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$GREEN_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$YELLOW_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$ORANGE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$RED_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$MAGENTA_BACKGROUND_CONFIG
];
const $cd302866fea6f361$export$bc16bf654619d060 = [
    $cd302866fea6f361$var$LIGHTEST_GRAY_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTEST_BLUE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTEST_TEAL_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTEST_GREEN_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTEST_LIME_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTEST_RED_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_GRAY_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_PURPLE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_BLUE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_TEAL_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_GREEN_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_LIME_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_YELLOW_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_ORANGE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_RED_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_MAGENTA_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_GRAY_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_PURPLE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_BLUE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_TEAL_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_GREEN_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_LIME_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_YELLOW_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_ORANGE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_RED_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_MAGENTA_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_GRAY_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_PURPLE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_BLUE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_TEAL_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_GREEN_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_LIME_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_YELLOW_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_ORANGE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_RED_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_MAGENTA_BACKGROUND_CONFIG
];
const $cd302866fea6f361$export$4b188262dd47f902 = [
    $cd302866fea6f361$export$dbb791a784a1373b,
    $cd302866fea6f361$export$e013fca1233b4f7f,
    $cd302866fea6f361$export$81ad18a6866e27ad,
    $cd302866fea6f361$export$e41eaa7177d56baf,
    $cd302866fea6f361$export$31b6c9185eea93be,
    $cd302866fea6f361$export$3214417ed3fa0b58
];
const $cd302866fea6f361$export$242b2d2213fedf27 = [
    $cd302866fea6f361$var$GRADIENT_DARK_TO_LIGHT_RED_META,
    $cd302866fea6f361$var$GRADIENT_MAGENTA_TO_ORANGE_META,
    $cd302866fea6f361$var$GRADIENT_DARK_TO_LIGHT_ORANGE_META,
    $cd302866fea6f361$var$GRADIENT_DARK_GREEN_TO_LIME_META,
    $cd302866fea6f361$var$GRADIENT_BLUE_TO_TEAL_META,
    $cd302866fea6f361$var$GRADIENT_DARK_TO_MEDIUM_TEAL_META,
    $cd302866fea6f361$var$GRADIENT_LIGHT_TO_DARK_BLUE_META,
    $cd302866fea6f361$var$GRADIENT_DARK_TO_MEDIUM_PURPLE_META,
    $cd302866fea6f361$var$GRADIENT_PURPLE_TO_MAGENTA_META,
    $cd302866fea6f361$var$GRADIENT_GRAY_TO_BLACK_META
];
const $cd302866fea6f361$export$8a6c8dd4a86d3f7d = [
    $cd302866fea6f361$var$ADAPTIVE_GRADIENT_GRAY_META,
    $cd302866fea6f361$var$ADAPTIVE_GRADIENT_PURPLE_META,
    $cd302866fea6f361$var$ADAPTIVE_GRADIENT_BLUE_META,
    $cd302866fea6f361$var$ADAPTIVE_GRADIENT_TEAL_META,
    $cd302866fea6f361$var$ADAPTIVE_GRADIENT_GREEN_META,
    $cd302866fea6f361$var$ADAPTIVE_GRADIENT_MAGENTA_META
];
const $cd302866fea6f361$export$fe05a238062e2c3d = {
    white: $cd302866fea6f361$export$4c351ec1dc290344,
    'light-purple': $cd302866fea6f361$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG,
    'light-blue': $cd302866fea6f361$var$LIGHTEST_BLUE_BACKGROUND_CONFIG,
    'light-teal': $cd302866fea6f361$var$LIGHTEST_TEAL_BACKGROUND_CONFIG,
    'light-green': $cd302866fea6f361$var$LIGHTEST_GREEN_BACKGROUND_CONFIG,
    'light-yellow': $cd302866fea6f361$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG,
    'light-orange': $cd302866fea6f361$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG,
    'light-red': $cd302866fea6f361$var$LIGHTEST_RED_BACKGROUND_CONFIG,
    'light-magenta': $cd302866fea6f361$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG,
    dark: $cd302866fea6f361$var$DARKEST_GRAY_BACKGROUND_CONFIG,
    purple: $cd302866fea6f361$var$DARKER_PURPLE_BACKGROUND_CONFIG,
    blue: $cd302866fea6f361$var$DARKER_BLUE_BACKGROUND_CONFIG,
    teal: $cd302866fea6f361$var$DARKER_TEAL_BACKGROUND_CONFIG,
    green: $cd302866fea6f361$var$DARKER_GREEN_BACKGROUND_CONFIG,
    yellow: $cd302866fea6f361$var$DARKER_YELLOW_BACKGROUND_CONFIG,
    orange: $cd302866fea6f361$var$DARKER_ORANGE_BACKGROUND_CONFIG,
    red: $cd302866fea6f361$var$DARKER_RED_BACKGROUND_CONFIG,
    magenta: $cd302866fea6f361$var$DARKER_MAGENTA_BACKGROUND_CONFIG
};
const $cd302866fea6f361$export$cab9d853866386f2 = $cd302866fea6f361$export$4c351ec1dc290344;
const $cd302866fea6f361$export$8e357501548afe78 = 24;
const $cd302866fea6f361$export$baaf8255c30ea280 = 95;
const $cd302866fea6f361$export$d9035bc768f8226d = `${$cd302866fea6f361$export$baaf8255c30ea280}px`;
const $cd302866fea6f361$export$4810531e30462f89 = `calc(100vh - ${(0, $81918a2ef6db1f93$export$d60454526e2281af)} - ${$cd302866fea6f361$export$d9035bc768f8226d})`;
const $cd302866fea6f361$export$1c0b806722927549 = `calc(100vh - ${(0, $81918a2ef6db1f93$export$d60454526e2281af)} - ${$cd302866fea6f361$export$d9035bc768f8226d} - ${$cd302866fea6f361$export$8e357501548afe78 * 2}px)`;
const $cd302866fea6f361$export$2af5673c2fa63c55 = 104;
const $cd302866fea6f361$export$5771162cdeebfb85 = `${$cd302866fea6f361$export$2af5673c2fa63c55}px`;
const $cd302866fea6f361$export$a1626d6d785092a2 = `calc(100vh - ${(0, $81918a2ef6db1f93$export$d60454526e2281af)} - ${$cd302866fea6f361$export$5771162cdeebfb85})`;
const $cd302866fea6f361$export$410e3d6221a052e = `calc(100vh - ${(0, $81918a2ef6db1f93$export$d60454526e2281af)} - ${$cd302866fea6f361$export$5771162cdeebfb85} - ${$cd302866fea6f361$export$8e357501548afe78 * 2}px)`;
const $cd302866fea6f361$export$77cdace62a821419 = `calc(100vw - ${(0, $565cb8192fc4e070$export$f963aecf2d4465bd)} - ${(0, $565cb8192fc4e070$export$f897e1ed9f8ed251)} - ${(0, $565cb8192fc4e070$export$750459958906793)} - ${(0, $565cb8192fc4e070$export$b44ab66843c05a69)}) !important`;
const $cd302866fea6f361$export$3efe68325dd9dc02 = `calc(100vw - ${(0, $565cb8192fc4e070$export$f963aecf2d4465bd)} - ${(0, $565cb8192fc4e070$export$f897e1ed9f8ed251)} - ${(0, $565cb8192fc4e070$export$750459958906793)} - ${(0, $565cb8192fc4e070$export$b44ab66843c05a69)} - ${$cd302866fea6f361$export$8e357501548afe78 * 2}px) !important`;
const $cd302866fea6f361$export$689a64196408e5c2 = 82;

});
// dimension vars
const $565cb8192fc4e070$export$cbfb0f5b2869b17b = 'leftPanelWidth';
const $565cb8192fc4e070$export$a30f2e00489a8957 = 'leftSidebarWidth';
const $565cb8192fc4e070$export$c103b605cd368aed = 'rightSidebarWidth';
const $565cb8192fc4e070$export$fa34f417972d6341 = 'rightPanelWidth';
const $565cb8192fc4e070$export$3a6a779d9181047c = 'topNavigationHeight';
const $565cb8192fc4e070$export$bcd94a6a792e7f96 = 'bannerHeight';
const $565cb8192fc4e070$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
const $565cb8192fc4e070$export$344062f7cfc9528e = 'left-panel';
const $565cb8192fc4e070$export$c7139cc2d6110b5f = 'right-panel';
const $565cb8192fc4e070$export$238d30785c4bca84 = 'banner';
const $565cb8192fc4e070$export$bec6dca2e63de4ae = 'top-navigation';
const $565cb8192fc4e070$export$d1213e82613ff4df = 'content';
const $565cb8192fc4e070$export$be83e7118304b28e = 56;
const $565cb8192fc4e070$export$4a98ee0bd1ae362 = 56;
const $565cb8192fc4e070$export$539e68c09584883a = 240;
const $565cb8192fc4e070$export$b92df8810d2fcd01 = 280;
const $565cb8192fc4e070$export$c3e41153b9288bcf = 368;
const $565cb8192fc4e070$export$c4d6152f86ea28f6 = 368;
const $565cb8192fc4e070$export$46acf8758e9e2636 = 20;
const $565cb8192fc4e070$export$70740f5ad8360a78 = 16;
const $565cb8192fc4e070$export$991d5285ad765a3d = 240;
const $565cb8192fc4e070$export$6949d4f32b161684 = 200;
const $565cb8192fc4e070$export$d6e7e8af042815bb = 350;
const $565cb8192fc4e070$export$3749e1104328fde4 = 300;
const $565cb8192fc4e070$export$1074d925b0b82be5 = 200;
const $565cb8192fc4e070$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
const $565cb8192fc4e070$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
const $565cb8192fc4e070$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
const $565cb8192fc4e070$export$70c702a8c5895f03 = 'data-grab-area-line';
const $565cb8192fc4e070$export$48a43f91e4becf4e = 'data-grab-area';
const $565cb8192fc4e070$export$dac2fb31a9f6844d = 'data-resize-button';
const $565cb8192fc4e070$export$9ecd22db14e6c70e = 'data-resize-control';
const $565cb8192fc4e070$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
const $565cb8192fc4e070$export$206a08f7f8beb554 = 'Skip to:';
const $565cb8192fc4e070$export$659ee746b31b360d = 'data-layout-container';
const $565cb8192fc4e070$export$f963aecf2d4465bd = `var(--${$565cb8192fc4e070$export$cbfb0f5b2869b17b}, 0px)`;
const $565cb8192fc4e070$export$750459958906793 = `var(--${$565cb8192fc4e070$export$fa34f417972d6341}, 0px)`;
const $565cb8192fc4e070$export$f897e1ed9f8ed251 = `var(--${$565cb8192fc4e070$export$a30f2e00489a8957}, 0px)`;
const $565cb8192fc4e070$export$b44ab66843c05a69 = `var(--${$565cb8192fc4e070$export$c103b605cd368aed}, 0px)`;
const $565cb8192fc4e070$export$aeff86a16f13529 = `var(--${$565cb8192fc4e070$export$3a6a779d9181047c}, 0px)`;
const $565cb8192fc4e070$export$ed7cc0d417ee89e = `var(--${$565cb8192fc4e070$export$bcd94a6a792e7f96}, 0px)`;
const $565cb8192fc4e070$export$d2fa14f05b61e66 = `var(--${$565cb8192fc4e070$export$b6744d31294864fd}, ${$565cb8192fc4e070$export$991d5285ad765a3d}px)`;

// We need to move away from using these variables directly as it results in a brittle hard to evolve system.
// This doesn't use @atlassian/jira-navigation-system as it results in a hard-to-debug cycle.
// These variables are inlined to reduce TS Complexity - Please reach out to #help-jfp-squads if you need more information.
const $81918a2ef6db1f93$var$UNSAFE_DO_NOT_USE_BANNER_HEIGHT = 'var(--bannerHeight, 0px)';
const $81918a2ef6db1f93$var$UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT = 'var(--topNavigationHeight, 0px)';
const $81918a2ef6db1f93$export$638757b621fbf475 = `${$81918a2ef6db1f93$var$UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT} + ${$81918a2ef6db1f93$var$UNSAFE_DO_NOT_USE_BANNER_HEIGHT}`;
const $81918a2ef6db1f93$export$d60454526e2281af = `(${$81918a2ef6db1f93$export$638757b621fbf475})`;


parcelRegister("027FQ", function(module, exports) {

$parcel$export(module.exports, "OVERVIEWS_SUCCESS_RESPONSE_TYPE", () => $fd4c320fd9ec6c35$export$ddf2fc82885279d);
const $fd4c320fd9ec6c35$export$ddf2fc82885279d = 'JiraWorkManagementGiraOverviewConnection';
const $fd4c320fd9ec6c35$export$39284f7325536558 = {
    ServiceDesk: 'SERVICE_DESK',
    Business: 'BUSINESS',
    Software: 'SOFTWARE'
};
const $fd4c320fd9ec6c35$export$1f66f9f05afa05a8 = {
    TeamManagedProject: 'TEAM_MANAGED_PROJECT',
    CompanyManagedProject: 'COMPANY_MANAGED_PROJECT'
};

});




parcelRegister("jrO9m", function(module, exports) {

$parcel$export(module.exports, "overviewDetailsResource", () => $e1715b61e2fa96e9$export$cd57aa046b167312);
$parcel$export(module.exports, "useOverview", () => $e1715b61e2fa96e9$export$626541a5c6f2cfa1);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $hFi7P = parcelRequire("hFi7P");
const $e1715b61e2fa96e9$var$RESOURCE_TYPE_KEY = 'BUSINESS_OVERVIEW_DETAILS';
const $e1715b61e2fa96e9$export$cd57aa046b167312 = (0, $2M1hQ.createResource)({
    type: $e1715b61e2fa96e9$var$RESOURCE_TYPE_KEY,
    getKey: ({ match: match })=>`${$e1715b61e2fa96e9$var$RESOURCE_TYPE_KEY}_${match.params.overviewId}`,
    getData: async ({ match: match }, { tenantContext: { cloudId: cloudId, activationId: activationId } })=>(0, $hFi7P.fetchOverviewDetails)(cloudId, activationId, match.params.overviewId),
    maxAge: 3600000
});
const $e1715b61e2fa96e9$export$626541a5c6f2cfa1 = ()=>(0, $2YP9W.useResource)($e1715b61e2fa96e9$export$cd57aa046b167312);

});
parcelRegister("hFi7P", function(module, exports) {

$parcel$export(module.exports, "fetchOverviewDetails", () => $692d3aa28ecf0a74$export$f0395142dbdd6c61);

var $7S1v3 = parcelRequire("7S1v3");

var $63wRx = parcelRequire("63wRx");

var $jlq4V = parcelRequire("jlq4V");

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $dpLxG = parcelRequire("dpLxG");

const $692d3aa28ecf0a74$export$f0395142dbdd6c61 = async (cloudId, activationId, overviewId)=>{
    if (!overviewId) return null;
    try {
        const response = await (0, $eusud.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $dpLxG.QUERY),
                variables: {
                    id: (0, $7S1v3.JiraProjectOverviewAri).create({
                        siteId: cloudId,
                        activationId: activationId,
                        overviewId: overviewId
                    }).toString()
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'projectStyle'
            }
        });
        if (response?.data?.jira?.overview?.__typename === (0, $4bd5c695609ae115$export$62a5da7e3fa5ff88)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $63wRx.mapOverviewFragment)(response.data.jira.overview);
        throw new (0, $jlq4V.GraphQLErrors)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        response?.data?.jira?.overview ?? response.errors);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 410 means that overviews have been migrated to plans and
        // we will show a different message on the not found page.
        if (error?.statusCode === 410) throw error;
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessOverviewDetails', 'Something went wrong while fetching business overview details');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'overviewDetailsResource',
                    packageName: 'jiraRouterResourcesBusinessOverviewDetails',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
    return null;
};

});
parcelRegister("63wRx", function(module, exports) {

$parcel$export(module.exports, "mapOverviewFragment", () => $bc1a4d4cd369fa52$export$e79bf238de33eabb);
const $bc1a4d4cd369fa52$var$SIMPLIFIED_PROJECT_STYLE = 'TEAM_MANAGED_PROJECT';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bc1a4d4cd369fa52$var$mapProjectsNode = (edges)=>edges.map((edge)=>{
        const { node: node } = edge || {};
        if (node == null) return null;
        return {
            key: node.key,
            id: Number(node.projectId),
            avatarUrl: node.avatar?.large ?? '',
            name: node.name,
            type: node.projectType.toLowerCase(),
            isSimplified: node.projectStyle === $bc1a4d4cd369fa52$var$SIMPLIFIED_PROJECT_STYLE,
            isFavorite: node.isFavourite === true,
            permissions: {
                assignIssues: false,
                administerProject: node.administerProject.canPerform,
                createIssues: node.createIssues.canPerform,
                deleteIssues: node.deleteIssues.canPerform,
                editIssues: node.editIssues.canPerform,
                linkIssues: node.linkIssues.canPerform,
                scheduleIssues: node.scheduleIssues.canPerform,
                // remove optional chaining when jwm-use-updated-graphql-querymutation-for-overview is cleaned up
                transitionIssues: node.transitionIssues?.canPerform === true,
                viewIssues: node.viewIssues.canPerform
            }
        };
    }).filter((project)=>project);
const $bc1a4d4cd369fa52$export$e79bf238de33eabb = (overview)=>{
    const { id: id, name: name, theme: theme, projects: projectsData } = overview;
    const projects = $bc1a4d4cd369fa52$var$mapProjectsNode(projectsData.edges);
    const unreachableProjectsCount = projectsData.edges.length - projects.length;
    return {
        id: id,
        name: name,
        theme: theme,
        projects: projects,
        unreachableProjectsCount: unreachableProjectsCount
    };
};

});

parcelRegister("dpLxG", function(module, exports) {

$parcel$export(module.exports, "QUERY", () => $42259e945f9fd88b$export$2b91517d6d5b4365);

const $42259e945f9fd88b$export$2b91517d6d5b4365 = `
    query JwmOverviewDetails($id:ID!) {
      jira {
        overview: jwmOverview(id: $id) {
          __typename
          ... on JiraWorkManagementGiraOverview {
            ...OverviewGiraFragment
          }
          ... on QueryError {
            message
            extensions {
              errorType
              statusCode
            }
          }
        }
      }
    }
    ${(0, $71cc1a0cc3cc977d$export$6f4bda7ea1dcf892)}
`;

});
const $71cc1a0cc3cc977d$export$6f4bda7ea1dcf892 = `
fragment OverviewGiraFragment on JiraWorkManagementGiraOverview {
  id
  name
  theme
  projects {
    edges {
      node {
        key
        projectId
        avatar {
          large
        }
        name
        projectType
        projectStyle
        isFavourite
        administerProject: action(type: EDIT_PROJECT_CONFIG) {
          canPerform
        }
        createIssues: action(type: CREATE_ISSUES) {
          canPerform
        }
        deleteIssues: action(type: DELETE_ISSUES) {
          canPerform
        }
        editIssues: action(type: EDIT_ISSUES) {
          canPerform
        }
        linkIssues: action(type: LINK_ISSUES) {
          canPerform
        }
        scheduleIssues: action(type: SCHEDULE_ISSUES) {
          canPerform
        }
        transitionIssues: action(type: TRANSITION_ISSUES) {
          canPerform
        }
        viewIssues: action(type: VIEW_ISSUES) {
          canPerform
        }
      }
    }
  }
}
`;


const $4bd5c695609ae115$export$62a5da7e3fa5ff88 = 'JiraWorkManagementGiraOverview';



parcelRegister("l2N2a", function(module, exports) {

$parcel$export(module.exports, "DEPRECATED_DO_NOT_USE_projectDetailsResource", () => $a72df1053ff3c9a0$export$ced53bf9d9551fef);
$parcel$export(module.exports, "useProject_DEPRECATED_DO_NOT_USE", () => $a72df1053ff3c9a0$export$97def3841413167f);
/* eslint-disable camelcase */ 
var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $8s4PA = parcelRequire("8s4PA");
const $a72df1053ff3c9a0$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_PROJECT_DETAILS';
const $a72df1053ff3c9a0$export$ced53bf9d9551fef = (0, $2M1hQ.createResource)({
    type: $a72df1053ff3c9a0$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        const projectIdOrKey = projectKey || projectId;
        return `${$a72df1053ff3c9a0$var$RESOURCE_TYPE_KEY}_${projectIdOrKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        return (0, $8s4PA.fetchProjectDetails)(cloudId, projectKey, projectId);
    },
    maxAge: 3600000
});
const $a72df1053ff3c9a0$export$97def3841413167f = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)($a72df1053ff3c9a0$export$ced53bf9d9551fef);
    return {
        data: data?.currentProject ?? null,
        loading: loading,
        error: error
    };
};

});
parcelRegister("8s4PA", function(module, exports) {

$parcel$export(module.exports, "fetchProjectDetails", () => $3400333a67b09775$export$78aa221476efa1c6);

var $kV9ss = parcelRequire("kV9ss");

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");


var $2D9kr = parcelRequire("2D9kr");
const $3400333a67b09775$var$EMPTY_VALUE = {};
const $3400333a67b09775$export$78aa221476efa1c6 = async (cloudId, projectKey, projectId)=>{
    const projectIdOrKey = projectId || projectKey;
    if (!projectIdOrKey) return null;
    try {
        const response = await (0, $eusud.performPostRequest)('/rest/gira/1/?operation=JiraBusinessProjectDetails', {
            body: JSON.stringify({
                query: (0, $7ceb2e31b4137f58$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId,
                    projectIdOrKey: projectIdOrKey,
                    usingProjectKey: projectId == null,
                    projectId: projectId != null ? (0, $kV9ss.JiraProjectAri).create({
                        siteId: cloudId,
                        projectId: projectId
                    }).toString() : ''
                }
            })
        });
        return (0, $2D9kr.transformData)(response.data, projectIdOrKey);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessProjectDetails', 'Something went wrong while fetching business project details');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'projectDetailsResource',
                    packageName: 'jiraRouterResourcesBusinessProjectDetails',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
    return $3400333a67b09775$var$EMPTY_VALUE;
};

});
const $7ceb2e31b4137f58$var$PROJECT_FRAGMENT = `
fragment ProjectFragment on JiraProject {
  key
  projectId
  avatar {
    large
  }
  name
  projectType
  simplified
  favorite
  administerProject: action(type: EDIT_PROJECT_CONFIG) {
    canPerform
  }
  createIssues: action(type: CREATE_ISSUES) {
    canPerform
  }
  viewIssues: action(type: VIEW_ISSUES) {
    canPerform
  }
}
`;
const $7ceb2e31b4137f58$export$2b91517d6d5b4365 = `
query JiraBusinessProjectDetails($cloudId: ID!, $projectIdOrKey: String!, $usingProjectKey: Boolean!, $projectId: ID!) {
  jwmSidebar(cloudId: $cloudId, projectIdOrKey: $projectIdOrKey) {
    jiraProjectByKey(cloudId: $cloudId, key: $projectIdOrKey) @include(if: $usingProjectKey) {
      ...ProjectFragment
    }
    jiraProjectById(id: $projectId) @skip(if: $usingProjectKey) {
      ...ProjectFragment
    }
  }
}
${$7ceb2e31b4137f58$var$PROJECT_FRAGMENT}
`;

parcelRegister("2D9kr", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $a9016a2d391e1663$export$3ceb62baab058c6b);
const $a9016a2d391e1663$var$mapProjectNode = (node)=>{
    if (node == null) return null;
    return {
        key: node.key,
        id: Number(node.projectId),
        avatarUrl: node.avatar?.large ?? '',
        name: node.name,
        type: node.projectType.toLowerCase(),
        isSimplified: node.simplified,
        isFavorite: node.favorite === true,
        permissions: {
            administerProject: node.administerProject.canPerform,
            createIssues: node.createIssues.canPerform,
            viewIssues: node.viewIssues.canPerform
        }
    };
};
const $a9016a2d391e1663$export$3ceb62baab058c6b = (data, projectIdOrKey)=>({
        currentProject: $a9016a2d391e1663$var$mapProjectNode(data?.jwmSidebar?.jiraProjectByKey) ?? $a9016a2d391e1663$var$mapProjectNode(data?.jwmSidebar?.jiraProjectById) ?? null,
        projectIdOrKey: projectIdOrKey
    });

});



parcelRegister("cSUZZ", function(module, exports) {

$parcel$export(module.exports, "licenseDetailsResource_DEPRECATED_DO_NOT_USE", () => $203c641f0a3380f5$export$92c4069b5349d086);
$parcel$export(module.exports, "useIsPremiumUserSeat", () => $203c641f0a3380f5$export$90749419e9042370);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


var $9dQKJ = parcelRequire("9dQKJ");
const $203c641f0a3380f5$export$92c4069b5349d086 = (0, $2M1hQ.createResource)({
    type: 'BUSINESS_LICENSE_DETAILS',
    getKey: ()=>'BUSINESS_LICENSE_DETAILS',
    getData: async (_routerContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
        // do not fetch the resource for anonymous access
        if (isAnonymous) return null;
        return (0, $9dQKJ.fetchLicenseDetails)((0, $2993c3eadd0dda3e$export$2b91517d6d5b4365), {
            cloudId: cloudId
        });
    },
    maxAge: Infinity
});
const $203c641f0a3380f5$export$90749419e9042370 = ()=>{
    const { data: data } = (0, $2YP9W.useResource)($203c641f0a3380f5$export$92c4069b5349d086);
    return Boolean(data?.isPremiumUserSeat);
};

});
const $2993c3eadd0dda3e$export$2b91517d6d5b4365 = `
query JiraBusinessLicenseDetails($cloudId:ID!) {
  jira {
    jwmLicensing(cloudId: $cloudId) {
      currentUserSeatEdition
    }
  }
}
`;

parcelRegister("9dQKJ", function(module, exports) {

$parcel$export(module.exports, "fetchLicenseDetails", () => $164a09ef89830ae9$export$ec058a82eccb31e);

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $164a09ef89830ae9$var$EMPTY_RESPONSE = {
    isPremiumUserSeat: false
};
const $164a09ef89830ae9$export$ec058a82eccb31e = async (query, { cloudId: cloudId })=>{
    try {
        const response = await (0, $eusud.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: {
                    cloudId: cloudId
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        return {
            isPremiumUserSeat: response.data?.jira?.jwmLicensing?.currentUserSeatEdition === 'PREMIUM'
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessLicenseDetails', 'Something went wrong while fetching the license details');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $jcw0u.default)({
            meta: {
                id: 'licenseDetailsResource',
                packageName: 'jiraRouterResourcesBusinessLicenseDetails',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return $164a09ef89830ae9$var$EMPTY_RESPONSE;
};

});


parcelRegister("aFVvc", function(module, exports) {

$parcel$export(module.exports, "projectCreatePermissionsResource", () => $9880b75bed11d4d0$export$f6c05eaea53ab4ae);
$parcel$export(module.exports, "useProjectCreatePermissionsResource", () => $9880b75bed11d4d0$export$2bd0d3b374549a68);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


const $9880b75bed11d4d0$var$getDataLoader = ()=>(parcelRequire("5ohEm"));
const $9880b75bed11d4d0$export$f6c05eaea53ab4ae = (0, $2M1hQ.createResource)({
    type: (0, $acc15b1fbe2101c5$export$8bc44dee8c6d28f),
    getKey: ()=>'state',
    getDataLoader: $9880b75bed11d4d0$var$getDataLoader,
    maxAge: Infinity
});
const $9880b75bed11d4d0$export$2bd0d3b374549a68 = ()=>(0, $2YP9W.useResource)($9880b75bed11d4d0$export$f6c05eaea53ab4ae);

});
const $acc15b1fbe2101c5$export$8bc44dee8c6d28f = 'RESOURCE_TYPE_PROJECT_PERMISSIONS';

parcelRegister("5ohEm", function(module, exports) {

let $3ecce2897af0bd36$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3ecce2897af0bd36$var$load("aErQO").then(()=>parcelRequire('5Yzmr'));

});


parcelRegister("9V5k0", function(module, exports) {

$parcel$export(module.exports, "projectThemeResource", () => $3c09c2af07d8e6b3$export$84730adce8987203);

var $cEpZ8 = parcelRequire("cEpZ8");

var $1nb22 = parcelRequire("1nb22");

var $ao2h1 = parcelRequire("ao2h1");

var $9Yclo = parcelRequire("9Yclo");
const $3c09c2af07d8e6b3$export$84730adce8987203 = (0, $9Yclo.withGiraAggAnonSsrFix)((0, $ao2h1.createRelayResource)({
    type: 'JIRA_PROJECT_THEME',
    getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        const { cloudId: cloudId } = tenantContext;
        return {
            parameters: (0, $cEpZ8.default),
            variables: {
                cloudId: cloudId,
                projectIdOrKey: projectKey ?? projectId ?? ''
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
}));

});
parcelRegister("cEpZ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $e482e6cdf4681d7d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a80e3120b80c99e5f371c683e47c1272>>
 * @relayHash 425f234e57bb5ee35d5bff67f4bb926f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 659f6d85a390f6f3ee8492f86debbfeaed75e90b37b222e25a49822daf422a5a

var $eiowN = parcelRequire("eiowN");
const $e482e6cdf4681d7d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectIdOrKey"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
            {
                "args": v2 /*: any*/ ,
                "kind": "ScalarField",
                "name": "mediaClientId"
            },
            {
                "args": v2 /*: any*/ ,
                "kind": "ScalarField",
                "name": "mediaExternalEndpointUrl"
            }
        ]
    }, v4 = [
        v1 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "idOrKey",
            "variableName": "projectIdOrKey"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v6 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ThemeSetterQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": v3 /*: any*/ ,
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "background",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "ThemeSetterBackground"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ThemeSetterQuery",
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "background",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraActiveBackgroundDetailsResult"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "colorValue"
                                        }
                                    ],
                                    "type": "JiraColorBackground"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "gradientValue"
                                        }
                                    ],
                                    "type": "JiraGradientBackground"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraCustomBackground",
                                            "kind": "LinkedField",
                                            "name": "customBackground",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "mediaApiFileId"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "durationInSeconds",
                                                            "value": 900
                                                        }
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "mediaReadToken",
                                                    "storageKey": "mediaReadToken(durationInSeconds:900)"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "sourceType"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "sourceIdentifier"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "altText"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "dominantColor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "brightness"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraMediaBackground"
                                }
                            ]
                        },
                        v7 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "659f6d85a390f6f3ee8492f86debbfeaed75e90b37b222e25a49822daf422a5a",
            "metadata": {},
            "name": "ThemeSetterQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e482e6cdf4681d7d$var$node.hash = "9864ab22015f44482ad59ad489f945e0";
(0, $eiowN.PreloadableQueryRegistry).set($e482e6cdf4681d7d$var$node.params.id, $e482e6cdf4681d7d$var$node);
var $e482e6cdf4681d7d$export$2e2bcd8739ae039 = $e482e6cdf4681d7d$var$node;

});

parcelRegister("9Yclo", function(module, exports) {

$parcel$export(module.exports, "withGiraAggAnonSsrFix", () => $ee875458deba4a50$export$f4b29e78f4c0a526);
const $ee875458deba4a50$export$f4b29e78f4c0a526 = (resource)=>{
    if (!resource || !resource.getData) return resource;
    const originalGetData = resource.getData;
    // @ts-expect-error types in the relay resource don't allow null, but the react-resource-router types do
    // eslint-disable-next-line no-param-reassign
    resource.getData = (routerContext, customContext)=>{
        if (false && customContext.tenantContext.isAnonymous) return Promise.resolve(null);
        return originalGetData(routerContext, customContext);
    };
    return resource;
};

});



parcelRegister("7nQyj", function(module, exports) {

$parcel$export(module.exports, "archivedWorkItemsJwmRoute", () => $3122019c54f6a6d1$export$1377e2cf39b3ae6a);
const $3122019c54f6a6d1$export$1377e2cf39b3ae6a = {
    name: 'classic-business-archived-work-items',
    path: '/jira/core/projects/:projectKey/archived-work-items',
    exact: true
};

});


parcelRegister("fpGzf", function(module, exports) {

$parcel$export(module.exports, "arjCalendarEmbedRouteEntry", () => $e45e5c76e61613b2$export$309ed92381819b04);

var $5uXOq = parcelRequire("5uXOq");


var $87OsA = parcelRequire("87OsA");

var $lkFvK = parcelRequire("lkFvK");

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $2Ql51 = parcelRequire("2Ql51");

var $6vwaX = parcelRequire("6vwaX");

var $5lsNZ = parcelRequire("5lsNZ");

var $kZOse = parcelRequire("kZOse");

var $02tNK = parcelRequire("02tNK");
const $e45e5c76e61613b2$var$planCalendarEmbedRouteEntry = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $02tNK.calendarEntryPoint)
});
const $e45e5c76e61613b2$export$309ed92381819b04 = (0, $7NszV.createEntry)((0, $6vwaX.arjCalendarEmbedRoute), ()=>({
        group: 'software',
        ufoName: 'software-advanced-roadmaps-calendar-embed',
        // Remove 'component' when cleanup 'smart_links_for_plans' FG
        component: (0, $5lsNZ.default),
        skeleton: ()=>{
            if ((0, $4R6GH.fg)('smart_links_for_plans')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZOse.CalendarSkeleton), null);
            return undefined;
        },
        entryPoint () {
            if ((0, $4R6GH.fg)('smart_links_for_plans')) {
                (0, $87OsA.setCapability)((0, $281cbd47ba46dd7d$export$f999749ac7a2cd1));
                return $e45e5c76e61613b2$var$planCalendarEmbedRouteEntry;
            }
            return undefined;
        },
        layout: (0, $aPfsS.createLayout)({
            isChromeless: true
        }),
        resources: [
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource),
            (0, $2Ql51.themePreferenceResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$f999749ac7a2cd1)
        },
        forPaint: []
    }));

});
const $281cbd47ba46dd7d$export$ef94a84e2990361c = 'ISSUE_VIEW';
const $281cbd47ba46dd7d$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
const $281cbd47ba46dd7d$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
const $281cbd47ba46dd7d$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
const $281cbd47ba46dd7d$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
const $281cbd47ba46dd7d$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
const $281cbd47ba46dd7d$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
const $281cbd47ba46dd7d$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
const $281cbd47ba46dd7d$export$4695c1a423ffe431 = 'DASHBOARD';
const $281cbd47ba46dd7d$export$f999749ac7a2cd1 = 'PLAN_CALENDAR';
const $281cbd47ba46dd7d$export$9a80695e72849f84 = 'X-Atlassian-Capability';

parcelRegister("c3WQb", function(module, exports) {

$parcel$export(module.exports, "advancedRoadmapsReduxStoreStateResource", () => $20c66b93015d9910$export$6ca262338f199e4b);
$parcel$export(module.exports, "advancedRoadmapsScenarioIdResource", () => $20c66b93015d9910$export$aec847b4ce72891);
$parcel$export(module.exports, "advancedRoadmapsPlanPageInitialChecksResource", () => $20c66b93015d9910$export$7431e46c7ad56c3d);
$parcel$export(module.exports, "advancedRoadmapsPlanReportPageInitialChecksResource", () => $20c66b93015d9910$export$bf0c5395c73cc255);
$parcel$export(module.exports, "advancedRoadmapsLastVisitedProgramBoardIdResource", () => $20c66b93015d9910$export$f5b159e1fb19e04e);

var $hGgHi = parcelRequire("hGgHi");

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");

var $9NiTW = parcelRequire("9NiTW");

var $iR3GG = parcelRequire("iR3GG");

var $4R6GH = parcelRequire("4R6GH");

const $20c66b93015d9910$export$6ca262338f199e4b = (0, $2M1hQ.createResource)({
    type: 'ADVANCED_ROADMAPS_REDUX_STORE_STATE',
    getKey: ({ match: match })=>{
        const { params: params, query: query } = match;
        if (params.planId != null && params.scenarioId != null) return `${params.planId}:${params.scenarioId}`;
        if (params.reportId != null) return params.reportId;
        if (query.r != null) return query.r;
        throw new Error('Unable to get resource key for ADVANCED_ROADMAPS_REDUX_STORE_STATE.');
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getData: async ()=>undefined,
    isBrowserOnly: true,
    // Invalidation is implemented here: src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx
    maxAge: Infinity
});
const $20c66b93015d9910$export$aec847b4ce72891 = (0, $2M1hQ.createResource)({
    type: (0, $025c2a539475c8ec$export$a0893d695ebee984),
    getKey: ({ query: query })=>`scenarioId_${query.id}`,
    getData: async ({ query: query })=>{
        const planId = query.id;
        const { id: id } = await (0, $eusud.performGetRequest)(`/rest/jpo/1.0/scenarios/${planId}`);
        return {
            scenarioId: id
        };
    },
    maxAge: 0
});
const $20c66b93015d9910$export$7431e46c7ad56c3d = (0, $2M1hQ.createResource)({
    type: (0, $025c2a539475c8ec$export$68390102872336b6),
    getKey: ({ match: match })=>{
        const { planId: planId, scenarioId: scenarioId } = match.params;
        return `planPageInitialChecks_${planId != null ? planId : ''}_${scenarioId != null ? scenarioId : ''}`;
    },
    getData: async ({ match: match }, { tenantContext: tenantContext })=>{
        if ((0, $4R6GH.fg)('plan_resource_error_handling')) {
            if (!(0, $9NiTW.checkAuthentication)(tenantContext)) throw (0, $iR3GG.createResourceError)({
                component: 'router-resources.advanced-roadmaps-plan.initial-checks.get-data',
                message: 'Current user is not authenticated',
                name: 'AuthenticationError',
                skipSentry: true
            });
        }
        const { planId: planId, scenarioId: scenarioId } = match.params;
        // @ts-expect-error - TS2367 - This condition will always return 'false' since the types '"null"' and '"undefined"' have no overlap.
        if (planId == null || planId === 'null' && planId === 'undefined' && planId === '') throw new Error('Plan cannot be loaded without a planId');
        let url = `/rest/jpo/1.0/plans/${planId}/checks`;
        if (scenarioId != null && scenarioId !== 'null' && scenarioId !== 'undefined' && scenarioId !== '') url = `${url}?sid=${scenarioId}`;
        const response = await (0, $eusud.performGetRequest)(url);
        return response;
    },
    // Invalidation is implemented here: src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx
    maxAge: Infinity
});
const $20c66b93015d9910$export$bf0c5395c73cc255 = (0, $2M1hQ.createResource)({
    type: (0, $025c2a539475c8ec$export$a00e869cafd63140),
    getKey: ({ match: match })=>`planReportPageInitialChecks_${match.params.reportId == null ? '' : match.params.reportId}`,
    getData: async ({ match: match }, { tenantContext: tenantContext })=>{
        if ((0, $4R6GH.fg)('plan_resource_error_handling')) {
            if (!(0, $9NiTW.checkAuthentication)(tenantContext)) throw (0, $iR3GG.createResourceError)({
                component: 'router-resources.advanced-roadmaps-plan.report-initial-checks.get-data',
                message: 'Current user is not authenticated',
                name: 'AuthenticationError',
                skipSentry: true
            });
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const initialPlanChecksPromise = window.__ARJ_INITIAL_PLAN_REPORT_CHECKS_PROMISE__;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        delete window.__ARJ_INITIAL_PLAN_REPORT_CHECKS_PROMISE__;
        if (initialPlanChecksPromise) {
            const response = await initialPlanChecksPromise;
            return response;
        }
        const { reportId: reportId } = match.params;
        const response = await (0, $eusud.performGetRequest)(`/rest/jpo/1.0/reportinfo/generic/${reportId == null ? '' : reportId}/checks`);
        return response;
    },
    // Invalidation is implemented here: src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx
    maxAge: Infinity
});
const $20c66b93015d9910$export$f5b159e1fb19e04e = (0, $2M1hQ.createResource)({
    type: (0, $025c2a539475c8ec$export$179a0d35e95a4d61),
    getKey: ({ query: query, match: match })=>`lastVisitedProgramBoardId_${query.id}_${match.params.planId}_${match.params.scenarioId}`,
    getData: async ({ match: match })=>{
        // Sometimes currentPlanId isn't yet ready - we retry a few times to check if it has loaded in before making the request
        const RETRIES = 3;
        const DELAY = 500;
        const attemptFetch = async (remainingRetries)=>{
            const currentPlanId = match.params.planId;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(currentPlanId)) {
                const defaultBoardIdResponse = await (0, $eusud.performGetRequest)(`/rest/jpo/2.0/plans/${currentPlanId}/increments/default`);
                if (defaultBoardIdResponse === null) return {
                    boardId: null
                };
                const { id: id } = defaultBoardIdResponse;
                return {
                    boardId: id
                };
            }
            if (remainingRetries > 0) {
                await new Promise((resolve)=>setTimeout(resolve, DELAY));
                return attemptFetch(remainingRetries - 1);
            }
            throw new Error('Attempted to get the last visited program board of a plan without a plan id after multiple retries.');
        };
        return attemptFetch(RETRIES);
    },
    // Invalidation is implemented here: src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx
    maxAge: Infinity
});

});
parcelRegister("iR3GG", function(module, exports) {

$parcel$export(module.exports, "createResourceError", () => $d895341acba1e817$export$13487d18466bc8a5);

var $2YZCu = parcelRequire("2YZCu");
class $d895341acba1e817$var$ResourceErrorClass extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message, options){
        super(message);
        this.name = options.name || 'ResourceError';
        this.skipSentry = options.skipSentry;
    }
}
const $d895341acba1e817$export$13487d18466bc8a5 = ({ name: name = 'ResourceError', message: message = '', component: component = '', skipSentry: skipSentry = false }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
errorOverride)=>{
    (0, $2YZCu.default).safeErrorWithoutCustomerData(component, message, errorOverride);
    if (errorOverride) return errorOverride;
    return new $d895341acba1e817$var$ResourceErrorClass(message, {
        name: name,
        skipSentry: skipSentry
    });
};

});

const $025c2a539475c8ec$export$68390102872336b6 = 'ADVANCED_ROADMAPS_PLAN_INITIAL_CHECKS';
const $025c2a539475c8ec$export$a00e869cafd63140 = 'ADVANCED_ROADMAPS_REPORT_INITIAL_CHECKS';
const $025c2a539475c8ec$export$a0893d695ebee984 = 'ADVANCED_ROADMAPS_SCENARIO_ID';
const $025c2a539475c8ec$export$179a0d35e95a4d61 = 'ADVANCED_ROADMAPS_LAST_VISITED_PROGRAM_BOARD_ID';


parcelRegister("6vwaX", function(module, exports) {

$parcel$export(module.exports, "arjCalendarEmbedRoute", () => $6f41180defbce930$export$30779cab3c860456);
const $6f41180defbce930$export$30779cab3c860456 = {
    name: 'software-plan-calendar-embed',
    path: '/jira/plans/:planId/scenarios/:scenarioId/calendar/embed'
};

});

parcelRegister("kZOse", function(module, exports) {

$parcel$export(module.exports, "CalendarSkeleton", () => $7999bdaf81f7939b$export$ebc7c47cc535837e);
$parcel$export(module.exports, "CalendarEmbedSkeleton", () => $7999bdaf81f7939b$export$bf543fe31d33292e);
$parcel$export(module.exports, "CalendarNoHeaderSkeleton", () => $7999bdaf81f7939b$export$504e7b05f3c54bf2);
/* CalendarSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $9AxEw = parcelRequire("9AxEw");

var $34brI = parcelRequire("34brI");

var $lxEy8 = parcelRequire("lxEy8");
const $7999bdaf81f7939b$var$customCssStyles = null;
const $7999bdaf81f7939b$export$ebc7c47cc535837e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9AxEw)))
    });
const $7999bdaf81f7939b$export$bf543fe31d33292e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($34brI)))
    });
const $7999bdaf81f7939b$export$504e7b05f3c54bf2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lxEy8))),
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("9AxEw", function(module, exports) {
module.exports = new URL("calendar-app-skeleton.tpl.77b09222.svg", import.meta.url).toString();

});

parcelRegister("34brI", function(module, exports) {
module.exports = new URL("calendar-embed-app-skeleton.tpl.29c9a641.svg", import.meta.url).toString();

});

parcelRegister("lxEy8", function(module, exports) {
module.exports = new URL("calendar-no-header-skeleton.tpl.d6779107.svg", import.meta.url).toString();

});


parcelRegister("02tNK", function(module, exports) {

$parcel$export(module.exports, "calendarEntryPoint", () => $8623df52c8647276$export$19cf4b398f638dc6);

var $4R6GH = parcelRequire("4R6GH");

var $7JhZX = parcelRequire("7JhZX");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");
const $8623df52c8647276$var$ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR_EMBED = 'software-plan-calendar-embed';
const $8623df52c8647276$var$SETTINGS_STORAGE_KEY = 'plans_calendar_view_settings';
function $8623df52c8647276$var$getViewSettings(key) {
    try {
        const serializedValue = globalThis.localStorage?.getItem(key);
        return serializedValue !== null ? JSON.parse(serializedValue) : undefined;
    } catch  {
        return undefined;
    }
}
function $8623df52c8647276$var$toPlanScenarioAri({ siteId: siteId, activationId: activationId, planId: planId, scenarioId: scenarioId }) {
    return `ari:cloud:jira:${siteId}:plan-scenario/activation/${activationId}/${planId}/scenario/${scenarioId}`;
}
function $8623df52c8647276$var$getStorageKeyFromScope(context) {
    const { match: { params: { planId: planId, scenarioId: scenarioId } } } = context;
    const LOCALSTORAGE_KEY_PREFIX = 'persist:calendar';
    return `${LOCALSTORAGE_KEY_PREFIX}/plan/${planId}/scenario/${scenarioId}`;
}
function $8623df52c8647276$var$getStorageValueFromScope(key) {
    const storedData = globalThis.localStorage?.getItem(key) || '';
    return storedData;
}
function $8623df52c8647276$var$toMidnightUTCString(date) {
    const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    return new Date(utcMilliseconds).toISOString();
}
function $8623df52c8647276$var$toDate(date) {
    if (!date) return new Date();
    try {
        const _date = new Date(date);
        return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
    } catch (e) {
        return new Date();
    }
}
function $8623df52c8647276$var$createScope({ context: context, tenantContext: tenantContext }) {
    const { match: { params: { planId: planId, scenarioId: scenarioId } } } = context;
    const { cloudId: cloudId, activationId: activationId } = tenantContext;
    const planScenarioAri = $8623df52c8647276$var$toPlanScenarioAri({
        siteId: cloudId,
        activationId: activationId,
        planId: String(planId),
        scenarioId: String(scenarioId)
    });
    return {
        type: 'plan',
        ids: [
            planScenarioAri
        ]
    };
}
function $8623df52c8647276$var$buildScopeInput(scope) {
    return {
        ids: scope.ids
    };
}
function $8623df52c8647276$var$buildViewId(scope) {
    // plan scenario ARI is the view id
    return scope.ids?.[0] ?? '';
}
function $8623df52c8647276$var$toViewMode(mode) {
    switch(mode){
        case 'week':
            return 'WEEK';
        case 'day':
            return 'DAY';
        default:
            return 'MONTH';
    }
}
function $8623df52c8647276$var$toWeekStart(weekStart) {
    switch(weekStart){
        case 'monday':
            return 'MONDAY';
        case 'saturday':
            return 'SATURDAY';
        default:
            return 'SUNDAY';
    }
}
function $8623df52c8647276$var$toCalendarWeekStart(weekStart) {
    switch(weekStart){
        case 'sunday':
            return 'sunday';
        case 'saturday':
            return 'saturday';
        default:
            return 'monday';
    }
}
function $8623df52c8647276$var$toCalendarColorBy(colorBy) {
    switch(colorBy){
        case 'none':
            return 'none';
        case 'status':
            return 'status';
        default:
            return 'status';
    }
}
function $8623df52c8647276$var$toCalendarViewRange(view) {
    switch(view){
        case 'week':
            return 'week';
        default:
            return 'month';
    }
}
function $8623df52c8647276$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField, viewId: viewId }) {
    return {
        date: $8623df52c8647276$var$toMidnightUTCString(selectedDate),
        mode: $8623df52c8647276$var$toViewMode(viewRange),
        weekStart: $8623df52c8647276$var$toWeekStart(weekStartsOn),
        ...(0, $4R6GH.fg)('jira_calendar_load_more_pagination') ? {
            startDateField: startDateField,
            endDateField: endDateField
        } : {},
        viewId: viewId
    };
}
function $8623df52c8647276$var$buildIssuesSearchInput(storageKey, // remove optional attribute when cleaning up fg smart_links_for_plans
filter, isEmbed) {
    if ((0, $4R6GH.fg)('smart_links_for_plans')) return {
        additionalFilterQuery: isEmbed === true ? filter ?? '' : filter || $8623df52c8647276$var$getStorageValueFromScope(storageKey)
    };
    return {
        additionalFilterQuery: $8623df52c8647276$var$getStorageValueFromScope(storageKey)
    };
}
function $8623df52c8647276$var$buildUnscheduledIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}
function $8623df52c8647276$var$buildVersionsSearchInput() {
    return {
        versionStatuses: [
            'RELEASED',
            'UNRELEASED'
        ]
    };
}
function $8623df52c8647276$var$buildCalendarCrossProjectVersionsInput() {
    return {
        statuses: [
            'RELEASED',
            'UNRELEASED'
        ]
    };
}
function $8623df52c8647276$var$buildSprintsSearchInput() {
    return {
        sprintStates: [
            'ACTIVE',
            'FUTURE',
            'CLOSED'
        ]
    };
}
function $8623df52c8647276$var$buildSettingsParams(hideWeekends, hideSprints, hideVersions, hideIssues, hideIssueKey, weekStartsOnQueryParam, colorBy, viewRange) {
    if (hideWeekends || hideSprints || hideVersions || hideIssues || hideIssueKey || weekStartsOnQueryParam || colorBy || viewRange) return {
        hideWeekends: hideWeekends === 'true' || undefined,
        hideSprints: hideSprints === 'true' || undefined,
        hideVersions: hideVersions === 'true' || undefined,
        hideIssues: hideIssues === 'true' || undefined,
        hideIssueKey: hideIssueKey === 'true' || undefined,
        weekStartsOn: $8623df52c8647276$var$toCalendarWeekStart(weekStartsOnQueryParam),
        colorBy: $8623df52c8647276$var$toCalendarColorBy(colorBy),
        viewRange: $8623df52c8647276$var$toCalendarViewRange(viewRange)
    };
    return undefined;
}

const $8623df52c8647276$export$19cf4b398f638dc6 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("hjCYs")), {
        moduleId: "53aec496",
        priority: "userVisible"
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
        const { cloudId: cloudId } = tenantContext;
        const scope = $8623df52c8647276$var$createScope(entryPointRouteParams);
        const scopeInput = $8623df52c8647276$var$buildScopeInput(scope);
        const { date: date, filter: filter, hideWeekends: hideWeekends, hideSprints: hideSprints, hideVersions: hideVersions, hideIssues: hideIssues, hideIssueKey: hideIssueKey, weekStartsOn: weekStartsOnQueryParam, colorBy: colorByQueryParam, viewRange: viewRangeParam } = context.query;
        const selectedDate = $8623df52c8647276$var$toDate(date);
        const hasFilterQueryParam = (0, $4R6GH.fg)('smart_links_for_plans') ? Boolean(filter) : false;
        const routeName = (0, $4R6GH.fg)('smart_links_for_plans') ? context.route.name : '';
        const settingsQueryParams = (0, $4R6GH.fg)('smart_links_for_plans') ? $8623df52c8647276$var$buildSettingsParams(hideWeekends, hideSprints, hideVersions, hideIssues, hideIssueKey, weekStartsOnQueryParam, colorByQueryParam, viewRangeParam) : {};
        const isEmbed = (0, $4R6GH.fg)('smart_links_for_plans') ? routeName === $8623df52c8647276$var$ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR_EMBED : false;
        const settings = (0, $4R6GH.fg)('jira_calendar_load_more_pagination') ? $8623df52c8647276$var$getViewSettings($8623df52c8647276$var$SETTINGS_STORAGE_KEY) : undefined;
        const viewRange = (0, $4R6GH.fg)('enable_week_mode_in_plan_calendar') ? settingsQueryParams?.viewRange ?? settings?.viewRange ?? 'month' : 'month';
        const weekStartsOn = (0, $4R6GH.fg)('jira_calendar_load_more_pagination') ? settingsQueryParams?.weekStartsOn ?? settings?.weekStartsOn ?? 'monday' : 'monday';
        const startDateField = 'startdate';
        const endDateField = 'duedate';
        const issueEventFields = {
            startDateField: startDateField,
            endDateField: endDateField
        };
        const storageKey = $8623df52c8647276$var$getStorageKeyFromScope(context);
        const viewId = $8623df52c8647276$var$buildViewId(scope);
        const filterQuery = (0, $4R6GH.fg)('smart_links_for_plans') ? $8623df52c8647276$var$buildIssuesSearchInput(storageKey, filter, isEmbed) : $8623df52c8647276$var$buildIssuesSearchInput(storageKey);
        return {
            queries: {
                calendarData: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $7JhZX.default,
                    variables: {
                        cloudId: cloudId,
                        scopeInput: scopeInput,
                        configurationInput: $8623df52c8647276$var$buildConfigurationInput({
                            selectedDate: selectedDate,
                            viewRange: viewRange,
                            weekStartsOn: weekStartsOn,
                            startDateField: startDateField,
                            endDateField: endDateField,
                            viewId: viewId
                        }),
                        issuesPageSize: 50,
                        issuesSearchInput: filterQuery,
                        unscheduledIssuesSearchInput: $8623df52c8647276$var$buildUnscheduledIssuesSearchInput(),
                        versionsSearchInput: $8623df52c8647276$var$buildVersionsSearchInput(),
                        sprintsSearchInput: $8623df52c8647276$var$buildSprintsSearchInput(),
                        crossProjectVersionsSearchInput: $8623df52c8647276$var$buildCalendarCrossProjectVersionsInput(),
                        viewId: viewId,
                        skipSprintSearch: false,
                        skipPanelIssueSearch: true,
                        skipCrossProjectVersionSearch: false,
                        schedulePermissionsEnabled: (0, $4R6GH.fg)('calendar_schedule_issue_permissions_check'),
                        pageLoadMoreEnabled: (0, $4R6GH.fg)('jira_calendar_load_more_pagination'),
                        skipVersionsV1Search: (0, $4R6GH.fg)('plan-calendar-versions-v2-adoption'),
                        skipVersionsV2Search: !(0, $4R6GH.fg)('plan-calendar-versions-v2-adoption'),
                        includeRecurrenceIndicator: false,
                        pageLoadMoreEnabledViewSettings: (0, $4R6GH.fg)('jira_calendar_load_more_pagination_view_settings')
                    }
                }
            },
            entryPoints: {},
            extraProps: {
                scope: scope,
                selectedDate: selectedDate,
                viewRange: viewRange,
                weekStartsOn: weekStartsOn,
                issueEventFields: issueEventFields,
                storageKey: storageKey,
                hasFilterQueryParam: hasFilterQueryParam,
                routeName: routeName,
                settingsQueryParams: settingsQueryParams,
                filterQuery: (0, $4R6GH.fg)('smart_links_for_plans') ? filterQuery.additionalFilterQuery : undefined
            }
        };
    }
});

});
parcelRegister("7JhZX", function(module, exports) {

$parcel$export(module.exports, "default", () => $122674b135b0c50b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d885ae30433602c86d069d6faefc88bb>>
 * @relayHash 049de4ae3c6fdd9cf38242148ced5df6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7b05b902b1f5bbf48ae4756c58d4841b930fd1b552e2d2cd45a05d7e5aded3e8

var $jczjB = parcelRequire("jczjB");
const $122674b135b0c50b$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "7b05b902b1f5bbf48ae4756c58d4841b930fd1b552e2d2cd45a05d7e5aded3e8",
        "metadata": {},
        "name": "ui_jiraCalendarQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcisjiracalendarreleaseflyoutlazyloadingenabledrelayprovider": (0, $jczjB.default)
        }
    }
};
var $122674b135b0c50b$export$2e2bcd8739ae039 = $122674b135b0c50b$var$node;

});
parcelRegister("jczjB", function(module, exports) {

$parcel$export(module.exports, "default", () => $51b693d306308748$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");
var $51b693d306308748$export$2e2bcd8739ae039 = {
    get () {
        return (0, $6s1PB.expVal)('jira_calendar_release_flyout_lazy_loading', 'isEnabled', false);
    }
};

});


parcelRegister("hjCYs", function(module, exports) {

let $c9b27170a2a2a44c$var$load = (parcelRequire("28QjX"))(4);





module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $c9b27170a2a2a44c$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $c9b27170a2a2a44c$var$load("k6g9p")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $c9b27170a2a2a44c$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $c9b27170a2a2a44c$var$load("7B2gt")
        ]);
    }),
    $c9b27170a2a2a44c$var$load("ffQaD"),
    $c9b27170a2a2a44c$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("gLm90"), 4)),
    $c9b27170a2a2a44c$var$load("fliVL"),
    $c9b27170a2a2a44c$var$load("76n7a"),
    $c9b27170a2a2a44c$var$load("l253H"),
    $c9b27170a2a2a44c$var$load("kE8pT")
]).then(()=>parcelRequire('5zu1k'));

});
parcelRegister("aMHR6", function(module, exports) {
"use strict";

var $g1Pp8 = parcelRequire("g1Pp8");
module.exports = $g1Pp8(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        let existingLinks = document.getElementsByTagName('link');
        if ([].concat(existingLinks).some(function(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("g1Pp8", function(module, exports) {
"use strict";
let $bab49d2fea43af49$var$cachedBundles = {};
let $bab49d2fea43af49$var$cachedPreloads = {};
let $bab49d2fea43af49$var$cachedPrefetches = {};
function $bab49d2fea43af49$var$getCache(type) {
    switch(type){
        case 'preload':
            return $bab49d2fea43af49$var$cachedPreloads;
        case 'prefetch':
            return $bab49d2fea43af49$var$cachedPrefetches;
        default:
            return $bab49d2fea43af49$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        let cache = $bab49d2fea43af49$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});





parcelRegister("aVGYm", function(module, exports) {

$parcel$export(module.exports, "arjDependenciesEmbedRouteEntry", () => $b6a501a17ba8d16b$export$2506a377ba649c46);

var $cSD7y = parcelRequire("cSD7y");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $2Ql51 = parcelRequire("2Ql51");

var $2NIIP = parcelRequire("2NIIP");

var $5lsNZ = parcelRequire("5lsNZ");

var $4R6GH = parcelRequire("4R6GH");

var $lkFvK = parcelRequire("lkFvK");

var $1zjAp = parcelRequire("1zjAp");

var $k7MTs = parcelRequire("k7MTs");
const $b6a501a17ba8d16b$var$planDependenciesReportEmbedRouteEntry = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $1zjAp.planDependenciesReportEntryPoint)
});
const $b6a501a17ba8d16b$export$2506a377ba649c46 = (0, $7NszV.createEntry)((0, $2NIIP.arjDependenciesEmbedRoute), ()=>({
        group: 'software',
        component: (0, $cSD7y.componentWithFG)('smart_links_for_plans', (0, $k7MTs.PlanDependenciesReportEmbedPage), (0, $5lsNZ.default)),
        entryPoint: ()=>(0, $4R6GH.fg)('migrate_plans_to_entrypoints') ? $b6a501a17ba8d16b$var$planDependenciesReportEmbedRouteEntry : undefined,
        layout: (0, $aPfsS.createLayout)({
            isChromeless: true
        }),
        resources: [
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource),
            (0, $2Ql51.themePreferenceResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        forPaint: [
            (0, $k7MTs.LazyPlanDependenciesReportEmbed)
        ]
    }));

});
parcelRegister("2NIIP", function(module, exports) {

$parcel$export(module.exports, "arjDependenciesEmbedRoute", () => $994711b55bffb4b7$export$96aaf89753980215);
const $994711b55bffb4b7$export$96aaf89753980215 = {
    name: 'software-plan-dependencies-embed',
    path: '/jira/plans/:planId/scenarios/:scenarioId/dependencies/embed'
};

});

parcelRegister("1zjAp", function(module, exports) {

$parcel$export(module.exports, "planDependenciesReportEntryPoint", () => $d023c1f5bac3e782$export$e4ba4cc5a2304191);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $d023c1f5bac3e782$export$e4ba4cc5a2304191 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("iQwbh")), {
        moduleId: "1a1a3500",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("iQwbh", function(module, exports) {

let $db860bc9f5373f3e$var$load = (parcelRequire("28QjX"))(4);





module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $db860bc9f5373f3e$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $db860bc9f5373f3e$var$load("k6g9p")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $db860bc9f5373f3e$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $db860bc9f5373f3e$var$load("7B2gt")
        ]);
    }),
    $db860bc9f5373f3e$var$load("ffQaD"),
    $db860bc9f5373f3e$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("lIVmo"), 4)),
    $db860bc9f5373f3e$var$load("76n7a"),
    $db860bc9f5373f3e$var$load("l253H"),
    $db860bc9f5373f3e$var$load("fliVL"),
    $db860bc9f5373f3e$var$load("j4ifu")
]).then(()=>parcelRequire('9WfFd'));

});


parcelRegister("k7MTs", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSummaryEmbed", () => $39df6cea3ba994f5$export$b0feb6e650be3c8c);
$parcel$export(module.exports, "PlanSummaryEmbedPage", () => $39df6cea3ba994f5$export$a37f296d90476a73);
$parcel$export(module.exports, "LazyPlanDependenciesReportEmbed", () => $39df6cea3ba994f5$export$48681ab0b4246654);
$parcel$export(module.exports, "PlanDependenciesReportEmbedPage", () => $39df6cea3ba994f5$export$4ece7fb6c15037f9);
$parcel$export(module.exports, "LazyPlanIncrementEmbed", () => $39df6cea3ba994f5$export$51f2083dff1ee684);
$parcel$export(module.exports, "PlanIncrementEmbedPage", () => $39df6cea3ba994f5$export$a2ae011b90c17927);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $39df6cea3ba994f5$export$b0feb6e650be3c8c = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("irZA1"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-summary/index.tsx"
});
const $39df6cea3ba994f5$export$a37f296d90476a73 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $39df6cea3ba994f5$export$b0feb6e650be3c8c,
        pageId: "plan-summary-embed-old",
        shouldShowSpinner: true
    });

const $39df6cea3ba994f5$export$48681ab0b4246654 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("iIlWE")).then(({ PlanDependenciesReportWithoutPageHeader: PlanDependenciesReportWithoutPageHeader })=>PlanDependenciesReportWithoutPageHeader)), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-dependencies-report/index-old.tsx"
});
const $39df6cea3ba994f5$export$4ece7fb6c15037f9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $39df6cea3ba994f5$export$48681ab0b4246654,
        pageId: "plan-dependencies-report-embed-old",
        shouldShowSpinner: true
    });

const $39df6cea3ba994f5$export$51f2083dff1ee684 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("1WeVM")).then(({ PlanIncrementWithoutPageHeader: PlanIncrementWithoutPageHeader })=>PlanIncrementWithoutPageHeader)), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-increment/index-old.tsx"
});
const $39df6cea3ba994f5$export$a2ae011b90c17927 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $39df6cea3ba994f5$export$51f2083dff1ee684,
        pageId: "plan-increment-embed-old",
        shouldShowSpinner: true
    });

});
parcelRegister("irZA1", function(module, exports) {

let $d6ea841ee58a5501$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $d6ea841ee58a5501$var$load("ffQaD"),
    $d6ea841ee58a5501$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("603yk"), 4)),
    $d6ea841ee58a5501$var$load("bDfzP")
]).then(()=>parcelRequire('3Wpua'));

});

parcelRegister("iIlWE", function(module, exports) {

let $d9fd5be07de2d772$var$load = (parcelRequire("28QjX"))(4);





module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $d9fd5be07de2d772$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $d9fd5be07de2d772$var$load("k6g9p")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $d9fd5be07de2d772$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $d9fd5be07de2d772$var$load("7B2gt")
        ]);
    }),
    $d9fd5be07de2d772$var$load("ffQaD"),
    $d9fd5be07de2d772$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("4eYMq"), 4)),
    $d9fd5be07de2d772$var$load("76n7a"),
    $d9fd5be07de2d772$var$load("l253H"),
    $d9fd5be07de2d772$var$load("fliVL"),
    $d9fd5be07de2d772$var$load("9ECEW")
]).then(()=>parcelRequire('kTf8P'));

});

parcelRegister("1WeVM", function(module, exports) {

let $1696ca33ddc38154$var$load = (parcelRequire("28QjX"))(4);






module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $1696ca33ddc38154$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $1696ca33ddc38154$var$load("k6g9p")
        ]);
    }),
    (parcelRequire("avM1e"))('jirt-convert-class-to-functional-component', function() {
        return Promise.all([
            $1696ca33ddc38154$var$load("1ls92")
        ]);
    }, function() {
        return Promise.all([
            $1696ca33ddc38154$var$load("kLeYK")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $1696ca33ddc38154$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $1696ca33ddc38154$var$load("7B2gt")
        ]);
    }),
    $1696ca33ddc38154$var$load("kNFvF"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("hzlTj"), 4)),
    $1696ca33ddc38154$var$load("ffQaD"),
    $1696ca33ddc38154$var$load("kvRbA"),
    $1696ca33ddc38154$var$load("76n7a"),
    $1696ca33ddc38154$var$load("l253H"),
    $1696ca33ddc38154$var$load("fliVL"),
    $1696ca33ddc38154$var$load("65L5Z")
]).then(()=>parcelRequire('fgv4D'));

});



parcelRegister("2DH60", function(module, exports) {

$parcel$export(module.exports, "arjIncrementEmbedRouteEntry", () => $ddc531e0f3e9c8bc$export$3feed0b4da010c52);

var $cSD7y = parcelRequire("cSD7y");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $2Ql51 = parcelRequire("2Ql51");

var $ddtN3 = parcelRequire("ddtN3");

var $5lsNZ = parcelRequire("5lsNZ");

var $4R6GH = parcelRequire("4R6GH");

var $lkFvK = parcelRequire("lkFvK");

var $8tlKP = parcelRequire("8tlKP");

var $k7MTs = parcelRequire("k7MTs");
const $ddc531e0f3e9c8bc$var$planProgramEmbedRouteEntry = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $8tlKP.planIncrementEntryPoint)
});
const $ddc531e0f3e9c8bc$export$3feed0b4da010c52 = (0, $7NszV.createEntry)((0, $ddtN3.arjIncrementEmbedRoute), ()=>({
        group: 'software',
        component: (0, $cSD7y.componentWithFG)('smart_links_for_plans', (0, $k7MTs.PlanIncrementEmbedPage), (0, $5lsNZ.default)),
        entryPoint: ()=>(0, $4R6GH.fg)('migrate_plans_to_entrypoints') ? $ddc531e0f3e9c8bc$var$planProgramEmbedRouteEntry : undefined,
        layout: (0, $aPfsS.createLayout)({
            isChromeless: true
        }),
        resources: [
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource),
            (0, $2Ql51.themePreferenceResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        forPaint: [
            (0, $k7MTs.LazyPlanIncrementEmbed)
        ]
    }));

});
parcelRegister("ddtN3", function(module, exports) {

$parcel$export(module.exports, "arjIncrementEmbedRoute", () => $0b961407c2693247$export$88913ef2dfa37bc1);
const $0b961407c2693247$export$88913ef2dfa37bc1 = {
    name: 'software-plan-increment-embed',
    path: '/jira/plans/:planId/scenarios/:scenarioId/program/:incrementId/embed'
};

});

parcelRegister("8tlKP", function(module, exports) {

$parcel$export(module.exports, "planIncrementEntryPoint", () => $fe259e4b6c6f1cb0$export$72cc8a7d91a08ace);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $fe259e4b6c6f1cb0$export$72cc8a7d91a08ace = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("gYoK8")), {
        moduleId: "6d0a9b0d",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("gYoK8", function(module, exports) {

let $c5b5716c35715c95$var$load = (parcelRequire("28QjX"))(4);






module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $c5b5716c35715c95$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $c5b5716c35715c95$var$load("k6g9p")
        ]);
    }),
    (parcelRequire("avM1e"))('jirt-convert-class-to-functional-component', function() {
        return Promise.all([
            $c5b5716c35715c95$var$load("1ls92")
        ]);
    }, function() {
        return Promise.all([
            $c5b5716c35715c95$var$load("kLeYK")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $c5b5716c35715c95$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $c5b5716c35715c95$var$load("7B2gt")
        ]);
    }),
    $c5b5716c35715c95$var$load("kNFvF"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("7XSFG"), 4)),
    $c5b5716c35715c95$var$load("ffQaD"),
    $c5b5716c35715c95$var$load("kvRbA"),
    $c5b5716c35715c95$var$load("76n7a"),
    $c5b5716c35715c95$var$load("l253H"),
    $c5b5716c35715c95$var$load("fliVL"),
    $c5b5716c35715c95$var$load("7nF5c")
]).then(()=>parcelRequire('f3Kyg'));

});



parcelRegister("7gypr", function(module, exports) {

$parcel$export(module.exports, "arjSettingsDependenciesLegacyRedirectRouteEntry", () => $3678ca52b1bdf235$export$804f2d81dfbdd5c9);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3DNgf = parcelRequire("3DNgf");

var $3RJkv = parcelRequire("3RJkv");

var $6i7U6 = parcelRequire("6i7U6");

var $a9hcp = parcelRequire("a9hcp");

var $i8IhR = parcelRequire("i8IhR");
const $3678ca52b1bdf235$export$804f2d81dfbdd5c9 = (0, $7NszV.createEntry)((0, $6i7U6.arjSettingsDependenciesLegacyRedirectRoute), ()=>({
        group: 'software',
        component: (0, $i8IhR.redirectTo)('/jira/plans/settings/dependencies'),
        isRedirect: true,
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $3DNgf.issueLinkInformationResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a9hcp.LazyArjSettingsDependencies)
        ]
    }));

});
parcelRegister("3DNgf", function(module, exports) {

$parcel$export(module.exports, "issueLinkInformationResource", () => $8163e55c16e335dc$export$8d8544ca08d98837);

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");
const $8163e55c16e335dc$var$body = {
    providers: [
        'issueLinks',
        'dependencySettings'
    ]
};
const $8163e55c16e335dc$var$url = '/rest/jpo/1.0/info/query';
const $8163e55c16e335dc$var$fetchIssueLinkInformation = ()=>(0, $eusud.performPostRequest)($8163e55c16e335dc$var$url, {
        body: JSON.stringify($8163e55c16e335dc$var$body)
    });
const $8163e55c16e335dc$export$8d8544ca08d98837 = (0, $2M1hQ.createResource)({
    type: 'ISSUE_LINK_INFORMATION',
    getKey: ()=>'issue-link-information',
    getData: async ()=>$8163e55c16e335dc$var$fetchIssueLinkInformation(),
    maxAge: 0
});

});

parcelRegister("6i7U6", function(module, exports) {

$parcel$export(module.exports, "arjSettingsDependenciesLegacyRedirectRoute", () => $461a54dd9cfd2345$export$f96bfb0a2b0ad0f4);
const $461a54dd9cfd2345$export$f96bfb0a2b0ad0f4 = {
    name: 'arj-settings-dependencies-redirect',
    path: '/secure/PortfolioDependencySettings.jspa'
};

});

parcelRegister("a9hcp", function(module, exports) {

$parcel$export(module.exports, "LazyArjSettingsDependencies", () => $8f893c79e2990b05$export$4fcc3c0f6e792efc);
$parcel$export(module.exports, "ArjSettingsDependencies", () => $8f893c79e2990b05$export$d6f045c7c1aaff50);
$parcel$export(module.exports, "LazyArjSettingsLoadingLimits", () => $8f893c79e2990b05$export$64761ea1912fdcd9);
$parcel$export(module.exports, "ArjSettingsLoadingLimits", () => $8f893c79e2990b05$export$7bb4c0f22b467385);
$parcel$export(module.exports, "LazyArjSettingsPermissions", () => $8f893c79e2990b05$export$edb4ae7e85c7908d);
$parcel$export(module.exports, "ArjSettingsPermissions", () => $8f893c79e2990b05$export$fa852ea42b98d3de);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $8f893c79e2990b05$export$4fcc3c0f6e792efc = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("clW64"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/dependencies/index.tsx"
});
const $8f893c79e2990b05$export$d6f045c7c1aaff50 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8f893c79e2990b05$export$4fcc3c0f6e792efc,
        pageId: "arj-settings-dependencies",
        shouldShowSpinner: true
    });

const $8f893c79e2990b05$export$64761ea1912fdcd9 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("lUhjW"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/loading-limits/index.tsx"
});
const $8f893c79e2990b05$export$7bb4c0f22b467385 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8f893c79e2990b05$export$64761ea1912fdcd9,
        pageId: "arj-settings-loading-limits",
        shouldShowSpinner: true
    });

const $8f893c79e2990b05$export$edb4ae7e85c7908d = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("lrggS"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/permissions/index.tsx"
});
const $8f893c79e2990b05$export$fa852ea42b98d3de = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8f893c79e2990b05$export$edb4ae7e85c7908d,
        pageId: "arj-settings-permissions",
        shouldShowSpinner: true
    });

});
parcelRegister("clW64", function(module, exports) {

let $8fe48307b43daa98$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8fe48307b43daa98$var$load("4fVgK").then(()=>parcelRequire('1Ba8D'));

});

parcelRegister("lUhjW", function(module, exports) {

let $ff2c43795f2e9c53$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("egMUS"), 4)),
    $ff2c43795f2e9c53$var$load("adoLY")
]).then(()=>parcelRequire('ieFCi'));

});

parcelRegister("lrggS", function(module, exports) {

let $f9b8bdb52f210df3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f9b8bdb52f210df3$var$load("izFXj").then(()=>parcelRequire('luimD'));

});


parcelRegister("i8IhR", function(module, exports) {

$parcel$export(module.exports, "redirectTo", () => $cf0b6f0a8f874806$export$2d47ce6f15e624e5);

var $5uXOq = parcelRequire("5uXOq");

var $ds5qV = parcelRequire("ds5qV");
const $cf0b6f0a8f874806$export$2d47ce6f15e624e5 = (redirectUrl)=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
            to: redirectUrl
        });

});
parcelRegister("ds5qV", function(module, exports) {

$parcel$export(module.exports, "ScreenRedirect", () => $7599a608c0c710a3$export$fdd3e60cd227c2f7);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $bVDE5 = parcelRequire("bVDE5");

var $7tQej = parcelRequire("7tQej");
var $doZTA = parcelRequire("doZTA");
const $7599a608c0c710a3$export$fdd3e60cd227c2f7 = ({ to: to, persistSearchParams: persistSearchParams = true })=>{
    const [{ route: route, location: location, query: query }] = (0, $doZTA.useRouter)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ isInitialRender: isInitial }] = (0, $bVDE5.useSpaStateTransition)();
    const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
    (0, $5uXOq.useEffect)(()=>{
        if (!route || !eventRef.current) return;
        (0, $8zOmE.fireUIAnalytics)(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        route,
        isInitial
    ]);
    if (Array.isArray(persistSearchParams)) {
        const persistParams = Object.keys(query) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((result, currentKey)=>{
            const shouldPersist = persistSearchParams.some((persistKey)=>currentKey.includes(persistKey));
            if (shouldPersist) result.push(`${currentKey}=${query[currentKey]}`);
            return result;
        }, []).join('&');
        if (persistParams !== '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: `${to}?${persistParams}`
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: to
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `${to}${persistSearchParams ? location.search : ''}`
    });
};

});
parcelRegister("bVDE5", function(module, exports) {

$parcel$export(module.exports, "useSpaStateTransition", () => $1f866bb77da3c907$export$4d1974344641a2c9);
$parcel$export(module.exports, "default", () => $1f866bb77da3c907$export$2e2bcd8739ae039);

var $6RCeq = parcelRequire("6RCeq");

var $3sQ5x = parcelRequire("3sQ5x");
var $51nlc = parcelRequire("51nlc");

var $7w9eZ = parcelRequire("7w9eZ");
const $1f866bb77da3c907$var$getNavigationStart = ()=>{
    // @ts-expect-error - TS2339 - Property 'timing' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'. | TS2339 - Property 'timing' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'.
    const timestamp = (0, $6RCeq.default) && (0, $6RCeq.default).timing && (0, $6RCeq.default).timing.navigationStart;
    return timestamp ? new Date(timestamp).toISOString() : undefined;
};
const $1f866bb77da3c907$var$getLastTransition = (currentPage, visitedPages)=>{
    if (visitedPages.length === 0) return undefined;
    const collectAppNames = (page)=>Object.keys(page.apps || {}).sort();
    const appNamesToStr = (appNames)=>appNames.join('+') || '?';
    const prevPage = appNamesToStr(collectAppNames(visitedPages.slice(-1)[0]));
    const currPage = appNamesToStr(collectAppNames(currentPage));
    return `${prevPage} > ${currPage}`;
};
const $1f866bb77da3c907$var$getLastTransitionStartTime = (currentPage, visitedPages)=>{
    // If there are no previously visited pages the transition didn't have a place
    if (visitedPages.length === 0) return undefined;
    return currentPage.startTime;
};
const $1f866bb77da3c907$export$aea217a45095ce11 = ({ visitedPages: visitedPages, currentPage: currentPage })=>({
        isInitialRender: visitedPages.length === 0,
        transitionsCount: visitedPages.length,
        lastTransition: $1f866bb77da3c907$var$getLastTransition(currentPage, visitedPages),
        lastTransitionStartTime: $1f866bb77da3c907$var$getLastTransitionStartTime(currentPage, visitedPages),
        navigationStart: $1f866bb77da3c907$var$getNavigationStart(),
        currentPageId: currentPage.uuid
    });
// @ts-expect-error - TS2322 - Type 'SubscriberComponent<TransitionState, BoundActions<State, typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/controllers/spa-state/src/actions/index")>, Record<...>>' is not assignable to type 'Subscriber'.
const $1f866bb77da3c907$var$SpaStateTransitionStateSubscriber = (0, $51nlc.createSubscriber)((0, $7w9eZ.default), {
    displayName: 'SpaStateTransitionStateSubscriber',
    selector: $1f866bb77da3c907$export$aea217a45095ce11
});
const $1f866bb77da3c907$export$4d1974344641a2c9 = (0, $3sQ5x.createHook)((0, $7w9eZ.default), {
    selector: $1f866bb77da3c907$export$aea217a45095ce11
});
var $1f866bb77da3c907$export$2e2bcd8739ae039 = $1f866bb77da3c907$var$SpaStateTransitionStateSubscriber;

});




parcelRegister("cwKGx", function(module, exports) {

$parcel$export(module.exports, "arjSettingsDependenciesRouteEntry", () => $98e5774d92d39cbd$export$70386609aff5ba12);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3DNgf = parcelRequire("3DNgf");

var $3RJkv = parcelRequire("3RJkv");

var $3NV88 = parcelRequire("3NV88");

var $a9hcp = parcelRequire("a9hcp");
const $98e5774d92d39cbd$export$70386609aff5ba12 = (0, $7NszV.createEntry)((0, $3NV88.arjSettingsDependenciesRoute), ()=>({
        group: 'software',
        component: (0, $a9hcp.ArjSettingsDependencies),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $3DNgf.issueLinkInformationResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a9hcp.LazyArjSettingsDependencies)
        ]
    }));

});
parcelRegister("3NV88", function(module, exports) {

$parcel$export(module.exports, "arjSettingsDependenciesRoute", () => $2117b55ed774a2be$export$ff9b90f9d680e34);
const $2117b55ed774a2be$export$ff9b90f9d680e34 = {
    name: 'arj-settings-dependencies',
    path: '/jira/plans/settings/dependencies'
};

});


parcelRegister("jZMnM", function(module, exports) {

$parcel$export(module.exports, "arjSettingsFinancialYearPageRouteEntry", () => $a36cb3f650c3074c$export$b6bba25826e621b9);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $7j3uW = parcelRequire("7j3uW");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $avmE3 = parcelRequire("avmE3");

var $Jhp2x = parcelRequire("Jhp2x");
const $a36cb3f650c3074c$export$b6bba25826e621b9 = (0, $7NszV.createEntry)((0, $avmE3.arjSettingsFinancialYearPageRoute), ()=>({
        group: 'software',
        component: (0, $Jhp2x.ArjSettingsFinancialYear),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $7j3uW.arjSettingsFinancialYearResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $Jhp2x.LazyArjSettingsFinancialYear)
        ]
    }));

});
parcelRegister("7j3uW", function(module, exports) {

$parcel$export(module.exports, "arjSettingsFinancialYearResource", () => $59a235170c0d382a$export$da45020eede4a793);

var $7f4tk = parcelRequire("7f4tk");

var $2M1hQ = parcelRequire("2M1hQ");

const $59a235170c0d382a$export$da45020eede4a793 = (0, $2M1hQ.createResource)({
    type: (0, $b242b5aa0787944c$export$e8e0384e95388aa3),
    getKey: ()=>'financial-year-information',
    getData: async ()=>(0, $7f4tk.default)('/rest/jpo/1.0/fiscalYear'),
    maxAge: 0
});

});
const $b242b5aa0787944c$export$e8e0384e95388aa3 = 'RESOURCE_TYPE_ARJ_SETTINGS_FINANCIAL_YEAR';


parcelRegister("avmE3", function(module, exports) {

$parcel$export(module.exports, "arjSettingsFinancialYearPageRoute", () => $7565a345f1dea2b4$export$7208300f00a36a5f);
const $7565a345f1dea2b4$export$7208300f00a36a5f = {
    name: 'arj-settings-financial-year',
    path: '/jira/plans/settings/financial-year',
    exact: true
};

});

parcelRegister("Jhp2x", function(module, exports) {

$parcel$export(module.exports, "LazyArjSettingsFinancialYear", () => $b5d39848dc9e7ba6$export$dd67c2f01a58231e);
$parcel$export(module.exports, "ArjSettingsFinancialYear", () => $b5d39848dc9e7ba6$export$785180185eba7ed9);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $b5d39848dc9e7ba6$export$dd67c2f01a58231e = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("f12PB")).then((module)=>module.ArjSettingsFinancialYear)), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/financial-year/index.tsx"
});
const $b5d39848dc9e7ba6$export$785180185eba7ed9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $b5d39848dc9e7ba6$export$dd67c2f01a58231e,
        pageId: "arj-settings-financial-year",
        shouldShowSpinner: true
    });

});
parcelRegister("f12PB", function(module, exports) {

let $aee92543390ff07d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $aee92543390ff07d$var$load("fFgLm").then(()=>parcelRequire('7bDNN'));

});



parcelRegister("dfdSu", function(module, exports) {

$parcel$export(module.exports, "arjSettingsLoadingLimitsLegacyRedirectRouteEntry", () => $99f00cddc0758136$export$9f80102c0f64ad9b);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $44HQw = parcelRequire("44HQw");

var $a9hcp = parcelRequire("a9hcp");

var $i8IhR = parcelRequire("i8IhR");
const $99f00cddc0758136$export$9f80102c0f64ad9b = (0, $7NszV.createEntry)((0, $44HQw.arjSettingsLoadingLimitsLegacyRedirectRoute), ()=>({
        group: 'software',
        component: (0, $i8IhR.redirectTo)('/jira/plans/settings/loading-limits'),
        isRedirect: true,
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a9hcp.LazyArjSettingsLoadingLimits)
        ]
    }));

});
parcelRegister("44HQw", function(module, exports) {

$parcel$export(module.exports, "arjSettingsLoadingLimitsLegacyRedirectRoute", () => $abfe17fb063fcb4e$export$7c71e235d628daf5);
const $abfe17fb063fcb4e$export$7c71e235d628daf5 = {
    name: 'arj-settings-loading-limits-redirect',
    path: '/secure/PortfolioLoadingLimits.jspa'
};

});


parcelRegister("ieqGd", function(module, exports) {

$parcel$export(module.exports, "arjSettingsLoadingLimitsRouteEntry", () => $f2c5f02fe8472718$export$6786257309f86d8c);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $azWKH = parcelRequire("azWKH");

var $3RJkv = parcelRequire("3RJkv");

var $hTLqB = parcelRequire("hTLqB");

var $a9hcp = parcelRequire("a9hcp");
const $f2c5f02fe8472718$export$6786257309f86d8c = (0, $7NszV.createEntry)((0, $hTLqB.arjSettingsLoadingLimitsRoute), ()=>({
        group: 'software',
        component: (0, $a9hcp.ArjSettingsLoadingLimits),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $azWKH.arjSettingsLoadingLimitsResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a9hcp.LazyArjSettingsLoadingLimits)
        ]
    }));

});
parcelRegister("azWKH", function(module, exports) {

$parcel$export(module.exports, "arjSettingsLoadingLimitsResource", () => $a9399ce8867d02dc$export$c9e47fa9b57975f5);

var $7f4tk = parcelRequire("7f4tk");

var $2M1hQ = parcelRequire("2M1hQ");

const $a9399ce8867d02dc$export$c9e47fa9b57975f5 = (0, $2M1hQ.createResource)({
    type: (0, $a9d74ae4a12ce55b$export$cd7bb91dd2e30684),
    getKey: ()=>'loading-limits-information',
    getData: async ()=>(0, $7f4tk.default)('/rest/jpo/1.0/configuration'),
    maxAge: 0
});

});
const $a9d74ae4a12ce55b$export$cd7bb91dd2e30684 = 'RESOURCE_TYPE_ARJ_SETTINGS_LOADING_LIMITS';


parcelRegister("hTLqB", function(module, exports) {

$parcel$export(module.exports, "arjSettingsLoadingLimitsRoute", () => $46a780a2a2e80d5e$export$f90dc3a45fadc1e2);
const $46a780a2a2e80d5e$export$f90dc3a45fadc1e2 = {
    name: 'arj-settings-loading-limits',
    path: '/jira/plans/settings/loading-limits'
};

});


parcelRegister("JQ5Vt", function(module, exports) {

$parcel$export(module.exports, "arjSettingsPermissionsRouteEntry", () => $c52f49db3f216f46$export$4e97658a5cc15eaa);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $1aR84 = parcelRequire("1aR84");

var $3RJkv = parcelRequire("3RJkv");

var $a8ttb = parcelRequire("a8ttb");

var $a9hcp = parcelRequire("a9hcp");
const $c52f49db3f216f46$export$4e97658a5cc15eaa = (0, $7NszV.createEntry)((0, $a8ttb.arjSettingsPermissionsRoute), ()=>({
        group: 'software',
        component: (0, $a9hcp.ArjSettingsPermissions),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $1aR84.getGlobalPermissionPageResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a9hcp.LazyArjSettingsPermissions)
        ]
    }));

});
parcelRegister("1aR84", function(module, exports) {

$parcel$export(module.exports, "grantedPermissionsResource", () => $d675e556a71c706a$export$aa3daf3280e2a2d7);
$parcel$export(module.exports, "permissionGroupsResource", () => $d675e556a71c706a$export$950060d83722e3bd);
$parcel$export(module.exports, "getGlobalPermissionPageResources", () => $d675e556a71c706a$export$a09a91246a866817);

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");
const $d675e556a71c706a$var$fetchGrantedPermissions = ()=>(0, $eusud.performPostRequest)('/rest/roadmaps/1.0/info/query', {
        body: JSON.stringify({
            providers: [
                'permissions'
            ]
        })
    });
const $d675e556a71c706a$var$fetchPermissionGroups = ()=>(0, $eusud.performPostRequest)('/rest/jpo/1.0/groupsandusers', {
        body: JSON.stringify({
            includeUsers: false,
            excludedGroups: [],
            excludedUsers: [],
            query: ''
        })
    });
const $d675e556a71c706a$export$aa3daf3280e2a2d7 = (0, $2M1hQ.createResource)({
    type: 'ARJ_GLOBAL_PERMISSIONS_GRANTED',
    getKey: ()=>'arj-granted-permissions',
    getData: async ()=>$d675e556a71c706a$var$fetchGrantedPermissions(),
    maxAge: 0
});
const $d675e556a71c706a$export$950060d83722e3bd = (0, $2M1hQ.createResource)({
    type: 'ARJ_GLOBAL_PERMISSIONS_GROUPS',
    getKey: ()=>'arj-permission-groups',
    getData: async ()=>$d675e556a71c706a$var$fetchPermissionGroups(),
    maxAge: 0
});
const $d675e556a71c706a$export$a09a91246a866817 = ()=>[
        $d675e556a71c706a$export$aa3daf3280e2a2d7,
        $d675e556a71c706a$export$950060d83722e3bd
    ];

});

parcelRegister("a8ttb", function(module, exports) {

$parcel$export(module.exports, "arjSettingsPermissionsRoute", () => $b264455695405ab2$export$4501213a8b1d3a10);
const $b264455695405ab2$export$4501213a8b1d3a10 = {
    name: 'arj-settings-permissions',
    path: '/jira/plans/settings/permissions'
};

});


parcelRegister("eOPb5", function(module, exports) {

$parcel$export(module.exports, "arjSettingsPermissionsRouteLegacyRedirectRouteEntry", () => $75e3fe7119ee0518$export$949c8177281fcc39);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $1aR84 = parcelRequire("1aR84");

var $3RJkv = parcelRequire("3RJkv");

var $dl4rj = parcelRequire("dl4rj");

var $a9hcp = parcelRequire("a9hcp");

var $i8IhR = parcelRequire("i8IhR");
const $75e3fe7119ee0518$export$949c8177281fcc39 = (0, $7NszV.createEntry)((0, $dl4rj.arjSettingsPermissionsRouteLegacyRedirectRoute), ()=>({
        group: 'software',
        component: (0, $i8IhR.redirectTo)('/jira/plans/settings/permissions'),
        isRedirect: true,
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $1aR84.getGlobalPermissionPageResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a9hcp.LazyArjSettingsPermissions)
        ]
    }));

});
parcelRegister("dl4rj", function(module, exports) {

$parcel$export(module.exports, "arjSettingsPermissionsRouteLegacyRedirectRoute", () => $a53440ab81155fb2$export$24bf73f2d1dbf0db);
const $a53440ab81155fb2$export$24bf73f2d1dbf0db = {
    name: 'arj-settings-permissions-redirect',
    path: '/secure/PortfolioPermissions.jspa'
};

});


parcelRegister("a5XVU", function(module, exports) {

$parcel$export(module.exports, "arjSummaryEmbedRouteEntry", () => $6fb04257162ebb90$export$bdc2c75e02c29d7);

var $cSD7y = parcelRequire("cSD7y");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $lv9xW = parcelRequire("lv9xW");

var $3RJkv = parcelRequire("3RJkv");

var $2Ql51 = parcelRequire("2Ql51");

var $7BjJ7 = parcelRequire("7BjJ7");

var $5lsNZ = parcelRequire("5lsNZ");

var $4R6GH = parcelRequire("4R6GH");

var $lkFvK = parcelRequire("lkFvK");

var $739vE = parcelRequire("739vE");

var $k7MTs = parcelRequire("k7MTs");
const $6fb04257162ebb90$var$planSummaryEmbedRouteEntry = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $739vE.planSummaryEntryPoint)
});
const $6fb04257162ebb90$export$bdc2c75e02c29d7 = (0, $7NszV.createEntry)((0, $7BjJ7.arjSummaryEmbedRoute), ()=>({
        group: 'software',
        component: (0, $cSD7y.componentWithFG)('smart_links_for_plans', (0, $k7MTs.PlanSummaryEmbedPage), (0, $5lsNZ.default)),
        entryPoint: ()=>(0, $4R6GH.fg)('migrate_plans_to_entrypoints') ? $6fb04257162ebb90$var$planSummaryEmbedRouteEntry : undefined,
        layout: (0, $aPfsS.createLayout)({
            isChromeless: true
        }),
        resources: [
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $lv9xW.advancedRoadmapsSummaryDataResource),
            (0, $2Ql51.themePreferenceResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        forPaint: [
            (0, $k7MTs.LazyPlanSummaryEmbed)
        ]
    }));

});
parcelRegister("lv9xW", function(module, exports) {

$parcel$export(module.exports, "advancedRoadmapsSummaryDataResource", () => $f87ae7e2901ac155$export$f9061628830b5175);
$parcel$export(module.exports, "fetchAdvancedRoadmapsSummaryData", () => $f87ae7e2901ac155$export$2dfe99460dae6bc6);

var $4R6GH = parcelRequire("4R6GH");

var $7f4tk = parcelRequire("7f4tk");

var $2M1hQ = parcelRequire("2M1hQ");

var $5m5rT = parcelRequire("5m5rT");

var $iz4dr = parcelRequire("iz4dr");
// we have to use location.search as we want to get params dynamically and rrr doesn't support it
// more info: https://atlassian-labs.github.io/react-resource-router/#/resources/usage?id=accessing-resource-state-for-another-route-or-url
const $f87ae7e2901ac155$var$getQueryParams = (routerQuery)=>{
    if (typeof window !== 'undefined') return Object.fromEntries(new URLSearchParams(window.location.search));
    return routerQuery;
};
const $f87ae7e2901ac155$export$f9061628830b5175 = (0, $2M1hQ.createResource)({
    type: 'ADVANCED_ROADMAPS_SUMMARY_DATA',
    getKey: ({ match: match })=>{
        const { params: params } = match;
        if (params.planId != null && params.scenarioId != null) return `${params.planId}:${params.scenarioId}`;
        // Just return fallback string if on a page that doesn't have a planId or scenarioId
        return 'none';
    },
    getData: async ({ match: match, query: query })=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (window.__ARJ_SUMMARY_PAGE_PROMISE__) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const response = window.__ARJ_SUMMARY_PAGE_PROMISE__;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.__ARJ_SUMMARY_PAGE_PROMISE__ = null;
            return response;
        }
        const { params: params } = match;
        return $f87ae7e2901ac155$export$2dfe99460dae6bc6(params, query, (0, $5m5rT.AVAILABLE_CHARTS));
    },
    maxAge: Infinity,
    isBrowserOnly: true
});
const $f87ae7e2901ac155$export$2dfe99460dae6bc6 = async (params, query, chartTypes)=>{
    if (params.planId == null) throw new Error('Unable to get fetch data for ADVANCED_ROADMAPS_SUMMARY_DATA. planId is not defined');
    if ((0, $4R6GH.fg)('smart_links_for_plans')) {
        const dateRange = (0, $iz4dr.validateDateRange)((0, $iz4dr.parseDateRange)($f87ae7e2901ac155$var$getQueryParams(query)));
        const data = await (0, $7f4tk.default)('/rest/jpo/1.0/summary/data', {
            method: 'POST',
            body: JSON.stringify({
                planId: params.planId,
                scenarioId: params.scenarioId,
                chartTypes: chartTypes,
                ...dateRange ? {
                    dateRange: dateRange
                } : {}
            })
        });
        return dateRange ? {
            ...data,
            customDateRange: dateRange
        } : data;
    }
    const { startDate: startDate, endDate: endDate } = $f87ae7e2901ac155$var$getQueryParams(query);
    const customDateRangeParams = startDate && endDate ? {
        startDate: startDate,
        endDate: endDate
    } : {};
    const data = await (0, $7f4tk.default)('/rest/jpo/1.0/summary/data', {
        method: 'POST',
        body: JSON.stringify({
            planId: params.planId,
            scenarioId: params.scenarioId,
            chartTypes: chartTypes,
            ...customDateRangeParams
        })
    });
    return data;
};

});
parcelRegister("5m5rT", function(module, exports) {

$parcel$export(module.exports, "CHART_TYPES", () => $d315f648a94f47c0$export$3251435144ca69e2);
$parcel$export(module.exports, "AVAILABLE_CHARTS", () => $d315f648a94f47c0$export$79cf9c14f738d70b);
$parcel$export(module.exports, "SCHEDULING_MODES", () => $d315f648a94f47c0$export$92daf59e30346cd2);
$parcel$export(module.exports, "CAPACITY_UNIT", () => $d315f648a94f47c0$export$494e761f17fc60a9);
$parcel$export(module.exports, "SPRINT_STATE", () => $d315f648a94f47c0$export$38e437924c2adbda);
const $d315f648a94f47c0$export$3251435144ca69e2 = {
    statusCategory: 'STATUS_CATEGORY',
    issueProgress: 'ISSUE_PROGRESS',
    teamProgress: 'TEAM_PROGRESS',
    teamCapacity: 'TEAM_CAPACITY',
    blockers: 'BLOCKERS',
    highestPriority: 'HIGHEST_PRIORITY',
    unassignedIssues: 'UNASSIGNED_ISSUES',
    overlappingBlockers: 'OVERLAPPING_BLOCKERS',
    overdue: 'OVERDUE'
};
const $d315f648a94f47c0$export$79cf9c14f738d70b = [
    $d315f648a94f47c0$export$3251435144ca69e2.statusCategory,
    $d315f648a94f47c0$export$3251435144ca69e2.issueProgress,
    $d315f648a94f47c0$export$3251435144ca69e2.teamProgress,
    $d315f648a94f47c0$export$3251435144ca69e2.teamCapacity,
    $d315f648a94f47c0$export$3251435144ca69e2.blockers,
    $d315f648a94f47c0$export$3251435144ca69e2.highestPriority,
    $d315f648a94f47c0$export$3251435144ca69e2.unassignedIssues,
    $d315f648a94f47c0$export$3251435144ca69e2.overlappingBlockers,
    $d315f648a94f47c0$export$3251435144ca69e2.overdue
];
const $d315f648a94f47c0$export$92daf59e30346cd2 = {
    SCRUM: 'Scrum',
    KANBAN: 'Kanban'
};
const $d315f648a94f47c0$export$494e761f17fc60a9 = {
    HOURS: 'HOURS',
    POINTS: 'STORY_POINTS',
    DAYS: 'DAYS'
};
const $d315f648a94f47c0$export$38e437924c2adbda = {
    CLOSED: 'CLOSED',
    ACTIVE: 'ACTIVE',
    FUTURE: 'FUTURE'
};

});

parcelRegister("iz4dr", function(module, exports) {

$parcel$export(module.exports, "parseDateRange", () => $8d575024c745c5c9$export$1cd7060bc72a318c);
$parcel$export(module.exports, "validateDateRange", () => $8d575024c745c5c9$export$b3e10550232e39db);
/**
 * Most of the code here is duplicated from `@atlassian/portfolio-3-summary-page`. We do not want to depend on all
 * the code from that package, but we want to parse and validate the date range before sending to the backend.
 */ 
var $gZ6zR = parcelRequire("gZ6zR");
const $8d575024c745c5c9$export$637d8b0948b783c7 = {
    [(0, $gZ6zR.DATE_UNITS).DAYS]: 3650,
    [(0, $gZ6zR.DATE_UNITS).WEEKS]: 520,
    [(0, $gZ6zR.DATE_UNITS).MONTHS]: 120
};
const $8d575024c745c5c9$export$cf70eebe96d0cb07 = (type)=>{
    switch(type){
        case (0, $gZ6zR.CUSTOM_TIME_RANGE_TYPES).FIXED:
        case (0, $gZ6zR.CUSTOM_TIME_RANGE_TYPES).RELATIVE:
            return type;
        default:
            return undefined;
    }
};
const $8d575024c745c5c9$export$6bf0e8cf8e1d780d = (value)=>{
    if (value === undefined) return undefined;
    const parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? undefined : parsed;
};
const $8d575024c745c5c9$export$c777dd44ece05114 = (unit)=>{
    switch(unit){
        case (0, $gZ6zR.DATE_UNITS).DAYS:
        case (0, $gZ6zR.DATE_UNITS).WEEKS:
        case (0, $gZ6zR.DATE_UNITS).MONTHS:
            return unit;
        default:
            return undefined;
    }
};
const $8d575024c745c5c9$export$1cd7060bc72a318c = (query)=>{
    const { fromDate: fromDate, toDate: toDate, toNow: toNow, fromNow: fromNow, toNowUnit: toNowUnit, fromNowUnit: fromNowUnit, dateRangeType: dateRangeType } = query;
    return {
        typeOfCustomDateRange: $8d575024c745c5c9$export$cf70eebe96d0cb07(dateRangeType),
        fromDate: $8d575024c745c5c9$export$6bf0e8cf8e1d780d(fromDate),
        toDate: $8d575024c745c5c9$export$6bf0e8cf8e1d780d(toDate),
        fromNowUnitCount: $8d575024c745c5c9$export$6bf0e8cf8e1d780d(fromNow),
        toNowUnitCount: $8d575024c745c5c9$export$6bf0e8cf8e1d780d(toNow),
        fromNowUnit: $8d575024c745c5c9$export$c777dd44ece05114(fromNowUnit),
        toNowUnit: $8d575024c745c5c9$export$c777dd44ece05114(toNowUnit)
    };
};
const $8d575024c745c5c9$export$68346777682e262 = (count, unit)=>{
    if (count === undefined || unit === undefined) return false;
    return count >= 0 && count <= $8d575024c745c5c9$export$637d8b0948b783c7[unit];
};
const $8d575024c745c5c9$export$1ba31c57b50b4374 = (timestamp)=>{
    if (timestamp === undefined) return false;
    const date = new Date(timestamp);
    return !Number.isNaN(date.getTime());
};
const $8d575024c745c5c9$export$b3e10550232e39db = (dateRange)=>{
    const { fromDate: fromDate, toDate: toDate, toNowUnitCount: toNowUnitCount, toNowUnit: toNowUnit, fromNowUnitCount: fromNowUnitCount, fromNowUnit: fromNowUnit, typeOfCustomDateRange: typeOfCustomDateRange } = dateRange;
    if (typeOfCustomDateRange === (0, $gZ6zR.CUSTOM_TIME_RANGE_TYPES).RELATIVE && $8d575024c745c5c9$export$68346777682e262(toNowUnitCount, toNowUnit) && $8d575024c745c5c9$export$68346777682e262(fromNowUnitCount, fromNowUnit)) return {
        toNowUnitCount: toNowUnitCount,
        toNowUnit: toNowUnit,
        fromNowUnitCount: fromNowUnitCount,
        fromNowUnit: fromNowUnit,
        typeOfCustomDateRange: typeOfCustomDateRange
    };
    if (typeOfCustomDateRange === (0, $gZ6zR.CUSTOM_TIME_RANGE_TYPES).FIXED && $8d575024c745c5c9$export$1ba31c57b50b4374(fromDate) && $8d575024c745c5c9$export$1ba31c57b50b4374(toDate)) return {
        fromDate: fromDate,
        toDate: toDate,
        typeOfCustomDateRange: typeOfCustomDateRange
    };
    return undefined;
};

});
parcelRegister("gZ6zR", function(module, exports) {

$parcel$export(module.exports, "CUSTOM_TIME_RANGE_TYPES", () => $ad83cd0410dc011b$export$78e07fecfaf51c7b);
$parcel$export(module.exports, "DATE_UNITS", () => $ad83cd0410dc011b$export$c99d20cdba4a5739);
$parcel$export(module.exports, "IssueStatus", () => $ad83cd0410dc011b$export$559eb15a98685419);
$parcel$export(module.exports, "BlockType", () => $ad83cd0410dc011b$export$48808c686fe495c4);
const $ad83cd0410dc011b$export$78e07fecfaf51c7b = {
    FIXED: 'fixed',
    RELATIVE: 'relative'
};
const $ad83cd0410dc011b$export$c99d20cdba4a5739 = {
    DAYS: 'days',
    MONTHS: 'months',
    WEEKS: 'weeks'
};
const $ad83cd0410dc011b$export$559eb15a98685419 = {
    TODO: 'TODO',
    IN_PROGRESS: 'IN_PROGRESS',
    DONE: 'DONE'
};
const $ad83cd0410dc011b$export$de194318c6dccbc1 = {
    INITIATIVE: 'INITIATIVE',
    EPIC: 'EPIC'
};
const $ad83cd0410dc011b$export$48808c686fe495c4 = {
    DELAY_WORK: 'DELAY_WORK',
    CRITICAL_PATH: 'CRITICAL_PATH',
    BLOCK_WORK: 'BLOCK_WORK'
};

});



parcelRegister("7BjJ7", function(module, exports) {

$parcel$export(module.exports, "arjSummaryEmbedRoute", () => $426fb5656e35864d$export$126053e8fb441b66);
const $426fb5656e35864d$export$126053e8fb441b66 = {
    name: 'software-plan-summary-embed',
    path: '/jira/plans/:planId/scenarios/:scenarioId/summary/embed'
};

});

parcelRegister("739vE", function(module, exports) {

$parcel$export(module.exports, "planSummaryEntryPoint", () => $dd4685bcee1d8b30$export$82d8368ec1a526b);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $dd4685bcee1d8b30$export$82d8368ec1a526b = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("irZA1")), {
        moduleId: "c48db9c0",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});


parcelRegister("lUhpq", function(module, exports) {

$parcel$export(module.exports, "arjTimelineEmbedRouteEntry", () => $f243e346f149e756$export$a977d398db1904ff);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $2Ql51 = parcelRequire("2Ql51");

var $in8iE = parcelRequire("in8iE");

var $5lsNZ = parcelRequire("5lsNZ");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $lkFvK = parcelRequire("lkFvK");

var $4Xa0b = parcelRequire("4Xa0b");
const $f243e346f149e756$var$planTimelineEmbedRouteEntry = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $4Xa0b.planTimelineEntryPoint)
});

// Update to default import when cleaning getWillShowNav4
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f243e346f149e756$var$LazyPlanTimelineEmbed = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("jEWT5")).then(({ PlanTimelineWithoutHeader: PlanTimelineWithoutHeader })=>PlanTimelineWithoutHeader)), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-timeline/index-old.tsx"
});
const $f243e346f149e756$var$PlanTimelineEmbedPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f243e346f149e756$var$LazyPlanTimelineEmbed,
        pageId: "plan-timeline-embed",
        shouldShowSpinner: true
    });
const $f243e346f149e756$export$a977d398db1904ff = (0, $7NszV.createEntry)((0, $in8iE.arjTimelineEmbedRoute), ()=>({
        group: 'software',
        component: (0, $cSD7y.componentWithFG)('smart_links_for_plans', $f243e346f149e756$var$PlanTimelineEmbedPage, (0, $5lsNZ.default)),
        entryPoint: ()=>(0, $4R6GH.fg)('migrate_plans_to_entrypoints') ? $f243e346f149e756$var$planTimelineEmbedRouteEntry : undefined,
        layout: (0, $aPfsS.createLayout)({
            isChromeless: true
        }),
        resources: [
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource),
            (0, $2Ql51.themePreferenceResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        forPaint: [
            $f243e346f149e756$var$LazyPlanTimelineEmbed
        ]
    }));

});
parcelRegister("in8iE", function(module, exports) {

$parcel$export(module.exports, "arjTimelineEmbedRoute", () => $2ec71a69a22a9944$export$aadc28402ef87b84);
const $2ec71a69a22a9944$export$aadc28402ef87b84 = {
    name: 'software-advanced-roadmaps-embed',
    path: '/jira/plans/:planId/scenarios/:scenarioId/timeline/embed'
};

});

parcelRegister("4Xa0b", function(module, exports) {

$parcel$export(module.exports, "planTimelineEntryPoint", () => $dfb41ee95126f54b$export$a36e3fca8afefb5b);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $dfb41ee95126f54b$export$a36e3fca8afefb5b = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("sKzgU")), {
        moduleId: "0b69767e",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("sKzgU", function(module, exports) {

let $0566bd0dda8ac376$var$load = (parcelRequire("28QjX"))(4);





module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $0566bd0dda8ac376$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $0566bd0dda8ac376$var$load("k6g9p")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $0566bd0dda8ac376$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $0566bd0dda8ac376$var$load("7B2gt")
        ]);
    }),
    $0566bd0dda8ac376$var$load("ffQaD"),
    $0566bd0dda8ac376$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("hm7Q6"), 4)),
    $0566bd0dda8ac376$var$load("76n7a"),
    $0566bd0dda8ac376$var$load("l253H"),
    $0566bd0dda8ac376$var$load("fliVL"),
    $0566bd0dda8ac376$var$load("d57pj")
]).then(()=>parcelRequire('iL9n8'));

});


parcelRegister("jEWT5", function(module, exports) {

let $e4ff6e97df0e96d0$var$load = (parcelRequire("28QjX"))(4);





module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $e4ff6e97df0e96d0$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $e4ff6e97df0e96d0$var$load("k6g9p")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $e4ff6e97df0e96d0$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $e4ff6e97df0e96d0$var$load("7B2gt")
        ]);
    }),
    $e4ff6e97df0e96d0$var$load("ffQaD"),
    $e4ff6e97df0e96d0$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("l8ypy"), 4)),
    $e4ff6e97df0e96d0$var$load("76n7a"),
    $e4ff6e97df0e96d0$var$load("l253H"),
    $e4ff6e97df0e96d0$var$load("fliVL"),
    $e4ff6e97df0e96d0$var$load("ia8V8")
]).then(()=>parcelRequire('aT9Sm'));

});


parcelRegister("gktyQ", function(module, exports) {

$parcel$export(module.exports, "assetsConfigurationRouteEntry", () => $fcbf97b2b57b87ef$export$1c86de5db8ff2b58);

var $7NszV = parcelRequire("7NszV");

var $9EXi9 = parcelRequire("9EXi9");

var $e9YVH = parcelRequire("e9YVH");

var $55ZOZ = parcelRequire("55ZOZ");

var $lkFvK = parcelRequire("lkFvK");

var $bdXN2 = parcelRequire("bdXN2");

var $k7I8D = parcelRequire("k7I8D");

var $7iyOx = parcelRequire("7iyOx");

var $kb4zh = parcelRequire("kb4zh");
const $fcbf97b2b57b87ef$var$globalConfigurePageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $bdXN2.assetsGlobalSettingsEntryPoint)
});
const $fcbf97b2b57b87ef$export$1c86de5db8ff2b58 = (0, $7NszV.createEntry)((0, $9EXi9.assetsConfigurationRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $k7I8D.AssetsLayout),
        PageConfigContainerOverride: (0, $7iyOx.AssetsPageConfigContainer),
        skeleton: (0, $kb4zh.default),
        ufoName: 'servicedesk-cmdb-assets-configure',
        entryPoint: ()=>$fcbf97b2b57b87ef$var$globalConfigurePageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-configure',
        resources: (0, $55ZOZ.getAssetsAppResources)(),
        forPaint: [
            (0, $k7I8D.LazyAssetsLayout)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-global-config-page',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION),
                teamName: 'aurum'
            }
        }
    }));

});
parcelRegister("9EXi9", function(module, exports) {

$parcel$export(module.exports, "assetsConfigurationRoute", () => $f9206ce977f9b0fa$export$266d00c8001d32ab);
const $f9206ce977f9b0fa$export$266d00c8001d32ab = {
    name: 'assets-configure',
    path: '/jira/assets/configure/global'
};

});

parcelRegister("55ZOZ", function(module, exports) {

$parcel$export(module.exports, "getCmdbResources", () => $15b640a3daddca1e$export$850433b0663023b8);
$parcel$export(module.exports, "getAssetsAppResources", () => $15b640a3daddca1e$export$70fc9421fb71e080);

var $3RJkv = parcelRequire("3RJkv");

var $fpjJX = parcelRequire("fpjJX");

var $2eyDn = parcelRequire("2eyDn");

var $gRzZD = parcelRequire("gRzZD");

var $2Ql51 = parcelRequire("2Ql51");

var $kkNtb = parcelRequire("kkNtb");

var $5kYzp = parcelRequire("5kYzp");
function $15b640a3daddca1e$export$850433b0663023b8() {
    return [
        ...(0, $3RJkv.getNavigationResources)(),
        ...(0, $fpjJX.getServicedeskPageContextResources)(),
        (0, $gRzZD.workspaceResource)
    ];
}
function $15b640a3daddca1e$export$70fc9421fb71e080() {
    return [
        (0, $2Ql51.themePreferenceResource),
        (0, $kkNtb.rovoEntitlementResource),
        (0, $gRzZD.workspaceResource),
        (0, $5kYzp.announcementBannerSettingsV4Resource),
        (0, $2eyDn.consentBannerUserPreferencesResource)
    ];
}

});

parcelRegister("bdXN2", function(module, exports) {

$parcel$export(module.exports, "assetsGlobalSettingsEntryPoint", () => $d81197ab248aed96$export$2b083e0274144f1b);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $d81197ab248aed96$export$2b083e0274144f1b = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("lTD03")), {
        moduleId: "b65d2969",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("lTD03", function(module, exports) {

let $ff0cfc930876c515$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ff0cfc930876c515$var$load("dHjHz").then(()=>parcelRequire('cB0p5'));

});


parcelRegister("k7I8D", function(module, exports) {

$parcel$export(module.exports, "LazyAssetsLayout", () => $5490b4e7bbb569d8$export$6d4ed5b3aae01b61);
$parcel$export(module.exports, "AssetsLayout", () => $5490b4e7bbb569d8$export$fc69c032e8242676);

var $5uXOq = parcelRequire("5uXOq");

var $kxZPA = parcelRequire("kxZPA");

var $lfTZh = parcelRequire("lfTZh");

const $5490b4e7bbb569d8$export$6d4ed5b3aae01b61 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("fesO6")).then((module)=>module.AssetsLayout), {
    ssr: false,
    moduleId: "./src/packages/assets-app/layout/src/ui/index.tsx"
});
const $5490b4e7bbb569d8$export$fc69c032e8242676 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "assets-layout-async"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5490b4e7bbb569d8$export$6d4ed5b3aae01b61, null, children));

});
parcelRegister("fesO6", function(module, exports) {

let $b16e824f775916fc$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $b16e824f775916fc$var$load("kNFvF"),
    $b16e824f775916fc$var$load("ffQaD"),
    $b16e824f775916fc$var$load("kvRbA"),
    $b16e824f775916fc$var$load("4cY42")
]).then(()=>parcelRequire('c2H7b'));

});


parcelRegister("7iyOx", function(module, exports) {

$parcel$export(module.exports, "AssetsPageConfigContainer", () => $084a169938ff8f74$export$68a74d1b39f069c5);

var $5uXOq = parcelRequire("5uXOq");

var $kxZPA = parcelRequire("kxZPA");

var $lfTZh = parcelRequire("lfTZh");

const $084a169938ff8f74$export$606469064c062fcd = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("7MPot")).then((module)=>module.PageConfigContainer), {
    ssr: false,
    moduleId: "./src/packages/assets-app/page-config-container/src/ui/index.tsx"
});
const $084a169938ff8f74$export$68a74d1b39f069c5 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "assets-page-config-container-async"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($084a169938ff8f74$export$606469064c062fcd, null, children));

});
parcelRegister("7MPot", function(module, exports) {

let $5ab4e1d83cdfc002$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5ab4e1d83cdfc002$var$load("9rnnk").then(()=>parcelRequire('iHQhD'));

});



parcelRegister("cmklJ", function(module, exports) {

$parcel$export(module.exports, "assetsDataManagerDataSourceRouteEntry", () => $7a0fd968f6a735ca$export$3ca446ebb8517896);

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $5lsNZ = parcelRequire("5lsNZ");

var $6sdGo = parcelRequire("6sdGo");

var $lkFvK = parcelRequire("lkFvK");

var $e9YVH = parcelRequire("e9YVH");

var $55ZOZ = parcelRequire("55ZOZ");

var $k7I8D = parcelRequire("k7I8D");

var $7iyOx = parcelRequire("7iyOx");

var $kb4zh = parcelRequire("kb4zh");

var $lL0UO = parcelRequire("lL0UO");
const $7a0fd968f6a735ca$var$assetsDataManagerDataSourcePageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $lL0UO.assetsDataManagerDataSourceEntryPoint)
});
const $7a0fd968f6a735ca$export$3ca446ebb8517896 = (0, $7NszV.createEntry)((0, $6sdGo.assetsDataManagerDataSourceRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $k7I8D.AssetsLayout),
        PageConfigContainerOverride: (0, $7iyOx.AssetsPageConfigContainer),
        skeleton: (0, $kb4zh.default),
        perfMetricKey: 'assets-data-manager-data-source',
        pageId: ()=>'spa-apps/assets-data-manager-data-source',
        resources: (0, $55ZOZ.getAssetsAppResources)(),
        forPaint: [
            (0, $k7I8D.LazyAssetsLayout)
        ],
        entryPoint () {
            return (0, $4R6GH.fg)('assets_data_manager_jira_spa') ? $7a0fd968f6a735ca$var$assetsDataManagerDataSourcePageEntryPoint : undefined;
        },
        component: (0, $5lsNZ.default),
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).ASSETS_APP_DATA_MANAGER_DATA_SOURCE_PAGE,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).ASSETS_APP_DATA_MANAGER_DATA_SOURCE_PAGE),
                teamName: 'Aurum'
            }
        }
    }));

});
parcelRegister("6sdGo", function(module, exports) {

$parcel$export(module.exports, "assetsDataManagerDataSourceRoute", () => $15a241fc22889d00$export$d046531151f2bc80);
const $15a241fc22889d00$export$d046531151f2bc80 = {
    name: 'assets-data-manager-data-source',
    path: '/jira/assets/data-manager/object-classes/data-source/:dataSourceId',
    exact: true
};

});

parcelRegister("lL0UO", function(module, exports) {

$parcel$export(module.exports, "assetsDataManagerDataSourceEntryPoint", () => $447084b2d3e1935c$export$bd7cd6f2edc69e5c);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $447084b2d3e1935c$export$bd7cd6f2edc69e5c = (0, $fEDBv.createEntryPoint)({
    // eslint-disable-next-line jira/jira-ssr/wrong-entrypoint-usage
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("dQARO")), {
        moduleId: "bcbb9c89",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("dQARO", function(module, exports) {

let $a14cbab6957fd5fe$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a14cbab6957fd5fe$var$load("boMV6").then(()=>parcelRequire('ek3zg'));

});



parcelRegister("ca1Zm", function(module, exports) {

$parcel$export(module.exports, "assetsDataManagerGettingStartedRouteEntry", () => $4bc06d3ca24631bd$export$d9a1c48acd35cf03);

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $5lsNZ = parcelRequire("5lsNZ");

var $2eDbE = parcelRequire("2eDbE");

var $lkFvK = parcelRequire("lkFvK");

var $4X5MI = parcelRequire("4X5MI");

var $e9YVH = parcelRequire("e9YVH");

var $55ZOZ = parcelRequire("55ZOZ");

var $k7I8D = parcelRequire("k7I8D");

var $7iyOx = parcelRequire("7iyOx");

var $kb4zh = parcelRequire("kb4zh");
const $4bc06d3ca24631bd$var$assetsDataManagerGettingStartedPageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $4X5MI.assetsDataManagerGettingStartedEntryPoint)
});
const $4bc06d3ca24631bd$export$d9a1c48acd35cf03 = (0, $7NszV.createEntry)((0, $2eDbE.assetsDataManagerGettingStartedRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $k7I8D.AssetsLayout),
        PageConfigContainerOverride: (0, $7iyOx.AssetsPageConfigContainer),
        skeleton: (0, $kb4zh.default),
        perfMetricKey: 'assets-data-manager-getting-started',
        ufoName: 'assets-data-manager-getting-started',
        pageId: ()=>'spa-apps/assets-data-manager-getting-started',
        resources: (0, $55ZOZ.getAssetsAppResources)(),
        forPaint: [
            (0, $k7I8D.LazyAssetsLayout)
        ],
        entryPoint () {
            return (0, $4R6GH.fg)('assets_data_manager_jira_spa') ? $4bc06d3ca24631bd$var$assetsDataManagerGettingStartedPageEntryPoint : undefined;
        },
        component: (0, $4R6GH.fg)('assets_data_manager_jira_spa') ? undefined : (0, $5lsNZ.default),
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).ASSETS_APP_DATA_MANAGER_GETTING_STARTED_PAGE,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).ASSETS_APP_DATA_MANAGER_GETTING_STARTED_PAGE),
                teamName: 'Aurum'
            }
        }
    }));

});
parcelRegister("2eDbE", function(module, exports) {

$parcel$export(module.exports, "assetsDataManagerGettingStartedRoute", () => $11e34d6ea6d371f6$export$82de2af972f327f8);
const $11e34d6ea6d371f6$export$82de2af972f327f8 = {
    name: 'assets-data-manager-getting-started',
    path: '/jira/assets/data-manager/getting-started',
    exact: true
};

});

parcelRegister("4X5MI", function(module, exports) {

$parcel$export(module.exports, "assetsDataManagerGettingStartedEntryPoint", () => $68099fa38484b838$export$4f270d89a19b2303);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $68099fa38484b838$export$4f270d89a19b2303 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("f2A9T")), {
        moduleId: "69964d1d",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("f2A9T", function(module, exports) {

let $af33173bd4b4ec92$var$load = (parcelRequire("28QjX"))(4);
module.exports = $af33173bd4b4ec92$var$load("g7uLf").then(()=>parcelRequire('6Ctkw'));

});



parcelRegister("6GNmk", function(module, exports) {

$parcel$export(module.exports, "assetsDataManagerObjectClassesRouteEntry", () => $36898c05fc75c8c5$export$21baed265eb8be15);

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $5lsNZ = parcelRequire("5lsNZ");

var $6HFp1 = parcelRequire("6HFp1");

var $lkFvK = parcelRequire("lkFvK");

var $e9YVH = parcelRequire("e9YVH");

var $55ZOZ = parcelRequire("55ZOZ");

var $k7I8D = parcelRequire("k7I8D");

var $7iyOx = parcelRequire("7iyOx");

var $kb4zh = parcelRequire("kb4zh");

var $gijLr = parcelRequire("gijLr");
const $36898c05fc75c8c5$var$assetsDataManagerObjectClassesPageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $gijLr.assetsDataManagerObjectClassesEntryPoint)
});
const $36898c05fc75c8c5$export$21baed265eb8be15 = (0, $7NszV.createEntry)((0, $6HFp1.assetsDataManagerObjectClassesRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $k7I8D.AssetsLayout),
        PageConfigContainerOverride: (0, $7iyOx.AssetsPageConfigContainer),
        skeleton: (0, $kb4zh.default),
        perfMetricKey: 'assets-data-manager-object-classes',
        pageId: ()=>'spa-apps/assets-data-manager-object-classes',
        resources: (0, $55ZOZ.getAssetsAppResources)(),
        forPaint: [
            (0, $k7I8D.LazyAssetsLayout)
        ],
        entryPoint () {
            return (0, $4R6GH.fg)('assets_data_manager_jira_spa') ? $36898c05fc75c8c5$var$assetsDataManagerObjectClassesPageEntryPoint : undefined;
        },
        component: (0, $4R6GH.fg)('assets_data_manager_jira_spa') ? undefined : (0, $5lsNZ.default),
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).ASSETS_APP_DATA_MANAGER_OBJECT_CLASSES_PAGE,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).ASSETS_APP_DATA_MANAGER_OBJECT_CLASSES_PAGE),
                teamName: 'Aurum'
            }
        }
    }));

});
parcelRegister("6HFp1", function(module, exports) {

$parcel$export(module.exports, "assetsDataManagerObjectClassesRoute", () => $3a9992b78f22acb9$export$efbc59a0b92a1a13);
const $3a9992b78f22acb9$export$efbc59a0b92a1a13 = {
    name: 'assets-data-manager-object-classes',
    path: '/jira/assets/data-manager/object-classes',
    exact: true
};

});

parcelRegister("gijLr", function(module, exports) {

$parcel$export(module.exports, "assetsDataManagerObjectClassesEntryPoint", () => $ae68c8884650ca59$export$c1881c035be68200);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $ae68c8884650ca59$export$c1881c035be68200 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("1oH3z")), {
        moduleId: "1ab370bf",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("1oH3z", function(module, exports) {

let $10496e7e140c3aba$var$load = (parcelRequire("28QjX"))(4);
module.exports = $10496e7e140c3aba$var$load("7adsU").then(()=>parcelRequire('94tLu'));

});



parcelRegister("3T2Ye", function(module, exports) {

$parcel$export(module.exports, "assetsObjectRouteEntry", () => $615c397cb5d7287d$export$17871a1fbc6e31db);

var $7NszV = parcelRequire("7NszV");

var $8naTI = parcelRequire("8naTI");

var $1KCrA = parcelRequire("1KCrA");

var $55ZOZ = parcelRequire("55ZOZ");

var $9jDQB = parcelRequire("9jDQB");

var $lkFvK = parcelRequire("lkFvK");

var $k7I8D = parcelRequire("k7I8D");

var $7iyOx = parcelRequire("7iyOx");

var $kb4zh = parcelRequire("kb4zh");
const $615c397cb5d7287d$var$assetsObjectPageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $9jDQB.assetsObjectViewEntryPoint)
});
const $615c397cb5d7287d$export$17871a1fbc6e31db = (0, $7NszV.createEntry)((0, $1KCrA.assetsObjectRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $k7I8D.AssetsLayout),
        PageConfigContainerOverride: (0, $7iyOx.AssetsPageConfigContainer),
        skeleton: (0, $kb4zh.default),
        entryPoint: ()=>$615c397cb5d7287d$var$assetsObjectPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-object-v2',
        resources: [
            ...(0, $55ZOZ.getAssetsAppResources)(),
            (0, $8naTI.insightObjectResource)
        ],
        forPaint: [
            (0, $k7I8D.LazyAssetsLayout)
        ],
        perfMetricKey: 'service-management.insight-cmdb.object-view-page-load',
        ufoName: 'service-management.insight-cmdb.object-view-page-load'
    }));

});
parcelRegister("8naTI", function(module, exports) {

$parcel$export(module.exports, "insightObjectResource", () => $2ad42c3dacc09c9e$export$215464c8085c5e35);

var $2M1hQ = parcelRequire("2M1hQ");

var $7JHOP = parcelRequire("7JHOP");
const $2ad42c3dacc09c9e$var$RESOURCE_TYPE_SERVICEDESK_INSIGHT_OBJECT = 'SERVICEDESK_INSIGHT_OBJECT';
const $2ad42c3dacc09c9e$export$215464c8085c5e35 = (0, $2M1hQ.createResource)({
    type: $2ad42c3dacc09c9e$var$RESOURCE_TYPE_SERVICEDESK_INSIGHT_OBJECT,
    getKey: ({ match: match })=>match.params.objectId || '',
    getData: $7JHOP.default,
    isBrowserOnly: true
});

});
parcelRegister("7JHOP", function(module, exports) {

$parcel$export(module.exports, "default", () => $07f064c629fd32ba$export$2e2bcd8739ae039);

var $x9xyg = parcelRequire("x9xyg");

var $2YZCu = parcelRequire("2YZCu");

var $xJtdX = parcelRequire("xJtdX");

var $7f4tk = parcelRequire("7f4tk");

var $8PRuf = parcelRequire("8PRuf");

var $iR3GG = parcelRequire("iR3GG");

var $eJOOa = parcelRequire("eJOOa");

var $ahEft = parcelRequire("ahEft");

var $9NiTW = parcelRequire("9NiTW");
const $07f064c629fd32ba$var$fetchInsightObjectDetails = async (routeDataContext, routerContext)=>{
    try {
        const { match: { params: params } } = routeDataContext;
        const { objectId: objectId } = params;
        if (objectId == null) return null;
        const workspaceId = await (0, $ahEft.default)(routeDataContext, routerContext);
        if (workspaceId == null) return null;
        const data = await (0, $7f4tk.default)((0, $eJOOa.getCmdbObjectByIdUrl)(workspaceId, objectId));
        (0, $x9xyg.setMark)((0, $8PRuf.prefetchApiReadyMark));
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jiraServicedeskInsightObjectResource', error);
        (0, $xJtdX.fireCmdbErrorAnalytics)({
            meta: {
                id: 'jiraServicedeskInsightObjectResource',
                packageName: 'jiraSpa'
            },
            error: error
        });
        throw error;
    }
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$07f064c629fd32ba$export$2e2bcd8739ae039 = async (routeDataContext, routerContext)=>{
    const { tenantContext: tenantContext } = routerContext;
    // Early exit on these cases and return a valid response. We don't want to flood sentry.
    if (!(0, $9NiTW.checkAuthentication)(tenantContext)) throw (0, $iR3GG.createResourceError)({
        component: 'spa.view.routes.servicedesk.cmdb-object.getData',
        message: 'Current user is not authenticated',
        name: 'AuthenticationError',
        skipSentry: true
    });
    return $07f064c629fd32ba$var$fetchInsightObjectDetails(routeDataContext, routerContext);
};

});
parcelRegister("xJtdX", function(module, exports) {

$parcel$export(module.exports, "fireCmdbErrorAnalytics", () => $f8d3fdda5fdae8d1$export$50d4fa14efd248c2);

var $jcw0u = parcelRequire("jcw0u");
const $f8d3fdda5fdae8d1$export$50d4fa14efd248c2 = (payload)=>{
    return (0, $jcw0u.default)(payload);
};

});

parcelRegister("8PRuf", function(module, exports) {

$parcel$export(module.exports, "appBundleReadyMark", () => $0ec5205bf4957ca4$export$7e50945a65dd40e);
$parcel$export(module.exports, "prefetchApiReadyMark", () => $0ec5205bf4957ca4$export$17cbe723d23101d8);
$parcel$export(module.exports, "prefetchApiStartMark", () => $0ec5205bf4957ca4$export$887fadb22e7c7735);
$parcel$export(module.exports, "jswRenderStartMark", () => $0ec5205bf4957ca4$export$bd099c0a906f4b3f);
$parcel$export(module.exports, "jswCreateReduxStoreStartMark", () => $0ec5205bf4957ca4$export$d23ef9e7633e30e7);
$parcel$export(module.exports, "jswCreateReduxStoreEndMark", () => $0ec5205bf4957ca4$export$319da6d901948a6d);
$parcel$export(module.exports, "jswTransformCriticalDataStartMark", () => $0ec5205bf4957ca4$export$f0b6622cdc5c7e4f);
$parcel$export(module.exports, "jswTransformCriticalDataEndMark", () => $0ec5205bf4957ca4$export$37e82663aa1e79a8);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedStartMark", () => $0ec5205bf4957ca4$export$21146514eacceb12);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedEndMark", () => $0ec5205bf4957ca4$export$4eb8d44ddb14424a);


var $hXKq5 = parcelRequire("hXKq5");
const $0ec5205bf4957ca4$export$7e50945a65dd40e = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$ff834eccc35b9089));
const $0ec5205bf4957ca4$export$17cbe723d23101d8 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$86b05e34d462ead8));
const $0ec5205bf4957ca4$export$887fadb22e7c7735 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$d6a604a7d9a390fb));
const $0ec5205bf4957ca4$export$bd099c0a906f4b3f = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$3ae43cc1782d058f));
const $0ec5205bf4957ca4$export$d23ef9e7633e30e7 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$363f6703ffa600be));
const $0ec5205bf4957ca4$export$319da6d901948a6d = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$e87b74567b79c8));
const $0ec5205bf4957ca4$export$f0b6622cdc5c7e4f = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$99fe642459a8b02));
const $0ec5205bf4957ca4$export$37e82663aa1e79a8 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$ab1f5705fc8e0571));
const $0ec5205bf4957ca4$export$21146514eacceb12 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$8c3a9046da692c35));
const $0ec5205bf4957ca4$export$4eb8d44ddb14424a = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$5aa497d1efdcc5bf));

});

parcelRegister("eJOOa", function(module, exports) {

$parcel$export(module.exports, "getCmdbObjectByIdUrl", () => $bba7f62e646e53a7$export$d33c3e25476d091d);
$parcel$export(module.exports, "getCmdbObjectByIdUrlWithoutQueryParams", () => $bba7f62e646e53a7$export$6ef8997552257871);
$parcel$export(module.exports, "getCmdbObjectByIdActivityUrl", () => $bba7f62e646e53a7$export$20c207abffb62450);
$parcel$export(module.exports, "getCmdbObjectByIdAvatarUrl", () => $bba7f62e646e53a7$export$31df868d16d545f8);
$parcel$export(module.exports, "getCmdbObjectByIdReferenceInfoUrl", () => $bba7f62e646e53a7$export$5044a1e9fc201773);
$parcel$export(module.exports, "getCmdbObjectCloneByIdUrl", () => $bba7f62e646e53a7$export$d7f6dc1d4f622458);
$parcel$export(module.exports, "getCmdbObjectCreateUrl", () => $bba7f62e646e53a7$export$9cdc19e8944d38cf);
$parcel$export(module.exports, "getCmdbObjectNavlistUrl", () => $bba7f62e646e53a7$export$bf9c534c2cd21829);
$parcel$export(module.exports, "getCmdbObjectNavlistQueryLanguageUrl", () => $bba7f62e646e53a7$export$b35334340ee827fa);
$parcel$export(module.exports, "getCmdbObjectRecentUrl", () => $bba7f62e646e53a7$export$a0a7c6f22bebdef0);
$parcel$export(module.exports, "getCmdbObjectQueryLanguageTotalCountUrl", () => $bba7f62e646e53a7$export$ee74f95a469c4433);
$parcel$export(module.exports, "getCmdbObjectQueryLanguageUrl", () => $bba7f62e646e53a7$export$84a34ee3f18e226);
$parcel$export(module.exports, "getCmdbAsyncObjectExportUrl", () => $bba7f62e646e53a7$export$878b627ac685384e);
$parcel$export(module.exports, "getCmdbAsyncBulkQrCodeUrl", () => $bba7f62e646e53a7$export$8eb3a6b36886db0);
$parcel$export(module.exports, "getCmdbAsyncBulkDeleteUrl", () => $bba7f62e646e53a7$export$b02201bcaeb75291);
$parcel$export(module.exports, "getCmdbAsyncBulkEditUrl", () => $bba7f62e646e53a7$export$f4d68a6f0e3217b5);

var $ebyGx = parcelRequire("ebyGx");

var $klJ8b = parcelRequire("klJ8b");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/object
 */ const $bba7f62e646e53a7$var$getCmdbObjectUrl = (workspaceId)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/object`;
const $bba7f62e646e53a7$export$d33c3e25476d091d = (workspaceId, objectId, includeExtendedInfo = false)=>{
    const path = $bba7f62e646e53a7$export$6ef8997552257871(workspaceId, objectId);
    if (!includeExtendedInfo) return `${path}?${(0, $ebyGx.stringify)({
        includeExtendedInfo: includeExtendedInfo
    })}`;
    return path;
};
const $bba7f62e646e53a7$export$6ef8997552257871 = (workspaceId, objectId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/${objectId}`;
const $bba7f62e646e53a7$export$20c207abffb62450 = (workspaceId, objectId, queryParams)=>`${$bba7f62e646e53a7$export$6ef8997552257871(workspaceId, objectId)}/activity?${(0, $ebyGx.stringify)(queryParams)}`;
const $bba7f62e646e53a7$export$31df868d16d545f8 = (workspaceId, objectId)=>`${$bba7f62e646e53a7$export$6ef8997552257871(workspaceId, objectId)}/avatar`;
const $bba7f62e646e53a7$export$5044a1e9fc201773 = (workspaceId, objectId)=>`${$bba7f62e646e53a7$export$6ef8997552257871(workspaceId, objectId)}/referenceinfo`;
const $bba7f62e646e53a7$export$d7f6dc1d4f622458 = (workspaceId, objectId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/clone/${objectId}`;
const $bba7f62e646e53a7$export$9cdc19e8944d38cf = (workspaceId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/create`;
const $bba7f62e646e53a7$export$bf9c534c2cd21829 = (workspaceId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/navlist`;
const $bba7f62e646e53a7$export$b35334340ee827fa = (workspaceId)=>`${$bba7f62e646e53a7$export$bf9c534c2cd21829(workspaceId)}/aql`;
const $bba7f62e646e53a7$export$a0a7c6f22bebdef0 = (workspaceId, queryParams)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/recent?${(0, $ebyGx.stringify)(queryParams)}`;
const $bba7f62e646e53a7$export$ee74f95a469c4433 = (workspaceId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/aql/totalcount`;
const $bba7f62e646e53a7$export$1016ae73c04d9079 = (workspaceId, queryParams)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/search?${(0, $ebyGx.stringify)(queryParams)}`;
const $bba7f62e646e53a7$export$cb41514f2508b033 = (workspaceId, queryParams)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/searchbyattributes?${(0, $ebyGx.stringify)(queryParams)}`;
const $bba7f62e646e53a7$export$84a34ee3f18e226 = (workspaceId, queryParams)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/aql?${(0, $ebyGx.stringify)(queryParams)}`;
const $bba7f62e646e53a7$export$878b627ac685384e = (workspaceId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/bulkexport`;
const $bba7f62e646e53a7$export$8eb3a6b36886db0 = (workspaceId, queryParams)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/bulkqrcode?${(0, $ebyGx.stringify)(queryParams)}`;
const $bba7f62e646e53a7$export$b02201bcaeb75291 = (workspaceId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/bulkdelete`;
const $bba7f62e646e53a7$export$f4d68a6f0e3217b5 = (workspaceId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/bulkedit`;

});
parcelRegister("klJ8b", function(module, exports) {

$parcel$export(module.exports, "getCmdbRestBaseUrl", () => $a22cc15ea8014e15$export$28b6c003daedf1c2);
const $a22cc15ea8014e15$export$28b6c003daedf1c2 = (workspaceId)=>`/gateway/api/jsm/assets/workspace/${workspaceId}/v1`;

});




parcelRegister("1KCrA", function(module, exports) {

$parcel$export(module.exports, "assetsObjectRoute", () => $f53da45d067bd137$export$8f0b5215230b6dd1);
const $f53da45d067bd137$export$8f0b5215230b6dd1 = {
    name: 'assets-object',
    path: '/jira/assets/object/:objectId'
};

});

parcelRegister("9jDQB", function(module, exports) {

$parcel$export(module.exports, "assetsObjectViewEntryPoint", () => $24c507f8dd2d8705$export$4311ec530d21ec36);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $24c507f8dd2d8705$export$4311ec530d21ec36 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("jJT8T")), {
        moduleId: "5026c489",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("jJT8T", function(module, exports) {

let $e5ecfe6cfb0985e3$var$load = (parcelRequire("28QjX"))(4);

module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $e5ecfe6cfb0985e3$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $e5ecfe6cfb0985e3$var$load("k6g9p")
        ]);
    }),
    $e5ecfe6cfb0985e3$var$load("ffQaD"),
    $e5ecfe6cfb0985e3$var$load("kvRbA"),
    $e5ecfe6cfb0985e3$var$load("kNFvF"),
    $e5ecfe6cfb0985e3$var$load("fliVL"),
    $e5ecfe6cfb0985e3$var$load("76n7a"),
    $e5ecfe6cfb0985e3$var$load("l253H"),
    $e5ecfe6cfb0985e3$var$load("bmBxo")
]).then(()=>parcelRequire('8V2Yz'));

});



parcelRegister("9CT95", function(module, exports) {

$parcel$export(module.exports, "assetsObjectTypeConfigurationRouteEntry", () => $90a106b2f6138f39$export$28b088de21f264eb);

var $7NszV = parcelRequire("7NszV");

var $8OvOy = parcelRequire("8OvOy");

var $e9YVH = parcelRequire("e9YVH");

var $55ZOZ = parcelRequire("55ZOZ");

var $2U2qS = parcelRequire("2U2qS");

var $lkFvK = parcelRequire("lkFvK");

var $k7I8D = parcelRequire("k7I8D");

var $7iyOx = parcelRequire("7iyOx");

var $kb4zh = parcelRequire("kb4zh");
const $90a106b2f6138f39$var$assetsObjectTypeSettingsPageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $2U2qS.assetsObjectTypeSettingsEntryPoint)
});
const $90a106b2f6138f39$export$28b088de21f264eb = (0, $7NszV.createEntry)((0, $8OvOy.assetsObjectTypeConfigurationRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $k7I8D.AssetsLayout),
        PageConfigContainerOverride: (0, $7iyOx.AssetsPageConfigContainer),
        skeleton: (0, $kb4zh.default),
        entryPoint: ()=>$90a106b2f6138f39$var$assetsObjectTypeSettingsPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-configure-object-type',
        resources: (0, $55ZOZ.getAssetsAppResources)(),
        forPaint: [
            (0, $k7I8D.LazyAssetsLayout)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION),
                teamName: 'aurum'
            }
        },
        ufoName: 'service-management.insight-cmdb-object-type-configuration'
    }));

});
parcelRegister("8OvOy", function(module, exports) {

$parcel$export(module.exports, "assetsObjectTypeConfigurationRoute", () => $7219951fe88b4de4$export$fe5957039840ffd3);
const $7219951fe88b4de4$export$fe5957039840ffd3 = {
    name: 'assets-object-type-configuration',
    path: '/jira/assets/configure/object-type/:objectTypeId'
};

});

parcelRegister("2U2qS", function(module, exports) {

$parcel$export(module.exports, "assetsObjectTypeSettingsEntryPoint", () => $b38a85b0472f579f$export$fab2e471b162aafc);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $b38a85b0472f579f$export$fab2e471b162aafc = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("dbln9")), {
        moduleId: "b4d985ee",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("dbln9", function(module, exports) {

let $998ce18f60966d15$var$load = (parcelRequire("28QjX"))(4);
module.exports = $998ce18f60966d15$var$load("fNTa5").then(()=>parcelRequire('2lY4S'));

});



parcelRegister("6fdEz", function(module, exports) {

$parcel$export(module.exports, "assetsReportsRouteEntry", () => $36ddac7deaedb3c0$export$dabfe6668c5a0cc4);

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $jAA3i = parcelRequire("jAA3i");

var $e9YVH = parcelRequire("e9YVH");

var $lO0iE = parcelRequire("lO0iE");

var $lkFvK = parcelRequire("lkFvK");

var $k7I8D = parcelRequire("k7I8D");

var $55ZOZ = parcelRequire("55ZOZ");

var $7iyOx = parcelRequire("7iyOx");

var $kb4zh = parcelRequire("kb4zh");
const $36ddac7deaedb3c0$var$assetsReportsPageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $lO0iE.assetsReportsNav4HomeEntryPoint)
});
const $36ddac7deaedb3c0$export$dabfe6668c5a0cc4 = (0, $7NszV.createEntry)((0, $jAA3i.assetsReportsRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $k7I8D.AssetsLayout),
        PageConfigContainerOverride: (0, $7iyOx.AssetsPageConfigContainer),
        skeleton: (0, $kb4zh.default),
        entryPoint: ()=>$36ddac7deaedb3c0$var$assetsReportsPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-assets-reports-home-page',
        resources: [
            ...(0, $55ZOZ.getAssetsAppResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $k7I8D.LazyAssetsLayout)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT),
                teamName: 'ITSM SAGA'
            }
        }
    }));

});
parcelRegister("jAA3i", function(module, exports) {

$parcel$export(module.exports, "assetsReportsRoute", () => $6707851ae8c25753$export$b123ccf7df3854f4);
const $6707851ae8c25753$export$b123ccf7df3854f4 = {
    name: 'assets-reports-default-redirect',
    path: '/jira/assets/reports',
    exact: true
};

});

parcelRegister("lO0iE", function(module, exports) {

$parcel$export(module.exports, "assetsReportsNav4HomeEntryPoint", () => $4ebd26cccf0a7e53$export$1a891b207b85b219);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $4ebd26cccf0a7e53$export$1a891b207b85b219 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("9vy7H")).then((module)=>module.AssetsReportsNav4HomePage), {
        moduleId: "cd1143ba",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9vy7H", function(module, exports) {

let $6ec17a719c259172$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6ec17a719c259172$var$load("ffQaD"),
    $6ec17a719c259172$var$load("kvRbA"),
    $6ec17a719c259172$var$load("8asWZ")
]).then(()=>parcelRequire('je9tT'));

});



parcelRegister("8WMR9", function(module, exports) {

$parcel$export(module.exports, "assetsReportsTemplateRouteEntry", () => $e1d23f4ef8c5f349$export$c69d6dbd8091ce7b);

var $lmyls = parcelRequire("lmyls");

var $72NwO = parcelRequire("72NwO");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $21dDm = parcelRequire("21dDm");

var $e9YVH = parcelRequire("e9YVH");

var $ceEFi = parcelRequire("ceEFi");

var $55ZOZ = parcelRequire("55ZOZ");

var $k7I8D = parcelRequire("k7I8D");

var $7iyOx = parcelRequire("7iyOx");

var $kb4zh = parcelRequire("kb4zh");
const $e1d23f4ef8c5f349$export$c69d6dbd8091ce7b = (0, $7NszV.createEntry)((0, $21dDm.assetsReportsTemplateRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $k7I8D.AssetsLayout),
        PageConfigContainerOverride: (0, $7iyOx.AssetsPageConfigContainer),
        skeleton: (0, $kb4zh.default),
        component: (0, $ceEFi.AssetsReports),
        resources: [
            ...(0, $55ZOZ.getAssetsAppResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $k7I8D.LazyAssetsLayout),
            (0, $ceEFi.LazyServicedeskCmdbAssetsReports)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $72NwO.default)
        },
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_ASSETS_REPORTS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_ASSETS_REPORTS),
                teamName: 'ITSM SAGA'
            }
        },
        perfMetricKey: 'service-management.insight-cmdb.load-assets-reports-template'
    }));

});
parcelRegister("72NwO", function(module, exports) {

$parcel$export(module.exports, "default", () => $d99ccdcd3c9cebe4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

const $d99ccdcd3c9cebe4$export$2260a0528570f8da = (0, $kxZPA.lazyForPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("7rR64")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/assets-reports/src/index.tsx"
});
const $d99ccdcd3c9cebe4$var$AssetsReportsSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "assets-reports-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d99ccdcd3c9cebe4$export$2260a0528570f8da, null)));
$d99ccdcd3c9cebe4$var$AssetsReportsSidebar.displayName = 'AssetsReportsSidebar';
var $d99ccdcd3c9cebe4$export$2e2bcd8739ae039 = $d99ccdcd3c9cebe4$var$AssetsReportsSidebar;

});
parcelRegister("7rR64", function(module, exports) {

let $56c43df7141f5b77$var$load = (parcelRequire("28QjX"))(4);
module.exports = $56c43df7141f5b77$var$load("kdcHi").then(()=>parcelRequire('ejeJy'));

});


parcelRegister("21dDm", function(module, exports) {

$parcel$export(module.exports, "assetsReportsTemplateRoute", () => $101c0306a4a55493$export$4255578ec14d83bb);
const $101c0306a4a55493$export$4255578ec14d83bb = {
    name: 'assets-reports',
    path: '/jira/assets/reports/:templateId',
    exact: true
};

});

parcelRegister("ceEFi", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskCmdbAssetsReports", () => $2e02aa1a19501df5$export$9f75cdfdfe8c8aaa);
$parcel$export(module.exports, "LazyServicedeskCmdbDefaultReportsRedirect", () => $2e02aa1a19501df5$export$2534c3e9f8e70d0d);
$parcel$export(module.exports, "LazyServicedeskCmdbAssetsReportsUnsubscribe", () => $2e02aa1a19501df5$export$dec85f15dd805ac4);
$parcel$export(module.exports, "LazyServicedeskCmdbAssetsReportsNav4HomePage", () => $2e02aa1a19501df5$export$c56cfef9aa68df09);
$parcel$export(module.exports, "AssetsReports", () => $2e02aa1a19501df5$export$d45b40d40442434);
$parcel$export(module.exports, "AssetsReportsUnsubscribe", () => $2e02aa1a19501df5$export$541b39e6d5be07df);
$parcel$export(module.exports, "AssetsReportingDefaultRedirect", () => $2e02aa1a19501df5$export$4155da54bfeacf74);
$parcel$export(module.exports, "AssetsReportsNav4HomePage", () => $2e02aa1a19501df5$export$9d28551695f98cae);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $2e02aa1a19501df5$export$9f75cdfdfe8c8aaa = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("gxUan")).then((exportedMembers)=>exportedMembers.CmdbAssetsReports), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports/src/index.tsx"
});

const $2e02aa1a19501df5$export$2534c3e9f8e70d0d = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("gxUan")).then((exportedMembers)=>exportedMembers.CmdbDefaultReportsRedirect), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports/src/index.tsx"
});

const $2e02aa1a19501df5$export$dec85f15dd805ac4 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("le0yB")), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports-unsubscribe/src/index.tsx"
});

const $2e02aa1a19501df5$export$c56cfef9aa68df09 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("gxUan")).then((exportedMembers)=>exportedMembers.CmdbAssetsReportsNav4HomePage), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports/src/index.tsx"
});
const $2e02aa1a19501df5$export$d45b40d40442434 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2e02aa1a19501df5$export$9f75cdfdfe8c8aaa,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports",
        shouldShowSpinner: true
    });
const $2e02aa1a19501df5$export$541b39e6d5be07df = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2e02aa1a19501df5$export$dec85f15dd805ac4,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports-unsubscribe",
        shouldShowSpinner: true
    });
const $2e02aa1a19501df5$export$4155da54bfeacf74 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2e02aa1a19501df5$export$2534c3e9f8e70d0d,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports-default-redirect",
        shouldShowSpinner: true
    });
const $2e02aa1a19501df5$export$9d28551695f98cae = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2e02aa1a19501df5$export$c56cfef9aa68df09,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports-home-page",
        shouldShowSpinner: true
    });

});
parcelRegister("gxUan", function(module, exports) {

let $c0bb4bdad74792a1$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $c0bb4bdad74792a1$var$load("kNFvF"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("g7sKJ"), 4)),
    $c0bb4bdad74792a1$var$load("ffQaD"),
    $c0bb4bdad74792a1$var$load("kvRbA"),
    $c0bb4bdad74792a1$var$load("76n7a"),
    $c0bb4bdad74792a1$var$load("l253H"),
    $c0bb4bdad74792a1$var$load("jzNjh")
]).then(()=>parcelRequire('7Jr0E'));

});

parcelRegister("le0yB", function(module, exports) {

let $f73b5668cdc8fb58$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $f73b5668cdc8fb58$var$load("kNFvF"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("6RlRv"), 4)),
    $f73b5668cdc8fb58$var$load("ffQaD"),
    $f73b5668cdc8fb58$var$load("kvRbA"),
    $f73b5668cdc8fb58$var$load("76n7a"),
    $f73b5668cdc8fb58$var$load("l253H"),
    $f73b5668cdc8fb58$var$load("2W1TX")
]).then(()=>parcelRequire('imnQf'));

});



parcelRegister("hSl7U", function(module, exports) {

$parcel$export(module.exports, "assetsReportsUnsubscribeRouteEntry", () => $ffecce251ff34805$export$25e4df4267166d6b);

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $dSJJZ = parcelRequire("dSJJZ");

var $e9YVH = parcelRequire("e9YVH");

var $l50mM = parcelRequire("l50mM");

var $lkFvK = parcelRequire("lkFvK");

var $55ZOZ = parcelRequire("55ZOZ");

var $k7I8D = parcelRequire("k7I8D");

var $7iyOx = parcelRequire("7iyOx");

var $kb4zh = parcelRequire("kb4zh");
const $ffecce251ff34805$var$assetsReportsUnsubscribePageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $l50mM.assetsReportsUnsubscribeEntryPoint)
});
const $ffecce251ff34805$export$25e4df4267166d6b = (0, $7NszV.createEntry)((0, $dSJJZ.assetsReportsUnsubscribeRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $k7I8D.AssetsLayout),
        PageConfigContainerOverride: (0, $7iyOx.AssetsPageConfigContainer),
        skeleton: (0, $kb4zh.default),
        entryPoint: ()=>$ffecce251ff34805$var$assetsReportsUnsubscribePageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-assets-reports-unsubscribe',
        resources: [
            ...(0, $55ZOZ.getAssetsAppResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $k7I8D.LazyAssetsLayout)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE),
                teamName: 'ITSM SAGA'
            }
        }
    }));

});
parcelRegister("dSJJZ", function(module, exports) {

$parcel$export(module.exports, "assetsReportsUnsubscribeRoute", () => $ff6ca822a7d33e3c$export$2b543c10e2c9e843);
const $ff6ca822a7d33e3c$export$2b543c10e2c9e843 = {
    name: 'assets-reports-unsubscribe',
    path: '/jira/assets/reports/unsubscribe/:templateId/:subscriptionId',
    exact: true
};

});

parcelRegister("l50mM", function(module, exports) {

$parcel$export(module.exports, "assetsReportsUnsubscribeEntryPoint", () => $1972442ea7884b36$export$d827c87e65bb6e47);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $1972442ea7884b36$export$d827c87e65bb6e47 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("le0yB")), {
        moduleId: "fe8b4981",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});


parcelRegister("7kGnZ", function(module, exports) {

$parcel$export(module.exports, "assetsRouteEntry", () => $b03272cc541907e2$export$7069f3fb497264f1);

var $7NszV = parcelRequire("7NszV");

var $hPMcq = parcelRequire("hPMcq");

var $55ZOZ = parcelRequire("55ZOZ");

var $lkFvK = parcelRequire("lkFvK");

var $kVDZN = parcelRequire("kVDZN");

var $k7I8D = parcelRequire("k7I8D");

var $7iyOx = parcelRequire("7iyOx");

var $kb4zh = parcelRequire("kb4zh");
const $b03272cc541907e2$var$assetsPageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $kVDZN.landingPageEntryPoint)
});
const $b03272cc541907e2$export$7069f3fb497264f1 = (0, $7NszV.createEntry)((0, $hPMcq.assetsRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $k7I8D.AssetsLayout),
        PageConfigContainerOverride: (0, $7iyOx.AssetsPageConfigContainer),
        skeleton: (0, $kb4zh.default),
        entryPoint: ()=>$b03272cc541907e2$var$assetsPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-landing-page',
        resources: (0, $55ZOZ.getAssetsAppResources)(),
        forPaint: [
            (0, $k7I8D.LazyAssetsLayout)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-landing-page'
    }));

});
parcelRegister("hPMcq", function(module, exports) {

$parcel$export(module.exports, "assetsRoute", () => $59be8ada95f8c1d8$export$70dab2ea29192797);
const $59be8ada95f8c1d8$export$70dab2ea29192797 = {
    name: 'assets',
    path: '/jira/assets',
    exact: true
};

});

parcelRegister("kVDZN", function(module, exports) {

$parcel$export(module.exports, "landingPageEntryPoint", () => $0cae44565e643672$export$36d88a15c123c06);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $0cae44565e643672$export$36d88a15c123c06 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("8W8bB")), {
        moduleId: "60961f22",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8W8bB", function(module, exports) {

let $681a171ce746c50d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $681a171ce746c50d$var$load("ffQaD"),
    $681a171ce746c50d$var$load("kvRbA"),
    $681a171ce746c50d$var$load("h4TlC")
]).then(()=>parcelRequire('9imjS'));

});



parcelRegister("elyxq", function(module, exports) {

$parcel$export(module.exports, "assetsSchemaConfigurationRouteEntry", () => $c609df68fdefe1cd$export$6c9c29c3048f2e2c);

var $7NszV = parcelRequire("7NszV");

var $6j0IA = parcelRequire("6j0IA");

var $cNynZ = parcelRequire("cNynZ");

var $e9YVH = parcelRequire("e9YVH");

var $55ZOZ = parcelRequire("55ZOZ");

var $6acMA = parcelRequire("6acMA");

var $lkFvK = parcelRequire("lkFvK");

var $k7I8D = parcelRequire("k7I8D");

var $7iyOx = parcelRequire("7iyOx");

var $kb4zh = parcelRequire("kb4zh");
const $c609df68fdefe1cd$var$assetsSchemaSettingsPageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $6acMA.assetsSchemaSettingsEntryPoint)
});
const $c609df68fdefe1cd$export$6c9c29c3048f2e2c = (0, $7NszV.createEntry)((0, $cNynZ.assetsSchemaConfigurationRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $k7I8D.AssetsLayout),
        PageConfigContainerOverride: (0, $7iyOx.AssetsPageConfigContainer),
        skeleton: (0, $kb4zh.default),
        entryPoint: ()=>$c609df68fdefe1cd$var$assetsSchemaSettingsPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-object-schema-configuration',
        resources: [
            ...(0, $55ZOZ.getAssetsAppResources)(),
            (0, $6j0IA.serviceDeskAssetsImportTypeForgeDataResource)
        ],
        forPaint: [
            (0, $k7I8D.LazyAssetsLayout)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-object-schema-config',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
                teamName: 'krispy-krew'
            }
        }
    }));

});
parcelRegister("6j0IA", function(module, exports) {

$parcel$export(module.exports, "serviceDeskAssetsImportTypeForgeDataResource", () => $f0c74bdf86d6b898$export$58d2462746e91c7d);

var $2M1hQ = parcelRequire("2M1hQ");

const $f0c74bdf86d6b898$var$getDataLoader = ()=>(parcelRequire("888RZ"));
const $f0c74bdf86d6b898$export$58d2462746e91c7d = (0, $2M1hQ.createResource)({
    type: 'ASSETS_IMPORT_TYPE_FORGE_DATA',
    getKey: ()=>'extensions',
    getDataLoader: $f0c74bdf86d6b898$var$getDataLoader,
    maxAge: Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});

});
parcelRegister("888RZ", function(module, exports) {

let $5eb5f3744fff0520$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5eb5f3744fff0520$var$load("2FiSC").then(()=>parcelRequire('jwVSb'));

});


parcelRegister("cNynZ", function(module, exports) {

$parcel$export(module.exports, "assetsSchemaConfigurationRoute", () => $a7e42f61407bcdca$export$f27e51e1e8d78f80);
const $a7e42f61407bcdca$export$f27e51e1e8d78f80 = {
    name: 'assets-schema-configuration',
    path: '/jira/assets/configure/object-schema/:objectSchemaId'
};

});

parcelRegister("6acMA", function(module, exports) {

$parcel$export(module.exports, "assetsSchemaSettingsEntryPoint", () => $f8bbd3389b616628$export$b012e15a5f6394fc);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $f8bbd3389b616628$export$b012e15a5f6394fc = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("byrcV")), {
        moduleId: "c93bb7f3",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("byrcV", function(module, exports) {

let $8697f98c2d506ec9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8697f98c2d506ec9$var$load("bfS0F").then(()=>parcelRequire('hEchH'));

});



parcelRegister("9F4ID", function(module, exports) {

$parcel$export(module.exports, "assetsSchemaRouteEntry", () => $28393bd3192d9d9e$export$92c5054123a75324);

var $7NszV = parcelRequire("7NszV");

var $k4Xe9 = parcelRequire("k4Xe9");

var $55ZOZ = parcelRequire("55ZOZ");

var $2iVq4 = parcelRequire("2iVq4");

var $bQHge = parcelRequire("bQHge");

var $lkFvK = parcelRequire("lkFvK");

var $k7I8D = parcelRequire("k7I8D");

var $7iyOx = parcelRequire("7iyOx");

var $kb4zh = parcelRequire("kb4zh");
const $28393bd3192d9d9e$var$assetsSchemaPageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $bQHge.assetsSchemaEntryPoint)
});
const $28393bd3192d9d9e$export$92c5054123a75324 = (0, $7NszV.createEntry)((0, $k4Xe9.assetsSchemaRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $k7I8D.AssetsLayout),
        PageConfigContainerOverride: (0, $7iyOx.AssetsPageConfigContainer),
        skeleton: (0, $kb4zh.default),
        component: (0, $2iVq4.ObjectSchemaV2),
        entryPoint: ()=>$28393bd3192d9d9e$var$assetsSchemaPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-object-schema',
        resources: (0, $55ZOZ.getAssetsAppResources)(),
        forPaint: [
            (0, $k7I8D.LazyAssetsLayout)
        ],
        perfMetricKey: 'service-management.insight-cmdb.load-schema-page'
    }));

});
parcelRegister("k4Xe9", function(module, exports) {

$parcel$export(module.exports, "assetsSchemaRoute", () => $edb3724412b3283d$export$9515b8d2f9c8b12d);
const $edb3724412b3283d$export$9515b8d2f9c8b12d = {
    name: 'assets-schema',
    path: '/jira/assets/object-schema/:objectSchemaId'
};

});

parcelRegister("2iVq4", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskCmdbObjectSchemaV2", () => $3c1950a2c10ba0ce$export$1e50d5a65ac4f5fc);
$parcel$export(module.exports, "ObjectSchemaV2", () => $3c1950a2c10ba0ce$export$f90a4f33c79fd86e);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $3c1950a2c10ba0ce$export$1e50d5a65ac4f5fc = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("7K7HE")), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-object-schema-v2/src/index.tsx"
});
const $3c1950a2c10ba0ce$export$f90a4f33c79fd86e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3c1950a2c10ba0ce$export$1e50d5a65ac4f5fc,
        pageId: "spa-apps/servicedesk/insight/cmdb-object-schema",
        shouldShowSpinner: true
    });
var $3c1950a2c10ba0ce$export$2e2bcd8739ae039 = $3c1950a2c10ba0ce$export$f90a4f33c79fd86e;

});
parcelRegister("7K7HE", function(module, exports) {

let $5a32cdee8aee2363$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $5a32cdee8aee2363$var$load("kNFvF"),
    $5a32cdee8aee2363$var$load("76n7a"),
    $5a32cdee8aee2363$var$load("l253H"),
    $5a32cdee8aee2363$var$load("5fSss")
]).then(()=>parcelRequire('ciybC'));

});


parcelRegister("bQHge", function(module, exports) {

$parcel$export(module.exports, "assetsSchemaEntryPoint", () => $42b8401f19d7a816$export$bbb96f529694d699);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $42b8401f19d7a816$export$bbb96f529694d699 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("7K7HE")), {
        moduleId: "a9175d64",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});


parcelRegister("18W8Q", function(module, exports) {

$parcel$export(module.exports, "assetsSearchRouteEntry", () => $0e927da2b693a3df$export$2a3cf8cc5b9b7e6);

var $7NszV = parcelRequire("7NszV");

var $55ZOZ = parcelRequire("55ZOZ");

var $lkFvK = parcelRequire("lkFvK");

var $k7I8D = parcelRequire("k7I8D");

var $2NDia = parcelRequire("2NDia");

var $ck92c = parcelRequire("ck92c");

var $7iyOx = parcelRequire("7iyOx");

var $kb4zh = parcelRequire("kb4zh");
const $0e927da2b693a3df$var$assetsSearchPageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $ck92c.assetsSearchEntryPoint)
});
const $0e927da2b693a3df$export$2a3cf8cc5b9b7e6 = (0, $7NszV.createEntry)((0, $2NDia.assetsSearchRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $k7I8D.AssetsLayout),
        PageConfigContainerOverride: (0, $7iyOx.AssetsPageConfigContainer),
        skeleton: (0, $kb4zh.default),
        entryPoint: ()=>$0e927da2b693a3df$var$assetsSearchPageEntryPoint,
        resources: (0, $55ZOZ.getAssetsAppResources)(),
        forPaint: [
            (0, $k7I8D.LazyAssetsLayout)
        ],
        perfMetricKey: 'assets-app.interact-with-search-page'
    }));

});
parcelRegister("2NDia", function(module, exports) {

$parcel$export(module.exports, "assetsSearchRoute", () => $a566f1c309df793b$export$6d41f99fb1a055c0);
const $a566f1c309df793b$export$6d41f99fb1a055c0 = {
    name: 'assets-search-results',
    path: '/jira/assets/search',
    exact: true
};

});

parcelRegister("ck92c", function(module, exports) {

$parcel$export(module.exports, "assetsSearchEntryPoint", () => $e8212bc60c70e700$export$5752b60b3fc851fc);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $e8212bc60c70e700$export$5752b60b3fc851fc = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("dgjY0")).then((module)=>module.AssetsAppSearchEntrypointWrapper), {
        moduleId: "49468062",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("dgjY0", function(module, exports) {

let $9a7c41fe3f95e532$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9a7c41fe3f95e532$var$load("ffQaD"),
    $9a7c41fe3f95e532$var$load("kvRbA"),
    $9a7c41fe3f95e532$var$load("kVX56"),
    $9a7c41fe3f95e532$var$load("7mIf9"),
    $9a7c41fe3f95e532$var$load("jXweD"),
    $9a7c41fe3f95e532$var$load("fliVL"),
    $9a7c41fe3f95e532$var$load("3lea0")
]).then(()=>parcelRequire('afJlR'));

});



parcelRegister("3ss0y", function(module, exports) {

$parcel$export(module.exports, "boardsDirectoryRedirectRouteEntry", () => $819db157557bdd41$export$2a34d21ecf479c40);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $bPjHb = parcelRequire("bPjHb");

var $3RJkv = parcelRequire("3RJkv");

var $6tsdD = parcelRequire("6tsdD");

var $ds5qV = parcelRequire("ds5qV");

var $cFtGt = parcelRequire("cFtGt");

var $6Ja6c = parcelRequire("6Ja6c");
const $819db157557bdd41$var$BoardsDirectoryRedirect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: "/jira/boards"
    });
const $819db157557bdd41$export$2a34d21ecf479c40 = (0, $7NszV.createEntry)((0, $6tsdD.boardsDirectoryRedirectRoute), ()=>({
        group: 'directories',
        component: $819db157557bdd41$var$BoardsDirectoryRedirect,
        skeleton: (0, $cFtGt.BoardsDirectorySkeleton),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bPjHb.boardsDirectoryResource)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6Ja6c.LazyBoardsDirectory)
        ],
        isRedirect: true
    }));

});
parcelRegister("bPjHb", function(module, exports) {

$parcel$export(module.exports, "boardsDirectoryResource", () => $817f387e86427323$export$2646f173fa2c14f2);

var $kbVA4 = parcelRequire("kbVA4");

var $2M1hQ = parcelRequire("2M1hQ");


const $817f387e86427323$export$2646f173fa2c14f2 = (0, $2M1hQ.createResource)({
    type: (0, $ee6731a28d0b2341$export$87526c4bd9c78abc),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("dO46Z")),
    maxAge: (0, $kbVA4.MIN_MAX_AGE)
});

});
const $ee6731a28d0b2341$export$87526c4bd9c78abc = 'BOARDS_DIRECTORY';

parcelRegister("dO46Z", function(module, exports) {

let $a0d3225d41019c94$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a0d3225d41019c94$var$load("7H3O2").then(()=>parcelRequire('goVIR'));

});


parcelRegister("6tsdD", function(module, exports) {

$parcel$export(module.exports, "boardsDirectoryRedirectRoute", () => $de45f7ff4b8bd3d7$export$a4fba1ebd6ba91ee);
const $de45f7ff4b8bd3d7$export$a4fba1ebd6ba91ee = {
    name: 'boards-directory-redirect',
    path: '/secure/ManageRapidViews.jspa'
};

});

parcelRegister("cFtGt", function(module, exports) {

$parcel$export(module.exports, "BoardsDirectorySkeleton", () => $4855316d4f3a3ac5$export$8194d6e87709f042);
$parcel$export(module.exports, "DashboardsDirectorySkeleton", () => $4855316d4f3a3ac5$export$75ef2bfed3801fb1);
$parcel$export(module.exports, "FiltersDirectorySkeleton", () => $4855316d4f3a3ac5$export$e76f94817327da1);
$parcel$export(module.exports, "ProjectsDirectorySkeleton", () => $4855316d4f3a3ac5$export$d94befb0e231760c);
$parcel$export(module.exports, "PlansDirectorySkeleton", () => $4855316d4f3a3ac5$export$6cd26a09efd6d158);

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $1UbEn = parcelRequire("1UbEn");

var $gd6BN = parcelRequire("gd6BN");

var $eKB9J = parcelRequire("eKB9J");

var $lnW2o = parcelRequire("lnW2o");
const $4855316d4f3a3ac5$export$8194d6e87709f042 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1UbEn)))
    });
const $4855316d4f3a3ac5$export$75ef2bfed3801fb1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gd6BN)))
    });
const $4855316d4f3a3ac5$export$e76f94817327da1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eKB9J)))
    });
const $4855316d4f3a3ac5$export$d94befb0e231760c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lnW2o)))
    });
const $4855316d4f3a3ac5$export$6cd26a09efd6d158 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lnW2o)))
    });

});
parcelRegister("1UbEn", function(module, exports) {
module.exports = new URL("boards-directory-app-skeleton.tpl.e4de30a4.svg", import.meta.url).toString();

});

parcelRegister("gd6BN", function(module, exports) {
module.exports = new URL("dashboards-directory-app-skeleton.tpl.eb730072.svg", import.meta.url).toString();

});

parcelRegister("eKB9J", function(module, exports) {
module.exports = new URL("filters-directory-app-skeleton.tpl.6583ea61.svg", import.meta.url).toString();

});

parcelRegister("lnW2o", function(module, exports) {
module.exports = new URL("projects-directory-app-skeleton.tpl.a21368f6.svg", import.meta.url).toString();

});


parcelRegister("6Ja6c", function(module, exports) {

$parcel$export(module.exports, "LazyBoardsDirectory", () => $63ac430661b12a63$export$2826049ae45f4cd);

var $7yO8g = parcelRequire("7yO8g");

var $kxZPA = parcelRequire("kxZPA");

const $63ac430661b12a63$export$2826049ae45f4cd = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("2v2yL"))), {
    moduleId: "./src/packages/spa-apps/directories/boards/src/index.tsx"
});

});
parcelRegister("2v2yL", function(module, exports) {

let $1d2076511bf45ba6$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $1d2076511bf45ba6$var$load("ffQaD"),
    $1d2076511bf45ba6$var$load("kvRbA"),
    $1d2076511bf45ba6$var$load("9PdWC")
]).then(()=>parcelRequire('3geiu'));

});



parcelRegister("bNtXI", function(module, exports) {

$parcel$export(module.exports, "boardsDirectoryRouteEntry", () => $bb811a13740c7cf1$export$e78b34c999194638);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $bPjHb = parcelRequire("bPjHb");

var $3RJkv = parcelRequire("3RJkv");

var $jP33S = parcelRequire("jP33S");

var $cFtGt = parcelRequire("cFtGt");

var $5j7Th = parcelRequire("5j7Th");

var $6Ja6c = parcelRequire("6Ja6c");
const $bb811a13740c7cf1$var$BoardsDirectoryComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $6Ja6c.LazyBoardsDirectory),
        pageId: "boards-directory",
        shouldShowSpinner: false
    });
const $bb811a13740c7cf1$export$e78b34c999194638 = (0, $7NszV.createEntry)((0, $jP33S.boardsDirectoryRoute), ()=>({
        group: 'directories',
        component: $bb811a13740c7cf1$var$BoardsDirectoryComponent,
        skeleton: (0, $cFtGt.BoardsDirectorySkeleton),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bPjHb.boardsDirectoryResource)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6Ja6c.LazyBoardsDirectory)
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("jP33S", function(module, exports) {

$parcel$export(module.exports, "boardsDirectoryRoute", () => $3c2c0ea0e55873e8$export$f0fc6f4e8be87e85);
const $3c2c0ea0e55873e8$export$f0fc6f4e8be87e85 = {
    name: 'boards-directory',
    path: '/jira/boards'
};

});


parcelRegister("eAlzO", function(module, exports) {

$parcel$export(module.exports, "browseConversationsRouteEntry", () => $88c89130df57850c$export$b81210c1c5fc2e86);

var $c04PQ = parcelRequire("c04PQ");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $gvZrS = parcelRequire("gvZrS");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $cOR6Z = parcelRequire("cOR6Z");

var $2IBFQ = parcelRequire("2IBFQ");

var $lkFvK = parcelRequire("lkFvK");

var $k6R7C = parcelRequire("k6R7C");
const $88c89130df57850c$var$browseConversationsPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $2IBFQ.browseConversationsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $88c89130df57850c$export$b81210c1c5fc2e86 = (0, $7NszV.createEntry)((0, $gvZrS.browseConversationsRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $c04PQ.isFedRamp)()) return undefined;
            return $88c89130df57850c$var$browseConversationsPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $k6R7C.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $cOR6Z.VirtualAgentBrowseConversationsSkeleton),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_BROWSE_CONVERSATIONS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_BROWSE_CONVERSATIONS),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }));

});
parcelRegister("cOR6Z", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentBrowseConversationsSkeleton", () => $93c172d4ef4f57d3$export$4a6267fad85ca589);
/* VirtualAgentBrowseConversationsSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $94zcy = parcelRequire("94zcy");
const $93c172d4ef4f57d3$var$customStyles = null;
const $93c172d4ef4f57d3$export$4a6267fad85ca589 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($94zcy))),
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("94zcy", function(module, exports) {
module.exports = new URL("virtual-agent-browse-conversations-app-skeleton.tpl.9f030add.svg", import.meta.url).toString();

});


parcelRegister("2IBFQ", function(module, exports) {

$parcel$export(module.exports, "browseConversationsEntryPoint", () => $d5456be03cb88be5$export$38549013d5d5a440);

var $iAqTc = parcelRequire("iAqTc");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");
const $d5456be03cb88be5$var$DEFAULT_RANGE_DAYS = 14;

const $d5456be03cb88be5$export$38549013d5d5a440 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("774VO")), {
        moduleId: "1bf85952",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const end = new Date();
        const start = new Date(end);
        start.setDate(start.getDate() - $d5456be03cb88be5$var$DEFAULT_RANGE_DAYS);
        return {
            extraProps: {
                initialDateRange: {
                    start: start,
                    end: end
                }
            },
            queries: {
                page: {
                    parameters: (0, $iAqTc.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey?.toUpperCase() ?? '',
                        startDate: start.toISOString(),
                        endDate: end.toISOString()
                    }
                }
            }
        };
    }
});

});
parcelRegister("iAqTc", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a4522a333dd4135$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<283ed4f377b201f98d14321a82b83de5>>
 * @relayHash 02e143cfdd95667a01d51463a678a48c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 19a45252d433996c267e9e919b0907677c72d7ab779a1d8cf1a338ce162c39ae

var $d4rfp = parcelRequire("d4rfp");

var $7oHmH = parcelRequire("7oHmH");
const $6a4522a333dd4135$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "19a45252d433996c267e9e919b0907677c72d7ab779a1d8cf1a338ce162c39ae",
        "metadata": {},
        "name": "srcVirtualAgentBrowseConversationsQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcisconversationfilterenabledrelayprovider": (0, $d4rfp.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $7oHmH.default)
        }
    }
};
var $6a4522a333dd4135$export$2e2bcd8739ae039 = $6a4522a333dd4135$var$node;

});
parcelRegister("d4rfp", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b78ba3d71d6b015$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $2b78ba3d71d6b015$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('expose_channels_on_va_conversation_history');
    }
};

});


parcelRegister("774VO", function(module, exports) {

let $52dd031c98259e0c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $52dd031c98259e0c$var$load("cJYN0").then(()=>parcelRequire('azR8x'));

});



parcelRegister("3KtPD", function(module, exports) {

$parcel$export(module.exports, "browseIntentsRouteEntry", () => $4f05bc6eb45d46da$export$da5f3658bd3ecdde);

var $c04PQ = parcelRequire("c04PQ");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6oHoX = parcelRequire("6oHoX");

var $e9YVH = parcelRequire("e9YVH");

var $lgNzP = parcelRequire("lgNzP");

var $aAhML = parcelRequire("aAhML");

var $lkFvK = parcelRequire("lkFvK");

var $cNMs5 = parcelRequire("cNMs5");

var $k6R7C = parcelRequire("k6R7C");
const $4f05bc6eb45d46da$var$browseIntentsPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $cNMs5.browseIntentsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $4f05bc6eb45d46da$export$da5f3658bd3ecdde = (0, $7NszV.createEntry)((0, $6oHoX.browseIntentsRoute), ()=>({
        group: 'project-settings-servicedesk',
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $c04PQ.isFedRamp)()) return undefined;
            return $4f05bc6eb45d46da$var$browseIntentsPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $k6R7C.FedRAMPFallbackRedirectToProjectSettings),
        layout: (0, $lgNzP.browseIntentsLayout),
        skeleton: (0, $aAhML.VirtualAgentBrowseIntentsSkeleton),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_BROWSE_INTENTS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_BROWSE_INTENTS),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }));

});
parcelRegister("lgNzP", function(module, exports) {

$parcel$export(module.exports, "browseIntentsLayout", () => $3f16128d6d3a9eb8$export$6659f41b213bad05);

var $2vSU6 = parcelRequire("2vSU6");

var $aPfsS = parcelRequire("aPfsS");

var $6Z2mh = parcelRequire("6Z2mh");

var $epSYp = parcelRequire("epSYp");
// TODO Remove this whenever all service project route paths are no longer ambiguous
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3f16128d6d3a9eb8$var$withServiceProjectContext = (Component)=>(0, $aPfsS.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $2vSU6.SERVICE_DESK_PROJECT)
        }
    });
const $3f16128d6d3a9eb8$export$6659f41b213bad05 = (0, $aPfsS.composeLayouts)((0, $6Z2mh.serviceProjectLayout), {
    rightSidebars: [
        $3f16128d6d3a9eb8$var$withServiceProjectContext((0, $epSYp.default))
    ]
});

});
parcelRegister("epSYp", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdb5ff159e084339$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $hsmeR = parcelRequire("hsmeR");

var $dAfqg = parcelRequire("dAfqg");

var $iwtyI = parcelRequire("iwtyI");

var $av9sZ = parcelRequire("av9sZ");

var $Y6PAl = parcelRequire("Y6PAl");

var $koeKL = parcelRequire("koeKL");

var $4R6GH = parcelRequire("4R6GH");
const $cdb5ff159e084339$var$runtimeProps = {};
const $cdb5ff159e084339$export$36ad24b9ac79bdc8 = ()=>{
    const rightSidebarCurrentState = (0, $hsmeR.useActiveRightSidebarState)();
    const panelId = rightSidebarCurrentState?.panelId ?? '';
    const cloudId = (0, $koeKL.useCloudId)();
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            key: projectContextData?.projectKey ?? '',
            isHideIntentDiscoveryWhenVaNotConfiguredEnabled: (0, $4R6GH.fg)('hide_intent_discovery_copy_when_va_not_configured')
        }), [
        cloudId,
        projectContextData
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $iwtyI.virtualAgentCreateIntentTemplateSidebarEntryPoint), entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (panelId === 'intentTemplate') entryPointActions.load();
        else entryPointActions.unload();
    }, [
        entryPointActions,
        panelId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "createIntentTemplatesSidebar",
        packageName: "jiraServicedeskSettingsVirtualAgentCreateIntentTemplates",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Y6PAl.VirtualAgentIntentTemplateSidebarSkeleton), null),
        errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cdb5ff159e084339$var$SideBarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $av9sZ.ErrorDisplay), {
                refetch: ()=>window.location.reload()
            })),
        runtimeProps: $cdb5ff159e084339$var$runtimeProps
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $cdb5ff159e084339$var$SideBarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1kl7udwz _1e0c1txw _2lx21bp4 _bfhk1bhr _vchhusvi _1p57u2gc _4t3i1osq _18m91wug",
            __cmplp.className
        ])
    });
});
var $cdb5ff159e084339$export$2e2bcd8739ae039 = $cdb5ff159e084339$export$36ad24b9ac79bdc8;

});
parcelRegister("7XluA", function(module, exports) {

$parcel$export(module.exports, "JiraEntryPointContainer", () => $f4c300dcb0cbacff$export$ee1e46af8fa2fb93);
$parcel$export(module.exports, "NestedEntryPointContainer", () => $f4c300dcb0cbacff$export$54db9e88249c9162);

var $5uXOq = parcelRequire("5uXOq");

var $8Bm0k = parcelRequire("8Bm0k");

var $c5vfY = parcelRequire("c5vfY");
const $f4c300dcb0cbacff$export$ee1e46af8fa2fb93 = ({ entryPointReferenceSubject: entryPointReferenceSubject, ...containerProps })=>{
    const entryPointReference = (0, $8Bm0k.useEntryPointSubscription)(entryPointReferenceSubject);
    return entryPointReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c5vfY.InternalEntryPointContainer), {
        ...containerProps,
        entryPointReference: entryPointReference,
        placeholderName: "jira-entry-point-container"
    }) : null;
};
const $f4c300dcb0cbacff$export$54db9e88249c9162 = (0, $c5vfY.InternalEntryPointContainer);

});
parcelRegister("8Bm0k", function(module, exports) {

$parcel$export(module.exports, "useEntryPointSubscription", () => $0458c70c3d6616bf$export$3cd1c81e13390c49);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");
const $0458c70c3d6616bf$export$3cd1c81e13390c49 = (subject)=>{
    const [entryPointReference, setEntryPointReference] = (0, $5uXOq.useState)(subject.getValue);
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = subject.subscribe(setEntryPointReference);
        setEntryPointReference(subject.getValue());
        return unsubscribe;
    }, [
        subject
    ]);
    // We should never provide an entrypoint that has been disposed.
    // This check guards against race conditions that could be triggered by the entrypoint load manager + concurrent rendering.
    if (entryPointReference?.isDisposed && (0, $4R6GH.fg)('jira-concurrent-entrypoint-fix')) return null;
    return entryPointReference;
};

});

parcelRegister("c5vfY", function(module, exports) {

$parcel$export(module.exports, "InternalEntryPointContainer", () => $df42b2d5b5551f77$export$5d4dc37edd8a3adb);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $l8ruj = parcelRequire("l8ruj");
const $df42b2d5b5551f77$export$5d4dc37edd8a3adb = ({ entryPointReference: entryPointReference, errorAttributes: errorAttributes, errorFallback: errorFallback, fallback: fallback, id: id, packageName: packageName, placeholderName: placeholderName, runtimeProps: runtimeProps, teamName: teamName })=>/* eslint-disable-next-line jira/ufo/valid-labels */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: id,
        packageName: packageName,
        teamName: teamName,
        attributes: errorAttributes,
        fallback: errorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: placeholderName ?? packageName ?? 'internal-entry-point-container',
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
        entryPointReference: entryPointReference,
        props: runtimeProps
    }))));

});


parcelRegister("4mO32", function(module, exports) {

$parcel$export(module.exports, "useEntryPoint", () => $f8987436643ccece$export$338256068bc140fb);

var $5uXOq = parcelRequire("5uXOq");

var $cutA3 = parcelRequire("cutA3");

var $4R6GH = parcelRequire("4R6GH");

var $c8WsS = parcelRequire("c8WsS");

var $9CqsK = parcelRequire("9CqsK");

var $j1gA4 = parcelRequire("j1gA4");

var $bzXq1 = parcelRequire("bzXq1");
const $f8987436643ccece$export$338256068bc140fb = (entryPoint, entryPointParams, metric, options = (0, $c8WsS.DEFAULT_OPTIONS))=>{
    // TODO: break tests on instability (stableEntryPointParams!==entryPointParams)
    // prevents {} from from triggering updates
    const stableEntryPointParams = (0, $cutA3.useShallowStableReference)(entryPointParams, (0, $4R6GH.fg)('jfp_magma_entrypoint-stability'));
    const { entryPointReferenceSubject: entryPointReferenceSubject, ...loadActions } = (0, $j1gA4.useEntryPointLoadManager)(entryPoint, stableEntryPointParams);
    const { startMetric: startMetric, stopMetric: stopMetric } = (0, $bzXq1.useMetricLogger)(metric);
    const entryPointActions = (0, $9CqsK.useEntryPointActions)(loadActions, options, startMetric);
    return (0, $5uXOq.useMemo)(()=>({
            entryPointActions: entryPointActions,
            entryPointReferenceSubject: entryPointReferenceSubject,
            stopMetric: stopMetric
        }), [
        entryPointActions,
        entryPointReferenceSubject,
        stopMetric
    ]);
};

});
parcelRegister("cutA3", function(module, exports) {

$parcel$export(module.exports, "useShallowStableReference", () => $43441358a7826a3c$export$cb8a85c49e39f60);
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions */ 
var $5uXOq = parcelRequire("5uXOq");

var $9pe79 = parcelRequire("9pe79");
const $43441358a7826a3c$var$STABLE_EMPTY_OBJECT = Object.freeze({});
const $43441358a7826a3c$var$STABLE_EMPTY_ARRAY = Object.freeze([]);
const $43441358a7826a3c$export$419c5efa1812e327 = ()=>$43441358a7826a3c$var$STABLE_EMPTY_OBJECT;
const $43441358a7826a3c$export$d81919e21b7bcda0 = ()=>$43441358a7826a3c$var$STABLE_EMPTY_ARRAY;
const $43441358a7826a3c$export$abf22ef229d645f7 = (value)=>Object.keys(value).length === 0 ? $43441358a7826a3c$var$STABLE_EMPTY_OBJECT : value;
const $43441358a7826a3c$export$540f03090e93e8f6 = (value)=>value.length === 0 ? $43441358a7826a3c$var$STABLE_EMPTY_ARRAY : value;
function $43441358a7826a3c$export$cb8a85c49e39f60(props, isEnabled = true) {
    const ref = (0, $5uXOq.useRef)(props);
    if (!isEnabled) return props;
    if (!(0, $9pe79.default)(props, ref.current)) ref.current = props;
    return ref.current;
}

});

parcelRegister("c8WsS", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_OPTIONS", () => $34664e57314d5c26$export$93ca5d3f8675ae4c);
const $34664e57314d5c26$export$93ca5d3f8675ae4c = {
    preloadMaxAge: 2000,
    timeToIntent: 200
};

});

parcelRegister("9CqsK", function(module, exports) {

$parcel$export(module.exports, "useEntryPointActions", () => $7bc2afeacf23b901$export$90681c8c3a56f09a);

var $5uXOq = parcelRequire("5uXOq");

var $jp5kW = parcelRequire("jp5kW");

var $c8WsS = parcelRequire("c8WsS");
const $7bc2afeacf23b901$var$PRELOAD_KILLSWITCH = 'entry_point_preload';
const $7bc2afeacf23b901$export$90681c8c3a56f09a = ({ loadEntryPoint: loadEntryPoint, unloadEntryPoint: unloadEntryPoint, commitPreload: commitPreload }, { preloadMaxAge: preloadMaxAge = (0, $c8WsS.DEFAULT_OPTIONS).preloadMaxAge, timeToIntent: timeToIntent = (0, $c8WsS.DEFAULT_OPTIONS).timeToIntent }, startMetric)=>{
    const preloadIntentTimeout = (0, $5uXOq.useRef)();
    const preloadMaxAgeTimeout = (0, $5uXOq.useRef)();
    const preloadLastRequested = (0, $5uXOq.useRef)(0);
    const cancelPreload = (0, $5uXOq.useCallback)(()=>{
        if (!(0, $jp5kW.default)($7bc2afeacf23b901$var$PRELOAD_KILLSWITCH)) {
            clearTimeout(preloadIntentTimeout.current);
            clearTimeout(preloadMaxAgeTimeout.current);
        }
    }, []);
    const load = (0, $5uXOq.useCallback)(()=>{
        cancelPreload();
        startMetric(preloadLastRequested.current);
        if (preloadLastRequested.current > 0) commitPreload();
        else loadEntryPoint();
        preloadLastRequested.current = 0;
    }, [
        cancelPreload,
        commitPreload,
        loadEntryPoint,
        startMetric
    ]);
    const preload = (0, $5uXOq.useCallback)(()=>{
        if ((0, $jp5kW.default)($7bc2afeacf23b901$var$PRELOAD_KILLSWITCH)) return;
        cancelPreload();
        preloadIntentTimeout.current = setTimeout(()=>{
            preloadLastRequested.current = Date.now();
            loadEntryPoint({
                isPreload: true
            });
            preloadMaxAgeTimeout.current = setTimeout(()=>{
                preloadLastRequested.current = 0;
            }, preloadMaxAge);
        }, timeToIntent);
    }, [
        cancelPreload,
        loadEntryPoint,
        preloadMaxAge,
        timeToIntent
    ]);
    (0, $5uXOq.useEffect)(()=>cancelPreload, [
        cancelPreload
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            cancelPreload: cancelPreload,
            load: load,
            preload: preload,
            unload: unloadEntryPoint
        }), [
        cancelPreload,
        load,
        preload,
        unloadEntryPoint
    ]);
};

});

parcelRegister("j1gA4", function(module, exports) {

$parcel$export(module.exports, "useEntryPointLoadManager", () => $d6e83c6db8fa388b$export$bfae318f9651db2f);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $fiv1r = parcelRequire("fiv1r");

var $iU8T2 = parcelRequire("iU8T2");
const $d6e83c6db8fa388b$export$bfae318f9651db2f = (entryPoint, entryPointParams)=>{
    const environmentProvider = (0, $fiv1r.useJiraRelayEnvironmentProvider)();
    const canLoad = (0, $5uXOq.useRef)(true);
    const timer = (0, $5uXOq.useRef)();
    const removeInactiveLoadsIdleCallback = (0, $5uXOq.useRef)(null);
    const entryPointReferenceQueue = (0, $5uXOq.useRef)([]);
    const { getValue: getValue, setEntryPointReference: setEntryPointReference, subscribe: subscribe } = (0, $iU8T2.useEntryPointReferenceSubject)(entryPoint);
    const setNextUpdate = (0, $5uXOq.useCallback)((nextEntryPointReference)=>{
        setEntryPointReference(nextEntryPointReference);
        if ((0, $4R6GH.fg)('jira-concurrent-entrypoint-fix')) {
            // Delay clean up to prioritise render cycle in case
            // prior queries get used again
            $d6e83c6db8fa388b$var$maybeCancelIdleCallback(removeInactiveLoadsIdleCallback.current);
            removeInactiveLoadsIdleCallback.current = $d6e83c6db8fa388b$var$callWhenIdle(()=>{
                const { current: currentQueue } = entryPointReferenceQueue;
                entryPointReferenceQueue.current = nextEntryPointReference === null ? (0, $iU8T2.removeAll)(currentQueue) : (0, $iU8T2.removeInactiveLoads)(currentQueue);
            });
        } else // Delay clean up to prioritise render cycle in case
        // prior queries get used again
        timer.current = setTimeout(()=>{
            const { current: currentQueue } = entryPointReferenceQueue;
            entryPointReferenceQueue.current = nextEntryPointReference === null ? (0, $iU8T2.removeAll)(currentQueue) : (0, $iU8T2.removeInactiveLoads)(currentQueue);
        }, 0);
    }, [
        setEntryPointReference
    ]);
    const load = (0, $5uXOq.useCallback)(({ isPreload: isPreload } = {
        isPreload: false
    })=>{
        if (canLoad.current) {
            const reference = (0, $8Uumt.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams);
            entryPointReferenceQueue.current.unshift({
                value: reference,
                isPreload: isPreload
            });
            if (isPreload) entryPointReferenceQueue.current = (0, $iU8T2.removeRedundantPreloads)(entryPointReferenceQueue.current);
            else setNextUpdate(reference);
        }
    }, [
        entryPoint,
        entryPointParams,
        environmentProvider,
        setNextUpdate
    ]);
    const unload = (0, $5uXOq.useCallback)(()=>{
        setNextUpdate(null);
    }, [
        setNextUpdate
    ]);
    const commitPreload = (0, $5uXOq.useCallback)(()=>{
        const [firstItem] = entryPointReferenceQueue.current;
        if (firstItem?.isPreload) {
            firstItem.isPreload = false;
            setNextUpdate(firstItem.value);
        }
    }, [
        setNextUpdate
    ]);
    if ((0, $4R6GH.fg)('jira-concurrent-entrypoint-fix')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        // In concurrent mode especially with strict mode, we would get stuck on canLoad.current = false
        // and it would never be turned back on to true without this
        canLoad.current = true;
        return ()=>{
            $d6e83c6db8fa388b$var$maybeCancelIdleCallback(removeInactiveLoadsIdleCallback.current);
            canLoad.current = false;
            entryPointReferenceQueue.current = (0, $iU8T2.removeAll)(entryPointReferenceQueue.current);
        };
    }, []);
    else // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>()=>{
            clearTimeout(timer.current);
            canLoad.current = false;
            entryPointReferenceQueue.current = (0, $iU8T2.removeAll)(entryPointReferenceQueue.current);
        }, []);
    return {
        entryPointReferenceSubject: (0, $5uXOq.useMemo)(()=>({
                getValue: getValue,
                subscribe: subscribe
            }), [
            getValue,
            subscribe
        ]),
        loadEntryPoint: load,
        unloadEntryPoint: unload,
        commitPreload: commitPreload
    };
};
function $d6e83c6db8fa388b$var$callWhenIdle(callback) {
    if ('requestIdleCallback' in window && typeof requestIdleCallback === 'function') return requestIdleCallback(callback);
    if ('requestAnimationFrame' in window && typeof requestAnimationFrame === 'function') return requestAnimationFrame(callback);
    return setTimeout(callback, 0);
}
function $d6e83c6db8fa388b$var$maybeCancelIdleCallback(idleCallbackId) {
    if (idleCallbackId === null) return;
    if ('cancelIdleCallback' in window && typeof cancelIdleCallback === 'function') {
        if (typeof idleCallbackId === 'number') return cancelIdleCallback(idleCallbackId);
        return;
    }
    if ('cancelAnimationFrame' in window && typeof cancelAnimationFrame === 'function') {
        if (typeof idleCallbackId === 'number') return cancelAnimationFrame(idleCallbackId);
        return;
    }
    return clearTimeout(idleCallbackId);
}

});
parcelRegister("fiv1r", function(module, exports) {

$parcel$export(module.exports, "default", () => $41dee5a929ec50c3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useJiraRelayEnvironmentProvider", () => $41dee5a929ec50c3$export$83fb48644dee72f0);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $5yJb9 = parcelRequire("5yJb9");
function $41dee5a929ec50c3$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.RelayEnvironmentProvider), {
        environment: (0, $5yJb9.default)()
    }, children);
}
function $41dee5a929ec50c3$export$83fb48644dee72f0() {
    const environment = (0, $8Uumt.useRelayEnvironment)();
    return (0, $5uXOq.useMemo)(()=>({
            getEnvironment () {
                return environment;
            }
        }), [
        environment
    ]);
}

});

parcelRegister("iU8T2", function(module, exports) {

$parcel$export(module.exports, "removeRedundantPreloads", () => $011b3d8d407c2901$export$a5b3b808f05fede2);
$parcel$export(module.exports, "removeInactiveLoads", () => $011b3d8d407c2901$export$ae329fe3ea179cb4);
$parcel$export(module.exports, "removeAll", () => $011b3d8d407c2901$export$1cfc7aad5cb1833b);
$parcel$export(module.exports, "useEntryPointReferenceSubject", () => $011b3d8d407c2901$export$322c8997d351da6a);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $4R6GH = parcelRequire("4R6GH");
const $011b3d8d407c2901$export$a5b3b808f05fede2 = (queue)=>{
    const [, ...potentialRedundantItems] = queue;
    potentialRedundantItems.forEach(({ isPreload: isPreload, value: value })=>{
        if (isPreload) value.dispose();
    });
    return queue.filter(({ value: value })=>!value.isDisposed);
};
const $011b3d8d407c2901$export$ae329fe3ea179cb4 = (queue)=>{
    if (queue.length === 0) return [];
    const [activeItem, ...redundantItems] = queue;
    redundantItems.forEach(({ value: value })=>{
        value.dispose();
    });
    return [
        activeItem
    ];
};
const $011b3d8d407c2901$export$1cfc7aad5cb1833b = (queue)=>{
    queue.forEach(({ value: value })=>{
        value.dispose();
    });
    return [];
};
const $011b3d8d407c2901$export$322c8997d351da6a = (entryPoint)=>{
    const value = (0, $5uXOq.useRef)(null);
    const subscribers = (0, $5uXOq.useRef)();
    const unsub = (0, $5uXOq.useRef)(null);
    const subscribe = (0, $5uXOq.useCallback)((subscriber)=>{
        if (!subscribers.current) subscribers.current = new Set();
        subscribers.current.add(subscriber);
        return ()=>{
            subscribers.current?.delete(subscriber);
        };
    }, []);
    const setEntryPointReference = (0, $5uXOq.useCallback)((entryPointReference)=>{
        value.current = entryPointReference;
        const notifySubscribers = ()=>{
            (0, $7nsd3.unstable_batchedUpdates)(()=>{
                if (subscribers.current) Array.from(subscribers.current).forEach((subscriber)=>{
                    subscriber(entryPointReference);
                });
            });
        };
        if ($011b3d8d407c2901$var$isReactAsyncJSResourceReference(entryPoint?.root) && (0, $4R6GH.fg)('jira-concurrent-entrypoint-fix')) unsub.current = entryPoint?.root?.onComplete?.(()=>{
            notifySubscribers();
        });
        else notifySubscribers();
    }, [
        entryPoint
    ]);
    const getValue = (0, $5uXOq.useCallback)(()=>value.current, []);
    (0, $5uXOq.useEffect)(()=>()=>{
            subscribers.current?.clear();
            if ((0, $4R6GH.fg)('jira-concurrent-entrypoint-fix')) unsub.current?.();
        }, []);
    return {
        getValue: getValue,
        setEntryPointReference: setEntryPointReference,
        subscribe: subscribe
    };
};
/**
 * JSResourceReference's in react-relay don't have an onComplete method,
 * but the version that we actually use from @atlassian/react-async does.
 */ function $011b3d8d407c2901$var$isReactAsyncJSResourceReference(value) {
    return Boolean(value && 'onComplete' in value && 'getModuleName' in value);
}

});


parcelRegister("bzXq1", function(module, exports) {

$parcel$export(module.exports, "useMetricLogger", () => $25198ca8fad8a13c$export$f291ec7cea728e1);

var $5uXOq = parcelRequire("5uXOq");
const $25198ca8fad8a13c$export$f291ec7cea728e1 = (metric)=>{
    const preloadStartTime = (0, $5uXOq.useRef)(0);
    const loadStartTime = (0, $5uXOq.useRef)(0);
    const startMetric = (0, $5uXOq.useCallback)((preloadTime = 0)=>{
        if (metric) {
            metric.start();
            preloadStartTime.current = preloadTime;
            loadStartTime.current = Date.now();
        }
    }, [
        metric
    ]);
    const stopMetric = (0, $5uXOq.useCallback)((additionalCustomData)=>{
        if (metric) {
            const preloadData = preloadStartTime.current > 0 ? {
                preloadToStartDuration: loadStartTime.current - preloadStartTime.current
            } : undefined;
            const metricData = preloadData || additionalCustomData ? {
                customData: {
                    ...preloadData,
                    ...additionalCustomData
                }
            } : undefined;
            metric.stop(metricData);
        }
    }, [
        metric
    ]);
    return {
        startMetric: startMetric,
        stopMetric: stopMetric
    };
};

});


parcelRegister("hsmeR", function(module, exports) {

$parcel$export(module.exports, "useActiveRightSidebarState", () => $39a48ee662f10943$export$ba763ab7661c3103);
$parcel$export(module.exports, "useRightSidebarState", () => $39a48ee662f10943$export$d1828e7f46a4960b);
$parcel$export(module.exports, "useRightSidebarController", () => $39a48ee662f10943$export$ebe5e907fb0bb63a);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");

var $byk51 = parcelRequire("byk51");

var $5e5zm = parcelRequire("5e5zm");
const $39a48ee662f10943$var$useActiveRightSidebar = (0, $3sQ5x.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>{
        const rightSidebarState = (0, $byk51.selectCurrentRightSidebar)(state.content.rightSidebar);
        if (!rightSidebarState) return null;
        return {
            ...rightSidebarState,
            shouldRender: !state.isChromeless
        };
    }
});
const $39a48ee662f10943$export$ba763ab7661c3103 = ()=>{
    const [rightSidebar] = $39a48ee662f10943$var$useActiveRightSidebar();
    return rightSidebar;
};
const $39a48ee662f10943$var$useRightSidebar = (0, $3sQ5x.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>state.content.rightSidebar
});
const $39a48ee662f10943$export$d1828e7f46a4960b = ()=>{
    const [rightSidebarState] = $39a48ee662f10943$var$useRightSidebar();
    return rightSidebarState;
};
const $39a48ee662f10943$export$ebe5e907fb0bb63a = ()=>{
    const [, { setRightSidebarState: setRightSidebarState, openRightSidebar: openRightSidebar, closeRightSidebar: closeRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar, closeAllRightSidebar: closeAllRightSidebar, minimiseRightSidebar: minimiseRightSidebar }] = (0, $5e5zm.useLayoutStoreActions)();
    return (0, $5uXOq.useMemo)(()=>({
            setRightSidebarState: setRightSidebarState,
            closeRightSidebar: closeRightSidebar,
            openRightSidebar: openRightSidebar,
            closeCurrentRightSidebar: closeCurrentRightSidebar,
            closeAllRightSidebar: closeAllRightSidebar,
            minimiseRightSidebar: minimiseRightSidebar
        }), [
        closeAllRightSidebar,
        closeCurrentRightSidebar,
        closeRightSidebar,
        openRightSidebar,
        setRightSidebarState,
        minimiseRightSidebar
    ]);
};

});
parcelRegister("byk51", function(module, exports) {

$parcel$export(module.exports, "selectCurrentRightSidebar", () => $4dabd377b098e1a2$export$57758d0cfaeec2c);
$parcel$export(module.exports, "setRightSidebarState", () => $4dabd377b098e1a2$export$f5584170a8c1db02);
$parcel$export(module.exports, "closeAllRightSidebar", () => $4dabd377b098e1a2$export$d91a6e55d52aa3e9);
$parcel$export(module.exports, "closeCurrentRightSidebar", () => $4dabd377b098e1a2$export$a9a5075d3d1b2165);
$parcel$export(module.exports, "closeRightSidebar", () => $4dabd377b098e1a2$export$d7149233c76efb32);
$parcel$export(module.exports, "minimiseRightSidebar", () => $4dabd377b098e1a2$export$4eedf7fa26a2749a);
$parcel$export(module.exports, "openRightSidebar", () => $4dabd377b098e1a2$export$c8dafe074328c4ca);

var $ajpes = parcelRequire("ajpes");
const $4dabd377b098e1a2$var$arrayMove = (array, oldIndex, newIndex)=>{
    const arrayCopy = [
        ...array
    ];
    const f = arrayCopy.splice(oldIndex, 1)[0];
    arrayCopy.splice(newIndex, 0, f);
    return arrayCopy;
};
const $4dabd377b098e1a2$var$dedupe = (stackState = [])=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const visited = {};
    return stackState.filter((item)=>{
        if (visited[item.panelId]) return false;
        visited[item.panelId] = true;
        return true;
    });
};
const $4dabd377b098e1a2$export$57758d0cfaeec2c = (state)=>{
    if (state.stackState.length === 1) return state.stackState[0];
    return state.stackState.find((sidebar)=>!sidebar.isCollapsed && !sidebar.isMinimised) || null;
};
const $4dabd377b098e1a2$export$f5584170a8c1db02 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: $4dabd377b098e1a2$var$dedupe(newState.stackState)
                }
            }
        });
    };
const $4dabd377b098e1a2$export$d91a6e55d52aa3e9 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: []
                }
            }
        });
    };
const $4dabd377b098e1a2$export$a9a5075d3d1b2165 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        if (!currentStack.length) return;
        const currentRightSidebar = $4dabd377b098e1a2$export$57758d0cfaeec2c(content.rightSidebar);
        if (!currentRightSidebar) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: content.rightSidebar.stackState.filter((item)=>item !== currentRightSidebar)
                }
            }
        });
    };
const $4dabd377b098e1a2$export$d7149233c76efb32 = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.filter((item)=>item.panelId !== panelId)
                }
            }
        });
    };
const $4dabd377b098e1a2$export$4eedf7fa26a2749a = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.map((item)=>{
                        if (item.panelId !== panelId) return item;
                        return {
                            ...item,
                            isMinimised: true
                        };
                    })
                }
            }
        });
    };
const $4dabd377b098e1a2$export$c8dafe074328c4ca = (panelId, width, isMinimised = false, toTop = false)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const tempRightSidebarStackStateValue = content.rightSidebar.stackState ? [
            ...content.rightSidebar.stackState.map((item)=>{
                if (item.panelId === panelId) return {
                    ...item,
                    isMinimised: isMinimised,
                    width: width
                };
                return item;
            })
        ] : [];
        const matchedPanelIndex = tempRightSidebarStackStateValue.findIndex((obj)=>obj.panelId === panelId);
        // if there's any matched panel id, we only move it to the top of the stack.
        if (matchedPanelIndex >= 0) {
            const nextIdx = toTop ? 0 : tempRightSidebarStackStateValue.length - 1;
            tempRightSidebarStackStateValue[matchedPanelIndex].isCollapsed = false;
            tempRightSidebarStackStateValue[matchedPanelIndex].isMinimised = isMinimised;
            const newRightSidebarStackStateValue = $4dabd377b098e1a2$var$arrayMove(tempRightSidebarStackStateValue, matchedPanelIndex, nextIdx);
            newRightSidebarStackStateValue[nextIdx].width = width;
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: newRightSidebarStackStateValue
                    }
                }
            });
            return;
        }
        const newRightSidebarStackStateValue = toTop ? [
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            },
            ...tempRightSidebarStackStateValue
        ] : [
            ...tempRightSidebarStackStateValue,
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            }
        ];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(newRightSidebarStackStateValue, content.rightSidebar.stackState)) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: newRightSidebarStackStateValue
                }
            }
        });
    };

});

parcelRegister("5e5zm", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", () => $0c99a19d69d506cf$export$539e68c09584883a);
$parcel$export(module.exports, "layoutStore", () => $0c99a19d69d506cf$export$b8cdfd44cddaf07);
$parcel$export(module.exports, "useLayoutStoreActions", () => $0c99a19d69d506cf$export$6136bc3b9858cff4);
$parcel$export(module.exports, "useDetailPanelWidth", () => $0c99a19d69d506cf$export$95fd7b6da3b9bbb0);
$parcel$export(module.exports, "useDetailPanelActions", () => $0c99a19d69d506cf$export$99e05a60cac05e86);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $8CM3x = parcelRequire("8CM3x");
const $0c99a19d69d506cf$export$539e68c09584883a = 240;
const $0c99a19d69d506cf$export$b92df8810d2fcd01 = 0;
const $0c99a19d69d506cf$var$initialState = {
    isChromeless: false,
    isFullscreen: false,
    banner: {
        height: 0,
        activeBanner: null
    },
    topNavigation: {
        isVisible: true
    },
    leftPanel: {
        isVisible: true,
        width: 0
    },
    rightPanel: {
        isVisible: true,
        width: 0
    },
    bottomRightCorner: {
        container: undefined,
        portals: []
    },
    content: {
        leftSidebar: {
            width: $0c99a19d69d506cf$export$539e68c09584883a,
            isCollapsed: true,
            isVisible: true,
            isFlyoutOpen: false
        },
        rightSidebar: {
            stackState: []
        }
    }
};
const $0c99a19d69d506cf$export$b8cdfd44cddaf07 = (0, $iXqE5.createStore)({
    initialState: $0c99a19d69d506cf$var$initialState,
    actions: $8CM3x.actions,
    name: 'JiraLayoutStore'
});
const $0c99a19d69d506cf$export$6136bc3b9858cff4 = (0, $3sQ5x.createHook)($0c99a19d69d506cf$export$b8cdfd44cddaf07, {
    selector: null
});
const $0c99a19d69d506cf$var$detailPanelWidthStore = (0, $iXqE5.createStore)({
    name: 'detailPanelWidth',
    initialState: {
        width: 0
    },
    actions: {
        setWidth: (value)=>({ setState: setState })=>{
                setState({
                    width: value
                });
            }
    }
});
const $0c99a19d69d506cf$export$95fd7b6da3b9bbb0 = (0, $3sQ5x.createHook)($0c99a19d69d506cf$var$detailPanelWidthStore);
const $0c99a19d69d506cf$export$99e05a60cac05e86 = (0, $3sQ5x.createActionsHook)($0c99a19d69d506cf$var$detailPanelWidthStore);

});
parcelRegister("8CM3x", function(module, exports) {

$parcel$export(module.exports, "actions", () => $939ad82f8ddcb8d9$export$e324594224ef24da);

var $4oU0I = parcelRequire("4oU0I");

var $flhve = parcelRequire("flhve");

var $f5TQt = parcelRequire("f5TQt");

var $hPsAX = parcelRequire("hPsAX");

var $gqQUV = parcelRequire("gqQUV");

var $byk51 = parcelRequire("byk51");
const $939ad82f8ddcb8d9$export$e324594224ef24da = {
    setIsChromeless: // global
    $f5TQt.setIsChromeless,
    setIsFullscreen: $hPsAX.setIsFullscreen,
    showBanner: // banner
    $4oU0I.showBanner,
    dismissCurrentBanner: $4oU0I.dismissCurrentBanner,
    setLeftSidebarState: // left-sidebar
    $gqQUV.setLeftSidebarState,
    setRightSidebarState: // right-sidebar
    $byk51.setRightSidebarState,
    openRightSidebar: $byk51.openRightSidebar,
    closeRightSidebar: $byk51.closeRightSidebar,
    closeAllRightSidebar: $byk51.closeAllRightSidebar,
    closeCurrentRightSidebar: $byk51.closeCurrentRightSidebar,
    minimiseRightSidebar: $byk51.minimiseRightSidebar,
    registerBottomRightCornerContainer: // bottom-right-corner
    $flhve.registerBottomRightCornerContainer,
    insertBottomRightCornerPortal: $flhve.insertBottomRightCornerPortal,
    removeBottomRightCornerPortal: $flhve.removeBottomRightCornerPortal
};

});
parcelRegister("4oU0I", function(module, exports) {

$parcel$export(module.exports, "showBanner", () => $820929f36789bf81$export$f5c0eb035ef26e87);
$parcel$export(module.exports, "dismissCurrentBanner", () => $820929f36789bf81$export$a45bccc0cc9ac424);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $820929f36789bf81$export$f5c0eb035ef26e87 = (newState)=>({ setState: setState })=>{
        setState({
            banner: newState
        });
    };
const $820929f36789bf81$export$a45bccc0cc9ac424 = ()=>({ dispatch: dispatch })=>{
        dispatch($820929f36789bf81$export$f5c0eb035ef26e87({
            height: 0,
            activeBanner: null
        }));
    };

});

parcelRegister("flhve", function(module, exports) {

$parcel$export(module.exports, "registerBottomRightCornerContainer", () => $560ff4740e75fa9e$export$2992ecf780497763);
$parcel$export(module.exports, "insertBottomRightCornerPortal", () => $560ff4740e75fa9e$export$3ed25a6bee272520);
$parcel$export(module.exports, "removeBottomRightCornerPortal", () => $560ff4740e75fa9e$export$928bf7e228ce06d2);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $560ff4740e75fa9e$export$2992ecf780497763 = (ref)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                container: ref ?? undefined
            }
        });
    };
const $560ff4740e75fa9e$export$3ed25a6bee272520 = (item)=>// @ts-expect-error - TS2322 - Type '({ setState, getState }: StoreActionApi<LayoutState>) => number' is not assignable to type 'Action<LayoutState, void, void | Promise<void>>'.
    ({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        const sorted = [
            item,
            ...portals
        ].sort((a, b)=>b.orderFromRight - a.orderFromRight);
        const index = sorted.findIndex((portal)=>portal.id === item.id);
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: sorted
            }
        });
        return index;
    };
const $560ff4740e75fa9e$export$928bf7e228ce06d2 = (id)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: portals.filter((portal)=>portal.id !== id)
            }
        });
    };

});

parcelRegister("f5TQt", function(module, exports) {

$parcel$export(module.exports, "setIsChromeless", () => $0389a2d5715d1f25$export$1998c4816ad37edb);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $0389a2d5715d1f25$export$1998c4816ad37edb = (isChromeless)=>({ setState: setState })=>{
        setState({
            isChromeless: isChromeless
        });
    };

});

parcelRegister("hPsAX", function(module, exports) {

$parcel$export(module.exports, "setIsFullscreen", () => $e3c9e6899dc6b3f0$export$9c73b2f282069160);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $e3c9e6899dc6b3f0$export$9c73b2f282069160 = (isFullscreen)=>({ setState: setState })=>{
        setState({
            isFullscreen: isFullscreen
        });
    };

});

parcelRegister("gqQUV", function(module, exports) {

$parcel$export(module.exports, "setLeftSidebarState", () => $54ca906cbb882b25$export$3e0fd2d894ef83c8);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $54ca906cbb882b25$export$3e0fd2d894ef83c8 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                leftSidebar: {
                    ...content.leftSidebar,
                    ...newState
                }
            }
        });
    };

});




parcelRegister("dAfqg", function(module, exports) {

$parcel$export(module.exports, "useProjectContext", () => $0baaa0dcf730951a$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $0baaa0dcf730951a$export$524ef4f6102ed540);
$parcel$export(module.exports, "ProjectContextProvider", () => $0baaa0dcf730951a$export$a85f6b5857d2176);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $dxCvy = parcelRequire("dxCvy");
const $0baaa0dcf730951a$export$8f31c2503e1efa93 = (customContext)=>{
    const { data: data, error: error, loading: loading, update: update, key: key } = (0, $324W5.useResourceWithCustomRouterContext)((0, $dxCvy.projectContextResourceWithCache), customContext);
    const updateCache = (0, $5uXOq.useCallback)((d)=>update(()=>d), [
        update
    ]);
    return {
        data: data,
        error: error,
        loading: loading,
        updateCache: updateCache,
        key: key
    };
};
const $0baaa0dcf730951a$export$524ef4f6102ed540 = ()=>{
    const { data: data } = $0baaa0dcf730951a$export$8f31c2503e1efa93();
    return data?.simplified || false;
};
const $0baaa0dcf730951a$export$a85f6b5857d2176 = ({ children: children })=>{
    const projectContext = $0baaa0dcf730951a$export$8f31c2503e1efa93();
    return children(projectContext);
};

});

parcelRegister("iwtyI", function(module, exports) {

$parcel$export(module.exports, "virtualAgentCreateIntentTemplateSidebarEntryPoint", () => $6713c6429155461a$export$2b1d9dc27ee42f8f);

var $aHrkz = parcelRequire("aHrkz");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $6713c6429155461a$export$2b1d9dc27ee42f8f = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("eFhzq")), {
        moduleId: "a4e9afeb",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, key: key, isHideIntentDiscoveryWhenVaNotConfiguredEnabled: isHideIntentDiscoveryWhenVaNotConfiguredEnabled })=>({
            queries: {
                intentTemplateQueryReference: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: (0, $aHrkz.default),
                    variables: {
                        cloudId: cloudId,
                        key: key,
                        isHideIntentDiscoveryWhenVaNotConfiguredEnabled: isHideIntentDiscoveryWhenVaNotConfiguredEnabled
                    }
                }
            },
            entryPoints: {},
            extraProps: {}
        })
});

});
parcelRegister("aHrkz", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2036dd19a3f68c8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<68ca1ff3c625c48e3b3f34fcd3122e1a>>
 * @relayHash c3ecae5efac1725022957b3584c6748a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d816bb1396041500986a655dbca037f2dba1138371158641897ea361c6ff7286
const $e2036dd19a3f68c8$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "d816bb1396041500986a655dbca037f2dba1138371158641897ea361c6ff7286",
        "metadata": {},
        "name": "uiVirtualAgentIntentTemplatesQuery",
        "operationKind": "query",
        "text": null
    }
};
var $e2036dd19a3f68c8$export$2e2bcd8739ae039 = $e2036dd19a3f68c8$var$node;

});

parcelRegister("eFhzq", function(module, exports) {

let $aad28621c1d0e796$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $aad28621c1d0e796$var$load("fliVL"),
    $aad28621c1d0e796$var$load("5jwWH")
]).then(()=>parcelRequire('dMvBS'));

});


parcelRegister("av9sZ", function(module, exports) {

$parcel$export(module.exports, "ErrorDisplay", () => $09828373404eee09$export$d56b0569bceb92ae);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $hTEpF = parcelRequire("hTEpF");

var $7q5TP = parcelRequire("7q5TP");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $2zwTA = parcelRequire("2zwTA");
const $09828373404eee09$export$d56b0569bceb92ae = ({ refetch: refetch })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        header: formatMessage((0, $2zwTA.default).errorDisplayHeading),
        description: formatMessage((0, $2zwTA.default).errorDisplayDescription),
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $7q5TP.default)),
        imageWidth: 160,
        maxImageHeight: 220,
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            onClick: refetch,
            appearance: "link"
        }, formatMessage((0, $2zwTA.default).reloadNowButtonText))
    });
};

});
parcelRegister("7q5TP", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc8d7b09135bd30b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("3RXYN")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("jb8SM")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = jx8k5z4r4cbqfnn3t56t46v9
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/jx8k5z4r4cbqfnn3t56t46v9

var $dCLgq = parcelRequire("dCLgq");

var $jb8SM = parcelRequire("jb8SM");

var $3RXYN = parcelRequire("3RXYN");
const $dc8d7b09135bd30b$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($3RXYN)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($jb8SM))
});
var $dc8d7b09135bd30b$export$2e2bcd8739ae039 = $dc8d7b09135bd30b$var$Illustration;
// for advanced use only
const $dc8d7b09135bd30b$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    212
];

});
parcelRegister("dCLgq", function(module, exports) {

$parcel$export(module.exports, "Illustration", () => $191b30bb5e9fa934$export$d43c2e2ca9b2c105);
$parcel$export(module.exports, "createIllustration", () => $191b30bb5e9fa934$export$4d00e7be716a0093);

var $5uXOq = parcelRequire("5uXOq");

var $10ozQ = parcelRequire("10ozQ");
function $191b30bb5e9fa934$export$d43c2e2ca9b2c105({ embedAs: embedAs, ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $10ozQ.AsImg), props);
}
function $191b30bb5e9fa934$export$4d00e7be716a0093({ srcLight: srcLight, srcDark: srcDark, autoDark: autoDark }) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($191b30bb5e9fa934$export$d43c2e2ca9b2c105, {
            srcLight: srcLight,
            srcDark: srcDark,
            autoDark: autoDark,
            ...props
        });
}

});
parcelRegister("10ozQ", function(module, exports) {

$parcel$export(module.exports, "AsImg", () => $b5af8835f639f069$export$75e378065cb7d6c0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // This is an INTENTIONAL FORK of @atlaskit/image
// copied 2023-11-09 v1.1.6
// with permission from @DDC from Design System,
// in order to refine the API and use cases.
// Will be back-ported to @atlaskit/image https://hello.atlassian.net/browse/ERAI-1660

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hxoiH = parcelRequire("hxoiH");
// Moved to src/packages/illustrations/illustration/src/ui/types.tsx to avoid circular dependency
// export interface AsImgProps extends IllustrationProps, ImgHTMLAttributes<HTMLImageElement>
// suggested defaults, the consumer is free to override
const $b5af8835f639f069$var$defaultStyles = null;
const $b5af8835f639f069$var$fillStyles = null;
const $b5af8835f639f069$var$autoDarkModeStyles = null;
function $b5af8835f639f069$export$75e378065cb7d6c0({ srcLight: srcLight, srcDark: srcDark = srcLight, autoDark: autoDark = true, alt: alt, fill: fill = false, testId: testId, ...imgProps }) {
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    return /*#__PURE__*/ $5uXOq.createElement("img", {
        src: colorMode === 'dark' ? srcDark : srcLight,
        alt: alt,
        "data-testid": testId,
        ...imgProps,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _tvdr18uv _p12f1osq _4t3i1wug _5ral1f51 _rsuf1h6o",
            fill && "_1r04idpf _kqswstnw _1bsb1osq _4t3i1osq",
            colorMode === 'dark' && srcDark === srcLight && autoDark && "_kdam1ato"
        ])
    });
}

});


parcelRegister("jb8SM", function(module, exports) {
module.exports = new URL("generic-error-darkmode.3646797f.svg", import.meta.url).toString();

});

parcelRegister("3RXYN", function(module, exports) {
module.exports = new URL("generic-error.f200ded6.svg", import.meta.url).toString();

});


parcelRegister("iVgQf", function(module, exports) {

$parcel$export(module.exports, "getAkEmptyStateRenderImageFn", () => $7affac5c7e698fc8$export$ebf64b9217c1b2a3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $4Bpvs = parcelRequire("4Bpvs");
function $7affac5c7e698fc8$export$ebf64b9217c1b2a3(JiraIllustration = (0, $4Bpvs.default)) {
    return ({ maxImageWidth: // we strictly follow EmptyState's defaults
    maxImageWidth = 160, maxImageHeight: maxImageHeight = 160, imageWidth: imageWidth, imageHeight: imageHeight })=>{
        // This wrapper emulates EmptyState's private "HeaderImage" styling
        // @see platform/packages/design-system/empty-state/src/empty-state.tsx
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
        const Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
                ...__cmplp,
                style: {
                    ...__cmpls,
                    "--_yv3y2x": (0, $lD23V.default)(maxImageWidth, "px"),
                    "--_nq7wev": (0, $lD23V.default)(maxImageHeight, "px")
                },
                ref: __cmplr,
                className: (0, $bwpsq.default)([
                    "_1e0c1ule _p12f1x6a _c71lc3ce _19pkidpf _2hwx1wug _otyr1ejb _18u01wug",
                    __cmplp.className
                ])
            });
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(JiraIllustration, {
            alt: "",
            role: "presentation",
            width: imageWidth || 'auto',
            height: imageHeight || 'auto'
        }));
    };
}

});
parcelRegister("4Bpvs", function(module, exports) {

$parcel$export(module.exports, "default", () => $029e22a35a3f42f7$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("gZXfK")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("ieXL6")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = tgxxcm73mk6phg9ttfj3rvpf
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/tgxxcm73mk6phg9ttfj3rvpf

var $dCLgq = parcelRequire("dCLgq");

var $ieXL6 = parcelRequire("ieXL6");

var $gZXfK = parcelRequire("gZXfK");
const $029e22a35a3f42f7$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($gZXfK)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($ieXL6))
});
var $029e22a35a3f42f7$export$2e2bcd8739ae039 = $029e22a35a3f42f7$var$Illustration;
// for advanced use only
const $029e22a35a3f42f7$export$a179c88182cb9d56 = [
    0,
    0,
    235,
    210
];

});
parcelRegister("ieXL6", function(module, exports) {
module.exports = new URL("generic-empty-state-darkmode.27f5dcf1.svg", import.meta.url).toString();

});

parcelRegister("gZXfK", function(module, exports) {
module.exports = new URL("generic-empty-state.1b007192.svg", import.meta.url).toString();

});



parcelRegister("2zwTA", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2ecc7c5e37557c1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b2ecc7c5e37557c1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorDisplayHeading: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.error-display-heading",
        "defaultMessage": "We couldn\u2019t load intent templates"
    },
    errorDisplayDescription: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.error-display-description",
        "defaultMessage": "Wait a moment and then try reloading."
    },
    reloadNowButtonText: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.reload-now-button-text",
        "defaultMessage": "Reload"
    }
});

});


parcelRegister("Y6PAl", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentIntentTemplateSidebarSkeleton", () => $61dfebc80ff570f9$export$fa68b26760d5b66f);
/* VirtualAgentIntentTemplateSidebarSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $o7aiq = parcelRequire("o7aiq");
const $61dfebc80ff570f9$var$customCssStyles = null;
const $61dfebc80ff570f9$export$fa68b26760d5b66f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($o7aiq))),
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("o7aiq", function(module, exports) {
module.exports = new URL("virtual-agent-intent-template-sidebar-app-skeleton.tpl.e2ff8557.svg", import.meta.url).toString();

});


parcelRegister("koeKL", function(module, exports) {

$parcel$export(module.exports, "useCloudId", () => $559e3c14e9652b55$export$9da0f7c65f28ed16);

var $9OXo1 = parcelRequire("9OXo1");
const $559e3c14e9652b55$export$9da0f7c65f28ed16 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.cloudId;
};

});



parcelRegister("aAhML", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentBrowseIntentsSkeleton", () => $47ee42028be217a3$export$444026e4d4f156e4);
$parcel$export(module.exports, "VirtualAgentIntentsTableSkeleton", () => $47ee42028be217a3$export$9dca41144a6398d2);
$parcel$export(module.exports, "VirtualAgentStatisticsSkeleton", () => $47ee42028be217a3$export$538762e63d6466fe);
/* VirtualAgentStatisticsSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $03lq1 = parcelRequire("03lq1");

var $drZ5P = parcelRequire("drZ5P");

var $aT0Jx = parcelRequire("aT0Jx");
const $47ee42028be217a3$var$customCssStyles = null;
const $47ee42028be217a3$export$444026e4d4f156e4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($03lq1))),
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });
const $47ee42028be217a3$export$9dca41144a6398d2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($drZ5P))),
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });
const $47ee42028be217a3$export$538762e63d6466fe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aT0Jx))),
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("03lq1", function(module, exports) {
module.exports = new URL("virtual-agent-browse-intents-app-skeleton.tpl.1eeb33c1.svg", import.meta.url).toString();

});

parcelRegister("drZ5P", function(module, exports) {
module.exports = new URL("virtual-agent-intents-table-app-skeleton.tpl.e28c55f7.svg", import.meta.url).toString();

});

parcelRegister("aT0Jx", function(module, exports) {
module.exports = new URL("virtual-agent-virtual-agent-statistics-app-skeleton.tpl.19ee5056.svg", import.meta.url).toString();

});


parcelRegister("cNMs5", function(module, exports) {

$parcel$export(module.exports, "browseIntentsEntryPoint", () => $0c1a3d6ae6de7f87$export$f19c213ae2d7940f);

var $2VZl9 = parcelRequire("2VZl9");

var $ae5pE = parcelRequire("ae5pE");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");
// When changing the default time range, make sure to also update jira/src/packages/servicedesk/virtual-agent/intents/browse-intents/src/ui/index.tsx
const $0c1a3d6ae6de7f87$var$DEFAULT_TIME_RANGE_MS = 604800000; // 7 days
const $0c1a3d6ae6de7f87$var$formatFetchDate = (date)=>date.toISOString().substring(0, 10);

const $0c1a3d6ae6de7f87$export$f19c213ae2d7940f = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("81aUU")), {
        moduleId: "85089c8d",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $2VZl9.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? ''
                    }
                },
                statistics: {
                    parameters: (0, $ae5pE.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        startDate: $0c1a3d6ae6de7f87$var$formatFetchDate(new Date(Date.now() - $0c1a3d6ae6de7f87$var$DEFAULT_TIME_RANGE_MS)),
                        endDate: $0c1a3d6ae6de7f87$var$formatFetchDate(new Date())
                    }
                }
            }
        })
});

});
parcelRegister("2VZl9", function(module, exports) {

$parcel$export(module.exports, "default", () => $84af76b2b1eda3ac$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<865219262865f0c2fe60a5d42c5b5ac3>>
 * @relayHash 332a18b0c791d5db703346b792e462c6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4f9fa1c86914f21c81c9bc463158fa765c0cb8dda8f8846aa2ac249230746d72

var $7oHmH = parcelRequire("7oHmH");
const $84af76b2b1eda3ac$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "4f9fa1c86914f21c81c9bc463158fa765c0cb8dda8f8846aa2ac249230746d72",
        "metadata": {},
        "name": "srcVirtualAgentBrowseIntentsQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $7oHmH.default)
        }
    }
};
var $84af76b2b1eda3ac$export$2e2bcd8739ae039 = $84af76b2b1eda3ac$var$node;

});

parcelRegister("ae5pE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3c21345417f9f8e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7de08b41c0233f993e9f465f2b55ff1d>>
 * @relayHash 2abd4ad2e8912c8629a5da83f2373cce
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1f5d76d0b50d1729fc79fb483dbf5fd8a89c1dcdb99beeede2b23b9584cca1ac

var $2LxWa = parcelRequire("2LxWa");
const $d3c21345417f9f8e$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "1f5d76d0b50d1729fc79fb483dbf5fd8a89c1dcdb99beeede2b23b9584cca1ac",
        "metadata": {},
        "name": "srcVirtualAgentBrowseIntentsStatisticsQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaenableperformancepagerelayprovider": (0, $2LxWa.default)
        }
    }
};
var $d3c21345417f9f8e$export$2e2bcd8739ae039 = $d3c21345417f9f8e$var$node;

});
parcelRegister("2LxWa", function(module, exports) {

$parcel$export(module.exports, "default", () => $5892cca023449b49$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $5892cca023449b49$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jsm_va_enable_performance_page');
    }
};

});


parcelRegister("81aUU", function(module, exports) {

let $5d66e297400a54e2$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $5d66e297400a54e2$var$load("ffQaD"),
    $5d66e297400a54e2$var$load("kvRbA"),
    $5d66e297400a54e2$var$load("54Upu")
]).then(()=>parcelRequire('9r2hQ'));

});



parcelRegister("hkNW0", function(module, exports) {

$parcel$export(module.exports, "browseIssueEmbedRouteEntry", () => $c08486eb8ed505d7$export$e275b3ca0c6ccb5e);


var $6e4Kt = parcelRequire("6e4Kt");

var $e2ctp = parcelRequire("e2ctp");

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $8ZUng = parcelRequire("8ZUng");

var $9XjL6 = parcelRequire("9XjL6");

var $3RJkv = parcelRequire("3RJkv");

var $2Ql51 = parcelRequire("2Ql51");

var $fjoQ1 = parcelRequire("fjoQ1");

var $gRzZD = parcelRequire("gRzZD");

var $lb0Dk = parcelRequire("lb0Dk");

var $lAGdd = parcelRequire("lAGdd");

var $gNStA = parcelRequire("gNStA");

var $7bHMy = parcelRequire("7bHMy");

var $2dmpO = parcelRequire("2dmpO");
const $c08486eb8ed505d7$export$e275b3ca0c6ccb5e = (0, $7NszV.createEntry)((0, $fjoQ1.browseIssueEmbedRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'issue',
        preloadOptions: {
            earlyChunks: [
                'issue-app-early-entry'
            ]
        },
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY),
        component: (0, $2dmpO.IssueEmbedComponent),
        skeleton: (0, $lb0Dk.IssueViewSkeleton),
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            ...(0, $3RJkv.getModernIssueTransitionResources)(),
            ...(0, $2dmpO.getUnusedEmbedRouteResources)(),
            (0, $9XjL6.issueGiraDataResource),
            ...(0, $2dmpO.removeNonCritialGiraCallFromCriticalPath)(),
            (0, $2dmpO.conditionalForgeResource),
            (0, $8ZUng.issueViewRelayResource),
            (0, $gRzZD.workspaceResource),
            (0, $2Ql51.themePreferenceResource),
            ...(0, $lAGdd.getAIContextPanelResources)(),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jira-project-isglobalcomponent-route-resource'), (0, $7bHMy.projectGlobalComponentsResource))
        ],
        forPaint: [
            (0, $2dmpO.LazyIssuePage)
        ],
        ufoName: 'issue-view-embed',
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$ef94a84e2990361c)
        },
        bifrost: {
            bifrostGroup: 'issue-view',
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-entries/src/browseIssueEmbedRouteEntry.tsx',
                whichExportToUse: 'browseIssueEmbedRouteEntry'
            },
            enabled: true,
            manifestName: 'jira-spa-issue-view.json'
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("6e4Kt", function(module, exports) {

$parcel$export(module.exports, "chromelessLayout", () => $c3106f352857c22e$export$17e73ed8c35891cb);

var $aPfsS = parcelRequire("aPfsS");
const $c3106f352857c22e$export$17e73ed8c35891cb = (0, $aPfsS.createLayout)({
    isChromeless: true
});

});

parcelRegister("e2ctp", function(module, exports) {

$parcel$export(module.exports, "NORMAL_EARLY_ASSET_STRATEGY", () => $f36666704bcc2bab$export$137d6d169f402a59);
$parcel$export(module.exports, "AGGRESSIVE_EARLY_ASSET_STRATEGY", () => $f36666704bcc2bab$export$ad16a91905cefb0a);
const $f36666704bcc2bab$var$COMMON_ASSET_REGEX = /.*\/commons(-entry|~[0-9a-z]*)?(\.[0-9a-z]*)?(\.[0-9])?\.js/;
const $f36666704bcc2bab$var$VENDOR_ASSET_REGEX = /.*\/vendor(-entry|~[0-9a-z]*)?(\.[0-9a-z]*)?(\.[0-9])?\.js/;
const $f36666704bcc2bab$var$PARCEL_COMMON_ASSET_REGEX = /.*\/shared~commons(~ar)?(\.[0-9a-z]*)\.js/;
const $f36666704bcc2bab$var$PARCEL_VENDOR_ASSET_REGEX = /.*\/shared~vendor(~ar)?(\.[0-9a-z]*)\.js/;
const $f36666704bcc2bab$export$137d6d169f402a59 = [
    $f36666704bcc2bab$var$VENDOR_ASSET_REGEX,
    $f36666704bcc2bab$var$PARCEL_VENDOR_ASSET_REGEX
];
const $f36666704bcc2bab$export$ad16a91905cefb0a = [
    $f36666704bcc2bab$var$VENDOR_ASSET_REGEX,
    $f36666704bcc2bab$var$COMMON_ASSET_REGEX,
    $f36666704bcc2bab$var$PARCEL_VENDOR_ASSET_REGEX,
    $f36666704bcc2bab$var$PARCEL_COMMON_ASSET_REGEX
];

});

parcelRegister("8ZUng", function(module, exports) {

$parcel$export(module.exports, "issueViewRelayResource", () => $e05b8d0e5bf08042$export$55131006e6699c0a);
$parcel$export(module.exports, "useIssueViewRelayRouteResource", () => $e05b8d0e5bf08042$export$252bdba8c8e5f066);

var $hnYwO = parcelRequire("hnYwO");

var $k3PbQ = parcelRequire("k3PbQ");

var $6yLM4 = parcelRequire("6yLM4");

var $ao2h1 = parcelRequire("ao2h1");

var $la3vp = parcelRequire("la3vp");

var $2Yhep = parcelRequire("2Yhep");

var $gNStA = parcelRequire("gNStA");


var $6s1PB = parcelRequire("6s1PB");

var $5XgeZ = parcelRequire("5XgeZ");
const $e05b8d0e5bf08042$export$55131006e6699c0a = (0, $gNStA.browserOnlyResourceWithCondition)(()=>{
    if (0, $cdb023d06c7f62fa$export$19d68f5aa485d903) // not "browser only" if FF is on
    return !(0, $6s1PB.expVal)('issue_view_ssr_perf_m2', 'isEnabled', false);
    return true;
}, (0, $5XgeZ.createRelayResourceDeprecated)({
    type: 'ISSUE_RELAY_DATA',
    isBrowserOnly: true,
    captureErrors: true,
    captureTraceIds: !false,
    getQuery: (routerContext, { tenantContext: { cloudId: cloudId } })=>{
        const { match: match } = routerContext;
        const issueKey = (0, $2Yhep.getIssueKey)(match);
        const siteAri = (0, $hnYwO.JiraSiteAri).create({
            siteId: cloudId
        }).toString();
        const projectKey = issueKey ? (0, $k3PbQ.extractProjectKey)(issueKey) : '';
        const queryVariables = {
            cloudId: cloudId,
            issueKey: issueKey || '',
            projectKey: projectKey,
            siteAri: siteAri
        };
        return {
            parameters: (0, $la3vp.default),
            variables: {
                ...queryVariables,
                ...(0, $6yLM4.getMainIssueViewAggQueryVariables)(issueKey)
            },
            // Pass over the variables that actually would trigger a reload when they are changed=
            keyVariables: {
                ...queryVariables,
                ...(0, $6yLM4.getMainIssueViewAggQueryFeatureFlagVariables)()
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    }
}));
const $e05b8d0e5bf08042$export$252bdba8c8e5f066 = (options)=>(0, $ao2h1.useRelayResource)($e05b8d0e5bf08042$export$55131006e6699c0a, options);

});
parcelRegister("hnYwO", function(module, exports) {

$parcel$export(module.exports, "JiraSiteAri", () => $ca83894601a84634$export$6c0f81f222d09301);

var $gQC3n = parcelRequire("gQC3n");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/site/manifest.ts
var $ca83894601a84634$var$jiraSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $gQC3n.JiraSiteAriResourceOwner),
    resourceType: (0, $gQC3n.JiraSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/jira/site/index.ts
var $ca83894601a84634$export$6c0f81f222d09301 = class _JiraSiteAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.resourceIdSegmentValues.siteId;
    }
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $ca83894601a84634$var$jiraSiteAriStaticOpts.qualifier,
            platformQualifier: $ca83894601a84634$var$jiraSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $ca83894601a84634$var$jiraSiteAriStaticOpts.resourceOwner,
            resourceType: $ca83894601a84634$var$jiraSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $ca83894601a84634$var$jiraSiteAriStaticOpts);
        return new _JiraSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $ca83894601a84634$var$jiraSiteAriStaticOpts);
        return new _JiraSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
};

});
parcelRegister("gQC3n", function(module, exports) {

$parcel$export(module.exports, "JiraSiteAriResourceOwner", () => $032a4e897fcecef5$export$b7d590981b504412);
$parcel$export(module.exports, "JiraSiteAriResourceType", () => $032a4e897fcecef5$export$886165a991f21644);
// src/jira/site/types.ts
var $032a4e897fcecef5$export$b7d590981b504412 = "jira", $032a4e897fcecef5$export$886165a991f21644 = "site";

});


parcelRegister("k3PbQ", function(module, exports) {

$parcel$export(module.exports, "extractProjectKey", () => $bfdd97e245e93328$export$f1a2e4721b127828);

var $g5X3G = parcelRequire("g5X3G");
const $bfdd97e245e93328$export$f1a2e4721b127828 = (issueKey)=>(0, $g5X3G.toProjectKey)(issueKey.split('-')[0]);

});

parcelRegister("6yLM4", function(module, exports) {

$parcel$export(module.exports, "getMainIssueViewAggQueryFeatureFlagVariables", () => $bbb83ac7c9853fc8$export$3dd406718c5846c6);
$parcel$export(module.exports, "getMainIssueViewAggQueryVariables", () => $bbb83ac7c9853fc8$export$5896c8dc13246fe2);
/**
 * @fileOverview
 * All variables that get passed in to the mainIssueAggQuery are defined here.
 * The abstraction is necessary because there are multiple call paths to mainIssueAggQuery,
 * so having a single source of truth for the variables eliminates a vector for
 * bugs and inconsistencies when they are invoked.
 *
 * This file will be removed (and therefore the need for the linting exemption) once we reduce
 * the number of discrete call paths for mainIssueAggQuery to one. That work will be done in
 * https://jira.atlassian.com/browse/JIV-19486.
 *
 * Sorry, Tom.
 *
 * <3 Daz
 */ /* eslint-disable jira/ff/inline-usage */ 
var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $5CSGy = parcelRequire("5CSGy");


var $ldyPw = parcelRequire("ldyPw");

var $lpLR9 = parcelRequire("lpLR9");

var $j8DrX = parcelRequire("j8DrX");

var $la3vp = parcelRequire("la3vp");

var $k2DRb = parcelRequire("k2DRb");

var $6tI1D = parcelRequire("6tI1D");
const $bbb83ac7c9853fc8$export$623cfa88de62fcd = ()=>{
    const providerVariables = (0, $la3vp.default)?.params?.providedVariables ?? {};
    return Object.entries(providerVariables).reduce((acc, [key, provider])=>{
        acc[key] = provider.get();
        return acc;
    }, {});
};
const $bbb83ac7c9853fc8$export$3dd406718c5846c6 = ()=>({
        isCompassComponentsEnabled: true,
        issueViewRelayConfigurationUrlFlag: (0, $4R6GH.fg)('jiv-replace-configuration-button-in-context-panel'),
        jsmSentimentCustomFieldFlag: true,
        isJPDPanelEnabled: (0, $4R6GH.fg)('jpd_idea_panel_in_issue_view'),
        isDiscoverIdeasRelayMigrationEnabled: (0, $4R6GH.fg)('discover_ideas_relay_migration'),
        issueViewRelayPriorityFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-priority'),
        issueViewRelayNumberFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-number'),
        issueViewRelayAttachmentsFlag: (0, $4R6GH.fg)('relay-migration-issue-view-attachments-'),
        issueViewRelayResolutionFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-resolution'),
        issueViewRelayParentFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-header-and-parent'),
        issueViewRelayMetadataFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-metadata'),
        issueViewDesignsPanelFlag: (0, $6s1PB.expVal)('collapsed_designs_panel', 'isCollapsedDesignsPanelEnabled', false),
        issueViewDesignsPanelProvidersFlag: (0, $4R6GH.fg)('only_show_designs_panel_with_design_providers'),
        isJPDDeliveryLinkTypeFilteringEnabled: (0, $4R6GH.fg)('jpd_idea_panel_in_issue_view'),
        issueViewRemoveCheckboxSelectFieldOptionsFlag: (0, $4R6GH.fg)('remove_issue_field_options_main_query'),
        issueViewRelaySummaryFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-summary'),
        issueViewRelayColorFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-color'),
        issueViewRelayHeaders: (0, $4R6GH.fg)('relay-migration-issue-header-and-parent'),
        issueViewRelayTimeTrackingFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-time-tracking'),
        customFieldConfigurationFlag: (0, $4R6GH.fg)('issue_view_field_config_edit'),
        isPinFieldConfigurabilityEnabled: true,
        jcsFlag: (0, $4R6GH.fg)('jcs_master_flag'),
        isProactiveCommentSummaryPreferenceEnabled: (0, $4R6GH.fg)('proactive_comment_summary_feature_toggle'),
        crossflowBannerDismissedInAggFlag: (0, $4R6GH.fg)('jiv-19897-move-user-prefs-to-mainissueagg'),
        dateFieldsMessageEnabled: (0, $6s1PB.expValEquals)('jsw_start_and_due_dates', 'cohort', 'variation'),
        chinEmbedQueryToAgg: (0, $4R6GH.fg)('issue-jiv-19838-chin-api-lookup-through-issue-key'),
        issueViewActivityLayoutFieldEnabled: (0, $6s1PB.expVal)('issue-view-side-panel-activity', 'isActivityInSidePanel', false),
        issueViewCollapsibleSectionsFieldEnabled: (0, $4R6GH.fg)('collapsible-sections-in-issue-view-fg'),
        issueViewUserPreferredLayoutFieldEnabled: (0, $4R6GH.fg)('issue_view_layout_experiment_feature_gate'),
        issueViewDetailsPanelFieldsReorderingEnabled: (0, $6s1PB.expVal)('issue_view_field_reordering_in_context_panel', 'isReorderingFieldsEnabled', false),
        userThemePrefsInAggEnabled: (0, $4R6GH.fg)('custom-nav-theme-preferences-to-mainissueagg'),
        issueViewRedactionExperience: // eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4R6GH.fg)('enable_redaction_support_in_jira_issue_view') && (0, $4R6GH.fg)('jiv-replace-configuration-button-in-context-panel') && (0, $4R6GH.fg)('relay-migration-issue-header-and-parent'),
        issueViewCoverExperimentEnabled: (0, $6s1PB.expVal)('cover-image-issue-view-experiment', 'isSharedCoverEnabled', false) || (0, $6s1PB.expVal)('cover-image-issue-view-experiment', 'isMiddleCoverEnabled', false),
        isPlaybooksEnabled: (0, $4R6GH.fg)('playbook_in_jsm_ga'),
        isPlaybooksEnabledForSpecificType: (0, $4R6GH.fg)('playbook_visibility_in_service_request'),
        assignToMeUserPreloaded: (0, $4R6GH.fg)('assign-to-me-user-preloaded-in-issue-view'),
        isAutomationDiscoverabilityEnabled: (0, $4R6GH.fg)('automation_discoverability_in_jsm'),
        issueViewCodePlannerPanelEnabled: (0, $4R6GH.fg)('devai-code-planner-issue-view-panel'),
        issueViewChildIssuesPanelPerformance: (0, $6s1PB.expVal)('jira-issue-view-chin-ga', 'isChildIssueEnabled', false) && (0, $6s1PB.expVal)('jira-issue-view-chin-m2-performance', 'isIssueSearchAPIEnabled', false),
        mentionedConfluencePageLinksV2PaginationFlag: // eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4R6GH.fg)('jsw_issue_view_placeholder_template_v2') && (0, $4R6GH.fg)('jiv-19125-fetch-remote-links-in-interactive-query'),
        linkedWorkItemsTableEnabled: (0, $4R6GH.fg)('jira-linked-work-items-table-kill-switch'),
        issueViewCommentAvatarFlag: (0, $4R6GH.fg)('relay-avatar-iv-llc-comments'),
        excludeRedundantNavigationMetadata: (0, $4R6GH.fg)('jiv-20833-remove-navmeta-when-not-needed'),
        issueViewSlackSyncInfoEnabled: (0, $4R6GH.fg)('jira_issue_view_show_slack_sync_info'),
        issueViewNextBestActionsEnabled: (0, $4R6GH.fg)('jira_issue_next_best_actions_aa_fg')
    });
// JIV-19906: retrieve query string from URL -- only expected to be used by client side code
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $bbb83ac7c9853fc8$var$getURLFromWindow = ()=>new URL(window.location.href);
const $bbb83ac7c9853fc8$export$5896c8dc13246fe2 = (issueKey, url = $bbb83ac7c9853fc8$var$getURLFromWindow())=>({
        ...$bbb83ac7c9853fc8$export$623cfa88de62fcd(),
        ...$bbb83ac7c9853fc8$export$3dd406718c5846c6(),
        ...$bbb83ac7c9853fc8$export$e2c3bddbfc195841(url),
        ...$bbb83ac7c9853fc8$var$getStorageBannerVariables(),
        ...$bbb83ac7c9853fc8$var$getIssueSearchForChildIssueQueryVariables(issueKey),
        ...$bbb83ac7c9853fc8$var$getForgeSpecificVariables(),
        ...$bbb83ac7c9853fc8$var$getIsFromSoftwareCalendarOrTimelineViewQueryVariables(),
        ...$bbb83ac7c9853fc8$var$getLinkedIssuesTableQueryVariables(issueKey)
    });
const $bbb83ac7c9853fc8$var$getIsFromSoftwareCalendarOrTimelineViewQueryVariables = ()=>{
    if ((0, $6s1PB.expValEquals)('jsw_start_and_due_dates', 'cohort', 'variation')) {
        if (typeof window !== 'undefined') {
            const pathname = window.location.pathname;
            const pattern = /^\/jira\/software(?:\/c)?\/projects\/[^/]+\/boards\/\d+\/(calendar|timeline)$/;
            return {
                isInTimelineOrCalendarView: pattern.test(pathname)
            };
        }
    }
    return {
        isInTimelineOrCalendarView: false
    };
};
const $bbb83ac7c9853fc8$export$9f8034ef70f20a00 = ()=>{
    /**
	 * Default fields we're fetching in child issues:
	 * - issuetype: Used to separate base-level and subtasks in epics (see `jira-issue-view-child-issues-panel-merge-subtasks`)
	 */ const childIssuesFieldIds = [
        'issuetype'
    ];
    // If we're not fetching the "Include subtasks" timetracking data through Relay
    // include it in `mainIssueAggQuery` so it can be derived from Redux
    if (!(0, $4R6GH.fg)('relay-migration-edit-worklog')) childIssuesFieldIds.push('timetracking');
    // If we're not fetching the progress summary status data through Relay,
    // include it in `mainIssueAggQuery` so it can be derived from Redux
    if (!(0, $4R6GH.fg)('issue-jiv-20335-relay-progress-summary')) childIssuesFieldIds.push('status');
    const unusedFields = [
        'assignee',
        'created',
        'priority',
        'summary',
        'updated'
    ];
    if (!(0, $6s1PB.expVal)('jira-issue-view-chin-ga', 'isChildIssueEnabled', false)) // Always include unused fields when GA experiment is OFF
    childIssuesFieldIds.push(...unusedFields);
    else if (!(0, $6s1PB.expVal)('jira-issue-view-chin-m2-performance', 'isChildIssuesCleanupEnabled', false)) // But if GA is ON, still include them if the M2 experiment off
    childIssuesFieldIds.push(...unusedFields);
    return childIssuesFieldIds;
};
const $bbb83ac7c9853fc8$var$getIssueSearchForChildIssueQueryVariables = (issueKey)=>({
        // will have to put jql order by rank later
        issueSearchInput: {
            childIssuesInput: {
                parentIssueKey: issueKey || ''
            }
        },
        amountOfColumns: 500,
        fieldSetsInput: {
            viewInput: {
                namespace: 'CHILD_ISSUE_PANEL',
                context: {
                    issueContext: {
                        issueKey: issueKey
                    }
                }
            }
        },
        childIssuesFieldIds: $bbb83ac7c9853fc8$export$9f8034ef70f20a00()
    });
const $bbb83ac7c9853fc8$var$getLinkedIssuesTableQueryVariables = (issueKey)=>({
        linkedIssuesSearchInput: {
            jql: `issue in linkedIssues(${issueKey})`
        },
        linkedIssuesFieldSetIds: [
            'issuetype',
            'issuekey',
            'summary',
            'priority',
            'assignee',
            'status'
        ],
        linkedIssuesFieldSetsInput: {
            fieldSetIds: [
                'issuetype',
                'issuekey',
                'summary',
                'priority',
                'assignee',
                'status'
            ]
        }
    });
const $bbb83ac7c9853fc8$export$afa6e4ae995b8926 = ()=>{
    const commentTargetId = (0, $6tI1D.getPermalinkId)((0, $6tI1D.COMMENTS)) || null;
    return {
        commentTargetId: commentTargetId,
        hasCommentTargetId: !!commentTargetId
    };
};
const $bbb83ac7c9853fc8$export$e2c3bddbfc195841 = (url)=>{
    const commentTargetId = (0, $6tI1D.getPermalinkIdFromURL)((0, $6tI1D.COMMENTS), url);
    return {
        commentTargetId: commentTargetId,
        hasCommentTargetId: !!commentTargetId
    };
};
const $bbb83ac7c9853fc8$var$getStorageBannerVariables = ()=>({
        issueViewStorageLimitsBannerFlag: (0, $lpLR9.default)((0, $j8DrX.default)).software === (0, $ldyPw.FREE_EDITION) && (0, $4R6GH.fg)('move_storage_banner_data_fetch_to_main_issue_agg'),
        offeringKey: (0, $5CSGy.getProductOfferingKeyOrThrow)((0, $c06e1abca7c13910$export$1346c9aa3cbb477d), (0, $ldyPw.STANDARD_EDITION)),
        productKey: (0, $c06e1abca7c13910$export$1346c9aa3cbb477d)
    });
const $bbb83ac7c9853fc8$var$getForgeSpecificVariables = ()=>{
    return {
        forgeInMainIssueAggFlag: (0, $4R6GH.fg)('move_forge_data_fetch_to_main_issue_agg'),
        forgeTypes: (0, $4R6GH.fg)('move_forge_data_fetch_to_main_issue_agg') ? [
            (0, $k2DRb.ISSUE_ACTION_MODULE),
            (0, $k2DRb.ISSUE_GLANCE_MODULE),
            (0, $k2DRb.ISSUE_CONTEXT_MODULE),
            (0, $k2DRb.ISSUE_PANEL_MODULE),
            (0, $k2DRb.ISSUE_ACTIVITY_MODULE),
            (0, $k2DRb.CUSTOM_FIELD_MODULE),
            (0, $k2DRb.CUSTOM_FIELD_TYPE_MODULE),
            (0, $k2DRb.ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE),
            (0, $k2DRb.UI_MODIFICATIONS_MODULE)
        ] : [],
        includeUserAccessForge: (0, $4R6GH.fg)('forge_query_include_user_access'),
        includeUserAccessEnabledForge: (0, $4R6GH.fg)('forge_query_include_user_access_enabled')
    };
};

});
parcelRegister("5CSGy", function(module, exports) {

$parcel$export(module.exports, "getProductOfferingKeyForProject", () => $75290a6120824a25$export$3ad43d25ded909ee);
$parcel$export(module.exports, "getProductOfferingKeyOrThrow", () => $75290a6120824a25$export$92c311d982d129d5);


var $1laI5 = parcelRequire("1laI5");
// Please don't use access these directly, try to implement these using common platform types such as below
const $75290a6120824a25$var$JSW_PRODUCT_OFFERING_KEYS = {
    FREE_EDITION: 'de2887c9-8a55-41d5-b5cf-ad6a5589ebed',
    STANDARD_EDITION: 'a70b5cbb-1ae1-4003-8f4a-9001a4a50526',
    PREMIUM_EDITION: '6dd805b4-da75-4374-a7a7-cf0b12f7ea07',
    UNLICENSED: null
};
const $75290a6120824a25$var$JPD_PRODUCT_OFFERING_KEYS = {
    FREE_EDITION: 'd843dd9e-23c5-4d27-af44-5009d568cb6e',
    STANDARD_EDITION: '35b9268e-66e2-45fb-81d3-dacd1e31831a',
    PREMIUM_EDITION: 'f0b24ca7-c3d8-4cac-b5ed-60f4152d4dcd',
    UNLICENSED: null
};
const $75290a6120824a25$var$JSM_PRODUCT_OFFERING_KEYS = {
    FREE_EDITION: '24656f1f-5c14-45ea-88ea-142b9c633661',
    STANDARD_EDITION: '99bcbf6c-4fff-4a45-8303-a854e7fbd17c',
    PREMIUM_EDITION: '0c6683b4-4633-4673-beca-690d171de6a5',
    UNLICENSED: null
};
const $75290a6120824a25$export$581b2a05d59c1826 = (applicationKey, applicationEdition)=>{
    switch(applicationKey){
        case 0, $c06e1abca7c13910$export$1346c9aa3cbb477d:
            return $75290a6120824a25$var$JSW_PRODUCT_OFFERING_KEYS[applicationEdition];
        case 0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61:
            return $75290a6120824a25$var$JSM_PRODUCT_OFFERING_KEYS[applicationEdition];
        case 0, $c06e1abca7c13910$export$202f50ee62667e32:
            return $75290a6120824a25$var$JPD_PRODUCT_OFFERING_KEYS[applicationEdition];
        // can support more products if implemented in future
        default:
            return null;
    }
};
const $75290a6120824a25$export$3ad43d25ded909ee = (project, edition)=>{
    const application = (0, $1laI5.projectToApplicationKey)(project);
    const offeringKey = $75290a6120824a25$export$581b2a05d59c1826(application, edition);
    if (offeringKey === null) throw new Error(`Missing offering key for: ${application} ${edition}`);
    return offeringKey;
};
const $75290a6120824a25$export$92c311d982d129d5 = (applicationKey, applicationEdition)=>{
    const offeringKey = $75290a6120824a25$export$581b2a05d59c1826(applicationKey, applicationEdition);
    if (offeringKey === null) throw new Error(`Missing offering key for: ${applicationKey} ${applicationEdition}`);
    return offeringKey;
};

});
parcelRegister("1laI5", function(module, exports) {

$parcel$export(module.exports, "getTrialDaysLeft", () => $39ed199f3e5d9f33$export$954628993bf3188e);
$parcel$export(module.exports, "projectToApplicationKey", () => $39ed199f3e5d9f33$export$1af4fd6f5c543149);

var $2vSU6 = parcelRequire("2vSU6");

const $39ed199f3e5d9f33$export$9dbbf537dffaafc7 = (timestamp)=>new Date(timestamp).setUTCHours(0, 0, 0, 0);
const $39ed199f3e5d9f33$export$954628993bf3188e = (trialEndTime)=>trialEndTime && Math.ceil(($39ed199f3e5d9f33$export$9dbbf537dffaafc7(trialEndTime) - Date.now()) / 86400000);
const $39ed199f3e5d9f33$export$271517afaa0c15eb = (trialEndTime)=>{
    const trialDaysLeft = $39ed199f3e5d9f33$export$954628993bf3188e(trialEndTime);
    // Technically we do not know whether user is in grace period or not, but if user is able to access the Jira with no payment details
    // and is trialEndTime is missing or over we assume that site is in grace period
    return !trialDaysLeft || trialDaysLeft < 0;
};
const $39ed199f3e5d9f33$export$1af4fd6f5c543149 = (project)=>{
    switch(project){
        // With spork, we should update core projects as it they were Software projects
        case 0, $2vSU6.SOFTWARE_PROJECT:
        case 0, $2vSU6.CORE_PROJECT:
            return 0, $c06e1abca7c13910$export$1346c9aa3cbb477d;
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return 0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61;
        case 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT:
            return 0, $c06e1abca7c13910$export$202f50ee62667e32;
        default:
            throw new Error(`Unsupported project: ${project}`);
    }
};

});


parcelRegister("la3vp", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d1e3365ed212162$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<47c1a6744f471cdf9d2f94c691eeb68d>>
 * @relayHash 0caefa31e1d1bf02d6ea1fe812fa0f17
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f603263c11d0e2f08e586fa21834b7890d95efab4c5f02975f17de03452495fe

var $k80F2 = parcelRequire("k80F2");

var $beHGE = parcelRequire("beHGE");

var $fjldt = parcelRequire("fjldt");

var $gY76A = parcelRequire("gY76A");

var $5ykrX = parcelRequire("5ykrX");

var $ggSVP = parcelRequire("ggSVP");

var $iMyvd = parcelRequire("iMyvd");

var $2pNN7 = parcelRequire("2pNN7");

var $5FIjM = parcelRequire("5FIjM");

var $knfEI = parcelRequire("knfEI");

var $5qm7M = parcelRequire("5qm7M");

var $l8ssf = parcelRequire("l8ssf");

var $dttgK = parcelRequire("dttgK");

var $adKYy = parcelRequire("adKYy");

var $eq0sU = parcelRequire("eq0sU");

var $iLxt4 = parcelRequire("iLxt4");

var $ju8GE = parcelRequire("ju8GE");

var $5YQLv = parcelRequire("5YQLv");

var $hBTVA = parcelRequire("hBTVA");

var $9OzGv = parcelRequire("9OzGv");

var $h6nNu = parcelRequire("h6nNu");

var $5pSyb = parcelRequire("5pSyb");

var $cKVMM = parcelRequire("cKVMM");

var $5mEVc = parcelRequire("5mEVc");

var $ef20f = parcelRequire("ef20f");

var $84KW9 = parcelRequire("84KW9");

var $kT0rw = parcelRequire("kT0rw");

var $d6bux = parcelRequire("d6bux");

var $krohK = parcelRequire("krohK");

var $6NR1m = parcelRequire("6NR1m");

var $3E2yq = parcelRequire("3E2yq");

var $fmbEw = parcelRequire("fmbEw");

var $hSNvs = parcelRequire("hSNvs");

var $8Y9hN = parcelRequire("8Y9hN");

var $ejqaS = parcelRequire("ejqaS");

var $eXeEx = parcelRequire("eXeEx");

var $hBvdF = parcelRequire("hBvdF");
const $7d1e3365ed212162$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "f603263c11d0e2f08e586fa21834b7890d95efab4c5f02975f17de03452495fe",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "forward",
                    "path": [
                        "jira",
                        "issueByKey",
                        "attachments"
                    ]
                }
            ]
        },
        "name": "mainIssueAggQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationconfigurationurlrelayprovider": (0, $5YQLv.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewredactionexperiencerelayprovider": (0, $5FIjM.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscustomfieldconfigrelayprovider": (0, $h6nNu.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsparent": (0, $d6bux.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldstimetrackingrelayprovider": (0, $8Y9hN.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscheckboxselectrelayprovider": (0, $9OzGv.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsoriginalestimaterelayprovider": (0, $kT0rw.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsgrouppickerrelayprovider": (0, $5pSyb.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsmultigrouppickerrelayprovider": (0, $84KW9.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsrichtextrelayprovider": (0, $6NR1m.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsassigneerelayprovider": (0, $hBTVA.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $hBvdF.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $5qm7M.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $knfEI.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsheaderactionsrelayprovider": (0, $cKVMM.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldswatchersrelayprovider": (0, $eXeEx.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldssecuritylevelrelayprovider": (0, $3E2yq.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsvotesrelayprovider": (0, $ejqaS.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsissuerestrictionsrelayprovider": (0, $5mEVc.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcconcealitemsintomeatballmenuexperimentrelayprovidertsx": (0, $beHGE.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsissuetypeswitcherrelayprovider": (0, $ef20f.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsstatusrelayprovider": (0, $hSNvs.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsstatuspanelrelayprovider": (0, $fmbEw.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsresolutionrelayprovider": (0, $krohK.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrconeeventimprovementsenabledrelayprovider": (0, $ju8GE.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider": (0, $iMyvd.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcmagma3191renderchinskeletoninssrrelayprovider": (0, $eq0sU.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchinm2performanceisissuesearchapienabledrelayprovider": (0, $2pNN7.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $dttgK.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $adKYy.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $fjldt.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": (0, $iLxt4.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $l8ssf.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": (0, $5ykrX.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": (0, $ggSVP.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $gY76A.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcboysenberryissueviewagentspanelrelayprovider": (0, $k80F2.default)
        }
    }
};
var $7d1e3365ed212162$export$2e2bcd8739ae039 = $7d1e3365ed212162$var$node;

});
parcelRegister("k80F2", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e1266ac115a4090$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $4e1266ac115a4090$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('bsnbry-rovodev-agents-panel');
    }
};

});

parcelRegister("beHGE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e77216947a3d05a6$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $e77216947a3d05a6$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('conceal_items_in_meatball_menu_ga_fg');
    }
};

});

parcelRegister("fjldt", function(module, exports) {

$parcel$export(module.exports, "default", () => $dad5d6a9d81ef63f$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");
var $dad5d6a9d81ef63f$export$2e2bcd8739ae039 = {
    get () {
        return (0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false);
    }
};

});

parcelRegister("gY76A", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b308b8f84a32bbf$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $5b308b8f84a32bbf$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jira_inline_field_config_gate');
    }
};

});

parcelRegister("5ykrX", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a88313492930423$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $5a88313492930423$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('render_jirawatchesfield_nin');
    }
};

});

parcelRegister("ggSVP", function(module, exports) {

$parcel$export(module.exports, "default", () => $67bb3d8089fa042c$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $67bb3d8089fa042c$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('single_line_row_height_collapsable_fields');
    }
};

});

parcelRegister("iMyvd", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccd515d7ae24a1bd$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $ccd515d7ae24a1bd$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jira-issue-view-child-issues-panel-realtime-update');
    }
};

});

parcelRegister("2pNN7", function(module, exports) {

$parcel$export(module.exports, "default", () => $c317a5429c553fb0$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");
var $c317a5429c553fb0$export$2e2bcd8739ae039 = {
    get () {
        return (0, $6s1PB.expVal)('jira-issue-view-chin-m2-performance', 'isIssueSearchAPIEnabled', false);
    }
};

});

parcelRegister("5FIjM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c20c48eec5732675$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $c20c48eec5732675$export$2e2bcd8739ae039 = {
    get () {
        return(// eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4R6GH.fg)('enable_redaction_support_in_jira_issue_view') && (0, $4R6GH.fg)('jiv-replace-configuration-button-in-context-panel') && (0, $4R6GH.fg)('relay-migration-issue-header-and-parent'));
    }
};

});

parcelRegister("knfEI", function(module, exports) {

$parcel$export(module.exports, "default", () => $91f4d6b980265dc0$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $91f4d6b980265dc0$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('frontier-currency-field-d1');
    }
};

});

parcelRegister("5qm7M", function(module, exports) {

$parcel$export(module.exports, "default", () => $124cec54bee44ed1$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $124cec54bee44ed1$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jsc_inline_editing_field_refactor');
    }
};

});

parcelRegister("l8ssf", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6503957c800342c$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $e6503957c800342c$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jsc_inline_editing_flag_fix');
    }
};

});

parcelRegister("dttgK", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7b98ab24c97dab4$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
const $c7b98ab24c97dab4$var$JscM2FeChangesRelayProvider = {
    get () {
        return (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes');
    }
};
var $c7b98ab24c97dab4$export$2e2bcd8739ae039 = $c7b98ab24c97dab4$var$JscM2FeChangesRelayProvider;

});

parcelRegister("adKYy", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff52f025ed33d5fc$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
const $ff52f025ed33d5fc$var$JscMergedColumnRelayProvider = {
    get () {
        return (0, $4R6GH.fg)('jira_list_merged_column_gate');
    }
};
var $ff52f025ed33d5fc$export$2e2bcd8739ae039 = $ff52f025ed33d5fc$var$JscMergedColumnRelayProvider;

});

parcelRegister("eq0sU", function(module, exports) {

$parcel$export(module.exports, "default", () => $475f45f039da3c7a$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $475f45f039da3c7a$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('magma-3191-render-chin-skeleton-in-ssr');
    }
};

});

parcelRegister("iLxt4", function(module, exports) {

$parcel$export(module.exports, "default", () => $c35fdb8bdb84235d$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
const $c35fdb8bdb84235d$var$NinMultiGroupPickerCellRelayProvider = {
    get () {
        return (0, $4R6GH.fg)('nin_multi_group_picker_cell');
    }
};
var $c35fdb8bdb84235d$export$2e2bcd8739ae039 = $c35fdb8bdb84235d$var$NinMultiGroupPickerCellRelayProvider;

});

parcelRegister("ju8GE", function(module, exports) {

$parcel$export(module.exports, "default", () => $f22f95d64a2848da$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $f22f95d64a2848da$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('one_event_improvements_1');
    }
};

});

parcelRegister("5YQLv", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cc7b1249165c5cc$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $8cc7b1249165c5cc$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jiv-replace-configuration-button-in-context-panel');
    }
};

});

parcelRegister("hBTVA", function(module, exports) {

$parcel$export(module.exports, "default", () => $317518afb86d429d$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $317518afb86d429d$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-assignee-fg');
    }
};

});

parcelRegister("9OzGv", function(module, exports) {

$parcel$export(module.exports, "default", () => $68a7d680b4f7aa31$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $68a7d680b4f7aa31$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-checkbox-select');
    }
};

});

parcelRegister("h6nNu", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ea05c28112074d6$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
const $4ea05c28112074d6$var$isIssueViewFieldConfigEditEnabled = {
    get () {
        return (0, $4R6GH.fg)('issue_view_field_config_edit');
    }
};
var $4ea05c28112074d6$export$2e2bcd8739ae039 = $4ea05c28112074d6$var$isIssueViewFieldConfigEditEnabled;

});

parcelRegister("5pSyb", function(module, exports) {

$parcel$export(module.exports, "default", () => $46b71e3be8dfea7a$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $46b71e3be8dfea7a$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-group-picker-sg');
    }
};

});

parcelRegister("cKVMM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7153ac791d0f4b40$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $7153ac791d0f4b40$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-header-and-parent');
    }
};

});

parcelRegister("5mEVc", function(module, exports) {

$parcel$export(module.exports, "default", () => $dba981d8b012adb8$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $dba981d8b012adb8$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-header-and-parent');
    }
};

});

parcelRegister("ef20f", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dac75eea754d44b$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $5dac75eea754d44b$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-header-and-parent');
    }
};

});

parcelRegister("84KW9", function(module, exports) {

$parcel$export(module.exports, "default", () => $78c1aa824cd21c11$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $78c1aa824cd21c11$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-multi-group-picker-fg');
    }
};

});

parcelRegister("kT0rw", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cdff8c37120a188$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $4cdff8c37120a188$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-original-estimate');
    }
};

});

parcelRegister("d6bux", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d9e6f2a33f8172f$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4d9e6f2a33f8172f$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-header-and-parent');
    }
};

});

parcelRegister("krohK", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ee92d752c596813$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $7ee92d752c596813$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-resolution');
    }
};

});

parcelRegister("6NR1m", function(module, exports) {

$parcel$export(module.exports, "default", () => $851058f7192cd7ee$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $851058f7192cd7ee$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-multi-line-text-fg');
    }
};

});

parcelRegister("3E2yq", function(module, exports) {

$parcel$export(module.exports, "default", () => $847675c0acc8db9e$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $847675c0acc8db9e$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-header-and-parent');
    }
};

});

parcelRegister("fmbEw", function(module, exports) {

$parcel$export(module.exports, "default", () => $afb9a48dda30cc33$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $afb9a48dda30cc33$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-resolution') || (0, $4R6GH.fg)('relay-migration-issue-fields-status');
    }
};

});

parcelRegister("hSNvs", function(module, exports) {

$parcel$export(module.exports, "default", () => $efddcea96d8714d0$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $efddcea96d8714d0$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-status');
    }
};

});

parcelRegister("8Y9hN", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb6d2edf34e99bba$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $eb6d2edf34e99bba$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-time-tracking');
    }
};

});

parcelRegister("ejqaS", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7323747132cbc58$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $c7323747132cbc58$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-header-and-parent');
    }
};

});

parcelRegister("eXeEx", function(module, exports) {

$parcel$export(module.exports, "default", () => $acfad9d58e7d968c$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $acfad9d58e7d968c$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-header-and-parent');
    }
};

});

parcelRegister("hBvdF", function(module, exports) {

$parcel$export(module.exports, "default", () => $5de224b7b5e8adbe$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $5de224b7b5e8adbe$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('thor_colourful_single_select_milestone2_gate');
    }
};

});


parcelRegister("6tI1D", function(module, exports) {

$parcel$export(module.exports, "PermalinkType", () => $ac458c74e4b12b29$export$b18d061fc042df1a);
$parcel$export(module.exports, "COMMENTS", () => $ac458c74e4b12b29$export$4cab9dfa8fc858f4);
$parcel$export(module.exports, "WORKLOG", () => $ac458c74e4b12b29$export$df36fc05622c402);
$parcel$export(module.exports, "getAllUrlParams", () => $ac458c74e4b12b29$export$dca91ad250f6b082);
$parcel$export(module.exports, "getPermalinkId", () => $ac458c74e4b12b29$export$bf42dbba4c31080e);
$parcel$export(module.exports, "getPermalinkIdFromURL", () => $ac458c74e4b12b29$export$87557f913748dcff);

var $gKZoD = parcelRequire("gKZoD");

var $2YZCu = parcelRequire("2YZCu");
const $ac458c74e4b12b29$export$b18d061fc042df1a = {
    COMMENTS: 'focusedCommentId',
    WORKLOG: 'focusedWorklogId'
};
const $ac458c74e4b12b29$export$4cab9dfa8fc858f4 = 'COMMENTS';
const $ac458c74e4b12b29$export$df36fc05622c402 = 'WORKLOG';
/**
 * @deprecated this function is unsafe for using on server side code due to `window` object usage
 */ const $ac458c74e4b12b29$export$dca91ad250f6b082 = ()=>{
    (0, $gKZoD.di)(window);
    // get query string from  window
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    let queryString = window.location.search.slice(1);
    // we'll store the parameters here
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const obj = {};
    // if query string exists
    if (queryString) {
        // stuff after # is not part of query string, so get rid of it
        queryString = queryString.split('#')[0];
        // split our query string into its component parts
        const arr = queryString.split('&');
        for(let i = 0; i < arr.length; i += 1){
            // separate the keys and the values
            const a = arr[i].split('=');
            // set parameter name and value (use 'true' if empty)
            const paramName = a[0];
            try {
                const paramValue = typeof a[1] === 'undefined' ? true : decodeURIComponent(a[1]);
                obj[paramName] = paramValue;
            } catch (error) {
                (0, $2YZCu.default).safeErrorWithoutCustomerData('getAllUrlParams', `Malformed value was obtained from the query string for ${paramName}`);
            }
        }
    }
    return obj;
};
const $ac458c74e4b12b29$export$bf42dbba4c31080e = (targetPermalinkType)=>{
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly COMMENTS: "focusedCommentId"; readonly WORKLOG: "focusedWorklogId"; }'.
    if (!$ac458c74e4b12b29$export$b18d061fc042df1a[targetPermalinkType]) return null;
    const urlParams = $ac458c74e4b12b29$export$dca91ad250f6b082();
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly COMMENTS: "focusedCommentId"; readonly WORKLOG: "focusedWorklogId"; }'.
    return urlParams[$ac458c74e4b12b29$export$b18d061fc042df1a[targetPermalinkType]];
};
const $ac458c74e4b12b29$export$87557f913748dcff = (targetPermalinkType, url)=>{
    const queryParamKey = $ac458c74e4b12b29$export$b18d061fc042df1a[targetPermalinkType];
    if (!queryParamKey) return null;
    return url.searchParams.get(queryParamKey);
};

});


parcelRegister("2Yhep", function(module, exports) {

$parcel$export(module.exports, "getIssueKey", () => $05d1e79edcc0dc56$export$4a030f6192bebe03);
const $05d1e79edcc0dc56$export$4a030f6192bebe03 = (match)=>{
    const fromMatch = match && match.params && match.params.issueKey !== undefined && match.params.issueKey !== null ? match.params.issueKey : null;
    return fromMatch;
};

});

// This constant will be true on entry-fs (modern SSR) bundles and false on jira-fe-gateway (legacy SSR) and client bundles
const $cdb023d06c7f62fa$export$19d68f5aa485d903 = false;

parcelRegister("5XgeZ", function(module, exports) {

$parcel$export(module.exports, "withResourceEarlyData", () => $36d3fb93786ec5e2$export$22da5fb8c8200986);
$parcel$export(module.exports, "createRelayResourceDeprecated", () => $36d3fb93786ec5e2$export$2e279339bedcd427);

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");

var $x9xyg = parcelRequire("x9xyg");

var $5yJb9 = parcelRequire("5yJb9");

var $5a0Nh = parcelRequire("5a0Nh");

var $kipqU = parcelRequire("kipqU");

var $2M1hQ = parcelRequire("2M1hQ");

var $5Wobd = parcelRequire("5Wobd");
const $36d3fb93786ec5e2$export$5664a170ac5a9781 = 5000;
const $36d3fb93786ec5e2$export$22da5fb8c8200986 = ({ type: type, getData: next, getDataLoader: getDataLoader, ...rest })=>{
    const getData = (...args)=>{
        performance.mark(`issueViewEarlyScripts:${type}:withResourceEarlyData:called`);
        if (!false && type in window) {
            // @ts-expect-error - Element implicitly has an 'any' type because index expression is not of type 'number'
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any, jira/jira-ssr/no-unchecked-globals-usage
            const promise = window[type];
            // @ts-expect-error - Element implicitly has an 'any' type because index expression is not of type 'number'
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            delete window[type];
            getDataLoader && promise.then(getDataLoader);
            return promise;
        }
        if (getDataLoader) return getDataLoader().then(({ default: getDataPromise })=>getDataPromise(...args));
        return next && next(...args);
    };
    return {
        ...rest,
        type: type,
        getData: getData
    };
};
const $36d3fb93786ec5e2$export$c6c8c12c0f1d8e54 = 'RELAY_RESOURCE_TYPE';
const $36d3fb93786ec5e2$var$createRelayResourceImpl = ({ type: type, isBrowserOnly: isBrowserOnly, getQuery: getQuery, loadParameters: loadParameters, captureErrors: captureErrors = false, captureTraceIds: captureTraceIds = false })=>(0, $2M1hQ.createResource)({
        type: `${$36d3fb93786ec5e2$export$c6c8c12c0f1d8e54}_${type}`,
        getKey: (routerContext, customContext)=>{
            const { parameters: preloadableRequest, variables: queryVariables, keyVariables: keyVariables } = getQuery(routerContext, customContext);
            // There are some variables that we don't want to trigger a reload even if they are changed, by default use 'variables', or you can also pass over
            // specific keyVariables that will trigger the reload
            const variables = keyVariables || queryVariables;
            // When providing an async query via `loadParameters` instead of getQuery's config, the query ID is not known upfront and so cannot be contributed to the resource key
            if (!preloadableRequest) return JSON.stringify(variables || {});
            let queryId;
            let params;
            if ('kind' in preloadableRequest && preloadableRequest.kind === 'PreloadableConcreteRequest') {
                ({ params: params } = preloadableRequest);
                ({ id: queryId } = params);
            } else {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                const graphQlTaggedNode = preloadableRequest;
                const request = (0, $eiowN.getRequest)(graphQlTaggedNode);
                params = request.params;
                queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
            }
            return `${String(queryId)}${JSON.stringify(variables || {})}`;
        },
        getData: async (routerContext, customContext)=>{
            const measureName = `relay_resource_get_data:${type}`;
            const startMark = `relay_resource_get_data:${type}:start`;
            const endMark = `relay_resource_get_data:${type}:end`;
            (0, $x9xyg.setMark)(startMark);
            const { parameters: parameters, variables: variables, options: options } = getQuery(routerContext, customContext);
            // We either have a sync query or an async one from loadParameters. Never neither
            // This is enforced by 2 aliases of this method having different types, but Typescript cannot infer that neatly, so we cast away the nullable case.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const query = parameters ?? await loadParameters?.();
            // loadQuery returns not a Promise, but Observable.
            // Resource waits until query Observable is completed and returns a queryReference
            // later queryReference could be used by usePreloadedQuery
            const queryReference = (0, $x9xyg.measureFunc)(`relay_resource_load_query:${type}`, ()=>(0, $8Uumt.loadQuery)((0, $5yJb9.default)(), query, variables || {}, options));
            if (false && queryReference.id != null) await (0, $kipqU.QueryPromisesMap).get(queryReference.id);
            if (queryReference.id != null) (0, $kipqU.QueryPromisesMap).get(queryReference.id)?.then(()=>{
                (0, $x9xyg.setMark)(endMark);
                (0, $x9xyg.setMeasure)(measureName, startMark, endMark);
            });
            /**
			 * We want to store HTTP codes from fetch response so that we can use it to report SLA correctly.
			 * (Unfortunately errors thrown by relay client validation doesn't include HTTP codes at the moment, so we have to store it ourselves)
			 * Starting to capture errors here ensures we capture errors for the early fetch of the query on initial page load,
			 * as well as subsequent fetches made by route transitions between spa-apps.
			 */ if (captureErrors) (0, $5a0Nh.startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
            if (captureTraceIds) (0, $5Wobd.startCapturingTraceIds)(queryReference.name);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return queryReference;
        },
        maxAge: 0,
        isBrowserOnly: isBrowserOnly
    });
const $36d3fb93786ec5e2$export$2e279339bedcd427 = $36d3fb93786ec5e2$var$createRelayResourceImpl;

});


parcelRegister("9XjL6", function(module, exports) {

$parcel$export(module.exports, "issueGiraDataResource", () => $94d751405759debc$export$37badecd288c49f4);

var $2Yhep = parcelRequire("2Yhep");

var $2M1hQ = parcelRequire("2M1hQ");

var $gNStA = parcelRequire("gNStA");


var $6s1PB = parcelRequire("6s1PB");

var $5XgeZ = parcelRequire("5XgeZ");

var $1UEZY = parcelRequire("1UEZY");
const $94d751405759debc$export$37badecd288c49f4 = (0, $gNStA.browserOnlyResourceWithCondition)(()=>{
    if (0, $cdb023d06c7f62fa$export$19d68f5aa485d903) // not "browser only" if FF is on
    return !(0, $6s1PB.expVal)('issue_view_ssr_perf_m2', 'isEnabled', false);
    return true;
}, // eslint-disable-next-line @typescript-eslint/no-explicit-any
(0, $2M1hQ.createResource)((0, $5XgeZ.withResourceEarlyData)({
    type: 'ISSUE_GIRA_DATA',
    getKey: ({ match: match })=>{
        const issueKey = (0, $2Yhep.getIssueKey)(match);
        return issueKey || '';
    },
    getData: (...args)=>(0, $1UEZY.default)(...args),
    isBrowserOnly: true
})));

});
parcelRegister("1UEZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $48e4146cd1317713$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $ePyEO = parcelRequire("ePyEO");

var $iR3GG = parcelRequire("iR3GG");

var $2Yhep = parcelRequire("2Yhep");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$48e4146cd1317713$export$2e2bcd8739ae039 = async ({ match: match }, { tenantContext: tenantContext })=>{
    const issueKey = (0, $2Yhep.getIssueKey)(match);
    if (!issueKey) return null;
    try {
        const { baseUrl: baseUrl } = tenantContext;
        const data = await (0, $ePyEO.default)(baseUrl, issueKey);
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $iR3GG.createResourceError)({
            component: 'spa.view.routes.issue-view.gira.getData',
            message: 'An error was thrown while prefetching issue gira data',
            name: 'ResourceError'
        }, error);
    }
};

});
parcelRegister("ePyEO", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef212fbaef309294$export$2e2bcd8739ae039);

var $dGrdR = parcelRequire("dGrdR");

var $k3PbQ = parcelRequire("k3PbQ");

var $fqpdr = parcelRequire("fqpdr");

var $9kbEN = parcelRequire("9kbEN");

var $iBOrg = parcelRequire("iBOrg");
const $ef212fbaef309294$var$ISSUE_GIRA_DATA = 'issue-gira-data';
const $ef212fbaef309294$var$timeToFetchIssueGiraDataMetric = (0, $dGrdR.metrics).custom({
    key: $ef212fbaef309294$var$ISSUE_GIRA_DATA
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ef212fbaef309294$export$2e2bcd8739ae039 = async (baseUrl, issueKey)=>{
    const projectKey = (0, $k3PbQ.extractProjectKey)(issueKey);
    const variables = {
        issueKey: issueKey,
        projectKey: projectKey
    };
    const payload = {
        query: (0, $fqpdr.buildIssueQuery)(),
        variables: variables,
        operationName: (0, $fqpdr.ISSUE_VIEW_INTERACTIVE_QUERY)
    };
    if ((0, $9kbEN.isInSample)()) $ef212fbaef309294$var$timeToFetchIssueGiraDataMetric.start();
    try {
        const response = await (0, $iBOrg.getClient)(baseUrl).query(payload);
        // Best-effort attempt to provide `issueId` and is not guaranteed
        const issueId = response.data?.viewIssue?.issueId;
        $ef212fbaef309294$var$timeToFetchIssueGiraDataMetric.stop({
            customData: issueId ? {
                issueId: issueId
            } : null
        });
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // Cancel the metric and re-throw the error
        $ef212fbaef309294$var$timeToFetchIssueGiraDataMetric.cancel();
        throw error;
    }
};

});
parcelRegister("fqpdr", function(module, exports) {

$parcel$export(module.exports, "ISSUE_VIEW_INTERACTIVE_QUERY", () => $3789cf83eed10ddd$export$1780a132c0453fee);
$parcel$export(module.exports, "getGiraUrl", () => $3789cf83eed10ddd$export$aefb19023b2eda55);
$parcel$export(module.exports, "getJiraQueryEcosystemFirstSeenOnIssueView", () => $3789cf83eed10ddd$export$79eba9bf6dc9960d);
$parcel$export(module.exports, "buildIssueQuery", () => $3789cf83eed10ddd$export$222ae9aca08830f0);
$parcel$export(module.exports, "getGiraRequestOptions", () => $3789cf83eed10ddd$export$e1542dc7ff749de8);
/**
 * ╔═══════════════╗
 * ║ !!IMPORTANT!! ║
 * ╚═══════════════╝
 * Please do not use statsig feature gating in this file.
 * Read https://hello.atlassian.net/wiki/spaces/JIE/pages/2858513117/Blockers+for+Statsig+in+the+issue-view
 * for why and to follow the fix.
 */ 
var $96nmc = parcelRequire("96nmc");

var $EJMEI = parcelRequire("EJMEI");

var $8TkIN = parcelRequire("8TkIN");

var $e2Vt6 = parcelRequire("e2Vt6");

var $92ECu = parcelRequire("92ECu");

var $6QL4r = parcelRequire("6QL4r");

var $5Pqa3 = parcelRequire("5Pqa3");

var $b1RJj = parcelRequire("b1RJj");

var $1HCMp = parcelRequire("1HCMp");

var $8JI9I = parcelRequire("8JI9I");

var $kNriQ = parcelRequire("kNriQ");

var $cRP2d = parcelRequire("cRP2d");
const $3789cf83eed10ddd$var$CREATED_ORDER_DESCENDING = '-created';
const $3789cf83eed10ddd$export$1780a132c0453fee = 'issueViewInteractiveQuery';
const $3789cf83eed10ddd$export$aefb19023b2eda55 = (_baseUrl, operation)=>`/rest/gira/1/${(0, $96nmc.appendOperationQuery)(operation)}`;
// JIV-19906: retrieve query string from URL -- only expected to be used by client side code
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $3789cf83eed10ddd$var$getURLFromWindow = ()=>new URL(window.location.href);
const $3789cf83eed10ddd$var$viewIssueQuery = (url = $3789cf83eed10ddd$var$getURLFromWindow())=>`
    viewIssue(issueKey: $issueKey) {
        canCreateSubTask
        canExportIssue
        ${/**
					 * THIS QUERY ONLY FETCHES TOTAL COUNT OF COMMENTS
					 * For all other comment related data, use AGG endpoints
					 * Note: When activity sorting feature is enabled, we do not
					 * want to fetch with sort order passed through; we should defer
					 * to the saved sort order in the backend to return the correct
					 * sort order
					 */ (0, $EJMEI.default)({
        maxResults: (0, $92ECu.NUM_INITIAL_COMMENTS_TO_LOAD),
        startAt: 0,
        orderBy: $3789cf83eed10ddd$var$CREATED_ORDER_DESCENDING,
        commentAmount: Math.floor((0, $92ECu.NUM_INITIAL_COMMENTS_TO_LOAD)),
        url: url
    })}
        ${/**
					 * Note: When activity sorting feature is enabled, we do not
					 * want to fetch with sort order passed through; we should defer
					 * to the saved sort order in the backend to return the correct
					 * sort order
					 */ (0, $cRP2d.default)({
        startAt: 0,
        worklogAmount: Math.floor((0, $92ECu.NUM_INITIAL_WORKLOGS_TO_LOAD)),
        url: url
    })}
        ${(0, $e2Vt6.getEcosystemQuery)()}
        ${(0, $8TkIN.getContentPanelsQuery)()}
        ${(0, $e2Vt6.getLegacyRightWebPanelsQuery)()}
        totalAttachmentsCount
        ${(0, $5Pqa3.getContainersByTypeQuery)()}
        ${(0, $kNriQ.getRemoteLinksQuery)()}
    }
`;
const $3789cf83eed10ddd$export$79eba9bf6dc9960d = ()=>`
    jira {
        ecosystemFirstSeenOnIssueView
    }
`;
const $3789cf83eed10ddd$export$58eaa2ae4a5a410a = ()=>`
    jira {
        ecosystemFirstSeenOnIssueView
        hasAdministerPermission: hasGlobalPermission(key: ADMINISTER)
        hasUserPickerPermission: hasGlobalPermission(key: USER_PICKER)
    }
`;
const $3789cf83eed10ddd$export$222ae9aca08830f0 = (url)=>`
query ${$3789cf83eed10ddd$export$1780a132c0453fee}($issueKey: String!, $projectKey: String)  {
        ${$3789cf83eed10ddd$export$58eaa2ae4a5a410a()}
        ${(0, $b1RJj.default)()}
        ${$3789cf83eed10ddd$var$viewIssueQuery(url)}
        ${(0, $6QL4r.getJiraSettingsQuery)()}
        ${(0, $1HCMp.default)()}
        ${(0, $8JI9I.default)()}
    }

`;
const $3789cf83eed10ddd$export$e1542dc7ff749de8 = (issueKey, projectKey, url)=>{
    const payload = {
        operationName: $3789cf83eed10ddd$export$1780a132c0453fee,
        query: $3789cf83eed10ddd$export$222ae9aca08830f0(url),
        variables: {
            issueKey: issueKey,
            projectKey: projectKey
        }
    };
    return {
        method: 'POST',
        body: JSON.stringify(payload)
    };
};

});
parcelRegister("96nmc", function(module, exports) {

$parcel$export(module.exports, "appendOperationQuery", () => $8119dcf59ebfcad5$export$69694c3add0f6058);
const $8119dcf59ebfcad5$export$69694c3add0f6058 = (operation)=>operation ? `?operation=${operation}` : '';

});

parcelRegister("EJMEI", function(module, exports) {

$parcel$export(module.exports, "default", () => $01ae9b8d951a6992$export$2e2bcd8739ae039);

var $6tI1D = parcelRequire("6tI1D");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$01ae9b8d951a6992$export$2e2bcd8739ae039 = ({ maxResults: maxResults, startAt: startAt, orderBy: orderBy, commentAmount: commentAmount, url: url })=>{
    const commentPermalinkId = url ? (0, $6tI1D.getPermalinkIdFromURL)((0, $6tI1D.COMMENTS), url) : (0, $6tI1D.getPermalinkId)((0, $6tI1D.COMMENTS));
    const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
    const commentParameter = commentPermalinkId !== null && commentPermalinkId !== undefined ? `, commentId: ${commentPermalinkId}` : '';
    const commentAmountParameter = commentParameter !== '' && commentAmount !== null && commentAmount !== undefined ? `, commentAmount: ${commentAmount}` : '';
    const maxResultsParameter = commentParameter === '' && maxResults !== null && maxResults !== undefined ? `, maxResults: ${maxResults}` : '';
    return `
        comments (first: ${startAt}${maxResultsParameter}${orderByParameter}${commentParameter}${commentAmountParameter}) {
            totalCount
        }
    `;
};

});

parcelRegister("8TkIN", function(module, exports) {

$parcel$export(module.exports, "getContentPanelsQuery", () => $09fdc8c72c341092$export$e6f14eac549b679d);
const $09fdc8c72c341092$var$getContentPanelNode = ()=>`
    name
    addonKey
    moduleKey
    options
    iconUrl
    tooltip
    type
    isShownByDefault
    wasManuallyAddedToIssue
`;
const $09fdc8c72c341092$var$getContentPanelsConnectionQuery = ()=>`
    contentPanels {
        edges {
            node {
                ${$09fdc8c72c341092$var$getContentPanelNode()}
            }
        }
    }
`;
const $09fdc8c72c341092$var$getLegacyContentPanelsConnectionQuery = ()=>`
    legacyContentPanels {
        edges {
            node {
                ${$09fdc8c72c341092$var$getContentPanelNode()}
            }
        }
    }
`;
const $09fdc8c72c341092$export$e6f14eac549b679d = ()=>`
    ${$09fdc8c72c341092$var$getContentPanelsConnectionQuery()}
    ${$09fdc8c72c341092$var$getLegacyContentPanelsConnectionQuery()}
    hasCustomisedContentPanels
`;

});

parcelRegister("e2Vt6", function(module, exports) {

$parcel$export(module.exports, "getEcosystemQuery", () => $1771eed42c62eeca$export$edefef8c65e08bd2);
$parcel$export(module.exports, "getLegacyRightWebPanelsQuery", () => $1771eed42c62eeca$export$92c9a3dc7076af51);
const $1771eed42c62eeca$var$getForgeQuery = ()=>`forge {
        panels {
          id
          instances {
            id
            collapsed
            added
          }
        }
      }`;
const $1771eed42c62eeca$export$edefef8c65e08bd2 = ()=>`
    ecosystem {
      activityPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
      }
      contextPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
        icon {
          url
        }
        content
        status
        type
      }
      ${$1771eed42c62eeca$var$getForgeQuery()}
    }
`;
const $1771eed42c62eeca$export$92c9a3dc7076af51 = ()=>`
        legacyRightWebPanels {
          edges {
            node {
              name
              status
              addonKey
              moduleKey
              options
              content
            }
          }
        }
      `;

});

parcelRegister("92ECu", function(module, exports) {

$parcel$export(module.exports, "NUM_INITIAL_COMMENTS_TO_LOAD", () => $9387aa2a419a55f9$export$c46d621c29194aa4);
$parcel$export(module.exports, "NUM_INITIAL_WORKLOGS_TO_LOAD", () => $9387aa2a419a55f9$export$b2e398ce246f55b3);
$parcel$export(module.exports, "gqlTagGira", () => $9387aa2a419a55f9$export$aeae6fc40846cf9f);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports














const $9387aa2a419a55f9$export$c46d621c29194aa4 = 5;
const $9387aa2a419a55f9$export$304a6c004edb30d8 = '-created';
const $9387aa2a419a55f9$export$b2e398ce246f55b3 = 5;
const $9387aa2a419a55f9$export$1c36ecc9afd61c73 = '-started';
const $9387aa2a419a55f9$export$aeae6fc40846cf9f = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};

});

parcelRegister("6QL4r", function(module, exports) {

$parcel$export(module.exports, "getJiraSettingsQuery", () => $10470e592ba8e782$export$191f50c0f86b85ec);
const $10470e592ba8e782$export$e302502f14e3f203 = ()=>`
          timeTracking {
            isTimeTrackingEnabled
            hoursPerDay
            daysPerWeek
            defaultUnit
            format
          }
    `;
const $10470e592ba8e782$export$65e7d3d1915962da = ()=>`
          subtasks {
            enabled
          }
    `;
const $10470e592ba8e782$export$191f50c0f86b85ec = ()=>`
    jiraSettings {
      newIssueViewTransitionSettings {
        shouldDelayChangeboarding
        newIssueViewTransitionLockingStatus
     }
    }
`;

});

parcelRegister("5Pqa3", function(module, exports) {

$parcel$export(module.exports, "getContainersByTypeQuery", () => $85e2f5a62f1697d1$export$63131b2831854cc);

var $e5wyW = parcelRequire("e5wyW");

var $4R6GH = parcelRequire("4R6GH");
const $85e2f5a62f1697d1$export$e30f32dd3fd26efd = ()=>`
containersByType(input:{systemContainerTypes: [CONTENT, PRIMARY, SECONDARY, REQUEST_PORTAL], supportDefaultTab: true}) {
__typename
... on JiraIssueItemContainers {
containers {
  containerType
  items {
    nodes {
      type: __typename
      ... on JiraIssueItemFieldItem {
        fieldItemId        
      }
      ... on JiraIssueItemPanelItem {
        panelItemId
      }
      ... on JiraIssueItemTabContainer {
        name
        tabContainerId              
        items {
          nodes {
            type: __typename
            ... on JiraIssueItemFieldItem {
              fieldItemId
            }
          }
        }
      }
    }
  }
}
}
}
`;
const $85e2f5a62f1697d1$export$842411c0b98baa9c = ()=>`
containersByType(input:{systemContainerTypes: [CONTENT, PRIMARY, SECONDARY, REQUEST_PORTAL, CUSTOMER_CONTEXT], supportDefaultTab: true}) {
__typename
... on JiraIssueItemContainers {
containers {
  containerType
  items {
    nodes {
      type: __typename
      ... on JiraIssueItemFieldItem {
        fieldItemId        
      }
      ... on JiraIssueItemPanelItem {
        panelItemId
      }
      ... on JiraIssueItemTabContainer {
        name
        tabContainerId              
        items {
          nodes {
            type: __typename
            ... on JiraIssueItemFieldItem {
              fieldItemId
            }
          }
        }
      }
    }
  }
}
}
}
`;
const $85e2f5a62f1697d1$export$63131b2831854cc = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('jcs_master_flag'), $85e2f5a62f1697d1$export$842411c0b98baa9c, $85e2f5a62f1697d1$export$e30f32dd3fd26efd);

});

parcelRegister("b1RJj", function(module, exports) {

$parcel$export(module.exports, "default", () => $42429f0fa15c54ae$export$2e2bcd8739ae039);

var $9wuCE = parcelRequire("9wuCE");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$42429f0fa15c54ae$export$2e2bcd8739ae039 = ()=>`mediaContext(issueKey: $issueKey) {
    userToken {
      token
      id
      issueId
      tokenDurationInMins
    }
    uploadToken {
      __typename
      ... on MediaUploadToken {
        endpointUrl
        token
        targetCollection
        tokenDurationInMins
        clientId
      }
      ... on FailedMediaUploadToken {
        error
      }
    }
    readToken(maxTokenLength: ${(0, $9wuCE.getMaxTokenLength)()}) {
      clientId
      endpointUrl
      tokensWithFiles {
        files {
          issueId
          attachmentId
          attachmentMediaApiId
        }
        token
      }
      tokenLifespanInSeconds
    }
  }`;

});
parcelRegister("9wuCE", function(module, exports) {

$parcel$export(module.exports, "getMaxTokenLength", () => $ebb491dcc11e8362$export$e40f2acaf1a50b00);
// Low enough such that it shouldn't cause problems for non-IE11 browsers, and high
// enough such that it shouldn't be encountered in practice very often.
const $ebb491dcc11e8362$var$nonIE11MaxTokenLength = 2 ** 16;
const $ebb491dcc11e8362$export$e40f2acaf1a50b00 = ()=>$ebb491dcc11e8362$var$nonIE11MaxTokenLength;

});


parcelRegister("1HCMp", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ea17df757c74c46$export$2e2bcd8739ae039);
// A list of all keys of permissions that this transformer supports.
const $0ea17df757c74c46$export$9fc40cb6f3529ef = ()=>[
        'ADMINISTER_PROJECTS',
        'ASSIGN_ISSUES',
        'EDIT_ISSUES',
        'SCHEDULE_ISSUES',
        'ADD_COMMENTS',
        'DELETE_ALL_COMMENTS',
        'DELETE_OWN_COMMENTS',
        'EDIT_ALL_COMMENTS',
        'EDIT_OWN_COMMENTS',
        'CREATE_ISSUES',
        'DELETE_ISSUES',
        'MOVE_ISSUES',
        'MODIFY_REPORTER',
        'CREATE_ATTACHMENTS',
        'DELETE_ALL_ATTACHMENTS',
        'DELETE_OWN_ATTACHMENTS',
        'WORK_ON_ISSUES',
        'ASSIGNABLE_USER',
        'LINK_ISSUES',
        'VIEW_VOTERS_AND_WATCHERS',
        'MANAGE_WATCHERS',
        'EDIT_ALL_WORKLOGS',
        'EDIT_OWN_WORKLOGS',
        'DELETE_ALL_WORKLOGS',
        'DELETE_OWN_WORKLOGS',
        'VIEW_DEV_TOOLS',
        'SERVICEDESK_AGENT',
        'RESOLVE_ISSUES',
        'CLONE_ISSUE',
        'ARCHIVE_ISSUES',
        'UNARCHIVE_ISSUES'
    ];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0ea17df757c74c46$export$2e2bcd8739ae039 = ()=>`

    permissions(issueKey:$issueKey, keys:["${$0ea17df757c74c46$export$9fc40cb6f3529ef().join('","')}"]) {
        key
        havePermission
    }
`;

});

parcelRegister("8JI9I", function(module, exports) {

$parcel$export(module.exports, "default", () => $2232e63ddd04bbb1$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $2232e63ddd04bbb1$export$2e2bcd8739ae039 = ()=>`
    project(projectKey: $projectKey) {
        id
        newIssueViewLockedIn
        issueTypes {
            id
            name
            iconUrl
            subtask
        }
    }
`;

});

parcelRegister("kNriQ", function(module, exports) {

$parcel$export(module.exports, "getRemoteLinksQuery", () => $e19ca26272d1dd4d$export$6bbc6b72b0b57f25);

var $4R6GH = parcelRequire("4R6GH");
const $e19ca26272d1dd4d$var$getRemoteLinkedIssuesPreviewFragment = ()=>`
    id
    issueId
    globalId
    href
    applicationType
    applicationName
    relationship
    title
`;
const $e19ca26272d1dd4d$var$getAssociatedIssueFragment = ()=>`
    issueId
    issueKey {
        stringValue
    }
    summary {
        textValue
    }
    status {
        statusCategoryId
        name
        statusId
    }
    priority {
        iconUrl
        name
    }
    issueType {
        iconUrl
        name
    }
    assignee {
        userValue
        {
            displayName
            avatarUrl
        }
    }
   isResolved
`;
const $e19ca26272d1dd4d$var$getRemoteLinkedIssuesDetailsFragment = ()=>`
    ... on AssociatedIssueWrapper {
        associatedIssue {
            ${$e19ca26272d1dd4d$var$getAssociatedIssueFragment()}
        }
    }
    ... on FailedRemoteIssue {
        error
        repairLink { href }
    }
`;
const $e19ca26272d1dd4d$var$getRemoteLinkedIssuesFragment = ()=>`
    remoteLinkedIssues {
        preview {
            ${$e19ca26272d1dd4d$var$getRemoteLinkedIssuesPreviewFragment()}
        }
        details {
            ${$e19ca26272d1dd4d$var$getRemoteLinkedIssuesDetailsFragment()}
        }
    }
`;
const $e19ca26272d1dd4d$var$getWebLinksFragment = ()=>`
    webLinks(allowThirdParties: true, orderBy: "-id") {
        linkCount
        links {
            id
            href
            linkText
            iconUrl
            summary
            resolved
            relationship
            applicationName
            applicationType
        }
    }
`;
const $e19ca26272d1dd4d$var$getRemoteLinksQueryNew = ()=>`
    remoteLinks {
        isLinkingEnabled
        confluencePages {
            linkedPages {
				pageCount
				pages {
					... on ConfluencePage {
						id
						globalId
						href
						title
						type
					}
					... on FailedRemoteLink {
						id
						error
						link {
							id
							globalId
							href
						}
						repairLink { href }
					}
				}
            }
        }
        ${$e19ca26272d1dd4d$var$getWebLinksFragment()}
        ${$e19ca26272d1dd4d$var$getRemoteLinkedIssuesFragment()}
    }
`;
const $e19ca26272d1dd4d$var$getRemoteLinksQueryOld = ()=>`
    remoteLinks {
        isLinkingEnabled
        remoteLinkedIssues {
            preview {
                id
                issueId
                globalId
                href
                applicationType
                applicationName
                relationship
                title
            }
        }
    }
`;
const $e19ca26272d1dd4d$export$6bbc6b72b0b57f25 = ()=>(0, $4R6GH.fg)('jiv-19125-fetch-remote-links-in-interactive-query') ? $e19ca26272d1dd4d$var$getRemoteLinksQueryNew() : $e19ca26272d1dd4d$var$getRemoteLinksQueryOld();

});

parcelRegister("cRP2d", function(module, exports) {

$parcel$export(module.exports, "default", () => $354b7c85b873ab44$export$2e2bcd8739ae039);

var $6tI1D = parcelRequire("6tI1D");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$354b7c85b873ab44$export$2e2bcd8739ae039 = ({ startAt: startAt, orderBy: orderBy, worklogAmount: worklogAmount, url: url })=>{
    const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
    const worklogPermalinkId = url ? (0, $6tI1D.getPermalinkIdFromURL)((0, $6tI1D.WORKLOG), url) : (0, $6tI1D.getPermalinkId)((0, $6tI1D.WORKLOG));
    if (worklogPermalinkId === null || worklogPermalinkId === undefined) return '';
    const worklogParameter = `, worklogId: ${worklogPermalinkId}`;
    const worklogAmountParameter = worklogAmount !== null && worklogAmount !== undefined ? `, worklogAmount: ${worklogAmount}` : '';
    return `
        worklogs (startAt: ${startAt}${orderByParameter}${worklogParameter}${worklogAmountParameter}) {
            nodes {
                id
                author {
                    accountId
                    displayName
                    avatarUrl
                }
                updateAuthor {
                    accountId
                    displayName
                    avatarUrl
                }
                created
                started
                updated
                comment
                timeSpent
                timeSpentSeconds
            }
            totalCount
            startIndex
        }
    `;
};

});


parcelRegister("9kbEN", function(module, exports) {

$parcel$export(module.exports, "isInSample", () => $b9c2013a86366ec0$export$a994c91d08ead5ff);

const $b9c2013a86366ec0$export$a994c91d08ead5ff = (sampleRate = (0, $670519621927ccc4$export$9fc1f2d681a9e609))=>Math.random() <= 1 / sampleRate;

});
/**
 * Sample rates are defined as the inverse.
 * e.g. a sample rate of 100 = 1 in 100 events are sent.
 */ const $670519621927ccc4$export$9fc1f2d681a9e609 = 100; // 1%


parcelRegister("iBOrg", function(module, exports) {

$parcel$export(module.exports, "getClient", () => $3d6ab2890da8f9df$export$6bb76d6eba7e258c);

var $7f4tk = parcelRequire("7f4tk");

var $fqpdr = parcelRequire("fqpdr");
const $3d6ab2890da8f9df$var$makeFetchClient = (baseUrl)=>({
        query: ({ query: query, variables: variables, signal: signal, operationName: operationName })=>(0, $7f4tk.default)((0, $fqpdr.getGiraUrl)(baseUrl, operationName), {
                method: 'POST',
                body: JSON.stringify({
                    query: query,
                    variables: variables,
                    operationName: operationName
                }),
                signal: signal
            })
    });
let $3d6ab2890da8f9df$var$client;
const $3d6ab2890da8f9df$export$6bb76d6eba7e258c = (baseUrl)=>{
    if (!$3d6ab2890da8f9df$var$client) $3d6ab2890da8f9df$var$client = $3d6ab2890da8f9df$var$makeFetchClient(baseUrl);
    return $3d6ab2890da8f9df$var$client;
};

});




parcelRegister("fjoQ1", function(module, exports) {

$parcel$export(module.exports, "browseIssueEmbedRoute", () => $1c5f13cdd9ba8bf4$export$240aeec71c480594);
const $1c5f13cdd9ba8bf4$export$240aeec71c480594 = {
    name: 'issue-embed',
    path: '/browse/:issueKey(\\w+-\\d+)/embed'
};

});

parcelRegister("lb0Dk", function(module, exports) {

$parcel$export(module.exports, "IssueViewSkeleton", () => $bf9ca492e3d15685$export$49addbcdecb6e6ff);
/* IssueViewSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $iMqhh = parcelRequire("iMqhh");

var $hCy6k = parcelRequire("hCy6k");

var $3441h = parcelRequire("3441h");
const $bf9ca492e3d15685$var$fullpageStyles = null;
const $bf9ca492e3d15685$var$modalStyles = null;
const $bf9ca492e3d15685$var$customSpacingStyles = null;
const $bf9ca492e3d15685$export$49addbcdecb6e6ff = ({ isEmbedView: isEmbedView, isModalView: isModalView })=>{
    // same as getIssueContainerMaxWidth
    const customCss = [
        $bf9ca492e3d15685$var$customSpacingStyles,
        isEmbedView !== true && isModalView !== true ? $bf9ca492e3d15685$var$fullpageStyles : null,
        isModalView === true ? $bf9ca492e3d15685$var$modalStyles : null
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iMqhh.CompactModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3441h))),
        className: (0, $bwpsq.default)([
            "_p12f107j _19pkze3t _2hwx1wug _otyrze3t _18u01wug _t6vdxy5q _hr4jxy5q _11y7uu9g _l82tpxbi _j7o0pxbi",
            isEmbedView !== true && isModalView !== true && "_uwhk1ejb",
            isModalView === true && "_19pk10j7"
        ])
    }));
};

});
parcelRegister("iMqhh", function(module, exports) {

$parcel$export(module.exports, "CompactModeContext", () => $db79d17d45755de5$export$37eeac5cc5245b18);
$parcel$export(module.exports, "CompactModeProvider", () => $db79d17d45755de5$export$10cf42790e523b8e);
$parcel$export(module.exports, "CompactModeConsumer", () => $db79d17d45755de5$export$20feb77b5b617e44);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eIGIx = parcelRequire("eIGIx");

var $4R6GH = parcelRequire("4R6GH");


var $8kj45 = parcelRequire("8kj45");

var $doZTA = parcelRequire("doZTA");

var $k1L82 = parcelRequire("k1L82");

var $hhMVP = parcelRequire("hhMVP");
const $db79d17d45755de5$export$37eeac5cc5245b18 = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
const { Provider: $db79d17d45755de5$var$Provider, Consumer: $db79d17d45755de5$var$Consumer } = $db79d17d45755de5$export$37eeac5cc5245b18;
const $db79d17d45755de5$export$55a90a8e865a39b5 = 700;
const $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY = `(max-width: ${$db79d17d45755de5$export$55a90a8e865a39b5}px)`;
const $db79d17d45755de5$export$ddd398a95f85cd75 = 850;
const $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY_SIDE_PANEL = `(max-width: ${$db79d17d45755de5$export$ddd398a95f85cd75}px)`;
/**
 * A utility hook which returns a key based on the route
 */ function $db79d17d45755de5$var$useRouteKey() {
    const [routeState] = (0, $doZTA.useRouter)();
    const { match: { path: path, params: params } } = routeState;
    // handle case where JSM doesn't have an issueKey on their route
    const hasIssueKey = params?.issueKey !== undefined;
    return `${path}${hasIssueKey ? '/hasIssueKey' : ''}`;
}
const $db79d17d45755de5$export$10cf42790e523b8e = ({ children: children })=>{
    const key = $db79d17d45755de5$var$useRouteKey();
    (0, $hhMVP.invalidateCacheIfRouteChanged)(key);
    let defaultState = (0, $hhMVP.getCachedIsCompactValue)(key);
    // in case there is no state change triggered
    if (defaultState === undefined) {
        defaultState = (0, $7093eea63dce9286$export$ee15e0cd1efafcb4);
        (0, $hhMVP.setCachedIsCompactValue)(defaultState, key);
    }
    const { isInDiscussionLayoutExperiment: isInDiscussionLayoutExperiment } = (0, $k1L82.useUserPreferredWorkItemLayout)();
    const query = isInDiscussionLayoutExperiment ? $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY_SIDE_PANEL : $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY;
    const [isCompact, setIsCompact] = (0, $5uXOq.useState)(defaultState);
    const onChange = (0, $eIGIx.useCallbackWithCondition)((state)=>{
        (0, $hhMVP.setCachedIsCompactValue)(state, key);
        setIsCompact(state);
    }, [
        key
    ], ()=>(0, $4R6GH.fg)('jfp_magma_issue-stability-phase1'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db79d17d45755de5$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8kj45.ContainerQueryObserver), {
        query: query,
        onChange: onChange,
        defaultState: defaultState
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db79d17d45755de5$var$Provider, {
        value: isCompact
    }, children));
};
const $db79d17d45755de5$export$20feb77b5b617e44 = $db79d17d45755de5$var$Consumer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $db79d17d45755de5$var$StyledWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eIGIx", function(module, exports) {

$parcel$export(module.exports, "useMemoWithCondition", () => $8faf574d2943732e$export$ed979cc60a2ab51b);
$parcel$export(module.exports, "useCallbackWithCondition", () => $8faf574d2943732e$export$a51aeb9e9cb9a97e);

var $5uXOq = parcelRequire("5uXOq");
const $8faf574d2943732e$export$ed979cc60a2ab51b = (fn, deps, condition)=>{
    if (condition()) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $5uXOq.useMemo)(fn, deps);
    return fn();
};
const $8faf574d2943732e$export$a51aeb9e9cb9a97e = (fn, deps, condition)=>{
    if (condition()) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $5uXOq.useCallback)(fn, deps);
    return fn;
};

});

const $7093eea63dce9286$export$ee15e0cd1efafcb4 = false;

parcelRegister("8kj45", function(module, exports) {

$parcel$export(module.exports, "ContainerQueryObserver", () => $ed10e3c030ea0408$export$e9574287678b8467);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

const $ed10e3c030ea0408$var$QueryContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
let $ed10e3c030ea0408$var$currentIdSeed = 0;
function $ed10e3c030ea0408$var$generateAttributeValue() {
    return `indicator-span-${$ed10e3c030ea0408$var$currentIdSeed++}`;
}
function $ed10e3c030ea0408$export$e9574287678b8467({ children: children, query: query, onChange: onChange, defaultState: defaultState = (0, $7093eea63dce9286$export$ee15e0cd1efafcb4) }) {
    const [active, setActive] = (0, $5uXOq.useState)(defaultState);
    const handleQueryStatusChange = (0, $5uXOq.useCallback)((isContainerQueryActive)=>{
        onChange?.(isContainerQueryActive);
        setActive(isContainerQueryActive);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$QueryContext.Provider, {
        value: active
    }, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$IntersectionIndicator, {
        query: query,
        notifyIntersectionStatusChanged: handleQueryStatusChange
    }), children);
}
function $ed10e3c030ea0408$export$b66a67697973e01() {
    const currentState = (0, $5uXOq.useContext)($ed10e3c030ea0408$var$QueryContext);
    if (currentState === undefined) throw new Error('The component must be wrapped in a ContainerQueryObserver to use useContainerQueryState');
    return currentState;
}
function $ed10e3c030ea0408$var$IntersectionIndicator({ notifyIntersectionStatusChanged: handleChange, query: query }) {
    const attributeValue = (0, $5uXOq.useMemo)(()=>$ed10e3c030ea0408$var$generateAttributeValue(), []);
    const spanRef = (0, $5uXOq.useRef)(null);
    const containerRef = (0, $5uXOq.useRef)(null);
    const currentState = $ed10e3c030ea0408$export$b66a67697973e01();
    (0, $5uXOq.useLayoutEffect)(()=>{
        const queryStatusChangedCallback = (entries)=>{
            // This means that the parent container is either empty or loading, we should not notify of any change in this case.
            if (!containerRef.current || containerRef.current.clientWidth === 0) return;
            if (entries.length > 0) {
                // only ever going to be one entry max
                const isContainerQueryActive = entries[0].isIntersecting;
                if (isContainerQueryActive !== currentState) handleChange(isContainerQueryActive);
            }
        };
        const intersectionObserver = new IntersectionObserver(queryStatusChangedCallback);
        const spanElement = spanRef.current;
        spanElement && intersectionObserver.observe(spanElement);
        return ()=>{
            spanElement && intersectionObserver.unobserve(spanElement);
            intersectionObserver.disconnect();
        };
    }, [
        currentState,
        handleChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$ContainerToBeQueried, {
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", {
        type: "text/css"
    }, `
                    [data-container-query-indicator-id="${attributeValue}"] {
                        display: none;
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100vh;
                        pointer-events: none;
                    }
                    @container ${query} {
                        [data-container-query-indicator-id="${attributeValue}"] {
                            display: inherit;
                        }
                    }`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        ref: spanRef,
        "data-container-query-indicator-id": attributeValue
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ed10e3c030ea0408$var$ContainerToBeQueried = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqsw1if8 _lcxvglyw _154iidpf _7ccakre2",
            __cmplp.className
        ])
    });
});

});

parcelRegister("k1L82", function(module, exports) {

$parcel$export(module.exports, "useIssueLayoutContainers", () => $725285d3420dc4d6$export$d146dfa0384f99a3);
$parcel$export(module.exports, "useLayoutContainerByType", () => $725285d3420dc4d6$export$5f49a43487b268);
$parcel$export(module.exports, "useLayoutContainerByTypeMemoised", () => $725285d3420dc4d6$export$ef5966e43b13b4a9);
$parcel$export(module.exports, "useIssueLayoutGlance", () => $725285d3420dc4d6$export$fd7f0cc3d2b405e6);
$parcel$export(module.exports, "useIssueLayoutContextPanel", () => $725285d3420dc4d6$export$5962da0433486667);
$parcel$export(module.exports, "useUserPreferredWorkItemLayout", () => $725285d3420dc4d6$export$9889eea62fdfa091);
$parcel$export(module.exports, "useIssueLayoutActions", () => $725285d3420dc4d6$export$1e5e9fc877a47cd9);

var $5uXOq = parcelRequire("5uXOq");

var $eIGIx = parcelRequire("eIGIx");

var $egBua = parcelRequire("egBua");

var $6s1PB = parcelRequire("6s1PB");

var $eNNkf = parcelRequire("eNNkf");

var $2gCtH = parcelRequire("2gCtH");


var $93Yeu = parcelRequire("93Yeu");

var $4R6GH = parcelRequire("4R6GH");

var $2vSU6 = parcelRequire("2vSU6");

var $2YZCu = parcelRequire("2YZCu");

var $bCdIp = parcelRequire("bCdIp");

var $kI4MM = parcelRequire("kI4MM");

var $cNJ33 = parcelRequire("cNJ33");
const $725285d3420dc4d6$export$d146dfa0384f99a3 = (issueKey)=>{
    const [containers] = (0, $kI4MM.useIssueLayoutContainersStore)(issueKey);
    return [
        containers
    ];
};
const $725285d3420dc4d6$export$5f49a43487b268 = (issueKey, type)=>{
    const [containers] = (0, $kI4MM.useIssueLayoutContainersStore)(issueKey);
    const container = containers.find((innerContainer)=>innerContainer.containerType === type);
    // Forge app with UI Modifications module can hide selected fields using
    // UI modifications Field API. We are removing them here from the layout fields
    const fieldsHiddenByUim = (0, $egBua.useEnabledHiddenFields)();
    return (0, $eIGIx.useMemoWithCondition)(()=>[
            (0, $cNJ33.filterOutItemsWithProvidedIds)(container?.items.nodes ?? [], fieldsHiddenByUim)
        ], [
        container?.items.nodes,
        fieldsHiddenByUim
    ], ()=>(0, $4R6GH.fg)('jfp_magma_issue-stability-phase1'));
};
const $725285d3420dc4d6$export$ef5966e43b13b4a9 = (issueKey, type)=>{
    const [containers] = (0, $kI4MM.useIssueLayoutContainersStore)(issueKey);
    const container = containers.find((innerContainer)=>innerContainer.containerType === type);
    const fieldsHiddenByUim = (0, $egBua.useEnabledHiddenFields)();
    const filteredItems = (0, $5uXOq.useMemo)(()=>{
        return (0, $cNJ33.filterOutItemsWithProvidedIds)(container?.items.nodes ?? [], fieldsHiddenByUim);
    }, [
        container,
        fieldsHiddenByUim
    ]);
    return [
        filteredItems
    ];
};
const $725285d3420dc4d6$export$fd7f0cc3d2b405e6 = (issueKey)=>{
    const [glance] = (0, $kI4MM.useIssueLayoutGlanceStore)(issueKey);
    return [
        glance
    ];
};
const $725285d3420dc4d6$export$5962da0433486667 = (issueKey)=>{
    const [contextPanel] = (0, $kI4MM.useIssueLayoutContextPanelStore)(issueKey);
    return [
        contextPanel
    ];
};
const $725285d3420dc4d6$export$9889eea62fdfa091 = ()=>{
    try {
        if (!(0, $4R6GH.fg)('issue_view_layouts_kill_switch')) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        // eslint-disable-next-line react-hooks/react-compiler
        /* eslint-disable react-hooks/rules-of-hooks */ const issueKey = (0, $2gCtH.useIssueKey)();
        const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
        const projectType = (0, $93Yeu.useProjectType)(projectKey);
        const isFullIssueView = (0, $2gCtH.useIsFullPageIssueView)();
        const [userPreferredLayout] = (0, $eNNkf.useUserPreferencesValue)((0, $31848aa9a0db89de$export$39aaf586c7ee5202));
        const isMobile = (0, $bCdIp.default)();
        const isSoftwareOrBusiness = projectType === (0, $2vSU6.SOFTWARE_PROJECT) || projectType === (0, $2vSU6.CORE_PROJECT);
        const shouldBeInLayoutExperiment = !isMobile && isSoftwareOrBusiness && isFullIssueView;
        if (!shouldBeInLayoutExperiment) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        const isInWideLayoutExperiment = shouldBeInLayoutExperiment && (0, $6s1PB.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false);
        const isInDiscussionLayoutExperiment = shouldBeInLayoutExperiment && (0, $6s1PB.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false);
        const isInLayoutExperiment = isInWideLayoutExperiment || isInDiscussionLayoutExperiment;
        const userLayoutType = isInLayoutExperiment && userPreferredLayout && typeof userPreferredLayout === 'string' ? JSON.parse(userPreferredLayout)?.layoutType : null;
        /* eslint-enable react-hooks/rules-of-hooks */ let userSelectedLayout = userLayoutType;
        if (isInLayoutExperiment && isInDiscussionLayoutExperiment && userLayoutType === 'WIDE') userSelectedLayout = 'STANDARD';
        if (isInLayoutExperiment && isInWideLayoutExperiment && userLayoutType === 'DISCUSSION') userSelectedLayout = 'STANDARD';
        // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
        // but we keep it to avoid making too many changes in the codebase
        const isActivityInVerticalSidePanel = isInDiscussionLayoutExperiment && userSelectedLayout === 'DISCUSSION';
        return {
            isInDiscussionLayoutExperiment: Boolean(isInDiscussionLayoutExperiment),
            isInWideLayoutExperiment: Boolean(isInWideLayoutExperiment),
            isInLayoutExperiment: Boolean(isInLayoutExperiment),
            // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
            // but we keep it to avoid making too many changes in the codebase
            isActivityInVerticalSidePanel: Boolean(isActivityInVerticalSidePanel),
            userPreferredLayout: userSelectedLayout
        };
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('issue-view-layout.services.main', `Error in useUserPreferredWorkItemLayout : ${error}`);
        return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
    }
};
const $725285d3420dc4d6$export$1e5e9fc877a47cd9 = ()=>{
    const [, actions] = (0, $kI4MM.useIssueLayoutActionsStore)();
    const setIssueViewContainersLayout = (0, $5uXOq.useCallback)((issueKey, containersByType)=>{
        actions.setIssueViewContainersLayout(issueKey, containersByType);
    }, [
        actions
    ]);
    const setIssueViewLayoutGlance = (0, $5uXOq.useCallback)((issueKey, glance)=>{
        actions.setIssueViewLayoutGlance(issueKey, glance);
    }, [
        actions
    ]);
    const setIssueViewLayoutContextPanel = (0, $5uXOq.useCallback)((issueKey, newContextPanel)=>{
        actions.setIssueViewLayoutContextPanel(issueKey, newContextPanel);
    }, [
        actions
    ]);
    return [
        null,
        {
            setIssueViewContainersLayout: setIssueViewContainersLayout,
            setIssueViewLayoutGlance: setIssueViewLayoutGlance,
            setIssueViewLayoutContextPanel: setIssueViewLayoutContextPanel
        }
    ];
};

});
parcelRegister("egBua", function(module, exports) {

$parcel$export(module.exports, "useEnabledHiddenFields", () => $ea65d07999c73532$export$bb6c2b9159c3f32b);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $jrwZp = parcelRequire("jrwZp");

var $eoznE = parcelRequire("eoznE");
const $ea65d07999c73532$export$bb6c2b9159c3f32b = ()=>{
    (0, $gKZoD.di)((0, $jrwZp.useAdjustmentsEnabled), (0, $eoznE.useHiddenFields));
    const adjustmentsAreEnabled = (0, $jrwZp.useAdjustmentsEnabled)();
    const hiddenFields = (0, $eoznE.useHiddenFields)();
    return (0, $5uXOq.useMemo)(()=>{
        if (!adjustmentsAreEnabled) return [];
        return hiddenFields;
    }, [
        adjustmentsAreEnabled,
        hiddenFields
    ]);
};

});
parcelRegister("jrwZp", function(module, exports) {

$parcel$export(module.exports, "store", () => $db4845f733e81d44$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustmentsEnabled", () => $db4845f733e81d44$export$358ad850b2f6d6fe);
$parcel$export(module.exports, "useAdjustmentsContextActions", () => $db4845f733e81d44$export$4f2729981f4b81d2);
$parcel$export(module.exports, "UiModificationContextContainer", () => $db4845f733e81d44$export$5eb9c167b683d125);

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
const $db4845f733e81d44$var$initialState = {
    shouldUiModificationsLoad: 'unknown',
    hasFinishedLoading: false,
    adjustmentsAreEnabled: false,
    uiModificationsConsentStatus: {}
};
const $db4845f733e81d44$export$e324594224ef24da = {
    resetAdjustmentContext: ()=>({ setState: setState })=>{
            setState($db4845f733e81d44$var$initialState);
        },
    setShouldUiModificationsLoad: (status)=>({ setState: setState })=>{
            setState({
                shouldUiModificationsLoad: status
            });
        },
    setHasFinishedLoading: (hasFinishedLoading)=>({ setState: setState })=>{
            setState({
                hasFinishedLoading: hasFinishedLoading
            });
        },
    setAdjustmentsAreEnabled: (enabled)=>({ setState: setState })=>{
            setState({
                adjustmentsAreEnabled: enabled
            });
        },
    setUIModificationsConsentStatus: ({ appId: appId, status: status })=>({ setState: setState, getState: getState })=>{
            const currentConsentState = getState().uiModificationsConsentStatus;
            setState({
                uiModificationsConsentStatus: {
                    ...currentConsentState,
                    [appId]: status
                }
            });
        }
};
const $db4845f733e81d44$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'issue-adjustments-context',
    initialState: $db4845f733e81d44$var$initialState,
    actions: $db4845f733e81d44$export$e324594224ef24da
});
const $db4845f733e81d44$export$a12f82a132dee079 = (0, $3sQ5x.createHook)($db4845f733e81d44$export$6f57813fe9f31bf9);
const $db4845f733e81d44$export$358ad850b2f6d6fe = (0, $3sQ5x.createStateHook)($db4845f733e81d44$export$6f57813fe9f31bf9, {
    selector: (state)=>state.adjustmentsAreEnabled
});
const $db4845f733e81d44$export$4f2729981f4b81d2 = (0, $3sQ5x.createActionsHook)($db4845f733e81d44$export$6f57813fe9f31bf9);
const $db4845f733e81d44$export$5eb9c167b683d125 = (0, $gg7kZ.createContainer)($db4845f733e81d44$export$6f57813fe9f31bf9, {
    displayName: 'UiModificationContextContainer'
});

});

parcelRegister("eoznE", function(module, exports) {

$parcel$export(module.exports, "useHiddenFields", () => $8c7bafd209de1659$export$de6fdc67c945e596);

var $6dDSs = parcelRequire("6dDSs");
var $3sQ5x = parcelRequire("3sQ5x");

var $1YewZ = parcelRequire("1YewZ");
const $8c7bafd209de1659$var$selectHiddenFields = (0, $6dDSs.createSelector)((state)=>state.formData, (state)=>state.appliedChanges, (formData, appliedChanges)=>{
    if (formData === null) return [];
    return Object.entries(formData).filter(([fieldId, field])=>appliedChanges?.[fieldId]?.isVisible !== undefined ? !appliedChanges[fieldId].isVisible : !field.isVisible).map(([fieldId])=>fieldId);
});
const $8c7bafd209de1659$export$de6fdc67c945e596 = (0, $3sQ5x.createStateHook)((0, $1YewZ.store), {
    selector: $8c7bafd209de1659$var$selectHiddenFields
});

});
parcelRegister("1YewZ", function(module, exports) {

$parcel$export(module.exports, "store", () => $cf6a6312e4141eb7$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustedField", () => $cf6a6312e4141eb7$export$df4b0714e8177e0e);
$parcel$export(module.exports, "useIssueAdjustmentsActions", () => $cf6a6312e4141eb7$export$cb9a014ec14556d8);
$parcel$export(module.exports, "useAdjustedScreenTabs", () => $cf6a6312e4141eb7$export$677b3e34bd14c681);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $3whHg = parcelRequire("3whHg");

var $hyCnL = parcelRequire("hyCnL");

var $boEP0 = parcelRequire("boEP0");

var $2NMWZ = parcelRequire("2NMWZ");

var $d30F5 = parcelRequire("d30F5");

var $8e24q = parcelRequire("8e24q");

var $cTj8m = parcelRequire("cTj8m");

var $i4uue = parcelRequire("i4uue");

var $3iUv8 = parcelRequire("3iUv8");

var $b8ZsE = parcelRequire("b8ZsE");

var $jDMtG = parcelRequire("jDMtG");

var $l0b2q = parcelRequire("l0b2q");

var $4MJXd = parcelRequire("4MJXd");

var $gHQFd = parcelRequire("gHQFd");

var $7JtDe = parcelRequire("7JtDe");
const $cf6a6312e4141eb7$var$name = 'issue-adjustments';
const $cf6a6312e4141eb7$export$d4c72bab9d6cc13a = {
    formData: null,
    screenTabs: null,
    appliedChanges: null,
    error: null,
    registeredFieldsDeprecated: {},
    registeredFields: {},
    triggerFieldInitializationKey: 0,
    // Selector checks if this is not equal 0 in the useFieldReady
    numberOfSupportedFields: 0,
    internalFormMetadata: {},
    viewType: null,
    experienceDataIsLoading: false,
    lastProcessedChange: null,
    fieldsInitialization: {
        startTime: null,
        timeoutId: undefined,
        status: 'notStarted'
    },
    appliedChangesHistory: {},
    appsErrors: {},
    notification: null
};
// triggerFieldInitializationKey, viewType and numberOfSupportedFields should not be reset on project or issue type change
const { triggerFieldInitializationKey: $cf6a6312e4141eb7$var$triggerFieldInitializationKey, viewType: $cf6a6312e4141eb7$var$scopedViewType, numberOfSupportedFields: $cf6a6312e4141eb7$var$numberOfSupportedFields, ...$cf6a6312e4141eb7$var$stateForResetAllFields } = $cf6a6312e4141eb7$export$d4c72bab9d6cc13a;
const $cf6a6312e4141eb7$export$e324594224ef24da = {
    triggerFieldInitialization: ()=>({ getState: getState, setState: setState })=>{
            setState({
                triggerFieldInitializationKey: getState().triggerFieldInitializationKey + 1
            });
        },
    processChange: $b8ZsE.processChange,
    setFieldValue: $l0b2q.setFieldValue,
    initializeField: $8e24q.initializeField,
    initializeFields: $8e24q.initializeFields,
    startFieldsInitialisationTimeout: $d30F5.startFieldsInitialisationTimeout,
    successFieldsInitalisation: $d30F5.successFieldsInitalisation,
    registerFields: $jDMtG.registerFields,
    unregisterFields: $jDMtG.unregisterFields,
    updateFields: $gHQFd.updateFields,
    clearAppliedValue: (fieldId)=>({ setState: setState, getState: getState })=>{
            const previousState = getState().appliedChanges || {};
            if (previousState[fieldId]) {
                const { value: value, ...otherFieldChanges } = previousState[fieldId];
                setState({
                    appliedChanges: {
                        ...previousState,
                        [fieldId]: otherFieldChanges
                    }
                });
            }
        },
    resetAllFields: ()=>({ setState: setState, getState: getState })=>{
            // Clear the fieldsInitialization timeout to avoid potetianl side effects.
            clearTimeout(getState().fieldsInitialization.timeoutId);
            setState($cf6a6312e4141eb7$var$stateForResetAllFields);
        },
    setError: $2NMWZ.setError,
    resetError: $2NMWZ.resetError,
    setNumberOfSupportedFields: (numberOfAllSupportedFields)=>({ setState: setState })=>{
            setState({
                numberOfSupportedFields: numberOfAllSupportedFields
            });
        },
    /**
	 * This is used to block onInit for specific case like Issue View background refresh loading.
	 */ setExperienceDataIsLoading: (experienceDataIsLoading)=>({ setState: setState })=>{
            setState({
                experienceDataIsLoading: experienceDataIsLoading
            });
        },
    setAppErrors: $3whHg.setAppErrors,
    resetAppErrors: $3whHg.resetAppErrors,
    addAppsErrors: $3whHg.addAppsErrors,
    initializeNoScreenTab: $cTj8m.initializeNoScreenTab,
    initializeScreenTabs: $i4uue.initializeScreenTabs,
    updateScreenTabs: $7JtDe.updateScreenTabs,
    updateActiveScreenTab: $4MJXd.updateActiveScreenTab,
    detectAppliedChangesConflicts: $hyCnL.detectAppliedChangesConflicts,
    collectScreenTabsAppliedChangesHistory: $boEP0.collectScreenTabsAppliedChangesHistory,
    collectFieldsAppliedChangesHistory: $boEP0.collectFieldsAppliedChangesHistory,
    setNotification: $3iUv8.setNotification,
    resetNotification: $3iUv8.resetNotification
};
const $cf6a6312e4141eb7$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: $cf6a6312e4141eb7$var$name,
    initialState: $cf6a6312e4141eb7$export$d4c72bab9d6cc13a,
    actions: $cf6a6312e4141eb7$export$e324594224ef24da
});
const $cf6a6312e4141eb7$export$37792a602e748c08 = (0, $3sQ5x.createHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9);
const $cf6a6312e4141eb7$var$stableEmptyFieldFromIframe = {};
const $cf6a6312e4141eb7$export$c76e674a29843e21 = (0, $3sQ5x.createHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9, {
    selector: (state)=>state.appliedChanges
});
const $cf6a6312e4141eb7$export$df4b0714e8177e0e = (0, $3sQ5x.createHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9, {
    selector: (state, fieldId)=>state.appliedChanges?.[fieldId] || $cf6a6312e4141eb7$var$stableEmptyFieldFromIframe
});
const $cf6a6312e4141eb7$export$cb9a014ec14556d8 = (0, $3sQ5x.createActionsHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9);
const $cf6a6312e4141eb7$export$677b3e34bd14c681 = (0, $3sQ5x.createHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9, {
    selector: (state)=>state.screenTabs
});

});
parcelRegister("3whHg", function(module, exports) {

$parcel$export(module.exports, "setAppErrors", () => $87bccf3deeafaa75$export$7054e2f8e68cf0dd);
$parcel$export(module.exports, "addAppsErrors", () => $87bccf3deeafaa75$export$903d525e420c7d00);
$parcel$export(module.exports, "resetAppErrors", () => $87bccf3deeafaa75$export$24c821207687a907);
const $87bccf3deeafaa75$export$7054e2f8e68cf0dd = ({ errors: errors, appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: errors
            }
        });
    };
const $87bccf3deeafaa75$export$903d525e420c7d00 = ({ errors: errors })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        const appsErrors = Object.entries(errors).reduce((acc, [appId, appErrors])=>{
            acc[appId] = [
                ...acc[appId] ?? [],
                ...appErrors
            ];
            return acc;
        }, {
            ...previousState
        });
        setState({
            appsErrors: appsErrors
        });
    };
const $87bccf3deeafaa75$export$24c821207687a907 = ({ appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: null
            }
        });
    };

});

parcelRegister("hyCnL", function(module, exports) {

$parcel$export(module.exports, "detectAppliedChangesConflicts", () => $4c0b86f075c0ff6b$export$90d94f20d157e756);

var $gKZoD = parcelRequire("gKZoD");

var $2jyqu = parcelRequire("2jyqu");


var $3whHg = parcelRequire("3whHg");

var $3iUv8 = parcelRequire("3iUv8");

var $lLAXK = parcelRequire("lLAXK");
const $4c0b86f075c0ff6b$var$HISTORY_LOG_TTL = 60000;
/**
 * Tidies up applied changes history by removing old entries by TTL.
 * It keeps the current changeId in history.
 */ const $4c0b86f075c0ff6b$var$tidyUpAppliedChangesHistory = (appliedChangesHistory, changeId)=>Object.fromEntries(Object.entries(appliedChangesHistory).filter(([existingChangeId, history])=>{
        return Date.now() - history.createdAt <= $4c0b86f075c0ff6b$var$HISTORY_LOG_TTL || existingChangeId === changeId;
    }));
const $4c0b86f075c0ff6b$export$90d94f20d157e756 = ({ appId: appId, changeId: changeId })=>({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        (0, $gKZoD.di)((0, $2jyqu.fireOperationalEvent));
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        const tidyAppliedChangesHistory = $4c0b86f075c0ff6b$var$tidyUpAppliedChangesHistory(appliedChangesHistory, changeId);
        setState({
            appliedChangesHistory: tidyAppliedChangesHistory
        });
        const appliedChangesHistoryChangeId = tidyAppliedChangesHistory[changeId];
        const newChanges = appliedChangesHistoryChangeId?.apps[appId];
        if (!appliedChangesHistoryChangeId || !newChanges || // No need to run conflicts checks for the first item in history
        Object.keys(appliedChangesHistoryChangeId.apps).length <= 1) return;
        const lifecycleHook = changeId === (0, $19ec31e354320eb2$export$415cc1afa6445f90) ? 'onInit' : 'onChange';
        const { appErrorsMap: appErrorsMap, conflicts: conflicts } = (0, $lLAXK.collectConflicts)({
            appliedChangesHistory: appliedChangesHistoryChangeId.apps,
            newChanges: newChanges,
            appIdOfNewChanges: appId,
            lifecycleHook: lifecycleHook
        });
        if (conflicts.length) {
            (0, $2jyqu.fireOperationalEvent)(createAnalyticsEvent, {
                action: 'conflicted',
                actionSubject: 'jiraUiModifications.appliedChangesHistory',
                attributes: {
                    conflictsCount: conflicts.length,
                    conflicts: conflicts,
                    conflictedApps: Object.keys(appErrorsMap),
                    viewType: viewType
                }
            });
            dispatch((0, $3whHg.addAppsErrors)({
                errors: appErrorsMap
            }));
            dispatch((0, $3iUv8.setNotification)({
                type: 'MULTIPLE_APPS_CONFLICTS'
            }));
        }
    };

});
parcelRegister("2jyqu", function(module, exports) {

$parcel$export(module.exports, "fireOperationalEvent", () => $9253211b05747618$export$a1fb57756f0de62b);

var $gB4mS = parcelRequire("gB4mS");


const $9253211b05747618$export$a1fb57756f0de62b = (createAnalyticsEvent, eventPayload)=>{
    (0, $gB4mS.default)((0, $aded369bac156944$export$8280e5c6104c5b40))({
        ...eventPayload,
        analyticsType: (0, $6e65040b988c460f$export$12346a674644c156)
    })(createAnalyticsEvent);
};

});
const $6e65040b988c460f$export$f636b5b56f1d624a = 'Screen';
const $6e65040b988c460f$export$9d2de6eebf7462b5 = 'Drawer';
const $6e65040b988c460f$export$1171103ea9083ffa = 'Modal';
const $6e65040b988c460f$export$cae2783c9279926 = 'InlineDialog';
const $6e65040b988c460f$export$d1123261ca8831d2 = 'Dropdown';
const $6e65040b988c460f$export$a1562d08625f5d7e = 'UI';
const $6e65040b988c460f$export$947dac6c72b26f81 = 'TRACK';
const $6e65040b988c460f$export$f1d537d508d2945a = 'SCREEN';
const $6e65040b988c460f$export$12346a674644c156 = 'OPERATIONAL';
const $6e65040b988c460f$export$2ceccf177fae277c = 'analyticsBridge';

const $aded369bac156944$export$8280e5c6104c5b40 = 'ui-modifications';


const $19ec31e354320eb2$export$415cc1afa6445f90 = 'onInitChangeId';
const $19ec31e354320eb2$export$811b7f067a43b422 = 'jira:uiModifications';

parcelRegister("3iUv8", function(module, exports) {

$parcel$export(module.exports, "setNotification", () => $547ed651019edc98$export$b9c5e783593ff01d);
$parcel$export(module.exports, "resetNotification", () => $547ed651019edc98$export$caafa3945f199bc7);
const $547ed651019edc98$export$b9c5e783593ff01d = (notificationProperties)=>({ setState: setState })=>{
        setState({
            notification: {
                type: notificationProperties.type
            }
        });
    };
const $547ed651019edc98$export$caafa3945f199bc7 = ()=>({ setState: setState })=>{
        setState({
            notification: null
        });
    };

});

parcelRegister("lLAXK", function(module, exports) {

$parcel$export(module.exports, "collectConflicts", () => $5d47c6c300e4a9ca$export$a06103ec99e4e394);

var $fr1K2 = parcelRequire("fr1K2");


var $bCvSM = parcelRequire("bCvSM");

const $5d47c6c300e4a9ca$var$MESSAGE_SUFFIX = 'Modifications have been applied, but it may lead to inconsistency for the user.';
const $5d47c6c300e4a9ca$var$mapToAppErrors = ({ conflicts: conflicts, lifecycleHook: lifecycleHook })=>{
    const appErrors = conflicts.map((change)=>{
        if (change.type === (0, $78805f0b93715186$export$f674b7a3bbd94b5)) return {
            type: (0, $ca611ff348f89182$export$2a3fdceaae2188d5),
            cause: (0, $ca611ff348f89182$export$877da1000325f8b5),
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified screen tabs in the '${lifecycleHook}' at the same trigger. ${$5d47c6c300e4a9ca$var$MESSAGE_SUFFIX}`
        };
        const { fieldId: fieldId, fieldType: fieldType, property: property } = change;
        const method = (0, $bCvSM.mapFieldPropertyToApiMethod)(property);
        return {
            type: (0, $ca611ff348f89182$export$2a3fdceaae2188d5),
            cause: (0, $ca611ff348f89182$export$e4ac32edd5da2ee7),
            fieldId: fieldId,
            fieldType: fieldType,
            method: method,
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified the same field: '${fieldId}' by its method: '${method}' in the '${lifecycleHook}' at the same trigger. ${$5d47c6c300e4a9ca$var$MESSAGE_SUFFIX}`
        };
    });
    return appErrors;
};
const $5d47c6c300e4a9ca$export$a06103ec99e4e394 = ({ appliedChangesHistory: appliedChangesHistory, newChanges: newChanges, appIdOfNewChanges: appIdOfNewChanges, lifecycleHook: lifecycleHook })=>{
    return Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(appliedChangesHistory, appIdOfNewChanges)).reduce((acc, [appId, previousChanges])=>{
        const previousChangesKeys = Object.keys(previousChanges);
        // Compares previous changes with new changes keys
        const conflicts = Object.entries(newChanges).filter(([changeKey, _])=>previousChangesKeys.includes(changeKey)).map(([_, change])=>({
                ...change,
                lifecycleHook: lifecycleHook,
                appIds: [
                    appId,
                    appIdOfNewChanges
                ]
            }));
        acc.conflicts.push(...conflicts);
        // Maps conflicts to app errors
        const appErrors = $5d47c6c300e4a9ca$var$mapToAppErrors({
            conflicts: conflicts,
            lifecycleHook: lifecycleHook
        });
        if (appErrors.length > 0) {
            acc.appErrorsMap[appId] = appErrors;
            // App errors for `appIdOfNewChanges` may already exists from the previous iteration.
            // We need to merge them to avoid overwriting and keep all errors.
            acc.appErrorsMap[appIdOfNewChanges] = [
                ...acc.appErrorsMap[appIdOfNewChanges] ?? [],
                ...appErrors
            ];
        }
        return acc;
    }, {
        appErrorsMap: {},
        conflicts: []
    });
};

});
parcelRegister("fr1K2", function(module, exports) {

var $1nIHN = parcelRequire("1nIHN");

var $7MmCC = parcelRequire("7MmCC");

var $ftdKz = parcelRequire("ftdKz");

var $etAYC = parcelRequire("etAYC");

var $4NkAS = parcelRequire("4NkAS");

var $b2dLE = parcelRequire("b2dLE");

var $9SRAA = parcelRequire("9SRAA");

var $7GWAt = parcelRequire("7GWAt");
/** Used to compose bitmasks for cloning. */ var $b3caba7e25e0a917$var$CLONE_DEEP_FLAG = 1, $b3caba7e25e0a917$var$CLONE_FLAT_FLAG = 2, $b3caba7e25e0a917$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $b3caba7e25e0a917$var$omit = $9SRAA(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $1nIHN(paths, function(path) {
        path = $etAYC(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $4NkAS(object, $7GWAt(object), result);
    if (isDeep) result = $7MmCC(result, $b3caba7e25e0a917$var$CLONE_DEEP_FLAG | $b3caba7e25e0a917$var$CLONE_FLAT_FLAG | $b3caba7e25e0a917$var$CLONE_SYMBOLS_FLAG, $b2dLE);
    var length = paths.length;
    while(length--)$ftdKz(result, paths[length]);
    return result;
});
module.exports = $b3caba7e25e0a917$var$omit;

});
parcelRegister("ftdKz", function(module, exports) {

var $etAYC = parcelRequire("etAYC");

var $hYfgW = parcelRequire("hYfgW");

var $8lSJl = parcelRequire("8lSJl");

var $gzebZ = parcelRequire("gzebZ");
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $b4343aeaece186b7$var$baseUnset(object, path) {
    path = $etAYC(path, object);
    object = $8lSJl(object, path);
    return object == null || delete object[$gzebZ($hYfgW(path))];
}
module.exports = $b4343aeaece186b7$var$baseUnset;

});
parcelRegister("8lSJl", function(module, exports) {

var $fTwLR = parcelRequire("fTwLR");

var $dM3Z8 = parcelRequire("dM3Z8");
/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $614abd39878e1d90$var$parent(object, path) {
    return path.length < 2 ? object : $fTwLR(object, $dM3Z8(path, 0, -1));
}
module.exports = $614abd39878e1d90$var$parent;

});


parcelRegister("b2dLE", function(module, exports) {

var $1QOns = parcelRequire("1QOns");
/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $808a8f8fca7f9ff7$var$customOmitClone(value) {
    return $1QOns(value) ? undefined : value;
}
module.exports = $808a8f8fca7f9ff7$var$customOmitClone;

});

parcelRegister("9SRAA", function(module, exports) {

var $183uB = parcelRequire("183uB");

var $e0aIo = parcelRequire("e0aIo");

var $8pgNR = parcelRequire("8pgNR");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $7322b9dc1e5079b9$var$flatRest(func) {
    return $8pgNR($e0aIo(func, undefined, $183uB), func + '');
}
module.exports = $7322b9dc1e5079b9$var$flatRest;

});


const $ca611ff348f89182$export$fd26696d109785a0 = 'SCREENTABS_VALIDATION_FAILED';
const $ca611ff348f89182$export$d1996cb46a690190 = 'FIELD_VALIDATION_FAILED';
const $ca611ff348f89182$export$8042247b663edbcc = 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD';
const $ca611ff348f89182$export$2a3fdceaae2188d5 = 'MULTIPLE_APPS_CONFLICT';
const $ca611ff348f89182$export$e4ac32edd5da2ee7 = 'FIELD';
const $ca611ff348f89182$export$877da1000325f8b5 = 'SCREENTABS';

parcelRegister("bCvSM", function(module, exports) {

$parcel$export(module.exports, "mapFieldPropertyToApiMethod", () => $b1dea33557091402$export$e1cc7da28a1c4bb7);
const $b1dea33557091402$var$SET_NAME_METHOD = 'setName';
const $b1dea33557091402$var$SET_DESCRIPTION_METHOD = 'setDescription';
const $b1dea33557091402$var$SET_VISIBLE_METHOD = 'setVisible';
const $b1dea33557091402$var$SET_READ_ONLY_METHOD = 'setReadOnly';
const $b1dea33557091402$var$SET_VALUE_METHOD = 'setValue';
const $b1dea33557091402$var$SET_REQUIRED_METHOD = 'setRequired';
const $b1dea33557091402$var$SET_OPTIONS_VISIBILITY_METHOD = 'setOptionsVisibility';
const $b1dea33557091402$export$8325709d137b2606 = {
    fieldName: $b1dea33557091402$var$SET_NAME_METHOD,
    description: $b1dea33557091402$var$SET_DESCRIPTION_METHOD,
    isVisible: $b1dea33557091402$var$SET_VISIBLE_METHOD,
    isReadOnly: $b1dea33557091402$var$SET_READ_ONLY_METHOD,
    value: $b1dea33557091402$var$SET_VALUE_METHOD,
    isRequired: $b1dea33557091402$var$SET_REQUIRED_METHOD,
    optionsVisibility: $b1dea33557091402$var$SET_OPTIONS_VISIBILITY_METHOD
};
const $b1dea33557091402$export$e1cc7da28a1c4bb7 = (fieldProperty)=>{
    const method = $b1dea33557091402$export$8325709d137b2606[fieldProperty];
    if (!method) throw new Error(`No method found for field property: ${fieldProperty}`);
    return method;
};

});

const $78805f0b93715186$export$f674b7a3bbd94b5 = 'SCREEN_TABS';
const $78805f0b93715186$export$4a9f236a0db33834 = 'FIELD';



parcelRegister("boEP0", function(module, exports) {

$parcel$export(module.exports, "collectScreenTabsAppliedChangesHistory", () => $f5288ff27f25fb7e$export$1d2b7abeeea36239);
$parcel$export(module.exports, "collectFieldsAppliedChangesHistory", () => $f5288ff27f25fb7e$export$7d0f534e5b16dcc9);


var $3vp6H = parcelRequire("3vp6H");
const $f5288ff27f25fb7e$var$prepareAppliedChangesHistoryForSingleChange = ({ currentAppliedChangesHistory: currentAppliedChangesHistory, appId: appId, changeId: changeId, newSingleAppChange: newSingleAppChange })=>{
    const appliedChangesHistoryChangeId = currentAppliedChangesHistory[changeId] ?? {};
    const appliedChangesHistoryChangeIdApp = appliedChangesHistoryChangeId.apps?.[appId] ?? {};
    return {
        ...currentAppliedChangesHistory,
        [changeId]: {
            apps: {
                ...appliedChangesHistoryChangeId.apps,
                [appId]: {
                    ...appliedChangesHistoryChangeIdApp,
                    ...newSingleAppChange
                }
            },
            createdAt: appliedChangesHistoryChangeId.createdAt ?? Date.now()
        }
    };
};
const $f5288ff27f25fb7e$export$1d2b7abeeea36239 = ({ appId: appId, changeId: changeId, screenTabs: screenTabs })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        if (!screenTabs.length) return;
        const newAppliedChangesHistory = $f5288ff27f25fb7e$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: {
                tabs: {
                    type: (0, $78805f0b93715186$export$f674b7a3bbd94b5)
                }
            }
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };
const $f5288ff27f25fb7e$export$7d0f534e5b16dcc9 = ({ appId: appId, changeId: changeId, fieldsChanges: fieldsChanges })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory, internalFormMetadata: internalFormMetadata } = getState();
        const singleAppChange = (0, $3vp6H.normalizeFieldsAppliedChangesForHistory)({
            fieldsChanges: fieldsChanges,
            internalFormMetadata: internalFormMetadata
        });
        const newAppliedChangesHistory = $f5288ff27f25fb7e$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: singleAppChange
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };

});
parcelRegister("3vp6H", function(module, exports) {

$parcel$export(module.exports, "normalizeFieldsAppliedChangesForHistory", () => $23bcfa1804fc8fad$export$8a23b3e9a1749620);

const $23bcfa1804fc8fad$var$normalizeFieldForHistory = (fieldId, fieldChanges, fieldMetadata)=>{
    // Can't type Object.keys in a better way
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(fieldChanges).reduce((acc, property)=>{
        const normalizedKey = `${fieldId}|${property}`;
        acc[normalizedKey] = {
            fieldId: fieldId,
            fieldType: fieldMetadata.fieldType,
            property: property,
            type: (0, $78805f0b93715186$export$4a9f236a0db33834)
        };
        return acc;
    }, {});
};
const $23bcfa1804fc8fad$export$8a23b3e9a1749620 = ({ fieldsChanges: fieldsChanges, internalFormMetadata: internalFormMetadata })=>{
    return Object.entries(fieldsChanges).reduce((acc, [fieldId, fieldChanges])=>{
        const fieldMetadata = internalFormMetadata[fieldId];
        if (!fieldMetadata) return acc;
        const normalizedFieldHistory = $23bcfa1804fc8fad$var$normalizeFieldForHistory(fieldId, fieldChanges, fieldMetadata);
        Object.assign(acc, normalizedFieldHistory);
        return acc;
    }, {});
};

});


parcelRegister("2NMWZ", function(module, exports) {

$parcel$export(module.exports, "setError", () => $13e2b126ca97f7fe$export$b8d0bb2aa0adefe5);
$parcel$export(module.exports, "resetError", () => $13e2b126ca97f7fe$export$7e5930c6217b1d4e);
const $13e2b126ca97f7fe$export$b8d0bb2aa0adefe5 = (errorProperties)=>({ setState: setState })=>{
        setState({
            error: {
                errorCode: errorProperties.errorCode,
                fieldName: errorProperties.fieldName
            }
        });
    };
const $13e2b126ca97f7fe$export$7e5930c6217b1d4e = ()=>({ setState: setState })=>{
        setState({
            error: null
        });
    };

});

parcelRegister("d30F5", function(module, exports) {

$parcel$export(module.exports, "startFieldsInitialisationTimeout", () => $e08f4de833312075$export$2c0f020b89dfa30b);
$parcel$export(module.exports, "successFieldsInitalisation", () => $e08f4de833312075$export$cf768a695e83eefa);

var $gKZoD = parcelRequire("gKZoD");

var $2jyqu = parcelRequire("2jyqu");

var $1FDIy = parcelRequire("1FDIy");

var $2NMWZ = parcelRequire("2NMWZ");
const $e08f4de833312075$var$getTimeout = ()=>50000;
const $e08f4de833312075$var$getFieldsInitializationTime = (startTime)=>startTime !== null ? performance.now() - startTime : null;
const $e08f4de833312075$var$isFieldInitialisationComplete = (status)=>status === 'success' || status === 'timedOut';
const $e08f4de833312075$export$2c0f020b89dfa30b = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { fieldsInitialization: fieldsInitialization } = getState();
        if (fieldsInitialization.timeoutId === undefined && fieldsInitialization.status === 'notStarted') {
            const timeoutId = setTimeout(()=>dispatch($e08f4de833312075$export$8ce83a9201590a5e({
                    createAnalyticsEvent: createAnalyticsEvent
                })), $e08f4de833312075$var$getTimeout());
            setState({
                fieldsInitialization: {
                    startTime: performance.now(),
                    timeoutId: timeoutId,
                    status: 'inProgress'
                }
            });
        }
    };
const $e08f4de833312075$export$8ce83a9201590a5e = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState, dispatch: dispatch }, { viewType: viewType })=>{
        (0, $gKZoD.di)((0, $2jyqu.fireOperationalEvent));
        const { formData: formData, experienceDataIsLoading: experienceDataIsLoading, numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { startTime: startTime, status: status } = fieldsInitialization;
        if ($e08f4de833312075$var$isFieldInitialisationComplete(status) || (0, $1FDIy.selectReadyPublicDataForOnInit)(getState(), {
            viewType: viewType
        }) !== null) return;
        dispatch((0, $2NMWZ.setError)({
            errorCode: 'ON_INIT_FIELDS_INITIALIZATION_TIMEOUT'
        }));
        (0, $2jyqu.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'timedOut',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                configuredTimeout: $e08f4de833312075$var$getTimeout(),
                fieldsInitializationTime: $e08f4de833312075$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: Object.keys(formData ?? {}).length,
                experienceDataIsLoading: experienceDataIsLoading,
                supportedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'timedOut'
            }
        });
    };
const $e08f4de833312075$export$cf768a695e83eefa = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        (0, $gKZoD.di)((0, $2jyqu.fireOperationalEvent));
        const { status: status } = getState().fieldsInitialization;
        if ($e08f4de833312075$var$isFieldInitialisationComplete(status)) return;
        const { numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { timeoutId: timeoutId, startTime: startTime } = fieldsInitialization;
        clearTimeout(timeoutId);
        (0, $2jyqu.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                fieldsInitializationTime: $e08f4de833312075$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'success'
            }
        });
    };

});
parcelRegister("1FDIy", function(module, exports) {

$parcel$export(module.exports, "selectReadyPublicDataForOnInit", () => $9ea7c26aba3c4975$export$4cadeedb8c3f31f7);

var $6dDSs = parcelRequire("6dDSs");
const $9ea7c26aba3c4975$export$4cadeedb8c3f31f7 = (0, $6dDSs.createSelector)((state)=>state.formData, (state)=>state.numberOfSupportedFields, (state)=>state.screenTabs, (state)=>state.experienceDataIsLoading, (formData, numberOfSupportedFields, screenTabsData, experienceDataIsLoading)=>{
    if (formData !== null && screenTabsData !== null && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return {
        formData: formData,
        screenTabsData: screenTabsData
    };
    return null;
});

});


parcelRegister("8e24q", function(module, exports) {

$parcel$export(module.exports, "initializeField", () => $c1b779e01c06a231$export$6b51e123e61a9615);
$parcel$export(module.exports, "initializeFields", () => $c1b779e01c06a231$export$4a6b4707110b0552);

var $iLSUx = parcelRequire("iLSUx");
const $c1b779e01c06a231$export$6b51e123e61a9615 = ({ field: field, metadata: metadata })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData = {} } = getState();
        const fieldMetadata = {
            allowedValues: field.allowedValues,
            isReadOnlyBySystem: field.isReadOnly,
            isRequiredBySystem: field.isRequired,
            fieldRenderer: metadata?.fieldRenderer,
            fieldType: field.fieldType
        };
        const publicValue = (0, $iLSUx.mapFieldValueFromInternalToPublic)({
            fieldMetadata: fieldMetadata,
            internalFieldValue: field.value,
            fieldType: field.fieldType,
            viewType: viewType
        });
        setState({
            formData: {
                ...formData,
                [field.fieldId]: {
                    fieldId: field.fieldId,
                    fieldName: field.fieldName,
                    description: field.description,
                    isVisible: field.isVisible,
                    fieldType: field.fieldType,
                    isReadOnly: field.isReadOnly,
                    isRequired: field.isRequired,
                    value: publicValue,
                    optionsVisibility: undefined
                }
            },
            internalFormMetadata: {
                ...internalFormMetadata,
                [field.fieldId]: fieldMetadata
            }
        });
    };
const $c1b779e01c06a231$export$4a6b4707110b0552 = (fields)=>({ setState: setState }, { viewType: viewType })=>{
        const { formData: formData, internalFormMetadata: internalFormMetadata } = fields.reduce((acc, { field: field, metadata: metadata })=>{
            const fieldMetadata = {
                allowedValues: field.allowedValues,
                isReadOnlyBySystem: field.isReadOnly,
                isRequiredBySystem: field.isRequired,
                fieldRenderer: metadata?.fieldRenderer,
                fieldType: field.fieldType
            };
            const publicValue = (0, $iLSUx.mapFieldValueFromInternalToPublic)({
                fieldMetadata: fieldMetadata,
                internalFieldValue: field.value,
                fieldType: field.fieldType,
                viewType: viewType
            });
            acc.formData[field.fieldId] = {
                fieldId: field.fieldId,
                fieldName: field.fieldName,
                description: field.description,
                isVisible: field.isVisible,
                fieldType: field.fieldType,
                isReadOnly: field.isReadOnly,
                isRequired: field.isRequired,
                value: publicValue,
                optionsVisibility: undefined
            };
            acc.internalFormMetadata[field.fieldId] = fieldMetadata;
            return acc;
        }, {
            internalFormMetadata: {},
            formData: {}
        });
        setState({
            formData: formData,
            internalFormMetadata: internalFormMetadata,
            numberOfSupportedFields: fields.length
        });
    };

});
parcelRegister("iLSUx", function(module, exports) {

$parcel$export(module.exports, "mapFieldValueFromInternalToPublic", () => $4854c3676fce92c1$export$50806045b617d116);

var $gKZoD = parcelRequire("gKZoD");

var $cmmj3 = parcelRequire("cmmj3");

var $gL80q = parcelRequire("gL80q");
const $4854c3676fce92c1$export$50806045b617d116 = ({ fieldMetadata: fieldMetadata, internalFieldValue: internalFieldValue, fieldType: fieldType, viewType: viewType })=>{
    (0, $gKZoD.di)((0, $cmmj3.fireErrorAnalytics), (0, $gL80q.getSupportedFieldConfiguration));
    if (fieldMetadata === undefined) throw new Error('Attempt to set value for the uninitialized field');
    let value = internalFieldValue;
    try {
        const valueTransformer = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType)?.internalToPublicTransformers.value;
        if (valueTransformer) /**
			 * We trust that the internal field data is in the correct shape.
			 * Data that is in the incorrect shape will result in error events
			 * being logged for further investigation. In this error case we will
			 * pass `null` as the value to unblock onInit for the apps
			 *
			 * The `fieldRenderer` passed to the `valueTransformer` is used only for
			 * rich text fields and will be `undefined` for most of the executions
			 */ value = valueTransformer(internalFieldValue, fieldMetadata?.fieldRenderer);
    } catch (error) {
        value = null;
        (0, $cmmj3.fireErrorAnalytics)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return value;
};

});
parcelRegister("cmmj3", function(module, exports) {

$parcel$export(module.exports, "fireErrorAnalytics", () => $1359a69054531aa4$export$a27c21aa3ed8f0f1);

var $1nF7O = parcelRequire("1nF7O");

var $z11xo = parcelRequire("z11xo");
const $1359a69054531aa4$export$1bee4e6be783dd26 = (message)=>message.replaceAll(/\w+@[\w.]+/gi, '***@***');
const $1359a69054531aa4$export$a27c21aa3ed8f0f1 = ({ error: error, id: id, viewType: viewType, attributes: attributes = {}, event: event })=>{
    const errorType = (0, $z11xo.getErrorType)(error);
    const packageName = `${viewType}jiraUiModifications`;
    (0, $1nF7O.fireErrorAnalytics)({
        event: event,
        meta: {
            id: id,
            packageName: packageName,
            teamName: 'unbox'
        },
        error: error,
        attributes: {
            errorType: errorType,
            errorMessage: typeof error.message === 'string' ? $1359a69054531aa4$export$1bee4e6be783dd26(error.message) : error.message,
            ...attributes
        }
    });
};

});
parcelRegister("z11xo", function(module, exports) {

$parcel$export(module.exports, "getErrorType", () => $df5192e881ed2750$export$e19f9f08a6d79fd2);

var $3HlI9 = parcelRequire("3HlI9");
const $df5192e881ed2750$var$commonErrors = {
    MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
    OPERATION_ABORTED: 'The operation was aborted. ',
    CANCELLED: 'cancelled',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    TIMEOUT: 'The request timed out.',
    AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
    GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504'
};
const $df5192e881ed2750$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
const $df5192e881ed2750$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
const $df5192e881ed2750$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
const $df5192e881ed2750$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
const $df5192e881ed2750$export$89a175d4190df42e = 'Invoke value functions failed:';
const $df5192e881ed2750$export$215c097832f3122d = 'AGG_UNDERLYING_SERVICE_TIMEOUT';
const $df5192e881ed2750$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
const $df5192e881ed2750$var$BAD_REQUEST = 400;
const $df5192e881ed2750$var$REQUEST_TIMEOUT = 408;
const $df5192e881ed2750$export$8a5d666d6e5b82fc = (error)=>{
    // React loosely lazy chunk load error type
    if (typeof error === 'object' && error.name === 'ChunkLoadError') return true;
    // Other chunk load error types
    // In theory it should be handled by a common isClientFetchError, but it ignores TypeError error types
    const KNOWN_NETWORK_ERRORS = [
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        'Importing a module script failed',
        'Cannot find module'
    ];
    const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
            // are sometimes wrapped to provide additional context, e.g.
            // "Something went wrong: ${error.message}"
            message.includes(networkErrorMessage));
    return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
};
const $df5192e881ed2750$export$e19f9f08a6d79fd2 = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    const isTimeoutError = (timedOutResource)=>Boolean(typeof error === 'object' && error.name === 'TimeoutError' && error.stack?.includes(timedOutResource));
    if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
    const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
    if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
    const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
    const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
    if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $df5192e881ed2750$export$7a1bd8c001e7e9c;
    const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
    if (serverErrorRegex.test(message)) {
        const match = message.match(serverErrorRegex);
        const statusCode = match ? match[1] : 'NO_STATUS_CODE';
        return `ERROR_SERVER_RESPONSE_${statusCode}`;
    }
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
    const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
    if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $df5192e881ed2750$export$23de3198bfe70090;
    // Add here errors related to a broken app configuration/manifest
    if (message.startsWith('Function definition is invalid.')) return 'APP_DEV_ERROR';
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ($df5192e881ed2750$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
    const aggUnderlyingServiceTimeoutRegex = new RegExp('The underlying service call timed out', 'i');
    if (aggUnderlyingServiceTimeoutRegex.test(message)) return $df5192e881ed2750$export$215c097832f3122d;
    const appValueFunction = new RegExp("The app's value function failed", 'i');
    const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
    const invokeValueFunctionFailed = new RegExp($df5192e881ed2750$export$89a175d4190df42e, 'i');
    /**
	 * In case when we get bad request(400) from the BE it should be treated as an app error as there
	 * are many ways to fail the value function
	 */ const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === $df5192e881ed2750$var$BAD_REQUEST;
    /**
	 * In case when we get request timeout(408) from the XIS invocation it should be treated as an app error.
	 * Error occurs when invocation exceeds 25s threshold e.g.too long time to execute request to external API
	 */ const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === $df5192e881ed2750$var$REQUEST_TIMEOUT;
    if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
    /*
	 * 	Whole message:
	 *	Fetching formatted value after edit failed: FetchError: Fetch call failed with status code: 429
	 */ const valueFunctionEditRateLimitedRegex = new RegExp('Fetch call failed with status code: 429', 'i');
    /*
	 * 	Whole message:
	 *	Invoke value functions failed: Error server response: 429
	 */ const valueFunctionInvokeRateLimitedRegex = new RegExp('Error server response: 429', 'i');
    if (valueFunctionEditRateLimitedRegex.test(message) || valueFunctionInvokeRateLimitedRegex.test(message)) return $df5192e881ed2750$export$7a1bd8c001e7e9c;
    // The full message states:
    // Extension "extension name" does not exist, the app may have changed or no longer be installed in this context
    const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
    if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
    // In case of React error message:
    // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
    const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
    if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
    if ($df5192e881ed2750$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
    if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
    if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
    if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
    const entry = Object.entries($df5192e881ed2750$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    if (entry) return entry[0];
    if ((0, $3HlI9.isClientFetchError)(error)) return $df5192e881ed2750$export$f52aa41ccd776f01;
    if (error != null && 'statusCode' in error && error.statusCode === 429) return 'RATE_LIMITING';
    return 'OTHER';
};

});
parcelRegister("3HlI9", function(module, exports) {

$parcel$export(module.exports, "isClientFetchError", () => $cbf82ad04131c769$export$2e7adc44463c3f4f);
// Copied from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
// Exclude client connectivity and HTTP client network errors as a SLO failure
// e.g. during quick SPA transition when a network call haven't finished yet,
// or when the user's internet connection drops out.
const $cbf82ad04131c769$export$c748438cec453c9f = [
    '... is not valid JSON',
    'server with the specified hostname could not be found',
    'cannot parse response',
    'connection failure',
    'Failed to fetch',
    'in JSON at position 0',
    'JSON.parse: unexpected character at line 1 column 1 of the JSON data',
    'JSON.parse: unexpected end of data at line 1 column 1 of the JSON data',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'Syntax or http error',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted',
    'Unable to fetch manifest',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'dynamically imported module',
    'Importing a module script failed'
];
const $cbf82ad04131c769$export$3876cb851aa46193 = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $cbf82ad04131c769$var$isClientFetchErrorMessage = (message)=>Boolean(message) && $cbf82ad04131c769$export$c748438cec453c9f.some((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
const $cbf82ad04131c769$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($cbf82ad04131c769$export$3876cb851aa46193.includes(error.name) || $cbf82ad04131c769$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && ($cbf82ad04131c769$export$3876cb851aa46193.includes(error.cause.name) || $cbf82ad04131c769$var$isClientFetchErrorMessage(error.cause.message)));

});



parcelRegister("gL80q", function(module, exports) {

$parcel$export(module.exports, "getSupportedFieldConfiguration", () => $968cd36658e5c86e$export$8fc8d6775f1842b8);
$parcel$export(module.exports, "isFieldTypeSupported", () => $968cd36658e5c86e$export$b47920a5dd99844f);
$parcel$export(module.exports, "getConsentMessage", () => $968cd36658e5c86e$export$20eabd2b3ada6bf3);
$parcel$export(module.exports, "isExecutionContextSupported", () => $968cd36658e5c86e$export$b768d6a95f7a930);
$parcel$export(module.exports, "getAnalytics", () => $968cd36658e5c86e$export$b0297573c90085aa);
$parcel$export(module.exports, "isTriggerPointSupported", () => $968cd36658e5c86e$export$ef45e4471aa21b27);

var $cmmj3 = parcelRequire("cmmj3");

var $3OTqu = parcelRequire("3OTqu");
const $968cd36658e5c86e$var$isKeyOf = (key, object)=>object[key] !== undefined;
const $968cd36658e5c86e$var$getConfigurationByViewType = ({ viewType: viewType })=>{
    const viewConfiguration = (0, $3OTqu.getViewConfiguration)(viewType);
    if (!viewConfiguration) throw new Error(`Unsupported view type ${viewType} in getConfigurationByViewType.`);
    return viewConfiguration;
};
function $968cd36658e5c86e$export$8fc8d6775f1842b8(viewType, fieldType) {
    const fieldsConfiguration = $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldsConfiguration();
    if (!$968cd36658e5c86e$var$isKeyOf(fieldType, fieldsConfiguration)) {
        (0, $cmmj3.fireErrorAnalytics)({
            error: new Error('Unsupported field type.'),
            id: 'getSupportedFieldConfiguration',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
        return undefined;
    }
    return fieldsConfiguration[fieldType];
}
const $968cd36658e5c86e$export$e4330d77fd93d1de = (viewType)=>$968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldTypes();
function $968cd36658e5c86e$export$b47920a5dd99844f(viewType, fieldType) {
    return fieldType !== undefined && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $968cd36658e5c86e$export$e4330d77fd93d1de(viewType).includes(fieldType);
}
function $968cd36658e5c86e$export$20eabd2b3ada6bf3(viewType) {
    return $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getConsentMessage();
}
function $968cd36658e5c86e$export$b768d6a95f7a930(context) {
    return $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: context.viewType
    }).isExecutionContextSupported({
        context: context
    });
}
function $968cd36658e5c86e$export$b0297573c90085aa(viewType) {
    return $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getAnalytics();
}
function $968cd36658e5c86e$export$c0728caa743a409e(viewType) {
    return $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedTriggerPointsConfiguration();
}
const $968cd36658e5c86e$export$ef45e4471aa21b27 = (viewType, triggerPoint)=>triggerPoint !== undefined && $968cd36658e5c86e$export$c0728caa743a409e(viewType).has(triggerPoint);

});
parcelRegister("3OTqu", function(module, exports) {

$parcel$export(module.exports, "getViewConfiguration", () => $b8beb3418915829f$export$176b6e68da08ffa2);
$parcel$export(module.exports, "useLoadViewConfiguration", () => $b8beb3418915829f$export$f0022a21ccd1f6be);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");
const $b8beb3418915829f$var$VIEW_CONFIGURATIONS = new Map();
const $b8beb3418915829f$export$cda1ad403b37fe70 = (viewType, configuration)=>{
    if (!$b8beb3418915829f$var$VIEW_CONFIGURATIONS.has(viewType)) $b8beb3418915829f$var$VIEW_CONFIGURATIONS.set(viewType, configuration);
};
const $b8beb3418915829f$export$176b6e68da08ffa2 = (viewType)=>$b8beb3418915829f$var$VIEW_CONFIGURATIONS.get(viewType);
const $b8beb3418915829f$export$e8091eff40c4f16e = ()=>{
    $b8beb3418915829f$var$VIEW_CONFIGURATIONS.clear();
};
const $b8beb3418915829f$export$f0022a21ccd1f6be = (viewType, configurationClass)=>{
    (0, $gKZoD.di)($b8beb3418915829f$export$cda1ad403b37fe70);
    /**
	 * Uses useState to load view configuration on component mount, before rendering.
	 */ (0, $5uXOq.useState)(()=>{
        $b8beb3418915829f$export$cda1ad403b37fe70(viewType, new configurationClass());
    });
};

});




parcelRegister("cTj8m", function(module, exports) {

$parcel$export(module.exports, "initializeNoScreenTab", () => $b87f070d69e40149$export$93459ad9bfd6c380);
const $b87f070d69e40149$export$93459ad9bfd6c380 = ()=>({ setState: setState })=>{
        setState({
            screenTabs: []
        });
    };

});

parcelRegister("i4uue", function(module, exports) {

$parcel$export(module.exports, "initializeScreenTabs", () => $559bbe3e01414de7$export$7f7be235f64f029b);
const $559bbe3e01414de7$export$7f7be235f64f029b = ({ tabs: tabs, selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: internalScreenTabs } = getState();
        const previouslySelected = internalScreenTabs?.findIndex((tab)=>tab.isActive);
        setState({
            screenTabs: tabs.map(({ id: id }, index)=>({
                    id: id,
                    isVisible: true,
                    isActive: index === selected || index === previouslySelected
                }))
        });
    };

});

parcelRegister("b8ZsE", function(module, exports) {

$parcel$export(module.exports, "processChange", () => $926b03f8c2e312a1$export$352dfcce04d66748);

var $3ZT8o = parcelRequire("3ZT8o");

var $gKZoD = parcelRequire("gKZoD");

var $gL80q = parcelRequire("gL80q");

var $l6AQO = parcelRequire("l6AQO");
const $926b03f8c2e312a1$export$352dfcce04d66748 = ({ fieldId: fieldId, fieldValue: fieldValue, eventType: eventType })=>({ setState: setState, getState: getState }, { viewType: viewType })=>{
        (0, $gKZoD.di)((0, (/*@__PURE__*/$parcel$interopDefault($3ZT8o))));
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        const fieldType = internalFormMetadata[fieldId]?.fieldType;
        if (!fieldType) return;
        const emitChangeOn = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType)?.emitChangeOn;
        if (emitChangeOn !== eventType) return;
        const nextFormData = (0, $l6AQO.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        /**
		 * setTimeout justification - we need to delay the state update to the next tick to avoid batched updates.
		 * Otherwise, UIM app may not be notified about every single change.
		 */ setTimeout(()=>{
            const changeId = (0, (/*@__PURE__*/$parcel$interopDefault($3ZT8o)))();
            setState({
                lastProcessedChange: {
                    fieldId: fieldId,
                    changeId: changeId
                },
                formData: nextFormData
            });
        }, 0);
    };

});
parcelRegister("3ZT8o", function(module, exports) {

var $jJVtR = parcelRequire("jJVtR");
/** Used to generate unique IDs. */ var $2e91d6202798e8a1$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $2e91d6202798e8a1$var$uniqueId(prefix) {
    var id = ++$2e91d6202798e8a1$var$idCounter;
    return $jJVtR(prefix) + id;
}
module.exports = $2e91d6202798e8a1$var$uniqueId;

});

parcelRegister("l6AQO", function(module, exports) {

$parcel$export(module.exports, "calculateNextFormValue", () => $2b658e9f553d1ad3$export$25441a03bb8f1cb0);

var $ajpes = parcelRequire("ajpes");

var $iLSUx = parcelRequire("iLSUx");
const $2b658e9f553d1ad3$export$25441a03bb8f1cb0 = ({ internalFormMetadata: internalFormMetadata, formData: formData, fieldId: fieldId, fieldValue: fieldValue, fieldType: fieldType, viewType: viewType })=>{
    if (formData === null) return null;
    let newPublicValue;
    try {
        newPublicValue = (0, $iLSUx.mapFieldValueFromInternalToPublic)({
            fieldMetadata: internalFormMetadata[fieldId],
            internalFieldValue: fieldValue,
            fieldType: fieldType,
            viewType: viewType
        });
    } catch (e) {
        return null;
    }
    const currentPublicValue = formData[fieldId]?.value;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(newPublicValue, currentPublicValue)) return null;
    return {
        ...formData,
        [fieldId]: {
            ...formData[fieldId],
            value: newPublicValue
        }
    };
};

});


parcelRegister("jDMtG", function(module, exports) {

$parcel$export(module.exports, "registerFields", () => $5e78d8ed1ee13321$export$d4eb181b231cf88d);
$parcel$export(module.exports, "unregisterFields", () => $5e78d8ed1ee13321$export$1ca69a85bb7273de);

var $fr1K2 = parcelRequire("fr1K2");

var $kGsr8 = parcelRequire("kGsr8");
const $5e78d8ed1ee13321$export$d4eb181b231cf88d = ({ changeId: changeId, fieldsToBeRegistered: fieldsToBeRegistered, appId: appId })=>({ setState: setState, getState: getState })=>{
        if (!Array.isArray(fieldsToBeRegistered)) return;
        const { registeredFields: registeredFields } = getState();
        const appFields = registeredFields[appId] ?? {};
        const appChangeIdFields = appFields[changeId] ?? [];
        const nextRegisteredFields = {
            ...registeredFields,
            [appId]: {
                ...appFields,
                [changeId]: (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))([
                    ...appChangeIdFields,
                    ...fieldsToBeRegistered
                ])
            }
        };
        setState({
            registeredFields: nextRegisteredFields
        });
    };
const $5e78d8ed1ee13321$export$1ca69a85bb7273de = ({ changeId: changeId, appId: appId })=>({ setState: setState, getState: getState })=>{
        const { registeredFields: registeredFields } = getState();
        const registeredAppFields = registeredFields[appId] ?? {};
        const nextRegisteredAppFields = (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(registeredAppFields, changeId);
        setState({
            registeredFields: {
                ...registeredFields,
                [appId]: nextRegisteredAppFields
            }
        });
    };

});

parcelRegister("l0b2q", function(module, exports) {

$parcel$export(module.exports, "setFieldValue", () => $da1080104d423ca2$export$6556d46d2662453c);

var $l6AQO = parcelRequire("l6AQO");
const $da1080104d423ca2$export$6556d46d2662453c = ({ fieldId: fieldId, fieldType: fieldType, fieldValue: fieldValue })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        /**
		 * We can set new field value only if the field was initialized.
		 * This checks the field metedata that indicates the successfull initialization.
		 */ if (!internalFormMetadata[fieldId]) return;
        const nextFormData = (0, $l6AQO.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        setState({
            formData: nextFormData
        });
    };

});

parcelRegister("4MJXd", function(module, exports) {

$parcel$export(module.exports, "updateActiveScreenTab", () => $104b1b4dd763f6ee$export$21363496760d39cd);
const $104b1b4dd763f6ee$export$21363496760d39cd = ({ selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: screenTabs } = getState();
        if (screenTabs) setState({
            screenTabs: screenTabs.map((tab, index)=>({
                    ...tab,
                    isActive: index === selected
                }))
        });
    };

});

parcelRegister("gHQFd", function(module, exports) {

$parcel$export(module.exports, "updateFields", () => $069ce0e12537855c$export$cceae62fd4d1ef0a);

var $gccSB = parcelRequire("gccSB");

var $gKZoD = parcelRequire("gKZoD");

var $2jyqu = parcelRequire("2jyqu");


var $ajglJ = parcelRequire("ajglJ");

var $dA2NP = parcelRequire("dA2NP");

var $fKje4 = parcelRequire("fKje4");

var $dwG9p = parcelRequire("dwG9p");

var $dRfi6 = parcelRequire("dRfi6");

var $3whHg = parcelRequire("3whHg");

var $boEP0 = parcelRequire("boEP0");

var $hzAKL = parcelRequire("hzAKL");
const $069ce0e12537855c$export$cceae62fd4d1ef0a = ({ changeId: changeId, fieldsChanges: fieldsChanges, lookupDataFromApi: lookupDataFromApi, tenantContext: tenantContext, executionContext: executionContext, environment: environment, appId: appId, intl: intl, createAnalyticsEvent: createAnalyticsEvent })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType })=>{
        (0, $gKZoD.di)((0, $boEP0.collectFieldsAppliedChangesHistory));
        const appliedChanges = getState().appliedChanges ?? {};
        const formData = getState().formData ?? {};
        const { internalFormMetadata: internalFormMetadata, registeredFields: registeredFields } = getState();
        const { changesToApply: changesToApply, incomingFormData: incomingFormData, errorsByField: errorsByField, newAppliedChangesPublic: newAppliedChangesPublic } = await Object.keys(fieldsChanges).reduce(async (acc, fieldId)=>{
            // Do not update fields that are not inside initialized data.
            // Validates if the field that comes from Iframe is supported
            // - because we add to formData only the supported ones.
            const fieldData = formData[fieldId];
            const internalMetadata = internalFormMetadata[fieldId];
            const fieldIsRegistered = (0, $dA2NP.fieldWasRegistered)(registeredFields, changeId, fieldId, appId);
            // Only registered field Ids can be updated.
            if (!fieldIsRegistered || !fieldData) {
                const { fieldType: fieldType } = fieldData ?? {};
                dispatch((0, $3whHg.addAppsErrors)({
                    errors: {
                        [appId]: [
                            {
                                fieldType: fieldType,
                                fieldId: fieldId,
                                type: 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD',
                                message: 'Application tried to apply changes to unregistered field'
                            }
                        ]
                    }
                }));
                (0, $2jyqu.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'unregisteredField',
                    actionSubject: 'jiraUiModifications.applyChanges',
                    attributes: {
                        message: 'Attempt to apply changes to a field that was not registered',
                        fieldId: fieldId,
                        viewType: viewType
                    }
                });
                return acc;
            }
            const lookupData = {
                [(0, $80e7f3d73b333b84$export$a1cacdcf198da901)]: internalMetadata.allowedValues,
                [(0, $80e7f3d73b333b84$export$3a106242c8f57ac2)]: lookupDataFromApi[0, $80e7f3d73b333b84$export$3a106242c8f57ac2]
            };
            // It updates properties in each field to avoid removing unchanged props for
            // selected field by another app or another onChange update.
            // Only supported properties are allowed.
            const supportedFieldChanges = await (0, $hzAKL.transformFieldChangesToInternalShape)({
                fieldType: fieldData.fieldType,
                fieldId: fieldId,
                fieldFromIframe: fieldsChanges?.[fieldId],
                lookupData: lookupData,
                viewType: viewType,
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                intl: intl
            });
            if (supportedFieldChanges.isValid === false) {
                (await acc).errorsByField[fieldId] = supportedFieldChanges.errors;
                return acc;
            }
            // It converts changes to 'public' format to update the formData
            const publicShapeChanges = (0, $dRfi6.transformFieldToIframe)(supportedFieldChanges.data, viewType, fieldData.fieldType, lookupData, fieldsChanges?.[fieldId], internalMetadata);
            const transformedFieldChanges = (0, $fKje4.mapFieldPropertyNamesToInternal)(supportedFieldChanges.data, viewType, fieldData.fieldType);
            const combinedChangesToApply = {
                ...appliedChanges[fieldId],
                ...transformedFieldChanges
            };
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(combinedChangesToApply)) {
                (await acc).newAppliedChangesPublic[fieldId] = publicShapeChanges;
                (await acc).changesToApply[fieldId] = combinedChangesToApply;
                (await acc).incomingFormData[fieldId] = {
                    ...formData[fieldId],
                    ...publicShapeChanges
                };
            }
            return acc;
        }, Promise.resolve({
            changesToApply: {
                ...appliedChanges
            },
            incomingFormData: {
                ...formData
            },
            newAppliedChangesPublic: {},
            errorsByField: {}
        }));
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(errorsByField)) throw new (0, $ajglJ.UiModificationsFieldsValidationError)('Transformation failed', {
            errors: (0, $dwG9p.prepareErrorsArray)(errorsByField)
        });
        setState({
            appliedChanges: changesToApply,
            formData: incomingFormData
        });
        dispatch((0, $boEP0.collectFieldsAppliedChangesHistory)({
            appId: appId,
            changeId: changeId,
            fieldsChanges: newAppliedChangesPublic
        }));
    };

});
const $80e7f3d73b333b84$export$a1cacdcf198da901 = 'LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY';
const $80e7f3d73b333b84$export$3a106242c8f57ac2 = 'LOOKUP_SOURCE_USERS_ASYNC_DATA';
const $80e7f3d73b333b84$export$f5d5f6bb902f1027 = '-1';
const $80e7f3d73b333b84$export$106087dcfd4fb129 = 100;

parcelRegister("ajglJ", function(module, exports) {

$parcel$export(module.exports, "UiModificationsFieldsValidationError", () => $907938b0f57574ed$export$9e8b5e552e255163);

var $2jqAp = parcelRequire("2jqAp");
class $907938b0f57574ed$export$9e8b5e552e255163 extends (0, $2jqAp.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'fields', cause);
    }
}

});
parcelRegister("2jqAp", function(module, exports) {

$parcel$export(module.exports, "UiModificationsValidationError", () => $b8ce6491bf34e535$export$6e8165c81a6a65df);
class $b8ce6491bf34e535$export$6e8165c81a6a65df extends Error {
    constructor(message, attributes, validationErrorType, cause){
        super(message, cause);
        this.attributes = attributes;
        this.validationErrorType = validationErrorType;
    }
}

});


parcelRegister("dA2NP", function(module, exports) {

$parcel$export(module.exports, "fieldWasRegistered", () => $aff4a3261c4c9b6e$export$fbe9157c12cb4e7b);
const $aff4a3261c4c9b6e$export$fbe9157c12cb4e7b = (registeredFields, changeId, fieldId, appId)=>!!registeredFields[appId]?.[changeId]?.includes(fieldId);

});

parcelRegister("fKje4", function(module, exports) {

$parcel$export(module.exports, "mapFieldPropertyNamesToInternal", () => $620a721e65ec1dbe$export$460820f27643954e);

var $gL80q = parcelRequire("gL80q");
const $620a721e65ec1dbe$export$460820f27643954e = (properties, viewType, fieldType)=>{
    const fieldConfiguration = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType);
    const propertyMapping = fieldConfiguration?.propertyMapping;
    if (!propertyMapping) return properties;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(properties).reduce((acc, propertyName)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const propertyMappingValue = propertyMapping[propertyName];
        acc[propertyMappingValue ?? propertyName] = properties[propertyName];
        return acc;
    }, {});
};

});

parcelRegister("dwG9p", function(module, exports) {

$parcel$export(module.exports, "prepareErrorsArray", () => $8d92968018d86237$export$e1fce51bc5be90b7);
const $8d92968018d86237$export$e1fce51bc5be90b7 = (errorsById)=>Object.values(errorsById).flat();

});

parcelRegister("dRfi6", function(module, exports) {

$parcel$export(module.exports, "transformFieldToIframe", () => $cc6b08557666e682$export$aa453854f74fab);

var $cmmj3 = parcelRequire("cmmj3");

var $gL80q = parcelRequire("gL80q");
const $cc6b08557666e682$export$aa453854f74fab = (fieldChanges, viewType, fieldType, lookupData, fieldFromIframe, fieldMetadata)=>{
    const fieldConfiguration = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldInternalToPublicTransformers = fieldConfiguration?.internalToPublicTransformers;
    const publicShapeField = {
        ...fieldChanges
    };
    if (publicShapeField.value !== undefined && fieldInternalToPublicTransformers?.value) try {
        publicShapeField.value = fieldInternalToPublicTransformers?.value(fieldChanges.value, fieldMetadata.fieldRenderer);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $cmmj3.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    if (fieldFromIframe.optionsVisibility !== undefined && fieldInternalToPublicTransformers?.optionsVisibility) try {
        const lookupSource = fieldConfiguration?.lookupSource;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - lookupData is not types on CI somehow
        const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
        publicShapeField.optionsVisibility = fieldInternalToPublicTransformers?.optionsVisibility(fieldFromIframe.optionsVisibility, lookupValues);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $cmmj3.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicOptionsVisibilityTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return publicShapeField;
};

});

parcelRegister("hzAKL", function(module, exports) {

$parcel$export(module.exports, "transformFieldChangesToInternalShape", () => $422557008e0dbc71$export$d14f85c01e334a1);

var $gccSB = parcelRequire("gccSB");

var $gKZoD = parcelRequire("gKZoD");

var $7NDId = parcelRequire("7NDId");

var $gL80q = parcelRequire("gL80q");


var $bCvSM = parcelRequire("bCvSM");

var $2J6IF = parcelRequire("2J6IF");

var $hwDyF = parcelRequire("hwDyF");
const $422557008e0dbc71$export$d14f85c01e334a1 = async ({ fieldType: fieldType, fieldId: fieldId, fieldFromIframe: fieldFromIframe, lookupData: lookupData, viewType: viewType, tenantContext: tenantContext, executionContext: executionContext, environment: environment, intl: intl })=>{
    (0, $gKZoD.di)((0, $gL80q.getSupportedFieldConfiguration));
    const fieldConfiguration = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldTransformers = fieldConfiguration?.publicToInternalTransformers;
    const fieldValidators = fieldConfiguration?.publicShapeValidators;
    if (!fieldFromIframe || !fieldTransformers || !fieldValidators) return {
        ...(0, $2J6IF.VALID_RESULT),
        data: {}
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const validatorsArray = Object.keys(fieldValidators);
    const lookupSource = fieldConfiguration?.lookupSource;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - lookupData is not types on CI somehow
    const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
    const fieldTransformationResults = await Promise.all(validatorsArray.map(async (propertyName)=>{
        if (!Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName)) return 0, $2J6IF.VALID_RESULT;
        const propertyValue = fieldFromIframe[propertyName];
        const transformer = fieldTransformers[propertyName];
        const fieldContext = {
            fieldId: fieldId
        };
        // We need to catch lookup values discrepancies and react accordingly
        // to how we react to validation errors - throw an error
        // if the set value wasn't found in the array of lookupValues
        try {
            const data = transformer ? await transformer(propertyValue, lookupValues, {
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                fieldContext: fieldContext,
                intl: intl
            }) : propertyValue;
            return {
                isValid: true,
                data: {
                    [propertyName]: data
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            // FieldValueLookupError will be thrown from the transformer
            // when the lookup value wasn't found
            if (err instanceof (0, $7NDId.FieldValueLookupError)) {
                // For single value fields its straightforward to just pass
                // the faulty propertyValue into error message,
                // but for multi value fields we should find out the faulty values from the array
                // thats why we should propagate the faulty values as a comma separated string
                // by using the error's message
                const faultyValue = err.message || propertyValue;
                return {
                    isValid: false,
                    error: {
                        fieldId: fieldId,
                        fieldType: fieldType,
                        type: (0, $ca611ff348f89182$export$d1996cb46a690190),
                        method: (0, $bCvSM.mapFieldPropertyToApiMethod)(propertyName),
                        message: `Invalid IDs provided: ${faultyValue}`
                    }
                };
            }
            throw err;
        }
    }));
    const invalidTransformationResults = (0, $hwDyF.filterInvalidResults)(fieldTransformationResults);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(invalidTransformationResults)) return {
        isValid: false,
        errors: invalidTransformationResults.map((result)=>result.error)
    };
    return (0, $hwDyF.mapValidResultsToFieldInternalShape)(fieldTransformationResults);
};

});
parcelRegister("7NDId", function(module, exports) {

$parcel$export(module.exports, "FieldValueLookupError", () => $64626586c22c486e$export$73c2f0689b6c4a5a);
class $64626586c22c486e$export$73c2f0689b6c4a5a extends Error {
}

});

parcelRegister("2J6IF", function(module, exports) {

$parcel$export(module.exports, "VALID_RESULT", () => $5fbccb776f84792e$export$ee79e3ab53b8db79);
const $5fbccb776f84792e$export$ee79e3ab53b8db79 = {
    isValid: true
};

});

parcelRegister("hwDyF", function(module, exports) {

$parcel$export(module.exports, "mapValidResultsToFieldInternalShape", () => $e8aa8431ce8b786b$export$a60dd8f1b025f23d);
$parcel$export(module.exports, "filterInvalidResults", () => $e8aa8431ce8b786b$export$ddd005554aecd409);
const $e8aa8431ce8b786b$export$a60dd8f1b025f23d = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === true && Object.prototype.hasOwnProperty.call(result, 'data')) acc.data = {
            ...acc.data,
            ...result.data
        };
        return acc;
    }, {
        isValid: true,
        data: {}
    });
const $e8aa8431ce8b786b$export$ddd005554aecd409 = (validationResults)=>validationResults.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);

});



parcelRegister("7JtDe", function(module, exports) {

$parcel$export(module.exports, "updateScreenTabs", () => $c6c7124cbfc0022b$export$131c67fd312b8a11);

var $gKZoD = parcelRequire("gKZoD");

var $iUvwD = parcelRequire("iUvwD");

var $50ech = parcelRequire("50ech");

var $boEP0 = parcelRequire("boEP0");

var $iiEdL = parcelRequire("iiEdL");
const $c6c7124cbfc0022b$export$131c67fd312b8a11 = ({ screenTabsChanges: screenTabsFromIframe, changeId: changeId, appId: appId })=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        (0, $gKZoD.di)((0, $boEP0.collectScreenTabsAppliedChangesHistory), (0, $iiEdL.getScreenTabsPublicToInternalValidationErrors));
        const { screenTabs: internalScreenTabs } = getState();
        // If screenTabsFromIframe is empty it means that the app does not provide srceenTabs changes.
        if (Array.isArray(screenTabsFromIframe) && !screenTabsFromIframe.length) return;
        if (internalScreenTabs && (0, $iiEdL.screenTabsPublicToInternalValidator)(internalScreenTabs, screenTabsFromIframe)) {
            const newScreenTabs = (0, $iiEdL.screenTabsPublicToInternalTransformer)(internalScreenTabs, screenTabsFromIframe);
            setState({
                screenTabs: newScreenTabs
            });
            dispatch((0, $boEP0.collectScreenTabsAppliedChangesHistory)({
                appId: appId,
                changeId: changeId,
                screenTabs: newScreenTabs
            }));
        } else throw new (0, $iUvwD.UiModificationsScreenTabsValidationError)('Transformation failed', {
            errors: (0, $iiEdL.getScreenTabsPublicToInternalValidationErrors)(internalScreenTabs, screenTabsFromIframe).map((0, $50ech.toScreenTabsValidationError))
        });
    };

});
parcelRegister("iUvwD", function(module, exports) {

$parcel$export(module.exports, "UiModificationsScreenTabsValidationError", () => $2febbf39fb2cebbc$export$faf1f1824ee0a136);

var $2jqAp = parcelRequire("2jqAp");
class $2febbf39fb2cebbc$export$faf1f1824ee0a136 extends (0, $2jqAp.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'screenTabs', cause);
    }
}

});

parcelRegister("50ech", function(module, exports) {

$parcel$export(module.exports, "toScreenTabsValidationError", () => $32af3bb8fe161d39$export$b2675440ade984fb);

const $32af3bb8fe161d39$export$b2675440ade984fb = (message)=>({
        message: message,
        type: (0, $ca611ff348f89182$export$fd26696d109785a0)
    });

});

parcelRegister("iiEdL", function(module, exports) {

$parcel$export(module.exports, "screenTabsPublicToInternalTransformer", () => $5d43d6affeb19d8a$export$9ca9b35e7b6a8bbc);
$parcel$export(module.exports, "screenTabsPublicToInternalValidator", () => $5d43d6affeb19d8a$export$e7a91e7e430e691a);
$parcel$export(module.exports, "getScreenTabsPublicToInternalValidationErrors", () => $5d43d6affeb19d8a$export$62d63af83dac7315);
const $5d43d6affeb19d8a$export$582443c7ead02173 = (value)=>typeof value === 'string' && value !== '';
const $5d43d6affeb19d8a$var$isValidScreenTabId = (internalScreenTabs, id)=>$5d43d6affeb19d8a$export$582443c7ead02173(id) && internalScreenTabs.find((tab)=>tab.id === id) !== undefined;
const $5d43d6affeb19d8a$var$isValidScreenTabIsActive = (isActive)=>typeof isActive === 'boolean' || typeof isActive === 'undefined';
const $5d43d6affeb19d8a$var$isValidScreenTabIsVisible = (isVisible)=>typeof isVisible === 'boolean' || typeof isVisible === 'undefined';
const $5d43d6affeb19d8a$var$isValidScreenTabData = (internalScreenTabs, { id: id, isVisible: isVisible, isActive: isActive })=>$5d43d6affeb19d8a$var$isValidScreenTabId(internalScreenTabs, id) && $5d43d6affeb19d8a$var$isValidScreenTabIsVisible(isVisible) && $5d43d6affeb19d8a$var$isValidScreenTabIsActive(isActive);
const $5d43d6affeb19d8a$var$countNumberOfActiveScreenTabs = (acc, { isActive: isActive })=>{
    if ($5d43d6affeb19d8a$var$isValidScreenTabIsActive(isActive) && isActive) return acc + 1;
    return acc;
};
const $5d43d6affeb19d8a$var$countNumberOfHiddenActiveScreenTabs = (acc, { isActive: isActive, isVisible: isVisible })=>{
    if ($5d43d6affeb19d8a$var$isValidScreenTabIsActive(isActive) && isActive && $5d43d6affeb19d8a$var$isValidScreenTabIsVisible(isVisible) && !isVisible) return acc + 1;
    return acc;
};
const $5d43d6affeb19d8a$export$9ca9b35e7b6a8bbc = (internalScreenTabs, screenTabsFromApp)=>{
    let numberOfActiveScreenTabs = 0;
    const internalActiveScreenTabIndex = internalScreenTabs.findIndex((tab)=>tab.isActive === true);
    const screenTabsInternalUpdated = internalScreenTabs.map((screenTabInternal)=>{
        const screenTabFromApp = screenTabsFromApp.find((tab)=>tab.id === screenTabInternal.id);
        if (!screenTabFromApp) return screenTabInternal;
        numberOfActiveScreenTabs += screenTabFromApp.isActive === true ? 1 : 0;
        return {
            id: screenTabInternal.id,
            isVisible: screenTabFromApp.isVisible ?? true,
            isActive: screenTabFromApp.isActive
        };
    });
    // if no active tab is specified. default to the first
    if (numberOfActiveScreenTabs === 0 && internalActiveScreenTabIndex === -1 && typeof screenTabsInternalUpdated[0]?.isActive !== 'undefined') screenTabsInternalUpdated[0].isActive = true;
    return screenTabsInternalUpdated;
};
const $5d43d6affeb19d8a$export$e7a91e7e430e691a = (internalScreenTabs, screenTabsFromApp)=>{
    if (!Array.isArray(screenTabsFromApp)) return false;
    const screenTabsFromAppFiltered = screenTabsFromApp.filter((data)=>$5d43d6affeb19d8a$var$isValidScreenTabData(internalScreenTabs, data));
    const numberOfActiveScreenTabs = screenTabsFromApp.reduce($5d43d6affeb19d8a$var$countNumberOfActiveScreenTabs, 0);
    const numberOfHiddenActiveScreenTabs = screenTabsFromApp.reduce($5d43d6affeb19d8a$var$countNumberOfHiddenActiveScreenTabs, 0);
    return numberOfActiveScreenTabs <= 1 && screenTabsFromApp.length === screenTabsFromAppFiltered.length && numberOfHiddenActiveScreenTabs === 0;
};
const $5d43d6affeb19d8a$export$62d63af83dac7315 = (internalScreenTabs, screenTabsFromApp)=>{
    if (!internalScreenTabs) return [
        'There are no screen tabs in the current view.'
    ];
    if (!Array.isArray(screenTabsFromApp)) return [
        'Your app must return screen tabs as an array.'
    ];
    const errors = [];
    if (screenTabsFromApp.reduce($5d43d6affeb19d8a$var$countNumberOfActiveScreenTabs, 0) > 1) errors.push('Only one screen tab can be in focus.');
    if (screenTabsFromApp.reduce($5d43d6affeb19d8a$var$countNumberOfHiddenActiveScreenTabs, 0) > 0) errors.push("You can't hide a screen tab that's currently in focus.");
    return errors;
};

});





parcelRegister("eNNkf", function(module, exports) {

$parcel$export(module.exports, "useUserPreferencesValue", () => $5092328ed6a09c60$export$8bd3660b16415efd);
$parcel$export(module.exports, "useUserPreferencesActions", () => $5092328ed6a09c60$export$eefe4b2985e8203e);

var $5uXOq = parcelRequire("5uXOq");

var $hLEug = parcelRequire("hLEug");

var $12pgs = parcelRequire("12pgs");
const $5092328ed6a09c60$export$8bd3660b16415efd = (userPreferenceKey)=>{
    const baseUrl = '';
    const [value, { setUserPreferenceValue: setUserPreferenceValue, deleteUserPreferenceValue: deleteUserPreferenceValue }] = (0, $hLEug.useUserPreferencesStoreValue)(userPreferenceKey);
    /**
	 * persist: boolean - if true, save the value to the server ,else just update the local state and return a promise with the new value
	 */ const setValue = (0, $5uXOq.useCallback)((newValue, persist = true)=>{
        setUserPreferenceValue(userPreferenceKey, newValue);
        if (!persist) return Promise.resolve(newValue);
        return (0, $12pgs.saveUserPreferenceValue)(baseUrl, userPreferenceKey, newValue);
    }, [
        baseUrl,
        setUserPreferenceValue,
        userPreferenceKey
    ]);
    const deleteValue = (0, $5uXOq.useCallback)(()=>{
        deleteUserPreferenceValue(userPreferenceKey);
        return (0, $12pgs.removeUserPreferenceValue)(baseUrl, userPreferenceKey);
    }, [
        baseUrl,
        deleteUserPreferenceValue,
        userPreferenceKey
    ]);
    const setUserPreferences = (0, $5uXOq.useMemo)(()=>({
            setValue: setValue,
            deleteValue: deleteValue
        }), [
        setValue,
        deleteValue
    ]);
    return [
        value,
        setUserPreferences
    ];
};
const $5092328ed6a09c60$export$eefe4b2985e8203e = ()=>{
    const baseUrl = '';
    const [, actions] = (0, $hLEug.useUserPreferencesStoreActions)();
    const userPreferenceActions = (0, $5uXOq.useMemo)(()=>{
        const setUserPreferenceValue = (userPreferenceKey, value)=>{
            actions.setUserPreferenceValue(userPreferenceKey, value);
            (0, $12pgs.saveUserPreferenceValue)(baseUrl, userPreferenceKey, value);
        };
        const deleteUserPreferenceValue = (userPreferenceKey)=>{
            actions.deleteUserPreferenceValue(userPreferenceKey);
            (0, $12pgs.removeUserPreferenceValue)(baseUrl, userPreferenceKey);
        };
        const setUserPreferences = (userPreferences)=>{
            userPreferences && Object.keys(userPreferences).length !== 0 && actions.setUserPreferences(userPreferences);
        };
        return {
            setUserPreferenceValue: setUserPreferenceValue,
            setUserPreferences: setUserPreferences,
            deleteUserPreferenceValue: deleteUserPreferenceValue,
            getUserPreferenceValue: actions.getUserPreferenceValue
        };
    }, [
        actions,
        baseUrl
    ]);
    return [
        null,
        userPreferenceActions
    ];
};

});
parcelRegister("hLEug", function(module, exports) {

$parcel$export(module.exports, "useUserPreferencesStoreValue", () => $f08ba98a3f2bdde2$export$46e7eeb2fc34fab8);
$parcel$export(module.exports, "useUserPreferencesStoreActions", () => $f08ba98a3f2bdde2$export$4d156074562bac9a);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $djdK3 = parcelRequire("djdK3");
const $f08ba98a3f2bdde2$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'user-preferences',
    initialState: {
        preferences: {}
    },
    actions: $djdK3.actions
});
const $f08ba98a3f2bdde2$var$getUserPreference = (state, userPreferenceKey)=>state.preferences[userPreferenceKey];
const $f08ba98a3f2bdde2$export$46e7eeb2fc34fab8 = (0, $3sQ5x.createHook)($f08ba98a3f2bdde2$export$6f57813fe9f31bf9, {
    selector: $f08ba98a3f2bdde2$var$getUserPreference
});
const $f08ba98a3f2bdde2$export$4d156074562bac9a = (0, $3sQ5x.createHook)($f08ba98a3f2bdde2$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("djdK3", function(module, exports) {

$parcel$export(module.exports, "actions", () => $5c68f1b920b8984c$export$e324594224ef24da);
const $5c68f1b920b8984c$var$setUserPreferenceValue = (key, value)=>({ setState: setState, getState: getState })=>{
        setState({
            preferences: {
                ...getState().preferences,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [key]: value
            }
        });
    };
const $5c68f1b920b8984c$var$deleteUserPreferenceValue = (key)=>({ setState: setState, getState: getState })=>{
        const { [key]: _, ...preferences } = getState().preferences;
        setState({
            preferences: preferences
        });
    };
const $5c68f1b920b8984c$var$setUserPreferences = (state)=>({ setState: setState })=>{
        setState({
            preferences: state
        });
    };
const $5c68f1b920b8984c$export$df0a4f67b9888111 = (key)=>({ getState: getState })=>{
        const { preferences: preferences } = getState();
        return preferences[key];
    };
const $5c68f1b920b8984c$export$e324594224ef24da = {
    setUserPreferenceValue: $5c68f1b920b8984c$var$setUserPreferenceValue,
    deleteUserPreferenceValue: $5c68f1b920b8984c$var$deleteUserPreferenceValue,
    setUserPreferences: $5c68f1b920b8984c$var$setUserPreferences,
    getUserPreferenceValue: $5c68f1b920b8984c$export$df0a4f67b9888111
};

});


parcelRegister("12pgs", function(module, exports) {

$parcel$export(module.exports, "saveUserPreferenceValue", () => $0dfd1081a7a72732$export$bebe1b9e9f4cbf16);
$parcel$export(module.exports, "removeUserPreferenceValue", () => $0dfd1081a7a72732$export$a60a810760d07867);

var $eusud = parcelRequire("eusud");
const $0dfd1081a7a72732$export$bebe1b9e9f4cbf16 = async (baseUrl, userPreferenceKey, value)=>(0, $eusud.performPutRequest)(`/rest/api/2/mypreferences?key=${userPreferenceKey}`, {
        body: value
    });
const $0dfd1081a7a72732$export$a60a810760d07867 = async (baseUrl, userPreferenceKey)=>(0, $eusud.performDeleteRequest)(`/rest/api/2/mypreferences?key=${userPreferenceKey}`);

});


parcelRegister("2gCtH", function(module, exports) {

$parcel$export(module.exports, "useChildIssuesLimit", () => $9e67f38435565e11$export$8d75f312eaa63aec);
$parcel$export(module.exports, "useChildIssuesIssueLimitUrl", () => $9e67f38435565e11$export$65a59acd1ffc5bba);
$parcel$export(module.exports, "useIsModal", () => $9e67f38435565e11$export$9ce8428ff198804a);
$parcel$export(module.exports, "useIssueKey", () => $9e67f38435565e11$export$22108eca27445997);
$parcel$export(module.exports, "useIssueId", () => $9e67f38435565e11$export$9df8176b5ffce5ab);
$parcel$export(module.exports, "useIsArchived", () => $9e67f38435565e11$export$7cd1821433aafaee);
$parcel$export(module.exports, "useIsClassifyEditEnabled", () => $9e67f38435565e11$export$b23b36ed5c42e920);
$parcel$export(module.exports, "useProjectKey", () => $9e67f38435565e11$export$f87be37f8e8be65);
$parcel$export(module.exports, "useAnalyticsSource", () => $9e67f38435565e11$export$aad3917152559b87);
$parcel$export(module.exports, "useIssueContextActions", () => $9e67f38435565e11$export$d6ec1293313f49ac);
$parcel$export(module.exports, "useRapidViewMap", () => $9e67f38435565e11$export$4d204e800e4e0be7);
$parcel$export(module.exports, "useEstimationStatistic", () => $9e67f38435565e11$export$5b20e30ee6db56e9);
$parcel$export(module.exports, "useViewMode", () => $9e67f38435565e11$export$3a7c3e259b6adb93);
$parcel$export(module.exports, "useBackButtonUrl", () => $9e67f38435565e11$export$cfe64a334903927c);
$parcel$export(module.exports, "useIssueNavigatorData", () => $9e67f38435565e11$export$aa008a00bae7e7ab);
$parcel$export(module.exports, "useOnIssueKeyChange", () => $9e67f38435565e11$export$52c975cf0b623556);
$parcel$export(module.exports, "useRapidViewId", () => $9e67f38435565e11$export$b34d0ea0bf41fee);
$parcel$export(module.exports, "useViewScreenId", () => $9e67f38435565e11$export$7c142b5701b4c3f9);
$parcel$export(module.exports, "useHasSoftwareAccess", () => $9e67f38435565e11$export$dcc0d1c3cd4bd9fb);
$parcel$export(module.exports, "useIsFullPageIssueView", () => $9e67f38435565e11$export$2e131fc4108f9106);
$parcel$export(module.exports, "useIsEmbedPageIssueView", () => $9e67f38435565e11$export$4596c26005fbb859);
$parcel$export(module.exports, "useIsAiEnabledForIssue", () => $9e67f38435565e11$export$db5174c7538abe4b);
$parcel$export(module.exports, "useIsJiraIssue", () => $9e67f38435565e11$export$cf5fc815f761fb4b);

var $5uXOq = parcelRequire("5uXOq");


var $2vSU6 = parcelRequire("2vSU6");

var $4Pf62 = parcelRequire("4Pf62");

var $93Yeu = parcelRequire("93Yeu");

var $g5X3G = parcelRequire("g5X3G");

var $ef5Xn = parcelRequire("ef5Xn");

var $7trqb = parcelRequire("7trqb");

var $hqBSi = parcelRequire("hqBSi");

var $koiRX = parcelRequire("koiRX");
const $9e67f38435565e11$export$8d75f312eaa63aec = ()=>{
    const [childIssuesLimit] = (0, $koiRX.useIssueContextStoreChildIssuesLimit)();
    return childIssuesLimit;
};
const $9e67f38435565e11$export$cc6e0a43a2a9b17a = ()=>{
    const [childIssuesIssueLimitUrls] = (0, $koiRX.useIssueContextStoreChildIssuesIssueLimitUrls)();
    return childIssuesIssueLimitUrls;
};
const $9e67f38435565e11$export$65a59acd1ffc5bba = (fieldId)=>{
    const childIssuesIssueLimitUrls = $9e67f38435565e11$export$cc6e0a43a2a9b17a();
    return childIssuesIssueLimitUrls?.[fieldId];
};
const $9e67f38435565e11$export$9ce8428ff198804a = ()=>{
    const [isModal] = (0, $koiRX.useIssueContextStoreIsModal)();
    return isModal;
};
const $9e67f38435565e11$export$22108eca27445997 = ()=>{
    const [issueKey] = (0, $koiRX.useIssueContextStoreIssueKey)();
    return issueKey;
};
const $9e67f38435565e11$export$9df8176b5ffce5ab = ()=>{
    const [issueId] = (0, $koiRX.useIssueContextStoreIssueId)();
    return issueId;
};
const $9e67f38435565e11$export$7cd1821433aafaee = ()=>{
    const [isArchived] = (0, $koiRX.useIssueContextStoreIsArchived)();
    return isArchived;
};
const $9e67f38435565e11$export$b23b36ed5c42e920 = ()=>{
    const [isClassifyEditEnabled] = (0, $koiRX.useIssueContextStoreIsClassifyEditEnabled)();
    return isClassifyEditEnabled;
};
const $9e67f38435565e11$export$f87be37f8e8be65 = ()=>{
    const [issueKey] = (0, $koiRX.useIssueContextStoreIssueKey)();
    return (0, $g5X3G.toProjectKey)(issueKey.split('-')[0]);
};
const $9e67f38435565e11$export$aad3917152559b87 = ()=>{
    const [analyticsSource] = (0, $koiRX.useIssueContextStoreAnalyticsSource)();
    return analyticsSource;
};
const $9e67f38435565e11$export$d6ec1293313f49ac = ()=>{
    const [, { setIssueContext: setIssueContext, mergeIssueContext: mergeIssueContext, getChildIssuesLimit: getChildIssuesLimit, getMaxTokenLength: getMaxTokenLength, getIsLoadedWithPage: getIsLoadedWithPage, getBackButtonUrl: getBackButtonUrl, getIsSpaEnabled: getIsSpaEnabled, getIssueKey: getIssueKey, setDetailViewAsModal: setDetailViewAsModal, setDetailViewAsSidebar: setDetailViewAsSidebar, setDetailViewAsExpandedModal: setDetailViewAsExpandedModal, setDetailViewAsCollapsedModal: setDetailViewAsCollapsedModal, resetDetailView: resetDetailView }] = (0, $koiRX.useIssueContextStoreActions)();
    const actions = (0, $5uXOq.useMemo)(()=>({
            setIssueContext: setIssueContext,
            mergeIssueContext: mergeIssueContext,
            getChildIssuesLimit: getChildIssuesLimit,
            getMaxTokenLength: getMaxTokenLength,
            getIsLoadedWithPage: getIsLoadedWithPage,
            getBackButtonUrl: getBackButtonUrl,
            getIsSpaEnabled: getIsSpaEnabled,
            getIssueKey: getIssueKey,
            setDetailViewAsModal: setDetailViewAsModal,
            setDetailViewAsSidebar: setDetailViewAsSidebar,
            setDetailViewAsExpandedModal: setDetailViewAsExpandedModal,
            setDetailViewAsCollapsedModal: setDetailViewAsCollapsedModal,
            resetDetailView: resetDetailView
        }), [
        setIssueContext,
        mergeIssueContext,
        getChildIssuesLimit,
        getMaxTokenLength,
        getIsLoadedWithPage,
        getBackButtonUrl,
        getIsSpaEnabled,
        getIssueKey,
        setDetailViewAsModal,
        setDetailViewAsSidebar,
        setDetailViewAsExpandedModal,
        setDetailViewAsCollapsedModal,
        resetDetailView
    ]);
    return [
        undefined,
        actions
    ];
};
const $9e67f38435565e11$export$4d204e800e4e0be7 = ()=>{
    const [rapidViewMap] = (0, $koiRX.useIssueContextRapidViewMap)();
    return rapidViewMap;
};
const $9e67f38435565e11$export$e0d7666ae716c88a = ()=>{
    const [maxTokenLength] = (0, $koiRX.useIssueContextStoreMaxTokenLength)();
    return maxTokenLength;
};
const $9e67f38435565e11$export$b4199f923267161e = ()=>{
    const [isLoadedWithPage] = (0, $koiRX.useIssueContextStoreIsLoadedWithPage)();
    return isLoadedWithPage;
};
const $9e67f38435565e11$export$5b20e30ee6db56e9 = ()=>{
    const [estimationStatistic] = (0, $koiRX.useIssueContextStoreEstimationStatistic)();
    return estimationStatistic;
};
const $9e67f38435565e11$export$4dface15d86304a4 = ()=>{
    const [isLoading] = (0, $koiRX.useIssueContextStoreIsLoading)();
    return isLoading;
};
const $9e67f38435565e11$export$3a7c3e259b6adb93 = ()=>{
    const [viewMode] = (0, $koiRX.useIssueContextStoreViewMode)();
    return viewMode;
};
const $9e67f38435565e11$export$cfe64a334903927c = ()=>{
    const [backButtonUrl] = (0, $koiRX.useIssueContextStoreBackButtonUrl)();
    return backButtonUrl;
};
const $9e67f38435565e11$export$aa008a00bae7e7ab = ()=>{
    const [issueNavigatorData] = (0, $koiRX.useIssueContextStoreIssueNavigatorData)();
    return issueNavigatorData;
};
const $9e67f38435565e11$export$b49754504c41149f = ()=>{
    const [boardId] = (0, $koiRX.useIssueContextStoreBoardId)();
    return boardId;
};
const $9e67f38435565e11$export$91aab984882a2a2c = ()=>{
    const [boardType] = (0, $koiRX.useIssueContextStoreBoardType)();
    return boardType;
};
const $9e67f38435565e11$export$dbad9dbd4871f2e9 = ()=>{
    const [isSpaEnabled] = (0, $koiRX.useIssueContextStoreIsSpaEnabled)();
    return isSpaEnabled;
};
const $9e67f38435565e11$export$7be495880d433ab9 = ()=>{
    const [loginRedirectUrl] = (0, $koiRX.useIssueContextStoreLoginRedirctUrl)();
    return loginRedirectUrl;
};
const $9e67f38435565e11$export$52c975cf0b623556 = ()=>{
    const [onIssueKeyChange] = (0, $koiRX.useIssueContextStoreOnIssueKeyChange)();
    return onIssueKeyChange;
};
const $9e67f38435565e11$export$b34d0ea0bf41fee = ()=>{
    const [rapidViewId] = (0, $koiRX.useIssueContextStoreRapidViewId)();
    return rapidViewId;
};
const $9e67f38435565e11$export$7c142b5701b4c3f9 = ()=>{
    const [viewScreenId] = (0, $koiRX.useIssueContextStoreViewScreenId)();
    return viewScreenId;
};
const $9e67f38435565e11$export$dcc0d1c3cd4bd9fb = ()=>{
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    const licenseStates = (0, $7trqb.useLicenseStates)();
    const isJiraSoftwareLicenseActive = licenseStates && licenseStates.software === (0, $ef5Xn.LICENSE_STATE_ACTIVE);
    return licensedProducts[(0, $4Pf62.LICENSED_PRODUCTS).JIRA_SOFTWARE] && isJiraSoftwareLicenseActive;
};
const $9e67f38435565e11$export$2e131fc4108f9106 = ()=>{
    const analyticsSource = $9e67f38435565e11$export$aad3917152559b87();
    return analyticsSource === (0, $fcf97b7a09088940$export$b19f949fb9713614);
};
const $9e67f38435565e11$export$4596c26005fbb859 = ()=>{
    const analyticsSource = $9e67f38435565e11$export$aad3917152559b87();
    return analyticsSource === (0, $fcf97b7a09088940$export$a5132300c5214280);
};
const $9e67f38435565e11$export$db5174c7538abe4b = ()=>{
    const [isAiEnabledForIssue] = (0, $koiRX.useIssueContextIsAiEnabledForIssue)();
    return isAiEnabledForIssue;
};
const $9e67f38435565e11$export$cf5fc815f761fb4b = ()=>{
    const issueKey = $9e67f38435565e11$export$22108eca27445997();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    return [
        (0, $2vSU6.SOFTWARE_PROJECT),
        (0, $2vSU6.CORE_PROJECT)
    ].some((type)=>type === projectType);
};

});
const $fcf97b7a09088940$export$53d41ff2666118e1 = 'agility-backlog';
const $fcf97b7a09088940$export$7552fe2669628499 = 'bitbucket-issue';
const $fcf97b7a09088940$export$41a718da0a8636f4 = 'connect-issue';
const $fcf97b7a09088940$export$cebf0bc8b2ccaf57 = 'core-issue';
const $fcf97b7a09088940$export$5e91e17726e54450 = 'jiraCalendar';
const $fcf97b7a09088940$export$2dac1950892123f5 = 'jiraTimeline';
const $fcf97b7a09088940$export$82540942fb014b0a = 'business-calendar';
const $fcf97b7a09088940$export$7ca28938a07e0c33 = 'business-list';
const $fcf97b7a09088940$export$f6cf06aaaeb58a54 = 'business-timeline';
const $fcf97b7a09088940$export$b2c0462ff17aa26e = 'business-board';
const $fcf97b7a09088940$export$a607850ebccd28ac = 'business-approvals';
const $fcf97b7a09088940$export$1da6cede3561048f = 'business-files';
const $fcf97b7a09088940$export$b19f949fb9713614 = 'full-issue';
const $fcf97b7a09088940$export$a5132300c5214280 = 'embed-issue';
const $fcf97b7a09088940$export$710114090a811b37 = 'global-issue-navigator-issue';
const $fcf97b7a09088940$export$ce88447986394f2d = 'mobile-issue';
const $fcf97b7a09088940$export$6a90d9196d330040 = 'project-issue-navigator';
const $fcf97b7a09088940$export$2247c9059c171db1 = 'roadmap-issue';
const $fcf97b7a09088940$export$cd16d39c55c569d0 = 'simple-software-board';
const $fcf97b7a09088940$export$f72626bf0d75dfad = 'software-backlog-issue';
const $fcf97b7a09088940$export$778b4609e784cb27 = 'software-deployments-issue';
const $fcf97b7a09088940$export$5b73d694a6048002 = 'version-detail-issue';
const $fcf97b7a09088940$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $fcf97b7a09088940$export$21b5b7189add7861 = 'software-incidents-issue';
const $fcf97b7a09088940$export$9c5d81b901471b27 = 'software-issue';
const $fcf97b7a09088940$export$1735f6ad917dc411 = 'change-calendar';
const $fcf97b7a09088940$export$7063ee6d0035a982 = 'queues-issue-view';
const $fcf97b7a09088940$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $fcf97b7a09088940$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $fcf97b7a09088940$export$14a8072f422804fd = 'issue-navigator-next';
const $fcf97b7a09088940$export$5f3c20fe2ff6c0a2 = 'staffing-issue';

parcelRegister("93Yeu", function(module, exports) {

$parcel$export(module.exports, "useProjectKey", () => $5f0f9360597cdbd8$export$f87be37f8e8be65);
$parcel$export(module.exports, "useProjectContextActions", () => $5f0f9360597cdbd8$export$bd73624ca941f105);
$parcel$export(module.exports, "useProjectType", () => $5f0f9360597cdbd8$export$6de29d851c914935);
$parcel$export(module.exports, "useProjectContext", () => $5f0f9360597cdbd8$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useApplication", () => $5f0f9360597cdbd8$export$aaf75bb403fe1fb5);
$parcel$export(module.exports, "useEdition", () => $5f0f9360597cdbd8$export$d56c02945cf5a9e5);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $5f0f9360597cdbd8$export$524ef4f6102ed540);
$parcel$export(module.exports, "useIsClassicProject", () => $5f0f9360597cdbd8$export$e2cf96f40a8867ce);
$parcel$export(module.exports, "useProjectId", () => $5f0f9360597cdbd8$export$16d1475ed6c26568);
$parcel$export(module.exports, "useProjectStatus", () => $5f0f9360597cdbd8$export$30f16f2782a4113b);
$parcel$export(module.exports, "useProjectConfiguration", () => $5f0f9360597cdbd8$export$af19ad68b52fa1a6);
$parcel$export(module.exports, "useProjectIssueTypes", () => $5f0f9360597cdbd8$export$80bef597b440cf71);

var $5uXOq = parcelRequire("5uXOq");

var $eIGIx = parcelRequire("eIGIx");

var $4R6GH = parcelRequire("4R6GH");

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");

var $g5X3G = parcelRequire("g5X3G");

var $9OXo1 = parcelRequire("9OXo1");

var $buby4 = parcelRequire("buby4");

var $1daUm = parcelRequire("1daUm");
const $5f0f9360597cdbd8$export$f87be37f8e8be65 = (issueKey)=>(0, $g5X3G.toProjectKey)(issueKey.split('-')[0]);
const $5f0f9360597cdbd8$export$bd73624ca941f105 = ()=>{
    const [, { setProjectContext: setProjectContext, mergeProjectProperty: mergeProjectProperty }] = (0, $buby4.useProjectContextActionStore)();
    const actions = (0, $5uXOq.useMemo)(()=>({
            setProjectContext: setProjectContext,
            mergeProjectProperty: mergeProjectProperty
        }), [
        setProjectContext,
        mergeProjectProperty
    ]);
    return [
        null,
        actions
    ];
};
const $5f0f9360597cdbd8$export$6de29d851c914935 = (projectKey)=>{
    const [projectType] = (0, $buby4.useProjectContextProjectTypeStore)({
        projectKey: projectKey
    });
    return projectType;
};
const $5f0f9360597cdbd8$export$27e24febf0f5c3bc = (projectKey)=>{
    const [projectStyle] = (0, $buby4.useProjectContextJiraProjectStyleStore)({
        projectKey: projectKey
    });
    return projectStyle;
};
const $5f0f9360597cdbd8$export$8f31c2503e1efa93 = (projectKey)=>{
    const [projectContext] = (0, $buby4.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext;
};
const $5f0f9360597cdbd8$export$aaf75bb403fe1fb5 = (projectKey, failSafely = false)=>{
    const projectType = $5f0f9360597cdbd8$export$6de29d851c914935(projectKey);
    if (projectType === undefined) {
        if (failSafely) return undefined;
        throw new Error(`No project type for project key ${projectKey} in Project Context Service`);
    }
    return (0, $efvDm.getApplicationForProject)(projectType);
};
const $5f0f9360597cdbd8$export$d56c02945cf5a9e5 = (projectKey, failSafely = false)=>{
    const { appEditions: appEditions } = (0, $9OXo1.useTenantContext)();
    const application = $5f0f9360597cdbd8$export$aaf75bb403fe1fb5(projectKey, failSafely);
    if (!application) return undefined;
    return (0, $ldyPw.getEdition)(application, appEditions);
};
const $5f0f9360597cdbd8$export$524ef4f6102ed540 = (projectKey)=>{
    const [projectContext] = (0, $buby4.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.isSimplified || false;
};
const $5f0f9360597cdbd8$export$e2cf96f40a8867ce = (projectKey)=>{
    const [projectContext] = (0, $buby4.useProjectContextStore)({
        projectKey: projectKey
    });
    return !projectContext?.isSimplified;
};
const $5f0f9360597cdbd8$export$16d1475ed6c26568 = (projectKey)=>{
    const [projectContext] = (0, $buby4.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.projectId;
};
const $5f0f9360597cdbd8$export$30f16f2782a4113b = (projectKey)=>{
    const [projectContext] = (0, $buby4.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.projectStatus;
};
const $5f0f9360597cdbd8$export$af19ad68b52fa1a6 = (projectKey)=>{
    const projectType = $5f0f9360597cdbd8$export$6de29d851c914935(projectKey);
    const isSimplified = $5f0f9360597cdbd8$export$524ef4f6102ed540(projectKey);
    return (0, $eIGIx.useMemoWithCondition)(()=>(0, $1daUm.getIssueConfiguration)({
            isSimplified: isSimplified,
            projectType: projectType
        }), [
        isSimplified,
        projectType
    ], ()=>(0, $4R6GH.fg)('jfp_magma_issue-stability-phase1'));
};
const $5f0f9360597cdbd8$export$654dd2c557853fbe = (projectKey)=>{
    const [projectName] = (0, $buby4.useProjectContextProjectNameStore)({
        projectKey: projectKey
    });
    return projectName;
};
const $5f0f9360597cdbd8$export$80bef597b440cf71 = (projectKey)=>{
    const [issueTypes] = (0, $buby4.useProjectContextIssueTypesStore)({
        projectKey: projectKey
    });
    return issueTypes;
};

});
parcelRegister("buby4", function(module, exports) {

$parcel$export(module.exports, "useProjectContextActionStore", () => $42c27dedc1310bb2$export$9afb89c1fe103bbe);
$parcel$export(module.exports, "useProjectContextStore", () => $42c27dedc1310bb2$export$8b09478b33186ec);
$parcel$export(module.exports, "useProjectContextProjectTypeStore", () => $42c27dedc1310bb2$export$f2e1ed3b2b4707cb);
$parcel$export(module.exports, "useProjectContextJiraProjectStyleStore", () => $42c27dedc1310bb2$export$b291cf203d6481a4);
$parcel$export(module.exports, "useProjectContextProjectNameStore", () => $42c27dedc1310bb2$export$9469fde70658518);
$parcel$export(module.exports, "useProjectContextIssueTypesStore", () => $42c27dedc1310bb2$export$f73e9904779f6be5);

var $2vSU6 = parcelRequire("2vSU6");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $aDpiK = parcelRequire("aDpiK");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $42c27dedc1310bb2$var$initialState = {};
const $42c27dedc1310bb2$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'project-context',
    initialState: $42c27dedc1310bb2$var$initialState,
    actions: $aDpiK
});
const $42c27dedc1310bb2$export$9afb89c1fe103bbe = (0, $3sQ5x.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
    selector: null
});
const $42c27dedc1310bb2$var$getProjectContext = (state, { projectKey: projectKey })=>state[projectKey];
const $42c27dedc1310bb2$export$8b09478b33186ec = (0, $3sQ5x.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
    selector: $42c27dedc1310bb2$var$getProjectContext
});
const $42c27dedc1310bb2$var$getProjectType = (state, { projectKey: projectKey })=>{
    const projectContext = $42c27dedc1310bb2$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.projectType;
};
const $42c27dedc1310bb2$var$getJiraProjectStyle = (state, { projectKey: projectKey })=>{
    const projectContext = $42c27dedc1310bb2$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.isSimplified ? (0, $2vSU6.TEAM_MANAGED_PROJECT) : (0, $2vSU6.COMPANY_MANAGED_PROJECT);
};
const $42c27dedc1310bb2$export$f2e1ed3b2b4707cb = (0, $3sQ5x.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
    selector: $42c27dedc1310bb2$var$getProjectType
});
const $42c27dedc1310bb2$export$b291cf203d6481a4 = (0, $3sQ5x.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
    selector: $42c27dedc1310bb2$var$getJiraProjectStyle
});
const $42c27dedc1310bb2$var$getProjectName = (state, { projectKey: projectKey })=>{
    const projectContext = $42c27dedc1310bb2$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.projectName;
};
const $42c27dedc1310bb2$export$9469fde70658518 = (0, $3sQ5x.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
    selector: $42c27dedc1310bb2$var$getProjectName
});
const $42c27dedc1310bb2$var$getIssueTypes = (state, { projectKey: projectKey })=>{
    const projectContext = $42c27dedc1310bb2$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.issueTypes;
};
const $42c27dedc1310bb2$export$f73e9904779f6be5 = (0, $3sQ5x.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
    selector: $42c27dedc1310bb2$var$getIssueTypes
});

});
parcelRegister("aDpiK", function(module, exports) {

$parcel$export(module.exports, "setProjectContext", () => $ad16c28ce51d4ccf$export$d64151aab9ae5f09);
$parcel$export(module.exports, "mergeProjectProperty", () => $ad16c28ce51d4ccf$export$78f1c6052937615f);
const $ad16c28ce51d4ccf$export$d64151aab9ae5f09 = (key, projectContext)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [key]: projectContext
        });
    };
const $ad16c28ce51d4ccf$export$78f1c6052937615f = (key, projectContext)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const currentProjectContext = currentState[key];
        const newProjectContext = {
            ...currentProjectContext,
            ...projectContext
        };
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [key]: newProjectContext
        });
    };

});


parcelRegister("1daUm", function(module, exports) {

$parcel$export(module.exports, "getIssueConfiguration", () => $7afb7a15cd46bd62$export$902f6c5cc939598a);

var $65mz3 = parcelRequire("65mz3");

var $2vSU6 = parcelRequire("2vSU6");
const $7afb7a15cd46bd62$export$cdbd1eb3b05729e0 = 'flagActions';
const $7afb7a15cd46bd62$export$c161a774ec2e7e56 = 'cardCoverActions';
const $7afb7a15cd46bd62$export$a52507e68e7aeeb = ()=>({
        issueActions: []
    });
const $7afb7a15cd46bd62$export$381ce08838c53afa = ()=>({
        applicationKey: (0, $65mz3.default).CORE_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $7afb7a15cd46bd62$export$27e0678365e5dcff = ()=>({
        applicationKey: (0, $65mz3.default).SOFTWARE_ISSUE,
        issueActions: [
            $7afb7a15cd46bd62$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $7afb7a15cd46bd62$export$aebf676dfa727a1c = ()=>({
        applicationKey: (0, $65mz3.default).SIMPLE_SOFTWARE_BOARD,
        issueActions: [
            $7afb7a15cd46bd62$export$cdbd1eb3b05729e0,
            $7afb7a15cd46bd62$export$c161a774ec2e7e56
        ],
        ecosystemEnabled: true
    });
const $7afb7a15cd46bd62$export$1afca4d3eb6b218b = ()=>({
        applicationKey: (0, $65mz3.default).STANDARD_ROADMAP_ISSUE,
        issueActions: [
            $7afb7a15cd46bd62$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $7afb7a15cd46bd62$export$8a060ed6f66c43b0 = ()=>({
        applicationKey: (0, $65mz3.default).BITBUCKET_ISSUE,
        issueActions: []
    });
const $7afb7a15cd46bd62$export$78a2cb921e46f5eb = ()=>({
        applicationKey: (0, $65mz3.default).MOBILE_ISSUE,
        issueActions: []
    });
const $7afb7a15cd46bd62$export$db1115186532f6d5 = ()=>({
        applicationKey: (0, $65mz3.default).SERVICE_DESK,
        issueActions: [],
        ecosystemEnabled: true
    });
const $7afb7a15cd46bd62$export$902f6c5cc939598a = (config)=>{
    if (config) switch(config.projectType){
        case 0, $2vSU6.SOFTWARE_PROJECT:
            if (config.isSimplified) return $7afb7a15cd46bd62$export$aebf676dfa727a1c();
            return $7afb7a15cd46bd62$export$27e0678365e5dcff();
        case 0, $2vSU6.CORE_PROJECT:
            return $7afb7a15cd46bd62$export$381ce08838c53afa();
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return $7afb7a15cd46bd62$export$db1115186532f6d5();
        default:
            // fallback to sofware config
            return $7afb7a15cd46bd62$export$27e0678365e5dcff();
    }
    return $7afb7a15cd46bd62$export$27e0678365e5dcff();
};

});
parcelRegister("65mz3", function(module, exports) {

$parcel$export(module.exports, "default", () => $7178ba5d31d0f054$export$2e2bcd8739ae039);
const $7178ba5d31d0f054$var$keys = {
    CONNECT_ISSUE: 'connect-issue',
    BITBUCKET_ISSUE: 'bitbucket-issue',
    CORE_ISSUE: 'core-issue',
    MOBILE_ISSUE: 'mobile-issue',
    SIMPLE_SOFTWARE_BOARD: 'simple-software-board',
    SOFTWARE_ISSUE: 'software-issue',
    STANDARD_ROADMAP_ISSUE: 'standard-roadmap-issue',
    SERVICE_DESK: 'service-desk',
    EMPTY_APPLICATION_KEY: ''
};
var $7178ba5d31d0f054$export$2e2bcd8739ae039 = $7178ba5d31d0f054$var$keys;

});



parcelRegister("7trqb", function(module, exports) {

$parcel$export(module.exports, "useLicenseStates", () => $5fcaa3f734e9c444$export$268651a63abe408a);

var $9OXo1 = parcelRequire("9OXo1");
const $5fcaa3f734e9c444$export$268651a63abe408a = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.licenseStates;
};

});

parcelRegister("hqBSi", function(module, exports) {

$parcel$export(module.exports, "useLicensedProducts", () => $7564850c0894983d$export$54d534cc91e54850);

var $9OXo1 = parcelRequire("9OXo1");
const $7564850c0894983d$export$54d534cc91e54850 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.licensedProducts || {};
};

});

parcelRegister("koiRX", function(module, exports) {

$parcel$export(module.exports, "useIssueContextStoreChildIssuesLimit", () => $35da250daae5206d$export$abdbea56d86b4aac);
$parcel$export(module.exports, "useIssueContextStoreChildIssuesIssueLimitUrls", () => $35da250daae5206d$export$326ff2b963d51c5c);
$parcel$export(module.exports, "useIssueContextStoreIssueKey", () => $35da250daae5206d$export$44bcaaabb74e402b);
$parcel$export(module.exports, "useIssueContextStoreIssueId", () => $35da250daae5206d$export$332dcee0cf9f4e45);
$parcel$export(module.exports, "useIssueContextStoreIsArchived", () => $35da250daae5206d$export$c940355b1fc6e1c4);
$parcel$export(module.exports, "useIssueContextStoreIsClassifyEditEnabled", () => $35da250daae5206d$export$b9eebaa1da421997);
$parcel$export(module.exports, "useIssueContextStoreIsModal", () => $35da250daae5206d$export$daa47fd600e43a32);
$parcel$export(module.exports, "useIssueContextStoreViewScreenId", () => $35da250daae5206d$export$ba2e9546ab5ba6f);
$parcel$export(module.exports, "useIssueContextStoreAnalyticsSource", () => $35da250daae5206d$export$74d38d6c437efc1b);
$parcel$export(module.exports, "useIssueContextRapidViewMap", () => $35da250daae5206d$export$2092528ee170d9e7);
$parcel$export(module.exports, "useIssueContextStoreMaxTokenLength", () => $35da250daae5206d$export$57898374e6239a5a);
$parcel$export(module.exports, "useIssueContextStoreIsLoadedWithPage", () => $35da250daae5206d$export$ff0264ec4c015dc1);
$parcel$export(module.exports, "useIssueContextStoreEstimationStatistic", () => $35da250daae5206d$export$6c8b81f6dca8c23d);
$parcel$export(module.exports, "useIssueContextStoreIsLoading", () => $35da250daae5206d$export$fe7085456138f0fc);
$parcel$export(module.exports, "useIssueContextStoreViewMode", () => $35da250daae5206d$export$c339e36468c12443);
$parcel$export(module.exports, "useIssueContextStoreBackButtonUrl", () => $35da250daae5206d$export$ef3bfa2642bb98cd);
$parcel$export(module.exports, "useIssueContextStoreIssueNavigatorData", () => $35da250daae5206d$export$8accd063c74cd455);
$parcel$export(module.exports, "useIssueContextStoreBoardId", () => $35da250daae5206d$export$e7edffc2a20027e7);
$parcel$export(module.exports, "useIssueContextStoreBoardType", () => $35da250daae5206d$export$48aaa3a6bc2085d7);
$parcel$export(module.exports, "useIssueContextStoreIsSpaEnabled", () => $35da250daae5206d$export$4a4b96bcf5166327);
$parcel$export(module.exports, "useIssueContextStoreLoginRedirctUrl", () => $35da250daae5206d$export$bbd8ba0180545556);
$parcel$export(module.exports, "useIssueContextStoreOnIssueKeyChange", () => $35da250daae5206d$export$aaa89627762c7d00);
$parcel$export(module.exports, "useIssueContextStoreRapidViewId", () => $35da250daae5206d$export$796589b0ec52848a);
$parcel$export(module.exports, "useIssueContextIsAiEnabledForIssue", () => $35da250daae5206d$export$455ae7fd9d68b157);
$parcel$export(module.exports, "useIssueTypeName", () => $35da250daae5206d$export$ec3ac562fe41f8db);
$parcel$export(module.exports, "useIssueHierarchyLevel", () => $35da250daae5206d$export$c998d5da56eeedf0);
$parcel$export(module.exports, "IssueContextContainer", () => $35da250daae5206d$export$93db6a8f3342dddf);
$parcel$export(module.exports, "useIssueContextStoreActions", () => $35da250daae5206d$export$965360ae27fcae98);

var $g5X3G = parcelRequire("g5X3G");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $fMAcJ = parcelRequire("fMAcJ");

var $iElCl = parcelRequire("iElCl");

var $edJtc = parcelRequire("edJtc");
const $35da250daae5206d$export$d4c72bab9d6cc13a = {
    childIssuesLimit: undefined,
    childIssuesIssueLimitUrls: undefined,
    issueKey: (0, $g5X3G.toIssueKey)(''),
    isArchived: false,
    isClassifyEditEnabled: false,
    isModal: false,
    maxTokenLength: 0,
    isLoadedWithPage: false,
    rapidViewMap: undefined,
    estimationStatistic: undefined,
    isLoading: false,
    // initialise viewMode with the value stored in local storage
    viewMode: (0, $edJtc.getViewModeFromLocalStorage)(),
    previousViewMode: (0, $edJtc.getPreviousViewModeFromLocalStorage)(),
    analyticsSource: undefined,
    backButtonUrl: undefined,
    issueNavigatorData: undefined,
    boardId: undefined,
    boardType: undefined,
    isSpaEnabled: false,
    loginRedirectUrl: undefined,
    onIssueKeyChange: undefined,
    rapidViewId: undefined,
    viewScreenId: undefined,
    isAiOptInEnabled: false,
    isAiEnabledForIssue: false,
    issueHierarchyLevel: undefined,
    issueType: undefined
};
const $35da250daae5206d$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'issue-context',
    initialState: $35da250daae5206d$export$d4c72bab9d6cc13a,
    actions: $fMAcJ.actions
});
const $35da250daae5206d$var$getIssueContext = (state)=>state;
const $35da250daae5206d$var$getIsModal = (state)=>state.isModal;
const $35da250daae5206d$var$getIssueKey = (state)=>state.issueKey;
const $35da250daae5206d$var$getIsArchived = (state)=>state.isArchived;
const $35da250daae5206d$var$getIsClassifyEditEnabled = (state)=>state.isClassifyEditEnabled;
const $35da250daae5206d$var$getIssueId = (state)=>state.issueId;
// @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
const $35da250daae5206d$var$getAnalyticsSource = (state)=>state.analyticsSource !== undefined ? state.analyticsSource : undefined;
const $35da250daae5206d$var$getRapidViewMap = (state)=>state.rapidViewMap;
const $35da250daae5206d$var$getMaxTokenLength = (state)=>state.maxTokenLength;
const $35da250daae5206d$var$getIsLoadedWithPage = (state)=>state.isLoadedWithPage;
const $35da250daae5206d$var$getEstimationStatistic = (state)=>state.estimationStatistic;
const $35da250daae5206d$var$getIsLoading = (state)=>state.isLoading;
const $35da250daae5206d$var$getViewMode = (state)=>state.viewMode;
const $35da250daae5206d$var$getPreviousViewMode = (state)=>state.previousViewMode;
const $35da250daae5206d$var$getBackButtonUrl = (state)=>state.backButtonUrl;
const $35da250daae5206d$var$getIssueNavigatorData = (state)=>state.issueNavigatorData;
const $35da250daae5206d$var$getBoardId = (state)=>state.boardId;
const $35da250daae5206d$var$getBoardType = (state)=>state.boardType;
const $35da250daae5206d$var$getIsSpaEnabled = (state)=>state.isSpaEnabled;
const $35da250daae5206d$var$getLoginRedirectUrl = (state)=>state.loginRedirectUrl;
const $35da250daae5206d$var$getOnIssueKeyChange = (state)=>state.onIssueKeyChange;
const $35da250daae5206d$var$getRapidViewId = (state)=>state.rapidViewId;
const $35da250daae5206d$var$getViewScreenId = (state)=>state.viewScreenId;
const $35da250daae5206d$var$getIsAiOptInEnabled = (state)=>Boolean(state.isAiOptInEnabled);
const $35da250daae5206d$var$getisAiEnabledForIssue = (state)=>Boolean(state.isAiEnabledForIssue);
const $35da250daae5206d$var$getIssueTypeName = (state)=>state.issueType;
const $35da250daae5206d$var$getIssueHierarchyLevel = (state)=>state.issueHierarchyLevel;
const $35da250daae5206d$export$f6e0a3ee03299fbc = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIssueContext
});
const $35da250daae5206d$export$abdbea56d86b4aac = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: (0, $iElCl.getChildIssuesLimit)
});
const $35da250daae5206d$export$326ff2b963d51c5c = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: (0, $iElCl.getChildIssuesIssueLimitUrls)
});
const $35da250daae5206d$export$44bcaaabb74e402b = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIssueKey
});
const $35da250daae5206d$export$332dcee0cf9f4e45 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIssueId
});
const $35da250daae5206d$export$c940355b1fc6e1c4 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIsArchived
});
const $35da250daae5206d$export$b9eebaa1da421997 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIsClassifyEditEnabled
});
const $35da250daae5206d$export$daa47fd600e43a32 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIsModal
});
const $35da250daae5206d$export$ba2e9546ab5ba6f = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getViewScreenId
});
const $35da250daae5206d$export$74d38d6c437efc1b = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getAnalyticsSource
});
const $35da250daae5206d$export$2092528ee170d9e7 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getRapidViewMap
});
const $35da250daae5206d$export$57898374e6239a5a = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getMaxTokenLength
});
const $35da250daae5206d$export$ff0264ec4c015dc1 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIsLoadedWithPage
});
const $35da250daae5206d$export$6c8b81f6dca8c23d = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getEstimationStatistic
});
const $35da250daae5206d$export$fe7085456138f0fc = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIsLoading
});
const $35da250daae5206d$export$c339e36468c12443 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getViewMode
});
const $35da250daae5206d$export$1473982989cfd8bf = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getPreviousViewMode
});
const $35da250daae5206d$export$ef3bfa2642bb98cd = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getBackButtonUrl
});
const $35da250daae5206d$export$8accd063c74cd455 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIssueNavigatorData
});
const $35da250daae5206d$export$e7edffc2a20027e7 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getBoardId
});
const $35da250daae5206d$export$48aaa3a6bc2085d7 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getBoardType
});
const $35da250daae5206d$export$4a4b96bcf5166327 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIsSpaEnabled
});
const $35da250daae5206d$export$bbd8ba0180545556 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getLoginRedirectUrl
});
const $35da250daae5206d$export$aaa89627762c7d00 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getOnIssueKeyChange
});
const $35da250daae5206d$export$796589b0ec52848a = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getRapidViewId
});
const $35da250daae5206d$export$7e70ee570119a0a7 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIsAiOptInEnabled
});
const $35da250daae5206d$export$455ae7fd9d68b157 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getisAiEnabledForIssue
});
const $35da250daae5206d$export$ec3ac562fe41f8db = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIssueTypeName
});
const $35da250daae5206d$export$c998d5da56eeedf0 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIssueHierarchyLevel
});
const $35da250daae5206d$export$93db6a8f3342dddf = (0, $gg7kZ.createContainer)($35da250daae5206d$export$6f57813fe9f31bf9);
const $35da250daae5206d$export$965360ae27fcae98 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("fMAcJ", function(module, exports) {

$parcel$export(module.exports, "actions", () => $043cabfbcc6107f0$export$e324594224ef24da);

var $7l48d = parcelRequire("7l48d");

var $iElCl = parcelRequire("iElCl");

var $edJtc = parcelRequire("edJtc");
const $043cabfbcc6107f0$export$784a03c4b74da53e = (issueContext)=>({ setState: setState, getState: getState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !issueContext.issueId && issueContext.issueKey !== currentIssueKey) setState({
            ...issueContext,
            issueId: undefined,
            viewMode: issueContext.viewMode || getState().viewMode
        });
        else setState({
            ...issueContext,
            viewMode: issueContext.viewMode || getState().viewMode
        });
    };
const $043cabfbcc6107f0$export$666ee48e0eaf4f13 = (partialIssueContext)=>({ getState: getState, setState: setState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !partialIssueContext.issueId && partialIssueContext.issueKey && partialIssueContext.issueKey !== currentIssueKey) setState({
            ...getState(),
            ...partialIssueContext,
            issueId: undefined
        });
        else setState({
            ...getState(),
            ...partialIssueContext
        });
    };
const $043cabfbcc6107f0$export$89b6937a83edcaa6 = ()=>({ getState: getState })=>(0, $iElCl.getChildIssuesLimit)(getState());
const $043cabfbcc6107f0$export$e40f2acaf1a50b00 = ()=>({ getState: getState })=>getState().maxTokenLength;
const $043cabfbcc6107f0$export$2fe981b90be13483 = ()=>({ getState: getState })=>getState().isLoadedWithPage;
const $043cabfbcc6107f0$export$afce556782490aae = ()=>({ getState: getState })=>getState().backButtonUrl;
const $043cabfbcc6107f0$export$711dfa096bf81f2d = ()=>({ getState: getState })=>getState().isSpaEnabled;
const $043cabfbcc6107f0$export$4a030f6192bebe03 = ()=>({ getState: getState })=>getState().issueKey;
const $043cabfbcc6107f0$export$b41341ac6c74ca6 = ()=>({ getState: getState })=>getState().isArchived;
const $043cabfbcc6107f0$export$77ec0de2f63f10c4 = (willSave = true)=>({ setState: setState })=>{
        if (willSave) (0, $7l48d.localStorage).set((0, $7l48d.VIEW_MODE_STORAGE_KEY), 'MODAL');
        setState({
            viewMode: 'MODAL'
        });
    };
const $043cabfbcc6107f0$export$b303af51de56a0e = (willSave = true)=>({ setState: setState })=>{
        if (willSave) (0, $7l48d.localStorage).set((0, $7l48d.VIEW_MODE_STORAGE_KEY), 'SIDEBAR');
        setState({
            viewMode: 'SIDEBAR'
        });
    };
const $043cabfbcc6107f0$export$19d65a0fcbb4ad9e = (willSave = true)=>({ getState: getState, setState: setState })=>{
        if (willSave) {
            (0, $7l48d.localStorage).set((0, $7l48d.VIEW_MODE_STORAGE_KEY), 'FULL_SCREEN_MODAL');
            (0, $7l48d.localStorage).set((0, $7l48d.PREVIOUS_VIEW_MODE_STORAGE_KEY), getState().viewMode);
        }
        setState({
            viewMode: 'FULL_SCREEN_MODAL',
            previousViewMode: getState().viewMode
        });
    };
const $043cabfbcc6107f0$export$ee359474c5820bf = (willSave = true)=>({ getState: getState, setState: setState })=>{
        const previousViewMode = getState().previousViewMode;
        if (willSave) {
            (0, $7l48d.localStorage).set((0, $7l48d.VIEW_MODE_STORAGE_KEY), previousViewMode);
            // Clear the previous view mode since we've restored it
            (0, $7l48d.localStorage).remove((0, $7l48d.PREVIOUS_VIEW_MODE_STORAGE_KEY));
        }
        setState({
            viewMode: previousViewMode,
            previousViewMode: undefined
        });
    };
const $043cabfbcc6107f0$export$75007d125f198b78 = ()=>({ setState: setState })=>{
        setState({
            viewMode: (0, $edJtc.getViewModeFromLocalStorage)()
        });
    };
const $043cabfbcc6107f0$export$e324594224ef24da = {
    setIssueContext: $043cabfbcc6107f0$export$784a03c4b74da53e,
    mergeIssueContext: $043cabfbcc6107f0$export$666ee48e0eaf4f13,
    getChildIssuesLimit: $043cabfbcc6107f0$export$89b6937a83edcaa6,
    getMaxTokenLength: $043cabfbcc6107f0$export$e40f2acaf1a50b00,
    getIsLoadedWithPage: $043cabfbcc6107f0$export$2fe981b90be13483,
    getBackButtonUrl: $043cabfbcc6107f0$export$afce556782490aae,
    getIsSpaEnabled: $043cabfbcc6107f0$export$711dfa096bf81f2d,
    getIssueKey: $043cabfbcc6107f0$export$4a030f6192bebe03,
    getIsArchived: $043cabfbcc6107f0$export$b41341ac6c74ca6,
    setDetailViewAsModal: $043cabfbcc6107f0$export$77ec0de2f63f10c4,
    setDetailViewAsSidebar: $043cabfbcc6107f0$export$b303af51de56a0e,
    resetDetailView: $043cabfbcc6107f0$export$75007d125f198b78,
    setDetailViewAsExpandedModal: $043cabfbcc6107f0$export$19d65a0fcbb4ad9e,
    setDetailViewAsCollapsedModal: $043cabfbcc6107f0$export$ee359474c5820bf
};

});
parcelRegister("7l48d", function(module, exports) {

$parcel$export(module.exports, "LOG_LOCATION", () => $e736233a6ed098e3$export$25a759e49d5049db);
$parcel$export(module.exports, "localStorage", () => $e736233a6ed098e3$export$c2ed3351cac403d1);
$parcel$export(module.exports, "VIEW_MODE_STORAGE_KEY", () => $e736233a6ed098e3$export$a13f7f627010bccd);
$parcel$export(module.exports, "PREVIOUS_VIEW_MODE_STORAGE_KEY", () => $e736233a6ed098e3$export$c2cda7684022695d);

var $bSSG7 = parcelRequire("bSSG7");
const $e736233a6ed098e3$export$25a759e49d5049db = 'issue.issue-context-service';
const $e736233a6ed098e3$export$c2ed3351cac403d1 = (0, $bSSG7.createLocalStorageProvider)('jira_issue_view');
const $e736233a6ed098e3$export$a13f7f627010bccd = 'view-mode';
const $e736233a6ed098e3$export$c2cda7684022695d = 'previous-view-mode';

});

parcelRegister("iElCl", function(module, exports) {

$parcel$export(module.exports, "getChildIssuesLimit", () => $fde75c94a28741e3$export$89b6937a83edcaa6);
$parcel$export(module.exports, "getChildIssuesIssueLimitUrls", () => $fde75c94a28741e3$export$8f43520910e8128c);

var $2YZCu = parcelRequire("2YZCu");

var $7l48d = parcelRequire("7l48d");
// This is here solely as a last resort option if the backend for some reason
// is unable to propagate the limit. Or if somehow the code that populates
// this store is broken.
// 500 is the current limit reflected in the backend at the time of writing.
const $fde75c94a28741e3$var$FALLBACK_CHILD_ISSUES_LIMIT = 500;
const $fde75c94a28741e3$var$getFallbackChildIssuesLimitAndLogAsUnexpected = ()=>{
    (0, $2YZCu.default).safeErrorWithoutCustomerData(`${(0, $7l48d.LOG_LOCATION)}.selectors.getChildIssuesLimit`, 'The child issues limit is undefined using the fallback child issues limit');
    return $fde75c94a28741e3$var$FALLBACK_CHILD_ISSUES_LIMIT;
};
const $fde75c94a28741e3$export$89b6937a83edcaa6 = (state)=>state.childIssuesLimit ?? $fde75c94a28741e3$var$getFallbackChildIssuesLimitAndLogAsUnexpected();
const $fde75c94a28741e3$export$8f43520910e8128c = (state)=>state.childIssuesIssueLimitUrls;

});

parcelRegister("edJtc", function(module, exports) {

$parcel$export(module.exports, "getViewModeFromLocalStorage", () => $75ce4ce78f606e67$export$cae7c4c591dcc261);
$parcel$export(module.exports, "getPreviousViewModeFromLocalStorage", () => $75ce4ce78f606e67$export$d32761230a2a17ad);

var $7l48d = parcelRequire("7l48d");
const $75ce4ce78f606e67$export$cae7c4c591dcc261 = ()=>{
    if (false) return 'DEFAULT';
    return (0, $7l48d.localStorage).get((0, $7l48d.VIEW_MODE_STORAGE_KEY)) || 'DEFAULT';
};
const $75ce4ce78f606e67$export$d32761230a2a17ad = ()=>{
    if (false) return 'DEFAULT';
    return (0, $7l48d.localStorage).get((0, $7l48d.PREVIOUS_VIEW_MODE_STORAGE_KEY)) || 'DEFAULT';
};

});




const $31848aa9a0db89de$export$a763454c55d057f2 = 'jira.user.issue.clickthrough-banner.lastinteracted';
const $31848aa9a0db89de$export$8c6b5c30f78ab338 = 'jira.user.issue.changeboarding.lastinteracted';
const $31848aa9a0db89de$export$5530d4ea250d4125 = 'jira.user.issue.attachment.view';
const $31848aa9a0db89de$export$a274dca8eb47fc4a = 'jira.user.issue.sidebar.resize-ratio';
const $31848aa9a0db89de$export$4c9f7f9f8a4000e1 = 'jira.user.issue.filter.hide-done-subtasks';
const $31848aa9a0db89de$export$2cf981c493d79a21 = 'jira.user.issue.details.activity-layout-setting';
const $31848aa9a0db89de$export$39aaf586c7ee5202 = 'jira.user.issue.user-preferred-layouts';
const $31848aa9a0db89de$export$25f5ee1223725a65 = 'jira.user.issue.comment-summaries.enabled';
const $31848aa9a0db89de$export$4936b1621439c095 = 'jira.user.issue.details.details-panel-fields-order';
const $31848aa9a0db89de$export$1a08240e14f65aa = 'jira.user.issue.collapsible-sections-state';
const $31848aa9a0db89de$export$32a0b5eafccd5141 = 'jira.user.issue.comment-slack-flag.dismissed';

parcelRegister("kI4MM", function(module, exports) {

$parcel$export(module.exports, "useIssueLayoutContainersStore", () => $189406269e224200$export$5c4a1f63cea7b5b3);
$parcel$export(module.exports, "useIssueLayoutGlanceStore", () => $189406269e224200$export$769bbe2bda9a43ce);
$parcel$export(module.exports, "useIssueLayoutContextPanelStore", () => $189406269e224200$export$3aa9017e11451546);
$parcel$export(module.exports, "useIssueLayoutActionsStore", () => $189406269e224200$export$5513f3c310d101f5);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $kjjoM = parcelRequire("kjjoM");
const $189406269e224200$var$STABLE_EMPTY_CONTAINER_ARRAY = [];
const $189406269e224200$var$getIssueViewLayoutContainers = (state, issueKey)=>state[String(issueKey)]?.containers || $189406269e224200$var$STABLE_EMPTY_CONTAINER_ARRAY;
const $189406269e224200$var$getIssueViewLayoutGlance = (state, issueKey)=>state[String(issueKey)]?.glance;
const $189406269e224200$var$getIssueViewLayoutContextPanel = (state, issueKey)=>state[String(issueKey)]?.contextPanel;
const $189406269e224200$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'issue-view-layout-service',
    initialState: {},
    actions: $kjjoM
});
const $189406269e224200$export$5c4a1f63cea7b5b3 = (0, $3sQ5x.createHook)($189406269e224200$export$6f57813fe9f31bf9, {
    selector: $189406269e224200$var$getIssueViewLayoutContainers
});
const $189406269e224200$export$769bbe2bda9a43ce = (0, $3sQ5x.createHook)($189406269e224200$export$6f57813fe9f31bf9, {
    selector: $189406269e224200$var$getIssueViewLayoutGlance
});
const $189406269e224200$export$3aa9017e11451546 = (0, $3sQ5x.createHook)($189406269e224200$export$6f57813fe9f31bf9, {
    selector: $189406269e224200$var$getIssueViewLayoutContextPanel
});
const $189406269e224200$export$5513f3c310d101f5 = (0, $3sQ5x.createHook)($189406269e224200$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("kjjoM", function(module, exports) {

$parcel$export(module.exports, "setIssueViewContainersLayout", () => $09c52f32f4231bd8$export$e956c64a7167b73a);
$parcel$export(module.exports, "setIssueViewLayoutGlance", () => $09c52f32f4231bd8$export$6a9b24c2efe66bb7);
$parcel$export(module.exports, "setIssueViewLayoutContextPanel", () => $09c52f32f4231bd8$export$9a04e4b958ebc410);
const $09c52f32f4231bd8$export$e956c64a7167b73a = (issueKey, containersByType)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                containers: containersByType?.containers || []
            }
        });
    };
const $09c52f32f4231bd8$export$6a9b24c2efe66bb7 = (issueKey, glance)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                glance: glance
            }
        });
    };
const $09c52f32f4231bd8$export$9a04e4b958ebc410 = (issueKey, contextPanel)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                contextPanel: contextPanel
            }
        });
    };

});


parcelRegister("cNJ33", function(module, exports) {

$parcel$export(module.exports, "getLayoutItemId", () => $0c6b6ff40aad7732$export$fec1c0749fa149f4);
$parcel$export(module.exports, "filterOutItemsWithProvidedIds", () => $0c6b6ff40aad7732$export$355607dae809ec65);

var $41gqO = parcelRequire("41gqO");
const $0c6b6ff40aad7732$export$fec1c0749fa149f4 = (layoutItem)=>{
    switch(layoutItem.type){
        case (0, $41gqO.layoutContainerItemTypes).field:
            return layoutItem.fieldItemId;
        case (0, $41gqO.layoutContainerItemTypes).panel:
            return layoutItem.panelItemId;
        case (0, $41gqO.layoutContainerItemTypes).tab:
            return layoutItem.tabContainerId;
        default:
            return layoutItem.id;
    }
};
const $0c6b6ff40aad7732$export$355607dae809ec65 = (items, idsToBeFilteredOut)=>{
    const filteredOutIdsSet = new Set(idsToBeFilteredOut);
    return items// Filter out items with the provided Ids
    .filter((item)=>!filteredOutIdsSet.has($0c6b6ff40aad7732$export$fec1c0749fa149f4(item)))// Filter out items with the provided Ids nested in the container tab items
    .map((item)=>{
        if (item.type === (0, $41gqO.layoutContainerItemTypes).tab && item.items?.nodes) return {
            ...item,
            items: {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                nodes: $0c6b6ff40aad7732$export$355607dae809ec65(item.items.nodes, idsToBeFilteredOut)
            }
        };
        return item;
    });
};

});
parcelRegister("41gqO", function(module, exports) {

$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $b08b2795aecf222d$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $b08b2795aecf222d$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $b08b2795aecf222d$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "FORGE_CONTEXT_TYPE", () => $b08b2795aecf222d$export$be8e68fb1aed253e);
$parcel$export(module.exports, "CONTEXT_AREA", () => $b08b2795aecf222d$export$7bf561e6ab380ea1);
$parcel$export(module.exports, "CONTENT_AREA", () => $b08b2795aecf222d$export$f42c11634d75863e);
$parcel$export(module.exports, "CONTENT_REQUEST_AREA", () => $b08b2795aecf222d$export$b38842736b6dbc1d);
$parcel$export(module.exports, "REACT_KEY_SUMMARY", () => $b08b2795aecf222d$export$605c43f1b33ab69);
$parcel$export(module.exports, "CUSTOM_ITEM_TYPE", () => $b08b2795aecf222d$export$e655b77b9efe622f);
$parcel$export(module.exports, "layoutContainerItemTypes", () => $b08b2795aecf222d$export$5507f31126c8b283);
$parcel$export(module.exports, "isLayoutContainerTabItem", () => $b08b2795aecf222d$export$ad3536b13febb432);
const $b08b2795aecf222d$export$99ad62164189f781 = 'ecosystemGlance';
const $b08b2795aecf222d$export$7719ef6e9283671 = 'forgeGlance';
const $b08b2795aecf222d$export$bfebea5ce2e1887a = 'ecosystemContext';
const $b08b2795aecf222d$export$be8e68fb1aed253e = 'forgeContext';
const $b08b2795aecf222d$export$7bf561e6ab380ea1 = 'context';
const $b08b2795aecf222d$export$f42c11634d75863e = 'content';
const $b08b2795aecf222d$export$b38842736b6dbc1d = 'content-request';
const $b08b2795aecf222d$export$bc9fa2d93b5fabae = 'FIELD';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$STATUS_TYPE = 'STATUS';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$TAB_TYPE = 'TAB';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$PANEL_TYPE = 'PANEL';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$ECOSYSTEM_TYPE = 'ECOSYSTEM';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$FORGE_TYPE = 'FORGE';
const $b08b2795aecf222d$export$605c43f1b33ab69 = 'SUMMARY';
const $b08b2795aecf222d$export$e655b77b9efe622f = 'CustomItem';
const $b08b2795aecf222d$export$5cf403de05e9bea = 'FieldSectionItem';
const $b08b2795aecf222d$export$30f7f9a86f182492 = 'TabLayout';
const $b08b2795aecf222d$export$196e597ad9a97f7a = 'PanelSectionItem';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$ECOSYSTEM_SECTION_ITEM = 'EcosystemSectionItem';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$FORGE_SECTION_ITEM = 'ForgeSectionItem';
const $b08b2795aecf222d$export$5507f31126c8b283 = {
    field: 'JiraIssueItemFieldItem',
    panel: 'JiraIssueItemPanelItem',
    tab: 'JiraIssueItemTabContainer'
};
const $b08b2795aecf222d$export$ad3536b13febb432 = (node)=>node.type === $b08b2795aecf222d$export$5507f31126c8b283.tab;

});



parcelRegister("hhMVP", function(module, exports) {

$parcel$export(module.exports, "getCachedIsCompactValue", () => $cd61c7d28b4f2500$export$c47621d55d10906c);
$parcel$export(module.exports, "setCachedIsCompactValue", () => $cd61c7d28b4f2500$export$568b2dd75c2027b4);
$parcel$export(module.exports, "invalidateCacheIfRouteChanged", () => $cd61c7d28b4f2500$export$a81477a3594bcaab);
// Cleared on window refresh, unique to each window
const $cd61c7d28b4f2500$var$cachedIsCompactValues = {};
let $cd61c7d28b4f2500$var$previousRouteKey;
function $cd61c7d28b4f2500$export$c47621d55d10906c(key) {
    return $cd61c7d28b4f2500$var$cachedIsCompactValues[key];
}
function $cd61c7d28b4f2500$export$568b2dd75c2027b4(isCompactValue, key) {
    $cd61c7d28b4f2500$var$cachedIsCompactValues[key] = isCompactValue;
}
function $cd61c7d28b4f2500$export$a81477a3594bcaab(currentRouteKey) {
    // If we navigate away from the route we can't assume that the cached value will stay valid when we come back
    if (currentRouteKey !== $cd61c7d28b4f2500$var$previousRouteKey) {
        $cd61c7d28b4f2500$var$previousRouteKey = currentRouteKey;
        delete $cd61c7d28b4f2500$var$cachedIsCompactValues[$cd61c7d28b4f2500$var$previousRouteKey];
    }
}

});


parcelRegister("3441h", function(module, exports) {
module.exports = new URL("issue-app-skeleton.tpl.e425fdce.svg", import.meta.url).toString();

});


parcelRegister("lAGdd", function(module, exports) {

$parcel$export(module.exports, "aiContextPanelResource", () => $f43677b290bdf8ab$export$8f6224974184ed8d);
$parcel$export(module.exports, "aiContextPanelResourceWithDependencies", () => $f43677b290bdf8ab$export$70559c909620e4ed);
$parcel$export(module.exports, "getAIContextPanelResources", () => $f43677b290bdf8ab$export$d5bd1af2f373eac4);

var $2M1hQ = parcelRequire("2M1hQ");

var $4R6GH = parcelRequire("4R6GH");


var $3RV1W = parcelRequire("3RV1W");

var $6s1PB = parcelRequire("6s1PB");


var $es0wa = parcelRequire("es0wa");

var $1b0RC = parcelRequire("1b0RC");

var $l9pCw = parcelRequire("l9pCw");

var $3kPby = parcelRequire("3kPby");

var $70Yef = parcelRequire("70Yef");
const $f43677b290bdf8ab$var$SUPPORTED_PRACTICES = new Set([
    (0, $b78738e839898752$export$a364d86306d4a6d4),
    (0, $b78738e839898752$export$31ffe79c2b019cf)
]);
const $f43677b290bdf8ab$var$fireSSRExperimentExposureIfRequired = ()=>{
    const notEnrolled = 'not-enrolled';
    const [config, fireExposure] = (0, $6s1PB.UNSAFE_noExposureExp)('ssr_service_context_panel_dependencies');
    const cohort = config.get('cohort', notEnrolled);
    if (cohort !== notEnrolled) fireExposure();
};
const $f43677b290bdf8ab$export$8f6224974184ed8d = (0, $2M1hQ.createResource)({
    type: (0, $aaf4ae2608fd2c06$export$57128ea4767a7885),
    getKey: ({ match: match })=>{
        const issueKey = match.params.issueKey || '';
        return `aiContextPanelResource-${issueKey}`;
    },
    getData: async (routerDataContext, resourceStoreContext)=>{
        const { skipChecks: skipChecks, issueKey: issueKey } = routerDataContext.match.params;
        let { issueId: issueId, practice: practice, projectId: projectId } = routerDataContext.match.params;
        const { cloudId: cloudId, locale: locale } = resourceStoreContext.tenantContext;
        if (!issueKey) return null;
        if (skipChecks !== '1') {
            // The suggestions panel is available only on service-desk.
            // Hence filtering them out to reduce the number of calls to AGG and features APIs
            if (!(0, $3RV1W.checkLicense)(resourceStoreContext.tenantContext, 'servicedesk') || !(0, $4R6GH.fg)('jsm_issue_view_ai_context')) return null;
            const issueDetails = await (0, $3kPby.getIssueDetails)(issueKey, cloudId, (0, $4R6GH.fg)('context_panel_state_in_issue_details'));
            const isAIEnabled = issueDetails.isAIEnabled;
            issueId = issueDetails.issueId;
            projectId = issueDetails.projectId;
            practice = issueDetails.practice;
            if (!isAIEnabled || !$f43677b290bdf8ab$var$SUPPORTED_PRACTICES.has(practice)) return null;
            let isAIContextPanelDisabled;
            if ((0, $4R6GH.fg)('context_panel_state_in_issue_details')) isAIContextPanelDisabled = !issueDetails.isAiContextFeatureEnabled;
            else {
                const featureState = await (0, $70Yef.getFeatureState)(routerDataContext, resourceStoreContext);
                isAIContextPanelDisabled = featureState?.['jsm-ai-context']?.status === (0, $b78738e839898752$export$8cd212c10b4124d2);
            }
            if (isAIContextPanelDisabled) return null;
        }
        if (!issueId) throw new Error('AI context service panel resource cannot be loaded without an issueId');
        if (practice === (0, $b78738e839898752$export$a364d86306d4a6d4)) {
            $f43677b290bdf8ab$var$fireSSRExperimentExposureIfRequired();
            return (0, $1b0RC.getServiceSuggestionData)(issueId, cloudId);
        }
        if (practice === (0, $b78738e839898752$export$31ffe79c2b019cf) && (0, $4R6GH.fg)('jsm_issue_view_ai_context_ops')) {
            if (!projectId) throw new Error('AI context ops panel resource cannot be loaded without a projectId');
            return (0, $l9pCw.getIncidentSuggestionEndpoint)({
                cloudId: cloudId,
                issueId: issueId,
                projectId: projectId,
                locale: locale
            });
        }
        return null;
    },
    maxAge: 0,
    isBrowserOnly: true
});
const $f43677b290bdf8ab$export$70559c909620e4ed = (0, $2M1hQ.createResource)({
    type: (0, $aaf4ae2608fd2c06$export$38f892c32d281e99),
    getKey: ({ match: match })=>{
        const issueKey = match.params.issueKey || '';
        return `aiContextPanelResourceWithDependencies-${issueKey}`;
    },
    getData: async (routerDataContext, resourceStoreContext)=>{
        const { issueKey: issueKey } = routerDataContext.match.params;
        let { issueId: issueId, practice: practice, projectId: projectId } = routerDataContext.match.params;
        const { cloudId: cloudId, locale: locale } = resourceStoreContext.tenantContext;
        if (!issueKey) return null;
        if (!(0, $3RV1W.checkLicense)(resourceStoreContext.tenantContext, 'servicedesk') || !(0, $4R6GH.fg)('jsm_issue_view_ai_context')) return null;
        let issueDetails = (0, $es0wa.getDependencyData)(routerDataContext.dependencies, (0, $aaf4ae2608fd2c06$export$3e1b459cf14e5bcd));
        if (issueDetails instanceof Promise) issueDetails = await issueDetails;
        const { isAIEnabled: isAIEnabled, isAiContextFeatureEnabled: isAiContextFeatureEnabled } = issueDetails;
        issueId = issueDetails.issueId;
        projectId = issueDetails.projectId;
        practice = issueDetails.practice;
        if (!isAIEnabled || !$f43677b290bdf8ab$var$SUPPORTED_PRACTICES.has(practice) || !isAiContextFeatureEnabled) return null;
        if (!issueId) throw new Error('AI context service panel resource cannot be loaded without an issueId');
        if (practice === (0, $b78738e839898752$export$a364d86306d4a6d4)) {
            $f43677b290bdf8ab$var$fireSSRExperimentExposureIfRequired();
            return (0, $1b0RC.getServiceSuggestionData)(issueId, cloudId);
        }
        if (practice === (0, $b78738e839898752$export$31ffe79c2b019cf) && (0, $4R6GH.fg)('jsm_issue_view_ai_context_ops')) {
            if (!projectId) throw new Error('AI context ops panel resource cannot be loaded without a projectId');
            return (0, $l9pCw.getIncidentSuggestionEndpoint)({
                cloudId: cloudId,
                issueId: issueId,
                projectId: projectId,
                locale: locale
            });
        }
        return null;
    },
    maxAge: 0,
    depends: [
        (0, $aaf4ae2608fd2c06$export$3e1b459cf14e5bcd)
    ],
    isBrowserOnly: true
});
const $f43677b290bdf8ab$export$d5bd1af2f373eac4 = ()=>{
    const [config] = (0, $6s1PB.UNSAFE_noExposureExp)('ssr_service_context_panel_dependencies');
    const useSSRDependency = config.get('useSSRDependency', false);
    return useSSRDependency ? [
        (0, $3kPby.contextPanelIssueDetailsResource),
        $f43677b290bdf8ab$export$70559c909620e4ed
    ] : [
        $f43677b290bdf8ab$export$8f6224974184ed8d
    ];
};

});
const $b78738e839898752$export$b45a36df7873757 = 'alerts';
const $b78738e839898752$export$a7952c5a5c371ddd = 'oncall';
const $b78738e839898752$export$de0bca182bc46c7f = 'services';
const $b78738e839898752$export$ed849d1eb34423e5 = 'similarIssues';
const $b78738e839898752$export$d4a1ed8524773042 = 'sentiment-analysis';
const $b78738e839898752$export$46f600f4680e5fd0 = 'jsm-ai-context';
const $b78738e839898752$export$3d2ce10d3ca55e3c = 'automaticallySetRequestType';
const $b78738e839898752$export$cae2404f62c0f4d7 = 'change-management';
const $b78738e839898752$export$31ffe79c2b019cf = 'incident-management';
const $b78738e839898752$export$3a20074cc38cbf69 = 'problem-management';
const $b78738e839898752$export$a364d86306d4a6d4 = 'service-request';
const $b78738e839898752$export$71f1a79e03f525 = 'post-incident-review';
const $b78738e839898752$export$6860c7a26d6d6d35 = 'csm-customer-context';
const $b78738e839898752$export$7c5ee80fcb40e9d3 = 'developer-escalation';
const $b78738e839898752$export$28fc94ee6c61f632 = 'products-and-entitlements';
const $b78738e839898752$export$93b42272f76473c9 = 'jsm-views';
const $b78738e839898752$export$1eb399d8c2d53748 = 'jsm-board';
const $b78738e839898752$export$abbcecf25bfa1e87 = 'jsm-calendar';
const $b78738e839898752$export$891877b4a4d60ea2 = 'jsm-project-summary';
const $b78738e839898752$export$34136c6420474672 = 'journey-builder';
const $b78738e839898752$export$66ede2c1de447f8f = 'developer-escalation';
const $b78738e839898752$export$1ee9c534405b9b35 = 'playbooks';
const $b78738e839898752$export$ac0832132e8992d7 = 'automation-discoverability';
const $b78738e839898752$export$fc77e86331b0e2c7 = 'jcs-customer-support-escalation';
const $b78738e839898752$export$e927a5d1b72f0b68 = 'ENABLED';
const $b78738e839898752$export$8cd212c10b4124d2 = 'DISABLED';

parcelRegister("3RV1W", function(module, exports) {

$parcel$export(module.exports, "checkLicense", () => $6334356fa938c5d8$export$fe2591be8b7e59ce);
$parcel$export(module.exports, "LicenseCheck", () => $6334356fa938c5d8$export$944be0b3bf2a6feb);

var $5uXOq = parcelRequire("5uXOq");

var $9OXo1 = parcelRequire("9OXo1");
const $6334356fa938c5d8$var$appPermissionMapper = {
    software: 'hasSoftwareAccess',
    servicedesk: 'hasServiceDeskAccess',
    customerservice: 'hasCustomerServiceAccess'
};
const $6334356fa938c5d8$export$fe2591be8b7e59ce = (tenantContext, type)=>Boolean(tenantContext.appPermissions && tenantContext.appPermissions[$6334356fa938c5d8$var$appPermissionMapper[type]]);
const $6334356fa938c5d8$export$944be0b3bf2a6feb = ({ children: children, type: type })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        const result = $6334356fa938c5d8$export$fe2591be8b7e59ce(tenantContext, type);
        return children({
            result: result
        });
    });

});

const $aaf4ae2608fd2c06$export$3e1b459cf14e5bcd = 'CONTEXT_PANEL_ISSUE_DETAILS';
const $aaf4ae2608fd2c06$export$57128ea4767a7885 = 'AI-CONTEXT-PANEL-RESOURCE-TYPE';
const $aaf4ae2608fd2c06$export$38f892c32d281e99 = 'AI-CONTEXT-PANEL-RESOURCE-TYPE-WITH-DEPENDENCIES';

parcelRegister("es0wa", function(module, exports) {

$parcel$export(module.exports, "getDependencyData", () => $2a613be27365c40e$export$c1f67084c4ca42af);

var $jthxb = parcelRequire("jthxb");
const $2a613be27365c40e$export$c1f67084c4ca42af = (dependencies, key)=>{
    if (dependencies[key]?.loading || dependencies[key]?.error) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $jthxb.consumeDependency)(dependencies, key);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return dependencies[key]?.data;
};

});

parcelRegister("1b0RC", function(module, exports) {

$parcel$export(module.exports, "getServiceSuggestionData", () => $ea3750099e69bfcf$export$afab700af9f021de);

var $eusud = parcelRequire("eusud");

var $4R6GH = parcelRequire("4R6GH");

var $9pxAu = parcelRequire("9pxAu");

var $jgbuq = parcelRequire("jgbuq");
const $ea3750099e69bfcf$export$d8192485ee52671b = (issueId)=>`/gateway/api/firebolt/1/context-panel/${issueId}`;
const $ea3750099e69bfcf$export$afab700af9f021de = (issueId, cloudId)=>{
    if ((0, $4R6GH.fg)('context-panel-graphql-migration')) return (0, $jgbuq.getContextPanelSuggestions)(cloudId, issueId);
    const url = $ea3750099e69bfcf$export$d8192485ee52671b(issueId);
    return (0, $eusud.performGetRequest)(url).then((0, $9pxAu.transformData));
};

});
parcelRegister("9pxAu", function(module, exports) {

$parcel$export(module.exports, "transformContent", () => $2284df78f056e7a3$export$b7cb80c25ebba28e);
$parcel$export(module.exports, "parseAdf", () => $2284df78f056e7a3$export$5659c60045974de9);
$parcel$export(module.exports, "transformData", () => $2284df78f056e7a3$export$3ceb62baab058c6b);
const $2284df78f056e7a3$export$b7cb80c25ebba28e = (content)=>{
    return {
        title: $2284df78f056e7a3$export$5659c60045974de9(content.title),
        description: $2284df78f056e7a3$export$5659c60045974de9(content.description)
    };
};
const $2284df78f056e7a3$export$3ceb62baab058c6b = (data)=>({
        type: 'ServicePanelSuggestions',
        summary: $2284df78f056e7a3$export$5659c60045974de9(data.summary),
        reporterDetails: $2284df78f056e7a3$export$5659c60045974de9(data.reporterDetails),
        nextSteps: $2284df78f056e7a3$export$5659c60045974de9(data.nextSteps),
        suggestedEscalation: $2284df78f056e7a3$export$5659c60045974de9(data.suggestedEscalation),
        suggestedActions: data.suggestedActions ? data.suggestedActions.map((action)=>{
            switch(action.type){
                case 'priority':
                    return {
                        type: action.type,
                        context: {
                            ...action.context,
                            suggestion: action.context.suggestion
                        },
                        content: $2284df78f056e7a3$export$b7cb80c25ebba28e(action.content)
                    };
                case 'comment':
                    return {
                        type: action.type,
                        context: {
                            ...action.context,
                            suggestion: action.context.suggestion
                        },
                        content: $2284df78f056e7a3$export$b7cb80c25ebba28e(action.content)
                    };
                case 'assignee':
                default:
                    return {
                        type: action.type,
                        context: {
                            ...action.context,
                            suggestion: action.context.suggestion
                        },
                        content: $2284df78f056e7a3$export$b7cb80c25ebba28e(action.content)
                    };
            }
        }) : []
    });
const $2284df78f056e7a3$export$5659c60045974de9 = (adfString)=>{
    if (!adfString) return null;
    try {
        return JSON.parse(adfString);
    } catch (_error) {
        return null;
    }
};

});

parcelRegister("jgbuq", function(module, exports) {

$parcel$export(module.exports, "getContextPanelSuggestions", () => $614a29b5470e1123$export$715f8fbc08922943);

var $jBcqv = parcelRequire("jBcqv");

var $8Uumt = parcelRequire("8Uumt");

var $5yJb9 = parcelRequire("5yJb9");

var $5Wobd = parcelRequire("5Wobd");

var $8dJMO = parcelRequire("8dJMO");
const $614a29b5470e1123$var$OPERATION_NAME = 'graphqlContextPanelQuery';
const $614a29b5470e1123$var$contextPanelQuery = (0, $jBcqv.default);
const $614a29b5470e1123$export$715f8fbc08922943 = async (cloudId, issueId)=>{
    (0, $5Wobd.startCapturingTraceIds)($614a29b5470e1123$var$OPERATION_NAME);
    const graphQLResponse = await (0, $8Uumt.fetchQuery)((0, $5yJb9.default)(), $614a29b5470e1123$var$contextPanelQuery, {
        cloudId: cloudId,
        issueId: issueId
    }).toPromise().then((data)=>{
        const traceIds = (0, $5Wobd.getTraceIds)($614a29b5470e1123$var$OPERATION_NAME);
        return (0, $8dJMO.handleGraphQLresponse)(data, traceIds);
    }).catch((error)=>{
        const traceIds = (0, $5Wobd.getTraceIds)($614a29b5470e1123$var$OPERATION_NAME);
        return (0, $8dJMO.handleGraphQLError)(error, traceIds);
    }).finally(()=>{
        (0, $5Wobd.stopCapturingTraceIds)($614a29b5470e1123$var$OPERATION_NAME);
    });
    return graphQLResponse;
};

});
parcelRegister("jBcqv", function(module, exports) {

$parcel$export(module.exports, "default", () => $86d8b2900debf159$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2f2296a9e4dc5a9c7f87482d4e72080a>>
 * @relayHash 0b817e9b59a520de5e2b21a42b9e7287
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3ac1cbc7f10f7aad403db10ad5ca17c4a01fbe5bf5350fef6f4eaabc1d3faaf9
const $86d8b2900debf159$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "issueId",
            "variableName": "issueId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "summary"
            },
            {
                "kind": "ScalarField",
                "name": "nextSteps"
            },
            {
                "kind": "ScalarField",
                "name": "reporterDetails"
            },
            {
                "kind": "ScalarField",
                "name": "suggestedEscalation"
            },
            {
                "concreteType": "AgentAISuggestAction",
                "kind": "LinkedField",
                "name": "suggestedActions",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "concreteType": "AgentAISuggestedActionContent",
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "title"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "description"
                            }
                        ]
                    },
                    {
                        "concreteType": "AgentAISuggestedActionContext",
                        "kind": "LinkedField",
                        "name": "context",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "fieldId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "fieldType"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "fieldName"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "suggestion"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "AgentAIContextPanelResponse"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v6 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "graphqlContextPanelQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "agentAI_contextPanel",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "QueryError"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "graphqlContextPanelQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "agentAI_contextPanel",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "QueryError"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3ac1cbc7f10f7aad403db10ad5ca17c4a01fbe5bf5350fef6f4eaabc1d3faaf9",
            "metadata": {},
            "name": "graphqlContextPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$86d8b2900debf159$var$node.hash = "b52c73d190e18f743ff20687e5b2ced0";
var $86d8b2900debf159$export$2e2bcd8739ae039 = $86d8b2900debf159$var$node;

});

parcelRegister("8dJMO", function(module, exports) {

$parcel$export(module.exports, "handleGraphQLresponse", () => $6716e474dac9243a$export$f09fdc2e4ab145a5);
$parcel$export(module.exports, "handleGraphQLError", () => $6716e474dac9243a$export$3af48ada790caea5);
/* eslint-disable jira/import-whitelist */ 
var $dO0aE = parcelRequire("dO0aE");

var $9pxAu = parcelRequire("9pxAu");
const $6716e474dac9243a$export$716425a07890b235 = (graphQLResponse, traceIds)=>{
    const data = graphQLResponse?.agentAI_contextPanel?.__typename === 'AgentAIContextPanelResponse' ? graphQLResponse?.agentAI_contextPanel : null;
    return {
        type: 'ServicePanelSuggestions',
        traceIds: traceIds,
        summary: (0, $9pxAu.parseAdf)(data?.summary),
        reporterDetails: (0, $9pxAu.parseAdf)(data?.reporterDetails),
        nextSteps: (0, $9pxAu.parseAdf)(data?.nextSteps),
        suggestedEscalation: (0, $9pxAu.parseAdf)(data?.suggestedEscalation),
        suggestedActions: data?.suggestedActions ? data?.suggestedActions?.map((action)=>({
                type: action.type,
                context: {
                    ...action.context,
                    suggestion: action.context?.suggestion
                },
                content: (0, $9pxAu.transformContent)(action?.content)
            })) : []
    };
};
const $6716e474dac9243a$export$f09fdc2e4ab145a5 = (graphQLResponse, traceIds)=>{
    const responseType = graphQLResponse?.agentAI_contextPanel?.__typename;
    if (responseType === 'AgentAIContextPanelResponse') return $6716e474dac9243a$export$716425a07890b235(graphQLResponse, traceIds);
    if (responseType === 'QueryError') {
        const errorMessage = graphQLResponse?.agentAI_contextPanel?.message ?? 'Unknown error';
        const errorStatus = graphQLResponse?.agentAI_contextPanel?.extensions?.[0]?.statusCode ?? 500;
        throw new (0, $dO0aE.FetchError)(errorStatus, `Error processing graphQL query: ${errorMessage}`, traceIds?.[0]);
    }
    throw new (0, $dO0aE.FetchError)(500, 'Failed to fetch data from AGG', traceIds?.[0]);
};
const $6716e474dac9243a$export$3af48ada790caea5 = (error, traceIds)=>{
    throw new (0, $dO0aE.FetchError)(500, `Failed to fetch data from AGG : ${error?.message}`, traceIds?.[0]);
};

});
parcelRegister("dO0aE", function(module, exports) {

$parcel$export(module.exports, "FetchError", () => $7345e390d0c3a088$export$26e841bcf1aeb894);
$parcel$export(module.exports, "ResponseNullError", () => $7345e390d0c3a088$export$895e385291c3b753);
/* eslint-disable max-classes-per-file */ class $7345e390d0c3a088$var$ExtensibleError extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message, options){
        super(message, options);
        this.message = message;
        this.name = this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        else this.stack = new Error(message).stack;
    }
}
class $7345e390d0c3a088$export$26e841bcf1aeb894 extends $7345e390d0c3a088$var$ExtensibleError {
    constructor(statusCode, message, traceId){
        super(message == null ? `Fetch call failed with status code: ${statusCode}` : message), this.graphQLErrors = [];
        this.name = 'FetchError';
        this.statusCode = statusCode;
        this.networkError = {
            statusCode: statusCode
        };
        this.skipSentry = true;
        if (traceId != null) this.traceId = traceId;
    }
}
class $7345e390d0c3a088$export$895e385291c3b753 extends $7345e390d0c3a088$var$ExtensibleError {
    constructor(message){
        super(message);
        this.name = 'ResponseNullError';
        this.skipSentry = true;
    }
}

});




parcelRegister("l9pCw", function(module, exports) {

$parcel$export(module.exports, "getIncidentSuggestionEndpoint", () => $b39b696aeaf00873$export$32b63803a24bceaa);

var $7f4tk = parcelRequire("7f4tk");

var $6s1PB = parcelRequire("6s1PB");

var $1p8cH = parcelRequire("1p8cH");
const $b39b696aeaf00873$export$db19de3f154d9918 = ({ cloudId: cloudId, issueId: issueId, projectId: projectId, locale: locale })=>`/gateway/api/jsm/aiops/cloudId/${cloudId}/api/v1/incident-suggestion/${issueId}?projectId=${projectId}&locale=${locale}
`;
const $b39b696aeaf00873$export$32b63803a24bceaa = (reqParams)=>{
    const url = $b39b696aeaf00873$export$db19de3f154d9918(reqParams);
    return (0, $7f4tk.default)(url, {
        method: 'GET'
    }).then((0, $6s1PB.expVal)('aiops_context_panel_ui_update_experiment', 'isEnabled', false) ? (0, $1p8cH.transformResponseV2) : (0, $1p8cH.transformResponse));
};

});
parcelRegister("1p8cH", function(module, exports) {

$parcel$export(module.exports, "transformResponse", () => $e2c7d231fb0d2d58$export$3361e9be8093ddcc);
$parcel$export(module.exports, "transformResponseV2", () => $e2c7d231fb0d2d58$export$deb8fcf4bacae588);
// Resource doesn't allow imports of getEmptyADF();
const $e2c7d231fb0d2d58$var$EMPTY_DOCUMENT = {
    version: 1,
    type: 'doc',
    content: []
};
const $e2c7d231fb0d2d58$var$parseToADF = (adfString)=>{
    try {
        return JSON.parse(adfString);
    } catch (error) {
        return $e2c7d231fb0d2d58$var$EMPTY_DOCUMENT;
    }
};
const $e2c7d231fb0d2d58$var$transformContent = (content)=>{
    return {
        title: $e2c7d231fb0d2d58$var$parseToADF(content.title),
        description: $e2c7d231fb0d2d58$var$parseToADF(content.description)
    };
};
const $e2c7d231fb0d2d58$var$transformMultipleSectionContent = (content)=>{
    return {
        title: $e2c7d231fb0d2d58$var$parseToADF(content.title),
        description: $e2c7d231fb0d2d58$var$parseToADF(content.description),
        descriptionList: content.descriptionList ? content.descriptionList.map((suggestion)=>({
                id: suggestion.id,
                description: $e2c7d231fb0d2d58$var$parseToADF(suggestion.description)
            })) : []
    };
};
const $e2c7d231fb0d2d58$var$exhaustiveCheck = (_)=>null;
const $e2c7d231fb0d2d58$export$3361e9be8093ddcc = (response)=>{
    return {
        type: 'OpsPanelSuggestions',
        incidentSummary: {
            ...response.incidentSummary.content,
            description: $e2c7d231fb0d2d58$var$parseToADF(response.incidentSummary.content.description)
        },
        probableRCA: response.probableRCA?.content ? {
            ...response.probableRCA.content,
            description: $e2c7d231fb0d2d58$var$parseToADF(response.probableRCA.content.description)
        } : null,
        suggestedActions: response.suggestedActions.map((action)=>{
            switch(action.type){
                case 'SEVERITY':
                    return {
                        ...action,
                        context: {
                            ...action.context,
                            suggestion: {
                                ...action.context.suggestion,
                                value: action.context.suggestion.name
                            }
                        },
                        content: $e2c7d231fb0d2d58$var$transformContent(action.content)
                    };
                case 'AFFECTED_SERVICES':
                    return {
                        ...action,
                        context: {
                            ...action.context,
                            suggestion: action.context.suggestion.map((service)=>({
                                    id: service.id,
                                    name: service.name,
                                    data: service
                                }))
                        },
                        content: $e2c7d231fb0d2d58$var$transformContent(action.content)
                    };
                case 'PROBLEM_TICKET':
                case 'MAJOR_INCIDENT':
                case 'PRIORITY':
                case 'RESPONDERS':
                case 'RCA_WITH_AUTOMATION':
                    return {
                        ...action,
                        content: $e2c7d231fb0d2d58$var$transformContent(action.content)
                    };
                default:
                    return $e2c7d231fb0d2d58$var$exhaustiveCheck(action);
            }
        }).filter(Boolean)
    };
};
const $e2c7d231fb0d2d58$export$deb8fcf4bacae588 = (response)=>{
    return {
        type: 'OpsPanelSuggestions',
        incidentSummary: {
            ...response.incidentSummary.content,
            description: $e2c7d231fb0d2d58$var$parseToADF(response.incidentSummary.content.description)
        },
        probableRCA: response.probableRCA?.content ? {
            ...response.probableRCA.content,
            description: $e2c7d231fb0d2d58$var$parseToADF(response.probableRCA.content.description)
        } : null,
        suggestedActions: response.suggestedActions.map((action)=>{
            switch(action.type){
                case 'SEVERITY':
                    return {
                        ...action,
                        context: {
                            ...action.context,
                            suggestion: {
                                ...action.context.suggestion,
                                value: action.context.suggestion.name
                            }
                        },
                        content: $e2c7d231fb0d2d58$var$transformContent(action.content)
                    };
                case 'AFFECTED_SERVICES':
                    return {
                        ...action,
                        context: {
                            ...action.context,
                            suggestion: action.context.suggestion.map((service)=>({
                                    id: service.id,
                                    name: service.name,
                                    data: service
                                }))
                        },
                        content: $e2c7d231fb0d2d58$var$transformMultipleSectionContent(action.content)
                    };
                case 'PROBLEM_TICKET':
                    return {
                        ...action,
                        context: action.context,
                        content: $e2c7d231fb0d2d58$var$transformContent(action.content)
                    };
                case 'MAJOR_INCIDENT':
                    return {
                        ...action,
                        context: action.context,
                        content: $e2c7d231fb0d2d58$var$transformContent(action.content)
                    };
                case 'PRIORITY':
                    return {
                        ...action,
                        context: action.context,
                        content: $e2c7d231fb0d2d58$var$transformContent(action.content)
                    };
                case 'RESPONDERS':
                    return {
                        ...action,
                        context: action.context,
                        content: $e2c7d231fb0d2d58$var$transformMultipleSectionContent(action.content)
                    };
                case 'RCA_WITH_AUTOMATION':
                    return {
                        ...action,
                        content: $e2c7d231fb0d2d58$var$transformContent(action.content)
                    };
                case 'ASSIGNEE':
                    return {
                        ...action,
                        context: action.context,
                        content: $e2c7d231fb0d2d58$var$transformMultipleSectionContent(action.content)
                    };
                default:
                    return $e2c7d231fb0d2d58$var$exhaustiveCheck(action);
            }
        }).filter(Boolean)
    };
};

});


parcelRegister("3kPby", function(module, exports) {

$parcel$export(module.exports, "getIssueDetails", () => $c64e867b4dbdc4a9$export$da0733c355d205d6);
$parcel$export(module.exports, "contextPanelIssueDetailsResource", () => $c64e867b4dbdc4a9$export$626ce3b2cb7fb94e);

var $4ytlu = parcelRequire("4ytlu");

var $8Uumt = parcelRequire("8Uumt");

var $5yJb9 = parcelRequire("5yJb9");

var $dGrdR = parcelRequire("dGrdR");

var $2M1hQ = parcelRequire("2M1hQ");

const $c64e867b4dbdc4a9$var$ISSUE_DETAILS_AGG_METRIC = 'context-panel-issue-details-agg';
const $c64e867b4dbdc4a9$var$issueDetailsAggMetric = (0, $dGrdR.metrics).custom({
    key: $c64e867b4dbdc4a9$var$ISSUE_DETAILS_AGG_METRIC
});
const $c64e867b4dbdc4a9$export$da0733c355d205d6 = async (issueKey, cloudId, includeContextPanelState = false)=>{
    $c64e867b4dbdc4a9$var$issueDetailsAggMetric.start();
    const issueDetails = await (0, $8Uumt.fetchQuery)((0, $5yJb9.default)(), (0, $4ytlu.default), {
        issueKey: issueKey,
        cloudId: cloudId,
        includeContextPanelState: includeContextPanelState
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise().then((data)=>{
        $c64e867b4dbdc4a9$var$issueDetailsAggMetric.stop();
        return data;
    }).catch((e)=>{
        $c64e867b4dbdc4a9$var$issueDetailsAggMetric.cancel();
        throw e;
    });
    return {
        issueId: issueDetails?.jira?.issueByKey?.issueId ?? undefined,
        practice: issueDetails?.jira?.issueByKey?.fieldByIdOrAlias?.text ?? undefined,
        projectId: issueDetails?.jira?.issueByKey?.projectField?.project?.projectId ?? undefined,
        isAIEnabled: issueDetails?.jira?.issueByKey?.projectField?.project?.isAIEnabled ?? undefined,
        ...includeContextPanelState && {
            isAiContextFeatureEnabled: issueDetails?.jira?.issueByKey?.projectField?.project?.isAiContextFeatureEnabled ?? undefined
        }
    };
};
const $c64e867b4dbdc4a9$export$626ce3b2cb7fb94e = (0, $2M1hQ.createResource)({
    type: (0, $aaf4ae2608fd2c06$export$3e1b459cf14e5bcd),
    getKey: ({ match: match })=>{
        const issueKey = match.params.issueKey || '';
        return `contextPanelIssueDetailsResource-${issueKey}`;
    },
    getData: async ({ match: match }, { tenantContext: tenantContext })=>{
        const issueKey = match.params.issueKey;
        const cloudId = tenantContext.cloudId;
        if (!issueKey) throw new Error('Context service issue details cannot be loaded without an issueKey');
        return $c64e867b4dbdc4a9$export$da0733c355d205d6(issueKey, cloudId, true);
    },
    maxAge: 3600000
});

});
parcelRegister("4ytlu", function(module, exports) {

$parcel$export(module.exports, "default", () => $84805cad546fc546$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<97b1ac959a33600e23b69a5ece8a9862>>
 * @relayHash f0aba673194e9058619abb300a99e877
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4deac53f2aeea0fe5f4fcf151ec1117fd3c5e9ae76d076f740f109cf10a9df74
const $84805cad546fc546$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeContextPanelState"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "issueKey"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v5 = [
        {
            "kind": "Literal",
            "name": "idOrAlias",
            "value": "servicedesk-practices"
        }
    ], v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "text"
            }
        ],
        "type": "JiraSingleLineTextField"
    }, v7 = {
        "kind": "ScalarField",
        "name": "isAIEnabled"
    }, v8 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v9 = {
        "condition": "includeContextPanelState",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isAiContextFeatureEnabled"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueDetailsForAIContextPanelQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "args": v5 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "fieldByIdOrAlias",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ 
                                    ],
                                    "storageKey": "fieldByIdOrAlias(idOrAlias:\"servicedesk-practices\")"
                                },
                                {
                                    "concreteType": "JiraProjectField",
                                    "kind": "LinkedField",
                                    "name": "projectField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "issueDetailsForAIContextPanelQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "args": v5 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "fieldByIdOrAlias",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v6 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ],
                                    "storageKey": "fieldByIdOrAlias(idOrAlias:\"servicedesk-practices\")"
                                },
                                {
                                    "concreteType": "JiraProjectField",
                                    "kind": "LinkedField",
                                    "name": "projectField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ 
                                            ]
                                        },
                                        v10 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4deac53f2aeea0fe5f4fcf151ec1117fd3c5e9ae76d076f740f109cf10a9df74",
            "metadata": {},
            "name": "issueDetailsForAIContextPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$84805cad546fc546$var$node.hash = "31378fdb45b287b152e0f480c90e621a";
var $84805cad546fc546$export$2e2bcd8739ae039 = $84805cad546fc546$var$node;

});


parcelRegister("70Yef", function(module, exports) {

$parcel$export(module.exports, "getFeatureState", () => $8817fa0932717f4c$export$c8c54cead17ad7fa);
// eslint-disable-next-line jira/import-whitelist

var $dGrdR = parcelRequire("dGrdR");

var $frQmB = parcelRequire("frQmB");
const $8817fa0932717f4c$var$FEATURE_STATE_METRIC = 'context-panel-feature-states';
const $8817fa0932717f4c$var$featureStateMetric = (0, $dGrdR.metrics).custom({
    key: $8817fa0932717f4c$var$FEATURE_STATE_METRIC
});
const $8817fa0932717f4c$export$c8c54cead17ad7fa = (routerDataContext, resourceStoreContext)=>{
    $8817fa0932717f4c$var$featureStateMetric.start();
    return (0, $frQmB.featuresResource)(routerDataContext, resourceStoreContext)?.then((data)=>{
        $8817fa0932717f4c$var$featureStateMetric.stop();
        return data;
    }).catch((e)=>{
        $8817fa0932717f4c$var$featureStateMetric.cancel();
        throw e;
    });
};

});
parcelRegister("frQmB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "transformRestData", () => $3a8e348215e4bd89$export$40da6ae06b8b332e);
$parcel$export(module.exports, "featuresResource", () => $3a8e348215e4bd89$export$16f81cc9da2c6c47);
$parcel$export(module.exports, "default", () => $3a8e348215e4bd89$export$2e2bcd8739ae039);

var $9XE6b = parcelRequire("9XE6b");

var $x9xyg = parcelRequire("x9xyg");

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $8PRuf = parcelRequire("8PRuf");

var $iR3GG = parcelRequire("iR3GG");

var $1nb22 = parcelRequire("1nb22");

var $9NiTW = parcelRequire("9NiTW");
const $3a8e348215e4bd89$export$40da6ae06b8b332e = (data)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    data.reduce((acc, { feature: feature, status: status, editable: editable })=>Object.assign(acc, {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [feature]: {
                status: status,
                editable: editable
            }
        }), {});
const $3a8e348215e4bd89$var$getFeatures = async (baseUrl, projectKey)=>{
    try {
        const data = await (0, $7f4tk.default)(`/rest/servicedesk/1/servicedesk/${projectKey}/features`);
        (0, $x9xyg.setMark)((0, $8PRuf.prefetchApiReadyMark));
        return $3a8e348215e4bd89$export$40da6ae06b8b332e(data);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jiraServicedeskPracticeFeaturesResource', error);
        (0, $jcw0u.default)({
            meta: {
                id: 'jiraServicedeskPracticeFeaturesResource',
                packageName: 'jiraSpa'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $3a8e348215e4bd89$export$16f81cc9da2c6c47 = ({ match: match, query: query }, { tenantContext: tenantContext })=>{
    const { params: params } = match;
    if (!(0, $9NiTW.checkAuthentication)(tenantContext)) throw (0, $iR3GG.createResourceError)({
        component: 'spa.view.routes.servicedesk.features.getData',
        message: 'Current user is not authenticated',
        name: 'AuthenticationError',
        skipSentry: true
    });
    // projectKey from url path or issueKey
    const projectKey = (0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(params, 'issueKey', '')?.split('-')[0];
    if (projectKey == null) return null;
    return $3a8e348215e4bd89$var$getFeatures(tenantContext.baseUrl, projectKey);
};
var $3a8e348215e4bd89$export$2e2bcd8739ae039 = $3a8e348215e4bd89$export$16f81cc9da2c6c47;

});



parcelRegister("7bHMy", function(module, exports) {

$parcel$export(module.exports, "projectGlobalComponentsResource", () => $3744a548180a29bd$export$d2cb7067a31cf873);

var $2M1hQ = parcelRequire("2M1hQ");

var $1nb22 = parcelRequire("1nb22");

var $jSMJu = parcelRequire("jSMJu");
const $3744a548180a29bd$export$be79e0677801e96e = 'PROJECT_GLOBAL_COMPONENTS';
const $3744a548180a29bd$export$d2cb7067a31cf873 = (0, $2M1hQ.createResource)({
    type: $3744a548180a29bd$export$be79e0677801e96e,
    getKey: (matchedRoute)=>(0, $1nb22.getProjectIdOrKey)(matchedRoute.match, matchedRoute.query),
    getData: (...args)=>(0, $jSMJu.getData)(...args)
});

});
parcelRegister("jSMJu", function(module, exports) {

$parcel$export(module.exports, "getData", () => $1db0f1fd3df49120$export$7a171f172be0782e);

var $1nb22 = parcelRequire("1nb22");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $1db0f1fd3df49120$export$7a171f172be0782e = async (matchedRoute, _)=>{
    const projectIdOrKey = (0, $1nb22.getProjectIdOrKey)(matchedRoute.match, matchedRoute.query);
    if (projectIdOrKey == null || projectIdOrKey === '') return null;
    return $1db0f1fd3df49120$export$1db3503600a1638e(projectIdOrKey);
};
const $1db0f1fd3df49120$var$GLOBAL_COMPONENTS_PROPERTY_KEY = 'jira.global.components';
// Default projectKey regex, source: https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-api/src/main/java/com/atlassian/jira/util/JiraKeyUtils.java#421
const $1db0f1fd3df49120$var$PROJECT_KEY_REGEX = /^[A-Z][A-Z]+$/;
const $1db0f1fd3df49120$var$url = (projectIdOrKey, entityKey)=>`/rest/api/3/project/${projectIdOrKey}/properties/${entityKey}`;
const $1db0f1fd3df49120$var$getProjectId = async (projectKey)=>{
    const project = await (0, $eusud.performGetRequest)(`/rest/api/3/project/${projectKey}`);
    return project?.id;
};
const $1db0f1fd3df49120$export$1db3503600a1638e = async (projectKey)=>{
    try {
        let endpoint;
        if (!$1db0f1fd3df49120$var$PROJECT_KEY_REGEX.test(projectKey)) {
            // We need to fetch the project id here because some users have malformed project keys that are not compatible with the project properties endpoint
            const projectId = await $1db0f1fd3df49120$var$getProjectId(projectKey);
            if (!projectId) return {
                key: $1db0f1fd3df49120$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
                value: null
            };
            endpoint = $1db0f1fd3df49120$var$url(projectId, $1db0f1fd3df49120$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        } else endpoint = $1db0f1fd3df49120$var$url(projectKey, $1db0f1fd3df49120$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        return await (0, $eusud.performGetRequest)(endpoint);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // The endpoint returns 404 if the project property is not set, but we don't treat it as an
        // actual error
        if (error.statusCode === 404) return {
            key: $1db0f1fd3df49120$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
            value: null
        };
        (0, $jcw0u.default)({
            meta: {
                id: 'getGlobalComponentsProperty',
                packageName: 'jiraCompassCommon',
                teamName: 'compass-lodestone'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                projectKey: projectKey
            }
        });
        throw error;
    }
};

});


parcelRegister("2dmpO", function(module, exports) {

$parcel$export(module.exports, "conditionalForgeResource", () => $f8439f5067be62dd$export$64ecc3d62be6b4bf);
$parcel$export(module.exports, "getUnusedRouteResources", () => $f8439f5067be62dd$export$a8ad2004cacc1137);
$parcel$export(module.exports, "removeNonCritialGiraCallFromCriticalPath", () => $f8439f5067be62dd$export$b398e8f4bdfdca6);
$parcel$export(module.exports, "getUnusedEmbedRouteResources", () => $f8439f5067be62dd$export$5776b3711dd897da);
$parcel$export(module.exports, "LazyIssuePage", () => $f8439f5067be62dd$export$3e1d7c9fee0b1f1a);
$parcel$export(module.exports, "IssueComponent", () => $f8439f5067be62dd$export$c1a868ace2f38803);
$parcel$export(module.exports, "IssueEmbedComponent", () => $f8439f5067be62dd$export$ef02bcc0eb1d9ded);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $7DqiA = parcelRequire("7DqiA");

var $93Yeu = parcelRequire("93Yeu");

var $dAfqg = parcelRequire("dAfqg");

var $lNicp = parcelRequire("lNicp");

var $l2N2a = parcelRequire("l2N2a");

var $bmvW5 = parcelRequire("bmvW5");

var $eqN9Q = parcelRequire("eqN9Q");

var $jdjBW = parcelRequire("jdjBW");

var $1WlLE = parcelRequire("1WlLE");

var $gNStA = parcelRequire("gNStA");

var $lGGIs = parcelRequire("lGGIs");

var $5j7Th = parcelRequire("5j7Th");

var $5CPDv = parcelRequire("5CPDv");

var $kxZPA = parcelRequire("kxZPA");

var $7tQej = parcelRequire("7tQej");
var $bmKPg = parcelRequire("bmKPg");

var $lCj8l = parcelRequire("lCj8l");
const $f8439f5067be62dd$export$64ecc3d62be6b4bf = (0, $gNStA.resourceWithCondition2)(()=>!(0, $4R6GH.fg)('move_forge_data_fetch_to_main_issue_agg'), (0, $5CPDv.issueForgeDataResource));
const $f8439f5067be62dd$export$a8ad2004cacc1137 = ()=>(0, $4R6GH.fg)('issue_view_remove_unused_route_resources') ? [] : [
        (0, $jdjBW.issueMediaUserAuthResource),
        (0, $bmvW5.issueMediaReadPermissionResource),
        (0, $eqN9Q.issueMediaUploadPermissionResource)
    ];
const $f8439f5067be62dd$export$b398e8f4bdfdca6 = ()=>(0, $4R6GH.fg)('move_iv_noncriticalgiraquery_out_of_critical_path') ? [] : [
        (0, $lCj8l.issueGiraNonCriticalDataResource)
    ];
const $f8439f5067be62dd$export$5776b3711dd897da = ()=>(0, $4R6GH.fg)('issue_view_remove_unused_route_resources') ? // eslint-disable-next-line camelcase
    [
        (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource)
    ] : [
        ...(0, $lNicp.getBusinessProjectResources)(),
        (0, $1WlLE.queuesNavigationItems),
        (0, $jdjBW.issueMediaUserAuthResource),
        (0, $bmvW5.issueMediaReadPermissionResource),
        (0, $eqN9Q.issueMediaUploadPermissionResource)
    ];

const $f8439f5067be62dd$export$3e1d7c9fee0b1f1a = (0, $kxZPA.lazyForPaint)(()=>(0, $lGGIs.markAsBentoBundleReady)(// chunk name here MUST be kept in sync with TempLazyIssuePageWithSsrAlwaysDisabled below
    (parcelRequire("kg2oj"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/issue/src/index.tsx"
});
const $f8439f5067be62dd$export$c1a868ace2f38803 = ()=>{
    const { data: data } = (0, $dAfqg.useProjectContext)();
    const [issueKey] = (0, $bmKPg.usePathParam)('issueKey');
    const pageId = 'spa-issue';
    const [projectKey, issueSuffix] = issueKey !== undefined ? issueKey.split('-') : [];
    let actualIssueKey = issueKey;
    if (data?.projectKey && data.projectKey !== projectKey) actualIssueKey = `${data.projectKey}-${issueSuffix}`;
    // special handling for product discovery (=== Polaris) project issues. During the experimental phase of
    // the polaris idea view (product-specific issue view), we will redirect to a polaris-specific issue view
    // page here instead of bento.
    // this will only happen for issues of this specific project type, and only if the switchover FF is enabled
    if (!false && data?.projectType === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT) && data?.projectKey !== undefined && actualIssueKey !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/jira/polaris/projects/${data.projectKey}/ideas?selectedIssue=${actualIssueKey}`
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f8439f5067be62dd$export$3e1d7c9fee0b1f1a,
        pageId: pageId,
        shouldShowSpinner: false
    });
};
const $f8439f5067be62dd$export$ef02bcc0eb1d9ded = ()=>{
    const [issueKey] = (0, $bmKPg.usePathParam)('issueKey');
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey || '');
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    const projectId = (0, $93Yeu.useProjectId)(projectKey);
    // Special handling for product discovery (=== Polaris) project issues in embed mode.
    // We have to redirect to Polaris issue embed view instead of loading Jira issue view.
    if (projectType === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT) && projectKey !== undefined && projectId !== undefined && issueKey !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/secure/JiraProductDiscoveryEmbedded.jspa?projectId=${projectId}&projectKey=${projectKey}&issueKey=${issueKey}`
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7DqiA.EmbedModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f8439f5067be62dd$export$c1a868ace2f38803, null));
};

});
parcelRegister("7DqiA", function(module, exports) {

$parcel$export(module.exports, "EmbedModeContext", () => $208612f70b1dde3d$export$5eb07b3c7c0b0771);
$parcel$export(module.exports, "EmbedModeProvider", () => $208612f70b1dde3d$export$9daaf42d62e1c430);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");
const $208612f70b1dde3d$export$5eb07b3c7c0b0771 = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
const { Provider: $208612f70b1dde3d$var$Provider } = $208612f70b1dde3d$export$5eb07b3c7c0b0771;
const $208612f70b1dde3d$var$handleEmbedLinkClick = (e)=>{
    // eslint-disable-next-line jira/ff/no-preconditioning
    if ((0, $4R6GH.fg)('jira_nin_smart_link') && (0, $4R6GH.fg)('jsc_nin_smart_link_fast_follows')) {
        if (e.target instanceof Element) {
            const anchor = e.target.closest('a'); // Find closest parent anchor (including the target itself)
            if (anchor && anchor.target !== '_blank') // link
            anchor.target = '_blank';
        }
    } else {
        const eventTarget = e.target;
        if (eventTarget && eventTarget instanceof HTMLAnchorElement && eventTarget.target !== '_blank') // link
        eventTarget.target = '_blank';
    }
};
// When issue view is loaded within an iframe, it needs to follow the proper
// element elevation principles, found here: https://hello.atlassian.net/wiki/spaces/~460573267/pages/2355983526/Jira+Dark+Mode+-+UI+Guidelines#Element-elevation-basics
// Unfortunately the current elevation is set in the global-container, which is loaded before this Provider so
// we have to override the overrider to ensure that the proper elevation is set
const $208612f70b1dde3d$var$DarkModeMonolithStyleOverride = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `
                    #jira-frontend {
                        background: ${"var(--ds-surface-overlay, #FFFFFF)"};
                    }
                `
        }
    });
const $208612f70b1dde3d$export$9daaf42d62e1c430 = ({ children: children })=>{
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('click', $208612f70b1dde3d$var$handleEmbedLinkClick, true);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('click', $208612f70b1dde3d$var$handleEmbedLinkClick);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($208612f70b1dde3d$var$DarkModeMonolithStyleOverride, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($208612f70b1dde3d$var$Provider, {
        value: true
    }, children));
};

});

parcelRegister("bmvW5", function(module, exports) {

$parcel$export(module.exports, "issueMediaReadPermissionResource", () => $2368cab4ab12a1eb$export$3b5744f70b49a5c4);

var $2M1hQ = parcelRequire("2M1hQ");

var $5XgeZ = parcelRequire("5XgeZ");
const $2368cab4ab12a1eb$export$3b5744f70b49a5c4 = (0, $2M1hQ.createResource)((0, $5XgeZ.withResourceEarlyData)({
    type: 'ISSUE_MEDIA_READ_PERM',
    getKey: ({ match: match })=>match && match.params && match.params.issueKey !== undefined && match.params.issueKey !== null ? match.params.issueKey : '',
    getData: ()=>null,
    isBrowserOnly: true
}));

});

parcelRegister("eqN9Q", function(module, exports) {

$parcel$export(module.exports, "issueMediaUploadPermissionResource", () => $018bbab5966993b0$export$80c2a5c658bd9e1e);

var $2Yhep = parcelRequire("2Yhep");

var $2M1hQ = parcelRequire("2M1hQ");

var $5XgeZ = parcelRequire("5XgeZ");
const $018bbab5966993b0$export$80c2a5c658bd9e1e = (0, $2M1hQ.createResource)((0, $5XgeZ.withResourceEarlyData)({
    type: 'ISSUE_MEDIA_UPLOAD_PERM',
    getKey: ({ match: match })=>{
        const issueKey = (0, $2Yhep.getIssueKey)(match);
        return issueKey || '';
    },
    getData: ()=>null,
    isBrowserOnly: true
}));

});

parcelRegister("jdjBW", function(module, exports) {

$parcel$export(module.exports, "issueMediaUserAuthResource", () => $c6e148d80f21d036$export$48db4eb29e9be72c);

var $2Yhep = parcelRequire("2Yhep");

var $2M1hQ = parcelRequire("2M1hQ");

var $5XgeZ = parcelRequire("5XgeZ");
const $c6e148d80f21d036$export$48db4eb29e9be72c = (0, $2M1hQ.createResource)((0, $5XgeZ.withResourceEarlyData)({
    type: 'ISSUE_MEDIA_USER_AUTH',
    getKey: ({ match: match })=>{
        const issueKey = (0, $2Yhep.getIssueKey)(match);
        return issueKey || '';
    },
    getData: ()=>null,
    isBrowserOnly: true
}));

});

parcelRegister("lGGIs", function(module, exports) {

$parcel$export(module.exports, "markAsBentoBundleReady", () => $7671cdebcdce4d73$export$d9ff0b3329728986);

var $fDtbf = parcelRequire("fDtbf");

var $2SVPM = parcelRequire("2SVPM");
let $7671cdebcdce4d73$var$reportedBentoBundleReady = false;
const $7671cdebcdce4d73$export$d9ff0b3329728986 = (importedBundle)=>{
    if (!false) importedBundle.then(()=>{
        // Mutex for reporter
        if ($7671cdebcdce4d73$var$reportedBentoBundleReady) return;
        $7671cdebcdce4d73$var$reportedBentoBundleReady = true;
        (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('bento.bundle-ready', 'jira-spa.js:eval-stop');
        const resources = performance.getEntriesByType('mark');
        for(let i = resources.length - 1; i >= 0; i -= 1)if (resources[i].name.startsWith('async-issue-app') && resources[i].name.endsWith((0, $fDtbf.JS_EVAL_START))) {
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('bento.eval', resources[i].name);
            break;
        }
    });
    return importedBundle;
};

});

parcelRegister("5CPDv", function(module, exports) {

$parcel$export(module.exports, "issueForgeDataResource", () => $82acf7aa3865e452$export$e28b79684fb81535);

var $2Yhep = parcelRequire("2Yhep");

var $2M1hQ = parcelRequire("2M1hQ");


var $gNStA = parcelRequire("gNStA");

var $6s1PB = parcelRequire("6s1PB");

var $jj8CY = parcelRequire("jj8CY");
const $82acf7aa3865e452$export$e28b79684fb81535 = (0, $gNStA.browserOnlyResourceWithCondition)(()=>{
    if (0, $cdb023d06c7f62fa$export$19d68f5aa485d903) // not "browser only" if FF is on
    return !(0, $6s1PB.expVal)('issue_view_ssr_perf_m2', 'isEnabled', false);
    return true;
}, // eslint-disable-next-line @typescript-eslint/no-explicit-any
(0, $2M1hQ.createResource)({
    type: 'ISSUE_FORGE_DATA',
    getKey: ({ match: match })=>{
        const issueKey = (0, $2Yhep.getIssueKey)(match);
        return issueKey || '';
    },
    getData: (...args)=>(0, $jj8CY.default)(...args),
    isBrowserOnly: true
}));

});
parcelRegister("jj8CY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a39eb6eca9b1263$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $hpuF5 = parcelRequire("hpuF5");

var $iR3GG = parcelRequire("iR3GG");

var $2Yhep = parcelRequire("2Yhep");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3a39eb6eca9b1263$export$2e2bcd8739ae039 = async ({ match: match }, { tenantContext: tenantContext })=>{
    const issueKey = (0, $2Yhep.getIssueKey)(match);
    if (!issueKey) return null;
    try {
        const { cloudId: cloudId, isAnonymous: isAnonymous } = tenantContext;
        const data = await (0, $hpuF5.fetchIssueForgeData)(cloudId, issueKey, isAnonymous);
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $iR3GG.createResourceError)({
            component: 'spa.view.routes.issue-view.forge.getData',
            message: 'An error was thrown while prefetching issue Forge data',
            name: 'ResourceError'
        }, error);
    }
};

});
parcelRegister("hpuF5", function(module, exports) {

$parcel$export(module.exports, "fetchIssueForgeData", () => $b0a1cdd28321d25a$export$44da8345d9ceca61);

var $k2DRb = parcelRequire("k2DRb");

var $5cmSg = parcelRequire("5cmSg");

var $iVaKa = parcelRequire("iVaKa");

var $7kNct = parcelRequire("7kNct");
const $b0a1cdd28321d25a$export$7c6ea4184129ef74 = (result, type)=>result.find((extensions)=>extensions.some((extension)=>extension.type === type)) || [];
const $b0a1cdd28321d25a$export$44da8345d9ceca61 = async (cloudId, issueKey, isAnonymous)=>{
    const extensions = await (0, $iVaKa.fetchModules)({
        cloudId: cloudId,
        isAnonymous: isAnonymous,
        types: [
            (0, $k2DRb.ISSUE_ACTION_MODULE),
            (0, $k2DRb.ISSUE_GLANCE_MODULE),
            (0, $k2DRb.ISSUE_CONTEXT_MODULE),
            (0, $k2DRb.ISSUE_PANEL_MODULE),
            (0, $k2DRb.ISSUE_ACTIVITY_MODULE),
            (0, $k2DRb.CUSTOM_FIELD_MODULE),
            (0, $k2DRb.CUSTOM_FIELD_TYPE_MODULE),
            (0, $k2DRb.ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE)
        ],
        context: {
            issueKey: issueKey
        },
        includeHidden: true,
        includeScopes: true,
        source: (0, $k2DRb.SOURCE_ISSUE_VIEW)
    });
    const getFilteredExtensions = (filterFn)=>({
            issueAction: extensions[0, $k2DRb.ISSUE_ACTION_MODULE].filter(filterFn),
            issueGlance: extensions[0, $k2DRb.ISSUE_GLANCE_MODULE].filter(filterFn),
            issueContext: extensions[0, $k2DRb.ISSUE_CONTEXT_MODULE].filter(filterFn),
            issuePanel: extensions[0, $k2DRb.ISSUE_PANEL_MODULE].filter(filterFn),
            issueActivity: extensions[0, $k2DRb.ISSUE_ACTIVITY_MODULE].filter(filterFn),
            customField: extensions[0, $k2DRb.CUSTOM_FIELD_MODULE].filter(filterFn),
            customFieldType: extensions[0, $k2DRb.CUSTOM_FIELD_TYPE_MODULE].filter(filterFn),
            issueViewBackgroundScript: extensions[0, $k2DRb.ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE].filter(filterFn)
        });
    const mappedResult = {
        ...getFilteredExtensions((extension)=>!(0, $5cmSg.isExtensionHiddenByAppAccessRules)(extension)),
        blockedExtensions: {
            ...getFilteredExtensions((extension)=>(0, $5cmSg.isExtensionHiddenByAppAccessRules)(extension))
        }
    };
    return (0, $7kNct.dedupeContextAndGlance)(mappedResult);
};

});
parcelRegister("5cmSg", function(module, exports) {

$parcel$export(module.exports, "isExtensionVisible", () => $30771269db74e480$export$41e48b53c2cc2013);
$parcel$export(module.exports, "isExtensionHidden", () => $30771269db74e480$export$3f5b3e61d567ef3);
$parcel$export(module.exports, "isExtensionHiddenByAppAccessRules", () => $30771269db74e480$export$5c38dfa9d1f96e61);
const $30771269db74e480$export$41e48b53c2cc2013 = (extension)=>!extension.hiddenBy;
const $30771269db74e480$export$3f5b3e61d567ef3 = (extension)=>!!extension.hiddenBy;
const $30771269db74e480$export$5c38dfa9d1f96e61 = (extension)=>extension.hiddenBy === 'AppAccessRules';
const $30771269db74e480$export$3cc53b8cca25d64 = (extension)=>extension.hiddenBy === 'DisplayConditions';

});

parcelRegister("7kNct", function(module, exports) {

$parcel$export(module.exports, "dedupeContextAndGlance", () => $4e352c29f229bbb8$export$17503ba1adfac304);
const $4e352c29f229bbb8$export$17503ba1adfac304 = (forgeData)=>{
    const contextInstallationIds = new Set(forgeData.issueContext?.map(({ installationId: installationId })=>installationId));
    const newGlanceItems = forgeData.issueGlance.filter(({ installationId: installationId })=>!contextInstallationIds.has(installationId));
    return {
        ...forgeData,
        issueGlance: newGlanceItems
    };
};

});




parcelRegister("lCj8l", function(module, exports) {

$parcel$export(module.exports, "issueGiraNonCriticalDataResource", () => $74422abbcf73f635$export$2d81f7bddf10f49e);

var $2Yhep = parcelRequire("2Yhep");

var $2M1hQ = parcelRequire("2M1hQ");

var $5XgeZ = parcelRequire("5XgeZ");

var $cvOMs = parcelRequire("cvOMs");
const $74422abbcf73f635$export$2d81f7bddf10f49e = (0, $2M1hQ.createResource)((0, $5XgeZ.withResourceEarlyData)({
    type: 'ISSUE_GIRA_NON_CRITICAL_DATA',
    getKey: ({ match: match })=>{
        const issueKey = (0, $2Yhep.getIssueKey)(match);
        return issueKey || '';
    },
    getData: (...args)=>(0, $cvOMs.default)(...args),
    isBrowserOnly: true
}));

});
parcelRegister("cvOMs", function(module, exports) {

$parcel$export(module.exports, "default", () => $07364a38d1410c3f$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $1O6Hj = parcelRequire("1O6Hj");

var $iR3GG = parcelRequire("iR3GG");

var $2Yhep = parcelRequire("2Yhep");

var $4R6GH = parcelRequire("4R6GH");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$07364a38d1410c3f$export$2e2bcd8739ae039 = async ({ match: match }, _)=>{
    const issueKey = (0, $2Yhep.getIssueKey)(match);
    if (!issueKey || (0, $4R6GH.fg)('move_iv_noncriticalgiraquery_out_of_critical_path')) return null;
    try {
        const data = await (0, $1O6Hj.fetchIssueGiraNonCriticalData)(issueKey);
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $iR3GG.createResourceError)({
            component: 'spa.view.routes.issue-view.gira-non-critical.getData',
            message: 'An error was thrown while prefetching issue gira non critical data',
            name: 'ResourceError'
        }, error);
    }
};

});
parcelRegister("1O6Hj", function(module, exports) {

$parcel$export(module.exports, "nonCriticalGiraQueryExperienceTracking", () => $6bf108f87308d37b$export$f382deefb24f95ae);
$parcel$export(module.exports, "fetchIssueGiraNonCriticalData", () => $6bf108f87308d37b$export$58a9221a6c5306db);

var $jJZqs = parcelRequire("jJZqs");

var $c6dax = parcelRequire("c6dax");

var $gXz4p = parcelRequire("gXz4p");

var $iBOrg = parcelRequire("iBOrg");
const $6bf108f87308d37b$var$nonCriticalGiraQueryExperienceDescription = ({ wasExperienceSuccessful: wasExperienceSuccessful, errorMessage: errorMessage, traceId: traceId, isEarlyFetch: isEarlyFetch })=>{
    const errorMessageItem = errorMessage != null ? {
        errorMessage: errorMessage
    } : {};
    const traceIdItem = traceId != null ? {
        traceId: traceId
    } : {};
    return {
        experience: isEarlyFetch ? 'issueEarlyFetchNonCriticalGiraQuery' : 'issueNonCriticalGiraQuery',
        wasExperienceSuccesful: wasExperienceSuccessful,
        analyticsSource: `Issue View ${isEarlyFetch ? 'Early Fetch ' : ''}Non Critical Gira Query`,
        additionalAttributes: {
            method: 'GET',
            ...errorMessageItem,
            ...traceIdItem
        },
        application: null,
        edition: null
    };
};
const $6bf108f87308d37b$export$f382deefb24f95ae = ({ wasExperienceSuccessful: wasExperienceSuccessful, isEarlyFetch: isEarlyFetch, error: error })=>{
    (0, $gXz4p.sendExperienceAnalytics)($6bf108f87308d37b$var$nonCriticalGiraQueryExperienceDescription({
        wasExperienceSuccessful: wasExperienceSuccessful,
        ...error instanceof (0, $jJZqs.default) && error.message != null ? {
            errorMessage: error.message
        } : {},
        ...error instanceof (0, $jJZqs.default) && error.traceId != null ? {
            traceId: error.traceId
        } : {},
        isEarlyFetch: isEarlyFetch
    }));
};
const $6bf108f87308d37b$export$58a9221a6c5306db = async (issueKey)=>{
    const variables = {
        issueKey: issueKey
    };
    const payload = {
        query: (0, $c6dax.buildNonCriticalGiraQuery)(),
        variables: variables,
        operationName: (0, $c6dax.ISSUE_VIEW_NON_CRITICAL_GIRA_QUERY)
    };
    try {
        const response = await (0, $iBOrg.getClient)('').query(payload);
        $6bf108f87308d37b$export$f382deefb24f95ae({
            wasExperienceSuccessful: true,
            isEarlyFetch: false
        });
        return response;
    } catch (error) {
        $6bf108f87308d37b$export$f382deefb24f95ae({
            wasExperienceSuccessful: false,
            isEarlyFetch: false,
            error: error instanceof (0, $jJZqs.default) ? error : undefined
        });
        throw error;
    }
};

});
parcelRegister("c6dax", function(module, exports) {

$parcel$export(module.exports, "ISSUE_VIEW_NON_CRITICAL_GIRA_QUERY", () => $b74efd74d6a135cc$export$857f1602ca5b9d99);
$parcel$export(module.exports, "buildNonCriticalGiraQuery", () => $b74efd74d6a135cc$export$df3c3aa9d6d3f431);
$parcel$export(module.exports, "getNonCriticalGiraQueryRequestOptions", () => $b74efd74d6a135cc$export$555194bfc9159fa3);

var $jzVvW = parcelRequire("jzVvW");
const $b74efd74d6a135cc$export$857f1602ca5b9d99 = 'issueViewNonCriticalGiraQuery';
const $b74efd74d6a135cc$export$df3c3aa9d6d3f431 = ()=>`
query ${$b74efd74d6a135cc$export$857f1602ca5b9d99}($issueKey: String!) {
    viewIssue(issueKey: $issueKey) {
        ${(0, $jzVvW.getEcosystemQuery)()}
        deletableAttachmentsCount
    }
}`;
const $b74efd74d6a135cc$export$555194bfc9159fa3 = (issueKey)=>({
        method: 'POST',
        body: JSON.stringify({
            operationName: $b74efd74d6a135cc$export$857f1602ca5b9d99,
            query: $b74efd74d6a135cc$export$df3c3aa9d6d3f431(),
            variables: {
                issueKey: issueKey
            }
        })
    });

});
parcelRegister("jzVvW", function(module, exports) {

$parcel$export(module.exports, "getEcosystemQuery", () => $8b485783ca3ced28$export$edefef8c65e08bd2);
const $8b485783ca3ced28$export$edefef8c65e08bd2 = ()=>`
  ecosystem {
    operations {
      name
      url: href
      tooltip
      styleClass
    }
    backgroundScripts {
      iframe {
        addonKey
        moduleKey
        options
      }
      shouldReloadOnRefresh
    }
  }
`;

});


parcelRegister("gXz4p", function(module, exports) {

$parcel$export(module.exports, "sendExperienceAnalytics", () => $b28eb6b892a8c2f7$export$4a95ada1b8228562);

var $1UikQ = parcelRequire("1UikQ");

var $gSA3s = parcelRequire("gSA3s");

var $hh0bW = parcelRequire("hh0bW");

var $j8DrX = parcelRequire("j8DrX");

var $4R6GH = parcelRequire("4R6GH");
const $b28eb6b892a8c2f7$var$isSynthetic = ()=>(0, $j8DrX.default)('ajs-is-synthetic') === 'true';
const $b28eb6b892a8c2f7$var$shouldAddConnectivityAttribute = (experienceDescription)=>{
    // Return false if feature flag is off
    if (!(0, $4R6GH.fg)('thor_refine_taskfail_offline_failed_events')) return false;
    // Return false if not a taskFail action
    if (experienceDescription.wasExperienceSuccesful) return false;
    const isKnownExperience = [
        'transitionIssue',
        'getTransitions',
        'startWatching',
        'stopWatching'
    ].includes(experienceDescription.experience);
    // Return false if not a known experience
    if (!isKnownExperience) return false;
    const hasStatusCode = !!experienceDescription.additionalAttributes?.statusCode;
    // Return false if status code is present
    return !hasStatusCode;
};
function $b28eb6b892a8c2f7$export$4a95ada1b8228562(experienceDescription) {
    const additionalContext = {};
    const shard = (0, $j8DrX.default)('ajs-shard');
    const region = (0, $j8DrX.default)('ajs-region');
    Object.assign(additionalContext, {
        shard: shard,
        region: region
    });
    const enabledFeatureFlags = Object.fromEntries([
        ...(0, $gSA3s.allFeatureFlagsAccessed)
    ].filter(([, value])=>value));
    Object.assign(additionalContext, {
        enabledFeatureFlags: enabledFeatureFlags
    });
    if ($b28eb6b892a8c2f7$var$shouldAddConnectivityAttribute(experienceDescription)) {
        const isOnline = typeof globalThis.window !== 'undefined' && globalThis.window?.navigator?.onLine;
        Object.assign(additionalContext, {
            isOnline: isOnline
        });
    }
    const synthetics = {
        additionalAttributes: {
            synthetic: $b28eb6b892a8c2f7$var$isSynthetic(),
            ...additionalContext
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(experienceDescription, synthetics);
    (0, $hh0bW.default)(experienceDescription);
}

});
parcelRegister("hh0bW", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c8a1e19e7613048$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");

var $j8DrX = parcelRequire("j8DrX");

var $fjcgS = parcelRequire("fjcgS");

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");
const $6c8a1e19e7613048$var$transformApplication = (application)=>{
    switch(application){
        case 0, $efvDm.JIRA_SOFTWARE:
            return 'jira-software';
        case 0, $efvDm.JIRA_PRODUCT_DISCOVERY:
            return 'jira-product-discovery';
        case 0, $efvDm.JIRA_CORE:
            return 'jira-core';
        case 0, $efvDm.JIRA_SERVICE_DESK:
            return 'jira-servicedesk';
        case 0, $efvDm.JIRA_PORTFOLIO:
            return 'jira-portfolio';
        default:
            return 'unknown';
    }
};
const $6c8a1e19e7613048$var$transformEdition = (edition)=>{
    switch(edition){
        case 0, $ldyPw.FREE_EDITION:
            return 'jedi';
        case 0, $ldyPw.STANDARD_EDITION:
            return 'standard';
        case 0, $ldyPw.PREMIUM_EDITION:
            return 'premium';
        case 0, $ldyPw.UNLICENSED:
            return 'unlicensed';
        default:
            return 'unknown';
    }
};
const $6c8a1e19e7613048$var$transformAction = (action, wasExperienceSuccesful)=>{
    if (action !== undefined) return action;
    return wasExperienceSuccesful ? 'taskSuccess' : 'taskFail';
};
const $6c8a1e19e7613048$var$createAnalyticsEvent = ({ experience: experience, wasExperienceSuccesful: wasExperienceSuccesful, action: action, location: location, field: field, hasEdit: hasEdit, analyticsSource: analyticsSource, application: application, edition: edition, additionalAttributes: additionalAttributes })=>({
        source: 'ui',
        action: $6c8a1e19e7613048$var$transformAction(action, wasExperienceSuccesful),
        actionSubject: 'ui',
        attributes: {
            ...additionalAttributes,
            task: experience,
            ...location ? {
                reason: location
            } : {},
            ...field ? {
                field: field
            } : {},
            ...typeof hasEdit === 'boolean' ? {
                hasEdit: hasEdit
            } : {},
            analyticsSource: analyticsSource,
            application: $6c8a1e19e7613048$var$transformApplication(application),
            edition: $6c8a1e19e7613048$var$transformEdition(edition),
            ...!false && (0, $4R6GH.fg)('chronos-add-shard-data-to-operational-metrics') ? {
                shard: (0, $j8DrX.default)('ajs-shard') || '',
                region: (0, $j8DrX.default)('ajs-region') || ''
            } : {}
        }
    });
var /**
 * @param {String} experienceDescription.experience
 * @param {Boolean} experienceDescription.wasExperienceSuccesful - Deprecated: Instead set `action` to `taskSuccess` (previously `true`), `taskFail` (previously `false`) or `taskAbort`
 * @param {Action} experienceDescription.action
 * @param {String} experienceDescription.location
 * @param {String} experienceDescription.field
 * @param {String} experienceDescription.hasEdit
 * @param {String} experienceDescription.analyticsSource
 * @param {String} experienceDescription.application
 * @param {Application} experienceDescription.edition
 * @param {ApplicationEdition} experienceDescription.additionalAttributes
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$6c8a1e19e7613048$export$2e2bcd8739ae039 = (experienceDescription)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        const event = $6c8a1e19e7613048$var$createAnalyticsEvent(experienceDescription);
        const clientInstance = client.getInstance();
        clientInstance.sendOperationalEvent(event);
    });
};

});





parcelRegister("kg2oj", function(module, exports) {

let $ebf7281c803ef1bb$var$load = (parcelRequire("28QjX"))(4);
































module.exports = Promise.all([
    (parcelRequire("avM1e"))('thor_add_taskabort_events_for_core_experiences', function() {
        return Promise.all([
            $ebf7281c803ef1bb$var$load("kweCQ"),
            $ebf7281c803ef1bb$var$load("kNFvF")
        ]);
    }, function() {
        return Promise.all([
            $ebf7281c803ef1bb$var$load("1f7yF"),
            $ebf7281c803ef1bb$var$load("kNFvF")
        ]);
    }),
    (parcelRequire("avM1e"))('memo_fix_issue_field_remounts_2', function() {
        return Promise.all([
            $ebf7281c803ef1bb$var$load("1oP3P")
        ]);
    }, function() {
        return Promise.all([
            $ebf7281c803ef1bb$var$load("9ev6R")
        ]);
    }),
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $ebf7281c803ef1bb$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $ebf7281c803ef1bb$var$load("k6g9p")
        ]);
    }),
    (parcelRequire("avM1e"))('jirt-convert-class-to-functional-component', function() {
        return Promise.all([
            $ebf7281c803ef1bb$var$load("1ls92")
        ]);
    }, function() {
        return Promise.all([
            $ebf7281c803ef1bb$var$load("kLeYK")
        ]);
    }),
    (parcelRequire("avM1e"))('redaction_onboarding_iv_llc', function() {
        return Promise.all([
            $ebf7281c803ef1bb$var$load("czPin")
        ]);
    }, function() {
        return Promise.all([
            $ebf7281c803ef1bb$var$load("iGvP4")
        ]);
    }),
    (parcelRequire("avM1e"))('jiv-20591-renderer-rerenders-fix-refactor', function() {
        return Promise.all([
            (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-small-nodes', function() {
                return Promise.all([
                    $ebf7281c803ef1bb$var$load("d5z58"),
                    $ebf7281c803ef1bb$var$load("kvRbA"),
                    $ebf7281c803ef1bb$var$load("ffQaD"),
                    $ebf7281c803ef1bb$var$load("l253H"),
                    $ebf7281c803ef1bb$var$load("76n7a")
                ]);
            }, function() {
                return Promise.all([
                    $ebf7281c803ef1bb$var$load("f771T")
                ]);
            }),
            (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-media-nodes', function() {
                return Promise.all([
                    $ebf7281c803ef1bb$var$load("gXEyJ"),
                    $ebf7281c803ef1bb$var$load("kvRbA"),
                    $ebf7281c803ef1bb$var$load("ffQaD"),
                    $ebf7281c803ef1bb$var$load("l253H"),
                    $ebf7281c803ef1bb$var$load("76n7a")
                ]);
            }, function() {
                return Promise.all([
                    $ebf7281c803ef1bb$var$load("hy7ba")
                ]);
            }),
            (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-card-nodes', function() {
                return Promise.all([
                    $ebf7281c803ef1bb$var$load("lh7CA"),
                    $ebf7281c803ef1bb$var$load("kNFvF"),
                    $ebf7281c803ef1bb$var$load("kvRbA"),
                    $ebf7281c803ef1bb$var$load("ffQaD"),
                    $ebf7281c803ef1bb$var$load("l253H"),
                    $ebf7281c803ef1bb$var$load("76n7a"),
                    $ebf7281c803ef1bb$var$load("fliVL")
                ]);
            }, function() {
                return Promise.all([
                    $ebf7281c803ef1bb$var$load("jrRVX")
                ]);
            }),
            $ebf7281c803ef1bb$var$load("gDexj")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-small-nodes', function() {
                return Promise.all([
                    $ebf7281c803ef1bb$var$load("d5z58"),
                    $ebf7281c803ef1bb$var$load("kvRbA"),
                    $ebf7281c803ef1bb$var$load("ffQaD"),
                    $ebf7281c803ef1bb$var$load("l253H"),
                    $ebf7281c803ef1bb$var$load("76n7a")
                ]);
            }, function() {
                return Promise.all([
                    $ebf7281c803ef1bb$var$load("f771T")
                ]);
            }),
            (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-media-nodes', function() {
                return Promise.all([
                    $ebf7281c803ef1bb$var$load("gXEyJ"),
                    $ebf7281c803ef1bb$var$load("kvRbA"),
                    $ebf7281c803ef1bb$var$load("ffQaD"),
                    $ebf7281c803ef1bb$var$load("l253H"),
                    $ebf7281c803ef1bb$var$load("76n7a")
                ]);
            }, function() {
                return Promise.all([
                    $ebf7281c803ef1bb$var$load("hy7ba")
                ]);
            }),
            (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-card-nodes', function() {
                return Promise.all([
                    $ebf7281c803ef1bb$var$load("lh7CA"),
                    $ebf7281c803ef1bb$var$load("kNFvF"),
                    $ebf7281c803ef1bb$var$load("kvRbA"),
                    $ebf7281c803ef1bb$var$load("ffQaD"),
                    $ebf7281c803ef1bb$var$load("l253H"),
                    $ebf7281c803ef1bb$var$load("76n7a"),
                    $ebf7281c803ef1bb$var$load("fliVL")
                ]);
            }, function() {
                return Promise.all([
                    $ebf7281c803ef1bb$var$load("jrRVX")
                ]);
            }),
            $ebf7281c803ef1bb$var$load("hyyp4")
        ]);
    }),
    (parcelRequire("avM1e"))('jira_amplitude_sr', function() {
        return Promise.all([
            $ebf7281c803ef1bb$var$load("8EtZR"),
            $ebf7281c803ef1bb$var$load("kVX56")
        ]);
    }, function() {
        return Promise.all([
            $ebf7281c803ef1bb$var$load("6jOz3")
        ]);
    }),
    (parcelRequire("avM1e"))('jiv-20455-dev-panel-to-sync', function() {
        return Promise.all([
            (parcelRequire("avM1e"))('jiv-20508-remove-height-animation-dev-panel', function() {
                return Promise.all([
                    $ebf7281c803ef1bb$var$load("hm756")
                ]);
            }, function() {
                return Promise.all([]);
            }),
            (parcelRequire("avM1e"))('create-branch-dropdown-iv-llc-dev-panel', function() {
                return Promise.all([
                    $ebf7281c803ef1bb$var$load("46Z1D")
                ]);
            }, function() {
                return Promise.all([
                    $ebf7281c803ef1bb$var$load("3DKoG")
                ]);
            }),
            (parcelRequire("avM1e"))('create-commit-dropdown-iv-llc-dev-panel', function() {
                return Promise.all([
                    $ebf7281c803ef1bb$var$load("cNRxo")
                ]);
            }, function() {
                return Promise.all([
                    $ebf7281c803ef1bb$var$load("i8oWy")
                ]);
            }),
            (parcelRequire("avM1e"))('create_pullrequest_dropdown_iv_llc_dev_panel', function() {
                return Promise.all([
                    $ebf7281c803ef1bb$var$load("63C5i")
                ]);
            }, function() {
                return Promise.all([
                    $ebf7281c803ef1bb$var$load("lbT1q")
                ]);
            }),
            (parcelRequire("avM1e"))('create_pullrequest_dropdown_iv_llc_dev_panel', function() {
                return Promise.all([
                    $ebf7281c803ef1bb$var$load("63C5i")
                ]);
            }, function() {
                return Promise.all([
                    $ebf7281c803ef1bb$var$load("lbT1q")
                ]);
            }),
            (parcelRequire("avM1e"))('ff-action-dropdown-simple-iv-llc-dev-panel', function() {
                return Promise.all([
                    $ebf7281c803ef1bb$var$load("lIp00")
                ]);
            }, function() {
                return Promise.all([
                    $ebf7281c803ef1bb$var$load("cZoU9")
                ]);
            }),
            (parcelRequire("avM1e"))('ff-action-dropdown-simple-iv-llc-dev-panel', function() {
                return Promise.all([
                    $ebf7281c803ef1bb$var$load("lIp00")
                ]);
            }, function() {
                return Promise.all([
                    $ebf7281c803ef1bb$var$load("cZoU9")
                ]);
            }),
            (parcelRequire("avM1e"))('vulnerability-dropdown-iv-llc-dev-panel', function() {
                return Promise.all([
                    $ebf7281c803ef1bb$var$load("dsjsy")
                ]);
            }, function() {
                return Promise.all([
                    $ebf7281c803ef1bb$var$load("QeZ1l")
                ]);
            }),
            $ebf7281c803ef1bb$var$load("ckYFZ"),
            $ebf7281c803ef1bb$var$load("kvRbA"),
            $ebf7281c803ef1bb$var$load("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $ebf7281c803ef1bb$var$load("etgJj")
        ]);
    }),
    (parcelRequire("avM1e"))('details_loader_to_entrypoint_iv_llc_dev_panel', function() {
        return Promise.all([
            $ebf7281c803ef1bb$var$load("84z1X")
        ]);
    }, function() {
        return Promise.all([
            $ebf7281c803ef1bb$var$load("eBkr0")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $ebf7281c803ef1bb$var$load("czifk")
        ]);
    }, function() {
        return Promise.all([
            $ebf7281c803ef1bb$var$load("kcs34")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $ebf7281c803ef1bb$var$load("cTJTG"),
            $ebf7281c803ef1bb$var$load("l253H"),
            $ebf7281c803ef1bb$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $ebf7281c803ef1bb$var$load("4Qxp7")
        ]);
    }),
    (parcelRequire("avM1e"))('fix_versions_component_perf_improvement_vc90', function() {
        return Promise.all([
            $ebf7281c803ef1bb$var$load("6TXdv")
        ]);
    }, function() {
        return Promise.all([
            $ebf7281c803ef1bb$var$load("4t8fr")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $ebf7281c803ef1bb$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $ebf7281c803ef1bb$var$load("7B2gt")
        ]);
    }),
    (parcelRequire("avM1e"))('improve_issue_automation_button_iv_llc', function() {
        return Promise.all([
            $ebf7281c803ef1bb$var$load("5VTmG")
        ]);
    }, function() {
        return Promise.all([
            $ebf7281c803ef1bb$var$load("6mU2N"),
            $ebf7281c803ef1bb$var$load("kvRbA"),
            $ebf7281c803ef1bb$var$load("ffQaD")
        ]);
    }),
    (parcelRequire("avM1e"))('improve_issue_view_comment_ai', function() {
        return Promise.all([
            $ebf7281c803ef1bb$var$load("egvYO")
        ]);
    }, function() {
        return Promise.all([
            $ebf7281c803ef1bb$var$load("hkt2G")
        ]);
    }),
    (parcelRequire("avM1e"))('issue_comment_reply_list_sync_import', function() {
        return Promise.all([
            $ebf7281c803ef1bb$var$load("eZWUu")
        ]);
    }, function() {
        return Promise.all([
            $ebf7281c803ef1bb$var$load("aWylw")
        ]);
    }),
    (parcelRequire("avM1e"))('link_paste_recommendations', function() {
        return Promise.all([]);
    }, function() {
        return Promise.all([
            $ebf7281c803ef1bb$var$load("7ClEP")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-issue-view-child-issues-panel-entrypoint', function() {
        return Promise.all([
            $ebf7281c803ef1bb$var$load("fdfwb")
        ]);
    }, function() {
        return Promise.all([
            $ebf7281c803ef1bb$var$load("7TIhF")
        ]);
    }),
    $ebf7281c803ef1bb$var$load("7mIf9"),
    $ebf7281c803ef1bb$var$load("jXweD"),
    $ebf7281c803ef1bb$var$load("5BNUw"),
    $ebf7281c803ef1bb$var$load("kGAgW"),
    $ebf7281c803ef1bb$var$load("kNFvF"),
    $ebf7281c803ef1bb$var$load("kVX56"),
    $ebf7281c803ef1bb$var$load("ffQaD"),
    $ebf7281c803ef1bb$var$load("kvRbA"),
    $ebf7281c803ef1bb$var$load("3yAl4"),
    $ebf7281c803ef1bb$var$load("fliVL"),
    $ebf7281c803ef1bb$var$load("76n7a"),
    $ebf7281c803ef1bb$var$load("l253H"),
    $ebf7281c803ef1bb$var$load("jbxE1"),
    $ebf7281c803ef1bb$var$load("7imUH"),
    $ebf7281c803ef1bb$var$load("70aLb")
]).then(()=>parcelRequire('kW74N'));

});



parcelRegister("1B0QU", function(module, exports) {

$parcel$export(module.exports, "browseIssueRouteEntry", () => $a10da1f1a9bba803$export$cef770e7c16cfcc);

var $ffza4 = parcelRequire("ffza4");


var $e2ctp = parcelRequire("e2ctp");

var $4R6GH = parcelRequire("4R6GH");

var $gyYxw = parcelRequire("gyYxw");

var $g5RGc = parcelRequire("g5RGc");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $8ZUng = parcelRequire("8ZUng");

var $9XjL6 = parcelRequire("9XjL6");

var $3RJkv = parcelRequire("3RJkv");

var $1aAOt = parcelRequire("1aAOt");

var $dxCvy = parcelRequire("dxCvy");

var $1WlLE = parcelRequire("1WlLE");

var $7GnDe = parcelRequire("7GnDe");

var $fw7Rx = parcelRequire("fw7Rx");

var $gRzZD = parcelRequire("gRzZD");

var $lb0Dk = parcelRequire("lb0Dk");

var $lAGdd = parcelRequire("lAGdd");

var $gNStA = parcelRequire("gNStA");

var $7bHMy = parcelRequire("7bHMy");

var $2dmpO = parcelRequire("2dmpO");
const $a10da1f1a9bba803$var$resourcesOld = ()=>[
        ...(0, $lNicp.getBusinessProjectResources)(),
        ...(0, $3RJkv.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $7GnDe.incidentExperimentTraitResourceOnNav3Only),
        (0, $dxCvy.projectContextResource),
        (0, $5bkvv.forgeProjectModuleResourceOnNav3Only),
        (0, $iEUaw.staticSidebarShortcutsResource),
        (0, $ggg5j.staticProjectSidebarNavigationResource),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...(0, $1aAOt.getOfferingCatalogueFeaturesResource)(),
        ...(0, $2dmpO.getUnusedRouteResources)(),
        (0, $9XjL6.issueGiraDataResource),
        ...(0, $2dmpO.removeNonCritialGiraCallFromCriticalPath)(),
        (0, $2dmpO.conditionalForgeResource),
        (0, $8ZUng.issueViewRelayResource),
        (0, $1WlLE.queuesNavigationItems),
        (0, $gRzZD.workspaceResource),
        (0, $bHhiy.getConsolidationStateResource)(),
        ...(0, $lAGdd.getAIContextPanelResources)(),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jira-project-isglobalcomponent-route-resource'), (0, $7bHMy.projectGlobalComponentsResource))
    ];
// jfp-magma-3491-reorder-issue-view-route-resources - These resources have been re-ordered. We have a theory that moving the more expensive ones to be first in the list makes them faster in SSR, there some small overhead that compounds over the 30 odd requests that happens.
// Longest poles at the moment are issueViewRelayResource and issueGiraDataResource, so we have moved them to the top of the list.
const $a10da1f1a9bba803$var$resourcesNew = ()=>[
        (0, $8ZUng.issueViewRelayResource),
        (0, $9XjL6.issueGiraDataResource),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        ...(0, $3RJkv.getNavigationResources)(),
        ...(0, $lNicp.getBusinessProjectResources)(),
        (0, $7GnDe.incidentExperimentTraitResourceOnNav3Only),
        (0, $dxCvy.projectContextResource),
        (0, $5bkvv.forgeProjectModuleResourceOnNav3Only),
        (0, $iEUaw.staticSidebarShortcutsResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        (0, $ggg5j.staticProjectSidebarNavigationResource),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only),
        ...(0, $1aAOt.getOfferingCatalogueFeaturesResource)(),
        ...(0, $2dmpO.getUnusedRouteResources)(),
        ...(0, $2dmpO.removeNonCritialGiraCallFromCriticalPath)(),
        (0, $2dmpO.conditionalForgeResource),
        (0, $1WlLE.queuesNavigationItems),
        (0, $gRzZD.workspaceResource),
        (0, $bHhiy.getConsolidationStateResource)(),
        ...(0, $lAGdd.getAIContextPanelResources)(),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jira-project-isglobalcomponent-route-resource'), (0, $7bHMy.projectGlobalComponentsResource))
    ];
const $a10da1f1a9bba803$export$cef770e7c16cfcc = (0, $7NszV.createEntry)((0, $fw7Rx.browseIssueRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'issue',
        isHydrateRootEnabled: (0, $4R6GH.fg)('jfp-magma-issue-view-full-page-hydrate-root'),
        preloadOptions: {
            earlyChunks: [
                'issue-app-early-entry'
            ]
        },
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY),
        component: (0, $2dmpO.IssueComponent),
        skeleton: (0, $lb0Dk.IssueViewSkeleton),
        layout: (0, $aPfsS.composeLayouts)((0, $gyYxw.genericProjectLayout), (0, $g5RGc.fullPageIssuePreloadLayout)),
        navigation: {
            sidebar: (0, $hBv66.genericProjectSidebars),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba)
        },
        resources: (0, $4R6GH.fg)('jfp-magma-3491-reorder-issue-view-route-resources') ? $a10da1f1a9bba803$var$resourcesNew() : $a10da1f1a9bba803$var$resourcesOld(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $2dmpO.LazyIssuePage)
        ],
        ufoName: 'issue-view',
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$ef94a84e2990361c)
        },
        bifrost: {
            bifrostGroup: 'issue-view',
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-entries/src/browseIssueRouteEntry.tsx',
                whichExportToUse: 'browseIssueRouteEntry'
            },
            enabled: true,
            manifestName: 'jira-spa-issue-view.json'
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("g5RGc", function(module, exports) {

$parcel$export(module.exports, "fullPageIssuePreloadLayout", () => $59d96d961d806fee$export$98e337c40eb151da);
$parcel$export(module.exports, "embeddedIssuePreloadLayoutBuilder", () => $59d96d961d806fee$export$7b113174a456921a);
$parcel$export(module.exports, "pageLoadIssuePreloadLayoutBuilder", () => $59d96d961d806fee$export$682dcbf7cc80ba11);

var $aPfsS = parcelRequire("aPfsS");

var $lGGIs = parcelRequire("lGGIs");

var $kxZPA = parcelRequire("kxZPA");

var $lODMY = parcelRequire("lODMY");
var $4sxG1 = parcelRequire("4sxG1");

var $l7Ytp = parcelRequire("l7Ytp");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $59d96d961d806fee$var$LazyIssuePage = (0, $kxZPA.lazyAfterPaint)(()=>(0, $lGGIs.markAsBentoBundleReady)((parcelRequire("kg2oj"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/issue/src/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $59d96d961d806fee$var$AsyncIssueAppComponent = (0, $kxZPA.lazyAfterPaint)(()=>(0, $lGGIs.markAsBentoBundleReady)((parcelRequire("d38KI"))), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $59d96d961d806fee$var$IssueModal = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("eM5k0")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/modal-issue-app.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $59d96d961d806fee$var$IssueModalContents = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("ewPO9")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-view.tsx"
});
const $59d96d961d806fee$var$imports = {
    fullPage: ()=>$59d96d961d806fee$var$LazyIssuePage.preload(),
    embedded: ()=>$59d96d961d806fee$var$AsyncIssueAppComponent.preload(),
    pageLoad: (viewModeToPreload)=>{
        // issue view that opens as a modal
        if (viewModeToPreload === 'MODAL' || viewModeToPreload === 'DEFAULT') {
            $59d96d961d806fee$var$IssueModal.preload();
            $59d96d961d806fee$var$IssueModalContents.preload();
        }
        // issue view that opens as a side panel
        if (viewModeToPreload === 'SIDEBAR') $59d96d961d806fee$var$AsyncIssueAppComponent.preload();
    }
};

const $59d96d961d806fee$var$PrefetchCBBResourcesComponent = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("hBQJM")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/services/prefetch-wrm-bundle/index.tsx"
});
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
if (!false && window.SPA_STATE?.serverIssuePreload) {
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly fullPage: () => Promise<typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/spa-apps/issue/src/index")>; readonly embedded: () => Promise<...>; }'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const importSupplier = $59d96d961d806fee$var$imports[window.SPA_STATE.serverIssuePreload];
    importSupplier && importSupplier();
}
const $59d96d961d806fee$var$ISSUE_PRELOAD_COMPONENT_MARK = 'IssuePreloadComponent:rendered';
const $59d96d961d806fee$var$useParamsSelector = (0, $lODMY.createRouterSelector)((state)=>({
        query: state.query,
        params: state.match.params
    }));
const $59d96d961d806fee$var$IssuePreloadComponentBuilder = (identifier, preloadSupplier, preloadContract)=>()=>{
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { query: query, params: params } = $59d96d961d806fee$var$useParamsSelector();
        if (// If we have an undefined contract, assume we want to preload
        !preloadContract || // Preload if we match the contract
        preloadContract.some((preloadingMatch)=>// Match query with router function
            // @ts-expect-error - TS2554 - Expected 3 arguments, but got 2.
            (!preloadingMatch.query || (0, $4sxG1.default)(preloadingMatch.query, query)) && // Match path params with simple object structure, where if value is undefined
            // we assume we match all values
            (!preloadingMatch.params || preloadingMatch.params.every(({ key: key, value: value })=>params && params[key] !== undefined && (value === undefined || params[key] === value))))) {
            if (!false) preloadSupplier();
            if (false) (0, $l7Ytp.setServerEvaluatedIssuePreload)(identifier);
            else performance.mark($59d96d961d806fee$var$ISSUE_PRELOAD_COMPONENT_MARK);
        }
        return null;
    };
const $59d96d961d806fee$var$FullPageIssuePreloadComponent = $59d96d961d806fee$var$IssuePreloadComponentBuilder('fullPage', $59d96d961d806fee$var$imports.fullPage);
$59d96d961d806fee$var$FullPageIssuePreloadComponent.displayName = 'FullPageIssuePreloadComponent';
const $59d96d961d806fee$export$98e337c40eb151da = (0, $aPfsS.createLayout)({
    globalComponents: [
        $59d96d961d806fee$var$FullPageIssuePreloadComponent,
        $59d96d961d806fee$var$PrefetchCBBResourcesComponent
    ]
});
const $59d96d961d806fee$export$7b113174a456921a = (preloadContract)=>{
    const EmbeddedIssuePreloadComponent = $59d96d961d806fee$var$IssuePreloadComponentBuilder('embedded', $59d96d961d806fee$var$imports.embedded, preloadContract);
    EmbeddedIssuePreloadComponent.displayName = 'EmbeddedIssuePreloadComponent';
    return (0, $aPfsS.createLayout)({
        globalComponents: [
            EmbeddedIssuePreloadComponent
        ]
    });
};
const $59d96d961d806fee$export$682dcbf7cc80ba11 = (preloadContract, viewModeToPreload)=>{
    const PageLoadIssuePreloadComponent = $59d96d961d806fee$var$IssuePreloadComponentBuilder('pageLoad', ()=>$59d96d961d806fee$var$imports.pageLoad(viewModeToPreload || 'DEFAULT'), preloadContract);
    PageLoadIssuePreloadComponent.displayName = 'PageLoadIssuePreloadComponent';
    return (0, $aPfsS.createLayout)({
        globalComponents: [
            PageLoadIssuePreloadComponent
        ]
    });
};

});
parcelRegister("l7Ytp", function(module, exports) {

$parcel$export(module.exports, "setServerEvaluatedIssuePreload", () => $1e750e126dd1eeef$export$d2077b3b0eac1c19);
/* eslint-disable jira/filename-case */ // We can start the evaluation at module level if we ran the component in SSR
// This needs to be an empty string because the router breaks if it's null or undefined
let $1e750e126dd1eeef$var$serverIssuePreloadIdentifier = '';
const $1e750e126dd1eeef$export$d2077b3b0eac1c19 = (identifier)=>{
    $1e750e126dd1eeef$var$serverIssuePreloadIdentifier = identifier;
};
const $1e750e126dd1eeef$export$f55e6973062dc859 = ()=>$1e750e126dd1eeef$var$serverIssuePreloadIdentifier;

});

parcelRegister("d38KI", function(module, exports) {

let $9802583962909688$var$load = (parcelRequire("28QjX"))(4);
































module.exports = Promise.all([
    (parcelRequire("avM1e"))('thor_add_taskabort_events_for_core_experiences', function() {
        return Promise.all([
            $9802583962909688$var$load("kweCQ"),
            $9802583962909688$var$load("kNFvF")
        ]);
    }, function() {
        return Promise.all([
            $9802583962909688$var$load("1f7yF"),
            $9802583962909688$var$load("kNFvF")
        ]);
    }),
    (parcelRequire("avM1e"))('memo_fix_issue_field_remounts_2', function() {
        return Promise.all([
            $9802583962909688$var$load("1oP3P")
        ]);
    }, function() {
        return Promise.all([
            $9802583962909688$var$load("9ev6R")
        ]);
    }),
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $9802583962909688$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $9802583962909688$var$load("k6g9p")
        ]);
    }),
    (parcelRequire("avM1e"))('jirt-convert-class-to-functional-component', function() {
        return Promise.all([
            $9802583962909688$var$load("1ls92")
        ]);
    }, function() {
        return Promise.all([
            $9802583962909688$var$load("kLeYK")
        ]);
    }),
    (parcelRequire("avM1e"))('redaction_onboarding_iv_llc', function() {
        return Promise.all([
            $9802583962909688$var$load("czPin")
        ]);
    }, function() {
        return Promise.all([
            $9802583962909688$var$load("iGvP4")
        ]);
    }),
    (parcelRequire("avM1e"))('jiv-20591-renderer-rerenders-fix-refactor', function() {
        return Promise.all([
            (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-small-nodes', function() {
                return Promise.all([
                    $9802583962909688$var$load("d5z58"),
                    $9802583962909688$var$load("kvRbA"),
                    $9802583962909688$var$load("ffQaD"),
                    $9802583962909688$var$load("l253H"),
                    $9802583962909688$var$load("76n7a")
                ]);
            }, function() {
                return Promise.all([
                    $9802583962909688$var$load("f771T")
                ]);
            }),
            (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-media-nodes', function() {
                return Promise.all([
                    $9802583962909688$var$load("gXEyJ"),
                    $9802583962909688$var$load("kvRbA"),
                    $9802583962909688$var$load("ffQaD"),
                    $9802583962909688$var$load("l253H"),
                    $9802583962909688$var$load("76n7a")
                ]);
            }, function() {
                return Promise.all([
                    $9802583962909688$var$load("hy7ba")
                ]);
            }),
            (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-card-nodes', function() {
                return Promise.all([
                    $9802583962909688$var$load("lh7CA"),
                    $9802583962909688$var$load("kNFvF"),
                    $9802583962909688$var$load("kvRbA"),
                    $9802583962909688$var$load("ffQaD"),
                    $9802583962909688$var$load("l253H"),
                    $9802583962909688$var$load("76n7a"),
                    $9802583962909688$var$load("fliVL")
                ]);
            }, function() {
                return Promise.all([
                    $9802583962909688$var$load("jrRVX")
                ]);
            }),
            $9802583962909688$var$load("gDexj")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-small-nodes', function() {
                return Promise.all([
                    $9802583962909688$var$load("d5z58"),
                    $9802583962909688$var$load("kvRbA"),
                    $9802583962909688$var$load("ffQaD"),
                    $9802583962909688$var$load("l253H"),
                    $9802583962909688$var$load("76n7a")
                ]);
            }, function() {
                return Promise.all([
                    $9802583962909688$var$load("f771T")
                ]);
            }),
            (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-media-nodes', function() {
                return Promise.all([
                    $9802583962909688$var$load("gXEyJ"),
                    $9802583962909688$var$load("kvRbA"),
                    $9802583962909688$var$load("ffQaD"),
                    $9802583962909688$var$load("l253H"),
                    $9802583962909688$var$load("76n7a")
                ]);
            }, function() {
                return Promise.all([
                    $9802583962909688$var$load("hy7ba")
                ]);
            }),
            (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-card-nodes', function() {
                return Promise.all([
                    $9802583962909688$var$load("lh7CA"),
                    $9802583962909688$var$load("kNFvF"),
                    $9802583962909688$var$load("kvRbA"),
                    $9802583962909688$var$load("ffQaD"),
                    $9802583962909688$var$load("l253H"),
                    $9802583962909688$var$load("76n7a"),
                    $9802583962909688$var$load("fliVL")
                ]);
            }, function() {
                return Promise.all([
                    $9802583962909688$var$load("jrRVX")
                ]);
            }),
            $9802583962909688$var$load("hyyp4")
        ]);
    }),
    (parcelRequire("avM1e"))('jira_amplitude_sr', function() {
        return Promise.all([
            $9802583962909688$var$load("8EtZR"),
            $9802583962909688$var$load("kVX56")
        ]);
    }, function() {
        return Promise.all([
            $9802583962909688$var$load("6jOz3")
        ]);
    }),
    (parcelRequire("avM1e"))('jiv-20455-dev-panel-to-sync', function() {
        return Promise.all([
            (parcelRequire("avM1e"))('jiv-20508-remove-height-animation-dev-panel', function() {
                return Promise.all([
                    $9802583962909688$var$load("hm756")
                ]);
            }, function() {
                return Promise.all([]);
            }),
            (parcelRequire("avM1e"))('create-branch-dropdown-iv-llc-dev-panel', function() {
                return Promise.all([
                    $9802583962909688$var$load("46Z1D")
                ]);
            }, function() {
                return Promise.all([
                    $9802583962909688$var$load("3DKoG")
                ]);
            }),
            (parcelRequire("avM1e"))('create-commit-dropdown-iv-llc-dev-panel', function() {
                return Promise.all([
                    $9802583962909688$var$load("cNRxo")
                ]);
            }, function() {
                return Promise.all([
                    $9802583962909688$var$load("i8oWy")
                ]);
            }),
            (parcelRequire("avM1e"))('create_pullrequest_dropdown_iv_llc_dev_panel', function() {
                return Promise.all([
                    $9802583962909688$var$load("63C5i")
                ]);
            }, function() {
                return Promise.all([
                    $9802583962909688$var$load("lbT1q")
                ]);
            }),
            (parcelRequire("avM1e"))('create_pullrequest_dropdown_iv_llc_dev_panel', function() {
                return Promise.all([
                    $9802583962909688$var$load("63C5i")
                ]);
            }, function() {
                return Promise.all([
                    $9802583962909688$var$load("lbT1q")
                ]);
            }),
            (parcelRequire("avM1e"))('ff-action-dropdown-simple-iv-llc-dev-panel', function() {
                return Promise.all([
                    $9802583962909688$var$load("lIp00")
                ]);
            }, function() {
                return Promise.all([
                    $9802583962909688$var$load("cZoU9")
                ]);
            }),
            (parcelRequire("avM1e"))('ff-action-dropdown-simple-iv-llc-dev-panel', function() {
                return Promise.all([
                    $9802583962909688$var$load("lIp00")
                ]);
            }, function() {
                return Promise.all([
                    $9802583962909688$var$load("cZoU9")
                ]);
            }),
            (parcelRequire("avM1e"))('vulnerability-dropdown-iv-llc-dev-panel', function() {
                return Promise.all([
                    $9802583962909688$var$load("dsjsy")
                ]);
            }, function() {
                return Promise.all([
                    $9802583962909688$var$load("QeZ1l")
                ]);
            }),
            $9802583962909688$var$load("ckYFZ"),
            $9802583962909688$var$load("kvRbA"),
            $9802583962909688$var$load("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $9802583962909688$var$load("etgJj")
        ]);
    }),
    (parcelRequire("avM1e"))('details_loader_to_entrypoint_iv_llc_dev_panel', function() {
        return Promise.all([
            $9802583962909688$var$load("84z1X")
        ]);
    }, function() {
        return Promise.all([
            $9802583962909688$var$load("eBkr0")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $9802583962909688$var$load("czifk")
        ]);
    }, function() {
        return Promise.all([
            $9802583962909688$var$load("kcs34")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $9802583962909688$var$load("cTJTG"),
            $9802583962909688$var$load("l253H"),
            $9802583962909688$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $9802583962909688$var$load("4Qxp7")
        ]);
    }),
    (parcelRequire("avM1e"))('fix_versions_component_perf_improvement_vc90', function() {
        return Promise.all([
            $9802583962909688$var$load("6TXdv")
        ]);
    }, function() {
        return Promise.all([
            $9802583962909688$var$load("4t8fr")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $9802583962909688$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $9802583962909688$var$load("7B2gt")
        ]);
    }),
    (parcelRequire("avM1e"))('improve_issue_automation_button_iv_llc', function() {
        return Promise.all([
            $9802583962909688$var$load("5VTmG")
        ]);
    }, function() {
        return Promise.all([
            $9802583962909688$var$load("6mU2N"),
            $9802583962909688$var$load("kvRbA"),
            $9802583962909688$var$load("ffQaD")
        ]);
    }),
    (parcelRequire("avM1e"))('improve_issue_view_comment_ai', function() {
        return Promise.all([
            $9802583962909688$var$load("egvYO")
        ]);
    }, function() {
        return Promise.all([
            $9802583962909688$var$load("hkt2G")
        ]);
    }),
    (parcelRequire("avM1e"))('issue_comment_reply_list_sync_import', function() {
        return Promise.all([
            $9802583962909688$var$load("eZWUu")
        ]);
    }, function() {
        return Promise.all([
            $9802583962909688$var$load("aWylw")
        ]);
    }),
    (parcelRequire("avM1e"))('link_paste_recommendations', function() {
        return Promise.all([]);
    }, function() {
        return Promise.all([
            $9802583962909688$var$load("7ClEP")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-issue-view-child-issues-panel-entrypoint', function() {
        return Promise.all([
            $9802583962909688$var$load("fdfwb")
        ]);
    }, function() {
        return Promise.all([
            $9802583962909688$var$load("7TIhF")
        ]);
    }),
    $9802583962909688$var$load("5BNUw"),
    $9802583962909688$var$load("kGAgW"),
    $9802583962909688$var$load("3yAl4"),
    $9802583962909688$var$load("fliVL"),
    $9802583962909688$var$load("7mIf9"),
    $9802583962909688$var$load("jXweD"),
    $9802583962909688$var$load("jbxE1"),
    $9802583962909688$var$load("7imUH"),
    $9802583962909688$var$load("ffQaD"),
    $9802583962909688$var$load("kvRbA"),
    $9802583962909688$var$load("kVX56"),
    $9802583962909688$var$load("kNFvF"),
    $9802583962909688$var$load("76n7a"),
    $9802583962909688$var$load("l253H"),
    $9802583962909688$var$load("gaip1")
]).then(()=>parcelRequire('6qbjz'));

});

parcelRegister("eM5k0", function(module, exports) {

let $ac19ad244adbde65$var$load = (parcelRequire("28QjX"))(4);




module.exports = Promise.all([
    (parcelRequire("avM1e"))('thor_add_taskabort_events_for_core_experiences', function() {
        return Promise.all([
            $ac19ad244adbde65$var$load("kweCQ"),
            $ac19ad244adbde65$var$load("kNFvF")
        ]);
    }, function() {
        return Promise.all([
            $ac19ad244adbde65$var$load("1f7yF"),
            $ac19ad244adbde65$var$load("kNFvF")
        ]);
    }),
    (parcelRequire("avM1e"))('memo_fix_issue_field_remounts_2', function() {
        return Promise.all([
            $ac19ad244adbde65$var$load("1oP3P")
        ]);
    }, function() {
        return Promise.all([
            $ac19ad244adbde65$var$load("9ev6R")
        ]);
    }),
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $ac19ad244adbde65$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $ac19ad244adbde65$var$load("k6g9p")
        ]);
    }),
    (parcelRequire("avM1e"))('jirt-convert-class-to-functional-component', function() {
        return Promise.all([
            $ac19ad244adbde65$var$load("1ls92")
        ]);
    }, function() {
        return Promise.all([
            $ac19ad244adbde65$var$load("kLeYK")
        ]);
    }),
    $ac19ad244adbde65$var$load("ffQaD"),
    $ac19ad244adbde65$var$load("kvRbA"),
    $ac19ad244adbde65$var$load("bWP0X")
]).then(()=>parcelRequire('2555l'));

});

parcelRegister("ewPO9", function(module, exports) {

let $a93c3dcbda54d244$var$load = (parcelRequire("28QjX"))(4);






























module.exports = Promise.all([
    (parcelRequire("avM1e"))('memo_fix_issue_field_remounts_2', function() {
        return Promise.all([
            $a93c3dcbda54d244$var$load("1oP3P")
        ]);
    }, function() {
        return Promise.all([
            $a93c3dcbda54d244$var$load("9ev6R")
        ]);
    }),
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $a93c3dcbda54d244$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $a93c3dcbda54d244$var$load("k6g9p")
        ]);
    }),
    (parcelRequire("avM1e"))('redaction_onboarding_iv_llc', function() {
        return Promise.all([
            $a93c3dcbda54d244$var$load("czPin")
        ]);
    }, function() {
        return Promise.all([
            $a93c3dcbda54d244$var$load("iGvP4")
        ]);
    }),
    (parcelRequire("avM1e"))('jiv-20591-renderer-rerenders-fix-refactor', function() {
        return Promise.all([
            (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-small-nodes', function() {
                return Promise.all([
                    $a93c3dcbda54d244$var$load("d5z58"),
                    $a93c3dcbda54d244$var$load("kvRbA"),
                    $a93c3dcbda54d244$var$load("ffQaD"),
                    $a93c3dcbda54d244$var$load("l253H"),
                    $a93c3dcbda54d244$var$load("76n7a")
                ]);
            }, function() {
                return Promise.all([
                    $a93c3dcbda54d244$var$load("f771T")
                ]);
            }),
            (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-media-nodes', function() {
                return Promise.all([
                    $a93c3dcbda54d244$var$load("gXEyJ"),
                    $a93c3dcbda54d244$var$load("kvRbA"),
                    $a93c3dcbda54d244$var$load("ffQaD"),
                    $a93c3dcbda54d244$var$load("l253H"),
                    $a93c3dcbda54d244$var$load("76n7a")
                ]);
            }, function() {
                return Promise.all([
                    $a93c3dcbda54d244$var$load("hy7ba")
                ]);
            }),
            (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-card-nodes', function() {
                return Promise.all([
                    $a93c3dcbda54d244$var$load("lh7CA"),
                    $a93c3dcbda54d244$var$load("kNFvF"),
                    $a93c3dcbda54d244$var$load("kvRbA"),
                    $a93c3dcbda54d244$var$load("ffQaD"),
                    $a93c3dcbda54d244$var$load("l253H"),
                    $a93c3dcbda54d244$var$load("76n7a"),
                    $a93c3dcbda54d244$var$load("fliVL")
                ]);
            }, function() {
                return Promise.all([
                    $a93c3dcbda54d244$var$load("jrRVX")
                ]);
            }),
            $a93c3dcbda54d244$var$load("gDexj")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-small-nodes', function() {
                return Promise.all([
                    $a93c3dcbda54d244$var$load("d5z58"),
                    $a93c3dcbda54d244$var$load("kvRbA"),
                    $a93c3dcbda54d244$var$load("ffQaD"),
                    $a93c3dcbda54d244$var$load("l253H"),
                    $a93c3dcbda54d244$var$load("76n7a")
                ]);
            }, function() {
                return Promise.all([
                    $a93c3dcbda54d244$var$load("f771T")
                ]);
            }),
            (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-media-nodes', function() {
                return Promise.all([
                    $a93c3dcbda54d244$var$load("gXEyJ"),
                    $a93c3dcbda54d244$var$load("kvRbA"),
                    $a93c3dcbda54d244$var$load("ffQaD"),
                    $a93c3dcbda54d244$var$load("l253H"),
                    $a93c3dcbda54d244$var$load("76n7a")
                ]);
            }, function() {
                return Promise.all([
                    $a93c3dcbda54d244$var$load("hy7ba")
                ]);
            }),
            (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-card-nodes', function() {
                return Promise.all([
                    $a93c3dcbda54d244$var$load("lh7CA"),
                    $a93c3dcbda54d244$var$load("kNFvF"),
                    $a93c3dcbda54d244$var$load("kvRbA"),
                    $a93c3dcbda54d244$var$load("ffQaD"),
                    $a93c3dcbda54d244$var$load("l253H"),
                    $a93c3dcbda54d244$var$load("76n7a"),
                    $a93c3dcbda54d244$var$load("fliVL")
                ]);
            }, function() {
                return Promise.all([
                    $a93c3dcbda54d244$var$load("jrRVX")
                ]);
            }),
            $a93c3dcbda54d244$var$load("hyyp4")
        ]);
    }),
    (parcelRequire("avM1e"))('jira_amplitude_sr', function() {
        return Promise.all([
            $a93c3dcbda54d244$var$load("8EtZR"),
            $a93c3dcbda54d244$var$load("kVX56")
        ]);
    }, function() {
        return Promise.all([
            $a93c3dcbda54d244$var$load("6jOz3")
        ]);
    }),
    (parcelRequire("avM1e"))('jiv-20455-dev-panel-to-sync', function() {
        return Promise.all([
            (parcelRequire("avM1e"))('jiv-20508-remove-height-animation-dev-panel', function() {
                return Promise.all([
                    $a93c3dcbda54d244$var$load("hm756")
                ]);
            }, function() {
                return Promise.all([]);
            }),
            (parcelRequire("avM1e"))('create-branch-dropdown-iv-llc-dev-panel', function() {
                return Promise.all([
                    $a93c3dcbda54d244$var$load("46Z1D")
                ]);
            }, function() {
                return Promise.all([
                    $a93c3dcbda54d244$var$load("3DKoG")
                ]);
            }),
            (parcelRequire("avM1e"))('create-commit-dropdown-iv-llc-dev-panel', function() {
                return Promise.all([
                    $a93c3dcbda54d244$var$load("cNRxo")
                ]);
            }, function() {
                return Promise.all([
                    $a93c3dcbda54d244$var$load("i8oWy")
                ]);
            }),
            (parcelRequire("avM1e"))('create_pullrequest_dropdown_iv_llc_dev_panel', function() {
                return Promise.all([
                    $a93c3dcbda54d244$var$load("63C5i")
                ]);
            }, function() {
                return Promise.all([
                    $a93c3dcbda54d244$var$load("lbT1q")
                ]);
            }),
            (parcelRequire("avM1e"))('create_pullrequest_dropdown_iv_llc_dev_panel', function() {
                return Promise.all([
                    $a93c3dcbda54d244$var$load("63C5i")
                ]);
            }, function() {
                return Promise.all([
                    $a93c3dcbda54d244$var$load("lbT1q")
                ]);
            }),
            (parcelRequire("avM1e"))('ff-action-dropdown-simple-iv-llc-dev-panel', function() {
                return Promise.all([
                    $a93c3dcbda54d244$var$load("lIp00")
                ]);
            }, function() {
                return Promise.all([
                    $a93c3dcbda54d244$var$load("cZoU9")
                ]);
            }),
            (parcelRequire("avM1e"))('ff-action-dropdown-simple-iv-llc-dev-panel', function() {
                return Promise.all([
                    $a93c3dcbda54d244$var$load("lIp00")
                ]);
            }, function() {
                return Promise.all([
                    $a93c3dcbda54d244$var$load("cZoU9")
                ]);
            }),
            (parcelRequire("avM1e"))('vulnerability-dropdown-iv-llc-dev-panel', function() {
                return Promise.all([
                    $a93c3dcbda54d244$var$load("dsjsy")
                ]);
            }, function() {
                return Promise.all([
                    $a93c3dcbda54d244$var$load("QeZ1l")
                ]);
            }),
            $a93c3dcbda54d244$var$load("ckYFZ"),
            $a93c3dcbda54d244$var$load("kvRbA"),
            $a93c3dcbda54d244$var$load("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $a93c3dcbda54d244$var$load("etgJj")
        ]);
    }),
    (parcelRequire("avM1e"))('details_loader_to_entrypoint_iv_llc_dev_panel', function() {
        return Promise.all([
            $a93c3dcbda54d244$var$load("84z1X")
        ]);
    }, function() {
        return Promise.all([
            $a93c3dcbda54d244$var$load("eBkr0")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $a93c3dcbda54d244$var$load("czifk")
        ]);
    }, function() {
        return Promise.all([
            $a93c3dcbda54d244$var$load("kcs34")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $a93c3dcbda54d244$var$load("cTJTG"),
            $a93c3dcbda54d244$var$load("l253H"),
            $a93c3dcbda54d244$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $a93c3dcbda54d244$var$load("4Qxp7")
        ]);
    }),
    (parcelRequire("avM1e"))('fix_versions_component_perf_improvement_vc90', function() {
        return Promise.all([
            $a93c3dcbda54d244$var$load("6TXdv")
        ]);
    }, function() {
        return Promise.all([
            $a93c3dcbda54d244$var$load("4t8fr")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $a93c3dcbda54d244$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $a93c3dcbda54d244$var$load("7B2gt")
        ]);
    }),
    (parcelRequire("avM1e"))('improve_issue_automation_button_iv_llc', function() {
        return Promise.all([
            $a93c3dcbda54d244$var$load("5VTmG")
        ]);
    }, function() {
        return Promise.all([
            $a93c3dcbda54d244$var$load("6mU2N"),
            $a93c3dcbda54d244$var$load("kvRbA"),
            $a93c3dcbda54d244$var$load("ffQaD")
        ]);
    }),
    (parcelRequire("avM1e"))('improve_issue_view_comment_ai', function() {
        return Promise.all([
            $a93c3dcbda54d244$var$load("egvYO")
        ]);
    }, function() {
        return Promise.all([
            $a93c3dcbda54d244$var$load("hkt2G")
        ]);
    }),
    (parcelRequire("avM1e"))('issue_comment_reply_list_sync_import', function() {
        return Promise.all([
            $a93c3dcbda54d244$var$load("eZWUu")
        ]);
    }, function() {
        return Promise.all([
            $a93c3dcbda54d244$var$load("aWylw")
        ]);
    }),
    (parcelRequire("avM1e"))('link_paste_recommendations', function() {
        return Promise.all([]);
    }, function() {
        return Promise.all([
            $a93c3dcbda54d244$var$load("7ClEP")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-issue-view-child-issues-panel-entrypoint', function() {
        return Promise.all([
            $a93c3dcbda54d244$var$load("fdfwb")
        ]);
    }, function() {
        return Promise.all([
            $a93c3dcbda54d244$var$load("7TIhF")
        ]);
    }),
    $a93c3dcbda54d244$var$load("3yAl4"),
    $a93c3dcbda54d244$var$load("fliVL"),
    $a93c3dcbda54d244$var$load("7mIf9"),
    $a93c3dcbda54d244$var$load("jXweD"),
    $a93c3dcbda54d244$var$load("jbxE1"),
    $a93c3dcbda54d244$var$load("7imUH"),
    $a93c3dcbda54d244$var$load("5BNUw"),
    $a93c3dcbda54d244$var$load("kGAgW"),
    $a93c3dcbda54d244$var$load("kVX56"),
    $a93c3dcbda54d244$var$load("ffQaD"),
    $a93c3dcbda54d244$var$load("kvRbA"),
    $a93c3dcbda54d244$var$load("76n7a"),
    $a93c3dcbda54d244$var$load("l253H"),
    $a93c3dcbda54d244$var$load("kNFvF"),
    $a93c3dcbda54d244$var$load("l3N0m")
]).then(()=>parcelRequire('kMGHs'));

});

parcelRegister("hBQJM", function(module, exports) {

let $cd1eccf09b15948b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cd1eccf09b15948b$var$load("kcnqS").then(()=>parcelRequire('4n6tJ'));

});


/**
 * @deprecated sharing routes between products leads to over-fetching resources. Please define
 * routes per-product and only define the resources + navigation components required for that product instead.
 */ const $0c2b5b2aa81ed54b$export$9ab1d1d726b36319 = 'GENERIC_PROJECT_HORIZONTAL_NAV';
const $0c2b5b2aa81ed54b$export$712453ef44fd2eba = 'GENERIC_BUSINESS_TRANSITIONAL_PROJECT_HORIZONTAL_NAV';

parcelRegister("hBv66", function(module, exports) {

$parcel$export(module.exports, "genericProjectSidebars", () => $0b920001492d0ef4$export$d88d2d25355bc89a);
$parcel$export(module.exports, "classicBoardSidebars", () => $0b920001492d0ef4$export$c04daf123cec1f1e);
$parcel$export(module.exports, "genericConnectSidebars", () => $0b920001492d0ef4$export$844d342b575ead35);

var $cin8p = parcelRequire("cin8p");

var $dmKXV = parcelRequire("dmKXV");

var $iHiHz = parcelRequire("iHiHz");

var $cOg46 = parcelRequire("cOg46");

var $koWFd = parcelRequire("koWFd");

var $h0bZU = parcelRequire("h0bZU");

var $9s3j1 = parcelRequire("9s3j1");

var $2IHt2 = parcelRequire("2IHt2");
const $0b920001492d0ef4$export$d88d2d25355bc89a = [
    // delete when cleaning up getWillShowNav4
    (0, $dmKXV.default),
    (0, $koWFd.default),
    (0, $h0bZU.default),
    (0, $9s3j1.default),
    (0, $2IHt2.default)
];
const $0b920001492d0ef4$export$c04daf123cec1f1e = [
    (0, $9s3j1.default),
    (0, $2IHt2.default)
];
const $0b920001492d0ef4$export$844d342b575ead35 = [
    ...$0b920001492d0ef4$export$d88d2d25355bc89a,
    (0, $cin8p.default),
    (0, $iHiHz.default),
    (0, $cOg46.default)
];

});
parcelRegister("cin8p", function(module, exports) {

$parcel$export(module.exports, "default", () => $760a63d3e4200cc2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

const $760a63d3e4200cc2$var$LazyConnectSidebar = (0, $kxZPA.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("jhHny")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/connect/src/index.tsx"
});
const $760a63d3e4200cc2$var$ConnectSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "connect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($760a63d3e4200cc2$var$LazyConnectSidebar, null)));
$760a63d3e4200cc2$var$ConnectSidebar.displayName = 'ConnectSidebar';
var $760a63d3e4200cc2$export$2e2bcd8739ae039 = $760a63d3e4200cc2$var$ConnectSidebar;

});
parcelRegister("jhHny", function(module, exports) {

let $e0a141047770dd76$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e0a141047770dd76$var$load("ffQaD"),
    $e0a141047770dd76$var$load("kvRbA"),
    $e0a141047770dd76$var$load("76n7a"),
    $e0a141047770dd76$var$load("l253H"),
    $e0a141047770dd76$var$load("cg4eD")
]).then(()=>parcelRequire('caET0'));

});


parcelRegister("2IHt2", function(module, exports) {

$parcel$export(module.exports, "default", () => $8627747b0236ab96$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

const $8627747b0236ab96$var$LazyUserSidebar = (0, $kxZPA.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("1kiam")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/user/src/index.tsx"
});
const $8627747b0236ab96$var$UserSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "user"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8627747b0236ab96$var$LazyUserSidebar, null)));
$8627747b0236ab96$var$UserSidebar.displayName = 'UserSidebar';
var $8627747b0236ab96$export$2e2bcd8739ae039 = $8627747b0236ab96$var$UserSidebar;

});
parcelRegister("1kiam", function(module, exports) {

let $0f75c01c3d1025dd$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0f75c01c3d1025dd$var$load("kNFvF"),
    $0f75c01c3d1025dd$var$load("ffQaD"),
    $0f75c01c3d1025dd$var$load("kvRbA"),
    $0f75c01c3d1025dd$var$load("kVX56"),
    $0f75c01c3d1025dd$var$load("76n7a"),
    $0f75c01c3d1025dd$var$load("l253H"),
    $0f75c01c3d1025dd$var$load("hY1ov")
]).then(()=>parcelRequire('3AQ56'));

});



parcelRegister("1aAOt", function(module, exports) {

$parcel$export(module.exports, "getOfferingCatalogueFeaturesResource", () => $3095ecb31c5b9ef2$export$d08a9fee651d30b2);

var $2M1hQ = parcelRequire("2M1hQ");


const $3095ecb31c5b9ef2$var$getDataLoader = ()=>(parcelRequire("gDJIx"));
const $3095ecb31c5b9ef2$export$ec991c565cf31550 = (0, $2M1hQ.createResource)({
    type: (0, $2e493fb3532188a0$export$23978b67a6b2068f),
    getKey: ()=>'state',
    getDataLoader: $3095ecb31c5b9ef2$var$getDataLoader,
    maxAge: 1800000
});
const $3095ecb31c5b9ef2$export$d08a9fee651d30b2 = ()=>[];

});
const $2e493fb3532188a0$export$23978b67a6b2068f = 'RESOURCE_TYPE_OFFERING_CATALOGUE_FEATURES';

parcelRegister("gDJIx", function(module, exports) {

let $c1d3c05a0654045c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c1d3c05a0654045c$var$load("60ISK").then(()=>parcelRequire('8OVUQ'));

});


parcelRegister("fw7Rx", function(module, exports) {

$parcel$export(module.exports, "browseIssueRoute", () => $b546ef0893c1765d$export$2c9c7e50a88e588b);
const $b546ef0893c1765d$export$2c9c7e50a88e588b = {
    name: 'issue',
    path: '/browse/:issueKey(\\w+-\\d+)(.*)?',
    query: [
        'filter?!=(.*)',
        'jql?!=(.*)'
    ]
};

});


parcelRegister("igqAf", function(module, exports) {

$parcel$export(module.exports, "browseProjectRedirectRouteEntry", () => $7846fd35a7cb282e$export$f9891419b34ab305);

var $ffza4 = parcelRequire("ffza4");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $1WlLE = parcelRequire("1WlLE");

var $iN5FK = parcelRequire("iN5FK");

var $7MCPm = parcelRequire("7MCPm");
const $7846fd35a7cb282e$export$f9891419b34ab305 = (0, $7NszV.createEntry)((0, $iN5FK.browseProjectRedirectRoute), ()=>({
        group: 'redirects',
        isRedirect: true,
        component: (0, $7MCPm.RedirectToLastVisitedProjectPage),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $1WlLE.queuesNavigationItems),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("iN5FK", function(module, exports) {

$parcel$export(module.exports, "browseProjectRedirectRoute", () => $84aa7aa5982a6e60$export$f9cac37753487f39);
const $84aa7aa5982a6e60$export$f9cac37753487f39 = {
    name: 'browse-project-redirect',
    path: "/browse/:projectKey([0-9a-zA-Z_$.+!*']+)",
    exact: true
};

});

parcelRegister("7MCPm", function(module, exports) {

$parcel$export(module.exports, "RedirectToLastVisitedProjectPage", () => $4c121c4cc7d1faa6$export$86041af020f4c959);

var $5uXOq = parcelRequire("5uXOq");

var $hqxtv = parcelRequire("hqxtv");
const $4c121c4cc7d1faa6$export$86041af020f4c959 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hqxtv.default), null);

});
parcelRegister("hqxtv", function(module, exports) {

$parcel$export(module.exports, "default", () => $bda9d95137e1a17a$export$2e2bcd8739ae039);

var $1bQGJ = parcelRequire("1bQGJ");

var $aNBa3 = parcelRequire("aNBa3");
var $bda9d95137e1a17a$export$2e2bcd8739ae039 = (0, $1bQGJ.withRouter)((0, $aNBa3.default));

});
parcelRegister("aNBa3", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d9c467899b3389b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $ebyGx = parcelRequire("ebyGx");

var $fNobW = parcelRequire("fNobW");

var $fDtbf = parcelRequire("fDtbf");

var $kUU4G = parcelRequire("kUU4G");

var $4Pf62 = parcelRequire("4Pf62");

var $2YZCu = parcelRequire("2YZCu");

var $7f4tk = parcelRequire("7f4tk");


var $ebbSc = parcelRequire("ebbSc");
const $8d9c467899b3389b$var$buildEndpoint = (projectKey, initialRedirect)=>`/rest/internal/2/projectlandingpage/${projectKey}${initialRedirect ? '?initialRedirect=true' : ''}`;
const $8d9c467899b3389b$var$allowListedSearchParams = [
    (0, $0592ef8772eedefd$export$29d3926e3d72cfb),
    (0, $0592ef8772eedefd$export$b3233b76460c1e7c)
];
const $8d9c467899b3389b$var$redirectForAnonymousUser = (projectKey, history, startTime)=>{
    const destination = `/projects/${projectKey}/issues/?filter=allissues`;
    history.replace(destination);
    // Log success
    (0, $2YZCu.default).safeInfoWithoutCustomerData((0, $0592ef8772eedefd$export$25a759e49d5049db), 'History replace correctly triggered for anonymous user', {
        requestTime: (0, $ebbSc.getNow)() - startTime,
        destination: destination
    });
};
const $8d9c467899b3389b$export$c79af62ad7a1fe8a = (query)=>Object.fromEntries(Object.entries(query).filter(([key])=>$8d9c467899b3389b$var$allowListedSearchParams.some((allowedParam)=>key === allowedParam) || key.includes((0, $0592ef8772eedefd$export$29d3926e3d72cfb))));
const $8d9c467899b3389b$export$283f1587d7a5369f = (searchQuery, queryInitializer)=>{
    const queryKeys = new URLSearchParams(searchQuery).toString();
    return queryKeys.length > 0 ? `${queryInitializer}${queryKeys}` : '';
};
class $8d9c467899b3389b$export$bf8d1fdc3b47a835 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { history: history, location: location, query: query, match: { params: params } } = this.props;
        // First time a project is created
        const { initial: initial } = query;
        // Clear the SSR Ready Mark if present
        (0, $kUU4G.default)((0, $fDtbf.SPA_SSR_RENDERED_MARK));
        const startTime = (0, $ebbSc.getNow)();
        const projectKey = // @ts-expect-error - TS2345 - Argument of type 'string | {}' is not assignable to parameter of type 'string'.
        params.projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse((0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(location, 'search', {})).projectKey;
        if (!params.projectKey) (0, $2YZCu.default).safeInfoWithoutCustomerData((0, $0592ef8772eedefd$export$25a759e49d5049db), 'queryString', {
            duration: (0, $ebbSc.getNow)() - startTime
        });
        if (projectKey) (0, $7f4tk.default)($8d9c467899b3389b$var$buildEndpoint(projectKey, !!initial)).then((response)=>{
            const endTime = (0, $ebbSc.getNow)();
            let searchQueryParams = '';
            const searchQuery = $8d9c467899b3389b$export$c79af62ad7a1fe8a(query);
            const queryInitializer = response.data.url.includes('?') ? '&' : '?';
            searchQueryParams = $8d9c467899b3389b$export$283f1587d7a5369f(searchQuery, queryInitializer);
            const destination = response.data.url + searchQueryParams;
            history.replace(destination);
            // Log success
            (0, $2YZCu.default).safeInfoWithoutCustomerData((0, $0592ef8772eedefd$export$25a759e49d5049db), 'History replace correctly triggered', {
                requestTime: endTime - startTime,
                destination: destination
            });
        }, (error)=>{
            const endTime = (0, $ebbSc.getNow)();
            if ((0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)().isAnonymous) $8d9c467899b3389b$var$redirectForAnonymousUser(projectKey, history, startTime);
            else // Log failures
            (0, $2YZCu.default).safeErrorWithoutCustomerData((0, $0592ef8772eedefd$export$25a759e49d5049db), `Error on request. Request time: ${endTime - startTime}`, error);
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
            name: "last-visited-project-page-redirect"
        });
    }
}
var $8d9c467899b3389b$export$2e2bcd8739ae039 = $8d9c467899b3389b$export$bf8d1fdc3b47a835;

});
const $0592ef8772eedefd$export$25a759e49d5049db = 'spa-apps.common.redirect.last-visited-project-page';
const $0592ef8772eedefd$export$29d3926e3d72cfb = 'search';
const $0592ef8772eedefd$export$b3233b76460c1e7c = 'showProjectBuilder';

parcelRegister("ebbSc", function(module, exports) {

$parcel$export(module.exports, "getNow", () => $fa5a995d36ebfbde$export$3991332aae1fc754);
const $fa5a995d36ebfbde$export$3991332aae1fc754 = ()=>Date.now();

});





parcelRegister("h3WYk", function(module, exports) {

$parcel$export(module.exports, "browseStandardFlowsRouteEntry", () => $f631f32c4725afe5$export$6a572c5bc9ffe9da);

var $c04PQ = parcelRequire("c04PQ");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $1r8X1 = parcelRequire("1r8X1");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $dhfPL = parcelRequire("dhfPL");

var $8HI9m = parcelRequire("8HI9m");

var $lkFvK = parcelRequire("lkFvK");

var $k6R7C = parcelRequire("k6R7C");
const $f631f32c4725afe5$var$browseStandardFlowsPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $8HI9m.browseStandardFlowsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $f631f32c4725afe5$export$6a572c5bc9ffe9da = (0, $7NszV.createEntry)((0, $1r8X1.browseStandardFlowsRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $c04PQ.isFedRamp)()) return undefined;
            return $f631f32c4725afe5$var$browseStandardFlowsPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $k6R7C.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $dhfPL.VirtualAgentBrowseStandardFlowsSkeleton),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }));

});
parcelRegister("dhfPL", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentBrowseStandardFlowsSkeleton", () => $42ac2f7c560a8df6$export$c2bd83dd149452bd);
/* VirtualAgentBrowseStandardFlowsSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $l6Vlb = parcelRequire("l6Vlb");
const $42ac2f7c560a8df6$var$customCssStyles = null;
const $42ac2f7c560a8df6$export$c2bd83dd149452bd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($l6Vlb))),
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("l6Vlb", function(module, exports) {
module.exports = new URL("virtual-agent-browse-standard-flows-app-skeleton.tpl.51e6e95a.svg", import.meta.url).toString();

});


parcelRegister("8HI9m", function(module, exports) {

$parcel$export(module.exports, "browseStandardFlowsEntryPoint", () => $32e48f8946c41f01$export$f7de8593c7455f1);

var $iARRY = parcelRequire("iARRY");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $32e48f8946c41f01$export$f7de8593c7455f1 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("csU99")), {
        moduleId: "c2d13204",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $iARRY.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey?.toUpperCase() ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("iARRY", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e33e127e8847987$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<33233bbde56426b21cb0cf7548a863c8>>
 * @relayHash 8658a1d9e0b503030f122af7546f7fa3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b2740e61056af93841794a91099e9b96903f93d7fe50bb2475c769a63f9f5288

var $7oHmH = parcelRequire("7oHmH");
const $4e33e127e8847987$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "b2740e61056af93841794a91099e9b96903f93d7fe50bb2475c769a63f9f5288",
        "metadata": {},
        "name": "srcVirtualAgentBrowseStandardFlowsQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $7oHmH.default)
        }
    }
};
var $4e33e127e8847987$export$2e2bcd8739ae039 = $4e33e127e8847987$var$node;

});

parcelRegister("csU99", function(module, exports) {

let $9133a720fb97f7fc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9133a720fb97f7fc$var$load("afT8l").then(()=>parcelRequire('exMWS'));

});



parcelRegister("dUuHj", function(module, exports) {

$parcel$export(module.exports, "classicBusinessOverviewCalendarRouteEntry", () => $8bbf45fcd3a87ffb$export$93f05037a457ce22);

var $l71WK = parcelRequire("l71WK");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $8bcrt = parcelRequire("8bcrt");

var $lkFvK = parcelRequire("lkFvK");

var $4tESa = parcelRequire("4tESa");
const $8bbf45fcd3a87ffb$var$overviewCalendarPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $4tESa.overviewCalendarEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $8bbf45fcd3a87ffb$export$93f05037a457ce22 = (0, $7NszV.createEntry)((0, $8bcrt.classicBusinessOverviewCalendarRoute), ()=>({
        group: 'classic-business',
        layout: (0, $2BrOV.globalLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $l71WK.AsyncHorizontalOverviewNav)
        },
        resources: (0, $lNicp.getOverviewViewResources)(),
        entryPoint: ()=>$8bbf45fcd3a87ffb$var$overviewCalendarPageEntrypoint
    }));

});
parcelRegister("aVFIE", function(module, exports) {

$parcel$export(module.exports, "ThemedLazySkeleton", () => $136611be2ae39444$export$ddeb5d943c4f17e3);
/* ThemedLazySkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fNobW = parcelRequire("fNobW");

var $lob44 = parcelRequire("lob44");
const $136611be2ae39444$export$ddeb5d943c4f17e3 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($136611be2ae39444$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "themed-spinner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lob44.ThemedSpinner), null))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $136611be2ae39444$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1osq _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lob44", function(module, exports) {

$parcel$export(module.exports, "ThemedSpinner", () => $150e941eee16207a$export$271c7b154ad6c401);
/* ThemedSpinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");
const $150e941eee16207a$export$271c7b154ad6c401 = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($150e941eee16207a$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "large",
        ...props,
        testId: "project-theme-components.ui.themed-spinner"
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $150e941eee16207a$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1xjgvy9e",
            __cmplp.className
        ])
    });
});

});


parcelRegister("8bcrt", function(module, exports) {

$parcel$export(module.exports, "classicBusinessOverviewCalendarRoute", () => $c0fa680257c9f3d1$export$61383e5418d2ffe3);
const $c0fa680257c9f3d1$export$61383e5418d2ffe3 = {
    name: 'classic-business-overview-calendar',
    path: '/jira/core/overviews/:overviewId/calendar',
    exact: true
};

});

parcelRegister("4tESa", function(module, exports) {

$parcel$export(module.exports, "overviewCalendarEntrypoint", () => $9344d5422559b8bf$export$b7094a9bdb66fbad);

var $2OZhN = parcelRequire("2OZhN");

var $dnOYu = parcelRequire("dnOYu");

var $fEDBv = parcelRequire("fEDBv");

const $9344d5422559b8bf$export$b7094a9bdb66fbad = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("kQup3")), {
        moduleId: "a9cf6a8e",
        priority: "userVisible"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId } })=>{
        return {
            queries: {
                overviewCalendarQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $dnOYu.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        };
    }
});

});
parcelRegister("dnOYu", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a44115091e7f597$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e514564c1688822aea8c6efba8699694>>
 * @relayHash 466f1e55c408e59be27b44b8156f9147
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 82d517df2c5a9cef088b63278282f98c94356907ff3ba4c909173bfd3d9477f7
const $7a44115091e7f597$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "82d517df2c5a9cef088b63278282f98c94356907ff3ba4c909173bfd3d9477f7",
        "metadata": {},
        "name": "src_jiraBusinessOverviewCalendarQuery",
        "operationKind": "query",
        "text": null
    }
};
var $7a44115091e7f597$export$2e2bcd8739ae039 = $7a44115091e7f597$var$node;

});

parcelRegister("kQup3", function(module, exports) {

let $f2d03f5fa37d8278$var$load = (parcelRequire("28QjX"))(4);

module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $f2d03f5fa37d8278$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $f2d03f5fa37d8278$var$load("k6g9p")
        ]);
    }),
    $f2d03f5fa37d8278$var$load("ffQaD"),
    $f2d03f5fa37d8278$var$load("kvRbA"),
    $f2d03f5fa37d8278$var$load("76n7a"),
    $f2d03f5fa37d8278$var$load("l253H"),
    $f2d03f5fa37d8278$var$load("2qAni")
]).then(()=>parcelRequire('UcTEy'));

});



parcelRegister("eiK9n", function(module, exports) {

$parcel$export(module.exports, "classicBusinessOverviewSummaryRouteEntry", () => $e86d6c5f1551d7af$export$f8fd32e123428b9a);

var $l71WK = parcelRequire("l71WK");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $a8LXv = parcelRequire("a8LXv");

var $lkFvK = parcelRequire("lkFvK");

var $eQQpY = parcelRequire("eQQpY");
const $e86d6c5f1551d7af$var$overviewSummaryPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $eQQpY.overviewSummaryEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $e86d6c5f1551d7af$export$f8fd32e123428b9a = (0, $7NszV.createEntry)((0, $a8LXv.classicBusinessOverviewSummaryRoute), ()=>({
        group: 'classic-business',
        layout: (0, $2BrOV.globalLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $l71WK.AsyncHorizontalOverviewNav)
        },
        resources: (0, $lNicp.getOverviewViewResources)(),
        entryPoint: ()=>$e86d6c5f1551d7af$var$overviewSummaryPageEntrypoint
    }));

});
parcelRegister("a8LXv", function(module, exports) {

$parcel$export(module.exports, "classicBusinessOverviewSummaryRoute", () => $64a453e593a46414$export$4a86e6b12ce49af9);
const $64a453e593a46414$export$4a86e6b12ce49af9 = {
    name: 'classic-business-overview-summary',
    path: '/jira/core/overviews/:overviewId/summary',
    exact: true
};

});

parcelRegister("eQQpY", function(module, exports) {

$parcel$export(module.exports, "overviewSummaryEntrypoint", () => $d80730b6496fafc5$export$3793bbcc33b62692);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $d80730b6496fafc5$export$3793bbcc33b62692 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("9Z1NC")), {
        moduleId: "5d9f07b1",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9Z1NC", function(module, exports) {

let $744b34db6938105d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $744b34db6938105d$var$load("ffQaD"),
    $744b34db6938105d$var$load("kvRbA"),
    $744b34db6938105d$var$load("hxiOL")
]).then(()=>parcelRequire('6QJpB'));

});



parcelRegister("4KinX", function(module, exports) {

$parcel$export(module.exports, "classicBusinessOverviewTimelineRouteEntry", () => $068b485441948b61$export$9d9d562e489097b3);

var $l71WK = parcelRequire("l71WK");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $8s9V5 = parcelRequire("8s9V5");

var $lkFvK = parcelRequire("lkFvK");

var $bB7nn = parcelRequire("bB7nn");
const $068b485441948b61$var$overviewTimelinePageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $bB7nn.overviewTimelineEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $068b485441948b61$export$9d9d562e489097b3 = (0, $7NszV.createEntry)((0, $8s9V5.classicBusinessOverviewTimelineRoute), ()=>({
        group: 'classic-business',
        layout: (0, $2BrOV.globalLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $l71WK.AsyncHorizontalOverviewNav)
        },
        resources: (0, $lNicp.getOverviewViewResources)(),
        entryPoint: ()=>$068b485441948b61$var$overviewTimelinePageEntrypoint
    }));

});
parcelRegister("8s9V5", function(module, exports) {

$parcel$export(module.exports, "classicBusinessOverviewTimelineRoute", () => $2de2a62458dcdd8a$export$13f0c823ff3059c2);
const $2de2a62458dcdd8a$export$13f0c823ff3059c2 = {
    name: 'classic-business-overview-timeline',
    path: '/jira/core/overviews/:overviewId/timeline',
    exact: true
};

});

parcelRegister("bB7nn", function(module, exports) {

$parcel$export(module.exports, "overviewTimelineEntrypoint", () => $41c8e0eb43e05110$export$d00505893f9d5d11);

var $2OZhN = parcelRequire("2OZhN");

var $gfPQt = parcelRequire("gfPQt");

var $fEDBv = parcelRequire("fEDBv");

const $41c8e0eb43e05110$export$d00505893f9d5d11 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("7bTJJ")), {
        moduleId: "ae6650bb",
        priority: "userVisible"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId } })=>{
        return {
            queries: {
                overviewTimelineQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $gfPQt.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        };
    }
});

});
parcelRegister("gfPQt", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a8e66778cabfaa5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<eb4ae6aae065c938f532a846255332dc>>
 * @relayHash 007933a1073bb512097f0e95cf95622d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 554086782541cb72a7484650860ffea7ea940346b5eb77793d5681f9e287d807
const $0a8e66778cabfaa5$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "554086782541cb72a7484650860ffea7ea940346b5eb77793d5681f9e287d807",
        "metadata": {},
        "name": "src_jiraBusinessOverviewTimelineQuery",
        "operationKind": "query",
        "text": null
    }
};
var $0a8e66778cabfaa5$export$2e2bcd8739ae039 = $0a8e66778cabfaa5$var$node;

});

parcelRegister("7bTJJ", function(module, exports) {

let $53c4cb998bd718c1$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $53c4cb998bd718c1$var$load("ffQaD"),
    $53c4cb998bd718c1$var$load("kvRbA"),
    $53c4cb998bd718c1$var$load("hpJtK")
]).then(()=>parcelRequire('ge8BQ'));

});



parcelRegister("d6K18", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProformaIssueFormsDirectEmbedRouteEntry", () => $93eb6540105b9307$export$99ff9a6f448db95c);

var $6e4Kt = parcelRequire("6e4Kt");

var $7NszV = parcelRequire("7NszV");

var $dxCvy = parcelRequire("dxCvy");

var $gtobw = parcelRequire("gtobw");

var $edJLT = parcelRequire("edJLT");
const $93eb6540105b9307$export$99ff9a6f448db95c = (0, $7NszV.createEntry)((0, $gtobw.classicBusinessProformaIssueFormsDirectEmbedRoute), ()=>({
        group: 'classic-business',
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            (0, $dxCvy.projectContextResource)
        ],
        component: (0, $edJLT.default),
        forPaint: [
            (0, $edJLT.LazyProformaIssueFormsDirectEmbed)
        ],
        perfMetricKey: 'issue-forms-direct-embed'
    }));

});
parcelRegister("gtobw", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProformaIssueFormsDirectEmbedRoute", () => $221926f6dc9630e3$export$92c0120052644a60);
const $221926f6dc9630e3$export$92c0120052644a60 = {
    name: 'classic-business-proforma-issue-forms-direct-embed',
    path: '/jira/core/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?/embed',
    exact: true
};

});

parcelRegister("edJLT", function(module, exports) {

$parcel$export(module.exports, "LazyProformaIssueFormsDirectEmbed", () => $321227a7cf9935db$export$22681210aaeb910f);
$parcel$export(module.exports, "default", () => $321227a7cf9935db$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $321227a7cf9935db$export$22681210aaeb910f = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("8yRRM")), {
    moduleId: "./src/packages/spa-apps/proforma-issue-forms-direct-embed/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$321227a7cf9935db$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $321227a7cf9935db$export$22681210aaeb910f,
        pageId: "proforma-issue-forms-direct-embed",
        shouldShowSpinner: true
    });

});
parcelRegister("8yRRM", function(module, exports) {

let $63bb487a59f60267$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $63bb487a59f60267$var$load("76n7a"),
    $63bb487a59f60267$var$load("l253H"),
    $63bb487a59f60267$var$load("3HzNK")
]).then(()=>parcelRequire('4RuJw'));

});



parcelRegister("lIfPP", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProformaIssueFormsDirectRouteEntry", () => $f6035edc22ca57c1$export$8aa48763ac761f64);

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $dxCvy = parcelRequire("dxCvy");

var $e3tm3 = parcelRequire("e3tm3");

var $6VQ64 = parcelRequire("6VQ64");
const $f6035edc22ca57c1$export$8aa48763ac761f64 = (0, $7NszV.createEntry)((0, $e3tm3.classicBusinessProformaIssueFormsDirectRoute), ()=>({
        group: 'classic-business',
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            (0, $dxCvy.projectContextResource)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        entryPoint: ()=>(0, $6VQ64.proformaIssueFormsDirectPageEntryPoint),
        perfMetricKey: 'issue-forms-direct'
    }));

});
parcelRegister("e3tm3", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProformaIssueFormsDirectRoute", () => $2adcae99a9770e81$export$97a413d49241d03b);
const $2adcae99a9770e81$export$97a413d49241d03b = {
    name: 'classic-business-proforma-issue-forms-direct',
    path: '/jira/core/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?',
    exact: true
};

});

parcelRegister("6VQ64", function(module, exports) {

$parcel$export(module.exports, "proformaIssueFormsDirectPageEntryPoint", () => $33e9f81a484baab5$export$dc0bb5719ae7aab4);

var $1aJjB = parcelRequire("1aJjB");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");
const $33e9f81a484baab5$export$dc0bb5719ae7aab4 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1aJjB.proformaIssueFormsDirectEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("1aJjB", function(module, exports) {

$parcel$export(module.exports, "proformaIssueFormsDirectEntryPoint", () => $47ed6b158c55f88b$export$2a51bba458da5928);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $47ed6b158c55f88b$export$2a51bba458da5928 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("84CrK")), {
        moduleId: "3047b51f",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("84CrK", function(module, exports) {

let $5e0c851fb68ad494$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $5e0c851fb68ad494$var$load("76n7a"),
    $5e0c851fb68ad494$var$load("l253H"),
    $5e0c851fb68ad494$var$load("309Ge")
]).then(()=>parcelRequire('izbAs'));

});




parcelRegister("6IB0N", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectApprovalsRouteEntry", () => $89b695e5f9f3673a$export$563b4fef899fe540);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $hsU7j = parcelRequire("hsU7j");

var $8roOm = parcelRequire("8roOm");
const $89b695e5f9f3673a$export$563b4fef899fe540 = (0, $7NszV.createEntry)((0, $hsU7j.classicBusinessProjectApprovalsRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.approvals-view',
        layout: (0, $lRPBw.businessProjectLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: (0, $lNicp.getProjectViewResources)(),
        entryPoint: ()=>(0, $8roOm.approvalsPageEntryPoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("lRPBw", function(module, exports) {

$parcel$export(module.exports, "businessProjectLayout", () => $d0bc40d3dc70d875$export$dfb0c3e0348f4429);

var $2vSU6 = parcelRequire("2vSU6");

var $1Du13 = parcelRequire("1Du13");

var $aPfsS = parcelRequire("aPfsS");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d0bc40d3dc70d875$var$Onboarding = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("b8Tmv")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/business-project-layout/src/ui/onboarding/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d0bc40d3dc70d875$var$withAnyBusinessProjectContext = (Component)=>(0, $aPfsS.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $2vSU6.CORE_PROJECT)
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d0bc40d3dc70d875$var$RightSidebars = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("lgXhK")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/business-project-layout/src/ui/right-sidebars/index.tsx"
});
const $d0bc40d3dc70d875$var$BusinessOnboarding = $d0bc40d3dc70d875$var$withAnyBusinessProjectContext($d0bc40d3dc70d875$var$Onboarding);
const $d0bc40d3dc70d875$var$nonSettingsRightSidebars = [
    $d0bc40d3dc70d875$var$withAnyBusinessProjectContext($d0bc40d3dc70d875$var$RightSidebars)
];
const $d0bc40d3dc70d875$var$sharedBusinessProjectLayout = (0, $aPfsS.composeLayouts)((0, $1Du13.projectLayout));
const $d0bc40d3dc70d875$export$dfb0c3e0348f4429 = (0, $aPfsS.composeLayouts)($d0bc40d3dc70d875$var$sharedBusinessProjectLayout, {
    rightSidebars: $d0bc40d3dc70d875$var$nonSettingsRightSidebars,
    globalComponents: [
        $d0bc40d3dc70d875$var$BusinessOnboarding
    ]
});

});
parcelRegister("b8Tmv", function(module, exports) {

let $81cb62d0e10c7f6d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $81cb62d0e10c7f6d$var$load("bX0C0").then(()=>parcelRequire('3PxNF'));

});

parcelRegister("lgXhK", function(module, exports) {

let $f7c91463c7d493b3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f7c91463c7d493b3$var$load("cCg53").then(()=>parcelRequire('lktzL'));

});


parcelRegister("hsU7j", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectApprovalsRoute", () => $5bb44f21c5956447$export$3109a183a442a02d);
const $5bb44f21c5956447$export$3109a183a442a02d = {
    name: 'classic-business-approvals',
    path: '/jira/core/projects/:projectKey/approvals',
    exact: true
};

});

parcelRegister("8roOm", function(module, exports) {

$parcel$export(module.exports, "approvalsPageEntryPoint", () => $09fa0192771673de$export$52c40d37705be5fa);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $4gsaJ = parcelRequire("4gsaJ");

var $fo6b8 = parcelRequire("fo6b8");
const $09fa0192771673de$export$52c40d37705be5fa = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $4gsaJ.approvalsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("4gsaJ", function(module, exports) {

$parcel$export(module.exports, "approvalsEntryPoint", () => $300bb28bd2b40101$export$25d4a03de93a440e);

var $dFopv = parcelRequire("dFopv");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $300bb28bd2b40101$export$25d4a03de93a440e = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("hfG9c")), {
        moduleId: "6a9ba200",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                approvalsQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $dFopv.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("dFopv", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cf737eba0cc3036$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fc6e2d903d7a5160ec3c02b7156848e4>>
 * @relayHash 2cc1b2be473185de0346970d79002539
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2a7b24f841e6d55f0b788183900c0f5208b596d9f5efe804ede9c194b19f5e8d
const $4cf737eba0cc3036$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "2a7b24f841e6d55f0b788183900c0f5208b596d9f5efe804ede9c194b19f5e8d",
        "metadata": {},
        "name": "src_jiraBusinessApprovalsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $4cf737eba0cc3036$export$2e2bcd8739ae039 = $4cf737eba0cc3036$var$node;

});

parcelRegister("hfG9c", function(module, exports) {

let $c8f487f94027b071$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c8f487f94027b071$var$load("gpVrA").then(()=>parcelRequire('iJtUd'));

});




parcelRegister("1sFpf", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormBuilderRouteEntry", () => $b4b68e41808a2055$export$9eb15893d080e73b);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $a2PcO = parcelRequire("a2PcO");

var $d9uEV = parcelRequire("d9uEV");
const $b4b68e41808a2055$export$9eb15893d080e73b = (0, $7NszV.createEntry)((0, $a2PcO.classicBusinessProjectFormBuilderRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.form-view',
        layout: (0, $lRPBw.businessProjectLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: (0, $lNicp.getProjectViewResources)(),
        entryPoint: ()=>(0, $d9uEV.formBuilderPageEntrypoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("a2PcO", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormBuilderRoute", () => $939973d6db7f74a6$export$5f684808e671de5);
const $939973d6db7f74a6$export$5f684808e671de5 = {
    name: 'classic-business-form-builder',
    path: '/jira/core/projects/:projectKey/form/:formId/builder',
    exact: true
};

});

parcelRegister("d9uEV", function(module, exports) {

$parcel$export(module.exports, "formBuilderPageEntrypoint", () => $69b26f1a607bfd2a$export$e0f4bcb9440be5eb);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $3SMwn = parcelRequire("3SMwn");

var $fo6b8 = parcelRequire("fo6b8");
const $69b26f1a607bfd2a$export$e0f4bcb9440be5eb = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $3SMwn.formBuilderEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("3SMwn", function(module, exports) {

$parcel$export(module.exports, "formBuilderEntrypoint", () => $5ed17fe91cd922c4$export$6d3c9fa7232f412c);

var $kNhf9 = parcelRequire("kNhf9");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $5ed17fe91cd922c4$export$6d3c9fa7232f412c = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("245xp")), {
        moduleId: "86254720",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                formBuilderQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $kNhf9.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("kNhf9", function(module, exports) {

$parcel$export(module.exports, "default", () => $8916cebd6c30ef65$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f4e5285cf738fae5658c117e04609239>>
 * @relayHash d97c7a633d846788784b53e47412dba2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4f1558c868f827e5a17035db5860c9c66151d5a49619d6606fa69856264023f5
const $8916cebd6c30ef65$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "4f1558c868f827e5a17035db5860c9c66151d5a49619d6606fa69856264023f5",
        "metadata": {},
        "name": "src_jiraBusinessFormBuilderQuery",
        "operationKind": "query",
        "text": null
    }
};
var $8916cebd6c30ef65$export$2e2bcd8739ae039 = $8916cebd6c30ef65$var$node;

});

parcelRegister("245xp", function(module, exports) {

let $18104037e9d07f4d$var$load = (parcelRequire("28QjX"))(4);

module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $18104037e9d07f4d$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $18104037e9d07f4d$var$load("k6g9p")
        ]);
    }),
    $18104037e9d07f4d$var$load("ffQaD"),
    $18104037e9d07f4d$var$load("kvRbA"),
    $18104037e9d07f4d$var$load("76n7a"),
    $18104037e9d07f4d$var$load("l253H"),
    $18104037e9d07f4d$var$load("kduUo")
]).then(()=>parcelRequire('fU1n9'));

});




parcelRegister("a2wNz", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormRouteEntry", () => $78b7bb0633a93217$export$4798edf139084d2e);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $aPjV2 = parcelRequire("aPjV2");

var $7VVhE = parcelRequire("7VVhE");
const $78b7bb0633a93217$export$4798edf139084d2e = (0, $7NszV.createEntry)((0, $aPjV2.classicBusinessProjectFormRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.form-directory-view',
        layout: (0, $lRPBw.businessProjectLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: (0, $lNicp.getProjectViewResources)(),
        entryPoint: ()=>(0, $7VVhE.formPageEntrypoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("aPjV2", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormRoute", () => $63fab73853b00f48$export$e98776bdf96c88ac);
const $63fab73853b00f48$export$e98776bdf96c88ac = {
    name: 'classic-business-form',
    path: '/jira/core/projects/:projectKey/form',
    exact: true
};

});

parcelRegister("7VVhE", function(module, exports) {

$parcel$export(module.exports, "formPageEntrypoint", () => $32842b78cbaba6f2$export$ebaf30a031a61671);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $13ZHy = parcelRequire("13ZHy");

var $fo6b8 = parcelRequire("fo6b8");
const $32842b78cbaba6f2$export$ebaf30a031a61671 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $13ZHy.formEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("13ZHy", function(module, exports) {

$parcel$export(module.exports, "formEntrypoint", () => $c30c690af04301b5$export$b931eb60522f687a);

var $41sHw = parcelRequire("41sHw");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $c30c690af04301b5$export$b931eb60522f687a = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("hWmwC")), {
        moduleId: "77eafb5a",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                formQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $41sHw.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("41sHw", function(module, exports) {

$parcel$export(module.exports, "default", () => $333e5c56ad243628$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f62e7b05d75adf93c826705d7992eb93>>
 * @relayHash 8e0b57fc78588fab5ce6e2ba76089a61
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 00dfb7b57058946faf78573ea5754789e6b3e2dd7eab0b5c0a813c3db15e260b
const $333e5c56ad243628$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "00dfb7b57058946faf78573ea5754789e6b3e2dd7eab0b5c0a813c3db15e260b",
        "metadata": {},
        "name": "src_jiraBusinessFormQuery",
        "operationKind": "query",
        "text": null
    }
};
var $333e5c56ad243628$export$2e2bcd8739ae039 = $333e5c56ad243628$var$node;

});

parcelRegister("hWmwC", function(module, exports) {

let $d0f953713a1b906d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d0f953713a1b906d$var$load("j09Vp").then(()=>parcelRequire('4qzdE'));

});




parcelRegister("eghTD", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormSubmitEmbedRouteEntry", () => $ea2f0b4ec45df3b4$export$c2f698be6eedea1a);

var $6e4Kt = parcelRequire("6e4Kt");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $4xJea = parcelRequire("4xJea");

var $MxpLn = parcelRequire("MxpLn");
const $ea2f0b4ec45df3b4$export$c2f698be6eedea1a = (0, $7NszV.createEntry)((0, $4xJea.classicBusinessProjectFormSubmitEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.form-submit-embed-view',
        layout: (0, $6e4Kt.chromelessLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        resources: (0, $lNicp.getProjectViewResources)(),
        entryPoint: ()=>(0, $MxpLn.formSubmitEmbedPageEntrypoint)
    }));

});
parcelRegister("4xJea", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormSubmitEmbedRoute", () => $bab948378ba6b470$export$7e8fd15fdfa29385);
const $bab948378ba6b470$export$7e8fd15fdfa29385 = {
    name: 'classic-business-form-submit-embed',
    path: '/jira/core/projects/:projectKey/form/:formId/embed',
    exact: true
};

});

parcelRegister("MxpLn", function(module, exports) {

$parcel$export(module.exports, "formSubmitEmbedPageEntrypoint", () => $7b75b9ef7f4c7083$export$93f08d580854f4a7);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $1XDMK = parcelRequire("1XDMK");

var $fo6b8 = parcelRequire("fo6b8");
const $7b75b9ef7f4c7083$export$93f08d580854f4a7 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1XDMK.formSubmitEmbedEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("1XDMK", function(module, exports) {

$parcel$export(module.exports, "formSubmitEmbedEntrypoint", () => $aa01aa42cf2471d0$export$4c748d8ca82fc24);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $aa01aa42cf2471d0$export$4c748d8ca82fc24 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("5Slvk")), {
        moduleId: "20838510",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("5Slvk", function(module, exports) {

let $4472ad374dfcc048$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $4472ad374dfcc048$var$load("ffQaD"),
    $4472ad374dfcc048$var$load("kvRbA"),
    $4472ad374dfcc048$var$load("76n7a"),
    $4472ad374dfcc048$var$load("l253H"),
    $4472ad374dfcc048$var$load("dVS2w")
]).then(()=>parcelRequire('7H3bY'));

});




parcelRegister("huQRU", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormSubmitPublicRouteEntry", () => $8ba2931eff60855d$export$69d2365670c516de);

var $6e4Kt = parcelRequire("6e4Kt");

var $7NszV = parcelRequire("7NszV");

var $82Fi7 = parcelRequire("82Fi7");

var $6s1PB = parcelRequire("6s1PB");

var $6LsQE = parcelRequire("6LsQE");

var $2Ql51 = parcelRequire("2Ql51");

var $eRU3k = parcelRequire("eRU3k");
const $8ba2931eff60855d$export$69d2365670c516de = (0, $7NszV.createEntry)((0, $82Fi7.classicBusinessProjectFormSubmitPublicRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.form-submit-public-view',
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            (0, $2Ql51.themePreferenceResource)
        ],
        entryPoint: ()=>(0, $6s1PB.expVal)('jira_forms_public_access_experiment', 'isEnabled', 'false') ? (0, $eRU3k.formSubmitPageEntrypoint) : (0, $6LsQE.notFoundPageEntrypoint)
    }));

});
parcelRegister("82Fi7", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormSubmitPublicRoute", () => $93f319f0fd75fd27$export$865063615075df54);
const $93f319f0fd75fd27$export$865063615075df54 = {
    name: 'classic-business-form-submit-public',
    path: '/jira/core/form/:formUuid',
    exact: true
};

});

parcelRegister("6LsQE", function(module, exports) {

$parcel$export(module.exports, "notFoundPageEntrypoint", () => $8a0b47b5f1d82a69$export$eb748b014da0ac9a);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $6ApJI = parcelRequire("6ApJI");
const $8a0b47b5f1d82a69$export$eb748b014da0ac9a = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $6ApJI.notFoundEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).HOME
});

});
parcelRegister("6ApJI", function(module, exports) {

$parcel$export(module.exports, "notFoundEntrypoint", () => $04e61a5f550e74fe$export$7fdee4826a30b643);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $04e61a5f550e74fe$export$7fdee4826a30b643 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("khFxT")), {
        moduleId: "4e8af128",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});


parcelRegister("eRU3k", function(module, exports) {

$parcel$export(module.exports, "formSubmitPageEntrypoint", () => $605ab26c97fbe982$export$26755d0805847061);

var $lkFvK = parcelRequire("lkFvK");

var $iGgme = parcelRequire("iGgme");
const $605ab26c97fbe982$export$26755d0805847061 = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $iGgme.formSubmitPublicEntrypoint)
});

});
parcelRegister("iGgme", function(module, exports) {

$parcel$export(module.exports, "formSubmitPublicEntrypoint", () => $ea12db6778cfe8c5$export$345530940ab03dbd);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $ea12db6778cfe8c5$export$345530940ab03dbd = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("hnolE")), {
        moduleId: "d418c43d",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("hnolE", function(module, exports) {

let $ca6778ae97dc7c4c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ca6778ae97dc7c4c$var$load("ffQaD"),
    $ca6778ae97dc7c4c$var$load("kvRbA"),
    $ca6778ae97dc7c4c$var$load("76n7a"),
    $ca6778ae97dc7c4c$var$load("l253H"),
    $ca6778ae97dc7c4c$var$load("5Lh79")
]).then(()=>parcelRequire('hkafd'));

});




parcelRegister("ajYJ1", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormSubmitRouteEntry", () => $1ad0e25a3297ce2b$export$bd59a50eb595d1d5);

var $5f2bR = parcelRequire("5f2bR");

var $6e4Kt = parcelRequire("6e4Kt");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $5VxfF = parcelRequire("5VxfF");

var $kimPG = parcelRequire("kimPG");
const $1ad0e25a3297ce2b$export$bd59a50eb595d1d5 = (0, $7NszV.createEntry)((0, $5VxfF.classicBusinessProjectFormSubmitRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.form-submit-view',
        layout: (0, $6e4Kt.chromelessLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: (0, $lNicp.getProjectViewResources)(),
        entryPoint: ()=>(0, $kimPG.formSubmitPageEntrypoint)
    }));

});
parcelRegister("5VxfF", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormSubmitRoute", () => $6637feb602e2c6a2$export$3cd93ff55b29f07f);
const $6637feb602e2c6a2$export$3cd93ff55b29f07f = {
    name: 'classic-business-form-submit',
    path: '/jira/core/projects/:projectKey/form/:formId',
    exact: true
};

});

parcelRegister("kimPG", function(module, exports) {

$parcel$export(module.exports, "formSubmitPageEntrypoint", () => $86d107866af1a870$export$26755d0805847061);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $ap0Y4 = parcelRequire("ap0Y4");
const $86d107866af1a870$export$26755d0805847061 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $ap0Y4.formSubmitEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("ap0Y4", function(module, exports) {

$parcel$export(module.exports, "formSubmitEntrypoint", () => $b9d2e58129000f4b$export$d33b8db02e0a0cb5);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $b9d2e58129000f4b$export$d33b8db02e0a0cb5 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("lfuvJ")), {
        moduleId: "1cf8636b",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("lfuvJ", function(module, exports) {

let $f782aa84f2c74fc1$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f782aa84f2c74fc1$var$load("ffQaD"),
    $f782aa84f2c74fc1$var$load("kvRbA"),
    $f782aa84f2c74fc1$var$load("76n7a"),
    $f782aa84f2c74fc1$var$load("l253H"),
    $f782aa84f2c74fc1$var$load("82xZj")
]).then(()=>parcelRequire('hcjUE'));

});




parcelRegister("47CVY", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectPagesRouteEntry", () => $64d1b6dc76e76b9d$export$7a55e12f93813823);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $a0g4h = parcelRequire("a0g4h");

var $cRzP7 = parcelRequire("cRzP7");
const $64d1b6dc76e76b9d$export$7a55e12f93813823 = (0, $7NszV.createEntry)((0, $a0g4h.classicBusinessProjectPagesRoute), ()=>({
        group: 'classic-business',
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource)
        ],
        layout: (0, $lRPBw.businessProjectLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        ufoName: 'jwm.jwm-pages',
        entryPoint: ()=>(0, $cRzP7.pagesPageEntrypoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("a0g4h", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectPagesRoute", () => $c3d7ad3cf5e0901f$export$573cc697c2d33124);
const $c3d7ad3cf5e0901f$export$573cc697c2d33124 = {
    name: 'project-pages',
    path: '/jira/core/projects/:projectKey/pages'
};

});

parcelRegister("cRzP7", function(module, exports) {

$parcel$export(module.exports, "pagesPageEntrypoint", () => $7e318392f3d5106d$export$4ce394de88f5b54a);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $i0f3c = parcelRequire("i0f3c");

var $fo6b8 = parcelRequire("fo6b8");
const $7e318392f3d5106d$export$4ce394de88f5b54a = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $i0f3c.pagesEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("i0f3c", function(module, exports) {

$parcel$export(module.exports, "pagesEntrypoint", () => $cc22f4626e458394$export$49834d404673808c);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $cc22f4626e458394$export$49834d404673808c = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("kz7Oe")), {
        moduleId: "671532d1",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("kz7Oe", function(module, exports) {

let $ef8d2247592f586f$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ef8d2247592f586f$var$load("76n7a"),
    $ef8d2247592f586f$var$load("l253H"),
    $ef8d2247592f586f$var$load("lDFU4")
]).then(()=>parcelRequire('719qB'));

});




parcelRegister("hF0nU", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectShortcutRouteEntry", () => $4d5ae7b8b70c8e78$export$22248cc626626132);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $403gp = parcelRequire("403gp");

var $6JJeH = parcelRequire("6JJeH");
const $4d5ae7b8b70c8e78$export$22248cc626626132 = (0, $7NszV.createEntry)((0, $403gp.classicBusinessProjectShortcutRoute), ()=>({
        group: 'classic-business',
        layout: (0, $lRPBw.businessProjectLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: (0, $lNicp.getProjectViewResources)(),
        entryPoint: ()=>(0, $6JJeH.shortcutsPageEntrypoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("403gp", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectShortcutRoute", () => $60aa8b153682dfa1$export$2dd4e8a37d8ac978);
const $60aa8b153682dfa1$export$2dd4e8a37d8ac978 = {
    name: 'classic-business-shortcut',
    path: '/jira/core/projects/:projectKey/shortcuts',
    exact: true
};

});

parcelRegister("6JJeH", function(module, exports) {

$parcel$export(module.exports, "shortcutsPageEntrypoint", () => $19b2198152d557fa$export$57a2f1af23fcbb8b);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $8qyT8 = parcelRequire("8qyT8");

var $fo6b8 = parcelRequire("fo6b8");
const $19b2198152d557fa$export$57a2f1af23fcbb8b = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $8qyT8.shortcutsEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("8qyT8", function(module, exports) {

$parcel$export(module.exports, "shortcutsEntrypoint", () => $2c08d7e07e3e2760$export$212fd76838eeb6ad);

var $hSK0t = parcelRequire("hSK0t");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $2c08d7e07e3e2760$export$212fd76838eeb6ad = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("aGRYM")), {
        moduleId: "736f6fc2",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                shortcutsQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $hSK0t.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("hSK0t", function(module, exports) {

$parcel$export(module.exports, "default", () => $c56df58cb6ff2ae3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<571227a0b71f1eebd07db7bde4b71b10>>
 * @relayHash f251714abaead8d7f256f75b2cbcdd4e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1b84b6702f8ba5906f411cf39e6585519029e426840a702a9fe6d1e6e094c95e
const $c56df58cb6ff2ae3$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "1b84b6702f8ba5906f411cf39e6585519029e426840a702a9fe6d1e6e094c95e",
        "metadata": {},
        "name": "src_jiraBusinessShortcutsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $c56df58cb6ff2ae3$export$2e2bcd8739ae039 = $c56df58cb6ff2ae3$var$node;

});

parcelRegister("aGRYM", function(module, exports) {

let $7c87b2cbcf8c0cc9$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $7c87b2cbcf8c0cc9$var$load("fliVL"),
    $7c87b2cbcf8c0cc9$var$load("1ChkR")
]).then(()=>parcelRequire('7WItf'));

});




parcelRegister("ejDmq", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectViewNotFoundRouteEntry", () => $c521464132416e2d$export$e23e06ae81848c38);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $8RNDo = parcelRequire("8RNDo");

var $1g8oF = parcelRequire("1g8oF");
const $c521464132416e2d$export$e23e06ae81848c38 = (0, $7NszV.createEntry)((0, $8RNDo.classicBusinessProjectViewNotFoundRoute), ()=>({
        group: 'classic-business',
        layout: (0, $lRPBw.businessProjectLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: (0, $lNicp.getProjectViewResources)(),
        entryPoint: ()=>(0, $1g8oF.projectViewNotFoundPageEntrypoint)
    }));

});
parcelRegister("8RNDo", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectViewNotFoundRoute", () => $20583b3f5bf95ee3$export$1194a530fb12fc37);
const $20583b3f5bf95ee3$export$1194a530fb12fc37 = {
    name: 'classic-business-view-not-found',
    path: '/jira/core/projects/:projectKey/not-found',
    exact: true
};

});

parcelRegister("1g8oF", function(module, exports) {

$parcel$export(module.exports, "projectViewNotFoundPageEntrypoint", () => $cdbfface63bc99c3$export$31e63eef3cc009c6);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $bclj6 = parcelRequire("bclj6");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $fo6b8 = parcelRequire("fo6b8");

const $cdbfface63bc99c3$var$main = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("7sCoY")), {
        moduleId: "24c3dcc7",
        moduleName: "ProjectViewNotFound",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                mainQuery: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $bclj6.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});
const $cdbfface63bc99c3$export$31e63eef3cc009c6 = (0, $lkFvK.createPageEntryPoint)({
    main: $cdbfface63bc99c3$var$main,
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("bclj6", function(module, exports) {

$parcel$export(module.exports, "default", () => $70fb7cc296b150fc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c9a08656b81123b3a899ed443afd14f3>>
 * @relayHash 4f9cc1b4eefda38b80dcbc5247f75776
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4e080d38c866eb2caaf06903fd96c2653d506a6f20f6ba761d204c141a5466d9
const $70fb7cc296b150fc$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "4e080d38c866eb2caaf06903fd96c2653d506a6f20f6ba761d204c141a5466d9",
        "metadata": {},
        "name": "ProjectViewNotFoundQuery",
        "operationKind": "query",
        "text": null
    }
};
var $70fb7cc296b150fc$export$2e2bcd8739ae039 = $70fb7cc296b150fc$var$node;

});

parcelRegister("7sCoY", function(module, exports) {

let $56e8efb5f8244d2f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $56e8efb5f8244d2f$var$load("4pw2D").then(()=>parcelRequire('8HTcg'));

});



parcelRegister("difFp", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsDataClassificationsRouteEntry", () => $72c99d901431c503$export$5b0670f37204a43d);

var $ffza4 = parcelRequire("ffza4");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $cSUZZ = parcelRequire("cSUZZ");

var $7GnDe = parcelRequire("7GnDe");

var $gADc2 = parcelRequire("gADc2");

var $5H2aw = parcelRequire("5H2aw");
const $72c99d901431c503$export$5b0670f37204a43d = (0, $7NszV.createEntry)((0, $gADc2.classicProjectSettingsDataClassificationsRoute), ()=>({
        group: 'project-settings-classic',
        component: (0, $5H2aw.default),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5H2aw.LazyDataClassificationsSettings)
        ]
    }));

});
parcelRegister("gADc2", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsDataClassificationsRoute", () => $fa8df43e7f1ddeea$export$952eefa1907e877a);
const $fa8df43e7f1ddeea$export$952eefa1907e877a = {
    name: 'project-settings-classic-data-classifications',
    path: '/plugins/servlet/project-config/:projectKey/data-classifications',
    exact: true
};

});

parcelRegister("5H2aw", function(module, exports) {

$parcel$export(module.exports, "LazyDataClassificationsSettings", () => $b4450c735413409b$export$b8abcf8aa8f4df56);
$parcel$export(module.exports, "default", () => $b4450c735413409b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $b4450c735413409b$export$b8abcf8aa8f4df56 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("foQoc"))), {
    moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b4450c735413409b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $b4450c735413409b$export$b8abcf8aa8f4df56,
        pageId: "project-settings-data-classifications",
        shouldShowSpinner: false
    });

});
parcelRegister("foQoc", function(module, exports) {

let $b361bc58347a5ac8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b361bc58347a5ac8$var$load("iOlJ7").then(()=>parcelRequire('9iqsx'));

});



parcelRegister("anDMO", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsDetailsRouteEntry", () => $0d63a1f004a7576a$export$9391a147c94081db);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $cubqk = parcelRequire("cubqk");

var $jaAyo = parcelRequire("jaAyo");

var $e7bC3 = parcelRequire("e7bC3");

var $cYgMq = parcelRequire("cYgMq");
const $0d63a1f004a7576a$export$9391a147c94081db = (0, $7NszV.createEntry)((0, $cubqk.classicProjectSettingsDetailsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $cYgMq.default),
        skeleton: (0, $jaAyo.ProjectSettingsDetailsSkeleton),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $dxCvy.projectContextResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cYgMq.LazyDetailsSettings)
        ]
    }));

});
parcelRegister("cubqk", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsDetailsRoute", () => $1e07e61b794dca8d$export$37e0dbac44df25b9);
const $1e07e61b794dca8d$export$37e0dbac44df25b9 = {
    name: 'classic-software-details',
    path: '/jira/software/c/projects/:projectKey/settings/details',
    exact: true
};

});

parcelRegister("jaAyo", function(module, exports) {

$parcel$export(module.exports, "ProjectSettingsAccessSkeleton", () => $e950186edd3e49fd$export$e6cc5ccd52c7fd63);
$parcel$export(module.exports, "ProjectSettingsDetailsSkeleton", () => $e950186edd3e49fd$export$bd7fd4005b84aec9);
$parcel$export(module.exports, "ProjectSettingsFeaturesSkeleton", () => $e950186edd3e49fd$export$ec1cdd0c8335373c);
/* ProjectSettingsFeaturesSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $4C3Cb = parcelRequire("4C3Cb");

var $fU8cb = parcelRequire("fU8cb");

var $8n9dD = parcelRequire("8n9dD");
const $e950186edd3e49fd$var$customCssStyles = null;
const $e950186edd3e49fd$var$listOnlyStyles = null;
const $e950186edd3e49fd$export$e6cc5ccd52c7fd63 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4C3Cb))),
        className: (0, $bwpsq.default)([
            "_19pkze3t _2hwx1wug _otyrze3t _18u01wug _p12f1qe4 _11y7oza4"
        ])
    });
const $e950186edd3e49fd$export$bd7fd4005b84aec9 = ({ isListOnly: isListOnly = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fU8cb))),
        className: (0, $bwpsq.default)([
            isListOnly ? "_1wgmglyw _rcuj1bdq" : "_19pkze3t _2hwx1wug _otyrze3t _18u01wug _p12f1qe4 _11y7oza4"
        ])
    });
const $e950186edd3e49fd$export$ec1cdd0c8335373c = ({ isListOnly: isListOnly = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8n9dD))),
        className: (0, $bwpsq.default)([
            isListOnly ? "_1wgmglyw _rcuj1bdq" : "_19pkze3t _2hwx1wug _otyrze3t _18u01wug _p12f1qe4 _11y7oza4"
        ])
    });

});
parcelRegister("4C3Cb", function(module, exports) {
module.exports = new URL("project-settings-access-app-skeleton.tpl.21bb94b1.svg", import.meta.url).toString();

});

parcelRegister("fU8cb", function(module, exports) {
module.exports = new URL("project-settings-details-app-skeleton.tpl.c4ebc2fd.svg", import.meta.url).toString();

});

parcelRegister("8n9dD", function(module, exports) {
module.exports = new URL("project-settings-features-app-skeleton.tpl.b8e7f249.svg", import.meta.url).toString();

});


parcelRegister("cYgMq", function(module, exports) {

$parcel$export(module.exports, "LazyDetailsSettings", () => $5dcf6caa5da05571$export$6f16b5efddd5c646);
$parcel$export(module.exports, "default", () => $5dcf6caa5da05571$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $5dcf6caa5da05571$export$6f16b5efddd5c646 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("eC5lK"))), {
    moduleId: "./src/packages/spa-apps/project-settings/details/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5dcf6caa5da05571$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $5dcf6caa5da05571$export$6f16b5efddd5c646,
        pageId: "project-settings-details",
        shouldShowSpinner: false
    });

});
parcelRegister("eC5lK", function(module, exports) {

let $aa38c3a1bc44c6e8$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $aa38c3a1bc44c6e8$var$load("76n7a"),
    $aa38c3a1bc44c6e8$var$load("l253H"),
    $aa38c3a1bc44c6e8$var$load("ffQaD"),
    $aa38c3a1bc44c6e8$var$load("kvRbA"),
    $aa38c3a1bc44c6e8$var$load("fliVL"),
    $aa38c3a1bc44c6e8$var$load("hnI4x")
]).then(()=>parcelRequire('9vEjY'));

});



parcelRegister("dYbYB", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsFeaturesRouteEntry", () => $f08d62940ca05012$export$b623393adc25556a);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $bzimk = parcelRequire("bzimk");

var $jaAyo = parcelRequire("jaAyo");

var $e7bC3 = parcelRequire("e7bC3");

var $4R6GH = parcelRequire("4R6GH");

var $gNStA = parcelRequire("gNStA");

var $7bHMy = parcelRequire("7bHMy");

var $4glor = parcelRequire("4glor");
const $f08d62940ca05012$export$b623393adc25556a = (0, $7NszV.createEntry)((0, $bzimk.classicProjectSettingsFeaturesRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'classic-features-page',
        component: (0, $4glor.ClassicFeaturesPage),
        skeleton: (0, $jaAyo.ProjectSettingsFeaturesSkeleton),
        layout: (0, $e7bC3.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $dxCvy.projectContextResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jira-project-isglobalcomponent-route-resource'), (0, $7bHMy.projectGlobalComponentsResource))
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4glor.LazySoftwareClassicFeatures)
        ]
    }));

});
parcelRegister("bzimk", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsFeaturesRoute", () => $a3d30ca18dd07505$export$d4bf23ba6f4199d7);
const $a3d30ca18dd07505$export$d4bf23ba6f4199d7 = {
    name: 'classic-software-features',
    path: '/jira/software/c/projects/:projectKey/settings/features',
    exact: true
};

});

parcelRegister("4glor", function(module, exports) {

$parcel$export(module.exports, "LazySoftwareClassicFeatures", () => $70eea33e6c09b198$export$79fe16f960f3d89f);
$parcel$export(module.exports, "ClassicFeaturesPage", () => $70eea33e6c09b198$export$8e6f565615e921dd);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $70eea33e6c09b198$export$79fe16f960f3d89f = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("cnRkx"))), {
    moduleId: "./src/packages/spa-apps/project-settings/classic-features/src/index.tsx"
});
const $70eea33e6c09b198$export$8e6f565615e921dd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $70eea33e6c09b198$export$79fe16f960f3d89f,
        pageId: "classic-features",
        shouldShowSpinner: true
    });

});
parcelRegister("cnRkx", function(module, exports) {

let $9041004cdb0bb96e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9041004cdb0bb96e$var$load("aRqGl").then(()=>parcelRequire('hX1AL'));

});



parcelRegister("dH2Tp", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsIssueLayoutRouteEntry", () => $72a8f02a914333fc$export$47b3bdf88a7d176b);

var $ffza4 = parcelRequire("ffza4");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $cSUZZ = parcelRequire("cSUZZ");

var $58ViO = parcelRequire("58ViO");

var $33syc = parcelRequire("33syc");
const $72a8f02a914333fc$export$47b3bdf88a7d176b = (0, $7NszV.createEntry)((0, $58ViO.classicProjectSettingsIssueLayoutRoute), ()=>({
        group: 'project-settings-classic',
        ufoName: 'project-settings.issue-type.jsw-cmp',
        component: (0, $33syc.default),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $33syc.LazyIssueTypeSettings)
        ]
    }));

});
parcelRegister("58ViO", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsIssueLayoutRoute", () => $3beddbd9a85d45eb$export$c593179674352d0);
const $3beddbd9a85d45eb$export$c593179674352d0 = {
    name: 'project-settings-classic-issue-layout',
    path: '/plugins/servlet/project-config/:projectKey/issuelayout',
    query: [
        'screenId'
    ],
    exact: true
};

});

parcelRegister("33syc", function(module, exports) {

$parcel$export(module.exports, "LazyIssueTypeSettings", () => $f7c23974aa64ecd2$export$36dcfb52d47cb93a);
$parcel$export(module.exports, "default", () => $f7c23974aa64ecd2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $f7c23974aa64ecd2$export$36dcfb52d47cb93a = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("7a4qW"))), {
    moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f7c23974aa64ecd2$export$2e2bcd8739ae039 = ({ match: match })=>{
    const { issueTypeId: issueTypeId } = match.params;
    // unique pageId need to be set so that ApdexProvider would properly reset all the performance marks when switching between issue types
    const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f7c23974aa64ecd2$export$36dcfb52d47cb93a,
        pageId: pageId,
        shouldShowSpinner: false
    });
};

});
parcelRegister("7a4qW", function(module, exports) {

let $536ce7f60faeaae5$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $536ce7f60faeaae5$var$load("ffQaD"),
    $536ce7f60faeaae5$var$load("kvRbA"),
    $536ce7f60faeaae5$var$load("cA99w")
]).then(()=>parcelRequire('8SAZe'));

});



parcelRegister("ffFBX", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsOpsgenieRouteEntry", () => $2bd54c69eb3061ae$export$17e7416abefe91dc);

var $ffza4 = parcelRequire("ffza4");

var $bwLf9 = parcelRequire("bwLf9");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $5lsNZ = parcelRequire("5lsNZ");

var $dcC1k = parcelRequire("dcC1k");

var $kfztd = parcelRequire("kfztd");

var $e7bC3 = parcelRequire("e7bC3");

var $1KQBW = parcelRequire("1KQBW");
const $2bd54c69eb3061ae$export$17e7416abefe91dc = (0, $7NszV.createEntry)((0, $dcC1k.classicProjectSettingsOpsgenieRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $bwLf9.default)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $1KQBW.default)),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $dxCvy.projectContextResource)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $1KQBW.LazyLinkOpsgeniePage)
        ],
        ufoName: 'project-settings.link-opsgenie'
    }));

});
parcelRegister("bwLf9", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7ec252b6b084884$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
var /**
 * @deprecated this does not support useRef and is being moved into a new package.
 * Use @atlassian/jira-feature-flagging-utils and componentWithCondition instead.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$a7ec252b6b084884$export$2e2bcd8739ae039 = (conditionGetter, ComponentTrue, ComponentFalse)=>{
    const ComponentWithCondition = (props)=>// @ts-expect-error - TS2322 - Type 'P' is not assignable to type 'IntrinsicAttributes & PropsWithoutRef<P> & RefAttributes<any> & { children?: ReactNode; }'. | TS2322 - Type 'P' is not assignable to type 'IntrinsicAttributes & PropsWithoutRef<P> & RefAttributes<any> & { children?: ReactNode; }'.
        conditionGetter() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ComponentTrue, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ComponentFalse, props);
    if (conditionGetter.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${conditionGetter.name}]`;
    // @ts-expect-error - TS2322 - Type '{ (props: P): JSX.Element; displayName: string; }' is not assignable to type 'AbstractComponent<P, any>'.
    return ComponentWithCondition;
};

});

parcelRegister("dcC1k", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsOpsgenieRoute", () => $f327483ffca6ed25$export$4e4a4b8762b611);
const $f327483ffca6ed25$export$4e4a4b8762b611 = {
    name: 'classic-software-link-opsgenie',
    path: '/jira/software/c/projects/:projectKey/settings/opsgenie',
    exact: true
};

});

parcelRegister("kfztd", function(module, exports) {

$parcel$export(module.exports, "isDevopsFeatureDisabledInFedRamp", () => $064393a36b21cb6e$export$18bfef4995ec57b7);

var $c04PQ = parcelRequire("c04PQ");
const $064393a36b21cb6e$export$18bfef4995ec57b7 = ()=>(0, $c04PQ.isFedRamp)();

});

parcelRegister("1KQBW", function(module, exports) {

$parcel$export(module.exports, "LazyLinkOpsgeniePage", () => $dab3ab2feb1de470$export$ca5dba69148b337);
$parcel$export(module.exports, "default", () => $dab3ab2feb1de470$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $dab3ab2feb1de470$export$ca5dba69148b337 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("bn3jD")), {
    moduleId: "./src/packages/spa-apps/project-settings/link-opsgenie/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$dab3ab2feb1de470$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $dab3ab2feb1de470$export$ca5dba69148b337,
        pageId: "link-opsgenie-page",
        shouldShowSpinner: false
    });

});
parcelRegister("bn3jD", function(module, exports) {

let $84746a230ea5fc68$var$load = (parcelRequire("28QjX"))(4);
module.exports = $84746a230ea5fc68$var$load("4BlES").then(()=>parcelRequire('7AMRE'));

});



parcelRegister("1IKX7", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsSoftwareNotificationsIssueLogsRouteEntry", () => $ced985b0a8859572$export$cdc4e64211a34457);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $5dFt2 = parcelRequire("5dFt2");

var $e7bC3 = parcelRequire("e7bC3");

var $14B4q = parcelRequire("14B4q");
const $ced985b0a8859572$export$cdc4e64211a34457 = (0, $7NszV.createEntry)((0, $5dFt2.classicProjectSettingsSoftwareNotificationsIssueLogsRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.classic-issue-logs-page',
        component: (0, $14B4q.SoftwareNotificationsIssueLogs),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $dxCvy.projectContextResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $14B4q.LazySoftwareNotificationsIssueLogs)
        ],
        entryPoint () {
            return 0, $14B4q.emailNotificationsLogEntryPointPage;
        }
    }));

});
parcelRegister("5dFt2", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsSoftwareNotificationsIssueLogsRoute", () => $631b97d030b0c8f3$export$5e2e0a895d6a14bd);
const $631b97d030b0c8f3$export$5e2e0a895d6a14bd = {
    name: 'classic-software-notifications-issue-logs',
    path: '/jira/software/c/projects/:projectKey/settings/notifications/issue-logs',
    query: [
        'projectId'
    ]
};

});

parcelRegister("14B4q", function(module, exports) {

$parcel$export(module.exports, "emailNotificationsLogEntryPointPage", () => $e5cbde6b3cad4f8b$export$cd8964bea0e3c2);
$parcel$export(module.exports, "LazySoftwareNotificationsIssueLogs", () => $e5cbde6b3cad4f8b$export$6960a46ebd209756);
$parcel$export(module.exports, "SoftwareNotificationsIssueLogs", () => $e5cbde6b3cad4f8b$export$4b75df09cc5b4e8e);

var $5uXOq = parcelRequire("5uXOq");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $femMW = parcelRequire("femMW");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");
const $e5cbde6b3cad4f8b$export$cd8964bea0e3c2 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $femMW.notificationsIssueLogsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

const $e5cbde6b3cad4f8b$export$6960a46ebd209756 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("5Q8bv"))), {
    moduleId: "./src/packages/spa-apps/project-settings/software-notifications-issue-logs/src/index.tsx"
});
const $e5cbde6b3cad4f8b$export$4b75df09cc5b4e8e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e5cbde6b3cad4f8b$export$6960a46ebd209756,
        pageId: "project-settings-software-notifications-issue-logs",
        shouldShowSpinner: false
    });

});
parcelRegister("femMW", function(module, exports) {

$parcel$export(module.exports, "notificationsIssueLogsEntryPoint", () => $6adcc3494d7c3774$export$97bbdefcbe0571ac);

var $9Cf70 = parcelRequire("9Cf70");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $6adcc3494d7c3774$export$97bbdefcbe0571ac = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("5Q8bv")), {
        moduleId: "b2136a4d",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                notificationLogs: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $9Cf70.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectId: Number(context?.query?.projectId ?? 0),
                        notificationType: 'INTERNAL_NOTIFICATION_ISSUE'
                    }
                }
            },
            extraProps: {
                accountId: tenantContext.atlassianAccountId,
                cloudId: tenantContext.cloudId,
                projectIds: context?.query?.projectId,
                projectKey: context?.match.params.projectKey
            }
        })
});

});
parcelRegister("9Cf70", function(module, exports) {

$parcel$export(module.exports, "default", () => $baebbc2289a2b843$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a829922c4d7e91622e88a1e75ca9c0ed>>
 * @relayHash ed735b233bfe7d6a34f4765ef97f56e9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 28e1d1e9657c726eca51c9d02a4b718874ec12653eea9e5bfcfef82047676924
const $baebbc2289a2b843$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "28e1d1e9657c726eca51c9d02a4b718874ec12653eea9e5bfcfef82047676924",
        "metadata": {},
        "name": "uiIssueNotificationLogsPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $baebbc2289a2b843$export$2e2bcd8739ae039 = $baebbc2289a2b843$var$node;

});

parcelRegister("5Q8bv", function(module, exports) {

let $4408285df5e2c7dd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4408285df5e2c7dd$var$load("bY8qa").then(()=>parcelRequire('6ZR0a'));

});




parcelRegister("1K27j", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsSoftwareProformaEditFormsRouteEntry", () => $7a878339e2d71181$export$e730b13555ff0c60);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $gSRO9 = parcelRequire("gSRO9");

var $e7bC3 = parcelRequire("e7bC3");

var $1XdKx = parcelRequire("1XdKx");

var $8JnjW = parcelRequire("8JnjW");
const $7a878339e2d71181$export$e730b13555ff0c60 = (0, $7NszV.createEntry)((0, $gSRO9.classicProjectSettingsSoftwareProformaEditFormsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $8JnjW.default),
        layout: (0, $e7bC3.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8JnjW.LazyProjectSettingsProformaJiraFormBuilder)
        ]
    }));

});
parcelRegister("gSRO9", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsSoftwareProformaEditFormsRoute", () => $db0151a276af1837$export$811ace4fee984f0e);
const $db0151a276af1837$export$811ace4fee984f0e = {
    name: 'project-settings-software-proforma-edit-forms',
    path: '/jira/software/c/projects/:projectKey/settings/forms/form/:templateFormId/edit',
    exact: true
};

});

parcelRegister("1XdKx", function(module, exports) {

$parcel$export(module.exports, "SOFTWARE_PRODUCT", () => $3caec8e095a44ec5$export$2954328f6207617a);
$parcel$export(module.exports, "getSettingsNavigationResources", () => $3caec8e095a44ec5$export$586756e5c0542a50);
$parcel$export(module.exports, "RedirectForSettings", () => $3caec8e095a44ec5$export$fb15a6ba8980fdac);
$parcel$export(module.exports, "RedirectForSettingsForClassicProject", () => $3caec8e095a44ec5$export$f9befa0a4925b36d);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $1J3t1 = parcelRequire("1J3t1");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $7tQej = parcelRequire("7tQej");
const $3caec8e095a44ec5$export$2954328f6207617a = 'software';
const $3caec8e095a44ec5$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $3caec8e095a44ec5$export$586756e5c0542a50 = ()=>{
    return [
        ...(0, $3RJkv.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $7GnDe.incidentExperimentTraitResource),
        (0, $dxCvy.projectContextResource),
        (0, $5bkvv.forgeProjectModuleResource),
        (0, $iEUaw.staticSidebarShortcutsResource),
        (0, $ggg5j.staticProjectSidebarNavigationResource),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)()
    ];
};
const $3caec8e095a44ec5$export$fb15a6ba8980fdac = ({ match: match })=>{
    const { data: data } = (0, $1J3t1.useJiraSoftwareProjectNavigation)();
    const { projectKey: projectKey } = match.params;
    if (data?.permissionInfo?.isAdmin || data?.permissionInfo?.isSiteAdmin || data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/jira/software/projects/${String(match.params.projectKey)}/settings/details`
    });
    // the next three if branches do not make a lot of sense for TMP as you always a project admin in TMP
    // however a wrong link is generated by the nav4 navbar for CMP projects which matches to this redirect logic
    // ex: "/jira/software/projects/JSWCMP1/settings"
    // instead it should be "/jira/software/c/projects/JSWCMP1/settings"
    // which matches to CMP redirect logic defined in RedirectForSettingsForClassicProject
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_WORKFLOW === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/workflows`
    });
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_ISSUE_LAYOUT === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/issuelayout`
    });
    if ((0, $4R6GH.fg)('vmc-11-manage-versions-permission')) {
        if (data?.permissionInfo?.projectPermissionsQueried?.MANAGE_VERSIONS === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: `/plugins/servlet/project-config/${String(projectKey)}/administer-versions`
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/jira/software/projects/${String(match.params.projectKey)}/settings/details`
    });
};
const $3caec8e095a44ec5$export$f9befa0a4925b36d = ({ match: match })=>{
    const { data: data } = (0, $1J3t1.useJiraSoftwareProjectNavigation)();
    const { projectKey: projectKey } = match.params;
    if (data?.permissionInfo?.isAdmin || data?.permissionInfo?.isSiteAdmin || data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/jira/software/c/projects/${String(projectKey)}/settings/details`
    });
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_WORKFLOW === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/workflows`
    });
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_ISSUE_LAYOUT === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/issuelayout`
    });
    if ((0, $4R6GH.fg)('vmc-11-manage-versions-permission')) {
        if (data?.permissionInfo?.projectPermissionsQueried?.MANAGE_VERSIONS === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: `/plugins/servlet/project-config/${String(projectKey)}/administer-versions`
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/jira/software/c/projects/${String(projectKey)}/settings/details`
    });
};

});

parcelRegister("8JnjW", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsProformaJiraFormBuilder", () => $c3a9ed7dcac6be32$export$a7d63246a10aedd);
$parcel$export(module.exports, "default", () => $c3a9ed7dcac6be32$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $c3a9ed7dcac6be32$export$a7d63246a10aedd = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("7R9RB")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-jira-form-builder/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c3a9ed7dcac6be32$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $c3a9ed7dcac6be32$export$a7d63246a10aedd,
        pageId: "project-settings-proforma-jira-form-builder",
        shouldShowSpinner: true
    });

});
parcelRegister("7R9RB", function(module, exports) {

let $0179e3a69349e757$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0179e3a69349e757$var$load("ffQaD"),
    $0179e3a69349e757$var$load("kvRbA"),
    $0179e3a69349e757$var$load("fliVL"),
    $0179e3a69349e757$var$load("76n7a"),
    $0179e3a69349e757$var$load("l253H"),
    $0179e3a69349e757$var$load("gT4kI")
]).then(()=>parcelRequire('1XLXC'));

});



parcelRegister("8DQ40", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsSoftwareProformaFormsRouteEntry", () => $c13f5ba4ed49c128$export$5e67ac6f50ae37e1);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $epiJW = parcelRequire("epiJW");

var $e7bC3 = parcelRequire("e7bC3");

var $1XdKx = parcelRequire("1XdKx");

var $gyEpf = parcelRequire("gyEpf");
const $c13f5ba4ed49c128$export$5e67ac6f50ae37e1 = (0, $7NszV.createEntry)((0, $epiJW.classicProjectSettingsSoftwareProformaFormsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $gyEpf.default),
        layout: (0, $e7bC3.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gyEpf.LazyProjectSettingsProformaProjectForms)
        ]
    }));

});
parcelRegister("epiJW", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsSoftwareProformaFormsRoute", () => $7b818f933be215b1$export$2313ca001d58ab27);
const $7b818f933be215b1$export$2313ca001d58ab27 = {
    name: 'project-settings-software-proforma-project-forms',
    path: '/jira/software/c/projects/:projectKey/settings/forms',
    exact: true
};

});

parcelRegister("gyEpf", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsProformaProjectForms", () => $97406b66ba2de080$export$38414b624a749cec);
$parcel$export(module.exports, "default", () => $97406b66ba2de080$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $97406b66ba2de080$export$38414b624a749cec = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("cShK4")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-project-forms/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$97406b66ba2de080$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $97406b66ba2de080$export$38414b624a749cec,
        pageId: "project-settings-proforma-project-forms",
        shouldShowSpinner: true
    });

});
parcelRegister("cShK4", function(module, exports) {

let $95f84a629d0d3b75$var$load = (parcelRequire("28QjX"))(4);
module.exports = $95f84a629d0d3b75$var$load("9xKEM").then(()=>parcelRequire('ciDU2'));

});



parcelRegister("hdWS0", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsSoftwareRedirectRouteEntry", () => $5fe7bdc999ce9cdf$export$3c7d008bbb14e2b);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $7OjcI = parcelRequire("7OjcI");

var $e7bC3 = parcelRequire("e7bC3");

var $1XdKx = parcelRequire("1XdKx");
const $5fe7bdc999ce9cdf$export$3c7d008bbb14e2b = (0, $7NszV.createEntry)((0, $7OjcI.classicProjectSettingsSoftwareRedirectRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $1XdKx.RedirectForSettingsForClassicProject),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("7OjcI", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsSoftwareRedirectRoute", () => $eb74524e076aae09$export$99b695c2b8299b5a);
const $eb74524e076aae09$export$99b695c2b8299b5a = {
    // the following route should be non-exact, it will handle "index" and "404" cases
    name: 'classic-software-redirect',
    path: '/jira/software/c/projects/:projectKey/settings'
};

});


parcelRegister("9MTKv", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsToolchainRouteEntry", () => $42ebeced13391ae5$export$1fe479c54f4d7684);

var $ffza4 = parcelRequire("ffza4");

var $bwLf9 = parcelRequire("bwLf9");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $35Wvp = parcelRequire("35Wvp");

var $7GnDe = parcelRequire("7GnDe");

var $5lsNZ = parcelRequire("5lsNZ");

var $gTGp2 = parcelRequire("gTGp2");

var $kfztd = parcelRequire("kfztd");

var $e7bC3 = parcelRequire("e7bC3");

var $aA5DA = parcelRequire("aA5DA");
const $42ebeced13391ae5$export$1fe479c54f4d7684 = (0, $7NszV.createEntry)((0, $gTGp2.classicProjectSettingsToolchainRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $bwLf9.default)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $aA5DA.default)),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $dxCvy.projectContextResource),
            (0, $35Wvp.projectSettingsToolchainResource)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aA5DA.LazyDevOpsConnectionsSettings)
        ],
        ufoName: 'project-settings.devops-connections'
    }));

});
parcelRegister("35Wvp", function(module, exports) {

$parcel$export(module.exports, "projectSettingsToolchainResource", () => $ed037648996bd812$export$182dfe2bc7c28567);

var $ao2h1 = parcelRequire("ao2h1");

var $avVgl = parcelRequire("avVgl");
const $ed037648996bd812$export$b8927fea69d9f414 = 'PROJECT_SETTINGS_TOOLCHAIN';
const $ed037648996bd812$export$182dfe2bc7c28567 = (0, $ao2h1.createRelayResource)({
    type: $ed037648996bd812$export$b8927fea69d9f414,
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $avVgl.default),
            variables: {
                cloudId: tenantContext?.cloudId || ''
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("avVgl", function(module, exports) {

$parcel$export(module.exports, "default", () => $5afd24d8f370d3e2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a2c9dc099d3b7d79cd74bd591996a945>>
 * @relayHash f5bf042c501578b47d326c7288427026
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2fc1f152f5ebcdcb577d22b928c317e308c8daf161c302627c4f00951b909409
const $5afd24d8f370d3e2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "concreteType": "DvcsQuery",
            "kind": "LinkedField",
            "name": "dvcs",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1
                        }
                    ],
                    "concreteType": "DvcsBitbucketWorkspaceConnection",
                    "kind": "LinkedField",
                    "name": "bitbucketWorkspacesLinkedToSite",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "DvcsBitbucketWorkspaceEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ui_projectSettingsToolchainQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ui_projectSettingsToolchainQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "2fc1f152f5ebcdcb577d22b928c317e308c8daf161c302627c4f00951b909409",
            "metadata": {},
            "name": "ui_projectSettingsToolchainQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5afd24d8f370d3e2$var$node.hash = "190735208b3c7baafbfc3c1808fa801b";
var $5afd24d8f370d3e2$export$2e2bcd8739ae039 = $5afd24d8f370d3e2$var$node;

});


parcelRegister("gTGp2", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsToolchainRoute", () => $8d33965caf47a037$export$7dbc23deac9553d4);
const $8d33965caf47a037$export$7dbc23deac9553d4 = {
    name: 'project-settings-software-toolchain-company-managed',
    path: '/jira/software/c/projects/:projectKey/settings/toolchain',
    exact: true
};

});

parcelRegister("aA5DA", function(module, exports) {

$parcel$export(module.exports, "LazyDevOpsConnectionsSettings", () => $11c79a07a4ec83b8$export$9d468faf674a5201);
$parcel$export(module.exports, "default", () => $11c79a07a4ec83b8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $11c79a07a4ec83b8$export$9d468faf674a5201 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("l0MM7")), {
    moduleId: "./src/packages/spa-apps/project-settings/connections/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$11c79a07a4ec83b8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $11c79a07a4ec83b8$export$9d468faf674a5201,
        pageId: "devops-connections-settings",
        shouldShowSpinner: false
    });

});
parcelRegister("l0MM7", function(module, exports) {

let $f4bf6ecbe8054cbc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f4bf6ecbe8054cbc$var$load("jyibG").then(()=>parcelRequire('a0GzC'));

});



parcelRegister("2XQq2", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBacklogEmbedRouteEntry", () => $f735d13d6cf6b150$export$1a7368427cd23b33);

var $7NszV = parcelRequire("7NszV");

var $iGbXw = parcelRequire("iGbXw");

var $4R6GH = parcelRequire("4R6GH");

var $16Z5s = parcelRequire("16Z5s");

var $6e4Kt = parcelRequire("6e4Kt");

var $f5kpo = parcelRequire("f5kpo");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $lJ1FP = parcelRequire("lJ1FP");

var $lfnsv = parcelRequire("lfnsv");

var $2Ql51 = parcelRequire("2Ql51");

var $fKmub = parcelRequire("fKmub");

var $e2ctp = parcelRequire("e2ctp");

var $3RJkv = parcelRequire("3RJkv");

var $1jxD5 = parcelRequire("1jxD5");

var $gNStA = parcelRequire("gNStA");

var $3NItL = parcelRequire("3NItL");

var $9u12M = parcelRequire("9u12M");
const $f735d13d6cf6b150$export$1a7368427cd23b33 = (0, $7NszV.createEntry)((0, $iGbXw.classicSoftwareBacklogEmbedRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-backlog-embed',
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental-backlog'),
        component: (0, $16Z5s.RapidBoardSpaPage),
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            ...(0, $f5kpo.getUIFBacklogDataResource)(),
            ...(0, $f5kpo.getRapidboardResources)(),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $f5kpo.getRapidBoardDataResource)(),
            (0, $lJ1FP.getEditModelResource)(),
            (0, $lfnsv.getBoardDetailsResource)(),
            (0, $5bkvv.forgeBacklogModuleResource),
            (0, $5bkvv.forgeSprintModuleResource),
            (0, $2Ql51.themePreferenceResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('crocs-load_ai_enablement_in_backlog_router'), (0, $1jxD5.aiEntitlementResource))
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $3NItL.LazyBacklogPage)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-cmp-backlog-early-entry'
            ]
        },
        meta: {
            capability: (0, $9u12M.classicBacklogCapability)
        },
        earlyAssets: (0, $e2ctp.AGGRESSIVE_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("iGbXw", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBacklogEmbedRoute", () => $100ce1fd940d8aba$export$e6776ef8123b7136);
const $100ce1fd940d8aba$export$e6776ef8123b7136 = {
    name: 'rapidboard-backlog-embed',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog/embed'
};

});

parcelRegister("16Z5s", function(module, exports) {

$parcel$export(module.exports, "UIFBoardSpa", () => $21fca9455db40549$export$2164de18d39af313);
$parcel$export(module.exports, "RapidBoardSpaPage", () => $21fca9455db40549$export$4ceb6cf2934825b2);
$parcel$export(module.exports, "LazyRapidBoard", () => $21fca9455db40549$export$9de09057ba255cc4);
$parcel$export(module.exports, "LazyRapidBoardWrmBundleResource", () => $21fca9455db40549$export$bcb5bb6438a46dcb);
$parcel$export(module.exports, "LazyRapidBoardDataApiResource", () => $21fca9455db40549$export$d4640ceb9bdd4b4);
$parcel$export(module.exports, "LazyRapidBoardConfigApiResource", () => $21fca9455db40549$export$c96c36c0cbfb2c16);
$parcel$export(module.exports, "LazyRapidBoardResource", () => $21fca9455db40549$export$2ad64ed8eb98d9e);
$parcel$export(module.exports, "LazyRapidBoardApps", () => $21fca9455db40549$export$4a8825f3e310b97);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $21fca9455db40549$export$2164de18d39af313 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("3gYTm")), {
    moduleId: "./src/packages/spa-apps/next-gen-board/src/index.tsx"
});

const $21fca9455db40549$export$bcc6315cf211edab = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("hiNeG")), {
    moduleId: "./src/packages/spa-apps/next-gen-backlog/src/index.tsx"
});

const $21fca9455db40549$export$a1c59527bd5131cc = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("96xE3")).then((module)=>module.BoardConfigSwitcher), {
    moduleId: "./src/packages/router-routes/software/classic/board-settings/switcher/src/index.tsx"
});
const $21fca9455db40549$export$4ceb6cf2934825b2 = (props)=>{
    const { route: route, query: query, match: match } = props;
    const basePageId = route && route.name || 'rapid-board';
    const chartParam = query.chart ? `-${query.chart}` : '';
    const boardId = query.rapidView ?? match.params.boardId;
    const pageId = `${basePageId}-${boardId}${chartParam}`;
    if ([
        'rapidboard-board',
        'rapidboard-board-embed',
        'rapidboard-user-board'
    ].includes(route.name) && !query.config) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $21fca9455db40549$export$2164de18d39af313,
        pageId: pageId,
        shouldShowSpinner: false
    });
    if ([
        'rapidboard-backlog',
        'rapidboard-user-backlog',
        'rapidboard-backlog-embed'
    ].includes(route.name) && !query.config) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $21fca9455db40549$export$bcc6315cf211edab,
        pageId: pageId,
        shouldShowSpinner: false
    });
    if ([
        'rapidboard-backlog',
        'rapidboard-user-backlog',
        'rapidboard-board',
        'rapidboard-board-embed',
        'rapidboard-user-board',
        'rapidboard-backlog-embed'
    ].includes(route.name) && query.config) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $21fca9455db40549$export$a1c59527bd5131cc,
        pageId: pageId,
        shouldShowSpinner: false
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $21fca9455db40549$export$9de09057ba255cc4,
        pageId: pageId,
        shouldShowSpinner: false
    });
};

const $21fca9455db40549$export$9de09057ba255cc4 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("lKkfh")), {
    moduleId: "./src/packages/spa-apps/rapid-board/src/index-old.tsx"
});

const $21fca9455db40549$export$bcb5bb6438a46dcb = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("4ntFd")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/services/wrm-bundle/get-data/index.tsx"
});

const $21fca9455db40549$export$d4640ceb9bdd4b4 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("66t2H")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/services/data-api/get-data/index.tsx"
});

const $21fca9455db40549$export$c96c36c0cbfb2c16 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("6Pdur")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/services/config-api/get-data/index.tsx"
});

const $21fca9455db40549$export$2ad64ed8eb98d9e = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("3B60s")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/services/rapidboard-resource/get-data/index.tsx"
});

const $21fca9455db40549$export$4a8825f3e310b97 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("kkF9E")), {
    moduleId: "./src/packages/entry-rapid-board-wrm-apps/src/index.tsx"
});

});
parcelRegister("3gYTm", function(module, exports) {

let $262219919f35e770$var$load = (parcelRequire("28QjX"))(4);





module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $262219919f35e770$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $262219919f35e770$var$load("k6g9p")
        ]);
    }),
    (parcelRequire("avM1e"))('jirt-convert-class-to-functional-component', function() {
        return Promise.all([
            $262219919f35e770$var$load("1ls92")
        ]);
    }, function() {
        return Promise.all([
            $262219919f35e770$var$load("kLeYK")
        ]);
    }),
    $262219919f35e770$var$load("kNFvF"),
    $262219919f35e770$var$load("kVX56"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("5uTaB"), 4)),
    $262219919f35e770$var$load("ffQaD"),
    $262219919f35e770$var$load("kvRbA"),
    $262219919f35e770$var$load("76n7a"),
    $262219919f35e770$var$load("l253H"),
    $262219919f35e770$var$load("c4Xsx")
]).then(()=>parcelRequire('dnhKp'));

});

parcelRegister("hiNeG", function(module, exports) {

let $c98a4f4c38194088$var$load = (parcelRequire("28QjX"))(4);










module.exports = Promise.all([
    (parcelRequire("avM1e"))('jsw-backlog-main-component-refactor', function() {
        return Promise.all([
            (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
                return Promise.all([
                    $c98a4f4c38194088$var$load("8i6Do")
                ]);
            }, function() {
                return Promise.all([
                    $c98a4f4c38194088$var$load("k6g9p")
                ]);
            }),
            (parcelRequire("avM1e"))('jirt-convert-class-to-functional-component', function() {
                return Promise.all([
                    $c98a4f4c38194088$var$load("1ls92")
                ]);
            }, function() {
                return Promise.all([
                    $c98a4f4c38194088$var$load("kLeYK")
                ]);
            }),
            $c98a4f4c38194088$var$load("gWxOK"),
            $c98a4f4c38194088$var$load("l253H"),
            $c98a4f4c38194088$var$load("76n7a"),
            $c98a4f4c38194088$var$load("kvRbA"),
            $c98a4f4c38194088$var$load("ffQaD"),
            $c98a4f4c38194088$var$load("kNFvF")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
                return Promise.all([
                    $c98a4f4c38194088$var$load("8i6Do")
                ]);
            }, function() {
                return Promise.all([
                    $c98a4f4c38194088$var$load("k6g9p")
                ]);
            }),
            (parcelRequire("avM1e"))('jirt-convert-class-to-functional-component', function() {
                return Promise.all([
                    $c98a4f4c38194088$var$load("1ls92")
                ]);
            }, function() {
                return Promise.all([
                    $c98a4f4c38194088$var$load("kLeYK")
                ]);
            }),
            $c98a4f4c38194088$var$load("IPRH2"),
            $c98a4f4c38194088$var$load("l253H"),
            $c98a4f4c38194088$var$load("76n7a"),
            $c98a4f4c38194088$var$load("kvRbA"),
            $c98a4f4c38194088$var$load("ffQaD"),
            $c98a4f4c38194088$var$load("kNFvF")
        ]);
    }),
    (parcelRequire("avM1e"))('jsw-backlog-main-component-refactor', function() {
        return Promise.all([
            (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
                return Promise.all([
                    $c98a4f4c38194088$var$load("8i6Do")
                ]);
            }, function() {
                return Promise.all([
                    $c98a4f4c38194088$var$load("k6g9p")
                ]);
            }),
            (parcelRequire("avM1e"))('jirt-convert-class-to-functional-component', function() {
                return Promise.all([
                    $c98a4f4c38194088$var$load("1ls92")
                ]);
            }, function() {
                return Promise.all([
                    $c98a4f4c38194088$var$load("kLeYK")
                ]);
            }),
            $c98a4f4c38194088$var$load("gWxOK"),
            $c98a4f4c38194088$var$load("l253H"),
            $c98a4f4c38194088$var$load("76n7a"),
            $c98a4f4c38194088$var$load("kvRbA"),
            $c98a4f4c38194088$var$load("ffQaD"),
            $c98a4f4c38194088$var$load("kNFvF")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
                return Promise.all([
                    $c98a4f4c38194088$var$load("8i6Do")
                ]);
            }, function() {
                return Promise.all([
                    $c98a4f4c38194088$var$load("k6g9p")
                ]);
            }),
            (parcelRequire("avM1e"))('jirt-convert-class-to-functional-component', function() {
                return Promise.all([
                    $c98a4f4c38194088$var$load("1ls92")
                ]);
            }, function() {
                return Promise.all([
                    $c98a4f4c38194088$var$load("kLeYK")
                ]);
            }),
            $c98a4f4c38194088$var$load("IPRH2"),
            $c98a4f4c38194088$var$load("l253H"),
            $c98a4f4c38194088$var$load("76n7a"),
            $c98a4f4c38194088$var$load("kvRbA"),
            $c98a4f4c38194088$var$load("ffQaD"),
            $c98a4f4c38194088$var$load("kNFvF")
        ]);
    }),
    $c98a4f4c38194088$var$load("ghmPk")
]).then(()=>parcelRequire('1Xeln'));

});

parcelRegister("96xE3", function(module, exports) {

let $6a0ec5d0e920746e$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6a0ec5d0e920746e$var$load("ffQaD"),
    $6a0ec5d0e920746e$var$load("kvRbA"),
    $6a0ec5d0e920746e$var$load("hgzhX")
]).then(()=>parcelRequire('iYOPQ'));

});

parcelRegister("lKkfh", function(module, exports) {

let $fd4d9930697459b4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fd4d9930697459b4$var$load("AD9h4").then(()=>parcelRequire('43ajl'));

});

parcelRegister("kkF9E", function(module, exports) {

let $ecd5995b77052de6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ecd5995b77052de6$var$load("7s1Qm").then(()=>parcelRequire('73mZu'));

});


parcelRegister("fKmub", function(module, exports) {

$parcel$export(module.exports, "LazyIssueApp", () => $43c3852afc527b13$export$8c70dcc4643464f8);

var $kxZPA = parcelRequire("kxZPA");

const $43c3852afc527b13$export$8c70dcc4643464f8 = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("d38KI")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});

});

parcelRegister("1jxD5", function(module, exports) {

$parcel$export(module.exports, "aiEntitlementResource", () => $f1ad36205823a0c5$export$1d7e36ec4890154f);
$parcel$export(module.exports, "useAiEntitlementResource", () => $f1ad36205823a0c5$export$58958385d85a6e72);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $e7VcZ = parcelRequire("e7VcZ");
const $f1ad36205823a0c5$var$RESOURCE_TYPE_AI_ENTITLEMENT = 'AI_ENTITLEMENT';
const $f1ad36205823a0c5$export$1d7e36ec4890154f = (0, $2M1hQ.createResource)({
    type: $f1ad36205823a0c5$var$RESOURCE_TYPE_AI_ENTITLEMENT,
    getKey: ()=>$f1ad36205823a0c5$var$RESOURCE_TYPE_AI_ENTITLEMENT,
    getData: ()=>(0, $e7VcZ.fetchAiEnablement)(),
    maxAge: 3600000
});
const $f1ad36205823a0c5$export$58958385d85a6e72 = ()=>(0, $2YP9W.useResource)($f1ad36205823a0c5$export$1d7e36ec4890154f);

});
parcelRegister("e7VcZ", function(module, exports) {

$parcel$export(module.exports, "fetchAiEnablement", () => $d2a02eb2068290e1$export$ad4105850d0ce824);

var $7f4tk = parcelRequire("7f4tk");
const $d2a02eb2068290e1$var$JIRA_SOFTWARE_AI_ENABLED_URL = '/rest/api/1/aiconfig/ai-enabled/jira-software';
const $d2a02eb2068290e1$export$ad4105850d0ce824 = async ()=>{
    // We could check for other jira products / confluence when we need to
    // Not doing that right now as it adds complexity & we need software only now
    // See `@atlassian/jira-platform-react-hooks-use-is-admin-hub-ai-enabled`
    const entitlementData = {
        isAiEnabledForJiraSoftware: null
    };
    try {
        const response = await (0, $7f4tk.default)($d2a02eb2068290e1$var$JIRA_SOFTWARE_AI_ENABLED_URL, {
            method: 'GET'
        });
        entitlementData.isAiEnabledForJiraSoftware = response.isEnabled;
    } catch (_) {
        entitlementData.isAiEnabledForJiraSoftware = null;
    }
    return entitlementData;
};

});


parcelRegister("3NItL", function(module, exports) {

$parcel$export(module.exports, "LazyBacklogPage", () => $bc74f9ecc918272d$export$edb4b8cf67d7d767);

var $kxZPA = parcelRequire("kxZPA");

var $7yO8g = parcelRequire("7yO8g");

const $bc74f9ecc918272d$export$edb4b8cf67d7d767 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hiNeG"))), {
    moduleId: "./src/packages/spa-apps/next-gen-backlog/src/index.tsx"
});

});

parcelRegister("9u12M", function(module, exports) {

$parcel$export(module.exports, "classicBacklogCapability", () => $552e03b9f8528211$export$10a7bb102137d92b);

const $552e03b9f8528211$export$10a7bb102137d92b = !false ? (0, $281cbd47ba46dd7d$export$571692eec8a399e1) : (0, $281cbd47ba46dd7d$export$93104dc4eba58ba4);

});


parcelRegister("58Cy7", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBacklogRouteEntry", () => $80af0d16c3f293f2$export$568101ebd359b606);

var $7NszV = parcelRequire("7NszV");

var $2H7GR = parcelRequire("2H7GR");

var $16Z5s = parcelRequire("16Z5s");

var $i8JTM = parcelRequire("i8JTM");

var $4R6GH = parcelRequire("4R6GH");

var $aPfsS = parcelRequire("aPfsS");

var $gyYxw = parcelRequire("gyYxw");

var $g5RGc = parcelRequire("g5RGc");

var $lmyls = parcelRequire("lmyls");

var $5f2bR = parcelRequire("5f2bR");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $3HwlS = parcelRequire("3HwlS");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $7uLIV = parcelRequire("7uLIV");

var $f5kpo = parcelRequire("f5kpo");

var $lJ1FP = parcelRequire("lJ1FP");

var $lfnsv = parcelRequire("lfnsv");

var $fKmub = parcelRequire("fKmub");

var $ffza4 = parcelRequire("ffza4");

var $e2ctp = parcelRequire("e2ctp");

var $9s3j1 = parcelRequire("9s3j1");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");

var $1jxD5 = parcelRequire("1jxD5");

var $4xgA9 = parcelRequire("4xgA9");

var $9u12M = parcelRequire("9u12M");

var $3NItL = parcelRequire("3NItL");
/**
 * @deprecated delete when cleaning up blu-5799-jira-software-board-entrypoint-route
 */ const $80af0d16c3f293f2$var$getHorizontalNavResources = ()=>(0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route') ? [] : [
        (0, $7uLIV.horizontalNavJiraResource)
    ];
const $80af0d16c3f293f2$export$568101ebd359b606 = (0, $7NszV.createEntry)((0, $2H7GR.classicSoftwareBacklogRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-backlog',
        component: (0, $16Z5s.RapidBoardSpaPage),
        skeleton: (0, $i8JTM.NextGenBacklogSkeleton),
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental-backlog'),
        layout: (0, $aPfsS.composeLayouts)((0, $gyYxw.genericProjectLayout), (0, $g5RGc.pageLoadIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ], 'SIDEBAR')),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.ForPaintClassicSoftwareProjectSidebar),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true,
            sidebarId: (0, $4R6GH.fg)('blu-7261-change-blu-5799-to-support-nav3') ? (0, $lmyls.SIDEBAR_ID).CONTENT : undefined
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)({
                isUsingSidebarEntrypoint: // eslint-disable-next-line jira/ff/no-preconditioning
                ((0, $4R6GH.fg)('blu-7261-change-blu-5799-to-support-nav3') || (0, $3HwlS.getWillShowNav4)()) && (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route') && (0, $4R6GH.fg)('jfp-magma-fix-nav4-sidebar-client-api-call')
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // delete when cleaning up blu-5799-jira-software-board-entrypoint-route
            ...$80af0d16c3f293f2$var$getHorizontalNavResources(),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getUIFBacklogDataResource)(),
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            (0, $lJ1FP.getEditModelResource)(),
            (0, $lfnsv.getBoardDetailsResource)(),
            (0, $5bkvv.forgeBacklogModuleResource),
            (0, $5bkvv.forgeSprintModuleResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingEnabled)(), (0, $9V5k0.projectThemeResource)),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('crocs-load_ai_enablement_in_backlog_router'), (0, $1jxD5.aiEntitlementResource))
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3NItL.LazyBacklogPage)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-cmp-backlog-early-entry'
            ]
        },
        meta: {
            capability: (0, $9u12M.classicBacklogCapability)
        },
        earlyAssets: (0, $e2ctp.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        bifrost: {
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-classic-backlog-entries/src/classicSoftwareBacklogRouteEntry.tsx',
                whichExportToUse: 'classicSoftwareBacklogRouteEntry'
            },
            enabled: true,
            manifestName: 'jira-spa-software-backlog.json'
        },
        entryPoint: ()=>((0, $4R6GH.fg)('blu-7261-change-blu-5799-to-support-nav3') || (0, $3HwlS.getWillShowNav4)()) && (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route') ? (0, $4xgA9.classicBacklogPageEntryPoint) : undefined,
        supportsPreviewPanel: true
    }));

});
parcelRegister("2H7GR", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBacklogRoute", () => $fe6107d28b9a7842$export$9bfa3c0dded1688f);
const $fe6107d28b9a7842$export$9bfa3c0dded1688f = {
    name: 'rapidboard-backlog',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog'
};

});

parcelRegister("i8JTM", function(module, exports) {

$parcel$export(module.exports, "NextGenBacklogSkeleton", () => $de21fa38a510bb6d$export$33cd465913cf178f);
/* NextGenBacklogSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7XYc4 = parcelRequire("7XYc4");

var $dCm1o = parcelRequire("dCm1o");

var $hCy6k = parcelRequire("hCy6k");

var $5Pi2v = parcelRequire("5Pi2v");
const $de21fa38a510bb6d$export$433c2e8574f2e911 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5Pi2v)))
    });
const $de21fa38a510bb6d$export$88189b56881f213e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($de21fa38a510bb6d$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5Pi2v)))
    }));
const $de21fa38a510bb6d$var$BacklogSkeleton = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $de21fa38a510bb6d$export$88189b56881f213e, $de21fa38a510bb6d$export$433c2e8574f2e911);
const $de21fa38a510bb6d$export$33cd465913cf178f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", false ? {
        'data-ssr-placeholder': 'software-backlog-skeleton'
    } : {
        'data-ssr-placeholder-replace': 'software-backlog-skeleton'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($de21fa38a510bb6d$var$BacklogSkeleton, null));
// Adding this wrapper to override the border width from AppSkeletonImage
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $de21fa38a510bb6d$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1bgi _1xpi1tcg _1sbz1tcg _1cpn1tcg _13xs1tcg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dCm1o", function(module, exports) {

$parcel$export(module.exports, "isVisualRefreshEnabled", () => $322f7f27e3ad3058$export$48345cb467db19b6);

var $3HwlS = parcelRequire("3HwlS");
const $322f7f27e3ad3058$export$48345cb467db19b6 = ()=>(0, $3HwlS.getWillShowNav4)();

});

parcelRegister("5Pi2v", function(module, exports) {
module.exports = new URL("next-gen-backlog-app-skeleton.tpl.28e29051.svg", import.meta.url).toString();

});


parcelRegister("7uLIV", function(module, exports) {

$parcel$export(module.exports, "horizontalNavJiraResource", () => $1769860a1d0fe224$export$faeb8c89315e20da);

var $ao2h1 = parcelRequire("ao2h1");

var $ivm9B = parcelRequire("ivm9B");

var $kV9ss = parcelRequire("kV9ss");

var $1nb22 = parcelRequire("1nb22");

var $3HwlS = parcelRequire("3HwlS");

var $ktofH = parcelRequire("ktofH");

var $gNStA = parcelRequire("gNStA");

var $6YG83 = parcelRequire("6YG83");
const $1769860a1d0fe224$export$71eec30d9db46a56 = ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
    const boardId = match.params.boardId;
    let { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    projectKey = projectKey ?? '';
    projectId = projectId ?? '';
    const projectIdOrKey = projectId || projectKey;
    const isTMPBoardRoute = boardId ? match.url.includes('/software/projects/') : false;
    const boardAri = boardId ? `ari:cloud:jira-software:${cloudId}:board/${boardId}` : '';
    const projectAri = projectId ? (0, $kV9ss.JiraProjectAri).create({
        siteId: cloudId,
        projectId: projectId
    }).toString() : '';
    let containerNavigationInput;
    if (isTMPBoardRoute) containerNavigationInput = projectAri ? {
        scopeId: boardAri
    } : {
        projectKeyQuery: {
            cloudId: cloudId,
            projectKey: projectKey
        }
    };
    else containerNavigationInput = boardAri || projectAri ? {
        scopeId: boardAri || projectAri
    } : {
        projectKeyQuery: {
            cloudId: cloudId,
            projectKey: projectKey
        }
    };
    return {
        options: {
            fetchPolicy: 'store-and-network'
        },
        parameters: (0, $ivm9B.default),
        variables: {
            cloudId: cloudId,
            projectIdOrKey: projectIdOrKey,
            withProject: Boolean(projectIdOrKey),
            boardId: boardAri,
            withBoard: Boolean(boardAri),
            containerNavigationInput: containerNavigationInput,
            isTMPBoardRoute: isTMPBoardRoute,
            first: (0, $ktofH.NAVIGATION_ITEMS_PAGE_SIZE)
        }
    };
};
const $1769860a1d0fe224$var$horizontalNavJiraResourceActual = (0, $6YG83.withGiraAggAnonSsrFix)((0, $ao2h1.createRelayResource)({
    type: 'HORIZONTAL_NAVIGATION_JIRA_QUERY',
    getQuery: $1769860a1d0fe224$export$71eec30d9db46a56
}));
const $1769860a1d0fe224$export$faeb8c89315e20da = (0, $gNStA.resourceWithCondition2)(()=>(0, $3HwlS.getWillShowNav4)(), $1769860a1d0fe224$var$horizontalNavJiraResourceActual);

});
parcelRegister("ivm9B", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e7cee9907baeab7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<25637c34c77ecbacbdb193525c6b35dc>>
 * @relayHash 803bd2411b5ccfb7091d5aac3095a48a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6d9f5406464f687f1985513ff8a0101826fc3041b4f0dee81c75ab40777cf9e2

var $58v9Y = parcelRequire("58v9Y");

var $i536Z = parcelRequire("i536Z");

var $9pmwJ = parcelRequire("9pmwJ");

var $eiowN = parcelRequire("eiowN");
const $5e7cee9907baeab7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerNavigationInput"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTMPBoardRoute"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIdOrKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "withBoard"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "withProject"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "url"
    }, v11 = {
        "kind": "ScalarField",
        "name": "label"
    }, v12 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v13 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v14 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v15 = [
        {
            "kind": "ScalarField",
            "name": "message"
        },
        {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                v8 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "statusCode"
                }
            ]
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "canEdit"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            v9 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v18 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v19 = {
        "kind": "ScalarField",
        "name": "boardId"
    }, v20 = {
        "kind": "ScalarField",
        "name": "name"
    }, v21 = {
        "kind": "ScalarField",
        "name": "boardType"
    }, v22 = {
        "concreteType": "JiraFavouriteValue",
        "kind": "LinkedField",
        "name": "favouriteValue",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isFavourite"
            },
            v9 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "HorizontalNavJiraInnerQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "JiraHorizontalNavigationContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v7 /*: any*/ ,
                v0 /*: any*/ ,
                v6 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "HorizontalNavJiraInnerQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "input",
                                    "variableName": "containerNavigationInput"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "containerNavigation",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraContainerNavigationResult"
                                },
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopeId"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "first",
                                                    "variableName": "first"
                                                }
                                            ],
                                            "concreteType": "JiraNavigationItemConnection",
                                            "kind": "LinkedField",
                                            "name": "navigationItems",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraNavigationItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isDefault"
                                                                },
                                                                v10 /*: any*/ ,
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "typeKey"
                                                                },
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "kind": "TypeDiscriminator",
                                                                    "abstractKey": "__isJiraNavigationItem"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canRename"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canRemove"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canSetAsDefault"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "appId"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraAppSection",
                                                                            "kind": "LinkedField",
                                                                            "name": "sections",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraAppNavigationItemNestedLink",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "links",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v10 /*: any*/ ,
                                                                                        v11 /*: any*/ ,
                                                                                        v12 /*: any*/ ,
                                                                                        v13 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v11 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v12 /*: any*/ ,
                                                                        v13 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "envLabel"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v14 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraNavigationItem",
                                                                            "abstractKey": "__isJiraNavigationItem"
                                                                        }
                                                                    ],
                                                                    "type": "JiraAppNavigationItem"
                                                                },
                                                                v14 /*: any*/ 
                                                            ]
                                                        },
                                                        v8 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "errors",
                                                    "plural": true,
                                                    "selections": v15 /*: any*/ 
                                                }
                                            ]
                                        },
                                        v16 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopeUrl"
                                        }
                                    ],
                                    "type": "JiraContainerNavigation"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": v15 /*: any*/ ,
                                    "type": "QueryError"
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                v18 /*: any*/ 
                            ],
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        },
                        {
                            "condition": "withBoard",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "boardId"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "jiraBoard",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v19 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v22 /*: any*/ ,
                                                v14 /*: any*/ 
                                            ],
                                            "type": "JiraBoard"
                                        },
                                        v17 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "withProject",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                v18 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "idOrKey",
                                    "variableName": "projectIdOrKey"
                                }
                            ],
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jira_projectByIdOrKey",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "large"
                                        }
                                    ]
                                },
                                {
                                    "alias": "canEditProjectConfig",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "EDIT_PROJECT_CONFIG"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "canPerform"
                                        }
                                    ],
                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                },
                                v20 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectStyle"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "softwareBoardCount"
                                },
                                v9 /*: any*/ ,
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphStoreSimplifiedTeamConnectedToContainerInverseConnection",
                                                    "kind": "LinkedField",
                                                    "name": "teamsConnected",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "totalCount"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "isTMPBoardRoute",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "alias": "projectKey",
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "mostRecentlyViewedBoard",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v14 /*: any*/ 
                                                    ],
                                                    "type": "JiraBoard"
                                                },
                                                v17 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isLiveTemplate"
                                        }
                                    ]
                                },
                                v14 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6d9f5406464f687f1985513ff8a0101826fc3041b4f0dee81c75ab40777cf9e2",
            "metadata": {},
            "name": "HorizontalNavJiraInnerQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider": (0, $58v9Y.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider": (0, $9pmwJ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider": (0, $i536Z.default)
            }
        }
    };
}();
$5e7cee9907baeab7$var$node.hash = "cfedd5347d81ca2f36fa810c25c638f4";
(0, $eiowN.PreloadableQueryRegistry).set($5e7cee9907baeab7$var$node.params.id, $5e7cee9907baeab7$var$node);
var $5e7cee9907baeab7$export$2e2bcd8739ae039 = $5e7cee9907baeab7$var$node;

});


parcelRegister("lmBAt", function(module, exports) {

$parcel$export(module.exports, "getIsSoftwareThemingEnabled", () => $e55c8e35955d09b8$export$a505f57c5130832f);
$parcel$export(module.exports, "getIsSoftwareThemingM2Enabled", () => $e55c8e35955d09b8$export$4fa2eaefe7d59f41);

var $3HwlS = parcelRequire("3HwlS");

var $6s1PB = parcelRequire("6s1PB");
const $e55c8e35955d09b8$export$a505f57c5130832f = ()=>(0, $3HwlS.getWillShowNav4)() && (0, $6s1PB.expVal)('jira_theming_milestone_1', 'isEnabled', false);
const $e55c8e35955d09b8$export$4fa2eaefe7d59f41 = ()=>$e55c8e35955d09b8$export$a505f57c5130832f() && (0, $6s1PB.expVal)('jira_theming_milestone_2', 'isEnabled', false);

});

parcelRegister("4xgA9", function(module, exports) {

$parcel$export(module.exports, "classicBacklogPageEntryPoint", () => $0d6e17d6eb5b0d6b$export$e07cd4fec395c8db);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $6avBT = parcelRequire("6avBT");

var $dwZUI = parcelRequire("dwZUI");

var $fT58V = parcelRequire("fT58V");

var $krpZe = parcelRequire("krpZe");

var $fo6b8 = parcelRequire("fo6b8");
const $0d6e17d6eb5b0d6b$export$e07cd4fec395c8db = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $6avBT.nextGenBacklogEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $fT58V.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $krpZe.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $dwZUI.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("6avBT", function(module, exports) {

$parcel$export(module.exports, "nextGenBacklogEntryPoint", () => $bb040829e080170c$export$377b23d5a7dc4052);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $bb040829e080170c$export$377b23d5a7dc4052 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("hiNeG")), {
        moduleId: "20e1173f",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});

parcelRegister("dwZUI", function(module, exports) {

$parcel$export(module.exports, "nav4JSWProjectEntryPoint", () => $a51b1482b4cc12b0$export$b1c3a10bbf92ce74);

var $gIUIa = parcelRequire("gIUIa");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");
const $a51b1482b4cc12b0$var$NO_OF_BOARDS_TO_FETCH = 25;

const $a51b1482b4cc12b0$export$b1c3a10bbf92ce74 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("dC9Hn")).then(({ JswExpandableProjectQuery: JswExpandableProjectQuery })=>JswExpandableProjectQuery), {
        moduleId: "69299f40",
        moduleName: "JswExpandableProjectQuery",
        priority: "userVisible"
    }),
    getPreloadProps: (params)=>{
        const cloudId = params.tenantContext?.cloudId ?? '';
        const projectKey = params.context?.match.params?.projectKey ?? '';
        return {
            queries: {
                projects: {
                    parameters: $gIUIa.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey,
                        noOfBoardsToFetch: $a51b1482b4cc12b0$var$NO_OF_BOARDS_TO_FETCH
                    }
                }
            }
        };
    }
});

});
parcelRegister("gIUIa", function(module, exports) {

$parcel$export(module.exports, "default", () => $b76d34c79f26c888$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e40ded01b81f7feeace8ee5b7256d3ba>>
 * @relayHash 097e9539e9354202b3e97195911da82f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6a320080b485b09015939f9500e70d6187724b59304246a0240d200bc037c971

var $eiowN = parcelRequire("eiowN");
const $b76d34c79f26c888$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "noOfBoardsToFetch"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v6 = {
        "kind": "ScalarField",
        "name": "boardId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            v4 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "JswExpandableProjectQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "noOfBoardsToFetch",
                                                    "variableName": "noOfBoardsToFetch"
                                                }
                                            ],
                                            "kind": "FragmentSpread",
                                            "name": "JswBoards"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "JswExpandableProjectQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "projectKey",
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                },
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "first",
                                            "variableName": "noOfBoardsToFetch"
                                        }
                                    ],
                                    "concreteType": "JiraBoardConnection",
                                    "kind": "LinkedField",
                                    "name": "boards",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraBoardEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraBoard",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "defaultNavigationItem",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ],
                                                                    "type": "JiraNavigationItem",
                                                                    "abstractKey": "__isJiraNavigationItem"
                                                                },
                                                                v8 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraFavouriteValue",
                                                            "kind": "LinkedField",
                                                            "name": "favouriteValue",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v4 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardType"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "canEdit"
                                                        },
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__id"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "mostRecentlyViewedBoard",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v6 /*: any*/ 
                                            ],
                                            "type": "JiraBoard"
                                        },
                                        v8 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "softwareBoardCount"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6a320080b485b09015939f9500e70d6187724b59304246a0240d200bc037c971",
            "metadata": {},
            "name": "JswExpandableProjectQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b76d34c79f26c888$var$node.hash = "c86c96423726df260003e830175ef141";
(0, $eiowN.PreloadableQueryRegistry).set($b76d34c79f26c888$var$node.params.id, $b76d34c79f26c888$var$node);
var $b76d34c79f26c888$export$2e2bcd8739ae039 = $b76d34c79f26c888$var$node;

});

parcelRegister("dC9Hn", function(module, exports) {

let $9e9658eed21b0f03$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9e9658eed21b0f03$var$load("4Wx3P").then(()=>parcelRequire('fhfEu'));

});


parcelRegister("fT58V", function(module, exports) {

$parcel$export(module.exports, "nav4SidebarContentCoreEntryPoint", () => $b83318e39ccb6f4a$export$c5a39ebd1638fa7);

var $2OeZv = parcelRequire("2OeZv");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $b83318e39ccb6f4a$export$c5a39ebd1638fa7 = (0, $fEDBv.createEntryPoint)({
    // sidebar is critical to rendering the initial view of a page
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>Promise.resolve((parcelRequire("gyZtn"))).then(({ SidebarContentForEntryPoint: SidebarContentForEntryPoint })=>SidebarContentForEntryPoint), {
        moduleId: "4c2c284d",
        priority: "userVisible"
    }),
    // Result matches the generics of the async component's EntryPointProps
    // except for TComponentProps which is derived from `root`
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getPreloadProps (params) {
        const { context: context, tenantContext: tenantContext, entryPoints: entryPoints = {}, isAppsExpanded: isAppsExpanded, isFiltersExpanded: isFiltersExpanded, isPlansExpanded: isPlansExpanded, isProjectsExpanded: isProjectsExpanded, isOperationsExpanded: isOperationsExpanded, isOverviewsExpanded: isOverviewsExpanded } = params;
        // The two parameters have been injected by the theme setter, and should
        // not be here. Setting them naively just to be able to use the sidebar entryPoint again.
        const projectAri = '';
        const projectKey = context.match.params.projectKey || '';
        return {
            // Queries your async component uses
            queries: {
                nav4SidebarContentCore: {
                    // generated .graphql
                    parameters: (0, $2OeZv.default),
                    // variables for your query
                    variables: {
                        cloudId: tenantContext.cloudId,
                        isAppsExpanded: isAppsExpanded,
                        isFiltersExpanded: isFiltersExpanded,
                        isPlansExpanded: isPlansExpanded,
                        isProjectsExpanded: isProjectsExpanded,
                        isOperationsExpanded: isOperationsExpanded,
                        isOverviewsExpanded: isOverviewsExpanded,
                        projectAri: projectAri,
                        projectKey: projectKey,
                        entityAriProjects: `ari:cloud:jira:${tenantContext.cloudId}:navigation-settings/activation/${tenantContext.activationId}/projects`,
                        ownerAri: tenantContext.atlassianAccountId && `ari:cloud:identity::user/${tenantContext.atlassianAccountId}`
                    },
                    // fetch options
                    options: {
                        fetchPolicy: 'store-and-network'
                    }
                }
            },
            entryPoints: entryPoints
        };
    }
});

});
parcelRegister("gyZtn", function(module, exports) {

$parcel$export(module.exports, "SidebarContent", () => $b739c7529929160b$export$49e8f7b58a4df4ea);
$parcel$export(module.exports, "SidebarContentForEntryPoint", () => $b739c7529929160b$export$ece6bd06aa8b2350);

var $5uXOq = parcelRequire("5uXOq");

var $3yxBH = parcelRequire("3yxBH");

var $cJFfS = parcelRequire("cJFfS");

var $gSZmd = parcelRequire("gSZmd");

var $7GXsr = parcelRequire("7GXsr");

var $7CMCs = parcelRequire("7CMCs");

var $4R6GH = parcelRequire("4R6GH");

var $2fwuR = parcelRequire("2fwuR");

var $46Cti = parcelRequire("46Cti");

var $cKjfv = parcelRequire("cKjfv");

var $dUyqZ = parcelRequire("dUyqZ");

var $lfTZh = parcelRequire("lfTZh");

var $ao2h1 = parcelRequire("ao2h1");

var $cZpsT = parcelRequire("cZpsT");

var $l8ruj = parcelRequire("l8ruj");

var $doZTA = parcelRequire("doZTA");

var $1zjdl = parcelRequire("1zjdl");

var $2TuwK = parcelRequire("2TuwK");
const $b739c7529929160b$export$49e8f7b58a4df4ea = ()=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const { queryReference: queryReference } = (0, $ao2h1.useRelayResource)((0, $2fwuR.sidebarNav4Resource));
    const queryReferenceRef = (0, $5uXOq.useRef)(null);
    if (isAnonymous) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b739c7529929160b$export$57e04c8c2365ae3b, null);
    // We don't want to use null query references. So only remember the non-null ones,
    // and pass the non-null query reference to the children.
    // From Slack: https://atlassian.slack.com/archives/C01E2MPPLE4/p1654736794416059?thread_ts=1654051102.548519&cid=C01E2MPPLE4
    if (queryReference) queryReferenceRef.current = queryReference;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b739c7529929160b$export$a18798f247d81ed3, {
        queryReference: queryReferenceRef.current
    });
};
function $b739c7529929160b$export$ece6bd06aa8b2350({ queries: { nav4SidebarContentCore: nav4SidebarContentCore } }) {
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    if (isAnonymous) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b739c7529929160b$export$57e04c8c2365ae3b, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b739c7529929160b$export$a18798f247d81ed3, {
        queryReference: nav4SidebarContentCore
    });
}
function $b739c7529929160b$export$a18798f247d81ed3({ queryReference: queryReference }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4-sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "l1-nav-menu-items",
        packageName: (0, $1zjdl.PACKAGE_NAME),
        teamName: (0, $1zjdl.TEAM_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3yxBH.SideNavContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gSZmd.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "l1-nav-menu-items",
        fallback: null
    }, queryReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2TuwK.L1MenuItems), {
        queryReference: queryReference
    })))), (0, $4R6GH.fg)('blu-2735_nav4_onboarding') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7GXsr.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cKjfv.SidebarReady), null)));
}
function $b739c7529929160b$export$57e04c8c2365ae3b() {
    const { formattedMessage: projectsMessage, icon: projectsIcon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).PROJECTS);
    const { formattedMessage: dashboardsMessage, icon: dashboardsIcon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).DASHBOARDS);
    const { formattedMessage: filtersMessage, icon: filtersIcon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).FILTERS);
    // We want to remove useRouter but the anonymous path is not as urgent as the authenticated path
    const [{ match: match }] = (0, $doZTA.useRouter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "l1-nav-menu-items",
        packageName: (0, $1zjdl.PACKAGE_NAME),
        teamName: (0, $1zjdl.TEAM_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3yxBH.SideNavContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gSZmd.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "l1-nav-menu-items",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cJFfS.LinkMenuItem), {
        elemBefore: projectsIcon,
        href: "/jira/projects",
        isSelected: match.path.startsWith('/jira/projects')
    }, projectsMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cJFfS.LinkMenuItem), {
        elemBefore: filtersIcon,
        href: "/jira/filters",
        isSelected: match.path === '/jira/filters' || match.path.startsWith('/issues/')
    }, filtersMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cJFfS.LinkMenuItem), {
        elemBefore: dashboardsIcon,
        href: "/jira/dashboards",
        isSelected: match.path.startsWith('/jira/dashboards')
    }, dashboardsMessage)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cKjfv.SidebarReady), null));
}

});
parcelRegister("3yxBH", function(module, exports) {

$parcel$export(module.exports, "SideNavContent", () => $0bf3573d8c099cfe$export$babe3c784778f3ba);
/* side-nav-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $0bf3573d8c099cfe$export$babe3c784778f3ba = /*#__PURE__*/ (0, $5uXOq.forwardRef)($0bf3573d8c099cfe$var$_SideNavContent);
// Placing this const below the function breaks Compiled!
const $0bf3573d8c099cfe$var$styles = {
    scrollContainer: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo1wug _18m91wug",
    paddingContainer: "_ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};
function $0bf3573d8c099cfe$var$_SideNavContent({ children: children, testId: testId }, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: ref,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            $0bf3573d8c099cfe$var$styles.scrollContainer
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $bwpsq.default)([
                $0bf3573d8c099cfe$var$styles.paddingContainer
            ]),
            children: children
        })
    });
}

});

parcelRegister("cJFfS", function(module, exports) {

$parcel$export(module.exports, "LinkMenuItem", () => $daf8eb0f19c00aff$export$d2cad7a1cce7b35f);
/* link-menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5JjdN = parcelRequire("5JjdN");

var $ivhXk = parcelRequire("ivhXk");

var $eUDGK = parcelRequire("eUDGK");

var $fdP8o = parcelRequire("fdP8o");

var $cs9Q6 = parcelRequire("cs9Q6");
const $daf8eb0f19c00aff$var$listItemStyles = {
    root: "_10m98stt"
};
const $daf8eb0f19c00aff$var$LinkMenuItemNoRef = ({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, actionsOnHover: actionsOnHover, isSelected: isSelected, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const itemRef = (0, $5uXOq.useRef)(null);
    (0, $cs9Q6.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: isSelected ?? false
    });
    const ref = (0, $5uXOq.useMemo)(()=>{
        return (0, $5JjdN.default)([
            itemRef,
            listItemRef ?? null
        ]);
    }, [
        itemRef,
        listItemRef
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eUDGK.ListItem), {
        ref: ref,
        xcss: $daf8eb0f19c00aff$var$listItemStyles.root,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fdP8o.MenuItemBase), {
            testId: testId,
            description: description,
            actions: actions,
            elemAfter: elemAfter,
            // TODO Always use "open in new window" icon when `openInNewWindow` prop is true
            elemBefore: elemBefore,
            href: href,
            target: target,
            actionsOnHover: actionsOnHover,
            isSelected: isSelected,
            onClick: onClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
};
const $daf8eb0f19c00aff$export$d2cad7a1cce7b35f = (0, $ivhXk.forwardRefWithGeneric)($daf8eb0f19c00aff$var$LinkMenuItemNoRef);

});
parcelRegister("fdP8o", function(module, exports) {

$parcel$export(module.exports, "MenuItemBase", () => $453992fef59345a2$export$859b390bf71e044e);
/* menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $DEWI6 = parcelRequire("DEWI6");

var $620nX = parcelRequire("620nX");

var $5JjdN = parcelRequire("5JjdN");

var $5McnS = parcelRequire("5McnS");
var $3Lty3 = parcelRequire("3Lty3");
var $dS3PR = parcelRequire("dS3PR");

var $3bDjY = parcelRequire("3bDjY");
var $btzsC = parcelRequire("btzsC");

var $ivhXk = parcelRequire("ivhXk");


var $et13M = parcelRequire("et13M");

var $aV1jL = parcelRequire("aV1jL");

var $4qwFZ = parcelRequire("4qwFZ");

// Using `lazy` so that only consumers who want drag and drop
// need to include code for the drag handle.
const $453992fef59345a2$var$LazyDragHandle = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("ckLZt")));
const $453992fef59345a2$var$tooltipStyles = {
    root: "_2rkoglpi _11c8dcr7 _1e0c1txw _2lx21bp4 _1bah1h6o _1tkezwfg _p12f1pna _vchhusvi _1q51v77o _y4ti12x7 _85i5v77o _bozg12x7 _bfhkcdhy _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _slp31hna"
};
const $453992fef59345a2$var$MenuItemTooltip = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function MenuItemTooltip({ children: children, className: className, ...rest }, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $btzsC.default), {
        ...rest,
        // Manually passing on `className` so it gets merged correctly in the build output.
        // The passed classname is mostly used for integration testing (`.Tooltip`)
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $453992fef59345a2$var$tooltipStyles.root,
            className
        ]),
        // "css" does not "exist" - it gets transformed into "className" by compiled
        ref: ref,
        children: children
    });
});
function $453992fef59345a2$var$isTextClamped(element) {
    // Checking for vertical height rather than horizontal height.
    // When text is "clamped", it's technically being clamped vertically! 🤯
    return element.scrollHeight > element.clientHeight;
}
const $453992fef59345a2$var$defaultAvatarValues = {
    size: 'small'
};
const $453992fef59345a2$var$elemAfterDisplayVar = '--elem-after-display';
const $453992fef59345a2$var$actionsOnHoverDisplayVar = '--actions-on-hover-display';
const $453992fef59345a2$var$notchColorVar = '--notch-color';
// Note: this is also used in `drag-handle.tsx`
const $453992fef59345a2$var$dragHandleDisplayVar = '--drag-handle-display';
const $453992fef59345a2$var$dragCursorAnimation = null;
/**
 * ## 🤹 `position:relative`
 *
 * We need `position:relative` on an element that takes
 * up the full size of the interactive element so we
 * can correctly use `position:absolute` to place:
 * 1. the notch for links
 * 2. drop indicators for drag and drop
 * 3. a child of button / anchor to stretch it out to
 *    increase it's pressable area.
 *
 * ⛔️ We cannot add `position:relative` _only_ on the
 * button / anchor as that will cause sibling elements
 * to be rendered under the button / anchor when setting
 * a background color on the button / anchor.
 *
 * 📖 Note: `position:relative` elements are painted after
 * elements with `position:static` (the default)
 * https://drafts.csswg.org/css-position-4/#painting-order
 *
 * ⛔️ We cannot add `position:relative` to the container
 * element, as then the `:focus` ring styles on the
 * button / anchor can be cut off by the next sibling if it has
 * has a background color set (eg when selected)
 *
 * ✅ Add `position:relative` to all first level descendants
 * of the container element so that we don't impact DOM ordered
 * paint ordering within the item and the button / anchor focus
 * ring can still bleed over siblings
 *
 * 📖 We could use `> * { position: relative; }` on the container,
 * but that would violate our styling standard.
 */ const $453992fef59345a2$var$topLevelSiblingStyles = {
    root: "_kqswh2mm"
};
/**
 * All slots on the menu item (eg `elemBefore`) are rendered as siblings
 * of our main button / anchor element and they are visually placed on
 * top of the main button / anchor.
 *
 * 📖 This is done so that we don't nest interactive elements in our markup.
 *
 * ✅ This is great when element in the slot is an interactive element
 * as we don't want the main menu item button / anchor to be triggered
 * when interacting with the element in the slot.
 *
 * ⛔️ When the element in the slot is static content (eg an `<Icon>`) it will
 * prevent the main button / anchor (that is visually behind the element in
 * the slot) from being clicked. The element in the slot is a sibling of our
 * main button / anchor (not a child of it) so clicking on the element in the
 * slot will not bubble up to the button / anchor.
 *
 * 🚀 We set `pointer-events:none` on a slot if it does not contain and interactive
 * element so that static content in a slot does not prevent clicking on the main
 * button / anchor.
 */ const $453992fef59345a2$var$onTopOfButtonOrAnchorStyles = {
    root: "_18ukglyw"
};
const $453992fef59345a2$export$91f7cd3f990d8a52 = '&:has([aria-expanded="true"][aria-haspopup="true"])';
const $453992fef59345a2$var$containerStyles = {
    root: "_2rkoglpi _vchhusvi _1e0c11p5 _yv0e7dup _2z05hkll _1lmcu4vt _1ul9t9kd _4t3izwfg _4cvr1h6o _uiztglyw _syaz1gjq _ek6gglyw _1yyu3acm _91ju1txw _1swv108i _1ojv1txw _irr3108i _1brr1txw _109x1txw",
    removeElemAfter: "_91juglyw",
    showHoverActions: "_ek6g1txw",
    removeElemAfterOnHover: "_1mfcglyw _1sjuglyw",
    removeElemAfterOnHoverOrOpenNestedPopup: "_1djyglyw _1mfcglyw _1sjuglyw",
    selected: "_bfhkfg4m _syazaqb7 _1yyu1fvw _1swvi1yw _30l3aqb7 _irr3i1yw",
    disabled: "_syaz1lh4 _irr3n7od",
    hasDescription: "_4t3ickbl",
    dragging: "_tzy41ou4"
};
const $453992fef59345a2$var$buttonOrAnchorStyles = {
    root: "_2rkoglpi _yyhyjvu9 _1ii7kb7n _1e0c11p5 _yv0enbh3 _2z05nbh3 _y4ti1b66 _bozg1b66 _1q511b66 _85i51b66 _bfhk18uv _syaz1gjq _4cvr1h6o _y3gnv2br _14iu1ji5",
    selected: "_syazaqb7 _14iu19ru",
    hasDragIndicator: "_1ifmglyw _1cykglyw _x0kw1txw _7psyru3m _11om6b4r _1uy01amc _bir2q7pw"
};
const $453992fef59345a2$var$extendButtonOrAnchorStyles = {
    root: "_1r04ze3t _kqswstnw"
};
const $453992fef59345a2$var$notchStyles = {
    root: "_kqswstnw _152t1ssb _1e02ze3t _1bsbyh40 _4t3i1crf _t9ec1i34 _bfhk1o0g"
};
const $453992fef59345a2$var$actionStyles = {
    root: "_zulp1b66 _nd5lbc26 _1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
};
const $453992fef59345a2$var$actionsOnHoverStyles = {
    root: "_nd5l16dh _zulp1b66 _1reo15vq _18m915vq _1e0c1c3z _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
};
const $453992fef59345a2$var$textStyles = {
    root: "_zulpv77o _1reo15vq _18m915vq _y4ti1b66 _bozg1b66 _1e0c1txw _2lx21bp4 _1ul91c9m _1guo18uv _12s918uv",
    noElemBeforeIndent: "_bozg12x7"
};
const $453992fef59345a2$var$elemBeforeStyles = {
    root: "_nd5l17zh _1reo15vq _18m915vq _1e0c1txw _1o9zidpf _1bsb1tcg _4t3i1tcg _4cvr1h6o _1bah1h6o _bozg1b66 _vchh18uv _1guo18uv _12s918uv"
};
const $453992fef59345a2$var$elemAfterStyles = {
    root: "_nd5l16dh _1reo15vq _18m915vq _1e0c13yo _1o9zidpf _4t3i1tcg _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
};
/**
 * We are using a wrapping element for our interactive content
 * even though only the `Text` element is the only thing not using `position:absolute`
 *
 * Rationale:
 * - Super clear that everything inside the interactive content should be in a specific slot in the grid
 * - To work around a browser bug in Safari where it does not work well with `position:absolute`
 *   on a subgrid child.
 *   Safari bug: https://bugs.webkit.org/show_bug.cgi?id=292516
 */ const $453992fef59345a2$var$interactiveContentStyles = {
    root: "_nd5l19l3 _1e0c1txw _2lx21bp4 _ae4v1h6o"
};
function $453992fef59345a2$var$getTextColor({ isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled) return 'color.text.disabled';
    if (isSelected) return 'color.text.selected';
    return 'color.text.subtle';
}
/**
 * This is the internal version of the component, to be passed into `forwardRef`.
 *
 * It contains a type argument `<T>`, to specify the type of the interactive element (`button` or `a`).
 * This can be inferred from the type of the `onClick` prop.
 */ const $453992fef59345a2$var$MenuItemBaseNoRef = ({ testId: testId, actions: actions, actionsOnHover: actionsOnHover, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, ariaControls: ariaControls, ariaExpanded: ariaExpanded, ariaHasPopup: ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const level = (0, $et13M.useLevel)();
    const setFlyoutMenuOpen = (0, $aV1jL.useSetFlyoutMenuOpen)();
    const isFlyoutMenuOpen = (0, $aV1jL.useFlyoutMenuOpen)();
    const isLink = typeof href !== 'undefined';
    const labelRef = (0, $5uXOq.useRef)(null);
    const descriptionRef = (0, $5uXOq.useRef)(null);
    const tooltipOnClick = (0, $5uXOq.useRef)(null);
    const handleClick = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        // Toggle flyout menu open state when inside a flyout context provider
        setFlyoutMenuOpen(!isFlyoutMenuOpen);
        tooltipOnClick.current?.(event);
    }, [
        onClick,
        setFlyoutMenuOpen,
        isFlyoutMenuOpen
    ]);
    /**
   * Show the tooltip if _either_ label or description is truncated
   */ const canTooltipAppear = (0, $5uXOq.useCallback)(()=>{
        if (isContentTooltipDisabled) return false;
        // Show tooltip if _either_ label or description are clamped
        const label = labelRef.current;
        const description = descriptionRef.current;
        if (label && $453992fef59345a2$var$isTextClamped(label)) return true;
        return Boolean(description && $453992fef59345a2$var$isTextClamped(description));
    }, [
        isContentTooltipDisabled
    ]);
    // By default provide the spacing for `elemBefore` to have good
    // vertical alignment of labels and to give clear indentation between levels
    // in the side navigation (even when items don't use elemBefore).
    const showElemBefore = elemBefore !== (0, $4qwFZ.COLLAPSE_ELEM_BEFORE);
    const interactiveElemContent = /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        className: (0, $bwpsq.default)([
            $453992fef59345a2$var$interactiveContentStyles.root
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                // This extends the clickable area of nested menu items to the width
                // of the root level menu items, while being visually indented.
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                style: {
                    insetInlineStart: `calc(-1 * ${level} * ${(0, $64ba54a200a2d4aa$export$d492445a79a49b48)})`
                },
                "aria-hidden": "true",
                className: (0, $bwpsq.default)([
                    $453992fef59345a2$var$extendButtonOrAnchorStyles.root
                ])
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                className: (0, $bwpsq.default)([
                    $453992fef59345a2$var$textStyles.root,
                    !showElemBefore && $453992fef59345a2$var$textStyles.noElemBeforeIndent
                ]),
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                        weight: "medium",
                        maxLines: 1,
                        color: $453992fef59345a2$var$getTextColor({
                            isDisabled: isDisabled,
                            isSelected: isSelected
                        }),
                        ref: labelRef,
                        children: children
                    }),
                    description && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                        color: isDisabled ? 'color.text.disabled' : 'color.text.subtle',
                        size: "small",
                        maxLines: 1,
                        ref: descriptionRef,
                        children: description
                    })
                ]
            }),
            hasDragIndicator ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($453992fef59345a2$var$LazyDragHandle, {})
            }) : null,
            dropIndicator
        ]
    });
    /**
   *  If the [expandable] menu item is expanded, show hover actions even when *not* hovered.
   *
   * Note: we also remove the `elemAfter` when showing `actionsOnHover`
   */ const showHoverActionsWhenNotHovered = Boolean(ariaExpanded && actionsOnHover);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $620nX.AvatarContext).Provider, {
        value: $453992fef59345a2$var$defaultAvatarValues,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            ref: visualContentRef,
            "data-testid": testId ? `${testId}-container` : undefined,
            "data-selected": isSelected,
            className: (0, $bwpsq.default)([
                $453992fef59345a2$var$containerStyles.root,
                isSelected && $453992fef59345a2$var$containerStyles.selected,
                isDragging && $453992fef59345a2$var$containerStyles.dragging,
                description && $453992fef59345a2$var$containerStyles.hasDescription,
                showHoverActionsWhenNotHovered && $453992fef59345a2$var$containerStyles.showHoverActions,
                showHoverActionsWhenNotHovered && elemAfter && $453992fef59345a2$var$containerStyles.removeElemAfter,
                actionsOnHover && elemAfter && $453992fef59345a2$var$containerStyles.removeElemAfterOnHoverOrOpenNestedPopup,
                isDisabled && $453992fef59345a2$var$containerStyles.disabled
            ]),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                    content: ()=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                                    children: children
                                }),
                                description ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                                    children: description
                                }) : null
                            ]
                        }),
                    position: "right",
                    // NOTE: Types in React 18 have changed and `forwardRef(() => <TooltipPrimitive>)` no longer appears to match 100%
                    component: $453992fef59345a2$var$MenuItemTooltip,
                    ignoreTooltipPointerEvents: true,
                    hideTooltipOnMouseDown: true,
                    // We don't need a duplicate hidden element containing tooltip content
                    // as the content of the tooltip matches what is rendered for the menu item.
                    isScreenReaderAnnouncementDisabled: true,
                    canAppear: canTooltipAppear,
                    children: (tooltipProps)=>{
                        // Putting the tooltip onClick into a ref.
                        // This way we don't need to create a new `onClick` function on each
                        // render (as we would need to merge `tooltipProps.onClick` and our `handleClick`)
                        tooltipOnClick.current = tooltipProps.onClick;
                        const sharedProps = {
                            ...tooltipProps,
                            'aria-controls': ariaControls,
                            'aria-haspopup': ariaHasPopup,
                            ref: (0, $5JjdN.default)([
                                forwardedRef,
                                tooltipProps.ref
                            ]),
                            testId: testId,
                            interactionName: interactionName
                        };
                        return isLink ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5McnS.default), {
                            ...sharedProps,
                            onClick: handleClick,
                            xcss: (0, $DEWI6.cx)($453992fef59345a2$var$buttonOrAnchorStyles.root, $453992fef59345a2$var$topLevelSiblingStyles.root, isSelected && $453992fef59345a2$var$buttonOrAnchorStyles.selected, hasDragIndicator && $453992fef59345a2$var$buttonOrAnchorStyles.hasDragIndicator),
                            // Needed to override Anchor style due to a compiled/emotion conflict
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                            style: {
                                textDecoration: 'none'
                            },
                            "aria-current": isSelected ? 'page' : undefined,
                            href: href,
                            target: target,
                            /**
           * For anchors we don't want to have the standard drag and drop behaviour.
           *
           * Thinking on the topic:
           *
           * - Anchors look visually similar to buttons in the sidenav
           * - Why should some menu items be natively draggable, while others are not?
           * - A user cannot know which menu items are "natively" draggable (ie anchors)
           * - If you wire up an anchor to be draggable using our standard affordances
           *   it will have a different preview experience to native anchor dragging.
           *
           * To promote consistency, all elements need to use the same visual affordances.
           *
           * Anchor elements will automatically attach URL information
           * to the native data store.
           *
           * When `hasDragIndicator` is `true` we are expecting consumers to register
           * the element as draggable through the `draggable()` Pragmatic drag and drop function.
           * The `draggable()` function will add `draggable="true"` to the element.
           */ draggable: hasDragIndicator ? undefined : false,
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                                    "aria-hidden": "true",
                                    className: (0, $bwpsq.default)([
                                        $453992fef59345a2$var$notchStyles.root
                                    ])
                                }),
                                interactiveElemContent
                            ]
                        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
                            ...sharedProps,
                            onClick: handleClick,
                            xcss: (0, $DEWI6.cx)($453992fef59345a2$var$buttonOrAnchorStyles.root, $453992fef59345a2$var$topLevelSiblingStyles.root, isSelected && $453992fef59345a2$var$buttonOrAnchorStyles.selected, hasDragIndicator && $453992fef59345a2$var$buttonOrAnchorStyles.hasDragIndicator),
                            "aria-expanded": ariaExpanded,
                            isDisabled: isDisabled,
                            children: interactiveElemContent
                        });
                    }
                }),
                showElemBefore && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $453992fef59345a2$var$elemBeforeStyles.root,
                        $453992fef59345a2$var$topLevelSiblingStyles.root,
                        $453992fef59345a2$var$onTopOfButtonOrAnchorStyles.root
                    ]),
                    children: elemBefore
                }),
                actionsOnHover && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $453992fef59345a2$var$actionsOnHoverStyles.root
                    ]),
                    children: actionsOnHover
                }),
                elemAfter && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $453992fef59345a2$var$elemAfterStyles.root,
                        $453992fef59345a2$var$topLevelSiblingStyles.root,
                        $453992fef59345a2$var$onTopOfButtonOrAnchorStyles.root
                    ]),
                    children: elemAfter
                }),
                actions && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $453992fef59345a2$var$actionStyles.root,
                        $453992fef59345a2$var$topLevelSiblingStyles.root,
                        $453992fef59345a2$var$onTopOfButtonOrAnchorStyles.root
                    ]),
                    children: actions
                })
            ]
        })
    });
};
const $453992fef59345a2$export$859b390bf71e044e = (0, $ivhXk.forwardRefWithGeneric)($453992fef59345a2$var$MenuItemBaseNoRef);

});
/**
 * _Internally_ shared value for the menu item indentation. Used in:
 * - Expandable menu item content, to add padding for each expandable level
 * - The base menu item, to set the negative inset to extend the clickable area of nested menu items
 * to the root level menu items.
 *
 * Internal to the package only. Should not be exported from the package.
 *
 * Note: We're unable to use a token() call here, as Compiled complains about function calls in imported
 * values - it requires statically defined values only.
 *
 * @private
 * @internal
 */ const $64ba54a200a2d4aa$export$d492445a79a49b48 = '12px';

parcelRegister("et13M", function(module, exports) {

$parcel$export(module.exports, "AreAllAncestorsExpandedContext", () => $a721eaa4679cbd17$export$9c01e0e6a504d553);
$parcel$export(module.exports, "IsExpandedContext", () => $a721eaa4679cbd17$export$c856e5885cc34d81);
$parcel$export(module.exports, "SetIsExpandedContext", () => $a721eaa4679cbd17$export$48cb11cb8691f597);
$parcel$export(module.exports, "OnExpansionToggleContext", () => $a721eaa4679cbd17$export$572ce188c913ceba);
$parcel$export(module.exports, "LevelContext", () => $a721eaa4679cbd17$export$650d12d3c2ddb8fc);
$parcel$export(module.exports, "useIsExpanded", () => $a721eaa4679cbd17$export$37e565a09598825e);
$parcel$export(module.exports, "useSetIsExpanded", () => $a721eaa4679cbd17$export$c9a171ea8de5861b);
$parcel$export(module.exports, "useOnExpansionToggle", () => $a721eaa4679cbd17$export$56c8438498b72c7a);
$parcel$export(module.exports, "useLevel", () => $a721eaa4679cbd17$export$fdfe9e5e8183d4f2);
$parcel$export(module.exports, "useAreAllAncestorsExpanded", () => $a721eaa4679cbd17$export$57108b5f08ae5194);

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");

var $fknot = parcelRequire("fknot");
const $a721eaa4679cbd17$export$9c01e0e6a504d553 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $a721eaa4679cbd17$export$c856e5885cc34d81 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $a721eaa4679cbd17$export$48cb11cb8691f597 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $a721eaa4679cbd17$export$572ce188c913ceba = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $a721eaa4679cbd17$export$650d12d3c2ddb8fc = (0, $fknot.ExpandableMenuItemLevelContext);
const $a721eaa4679cbd17$export$37e565a09598825e = ()=>{
    const context = (0, $5uXOq.useContext)($a721eaa4679cbd17$export$c856e5885cc34d81);
    (0, $3joPi.default)(context !== null, 'useIsExpanded must be used within an ExpandableMenuItem');
    return context;
};
const $a721eaa4679cbd17$export$c9a171ea8de5861b = ()=>{
    const context = (0, $5uXOq.useContext)($a721eaa4679cbd17$export$48cb11cb8691f597);
    (0, $3joPi.default)(context !== null, 'useSetIsExpanded must be used within an ExpandableMenuItem');
    return context;
};
const $a721eaa4679cbd17$export$56c8438498b72c7a = ()=>(0, $5uXOq.useContext)($a721eaa4679cbd17$export$572ce188c913ceba);
const $a721eaa4679cbd17$export$fdfe9e5e8183d4f2 = ()=>(0, $5uXOq.useContext)($a721eaa4679cbd17$export$650d12d3c2ddb8fc);
const $a721eaa4679cbd17$export$57108b5f08ae5194 = ()=>(0, $5uXOq.useContext)($a721eaa4679cbd17$export$9c01e0e6a504d553) ?? true;

});
parcelRegister("fknot", function(module, exports) {

$parcel$export(module.exports, "ExpandableMenuItemLevelContext", () => $04e0b0327ebe6690$export$f8d6463f9b5ca897);

var $5uXOq = parcelRequire("5uXOq");
const $04e0b0327ebe6690$export$f8d6463f9b5ca897 = /*#__PURE__*/ (0, $5uXOq.createContext)(0);

});


parcelRegister("aV1jL", function(module, exports) {

$parcel$export(module.exports, "IsOpenContext", () => $f9ed7d1271d6aaec$export$efa4d9670e96ac31);
$parcel$export(module.exports, "SetIsOpenContext", () => $f9ed7d1271d6aaec$export$4c55b1c61a116b42);
$parcel$export(module.exports, "useFlyoutMenuOpen", () => $f9ed7d1271d6aaec$export$6927118f874a49aa);
$parcel$export(module.exports, "useSetFlyoutMenuOpen", () => $f9ed7d1271d6aaec$export$538ac1aa421adb94);

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");
const $f9ed7d1271d6aaec$export$efa4d9670e96ac31 = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
const $f9ed7d1271d6aaec$export$4c55b1c61a116b42 = /*#__PURE__*/ (0, $5uXOq.createContext)((0, $eGmKJ.default));
const $f9ed7d1271d6aaec$export$6927118f874a49aa = ()=>(0, $5uXOq.useContext)($f9ed7d1271d6aaec$export$efa4d9670e96ac31);
const $f9ed7d1271d6aaec$export$538ac1aa421adb94 = ()=>(0, $5uXOq.useContext)($f9ed7d1271d6aaec$export$4c55b1c61a116b42);

});

parcelRegister("4qwFZ", function(module, exports) {

$parcel$export(module.exports, "COLLAPSE_ELEM_BEFORE", () => $f540ea5c01f27028$export$f4b8e24fae579c6f);
/**
 * A symbol to collapse the `elemBefore` slot.
 * This should be placed in the `elemBefore` prop of supported menu items.
 */ const $f540ea5c01f27028$export$f4b8e24fae579c6f = Symbol('collapse-elem-before');

});

parcelRegister("ckLZt", function(module, exports) {

let $8fac9434f8bf2033$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8fac9434f8bf2033$var$load("l6pXO").then(()=>parcelRequire('jqmSK'));

});


parcelRegister("cs9Q6", function(module, exports) {

$parcel$export(module.exports, "useScrollMenuItemIntoView", () => $7d0fedb322aa4679$export$2c52ec851fcc6058);

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");

var $et13M = parcelRequire("et13M");
function $7d0fedb322aa4679$var$scrollMenuItemIntoView(element) {
    /**
	 * If [scrollIntoViewIfNeeded](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoViewIfNeeded) is available,
	 * we are using it to scroll the element into view _in the center_ of the scroll container. Because it is a non-standard method
	 * and not available on all browsers (currently not supported in Firefox), we are using it for progressive enhancement.
	 *
	 * Otherwise, we are falling back to [scrollIntoView](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView).
	 */ if (typeof element.scrollIntoViewIfNeeded === 'function') {
        element.scrollIntoViewIfNeeded(true);
        return;
    }
    // JSDOM does not support scrollIntoView, so defensively using it (see https://github.com/jsdom/jsdom/issues/1695)
    element.scrollIntoView?.({
        // We are using `nearest` to prevent scrolling on user interaction when the menu item is already in view.
        block: 'nearest'
    });
}
function $7d0fedb322aa4679$export$2c52ec851fcc6058({ elementRef: elementRef, isSelected: isSelected }) {
    const areAllAncestorsExpanded = (0, $et13M.useAreAllAncestorsExpanded)();
    const waitingStateRef = (0, $5uXOq.useRef)({
        type: 'waiting-to-be-selected-and-all-ancestors-expanded'
    });
    (0, $5uXOq.useEffect)(()=>{
        if (waitingStateRef.current.type === 'waiting-to-be-selected-and-all-ancestors-expanded') {
            const shouldScroll = areAllAncestorsExpanded && isSelected;
            if (!shouldScroll) return;
            const element = elementRef.current;
            (0, $3joPi.default)(element, 'Element ref must be set');
            $7d0fedb322aa4679$var$scrollMenuItemIntoView(element);
            // Now that we are scrolled the menu item into view, we need to wait for the menu item to
            // be unselected before checking again.
            waitingStateRef.current.type = 'waiting-to-be-unselected';
            return;
        }
        if (waitingStateRef.current.type === 'waiting-to-be-unselected') {
            if (!isSelected) waitingStateRef.current.type = 'waiting-to-be-selected-and-all-ancestors-expanded';
            return;
        }
    }, [
        areAllAncestorsExpanded,
        elementRef,
        isSelected
    ]);
}

});


parcelRegister("gSZmd", function(module, exports) {

$parcel$export(module.exports, "MenuList", () => $dfe52a3a6f12c8c9$export$d4c4e98c5044dc8);

var $hEtBs = parcelRequire("hEtBs");
const $dfe52a3a6f12c8c9$export$d4c4e98c5044dc8 = (0, $hEtBs.List);

});

parcelRegister("7GXsr", function(module, exports) {

$parcel$export(module.exports, "default", () => $485ad0479413a47e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hYRTO = parcelRequire("hYRTO");

var $7CMCs = parcelRequire("7CMCs");

var $kxZPA = parcelRequire("kxZPA");

var $lfTZh = parcelRequire("lfTZh");

var $4R6GH = parcelRequire("4R6GH");

const $485ad0479413a47e$var$LazyAtlassianOnboardingNav4 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("35KYt")).then(({ Nav4Onboarding: Nav4Onboarding })=>Nav4Onboarding), {
    moduleId: "./src/packages/navigation-apps/onboarding-nav4/src/index.tsx"
});
const $485ad0479413a47e$var$AsyncAtlassianOnboardingNav4 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    if ((0, $4R6GH.fg)('jfp-magma-fix-misaligned-suspense-boundaries')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "asyncAtlassianOnboardingNav4",
        packageName: "jiraAtlassianOnboardingNav4",
        teamName: "jira-cosmos",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "lazyAtlassianOnboardingNav4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($485ad0479413a47e$var$LazyAtlassianOnboardingNav4, null)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "asyncAtlassianOnboardingNav4",
        packageName: "jiraAtlassianOnboardingNav4",
        teamName: "jira-cosmos",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hYRTO.default), {
        name: "lazyAtlassianOnboardingNav4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($485ad0479413a47e$var$LazyAtlassianOnboardingNav4, null)));
});
$485ad0479413a47e$var$AsyncAtlassianOnboardingNav4.displayName = 'AsyncAtlassianOnboardingNav4';
var $485ad0479413a47e$export$2e2bcd8739ae039 = $485ad0479413a47e$var$AsyncAtlassianOnboardingNav4;

});
parcelRegister("35KYt", function(module, exports) {

let $240646d9eb3070c7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $240646d9eb3070c7$var$load("8174o").then(()=>parcelRequire('1UJgx'));

});


parcelRegister("46Cti", function(module, exports) {

$parcel$export(module.exports, "L1_MENU_ID", () => $2d5b83df0b5ff159$export$918aea3cf024d90b);

var $jhS4y = parcelRequire("jhS4y");
const $2d5b83df0b5ff159$var$OPERATIONS_MENU_ID = {
    OPERATIONS_ALERT_SAVED_SEARCH_SHARED_WITH_ME: 'jira.sidebar.operations.alert.savedSearches.sharedWithMe',
    OPERATIONS_ALERT_SAVED_SEARCH_CREATED_BY_ME: 'jira.sidebar.operations.alert.savedSearches.createdByMe'
};
const $2d5b83df0b5ff159$export$bb47524d7f3cb1f8 = {
    ...(0, $jhS4y.CONFIGURABLE_MENU_ID),
    BOARDS: 'jira.sidebar.boards',
    QUEUES: 'jira.sidebar.queues',
    ALL: 'jira.sidebar.all'
};
const $2d5b83df0b5ff159$export$918aea3cf024d90b = {
    YOUR_WORK: 'jira.sidebar.yourWork',
    ...(0, $jhS4y.CONFIGURABLE_MENU_ID),
    ...$2d5b83df0b5ff159$var$OPERATIONS_MENU_ID
};

});

parcelRegister("cKjfv", function(module, exports) {

$parcel$export(module.exports, "useSidebarExperience", () => $c4243e40cbbf3b86$export$d4fa533dfe4d7583);
$parcel$export(module.exports, "SidebarStart", () => $c4243e40cbbf3b86$export$6738d1299dc79710);
$parcel$export(module.exports, "SidebarReady", () => $c4243e40cbbf3b86$export$a06ecbbe5820282);

var $5uXOq = parcelRequire("5uXOq");

var $99gkn = parcelRequire("99gkn");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $6jY6G = parcelRequire("6jY6G");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $6IzHB = parcelRequire("6IzHB");

var $92h6i = parcelRequire("92h6i");
const $c4243e40cbbf3b86$export$d4fa533dfe4d7583 = ()=>{
    const pageId = (0, $6IzHB.usePageId)();
    return (0, $5uXOq.useMemo)(()=>({
            experience: 'viewSidebarNavigation',
            experienceId: pageId,
            analyticsSource: 'Sidebar',
            attributes: {
                sidebar: 'v4'
            }
        }), [
        pageId
    ]);
};
const $c4243e40cbbf3b86$export$6738d1299dc79710 = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const { experience: experience, experienceId: experienceId, analyticsSource: analyticsSource } = $c4243e40cbbf3b86$export$d4fa533dfe4d7583();
    const onStartExperience = (0, $kaHBi.useExperienceStart)({
        experience: experience,
        experienceId: experienceId,
        analyticsSource: analyticsSource
    });
    (0, $5uXOq.useEffect)(()=>{
        if (route.isRedirect) return;
        onStartExperience();
    }, [
        onStartExperience,
        route
    ]);
    return null;
};
const $c4243e40cbbf3b86$export$a06ecbbe5820282 = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const { experience: experience, attributes: attributes } = $c4243e40cbbf3b86$export$d4fa533dfe4d7583();
    const onSuccessfulExperience = (0, $3bQtK.useExperienceSuccess)({
        experience: experience,
        attributes: attributes
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const routeName = route.name ?? route.group ?? 'UNKNOWN';
    const doNotRunEffects = route.isRedirect || false;
    const sidebarId = route.navigation?.sidebarId ?? 'default';
    (0, $92h6i.useEffectWithoutConcurrency)(()=>{
        if (doNotRunEffects) return;
        const event = createAnalyticsEvent({
            action: 'ready',
            actionSubject: 'sidebar',
            meta: {
                teamName: 'endeavour'
            }
        });
        (0, $8zOmE.fireUIAnalytics)(event, 'Sidebar Ready', {
            route: routeName
        });
    }, [
        createAnalyticsEvent,
        doNotRunEffects,
        routeName
    ]);
    (0, $92h6i.useEffectWithoutConcurrency)(()=>{
        if (doNotRunEffects) return;
        onSuccessfulExperience();
    }, [
        doNotRunEffects,
        onSuccessfulExperience,
        route
    ]);
    const customData = (0, $5uXOq.useMemo)(()=>({
            sidebarType: sidebarId
        }), [
        sidebarId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99gkn.default), {
        data: customData
    });
};

});
parcelRegister("99gkn", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a18f2c0b045372b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "addUFOCustomData", () => $7a18f2c0b045372b$export$d12f56a472cdbe6c);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $7a18f2c0b045372b$export$2e2bcd8739ae039({ data: data }) {
    const interactionContext = (0, $5uXOq.useContext)((0, $1tcYS.default));
    (0, $5uXOq.useMemo)(()=>{
        if (!interactionContext) return;
        if (typeof globalThis?.structuredClone === 'function') interactionContext.addCustomData(globalThis.structuredClone(data));
        else interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}
function $7a18f2c0b045372b$export$d12f56a472cdbe6c(data) {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    if (typeof globalThis?.structuredClone === 'function') (0, $bFU4G.addCustomData)(currentInteractionId, [], globalThis.structuredClone(data));
    else (0, $bFU4G.addCustomData)(currentInteractionId, [], data);
}

});

parcelRegister("92h6i", function(module, exports) {

$parcel$export(module.exports, "useEffectWithoutConcurrency", () => $f224f3606a6cd92d$export$e44126cd87ea434);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $3joPi = parcelRequire("3joPi");
function $f224f3606a6cd92d$export$e44126cd87ea434(effect, dependencies) {
    const effectCalledRef = (0, $5uXOq.useRef)(false);
    const depsRef = (0, $5uXOq.useRef)(dependencies);
    (0, $5uXOq.useEffect)(()=>{
        // If the dependencies have changed, reset the state of the ref.
        // This is how we catch the strict-mode execution.
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(depsRef.current, dependencies)) {
            depsRef.current = dependencies;
            effectCalledRef.current = false;
        }
        // If the effect has already executed, we shouldn't be executing again unless we do a cleanup first.
        // This is the code that ignores the strict-mode update
        if (effectCalledRef.current) return;
        // Set this immediately
        effectCalledRef.current = true;
        const cleanup = effect();
        // If we do get a cleanup function, throw an error
        (0, $3joPi.default)(typeof cleanup !== 'function', 'useEffectWithoutConcurrency() cannot be used with cleanup functions');
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
}

});


parcelRegister("dUyqZ", function(module, exports) {

$parcel$export(module.exports, "useConfigurableMessageAndIconMap", () => $5654470bb2a53aff$export$783a136280b37c09);

var $4DrQd = parcelRequire("4DrQd");

var $24a2m = parcelRequire("24a2m");
const $5654470bb2a53aff$export$783a136280b37c09 = (menuId)=>{
    const { message: message, Icon: Icon } = (0, $4DrQd.CONFIGURABLE_MESSAGE_AND_ICON_MAP)[menuId];
    return (0, $24a2m.useFormattedMessageAndIcon)(message, Icon);
};

});
parcelRegister("4DrQd", function(module, exports) {

$parcel$export(module.exports, "MENU_GROUP_MIN_WIDTH", () => $e2413e530566d4f6$export$47f3715a07cde7e8);
$parcel$export(module.exports, "CONFIGURABLE_MENU_IDS_AS_STRINGS", () => $e2413e530566d4f6$export$f5a7bd7eb586e4e8);
$parcel$export(module.exports, "GLOBAL_APP_MENU_IDS_AS_STRINGS", () => $e2413e530566d4f6$export$de634ec0f98ab74b);
$parcel$export(module.exports, "CONFIGURABLE_MESSAGE_AND_ICON_MAP", () => $e2413e530566d4f6$export$6a976dc7193b8a18);
$parcel$export(module.exports, "FOR_YOU_MESSAGE_AND_ICON_MAP", () => $e2413e530566d4f6$export$5034ad0032cd499d);
$parcel$export(module.exports, "FOR_YOU_MESSAGE_STRING", () => $e2413e530566d4f6$export$b66ae8c18ec95bc6);
$parcel$export(module.exports, "CONFIGURABLE_MESSAGE_STRING", () => $e2413e530566d4f6$export$da92a6698d96e3f2);
$parcel$export(module.exports, "LEFT_SIDEBAR_EXPANDED_MIN_WIDTH", () => $e2413e530566d4f6$export$9fcc53f3b36e0949);
$parcel$export(module.exports, "IS_LEFT_SIDEBAR_COLLAPSED_DEFAULT", () => $e2413e530566d4f6$export$2eb8dda9e83d33ff);
$parcel$export(module.exports, "NAV4_OPT_OUT_FEEDBACK_GROUP_ID", () => $e2413e530566d4f6$export$9cf873ba2e9a3ce0);
$parcel$export(module.exports, "NAV4_GENERAL_FEEDBACK_GROUP_ID", () => $e2413e530566d4f6$export$a495ba70b16d4d90);
$parcel$export(module.exports, "NO_OF_BOARDS_TO_SHOW", () => $e2413e530566d4f6$export$89de709e88232646);

var $5Trwl = parcelRequire("5Trwl");

var $1ZDWg = parcelRequire("1ZDWg");

var $ls0mX = parcelRequire("ls0mX");

var $hyKRO = parcelRequire("hyKRO");

var $gsyzJ = parcelRequire("gsyzJ");

var $jX361 = parcelRequire("jX361");

var $9x5pH = parcelRequire("9x5pH");

var $4iV1e = parcelRequire("4iV1e");

var $ecqyi = parcelRequire("ecqyi");

var $kjHmv = parcelRequire("kjHmv");

var $1U4EY = parcelRequire("1U4EY");

var $9bk6s = parcelRequire("9bk6s");

var $by9zw = parcelRequire("by9zw");

var $hT1xk = parcelRequire("hT1xk");

var $lV2o9 = parcelRequire("lV2o9");

var $dXQDI = parcelRequire("dXQDI");

var $ifnb0 = parcelRequire("ifnb0");

var $dAf5R = parcelRequire("dAf5R");

var $c781K = parcelRequire("c781K");

var $bdVbi = parcelRequire("bdVbi");

var $bfgl4 = parcelRequire("bfgl4");

var $8bDjo = parcelRequire("8bDjo");

var $7EZ5v = parcelRequire("7EZ5v");

var $empdx = parcelRequire("empdx");

var $jhS4y = parcelRequire("jhS4y");

var $6x874 = parcelRequire("6x874");

var $ih7ba = parcelRequire("ih7ba");

var $46Cti = parcelRequire("46Cti");
const $e2413e530566d4f6$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Common';
const $e2413e530566d4f6$export$d57b6b390e78d90f = 'jira-cosmos';
const $e2413e530566d4f6$export$47f3715a07cde7e8 = 250;
const $e2413e530566d4f6$export$421b92818c76ee2d = Object.values((0, $jhS4y.CONFIGURABLE_MENU_ID));
const $e2413e530566d4f6$export$f5a7bd7eb586e4e8 = $e2413e530566d4f6$export$421b92818c76ee2d;
const $e2413e530566d4f6$export$c52c93cc28495ab0 = Object.values((0, $jhS4y.GLOBAL_APP_MENU_ID));
const $e2413e530566d4f6$export$de634ec0f98ab74b = $e2413e530566d4f6$export$c52c93cc28495ab0;
const $e2413e530566d4f6$export$6a976dc7193b8a18 = {
    [(0, $46Cti.L1_MENU_ID).APPS]: {
        message: (0, $ih7ba.default).apps,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($1ZDWg)))
    },
    [(0, $46Cti.L1_MENU_ID).GOALS]: {
        message: (0, $ih7ba.default).goals,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($4iV1e)))
    },
    [(0, $46Cti.L1_MENU_ID).ROADMAPS]: {
        message: (0, $ih7ba.default).roadmaps,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($5Trwl)))
    },
    [(0, $46Cti.L1_MENU_ID).PLANS]: {
        message: (0, $ih7ba.default).plans,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($ifnb0)))
    },
    [(0, $46Cti.L1_MENU_ID).PROJECTS]: {
        message: (0, $ih7ba.default).projects,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dXQDI)))
    },
    [(0, $46Cti.L1_MENU_ID).FILTERS]: {
        message: (0, $ih7ba.default).filters,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($jX361)))
    },
    [(0, $46Cti.L1_MENU_ID).DASHBOARDS]: {
        message: (0, $ih7ba.default).dashboards,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($gsyzJ)))
    },
    [(0, $46Cti.L1_MENU_ID).COMMUNICATION]: {
        message: (0, $ih7ba.default).communication,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($empdx)))
    },
    [(0, $46Cti.L1_MENU_ID).OVERVIEWS]: {
        message: (0, $ih7ba.default).overviews,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($9x5pH)))
    },
    [(0, $46Cti.L1_MENU_ID).OPERATIONS]: {
        message: (0, $ih7ba.default).operations,
        Icon: (0, $6x874.default)
    },
    [(0, $46Cti.L1_MENU_ID).ASSETS]: {
        message: (0, $ih7ba.default).assets,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($ls0mX)))
    },
    [(0, $46Cti.L1_MENU_ID).TEAMS]: {
        message: (0, $ih7ba.default).teams,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($c781K)))
    },
    [(0, $46Cti.L1_MENU_ID).RECENT]: {
        message: (0, $ih7ba.default).recent,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($hyKRO)))
    },
    [(0, $46Cti.L1_MENU_ID).STARRED]: {
        message: (0, $ih7ba.default).starred,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dAf5R)))
    },
    [(0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE]: {
        message: (0, $ih7ba.default).customerService,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($ecqyi)))
    },
    [(0, $46Cti.L1_MENU_ID).CUSTOMER_HUBS]: {
        message: (0, $ih7ba.default).customerHubs,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($kjHmv)))
    },
    [(0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: {
        message: (0, $ih7ba.default).customerServiceAnalytics,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EZ5v)))
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_ASSETS]: {
        message: (0, $ih7ba.default).assets,
        Icon: (0, $bfgl4.AssetsIcon)
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_GOALS]: {
        message: (0, $ih7ba.default).goals,
        Icon: (0, $8bDjo.GoalsIcon)
    },
    // App Shortcuts for Platform Component
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: {
        message: (0, $ih7ba.default).confluence,
        Icon: (0, $1U4EY.ConfluenceIcon)
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_LOOM]: {
        message: (0, $ih7ba.default).loom,
        Icon: (0, $9bk6s.LoomIcon)
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_PROJECTS]: {
        message: (0, $ih7ba.default).projects,
        Icon: (0, $hT1xk.ProjectsIcon)
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_TEAMS]: {
        message: (0, $ih7ba.default).teams,
        Icon: (0, $by9zw.TeamsIcon)
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: {
        message: (0, $ih7ba.default).opsgenie,
        Icon: (0, $lV2o9.OpsgenieIcon)
    }
};
const $e2413e530566d4f6$export$5034ad0032cd499d = {
    message: (0, $ih7ba.default).forYou,
    Icon: (0, (/*@__PURE__*/$parcel$interopDefault($bdVbi)))
};
const $e2413e530566d4f6$export$b66ae8c18ec95bc6 = {
    message: (0, $ih7ba.default).forYou.defaultMessage
};
const $e2413e530566d4f6$export$da92a6698d96e3f2 = {
    [(0, $46Cti.L1_MENU_ID).APPS]: {
        message: (0, $ih7ba.default).apps.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).GOALS]: {
        message: (0, $ih7ba.default).goals.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).ROADMAPS]: {
        message: (0, $ih7ba.default).roadmaps.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).PLANS]: {
        message: (0, $ih7ba.default).plans.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).PROJECTS]: {
        message: (0, $ih7ba.default).projects.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).FILTERS]: {
        message: (0, $ih7ba.default).filters.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).DASHBOARDS]: {
        message: (0, $ih7ba.default).dashboards.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).OVERVIEWS]: {
        message: (0, $ih7ba.default).overviews.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).COMMUNICATION]: {
        message: (0, $ih7ba.default).communication.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).OPERATIONS]: {
        message: (0, $ih7ba.default).operations.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).ASSETS]: {
        message: (0, $ih7ba.default).assets.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).TEAMS]: {
        message: (0, $ih7ba.default).teams.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).RECENT]: {
        message: (0, $ih7ba.default).recent.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).STARRED]: {
        message: (0, $ih7ba.default).starred.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE]: {
        message: (0, $ih7ba.default).customerService.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).CUSTOMER_HUBS]: {
        message: (0, $ih7ba.default).customerHubs.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: {
        message: (0, $ih7ba.default).customerServiceAnalytics.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_ASSETS]: {
        message: (0, $ih7ba.default).assets.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_GOALS]: {
        message: (0, $ih7ba.default).goals.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: {
        message: (0, $ih7ba.default).confluence.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_LOOM]: {
        message: (0, $ih7ba.default).loom.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_PROJECTS]: {
        message: (0, $ih7ba.default).projects.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_TEAMS]: {
        message: (0, $ih7ba.default).teams.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: {
        message: (0, $ih7ba.default).opsgenie.defaultMessage
    }
};
const $e2413e530566d4f6$export$9fcc53f3b36e0949 = 240; // in pixels
const $e2413e530566d4f6$export$6621cd553335536a = 320; // in pixels
const $e2413e530566d4f6$export$2eb8dda9e83d33ff = false;
const $e2413e530566d4f6$export$b4b2658405615c86 = 'TEAM_MANAGED_PROJECT';
const $e2413e530566d4f6$export$2336313834642df = 'COMPANY_MANAGED_PROJECT';
const $e2413e530566d4f6$export$9cf873ba2e9a3ce0 = 'nav4-opt-out';
const $e2413e530566d4f6$export$a495ba70b16d4d90 = 'nav4-sidebar';
const $e2413e530566d4f6$export$89de709e88232646 = 25;

});
parcelRegister("6x874", function(module, exports) {

$parcel$export(module.exports, "default", () => $079d8146cc6d581f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fJMTr = parcelRequire("fJMTr");

var $llvRa = parcelRequire("llvRa");

var $4R6GH = parcelRequire("4R6GH");
const $079d8146cc6d581f$var$OperationsIcon = ({ ...props })=>{
    if ((0, $4R6GH.fg)('nav4_operations_icon_update')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fJMTr))), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($llvRa))), props);
};
var $079d8146cc6d581f$export$2e2bcd8739ae039 = $079d8146cc6d581f$var$OperationsIcon;

});

parcelRegister("ih7ba", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c16ecaa1449e546$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7c16ecaa1449e546$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    projects: {
        "id": "navigation-apps-sidebar-nav4-common.common.projects",
        "defaultMessage": "Projects"
    },
    filters: {
        "id": "navigation-apps-sidebar-nav4-common.common.filters",
        "defaultMessage": "Filters"
    },
    dashboards: {
        "id": "navigation-apps-sidebar-nav4-common.common.dashboards",
        "defaultMessage": "Dashboards"
    },
    overviews: {
        "id": "navigation-apps-sidebar-nav4-common.common.overviews",
        "defaultMessage": "Overviews"
    },
    teams: {
        "id": "navigation-apps-sidebar-nav4-common.common.teams",
        "defaultMessage": "Teams"
    },
    assets: {
        "id": "navigation-apps-sidebar-nav4-common.common.assets",
        "defaultMessage": "Assets"
    },
    plans: {
        "id": "navigation-apps-sidebar-nav4-common.common.plans",
        "defaultMessage": "Plans"
    },
    apps: {
        "id": "navigation-apps-sidebar-nav4-common.common.apps",
        "defaultMessage": "Apps"
    },
    operations: {
        "id": "navigation-apps-sidebar-nav4-common.common.operations",
        "defaultMessage": "Operations"
    },
    goals: {
        "id": "navigation-apps-sidebar-nav4-common.common.goals",
        "defaultMessage": "Goals"
    },
    recent: {
        "id": "navigation-apps-sidebar-nav4-common.common.recent",
        "defaultMessage": "Recent"
    },
    starred: {
        "id": "navigation-apps-sidebar-nav4-common.common.starred",
        "defaultMessage": "Starred"
    },
    roadmaps: {
        "id": "navigation-apps-sidebar-nav4-common.common.roadmaps",
        "defaultMessage": "Roadmaps"
    },
    customerService: {
        "id": "navigation-apps-sidebar-nav4-common.common.customer-service",
        "defaultMessage": "Customer service"
    },
    customerHubs: {
        "id": "navigation-apps-sidebar-nav4-common.common.customer-hubs",
        "defaultMessage": "Customer hubs"
    },
    customerServiceAnalytics: {
        "id": "navigation-apps-sidebar-nav4-common.common.customerServiceAnalytics",
        "defaultMessage": "Insights"
    },
    forYou: {
        "id": "navigation-apps-sidebar-nav4-common.common.forYou",
        "defaultMessage": "For you"
    },
    confluence: {
        "id": "navigation-apps-sidebar-nav4-common.common.confluence",
        "defaultMessage": "Confluence"
    },
    loom: {
        "id": "navigation-apps-sidebar-nav4-common.common.loom",
        "defaultMessage": "Loom"
    },
    opsgenie: {
        "id": "navigation-apps-sidebar-nav4-common.common.opsgenie",
        "defaultMessage": "Opsgenie"
    },
    communication: {
        "id": "navigation-apps-sidebar-nav4-common.common.communication",
        "defaultMessage": "Communications"
    }
});

});


parcelRegister("24a2m", function(module, exports) {

$parcel$export(module.exports, "useFormattedMessageAndIcon", () => $a546a39b12f7f59a$export$efa1c7d3cd2d4f5c);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");
const $a546a39b12f7f59a$export$efa1c7d3cd2d4f5c = (message, Icon)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const formattedMessage = formatMessage(message);
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
        label: formattedMessage,
        spacing: "spacious",
        color: "currentColor"
    });
    return {
        formattedMessage: formattedMessage,
        icon: icon
    };
};

});


parcelRegister("cZpsT", function(module, exports) {

$parcel$export(module.exports, "useIsAnonymous", () => $5ea99a868eaaf0f7$export$bf7b5d502f6d6d3b);

var $9OXo1 = parcelRequire("9OXo1");
const $5ea99a868eaaf0f7$export$bf7b5d502f6d6d3b = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.isAnonymous;
};

});

parcelRegister("1zjdl", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $5d2bb3999d13b3c1$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $5d2bb3999d13b3c1$export$d57b6b390e78d90f);
$parcel$export(module.exports, "USER_NAVIGATION_ITEM_LINKS", () => $5d2bb3999d13b3c1$export$d34001b14a9e6d48);
$parcel$export(module.exports, "USER_NAVIGATION_CONFIGURATION_DEFAULT", () => $5d2bb3999d13b3c1$export$6f21b70acbf71216);
$parcel$export(module.exports, "USER_NAVIGATION_CONFIGURATION_DEFAULT_MENU_IDS", () => $5d2bb3999d13b3c1$export$c2614ebabc74446e);

var $46Cti = parcelRequire("46Cti");

var $dDmlh = parcelRequire("dDmlh");
const $5d2bb3999d13b3c1$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4SidebarContent';
const $5d2bb3999d13b3c1$export$d57b6b390e78d90f = 'jira-cosmos';
const $5d2bb3999d13b3c1$export$d34001b14a9e6d48 = {
    [(0, $46Cti.L1_MENU_ID).APPS]: '/jira/marketplace/discover?source=apps-menu',
    [(0, $46Cti.L1_MENU_ID).GOALS]: '/jira/your-work?goals',
    [(0, $46Cti.L1_MENU_ID).DASHBOARDS]: (0, $dDmlh.dashboardsDirectoryRoute).path,
    [(0, $46Cti.L1_MENU_ID).TEAMS]: '/jira/people/search',
    [(0, $46Cti.L1_MENU_ID).ROADMAPS]: '/jira/polaris/roadmaps',
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_ASSETS]: '/jira/assets',
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_GOALS]: 'https://home.atlassian.com/goals'
};
const $5d2bb3999d13b3c1$export$6f21b70acbf71216 = {
    navKey: 'JIRA_SIDEBAR',
    navItems: [
        {
            menuId: (0, $46Cti.L1_MENU_ID).RECENT,
            isVisible: true
        },
        {
            menuId: (0, $46Cti.L1_MENU_ID).STARRED,
            isVisible: true
        },
        {
            menuId: (0, $46Cti.L1_MENU_ID).APPS,
            isVisible: true
        },
        // See https://jplat.jira.atlassian.cloud/browse/BLU-3307
        // For the Dogfooding phase of Nav4 we are going to intentionally hide the Goals menu item.
        // Keeping code in comments so it can be easily reintroduced during EAP
        // {
        // 	menuId: L1_MENU_ID.GOALS,
        // 	isVisible: true,
        // },
        {
            menuId: (0, $46Cti.L1_MENU_ID).ROADMAPS,
            isVisible: true
        },
        {
            menuId: (0, $46Cti.L1_MENU_ID).OVERVIEWS,
            isVisible: true
        },
        {
            menuId: (0, $46Cti.L1_MENU_ID).PLANS,
            isVisible: true
        },
        {
            menuId: (0, $46Cti.L1_MENU_ID).PROJECTS,
            isVisible: true
        },
        {
            menuId: (0, $46Cti.L1_MENU_ID).FILTERS,
            isVisible: true
        },
        {
            menuId: (0, $46Cti.L1_MENU_ID).DASHBOARDS,
            isVisible: true
        },
        {
            menuId: (0, $46Cti.L1_MENU_ID).OPERATIONS,
            isVisible: true
        },
        {
            menuId: (0, $46Cti.L1_MENU_ID).COMMUNICATION,
            isVisible: true
        },
        {
            /* remove this on
			 * blu-6313_sidebar_global_app_shortcuts cleanup &&
			 * assets_as_an_app_v2 cleanup &&
			 */ menuId: (0, $46Cti.L1_MENU_ID).ASSETS,
            isVisible: true
        },
        {
            menuId: (0, $46Cti.L1_MENU_ID).TEAMS,
            isVisible: true
        },
        {
            menuId: (0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE,
            isVisible: true
        },
        {
            menuId: (0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS,
            isVisible: true
        },
        {
            menuId: (0, $46Cti.L1_MENU_ID).GLOBAL_APP_CONFLUENCE,
            isVisible: true
        },
        {
            menuId: (0, $46Cti.L1_MENU_ID).GLOBAL_APP_LOOM,
            isVisible: true
        },
        {
            menuId: (0, $46Cti.L1_MENU_ID).GLOBAL_APP_ASSETS,
            isVisible: true
        },
        {
            menuId: (0, $46Cti.L1_MENU_ID).GLOBAL_APP_OPSGENIE,
            isVisible: true
        },
        {
            menuId: (0, $46Cti.L1_MENU_ID).GLOBAL_APP_GOALS,
            isVisible: true
        },
        {
            menuId: (0, $46Cti.L1_MENU_ID).GLOBAL_APP_TEAMS,
            isVisible: true
        },
        {
            menuId: (0, $46Cti.L1_MENU_ID).GLOBAL_APP_PROJECTS,
            isVisible: true
        }
    ]
};
const $5d2bb3999d13b3c1$export$c2614ebabc74446e = $5d2bb3999d13b3c1$export$6f21b70acbf71216.navItems.map(({ menuId: menuId })=>menuId);

});
parcelRegister("dDmlh", function(module, exports) {

$parcel$export(module.exports, "dashboardsDirectoryRoute", () => $fd66dc0239264856$export$41bba408475cab16);
const $fd66dc0239264856$export$41bba408475cab16 = {
    name: 'dashboards-directory',
    path: '/jira/dashboards'
};

});


parcelRegister("2TuwK", function(module, exports) {

$parcel$export(module.exports, "L1MenuItems", () => $acec8e7e455fe5dc$export$a1e3b15bccd7433c);

var $2OeZv = parcelRequire("2OeZv");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $6kIiE = parcelRequire("6kIiE");

var $60xWx = parcelRequire("60xWx");
function $acec8e7e455fe5dc$export$a1e3b15bccd7433c({ queryReference: queryReference }) {
    // We define a query which requires a few variables: $cloudId and others
    // Looking at https://relay.dev/docs/guided-tour/rendering/variables/, we can either:
    // a) pass these query-level variables down to the fragments as arguments, OR,
    // b) allow the fragments to reference the query-level variables directly.
    // We've chosen b) for now, as it would be a hassle to have to specify 8+ variables
    // at every level of the component tree.
    const l1MenuData = (0, $8Uumt.usePreloadedQuery)((0, $2OeZv.default), queryReference);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6kIiE.YourWork), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $60xWx.ConfigurableMenuItems), {
        menuData: l1MenuData
    }));
}

});
parcelRegister("6kIiE", function(module, exports) {

$parcel$export(module.exports, "YourWork", () => $62ee6641d8028b84$export$c7da207c25eb3776);

var $5uXOq = parcelRequire("5uXOq");

var $bdVbi = parcelRequire("bdVbi");

var $jecJ3 = parcelRequire("jecJ3");

var $jhS4y = parcelRequire("jhS4y");

var $5FnJJ = parcelRequire("5FnJJ");

var $24a2m = parcelRequire("24a2m");

var $dIHnK = parcelRequire("dIHnK");

var $lCMI0 = parcelRequire("lCMI0");
const $62ee6641d8028b84$var$JIRA_HOME_PATH = (0, $dIHnK.jiraHomeRoute).path;
const $62ee6641d8028b84$var$analytics = {
    actionSubjectId: (0, $jecJ3.SECTION_ITEM_YOUR_WORK),
    itemId: 'yourWork',
    level: 1,
    // Note: Your work doesn't seem to be configurable via Customise sidebar - More menu
    isInMore: false
};
const $62ee6641d8028b84$export$c7da207c25eb3776 = ()=>{
    const { formattedMessage: formattedMessage, icon: icon } = (0, $24a2m.useFormattedMessageAndIcon)((0, $lCMI0.default).forYou, (0, (/*@__PURE__*/$parcel$interopDefault($bdVbi))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        analytics: $62ee6641d8028b84$var$analytics,
        elemBefore: icon,
        href: $62ee6641d8028b84$var$JIRA_HOME_PATH,
        menuId: (0, $jhS4y.MENU_ID_YOUR_WORK)
    }, formattedMessage);
};

});
parcelRegister("jecJ3", function(module, exports) {

$parcel$export(module.exports, "SECTION_ITEM_RECENT", () => $06147718dc8a8493$export$ed5276b2863990a4);
$parcel$export(module.exports, "SECTION_ITEM_STARRED", () => $06147718dc8a8493$export$73b9e2753c0313a);
$parcel$export(module.exports, "SECTION_ITEM_YOUR_WORK", () => $06147718dc8a8493$export$a7cdcfc40ede2092);
$parcel$export(module.exports, "SECTION_ITEM_APPS", () => $06147718dc8a8493$export$31b95a89c6fecef5);
$parcel$export(module.exports, "SECTION_ITEM_PLANS", () => $06147718dc8a8493$export$b8d778ecbc8de386);
$parcel$export(module.exports, "SECTION_ITEM_PROJECTS", () => $06147718dc8a8493$export$31111a67d393221);
$parcel$export(module.exports, "SECTION_ITEM_FILTERS", () => $06147718dc8a8493$export$15cffe8e769011f4);
$parcel$export(module.exports, "SECTION_ITEM_DASHBOARDS", () => $06147718dc8a8493$export$573d88e8f19dee53);
$parcel$export(module.exports, "SECTION_ITEM_OPERATIONS", () => $06147718dc8a8493$export$4d8d544db40ea55b);
$parcel$export(module.exports, "SECTION_ITEM_TEAMS", () => $06147718dc8a8493$export$ee4743a74ca6b2b4);
$parcel$export(module.exports, "SECTION_ITEM_ASSETS", () => $06147718dc8a8493$export$935694b184853c59);
$parcel$export(module.exports, "SECTION_ITEM_MORE", () => $06147718dc8a8493$export$b0aa6b1b7598bca0);
$parcel$export(module.exports, "SECTION_ITEM_CUSTOMIZE_SIDEBAR", () => $06147718dc8a8493$export$60a8edfaff189e32);
$parcel$export(module.exports, "SECTION_ITEM_OVERVIEW", () => $06147718dc8a8493$export$c15c267765b7c087);
$parcel$export(module.exports, "SECTION_ITEM_ROADMAPS", () => $06147718dc8a8493$export$1e1623e43a47b758);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_ASSETS", () => $06147718dc8a8493$export$be1ee97c6c39a7a0);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_GOALS", () => $06147718dc8a8493$export$340dfb7166bc7df6);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_CONFLUENCE", () => $06147718dc8a8493$export$68f5347447985678);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_LOOM", () => $06147718dc8a8493$export$1d6ac45ce8d48696);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_TEAMS", () => $06147718dc8a8493$export$73432842fefef2ac);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_PROJECTS", () => $06147718dc8a8493$export$3023d22f41447712);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_OPSGENIE", () => $06147718dc8a8493$export$3cc2573a8cf93a99);
$parcel$export(module.exports, "SECTION_ITEM_MAP", () => $06147718dc8a8493$export$1a73d7f5e6997c6d);

var $jhS4y = parcelRequire("jhS4y");
const $06147718dc8a8493$export$ed5276b2863990a4 = 'recent';
const $06147718dc8a8493$export$73b9e2753c0313a = 'starred';
const $06147718dc8a8493$export$a01a58e0d3083eac = 'yourApps';
const $06147718dc8a8493$export$a7cdcfc40ede2092 = 'yourWork';
const $06147718dc8a8493$export$31b95a89c6fecef5 = 'apps';
const $06147718dc8a8493$export$b8d778ecbc8de386 = 'plans';
const $06147718dc8a8493$export$31111a67d393221 = 'projects';
const $06147718dc8a8493$export$15cffe8e769011f4 = 'filters';
const $06147718dc8a8493$export$573d88e8f19dee53 = 'dashboards';
const $06147718dc8a8493$export$4d8d544db40ea55b = 'operations';
const $06147718dc8a8493$export$ee4743a74ca6b2b4 = 'teams';
const $06147718dc8a8493$export$935694b184853c59 = 'assets';
const $06147718dc8a8493$export$b0aa6b1b7598bca0 = 'more';
const $06147718dc8a8493$export$60a8edfaff189e32 = 'customiseSidebar';
const $06147718dc8a8493$export$c15c267765b7c087 = 'overviews';
const $06147718dc8a8493$export$e52ffdfdd2f167e7 = 'communication';
const $06147718dc8a8493$export$61feca79c347b0c7 = 'goals';
const $06147718dc8a8493$export$1e1623e43a47b758 = 'roadmaps';
const $06147718dc8a8493$export$99cd56faa69bbbb6 = 'customerService';
const $06147718dc8a8493$export$f3045e909a12df36 = 'customerHubs';
const $06147718dc8a8493$export$f780439bdf7412c6 = 'customerServiceAnalytics';
const $06147718dc8a8493$export$be1ee97c6c39a7a0 = 'assetsGlobalAppShortcut';
const $06147718dc8a8493$export$340dfb7166bc7df6 = 'goalsGlobalAppShortcut';
const $06147718dc8a8493$export$68f5347447985678 = 'confluenceGlobalAppShortcut';
const $06147718dc8a8493$export$1d6ac45ce8d48696 = 'loomGlobalAppShortcut';
const $06147718dc8a8493$export$73432842fefef2ac = 'teamsGlobalAppShortcut';
const $06147718dc8a8493$export$3023d22f41447712 = 'projectsGlobalAppShortcut';
const $06147718dc8a8493$export$3cc2573a8cf93a99 = 'opsgenieGlobalAppShortcut';
const $06147718dc8a8493$export$1a73d7f5e6997c6d = {
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).APPS]: $06147718dc8a8493$export$31b95a89c6fecef5,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).ASSETS]: $06147718dc8a8493$export$935694b184853c59,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).DASHBOARDS]: $06147718dc8a8493$export$573d88e8f19dee53,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).FILTERS]: $06147718dc8a8493$export$15cffe8e769011f4,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).OPERATIONS]: $06147718dc8a8493$export$4d8d544db40ea55b,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).PLANS]: $06147718dc8a8493$export$b8d778ecbc8de386,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).PROJECTS]: $06147718dc8a8493$export$31111a67d393221,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).RECENT]: $06147718dc8a8493$export$ed5276b2863990a4,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).STARRED]: $06147718dc8a8493$export$73b9e2753c0313a,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).TEAMS]: $06147718dc8a8493$export$ee4743a74ca6b2b4,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).GOALS]: $06147718dc8a8493$export$61feca79c347b0c7,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).OVERVIEWS]: $06147718dc8a8493$export$c15c267765b7c087,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).COMMUNICATION]: $06147718dc8a8493$export$e52ffdfdd2f167e7,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).ROADMAPS]: $06147718dc8a8493$export$1e1623e43a47b758,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).CUSTOMER_SERVICE]: $06147718dc8a8493$export$99cd56faa69bbbb6,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).CUSTOMER_HUBS]: $06147718dc8a8493$export$f3045e909a12df36,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: $06147718dc8a8493$export$f780439bdf7412c6,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).GLOBAL_APP_GOALS]: $06147718dc8a8493$export$340dfb7166bc7df6,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).GLOBAL_APP_ASSETS]: $06147718dc8a8493$export$be1ee97c6c39a7a0,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).GLOBAL_APP_CONFLUENCE]: $06147718dc8a8493$export$68f5347447985678,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).GLOBAL_APP_LOOM]: $06147718dc8a8493$export$1d6ac45ce8d48696,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).GLOBAL_APP_TEAMS]: $06147718dc8a8493$export$73432842fefef2ac,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).GLOBAL_APP_PROJECTS]: $06147718dc8a8493$export$3023d22f41447712,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).GLOBAL_APP_OPSGENIE]: $06147718dc8a8493$export$3cc2573a8cf93a99
};

});

parcelRegister("5FnJJ", function(module, exports) {

$parcel$export(module.exports, "Nav4MenuLinkItem", () => $0d86e9008b98ae27$export$3253d78f1560490f);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $5uXOq = parcelRequire("5uXOq");

var $c6x3L = parcelRequire("c6x3L");

var $lJ5jf = parcelRequire("lJ5jf");

var $1juF8 = parcelRequire("1juF8");

var $dQbFB = parcelRequire("dQbFB");
const $0d86e9008b98ae27$export$3253d78f1560490f = /*#__PURE__*/ (0, $5uXOq.forwardRef)($0d86e9008b98ae27$var$Nav4MenuLinkItemContent);
function $0d86e9008b98ae27$var$Nav4MenuLinkItemContent(props, ref) {
    const { menuId: menuId } = props;
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    const { isSelectedPath: isSelectedPath } = (0, $c6x3L.useSidebarNav4)();
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    const { isControlledPath: isControlledPath } = (0, $lJ5jf.useSidebarNav4Controller)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1juF8.default), {
        ref: ref,
        ...props,
        isSelected: isSelectedPath(menuId) || isControlledPath(menuId),
        testId: (0, $dQbFB.getTestId)(menuId)
    });
}

});
parcelRegister("c6x3L", function(module, exports) {

$parcel$export(module.exports, "SidebarNav4ContextProvider", () => $313dc1bbe6a8339e$export$ebf7cdfc2e83bcef);
$parcel$export(module.exports, "useSidebarNav4", () => $313dc1bbe6a8339e$export$dc46c14934833db2);

var $5uXOq = parcelRequire("5uXOq");

var $doZTA = parcelRequire("doZTA");

var $3Jbkp = parcelRequire("3Jbkp");

var $fMcVX = parcelRequire("fMcVX");

var $7Ckoi = parcelRequire("7Ckoi");
const $313dc1bbe6a8339e$var$SidebarNav4Context = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
function $313dc1bbe6a8339e$export$2854101beb9a2d8d(props) {
    const { children: children, isInitialSelectedPath: isInitialSelectedPath } = props;
    const [routerContext] = (0, $doZTA.useRouter)();
    const initialSelectedPath = (0, $3Jbkp.getInitialSelectedPath)(routerContext);
    const [selectedPath, setSelectedPath] = (0, $5uXOq.useState)(initialSelectedPath);
    // When the `routerContext` changes, we need to recalculate the selected path.
    // useLayoutEffect, so this happens before render.
    (0, $5uXOq.useLayoutEffect)(()=>{
        setSelectedPath((currentPath)=>{
            const newPath = (0, $7Ckoi.routeToSelectedPath)(routerContext);
            return currentPath.toString() === newPath.toString() ? currentPath : newPath;
        });
    }, [
        routerContext
    ]);
    const sidebarNav4Controller = (0, $5uXOq.useMemo)(()=>({
            isInitialSelectedPath: isInitialSelectedPath ?? (0, $fMcVX.isSelectedPath)(initialSelectedPath),
            isSelectedPath: (0, $fMcVX.isSelectedPath)(selectedPath)
        }), [
        initialSelectedPath,
        isInitialSelectedPath,
        selectedPath
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($313dc1bbe6a8339e$var$SidebarNav4Context.Provider, {
        value: sidebarNav4Controller
    }, children);
}
function $313dc1bbe6a8339e$export$ebf7cdfc2e83bcef(props) {
    const { children: children, isInitialSelectedPath: isInitialSelectedPath } = props;
    const selectedPathData = (0, $7Ckoi.useRouteToSelectedPath)();
    const sidebarNav4Controller = (0, $5uXOq.useMemo)(()=>({
            isInitialSelectedPath: isInitialSelectedPath ?? (0, $fMcVX.isSelectedPath)(selectedPathData.initialSelectedPath),
            isSelectedPath: (0, $fMcVX.isSelectedPath)(selectedPathData.selectedPath)
        }), [
        isInitialSelectedPath,
        selectedPathData.initialSelectedPath,
        selectedPathData.selectedPath
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($313dc1bbe6a8339e$var$SidebarNav4Context.Provider, {
        value: sidebarNav4Controller
    }, children);
}
function $313dc1bbe6a8339e$export$dc46c14934833db2() {
    const context = (0, $5uXOq.useContext)($313dc1bbe6a8339e$var$SidebarNav4Context);
    if (context == null) throw new Error('useSidebarNav4 must be used inside a SidebarNav4ContextProvider');
    return context;
}

});

parcelRegister("lJ5jf", function(module, exports) {

$parcel$export(module.exports, "SidebarNav4ControllerProvider", () => $ba2af518cd3fa886$export$ec25d268893d889d);
$parcel$export(module.exports, "useSidebarNav4Controller", () => $ba2af518cd3fa886$export$641950c86d73374);

var $5uXOq = parcelRequire("5uXOq");

var $fMcVX = parcelRequire("fMcVX");
const $ba2af518cd3fa886$var$SidebarNav4ControllerContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
function $ba2af518cd3fa886$export$ec25d268893d889d(props) {
    const { children: children, controlledPath: initialControlledPath = null } = props;
    const [controlledPath, setControlledPath] = (0, $5uXOq.useState)(initialControlledPath); // null means "not being controlled"
    const sidebarNav4Controller = (0, $5uXOq.useMemo)(()=>({
            // is any path in Navigation a controlled one
            isControlledNav: controlledPath !== null,
            isControlledPath: (0, $fMcVX.isSelectedPath)(controlledPath ?? []),
            setControlledPath: setControlledPath
        }), [
        controlledPath
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ba2af518cd3fa886$var$SidebarNav4ControllerContext.Provider, {
        value: sidebarNav4Controller
    }, children);
}
function $ba2af518cd3fa886$export$641950c86d73374() {
    const context = (0, $5uXOq.useContext)($ba2af518cd3fa886$var$SidebarNav4ControllerContext);
    if (context == null) throw new Error('useSidebarNav4Controller must be used inside a SidebarNav4ControllerContext');
    return context;
}

});

parcelRegister("1juF8", function(module, exports) {

$parcel$export(module.exports, "default", () => $7af6d3b30799ed49$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cJFfS = parcelRequire("cJFfS");


var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");
function $7af6d3b30799ed49$var$LinkMenuItemWithAnalytics({ analytics: analytics, onClick: onClick, ...rest }, ref) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleClick = (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        if (!analytics) return;
        const { actionSubjectId: actionSubjectId, ...analyticsAttributes } = analytics;
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
        }), actionSubjectId, analyticsAttributes);
    }, [
        analytics,
        createAnalyticsEvent,
        onClick
    ]) : (event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        if (!analytics) return;
        const { actionSubjectId: actionSubjectId, ...analyticsAttributes } = analytics;
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
        }), actionSubjectId, analyticsAttributes);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cJFfS.LinkMenuItem), {
        ref: ref,
        onClick: handleClick,
        ...rest
    });
}
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$7af6d3b30799ed49$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.forwardRef)($7af6d3b30799ed49$var$LinkMenuItemWithAnalytics);

});
const $ce8062101363feb9$export$6dd9406e478a1fe2 = 'navigationItem';
const $ce8062101363feb9$export$b887e88d8d0739f6 = 'button';
const $ce8062101363feb9$export$64fed82162bd367 = 'dropdownItem';


parcelRegister("dQbFB", function(module, exports) {

$parcel$export(module.exports, "getTestId", () => $f598f66a6b396d35$export$ec17b125bc42c229);
// By giving all of the Nav4-HTMLElements a test-id prefix, we can find them again,
// and even build a path from each leaf to the root. We do this in Storybook to
// simulate link-click-selection, since we are not using a real router in SB.
function $f598f66a6b396d35$export$ec17b125bc42c229(suffix) {
    return `NAV4_${suffix}`;
}

});


parcelRegister("dIHnK", function(module, exports) {

$parcel$export(module.exports, "jiraHomeRoute", () => $90d9eefc14df7b5b$export$11ebbd6d4e57759c);
const $90d9eefc14df7b5b$export$11ebbd6d4e57759c = {
    name: 'your-work',
    path: '/jira/your-work'
};

});

parcelRegister("lCMI0", function(module, exports) {

$parcel$export(module.exports, "default", () => $f35f2103e05fea00$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f35f2103e05fea00$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    yourWork: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-your-work.your-work.your-work",
        "defaultMessage": "Your work"
    },
    forYou: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-your-work.your-work.for-you",
        "defaultMessage": "For you"
    }
});

});


parcelRegister("60xWx", function(module, exports) {

$parcel$export(module.exports, "ConfigurableMenuItems", () => $b2e090acb983f40f$export$4aa1992a31b27e16);

var $4yzqs = parcelRequire("4yzqs");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $cZH0T = parcelRequire("cZH0T");

var $iszzG = parcelRequire("iszzG");

var $fiYXQ = parcelRequire("fiYXQ");

var $lxgkT = parcelRequire("lxgkT");

var $jybPW = parcelRequire("jybPW");

var $eUfQ2 = parcelRequire("eUfQ2");

var $4R6GH = parcelRequire("4R6GH");

var $cSD7y = parcelRequire("cSD7y");

var $3muxY = parcelRequire("3muxY");

var $cam2y = parcelRequire("cam2y");

var $jM4TX = parcelRequire("jM4TX");

var $i98eP = parcelRequire("i98eP");

var $1tKM7 = parcelRequire("1tKM7");

var $8FnIk = parcelRequire("8FnIk");

var $ef14J = parcelRequire("ef14J");
const $b2e090acb983f40f$export$4aa1992a31b27e16 = (0, $cSD7y.componentWithFG)('jfp-magma-stability-check-nav4-batch-1', /*#__PURE__*/ (0, $5uXOq.memo)($b2e090acb983f40f$var$ConfigurableMenuItemsInner), $b2e090acb983f40f$var$ConfigurableMenuItemsInner);
function $b2e090acb983f40f$var$ConfigurableMenuItemsInner({ menuData: menuData }) {
    const data = (0, $8Uumt.useFragment)((0, $4yzqs.default), menuData);
    // Creates a synced ref to the global app shortcuts to get the response from global app shortcuts component.
    const getFilteredProductLinks = (0, $5uXOq.useRef)(undefined);
    const globalAppLicense = (0, $eUfQ2.useGlobalApps)();
    const navItems = (0, $cam2y.useFilterL1MenuItemsByEditionAndLicense)(// Add back any missing menu ids before filtering in case licensing has changed or a new L1 has been created.
    // This also handles when a user has no configuration yet.
    (0, $jM4TX.useRefreshL1MenuItems)(data.jira?.userNavigationConfiguration?.navItems));
    const navItemsContext = (0, $5uXOq.useMemo)(()=>({
            navItems: navItems,
            visibleMenuIds: (0, $fiYXQ.getConfigurableMenuIds)(navItems, true),
            moreMenuIds: (0, $fiYXQ.getConfigurableMenuIds)(navItems, false),
            productItemsData: (0, $lxgkT.getProductItemsData)(navItems)
        }), [
        navItems
    ]);
    const visibleGlobalAppMenuIds = (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useMemo)(()=>(0, $lxgkT.getVisibleAppItemsData)(navItems, globalAppLicense, getFilteredProductLinks.current), [
        globalAppLicense,
        navItems,
        getFilteredProductLinks
    ]) : (0, $lxgkT.getVisibleAppItemsData)(navItems, globalAppLicense, getFilteredProductLinks.current);
    const appItemsData = (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useMemo)(()=>(0, $lxgkT.getAppItemsData)(navItems, globalAppLicense, getFilteredProductLinks.current), [
        globalAppLicense,
        navItems,
        getFilteredProductLinks
    ]) : (0, $lxgkT.getAppItemsData)(navItems, globalAppLicense, getFilteredProductLinks.current);
    // Teams App requires the invite modal context provider to be wrapped around it.
    const globalShortcuts = (0, $5uXOq.useMemo)(()=>{
        if ((0, $4R6GH.fg)('nav4_global_links_jira')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZH0T.TopLevelSpacer), null), (0, $4R6GH.fg)('nav4_gas_include_teams') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ef14J.GlobalShortcutsWithInvitePeopleProvider), {
            appItemsData: appItemsData,
            handleUpdateGetFilteredProductLinks: (fn)=>{
                getFilteredProductLinks.current = fn;
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ef14J.GlobalShortcuts), {
            appItemsData: appItemsData,
            handleUpdateGetFilteredProductLinks: (fn)=>{
                getFilteredProductLinks.current = fn;
            }
        }));
        return visibleGlobalAppMenuIds.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZH0T.TopLevelSpacer), null), visibleGlobalAppMenuIds.map((menuId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jybPW.GlobalAppShortcuts), {
                menuId: menuId,
                key: menuId
            }))) : null;
    }, [
        visibleGlobalAppMenuIds,
        appItemsData
    ]);
    const getAppShortcutURL = (0, $5uXOq.useCallback)((apsKey)=>{
        if (getFilteredProductLinks.current) {
            const result = getFilteredProductLinks?.current?.(apsKey);
            return result.promotedLink?.url;
        }
    }, [
        getFilteredProductLinks
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iszzG.NavItemsContext).Provider, {
        value: navItemsContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8FnIk.PeekMenuIdContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i98eP.MoreMenuIsOpenContextProvider), null, navItemsContext.visibleMenuIds.map((menuId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3muxY.ConfigurableMenuItem), {
            key: menuId,
            menuData: data,
            menuId: menuId
        })), globalShortcuts, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZH0T.TopLevelSpacer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1tKM7.SidebarCustomization), {
        navItems: navItems,
        menuData: data,
        productItemsData: navItemsContext.productItemsData,
        appItemsData: appItemsData,
        getAppShortcutURL: getAppShortcutURL
    }))));
}

});
parcelRegister("4yzqs", function(module, exports) {

$parcel$export(module.exports, "default", () => $456c834cb9e35bf5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<00967a64cef8c686dca07727f080bd28>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $456c834cb9e35bf5$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "ConfigurableMenuItems",
    "selections": [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudID",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Literal",
                            "name": "navKey",
                            "value": "NAV_SIDEBAR"
                        }
                    ],
                    "concreteType": "JiraUserNavigationConfiguration",
                    "kind": "LinkedField",
                    "name": "userNavigationConfiguration",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraConfigurableNavigationItem",
                            "kind": "LinkedField",
                            "name": "navItems",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "menuId"
                                    },
                                    "action": "THROW",
                                    "path": "jira.userNavigationConfiguration.navItems.menuId"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "isVisible"
                                    },
                                    "action": "THROW",
                                    "path": "jira.userNavigationConfiguration.navItems.isVisible"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "ConfigurableMenuItem"
        }
    ],
    "type": "Query"
};
$456c834cb9e35bf5$var$node.hash = "186fc107bcd2a8ade003841f3137d27b";
var $456c834cb9e35bf5$export$2e2bcd8739ae039 = $456c834cb9e35bf5$var$node;

});

parcelRegister("cZH0T", function(module, exports) {

$parcel$export(module.exports, "TopLevelSpacer", () => $30a39a641f92d60b$export$5776f68925982056);
/* top-level-spacer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $et13M = parcelRequire("et13M");
const $30a39a641f92d60b$var$styles = {
    root: "_4t3iutpp"
};
function $30a39a641f92d60b$export$5776f68925982056() {
    const level = (0, $et13M.useLevel)();
    (0, $5uXOq.useEffect)(()=>{}, [
        level
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            $30a39a641f92d60b$var$styles.root
        ])
    });
}

});

parcelRegister("iszzG", function(module, exports) {

$parcel$export(module.exports, "NavItemsContext", () => $71af5d0260a148da$export$a2018da95558f5c);
$parcel$export(module.exports, "PeekMenuIdContext", () => $71af5d0260a148da$export$390c771b9e3f4124);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");
const $71af5d0260a148da$export$a2018da95558f5c = /*#__PURE__*/ (0, $5uXOq.createContext)({
    navItems: [],
    visibleMenuIds: [],
    moreMenuIds: []
});
const $71af5d0260a148da$export$390c771b9e3f4124 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    peekMenuId: undefined,
    setPeekMenuId: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
});

});

parcelRegister("fiYXQ", function(module, exports) {

$parcel$export(module.exports, "getConfigurableMenuIds", () => $9312141792122626$export$6071c13fba14d7fa);

var $5Yh04 = parcelRequire("5Yh04");
const $9312141792122626$export$6071c13fba14d7fa = (navItems, isVisible)=>navItems.filter((navItem)=>navItem.isVisible === isVisible).map(({ menuId: menuId })=>menuId).filter((0, $5Yh04.isConfigurableMenuId));

});
parcelRegister("5Yh04", function(module, exports) {

$parcel$export(module.exports, "isConfigurableMenuId", () => $a5f9a046dfa6b79b$export$454094eefbaf1797);

var $4DrQd = parcelRequire("4DrQd");
const $a5f9a046dfa6b79b$export$454094eefbaf1797 = (value)=>(0, $4DrQd.CONFIGURABLE_MENU_IDS_AS_STRINGS).includes(value);

});


parcelRegister("lxgkT", function(module, exports) {

$parcel$export(module.exports, "getProductItemsData", () => $22d59b84f7f46516$export$92d3bf799aea2628);
$parcel$export(module.exports, "getAppItemsData", () => $22d59b84f7f46516$export$153d0c6accbfb26a);
$parcel$export(module.exports, "getVisibleAppItemsData", () => $22d59b84f7f46516$export$b7cc8dd7bef58aa3);

var $4R6GH = parcelRequire("4R6GH");

var $jhS4y = parcelRequire("jhS4y");

var $4Pf62 = parcelRequire("4Pf62");

var $46Cti = parcelRequire("46Cti");

var $eUfQ2 = parcelRequire("eUfQ2");
const $22d59b84f7f46516$export$92d3bf799aea2628 = (navItems)=>(0, $4R6GH.fg)('nav4_global_links_jira') ? navItems.filter((navItem)=>(0, $eUfQ2.isSupportedMenuId)(navItem.menuId)).filter((navItem)=>!(0, $eUfQ2.isGlobalAppMenuId)(navItem.menuId)).filter((navItem)=>{
        if (!(0, $4R6GH.fg)('nav4_gas_include_teams')) return true;
        return navItem.menuId !== (0, $46Cti.L1_MENU_ID).TEAMS;
    }).map((item)=>{
        return {
            menuId: item.menuId,
            visible: item.isVisible
        };
    }) : navItems.filter((navItem)=>!(0, $eUfQ2.isGlobalAppMenuId)(navItem.menuId)).map((item)=>{
        return {
            menuId: item.menuId,
            visible: item.isVisible
        };
    });
const $22d59b84f7f46516$export$153d0c6accbfb26a = (navItems, globalAppLicense, getFilteredProductLinks)=>navItems.filter((navItem)=>(0, $eUfQ2.isGlobalAppMenuId)(navItem.menuId)).filter((navItem)=>{
        // TODO: put this under a feature gate
        if (!(0, $4R6GH.fg)('nav4_global_links_jira')) return true;
        // Metadata app licencing check
        if (!$22d59b84f7f46516$var$isProductSupportedFromMetadata(navItem.menuId)) return false;
        if (getFilteredProductLinks) {
            if (navItem.menuId in (0, $jhS4y.GLOBAL_APP_MENU_ID_TO_APS_KEY)) {
                const apsKey = (0, $jhS4y.GLOBAL_APP_MENU_ID_TO_APS_KEY)[navItem.menuId];
                const filteredProducts = getFilteredProductLinks(apsKey);
                if (filteredProducts.links.length === 0) // If there are no filtered links, we don't want to show this item.
                return false;
            }
        }
        return true;
    }).filter((navItem)=>(0, $eUfQ2.hasGlobalAppLicense)(navItem.menuId, globalAppLicense)).map((item)=>{
        return {
            menuId: item.menuId,
            visible: item.isVisible
        };
    });
const $22d59b84f7f46516$export$b7cc8dd7bef58aa3 = (navItems, globalAppLicense, getFilteredProductLinks)=>{
    return navItems.filter((navItem)=>navItem.isVisible).map(({ menuId: menuId })=>menuId).filter((0, $eUfQ2.isGlobalAppMenuId)).filter((navItem)=>{
        if (!(0, $4R6GH.fg)('nav4_global_links_jira')) return true;
        // Metadata app licencing check
        if (!$22d59b84f7f46516$var$isProductSupportedFromMetadata(navItem)) return false;
        if (getFilteredProductLinks) {
            if (navItem in (0, $jhS4y.GLOBAL_APP_MENU_ID_TO_APS_KEY)) {
                const apsKey = (0, $jhS4y.GLOBAL_APP_MENU_ID_TO_APS_KEY)[navItem];
                const filteredProducts = getFilteredProductLinks(apsKey);
                if (filteredProducts.links.length === 0) // If there are no filtered links, we don't want to show this item.
                return false;
            }
        }
        return true;
    }).filter((menuId)=>(0, $eUfQ2.hasGlobalAppLicense)(menuId, globalAppLicense));
};
const $22d59b84f7f46516$var$isProductSupportedFromMetadata = (menuId)=>{
    const products = (0, $4Pf62.getLicensedProducts)();
    switch(menuId){
        case (0, $46Cti.L1_MENU_ID).GLOBAL_APP_CONFLUENCE:
            return !!products[(0, $4Pf62.LICENSED_PRODUCTS).CONFLUENCE];
        case (0, $46Cti.L1_MENU_ID).GLOBAL_APP_LOOM:
            return !!products[(0, $4Pf62.LICENSED_PRODUCTS).LOOM];
        default:
            return true;
    }
};

});
parcelRegister("eUfQ2", function(module, exports) {

$parcel$export(module.exports, "useGlobalApps", () => $ee3038da8e9367b5$export$3a835823210524f1);
$parcel$export(module.exports, "isSupportedMenuId", () => $ee3038da8e9367b5$export$54d4b2a367e2f9d);
$parcel$export(module.exports, "isGlobalAppMenuId", () => $ee3038da8e9367b5$export$4c0a3527505b04c5);
$parcel$export(module.exports, "hasGlobalAppLicense", () => $ee3038da8e9367b5$export$f97a769ad5c10cb4);

var $5uXOq = parcelRequire("5uXOq");

var $cwX5o = parcelRequire("cwX5o");

var $4R6GH = parcelRequire("4R6GH");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $ktP1V = parcelRequire("ktP1V");

var $9OXo1 = parcelRequire("9OXo1");

var $4DrQd = parcelRequire("4DrQd");

var $46Cti = parcelRequire("46Cti");
function $ee3038da8e9367b5$export$3a835823210524f1() {
    const appEditions = (0, $k9JTq.useAppEditions)();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const shouldShowGoals = (appEditions.productDiscovery !== (0, $ldyPw.UNLICENSED) || appEditions.software !== (0, $ldyPw.UNLICENSED) || // JSM comes with a free core license. Goals don't display with JSM-only, so checking for unlicensed JSM
    appEditions.core !== (0, $ldyPw.UNLICENSED) && appEditions.serviceDesk === (0, $ldyPw.UNLICENSED)) && (0, $4R6GH.fg)('blu-6313_sidebar_global_app_shortcuts') && !(0, $cwX5o.isFedrampModerate)();
    const shouldShowAssets = // eslint-disable-next-line jira/ff/no-preconditioning
    appEditions.serviceDesk !== (0, $ldyPw.UNLICENSED) && (0, $4R6GH.fg)('assets_as_an_app_v2') && (0, $4R6GH.fg)('blu-6313_sidebar_global_app_shortcuts') && (0, $ktP1V.isCMDBEnabledInEnvironment)(tenantContext.cmdbDisabledInFedRAMP);
    // eslint-disable-next-line jira/ff/no-preconditioning
    const shouldShowTeams = (0, $4R6GH.fg)('nav4_global_links_jira') && (0, $4R6GH.fg)('nav4_gas_include_teams');
    const globalAppShortcuts = (0, $5uXOq.useMemo)(()=>{
        if (appEditions.core !== (0, $ldyPw.UNLICENSED)) {
            if (appEditions.serviceDesk !== (0, $ldyPw.UNLICENSED)) return {
                confluence: true,
                loom: true,
                projects: false,
                teams: shouldShowTeams,
                opsgenie: true
            };
            if (appEditions.productDiscovery !== (0, $ldyPw.UNLICENSED)) return {
                confluence: true,
                loom: true,
                projects: false,
                teams: shouldShowTeams,
                opsgenie: false
            };
        } else {
            if (appEditions.serviceDesk !== (0, $ldyPw.UNLICENSED)) return {
                confluence: false,
                loom: false,
                projects: false,
                teams: shouldShowTeams,
                opsgenie: true
            };
            if (appEditions.productDiscovery !== (0, $ldyPw.UNLICENSED)) return {
                confluence: false,
                loom: false,
                projects: false,
                teams: shouldShowTeams,
                opsgenie: false
            };
        }
        return {
            confluence: true,
            loom: true,
            projects: true,
            teams: shouldShowTeams,
            opsgenie: false
        };
    }, [
        appEditions,
        shouldShowTeams
    ]);
    if ((0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $5uXOq.useMemo)(()=>{
        if ((0, $4R6GH.fg)('nav4_global_links_jira')) return {
            goals: shouldShowGoals,
            assets: shouldShowAssets,
            ...globalAppShortcuts
        };
        return {
            goals: shouldShowGoals,
            assets: shouldShowAssets,
            confluence: false,
            loom: false,
            projects: false,
            teams: false,
            opsgenie: false
        };
    }, [
        globalAppShortcuts,
        shouldShowAssets,
        shouldShowGoals
    ]);
    if ((0, $4R6GH.fg)('nav4_global_links_jira')) return {
        goals: shouldShowGoals,
        assets: shouldShowAssets,
        ...globalAppShortcuts
    };
    return {
        goals: shouldShowGoals,
        assets: shouldShowAssets,
        confluence: false,
        loom: false,
        projects: false,
        teams: false,
        opsgenie: false
    };
}
const $ee3038da8e9367b5$export$54d4b2a367e2f9d = (value)=>(0, $4DrQd.CONFIGURABLE_MENU_IDS_AS_STRINGS).includes(value);
const $ee3038da8e9367b5$export$4c0a3527505b04c5 = (value)=>(0, $4DrQd.GLOBAL_APP_MENU_IDS_AS_STRINGS).includes(value);
const $ee3038da8e9367b5$export$f97a769ad5c10cb4 = (value, globalAppLicense)=>{
    switch(value){
        case (0, $46Cti.L1_MENU_ID).GLOBAL_APP_ASSETS:
            return globalAppLicense.assets;
        case (0, $46Cti.L1_MENU_ID).GLOBAL_APP_GOALS:
            return globalAppLicense.goals;
        case (0, $46Cti.L1_MENU_ID).GLOBAL_APP_CONFLUENCE:
            return globalAppLicense.confluence;
        case (0, $46Cti.L1_MENU_ID).GLOBAL_APP_LOOM:
            return globalAppLicense.loom;
        case (0, $46Cti.L1_MENU_ID).GLOBAL_APP_PROJECTS:
            return globalAppLicense.projects;
        case (0, $46Cti.L1_MENU_ID).GLOBAL_APP_TEAMS:
            return globalAppLicense.teams;
        default:
            return false;
    }
};

});
parcelRegister("cwX5o", function(module, exports) {

$parcel$export(module.exports, "isIsolatedCloud", () => $b04dbd20302f23e5$export$9186ccba8effc5de);
$parcel$export(module.exports, "isFedrampModerate", () => $b04dbd20302f23e5$export$104cb891a6e90b3a);

var $bNXfF = parcelRequire("bNXfF");

var $jCq2W = parcelRequire("jCq2W");
function $b04dbd20302f23e5$export$9186ccba8effc5de() {
    const atlCtxCookieValues = (0, $jCq2W.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    // The icDomain check is needed for when federal perimeters are eventually added to Isolated Cloud as well
    return (0, $bNXfF.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
}
function $b04dbd20302f23e5$export$104cb891a6e90b3a() {
    const atlCtxCookieValues = (0, $jCq2W.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    return atlCtxCookieValues.perimeter === (0, $bNXfF.FEDRAMP_MODERATE);
}
function $b04dbd20302f23e5$export$80638ee198476daf() {
    const atlCtxCookieValues = (0, $jCq2W.parseAtlCtxCookies)();
    return atlCtxCookieValues?.icDomain;
}

});
parcelRegister("bNXfF", function(module, exports) {

$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $16271ea4123e88a6$export$ce553301d55c2fd8);
$parcel$export(module.exports, "ISOLATED_CLOUD_PERIMETERS", () => $16271ea4123e88a6$export$d8347b4aae768c2d);
$parcel$export(module.exports, "ATL_CTX_PERIMETER", () => $16271ea4123e88a6$export$87285944378c596);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_DOMAIN", () => $16271ea4123e88a6$export$715603e81922c3ec);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_ID", () => $16271ea4123e88a6$export$a0ffa0598c95dfb7);
const $16271ea4123e88a6$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $16271ea4123e88a6$export$f005e2e9f707cb5f = 'commercial';
const $16271ea4123e88a6$export$a739cd5aac835909 = 'staging';
const $16271ea4123e88a6$export$42dd0cdd351a4a9 = 'prod';
const $16271ea4123e88a6$export$404582bc18fe4d9e = 'dev';
const $16271ea4123e88a6$export$d8347b4aae768c2d = [
    $16271ea4123e88a6$export$f005e2e9f707cb5f
];
const $16271ea4123e88a6$export$b1b1ccc8f3e7f954 = [
    $16271ea4123e88a6$export$f005e2e9f707cb5f,
    $16271ea4123e88a6$export$ce553301d55c2fd8
];
const $16271ea4123e88a6$export$87285944378c596 = 'Atl-Ctx-Perimeter';
const $16271ea4123e88a6$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
const $16271ea4123e88a6$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';

});

parcelRegister("jCq2W", function(module, exports) {

$parcel$export(module.exports, "parseAtlCtxCookies", () => $dce0d7cd5cbc865c$export$3fa7b7af96286cc9);

var $bNXfF = parcelRequire("bNXfF");
/**
 * Internal helper function used to parse cookie values and extract value of provided cookie name
 * @param {AtlCtxCookieName} cookieName - The name of the cookie to extract
 * @param {string} cookieString - The full cookie string
 * @returns {string | undefined} - The cookie value if present, undefined otherwise
 */ function $dce0d7cd5cbc865c$var$getRawCookieValue(cookieName, cookieString) {
    if (!cookieString) return undefined;
    const cookies = cookieString.split(';');
    for (const cookie of cookies){
        const [name, value] = cookie.trim().split('=');
        if (name === cookieName) return value;
    }
    return undefined;
}
function $dce0d7cd5cbc865c$export$3fa7b7af96286cc9() {
    const global = globalThis;
    try {
        const cookies = global.document.cookie;
        const perimeter = $dce0d7cd5cbc865c$var$getRawCookieValue((0, $bNXfF.ATL_CTX_PERIMETER), cookies);
        if (!perimeter) // Indicative of non-isolated commercial perimeter
        return undefined;
        const icDomain = $dce0d7cd5cbc865c$var$getRawCookieValue((0, $bNXfF.ATL_CTX_ISOLATION_CONTEXT_DOMAIN), cookies);
        const icId = $dce0d7cd5cbc865c$var$getRawCookieValue((0, $bNXfF.ATL_CTX_ISOLATION_CONTEXT_ID), cookies);
        // The IC Domain and IC Id cookie values are empty strings for non Isolated Cloud
        const emptyIcDomain = !icDomain || icDomain.length === 0;
        const emptyIcId = !icId || icId.length === 0;
        return {
            perimeter: perimeter,
            icDomain: emptyIcDomain ? undefined : icDomain,
            icId: emptyIcId ? undefined : icId
        };
    } catch (e) {
        console.warn('Failed to parse atl-ctx cookies:', e);
        return undefined;
    }
}

});


parcelRegister("k9JTq", function(module, exports) {

$parcel$export(module.exports, "useAppEditions", () => $dde261c9da85268a$export$92ed15881fc090d7);

var $9OXo1 = parcelRequire("9OXo1");
const $dde261c9da85268a$export$92ed15881fc090d7 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.appEditions;
};

});



parcelRegister("jybPW", function(module, exports) {

$parcel$export(module.exports, "GlobalAppShortcuts", () => $caac9dedc6905047$export$69209b4d7b9e00bc);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lzGRO = parcelRequire("lzGRO");

const $caac9dedc6905047$export$69209b4d7b9e00bc = ({ menuId: menuId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "flag",
        id: "global-app-shortcuts-section",
        packageName: (0, $3287f4a6e09b4c02$export$b8b9d90f9e5bd72b),
        teamName: (0, $3287f4a6e09b4c02$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lzGRO.GlobalAppShortcuts), {
        menuId: menuId
    }));

});
parcelRegister("lzGRO", function(module, exports) {

$parcel$export(module.exports, "GlobalAppShortcuts", () => $6b4660393b5fff8f$export$69209b4d7b9e00bc);

var $5uXOq = parcelRequire("5uXOq");

var $jhS4y = parcelRequire("jhS4y");

var $eQV8d = parcelRequire("eQV8d");

var $jecJ3 = parcelRequire("jecJ3");

var $4R6GH = parcelRequire("4R6GH");

var $iiqUN = parcelRequire("iiqUN");

var $RMW1a = parcelRequire("RMW1a");
function $6b4660393b5fff8f$export$69209b4d7b9e00bc({ menuId: menuId }) {
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    const onClick = (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useCallback)(()=>{
        sendSectionItemAnalyticsEvent({
            menuId: menuId,
            sectionItem: (0, $jecJ3.SECTION_ITEM_MAP)[menuId]
        });
    }, [
        menuId,
        sendSectionItemAnalyticsEvent
    ]) : ()=>{
        sendSectionItemAnalyticsEvent({
            menuId: menuId,
            sectionItem: (0, $jecJ3.SECTION_ITEM_MAP)[menuId]
        });
    };
    switch(menuId){
        case (0, $jhS4y.GLOBAL_APP_MENU_ID).GLOBAL_APP_GOALS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $RMW1a.Goals), {
                onClick: onClick
            });
        case (0, $jhS4y.GLOBAL_APP_MENU_ID).GLOBAL_APP_ASSETS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iiqUN.Assets), {
                onClick: onClick
            });
        default:
            return null;
    }
}

});
parcelRegister("eQV8d", function(module, exports) {

$parcel$export(module.exports, "useSectionItemAnalytics", () => $209417640a04fcbd$export$88869d054e1fb00a);

var $5uXOq = parcelRequire("5uXOq");


var $jecJ3 = parcelRequire("jecJ3");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $iszzG = parcelRequire("iszzG");
const $209417640a04fcbd$export$ee0f05907a733e87 = ({ sectionItem: sectionItem, menuId: menuId, moreMenuIds: moreMenuIds })=>{
    if (sectionItem === (0, $jecJ3.SECTION_ITEM_CUSTOMIZE_SIDEBAR)) return moreMenuIds.length !== 0;
    if (menuId) return moreMenuIds.includes(menuId);
    return false;
};
function $209417640a04fcbd$export$88869d054e1fb00a() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { moreMenuIds: moreMenuIds } = (0, $5uXOq.useContext)((0, $iszzG.NavItemsContext));
    const sendSectionItemAnalyticsEvent = (0, $5uXOq.useCallback)(({ menuId: menuId, sectionItem: sectionItem })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
        });
        const isInMore = $209417640a04fcbd$export$ee0f05907a733e87({
            sectionItem: sectionItem,
            menuId: menuId,
            moreMenuIds: moreMenuIds
        });
        (0, $8zOmE.fireUIAnalytics)(event, sectionItem, {
            isInMore: isInMore
        });
    }, [
        createAnalyticsEvent,
        moreMenuIds
    ]);
    return sendSectionItemAnalyticsEvent;
}

});

parcelRegister("iiqUN", function(module, exports) {

$parcel$export(module.exports, "Assets", () => $4bdc039a652f8e65$export$c8eca95e306f7116);

var $5uXOq = parcelRequire("5uXOq");

var $ggICg = parcelRequire("ggICg");

var $bfgl4 = parcelRequire("bfgl4");

var $cJFfS = parcelRequire("cJFfS");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koVbs = parcelRequire("koVbs");

var $46Cti = parcelRequire("46Cti");

var $k9JTq = parcelRequire("k9JTq");

var $j054R = parcelRequire("j054R");

var $cNd4s = parcelRequire("cNd4s");

var $ldyPw = parcelRequire("ldyPw");

var $3RvHe = parcelRequire("3RvHe");
function $4bdc039a652f8e65$export$c8eca95e306f7116({ onClick: onClick }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const url = '/jira/assets';
    const appEditions = (0, $k9JTq.useAppEditions)();
    const isNotJsmPremium = appEditions.serviceDesk !== (0, $ldyPw.PREMIUM_EDITION);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    if (isNotJsmPremium) {
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'cmdbUpsellPageButton viewed', {
            serviceDeskEdition: appEditions.serviceDesk,
            isSiteAdmin: isSiteAdmin
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j054R.AssetsUpsellButton), {
            configurableMenuId: (0, $46Cti.L1_MENU_ID).GLOBAL_APP_ASSETS,
            lozengeText: formatMessage((0, $3RvHe.default).lozenge)
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cJFfS.LinkMenuItem), {
        href: url,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ggICg))), {
            label: "",
            spacing: "spacious",
            size: "small"
        }),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bfgl4.AssetsIcon), null),
        target: "_blank",
        onClick: onClick,
        testId: "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.ui.assets.menu-link-item"
    }, formatMessage((0, $3RvHe.default).assets));
}

});
parcelRegister("j054R", function(module, exports) {

$parcel$export(module.exports, "AssetsUpsellButton", () => $6d4c03fd42d36bed$export$a04ba1c400e85b23);
$parcel$export(module.exports, "AssetsAppItem", () => $6d4c03fd42d36bed$export$5803e5f720bc19ab);

var $5uXOq = parcelRequire("5uXOq");

var $ggICg = parcelRequire("ggICg");

var $aYAc3 = parcelRequire("aYAc3");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $kR9Jy = parcelRequire("kR9Jy");
var $aBglh = parcelRequire("aBglh");
var $8lfxp = parcelRequire("8lfxp");
var $huQXe = parcelRequire("huQXe");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $24a2m = parcelRequire("24a2m");

var $blEB6 = parcelRequire("blEB6");

var $46Cti = parcelRequire("46Cti");

var $dUyqZ = parcelRequire("dUyqZ");

var $eaKdt = parcelRequire("eaKdt");

var $jhS4y = parcelRequire("jhS4y");

var $5FnJJ = parcelRequire("5FnJJ");

var $bgqtS = parcelRequire("bgqtS");

var $aCS3f = parcelRequire("aCS3f");

var $85JfV = parcelRequire("85JfV");



var $9wUqW = parcelRequire("9wUqW");
const $6d4c03fd42d36bed$var$actionsOnHover = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCS3f.MoreNavMenuButton), {
    MenuItems: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaKdt.HideL1MenuItemSection), {
            menuId: (0, $46Cti.L1_MENU_ID).ASSETS
        })
});
const $6d4c03fd42d36bed$var$linkAnalytics = {
    actionSubjectId: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
    itemId: (0, $jhS4y.MENU_ID_ASSETS),
    level: 1
};
const $6d4c03fd42d36bed$var$upsellButtonAnalytics = {
    ...$6d4c03fd42d36bed$var$linkAnalytics,
    componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147)
};
const $6d4c03fd42d36bed$var$AssetsExternalLink = ()=>{
    const { formattedMessage: assetsMessage, icon: assetsIcon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).ASSETS);
    const { icon: openExternalLinkIcon } = (0, $24a2m.useFormattedMessageAndIcon)((0, $9wUqW.default).openAssetsApp, (0, (/*@__PURE__*/$parcel$interopDefault($ggICg))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        href: (0, $blEB6.getRootPath)(),
        target: "_blank",
        menuId: (0, $jhS4y.MENU_ID_ASSETS),
        analytics: $6d4c03fd42d36bed$var$linkAnalytics,
        elemBefore: assetsIcon,
        elemAfter: openExternalLinkIcon,
        actionsOnHover: $6d4c03fd42d36bed$var$actionsOnHover
    }, assetsMessage);
};
const $6d4c03fd42d36bed$export$a04ba1c400e85b23 = ({ configurableMenuId: configurableMenuId, lozengeText: lozengeText })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const configurableMessageIcon = configurableMenuId ?? (0, $46Cti.L1_MENU_ID).ASSETS;
    const { formattedMessage: assetsMessage, icon: assetsIcon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)(configurableMessageIcon);
    const upsellText = lozengeText ?? formatMessage((0, $9wUqW.default).upsellLozengeText);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bgqtS.default), {
        elemBefore: assetsIcon,
        elemAfter: (0, $4R6GH.fg)('assets_fix_truncation_issue_in_safari') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
            testId: "navigation-apps-sidebar-nav4-sidebars-content-assets.ui.assets-app-item.upsell-lozenge",
            appearance: "new"
        }, upsellText),
        analytics: $6d4c03fd42d36bed$var$upsellButtonAnalytics,
        onClick: ()=>{
            setIsOpen(true);
        },
        actionsOnHover: configurableMessageIcon === (0, $46Cti.L1_MENU_ID).ASSETS ? $6d4c03fd42d36bed$var$actionsOnHover : null,
        testId: "navigation-apps-sidebar-nav4-sidebars-content-assets.ui.assets-app-item.nav-4-menu-button-item"
    }, (0, $4R6GH.fg)('assets_fix_truncation_issue_in_safari') && assetsMessage, !(0, $4R6GH.fg)('assets_fix_truncation_issue_in_safari') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $6d4c03fd42d36bed$var$assetsUpsellButtonStyles
    }, assetsMessage, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
        testId: "navigation-apps-sidebar-nav4-sidebars-content-assets.ui.assets-app-item.upsell-lozenge",
        appearance: "new"
    }, upsellText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kR9Jy.Drawer), {
        isOpen: isOpen,
        onClose: ()=>{
            setIsOpen(false);
        },
        width: "full",
        testId: "navigation-apps-sidebar-nav4-sidebars-content-assets.ui.assets-app-item.drawer",
        label: assetsMessage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $huQXe.DrawerSidebar), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aBglh.DrawerCloseButton), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8lfxp.DrawerContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $85JfV.AsyncCmdbUpsellPage), null))));
};
const $6d4c03fd42d36bed$export$5803e5f720bc19ab = ({ showUpsell: showUpsell })=>{
    if (showUpsell) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6d4c03fd42d36bed$export$a04ba1c400e85b23, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6d4c03fd42d36bed$var$AssetsExternalLink, null);
};
const $6d4c03fd42d36bed$var$assetsUpsellButtonStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'center',
    alignContent: 'center'
});

});
parcelRegister("kR9Jy", function(module, exports) {

$parcel$export(module.exports, "Drawer", () => $8cc91d4f0171e95c$export$4071300121a182f5);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lv4Ny = parcelRequire("lv4Ny");

var $6QvkM = parcelRequire("6QvkM");

var $9MHPe = parcelRequire("9MHPe");
var $fxUuP = parcelRequire("fxUuP");

var $k8nZq = parcelRequire("k8nZq");

var $8gryn = parcelRequire("8gryn");

var $lXqlK = parcelRequire("lXqlK");
// escape close manager for layering
const $8cc91d4f0171e95c$var$EscapeCloseManager = ({ onClose: onClose })=>{
    // wrap so that we can cast the event to a React.KeyboardEvent
    const handleClose = (0, $5uXOq.useCallback)((evt)=>{
        onClose && onClose(evt);
    }, [
        onClose
    ]);
    (0, $fxUuP.useCloseOnEscapePress)({
        onClose: handleClose
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {});
};
const $8cc91d4f0171e95c$export$4071300121a182f5 = ({ width: width = 'narrow', isOpen: isOpen, isFocusLockEnabled: isFocusLockEnabled = true, shouldReturnFocus: shouldReturnFocus = true, autoFocusFirstElem: autoFocusFirstElem = true, onKeyDown: onKeyDown, testId: testId, children: children, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, zIndex: zIndex = 'unset', label: label, titleId: titleId, enterFrom: enterFrom })=>{
    const handleClose = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (evt, analyticsEvent)=>onClose?.(evt, analyticsEvent),
        action: 'dismissed',
        componentName: 'drawer',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: {
            trigger: 'escKey'
        }
    });
    const handleKeyDown = (0, $5uXOq.useCallback)((evt)=>{
        onKeyDown && onKeyDown(evt);
    }, [
        onKeyDown
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isOpen) window.addEventListener('keydown', handleKeyDown);
        return ()=>{
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleKeyDown,
        isOpen
    ]);
    const handleBlanketClick = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (evt, analyticsEvent)=>onClose?.(evt, analyticsEvent),
        action: 'dismissed',
        componentName: 'drawer',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: {
            trigger: 'blanket'
        }
    });
    const handleBackButtonClick = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (evt, analyticsEvent)=>onClose?.(evt, analyticsEvent),
        action: 'dismissed',
        componentName: 'drawer',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: {
            trigger: 'backButton'
        }
    });
    const body = (0, $lv4Ny.canUseDOM) ? document.querySelector('body') : undefined;
    if (!body) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $k8nZq.default), {
        zIndex: zIndex,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8gryn.default), {
                isOpen: isOpen,
                onBlanketClicked: handleBlanketClick,
                testId: testId && `${testId}--blanket`
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lXqlK.DrawerPanel), {
                testId: testId,
                isOpen: isOpen,
                onClose: handleBackButtonClick,
                onCloseComplete: onCloseComplete,
                onOpenComplete: onOpenComplete,
                width: width,
                enterFrom: enterFrom,
                label: label,
                titleId: titleId,
                autoFocusFirstElem: autoFocusFirstElem,
                isFocusLockEnabled: isFocusLockEnabled,
                shouldReturnFocus: shouldReturnFocus,
                children: isOpen ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9MHPe.Layering), {
                    isDisabled: false,
                    children: [
                        children,
                        /*#__PURE__*/ (0, $2OMIu.jsx)($8cc91d4f0171e95c$var$EscapeCloseManager, {
                            onClose: handleClose
                        })
                    ]
                }) : children
            })
        ]
    });
};

});
parcelRegister("8gryn", function(module, exports) {

$parcel$export(module.exports, "default", () => $bff64b63a17e23c4$export$2e2bcd8739ae039);
/* blanket.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("5uXOq");

var $j55bS = parcelRequire("j55bS");

var $35XSW = parcelRequire("35XSW");
var $4uxPN = parcelRequire("4uxPN");
const $bff64b63a17e23c4$var$styles = {
    blanket: "_kqswh2mm"
};
/**
 * A wrapper around `@atlaskit/blanket` that adds a fade in/out transition.
 */ const $bff64b63a17e23c4$var$Blanket = ({ isOpen: isOpen, onBlanketClicked: onBlanketClicked, testId: testId })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $35XSW.default), {
        appear: true,
        children: isOpen && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4uxPN.default), {
            /*
     * The fade out animation uses half the passed duration so it evens out.
     */ duration: "large",
            /**
     * We don't expose this on `FadeIn` but it does get passed down.
     * TODO: figure out how we want to handle this...
     */ // @ts-ignore
            animationTimingFunction: "ease-out",
            children: ({ className: className })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $bff64b63a17e23c4$var$styles.blanket,
                        className
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j55bS.default), {
                        isTinted: true,
                        onBlanketClicked: onBlanketClicked,
                        testId: testId && testId
                    })
                })
        })
    });
};
var $bff64b63a17e23c4$export$2e2bcd8739ae039 = $bff64b63a17e23c4$var$Blanket;

});

parcelRegister("lXqlK", function(module, exports) {

$parcel$export(module.exports, "DrawerPanel", () => $d3ab0b7f345ea266$export$96114a266f19b4d0);
/* drawer-panel.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $35XSW = parcelRequire("35XSW");
var $8Sbj3 = parcelRequire("8Sbj3");

var $csKKl = parcelRequire("csKKl");

var $fcyo0 = parcelRequire("fcyo0");
const $d3ab0b7f345ea266$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $d3ab0b7f345ea266$var$styles = {
    root: "_1reo15vq _18m915vq _1e0c1txw _4t3i1kxc _kqsw1n9t _1pbybfng _bfhk1bhr _1q1l1bhr _152tze3t _1e02ze3t _ect41gqc",
    full: "_1bsbauwl",
    extended: "_1bsb1mwr",
    narrow: "_1bsb1gwv",
    medium: "_1bsb1y37",
    wide: "_1bsb1ogm"
}; /**
    * This wrapper is used to specify separate durations for enter and exit.
    */ 
const $d3ab0b7f345ea266$var$CustomSlideIn = ({ children: children, onFinish: onFinish, enterFrom: enterFrom })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Sbj3.default), {
        animationTimingFunction: "ease-out",
        duration: "small",
        enterFrom: enterFrom,
        exitTo: enterFrom,
        fade: "none",
        onFinish: onFinish,
        children: children
    });
}; /**
    * __Drawer panel__
    */ 
const $d3ab0b7f345ea266$export$96114a266f19b4d0 = ({ children: children, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, testId: testId, isOpen: isOpen, shouldReturnFocus: shouldReturnFocus, autoFocusFirstElem: autoFocusFirstElem, isFocusLockEnabled: isFocusLockEnabled, width: width = 'narrow', label: label, titleId: titleId, enterFrom: enterFrom = 'left' })=>{
    /**
   * A ref to point to our wrapper, passed to `onCloseComplete` and `onOpenComplete` callbacks.
   */ const drawerRef = (0, $5uXOq.useRef)(null);
    const onFinish = (0, $5uXOq.useCallback)((state)=>{
        if (state === 'entering') onOpenComplete?.(drawerRef.current);
        else if (state === 'exiting') onCloseComplete?.(drawerRef.current);
    }, [
        onCloseComplete,
        onOpenComplete
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $35XSW.default), {
        appear: true,
        children: isOpen && /*#__PURE__*/ (0, $2OMIu.jsx)($d3ab0b7f345ea266$var$CustomSlideIn, {
            onFinish: onFinish,
            enterFrom: enterFrom,
            children: ({ className: className })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $fcyo0.default), {
                    autoFocusFirstElem: autoFocusFirstElem,
                    isFocusLockEnabled: isFocusLockEnabled,
                    shouldReturnFocus: shouldReturnFocus,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    , {
                        className: (0, $bwpsq.default)([
                            $d3ab0b7f345ea266$var$styles.root,
                            $d3ab0b7f345ea266$var$styles[width],
                            className
                        ]),
                        "data-testid": testId,
                        ref: drawerRef,
                        "aria-modal": true,
                        role: "dialog",
                        "aria-label": label,
                        "aria-labelledby": titleId,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $csKKl.EnsureIsInsideDrawerContext).Provider, {
                            value: true,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $csKKl.OnCloseContext).Provider, {
                                value: onClose,
                                children: children
                            })
                        })
                    })
                })
        })
    });
};

});
parcelRegister("csKKl", function(module, exports) {

$parcel$export(module.exports, "OnCloseContext", () => $6adc395c21ff5b23$export$7376ab1fc7707bdd);
$parcel$export(module.exports, "useOnClose", () => $6adc395c21ff5b23$export$c2b12c82f332a6fb);
$parcel$export(module.exports, "EnsureIsInsideDrawerContext", () => $6adc395c21ff5b23$export$e3662b8677049786);
$parcel$export(module.exports, "useEnsureIsInsideDrawer", () => $6adc395c21ff5b23$export$780b9799f6bfecd8);

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");
const $6adc395c21ff5b23$export$7376ab1fc7707bdd = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $6adc395c21ff5b23$export$c2b12c82f332a6fb = ()=>(0, $5uXOq.useContext)($6adc395c21ff5b23$export$7376ab1fc7707bdd);
const $6adc395c21ff5b23$export$e3662b8677049786 = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
const $6adc395c21ff5b23$export$780b9799f6bfecd8 = ()=>{
    const context = (0, $5uXOq.useContext)($6adc395c21ff5b23$export$e3662b8677049786);
    (0, $3joPi.default)(context, 'Drawer sub-components must be used within a Drawer component.');
};

});

parcelRegister("fcyo0", function(module, exports) {

$parcel$export(module.exports, "default", () => $968f0a3ee512d4eb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ao4Ml = parcelRequire("ao4Ml");
/**
 * __Focus lock__
 *
 * Thin wrapper around react-focus-lock.
 */ const $968f0a3ee512d4eb$var$FocusLock = ({ isFocusLockEnabled: isFocusLockEnabled = true, autoFocusFirstElem: autoFocusFirstElem = true, shouldReturnFocus: shouldReturnFocus = true, children: children })=>{
    const getFocusTarget = ()=>{
        if (typeof shouldReturnFocus === 'boolean') return shouldReturnFocus;
        return false;
    };
    const onDeactivation = ()=>{
        if (typeof shouldReturnFocus !== 'boolean') window.setTimeout(()=>{
            shouldReturnFocus?.current?.focus();
        }, 0);
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ao4Ml.default), {
        disabled: !isFocusLockEnabled,
        autoFocus: autoFocusFirstElem,
        returnFocus: getFocusTarget(),
        onDeactivation: onDeactivation,
        children: children
    });
};
var $968f0a3ee512d4eb$export$2e2bcd8739ae039 = $968f0a3ee512d4eb$var$FocusLock;

});



parcelRegister("aBglh", function(module, exports) {

$parcel$export(module.exports, "DrawerCloseButton", () => $39d010c8d088d9dc$export$d0c3a75c17ac0cab);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $bu8Mq = parcelRequire("bu8Mq");

var $csKKl = parcelRequire("csKKl");
const $39d010c8d088d9dc$export$d0c3a75c17ac0cab = ({ icon: Icon, label: label = 'Close drawer', testId: testId = 'DrawerCloseButton' })=>{
    (0, $csKKl.useEnsureIsInsideDrawer)();
    const onClose = (0, $csKKl.useOnClose)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
        onClick: onClose,
        testId: testId,
        icon: Icon ? (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                ...iconProps,
                size: "large",
                LEGACY_size: "large"
            }) : (0, (/*@__PURE__*/$parcel$interopDefault($bu8Mq))),
        label: label,
        shape: "circle",
        appearance: "subtle"
    });
};

});

parcelRegister("8lfxp", function(module, exports) {

$parcel$export(module.exports, "DrawerContent", () => $79b1ef7a23ca4954$export$57ca055474bc0056);
/* drawer-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2alJM = parcelRequire("2alJM");

var $bWn3s = parcelRequire("bWn3s");

var $csKKl = parcelRequire("csKKl");

var $dzfjD = parcelRequire("dzfjD");
const $79b1ef7a23ca4954$var$styles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo1wug _18m91wug _19pk1ejb"
};
const $79b1ef7a23ca4954$var$DrawerContentBase = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, scrollContentLabel: scrollContentLabel = 'Scrollable content', xcss: xcss }, scrollableRef)=>{
    const [showContentFocus, setContentFocus] = (0, $5uXOq.useState)(false);
    const ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        const setLazyContentFocus = ()=>{
            const target = ref.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        };
        setLazyContentFocus();
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            $79b1ef7a23ca4954$var$styles.default,
            xcss
        ]),
        ref: (0, $bWn3s.mergeRefs)([
            ref,
            scrollableRef
        ]),
        // tabindex is allowed here so that keyboard users can scroll content
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? scrollContentLabel : undefined,
        "data-testid": "drawer-contents",
        children: children
    });
});
const $79b1ef7a23ca4954$export$57ca055474bc0056 = ({ children: children, scrollContentLabel: scrollContentLabel, xcss: xcss })=>{
    (0, $csKKl.useEnsureIsInsideDrawer)();
    (0, $dzfjD.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2alJM))), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($79b1ef7a23ca4954$var$DrawerContentBase, {
            scrollContentLabel: scrollContentLabel,
            xcss: xcss,
            children: children
        })
    });
};

});
parcelRegister("dzfjD", function(module, exports) {

$parcel$export(module.exports, "default", () => $23e44d51b0fd4216$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 * ⚠️ This is copied from `packages/design-system/modal-dialog/src/internal/hooks/use-prevent-programmatic-scroll.tsx`
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $23e44d51b0fd4216$var$getScrollDistance() {
    return window.pageYOffset || document.documentElement?.scrollTop || document.body?.scrollTop || 0;
}
function $23e44d51b0fd4216$export$2e2bcd8739ae039() {
    const [scrollTopOffset, setScrollTopOffset] = (0, $5uXOq.useState)(0);
    (0, $5uXOq.useLayoutEffect)(()=>{
        setScrollTopOffset($23e44d51b0fd4216$var$getScrollDistance());
    }, []);
    const onWindowScroll = (0, $5uXOq.useCallback)(()=>{
        if ($23e44d51b0fd4216$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $5uXOq.useEffect)(()=>{
        return (0, $cBeZP.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});


parcelRegister("huQXe", function(module, exports) {

$parcel$export(module.exports, "DrawerSidebar", () => $7a1196a3ddd27e0f$export$25c48648e7980210);
/* drawer-sidebar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $csKKl = parcelRequire("csKKl");
const $7a1196a3ddd27e0f$var$styles = {
    default: "_4cvr1h6o _vchhusvi _syaz1gjq _1e0c1txw _1o9zidpf _2lx21bp4 _4t3i1kxc _n3tdpxbi _ca0q1ejb _1bsbxncg"
};
const $7a1196a3ddd27e0f$export$25c48648e7980210 = ({ children: children, xcss: xcss })=>{
    (0, $csKKl.useEnsureIsInsideDrawer)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            $7a1196a3ddd27e0f$var$styles.default,
            xcss
        ]),
        "data-testid": "drawer-sidebar",
        children: children
    });
};

});

parcelRegister("blEB6", function(module, exports) {

$parcel$export(module.exports, "ASSETS_APP_ROUTE_PREFIX", () => $587a2dd53fdae2e8$export$42e57fb76a904fc3);
$parcel$export(module.exports, "isInsightRoute", () => $587a2dd53fdae2e8$export$296d80f3ce129968);
$parcel$export(module.exports, "getCreateServiceUrl", () => $587a2dd53fdae2e8$export$1f9b8b558a361aaf);
$parcel$export(module.exports, "getRootPath", () => $587a2dd53fdae2e8$export$5413f45d031c7806);
$parcel$export(module.exports, "getLandingPageUrl", () => $587a2dd53fdae2e8$export$9366da5a373815e5);
$parcel$export(module.exports, "getGlobalConfigUrl", () => $587a2dd53fdae2e8$export$20fd4a0aec335970);
$parcel$export(module.exports, "getDataManagerUrl", () => $587a2dd53fdae2e8$export$c9b27b0d2e19d52f);
$parcel$export(module.exports, "getDataManagerGettingStartedUrl", () => $587a2dd53fdae2e8$export$3d0380185f73b3d);
$parcel$export(module.exports, "getDataManagerObjectClassesUrl", () => $587a2dd53fdae2e8$export$4c9768bc51c7a1a);
$parcel$export(module.exports, "getDataManagerVisualizationUrl", () => $587a2dd53fdae2e8$export$6c3cb6f103b2324);
$parcel$export(module.exports, "getDataManagerAdaptersUrl", () => $587a2dd53fdae2e8$export$cd6b35373ba077a);
$parcel$export(module.exports, "getAssetsReportsUrl", () => $587a2dd53fdae2e8$export$c1909404b7ea317f);
$parcel$export(module.exports, "getAssetsReportUrl", () => $587a2dd53fdae2e8$export$272d35cbff1c220e);
$parcel$export(module.exports, "getAssetsSearchResultsUrl", () => $587a2dd53fdae2e8$export$97bfda8f5f38a121);
$parcel$export(module.exports, "createObjectSchemasUrl", () => $587a2dd53fdae2e8$export$c48ea1282c74411e);
$parcel$export(module.exports, "createObjectSchemaUrl", () => $587a2dd53fdae2e8$export$3a0332e980fe56cf);
$parcel$export(module.exports, "createObjectTypeUrl", () => $587a2dd53fdae2e8$export$cfefb90cfb86b528);
$parcel$export(module.exports, "createObjectSchemaConfigUrl", () => $587a2dd53fdae2e8$export$f02479149ce3cac7);
$parcel$export(module.exports, "createObjectDetailUrl", () => $587a2dd53fdae2e8$export$51e4229f2c7d3866);
$parcel$export(module.exports, "createObjectTypeSettingsUrl", () => $587a2dd53fdae2e8$export$4b4b7d2c3df4fa58);
$parcel$export(module.exports, "createObjectTypeListWithObjectSelectedUrl", () => $587a2dd53fdae2e8$export$c1790fa8f0d8e89a);
$parcel$export(module.exports, "getFeatureUsagePageUrl", () => $587a2dd53fdae2e8$export$5ba89eed0cf60033);
$parcel$export(module.exports, "getFeatureUsageVirtualAgentPageUrl", () => $587a2dd53fdae2e8$export$415502b49e27270d);

var $ebyGx = parcelRequire("ebyGx");

var $4R6GH = parcelRequire("4R6GH");

var $9PhlU = parcelRequire("9PhlU");
const $587a2dd53fdae2e8$export$ee637ecb2dfa4f6a = '/jira/servicedesk/service-modal';
const $587a2dd53fdae2e8$export$42e57fb76a904fc3 = '/jira/assets';
const $587a2dd53fdae2e8$export$80e512187a5e0d10 = '/jira/servicedesk/assets';
const $587a2dd53fdae2e8$export$6d7574dbda22cf7 = '/jira/servicedesk/insight';
const $587a2dd53fdae2e8$export$296d80f3ce129968 = (pathname)=>pathname.includes($587a2dd53fdae2e8$export$6d7574dbda22cf7);
const $587a2dd53fdae2e8$export$1f9b8b558a361aaf = ()=>$587a2dd53fdae2e8$export$ee637ecb2dfa4f6a;
const $587a2dd53fdae2e8$export$5413f45d031c7806 = ()=>(0, $4R6GH.fg)('assets_as_an_app_v2') ? $587a2dd53fdae2e8$export$42e57fb76a904fc3 : $587a2dd53fdae2e8$export$80e512187a5e0d10;
const $587a2dd53fdae2e8$export$9366da5a373815e5 = ()=>$587a2dd53fdae2e8$export$5413f45d031c7806();
const $587a2dd53fdae2e8$export$20fd4a0aec335970 = ()=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/configure/global`;
const $587a2dd53fdae2e8$export$c9b27b0d2e19d52f = ()=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/data-manager/`;
const $587a2dd53fdae2e8$export$3d0380185f73b3d = ()=>`${$587a2dd53fdae2e8$export$42e57fb76a904fc3}/data-manager/getting-started`;
const $587a2dd53fdae2e8$export$4c9768bc51c7a1a = ()=>`${$587a2dd53fdae2e8$export$42e57fb76a904fc3}/data-manager/object-classes`;
const $587a2dd53fdae2e8$export$6c3cb6f103b2324 = ()=>`${$587a2dd53fdae2e8$export$42e57fb76a904fc3}/data-manager/#/dashboards`;
const $587a2dd53fdae2e8$export$cd6b35373ba077a = ()=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/data-manager/adapters/`;
const $587a2dd53fdae2e8$export$c1909404b7ea317f = ()=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/reports`;
const $587a2dd53fdae2e8$export$272d35cbff1c220e = (reportId)=>`${$587a2dd53fdae2e8$export$c1909404b7ea317f()}/${reportId}`;
const $587a2dd53fdae2e8$export$97bfda8f5f38a121 = (query)=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/search${query ? `?${query}` : ''}`;
const $587a2dd53fdae2e8$export$c48ea1282c74411e = ()=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/object-schemas`;
const $587a2dd53fdae2e8$export$3a0332e980fe56cf = (objectSchemaId)=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/object-schema/${objectSchemaId}`;
const $587a2dd53fdae2e8$export$cfefb90cfb86b528 = (objectSchemaId, objectTypeId)=>`${$587a2dd53fdae2e8$export$3a0332e980fe56cf(objectSchemaId)}?${(0, $9PhlU.SCHEMA_PAGE_QUERY_PARAMS).objectTypeId}=${objectTypeId}`;
const $587a2dd53fdae2e8$export$f02479149ce3cac7 = (objectSchemaId)=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/configure/object-schema/${objectSchemaId}`;
const $587a2dd53fdae2e8$export$51e4229f2c7d3866 = (objectId)=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/object/${objectId}`;
const $587a2dd53fdae2e8$export$4b4b7d2c3df4fa58 = (objectTypeId)=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/configure/object-type/${objectTypeId}`;
const $587a2dd53fdae2e8$export$c1790fa8f0d8e89a = (objectSchemaId, objectTypeId, objectId)=>`${$587a2dd53fdae2e8$export$cfefb90cfb86b528(objectSchemaId, objectTypeId)}&view=list&objectId=${objectId}`;
const $587a2dd53fdae2e8$export$6e21e6efe57484c5 = (queryParams = {})=>{
    const base = `${$587a2dd53fdae2e8$export$42e57fb76a904fc3}/search`;
    if (Object.keys(queryParams).length > 0) {
        const encodedParams = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(queryParams);
        return `${base}?${encodedParams}`;
    }
    return base;
};
const $587a2dd53fdae2e8$export$5ba89eed0cf60033 = ({ showChangeLimitModal: showChangeLimitModal } = {})=>`/jira/settings/products/servicedesk/feature-usage?feature=assets${showChangeLimitModal ? '&changeLimit=true' : ''}`;
const $587a2dd53fdae2e8$export$415502b49e27270d = ({ showChangeLimitModal: showChangeLimitModal } = {})=>`/jira/settings/products/servicedesk/feature-usage?feature=virtual-agent${showChangeLimitModal ? '&changeLimit=true' : ''}`;

});
parcelRegister("9PhlU", function(module, exports) {

$parcel$export(module.exports, "SCHEMA_PAGE_QUERY_PARAMS", () => $dee65df3d835c7b2$export$a73deb42718b5c4);
$parcel$export(module.exports, "TAB_QUERY_PARAM_REFERENCE_TYPES", () => $dee65df3d835c7b2$export$f7855185bab37329);
$parcel$export(module.exports, "TAB_QUERY_PARAM_STATUSES", () => $dee65df3d835c7b2$export$3739ebbc7c6e87e8);
$parcel$export(module.exports, "TAB_QUERY_PARAM_ICONS", () => $dee65df3d835c7b2$export$2c22dc6c729ae0bd);
$parcel$export(module.exports, "TAB_QUERY_PARAM_DATA_MANAGER", () => $dee65df3d835c7b2$export$f37b3a97acf56eaf);
$parcel$export(module.exports, "TAB_QUERY_PARAM_GENERAL", () => $dee65df3d835c7b2$export$12ebb1d5017e1d6d);
$parcel$export(module.exports, "TAB_QUERY_PARAM_ROLES", () => $dee65df3d835c7b2$export$a77734d9ea30fe44);
$parcel$export(module.exports, "TAB_QUERY_PARAM_IMPORT", () => $dee65df3d835c7b2$export$be37b820df30c947);
$parcel$export(module.exports, "TAB_QUERY_PARAM_INHERITANCE", () => $dee65df3d835c7b2$export$670faa8ae93e0903);
$parcel$export(module.exports, "useUpdateQueryParams", () => $dee65df3d835c7b2$export$e66acc5f4583ce1c);
$parcel$export(module.exports, "useObjectTypeIdQueryParam", () => $dee65df3d835c7b2$export$f5a33d51dd6de08);
$parcel$export(module.exports, "useObjectIdQueryParam", () => $dee65df3d835c7b2$export$a6e3187c87554a1e);
$parcel$export(module.exports, "useSchemaViewModeQueryParam", () => $dee65df3d835c7b2$export$6abda0ad26022eff);
$parcel$export(module.exports, "useObjectViewModeQueryParam", () => $dee65df3d835c7b2$export$1927b50f7d074492);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $5Ny9E = parcelRequire("5Ny9E");

var $ieDtd = parcelRequire("ieDtd");
var $doZTA = parcelRequire("doZTA");
var $lVJAU = parcelRequire("lVJAU");
const $dee65df3d835c7b2$export$a73deb42718b5c4 = {
    // Values are 'object' or 'attribute'
    schemaMode: 'mode',
    // Values are 'list' or undefined
    objectViewMode: 'view',
    // Both of these params are supported to set the object type ID. 'typeId' is preferred and is the one that is updated.
    // 'objecttypeid' is only used on initial load to support customers who have bookmarked this URL.
    objectTypeId: 'typeId',
    fallbackObjectTypeId: 'objecttypeid',
    objectId: 'objectId'
};
const $dee65df3d835c7b2$export$f7855185bab37329 = 'reference-types';
const $dee65df3d835c7b2$export$3739ebbc7c6e87e8 = 'statuses';
const $dee65df3d835c7b2$export$2c22dc6c729ae0bd = 'icons';
const $dee65df3d835c7b2$export$f37b3a97acf56eaf = 'data-manager';
const $dee65df3d835c7b2$export$12ebb1d5017e1d6d = 'general';
const $dee65df3d835c7b2$export$a77734d9ea30fe44 = 'roles';
const $dee65df3d835c7b2$export$be37b820df30c947 = 'import';
const $dee65df3d835c7b2$export$670faa8ae93e0903 = 'inheritance';
const $dee65df3d835c7b2$export$e66acc5f4583ce1c = ()=>{
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const [{ location: location }] = (0, $doZTA.useRouter)();
    const updateQueryParams = (0, $5uXOq.useCallback)((queryParams = {})=>{
        const { pathname: pathname, search: search } = location;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedQueryParams = {};
        Object.keys(queryParams).forEach((key)=>{
            updatedQueryParams[key] = queryParams[key] ?? undefined;
        });
        return `${pathname}?${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
            ...(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(search),
            ...updatedQueryParams
        })}`;
    }, [
        location
    ]);
    const pushRouterAction = (0, $5uXOq.useCallback)((path)=>{
        push(path);
    }, [
        push
    ]);
    return [
        {
            updateQueryParams: updateQueryParams,
            pushRouterAction: pushRouterAction
        }
    ];
};
const $dee65df3d835c7b2$export$f5a33d51dd6de08 = ()=>{
    const [objectTypeId, setObjectTypeId] = (0, $ieDtd.useQueryParam)($dee65df3d835c7b2$export$a73deb42718b5c4.objectTypeId);
    const [fallbackObjectTypeId, setFallbackObjectTypeId] = (0, $ieDtd.useQueryParam)($dee65df3d835c7b2$export$a73deb42718b5c4.fallbackObjectTypeId);
    (0, $5uXOq.useEffect)(()=>{
        if (fallbackObjectTypeId !== undefined) {
            setObjectTypeId((0, $5Ny9E.toCmdbObjectTypeId)(fallbackObjectTypeId), 'replace');
            setFallbackObjectTypeId(undefined, 'replace');
        }
    }, [
        fallbackObjectTypeId,
        setObjectTypeId,
        setFallbackObjectTypeId
    ]);
    const nullableMain = objectTypeId !== undefined ? (0, $5Ny9E.toCmdbObjectTypeId)(objectTypeId) : null;
    const nullableFallback = fallbackObjectTypeId !== undefined ? (0, $5Ny9E.toCmdbObjectTypeId)(fallbackObjectTypeId) : null;
    const setter = (newObjectTypeId, updateType)=>{
        setObjectTypeId(newObjectTypeId !== null ? newObjectTypeId : undefined, updateType);
    };
    return [
        nullableMain !== null ? nullableMain : nullableFallback,
        setter
    ];
};
const $dee65df3d835c7b2$export$a6e3187c87554a1e = ()=>{
    const [objectId, setObjectId] = (0, $ieDtd.useQueryParam)($dee65df3d835c7b2$export$a73deb42718b5c4.objectId);
    const nullableObjectId = objectId !== undefined ? (0, $5Ny9E.toCmdbObjectId)(objectId) : null;
    const setter = (newObjectId, updateType)=>{
        setObjectId(newObjectId !== null ? newObjectId : undefined, updateType);
    };
    return [
        nullableObjectId,
        setter
    ];
};
const $dee65df3d835c7b2$export$6abda0ad26022eff = ()=>{
    const [rawParamValue, setSchemaMode] = (0, $ieDtd.useQueryParam)($dee65df3d835c7b2$export$a73deb42718b5c4.schemaMode);
    const schemaMode = rawParamValue === 'attribute' ? 'attribute' : 'object';
    return [
        schemaMode,
        setSchemaMode
    ];
};
const $dee65df3d835c7b2$export$1927b50f7d074492 = ()=>{
    const [rawParamValue, setObjectViewMode] = (0, $ieDtd.useQueryParam)($dee65df3d835c7b2$export$a73deb42718b5c4.objectViewMode);
    const objectViewMode = rawParamValue === 'list' ? 'list' : 'details';
    const setter = (newValue, updateMode)=>{
        setObjectViewMode(newValue === 'list' ? 'list' : undefined, updateMode);
    };
    return [
        objectViewMode,
        setter
    ];
};

});


parcelRegister("eaKdt", function(module, exports) {

$parcel$export(module.exports, "HideL1MenuItemSection", () => $6a7321776d8332cb$export$a6246d2fccf72824);

var $bcArA = parcelRequire("bcArA");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $kJpBP = parcelRequire("kJpBP");
var $9UCCQ = parcelRequire("9UCCQ");

var $dS3PR = parcelRequire("dS3PR");

var $fraBZ = parcelRequire("fraBZ");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");




var $jecJ3 = parcelRequire("jecJ3");

var $ivGSs = parcelRequire("ivGSs");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $8zOmE = parcelRequire("8zOmE");

var $koeKL = parcelRequire("koeKL");

var $4R6GH = parcelRequire("4R6GH");

var $iszzG = parcelRequire("iszzG");

var $fS0Tg = parcelRequire("fS0Tg");

var $bMQWP = parcelRequire("bMQWP");

var $ji6RV = parcelRequire("ji6RV");
const $6a7321776d8332cb$var$HIDE_ROOT_MENU_ITEM_SUCCESS = 'HIDE_ROOT_MENU_ITEM_SUCCESS';
const $6a7321776d8332cb$var$RESTORE_ROOT_MENU_ITEM_SUCCESS = 'RESTORE_ROOT_MENU_ITEM_SUCCESS';
function $6a7321776d8332cb$var$HideL1MenuItemSectionInner(props) {
    const { menuId: menuId } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { navItems: navItems } = (0, $5uXOq.useContext)((0, $iszzG.NavItemsContext));
    const { peekMenuId: peekMenuId } = (0, $5uXOq.useContext)((0, $iszzG.PeekMenuIdContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const cloudID = (0, $koeKL.useCloudId)();
    const [isHidden, setIsHidden] = (0, $5uXOq.useState)(false);
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const [commit] = (0, $8Uumt.useMutation)((0, $bcArA.default));
    const onSave = (0, $5uXOq.useCallback)((newNavItems)=>{
        commit({
            variables: {
                input: {
                    cloudID: cloudID,
                    navKey: 'NAV_SIDEBAR',
                    navItems: newNavItems
                }
            }
        });
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'sidebarNavItems changed', {
            originalNavItems: navItems,
            updatedNavItems: newNavItems,
            changedFrom: 'hideFromSidebarButton'
        });
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[menuId],
            attributes: {
                level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                componentType: (0, $1e554a683893bd46$export$17bca95234dea43b),
                parentItemId: (0, $jecJ3.SECTION_ITEM_MAP)[menuId],
                itemId: 'hideFromSidebar'
            }
        });
    }, [
        cloudID,
        commit,
        createAnalyticsEvent,
        menuId,
        navItems
    ]);
    const toggleNavItemVisibility = (0, $5uXOq.useCallback)(({ isVisible: isVisible })=>{
        const newNavItems = navItems.map((item)=>{
            if (item.menuId === menuId) return {
                ...item,
                isVisible: isVisible
            };
            return {
                ...item
            };
        });
        return newNavItems;
    }, [
        menuId,
        navItems
    ]);
    const onRestoreRootMenuItem = ()=>{
        if (navItems !== undefined) {
            const newNavItems = toggleNavItemVisibility({
                isVisible: true
            });
            onSave(newNavItems);
            setIsHidden(false);
            showFlag({
                type: 'success',
                id: $6a7321776d8332cb$var$RESTORE_ROOT_MENU_ITEM_SUCCESS,
                title: (0, $ji6RV.getNavItemRestoredFromSideBarFlagTitle)(menuId),
                isAutoDismiss: true,
                messageId: 'navigation-apps-sidebar-nav4-sidebars-common-core.ui.hide-l1-menu-item-action.show-flag.success.restore-root-menu-item-success',
                messageType: 'transactional'
            });
        }
    };
    const onHideRootMenuItem = ()=>{
        if (navItems !== undefined) {
            const newNavItems = toggleNavItemVisibility({
                isVisible: false
            });
            onSave(newNavItems);
            setIsHidden(true);
            showFlag({
                type: 'success',
                id: $6a7321776d8332cb$var$HIDE_ROOT_MENU_ITEM_SUCCESS,
                title: (0, $ji6RV.getNavItemHiddenFromSideBarFlagTitle)(menuId),
                isAutoDismiss: true,
                messageId: 'navigation-apps-sidebar-nav4-sidebars-common-core.ui.hide-l1-menu-item-action.show-flag.success.hide-root-menu-item-success',
                messageType: 'transactional',
                actions: [
                    {
                        content: (0, $bMQWP.default).moveBackToSidebar,
                        onClick: ()=>{
                            onRestoreRootMenuItem();
                            dismissFlag($6a7321776d8332cb$var$HIDE_ROOT_MENU_ITEM_SUCCESS);
                        }
                    }
                ]
            });
        }
    };
    // When the peekend menu id is the same as the menu id, the menu item is disabled because it's not possible
    // to hide an already hidden menu item. Do indicate this we need to both disable the button and set the color
    // of the icon and text appropriately.
    const isDisabled = peekMenuId === menuId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fraBZ.AnnouncerV2), {
        message: formatMessage((0, $ji6RV.getA11YAlert)(menuId)),
        shouldAnnounce: isHidden
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        interactionName: (0, $4R6GH.fg)('blu-7837_apply_presstrace_nav4') ? 'nav4-sidebar-hide-from-sidebar-button' : undefined,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fS0Tg.HideIcon), {
            label: "",
            primaryColor: isDisabled ? 'color.icon.disabled' : 'color.icon'
        }),
        onClick: onHideRootMenuItem,
        isDisabled: isDisabled,
        "aria-label": formatMessage((0, $ji6RV.getA11YLabel)(menuId))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        color: isDisabled ? 'color.text.disabled' : 'color.text'
    }, formatMessage((0, $bMQWP.default).hideFromSidebar))));
}
function $6a7321776d8332cb$export$a6246d2fccf72824(props) {
    const { hasSeparator: hasSeparator = true, hasSection: hasSection = true } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: (0, $e0b5a9368b34b1c5$export$a3821bc63538b210),
        sourceType: (0, $4d5e0871c06cee03$export$d1123261ca8831d2),
        containerId: (0, $e0b5a9368b34b1c5$export$3c19576bd92ff564),
        containerType: (0, $e0b5a9368b34b1c5$export$fba7c3adda5094d9)
    }, hasSection ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        hasSeparator: hasSeparator
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6a7321776d8332cb$var$HideL1MenuItemSectionInner, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6a7321776d8332cb$var$HideL1MenuItemSectionInner, props));
}

});
parcelRegister("bcArA", function(module, exports) {

$parcel$export(module.exports, "default", () => $6858b1c2ad9da191$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<051e81191e9528d0339140ee7536941d>>
 * @relayHash 66baa10107c8516c24b8ed85cb97aa27
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b23a1defc70b85ce697c0dc1d84377c11fe03c64d3dbd4d0cb309c2158ac9e77
const $6858b1c2ad9da191$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "JiraConfigurableNavigationItem",
        "kind": "LinkedField",
        "name": "navItems",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "menuId"
            },
            {
                "kind": "ScalarField",
                "name": "isVisible"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "hideL1MenuItemActionMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUserNavigationConfigurationPayload",
                            "kind": "LinkedField",
                            "name": "updateUserNavigationConfiguration",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraUserNavigationConfiguration",
                                    "kind": "LinkedField",
                                    "name": "userNavigationConfiguration",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "hideL1MenuItemActionMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUserNavigationConfigurationPayload",
                            "kind": "LinkedField",
                            "name": "updateUserNavigationConfiguration",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraUserNavigationConfiguration",
                                    "kind": "LinkedField",
                                    "name": "userNavigationConfiguration",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b23a1defc70b85ce697c0dc1d84377c11fe03c64d3dbd4d0cb309c2158ac9e77",
            "metadata": {},
            "name": "hideL1MenuItemActionMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$6858b1c2ad9da191$var$node.hash = "1b96ba09e281b673ec1bfa126587621b";
var $6858b1c2ad9da191$export$2e2bcd8739ae039 = $6858b1c2ad9da191$var$node;

});

parcelRegister("fraBZ", function(module, exports) {

$parcel$export(module.exports, "AnnouncerV2", () => $f73a83ae5cba96ea$export$a43c8a2f4981e0e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dqoiX = parcelRequire("dqoiX");
const $f73a83ae5cba96ea$var$NON_BREAKING_SPACE = '\u00A0';
const $f73a83ae5cba96ea$export$a43c8a2f4981e0e = /*#__PURE__*/ (0, $5uXOq.memo)(({ message: originalMessage, liveMode: liveMode = 'polite', shouldAnnounce: shouldAnnounce = true, testId: testId })=>{
    const previousMessage = (0, $5uXOq.useRef)('');
    const setAlternatePolite = (0, $5uXOq.useRef)(false);
    const addSuffix = (0, $5uXOq.useRef)(false);
    const [oldMessage, setOldMessage] = (0, $5uXOq.useState)('');
    const [newMessage, setNewMessage] = (0, $5uXOq.useState)('');
    (0, $5uXOq.useEffect)(()=>{
        let message = shouldAnnounce ? originalMessage : $f73a83ae5cba96ea$var$NON_BREAKING_SPACE;
        if (previousMessage.current === message) {
            addSuffix.current = !addSuffix.current;
            if (addSuffix.current) message += $f73a83ae5cba96ea$var$NON_BREAKING_SPACE;
        }
        setOldMessage(setAlternatePolite.current ? '' : message);
        setNewMessage(setAlternatePolite.current ? message : '');
        if (shouldAnnounce) setAlternatePolite.current = !setAlternatePolite.current;
        previousMessage.current = originalMessage;
    }, [
        originalMessage,
        shouldAnnounce
    ]);
    // 2 aria-live containers needed to prevent bugs in browsers that will stop
    // announcing updates to the same div if these are too repetitive.
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_kqswh2mm"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $dqoiX.ScreenReaderText), {
        role: "status",
        "aria-live": liveMode,
        "aria-relevant": "additions text",
        "aria-atomic": "true"
    }, oldMessage), /*#__PURE__*/ $5uXOq.createElement((0, $dqoiX.ScreenReaderText), {
        role: "status",
        "aria-live": liveMode,
        "aria-relevant": "additions text",
        "aria-atomic": "true"
    }, newMessage));
});
const $f73a83ae5cba96ea$var$positionRelative = null;

});
parcelRegister("dqoiX", function(module, exports) {

$parcel$export(module.exports, "visuallyHiddenStyles", () => $11827e0613b04108$export$8dd524ceb40e3d16);
$parcel$export(module.exports, "ScreenReaderText", () => $11827e0613b04108$export$88fad6aa294f111c);
$parcel$export(module.exports, "ScreenReaderCaption", () => $11827e0613b04108$export$200c8e5d652aa9af);
$parcel$export(module.exports, "ScreenReaderLegend", () => $11827e0613b04108$export$dabfb48aa98ffd97);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * Visible only to screenreaders. Use when there is a need
 * to provide more context to a non-sighted user.
 * Styled copied from @atlaskit/visually-hidden
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $11827e0613b04108$export$8dd524ceb40e3d16 = {
    width: '1px',
    height: '1px',
    padding: 0,
    position: 'absolute',
    border: '0',
    clip: 'rect(1px, 1px, 1px, 1px)',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
};
const $11827e0613b04108$export$88fad6aa294f111c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c",
            __cmplp.className
        ])
    });
});
const $11827e0613b04108$export$200c8e5d652aa9af = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "caption", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c",
            __cmplp.className
        ])
    });
});
const $11827e0613b04108$export$dabfb48aa98ffd97 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "legend", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c",
            __cmplp.className
        ])
    });
});

});


const $1e554a683893bd46$export$4165a3d0da3bd147 = 'fixedItem';
const $1e554a683893bd46$export$95b0c331af13d819 = 'fixedItemButton';
const $1e554a683893bd46$export$74712b62056d422e = 'fixedItemAction';
const $1e554a683893bd46$export$3ac911b122986477 = 'customItem';
const $1e554a683893bd46$export$9bd6c21d500ae611 = 'customItemButton';
const $1e554a683893bd46$export$5374c2c2d3ece55e = 'customItemAction';
const $1e554a683893bd46$export$56981f28056f258e = 'customItemDropdownAction';
const $1e554a683893bd46$export$17bca95234dea43b = 'fixedItemDropdownAction';

const $e0b5a9368b34b1c5$export$a3821bc63538b210 = 'customiseSidebar';
const $e0b5a9368b34b1c5$export$fba7c3adda5094d9 = 'sidebar-nav4';
const $e0b5a9368b34b1c5$export$3c19576bd92ff564 = 'sidebar-content';

const $951a0ed422513987$export$265c523d1a8f25cf = '1';
const $951a0ed422513987$export$fe3b012b0224e4e1 = '2';
const $951a0ed422513987$export$f9db6a58b4aabd18 = '3';
const $951a0ed422513987$export$35ac629b8b943d5a = '4';

parcelRegister("ivGSs", function(module, exports) {

$parcel$export(module.exports, "getSideNavToggleButtonAnalyticEventPayload", () => $968dc7093f3ba590$export$7165a1ebf1926b86);
$parcel$export(module.exports, "MENU_ID_ANALYTIC_EVENT_IDS", () => $968dc7093f3ba590$export$d70e7a5f39328991);

var $jhS4y = parcelRequire("jhS4y");





var $jecJ3 = parcelRequire("jecJ3");
const $968dc7093f3ba590$var$SIDEBAR_TOGGLE = 'sidebarToggle';
const $968dc7093f3ba590$var$SIDEBAR_TOGGLE_ACTION_COLLAPSE = 'collapse';
const $968dc7093f3ba590$var$SIDEBAR_TOGGLE_ACTION_EXPAND = 'expand';
const $968dc7093f3ba590$var$CLICKED = 'clicked';
const $968dc7093f3ba590$export$7165a1ebf1926b86 = (isSideNavVisible, stage)=>{
    const toggleAction = isSideNavVisible ? $968dc7093f3ba590$var$SIDEBAR_TOGGLE_ACTION_COLLAPSE : $968dc7093f3ba590$var$SIDEBAR_TOGGLE_ACTION_EXPAND;
    const payload = {
        action: $968dc7093f3ba590$var$CLICKED,
        actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
        actionSubjectId: $968dc7093f3ba590$var$SIDEBAR_TOGGLE,
        attributes: {
            navigationLayer: (0, $ce9c0831aed9ffb3$export$17ff3f7e02c6ac22),
            navigationContainer: (0, $68cb678dc917978e$export$793ed84f5e13fedc),
            stage: stage,
            navState: (0, $1520d876660a71bd$export$2bd315ece9f68967),
            toggleAction: toggleAction
        }
    };
    return payload;
};
const $968dc7093f3ba590$export$d70e7a5f39328991 = {
    [(0, $jhS4y.MENU_ID_APPS)]: 'appsNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_ASSETS)]: 'assetsNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_DASHBOARDS)]: 'dashboardsNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_FILTERS)]: 'filtersNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_GOALS)]: 'goalsNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_OPERATIONS)]: 'operationsNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_OVERVIEWS)]: 'overviewsNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_COMMUNICATION)]: 'communivationsNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_PLANS)]: 'plansNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_PROJECTS)]: 'projectsNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_RECENT)]: 'recentNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_STARRED)]: 'starredNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_TEAMS)]: 'teamsNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_ROADMAPS)]: 'roadmapsNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_CUSTOMER_SERVICE)]: 'customerServiceMenuItem',
    [(0, $jhS4y.MENU_ID_CUSTOMER_HUBS)]: 'customerHubsMenuItem',
    [(0, $jhS4y.MENU_ID_CUSTOMER_SERVICE_ANALYTICS)]: 'customerServiceAnalyticsMenuItem',
    [(0, $jhS4y.MENU_ID_GLOBAL_APP_ASSETS)]: (0, $jecJ3.GLOBAL_APP_SHORTCUT_ASSETS),
    [(0, $jhS4y.MENU_ID_GLOBAL_APP_GOALS)]: (0, $jecJ3.GLOBAL_APP_SHORTCUT_GOALS),
    [(0, $jhS4y.MENU_ID_GLOBAL_APP_CONFLUENCE)]: (0, $jecJ3.GLOBAL_APP_SHORTCUT_CONFLUENCE),
    [(0, $jhS4y.MENU_ID_GLOBAL_APP_LOOM)]: (0, $jecJ3.GLOBAL_APP_SHORTCUT_LOOM),
    [(0, $jhS4y.MENU_ID_GLOBAL_APP_TEAMS)]: (0, $jecJ3.GLOBAL_APP_SHORTCUT_TEAMS),
    [(0, $jhS4y.MENU_ID_GLOBAL_APP_PROJECTS)]: (0, $jecJ3.GLOBAL_APP_SHORTCUT_PROJECTS),
    [(0, $jhS4y.MENU_ID_GLOBAL_APP_OPSGENIE)]: (0, $jecJ3.GLOBAL_APP_SHORTCUT_OPSGENIE)
};

});
const $1520d876660a71bd$export$d2aa6c54a5925f01 = 'v3';
const $1520d876660a71bd$export$2bd315ece9f68967 = 'v4';

const $68cb678dc917978e$export$2ee9e5a3556c1e43 = 'sidebar';
const $68cb678dc917978e$export$793ed84f5e13fedc = 'top';
const $68cb678dc917978e$export$f1c9dd0f5207dd5e = 'tab';
const $68cb678dc917978e$export$b83d0ee9325a2d0a = 'projectTitle';

// TopNav or sidebar
const $ce9c0831aed9ffb3$export$17ff3f7e02c6ac22 = 'global';
const $ce9c0831aed9ffb3$export$33d8c916a600c5e9 = 'container';


// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("fS0Tg", function(module, exports) {

$parcel$export(module.exports, "HideIcon", () => $a110cc98d6df0e48$export$3fa055d21925b0d3);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $a110cc98d6df0e48$var$CustomGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        id: "icon <icon>"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        id: "Vector",
        d: "M19.2405 10.6209L18.9347 11.3057C18.734 11.7553 18.3679 12.2877 17.8832 12.8226L18.5909 13.5303C18.8838 13.8232 18.8838 14.2981 18.5909 14.591C18.298 14.8839 17.8231 14.8839 17.5302 14.591L16.7926 13.8534C16.6895 13.9372 16.5839 14.0197 16.4761 14.1004C15.998 14.4583 15.4587 14.795 14.8732 15.0696L15.3415 16.0062C15.5267 16.3767 15.3766 16.8272 15.0061 17.0125C14.6356 17.1977 14.1851 17.0475 13.9999 16.677L13.4486 15.5744C12.9819 15.6864 12.4971 15.75 11.9999 15.75C11.5026 15.75 11.0179 15.6864 10.5512 15.5744L9.99986 16.677C9.81462 17.0475 9.36412 17.1977 8.99363 17.0125C8.62315 16.8272 8.47298 16.3767 8.65822 16.0062L9.12653 15.0696C8.54102 14.795 8.00173 14.4583 7.5236 14.1004C7.41582 14.0197 7.31026 13.9372 7.20713 13.8534L6.46955 14.591C6.17666 14.8839 5.70179 14.8839 5.40889 14.591C5.116 14.2981 5.116 13.8232 5.40889 13.5303L6.11656 12.8227C5.63186 12.2877 5.26571 11.7553 5.06502 11.3057L4.75928 10.6209L6.12898 10.0094L6.43472 10.6943C6.66455 11.2091 7.37568 12.1158 8.42257 12.8996C9.45878 13.6754 10.7174 14.25 11.9999 14.25C13.2823 14.25 14.541 13.6754 15.5772 12.8996C16.6241 12.1158 17.3352 11.2091 17.565 10.6943L17.8708 10.0094L19.2405 10.6209Z",
        fill: "currentColor"
    })));
const $a110cc98d6df0e48$export$3fa055d21925b0d3 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        glyph: $a110cc98d6df0e48$var$CustomGlyph,
        ...props
    });

});

parcelRegister("bMQWP", function(module, exports) {

$parcel$export(module.exports, "default", () => $101e40a24fd8093e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $101e40a24fd8093e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    hideFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.hide-from-sidebar",
        "defaultMessage": "Hide from sidebar"
    },
    a11YAlertHideDefaultFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-default-from-sidebar",
        "defaultMessage": "Menu Item have been hidden from the sidebar"
    },
    // apps
    a11YHideAppsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-apps-from-sidebar",
        "defaultMessage": "Hide apps from sidebar"
    },
    a11YAlertHideAppsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-apps-from-sidebar",
        "defaultMessage": "Apps have been hidden from the sidebar"
    },
    // assets
    a11YHideAssetsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-assets-from-sidebar",
        "defaultMessage": "Hide assets from sidebar"
    },
    a11YAlertHideAssetsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-assets-from-sidebar",
        "defaultMessage": "Assets have been hidden from the sidebar"
    },
    // dashboards
    a11YHideDashboardsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-dashboards-from-sidebar",
        "defaultMessage": "Hide dashboards from sidebar"
    },
    a11YAlertHideDashboardsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-dashboards-from-sidebar",
        "defaultMessage": "Dashboards have been hidden from the sidebar"
    },
    // filters
    a11YHideFiltersFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-filters-from-sidebar",
        "defaultMessage": "Hide filters from sidebar"
    },
    a11YAlertHideFiltersFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-filters-from-sidebar",
        "defaultMessage": "Filters have been hidden from the sidebar"
    },
    // goals
    a11YHideGoalsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-goals-from-sidebar",
        "defaultMessage": "Hide goals from sidebar"
    },
    a11YAlertHideGoalsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-goals-from-sidebar",
        "defaultMessage": "Goals have been hidden from the sidebar"
    },
    // operations
    a11YHideOperationsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-operations-from-sidebar",
        "defaultMessage": "Hide operations from sidebar"
    },
    a11YAlertHideOperationsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-operations-from-sidebar",
        "defaultMessage": "Operations have been hidden from the sidebar"
    },
    // overviews
    a11YHideOverviewsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-overviews-from-sidebar",
        "defaultMessage": "Hide overviews from sidebar"
    },
    a11YAlertHideOverviewsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-overviews-from-sidebar",
        "defaultMessage": "Overviews have been hidden from the sidebar"
    },
    // plans
    a11YHidePlansFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-plans-from-sidebar",
        "defaultMessage": "Hide plans from sidebar"
    },
    a11YAlertHidePlansFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-plans-from-sidebar",
        "defaultMessage": "Plans have been hidden from the sidebar"
    },
    // projects
    a11YHideProjectsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-projects-from-sidebar",
        "defaultMessage": "Hide projects from sidebar"
    },
    a11YAlertHideProjectsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-projects-from-sidebar",
        "defaultMessage": "Projects have been hidden from the sidebar"
    },
    // teams
    a11YHideTeamsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-teams-from-sidebar",
        "defaultMessage": "Hide teams from sidebar"
    },
    a11YAlertHideTeamsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-teams-from-sidebar",
        "defaultMessage": "Teams have been hidden from the sidebar"
    },
    // roadmaps
    a11YHideRoadmapsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-roadmaps-from-sidebar",
        "defaultMessage": "Hide roadmaps from sidebar"
    },
    a11YAlertHideRoadmapsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-roadmaps-from-sidebar",
        "defaultMessage": "Roadmaps have been hidden from the sidebar"
    },
    // flags related texts
    moveBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.move-back-to-sidebar",
        "defaultMessage": "Move back to sidebar"
    },
    defaultHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.default-hidden-from-sidebar",
        "defaultMessage": "Hidden from sidebar"
    },
    appsHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.apps-hidden-from-sidebar",
        "defaultMessage": "Apps hidden from sidebar"
    },
    assetsHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.assets-hidden-from-sidebar",
        "defaultMessage": "Assets hidden from sidebar"
    },
    dashboardsHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.dashboards-hidden-from-sidebar",
        "defaultMessage": "Dashboards hidden from sidebar"
    },
    filtersHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.filters-hidden-from-sidebar",
        "defaultMessage": "Filters hidden from sidebar"
    },
    goalsHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.goals-hidden-from-sidebar",
        "defaultMessage": "Goals hidden from sidebar"
    },
    operationsHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.operations-hidden-from-sidebar",
        "defaultMessage": "Operations hidden from sidebar"
    },
    overviewsHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.overviews-hidden-from-sidebar",
        "defaultMessage": "Overviews hidden from sidebar"
    },
    plansHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.plans-hidden-from-sidebar",
        "defaultMessage": "Plans hidden from sidebar"
    },
    projectsHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.projects-hidden-from-sidebar",
        "defaultMessage": "Projects hidden from sidebar"
    },
    teamsHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.teams-hidden-from-sidebar",
        "defaultMessage": "Teams hidden from sidebar"
    },
    roadmapsHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.roadmaps-hidden-from-sidebar",
        "defaultMessage": "Roadmaps hidden from sidebar"
    },
    defaultMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.default-moved-back-to-sidebar",
        "defaultMessage": "Moved back to sidebar"
    },
    appsMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.apps-moved-back-to-sidebar",
        "defaultMessage": "Apps moved back to sidebar"
    },
    assetsMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.assets-moved-back-to-sidebar",
        "defaultMessage": "Assets moved back to sidebar"
    },
    dashboardsMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.dashboards-moved-back-to-sidebar",
        "defaultMessage": "Dashboards moved back to sidebar"
    },
    filtersMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.filters-moved-back-to-sidebar",
        "defaultMessage": "Filters moved back to sidebar"
    },
    goalsMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.goals-moved-back-to-sidebar",
        "defaultMessage": "Goals moved back to sidebar"
    },
    operationsMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.operations-moved-back-to-sidebar",
        "defaultMessage": "Operations moved back to sidebar"
    },
    overviewsMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.overviews-moved-back-to-sidebar",
        "defaultMessage": "Overviews moved back to sidebar"
    },
    plansMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.plans-moved-back-to-sidebar",
        "defaultMessage": "Plans moved back to sidebar"
    },
    projectsMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.projects-moved-back-to-sidebar",
        "defaultMessage": "Projects moved back to sidebar"
    },
    teamsMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.teams-moved-back-to-sidebar",
        "defaultMessage": "Teams moved back to sidebar"
    },
    roadmapsMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.roadmaps-moved-back-to-sidebar",
        "defaultMessage": "Roadmaps moved back to sidebar"
    }
});

});

parcelRegister("ji6RV", function(module, exports) {

$parcel$export(module.exports, "getA11YLabel", () => $88b27df430ca218e$export$fcb002b66b92bf50);
$parcel$export(module.exports, "getA11YAlert", () => $88b27df430ca218e$export$45edd6abaa8989eb);
$parcel$export(module.exports, "getNavItemHiddenFromSideBarFlagTitle", () => $88b27df430ca218e$export$95caae642a80ad);
$parcel$export(module.exports, "getNavItemRestoredFromSideBarFlagTitle", () => $88b27df430ca218e$export$d4ad18508eb0e1ec);

var $46Cti = parcelRequire("46Cti");

var $bMQWP = parcelRequire("bMQWP");
const $88b27df430ca218e$export$fcb002b66b92bf50 = (menuId)=>{
    switch(menuId){
        case (0, $46Cti.L1_MENU_ID).APPS:
            return (0, $bMQWP.default).a11YHideAppsFromSidebar;
        case (0, $46Cti.L1_MENU_ID).GOALS:
            return (0, $bMQWP.default).a11YHideGoalsFromSidebar;
        case (0, $46Cti.L1_MENU_ID).ROADMAPS:
            return (0, $bMQWP.default).a11YHideRoadmapsFromSidebar;
        case (0, $46Cti.L1_MENU_ID).PLANS:
            return (0, $bMQWP.default).a11YHidePlansFromSidebar;
        case (0, $46Cti.L1_MENU_ID).PROJECTS:
            return (0, $bMQWP.default).a11YHideProjectsFromSidebar;
        case (0, $46Cti.L1_MENU_ID).FILTERS:
            return (0, $bMQWP.default).a11YHideFiltersFromSidebar;
        case (0, $46Cti.L1_MENU_ID).DASHBOARDS:
            return (0, $bMQWP.default).a11YHideDashboardsFromSidebar;
        case (0, $46Cti.L1_MENU_ID).OVERVIEWS:
            return (0, $bMQWP.default).a11YHideOverviewsFromSidebar;
        case (0, $46Cti.L1_MENU_ID).OPERATIONS:
            return (0, $bMQWP.default).a11YHideOperationsFromSidebar;
        case (0, $46Cti.L1_MENU_ID).ASSETS:
            return (0, $bMQWP.default).a11YHideAssetsFromSidebar;
        case (0, $46Cti.L1_MENU_ID).TEAMS:
            return (0, $bMQWP.default).a11YHideTeamsFromSidebar;
        default:
            return (0, $bMQWP.default).hideFromSidebar;
    }
};
const $88b27df430ca218e$export$45edd6abaa8989eb = (menuId)=>{
    switch(menuId){
        case (0, $46Cti.L1_MENU_ID).APPS:
            return (0, $bMQWP.default).a11YAlertHideAppsFromSidebar;
        case (0, $46Cti.L1_MENU_ID).GOALS:
            return (0, $bMQWP.default).a11YAlertHideGoalsFromSidebar;
        case (0, $46Cti.L1_MENU_ID).ROADMAPS:
            return (0, $bMQWP.default).a11YAlertHideRoadmapsFromSidebar;
        case (0, $46Cti.L1_MENU_ID).PLANS:
            return (0, $bMQWP.default).a11YAlertHidePlansFromSidebar;
        case (0, $46Cti.L1_MENU_ID).PROJECTS:
            return (0, $bMQWP.default).a11YAlertHideProjectsFromSidebar;
        case (0, $46Cti.L1_MENU_ID).FILTERS:
            return (0, $bMQWP.default).a11YAlertHideFiltersFromSidebar;
        case (0, $46Cti.L1_MENU_ID).DASHBOARDS:
            return (0, $bMQWP.default).a11YAlertHideDashboardsFromSidebar;
        case (0, $46Cti.L1_MENU_ID).OVERVIEWS:
            return (0, $bMQWP.default).a11YAlertHideOverviewsFromSidebar;
        case (0, $46Cti.L1_MENU_ID).OPERATIONS:
            return (0, $bMQWP.default).a11YAlertHideOperationsFromSidebar;
        case (0, $46Cti.L1_MENU_ID).ASSETS:
            return (0, $bMQWP.default).a11YAlertHideAssetsFromSidebar;
        case (0, $46Cti.L1_MENU_ID).TEAMS:
            return (0, $bMQWP.default).a11YAlertHideTeamsFromSidebar;
        default:
            return (0, $bMQWP.default).a11YAlertHideDefaultFromSidebar;
    }
};
const $88b27df430ca218e$export$95caae642a80ad = (menuId)=>{
    switch(menuId){
        case (0, $46Cti.L1_MENU_ID).APPS:
            return (0, $bMQWP.default).appsHiddenFromSidebar;
        case (0, $46Cti.L1_MENU_ID).GOALS:
            return (0, $bMQWP.default).goalsHiddenFromSidebar;
        case (0, $46Cti.L1_MENU_ID).ROADMAPS:
            return (0, $bMQWP.default).roadmapsHiddenFromSidebar;
        case (0, $46Cti.L1_MENU_ID).PLANS:
            return (0, $bMQWP.default).plansHiddenFromSidebar;
        case (0, $46Cti.L1_MENU_ID).PROJECTS:
            return (0, $bMQWP.default).projectsHiddenFromSidebar;
        case (0, $46Cti.L1_MENU_ID).FILTERS:
            return (0, $bMQWP.default).filtersMovedBackToSidebar;
        case (0, $46Cti.L1_MENU_ID).DASHBOARDS:
            return (0, $bMQWP.default).dashboardsHiddenFromSidebar;
        case (0, $46Cti.L1_MENU_ID).OVERVIEWS:
            return (0, $bMQWP.default).overviewsHiddenFromSidebar;
        case (0, $46Cti.L1_MENU_ID).OPERATIONS:
            return (0, $bMQWP.default).operationsHiddenFromSidebar;
        case (0, $46Cti.L1_MENU_ID).ASSETS:
            return (0, $bMQWP.default).assetsHiddenFromSidebar;
        case (0, $46Cti.L1_MENU_ID).TEAMS:
            return (0, $bMQWP.default).teamsHiddenFromSidebar;
        default:
            return (0, $bMQWP.default).defaultHiddenFromSidebar;
    }
};
const $88b27df430ca218e$export$d4ad18508eb0e1ec = (menuId)=>{
    switch(menuId){
        case (0, $46Cti.L1_MENU_ID).APPS:
            return (0, $bMQWP.default).appsMovedBackToSidebar;
        case (0, $46Cti.L1_MENU_ID).GOALS:
            return (0, $bMQWP.default).goalsMovedBackToSidebar;
        case (0, $46Cti.L1_MENU_ID).ROADMAPS:
            return (0, $bMQWP.default).roadmapsMovedBackToSidebar;
        case (0, $46Cti.L1_MENU_ID).PLANS:
            return (0, $bMQWP.default).plansMovedBackToSidebar;
        case (0, $46Cti.L1_MENU_ID).PROJECTS:
            return (0, $bMQWP.default).projectsMovedBackToSidebar;
        case (0, $46Cti.L1_MENU_ID).FILTERS:
            return (0, $bMQWP.default).filtersMovedBackToSidebar;
        case (0, $46Cti.L1_MENU_ID).DASHBOARDS:
            return (0, $bMQWP.default).dashboardsMovedBackToSidebar;
        case (0, $46Cti.L1_MENU_ID).OVERVIEWS:
            return (0, $bMQWP.default).overviewsMovedBackToSidebar;
        case (0, $46Cti.L1_MENU_ID).OPERATIONS:
            return (0, $bMQWP.default).operationsMovedBackToSidebar;
        case (0, $46Cti.L1_MENU_ID).ASSETS:
            return (0, $bMQWP.default).assetsMovedBackToSidebar;
        case (0, $46Cti.L1_MENU_ID).TEAMS:
            return (0, $bMQWP.default).teamsMovedBackToSidebar;
        default:
            return (0, $bMQWP.default).defaultMovedBackToSidebar;
    }
};

});


parcelRegister("bgqtS", function(module, exports) {

$parcel$export(module.exports, "default", () => $438270d78383a090$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jpyeI = parcelRequire("jpyeI");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $438270d78383a090$var$ButtonMenuItemWithAnalytics = ({ analytics: analytics, onClick: onClick, ...rest }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleClick = (event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        if (!analytics) return;
        const { actionSubjectId: actionSubjectId, ...analyticsAttributes } = analytics;
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        }), actionSubjectId, analyticsAttributes);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jpyeI.ButtonMenuItem), {
        ref: ref,
        onClick: handleClick,
        ...rest
    });
};
var $438270d78383a090$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.forwardRef)($438270d78383a090$var$ButtonMenuItemWithAnalytics);

});
parcelRegister("jpyeI", function(module, exports) {

$parcel$export(module.exports, "ButtonMenuItem", () => $b9fd6b27d25ee83b$export$6dc09b7c0ec1dfcd);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fdP8o = parcelRequire("fdP8o");

var $1qQhw = parcelRequire("1qQhw");
const $b9fd6b27d25ee83b$export$6dc09b7c0ec1dfcd = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, isDisabled: isDisabled, elemBefore: elemBefore, actionsOnHover: actionsOnHover, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1qQhw.MenuListItem), {
        ref: listItemRef,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fdP8o.MenuItemBase), {
            testId: testId,
            description: description,
            elemAfter: elemAfter,
            elemBefore: elemBefore,
            isDisabled: isDisabled,
            /**
				 * Not passing `actions` and `actionsOnHover` to MenuItemBase when `isDisabled`,
				 * so they aren't rendered in the disabled state.
				 */ actions: isDisabled ? undefined : actions,
            actionsOnHover: isDisabled ? undefined : actionsOnHover,
            onClick: onClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    }));

});
parcelRegister("1qQhw", function(module, exports) {

$parcel$export(module.exports, "MenuListItem", () => $352eeaf5cfbddcbe$export$6c2f3257abc4825b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUDGK = parcelRequire("eUDGK");
const $352eeaf5cfbddcbe$export$6c2f3257abc4825b = (0, $eUDGK.ListItem);

});



parcelRegister("aCS3f", function(module, exports) {

$parcel$export(module.exports, "MoreNavMenuButton", () => $75aa993ce8b7228b$export$df3f5812ef8777cb);

var $5uXOq = parcelRequire("5uXOq");

var $jgJNO = parcelRequire("jgJNO");

var $LmW5e = parcelRequire("LmW5e");

var $4R6GH = parcelRequire("4R6GH");

var $cDvOQ = parcelRequire("cDvOQ");

var $fa1Fm = parcelRequire("fa1Fm");

var $98dJo = parcelRequire("98dJo");
const $75aa993ce8b7228b$export$df3f5812ef8777cb = (0, $LmW5e.memoWithCondition)(()=>(0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1'), ({ MenuItems: MenuItems, name: name, onOpen: onOpen, onClose: onCloseFlyout })=>{
    const { isOpen: isOpen, onClose: onCloseDropdown, onToggle: onToggle } = (0, $cDvOQ.useOpenable)();
    const content = (contentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fa1Fm.MoreNavMenuButtonSubmenu), {
            ...contentProps,
            MenuItems: MenuItems
        });
    const onClose = (0, $5uXOq.useCallback)((e)=>{
        try {
            onCloseFlyout?.(e);
        } finally{
            onCloseDropdown();
        }
    }, [
        onCloseFlyout,
        onCloseDropdown
    ]);
    const onTriggerClick = (0, $5uXOq.useCallback)(()=>{
        try {
            if (!isOpen) onOpen?.();
        } finally{
            onToggle();
        }
    }, [
        isOpen,
        onOpen,
        onToggle
    ]);
    const trigger = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $98dJo.MoreNavMenuButtonTrigger), {
            ...triggerProps,
            name: name,
            onClick: onTriggerClick,
            testId: "navigation-apps-sidebar-nav4-sidebars-common-core.ui.more-nav-menu-button.more-nav-menu-button-trigger"
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        content: content,
        isOpen: isOpen,
        onClose: onClose,
        placement: "bottom-start",
        messageId: "navigation-apps-sidebar-nav4-sidebars-common-core.ui.more-nav-menu-button.popup",
        messageType: "transactional",
        trigger: trigger,
        shouldRenderToParent: true
    });
});

});
parcelRegister("jgJNO", function(module, exports) {

$parcel$export(module.exports, "JiraPopup", () => $93ebfe5964b2617d$export$2da4be1e3f9adef3);

var $5uXOq = parcelRequire("5uXOq");

var $1I7E8 = parcelRequire("1I7E8");

var $10xFf = parcelRequire("10xFf");

var $egZ8z = parcelRequire("egZ8z");
const $93ebfe5964b2617d$export$2da4be1e3f9adef3 = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $egZ8z.ChoreographerPopup), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.Popup), rest);
};

});
parcelRegister("10xFf", function(module, exports) {

$parcel$export(module.exports, "shouldBeChoreographed", () => $36201c75b4df20a7$export$a8ba9111c7eec9ac);
$parcel$export(module.exports, "environmentToEnvType", () => $36201c75b4df20a7$export$e2cf19200849be9e);

var $iZhen = parcelRequire("iZhen");

var $fG5AJ = parcelRequire("fG5AJ");
function $36201c75b4df20a7$export$a8ba9111c7eec9ac(props) {
    return (0, $fG5AJ.shouldBeChoreographed)(props);
}
function $36201c75b4df20a7$export$e2cf19200849be9e(environment) {
    switch(environment){
        case 'dev':
            return (0, $iZhen.envType).DEV;
        case 'staging':
            return (0, $iZhen.envType).STAGING;
        case 'prod':
            return (0, $iZhen.envType).PROD;
        default:
            return (0, $iZhen.envType).LOCAL;
    }
}

});
parcelRegister("fG5AJ", function(module, exports) {

$parcel$export(module.exports, "getPendoPlugin", () => $596f0fde3f3a2d5a$export$3d3a86b2d636214b);
$parcel$export(module.exports, "shouldBeChoreographed", () => $596f0fde3f3a2d5a$export$a8ba9111c7eec9ac);
$parcel$export(module.exports, "withChoreographedToggle", () => $596f0fde3f3a2d5a$export$a646002207b915ac);
$parcel$export(module.exports, "useChoreographedRender", () => $596f0fde3f3a2d5a$export$2cfd68294be82811);
$parcel$export(module.exports, "useDisableInAppMessagesForIframe", () => $596f0fde3f3a2d5a$export$a60a99a250d6a89c);

var $5uXOq = parcelRequire("5uXOq");

var $9ACoj = parcelRequire("9ACoj");
var $4zICj = parcelRequire("4zICj");
var $TTRxY = parcelRequire("TTRxY");
var $8r6xd = parcelRequire("8r6xd");

var $4R6GH = parcelRequire("4R6GH");

var $j8DrX = parcelRequire("j8DrX");

var $7qPn9 = parcelRequire("7qPn9");

var $ioD1B = parcelRequire("ioD1B");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $596f0fde3f3a2d5a$var$environment = (0, $7qPn9.toEnvironment)((0, $j8DrX.default)('ajs-environment')) ?? 'prod';
const $596f0fde3f3a2d5a$var$createChoreographerFactory = ()=>{
    if (false) return {
        useChoreographer: (..._)=>({
                startMessage: ()=>Promise.resolve((0, $TTRxY.MessageDeliveryStatus).STARTED),
                stopMessage: ()=>Promise.resolve((0, $TTRxY.MessageDeliveryStatus).STOPPED),
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                toggleMessage: ()=>Promise.resolve('')
            }),
        withChoreographedToggle: (Component)=>Component,
        shouldBeChoreographed: (props)=>false
    };
    return (0, $4zICj.choreographerFactory)((0, $TTRxY.ProductIds).JIRA, $596f0fde3f3a2d5a$var$environment);
};
let $596f0fde3f3a2d5a$var$pendoPlugin;
function $596f0fde3f3a2d5a$export$3d3a86b2d636214b(env) {
    if (!$596f0fde3f3a2d5a$var$pendoPlugin) $596f0fde3f3a2d5a$var$pendoPlugin = new (0, $8r6xd.PendoChoreographerPlugin)(env, {
        sourceProductId: (0, $TTRxY.ProductIds).JIRA
    });
    return $596f0fde3f3a2d5a$var$pendoPlugin;
}
/**
 * Stupid hack alert: useChoreographer is throwing a TS compiler error about using MessageEventType
 * internally, and not being able to resolve that name... The usual fix for this is to add the
 * offending type to the project's exports, and then import it here so that the compiler has some
 * knowledge of what that type definition is... In this case, it doesn't seem to be working, but
 * for whatever reason, I can cast the choreographerFactory's return type using nothing more than
 * the information provided by the ReturnType<typeof choreographerFactory> type above, and then
 * define the useChoreographer type as an args list that conforms to its Parameters list, and a
 * return type that conforms to its ReturnType, and that seems to work just fine. Hopefully, somebody
 * can figure out what's going wrong here, and remove this idiocy in favor of something more sane.
 */ const { useChoreographer: $596f0fde3f3a2d5a$export$9f0e2488ffd90f11, withChoreographedToggle: $596f0fde3f3a2d5a$var$withChoreographedToggleFromFactory, shouldBeChoreographed: $596f0fde3f3a2d5a$export$a8ba9111c7eec9ac } = $596f0fde3f3a2d5a$var$createChoreographerFactory();
const $596f0fde3f3a2d5a$export$a646002207b915ac = (Component, toggleableProp, toggleableContentProp)=>{
    const WithChoreographedToggleComponent = (props)=>{
        const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $ioD1B.useChoreographedStatusContext)();
        const ChoreographedComponent = (0, $5uXOq.useMemo)(()=>$596f0fde3f3a2d5a$var$withChoreographedToggleFromFactory(Component, toggleableProp), []);
        if (isAlreadyChoreographedAtAncestor || !(0, $4R6GH.fg)('jira_with_choreographed_toggle_fix')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, props);
        const propsWithContextProviderWrapper = {
            ...props
        };
        if (toggleableContentProp) {
            const { [toggleableContentProp]: toggleableContentPropValue } = propsWithContextProviderWrapper;
            if (typeof toggleableContentPropValue === 'function') // @ts-expect-error TS doesn't know this is a callback with variable params that returns ReactNode, but we do
            propsWithContextProviderWrapper[toggleableContentProp] = (...args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ioD1B.ChoreographerContextProvider), {
                    isChoreographed: true
                }, toggleableContentPropValue(...args));
            else {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const content = toggleableContentPropValue;
                // @ts-expect-error TS doesn't know this is a ReactNode, but we do
                propsWithContextProviderWrapper[toggleableContentProp] = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ioD1B.ChoreographerContextProvider), {
                    isChoreographed: true
                }, content);
            }
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ChoreographedComponent, propsWithContextProviderWrapper);
    };
    WithChoreographedToggleComponent.displayName = `WithChoreographedToggle(${Component.displayName ?? Component.name ?? 'Component'})`;
    return WithChoreographedToggleComponent;
};
const $596f0fde3f3a2d5a$export$2cfd68294be82811 = ({ messageId: messageId, onMessageDisposition: onMessageDisposition })=>{
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $ioD1B.useChoreographedStatusContext)();
    const [shouldRender, setShouldRender] = (0, $5uXOq.useState)(false);
    const { startMessage: startMessage, stopMessage: stopMessage } = $596f0fde3f3a2d5a$export$9f0e2488ffd90f11(messageId, {
        start: ()=>setShouldRender(true)
    });
    (0, $5uXOq.useEffect)(()=>{
        if (!isAlreadyChoreographedAtAncestor) {
            const startMessageAsync = async ()=>{
                const disposition = await startMessage();
                onMessageDisposition?.(disposition);
            };
            startMessageAsync();
            return ()=>{
                stopMessage();
            };
        }
    }, [
        onMessageDisposition,
        startMessage,
        stopMessage,
        isAlreadyChoreographedAtAncestor
    ]);
    return shouldRender || isAlreadyChoreographedAtAncestor;
};
const $596f0fde3f3a2d5a$export$a60a99a250d6a89c = ()=>{
    const cleanup = (0, $5uXOq.useRef)();
    const disabled = (0, $5uXOq.useRef)(false);
    if (!disabled.current) {
        cleanup.current = (0, $9ACoj.Choreographer).getInstance().disableChoreographerForIframe();
        disabled.current = true;
    }
    (0, $5uXOq.useEffect)(()=>()=>cleanup.current?.(), []);
};

});
parcelRegister("ioD1B", function(module, exports) {

$parcel$export(module.exports, "ChoreographerContextProvider", () => $c141e5ba3428702a$export$c3226151caaf2fbf);
$parcel$export(module.exports, "useChoreographedStatusContext", () => $c141e5ba3428702a$export$2eb1efa814fe4a);

var $5uXOq = parcelRequire("5uXOq");
const $c141e5ba3428702a$var$choreographedStatusContextValue = {
    isAlreadyChoreographedAtAncestor: true
};
const $c141e5ba3428702a$export$c3226151caaf2fbf = ({ isChoreographed: isChoreographed, children: children })=>{
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = $c141e5ba3428702a$export$2eb1efa814fe4a();
    const shouldUseChoreographerContextProvider = !isAlreadyChoreographedAtAncestor && isChoreographed;
    return shouldUseChoreographerContextProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c141e5ba3428702a$export$3ff96dbefca6b00d.Provider, {
        value: $c141e5ba3428702a$var$choreographedStatusContextValue
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $c141e5ba3428702a$export$3ff96dbefca6b00d = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isAlreadyChoreographedAtAncestor: false
});
const $c141e5ba3428702a$export$2eb1efa814fe4a = ()=>(0, $5uXOq.useContext)($c141e5ba3428702a$export$3ff96dbefca6b00d);

});



parcelRegister("egZ8z", function(module, exports) {

$parcel$export(module.exports, "ChoreographerPopup", () => $985c2abc03675c6b$export$8ecc19d18d3df807);

var $1I7E8 = parcelRequire("1I7E8");

var $fG5AJ = parcelRequire("fG5AJ");
const $985c2abc03675c6b$export$8ecc19d18d3df807 = (0, $fG5AJ.withChoreographedToggle)((0, $1I7E8.Popup), 'isOpen', 'content');

});


parcelRegister("LmW5e", function(module, exports) {

$parcel$export(module.exports, "memoWithCondition", () => $9f8bd255d0869198$export$26f85cb52df6fa94);

var $5uXOq = parcelRequire("5uXOq");

var $7XYc4 = parcelRequire("7XYc4");
const $9f8bd255d0869198$export$26f85cb52df6fa94 = (condition, Component, propsAreEqual)=>{
    return (0, $7XYc4.componentWithCondition)(condition, /*#__PURE__*/ (0, $5uXOq.memo)(Component, propsAreEqual), Component);
};

});

parcelRegister("cDvOQ", function(module, exports) {

$parcel$export(module.exports, "useOpenable", () => $89d72d59f9676a7b$export$e07f550759260fd7);

var $5uXOq = parcelRequire("5uXOq");
const $89d72d59f9676a7b$export$e07f550759260fd7 = (initialState = false)=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(initialState);
    const onClose = (0, $5uXOq.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    const onOpen = (0, $5uXOq.useCallback)(()=>setIsOpen(true), [
        setIsOpen
    ]);
    const onToggle = (0, $5uXOq.useCallback)(()=>setIsOpen((value)=>!value), [
        setIsOpen
    ]);
    return {
        isOpen: isOpen,
        onClose: onClose,
        onOpen: onOpen,
        onToggle: onToggle,
        setIsOpen: setIsOpen
    };
};

});

parcelRegister("fa1Fm", function(module, exports) {

$parcel$export(module.exports, "MoreNavMenuButtonSubmenu", () => $60df3cdd5682c247$export$ac88f3e136748c4a);

var $5uXOq = parcelRequire("5uXOq");

var $eZUJu = parcelRequire("eZUJu");

var $MHKc7 = parcelRequire("MHKc7");

var $4DrQd = parcelRequire("4DrQd");
const $60df3cdd5682c247$var$stopEventPropagation = (event)=>event.stopPropagation();
const $60df3cdd5682c247$export$ac88f3e136748c4a = ({ MenuItems: MenuItems, onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        onMouseEnter: $60df3cdd5682c247$var$stopEventPropagation,
        onMouseLeave: $60df3cdd5682c247$var$stopEventPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), {
        minWidth: (0, $4DrQd.MENU_GROUP_MIN_WIDTH)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItems, {
        onClose: onClose
    })));

});

parcelRegister("98dJo", function(module, exports) {

$parcel$export(module.exports, "MoreNavMenuButtonTrigger", () => $404df4ddac9bf885$export$c1fd214ac7085e79);

var $5uXOq = parcelRequire("5uXOq");

var $8U6zd = parcelRequire("8U6zd");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $1xonH = parcelRequire("1xonH");

var $cwTmj = parcelRequire("cwTmj");
const $404df4ddac9bf885$export$c1fd214ac7085e79 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ name: name, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1xonH.CommonNavMenuButton), {
        ...props,
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))), {
                ...iconProps,
                size: "small"
            }),
        label: name ? formatMessage((0, $cwTmj.default).moreActionsFor, {
            name: name
        }) : formatMessage((0, $cwTmj.default).moreActions),
        ref: ref,
        ...(0, $dCm1o.isVisualRefreshEnabled)() ? {
            isTooltipDisabled: false,
            tooltip: {
                content: formatMessage((0, $cwTmj.default).moreActions),
                hideTooltipOnClick: true
            }
        } : {},
        ...(0, $4R6GH.fg)('blu-7837_apply_presstrace_nav4') && {
            interactionName: 'nav4-sidebar-more-actions-button'
        }
    });
});

});
parcelRegister("1xonH", function(module, exports) {

$parcel$export(module.exports, "CommonNavMenuButton", () => $aa94212e0d70bb87$export$358f21998d56a71e);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");
const $aa94212e0d70bb87$export$358f21998d56a71e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onClick: onClick, icon: icon, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        ...props,
        icon: icon,
        onClick: onClick,
        ref: ref,
        spacing: "compact",
        appearance: "subtle"
    }));

});

parcelRegister("cwTmj", function(module, exports) {

$parcel$export(module.exports, "default", () => $83d1dc5b83237d0a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $83d1dc5b83237d0a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    moreActions: {
        "id": "navigation-apps-sidebar-nav4-common.more-nav-menu-button.trigger.more-actions",
        "defaultMessage": "More actions"
    },
    moreActionsFor: {
        "id": "navigation-apps-sidebar-nav4-common.more-nav-menu-button.trigger.more-actions-for",
        "defaultMessage": "More actions for {name}"
    }
});

});



parcelRegister("85JfV", function(module, exports) {

$parcel$export(module.exports, "AsyncCmdbUpsellPage", () => $b37619bcb54c01d2$export$659eb30d49d6ed87);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $b37619bcb54c01d2$var$LazyCmdbUpsellPage = (0, $kxZPA.lazy)(()=>(parcelRequire("60bOt")).then((module)=>module.UpsellPage), {
    moduleId: "./src/packages/servicedesk/cmdb/cmdb-upsell-page/src/ui/index.tsx"
});
const $b37619bcb54c01d2$export$659eb30d49d6ed87 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "cmdb-upsell-page",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b37619bcb54c01d2$var$LazyCmdbUpsellPage, null));

});
parcelRegister("60bOt", function(module, exports) {

let $45ebe803aaa54e5b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $45ebe803aaa54e5b$var$load("mNlmy").then(()=>parcelRequire('dhOKV'));

});


parcelRegister("9wUqW", function(module, exports) {

$parcel$export(module.exports, "default", () => $63c530e31abad1b1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $63c530e31abad1b1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    openAssetsApp: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.ui.assets-app-item.open-assets-app",
        "defaultMessage": "Open Assets"
    },
    upsellLozengeText: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.ui.assets-app-item.upsell-lozenge-text",
        "defaultMessage": "Premium"
    }
});

});


parcelRegister("cNd4s", function(module, exports) {

$parcel$export(module.exports, "useIsSiteAdmin", () => $3ad4a3e53b34f026$export$f9f8a5cdb0c565ef);

var $9OXo1 = parcelRequire("9OXo1");
const $3ad4a3e53b34f026$export$f9f8a5cdb0c565ef = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.isSiteAdmin || false;
};

});

parcelRegister("3RvHe", function(module, exports) {

$parcel$export(module.exports, "default", () => $e923a6c97ae94827$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e923a6c97ae94827$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    lozenge: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.assets.lozenge",
        "defaultMessage": "Try"
    },
    assets: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.assets.assets",
        "defaultMessage": "Assets"
    }
});

});


parcelRegister("RMW1a", function(module, exports) {

$parcel$export(module.exports, "Goals", () => $a9a9e246a26b4e96$export$3c4000465299790);

var $5uXOq = parcelRequire("5uXOq");

var $ggICg = parcelRequire("ggICg");

var $8bDjo = parcelRequire("8bDjo");

var $cJFfS = parcelRequire("cJFfS");

var $koVbs = parcelRequire("koVbs");

var $2YlU4 = parcelRequire("2YlU4");
function $a9a9e246a26b4e96$export$3c4000465299790({ onClick: onClick }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const url = 'https://home.atlassian.com/goals';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cJFfS.LinkMenuItem), {
        href: url,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ggICg))), {
            label: "",
            spacing: "spacious",
            size: "small"
        }),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8bDjo.GoalsIcon), null),
        target: "_blank",
        onClick: onClick,
        testId: "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.ui.goals.menu-link-item"
    }, formatMessage((0, $2YlU4.default).goals));
}

});
parcelRegister("2YlU4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddddb229bf99ab01$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ddddb229bf99ab01$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    goals: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.goals.goals",
        "defaultMessage": "Goals"
    }
});

});



const $3287f4a6e09b4c02$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4GlobalAppShortcuts';
const $3287f4a6e09b4c02$export$d57b6b390e78d90f = 'jira-cosmos';


parcelRegister("3muxY", function(module, exports) {

$parcel$export(module.exports, "ConfigurableMenuItem", () => $8be3eed13df9fa08$export$5de02966decf8405);

var $59EX7 = parcelRequire("59EX7");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $46Cti = parcelRequire("46Cti");

var $3iY1w = parcelRequire("3iY1w");

var $67KAW = parcelRequire("67KAW");

var $kcT7A = parcelRequire("kcT7A");

var $aXxBX = parcelRequire("aXxBX");

var $kcmzD = parcelRequire("kcmzD");

var $blbXb = parcelRequire("blbXb");

var $VyuC0 = parcelRequire("VyuC0");

var $iWRQ3 = parcelRequire("iWRQ3");

var $iKHgp = parcelRequire("iKHgp");

var $lz3si = parcelRequire("lz3si");

var $1YUDD = parcelRequire("1YUDD");

var $3nmOf = parcelRequire("3nmOf");

var $abrAF = parcelRequire("abrAF");

var $3J4Wg = parcelRequire("3J4Wg");

var $cq1bX = parcelRequire("cq1bX");

var $96poX = parcelRequire("96poX");

var $cSD7y = parcelRequire("cSD7y");

var $1zjdl = parcelRequire("1zjdl");

var $3cFRo = parcelRequire("3cFRo");
const $8be3eed13df9fa08$export$5de02966decf8405 = (0, $cSD7y.componentWithFG)('jfp-magma-stability-check-nav4-batch-1', /*#__PURE__*/ (0, $5uXOq.memo)($8be3eed13df9fa08$var$ConfigurableMenuItemInner), $8be3eed13df9fa08$var$ConfigurableMenuItemInner);
function $8be3eed13df9fa08$var$ConfigurableMenuItemInner({ isDefaultOpen: isDefaultOpen = false, menuData: menuData, menuId: menuId }) {
    const data = (0, $8Uumt.useFragment)((0, $59EX7.default), menuData);
    const shouldRenderOverviews = (0, $iKHgp.useShouldRenderOverviews)();
    switch(menuId){
        case (0, $46Cti.L1_MENU_ID).APPS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iY1w.Nav4Apps), {
                isExpanded: isDefaultOpen,
                queryRef: data
            });
        case (0, $46Cti.L1_MENU_ID).ASSETS:
            /* remove this case on
       * blu-6313_sidebar_global_app_shortcuts cleanup &&
       * assets_as_an_app_v2 cleanup &&
       */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $67KAW.Nav4Assets), {
                isExpanded: isDefaultOpen
            });
        case (0, $46Cti.L1_MENU_ID).DASHBOARDS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kcmzD.Nav4Dashboards), {
                isExpanded: isDefaultOpen
            });
        case (0, $46Cti.L1_MENU_ID).FILTERS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $blbXb.Nav4Filters), {
                isExpanded: isDefaultOpen,
                queryRef: data
            });
        case (0, $46Cti.L1_MENU_ID).GOALS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3cFRo.Stub), {
                menuId: (0, $46Cti.L1_MENU_ID).GOALS,
                href: (0, $1zjdl.USER_NAVIGATION_ITEM_LINKS)[(0, $46Cti.L1_MENU_ID).GOALS]
            });
        case (0, $46Cti.L1_MENU_ID).OPERATIONS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $VyuC0.Nav4Operations), {
                isExpanded: isDefaultOpen,
                queryRef: data
            });
        case (0, $46Cti.L1_MENU_ID).COMMUNICATION:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iWRQ3.Nav4Communications), {
                isExpanded: isDefaultOpen
            });
        case (0, $46Cti.L1_MENU_ID).PLANS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1YUDD.Nav4Plans), {
                isExpanded: isDefaultOpen,
                queryRef: data
            });
        case (0, $46Cti.L1_MENU_ID).OVERVIEWS:
            return shouldRenderOverviews && (0, $4R6GH.fg)('blu-2858-sidebar-menu-overviews') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lz3si.Nav4Overviews), {
                isExpanded: isDefaultOpen,
                queryRef: data
            }) : null;
        case (0, $46Cti.L1_MENU_ID).PROJECTS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3nmOf.Nav4Projects), {
                isExpanded: isDefaultOpen,
                queryRef: data
            });
        case (0, $46Cti.L1_MENU_ID).RECENT:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $abrAF.Recent), null);
        case (0, $46Cti.L1_MENU_ID).ROADMAPS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3J4Wg.Nav4Roadmaps), {
                isExpanded: isDefaultOpen
            });
        case (0, $46Cti.L1_MENU_ID).STARRED:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cq1bX.Starred), null);
        case (0, $46Cti.L1_MENU_ID).TEAMS:
            return !(0, $4R6GH.fg)('nav4_gas_include_teams') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96poX.Teams), null) : null;
        case (0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE:
            return (0, $4R6GH.fg)('jcs_master_flag') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aXxBX.CustomerService), null) : null;
        case (0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS:
            return (0, $4R6GH.fg)('jcs-analytics-page') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kcT7A.CustomerServiceAnalytics), null) : null;
        default:
            return null;
    }
}

});
parcelRegister("59EX7", function(module, exports) {

$parcel$export(module.exports, "default", () => $047ebaf8cd6dba5c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<237b885497b658573d984371ca06695a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $047ebaf8cd6dba5c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ConfigurableMenuItem",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Nav4Projects"
        },
        {
            "kind": "FragmentSpread",
            "name": "Nav4Filters"
        },
        {
            "kind": "FragmentSpread",
            "name": "Nav4Plans"
        },
        {
            "kind": "FragmentSpread",
            "name": "Nav4Apps"
        },
        {
            "kind": "FragmentSpread",
            "name": "Nav4Operations"
        },
        {
            "kind": "FragmentSpread",
            "name": "Nav4Overviews"
        }
    ],
    "type": "Query"
};
$047ebaf8cd6dba5c$var$node.hash = "5c4da86f47569a65309ccf227624f58f";
var $047ebaf8cd6dba5c$export$2e2bcd8739ae039 = $047ebaf8cd6dba5c$var$node;

});

parcelRegister("3iY1w", function(module, exports) {

$parcel$export(module.exports, "Nav4Apps", () => $37401459bf6b58c5$export$8473036ee9e92881);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $ksJl5 = parcelRequire("ksJl5");

var $l8ruj = parcelRequire("l8ruj");


var $6EHtA = parcelRequire("6EHtA");
const $37401459bf6b58c5$export$8473036ee9e92881 = (props)=>{
    const getAttributes = (0, $5uXOq.useCallback)((error)=>(0, $6EHtA.createAttributes)({
            error: error,
            component: 'Nav4Apps'
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4-sidebar-apps"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "flag",
        id: "apps-section",
        attributes: getAttributes,
        packageName: (0, $13973d4cc5182a50$export$b8b9d90f9e5bd72b),
        teamName: (0, $13973d4cc5182a50$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ksJl5.Nav4Apps), props)));
};

});
parcelRegister("ksJl5", function(module, exports) {

$parcel$export(module.exports, "Nav4Apps", () => $00f56297c031450d$export$8473036ee9e92881);

var $c8TfS = parcelRequire("c8TfS");

var $gQbcG = parcelRequire("gQbcG");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jhS4y = parcelRequire("jhS4y");

var $c6x3L = parcelRequire("c6x3L");

var $9ETtY = parcelRequire("9ETtY");

var $jEa4c = parcelRequire("jEa4c");

var $cbY68 = parcelRequire("cbY68");

var $iJgtS = parcelRequire("iJgtS");

var $nX8wH = parcelRequire("nX8wH");

var $bhapp = parcelRequire("bhapp");
function $00f56297c031450d$export$8473036ee9e92881(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bhapp.Nav4AppsSpotlightWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($00f56297c031450d$var$Nav4AppsInner, props));
}
function $00f56297c031450d$var$Nav4AppsInner({ isExpanded: isExpanded, queryRef: queryRef }) {
    const { isInitialSelectedPath: isInitialSelectedPath } = (0, $c6x3L.useSidebarNav4)();
    const data = (0, $8Uumt.useFragment)((0, $gQbcG.default), queryRef);
    /* eslint-disable @atlassian/relay/unused-fields */ const globalAppNavigationItems = (0, $8Uumt.useFragment)((0, $c8TfS.default), data.jira);
    /* eslint-enable @atlassian/relay/unused-fields */ // $isAppsExpanded (in the query) is based on the same logic as in isInitialSelectedPath(MENU_ID_APPS).
    // However, below we filter out false positives based on extra data we retrieve from GraphQL.
    // We simply can't determine whether the general Connect app is a part of the "Apps" section or not without that extra data.
    // And we would like to avoid situations where the "Apps" section is expanded when it shouldn't be.
    // Keep in mind that global Connect app != general Connect app. Global app is a subset of the general app.
    // General app can be rendered in various contexts, while the global one only under the "Apps" section.
    const isMaybeAppsSectionRoute = isInitialSelectedPath((0, $jhS4y.MENU_ID_APPS));
    const isGeneralConnectRoute = (0, $9ETtY.useIsGeneralConnectRoute)();
    const isGlobalConnectAppRoute = (0, $nX8wH.useIsGlobalConnectAppRoute)({
        data: globalAppNavigationItems
    });
    const isAppsSectionExpanded = isMaybeAppsSectionRoute && (isGeneralConnectRoute ? isGlobalConnectAppRoute : true);
    const sectionActions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jEa4c.SectionActions), null);
    return isAppsSectionExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iJgtS.Nav4AppsForLanding), {
        actionsOnHover: sectionActions,
        isExpanded: isExpanded,
        queryRef: data.jira
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cbY68.Nav4AppsDefault), {
        actionsOnHover: sectionActions,
        isExpanded: isExpanded
    });
}

});
parcelRegister("c8TfS", function(module, exports) {

$parcel$export(module.exports, "default", () => $58cc3d53236e7f5f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b841eae00c140d0fa10ac87feab52bf9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $58cc3d53236e7f5f$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "isAppsExpanded"
            }
        ],
        "kind": "Fragment",
        "name": "Nav4Apps_GlobalAppsFragment",
        "selections": [
            {
                "condition": "isAppsExpanded",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "cloudId",
                                "variableName": "cloudId"
                            }
                        ],
                        "concreteType": "JiraNavigationItemConnection",
                        "kind": "LinkedField",
                        "name": "globalAppNavigationItems",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraNavigationItemEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "appType"
                                                    },
                                                    v0 /*: any*/ ,
                                                    {
                                                        "concreteType": "JiraAppSection",
                                                        "kind": "LinkedField",
                                                        "name": "sections",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraAppNavigationItemNestedLink",
                                                                "kind": "LinkedField",
                                                                "name": "links",
                                                                "plural": true,
                                                                "selections": [
                                                                    v0 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "JiraAppNavigationItem"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraQuery"
    };
}();
$58cc3d53236e7f5f$var$node.hash = "fcee4331eb5ce6a0f2c7ee593634458d";
var $58cc3d53236e7f5f$export$2e2bcd8739ae039 = $58cc3d53236e7f5f$var$node;

});

parcelRegister("gQbcG", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea6f03604759aa38$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bf10716a4c00972068007e73ef5b1c3f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ea6f03604759aa38$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isAppsExpanded"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4Apps",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "condition": "isAppsExpanded",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "Nav4AppsForLanding"
                            }
                        ]
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "Nav4Apps_GlobalAppsFragment"
                    }
                ]
            },
            "action": "THROW",
            "path": "jira"
        }
    ],
    "type": "Query"
};
$ea6f03604759aa38$var$node.hash = "c3df504da3663fd99ebe67a0d32de67f";
var $ea6f03604759aa38$export$2e2bcd8739ae039 = $ea6f03604759aa38$var$node;

});

parcelRegister("9ETtY", function(module, exports) {

$parcel$export(module.exports, "useIsGeneralConnectRoute", () => $06f03c6d90d3978b$export$db179b21b0be87a1);

var $8j0rr = parcelRequire("8j0rr");
const $06f03c6d90d3978b$var$GENERAL_CONNECT_ROUTES = new Set([
    'connect-general',
    'connect-general-invalid',
    'legacy-connect-general',
    'connect-general-service-desk-project'
]);
const $06f03c6d90d3978b$var$UNCERTAIN_APPS_SECTION_ROUTES = $06f03c6d90d3978b$var$GENERAL_CONNECT_ROUTES;
const $06f03c6d90d3978b$var$CERTAIN_APPS_SECTION_ROUTES = new Set([
    'forge-spa-global',
    'marketplace-index'
]);
const $06f03c6d90d3978b$export$22e210b2ba662e30 = new Set([
    ...$06f03c6d90d3978b$var$UNCERTAIN_APPS_SECTION_ROUTES,
    ...$06f03c6d90d3978b$var$CERTAIN_APPS_SECTION_ROUTES
]);
function $06f03c6d90d3978b$export$db179b21b0be87a1() {
    const route = (0, $8j0rr.useRoute)();
    return $06f03c6d90d3978b$var$GENERAL_CONNECT_ROUTES.has(route.name);
}

});
parcelRegister("8j0rr", function(module, exports) {

$parcel$export(module.exports, "useRoute", () => $71494baa766bb420$export$3f79f0b98112cf57);

var $lODMY = parcelRequire("lODMY");
const $71494baa766bb420$export$3f79f0b98112cf57 = (0, $lODMY.createRouterSelector)((state)=>state.route);

});


parcelRegister("jEa4c", function(module, exports) {

$parcel$export(module.exports, "SectionActions", () => $e6bcc3c836f7b03e$export$51f8029abf8c56ce);

var $5uXOq = parcelRequire("5uXOq");

var $hRf4g = parcelRequire("hRf4g");

var $epOG5 = parcelRequire("epOG5");

var $3Z96c = parcelRequire("3Z96c");
var $9UCCQ = parcelRequire("9UCCQ");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $5euJh = parcelRequire("5euJh");



var $jecJ3 = parcelRequire("jecJ3");

var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $46Cti = parcelRequire("46Cti");

var $9eeFp = parcelRequire("9eeFp");

var $eaKdt = parcelRequire("eaKdt");

var $aCS3f = parcelRequire("aCS3f");

var $6awYZ = parcelRequire("6awYZ");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $9OXo1 = parcelRequire("9OXo1");

var $iFqOo = parcelRequire("iFqOo");
function $e6bcc3c836f7b03e$export$51f8029abf8c56ce({ onClose: onClose }) {
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { isAdmin: isAdmin, isSiteAdmin: isSiteAdmin } = tenantContext;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const showManageApps = isAdmin || isSiteAdmin;
    const showAppAuditLogs = (0, $4R6GH.fg)('upm_frontend_deprecation') && (isAdmin || isSiteAdmin);
    const showViewAppRequests = (0, $6s1PB.expVal)('enduser-emcee-discover', 'value', true) && isSiteAdmin;
    const fireOpenEvent = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_APPS],
            attributes: {
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                itemId: 'meatballDropdown'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCS3f.MoreNavMenuButton), {
        MenuItems: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e6bcc3c836f7b03e$var$MoreMenuItems, {
                showManageApps: showManageApps,
                showViewAppRequests: showViewAppRequests,
                showAppAuditLogs: showAppAuditLogs,
                ...props
            }),
        onOpen: fireOpenEvent,
        onClose: onClose
    });
}
function $e6bcc3c836f7b03e$var$MoreMenuItems({ onClose: onClose, showManageApps: showManageApps, showViewAppRequests: showViewAppRequests, showAppAuditLogs: showAppAuditLogs }) {
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { cloudId: cloudId } = tenantContext;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const adminHubAppRequestsUrl = `https://${(0, $5euJh.getATLContextDomain)('admin')}/s/${cloudId}/user-connected-apps/tab/requested`;
    const viewAppRequestsLink = (0, $5uXOq.useMemo)(()=>(0, $4R6GH.fg)('should_redirect_to_admin-hub_for_app_requests') ? adminHubAppRequestsUrl : (0, $6awYZ.getAppRequestsLink)(), [
        adminHubAppRequestsUrl
    ]);
    const onCloseWithStopPropagation = (0, $9eeFp.useStopPropagation)(onClose);
    const showTopSection = showManageApps || showViewAppRequests;
    const fireClickEvent = (0, $5uXOq.useCallback)((itemId)=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_APPS],
            attributes: {
                level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                componentType: (0, $1e554a683893bd46$export$74712b62056d422e),
                itemId: itemId,
                parentItemId: (0, $jecJ3.SECTION_ITEM_APPS)
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, showTopSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), null, showManageApps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Z96c.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($epOG5))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        }),
        href: "/plugins/servlet/upm",
        target: "_blank",
        onClick: (...args)=>{
            fireClickEvent('manageApps');
            onCloseWithStopPropagation(...args);
        }
    }, formatMessage((0, $iFqOo.default).manageApps)), showAppAuditLogs && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Z96c.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($epOG5))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        }),
        href: "/plugins/servlet/upm/log",
        onClick: (...args)=>{
            onCloseWithStopPropagation(...args);
        },
        target: "_blank"
    }, formatMessage((0, $iFqOo.default).appAuditLogs)), showViewAppRequests && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Z96c.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hRf4g))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        }),
        href: viewAppRequestsLink,
        target: "_blank",
        onClick: (...args)=>{
            fireClickEvent('viewAppRequests');
            onCloseWithStopPropagation(...args);
        }
    }, formatMessage((0, $iFqOo.default).viewAppRequests))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaKdt.HideL1MenuItemSection), {
        menuId: (0, $46Cti.L1_MENU_ID).APPS,
        hasSeparator: showTopSection
    }));
}

});
parcelRegister("9eeFp", function(module, exports) {

$parcel$export(module.exports, "useStopPropagation", () => $9838019739bca90d$export$f7bb512e68bcecd9);

var $5uXOq = parcelRequire("5uXOq");
const $9838019739bca90d$export$f7bb512e68bcecd9 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
onEvent)=>(0, $5uXOq.useCallback)((e, ...args)=>{
        try {
            onEvent?.(e, ...args);
        } finally{
            e?.stopPropagation();
        }
    }, [
        onEvent
    ]);

});

parcelRegister("6awYZ", function(module, exports) {

$parcel$export(module.exports, "getEmceeDiscoverLink", () => $3f6cbde73539e62b$export$f26dabf284aefb17);
$parcel$export(module.exports, "getEmceeAppListingLink", () => $3f6cbde73539e62b$export$eb09695b9e9f6a3);
$parcel$export(module.exports, "getAppRequestsLink", () => $3f6cbde73539e62b$export$7ab8c48f9081e976);
$parcel$export(module.exports, "getManagePromotionsLink", () => $3f6cbde73539e62b$export$350ca33eed6a2742);
const $3f6cbde73539e62b$var$sanitiseParams = (params)=>params ? Object.entries(params).reduce((res, [key, value])=>{
        if (value) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'EmceeQueryParams | JiraQueryParams'.
        res[key] = params[key];
        return res;
    }, {}) : {};
const $3f6cbde73539e62b$var$addQueryParamsToLink = (params, link)=>{
    // @ts-expect-error - TS2345 - Argument of type 'EmceeQueryParams | JiraQueryParams | null | undefined' is not assignable to parameter of type 'EmceeQueryParams | JiraQueryParams | undefined'.
    const queryParams = $3f6cbde73539e62b$var$sanitiseParams(params);
    const queryString = new URLSearchParams(queryParams).toString();
    return queryString ? `${link}?${queryString}` : link;
};
const $3f6cbde73539e62b$export$f26dabf284aefb17 = (params)=>{
    const link = '/jira/marketplace/discover';
    return $3f6cbde73539e62b$var$addQueryParamsToLink(params, link);
};
const $3f6cbde73539e62b$export$eb09695b9e9f6a3 = (appKey, params, jiraQueryParams)=>$3f6cbde73539e62b$var$addQueryParamsToLink({
        ...jiraQueryParams,
        ...params
    }, `/jira/marketplace/discover/app/${appKey}`);
const $3f6cbde73539e62b$export$7ab8c48f9081e976 = (params)=>{
    const link = '/jira/marketplace/manage/app-requests';
    return $3f6cbde73539e62b$var$addQueryParamsToLink(params, link);
};
const $3f6cbde73539e62b$export$350ca33eed6a2742 = (params)=>{
    const link = '/jira/marketplace/manage/promotions';
    return $3f6cbde73539e62b$var$addQueryParamsToLink(params, link);
};

});

parcelRegister("iFqOo", function(module, exports) {

$parcel$export(module.exports, "default", () => $560cd06a0adfd8ce$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $560cd06a0adfd8ce$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    manageApps: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-apps.common.section-actions.manage-apps",
        "defaultMessage": "Manage apps"
    },
    appAuditLogs: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-apps.common.section-actions.app-audit-logs",
        "defaultMessage": "App audit logs"
    },
    viewAppRequests: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-apps.common.section-actions.view-app-requests",
        "defaultMessage": "View app requests"
    }
});

});


parcelRegister("cbY68", function(module, exports) {

$parcel$export(module.exports, "Nav4AppsDefault", () => $18bb1ac270cbc9bf$export$3732a771b6ecd66d);

var $5uXOq = parcelRequire("5uXOq");

var $lnznH = parcelRequire("lnznH");
var $cZa9B = parcelRequire("cZa9B");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");


var $jecJ3 = parcelRequire("jecJ3");

var $jhS4y = parcelRequire("jhS4y");

var $iszzG = parcelRequire("iszzG");

var $46Cti = parcelRequire("46Cti");

var $c16H2 = parcelRequire("c16H2");

var $338xa = parcelRequire("338xa");

var $dQbFB = parcelRequire("dQbFB");

var $dUyqZ = parcelRequire("dUyqZ");

var $4zcxJ = parcelRequire("4zcxJ");

var $7Y7Js = parcelRequire("7Y7Js");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koeKL = parcelRequire("koeKL");

var $4R6GH = parcelRequire("4R6GH");


var $6EHtA = parcelRequire("6EHtA");

var $g72iU = parcelRequire("g72iU");
function $18bb1ac270cbc9bf$export$3732a771b6ecd66d(props) {
    const { actionsOnHover: actionsOnHover, simulateLoading: simulateLoading = false, isExpanded: isExpanded = simulateLoading } = props;
    const cloudId = (0, $koeKL.useCloudId)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId
        }), [
        cloudId
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $g72iU.asyncNav4AppsContentViewQuery), entryPointParams);
    const triggerRef = (0, $4zcxJ.useExpandableEntryPointTrigger)(entryPointActions);
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).APPS);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { moreMenuIds: moreMenuIds } = (0, $5uXOq.useContext)((0, $iszzG.NavItemsContext));
    const getAttributes = (0, $5uXOq.useCallback)((error)=>(0, $6EHtA.createAttributes)({
            error: error,
            component: 'Nav4AppsDefault'
        }), []);
    // If starting life expanded, make sure to load.
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (isExpanded) entryPointActions.load();
    }, [
        entryPointActions,
        isExpanded
    ]);
    const menuId = (0, $jhS4y.MENU_ID_APPS);
    const onSystemToggle = (0, $5uXOq.useCallback)((hasExpanded)=>{
        if (hasExpanded) entryPointActions.load();
    }, [
        entryPointActions
    ]);
    const onExpansionToggle = (0, $5uXOq.useCallback)((hasExpanded)=>{
        if (hasExpanded) {
            entryPointActions.load();
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
            });
            const isInMore = moreMenuIds.includes((0, $46Cti.L1_MENU_ID).APPS);
            (0, $8zOmE.fireUIAnalytics)(event, (0, $jecJ3.SECTION_ITEM_APPS), {
                isInMore: isInMore
            });
        }
    }, [
        createAnalyticsEvent,
        entryPointActions,
        moreMenuIds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onSystemToggle: (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? onSystemToggle : (hasExpanded)=>{
            if (hasExpanded) entryPointActions.load();
        },
        onExpansionToggle: (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? onExpansionToggle : (hasExpanded)=>{
            if (hasExpanded) {
                entryPointActions.load();
                const event = createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
                });
                const isInMore = moreMenuIds.includes((0, $46Cti.L1_MENU_ID).APPS);
                (0, $8zOmE.fireUIAnalytics)(event, (0, $jecJ3.SECTION_ITEM_APPS), {
                    isInMore: isInMore
                });
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZa9B.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-apps-default",
        actionsOnHover: actionsOnHover,
        // Prevent double-up of accessible name that occurs in icon+text situation.
        "aria-label": formattedMessage,
        elemBefore: icon,
        ref: triggerRef,
        testId: (0, $dQbFB.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnznH.ExpandableMenuItemContent), null, simulateLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        // Data stream, will subscribe to load updates.
        entryPointReferenceSubject: entryPointReferenceSubject,
        // Required props for error JSErrorBoundary.
        id: "nav4-sidebar-apps-default",
        errorAttributes: getAttributes,
        packageName: (0, $13973d4cc5182a50$export$b8b9d90f9e5bd72b),
        // Optional props for error JSErrorBoundary.
        errorFallback: "flag",
        teamName: (0, $13973d4cc5182a50$export$d57b6b390e78d90f),
        // Fallback for `Suspense`.
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), null),
        // Props for the root component.
        runtimeProps: entryPointParams
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Y7Js.ExploreMoreApps), null)));
}

});
parcelRegister("lnznH", function(module, exports) {

$parcel$export(module.exports, "ExpandableMenuItemContent", () => $989ef304f4c01dfd$export$bd680a81504a92e9);
/* expandable-menu-item-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $DEWI6 = parcelRequire("DEWI6");

var $hEtBs = parcelRequire("hEtBs");

var $et13M = parcelRequire("et13M");
const $989ef304f4c01dfd$var$styles = {
    content: "_bozg1crf",
    collapsedContent: "_1e0cglyw"
};
const $989ef304f4c01dfd$export$bd680a81504a92e9 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children }, forwardedRef)=>{
    const isExpanded = (0, $et13M.useIsExpanded)();
    const level = (0, $et13M.useLevel)();
    const hasExpanded = (0, $5uXOq.useRef)(false);
    const areAllAncestorsExpanded = (0, $et13M.useAreAllAncestorsExpanded)();
    if (!isExpanded && !hasExpanded.current) return null;
    hasExpanded.current = true;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $et13M.LevelContext).Provider, {
        value: level + 1,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $et13M.AreAllAncestorsExpandedContext).Provider, {
            value: /**
     * By combining the current ancestor and with the current menu item's state, all nested menu items will know if their
     * ancestor menu items are all expanded.
     */ areAllAncestorsExpanded && isExpanded,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hEtBs.List), {
                ref: forwardedRef,
                xcss: (0, $DEWI6.cx)($989ef304f4c01dfd$var$styles.content, !isExpanded && $989ef304f4c01dfd$var$styles.collapsedContent),
                children: children
            })
        })
    });
});

});

parcelRegister("cZa9B", function(module, exports) {

$parcel$export(module.exports, "ExpandableMenuItemTrigger", () => $299b2713b0d220a7$export$fe6fe51056867f4d);
/* expandable-menu-item-trigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $iy9RA = parcelRequire("iy9RA");

var $bpC55 = parcelRequire("bpC55");

var $fdP8o = parcelRequire("fdP8o");

var $cs9Q6 = parcelRequire("cs9Q6");

var $et13M = parcelRequire("et13M");
// Widening type to `string` to side-step Compiled cssMap typescript warnings with unknown properties
const $299b2713b0d220a7$var$chevronDisplayCssVar = '--expandable-chevron-display';
const $299b2713b0d220a7$var$providedElemBeforeDisplayCssVar = '--expandable-provided-elembefore-display';
const $299b2713b0d220a7$var$wrapperStyles = {
    root: "_1mmi1txw _165nglyw",
    showProvidedElemBefore: "_1mmiglyw _165n1bgi _v9u71txw _1hl9glyw _b31z1txw _1vnl1txw _12xsglyw _p8btglyw"
};
const $299b2713b0d220a7$var$iconStyles = {
    chevron: "_1e0ciw0t _1tz3r0mg",
    providedElemBefore: "_1e0c1xb2"
};
const $299b2713b0d220a7$var$ExpandableMenuItemIcon = ({ iconProps: iconProps, isExpanded: isExpanded, isSelected: isSelected, providedElemBefore: providedElemBefore })=>{
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($iy9RA))) : (0, (/*@__PURE__*/$parcel$interopDefault($bpC55)));
    const chevronElem = /*#__PURE__*/ (0, $2OMIu.jsx)(ChevronIcon, {
        ...iconProps,
        label: "",
        color: isSelected ? "var(--ds-icon-selected, #0C66E4)" : undefined,
        size: "small"
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    $299b2713b0d220a7$var$iconStyles.chevron
                ]),
                children: chevronElem
            }),
            providedElemBefore && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    $299b2713b0d220a7$var$iconStyles.providedElemBefore
                ]),
                children: providedElemBefore
            })
        ]
    });
};
const $299b2713b0d220a7$export$fe6fe51056867f4d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ actions: actions, isSelected: isSelected, href: href, elemBefore: providedElemBefore, elemAfter: elemAfter, actionsOnHover: actionsOnHover, onClick: onClick, children: children, testId: testId, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const onExpansionToggle = (0, $et13M.useOnExpansionToggle)();
    const isExpanded = (0, $et13M.useIsExpanded)();
    const setIsExpanded = (0, $et13M.useSetIsExpanded)();
    const itemRef = (0, $5uXOq.useRef)(null);
    const handleIconClick = (0, $5uXOq.useCallback)(()=>{
        onExpansionToggle?.(!isExpanded);
        setIsExpanded(!isExpanded);
    }, [
        isExpanded,
        onExpansionToggle,
        setIsExpanded
    ]);
    const handleMenuContentClick = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        const newValue = !isExpanded;
        onClick?.(event, analyticsEvent, {
            isExpanded: newValue
        });
        onExpansionToggle?.(newValue);
        setIsExpanded(newValue);
    }, [
        onClick,
        onExpansionToggle,
        isExpanded,
        setIsExpanded
    ]);
    const isSelectable = typeof href !== 'undefined';
    (0, $cs9Q6.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: Boolean(isSelectable && isSelected)
    });
    // Wrapped in an IconButton if the expandable menu item trigger is selectable
    const elemBefore = isSelectable ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)($299b2713b0d220a7$var$ExpandableMenuItemIcon, {
                iconProps: iconProps,
                isExpanded: isExpanded,
                isSelected: isSelected,
                providedElemBefore: providedElemBefore
            }),
        "aria-expanded": isExpanded,
        label: isExpanded ? 'Collapse' : 'Expand',
        appearance: "subtle",
        spacing: "compact",
        onClick: handleIconClick,
        interactionName: interactionName
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($299b2713b0d220a7$var$ExpandableMenuItemIcon, {
        isExpanded: isExpanded,
        isSelected: isSelected,
        providedElemBefore: providedElemBefore
    });
    // For expandable menu items, we shouldn't wrap in a `li` here. The `li` is instead at a higher level (`ExpandableMenuItem`), grouping the expandable menu item trigger and its content
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: itemRef,
        className: (0, $bwpsq.default)([
            $299b2713b0d220a7$var$wrapperStyles.root,
            providedElemBefore && $299b2713b0d220a7$var$wrapperStyles.showProvidedElemBefore
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fdP8o.MenuItemBase), {
            actions: actions,
            actionsOnHover: actionsOnHover,
            elemBefore: elemBefore,
            ariaExpanded: isExpanded,
            elemAfter: elemAfter,
            href: href,
            isSelected: isSelected,
            onClick: handleMenuContentClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            testId: testId,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
});

});

parcelRegister("c16H2", function(module, exports) {

$parcel$export(module.exports, "Nav4ExpandableMenuItem", () => $ea944fd631b4ab3b$export$3c0db18b09c9af3e);

var $5uXOq = parcelRequire("5uXOq");

var $mwgEH = parcelRequire("mwgEH");

var $4R6GH = parcelRequire("4R6GH");

var $c6x3L = parcelRequire("c6x3L");

var $lJ5jf = parcelRequire("lJ5jf");

var $LmW5e = parcelRequire("LmW5e");

var $7mPT9 = parcelRequire("7mPT9");
const $ea944fd631b4ab3b$export$3c0db18b09c9af3e = (0, $LmW5e.memoWithCondition)(()=>(0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1'), /*#__PURE__*/ (0, $5uXOq.forwardRef)($ea944fd631b4ab3b$var$Nav4ExpandableMenuItemView));
function $ea944fd631b4ab3b$var$Nav4ExpandableMenuItemView(props, ref) {
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    const { isSelectedPath: isSelectedPath, isInitialSelectedPath: isInitialSelectedPath } = (0, $c6x3L.useSidebarNav4)();
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    const { isControlledNav: isControlledNav, isControlledPath: isControlledPath } = (0, $lJ5jf.useSidebarNav4Controller)();
    const { children: children, menuId: menuId, onExpansionToggle: onExpansionToggle, isExpanded: isExpanded = false, onSystemToggle: onSystemToggle, expandedRef: expandedRef, collapsedRef: collapsedRef, dropIndicator: dropIndicator = null, dropTargetRef: dropTargetRef = null } = props;
    // controlled state, `isActuallyExpanded` decides whether the component is expanded or not (based on logic in this component and props.isExpanded)
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    const [isActuallyExpanded, setActuallyExpanded] = (0, $5uXOq.useState)(isInitialSelectedPath(menuId) || isExpanded);
    // By default, the expandable component is closed. When we want it to be initially open, we also need to trigger onExpansionToggle().
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    (0, $5uXOq.useEffect)(()=>{
        if (isActuallyExpanded === true && isExpanded === false) onSystemToggle?.(isActuallyExpanded);
    // We want to run this only once, on init.
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // If isSelectedPath changes (external change), update our internal state.
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    (0, $5uXOq.useEffect)(()=>{
        // Fyi, the following logic causes the component to _collapse_ when the selectedPath changes (preserved here for posterity):
        //   const localIsExpanded = isSelectedPath(menuId);
        // ...but this logic _keeps the component expanded_ (if it is) when the selectedPath changes. We can only auto-expand component, not auto-collapse it though (which is fine, for current UX):
        const localIsExpanded = isSelectedPath(menuId) || isActuallyExpanded;
        // Trigger the callbacks ONLY when the previous state doesn't match the new state.
        if (localIsExpanded !== isActuallyExpanded) {
            setActuallyExpanded(localIsExpanded);
            onSystemToggle?.(localIsExpanded);
        }
    // We only want to run this when isSelectedPath() changes, not when isActuallyExpanded changes.
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isSelectedPath
    ]);
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    (0, $5uXOq.useEffect)(()=>{
        if (!isControlledNav) return;
        const localIsExpanded = isControlledPath(menuId);
        if (localIsExpanded !== isActuallyExpanded) {
            setActuallyExpanded(localIsExpanded);
            onSystemToggle?.(localIsExpanded);
        }
    // We only want to run this when isControlledPath() changes, not when isActuallyExpanded changes.
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isControlledPath
    ]);
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    const expandableMenuItemRef = (0, $5uXOq.useMemo)(()=>{
        if (isActuallyExpanded) return expandedRef ?? ref;
        return collapsedRef ?? ref;
    }, [
        collapsedRef,
        expandedRef,
        isActuallyExpanded,
        ref
    ]);
    const onExpandableMenuItemToggle = (0, $5uXOq.useCallback)((hasExpanded)=>{
        // Since we are controlling `isExpanded` state in this component (via `isActuallyExpanded`), we need to change it on onExpansionToggle user-event too.
        setActuallyExpanded(hasExpanded);
        onExpansionToggle?.(hasExpanded);
    }, [
        onExpansionToggle
    ]);
    if ((0, $4R6GH.fg)('blu-6314-drag-and-drop-projects-sidebar-mouse')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $mwgEH.ExpandableMenuItem), {
        ref: (0, $7mPT9.mergeRefs)(expandableMenuItemRef, dropTargetRef),
        dropIndicator: dropIndicator,
        isExpanded: isActuallyExpanded && !props.isDragging,
        onExpansionToggle: (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? onExpandableMenuItemToggle : (hasExpanded)=>{
            // Since we are controlling `isExpanded` state in this component (via `isActuallyExpanded`), we need to change it on onExpansionToggle user-event too.
            setActuallyExpanded(hasExpanded);
            onExpansionToggle?.(hasExpanded);
        }
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $mwgEH.ExpandableMenuItem), {
        ref: expandableMenuItemRef,
        isExpanded: isActuallyExpanded,
        onExpansionToggle: (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? onExpandableMenuItemToggle : (hasExpanded)=>{
            // Since we are controlling `isExpanded` state in this component (via `isActuallyExpanded`), we need to change it on onExpansionToggle user-event too.
            setActuallyExpanded(hasExpanded);
            onExpansionToggle?.(hasExpanded);
        }
    }, children);
}

});
parcelRegister("mwgEH", function(module, exports) {

$parcel$export(module.exports, "ExpandableMenuItem", () => $c5233d2b5c8a7c4f$export$341dea48c30b36ff);
/* expandable-menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $33etG = parcelRequire("33etG");

var $1qQhw = parcelRequire("1qQhw");

var $et13M = parcelRequire("et13M");
const $c5233d2b5c8a7c4f$var$relativeStyles = {
    root: "_kqswh2mm"
};
const $c5233d2b5c8a7c4f$export$341dea48c30b36ff = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isExpanded: isExpandedControlled, isDefaultExpanded: isDefaultExpanded = false, onExpansionToggle: onExpansionToggle, children: children, dropIndicator: dropIndicator }, forwardedRef)=>{
    const [isExpanded, setIsExpanded] = (0, $33etG.default)(isExpandedControlled, ()=>isDefaultExpanded);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $et13M.IsExpandedContext).Provider, {
        value: isExpanded,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $et13M.SetIsExpandedContext).Provider, {
            value: setIsExpanded,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $et13M.OnExpansionToggleContext).Provider, {
                value: onExpansionToggle ?? null,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1qQhw.MenuListItem), {
                    ref: forwardedRef,
                    children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                        className: (0, $bwpsq.default)([
                            dropIndicator && $c5233d2b5c8a7c4f$var$relativeStyles.root
                        ]),
                        children: [
                            children,
                            dropIndicator
                        ]
                    })
                })
            })
        })
    });
});

});

parcelRegister("7mPT9", function(module, exports) {

$parcel$export(module.exports, "mergeRefs", () => $d1da29f25d5b5e0a$export$c9058316764c140e);
$parcel$export(module.exports, "default", () => $d1da29f25d5b5e0a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $d1da29f25d5b5e0a$export$c9058316764c140e(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref != null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref.current = value; // eslint-disable-line no-param-reassign
        });
    };
}
function $d1da29f25d5b5e0a$export$2e2bcd8739ae039(...refs) {
    return (0, $5uXOq.useMemo)(()=>$d1da29f25d5b5e0a$export$c9058316764c140e(...refs), // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    refs);
}

});


parcelRegister("338xa", function(module, exports) {

$parcel$export(module.exports, "SkeletonNavMenuItems", () => $32c488973b24b27b$export$c3a3a246584433d7);

var $5uXOq = parcelRequire("5uXOq");

var $9PCp5 = parcelRequire("9PCp5");

var $iwwXK = parcelRequire("iwwXK");

var $1qQhw = parcelRequire("1qQhw");

var $fNobW = parcelRequire("fNobW");

var $4R6GH = parcelRequire("4R6GH");
const $32c488973b24b27b$export$c3a3a246584433d7 = ({ count: count = 5 })=>(0, $4R6GH.fg)('blu-7837_apply_presstrace_nav4') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "nav4-sidebar-menu-items-loading"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($9PCp5)))(0, count).map((index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1qQhw.MenuListItem), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
            isShimmering: true
        })))) : (0, (/*@__PURE__*/$parcel$interopDefault($9PCp5)))(0, count).map((index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1qQhw.MenuListItem), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
            isShimmering: true
        })));

});
parcelRegister("9PCp5", function(module, exports) {

var $lVx1a = parcelRequire("lVx1a");

var $7286aa9f89a20bb7$var$func = $lVx1a('range', (parcelRequire("iASWI")));

$7286aa9f89a20bb7$var$func.placeholder = (parcelRequire("aPsMW"));
module.exports = $7286aa9f89a20bb7$var$func;

});
parcelRegister("lVx1a", function(module, exports) {

var $iIayQ = parcelRequire("iIayQ");

var $7sR67 = parcelRequire("7sR67");
/**
 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
 * version with conversion `options` applied. If `name` is an object its methods
 * will be converted.
 *
 * @param {string} name The name of the function to wrap.
 * @param {Function} [func] The function to wrap.
 * @param {Object} [options] The options object. See `baseConvert` for more details.
 * @returns {Function|Object} Returns the converted function or object.
 */ function $ff688881095ae098$var$convert(name, func, options) {
    return $iIayQ($7sR67, name, func, options);
}
module.exports = $ff688881095ae098$var$convert;

});
parcelRegister("iIayQ", function(module, exports) {

var $lTdwm = parcelRequire("lTdwm");

var $aPsMW = parcelRequire("aPsMW");
/** Built-in value reference. */ var $d9f487426e0f9b59$var$push = Array.prototype.push;
/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */ function $d9f487426e0f9b59$var$baseArity(func, n) {
    return n == 2 ? function(a, b) {
        return func.apply(undefined, arguments);
    } : function(a) {
        return func.apply(undefined, arguments);
    };
}
/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */ function $d9f487426e0f9b59$var$baseAry(func, n) {
    return n == 2 ? function(a, b) {
        return func(a, b);
    } : function(a) {
        return func(a);
    };
}
/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */ function $d9f487426e0f9b59$var$cloneArray(array) {
    var length = array ? array.length : 0, result = Array(length);
    while(length--)result[length] = array[length];
    return result;
}
/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */ function $d9f487426e0f9b59$var$createCloner(func) {
    return function(object) {
        return func({}, object);
    };
}
/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */ function $d9f487426e0f9b59$var$flatSpread(func, start) {
    return function() {
        var length = arguments.length, lastIndex = length - 1, args = Array(length);
        while(length--)args[length] = arguments[length];
        var array = args[start], otherArgs = args.slice(0, start);
        if (array) $d9f487426e0f9b59$var$push.apply(otherArgs, array);
        if (start != lastIndex) $d9f487426e0f9b59$var$push.apply(otherArgs, args.slice(start + 1));
        return func.apply(this, otherArgs);
    };
}
/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */ function $d9f487426e0f9b59$var$wrapImmutable(func, cloner) {
    return function() {
        var length = arguments.length;
        if (!length) return;
        var args = Array(length);
        while(length--)args[length] = arguments[length];
        var result = args[0] = cloner.apply(undefined, args);
        func.apply(undefined, args);
        return result;
    };
}
/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */ function $d9f487426e0f9b59$var$baseConvert(util, name, func, options) {
    var isLib = typeof name == 'function', isObj = name === Object(name);
    if (isObj) {
        options = func;
        func = name;
        name = undefined;
    }
    if (func == null) throw new TypeError;
    options || (options = {});
    var config = {
        'cap': 'cap' in options ? options.cap : true,
        'curry': 'curry' in options ? options.curry : true,
        'fixed': 'fixed' in options ? options.fixed : true,
        'immutable': 'immutable' in options ? options.immutable : true,
        'rearg': 'rearg' in options ? options.rearg : true
    };
    var defaultHolder = isLib ? func : $aPsMW, forceCurry = 'curry' in options && options.curry, forceFixed = 'fixed' in options && options.fixed, forceRearg = 'rearg' in options && options.rearg, pristine = isLib ? func.runInContext() : undefined;
    var helpers = isLib ? func : {
        'ary': util.ary,
        'assign': util.assign,
        'clone': util.clone,
        'curry': util.curry,
        'forEach': util.forEach,
        'isArray': util.isArray,
        'isError': util.isError,
        'isFunction': util.isFunction,
        'isWeakMap': util.isWeakMap,
        'iteratee': util.iteratee,
        'keys': util.keys,
        'rearg': util.rearg,
        'toInteger': util.toInteger,
        'toPath': util.toPath
    };
    var ary = helpers.ary, assign = helpers.assign, clone = helpers.clone, curry = helpers.curry, each = helpers.forEach, isArray = helpers.isArray, isError = helpers.isError, isFunction = helpers.isFunction, isWeakMap = helpers.isWeakMap, keys = helpers.keys, rearg = helpers.rearg, toInteger = helpers.toInteger, toPath = helpers.toPath;
    var aryMethodKeys = keys($lTdwm.aryMethod);
    var wrappers = {
        'castArray': function(castArray) {
            return function() {
                var value = arguments[0];
                return isArray(value) ? castArray($d9f487426e0f9b59$var$cloneArray(value)) : castArray.apply(undefined, arguments);
            };
        },
        'iteratee': function(iteratee) {
            return function() {
                var func = arguments[0], arity = arguments[1], result = iteratee(func, arity), length = result.length;
                if (config.cap && typeof arity == 'number') {
                    arity = arity > 2 ? arity - 2 : 1;
                    return length && length <= arity ? result : $d9f487426e0f9b59$var$baseAry(result, arity);
                }
                return result;
            };
        },
        'mixin': function(mixin) {
            return function(source) {
                var func = this;
                if (!isFunction(func)) return mixin(func, Object(source));
                var pairs = [];
                each(keys(source), function(key) {
                    if (isFunction(source[key])) pairs.push([
                        key,
                        func.prototype[key]
                    ]);
                });
                mixin(func, Object(source));
                each(pairs, function(pair) {
                    var value = pair[1];
                    if (isFunction(value)) func.prototype[pair[0]] = value;
                    else delete func.prototype[pair[0]];
                });
                return func;
            };
        },
        'nthArg': function(nthArg) {
            return function(n) {
                var arity = n < 0 ? 1 : toInteger(n) + 1;
                return curry(nthArg(n), arity);
            };
        },
        'rearg': function(rearg) {
            return function(func, indexes) {
                var arity = indexes ? indexes.length : 0;
                return curry(rearg(func, indexes), arity);
            };
        },
        'runInContext': function(runInContext) {
            return function(context) {
                return $d9f487426e0f9b59$var$baseConvert(util, runInContext(context), options);
            };
        }
    };
    /*--------------------------------------------------------------------------*/ /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */ function castCap(name, func) {
        if (config.cap) {
            var indexes = $lTdwm.iterateeRearg[name];
            if (indexes) return iterateeRearg(func, indexes);
            var n = !isLib && $lTdwm.iterateeAry[name];
            if (n) return iterateeAry(func, n);
        }
        return func;
    }
    /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */ function castCurry(name, func, n) {
        return forceCurry || config.curry && n > 1 ? curry(func, n) : func;
    }
    /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */ function castFixed(name, func, n) {
        if (config.fixed && (forceFixed || !$lTdwm.skipFixed[name])) {
            var data = $lTdwm.methodSpread[name], start = data && data.start;
            return start === undefined ? ary(func, n) : $d9f487426e0f9b59$var$flatSpread(func, start);
        }
        return func;
    }
    /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */ function castRearg(name, func, n) {
        return config.rearg && n > 1 && (forceRearg || !$lTdwm.skipRearg[name]) ? rearg(func, $lTdwm.methodRearg[name] || $lTdwm.aryRearg[n]) : func;
    }
    /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */ function cloneByPath(object, path) {
        path = toPath(path);
        var index = -1, length = path.length, lastIndex = length - 1, result = clone(Object(object)), nested = result;
        while(nested != null && ++index < length){
            var key = path[index], value = nested[key];
            if (value != null && !(isFunction(value) || isError(value) || isWeakMap(value))) nested[key] = clone(index == lastIndex ? value : Object(value));
            nested = nested[key];
        }
        return result;
    }
    /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */ function convertLib(options) {
        return _.runInContext.convert(options)(undefined);
    }
    /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */ function createConverter(name, func) {
        var realName = $lTdwm.aliasToReal[name] || name, methodName = $lTdwm.remap[realName] || realName, oldOptions = options;
        return function(options) {
            var newUtil = isLib ? pristine : helpers, newFunc = isLib ? pristine[methodName] : func, newOptions = assign(assign({}, oldOptions), options);
            return $d9f487426e0f9b59$var$baseConvert(newUtil, realName, newFunc, newOptions);
        };
    }
    /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */ function iterateeAry(func, n) {
        return overArg(func, function(func) {
            return typeof func == 'function' ? $d9f487426e0f9b59$var$baseAry(func, n) : func;
        });
    }
    /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */ function iterateeRearg(func, indexes) {
        return overArg(func, function(func) {
            var n = indexes.length;
            return $d9f487426e0f9b59$var$baseArity(rearg($d9f487426e0f9b59$var$baseAry(func, n), indexes), n);
        });
    }
    /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function() {
            var length = arguments.length;
            if (!length) return func();
            var args = Array(length);
            while(length--)args[length] = arguments[length];
            var index = config.rearg ? 0 : length - 1;
            args[index] = transform(args[index]);
            return func.apply(undefined, args);
        };
    }
    /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */ function wrap(name, func, placeholder) {
        var result, realName = $lTdwm.aliasToReal[name] || name, wrapped = func, wrapper = wrappers[realName];
        if (wrapper) wrapped = wrapper(func);
        else if (config.immutable) {
            if ($lTdwm.mutate.array[realName]) wrapped = $d9f487426e0f9b59$var$wrapImmutable(func, $d9f487426e0f9b59$var$cloneArray);
            else if ($lTdwm.mutate.object[realName]) wrapped = $d9f487426e0f9b59$var$wrapImmutable(func, $d9f487426e0f9b59$var$createCloner(func));
            else if ($lTdwm.mutate.set[realName]) wrapped = $d9f487426e0f9b59$var$wrapImmutable(func, cloneByPath);
        }
        each(aryMethodKeys, function(aryKey) {
            each($lTdwm.aryMethod[aryKey], function(otherName) {
                if (realName == otherName) {
                    var data = $lTdwm.methodSpread[realName], afterRearg = data && data.afterRearg;
                    result = afterRearg ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey) : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);
                    result = castCap(realName, result);
                    result = castCurry(realName, result, aryKey);
                    return false;
                }
            });
            return !result;
        });
        result || (result = wrapped);
        if (result == func) result = forceCurry ? curry(result, 1) : function() {
            return func.apply(this, arguments);
        };
        result.convert = createConverter(realName, func);
        result.placeholder = func.placeholder = placeholder;
        return result;
    }
    /*--------------------------------------------------------------------------*/ if (!isObj) return wrap(name, func, defaultHolder);
    var _ = func;
    // Convert methods by ary cap.
    var pairs = [];
    each(aryMethodKeys, function(aryKey) {
        each($lTdwm.aryMethod[aryKey], function(key) {
            var func = _[$lTdwm.remap[key] || key];
            if (func) pairs.push([
                key,
                wrap(key, func, _)
            ]);
        });
    });
    // Convert remaining methods.
    each(keys(_), function(key) {
        var func = _[key];
        if (typeof func == 'function') {
            var length = pairs.length;
            while(length--){
                if (pairs[length][0] == key) return;
            }
            func.convert = createConverter(key, func);
            pairs.push([
                key,
                func
            ]);
        }
    });
    // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
    each(pairs, function(pair) {
        _[pair[0]] = pair[1];
    });
    _.convert = convertLib;
    _.placeholder = _;
    // Assign aliases.
    each(keys(_), function(key) {
        each($lTdwm.realToAlias[key] || [], function(alias) {
            _[alias] = _[key];
        });
    });
    return _;
}
module.exports = $d9f487426e0f9b59$var$baseConvert;

});
parcelRegister("lTdwm", function(module, exports) {

$parcel$export(module.exports, "aliasToReal", () => $fef938fb92c31507$export$bd0f5e6e44efa6b4, (v) => $fef938fb92c31507$export$bd0f5e6e44efa6b4 = v);
$parcel$export(module.exports, "aryMethod", () => $fef938fb92c31507$export$85c665b4d7da9cb4, (v) => $fef938fb92c31507$export$85c665b4d7da9cb4 = v);
$parcel$export(module.exports, "aryRearg", () => $fef938fb92c31507$export$42564e045b285e32, (v) => $fef938fb92c31507$export$42564e045b285e32 = v);
$parcel$export(module.exports, "iterateeAry", () => $fef938fb92c31507$export$81e17196e6a22b07, (v) => $fef938fb92c31507$export$81e17196e6a22b07 = v);
$parcel$export(module.exports, "iterateeRearg", () => $fef938fb92c31507$export$30975ceb42167ebd, (v) => $fef938fb92c31507$export$30975ceb42167ebd = v);
$parcel$export(module.exports, "methodRearg", () => $fef938fb92c31507$export$8ceb0ad7e94d3801, (v) => $fef938fb92c31507$export$8ceb0ad7e94d3801 = v);
$parcel$export(module.exports, "methodSpread", () => $fef938fb92c31507$export$fbaeb3f87df3cf26, (v) => $fef938fb92c31507$export$fbaeb3f87df3cf26 = v);
$parcel$export(module.exports, "mutate", () => $fef938fb92c31507$export$57e795267c26e600, (v) => $fef938fb92c31507$export$57e795267c26e600 = v);
$parcel$export(module.exports, "realToAlias", () => $fef938fb92c31507$export$1eb71a7e27943e71, (v) => $fef938fb92c31507$export$1eb71a7e27943e71 = v);
$parcel$export(module.exports, "remap", () => $fef938fb92c31507$export$aee1dbae5de2db9d, (v) => $fef938fb92c31507$export$aee1dbae5de2db9d = v);
$parcel$export(module.exports, "skipFixed", () => $fef938fb92c31507$export$87ffbe4821a5d5e0, (v) => $fef938fb92c31507$export$87ffbe4821a5d5e0 = v);
$parcel$export(module.exports, "skipRearg", () => $fef938fb92c31507$export$b4d07413ce528c90, (v) => $fef938fb92c31507$export$b4d07413ce528c90 = v);
/** Used to map aliases to their real names. */ var $fef938fb92c31507$export$bd0f5e6e44efa6b4;
/** Used to map ary to method names. */ var $fef938fb92c31507$export$85c665b4d7da9cb4;
/** Used to map ary to rearg configs. */ var $fef938fb92c31507$export$42564e045b285e32;
/** Used to map method names to their iteratee ary. */ var $fef938fb92c31507$export$81e17196e6a22b07;
/** Used to map method names to iteratee rearg configs. */ var $fef938fb92c31507$export$30975ceb42167ebd;
/** Used to map method names to rearg configs. */ var $fef938fb92c31507$export$8ceb0ad7e94d3801;
/** Used to map method names to spread configs. */ var $fef938fb92c31507$export$fbaeb3f87df3cf26;
/** Used to identify methods which mutate arrays or objects. */ var $fef938fb92c31507$export$57e795267c26e600;
/** Used to map real names to their aliases. */ var $fef938fb92c31507$export$1eb71a7e27943e71;
/** Used to map method names to other names. */ var $fef938fb92c31507$export$aee1dbae5de2db9d;
/** Used to track methods that skip fixing their arity. */ var $fef938fb92c31507$export$87ffbe4821a5d5e0;
/** Used to track methods that skip rearranging arguments. */ var $fef938fb92c31507$export$b4d07413ce528c90;
$fef938fb92c31507$export$bd0f5e6e44efa6b4 = {
    // Lodash aliases.
    'each': 'forEach',
    'eachRight': 'forEachRight',
    'entries': 'toPairs',
    'entriesIn': 'toPairsIn',
    'extend': 'assignIn',
    'extendAll': 'assignInAll',
    'extendAllWith': 'assignInAllWith',
    'extendWith': 'assignInWith',
    'first': 'head',
    // Methods that are curried variants of others.
    'conforms': 'conformsTo',
    'matches': 'isMatch',
    'property': 'get',
    // Ramda aliases.
    '__': 'placeholder',
    'F': 'stubFalse',
    'T': 'stubTrue',
    'all': 'every',
    'allPass': 'overEvery',
    'always': 'constant',
    'any': 'some',
    'anyPass': 'overSome',
    'apply': 'spread',
    'assoc': 'set',
    'assocPath': 'set',
    'complement': 'negate',
    'compose': 'flowRight',
    'contains': 'includes',
    'dissoc': 'unset',
    'dissocPath': 'unset',
    'dropLast': 'dropRight',
    'dropLastWhile': 'dropRightWhile',
    'equals': 'isEqual',
    'identical': 'eq',
    'indexBy': 'keyBy',
    'init': 'initial',
    'invertObj': 'invert',
    'juxt': 'over',
    'omitAll': 'omit',
    'nAry': 'ary',
    'path': 'get',
    'pathEq': 'matchesProperty',
    'pathOr': 'getOr',
    'paths': 'at',
    'pickAll': 'pick',
    'pipe': 'flow',
    'pluck': 'map',
    'prop': 'get',
    'propEq': 'matchesProperty',
    'propOr': 'getOr',
    'props': 'at',
    'symmetricDifference': 'xor',
    'symmetricDifferenceBy': 'xorBy',
    'symmetricDifferenceWith': 'xorWith',
    'takeLast': 'takeRight',
    'takeLastWhile': 'takeRightWhile',
    'unapply': 'rest',
    'unnest': 'flatten',
    'useWith': 'overArgs',
    'where': 'conformsTo',
    'whereEq': 'isMatch',
    'zipObj': 'zipObject'
};
$fef938fb92c31507$export$85c665b4d7da9cb4 = {
    '1': [
        'assignAll',
        'assignInAll',
        'attempt',
        'castArray',
        'ceil',
        'create',
        'curry',
        'curryRight',
        'defaultsAll',
        'defaultsDeepAll',
        'floor',
        'flow',
        'flowRight',
        'fromPairs',
        'invert',
        'iteratee',
        'memoize',
        'method',
        'mergeAll',
        'methodOf',
        'mixin',
        'nthArg',
        'over',
        'overEvery',
        'overSome',
        'rest',
        'reverse',
        'round',
        'runInContext',
        'spread',
        'template',
        'trim',
        'trimEnd',
        'trimStart',
        'uniqueId',
        'words',
        'zipAll'
    ],
    '2': [
        'add',
        'after',
        'ary',
        'assign',
        'assignAllWith',
        'assignIn',
        'assignInAllWith',
        'at',
        'before',
        'bind',
        'bindAll',
        'bindKey',
        'chunk',
        'cloneDeepWith',
        'cloneWith',
        'concat',
        'conformsTo',
        'countBy',
        'curryN',
        'curryRightN',
        'debounce',
        'defaults',
        'defaultsDeep',
        'defaultTo',
        'delay',
        'difference',
        'divide',
        'drop',
        'dropRight',
        'dropRightWhile',
        'dropWhile',
        'endsWith',
        'eq',
        'every',
        'filter',
        'find',
        'findIndex',
        'findKey',
        'findLast',
        'findLastIndex',
        'findLastKey',
        'flatMap',
        'flatMapDeep',
        'flattenDepth',
        'forEach',
        'forEachRight',
        'forIn',
        'forInRight',
        'forOwn',
        'forOwnRight',
        'get',
        'groupBy',
        'gt',
        'gte',
        'has',
        'hasIn',
        'includes',
        'indexOf',
        'intersection',
        'invertBy',
        'invoke',
        'invokeMap',
        'isEqual',
        'isMatch',
        'join',
        'keyBy',
        'lastIndexOf',
        'lt',
        'lte',
        'map',
        'mapKeys',
        'mapValues',
        'matchesProperty',
        'maxBy',
        'meanBy',
        'merge',
        'mergeAllWith',
        'minBy',
        'multiply',
        'nth',
        'omit',
        'omitBy',
        'overArgs',
        'pad',
        'padEnd',
        'padStart',
        'parseInt',
        'partial',
        'partialRight',
        'partition',
        'pick',
        'pickBy',
        'propertyOf',
        'pull',
        'pullAll',
        'pullAt',
        'random',
        'range',
        'rangeRight',
        'rearg',
        'reject',
        'remove',
        'repeat',
        'restFrom',
        'result',
        'sampleSize',
        'some',
        'sortBy',
        'sortedIndex',
        'sortedIndexOf',
        'sortedLastIndex',
        'sortedLastIndexOf',
        'sortedUniqBy',
        'split',
        'spreadFrom',
        'startsWith',
        'subtract',
        'sumBy',
        'take',
        'takeRight',
        'takeRightWhile',
        'takeWhile',
        'tap',
        'throttle',
        'thru',
        'times',
        'trimChars',
        'trimCharsEnd',
        'trimCharsStart',
        'truncate',
        'union',
        'uniqBy',
        'uniqWith',
        'unset',
        'unzipWith',
        'without',
        'wrap',
        'xor',
        'zip',
        'zipObject',
        'zipObjectDeep'
    ],
    '3': [
        'assignInWith',
        'assignWith',
        'clamp',
        'differenceBy',
        'differenceWith',
        'findFrom',
        'findIndexFrom',
        'findLastFrom',
        'findLastIndexFrom',
        'getOr',
        'includesFrom',
        'indexOfFrom',
        'inRange',
        'intersectionBy',
        'intersectionWith',
        'invokeArgs',
        'invokeArgsMap',
        'isEqualWith',
        'isMatchWith',
        'flatMapDepth',
        'lastIndexOfFrom',
        'mergeWith',
        'orderBy',
        'padChars',
        'padCharsEnd',
        'padCharsStart',
        'pullAllBy',
        'pullAllWith',
        'rangeStep',
        'rangeStepRight',
        'reduce',
        'reduceRight',
        'replace',
        'set',
        'slice',
        'sortedIndexBy',
        'sortedLastIndexBy',
        'transform',
        'unionBy',
        'unionWith',
        'update',
        'xorBy',
        'xorWith',
        'zipWith'
    ],
    '4': [
        'fill',
        'setWith',
        'updateWith'
    ]
};
$fef938fb92c31507$export$42564e045b285e32 = {
    '2': [
        1,
        0
    ],
    '3': [
        2,
        0,
        1
    ],
    '4': [
        3,
        2,
        0,
        1
    ]
};
$fef938fb92c31507$export$81e17196e6a22b07 = {
    'dropRightWhile': 1,
    'dropWhile': 1,
    'every': 1,
    'filter': 1,
    'find': 1,
    'findFrom': 1,
    'findIndex': 1,
    'findIndexFrom': 1,
    'findKey': 1,
    'findLast': 1,
    'findLastFrom': 1,
    'findLastIndex': 1,
    'findLastIndexFrom': 1,
    'findLastKey': 1,
    'flatMap': 1,
    'flatMapDeep': 1,
    'flatMapDepth': 1,
    'forEach': 1,
    'forEachRight': 1,
    'forIn': 1,
    'forInRight': 1,
    'forOwn': 1,
    'forOwnRight': 1,
    'map': 1,
    'mapKeys': 1,
    'mapValues': 1,
    'partition': 1,
    'reduce': 2,
    'reduceRight': 2,
    'reject': 1,
    'remove': 1,
    'some': 1,
    'takeRightWhile': 1,
    'takeWhile': 1,
    'times': 1,
    'transform': 2
};
$fef938fb92c31507$export$30975ceb42167ebd = {
    'mapKeys': [
        1
    ],
    'reduceRight': [
        1,
        0
    ]
};
$fef938fb92c31507$export$8ceb0ad7e94d3801 = {
    'assignInAllWith': [
        1,
        0
    ],
    'assignInWith': [
        1,
        2,
        0
    ],
    'assignAllWith': [
        1,
        0
    ],
    'assignWith': [
        1,
        2,
        0
    ],
    'differenceBy': [
        1,
        2,
        0
    ],
    'differenceWith': [
        1,
        2,
        0
    ],
    'getOr': [
        2,
        1,
        0
    ],
    'intersectionBy': [
        1,
        2,
        0
    ],
    'intersectionWith': [
        1,
        2,
        0
    ],
    'isEqualWith': [
        1,
        2,
        0
    ],
    'isMatchWith': [
        2,
        1,
        0
    ],
    'mergeAllWith': [
        1,
        0
    ],
    'mergeWith': [
        1,
        2,
        0
    ],
    'padChars': [
        2,
        1,
        0
    ],
    'padCharsEnd': [
        2,
        1,
        0
    ],
    'padCharsStart': [
        2,
        1,
        0
    ],
    'pullAllBy': [
        2,
        1,
        0
    ],
    'pullAllWith': [
        2,
        1,
        0
    ],
    'rangeStep': [
        1,
        2,
        0
    ],
    'rangeStepRight': [
        1,
        2,
        0
    ],
    'setWith': [
        3,
        1,
        2,
        0
    ],
    'sortedIndexBy': [
        2,
        1,
        0
    ],
    'sortedLastIndexBy': [
        2,
        1,
        0
    ],
    'unionBy': [
        1,
        2,
        0
    ],
    'unionWith': [
        1,
        2,
        0
    ],
    'updateWith': [
        3,
        1,
        2,
        0
    ],
    'xorBy': [
        1,
        2,
        0
    ],
    'xorWith': [
        1,
        2,
        0
    ],
    'zipWith': [
        1,
        2,
        0
    ]
};
$fef938fb92c31507$export$fbaeb3f87df3cf26 = {
    'assignAll': {
        'start': 0
    },
    'assignAllWith': {
        'start': 0
    },
    'assignInAll': {
        'start': 0
    },
    'assignInAllWith': {
        'start': 0
    },
    'defaultsAll': {
        'start': 0
    },
    'defaultsDeepAll': {
        'start': 0
    },
    'invokeArgs': {
        'start': 2
    },
    'invokeArgsMap': {
        'start': 2
    },
    'mergeAll': {
        'start': 0
    },
    'mergeAllWith': {
        'start': 0
    },
    'partial': {
        'start': 1
    },
    'partialRight': {
        'start': 1
    },
    'without': {
        'start': 1
    },
    'zipAll': {
        'start': 0
    }
};
$fef938fb92c31507$export$57e795267c26e600 = {
    'array': {
        'fill': true,
        'pull': true,
        'pullAll': true,
        'pullAllBy': true,
        'pullAllWith': true,
        'pullAt': true,
        'remove': true,
        'reverse': true
    },
    'object': {
        'assign': true,
        'assignAll': true,
        'assignAllWith': true,
        'assignIn': true,
        'assignInAll': true,
        'assignInAllWith': true,
        'assignInWith': true,
        'assignWith': true,
        'defaults': true,
        'defaultsAll': true,
        'defaultsDeep': true,
        'defaultsDeepAll': true,
        'merge': true,
        'mergeAll': true,
        'mergeAllWith': true,
        'mergeWith': true
    },
    'set': {
        'set': true,
        'setWith': true,
        'unset': true,
        'update': true,
        'updateWith': true
    }
};
$fef938fb92c31507$export$1eb71a7e27943e71 = function() {
    var hasOwnProperty = Object.prototype.hasOwnProperty, object = $fef938fb92c31507$export$bd0f5e6e44efa6b4, result = {};
    for(var key in object){
        var value = object[key];
        if (hasOwnProperty.call(result, value)) result[value].push(key);
        else result[value] = [
            key
        ];
    }
    return result;
}();
$fef938fb92c31507$export$aee1dbae5de2db9d = {
    'assignAll': 'assign',
    'assignAllWith': 'assignWith',
    'assignInAll': 'assignIn',
    'assignInAllWith': 'assignInWith',
    'curryN': 'curry',
    'curryRightN': 'curryRight',
    'defaultsAll': 'defaults',
    'defaultsDeepAll': 'defaultsDeep',
    'findFrom': 'find',
    'findIndexFrom': 'findIndex',
    'findLastFrom': 'findLast',
    'findLastIndexFrom': 'findLastIndex',
    'getOr': 'get',
    'includesFrom': 'includes',
    'indexOfFrom': 'indexOf',
    'invokeArgs': 'invoke',
    'invokeArgsMap': 'invokeMap',
    'lastIndexOfFrom': 'lastIndexOf',
    'mergeAll': 'merge',
    'mergeAllWith': 'mergeWith',
    'padChars': 'pad',
    'padCharsEnd': 'padEnd',
    'padCharsStart': 'padStart',
    'propertyOf': 'get',
    'rangeStep': 'range',
    'rangeStepRight': 'rangeRight',
    'restFrom': 'rest',
    'spreadFrom': 'spread',
    'trimChars': 'trim',
    'trimCharsEnd': 'trimEnd',
    'trimCharsStart': 'trimStart',
    'zipAll': 'zip'
};
$fef938fb92c31507$export$87ffbe4821a5d5e0 = {
    'castArray': true,
    'flow': true,
    'flowRight': true,
    'iteratee': true,
    'mixin': true,
    'rearg': true,
    'runInContext': true
};
$fef938fb92c31507$export$b4d07413ce528c90 = {
    'add': true,
    'assign': true,
    'assignIn': true,
    'bind': true,
    'bindKey': true,
    'concat': true,
    'difference': true,
    'divide': true,
    'eq': true,
    'gt': true,
    'gte': true,
    'isEqual': true,
    'lt': true,
    'lte': true,
    'matchesProperty': true,
    'merge': true,
    'multiply': true,
    'overArgs': true,
    'partial': true,
    'partialRight': true,
    'propertyOf': true,
    'random': true,
    'range': true,
    'rangeRight': true,
    'subtract': true,
    'zip': true,
    'zipObject': true,
    'zipObjectDeep': true
};

});

parcelRegister("aPsMW", function(module, exports) {
/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */ module.exports = {};

});


parcelRegister("7sR67", function(module, exports) {














module.exports = {
    'ary': (parcelRequire("lEyvi")),
    'assign': (parcelRequire("bqJNK")),
    'clone': (parcelRequire("91VA7")),
    'curry': (parcelRequire("a7NzZ")),
    'forEach': (parcelRequire("fmP8r")),
    'isArray': (parcelRequire("8LQ84")),
    'isError': (parcelRequire("aZFhV")),
    'isFunction': (parcelRequire("5vD8v")),
    'isWeakMap': (parcelRequire("5UxIS")),
    'iteratee': (parcelRequire("5qDt4")),
    'keys': (parcelRequire("hR3Ue")),
    'rearg': (parcelRequire("iZlmO")),
    'toInteger': (parcelRequire("kPZpS")),
    'toPath': (parcelRequire("6TYHJ"))
};

});
parcelRegister("lEyvi", function(module, exports) {

var $5oTQF = parcelRequire("5oTQF");
/** Used to compose bitmasks for function metadata. */ var $fc3819207d6eebc6$var$WRAP_ARY_FLAG = 128;
/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */ function $fc3819207d6eebc6$var$ary(func, n, guard) {
    n = guard ? undefined : n;
    n = func && n == null ? func.length : n;
    return $5oTQF(func, $fc3819207d6eebc6$var$WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
}
module.exports = $fc3819207d6eebc6$var$ary;

});
parcelRegister("5oTQF", function(module, exports) {

var $g1o5k = parcelRequire("g1o5k");

var $1BSxH = parcelRequire("1BSxH");

var $gQoGK = parcelRequire("gQoGK");

var $2pq1V = parcelRequire("2pq1V");

var $cwXqG = parcelRequire("cwXqG");

var $dzqxs = parcelRequire("dzqxs");

var $c8pf3 = parcelRequire("c8pf3");

var $4EzKU = parcelRequire("4EzKU");

var $iKqmZ = parcelRequire("iKqmZ");

var $kPZpS = parcelRequire("kPZpS");
/** Error message constants. */ var $3eea84024a50d6cf$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used to compose bitmasks for function metadata. */ var $3eea84024a50d6cf$var$WRAP_BIND_FLAG = 1, $3eea84024a50d6cf$var$WRAP_BIND_KEY_FLAG = 2, $3eea84024a50d6cf$var$WRAP_CURRY_FLAG = 8, $3eea84024a50d6cf$var$WRAP_CURRY_RIGHT_FLAG = 16, $3eea84024a50d6cf$var$WRAP_PARTIAL_FLAG = 32, $3eea84024a50d6cf$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $3eea84024a50d6cf$var$nativeMax = Math.max;
/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $3eea84024a50d6cf$var$createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
    var isBindKey = bitmask & $3eea84024a50d6cf$var$WRAP_BIND_KEY_FLAG;
    if (!isBindKey && typeof func != 'function') throw new TypeError($3eea84024a50d6cf$var$FUNC_ERROR_TEXT);
    var length = partials ? partials.length : 0;
    if (!length) {
        bitmask &= ~($3eea84024a50d6cf$var$WRAP_PARTIAL_FLAG | $3eea84024a50d6cf$var$WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
    }
    ary = ary === undefined ? ary : $3eea84024a50d6cf$var$nativeMax($kPZpS(ary), 0);
    arity = arity === undefined ? arity : $kPZpS(arity);
    length -= holders ? holders.length : 0;
    if (bitmask & $3eea84024a50d6cf$var$WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials, holdersRight = holders;
        partials = holders = undefined;
    }
    var data = isBindKey ? undefined : $dzqxs(func);
    var newData = [
        func,
        bitmask,
        thisArg,
        partials,
        holders,
        partialsRight,
        holdersRight,
        argPos,
        ary,
        arity
    ];
    if (data) $c8pf3(newData, data);
    func = newData[0];
    bitmask = newData[1];
    thisArg = newData[2];
    partials = newData[3];
    holders = newData[4];
    arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : $3eea84024a50d6cf$var$nativeMax(newData[9] - length, 0);
    if (!arity && bitmask & ($3eea84024a50d6cf$var$WRAP_CURRY_FLAG | $3eea84024a50d6cf$var$WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~($3eea84024a50d6cf$var$WRAP_CURRY_FLAG | $3eea84024a50d6cf$var$WRAP_CURRY_RIGHT_FLAG);
    if (!bitmask || bitmask == $3eea84024a50d6cf$var$WRAP_BIND_FLAG) var result = $1BSxH(func, bitmask, thisArg);
    else if (bitmask == $3eea84024a50d6cf$var$WRAP_CURRY_FLAG || bitmask == $3eea84024a50d6cf$var$WRAP_CURRY_RIGHT_FLAG) result = $gQoGK(func, bitmask, arity);
    else if ((bitmask == $3eea84024a50d6cf$var$WRAP_PARTIAL_FLAG || bitmask == ($3eea84024a50d6cf$var$WRAP_BIND_FLAG | $3eea84024a50d6cf$var$WRAP_PARTIAL_FLAG)) && !holders.length) result = $cwXqG(func, bitmask, thisArg, partials);
    else result = $2pq1V.apply(undefined, newData);
    var setter = data ? $g1o5k : $4EzKU;
    return $iKqmZ(setter(result, newData), func, bitmask);
}
module.exports = $3eea84024a50d6cf$var$createWrap;

});
parcelRegister("g1o5k", function(module, exports) {

var $etyzk = parcelRequire("etyzk");

var $hQCy5 = parcelRequire("hQCy5");
/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var $ba9f6c1d52531584$var$baseSetData = !$hQCy5 ? $etyzk : function(func, data) {
    $hQCy5.set(func, data);
    return func;
};
module.exports = $ba9f6c1d52531584$var$baseSetData;

});
parcelRegister("hQCy5", function(module, exports) {

var $kUWNo = parcelRequire("kUWNo");
/** Used to store function metadata. */ var $cfe531f816dee27d$var$metaMap = $kUWNo && new $kUWNo;
module.exports = $cfe531f816dee27d$var$metaMap;

});


parcelRegister("1BSxH", function(module, exports) {

var $iJkMv = parcelRequire("iJkMv");

var $1V15E = parcelRequire("1V15E");
/** Used to compose bitmasks for function metadata. */ var $12c38e2c5009183b$var$WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $12c38e2c5009183b$var$createBind(func, bitmask, thisArg) {
    var isBind = bitmask & $12c38e2c5009183b$var$WRAP_BIND_FLAG, Ctor = $iJkMv(func);
    function wrapper() {
        var fn = this && this !== $1V15E && this instanceof wrapper ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
    }
    return wrapper;
}
module.exports = $12c38e2c5009183b$var$createBind;

});
parcelRegister("iJkMv", function(module, exports) {

var $ady43 = parcelRequire("ady43");

var $k0qYG = parcelRequire("k0qYG");
/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */ function $da2c8caf7ae3955a$var$createCtor(Ctor) {
    return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch(args.length){
            case 0:
                return new Ctor;
            case 1:
                return new Ctor(args[0]);
            case 2:
                return new Ctor(args[0], args[1]);
            case 3:
                return new Ctor(args[0], args[1], args[2]);
            case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = $ady43(Ctor.prototype), result = Ctor.apply(thisBinding, args);
        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return $k0qYG(result) ? result : thisBinding;
    };
}
module.exports = $da2c8caf7ae3955a$var$createCtor;

});


parcelRegister("gQoGK", function(module, exports) {

var $hlchF = parcelRequire("hlchF");

var $iJkMv = parcelRequire("iJkMv");

var $2pq1V = parcelRequire("2pq1V");

var $6fuEo = parcelRequire("6fuEo");

var $8ZIC5 = parcelRequire("8ZIC5");

var $kBUUu = parcelRequire("kBUUu");

var $1V15E = parcelRequire("1V15E");
/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $c434a7442e0e841e$var$createCurry(func, bitmask, arity) {
    var Ctor = $iJkMv(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length, placeholder = $8ZIC5(wrapper);
        while(index--)args[index] = arguments[index];
        var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : $kBUUu(args, placeholder);
        length -= holders.length;
        if (length < arity) return $6fuEo(func, bitmask, $2pq1V, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
        var fn = this && this !== $1V15E && this instanceof wrapper ? Ctor : func;
        return $hlchF(fn, this, args);
    }
    return wrapper;
}
module.exports = $c434a7442e0e841e$var$createCurry;

});
parcelRegister("2pq1V", function(module, exports) {

var $k8MLc = parcelRequire("k8MLc");

var $eqXBf = parcelRequire("eqXBf");

var $khpbX = parcelRequire("khpbX");

var $iJkMv = parcelRequire("iJkMv");

var $6fuEo = parcelRequire("6fuEo");

var $8ZIC5 = parcelRequire("8ZIC5");

var $3Prcz = parcelRequire("3Prcz");

var $kBUUu = parcelRequire("kBUUu");

var $1V15E = parcelRequire("1V15E");
/** Used to compose bitmasks for function metadata. */ var $1c121b92b9034c1f$var$WRAP_BIND_FLAG = 1, $1c121b92b9034c1f$var$WRAP_BIND_KEY_FLAG = 2, $1c121b92b9034c1f$var$WRAP_CURRY_FLAG = 8, $1c121b92b9034c1f$var$WRAP_CURRY_RIGHT_FLAG = 16, $1c121b92b9034c1f$var$WRAP_ARY_FLAG = 128, $1c121b92b9034c1f$var$WRAP_FLIP_FLAG = 512;
/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $1c121b92b9034c1f$var$createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
    var isAry = bitmask & $1c121b92b9034c1f$var$WRAP_ARY_FLAG, isBind = bitmask & $1c121b92b9034c1f$var$WRAP_BIND_FLAG, isBindKey = bitmask & $1c121b92b9034c1f$var$WRAP_BIND_KEY_FLAG, isCurried = bitmask & ($1c121b92b9034c1f$var$WRAP_CURRY_FLAG | $1c121b92b9034c1f$var$WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & $1c121b92b9034c1f$var$WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : $iJkMv(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length;
        while(index--)args[index] = arguments[index];
        if (isCurried) var placeholder = $8ZIC5(wrapper), holdersCount = $khpbX(args, placeholder);
        if (partials) args = $k8MLc(args, partials, holders, isCurried);
        if (partialsRight) args = $eqXBf(args, partialsRight, holdersRight, isCurried);
        length -= holdersCount;
        if (isCurried && length < arity) {
            var newHolders = $kBUUu(args, placeholder);
            return $6fuEo(func, bitmask, $1c121b92b9034c1f$var$createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
        }
        var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
        length = args.length;
        if (argPos) args = $3Prcz(args, argPos);
        else if (isFlip && length > 1) args.reverse();
        if (isAry && ary < length) args.length = ary;
        if (this && this !== $1V15E && this instanceof wrapper) fn = Ctor || $iJkMv(fn);
        return fn.apply(thisBinding, args);
    }
    return wrapper;
}
module.exports = $1c121b92b9034c1f$var$createHybrid;

});
parcelRegister("k8MLc", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ea9a60ca966f8da9$var$nativeMax = Math.max;
/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function $ea9a60ca966f8da9$var$composeArgs(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = $ea9a60ca966f8da9$var$nativeMax(argsLength - holdersLength, 0), result = Array(leftLength + rangeLength), isUncurried = !isCurried;
    while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
    while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
    while(rangeLength--)result[leftIndex++] = args[argsIndex++];
    return result;
}
module.exports = $ea9a60ca966f8da9$var$composeArgs;

});

parcelRegister("eqXBf", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $a821b9ab167c5b82$var$nativeMax = Math.max;
/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function $a821b9ab167c5b82$var$composeArgsRight(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = $a821b9ab167c5b82$var$nativeMax(argsLength - holdersLength, 0), result = Array(rangeLength + rightLength), isUncurried = !isCurried;
    while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
    var offset = argsIndex;
    while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
    while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
    return result;
}
module.exports = $a821b9ab167c5b82$var$composeArgsRight;

});

parcelRegister("khpbX", function(module, exports) {
/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */ function $ec38efbc1ab3f809$var$countHolders(array, placeholder) {
    var length = array.length, result = 0;
    while(length--)if (array[length] === placeholder) ++result;
    return result;
}
module.exports = $ec38efbc1ab3f809$var$countHolders;

});

parcelRegister("6fuEo", function(module, exports) {

var $2dCKt = parcelRequire("2dCKt");

var $4EzKU = parcelRequire("4EzKU");

var $iKqmZ = parcelRequire("iKqmZ");
/** Used to compose bitmasks for function metadata. */ var $48cbeb57943323d5$var$WRAP_BIND_FLAG = 1, $48cbeb57943323d5$var$WRAP_BIND_KEY_FLAG = 2, $48cbeb57943323d5$var$WRAP_CURRY_BOUND_FLAG = 4, $48cbeb57943323d5$var$WRAP_CURRY_FLAG = 8, $48cbeb57943323d5$var$WRAP_PARTIAL_FLAG = 32, $48cbeb57943323d5$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $48cbeb57943323d5$var$createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
    var isCurry = bitmask & $48cbeb57943323d5$var$WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
    bitmask |= isCurry ? $48cbeb57943323d5$var$WRAP_PARTIAL_FLAG : $48cbeb57943323d5$var$WRAP_PARTIAL_RIGHT_FLAG;
    bitmask &= ~(isCurry ? $48cbeb57943323d5$var$WRAP_PARTIAL_RIGHT_FLAG : $48cbeb57943323d5$var$WRAP_PARTIAL_FLAG);
    if (!(bitmask & $48cbeb57943323d5$var$WRAP_CURRY_BOUND_FLAG)) bitmask &= ~($48cbeb57943323d5$var$WRAP_BIND_FLAG | $48cbeb57943323d5$var$WRAP_BIND_KEY_FLAG);
    var newData = [
        func,
        bitmask,
        thisArg,
        newPartials,
        newHolders,
        newPartialsRight,
        newHoldersRight,
        argPos,
        ary,
        arity
    ];
    var result = wrapFunc.apply(undefined, newData);
    if ($2dCKt(func)) $4EzKU(result, newData);
    result.placeholder = placeholder;
    return $iKqmZ(result, func, bitmask);
}
module.exports = $48cbeb57943323d5$var$createRecurry;

});
parcelRegister("2dCKt", function(module, exports) {

var $gXHdK = parcelRequire("gXHdK");

var $dzqxs = parcelRequire("dzqxs");

var $dJhFY = parcelRequire("dJhFY");

var $h4Vl3 = parcelRequire("h4Vl3");
/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */ function $19dada4f3cc4c77d$var$isLaziable(func) {
    var funcName = $dJhFY(func), other = $h4Vl3[funcName];
    if (typeof other != 'function' || !(funcName in $gXHdK.prototype)) return false;
    if (func === other) return true;
    var data = $dzqxs(other);
    return !!data && func === data[0];
}
module.exports = $19dada4f3cc4c77d$var$isLaziable;

});
parcelRegister("gXHdK", function(module, exports) {

var $ady43 = parcelRequire("ady43");

var $dtL2K = parcelRequire("dtL2K");
/** Used as references for the maximum length and index of an array. */ var $c593aec8028eae80$var$MAX_ARRAY_LENGTH = 4294967295;
/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */ function $c593aec8028eae80$var$LazyWrapper(value) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__dir__ = 1;
    this.__filtered__ = false;
    this.__iteratees__ = [];
    this.__takeCount__ = $c593aec8028eae80$var$MAX_ARRAY_LENGTH;
    this.__views__ = [];
}
// Ensure `LazyWrapper` is an instance of `baseLodash`.
$c593aec8028eae80$var$LazyWrapper.prototype = $ady43($dtL2K.prototype);
$c593aec8028eae80$var$LazyWrapper.prototype.constructor = $c593aec8028eae80$var$LazyWrapper;
module.exports = $c593aec8028eae80$var$LazyWrapper;

});
parcelRegister("dtL2K", function(module, exports) {
/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */ function $9d02799e26f2befc$var$baseLodash() {
// No operation performed.
}
module.exports = $9d02799e26f2befc$var$baseLodash;

});


parcelRegister("dzqxs", function(module, exports) {

var $hQCy5 = parcelRequire("hQCy5");

var $8Rkzz = parcelRequire("8Rkzz");
/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */ var $9e13214619654b13$var$getData = !$hQCy5 ? $8Rkzz : function(func) {
    return $hQCy5.get(func);
};
module.exports = $9e13214619654b13$var$getData;

});

parcelRegister("dJhFY", function(module, exports) {

var $b34cU = parcelRequire("b34cU");
/** Used for built-in method references. */ var $9fed306476bd143b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9fed306476bd143b$var$hasOwnProperty = $9fed306476bd143b$var$objectProto.hasOwnProperty;
/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */ function $9fed306476bd143b$var$getFuncName(func) {
    var result = func.name + '', array = $b34cU[result], length = $9fed306476bd143b$var$hasOwnProperty.call($b34cU, result) ? array.length : 0;
    while(length--){
        var data = array[length], otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) return data.name;
    }
    return result;
}
module.exports = $9fed306476bd143b$var$getFuncName;

});
parcelRegister("b34cU", function(module, exports) {
/** Used to lookup unminified function names. */ var $80b33cfa5c78e39a$var$realNames = {};
module.exports = $80b33cfa5c78e39a$var$realNames;

});


parcelRegister("h4Vl3", function(module, exports) {

var $gXHdK = parcelRequire("gXHdK");

var $1WNhJ = parcelRequire("1WNhJ");

var $dtL2K = parcelRequire("dtL2K");

var $8LQ84 = parcelRequire("8LQ84");

var $fC1Kz = parcelRequire("fC1Kz");

var $6e2jm = parcelRequire("6e2jm");
/** Used for built-in method references. */ var $c6ef49a1bd112766$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c6ef49a1bd112766$var$hasOwnProperty = $c6ef49a1bd112766$var$objectProto.hasOwnProperty;
/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */ function $c6ef49a1bd112766$var$lodash(value) {
    if ($fC1Kz(value) && !$8LQ84(value) && !(value instanceof $gXHdK)) {
        if (value instanceof $1WNhJ) return value;
        if ($c6ef49a1bd112766$var$hasOwnProperty.call(value, '__wrapped__')) return $6e2jm(value);
    }
    return new $1WNhJ(value);
}
// Ensure wrappers are instances of `baseLodash`.
$c6ef49a1bd112766$var$lodash.prototype = $dtL2K.prototype;
$c6ef49a1bd112766$var$lodash.prototype.constructor = $c6ef49a1bd112766$var$lodash;
module.exports = $c6ef49a1bd112766$var$lodash;

});
parcelRegister("1WNhJ", function(module, exports) {

var $ady43 = parcelRequire("ady43");

var $dtL2K = parcelRequire("dtL2K");
/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */ function $16b170343299e90c$var$LodashWrapper(value, chainAll) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__chain__ = !!chainAll;
    this.__index__ = 0;
    this.__values__ = undefined;
}
$16b170343299e90c$var$LodashWrapper.prototype = $ady43($dtL2K.prototype);
$16b170343299e90c$var$LodashWrapper.prototype.constructor = $16b170343299e90c$var$LodashWrapper;
module.exports = $16b170343299e90c$var$LodashWrapper;

});

parcelRegister("6e2jm", function(module, exports) {

var $gXHdK = parcelRequire("gXHdK");

var $1WNhJ = parcelRequire("1WNhJ");

var $jHlUS = parcelRequire("jHlUS");
/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */ function $4885d7df48eb0605$var$wrapperClone(wrapper) {
    if (wrapper instanceof $gXHdK) return wrapper.clone();
    var result = new $1WNhJ(wrapper.__wrapped__, wrapper.__chain__);
    result.__actions__ = $jHlUS(wrapper.__actions__);
    result.__index__ = wrapper.__index__;
    result.__values__ = wrapper.__values__;
    return result;
}
module.exports = $4885d7df48eb0605$var$wrapperClone;

});



parcelRegister("4EzKU", function(module, exports) {

var $g1o5k = parcelRequire("g1o5k");

var $eqv0t = parcelRequire("eqv0t");
/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var $3636a22a88d50b78$var$setData = $eqv0t($g1o5k);
module.exports = $3636a22a88d50b78$var$setData;

});

parcelRegister("iKqmZ", function(module, exports) {

var $d25DY = parcelRequire("d25DY");

var $iPKwQ = parcelRequire("iPKwQ");

var $8pgNR = parcelRequire("8pgNR");

var $1ZcUe = parcelRequire("1ZcUe");
/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */ function $da60fa5a8c702882$var$setWrapToString(wrapper, reference, bitmask) {
    var source = reference + '';
    return $8pgNR(wrapper, $iPKwQ(source, $1ZcUe($d25DY(source), bitmask)));
}
module.exports = $da60fa5a8c702882$var$setWrapToString;

});
parcelRegister("d25DY", function(module, exports) {
/** Used to match wrap detail comments. */ var $97cfd7023a392295$var$reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, $97cfd7023a392295$var$reSplitDetails = /,? & /;
/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */ function $97cfd7023a392295$var$getWrapDetails(source) {
    var match = source.match($97cfd7023a392295$var$reWrapDetails);
    return match ? match[1].split($97cfd7023a392295$var$reSplitDetails) : [];
}
module.exports = $97cfd7023a392295$var$getWrapDetails;

});

parcelRegister("iPKwQ", function(module, exports) {
/** Used to match wrap detail comments. */ var $db61150bcd231438$var$reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */ function $db61150bcd231438$var$insertWrapDetails(source, details) {
    var length = details.length;
    if (!length) return source;
    var lastIndex = length - 1;
    details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
    details = details.join(length > 2 ? ', ' : ' ');
    return source.replace($db61150bcd231438$var$reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}
module.exports = $db61150bcd231438$var$insertWrapDetails;

});

parcelRegister("1ZcUe", function(module, exports) {

var $fmP8r = parcelRequire("fmP8r");

var $fUP98 = parcelRequire("fUP98");
/** Used to compose bitmasks for function metadata. */ var $17257fcfcc231370$var$WRAP_BIND_FLAG = 1, $17257fcfcc231370$var$WRAP_BIND_KEY_FLAG = 2, $17257fcfcc231370$var$WRAP_CURRY_FLAG = 8, $17257fcfcc231370$var$WRAP_CURRY_RIGHT_FLAG = 16, $17257fcfcc231370$var$WRAP_PARTIAL_FLAG = 32, $17257fcfcc231370$var$WRAP_PARTIAL_RIGHT_FLAG = 64, $17257fcfcc231370$var$WRAP_ARY_FLAG = 128, $17257fcfcc231370$var$WRAP_REARG_FLAG = 256, $17257fcfcc231370$var$WRAP_FLIP_FLAG = 512;
/** Used to associate wrap methods with their bit flags. */ var $17257fcfcc231370$var$wrapFlags = [
    [
        'ary',
        $17257fcfcc231370$var$WRAP_ARY_FLAG
    ],
    [
        'bind',
        $17257fcfcc231370$var$WRAP_BIND_FLAG
    ],
    [
        'bindKey',
        $17257fcfcc231370$var$WRAP_BIND_KEY_FLAG
    ],
    [
        'curry',
        $17257fcfcc231370$var$WRAP_CURRY_FLAG
    ],
    [
        'curryRight',
        $17257fcfcc231370$var$WRAP_CURRY_RIGHT_FLAG
    ],
    [
        'flip',
        $17257fcfcc231370$var$WRAP_FLIP_FLAG
    ],
    [
        'partial',
        $17257fcfcc231370$var$WRAP_PARTIAL_FLAG
    ],
    [
        'partialRight',
        $17257fcfcc231370$var$WRAP_PARTIAL_RIGHT_FLAG
    ],
    [
        'rearg',
        $17257fcfcc231370$var$WRAP_REARG_FLAG
    ]
];
/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */ function $17257fcfcc231370$var$updateWrapDetails(details, bitmask) {
    $fmP8r($17257fcfcc231370$var$wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if (bitmask & pair[1] && !$fUP98(details, value)) details.push(value);
    });
    return details.sort();
}
module.exports = $17257fcfcc231370$var$updateWrapDetails;

});



parcelRegister("8ZIC5", function(module, exports) {
/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */ function $68c6a086039b9437$var$getHolder(func) {
    var object = func;
    return object.placeholder;
}
module.exports = $68c6a086039b9437$var$getHolder;

});

parcelRegister("3Prcz", function(module, exports) {

var $jHlUS = parcelRequire("jHlUS");

var $e8U1z = parcelRequire("e8U1z");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $2c9b3c36ffa24094$var$nativeMin = Math.min;
/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */ function $2c9b3c36ffa24094$var$reorder(array, indexes) {
    var arrLength = array.length, length = $2c9b3c36ffa24094$var$nativeMin(indexes.length, arrLength), oldArray = $jHlUS(array);
    while(length--){
        var index = indexes[length];
        array[length] = $e8U1z(index, arrLength) ? oldArray[index] : undefined;
    }
    return array;
}
module.exports = $2c9b3c36ffa24094$var$reorder;

});

parcelRegister("kBUUu", function(module, exports) {
/** Used as the internal argument placeholder. */ var $f0136883d4267917$var$PLACEHOLDER = '__lodash_placeholder__';
/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */ function $f0136883d4267917$var$replaceHolders(array, placeholder) {
    var index = -1, length = array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (value === placeholder || value === $f0136883d4267917$var$PLACEHOLDER) {
            array[index] = $f0136883d4267917$var$PLACEHOLDER;
            result[resIndex++] = index;
        }
    }
    return result;
}
module.exports = $f0136883d4267917$var$replaceHolders;

});



parcelRegister("cwXqG", function(module, exports) {

var $hlchF = parcelRequire("hlchF");

var $iJkMv = parcelRequire("iJkMv");

var $1V15E = parcelRequire("1V15E");
/** Used to compose bitmasks for function metadata. */ var $91f6929c17575724$var$WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */ function $91f6929c17575724$var$createPartial(func, bitmask, thisArg, partials) {
    var isBind = bitmask & $91f6929c17575724$var$WRAP_BIND_FLAG, Ctor = $iJkMv(func);
    function wrapper() {
        var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array(leftLength + argsLength), fn = this && this !== $1V15E && this instanceof wrapper ? Ctor : func;
        while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
        while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
        return $hlchF(fn, isBind ? thisArg : this, args);
    }
    return wrapper;
}
module.exports = $91f6929c17575724$var$createPartial;

});

parcelRegister("c8pf3", function(module, exports) {

var $k8MLc = parcelRequire("k8MLc");

var $eqXBf = parcelRequire("eqXBf");

var $kBUUu = parcelRequire("kBUUu");
/** Used as the internal argument placeholder. */ var $8d59cfe3586d6695$var$PLACEHOLDER = '__lodash_placeholder__';
/** Used to compose bitmasks for function metadata. */ var $8d59cfe3586d6695$var$WRAP_BIND_FLAG = 1, $8d59cfe3586d6695$var$WRAP_BIND_KEY_FLAG = 2, $8d59cfe3586d6695$var$WRAP_CURRY_BOUND_FLAG = 4, $8d59cfe3586d6695$var$WRAP_CURRY_FLAG = 8, $8d59cfe3586d6695$var$WRAP_ARY_FLAG = 128, $8d59cfe3586d6695$var$WRAP_REARG_FLAG = 256;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $8d59cfe3586d6695$var$nativeMin = Math.min;
/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */ function $8d59cfe3586d6695$var$mergeData(data, source) {
    var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < ($8d59cfe3586d6695$var$WRAP_BIND_FLAG | $8d59cfe3586d6695$var$WRAP_BIND_KEY_FLAG | $8d59cfe3586d6695$var$WRAP_ARY_FLAG);
    var isCombo = srcBitmask == $8d59cfe3586d6695$var$WRAP_ARY_FLAG && bitmask == $8d59cfe3586d6695$var$WRAP_CURRY_FLAG || srcBitmask == $8d59cfe3586d6695$var$WRAP_ARY_FLAG && bitmask == $8d59cfe3586d6695$var$WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == ($8d59cfe3586d6695$var$WRAP_ARY_FLAG | $8d59cfe3586d6695$var$WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == $8d59cfe3586d6695$var$WRAP_CURRY_FLAG;
    // Exit early if metadata can't be merged.
    if (!(isCommon || isCombo)) return data;
    // Use source `thisArg` if available.
    if (srcBitmask & $8d59cfe3586d6695$var$WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & $8d59cfe3586d6695$var$WRAP_BIND_FLAG ? 0 : $8d59cfe3586d6695$var$WRAP_CURRY_BOUND_FLAG;
    }
    // Compose partial arguments.
    var value = source[3];
    if (value) {
        var partials = data[3];
        data[3] = partials ? $k8MLc(partials, value, source[4]) : value;
        data[4] = partials ? $kBUUu(data[3], $8d59cfe3586d6695$var$PLACEHOLDER) : source[4];
    }
    // Compose partial right arguments.
    value = source[5];
    if (value) {
        partials = data[5];
        data[5] = partials ? $eqXBf(partials, value, source[6]) : value;
        data[6] = partials ? $kBUUu(data[5], $8d59cfe3586d6695$var$PLACEHOLDER) : source[6];
    }
    // Use source `argPos` if available.
    value = source[7];
    if (value) data[7] = value;
    // Use source `ary` if it's smaller.
    if (srcBitmask & $8d59cfe3586d6695$var$WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : $8d59cfe3586d6695$var$nativeMin(data[8], source[8]);
    // Use source `arity` if one is not provided.
    if (data[9] == null) data[9] = source[9];
    // Use source `func` and merge bitmasks.
    data[0] = source[0];
    data[1] = newBitmask;
    return data;
}
module.exports = $8d59cfe3586d6695$var$mergeData;

});



parcelRegister("91VA7", function(module, exports) {

var $7MmCC = parcelRequire("7MmCC");
/** Used to compose bitmasks for cloning. */ var $6930df867851495d$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $6930df867851495d$var$clone(value) {
    return $7MmCC(value, $6930df867851495d$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $6930df867851495d$var$clone;

});

parcelRegister("a7NzZ", function(module, exports) {

var $5oTQF = parcelRequire("5oTQF");
/** Used to compose bitmasks for function metadata. */ var $75f10447dad5f8f2$var$WRAP_CURRY_FLAG = 8;
/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */ function $75f10447dad5f8f2$var$curry(func, arity, guard) {
    arity = guard ? undefined : arity;
    var result = $5oTQF(func, $75f10447dad5f8f2$var$WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
    result.placeholder = $75f10447dad5f8f2$var$curry.placeholder;
    return result;
}
// Assign default placeholders.
$75f10447dad5f8f2$var$curry.placeholder = {};
module.exports = $75f10447dad5f8f2$var$curry;

});

parcelRegister("aZFhV", function(module, exports) {

var $beQoo = parcelRequire("beQoo");

var $fC1Kz = parcelRequire("fC1Kz");

var $1QOns = parcelRequire("1QOns");
/** `Object#toString` result references. */ var $800fa0dabdb52684$var$domExcTag = '[object DOMException]', $800fa0dabdb52684$var$errorTag = '[object Error]';
/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */ function $800fa0dabdb52684$var$isError(value) {
    if (!$fC1Kz(value)) return false;
    var tag = $beQoo(value);
    return tag == $800fa0dabdb52684$var$errorTag || tag == $800fa0dabdb52684$var$domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !$1QOns(value);
}
module.exports = $800fa0dabdb52684$var$isError;

});

parcelRegister("5UxIS", function(module, exports) {

var $jtBGw = parcelRequire("jtBGw");

var $fC1Kz = parcelRequire("fC1Kz");
/** `Object#toString` result references. */ var $44dc5758474a5c9f$var$weakMapTag = '[object WeakMap]';
/**
 * Checks if `value` is classified as a `WeakMap` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
 * @example
 *
 * _.isWeakMap(new WeakMap);
 * // => true
 *
 * _.isWeakMap(new Map);
 * // => false
 */ function $44dc5758474a5c9f$var$isWeakMap(value) {
    return $fC1Kz(value) && $jtBGw(value) == $44dc5758474a5c9f$var$weakMapTag;
}
module.exports = $44dc5758474a5c9f$var$isWeakMap;

});

parcelRegister("5qDt4", function(module, exports) {

var $7MmCC = parcelRequire("7MmCC");

var $bxDef = parcelRequire("bxDef");
/** Used to compose bitmasks for cloning. */ var $3f3dfefad45dde4d$var$CLONE_DEEP_FLAG = 1;
/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */ function $3f3dfefad45dde4d$var$iteratee(func) {
    return $bxDef(typeof func == 'function' ? func : $7MmCC(func, $3f3dfefad45dde4d$var$CLONE_DEEP_FLAG));
}
module.exports = $3f3dfefad45dde4d$var$iteratee;

});

parcelRegister("iZlmO", function(module, exports) {

var $5oTQF = parcelRequire("5oTQF");

var $9SRAA = parcelRequire("9SRAA");
/** Used to compose bitmasks for function metadata. */ var $dd2e7f874e5ccea3$var$WRAP_REARG_FLAG = 256;
/**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */ var $dd2e7f874e5ccea3$var$rearg = $9SRAA(function(func, indexes) {
    return $5oTQF(func, $dd2e7f874e5ccea3$var$WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
});
module.exports = $dd2e7f874e5ccea3$var$rearg;

});

parcelRegister("6TYHJ", function(module, exports) {

var $1nIHN = parcelRequire("1nIHN");

var $jHlUS = parcelRequire("jHlUS");

var $8LQ84 = parcelRequire("8LQ84");

var $4faK3 = parcelRequire("4faK3");

var $h5JBK = parcelRequire("h5JBK");

var $gzebZ = parcelRequire("gzebZ");

var $jJVtR = parcelRequire("jJVtR");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $5066f7c1bc1a55ec$var$toPath(value) {
    if ($8LQ84(value)) return $1nIHN(value, $gzebZ);
    return $4faK3(value) ? [
        value
    ] : $jHlUS($h5JBK($jJVtR(value)));
}
module.exports = $5066f7c1bc1a55ec$var$toPath;

});



parcelRegister("iASWI", function(module, exports) {

var $irTmi = parcelRequire("irTmi");
/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $d89635f071f7433a$var$range = $irTmi();
module.exports = $d89635f071f7433a$var$range;

});
parcelRegister("irTmi", function(module, exports) {

var $7DMj9 = parcelRequire("7DMj9");

var $4rDUz = parcelRequire("4rDUz");

var $kJ0Lf = parcelRequire("kJ0Lf");
/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $d6e5b0af0cc26ead$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && $4rDUz(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $kJ0Lf(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $kJ0Lf(end);
        step = step === undefined ? start < end ? 1 : -1 : $kJ0Lf(step);
        return $7DMj9(start, end, step, fromRight);
    };
}
module.exports = $d6e5b0af0cc26ead$var$createRange;

});
parcelRegister("7DMj9", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5901a5dd7694a169$var$nativeCeil = Math.ceil, $5901a5dd7694a169$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $5901a5dd7694a169$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $5901a5dd7694a169$var$nativeMax($5901a5dd7694a169$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
module.exports = $5901a5dd7694a169$var$baseRange;

});





parcelRegister("4zcxJ", function(module, exports) {

$parcel$export(module.exports, "useExpandableEntryPointTrigger", () => $a613456b7f090bbf$export$569294f6ae10bba9);

var $5uXOq = parcelRequire("5uXOq");

var $47gW9 = parcelRequire("47gW9");
const $a613456b7f090bbf$export$569294f6ae10bba9 = (actions, isActive = true)=>{
    // We don't want the click-handler, as ExpandableMenuItem handles the entry-point loading itself
    const eventMap = (0, $5uXOq.useMemo)(()=>Object.fromEntries(Object.entries((0, $47gW9.getDefaultEntrypointActionEventMap)(actions)).filter(([key])=>key !== 'click')), [
        actions
    ]);
    return (0, $47gW9.useEntryPointButtonTrigger)(actions, isActive, eventMap);
};

});
parcelRegister("47gW9", function(module, exports) {

$parcel$export(module.exports, "useEntryPointButtonTrigger", () => $1be876415a945060$export$25d2524a63315ed);
$parcel$export(module.exports, "getDefaultEntrypointActionEventMap", () => $1be876415a945060$export$5f13515bd3a35325);

var $5uXOq = parcelRequire("5uXOq");

var $iRKpN = parcelRequire("iRKpN");
const $1be876415a945060$export$25d2524a63315ed = (actions, isActive = true, eventMap)=>{
    const removePreviousListeners = (0, $5uXOq.useRef)(null);
    const isMounted = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useEffect)(()=>()=>{
            removePreviousListeners.current?.();
            removePreviousListeners.current = null;
            isMounted.current = false;
        }, []);
    return (0, $5uXOq.useCallback)((element)=>{
        if (!isMounted.current) return;
        removePreviousListeners.current?.();
        const elementEventMap = eventMap || $1be876415a945060$export$5f13515bd3a35325(actions);
        if (element && isActive) {
            (0, $iRKpN.modifyListeners)({
                element: element,
                operationName: 'add',
                eventMap: elementEventMap
            });
            removePreviousListeners.current = ()=>{
                (0, $iRKpN.modifyListeners)({
                    element: element,
                    operationName: 'remove',
                    eventMap: elementEventMap
                });
            };
        } else removePreviousListeners.current = null;
    }, [
        actions,
        eventMap,
        isActive
    ]);
};
const $1be876415a945060$export$5f13515bd3a35325 = (actions)=>({
        click: actions.load,
        mouseenter: actions.preload,
        mouseleave: actions.cancelPreload,
        focusin: actions.preload,
        focusout: actions.cancelPreload
    });

});
parcelRegister("iRKpN", function(module, exports) {

$parcel$export(module.exports, "modifyListeners", () => $62bae43418420b8a$export$15257a36a7e3f9d6);
function $62bae43418420b8a$export$15257a36a7e3f9d6(params) {
    const { element: element, operationName: operationName, eventMap: eventMap } = params;
    const functionName = operationName === 'add' ? 'addEventListener' : 'removeEventListener';
    if (element) Object.keys(eventMap).forEach((eventName)=>element[functionName](eventName, eventMap[eventName]));
}

});



parcelRegister("7Y7Js", function(module, exports) {

$parcel$export(module.exports, "ExploreMoreApps", () => $f69daa56854375f6$export$e3e10d2adcb07330);

var $5uXOq = parcelRequire("5uXOq");

var $1ZDWg = parcelRequire("1ZDWg");



var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $5FnJJ = parcelRequire("5FnJJ");

var $24a2m = parcelRequire("24a2m");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $9OXo1 = parcelRequire("9OXo1");

var $6s1PB = parcelRequire("6s1PB");

var $jGx9e = parcelRequire("jGx9e");
const $f69daa56854375f6$var$pathToNavigate = '/jira/marketplace/discover';
function $f69daa56854375f6$export$e3e10d2adcb07330() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { isAdmin: isAdmin, isSiteAdmin: isSiteAdmin } = tenantContext;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $24a2m.useFormattedMessageAndIcon)((0, $jGx9e.default).exploreMoreApps, (0, (/*@__PURE__*/$parcel$interopDefault($1ZDWg))));
    const onClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_APPS],
            attributes: {
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                itemId: 'exploreMoreApps'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const showExploreMoreApps = isAdmin || isSiteAdmin ? (0, $6s1PB.expVal)('emcee-discover', 'value', true) : (0, $6s1PB.expVal)('enduser-emcee-discover', 'value', true);
    if (!showExploreMoreApps) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        elemBefore: icon,
        href: $f69daa56854375f6$var$pathToNavigate,
        menuId: (0, $jhS4y.MENU_ID_APP_MARKETPLACE_DISCOVER),
        onClick: onClick
    }, formattedMessage);
}

});
parcelRegister("jGx9e", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1d28052ecc552f9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c1d28052ecc552f9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    exploreMoreApps: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-apps.common.explore-more-apps.explore-more-apps",
        "defaultMessage": "Explore more apps"
    }
});

});


const $13973d4cc5182a50$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Apps';
const $13973d4cc5182a50$export$d57b6b390e78d90f = 'smite';

parcelRegister("6EHtA", function(module, exports) {

$parcel$export(module.exports, "createAttributes", () => $5df5d3b717f9866b$export$c7c9603a6b1fd815);

var $4R6GH = parcelRequire("4R6GH");

var $fZneA = parcelRequire("fZneA");

var $j8DrX = parcelRequire("j8DrX");
const $5df5d3b717f9866b$var$isSynthetic = ()=>// Filter out synthetic tests using all known ways
    (0, $j8DrX.default)('ajs-is-synthetic') === 'true' || (0, $4R6GH.fg)('forge_ui_synthetic_check');
const $5df5d3b717f9866b$var$FAILED_TO_FETCH = 'FAILED_TO_FETCH';
const $5df5d3b717f9866b$var$getErrorType = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ((0, $fZneA.isClientFetchError)(error)) return $5df5d3b717f9866b$var$FAILED_TO_FETCH;
    return 'OTHER';
};
const $5df5d3b717f9866b$export$78c6267359db7e73 = (error)=>({
        ...error,
        stack: error.stack,
        message: error?.message
    });
const $5df5d3b717f9866b$export$c7c9603a6b1fd815 = (rawAttributes)=>{
    const attributes = {
        isSynthetic: $5df5d3b717f9866b$var$isSynthetic(),
        isSSR: false
    };
    if (rawAttributes) {
        const { error: error } = rawAttributes;
        if (error) {
            attributes.error = $5df5d3b717f9866b$export$78c6267359db7e73(error);
            attributes.errorType = $5df5d3b717f9866b$var$getErrorType(error);
        }
    }
    return {
        ...rawAttributes,
        ...attributes
    };
};

});

parcelRegister("g72iU", function(module, exports) {

$parcel$export(module.exports, "asyncNav4AppsContentViewQuery", () => $cda04b3061c529f3$export$3cc582e017e659a5);

var $2W8ID = parcelRequire("2W8ID");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $cda04b3061c529f3$export$3cc582e017e659a5 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("28xFJ")).then(({ Nav4AppsContentViewQuery: Nav4AppsContentViewQuery })=>Nav4AppsContentViewQuery), {
        moduleId: "5e1e3d10",
        moduleName: "Nav4AppsContentViewQuery",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                apps: {
                    parameters: $2W8ID.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("2W8ID", function(module, exports) {

$parcel$export(module.exports, "default", () => $997a21b7e3836e4d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2a797f95d565e272b64c867b7e10016a>>
 * @relayHash 3ad9de847a73c165c119877312ac8b41
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7e949716a36a3b7276a3e0c3e396a35d07392bc693f41443586e94aec2d3222b
const $997a21b7e3836e4d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "label"
    }, v2 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v3 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "Nav4AppsContentViewQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "Nav4AppsContent"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "Nav4AppsContentViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                }
                            ],
                            "concreteType": "JiraNavigationItemConnection",
                            "kind": "LinkedField",
                            "name": "globalAppNavigationItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraNavigationItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "appId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "appType"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "envLabel"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "iconUrl"
                                                        },
                                                        v2 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraAppSection",
                                                            "kind": "LinkedField",
                                                            "name": "sections",
                                                            "plural": true,
                                                            "selections": [
                                                                v1 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAppNavigationItemNestedLink",
                                                                    "kind": "LinkedField",
                                                                    "name": "links",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v1 /*: any*/ ,
                                                                        v3 /*: any*/ ,
                                                                        v2 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "settingsUrl"
                                                        },
                                                        v3 /*: any*/ 
                                                    ],
                                                    "type": "JiraAppNavigationItem"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7e949716a36a3b7276a3e0c3e396a35d07392bc693f41443586e94aec2d3222b",
            "metadata": {},
            "name": "Nav4AppsContentViewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$997a21b7e3836e4d$var$node.hash = "157a8cfe104b1d671cc09c5f8aee481a";
var $997a21b7e3836e4d$export$2e2bcd8739ae039 = $997a21b7e3836e4d$var$node;

});

parcelRegister("28xFJ", function(module, exports) {

let $18e672b40c765d08$var$load = (parcelRequire("28QjX"))(4);
module.exports = $18e672b40c765d08$var$load("SBkY7").then(()=>parcelRequire('30ibK'));

});



parcelRegister("iJgtS", function(module, exports) {

$parcel$export(module.exports, "Nav4AppsForLanding", () => $e9ee9ccd4f89fb22$export$889c9c34c80104b2);

var $3iyZg = parcelRequire("3iyZg");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $lnznH = parcelRequire("lnznH");
var $cZa9B = parcelRequire("cZa9B");


var $jecJ3 = parcelRequire("jecJ3");

var $jhS4y = parcelRequire("jhS4y");

var $iszzG = parcelRequire("iszzG");

var $46Cti = parcelRequire("46Cti");

var $c16H2 = parcelRequire("c16H2");

var $dQbFB = parcelRequire("dQbFB");

var $dUyqZ = parcelRequire("dUyqZ");

var $gpcgC = parcelRequire("gpcgC");

var $7Y7Js = parcelRequire("7Y7Js");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $l8ruj = parcelRequire("l8ruj");

var $4R6GH = parcelRequire("4R6GH");
function $e9ee9ccd4f89fb22$export$889c9c34c80104b2(props) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { moreMenuIds: moreMenuIds } = (0, $5uXOq.useContext)((0, $iszzG.NavItemsContext));
    const { actionsOnHover: actionsOnHover, isExpanded: isExpanded, queryRef: queryRef } = props;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).APPS);
    const data = (0, $8Uumt.useFragment)((0, $3iyZg.default), queryRef);
    const menuId = (0, $jhS4y.MENU_ID_APPS);
    const handleExpansionToggle = (hasExpanded)=>{
        if (hasExpanded) {
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
            });
            const isInMore = moreMenuIds.includes((0, $46Cti.L1_MENU_ID).APPS);
            (0, $8zOmE.fireUIAnalytics)(event, (0, $jecJ3.SECTION_ITEM_APPS), {
                isInMore: isInMore
            });
        }
    };
    // Feature gate: wrap with useCallback if enabled
    const onExpansionToggle = (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useCallback)(handleExpansionToggle, [
        createAnalyticsEvent,
        moreMenuIds
    ]) : handleExpansionToggle;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: onExpansionToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZa9B.ExpandableMenuItemTrigger), {
        actionsOnHover: actionsOnHover,
        // Prevent double-up of accessible name that occurs in icon + text situation.
        "aria-label": formattedMessage,
        elemBefore: icon,
        testId: (0, $dQbFB.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnznH.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4-sidebar-apps-landing"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gpcgC.Nav4AppsContent), {
        queryRef: data
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Y7Js.ExploreMoreApps), null))));
}

});
parcelRegister("3iyZg", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf7940716f9101a5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<43a8cee8bfdf430e242ac6d6e2f5e807>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bf7940716f9101a5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4AppsForLanding",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Nav4AppsContent"
        }
    ],
    "type": "JiraQuery"
};
$bf7940716f9101a5$var$node.hash = "9c28cb4a0c92a920a58010f91f4f4f0e";
var $bf7940716f9101a5$export$2e2bcd8739ae039 = $bf7940716f9101a5$var$node;

});

parcelRegister("gpcgC", function(module, exports) {

$parcel$export(module.exports, "Nav4AppsContent", () => $23e70e20d1d66b25$export$aaf45d195a81792d);

var $67Dt2 = parcelRequire("67Dt2");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $gSZmd = parcelRequire("gSZmd");
var $1qQhw = parcelRequire("1qQhw");
var $1FdfO = parcelRequire("1FdfO");
var $2CQvU = parcelRequire("2CQvU");

var $4R6GH = parcelRequire("4R6GH");

var $1rTGO = parcelRequire("1rTGO");

var $3wOYX = parcelRequire("3wOYX");

var $k2DRb = parcelRequire("k2DRb");

var $koVbs = parcelRequire("koVbs");

var $lmyls = parcelRequire("lmyls");

var $i2fHy = parcelRequire("i2fHy");

var $8MAOw = parcelRequire("8MAOw");

var $j02Uq = parcelRequire("j02Uq");

var $hDULT = parcelRequire("hDULT");
function $23e70e20d1d66b25$export$aaf45d195a81792d({ queryRef: queryRef }) {
    const data = (0, $8Uumt.useFragment)((0, $67Dt2.default), queryRef);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const menuItemNodes = (0, $5uXOq.useMemo)(()=>(data?.globalAppNavigationItems?.edges || []).filter((edge)=>{
            // Keep only Forge and Connect apps on the list
            if (edge?.node?.appType !== 'CONNECT' && edge?.node?.appType !== 'FORGE') return false;
            // Filter out system apps just like it was done in the old navigation
            return edge?.node?.appId !== (0, $lmyls.ADDON_ID).DISCOVER;
        }).map((edge)=>edge?.node).sort((a, b)=>(a?.label || '').localeCompare(b?.label || '')) || [], [
        data?.globalAppNavigationItems
    ]);
    const renderedMenuItems = (0, $5uXOq.useMemo)(()=>menuItemNodes.map((node)=>{
            switch(node?.appType){
                case 'CONNECT':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2fHy.Nav4ConnectMenuItem), {
                        key: node.id,
                        queryRef: node
                    });
                case 'FORGE':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8MAOw.Nav4ForgeMenuItem), {
                        key: node.id,
                        queryRef: node
                    });
                default:
                    return null;
            }
        }).filter(Boolean), [
        menuItemNodes
    ]);
    const hasForgeApps = (0, $5uXOq.useMemo)(()=>menuItemNodes.some((node)=>node?.appType === 'FORGE'), [
        menuItemNodes
    ]);
    return renderedMenuItems.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($23e70e20d1d66b25$var$ForgeAnalyticsWrapper, {
        shouldReport: hasForgeApps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1qQhw.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1FdfO.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2CQvU.MenuSectionHeading), null, formatMessage((0, $hDULT.default).yourApps)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gSZmd.MenuList), null, renderedMenuItems, hasForgeApps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $k2DRb.GLOBAL_PAGE_MODULE)
        }
    })))), (0, $4R6GH.fg)('jira_nav4_apps_menu_recommend') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j02Uq.AsyncDiscoverSection), null) : null) : null;
}
function $23e70e20d1d66b25$var$ForgeAnalyticsWrapper({ shouldReport: shouldReport, children: children }) {
    return shouldReport ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3wOYX.TriggerAnalyticsWrapper), null, children) : children;
}

});
parcelRegister("67Dt2", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1c56b3bd1de4f5e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ddb8a1bbce6fff611878abb761dbf404>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c1c56b3bd1de4f5e$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4AppsContent",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "JiraNavigationItemConnection",
            "kind": "LinkedField",
            "name": "globalAppNavigationItems",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraNavigationItemEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "kind": "ScalarField",
                                                "name": "id"
                                            },
                                            "action": "THROW",
                                            "path": "globalAppNavigationItems.edges.node.id"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "label"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "appId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "appType"
                                                }
                                            ],
                                            "type": "JiraAppNavigationItem"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "Nav4ConnectMenuItem"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "Nav4ForgeMenuItem"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "globalAppNavigationItems.edges.node"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "globalAppNavigationItems.edges"
                }
            ]
        }
    ],
    "type": "JiraQuery"
};
$c1c56b3bd1de4f5e$var$node.hash = "6074e52ca012374d836fe32977dd1a14";
var $c1c56b3bd1de4f5e$export$2e2bcd8739ae039 = $c1c56b3bd1de4f5e$var$node;

});

parcelRegister("1FdfO", function(module, exports) {

$parcel$export(module.exports, "MenuSection", () => $7bc49b2ac035272f$export$4b1545b4f2016d26);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $9KnKW = parcelRequire("9KnKW");

var $1qQhw = parcelRequire("1qQhw");

var $bXf7n = parcelRequire("bXf7n");
const $7bc49b2ac035272f$export$4b1545b4f2016d26 = ({ children: children, testId: testId, isMenuListItem: isMenuListItem = false })=>{
    const id = (0, $9KnKW.useId)();
    const content = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bXf7n.MenuSectionContext).Provider, {
        value: id,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            role: "group",
            "aria-labelledby": `${id}-heading`,
            children: children
        })
    });
    if (isMenuListItem) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1qQhw.MenuListItem), {
        testId: testId,
        children: content
    });
    // Legacy. isMenuListItem should become default.
    return content;
};

});
parcelRegister("bXf7n", function(module, exports) {

$parcel$export(module.exports, "MenuSectionContext", () => $1c4053efb9c0d283$export$728ac99b9c7eea8a);
$parcel$export(module.exports, "useMenuSectionContext", () => $1c4053efb9c0d283$export$8100cda602411810);

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");
const $1c4053efb9c0d283$export$728ac99b9c7eea8a = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $1c4053efb9c0d283$export$8100cda602411810 = ()=>{
    const context = (0, $5uXOq.useContext)($1c4053efb9c0d283$export$728ac99b9c7eea8a);
    (0, $3joPi.default)(context, 'useMenuSectionContext must be used within a MenuSection');
    return context;
};

});


parcelRegister("2CQvU", function(module, exports) {

$parcel$export(module.exports, "MenuSectionHeading", () => $2dcd93264b8e5f0d$export$5d3acdbf9237a364);
/* menu-section-heading.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bXf7n = parcelRequire("bXf7n");
const $2dcd93264b8e5f0d$var$styles = {
    root: "_11c81vhk _1rjcu2gc _syaz131l _bozg12x7"
};
const $2dcd93264b8e5f0d$export$5d3acdbf9237a364 = ({ children: children })=>{
    const id = (0, $bXf7n.useMenuSectionContext)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)("h2", {
        id: `${id}-heading`,
        className: (0, $bwpsq.default)([
            $2dcd93264b8e5f0d$var$styles.root
        ]),
        children: children
    });
};

});

parcelRegister("1rTGO", function(module, exports) {

$parcel$export(module.exports, "ForgeScreenEvent", () => $abbdb580491d9d09$export$92d758d83665314b);
$parcel$export(module.exports, "ForgeOperationaFailedEvent", () => $abbdb580491d9d09$export$a238c3c13f29c134);
$parcel$export(module.exports, "ForgeErrorBoundary", () => $abbdb580491d9d09$export$ac7e7464cefab440);
$parcel$export(module.exports, "ForgeAnalyticsWrapper", () => $abbdb580491d9d09$export$ad2a5d9127152fb8);
$parcel$export(module.exports, "withMetrics", () => $abbdb580491d9d09$export$14e56d7f5d3f917c);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $k2DRb = parcelRequire("k2DRb");

var $3mOWa = parcelRequire("3mOWa");

var $eOGyv = parcelRequire("eOGyv");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $5oFIy = parcelRequire("5oFIy");
var $isuse = parcelRequire("isuse");

var $4R6GH = parcelRequire("4R6GH");

var $hBuqR = parcelRequire("hBuqR");

var $6MtPV = parcelRequire("6MtPV");

var $dd7Uh = parcelRequire("dd7Uh");

var $2RhPB = parcelRequire("2RhPB");

var $9BrHy = parcelRequire("9BrHy");

var $8kVg1 = parcelRequire("8kVg1");
const $abbdb580491d9d09$export$92d758d83665314b = ({ attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: (0, $6MtPV.createAttributes)(attributes)
    });
const $abbdb580491d9d09$export$a238c3c13f29c134 = ({ eventId: eventId, attributes: attributes })=>{
    (0, $dd7Uh.fireOperationalFailedEvent)({
        eventId: eventId,
        attributes: attributes
    });
    return null;
};
const $abbdb580491d9d09$export$4c46624a93517c10 = ({ eventId: eventId, action: action, attributes: attributes })=>{
    const hasForgeAccess = (0, $eOGyv.useHasForgeAccess)();
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>(0, $6MtPV.createAttributes)({
            ...attributes,
            hasForgeAccess: hasForgeAccess
        }), [
        attributes,
        hasForgeAccess
    ]);
    const fireEvent = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, (0, $9BrHy.getEventActionName)(eventId, action), analyticsAttributes);
    }, [
        eventId,
        action,
        analyticsAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isuse.MountEvent), {
        onMount: fireEvent
    });
};
const $abbdb580491d9d09$export$f461e628d5e73fa0 = ({ children: children, eventId: eventId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: `${(0, $hBuqR.PACKAGE_NAME_GASV3)}.${eventId}`
    }, children);
const $abbdb580491d9d09$export$ac7e7464cefab440 = ({ children: children, eventId: eventId, attributes: attributes, onError: onError, errorFallback: errorFallback, resetCaughtError: resetCaughtError })=>{
    const fallback = (0, $5uXOq.useMemo)(()=>errorFallback || 'unmount', [
        errorFallback
    ]);
    const getAttributes = (0, $5uXOq.useCallback)((error)=>(0, $6MtPV.createAttributes)({
            ...attributes,
            error: error
        }), [
        attributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: eventId,
        packageName: (0, $hBuqR.PACKAGE_NAME_GASV3),
        teamName: "smite",
        fallback: fallback,
        attributes: getAttributes,
        onError: onError,
        resetCaughtError: resetCaughtError
    }, children);
};
const $abbdb580491d9d09$export$ad2a5d9127152fb8 = ({ children: children, module: module, entryPoint: entryPoint, attributes: attributes, moduleType: moduleType = (0, $hBuqR.MODULE_TYPE_EXTENSION), errorFallback: errorFallback = 'unmount', shouldFireInitializedEvent: shouldFireInitializedEvent = false, resetCaughtError: resetCaughtError })=>{
    const eventId = (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
        module: module,
        moduleType: moduleType,
        entryPoint: entryPoint
    }) : (0, $9BrHy.getEventIdOld)({
        module: module,
        moduleType: moduleType,
        entryPoint: entryPoint
    });
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>(0, $6MtPV.createAttributes)(attributes), [
        attributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$f461e628d5e73fa0, {
        eventId: eventId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$ac7e7464cefab440, {
        eventId: eventId,
        attributes: analyticsAttributes,
        errorFallback: errorFallback,
        resetCaughtError: resetCaughtError
    }, shouldFireInitializedEvent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$4c46624a93517c10, {
        eventId: eventId,
        action: "initialized",
        attributes: analyticsAttributes
    }), children));
};
function $abbdb580491d9d09$var$isExtensionTimeMeasuredFromTriggerClick(extensionModule, entryPoint, attributes) {
    if ((extensionModule === (0, $k2DRb.CUSTOM_FIELD_MODULE) || extensionModule === (0, $k2DRb.CUSTOM_FIELD_TYPE_MODULE)) && (entryPoint !== 'edit' || attributes.renderContext === 'issue-create')) return false;
    if (extensionModule === (0, $k2DRb.ISSUE_PANEL_MODULE) && !attributes?.isNewToIssue) return false;
    return /* eslint-disable @typescript-eslint/consistent-type-assertions */ [
        (0, $k2DRb.GLOBAL_PAGE_MODULE),
        (0, $k2DRb.ISSUE_ACTION_MODULE),
        (0, $k2DRb.ISSUE_ACTIVITY_MODULE),
        (0, $k2DRb.ISSUE_CONTEXT_MODULE),
        (0, $k2DRb.ISSUE_GLANCE_MODULE),
        (0, $k2DRb.ISSUE_NAVIGATOR_ACTION_MODULE),
        (0, $k2DRb.ISSUE_PANEL_MODULE),
        (0, $k2DRb.CUSTOM_FIELD_MODULE),
        (0, $k2DRb.CUSTOM_FIELD_TYPE_MODULE),
        (0, $k2DRb.PROJECT_PAGE_MODULE),
        (0, $k2DRb.ADMIN_PAGE_MODULE),
        (0, $k2DRb.PROJECT_SETTINGS_PAGE_MODULE),
        (0, $k2DRb.BACKLOG_ACTION_MODULE),
        (0, $k2DRb.BOARD_ACTION_MODULE),
        (0, $k2DRb.SPRINT_ACTION_MODULE),
        (0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE)
    ].includes(extensionModule);
}
const $abbdb580491d9d09$export$14e56d7f5d3f917c = (Component)=>(props)=>{
        const startTime = (0, $5uXOq.useRef)(performance.now());
        const isCustomUI = (0, $3mOWa.isCustomUIExtension)(props.extension, props.entryPoint);
        const [isExtensionRendered, setExtensionRendered] = (0, $5uXOq.useState)(false);
        const { module: module, entryPoint: entryPoint, analyticsAttributes: analyticsAttributes, localId: localId = '', onInitialRender: onInitialRender, onLoad: onLoad, extension: extension } = props;
        const extensionId = props.extension?.id;
        const eventId = (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
            module: module,
            entryPoint: entryPoint
        }) : (0, $9BrHy.getEventIdOld)({
            module: module,
            entryPoint: entryPoint
        });
        const browserMetricsEventId = (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getBrowserMetricsEventId)({
            module: module,
            entryPoint: entryPoint,
            forgeUiType: (0, $3mOWa.getForgeUIType)(extension, entryPoint)
        }) : (0, $9BrHy.getBrowserMetricsEventIdOld)({
            module: module,
            entryPoint: entryPoint,
            forgeUiType: (0, $3mOWa.getForgeUIType)(extension, entryPoint)
        });
        const attributes = (0, $5uXOq.useMemo)(()=>({
                ...analyticsAttributes,
                ...(0, $2RhPB.getAnalyticsAttributesFromExtension)(extension, entryPoint)
            }), // because extension is an object but we only want extension.id to trigger re-render
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            analyticsAttributes,
            entryPoint,
            extension.id,
            isCustomUI
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!$abbdb580491d9d09$var$isExtensionTimeMeasuredFromTriggerClick(extension.type, entryPoint ?? 'view', attributes) && extensionId) (0, $8kVg1.forgeModulesConcurrentLoadTime)(extensionId).start({
                startTime: startTime.current
            });
        }, // We want to run this code only once on mount
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []);
        const onError = (0, $5uXOq.useCallback)(()=>{
            extensionId && (0, $8kVg1.forgeModulesConcurrentLoadTime)(extensionId).cancel();
        }, [
            extensionId
        ]);
        const onInitialRenderUiKitWithMetrics = (0, $5uXOq.useCallback)((payload)=>{
            onInitialRender && onInitialRender(payload);
            if (payload?.error == null) {
                const stopTimeDeduction = payload?.appTime || 0;
                setExtensionRendered(true);
                extensionId && (0, $8kVg1.forgeModulesConcurrentLoadTime)(extensionId).stop({
                    stopTime: performance.now() - stopTimeDeduction,
                    customData: {
                        eventId: browserMetricsEventId
                    }
                });
            } else {
                onError();
                (0, $dd7Uh.fireOperationalFailedEvent)({
                    eventId: eventId,
                    attributes: {
                        error: new Error(payload.error),
                        ...attributes
                    }
                });
            }
        }, [
            onInitialRender,
            extensionId,
            browserMetricsEventId,
            onError,
            eventId,
            attributes
        ]);
        const onLoadCustomUiWithMetrics = (0, $5uXOq.useCallback)(()=>{
            onLoad && onLoad();
            setExtensionRendered(true);
            extensionId && (0, $8kVg1.forgeModulesConcurrentLoadTime)(extensionId).stop({
                stopTime: performance.now(),
                customData: {
                    eventId: browserMetricsEventId
                }
            });
        // SMT-1418
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            analyticsAttributes,
            extensionId,
            localId,
            onLoad
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$f461e628d5e73fa0, {
            eventId: eventId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
            ...props,
            ...isCustomUI ? {
                onLoad: onLoadCustomUiWithMetrics
            } : {
                onInitialRender: onInitialRenderUiKitWithMetrics
            }
        }), isExtensionRendered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$92d758d83665314b, {
            attributes: attributes
        }));
    };

});
parcelRegister("3mOWa", function(module, exports) {

$parcel$export(module.exports, "getForgeUIType", () => $e79bbc527e600bd1$export$aed4d8a86badbf61);
$parcel$export(module.exports, "isCustomUIExtension", () => $e79bbc527e600bd1$export$edb00cfe4962b026);
$parcel$export(module.exports, "isNativeUiExtension", () => $e79bbc527e600bd1$export$2ecba06e617fea0a);
$parcel$export(module.exports, "overrideExtension", () => $e79bbc527e600bd1$export$42b85bc9b386c977);

var $gccSB = parcelRequire("gccSB");
const $e79bbc527e600bd1$export$aed4d8a86badbf61 = (extension, entryPoint = '')=>{
    const { render: render, resource: resource } = extension.properties;
    if (entryPoint && extension.properties[entryPoint]) {
        const { resource: entryPointResource, render: entryPointRender } = extension.properties[entryPoint];
        if (entryPointResource == null) return 'ui-kit';
        if (entryPointRender === 'native') return 'native-ui';
        return 'custom-ui';
    }
    if (resource == null) return 'ui-kit';
    if (render === 'native') return 'native-ui';
    return 'custom-ui';
};
const $e79bbc527e600bd1$export$edb00cfe4962b026 = (extension, entryPoint = '')=>$e79bbc527e600bd1$export$aed4d8a86badbf61(extension, entryPoint) === 'custom-ui';
const $e79bbc527e600bd1$export$2ecba06e617fea0a = (extension, entryPoint = '')=>$e79bbc527e600bd1$export$aed4d8a86badbf61(extension, entryPoint) === 'native-ui';
const $e79bbc527e600bd1$export$42b85bc9b386c977 = (extension, propsToOverride)=>{
    if (extension == null) return extension;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(propsToOverride)) return extension;
    const { resource: resource } = propsToOverride;
    // We must also spread `extension.properties` because JS doesn't deep-copy objects.
    // Only spreading `extension` will result in `resource` on the original `extension`
    // object being modified.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const extensionCopy = {
        ...extension,
        properties: {
            ...extension.properties
        }
    }; // eslint-disable-line @typescript-eslint/no-explicit-any
    if (resource != null) extensionCopy.properties.resource = resource;
    return extensionCopy;
};

});

parcelRegister("eOGyv", function(module, exports) {

$parcel$export(module.exports, "useHasForgeAccess", () => $5bef20cd08fcb4ca$export$fd7f94d3d2bac7f2);

var $cZpsT = parcelRequire("cZpsT");
const $5bef20cd08fcb4ca$export$fd7f94d3d2bac7f2 = ()=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    return !isAnonymous;
};

});

parcelRegister("5oFIy", function(module, exports) {

$parcel$export(module.exports, "FireUiAnalytics", () => $3ea3e1dfbcd8cda6$export$5a67e7291fd4569e);
$parcel$export(module.exports, "FireTrackAnalytics", () => $3ea3e1dfbcd8cda6$export$5f0d7aae8dfa8b86);
$parcel$export(module.exports, "FireOperationalAnalytics", () => $3ea3e1dfbcd8cda6$export$b71c3ada5d4ec5da);
$parcel$export(module.exports, "FireScreenAnalytics", () => $3ea3e1dfbcd8cda6$export$2ccf161b817b43b);

var $5uXOq = parcelRequire("5uXOq");

var $cb25w = parcelRequire("cb25w");


var $8zOmE = parcelRequire("8zOmE");
// eslint-disable-next-line jira/react/no-class-components
class $3ea3e1dfbcd8cda6$var$FireComponent extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { type: type, attributes: attributes, eventName: eventName, componentName: componentName, action: actionProps, actionSubject: actionSubjectProps, actionSubjectId: actionSubjectIdProps } = this.props;
        if (eventName && (actionProps || actionSubjectProps)) throw Error('eventName is an alias for action & actionSubject, provide only one of those');
        if (componentName && actionSubjectIdProps) throw Error('componentName is an alias for actionSubjectId, provide only one of those');
        const eventNameSplit = eventName ? eventName.split(' ') : [];
        const action = actionProps || eventNameSplit[1];
        const actionSubject = actionSubjectProps || eventNameSplit[0];
        if (!action || !actionSubject) throw Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
        const actionSubjectId = actionSubjectIdProps || componentName;
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: action
        });
        (0, $8zOmE.fireAnalytics)(analyticsEvent, type, {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    }
    render() {
        return null;
    }
}
const $3ea3e1dfbcd8cda6$export$64eb47d7b94ba089 = (0, $cb25w.default)()($3ea3e1dfbcd8cda6$var$FireComponent);
const $3ea3e1dfbcd8cda6$export$5a67e7291fd4569e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$a1562d08625f5d7e)
    });
const $3ea3e1dfbcd8cda6$export$5f0d7aae8dfa8b86 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$947dac6c72b26f81)
    });
const $3ea3e1dfbcd8cda6$export$b71c3ada5d4ec5da = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$12346a674644c156)
    });
const $3ea3e1dfbcd8cda6$export$2ccf161b817b43b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$f1d537d508d2945a),
        eventName: "screen viewed"
    });

});

parcelRegister("isuse", function(module, exports) {

$parcel$export(module.exports, "MountEvent", () => $1df0619a43ad69d9$export$2c6963927dbc68f1);
/**
 * This library is the only place where you'd use raw analytics from atlaskit
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $cb25w = parcelRequire("cb25w");
// eslint-disable-next-line jira/react/no-class-components
class $1df0619a43ad69d9$var$MountEventComponent extends (0, $5uXOq.Component) {
    componentDidMount() {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'mounted'
        });
        if (this.props.onMount) this.props.onMount(analyticsEvent);
    }
    render() {
        return null;
    }
}
const $1df0619a43ad69d9$export$2c6963927dbc68f1 = (0, $cb25w.default)()($1df0619a43ad69d9$var$MountEventComponent);

});

parcelRegister("dd7Uh", function(module, exports) {

$parcel$export(module.exports, "fireOperationalFailedEvent", () => $7d829a81d29f9e72$export$add44f896fb31ba3);

var $hBuqR = parcelRequire("hBuqR");

var $8uOa6 = parcelRequire("8uOa6");
const $7d829a81d29f9e72$export$add44f896fb31ba3 = ({ eventId: eventId, attributes: attributes })=>{
    (0, $8uOa6.fireOperationalEvent)((0, $hBuqR.OPERATIONAL_ACTIONS).FAILED, {
        id: eventId,
        attributes: attributes
    });
};

});

parcelRegister("2RhPB", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsAttributesFromExtension", () => $3fba0b567cec1fe0$export$5d3b06ab08af139e);

var $3mOWa = parcelRequire("3mOWa");

var $e0AC8 = parcelRequire("e0AC8");
const $3fba0b567cec1fe0$export$5d3b06ab08af139e = (extension, entryPoint)=>{
    const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
    return {
        appId: appId,
        envId: envId,
        forgeType: (0, $3mOWa.getForgeUIType)(extension, entryPoint),
        envType: extension?.environmentType
    };
};

});

parcelRegister("9BrHy", function(module, exports) {

$parcel$export(module.exports, "getEventId", () => $10bc2a9e37d5a5bb$export$5639f6a927500d9);
$parcel$export(module.exports, "getEventIdOld", () => $10bc2a9e37d5a5bb$export$b2919e256f1e5dfc);
$parcel$export(module.exports, "getBrowserMetricsEventId", () => $10bc2a9e37d5a5bb$export$25830fc7d037f0f2);
$parcel$export(module.exports, "getBrowserMetricsEventIdOld", () => $10bc2a9e37d5a5bb$export$66db5d4145894f38);
$parcel$export(module.exports, "getEventActionName", () => $10bc2a9e37d5a5bb$export$644ccb9a67b9a9c1);

var $k2DRb = parcelRequire("k2DRb");

var $6yg2S = parcelRequire("6yg2S");

var $hBuqR = parcelRequire("hBuqR");
const $10bc2a9e37d5a5bb$var$capitalizeFirstLetter = (str)=>str != null && str.charAt(0).toUpperCase() + str.slice(1) || '';
const $10bc2a9e37d5a5bb$var$prepareModuleMode = (entryPoint)=>`${$10bc2a9e37d5a5bb$var$capitalizeFirstLetter(entryPoint)}`;
const $10bc2a9e37d5a5bb$export$3e50bc81d8ed2e3f = (moduleName)=>moduleName.replace(/^jira:/, '');
const $10bc2a9e37d5a5bb$var$prepareModuleName = (moduleName)=>(0, $k2DRb.SUPPORTED_MODULES).includes(moduleName) ? $10bc2a9e37d5a5bb$export$3e50bc81d8ed2e3f(moduleName) : 'unknown';
const $10bc2a9e37d5a5bb$export$5639f6a927500d9 = ({ module: module, moduleType: moduleType = (0, $hBuqR.MODULE_TYPE_EXTENSION), entryPoint: entryPoint })=>{
    const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
    // we use view entry point for custom field and custom field type but we don't want to update all the event names
    if (entryPoint === 'view' && (module === 'jira:customField' || module === 'jira:customFieldType')) return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${eventNamePostfix}`);
    return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`);
};
const $10bc2a9e37d5a5bb$export$b2919e256f1e5dfc = ({ module: module, moduleType: moduleType = (0, $hBuqR.MODULE_TYPE_EXTENSION), entryPoint: entryPoint })=>{
    const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
    return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`);
};
const $10bc2a9e37d5a5bb$export$25830fc7d037f0f2 = ({ module: module, entryPoint: entryPoint, forgeUiType: forgeUiType })=>{
    // we use view entry point for custom field and custom field type but we don't want to update all the event names
    if (entryPoint === 'view' && (module === 'jira:customField' || module === 'jira:customFieldType')) return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}-${forgeUiType}`);
    return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}-${forgeUiType}`);
};
const $10bc2a9e37d5a5bb$export$66db5d4145894f38 = ({ module: module, entryPoint: entryPoint, forgeUiType: forgeUiType })=>{
    return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}-${forgeUiType}`);
};
const $10bc2a9e37d5a5bb$export$644ccb9a67b9a9c1 = (eventId, action)=>`${0, $hBuqR.PACKAGE_NAME_GASV3}.${eventId} ${action}`;

});


parcelRegister("3wOYX", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $5b5e8901ec23bf19$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $5b5e8901ec23bf19$export$e1a79e3d472c925a);

var $5uXOq = parcelRequire("5uXOq");

var $k2DRb = parcelRequire("k2DRb");

var $1rTGO = parcelRequire("1rTGO");

var $hBuqR = parcelRequire("hBuqR");
const $5b5e8901ec23bf19$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.GLOBAL_PAGE_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $5b5e8901ec23bf19$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.GLOBAL_PAGE_MODULE),
        moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER),
        ...props
    });

});

parcelRegister("i2fHy", function(module, exports) {

$parcel$export(module.exports, "Nav4ConnectMenuItem", () => $ee90bbc4e1163598$export$d311b4cb0fdc0b92);

var $4Oh0F = parcelRequire("4Oh0F");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jjUR3 = parcelRequire("jjUR3");

var $hrlU6 = parcelRequire("hrlU6");

var $46ae2 = parcelRequire("46ae2");

var $fmg3f = parcelRequire("fmg3f");
function $ee90bbc4e1163598$export$d311b4cb0fdc0b92({ queryRef: queryRef }) {
    const data = (0, $8Uumt.useFragment)((0, $4Oh0F.default), queryRef);
    const { addNew: addNew } = (0, $jjUR3.useConnectItemClickHistory)();
    const onClick = (0, $5uXOq.useCallback)((e, target, styleClass, url)=>{
        if (url == null) return;
        addNew(url);
        if (target == null) return;
        (0, $hrlU6.withConnectHost)((connectHost)=>{
            connectHost.triggerWebItem(target, styleClass, url);
        });
        if ((0, $hrlU6.isConnectDialogWebItem)(styleClass)) e.preventDefault();
    }, [
        addNew
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $46ae2.Nav4AppMenuItem), {
        queryRef: data,
        onData: $ee90bbc4e1163598$var$transformData,
        onClick: onClick
    });
}
/**
 * Data transformer for Connect.
 * We are going to convert multi-page Connect apps into single-page ones in case their subpages don't contain a url that matches the root one.
 * For more details, see {@link canHaveSubpages}.
 */ function $ee90bbc4e1163598$var$transformData(data) {
    return (0, $fmg3f.canHaveSubpages)(data) ? data : {
        ...data,
        sections: null
    };
}

});
parcelRegister("4Oh0F", function(module, exports) {

$parcel$export(module.exports, "default", () => $6486cfe515f60293$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f245c96814deb8f505d2b497ec43b86d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6486cfe515f60293$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4ConnectMenuItem",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Nav4AppMenuItem"
        }
    ],
    "type": "JiraAppNavigationItem"
};
$6486cfe515f60293$var$node.hash = "76baf08d707245f4a5aadd384fd44056";
var $6486cfe515f60293$export$2e2bcd8739ae039 = $6486cfe515f60293$var$node;

});

parcelRegister("jjUR3", function(module, exports) {

$parcel$export(module.exports, "useConnectItemClickHistory", () => $c499ec49965fe6fe$export$c251e3fda1cce4a3);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");
// A single instance for the entire SPA session
const $c499ec49965fe6fe$var$history = {
    unique: []
};
const $c499ec49965fe6fe$export$c251e3fda1cce4a3 = ()=>{
    (0, $gKZoD.di)(window);
    const addNew = (0, $5uXOq.useCallback)((historyItem)=>{
        // Here we want to store only unique items. For example, if the add-on updates Jira hash
        // and user clicks the same navigation link we consider it as a unique navigation action
        // so we can use this info later on to rerender the iframe
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (window.location.href.endsWith(historyItem) === false) // @ts-expect-error - TS2339 - Property 'push' does not exist on type 'readonly []'.
        $c499ec49965fe6fe$var$history.unique.push(historyItem);
    }, []);
    return (0, $5uXOq.useMemo)(()=>({
            history: $c499ec49965fe6fe$var$history,
            addNew: addNew
        }), [
        addNew
    ]);
};
const $c499ec49965fe6fe$export$ef04cd58bebb0345 = ()=>{
    // @ts-expect-error TS2540: Cannot assign to 'length' because it is a read-only property.
    $c499ec49965fe6fe$var$history.unique.length = 0;
};

});

parcelRegister("hrlU6", function(module, exports) {

$parcel$export(module.exports, "withConnectHost", () => $9316db67541b8a94$export$970e2411dd8601c8);
$parcel$export(module.exports, "getConnectHost", () => $9316db67541b8a94$export$186d423c00af146c);
$parcel$export(module.exports, "isConnectDialogWebItem", () => $9316db67541b8a94$export$920fb4b46d4f2eec);

var $dJZWD = parcelRequire("dJZWD");
const $9316db67541b8a94$export$970e2411dd8601c8 = async (action)=>{
    const connectHost = await (0, $dJZWD.setupConnectJs)();
    action(connectHost);
};
const $9316db67541b8a94$export$186d423c00af146c = ()=>window.connectHost;
const $9316db67541b8a94$export$920fb4b46d4f2eec = (classes)=>classes.includes('ap-dialog') || classes.includes('ap-inline-dialog');

});
parcelRegister("dJZWD", function(module, exports) {

$parcel$export(module.exports, "setupConnectJs", () => $762ba9fa524ea8e6$export$891414b605e5f038);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $6BZYo = parcelRequire("6BZYo");
var $cQZXC = parcelRequire("cQZXC");

var $dH9DT = parcelRequire("dH9DT");

const $762ba9fa524ea8e6$var$installConnectJs = async ()=>{
    // we need the heritage to load in order for WRM core and jQuery to exist.
    // eslint-disable-next-line jira/wrm/no-load-bridge
    await (0, $cQZXC.waitForHeritage)();
    await (0, $dH9DT.waitForJQuery)();
    const loader = await (parcelRequire("fsoZQ"));
    await loader.performSideEffects();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.connectHost;
};
let $762ba9fa524ea8e6$var$installConnectJsPromise = null;
const $762ba9fa524ea8e6$export$891414b605e5f038 = async ()=>{
    // Only pages in the SPA will benefit from modernising connect
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__SPA__) {
        if ($762ba9fa524ea8e6$var$installConnectJsPromise === null) $762ba9fa524ea8e6$var$installConnectJsPromise = $762ba9fa524ea8e6$var$installConnectJs();
        return $762ba9fa524ea8e6$var$installConnectJsPromise;
    }
    // eslint-disable-next-line jira/wrm/no-load-bridge
    await (0, $6BZYo.loadBridge)({
        name: 'ac/create',
        wrmKeys: [
            'wrc!com.atlassian.plugins.atlassian-connect-plugin:jira-atlassian-connect-resources-v5',
            // Undeclared Dependency: jira/navigation
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:sidebar'
        ]
    });
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.connectHost;
};

});
parcelRegister("6BZYo", function(module, exports) {

$parcel$export(module.exports, "loadBridge", () => $ce95ee3fd66207c7$export$df8409da353bde5a);

var $fqWWz = parcelRequire("fqWWz");
var $3GASE = parcelRequire("3GASE");
var $ig88W = parcelRequire("ig88W");
var $7T84i = parcelRequire("7T84i");

var $ig88W = parcelRequire("ig88W");
var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");
var $8JNtu = parcelRequire("8JNtu");
var $5Ik5Y = parcelRequire("5Ik5Y");
const $ce95ee3fd66207c7$export$df8409da353bde5a = ({ name: name, wrmKeys: wrmKeys, tentatives: tentatives = (0, $fqWWz.MAX_RETRIES), timeout: timeout = (0, $fqWWz.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>{
    if (wrmKeys != null) return (0, $7T84i.loadBridgeStrict)({
        name: name,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        wrmKeys: [].concat(wrmKeys),
        shouldLogError: shouldLogError
    });
    if (tentatives <= 0) return Promise.reject(new Error('Unable to load bridge, zero tentatives never works'));
    if (tentatives <= 1) return (0, $3GASE.loadBridgeBail)({
        name: name,
        shouldLogError: shouldLogError
    });
    return (0, $ig88W.loadBridgeRace)({
        name: name,
        shouldLogError: shouldLogError,
        timeout: (tentatives - 1) * timeout
    });
};

});
parcelRegister("fqWWz", function(module, exports) {

$parcel$export(module.exports, "safeErrorWithoutCustomerData", () => $71bf66166926d1dc$export$f19a2d31722e3428);
$parcel$export(module.exports, "MAX_RETRIES", () => $71bf66166926d1dc$export$1f86472c1374185a);
$parcel$export(module.exports, "DEFAULT_TIMEOUT", () => $71bf66166926d1dc$export$7bd623b29ec8e1eb);
$parcel$export(module.exports, "SHOULD_LOG_ERROR", () => $71bf66166926d1dc$export$37f20f0ff732fcd7);

var $2YZCu = parcelRequire("2YZCu");
const { safeErrorWithoutCustomerData: $71bf66166926d1dc$export$f19a2d31722e3428, safeInfoWithoutCustomerData: $71bf66166926d1dc$export$ea810ce67e3c8eac } = (0, $2YZCu.default);
const $71bf66166926d1dc$export$1f86472c1374185a = 40;
const $71bf66166926d1dc$export$7bd623b29ec8e1eb = 500;
const $71bf66166926d1dc$export$37f20f0ff732fcd7 = true;

});

parcelRegister("3GASE", function(module, exports) {

$parcel$export(module.exports, "loadBridgeBail", () => $e512b6cc4a8702e5$export$a036f92c2465504e);

var $wRU6t = parcelRequire("wRU6t");

var $fqWWz = parcelRequire("fqWWz");
const $e512b6cc4a8702e5$export$a036f92c2465504e = async ({ name: name, shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>{
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $fqWWz.safeErrorWithoutCustomerData)('common.bridge', `Unable to load bridge "${name}". ${(0, $wRU6t.safeStringify)(error) ?? ''}`, {
            isSpa: __SPA__,
            name: name,
            error: (0, $wRU6t.safeStringify)(error)
        });
        throw new Error(`Unable to load bridge "${name}"`, {
            cause: error
        });
    }
};

});
parcelRegister("wRU6t", function(module, exports) {

$parcel$export(module.exports, "safeStringify", () => $7e2bd894031d4476$export$56831a8b9cb27763);
/**
 * Stringifies a JS object for logging.
 * @param object
 * @returns {string}
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7e2bd894031d4476$export$56831a8b9cb27763 = (object)=>{
    if (!object) return '';
    if (object instanceof Error) return object.stack || object.message;
    return JSON.stringify(object, Object.getOwnPropertyNames(object));
};

});


parcelRegister("ig88W", function(module, exports) {

$parcel$export(module.exports, "loadBridgeRace", () => $64f1dbae1ea314ee$export$20c32b4579d78b92);

var $3GASE = parcelRequire("3GASE");

var $9B86Q = parcelRequire("9B86Q");

var $fqWWz = parcelRequire("fqWWz");
const $64f1dbae1ea314ee$export$20c32b4579d78b92 = ({ name: name, timeout: timeout = (0, $fqWWz.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>Promise.race([
        (0, $9B86Q.loadBridgeWeak)({
            name: name
        }),
        new Promise((resolve)=>setTimeout(resolve, timeout)).then(()=>(0, $3GASE.loadBridgeBail)({
                name: name,
                shouldLogError: shouldLogError
            }))
    ]);

});
parcelRegister("9B86Q", function(module, exports) {

$parcel$export(module.exports, "loadBridgeWeak", () => $61b2a5aa3a2a1160$export$3cefda82396756a1);

var $ifVVd = parcelRequire("ifVVd");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $61b2a5aa3a2a1160$var$pollingSingleton = null;
const $61b2a5aa3a2a1160$export$3cefda82396756a1 = ({ name: name })=>{
    const getter = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    $61b2a5aa3a2a1160$var$pollingSingleton ?? (0, $ifVVd.createPollingCollection)((v)=>window.require(v), 100);
    $61b2a5aa3a2a1160$var$pollingSingleton = getter;
    return getter(name);
};

});
parcelRegister("ifVVd", function(module, exports) {

$parcel$export(module.exports, "createPollingCollection", () => $60e6b0d4bc46beac$export$f163446a982a8077);

var $gKZoD = parcelRequire("gKZoD");

var $aePFs = parcelRequire("aePFs");
const $60e6b0d4bc46beac$export$f163446a982a8077 = (fn, timeout)=>{
    (0, $gKZoD.di)(setTimeout);
    let isPolling = false;
    // Deferred instance is retained for polling
    const deferredMap = new Map();
    // Promise is derived from Deferred and is retained indefinitely
    const promiseMap = new Map();
    // Provided fn will throw until ready, once ready we will resolve and delete the Deferred
    const evaluateForKey = (key)=>{
        let result;
        try {
            result = fn(key);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            return;
        }
        const deferred = deferredMap.get(key);
        if (deferred instanceof (0, $aePFs.default)) {
            deferred.resolve(result);
            deferredMap.delete(key);
        }
    };
    const maybePoll = ()=>{
        if (!isPolling && deferredMap.size > 0) {
            isPolling = true;
            setTimeout(()=>{
                isPolling = false;
                [
                    ...deferredMap.keys()
                ].forEach(evaluateForKey);
                maybePoll();
            }, timeout);
        }
    };
    const getter = (key)=>{
        if (!promiseMap.has(key)) {
            const deferred = new (0, $aePFs.default)();
            const promise = deferred.then((v)=>v);
            deferredMap.set(key, deferred);
            promiseMap.set(key, promise);
            evaluateForKey(key);
            maybePoll();
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return promiseMap.get(key);
    };
    return getter;
};

});
parcelRegister("aePFs", function(module, exports) {

$parcel$export(module.exports, "default", () => $02f3c6551bf5b1ff$export$2e2bcd8739ae039);
// @ts-expect-error - TS2417 - Class static side 'typeof Deferred' incorrectly extends base class static side '{ all<T>(values: Iterable<T | PromiseLike<T>>): Promise<Awaited<T>[]>; all<T extends readonly unknown[] | []>(values: T): Promise<{ -readonly [P in keyof T]: Awaited<T[P]>; }>; ... 5 more ...; readonly [Symbol.species]: PromiseConstructor; }'.
class $02f3c6551bf5b1ff$export$2e2bcd8739ae039 extends Promise {
    // go/jfe-eslint
    static resolve(v) {
        const instance = new $02f3c6551bf5b1ff$export$2e2bcd8739ae039();
        instance.resolve(v);
        return instance;
    }
    // go/jfe-eslint
    static reject(e) {
        const instance = new $02f3c6551bf5b1ff$export$2e2bcd8739ae039();
        instance.reject(e);
        return instance;
    }
    constructor(){
        // Promise.prototype.then() must be able to call new Deferred(fn)
        // @see https://stackoverflow.com/a/48159603
        // by using arguments flow will ensure we cannot instantiate with constructor parameters
        // eslint-disable-next-line prefer-rest-params
        const [fn] = Array.prototype.slice.call(arguments);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const callbacks = [];
        super(fn ?? callbacks.push.bind(callbacks));
        this.#resolve = callbacks[0];
        this.#reject = callbacks[1];
    }
    #resolve;
    #reject;
    resolve(v) {
        this.#resolve?.(v);
    }
    reject(e) {
        this.#reject?.(e);
    }
}

});




parcelRegister("7T84i", function(module, exports) {

$parcel$export(module.exports, "loadBridgeStrict", () => $89a95eb8b151782d$export$eba600d28decc4ac);

var $c56lL = parcelRequire("c56lL");

var $ig88W = parcelRequire("ig88W");

var $fVOHM = parcelRequire("fVOHM");

var $fqWWz = parcelRequire("fqWWz");
const $89a95eb8b151782d$export$eba600d28decc4ac = async ({ name: name, wrmKeys: wrmKeys, shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>{
    (0, $c56lL.saveStats)(name, wrmKeys);
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        await (0, $fVOHM.loadWrmResources)({
            wrmKeys: wrmKeys,
            shouldLogError: shouldLogError
        });
        return (0, $ig88W.loadBridgeRace)({
            name: name,
            shouldLogError: shouldLogError
        });
    }
};

});
parcelRegister("c56lL", function(module, exports) {

$parcel$export(module.exports, "saveStats", () => $6c875a5034ae8433$export$9ea3ff7978093559);
const $6c875a5034ae8433$var$incrementResourceStats = (resource, stats)=>{
    if (stats[resource] == null) // eslint-disable-next-line no-param-reassign
    stats[resource] = 1;
    else // eslint-disable-next-line no-param-reassign
    stats[resource] += 1;
};
const $6c875a5034ae8433$var$getEmptyLoadBridgeStats = ()=>({
        requests: 0,
        amdModules: {},
        wrmKeys: {}
    });
const $6c875a5034ae8433$var$initStats = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__WRM_INTERNAL_STATS__ == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__ = {
        loadBridge: $6c875a5034ae8433$var$getEmptyLoadBridgeStats()
    };
    else if (window.__WRM_INTERNAL_STATS__.loadBridge == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__.loadBridge = $6c875a5034ae8433$var$getEmptyLoadBridgeStats();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WRM_INTERNAL_STATS__.loadBridge;
};
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $6c875a5034ae8433$var$isPageInteractive = ()=>window.__WRM_INTERNAL_STATS__?.isPageInteractive;
const $6c875a5034ae8433$export$9ea3ff7978093559 = (amdModuleName, wrmKeys)=>{
    try {
        const stats = $6c875a5034ae8433$var$initStats();
        // stop accumulating stats at TTI mark
        if ($6c875a5034ae8433$var$isPageInteractive()) return;
        stats.requests += 1;
        $6c875a5034ae8433$var$incrementResourceStats(amdModuleName, stats.amdModules);
        if (Array.isArray(wrmKeys)) wrmKeys.forEach((wrmKey)=>$6c875a5034ae8433$var$incrementResourceStats(wrmKey, stats.wrmKeys));
        else if (wrmKeys != null) $6c875a5034ae8433$var$incrementResourceStats(wrmKeys, stats.wrmKeys);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // not critical functionality
    }
};

});

parcelRegister("fVOHM", function(module, exports) {

$parcel$export(module.exports, "loadWrmResources", () => $0c0552c7bb135144$export$6cda16b6eff75f59);

var $wRU6t = parcelRequire("wRU6t");

var $294PS = parcelRequire("294PS");

var $9B86Q = parcelRequire("9B86Q");

var $fqWWz = parcelRequire("fqWWz");
const $0c0552c7bb135144$export$6cda16b6eff75f59 = async ({ wrmKeys: wrmKeys, shouldLogError: shouldLogError, ...options })=>{
    const isPrefetch = 'batchUrl' in options;
    let newWrmKeys = wrmKeys;
    try {
        const name = isPrefetch ? 'wrm/require-v2' : 'wrm/require';
        const wrmRequireModule = await (0, $9B86Q.loadBridgeWeak)({
            name: name
        });
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const wrmRequire = isPrefetch ? wrmRequireModule.requireWithPrefetch : wrmRequireModule;
        // @ts-expect-error - TS2322 - Type 'string | string[]' is not assignable to type 'string[]'.
        newWrmKeys = (0, $294PS.prependSuperBatchDepsOnce)(wrmKeys);
        if (isPrefetch) return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys, options.batchUrl)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
        return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $fqWWz.safeErrorWithoutCustomerData)('common.bridge.wrm', 'Unable to load wrm resource', {
            isSpa: __SPA__,
            wrmKeys: JSON.stringify(newWrmKeys),
            error: (0, $wRU6t.safeStringify)(error)
        });
        throw new Error('Unable to load wrm resource', {
            cause: error
        });
    }
};

});
parcelRegister("294PS", function(module, exports) {

$parcel$export(module.exports, "prependSuperBatchDepsOnce", () => $a437264dd6b89021$export$93d9db5fbabad1b0);

var $1r4rO = parcelRequire("1r4rO");
let $a437264dd6b89021$var$isSuperBatchDependenciesLoaded = false;
const $a437264dd6b89021$var$isOnRapidBoardsPage = ()=>{
    const boardsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*[/]?$/;
    const backlogsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*\/backlog[/]?$/;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { pathname: pathname } = window.location;
    return boardsRegex.test(pathname) || backlogsRegex.test(pathname) || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href.includes('secure/RapidBoard.jspa');
};
const $a437264dd6b89021$export$93d9db5fbabad1b0 = (wrmKeys)=>{
    // These usually need injecting before most domain-specific deps but in rapidboards they load a
    // smaller set of the needed deps internally early and delay the rest
    if ($a437264dd6b89021$var$isSuperBatchDependenciesLoaded || $a437264dd6b89021$var$isOnRapidBoardsPage()) return wrmKeys;
    $a437264dd6b89021$var$isSuperBatchDependenciesLoaded = true;
    return (0, $1r4rO.jiraSuperBatchDependencies).concat(wrmKeys);
};

});
parcelRegister("1r4rO", function(module, exports) {

$parcel$export(module.exports, "jiraSuperBatchDependencies", () => $e87d6a02e2466ae8$export$f14a6b583ce9e077);
const $e87d6a02e2466ae8$export$f14a6b583ce9e077 = [
    // SKATE HAS TO COME FIRST OR ELSE THE OTHER MODULES WILL FAIL
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:util-lite',
    'wrc!jira.webresources:util',
    'wrc!jira.webresources:feature-flags',
    'wrc!jira.webresources:dialogs',
    'wrc!jira.webresources:jira-global',
    'wrc!com.atlassian.auiplugin:aui-spinner'
];

});




parcelRegister("cQZXC", function(module, exports) {

$parcel$export(module.exports, "waitForHeritage", () => $90def0f7a7aa11d6$export$c61060338d026f78);

var $7aBP4 = parcelRequire("7aBP4");

var $aePFs = parcelRequire("aePFs");
const $90def0f7a7aa11d6$export$c61060338d026f78 = ()=>{
    if (false) // WRM is not used on server
    // return null because we don't want to ?.then() chain into loadBridge functions
    return null;
    if (!__SPA__) // Heritage remainder is an SPA concept
    // return promise because we want to ?.then() chain into loadBridge functions
    return Promise.resolve();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (!window.__WAIT_FOR_HERITAGE__) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WAIT_FOR_HERITAGE__ = new (0, $aePFs.default)();
        (0, $7aBP4.bootstrapWrmClient)().then(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.__WAIT_FOR_HERITAGE__.resolve();
        });
    }
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WAIT_FOR_HERITAGE__;
};

});
parcelRegister("7aBP4", function(module, exports) {

$parcel$export(module.exports, "bootstrapWrmClient", () => $f93199c7ae9c59d8$export$d001f71dd306cb0c);

var $7f4tk = parcelRequire("7f4tk");

var $wRU6t = parcelRequire("wRU6t");

var $jcw0u = parcelRequire("jcw0u");
const $f93199c7ae9c59d8$var$SPA_WRM_CONTEXT_ENDPOINT = '/rest/frontend/1/spawrmcontext';
const $f93199c7ae9c59d8$var$fetchSpaWrmContext = async ()=>{
    return (0, $7f4tk.default)($f93199c7ae9c59d8$var$SPA_WRM_CONTEXT_ENDPOINT);
};
const $f93199c7ae9c59d8$var$createResourceElement = ({ url: url, resourceType: resourceType, key: key, batchType: batchType })=>{
    let element;
    if (resourceType === 'JAVASCRIPT') {
        element = globalThis.document?.createElement('script');
        element.setAttribute('crossorigin', '');
        element.setAttribute('src', url);
        element.setAttribute('data-client-bootstrapped', '');
        element.setAttribute('data-wrm-key', key);
        element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
    } else {
        element = globalThis.document?.createElement('link');
        element.setAttribute('crossorigin', '');
        element.setAttribute('href', url);
        element.setAttribute('rel', 'stylesheet');
        element.setAttribute('media', 'all');
        element.setAttribute('data-client-bootstrapped', '');
        element.setAttribute('data-wrm-key', key);
        element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
    }
    return element;
};
let $f93199c7ae9c59d8$var$hasWrmInitialised;
const $f93199c7ae9c59d8$var$runBootstrap = ()=>{
    const spaWrmContext = $f93199c7ae9c59d8$var$fetchSpaWrmContext();
    return new Promise((resolve, reject)=>{
        spaWrmContext.then(({ data: data, errors: errors, resources: resources })=>{
            // eslint-disable-next-line no-multi-assign
            const WRM = globalThis.WRM = globalThis.WRM || {};
            WRM._unparsedData = data;
            WRM._unparsedErrors = errors;
            if (WRM._dataArrived) WRM._dataArrived();
            resources.map($f93199c7ae9c59d8$var$createResourceElement).forEach((element)=>globalThis.document?.head.appendChild(element));
            resolve();
        }).catch((error)=>{
            (0, $jcw0u.default)({
                error: new Error((0, $wRU6t.safeStringify)(error)),
                meta: {
                    id: 'bootstrap-wrm-client',
                    packageName: 'common-bridge',
                    teamName: 'jfp-magma'
                }
            });
            reject(new Error('Failed to fetch the spa wrm context'));
        });
    });
};
const $f93199c7ae9c59d8$export$d001f71dd306cb0c = ()=>{
    if (false) return Promise.resolve();
    if ($f93199c7ae9c59d8$var$hasWrmInitialised) return $f93199c7ae9c59d8$var$hasWrmInitialised;
    // todo maybe a more robust check to validate whether WRM initialisation already underway?
    if (typeof globalThis.WRM !== 'undefined') $f93199c7ae9c59d8$var$hasWrmInitialised = Promise.resolve();
    else $f93199c7ae9c59d8$var$hasWrmInitialised = $f93199c7ae9c59d8$var$runBootstrap();
    return $f93199c7ae9c59d8$var$hasWrmInitialised;
};

});


parcelRegister("8JNtu", function(module, exports) {

$parcel$export(module.exports, "wrmRequire", () => $17e2d7d864398bad$export$cc9d8f51375ef66a);

var $fVOHM = parcelRequire("fVOHM");

var $fqWWz = parcelRequire("fqWWz");
const $17e2d7d864398bad$export$cc9d8f51375ef66a = async (wrmKeys, shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR))=>(0, $fVOHM.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError
    });

});

parcelRegister("5Ik5Y", function(module, exports) {

$parcel$export(module.exports, "wrmRequireWithPrefetch", () => $a1df1daee76d40f7$export$e53a5db19a39ed2f);

var $fVOHM = parcelRequire("fVOHM");

var $fqWWz = parcelRequire("fqWWz");
const $a1df1daee76d40f7$export$e53a5db19a39ed2f = async (wrmKeys, batchUrl, shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR))=>(0, $fVOHM.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError,
        batchUrl: batchUrl
    });

});


parcelRegister("dH9DT", function(module, exports) {

$parcel$export(module.exports, "getMeta", () => $a78c52ec7ed5d025$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "getJQuery", () => $a78c52ec7ed5d025$export$7232a6dc780f9887);
$parcel$export(module.exports, "getGlobalAP", () => $a78c52ec7ed5d025$export$fbc82125a6bd8012);
$parcel$export(module.exports, "isObject", () => $a78c52ec7ed5d025$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "escapeSelector", () => $a78c52ec7ed5d025$export$c8c0ea01c118c2eb);
$parcel$export(module.exports, "waitForJQuery", () => $a78c52ec7ed5d025$export$97214de9c546981c);
$parcel$export(module.exports, "ErrorDebugAddonKeys", () => $a78c52ec7ed5d025$export$d690da9bc8146677);

var $jcw0u = parcelRequire("jcw0u");

const $a78c52ec7ed5d025$export$c47913ca32a5c6f7 = (key)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const metaTag = document.querySelector(`meta[name='ajs-${key}']`);
    return metaTag === null ? undefined : metaTag.getAttribute('content') || undefined;
};
const $a78c52ec7ed5d025$export$7232a6dc780f9887 = ()=>AJS.$;
const $a78c52ec7ed5d025$export$fbc82125a6bd8012 = ()=>// In the future, we can add analytics events to know how this can fail to access the global variable.
    // We can improve it to load WRM in async
    // Just to add some context for future reviewers: `window._AP` is the actual Connect module that will no longer be loaded via WRM.
    // Its properties are both appended from modules like the dialog options and the public @atlassian/atlassian-connect-js library.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window._AP;
const $a78c52ec7ed5d025$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'function' || typeof obj === 'object' && !!obj;
const $a78c52ec7ed5d025$export$c8c0ea01c118c2eb = (s)=>{
    if (!s) throw new Error('No selector to escape');
    return s.replace(/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g, '\\$&');
};
const $a78c52ec7ed5d025$var$FIVE_MINUTES = 300000;
const $a78c52ec7ed5d025$export$97214de9c546981c = ()=>new Promise((resolve, reject)=>{
        const interval = setInterval(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (window.AJS?.$) {
                clearInterval(interval);
                resolve();
            }
        }, 10);
        setTimeout(()=>{
            clearInterval(interval);
            (0, $jcw0u.default)({
                meta: {
                    id: 'connect-jquery-timeout',
                    packageName: 'jiraConnect'
                },
                error: new Error('Timeout when waiting for jQuery to be available on the page'),
                // this is an extremely common error, so we don't want to spam Sentry with it
                skipSentry: true
            });
            reject();
        }, $a78c52ec7ed5d025$var$FIVE_MINUTES);
    });
const $a78c52ec7ed5d025$export$7315c38dc71bd41f = 'com.atlassian.servicedesk.embedded-dev';
const $a78c52ec7ed5d025$export$cb954c21735b28e4 = 'com.atlassian.servicedesk.embedded';
const $a78c52ec7ed5d025$export$d690da9bc8146677 = [
    $a78c52ec7ed5d025$export$cb954c21735b28e4,
    $a78c52ec7ed5d025$export$7315c38dc71bd41f
];

});

parcelRegister("fsoZQ", function(module, exports) {

let $b40cdc4ebdd385ab$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b40cdc4ebdd385ab$var$load("gZGeX").then(()=>parcelRequire('8vJyT'));

});



parcelRegister("46ae2", function(module, exports) {

$parcel$export(module.exports, "Nav4AppMenuItem", () => $0602058127748c94$export$549160040f86c542);

var $jX06n = parcelRequire("jX06n");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $aAbfD = parcelRequire("aAbfD");
var $lnznH = parcelRequire("lnznH");
var $cZa9B = parcelRequire("cZa9B");
var $gSZmd = parcelRequire("gSZmd");
var $1qQhw = parcelRequire("1qQhw");
var $1FdfO = parcelRequire("1FdfO");




var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $lhMtU = parcelRequire("lhMtU");

var $c16H2 = parcelRequire("c16H2");

var $5FnJJ = parcelRequire("5FnJJ");

var $dQbFB = parcelRequire("dQbFB");

var $fLtNy = parcelRequire("fLtNy");

var $5QCWL = parcelRequire("5QCWL");

var $9Ft6m = parcelRequire("9Ft6m");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

var $eIGIx = parcelRequire("eIGIx");
function $0602058127748c94$export$549160040f86c542({ queryRef: queryRef, onData: onData, onClick: onClick }) {
    const rawData = (0, $8Uumt.useFragment)((0, $jX06n.default), queryRef);
    const data = (0, $5uXOq.useMemo)(()=>onData ? onData($0602058127748c94$var$normalizeData(rawData)) : $0602058127748c94$var$normalizeData(rawData), [
        onData,
        rawData
    ]);
    const icon = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5QCWL.AppIcon), {
            iconUrl: data.iconUrl || ''
        }), [
        data.iconUrl
    ]);
    const withSeparators = (0, $5uXOq.useMemo)(()=>$0602058127748c94$var$shouldUseSeparators(data), [
        data
    ]);
    const envLozenge = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Ft6m.EnvLozenge), {
            label: data.envLabel || ''
        }), [
        data.envLabel
    ]);
    const actionsOnHover = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fLtNy.AppActions), {
            settingsUrl: data.settingsUrl || '',
            appId: data.appId || ''
        }), [
        data.settingsUrl,
        data.appId
    ]);
    const expandable = (0, $5uXOq.useMemo)(()=>{
        if ((data.sections || []).length === 0) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0602058127748c94$var$MaybeExpandable, {
            actionsOnHover: actionsOnHover,
            appId: data.appId || '',
            envLozenge: envLozenge,
            icon: icon,
            label: data.label || 'Unknown app',
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            menuIds: $0602058127748c94$var$toExpandableMenuId(data.sections),
            itemId: data.appId || '',
            level: (0, $951a0ed422513987$export$265c523d1a8f25cf)
        }, (data.sections || []).map((section, sectionIndex)=>(section?.links || []).length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1qQhw.MenuListItem), {
                key: `${sectionIndex}-${section?.label}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1FdfO.MenuSection), null, withSeparators && sectionIndex > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aAbfD.Divider), null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gSZmd.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0602058127748c94$var$MaybeExpandable, {
                appId: data.appId || '',
                label: section?.label || '',
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                menuIds: $0602058127748c94$var$toExpandableMenuId([
                    {
                        links: section?.links
                    }
                ]),
                itemId: `section/${sectionIndex}`,
                level: (0, $951a0ed422513987$export$fe3b012b0224e4e1)
            }, (section?.links || []).map((link, linkIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0602058127748c94$var$SimpleItem, {
                    appId: data.appId || '',
                    key: link?.url || '',
                    label: link?.label || '',
                    onClick: onClick,
                    styleClass: link?.styleClass || '',
                    url: link?.url == null ? null : $0602058127748c94$var$removeTrailingSlash(link?.url),
                    itemId: `section/${sectionIndex}/link/${linkIndex}`,
                    level: section?.label ? (0, $951a0ed422513987$export$f9db6a58b4aabd18) : (0, $951a0ed422513987$export$fe3b012b0224e4e1)
                })))))) : null));
    }, [
        data.sections,
        data.label,
        data.appId,
        icon,
        envLozenge,
        actionsOnHover,
        withSeparators,
        onClick
    ]);
    if (expandable) return expandable;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0602058127748c94$var$SimpleItem, {
        actionsOnHover: actionsOnHover,
        appId: data.appId || '',
        envLozenge: envLozenge,
        icon: icon,
        label: data.label || 'Unknown app',
        onClick: onClick,
        styleClass: data.styleClass || '',
        url: data.url == null ? null : $0602058127748c94$var$removeTrailingSlash(data.url || ''),
        itemId: data.appId || '',
        level: (0, $951a0ed422513987$export$265c523d1a8f25cf)
    });
}
function $0602058127748c94$var$SimpleItem({ actionsOnHover: actionsOnHover, appId: appId, envLozenge: envLozenge, icon: icon, label: label, onClick: onClick, styleClass: styleClass, url: url, itemId: itemId, level: level }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const anchorElement = (0, $5uXOq.useRef)(null);
    const onItemClick = (0, $5uXOq.useCallback)((e)=>{
        $0602058127748c94$var$fireAppClickEvent({
            event: createAnalyticsEvent({}),
            itemId: itemId,
            appId: appId,
            level: level
        });
        onClick?.(e, anchorElement.current, styleClass || '', url);
    }, [
        url,
        onClick,
        itemId,
        appId,
        level,
        styleClass,
        createAnalyticsEvent
    ]);
    // If a Connect app does NOT have a URL, we should use a MenuButtonItem instead.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        href: $0602058127748c94$var$removeTrailingSlash(url ?? ''),
        elemBefore: icon,
        elemAfter: envLozenge,
        actionsOnHover: actionsOnHover,
        menuId: $0602058127748c94$export$171d73a56172dba4(url ?? ''),
        ref: anchorElement,
        onClick: onItemClick
    }, label);
}
function $0602058127748c94$var$MaybeExpandable(params) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { actionsOnHover: actionsOnHover, children: children, envLozenge: envLozenge, icon: icon, label: label, menuIds: menuIds, itemId: itemId, appId: appId, level: level } = params;
    const menuId = (0, $lhMtU.toMenuIdFromMenuIdList)(menuIds);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        $0602058127748c94$var$fireAppClickEvent({
            event: createAnalyticsEvent({}),
            itemId: itemId,
            appId: appId,
            level: level,
            isExpandable: true
        });
    }, [
        createAnalyticsEvent,
        itemId,
        appId,
        level
    ]);
    const onExpansionToggle = (0, $eIGIx.useCallbackWithCondition)((hasExpanded)=>{
        if (hasExpanded) onClick();
    }, [
        onClick
    ], ()=>(0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1'));
    return label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        menuId: menuId,
        isExpanded: level !== (0, $951a0ed422513987$export$265c523d1a8f25cf),
        onExpansionToggle: onExpansionToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZa9B.ExpandableMenuItemTrigger), {
        actionsOnHover: actionsOnHover,
        elemBefore: icon,
        elemAfter: envLozenge,
        testId: (0, $dQbFB.getTestId)(menuId)
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnznH.ExpandableMenuItemContent), null, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
}
function $0602058127748c94$var$fireAppClickEvent(params) {
    const { event: event, itemId: itemId, appId: appId, level: level, isExpandable: isExpandable } = params;
    (0, $8zOmE.fireUIAnalytics)(event, {
        action: 'clicked',
        actionSubject: 'navigationItem',
        actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_APPS],
        attributes: {
            level: level,
            componentType: (0, $1e554a683893bd46$export$3ac911b122986477),
            itemId: itemId,
            isExpandable: isExpandable,
            section: 'yourApps',
            ...level === (0, $951a0ed422513987$export$265c523d1a8f25cf) ? {
                itemType: (0, $632bd8725b437a12$export$c3d83ca6855fa0d0)
            } : {
                itemType: (0, $632bd8725b437a12$export$509e83d3c8d91279),
                parentItemId: appId,
                parentItemType: (0, $632bd8725b437a12$export$c3d83ca6855fa0d0)
            }
        }
    });
}
function $0602058127748c94$var$shouldUseSeparators(data) {
    for (const section of data.sections || []){
        if (section?.label) return false;
    }
    return true;
}
/**
 * Common data transformer.
 * Filters out sections with empty links.
 */ function $0602058127748c94$var$normalizeData(data) {
    return {
        ...data,
        sections: (data.sections || []).filter((section)=>(section?.links || []).length > 0)
    };
}
const $0602058127748c94$var$removeTrailingSlash = (url = '')=>url.replace(/\/$/, '');
const $0602058127748c94$var$removeQueryParams = (url)=>url.split('?')[0];
const $0602058127748c94$var$removeHash = (url)=>url.split('#')[0];
const $0602058127748c94$export$171d73a56172dba4 = (path_ = '')=>{
    let path = path_;
    // This is the format we ask Connect vendors to use: /plugins/servlet/ac/:addonKey/:moduleKey
    // However, there are Connect apps that do not follow our recommendations and add extra path segments.
    // As result they might look like this: /plugins/servlet/ac/:addonKey/:moduleKey/:extraPathSegment
    // Because of that we have issues with menu ids matching since the path created out of current route differs from the actual url.
    // To fix this we remove those extra path segments from the url.
    if (path.startsWith('/plugins/servlet/ac/')) path = path.split('/').slice(0, 6).join('/');
    return (0, $jhS4y.ENTITY_ID).APP($0602058127748c94$var$removeTrailingSlash($0602058127748c94$var$removeQueryParams($0602058127748c94$var$removeHash(path))));
};
// Because of the apps nature, the parent url may differ from the child url.
// And if we want to make sure the expand state is properly calculated, we must pass down children menu ids.
const $0602058127748c94$var$toExpandableMenuId = (sections)=>(sections || []).flatMap(({ links: links })=>(links || []).map((link)=>$0602058127748c94$export$171d73a56172dba4(link.url)));

});
parcelRegister("jX06n", function(module, exports) {

$parcel$export(module.exports, "default", () => $af6546e449d47625$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f1dd304f2b2075cf9083f0c067a308e3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $af6546e449d47625$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "label"
    }, v1 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v2 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "Nav4AppMenuItem",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "appId"
            },
            {
                "kind": "ScalarField",
                "name": "envLabel"
            },
            {
                "kind": "ScalarField",
                "name": "iconUrl"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            {
                "concreteType": "JiraAppSection",
                "kind": "LinkedField",
                "name": "sections",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "concreteType": "JiraAppNavigationItemNestedLink",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": true,
                        "selections": [
                            v0 /*: any*/ ,
                            v2 /*: any*/ ,
                            v1 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "settingsUrl"
            },
            v2 /*: any*/ 
        ],
        "type": "JiraAppNavigationItem"
    };
}();
$af6546e449d47625$var$node.hash = "fe622bd16e14b11ec5e3f21d8553bac3";
var $af6546e449d47625$export$2e2bcd8739ae039 = $af6546e449d47625$var$node;

});

parcelRegister("aAbfD", function(module, exports) {

$parcel$export(module.exports, "Divider", () => $f1ca0f480f6cde16$export$2e0a83ec2e27ecbb);
/* divider.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $f1ca0f480f6cde16$var$styles = null;
const $f1ca0f480f6cde16$export$2e0a83ec2e27ecbb = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("hr", {
        /**
 * The existing usage of these dividers is presentational,
 * so we are removing the separator semantics by default.
 *
 * In the future we may consider allowing opt-in separator semantics,
 * but it probably isn't necessary.
 */ role: "none",
        className: (0, $bwpsq.default)([
            "_h7alglyw _179rglyw _mqm2zgxb _1bsb1osq"
        ])
    });

});

const $632bd8725b437a12$export$9b8283d5878d2491 = 'board';
const $632bd8725b437a12$export$c3d83ca6855fa0d0 = 'app';
const $632bd8725b437a12$export$c1c49903035a02df = 'filter';
const $632bd8725b437a12$export$6deee0e4f2fb784e = 'defaultFilter';
const $632bd8725b437a12$export$4695c1a423ffe431 = 'dashboard';
const $632bd8725b437a12$export$5828682c822c26e7 = 'queue';
const $632bd8725b437a12$export$fe791c4fa892e400 = 'project';
const $632bd8725b437a12$export$c303e491e026ebc6 = 'plan';
const $632bd8725b437a12$export$509e83d3c8d91279 = 'appSubpage';
const $632bd8725b437a12$export$a2e7d1d0a3d169f4 = 'asset';
const $632bd8725b437a12$export$b56168d831461ce2 = 'operation';
const $632bd8725b437a12$export$499a3e77858b7713 = 'translationGroup';
const $632bd8725b437a12$export$bb8a37ab8d9ba82b = 'roadmap';
const $632bd8725b437a12$export$9a778ca616c24a93 = 'projectRecommendation';
const $632bd8725b437a12$export$9cbb0f231a0ab7ea = 'overview';
const $632bd8725b437a12$export$119dad133da0b4a = 'changeView';

parcelRegister("fLtNy", function(module, exports) {

$parcel$export(module.exports, "AppActions", () => $c30e381fa79c5849$export$6b031ef628e5f9c2);

var $5uXOq = parcelRequire("5uXOq");

var $epOG5 = parcelRequire("epOG5");

var $3Z96c = parcelRequire("3Z96c");
var $9UCCQ = parcelRequire("9UCCQ");

var $koVbs = parcelRequire("koVbs");




var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $aCS3f = parcelRequire("aCS3f");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $cSaAc = parcelRequire("cSaAc");
function $c30e381fa79c5849$export$6b031ef628e5f9c2({ settingsUrl: settingsUrl, appId: appId, onClose: onClose }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireOpenEvent = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_APPS],
            attributes: {
                level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                componentType: (0, $1e554a683893bd46$export$9bd6c21d500ae611),
                itemId: 'meatballDropdown',
                section: 'yourApps'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireClickEvent = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_APPS],
            attributes: {
                level: (0, $951a0ed422513987$export$f9db6a58b4aabd18),
                componentType: (0, $1e554a683893bd46$export$5374c2c2d3ece55e),
                parentItemId: appId,
                parentItemType: (0, $632bd8725b437a12$export$c3d83ca6855fa0d0),
                itemId: 'appSettings',
                section: 'yourApps'
            }
        });
    }, [
        createAnalyticsEvent,
        appId
    ]);
    if (!settingsUrl) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCS3f.MoreNavMenuButton), {
        MenuItems: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Z96c.default), {
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($epOG5))), {
                    label: "",
                    color: "var(--ds-icon, #44546F)"
                }),
                href: settingsUrl,
                target: "_blank",
                onClick: (...args)=>{
                    fireClickEvent();
                    props.onClose?.(...args);
                }
            }, formatMessage((0, $cSaAc.default).appSettings))),
        onOpen: fireOpenEvent,
        onClose: onClose
    });
}

});
parcelRegister("cSaAc", function(module, exports) {

$parcel$export(module.exports, "default", () => $9feae85879e795be$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9feae85879e795be$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    appSettings: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-apps.common.app-actions.app-settings",
        "defaultMessage": "App settings"
    }
});

});


parcelRegister("5QCWL", function(module, exports) {

$parcel$export(module.exports, "AppIcon", () => $1ef09001d2a6006a$export$5153830bdfb71453);

var $5uXOq = parcelRequire("5uXOq");

var $hRf4g = parcelRequire("hRf4g");

var $k4j3t = parcelRequire("k4j3t");
function $1ef09001d2a6006a$export$5153830bdfb71453({ iconUrl: iconUrl }) {
    return iconUrl.trim().length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k4j3t.IconCustom), {
        url: iconUrl
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hRf4g))), {
        label: "",
        color: "var(--ds-icon, #44546F)"
    });
}

});
parcelRegister("k4j3t", function(module, exports) {

$parcel$export(module.exports, "IconCustom", () => $0744fb0e35ced980$export$5b6504ec6adf0047);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $ljMUk = parcelRequire("ljMUk");
// got this value through trial and error
// in the long term, we should change the color of icon generated for the conntect apps
const $0744fb0e35ced980$var$colorMatrixValues = '0.08, 0, 0, 0, 0, 0, 0.1, 0, 0, 0, 0, 0,0.2, 0, 0, 0, 0, 0, 1, 0';
const $0744fb0e35ced980$export$5b6504ec6adf0047 = ({ url: url, shouldChangeFillColor: shouldChangeFillColor = true, ariaLabelledBy: ariaLabelledBy })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $0744fb0e35ced980$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        viewBox: "0 0 20 20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("filter", {
        id: "changeFillColor"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("feColorMatrix", {
        type: "matrix",
        values: $0744fb0e35ced980$var$colorMatrixValues
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("image", {
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        xlinkHref: url,
        width: "20",
        height: "20",
        x: "0",
        y: "0",
        filter: shouldChangeFillColor && (0, $ljMUk.checkForSvg)(url) ? 'url(#changeFillColor)' : '',
        "aria-labelledby": ariaLabelledBy
    })));
};
const $0744fb0e35ced980$var$styles = (0, $8CUq3.xcss)({
    display: 'inline-block',
    margin: 'space.025',
    height: "var(--ds-space-250, 20px)",
    width: "var(--ds-space-250, 20px)"
});

});
parcelRegister("ljMUk", function(module, exports) {

$parcel$export(module.exports, "checkForSvg", () => $c203648fb17df2d9$export$9a369805b0fabb72);
const $c203648fb17df2d9$export$9a369805b0fabb72 = (url)=>{
    const fileType = url.split(/#|\?/)[0].split('.').pop();
    // falsey check is for Ts
    return fileType ? fileType.trim() === 'svg' : false;
};

});



parcelRegister("9Ft6m", function(module, exports) {

$parcel$export(module.exports, "EnvLozenge", () => $5f161ee51f6727e1$export$61c90f482f9775c6);

var $5uXOq = parcelRequire("5uXOq");

var $aYAc3 = parcelRequire("aYAc3");
function $5f161ee51f6727e1$export$61c90f482f9775c6({ label: label }) {
    return label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
        appearance: label === 'Dev' ? 'default' : 'moved'
    }, label) : null;
}

});


parcelRegister("fmg3f", function(module, exports) {

$parcel$export(module.exports, "canHaveSubpages", () => $9085d7a7b2e046cd$export$352a285d5cb56873);
/**
 * The magic is copied from jira/src/packages/navigation-apps/sidebar/connect/src/common/utils/find-item-stack/index.tsx
 * No clue what that `s` query param stands for, just keeping the link comparison logic 1:1 to avoid regressions.
 */ 
var $ajpes = parcelRequire("ajpes");
// JSPA-1062 remove qs items that might not always be there
const $9085d7a7b2e046cd$var$splitRelevantQs = (s)=>s.replace('?', '').split('&').filter((v)=>v && !/^(ac\.|project|board|user|servicedesk)/.test(v));
// match query strings, but allow case where query param "s" is present in the menu item, but not the window url
const $9085d7a7b2e046cd$var$isSameQuery = (locationQuery, itemQuery)=>(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(locationQuery, itemQuery) || !locationQuery.some((q)=>q.startsWith('s=')) && (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(itemQuery.filter((q)=>!q.startsWith('s=')), locationQuery);
const $9085d7a7b2e046cd$var$parseUrl = (url = '')=>{
    const [pathname, qs = ''] = url.split('#')[0].split('?');
    return {
        pathname: pathname,
        query: $9085d7a7b2e046cd$var$splitRelevantQs(qs)
    };
};
function $9085d7a7b2e046cd$export$352a285d5cb56873(data) {
    const sections = data.sections || [];
    const { pathname: rootPagePathname, query: rootPageQuery } = $9085d7a7b2e046cd$var$parseUrl(data.url || '');
    for (const section of sections){
        if ((section?.links || []).some((link)=>{
            const { pathname: pathname, query: query } = $9085d7a7b2e046cd$var$parseUrl(link?.url || '');
            return rootPagePathname === pathname && $9085d7a7b2e046cd$var$isSameQuery(rootPageQuery, query);
        })) return true;
    }
    return false;
}

});


parcelRegister("8MAOw", function(module, exports) {

$parcel$export(module.exports, "Nav4ForgeMenuItem", () => $a309e8f531726635$export$9d5c2149f38ae387);

var $4QYEU = parcelRequire("4QYEU");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $46ae2 = parcelRequire("46ae2");
function $a309e8f531726635$export$9d5c2149f38ae387({ queryRef: queryRef }) {
    const data = (0, $8Uumt.useFragment)((0, $4QYEU.default), queryRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $46ae2.Nav4AppMenuItem), {
        queryRef: data
    });
}

});
parcelRegister("4QYEU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c19f8830116fdeb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3988ad3da7c9b5f6abf2f3718a010e31>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7c19f8830116fdeb$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4ForgeMenuItem",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Nav4AppMenuItem"
        }
    ],
    "type": "JiraAppNavigationItem"
};
$7c19f8830116fdeb$var$node.hash = "e6f8d3ee567e6cd74addae3ad5622034";
var $7c19f8830116fdeb$export$2e2bcd8739ae039 = $7c19f8830116fdeb$var$node;

});


parcelRegister("j02Uq", function(module, exports) {

$parcel$export(module.exports, "AsyncDiscoverSection", () => $c252b5269b2661b3$export$45fe6164578a6f29);

var $kxZPA = parcelRequire("kxZPA");

const $c252b5269b2661b3$export$45fe6164578a6f29 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("aLUVr")).then((module)=>module.DiscoverSection), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/content/marketplace-recommendations/src/ui/discover-section/DiscoverSection.tsx"
});

});
parcelRegister("aLUVr", function(module, exports) {

let $7d7a73618d07f39c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7d7a73618d07f39c$var$load("kI8YJ").then(()=>parcelRequire('3xy6E'));

});


parcelRegister("hDULT", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfa76cb9830908a5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cfa76cb9830908a5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    yourApps: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-apps.common.content.your-apps",
        "defaultMessage": "Your apps"
    }
});

});



parcelRegister("nX8wH", function(module, exports) {

$parcel$export(module.exports, "useIsGlobalConnectAppRoute", () => $cf4b597ee7e1007d$export$32897ea1251cd6aa);

var $5uXOq = parcelRequire("5uXOq");

var $aZsz6 = parcelRequire("aZsz6");

var $4OCke = parcelRequire("4OCke");

var $3TY9o = parcelRequire("3TY9o");

var $5LMr7 = parcelRequire("5LMr7");

var $fmg3f = parcelRequire("fmg3f");
const $cf4b597ee7e1007d$export$32897ea1251cd6aa = ({ data: data })=>{
    const location = (0, $3TY9o.useLocation)();
    const query = (0, $5LMr7.useQuery)();
    const locations = (0, $5uXOq.useMemo)(()=>(data?.globalAppNavigationItems?.edges || []).filter((edge)=>edge?.node?.appType === 'CONNECT').flatMap((edge)=>(edge?.node && (0, $fmg3f.canHaveSubpages)(edge?.node) && edge?.node?.sections || [
                {
                    links: [
                        {
                            url: edge?.node?.url
                        }
                    ]
                }
            ]).flatMap((section)=>(section?.links || []).map((link)=>(0, (/*@__PURE__*/$parcel$interopDefault($aZsz6)))(link?.url || '/', true)))), [
        data
    ]);
    return (0, $5uXOq.useMemo)(()=>{
        const matcher = (0, $4OCke.matchUrlExact)();
        const currentLocation = {
            ...location,
            query: query
        };
        // @ts-expect-error - Property 'search' is missing in type 'URLParse' but required in type 'MatcherLocation'.
        return locations.some((loc)=>matcher(currentLocation, loc));
    }, [
        locations,
        location,
        query
    ]);
};

});
parcelRegister("4OCke", function(module, exports) {

$parcel$export(module.exports, "matchPathname", () => $cf3ce1d2a79b8e17$export$b71b01274a8bb9ec);
$parcel$export(module.exports, "matchUrlPathname", () => $cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c);
$parcel$export(module.exports, "matchPartialUrlPathname", () => $cf3ce1d2a79b8e17$export$9870a2fa97808ed7);
$parcel$export(module.exports, "matchUrlExact", () => $cf3ce1d2a79b8e17$export$422d2a799c6e30b8);
$parcel$export(module.exports, "matchUrlParams", () => $cf3ce1d2a79b8e17$export$63fdecce99465869);

var $f8l56 = parcelRequire("f8l56");
// Jira url paths are messy, so we have to try to clean them to avoid missing matches
// - pages urls sometimes have /secure, sometimes they don't
// - jspa pages urls sometimes have !action, sometimes they don't
const $cf3ce1d2a79b8e17$var$cleanPath = (path)=>path.replace('/secure/', '/').replace(/!\w+\.jspa/, '.jspa');
const $cf3ce1d2a79b8e17$export$b71b01274a8bb9ec = (currentUrlPath, itemUrlPath)=>$cf3ce1d2a79b8e17$var$cleanPath(currentUrlPath) === $cf3ce1d2a79b8e17$var$cleanPath(itemUrlPath);
const $cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c = ()=>(currentLocation, itemLocation)=>$cf3ce1d2a79b8e17$export$b71b01274a8bb9ec(currentLocation.pathname, itemLocation.pathname);
const $cf3ce1d2a79b8e17$export$9870a2fa97808ed7 = ()=>(currentLocation, itemLocation)=>currentLocation.pathname.includes(itemLocation.pathname);
const $cf3ce1d2a79b8e17$export$422d2a799c6e30b8 = ()=>(currentLocation, itemLocation)=>$cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c()(currentLocation, itemLocation) && (0, (/*@__PURE__*/$parcel$interopDefault($f8l56)))(currentLocation.query, itemLocation.query);
const $cf3ce1d2a79b8e17$export$63fdecce99465869 = (withParams, withPathname = true)=>(currentLocation, itemLocation)=>(!withPathname || $cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c()(currentLocation, itemLocation)) && withParams.every((p)=>currentLocation.query[p] && currentLocation.query[p] === itemLocation.query[p]);

});

parcelRegister("3TY9o", function(module, exports) {

$parcel$export(module.exports, "useLocation", () => $98b56a9c283f50ed$export$45d76561a5302f2b);

var $lODMY = parcelRequire("lODMY");
const $98b56a9c283f50ed$export$45d76561a5302f2b = (0, $lODMY.createRouterSelector)((state)=>state.location);

});

parcelRegister("5LMr7", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $29396ff44ea7e839$export$dd0a697e1782aedd);

var $lODMY = parcelRequire("lODMY");
const $29396ff44ea7e839$export$dd0a697e1782aedd = (0, $lODMY.createRouterSelector)((state)=>state.query);

});


parcelRegister("bhapp", function(module, exports) {

$parcel$export(module.exports, "Nav4AppsSpotlightWrapper", () => $b4dbfb30b95b8dd8$export$d148eb6657a374a);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $fD6iO = parcelRequire("fD6iO");

var $8Bc5A = parcelRequire("8Bc5A");

var $cE2Qr = parcelRequire("cE2Qr");

var $a4k7n = parcelRequire("a4k7n");

var $heI7y = parcelRequire("heI7y");

var $4R6GH = parcelRequire("4R6GH");
function $b4dbfb30b95b8dd8$export$d148eb6657a374a({ children: children }) {
    const [{ hasOpened: shouldShowNudge }] = (0, $heI7y.useHasOpened)();
    const [isUnloaded] = (0, $cE2Qr.useIsDismissed)();
    const expandSideNav = (0, $fD6iO.useExpandSideNav)();
    const [openTask] = (0, $cE2Qr.useOpenTask)();
    const [, { setHasNudgeActive: setHasNudgeActive }] = (0, $cE2Qr.useQuickstartActions)();
    (0, $5uXOq.useEffect)(()=>{
        if (!isUnloaded && openTask === (0, $8Bc5A.CAPTURE_INTEGRATIONS_TASK) && shouldShowNudge) {
            expandSideNav();
            setHasNudgeActive(true); // This re-shows the button-highlight, which can be hidden if the user tries to hide the sidebar
        }
    }, [
        isUnloaded,
        openTask,
        shouldShowNudge,
        setHasNudgeActive,
        expandSideNav
    ]);
    if ((0, $4R6GH.fg)('jira_onboarding_experiences_a11y_fixes')) return !false && shouldShowNudge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $b4dbfb30b95b8dd8$var$fullWidthStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a4k7n.NavigationAppsNavItemWrapperNudgeAsync), null, children)) : children;
    return !false && shouldShowNudge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a4k7n.NavigationAppsNavItemWrapperNudgeAsync), null, children) : children;
}
const $b4dbfb30b95b8dd8$var$fullWidthStyles = (0, $8CUq3.xcss)({
    width: '100%'
});

});
parcelRegister("fD6iO", function(module, exports) {

$parcel$export(module.exports, "useExpandSideNav", () => $d44c9e93ca4d5bd6$export$e44b4744d8ff971a);

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");

var $b0CFU = parcelRequire("b0CFU");
function $d44c9e93ca4d5bd6$export$e44b4744d8ff971a() {
    const setSideNavState = (0, $5uXOq.useContext)((0, $b0CFU.SetSideNavVisibilityState));
    const expandSideNav = (0, $5uXOq.useCallback)(()=>{
        const { matches: matches } = window.matchMedia('(min-width: 64rem)');
        if (matches) setSideNavState((currentState)=>{
            (0, $3joPi.default)(currentState, 'Side nav state should not be null');
            // Skip the re-render if it's a no-op change
            if (currentState.desktop === 'expanded' && currentState.flyout === 'closed') return currentState;
            return {
                mobile: currentState.mobile,
                desktop: 'expanded',
                flyout: 'closed'
            };
        });
        else setSideNavState((currentState)=>{
            (0, $3joPi.default)(currentState, 'Side nav state should not be null');
            // Skip the re-render if it's a no-op change
            if (currentState.mobile === 'expanded' && currentState.flyout === 'closed') return currentState;
            return {
                desktop: currentState.desktop,
                mobile: 'expanded',
                flyout: 'closed'
            };
        });
    }, [
        setSideNavState
    ]);
    return expandSideNav;
}

});

parcelRegister("8Bc5A", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $5f07ce956337ba8b$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "PACKAGE_TEAM_NAME", () => $5f07ce956337ba8b$export$2b3151a089bc8780);
$parcel$export(module.exports, "DEFAULT_NUDGE_WIDTH", () => $5f07ce956337ba8b$export$6826d33e9a2c0119);
$parcel$export(module.exports, "ROOT_TASK", () => $5f07ce956337ba8b$export$b580da85daad7757);
$parcel$export(module.exports, "REVERSE_TRIAL_ROOT_TASK", () => $5f07ce956337ba8b$export$5eef19b26a4bbe70);
$parcel$export(module.exports, "QUICKSTART_TYPE", () => $5f07ce956337ba8b$export$c57d251ae83aff51);
$parcel$export(module.exports, "getBackendVisibilityKey", () => $5f07ce956337ba8b$export$d9df7fd23ab00c49);
$parcel$export(module.exports, "KEY_OPEN", () => $5f07ce956337ba8b$export$93a67c1026e8cb7c);
$parcel$export(module.exports, "KEY_DISMISSED", () => $5f07ce956337ba8b$export$a7dcb0b5013e932b);
$parcel$export(module.exports, "KEY_TASK_GROUP", () => $5f07ce956337ba8b$export$f962b14e410d598f);
$parcel$export(module.exports, "KEY_OPEN_TASK", () => $5f07ce956337ba8b$export$21e8355b28449456);
$parcel$export(module.exports, "KEY_HAS_EVER_SEEN_ROUTE", () => $5f07ce956337ba8b$export$536a90031123e004);
$parcel$export(module.exports, "KEY_PREMIUM_TRIAL_REOPENED", () => $5f07ce956337ba8b$export$3ccd291a1a3a4f6d);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $5f07ce956337ba8b$export$9957974f8b4d8f74);
$parcel$export(module.exports, "SOURCE", () => $5f07ce956337ba8b$export$83c8d7110915321e);
$parcel$export(module.exports, "KEY_JSW_ONBOARDING", () => $5f07ce956337ba8b$export$8b9bd2a9275b0187);
$parcel$export(module.exports, "convertToHaveSeenItTask", () => $5f07ce956337ba8b$export$ec43e7bf5973b10f);
$parcel$export(module.exports, "ADD_COLUMNS_TASK", () => $5f07ce956337ba8b$export$cbeb719208f32c8a);
$parcel$export(module.exports, "CREATE_PROJECT_TASK", () => $5f07ce956337ba8b$export$88c918f2cfaff86);
$parcel$export(module.exports, "CREATE_ISSUE_TASK", () => $5f07ce956337ba8b$export$abbbea7c37c93cb5);
$parcel$export(module.exports, "CREATE_ISSUE_TASK_SIMPLIFIED", () => $5f07ce956337ba8b$export$2a0253cb20f48a8);
$parcel$export(module.exports, "INVITE_TEAMMATES_TASK", () => $5f07ce956337ba8b$export$f97428bb4b1991ec);
$parcel$export(module.exports, "INVITE_TEAMMATES_VIDEO_TASK", () => $5f07ce956337ba8b$export$45eaf4204fcc7);
$parcel$export(module.exports, "CAPTURE_INTEGRATIONS_TASK", () => $5f07ce956337ba8b$export$af57685e201438e8);
$parcel$export(module.exports, "FIND_HELP_TASK", () => $5f07ce956337ba8b$export$d6c67e9aab4e2b26);
$parcel$export(module.exports, "SET_UP_BOARD_TASK", () => $5f07ce956337ba8b$export$3de8c242d2b82f26);
$parcel$export(module.exports, "GET_MOBILE_APP_TASK", () => $5f07ce956337ba8b$export$a01fa44f793dbfac);
$parcel$export(module.exports, "MAP_OUT_YOUR_PROJECT_GOALS_TASK", () => $5f07ce956337ba8b$export$6a4507e462fd41da);
$parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK", () => $5f07ce956337ba8b$export$e64c1dced6ac4458);
$parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_KANBAN_TASK", () => $5f07ce956337ba8b$export$63b0e55f9c6454ac);
$parcel$export(module.exports, "MONITOR_MANAGE_RISK_TASK", () => $5f07ce956337ba8b$export$c1effb1c8979fe22);
$parcel$export(module.exports, "PREMIUM_REVERSE_TRIAL_TASK", () => $5f07ce956337ba8b$export$d97d31d934dbb194);
$parcel$export(module.exports, "PREMIUM_EDITION_OVERVIEW_TASK", () => $5f07ce956337ba8b$export$cafb5bd13b02056b);
$parcel$export(module.exports, "PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN", () => $5f07ce956337ba8b$export$e55c18b809946e72);
$parcel$export(module.exports, "STANDARD_EDITION_OVERVIEW_TASK", () => $5f07ce956337ba8b$export$de5640b9ae8140a7);
$parcel$export(module.exports, "ADVANCED_ROADMAPS_TASK", () => $5f07ce956337ba8b$export$540b5c3c4b6ce459);
$parcel$export(module.exports, "CHANGE_CONTROL_TASK", () => $5f07ce956337ba8b$export$6f71dff531ff592);
$parcel$export(module.exports, "AUTOMATIONS_TASK", () => $5f07ce956337ba8b$export$83255ab79e45f34f);
$parcel$export(module.exports, "SITE_ADMINISTRATIONS_TASK", () => $5f07ce956337ba8b$export$b57d172af9ad7647);
$parcel$export(module.exports, "USER_MANAGEMENT_TASK", () => $5f07ce956337ba8b$export$ff4c933c1fe90b68);
$parcel$export(module.exports, "SCRUM_ONBOARDING_TASK", () => $5f07ce956337ba8b$export$3e2776d61f3662dc);
$parcel$export(module.exports, "CUSTOMIZE_SITE_NAME_TASK", () => $5f07ce956337ba8b$export$9048315f2c03fd9d);
$parcel$export(module.exports, "CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK", () => $5f07ce956337ba8b$export$4145c2cec2da6f9b);
$parcel$export(module.exports, "TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK", () => $5f07ce956337ba8b$export$4957a1ad203cf6dd);
$parcel$export(module.exports, "CALENDAR_VIEW_TASK", () => $5f07ce956337ba8b$export$190b5dd0a1322552);
$parcel$export(module.exports, "JWM_PROJECT_SUMMARY_TASK", () => $5f07ce956337ba8b$export$501166b25f254aab);
$parcel$export(module.exports, "JWM_CREATE_SAMPLE_PROJECT_TASK", () => $5f07ce956337ba8b$export$94ad6507a703f4eb);
$parcel$export(module.exports, "JWM_BACKGROUND_COLOR_TASK", () => $5f07ce956337ba8b$export$be1c522400a1bd7c);
$parcel$export(module.exports, "JWM_CALENDAR_TASK", () => $5f07ce956337ba8b$export$2aa6e7b6e24a04f5);
$parcel$export(module.exports, "JWM_TIMELINE_TASK", () => $5f07ce956337ba8b$export$f3b53199b07af2a1);
$parcel$export(module.exports, "JWM_BUILD_FORM_TASK", () => $5f07ce956337ba8b$export$d37415ffddcf2142);
$parcel$export(module.exports, "JWM_FEEDBACK_TASK", () => $5f07ce956337ba8b$export$2ae00586da7cb606);
$parcel$export(module.exports, "JWM_FEEDBACK_SAMPLE_PROJECT_TASK", () => $5f07ce956337ba8b$export$b86266e6594a97bb);
$parcel$export(module.exports, "JWM_CREATE_YOUR_OWN_PROJECT_TASK", () => $5f07ce956337ba8b$export$20bc3dc137ac1c38);
$parcel$export(module.exports, "JWM_CREATE_PROJECT_TASK", () => $5f07ce956337ba8b$export$77071b77e2801b18);
$parcel$export(module.exports, "JWM_SHARE_PROJECT_TASK", () => $5f07ce956337ba8b$export$9c89f946f05d884a);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_IMPORT", () => $5f07ce956337ba8b$export$b52a7c936684cfc5);
$parcel$export(module.exports, "JWM_SUMMARY_AND_REPORTS_TASK", () => $5f07ce956337ba8b$export$b5555f24061f9fb);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK", () => $5f07ce956337ba8b$export$ff25449f34b8abf);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES", () => $5f07ce956337ba8b$export$3380e677209260fe);
$parcel$export(module.exports, "GET_STARTED_LIST_TASK", () => $5f07ce956337ba8b$export$7a2fcaad1564e6b7);
$parcel$export(module.exports, "OPS_JTBD_1_LIST", () => $5f07ce956337ba8b$export$da23b72d32bfad9e);
$parcel$export(module.exports, "OPS_JTBD_2_BOARD", () => $5f07ce956337ba8b$export$4b064659282e0238);
$parcel$export(module.exports, "OPS_JTBD_2_FORMS", () => $5f07ce956337ba8b$export$3ab51851f6d823e);
$parcel$export(module.exports, "OPS_JTBD_2_SUMMARY", () => $5f07ce956337ba8b$export$e4a1a37a9a1350ad);
$parcel$export(module.exports, "OPS_JTBD_3_LIST", () => $5f07ce956337ba8b$export$b7f7da5e795f0327);
$parcel$export(module.exports, "OPS_JTBD_3_CALENDAR", () => $5f07ce956337ba8b$export$80a401c1aa47a377);
$parcel$export(module.exports, "OPS_JTBD_3_PAGES", () => $5f07ce956337ba8b$export$934ac7a251b26dc7);
$parcel$export(module.exports, "OPS_JTBD_4_LIST", () => $5f07ce956337ba8b$export$4634f6395df3ebbe);
$parcel$export(module.exports, "OPS_JTBD_4_CALENDAR", () => $5f07ce956337ba8b$export$768fb41107a1e8d7);
$parcel$export(module.exports, "OPS_JTBD_4_TIMELINE", () => $5f07ce956337ba8b$export$d797a81bace17184);
$parcel$export(module.exports, "OPS_JTBD_4_SUMMARY", () => $5f07ce956337ba8b$export$746102c94db9df1f);
$parcel$export(module.exports, "OPS_JTBD_5_LIST", () => $5f07ce956337ba8b$export$5f1efd797d65e349);
$parcel$export(module.exports, "OPS_JTBD_5_TIMELINE", () => $5f07ce956337ba8b$export$cccc812ccafbf11f);
$parcel$export(module.exports, "OPS_JTBD_5_PAGES", () => $5f07ce956337ba8b$export$64822db87abd8a47);
$parcel$export(module.exports, "OPS_JTBD_6_PAGES", () => $5f07ce956337ba8b$export$64f764d8be495c82);
$parcel$export(module.exports, "OPS_JTBD_7_LIST", () => $5f07ce956337ba8b$export$24eae23dc1c68bbd);
$parcel$export(module.exports, "OPS_JTBD_7_CALENDAR", () => $5f07ce956337ba8b$export$50fa92eba6f82feb);
$parcel$export(module.exports, "OPS_JTBD_0_LIST", () => $5f07ce956337ba8b$export$4155d22fe3f14cd6);
$parcel$export(module.exports, "OPS_JTBD_0_TIMELINE", () => $5f07ce956337ba8b$export$76813cbead887191);
$parcel$export(module.exports, "OPS_JTBD_0_PAGES", () => $5f07ce956337ba8b$export$90aab2ff89daf770);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_LIST", () => $5f07ce956337ba8b$export$a2bc0cbad2e6e605);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_BOARD", () => $5f07ce956337ba8b$export$f90872a1280728bb);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_INVITES", () => $5f07ce956337ba8b$export$bce644e96518cbd2);
$parcel$export(module.exports, "MKT_JTBD_1_LIST", () => $5f07ce956337ba8b$export$241aaebffac0a3e5);
$parcel$export(module.exports, "MKT_JTBD_1_CALENDAR", () => $5f07ce956337ba8b$export$f9dfc43b5b31c4b7);
$parcel$export(module.exports, "MKT_JTBD_1_TIMELINE", () => $5f07ce956337ba8b$export$79759e9e62fb9312);
$parcel$export(module.exports, "MKT_JTBD_2_CALENDAR", () => $5f07ce956337ba8b$export$992d1e0dce255d19);
$parcel$export(module.exports, "MKT_JTBD_2_PAGES", () => $5f07ce956337ba8b$export$d28c1b0e5b3e768);
$parcel$export(module.exports, "MKT_JTBD_3_PAGES", () => $5f07ce956337ba8b$export$ca714ee197bed4ec);
$parcel$export(module.exports, "MKT_JTBD_3_TIMELINE", () => $5f07ce956337ba8b$export$faae55ceea4b6073);
$parcel$export(module.exports, "MKT_JTBD_4_LIST", () => $5f07ce956337ba8b$export$200bc24cd120667e);
$parcel$export(module.exports, "MKT_JTBD_4_SUMMARY", () => $5f07ce956337ba8b$export$a0d784a48b4e886c);
$parcel$export(module.exports, "MKT_JTBD_4_PAGES", () => $5f07ce956337ba8b$export$baf5bd09b4b33b8a);
$parcel$export(module.exports, "MKT_JTBD_5_TIMELINE", () => $5f07ce956337ba8b$export$4702007eedbca8ab);
$parcel$export(module.exports, "MKT_JTBD_5_SUMMARY", () => $5f07ce956337ba8b$export$aa9d2d635ea63898);
$parcel$export(module.exports, "MKT_JTBD_6_FORMS", () => $5f07ce956337ba8b$export$2ea449225c1f6cac);
$parcel$export(module.exports, "MKT_JTBD_0_LIST", () => $5f07ce956337ba8b$export$deb8b557e735e26a);
$parcel$export(module.exports, "MKT_JTBD_0_CALENDAR", () => $5f07ce956337ba8b$export$d45754df44e4c309);
$parcel$export(module.exports, "MKT_JTBD_0_TIMELINE", () => $5f07ce956337ba8b$export$78b2913b550edbb);
$parcel$export(module.exports, "MKT_JTBD_0_SUMMARY", () => $5f07ce956337ba8b$export$71243272608c58ab);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_LIST", () => $5f07ce956337ba8b$export$39a08f215c33bc39);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_BOARD", () => $5f07ce956337ba8b$export$d2377f6a6fa3b49c);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_PROJECT", () => $5f07ce956337ba8b$export$befa8f6533309779);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_INVITES", () => $5f07ce956337ba8b$export$736b40db8701ba6c);
$parcel$export(module.exports, "TAILORED_ONBOARDING_SUMMARY", () => $5f07ce956337ba8b$export$11eff6ae2f70b67b);
$parcel$export(module.exports, "TAILORED_ONBOARDING_LIST", () => $5f07ce956337ba8b$export$fb2d23e5315a67a9);
$parcel$export(module.exports, "TAILORED_ONBOARDING_CALENDAR", () => $5f07ce956337ba8b$export$32e794bb49d60b6);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BOARD", () => $5f07ce956337ba8b$export$fed256238b27db06);
$parcel$export(module.exports, "TAILORED_ONBOARDING_TIMELINE", () => $5f07ce956337ba8b$export$132eecb4d35a590d);
$parcel$export(module.exports, "TAILORED_ONBOARDING_PAGES", () => $5f07ce956337ba8b$export$2579c51cadd45eca);
$parcel$export(module.exports, "TAILORED_ONBOARDING_FORM", () => $5f07ce956337ba8b$export$4b1a0cefa966ea0);
$parcel$export(module.exports, "TAILORED_ONBOARDING_INVITE", () => $5f07ce956337ba8b$export$f6558daacc312a65);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BACKLOG", () => $5f07ce956337ba8b$export$925efa2e24e86b88);
$parcel$export(module.exports, "TAILORED_ONBOARDING_CODE", () => $5f07ce956337ba8b$export$40454d3e062dcd44);
$parcel$export(module.exports, "JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK", () => $5f07ce956337ba8b$export$99b0e09ff6f00490);
$parcel$export(module.exports, "JSM_REVIEW_YOUR_CHANNELS_TASK", () => $5f07ce956337ba8b$export$2a82344eb273eeff);
$parcel$export(module.exports, "JSM_INVITE_YOUR_TEAM_TASK", () => $5f07ce956337ba8b$export$1de5766b7e640d6b);
$parcel$export(module.exports, "KEY_HAS_NAVIGATED_FROM_LINK", () => $5f07ce956337ba8b$export$11c0696d49e68c93);
$parcel$export(module.exports, "ACCOUNT_ID", () => $5f07ce956337ba8b$export$c8ab6996f562d0db);
$parcel$export(module.exports, "KANBAN_ONBOARDING_TASK", () => $5f07ce956337ba8b$export$2b5f951ad8e70cfe);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => $5f07ce956337ba8b$export$5703447487aaccdf);
$parcel$export(module.exports, "BACKLOG_CREATE_SPRINT_NUDGE_ID", () => $5f07ce956337ba8b$export$e0197e09cccd4e50);
$parcel$export(module.exports, "PROJECT_SETTING_PAGES", () => $5f07ce956337ba8b$export$f779bbfe667acddc);
$parcel$export(module.exports, "JSM_BUSINESS_TASKS", () => $5f07ce956337ba8b$export$38fbac7a5bf4aa33);
$parcel$export(module.exports, "allTasksExcludingJSMBusinessTasks", () => $5f07ce956337ba8b$export$7578902c7f420a3);
$parcel$export(module.exports, "SAMPLE_DATA_PROJECT_KEYS_TO_HIDE_ON", () => $5f07ce956337ba8b$export$5980f41aa657f9c7);

var $g5X3G = parcelRequire("g5X3G");
const $5f07ce956337ba8b$var$completeJwmTaskName = (taskId)=>`jwm-onboarding-checklist.${taskId}`;
const $5f07ce956337ba8b$var$completeJswTaskName = (taskId)=>`jsw-onboarding-checklist.${taskId}`;
const $5f07ce956337ba8b$var$completeJsmTaskName = (taskId)=>`jsm-onboarding-checklist.${taskId}`;
const $5f07ce956337ba8b$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingQuickstart';
const $5f07ce956337ba8b$export$2b3151a089bc8780 = 'jlove-makkuro';
const $5f07ce956337ba8b$export$6826d33e9a2c0119 = 320;
const $5f07ce956337ba8b$export$b580da85daad7757 = 'root';
const $5f07ce956337ba8b$export$5eef19b26a4bbe70 = 'reverseTrialRoot';
const $5f07ce956337ba8b$export$c57d251ae83aff51 = {
    JSM_BUSINESS_QUICKSTART_KEY: 'jsm-business-checklist',
    OLD_GLOBAL_QUICKSTART_KEY: 'jsw-onboarding-checklist'
};
const $5f07ce956337ba8b$export$d9df7fd23ab00c49 = (type)=>`${type}.visibility`;
const $5f07ce956337ba8b$export$93a67c1026e8cb7c = 'jsw-onboarding-checklist.open';
const $5f07ce956337ba8b$export$a7dcb0b5013e932b = 'jsw-onboarding-checklist.dismissed';
const $5f07ce956337ba8b$export$f962b14e410d598f = 'jsw-onboarding-checklist.task-group';
const $5f07ce956337ba8b$export$21e8355b28449456 = 'jsw-onboarding-checklist.open-task';
const $5f07ce956337ba8b$export$536a90031123e004 = 'jsw-onboarding-checklist.has-ever-seen-route';
const $5f07ce956337ba8b$export$3ccd291a1a3a4f6d = 'jsw-onboarding-checklist.reopened-on-premium-trial';
const $5f07ce956337ba8b$export$9957974f8b4d8f74 = 'nuxOnboardingQuickstart';
const $5f07ce956337ba8b$export$83c8d7110915321e = 'nuxOnboardingQuickstart';
const $5f07ce956337ba8b$export$8b9bd2a9275b0187 = 'jsw.onboarding';
const $5f07ce956337ba8b$export$ec43e7bf5973b10f = (taskId)=>`${taskId}.have-seenit`;
const $5f07ce956337ba8b$export$cbeb719208f32c8a = $5f07ce956337ba8b$var$completeJswTaskName('add-columns-task');
const $5f07ce956337ba8b$export$88c918f2cfaff86 = $5f07ce956337ba8b$var$completeJswTaskName('create-project-task');
const $5f07ce956337ba8b$export$abbbea7c37c93cb5 = $5f07ce956337ba8b$var$completeJswTaskName('create-issue-task');
const $5f07ce956337ba8b$export$2a0253cb20f48a8 = $5f07ce956337ba8b$var$completeJswTaskName('create-issue-task-simplified');
const $5f07ce956337ba8b$export$f97428bb4b1991ec = $5f07ce956337ba8b$var$completeJswTaskName('invite-teammates-task');
const $5f07ce956337ba8b$export$45eaf4204fcc7 = $5f07ce956337ba8b$var$completeJswTaskName('invite-teammates-video-task');
const $5f07ce956337ba8b$export$af57685e201438e8 = $5f07ce956337ba8b$var$completeJswTaskName('capture-integrations-task');
const $5f07ce956337ba8b$export$d6c67e9aab4e2b26 = $5f07ce956337ba8b$var$completeJswTaskName('find-help-task');
const $5f07ce956337ba8b$export$3de8c242d2b82f26 = $5f07ce956337ba8b$var$completeJswTaskName('set-up-board-task');
const $5f07ce956337ba8b$export$a01fa44f793dbfac = $5f07ce956337ba8b$var$completeJswTaskName('get-mobile-app-task');
const $5f07ce956337ba8b$export$6a4507e462fd41da = $5f07ce956337ba8b$var$completeJswTaskName('map-out-your-project-goals');
const $5f07ce956337ba8b$export$e64c1dced6ac4458 = $5f07ce956337ba8b$var$completeJswTaskName('identify-small-chunks-of-work');
const $5f07ce956337ba8b$export$63b0e55f9c6454ac = $5f07ce956337ba8b$var$completeJswTaskName('identify-small-chunks-of-work-kanban');
const $5f07ce956337ba8b$export$c1effb1c8979fe22 = $5f07ce956337ba8b$var$completeJswTaskName('monitor-manage-risk');
const $5f07ce956337ba8b$export$d97d31d934dbb194 = $5f07ce956337ba8b$var$completeJswTaskName('premium-reverse-trial-task');
const $5f07ce956337ba8b$export$cafb5bd13b02056b = $5f07ce956337ba8b$var$completeJswTaskName('premium-edition-overview-task');
const $5f07ce956337ba8b$export$e55c18b809946e72 = $5f07ce956337ba8b$var$completeJswTaskName('premium-edition-overview-task-non-admin');
const $5f07ce956337ba8b$export$de5640b9ae8140a7 = $5f07ce956337ba8b$var$completeJswTaskName('standard-edition-overview-task');
const $5f07ce956337ba8b$export$540b5c3c4b6ce459 = $5f07ce956337ba8b$var$completeJswTaskName('advanced-roadmaps-task');
const $5f07ce956337ba8b$export$6f71dff531ff592 = $5f07ce956337ba8b$var$completeJswTaskName('change-control-task');
const $5f07ce956337ba8b$export$83255ab79e45f34f = $5f07ce956337ba8b$var$completeJswTaskName('automations-task');
const $5f07ce956337ba8b$export$b57d172af9ad7647 = $5f07ce956337ba8b$var$completeJswTaskName('site-administrations-task');
const $5f07ce956337ba8b$export$ff4c933c1fe90b68 = $5f07ce956337ba8b$var$completeJswTaskName('user-management-task');
const $5f07ce956337ba8b$export$3e2776d61f3662dc = $5f07ce956337ba8b$var$completeJswTaskName('scrum-onboarding-task');
const $5f07ce956337ba8b$export$9048315f2c03fd9d = $5f07ce956337ba8b$var$completeJswTaskName('customize-site-name-task');
const $5f07ce956337ba8b$export$4145c2cec2da6f9b = $5f07ce956337ba8b$var$completeJswTaskName('create-business-project-from-jsw-quickstart-task');
const $5f07ce956337ba8b$export$4957a1ad203cf6dd = $5f07ce956337ba8b$var$completeJswTaskName('try-atlassian-university-task');
const $5f07ce956337ba8b$export$190b5dd0a1322552 = $5f07ce956337ba8b$var$completeJswTaskName('calendar-view-task');
const $5f07ce956337ba8b$export$501166b25f254aab = $5f07ce956337ba8b$var$completeJwmTaskName('jwm-project-summary-task');
const $5f07ce956337ba8b$export$94ad6507a703f4eb = $5f07ce956337ba8b$var$completeJwmTaskName('jwm-create-sample-project-task');
const $5f07ce956337ba8b$export$be1c522400a1bd7c = $5f07ce956337ba8b$var$completeJwmTaskName('background-color-task');
const $5f07ce956337ba8b$export$2aa6e7b6e24a04f5 = $5f07ce956337ba8b$var$completeJwmTaskName('calendar-task');
const $5f07ce956337ba8b$export$f3b53199b07af2a1 = $5f07ce956337ba8b$var$completeJwmTaskName('timeline-task');
const $5f07ce956337ba8b$export$d37415ffddcf2142 = $5f07ce956337ba8b$var$completeJwmTaskName('build-form-task');
const $5f07ce956337ba8b$export$2ae00586da7cb606 = $5f07ce956337ba8b$var$completeJwmTaskName('feedback-task');
const $5f07ce956337ba8b$export$b86266e6594a97bb = $5f07ce956337ba8b$var$completeJwmTaskName('feedback-sample-project-task');
const $5f07ce956337ba8b$export$20bc3dc137ac1c38 = $5f07ce956337ba8b$var$completeJwmTaskName('create-your-own-project-task');
const $5f07ce956337ba8b$export$77071b77e2801b18 = $5f07ce956337ba8b$var$completeJwmTaskName('jwm-create-project-task');
const $5f07ce956337ba8b$export$9c89f946f05d884a = $5f07ce956337ba8b$var$completeJwmTaskName('share-project-task');
const $5f07ce956337ba8b$export$b52a7c936684cfc5 = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-import');
const $5f07ce956337ba8b$export$b5555f24061f9fb = $5f07ce956337ba8b$var$completeJwmTaskName('summary-and-reports-task');
const $5f07ce956337ba8b$export$ff25449f34b8abf = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-calendar-and-timeline');
const $5f07ce956337ba8b$export$3380e677209260fe = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-key-differences');
const $5f07ce956337ba8b$export$7a2fcaad1564e6b7 = $5f07ce956337ba8b$var$completeJwmTaskName('get-started-list-task');
const $5f07ce956337ba8b$export$da23b72d32bfad9e = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_1_LIST');
const $5f07ce956337ba8b$export$4b064659282e0238 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_2_BOARD');
const $5f07ce956337ba8b$export$3ab51851f6d823e = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_2_FORMS');
const $5f07ce956337ba8b$export$e4a1a37a9a1350ad = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_2_SUMMARY');
const $5f07ce956337ba8b$export$b7f7da5e795f0327 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_3_LIST');
const $5f07ce956337ba8b$export$80a401c1aa47a377 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_3_CALENDAR');
const $5f07ce956337ba8b$export$934ac7a251b26dc7 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_3_PAGES');
const $5f07ce956337ba8b$export$4634f6395df3ebbe = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_LIST');
const $5f07ce956337ba8b$export$768fb41107a1e8d7 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_CALENDAR');
const $5f07ce956337ba8b$export$d797a81bace17184 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_TIMELINE');
const $5f07ce956337ba8b$export$746102c94db9df1f = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_SUMMARY');
const $5f07ce956337ba8b$export$5f1efd797d65e349 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_5_LIST');
const $5f07ce956337ba8b$export$cccc812ccafbf11f = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_5_TIMELINE');
const $5f07ce956337ba8b$export$64822db87abd8a47 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_5_PAGES');
const $5f07ce956337ba8b$export$64f764d8be495c82 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_6_PAGES');
const $5f07ce956337ba8b$export$24eae23dc1c68bbd = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_7_LIST');
const $5f07ce956337ba8b$export$50fa92eba6f82feb = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_7_CALENDAR');
const $5f07ce956337ba8b$export$4155d22fe3f14cd6 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_0_LIST');
const $5f07ce956337ba8b$export$76813cbead887191 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_0_TIMELINE');
const $5f07ce956337ba8b$export$90aab2ff89daf770 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_0_PAGES');
const $5f07ce956337ba8b$export$a2bc0cbad2e6e605 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_DEFAULT_LIST');
const $5f07ce956337ba8b$export$f90872a1280728bb = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_DEFAULT_BOARD');
const $5f07ce956337ba8b$export$bce644e96518cbd2 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_DEFAULT_INVITES');
const $5f07ce956337ba8b$export$241aaebffac0a3e5 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_1_LIST');
const $5f07ce956337ba8b$export$f9dfc43b5b31c4b7 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_1_CALENDAR');
const $5f07ce956337ba8b$export$79759e9e62fb9312 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_1_TIMELINE');
const $5f07ce956337ba8b$export$992d1e0dce255d19 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_2_CALENDAR');
const $5f07ce956337ba8b$export$d28c1b0e5b3e768 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_2_PAGES');
const $5f07ce956337ba8b$export$ca714ee197bed4ec = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_3_PAGES');
const $5f07ce956337ba8b$export$faae55ceea4b6073 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_3_TIMELINE');
const $5f07ce956337ba8b$export$200bc24cd120667e = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_4_LIST');
const $5f07ce956337ba8b$export$a0d784a48b4e886c = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_4_SUMMARY');
const $5f07ce956337ba8b$export$baf5bd09b4b33b8a = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_4_PAGES');
const $5f07ce956337ba8b$export$4702007eedbca8ab = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_5_TIMELINE');
const $5f07ce956337ba8b$export$aa9d2d635ea63898 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_5_SUMMARY');
const $5f07ce956337ba8b$export$2ea449225c1f6cac = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_6_FORMS');
const $5f07ce956337ba8b$export$deb8b557e735e26a = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_LIST');
const $5f07ce956337ba8b$export$d45754df44e4c309 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_CALENDAR');
const $5f07ce956337ba8b$export$78b2913b550edbb = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_TIMELINE');
const $5f07ce956337ba8b$export$71243272608c58ab = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_SUMMARY');
const $5f07ce956337ba8b$export$39a08f215c33bc39 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_LIST');
const $5f07ce956337ba8b$export$d2377f6a6fa3b49c = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_BOARD');
const $5f07ce956337ba8b$export$befa8f6533309779 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_PROJECT');
const $5f07ce956337ba8b$export$736b40db8701ba6c = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_INVITES');
const $5f07ce956337ba8b$export$11eff6ae2f70b67b = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_SUMMARY');
const $5f07ce956337ba8b$export$fb2d23e5315a67a9 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_LIST');
const $5f07ce956337ba8b$export$32e794bb49d60b6 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_CALENDAR');
const $5f07ce956337ba8b$export$fed256238b27db06 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_BOARD');
const $5f07ce956337ba8b$export$132eecb4d35a590d = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_TIMELINE');
const $5f07ce956337ba8b$export$2579c51cadd45eca = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_PAGES');
const $5f07ce956337ba8b$export$4b1a0cefa966ea0 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_FORM');
const $5f07ce956337ba8b$export$f6558daacc312a65 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_INVITE');
const $5f07ce956337ba8b$export$925efa2e24e86b88 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_BACKLOG');
const $5f07ce956337ba8b$export$40454d3e062dcd44 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_CODE');
const $5f07ce956337ba8b$export$99b0e09ff6f00490 = $5f07ce956337ba8b$var$completeJsmTaskName('customize-your-request-types-task');
const $5f07ce956337ba8b$export$2a82344eb273eeff = $5f07ce956337ba8b$var$completeJsmTaskName('review-your-channels-task');
const $5f07ce956337ba8b$export$1de5766b7e640d6b = $5f07ce956337ba8b$var$completeJsmTaskName('invite-your-team-task');
const $5f07ce956337ba8b$export$11c0696d49e68c93 = 'jsw-onboarding-checklist.has.navigated.from.link';
const $5f07ce956337ba8b$export$c8ab6996f562d0db = (0, $g5X3G.toAccountId)('accountId');
const $5f07ce956337ba8b$export$2b5f951ad8e70cfe = $5f07ce956337ba8b$var$completeJswTaskName('kanban-onboarding-task');
const $5f07ce956337ba8b$export$5703447487aaccdf = {
    NOT_LOADED: 'NOT_LOADED',
    OPEN: 'OPEN',
    MINIMIZED: 'MINIMIZED',
    DISMISSED: 'DISMISSED'
};
const $5f07ce956337ba8b$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $5f07ce956337ba8b$export$f779bbfe667acddc = [
    'legacy-project-settings-people',
    'project-settings-software-access'
];
const $5f07ce956337ba8b$export$38fbac7a5bf4aa33 = [
    $5f07ce956337ba8b$export$2a82344eb273eeff,
    $5f07ce956337ba8b$export$99b0e09ff6f00490,
    $5f07ce956337ba8b$export$1de5766b7e640d6b
];
const $5f07ce956337ba8b$export$7578902c7f420a3 = [
    $5f07ce956337ba8b$export$88c918f2cfaff86,
    $5f07ce956337ba8b$export$6a4507e462fd41da,
    $5f07ce956337ba8b$export$e64c1dced6ac4458,
    $5f07ce956337ba8b$export$63b0e55f9c6454ac,
    $5f07ce956337ba8b$export$c1effb1c8979fe22,
    $5f07ce956337ba8b$export$cbeb719208f32c8a,
    $5f07ce956337ba8b$export$abbbea7c37c93cb5,
    $5f07ce956337ba8b$export$2a0253cb20f48a8,
    $5f07ce956337ba8b$export$f97428bb4b1991ec,
    $5f07ce956337ba8b$export$d6c67e9aab4e2b26,
    $5f07ce956337ba8b$export$3de8c242d2b82f26,
    $5f07ce956337ba8b$export$a01fa44f793dbfac,
    $5f07ce956337ba8b$export$45eaf4204fcc7,
    $5f07ce956337ba8b$export$af57685e201438e8,
    $5f07ce956337ba8b$export$d97d31d934dbb194,
    $5f07ce956337ba8b$export$cafb5bd13b02056b,
    $5f07ce956337ba8b$export$e55c18b809946e72,
    $5f07ce956337ba8b$export$de5640b9ae8140a7,
    $5f07ce956337ba8b$export$540b5c3c4b6ce459,
    $5f07ce956337ba8b$export$6f71dff531ff592,
    $5f07ce956337ba8b$export$83255ab79e45f34f,
    $5f07ce956337ba8b$export$b57d172af9ad7647,
    $5f07ce956337ba8b$export$ff4c933c1fe90b68,
    $5f07ce956337ba8b$export$77071b77e2801b18,
    $5f07ce956337ba8b$export$94ad6507a703f4eb,
    $5f07ce956337ba8b$export$501166b25f254aab,
    $5f07ce956337ba8b$export$be1c522400a1bd7c,
    $5f07ce956337ba8b$export$2aa6e7b6e24a04f5,
    $5f07ce956337ba8b$export$f3b53199b07af2a1,
    $5f07ce956337ba8b$export$d37415ffddcf2142,
    $5f07ce956337ba8b$export$2ae00586da7cb606,
    $5f07ce956337ba8b$export$9c89f946f05d884a,
    $5f07ce956337ba8b$export$20bc3dc137ac1c38,
    $5f07ce956337ba8b$export$b52a7c936684cfc5,
    $5f07ce956337ba8b$export$b5555f24061f9fb,
    $5f07ce956337ba8b$export$ff25449f34b8abf,
    $5f07ce956337ba8b$export$3380e677209260fe,
    $5f07ce956337ba8b$export$b86266e6594a97bb,
    $5f07ce956337ba8b$export$3e2776d61f3662dc,
    $5f07ce956337ba8b$export$2b5f951ad8e70cfe,
    $5f07ce956337ba8b$export$9048315f2c03fd9d,
    $5f07ce956337ba8b$export$4145c2cec2da6f9b,
    $5f07ce956337ba8b$export$4957a1ad203cf6dd,
    $5f07ce956337ba8b$export$7a2fcaad1564e6b7,
    $5f07ce956337ba8b$export$190b5dd0a1322552,
    $5f07ce956337ba8b$export$da23b72d32bfad9e,
    $5f07ce956337ba8b$export$4b064659282e0238,
    $5f07ce956337ba8b$export$3ab51851f6d823e,
    $5f07ce956337ba8b$export$e4a1a37a9a1350ad,
    $5f07ce956337ba8b$export$b7f7da5e795f0327,
    $5f07ce956337ba8b$export$80a401c1aa47a377,
    $5f07ce956337ba8b$export$934ac7a251b26dc7,
    $5f07ce956337ba8b$export$4634f6395df3ebbe,
    $5f07ce956337ba8b$export$768fb41107a1e8d7,
    $5f07ce956337ba8b$export$d797a81bace17184,
    $5f07ce956337ba8b$export$746102c94db9df1f,
    $5f07ce956337ba8b$export$5f1efd797d65e349,
    $5f07ce956337ba8b$export$cccc812ccafbf11f,
    $5f07ce956337ba8b$export$64822db87abd8a47,
    $5f07ce956337ba8b$export$64f764d8be495c82,
    $5f07ce956337ba8b$export$24eae23dc1c68bbd,
    $5f07ce956337ba8b$export$50fa92eba6f82feb,
    $5f07ce956337ba8b$export$4155d22fe3f14cd6,
    $5f07ce956337ba8b$export$76813cbead887191,
    $5f07ce956337ba8b$export$90aab2ff89daf770,
    $5f07ce956337ba8b$export$a2bc0cbad2e6e605,
    $5f07ce956337ba8b$export$f90872a1280728bb,
    $5f07ce956337ba8b$export$bce644e96518cbd2,
    $5f07ce956337ba8b$export$241aaebffac0a3e5,
    $5f07ce956337ba8b$export$f9dfc43b5b31c4b7,
    $5f07ce956337ba8b$export$79759e9e62fb9312,
    $5f07ce956337ba8b$export$992d1e0dce255d19,
    $5f07ce956337ba8b$export$d28c1b0e5b3e768,
    $5f07ce956337ba8b$export$ca714ee197bed4ec,
    $5f07ce956337ba8b$export$faae55ceea4b6073,
    $5f07ce956337ba8b$export$200bc24cd120667e,
    $5f07ce956337ba8b$export$a0d784a48b4e886c,
    $5f07ce956337ba8b$export$baf5bd09b4b33b8a,
    $5f07ce956337ba8b$export$4702007eedbca8ab,
    $5f07ce956337ba8b$export$aa9d2d635ea63898,
    $5f07ce956337ba8b$export$2ea449225c1f6cac,
    $5f07ce956337ba8b$export$deb8b557e735e26a,
    $5f07ce956337ba8b$export$d45754df44e4c309,
    $5f07ce956337ba8b$export$78b2913b550edbb,
    $5f07ce956337ba8b$export$71243272608c58ab,
    $5f07ce956337ba8b$export$39a08f215c33bc39,
    $5f07ce956337ba8b$export$d2377f6a6fa3b49c,
    $5f07ce956337ba8b$export$befa8f6533309779,
    $5f07ce956337ba8b$export$736b40db8701ba6c,
    // Tailored onboarding M3
    $5f07ce956337ba8b$export$11eff6ae2f70b67b,
    $5f07ce956337ba8b$export$fb2d23e5315a67a9,
    $5f07ce956337ba8b$export$32e794bb49d60b6,
    $5f07ce956337ba8b$export$fed256238b27db06,
    $5f07ce956337ba8b$export$132eecb4d35a590d,
    $5f07ce956337ba8b$export$2579c51cadd45eca,
    $5f07ce956337ba8b$export$4b1a0cefa966ea0,
    $5f07ce956337ba8b$export$f6558daacc312a65,
    $5f07ce956337ba8b$export$925efa2e24e86b88,
    $5f07ce956337ba8b$export$40454d3e062dcd44
];
const $5f07ce956337ba8b$export$5980f41aa657f9c7 = [
    'SAM1'
];

});

parcelRegister("cE2Qr", function(module, exports) {

$parcel$export(module.exports, "useJswOnboarding", () => $796be817ff5bbbfa$export$7d91c0af4772787a);
$parcel$export(module.exports, "useOpenTask", () => $796be817ff5bbbfa$export$594f006fa6a1b2e5);
$parcel$export(module.exports, "useNudgeStep", () => $796be817ff5bbbfa$export$c5e63e44ad178ae8);
$parcel$export(module.exports, "useQuickstartActions", () => $796be817ff5bbbfa$export$2c3cd14fff9d6e43);
$parcel$export(module.exports, "useShouldShowNudge", () => $796be817ff5bbbfa$export$b0db7e46e369e1d9);
$parcel$export(module.exports, "useInviteToProject", () => $796be817ff5bbbfa$export$71de79653346a1ea);
$parcel$export(module.exports, "useShowVideoCards", () => $796be817ff5bbbfa$export$61185a9266f1f57a);
$parcel$export(module.exports, "useProjectState", () => $796be817ff5bbbfa$export$ef4747ba36826d6a);
$parcel$export(module.exports, "useQuickstartUiStatus", () => $796be817ff5bbbfa$export$522993b46d9f8266);
$parcel$export(module.exports, "useIsLoaded", () => $796be817ff5bbbfa$export$aa4ba29241532382);
$parcel$export(module.exports, "useIsFocusedOn", () => $796be817ff5bbbfa$export$ed5c755b733bf2b1);
$parcel$export(module.exports, "useIsDismissed", () => $796be817ff5bbbfa$export$35fe0366802512dd);
$parcel$export(module.exports, "useCompletedTaskList", () => $796be817ff5bbbfa$export$a41ee0d3b6938099);
$parcel$export(module.exports, "useAllTasksCompleted", () => $796be817ff5bbbfa$export$4ae7b465b076be9);
$parcel$export(module.exports, "useMountedNudges", () => $796be817ff5bbbfa$export$bf6e646c0476acad);
$parcel$export(module.exports, "useHasEverSeen", () => $796be817ff5bbbfa$export$6b706bff94798d11);
$parcel$export(module.exports, "useRoadmapState", () => $796be817ff5bbbfa$export$c98db656edc5b3e1);
$parcel$export(module.exports, "useShouldShowScrumOnboardingExperience", () => $796be817ff5bbbfa$export$a823278ac9d1112b);
$parcel$export(module.exports, "useShouldShowOnboardingKanbanTour", () => $796be817ff5bbbfa$export$cb9e0e8fe4df8490);
$parcel$export(module.exports, "useHasNudgeActive", () => $796be817ff5bbbfa$export$521909e3dc7ab811);
$parcel$export(module.exports, "useSelectedProjectTemplateKeyFromOnboarding", () => $796be817ff5bbbfa$export$f4a2be940259bf95);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => (parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS);

var $58GFP = parcelRequire("58GFP");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

var $8Bc5A = parcelRequire("8Bc5A");

var $6RAg1 = parcelRequire("6RAg1");

var $ieqoN = parcelRequire("ieqoN");

var $cGE52 = parcelRequire("cGE52");

var $3B5jO = parcelRequire("3B5jO");

var $4ji4w = parcelRequire("4ji4w");

const $796be817ff5bbbfa$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    name: 'jsw-onboarding-quickstart',
    initialState: $cGE52.initialState,
    actions: $6RAg1.actions
});
const $796be817ff5bbbfa$export$1cbc60d8dd921852 = (0, $51nlc.createSubscriber)($796be817ff5bbbfa$export$390f32400eaf98c9);
const $796be817ff5bbbfa$export$7d91c0af4772787a = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9);
const $796be817ff5bbbfa$export$638bfcfce1254bb8 = (0, $gg7kZ.createContainer)($796be817ff5bbbfa$export$390f32400eaf98c9, {});
const $796be817ff5bbbfa$export$9d731f44f82af09f = (state, { itemNames: itemNames })=>{
    const commonConditionsToShowNudge = state.shouldRenderComponent && state.visibility[(0, $3B5jO.getQuickstartTypeSelector)(state)] === (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN && // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
    itemNames.includes(state.openTask);
    return commonConditionsToShowNudge && state.hasNudgeActive;
};
const $796be817ff5bbbfa$export$ea14030920a5d8e6 = (state)=>state.openTask;
const $796be817ff5bbbfa$export$594f006fa6a1b2e5 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: $796be817ff5bbbfa$export$ea14030920a5d8e6
});
const $796be817ff5bbbfa$export$a943afa434e9487a = (state)=>state.nudgeStep;
const $796be817ff5bbbfa$export$c5e63e44ad178ae8 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: $796be817ff5bbbfa$export$a943afa434e9487a
});
const $796be817ff5bbbfa$export$2c3cd14fff9d6e43 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: null
});
const $796be817ff5bbbfa$export$b0db7e46e369e1d9 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: $796be817ff5bbbfa$export$9d731f44f82af09f
});
const $796be817ff5bbbfa$export$71de79653346a1ea = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.projectState && state.projectState.canInvitePeopleToProject)
});
const $796be817ff5bbbfa$export$61185a9266f1f57a = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (!state.projectState) return false;
        const { isNextGen: isNextGen, userRole: userRole, isProjectAdmin: isProjectAdmin } = state.projectState;
        return Boolean(isNextGen && (userRole === (0, $ieqoN.USER_ROLE).JIRA_ADMIN || userRole === (0, $ieqoN.USER_ROLE).SITE_ADMIN || isProjectAdmin));
    }
});
const $796be817ff5bbbfa$export$ef4747ba36826d6a = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.projectState
});
const $796be817ff5bbbfa$export$522993b46d9f8266 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>{
        const quickstartType = (0, $3B5jO.getQuickstartTypeSelector)(state);
        if (state.shouldRenderComponent === false) return (0, $4ji4w.getLocalStorageItem)(`${quickstartType}.visibility`) ?? (0, $8Bc5A.QUICKSTART_UI_STATUS).NOT_LOADED;
        return state.visibility[quickstartType];
    }
});
const $796be817ff5bbbfa$export$aa4ba29241532382 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.isQuickstartLoaded
});
const $796be817ff5bbbfa$export$ed5c755b733bf2b1 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.isFocusedOn
});
const $796be817ff5bbbfa$export$35fe0366802512dd = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>{
        const visibility = state.visibility[(0, $3B5jO.getQuickstartTypeSelector)(state)];
        return visibility === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED || visibility === (0, $8Bc5A.QUICKSTART_UI_STATUS).NOT_LOADED;
    }
});
const $796be817ff5bbbfa$export$a41ee0d3b6938099 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.completedTaskList
});
const $796be817ff5bbbfa$export$4ae7b465b076be9 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (!state.tasks) return null;
        return state.tasks.items.every((task)=>state.completedTaskList.includes(task));
    }
});
const $796be817ff5bbbfa$export$bf6e646c0476acad = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.mountedNudges
});
const $796be817ff5bbbfa$export$6b706bff94798d11 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.hasEverSeenRoute
});
const $796be817ff5bbbfa$export$c98db656edc5b3e1 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>({
            roadmapIsCreateEnabled: state.roadmapIsCreateEnabled,
            roadmapIsListEmpty: state.roadmapIsListEmpty
        })
});
const $796be817ff5bbbfa$export$a823278ac9d1112b = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.isQuickstartLoaded && state.selectedProjectTemplateKeyFromOnboarding === (0, $58GFP.SCRUM_TEAM_MANAGED_KEY) && state.projectState?.userRole === (0, $ieqoN.USER_ROLE).SITE_ADMIN)
});
const $796be817ff5bbbfa$export$cb9e0e8fe4df8490 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.isQuickstartLoaded && state.selectedProjectTemplateKeyFromOnboarding === (0, $58GFP.KANBAN_TEAM_MANAGED_KEY) && state.projectState?.userRole === (0, $ieqoN.USER_ROLE).SITE_ADMIN && // edge case - if e.g. welcome modal failed to load, and user completed task by themself, then the welcome modal should be skipped on subsequent page loads.
        !state.completedTaskList.includes((0, $8Bc5A.KANBAN_ONBOARDING_TASK)))
});
const $796be817ff5bbbfa$export$521909e3dc7ab811 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.hasNudgeActive
});
const $796be817ff5bbbfa$export$f4a2be940259bf95 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.selectedProjectTemplateKeyFromOnboarding
});

});
parcelRegister("58GFP", function(module, exports) {

$parcel$export(module.exports, "KANBAN_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$f40a08fc76eb112d);
$parcel$export(module.exports, "KANBAN_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$e3844688f2693533);
$parcel$export(module.exports, "SCRUM_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$e3cec071fcb2fbd3);
$parcel$export(module.exports, "SCRUM_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$21783d461e3ef6d);
$parcel$export(module.exports, "BUG_TRACKING_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$6cd1c1b2ba0f6e2d);
$parcel$export(module.exports, "CROSS_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$57d877f2e01e0029);
$parcel$export(module.exports, "CROSS_TEAM_PLANNING_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$6f4213a3addc3fdb);
$parcel$export(module.exports, "JWM_TEMPLATE_PREFIX", () => $c364c398187f9175$export$7492b6cc3ef89883);
$parcel$export(module.exports, "PROJECT_MANAGEMENT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$7d9a4e0ef5194fe1);
$parcel$export(module.exports, "PROJECT_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$477ca3550da12e43);
$parcel$export(module.exports, "BLANK_TEMPLATE_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$7c0307155b744916);
$parcel$export(module.exports, "BLANK_TEMPLATE_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$b5ab111fb8825075);
$parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$14139f0ec41d437e);
$parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$ebf7af45376deb8b);
$parcel$export(module.exports, "CONTENT_MANAGEMENT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$7b6945581ccdab4a);
$parcel$export(module.exports, "CONTENT_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$310a9ac5c28d65f6);
$parcel$export(module.exports, "TASK_TRACKING_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$136d17feb2f4285d);
$parcel$export(module.exports, "DOCUMENT_APPROVAL_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$e288f4758e94a8cc);
$parcel$export(module.exports, "PROCESS_CONTROL_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$4e9ac1417ba54bba);
$parcel$export(module.exports, "POLICY_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$560c9f6765bf9af4);
$parcel$export(module.exports, "SALES_PIPELINE_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$14d4c6dbbb62a127);
$parcel$export(module.exports, "PROCUREMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$1367ee12532c525f);
$parcel$export(module.exports, "WEB_DESIGN_PROCESS_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$278632cc7ed9a312);
$parcel$export(module.exports, "BUDGET_CREATION_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$594d0d4f5ecbf4c7);
$parcel$export(module.exports, "EMPLOYEE_ONBOARDING_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$dda85c7a8278e495);
$parcel$export(module.exports, "RECRUITMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$b92c431651f9ee91);
$parcel$export(module.exports, "LEAD_TRACKING_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$d72d75d9d0e071fc);
$parcel$export(module.exports, "IP_INFRINGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$753322ed1c32ff89);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$4d29ee0c00eb5df4);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$6278b41164dbde6c);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_BASIC_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$17a2f771efabf02f);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_OPERATIONS_TEMPLATE_KEY", () => $c364c398187f9175$export$df7d1440e0a80c03);
$parcel$export(module.exports, "JIRA_CUSTOMER_SERVICE_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$bd14946bcde77195);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY", () => $c364c398187f9175$export$e8df553a3f519284);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY", () => $c364c398187f9175$export$97fc32bd703bb4d1);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY", () => $c364c398187f9175$export$8eecdf6acea9494);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY", () => $c364c398187f9175$export$ff16be7794ed4222);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$9917830b560a2f4);
$parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$b0928b02ffab3875);
$parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_FOR_IT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$fd75f6abc7861439);
$parcel$export(module.exports, "HR_SERVICE_PROJECT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$2bc7db2da3df8313);
$parcel$export(module.exports, "INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY", () => $c364c398187f9175$export$87a8fff98b5bc81);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$7c567eb725bd36f);
$parcel$export(module.exports, "getIsJsmBlankProjectTemplate", () => $c364c398187f9175$export$73fd025e86012868);
$parcel$export(module.exports, "getGeneralITOrBusinessProjectTemplateMap", () => $c364c398187f9175$export$a062badd78c9993);
// Project template type keys are used to create projects.
// TODO: KURO-1818 consolidate keys from `project-template-keys` in this file.
// Software template keys
const $c364c398187f9175$export$f40a08fc76eb112d = 'com.pyxis.greenhopper.jira:gh-simplified-agility-kanban';
const $c364c398187f9175$export$e3844688f2693533 = 'com.pyxis.greenhopper.jira:gh-simplified-kanban-classic';
const $c364c398187f9175$export$e3cec071fcb2fbd3 = 'com.pyxis.greenhopper.jira:gh-simplified-agility-scrum';
const $c364c398187f9175$export$21783d461e3ef6d = 'com.pyxis.greenhopper.jira:gh-simplified-scrum-classic';
const $c364c398187f9175$export$6cd1c1b2ba0f6e2d = 'com.pyxis.greenhopper.jira:gh-simplified-basic';
const $c364c398187f9175$export$57d877f2e01e0029 = 'com.pyxis.greenhopper.jira:gh-cross-team-template';
const $c364c398187f9175$export$6f4213a3addc3fdb = 'com.pyxis.greenhopper.jira:gh-cross-team-planning-template';
const $c364c398187f9175$export$7492b6cc3ef89883 = 'com.atlassian.jira-core-project-templates';
const $c364c398187f9175$export$7d9a4e0ef5194fe1 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-core-simplified-project-management`;
const $c364c398187f9175$export$477ca3550da12e43 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-project-management-team-managed`;
const $c364c398187f9175$export$7c0307155b744916 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-blank-project`;
const $c364c398187f9175$export$b5ab111fb8825075 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-blank-project-team-managed`;
const $c364c398187f9175$export$14139f0ec41d437e = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-campaign-management`;
const $c364c398187f9175$export$ebf7af45376deb8b = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-campaign-management-team-managed`;
const $c364c398187f9175$export$7b6945581ccdab4a = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-core-simplified-content-management`;
const $c364c398187f9175$export$310a9ac5c28d65f6 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-content-management-team-managed`;
const $c364c398187f9175$export$136d17feb2f4285d = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-task-tracking-team-managed`;
const $c364c398187f9175$export$e288f4758e94a8cc = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-document-approval-team-managed`;
const $c364c398187f9175$export$4e9ac1417ba54bba = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-process-control-team-managed`;
const $c364c398187f9175$export$560c9f6765bf9af4 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-policy-management-team-managed`;
const $c364c398187f9175$export$14d4c6dbbb62a127 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-sales-pipeline-team-managed`;
const $c364c398187f9175$export$1367ee12532c525f = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-procurement-team-managed`;
const $c364c398187f9175$export$278632cc7ed9a312 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-web-design-process-team-managed`;
const $c364c398187f9175$export$594d0d4f5ecbf4c7 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-budget-creation-team-managed`;
const $c364c398187f9175$export$dda85c7a8278e495 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-employee-onboarding-team-managed`;
const $c364c398187f9175$export$b92c431651f9ee91 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-recruitment-team-managed`;
const $c364c398187f9175$export$d72d75d9d0e071fc = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-lead-tracking-team-managed`;
const $c364c398187f9175$export$753322ed1c32ff89 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-ip-infringement-team-managed`;
const $c364c398187f9175$export$4d29ee0c00eb5df4 = 'com.atlassian.servicedesk:simplified-it-service-management';
const $c364c398187f9175$export$6278b41164dbde6c = 'com.atlassian.servicedesk:next-gen-it-service-desk';
const $c364c398187f9175$export$17a2f771efabf02f = 'com.atlassian.servicedesk:simplified-it-service-management-basic';
const $c364c398187f9175$export$df7d1440e0a80c03 = 'com.atlassian.servicedesk:simplified-it-service-management-operations';
const $c364c398187f9175$export$bd14946bcde77195 = 'com.atlassian.jcs:customer-service-management';
const $c364c398187f9175$export$e8df553a3f519284 = 'jsm.blank-project-business-cmp-only';
const $c364c398187f9175$export$97fc32bd703bb4d1 = 'com.atlassian.servicedesk:simplified-blank-project-it';
const $c364c398187f9175$export$8eecdf6acea9494 = 'jsm.blank-project-it-cmp-only';
const $c364c398187f9175$export$ff16be7794ed4222 = 'com.atlassian.servicedesk:simplified-blank-project-business';
const $c364c398187f9175$export$9e38ad41d19608ee = 'jsm.blank-service-management';
const $c364c398187f9175$export$9917830b560a2f4 = 'com.atlassian.servicedesk:company-managed-blank-service-project';
const $c364c398187f9175$export$b95641716115e7f9 = 'com.atlassian.servicedesk:team-managed-blank-service-project';
const $c364c398187f9175$export$e87297d5e9fa3d43 = 'com.atlassian.servicedesk:simplified-legal-service-desk';
const $c364c398187f9175$export$3f1f11fb5d08da21 = 'com.atlassian.servicedesk:next-gen-legal-service-desk';
const $c364c398187f9175$export$2b90912656e0b76b = 'com.atlassian.servicedesk:simplified-general-service-desk';
const $c364c398187f9175$export$e8fdad132bc6d342 = 'com.atlassian.servicedesk:next-gen-general-service-desk';
const $c364c398187f9175$export$b0928b02ffab3875 = 'com.atlassian.servicedesk:company-managed-general-service-project';
const $c364c398187f9175$export$50478ee5ecbf7a4d = 'com.atlassian.servicedesk:team-managed-general-service-project';
const $c364c398187f9175$export$fd75f6abc7861439 = 'com.atlassian.servicedesk:simplified-general-service-desk-it';
const $c364c398187f9175$export$fb658bddae7f81bb = 'com.atlassian.servicedesk:next-gen-general-it-service-desk';
const $c364c398187f9175$export$e82092c4fb277f9b = 'com.atlassian.servicedesk:simplified-general-service-desk-business';
const $c364c398187f9175$export$5eddf3b31dd1858f = 'com.atlassian.servicedesk:next-gen-general-business-service-desk';
const $c364c398187f9175$export$bc3e0c6bccecee38 = 'com.atlassian.servicedesk:simplified-external-service-desk';
const $c364c398187f9175$export$feb6dd6f9d18a640 = 'com.atlassian.servicedesk:next-gen-external-service-desk';
const $c364c398187f9175$export$f3c5f5a180797f04 = 'com.atlassian.servicedesk:simplified-hr-service-desk';
const $c364c398187f9175$export$2bc7db2da3df8313 = 'com.atlassian.servicedesk:next-gen-hr-service-desk';
const $c364c398187f9175$export$a1a1f02e9f561918 = 'com.atlassian.servicedesk:simplified-facilities-service-desk';
const $c364c398187f9175$export$17a955064ab71480 = 'com.atlassian.servicedesk:next-gen-facilities-service-desk';
const $c364c398187f9175$export$d66326f3f6b558b = 'com.atlassian.servicedesk:simplified-analytics-service-desk';
const $c364c398187f9175$export$6c5416b0177f2ef3 = 'com.atlassian.servicedesk:next-gen-analytics-service-desk';
const $c364c398187f9175$export$ea36fb35725fc554 = 'com.atlassian.servicedesk:simplified-finance-service-desk';
const $c364c398187f9175$export$e7038c17e9311de9 = 'com.atlassian.servicedesk:next-gen-finance-service-desk';
const $c364c398187f9175$export$38d7bc62a093e5a3 = 'com.atlassian.servicedesk:simplified-marketing-service-desk';
const $c364c398187f9175$export$fa06d276537993ce = 'com.atlassian.servicedesk:next-gen-marketing-service-desk';
const $c364c398187f9175$export$9801b8ec713d3079 = 'com.atlassian.servicedesk:simplified-sales-service-desk';
const $c364c398187f9175$export$a9f0e6470e3b6147 = 'com.atlassian.servicedesk:next-gen-sales-service-desk';
const $c364c398187f9175$export$aeedd4330ac1268c = 'com.atlassian.servicedesk:simplified-design-service-desk';
const $c364c398187f9175$export$c0e4ffe74102f756 = 'com.atlassian.servicedesk:next-gen-design-service-desk';
const $c364c398187f9175$export$87a8fff98b5bc81 = 'initial.project.template.name';
const $c364c398187f9175$export$7c567eb725bd36f = 'jira.polaris:discovery';
const $c364c398187f9175$export$b0eec2c6558182ca = 'jira.polaris:blank-project';
const $c364c398187f9175$export$f9776303073903dd = 'jira.polaris:roadmap';
const $c364c398187f9175$export$b7c4ca557ac2074e = 'jira.polaris:prioritization';
const $c364c398187f9175$export$789332a2d3504754 = 'jira.polaris:portfolio';
const $c364c398187f9175$export$73fd025e86012868 = (T4JTemplateKey)=>T4JTemplateKey === $c364c398187f9175$export$e8df553a3f519284 || T4JTemplateKey === $c364c398187f9175$export$8eecdf6acea9494 || T4JTemplateKey === $c364c398187f9175$export$9e38ad41d19608ee;
const $c364c398187f9175$export$a062badd78c9993 = {
    [$c364c398187f9175$export$e82092c4fb277f9b]: $c364c398187f9175$export$b0928b02ffab3875,
    [$c364c398187f9175$export$fd75f6abc7861439]: $c364c398187f9175$export$b0928b02ffab3875,
    [$c364c398187f9175$export$5eddf3b31dd1858f]: $c364c398187f9175$export$50478ee5ecbf7a4d,
    [$c364c398187f9175$export$fb658bddae7f81bb]: $c364c398187f9175$export$50478ee5ecbf7a4d
};

});

parcelRegister("6RAg1", function(module, exports) {

$parcel$export(module.exports, "actions", () => $4752306278e43a2d$export$e324594224ef24da);

var $6fSBR = parcelRequire("6fSBR");

var $j6wxT = parcelRequire("j6wxT");

var $7mZ3t = parcelRequire("7mZ3t");

var $8UXiA = parcelRequire("8UXiA");

var $3iEb4 = parcelRequire("3iEb4");

var $7yDu9 = parcelRequire("7yDu9");

var $5UBG2 = parcelRequire("5UBG2");

var $lHcRB = parcelRequire("lHcRB");

var $eiyXc = parcelRequire("eiyXc");

var $jZvbN = parcelRequire("jZvbN");

var $azcAL = parcelRequire("azcAL");

var $gbXQ5 = parcelRequire("gbXQ5");

var $iZuFy = parcelRequire("iZuFy");

var $70Fss = parcelRequire("70Fss");

var $erLQY = parcelRequire("erLQY");

var $dQPsy = parcelRequire("dQPsy");

var $abQXL = parcelRequire("abQXL");

var $4VXxO = parcelRequire("4VXxO");

var $cUGWT = parcelRequire("cUGWT");

var $boV1S = parcelRequire("boV1S");

var $4Viq4 = parcelRequire("4Viq4");

var $jIoq4 = parcelRequire("jIoq4");

var $75A1x = parcelRequire("75A1x");

var $1Xkin = parcelRequire("1Xkin");
const $4752306278e43a2d$export$e324594224ef24da = {
    changeTaskGroupParent: $6fSBR.nextChangeTaskGroupParent,
    goBackToPreviousTaskGroup: $6fSBR.nextGoBackToPreviousTaskGroup,
    setIsOpen: $j6wxT.setIsOpen,
    refreshAppState: $7mZ3t.refreshAppState,
    setNudgeStep: $8UXiA.setNudgeStep,
    addMountedNudge: $3iEb4.addMountedNudge,
    removeMountedNudge: $3iEb4.removeMountedNudge,
    setShouldRenderComponent: $7yDu9.setShouldRenderComponent,
    setProjectState: $5UBG2.setProjectState,
    setHasNudgeActive: $lHcRB.setHasNudgeActive,
    forceHideNudge: $eiyXc.forceHideNudge,
    setHasEverSeenRoute: $jZvbN.setHasEverSeenRoute,
    setRoadmapIsCreateEnabled: $azcAL.setRoadmapIsCreateEnabled,
    setRoadmapIsListEmpty: $azcAL.setRoadmapIsListEmpty,
    openNextTask: $gbXQ5.openNextTask,
    resetIsQuickstartLoaded: $iZuFy.resetIsQuickstartLoaded,
    refreshAppStateUiStatusOnly: $70Fss.refreshAppStateUiStatusOnly,
    nextMarkAsCompletedTask: $erLQY.nextMarkAsCompletedTask,
    nextSetChecklistItemSeen: $dQPsy.nextSetChecklistItemSeen,
    nextSetChecklistIsDismissed: $abQXL.nextSetChecklistIsDismissed,
    nextSetChecklistIsOpen: $4VXxO.nextSetChecklistIsOpen,
    nextOpenTask: $cUGWT.nextOpenTask,
    nextAutoExpand: $boV1S.nextAutoExpand,
    nextShouldShowNudgeAfterNavigation: $4Viq4.nextShouldShowNudgeAfterNavigation,
    nextGetTasks: $jIoq4.nextGetTasks,
    syncVisibilityWithLocal: $75A1x.syncVisibilityWithLocal,
    universalDispatch: $1Xkin.universalDispatch
};

});
parcelRegister("6fSBR", function(module, exports) {

$parcel$export(module.exports, "nextChangeTaskGroupParent", () => $0f1566e1d3fc2987$export$76708cce5888039a);
$parcel$export(module.exports, "nextGoBackToPreviousTaskGroup", () => $0f1566e1d3fc2987$export$57534cbc400a434c);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4R6GH = parcelRequire("4R6GH");

var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");
const $0f1566e1d3fc2987$var$setTaskGroup = (taskGroup, openTask)=>({ setState: setState })=>{
        setState({
            ...taskGroup,
            openTask: openTask || ''
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_TASK_GROUP),
            value: {
                taskGroup: taskGroup
            }
        });
    };
const $0f1566e1d3fc2987$export$76708cce5888039a = (newCurrentTaskGroupParent)=>({ getState: getState, dispatch: dispatch })=>{
        const { previousTaskGroupParents: previousTaskGroupParents, currentTaskGroupParent: currentTaskGroupParent } = getState();
        if (previousTaskGroupParents.includes(newCurrentTaskGroupParent)) // prevent infinite loop nesting
        return;
        previousTaskGroupParents.push(currentTaskGroupParent);
        const taskGroup = {
            previousTaskGroupParents: previousTaskGroupParents,
            currentTaskGroupParent: newCurrentTaskGroupParent
        };
        dispatch($0f1566e1d3fc2987$var$setTaskGroup(taskGroup));
    };
const $0f1566e1d3fc2987$export$57534cbc400a434c = ()=>({ dispatch: dispatch, getState: getState })=>{
        if ((0, $4R6GH.fg)('jira_a11y_fix_returning_focus')) {
            const { previousTaskGroupParents: previousTaskGroupParents, currentTriggerForTaskGroupParent: currentTriggerForTaskGroupParent } = getState();
            const lastIndexOfPreviousTaskGroupParents = previousTaskGroupParents.length - 1;
            const newTaskGroupParent = previousTaskGroupParents.length === 0 ? (0, $8Bc5A.ROOT_TASK) : previousTaskGroupParents[lastIndexOfPreviousTaskGroupParents];
            const newPreviousTaskGroupParents = previousTaskGroupParents.slice(0, lastIndexOfPreviousTaskGroupParents);
            const taskGroup = {
                previousTaskGroupParents: newPreviousTaskGroupParents,
                currentTaskGroupParent: newTaskGroupParent
            };
            dispatch($0f1566e1d3fc2987$var$setTaskGroup(taskGroup, currentTriggerForTaskGroupParent));
        } else {
            const { previousTaskGroupParents: previousTaskGroupParents } = getState();
            const newTaskGroupParent = previousTaskGroupParents.length === 0 ? (0, $8Bc5A.ROOT_TASK) : previousTaskGroupParents.pop();
            const taskGroup = {
                previousTaskGroupParents: previousTaskGroupParents,
                currentTaskGroupParent: newTaskGroupParent
            };
            // @ts-expect-error - TS2345 - Argument of type '{ previousTaskGroupParents: string[]; currentTaskGroupParent: string | undefined; }' is not assignable to parameter of type 'TaskGroup'.
            dispatch($0f1566e1d3fc2987$var$setTaskGroup(taskGroup));
        }
    };

});
parcelRegister("1ftPQ", function(module, exports) {

$parcel$export(module.exports, "pushToBackend", () => $d3dd40bf54ad27bf$export$583b2d2422a6757f);

var $89SaW = parcelRequire("89SaW");

var $4Pf62 = parcelRequire("4Pf62");

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");
const $d3dd40bf54ad27bf$var$getAccountId = ()=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    if (atlassianAccountId === null) throw new Error('Atlassian Account Id is empty');
    return atlassianAccountId;
};
const $d3dd40bf54ad27bf$var$setRemoteUserProperties = async ({ key: key, value: value })=>(0, $89SaW.setUserProperties)($d3dd40bf54ad27bf$var$getAccountId(), key, JSON.stringify(value)).then((response)=>{
        if (!response.ok) throw new (0, $jJZqs.default)(response.status, response.statusText);
    });
const $d3dd40bf54ad27bf$var$trySetUserProperties = async (props, attemptCount)=>{
    try {
        await $d3dd40bf54ad27bf$var$setRemoteUserProperties(props);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'pushToBackend',
                packageName: 'jiraOnboardingQuickstartCore',
                teamName: 'jlove-makkuro'
            },
            attributes: {
                action: 'pushToBackend',
                actionSubject: 'jiraOnboardingChecklistCore',
                attemptCount: attemptCount,
                key: props.key,
                reason: error && error.message
            },
            error: error
        });
        return false;
    }
    return true;
};
const $d3dd40bf54ad27bf$export$583b2d2422a6757f = async (props)=>{
    const success = await $d3dd40bf54ad27bf$var$trySetUserProperties(props, 1);
    if (!success) // On failure retry - if retry fails data is lost.
    await $d3dd40bf54ad27bf$var$trySetUserProperties(props, 2);
};

});


parcelRegister("j6wxT", function(module, exports) {

$parcel$export(module.exports, "setIsOpen", () => $eefde484654068e9$export$dcf23146e0a40195);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");

var $3B5jO = parcelRequire("3B5jO");
const $eefde484654068e9$export$dcf23146e0a40195 = (isOpen)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3B5jO.getQuickstartTypeSelector)(state);
        const currentIsOpen = state.visibility[quickstartType] === (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN;
        if (isOpen === currentIsOpen) // if state has not been updated we just return
        return;
        const quickstartStatus = isOpen ? (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN : (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            }
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        // Delete code below when cleaning up isOpen in state
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_OPEN),
            value: isOpen
        });
    };
var $eefde484654068e9$export$2e2bcd8739ae039 = $eefde484654068e9$export$dcf23146e0a40195;

});
parcelRegister("3B5jO", function(module, exports) {

$parcel$export(module.exports, "getQuickstartTypeSelector", () => $47424244d57f6abc$export$eae834ce0286017a);

var $2vSU6 = parcelRequire("2vSU6");

var $8Bc5A = parcelRequire("8Bc5A");
const $47424244d57f6abc$export$6f17f2cb816105eb = (state)=>state.projectState?.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);
const $47424244d57f6abc$export$eae834ce0286017a = (state)=>{
    if ($47424244d57f6abc$export$6f17f2cb816105eb(state)) return (0, $8Bc5A.QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY;
    return (0, $8Bc5A.QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY;
};

});


parcelRegister("7mZ3t", function(module, exports) {

$parcel$export(module.exports, "refreshAppState", () => $ecf6e94ad9c4f8d6$export$797c35e2e1d0d014);


var $8fqy8 = parcelRequire("8fqy8");

var $8zOmE = parcelRequire("8zOmE");

var $bfWlw = parcelRequire("bfWlw");

var $ldyPw = parcelRequire("ldyPw");

var $8Bc5A = parcelRequire("8Bc5A");

var $6yhDy = parcelRequire("6yhDy");

var $1ftPQ = parcelRequire("1ftPQ");

var $52Vcw = parcelRequire("52Vcw");

var $ljzlb = parcelRequire("ljzlb");

var $6ypzr = parcelRequire("6ypzr");

var $4ji4w = parcelRequire("4ji4w");

var $abQXL = parcelRequire("abQXL");

var $4VXxO = parcelRequire("4VXxO");

var $erLQY = parcelRequire("erLQY");

var $6fSBR = parcelRequire("6fSBR");
const $ecf6e94ad9c4f8d6$var$allTasks = [
    ...(0, $8Bc5A.allTasksExcludingJSMBusinessTasks),
    ...(0, $8Bc5A.JSM_BUSINESS_TASKS)
];
const $ecf6e94ad9c4f8d6$export$797c35e2e1d0d014 = ({ atlassianAccountId: atlassianAccountId, cloudId: cloudId, appEditions: appEditions, isAdmin: isAdmin, canEditPlans: canEditPlans, isAdvancedRoadmapsTrial: isAdvancedRoadmapsTrial, isTargetedForReverseTrials: isTargetedForReverseTrials, createAnalyticsEvent: createAnalyticsEvent, projectType: projectType })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        // Need to check to see if there is anything in the backend to take that as source of truth
        // If there is nothing then use defaults
        // Check backend for flags that are marked as completed (true)
        // Carry over state from previous actions
        // Create Completed Actions
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedState = {};
        const hasSeenTasks = [
            (0, $8Bc5A.convertToHaveSeenItTask)((0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK)),
            (0, $8Bc5A.convertToHaveSeenItTask)((0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)),
            (0, $8Bc5A.convertToHaveSeenItTask)((0, $8Bc5A.STANDARD_EDITION_OVERVIEW_TASK))
        ];
        const { projectState: projectState = null } = getState();
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.isOpen = true;
        updatedState.isDismissed = false;
        updatedState.quickstartStateProjectType = projectType;
        let backendVisibilityKeys = [];
        let jsmTaskProjectKeys = [];
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.visibility = Object.values((0, $8Bc5A.QUICKSTART_TYPE)).reduce((acc, type)=>{
            acc[type] = (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN;
            return acc;
        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {});
        backendVisibilityKeys = Object.values((0, $8Bc5A.QUICKSTART_TYPE)).map((type)=>(0, $8Bc5A.getBackendVisibilityKey)(type));
        if (projectState?.projectId) jsmTaskProjectKeys = (0, $8Bc5A.JSM_BUSINESS_TASKS).map((task)=>`${task}.${projectState?.projectId}`);
        const backendState = await (0, $6yhDy.pollBackend)({
            keys: [
                (0, $8Bc5A.KEY_OPEN),
                (0, $8Bc5A.KEY_DISMISSED),
                (0, $8Bc5A.KEY_OPEN_TASK),
                (0, $8Bc5A.KEY_TASK_GROUP),
                (0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE),
                (0, $8Bc5A.KEY_JSW_ONBOARDING),
                (0, $8Bc5A.KEY_PREMIUM_TRIAL_REOPENED),
                ...$ecf6e94ad9c4f8d6$var$allTasks,
                ...hasSeenTasks,
                ...backendVisibilityKeys,
                ...jsmTaskProjectKeys
            ]
        });
        const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
        if (backendStateExists) {
            updatedState.completedTaskList = Object.keys(backendState).filter((key)=>[
                    ...(0, $8Bc5A.allTasksExcludingJSMBusinessTasks),
                    ...jsmTaskProjectKeys
                ].includes(key) && backendState[key] === true);
            updatedState.hasSeenTasks = hasSeenTasks.filter((key)=>backendState[key] === true);
            Object.values((0, $8Bc5A.QUICKSTART_TYPE)).forEach((type)=>{
                // use new state if possible
                if ((0, $8Bc5A.getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, $8Bc5A.getBackendVisibilityKey)(type)];
                else if ((0, $8Bc5A.KEY_DISMISSED) in backendState && backendState[0, $8Bc5A.KEY_DISMISSED]) updatedState.visibility[type] = (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED;
                else if ((0, $8Bc5A.KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, $8Bc5A.KEY_OPEN] ? (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN : (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED;
                (0, $4ji4w.setLocalStorageItem)(`${type}.visibility`, updatedState.visibility[type]);
            });
            // Delete when cleaning up isDismissed in state
            if ((0, $8Bc5A.KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, $8Bc5A.KEY_DISMISSED];
            // Delete when cleaning up isOpen in state
            if ((0, $8Bc5A.KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, $8Bc5A.KEY_OPEN];
            if ((0, $8Bc5A.KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, $8Bc5A.KEY_OPEN_TASK];
            if ((0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE];
            if ((0, $8Bc5A.KEY_TASK_GROUP) in backendState) {
                updatedState.currentTaskGroupParent = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $8Bc5A.KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                updatedState.previousTaskGroupParents = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $8Bc5A.KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
            }
            if ((0, $8Bc5A.KEY_JSW_ONBOARDING) in backendState) {
                if (typeof backendState[0, $8Bc5A.KEY_JSW_ONBOARDING] === 'object' && backendState[0, $8Bc5A.KEY_JSW_ONBOARDING] !== null && (0, $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe) in backendState[0, $8Bc5A.KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, $8Bc5A.KEY_JSW_ONBOARDING][0, $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe];
            }
        }
        // Important that this call is before the dismiss migration logic and the premium card permission migration, otherwise it would
        // override the dismiss and currentTaskGroupParent
        setState(updatedState);
        // Bit of a migration
        // Handles case where non-admin premium users have a premium card child open which they can no longer access as we added more permission checks
        // Or, if a user was on a premium trial and saw premium content but is now free,
        // We take them to the root instead
        if ((updatedState.currentTaskGroupParent === (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN) || updatedState.currentTaskGroupParent === (0, $8Bc5A.PREMIUM_REVERSE_TRIAL_TASK)) && !canEditPlans || (updatedState.currentTaskGroupParent === (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK) || updatedState.currentTaskGroupParent === (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN) || updatedState.currentTaskGroupParent === (0, $8Bc5A.PREMIUM_REVERSE_TRIAL_TASK)) && appEditions.software !== (0, $ldyPw.PREMIUM_EDITION)) {
            dispatch((0, $6fSBR.nextGoBackToPreviousTaskGroup)());
            const analyticsEvent = createAnalyticsEvent({});
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'refreshAppState premiumCardPermissionsRevoked');
        }
        if (!(backendStateExists && (0, $8Bc5A.KEY_OPEN) in backendState)) try {
            const skipApplicationProperty = await (0, $6ypzr.getOnboardingSkipApplicationProperty)();
            if (skipApplicationProperty.quickstart) dispatch((0, $abQXL.nextSetChecklistIsDismissed)(true));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $52Vcw.fireAPIErrorAnalytics)(error, 'skipOnboarding');
        }
        const jswTrackDeferSitenameSiteTrait = await (0, $8fqy8.getJswTrackDeferSitenameSiteTrait)(cloudId, {
            packageName: (0, $8Bc5A.PACKAGE_NAME),
            teamName: (0, $8Bc5A.PACKAGE_TEAM_NAME)
        });
        setState({
            isEligibleToUpdateSitename: jswTrackDeferSitenameSiteTrait?.value === 'experiment-generated-site-name'
        });
        const setPremiumCardAudienceTrait = async (accountId)=>{
            if (accountId === null) return;
            const trait = await (0, $ljzlb.getCrossProjectBoardTrait)(createAnalyticsEvent, cloudId, accountId);
            setState({
                isCrossProjectBoardToPlanUpsell: trait?.value === true || false
            });
        };
        // We only want to check if a non-admin user has the CPB trait if they are in a
        // premium evaluation of jira software (i.e. they have access to Advanced Roadmaps)
        if (appEditions.software === (0, $ldyPw.PREMIUM_EDITION) && !isAdmin) await setPremiumCardAudienceTrait(atlassianAccountId);
        const { isCrossProjectBoardToPlanUpsell: isCrossProjectBoardToPlanUpsell } = getState();
        // If the user is on a JSW Premium instance, perform a fetch to check that they signed up with a Premium Reverse Trial.
        let isReverseTrialForJSW;
        if (isTargetedForReverseTrials) {
            const isOnboardingPremiumTrial = await (0, $bfWlw.getOnboardingPremiumTrial)();
            isReverseTrialForJSW = isOnboardingPremiumTrial?.premiumTrialOnSignup;
        }
        /**
		 * Re-open QS for:
		 *  - admins on an AdvancedRoadmaps trial who haven't had it re-opened for them yet
		 *  - non-admins on an AdvancedRoadmaps trial with isCrossProjectBoardToPlanUpsell trait
		 */ if (!isReverseTrialForJSW && appEditions.software === (0, $ldyPw.PREMIUM_EDITION) && isAdvancedRoadmapsTrial && (isAdmin || isCrossProjectBoardToPlanUpsell) && atlassianAccountId != null && !backendState[0, $8Bc5A.KEY_PREMIUM_TRIAL_REOPENED]) {
            // Re-open QS if not already opened
            dispatch((0, $4VXxO.nextSetChecklistIsOpen)(true));
            dispatch((0, $abQXL.nextSetChecklistIsDismissed)(false));
            const taskToDispatch = isAdmin ? (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK) : (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN);
            // Go to advanced roadmaps task
            dispatch((0, $erLQY.nextMarkAsCompletedTask)(taskToDispatch));
            dispatch((0, $6fSBR.nextChangeTaskGroupParent)(taskToDispatch));
            await (0, $1ftPQ.pushToBackend)({
                key: (0, $8Bc5A.KEY_PREMIUM_TRIAL_REOPENED),
                value: true
            });
            const analyticsEvent = createAnalyticsEvent({});
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'advancedRoadmapsTask reopened', {
                isAdmin: isAdmin
            });
        }
        setState({
            canEditPlans: canEditPlans
        });
        setState({
            isQuickstartLoaded: true
        });
    };

});
// Session storage constants used between going through initial onboarding screens
// and landing in JIRA
// Note this key used to be 'should-show-scrum-modal' but was changed to prevent a bug where experienced users
// Could see the modal if they were previously enrolled into ISO
const $6784cbc7d62e5d7c$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $6784cbc7d62e5d7c$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $6784cbc7d62e5d7c$export$e3884212029f7bef = 'should-show-welcome-modal';
const $6784cbc7d62e5d7c$export$c45d2ea50af63a85 = 'showed-welcome-modal-during-signup';
const $6784cbc7d62e5d7c$export$c9dc4cb209930823 = 'can-enroll-in-config-wizard-view';
const $6784cbc7d62e5d7c$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $6784cbc7d62e5d7c$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $6784cbc7d62e5d7c$export$16588d2012f3f89b = 'should-show-business-sample-data-nudge';
const $6784cbc7d62e5d7c$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $6784cbc7d62e5d7c$export$6e69f8dc03075ef8 = 'team-type';
const $6784cbc7d62e5d7c$export$c06666264cd35603 = 'team-type-shorthand';
const $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $6784cbc7d62e5d7c$export$6973064a898f5989 = 'should-show-list-view-type-cell-spotlight';
const $6784cbc7d62e5d7c$export$115fac1f1144bda1 = 'should-show-list-view-fields-dropdown-spotlight';
const $6784cbc7d62e5d7c$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $6784cbc7d62e5d7c$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $6784cbc7d62e5d7c$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $6784cbc7d62e5d7c$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $6784cbc7d62e5d7c$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $6784cbc7d62e5d7c$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $6784cbc7d62e5d7c$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $6784cbc7d62e5d7c$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $6784cbc7d62e5d7c$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $6784cbc7d62e5d7c$export$eb64d5f1a091478b = 'backlogCreateSprintIssueNudge';
const $6784cbc7d62e5d7c$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $6784cbc7d62e5d7c$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $6784cbc7d62e5d7c$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $6784cbc7d62e5d7c$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $6784cbc7d62e5d7c$export$468488291ccd988 = 'timelineAddItemNudge';
const $6784cbc7d62e5d7c$export$7a33548109ac931d = 'createFormNudge';
const $6784cbc7d62e5d7c$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $6784cbc7d62e5d7c$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $6784cbc7d62e5d7c$export$594d3436316492be = 'summaryViewNudge';
const $6784cbc7d62e5d7c$export$f93b83d735f01fa3 = 'pagesCreatePageNudge';
const $6784cbc7d62e5d7c$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $6784cbc7d62e5d7c$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $6784cbc7d62e5d7c$export$699265ec8ad9a740 = 'Software Development';
const $6784cbc7d62e5d7c$export$e07d1fa2da8ed874 = 'Customer Service';
const $6784cbc7d62e5d7c$export$76dcec3f438d9e56 = 'IT Support';
const $6784cbc7d62e5d7c$export$9a574c301f67ba30 = 'Human Resources';
const $6784cbc7d62e5d7c$export$363ec144a94029c8 = 'Finance';
const $6784cbc7d62e5d7c$export$df0fb32d68ae1e78 = 'Legal';
const $6784cbc7d62e5d7c$export$d9c0e3e59442fb4 = 'Marketing';
const $6784cbc7d62e5d7c$export$27dbc7d7ce66e6e3 = 'Operations';
const $6784cbc7d62e5d7c$export$a5dce388adf922bd = 'Sales';
const $6784cbc7d62e5d7c$export$e1473b31a257caff = 'Data Science';
const $6784cbc7d62e5d7c$export$85657457db93c2c2 = 'Product Management';
const $6784cbc7d62e5d7c$export$c0c2d1dfaeba89dd = 'Project Management';
const $6784cbc7d62e5d7c$export$2e6a7ad3ab9c82a3 = 'Design';
const $6784cbc7d62e5d7c$export$7b60378c3b4372e9 = 'Other or Personal';
const $6784cbc7d62e5d7c$export$572242e58bd07594 = 'CS';
const $6784cbc7d62e5d7c$export$d7de553940261eba = 'ITS';
const $6784cbc7d62e5d7c$export$4c29d0d04c15e55d = 'HR';
const $6784cbc7d62e5d7c$export$3950f7f841bf94b6 = 'FNC';
const $6784cbc7d62e5d7c$export$881249b988b6030f = 'LGL';
const $6784cbc7d62e5d7c$export$e4824f74b9879164 = 'MKT';
const $6784cbc7d62e5d7c$export$4f3cb0844009af52 = 'OPS';
const $6784cbc7d62e5d7c$export$1a65d50c4a641bb4 = 'SAL';
const $6784cbc7d62e5d7c$export$9ee64e8fbd8b03a2 = 'DS';
const $6784cbc7d62e5d7c$export$b8b1ac856ba1434b = 'DEV';
const $6784cbc7d62e5d7c$export$4f54a09a24fd1d74 = 'PDM';
const $6784cbc7d62e5d7c$export$79685802e8ff1098 = 'PJM';
const $6784cbc7d62e5d7c$export$e5c438b7501b5a24 = 'DES';
const $6784cbc7d62e5d7c$export$cbc0e551d91a692d = 'OTR';

parcelRegister("8fqy8", function(module, exports) {

$parcel$export(module.exports, "getSignupTrackDeferSitenameUserTrait", () => $77364531dfabe700$export$686752df505238be);
$parcel$export(module.exports, "getJswTrackDeferSitenameSiteTrait", () => $77364531dfabe700$export$6da79f996c267010);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $77364531dfabe700$var$PERSONALIZATION_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
const $77364531dfabe700$var$SITE_PERSONALIZATION_ENDPOINT = `${$77364531dfabe700$var$PERSONALIZATION_ENDPOINT}/site/`;
const $77364531dfabe700$var$USER_PERSONALIZATION_ENDPOINT = `${$77364531dfabe700$var$PERSONALIZATION_ENDPOINT}/user/`;
const $77364531dfabe700$var$SIGNUP_TRACK_DEFER_SITENAME_USER_TRAIT = 'marketing-signup_track_deferred-sitename_signup_server_enrollment';
const $77364531dfabe700$var$JSW_TRACK_DEFER_SITENAME_TRAIT = 'jira_track_instance_created_server_defer_site_rename_cohort';
const $77364531dfabe700$var$fetchPersonalization = (endpoint, subject)=>async (id, meta)=>{
        try {
            const url = endpoint + id;
            return await (0, $eusud.performGetRequest)(url);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'onboarding',
                    teamName: 'jlove-makkuro',
                    ...meta
                },
                attributes: {
                    subject: subject
                },
                error: error
            });
            return undefined;
        }
    };
const $77364531dfabe700$var$getTraits = (fetch, traitName)=>async (id, meta)=>{
        const personalization = await fetch(id, meta);
        return personalization?.attributes?.find((att)=>att.name === traitName);
    };
const $77364531dfabe700$export$686752df505238be = $77364531dfabe700$var$getTraits($77364531dfabe700$var$fetchPersonalization($77364531dfabe700$var$USER_PERSONALIZATION_ENDPOINT, 'fetchUserPersonalization'), $77364531dfabe700$var$SIGNUP_TRACK_DEFER_SITENAME_USER_TRAIT);
const $77364531dfabe700$export$6da79f996c267010 = $77364531dfabe700$var$getTraits($77364531dfabe700$var$fetchPersonalization($77364531dfabe700$var$SITE_PERSONALIZATION_ENDPOINT, 'fetchSitePersonalization'), $77364531dfabe700$var$JSW_TRACK_DEFER_SITENAME_TRAIT);

});

parcelRegister("bfWlw", function(module, exports) {

$parcel$export(module.exports, "getOnboardingPremiumTrialWithRethrow", () => $a55f3307b43c0521$export$d9a9dd6206da5bef);
$parcel$export(module.exports, "getOnboardingPremiumTrial", () => $a55f3307b43c0521$export$ef676f7f369f74fe);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $6c7t9 = parcelRequire("6c7t9");
const $a55f3307b43c0521$var$endpoint = '/rest/onboarding/1.0/premium-trial';
const $a55f3307b43c0521$export$d9a9dd6206da5bef = async ()=>{
    try {
        // Attempt to get from localStorage
        const localStorageOnboardingPremiumTrial = (0, $6c7t9.localStorageGetOnboardingPremiumTrial)();
        const localStorageOnboardingPremiumTrialCohort = (0, $6c7t9.localStorageGetOnboardingPremiumTrialCohort)();
        if (typeof localStorageOnboardingPremiumTrial === 'boolean' && typeof localStorageOnboardingPremiumTrialCohort === 'string') return {
            premiumTrialOnSignup: localStorageOnboardingPremiumTrial,
            reverseTrialCohort: localStorageOnboardingPremiumTrialCohort
        };
        const response = await (0, $eusud.performGetRequestWithRetry)($a55f3307b43c0521$var$endpoint);
        const premiumTrialOnSignup = response?.premiumTrialOnSignup;
        const reverseTrialCohort = response?.reverseTrialCohort;
        if (typeof premiumTrialOnSignup === 'boolean' && typeof reverseTrialCohort === 'string') {
            // Set into localStorage
            (0, $6c7t9.localStorageSetOnboardingPremiumTrial)(premiumTrialOnSignup);
            (0, $6c7t9.localStorageSetOnboardingPremiumTrialCohort)(reverseTrialCohort);
            return {
                premiumTrialOnSignup: premiumTrialOnSignup,
                reverseTrialCohort: reverseTrialCohort
            };
        }
        throw new Error('response?.premiumTrialOnSignup or response?.reverseTrialCohort is undefined');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'getOnboardingPremiumTrialWithRethrow',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $a55f3307b43c0521$export$ef676f7f369f74fe = async ()=>{
    try {
        return await $a55f3307b43c0521$export$d9a9dd6206da5bef();
    } catch (e) {
    // ignored
    }
};

});
parcelRegister("6c7t9", function(module, exports) {

$parcel$export(module.exports, "localStorageGetOnboardingPremiumTrial", () => $fab9df2877e9db77$export$782df5489e5cfd1e);
$parcel$export(module.exports, "localStorageGetOnboardingPremiumTrialCohort", () => $fab9df2877e9db77$export$c3378895d06b5528);
$parcel$export(module.exports, "localStorageSetOnboardingPremiumTrial", () => $fab9df2877e9db77$export$f83a7a49524e74ad);
$parcel$export(module.exports, "localStorageSetOnboardingPremiumTrialCohort", () => $fab9df2877e9db77$export$f389f8ca168b4a3a);

var $bSSG7 = parcelRequire("bSSG7");

var $jcw0u = parcelRequire("jcw0u");
const $fab9df2877e9db77$export$3538ee3f5c6c8b5c = 'premiumTrialOnSignup';
const $fab9df2877e9db77$export$2f93fdc3330233dc = 'reverseTrialCohort';
const $fab9df2877e9db77$var$localStorage = (0, $bSSG7.createLocalStorageProvider)('jsw-onboarding-premium-reverse-trial');
const $fab9df2877e9db77$export$782df5489e5cfd1e = ()=>{
    try {
        const value = $fab9df2877e9db77$var$localStorage.get($fab9df2877e9db77$export$3538ee3f5c6c8b5c);
        // localStorage.get is able to return proper booleans and not stringified booleans like "true"/"false"
        return value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'localStorageGetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        // note: unlike window.localStorage, the get method returns undefined instead of null. Thus this also returns undefined.
        return undefined;
    }
};
const $fab9df2877e9db77$export$c3378895d06b5528 = ()=>{
    try {
        const value = $fab9df2877e9db77$var$localStorage.get($fab9df2877e9db77$export$2f93fdc3330233dc);
        return value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'localStorageGetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        // note: unlike window.localStorage, the get method returns undefined instead of null. Thus this also returns undefined.
        return undefined;
    }
};
const $fab9df2877e9db77$export$f83a7a49524e74ad = (premiumTrialOnSignup)=>{
    try {
        $fab9df2877e9db77$var$localStorage.set($fab9df2877e9db77$export$3538ee3f5c6c8b5c, premiumTrialOnSignup);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'localStorageSetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};
const $fab9df2877e9db77$export$f389f8ca168b4a3a = (reverseTrialCohort)=>{
    try {
        $fab9df2877e9db77$var$localStorage.set($fab9df2877e9db77$export$2f93fdc3330233dc, reverseTrialCohort);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'localStorageSetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});


parcelRegister("6yhDy", function(module, exports) {

$parcel$export(module.exports, "pollBackend", () => $760653e5a4f27459$export$8420ef0cee98de);

var $1sYcL = parcelRequire("1sYcL");

var $8Bc5A = parcelRequire("8Bc5A");
const $760653e5a4f27459$export$8420ef0cee98de = async ({ keys: keys })=>{
    const { user: user } = await (0, $1sYcL.get)({
        userProperties: keys,
        consumerMeta: {
            id: 'fetchUserProperties',
            packageName: (0, $8Bc5A.PACKAGE_NAME),
            teamName: (0, $8Bc5A.PACKAGE_TEAM_NAME)
        }
    });
    return user;
};

});
parcelRegister("1sYcL", function(module, exports) {

$parcel$export(module.exports, "get", () => $7fc92c544211ac93$export$3988ae62b71be9a3);

var $lbWm4 = parcelRequire("lbWm4");

var $3T6Xo = parcelRequire("3T6Xo");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $fZneA = parcelRequire("fZneA");

var $eusud = parcelRequire("eusud");

var $fjcgS = parcelRequire("fjcgS");

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
let $7fc92c544211ac93$var$ufoExperiencesMap = {};
const $7fc92c544211ac93$var$getUfoExperience = (key)=>{
    if (!$7fc92c544211ac93$var$ufoExperiencesMap[key]) $7fc92c544211ac93$var$ufoExperiencesMap[key] = new (0, $duUGa.UFOExperience)(key, {
        type: (0, $atdLB.ExperienceTypes).Operation,
        performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom
    });
    return $7fc92c544211ac93$var$ufoExperiencesMap[key];
};
const $7fc92c544211ac93$export$c907f169d33b2e25 = ()=>{
    $7fc92c544211ac93$var$ufoExperiencesMap = {};
};
const $7fc92c544211ac93$export$a5b7a8c3b1c6e775 = ({ userProperties: userProperties, projectId: projectId, projectProperties: projectProperties, instanceProperties: instanceProperties })=>{
    const params = new URLSearchParams();
    userProperties && params.append('user', userProperties.join(','));
    projectId !== undefined && params.append('projectId', projectId);
    projectProperties && params.append('project', projectProperties.join(','));
    instanceProperties && params.append('instance', instanceProperties.join(','));
    return `/rest/internal/latest/frontendconfig/properties?${params.toString()}`;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7fc92c544211ac93$var$patchProperties = (response, propertiesPath)=>((0, $4R6GH.fg)('handle_null_response_for_fe_config_properties_call') ? response : true) && (0, (/*@__PURE__*/$parcel$interopDefault($lbWm4)))(response[propertiesPath], (value, prop)=>{
        try {
            response[propertiesPath][prop] = JSON.parse(value);
        } catch (error) {
            // TODO: Endpoint should ideally only return stringified values
            if (prop === 'initial.project.template.name') response[propertiesPath][prop] = value;
            else throw error;
        }
    });
const $7fc92c544211ac93$export$3988ae62b71be9a3 = async (options)=>{
    const ufoExperience = $7fc92c544211ac93$var$getUfoExperience(`${(0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))(options.consumerMeta.packageName)}.${(0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))(options.consumerMeta.id)}`);
    try {
        ufoExperience?.start();
        const url = $7fc92c544211ac93$export$a5b7a8c3b1c6e775(options);
        const response = await (0, $eusud.performGetRequest)(url);
        if (response === null) (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                action: 'succeeded',
                actionSubject: 'jiraCommonRestInternalLatest.getConfigProperties',
                source: 'frontendConfigProperties',
                attributes: {
                    package: consumerMeta.packageName,
                    id: consumerMeta.id,
                    isNullResponse: true
                }
            };
            client.getInstance().sendOperationalEvent(payload);
        });
        $7fc92c544211ac93$var$patchProperties(response, 'user');
        $7fc92c544211ac93$var$patchProperties(response, 'instance');
        $7fc92c544211ac93$var$patchProperties(response, 'project');
        const { consumerMeta: consumerMeta } = options;
        (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                source: 'frontendConfigProperties',
                action: 'success',
                actionSubject: `${consumerMeta.packageName}.${consumerMeta.id}`
            };
            client.getInstance().sendOperationalEvent(payload);
        });
        ufoExperience?.success();
        return (0, $4R6GH.fg)('handle_null_response_for_fe_config_properties_call') ? response || {
            user: {},
            instance: {},
            project: {}
        } : response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const { consumerMeta: consumerMeta } = options;
        !(0, $fZneA.isClientFetchError)(error) && (0, $jcw0u.default)({
            error: error,
            meta: {
                id: consumerMeta.id,
                packageName: consumerMeta.packageName,
                teamName: consumerMeta.teamName
            },
            sendToPrivacyUnsafeSplunk: true
        });
        ufoExperience?.failure();
        throw error;
    }
};

});


parcelRegister("52Vcw", function(module, exports) {

$parcel$export(module.exports, "fireAnalyticsOnQuickstartClose", () => $5dab66e6da9554ae$export$c98a6ee6aadb8055);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartDismiss", () => $5dab66e6da9554ae$export$45d8c76e0490b3ec);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartBack", () => $5dab66e6da9554ae$export$b1be4ae35a43115d);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartExperienceComplete", () => $5dab66e6da9554ae$export$fa4f266bd2444d14);
$parcel$export(module.exports, "fireAnalyticsOnChecklistItemCompleted", () => $5dab66e6da9554ae$export$a68a2e5a69c8cd74);
$parcel$export(module.exports, "fireAPIErrorAnalytics", () => $5dab66e6da9554ae$export$a4d7f1a52677d339);
$parcel$export(module.exports, "fireAnalyticsOnOpenRightHandSidebar", () => $5dab66e6da9554ae$export$160bb78a3b11a5a9);
$parcel$export(module.exports, "fireAnalyticsOnMinimiseRightHandSidebar", () => $5dab66e6da9554ae$export$6ccbe54cd3a5a12);
$parcel$export(module.exports, "fireAnalyticsOnCloseRightHandSidebar", () => $5dab66e6da9554ae$export$6c39ca65ca354e59);

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");

var $8Bc5A = parcelRequire("8Bc5A");

var $izv86 = parcelRequire("izv86");
const $5dab66e6da9554ae$export$c98a6ee6aadb8055 = (analyticsEvent, attributes)=>{
    analyticsEvent.update({
        action: 'closed',
        actionSubject: 'button'
    });
    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button closed', (0, $8Bc5A.ACTION_SUBJECT_ID), attributes);
};
const $5dab66e6da9554ae$export$45d8c76e0490b3ec = (analyticsEvent, attributes, source)=>{
    if (source === 'button') (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstartButton', attributes);
    else if (source === 'checklist') (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstart', attributes);
};
const $5dab66e6da9554ae$export$b1be4ae35a43115d = (analyticsEvent)=>{
    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'backButton');
};
const $5dab66e6da9554ae$export$fa4f266bd2444d14 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'experience completed', (0, $8Bc5A.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $5dab66e6da9554ae$export$a68a2e5a69c8cd74 = (createAnalyticsEvent, completedTaskId)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'checklistItem completed', (0, $izv86.convertTaskIdToActionSubjectId)(completedTaskId), {
        taskId: completedTaskId
    });
};
const $5dab66e6da9554ae$export$a4d7f1a52677d339 = (error, endpointSource)=>{
    (0, $jcw0u.default)({
        error: error,
        meta: {
            id: 'quickstartApiError',
            packageName: 'jiraOnboardingQuickstartCore',
            teamName: 'jlove-makkuro'
        },
        attributes: {
            error: error.message,
            endpointSource: endpointSource
        }
    });
};
const $5dab66e6da9554ae$export$160bb78a3b11a5a9 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart openRightSidebar', (0, $8Bc5A.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $5dab66e6da9554ae$export$6ccbe54cd3a5a12 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart minimiseRightSidebar', (0, $8Bc5A.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $5dab66e6da9554ae$export$6c39ca65ca354e59 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart closeRightSidebar', (0, $8Bc5A.ACTION_SUBJECT_ID), {
        ...attributes
    });
};

});
parcelRegister("izv86", function(module, exports) {

$parcel$export(module.exports, "getProductType", () => $4725f5ccfabd2231$export$27e53caf66bae1d);
$parcel$export(module.exports, "convertTaskIdToActionSubjectId", () => $4725f5ccfabd2231$export$3b914201960fa7a6);

var $e4eHl = parcelRequire("e4eHl");

var $2vSU6 = parcelRequire("2vSU6");
const $4725f5ccfabd2231$export$d64a7dd8c7cd80e0 = {
    [(0, $2vSU6.CORE_PROJECT)]: 'workManagement',
    [(0, $2vSU6.SOFTWARE_PROJECT)]: 'software',
    [(0, $2vSU6.SERVICE_DESK_PROJECT)]: 'serviceManagement'
};
const $4725f5ccfabd2231$export$27e53caf66bae1d = (projectType)=>{
    if (projectType) return $4725f5ccfabd2231$export$d64a7dd8c7cd80e0[projectType] || (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(projectType);
    return null;
};
const $4725f5ccfabd2231$export$3b914201960fa7a6 = (taskId)=>{
    if (!taskId) return '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(taskId.split('.').pop());
};

});


parcelRegister("ljzlb", function(module, exports) {

$parcel$export(module.exports, "getCrossProjectBoardTrait", () => $9217b5bb53dd29c2$export$7f2186c37a3d095d);

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");

var $8zOmE = parcelRequire("8zOmE");

var $8Bc5A = parcelRequire("8Bc5A");

var $k9OK8 = parcelRequire("k9OK8");
const $9217b5bb53dd29c2$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT = 'segment_jsw_cross_project_board_trait_siteuser';
const $9217b5bb53dd29c2$var$TAP_DELIVERY_PROXY_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
const $9217b5bb53dd29c2$var$ONE_DAY = 86400000;
const $9217b5bb53dd29c2$export$88f2f25e1418caf1 = async (createAnalyticsEvent, siteId, userId)=>{
    try {
        const url = `${$9217b5bb53dd29c2$var$TAP_DELIVERY_PROXY_ENDPOINT}/site/${siteId}/user/${userId}`;
        const result = await (0, $eusud.performGetRequest)(url);
        const analyticsEvent = createAnalyticsEvent({});
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait personalizationApi', {
            synthetic: (0, $4R6GH.fg)('is_synthetic_tenant')
        });
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'quickstartApiError',
                packageName: (0, $8Bc5A.PACKAGE_NAME),
                teamName: (0, $8Bc5A.PACKAGE_TEAM_NAME)
            },
            attributes: {
                error: error.message,
                endpointSource: 'getJSWCrossProjectBoardTrait',
                synthetic: (0, $4R6GH.fg)('is_synthetic_tenant')
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            attributes: []
        };
    }
};
const $9217b5bb53dd29c2$export$7f2186c37a3d095d = async (createAnalyticsEvent, siteId, userId)=>{
    const { get: get, persist: persist } = (0, $k9OK8.crossProjectBoardTraitSessionStorageProvider)();
    // Check session storage
    const sessionStorage = get();
    if (sessionStorage && userId === sessionStorage.userId && siteId === sessionStorage.siteId && Date.now() - sessionStorage.date < $9217b5bb53dd29c2$var$ONE_DAY) {
        const analyticsEvent = createAnalyticsEvent({});
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait sessionStorage', {
            synthetic: (0, $4R6GH.fg)('is_synthetic_tenant')
        });
        return sessionStorage.attribute;
    }
    // Fetch from personalization
    const personalization = await $9217b5bb53dd29c2$export$88f2f25e1418caf1(createAnalyticsEvent, siteId, userId);
    const attribute = personalization.attributes.find((att)=>att.name === $9217b5bb53dd29c2$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT);
    if (attribute !== undefined) persist({
        attribute: attribute,
        date: Date.now(),
        userId: userId,
        siteId: siteId
    });
    return attribute;
};

});
parcelRegister("k9OK8", function(module, exports) {

$parcel$export(module.exports, "crossProjectBoardTraitSessionStorageProvider", () => $ee27e8acf854e0ab$export$99f3e48748c2a8c3);

var $eNf8a = parcelRequire("eNf8a");

const $ee27e8acf854e0ab$var$crossProjectBoardTraitSessionProvider = (0, $eNf8a.createSessionExpirableStorageProvider)((0, $111ca51573c84ae8$export$fac14ff24e5b1e7a));
const $ee27e8acf854e0ab$export$99f3e48748c2a8c3 = ()=>{
    const persist = (toPersist)=>{
        $ee27e8acf854e0ab$var$crossProjectBoardTraitSessionProvider.set((0, $111ca51573c84ae8$export$fac14ff24e5b1e7a), toPersist);
    };
    const get = ()=>$ee27e8acf854e0ab$var$crossProjectBoardTraitSessionProvider.get((0, $111ca51573c84ae8$export$fac14ff24e5b1e7a));
    return {
        get: get,
        persist: persist
    };
};

});
parcelRegister("eNf8a", function(module, exports) {

$parcel$export(module.exports, "createSessionStorageProvider", () => $b98f887ad675a269$export$a922b987e648d2fa);
$parcel$export(module.exports, "createSessionExpirableStorageProvider", () => $b98f887ad675a269$export$e0a2e9a062c6a695);

var $gJBT6 = parcelRequire("gJBT6");

var $fNVZf = parcelRequire("fNVZf");

var $j9Vq5 = parcelRequire("j9Vq5");
const $b98f887ad675a269$export$a922b987e648d2fa = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((appPrefix, shouldSerialize = true)=>(0, $fNVZf.createStorageProvider)((0, $fNVZf.WebStorageType).SessionStorage, appPrefix, (0, $j9Vq5.makeSessionStore)(), shouldSerialize));
const $b98f887ad675a269$export$e0a2e9a062c6a695 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((appPrefix)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    return (0, $fNVZf.createExpirableStorageProvider)((0, $fNVZf.WebStorageType).SessionStorage, appPrefix, (0, $j9Vq5.makeSessionExpirableStore)());
});

});
parcelRegister("j9Vq5", function(module, exports) {

$parcel$export(module.exports, "makeSessionStore", () => $93ac2abe604287b3$export$fb690882d627b3b5);
$parcel$export(module.exports, "makeSessionExpirableStore", () => $93ac2abe604287b3$export$a8f626c8ded9a06c);

var $fKgem = parcelRequire("fKgem");

var $kzObv = parcelRequire("kzObv");

var $c4CII = parcelRequire("c4CII");

var $2NjNT = parcelRequire("2NjNT");

var $c74za = parcelRequire("c74za");

var $fNVZf = parcelRequire("fNVZf");
const $93ac2abe604287b3$export$fb690882d627b3b5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($c4CII))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($c74za))),
        (0, (/*@__PURE__*/$parcel$interopDefault($2NjNT)))
    ], (0, $fNVZf.plugins));
const $93ac2abe604287b3$export$a8f626c8ded9a06c = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($c4CII))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($c74za))),
        (0, (/*@__PURE__*/$parcel$interopDefault($2NjNT)))
    ], [
        (0, (/*@__PURE__*/$parcel$interopDefault($fKgem))),
        (0, (/*@__PURE__*/$parcel$interopDefault($kzObv)))
    ]);

});


const $111ca51573c84ae8$export$fac14ff24e5b1e7a = 'jira-user-cross-project-board-trait';



parcelRegister("6ypzr", function(module, exports) {

$parcel$export(module.exports, "getOnboardingSkipApplicationProperty", () => $98fe78eb4dc2e758$export$980c26b6f100081d);

var $eusud = parcelRequire("eusud");
const $98fe78eb4dc2e758$export$980c26b6f100081d = ()=>(0, $eusud.performGetRequest)('/rest/onboarding/1.0/skip');

});

parcelRegister("4ji4w", function(module, exports) {

$parcel$export(module.exports, "getNextNonCompleteTask", () => $af696889329ec63a$export$b61dc70e2ed3fae3);
$parcel$export(module.exports, "getNextTask", () => $af696889329ec63a$export$404421ce8f3cbf9a);
$parcel$export(module.exports, "setLocalStorageItem", () => $af696889329ec63a$export$5aa524d86254b4f);
$parcel$export(module.exports, "getLocalStorageItem", () => $af696889329ec63a$export$93d719890ad66653);

var $bSSG7 = parcelRequire("bSSG7");

var $aFsRe = parcelRequire("aFsRe");
const $af696889329ec63a$export$b61dc70e2ed3fae3 = (tasks, completed, openTask)=>{
    const taskPosition = (0, $aFsRe.getTaskIndex)(tasks, openTask);
    // if the task does not exist(-1), we want to start at 0
    // if it exists we want to start at array index + 1 (taskPosition is already index+1)
    const start = taskPosition === -1 ? 0 : taskPosition;
    const len = tasks.length;
    // This loop:
    // 1) searches for non completed items from the start index to last index of the array
    // 2) searches from 0 until start if nothing was found during 1)
    for(let i = start; i < start + len; i += 1){
        const ind = i % len;
        if (!completed.includes(tasks[ind])) return tasks[ind];
    }
    // nothing was found there is no task to open
    return null;
};
const $af696889329ec63a$export$404421ce8f3cbf9a = (tasks, openTask)=>{
    const taskPosition = (0, $aFsRe.getTaskIndex)(tasks, openTask);
    // if the task does not exist(-1), we want to start at 0
    // if it exists we want to start at array index + 1 (taskPosition is already index+1)
    const ind = taskPosition === -1 ? 0 : taskPosition;
    return tasks[ind] ? tasks[ind] : null;
};
const $af696889329ec63a$var$store = (0, $bSSG7.createLocalStorageProvider)('quickstart');
const $af696889329ec63a$export$5aa524d86254b4f = (key, value)=>{
    $af696889329ec63a$var$store.set(key, value);
};
const $af696889329ec63a$export$93d719890ad66653 = (key)=>$af696889329ec63a$var$store.get(key);

});
parcelRegister("aFsRe", function(module, exports) {

$parcel$export(module.exports, "getTaskIndex", () => $856e0575daef172f$export$9ba3adcb1954c00);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForShowMe", () => $856e0575daef172f$export$9711f11998d5795c);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForLink", () => $856e0575daef172f$export$995248f3b43d8505);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForCta", () => $856e0575daef172f$export$293f6b2affa6ea5a);

var $izv86 = parcelRequire("izv86");







const $856e0575daef172f$export$9ba3adcb1954c00 = (taskList, taskId)=>{
    if (!taskList || taskId === null) return -1;
    return taskList.indexOf(taskId) + 1;
};
const $856e0575daef172f$export$9711f11998d5795c = (taskId)=>`${(0, $izv86.convertTaskIdToActionSubjectId)(taskId)}ShowMe`;
const $856e0575daef172f$export$995248f3b43d8505 = (taskId)=>`${(0, $izv86.convertTaskIdToActionSubjectId)(taskId)}Link`;
const $856e0575daef172f$export$293f6b2affa6ea5a = (taskId)=>`${(0, $izv86.convertTaskIdToActionSubjectId)(taskId)}Cta`;

});


parcelRegister("abQXL", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistIsDismissed", () => $dc09dffee9419aae$export$f24c05f83b880547);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");

var $3B5jO = parcelRequire("3B5jO");

var $4ji4w = parcelRequire("4ji4w");
const $dc09dffee9419aae$export$f24c05f83b880547 = (isDismissed)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3B5jO.getQuickstartTypeSelector)(state);
        const currentIsDismissed = state.visibility[quickstartType] === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED;
        if (isDismissed === currentIsDismissed) // if state has not been updated we just return
        return;
        const quickstartStatus = isDismissed ? (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED : (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            },
            isFocusedOn: !isDismissed
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        (0, $4ji4w.setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
        // Delete all code below when cleaning up isDismissed in state
        if (isDismissed === false) // When setting IsDismissed to false, also setting QS status to OPEN so checklist appears in open state
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_OPEN),
            value: true
        });
        else // When setting IsDismissed, also toggle the open state of the checklist to match.
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_OPEN),
            value: false
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_DISMISSED),
            value: isDismissed
        });
    };

});

parcelRegister("4VXxO", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistIsOpen", () => $7815e3bf96163d46$export$4249eabbb34e2e69);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");

var $3B5jO = parcelRequire("3B5jO");

var $4ji4w = parcelRequire("4ji4w");
const $7815e3bf96163d46$export$4249eabbb34e2e69 = (isOpen)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3B5jO.getQuickstartTypeSelector)(state);
        const currentIsOpen = state.visibility[quickstartType] === (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN;
        const currentIsMinimised = state.visibility[quickstartType] === (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED;
        if (currentIsOpen && isOpen || currentIsMinimised && !isOpen) // if state has not been updated we just return
        return;
        const quickstartStatus = isOpen ? (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN : (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            },
            hasNudgeActive: false,
            isFocusedOn: isOpen
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        (0, $4ji4w.setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
        // Delete all code below when cleaning up isOpen in state
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_OPEN),
            value: isOpen
        });
    };

});

parcelRegister("erLQY", function(module, exports) {

$parcel$export(module.exports, "nextMarkAsCompletedTask", () => $f082da41253fd664$export$d6628d41a3bec42d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $1ftPQ = parcelRequire("1ftPQ");
const $f082da41253fd664$export$d6628d41a3bec42d = (taskId)=>({ getState: getState, setState: setState })=>{
        // When a task is complete:
        // Check to see if the task is complete in the completedKeys already
        // update the checklist dict (maybe should be at a different point or use setState)
        const { completedTaskList: completedTaskList } = getState();
        if (completedTaskList.includes(taskId)) return;
        // update the backend with the KEY and true
        (0, $1ftPQ.pushToBackend)({
            key: taskId,
            value: true
        });
        // update itemsList to reflect checked status. clone -> update -> override
        setState({
            completedTaskList: [
                ...completedTaskList,
                taskId
            ]
        });
    };

});


parcelRegister("8UXiA", function(module, exports) {

$parcel$export(module.exports, "setNudgeStep", () => $2d15900fae273e3c$export$4debc323813b6997);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $2d15900fae273e3c$export$4debc323813b6997 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { nudgeStep: nudgeStep } = getState();
        if (nudge === nudgeStep) return;
        setState({
            nudgeStep: nudge
        });
    };
var $2d15900fae273e3c$export$2e2bcd8739ae039 = $2d15900fae273e3c$export$4debc323813b6997;

});

parcelRegister("3iEb4", function(module, exports) {

$parcel$export(module.exports, "addMountedNudge", () => $d23aba2b0749d2be$export$92a89c32d0ea3943);
$parcel$export(module.exports, "removeMountedNudge", () => $d23aba2b0749d2be$export$748f4cda8ab98c91);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $d23aba2b0749d2be$export$92a89c32d0ea3943 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { mountedNudges: mountedNudges } = getState();
        // skip store update if this nudge is already added
        if (mountedNudges.includes(nudge)) return;
        setState({
            mountedNudges: [
                ...mountedNudges,
                nudge
            ]
        });
    };
const $d23aba2b0749d2be$export$748f4cda8ab98c91 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { mountedNudges: mountedNudges } = getState();
        // skip store update if this nudge is already removed
        if (!mountedNudges.includes(nudge)) return;
        setState({
            mountedNudges: mountedNudges.filter((mountedNudge)=>mountedNudge !== nudge)
        });
    };

});

parcelRegister("7yDu9", function(module, exports) {

$parcel$export(module.exports, "setShouldRenderComponent", () => $e7988e1b8f7782bd$export$1f9c6770ed938b6e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $e7988e1b8f7782bd$export$1f9c6770ed938b6e = (shouldRenderComponent)=>({ getState: getState, setState: setState })=>{
        /* Grab current state of is shouldRenderComponent */ const { shouldRenderComponent: currentShouldRenderComponent } = getState();
        if (shouldRenderComponent === currentShouldRenderComponent) // if state has not been updated we just return
        return;
        setState({
            shouldRenderComponent: shouldRenderComponent
        });
    };
var $e7988e1b8f7782bd$export$2e2bcd8739ae039 = $e7988e1b8f7782bd$export$1f9c6770ed938b6e;

});

parcelRegister("5UBG2", function(module, exports) {

$parcel$export(module.exports, "setProjectState", () => $72dc29ca0b198f0e$export$1ba498e440c0a1e4);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $72dc29ca0b198f0e$export$1ba498e440c0a1e4 = (projectState)=>({ setState: setState })=>{
        setState({
            projectState: projectState
        });
    };
var $72dc29ca0b198f0e$export$2e2bcd8739ae039 = $72dc29ca0b198f0e$export$1ba498e440c0a1e4;

});

parcelRegister("lHcRB", function(module, exports) {

$parcel$export(module.exports, "setHasNudgeActive", () => $4ecbca1b06d3bc5e$export$497c281e6eb0786e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $4ecbca1b06d3bc5e$export$497c281e6eb0786e = (hasNudgeActive, itemName = '')=>({ getState: getState, setState: setState })=>{
        /* Grab current state of is currentHasNudgeActive */ const { hasNudgeActive: currentHasNudgeActive, openTask: openTask } = getState();
        if (hasNudgeActive === currentHasNudgeActive) // if state has not been updated we just return
        return;
        if (hasNudgeActive === false && itemName !== openTask) // do not update a nudge if the current open task is different than the one we called the function with
        return;
        setState({
            hasNudgeActive: hasNudgeActive
        });
    };
var $4ecbca1b06d3bc5e$export$2e2bcd8739ae039 = $4ecbca1b06d3bc5e$export$497c281e6eb0786e;

});

parcelRegister("eiyXc", function(module, exports) {

$parcel$export(module.exports, "forceHideNudge", () => $7ab5d12e3e83c16f$export$6d1ed97b83a62e8e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
// We use this action in cases where we want to hide the nudge no matter what.
const $7ab5d12e3e83c16f$export$6d1ed97b83a62e8e = ()=>({ setState: setState })=>{
        setState({
            hasNudgeActive: false
        });
    };

});

parcelRegister("jZvbN", function(module, exports) {

$parcel$export(module.exports, "setHasEverSeenRoute", () => $bde38543b00c29f3$export$28e0a4314a1ce52f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");
const $bde38543b00c29f3$export$28e0a4314a1ce52f = (update)=>({ getState: getState, setState: setState })=>{
        const { hasEverSeenRoute: currentHasEverSeenRoute } = getState();
        const somethingHasBeenUpdated = Object.keys(update).some(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap", boolean>>'.
        (key)=>update[key] !== currentHasEverSeenRoute[key]);
        if (!somethingHasBeenUpdated) return;
        const newHasEverSeenRoute = {
            ...currentHasEverSeenRoute,
            ...update
        };
        setState({
            hasEverSeenRoute: newHasEverSeenRoute
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE),
            value: newHasEverSeenRoute
        });
    };
var $bde38543b00c29f3$export$2e2bcd8739ae039 = $bde38543b00c29f3$export$28e0a4314a1ce52f;

});

parcelRegister("azcAL", function(module, exports) {

$parcel$export(module.exports, "setRoadmapIsCreateEnabled", () => $f19987e3027503ab$export$35ea35d1a8e07307);
$parcel$export(module.exports, "setRoadmapIsListEmpty", () => $f19987e3027503ab$export$932967764e7a0b31);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $f19987e3027503ab$export$35ea35d1a8e07307 = (roadmapIsCreateEnabled)=>({ getState: getState, setState: setState })=>{
        const { roadmapIsCreateEnabled: currentRoadmapIsCreateEnabled } = getState();
        // skip store update if no state change
        if (currentRoadmapIsCreateEnabled === roadmapIsCreateEnabled) return;
        setState({
            roadmapIsCreateEnabled: roadmapIsCreateEnabled
        });
    };
const $f19987e3027503ab$export$932967764e7a0b31 = (roadmapIsListEmpty)=>({ getState: getState, setState: setState })=>{
        const { roadmapIsListEmpty: currentRoadmapIsListEmpty } = getState();
        // skip store update if no state change
        if (currentRoadmapIsListEmpty === roadmapIsListEmpty) return;
        setState({
            roadmapIsListEmpty: roadmapIsListEmpty
        });
    };

});

parcelRegister("gbXQ5", function(module, exports) {

$parcel$export(module.exports, "openNextTask", () => $460159056a360dfc$export$867dbb6d61569ae9);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4ji4w = parcelRequire("4ji4w");

var $cUGWT = parcelRequire("cUGWT");
const $460159056a360dfc$export$867dbb6d61569ae9 = ()=>({ getState: getState, dispatch: dispatch })=>{
        const { openTask: openTask, tasks: tasks } = getState();
        if (!tasks) return;
        const { items: items } = tasks;
        const taskIdToExpand = (0, $4ji4w.getNextTask)(items, openTask);
        if (taskIdToExpand === null) return;
        dispatch((0, $cUGWT.nextOpenTask)(taskIdToExpand));
    };

});
parcelRegister("cUGWT", function(module, exports) {

$parcel$export(module.exports, "nextOpenTask", () => $f8b3135a172025f8$export$5deb889489d2f989);
$parcel$export(module.exports, "nextAutoOpenTask", () => $f8b3135a172025f8$export$cc5f3544a6cb2922);


var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");

var $8UXiA = parcelRequire("8UXiA");

var $lHcRB = parcelRequire("lHcRB");
const $f8b3135a172025f8$var$openTask = (taskId)=>({ setState: setState })=>{
        setState({
            openTask: taskId
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_OPEN_TASK),
            value: taskId
        });
    };
const $f8b3135a172025f8$export$5deb889489d2f989 = (taskId, { closeNudge: closeNudge } = {})=>({ dispatch: dispatch, getState: getState })=>{
        dispatch($f8b3135a172025f8$var$openTask(taskId));
        const { completedTaskList: completedTaskList } = getState();
        const taskIsCompleted = completedTaskList.includes(taskId);
        const taskIdExistsAndIsNotCompleted = !(taskId === '' || taskId === null) && !taskIsCompleted;
        if (closeNudge) dispatch((0, $lHcRB.setHasNudgeActive)(false, taskId));
        else dispatch((0, $lHcRB.setHasNudgeActive)(taskIdExistsAndIsNotCompleted, taskId));
        // This is a temporary solution for Scrum Onboarding.
        // See https://hello.atlassian.net/wiki/spaces/agile/pages/1321008806/Draft+Quickstart+Nudge+Interaction for details
        if (taskIdExistsAndIsNotCompleted && taskId === (0, $8Bc5A.SCRUM_ONBOARDING_TASK)) dispatch((0, $8UXiA.setNudgeStep)((0, $6784cbc7d62e5d7c$export$b1a6ab17737f33e)));
        else if (taskIdExistsAndIsNotCompleted && taskId === (0, $8Bc5A.KANBAN_ONBOARDING_TASK)) dispatch((0, $8UXiA.setNudgeStep)((0, $6784cbc7d62e5d7c$export$3366ddefe77d5112)));
        else if (taskIdExistsAndIsNotCompleted && taskId === (0, $8Bc5A.ADD_COLUMNS_TASK)) dispatch((0, $8UXiA.setNudgeStep)((0, $6784cbc7d62e5d7c$export$3366ddefe77d5112)));
        else dispatch((0, $8UXiA.setNudgeStep)(''));
    };
const $f8b3135a172025f8$export$cc5f3544a6cb2922 = (taskId)=>({ dispatch: dispatch })=>{
        dispatch($f8b3135a172025f8$var$openTask(taskId));
        dispatch((0, $lHcRB.setHasNudgeActive)(false, taskId));
        dispatch((0, $8UXiA.setNudgeStep)(''));
    };

});


parcelRegister("iZuFy", function(module, exports) {

$parcel$export(module.exports, "resetIsQuickstartLoaded", () => $b50ce46f86d3e3d7$export$bda085a823763e5a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $3B5jO = parcelRequire("3B5jO");
const $b50ce46f86d3e3d7$export$bda085a823763e5a = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3B5jO.getQuickstartTypeSelector)(state);
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: (0, $8Bc5A.QUICKSTART_UI_STATUS).NOT_LOADED
            },
            hasNudgeActive: false,
            isQuickstartLoaded: false
        });
    };

});

parcelRegister("70Fss", function(module, exports) {

$parcel$export(module.exports, "refreshAppStateUiStatusOnly", () => $f0fdda8951af3bde$export$87fe8079a4ed9766);


var $8Bc5A = parcelRequire("8Bc5A");

var $6yhDy = parcelRequire("6yhDy");

var $52Vcw = parcelRequire("52Vcw");

var $6ypzr = parcelRequire("6ypzr");

var $abQXL = parcelRequire("abQXL");
const $f0fdda8951af3bde$export$87fe8079a4ed9766 = ({ taskList: taskList })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        // Need to check to see if there is anything in the backend to take that as source of truth
        // If there is nothing then use defaults
        // Check backend for flags that are marked as completed (true)
        // Carry over state from previous actions
        // Create Completed Actions
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedState = {};
        const { projectState: projectState } = getState();
        if (!projectState) return;
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.isOpen = true;
        updatedState.isDismissed = false;
        updatedState.quickstartStateProjectType = projectState.projectType;
        let backendVisibilityKeys = [];
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.visibility = Object.values((0, $8Bc5A.QUICKSTART_TYPE)).reduce((acc, type)=>{
            acc[type] = (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN;
            return acc;
        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {});
        backendVisibilityKeys = Object.values((0, $8Bc5A.QUICKSTART_TYPE)).map((type)=>(0, $8Bc5A.getBackendVisibilityKey)(type));
        const backendState = await (0, $6yhDy.pollBackend)({
            keys: [
                (0, $8Bc5A.KEY_OPEN),
                (0, $8Bc5A.KEY_DISMISSED),
                (0, $8Bc5A.KEY_OPEN_TASK),
                (0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE),
                (0, $8Bc5A.KEY_JSW_ONBOARDING),
                ...(0, $8Bc5A.allTasksExcludingJSMBusinessTasks),
                ...backendVisibilityKeys
            ]
        });
        const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
        if (backendStateExists) {
            updatedState.completedTaskList = Object.keys(backendState).filter((key)=>[
                    ...(0, $8Bc5A.allTasksExcludingJSMBusinessTasks)
                ].includes(key) && backendState[key] === true);
            Object.values((0, $8Bc5A.QUICKSTART_TYPE)).forEach((type)=>{
                // use new state if possible
                if ((0, $8Bc5A.getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, $8Bc5A.getBackendVisibilityKey)(type)];
                else if ((0, $8Bc5A.KEY_DISMISSED) in backendState && backendState[0, $8Bc5A.KEY_DISMISSED]) updatedState.visibility[type] = (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED;
                else if ((0, $8Bc5A.KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, $8Bc5A.KEY_OPEN] ? (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN : (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED;
            });
            if ((0, $8Bc5A.KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, $8Bc5A.KEY_DISMISSED];
            if ((0, $8Bc5A.KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, $8Bc5A.KEY_OPEN];
            if ((0, $8Bc5A.KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, $8Bc5A.KEY_OPEN_TASK];
            if ((0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE];
            if ((0, $8Bc5A.KEY_TASK_GROUP) in backendState) {
                updatedState.currentTaskGroupParent = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $8Bc5A.KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                updatedState.previousTaskGroupParents = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $8Bc5A.KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
            }
            if ((0, $8Bc5A.KEY_JSW_ONBOARDING) in backendState) {
                if (typeof backendState[0, $8Bc5A.KEY_JSW_ONBOARDING] === 'object' && backendState[0, $8Bc5A.KEY_JSW_ONBOARDING] !== null && (0, $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe) in backendState[0, $8Bc5A.KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, $8Bc5A.KEY_JSW_ONBOARDING][0, $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe];
            }
        }
        setState(updatedState);
        if (!(backendStateExists && (0, $8Bc5A.KEY_OPEN) in backendState)) try {
            const skipApplicationProperty = await (0, $6ypzr.getOnboardingSkipApplicationProperty)();
            if (skipApplicationProperty.quickstart) dispatch((0, $abQXL.nextSetChecklistIsDismissed)(true));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $52Vcw.fireAPIErrorAnalytics)(error, 'skipOnboarding');
        }
        setState({
            taskList: taskList
        });
        setState({
            isQuickstartLoaded: true
        });
    };

});

parcelRegister("dQPsy", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistItemSeen", () => $82a74350685dcd25$export$4eac017dcde0be8f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");
const $82a74350685dcd25$export$4eac017dcde0be8f = (taskId)=>({ getState: getState, setState: setState })=>{
        const hasSeenTaskId = (0, $8Bc5A.convertToHaveSeenItTask)(taskId);
        const { hasSeenTasks: hasSeenTasks } = getState();
        if (hasSeenTasks.includes(hasSeenTaskId)) return;
        setState({
            hasSeenTasks: [
                ...hasSeenTasks,
                hasSeenTaskId
            ]
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.convertToHaveSeenItTask)(taskId),
            value: true
        });
    };

});

parcelRegister("boV1S", function(module, exports) {

$parcel$export(module.exports, "nextAutoExpand", () => $35a410a5fb89f79b$export$3d24e97d30cfd09e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4R6GH = parcelRequire("4R6GH");

var $8Bc5A = parcelRequire("8Bc5A");

var $984bX = parcelRequire("984bX");

var $4ji4w = parcelRequire("4ji4w");

var $cUGWT = parcelRequire("cUGWT");
const $35a410a5fb89f79b$export$3d24e97d30cfd09e = ()=>({ getState: getState, dispatch: dispatch })=>{
        const hasNudgeToShowAfterNavigation = (0, $984bX.localStorageProvider)().get({
            accountId: (0, $8Bc5A.ACCOUNT_ID),
            key: (0, $8Bc5A.KEY_HAS_NAVIGATED_FROM_LINK)
        });
        if (hasNudgeToShowAfterNavigation) return;
        const { openTask: openTask, completedTaskList: completedTaskList, tasks: tasks, currentTriggerForTaskGroupParent: currentTriggerForTaskGroupParent } = getState();
        if (!tasks) return;
        const { items: items } = tasks;
        if (// @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        items.includes(openTask) && // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        !completedTaskList.includes(openTask)) return;
        const taskIdToExpand = (0, $4ji4w.getNextNonCompleteTask)(items, completedTaskList, openTask);
        if (taskIdToExpand === null) return;
        // If the openTask is the same as the currentTriggerForTaskGroupParent, we just returned back from a sub menu and don't need to auto open the next task
        if ((0, $4R6GH.fg)('jira_a11y_fix_returning_focus')) {
            if (openTask === currentTriggerForTaskGroupParent) return;
        }
        dispatch((0, $cUGWT.nextAutoOpenTask)(taskIdToExpand));
    };

});
parcelRegister("984bX", function(module, exports) {

$parcel$export(module.exports, "localStorageProvider", () => $a6d0a6873aa6f7aa$export$aa821bfb3308a1f5);
$parcel$export(module.exports, "setLocalStorageHasNavigatedFromLink", () => $a6d0a6873aa6f7aa$export$f2666fae743fa5f);

var $eNf8a = parcelRequire("eNf8a");

var $jcw0u = parcelRequire("jcw0u");

var $8Bc5A = parcelRequire("8Bc5A");
const $a6d0a6873aa6f7aa$var$DAYS_BEFORE_EXPIRY = 1;
const $a6d0a6873aa6f7aa$var$DAY = 86400000;
const $a6d0a6873aa6f7aa$var$getKey = ({ accountId: accountId, key: key })=>`${accountId}.${key}`;
const $a6d0a6873aa6f7aa$var$getExpiryTime = ()=>{
    const now = Date.now();
    return now + $a6d0a6873aa6f7aa$var$DAYS_BEFORE_EXPIRY * $a6d0a6873aa6f7aa$var$DAY;
};
let $a6d0a6873aa6f7aa$var$localStorage;
const $a6d0a6873aa6f7aa$export$aa821bfb3308a1f5 = ()=>{
    if ($a6d0a6873aa6f7aa$var$localStorage) return $a6d0a6873aa6f7aa$var$localStorage;
    const provider = (0, $eNf8a.createSessionExpirableStorageProvider)('jsw-onboarding-checklist');
    try {
        provider.removeExpiredKeys();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $jcw0u.default)({
            meta: {
                id: 'localStorageProviderKeyRemoval',
                packageName: 'jiraOnboardingQuickstartCore'
            },
            error: e
        });
    }
    const get = ({ accountId: accountId, key: key })=>provider.get($a6d0a6873aa6f7aa$var$getKey({
            accountId: accountId,
            key: key
        }));
    const set = ({ accountId: accountId, key: key, value: value })=>provider.set($a6d0a6873aa6f7aa$var$getKey({
            accountId: accountId,
            key: key
        }), value, $a6d0a6873aa6f7aa$var$getExpiryTime());
    const remove = ({ accountId: accountId, key: key })=>provider.remove($a6d0a6873aa6f7aa$var$getKey({
            accountId: accountId,
            key: key
        }));
    $a6d0a6873aa6f7aa$var$localStorage = {
        provider: provider,
        remove: remove,
        get: get,
        set: set
    };
    return $a6d0a6873aa6f7aa$var$localStorage;
};
const $a6d0a6873aa6f7aa$export$f2666fae743fa5f = (value)=>{
    $a6d0a6873aa6f7aa$export$aa821bfb3308a1f5().set({
        accountId: (0, $8Bc5A.ACCOUNT_ID),
        key: (0, $8Bc5A.KEY_HAS_NAVIGATED_FROM_LINK),
        value: value
    });
};

});


parcelRegister("4Viq4", function(module, exports) {

$parcel$export(module.exports, "nextShouldShowNudgeAfterNavigation", () => $0d74d0b8a43d2c5f$export$6f336ccb6432fcd0);
// Special case for nudges that need to show after a navigation.
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $984bX = parcelRequire("984bX");

var $lHcRB = parcelRequire("lHcRB");
const $0d74d0b8a43d2c5f$export$6f336ccb6432fcd0 = (taskId)=>({ dispatch: dispatch })=>{
        const nudgeToShowAfterNavigationKeyPair = {
            accountId: (0, $8Bc5A.ACCOUNT_ID),
            key: (0, $8Bc5A.KEY_HAS_NAVIGATED_FROM_LINK)
        };
        const shouldShowNudge = (0, $984bX.localStorageProvider)().get(nudgeToShowAfterNavigationKeyPair) === taskId;
        if (shouldShowNudge) {
            dispatch((0, $lHcRB.setHasNudgeActive)(true));
            (0, $984bX.localStorageProvider)().remove(nudgeToShowAfterNavigationKeyPair);
        }
    };

});

parcelRegister("jIoq4", function(module, exports) {

$parcel$export(module.exports, "nextGetTasks", () => $034f263b888956c9$export$15d877e1f3abf489);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $ikZFc = parcelRequire("ikZFc");
const $034f263b888956c9$export$15d877e1f3abf489 = (props)=>({ getState: getState, setState: setState })=>{
        const { taskList: taskList } = getState();
        const tasks = (0, $ikZFc.getAllTasks)({
            ...props,
            taskList: taskList
        });
        setState({
            tasks: tasks
        });
    };

});
parcelRegister("ikZFc", function(module, exports) {

$parcel$export(module.exports, "getAllTasks", () => $cb6c1b1dc7b1b225$export$d1f442602a91e7cc);

var $6s1PB = parcelRequire("6s1PB");

var $c04PQ = parcelRequire("c04PQ");

var $4R6GH = parcelRequire("4R6GH");


var $ldyPw = parcelRequire("ldyPw");

var $jtI3q = parcelRequire("jtI3q");

var $8Bc5A = parcelRequire("8Bc5A");

var $1ffS1 = parcelRequire("1ffS1");

var $ieqoN = parcelRequire("ieqoN");

var $3Iaiu = parcelRequire("3Iaiu");

var $aHo1U = parcelRequire("aHo1U");

var $5yUqp = parcelRequire("5yUqp");

var $5zzQl = parcelRequire("5zzQl");

var $jJca1 = parcelRequire("jJca1");

var $d7Knl = parcelRequire("d7Knl");

var $8VfDj = parcelRequire("8VfDj");

var $pDX5d = parcelRequire("pDX5d");
const $cb6c1b1dc7b1b225$var$getTaskListItem = ({ variants: variants, taskVariants: taskVariants, taskList: taskList, taskGroupParent: taskGroupParent })=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_rt_quickstart_m1');
    if (variants.includes((0, $aHo1U.JSW).experiment.jswReverseTrial) && !expConfig.get('isEnabled', false)) {
        const { title: title, items: items } = taskList[taskGroupParent === (0, $8Bc5A.ROOT_TASK) ? (0, $8Bc5A.REVERSE_TRIAL_ROOT_TASK) : taskGroupParent] ?? taskList[0, $8Bc5A.REVERSE_TRIAL_ROOT_TASK];
        return {
            title: title,
            items: (0, $5zzQl.getTasks)(variants, taskVariants, items)
        };
    }
    const { title: title, items: items } = taskList[taskGroupParent] ?? taskList[0, $8Bc5A.ROOT_TASK];
    return {
        title: title,
        items: (0, $5zzQl.getTasks)(variants, taskVariants, items)
    };
};
const $cb6c1b1dc7b1b225$var$createJswTasks = (projectState, taskGroupParent, routeName, shouldShowScrumOnboardingExperience, mountedNudges, canCreateProject, isEligibleToUpdateSitename, isCrossProjectBoardToPlanUpsell, isWizardSimplifyQS, canEditPlans, premiumTrialOnSignup)=>{
    const variants = new Set();
    const isTmpScrumWithSprintPermission = mountedNudges.includes((0, $8Bc5A.BACKLOG_CREATE_SPRINT_NUDGE_ID));
    const isEligibleForKanbanTour = mountedNudges.includes((0, $6784cbc7d62e5d7c$export$3366ddefe77d5112));
    if ((0, $c04PQ.isFedRamp)()) variants.add((0, $aHo1U.JSW).experience.fedRamp);
    if (premiumTrialOnSignup) {
        variants.add((0, $aHo1U.JSW).experiment.jswReverseTrial);
        (0, $6s1PB.expValEquals)('jira_rt_quickstart_m1', 'isEnabled', true) && variants.add((0, $aHo1U.JSW).experiment.rtQuickstartM1);
    }
    if (shouldShowScrumOnboardingExperience && isTmpScrumWithSprintPermission) variants.add((0, $aHo1U.JSW).experiment.scrumOnboarding);
    if (isCrossProjectBoardToPlanUpsell) variants.add((0, $aHo1U.JSW).trait.crossProjectBoardToPlanUpsell);
    if (canEditPlans) variants.add((0, $aHo1U.JSW).permissions.hasPlanEditPermissions);
    if (isEligibleForKanbanTour || routeName !== 'software-boards') variants.add((0, $aHo1U.JSW).experience.kanbanOnboarding);
    if (isWizardSimplifyQS) variants.add((0, $aHo1U.JSW).experiment.wizard);
    if (canCreateProject === false) variants.add((0, $aHo1U.JSW).permissions.notCanCreateProject);
    if (projectState?.isNextGen) variants.add((0, $aHo1U.JSW).projectStyle.teamManaged);
    else variants.add((0, $aHo1U.JSW).projectStyle.companyManaged);
    if (projectState?.isProjectAdmin) variants.add((0, $aHo1U.JSW).userRole.projectAdmin);
    if (projectState?.userRole === (0, $ieqoN.USER_ROLE).JIRA_ADMIN) {
        variants.add((0, $aHo1U.JSW).userRole.jiraAdmin);
        variants.add((0, $aHo1U.JSW).userRole.admin);
    }
    if (projectState?.userRole === (0, $ieqoN.USER_ROLE).SITE_ADMIN) {
        variants.add((0, $aHo1U.JSW).userRole.siteAdmin);
        variants.add((0, $aHo1U.JSW).userRole.admin);
    }
    if (projectState?.edition === (0, $ldyPw.FREE_EDITION)) variants.add((0, $aHo1U.JSW).edition.free);
    else if (projectState?.edition === (0, $ldyPw.STANDARD_EDITION)) variants.add((0, $aHo1U.JSW).edition.standard);
    else if (projectState?.edition === (0, $ldyPw.PREMIUM_EDITION)) variants.add((0, $aHo1U.JSW).edition.premium);
    if ((0, $1ffS1.isRoadmapRoute)(routeName)) variants.add((0, $aHo1U.JSW).route.softwareRoadmap);
    else if (routeName === 'software-backlog') variants.add((0, $aHo1U.JSW).route.softwareBacklog);
    else if (routeName === 'software-boards') variants.add((0, $aHo1U.JSW).route.softwareBoard);
    else if (routeName === 'software-list' || routeName === 'software-list-classic') variants.add((0, $aHo1U.JSW).route.softwareList);
    else if (routeName === 'project-settings-software-access') variants.add((0, $aHo1U.JSW).route.projectSettingsSoftwareAccess);
    else if (routeName === 'issue') variants.add((0, $aHo1U.JSW).route.issue);
    else if ((routeName === 'software-calendar' || routeName === 'software-calendar-classic') && (0, $4R6GH.fg)('software_calendar_quickstart_onboarding')) variants.add((0, $aHo1U.JSW).route.softwareCalendar);
    if (isEligibleToUpdateSitename) variants.add((0, $aHo1U.JSW).experiment.customizeSiteName);
    return $cb6c1b1dc7b1b225$var$getTaskListItem({
        variants: Array.from(variants.values()),
        taskVariants: (0, $aHo1U.JSW).taskVariants,
        taskList: (0, $aHo1U.JSW).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $cb6c1b1dc7b1b225$var$createJwmTasks = ({ projectState: projectState, taskGroupParent: taskGroupParent, taskList: taskList = (0, $5yUqp.JWM).taskList, teamType: teamType, isEligibleForTailoredOnboardingM2P5: isEligibleForTailoredOnboardingM2P5 })=>{
    const variants = [];
    variants.push((0, $5yUqp.JWM).experiments.projectTheming);
    if (isEligibleForTailoredOnboardingM2P5) return $cb6c1b1dc7b1b225$var$createTailoredOnboardingTasksM2P5({
        taskGroupParent: taskGroupParent,
        teamType: teamType
    });
    if (projectState?.isProjectAdmin) variants.push((0, $5yUqp.JWM).userRole.projectAdmin);
    if (projectState?.userRole === (0, $ieqoN.USER_ROLE).JIRA_ADMIN) variants.push((0, $5yUqp.JWM).userRole.jiraAdmin);
    if (projectState?.userRole === (0, $ieqoN.USER_ROLE).SITE_ADMIN) variants.push((0, $5yUqp.JWM).userRole.siteAdmin);
    if (projectState?.isSampleProject) variants.push((0, $5yUqp.JWM).experiments.isSampleProject);
    else variants.push((0, $5yUqp.JWM).experiments.isNotSampleProject);
    if (projectState?.isTrelloCrossflow) variants.push((0, $5yUqp.JWM).experiments.trelloCrossflow);
    return $cb6c1b1dc7b1b225$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $5yUqp.JWM).taskVariants,
        taskList: taskList,
        taskGroupParent: taskGroupParent
    });
};
const $cb6c1b1dc7b1b225$var$createJsmTasks = (projectState, taskGroupParent)=>{
    const variants = [];
    variants.push((0, $3Iaiu.JSM).experiments.projectTheming);
    if (projectState?.isProjectAdmin) variants.push((0, $3Iaiu.JSM).userRole.projectAdmin);
    if (projectState?.userRole === (0, $ieqoN.USER_ROLE).JIRA_ADMIN) variants.push((0, $3Iaiu.JSM).userRole.jiraAdmin);
    if (projectState?.userRole === (0, $ieqoN.USER_ROLE).SITE_ADMIN) variants.push((0, $3Iaiu.JSM).userRole.siteAdmin);
    return $cb6c1b1dc7b1b225$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $3Iaiu.JSM).taskVariants,
        taskList: (0, $3Iaiu.JSM).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $cb6c1b1dc7b1b225$export$d9d83c8e96505820 = (taskGroupParent, teamType, features, isEligibleForTailoredOnboardingM3, isEligibleForTailoredOnboardingScrumAndSoftwareKanban)=>{
    if ((0, $4R6GH.fg)('jira_tailored_onboarding_single_config')) {
        const variants = [];
        if (features?.hasBacklog) variants.push((0, $pDX5d.Feature).hasBacklog);
        if (features?.hasSprint) variants.push((0, $pDX5d.Feature).hasSprint);
        if (isEligibleForTailoredOnboardingM3) variants.push((0, $8VfDj.Experiment).tailoredOnboardingM3Eligible);
        if (isEligibleForTailoredOnboardingScrumAndSoftwareKanban) variants.push((0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible);
        if (teamType && (0, $jtI3q.isTailoredOnboardingWithScrumAndSoftwareKanbanTeamType)(teamType)) variants.push(`teamType.${teamType}`);
        else variants.push('teamType.everythingElse');
        return $cb6c1b1dc7b1b225$var$getTaskListItem({
            variants: variants,
            taskVariants: (0, $d7Knl.TAILORED_ONBOARDING_WITH_SINGLE_CONFIG).taskVariants,
            taskList: (0, $d7Knl.TAILORED_ONBOARDING_WITH_SINGLE_CONFIG).taskList,
            taskGroupParent: taskGroupParent
        });
    }
    // Following the same pattern as other configs and using an array here
    // but right now only one value(team type) will ever be in this array
    const variants = [];
    if (teamType && (0, $jtI3q.isTailoredOnboardingTailoredTeamType)(teamType)) variants.push(teamType);
    else variants.push('everythingElse');
    return $cb6c1b1dc7b1b225$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $d7Knl.TAILORED_ONBOARDING).getTaskVariants(teamType ?? 'everythingElse'),
        taskList: (0, $d7Knl.TAILORED_ONBOARDING).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $cb6c1b1dc7b1b225$var$createTailoredOnboardingTasksM2P5 = ({ taskGroupParent: taskGroupParent, teamType: teamType })=>{
    const variants = [];
    if (teamType && (0, $jtI3q.isTailoredOnboardingM2P5TailoredTeamType)(teamType)) variants.push(teamType);
    else variants.push('everythingElse');
    return $cb6c1b1dc7b1b225$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $d7Knl.TAILORED_ONBOARDING_M2P5).getM2P5TaskVariants(teamType ?? 'everythingElse'),
        taskList: (0, $d7Knl.TAILORED_ONBOARDING_M2P5).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $cb6c1b1dc7b1b225$export$d1f442602a91e7cc = ({ projectState: projectState, taskGroupParent: taskGroupParent, routeName: routeName, shouldShowScrumOnboardingExperience: shouldShowScrumOnboardingExperience, mountedNudges: mountedNudges, canCreateProject: canCreateProject, isEligibleToUpdateSitename: isEligibleToUpdateSitename, isCrossProjectBoardToPlanUpsell: isCrossProjectBoardToPlanUpsell, isWizardSimplifyQS: isWizardSimplifyQS = false, canEditPlans: canEditPlans, premiumTrialOnSignup: premiumTrialOnSignup, taskList: taskList, teamType: teamType, isEligibleForTailoredOnboardingM2P5: isEligibleForTailoredOnboardingM2P5, isEligibleForTailoredOnboardingM3: isEligibleForTailoredOnboardingM3, isEligibleForTailoredOnboardingScrumAndSoftwareKanban: isEligibleForTailoredOnboardingScrumAndSoftwareKanban, features: features })=>{
    if ((0, $jJca1.isJwmProject)(projectState)) return $cb6c1b1dc7b1b225$var$createJwmTasks({
        projectState: projectState,
        taskGroupParent: taskGroupParent,
        taskList: taskList,
        teamType: teamType,
        isEligibleForTailoredOnboardingM2P5: isEligibleForTailoredOnboardingM2P5
    });
    if ((0, $jJca1.isJsmProject)(projectState)) return $cb6c1b1dc7b1b225$var$createJsmTasks(projectState, taskGroupParent);
    // We cannot do these in the config itself as we need to fallback to createJswTasks for other users
    // And unlike previous QS experiments, we want to change the entire QS for these users so a new config makes sense over variants to the existing JSW one
    if (isEligibleForTailoredOnboardingM3 || isEligibleForTailoredOnboardingScrumAndSoftwareKanban) return $cb6c1b1dc7b1b225$export$d9d83c8e96505820(taskGroupParent, teamType, features, isEligibleForTailoredOnboardingM3, isEligibleForTailoredOnboardingScrumAndSoftwareKanban);
    return $cb6c1b1dc7b1b225$var$createJswTasks(projectState, taskGroupParent, routeName, shouldShowScrumOnboardingExperience, mountedNudges, canCreateProject, isEligibleToUpdateSitename, isCrossProjectBoardToPlanUpsell, isWizardSimplifyQS, canEditPlans, premiumTrialOnSignup);
};

});
parcelRegister("jtI3q", function(module, exports) {

$parcel$export(module.exports, "isTailoredOnboardingTailoredTeamType", () => $606262a699c9299e$export$8ea98ac9729b7e09);
$parcel$export(module.exports, "isTailoredOnboardingWithScrumAndSoftwareKanbanTeamType", () => $606262a699c9299e$export$a40edd97e5cbfaa9);
$parcel$export(module.exports, "isTailoredOnboardingM2P5TailoredTeamType", () => $606262a699c9299e$export$26c385918d734203);

var $370Ye = parcelRequire("370Ye");
const $606262a699c9299e$export$8ea98ac9729b7e09 = (teamType)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $370Ye.tailoredTeamTypes).includes(teamType);
};
const $606262a699c9299e$export$a40edd97e5cbfaa9 = (teamType)=>{
    return (0, $370Ye.tailoredTeamTypesWithSoftware).includes(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    teamType);
};
const $606262a699c9299e$export$26c385918d734203 = (teamType)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $370Ye.tailoredM2P5TeamTypes).includes(teamType);
};

});
parcelRegister("370Ye", function(module, exports) {

$parcel$export(module.exports, "tailoredTeamTypes", () => $06c84b7af2a23aee$export$a1fbb7d965e15a39);
$parcel$export(module.exports, "tailoredTeamTypesWithSoftware", () => $06c84b7af2a23aee$export$7e2d6cf3886ecaf7);
$parcel$export(module.exports, "tailoredM2P5TeamTypes", () => $06c84b7af2a23aee$export$52c5394d6e6cfcf3);

const $06c84b7af2a23aee$export$a1fbb7d965e15a39 = [
    (0, $6784cbc7d62e5d7c$export$e5c438b7501b5a24),
    (0, $6784cbc7d62e5d7c$export$d7de553940261eba),
    (0, $6784cbc7d62e5d7c$export$e4824f74b9879164),
    (0, $6784cbc7d62e5d7c$export$4f3cb0844009af52),
    (0, $6784cbc7d62e5d7c$export$cbc0e551d91a692d),
    (0, $6784cbc7d62e5d7c$export$4f54a09a24fd1d74),
    (0, $6784cbc7d62e5d7c$export$79685802e8ff1098)
];
const $06c84b7af2a23aee$export$7e2d6cf3886ecaf7 = [
    ...$06c84b7af2a23aee$export$a1fbb7d965e15a39,
    (0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b)
];
const $06c84b7af2a23aee$export$52c5394d6e6cfcf3 = [
    (0, $6784cbc7d62e5d7c$export$e5c438b7501b5a24),
    (0, $6784cbc7d62e5d7c$export$d7de553940261eba),
    (0, $6784cbc7d62e5d7c$export$cbc0e551d91a692d),
    (0, $6784cbc7d62e5d7c$export$4f54a09a24fd1d74),
    (0, $6784cbc7d62e5d7c$export$79685802e8ff1098),
    (0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b)
];

});


parcelRegister("1ffS1", function(module, exports) {

$parcel$export(module.exports, "isRoadmapRoute", () => $ee93e5dd18635f6d$export$d1fa67c1ffb68871);
const $ee93e5dd18635f6d$export$d1fa67c1ffb68871 = (routeName)=>{
    if (routeName === undefined) return false;
    return routeName === 'software-timeline' || routeName === 'software-timeline-classic';
};

});

parcelRegister("ieqoN", function(module, exports) {

$parcel$export(module.exports, "USER_ROLE", () => $353950c3dd35bbc6$export$8eeb199b23203523);
const $353950c3dd35bbc6$export$8eeb199b23203523 = {
    END_USER: 'end-user',
    SITE_ADMIN: 'site-admin',
    JIRA_ADMIN: 'jira-admin'
};

});

parcelRegister("3Iaiu", function(module, exports) {

$parcel$export(module.exports, "JSM", () => $56a077523ddf70fb$export$63f289f2da861d35);

var $58IQc = parcelRequire("58IQc");
const $56a077523ddf70fb$export$63f289f2da861d35 = {
    taskList: (0, $58IQc.JSM_TASK_LIST),
    taskVariants: (0, $58IQc.JSM_TASK_VARIANTS),
    userRole: (0, $58IQc.UserRole),
    experiments: (0, $58IQc.Experiments)
};

});
parcelRegister("58IQc", function(module, exports) {

$parcel$export(module.exports, "JSM_TASK_LIST", () => $3c13225c81ad4b5c$export$6c6c561944d49bcb);
$parcel$export(module.exports, "Experiments", () => $3c13225c81ad4b5c$export$c8d6ffd15214553a);
$parcel$export(module.exports, "UserRole", () => $3c13225c81ad4b5c$export$eb3485a690c2f0b8);
$parcel$export(module.exports, "JSM_TASK_VARIANTS", () => $3c13225c81ad4b5c$export$5b68aef408c932d9);

var $8Bc5A = parcelRequire("8Bc5A");

var $kTSRm = parcelRequire("kTSRm");
const $3c13225c81ad4b5c$export$6c6c561944d49bcb = Object.freeze({
    root: {
        title: (0, $kTSRm.messages).rootTitle,
        items: [
            (0, $8Bc5A.JSM_REVIEW_YOUR_CHANNELS_TASK),
            (0, $8Bc5A.JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK),
            (0, $8Bc5A.JSM_INVITE_YOUR_TEAM_TASK)
        ]
    }
});
const $3c13225c81ad4b5c$export$c8d6ffd15214553a = {
    projectTheming: 'projectTheming'
};
const $3c13225c81ad4b5c$export$eb3485a690c2f0b8 = {
    projectAdmin: 'projectAdmin',
    jiraAdmin: 'jiraAdmin',
    siteAdmin: 'siteAdmin'
};
const $3c13225c81ad4b5c$export$5b68aef408c932d9 = {
    [(0, $8Bc5A.JSM_REVIEW_YOUR_CHANNELS_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true
        }
    },
    [(0, $8Bc5A.JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK)]: {
        position: {
            default: 1
        },
        visibility: {
            default: true
        }
    },
    [(0, $8Bc5A.JSM_INVITE_YOUR_TEAM_TASK)]: {
        position: {
            default: 2
        },
        visibility: {
            default: true
        }
    }
};

});
parcelRegister("kTSRm", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f1f6142c4170f38e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f1f6142c4170f38e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jsm.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});



parcelRegister("aHo1U", function(module, exports) {

$parcel$export(module.exports, "JSW", () => $563027753d017a60$export$4cfe6e52f2e72a54);

var $8VfDj = parcelRequire("8VfDj");
const $563027753d017a60$export$4cfe6e52f2e72a54 = {
    taskList: (0, $8VfDj.TASK_LIST),
    taskVariants: (0, $8VfDj.TASK_VARIANTS),
    experiment: (0, $8VfDj.Experiment),
    experience: (0, $8VfDj.Experience),
    projectStyle: (0, $8VfDj.ProjectStyle),
    userRole: (0, $8VfDj.UserRole),
    edition: (0, $8VfDj.Edition),
    route: (0, $8VfDj.Route),
    permissions: (0, $8VfDj.Permissions),
    trait: (0, $8VfDj.Trait)
};

});
parcelRegister("8VfDj", function(module, exports) {

$parcel$export(module.exports, "Experiment", () => $ea3903bb15047c3b$export$4e0ab25c8a7e4009);
$parcel$export(module.exports, "Experience", () => $ea3903bb15047c3b$export$c90b54e658fc4d7c);
$parcel$export(module.exports, "ProjectStyle", () => $ea3903bb15047c3b$export$1f66f9f05afa05a8);
$parcel$export(module.exports, "UserRole", () => $ea3903bb15047c3b$export$eb3485a690c2f0b8);
$parcel$export(module.exports, "Edition", () => $ea3903bb15047c3b$export$6f4a0f769e61929);
$parcel$export(module.exports, "Route", () => $ea3903bb15047c3b$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Permissions", () => $ea3903bb15047c3b$export$2d41982586bbb6be);
$parcel$export(module.exports, "Trait", () => $ea3903bb15047c3b$export$2d08cfa40d69142e);
$parcel$export(module.exports, "TASK_LIST", () => $ea3903bb15047c3b$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "TASK_VARIANTS", () => $ea3903bb15047c3b$export$36f4d47dfe11b613);

var $8Bc5A = parcelRequire("8Bc5A");

var $ciLFO = parcelRequire("ciLFO");
const $ea3903bb15047c3b$export$4e0ab25c8a7e4009 = {
    scrumOnboarding: 'experiment.scrumOnboarding',
    customizeSiteName: 'experiment.customizeSiteName',
    jswReverseTrial: 'experiment.jswReverseTrial',
    rtQuickstartM1: 'experiment.rtQuickstartM1',
    wizard: 'experiment.wizard',
    tailoredOnboardingM3Eligible: 'experiment.tailoredOnboardingM3Eligible',
    tailoredOnboardingScrumAndSoftwareKanbanEligible: 'experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible'
};
const $ea3903bb15047c3b$export$c90b54e658fc4d7c = {
    kanbanOnboarding: 'experience.kanbanOnboarding',
    fedRamp: 'experience.fedRamp'
};
const $ea3903bb15047c3b$export$1f66f9f05afa05a8 = {
    teamManaged: 'projectStyle.teamManaged',
    companyManaged: 'projectStyle.companyManaged'
};
const $ea3903bb15047c3b$export$eb3485a690c2f0b8 = {
    siteAdmin: 'userRole.siteAdmin',
    jiraAdmin: 'userRole.jiraAdmin',
    admin: 'userRole.admin',
    projectAdmin: 'userRole.projectAdmin'
};
const $ea3903bb15047c3b$export$6f4a0f769e61929 = {
    free: 'productEdition.free',
    standard: 'productEdition.standard',
    premium: 'productEdition.premium'
};
const $ea3903bb15047c3b$export$e7b0ac011bb776c6 = {
    softwareRoadmap: 'route.softwareRoadmap',
    softwareBacklog: 'route.softwareBacklog',
    softwareBoard: 'route.softwareBoard',
    softwareList: 'route.softwareList',
    projectSettingsSoftwareAccess: 'route.projectSettingsSoftwareAccess',
    issue: 'route.issue',
    softwareCalendar: 'route.softwareCalendar'
};
const $ea3903bb15047c3b$export$2d41982586bbb6be = {
    notCanCreateProject: 'permissions.notCanCreateProject',
    hasPlanEditPermissions: 'permissions.hasPlanEditPermissions'
};
const $ea3903bb15047c3b$export$2d08cfa40d69142e = {
    crossProjectBoardToPlanUpsell: 'trait.crossProjectBoardToPlanUpsell'
};
const $ea3903bb15047c3b$var$DEFAULT_TASK_LIST = [
    (0, $8Bc5A.ADD_COLUMNS_TASK),
    (0, $8Bc5A.CREATE_PROJECT_TASK),
    (0, $8Bc5A.CREATE_ISSUE_TASK),
    (0, $8Bc5A.CREATE_ISSUE_TASK_SIMPLIFIED),
    (0, $8Bc5A.TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK),
    (0, $8Bc5A.INVITE_TEAMMATES_TASK),
    (0, $8Bc5A.INVITE_TEAMMATES_VIDEO_TASK),
    (0, $8Bc5A.CAPTURE_INTEGRATIONS_TASK),
    (0, $8Bc5A.FIND_HELP_TASK),
    (0, $8Bc5A.SET_UP_BOARD_TASK),
    (0, $8Bc5A.GET_MOBILE_APP_TASK),
    (0, $8Bc5A.PREMIUM_REVERSE_TRIAL_TASK),
    (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK),
    (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN),
    (0, $8Bc5A.STANDARD_EDITION_OVERVIEW_TASK),
    (0, $8Bc5A.MAP_OUT_YOUR_PROJECT_GOALS_TASK),
    (0, $8Bc5A.IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK),
    (0, $8Bc5A.MONITOR_MANAGE_RISK_TASK),
    (0, $8Bc5A.SCRUM_ONBOARDING_TASK),
    (0, $8Bc5A.CUSTOMIZE_SITE_NAME_TASK),
    (0, $8Bc5A.CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK),
    (0, $8Bc5A.GET_STARTED_LIST_TASK),
    (0, $8Bc5A.CALENDAR_VIEW_TASK)
];
const $ea3903bb15047c3b$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $ciLFO.messages).rootTitle,
        items: $ea3903bb15047c3b$var$DEFAULT_TASK_LIST
    },
    reverseTrialRoot: {
        title: (0, $ciLFO.messages).reverseTrialRootTitle,
        items: $ea3903bb15047c3b$var$DEFAULT_TASK_LIST
    },
    [(0, $8Bc5A.PREMIUM_REVERSE_TRIAL_TASK)]: {
        title: (0, $ciLFO.messages).reverseTrialCardTitle,
        items: [
            (0, $8Bc5A.ADVANCED_ROADMAPS_TASK),
            (0, $8Bc5A.CHANGE_CONTROL_TASK),
            (0, $8Bc5A.AUTOMATIONS_TASK),
            (0, $8Bc5A.SITE_ADMINISTRATIONS_TASK),
            (0, $8Bc5A.USER_MANAGEMENT_TASK)
        ]
    },
    [(0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK)]: {
        title: (0, $ciLFO.messages).premiumPlanTitle,
        items: [
            (0, $8Bc5A.ADVANCED_ROADMAPS_TASK),
            (0, $8Bc5A.CHANGE_CONTROL_TASK),
            (0, $8Bc5A.AUTOMATIONS_TASK),
            (0, $8Bc5A.SITE_ADMINISTRATIONS_TASK),
            (0, $8Bc5A.USER_MANAGEMENT_TASK)
        ]
    },
    [(0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)]: {
        title: (0, $ciLFO.messages).premiumPlanTitle,
        items: [
            (0, $8Bc5A.ADVANCED_ROADMAPS_TASK),
            (0, $8Bc5A.AUTOMATIONS_TASK)
        ]
    },
    [(0, $8Bc5A.STANDARD_EDITION_OVERVIEW_TASK)]: {
        title: (0, $ciLFO.messages).standardPlanTitle,
        items: [
            (0, $8Bc5A.AUTOMATIONS_TASK),
            (0, $8Bc5A.USER_MANAGEMENT_TASK),
            (0, $8Bc5A.SITE_ADMINISTRATIONS_TASK)
        ]
    }
});
const $ea3903bb15047c3b$var$PLAN_ONBOARDING_TASKS = {
    [(0, $8Bc5A.PREMIUM_REVERSE_TRIAL_TASK)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.rtQuickstartM1,
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    // This condition needs to be the opposite condition to PREMIUM_EDITION_OVERVIEW_TASK
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $ea3903bb15047c3b$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.STANDARD_EDITION_OVERVIEW_TASK)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.standard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.ADVANCED_ROADMAPS_TASK)]: {
        position: {
            default: 105
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $ea3903bb15047c3b$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.AUTOMATIONS_TASK)]: {
        position: {
            default: 110
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $ea3903bb15047c3b$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.standard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.USER_MANAGEMENT_TASK)]: {
        position: {
            default: 115
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.standard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.CHANGE_CONTROL_TASK)]: {
        position: {
            default: 120
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.SITE_ADMINISTRATIONS_TASK)]: {
        position: {
            default: 125
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.standard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};
const $ea3903bb15047c3b$export$36f4d47dfe11b613 = {
    ...$ea3903bb15047c3b$var$PLAN_ONBOARDING_TASKS,
    [(0, $8Bc5A.CREATE_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$2d41982586bbb6be.notCanCreateProject
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.CUSTOMIZE_SITE_NAME_TASK)]: {
        position: {
            default: 50
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin,
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.customizeSiteName
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.CALENDAR_VIEW_TASK)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    value: true,
                    condition: [
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareCalendar
                    ]
                }
            ]
        }
    },
    [(0, $8Bc5A.SCRUM_ONBOARDING_TASK)]: {
        position: {
            default: 150
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin,
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.scrumOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBacklog
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.MAP_OUT_YOUR_PROJECT_GOALS_TASK)]: {
        position: {
            default: 150
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK)]: {
        position: {
            default: 151
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.MONITOR_MANAGE_RISK_TASK)]: {
        position: {
            default: 152
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.SET_UP_BOARD_TASK)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.projectAdmin,
                        $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.CREATE_ISSUE_TASK)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.wizard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.CREATE_ISSUE_TASK_SIMPLIFIED)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.ADD_COLUMNS_TASK)]: {
        position: {
            default: 310
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.GET_STARTED_LIST_TASK)]: {
        position: {
            default: 320
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK)]: {
        position: {
            default: 350
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.wizard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.INVITE_TEAMMATES_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.projectAdmin,
                        $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.INVITE_TEAMMATES_VIDEO_TASK)]: {
        position: {
            default: 400,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: 600
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.projectAdmin,
                        $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.CAPTURE_INTEGRATIONS_TASK)]: {
        position: {
            default: 500
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.fedRamp
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.GET_MOBILE_APP_TASK)]: {
        position: {
            default: 600
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.wizard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.FIND_HELP_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.wizard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK)]: {
        position: {
            default: 800
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$2d41982586bbb6be.notCanCreateProject
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.wizard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                }
            ]
        }
    }
};

});
parcelRegister("ciLFO", function(module, exports) {

$parcel$export(module.exports, "messages", () => $609e253829546460$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $609e253829546460$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jsw.root-title.no-translate",
        "defaultMessage": "Quickstart"
    },
    premiumPlanTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.premium-plan-title",
        "defaultMessage": "Included in your Premium plan"
    },
    standardPlanTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.standard-plan-title",
        "defaultMessage": "Your Standard plan"
    },
    reverseTrialRootTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-root-title",
        "defaultMessage": "Your 30-day Premium trial"
    },
    reverseTrialCardTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-card-title",
        "defaultMessage": "Included in your Premium trial"
    }
});

});



parcelRegister("5yUqp", function(module, exports) {

$parcel$export(module.exports, "JWM", () => $80382801c7786de6$export$3ff26c80cb588e12);

var $82B5j = parcelRequire("82B5j");

var $8jC8d = parcelRequire("8jC8d");

var $5PFhq = parcelRequire("5PFhq");
const $80382801c7786de6$export$3ff26c80cb588e12 = {
    taskList: (0, $82B5j.TASK_LIST),
    taskVariants: (0, $82B5j.TASK_VARIANTS),
    userRole: (0, $5PFhq.UserRole),
    experiments: (0, $8jC8d.Experiments)
};

});
parcelRegister("82B5j", function(module, exports) {

$parcel$export(module.exports, "TASK_LIST", () => $3b1179694682c8c8$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "TASK_VARIANTS", () => $3b1179694682c8c8$export$36f4d47dfe11b613);

var $8Bc5A = parcelRequire("8Bc5A");

var $8jC8d = parcelRequire("8jC8d");

var $aQMWP = parcelRequire("aQMWP");

var $5PFhq = parcelRequire("5PFhq");
const $3b1179694682c8c8$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $aQMWP.messages).rootTitle,
        items: [
            (0, $8Bc5A.JWM_CREATE_PROJECT_TASK),
            (0, $8Bc5A.JWM_TRELLO_CROSSFLOW_TASK_IMPORT),
            (0, $8Bc5A.JWM_SUMMARY_AND_REPORTS_TASK),
            (0, $8Bc5A.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK),
            (0, $8Bc5A.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES),
            (0, $8Bc5A.JWM_CREATE_SAMPLE_PROJECT_TASK),
            (0, $8Bc5A.JWM_PROJECT_SUMMARY_TASK),
            (0, $8Bc5A.GET_STARTED_LIST_TASK),
            (0, $8Bc5A.JWM_CALENDAR_TASK),
            (0, $8Bc5A.JWM_TIMELINE_TASK),
            (0, $8Bc5A.JWM_BUILD_FORM_TASK),
            (0, $8Bc5A.JWM_BACKGROUND_COLOR_TASK),
            (0, $8Bc5A.JWM_FEEDBACK_TASK),
            (0, $8Bc5A.JWM_FEEDBACK_SAMPLE_PROJECT_TASK),
            (0, $8Bc5A.JWM_SHARE_PROJECT_TASK),
            (0, $8Bc5A.JWM_CREATE_YOUR_OWN_PROJECT_TASK)
        ]
    }
});
const $3b1179694682c8c8$var$OPS_TAILORED_ONBOARDING_TASK_VARIANTS = {
    [(0, $8Bc5A.OPS_JTBD_3_LIST)]: {
        position: {
            default: 100
        }
    },
    [(0, $8Bc5A.OPS_JTBD_3_CALENDAR)]: {
        position: {
            default: 200
        }
    },
    [(0, $8Bc5A.OPS_JTBD_3_PAGES)]: {
        position: {
            default: 300
        }
    },
    [(0, $8Bc5A.OPS_JTBD_4_LIST)]: {
        position: {
            default: 400
        }
    },
    [(0, $8Bc5A.OPS_JTBD_4_CALENDAR)]: {
        position: {
            default: 500
        }
    },
    [(0, $8Bc5A.OPS_JTBD_4_TIMELINE)]: {
        position: {
            default: 600
        }
    },
    [(0, $8Bc5A.OPS_JTBD_4_SUMMARY)]: {
        position: {
            default: 700
        }
    },
    [(0, $8Bc5A.OPS_JTBD_5_LIST)]: {
        position: {
            default: 800
        }
    },
    [(0, $8Bc5A.OPS_JTBD_5_TIMELINE)]: {
        position: {
            default: 900
        }
    },
    [(0, $8Bc5A.OPS_JTBD_5_PAGES)]: {
        position: {
            default: 1000
        }
    },
    [(0, $8Bc5A.OPS_JTBD_7_LIST)]: {
        position: {
            default: 1100
        }
    },
    [(0, $8Bc5A.OPS_JTBD_7_CALENDAR)]: {
        position: {
            default: 1200
        }
    },
    [(0, $8Bc5A.OPS_JTBD_2_BOARD)]: {
        position: {
            default: 1300
        }
    },
    [(0, $8Bc5A.OPS_JTBD_2_FORMS)]: {
        position: {
            default: 1400
        }
    },
    [(0, $8Bc5A.OPS_JTBD_2_SUMMARY)]: {
        position: {
            default: 1500
        }
    },
    [(0, $8Bc5A.OPS_JTBD_1_LIST)]: {
        position: {
            default: 1600
        }
    },
    [(0, $8Bc5A.OPS_JTBD_6_PAGES)]: {
        position: {
            default: 1700
        }
    },
    [(0, $8Bc5A.OPS_JTBD_0_LIST)]: {
        position: {
            default: 1800
        }
    },
    [(0, $8Bc5A.OPS_JTBD_0_TIMELINE)]: {
        position: {
            default: 1900
        }
    },
    [(0, $8Bc5A.OPS_JTBD_0_PAGES)]: {
        position: {
            default: 2000
        }
    },
    [(0, $8Bc5A.OPS_JTBD_DEFAULT_LIST)]: {
        position: {
            default: 2100
        }
    },
    [(0, $8Bc5A.OPS_JTBD_DEFAULT_BOARD)]: {
        position: {
            default: 2200
        }
    },
    [(0, $8Bc5A.OPS_JTBD_DEFAULT_INVITES)]: {
        position: {
            default: 2300
        }
    }
};
const $3b1179694682c8c8$var$MKT_TAILORED_ONBOARDING_TASK_VARIANTS = {
    [(0, $8Bc5A.MKT_JTBD_1_LIST)]: {
        position: {
            default: 100
        }
    },
    [(0, $8Bc5A.MKT_JTBD_1_CALENDAR)]: {
        position: {
            default: 200
        }
    },
    [(0, $8Bc5A.MKT_JTBD_1_TIMELINE)]: {
        position: {
            default: 300
        }
    },
    [(0, $8Bc5A.MKT_JTBD_2_CALENDAR)]: {
        position: {
            default: 400
        }
    },
    [(0, $8Bc5A.MKT_JTBD_2_PAGES)]: {
        position: {
            default: 500
        }
    },
    [(0, $8Bc5A.MKT_JTBD_3_PAGES)]: {
        position: {
            default: 600
        }
    },
    [(0, $8Bc5A.MKT_JTBD_3_TIMELINE)]: {
        position: {
            default: 700
        }
    },
    [(0, $8Bc5A.MKT_JTBD_4_LIST)]: {
        position: {
            default: 800
        }
    },
    [(0, $8Bc5A.MKT_JTBD_4_SUMMARY)]: {
        position: {
            default: 900
        }
    },
    [(0, $8Bc5A.MKT_JTBD_4_PAGES)]: {
        position: {
            default: 1000
        }
    },
    [(0, $8Bc5A.MKT_JTBD_5_TIMELINE)]: {
        position: {
            default: 1100
        }
    },
    [(0, $8Bc5A.MKT_JTBD_5_SUMMARY)]: {
        position: {
            default: 1200
        }
    },
    [(0, $8Bc5A.MKT_JTBD_6_FORMS)]: {
        position: {
            default: 1300
        }
    },
    [(0, $8Bc5A.MKT_JTBD_0_LIST)]: {
        position: {
            default: 1400
        }
    },
    [(0, $8Bc5A.MKT_JTBD_0_CALENDAR)]: {
        position: {
            default: 1500
        }
    },
    [(0, $8Bc5A.MKT_JTBD_0_TIMELINE)]: {
        position: {
            default: 1600
        }
    },
    [(0, $8Bc5A.MKT_JTBD_0_SUMMARY)]: {
        position: {
            default: 1700
        }
    },
    [(0, $8Bc5A.MKT_JTBD_DEFAULT_LIST)]: {
        position: {
            default: 1800
        }
    },
    [(0, $8Bc5A.MKT_JTBD_DEFAULT_BOARD)]: {
        position: {
            default: 1900
        }
    },
    [(0, $8Bc5A.MKT_JTBD_DEFAULT_PROJECT)]: {
        position: {
            default: 2000
        }
    },
    [(0, $8Bc5A.MKT_JTBD_DEFAULT_INVITES)]: {
        position: {
            default: 2100
        }
    }
};
const $3b1179694682c8c8$export$36f4d47dfe11b613 = {
    ...$3b1179694682c8c8$var$OPS_TAILORED_ONBOARDING_TASK_VARIANTS,
    ...$3b1179694682c8c8$var$MKT_TAILORED_ONBOARDING_TASK_VARIANTS,
    [(0, $8Bc5A.JWM_CREATE_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES)]: {
        position: {
            default: 15
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isNotSampleProject,
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_CREATE_SAMPLE_PROJECT_TASK)]: {
        position: {
            default: 40
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_PROJECT_SUMMARY_TASK)]: {
        position: {
            default: 50
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.GET_STARTED_LIST_TASK)]: {
        position: {
            default: 100
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_CALENDAR_TASK)]: {
        position: {
            default: 200
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_TIMELINE_TASK)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_BUILD_FORM_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: true
        }
    },
    [(0, $8Bc5A.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK)]: {
        position: {
            default: 425
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isNotSampleProject,
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_SUMMARY_AND_REPORTS_TASK)]: {
        position: {
            default: 450
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isNotSampleProject,
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_BACKGROUND_COLOR_TASK)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).projectTheming,
                        (0, $5PFhq.UserRole).jiraAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).projectTheming,
                        (0, $5PFhq.UserRole).siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).projectTheming,
                        (0, $5PFhq.UserRole).projectAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_SHARE_PROJECT_TASK)]: {
        position: {
            default: 600
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_TRELLO_CROSSFLOW_TASK_IMPORT)]: {
        position: {
            default: 650
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isNotSampleProject,
                        (0, $8jC8d.Experiments).trelloCrossflow,
                        (0, $5PFhq.UserRole).siteAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_FEEDBACK_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_FEEDBACK_SAMPLE_PROJECT_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_CREATE_YOUR_OWN_PROJECT_TASK)]: {
        position: {
            default: 800
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject,
                        (0, $5PFhq.UserRole).jiraAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject,
                        (0, $5PFhq.UserRole).siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject,
                        (0, $5PFhq.UserRole).projectAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};

});
parcelRegister("8jC8d", function(module, exports) {

$parcel$export(module.exports, "Experiments", () => $6cd173da51fb2ca8$export$c8d6ffd15214553a);
const $6cd173da51fb2ca8$export$c8d6ffd15214553a = {
    projectTheming: 'projectTheming',
    isSampleProject: 'isSampleProject',
    isNotSampleProject: 'isNotSampleProject',
    trelloCrossflow: 'trelloCrossflow'
};

});

parcelRegister("aQMWP", function(module, exports) {

$parcel$export(module.exports, "messages", () => $40755a70921f89dd$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $40755a70921f89dd$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jwm.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});

parcelRegister("5PFhq", function(module, exports) {

$parcel$export(module.exports, "UserRole", () => $637dacd99a3a1727$export$eb3485a690c2f0b8);
const $637dacd99a3a1727$export$eb3485a690c2f0b8 = {
    projectAdmin: 'projectAdmin',
    jiraAdmin: 'jiraAdmin',
    siteAdmin: 'siteAdmin'
};

});



parcelRegister("5zzQl", function(module, exports) {

$parcel$export(module.exports, "getTasks", () => $f17c108f7b3045ad$export$20b82b4a32771893);

var $fNtu3 = parcelRequire("fNtu3");
const $f17c108f7b3045ad$var$getTaskVisibility = (variants, visibility)=>visibility !== undefined ? (0, $fNtu3.getConditional)(visibility, variants) : true;
const $f17c108f7b3045ad$var$getTaskPosition = (variants, position)=>(0, $fNtu3.getConditional)(position, variants);
const $f17c108f7b3045ad$export$20b82b4a32771893 = (variants, taskVariants, taskList)=>taskList.filter((task)=>$f17c108f7b3045ad$var$getTaskVisibility(variants, taskVariants[task].visibility)).sort((taskA, taskB)=>$f17c108f7b3045ad$var$getTaskPosition(variants, taskVariants[taskA].position) - $f17c108f7b3045ad$var$getTaskPosition(variants, taskVariants[taskB].position));

});
parcelRegister("fNtu3", function(module, exports) {

$parcel$export(module.exports, "getConditional", () => $8978a3b25f57d9ac$export$fe3161cde0106bba);
const $8978a3b25f57d9ac$export$fe3161cde0106bba = ({ conditional: conditions, default: defaultValue }, variants)=>{
    if (conditions === undefined) return defaultValue;
    const variantsIncludesCondition = (c)=>variants.includes(c);
    const conditionObj = conditions.find(({ condition: condition })=>condition.every(variantsIncludesCondition));
    return conditionObj ? conditionObj.value : defaultValue;
};

});


parcelRegister("jJca1", function(module, exports) {

$parcel$export(module.exports, "isJwmProject", () => $6249819f9bc2846f$export$ea2e5a5c1a1a6748);
$parcel$export(module.exports, "isJsmProject", () => $6249819f9bc2846f$export$a972ed853ed1d469);

var $2vSU6 = parcelRequire("2vSU6");
const $6249819f9bc2846f$export$ea2e5a5c1a1a6748 = (projectState)=>projectState?.projectType === (0, $2vSU6.CORE_PROJECT);
const $6249819f9bc2846f$export$a972ed853ed1d469 = (projectState)=>projectState?.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);

});

parcelRegister("d7Knl", function(module, exports) {

$parcel$export(module.exports, "TAILORED_ONBOARDING", () => $98ba598c6688dfac$export$861e712b5b639c2a);
$parcel$export(module.exports, "TAILORED_ONBOARDING_WITH_SINGLE_CONFIG", () => $98ba598c6688dfac$export$83849aa73c0a20db);
$parcel$export(module.exports, "TAILORED_ONBOARDING_M2P5", () => $98ba598c6688dfac$export$eb17ad7838835d2a);


var $8Bc5A = parcelRequire("8Bc5A");

var $57ZKw = parcelRequire("57ZKw");

var $i2O9c = parcelRequire("i2O9c");

var $643hq = parcelRequire("643hq");

var $2Ld7w = parcelRequire("2Ld7w");

var $1bW8Q = parcelRequire("1bW8Q");

var $9mlnS = parcelRequire("9mlnS");

var $aRLWM = parcelRequire("aRLWM");

var $8oUbS = parcelRequire("8oUbS");

var $f4rKN = parcelRequire("f4rKN");

var $3YqPl = parcelRequire("3YqPl");

var $xk58e = parcelRequire("xk58e");
const $98ba598c6688dfac$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $57ZKw.messages).rootTitle,
        items: [
            (0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY),
            (0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR),
            (0, $8Bc5A.TAILORED_ONBOARDING_LIST),
            (0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE),
            (0, $8Bc5A.TAILORED_ONBOARDING_PAGES),
            (0, $8Bc5A.TAILORED_ONBOARDING_FORM),
            (0, $8Bc5A.TAILORED_ONBOARDING_INVITE),
            (0, $8Bc5A.TAILORED_ONBOARDING_BOARD)
        ]
    }
});
const $98ba598c6688dfac$export$36f4d47dfe11b613 = {
    ...(0, $643hq.PRODUCT_MANAGEMENT_VARIANTS),
    ...(0, $i2O9c.PROJECT_MANAGEMENT_VARIANTS),
    ...(0, $2Ld7w.DESIGN_VARIANTS),
    ...(0, $1bW8Q.IT_SUPPORT_VARIANTS),
    ...(0, $9mlnS.OTHER_PERSONAL_VARIANTS),
    ...(0, $aRLWM.MARKETING_VARIANTS),
    ...(0, $8oUbS.OPERATIONS_VARIANTS),
    ...(0, $f4rKN.EVERYTHING_ELSE_VARIANTS)
};
const $98ba598c6688dfac$var$getTaskVariants = (teamType)=>{
    switch(teamType){
        case 0, $6784cbc7d62e5d7c$export$4f54a09a24fd1d74:
            return 0, $643hq.PRODUCT_MANAGEMENT_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$79685802e8ff1098:
            return 0, $i2O9c.PROJECT_MANAGEMENT_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$e5c438b7501b5a24:
            return 0, $2Ld7w.DESIGN_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$d7de553940261eba:
            return 0, $1bW8Q.IT_SUPPORT_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$cbc0e551d91a692d:
            return 0, $9mlnS.OTHER_PERSONAL_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$e4824f74b9879164:
            return 0, $aRLWM.MARKETING_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$4f3cb0844009af52:
            return 0, $8oUbS.OPERATIONS_VARIANTS;
        default:
            return 0, $f4rKN.EVERYTHING_ELSE_VARIANTS;
    }
};
const $98ba598c6688dfac$export$861e712b5b639c2a = {
    taskList: $98ba598c6688dfac$export$601c8c0f45aeb0a0,
    getTaskVariants: $98ba598c6688dfac$var$getTaskVariants
};
const $98ba598c6688dfac$export$2757f7b23d120b9b = Object.freeze({
    root: {
        title: (0, $57ZKw.messages).rootTitle,
        items: [
            (0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY),
            (0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR),
            (0, $8Bc5A.TAILORED_ONBOARDING_LIST),
            (0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE),
            (0, $8Bc5A.TAILORED_ONBOARDING_PAGES),
            (0, $8Bc5A.TAILORED_ONBOARDING_FORM),
            (0, $8Bc5A.TAILORED_ONBOARDING_INVITE),
            (0, $8Bc5A.TAILORED_ONBOARDING_BOARD),
            (0, $8Bc5A.TAILORED_ONBOARDING_BACKLOG),
            (0, $8Bc5A.TAILORED_ONBOARDING_CODE)
        ]
    }
});
const $98ba598c6688dfac$export$83849aa73c0a20db = {
    taskList: $98ba598c6688dfac$export$2757f7b23d120b9b,
    taskVariants: (0, $xk58e.TAILORED_ONBOARDING_SINGLE_CONFIG)
};
const $98ba598c6688dfac$export$fd94bb9b6d992528 = Object.freeze({
    root: {
        title: (0, $57ZKw.messages).rootTitle,
        items: [
            (0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY),
            (0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR),
            (0, $8Bc5A.TAILORED_ONBOARDING_LIST),
            (0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE),
            (0, $8Bc5A.TAILORED_ONBOARDING_PAGES),
            (0, $8Bc5A.TAILORED_ONBOARDING_FORM),
            (0, $8Bc5A.TAILORED_ONBOARDING_INVITE),
            (0, $8Bc5A.TAILORED_ONBOARDING_BOARD)
        ]
    }
});
const $98ba598c6688dfac$export$be9c097e18825d4c = {
    ...(0, $643hq.PRODUCT_MANAGEMENT_VARIANTS),
    ...(0, $i2O9c.PROJECT_MANAGEMENT_VARIANTS),
    ...(0, $2Ld7w.DESIGN_VARIANTS),
    ...(0, $1bW8Q.IT_SUPPORT_VARIANTS),
    ...(0, $3YqPl.SOFTWARE_VARIANTS),
    ...(0, $9mlnS.OTHER_PERSONAL_VARIANTS),
    ...(0, $f4rKN.EVERYTHING_ELSE_VARIANTS)
};
const $98ba598c6688dfac$export$3c409334669aec75 = (teamType)=>{
    switch(teamType){
        case 0, $6784cbc7d62e5d7c$export$4f54a09a24fd1d74:
            return 0, $643hq.PRODUCT_MANAGEMENT_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$79685802e8ff1098:
            return 0, $i2O9c.PROJECT_MANAGEMENT_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$e5c438b7501b5a24:
            return 0, $2Ld7w.DESIGN_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$d7de553940261eba:
            return 0, $1bW8Q.IT_SUPPORT_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$cbc0e551d91a692d:
            return 0, $9mlnS.OTHER_PERSONAL_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b:
            return 0, $3YqPl.SOFTWARE_VARIANTS;
        default:
            return 0, $f4rKN.EVERYTHING_ELSE_VARIANTS;
    }
};
const $98ba598c6688dfac$export$eb17ad7838835d2a = {
    taskList: $98ba598c6688dfac$export$fd94bb9b6d992528,
    getM2P5TaskVariants: $98ba598c6688dfac$export$3c409334669aec75
};

});
parcelRegister("57ZKw", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b241f4df6ba82218$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $b241f4df6ba82218$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.tailored-onboarding.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});

parcelRegister("i2O9c", function(module, exports) {

$parcel$export(module.exports, "PROJECT_MANAGEMENT_VARIANTS", () => $c81c85368d94bebb$export$bdd338c80f8962df);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $c81c85368d94bebb$export$bdd338c80f8962df = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    }
};

});
parcelRegister("pDX5d", function(module, exports) {

$parcel$export(module.exports, "TeamType", () => $c47e1ea5de95ecc4$export$26bc40b960693765);
$parcel$export(module.exports, "TeamTypeWithPrefix", () => $c47e1ea5de95ecc4$export$668a7c1cbabc62a);
$parcel$export(module.exports, "Feature", () => $c47e1ea5de95ecc4$export$6e91cf7616333d5);

const $c47e1ea5de95ecc4$export$26bc40b960693765 = {
    productManagement: (0, $6784cbc7d62e5d7c$export$4f54a09a24fd1d74),
    projectManagement: (0, $6784cbc7d62e5d7c$export$79685802e8ff1098),
    design: (0, $6784cbc7d62e5d7c$export$e5c438b7501b5a24),
    itSupport: (0, $6784cbc7d62e5d7c$export$d7de553940261eba),
    otherPersonal: (0, $6784cbc7d62e5d7c$export$cbc0e551d91a692d),
    marketing: (0, $6784cbc7d62e5d7c$export$e4824f74b9879164),
    operations: (0, $6784cbc7d62e5d7c$export$4f3cb0844009af52),
    software: (0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b),
    // Fallback team type config used for team types we aren't catering for e.g. Data science
    // and also used if the team type is unexpected/unknown
    everythingElse: 'everythingElse'
};
const $c47e1ea5de95ecc4$export$668a7c1cbabc62a = {
    productManagement: `teamType.${(0, $6784cbc7d62e5d7c$export$4f54a09a24fd1d74)}`,
    projectManagement: `teamType.${(0, $6784cbc7d62e5d7c$export$79685802e8ff1098)}`,
    design: `teamType.${(0, $6784cbc7d62e5d7c$export$e5c438b7501b5a24)}`,
    itSupport: `teamType.${(0, $6784cbc7d62e5d7c$export$d7de553940261eba)}`,
    otherPersonal: `teamType.${(0, $6784cbc7d62e5d7c$export$cbc0e551d91a692d)}`,
    marketing: `teamType.${(0, $6784cbc7d62e5d7c$export$e4824f74b9879164)}`,
    operations: `teamType.${(0, $6784cbc7d62e5d7c$export$4f3cb0844009af52)}`,
    software: `teamType.${(0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b)}`,
    // Fallback team type config used for team types we aren't catering for e.g. Data science
    // and also used if the team type is unexpected/unknown
    everythingElse: 'teamType.everythingElse'
};
const $c47e1ea5de95ecc4$export$6e91cf7616333d5 = {
    hasBacklog: 'feature.hasBacklog',
    hasSprint: 'feature.hasSprint'
};

});


parcelRegister("643hq", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_MANAGEMENT_VARIANTS", () => $fed1dddbfb0b30cf$export$b07ea6a2d29f9c08);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $fed1dddbfb0b30cf$export$b07ea6a2d29f9c08 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("2Ld7w", function(module, exports) {

$parcel$export(module.exports, "DESIGN_VARIANTS", () => $d62d711ad5ddd92f$export$a3c4cd8e420f13a);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $d62d711ad5ddd92f$export$a3c4cd8e420f13a = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("1bW8Q", function(module, exports) {

$parcel$export(module.exports, "IT_SUPPORT_VARIANTS", () => $09c03dfb484f3e93$export$a25e809b52945082);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $09c03dfb484f3e93$export$a25e809b52945082 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("9mlnS", function(module, exports) {

$parcel$export(module.exports, "OTHER_PERSONAL_VARIANTS", () => $6398fc5437bfee58$export$916be3c140ae8c0);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $6398fc5437bfee58$export$916be3c140ae8c0 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("aRLWM", function(module, exports) {

$parcel$export(module.exports, "MARKETING_VARIANTS", () => $ca6dac271f81ec57$export$5580e2b7ba40f572);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $ca6dac271f81ec57$export$5580e2b7ba40f572 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("8oUbS", function(module, exports) {

$parcel$export(module.exports, "OPERATIONS_VARIANTS", () => $7ebba77bc28e7956$export$cd166ee66dc078f4);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $7ebba77bc28e7956$export$cd166ee66dc078f4 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 600
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("f4rKN", function(module, exports) {

$parcel$export(module.exports, "EVERYTHING_ELSE_VARIANTS", () => $dc653043c34d0d58$export$7a0daeb069f34de3);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $dc653043c34d0d58$export$7a0daeb069f34de3 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("3YqPl", function(module, exports) {

$parcel$export(module.exports, "SOFTWARE_VARIANTS", () => $136badd6870fea88$export$76a143792cc73994);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $136badd6870fea88$export$76a143792cc73994 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("xk58e", function(module, exports) {

$parcel$export(module.exports, "TAILORED_ONBOARDING_SINGLE_CONFIG", () => $70190108b7b6e00a$export$64855550cee11b78);

var $8Bc5A = parcelRequire("8Bc5A");

var $8VfDj = parcelRequire("8VfDj");

var $pDX5d = parcelRequire("pDX5d");
const $70190108b7b6e00a$export$64855550cee11b78 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 200,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 0,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamTypeWithPrefix).software,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).productManagement
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamTypeWithPrefix).software,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0,
            conditional: []
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BACKLOG)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).design
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: 100
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 300,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: 200
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamTypeWithPrefix).software,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CODE)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamTypeWithPrefix).software,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 300,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamTypeWithPrefix).software,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: 500
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 500,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).design
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 700
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software,
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible
                    ],
                    value: 700
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: true
                }
            ]
        }
    }
};

});




parcelRegister("75A1x", function(module, exports) {

$parcel$export(module.exports, "syncVisibilityWithLocal", () => $f9427b1514e1931c$export$4aab9a98fc53b894);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3B5jO = parcelRequire("3B5jO");

var $4ji4w = parcelRequire("4ji4w");
const $f9427b1514e1931c$export$4aab9a98fc53b894 = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3B5jO.getQuickstartTypeSelector)(state);
        const visibilityLocal = (0, $4ji4w.getLocalStorageItem)(`${quickstartType}.visibility`);
        if (visibilityLocal === state.visibility[quickstartType]) return;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: visibilityLocal
            }
        });
    };

});

parcelRegister("1Xkin", function(module, exports) {

$parcel$export(module.exports, "universalDispatch", () => $e706482dec5e8abf$export$efe980271ca9cc08);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $e706482dec5e8abf$export$efe980271ca9cc08 = ({ fn: fn })=>({ dispatch: dispatch })=>{
        dispatch(fn());
    };

});


parcelRegister("cGE52", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $d175a7a443e10f6d$export$d4c72bab9d6cc13a);

var $8Bc5A = parcelRequire("8Bc5A");
const $d175a7a443e10f6d$export$d4c72bab9d6cc13a = {
    shouldRenderComponent: false,
    completedTaskList: [],
    hasSeenTasks: [],
    isDismissed: true,
    isOpen: false,
    isFocusedOn: false,
    openTask: '',
    projectState: null,
    hasNudgeActive: false,
    isQuickstartLoaded: false,
    nudgeStep: '',
    mountedNudges: [],
    hasEverSeenRoute: {
        'jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap': false
    },
    roadmapIsCreateEnabled: false,
    roadmapIsListEmpty: true,
    previousTaskGroupParents: [],
    currentTaskGroupParent: (0, $8Bc5A.ROOT_TASK),
    currentTriggerForTaskGroupParent: '',
    selectedProjectTemplateKeyFromOnboarding: undefined,
    isEligibleToUpdateSitename: false,
    isCrossProjectBoardToPlanUpsell: false,
    canEditPlans: false,
    visibility: {
        [(0, $8Bc5A.QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY]: (0, $8Bc5A.QUICKSTART_UI_STATUS).NOT_LOADED,
        [(0, $8Bc5A.QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY]: (0, $8Bc5A.QUICKSTART_UI_STATUS).NOT_LOADED
    }
};

});


parcelRegister("a4k7n", function(module, exports) {

$parcel$export(module.exports, "NavigationAppsNavItemWrapperNudgeAsync", () => $86c9ba44b2aedf6e$export$c143067f544307f);

var $5uXOq = parcelRequire("5uXOq");


var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $86c9ba44b2aedf6e$var$NavigationAppsNavItemLazy = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("6rsRb")).then((exportedModule)=>exportedModule.NavigationAppsNavItemWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/navigation-apps/index.tsx"
});
const $86c9ba44b2aedf6e$export$c143067f544307f = ({ children: children, isInsideMenu: isInsideMenu })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $6784cbc7d62e5d7c$export$dd63d0099d95ba4f),
        fallback: children,
        attributes: {
            nudgeId: (0, $6784cbc7d62e5d7c$export$dd63d0099d95ba4f)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "navigation-apps-nav-item-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($86c9ba44b2aedf6e$var$NavigationAppsNavItemLazy, {
        nudgeId: (0, $6784cbc7d62e5d7c$export$dd63d0099d95ba4f),
        isInsideMenu: isInsideMenu
    }, children)));

});
parcelRegister("bBbEG", function(module, exports) {

$parcel$export(module.exports, "OnboardingNudgeErrorBoundary", () => $383be1d115a6551b$export$3915a8814b99f0b);

var $5uXOq = parcelRequire("5uXOq");

var $lkem5 = parcelRequire("lkem5");

var $8Bc5A = parcelRequire("8Bc5A");
const $383be1d115a6551b$export$3915a8814b99f0b = (props)=>{
    const { id: id, attributes: attributes, fallback: fallback, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lkem5.ErrorBoundaryWithChunkErrorLogging), {
        id: id,
        packageName: (0, $8Bc5A.PACKAGE_NAME),
        render: ()=>fallback,
        attributes: attributes
    }, children);
};

});
parcelRegister("lkem5", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundaryWithChunkErrorLogging", () => $3df8b034ebbd68e5$export$9171acf2e93b7d4d);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $30rnQ = parcelRequire("30rnQ");
const $3df8b034ebbd68e5$export$9171acf2e93b7d4d = (props)=>{
    const { attributes: attributes, children: children, ...rest } = props;
    const addErrorBoundaryAnalyticsAttributes = (0, $30rnQ.useAddErrorBoundaryAnalyticsAttributes)(attributes);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        ...rest,
        attributes: addErrorBoundaryAnalyticsAttributes
    }, children);
};

});
parcelRegister("30rnQ", function(module, exports) {

$parcel$export(module.exports, "addChunkLoadErrorAnalyticsAttribute", () => $53c68ff9a9edd0fe$export$94ee0b5fca1e74d2);
$parcel$export(module.exports, "useAddErrorBoundaryAnalyticsAttributes", () => $53c68ff9a9edd0fe$export$807be5f3f1ea996);

var $5uXOq = parcelRequire("5uXOq");

var $bCf8q = parcelRequire("bCf8q");
const $53c68ff9a9edd0fe$export$94ee0b5fca1e74d2 = (error)=>({
        chunkLoadError: (0, $bCf8q.isLoaderError)(error)
    });
const $53c68ff9a9edd0fe$export$807be5f3f1ea996 = (attributes = {})=>(0, $5uXOq.useCallback)((error)=>({
            ...attributes,
            ...$53c68ff9a9edd0fe$export$94ee0b5fca1e74d2(error)
        }), [
        attributes
    ]);

});



parcelRegister("6rsRb", function(module, exports) {

let $4b0ba60e07f8a2c3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4b0ba60e07f8a2c3$var$load("ffRiQ").then(()=>parcelRequire('3Hy6N'));

});


parcelRegister("heI7y", function(module, exports) {

$parcel$export(module.exports, "useHasOpened", () => $c02ba9c4f48115f2$export$cbaabcded53b5c1f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $h97QA = parcelRequire("h97QA");
const $c02ba9c4f48115f2$var$actions = {
    setHasOpened: $h97QA.setHasOpened
};
const $c02ba9c4f48115f2$var$initialState = {
    hasOpened: false
};
const $c02ba9c4f48115f2$var$Store = (0, $iXqE5.createStore)({
    initialState: $c02ba9c4f48115f2$var$initialState,
    actions: $c02ba9c4f48115f2$var$actions,
    name: 'jsw-onboarding-quickstart-has-opened'
});
const $c02ba9c4f48115f2$export$cbaabcded53b5c1f = (0, $3sQ5x.createHook)($c02ba9c4f48115f2$var$Store);

});
parcelRegister("h97QA", function(module, exports) {

$parcel$export(module.exports, "setHasOpened", () => $68011af9f70af395$export$c4743c64a7c42294);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $68011af9f70af395$export$c4743c64a7c42294 = ()=>({ getState: getState, setState: setState })=>{
        const { hasOpened: hasOpened } = getState();
        if (hasOpened === true) // if state has been updated already return
        return;
        setState({
            hasOpened: true
        });
    };
var $68011af9f70af395$export$2e2bcd8739ae039 = $68011af9f70af395$export$c4743c64a7c42294;

});





parcelRegister("67KAW", function(module, exports) {

$parcel$export(module.exports, "Nav4Assets", () => $ddf4be88098c0b0a$export$ae278c7655ee6005);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $7DxXA = parcelRequire("7DxXA");

var $ahEft = parcelRequire("ahEft");

var $j8qoE = parcelRequire("j8qoE");

var $9OXo1 = parcelRequire("9OXo1");

var $4R6GH = parcelRequire("4R6GH");

var $kT9FG = parcelRequire("kT9FG");

var $j054R = parcelRequire("j054R");
function $ddf4be88098c0b0a$export$ae278c7655ee6005({ isExpanded: isExpanded }) {
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    // useInsightVisibility can help fetch WorkspaceId
    const _ = (0, $7DxXA.useInsightVisibility)();
    const isPremiumUser = (0, $ahEft.isLicensedPremiumUser)(tenantContext);
    const { workspaceId: workspaceId } = (0, $7DxXA.useWorkspaceContext)();
    if (!isPremiumUser) {
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'cmdbUpsellPageButton viewed', {
            serviceDeskEdition: tenantContext.appEditions?.serviceDesk,
            isSiteAdmin: tenantContext.isSiteAdmin
        });
        if ((0, $4R6GH.fg)('assets_as_an_app_v2')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j054R.AssetsAppItem), {
            showUpsell: true
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kT9FG.AssetsSingleMenuItem), {
            showUpsellLozenge: true
        });
    }
    if ((0, $4R6GH.fg)('assets_as_an_app_v2')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j054R.AssetsAppItem), {
        showUpsell: false
    });
    return workspaceId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8qoE.InsightGlobalConfigContainer), {
        isGlobal: true,
        workspaceId: workspaceId,
        createAnalyticsEvent: createAnalyticsEvent,
        disableOnInit: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kT9FG.AssetsMenu), {
        isExpanded: isExpanded
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kT9FG.AssetsSingleMenuItem), {
        showUpsellLozenge: false
    });
}

});
parcelRegister("7DxXA", function(module, exports) {

$parcel$export(module.exports, "useWorkspaceContext", () => $5d7c6ac21f7af915$export$827d903316fc333c);
$parcel$export(module.exports, "useInsightVisibility", () => $5d7c6ac21f7af915$export$74ebc9a49f60d38a);

var $5uXOq = parcelRequire("5uXOq");

var $ktP1V = parcelRequire("ktP1V");

var $9OXo1 = parcelRequire("9OXo1");

var $2YP9W = parcelRequire("2YP9W");

var $ahEft = parcelRequire("ahEft");

var $gRzZD = parcelRequire("gRzZD");
const $5d7c6ac21f7af915$export$a0002067fa97246a = '/rest/servicedesk/cmdb/latest/workspace';
const $5d7c6ac21f7af915$export$122fccf0bbbc9acc = 30000;
const $5d7c6ac21f7af915$export$827d903316fc333c = ()=>{
    const { data: data, loading: loading, error: error, refresh: fetchWorkspaceId } = (0, $2YP9W.useResource)((0, $gRzZD.workspaceResource));
    const workspaceId = data ?? undefined;
    return {
        loading: loading,
        error: // @ts-expect-error - TS2322 - Type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to type 'Error | null | undefined'.
        error,
        workspaceId: workspaceId,
        fetchWorkspaceId: fetchWorkspaceId
    };
};
// https://overreacted.io/making-setinterval-declarative-with-react-hooks/
const $5d7c6ac21f7af915$var$useInterval = (callback, delay)=>{
    const savedCallback = (0, $5uXOq.useRef)(callback);
    // Remember the latest callback.
    (0, $5uXOq.useEffect)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    // Set up the interval.
    (0, $5uXOq.useEffect)(()=>{
        const tick = ()=>{
            savedCallback.current();
        };
        if (delay !== null) {
            const id = setInterval(tick, delay);
            return ()=>clearInterval(id);
        }
        return undefined;
    }, [
        delay
    ]);
};
const $5d7c6ac21f7af915$export$74ebc9a49f60d38a = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { workspaceId: workspaceId, fetchWorkspaceId: fetchWorkspaceId, loading: loading } = $5d7c6ac21f7af915$export$827d903316fc333c();
    // Optimistically set this true if user is premium and CMDB is enabled in environment - which will prevent a flash for the majority of users
    const [isVisible, setIsVisible] = (0, $5uXOq.useState)((0, $ktP1V.isCMDBEnabledInEnvironment)(tenantContext.cmdbDisabledInFedRAMP) && (0, $ahEft.isLicensedPremiumUser)(tenantContext));
    const [shouldPollForWorkspaceId, setShouldPollForWorkspaceId] = (0, $5uXOq.useState)(false);
    const [hasFetchedWorkspaceId, setHasFetchedWorkspaceId] = (0, $5uXOq.useState)(false);
    // Can't test this component without a rerender on each poll — so am just increment a counter with each poll
    const [, setPollCount] = (0, $5uXOq.useState)(0);
    // Run an initial fetch of the workspaceId if the resource wasn't already fetched as
    // part of the route definition (like for the Insight menu in the global nav)
    (0, $5uXOq.useEffect)(()=>{
        if (!hasFetchedWorkspaceId && !workspaceId && (0, $ahEft.isLicensedPremiumUser)(tenantContext) && (0, $ktP1V.isCMDBEnabledInEnvironment)(tenantContext.cmdbDisabledInFedRAMP)) {
            fetchWorkspaceId();
            setHasFetchedWorkspaceId(true);
        }
    }, [
        fetchWorkspaceId,
        hasFetchedWorkspaceId,
        tenantContext,
        workspaceId
    ]);
    // Starts/stops the polling of workspaceId
    $5d7c6ac21f7af915$var$useInterval(()=>{
        fetchWorkspaceId();
        setPollCount((a)=>a + 1);
    }, shouldPollForWorkspaceId ? $5d7c6ac21f7af915$export$122fccf0bbbc9acc : null);
    // Main check to see if insight should be visible
    // If user has premium subscription but no workspace ID, we begin polling for the
    // workspace ID as it means their Insight instance hasn’t completed provisioning yet
    (0, $5uXOq.useEffect)(()=>{
        if (hasFetchedWorkspaceId && !loading) {
            if ((0, $ahEft.isLicensedPremiumUser)(tenantContext)) {
                if (workspaceId !== undefined) {
                    setIsVisible(true);
                    setShouldPollForWorkspaceId(false);
                } else {
                    setIsVisible(false);
                    setShouldPollForWorkspaceId(true);
                }
            } else {
                setIsVisible(false);
                setShouldPollForWorkspaceId(false);
            }
        }
    }, [
        tenantContext,
        workspaceId,
        loading,
        hasFetchedWorkspaceId
    ]);
    return isVisible;
};

});

parcelRegister("j8qoE", function(module, exports) {

$parcel$export(module.exports, "useInsightGlobalConfig", () => $39a17ba3a31a7663$export$ee996472bb397b41);
$parcel$export(module.exports, "useInsightReferenceTypes", () => $39a17ba3a31a7663$export$efb93af726a65b26);
$parcel$export(module.exports, "useInsightStatusTypes", () => $39a17ba3a31a7663$export$7eefa9cea32e596a);
$parcel$export(module.exports, "useInsightIcons", () => $39a17ba3a31a7663$export$8336b36336c9f3c8);
$parcel$export(module.exports, "useDataManager", () => $39a17ba3a31a7663$export$143bcc72da01e561);
$parcel$export(module.exports, "useNamedInsightIcons", () => $39a17ba3a31a7663$export$979b264266dab4ed);
$parcel$export(module.exports, "useIsRestrictedSchema", () => $39a17ba3a31a7663$export$d07372ba961b2bc5);
$parcel$export(module.exports, "InsightGlobalConfigContainer", () => $39a17ba3a31a7663$export$c4c69c73d422ea06);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $4R6GH = parcelRequire("4R6GH");

var $5Jzjf = parcelRequire("5Jzjf");

var $3SYcN = parcelRequire("3SYcN");
const $39a17ba3a31a7663$export$d4c72bab9d6cc13a = {
    loading: false,
    error: undefined,
    config: undefined,
    referenceTypes: {
        data: undefined,
        createLoading: false,
        createError: undefined,
        deleteLoading: false,
        deleteError: undefined,
        updateLoading: false,
        updateError: undefined
    },
    statusTypes: {
        data: undefined,
        createLoading: false,
        createError: undefined,
        deleteLoading: false,
        deleteError: undefined,
        updateLoading: false,
        updateError: undefined
    },
    icons: {
        data: undefined,
        deleteLoading: false,
        deleteError: undefined,
        addLoading: false,
        addError: undefined,
        updateLoading: false,
        updateError: undefined
    },
    dataManager: {
        rolesData: undefined,
        rolesError: undefined,
        rolesLoading: false,
        rolesUpdateLoading: false,
        rolesUpdateError: undefined,
        tokensLoading: false,
        tokensData: undefined,
        tokensError: undefined,
        tokenRevokeLoading: false,
        tokenRevokeError: undefined,
        isProvisioned: undefined,
        provisioningLoading: false,
        provisioningError: undefined,
        provisioningUpdateLoading: false,
        provisioningUpdateError: undefined,
        myRoles: undefined,
        myRolesError: undefined,
        myRolesLoading: false
    }
};
const $39a17ba3a31a7663$var$Store = (0, $iXqE5.createStore)({
    initialState: $39a17ba3a31a7663$export$d4c72bab9d6cc13a,
    actions: $5Jzjf.actions
});
const $39a17ba3a31a7663$export$ee996472bb397b41 = (0, $3sQ5x.createHook)($39a17ba3a31a7663$var$Store, {
    selector: (state)=>state
});
const $39a17ba3a31a7663$export$efb93af726a65b26 = (0, $3sQ5x.createHook)($39a17ba3a31a7663$var$Store, {
    selector: ({ referenceTypes: referenceTypes })=>({
            ...referenceTypes,
            data: referenceTypes.data ? (0, $3SYcN.sortReferenceTypes)(referenceTypes.data) : undefined
        })
});
const $39a17ba3a31a7663$export$7eefa9cea32e596a = (0, $3sQ5x.createHook)($39a17ba3a31a7663$var$Store, {
    selector: ({ statusTypes: statusTypes })=>({
            ...statusTypes,
            data: statusTypes.data ? (0, $3SYcN.sortStatusTypes)(statusTypes.data) : undefined
        })
});
const $39a17ba3a31a7663$export$8336b36336c9f3c8 = (0, $3sQ5x.createHook)($39a17ba3a31a7663$var$Store, {
    selector: ({ icons: icons })=>icons
});
const $39a17ba3a31a7663$export$143bcc72da01e561 = (0, $3sQ5x.createHook)($39a17ba3a31a7663$var$Store, {
    selector: ({ dataManager: dataManager })=>dataManager
});
const $39a17ba3a31a7663$export$979b264266dab4ed = (0, $3sQ5x.createStateHook)($39a17ba3a31a7663$var$Store, {
    selector: ({ icons: icons })=>{
        const map = {};
        (icons.data ?? []).forEach((icon)=>{
            map[icon.name] = icon;
        });
        return map;
    }
});
const $39a17ba3a31a7663$export$9c8eee3abcaa634e = (state, schemaId)=>{
    const restrictedObjectSchemaIds = state.config?.restrictedObjectSchemaIds ?? [];
    return restrictedObjectSchemaIds.includes(parseInt(schemaId, 10));
};
const $39a17ba3a31a7663$export$d07372ba961b2bc5 = (0, $3sQ5x.createHook)($39a17ba3a31a7663$var$Store, {
    selector: $39a17ba3a31a7663$export$9c8eee3abcaa634e
});
const $39a17ba3a31a7663$var$autoFetchGlobalConfig = ()=>({ dispatch: dispatch, getState: getState }, { disableOnInit: disableOnInit })=>{
        const { loading: loading, error: error, config: config } = getState();
        if (!disableOnInit && !loading && !error && !config) {
            dispatch((0, $5Jzjf.actions).fetchGlobalConfig());
            if ((0, $4R6GH.fg)('assets_as_an_app_v2')) {
                dispatch((0, $5Jzjf.actions).fetchProvisioningStatus());
                dispatch((0, $5Jzjf.actions).fetchMyDataManagerRoles());
            }
        }
    };
const $39a17ba3a31a7663$export$c4c69c73d422ea06 = (0, $gg7kZ.createContainer)($39a17ba3a31a7663$var$Store, {
    onInit: $39a17ba3a31a7663$var$autoFetchGlobalConfig
});

});
parcelRegister("5Jzjf", function(module, exports) {

$parcel$export(module.exports, "actions", () => $f2ab8bdfc51ba92b$export$e324594224ef24da);

var $h3JSQ = parcelRequire("h3JSQ");

var $afOgx = parcelRequire("afOgx");

var $dLfth = parcelRequire("dLfth");

var $irXYU = parcelRequire("irXYU");

var $jz1my = parcelRequire("jz1my");

var $3MY0W = parcelRequire("3MY0W");

var $3WfMh = parcelRequire("3WfMh");

var $eiTPs = parcelRequire("eiTPs");

var $8u5AZ = parcelRequire("8u5AZ");

var $5VTnO = parcelRequire("5VTnO");

var $axmNY = parcelRequire("axmNY");

var $j9kxm = parcelRequire("j9kxm");

var $yPoOn = parcelRequire("yPoOn");

var $akTZj = parcelRequire("akTZj");

var $czU2t = parcelRequire("czU2t");

var $lsHFw = parcelRequire("lsHFw");
const $f2ab8bdfc51ba92b$export$e324594224ef24da = {
    addIcon: $h3JSQ.addIcon,
    createReferenceType: $afOgx.createReferenceType,
    createStatusType: $dLfth.createStatusType,
    deleteIcon: $irXYU.deleteIcon,
    deleteReferenceType: $jz1my.deleteReferenceType,
    deleteStatusType: $3MY0W.deleteStatusType,
    fetchDataManagerTokens: $axmNY.fetchDataManagerTokens,
    fetchGlobalConfig: $3WfMh.fetchGlobalConfig,
    fetchMyDataManagerRoles: $eiTPs.fetchMyDataManagerRoles,
    fetchPrincipalsForRoles: $8u5AZ.fetchPrincipalsForRoles,
    fetchProvisioningStatus: $5VTnO.fetchProvisioningStatus,
    setIcon: $yPoOn.setIcon,
    setReferenceType: $czU2t.setReferenceType,
    setStatusType: $lsHFw.setStatusType,
    updateDataManagerRole: $j9kxm.updateDataManagerRole,
    updateIcon: $yPoOn.updateIcon,
    updateProvisioningStatus: $akTZj.updateProvisioningStatus,
    updateReferenceType: $czU2t.updateReferenceType,
    updateStatusType: $lsHFw.updateStatusType
};

});
parcelRegister("h3JSQ", function(module, exports) {

$parcel$export(module.exports, "addIcon", () => $8a6a0321f1a1ecf0$export$3488242433cbedb);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $5Ny9E = parcelRequire("5Ny9E");

var $gm5wx = parcelRequire("gm5wx");

var $lbRfL = parcelRequire("lbRfL");
const $8a6a0321f1a1ecf0$export$3488242433cbedb = (newIcon)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            icons: {
                ...state.icons,
                addLoading: true
            }
        });
        try {
            const uploadCredentials = await (0, $lbRfL.mediaInfoForUpload)((0, $5Ny9E.toWorkspaceId)(workspaceId));
            const uploadMediaResult = await (0, $lbRfL.mediaUploadFile)({
                mediaBaseUrl: (0, $gm5wx.toMediaBaseUrl)(uploadCredentials.mediaBaseUrl),
                collectionId: (0, $gm5wx.toCollectionId)(uploadCredentials.collectionId),
                fileName: (0, $gm5wx.toFileName)(newIcon.fileName),
                clientId: (0, $gm5wx.toMediaClientId)(uploadCredentials.clientId),
                mediaJwtToken: (0, $gm5wx.toMediaJwt)(uploadCredentials.mediaJwtToken),
                blob: newIcon.blob
            });
            const mediaInfoForPullingResult = await (0, $lbRfL.mediaInfoForPulling)((0, $5Ny9E.toWorkspaceId)(workspaceId), (0, $gm5wx.toMediaFileUuid)(uploadMediaResult.data.id));
            const pollMediaFileReady = ()=>{
                const getMediaFileStatus = ()=>(0, $lbRfL.mediaGetFileInfo)({
                        mediaBaseUrl: (0, $gm5wx.toMediaBaseUrl)(mediaInfoForPullingResult.mediaBaseUrl),
                        mediaFileUuid: (0, $gm5wx.toMediaFileUuid)(uploadMediaResult.data.id),
                        clientId: (0, $gm5wx.toMediaClientId)(uploadCredentials.clientId),
                        mediaJwtToken: (0, $gm5wx.toMediaJwt)(mediaInfoForPullingResult.mediaJwtToken)
                    });
                return new Promise((resolve, // eslint-disable-next-line @typescript-eslint/no-explicit-any
                reject)=>{
                    const poll = (attempt = 0)=>{
                        const statusPromise = getMediaFileStatus();
                        statusPromise.then((response)=>{
                            const status = response.data.processingStatus;
                            switch(status){
                                default:
                                case (0, $gm5wx.MEDIA_PROCESS_STATUS).PENDING:
                                case (0, $gm5wx.MEDIA_PROCESS_STATUS).RUNNING:
                                    return setTimeout(()=>{
                                        // 20 tries before throwing an error
                                        if (attempt > 20) return reject(new Error('Failed to add icon after 10 tries'));
                                        return poll(attempt + 1);
                                    }, 5000);
                                case (0, $gm5wx.MEDIA_PROCESS_STATUS).SUCCEEDED:
                                    // @ts-expect-error - TS2794 - Expected 1 arguments, but got 0. Did you forget to include 'void' in your type argument to 'Promise'?
                                    return resolve();
                                case (0, $gm5wx.MEDIA_PROCESS_STATUS).FAILED:
                                    return reject(new Error('Media services failed to process file!'));
                            }
                        }).catch((error)=>reject(new Error(error)));
                    };
                    poll();
                });
            };
            await pollMediaFileReady();
            const savedIconEntry = await (0, $lbRfL.publishNewIcon)((0, $5Ny9E.toWorkspaceId)(workspaceId), (0, $gm5wx.toIconName)(newIcon.iconName), (0, $gm5wx.toMediaFileUuid)(uploadMediaResult.data.id));
            // Make flow happy
            if (!Array.isArray(state.icons.data)) throw new Error('Invalid state! Icons data is not array!');
            const newIconsData = state.icons.data.slice(0);
            newIconsData.unshift(savedIconEntry);
            const newState = {
                ...state,
                icons: {
                    ...state.icons,
                    addLoading: false,
                    data: newIconsData
                }
            };
            setState(newState);
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'addIcon succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                icons: {
                    ...state.icons,
                    addLoading: false,
                    addError: error
                }
            });
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'addIcon',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'aurum'
                },
                error: error
            });
            throw error;
        }
    };

});
parcelRegister("gm5wx", function(module, exports) {

$parcel$export(module.exports, "MEDIA_PROCESS_STATUS", () => $1ed2f93c2402a594$export$a760cae7c12e7f51);
$parcel$export(module.exports, "toMediaBaseUrl", () => $1ed2f93c2402a594$export$342e5c2fdd47297c);
$parcel$export(module.exports, "toCollectionId", () => $1ed2f93c2402a594$export$59b8a2c37e183bf5);
$parcel$export(module.exports, "toIconName", () => $1ed2f93c2402a594$export$41540e96af228b1a);
$parcel$export(module.exports, "toFileName", () => $1ed2f93c2402a594$export$249aa0c12095aafd);
$parcel$export(module.exports, "toMediaJwt", () => $1ed2f93c2402a594$export$dce78fe68aa68f20);
$parcel$export(module.exports, "toMediaFileUuid", () => $1ed2f93c2402a594$export$79083a8ab294d28e);
$parcel$export(module.exports, "toMediaClientId", () => $1ed2f93c2402a594$export$b105972f97cb69fa);
const $1ed2f93c2402a594$export$a760cae7c12e7f51 = {
    SUCCEEDED: 'succeeded',
    FAILED: 'failed',
    PENDING: 'pending',
    RUNNING: 'running'
};
const $1ed2f93c2402a594$export$342e5c2fdd47297c = (url)=>url;
const $1ed2f93c2402a594$export$59b8a2c37e183bf5 = (uuid)=>uuid;
const $1ed2f93c2402a594$export$41540e96af228b1a = (iconName)=>iconName;
const $1ed2f93c2402a594$export$249aa0c12095aafd = (fileName)=>fileName;
const $1ed2f93c2402a594$export$9dd52a3c923cba73 = (mediaIssuer)=>mediaIssuer;
const $1ed2f93c2402a594$export$dce78fe68aa68f20 = (mediaIssuer)=>mediaIssuer;
const $1ed2f93c2402a594$export$79083a8ab294d28e = (mediaFileUuid)=>mediaFileUuid;
const $1ed2f93c2402a594$export$b105972f97cb69fa = (mediaClientId)=>mediaClientId;

});

parcelRegister("lbRfL", function(module, exports) {

$parcel$export(module.exports, "mediaInfoForUpload", () => $4a8bb82a4fdfb7bb$export$c7944179dc1cb15d);
$parcel$export(module.exports, "mediaUploadFile", () => $4a8bb82a4fdfb7bb$export$6fba374ded90c76b);
$parcel$export(module.exports, "mediaInfoForPulling", () => $4a8bb82a4fdfb7bb$export$4138ca7fa1c5dcbc);
$parcel$export(module.exports, "mediaGetFileInfo", () => $4a8bb82a4fdfb7bb$export$c607c6f99a3a53ca);
$parcel$export(module.exports, "publishNewIcon", () => $4a8bb82a4fdfb7bb$export$a7fc7d8db8ccf9da);

var $eusud = parcelRequire("eusud");

var $4VpwK = parcelRequire("4VpwK");

var $3jFL4 = parcelRequire("3jFL4");
const $4a8bb82a4fdfb7bb$export$336c36f125eba39c = ({ clientId: clientId, mediaJwtToken: mediaJwtToken })=>{
    return {
        'X-Client-Id': clientId,
        Authorization: `Bearer ${mediaJwtToken}`
    };
};
const $4a8bb82a4fdfb7bb$export$c7944179dc1cb15d = (workspaceId)=>(0, $4VpwK.performCmdbGetRequest)((0, $3jFL4.getCmdbIconTokenUploadingUrl)(workspaceId));
const $4a8bb82a4fdfb7bb$export$6fba374ded90c76b = ({ mediaBaseUrl: mediaBaseUrl, collectionId: collectionId, fileName: fileName, mediaJwtToken: mediaJwtToken, blob: blob, clientId: clientId })=>(0, $eusud.performPostRequest)(`${String(mediaBaseUrl)}/file/binary?collection=${String(collectionId)}&name=${String(fileName)}&deletable=true`, {
        headers: {
            ...$4a8bb82a4fdfb7bb$export$336c36f125eba39c({
                clientId: clientId,
                mediaJwtToken: mediaJwtToken
            }),
            'Content-Type': blob.type
        },
        body: blob
    });
const $4a8bb82a4fdfb7bb$export$4138ca7fa1c5dcbc = (workspaceId, fileUuid)=>(0, $4VpwK.performCmdbGetRequest)((0, $3jFL4.getCmdbIconTokenFetchingUrl)(workspaceId, fileUuid));
const $4a8bb82a4fdfb7bb$export$c607c6f99a3a53ca = ({ mediaBaseUrl: mediaBaseUrl, mediaFileUuid: mediaFileUuid, mediaJwtToken: mediaJwtToken, clientId: clientId })=>(0, $eusud.performGetRequest)(`${String(mediaBaseUrl)}/file/${String(mediaFileUuid)}`, {
        headers: $4a8bb82a4fdfb7bb$export$336c36f125eba39c({
            clientId: clientId,
            mediaJwtToken: mediaJwtToken
        })
    });
const $4a8bb82a4fdfb7bb$export$a7fc7d8db8ccf9da = (workspaceId, iconName, mediaFileUuid)=>(0, $4VpwK.performCmdbPostRequest)((0, $3jFL4.getCmdbIconCreateUrl)(workspaceId), {
        body: JSON.stringify({
            name: iconName,
            mediaFileUuid: mediaFileUuid
        })
    });

});
parcelRegister("3jFL4", function(module, exports) {

$parcel$export(module.exports, "getCmdbIconCreateUrl", () => $af0daf8901be8d29$export$4c6ff27b48881aba);
$parcel$export(module.exports, "getCmdbIconTokenFetchingUrl", () => $af0daf8901be8d29$export$39e83f10cc93fe99);
$parcel$export(module.exports, "getCmdbIconTokenUploadingUrl", () => $af0daf8901be8d29$export$7fdc9cd59a492763);
$parcel$export(module.exports, "getCmdbIconByIdUrl", () => $af0daf8901be8d29$export$b881a625e1bc4876);

var $klJ8b = parcelRequire("klJ8b");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/icon
 */ const $af0daf8901be8d29$var$getCmdbIconUrl = (workspaceId)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/icon`;
const $af0daf8901be8d29$export$4c6ff27b48881aba = (workspaceId)=>`${$af0daf8901be8d29$var$getCmdbIconUrl(workspaceId)}/create`;
const $af0daf8901be8d29$export$39e83f10cc93fe99 = (workspaceId, fileUuid)=>`${$af0daf8901be8d29$var$getCmdbIconUrl(workspaceId)}/token-for-fetching-icon/${fileUuid}`;
const $af0daf8901be8d29$export$7fdc9cd59a492763 = (workspaceId)=>`${$af0daf8901be8d29$var$getCmdbIconUrl(workspaceId)}/token-for-uploading-icon`;
const $af0daf8901be8d29$export$b881a625e1bc4876 = (workspaceId, iconId)=>`${$af0daf8901be8d29$var$getCmdbIconUrl(workspaceId)}/${iconId}`;

});



parcelRegister("afOgx", function(module, exports) {

$parcel$export(module.exports, "createReferenceType", () => $e882d4e4e4fabf3c$export$ac28770630794807);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $Zsxbh = parcelRequire("Zsxbh");
const $e882d4e4e4fabf3c$export$ac28770630794807 = (data)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            referenceTypes: {
                ...state.referenceTypes,
                createLoading: true
            }
        });
        try {
            const response = await (0, $4VpwK.performCmdbPostRequest)((0, $Zsxbh.getCmdbConfigReferenceTypeUrl)(workspaceId), {
                body: JSON.stringify({
                    ...data,
                    color: data.color.replace('#', '')
                })
            });
            setState({
                ...state,
                referenceTypes: {
                    ...state.referenceTypes,
                    createLoading: false,
                    data: [
                        ...state.referenceTypes.data ?? [],
                        response
                    ]
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'createReferenceType succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                referenceTypes: {
                    ...state.referenceTypes,
                    createLoading: false,
                    createError: error
                }
            });
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'createReferenceType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'aurum'
                },
                error: error
            });
            throw error;
        }
    };

});
parcelRegister("Zsxbh", function(module, exports) {

$parcel$export(module.exports, "getCmdbConfigStatusTypeUrl", () => $72391202dbecf10a$export$3269d36b59c9d27f);
$parcel$export(module.exports, "getCmdbConfigStatusTypeByIdUrl", () => $72391202dbecf10a$export$229964acb6a55e5);
$parcel$export(module.exports, "getCmdbConfigStatusTypePickerUrl", () => $72391202dbecf10a$export$1991fb4d07b18469);
$parcel$export(module.exports, "getCmdbConfigReferenceTypeUrl", () => $72391202dbecf10a$export$ad07341c88d2bbab);
$parcel$export(module.exports, "getCmdbConfigReferenceTypeByIdUrl", () => $72391202dbecf10a$export$293e2bfa6752a2aa);
$parcel$export(module.exports, "getCmdbConfigRoleByIdUrl", () => $72391202dbecf10a$export$225d5f547cc90d86);
$parcel$export(module.exports, "getCmdbConfigRoleObjectSchemaByIdUrl", () => $72391202dbecf10a$export$9c1d73050da32aae);
$parcel$export(module.exports, "getCmdbConfigRoleObjectTypeByIdUrl", () => $72391202dbecf10a$export$6583ed007df50d2b);
$parcel$export(module.exports, "getCmdbPermsPrincipalUrl", () => $72391202dbecf10a$export$a635e2e9382b1621);
$parcel$export(module.exports, "getCmdbPermsRoleAssignmentUrl", () => $72391202dbecf10a$export$b3cb4590859563b0);
$parcel$export(module.exports, "getCmdbPermsTokenStatusUrl", () => $72391202dbecf10a$export$8ae00db5fd7218c5);
$parcel$export(module.exports, "getMyDataManagerRolesUrl", () => $72391202dbecf10a$export$794aa3ae46133f30);

var $ebyGx = parcelRequire("ebyGx");

var $klJ8b = parcelRequire("klJ8b");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/config
 */ const $72391202dbecf10a$var$getCmdbConfigUrl = (workspaceId)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/config`;
const $72391202dbecf10a$export$3269d36b59c9d27f = (workspaceId, queryParams)=>`${$72391202dbecf10a$var$getCmdbConfigUrl(workspaceId)}/statustype${queryParams ? `?${(0, $ebyGx.stringify)(queryParams)}` : ''}`;
const $72391202dbecf10a$export$229964acb6a55e5 = (workspaceId, statusTypeId)=>`${$72391202dbecf10a$var$getCmdbConfigUrl(workspaceId)}/statustype/${statusTypeId}`;
const $72391202dbecf10a$export$1991fb4d07b18469 = (workspaceId, queryParams)=>`${$72391202dbecf10a$var$getCmdbConfigUrl(workspaceId)}/statustype/picker?${(0, $ebyGx.stringify)(queryParams)}`;
const $72391202dbecf10a$export$ad07341c88d2bbab = (workspaceId, queryParams)=>`${$72391202dbecf10a$var$getCmdbConfigUrl(workspaceId)}/referencetype${queryParams ? `?${(0, $ebyGx.stringify)(queryParams)}` : ''}`;
const $72391202dbecf10a$export$293e2bfa6752a2aa = (workspaceId, referenceTypeId)=>`${$72391202dbecf10a$var$getCmdbConfigUrl(workspaceId)}/referencetype/${referenceTypeId}`;
const $72391202dbecf10a$export$225d5f547cc90d86 = (workspaceId, roleId)=>`${$72391202dbecf10a$var$getCmdbConfigUrl(workspaceId)}/role/${roleId}`;
const $72391202dbecf10a$export$9c1d73050da32aae = (workspaceId, objectSchemaId)=>`${$72391202dbecf10a$var$getCmdbConfigUrl(workspaceId)}/role/objectschema/${objectSchemaId}`;
const $72391202dbecf10a$export$6583ed007df50d2b = (workspaceId, objectTypeId)=>`${$72391202dbecf10a$var$getCmdbConfigUrl(workspaceId)}/role/objecttype/${objectTypeId}`;
const $72391202dbecf10a$export$a635e2e9382b1621 = (workspaceId)=>`${$72391202dbecf10a$var$getCmdbConfigUrl(workspaceId)}/perms/principal`;
const $72391202dbecf10a$export$b3cb4590859563b0 = (workspaceId)=>`${$72391202dbecf10a$var$getCmdbConfigUrl(workspaceId)}/perms/role-assignment`;
const $72391202dbecf10a$export$8ae00db5fd7218c5 = (workspaceId, token)=>`${$72391202dbecf10a$var$getCmdbConfigUrl(workspaceId)}/perms/token-status?token=${token}`;
const $72391202dbecf10a$export$794aa3ae46133f30 = (workspaceId)=>`${$72391202dbecf10a$var$getCmdbConfigUrl(workspaceId)}/perms/my-roles`;

});


parcelRegister("dLfth", function(module, exports) {

$parcel$export(module.exports, "createStatusType", () => $98b79b2a12298162$export$8c874b16a69a1b9d);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $Zsxbh = parcelRequire("Zsxbh");
const $98b79b2a12298162$export$8c874b16a69a1b9d = (data)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            statusTypes: {
                ...state.statusTypes,
                createLoading: true
            }
        });
        try {
            const response = await (0, $4VpwK.performCmdbPostRequest)((0, $Zsxbh.getCmdbConfigStatusTypeUrl)(workspaceId), {
                body: JSON.stringify(data)
            });
            setState({
                ...state,
                statusTypes: {
                    ...state.statusTypes,
                    createLoading: false,
                    data: [
                        ...state.statusTypes.data ?? [],
                        response
                    ]
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({
                source: 'insightGlobalConfigStatuses',
                action: 'created',
                actionSubject: 'insightGlobalConfigStatuses'
            }), 'insightGlobalConfigStatuses created');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                statusTypes: {
                    ...state.statusTypes,
                    createLoading: false,
                    createError: error
                }
            });
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'createStatusType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'aurum'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("irXYU", function(module, exports) {

$parcel$export(module.exports, "deleteIcon", () => $2669ccdf98bb7ce7$export$12d45ee5c2161b75);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $3jFL4 = parcelRequire("3jFL4");
const $2669ccdf98bb7ce7$export$12d45ee5c2161b75 = (icon)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            icons: {
                ...state.icons,
                deleteLoading: true
            }
        });
        try {
            await (0, $4VpwK.performCmdbDeleteRequest)((0, $3jFL4.getCmdbIconByIdUrl)(workspaceId, icon.id));
            setState({
                ...state,
                icons: {
                    ...state.icons,
                    deleteLoading: false,
                    data: state.icons.data ? state.icons.data.filter(({ id: id })=>id !== icon.id) : undefined
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'deleteIcon succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                icons: {
                    ...state.icons,
                    deleteLoading: false,
                    deleteError: error
                }
            });
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'deleteIcon',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'aurum'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("jz1my", function(module, exports) {

$parcel$export(module.exports, "deleteReferenceType", () => $a2a9cfda90a52e02$export$432ee1f3819316e5);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $Zsxbh = parcelRequire("Zsxbh");
const $a2a9cfda90a52e02$export$432ee1f3819316e5 = (referenceType)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            referenceTypes: {
                ...state.referenceTypes,
                deleteLoading: true
            }
        });
        try {
            await (0, $4VpwK.performCmdbDeleteRequest)((0, $Zsxbh.getCmdbConfigReferenceTypeByIdUrl)(workspaceId, referenceType.id));
            setState({
                ...state,
                referenceTypes: {
                    ...state.referenceTypes,
                    deleteLoading: false,
                    data: state.referenceTypes.data ? state.referenceTypes.data.filter(({ id: id })=>id !== referenceType.id) : undefined
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'deleteReferenceType succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                referenceTypes: {
                    ...state.referenceTypes,
                    deleteLoading: false,
                    deleteError: error
                }
            });
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'deleteReferenceType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'aurum'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("3MY0W", function(module, exports) {

$parcel$export(module.exports, "deleteStatusType", () => $b29c0bec337815ce$export$812423dc05f0fc3d);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $Zsxbh = parcelRequire("Zsxbh");
const $b29c0bec337815ce$export$812423dc05f0fc3d = (statusType)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            statusTypes: {
                ...state.statusTypes,
                deleteLoading: true
            }
        });
        try {
            await (0, $4VpwK.performCmdbDeleteRequest)((0, $Zsxbh.getCmdbConfigStatusTypeByIdUrl)(workspaceId, statusType.id));
            setState({
                ...state,
                statusTypes: {
                    ...state.statusTypes,
                    deleteLoading: false,
                    data: state.statusTypes.data ? state.statusTypes.data.filter(({ id: id })=>id !== statusType.id) : undefined
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'deleteStatusType succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                statusTypes: {
                    ...state.statusTypes,
                    deleteLoading: false,
                    deleteError: error
                }
            });
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'deleteStatusType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'aurum'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("3WfMh", function(module, exports) {

$parcel$export(module.exports, "fetchGlobalConfig", () => $032f1f2dd067f8fc$export$14c75ba3f0e48e21);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $juXmc = parcelRequire("juXmc");
const $032f1f2dd067f8fc$export$14c75ba3f0e48e21 = (shouldRefetch = true)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        if (getState().loading || !shouldRefetch && getState().config) return;
        setState({
            loading: true,
            error: undefined
        });
        try {
            const response = await (0, $4VpwK.performCmdbGetRequest)((0, $juXmc.getCmdbGlobalConfigUrl)(workspaceId));
            const iconListWithServiceOTEntriesRemoved = response ? response.icons.filter((item)=>item.name !== 'Applications' && item.name !== 'Business Services' && item.name !== 'Capabilities' && item.name !== 'Software Services') : undefined;
            setState({
                loading: false,
                config: {
                    ...response,
                    restrictedObjectSchemaIds: response?.restrictedObjectSchemaIds ?? [],
                    icons: iconListWithServiceOTEntriesRemoved || []
                },
                referenceTypes: {
                    ...getState().referenceTypes,
                    data: response ? response.referenceTypes : undefined
                },
                statusTypes: {
                    ...getState().statusTypes,
                    data: response ? response.statusTypes : undefined
                },
                icons: {
                    ...getState().icons,
                    data: iconListWithServiceOTEntriesRemoved
                },
                dataManager: {
                    ...getState().dataManager
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchInsightGlobalConfig succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                loading: false,
                error: error
            });
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'fetchInsightGlobalConfig',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'aurum'
                },
                error: error
            });
            throw error;
        }
    };

});
parcelRegister("juXmc", function(module, exports) {

$parcel$export(module.exports, "getCmdbGlobalConfigUrl", () => $d0e7aed8ea80c147$export$50437136a9a5e2d3);
$parcel$export(module.exports, "getCmdbGlobalConfigObjectUrl", () => $d0e7aed8ea80c147$export$73e58b72a1074528);
$parcel$export(module.exports, "getCmdbGlobalConfigObjectSchemaByIdUrl", () => $d0e7aed8ea80c147$export$e2019224257efde3);
$parcel$export(module.exports, "getCmdbGlobalConfigObjectSchemaByIdPropertyUrl", () => $d0e7aed8ea80c147$export$d1b25f8feb06db8a);

var $ebyGx = parcelRequire("ebyGx");

var $klJ8b = parcelRequire("klJ8b");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/global
 */ const $d0e7aed8ea80c147$var$getCmdbGlobalUrl = (workspaceId)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/global`;
const $d0e7aed8ea80c147$export$50437136a9a5e2d3 = (workspaceId)=>`${$d0e7aed8ea80c147$var$getCmdbGlobalUrl(workspaceId)}/config`;
const $d0e7aed8ea80c147$export$73e58b72a1074528 = (workspaceId, queryParams)=>`${$d0e7aed8ea80c147$var$getCmdbGlobalUrl(workspaceId)}/config/object?${(0, $ebyGx.stringify)(queryParams)}`;
const $d0e7aed8ea80c147$export$e2019224257efde3 = (workspaceId, objectSchemaId)=>`${$d0e7aed8ea80c147$var$getCmdbGlobalUrl(workspaceId)}/config/objectschema/${objectSchemaId}`;
const $d0e7aed8ea80c147$export$d1b25f8feb06db8a = (workspaceId, objectSchemaId)=>`${$d0e7aed8ea80c147$var$getCmdbGlobalUrl(workspaceId)}/config/objectschema/${objectSchemaId}/property`;

});


parcelRegister("eiTPs", function(module, exports) {

$parcel$export(module.exports, "fetchMyDataManagerRoles", () => $716ec7c261a3e8b3$export$2211f294ebd95b92);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $Zsxbh = parcelRequire("Zsxbh");
const $716ec7c261a3e8b3$export$2211f294ebd95b92 = (shouldRefetch = true)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        if (getState().dataManager.myRolesLoading || !shouldRefetch && getState().dataManager.myRoles) return;
        setState({
            dataManager: {
                ...getState().dataManager,
                myRolesLoading: true,
                myRolesError: undefined
            }
        });
        try {
            const myRoles = await (0, $4VpwK.performCmdbGetRequest)((0, $Zsxbh.getMyDataManagerRolesUrl)(workspaceId));
            setState({
                dataManager: {
                    ...getState().dataManager,
                    myRoles: myRoles.results,
                    myRolesLoading: false
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchMyDataManagerRoles succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                dataManager: {
                    ...getState().dataManager,
                    myRolesLoading: false,
                    myRolesError: error
                }
            });
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'fetchMyDataManagerRoles',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("8u5AZ", function(module, exports) {

$parcel$export(module.exports, "fetchPrincipalsForRoles", () => $3daa0c86c5959b28$export$9c5110cfdcb72b5);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $Zsxbh = parcelRequire("Zsxbh");
const $3daa0c86c5959b28$export$9c5110cfdcb72b5 = (roleIds)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        if (state.dataManager.rolesLoading) return;
        setState({
            ...state,
            dataManager: {
                ...state.dataManager,
                rolesLoading: true
            }
        });
        try {
            const requestBody = {
                roleIds: roleIds,
                resourceId: `ari:cloud:cmdb::workspace/${workspaceId}`
            };
            const principalIdsForRoles = await (0, $4VpwK.performCmdbPostRequest)((0, $Zsxbh.getCmdbPermsPrincipalUrl)(workspaceId), {
                body: JSON.stringify(requestBody)
            });
            setState({
                dataManager: {
                    ...state.dataManager,
                    rolesData: principalIdsForRoles.results,
                    rolesLoading: false
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchPrincipalsForRoles succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                dataManager: {
                    ...state.dataManager,
                    rolesLoading: false,
                    rolesError: error
                }
            });
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'fetchPrincipalsForRoles',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("5VTnO", function(module, exports) {

$parcel$export(module.exports, "fetchProvisioningStatus", () => $1d2259843f354494$export$aa3ea988cce42be1);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $8OEkP = parcelRequire("8OEkP");
const $1d2259843f354494$export$aa3ea988cce42be1 = (shouldRefetch = true)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        if (getState().dataManager.provisioningLoading || !shouldRefetch && // isProvisioned is a boolean so needs to specifically check undefined
        getState().dataManager.isProvisioned !== undefined) return;
        setState({
            dataManager: {
                ...getState().dataManager,
                provisioningLoading: true,
                provisioningError: undefined
            }
        });
        try {
            const result = await (0, $4VpwK.performCmdbGetRequest)((0, $8OEkP.getDataManagerProvisioningStatusUrl)(workspaceId));
            setState({
                dataManager: {
                    ...getState().dataManager,
                    isProvisioned: $1d2259843f354494$var$isProvisioned(result.enabled),
                    provisioningLoading: false
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchProvisioningStatus succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                dataManager: {
                    ...getState().dataManager,
                    provisioningLoading: false,
                    provisioningError: error
                }
            });
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'fetchProvisioningStatus',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                },
                error: error
            });
            throw error;
        }
    };
const $1d2259843f354494$var$isProvisioned = (status)=>status === 'ON';

});
parcelRegister("8OEkP", function(module, exports) {

$parcel$export(module.exports, "getDataManagerGenerateContainerTokenUrl", () => $5d534e44ee8c7958$export$5f42b4e80a66d7c);
$parcel$export(module.exports, "delDataManagerContainerTokenUrl", () => $5d534e44ee8c7958$export$ddc5a4cb751fae27);
$parcel$export(module.exports, "getDataManagerFetchContainerTokenUrl", () => $5d534e44ee8c7958$export$591d877d695dbd95);
$parcel$export(module.exports, "getDataManagerProvisioningStatusUrl", () => $5d534e44ee8c7958$export$1dd01c50c7948938);

var $klJ8b = parcelRequire("klJ8b");
const $5d534e44ee8c7958$export$5f42b4e80a66d7c = (workspaceId, label, type, duration)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/data-manager/token/${type}?label=${label}&duration=${duration}`;
const $5d534e44ee8c7958$export$ddc5a4cb751fae27 = (workspaceId, tokenID)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/data-manager/token/${tokenID}`;
const $5d534e44ee8c7958$export$591d877d695dbd95 = (workspaceId)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/data-manager/token`;
const $5d534e44ee8c7958$export$1dd01c50c7948938 = (workspaceId)=>`${$5d534e44ee8c7958$var$getAirtrackAppRestBaseUrl(workspaceId)}/config/sync/provisioningstatus`;
const $5d534e44ee8c7958$var$getAirtrackAppRestBaseUrl = (workspaceId)=>`/gateway/api/jsm/data-manager/workspace/${workspaceId}/app`;

});


parcelRegister("axmNY", function(module, exports) {

$parcel$export(module.exports, "fetchDataManagerTokens", () => $7c2d95880f7fa57e$export$c6b3de84befa4259);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $8OEkP = parcelRequire("8OEkP");
const $7c2d95880f7fa57e$export$c6b3de84befa4259 = ()=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        if (state.dataManager.tokensLoading) return;
        setState({
            ...state,
            dataManager: {
                ...state.dataManager,
                tokensLoading: true
            }
        });
        try {
            const tokenDetails = await (0, $4VpwK.performCmdbGetRequest)((0, $8OEkP.getDataManagerFetchContainerTokenUrl)(workspaceId));
            setState({
                dataManager: {
                    ...state.dataManager,
                    tokensData: tokenDetails.tokens,
                    tokensLoading: false
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchDataManagerTokens succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                dataManager: {
                    ...state.dataManager,
                    tokensLoading: false,
                    tokensError: error
                }
            });
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'fetchDataManagerTokens',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("j9kxm", function(module, exports) {

$parcel$export(module.exports, "updateDataManagerRole", () => $4b933e04f7b1c1e3$export$314337b594e79a51);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $Zsxbh = parcelRequire("Zsxbh");
const $4b933e04f7b1c1e3$export$93aad6482f82f57d = 5000;
const $4b933e04f7b1c1e3$export$214f23982cabf5f8 = 1000;
const $4b933e04f7b1c1e3$export$314337b594e79a51 = ({ principalIds: principalIds, roleId: roleId })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        if (state.dataManager.rolesUpdateLoading) return;
        setState({
            ...state,
            dataManager: {
                ...state.dataManager,
                rolesUpdateLoading: true
            }
        });
        try {
            const requestBody = {
                principalIds: principalIds,
                roleId: roleId,
                resourceType: 'workspace'
            };
            const updateRolesResponse = await (0, $4VpwK.performCmdbPutRequest)((0, $Zsxbh.getCmdbPermsRoleAssignmentUrl)(workspaceId), {
                body: JSON.stringify(requestBody)
            });
            const pollTimeoutTime = new Date(Date.now() + $4b933e04f7b1c1e3$export$93aad6482f82f57d).getTime();
            // poll the checking of the token status for 5 seconds as updating of
            // Identity role assignments have eventually consistency
            const tryPollTokenStatus = async (resolve, // eslint-disable-next-line @typescript-eslint/no-explicit-any
            reject)=>{
                if (Date.now() > pollTimeoutTime) {
                    reject(new Error('Some role assignments have failed or is still in progress'));
                    return;
                }
                try {
                    const url = (0, $Zsxbh.getCmdbPermsTokenStatusUrl)(workspaceId, updateRolesResponse.tokens[updateRolesResponse.tokens.length - 1]);
                    const updateRoleAssignmentToken = await (0, $4VpwK.performCmdbGetRequest)(url);
                    if (updateRoleAssignmentToken.isSuccessful) {
                        resolve();
                        return;
                    }
                    setTimeout(()=>{
                        tryPollTokenStatus(resolve, reject);
                    }, $4b933e04f7b1c1e3$export$214f23982cabf5f8);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (e) {
                    // Ignore unexpected network/server error and quickly retry
                    setTimeout(()=>{
                        tryPollTokenStatus(resolve, reject);
                    }, $4b933e04f7b1c1e3$export$214f23982cabf5f8);
                }
            };
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            await new Promise((res, rej)=>tryPollTokenStatus(res, rej));
            setState({
                ...state,
                dataManager: {
                    ...state.dataManager,
                    rolesUpdateLoading: false
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateDataManagerRole succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                dataManager: {
                    ...state.dataManager,
                    rolesUpdateLoading: false,
                    rolesUpdateError: error
                }
            });
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'updateDataManagerRole',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'data-manager'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("yPoOn", function(module, exports) {

$parcel$export(module.exports, "setIcon", () => $95e73dfa2b8a3d46$export$33914de34c28be6c);
$parcel$export(module.exports, "updateIcon", () => $95e73dfa2b8a3d46$export$89ea7ff652eb14dd);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $3jFL4 = parcelRequire("3jFL4");
const $95e73dfa2b8a3d46$export$33914de34c28be6c = (updatedIcon)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        const updatedData = state.icons.data?.map((icon)=>icon.id === updatedIcon.id ? updatedIcon : icon);
        setState({
            ...state,
            icons: {
                ...state.icons,
                data: updatedData
            }
        });
    };
const $95e73dfa2b8a3d46$export$89ea7ff652eb14dd = ({ iconId: iconId, updatedProperties: updatedProperties })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            icons: {
                ...state.icons,
                updateLoading: true
            }
        });
        try {
            const response = await (0, $4VpwK.performCmdbPutRequest)((0, $3jFL4.getCmdbIconByIdUrl)(workspaceId, iconId), {
                body: JSON.stringify(updatedProperties)
            });
            const updatedState = getState();
            const updatedData = updatedState.icons.data?.map((icon)=>icon.id === response.id ? response : icon);
            setState({
                ...updatedState,
                icons: {
                    ...updatedState.icons,
                    updateLoading: false,
                    data: updatedData
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateIcon succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const updatedState = getState();
            setState({
                ...updatedState,
                icons: {
                    ...updatedState.icons,
                    updateLoading: false,
                    updateError: error
                }
            });
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'updateIcon',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'aurum'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("akTZj", function(module, exports) {

$parcel$export(module.exports, "updateProvisioningStatus", () => $d823977f3c28c840$export$ae3c5292a85a06f4);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $8OEkP = parcelRequire("8OEkP");
const $d823977f3c28c840$export$ae3c5292a85a06f4 = ({ isEnabled: isEnabled })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        if (state.dataManager.provisioningUpdateLoading) return;
        setState({
            ...state,
            dataManager: {
                ...state.dataManager,
                isProvisioned: isEnabled,
                provisioningUpdateLoading: true
            }
        });
        try {
            const requestBody = {
                enabled: isEnabled
            };
            await (0, $4VpwK.performCmdbPutRequest)((0, $8OEkP.getDataManagerProvisioningStatusUrl)(workspaceId), {
                body: JSON.stringify(requestBody)
            });
            const result = await (0, $4VpwK.performCmdbGetRequest)((0, $8OEkP.getDataManagerProvisioningStatusUrl)(workspaceId));
            setState({
                ...state,
                dataManager: {
                    ...state.dataManager,
                    isProvisioned: result.enabled === 'ON',
                    provisioningUpdateLoading: false
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateProvisioningStatus succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                dataManager: {
                    ...state.dataManager,
                    provisioningUpdateLoading: false,
                    provisioningUpdateError: error
                }
            });
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'updateProvisioningStatus',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("czU2t", function(module, exports) {

$parcel$export(module.exports, "setReferenceType", () => $d89b12ad155fa4aa$export$7c6efce0302318d);
$parcel$export(module.exports, "updateReferenceType", () => $d89b12ad155fa4aa$export$f9e29a0f21a33136);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $Zsxbh = parcelRequire("Zsxbh");
const $d89b12ad155fa4aa$export$7c6efce0302318d = (updatedReferenceType)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        const updatedData = state.referenceTypes.data?.map((referenceType)=>referenceType.id === updatedReferenceType.id ? updatedReferenceType : referenceType);
        setState({
            ...state,
            referenceTypes: {
                ...state.referenceTypes,
                data: updatedData
            }
        });
    };
const $d89b12ad155fa4aa$export$f9e29a0f21a33136 = ({ referenceTypeId: referenceTypeId, updatedProperties: updatedProperties })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            referenceTypes: {
                ...state.referenceTypes,
                updateLoading: true
            }
        });
        try {
            const response = await (0, $4VpwK.performCmdbPutRequest)((0, $Zsxbh.getCmdbConfigReferenceTypeByIdUrl)(workspaceId, referenceTypeId), {
                body: JSON.stringify({
                    ...updatedProperties,
                    color: updatedProperties.color !== undefined ? updatedProperties.color.replace('#', '') : undefined
                })
            });
            const updatedState = getState();
            const updatedData = updatedState.referenceTypes.data?.map((referenceType)=>referenceType.id === response.id ? response : referenceType);
            setState({
                ...updatedState,
                referenceTypes: {
                    ...updatedState.referenceTypes,
                    updateLoading: false,
                    data: updatedData || undefined
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateReferenceType succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const updatedState = getState();
            setState({
                ...updatedState,
                referenceTypes: {
                    ...updatedState.referenceTypes,
                    updateLoading: false,
                    updateError: error
                }
            });
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'updateReferenceType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'aurum'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("lsHFw", function(module, exports) {

$parcel$export(module.exports, "setStatusType", () => $800507e86f7d8a8e$export$80a24939e43be67c);
$parcel$export(module.exports, "updateStatusType", () => $800507e86f7d8a8e$export$2174575c3f57e8f8);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $Zsxbh = parcelRequire("Zsxbh");
const $800507e86f7d8a8e$export$80a24939e43be67c = (updatedStatusType)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        const updatedData = state.statusTypes.data?.map((statusType)=>statusType.id === updatedStatusType.id ? updatedStatusType : statusType);
        setState({
            ...state,
            statusTypes: {
                ...state.statusTypes,
                data: updatedData
            }
        });
    };
const $800507e86f7d8a8e$export$2174575c3f57e8f8 = ({ statusTypeId: statusTypeId, updatedProperties: updatedProperties })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            statusTypes: {
                ...state.statusTypes,
                updateLoading: true
            }
        });
        try {
            const response = await (0, $4VpwK.performCmdbPutRequest)((0, $Zsxbh.getCmdbConfigStatusTypeByIdUrl)(workspaceId, statusTypeId), {
                body: JSON.stringify(updatedProperties)
            });
            const updatedState = getState();
            const updatedData = updatedState.statusTypes.data?.map((statusType)=>statusType.id === response.id ? response : statusType);
            setState({
                ...updatedState,
                statusTypes: {
                    ...updatedState.statusTypes,
                    updateLoading: false,
                    data: updatedData || undefined
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateStatusType succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const updatedState = getState();
            setState({
                ...updatedState,
                statusTypes: {
                    ...updatedState.statusTypes,
                    updateLoading: false,
                    updateError: error
                }
            });
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'updateStatusType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'aurum'
                },
                error: error
            });
            throw error;
        }
    };

});


parcelRegister("3SYcN", function(module, exports) {

$parcel$export(module.exports, "sortReferenceTypes", () => $52d2d568421769f9$export$7e55dd84e7cc0829);
$parcel$export(module.exports, "sortStatusTypes", () => $52d2d568421769f9$export$5f25bb3183b5823d);
const $52d2d568421769f9$export$7e55dd84e7cc0829 = (referenceTypes)=>referenceTypes.sort((a, b)=>a.name.localeCompare(b.name)).sort((a, b)=>{
        if (a.removable === b.removable) return 0;
        return a.removable ? 1 : -1;
    });
const $52d2d568421769f9$export$5f25bb3183b5823d = (statusTypes)=>statusTypes.sort((a, b)=>a.name.localeCompare(b.name));

});


parcelRegister("kT9FG", function(module, exports) {

$parcel$export(module.exports, "AssetsMenu", () => $68b59dd7ae4cb0b4$export$a578a9f5b9517a27);
$parcel$export(module.exports, "AssetsSingleMenuItem", () => $68b59dd7ae4cb0b4$export$252d7ffe38b4e8ef);

var $5uXOq = parcelRequire("5uXOq");

var $aYAc3 = parcelRequire("aYAc3");

var $lnznH = parcelRequire("lnznH");
var $cZa9B = parcelRequire("cZa9B");

var $koVbs = parcelRequire("koVbs");

var $jecJ3 = parcelRequire("jecJ3");

var $jhS4y = parcelRequire("jhS4y");

var $46Cti = parcelRequire("46Cti");

var $c16H2 = parcelRequire("c16H2");

var $5FnJJ = parcelRequire("5FnJJ");

var $dQbFB = parcelRequire("dQbFB");

var $eQV8d = parcelRequire("eQV8d");

var $dUyqZ = parcelRequire("dUyqZ");

var $eKq7N = parcelRequire("eKq7N");

var $j8qoE = parcelRequire("j8qoE");

var $blEB6 = parcelRequire("blEB6");

var $cNd4s = parcelRequire("cNd4s");

var $4PFfc = parcelRequire("4PFfc");

var $iHwh4 = parcelRequire("iHwh4");

var $tKTx3 = parcelRequire("tKTx3");

var $2Wh2X = parcelRequire("2Wh2X");

var $8Hhya = parcelRequire("8Hhya");
function $68b59dd7ae4cb0b4$export$a578a9f5b9517a27({ isExpanded: isExpanded }) {
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).ASSETS);
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const { isByokCustomer: isByokCustomer } = (0, $4PFfc.useByokComplianceSettingWithInitialisation)();
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    const [{ config: config, dataManager: dataManager, loading: loading }, { fetchGlobalConfig: fetchGlobalConfig, fetchProvisioningStatus: fetchProvisioningStatus, fetchMyDataManagerRoles: fetchMyDataManagerRoles }] = (0, $j8qoE.useInsightGlobalConfig)();
    const fetchAssetsConfig = (0, $5uXOq.useCallback)(async ()=>{
        fetchGlobalConfig(false);
        fetchProvisioningStatus(false);
        fetchMyDataManagerRoles(false);
    }, [
        fetchGlobalConfig,
        fetchMyDataManagerRoles,
        fetchProvisioningStatus
    ]);
    const menuId = (0, $jhS4y.MENU_ID_ASSETS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $46Cti.L1_MENU_ID).ASSETS,
                sectionItem: (0, $jecJ3.SECTION_ITEM_ASSETS)
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZa9B.ExpandableMenuItemTrigger), {
        elemBefore: icon,
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Hhya.SectionActions), {
            isInsightAdministrator: config?.insightAdministrator
        }),
        testId: (0, $dQbFB.getTestId)(menuId),
        onClick: (_e, _a, { isExpanded: hasExpanded })=>{
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $46Cti.L1_MENU_ID).ASSETS,
                sectionItem: (0, $jecJ3.SECTION_ITEM_ASSETS)
            });
        }
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnznH.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Wh2X.HeaderSchemasMenuItems), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eKq7N.L1ExpandableMenuItemSubmenu), {
        fetch: fetchAssetsConfig,
        isFetching: loading || dataManager.provisioningLoading || dataManager.myRolesLoading,
        MenuItems: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iHwh4.AssetsMenuItems), {
                dataManagerIsProvisioned: dataManager.isProvisioned,
                dataManagerMyRoles: dataManager.myRoles,
                isSiteAdmin: isSiteAdmin,
                insightAdministrator: config?.insightAdministrator,
                insightReporting: config?.insightReporting,
                isByokCustomer: isByokCustomer
            }),
        skeletonCount: 2
    })));
}
const $68b59dd7ae4cb0b4$export$252d7ffe38b4e8ef = ({ showUpsellLozenge: showUpsellLozenge = false })=>{
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).ASSETS);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        onClick: ()=>{
            sendSectionItemAnalyticsEvent({
                menuId: (0, $46Cti.L1_MENU_ID).ASSETS,
                sectionItem: (0, $jecJ3.SECTION_ITEM_ASSETS)
            });
        },
        menuId: (0, $jhS4y.MENU_ID_ASSETS),
        elemBefore: icon,
        href: (0, $blEB6.getLandingPageUrl)(),
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Hhya.SectionActions), {
            isInsightAdministrator: false
        })
    }, `${formattedMessage} `, showUpsellLozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
        testId: "navigation-apps-sidebar-nav4-sidebars-content-assets.ui.assets-menu.upsell-lozenge",
        appearance: "new"
    }, formatMessage((0, $tKTx3.default).upsellLozengeText)));
};

});
parcelRegister("eKq7N", function(module, exports) {

$parcel$export(module.exports, "L1ExpandableMenuItemSubmenu", () => $791f4f5cc9cec4d6$export$a0d95f81c9ddf0e9);

var $5uXOq = parcelRequire("5uXOq");

var $5qw5u = parcelRequire("5qw5u");
const $791f4f5cc9cec4d6$export$a0d95f81c9ddf0e9 = (props)=>{
    const { fetch: fetch, Footer: Footer, isFetching: isFetching, MenuItems: MenuItems, skeletonCount: skeletonCount } = props;
    const expandableMenuItems = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItems, null);
    const expandableFooter = Footer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Footer, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qw5u.ExpandableMenuItemSubmenu), {
        fetch: fetch,
        footer: expandableFooter,
        isFetching: isFetching,
        menuItems: expandableMenuItems,
        skeletonCount: skeletonCount
    });
};

});
parcelRegister("5qw5u", function(module, exports) {

$parcel$export(module.exports, "ExpandableMenuItemSubmenu", () => $71e5e00939216601$export$216998a85b3335a2);

var $5uXOq = parcelRequire("5uXOq");

var $et13M = parcelRequire("et13M");

var $1oZ5x = parcelRequire("1oZ5x");

var $338xa = parcelRequire("338xa");
const $71e5e00939216601$export$216998a85b3335a2 = (props)=>{
    const { fetch: fetchMaybe, footer: footer, isFetching: isFetchingMaybe, menuItems: menuItems, skeletonCount: skeletonCount } = props;
    const { isFetching: isFetching, fetch: fetch } = (0, $1oZ5x.useFetchActual)(isFetchingMaybe, fetchMaybe);
    const isExpanded = (0, $et13M.useIsExpanded)();
    // Fetch on open to refresh.
    (0, $5uXOq.useEffect)(()=>{
        if (isExpanded && !isFetching) fetch();
    }, // Don't include `isFetching` or this effect will go into an endless loop.
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isExpanded,
        fetch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isFetching ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), {
        count: skeletonCount
    }) : menuItems, footer);
};

});
parcelRegister("1oZ5x", function(module, exports) {

$parcel$export(module.exports, "useFetchActual", () => $e36b0174fdde90f4$export$49f3bd519990bec7);

var $5uXOq = parcelRequire("5uXOq");
const $e36b0174fdde90f4$export$49f3bd519990bec7 = (isFetchingMaybe, fetchMaybe)=>{
    const [isFetching, setIsFetching] = (0, $5uXOq.useState)(false);
    const fetch = (0, $5uXOq.useCallback)(async ()=>{
        if (!fetchMaybe) return;
        setIsFetching(true);
        try {
            await fetchMaybe();
        } finally{
            setIsFetching(false);
        }
    }, [
        fetchMaybe,
        setIsFetching
    ]);
    return {
        isFetching: !!isFetchingMaybe || isFetching,
        fetch: fetch
    };
};

});



parcelRegister("4PFfc", function(module, exports) {

$parcel$export(module.exports, "useByokComplianceSettingWithInitialisation", () => $4598a5eb88f036a1$export$fb68f4844474e7cb);

var $5uXOq = parcelRequire("5uXOq");

var $eusud = parcelRequire("eusud");

var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");

var $9OXo1 = parcelRequire("9OXo1");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $4R6GH = parcelRequire("4R6GH");

var $6rXpq = parcelRequire("6rXpq");
const $4598a5eb88f036a1$export$f907f15fb3e7d5a9 = (0, $7HGHK.toFlagId)('byok-settings-enabled-success-flag-key');
const $4598a5eb88f036a1$var$LEARN_MORE_ABOUT_BYOK_COMPLIANCE_SETTING_LINK = 'https://support.atlassian.com/security-and-access-policies/docs/data-managed-with-byok-encryption/24h';
const $4598a5eb88f036a1$var$actions = {
    fetchByokComplianceSetting: (cloudId)=>async ({ setState: setState, getState: getState })=>{
            const state = getState();
            if (state.loading === true) return;
            setState({
                ...state,
                loading: true
            });
            try {
                const { data: data } = await (0, $eusud.performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/customers/byok-setting`);
                setState({
                    ...state,
                    data: data,
                    loading: false,
                    error: undefined
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    ...state,
                    loading: false,
                    error: error
                });
            }
        },
    updateByokComplianceSetting: (option, cloudId)=>async ({ setState: setState, getState: getState })=>{
            const state = getState();
            if (state.loading === true) return;
            const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
            setState({
                ...state,
                loading: true
            });
            try {
                await (0, $eusud.performPatchRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/customers/byok-setting`, {
                    body: JSON.stringify({
                        ugcPrimaryLogEnabledForByok: option
                    })
                });
                if (option) showFlag({
                    id: $4598a5eb88f036a1$export$f907f15fb3e7d5a9,
                    title: (0, $6rXpq.default).byokComplianceSettingEnabledSuccessTitle,
                    type: 'success',
                    description: (0, $6rXpq.default).byokComplianceSettingEnabledSuccessDescription,
                    messageId: 'products-jsm-compliance-main.services.byok-compliance-setting.show-flag.success',
                    messageType: 'transactional',
                    actions: [
                        {
                            content: (0, $6rXpq.default).flagOk,
                            onClick: ()=>{
                                dismissFlag($4598a5eb88f036a1$export$f907f15fb3e7d5a9);
                            }
                        },
                        {
                            content: (0, $6rXpq.default).flagLearnMore,
                            href: $4598a5eb88f036a1$var$LEARN_MORE_ABOUT_BYOK_COMPLIANCE_SETTING_LINK,
                            target: '_blank'
                        }
                    ]
                });
                setState({
                    ...state,
                    data: {
                        byokCustomer: state.data?.byokCustomer ?? false,
                        ugcPrimaryLogEnabledForByok: option
                    },
                    loading: false,
                    error: undefined
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    ...state,
                    loading: false,
                    error: error
                });
            }
        }
};
const $4598a5eb88f036a1$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        data: null,
        loading: false,
        error: undefined
    },
    actions: $4598a5eb88f036a1$var$actions,
    name: 'BYOKComplianceSetting'
});
const $4598a5eb88f036a1$var$useByokComplianceSettingData = (0, $3sQ5x.createHook)($4598a5eb88f036a1$var$Store);
const $4598a5eb88f036a1$export$fb68f4844474e7cb = ()=>{
    const [ByokComplianceSettingState, { fetchByokComplianceSetting: fetchByokComplianceSetting, updateByokComplianceSetting: updateByokComplianceSetting }] = $4598a5eb88f036a1$var$useByokComplianceSettingData();
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    (0, $5uXOq.useEffect)(()=>{
        if (!ByokComplianceSettingState.data && (0, $4R6GH.fg)('audit-logs-byok-encrypted-data')) fetchByokComplianceSetting(cloudId);
    }, [
        ByokComplianceSettingState.data,
        cloudId,
        fetchByokComplianceSetting
    ]);
    return {
        loading: ByokComplianceSettingState.loading,
        error: ByokComplianceSettingState.error,
        data: ByokComplianceSettingState.data,
        isByokComplianceSettingEnabled: ByokComplianceSettingState.data?.ugcPrimaryLogEnabledForByok ?? false,
        isByokCustomer: ByokComplianceSettingState.data?.byokCustomer ?? false,
        enableSetting: ()=>updateByokComplianceSetting(true, cloudId),
        disableSetting: ()=>updateByokComplianceSetting(false, cloudId)
    };
};

});
parcelRegister("6rXpq", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a126756b74ac450$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5a126756b74ac450$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    byokComplianceSettingEnabledSuccessTitle: {
        "id": "products-jsm-compliance-main.services.byok-compliance-setting.byok-compliance-setting-enabled-success-title",
        "defaultMessage": "HIPAA-compliant alert notifications turned on"
    },
    byokComplianceSettingEnabledSuccessDescription: {
        "id": "products-jsm-compliance-main.services.byok-compliance-setting.byok-compliance-setting-enabled-success-description",
        "defaultMessage": "Let your team admins know about the recommended actions they can take."
    },
    flagOk: {
        "id": "products-jsm-compliance-main.services.byok-compliance-setting.flag-ok",
        "defaultMessage": "Ok"
    },
    flagLearnMore: {
        "id": "products-jsm-compliance-main.services.byok-compliance-setting.flag-learn-more",
        "defaultMessage": "Learn more"
    }
});

});


parcelRegister("iHwh4", function(module, exports) {

$parcel$export(module.exports, "AssetsMenuItems", () => $a72239a654789f48$export$eca9d73b7de13f6a);

var $5uXOq = parcelRequire("5uXOq");

var $cfud7 = parcelRequire("cfud7");

var $c04PQ = parcelRequire("c04PQ");

var $4R6GH = parcelRequire("4R6GH");

var $jRK4a = parcelRequire("jRK4a");

var $3aBrO = parcelRequire("3aBrO");

var $cyPK0 = parcelRequire("cyPK0");
const $a72239a654789f48$export$eca9d73b7de13f6a = ({ dataManagerIsProvisioned: dataManagerIsProvisioned, dataManagerMyRoles: dataManagerMyRoles, isSiteAdmin: isSiteAdmin, insightAdministrator: insightAdministrator, insightReporting: insightReporting, isByokCustomer: isByokCustomer })=>{
    const showDataManagerLink = (0, $5uXOq.useCallback)(()=>{
        if (dataManagerIsProvisioned && dataManagerMyRoles) {
            const hasDMRoles = dataManagerMyRoles.some((myRole)=>(0, $cfud7.DATA_MANAGER_ROLES).includes(myRole));
            const hasAdapterRoles = dataManagerMyRoles.some((myRole)=>(0, $cfud7.DATA_MANAGER_ADAPTERS_ROLES).includes(myRole));
            if (hasDMRoles) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3aBrO.DataManagerMenuItems), null);
            if (hasAdapterRoles) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jRK4a.DataManagerAdapterMenuItems), null);
        }
    }, [
        dataManagerIsProvisioned,
        dataManagerMyRoles
    ]);
    const isAssetsReportsByokSupported = isByokCustomer ? (0, $4R6GH.fg)('assets_reports_enabled_for_byok_customers') : true;
    const isInsightReportsEnabled = (0, $5uXOq.useCallback)(()=>(isSiteAdmin || insightAdministrator) && isAssetsReportsByokSupported && insightReporting, [
        insightAdministrator,
        insightReporting,
        isSiteAdmin,
        isAssetsReportsByokSupported
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isInsightReportsEnabled() && !(0, $c04PQ.isFedRamp)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cyPK0.ReportsMenuItem), null), showDataManagerLink());
};

});
parcelRegister("cfud7", function(module, exports) {

$parcel$export(module.exports, "DATA_MANAGER_ADMIN", () => $b7b7b13be4edcaed$export$48abe9ccfdd98170);
$parcel$export(module.exports, "DATA_MANAGER_REPORT_VIEWER", () => $b7b7b13be4edcaed$export$8939b849d295aa4c);
$parcel$export(module.exports, "DATA_MANAGER_REPORT_EDITOR", () => $b7b7b13be4edcaed$export$4ca2081d195ddbdb);
$parcel$export(module.exports, "DATA_MANAGER_ADAPTERS_ADMIN", () => $b7b7b13be4edcaed$export$4c3d5fe6bdc107f1);
$parcel$export(module.exports, "DATA_MANAGER_ROLES", () => $b7b7b13be4edcaed$export$48703faa5030b273);
$parcel$export(module.exports, "DATA_MANAGER_ADAPTERS_ROLES", () => $b7b7b13be4edcaed$export$8b2dfd13f5f35ee4);
$parcel$export(module.exports, "ORDERED_ASSETS_DATA_MANAGER_ROLES", () => $b7b7b13be4edcaed$export$1d276f65230af2e);
const $b7b7b13be4edcaed$export$48abe9ccfdd98170 = 'ari:cloud:cmdb::role/airtrack/admin';
const $b7b7b13be4edcaed$export$8939b849d295aa4c = 'ari:cloud:cmdb::role/airtrack/report-viewer';
const $b7b7b13be4edcaed$export$4ca2081d195ddbdb = 'ari:cloud:cmdb::role/airtrack/report-editor';
const $b7b7b13be4edcaed$export$4c3d5fe6bdc107f1 = 'ari:cloud:cmdb::role/airtrack-buoy/admin';
const $b7b7b13be4edcaed$export$48703faa5030b273 = [
    $b7b7b13be4edcaed$export$48abe9ccfdd98170,
    $b7b7b13be4edcaed$export$8939b849d295aa4c,
    $b7b7b13be4edcaed$export$4ca2081d195ddbdb
];
const $b7b7b13be4edcaed$export$8b2dfd13f5f35ee4 = [
    $b7b7b13be4edcaed$export$4c3d5fe6bdc107f1
];
const $b7b7b13be4edcaed$export$1d276f65230af2e = [
    $b7b7b13be4edcaed$export$48abe9ccfdd98170,
    $b7b7b13be4edcaed$export$4c3d5fe6bdc107f1,
    $b7b7b13be4edcaed$export$4ca2081d195ddbdb,
    $b7b7b13be4edcaed$export$8939b849d295aa4c
];

});

parcelRegister("jRK4a", function(module, exports) {

$parcel$export(module.exports, "DataManagerAdapterMenuItems", () => $34fbfe3fa95e91ec$export$f74d67a8d693b664);

var $5uXOq = parcelRequire("5uXOq");

var $9Xmvg = parcelRequire("9Xmvg");

var $aYAc3 = parcelRequire("aYAc3");

var $c0aEF = parcelRequire("c0aEF");

var $cJFfS = parcelRequire("cJFfS");

var $koVbs = parcelRequire("koVbs");


var $24a2m = parcelRequire("24a2m");

var $c0oSL = parcelRequire("c0oSL");

var $blEB6 = parcelRequire("blEB6");

var $isEeX = parcelRequire("isEeX");

var $i1on6 = parcelRequire("i1on6");
const $34fbfe3fa95e91ec$export$f74d67a8d693b664 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { icon: formattedAdapterIcon } = (0, $24a2m.useFormattedMessageAndIcon)((0, $i1on6.default).jsmAssetsDataManagerAdapters, (0, $c0oSL.DataManagerAdaptersGlyph));
    const { icon: formattedOpenIcon } = (0, $24a2m.useFormattedMessageAndIcon)((0, $i1on6.default).jsmAssetsOpenDataManager, (0, (/*@__PURE__*/$parcel$interopDefault($9Xmvg))));
    const { fireUINavigationItemAnalytics: fireUINavigationItemAnalytics } = (0, $isEeX.useAssetsUIAnalytics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cJFfS.LinkMenuItem), {
        elemBefore: formattedAdapterIcon,
        elemAfter: formattedOpenIcon,
        href: (0, $blEB6.getDataManagerAdaptersUrl)(),
        target: "_blank",
        onClick: ()=>fireUINavigationItemAnalytics((0, $496585bee7985bb9$export$ee52916f9ebd8000))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        space: "space.050",
        alignBlock: "baseline"
    }, formatMessage((0, $i1on6.default).jsmAssetsDataManagerAdapters), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
        appearance: "new"
    }, formatMessage((0, $i1on6.default).assetsDataManagerBeta))));
};

});
parcelRegister("9Xmvg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2acc08ab6395d499b2798249d78c49fd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $73fb14674561f421$var$_react = $73fb14674561f421$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $73fb14674561f421$var$_arrowUpRight = $73fb14674561f421$var$_interopRequireDefault((parcelRequire("3sGLB")));

var $73fb14674561f421$var$_open = $73fb14674561f421$var$_interopRequireDefault((parcelRequire("1FouZ")));
function $73fb14674561f421$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowUpRightIcon.
 * This component is ArrowUpRightIcon, with `UNSAFE_fallbackIcon` set to "OpenIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $73fb14674561f421$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $73fb14674561f421$var$_react.default.createElement($73fb14674561f421$var$_arrowUpRight.default, Object.assign({
        LEGACY_fallbackIcon: $73fb14674561f421$var$_open.default
    }, props));
$73fb14674561f421$var$ArrowUpRightIcon.Name = 'ArrowUpRightIconMigration';
var $73fb14674561f421$var$_default = module.exports.default = $73fb14674561f421$var$ArrowUpRightIcon;

});
parcelRegister("3sGLB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aa37e7fb05387379200e2a91e20ea76e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2855293259c2814d$var$_react = $2855293259c2814d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2855293259c2814d$var$_baseNew = $2855293259c2814d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $2855293259c2814d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUpRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2855293259c2814d$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $2855293259c2814d$var$_react.default.createElement($2855293259c2814d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m2.47 12.47 9.75-9.75 1.06 1.06-9.75 9.75z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M12 4H5.75V2.5h7a.75.75 0 0 1 .75.75v7H12z" clip-rule="evenodd"/>`
    }, props));
$2855293259c2814d$var$ArrowUpRightIcon.displayName = 'ArrowUpRightIcon';
var $2855293259c2814d$var$_default = module.exports.default = $2855293259c2814d$var$ArrowUpRightIcon;

});

parcelRegister("1FouZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $136c9fbd1122fba5$var$_react = $136c9fbd1122fba5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $136c9fbd1122fba5$var$_arrowUpRight = $136c9fbd1122fba5$var$_interopRequireDefault((parcelRequire("3sGLB")));
function $136c9fbd1122fba5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $136c9fbd1122fba5$var$OpenIcon = (props)=>/*#__PURE__*/ $136c9fbd1122fba5$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11.031 7A1.03 1.03 0 0 0 10 8.036a1.05 1.05 0 0 0 1.044 1.045l3.121.014.014 3.121a1.05 1.05 0 0 0 1.045 1.044 1.03 1.03 0 0 0 1.036-1.035l-.019-4.161a1.053 1.053 0 0 0-1.045-1.045L11.035 7z"/><path d="m13.364 8.292-7.071 7.071a1 1 0 0 0 0 1.415 1 1 0 0 0 1.414 0l7.071-7.071A1.002 1.002 0 0 0 14.071 8a1 1 0 0 0-.707.292"/></g></svg>`
    }, props, {
        newIcon: $136c9fbd1122fba5$var$_arrowUpRight.default
    }));
$136c9fbd1122fba5$var$OpenIcon.displayName = 'OpenIcon';
var $136c9fbd1122fba5$var$_default = module.exports.default = $136c9fbd1122fba5$var$OpenIcon;

});


const $496585bee7985bb9$export$f06dfcec5ff912e = 'meatballDropdown';
const $496585bee7985bb9$export$7ae7abcf2c19d3e5 = 'removeFromStarred';
const $496585bee7985bb9$export$78fd0bd637fe1684 = 'addToStarred';
const $496585bee7985bb9$export$c540230986f848f6 = 'addPeople';
const $496585bee7985bb9$export$44d67b522cbcce6d = 'projects';
const $496585bee7985bb9$export$3cc9ab700c406a19 = 'projectSettings';
const $496585bee7985bb9$export$dc23a793cf9e9de8 = 'archiveProject';
const $496585bee7985bb9$export$a68d619e7022f2c3 = 'deleteBoard';
const $496585bee7985bb9$export$22748439827110a4 = 'deleteProject';
const $496585bee7985bb9$export$192d610b0b7719f4 = 'boardSettings';
const $496585bee7985bb9$export$a65812b4aab631bb = 'alertSettings';
const $496585bee7985bb9$export$36b5d4d0cb4e437 = 'moveInSidebar';
const $496585bee7985bb9$export$ca6db12118be69a1 = 'schemas';
const $496585bee7985bb9$export$f2eca6cf19c9a973 = 'reports';
const $496585bee7985bb9$export$147264622218a553 = 'dataManager';
const $496585bee7985bb9$export$ee52916f9ebd8000 = 'adapters';
const $496585bee7985bb9$export$83d40997eb7cc5b7 = 'assetsGlobalConfiguration';
const $496585bee7985bb9$export$5c09fa42f8d45ed8 = 'dismissRecommendation';
const $496585bee7985bb9$export$de9ad1ebeca97ec1 = 'newDiscoveryProject';
const $496585bee7985bb9$export$27e4092edca7bb97 = 'jwmSampleProject';
const $496585bee7985bb9$export$ce0bea1467165424 = 'whyAmISeeingThis';
const $496585bee7985bb9$export$98d08638c2a90c44 = 'starredAndRecentProjects';
const $496585bee7985bb9$export$ed36b1ade72db400 = 'starredProjectsOnly';
const $496585bee7985bb9$export$f8a73cc0211412ca = 'mostRecentProjectOnly';
const $496585bee7985bb9$export$3e2efdbdb3eed97e = 'moreProjects';
const $496585bee7985bb9$export$2de7e56f66635690 = 'viewAllProjects';
const $496585bee7985bb9$export$5ff59e4f08b9b299 = 'moveToTop';
const $496585bee7985bb9$export$9964b4a63620a911 = 'moveUp';
const $496585bee7985bb9$export$2692a384035c5ef7 = 'moveDown';
const $496585bee7985bb9$export$a5a45050b97fca24 = 'moveToBottom';

parcelRegister("c0oSL", function(module, exports) {

$parcel$export(module.exports, "DataManagerAdaptersGlyph", () => $1cdb3cd51030e227$export$cff497901afe8164);
$parcel$export(module.exports, "DataManagerLink", () => $1cdb3cd51030e227$export$905e681c1cad3de);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $5LWLA = parcelRequire("5LWLA");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $aYAc3 = parcelRequire("aYAc3");

var $hjSul = parcelRequire("hjSul");
const $1cdb3cd51030e227$export$fb5ad6208dd8d5f1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.5 6.5C7.5 7.05228 7.05228 7.5 6.5 7.5C5.94772 7.5 5.5 7.05228 5.5 6.5C5.5 5.94772 5.94772 5.5 6.5 5.5C7.05228 5.5 7.5 5.94772 7.5 6.5ZM7.5 17.5C7.5 18.0523 7.05228 18.5 6.5 18.5C5.94772 18.5 5.5 18.0523 5.5 17.5C5.5 16.9477 5.94772 16.5 6.5 16.5C7.05228 16.5 7.5 16.9477 7.5 17.5ZM18.5 12C18.5 12.5523 18.0523 13 17.5 13C16.9477 13 16.5 12.5523 16.5 12C16.5 11.4477 16.9477 11 17.5 11C18.0523 11 18.5 11.4477 18.5 12ZM8.88555 7.25C8.56698 8.26428 7.61941 9 6.5 9C5.11929 9 4 7.88071 4 6.5C4 5.11929 5.11929 4 6.5 4C7.61941 4 8.56698 4.73572 8.88555 5.75H10.5523C11.697 5.75 12.625 6.67797 12.625 7.82267V11.25H14.5H15.1145C15.433 10.2357 16.3806 9.5 17.5 9.5C18.8807 9.5 20 10.6193 20 12C20 13.3807 18.8807 14.5 17.5 14.5C16.3806 14.5 15.433 13.7643 15.1145 12.75H14.5H12.625V16.1773C12.625 17.322 11.697 18.25 10.5523 18.25H8.88555C8.56698 19.2643 7.61941 20 6.5 20C5.11929 20 4 18.8807 4 17.5C4 16.1193 5.11929 15 6.5 15C7.61941 15 8.56698 15.7357 8.88555 16.75H10.5523C10.8686 16.75 11.125 16.4936 11.125 16.1773V12.75V12V11.25V7.82267C11.125 7.50639 10.8686 7.25 10.5523 7.25H8.88555Z",
        fill: "#44546F"
    }));
const $1cdb3cd51030e227$export$cff497901afe8164 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        clipPath: "url(#clip0_2374_102539)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.5076 15.8019C10.8212 16.0862 11 16.4898 11 16.913V18.5H13V16.913C13 16.4898 13.1788 16.0862 13.4924 15.8019L16.5 13.0745V9.5H7.5V13.0745L10.5076 15.8019ZM6 13.7391V9C6 8.44771 6.44772 8 7 8H17C17.5523 8 18 8.44772 18 9V13.7391L14.5 16.913V19C14.5 19.5523 14.0523 20 13.5 20H10.5C9.94772 20 9.5 19.5523 9.5 19V16.913L6 13.7391Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9 9L9 4L10.5 4V9H9Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.5 9V4L15 4V9H13.5Z",
        fill: "currentColor"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("clipPath", {
        id: "clip0_2374_102539"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        width: "24",
        height: "24",
        fill: "currentColor"
    }))));
const $1cdb3cd51030e227$export$905e681c1cad3de = ({ children: children, onClick: onClick, testId: testId, to: to, app: app })=>{
    const getIcon = ()=>{
        if (app === 'data-manager') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
            glyph: $1cdb3cd51030e227$export$fb5ad6208dd8d5f1,
            label: "Data manager icon",
            size: "medium"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
            glyph: $1cdb3cd51030e227$export$cff497901afe8164,
            label: "Adapters icon",
            size: "medium"
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1cdb3cd51030e227$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        href: to,
        component: (0, $hjSul.Link),
        appearance: "subtle",
        iconBefore: getIcon(),
        testId: testId,
        onClick: (event, analyticsEvent)=>{
            onClick?.(analyticsEvent);
        },
        target: "_blank"
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1cdb3cd51030e227$var$lozengeStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
        appearance: "new"
    }, "BETA"))));
};
const $1cdb3cd51030e227$var$lozengeStyles = (0, $8CUq3.xcss)({
    display: 'inline-block',
    marginLeft: 'space.050'
});
const $1cdb3cd51030e227$var$wrapperStyles = (0, $8CUq3.xcss)({});

});

parcelRegister("isEeX", function(module, exports) {

$parcel$export(module.exports, "useAssetsUIAnalytics", () => $9e3bbdcdefd1cee6$export$2eb4a7a38c92c87f);

var $5uXOq = parcelRequire("5uXOq");




var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $9e3bbdcdefd1cee6$export$2eb4a7a38c92c87f = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireUINavigationItemAnalytics = (0, $5uXOq.useCallback)((analyticsItemId)=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
        }), (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_ASSETS], {
            level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
            componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
            itemId: analyticsItemId
        });
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireUINavigationItemAnalytics: fireUINavigationItemAnalytics
    };
};

});

parcelRegister("i1on6", function(module, exports) {

$parcel$export(module.exports, "default", () => $43eab5367bedc66d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $43eab5367bedc66d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    jsmAssetsDataManagerAdapters: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager-adapter.jsm-assets-data-manager-adapters",
        "defaultMessage": "Adapters"
    },
    jsmAssetsOpenDataManager: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager-adapter.jsm-assets-open-data-manager",
        "defaultMessage": "Open data manager"
    },
    assetsDataManagerBeta: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager-adapter.assets-data-manager-beta",
        "defaultMessage": "Beta"
    }
});

});


parcelRegister("3aBrO", function(module, exports) {

$parcel$export(module.exports, "DataManagerMenuItems", () => $be611fc140bff39d$export$34300598ca712097);

var $5uXOq = parcelRequire("5uXOq");

var $9Xmvg = parcelRequire("9Xmvg");

var $c0aEF = parcelRequire("c0aEF");

var $aYAc3 = parcelRequire("aYAc3");

var $cJFfS = parcelRequire("cJFfS");

var $la5Q6 = parcelRequire("la5Q6");

var $koVbs = parcelRequire("koVbs");


var $24a2m = parcelRequire("24a2m");

var $blEB6 = parcelRequire("blEB6");

var $isEeX = parcelRequire("isEeX");

var $drPTS = parcelRequire("drPTS");
const $be611fc140bff39d$export$34300598ca712097 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { icon: formattedOpenIcon } = (0, $24a2m.useFormattedMessageAndIcon)((0, $drPTS.default).assetsOpenDataManager, (0, (/*@__PURE__*/$parcel$interopDefault($9Xmvg))));
    const { icon: formattedDataManagerIcon } = (0, $24a2m.useFormattedMessageAndIcon)((0, $drPTS.default).assetsDataManager, (0, $la5Q6.default));
    const { fireUINavigationItemAnalytics: fireUINavigationItemAnalytics } = (0, $isEeX.useAssetsUIAnalytics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cJFfS.LinkMenuItem), {
        elemBefore: formattedDataManagerIcon,
        elemAfter: formattedOpenIcon,
        href: (0, $blEB6.getDataManagerUrl)(),
        target: "_blank",
        onClick: ()=>fireUINavigationItemAnalytics((0, $496585bee7985bb9$export$147264622218a553))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        space: "space.050",
        alignBlock: "baseline"
    }, formatMessage((0, $drPTS.default).assetsDataManager), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
        appearance: "new"
    }, formatMessage((0, $drPTS.default).assetsDataManagerBeta))));
};

});
parcelRegister("la5Q6", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb221b5381fce3c6$export$2e2bcd8739ae039);
/**
 * Based on custom icon example:
 * https://atlassian.design/components/icon/custom-icon/examples
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $fb221b5381fce3c6$var$JSMAssetsDataManagerGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label']
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.5 6.5C7.5 7.05228 7.05228 7.5 6.5 7.5C5.94772 7.5 5.5 7.05228 5.5 6.5C5.5 5.94772 5.94772 5.5 6.5 5.5C7.05228 5.5 7.5 5.94772 7.5 6.5ZM8.88555 7.25C8.56698 8.26428 7.61941 9 6.5 9C5.11929 9 4 7.88071 4 6.5C4 5.11929 5.11929 4 6.5 4C7.61941 4 8.56698 4.73572 8.88555 5.75H10.5523C11.697 5.75 12.625 6.67797 12.625 7.82267V8.5V11.25H14.5H15.1145C15.433 10.2357 16.3806 9.5 17.5 9.5C18.8807 9.5 20 10.6193 20 12C20 13.3807 18.8807 14.5 17.5 14.5C16.3806 14.5 15.433 13.7643 15.1145 12.75H14.5H12.625V15.5V16.1773C12.625 17.322 11.697 18.25 10.5523 18.25H8.88555C8.56698 19.2643 7.61941 20 6.5 20C5.11929 20 4 18.8807 4 17.5C4 16.1193 5.11929 15 6.5 15C7.61941 15 8.56698 15.7357 8.88555 16.75H10.5523C10.8686 16.75 11.125 16.4936 11.125 16.1773V15.5V12.75V12V11.25V8.5V7.82267C11.125 7.50639 10.8686 7.25 10.5523 7.25H8.88555ZM6.5 18.5C7.05228 18.5 7.5 18.0523 7.5 17.5C7.5 16.9477 7.05228 16.5 6.5 16.5C5.94772 16.5 5.5 16.9477 5.5 17.5C5.5 18.0523 5.94772 18.5 6.5 18.5ZM18.5 12C18.5 12.5523 18.0523 13 17.5 13C16.9477 13 16.5 12.5523 16.5 12C16.5 11.4477 16.9477 11 17.5 11C18.0523 11 18.5 11.4477 18.5 12Z",
        fill: "currentColor"
    }));
const $fb221b5381fce3c6$var$JSMAssetsDataManagerIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        ...props,
        glyph: $fb221b5381fce3c6$var$JSMAssetsDataManagerGlyph
    });
var $fb221b5381fce3c6$export$2e2bcd8739ae039 = $fb221b5381fce3c6$var$JSMAssetsDataManagerIcon;

});

parcelRegister("drPTS", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bef7773ffc3fd68$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0bef7773ffc3fd68$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    assetsDataManager: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager.assets-data-manager",
        "defaultMessage": "Data Manager"
    },
    assetsOpenDataManager: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager.assets-open-data-manager",
        "defaultMessage": "Open Data Manager"
    },
    assetsDataManagerBeta: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager.assets-data-manager-beta",
        "defaultMessage": "Beta"
    }
});

});


parcelRegister("cyPK0", function(module, exports) {

$parcel$export(module.exports, "ReportsMenuItem", () => $ebc6899836d65f8e$export$156f96ce3bb16879);

var $5uXOq = parcelRequire("5uXOq");

var $fDskX = parcelRequire("fDskX");

var $koVbs = parcelRequire("koVbs");


var $jhS4y = parcelRequire("jhS4y");

var $5FnJJ = parcelRequire("5FnJJ");

var $blEB6 = parcelRequire("blEB6");

var $isEeX = parcelRequire("isEeX");

var $4UvDQ = parcelRequire("4UvDQ");
const $ebc6899836d65f8e$export$156f96ce3bb16879 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const reportsLink = (0, $5uXOq.useMemo)(()=>(0, $blEB6.getAssetsReportsUrl)(), []);
    const { fireUINavigationItemAnalytics: fireUINavigationItemAnalytics } = (0, $isEeX.useAssetsUIAnalytics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fDskX))), {
            label: formatMessage((0, $4UvDQ.default).jsmAssetsReports),
            color: "currentColor",
            spacing: "spacious"
        }),
        href: reportsLink,
        menuId: (0, $jhS4y.MENU_ID_ASSETS_REPORTS),
        onClick: ()=>fireUINavigationItemAnalytics((0, $496585bee7985bb9$export$f2eca6cf19c9a973))
    }, formatMessage((0, $4UvDQ.default).jsmAssetsReports));
};

});
parcelRegister("fDskX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::938052aeb81071adc088ccde54cc9808>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b6207aa8debd29f4$var$_react = $b6207aa8debd29f4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b6207aa8debd29f4$var$_baseNew = $b6207aa8debd29f4$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $b6207aa8debd29f4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Reports in JSM, Space Analytics in Confluence, and other graph charts.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b6207aa8debd29f4$var$ChartBarIcon = (props)=>/*#__PURE__*/ $b6207aa8debd29f4$var$_react.default.createElement($b6207aa8debd29f4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.333 1.75a.75.75 0 0 1 .75-.75h4.167a.75.75 0 0 1 .75.75V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V9.75A.75.75 0 0 1 1.75 9h3.417V5.75a.75.75 0 0 1 .75-.75h3.416zm0 4.75H6.667v7h2.666zm1.5 7H13a.5.5 0 0 0 .5-.5V2.5h-2.667zm-5.666 0v-3H2.5V13a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$b6207aa8debd29f4$var$ChartBarIcon.displayName = 'ChartBarIcon';
var $b6207aa8debd29f4$var$_default = module.exports.default = $b6207aa8debd29f4$var$ChartBarIcon;

});

parcelRegister("4UvDQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $884cac664127c061$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $884cac664127c061$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    jsmAssetsReports: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.common.reports.jsm-assets-reports",
        "defaultMessage": "Reports"
    }
});

});



parcelRegister("tKTx3", function(module, exports) {

$parcel$export(module.exports, "default", () => $aac539a54eaf043d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $aac539a54eaf043d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    upsellLozengeText: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.assets-menu.upsell-lozenge-text",
        "defaultMessage": "Premium"
    }
});

});

parcelRegister("2Wh2X", function(module, exports) {

$parcel$export(module.exports, "HeaderSchemasMenuItems", () => $77dfa228afe7bffb$export$7243359973253e5);

var $5uXOq = parcelRequire("5uXOq");

var $er8sA = parcelRequire("er8sA");

var $koVbs = parcelRequire("koVbs");


var $jhS4y = parcelRequire("jhS4y");

var $5FnJJ = parcelRequire("5FnJJ");

var $24a2m = parcelRequire("24a2m");

var $blEB6 = parcelRequire("blEB6");

var $isEeX = parcelRequire("isEeX");

var $aGzpx = parcelRequire("aGzpx");
const $77dfa228afe7bffb$export$7243359973253e5 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const schemasLink = (0, $5uXOq.useMemo)(()=>(0, $blEB6.getLandingPageUrl)(), []);
    const { icon: formattedSchemasIcon } = (0, $24a2m.useFormattedMessageAndIcon)((0, $aGzpx.default).jsmAssetsSchemas, (0, $er8sA.default));
    const { fireUINavigationItemAnalytics: fireUINavigationItemAnalytics } = (0, $isEeX.useAssetsUIAnalytics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        menuId: (0, $jhS4y.MENU_ID_ASSETS_SCHEMAS),
        elemBefore: formattedSchemasIcon,
        href: schemasLink,
        onClick: ()=>fireUINavigationItemAnalytics((0, $496585bee7985bb9$export$ca6db12118be69a1))
    }, formatMessage((0, $aGzpx.default).jsmAssetsSchemas));
};

});
parcelRegister("er8sA", function(module, exports) {

$parcel$export(module.exports, "default", () => $53e65d8c0991a293$export$2e2bcd8739ae039);
/**
 * Based on custom icon example:
 * https://atlassian.design/components/icon/custom-icon/examples
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $53e65d8c0991a293$var$JSMAssetsSchemasGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label']
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.5 7.5C8.05228 7.5 8.5 7.05228 8.5 6.5C8.5 5.94772 8.05228 5.5 7.5 5.5C6.94772 5.5 6.5 5.94772 6.5 6.5C6.5 7.05228 6.94772 7.5 7.5 7.5ZM10 6.5C10 7.61941 9.26428 8.56698 8.25 8.88555V10.5H14.1145C14.433 9.48572 15.3806 8.75 16.5 8.75C17.8807 8.75 19 9.86929 19 11.25C19 12.6307 17.8807 13.75 16.5 13.75C15.3806 13.75 14.433 13.0143 14.1145 12H8.25V16.25C8.25 16.6642 8.58579 17 9 17H14.05C14.2816 15.8589 15.2905 15 16.5 15C17.8807 15 19 16.1193 19 17.5C19 18.8807 17.8807 20 16.5 20C15.4748 20 14.5938 19.383 14.208 18.5H9C7.75736 18.5 6.75 17.4926 6.75 16.25V12V10.5V8.88555C5.73572 8.56698 5 7.61941 5 6.5C5 5.11929 6.11929 4 7.5 4C8.88071 4 10 5.11929 10 6.5ZM16.5 18.5C17.0523 18.5 17.5 18.0523 17.5 17.5C17.5 16.9477 17.0523 16.5 16.5 16.5C15.9477 16.5 15.5 16.9477 15.5 17.5C15.5 18.0523 15.9477 18.5 16.5 18.5ZM17.5 11.25C17.5 11.8023 17.0523 12.25 16.5 12.25C15.9477 12.25 15.5 11.8023 15.5 11.25C15.5 10.6977 15.9477 10.25 16.5 10.25C17.0523 10.25 17.5 10.6977 17.5 11.25Z",
        fill: "currentColor"
    }));
const $53e65d8c0991a293$var$JSMAssetsSchemasIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        ...props,
        glyph: $53e65d8c0991a293$var$JSMAssetsSchemasGlyph
    });
var $53e65d8c0991a293$export$2e2bcd8739ae039 = $53e65d8c0991a293$var$JSMAssetsSchemasIcon;

});

parcelRegister("aGzpx", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfefc3311594219e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bfefc3311594219e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    jsmAssetsSchemas: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.assets-menu.schemas.jsm-assets-schemas",
        "defaultMessage": "Schemas"
    }
});

});


parcelRegister("8Hhya", function(module, exports) {

$parcel$export(module.exports, "SectionActions", () => $cad83d2e8a58ef00$export$51f8029abf8c56ce);

var $5uXOq = parcelRequire("5uXOq");

var $epOG5 = parcelRequire("epOG5");

var $3Z96c = parcelRequire("3Z96c");
var $9UCCQ = parcelRequire("9UCCQ");

var $c0aEF = parcelRequire("c0aEF");

var $koVbs = parcelRequire("koVbs");




var $jecJ3 = parcelRequire("jecJ3");

var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $46Cti = parcelRequire("46Cti");

var $9eeFp = parcelRequire("9eeFp");

var $eaKdt = parcelRequire("eaKdt");

var $aCS3f = parcelRequire("aCS3f");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $blEB6 = parcelRequire("blEB6");

var $bwEvZ = parcelRequire("bwEvZ");
function $cad83d2e8a58ef00$export$51f8029abf8c56ce({ onClose: onClose, isInsightAdministrator: isInsightAdministrator = false }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onOpen = ()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'button',
            action: 'clicked'
        }), (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_ASSETS], {
            level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
            componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
            itemId: (0, $496585bee7985bb9$export$f06dfcec5ff912e)
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCS3f.MoreNavMenuButton), {
        MenuItems: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cad83d2e8a58ef00$var$MoreMenuItems, {
                ...props,
                isInsightAdministrator: isInsightAdministrator
            }),
        onClose: onClose,
        onOpen: ()=>onOpen()
    });
}
function $cad83d2e8a58ef00$var$MoreMenuItems({ onClose: onClose, isInsightAdministrator: isInsightAdministrator = false }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const configLink = (0, $5uXOq.useMemo)(()=>(0, $blEB6.getGlobalConfigUrl)(), []);
    const onCloseWithStopPropagation = (0, $9eeFp.useStopPropagation)(onClose);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onClick = (e)=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        }), (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_ASSETS], {
            level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
            componentType: (0, $1e554a683893bd46$export$74712b62056d422e),
            parentItemId: (0, $jecJ3.SECTION_ITEM_ASSETS),
            itemId: (0, $496585bee7985bb9$export$83d40997eb7cc5b7)
        });
        onCloseWithStopPropagation(e);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isInsightAdministrator ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Z96c.default), {
        href: configLink,
        onClick: (e)=>onClick(e)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($epOG5))), {
        label: formatMessage((0, $bwEvZ.default).jsmAssetsSettingsIcon),
        spacing: "spacious",
        color: "var(--ds-icon, #44546F)"
    }), formatMessage((0, $bwEvZ.default).jsmAssetsGlobalConfiguration)))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaKdt.HideL1MenuItemSection), {
        menuId: (0, $46Cti.L1_MENU_ID).ASSETS
    }));
}

});
parcelRegister("bwEvZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $41b3b3b94f3d9484$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $41b3b3b94f3d9484$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    jsmAssetsGlobalConfiguration: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.assets-menu.section-actions.jsm-assets-global-configuration",
        "defaultMessage": "General configuration"
    },
    jsmAssetsSettingsIcon: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.assets-menu.section-actions.jsm-assets-settings-icon",
        "defaultMessage": "Settings"
    }
});

});




parcelRegister("kcT7A", function(module, exports) {

$parcel$export(module.exports, "CustomerServiceAnalytics", () => $8beddc3162728349$export$5b58aa15c2701e8);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $1JmlQ = parcelRequire("1JmlQ");
const $8beddc3162728349$export$5b58aa15c2701e8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "flag",
        id: "assets",
        packageName: "jiraNavigationAppsSidebarNav4SidebarsContentCustomerService",
        teamName: "Kalari"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1JmlQ.CustomerServiceAnalyticsMenuLinkItem), null));

});
parcelRegister("1JmlQ", function(module, exports) {

$parcel$export(module.exports, "CustomerServiceAnalyticsMenuLinkItem", () => $0ffa5fb0eea93988$export$d4508bff4cbbd271);

var $5uXOq = parcelRequire("5uXOq");

var $eZUJu = parcelRequire("eZUJu");

var $jhS4y = parcelRequire("jhS4y");

var $46Cti = parcelRequire("46Cti");

var $5FnJJ = parcelRequire("5FnJJ");

var $dUyqZ = parcelRequire("dUyqZ");

var $eaKdt = parcelRequire("eaKdt");

var $aCS3f = parcelRequire("aCS3f");
const $0ffa5fb0eea93988$export$df8bbcec1e54e3c3 = '/jira/helpcenter/analytics';
const $0ffa5fb0eea93988$export$d4508bff4cbbd271 = ()=>{
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        testId: "navigation-apps-sidebar-nav4-sidebars-content-customer-service-analytics.ui.sidenav-customer-service",
        href: $0ffa5fb0eea93988$export$df8bbcec1e54e3c3,
        menuId: (0, $jhS4y.MENU_ID_CUSTOMER_SERVICE_ANALYTICS),
        elemBefore: icon,
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCS3f.MoreNavMenuButton), {
            MenuItems: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaKdt.HideL1MenuItemSection), {
                    menuId: (0, $jhS4y.MENU_ID_CUSTOMER_SERVICE_ANALYTICS),
                    hasSeparator: false
                }))
        })
    }, formattedMessage);
};

});


parcelRegister("aXxBX", function(module, exports) {

$parcel$export(module.exports, "CustomerService", () => $a426b2d854204abe$export$5c26f0ffd7a4820d);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $6oVYF = parcelRequire("6oVYF");
const $a426b2d854204abe$export$5c26f0ffd7a4820d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "flag",
        id: "assets",
        packageName: "jiraNavigationAppsSidebarNav4SidebarsContentCustomerService",
        teamName: "Boysenberry"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6oVYF.CustomerServiceMenuLinkItem), null));

});
parcelRegister("6oVYF", function(module, exports) {

$parcel$export(module.exports, "CustomerServiceMenuLinkItem", () => $f06b8199f1c8d83f$export$276375fee74f0f11);

var $5uXOq = parcelRequire("5uXOq");

var $eZUJu = parcelRequire("eZUJu");

var $jhS4y = parcelRequire("jhS4y");

var $46Cti = parcelRequire("46Cti");

var $5FnJJ = parcelRequire("5FnJJ");

var $dUyqZ = parcelRequire("dUyqZ");

var $eaKdt = parcelRequire("eaKdt");

var $aCS3f = parcelRequire("aCS3f");

var $4R6GH = parcelRequire("4R6GH");
const $f06b8199f1c8d83f$export$208752a9164e5a6d = '/jira/helpcenter';
const $f06b8199f1c8d83f$export$276375fee74f0f11 = ()=>{
    const customerServiceMenuId = (0, $4R6GH.fg)('jcs_project_type_m3') ? (0, $46Cti.L1_MENU_ID).CUSTOMER_HUBS : (0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)(customerServiceMenuId);
    const menuId = (0, $4R6GH.fg)('jcs_project_type_m3') ? (0, $jhS4y.MENU_ID_CUSTOMER_HUBS) : (0, $jhS4y.MENU_ID_CUSTOMER_SERVICE);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        testId: "navigation-apps-sidebar-nav4-sidebars-content-customer-service.ui.sidenav-customer-service",
        href: $f06b8199f1c8d83f$export$208752a9164e5a6d,
        menuId: menuId,
        elemBefore: icon,
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCS3f.MoreNavMenuButton), {
            MenuItems: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaKdt.HideL1MenuItemSection), {
                    menuId: menuId,
                    hasSeparator: false
                }))
        })
    }, formattedMessage);
};

});


parcelRegister("kcmzD", function(module, exports) {

$parcel$export(module.exports, "Nav4Dashboards", () => $66938623734b1b6f$export$14aa7c6c8f362b5b);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $l8ruj = parcelRequire("l8ruj");

var $ahfXZ = parcelRequire("ahfXZ");

var $6MFxN = parcelRequire("6MFxN");

const $66938623734b1b6f$export$14aa7c6c8f362b5b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4-sidebar-dashboards"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "flag",
        id: "dashboards-section",
        packageName: (0, $ddbe4b334e21c7a1$export$b8b9d90f9e5bd72b),
        teamName: (0, $ddbe4b334e21c7a1$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6MFxN.AnalyticContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ahfXZ.Nav4Dashboards), props))));

});
parcelRegister("ahfXZ", function(module, exports) {

$parcel$export(module.exports, "Nav4Dashboards", () => $a67ed45d3a5ce5eb$export$14aa7c6c8f362b5b);

var $5uXOq = parcelRequire("5uXOq");

var $ayvjE = parcelRequire("ayvjE");

var $8urqk = parcelRequire("8urqk");
function $a67ed45d3a5ce5eb$export$14aa7c6c8f362b5b({ isExpanded: isExpanded }) {
    const actionButtons = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ayvjE.ActionButtons), null), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8urqk.DashboardsDefault), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded
    });
}

});
parcelRegister("ayvjE", function(module, exports) {

$parcel$export(module.exports, "ActionButtons", () => $feeebb4436f3de85$export$88c65d2d98aab183);

var $5uXOq = parcelRequire("5uXOq");

var $dZbEw = parcelRequire("dZbEw");

var $eZUJu = parcelRequire("eZUJu");

var $3bDjY = parcelRequire("3bDjY");

var $Mp6qH = parcelRequire("Mp6qH");

var $jgE05 = parcelRequire("jgE05");

var $koVbs = parcelRequire("koVbs");

var $46Cti = parcelRequire("46Cti");

var $1xonH = parcelRequire("1xonH");

var $eaKdt = parcelRequire("eaKdt");

var $aCS3f = parcelRequire("aCS3f");

var $6jY6G = parcelRequire("6jY6G");

var $e9QkH = parcelRequire("e9QkH");

var $9VXkC = parcelRequire("9VXkC");
var $lVJAU = parcelRequire("lVJAU");

var $4R6GH = parcelRequire("4R6GH");

var $eIGIx = parcelRequire("eIGIx");


var $6MFxN = parcelRequire("6MFxN");

var $kg2u4 = parcelRequire("kg2u4");
function $feeebb4436f3de85$export$88c65d2d98aab183() {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [, { off: modalClose }] = (0, $e9QkH.useSwitchModals)((0, $Mp6qH.MODAL_ID).DASHBOARD_CREATE);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { path: path } = (0, $6jY6G.useRouteByName)('dashboard-edit') ?? {};
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const onSuccess = (0, $5uXOq.useCallback)((_, { id: id })=>{
        path && push((0, $9VXkC.generatePath)(path, {
            dashboardId: id
        }));
        setIsOpen(false);
        modalClose();
    }, [
        modalClose,
        path,
        push
    ]);
    const { fireUIAnalyticForFixButton: fireUIAnalyticForFixButton } = (0, $5uXOq.useContext)((0, $6MFxN.AnalyticContext));
    const onCancelCreateDashboardModal = (0, $eIGIx.useCallbackWithCondition)(()=>{
        setIsOpen(false);
        modalClose();
    }, [
        modalClose
    ], ()=>(0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1'));
    const onClickCommonNavMenuButton = (0, $eIGIx.useCallbackWithCondition)(()=>{
        fireUIAnalyticForFixButton({
            itemId: (0, $ddbe4b334e21c7a1$export$7be02fe416808d26)
        });
        setIsOpen(true);
    }, [
        fireUIAnalyticForFixButton
    ], ()=>(0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1'));
    const onOpenMoreNavMenuButton = (0, $eIGIx.useCallbackWithCondition)(()=>fireUIAnalyticForFixButton({
            itemId: (0, $ddbe4b334e21c7a1$export$f06dfcec5ff912e)
        }), [
        fireUIAnalyticForFixButton
    ], ()=>(0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgE05.default), {
        onSuccess: onSuccess,
        onCancel: onCancelCreateDashboardModal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $kg2u4.default).createDashboard)
    }, (0, $4R6GH.fg)('blu-7837_apply_presstrace_nav4') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1xonH.CommonNavMenuButton), {
        interactionName: "nav4-sidebar-dashboards-create-button",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage((0, $kg2u4.default).createDashboard),
        onClick: onClickCommonNavMenuButton
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1xonH.CommonNavMenuButton), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage((0, $kg2u4.default).createDashboard),
        onClick: onClickCommonNavMenuButton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCS3f.MoreNavMenuButton), {
        onOpen: onOpenMoreNavMenuButton,
        MenuItems: (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? $feeebb4436f3de85$var$MenuItems : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaKdt.HideL1MenuItemSection), {
                menuId: (0, $46Cti.L1_MENU_ID).DASHBOARDS,
                hasSeparator: false
            }))
    }));
}
const $feeebb4436f3de85$var$MenuItems = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaKdt.HideL1MenuItemSection), {
        menuId: (0, $46Cti.L1_MENU_ID).DASHBOARDS,
        hasSeparator: false
    }));

});
parcelRegister("Mp6qH", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $d722fd8ef23adae6$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $d722fd8ef23adae6$export$d57b6b390e78d90f);
$parcel$export(module.exports, "DEFAULT_LOAD_COUNT_FAV", () => $d722fd8ef23adae6$export$ea341e6cc435ed40);
$parcel$export(module.exports, "DEFAULT_LOAD_COUNT_VIEWED", () => $d722fd8ef23adae6$export$cb66c02d110b1531);
$parcel$export(module.exports, "DEFAULT_LOAD_COUNT_RECENT", () => $d722fd8ef23adae6$export$22ea57e66775a6b2);
$parcel$export(module.exports, "TOP_LEVEL_ERROR_BOUNDARY_ID", () => $d722fd8ef23adae6$export$4766f0c4b6fe35dc);
$parcel$export(module.exports, "NAVIGATION_ITEM_ID", () => $d722fd8ef23adae6$export$1a9b265c626e9d44);
$parcel$export(module.exports, "MODAL_ID", () => $d722fd8ef23adae6$export$ebdd5a8e5b1c2de5);
$parcel$export(module.exports, "PROFILE_SPOTLIGHT_KEY", () => $d722fd8ef23adae6$export$6037915bf3452cf3);
$parcel$export(module.exports, "HELP_SPOTLIGHT_KEY", () => $d722fd8ef23adae6$export$286c2faa2103eb9c);
$parcel$export(module.exports, "SEARCH_SPOTLIGHT_KEY", () => $d722fd8ef23adae6$export$c0d6ac131d4391b9);
$parcel$export(module.exports, "PROJECTS_SPOTLIGHT_KEY", () => $d722fd8ef23adae6$export$8d9442dfaec4086f);
$parcel$export(module.exports, "EXPERIENCE_NAVIGATION_TOP_MAIN", () => $d722fd8ef23adae6$export$3014c5ec440d8824);
$parcel$export(module.exports, "EXPERIENCE_NAVIGATION_TOP_MENU", () => $d722fd8ef23adae6$export$69cbedccc0df48);
$parcel$export(module.exports, "YOUR_WORK_DROPDOWN_TAB_ID", () => $d722fd8ef23adae6$export$1935aad1d702494c);
$parcel$export(module.exports, "JSW_TMP_BACKLOG_BOARD_REGEXP", () => $d722fd8ef23adae6$export$cc578bc72d7a7308);
const $d722fd8ef23adae6$export$b8b9d90f9e5bd72b = '@atlassian/jira-atlassian-navigation';
const $d722fd8ef23adae6$export$d57b6b390e78d90f = 'navigation';
const $d722fd8ef23adae6$export$ea341e6cc435ed40 = 15;
const $d722fd8ef23adae6$export$cb66c02d110b1531 = 10;
const $d722fd8ef23adae6$export$22ea57e66775a6b2 = 5;
const $d722fd8ef23adae6$export$4766f0c4b6fe35dc = 'TOP_LEVEL';
const $d722fd8ef23adae6$export$1a9b265c626e9d44 = {
    ADDONS: 'apps',
    CREATE: 'createIssue',
    APP_SWITCHER: 'atlassianSwitcher',
    DASHBOARDS: 'dashboards',
    FILTERS: 'filters',
    HELP: 'help',
    HELP_BADGE: 'helpBadge',
    HOME: 'home',
    INSIGHT: 'insight',
    LOGO: 'productLogo',
    NOTIFICATIONS: 'notifications',
    PEOPLE: 'people',
    PLANS: 'plans',
    PROFILE: 'profile',
    PROJECTS: 'projects',
    ROADMAPS: 'roadmaps',
    SEARCH: 'search',
    SERVICE_HUB: 'services',
    SETTINGS: 'settings',
    SIGN_IN: 'signIn',
    YOUR_WORK_DROPDOWN: 'yourWorkDropdown',
    CONVERSATION_ASSISTANT: 'conversationAssistant',
    ROVO_DEMAND_TESTS: 'rovoDemandTests'
};
const $d722fd8ef23adae6$export$ebdd5a8e5b1c2de5 = {
    DASHBOARD_CREATE: 'DASHBOARD_CREATE',
    KEYBOARD_SHORTCUTS: 'keyboard-shortcuts',
    PROJECT_CREATE: 'PROJECT_CREATE'
};
const $d722fd8ef23adae6$export$6037915bf3452cf3 = 'profile-spotlight';
const $d722fd8ef23adae6$export$286c2faa2103eb9c = 'help-spotlight';
const $d722fd8ef23adae6$export$c0d6ac131d4391b9 = 'search-spotlight';
const $d722fd8ef23adae6$export$8d9442dfaec4086f = 'projects-spotlight';
const $d722fd8ef23adae6$export$3014c5ec440d8824 = 'viewAtlassianNavigation';
const $d722fd8ef23adae6$export$69cbedccc0df48 = 'viewAtlassianNavigationMenu';
const $d722fd8ef23adae6$export$1935aad1d702494c = {
    RECENT: 'RECENT',
    BOARDS: 'BOARDS',
    QUEUES: 'QUEUES',
    ASSIGNED_TO_ME: 'ASSIGNED_TO_ME',
    ADD_FILTER: 'ADD_FILTER',
    ALERTS: 'ALERTS'
};
const $d722fd8ef23adae6$export$cc578bc72d7a7308 = /jira\/software\/projects\/[a-zA-Z0-9]+\/boards\/\d+(\/backlog)?/;

});

parcelRegister("jgE05", function(module, exports) {

$parcel$export(module.exports, "default", () => $927aeb284ed7a228$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $927aeb284ed7a228$var$AsyncCreateDashboardModal = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("94ZKl")), {
    ssr: false,
    moduleId: "./src/packages/global-pages/directories/dashboards-directory-v2/create-dashboard-modal/src/index.tsx"
});
const $927aeb284ed7a228$var$AsyncCreateDashboardModalContainer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "create-dashboard-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($927aeb284ed7a228$var$AsyncCreateDashboardModal, props));
var $927aeb284ed7a228$export$2e2bcd8739ae039 = $927aeb284ed7a228$var$AsyncCreateDashboardModalContainer;

});
parcelRegister("94ZKl", function(module, exports) {

let $69c46253fb3e8cf2$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $69c46253fb3e8cf2$var$load("ffQaD"),
    $69c46253fb3e8cf2$var$load("kvRbA"),
    $69c46253fb3e8cf2$var$load("clgj9")
]).then(()=>parcelRequire('eTZZm'));

});


parcelRegister("e9QkH", function(module, exports) {

$parcel$export(module.exports, "useSwitchModals", () => $bbe85969245206f0$export$5ed4b99cbad4ebd6);

var $2qauD = parcelRequire("2qauD");
const { useSwitch: $bbe85969245206f0$var$useSwitch } = (0, $2qauD.createSwitchController)('jira-switch-modals');
const $bbe85969245206f0$export$5ed4b99cbad4ebd6 = $bbe85969245206f0$var$useSwitch;

});
parcelRegister("2qauD", function(module, exports) {

$parcel$export(module.exports, "createSwitchController", () => $a539fc33301c42ee$export$1856548326159ec8);

var $5uXOq = parcelRequire("5uXOq");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $a539fc33301c42ee$export$1856548326159ec8 = (name, activeByDefault)=>{
    const actions = {
        on: (active)=>({ setState: setState })=>setState({
                    active: active
                }),
        off: (active)=>({ setState: setState, getState: getState })=>{
                if (getState().active === active || active === undefined) setState({
                    active: undefined
                });
            },
        toggle: (active)=>({ getState: getState, dispatch: dispatch })=>{
                if (getState().active === active) dispatch(actions.off(active));
                else dispatch(actions.on(active));
            }
    };
    const initialState = {
        active: activeByDefault
    };
    const store = (0, $iXqE5.createStore)({
        name: name,
        initialState: initialState,
        actions: actions
    });
    const SwitchContainer = (0, $gg7kZ.createContainer)(store);
    const selector = (state, key)=>state.active === key;
    const useSwitchInternal = (0, $3sQ5x.createHook)(store, {
        selector: selector
    });
    const useSwitch = (active)=>{
        const [isActive, { on: onSwitch, off: offSwitch, toggle: toggleSwitch }] = useSwitchInternal(active);
        const on = (0, $5uXOq.useCallback)(()=>onSwitch(active), [
            onSwitch,
            active
        ]);
        const off = (0, $5uXOq.useCallback)(()=>offSwitch(active), [
            active,
            offSwitch
        ]);
        const toggle = (0, $5uXOq.useCallback)(()=>toggleSwitch(active), [
            toggleSwitch,
            active
        ]);
        return [
            isActive,
            {
                on: on,
                off: off,
                toggle: toggle
            }
        ];
    };
    return {
        SwitchContainer: SwitchContainer,
        useSwitch: useSwitch
    };
};

});


const $ddbe4b334e21c7a1$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Dashboards';
const $ddbe4b334e21c7a1$export$d57b6b390e78d90f = 'jira-cosmos';
const $ddbe4b334e21c7a1$export$65b778215f917c60 = 'viewAllDashboards';
const $ddbe4b334e21c7a1$export$7be02fe416808d26 = 'createDashboard';
const $ddbe4b334e21c7a1$export$f06dfcec5ff912e = 'meatballDropdown';

parcelRegister("6MFxN", function(module, exports) {

$parcel$export(module.exports, "AnalyticContext", () => $12282e91517b56b8$export$da0556bf821b3494);
$parcel$export(module.exports, "AnalyticContextProvider", () => $12282e91517b56b8$export$aea8e3edcdec81e3);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");




var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

const $12282e91517b56b8$export$da0556bf821b3494 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    fireUIAnalyticForFixMenuItem: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    fireUIAnalyticForFixButton: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    fireUIAnalyticForFavouriteToggle: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    fireUIAnalyticForDashboardItems: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
});
const $12282e91517b56b8$export$aea8e3edcdec81e3 = ({ children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireUIAnalyticForFixMenuItem = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_DASHBOARDS],
            attributes: {
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                itemId: (0, $ddbe4b334e21c7a1$export$65b778215f917c60)
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireUIAnalyticForFixButton = (0, $5uXOq.useCallback)(({ itemId: itemId })=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_DASHBOARDS],
            attributes: {
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                itemId: itemId
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireUIAnalyticForFavouriteToggle = (0, $5uXOq.useCallback)(({ starType: starType, parentItemId: parentItemId })=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_DASHBOARDS],
            attributes: {
                level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                componentType: (0, $1e554a683893bd46$export$74712b62056d422e),
                parentItemId: parentItemId,
                parentItemType: 'dashboard',
                itemId: starType
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireUIAnalyticForDashboardItems = (0, $5uXOq.useCallback)(({ itemId: itemId, section: section })=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_DASHBOARDS],
            attributes: {
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                componentType: (0, $1e554a683893bd46$export$3ac911b122986477),
                itemType: (0, $632bd8725b437a12$export$4695c1a423ffe431).toLowerCase(),
                itemId: itemId,
                section: section
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const memoValue = (0, $5uXOq.useMemo)(()=>({
            fireUIAnalyticForFixMenuItem: fireUIAnalyticForFixMenuItem,
            fireUIAnalyticForFixButton: fireUIAnalyticForFixButton,
            fireUIAnalyticForFavouriteToggle: fireUIAnalyticForFavouriteToggle,
            fireUIAnalyticForDashboardItems: fireUIAnalyticForDashboardItems
        }), [
        fireUIAnalyticForDashboardItems,
        fireUIAnalyticForFavouriteToggle,
        fireUIAnalyticForFixButton,
        fireUIAnalyticForFixMenuItem
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12282e91517b56b8$export$da0556bf821b3494.Provider, {
        value: memoValue
    }, children);
};

});

parcelRegister("kg2u4", function(module, exports) {

$parcel$export(module.exports, "default", () => $0357cb1b75baecf6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0357cb1b75baecf6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createDashboard: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-dashboards.common.action-buttons.create-dashboard",
        "defaultMessage": "Create dashboard"
    }
});

});


parcelRegister("8urqk", function(module, exports) {

$parcel$export(module.exports, "DashboardsDefault", () => $ddb064d4de558bd2$export$bffc92c7e4f51e0b);

var $5uXOq = parcelRequire("5uXOq");

var $lnznH = parcelRequire("lnznH");
var $cZa9B = parcelRequire("cZa9B");

var $4mO32 = parcelRequire("4mO32");

var $jecJ3 = parcelRequire("jecJ3");

var $jhS4y = parcelRequire("jhS4y");

var $46Cti = parcelRequire("46Cti");

var $c16H2 = parcelRequire("c16H2");

var $338xa = parcelRequire("338xa");

var $dQbFB = parcelRequire("dQbFB");

var $eQV8d = parcelRequire("eQV8d");

var $dUyqZ = parcelRequire("dUyqZ");

var $4zcxJ = parcelRequire("4zcxJ");

var $koeKL = parcelRequire("koeKL");


var $2Ioew = parcelRequire("2Ioew");

var $5GG0x = parcelRequire("5GG0x");


var $ehnIE = parcelRequire("ehnIE");

var $h4rc7 = parcelRequire("h4rc7");
const $ddb064d4de558bd2$export$bffc92c7e4f51e0b = /*#__PURE__*/ (0, $5uXOq.memo)($ddb064d4de558bd2$var$_DashboardsDefault);
function $ddb064d4de558bd2$var$_DashboardsDefault(props) {
    const { actionsOnHover: actionsOnHover, isExpanded: isExpanded } = props;
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const cloudId = (0, $koeKL.useCloudId)();
    // Ignore this error as our component does not need the context.
    // @ts-expect-error - Property 'context' is missing in type '{ tenantContext: { cloudId: string; }; }' but required in type 'EntryPointRouteParams'.ts(2741)
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            tenantContext: {
                cloudId: cloudId
            }
        }), [
        cloudId
    ]);
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, react-hooks/rules-of-hooks
    const leftSidebarEPRef = (0, $2Ioew.usePageLayoutEntryPoint)((0, $6d6ccf8a2b2c5b3c$export$50ea883ba6f28ff5));
    const dashboardsEPRef = leftSidebarEPRef?.entryPoints?.dashboards;
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $h4rc7.nav4DashboardsContentEntryPoint), entryPointParams);
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const triggerRef = (0, $4zcxJ.useExpandableEntryPointTrigger)(entryPointActions);
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).DASHBOARDS);
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const epContainerProps = (0, $5uXOq.useMemo)(()=>({
            id: 'nav4-sidebar-dashboards-default',
            packageName: (0, $ddbe4b334e21c7a1$export$b8b9d90f9e5bd72b),
            teamName: (0, $ddbe4b334e21c7a1$export$d57b6b390e78d90f),
            errorFallback: 'flag',
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), null),
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            runtimeProps: entryPointParams
        }), [
        entryPointParams
    ]);
    // This callback makes sure that the EP is loaded when the _system_ determines that the expandable
    // should be open.
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const onSystemToggleFn = (0, $5uXOq.useCallback)((hasExpanded)=>{
        if (hasExpanded) entryPointActions.load();
    }, [
        entryPointActions
    ]);
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const onExpansionToggleFn = (0, $5uXOq.useCallback)((hasExpanded)=>{
        if (hasExpanded) {
            entryPointActions.load();
            sendSectionItemAnalyticsEvent({
                menuId: (0, $46Cti.L1_MENU_ID).DASHBOARDS,
                sectionItem: (0, $jecJ3.SECTION_ITEM_DASHBOARDS)
            });
        }
    }, [
        entryPointActions,
        sendSectionItemAnalyticsEvent
    ]);
    const menuId = (0, $jhS4y.MENU_ID_DASHBOARDS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onSystemToggle: onSystemToggleFn,
        onExpansionToggle: onExpansionToggleFn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZa9B.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-dashboards-default",
        actionsOnHover: actionsOnHover,
        "aria-label": formattedMessage,
        elemBefore: icon,
        ref: triggerRef,
        testId: (0, $dQbFB.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnznH.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5GG0x.RouteEntryPointContainer), {
        epContainerProps: epContainerProps,
        jiraEPRef: entryPointReferenceSubject,
        nestedEPRef: dashboardsEPRef,
        placeholderEntryPoint: (0, $h4rc7.nav4DashboardsContentEntryPoint)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehnIE.Footer), null)));
}

});
parcelRegister("2Ioew", function(module, exports) {

$parcel$export(module.exports, "usePageLayoutEntryPoint", () => $dcf886ac39f7cfda$export$fe1c839e8baf4110);

var $h22md = parcelRequire("h22md");

var $6jY6G = parcelRequire("6jY6G");
const $dcf886ac39f7cfda$export$fe1c839e8baf4110 = (layoutField)=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const entryPointReference = (0, $h22md.useRouteEntryPoint)({
        route: route
    });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return entryPointReference?.entryPoints[layoutField];
};

});
parcelRegister("h22md", function(module, exports) {

$parcel$export(module.exports, "useRouteEntryPoint", () => $4e1bc9edc261b42d$export$c96377f800cdddb4);

var $3I4nj = parcelRequire("3I4nj");
const $4e1bc9edc261b42d$export$c96377f800cdddb4 = ({ route: route })=>{
    const [lastLoadedRoute] = (0, $3I4nj.useLastLoadedRoute)();
    // route.entryPoint is already loaded
    if (lastLoadedRoute && lastLoadedRoute.entryPointReference && lastLoadedRoute.route === route) return lastLoadedRoute.entryPointReference;
    return null;
};

});
parcelRegister("3I4nj", function(module, exports) {

$parcel$export(module.exports, "useLastLoadedRoute", () => $f09634e8d32626d1$export$895238443fc3eae4);
$parcel$export(module.exports, "getEntryPointsStore", () => $f09634e8d32626d1$export$fe654a734624d17f);
$parcel$export(module.exports, "getLastLoadedRoute", () => $f09634e8d32626d1$export$5763b2305b3056df);
$parcel$export(module.exports, "getPrefetchingRoute", () => $f09634e8d32626d1$export$7e18f3e3cbd04326);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $bKpgX = parcelRequire("bKpgX");
const $f09634e8d32626d1$export$1cec83a23d40a9fa = ({ route: route, entryPointReference: entryPointReference })=>({ setState: setState })=>{
        setState({
            lastLoadedRoute: {
                route: route,
                entryPointReference: entryPointReference
            }
        });
    };
const $f09634e8d32626d1$export$bb3dc9c55f78173e = ({ routerContext: routerContext, entryPointReference: entryPointReference, expiresAt: expiresAt })=>({ setState: setState })=>{
        setState({
            prefetchingRoute: {
                routerContext: routerContext,
                expiresAt: expiresAt,
                entryPointReference: entryPointReference
            }
        });
    };
const $f09634e8d32626d1$var$actions = {
    setLastLoadedRoute: $f09634e8d32626d1$export$1cec83a23d40a9fa,
    setPrefetchingRoute: $f09634e8d32626d1$export$bb3dc9c55f78173e
};
const $f09634e8d32626d1$var$EntryPointsStore = (0, $iXqE5.createStore)({
    initialState: {
        lastLoadedRoute: null,
        prefetchingRoute: null
    },
    actions: $f09634e8d32626d1$var$actions,
    name: 'react-resource-router/entry-points'
});
const $f09634e8d32626d1$export$895238443fc3eae4 = (0, $3sQ5x.createHook)($f09634e8d32626d1$var$EntryPointsStore, {
    selector: (state)=>state.lastLoadedRoute
});
const $f09634e8d32626d1$export$fe654a734624d17f = ()=>(0, $bKpgX.defaultRegistry).getStore($f09634e8d32626d1$var$EntryPointsStore);
const $f09634e8d32626d1$export$b28ecd0e4705f6b7 = ()=>$f09634e8d32626d1$export$fe654a734624d17f().storeState.getState();
const $f09634e8d32626d1$export$5763b2305b3056df = ()=>$f09634e8d32626d1$export$b28ecd0e4705f6b7().lastLoadedRoute;
const $f09634e8d32626d1$export$7e18f3e3cbd04326 = ()=>$f09634e8d32626d1$export$b28ecd0e4705f6b7().prefetchingRoute;

});



parcelRegister("5GG0x", function(module, exports) {

$parcel$export(module.exports, "RouteEntryPointContainer", () => $36ec2bd8bdc583ac$export$3e4cdfb894377bc9);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $frBVt = parcelRequire("frBVt");

var $7XluA = parcelRequire("7XluA");

var $7CMCs = parcelRequire("7CMCs");

var $l8ruj = parcelRequire("l8ruj");
const $36ec2bd8bdc583ac$export$3e4cdfb894377bc9 = /*#__PURE__*/ (0, $5uXOq.memo)(({ epContainerProps: epContainerProps, jiraEPRef: jiraEPRef, nestedEPRef: nestedEPRef, shouldRenderNestedEntryPoint: shouldRenderNestedEntryPoint = true })=>{
    // If the route is an entryPoint, and the initialRoute was an entryPoint, use EntryPointContainer.
    // Otherwise, use the JiraEntryPointContainer.
    return shouldRenderNestedEntryPoint && nestedEPRef ? // eslint-disable-next-line jira/ufo/valid-labels
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: `${epContainerProps.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        attributes: epContainerProps.errorAttributes,
        fallback: epContainerProps.errorFallback,
        id: epContainerProps.id,
        packageName: epContainerProps.packageName,
        teamName: epContainerProps.teamName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $frBVt.EntryPointReferencePlaceholder), {
        name: `${epContainerProps.id || 'route-entrypoint-adapter'}-entrypoint-placeholder`,
        fallback: epContainerProps.fallback,
        entryPointReference: nestedEPRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
        entryPointReference: nestedEPRef,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props: {}
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        ...epContainerProps,
        entryPointReferenceSubject: jiraEPRef
    });
});

});
parcelRegister("frBVt", function(module, exports) {

$parcel$export(module.exports, "getPlaceholdersFromHTML", () => $126443352ff757de$export$9e9f35acc3af3a9a);
$parcel$export(module.exports, "EntryPointPlaceholderContext", () => $126443352ff757de$export$b5b377bb81310c48);
$parcel$export(module.exports, "EntryPointReferencePlaceholder", () => $126443352ff757de$export$35247b69e0cfe74);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $4R6GH = parcelRequire("4R6GH");

var $7XYc4 = parcelRequire("7XYc4");
const $126443352ff757de$var$styles = {
    root: "_1e0c1bgi"
};
const $126443352ff757de$var$Placeholder = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jfp-magma-concurrent-fix-entrypoint-placeholder'), (0, $lfTZh.PlaceholderWithNativeSuspense), (0, $lfTZh.default));
function $126443352ff757de$export$9e9f35acc3af3a9a() {
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const placeholders = document.querySelectorAll('[data-ep-placeholder-id]');
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return new Map(Array.from(placeholders, (el)=>[
            el.dataset.epPlaceholderId,
            el.innerHTML
        ]));
}
const $126443352ff757de$export$b5b377bb81310c48 = /*#__PURE__*/ (0, $5uXOq.createContext)(new Map());
function $126443352ff757de$export$35247b69e0cfe74({ children: children, entryPointReference: entryPointReference, fallback: originalFallback, name: name, ...placeholderProps }) {
    const hasMounted = (0, $5uXOq.useRef)(false);
    // using useState to ensure the entryPointReference is loaded synchronously
    // for the initial render (enabling SSR)
    const [component] = (0, $5uXOq.useState)(()=>{
        if (entryPointReference) try {
            return entryPointReference.getComponent();
        } catch (thrown) {
            return undefined;
        }
    });
    const placeholders = (0, $5uXOq.useContext)($126443352ff757de$export$b5b377bb81310c48);
    const ssrFallback = placeholders.get(name);
    const [fallback, setFallback] = (0, $5uXOq.useState)(!ssrFallback || component ? originalFallback : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: ssrFallback
        },
        "data-ep-placeholder-id": name,
        className: (0, $bwpsq.default)([
            $126443352ff757de$var$styles.root
        ])
    }));
    const lastOriginalFallback = (0, $5uXOq.useRef)(originalFallback);
    lastOriginalFallback.current = originalFallback;
    const resetFallback = (0, $5uXOq.useCallback)(()=>{
        if (placeholders.has(name)) {
            placeholders.delete(name);
            setFallback(lastOriginalFallback.current);
        }
    }, [
        name,
        placeholders,
        setFallback
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        // reset the fallback when the entrypoint reference changes
        if (hasMounted.current) resetFallback();
    }, [
        entryPointReference,
        resetFallback
    ]);
    (0, $5uXOq.useEffect)(()=>{
        hasMounted.current = true;
        // reset fallback on unmount
        return resetFallback;
    }, [
        resetFallback
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($126443352ff757de$var$Placeholder, {
        fallback: fallback,
        name: name,
        ...placeholderProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-ep-placeholder-id": name,
        className: (0, $bwpsq.default)([
            $126443352ff757de$var$styles.root
        ])
    }, children));
}

});


parcelRegister("ehnIE", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $efafdfdbad2ab24a$export$a06f1c675e846f6f);

var $5uXOq = parcelRequire("5uXOq");

var $gSZmd = parcelRequire("gSZmd");
var $1qQhw = parcelRequire("1qQhw");
var $1FdfO = parcelRequire("1FdfO");

var $koVbs = parcelRequire("koVbs");

var $jhS4y = parcelRequire("jhS4y");

var $34PKs = parcelRequire("34PKs");

var $dDmlh = parcelRequire("dDmlh");

var $6MFxN = parcelRequire("6MFxN");

var $djUjd = parcelRequire("djUjd");
const $efafdfdbad2ab24a$var$VIEW_ALL_DASHBOARDS_HREF = (0, $dDmlh.dashboardsDirectoryRoute).path;
const $efafdfdbad2ab24a$export$a06f1c675e846f6f = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { fireUIAnalyticForFixMenuItem: fireUIAnalyticForFixMenuItem } = (0, $5uXOq.useContext)((0, $6MFxN.AnalyticContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1qQhw.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1FdfO.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gSZmd.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $34PKs.ViewAllEntityMenuItem), {
        href: $efafdfdbad2ab24a$var$VIEW_ALL_DASHBOARDS_HREF,
        menuId: (0, $jhS4y.MENU_ID_DASHBOARDS_VIEW_ALL),
        onClick: (e)=>{
            fireUIAnalyticForFixMenuItem();
            onClose?.(e);
        }
    }, formatMessage((0, $djUjd.default).viewAllDashboards)))));
};

});
parcelRegister("34PKs", function(module, exports) {

$parcel$export(module.exports, "ViewAllEntityMenuItem", () => $5926a0296e1ab93a$export$505e81ff2081288b);

var $5uXOq = parcelRequire("5uXOq");

var $6L0PY = parcelRequire("6L0PY");

var $5FnJJ = parcelRequire("5FnJJ");
function $5926a0296e1ab93a$export$505e81ff2081288b(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        ...props,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6L0PY))), {
            label: "",
            color: "currentColor"
        })
    });
}

});
parcelRegister("6L0PY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8c17960d483820ffdc74817869db42b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4eb7c81f940e2211$var$_react = $4eb7c81f940e2211$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4eb7c81f940e2211$var$_baseNew = $4eb7c81f940e2211$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $4eb7c81f940e2211$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignTextLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: align text left, align content left, summary.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4eb7c81f940e2211$var$AlignTextLeftIcon = (props)=>/*#__PURE__*/ $4eb7c81f940e2211$var$_react.default.createElement($4eb7c81f940e2211$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm0 5.25H1v-1.5h14zM8 14H1v-1.5h7z" clip-rule="evenodd"/>`
    }, props));
$4eb7c81f940e2211$var$AlignTextLeftIcon.displayName = 'AlignTextLeftIcon';
var $4eb7c81f940e2211$var$_default = module.exports.default = $4eb7c81f940e2211$var$AlignTextLeftIcon;

});


parcelRegister("djUjd", function(module, exports) {

$parcel$export(module.exports, "default", () => $93087624b28395ab$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $93087624b28395ab$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    viewAllDashboards: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-dashboards.common.footer.view-all-dashboards",
        "defaultMessage": "View all dashboards"
    }
});

});


parcelRegister("h4rc7", function(module, exports) {

$parcel$export(module.exports, "nav4DashboardsContentEntryPoint", () => $3f7d81973c7cae41$export$d6e6956d3748383b);

var $fTvGY = parcelRequire("fTvGY");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $3f7d81973c7cae41$export$d6e6956d3748383b = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("jlxKs")).then(({ DashboardsContentViewQuery: DashboardsContentViewQuery })=>DashboardsContentViewQuery), {
        moduleId: "d524dcfe",
        moduleName: "DashboardsContentViewQuery",
        priority: "userVisible"
    }),
    getPreloadProps: (params)=>{
        const cloudId = params.tenantContext?.cloudId || '';
        return {
            queries: {
                queryRef: {
                    parameters: $fTvGY.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        };
    }
});

});
parcelRegister("fTvGY", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb948c176bb6527e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6793555e2dbfaf8db2fe4c7edd9d81f4>>
 * @relayHash 9a58486151638f4e45660f746394b248
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 187971dfb7440b89eb5a98f67e766ec91b921dc8dd450612125a7211123e347d
const $cb948c176bb6527e$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "187971dfb7440b89eb5a98f67e766ec91b921dc8dd450612125a7211123e347d",
        "metadata": {},
        "name": "DashboardsContentViewQuery",
        "operationKind": "query",
        "text": null
    }
};
var $cb948c176bb6527e$export$2e2bcd8739ae039 = $cb948c176bb6527e$var$node;

});

parcelRegister("jlxKs", function(module, exports) {

let $03a27c84e2b07f93$var$load = (parcelRequire("28QjX"))(4);
module.exports = $03a27c84e2b07f93$var$load("6c5on").then(()=>parcelRequire('gSGR3'));

});





parcelRegister("blbXb", function(module, exports) {

$parcel$export(module.exports, "Nav4Filters", () => $6d9491a946e77dbf$export$caf6e58bb8560bb2);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $iuhhQ = parcelRequire("iuhhQ");

var $l8ruj = parcelRequire("l8ruj");

const $6d9491a946e77dbf$export$caf6e58bb8560bb2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4-sidebar-filters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "flag",
        id: "filters-section",
        packageName: (0, $095930ee3b140077$export$b8b9d90f9e5bd72b),
        teamName: (0, $095930ee3b140077$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iuhhQ.Nav4Filters), props)));

});
parcelRegister("iuhhQ", function(module, exports) {

$parcel$export(module.exports, "Nav4Filters", () => $37c0282fd3f73bb5$export$caf6e58bb8560bb2);

var $avYh4 = parcelRequire("avYh4");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jhS4y = parcelRequire("jhS4y");

var $c6x3L = parcelRequire("c6x3L");

var $c0v8V = parcelRequire("c0v8V");

var $iaOwN = parcelRequire("iaOwN");

var $6jcf1 = parcelRequire("6jcf1");
function $37c0282fd3f73bb5$export$caf6e58bb8560bb2({ isExpanded: isExpanded, queryRef: queryRef }) {
    const data = (0, $8Uumt.useFragment)((0, $avYh4.default), queryRef);
    const { isInitialSelectedPath: isInitialSelectedPath } = (0, $c6x3L.useSidebarNav4)();
    const actionButtons = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iaOwN.ActionButtons), null), []);
    if (!data.jira?.hasIsFiltersExpanded && isInitialSelectedPath((0, $jhS4y.MENU_ID_FILTERS))) // We need to make sure that we're only passing the conditionalal fragment when it is actually
    // available. Due to a lack of support the @alias Relay directive, we need to use another mechanism
    // and in this case we're using a hardcoded __typename to check if the fragment is available.
    // This is a workaround until we can use the @alias directive in Relay. If the hasIsProjectsExpanded
    // attribute is not available, then the fragment won't be either and we shouldn't pass it.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6jcf1.Nav4FiltersDefault), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded
    });
    return isInitialSelectedPath((0, $jhS4y.MENU_ID_FILTERS)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0v8V.Nav4FiltersForLanding), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded,
        queryRef: data
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6jcf1.Nav4FiltersDefault), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded
    });
}

});
parcelRegister("avYh4", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f2d98cdc206343c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ca5697fbb6a29ad933542b5ec3a3de2d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4f2d98cdc206343c$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isFiltersExpanded"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4Filters",
    "selections": [
        {
            "condition": "isFiltersExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4FiltersForLanding"
                }
            ]
        },
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "condition": "isFiltersExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "hasIsFiltersExpanded",
                            "kind": "ScalarField",
                            "name": "__typename"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$4f2d98cdc206343c$var$node.hash = "3df2d83f4108ed18026f86044ce6e248";
var $4f2d98cdc206343c$export$2e2bcd8739ae039 = $4f2d98cdc206343c$var$node;

});

parcelRegister("c0v8V", function(module, exports) {

$parcel$export(module.exports, "Nav4FiltersForLanding", () => $c780ddd933f6ccc4$export$90658bd06cecabd4);

var $f0kDR = parcelRequire("f0kDR");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $lnznH = parcelRequire("lnznH");
var $cZa9B = parcelRequire("cZa9B");

var $7CMCs = parcelRequire("7CMCs");

var $jecJ3 = parcelRequire("jecJ3");

var $jhS4y = parcelRequire("jhS4y");

var $46Cti = parcelRequire("46Cti");

var $c16H2 = parcelRequire("c16H2");

var $dQbFB = parcelRequire("dQbFB");

var $eQV8d = parcelRequire("eQV8d");

var $dUyqZ = parcelRequire("dUyqZ");

var $jNsky = parcelRequire("jNsky");

var $l8ruj = parcelRequire("l8ruj");

var $4R6GH = parcelRequire("4R6GH");


var $eYeHi = parcelRequire("eYeHi");

var $3XHNc = parcelRequire("3XHNc");
function $c780ddd933f6ccc4$export$90658bd06cecabd4(props) {
    const { actionsOnHover: actionsOnHover, isExpanded: isExpanded, queryRef: queryRef } = props;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).FILTERS);
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    const data = (0, $8Uumt.useFragment)((0, $f0kDR.default), queryRef);
    const menuId = (0, $jhS4y.MENU_ID_FILTERS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $46Cti.L1_MENU_ID).FILTERS,
                sectionItem: (0, $jecJ3.SECTION_ITEM_FILTERS)
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZa9B.ExpandableMenuItemTrigger), {
        interactionName: (0, $4R6GH.fg)('blu-7837_apply_presstrace_nav4') ? 'nav4-sidebar-filters-landing' : undefined,
        actionsOnHover: actionsOnHover,
        // Prevent double-up of accessible name that occurs in icon + text situation.
        "aria-label": formattedMessage,
        elemBefore: icon,
        testId: (0, $dQbFB.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnznH.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3XHNc.Header), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4-sidebar-filters-landing"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "nav4-sidebar-filters-landing",
        packageName: (0, $095930ee3b140077$export$b8b9d90f9e5bd72b),
        teamName: (0, $095930ee3b140077$export$d57b6b390e78d90f),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jNsky.Nav4FiltersContent), {
        queryRef: data
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eYeHi.Footer), null)));
}

});
parcelRegister("f0kDR", function(module, exports) {

$parcel$export(module.exports, "default", () => $73859602a3769ede$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e3cce317c9d4d64ec51601d1438d8020>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $73859602a3769ede$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4FiltersForLanding",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Nav4FiltersContent"
        }
    ],
    "type": "Query"
};
$73859602a3769ede$var$node.hash = "6171665054b4de86e6a0c40316984aba";
var $73859602a3769ede$export$2e2bcd8739ae039 = $73859602a3769ede$var$node;

});

parcelRegister("jNsky", function(module, exports) {

$parcel$export(module.exports, "Nav4FiltersContent", () => $18f5885dbaabbc22$export$e0cd6afcf36dd0ac);

var $7eMNW = parcelRequire("7eMNW");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $mwgEH = parcelRequire("mwgEH");
var $lnznH = parcelRequire("lnznH");
var $cZa9B = parcelRequire("cZa9B");
var $gSZmd = parcelRequire("gSZmd");
var $1qQhw = parcelRequire("1qQhw");
var $1FdfO = parcelRequire("1FdfO");
var $2CQvU = parcelRequire("2CQvU");

var $7hmi2 = parcelRequire("7hmi2");

var $koVbs = parcelRequire("koVbs");




var $jecJ3 = parcelRequire("jecJ3");

var $jhS4y = parcelRequire("jhS4y");

var $c6x3L = parcelRequire("c6x3L");

var $9Gyp5 = parcelRequire("9Gyp5");

var $5FnJJ = parcelRequire("5FnJJ");

var $gxbcq = parcelRequire("gxbcq");

var $1b6zA = parcelRequire("1b6zA");

var $GgrBz = parcelRequire("GgrBz");

var $2SzoU = parcelRequire("2SzoU");

var $koeKL = parcelRequire("koeKL");

var $cZpsT = parcelRequire("cZpsT");

var $4R6GH = parcelRequire("4R6GH");

var $eIGIx = parcelRequire("eIGIx");

var $qBWno = parcelRequire("qBWno");

var $jjTbl = parcelRequire("jjTbl");
const $18f5885dbaabbc22$var$MAX_RECENT_FILTERS = 5;
const $18f5885dbaabbc22$export$1f869c99ead9db5f = 15;
const $18f5885dbaabbc22$var$VIEW_ALL_STARRED_HREF = '/jira/your-work?starred';
const $18f5885dbaabbc22$var$defaultFiltersRequiringLogin = [
    {
        id: '-1'
    },
    {
        id: '-2'
    },
    {
        id: '-3'
    }
];
const $18f5885dbaabbc22$var$entityTypenames = [
    'JiraCustomFilter',
    'JiraSystemFilter'
];
function $18f5885dbaabbc22$export$e0cd6afcf36dd0ac({ queryRef: queryRef }) {
    const cloudId = (0, $koeKL.useCloudId)();
    const { getStableItems: getStableItems } = (0, $1b6zA.useStableItems)();
    const { isSelectedPath: isSelectedPath } = (0, $c6x3L.useSidebarNav4)();
    // We intentionally request 15 starred and 20 recent filters.
    // Recent filters should exclude system/default filters.
    // Then, if all 15 starred filters were recently visited, we still show 5 recent filters as well.
    const [fragmentData, refetch] = (0, $8Uumt.useRefetchableFragment)((0, $7eMNW.default), queryRef);
    const { jira: { favouriteFilters: favouriteFilters, recentFilters: recentFilters, systemFilters: systemFilters } } = fragmentData;
    (0, $9Gyp5.useRefetchWhenIsSelected)({
        cloudId: cloudId,
        isSelectedPath: isSelectedPath,
        QUERY: $2SzoU.default,
        refetch: refetch,
        menuId: (0, $jhS4y.MENU_ID_FILTERS)
    });
    const refetchOnChange = (0, $5uXOq.useCallback)(({ onComplete: onComplete })=>{
        refetch({
            cloudId: cloudId
        }, {
            fetchPolicy: 'store-and-network',
            onComplete: onComplete
        });
    }, [
        cloudId,
        refetch
    ]);
    (0, $gxbcq.useSubscribeAndUpdateFavorites)({
        entityTypename: $18f5885dbaabbc22$var$entityTypenames,
        favouriteConnectionId: favouriteFilters.__id,
        recentConnectionId: recentFilters.__id,
        refetch: refetchOnChange
    });
    const { subscribe: subscribe, unsubscribe: unsubscribe } = (0, $7hmi2.useDeleteChangeActions)();
    // allows the sidebar to reflect filter changes when a filter is deleted from the filters directory page
    (0, $5uXOq.useEffect)(()=>{
        subscribe(refetchOnChange);
        return ()=>{
            unsubscribe(refetchOnChange);
        };
    }, [
        refetchOnChange,
        subscribe,
        unsubscribe
    ]);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const starred = formatMessage((0, $jjTbl.default).starred);
    const recent = formatMessage((0, $jjTbl.default).recent);
    const sendFilterAnalytics = (0, $qBWno.useFilterActionsAnalytics)();
    const favorites = (0, $5uXOq.useMemo)(()=>{
        const ids = favouriteFilters.edges?.map((edge)=>edge?.node.filterId).filter(Boolean) ?? [];
        const list = favouriteFilters.edges?.filter(Boolean).map((edge)=>{
            const isCustom = edge.node.__typename === 'JiraCustomFilter';
            const sendFavouriteFilterAnalytics = ()=>sendFilterAnalytics((0, $ce8062101363feb9$export$6dd9406e478a1fe2), (0, $qBWno.getRecentAndFavouriteFilterAttributes)({
                    isCustom: isCustom,
                    filterId: edge.node.filterId,
                    section: (0, $jecJ3.SECTION_ITEM_STARRED)
                }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $GgrBz.Nav4FilterMenuItem), {
                key: edge.node.filterId,
                queryRef: edge.node,
                onRefetch: refetchOnChange,
                onClick: sendFavouriteFilterAnalytics
            });
        }) ?? [];
        return {
            idSet: new Set(ids),
            list: list.slice(0, $18f5885dbaabbc22$export$1f869c99ead9db5f),
            hasItems: Boolean(list.length),
            hasMore: favouriteFilters.pageInfo?.hasNextPage || list.length > $18f5885dbaabbc22$export$1f869c99ead9db5f
        };
    }, [
        favouriteFilters,
        refetchOnChange,
        sendFilterAnalytics
    ]);
    const recentItems = (0, $5uXOq.useMemo)(()=>{
        const nodes = recentFilters.edges?.filter(Boolean).filter((edge)=>edge.node.filterId && !favorites.idSet.has(edge.node.filterId)).map((edge)=>edge.node).slice(0, $18f5885dbaabbc22$var$MAX_RECENT_FILTERS) ?? [];
        const stableOrderedNodes = getStableItems({
            nodes: nodes,
            idKey: 'filterId'
        });
        const list = stableOrderedNodes.map((node)=>{
            const sendRecentFilterAnalytics = ()=>sendFilterAnalytics((0, $ce8062101363feb9$export$6dd9406e478a1fe2), (0, $qBWno.getRecentAndFavouriteFilterAttributes)({
                    isCustom: true,
                    filterId: node.filterId,
                    section: (0, $jecJ3.SECTION_ITEM_RECENT)
                }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $GgrBz.Nav4FilterMenuItem), {
                key: node.filterId,
                queryRef: node,
                onRefetch: refetchOnChange,
                onClick: sendRecentFilterAnalytics
            });
        });
        return {
            list: list,
            hasItems: Boolean(list.length)
        };
    }, [
        recentFilters.edges,
        getStableItems,
        favorites.idSet,
        refetchOnChange,
        sendFilterAnalytics
    ]);
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const defaultItems = (0, $5uXOq.useMemo)(()=>{
        const filterIds = [];
        const list = systemFilters.edges?.filter((edge)=>edge?.node?.filterId && !favorites.idSet.has(edge.node.filterId))?.filter((edge)=>edge?.node?.filterId && (!isAnonymous || !$18f5885dbaabbc22$var$defaultFiltersRequiringLogin.find((filter)=>filter.id === edge.node.filterId))).map((edge)=>{
            edge?.node && filterIds.push(edge?.node.filterId);
            return edge;
        }).map((edge)=>{
            if (!edge?.node) return null;
            const sendDefaultFilterAnalytics = ()=>sendFilterAnalytics((0, $ce8062101363feb9$export$6dd9406e478a1fe2), (0, $qBWno.getDefaulFilterAttributes)({
                    filterId: edge.node.filterId
                }));
            return edge?.node ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $GgrBz.Nav4FilterMenuItem), {
                key: edge.node.filterId,
                queryRef: edge.node,
                onRefetch: refetchOnChange,
                onClick: sendDefaultFilterAnalytics
            }) : null;
        }) || [];
        return {
            list: list,
            hasItems: Boolean(list.length),
            filterIds: filterIds
        };
    }, [
        systemFilters.edges,
        favorites.idSet,
        isAnonymous,
        refetchOnChange,
        sendFilterAnalytics
    ]);
    const sendViewAllStarredAnalytics = (0, $5uXOq.useCallback)(()=>{
        sendFilterAnalytics((0, $ce8062101363feb9$export$6dd9406e478a1fe2), {
            level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
            componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
            itemId: 'viewAllStarred'
        });
    }, [
        sendFilterAnalytics
    ]);
    const sendDefaultFilterDropdownAnalytics = (0, $5uXOq.useCallback)(()=>{
        sendFilterAnalytics((0, $ce8062101363feb9$export$b887e88d8d0739f6), {
            level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
            componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
            itemId: 'defaultFilters'
        });
    }, [
        sendFilterAnalytics
    ]);
    const onExpansionToggle = (0, $eIGIx.useCallbackWithCondition)((hasExpanded)=>{
        if (hasExpanded) sendDefaultFilterDropdownAnalytics();
    }, [
        sendDefaultFilterDropdownAnalytics
    ], ()=>(0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, favorites.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1qQhw.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1FdfO.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2CQvU.MenuSectionHeading), null, starred), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gSZmd.MenuList), null, favorites.list))), favouriteFilters.pageInfo?.hasNextPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        href: $18f5885dbaabbc22$var$VIEW_ALL_STARRED_HREF,
        menuId: (0, $jhS4y.MENU_ID_FILTERS_VIEW_ALL_STARRED),
        onClick: sendViewAllStarredAnalytics
    }, formatMessage((0, $jjTbl.default).viewAllStarred))), recentItems.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1qQhw.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1FdfO.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2CQvU.MenuSectionHeading), null, recent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gSZmd.MenuList), null, recentItems.list))), defaultItems.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $mwgEH.ExpandableMenuItem), {
        isDefaultExpanded: true,
        onExpansionToggle: onExpansionToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZa9B.ExpandableMenuItemTrigger), {
        interactionName: (0, $4R6GH.fg)('blu-7837_apply_presstrace_nav4') ? 'nav4-sidebar-filters-default-filters' : undefined
    }, formatMessage((0, $jjTbl.default).defaultFilters)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnznH.ExpandableMenuItemContent), null, defaultItems.list)));
}

});
parcelRegister("7eMNW", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecbe3a8ee266c1ca$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ffa5b5733326eabb56fcfb6e2f05b1d3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $2SzoU = parcelRequire("2SzoU");
const $ecbe3a8ee266c1ca$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v1 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v2 = {
        "kind": "FragmentSpread",
        "name": "Nav4FilterMenuItem"
    }, v3 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v4 = [
        v1 /*: any*/ ,
        v2 /*: any*/ 
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "currentURL"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "refetch": {
                "fragmentPathInResult": [],
                "operation": (0, $2SzoU.default)
            }
        },
        "name": "Nav4FiltersContent",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "favouriteFilters",
                                "args": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": {
                                            "sort": {
                                                "order": "DESC"
                                            },
                                            "type": "FILTER"
                                        }
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 15
                                    }
                                ],
                                "concreteType": "JiraFavouriteConnection",
                                "kind": "LinkedField",
                                "name": "favourites",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraFavouriteEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                },
                                                                v1 /*: any*/ ,
                                                                v2 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "jira.favouriteFilters.edges.node"
                                            }
                                        ]
                                    },
                                    v3 /*: any*/ 
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.favouriteFilters"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "recentFilters",
                                "args": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Variable",
                                        "name": "currentURL",
                                        "variableName": "currentURL"
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 20
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "types",
                                        "value": [
                                            "FILTER"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraSearchableEntityConnection",
                                "kind": "LinkedField",
                                "name": "recentItems",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraSearchableEntityEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v4 /*: any*/ ,
                                                            "type": "JiraCustomFilter"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "jira.recentFilters.edges.node"
                                            }
                                        ]
                                    },
                                    v3 /*: any*/ 
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.recentFilters"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": [
                                    v0 /*: any*/ 
                                ],
                                "concreteType": "JiraSystemFilterConnection",
                                "kind": "LinkedField",
                                "name": "systemFilters",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraSystemFilterEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "JiraSystemFilter",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": v4 /*: any*/ 
                                                },
                                                "action": "THROW",
                                                "path": "jira.systemFilters.edges.node"
                                            }
                                        ]
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.systemFilters"
                        }
                    ]
                },
                "action": "THROW",
                "path": "jira"
            }
        ],
        "type": "Query"
    };
}();
$ecbe3a8ee266c1ca$var$node.hash = "3f2ab01091a0154bb13d2ed1b15e13ef";
var $ecbe3a8ee266c1ca$export$2e2bcd8739ae039 = $ecbe3a8ee266c1ca$var$node;

});
parcelRegister("2SzoU", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4b5e5aaa6a2bc38$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e4100b4266ad9f2bb1c31ed34ee8522f>>
 * @relayHash 99bea4c9d007a836d2f2aee3f9d2e63e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7050d00d8eefcfbd4847d47076260938acf8d0a28ab345db32aaed09d76e8fc5
const $c4b5e5aaa6a2bc38$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "currentURL"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "currentURL",
        "variableName": "currentURL"
    }, v2 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v8 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                    v3 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v6 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCustomFilter"
    }, v10 = {
        "kind": "InlineFragment",
        "selections": [
            v6 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v11 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "Nav4FiltersContentQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "Nav4FiltersContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "Nav4FiltersContentQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "favouriteFilters",
                            "args": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "sort": {
                                            "order": "DESC"
                                        },
                                        "type": "FILTER"
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 15
                                }
                            ],
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ],
                                                    "type": "JiraFilter",
                                                    "abstractKey": "__isJiraFilter"
                                                },
                                                v10 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v11 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "recentFilters",
                            "args": [
                                v2 /*: any*/ ,
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 20
                                },
                                {
                                    "kind": "Literal",
                                    "name": "types",
                                    "value": [
                                        "FILTER"
                                    ]
                                }
                            ],
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v8 /*: any*/ ,
                                                                v9 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        }
                                                    ],
                                                    "type": "JiraCustomFilter"
                                                },
                                                v10 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v11 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                v2 /*: any*/ 
                            ],
                            "concreteType": "JiraSystemFilterConnection",
                            "kind": "LinkedField",
                            "name": "systemFilters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSystemFilterEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSystemFilter",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ],
                                                    "type": "JiraFilter",
                                                    "abstractKey": "__isJiraFilter"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7050d00d8eefcfbd4847d47076260938acf8d0a28ab345db32aaed09d76e8fc5",
            "metadata": {},
            "name": "Nav4FiltersContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c4b5e5aaa6a2bc38$var$node.hash = "3f2ab01091a0154bb13d2ed1b15e13ef";
var $c4b5e5aaa6a2bc38$export$2e2bcd8739ae039 = $c4b5e5aaa6a2bc38$var$node;

});


parcelRegister("7hmi2", function(module, exports) {

$parcel$export(module.exports, "useDeleteChangeActions", () => $4b1281a69eb8a7ab$export$ebbca0408972222d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $4b1281a69eb8a7ab$var$initialState = {
    callbacks: []
};
const $4b1281a69eb8a7ab$export$e324594224ef24da = {
    subscribe: (callback)=>({ getState: getState, setState: setState })=>{
            if (!getState().callbacks.includes(callback)) setState({
                callbacks: [
                    ...getState().callbacks,
                    callback
                ]
            });
        },
    unsubscribe: (callback)=>({ getState: getState, setState: setState })=>{
            if (getState().callbacks.includes(callback)) setState({
                callbacks: getState().callbacks.filter((item)=>item !== callback)
            });
        },
    publish: ()=>({ getState: getState })=>{
            getState().callbacks.forEach((callback)=>callback({
                    onComplete: ()=>undefined
                }));
        }
};
const $4b1281a69eb8a7ab$var$Store = (0, $iXqE5.createStore)({
    initialState: $4b1281a69eb8a7ab$var$initialState,
    actions: $4b1281a69eb8a7ab$export$e324594224ef24da
});
const $4b1281a69eb8a7ab$export$440b46140bc86b64 = (0, $3sQ5x.createStateHook)($4b1281a69eb8a7ab$var$Store);
const $4b1281a69eb8a7ab$export$ebbca0408972222d = (0, $3sQ5x.createActionsHook)($4b1281a69eb8a7ab$var$Store);

});

parcelRegister("9Gyp5", function(module, exports) {

$parcel$export(module.exports, "useRefetchWhenIsSelected", () => $b6947c490b25f582$export$ed209ae428704c56);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $aGONy = parcelRequire("aGONy");
function $b6947c490b25f582$export$ed209ae428704c56(params) {
    const { cloudId: cloudId, isSelectedPath: isSelectedPath, menuId: menuId, refetch: refetch, queryVariables: queryVariables, QUERY: QUERY } = params;
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const currentURL = (0, $aGONy.useGetCurrentUrl)();
    const currentURLPath = (0, $aGONy.useGetCurrentUrlPath)();
    (0, $5uXOq.useEffect)(()=>{
        if (isSelectedPath(menuId)) (0, $8Uumt.fetchQuery)(environment, QUERY, {
            cloudId: cloudId,
            currentURL: currentURL,
            currentURLPath: currentURLPath,
            ...queryVariables
        }).subscribe({
            complete: ()=>{
                refetch({
                    cloudId: cloudId,
                    currentURL: currentURL,
                    ...queryVariables
                }, {
                    fetchPolicy: 'store-only'
                });
            }
        });
    }, [
        cloudId,
        isSelectedPath,
        menuId,
        refetch,
        currentURL,
        currentURLPath,
        environment,
        queryVariables,
        QUERY
    ]);
}

});
parcelRegister("aGONy", function(module, exports) {

$parcel$export(module.exports, "useGetCurrentUrl", () => $e40fd709c4a3ab1d$export$d758ec3f153761c1);
$parcel$export(module.exports, "useGetCurrentUrlPath", () => $e40fd709c4a3ab1d$export$f61d14d754da11cc);

var $lODMY = parcelRequire("lODMY");

var $edUVe = parcelRequire("edUVe");

var $5LMr7 = parcelRequire("5LMr7");

var $4R6GH = parcelRequire("4R6GH");

var $2YZCu = parcelRequire("2YZCu");
function $e40fd709c4a3ab1d$export$d758ec3f153761c1() {
    const match = (0, $edUVe.useMatch)();
    const query = (0, $5LMr7.useQuery)();
    const searchParams = new URLSearchParams(query ?? {});
    const url = new URL(`http://example.com${match.url}/?${searchParams.toString()}`);
    return url.toString();
}
const $e40fd709c4a3ab1d$export$f61d14d754da11cc = (0, $lODMY.createRouterSelector)((routerContext)=>{
    if ((0, $4R6GH.fg)('chronos-extra-logging-for-url-path')) try {
        const url = new URL(`http://example.com${routerContext.match.url}`);
        return url.toString();
    } catch (error) {
        (0, $2YZCu.default).unsafeErrorWithCustomerData('navigation-apps.sidebar-nav4.use-get-current-url', 'Failed to construct URL', {
            urlPath: routerContext.match.url
        });
        throw error;
    }
    const url = new URL(`http://example.com${routerContext.match.url}`);
    return url.toString();
});

});
parcelRegister("edUVe", function(module, exports) {

$parcel$export(module.exports, "useMatch", () => $02f34894572f6fbe$export$6c330e8992e8a295);

var $lODMY = parcelRequire("lODMY");
const $02f34894572f6fbe$export$6c330e8992e8a295 = (0, $lODMY.createRouterSelector)((state)=>state.match);

});



parcelRegister("gxbcq", function(module, exports) {

$parcel$export(module.exports, "useSubscribeAndUpdateFavorites", () => $7a04a668720dad88$export$1032774f8dab9cec);

var $5uXOq = parcelRequire("5uXOq");

var $eiowN = parcelRequire("eiowN");

var $7lK06 = parcelRequire("7lK06");
const $7a04a668720dad88$export$923c488bb9fac2df = (favouriteConnectionId, recentConnectionId)=>(0, $5uXOq.useCallback)(({ store: store, dataId: dataId, isFavourite: isFavourite })=>{
        const node = store.get(dataId);
        const favorites = store.get(favouriteConnectionId);
        // Exit if we can't find the relevant data to optimistically update
        if (!node || !favorites) return false;
        if (isFavourite) {
            const recentEdges = store.get(recentConnectionId)?.getLinkedRecords('edges') ?? [];
            const existingEdge = recentEdges.find((edge)=>edge.getLinkedRecord('node')?.getDataID() === dataId);
            // Only optimistically insert a new favorite edge if it exists in the recent connection so we know it
            // has required fragment data.
            if (!existingEdge) return false;
            const edge = (0, $eiowN.ConnectionHandler).createEdge(store, favorites, node, 'JiraFavouriteEdge');
            (0, $eiowN.ConnectionHandler).insertEdgeBefore(favorites, edge);
        } else (0, $eiowN.ConnectionHandler).deleteNode(favorites, dataId);
        return true;
    }, [
        favouriteConnectionId,
        recentConnectionId
    ]);
const $7a04a668720dad88$export$1032774f8dab9cec = ({ entityTypename: entityTypename, favouriteConnectionId: favouriteConnectionId, recentConnectionId: recentConnectionId, refetch: refetch })=>{
    const updateFavoriteConnection = $7a04a668720dad88$export$923c488bb9fac2df(favouriteConnectionId, recentConnectionId);
    const pendingRefetch = (0, $5uXOq.useRef)(false); // Track in-flight refetch requests
    const trailingRefetch = (0, $5uXOq.useRef)(false); // Track queued refetch requests
    const onRefetch = (0, $5uXOq.useCallback)(()=>{
        // If there is already an in-flight refetch then wait until the request is complete before fetching again
        // Relay will dedupe refetch calls with matching variables. Therefore, we need to wait until any pending request
        // has finished before executing the latest refetch
        if (pendingRefetch.current) {
            trailingRefetch.current = true;
            return;
        }
        pendingRefetch.current = true;
        trailingRefetch.current = false;
        refetch({
            onComplete: ()=>{
                pendingRefetch.current = false;
                // Recursively refetch if it has been queued while a request was in-flight.
                if (trailingRefetch.current) // Wait for Relay to delete the cached request before refetching
                setTimeout(onRefetch, 0);
            }
        });
    }, [
        refetch
    ]);
    const subscriber = (0, $5uXOq.useCallback)((payload)=>{
        if (payload.type === 'MUTATION') {
            const success = updateFavoriteConnection(payload);
            // If we successfully updated the connection or it's an optimistic update, exit without further action
            if (success || payload.isOptimistic) return;
        }
        // If we can't update the record directly in the Relay store then perform a refetch
        onRefetch();
    }, [
        onRefetch,
        updateFavoriteConnection
    ]);
    (0, $7lK06.useSubscribeToFavorite)(entityTypename, subscriber);
};

});
parcelRegister("7lK06", function(module, exports) {

$parcel$export(module.exports, "publishFavorite", () => $703ce7b9c2eadfdd$export$229a24253fb568e1);
$parcel$export(module.exports, "useSubscribeToFavorite", () => $703ce7b9c2eadfdd$export$eb04bf805f6b8fb2);

var $5uXOq = parcelRequire("5uXOq");
/**
 * Simple pub-sub implementation to emit and listen to change events for the favorite state of an entity.
 */ class $703ce7b9c2eadfdd$var$FavoritePubSub {
    constructor(){
        this.subscribers = {};
        this.subscribe = (typename, subscriber)=>{
            this.subscribers[typename] = [
                ...this.subscribers[typename] ?? [],
                subscriber
            ];
            return ()=>{
                this.subscribers[typename] = this.subscribers[typename]?.filter((sub)=>sub !== subscriber) ?? [];
            };
        };
        this.publish = (typename, payload)=>{
            this.subscribers[typename]?.forEach((subscriber)=>subscriber(payload));
        };
    }
}
// Singleton to emit and listen to events
const $703ce7b9c2eadfdd$var$favoritePubSub = new $703ce7b9c2eadfdd$var$FavoritePubSub();
const $703ce7b9c2eadfdd$export$229a24253fb568e1 = $703ce7b9c2eadfdd$var$favoritePubSub.publish;
const $703ce7b9c2eadfdd$export$eb04bf805f6b8fb2 = (typename, subscriber)=>{
    (0, $5uXOq.useEffect)(()=>{
        const typenames = Array.isArray(typename) ? typename : [
            typename
        ];
        const unsubscribes = typenames.map((val)=>$703ce7b9c2eadfdd$var$favoritePubSub.subscribe(val, subscriber));
        return ()=>unsubscribes.forEach((unsubscribe)=>unsubscribe());
    }, [
        typename,
        subscriber
    ]);
};

});


parcelRegister("1b6zA", function(module, exports) {

$parcel$export(module.exports, "useStableItems", () => $5cc76236fb007e50$export$cb9e0e36b6d0277e);

var $5uXOq = parcelRequire("5uXOq");
const $5cc76236fb007e50$export$cb9e0e36b6d0277e = ()=>{
    const stableIdMapRef = (0, $5uXOq.useRef)(new Map());
    const getStableItems = (0, $5uXOq.useCallback)(({ nodes: nodes, idKey: idKey })=>{
        const getStringId = (node)=>`${node[idKey]}`;
        const intersectedNodes = nodes.filter((node)=>stableIdMapRef.current.has(getStringId(node))).sort((nodeA, nodeB)=>{
            const indexA = stableIdMapRef.current.get(getStringId(nodeA)) ?? 0;
            const indexB = stableIdMapRef.current.get(getStringId(nodeB)) ?? 0;
            return indexA - indexB;
        });
        const hasIntersectedNodes = Boolean(intersectedNodes.length);
        const stableOrderedNodes = hasIntersectedNodes ? nodes.reduceRight((acc, node, index, array)=>{
            if (!stableIdMapRef.current.has(getStringId(node))) {
                const addToStart = index + 1 !== array.length;
                addToStart ? acc.unshift(node) : acc.push(node);
            }
            return acc;
        }, intersectedNodes) : nodes;
        stableIdMapRef.current = new Map(stableOrderedNodes.map((node, index)=>[
                getStringId(node),
                index
            ]));
        return stableOrderedNodes;
    }, []);
    return {
        getStableItems: getStableItems
    };
};

});

parcelRegister("GgrBz", function(module, exports) {

$parcel$export(module.exports, "Nav4FilterMenuItem", () => $e1d0066c79c6dc07$export$6c93ee534b1d4d10);

var $m231W = parcelRequire("m231W");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $iyWGS = parcelRequire("iyWGS");

var $cZpsT = parcelRequire("cZpsT");

var $MaZbq = parcelRequire("MaZbq");
function $e1d0066c79c6dc07$export$6c93ee534b1d4d10({ queryRef: queryRef, onRefetch: onRefetch, onClick: onClick }) {
    const data = (0, $8Uumt.useFragment)((0, $m231W.default), queryRef);
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MaZbq.SimpleFilterMenuItem), {
        actionsOnHover: !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iyWGS.Nav4FilterActions), {
            queryRef: data,
            onRefetch: onRefetch
        }),
        filterId: data.filterId,
        name: data.name,
        onClick: onClick
    });
}

});
parcelRegister("m231W", function(module, exports) {

$parcel$export(module.exports, "default", () => $11acb6858e14c1d4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6139076109a0e91490e1fa3e8272c1fa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $11acb6858e14c1d4$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4FilterMenuItem",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "filterId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "FragmentSpread",
            "name": "Nav4FilterActions"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$11acb6858e14c1d4$var$node.hash = "db4e5c3fb6fe1fa05a10eea572e428b4";
var $11acb6858e14c1d4$export$2e2bcd8739ae039 = $11acb6858e14c1d4$var$node;

});

parcelRegister("iyWGS", function(module, exports) {

$parcel$export(module.exports, "Nav4FilterActions", () => $013d853f5bcf1d51$export$7077dee41f8ad33d);

var $jaCjz = parcelRequire("jaCjz");

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $8Uumt = parcelRequire("8Uumt");

var $8w53e = parcelRequire("8w53e");

var $4IrpZ = parcelRequire("4IrpZ");

var $5nRKm = parcelRequire("5nRKm");

var $eRB05 = parcelRequire("eRB05");

var $1bKdn = parcelRequire("1bKdn");

var $kJpBP = parcelRequire("kJpBP");
var $3Z96c = parcelRequire("3Z96c");
var $9UCCQ = parcelRequire("9UCCQ");

var $dS3PR = parcelRequire("dS3PR");

var $7WnQL = parcelRequire("7WnQL");

var $koVbs = parcelRequire("koVbs");



var $d62in = parcelRequire("d62in");

var $aCS3f = parcelRequire("aCS3f");

var $4tcSU = parcelRequire("4tcSU");

var $cKjus = parcelRequire("cKjus");

var $6KXPO = parcelRequire("6KXPO");

var $90yGq = parcelRequire("90yGq");

var $itmJb = parcelRequire("itmJb");

var $lVJAU = parcelRequire("lVJAU");

var $4R6GH = parcelRequire("4R6GH");

var $koeKL = parcelRequire("koeKL");

var $fY39E = parcelRequire("fY39E");

var $dXq4S = parcelRequire("dXq4S");

var $2KAtx = parcelRequire("2KAtx");

var $c88gN = parcelRequire("c88gN");

var $dPDY8 = parcelRequire("dPDY8");

var $qBWno = parcelRequire("qBWno");

var $gDIE0 = parcelRequire("gDIE0");

var $l3IPn = parcelRequire("l3IPn");

var $199zy = parcelRequire("199zy");

var $eKG0o = parcelRequire("eKG0o");
const $013d853f5bcf1d51$export$7077dee41f8ad33d = ({ queryRef: queryRef, onRefetch: onRefetch })=>{
    const { __typename: __typename, isEditable: isEditable, isFavourite: isFavourite, name: name, owner: owner, id: id, filterId: filterId, jql: jql } = (0, $8Uumt.useFragment)((0, $jaCjz.default), queryRef);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const accountId = (0, $90yGq.useAccountId)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const sendFilterAnalytics = (0, $qBWno.useFilterActionsAnalytics)();
    const { isOpen: isCopyFilterModalOpen, onOpen: openCopyFilterModal, onClose: closeCopyFilterModal } = (0, $eKG0o.useModalState)(false);
    const { isOpen: isEditFilterModalOpen, onOpen: openEditFilterModal, onClose: closeEditFilterModal } = (0, $eKG0o.useModalState)(false);
    const { isOpen: isChangeOwnerModalOpen, onOpen: openChangeOwnerModal, onClose: closeChangeOwnerModal } = (0, $eKG0o.useModalState)(false);
    const { isOpen: isDeleteFilterModalOpen, onOpen: openDeleteFilterModal, onClose: closeDeleteFilterModal } = (0, $eKG0o.useModalState)(false);
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const onFilterSave = (0, $5uXOq.useCallback)((copiedFilterId)=>{
        push(`/issues/?filter=${copiedFilterId}`);
    }, [
        push
    ]);
    const isCustom = __typename === 'JiraCustomFilter';
    const isOwner = owner?.accountId && owner.accountId === accountId;
    const sendFilterActionAnalytics = (0, $5uXOq.useCallback)((itemId)=>{
        sendFilterAnalytics((0, $ce8062101363feb9$export$64fed82162bd367), (0, $qBWno.getFilterActionAttributes)({
            itemId: itemId,
            isCustom: isCustom,
            isFavourite: isFavourite,
            filterId: filterId
        }));
    }, [
        filterId,
        isCustom,
        isFavourite,
        sendFilterAnalytics
    ]);
    let modalProps;
    let saveFilterEntryPointProps;
    let updateFilterEntryPointProps;
    let entryPointParams;
    if ((0, $4R6GH.fg)('nin-save-filter-dialog-entry-point')) {
        modalProps = {
            width: 'medium',
            shouldScrollInViewport: true
        };
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        saveFilterEntryPointProps = (0, $5uXOq.useMemo)(()=>({
                jql: jql,
                filterId: filterId,
                onFilterSave: onFilterSave,
                title: formatMessage((0, $199zy.default).copyFilterDialogTitle)
            }), [
            jql,
            filterId,
            onFilterSave,
            formatMessage
        ]);
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        updateFilterEntryPointProps = (0, $5uXOq.useMemo)(()=>({
                filterId: filterId ?? ''
            }), [
            filterId
        ]);
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const cloudId = (0, $koeKL.useCloudId)();
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const activationId = (0, $fY39E.useActivationId)();
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        entryPointParams = (0, $5uXOq.useMemo)(()=>({
                filterAri: filterId !== null && filterId !== undefined ? (0, $dXq4S.createAri)({
                    resourceOwner: 'jira',
                    cloudId: cloudId,
                    resourceType: 'filter',
                    resourceId: filterId,
                    activationId: activationId
                }) : undefined
            }), [
            filterId,
            cloudId,
            activationId
        ]);
    }
    const MenuItems = (0, $5uXOq.useCallback)(({ onClose: onClose })=>{
        const getManageSubscriptionsUrl = (actionType)=>{
            const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
                atl_token: (0, $4tcSU.default)(),
                returnUrl: 'ManageFilters.jspa',
                filterId: filterId
            });
            return `/${actionType}!default.jspa?${parsed}`;
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
            isList: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d62in.FavoriteToggleButton), {
            entityId: id,
            defaultIsStarred: Boolean(isFavourite),
            entityTypeName: (0, $7WnQL.isFavoritableItemTypename)(__typename) ? __typename : 'JiraCustomFilter',
            onClick: ()=>sendFilterActionAnalytics(isFavourite ? (0, $496585bee7985bb9$export$7ae7abcf2c19d3e5) : (0, $496585bee7985bb9$export$78fd0bd637fe1684)),
            name: name
        }), isCustom && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Z96c.default), {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eRB05))), {
                label: "",
                spacing: "spacious",
                color: "var(--ds-icon, #44546F)"
            }),
            href: getManageSubscriptionsUrl('ViewSubscriptions'),
            "aria-label": formatMessage((0, $199zy.default).manageSubscriptionWithName, {
                name: name
            }),
            onClick: ()=>sendFilterActionAnalytics('manageSubscription')
        }, formatMessage((0, $199zy.default).manageSubscription)), (0, $4R6GH.fg)('nin-save-filter-dialog-entry-point') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
            modalProps: modalProps,
            entryPoint: (0, $c88gN.saveFilterDialogEntryPoint),
            entryPointProps: saveFilterEntryPointProps,
            entryPointParams: entryPointParams,
            interactionName: "jiraSaveFilterDialog.SaveFilter",
            useInternalModal: true
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
                onClick: (e)=>{
                    sendFilterActionAnalytics('copyFilter');
                    onClose && onClose(e);
                },
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8w53e))), {
                    label: "",
                    spacing: "spacious",
                    color: "var(--ds-icon, #44546F)"
                }),
                "aria-label": formatMessage((0, $199zy.default).copyFilterWithName, {
                    name: name
                }),
                ref: ref
            }, formatMessage((0, $199zy.default).copyFilter))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
            onClick: (e)=>{
                openCopyFilterModal();
                sendFilterActionAnalytics('copyFilter');
                onClose && onClose(e);
            },
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8w53e))), {
                label: "",
                spacing: "spacious",
                color: "var(--ds-icon, #44546F)"
            }),
            "aria-label": formatMessage((0, $199zy.default).copyFilterWithName, {
                name: name
            })
        }, formatMessage((0, $199zy.default).copyFilter)), isCustom && (isOwner || isEditable) && ((0, $4R6GH.fg)('nin-save-filter-dialog-entry-point') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
            modalProps: modalProps,
            entryPoint: (0, $dPDY8.updateFilterDialogEntryPoint),
            entryPointProps: updateFilterEntryPointProps,
            entryPointParams: entryPointParams,
            interactionName: "jiraSaveFilterDialog.UpdateFilterDetails",
            useInternalModal: true
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
                onClick: (e)=>{
                    sendFilterActionAnalytics('editFilter');
                    onClose && onClose(e);
                },
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5nRKm))), {
                    label: "",
                    spacing: "spacious",
                    color: "var(--ds-icon, #44546F)"
                }),
                "aria-label": formatMessage((0, $199zy.default).editWithName, {
                    name: name
                }),
                ref: ref
            }, formatMessage((0, $199zy.default).edit))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5nRKm))), {
                label: "",
                spacing: "spacious",
                color: "var(--ds-icon, #44546F)"
            }),
            onClick: (e)=>{
                openEditFilterModal();
                sendFilterActionAnalytics('editFilter');
                onClose && onClose(e);
            },
            "aria-label": formatMessage((0, $199zy.default).editWithName, {
                name: name
            })
        }, formatMessage((0, $199zy.default).edit))), isCustom && (isOwner || isAdmin) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
            onClick: (e)=>{
                openChangeOwnerModal();
                sendFilterActionAnalytics('changeOwner');
                onClose && onClose(e);
            },
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bKdn))), {
                label: "",
                spacing: "spacious",
                color: "var(--ds-icon, #44546F)"
            }),
            "aria-label": formatMessage((0, $199zy.default).changeOwnerWithName, {
                name: name
            })
        }, formatMessage((0, $199zy.default).changeOwner))), isCustom && (isOwner || isAdmin) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
            hasSeparator: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
            onClick: (e)=>{
                openDeleteFilterModal();
                sendFilterActionAnalytics('deleteFilter');
                onClose && onClose(e);
            },
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4IrpZ))), {
                label: "",
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "spacious"
            }),
            "aria-label": formatMessage((0, $199zy.default).deleteWithName, {
                name: name
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
            color: "color.text.danger"
        }, formatMessage((0, $199zy.default).delete)))));
    }, [
        id,
        isFavourite,
        __typename,
        name,
        isCustom,
        formatMessage,
        isOwner,
        isEditable,
        isAdmin,
        filterId,
        sendFilterActionAnalytics,
        openCopyFilterModal,
        openEditFilterModal,
        openChangeOwnerModal,
        openDeleteFilterModal,
        modalProps,
        saveFilterEntryPointProps,
        updateFilterEntryPointProps,
        entryPointParams
    ]);
    const sendMeatballAnalytics = (0, $5uXOq.useCallback)(()=>{
        sendFilterAnalytics((0, $ce8062101363feb9$export$b887e88d8d0739f6), (0, $qBWno.getFilterMeatBallAttributes)({
            isCustom: isCustom,
            isFavourite: isFavourite,
            filterId: filterId
        }));
    }, [
        filterId,
        isCustom,
        isFavourite,
        sendFilterAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCS3f.MoreNavMenuButton), {
        onOpen: sendMeatballAnalytics,
        MenuItems: MenuItems,
        name: name
    }), !(0, $4R6GH.fg)('nin-save-filter-dialog-entry-point') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cKjus.AsyncSaveFilterDialogContent), {
        isOpen: isCopyFilterModalOpen,
        filterId: filterId,
        jql: jql,
        title: formatMessage((0, $199zy.default).copyFilterDialogTitle),
        onClose: closeCopyFilterModal,
        onFilterSave: onFilterSave
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6KXPO.AsyncUpdateFilterDialog), {
        isOpen: isEditFilterModalOpen,
        filterId: filterId ?? '',
        onClose: closeEditFilterModal
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gDIE0.ChangeOwnerModal), {
        isOpen: isChangeOwnerModalOpen,
        filterId: filterId,
        onRefetch: onRefetch,
        onClose: closeChangeOwnerModal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l3IPn.DeleteFilterModal), {
        isOpen: isDeleteFilterModalOpen,
        name: name,
        filterId: filterId,
        onRefetch: onRefetch,
        onClose: closeDeleteFilterModal
    }));
};

});
parcelRegister("jaCjz", function(module, exports) {

$parcel$export(module.exports, "default", () => $349d0551267ba34b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b02630a993ab57f513c5d9a5a5ea9816>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $349d0551267ba34b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4FilterActions",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "filterId"
        },
        {
            "kind": "ScalarField",
            "name": "jql"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                },
                {
                    "kind": "LinkedField",
                    "name": "owner",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        }
                    ]
                }
            ],
            "type": "JiraCustomFilter"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$349d0551267ba34b$var$node.hash = "ceac0ec9e5b4a025e25fe096d35c5d3b";
var $349d0551267ba34b$export$2e2bcd8739ae039 = $349d0551267ba34b$var$node;

});

parcelRegister("8w53e", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cbd1068d7fb082440154244857d12f2c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $63353af41c1756be$var$_react = $63353af41c1756be$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $63353af41c1756be$var$_baseNew = $63353af41c1756be$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $63353af41c1756be$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $63353af41c1756be$var$CopyIcon = (props)=>/*#__PURE__*/ $63353af41c1756be$var$_react.default.createElement($63353af41c1756be$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM16 6v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75V6z" clip-rule="evenodd"/>`
    }, props));
$63353af41c1756be$var$CopyIcon.displayName = 'CopyIcon';
var $63353af41c1756be$var$_default = module.exports.default = $63353af41c1756be$var$CopyIcon;

});

parcelRegister("4IrpZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::32784ef133e6e682f32ae3035edbf69e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36f08a2f957bd6ab$var$_react = $36f08a2f957bd6ab$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $36f08a2f957bd6ab$var$_baseNew = $36f08a2f957bd6ab$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $36f08a2f957bd6ab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Delete".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing or deleting an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $36f08a2f957bd6ab$var$DeleteIcon = (props)=>/*#__PURE__*/ $36f08a2f957bd6ab$var$_react.default.createElement($36f08a2f957bd6ab$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 .75A.75.75 0 0 1 5.75 0h4.5a.75.75 0 0 1 .75.75V2.5h3.5V4h-1v10a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2V4h-1V2.5H5zM6.5 2.5h3v-1h-3zM4 4v10a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V4zm1.75 9V5.5h1.5V13zm3 0V5.5h1.5V13z" clip-rule="evenodd"/>`
    }, props));
$36f08a2f957bd6ab$var$DeleteIcon.displayName = 'DeleteIcon';
var $36f08a2f957bd6ab$var$_default = module.exports.default = $36f08a2f957bd6ab$var$DeleteIcon;

});

parcelRegister("5nRKm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ce3559d453dff44735097f553c900f9f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3eb8cab3ab465b93$var$_react = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3eb8cab3ab465b93$var$_baseNew = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3eb8cab3ab465b93$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3eb8cab3ab465b93$var$EditIcon = (props)=>/*#__PURE__*/ $3eb8cab3ab465b93$var$_react.default.createElement($3eb8cab3ab465b93$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.707zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.217l-.54 1.89 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$3eb8cab3ab465b93$var$EditIcon.displayName = 'EditIcon';
var $3eb8cab3ab465b93$var$_default = module.exports.default = $3eb8cab3ab465b93$var$EditIcon;

});

parcelRegister("eRB05", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::19440c8dd0e3db5766add744ad314d45>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ad22b76beceec928$var$_react = $ad22b76beceec928$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ad22b76beceec928$var$_baseNew = $ad22b76beceec928$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $ad22b76beceec928$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Email".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ad22b76beceec928$var$EmailIcon = (props)=>/*#__PURE__*/ $ad22b76beceec928$var$_react.default.createElement($ad22b76beceec928$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v.529L8 8.128l6.5-3.6V4a.5.5 0 0 0-.5-.5zm12.5 2.743L8.363 9.641a.75.75 0 0 1-.726 0L1.5 6.243V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$ad22b76beceec928$var$EmailIcon.displayName = 'EmailIcon';
var $ad22b76beceec928$var$_default = module.exports.default = $ad22b76beceec928$var$EmailIcon;

});

parcelRegister("7WnQL", function(module, exports) {

$parcel$export(module.exports, "isFavoritableItemTypename", () => $28a998bf88e6dba6$export$2bcd2af12bfc25b5);

var $eXQym = parcelRequire("eXQym");
const $28a998bf88e6dba6$export$2bcd2af12bfc25b5 = (typename)=>(0, $eXQym.VALID_ITEM_TYPENAMES).some((itemTypename)=>itemTypename === typename);

});
parcelRegister("eXQym", function(module, exports) {

$parcel$export(module.exports, "BOARDS_ITEM_TYPE", () => $6c76a5a290814989$export$aade82542e73ffc8);
$parcel$export(module.exports, "FILTERS_ITEM_TYPE", () => $6c76a5a290814989$export$a448ebfa10cebc74);
$parcel$export(module.exports, "DASHBOARDS_ITEM_TYPE", () => $6c76a5a290814989$export$f8099f229527572c);
$parcel$export(module.exports, "ISSUES_ITEM_TYPE", () => $6c76a5a290814989$export$8e58083dcbb878d);
$parcel$export(module.exports, "PLANS_ITEM_TYPE", () => $6c76a5a290814989$export$2fd44a6cb58b66cb);
$parcel$export(module.exports, "PROJECTS_ITEM_TYPE", () => $6c76a5a290814989$export$8e2cd98172988d7e);
$parcel$export(module.exports, "QUEUES_ITEM_TYPE", () => $6c76a5a290814989$export$6b0c8e47d2c7f1d9);
$parcel$export(module.exports, "VALID_ITEM_TYPES", () => $6c76a5a290814989$export$9c8cfad65800ddfb);
$parcel$export(module.exports, "VALID_ITEM_TYPENAMES", () => $6c76a5a290814989$export$2d63a9c2e78633c8);
const $6c76a5a290814989$export$aade82542e73ffc8 = 'boards';
const $6c76a5a290814989$export$a448ebfa10cebc74 = 'filters';
const $6c76a5a290814989$export$f8099f229527572c = 'dashboards';
const $6c76a5a290814989$export$8e58083dcbb878d = 'issues';
const $6c76a5a290814989$export$2fd44a6cb58b66cb = 'plans';
const $6c76a5a290814989$export$8e2cd98172988d7e = 'projects';
const $6c76a5a290814989$export$6b0c8e47d2c7f1d9 = 'queues';
const $6c76a5a290814989$export$9c8cfad65800ddfb = [
    $6c76a5a290814989$export$aade82542e73ffc8,
    $6c76a5a290814989$export$f8099f229527572c,
    $6c76a5a290814989$export$a448ebfa10cebc74,
    $6c76a5a290814989$export$8e58083dcbb878d,
    $6c76a5a290814989$export$2fd44a6cb58b66cb,
    $6c76a5a290814989$export$8e2cd98172988d7e,
    $6c76a5a290814989$export$6b0c8e47d2c7f1d9
];
const $6c76a5a290814989$export$2d63a9c2e78633c8 = [
    'JiraProject',
    'JiraCustomFilter',
    'JiraSystemFilter',
    'JiraDashboard',
    'JiraPlan',
    'JiraBoard',
    'JiraServiceManagementQueue'
];

});


parcelRegister("d62in", function(module, exports) {

$parcel$export(module.exports, "FavoriteToggleButton", () => $177932fc5526585a$export$b01f3062fe4ad89b);

var $5uXOq = parcelRequire("5uXOq");

var $dm1qi = parcelRequire("dm1qi");

var $dAf5R = parcelRequire("dAf5R");

var $kJpBP = parcelRequire("kJpBP");

var $dS3PR = parcelRequire("dS3PR");

var $4041n = parcelRequire("4041n");

var $koVbs = parcelRequire("koVbs");

var $9eeFp = parcelRequire("9eeFp");

var $9WLyc = parcelRequire("9WLyc");
const $177932fc5526585a$var$UnstarredIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAf5R))), {
    label: "",
    color: "currentColor",
    spacing: "spacious"
});
const $177932fc5526585a$var$StarredIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dm1qi))), {
    label: "",
    color: "var(--ds-icon-accent-yellow, #B38600)",
    spacing: "spacious"
});
const $177932fc5526585a$export$b01f3062fe4ad89b = ({ entityId: entityId, entityTypeName: entityTypeName, defaultIsStarred: defaultIsStarred = false, name: name, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isStarred, setIsStarred] = (0, $5uXOq.useState)(defaultIsStarred);
    const { changeFavoriteMutation: changeFavoriteMutation } = (0, $4041n.useChangeFavorite)();
    const handleOnClick = (0, $5uXOq.useCallback)(()=>{
        setIsStarred((prevIsStarred)=>!prevIsStarred);
        onClick?.();
    }, [
        onClick
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isStarred !== defaultIsStarred) changeFavoriteMutation({
            id: entityId,
            typename: entityTypeName,
            value: isStarred
        });
    }, [
        entityId,
        entityTypeName,
        isStarred,
        defaultIsStarred,
        changeFavoriteMutation
    ]);
    const handleOnClickWithStopPropagation = (0, $9eeFp.useStopPropagation)(handleOnClick);
    return isStarred ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        iconBefore: $177932fc5526585a$var$StarredIcon,
        onClick: handleOnClickWithStopPropagation,
        "aria-label": name ? formatMessage((0, $9WLyc.default).removeFromStarredWithName, {
            name: name
        }) : formatMessage((0, $9WLyc.default).removeFromStarred)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        color: "color.text"
    }, formatMessage((0, $9WLyc.default).removeFromStarred))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        iconBefore: $177932fc5526585a$var$UnstarredIcon,
        onClick: handleOnClickWithStopPropagation,
        "aria-label": name ? formatMessage((0, $9WLyc.default).addToStarredWithName, {
            name: name
        }) : formatMessage((0, $9WLyc.default).addToStarred)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        color: "color.text"
    }, formatMessage((0, $9WLyc.default).addToStarred)));
};

});
parcelRegister("dm1qi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84298877a5ffec5302189e1356603055>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9b8e6f0febff8b04$var$_react = $9b8e6f0febff8b04$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9b8e6f0febff8b04$var$_baseNew = $9b8e6f0febff8b04$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $9b8e6f0febff8b04$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarStarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9b8e6f0febff8b04$var$StarStarredIcon = (props)=>/*#__PURE__*/ $9b8e6f0febff8b04$var$_react.default.createElement($9b8e6f0febff8b04$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.655 6.336 8 2.84l1.345 3.497 3.506.27-2.7 2.25.973 3.627L8 10.341l-3.124 2.142.973-3.627-2.7-2.25z"/>`
    }, props));
$9b8e6f0febff8b04$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $9b8e6f0febff8b04$var$_default = module.exports.default = $9b8e6f0febff8b04$var$StarStarredIcon;

});

parcelRegister("4041n", function(module, exports) {

$parcel$export(module.exports, "FavoriteChangeContext", () => $e574e5c3227b76f4$export$a5d258b9665ce94b);
$parcel$export(module.exports, "FavoriteChangeProvider", () => $e574e5c3227b76f4$export$b06b5ce59fd5e408);
$parcel$export(module.exports, "FavoriteChangeConsumer", () => $e574e5c3227b76f4$export$f227cdfbb355444a);
$parcel$export(module.exports, "useChangeFavorite", () => $e574e5c3227b76f4$export$cfa169f3278459e8);

var $kZupY = parcelRequire("kZupY");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");

var $jcw0u = parcelRequire("jcw0u");

var $dXq4S = parcelRequire("dXq4S");

var $8zOmE = parcelRequire("8zOmE");

var $koeKL = parcelRequire("koeKL");

var $iJZ8l = parcelRequire("iJZ8l");

var $j6ttF = parcelRequire("j6ttF");

var $7lK06 = parcelRequire("7lK06");

var $eXQym = parcelRequire("eXQym");

var $5c9oS = parcelRequire("5c9oS");

var $7SIuT = parcelRequire("7SIuT");
const $e574e5c3227b76f4$export$4fe337ef5f0ceb74 = (item)=>(state)=>({
            ...state,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [item.type]: {
                ...state[item.type],
                [item.id]: item
            }
        });
const $e574e5c3227b76f4$export$72b8c6d38aa6195b = (item)=>(state)=>({
            ...state,
            items: {
                ...state.items,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [item.type]: {
                    ...state.items[item.type],
                    [item.id]: item
                }
            }
        });
const $e574e5c3227b76f4$export$b212ddc707077772 = {
    items: {
        boards: {},
        filters: {},
        issues: {},
        dashboards: {},
        projects: {},
        queues: {},
        plans: {}
    },
    changeFavorite: ()=>new Promise((0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))),
    changeFavoriteMutation: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    emitChangedFavorite: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    emitChangedFavoriteMutation: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    updateFavoriteState: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $e574e5c3227b76f4$export$a5d258b9665ce94b = /*#__PURE__*/ (0, $5uXOq.createContext)($e574e5c3227b76f4$export$b212ddc707077772);
// supports project types only for now
const $e574e5c3227b76f4$var$useRelayFavoriteUpdate = ()=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const cloudId = (0, $koeKL.useCloudId)();
    const commitUpdate = (0, $5uXOq.useCallback)(({ id: id, type: type, value: value })=>{
        if (type === (0, $eXQym.PROJECTS_ITEM_TYPE)) (0, $eiowN.commitLocalUpdate)(environment, (store)=>{
            const ari = (0, $dXq4S.createAri)({
                resourceOwner: 'jira',
                resourceType: 'project',
                resourceId: id,
                cloudId: cloudId
            });
            const projectRecordId = (0, $iJZ8l.default)({
                id: ari
            }, 'JiraProject');
            if (projectRecordId) {
                const projectRecord = store.get(projectRecordId);
                const favoriteRecord = projectRecord?.getLinkedRecord('favouriteValue');
                favoriteRecord?.setValue(value, 'isFavourite');
            }
        });
    }, [
        cloudId,
        environment
    ]);
    return {
        commitUpdate: commitUpdate
    };
};
const $e574e5c3227b76f4$export$b06b5ce59fd5e408 = ({ onShowFlag: onShowFlag, children: children })=>{
    const { commitUpdate: commitUpdate } = $e574e5c3227b76f4$var$useRelayFavoriteUpdate();
    const [items, setItems] = (0, $5uXOq.useState)({
        boards: {},
        filters: {},
        dashboards: {},
        issues: {},
        projects: {},
        queues: {},
        plans: {}
    });
    const onChangeStart = (0, $5uXOq.useCallback)((item)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            pending: true
        }));
    }, []);
    const onChangeSuccess = (0, $5uXOq.useCallback)((item, analyticsEvent)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            pending: false
        }));
        if (analyticsEvent) (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, // removing last letter to make item.type singular tense (i.e. boards => board)
        `${item.type.slice(0, item.type.length - 1)} ${item.value ? 'starred' : 'unstarred'}`, `${item.id}`);
    }, []);
    const onChangeFail = (0, $5uXOq.useCallback)((item, analyticsId, error)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            value: !item.value,
            pending: false
        }));
        if (onShowFlag) onShowFlag((0, $7SIuT.errorFlag)());
        (0, $jcw0u.default)({
            meta: {
                id: analyticsId,
                packageName: 'jiraFavouriteChangeProvider',
                teamName: 'empanada'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        onShowFlag
    ]);
    const changeFavorite = (0, $5uXOq.useCallback)(async (item, analyticsEvent)=>{
        const performChange = async ()=>{
            onChangeStart(item);
            try {
                commitUpdate({
                    type: item.type,
                    id: item.id,
                    value: item.value
                });
                await (0, $5c9oS.default)(item);
                const typename = (0, $j6ttF.favoriteTypeToTypename)(item.type, item.id);
                if (typename) (0, $7lK06.publishFavorite)(typename, {
                    type: 'REST',
                    entityId: item.id,
                    isFavourite: item.value
                });
                onChangeSuccess(item, analyticsEvent);
            } catch (error) {
                commitUpdate({
                    type: item.type,
                    id: item.id,
                    value: !item.value
                });
                onChangeFail(item, 'changeFavourite', error instanceof Error ? error : undefined);
            }
        };
        return performChange();
    }, [
        commitUpdate,
        onChangeStart,
        onChangeSuccess,
        onChangeFail
    ]);
    const [commitMutation] = (0, $8Uumt.useMutation)((0, $kZupY.default));
    const changeFavoriteMutation = (0, $5uXOq.useCallback)((payload, analyticsEvent)=>{
        const dataId = (0, $iJZ8l.default)({
            id: payload.id
        }, payload.typename);
        const restItem = (0, $j6ttF.favoriteMutationToRestPayload)(payload);
        const onUpdate = (store, isOptimistic)=>{
            if (!dataId) return;
            (0, $7lK06.publishFavorite)(payload.typename, {
                type: 'MUTATION',
                store: store,
                dataId: dataId,
                entityId: payload.id,
                isFavourite: payload.value,
                isOptimistic: isOptimistic
            });
            const record = store.get(dataId);
            if (record) {
                // Some favoritable entities provide an `isFavourite` field, e.g. `JiraFilter`, `JiraProject`.
                if (typeof record.getValue('isFavourite') === 'boolean') record.setValue(payload.value, 'isFavourite');
                // Optimistically update the `favouriteValue` node associated with the updated entity (if present).
                // We only need to do this during optimistic update as the node will be returned in a successful
                // mutation response.
                if (isOptimistic) {
                    const favoriteRecord = record.getLinkedRecord('favouriteValue');
                    favoriteRecord?.setValue(payload.value, 'isFavourite');
                }
            }
        };
        onChangeStart(restItem);
        commitMutation({
            variables: {
                input: {
                    entityId: payload.id,
                    isFavourite: payload.value,
                    beforeEntityId: payload.beforeEntity?.id ?? null
                }
            },
            optimisticUpdater: (store)=>{
                onUpdate(store, true);
            },
            updater: (store, response)=>{
                if (response?.jira?.setEntityIsFavourite?.success) onUpdate(store, false);
            },
            onCompleted: (response)=>{
                if (response?.jira?.setEntityIsFavourite?.success) onChangeSuccess(restItem, analyticsEvent);
                else onChangeFail(restItem, 'changeFavoriteMutation');
            },
            onError: (error)=>onChangeFail(restItem, 'changeFavouriteMutation', error)
        });
    }, [
        commitMutation,
        onChangeStart,
        onChangeSuccess,
        onChangeFail
    ]);
    const updateFavoriteState = (0, $5uXOq.useCallback)((item)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            pending: false
        }));
    }, []);
    const emitChangedFavorite = (0, $5uXOq.useCallback)((payload, analyticsEvent)=>{
        onChangeSuccess(payload, analyticsEvent);
        const typeName = (0, $j6ttF.favoriteTypeToTypename)(payload.type, payload.id);
        if (typeName) (0, $7lK06.publishFavorite)(typeName, {
            type: 'REST',
            entityId: payload.id,
            isFavourite: payload.value
        });
    }, [
        onChangeSuccess
    ]);
    const emitChangedFavoriteMutation = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (payload, store, analyticsEvent)=>{
        const dataId = (0, $iJZ8l.default)({
            id: payload.id
        }, payload.typename) ?? '';
        const restItem = (0, $j6ttF.favoriteMutationToRestPayload)(payload);
        onChangeSuccess(restItem, analyticsEvent);
        (0, $7lK06.publishFavorite)(payload.typename, {
            type: 'MUTATION',
            store: store,
            dataId: dataId,
            entityId: payload.id,
            isFavourite: payload.value,
            isOptimistic: false
        });
    }, [
        onChangeSuccess
    ]);
    const providerValue = (0, $5uXOq.useMemo)(()=>({
            items: items,
            changeFavorite: changeFavorite,
            changeFavoriteMutation: changeFavoriteMutation,
            emitChangedFavorite: emitChangedFavorite,
            emitChangedFavoriteMutation: emitChangedFavoriteMutation,
            updateFavoriteState: updateFavoriteState
        }), [
        items,
        changeFavorite,
        changeFavoriteMutation,
        emitChangedFavorite,
        emitChangedFavoriteMutation,
        updateFavoriteState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e574e5c3227b76f4$export$a5d258b9665ce94b.Provider, {
        value: providerValue
    }, children);
};
const $e574e5c3227b76f4$export$f227cdfbb355444a = $e574e5c3227b76f4$export$a5d258b9665ce94b.Consumer;
const $e574e5c3227b76f4$export$61944ffe37754ff2 = (WrappedComponent)=>{
    const WithFavoriteChangeConsumer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e574e5c3227b76f4$export$f227cdfbb355444a, null, (favoriteChangeContext)=>// @ts-expect-error - TS2322 - Type 'P & { favoriteChangeContext: FavoriteChangeContextType; }' is not assignable to type 'IntrinsicAttributes & W & { children?: ReactNode; }'.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                favoriteChangeContext: favoriteChangeContext
            }));
    const wrappedDisplayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    WithFavoriteChangeConsumer.displayName = `WithFavoriteChangeConsumer(${wrappedDisplayName})`;
    return WithFavoriteChangeConsumer;
};
const $e574e5c3227b76f4$export$cfa169f3278459e8 = ()=>(0, $5uXOq.useContext)($e574e5c3227b76f4$export$a5d258b9665ce94b);

});
parcelRegister("kZupY", function(module, exports) {

$parcel$export(module.exports, "default", () => $d64781493fbfe6b0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<581ee8573bf9ee1f32ccc64539d4c7bc>>
 * @relayHash 6de546c6546651e6c4572b78dca9bcd9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 55cc4316f34f570b5daad61eb737e9475face6fd2ceb7b85de1040658ff30d9f
const $d64781493fbfe6b0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraSetIsFavouritePayload",
                    "kind": "LinkedField",
                    "name": "setEntityIsFavourite",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "viewSetFavouriteMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "viewSetFavouriteMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "55cc4316f34f570b5daad61eb737e9475face6fd2ceb7b85de1040658ff30d9f",
            "metadata": {},
            "name": "viewSetFavouriteMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$d64781493fbfe6b0$var$node.hash = "af74e48c451986374e11a5b801d5009f";
var $d64781493fbfe6b0$export$2e2bcd8739ae039 = $d64781493fbfe6b0$var$node;

});

parcelRegister("dXq4S", function(module, exports) {

$parcel$export(module.exports, "isAri", () => $5c4418bd595ae8cf$export$8e68286aef4c3a8b);
$parcel$export(module.exports, "createAri", () => $5c4418bd595ae8cf$export$594d18a0ad2e0e57);
$parcel$export(module.exports, "toAri", () => $5c4418bd595ae8cf$export$24b47820a324e614);
$parcel$export(module.exports, "toAriOrDefault", () => $5c4418bd595ae8cf$export$e2789192113e8b07);
$parcel$export(module.exports, "parseAri", () => $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5);
$parcel$export(module.exports, "getAriConfig", () => $5c4418bd595ae8cf$export$3d8d7031a11613fd);
/**
 * Module to work with Atlassian Resource Identifier (ARI)
 * More info in go/aris
 */ const $5c4418bd595ae8cf$var$ARI_REG_EXP = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>.{0}):(?<resourceType>[a-z.-]+)(\/(?<workspaceId>[\w.~_-]+)?)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<providerAppId>[\w.~_-]+)\/(?<resourceId>[\w.~_/-]+)$/;
const $5c4418bd595ae8cf$export$8e68286aef4c3a8b = (ari)=>$5c4418bd595ae8cf$var$ARI_REG_EXP.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER.test(ari);
const $5c4418bd595ae8cf$export$594d18a0ad2e0e57 = ({ resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId })=>{
    if (workspaceId != null) return `ari:cloud:${resourceOwner}::${resourceType}/${workspaceId}/${resourceId}`;
    if (activationId != null) return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/${resourceId}`;
};
const $5c4418bd595ae8cf$export$24b47820a324e614 = (ari)=>{
    if ($5c4418bd595ae8cf$export$8e68286aef4c3a8b(ari)) return ari;
    return undefined;
};
const $5c4418bd595ae8cf$export$e2789192113e8b07 = (ari, defaultValue = '')=>$5c4418bd595ae8cf$export$24b47820a324e614(ari) ?? defaultValue;
const $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5 = (ari)=>{
    if ($5c4418bd595ae8cf$export$8e68286aef4c3a8b(ari)) {
        const parts = $5c4418bd595ae8cf$var$ARI_REG_EXP.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER.exec(ari);
        if (parts?.groups) {
            // reconstructing an object just to avoid flow error (otherwise says inexact object type of parts.groups is incompatible with exact AriConfig type)
            const { resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId } = parts.groups;
            return {
                resourceOwner: resourceOwner,
                cloudId: cloudId,
                resourceType: resourceType,
                workspaceId: workspaceId,
                resourceId: resourceId,
                activationId: activationId
            };
        }
    }
    return undefined;
};
const $5c4418bd595ae8cf$export$3d8d7031a11613fd = (ari)=>{
    const config = $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5(ari);
    if (config === undefined) throw Error('Invalid ARI - this should only be possible if there is a bug in `toAri`');
    return config;
};

});

parcelRegister("j6ttF", function(module, exports) {

$parcel$export(module.exports, "favoriteTypeToTypename", () => $b9c3378eb0d73712$export$b98f76d96728a853);
$parcel$export(module.exports, "favoriteMutationToRestPayload", () => $b9c3378eb0d73712$export$717886a1047f1287);

var $9AmTW = parcelRequire("9AmTW");

var $6BtlL = parcelRequire("6BtlL");

var $kwbhb = parcelRequire("kwbhb");

var $6oLWS = parcelRequire("6oLWS");

var $aSWXp = parcelRequire("aSWXp");

var $kV9ss = parcelRequire("kV9ss");
function $b9c3378eb0d73712$var$assertUnreachable(_) {
    throw new Error('Unexpected entity type');
}
const $b9c3378eb0d73712$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
const $b9c3378eb0d73712$export$b98f76d96728a853 = (type, resourceId)=>{
    switch(type){
        case 'projects':
            return 'JiraProject';
        case 'filters':
            return $b9c3378eb0d73712$var$isSystemFilter(resourceId) ? 'JiraSystemFilter' : 'JiraCustomFilter';
        case 'dashboards':
            return 'JiraDashboard';
        case 'plans':
            return 'JiraPlan';
        case 'boards':
            return 'JiraBoard';
        case 'queues':
            return 'JiraServiceManagementQueue';
        default:
            return undefined;
    }
};
const $b9c3378eb0d73712$var$favoriteAriToId = (typename, ari)=>{
    switch(typename){
        case 'JiraProject':
            return (0, $kV9ss.JiraProjectAri).parse(ari).projectId;
        case 'JiraCustomFilter':
        case 'JiraSystemFilter':
            return (0, $6oLWS.JiraFilterAri).parse(ari).filterId;
        case 'JiraDashboard':
            return (0, $kwbhb.JiraDashboardAri).parse(ari).dashboardId;
        case 'JiraPlan':
            return (0, $aSWXp.JiraPlanAri).parse(ari).planId;
        case 'JiraBoard':
            return (0, $6BtlL.JiraSoftwareBoardAri).parse(ari).boardId;
        case 'JiraServiceManagementQueue':
            return (0, $9AmTW.JiraServicedeskQueueAri).parse(ari).queueId;
        default:
            $b9c3378eb0d73712$var$assertUnreachable(typename);
    }
};
const $b9c3378eb0d73712$var$favoriteTypenameToType = (typename)=>{
    switch(typename){
        case 'JiraProject':
            return 'projects';
        case 'JiraCustomFilter':
        case 'JiraSystemFilter':
            return 'filters';
        case 'JiraDashboard':
            return 'dashboards';
        case 'JiraPlan':
            return 'plans';
        case 'JiraBoard':
            return 'boards';
        case 'JiraServiceManagementQueue':
            return 'queues';
        default:
            $b9c3378eb0d73712$var$assertUnreachable(typename);
    }
};
const $b9c3378eb0d73712$export$717886a1047f1287 = ({ id: id, typename: typename, value: value, beforeEntity: beforeEntity })=>({
        id: $b9c3378eb0d73712$var$favoriteAriToId(typename, id),
        type: $b9c3378eb0d73712$var$favoriteTypenameToType(typename),
        value: value,
        beforeEntity: beforeEntity ? {
            id: $b9c3378eb0d73712$var$favoriteAriToId(beforeEntity.typename, beforeEntity.id),
            type: $b9c3378eb0d73712$var$favoriteTypenameToType(beforeEntity.typename)
        } : undefined
    });

});
parcelRegister("9AmTW", function(module, exports) {

$parcel$export(module.exports, "JiraServicedeskQueueAri", () => $6fa93d978dc51edc$export$555c8ae00f64ebff);

var $IfwMb = parcelRequire("IfwMb");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira-servicedesk/queue/manifest.ts
var $6fa93d978dc51edc$var$jiraServicedeskQueueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $IfwMb.JiraServicedeskQueueAriResourceOwner),
    resourceType: (0, $IfwMb.JiraServicedeskQueueAriResourceType),
    resourceIdSlug: "activation/{activationId}/{queueId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        queueId: /[0-9]+/
    }
};
// src/jira-servicedesk/queue/index.ts
var $6fa93d978dc51edc$export$555c8ae00f64ebff = class _JiraServicedeskQueueAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._queueId = opts.resourceIdSegmentValues.queueId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get queueId() {
        return this._queueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $6fa93d978dc51edc$var$jiraServicedeskQueueAriStaticOpts.qualifier,
            platformQualifier: $6fa93d978dc51edc$var$jiraServicedeskQueueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $6fa93d978dc51edc$var$jiraServicedeskQueueAriStaticOpts.resourceOwner,
            resourceType: $6fa93d978dc51edc$var$jiraServicedeskQueueAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.queueId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                queueId: opts.queueId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $6fa93d978dc51edc$var$jiraServicedeskQueueAriStaticOpts);
        return new _JiraServicedeskQueueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $6fa93d978dc51edc$var$jiraServicedeskQueueAriStaticOpts);
        return new _JiraServicedeskQueueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            queueId: this.queueId
        };
    }
};

});
parcelRegister("IfwMb", function(module, exports) {

$parcel$export(module.exports, "JiraServicedeskQueueAriResourceOwner", () => $085027a493012871$export$704112eeb385ceab);
$parcel$export(module.exports, "JiraServicedeskQueueAriResourceType", () => $085027a493012871$export$6adb8c07b8bc2c5a);
// src/jira-servicedesk/queue/types.ts
var $085027a493012871$export$704112eeb385ceab = "jira-servicedesk", $085027a493012871$export$6adb8c07b8bc2c5a = "queue";

});


parcelRegister("6BtlL", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwareBoardAri", () => $4cecf7137216f798$export$fcd404066e55a7a8);

var $8ANGM = parcelRequire("8ANGM");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira-software/board/manifest.ts
var $4cecf7137216f798$var$jiraSoftwareBoardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $8ANGM.JiraSoftwareBoardAriResourceOwner),
    resourceType: (0, $8ANGM.JiraSoftwareBoardAriResourceType),
    resourceIdSlug: "{boardId}",
    resourceIdSegmentFormats: {
        boardId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira-software/board/index.ts
var $4cecf7137216f798$export$fcd404066e55a7a8 = class _JiraSoftwareBoardAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._boardId = opts.resourceIdSegmentValues.boardId;
    }
    get siteId() {
        return this._siteId;
    }
    get boardId() {
        return this._boardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $4cecf7137216f798$var$jiraSoftwareBoardAriStaticOpts.qualifier,
            platformQualifier: $4cecf7137216f798$var$jiraSoftwareBoardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $4cecf7137216f798$var$jiraSoftwareBoardAriStaticOpts.resourceOwner,
            resourceType: $4cecf7137216f798$var$jiraSoftwareBoardAriStaticOpts.resourceType,
            resourceId: `${opts.boardId}`,
            resourceIdSegmentValues: {
                boardId: opts.boardId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $4cecf7137216f798$var$jiraSoftwareBoardAriStaticOpts);
        return new _JiraSoftwareBoardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $4cecf7137216f798$var$jiraSoftwareBoardAriStaticOpts);
        return new _JiraSoftwareBoardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            boardId: this.boardId
        };
    }
};

});
parcelRegister("8ANGM", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwareBoardAriResourceOwner", () => $64183abbeecc9672$export$d716ba4f5572ec86);
$parcel$export(module.exports, "JiraSoftwareBoardAriResourceType", () => $64183abbeecc9672$export$d4b70c04cf2221a5);
// src/jira-software/board/types.ts
var $64183abbeecc9672$export$d716ba4f5572ec86 = "jira-software", $64183abbeecc9672$export$d4b70c04cf2221a5 = "board";

});


parcelRegister("kwbhb", function(module, exports) {

$parcel$export(module.exports, "JiraDashboardAri", () => $eeff8afd95fca51f$export$b7d4016f0f5da5b8);

var $6H9w3 = parcelRequire("6H9w3");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/dashboard/manifest.ts
var $eeff8afd95fca51f$var$jiraDashboardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $6H9w3.JiraDashboardAriResourceOwner),
    resourceType: (0, $6H9w3.JiraDashboardAriResourceType),
    resourceIdSlug: "activation/{activationId}/{dashboardId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        dashboardId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/dashboard/index.ts
var $eeff8afd95fca51f$export$b7d4016f0f5da5b8 = class _JiraDashboardAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._dashboardId = opts.resourceIdSegmentValues.dashboardId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get dashboardId() {
        return this._dashboardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $eeff8afd95fca51f$var$jiraDashboardAriStaticOpts.qualifier,
            platformQualifier: $eeff8afd95fca51f$var$jiraDashboardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $eeff8afd95fca51f$var$jiraDashboardAriStaticOpts.resourceOwner,
            resourceType: $eeff8afd95fca51f$var$jiraDashboardAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.dashboardId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                dashboardId: opts.dashboardId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $eeff8afd95fca51f$var$jiraDashboardAriStaticOpts);
        return new _JiraDashboardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $eeff8afd95fca51f$var$jiraDashboardAriStaticOpts);
        return new _JiraDashboardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            dashboardId: this.dashboardId
        };
    }
};

});
parcelRegister("6H9w3", function(module, exports) {

$parcel$export(module.exports, "JiraDashboardAriResourceOwner", () => $014208d660d71eea$export$62c1deae25c41d24);
$parcel$export(module.exports, "JiraDashboardAriResourceType", () => $014208d660d71eea$export$e4e3a57a5e435aff);
// src/jira/dashboard/types.ts
var $014208d660d71eea$export$62c1deae25c41d24 = "jira", $014208d660d71eea$export$e4e3a57a5e435aff = "dashboard";

});


parcelRegister("aSWXp", function(module, exports) {

$parcel$export(module.exports, "JiraPlanAri", () => $7eccae3426beb5b5$export$6d2eb3641569f26);

var $fi2nK = parcelRequire("fi2nK");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/plan/manifest.ts
var $7eccae3426beb5b5$var$jiraPlanAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $fi2nK.JiraPlanAriResourceOwner),
    resourceType: (0, $fi2nK.JiraPlanAriResourceType),
    resourceIdSlug: "activation/{activationId}/{planId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        planId: /[0-9]+/
    }
};
// src/jira/plan/index.ts
var $7eccae3426beb5b5$export$6d2eb3641569f26 = class _JiraPlanAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._planId = opts.resourceIdSegmentValues.planId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get planId() {
        return this._planId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $7eccae3426beb5b5$var$jiraPlanAriStaticOpts.qualifier,
            platformQualifier: $7eccae3426beb5b5$var$jiraPlanAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $7eccae3426beb5b5$var$jiraPlanAriStaticOpts.resourceOwner,
            resourceType: $7eccae3426beb5b5$var$jiraPlanAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.planId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                planId: opts.planId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $7eccae3426beb5b5$var$jiraPlanAriStaticOpts);
        return new _JiraPlanAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $7eccae3426beb5b5$var$jiraPlanAriStaticOpts);
        return new _JiraPlanAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            planId: this.planId
        };
    }
};

});
parcelRegister("fi2nK", function(module, exports) {

$parcel$export(module.exports, "JiraPlanAriResourceOwner", () => $b21a627cc548ba69$export$bfd26af3c5e1b90d);
$parcel$export(module.exports, "JiraPlanAriResourceType", () => $b21a627cc548ba69$export$d6abe08eb30f433d);
// src/jira/plan/types.ts
var $b21a627cc548ba69$export$bfd26af3c5e1b90d = "jira", $b21a627cc548ba69$export$d6abe08eb30f433d = "plan";

});



parcelRegister("5c9oS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9559749111f2eca$export$2e2bcd8739ae039);

var $7eYK2 = parcelRequire("7eYK2");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f9559749111f2eca$export$2e2bcd8739ae039 = async (request)=>(0, $7eYK2.updateFavorite)(request);

});
parcelRegister("7eYK2", function(module, exports) {

$parcel$export(module.exports, "updateFavorite", () => $16085bb5bdb7219b$export$8c2f00130cc945dc);

var $eusud = parcelRequire("eusud");
const $16085bb5bdb7219b$export$8c2f00130cc945dc = async (request)=>{
    if (request.value) return (0, $eusud.performPostRequest)('/rest/internal/2/favourites', {
        body: JSON.stringify({
            entity: {
                id: request.id,
                type: request.type
            },
            beforeEntityPosition: request.beforeEntity || null
        })
    });
    return (0, $eusud.performDeleteRequest)(`/rest/internal/2/favourites/${request.type}/${request.id}`);
};

});


parcelRegister("7SIuT", function(module, exports) {

$parcel$export(module.exports, "errorFlag", () => $7252fdcfc0e15292$export$b9a7f1ebeaa76953);

var $0YlRJ = parcelRequire("0YlRJ");
const $7252fdcfc0e15292$export$b9a7f1ebeaa76953 = ()=>({
        type: 'error',
        ...(0, $0YlRJ.default)
    });

});
parcelRegister("0YlRJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $87ad72b3da53041c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $87ad72b3da53041c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.title",
        "defaultMessage": "Something\u2019s gone wrong"
    },
    description: {
        "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.description",
        "defaultMessage": "You cannot star items right now due to an error."
    }
});

});



parcelRegister("9WLyc", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ff4f0ec548b713f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0ff4f0ec548b713f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addToStarred: {
        "id": "navigation-apps-sidebar-nav4-common.favorite-toggle-button.add-to-starred",
        "defaultMessage": "Add to starred"
    },
    removeFromStarred: {
        "id": "navigation-apps-sidebar-nav4-common.favorite-toggle-button.remove-from-starred",
        "defaultMessage": "Remove from starred"
    },
    addToStarredWithName: {
        "id": "navigation-apps-sidebar-nav4-common.favorite-toggle-button.add-to-starred-with-name",
        "defaultMessage": "Add \"{name}\" to starred"
    },
    removeFromStarredWithName: {
        "id": "navigation-apps-sidebar-nav4-common.favorite-toggle-button.remove-from-starred-with-name",
        "defaultMessage": "Remove \"{name}\" from starred"
    }
});

});


parcelRegister("cKjus", function(module, exports) {

$parcel$export(module.exports, "AsyncSaveFilterDialogContent", () => $c23de2261bd2f58d$export$e0d40cb0f88fa57d);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $c23de2261bd2f58d$var$SaveFilterDialogContent = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("51u3z")).then((module)=>({
            default: module.OldSaveFilterDialogContent
        })), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/save-filter-dialog/src/ui/save-filter-dialog/save-filter-dialog-content/index.tsx"
});
const $c23de2261bd2f58d$export$e0d40cb0f88fa57d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-save-filters-dialog-content",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c23de2261bd2f58d$var$SaveFilterDialogContent, props));

});
parcelRegister("51u3z", function(module, exports) {

let $3a845c57f539c9fd$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $3a845c57f539c9fd$var$load("ffQaD"),
    $3a845c57f539c9fd$var$load("kvRbA"),
    $3a845c57f539c9fd$var$load("hISoq")
]).then(()=>parcelRequire('2lPrs'));

});


parcelRegister("6KXPO", function(module, exports) {

$parcel$export(module.exports, "AsyncUpdateFilterDialog", () => $5522efbabcc83563$export$8692e2751472dade);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5522efbabcc83563$var$UpdateFilterDialog = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("3sC5F")).then((module)=>({
            default: module.OldUpdateFilterDialog
        })), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/save-filter-dialog/src/ui/update-filter-dialog/index.tsx"
});
const $5522efbabcc83563$export$8692e2751472dade = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-update-filter-dialog",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5522efbabcc83563$var$UpdateFilterDialog, props));

});
parcelRegister("3sC5F", function(module, exports) {

let $28518898ef4402ce$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $28518898ef4402ce$var$load("ffQaD"),
    $28518898ef4402ce$var$load("kvRbA"),
    $28518898ef4402ce$var$load("eSPSB")
]).then(()=>parcelRequire('36hTn'));

});


parcelRegister("90yGq", function(module, exports) {

$parcel$export(module.exports, "useAccountId", () => $903db0de2618ef6c$export$e72033e0f5baa3e);

var $9OXo1 = parcelRequire("9OXo1");
const $903db0de2618ef6c$export$e72033e0f5baa3e = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.atlassianAccountId || null;
};

});

parcelRegister("fY39E", function(module, exports) {

$parcel$export(module.exports, "useActivationId", () => $d72c67677898c114$export$43686faa787c943);

var $9OXo1 = parcelRequire("9OXo1");
const $d72c67677898c114$export$43686faa787c943 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.activationId;
};

});

parcelRegister("2KAtx", function(module, exports) {

$parcel$export(module.exports, "ModalEntryPointPressableTrigger", () => $a17c22dd70443cfd$export$defad645fcc21c0a);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $iwwXK = parcelRequire("iwwXK");

var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");

var $414Wj = parcelRequire("414Wj");

var $kMSay = parcelRequire("kMSay");

var $7NYq5 = parcelRequire("7NYq5");

var $9fuVs = parcelRequire("9fuVs");

var $c5vfY = parcelRequire("c5vfY");

var $7mPT9 = parcelRequire("7mPT9");

var $gJdig = parcelRequire("gJdig");

var $fiv1r = parcelRequire("fiv1r");

var $dWBzX = parcelRequire("dWBzX");
const $a17c22dd70443cfd$var$emptyObject = {};
const $a17c22dd70443cfd$export$defad645fcc21c0a = ({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorAttributes: errorAttributes, Fallback: Fallback, interactionName: interactionName, title: title, modalProps: modalProps, useInternalModal: useInternalModal, forwardedRef: forwardedRef })=>{
    const { openModal: openModal } = (0, $5uXOq.useContext)((0, $gJdig.ModalContext));
    const environmentProvider = (0, $fiv1r.useJiraRelayEnvironmentProvider)();
    const metricName = (0, $5uXOq.useMemo)(()=>{
        if (interactionName) return interactionName;
        // @ts-expect-error Need to fix the types on this
        return entryPoint?.root?.getModuleName() ?? 'unknown';
    }, [
        entryPoint,
        interactionName
    ]);
    // eslint-disable-next-line jira/ufo/valid-labels
    const pressTracing = (0, $kMSay.default)(metricName);
    const load = (0, $5uXOq.useCallback)(()=>(0, $8Uumt.loadEntryPoint)(environmentProvider, entryPoint, // @ts-expect-error TS cannot infer that emptyObject is the correct params
        // type for TEntryPoint even when performing an explicit undefined check
        entryPointParams ?? $a17c22dd70443cfd$var$emptyObject), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onBeforeLoad = (0, $5uXOq.useCallback)(()=>{
        if (interactionName) pressTracing();
    }, [
        interactionName,
        pressTracing
    ]);
    const onLoad = (0, $5uXOq.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
        openModal(({ onClose: closeModal, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress, setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick, setShouldCloseOnEscapePress: setShouldCloseOnEscapePress })=>{
            const onClose = ()=>{
                entryPointProps?.onClose?.();
                closeModal();
                dispose();
            };
            const defaultFallbackInner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), null, title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $414Wj.default), {
                grow: "fill"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null));
            const defaultFallback = useInternalModal ? defaultFallbackInner : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
                messageId: "modal-entry-point-pressable-trigger.modal.fallback",
                messageType: "transactional",
                onClose: closeModal,
                width: modalProps?.width,
                height: modalProps?.height
            }, defaultFallbackInner);
            const container = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c5vfY.InternalEntryPointContainer), {
                entryPointReference: entryPointReference,
                errorAttributes: errorAttributes,
                errorFallback: "flag",
                fallback: Fallback ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Fallback, {
                    onClose: closeModal
                }) : defaultFallback,
                id: metricName,
                placeholderName: "modal-entry-point-pressable-trigger-container",
                // @ts-expect-error Some type mismatch, should fix it one day
                runtimeProps: {
                    ...entryPointProps ?? $a17c22dd70443cfd$var$emptyObject,
                    onClose: onClose,
                    setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
                    setShouldCloseOnEscapePress: setShouldCloseOnEscapePress,
                    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress
                }
            });
            return useInternalModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
                ...modalProps,
                messageId: "modal-entry-point-pressable-trigger.modal",
                messageType: "transactional",
                onClose: onClose,
                shouldCloseOnOverlayClick: shouldCloseOnOverlayClick ?? modalProps?.shouldCloseOnOverlayClick,
                shouldCloseOnEscapePress: shouldCloseOnEscapePress ?? modalProps?.shouldCloseOnEscapePress
            }, container)) : container;
        });
    }, [
        openModal,
        title,
        useInternalModal,
        modalProps,
        errorAttributes,
        Fallback,
        metricName,
        entryPointProps
    ]);
    const triggerRef = (0, $dWBzX.usePressablePreloadRef)({
        load: load,
        onBeforeLoad: onBeforeLoad,
        onLoad: onLoad
    });
    if (forwardedRef != null) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const ref = (0, $7mPT9.default)(triggerRef, forwardedRef);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return children({
            ref: ref
        });
    }
    return children({
        ref: triggerRef
    });
};

});
parcelRegister("kMSay", function(module, exports) {

$parcel$export(module.exports, "default", () => $143a91bbcd4a2e96$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6wxJn = parcelRequire("6wxJn");
function $143a91bbcd4a2e96$export$2e2bcd8739ae039(name) {
    const context = (0, $5uXOq.useContext)((0, $6wxJn.default));
    const handleClick = (0, $5uXOq.useCallback)((timeStamp)=>{
        if (context) {
            const time = timeStamp || performance.now();
            context.tracePress(name, time);
        }
    }, [
        context,
        name
    ]);
    return handleClick;
}

});

parcelRegister("7NYq5", function(module, exports) {

$parcel$export(module.exports, "JiraModal", () => $d308ab9275c4cac7$export$3782fcca1f68992e);

var $5uXOq = parcelRequire("5uXOq");

var $1R1Ge = parcelRequire("1R1Ge");

var $10xFf = parcelRequire("10xFf");

var $c0dQj = parcelRequire("c0dQj");

var $1WAOl = parcelRequire("1WAOl");
const $d308ab9275c4cac7$export$3782fcca1f68992e = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        if ((0, $c0dQj.isMobileAndInViewPanelIterationExperiment)()) return null;
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1WAOl.ChoreographerModal), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1R1Ge.default), rest);
};
$d308ab9275c4cac7$export$3782fcca1f68992e.displayName = 'JiraModal';

});
parcelRegister("1WAOl", function(module, exports) {

$parcel$export(module.exports, "ChoreographerModal", () => $ae3d8c3c4e97b978$export$3f5d627caa6fc630);
// eslint-disable-next-line @typescript-eslint/no-restricted-imports

var $1R1Ge = parcelRequire("1R1Ge");

var $cSWNW = parcelRequire("cSWNW");
const $ae3d8c3c4e97b978$export$3f5d627caa6fc630 = (0, $cSWNW.withChoreographedRender)((0, $1R1Ge.default));

});
parcelRegister("cSWNW", function(module, exports) {

$parcel$export(module.exports, "withChoreographedRender", () => $620c1a9f3fec1a68$export$c1160fdac17030e);

var $5uXOq = parcelRequire("5uXOq");

var $ioD1B = parcelRequire("ioD1B");

var $fG5AJ = parcelRequire("fG5AJ");
function $620c1a9f3fec1a68$export$c1160fdac17030e(Component) {
    function ChoreographedComponent(props) {
        const { messageId: messageId, onMessageDisposition: onMessageDisposition } = props;
        const shouldRender = (0, $fG5AJ.useChoreographedRender)({
            messageId: messageId,
            onMessageDisposition: onMessageDisposition
        });
        if (shouldRender) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ioD1B.ChoreographerContextProvider), {
            isChoreographed: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, props));
        return null;
    }
    ChoreographedComponent.displayName = `Choreographed${Component.displayName ?? 'Component'}`;
    function WithChoreographedRenderComponent(props) {
        const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $ioD1B.useChoreographedStatusContext)();
        if (isAlreadyChoreographedAtAncestor) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ChoreographedComponent, props);
    }
    WithChoreographedRenderComponent.displayName = `WithChoreographedRender${Component.displayName ?? 'Component'}`;
    return WithChoreographedRenderComponent;
}

});



parcelRegister("9fuVs", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $1dd87679d9ca363b$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $1dd87679d9ca363b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $k4r7E = parcelRequire("k4r7E");
const $1dd87679d9ca363b$export$ebbb59327adb551a = /*#__PURE__*/ (0, $5uXOq.createContext)((0, $k4r7E.rootRegistry));
const $1dd87679d9ca363b$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $5uXOq.useMemo)(()=>new (0, $k4r7E.ShortcutRegistry)(), []);
    const parentRegistry = (0, $5uXOq.useContext)($1dd87679d9ca363b$export$ebbb59327adb551a) || (0, $k4r7E.rootRegistry);
    (0, $5uXOq.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1dd87679d9ca363b$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $1dd87679d9ca363b$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : $1dd87679d9ca363b$var$ShortcutScope;

});
parcelRegister("k4r7E", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $a65fecdbaed23de2$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $a65fecdbaed23de2$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $lbWm4 = parcelRequire("lbWm4");

var $561FV = parcelRequire("561FV");

var $hGgHi = parcelRequire("hGgHi");

var $FISJv = parcelRequire("FISJv");

var $lIZQG = parcelRequire("lIZQG");
const $a65fecdbaed23de2$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($lbWm4)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($lbWm4)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $lIZQG.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($lbWm4)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $lIZQG.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $lIZQG.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $a65fecdbaed23de2$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $a65fecdbaed23de2$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($FISJv)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($FISJv)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$a65fecdbaed23de2$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $a65fecdbaed23de2$export$1dd4c61d1ce1fa15 = new $a65fecdbaed23de2$export$ca1c75b575abf5ff();

});
parcelRegister("FISJv", function(module, exports) {

var $g7i7g = parcelRequire("g7i7g");

var $5wIsF = parcelRequire("5wIsF");
/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */ var $07d6a509d0c9362c$var$pull = $g7i7g($5wIsF);
module.exports = $07d6a509d0c9362c$var$pull;

});
parcelRegister("5wIsF", function(module, exports) {

var $anVYT = parcelRequire("anVYT");
/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */ function $40626e026fe1545a$var$pullAll(array, values) {
    return array && array.length && values && values.length ? $anVYT(array, values) : array;
}
module.exports = $40626e026fe1545a$var$pullAll;

});
parcelRegister("anVYT", function(module, exports) {

var $1nIHN = parcelRequire("1nIHN");

var $2wwA6 = parcelRequire("2wwA6");

var $jA03V = parcelRequire("jA03V");

var $cW28x = parcelRequire("cW28x");

var $jHlUS = parcelRequire("jHlUS");
/** Used for built-in method references. */ var $78f90735d44c9d27$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $78f90735d44c9d27$var$splice = $78f90735d44c9d27$var$arrayProto.splice;
/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */ function $78f90735d44c9d27$var$basePullAll(array, values, iteratee, comparator) {
    var indexOf = comparator ? $jA03V : $2wwA6, index = -1, length = values.length, seen = array;
    if (array === values) values = $jHlUS(values);
    if (iteratee) seen = $1nIHN(array, $cW28x(iteratee));
    while(++index < length){
        var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
        while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
            if (seen !== array) $78f90735d44c9d27$var$splice.call(seen, fromIndex, 1);
            $78f90735d44c9d27$var$splice.call(array, fromIndex, 1);
        }
    }
    return array;
}
module.exports = $78f90735d44c9d27$var$basePullAll;

});
parcelRegister("jA03V", function(module, exports) {
/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e4116d7d57d0dfb7$var$baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (comparator(array[index], value)) return index;
    }
    return -1;
}
module.exports = $e4116d7d57d0dfb7$var$baseIndexOfWith;

});




parcelRegister("lIZQG", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $ca3344250c7b7406$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $ca3344250c7b7406$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $ca3344250c7b7406$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $ca3344250c7b7406$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $ca3344250c7b7406$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $ca3344250c7b7406$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $ca3344250c7b7406$var$toKey = (e)=>{
    if ($ca3344250c7b7406$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $ca3344250c7b7406$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $ca3344250c7b7406$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($ca3344250c7b7406$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $ca3344250c7b7406$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $ca3344250c7b7406$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$ca3344250c7b7406$var$orSpecialChars}))))?(meta\\+)?(${$ca3344250c7b7406$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $ca3344250c7b7406$var$shortcutRegex = RegExp(`^${$ca3344250c7b7406$var$singleShortcutEntry}( ${$ca3344250c7b7406$var$singleShortcutEntry})*$`);
const $ca3344250c7b7406$export$8e231506c5580162 = (shortcut)=>$ca3344250c7b7406$var$shortcutRegex.test(shortcut);
const $ca3344250c7b7406$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});



parcelRegister("gJdig", function(module, exports) {

$parcel$export(module.exports, "ModalContext", () => $308ba6e6ba886f08$export$ab57792b9b6974a6);

var $5uXOq = parcelRequire("5uXOq");
const $308ba6e6ba886f08$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    openModal: ()=>{}
});

});

parcelRegister("dWBzX", function(module, exports) {

$parcel$export(module.exports, "usePressablePreloadRef", () => $01294bc664dce1e5$export$1ff47f24e06a5d2d);

var $5uXOq = parcelRequire("5uXOq");
const $01294bc664dce1e5$var$PRELOAD_MAX_AGE = 2000;
const $01294bc664dce1e5$var$TIME_TO_INTENT = 200;
function $01294bc664dce1e5$export$1ff47f24e06a5d2d({ load: load, onBeforeLoad: onBeforeLoad, onLoad: onLoad }) {
    const ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const request = {};
        const clearPreloadTimeouts = ()=>{
            if (typeof request.preloadIntentTimeout === 'number') {
                clearTimeout(request.preloadIntentTimeout);
                delete request.preloadIntentTimeout;
            }
            if (typeof request.preloadMaxAgeTimeout === 'number') {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const cancelPreload = ()=>{
            clearPreloadTimeouts();
            request.preload?.dispose();
        };
        const loadReference = ()=>{
            if (request.load) return request.load;
            const reference = request.preload?.reference ?? load();
            if (request.preload) delete request.preload;
            request.load = {
                reference: reference,
                dispose () {
                    reference.dispose();
                    delete request.load;
                }
            };
            return request.load;
        };
        const clickListener = ()=>{
            clearPreloadTimeouts();
            onBeforeLoad();
            onLoad(loadReference());
        };
        const mouseDownListener = ()=>{
            clearPreloadTimeouts();
            loadReference();
        };
        const preloadReference = ()=>{
            if (request.preloadIntentTimeout || request.preload) return;
            request.preloadIntentTimeout = setTimeout(()=>{
                delete request.preloadIntentTimeout;
                const reference = load();
                request.preload = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.preload;
                    }
                };
                request.preloadMaxAgeTimeout = setTimeout(()=>{
                    delete request.preloadMaxAgeTimeout;
                    request.preload?.dispose();
                }, $01294bc664dce1e5$var$PRELOAD_MAX_AGE);
            }, $01294bc664dce1e5$var$TIME_TO_INTENT);
        };
        el.addEventListener('click', clickListener);
        el.addEventListener('mousedown', mouseDownListener);
        el.addEventListener('mouseenter', preloadReference);
        el.addEventListener('mouseleave', cancelPreload);
        return ()=>{
            cancelPreload();
            el.removeEventListener('click', clickListener);
            el.removeEventListener('mousedown', mouseDownListener);
            el.removeEventListener('mouseenter', preloadReference);
            el.removeEventListener('mouseleave', cancelPreload);
        };
    }, [
        load,
        onBeforeLoad,
        onLoad
    ]);
    return ref;
}

});


parcelRegister("c88gN", function(module, exports) {

$parcel$export(module.exports, "saveFilterDialogEntryPoint", () => $cfe7c72484f65a07$export$7485e0220e11838f);

var $8Wzbc = parcelRequire("8Wzbc");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $cfe7c72484f65a07$export$7485e0220e11838f = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("51u3z")), {
        moduleId: "6b7b6fa9",
        priority: "interaction"
    }),
    getPreloadProps: ({ filterAri: filterAri })=>({
            queries: {
                filterDataQuery: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $8Wzbc.default,
                    variables: {
                        filterAri: filterAri ?? '',
                        includeFilter: !!filterAri
                    }
                }
            }
        })
});

});
parcelRegister("8Wzbc", function(module, exports) {

$parcel$export(module.exports, "default", () => $5367ef59b8680269$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<023defe713d59713b501c494a8f5f82d>>
 * @relayHash 1cbad96d89377cc6461f652661fc6f1e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fd504e29d4dc200a7bd2aa6320fb29407cc36c5f68c5b1d8ee23563f54a69190
const $5367ef59b8680269$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeFilter"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "filterAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "description"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v7 = {
        "kind": "RequiredField",
        "field": {
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": v2 /*: any*/ ,
                    "action": "THROW",
                    "path": "jira.filter.shareGrants.edges.node.project.id"
                },
                v3 /*: any*/ ,
                v6 /*: any*/ 
            ]
        },
        "action": "THROW",
        "path": "jira.filter.shareGrants.edges.node.project"
    }, v8 = {
        "kind": "ScalarField",
        "name": "roleId"
    }, v9 = {
        "concreteType": "JiraRole",
        "kind": "LinkedField",
        "name": "role",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            v3 /*: any*/ 
        ]
    }, v10 = {
        "concreteType": "JiraGroup",
        "kind": "LinkedField",
        "name": "group",
        "plural": false,
        "selections": [
            v2 /*: any*/ ,
            v3 /*: any*/ 
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v12 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v13 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            v3 /*: any*/ ,
            v12 /*: any*/ 
        ]
    }, v14 = {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
            v2 /*: any*/ ,
            v3 /*: any*/ ,
            v6 /*: any*/ 
        ]
    }, v15 = {
        "kind": "RequiredField",
        "field": v14 /*: any*/ ,
        "action": "THROW",
        "path": "jira.filter.editGrants.edges.node.project"
    }, v16 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v5 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v14 /*: any*/ 
                    ],
                    "type": "JiraShareableEntityProjectGrant"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v14 /*: any*/ ,
                        {
                            "concreteType": "JiraRole",
                            "kind": "LinkedField",
                            "name": "role",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                v3 /*: any*/ ,
                                v2 /*: any*/ 
                            ]
                        }
                    ],
                    "type": "JiraShareableEntityProjectRoleGrant"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v10 /*: any*/ 
                    ],
                    "type": "JiraShareableEntityGroupGrant"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v11 /*: any*/ ,
                                v3 /*: any*/ ,
                                v12 /*: any*/ ,
                                v2 /*: any*/ 
                            ]
                        }
                    ],
                    "type": "JiraShareableEntityUserGrant"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "saveFilterDialogBaseQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "includeFilter",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraShareableEntityShareGrantConnection",
                                                    "kind": "LinkedField",
                                                    "name": "shareGrants",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraShareableEntityShareGrantEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v7 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraShareableEntityProjectGrant"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v9 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "jira.filter.shareGrants.edges.node.role"
                                                                                }
                                                                            ],
                                                                            "type": "JiraShareableEntityProjectRoleGrant"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v10 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "jira.filter.shareGrants.edges.node.group"
                                                                                }
                                                                            ],
                                                                            "type": "JiraShareableEntityGroupGrant"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v13 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "jira.filter.shareGrants.edges.node.user"
                                                                                }
                                                                            ],
                                                                            "type": "JiraShareableEntityUserGrant"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraShareableEntityEditGrantConnection",
                                                    "kind": "LinkedField",
                                                    "name": "editGrants",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraShareableEntityEditGrantEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v15 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraShareableEntityProjectGrant"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v15 /*: any*/ ,
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v9 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "jira.filter.editGrants.edges.node.role"
                                                                                }
                                                                            ],
                                                                            "type": "JiraShareableEntityProjectRoleGrant"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v10 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "jira.filter.editGrants.edges.node.group"
                                                                                }
                                                                            ],
                                                                            "type": "JiraShareableEntityGroupGrant"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v13 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "jira.filter.editGrants.edges.node.user"
                                                                                }
                                                                            ],
                                                                            "type": "JiraShareableEntityUserGrant"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraCustomFilter"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "saveFilterDialogBaseQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "includeFilter",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraShareableEntityShareGrantConnection",
                                                    "kind": "LinkedField",
                                                    "name": "shareGrants",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraShareableEntityShareGrantEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": v16 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraShareableEntityEditGrantConnection",
                                                    "kind": "LinkedField",
                                                    "name": "editGrants",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraShareableEntityEditGrantEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": v16 /*: any*/ 
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraCustomFilter"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fd504e29d4dc200a7bd2aa6320fb29407cc36c5f68c5b1d8ee23563f54a69190",
            "metadata": {},
            "name": "saveFilterDialogBaseQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5367ef59b8680269$var$node.hash = "45c8d5891e94a17785f8230bd778c3e5";
var $5367ef59b8680269$export$2e2bcd8739ae039 = $5367ef59b8680269$var$node;

});


parcelRegister("dPDY8", function(module, exports) {

$parcel$export(module.exports, "updateFilterDialogEntryPoint", () => $d618886bc2f027fb$export$89f63332d1b5f8db);

var $8Wzbc = parcelRequire("8Wzbc");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $d618886bc2f027fb$export$89f63332d1b5f8db = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("3sC5F")), {
        moduleId: "a40748cc",
        priority: "interaction"
    }),
    getPreloadProps: ({ filterAri: filterAri })=>({
            queries: {
                filterDataQuery: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $8Wzbc.default,
                    variables: {
                        filterAri: filterAri ?? '',
                        includeFilter: !!filterAri
                    }
                }
            }
        })
});

});

parcelRegister("qBWno", function(module, exports) {

$parcel$export(module.exports, "useFilterActionsAnalytics", () => $e63dd990973b9127$export$97e99df7fbddf9f6);
$parcel$export(module.exports, "getFilterActionAttributes", () => $e63dd990973b9127$export$b06742bfd24ebf9f);
$parcel$export(module.exports, "getFilterMeatBallAttributes", () => $e63dd990973b9127$export$b8e6b9b84ba340a2);
$parcel$export(module.exports, "getRecentAndFavouriteFilterAttributes", () => $e63dd990973b9127$export$2108e20c9691c7e4);
$parcel$export(module.exports, "getDefaulFilterAttributes", () => $e63dd990973b9127$export$15e07b997aa6036a);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");





var $jecJ3 = parcelRequire("jecJ3");

var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $e63dd990973b9127$export$97e99df7fbddf9f6 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireFilterActionAnalytics = (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useCallback)((actionSubject, attributes)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: actionSubject
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_FILTERS], attributes);
    }, [
        createAnalyticsEvent
    ]) : (actionSubject, attributes)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: actionSubject
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_FILTERS], attributes);
    };
    return fireFilterActionAnalytics;
};
const $e63dd990973b9127$var$systemFilterNameMap = [
    {
        name: 'myOpenIssues',
        id: '-1'
    },
    {
        name: 'reportedByMe',
        id: '-2'
    },
    {
        name: 'allIssues',
        id: '-4'
    },
    {
        name: 'openIssues',
        id: '-5'
    },
    {
        name: 'doneIssues',
        id: '-9'
    },
    {
        name: 'viewedRecently',
        id: '-3'
    },
    {
        name: 'resolvedRecently',
        id: '-7'
    },
    {
        name: 'updatedRecently',
        id: '-8'
    },
    {
        name: 'createdRecently',
        id: '-6'
    }
];
const $e63dd990973b9127$export$c8c77a62dd73e040 = (id)=>{
    const systemFilter = $e63dd990973b9127$var$systemFilterNameMap.find((filter)=>filter.id === id);
    return systemFilter?.name || '';
};
const $e63dd990973b9127$var$getSection = (isCustom, isFavourite)=>{
    let section;
    if (!isCustom && !isFavourite) section = 'defaultFilters';
    else if (isFavourite) section = (0, $jecJ3.SECTION_ITEM_STARRED);
    else section = (0, $jecJ3.SECTION_ITEM_RECENT);
    return section;
};
const $e63dd990973b9127$var$getFilterId = (isCustom, filterId)=>{
    if (!filterId) return null;
    return (0, $jhS4y.ENTITY_ID).FILTER(isCustom ? filterId : $e63dd990973b9127$export$c8c77a62dd73e040(filterId));
};
const $e63dd990973b9127$export$b06742bfd24ebf9f = ({ itemId: itemId, isCustom: isCustom, isFavourite: isFavourite, filterId: filterId })=>{
    const section = $e63dd990973b9127$var$getSection(isCustom, Boolean(isFavourite));
    return {
        itemId: itemId,
        section: section,
        level: section === 'defaultFilters' ? (0, $951a0ed422513987$export$35ac629b8b943d5a) : (0, $951a0ed422513987$export$f9db6a58b4aabd18),
        componentType: isCustom ? (0, $1e554a683893bd46$export$5374c2c2d3ece55e) : (0, $1e554a683893bd46$export$74712b62056d422e),
        parentItemType: isCustom ? (0, $632bd8725b437a12$export$c1c49903035a02df) : (0, $632bd8725b437a12$export$6deee0e4f2fb784e),
        parentItemId: $e63dd990973b9127$var$getFilterId(isCustom, filterId)
    };
};
const $e63dd990973b9127$export$b8e6b9b84ba340a2 = ({ isCustom: isCustom, isFavourite: isFavourite, filterId: filterId })=>{
    const section = $e63dd990973b9127$var$getSection(isCustom, Boolean(isFavourite));
    return {
        section: section,
        level: section === 'defaultFilters' ? (0, $951a0ed422513987$export$f9db6a58b4aabd18) : (0, $951a0ed422513987$export$fe3b012b0224e4e1),
        componentType: isCustom ? (0, $1e554a683893bd46$export$9bd6c21d500ae611) : (0, $1e554a683893bd46$export$95b0c331af13d819),
        itemId: (0, $496585bee7985bb9$export$f06dfcec5ff912e),
        parentItemType: isCustom ? (0, $632bd8725b437a12$export$c1c49903035a02df) : (0, $632bd8725b437a12$export$6deee0e4f2fb784e),
        parentItemId: $e63dd990973b9127$var$getFilterId(isCustom, filterId)
    };
};
const $e63dd990973b9127$export$2108e20c9691c7e4 = ({ isCustom: isCustom, filterId: filterId, section: section })=>{
    return {
        level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
        section: section,
        componentType: isCustom ? (0, $1e554a683893bd46$export$3ac911b122986477) : (0, $1e554a683893bd46$export$4165a3d0da3bd147),
        itemId: $e63dd990973b9127$var$getFilterId(isCustom, filterId),
        itemType: isCustom ? (0, $632bd8725b437a12$export$c1c49903035a02df) : (0, $632bd8725b437a12$export$6deee0e4f2fb784e)
    };
};
const $e63dd990973b9127$export$15e07b997aa6036a = ({ filterId: filterId })=>{
    return {
        level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
        itemId: $e63dd990973b9127$var$getFilterId(false, filterId),
        section: 'defaultFilters',
        componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
        itemType: (0, $632bd8725b437a12$export$6deee0e4f2fb784e)
    };
};

});

parcelRegister("gDIE0", function(module, exports) {

$parcel$export(module.exports, "ChangeOwnerModal", () => $af6a0238933bbda1$export$fe3f500d38bfe0df);

var $5uXOq = parcelRequire("5uXOq");

var $bSlMQ = parcelRequire("bSlMQ");
const $af6a0238933bbda1$export$fe3f500d38bfe0df = ({ isOpen: isOpen, filterId: filterId, onRefetch: onRefetch, onClose: onClose })=>{
    const onSuccess = (0, $5uXOq.useCallback)(()=>{
        onRefetch({
            onComplete: ()=>undefined
        });
        onClose();
    }, [
        onRefetch,
        onClose
    ]);
    return isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bSlMQ.default), {
        id: filterId,
        onInitiateSuccess: ()=>undefined,
        onSuccess: onSuccess,
        onCancel: onClose,
        onInitiateFailed: ()=>undefined
    });
};

});
parcelRegister("bSlMQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b0e45c1a3e32250$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $j55bS = parcelRequire("j55bS");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5b0e45c1a3e32250$var$NoLazyAsyncChangeOwnerFilterModal = (0, $kxZPA.lazy)(()=>(parcelRequire("cqhDQ")), {
    moduleId: "./src/packages/global-pages/directories/filters-directory-v2/change-owner-filter-modal/src/index.tsx"
});
const $5b0e45c1a3e32250$var$AsyncChangeOwnerFilterModal = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "configure-owner-modal",
        packageName: "filter",
        fallback: "flag",
        teamName: "endeavour"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "change-owner-filter-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j55bS.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5b0e45c1a3e32250$var$NoLazyAsyncChangeOwnerFilterModal, props)));
var $5b0e45c1a3e32250$export$2e2bcd8739ae039 = $5b0e45c1a3e32250$var$AsyncChangeOwnerFilterModal;

});
parcelRegister("cqhDQ", function(module, exports) {

let $90b599040e9a71b3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $90b599040e9a71b3$var$load("dLKaq").then(()=>parcelRequire('2gMly'));

});



parcelRegister("l3IPn", function(module, exports) {

$parcel$export(module.exports, "DeleteFilterModal", () => $fae9ebce90c122ba$export$7eeb027d3dbb72df);

var $5uXOq = parcelRequire("5uXOq");

var $eM3no = parcelRequire("eM3no");

var $pa9q9 = parcelRequire("pa9q9");

var $ieDtd = parcelRequire("ieDtd");
var $lVJAU = parcelRequire("lVJAU");

var $ddrvO = parcelRequire("ddrvO");
const $fae9ebce90c122ba$export$7eeb027d3dbb72df = ({ isOpen: isOpen, name: name, filterId: filterId, onClose: onClose, onRefetch: onRefetch })=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const [filterQueryParam] = (0, $ieDtd.useQueryParam)('filter');
    const onSuccess = (0, $5uXOq.useCallback)(()=>{
        onRefetch({
            onComplete: ()=>undefined
        });
        if (filterQueryParam === filterId) push('/jira/filters');
        onClose();
        showFlag({
            id: 'filter-deleted',
            title: [
                (0, $ddrvO.default).filterDeletedModalTitleSuccessNonFinal,
                {
                    name: name
                }
            ],
            type: 'success',
            messageId: 'navigation-apps-sidebar-nav4-sidebars-content-filters.common.ui.filter-actions.delete-filter-modal.show-flag.success',
            messageType: 'transactional'
        });
    }, [
        filterId,
        filterQueryParam,
        name,
        onClose,
        onRefetch,
        push,
        showFlag
    ]);
    const onFailure = (0, $5uXOq.useCallback)(()=>{
        onClose();
        showFlag({
            id: 'filter-delete-failed',
            title: (0, $ddrvO.default).filterDeletedModalTitleErrorNonFinal,
            description: (0, $ddrvO.default).filterDeletedModalDescriptionErrorNonFinal,
            type: 'error',
            messageId: 'navigation-apps-sidebar-nav4-sidebars-content-filters.common.ui.filter-actions.delete-filter-modal.show-flag.error',
            messageType: 'transactional'
        });
    }, [
        onClose,
        showFlag
    ]);
    const filter = {
        name: name,
        id: filterId
    };
    return isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eM3no.default), {
        baseUrl: "",
        filter: filter,
        onFilterDeleted: onSuccess,
        onFilterDeleteFailed: onFailure,
        onFilterInitiateFailed: onFailure,
        onCancel: onClose
    });
};

});
parcelRegister("eM3no", function(module, exports) {

$parcel$export(module.exports, "default", () => $06cd5fbdfa743d8b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $jzjy1 = parcelRequire("jzjy1");

var $jD5no = parcelRequire("jD5no");

var $lf2Au = parcelRequire("lf2Au");

var $7iJwP = parcelRequire("7iJwP");


var $dZMvI = parcelRequire("dZMvI");

var $jemkP = parcelRequire("jemkP");

var $aDeVF = parcelRequire("aDeVF");

var $9ekJG = parcelRequire("9ekJG");

// eslint-disable-next-line jira/react/no-class-components
class $06cd5fbdfa743d8b$var$DeleteModal extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            onInitialised: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onFilterDeleted: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    constructor(props){
        super(props);
        this.store = (0, $aDeVF.default)((0, $dZMvI.default));
        this.store.dispatch((0, $jemkP.setAppProps)(this.props));
        this.store.dispatch((0, $jemkP.getAssociatedItems)());
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
            store: this.store,
            hasErrorBoundary: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
            id: "unhandled",
            packageName: "jiraDeleteFiltersModal",
            teamName: "jira-cosmos"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lf2Au.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9ekJG.default), null))));
    }
}
var $06cd5fbdfa743d8b$export$2e2bcd8739ae039 = (0, $jzjy1.AnalyticsSource)('deleteFilter', (0, $4d5e0871c06cee03$export$1171103ea9083ffa))($06cd5fbdfa743d8b$var$DeleteModal);

});
parcelRegister("jzjy1", function(module, exports) {

$parcel$export(module.exports, "AnalyticsSource", () => $578c443a5ba38dde$export$6890652a1aff7d1c);
$parcel$export(module.exports, "AnalyticsSubject", () => $578c443a5ba38dde$export$ec9f54bd4341ceb);

var $994MI = parcelRequire("994MI");
const $578c443a5ba38dde$export$6890652a1aff7d1c = (name, type)=>(WrappedComponent)=>(0, $994MI.default)({
            source: `${name}${type}`
        })(WrappedComponent);
const $578c443a5ba38dde$export$ec9f54bd4341ceb = (name, attributes)=>(WrappedComponent)=>(0, $994MI.default)({
            actionSubject: name,
            attributes: attributes
        })(WrappedComponent);

});

parcelRegister("lf2Au", function(module, exports) {

$parcel$export(module.exports, "default", () => $9249f8c63b854f95$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $9249f8c63b854f95$var$AppStyle = ({ children: children })=>/*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            "_11c82smr _4t3i1kw7"
        ])
    }, children);
const $9249f8c63b854f95$var$appStyles = null;
var $9249f8c63b854f95$export$2e2bcd8739ae039 = $9249f8c63b854f95$var$AppStyle;

});

parcelRegister("dZMvI", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8e39f8e320e7804$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $kzfeq = parcelRequire("kzfeq");

var $b5iht = parcelRequire("b5iht");
var // @ts-expect-error - TS2769 - No overload matches this call.
$a8e39f8e320e7804$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $kzfeq.default), (0, $b5iht.default));

});
parcelRegister("kzfeq", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b20171187c0eaaf$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("9o0uh");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $fsh9d = parcelRequire("fsh9d");


var $3HwlS = parcelRequire("3HwlS");

var $i2hR1 = parcelRequire("i2hR1");

var $jemkP = parcelRequire("jemkP");

var $iOraS = parcelRequire("iOraS");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1b20171187c0eaaf$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $jemkP.DELETE_FILTER)).mergeMap(({ onComplete: onComplete })=>{
        const state = store.getState();
        const baseUrl = (0, $iOraS.getBaseUrl)(state);
        const filter = (0, $iOraS.getFilter)(state);
        return (0, $kVLXA.Observable).fromPromise((0, $i2hR1.default)(baseUrl, filter.id)).mergeMap(()=>{
            (0, $iOraS.getOnFilterDeleted)(state)(filter);
            (0, $3HwlS.getWillShowNav4)() && onComplete?.();
            return (0, $kVLXA.Observable).of((0, $jemkP.filterDeleted)());
        }).catch((error)=>{
            (0, $fsh9d.logSafeErrorWithoutCustomerData)(error, 'directories.filters-v2.delete-modal.ops.delete-filter', (0, $c6c682f59adc6c63$export$9c2a9d62bcf944f8));
            (0, $iOraS.getOnFilterDeleteFailed)(state)(filter);
            return (0, $kVLXA.Observable).of((0, $jemkP.deleteFilterFailed)());
        });
    });

});
parcelRegister("fsh9d", function(module, exports) {

$parcel$export(module.exports, "logSafeErrorWithoutCustomerData", () => $064efdbf2b7e743c$export$c77be5886e7f1d9e);

var $2YZCu = parcelRequire("2YZCu");
const $064efdbf2b7e743c$export$b94ad046ae639a1c = (error, location, suffix, message)=>(0, $2YZCu.default).safeErrorWithoutCustomerData(location, message || error.message, error);
const $064efdbf2b7e743c$export$c77be5886e7f1d9e = (error, location, suffix, message)=>(0, $2YZCu.default).safeErrorWithoutCustomerData(location, message || error.message, error);

});

const $c6c682f59adc6c63$export$9c2a9d62bcf944f8 = 'directories.filters.error';

parcelRegister("i2hR1", function(module, exports) {

$parcel$export(module.exports, "default", () => $f063f6444575f430$export$2e2bcd8739ae039);

var $lNsNP = parcelRequire("lNsNP");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f063f6444575f430$export$2e2bcd8739ae039 = (baseUrl, filterId)=>(0, $lNsNP.default)(baseUrl, filterId);

});
parcelRegister("lNsNP", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3cc82205e32ffce$export$2e2bcd8739ae039);

var $eusud = parcelRequire("eusud");
const $d3cc82205e32ffce$export$7138c24907de3954 = (baseUrl, filterId)=>`/rest/api/3/filter/${filterId}`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d3cc82205e32ffce$export$2e2bcd8739ae039 = (baseUrl, filterId)=>(0, $eusud.performDeleteRequest)($d3cc82205e32ffce$export$7138c24907de3954(baseUrl, filterId));

});


parcelRegister("jemkP", function(module, exports) {

$parcel$export(module.exports, "SET_APP_PROPS", () => $62c4330949a1ef35$export$8aefe701a6f431e0);
$parcel$export(module.exports, "setAppProps", () => $62c4330949a1ef35$export$cfda7627848a58cd);
$parcel$export(module.exports, "GET_ASSOCIATED_ITEMS", () => $62c4330949a1ef35$export$30d51c320095bdf2);
$parcel$export(module.exports, "getAssociatedItems", () => $62c4330949a1ef35$export$41e54fd4a1e5f9ba);
$parcel$export(module.exports, "ASSOCIATED_ITEMS_RETRIEVED", () => $62c4330949a1ef35$export$ba1e7147572f059);
$parcel$export(module.exports, "associatedItemsRetrieved", () => $62c4330949a1ef35$export$25e9475c64e5eda0);
$parcel$export(module.exports, "GET_ASSOCIATED_ITEMS_FAILED", () => $62c4330949a1ef35$export$4c7da338bde02996);
$parcel$export(module.exports, "getAssociatedItemsFailed", () => $62c4330949a1ef35$export$bc1efa3ceb08db7b);
$parcel$export(module.exports, "DELETE_FILTER", () => $62c4330949a1ef35$export$c90b00f6f11adca7);
$parcel$export(module.exports, "deleteFilter", () => $62c4330949a1ef35$export$d80cc0328fcc6685);
$parcel$export(module.exports, "DELETE_FILTER_FAILED", () => $62c4330949a1ef35$export$d3f2a09b0efe5b07);
$parcel$export(module.exports, "deleteFilterFailed", () => $62c4330949a1ef35$export$e303ddf5f6d63378);
$parcel$export(module.exports, "FILTER_DELETED", () => $62c4330949a1ef35$export$c8cf94be5a7baff9);
$parcel$export(module.exports, "filterDeleted", () => $62c4330949a1ef35$export$9411fafcb56b5a87);
const $62c4330949a1ef35$export$8aefe701a6f431e0 = 'state.SET_APP_PROPS';
const $62c4330949a1ef35$export$cfda7627848a58cd = (payload)=>({
        type: $62c4330949a1ef35$export$8aefe701a6f431e0,
        payload: payload
    });
const $62c4330949a1ef35$export$30d51c320095bdf2 = 'state.GET_ASSOCIATED_ITEMS';
const $62c4330949a1ef35$export$41e54fd4a1e5f9ba = ()=>({
        type: $62c4330949a1ef35$export$30d51c320095bdf2
    });
const $62c4330949a1ef35$export$ba1e7147572f059 = 'state.ASSOCIATED_ITEMS_RETRIEVED';
const $62c4330949a1ef35$export$25e9475c64e5eda0 = (payload)=>({
        type: $62c4330949a1ef35$export$ba1e7147572f059,
        payload: payload
    });
const $62c4330949a1ef35$export$4c7da338bde02996 = 'state.GET_ASSOCIATED_ITEMS_FAILED';
const $62c4330949a1ef35$export$bc1efa3ceb08db7b = ()=>({
        type: $62c4330949a1ef35$export$4c7da338bde02996
    });
const $62c4330949a1ef35$export$c90b00f6f11adca7 = 'state.DELETE_FILTER';
const $62c4330949a1ef35$export$d80cc0328fcc6685 = (onComplete)=>({
        type: $62c4330949a1ef35$export$c90b00f6f11adca7,
        onComplete: onComplete
    });
const $62c4330949a1ef35$export$d3f2a09b0efe5b07 = 'state.DELETE_FILTER_FAILED';
const $62c4330949a1ef35$export$e303ddf5f6d63378 = ()=>({
        type: $62c4330949a1ef35$export$d3f2a09b0efe5b07
    });
const $62c4330949a1ef35$export$c8cf94be5a7baff9 = 'state.FILTER_DELETED';
const $62c4330949a1ef35$export$9411fafcb56b5a87 = ()=>({
        type: $62c4330949a1ef35$export$c8cf94be5a7baff9
    });

});

parcelRegister("iOraS", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $317d9690ead12f9d$export$f654b28f82155665);
$parcel$export(module.exports, "getFilter", () => $317d9690ead12f9d$export$61ec8404f465cd36);
$parcel$export(module.exports, "getFilterName", () => $317d9690ead12f9d$export$b055b0a980ec5c8b);
$parcel$export(module.exports, "getOnInitialised", () => $317d9690ead12f9d$export$47263859bc15a8b8);
$parcel$export(module.exports, "getOnFilterDeleted", () => $317d9690ead12f9d$export$f5f4c932a633fd32);
$parcel$export(module.exports, "getOnFilterDeleteFailed", () => $317d9690ead12f9d$export$eb50a3cf06607a3c);
$parcel$export(module.exports, "getOnFilterInitiateFailed", () => $317d9690ead12f9d$export$9ef18d2a82ac120);
$parcel$export(module.exports, "getOnCancel", () => $317d9690ead12f9d$export$2c6267c00ffc9906);
$parcel$export(module.exports, "isDeleteInProgress", () => $317d9690ead12f9d$export$906c0d65e4ece39d);
$parcel$export(module.exports, "isDataRetrieved", () => $317d9690ead12f9d$export$a9211cdc0a6969f);
$parcel$export(module.exports, "getAssociatedBoards", () => $317d9690ead12f9d$export$2de9e9ee805a66);
$parcel$export(module.exports, "getAssociatedUsers", () => $317d9690ead12f9d$export$4004cc0feaedb1d1);
$parcel$export(module.exports, "getAssociatedGroups", () => $317d9690ead12f9d$export$4f21761c9913ab49);
$parcel$export(module.exports, "getCanDelete", () => $317d9690ead12f9d$export$e31d21defdc79bd5);
const $317d9690ead12f9d$export$f654b28f82155665 = (state)=>state.appProps.baseUrl;
const $317d9690ead12f9d$export$61ec8404f465cd36 = (state)=>state.appProps.filter;
const $317d9690ead12f9d$export$b055b0a980ec5c8b = (state)=>state.appProps.filter.name;
const $317d9690ead12f9d$export$47263859bc15a8b8 = (state)=>state.appProps.onInitialised;
const $317d9690ead12f9d$export$f5f4c932a633fd32 = (state)=>state.appProps.onFilterDeleted;
const $317d9690ead12f9d$export$eb50a3cf06607a3c = (state)=>state.appProps.onFilterDeleteFailed;
const $317d9690ead12f9d$export$9ef18d2a82ac120 = (state)=>state.appProps.onFilterInitiateFailed;
const $317d9690ead12f9d$export$2c6267c00ffc9906 = (state)=>state.appProps.onCancel;
const $317d9690ead12f9d$export$906c0d65e4ece39d = (state)=>state.isDeleteInProgress;
const $317d9690ead12f9d$export$a9211cdc0a6969f = (state)=>state.isDataRetrieved;
const $317d9690ead12f9d$export$2de9e9ee805a66 = (state)=>state.boards;
const $317d9690ead12f9d$export$4004cc0feaedb1d1 = (state)=>state.users;
const $317d9690ead12f9d$export$4f21761c9913ab49 = (state)=>state.groups;
const $317d9690ead12f9d$export$e31d21defdc79bd5 = (state)=>Array.isArray(state.boards) && state.boards.length === 0;

});


parcelRegister("b5iht", function(module, exports) {

$parcel$export(module.exports, "default", () => $b80972f9b3fefbb4$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("9o0uh");
parcelRequire("9IWoG");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $fsh9d = parcelRequire("fsh9d");


var $2idt2 = parcelRequire("2idt2");

var $7r08o = parcelRequire("7r08o");

var $jemkP = parcelRequire("jemkP");

var $iOraS = parcelRequire("iOraS");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b80972f9b3fefbb4$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $jemkP.GET_ASSOCIATED_ITEMS)).mergeMap(()=>{
        const state = store.getState();
        const baseUrl = (0, $iOraS.getBaseUrl)(state);
        const filter = (0, $iOraS.getFilter)(state);
        return (0, $kVLXA.Observable).forkJoin((0, $kVLXA.Observable).fromPromise((0, $2idt2.default)(baseUrl, filter.id)), (0, $kVLXA.Observable).fromPromise((0, $7r08o.default)(baseUrl, filter.id))) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .map(([boards, subscriptions])=>{
            const { users: users, groups: groups } = subscriptions;
            (0, $iOraS.getOnInitialised)(state)();
            return (0, $jemkP.associatedItemsRetrieved)({
                boards: boards,
                users: users,
                groups: groups
            });
        }).catch((error)=>{
            (0, $fsh9d.logSafeErrorWithoutCustomerData)(error, 'directories.filters-v2.delete-modal.ops.get-associated-items', (0, $c6c682f59adc6c63$export$9c2a9d62bcf944f8));
            (0, $iOraS.getOnFilterInitiateFailed)(state)(filter);
            return (0, $kVLXA.Observable).of((0, $jemkP.getAssociatedItemsFailed)());
        });
    });

});
parcelRegister("2idt2", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f9e6e4df190511d$export$2e2bcd8739ae039);

var $fDRaW = parcelRequire("fDRaW");

var $1rV38 = parcelRequire("1rV38");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5f9e6e4df190511d$export$2e2bcd8739ae039 = async (baseUrl, filterId)=>{
    const response = await (0, $fDRaW.default)(baseUrl, filterId);
    return (0, $1rV38.default)(response, baseUrl);
};

});
parcelRegister("fDRaW", function(module, exports) {

$parcel$export(module.exports, "default", () => $57ef3264d1641307$export$2e2bcd8739ae039);

var $7f4tk = parcelRequire("7f4tk");
const $57ef3264d1641307$export$7138c24907de3954 = (baseUrl, filterId)=>`/rest/agile/1.0/board/filter/${filterId}`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$57ef3264d1641307$export$2e2bcd8739ae039 = (baseUrl, filterId)=>(0, $7f4tk.default)($57ef3264d1641307$export$7138c24907de3954(baseUrl, filterId));

});

parcelRegister("1rV38", function(module, exports) {

$parcel$export(module.exports, "default", () => $af931ea4cf63d8b4$export$2e2bcd8739ae039);
const $af931ea4cf63d8b4$export$b708cb7873d8352c = (baseUrl, id)=>`/secure/RapidBoard.jspa?rapidView=${id}&useStoredSettings=true`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$af931ea4cf63d8b4$export$2e2bcd8739ae039 = (response, baseUrl)=>{
    const boards = response && response.values || [];
    return boards.map((board)=>{
        const { name: name, id: id } = board;
        const href = $af931ea4cf63d8b4$export$b708cb7873d8352c(baseUrl, id);
        return {
            name: name,
            id: id,
            href: href
        };
    });
};

});


parcelRegister("7r08o", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddd004cba93b1adc$export$2e2bcd8739ae039);

var $eAHx9 = parcelRequire("eAHx9");

var $79DFK = parcelRequire("79DFK");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ddd004cba93b1adc$export$2e2bcd8739ae039 = async (baseUrl, filterId)=>{
    const response = await (0, $eAHx9.default)(baseUrl, filterId);
    return (0, $79DFK.default)(response, baseUrl);
};

});
parcelRegister("eAHx9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7443769520e58a35$export$2e2bcd8739ae039);

var $7f4tk = parcelRequire("7f4tk");
const $7443769520e58a35$export$7138c24907de3954 = (baseUrl, filterId)=>`/rest/api/3/filter/${filterId}?expand=subscriptions`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7443769520e58a35$export$2e2bcd8739ae039 = (baseUrl, filterId)=>(0, $7f4tk.default)($7443769520e58a35$export$7138c24907de3954(baseUrl, filterId));

});

parcelRegister("79DFK", function(module, exports) {

$parcel$export(module.exports, "default", () => $196e75ab8ca89e74$export$2e2bcd8739ae039);

var $EVhLF = parcelRequire("EVhLF");

var $4R6GH = parcelRequire("4R6GH");
const $196e75ab8ca89e74$export$d62b55bf0ad74ba2 = (baseUrl, id)=>{
    if ((0, $4R6GH.fg)('jira-adopt-teams-nav-config')) {
        const { href: href } = (0, $EVhLF.getNavigateToTeamsApp)({
            type: 'USER',
            payload: {
                userId: id
            }
        });
        return href;
    }
    return `/jira/people/${id}`;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$196e75ab8ca89e74$export$2e2bcd8739ae039 = (response, baseUrl)=>{
    const subscriptions = response && response.subscriptions && response.subscriptions.items || [];
    const users = [];
    const groups = [];
    subscriptions.forEach((subscription)=>{
        const { user: user, group: group } = subscription;
        if (group) return groups.push({
            // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'never'.
            name: group.name
        });
        // @ts-expect-error - TS2339 - Property 'accountId' does not exist on type 'never'.
        const href = $196e75ab8ca89e74$export$d62b55bf0ad74ba2(baseUrl, user.accountId);
        return user && users.push({
            // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'never'.
            displayName: user.displayName,
            href: href
        });
    });
    return {
        users: users,
        groups: groups
    };
};

});
parcelRegister("EVhLF", function(module, exports) {

$parcel$export(module.exports, "useNavigateToTeamsApp", () => $0d16faf147778319$export$520a42ab062954ec);
$parcel$export(module.exports, "getNavigateToTeamsApp", () => $0d16faf147778319$export$cfadab73fb247145);

var $d53Sn = parcelRequire("d53Sn");

var $14XJw = parcelRequire("14XJw");

var $koeKL = parcelRequire("koeKL");

var $lVJAU = parcelRequire("lVJAU");

var $3HwlS = parcelRequire("3HwlS");

var $j8DrX = parcelRequire("j8DrX");
const $0d16faf147778319$export$520a42ab062954ec = (navActionPayload, shouldOpenInSameTab)=>{
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    if (!orgId) throw new Error('Org ID is required to navigate to Teams App');
    return (0, $d53Sn.navigateToTeamsApp)({
        push: push,
        hostProduct: 'jira',
        orgId: orgId,
        cloudId: cloudId,
        userHasNav4Enabled: (0, $3HwlS.getWillShowNav4)(),
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
const $0d16faf147778319$export$cfadab73fb247145 = (navActionPayload, shouldOpenInSameTab)=>{
    const orgId = (0, $j8DrX.default)('ajs-org-id');
    if (!orgId) throw new Error('Org ID is required to navigate to Teams App');
    return (0, $d53Sn.navigateToTeamsApp)({
        hostProduct: 'jira',
        orgId: orgId,
        userHasNav4Enabled: (0, $3HwlS.getWillShowNav4)(),
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};

});
parcelRegister("d53Sn", function(module, exports) {

$parcel$export(module.exports, "navigateToTeamsApp", () => $13549e397172d8e2$export$cd99a4ca8e852372);

var $lBryT = parcelRequire("lBryT");
const $13549e397172d8e2$export$cd99a4ca8e852372 = (action)=>{
    const { hostProduct: hostProduct, shouldOpenInSameTab: shouldOpenInSameTab } = action;
    const actionWithDefaults = {
        ...action,
        /**
		 * If teams app is enabled, default to opening in new tab.
		 */ shouldOpenInSameTab: shouldOpenInSameTab === undefined ? !(0, $lBryT.isTeamsAppEnabled)(action) : shouldOpenInSameTab,
        hostProduct: hostProduct || (0, $lBryT.getHostProductFromPath)()
    };
    const { path: path, query: query } = (0, $lBryT.getPathAndQuery)(actionWithDefaults);
    const href = (0, $lBryT.generatePath)(path, actionWithDefaults, query);
    const onNavigate = (0, $lBryT.onNavigateBase)(href, actionWithDefaults);
    const result = {
        onNavigate: onNavigate,
        href: href,
        target: actionWithDefaults.shouldOpenInSameTab ? '_self' : '_blank'
    };
    return result;
};

});
parcelRegister("lBryT", function(module, exports) {

$parcel$export(module.exports, "generatePath", () => $e8f5f831eba017b3$export$82476f982757e71e);
$parcel$export(module.exports, "isTeamsAppEnabled", () => $e8f5f831eba017b3$export$5921b2a93a401547);
$parcel$export(module.exports, "onNavigateBase", () => $e8f5f831eba017b3$export$39f25014273b0a58);
$parcel$export(module.exports, "getPathAndQuery", () => $e8f5f831eba017b3$export$b406f12e2156b3fe);
$parcel$export(module.exports, "getHostProductFromPath", () => $e8f5f831eba017b3$export$a792d22ca73cc3ca);

var $5euJh = parcelRequire("5euJh");
var $c04PQ = parcelRequire("c04PQ");

var $VSDnB = parcelRequire("VSDnB");

var $bs8uJ = parcelRequire("bs8uJ");
function $e8f5f831eba017b3$export$82476f982757e71e(path, config, query = new URLSearchParams(), anchor) {
    if ($e8f5f831eba017b3$export$5921b2a93a401547(config) || config.hostProduct === 'home' || !config.hostProduct) {
        if (config.cloudId) query.set('cloudId', config.cloudId);
        // URLSearchParams.size doesn't work in jest
        const queryString = [
            ...new Set(query.keys())
        ].length > 0 ? `?${query.toString()}` : '';
        // Home & therefore the Teams app, is not deployed to FedRamp, instead we have deployed Standalone directory.
        // At some point, likely both Commercial & FedRamp will follow the same URL convention and we can remove this,
        // but for now, we need to generate a different URL for FedRamp.
        if ((0, $c04PQ.isFedRamp)()) // We can't use getATLContextUrl here as the URL doesn't yet exist in commercial. When it does, we should properly define it there.
        return `https://teams${$e8f5f831eba017b3$export$a9f2c34176fff494() ? '.stg' : ''}.atlassian-us-gov.com/${path}${anchor ? `#${anchor}` : ''}${queryString}`;
        const orgIdString = config.orgId ? `/o/${config.orgId}` : '';
        return `${(0, $5euJh.getATLContextUrl)('home')}${orgIdString}/people/${path}${anchor ? `#${anchor}` : ''}${queryString}`;
    }
    const queryString = [
        ...new Set(query.keys())
    ].length > 0 ? `?${query.toString()}` : '';
    return `${(0, $bs8uJ.origin)()}/${config.hostProduct === 'confluence' ? 'wiki' : 'jira'}/people/${path}${queryString}`;
}
const $e8f5f831eba017b3$export$39f25014273b0a58 = (href, config)=>(e)=>{
        if (e) e.preventDefault();
        if ($e8f5f831eba017b3$export$5921b2a93a401547(config)) {
            if (config.shouldOpenInSameTab) {
                (0, $bs8uJ.redirect)(href);
                return;
            }
            (0, $bs8uJ.openInNewTab)(href);
            return;
        } else if (config.shouldOpenInSameTab) {
            if (config.push) {
                config.push(href);
                return;
            }
            (0, $bs8uJ.redirect)(href);
            return;
        } else {
            (0, $bs8uJ.openInNewTab)(href);
            return;
        }
    };
function $e8f5f831eba017b3$var$stripAriFromId(id) {
    // Return everything after the last slash
    return id.split('/').pop() || '';
}
function $e8f5f831eba017b3$export$b406f12e2156b3fe(action) {
    switch(action.type){
        case 'LANDING':
        case 'DIRECTORY':
            return {
                path: ''
            };
        case 'USER':
            return {
                path: `${$e8f5f831eba017b3$var$stripAriFromId(action.payload.userId)}`,
                anchor: action.payload.section
            };
        case 'TEAM':
            return {
                path: `team/${$e8f5f831eba017b3$var$stripAriFromId(action.payload.teamId)}`
            };
        case 'AGENT':
            return {
                path: `agent/${$e8f5f831eba017b3$var$stripAriFromId(action.payload.agentId)}`
            };
        case 'KUDOS':
            return {
                path: `kudos/${$e8f5f831eba017b3$var$stripAriFromId(action.payload.kudosId)}`
            };
        case 'TEAMS_DIRECTORY':
            return {
                path: '',
                query: new URLSearchParams({
                    screen: 'SEARCH_TEAMS'
                })
            };
        case 'PEOPLE_DIRECTORY':
            return {
                path: `search/people`,
                query: new URLSearchParams(action.payload.query)
            };
        case 'USER_WORK':
            return {
                path: `${$e8f5f831eba017b3$var$stripAriFromId(action.payload.userId)}/work`
            };
        default:
            return {
                path: ''
            };
    }
}
function $e8f5f831eba017b3$export$a9f2c34176fff494() {
    const host = (0, $bs8uJ.hostname)();
    // *.stg.atlassian-us-gov-mod.com OR *.stg.atlassian-us-gov-mod.net
    if (host.match(/stg\.atlassian-us-gov-mod\.(com|net)/)) return true;
    return false;
}
function $e8f5f831eba017b3$export$5921b2a93a401547(config) {
    if (!(0, $VSDnB.fg)('should-redirect-directory-to-teams-app')) // This is the base switch, without it, teams app is not enabled
    return false;
    if ((0, $c04PQ.isFedRamp)()) // In FedRamp, we are ignoring the Nav4 dependency
    return true;
    // We have a hard dependency on Nav4 being enabled in order to use the teams app
    return config.userHasNav4Enabled === undefined ? true : config.userHasNav4Enabled;
}
function $e8f5f831eba017b3$export$a792d22ca73cc3ca() {
    const path = (0, $bs8uJ.pathname)();
    if (path.startsWith('/wiki')) return 'confluence';
    if (path.startsWith('/jira')) return 'jira';
    if ((0, $bs8uJ.hostname)().startsWith('home')) return 'home';
    return undefined;
}

});
parcelRegister("bs8uJ", function(module, exports) {

$parcel$export(module.exports, "redirect", () => $e7dd5c0b1b178de6$export$89e12c5b50f7529d);
$parcel$export(module.exports, "openInNewTab", () => $e7dd5c0b1b178de6$export$9e52b10d57ddf9e3);
$parcel$export(module.exports, "hostname", () => $e7dd5c0b1b178de6$export$640106f6dc7d2706);
$parcel$export(module.exports, "origin", () => $e7dd5c0b1b178de6$export$f710a83a91838a36);
$parcel$export(module.exports, "pathname", () => $e7dd5c0b1b178de6$export$7333db99aa99d383);
function $e7dd5c0b1b178de6$export$89e12c5b50f7529d(url) {
    window.location.href = url;
}
const $e7dd5c0b1b178de6$export$9e52b10d57ddf9e3 = (url)=>window.open(url, '_blank', 'noopener noreferrer');
const $e7dd5c0b1b178de6$export$640106f6dc7d2706 = ()=>globalThis.location?.hostname;
const $e7dd5c0b1b178de6$export$f710a83a91838a36 = ()=>globalThis.location?.origin;
const $e7dd5c0b1b178de6$export$7333db99aa99d383 = ()=>globalThis.location?.pathname;

});








parcelRegister("aDeVF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ce4dd7ecc996a54$export$2e2bcd8739ae039);

var $F2Mxm = parcelRequire("F2Mxm");

var $aXcJn = parcelRequire("aXcJn");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9ce4dd7ecc996a54$export$2e2bcd8739ae039 = (rootEpic)=>(0, $F2Mxm.default)({
        appName: 'directories/filters-v2/delete-modal',
        rootReducer: $aXcJn.default,
        rootEpic: rootEpic
    });

});
parcelRegister("aXcJn", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3e77f8c76d4fb6d$export$2e2bcd8739ae039);

var $jemkP = parcelRequire("jemkP");
const $f3e77f8c76d4fb6d$export$49d5fc8cba920a0 = {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    appProps: undefined,
    boards: [],
    users: [],
    groups: [],
    isDataRetrieved: false,
    isDeleteInProgress: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f3e77f8c76d4fb6d$export$2e2bcd8739ae039 = (state = $f3e77f8c76d4fb6d$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $jemkP.SET_APP_PROPS:
            return {
                ...state,
                appProps: action.payload
            };
        case 0, $jemkP.DELETE_FILTER:
            return {
                ...state,
                isDeleteInProgress: true
            };
        case 0, $jemkP.FILTER_DELETED:
        case 0, $jemkP.DELETE_FILTER_FAILED:
            return {
                ...state,
                isDeleteInProgress: false
            };
        case 0, $jemkP.ASSOCIATED_ITEMS_RETRIEVED:
            {
                const { boards: boards, users: users, groups: groups } = action.payload;
                return {
                    ...state,
                    isDataRetrieved: true,
                    ...boards ? {
                        boards: boards
                    } : undefined,
                    ...users ? {
                        users: users
                    } : undefined,
                    ...groups ? {
                        groups: groups
                    } : undefined
                };
            }
        case 0, $jemkP.GET_ASSOCIATED_ITEMS_FAILED:
        case 0, $jemkP.GET_ASSOCIATED_ITEMS:
            return state;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});


parcelRegister("9ekJG", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffbff3d345f85465$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $iOraS = parcelRequire("iOraS");

var $5d0Op = parcelRequire("5d0Op");

var $6EW7m = parcelRequire("6EW7m");

var $7rRaV = parcelRequire("7rRaV");
const $ffbff3d345f85465$var$mapStateToProps = (state)=>({
        Content: $5d0Op.default,
        Footer: $6EW7m.default,
        name: (0, $iOraS.getFilterName)(state),
        onCancel: (0, $iOraS.getOnCancel)(state),
        isOpen: (0, $iOraS.isDataRetrieved)(state)
    });
var $ffbff3d345f85465$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($ffbff3d345f85465$var$mapStateToProps, {})((0, $7rRaV.default));

});
parcelRegister("5d0Op", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1dc72c582811a16$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $iOraS = parcelRequire("iOraS");

var $8SnWj = parcelRequire("8SnWj");
const $d1dc72c582811a16$var$mapStateToProps = (state)=>({
        filter: (0, $iOraS.getFilter)(state),
        boards: (0, $iOraS.getAssociatedBoards)(state),
        users: (0, $iOraS.getAssociatedUsers)(state),
        groups: (0, $iOraS.getAssociatedGroups)(state)
    });
var $d1dc72c582811a16$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($d1dc72c582811a16$var$mapStateToProps, {})((0, $8SnWj.default));

});
parcelRegister("8SnWj", function(module, exports) {

$parcel$export(module.exports, "default", () => $62e1c0ece3b30ec8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $e4yMr = parcelRequire("e4yMr");

var $koVbs = parcelRequire("koVbs");

var $cRRmC = parcelRequire("cRRmC");
const $62e1c0ece3b30ec8$var$ContentWithoutBoardsAndSubscriptions = ({ formatMessage: formatMessage })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $cRRmC.default).noSubscriptionsAndBoards));
const $62e1c0ece3b30ec8$var$ContentWithAssociatedSubscriptions = ({ formatMessage: formatMessage, groups: groups, users: users })=>users.length === 1 && groups.length === 0 || users.length === 0 && groups.length === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $cRRmC.default).singleSubscription), users.length === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
        href: users[0].href
    }, `${users[0].displayName}.`) : null, groups.length === 1 ? `${groups[0].name}.` : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $cRRmC.default).multipleBoardsWarning))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $cRRmC.default).multipleSubscriptions, {
        number: users.length + groups.length
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("ul", null, users.map(({ displayName: displayName, href: href }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
            href: href
        }, displayName))), groups.map(({ name: name }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
            key: index
        }, name))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $cRRmC.default).multipleSubscriptionsWarning)));
const $62e1c0ece3b30ec8$var$ContentWithAssociatedBoards = ({ boards: boards, formatMessage: formatMessage })=>boards.length === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $cRRmC.default).singleBoard), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
        href: boards[0].href
    }, `${boards[0].name}.`)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $cRRmC.default).multipleBoardsWarning))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $cRRmC.default).multipleBoards, {
        number: boards.length
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("ul", null, boards.map(({ name: name, href: href }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
            href: href
        }, name)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $cRRmC.default).multipleBoardsWarning)));
const $62e1c0ece3b30ec8$export$7c6e2c02157bb7d2 = ({ boards: boards, groups: groups, users: users })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (users.length === 0 && groups.length === 0 && boards.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($62e1c0ece3b30ec8$var$ContentWithoutBoardsAndSubscriptions, {
        formatMessage: formatMessage
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $cRRmC.default).associatedItems)), boards.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($62e1c0ece3b30ec8$var$ContentWithAssociatedBoards, {
        boards: boards,
        formatMessage: formatMessage
    }) : null, users.length > 0 || groups.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($62e1c0ece3b30ec8$var$ContentWithAssociatedSubscriptions, {
        users: users,
        groups: groups,
        formatMessage: formatMessage
    }) : null);
};
var $62e1c0ece3b30ec8$export$2e2bcd8739ae039 = $62e1c0ece3b30ec8$export$7c6e2c02157bb7d2;

});
parcelRegister("cRRmC", function(module, exports) {

$parcel$export(module.exports, "default", () => $3531ea37b151c3e0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3531ea37b151c3e0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noSubscriptionsAndBoards: {
        "id": "directories.filters-v2.delete-modal.content.no-subscriptions-and-boards",
        "defaultMessage": "Are you sure you want to delete this filter?"
    },
    associatedItems: {
        "id": "directories.filters-v2.delete-modal.content.associated-items",
        "defaultMessage": "This filter is used elsewhere. Deleting it may impact other people's work."
    },
    multipleSubscriptions: {
        "id": "directories.filters-v2.delete-modal.content.multiple-subscriptions",
        "defaultMessage": "This filter has currently {number} subscriptions:"
    },
    singleSubscription: {
        "id": "directories.filters-v2.delete-modal.content.single-subscription",
        "defaultMessage": "This filter has a subscription for "
    },
    multipleSubscriptionsWarning: {
        "id": "directories.filters-v2.delete-modal.content.multiple-subscriptions-warning",
        "defaultMessage": "Deleting this filter will cause subscription emails for these users and groups to no longer be delivered."
    },
    multipleBoards: {
        "id": "directories.filters-v2.delete-modal.content.multiple-boards",
        "defaultMessage": "This filter is currently being used by {number} boards:"
    },
    singleBoard: {
        "id": "directories.filters-v2.delete-modal.content.single-board",
        "defaultMessage": "This filter is currently being used by "
    },
    multipleBoardsWarning: {
        "id": "directories.filters-v2.delete-modal.content.multiple-boards-warning",
        "defaultMessage": "You'll need to remove this filters associations to the boards before it can be removed."
    }
});

});



parcelRegister("6EW7m", function(module, exports) {

$parcel$export(module.exports, "default", () => $310670aed312a399$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $iQv12 = parcelRequire("iQv12");

var $bC2fB = parcelRequire("bC2fB");

var $jemkP = parcelRequire("jemkP");

var $iOraS = parcelRequire("iOraS");

var $9pknF = parcelRequire("9pknF");
const $310670aed312a399$var$mapStateToProps = (state)=>({
        filter: (0, $iOraS.getFilter)(state),
        canDelete: (0, $iOraS.getCanDelete)(state),
        deleteInProgress: (0, $iOraS.isDeleteInProgress)(state),
        onCancel: (0, $iOraS.getOnCancel)(state)
    });
var $310670aed312a399$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $iQv12.default)({
    onDelete: 'filterDeleted',
    onCancel: 'filterDeleteCanceled'
}), (0, $bC2fB.connect)($310670aed312a399$var$mapStateToProps, {
    onDelete: (0, $jemkP.deleteFilter)
}))((0, $9pknF.default));

});
parcelRegister("basmW", function(module, exports) {

var $2cFTm = parcelRequire("2cFTm");
/**
 * Creates a function that returns the result of invoking the given functions
 * with the `this` binding of the created function, where each successive
 * invocation is supplied the return value of the previous.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flowRight
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flow([_.add, square]);
 * addSquare(1, 2);
 * // => 9
 */ var $8216a25e54656007$var$flow = $2cFTm();
module.exports = $8216a25e54656007$var$flow;

});
parcelRegister("2cFTm", function(module, exports) {

var $1WNhJ = parcelRequire("1WNhJ");

var $9SRAA = parcelRequire("9SRAA");

var $dzqxs = parcelRequire("dzqxs");

var $dJhFY = parcelRequire("dJhFY");

var $8LQ84 = parcelRequire("8LQ84");

var $2dCKt = parcelRequire("2dCKt");
/** Error message constants. */ var $19ad329dbed10597$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used to compose bitmasks for function metadata. */ var $19ad329dbed10597$var$WRAP_CURRY_FLAG = 8, $19ad329dbed10597$var$WRAP_PARTIAL_FLAG = 32, $19ad329dbed10597$var$WRAP_ARY_FLAG = 128, $19ad329dbed10597$var$WRAP_REARG_FLAG = 256;
/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */ function $19ad329dbed10597$var$createFlow(fromRight) {
    return $9SRAA(function(funcs) {
        var length = funcs.length, index = length, prereq = $1WNhJ.prototype.thru;
        if (fromRight) funcs.reverse();
        while(index--){
            var func = funcs[index];
            if (typeof func != 'function') throw new TypeError($19ad329dbed10597$var$FUNC_ERROR_TEXT);
            if (prereq && !wrapper && $dJhFY(func) == 'wrapper') var wrapper = new $1WNhJ([], true);
        }
        index = wrapper ? index : length;
        while(++index < length){
            func = funcs[index];
            var funcName = $dJhFY(func), data = funcName == 'wrapper' ? $dzqxs(func) : undefined;
            if (data && $2dCKt(data[0]) && data[1] == ($19ad329dbed10597$var$WRAP_ARY_FLAG | $19ad329dbed10597$var$WRAP_CURRY_FLAG | $19ad329dbed10597$var$WRAP_PARTIAL_FLAG | $19ad329dbed10597$var$WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[$dJhFY(data[0])].apply(wrapper, data[3]);
            else wrapper = func.length == 1 && $2dCKt(func) ? wrapper[funcName]() : wrapper.thru(func);
        }
        return function() {
            var args = arguments, value = args[0];
            if (wrapper && args.length == 1 && $8LQ84(value)) return wrapper.plant(value).value();
            var index = 0, result = length ? funcs[index].apply(this, args) : value;
            while(++index < length)result = funcs[index].call(this, result);
            return result;
        };
    });
}
module.exports = $19ad329dbed10597$var$createFlow;

});


parcelRegister("iQv12", function(module, exports) {

$parcel$export(module.exports, "default", () => $945500a9598c3ac2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gvRPW = parcelRequire("gvRPW");
/**
 * Adds analytics events to the given callbacks without altering the original behavior
 * Callback is expected to have analyticsEvent as a last argument
 * @example
 * ```tsx
 *  // will fire "select" event when onSelect is called
 *  fileWithUIAnalytics({ onSelect: 'select' })
 *
 *  // will fire "select" event with extra attributes
 *  fileWithUIAnalytics({ onSelect: (value) => ({ name: 'select', value: value}) }
 *  ```
 */ const $945500a9598c3ac2$var$fireWithUIAnalytics = (ConnectedProps)=>{
    // sort the keys so we can set the deps of useMemo
    const providedKeys = Object.keys(ConnectedProps).sort();
    /**
	 * We implement a custom caching mechanism rather than memoizeOne. We got
	 * more ops/sec this way and we only need to bust the changing props cache
	 * instead of destroying all references on a single prop change.
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedMappedProps = {}; /*    the actual prop value */ 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedConnectedProps = {}; /* the connected prop value (the callback) */ 
    const getStateFromMappedProps = (mapped)=>{
        providedKeys.forEach((key, index)=>{
            // firstly check the cache if the prop has changed before creating
            // any new connected props
            const prop = mapped[index];
            if (key in cachedMappedProps && cachedMappedProps[key] === prop) return;
            cachedMappedProps[key] = prop;
            // @ts-expect-error - TS7019 - Rest parameter 'attrs' implicitly has an 'any[]' type.
            cachedConnectedProps[key] = (...attrs)=>{
                // assume that analytics event is always the last one (it should be by convention)
                const analyticsEvent = attrs[attrs.length - 1].clone();
                const connectedProp = ConnectedProps[key];
                // example: { onSelect: 'select' }
                if (typeof ConnectedProps[key] === 'string') analyticsEvent.update({
                    name: connectedProp,
                    analyticsType: (0, $gvRPW.UI_EVENT_TYPE)
                }).fire();
                else if (typeof connectedProp === 'function') {
                    const update = connectedProp(...attrs);
                    analyticsEvent.update({
                        ...update,
                        analyticsType: (0, $gvRPW.UI_EVENT_TYPE)
                    }).fire();
                }
                if (typeof prop === 'function') prop(...attrs);
            };
        });
        return cachedConnectedProps;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (WrappedComponent)=>// eslint-disable-next-line jira/react/no-class-components, @typescript-eslint/no-explicit-any,@typescript-eslint/consistent-type-assertions
        class WithAnalytics extends (0, $5uXOq.Component) {
            static{
                // Note: This seems to render weirdly in the chrome debugger. May need to change the string formatting to work around it
                this.displayName = `WithAnalytics(${WrappedComponent.displayName || WrappedComponent.name || 'UnnamedComponent'}`;
            }
            render() {
                const newMappedProps = getStateFromMappedProps(providedKeys.map((key)=>this.props[key]));
                // @ts-expect-error TS2322: Type {} is not assignable to type
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    ...this.props,
                    ...newMappedProps
                });
            }
        }; // eslint-disable-line @typescript-eslint/no-explicit-any
};
var $945500a9598c3ac2$export$2e2bcd8739ae039 = $945500a9598c3ac2$var$fireWithUIAnalytics;

});

parcelRegister("9pknF", function(module, exports) {

$parcel$export(module.exports, "default", () => $8841fecfbc7d37be$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $ldJSL = parcelRequire("ldJSL");

var $juxqI = parcelRequire("juxqI");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $az4zD = parcelRequire("az4zD");

var $3HwlS = parcelRequire("3HwlS");

var $7hmi2 = parcelRequire("7hmi2");

var $7kS0u = parcelRequire("7kS0u");
const $8841fecfbc7d37be$var$Footer = ({ intl: { formatMessage: formatMessage }, canDelete: canDelete, deleteInProgress: deleteInProgress, onCancel: onCancel, onDelete: onDelete })=>{
    const { publish: publish } = (0, $7hmi2.useDeleteChangeActions)();
    const onDeleteWithEvent = (event, analyticsEvent)=>{
        // additional args aside from event & analyticsEvent that you wish to pass down needs to be passed as the first argument
        onDelete(publish, event, analyticsEvent);
    };
    const onDeleteOld = (event, analyticsEvent)=>{
        onDelete(undefined, event, analyticsEvent);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8841fecfbc7d37be$var$Container, null, deleteInProgress && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8841fecfbc7d37be$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "danger",
        type: "submit",
        isDisabled: !canDelete,
        onClick: (0, $3HwlS.getWillShowNav4)() ? onDeleteWithEvent : onDeleteOld
    }, formatMessage((0, $7kS0u.default).delete)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle-link",
        isDisabled: deleteInProgress,
        onClick: onCancel
    }, formatMessage((0, $7kS0u.default).cancelButtonCaption)))));
};
$8841fecfbc7d37be$var$Footer.defaultProps = {
    onDelete: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    deleteInProgress: false,
    canDelete: true
};
var $8841fecfbc7d37be$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $az4zD.injectIntlV2)($8841fecfbc7d37be$var$Footer);
const $8841fecfbc7d37be$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bahesu3 _4cvr1h6o _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $8841fecfbc7d37be$var$spinnerContainerStyles = (0, $8CUq3.xcss)({
    marginRight: 'space.200'
});

});
parcelRegister("az4zD", function(module, exports) {

$parcel$export(module.exports, "injectIntlV2", () => $90dc1bd887533804$export$440265f0ca78e98e);
/* eslint-disable @typescript-eslint/consistent-type-assertions */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $5uXOq = parcelRequire("5uXOq");

var $dY8Js = parcelRequire("dY8Js");

var $koVbs = parcelRequire("koVbs");
const $90dc1bd887533804$var$isDisplayableString = (mayBeString)=>typeof mayBeString === 'string' && mayBeString !== '';
function $90dc1bd887533804$var$getDisplayName(Component) {
    if ($90dc1bd887533804$var$isDisplayableString(Component.displayName)) // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    return Component.displayName;
    if ($90dc1bd887533804$var$isDisplayableString(Component.name)) return Component.name;
    return 'Component';
}
const $90dc1bd887533804$export$440265f0ca78e98e = (WrappedComponent, options)=>{
    const { withRef: withRef = false } = options || {};
    const WithIntl = (props)=>{
        const intl = (0, $koVbs.default)();
        const intlRef = (0, $5uXOq.useRef)(null);
        if (!intl) throw new Error('REACT_INTL_FACADE: React Intl Could not find required `intl` object');
        if (!intlRef.current) intlRef.current = {
            // @ts-expect-error We force v5 messages type on v2 type
            messages: intl.messages,
            locale: intl.locale,
            formats: intl.formats,
            formatDate: intl.formatDate,
            formatMessage: intl.formatMessage,
            formatNumber: intl.formatNumber,
            formatPlural: intl.formatPlural,
            formatTime: intl.formatTime
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            intl: intlRef.current,
            ref: withRef ? props.forwardedRef : null
        });
    };
    // Changed this display name to be capital letter to prevent snapshots from failing, here is the original: https://github.com/formatjs/formatjs/blob/main/packages/react-intl/src/components/injectIntl.tsx#L98
    WithIntl.displayName = `InjectIntl(${$90dc1bd887533804$var$getDisplayName(WrappedComponent)})`;
    WithIntl.WrappedComponent = WrappedComponent;
    if (withRef) return (0, (/*@__PURE__*/$parcel$interopDefault($dY8Js)))(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WithIntl, {
            ...props,
            forwardedRef: ref
        })), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($dY8Js)))(WithIntl, WrappedComponent);
};

});

parcelRegister("7kS0u", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc97edda63b98d49$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bc97edda63b98d49$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    delete: {
        "id": "directories.filters-v2.delete-modal.footer.delete",
        "defaultMessage": "Delete"
    },
    cancelButtonCaption: {
        "id": "directories.filters-v2.delete-modal.footer.cancel-button-caption",
        "defaultMessage": "Cancel"
    }
});

});



parcelRegister("7rRaV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3b1435469220d97$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7QSqG = parcelRequire("7QSqG");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");
var $i8Qvm = parcelRequire("i8Qvm");

var $hZHze = parcelRequire("hZHze");

var $9fuVs = parcelRequire("9fuVs");

var $az4zD = parcelRequire("az4zD");

var $1ppIJ = parcelRequire("1ppIJ");

var $liKYS = parcelRequire("liKYS");
const $d3b1435469220d97$var$DeleteModal = ({ intl: { formatMessage: formatMessage }, isOpen: isOpen, Content: Content, Footer: Footer, onCancel: onCancel, name: name })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1ppIJ.ModalDialog), {
        messageId: "delete-filters-modal.modal-dialog",
        messageType: "transactional",
        width: "small",
        onClose: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), {
        appearance: "danger"
    }, formatMessage((0, $liKYS.default).title, {
        name: name
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Content, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZHze.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Footer, {
        onClose: onCancel
    }))));
var $d3b1435469220d97$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($d3b1435469220d97$var$DeleteModal);

});
parcelRegister("hZHze", function(module, exports) {

$parcel$export(module.exports, "default", () => $69dc4a27be9f367e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $gvRPW = parcelRequire("gvRPW");
// eslint-disable-next-line jira/react/no-class-components
class $69dc4a27be9f367e$var$ViewTracker extends (0, $5uXOq.Component) {
    componentDidMount() {
        this.props.onMount();
    }
    render() {
        return null;
    }
}
const $69dc4a27be9f367e$var$ViewTrackerWithAnalytics = (0, $994MI.default)({
    componentName: 'view-tracker'
})((0, $cb25w.default)({
    onMount: (createEvent)=>createEvent({
            action: (0, $gvRPW.PAGE_EVENT_ACTION)
        }).fire()
})($69dc4a27be9f367e$var$ViewTracker));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$69dc4a27be9f367e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($69dc4a27be9f367e$var$ViewTrackerWithAnalytics, {
        onMount: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    });

});

parcelRegister("1ppIJ", function(module, exports) {

$parcel$export(module.exports, "ModalDialog", () => $8fbdebf88f199b98$export$1fa217be60c2f188);

var $5uXOq = parcelRequire("5uXOq");

var $7NYq5 = parcelRequire("7NYq5");

var $lu5k0 = parcelRequire("lu5k0");
const $8fbdebf88f199b98$export$1fa217be60c2f188 = ({ shouldReturnFocus: shouldReturnFocus, ...rest })=>{
    const returnFocusTarget = (0, $lu5k0.useReturnFocusTo)();
    const { setReturnFocusTo: setReturnFocusTo } = (0, $lu5k0.useModalDialogActions)();
    (0, $5uXOq.useEffect)(()=>()=>{
            if (returnFocusTarget?.current) {
                !shouldReturnFocus && returnFocusTarget.current.focus();
                setReturnFocusTo(null);
            }
        }, [
        returnFocusTarget,
        setReturnFocusTo,
        shouldReturnFocus
    ]);
    /**
	 *  when shouldReturnFocus is defined,
	 * 	we won't handle passing focus back to this element
	 *	we will ignore the returnFocusTarget
	 */ const returnFocus = shouldReturnFocus ?? !returnFocusTarget;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        shouldReturnFocus: returnFocus,
        ...rest,
        messageId: rest.messageId ?? 'software.modal-dialog.ui.ak-modal-dialog',
        messageType: rest.messageType ?? 'transactional'
    });
};

});
parcelRegister("lu5k0", function(module, exports) {

$parcel$export(module.exports, "useModalDialogActions", () => $5f429bdcb9dbbc95$export$3cf2e4b6d3541465);
$parcel$export(module.exports, "useReturnFocusTo", () => $5f429bdcb9dbbc95$export$217308a4ece853b2);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $49R2H = parcelRequire("49R2H");

var $a3Qjd = parcelRequire("a3Qjd");

var $kIxMH = parcelRequire("kIxMH");
const $5f429bdcb9dbbc95$var$Store = (0, $iXqE5.createStore)({
    name: 'JiraSoftwareModalDialog',
    initialState: $49R2H.initialState,
    actions: $a3Qjd.actions
});
const $5f429bdcb9dbbc95$export$3cf2e4b6d3541465 = (0, $3sQ5x.createActionsHook)($5f429bdcb9dbbc95$var$Store);
const $5f429bdcb9dbbc95$export$217308a4ece853b2 = (0, $3sQ5x.createStateHook)($5f429bdcb9dbbc95$var$Store, {
    selector: (0, $kIxMH.getReturnFocusTo)
});

});
parcelRegister("49R2H", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $1a3a816977643252$export$d4c72bab9d6cc13a);
const $1a3a816977643252$export$d4c72bab9d6cc13a = {
    returnFocusTo: null
};

});

parcelRegister("a3Qjd", function(module, exports) {

$parcel$export(module.exports, "actions", () => $1886bc9c17d47b9b$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $1886bc9c17d47b9b$export$b263d1e638b131c2 = (returnFocusTo)=>({ setState: setState })=>{
        setState({
            returnFocusTo: returnFocusTo
        });
    };
const $1886bc9c17d47b9b$export$e324594224ef24da = {
    setReturnFocusTo: $1886bc9c17d47b9b$export$b263d1e638b131c2
};

});

parcelRegister("kIxMH", function(module, exports) {

$parcel$export(module.exports, "getReturnFocusTo", () => $cd4eb273a1fc9e15$export$d5f8692765ccd209);
const $cd4eb273a1fc9e15$export$d5f8692765ccd209 = (state)=>state.returnFocusTo;

});



parcelRegister("liKYS", function(module, exports) {

$parcel$export(module.exports, "default", () => $33404efbe1d974cc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $33404efbe1d974cc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "directories.filters-v2.delete-modal.title",
        "defaultMessage": "Delete {name}"
    }
});

});




parcelRegister("ddrvO", function(module, exports) {

$parcel$export(module.exports, "default", () => $d826b76ed7b00be0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d826b76ed7b00be0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    filterDeletedModalTitleSuccessNonFinal: {
        "id": "navigation-apps-sidebar-nav4-filters.common.filter-actions.delete-filter-modal.filter-deleted-modal-title-success-non-final",
        "defaultMessage": "{name} was deleted"
    },
    filterDeletedModalTitleErrorNonFinal: {
        "id": "navigation-apps-sidebar-nav4-filters.common.filter-actions.delete-filter-modal.filter-deleted-modal-title-error-non-final",
        "defaultMessage": "We couldn't delete filter"
    },
    filterDeletedModalDescriptionErrorNonFinal: {
        "id": "navigation-apps-sidebar-nav4-filters.common.filter-actions.delete-filter-modal.filter-deleted-modal-description-error-non-final",
        "defaultMessage": "There was an error, please try again."
    }
});

});


parcelRegister("199zy", function(module, exports) {

$parcel$export(module.exports, "default", () => $d773a1ee239d0f58$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d773a1ee239d0f58$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    manageSubscription: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.manage-subscription",
        "defaultMessage": "Manage subscriptions"
    },
    copyFilter: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.copy-filter",
        "defaultMessage": "Copy filter"
    },
    copyFilterDialogTitle: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.copy-filter-dialog-title",
        "defaultMessage": "Copy filter"
    },
    edit: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.edit",
        "defaultMessage": "Edit filter"
    },
    changeOwner: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.change-owner",
        "defaultMessage": "Change owner"
    },
    delete: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.delete",
        "defaultMessage": "Delete filter"
    },
    manageSubscriptionWithName: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.manage-subscription-with-name",
        "defaultMessage": "Manage subscriptions for {name}"
    },
    copyFilterWithName: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.copy-filter-with-name",
        "defaultMessage": "Copy filter {name}"
    },
    editWithName: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.edit-with-name",
        "defaultMessage": "Edit filter {name}"
    },
    changeOwnerWithName: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.change-owner-with-name",
        "defaultMessage": "Change owner for {name}"
    },
    deleteWithName: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.delete-with-name",
        "defaultMessage": "Delete filter {name}"
    }
});

});

parcelRegister("eKG0o", function(module, exports) {

$parcel$export(module.exports, "useModalState", () => $d7462e2c0d74d90a$export$baa48889c42cc6cb);

var $5uXOq = parcelRequire("5uXOq");
const $d7462e2c0d74d90a$export$baa48889c42cc6cb = (defaultOpen = false)=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultOpen);
    const onClose = (0, $5uXOq.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    const onOpen = (0, $5uXOq.useCallback)(()=>setIsOpen(true), [
        setIsOpen
    ]);
    return {
        isOpen: isOpen,
        onClose: onClose,
        onOpen: onOpen
    };
};

});


parcelRegister("MaZbq", function(module, exports) {

$parcel$export(module.exports, "SimpleFilterMenuItem", () => $43f8c4d99214e245$export$608d42ceb4060968);

var $5uXOq = parcelRequire("5uXOq");

var $jX361 = parcelRequire("jX361");

var $4zlUA = parcelRequire("4zlUA");

var $jhS4y = parcelRequire("jhS4y");

var $5FnJJ = parcelRequire("5FnJJ");
function $43f8c4d99214e245$export$608d42ceb4060968({ actionsOnHover: actionsOnHover, filterId: filterId, name: name, onClick: onClick }) {
    const handlOnClick = (0, $5uXOq.useCallback)((e)=>{
        onClick?.();
        (0, $4zlUA.handleGinSPAClick)(e);
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        actionsOnHover: actionsOnHover,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jX361))), {
            label: "",
            color: "currentColor"
        }),
        href: `/issues/?filter=${filterId}`,
        menuId: (0, $jhS4y.ENTITY_ID).FILTER(filterId),
        onClick: handlOnClick
    }, name);
}

});
parcelRegister("4zlUA", function(module, exports) {

$parcel$export(module.exports, "handleGinSPAClick", () => $7b30a009e09f47e3$export$f74673b086629362);
const $7b30a009e09f47e3$export$f74673b086629362 = (e)=>{
    const href = // @ts-expect-error - TS2339 - Property 'href' does not exist on type 'EventTarget | (EventTarget & HTMLAnchorElement)'. | TS2339 - Property 'href' does not exist on type 'EventTarget | (EventTarget & HTMLAnchorElement)'.
    typeof e.currentTarget.href === 'string' ? e.currentTarget.href : undefined;
    const openInNewTab = // @ts-expect-error - TS2339 - Property 'button' does not exist on type 'KeyboardEvent<HTMLAnchorElement> | MouseEvent<HTMLAnchorElement, MouseEvent> | MouseEvent<EventTarget, MouseEvent> | KeyboardEvent<...>'. | TS2339 - Property 'button' does not exist on type 'KeyboardEvent<HTMLAnchorElement> | MouseEvent<HTMLAnchorElement, MouseEvent> | MouseEvent<EventTarget, MouseEvent> | KeyboardEvent<...>'.
    e.metaKey || e.altKey || e.ctrlKey || e.shiftKey || e.button != null && e.button === 1;
    if (href == null || href === '' || e.defaultPrevented || openInNewTab) return;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.JIRA?.Issues?.Application) {
        e.preventDefault();
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.JIRA.Issues.Application.execute('navigation:navigateToUrl', href, {
            forceRefresh: true,
            checkPermission: true,
            replace: false,
            reset: true,
            routerEvent: true
        });
    }
};

});



parcelRegister("jjTbl", function(module, exports) {

$parcel$export(module.exports, "default", () => $0092439b070ce89c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0092439b070ce89c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    recent: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.content.recent",
        "defaultMessage": "Recent"
    },
    starred: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.content.starred",
        "defaultMessage": "Starred"
    },
    viewAllStarred: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.content.view-all-starred",
        "defaultMessage": "View all starred items"
    },
    defaultFilters: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.content.default-filters",
        "defaultMessage": "Default filters"
    }
});

});


const $095930ee3b140077$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Filters';
const $095930ee3b140077$export$d57b6b390e78d90f = 'empanada';

parcelRegister("eYeHi", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $36b3581ba956a97e$export$a06f1c675e846f6f);

var $5uXOq = parcelRequire("5uXOq");

var $gSZmd = parcelRequire("gSZmd");
var $1qQhw = parcelRequire("1qQhw");
var $1FdfO = parcelRequire("1FdfO");

var $koVbs = parcelRequire("koVbs");




var $jhS4y = parcelRequire("jhS4y");

var $34PKs = parcelRequire("34PKs");

var $b6S3k = parcelRequire("b6S3k");

var $qBWno = parcelRequire("qBWno");

var $8sLEz = parcelRequire("8sLEz");
const $36b3581ba956a97e$var$VIEW_ALL_FILTERS_PATH = (0, $b6S3k.filtersDirectoryRoute).path;
function $36b3581ba956a97e$export$a06f1c675e846f6f() {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const sendFilterAnalytics = (0, $qBWno.useFilterActionsAnalytics)();
    const sendDefaultFilterDropdownAnalytics = (0, $5uXOq.useCallback)(()=>{
        sendFilterAnalytics((0, $ce8062101363feb9$export$6dd9406e478a1fe2), {
            level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
            componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
            itemId: 'viewAllFilters'
        });
    }, [
        sendFilterAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1qQhw.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1FdfO.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gSZmd.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $34PKs.ViewAllEntityMenuItem), {
        onClick: sendDefaultFilterDropdownAnalytics,
        href: $36b3581ba956a97e$var$VIEW_ALL_FILTERS_PATH,
        menuId: (0, $jhS4y.MENU_ID_FILTERS_VIEW_ALL)
    }, formatMessage((0, $8sLEz.default).viewAllFilters)))));
}

});
parcelRegister("b6S3k", function(module, exports) {

$parcel$export(module.exports, "filtersDirectoryRoute", () => $45a85df0dbaf23d9$export$6350f52c8b40042d);
const $45a85df0dbaf23d9$export$6350f52c8b40042d = {
    name: 'filters-directory',
    path: '/jira/filters'
};

});

parcelRegister("8sLEz", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6fd2ed1497d7321$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b6fd2ed1497d7321$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    viewAllFilters: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.footer.view-all-filters",
        "defaultMessage": "View all filters"
    }
});

});


parcelRegister("3XHNc", function(module, exports) {

$parcel$export(module.exports, "Header", () => $7b1d5262779046c2$export$8b251419efc915eb);

var $5uXOq = parcelRequire("5uXOq");

var $hyOJh = parcelRequire("hyOJh");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");




var $jhS4y = parcelRequire("jhS4y");

var $5FnJJ = parcelRequire("5FnJJ");

var $qBWno = parcelRequire("qBWno");

var $bqhl5 = parcelRequire("bqhl5");
const $7b1d5262779046c2$export$8b251419efc915eb = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const sendFilterAnalytics = (0, $qBWno.useFilterActionsAnalytics)();
    const handleOnClick = (0, $5uXOq.useCallback)((event)=>{
        sendFilterAnalytics((0, $ce8062101363feb9$export$6dd9406e478a1fe2), {
            level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
            componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
            itemId: 'searchAllIssues'
        });
        onClose?.(event);
    }, [
        onClose,
        sendFilterAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        href: "/issues/?jql=created%20%3E%3D%20-30d%20order%20by%20created%20DESC",
        onClick: handleOnClick,
        menuId: (0, $jhS4y.MENU_ID_FILTERS_SEARCH),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hyOJh))), {
            label: "",
            color: "currentColor"
        })
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $bqhl5.default).searchAllIssuesIssueTermRefresh : (0, $bqhl5.default).searchAllIssues));
};

});
parcelRegister("bqhl5", function(module, exports) {

$parcel$export(module.exports, "default", () => $2997cabf9dd4d5cf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2997cabf9dd4d5cf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    searchAllIssues: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.header.search-all-issues",
        "defaultMessage": "Search issues"
    },
    searchAllIssuesIssueTermRefresh: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.header.search-all-issues-issue-term-refresh",
        "defaultMessage": "Search work items"
    }
});

});



parcelRegister("iaOwN", function(module, exports) {

$parcel$export(module.exports, "ActionButtons", () => $0188d5ec8b84466a$export$88c65d2d98aab183);

var $5uXOq = parcelRequire("5uXOq");

var $eZUJu = parcelRequire("eZUJu");





var $46Cti = parcelRequire("46Cti");

var $eaKdt = parcelRequire("eaKdt");

var $aCS3f = parcelRequire("aCS3f");

var $LmW5e = parcelRequire("LmW5e");

var $4R6GH = parcelRequire("4R6GH");

var $qBWno = parcelRequire("qBWno");
const $0188d5ec8b84466a$export$88c65d2d98aab183 = (0, $LmW5e.memoWithCondition)(()=>(0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1'), ({ onClose: onClose })=>{
    const sendFilterAnalytics = (0, $qBWno.useFilterActionsAnalytics)();
    const sendMeatballAnalytics = (0, $5uXOq.useCallback)(()=>{
        sendFilterAnalytics((0, $ce8062101363feb9$export$b887e88d8d0739f6), {
            level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
            componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
            itemId: (0, $496585bee7985bb9$export$f06dfcec5ff912e)
        });
    }, [
        sendFilterAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCS3f.MoreNavMenuButton), {
        onOpen: sendMeatballAnalytics,
        MenuItems: $0188d5ec8b84466a$var$MoreMenuItems,
        onClose: onClose
    });
});
function $0188d5ec8b84466a$var$MoreMenuItems(_) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaKdt.HideL1MenuItemSection), {
        menuId: (0, $46Cti.L1_MENU_ID).FILTERS,
        hasSeparator: false
    }));
}

});

parcelRegister("6jcf1", function(module, exports) {

$parcel$export(module.exports, "Nav4FiltersDefault", () => $58a856783fb255e5$export$c9a2a24425c3fa5e);

var $5uXOq = parcelRequire("5uXOq");

var $lnznH = parcelRequire("lnznH");
var $cZa9B = parcelRequire("cZa9B");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $jecJ3 = parcelRequire("jecJ3");

var $jhS4y = parcelRequire("jhS4y");

var $aGONy = parcelRequire("aGONy");

var $46Cti = parcelRequire("46Cti");

var $c16H2 = parcelRequire("c16H2");

var $338xa = parcelRequire("338xa");

var $dQbFB = parcelRequire("dQbFB");

var $eQV8d = parcelRequire("eQV8d");

var $dUyqZ = parcelRequire("dUyqZ");

var $4zcxJ = parcelRequire("4zcxJ");

var $koeKL = parcelRequire("koeKL");

var $4R6GH = parcelRequire("4R6GH");


var $eYeHi = parcelRequire("eYeHi");

var $3XHNc = parcelRequire("3XHNc");

var $bq9gb = parcelRequire("bq9gb");
function $58a856783fb255e5$export$c9a2a24425c3fa5e(props) {
    const { actionsOnHover: actionsOnHover, isExpanded: isExpanded, simulateLoading: simulateLoading = false } = props;
    const cloudId = (0, $koeKL.useCloudId)();
    const currentURL = (0, $aGONy.useGetCurrentUrl)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            currentURL: currentURL
        }), [
        cloudId,
        currentURL
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $bq9gb.asyncFiltersContentViewQuery), entryPointParams);
    const triggerRef = (0, $4zcxJ.useExpandableEntryPointTrigger)(entryPointActions);
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).FILTERS);
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    // If starting life expanded, make sure to load.
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (isExpanded) entryPointActions.load();
    }, [
        entryPointActions,
        isExpanded
    ]);
    const menuId = (0, $jhS4y.MENU_ID_FILTERS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onSystemToggle: (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $5uXOq.useCallback)((hasExpanded)=>{
            if (hasExpanded) entryPointActions.load();
        }, [
            entryPointActions
        ]) : (hasExpanded)=>{
            if (hasExpanded) entryPointActions.load();
        },
        onExpansionToggle: (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $5uXOq.useCallback)((hasExpanded)=>{
            if (hasExpanded) {
                entryPointActions.load();
                sendSectionItemAnalyticsEvent({
                    menuId: (0, $46Cti.L1_MENU_ID).FILTERS,
                    sectionItem: (0, $jecJ3.SECTION_ITEM_FILTERS)
                });
            }
        }, [
            entryPointActions,
            sendSectionItemAnalyticsEvent
        ]) : (hasExpanded)=>{
            if (hasExpanded) {
                entryPointActions.load();
                sendSectionItemAnalyticsEvent({
                    menuId: (0, $46Cti.L1_MENU_ID).FILTERS,
                    sectionItem: (0, $jecJ3.SECTION_ITEM_FILTERS)
                });
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZa9B.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-filters-default",
        actionsOnHover: actionsOnHover,
        // Prevent double-up of accessible name that occurs in icon+text situation.
        "aria-label": formattedMessage,
        elemBefore: icon,
        ref: triggerRef,
        testId: (0, $dQbFB.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnznH.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3XHNc.Header), null), simulateLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        // Data stream, will subscribe to load updates.
        entryPointReferenceSubject: entryPointReferenceSubject,
        // Required props for error JSErrorBoundary.
        id: "nav4-sidebar-filters-default",
        packageName: (0, $095930ee3b140077$export$b8b9d90f9e5bd72b),
        // Optional props for error JSErrorBoundary.
        errorFallback: "flag",
        teamName: (0, $095930ee3b140077$export$d57b6b390e78d90f),
        // Fallback for `Suspense`.
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), null),
        // Props for the root component.
        runtimeProps: entryPointParams
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eYeHi.Footer), null)));
}

});
parcelRegister("bq9gb", function(module, exports) {

$parcel$export(module.exports, "asyncFiltersContentViewQuery", () => $54738359b90672c7$export$fae48e64221e5e6e);

var $h5aHz = parcelRequire("h5aHz");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $54738359b90672c7$export$fae48e64221e5e6e = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("cygvE")).then(({ Nav4FiltersContentViewQuery: Nav4FiltersContentViewQuery })=>Nav4FiltersContentViewQuery), {
        moduleId: "efb9eb25",
        moduleName: "Nav4FiltersContentViewQuery",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                filters: {
                    parameters: $h5aHz.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("h5aHz", function(module, exports) {

$parcel$export(module.exports, "default", () => $e23e452905350c49$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5b09b73015f6d4eda410be086a0ec06e>>
 * @relayHash c3bc46f986acdf13f968e5919fcd2d52
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3c97505ceda772c1ff0a6ccf4c08e12237f9f7d57f5f99db7c9b61da8af86b7e
const $e23e452905350c49$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v7 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                    v2 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v5 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCustomFilter"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            v5 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v10 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "Nav4FiltersContentViewQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4FiltersContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "Nav4FiltersContentViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "favouriteFilters",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "sort": {
                                            "order": "DESC"
                                        },
                                        "type": "FILTER"
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 15
                                }
                            ],
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ],
                                                    "type": "JiraFilter",
                                                    "abstractKey": "__isJiraFilter"
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v10 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "recentFilters",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 20
                                },
                                {
                                    "kind": "Literal",
                                    "name": "types",
                                    "value": [
                                        "FILTER"
                                    ]
                                }
                            ],
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v8 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        }
                                                    ],
                                                    "type": "JiraCustomFilter"
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v10 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                v1 /*: any*/ 
                            ],
                            "concreteType": "JiraSystemFilterConnection",
                            "kind": "LinkedField",
                            "name": "systemFilters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSystemFilterEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSystemFilter",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ],
                                                    "type": "JiraFilter",
                                                    "abstractKey": "__isJiraFilter"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3c97505ceda772c1ff0a6ccf4c08e12237f9f7d57f5f99db7c9b61da8af86b7e",
            "metadata": {},
            "name": "Nav4FiltersContentViewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e23e452905350c49$var$node.hash = "9218fd54b0172bf14bf1082dd5032107";
var $e23e452905350c49$export$2e2bcd8739ae039 = $e23e452905350c49$var$node;

});

parcelRegister("cygvE", function(module, exports) {

let $92357778e7c8ed2f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $92357778e7c8ed2f$var$load("1NqnQ").then(()=>parcelRequire('7EWLy'));

});





parcelRegister("VyuC0", function(module, exports) {

$parcel$export(module.exports, "Nav4Operations", () => $7b6a2654543e51de$export$bc4d01c843cee95e);

var $e2y3Y = parcelRequire("e2y3Y");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jhS4y = parcelRequire("jhS4y");

var $c6x3L = parcelRequire("c6x3L");

var $4R6GH = parcelRequire("4R6GH");

var $37Ssu = parcelRequire("37Ssu");

var $2CMcE = parcelRequire("2CMcE");

var $8BItO = parcelRequire("8BItO");
const $7b6a2654543e51de$export$bc4d01c843cee95e = ({ isExpanded: isExpanded, queryRef: queryRef })=>{
    const data = (0, $8Uumt.useFragment)((0, $e2y3Y.default), queryRef);
    const { isInitialSelectedPath: isInitialSelectedPath } = (0, $c6x3L.useSidebarNav4)();
    const contents = isInitialSelectedPath((0, $jhS4y.MENU_ID_OPERATIONS)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2CMcE.OperationsMenuForLanding), {
        isExpanded: isExpanded,
        queryRef: data
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $37Ssu.OperationsMenuDefault), {
        isExpanded: isExpanded
    });
    if ((0, $4R6GH.fg)('operations_nav4_remaining_items')) /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8BItO.AlertsPopoutStoreContainer), {
        isGlobal: true
    }, contents);
    return contents;
};

});
parcelRegister("e2y3Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $8997765d9fbf503d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3902b07ebd67a0b3cbf092c1d6ea3a35>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8997765d9fbf503d$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isOperationsExpanded"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4Operations",
    "selections": [
        {
            "condition": "isOperationsExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "OperationsMenuForLanding"
                }
            ]
        }
    ],
    "type": "Query"
};
$8997765d9fbf503d$var$node.hash = "1d297012078c362907ac313c8068c25a";
var $8997765d9fbf503d$export$2e2bcd8739ae039 = $8997765d9fbf503d$var$node;

});

parcelRegister("37Ssu", function(module, exports) {

$parcel$export(module.exports, "OperationsMenuDefault", () => $82831b0d881f1209$export$ef19d9521d85a60a);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $338xa = parcelRequire("338xa");

var $4zcxJ = parcelRequire("4zcxJ");

var $koeKL = parcelRequire("koeKL");

var $4R6GH = parcelRequire("4R6GH");

var $83AHd = parcelRequire("83AHd");

var $gzxPn = parcelRequire("gzxPn");

var $8BItO = parcelRequire("8BItO");
function $82831b0d881f1209$export$ef19d9521d85a60a(props) {
    const { isExpanded: isExpanded } = props;
    const cloudId = (0, $koeKL.useCloudId)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId
        }), [
        cloudId
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $83AHd.asyncAlertsContentViewQuery), entryPointParams);
    const triggerRef = (0, $4zcxJ.useExpandableEntryPointTrigger)(entryPointActions);
    const { state: { isPoppedOut: isPoppedOut, lastVisitedSearch: lastVisitedSearch }, setContent: setContent } = (0, $8BItO.useAlertsPopoutStore)();
    // If starting life expanded, make sure to load.
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (isExpanded) entryPointActions.load();
    }, [
        entryPointActions,
        isExpanded
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (lastVisitedSearch && (0, $4R6GH.fg)('operations_nav4_remaining_items')) setContent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            // Data stream, will subscribe to load updates.
            entryPointReferenceSubject: entryPointReferenceSubject,
            // Required props for error JSErrorBoundary.
            id: "operations-menu-default",
            packageName: "jiraNavigationAppsSidebarNav4Operations",
            // Optional props for error JSErrorBoundary.
            errorFallback: "flag",
            teamName: "platform-united",
            // Fallback for `Suspense`.
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), null),
            // Props for the root component.
            runtimeProps: {
                ...entryPointParams,
                location: 'popOutPanel'
            }
        }));
    }, [
        entryPointParams,
        entryPointReferenceSubject,
        isPoppedOut,
        lastVisitedSearch,
        setContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gzxPn.OperationsExpandableMenuItem), {
        isExpanded: props.isExpanded,
        onSystemToggle: (hasExpanded)=>{
            if (hasExpanded) entryPointActions.load();
        },
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) entryPointActions.load();
        },
        triggerRef: triggerRef,
        AlertsMenuItemContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            // Data stream, will subscribe to load updates.
            entryPointReferenceSubject: entryPointReferenceSubject,
            // Required props for error JSErrorBoundary.
            id: "operations-menu-default",
            packageName: "jiraNavigationAppsSidebarNav4Operations",
            // Optional props for error JSErrorBoundary.
            errorFallback: "flag",
            teamName: "platform-united",
            // Fallback for `Suspense`.
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), null),
            // Props for the root component.
            runtimeProps: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
                ...entryPointParams,
                location: 'sidenav'
            } : entryPointParams
        })
    });
}

});
parcelRegister("83AHd", function(module, exports) {

$parcel$export(module.exports, "asyncAlertsContentViewQuery", () => $f6fac0db87404723$export$182f7de76119e38a);

var $8myYV = parcelRequire("8myYV");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $f6fac0db87404723$export$182f7de76119e38a = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("1KC4L")).then(({ AlertsContentViewQuery: AlertsContentViewQuery })=>AlertsContentViewQuery), {
        moduleId: "4fcb17ab",
        moduleName: "AlertsContentViewQuery",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                queryRef: {
                    parameters: $8myYV.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("8myYV", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ef6ab9035056fc1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d8f87fd6efcb3b2793833812a581fd4f>>
 * @relayHash 539d81342bcb3bdab170556f3882c1e6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1354395b89d1b40a39f597c3f378eb87813ab2626873be265cad98b57286915d
const $4ef6ab9035056fc1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "alertSearchQuery"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AlertsContentViewQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "AlertsMenuItemContentNew"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "AlertsMenuItemContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AlertsContentViewQuery",
            "selections": [
                {
                    "concreteType": "OpsgenieQuery",
                    "kind": "LinkedField",
                    "name": "opsgenie",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                }
                            ],
                            "concreteType": "OpsgenieSavedSearches",
                            "kind": "LinkedField",
                            "name": "savedSearches",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "OpsgenieSavedSearch",
                                    "kind": "LinkedField",
                                    "name": "sharedWithMe",
                                    "plural": true,
                                    "selections": v1 /*: any*/ 
                                },
                                {
                                    "concreteType": "OpsgenieSavedSearch",
                                    "kind": "LinkedField",
                                    "name": "createdByMe",
                                    "plural": true,
                                    "selections": v1 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1354395b89d1b40a39f597c3f378eb87813ab2626873be265cad98b57286915d",
            "metadata": {},
            "name": "AlertsContentViewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4ef6ab9035056fc1$var$node.hash = "879968e67a244943ed377d7fb5da054d";
var $4ef6ab9035056fc1$export$2e2bcd8739ae039 = $4ef6ab9035056fc1$var$node;

});

parcelRegister("1KC4L", function(module, exports) {

let $14679f5f33101029$var$load = (parcelRequire("28QjX"))(4);
module.exports = $14679f5f33101029$var$load("bkvGp").then(()=>parcelRequire('7GeK2'));

});


parcelRegister("gzxPn", function(module, exports) {

$parcel$export(module.exports, "OperationsExpandableMenuItem", () => $13a888bc5715405b$export$a04d9e9cc5ec19d3);

var $5uXOq = parcelRequire("5uXOq");

var $boIsJ = parcelRequire("boIsJ");

var $6L0PY = parcelRequire("6L0PY");

var $fDskX = parcelRequire("fDskX");

var $gitmU = parcelRequire("gitmU");

var $lnznH = parcelRequire("lnznH");
var $cZa9B = parcelRequire("cZa9B");




var $jecJ3 = parcelRequire("jecJ3");

var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $46Cti = parcelRequire("46Cti");

var $c16H2 = parcelRequire("c16H2");

var $5FnJJ = parcelRequire("5FnJJ");

var $dQbFB = parcelRequire("dQbFB");

var $24a2m = parcelRequire("24a2m");

var $eQV8d = parcelRequire("eQV8d");

var $dUyqZ = parcelRequire("dUyqZ");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $lODMY = parcelRequire("lODMY");

var $4R6GH = parcelRequire("4R6GH");

var $lUaB2 = parcelRequire("lUaB2");

var $fnZCh = parcelRequire("fnZCh");

var $9MLkJ = parcelRequire("9MLkJ");

var $7Qdrb = parcelRequire("7Qdrb");

var $7zFZv = parcelRequire("7zFZv");

var $87kQ4 = parcelRequire("87kQ4");

var $8BItO = parcelRequire("8BItO");
function $13a888bc5715405b$export$a04d9e9cc5ec19d3(props) {
    const isAlertsRoute = (0, $lODMY.useIsActiveRoute)(new Set([
        (0, $lUaB2.eocGlobalAlertListRoute).name,
        (0, $fnZCh.eocTeamAlertDetailRoute).name
    ]));
    const { AlertsMenuItemContent: AlertsMenuItemContent, isExpanded: isExpanded, onExpansionToggle: onExpansionToggle, onSystemToggle: onSystemToggle, triggerRef: triggerRef } = props;
    const { hasReports: hasReports } = (0, $7Qdrb.useFeatures)();
    const { icon: alertsIcon, formattedMessage: alertsMessage } = (0, $24a2m.useFormattedMessageAndIcon)((0, $9MLkJ.default).alerts, (0, (/*@__PURE__*/$parcel$interopDefault($boIsJ))));
    const { icon: overviewIcon, formattedMessage: overviewMessage } = (0, $24a2m.useFormattedMessageAndIcon)((0, $7zFZv.default).overview, (0, (/*@__PURE__*/$parcel$interopDefault($6L0PY))));
    const { icon: oncallSchedulesIcon, formattedMessage: oncallSchedulesMessage } = (0, $24a2m.useFormattedMessageAndIcon)((0, $7zFZv.default).onCallSchedules, (0, (/*@__PURE__*/$parcel$interopDefault($gitmU))));
    const { icon: reportsIcon, formattedMessage: reportsMessage } = (0, $24a2m.useFormattedMessageAndIcon)((0, $7zFZv.default).reports, (0, (/*@__PURE__*/$parcel$interopDefault($fDskX))));
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).OPERATIONS);
    const { state: { lastVisitedSearch: lastVisitedSearch }, setIsPoppedOut: setIsPoppedOut, syncLastVisitedSearch: syncLastVisitedSearch } = (0, $8BItO.useAlertsPopoutStore)();
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $4R6GH.fg)('operations_nav4_remaining_items')) syncLastVisitedSearch();
    }, [
        syncLastVisitedSearch
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const menuId = (0, $jhS4y.MENU_ID_OPERATIONS);
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $4R6GH.fg)('operations_nav4_remaining_items_local_storage')) {
            if (!isAlertsRoute) setIsPoppedOut(false);
            return ()=>{
                setIsPoppedOut(false);
            };
        }
    }, [
        isAlertsRoute,
        setIsPoppedOut
    ]);
    const alertsChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, lastVisitedSearch && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $87kQ4.PopoutToggleButton), null),
        elemBefore: alertsIcon,
        href: lastVisitedSearch,
        menuId: (0, $jhS4y.MENU_ID_OPS_OVERVIEW)
    }, alertsMessage) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZa9B.ExpandableMenuItemTrigger), {
        interactionName: (0, $4R6GH.fg)('blu-7837_apply_presstrace_nav4') ? 'nav4-sidebar-operations-alerts' : undefined,
        actions: isAlertsRoute && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $87kQ4.PopoutToggleButton), null) : undefined,
        onClick: (_e, _a, { isExpanded: hasExpanded })=>{
            if (hasExpanded) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                    level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                    itemId: 'alerts'
                }
            });
        },
        elemBefore: alertsIcon,
        testId: (0, $dQbFB.getTestId)((0, $jhS4y.MENU_ID_OPS_ALERTS))
    }, alertsMessage), !(lastVisitedSearch && (0, $4R6GH.fg)('operations_nav4_remaining_items')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnznH.ExpandableMenuItemContent), null, AlertsMenuItemContent));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $46Cti.L1_MENU_ID).OPERATIONS,
                sectionItem: (0, $jecJ3.SECTION_ITEM_OPERATIONS)
            });
            onExpansionToggle?.(hasExpanded);
        },
        onSystemToggle: onSystemToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZa9B.ExpandableMenuItemTrigger), {
        interactionName: (0, $4R6GH.fg)('blu-7837_apply_presstrace_nav4') ? 'nav4-sidebar-operations' : undefined,
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $87kQ4.ActionButtons), null),
        elemBefore: icon,
        ref: triggerRef,
        testId: (0, $dQbFB.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnznH.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        elemBefore: overviewIcon,
        href: "/jira/ops/overview",
        menuId: (0, $jhS4y.MENU_ID_OPS_OVERVIEW),
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                    level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                    itemId: 'overview'
                }
            });
        }
    }, overviewMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        menuId: (0, $jhS4y.MENU_ID_OPS_ALERTS)
    }, alertsChildren), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        elemBefore: oncallSchedulesIcon,
        href: "/jira/ops/who-is-on-call",
        menuId: (0, $jhS4y.MENU_ID_OPS_ON_CALL),
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                    level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                    itemId: 'onCallSchedules'
                }
            });
        }
    }, oncallSchedulesMessage), hasReports && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        elemBefore: reportsIcon,
        href: "/jira/ops/reports",
        menuId: (0, $jhS4y.MENU_ID_OPS_REPORTS),
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                    level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                    itemId: 'reports'
                }
            });
        }
    }, reportsMessage)));
}

});
parcelRegister("boIsJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::76f067d08aa7c324d1505318ade2e26f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0224334e234c3d66$var$_react = $0224334e234c3d66$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0224334e234c3d66$var$_baseNew = $0224334e234c3d66$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $0224334e234c3d66$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Alert".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for alerts in JSM and Compass.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0224334e234c3d66$var$AlertIcon = (props)=>/*#__PURE__*/ $0224334e234c3d66$var$_react.default.createElement($0224334e234c3d66$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 0v3h-1.5V0zM2.123 1.063 4.172 3.11 3.11 4.17 1.063 2.124zm12.814 1.06L12.89 4.172 11.83 3.11l2.047-2.048zM4.195 5.875A1.5 1.5 0 0 1 5.69 4.5h4.62a1.5 1.5 0 0 1 1.495 1.375l.635 7.625H14V15H2v-1.5h1.56zm.87 7.625h5.87L10.31 6H5.69z" clip-rule="evenodd"/>`
    }, props));
$0224334e234c3d66$var$AlertIcon.displayName = 'AlertIcon';
var $0224334e234c3d66$var$_default = module.exports.default = $0224334e234c3d66$var$AlertIcon;

});

parcelRegister("gitmU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b34e6857b52d4ec156a688609aa0810c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bdd51bc1f2f099ea$var$_react = $bdd51bc1f2f099ea$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $bdd51bc1f2f099ea$var$_baseNew = $bdd51bc1f2f099ea$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $bdd51bc1f2f099ea$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Phone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: call us, phone number input.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bdd51bc1f2f099ea$var$PhoneIcon = (props)=>/*#__PURE__*/ $bdd51bc1f2f099ea$var$_react.default.createElement($bdd51bc1f2f099ea$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1.75A.75.75 0 0 1 1.75 1h3.5a.75.75 0 0 1 .721.544l.821 2.874a1.75 1.75 0 0 1-.562 1.825L4.29 7.86c.975 1.55 2.3 2.875 3.85 3.85l1.617-1.94a1.75 1.75 0 0 1 1.825-.562l2.874.82a.75.75 0 0 1 .544.722v3.5a.75.75 0 0 1-.75.75c-2.266 0-4.422-.61-6.309-1.664a13.77 13.77 0 0 1-5.277-5.277A12.9 12.9 0 0 1 1 1.75m8.484 10.69c1.25.578 2.606.94 4.016 1.035v-2.16l-2.33-.665a.25.25 0 0 0-.26.08zM3.56 6.516 5.27 5.09a.25.25 0 0 0 .08-.261L4.684 2.5H2.525A11.4 11.4 0 0 0 3.56 6.516" clip-rule="evenodd"/>`
    }, props));
$bdd51bc1f2f099ea$var$PhoneIcon.displayName = 'PhoneIcon';
var $bdd51bc1f2f099ea$var$_default = module.exports.default = $bdd51bc1f2f099ea$var$PhoneIcon;

});

parcelRegister("lUaB2", function(module, exports) {

$parcel$export(module.exports, "eocGlobalAlertListRoute", () => $ea0b3602049f5b80$export$29721341dde2ed3d);
const $ea0b3602049f5b80$export$29721341dde2ed3d = {
    name: 'eoc-global-alerts',
    path: '/jira/ops/alerts',
    exact: true
};

});

parcelRegister("fnZCh", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertDetailRoute", () => $6dfda5a4ad42a793$export$ac102dc13a0f4aff);
const $6dfda5a4ad42a793$export$ac102dc13a0f4aff = {
    name: 'eoc-team-alert-detail',
    path: '/jira/ops/teams/:teamId/alerts/:id',
    exact: true
};

});

parcelRegister("9MLkJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0593e321a36ff6ce$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0593e321a36ff6ce$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    alerts: {
        "id": "navigation-apps-sidebar-nav4-operations.alerts",
        "defaultMessage": "Alerts"
    }
});

});

parcelRegister("7Qdrb", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $9e533ca5776ffda5$export$4a39035bacc4ed76);

var $8J6rn = parcelRequire("8J6rn");

var $4PFfc = parcelRequire("4PFfc");


var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $itmJb = parcelRequire("itmJb");

var $cNd4s = parcelRequire("cNd4s");

var $hqBSi = parcelRequire("hqBSi");
const $9e533ca5776ffda5$export$4a39035bacc4ed76 = ()=>{
    const { isByokCustomer: isByokCustomer } = (0, $4PFfc.useByokComplianceSettingWithInitialisation)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    const { shouldUseJSM: shouldUseJSM, loading: ogTenantInfoLoading } = (0, $8J6rn.useOgTenantInfo)();
    const appEditions = (0, $k9JTq.useAppEditions)();
    const hasReports = !ogTenantInfoLoading && (isSiteAdmin || isAdmin) && !isByokCustomer && shouldUseJSM && !!licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61] && appEditions.serviceDesk !== (0, $ldyPw.FREE_EDITION);
    return {
        hasReports: hasReports
    };
};

});
parcelRegister("8J6rn", function(module, exports) {

$parcel$export(module.exports, "useOgTenantInfo", () => $31f27587daf0b28f$export$990ea9ff15ca04f7);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $bHhiy = parcelRequire("bHhiy");

var $daoB1 = parcelRequire("daoB1");

var $2YP9W = parcelRequire("2YP9W");

var $3H5ry = parcelRequire("3H5ry");
/**
 * This hook is used to refresh the tenant info resource when the server side
 * rendering fails due to an error or never actually happens.
 */ const $31f27587daf0b28f$var$useConsolidationStateResourceRefresh = (tenantInfoResource)=>{
    // It is important that this ff should stop any new behaviour except for
    // safe hook calls. That's why we only do very minimal stuff here.
    const { data: data, loading: loading, refresh: refresh } = tenantInfoResource;
    const isRefreshed = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (// eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4R6GH.fg)('refresh_tenant_info_on_client_for_ssr_error') && data === null && loading === false && isRefreshed.current === false) {
            refresh();
            isRefreshed.current = true;
        }
    }, [
        data,
        loading,
        refresh
    ]);
};
const $31f27587daf0b28f$export$990ea9ff15ca04f7 = ()=>{
    const tenantInfoResource = (0, $2YP9W.useResource)((0, $bHhiy.getConsolidationStateResource)());
    const applicationPermissions = (0, $daoB1.useApplicationPermissions)();
    $31f27587daf0b28f$var$useConsolidationStateResourceRefresh(tenantInfoResource);
    if (// TODO: Remove this check after the feature flag is removed
    // The refresh is handled in useConsolidationStateResourceRefresh
    // and this one is only for the old behaviour.
    !(0, $4R6GH.fg)('refresh_tenant_info_on_client_for_ssr_error') && tenantInfoResource.data === null && tenantInfoResource.loading === false && tenantInfoResource.error === null) tenantInfoResource.refresh();
    return {
        loading: tenantInfoResource.loading,
        error: tenantInfoResource.error,
        shouldUseJSM: (0, $3H5ry.checkShouldUseJSM)(tenantInfoResource.data),
        isConsolidated: (0, $3H5ry.checkIsConsolidated)(tenantInfoResource.data),
        isOpsAdmin: (0, $4R6GH.fg)('operations-tenant-info-endpoint-update') && (0, $3H5ry.checkIsOpsAdmin)(tenantInfoResource.data),
        isTransitioning: (0, $3H5ry.checkIsTransitioning)(tenantInfoResource.data),
        isTransitioned: (0, $3H5ry.checkIsTransitioned)(tenantInfoResource.data),
        isTransitionEligible: applicationPermissions.hasServiceDeskAccess && (0, $3H5ry.checkIsTransitionEligible)(tenantInfoResource.data),
        shouldAccessUnlockOperations: applicationPermissions.hasServiceDeskAccess && (0, $3H5ry.checkShouldAccessUnlockOperations)(tenantInfoResource.data),
        cohort: typeof tenantInfoResource.data === 'string' ? undefined : tenantInfoResource.data?.cohortInfo
    };
};

});
parcelRegister("daoB1", function(module, exports) {

$parcel$export(module.exports, "ApplicationPermissionsSubscriber", () => $77add4b5420e5058$export$d8c76f7e52d0a856);
$parcel$export(module.exports, "useApplicationPermissions", () => $77add4b5420e5058$export$4d9cadb4042acc1b);

var $dGvGJ = parcelRequire("dGvGJ");

var $51nlc = parcelRequire("51nlc");

var $2gywT = parcelRequire("2gywT");

var $9OXo1 = parcelRequire("9OXo1");
const $77add4b5420e5058$var$selector = (0, $dGvGJ.createSelector)((state)=>state.tenantContext.appPermissions, (applicationPermissions)=>({
        data: {
            applicationPermissions: applicationPermissions
        }
    }));
const $77add4b5420e5058$export$d8c76f7e52d0a856 = (0, $51nlc.createSubscriber)((0, $2gywT.default), {
    displayName: 'ApplicationPermissionsSubscriber',
    selector: $77add4b5420e5058$var$selector
});
const $77add4b5420e5058$export$4d9cadb4042acc1b = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.appPermissions;
};

});



parcelRegister("7zFZv", function(module, exports) {

$parcel$export(module.exports, "default", () => $adc2a9b3f9b765e0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $adc2a9b3f9b765e0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    overview: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.overview",
        "defaultMessage": "Overview"
    },
    alerts: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.alerts",
        "defaultMessage": "Alerts"
    },
    onCallSchedules: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.on-call-schedules",
        "defaultMessage": "On-call schedules"
    },
    generalConfiguration: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.general-configuration",
        "defaultMessage": "General configuration"
    },
    reports: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.reports",
        "defaultMessage": "Reports"
    },
    defaultFilters: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.default-filters",
        "defaultMessage": "Default filters"
    },
    sharedWithMe: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.shared-with-me",
        "defaultMessage": "Shared with me"
    },
    createdByMe: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.created-by-me",
        "defaultMessage": "Created by me"
    },
    starred: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.starred",
        "defaultMessage": "Starred"
    },
    allAlerts: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.all-alerts",
        "defaultMessage": "All alerts"
    },
    myAlerts: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.my-alerts",
        "defaultMessage": "My alerts"
    },
    viewAllFiltersPopupMenuButtonText: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.view-all-filters-popup-menu-button-text",
        "defaultMessage": "View all"
    },
    viewAllFiltersSearchPlaceholder: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.view-all-filters-search-placeholder",
        "defaultMessage": "Search"
    },
    viewAllFiltersNoResultsFoundText: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.view-all-filters-no-results-found-text",
        "defaultMessage": "No search results found"
    },
    allSearch: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.all-search",
        "defaultMessage": "All"
    },
    openSearch: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.open-search",
        "defaultMessage": "Open"
    },
    closedSearch: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.closed-search",
        "defaultMessage": "Closed"
    },
    unackedSearch: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.unacked-search",
        "defaultMessage": "Unacknowledged"
    },
    notSeenSearch: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.not-seen-search",
        "defaultMessage": "Not seen"
    },
    assignedToMeSearch: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.assigned-to-me-search",
        "defaultMessage": "Assigned to me"
    }
});

});

parcelRegister("87kQ4", function(module, exports) {

$parcel$export(module.exports, "ActionButtons", () => $cfb53a200327fce3$export$88c65d2d98aab183);
$parcel$export(module.exports, "PopoutToggleButton", () => $cfb53a200327fce3$export$a9edf85e3b30c33a);

var $5uXOq = parcelRequire("5uXOq");

var $epOG5 = parcelRequire("epOG5");

var $3Z96c = parcelRequire("3Z96c");
var $9UCCQ = parcelRequire("9UCCQ");

var $3bDjY = parcelRequire("3bDjY");

var $42CjB = parcelRequire("42CjB");

var $8J6rn = parcelRequire("8J6rn");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");





var $jecJ3 = parcelRequire("jecJ3");

var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $46Cti = parcelRequire("46Cti");

var $eaKdt = parcelRequire("eaKdt");

var $aCS3f = parcelRequire("aCS3f");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");


var $9OXo1 = parcelRequire("9OXo1");

var $lODMY = parcelRequire("lODMY");

var $9eeFp = parcelRequire("9eeFp");

var $lFWH9 = parcelRequire("lFWH9");

var $bLVOJ = parcelRequire("bLVOJ");

var $8BItO = parcelRequire("8BItO");
function $cfb53a200327fce3$export$88c65d2d98aab183({ onClose: onClose }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCS3f.MoreNavMenuButton), {
        onOpen: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$b887e88d8d0739f6),
                actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                    level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                    itemId: (0, $496585bee7985bb9$export$f06dfcec5ff912e)
                }
            });
        },
        MenuItems: $cfb53a200327fce3$var$MoreMenuItems,
        onClose: onClose
    });
}
function $cfb53a200327fce3$var$MoreMenuItems({ onClose: onClose }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onCloseWithStopPropagation = (0, $9eeFp.useStopPropagation)((event)=>{
        onClose?.(event);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$64fed82162bd367),
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $1e554a683893bd46$export$17bca95234dea43b),
                level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                itemId: 'generalConfiguration',
                parentItemId: (0, $jecJ3.SECTION_ITEM_OPERATIONS)
            }
        });
    });
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { isOpsAdmin: isOpsAdmin } = (0, $8J6rn.useOgTenantInfo)();
    const shouldShowGeneralConfiguration = (0, $4R6GH.fg)('operations-tenant-info-endpoint-update') ? (tenantContext.isAdmin || isOpsAdmin) && tenantContext.licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61] : tenantContext.isAdmin && tenantContext.licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, shouldShowGeneralConfiguration ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Z96c.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($epOG5))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        }),
        href: "/jira/settings/products/ops/jira-service-management-audit-logs",
        onClick: onCloseWithStopPropagation
    }, formatMessage((0, $bLVOJ.default).generalConfiguration))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaKdt.HideL1MenuItemSection), {
        menuId: (0, $46Cti.L1_MENU_ID).OPERATIONS,
        hasSeparator: shouldShowGeneralConfiguration
    }));
}
const $cfb53a200327fce3$var$usePath = (0, $lODMY.createRouterSelector)((state)=>`${state.location.pathname}${state.location.search}`);
const $cfb53a200327fce3$export$a9edf85e3b30c33a = ({ onClick: onClick })=>{
    const { state: { isPoppedOut: isPoppedOut, lastVisitedSearch: lastVisitedSearch }, setIsPoppedOut: setIsPoppedOut, togglePoppedOut: togglePoppedOut } = (0, $8BItO.useAlertsPopoutStore)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const path = $cfb53a200327fce3$var$usePath();
    const handleToggle = (_, analyticsEvent)=>{
        onClick?.();
        if ((0, $4R6GH.fg)('operations_nav4_remaining_items')) {
            togglePoppedOut(path);
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'jsmOperationsAlertsPopoutButtonToggle', {
                isPoppedOut: lastVisitedSearch
            });
        } else {
            setIsPoppedOut(!isPoppedOut);
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'jsmOperationsAlertsPopoutButtonToggle', {
                isPoppedOut: isPoppedOut
            });
        }
    };
    const iconButtonLabel = ((0, $4R6GH.fg)('operations_nav4_remaining_items') ? lastVisitedSearch : isPoppedOut) ? formatMessage((0, $bLVOJ.default).popInLabel) : formatMessage((0, $bLVOJ.default).popOutLabel);
    const tooltipContent = ((0, $4R6GH.fg)('operations_nav4_remaining_items') ? lastVisitedSearch : isPoppedOut) ? formatMessage((0, $bLVOJ.default).popInTooltip) : formatMessage((0, $bLVOJ.default).popOutTooltip);
    const Icon = ((0, $4R6GH.fg)('operations_nav4_remaining_items') ? lastVisitedSearch : isPoppedOut) ? (0, $lFWH9.PopinIcon) : (0, $lFWH9.PopoutIcon);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: tooltipContent
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            ...tooltipProps,
            label: iconButtonLabel,
            onClick: handleToggle,
            icon: Icon,
            spacing: "compact",
            appearance: "subtle"
        }));
};

});
parcelRegister("lFWH9", function(module, exports) {

$parcel$export(module.exports, "PopoutIcon", () => $6741c2a704632c64$export$a837275bb5fcc92e);
$parcel$export(module.exports, "PopinIcon", () => $6741c2a704632c64$export$5b106f296c88ef0);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");

var $koVbs = parcelRequire("koVbs");

var $kwXbj = parcelRequire("kwXbj");
const $6741c2a704632c64$var$PoputGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15 4L19.25 4C19.4489 4 19.6397 4.07902 19.7803 4.21967C19.921 4.36032 20 4.55109 20 4.75V9H18.5V6.56066L15.0303 10.0303L13.9697 8.96967L17.4393 5.5L15 5.5V4ZM7 7.5C6.72386 7.5 6.5 7.72386 6.5 8L6.5 10.5H11.5C12.6046 10.5 13.5 11.3954 13.5 12.5L13.5 17.5H16C16.2761 17.5 16.5 17.2761 16.5 17V12H18V17C18 18.1046 17.1046 19 16 19H12.7512C12.7508 19 12.7504 19 12.75 19L7 19C5.89543 19 5 18.1046 5 17L5 11.25C5 11.2498 5 11.2497 5 11.2495L5 8C5 6.89543 5.89543 6 7 6L12 6V7.5L7 7.5ZM7 17.5L12 17.5L12 12.5C12 12.2239 11.7761 12 11.5 12H6.5L6.5 17C6.5 17.2761 6.72386 17.5 7 17.5Z"
    }));
const $6741c2a704632c64$var$PopinGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14 4L18 4C19.1046 4 20 4.89543 20 6V10C20 11.1046 19.1046 12 18 12H14C13.7229 12 13.4589 11.9436 13.2189 11.8417L11.0607 14H13.5V15.5H9.25C8.83579 15.5 8.5 15.1642 8.5 14.75L8.5 10.5H10L10 12.9393L12.1583 10.7811C12.0564 10.5411 12 10.2771 12 10V6C12 4.89543 12.8954 4 14 4ZM18 5.5L14 5.5C13.7239 5.5 13.5 5.72386 13.5 6V10C13.5 10.2761 13.7239 10.5 14 10.5H18C18.2761 10.5 18.5 10.2761 18.5 10V6C18.5 5.72386 18.2761 5.5 18 5.5ZM7 6L10 6V7.5H7C6.72386 7.5 6.5 7.72386 6.5 8L6.5 17C6.5 17.2761 6.72386 17.5 7 17.5L16 17.5C16.2761 17.5 16.5 17.2761 16.5 17V14H18V17C18 18.1046 17.1046 19 16 19L7 19C5.89543 19 5 18.1046 5 17L5 8C5 6.89543 5.89543 6 7 6Z"
    }));
const $6741c2a704632c64$export$a837275bb5fcc92e = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        glyph: $6741c2a704632c64$var$PoputGlyph,
        label: formatMessage((0, $kwXbj.messages).popoutIconLabel)
    });
};
const $6741c2a704632c64$export$5b106f296c88ef0 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        glyph: $6741c2a704632c64$var$PopinGlyph,
        label: formatMessage((0, $kwXbj.messages).popinIconLabel)
    });
};

});
parcelRegister("kwXbj", function(module, exports) {

$parcel$export(module.exports, "messages", () => $224ad3c1be6abc40$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $224ad3c1be6abc40$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    popoutIconLabel: {
        "id": "servicedesk-queues-nav4.common.popout-toggle-button.icons.popout-icon-label",
        "defaultMessage": "Pop out icon"
    },
    popinIconLabel: {
        "id": "servicedesk-queues-nav4.common.popout-toggle-button.icons.popin-icon-label",
        "defaultMessage": "Pop in icon"
    }
});

});


parcelRegister("bLVOJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $305b1dd418fc2a25$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $305b1dd418fc2a25$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    generalConfiguration: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.operations-expandable-menu-item.action-buttons.general-configuration",
        "defaultMessage": "General configuration"
    },
    popOutLabel: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.operations-expandable-menu-item.action-buttons.pop-out-label",
        "defaultMessage": "Pop out operations alert searches"
    },
    popOutTooltip: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.operations-expandable-menu-item.action-buttons.pop-out-tooltip",
        "defaultMessage": "Pop out from sidebar"
    },
    popInLabel: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.operations-expandable-menu-item.action-buttons.pop-in-label",
        "defaultMessage": "Pop in operations alert searches"
    },
    popInTooltip: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.operations-expandable-menu-item.action-buttons.pop-in-tooltip",
        "defaultMessage": "Move back to sidebar"
    }
});

});

parcelRegister("8BItO", function(module, exports) {

$parcel$export(module.exports, "AlertsPopoutStoreContainer", () => $57b94178b916bb11$export$c37792f744809959);
$parcel$export(module.exports, "useAlertsPopoutStore", () => $57b94178b916bb11$export$f89494880a713101);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $bSSG7 = parcelRequire("bSSG7");

var $4R6GH = parcelRequire("4R6GH");
const $57b94178b916bb11$var$LOCAL_STORAGE_KEY_LAST_VISITED_SEARCH = 'jira-ops-alert-filters-last-visited-search';
const $57b94178b916bb11$var$localStorageProvider = (0, $bSSG7.createLocalStorageProvider)('alert_filters_popout');
const $57b94178b916bb11$var$setAlertFiltersLastVisitedInLocalStorage = (value)=>{
    try {
        $57b94178b916bb11$var$localStorageProvider.set($57b94178b916bb11$var$LOCAL_STORAGE_KEY_LAST_VISITED_SEARCH, value);
    } catch (_) {
        return false;
    }
    return true;
};
const $57b94178b916bb11$var$getAlertFiltersLastVisitedFromLocalStorage = ()=>{
    let item;
    try {
        item = $57b94178b916bb11$var$localStorageProvider.get($57b94178b916bb11$var$LOCAL_STORAGE_KEY_LAST_VISITED_SEARCH);
    } catch (_) {
        return undefined;
    }
    return item;
};
const $57b94178b916bb11$var$getOnInit = ()=>{
    return (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        lastVisitedSearch: $57b94178b916bb11$var$getAlertFiltersLastVisitedFromLocalStorage()
    } : {
        isPoppedOut: false,
        content: null
    };
};
const $57b94178b916bb11$var$actions = {
    setIsPoppedOut: (value)=>({ getState: getState, setState: setState })=>{
            if (!(0, $4R6GH.fg)('operations_nav4_remaining_items')) setState({
                ...getState(),
                isPoppedOut: value
            });
        },
    setLastVisitedSearch: (value)=>({ getState: getState, setState: setState })=>{
            if (getState().lastVisitedSearch) {
                setState({
                    ...getState(),
                    lastVisitedSearch: value
                });
                $57b94178b916bb11$var$setAlertFiltersLastVisitedInLocalStorage(value);
            }
        },
    togglePoppedOut: (value)=>({ getState: getState, setState: setState })=>{
            if (!getState().lastVisitedSearch) {
                setState({
                    ...getState(),
                    lastVisitedSearch: value
                });
                $57b94178b916bb11$var$setAlertFiltersLastVisitedInLocalStorage(value);
            } else {
                setState({
                    ...getState(),
                    lastVisitedSearch: null
                });
                $57b94178b916bb11$var$setAlertFiltersLastVisitedInLocalStorage(null);
            }
        },
    syncLastVisitedSearch: ()=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                lastVisitedSearch: $57b94178b916bb11$var$getAlertFiltersLastVisitedFromLocalStorage()
            });
        },
    setContent: (content)=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                content: content
            });
        }
};
const $57b94178b916bb11$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        content: null,
        isPoppedOut: false,
        lastVisitedSearch: ' '
    },
    actions: $57b94178b916bb11$var$actions,
    name: 'AlertsPopoutStore'
});
const $57b94178b916bb11$export$c37792f744809959 = (0, $gg7kZ.createContainer)($57b94178b916bb11$var$Store, {
    onInit: ()=>({ setState: setState })=>{
            setState($57b94178b916bb11$var$getOnInit());
        }
});
const $57b94178b916bb11$var$useHook = (0, $3sQ5x.createHook)($57b94178b916bb11$var$Store);
const $57b94178b916bb11$export$f89494880a713101 = ()=>{
    const [state, hookActions] = $57b94178b916bb11$var$useHook();
    return {
        state: state,
        ...hookActions
    };
};

});




parcelRegister("2CMcE", function(module, exports) {

$parcel$export(module.exports, "OperationsMenuForLanding", () => $4f2124831a167c55$export$b37dd5cf3b893940);

var $df0z5 = parcelRequire("df0z5");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $l8ruj = parcelRequire("l8ruj");

var $dGQgy = parcelRequire("dGQgy");

var $gzxPn = parcelRequire("gzxPn");

var $ePmXi = parcelRequire("ePmXi");

var $8BItO = parcelRequire("8BItO");
const $4f2124831a167c55$export$b37dd5cf3b893940 = ({ isExpanded: isExpanded, queryRef: queryRef })=>{
    const data = (0, $8Uumt.useFragment)((0, $df0z5.default), queryRef);
    const { state: { isPoppedOut: isPoppedOut, lastVisitedSearch: lastVisitedSearch }, setContent: setContent } = (0, $8BItO.useAlertsPopoutStore)();
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $4R6GH.fg)('operations_nav4_remaining_items') ? lastVisitedSearch : isPoppedOut) setContent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dGQgy.AlertsMenuItemContent), {
            queryRef: data
        }));
        if (!(0, $4R6GH.fg)('operations_nav4_remaining_items')) return ()=>{
            setContent(null);
        };
    }, [
        data,
        isPoppedOut,
        lastVisitedSearch,
        setContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4-sidebar-operations-trigger-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gzxPn.OperationsExpandableMenuItem), {
        isExpanded: isExpanded,
        AlertsMenuItemContent: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
            name: "nav4-sidebar-operations-expanded-items"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ePmXi.AlertsMenuItemContentNew), {
            queryRef: data
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dGQgy.AlertsMenuItemContent), {
            queryRef: data
        })
    }));
};

});
parcelRegister("df0z5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a039eea1ea338a10$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4581c0468a5d4ef30519c5609a70ff06>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a039eea1ea338a10$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "OperationsMenuForLanding",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "AlertsMenuItemContentNew"
        },
        {
            "kind": "FragmentSpread",
            "name": "AlertsMenuItemContent"
        }
    ],
    "type": "Query"
};
$a039eea1ea338a10$var$node.hash = "539a9dffb7945e99bc6a650607eca8e4";
var $a039eea1ea338a10$export$2e2bcd8739ae039 = $a039eea1ea338a10$var$node;

});

parcelRegister("dGQgy", function(module, exports) {

$parcel$export(module.exports, "AlertsMenuItemContent", () => $ab6d77ca097b26bb$export$fcbb0679bb6c6da1);

var $k3zlg = parcelRequire("k3zlg");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $6a9Wp = parcelRequire("6a9Wp");

var $lnznH = parcelRequire("lnznH");
var $cZa9B = parcelRequire("cZa9B");

var $4R6GH = parcelRequire("4R6GH");

var $39KIs = parcelRequire("39KIs");

var $koVbs = parcelRequire("koVbs");




var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $lhMtU = parcelRequire("lhMtU");

var $c6x3L = parcelRequire("c6x3L");

var $c16H2 = parcelRequire("c16H2");

var $5FnJJ = parcelRequire("5FnJJ");

var $dQbFB = parcelRequire("dQbFB");

var $24a2m = parcelRequire("24a2m");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $90yGq = parcelRequire("90yGq");

var $l8ruj = parcelRequire("l8ruj");

var $ieDtd = parcelRequire("ieDtd");

var $cM3YM = parcelRequire("cM3YM");

var $9MLkJ = parcelRequire("9MLkJ");

var $7zFZv = parcelRequire("7zFZv");

var $8BItO = parcelRequire("8BItO");

var $gtYPY = parcelRequire("gtYPY");
function $ab6d77ca097b26bb$export$fcbb0679bb6c6da1({ queryRef: queryRef }) {
    const data = (0, $8Uumt.useFragment)((0, $k3zlg.default), queryRef);
    const [selectedFilter, setSelectedFilter] = (0, $5uXOq.useState)('');
    const { isSelectedPath: isSelectedPath } = (0, $c6x3L.useSidebarNav4)();
    const { sharedWithMe: sharedWithMe, createdByMe: createdByMe } = data?.opsgenie?.savedSearches || {};
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const accountId = (0, $90yGq.useAccountId)();
    const [savedSearchIdFromURL] = (0, $ieDtd.useQueryParam)('filter');
    const [viewType] = (0, $ieDtd.useQueryParam)('view');
    const { icon: pagesIcon } = (0, $24a2m.useFormattedMessageAndIcon)((0, $9MLkJ.default).alerts, (0, (/*@__PURE__*/$parcel$interopDefault($6a9Wp))));
    const { setLastVisitedSearch: setLastVisitedSearch } = (0, $8BItO.useAlertsPopoutStore)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const defaultFilters = [
        {
            id: 'all',
            name: formatMessage((0, $7zFZv.default).allSearch),
            alertSearchQuery: ''
        },
        {
            id: 'open',
            name: formatMessage((0, $7zFZv.default).openSearch),
            alertSearchQuery: `${(0, $39KIs.IDENTIFIER_STATUS)}${(0, $39KIs.OPERATOR_EQUAL_TO)} ${(0, $39KIs.STRING_LITERAL_STATUS_OPEN)}`
        },
        {
            id: 'closed',
            name: formatMessage((0, $7zFZv.default).closedSearch),
            alertSearchQuery: `${(0, $39KIs.IDENTIFIER_STATUS)}${(0, $39KIs.OPERATOR_EQUAL_TO)} ${(0, $39KIs.STRING_LITERAL_STATUS_CLOSED)}`
        },
        {
            id: 'unacked',
            name: formatMessage((0, $7zFZv.default).unackedSearch),
            alertSearchQuery: `${(0, $39KIs.IDENTIFIER_STATUS)}${(0, $39KIs.OPERATOR_EQUAL_TO)} ${(0, $39KIs.STRING_LITERAL_STATUS_OPEN)} ${(0, $39KIs.LOGICAL_OPERATOR_AND)} ${(0, $39KIs.IDENTIFIER_ACKNOWLEDGED)}${(0, $39KIs.OPERATOR_EQUAL_TO)} ${(0, $39KIs.BOOLEAN_LITERAL_FALSE)}`
        },
        {
            id: 'notSeen',
            name: formatMessage((0, $7zFZv.default).notSeenSearch),
            alertSearchQuery: `${(0, $39KIs.IDENTIFIER_IS_SEEN)}${(0, $39KIs.OPERATOR_EQUAL_TO)} ${(0, $39KIs.BOOLEAN_LITERAL_FALSE)}`
        },
        {
            id: 'assignedToMe',
            name: formatMessage((0, $7zFZv.default).assignedToMeSearch),
            alertSearchQuery: `${(0, $39KIs.IDENTIFIER_ASSIGNEE)}${(0, $39KIs.OPERATOR_EQUAL_TO)} "${accountId || 'me'}"`
        }
    ];
    const defaultFilterMenuIds = $ab6d77ca097b26bb$var$getParentMenuId(defaultFilters);
    const sharedWithMeMenuIds = $ab6d77ca097b26bb$var$getParentMenuId(sharedWithMe, savedSearchIdFromURL);
    const createdByMeMenuIds = $ab6d77ca097b26bb$var$getParentMenuId(createdByMe, savedSearchIdFromURL);
    (0, $5uXOq.useEffect)(()=>{
        if (!isSelectedPath((0, $jhS4y.MENU_ID_OPS_ALERTS)) && selectedFilter !== '') setSelectedFilter('');
    }, [
        isSelectedPath,
        selectedFilter
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4.sidebar.operations.alerts"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        menuId: defaultFilterMenuIds,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                    level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                    itemId: 'defaultFilters',
                    parentItemId: 'alerts'
                }
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZa9B.ExpandableMenuItemTrigger), {
        testId: (0, $dQbFB.getTestId)(defaultFilterMenuIds)
    }, formatMessage((0, $7zFZv.default).defaultFilters)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnznH.ExpandableMenuItemContent), null, defaultFilters.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
            elemBefore: pagesIcon,
            key: item.id,
            href: `/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}`,
            menuId: (0, $jhS4y.ENTITY_ID).ALARM_QUEUE(item.alertSearchQuery),
            onClick: ()=>{
                setSelectedFilter(item.id);
                if ((0, $4R6GH.fg)('operations_nav4_remaining_items')) setLastVisitedSearch(`/jira/ops/alerts?view=${viewType ?? 'list'}${item.alertSearchQuery ? `&query=${item.alertSearchQuery}` : ''}`);
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                    action: 'clicked',
                    actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                    actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OPERATIONS],
                    attributes: {
                        componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                        level: (0, $951a0ed422513987$export$f9db6a58b4aabd18),
                        itemId: item.id,
                        parentItemId: 'defaultFilters',
                        itemType: 'defaultFilter'
                    }
                });
            }
        }, item.name)))), sharedWithMe && sharedWithMe.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        menuId: sharedWithMeMenuIds,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                    level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                    itemId: 'sharedWithMe',
                    parentItemId: 'alerts'
                }
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZa9B.ExpandableMenuItemTrigger), {
        testId: (0, $dQbFB.getTestId)(sharedWithMeMenuIds)
    }, formatMessage((0, $7zFZv.default).sharedWithMe), sharedWithMe.some((filter)=>isSelectedPath(filter.alertSearchQuery))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnznH.ExpandableMenuItemContent), null, sharedWithMe.map((item)=>{
        if ((0, $4R6GH.fg)('operations_nav4_remaining_items')) {
            const savedSearchId = item.id ? (0, $cM3YM.OpsgenieSavedSearchAri).parse(item.id).savedSearchId : '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
                key: item.id,
                elemBefore: pagesIcon,
                href: `/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}${item.id ? `&filter=${savedSearchId}` : ''}`,
                menuId: (0, $jhS4y.ENTITY_ID).ALARM_QUEUE(savedSearchIdFromURL ? savedSearchId : item.alertSearchQuery),
                onClick: ()=>{
                    setSelectedFilter('');
                    if ((0, $4R6GH.fg)('operations_nav4_remaining_items')) setLastVisitedSearch(`/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}${item.id ? `&filter=${savedSearchId}` : ''}`);
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                        action: 'clicked',
                        actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                        actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OPERATIONS],
                        attributes: {
                            componentType: (0, $1e554a683893bd46$export$3ac911b122986477),
                            level: (0, $951a0ed422513987$export$f9db6a58b4aabd18),
                            itemId: item.id,
                            itemType: 'savedSearch',
                            parentItemId: 'sharedWithMe'
                        }
                    });
                }
            }, item.name);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
            elemBefore: pagesIcon,
            href: `/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}`,
            key: item.id,
            menuId: (0, $jhS4y.ENTITY_ID).ALARM_QUEUE(item.alertSearchQuery),
            onClick: ()=>{
                setSelectedFilter('');
                if ((0, $4R6GH.fg)('operations_nav4_remaining_items')) setLastVisitedSearch(`/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}`);
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                    action: 'clicked',
                    actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                    actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OPERATIONS],
                    attributes: {
                        componentType: (0, $1e554a683893bd46$export$3ac911b122986477),
                        level: (0, $951a0ed422513987$export$f9db6a58b4aabd18),
                        itemId: item.id,
                        itemType: 'savedSearch',
                        parentItemId: 'sharedWithMe'
                    }
                });
            }
        }, item.name);
    }))), createdByMe && createdByMe.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        menuId: createdByMeMenuIds,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                    level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                    itemId: 'createdByMe',
                    parentItemId: 'alerts'
                }
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZa9B.ExpandableMenuItemTrigger), {
        testId: (0, $dQbFB.getTestId)(createdByMeMenuIds)
    }, formatMessage((0, $7zFZv.default).createdByMe)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnznH.ExpandableMenuItemContent), null, createdByMe.map((item)=>{
        if ((0, $4R6GH.fg)('operations_nav4_remaining_items')) {
            const savedSearchId = item.id ? (0, $cM3YM.OpsgenieSavedSearchAri).parse(item.id).savedSearchId : '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
                key: item.id,
                elemBefore: pagesIcon,
                href: `/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}${item.id ? `&filter=${savedSearchId}` : ''}`,
                menuId: (0, $jhS4y.ENTITY_ID).ALARM_QUEUE(savedSearchIdFromURL ? savedSearchId : item.alertSearchQuery),
                onClick: ()=>{
                    setSelectedFilter('');
                    if ((0, $4R6GH.fg)('operations_nav4_remaining_items')) setLastVisitedSearch(`/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}${item.id ? `&filter=${savedSearchId}` : ''}`);
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                        action: 'clicked',
                        actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                        actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OPERATIONS],
                        attributes: {
                            componentType: (0, $1e554a683893bd46$export$3ac911b122986477),
                            level: (0, $951a0ed422513987$export$f9db6a58b4aabd18),
                            itemId: item.id,
                            itemType: 'savedSearch',
                            parentItemId: 'createdByMe'
                        }
                    });
                },
                actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gtYPY.SavedSearchActionButtons), {
                    savedSearch: item
                })
            }, item.name);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
            elemBefore: pagesIcon,
            href: `/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}`,
            key: item.id,
            menuId: (0, $jhS4y.ENTITY_ID).ALARM_QUEUE(item.alertSearchQuery),
            onClick: ()=>{
                setSelectedFilter('');
                if ((0, $4R6GH.fg)('operations_nav4_remaining_items')) setLastVisitedSearch(`/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}`);
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                    action: 'clicked',
                    actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                    actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OPERATIONS],
                    attributes: {
                        componentType: (0, $1e554a683893bd46$export$3ac911b122986477),
                        level: (0, $951a0ed422513987$export$f9db6a58b4aabd18),
                        itemId: item.id,
                        itemType: 'savedSearch',
                        parentItemId: 'createdByMe'
                    }
                });
            },
            actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gtYPY.SavedSearchActionButtons), {
                savedSearch: item
            })
        }, item.name);
    }))));
}
function $ab6d77ca097b26bb$var$getParentMenuId(arr, savedSearchId) {
    return (0, $lhMtU.toMenuIdFromMenuIdList)((arr || []).map((i)=>(0, $4R6GH.fg)('operations_nav4_remaining_items') ? (0, $jhS4y.ENTITY_ID).ALARM_QUEUE(savedSearchId ? (0, $cM3YM.OpsgenieSavedSearchAri).parse(i.id).savedSearchId : i.alertSearchQuery) : (0, $jhS4y.ENTITY_ID).ALARM_QUEUE(i.alertSearchQuery)));
}

});
parcelRegister("k3zlg", function(module, exports) {

$parcel$export(module.exports, "default", () => $06087129a1b4fe18$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d1bb40d3f14284ac71e150506c3a9894>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $06087129a1b4fe18$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    }, v2 = {
        "kind": "ScalarField",
        "name": "alertSearchQuery"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            }
        ],
        "kind": "Fragment",
        "name": "AlertsMenuItemContent",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "OpsgenieQuery",
                    "kind": "LinkedField",
                    "name": "opsgenie",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    }
                                ],
                                "concreteType": "OpsgenieSavedSearches",
                                "kind": "LinkedField",
                                "name": "savedSearches",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "sharedWithMe",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v0 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.sharedWithMe.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v1 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.sharedWithMe.name"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v2 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.sharedWithMe.alertSearchQuery"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "opsgenie.savedSearches.sharedWithMe"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "createdByMe",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v0 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.createdByMe.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v1 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.createdByMe.name"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v2 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.createdByMe.alertSearchQuery"
                                                }
                                            ]
                                        },
                                        "action": "LOG",
                                        "path": "opsgenie.savedSearches.createdByMe"
                                    }
                                ]
                            },
                            "action": "LOG",
                            "path": "opsgenie.savedSearches"
                        }
                    ]
                },
                "action": "LOG",
                "path": "opsgenie"
            }
        ],
        "type": "Query"
    };
}();
$06087129a1b4fe18$var$node.hash = "a105f985be669906c4ceff76a45b11bc";
var $06087129a1b4fe18$export$2e2bcd8739ae039 = $06087129a1b4fe18$var$node;

});

parcelRegister("6a9Wp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aff4cd926156d74fe58acdf2d87dd6f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $47cb635ccdf7d850$var$_react = $47cb635ccdf7d850$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $47cb635ccdf7d850$var$_baseNew = $47cb635ccdf7d850$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $47cb635ccdf7d850$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pages".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for multipe pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $47cb635ccdf7d850$var$PagesIcon = (props)=>/*#__PURE__*/ $47cb635ccdf7d850$var$_react.default.createElement($47cb635ccdf7d850$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM4 4h6v1.5H4zm10.5 8.75V6H16v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75M4 7h4.5v1.5H4z" clip-rule="evenodd"/>`
    }, props));
$47cb635ccdf7d850$var$PagesIcon.displayName = 'PagesIcon';
var $47cb635ccdf7d850$var$_default = module.exports.default = $47cb635ccdf7d850$var$PagesIcon;

});

parcelRegister("39KIs", function(module, exports) {

$parcel$export(module.exports, "TOKEN_TYPES", () => $8a97fa493a4d7e02$export$e92b897d610f2aba);
$parcel$export(module.exports, "LEFT_PARENTHESIS", () => $8a97fa493a4d7e02$export$9ce7f372949a1546);
$parcel$export(module.exports, "RIGHT_PARENTHESIS", () => $8a97fa493a4d7e02$export$bbbb3f477a9839e0);
$parcel$export(module.exports, "OPERATOR_EQUAL_TO", () => $8a97fa493a4d7e02$export$ea7497008076d6d2);
$parcel$export(module.exports, "OPERATOR_GROUP_FOR_ASSISTANT", () => $8a97fa493a4d7e02$export$e75c84803c67e1f4);
$parcel$export(module.exports, "LOGICAL_OPERATOR_AND", () => $8a97fa493a4d7e02$export$61308b2610174a70);
$parcel$export(module.exports, "LOGICAL_OPERATOR_OR", () => $8a97fa493a4d7e02$export$1de654320eb3e523);
$parcel$export(module.exports, "BOOLEAN_LITERAL_TRUE", () => $8a97fa493a4d7e02$export$ff7eed6ac2251302);
$parcel$export(module.exports, "BOOLEAN_LITERAL_FALSE", () => $8a97fa493a4d7e02$export$4b436fec6f13b741);
$parcel$export(module.exports, "BOOLEAN_LITERAL_GROUP", () => $8a97fa493a4d7e02$export$8cbc171ac4843075);
$parcel$export(module.exports, "STRING_LITERAL_DOUBLE_QUOTE", () => $8a97fa493a4d7e02$export$347c7cb6285a1d61);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_OPEN", () => $8a97fa493a4d7e02$export$910131ff5cd3d496);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_CLOSED", () => $8a97fa493a4d7e02$export$2aa0d26cb4549272);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_ACKED", () => $8a97fa493a4d7e02$export$572cec90aa166025);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_SNOOZED", () => $8a97fa493a4d7e02$export$f94109650ec67751);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_GROUP", () => $8a97fa493a4d7e02$export$3a3a37e9da45a2a4);
$parcel$export(module.exports, "STRING_LITERAL_PRIORITY_GROUP", () => $8a97fa493a4d7e02$export$9ef3f42fa10fce44);
$parcel$export(module.exports, "NULL_LITERAL", () => $8a97fa493a4d7e02$export$c2b6d31a7a2d40ba);
$parcel$export(module.exports, "IDENTIFIER_ALIAS", () => $8a97fa493a4d7e02$export$21c480ed86e9d13);
$parcel$export(module.exports, "IDENTIFIER_CLOSED_BY", () => $8a97fa493a4d7e02$export$534c195089710c34);
$parcel$export(module.exports, "IDENTIFIER_DEDUPLICATION", () => $8a97fa493a4d7e02$export$4699ad3805947d4d);
$parcel$export(module.exports, "IDENTIFIER_ENTITY", () => $8a97fa493a4d7e02$export$2a30b5099ba66c99);
$parcel$export(module.exports, "IDENTIFIER_IS_SEEN", () => $8a97fa493a4d7e02$export$7926b4c2836db847);
$parcel$export(module.exports, "IDENTIFIER_MESSAGE", () => $8a97fa493a4d7e02$export$5a8895646b1d5248);
$parcel$export(module.exports, "IDENTIFIER_ASSIGNEE", () => $8a97fa493a4d7e02$export$4047502bdab1e205);
$parcel$export(module.exports, "IDENTIFIER_PRIORITY", () => $8a97fa493a4d7e02$export$5922c06b76ebb57d);
$parcel$export(module.exports, "IDENTIFIER_COMPONENTS", () => $8a97fa493a4d7e02$export$1122634b5d555f05);
$parcel$export(module.exports, "IDENTIFIER_SERVICES", () => $8a97fa493a4d7e02$export$ec912454cd7d858a);
$parcel$export(module.exports, "IDENTIFIER_RESPONDERS", () => $8a97fa493a4d7e02$export$44673ddac1790242);
$parcel$export(module.exports, "IDENTIFIER_SOURCE", () => $8a97fa493a4d7e02$export$f250d53474e801dc);
$parcel$export(module.exports, "IDENTIFIER_STATUS", () => $8a97fa493a4d7e02$export$43181828ba8680e4);
$parcel$export(module.exports, "IDENTIFIER_TAG", () => $8a97fa493a4d7e02$export$8242733866920892);
$parcel$export(module.exports, "IDENTIFIER_TINY_ID", () => $8a97fa493a4d7e02$export$c833829cf31052f0);
$parcel$export(module.exports, "IDENTIFIER_ACKNOWLEDGED", () => $8a97fa493a4d7e02$export$5f1e5c89a704810f);
$parcel$export(module.exports, "IDENTIFIER_ACKNOWLEDGED_BY", () => $8a97fa493a4d7e02$export$89d93eb7117999c0);
$parcel$export(module.exports, "IDENTIFIER_TEAMS", () => $8a97fa493a4d7e02$export$a79eb1864dd7b745);
$parcel$export(module.exports, "IDENTIFIER_GROUP_ALERT", () => $8a97fa493a4d7e02$export$888a9cda49b5e18c);
$parcel$export(module.exports, "IDENTIFIER_BOOLEAN_GROUP", () => $8a97fa493a4d7e02$export$60745b712d37edf9);
$parcel$export(module.exports, "IDENTIFIER_GROUP_ALL", () => $8a97fa493a4d7e02$export$b38df7dc61d42293);
$parcel$export(module.exports, "splitToTokensRegex", () => $8a97fa493a4d7e02$export$28041d1d2a85f002);
$parcel$export(module.exports, "isKeywordRegex", () => $8a97fa493a4d7e02$export$290f3472231a2ca1);
$parcel$export(module.exports, "isModifierRegex", () => $8a97fa493a4d7e02$export$56079d3966b6b26c);
$parcel$export(module.exports, "isComplexOperatorRegex", () => $8a97fa493a4d7e02$export$3f6ac43c2355116b);
$parcel$export(module.exports, "isWSRegex", () => $8a97fa493a4d7e02$export$b1b0fc0dc5c83a12);
$parcel$export(module.exports, "isIdentifierRegex", () => $8a97fa493a4d7e02$export$218cf3eb73c65394);
$parcel$export(module.exports, "isLogicalOperatorRegex", () => $8a97fa493a4d7e02$export$a46484930d6fa80f);
$parcel$export(module.exports, "isOperatorRegex", () => $8a97fa493a4d7e02$export$d48805fc5b137dc9);
/**
 * Token types
 */ const $8a97fa493a4d7e02$export$e92b897d610f2aba = [
    'WHITE_SPACE',
    'SEPARATOR',
    'IDENTIFIER',
    'MODIFIER',
    'KEYWORD',
    'LOGICAL_OPERATOR',
    'STRING_LITERAL',
    'NUMBER_LITERAL',
    'BOOLEAN_LITERAL',
    'NULL_LITERAL',
    'OPERATOR'
];
const $8a97fa493a4d7e02$export$9ce7f372949a1546 = '(';
const $8a97fa493a4d7e02$export$bbbb3f477a9839e0 = ')';
const $8a97fa493a4d7e02$export$adbc66edc544fda9 = '=';
const $8a97fa493a4d7e02$export$fbd271ef020db0c = '!=';
const $8a97fa493a4d7e02$export$ea7497008076d6d2 = ':';
const $8a97fa493a4d7e02$export$6d44219c9e0c2567 = '!:';
const $8a97fa493a4d7e02$export$f8636d23c210043c = '<';
const $8a97fa493a4d7e02$export$1892bd0c818db570 = '<=';
const $8a97fa493a4d7e02$export$386b1ae18a32d690 = '>';
const $8a97fa493a4d7e02$export$44a62afa61d82568 = '>=';
const $8a97fa493a4d7e02$export$e75c84803c67e1f4 = [
    $8a97fa493a4d7e02$export$adbc66edc544fda9,
    $8a97fa493a4d7e02$export$f8636d23c210043c,
    $8a97fa493a4d7e02$export$1892bd0c818db570,
    $8a97fa493a4d7e02$export$386b1ae18a32d690,
    $8a97fa493a4d7e02$export$44a62afa61d82568
];
const $8a97fa493a4d7e02$export$61308b2610174a70 = 'AND';
const $8a97fa493a4d7e02$export$1de654320eb3e523 = 'OR';
const $8a97fa493a4d7e02$export$184522872a5410fc = 'not';
const $8a97fa493a4d7e02$export$ff7eed6ac2251302 = 'true';
const $8a97fa493a4d7e02$export$4b436fec6f13b741 = 'false';
const $8a97fa493a4d7e02$export$8cbc171ac4843075 = [
    $8a97fa493a4d7e02$export$ff7eed6ac2251302,
    $8a97fa493a4d7e02$export$4b436fec6f13b741
];
const $8a97fa493a4d7e02$export$347c7cb6285a1d61 = '"';
const $8a97fa493a4d7e02$export$d84ab70dc909b702 = "'";
const $8a97fa493a4d7e02$export$910131ff5cd3d496 = `${$8a97fa493a4d7e02$export$347c7cb6285a1d61}open${$8a97fa493a4d7e02$export$347c7cb6285a1d61}`;
const $8a97fa493a4d7e02$export$2aa0d26cb4549272 = `${$8a97fa493a4d7e02$export$347c7cb6285a1d61}closed${$8a97fa493a4d7e02$export$347c7cb6285a1d61}`;
const $8a97fa493a4d7e02$export$572cec90aa166025 = `${$8a97fa493a4d7e02$export$347c7cb6285a1d61}acknowledged${$8a97fa493a4d7e02$export$347c7cb6285a1d61}`;
const $8a97fa493a4d7e02$export$f94109650ec67751 = `${$8a97fa493a4d7e02$export$347c7cb6285a1d61}snoozed${$8a97fa493a4d7e02$export$347c7cb6285a1d61}`;
const $8a97fa493a4d7e02$export$3a3a37e9da45a2a4 = [
    $8a97fa493a4d7e02$export$910131ff5cd3d496,
    $8a97fa493a4d7e02$export$2aa0d26cb4549272,
    $8a97fa493a4d7e02$export$572cec90aa166025,
    $8a97fa493a4d7e02$export$f94109650ec67751
];
const $8a97fa493a4d7e02$export$928c1edd572e94f0 = 'P1';
const $8a97fa493a4d7e02$export$22202070e5f64c55 = 'P2';
const $8a97fa493a4d7e02$export$537865d58d2072a3 = 'P3';
const $8a97fa493a4d7e02$export$3d5cfea3feefee83 = 'P4';
const $8a97fa493a4d7e02$export$fe945cac89cd21a5 = 'P5';
const $8a97fa493a4d7e02$export$9ef3f42fa10fce44 = [
    $8a97fa493a4d7e02$export$928c1edd572e94f0,
    $8a97fa493a4d7e02$export$22202070e5f64c55,
    $8a97fa493a4d7e02$export$537865d58d2072a3,
    $8a97fa493a4d7e02$export$3d5cfea3feefee83,
    $8a97fa493a4d7e02$export$fe945cac89cd21a5
];
const $8a97fa493a4d7e02$export$c2b6d31a7a2d40ba = 'null';
const $8a97fa493a4d7e02$export$5a484b762b542c13 = 'actions';
const $8a97fa493a4d7e02$export$21c480ed86e9d13 = 'alias';
const $8a97fa493a4d7e02$export$534c195089710c34 = 'closedBy';
const $8a97fa493a4d7e02$export$4699ad3805947d4d = 'count';
const $8a97fa493a4d7e02$export$7c3401d7874d69f5 = 'createdAt';
const $8a97fa493a4d7e02$export$afffcbd5b444e040 = 'description';
const $8a97fa493a4d7e02$export$e1e61c3bf43fff11 = 'details.key';
const $8a97fa493a4d7e02$export$aa35da9746edbfe2 = 'details.value';
const $8a97fa493a4d7e02$export$b620b7163533b409 = 'detailsPair';
const $8a97fa493a4d7e02$export$2a30b5099ba66c99 = 'entity';
const $8a97fa493a4d7e02$export$2bfb49435a331d16 = 'integration.name';
const $8a97fa493a4d7e02$export$feced558810f4b3e = 'integration.type';
const $8a97fa493a4d7e02$export$7926b4c2836db847 = 'isSeen';
const $8a97fa493a4d7e02$export$5a8895646b1d5248 = 'message';
const $8a97fa493a4d7e02$export$4047502bdab1e205 = 'owner';
const $8a97fa493a4d7e02$export$5922c06b76ebb57d = 'priority';
const $8a97fa493a4d7e02$export$1122634b5d555f05 = 'components';
const $8a97fa493a4d7e02$export$ec912454cd7d858a = 'services';
const $8a97fa493a4d7e02$export$44673ddac1790242 = 'responders';
const $8a97fa493a4d7e02$export$f250d53474e801dc = 'source';
const $8a97fa493a4d7e02$export$43181828ba8680e4 = 'status';
const $8a97fa493a4d7e02$export$a1959e1b76e880dd = 'sync.name';
const $8a97fa493a4d7e02$export$8417ff61f7a57db6 = 'sync.type';
const $8a97fa493a4d7e02$export$8242733866920892 = 'tags';
const $8a97fa493a4d7e02$export$c833829cf31052f0 = 'tinyId';
const $8a97fa493a4d7e02$export$78d4faf48faf13c2 = 'updatedAt';
const $8a97fa493a4d7e02$export$5f1e5c89a704810f = 'acknowledged';
const $8a97fa493a4d7e02$export$89d93eb7117999c0 = 'acknowledgedBy';
const $8a97fa493a4d7e02$export$1ee0ad656333fc23 = 'aggregatorIds';
const $8a97fa493a4d7e02$export$d42da2034504d6de = 'alertId';
const $8a97fa493a4d7e02$export$8464a15b62fb09bb = 'alertType';
const $8a97fa493a4d7e02$export$2f7ba2848fc019c6 = 'encrypted';
const $8a97fa493a4d7e02$export$86e4b68c61c8cca5 = 'encryptionId';
const $8a97fa493a4d7e02$export$cd9dc7ab4d04d11c = 'lastOccurredAt';
const $8a97fa493a4d7e02$export$8508b76d4c14d7e = 'notify';
const $8a97fa493a4d7e02$export$e73ddf8d219f28b7 = 'snoozedUntil';
const $8a97fa493a4d7e02$export$a79eb1864dd7b745 = 'teams';
const $8a97fa493a4d7e02$export$888a9cda49b5e18c = [
    $8a97fa493a4d7e02$export$5f1e5c89a704810f,
    $8a97fa493a4d7e02$export$89d93eb7117999c0,
    $8a97fa493a4d7e02$export$1ee0ad656333fc23,
    $8a97fa493a4d7e02$export$d42da2034504d6de,
    $8a97fa493a4d7e02$export$8464a15b62fb09bb,
    $8a97fa493a4d7e02$export$2f7ba2848fc019c6,
    $8a97fa493a4d7e02$export$86e4b68c61c8cca5,
    $8a97fa493a4d7e02$export$cd9dc7ab4d04d11c,
    $8a97fa493a4d7e02$export$8508b76d4c14d7e,
    $8a97fa493a4d7e02$export$e73ddf8d219f28b7,
    $8a97fa493a4d7e02$export$a79eb1864dd7b745,
    $8a97fa493a4d7e02$export$5a484b762b542c13,
    $8a97fa493a4d7e02$export$21c480ed86e9d13,
    $8a97fa493a4d7e02$export$534c195089710c34,
    $8a97fa493a4d7e02$export$4699ad3805947d4d,
    $8a97fa493a4d7e02$export$7c3401d7874d69f5,
    $8a97fa493a4d7e02$export$afffcbd5b444e040,
    $8a97fa493a4d7e02$export$e1e61c3bf43fff11,
    $8a97fa493a4d7e02$export$aa35da9746edbfe2,
    $8a97fa493a4d7e02$export$b620b7163533b409,
    $8a97fa493a4d7e02$export$2a30b5099ba66c99,
    $8a97fa493a4d7e02$export$2bfb49435a331d16,
    $8a97fa493a4d7e02$export$feced558810f4b3e,
    $8a97fa493a4d7e02$export$7926b4c2836db847,
    $8a97fa493a4d7e02$export$5a8895646b1d5248,
    $8a97fa493a4d7e02$export$4047502bdab1e205,
    $8a97fa493a4d7e02$export$5922c06b76ebb57d,
    $8a97fa493a4d7e02$export$44673ddac1790242,
    $8a97fa493a4d7e02$export$1122634b5d555f05,
    $8a97fa493a4d7e02$export$ec912454cd7d858a,
    $8a97fa493a4d7e02$export$f250d53474e801dc,
    $8a97fa493a4d7e02$export$43181828ba8680e4,
    $8a97fa493a4d7e02$export$a1959e1b76e880dd,
    $8a97fa493a4d7e02$export$8417ff61f7a57db6,
    $8a97fa493a4d7e02$export$8242733866920892,
    $8a97fa493a4d7e02$export$c833829cf31052f0,
    $8a97fa493a4d7e02$export$78d4faf48faf13c2
];
const $8a97fa493a4d7e02$export$60745b712d37edf9 = [
    $8a97fa493a4d7e02$export$5f1e5c89a704810f,
    $8a97fa493a4d7e02$export$7926b4c2836db847
];
const $8a97fa493a4d7e02$export$b38df7dc61d42293 = [
    ...$8a97fa493a4d7e02$export$888a9cda49b5e18c
];
/**
 * Regex definitions
 */ // The main regex to split any given query into smaller tokens.
// Please be aware that token order has a meaning here.
const $8a97fa493a4d7e02$var$splitToTokensCases = [
    // 1. Split single and double quotes
    ...[
        $8a97fa493a4d7e02$export$d84ab70dc909b702,
        $8a97fa493a4d7e02$export$347c7cb6285a1d61
    ].map((i)=>`(${i}.*?${i})`),
    ...[
        $8a97fa493a4d7e02$export$d84ab70dc909b702,
        $8a97fa493a4d7e02$export$347c7cb6285a1d61
    ].map((i)=>`(${i}.*)`),
    // 2. Split operators and separators
    ...[
        $8a97fa493a4d7e02$export$9ce7f372949a1546,
        $8a97fa493a4d7e02$export$bbbb3f477a9839e0,
        $8a97fa493a4d7e02$export$adbc66edc544fda9,
        $8a97fa493a4d7e02$export$fbd271ef020db0c,
        $8a97fa493a4d7e02$export$ea7497008076d6d2,
        $8a97fa493a4d7e02$export$6d44219c9e0c2567,
        $8a97fa493a4d7e02$export$44a62afa61d82568,
        $8a97fa493a4d7e02$export$386b1ae18a32d690,
        $8a97fa493a4d7e02$export$1892bd0c818db570,
        $8a97fa493a4d7e02$export$f8636d23c210043c
    ].map((i)=>`(\\${i})`),
    // 3. Split the exact keywords when it's a known literal
    // Known issue: The word boundary in the beginning does not capture letters except latin chars, digits and underscore, i.e. "+and" results to STRING_LITERAL + BOOLEAN_LITERAL
    ...[
        $8a97fa493a4d7e02$export$61308b2610174a70,
        $8a97fa493a4d7e02$export$1de654320eb3e523,
        $8a97fa493a4d7e02$export$ff7eed6ac2251302,
        $8a97fa493a4d7e02$export$4b436fec6f13b741,
        $8a97fa493a4d7e02$export$184522872a5410fc,
        `is\\s*null`,
        `is\\s*not\\s*null`
    ].map((i)=>`(\\b${i}(?=\\s|$))`),
    // 4. Empty spaces
    '(\\s+)'
];
const $8a97fa493a4d7e02$export$28041d1d2a85f002 = new RegExp($8a97fa493a4d7e02$var$splitToTokensCases.join('|'), 'gi');
const $8a97fa493a4d7e02$export$290f3472231a2ca1 = /^(is(  *)not(  *)null)$|^(is(  *)null)$/i;
const $8a97fa493a4d7e02$export$56079d3966b6b26c = /^not$/i;
const $8a97fa493a4d7e02$export$3f6ac43c2355116b = /^<=$|^>=$|^!=$|^!:$/;
const $8a97fa493a4d7e02$export$b1b0fc0dc5c83a12 = /^\s+$/;
const $8a97fa493a4d7e02$export$218cf3eb73c65394 = new RegExp($8a97fa493a4d7e02$export$b38df7dc61d42293.map((i)=>`^${i}$`).join('|'));
const $8a97fa493a4d7e02$export$a46484930d6fa80f = /^and$|^or$/i;
const $8a97fa493a4d7e02$export$d48805fc5b137dc9 = /^[=:<>]$/;

});

parcelRegister("cM3YM", function(module, exports) {

$parcel$export(module.exports, "OpsgenieSavedSearchAri", () => $94cd0dec7afb09eb$export$1dc7f741fb628a10);

var $47ByP = parcelRequire("47ByP");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/opsgenie/saved-search/manifest.ts
var $94cd0dec7afb09eb$var$opsgenieSavedSearchAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $47ByP.OpsgenieSavedSearchAriResourceOwner),
    resourceType: (0, $47ByP.OpsgenieSavedSearchAriResourceType),
    resourceIdSlug: "{workspaceId}/{savedSearchId}",
    resourceIdSegmentFormats: {
        workspaceId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        savedSearchId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/opsgenie/saved-search/index.ts
var $94cd0dec7afb09eb$export$1dc7f741fb628a10 = class _OpsgenieSavedSearchAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._workspaceId = opts.resourceIdSegmentValues.workspaceId, this._savedSearchId = opts.resourceIdSegmentValues.savedSearchId;
    }
    get workspaceId() {
        return this._workspaceId;
    }
    get savedSearchId() {
        return this._savedSearchId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $94cd0dec7afb09eb$var$opsgenieSavedSearchAriStaticOpts.qualifier,
            platformQualifier: $94cd0dec7afb09eb$var$opsgenieSavedSearchAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $94cd0dec7afb09eb$var$opsgenieSavedSearchAriStaticOpts.resourceOwner,
            resourceType: $94cd0dec7afb09eb$var$opsgenieSavedSearchAriStaticOpts.resourceType,
            resourceId: `${opts.workspaceId}/${opts.savedSearchId}`,
            resourceIdSegmentValues: {
                workspaceId: opts.workspaceId,
                savedSearchId: opts.savedSearchId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $94cd0dec7afb09eb$var$opsgenieSavedSearchAriStaticOpts);
        return new _OpsgenieSavedSearchAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $94cd0dec7afb09eb$var$opsgenieSavedSearchAriStaticOpts);
        return new _OpsgenieSavedSearchAri(opts);
    }
    getVariables() {
        return {
            workspaceId: this.workspaceId,
            savedSearchId: this.savedSearchId
        };
    }
};

});
parcelRegister("47ByP", function(module, exports) {

$parcel$export(module.exports, "OpsgenieSavedSearchAriResourceOwner", () => $3004f3ab9c3d798b$export$7416cc1df15f6b85);
$parcel$export(module.exports, "OpsgenieSavedSearchAriResourceType", () => $3004f3ab9c3d798b$export$1db52fe39936618e);
// src/opsgenie/saved-search/types.ts
var $3004f3ab9c3d798b$export$7416cc1df15f6b85 = "opsgenie", $3004f3ab9c3d798b$export$1db52fe39936618e = "saved-search";

});


parcelRegister("gtYPY", function(module, exports) {

$parcel$export(module.exports, "SavedSearchActionButtons", () => $aec190113be184ad$export$78ee2939aff842cb);

var $5uXOq = parcelRequire("5uXOq");

var $hUqzg = parcelRequire("hUqzg");

var $kJpBP = parcelRequire("kJpBP");
var $9UCCQ = parcelRequire("9UCCQ");

var $cM3YM = parcelRequire("cM3YM");

var $1a6oa = parcelRequire("1a6oa");

var $6IJKZ = parcelRequire("6IJKZ");
var $aQd57 = parcelRequire("aQd57");

var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");





var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $9eeFp = parcelRequire("9eeFp");

var $aCS3f = parcelRequire("aCS3f");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");


var $dfzUf = parcelRequire("dfzUf");
const $aec190113be184ad$export$78ee2939aff842cb = ({ onClose: onClose, savedSearch: savedSearch })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCS3f.MoreNavMenuButton), {
        onOpen: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$b887e88d8d0739f6),
                actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                    level: (0, $951a0ed422513987$export$f9db6a58b4aabd18),
                    itemId: (0, $496585bee7985bb9$export$a65812b4aab631bb),
                    parentItemType: 'savedSearch',
                    parentItemId: savedSearch.id
                }
            });
        },
        MenuItems: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aec190113be184ad$var$MoreMenuItems, {
                ...props,
                savedSearch: savedSearch
            }),
        onClose: onClose
    });
};
const $aec190113be184ad$var$MoreMenuItems = ({ onClose: onClose, savedSearch: savedSearch })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [modalType, setModalType] = (0, $5uXOq.useState)(undefined);
    const onCloseWithStopPropagation = (0, $9eeFp.useStopPropagation)(onClose);
    const { removeSavedSearchFromCreatedByMe: removeSavedSearchFromCreatedByMe } = (0, $aQd57.useSavedSearchRelayUtils)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const deleteSavedSearch = (0, $5uXOq.useCallback)((e)=>{
        setIsLoading(true);
        const savedSearchId = (0, $cM3YM.OpsgenieSavedSearchAri).parse(savedSearch.id).savedSearchId;
        (0, $6IJKZ.deleteSearchEndpoint)(savedSearchId).then(()=>{
            removeSavedSearchFromCreatedByMe(savedSearch.id);
        }).catch(()=>{
            showFlag({
                key: (0, $7HGHK.toFlagId)((0, $f4d30246a2d1df81$export$337d30e19f17af0f)),
                type: 'error',
                title: (0, $dfzUf.default).errorTitle,
                description: (0, $dfzUf.default).errorMessage,
                messageId: 'navigation-apps-sidebar-nav4-sidebars-content-operations.ui.alerts-content.alerts-menu-item.action-button.show-flag.error',
                messageType: 'transactional'
            });
        }).finally(()=>{
            setIsLoading(false);
            if (onClose) onClose(e);
        });
    }, [
        savedSearch,
        onClose,
        removeSavedSearchFromCreatedByMe,
        showFlag
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hUqzg))), {
            LEGACY_size: "small",
            color: "var(--ds-icon-danger, #C9372C)",
            label: ""
        }),
        onClick: (e)=>{
            e.preventDefault();
            setModalType('delete');
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$64fed82162bd367),
                actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $1e554a683893bd46$export$56981f28056f258e),
                    level: (0, $951a0ed422513987$export$35ac629b8b943d5a),
                    itemId: 'deleteSavedSearch',
                    parentItemType: 'savedSearch',
                    parentItemId: savedSearch.id
                }
            });
        }
    }, formatMessage((0, $dfzUf.default).deleteSavedSearch))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1a6oa.DeleteModal), {
        messageDescriptors: {
            title: (0, $dfzUf.default).confirmTrashHeading,
            description: (0, $dfzUf.default).confirmTrashMessage
        },
        isDeleteDialogOpen: modalType === 'delete',
        onDeleteAttemptCancel: onCloseWithStopPropagation,
        isLoading: isLoading,
        onDelete: (e)=>deleteSavedSearch(e)
    }));
};

});
parcelRegister("hUqzg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aba66ada45c058f49805b51f0ffb84ff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d09c4671709f5c19$var$_react = $d09c4671709f5c19$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d09c4671709f5c19$var$_delete = $d09c4671709f5c19$var$_interopRequireDefault((parcelRequire("4IrpZ")));

var $d09c4671709f5c19$var$_trash = $d09c4671709f5c19$var$_interopRequireDefault((parcelRequire("3fOYK")));
function $d09c4671709f5c19$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DeleteIcon.
 * This component is DeleteIcon, with `UNSAFE_fallbackIcon` set to "TrashIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing or deleting an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d09c4671709f5c19$var$DeleteIcon = (props)=>/*#__PURE__*/ $d09c4671709f5c19$var$_react.default.createElement($d09c4671709f5c19$var$_delete.default, Object.assign({
        LEGACY_fallbackIcon: $d09c4671709f5c19$var$_trash.default
    }, props));
$d09c4671709f5c19$var$DeleteIcon.Name = 'DeleteIconMigration';
var $d09c4671709f5c19$var$_default = module.exports.default = $d09c4671709f5c19$var$DeleteIcon;

});
parcelRegister("3fOYK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25ea512a3c153cf8$var$_react = $25ea512a3c153cf8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $25ea512a3c153cf8$var$_delete = $25ea512a3c153cf8$var$_interopRequireDefault((parcelRequire("4IrpZ")));
function $25ea512a3c153cf8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $25ea512a3c153cf8$var$TrashIcon = (props)=>/*#__PURE__*/ $25ea512a3c153cf8$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5 5a1 1 0 0 0-1 1v1h16V6a1 1 0 0 0-1-1zm11.15 15h-8.3a1 1 0 0 1-.99-.83L5 8h14l-1.86 11.17a1 1 0 0 1-.99.83M9 4.5a.5.5 0 0 1 .49-.5h5.02a.5.5 0 0 1 .49.5V5H9z"/></svg>`
    }, props, {
        newIcon: $25ea512a3c153cf8$var$_delete.default
    }));
$25ea512a3c153cf8$var$TrashIcon.displayName = 'TrashIcon';
var $25ea512a3c153cf8$var$_default = module.exports.default = $25ea512a3c153cf8$var$TrashIcon;

});


parcelRegister("1a6oa", function(module, exports) {

$parcel$export(module.exports, "DeleteModal", () => $cced2403e06280a2$export$73392e09138fecd6);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $fVnbM = parcelRequire("fVnbM");
var $2rqOp = parcelRequire("2rqOp");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");
var $i8Qvm = parcelRequire("i8Qvm");

var $kWK4V = parcelRequire("kWK4V");
const $cced2403e06280a2$export$73392e09138fecd6 = ({ isDeleteDialogOpen: isDeleteDialogOpen, onDeleteAttemptCancel: onDeleteAttemptCancel, onDelete: onDelete, isLoading: isLoading, messageDescriptors: messageDescriptors, returnFocusRef: returnFocusRef })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i8Qvm.default), {
        children: isDeleteDialogOpen && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $1R1Ge.default), {
            shouldCloseOnOverlayClick: !isLoading,
            onClose: onDeleteAttemptCancel,
            shouldReturnFocus: returnFocusRef,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jgVsb.default), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gofOI.default), {
                        appearance: "danger",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...messageDescriptors.title
                        })
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7QSqG.default), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...messageDescriptors.description
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $juxqI.default), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                            isDisabled: isLoading,
                            appearance: "subtle",
                            onClick: onDeleteAttemptCancel,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                ...(0, $kWK4V.messages).cancelButton
                            })
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2rqOp.default), {
                            appearance: "danger",
                            onClick: onDelete,
                            autoFocus: true,
                            isLoading: isLoading,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                ...(0, $kWK4V.messages).deleteButton
                            })
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("kWK4V", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1a237904e75f23fb$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $1a237904e75f23fb$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    cancelButton: {
        id: 'eoc.alert-detail.delete-modal.cancel-button.no-translate',
        defaultMessage: 'Cancel',
        description: 'The text will be displayed in the delete modal footer for cancel button.'
    },
    deleteButton: {
        id: 'eoc.alert-detail.extra-property.delete-modal.delete-button.no-translate',
        defaultMessage: 'Delete',
        description: 'The text will be displayed in the delete modal footer for delete button.'
    }
});

});


parcelRegister("6IJKZ", function(module, exports) {

$parcel$export(module.exports, "getSavedSearchesEndpoint", () => $2b3a64f0a6563850$export$3b7b44889eb94cd0);
$parcel$export(module.exports, "createSavedSearchEndpoint", () => $2b3a64f0a6563850$export$4976332c0ec66407);
$parcel$export(module.exports, "deleteSearchEndpoint", () => $2b3a64f0a6563850$export$401da4a793944201);

var $j74qU = parcelRequire("j74qU");
const $2b3a64f0a6563850$export$3b7b44889eb94cd0 = ()=>{
    return (0, $j74qU.eocFetch)('/v1/alerts/saved-searches');
};
const $2b3a64f0a6563850$export$4976332c0ec66407 = (data)=>{
    return (0, $j74qU.eocFetch)('/v1/alerts/saved-searches', {
        method: 'POST',
        body: data
    });
};
const $2b3a64f0a6563850$export$401da4a793944201 = (id)=>{
    return (0, $j74qU.eocFetch)(`/v1/alerts/saved-searches/${id}`, {
        method: 'DELETE',
        responseType: 'headers'
    });
};

});

parcelRegister("aQd57", function(module, exports) {

$parcel$export(module.exports, "useSavedSearchRelayUtils", () => $3d73dcd807f3f6b7$export$e07c40a7acca4305);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $cM3YM = parcelRequire("cM3YM");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $030R0 = parcelRequire("030R0");

var $1Z10l = parcelRequire("1Z10l");
const $3d73dcd807f3f6b7$export$e07c40a7acca4305 = ()=>{
    const relayEnvironment = (0, $8Uumt.useRelayEnvironment)();
    const cloudId = (0, $030R0.getMeta)('ajs-cloud-id') ?? (0, $1Z10l.getCloudIdForDevEnvironment)();
    (0, $hmVmJ.assert)(!!cloudId, new (0, $dH6Pi.AssertionError)('cloudId', 'useSavedSarchRelayUtils: cloudId is undefined'));
    const removeSavedSearch = (0, $5uXOq.useCallback)((savedSearchId, key)=>{
        (0, $8Uumt.commitLocalUpdate)(relayEnvironment, (store)=>{
            const root = store.getRoot();
            const opsgenieRecord = root.getLinkedRecord('opsgenie');
            if (opsgenieRecord) {
                const savedSearches = opsgenieRecord.getLinkedRecord('savedSearches', {
                    cloudId: cloudId
                });
                if (savedSearches) {
                    const removeItem = savedSearches.getLinkedRecords(key);
                    if (removeItem) {
                        const filteredItems = removeItem.filter((record)=>record.getValue('id') !== savedSearchId);
                        savedSearches.setLinkedRecords(filteredItems, key);
                    }
                }
            }
        });
    }, [
        cloudId,
        relayEnvironment
    ]);
    const addSavedSearch = (0, $5uXOq.useCallback)((savedSearch, key)=>{
        (0, $8Uumt.commitLocalUpdate)(relayEnvironment, (store)=>{
            const newSavedSearchId = (0, $cM3YM.OpsgenieSavedSearchAri).create({
                workspaceId: cloudId,
                savedSearchId: savedSearch.id
            }).toString();
            const newSavedSearch = store.create(newSavedSearchId, 'OpsgenieSavedSearch');
            newSavedSearch.setValue(newSavedSearchId, 'id');
            newSavedSearch.setValue(savedSearch.name, 'name');
            newSavedSearch.setValue(savedSearch.query, 'alertSearchQuery');
            const root = store.getRoot();
            const opsgenieRecord = root.getLinkedRecord('opsgenie');
            if (opsgenieRecord) {
                const savedSearches = opsgenieRecord.getLinkedRecord('savedSearches', {
                    cloudId: cloudId
                });
                if (savedSearches) {
                    const savedSearchesList = savedSearches.getLinkedRecords(key) || [];
                    const updatedSavedSearches = [
                        ...savedSearchesList,
                        newSavedSearch
                    ];
                    savedSearches.setLinkedRecords(updatedSavedSearches, key);
                }
            }
        });
    }, [
        cloudId,
        relayEnvironment
    ]);
    const addSavedSearchToCreatedByMe = (0, $5uXOq.useCallback)((savedSearch)=>{
        addSavedSearch(savedSearch, 'createdByMe');
    }, [
        addSavedSearch
    ]);
    const removeSavedSearchFromCreatedByMe = (0, $5uXOq.useCallback)((savedSearchId)=>{
        removeSavedSearch(savedSearchId, 'createdByMe');
    }, [
        removeSavedSearch
    ]);
    return {
        addSavedSearchToCreatedByMe: addSavedSearchToCreatedByMe,
        removeSavedSearchFromCreatedByMe: removeSavedSearchFromCreatedByMe
    };
};

});
parcelRegister("1Z10l", function(module, exports) {

$parcel$export(module.exports, "validateTimeInput", () => $63876a0dc22d7edb$export$8880da3ae4274888);
$parcel$export(module.exports, "validateBetweenInput", () => $63876a0dc22d7edb$export$57c3e855fbf300fa);
$parcel$export(module.exports, "isInvalidDateValue", () => $63876a0dc22d7edb$export$f18cd4bc58b99a27);
$parcel$export(module.exports, "removeQuotes", () => $63876a0dc22d7edb$export$dd2bdf5049bf0915);
$parcel$export(module.exports, "withQuote", () => $63876a0dc22d7edb$export$8708814d32e406db);
$parcel$export(module.exports, "calculateTimes", () => $63876a0dc22d7edb$export$b362bc6892126b7a);
$parcel$export(module.exports, "getDefaultFilterQuery", () => $63876a0dc22d7edb$export$16cce822d8159876);
$parcel$export(module.exports, "isResponderAlert", () => $63876a0dc22d7edb$export$78656db4ffc3ccd8);
$parcel$export(module.exports, "isGroupAlert", () => $63876a0dc22d7edb$export$be2243d4df51c704);
$parcel$export(module.exports, "withAIOpsDomainPrefix", () => $63876a0dc22d7edb$export$81c70e0016508593);
$parcel$export(module.exports, "getCloudIdForDevEnvironment", () => $63876a0dc22d7edb$export$fc6ce7ac2248d7f5);

var $jovBr = parcelRequire("jovBr");

var $eZDAP = parcelRequire("eZDAP");

var $gn1v9 = parcelRequire("gn1v9");

var $030R0 = parcelRequire("030R0");

var $j6OA2 = parcelRequire("j6OA2");
var $39KIs = parcelRequire("39KIs");

var $5F4Xi = parcelRequire("5F4Xi");

var $6cAn5 = parcelRequire("6cAn5");
const $63876a0dc22d7edb$export$8880da3ae4274888 = (intl, timeDigits, timeUnit)=>{
    if (!timeDigits) return;
    const timeDigitsNumber = parseInt(timeDigits);
    if (isNaN(timeDigitsNumber)) return intl.formatMessage((0, $5F4Xi.default).validNumber);
    if (timeUnit === 'hours' && (timeDigitsNumber < 1 || timeDigitsNumber > 99999)) return intl.formatMessage((0, $5F4Xi.default).hoursNotInRange);
    if (timeUnit === 'days' && (timeDigitsNumber < 1 || timeDigitsNumber > 9999)) return intl.formatMessage((0, $5F4Xi.default).daysNotInRange);
    if (timeUnit === 'weeks' && (timeDigitsNumber < 1 || timeDigitsNumber > 999)) return intl.formatMessage((0, $5F4Xi.default).weeksNotInRange);
    if (timeUnit === 'months' && (timeDigitsNumber < 1 || timeDigitsNumber > 99)) return intl.formatMessage((0, $5F4Xi.default).monthsNotInRange);
    if (timeUnit === 'years' && (timeDigitsNumber < 1 || timeDigitsNumber > 9)) return intl.formatMessage((0, $5F4Xi.default).yearsNotInRange);
};
const $63876a0dc22d7edb$export$57c3e855fbf300fa = (intl, value)=>{
    if (value) {
        const { startDate: startDate, endDate: endDate } = value;
        if (!startDate && !endDate) return;
        if (startDate && endDate && new Date(startDate) > new Date(endDate)) return intl.formatMessage((0, $5F4Xi.default).validationMessageBeforeGreaterThanAfter);
        if (value && (startDate !== '' && !(0, $jovBr.default)(new Date(startDate)) || endDate !== '' && !(0, $jovBr.default)(new Date(endDate)))) return intl.formatMessage((0, $5F4Xi.default).validationMessageInvalidDateFormat);
    }
    return;
};
const $63876a0dc22d7edb$export$f18cd4bc58b99a27 = (value)=>{
    return !(0, $jovBr.default)((0, $eZDAP.default)(value)) && value !== '';
};
const $63876a0dc22d7edb$export$dd2bdf5049bf0915 = (value)=>{
    return value.replace(/^"(.*)"$/, '$1');
};
const $63876a0dc22d7edb$export$d4aae9ad13afd6c = (data)=>{
    return {
        ...data,
        label: data.name,
        value: data.id
    };
};
const $63876a0dc22d7edb$export$8708814d32e406db = (value)=>{
    if ((0, $j6OA2.hasSpaceRegEx).test(value) || (0, $j6OA2.hasColonRegex).test(value)) return `${0, $39KIs.STRING_LITERAL_DOUBLE_QUOTE}${value}${0, $39KIs.STRING_LITERAL_DOUBLE_QUOTE}`;
    else return value;
};
const $63876a0dc22d7edb$export$b362bc6892126b7a = (time)=>{
    if (!time) return {
        from: undefined,
        to: undefined
    };
    if (time.range === 'all') return {
        from: undefined,
        to: undefined
    };
    if (time.range === 'custom') return {
        from: time.from,
        to: time.to
    };
    const now = new Date();
    const subAmount = {
        [time.range]: time.value
    };
    return {
        from: (0, $gn1v9.default)(now, subAmount).getTime(),
        to: now.getTime()
    };
};
const $63876a0dc22d7edb$export$16cce822d8159876 = (query, teamId)=>{
    if (teamId) {
        if (query) return `${0, $39KIs.IDENTIFIER_RESPONDERS}: ${teamId} ${0, $39KIs.LOGICAL_OPERATOR_AND} ${query}`;
        return `${0, $39KIs.IDENTIFIER_RESPONDERS}: ${teamId}`;
    }
    return query;
};
const $63876a0dc22d7edb$export$78656db4ffc3ccd8 = (alert)=>alert && alert.alertType === 'responder';
const $63876a0dc22d7edb$export$be2243d4df51c704 = (alert)=>alert.entityType === 'group';
const $63876a0dc22d7edb$export$81c70e0016508593 = (input)=>{
    const cloudId = (0, $030R0.getMeta)('ajs-cloud-id');
    if (cloudId) return `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input;
    return input;
};
const $63876a0dc22d7edb$var$isDevEnvironment = ()=>{
    return typeof $6cAn5 !== 'undefined' && ($6cAn5?.env?.STORYBOOK === 'true' || $6cAn5?.env?.NODE_ENV === 'development') || window.location.hostname === 'localhost';
};
const $63876a0dc22d7edb$export$fc6ce7ac2248d7f5 = ()=>{
    if ($63876a0dc22d7edb$var$isDevEnvironment()) return 'abc-def-ghi-jkl';
    return undefined;
};

});
parcelRegister("j6OA2", function(module, exports) {

$parcel$export(module.exports, "TAB_KEY", () => $2bdcdc7877436b61$export$da8c7facc28740b1);
$parcel$export(module.exports, "ENTER_KEY", () => $2bdcdc7877436b61$export$4162dbd8c730437);
$parcel$export(module.exports, "ESCAPE_KEY", () => $2bdcdc7877436b61$export$728705b4513abbb5);
$parcel$export(module.exports, "SPACE_KEY", () => $2bdcdc7877436b61$export$a47625ee19580f99);
$parcel$export(module.exports, "LEFT_KEY", () => $2bdcdc7877436b61$export$ba950c21a0561bed);
$parcel$export(module.exports, "UP_KEY", () => $2bdcdc7877436b61$export$16859d5882a95fea);
$parcel$export(module.exports, "RIGHT_KEY", () => $2bdcdc7877436b61$export$4b96cad863d88376);
$parcel$export(module.exports, "DOWN_KEY", () => $2bdcdc7877436b61$export$fc0cf2556509233e);
$parcel$export(module.exports, "SUGGESTION_CARD_Y_POS", () => $2bdcdc7877436b61$export$87b2b08fc4c97f78);
$parcel$export(module.exports, "hasSpaceRegEx", () => $2bdcdc7877436b61$export$a07ca273fbeffcb8);
$parcel$export(module.exports, "hasStartingQuotesRegex", () => $2bdcdc7877436b61$export$a3aaedcec21ac282);
$parcel$export(module.exports, "hasEndingQuotesRegex", () => $2bdcdc7877436b61$export$e5ad519d04ef012a);
$parcel$export(module.exports, "hasNewLinesRegex", () => $2bdcdc7877436b61$export$7645e556e9948ecd);
$parcel$export(module.exports, "EMAIL_REGEX", () => $2bdcdc7877436b61$export$7b7637218245c8a);
$parcel$export(module.exports, "hasColonRegex", () => $2bdcdc7877436b61$export$65a2b373cb60e599);
const $2bdcdc7877436b61$export$da8c7facc28740b1 = 'Tab';
const $2bdcdc7877436b61$export$4162dbd8c730437 = 'Enter';
const $2bdcdc7877436b61$export$728705b4513abbb5 = 'Escape';
const $2bdcdc7877436b61$export$a47625ee19580f99 = ' ';
const $2bdcdc7877436b61$export$ba950c21a0561bed = 'ArrowLeft';
const $2bdcdc7877436b61$export$16859d5882a95fea = 'ArrowUp';
const $2bdcdc7877436b61$export$4b96cad863d88376 = 'ArrowRight';
const $2bdcdc7877436b61$export$fc0cf2556509233e = 'ArrowDown';
const $2bdcdc7877436b61$export$87b2b08fc4c97f78 = 28;
const $2bdcdc7877436b61$export$a07ca273fbeffcb8 = /\s/;
const $2bdcdc7877436b61$export$8866d083cd03ffd7 = /^\s|\s$/;
const $2bdcdc7877436b61$export$a3aaedcec21ac282 = /^('|")/;
const $2bdcdc7877436b61$export$e5ad519d04ef012a = /('|")$/;
const $2bdcdc7877436b61$export$7645e556e9948ecd = /(\r\n|\n|\r)/gm;
const $2bdcdc7877436b61$export$7b7637218245c8a = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const $2bdcdc7877436b61$export$65a2b373cb60e599 = /:/;

});

parcelRegister("5F4Xi", function(module, exports) {

$parcel$export(module.exports, "default", () => $e43ae1f84d6f7300$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $e43ae1f84d6f7300$var$messages = (0, $7VHMR.defineMessages)({
    validationMessageBeforeGreaterThanAfter: {
        id: `eoc.alert-list.common.utils.validation-message-before-greater-than-after.no-translate`,
        defaultMessage: "'Before' field cannot be later than 'After' field.",
        description: 'Message displayed to the user when the Before date used is greater than the after date while specifying dates'
    },
    validationMessageInvalidDateFormat: {
        id: `eoc.alert-list.common.utils.validation-message-invalid-date-format.no-translate`,
        defaultMessage: 'Invalid date format.',
        description: 'Invalid date format.'
    },
    validNumber: {
        id: `eoc.alert-list.common.utils.validation-not-number.no-translate`,
        defaultMessage: 'Enter a valid number.',
        description: 'The error message that shown when user write different chars other than numeric chars.'
    },
    hoursNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-hours-not-in-range.no-translate`,
        defaultMessage: 'Enter a number between 1-99999.',
        description: 'Message displayed to the user when hours value is not in range'
    },
    daysNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-days-not-in-range.no-translate`,
        defaultMessage: 'Enter a number between 1-9999.',
        description: 'Message displayed to the user when days value is not in range'
    },
    weeksNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-weeks-not-in-range.no-translate`,
        defaultMessage: 'Enter a number between 1-999.',
        description: 'Message displayed to the user when weeks value is not in range'
    },
    monthsNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-months-not-in-range.no-translate`,
        defaultMessage: 'Enter a number between 1-99.',
        description: 'Message displayed to the user when months value is not in range'
    },
    yearsNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-years-not-in-range.no-translate`,
        defaultMessage: 'Enter a number between 1-9.',
        description: 'Message displayed to the user when years value is not in range'
    }
});
var $e43ae1f84d6f7300$export$2e2bcd8739ae039 = $e43ae1f84d6f7300$var$messages;

});



const $f4d30246a2d1df81$export$337d30e19f17af0f = 'fetchError';

parcelRegister("dfzUf", function(module, exports) {

$parcel$export(module.exports, "default", () => $57b524cf9eff8335$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $57b524cf9eff8335$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    deleteSavedSearch: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.alerts-content.alerts-menu-item.action-button.delete-saved-search",
        "defaultMessage": "Delete"
    },
    confirmTrashHeading: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.alerts-content.alerts-menu-item.action-button.confirm-trash-heading",
        "defaultMessage": "Delete saved search"
    },
    confirmTrashMessage: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.alerts-content.alerts-menu-item.action-button.confirm-trash-message",
        "defaultMessage": "Are you sure you want to delete this saved search?"
    },
    errorTitle: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.alerts-content.alerts-menu-item.action-button.error-title",
        "defaultMessage": "Error"
    },
    errorMessage: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.alerts-content.alerts-menu-item.action-button.error-message",
        "defaultMessage": "Something went wrong. Please try again."
    }
});

});



parcelRegister("ePmXi", function(module, exports) {

$parcel$export(module.exports, "AlertsMenuItemContentNew", () => $52a00eeba0ac60fa$export$f0f13aaf6210507e);

var $4gZTO = parcelRequire("4gZTO");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $6a9Wp = parcelRequire("6a9Wp");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $lnznH = parcelRequire("lnznH");
var $cZa9B = parcelRequire("cZa9B");

var $4R6GH = parcelRequire("4R6GH");

var $39KIs = parcelRequire("39KIs");

var $koVbs = parcelRequire("koVbs");




var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $lhMtU = parcelRequire("lhMtU");

var $c16H2 = parcelRequire("c16H2");

var $5FnJJ = parcelRequire("5FnJJ");

var $dQbFB = parcelRequire("dQbFB");

var $24a2m = parcelRequire("24a2m");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $90yGq = parcelRequire("90yGq");

var $l8ruj = parcelRequire("l8ruj");

var $lODMY = parcelRequire("lODMY");
var $ieDtd = parcelRequire("ieDtd");

var $cM3YM = parcelRequire("cM3YM");

var $cySG4 = parcelRequire("cySG4");

var $lUaB2 = parcelRequire("lUaB2");

var $fnZCh = parcelRequire("fnZCh");

var $9MLkJ = parcelRequire("9MLkJ");

var $7zFZv = parcelRequire("7zFZv");

var $8BItO = parcelRequire("8BItO");

var $9At5X = parcelRequire("9At5X");

var $gtYPY = parcelRequire("gtYPY");
function $52a00eeba0ac60fa$export$f0f13aaf6210507e({ queryRef: queryRef }) {
    const data = (0, $8Uumt.useFragment)((0, $4gZTO.default), queryRef);
    const [savedSearchIdFromURL] = (0, $ieDtd.useQueryParam)('filter');
    const [alertSearchQueryFromURL] = (0, $ieDtd.useQueryParam)('query');
    const [selectedFilter, setSelectedFilter] = (0, $5uXOq.useState)('');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const accountId = (0, $90yGq.useAccountId)();
    const [viewType] = (0, $ieDtd.useQueryParam)('view');
    const { icon: pagesIcon } = (0, $24a2m.useFormattedMessageAndIcon)((0, $9MLkJ.default).alerts, (0, (/*@__PURE__*/$parcel$interopDefault($6a9Wp))));
    const isAlertsRoute = (0, $lODMY.useIsActiveRoute)(new Set([
        (0, $lUaB2.eocGlobalAlertListRoute).name,
        (0, $fnZCh.eocTeamAlertDetailRoute).name
    ]));
    const { setLastVisitedSearch: setLastVisitedSearch } = (0, $8BItO.useAlertsPopoutStore)();
    const { sharedWithMe: sharedWithMe, createdByMe: createdByMe } = data?.opsgenie?.savedSearches || {};
    const defaultFilters = (0, $5uXOq.useMemo)(()=>[
            {
                id: 'all',
                name: formatMessage((0, $7zFZv.default).allSearch),
                alertSearchQuery: ''
            },
            {
                id: 'open',
                name: formatMessage((0, $7zFZv.default).openSearch),
                alertSearchQuery: `${(0, $39KIs.IDENTIFIER_STATUS)}${(0, $39KIs.OPERATOR_EQUAL_TO)} ${(0, $39KIs.STRING_LITERAL_STATUS_OPEN)}`
            },
            {
                id: 'closed',
                name: formatMessage((0, $7zFZv.default).closedSearch),
                alertSearchQuery: `${(0, $39KIs.IDENTIFIER_STATUS)}${(0, $39KIs.OPERATOR_EQUAL_TO)} ${(0, $39KIs.STRING_LITERAL_STATUS_CLOSED)}`
            },
            {
                id: 'unacked',
                name: formatMessage((0, $7zFZv.default).unackedSearch),
                alertSearchQuery: `${(0, $39KIs.IDENTIFIER_STATUS)}${(0, $39KIs.OPERATOR_EQUAL_TO)} ${(0, $39KIs.STRING_LITERAL_STATUS_OPEN)} ${(0, $39KIs.LOGICAL_OPERATOR_AND)} ${(0, $39KIs.IDENTIFIER_ACKNOWLEDGED)}${(0, $39KIs.OPERATOR_EQUAL_TO)} ${(0, $39KIs.BOOLEAN_LITERAL_FALSE)}`
            },
            {
                id: 'notSeen',
                name: formatMessage((0, $7zFZv.default).notSeenSearch),
                alertSearchQuery: `${(0, $39KIs.IDENTIFIER_IS_SEEN)}${(0, $39KIs.OPERATOR_EQUAL_TO)} ${(0, $39KIs.BOOLEAN_LITERAL_FALSE)}`
            },
            {
                id: 'assignedToMe',
                name: formatMessage((0, $7zFZv.default).assignedToMeSearch),
                alertSearchQuery: `${(0, $39KIs.IDENTIFIER_ASSIGNEE)}${(0, $39KIs.OPERATOR_EQUAL_TO)} "${accountId || 'me'}"`
            }
        ], [
        formatMessage,
        accountId
    ]);
    const defaultFilterMenuIds = $52a00eeba0ac60fa$var$getParentMenuId(defaultFilters);
    const defaultFilterWithComponentList = $52a00eeba0ac60fa$var$getComponentAddedSearchObjects(defaultFilters, pagesIcon, viewType, 'default', savedSearchIdFromURL, setSelectedFilter, createAnalyticsEvent, setLastVisitedSearch, isAlertsRoute);
    const sharedWithMeWithComponentList = $52a00eeba0ac60fa$var$getComponentAddedSearchObjects(sharedWithMe || [], pagesIcon, viewType, 'sharedWithMe', savedSearchIdFromURL, setSelectedFilter, createAnalyticsEvent, setLastVisitedSearch, isAlertsRoute);
    const createdByMeWithComponentList = $52a00eeba0ac60fa$var$getComponentAddedSearchObjects(createdByMe || [], pagesIcon, viewType, 'createdByMe', savedSearchIdFromURL, setSelectedFilter, createAnalyticsEvent, setLastVisitedSearch, isAlertsRoute);
    const allFiltersWithComponentList = (0, $5uXOq.useMemo)(()=>[
            ...defaultFilterWithComponentList,
            ...sharedWithMeWithComponentList,
            ...createdByMeWithComponentList
        ], [
        createdByMeWithComponentList,
        defaultFilterWithComponentList,
        sharedWithMeWithComponentList
    ]);
    const getSelectedFilterComponentIfNotDefault = (0, $5uXOq.useMemo)(()=>(filterId)=>{
            if (defaultFilters.find((item)=>item.id === filterId)) return;
            const foundComponent = [
                ...sharedWithMeWithComponentList,
                ...createdByMeWithComponentList
            ].find((item)=>item.id === filterId)?.component;
            return foundComponent;
        }, [
        createdByMeWithComponentList,
        defaultFilters,
        sharedWithMeWithComponentList
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $4R6GH.fg)('operations_nav4_remaining_items')) {
            if (selectedFilter === '') {
                const customSearches = [
                    ...createdByMeWithComponentList,
                    ...sharedWithMeWithComponentList
                ];
                if (savedSearchIdFromURL) {
                    const matchedItem = customSearches.find((item)=>(0, $cM3YM.OpsgenieSavedSearchAri).parse(item.id).savedSearchId === savedSearchIdFromURL);
                    if (matchedItem) {
                        setSelectedFilter(matchedItem.id);
                        return;
                    }
                }
                if (alertSearchQueryFromURL) {
                    const matchedItem = customSearches.find((item)=>item.alertSearchQuery === alertSearchQueryFromURL);
                    if (matchedItem) setSelectedFilter(matchedItem.id);
                }
            }
        }
        if (!(0, $4R6GH.fg)('operations_nav4_remaining_items')) {
            if (selectedFilter === '') {
                for (const item of allFiltersWithComponentList)// FIXME: This approach is not ideal. We should somehow use id instead of the alertSearchQuery.
                // https://ifountain.atlassian.net/browse/ALX-9535
                if (item.alertSearchQuery === alertSearchQueryFromURL) {
                    setSelectedFilter(item.id);
                    break;
                }
            }
        }
    }, [
        alertSearchQueryFromURL,
        allFiltersWithComponentList,
        createdByMeWithComponentList,
        savedSearchIdFromURL,
        selectedFilter,
        sharedWithMeWithComponentList
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4.sidebar.operations.alerts"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: (0, $cySG4.ALERT_LIST_SPOTLIGHT_TARGETS).sidebar
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        menuId: defaultFilterMenuIds,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                    level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                    itemId: 'defaultFilters',
                    parentItemId: 'alerts'
                }
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZa9B.ExpandableMenuItemTrigger), {
        testId: (0, $dQbFB.getTestId)(defaultFilterMenuIds)
    }, formatMessage((0, $7zFZv.default).defaultFilters)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnznH.ExpandableMenuItemContent), null, defaultFilters.map((item)=>{
        const href = `/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
            elemBefore: pagesIcon,
            key: item.id,
            href: href,
            menuId: (0, $jhS4y.ENTITY_ID).ALARM_QUEUE(item.alertSearchQuery),
            onClick: ()=>{
                setSelectedFilter(item.id);
                if ((0, $4R6GH.fg)('operations_nav4_remaining_items')) setLastVisitedSearch(href);
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                    action: 'clicked',
                    actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                    actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OPERATIONS],
                    attributes: {
                        componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                        level: (0, $951a0ed422513987$export$f9db6a58b4aabd18),
                        itemId: item.id,
                        parentItemId: 'defaultFilters',
                        itemType: 'defaultFilter'
                    }
                });
            }
        }, item.name);
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, getSelectedFilterComponentIfNotDefault(selectedFilter)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9At5X.AlertsFlyoutMenuItem), {
        defaultFilterWithComponentList: defaultFilterWithComponentList,
        sharedWithMeWithComponentList: sharedWithMeWithComponentList,
        createdByMeWithComponentList: createdByMeWithComponentList,
        allFiltersWithComponentList: allFiltersWithComponentList
    }))));
}
function $52a00eeba0ac60fa$var$getParentMenuId(arr) {
    return (0, $lhMtU.toMenuIdFromMenuIdList)((arr || []).map((i)=>(0, $jhS4y.ENTITY_ID).ALARM_QUEUE(i.alertSearchQuery)));
}
function $52a00eeba0ac60fa$var$getComponentAddedSearchObjects(arrayList, pagesIcon, viewType, savedSearchType, savedSearchIdFromURL, setSelectedFilter, createAnalyticsEvent, setLastVisitedSearch, isAlertsRoute) {
    return arrayList.map((item)=>{
        if ((0, $4R6GH.fg)('operations_nav4_remaining_items')) {
            const requiresSavedSearchId = item.id && savedSearchType !== 'default';
            const savedSearchId = requiresSavedSearchId ? (0, $cM3YM.OpsgenieSavedSearchAri).parse(item.id).savedSearchId : '';
            const href = `/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}${requiresSavedSearchId ? `&filter=${savedSearchId}` : ''}`;
            return {
                ...item,
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
                    elemBefore: pagesIcon,
                    key: item.id,
                    href: href,
                    menuId: (0, $jhS4y.ENTITY_ID).ALARM_QUEUE(savedSearchIdFromURL ? savedSearchId : item.alertSearchQuery),
                    onClick: ()=>{
                        setSelectedFilter(item.id);
                        if (isAlertsRoute && (0, $4R6GH.fg)('operations_nav4_remaining_items')) setLastVisitedSearch(href);
                        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                            action: 'clicked',
                            actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OPERATIONS],
                            attributes: {
                                componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                                level: (0, $951a0ed422513987$export$f9db6a58b4aabd18),
                                itemId: item.id,
                                parentItemId: 'defaultFilters',
                                itemType: 'defaultFilter'
                            }
                        });
                    },
                    ...savedSearchType === 'createdByMe' && {
                        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gtYPY.SavedSearchActionButtons), {
                            savedSearch: item
                        })
                    }
                }, item.name)
            };
        }
        return {
            ...item,
            component: (()=>{
                const href = `/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}`;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
                    elemBefore: pagesIcon,
                    key: item.id,
                    href: href,
                    menuId: (0, $jhS4y.ENTITY_ID).ALARM_QUEUE(item.alertSearchQuery),
                    onClick: ()=>{
                        setSelectedFilter(item.id);
                        if (isAlertsRoute && (0, $4R6GH.fg)('operations_nav4_remaining_items')) setLastVisitedSearch(href);
                        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                            action: 'clicked',
                            actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OPERATIONS],
                            attributes: {
                                componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                                level: (0, $951a0ed422513987$export$f9db6a58b4aabd18),
                                itemId: item.id,
                                parentItemId: 'defaultFilters',
                                itemType: 'defaultFilter'
                            }
                        });
                    },
                    ...savedSearchType === 'createdByMe' && {
                        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gtYPY.SavedSearchActionButtons), {
                            savedSearch: item
                        })
                    }
                }, item.name);
            })()
        };
    });
}

});
parcelRegister("4gZTO", function(module, exports) {

$parcel$export(module.exports, "default", () => $01ff80c65f890cde$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e5396e4ff48992f40c4331cd3bb4c1bb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $01ff80c65f890cde$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    }, v2 = {
        "kind": "ScalarField",
        "name": "alertSearchQuery"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            }
        ],
        "kind": "Fragment",
        "name": "AlertsMenuItemContentNew",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "OpsgenieQuery",
                    "kind": "LinkedField",
                    "name": "opsgenie",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    }
                                ],
                                "concreteType": "OpsgenieSavedSearches",
                                "kind": "LinkedField",
                                "name": "savedSearches",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "sharedWithMe",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v0 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.sharedWithMe.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v1 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.sharedWithMe.name"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v2 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.sharedWithMe.alertSearchQuery"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "opsgenie.savedSearches.sharedWithMe"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "createdByMe",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v0 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.createdByMe.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v1 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.createdByMe.name"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v2 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.createdByMe.alertSearchQuery"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "opsgenie.savedSearches.createdByMe"
                                    }
                                ]
                            },
                            "action": "LOG",
                            "path": "opsgenie.savedSearches"
                        }
                    ]
                },
                "action": "LOG",
                "path": "opsgenie"
            }
        ],
        "type": "Query"
    };
}();
$01ff80c65f890cde$var$node.hash = "639a282aa854558238900abb0fd76b71";
var $01ff80c65f890cde$export$2e2bcd8739ae039 = $01ff80c65f890cde$var$node;

});

parcelRegister("cySG4", function(module, exports) {

$parcel$export(module.exports, "QUERY_PARAMETER_QUERY_LABEL", () => $5de925396bc7bec4$export$19f7845e9b507cf2);
$parcel$export(module.exports, "QUERY_PARAMETER_VIEW_LABEL", () => $5de925396bc7bec4$export$8540b2e79718c77f);
$parcel$export(module.exports, "QUERY_PARAMETER_ONLY_ALERTS_LABEL", () => $5de925396bc7bec4$export$d0190736add6775e);
$parcel$export(module.exports, "BASE_URL", () => $5de925396bc7bec4$export$ca6dda5263526f75);
$parcel$export(module.exports, "ALERT_LIST_SPOTLIGHT_TARGETS", () => $5de925396bc7bec4$export$84fe9cd6ee892532);
const $5de925396bc7bec4$export$19f7845e9b507cf2 = 'query';
const $5de925396bc7bec4$export$8540b2e79718c77f = 'view';
const $5de925396bc7bec4$export$d0190736add6775e = 'onlyAlerts';
const $5de925396bc7bec4$export$ca6dda5263526f75 = '/jira/ops';
const $5de925396bc7bec4$export$84fe9cd6ee892532 = {
    sidebar: 'operations-alert-sidebar-target',
    alertHeader: 'operations-alert-header-target',
    alertActions: 'operations-alert-actions-target',
    alertSources: 'operations-alert-sources-target',
    alertResponders: 'operations-alert-responders-target'
};

});

parcelRegister("9At5X", function(module, exports) {

$parcel$export(module.exports, "AlertsFlyoutMenuItem", () => $029eccda8b472a6e$export$22af2a033e73b845);

var $5uXOq = parcelRequire("5uXOq");

var $kY99m = parcelRequire("kY99m");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $hyOJh = parcelRequire("hyOJh");

var $6L0PY = parcelRequire("6L0PY");

var $l1N8i = parcelRequire("l1N8i");

var $jUDIz = parcelRequire("jUDIz");
var $17aWz = parcelRequire("17aWz");
var $lBNLs = parcelRequire("lBNLs");
var $1FdfO = parcelRequire("1FdfO");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

var $7zFZv = parcelRequire("7zFZv");
const $029eccda8b472a6e$export$22af2a033e73b845 = ({ defaultFilterWithComponentList: defaultFilterWithComponentList, sharedWithMeWithComponentList: sharedWithMeWithComponentList, createdByMeWithComponentList: createdByMeWithComponentList, allFiltersWithComponentList: allFiltersWithComponentList })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [textFilterValue, setTextFilterValue] = (0, $5uXOq.useState)('');
    const [foundItems, setFoundItems] = (0, $5uXOq.useState)([]);
    const handleChange = (0, $5uXOq.useCallback)((event)=>{
        const value = event.currentTarget.value;
        setTextFilterValue(value);
        const foundItemsList = allFiltersWithComponentList.filter((item)=>item.name.toLowerCase().includes(value.toLowerCase()));
        const components = foundItemsList.map((item)=>item.component);
        setFoundItems(components);
    }, [
        allFiltersWithComponentList
    ]);
    const onStopSavedSearch = (0, $5uXOq.useCallback)(()=>{
        const savedSearchesEvent = createAnalyticsEvent({
            action: 'blurred',
            actionSubject: 'jsmViewAllSavedSearchesFlyoutSearch'
        });
        (0, $8zOmE.fireUIAnalytics)(savedSearchesEvent, 'stopViewAllQueueSearch');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jUDIz.FlyoutMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lBNLs.FlyoutMenuItemTrigger), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6L0PY))), {
            label: "",
            spacing: "spacious",
            color: "currentColor"
        })
    }, formatMessage((0, $7zFZv.default).viewAllFiltersPopupMenuButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $17aWz.FlyoutMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1FdfO.MenuSection), null, (0, $4R6GH.fg)('operations_nav4_remaining_items') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $029eccda8b472a6e$var$headerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall"
    }, formatMessage((0, $7zFZv.default).alerts))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $029eccda8b472a6e$var$textfieldStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
        isCompact: true,
        value: textFilterValue,
        onChange: handleChange,
        "aria-label": formatMessage((0, $7zFZv.default).viewAllFiltersSearchPlaceholder),
        placeholder: formatMessage((0, $7zFZv.default).viewAllFiltersSearchPlaceholder),
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hyOJh))), {
            label: "",
            spacing: "spacious",
            color: "currentColor"
        }),
        onBlur: onStopSavedSearch
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.050",
        xcss: $029eccda8b472a6e$var$flyoutContentStyles
    }, !textFilterValue.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xxsmall"
    }, formatMessage((0, $7zFZv.default).defaultFilters))), defaultFilterWithComponentList.map((item)=>item.component), sharedWithMeWithComponentList && sharedWithMeWithComponentList.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xxsmall"
    }, formatMessage((0, $7zFZv.default).sharedWithMe))), sharedWithMeWithComponentList.map((item)=>item.component)), createdByMeWithComponentList && createdByMeWithComponentList.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xxsmall"
    }, formatMessage((0, $7zFZv.default).createdByMe))), createdByMeWithComponentList.map((item)=>item.component))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, foundItems.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        key: "no-item-found",
        paddingBlock: "space.100",
        xcss: $029eccda8b472a6e$var$noSearchResultsFoundStyles
    }, formatMessage((0, $7zFZv.default).viewAllFiltersNoResultsFoundText)) : foundItems))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.050",
        xcss: $029eccda8b472a6e$var$flyoutContentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $029eccda8b472a6e$var$stickyBarOldStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall"
    }, formatMessage((0, $7zFZv.default).alerts))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $029eccda8b472a6e$var$textfieldStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
        isCompact: true,
        value: textFilterValue,
        onChange: handleChange,
        "aria-label": formatMessage((0, $7zFZv.default).viewAllFiltersSearchPlaceholder),
        placeholder: formatMessage((0, $7zFZv.default).viewAllFiltersSearchPlaceholder),
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hyOJh))), {
            label: "",
            spacing: "spacious",
            color: "currentColor"
        }),
        onBlur: onStopSavedSearch
    }))), !textFilterValue.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xxsmall"
    }, formatMessage((0, $7zFZv.default).defaultFilters))), defaultFilterWithComponentList.map((item)=>item.component), sharedWithMeWithComponentList && sharedWithMeWithComponentList.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xxsmall"
    }, formatMessage((0, $7zFZv.default).sharedWithMe))), sharedWithMeWithComponentList.map((item)=>item.component)), createdByMeWithComponentList && createdByMeWithComponentList.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xxsmall"
    }, formatMessage((0, $7zFZv.default).createdByMe))), createdByMeWithComponentList.map((item)=>item.component))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, foundItems.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        key: "no-item-found",
        paddingBlock: "space.100",
        xcss: $029eccda8b472a6e$var$noSearchResultsFoundStyles
    }, formatMessage((0, $7zFZv.default).viewAllFiltersNoResultsFoundText)) : foundItems)))));
};
const $029eccda8b472a6e$var$headerStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.150',
    backgroundColor: 'utility.elevation.surface.current'
});
const $029eccda8b472a6e$var$stickyBarOldStyles = (0, $8CUq3.xcss)({
    position: 'sticky',
    top: '0',
    backgroundColor: 'utility.elevation.surface.current',
    zIndex: 'navigation'
});
const $029eccda8b472a6e$var$textfieldStyles = (0, $8CUq3.xcss)({
    paddingRight: 'space.100'
});
const $029eccda8b472a6e$var$noSearchResultsFoundStyles = (0, $8CUq3.xcss)({
    fontStyle: 'italic'
});
const $029eccda8b472a6e$var$flyoutContentStyles = (0, $8CUq3.xcss)({
    maxHeight: '500px',
    overflowY: 'auto'
});

});
parcelRegister("kY99m", function(module, exports) {

$parcel$export(module.exports, "default", () => $509076ff0c6afa78$export$2e2bcd8739ae039);
/* text-field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $VSDnB = parcelRequire("VSDnB");
const $509076ff0c6afa78$var$containerMedia = {
    invalid: "_msj6gir2",
    disabled: "_6up518qt"
};
const $509076ff0c6afa78$var$inputMediaDisabled = null;
const $509076ff0c6afa78$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $509076ff0c6afa78$var$disabledStyle = {
    standard: "_1h6dsyzs _bfhksyzs _syaz1lh4 _80om13gf",
    subtle: "_1h6d3acm _bfhk18uv _syaz1lh4 _80om13gf",
    none: "_1h6d3acm _bfhk18uv _syaz1lh4 _80om13gf"
};
const $509076ff0c6afa78$var$invalidStyle = null;
const $509076ff0c6afa78$var$focusWithinStyle = {
    standard: "_1p9x1p6i _qao9r01l _q433q049",
    subtle: "_1p9x1p6i _qao9r01l _q433q049",
    none: "_1p9x3acm _qao918uv _q433nruj"
};
const $509076ff0c6afa78$var$hoverStyle = {
    standard: "_4cvx1elr _irr31d5g",
    subtle: "_4cvx1elr _irr31d5g",
    none: "_4cvx3acm _irr318uv"
};
const $509076ff0c6afa78$var$getContainerTextBgAndBorderColor = {
    standard: "_1h6d1elr _1dqonqa1 _syaz1fxt _80om1kdv _bfhk1j9a _msj6gir2",
    subtle: "_1h6d3acm _1dqonqa1 _syaz1fxt _80om1kdv _16hg18uv _msj6gir2",
    none: "_1h6d3acm _1dqoglyw _syaz1fxt _80om1kdv _16hg18uv _msj6gir2"
};
const $509076ff0c6afa78$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $509076ff0c6afa78$var$getMaxWidth = (width)=>!width ? `100%` : width in $509076ff0c6afa78$var$widthMap ? `${$509076ff0c6afa78$var$widthMap[width]}px` : `${+width}px`;
const $509076ff0c6afa78$var$containerStyleAppearance = {
    standard: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    subtle: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    none: "_1dqoglyw"
};
const $509076ff0c6afa78$var$containerStyles = null;
const $509076ff0c6afa78$var$inputDisabledStyle = null;
const $509076ff0c6afa78$var$inputCompactStyleWithFg = null;
const $509076ff0c6afa78$var$inputCompactStyle = null;
const $509076ff0c6afa78$var$inputMonospacedStyle = null;
const $509076ff0c6afa78$var$inputFontStyleWithFG = null;
const $509076ff0c6afa78$var$inputStyleMonospacedWithFg = null;
const $509076ff0c6afa78$var$inputStyleNotDataCompactWithFG = null;
const $509076ff0c6afa78$var$inputStyle = null; /**
                          * __Textfield__
                          *
                          * A text field is an input that allows a user to write or edit text.
                          *
                          * - [Examples](https://atlassian.design/components/textfield/examples)
                          * - [Code](https://atlassian.design/components/textfield/code)
                          * - [Usage](https://atlassian.design/components/textfield/usage)
                          */ 
const $509076ff0c6afa78$var$Textfield = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $5uXOq.useRef)(null);
    const handleOnFocus = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$509076ff0c6afa78$var$analyticsParams
    });
    const handleOnBlur = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$509076ff0c6afa78$var$analyticsParams
    });
    const handleOnMouseDown = (0, $5uXOq.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $5uXOq.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        style: {
            maxWidth: `${$509076ff0c6afa78$var$getMaxWidth(width)}`
        },
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1osq _11c82smr _1reo15vq _18m915vq _v564r5cv _189ee4h9 _1e0c1txw _vchhusvi _4cvr1h6o _1bah1yb4 _lcxv1wug _s7n4jp4b _slp31hna _1tnq1l7b",
            $509076ff0c6afa78$var$getContainerTextBgAndBorderColor[appearance],
            $509076ff0c6afa78$var$containerStyleAppearance[appearance],
            !isDisabled && $509076ff0c6afa78$var$focusWithinStyle[appearance],
            !isDisabled && $509076ff0c6afa78$var$hoverStyle[appearance],
            isDisabled && $509076ff0c6afa78$var$containerMedia.disabled,
            isDisabled && $509076ff0c6afa78$var$disabledStyle[appearance],
            isInvalid && $509076ff0c6afa78$var$containerMedia.invalid,
            isInvalid && "_1h6d1bqt _4cvx1bqt _16qsizbr _1dbzizbr _uk1sr01l",
            className
        ]),
        children: [
            elemBeforeInput,
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                ...spreadProps,
                "aria-invalid": isInvalid ? isInvalid : undefined,
                "data-compact": isCompact ? isCompact : undefined,
                "data-ds--text-field--input": true,
                "data-monospaced": isMonospaced ? isMonospaced : undefined,
                "data-testid": testId,
                disabled: isDisabled,
                name: name,
                onBlur: handleOnBlur,
                onChange: onChange,
                onFocus: handleOnFocus,
                placeholder: placeholder,
                readOnly: isReadOnly,
                ref: setInputRef,
                required: isRequired,
                className: (0, $bwpsq.default)([
                    "_19itidpf _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _vchhusvi _1bsb1osq _1ul9idpf _bfhk18uv _syaz1kw7 _80om1kw7 _14jiu2gc _olc6u2gc _1kod12x7 _7ba012x7 _1goxglyw _13xeglyw _1n7e1l2s _1idr131l",
                    isMonospaced && "_ect41odn",
                    isCompact && "_85i51b66 _1q511b66 _y4ti12x7 _bozg12x7",
                    isDisabled && "_syaz1lh4 _1idr1lh4",
                    isDisabled && "_1fnx18qt",
                    !isCompact && (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') && "_14ji12x7 _olc612x7 _1kod12x7 _7ba012x7 _l9oiu2gc _549yu2gc _1h5w12x7 _124212x7",
                    (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') && "_11c81ixg _1tn22smr",
                    isCompact && (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') && "_11zpv77o _1l02v77o _daj712x7 _141f12x7 _1srd1b66 _oi9h1b66 _1e3012x7 _1txv12x7",
                    isMonospaced && (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') && "_ect41odn _14md1odn"
                ])
            }),
            elemAfterInput
        ]
    });
});
var $509076ff0c6afa78$export$2e2bcd8739ae039 = $509076ff0c6afa78$var$Textfield;

});

parcelRegister("jUDIz", function(module, exports) {

$parcel$export(module.exports, "FlyoutMenuItem", () => $ffd758778f838162$export$34e3b4eaa687835);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $33etG = parcelRequire("33etG");

var $lp9re = parcelRequire("lp9re");

var $iUFLC = parcelRequire("iUFLC");

var $1qQhw = parcelRequire("1qQhw");

var $aV1jL = parcelRequire("aV1jL");
const $ffd758778f838162$export$34e3b4eaa687835 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, id: id, isOpen: isOpenControlled, isDefaultOpen: isDefaultOpen = false, onOpenChange: onOpenChange }, forwardedRef)=>{
    const [isOpen, setIsOpen] = (0, $33etG.default)(isOpenControlled, ()=>isDefaultOpen);
    const previousIsOpen = (0, $lp9re.default)(isOpen);
    (0, $5uXOq.useEffect)(()=>{
        if (previousIsOpen === undefined || previousIsOpen === isOpen) /**
				 * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
				 *
				 * The previous value can be equal to the current one if the component re-renders due to something else changing.
				 *
				 * In both cases the value hasn't changed and we don't want to notify consumers.
				 */ return;
        onOpenChange?.(isOpen);
    }, [
        isOpen,
        onOpenChange,
        previousIsOpen
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aV1jL.IsOpenContext).Provider, {
        value: isOpen,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aV1jL.SetIsOpenContext).Provider, {
            value: setIsOpen,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1qQhw.MenuListItem), {
                ref: forwardedRef,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iUFLC.Popup), {
                    id: id,
                    isOpen: isOpen,
                    children: children
                })
            })
        })
    });
});

});
parcelRegister("iUFLC", function(module, exports) {

$parcel$export(module.exports, "Popup", () => $822df708b53543f9$export$129a32eedafa97c5);
$parcel$export(module.exports, "PopupTrigger", () => $822df708b53543f9$export$95d4acdbab2fc6ef);
$parcel$export(module.exports, "PopupContent", () => $822df708b53543f9$export$2a2c7ba12d3231e3);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");

var $eGmKJ = parcelRequire("eGmKJ");

var $9KnKW = parcelRequire("9KnKW");

var $9MHPe = parcelRequire("9MHPe");

var $9Mkr0 = parcelRequire("9Mkr0");

var $gkD4s = parcelRequire("gkD4s");
var $1V7PR = parcelRequire("1V7PR");

var $k8nZq = parcelRequire("k8nZq");

var $jIMB4 = parcelRequire("jIMB4");

var $hdHM8 = parcelRequire("hdHM8");

var $jLapR = parcelRequire("jLapR");
const $822df708b53543f9$var$IsOpenContext = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
const $822df708b53543f9$var$IdContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $822df708b53543f9$var$TriggerRefContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $822df708b53543f9$var$SetTriggerRefContext = /*#__PURE__*/ (0, $5uXOq.createContext)((0, $eGmKJ.default));
const $822df708b53543f9$var$EnsureIsInsidePopupContext = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
// Used to ensure popup sub-components are used within a Popup
// and provide a useful error message if not.
const $822df708b53543f9$var$useEnsureIsInsidePopup = ()=>{
    const context = (0, $5uXOq.useContext)($822df708b53543f9$var$EnsureIsInsidePopupContext);
    (0, $3joPi.default)(context, 'PopupTrigger and PopupContent components must be used within a Popup');
};
const $822df708b53543f9$export$129a32eedafa97c5 = ({ children: children, id: providedId, isOpen: isOpen = false })=>{
    const [triggerRef, setTriggerRef] = (0, $5uXOq.useState)(null);
    const generatedId = (0, $9KnKW.useId)();
    const id = providedId || generatedId;
    return /*#__PURE__*/ (0, $2OMIu.jsx)($822df708b53543f9$var$EnsureIsInsidePopupContext.Provider, {
        value: true,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($822df708b53543f9$var$IdContext.Provider, {
            value: id,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($822df708b53543f9$var$TriggerRefContext.Provider, {
                value: triggerRef,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($822df708b53543f9$var$SetTriggerRefContext.Provider, {
                    value: setTriggerRef,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($822df708b53543f9$var$IsOpenContext.Provider, {
                        value: isOpen,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gkD4s.Manager), {
                            children: children
                        })
                    })
                })
            })
        })
    });
};
const $822df708b53543f9$export$95d4acdbab2fc6ef = ({ children: children })=>{
    $822df708b53543f9$var$useEnsureIsInsidePopup();
    const isOpen = (0, $5uXOq.useContext)($822df708b53543f9$var$IsOpenContext);
    const id = (0, $5uXOq.useContext)($822df708b53543f9$var$IdContext);
    const setTriggerRef = (0, $5uXOq.useContext)($822df708b53543f9$var$SetTriggerRefContext);
    const getMergedTriggerRef = (0, $jLapR.useGetMemoizedMergedTriggerRef)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1V7PR.Reference), {
        children: ({ ref: ref })=>children({
                ref: getMergedTriggerRef(ref, setTriggerRef, isOpen),
                'aria-controls': id,
                'aria-expanded': isOpen,
                'aria-haspopup': true
            })
    });
};
const $822df708b53543f9$var$defaultLayer = 400;
/**
 * Disables popper.js GPU acceleration for this popup.
 * This means only positioning will be used, without any transforms.
 *
 * Performance will be degraded if the popup is expected to move.
 */ const $822df708b53543f9$var$shouldDisableGpuAccelerationModifiers = [
    {
        name: 'computeStyles',
        options: {
            gpuAcceleration: false
        }
    }
];
const $822df708b53543f9$export$2a2c7ba12d3231e3 = ({ xcss: xcss, appearance: inAppearance = 'default', children: children, boundary: boundary, offset: offset, strategy: strategy, onClose: onClose, testId: testId, rootBoundary: rootBoundary = 'viewport', shouldFlip: shouldFlip = true, placement: placement = 'auto', fallbackPlacements: fallbackPlacements, popupComponent: popupComponent, autoFocus: autoFocus = true, zIndex: zIndex = $822df708b53543f9$var$defaultLayer, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick = false, shouldRenderToParent: inShouldRenderToParent, shouldDisableFocusLock: shouldDisableFocusLock = false, shouldFitContainer: shouldFitContainer, shouldFitViewport: shouldFitViewport, shouldDisableGpuAcceleration: shouldDisableGpuAcceleration = false })=>{
    $822df708b53543f9$var$useEnsureIsInsidePopup();
    const isOpen = (0, $5uXOq.useContext)($822df708b53543f9$var$IsOpenContext);
    const id = (0, $5uXOq.useContext)($822df708b53543f9$var$IdContext);
    const triggerRef = (0, $5uXOq.useContext)($822df708b53543f9$var$TriggerRefContext);
    const { appearance: appearance, shouldRenderToParent: shouldRenderToParent } = (0, $hdHM8.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    });
    const handleOpenLayerObserverCloseSignal = (0, $5uXOq.useCallback)(()=>{
        onClose?.(null);
    }, [
        onClose
    ]);
    (0, $9Mkr0.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal
    });
    if (!isOpen) return null;
    const popperWrapper = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9MHPe.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jIMB4.default), {
            xcss: xcss,
            appearance: appearance,
            content: children,
            isOpen: isOpen,
            placement: placement,
            fallbackPlacements: fallbackPlacements,
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: shouldFlip,
            offset: offset,
            popupComponent: popupComponent,
            id: id,
            testId: testId,
            onClose: onClose,
            autoFocus: autoFocus,
            shouldFitContainer: shouldFitContainer,
            shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
            shouldRenderToParent: shouldRenderToParent,
            shouldDisableFocusLock: shouldDisableFocusLock,
            triggerRef: triggerRef,
            strategy: strategy,
            shouldFitViewport: shouldFitViewport,
            modifiers: shouldDisableGpuAcceleration ? $822df708b53543f9$var$shouldDisableGpuAccelerationModifiers : undefined
        })
    });
    if (shouldRenderToParent) return popperWrapper;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8nZq.default), {
        zIndex: zIndex,
        children: popperWrapper
    });
};

});


parcelRegister("17aWz", function(module, exports) {

$parcel$export(module.exports, "FlyoutMenuItemContent", () => $260a0085e2df9f2c$export$2ca9a13c57a8839a);
/* flyout-menu-item-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $iUFLC = parcelRequire("iUFLC");

var $aV1jL = parcelRequire("aV1jL");
const $260a0085e2df9f2c$var$flyoutMenuItemContentStyles = {
    root: "_1q51u2gc _85i5u2gc _bozgu2gc _y4tiu2gc _14b51kdj"
};
const $260a0085e2df9f2c$export$2ca9a13c57a8839a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, containerTestId: containerTestId, onClose: onClose, autoFocus: autoFocus }, forwardedRef)=>{
    const setIsOpen = (0, $5uXOq.useContext)((0, $aV1jL.SetIsOpenContext));
    const handleClose = (0, $5uXOq.useCallback)(()=>{
        onClose?.();
        setIsOpen(false);
    }, [
        setIsOpen,
        onClose
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iUFLC.PopupContent), {
        appearance: "UNSAFE_modal-below-sm",
        onClose: handleClose,
        placement: "right-start",
        shouldFitViewport: true,
        testId: containerTestId,
        xcss: $260a0085e2df9f2c$var$flyoutMenuItemContentStyles.root,
        autoFocus: autoFocus,
        /**
   * Disabling GPU acceleration removes the use of `transform` by popper.js for this popup.
   *
   * This allows makers to use popups with `shouldRenderToParent` inside the flyout.
   *
   * Without this, the `transform` makes the flyout the containing element for fixed positioning.
   * Because the flyout is also a scroll container then any nested, layered element is unable to
   * escape the flyout.
   *
   * Disabling the `transform` is the simplest way to resolve this layering issue,
   * and should have negligible performance impacts, because the flyout menus should rarely
   * need to be repositioned.
   */ shouldDisableGpuAcceleration: true,
        children: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                ref: forwardedRef,
                children: children
            })
    });
});

});

parcelRegister("lBNLs", function(module, exports) {

$parcel$export(module.exports, "FlyoutMenuItemTrigger", () => $d5ca4c545cb9ae15$export$9f59f399fe37b6ca);
/* flyout-menu-item-trigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $5JjdN = parcelRequire("5JjdN");

var $bpC55 = parcelRequire("bpC55");

var $iUFLC = parcelRequire("iUFLC");

var $fdP8o = parcelRequire("fdP8o");
const $d5ca4c545cb9ae15$var$elemAfterStyles = {
    root: "_18zr12x7 _1tz3r0mg"
};
const $d5ca4c545cb9ae15$export$9f59f399fe37b6ca = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, elemBefore: elemBefore, onClick: onClick, isSelected: isSelected, interactionName: interactionName, testId: testId, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $iUFLC.PopupTrigger), {
        children: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $fdP8o.MenuItemBase), {
                testId: testId,
                ref: (0, $5JjdN.default)([
                    ref,
                    forwardedRef
                ]),
                visualContentRef: visualContentRef,
                elemBefore: elemBefore,
                elemAfter: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $d5ca4c545cb9ae15$var$elemAfterStyles.root
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bpC55))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)",
                        size: "small"
                    })
                }),
                onClick: onClick,
                ariaControls: ariaControls,
                ariaExpanded: ariaExpanded,
                ariaHasPopup: ariaHasPopup,
                interactionName: interactionName,
                isContentTooltipDisabled: isContentTooltipDisabled,
                isSelected: isSelected,
                isDragging: isDragging,
                hasDragIndicator: hasDragIndicator,
                dropIndicator: dropIndicator,
                children: children
            })
    }));

});





parcelRegister("iWRQ3", function(module, exports) {

$parcel$export(module.exports, "Nav4Communications", () => $e392e123a4a07fe2$export$2d3b6d12e7bc4c2d);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $l8ruj = parcelRequire("l8ruj");

var $hQNDZ = parcelRequire("hQNDZ");

const $e392e123a4a07fe2$export$2d3b6d12e7bc4c2d = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4-sidebar-communications"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "flag",
        id: "communications-section",
        packageName: (0, $65e2bba8a28b0873$export$b8b9d90f9e5bd72b),
        teamName: (0, $65e2bba8a28b0873$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hQNDZ.Nav4Communications), props)));
};

});
parcelRegister("hQNDZ", function(module, exports) {

$parcel$export(module.exports, "Nav4Communications", () => $ff046021b20673d7$export$2d3b6d12e7bc4c2d);

var $5uXOq = parcelRequire("5uXOq");

var $fptva = parcelRequire("fptva");

var $lnznH = parcelRequire("lnznH");
var $cZa9B = parcelRequire("cZa9B");

var $24a2m = parcelRequire("24a2m");

var $c16H2 = parcelRequire("c16H2");

var $5FnJJ = parcelRequire("5FnJJ");


var $jhS4y = parcelRequire("jhS4y");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ivGSs = parcelRequire("ivGSs");



var $dQbFB = parcelRequire("dQbFB");

var $dUyqZ = parcelRequire("dUyqZ");

var $46Cti = parcelRequire("46Cti");

var $hcl9J = parcelRequire("hcl9J");
const $ff046021b20673d7$export$2d3b6d12e7bc4c2d = ({ isExpanded: isExpanded = false })=>{
    const { icon: stakeholdersIcon, formattedMessage: stakeholdersMessage } = (0, $24a2m.useFormattedMessageAndIcon)((0, $hcl9J.default).stakeholders, (0, (/*@__PURE__*/$parcel$interopDefault($fptva))));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formattedMessage: triggerFormattedMessage, icon: triggerIcon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).COMMUNICATION);
    const menuId = (0, $jhS4y.MENU_ID_COMMUNICATION);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        menuId: menuId,
        isExpanded: isExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZa9B.ExpandableMenuItemTrigger), {
        testId: (0, $dQbFB.getTestId)(menuId),
        elemBefore: triggerIcon
    }, triggerFormattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnznH.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        menuId: (0, $jhS4y.MENU_ID_COMMUNICATIONS_STAKEHOLDERS),
        href: "/jira/communications/stakeholders",
        elemBefore: stakeholdersIcon,
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_COMMUNICATION],
                attributes: {
                    componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                    level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                    itemId: 'stakeholders'
                }
            });
        }
    }, stakeholdersMessage)));
};

});
parcelRegister("hcl9J", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c2c3e405d82351e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9c2c3e405d82351e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    communication: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-communications.communications.non-final",
        "defaultMessage": "Communications"
    },
    overview: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-communications.overview.non-final",
        "defaultMessage": "Overview"
    },
    statusPages: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-communications.status-pages.non-final",
        "defaultMessage": "Status Pages"
    },
    communicationPlans: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-communications.communication-plans.non-final",
        "defaultMessage": "Communication Plans"
    },
    stakeholders: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-communications.stakeholders.non-final",
        "defaultMessage": "Stakeholders"
    },
    channels: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-communications.channels.non-final",
        "defaultMessage": "Channels"
    },
    reports: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-communications.reports.non-final",
        "defaultMessage": "Reports"
    }
});

});


const $65e2bba8a28b0873$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Communications';
const $65e2bba8a28b0873$export$d57b6b390e78d90f = 'Alexstrasza';


parcelRegister("iKHgp", function(module, exports) {

$parcel$export(module.exports, "useShouldRenderOverviews", () => $fb6128b9861df989$export$4ce95cd18a7f8574);

var $4R6GH = parcelRequire("4R6GH");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");
const $fb6128b9861df989$export$4ce95cd18a7f8574 = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    if (!(0, $4R6GH.fg)('blu-2858-sidebar-menu-overviews')) return false;
    // JSW Premium does not have Overviews because it has the newer Plans feature available
    if (appEditions.software === (0, $ldyPw.PREMIUM_EDITION)) return false;
    // JWM Premium has Overviews if JSW Premium is not also present
    // Note: This means there are some cases where both the Plans and Overviews menu items will be available;
    // in these cases it's because the user should see the Plans upsell (that logic is taken care of within the Plans menu item)
    if (appEditions.core === (0, $ldyPw.PREMIUM_EDITION)) return true;
    // JSM Premium has Overviews if any edition of JWM is also present
    if (appEditions.serviceDesk === (0, $ldyPw.PREMIUM_EDITION) && (appEditions.core === (0, $ldyPw.FREE_EDITION) || appEditions.core === (0, $ldyPw.STANDARD_EDITION))) return true;
    return false;
};

});

parcelRegister("lz3si", function(module, exports) {

$parcel$export(module.exports, "Nav4Overviews", () => $dddda2f6dd48ba2b$export$2c62779314f9754a);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $l8ruj = parcelRequire("l8ruj");


var $hWrpp = parcelRequire("hWrpp");
function $dddda2f6dd48ba2b$export$2c62779314f9754a(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4-sidebar-overviews"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "flag",
        id: "overviews-section",
        packageName: (0, $cdfe315557fc43d2$export$b8b9d90f9e5bd72b),
        teamName: (0, $cdfe315557fc43d2$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hWrpp.Nav4Overviews), props)));
}

});
const $cdfe315557fc43d2$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Overviews';
const $cdfe315557fc43d2$export$d57b6b390e78d90f = 'jira-cosmos';

parcelRegister("hWrpp", function(module, exports) {

$parcel$export(module.exports, "Nav4Overviews", () => $441eac7217d261af$export$2c62779314f9754a);

var $8tKjq = parcelRequire("8tKjq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jhS4y = parcelRequire("jhS4y");

var $c6x3L = parcelRequire("c6x3L");

var $gQORo = parcelRequire("gQORo");

var $VgtWG = parcelRequire("VgtWG");

var $aKoWU = parcelRequire("aKoWU");
function $441eac7217d261af$export$2c62779314f9754a({ isExpanded: isExpanded, queryRef: queryRef }) {
    const { isInitialSelectedPath: isInitialSelectedPath } = (0, $c6x3L.useSidebarNav4)();
    const data = (0, $8Uumt.useFragment)((0, $8tKjq.default), queryRef);
    const actionButtons = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gQORo.SectionActions), {
            totalCount: data?.jira?.jwmOverviews?.totalCount ?? 0
        }), [
        data?.jira?.jwmOverviews?.totalCount
    ]);
    return isInitialSelectedPath((0, $jhS4y.MENU_ID_OVERVIEWS)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aKoWU.Nav4OverviewsForLanding), {
        isExpanded: isExpanded,
        queryRef: data,
        actionsOnHover: actionButtons
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $VgtWG.Nav4OverviewsDefault), {
        isExpanded: isExpanded,
        actionsOnHover: actionButtons
    });
}

});
parcelRegister("8tKjq", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fc06df8a8701f9c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d103d7389206befab32513e4690206a4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3fc06df8a8701f9c$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "kind": "RootArgument",
            "name": "isOverviewsExpanded"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4Overviews",
    "selections": [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "JiraWorkManagementGiraOverviewConnection",
                    "kind": "LinkedField",
                    "name": "jwmOverviews",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "totalCount"
                        }
                    ]
                }
            ]
        },
        {
            "condition": "isOverviewsExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4OverviewsForLanding"
                }
            ]
        }
    ],
    "type": "Query"
};
$3fc06df8a8701f9c$var$node.hash = "49456eee5b5999aee543e784e4db7323";
var $3fc06df8a8701f9c$export$2e2bcd8739ae039 = $3fc06df8a8701f9c$var$node;

});

parcelRegister("gQORo", function(module, exports) {

$parcel$export(module.exports, "SectionActions", () => $782e3beee288b950$export$51f8029abf8c56ce);

var $5uXOq = parcelRequire("5uXOq");

var $dZbEw = parcelRequire("dZbEw");

var $ldKol = parcelRequire("ldKol");

var $i8Qvm = parcelRequire("i8Qvm");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
var $dS3PR = parcelRequire("dS3PR");

var $3bDjY = parcelRequire("3bDjY");

var $7yUJn = parcelRequire("7yUJn");

var $koVbs = parcelRequire("koVbs");



var $ivGSs = parcelRequire("ivGSs");

var $i3a7M = parcelRequire("i3a7M");

var $jhS4y = parcelRequire("jhS4y");

var $46Cti = parcelRequire("46Cti");

var $1xonH = parcelRequire("1xonH");

var $cDvOQ = parcelRequire("cDvOQ");

var $eaKdt = parcelRequire("eaKdt");

var $aCS3f = parcelRequire("aCS3f");

var $jgJNO = parcelRequire("jgJNO");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $92djE = parcelRequire("92djE");
function $782e3beee288b950$export$51f8029abf8c56ce({ totalCount: totalCount }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isOpen: isOpen, onClose: onClose, onOpen: onOpen, onToggle: onToggle } = (0, $cDvOQ.useOpenable)();
    const { sendCreateOverviewAnalyticsEvent: sendCreateOverviewAnalyticsEvent } = (0, $i3a7M.useOverviewsAnalyticsL1)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireOpenEvent = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OVERVIEWS],
            attributes: {
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                itemId: 'meatballDropdown'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const onCreateOverviewHandler = (0, $5uXOq.useCallback)(()=>{
        sendCreateOverviewAnalyticsEvent({
            overviewLimitReached: false
        });
        onOpen();
    }, [
        onOpen,
        sendCreateOverviewAnalyticsEvent
    ]);
    const onToggleOverviewHandler = (0, $5uXOq.useCallback)(()=>{
        sendCreateOverviewAnalyticsEvent({
            overviewLimitReached: true
        });
        onToggle();
    }, [
        onToggle,
        sendCreateOverviewAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, totalCount < 10 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7yUJn.default), {
        onClose: onClose
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $92djE.default).createOverview)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1xonH.CommonNavMenuButton), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage((0, $92djE.default).createOverview),
        onClick: onCreateOverviewHandler
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: onClose,
        placement: "right",
        messageId: "navigation-apps-sidebar-nav4-sidebars-content-overviews.common.ui.section-actions.popup",
        messageType: "transactional",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
                padding: "space.200"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
                space: "space.200",
                alignBlock: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ldKol))), {
                spacing: "none",
                label: "",
                color: "var(--ds-icon-warning, #E56910)"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), null, formatMessage((0, $92djE.default).moreThanTenWarning)))),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: formatMessage((0, $92djE.default).createOverview)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1xonH.CommonNavMenuButton), {
                icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
                        ...iconProps,
                        size: "small"
                    }),
                label: formatMessage((0, $92djE.default).createOverview),
                onClick: onToggleOverviewHandler,
                ...triggerProps
            }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCS3f.MoreNavMenuButton), {
        MenuItems: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($782e3beee288b950$var$MoreMenuItems, null),
        onOpen: fireOpenEvent
    }));
}
function $782e3beee288b950$var$MoreMenuItems() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaKdt.HideL1MenuItemSection), {
        menuId: (0, $46Cti.L1_MENU_ID).OVERVIEWS
    });
}

});
parcelRegister("ldKol", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::435e803a057e79e21a0d31c5b12f3f81>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f72ecc49e3f0753c$var$_react = $f72ecc49e3f0753c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f72ecc49e3f0753c$var$_baseNew = $f72ecc49e3f0753c$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $f72ecc49e3f0753c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f72ecc49e3f0753c$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $f72ecc49e3f0753c$var$_react.default.createElement($f72ecc49e3f0753c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$f72ecc49e3f0753c$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $f72ecc49e3f0753c$var$_default = module.exports.default = $f72ecc49e3f0753c$var$StatusWarningIcon;

});

parcelRegister("7yUJn", function(module, exports) {

$parcel$export(module.exports, "default", () => $2eb121a7f5478dbf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cm8b5 = parcelRequire("cm8b5");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $bTIks = parcelRequire("bTIks");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2eb121a7f5478dbf$var$LazyCreateOverviewModal = (0, $kxZPA.lazy)(()=>(parcelRequire("ePB6h")), {
    ssr: false,
    moduleId: "./src/packages/business/entity/overview/src/ui/create-overview-modal/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2eb121a7f5478dbf$export$2e2bcd8739ae039 = ({ onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8b5.ExperienceErrorBoundary), {
        experience: (0, $bTIks.CREATE_OVERVIEW_EXPERIENCE),
        fallback: "unmount",
        shouldStartExperience: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "overview-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2eb121a7f5478dbf$var$LazyCreateOverviewModal, {
        onClose: onClose
    })));

});
parcelRegister("cm8b5", function(module, exports) {

$parcel$export(module.exports, "useExperienceStart", () => $aca94fc714dddc77$export$675e0d25df38d426);
$parcel$export(module.exports, "useExperienceAbort", () => $aca94fc714dddc77$export$cc92b7ce453f4403);
$parcel$export(module.exports, "useExperienceSuccess", () => $aca94fc714dddc77$export$e94f0da4fc0603c6);
$parcel$export(module.exports, "useExperienceFail", () => $aca94fc714dddc77$export$606da7704d8eaf06);
$parcel$export(module.exports, "useQueryBasedViewAutomaticTracking", () => $aca94fc714dddc77$export$8ca25d6ff1437be3);
$parcel$export(module.exports, "ExperienceStart", () => $aca94fc714dddc77$export$f20b867e738a222c);
$parcel$export(module.exports, "ExperienceFailed", () => $aca94fc714dddc77$export$ae65a9e09c4516b3);
$parcel$export(module.exports, "ExperienceErrorBoundary", () => $aca94fc714dddc77$export$139c4a4ad101c3c5);
$parcel$export(module.exports, "ExperienceSuccess", () => $aca94fc714dddc77$export$4962f3898bd5c829);
$parcel$export(module.exports, "ExperienceAbort", () => $aca94fc714dddc77$export$c9b6bcd70239a39c);

var $5uXOq = parcelRequire("5uXOq");

var $8Wswo = parcelRequire("8Wswo");

var $j8DrX = parcelRequire("j8DrX");

var $8UpTw = parcelRequire("8UpTw");

var $7CMCs = parcelRequire("7CMCs");

var $jcw0u = parcelRequire("jcw0u");

var $8dXDG = parcelRequire("8dXDG");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $jJZqs = parcelRequire("jJZqs");
const $aca94fc714dddc77$export$675e0d25df38d426 = ({ experience: experience, experienceId: experienceId, packageName: packageName })=>(0, $kaHBi.useExperienceStart)({
        experience: experience,
        experienceId: experienceId,
        analyticsSource: packageName
    });
const $aca94fc714dddc77$export$cc92b7ce453f4403 = ({ experience: experience }, attributes)=>(0, $8dXDG.useExperienceAbort)({
        experience: experience,
        attributes: attributes
    });
const $aca94fc714dddc77$var$shard = (0, $j8DrX.default)('ajs-shard');
const $aca94fc714dddc77$var$region = (0, $j8DrX.default)('ajs-region');
const $aca94fc714dddc77$export$e94f0da4fc0603c6 = ({ experience: experience })=>(0, $3bQtK.useExperienceSuccess)({
        experience: experience,
        attributes: {
            shard: $aca94fc714dddc77$var$shard,
            region: $aca94fc714dddc77$var$region
        }
    });
const $aca94fc714dddc77$export$606da7704d8eaf06 = ({ experience: experience, experienceId: experienceId, packageName: packageName, teamName: teamName })=>{
    const onExperienceFail = (0, $93jKl.useExperienceFail)({
        experience: experience,
        attributes: {
            shard: $aca94fc714dddc77$var$shard,
            region: $aca94fc714dddc77$var$region
        }
    });
    const onFail = (0, $5uXOq.useCallback)((location, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error, extraAttributes)=>{
        const relevantError = error?.networkError ?? error;
        if (relevantError instanceof (0, $jJZqs.ValidationError) && relevantError.message === '' && relevantError.errors.length) relevantError.message = relevantError.errors[0].error;
        extraAttributes !== undefined ? onExperienceFail(location, relevantError, extraAttributes) : onExperienceFail(location, relevantError);
        (0, $jcw0u.default)({
            meta: {
                id: `experience-tracker-${experienceId ?? experience}`,
                packageName: packageName,
                teamName: teamName
            },
            attributes: {
                location: location
            },
            error: relevantError,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        onExperienceFail,
        experienceId,
        experience,
        packageName,
        teamName
    ]);
    return onFail;
};
const $aca94fc714dddc77$export$8ca25d6ff1437be3 = (experience, { loading: loading, error: error, shouldStartExperience: shouldStartExperience })=>{
    const [hasStarted, setHasStarted] = (0, $5uXOq.useState)(loading);
    const [hasCompleted, setHasCompleted] = (0, $5uXOq.useState)(false);
    const [hasExperienceBeenTracked, setHasExperienceBeenTracked] = (0, $5uXOq.useState)(false);
    const startExperience = $aca94fc714dddc77$export$675e0d25df38d426(experience);
    const onFail = $aca94fc714dddc77$export$606da7704d8eaf06(experience);
    const onSuccess = $aca94fc714dddc77$export$e94f0da4fc0603c6(experience);
    (0, $5uXOq.useEffect)(()=>{
        if (shouldStartExperience === true) startExperience();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        shouldStartExperience
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (hasStarted === false && loading === true) setHasStarted(true);
        if (hasStarted === true && loading === false) {
            setHasCompleted(true);
            setHasExperienceBeenTracked(false);
        }
    }, [
        hasStarted,
        loading
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (hasCompleted && !hasExperienceBeenTracked) {
            // make sure experience is tracked once despite re-rendering of the view
            setHasExperienceBeenTracked(true);
            if (typeof error !== 'undefined') {
                onFail(`${experience.experience} ${experience.experienceId || ''} useEffect error handling`, error, (0, $8Wswo.getGraphqlErrorAttributes)(error));
                return;
            }
            onSuccess({
                loaded: true
            });
        }
    }, [
        error,
        experience,
        hasCompleted,
        hasExperienceBeenTracked,
        onFail,
        onSuccess
    ]);
};
const $aca94fc714dddc77$export$f20b867e738a222c = /*#__PURE__*/ (0, $5uXOq.memo)(({ experience: experience })=>{
    const start = $aca94fc714dddc77$export$675e0d25df38d426(experience);
    (0, $5uXOq.useEffect)(()=>{
        start();
    }, [
        start
    ]);
    return null;
});
const $aca94fc714dddc77$export$ae65a9e09c4516b3 = /*#__PURE__*/ (0, $5uXOq.memo)(({ experience: experience, error: error, attributes: attributes })=>{
    const onFail = $aca94fc714dddc77$export$606da7704d8eaf06(experience);
    (0, $5uXOq.useEffect)(()=>{
        onFail(experience.experience, error, attributes);
    }, [
        attributes,
        error,
        experience,
        onFail
    ]);
    return null;
});
const $aca94fc714dddc77$export$139c4a4ad101c3c5 = ({ experience: experience, shouldStartExperience: shouldStartExperience, fallback: fallback = (0, $8UpTw.ErrorPage), children: children })=>{
    const onFail = $aca94fc714dddc77$export$606da7704d8eaf06(experience);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: experience.packageName,
        teamName: experience.teamName,
        id: experience.experience,
        onError: onFail,
        fallback: fallback
    }, shouldStartExperience === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aca94fc714dddc77$export$f20b867e738a222c, {
        experience: experience
    }), children);
};
const $aca94fc714dddc77$export$4962f3898bd5c829 = /*#__PURE__*/ (0, $5uXOq.memo)(({ experience: experience, attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bQtK.ExperienceSuccess), {
        experience: experience.experience,
        attributes: {
            ...experience.experienceId == null ? undefined : {
                experienceId: experience.experienceId
            },
            ...attributes
        }
    }));
const $aca94fc714dddc77$export$c9b6bcd70239a39c = /*#__PURE__*/ (0, $5uXOq.memo)(({ experience: experience, error: error })=>{
    const onAbort = $aca94fc714dddc77$export$cc92b7ce453f4403(experience);
    (0, $5uXOq.useEffect)(()=>{
        onAbort(experience.experience, {
            error: error.message
        });
    }, [
        error,
        experience,
        onAbort
    ]);
    return null;
});

});
parcelRegister("8Wswo", function(module, exports) {

$parcel$export(module.exports, "shouldHandleTheError", () => $6f94bc39289ec711$export$47770c8b6d645cdb);
$parcel$export(module.exports, "getGraphqlErrorAttributes", () => $6f94bc39289ec711$export$b19e649eafc62480);

var $e3a3O = parcelRequire("e3a3O");
const $6f94bc39289ec711$var$errorWhitelist = [
    'EXPERIENCE_UNAVAILABLE',
    'FIELD_UNAVAILABLE',
    'ISSUE_UNAVAILABLE'
];
const $6f94bc39289ec711$export$47770c8b6d645cdb = (error)=>{
    if (error?.networkError) return true;
    // when issue links are disabled at the instance level and we request it, it throws an error but we still get the whole response
    // There is a issue links perm check that happens after loading the list so the UI already deals with this properly and we can ignore it
    // similarly, even when issue links are enabled, but the field itself is hidden in every screen it will throw an error but we'll still get the whole response
    const filterIssueLinksDisabledErrors = (graphQLError)=>{
        const isWhitelisted = $6f94bc39289ec711$var$errorWhitelist.includes(graphQLError?.extensions?.errorType);
        return !isWhitelisted;
    };
    const errorsToShow = (error?.graphQLErrors || []).filter(filterIssueLinksDisabledErrors);
    return errorsToShow.length > 0;
};
const $6f94bc39289ec711$export$b19e649eafc62480 = (error)=>{
    const isApolloError = error instanceof (0, $e3a3O.ApolloError);
    if (!isApolloError) return {};
    const getErrorAttribute = (graphQLErrors, errorAttribute)=>{
        const errors = graphQLErrors.map((graphQLError)=>graphQLError?.extensions?.[errorAttribute]).filter(Boolean);
        return JSON.stringify(errors);
    };
    return {
        statusCodes: getErrorAttribute(error?.graphQLErrors || [], 'statusCode'),
        errorTypes: getErrorAttribute(error?.graphQLErrors || [], 'errorType')
    };
};

});
parcelRegister("e3a3O", function(module, exports) {

$parcel$export(module.exports, "NetworkStatus", () => $02a3c2aebc919401$export$bd096ddbd246c79c);
$parcel$export(module.exports, "isApolloError", () => $02a3c2aebc919401$export$17f5e6bd290bb15d);
$parcel$export(module.exports, "ApolloError", () => $02a3c2aebc919401$export$26a337512320b8c6);
$parcel$export(module.exports, "ApolloClient", () => $02a3c2aebc919401$export$13f5a5f0f1dbab88);

var $3VFsf = parcelRequire("3VFsf");

var $jojW6 = parcelRequire("jojW6");
var $bqMzA = parcelRequire("bqMzA");

var $clSzL = parcelRequire("clSzL");
var $aS6b9 = parcelRequire("aS6b9");

var $ebaCz = parcelRequire("ebaCz");

var $1DiV8 = parcelRequire("1DiV8");

var $12QNw = parcelRequire("12QNw");
var $02a3c2aebc919401$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($02a3c2aebc919401$export$bd096ddbd246c79c || ($02a3c2aebc919401$export$bd096ddbd246c79c = {}));
function $02a3c2aebc919401$var$isNetworkRequestInFlight(networkStatus) {
    return networkStatus < 7;
}
var $02a3c2aebc919401$var$Observable = function(_super) {
    (0, $3VFsf.__extends)(Observable, _super);
    function Observable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Observable.prototype[0, $ebaCz.default] = function() {
        return this;
    };
    Observable.prototype['@@observable'] = function() {
        return this;
    };
    return Observable;
}((0, $aS6b9.default));
function $02a3c2aebc919401$var$isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
function $02a3c2aebc919401$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var $02a3c2aebc919401$var$generateErrorMessage = function(err) {
    var message = '';
    if ($02a3c2aebc919401$var$isNonEmptyArray(err.graphQLErrors)) err.graphQLErrors.forEach(function(graphQLError) {
        var errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += "GraphQL error: " + errorMessage + "\n";
    });
    if (err.networkError) message += 'Network error: ' + err.networkError.message + '\n';
    message = message.replace(/\n$/, '');
    return message;
};
var $02a3c2aebc919401$export$26a337512320b8c6 = function(_super) {
    (0, $3VFsf.__extends)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        if (!errorMessage) _this.message = $02a3c2aebc919401$var$generateErrorMessage(_this);
        else _this.message = errorMessage;
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);
var $02a3c2aebc919401$export$160bafb6ac1e0641;
(function(FetchType) {
    FetchType[FetchType["normal"] = 1] = "normal";
    FetchType[FetchType["refetch"] = 2] = "refetch";
    FetchType[FetchType["poll"] = 3] = "poll";
})($02a3c2aebc919401$export$160bafb6ac1e0641 || ($02a3c2aebc919401$export$160bafb6ac1e0641 = {}));
var $02a3c2aebc919401$var$hasError = function(storeValue, policy) {
    if (policy === void 0) policy = 'none';
    return storeValue && (storeValue.networkError || policy === 'none' && $02a3c2aebc919401$var$isNonEmptyArray(storeValue.graphQLErrors));
};
var $02a3c2aebc919401$export$6c1b56eac59c9584 = function(_super) {
    (0, $3VFsf.__extends)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
        var _this = _super.call(this, function(observer) {
            return _this.onSubscribe(observer);
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.isTornDown = false;
        _this.options = options;
        _this.variables = options.variables || {};
        _this.queryId = queryManager.generateQueryId();
        _this.shouldSubscribe = shouldSubscribe;
        var opDef = (0, $jojW6.getOperationDefinition)(options.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        _this.queryManager = queryManager;
        return _this;
    }
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var observer = {
                next: function(result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.currentResult = function() {
        var result = this.getCurrentResult();
        if (result.data === undefined) result.data = {};
        return result;
    };
    ObservableQuery.prototype.getCurrentResult = function() {
        if (this.isTornDown) {
            var lastResult = this.lastResult;
            return {
                data: !this.lastError && lastResult && lastResult.data || void 0,
                error: this.lastError,
                loading: false,
                networkStatus: $02a3c2aebc919401$export$bd096ddbd246c79c.error
            };
        }
        var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
        var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
        var result;
        var fetchPolicy = this.options.fetchPolicy;
        var isNetworkFetchPolicy = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
        if (queryStoreValue) {
            var networkStatus = queryStoreValue.networkStatus;
            if ($02a3c2aebc919401$var$hasError(queryStoreValue, this.options.errorPolicy)) return {
                data: void 0,
                loading: false,
                networkStatus: networkStatus,
                error: new $02a3c2aebc919401$export$26a337512320b8c6({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError
                })
            };
            if (queryStoreValue.variables) {
                this.options.variables = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.options.variables), queryStoreValue.variables);
                this.variables = this.options.variables;
            }
            result = {
                data: data,
                loading: $02a3c2aebc919401$var$isNetworkRequestInFlight(networkStatus),
                networkStatus: networkStatus
            };
            if (queryStoreValue.graphQLErrors && this.options.errorPolicy === 'all') result.errors = queryStoreValue.graphQLErrors;
        } else {
            var loading = isNetworkFetchPolicy || partial && fetchPolicy !== 'cache-only';
            result = {
                data: data,
                loading: loading,
                networkStatus: loading ? $02a3c2aebc919401$export$bd096ddbd246c79c.loading : $02a3c2aebc919401$export$bd096ddbd246c79c.ready
            };
        }
        if (!partial) this.updateLastResult((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
            stale: false
        }));
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
            partial: partial
        });
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult) {
        var snapshot = this.lastResultSnapshot;
        return !(snapshot && newResult && snapshot.networkStatus === newResult.networkStatus && snapshot.stale === newResult.stale && (0, $bqMzA.equal)(snapshot.data, newResult.data));
    };
    ObservableQuery.prototype.getLastResult = function() {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function() {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.lastResult;
        delete this.lastResultSnapshot;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        var queryStore = this.queryManager.queryStore.get(this.queryId);
        if (queryStore) {
            queryStore.networkError = null;
            queryStore.graphQLErrors = [];
        }
    };
    ObservableQuery.prototype.refetch = function(variables) {
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-only') return Promise.reject(new (0, $1DiV8.InvariantError)(1));
        if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'cache-and-network') fetchPolicy = 'network-only';
        if (!(0, $bqMzA.equal)(this.variables, variables)) this.variables = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.variables), variables);
        if (!(0, $bqMzA.equal)(this.options.variables, this.variables)) this.options.variables = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.options.variables), this.variables);
        return this.queryManager.fetchQuery(this.queryId, (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.options), {
            fetchPolicy: fetchPolicy
        }), $02a3c2aebc919401$export$160bafb6ac1e0641.refetch);
    };
    ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        (0, $1DiV8.invariant)(fetchMoreOptions.updateQuery, 2);
        var combinedOptions = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $3VFsf.__assign)((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.options), fetchMoreOptions), {
            variables: (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.variables), fetchMoreOptions.variables)
        })), {
            fetchPolicy: 'network-only'
        });
        var qid = this.queryManager.generateQueryId();
        return this.queryManager.fetchQuery(qid, combinedOptions, $02a3c2aebc919401$export$160bafb6ac1e0641.normal, this.queryId).then(function(fetchMoreResult) {
            _this.updateQuery(function(previousResult) {
                return fetchMoreOptions.updateQuery(previousResult, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables
                });
            });
            _this.queryManager.stopQuery(qid);
            return fetchMoreResult;
        }, function(error) {
            _this.queryManager.stopQuery(qid);
            throw error;
        });
    };
    ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(opts) {
        var oldFetchPolicy = this.options.fetchPolicy;
        this.options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.options), opts);
        if (opts.pollInterval) this.startPolling(opts.pollInterval);
        else if (opts.pollInterval === 0) this.stopPolling();
        var fetchPolicy = opts.fetchPolicy;
        return this.setVariables(this.options.variables, oldFetchPolicy !== fetchPolicy && (oldFetchPolicy === 'cache-only' || oldFetchPolicy === 'standby' || fetchPolicy === 'network-only'), opts.fetchResults);
    };
    ObservableQuery.prototype.setVariables = function(variables, tryFetch, fetchResults) {
        if (tryFetch === void 0) tryFetch = false;
        if (fetchResults === void 0) fetchResults = true;
        this.isTornDown = false;
        variables = variables || this.variables;
        if (!tryFetch && (0, $bqMzA.equal)(variables, this.variables)) return this.observers.size && fetchResults ? this.result() : Promise.resolve();
        this.variables = this.options.variables = variables;
        if (!this.observers.size) return Promise.resolve();
        return this.queryManager.fetchQuery(this.queryId, this.options);
    };
    ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var _a = queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
        var newResult = (0, $jojW6.tryFunctionOrLogError)(function() {
            return mapFn(previousResult, {
                variables: variables
            });
        });
        if (newResult) {
            queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.stopPolling = function() {
        this.queryManager.stopPollingQuery(this.queryId);
        this.options.pollInterval = undefined;
    };
    ObservableQuery.prototype.startPolling = function(pollInterval) {
        $02a3c2aebc919401$var$assertNotCacheFirstOrOnly(this);
        this.options.pollInterval = pollInterval;
        this.queryManager.startPollingQuery(this.options, this.queryId);
    };
    ObservableQuery.prototype.updateLastResult = function(newResult) {
        var previousResult = this.lastResult;
        this.lastResult = newResult;
        this.lastResultSnapshot = this.queryManager.assumeImmutableResults ? newResult : (0, $jojW6.cloneDeep)(newResult);
        return previousResult;
    };
    ObservableQuery.prototype.onSubscribe = function(observer) {
        var _this = this;
        try {
            var subObserver = observer._subscription._observer;
            if (subObserver && !subObserver.error) subObserver.error = $02a3c2aebc919401$var$defaultSubscriptionObserverErrorCallback;
        } catch (_a) {}
        var first = !this.observers.size;
        this.observers.add(observer);
        if (observer.next && this.lastResult) observer.next(this.lastResult);
        if (observer.error && this.lastError) observer.error(this.lastError);
        if (first) this.setUpQuery();
        return function() {
            if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
        };
    };
    ObservableQuery.prototype.setUpQuery = function() {
        var _this = this;
        var _a = this, queryManager = _a.queryManager, queryId = _a.queryId;
        if (this.shouldSubscribe) queryManager.addObservableQuery(queryId, this);
        if (this.options.pollInterval) {
            $02a3c2aebc919401$var$assertNotCacheFirstOrOnly(this);
            queryManager.startPollingQuery(this.options, queryId);
        }
        var onError = function(error) {
            _this.updateLastResult((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, _this.lastResult), {
                errors: error.graphQLErrors,
                networkStatus: $02a3c2aebc919401$export$bd096ddbd246c79c.error,
                loading: false
            }));
            $02a3c2aebc919401$var$iterateObserversSafely(_this.observers, 'error', _this.lastError = error);
        };
        queryManager.observeQuery(queryId, this.options, {
            next: function(result) {
                if (_this.lastError || _this.isDifferentFromLastResult(result)) {
                    var previousResult_1 = _this.updateLastResult(result);
                    var _a = _this.options, query_1 = _a.query, variables = _a.variables, fetchPolicy_1 = _a.fetchPolicy;
                    if (queryManager.transform(query_1).hasClientExports) queryManager.getLocalState().addExportedVariables(query_1, variables).then(function(variables) {
                        var previousVariables = _this.variables;
                        _this.variables = _this.options.variables = variables;
                        if (!result.loading && previousResult_1 && fetchPolicy_1 !== 'cache-only' && queryManager.transform(query_1).serverQuery && !(0, $bqMzA.equal)(previousVariables, variables)) _this.refetch();
                        else $02a3c2aebc919401$var$iterateObserversSafely(_this.observers, 'next', result);
                    });
                    else $02a3c2aebc919401$var$iterateObserversSafely(_this.observers, 'next', result);
                }
            },
            error: onError
        }).catch(onError);
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        var queryManager = this.queryManager;
        this.isTornDown = true;
        queryManager.stopPollingQuery(this.queryId);
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        queryManager.removeObservableQuery(this.queryId);
        queryManager.stopQuery(this.queryId);
        this.observers.clear();
    };
    return ObservableQuery;
}($02a3c2aebc919401$var$Observable);
function $02a3c2aebc919401$var$defaultSubscriptionObserverErrorCallback(error) {}
function $02a3c2aebc919401$var$iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}
function $02a3c2aebc919401$var$assertNotCacheFirstOrOnly(obsQuery) {
    var fetchPolicy = obsQuery.options.fetchPolicy;
    (0, $1DiV8.invariant)(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only', 3);
}
var $02a3c2aebc919401$var$MutationStore = function() {
    function MutationStore() {
        this.store = {};
    }
    MutationStore.prototype.getStore = function() {
        return this.store;
    };
    MutationStore.prototype.get = function(mutationId) {
        return this.store[mutationId];
    };
    MutationStore.prototype.initMutation = function(mutationId, mutation, variables) {
        this.store[mutationId] = {
            mutation: mutation,
            variables: variables || {},
            loading: true,
            error: null
        };
    };
    MutationStore.prototype.markMutationError = function(mutationId, error) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = error;
        }
    };
    MutationStore.prototype.markMutationResult = function(mutationId) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = null;
        }
    };
    MutationStore.prototype.reset = function() {
        this.store = {};
    };
    return MutationStore;
}();
var $02a3c2aebc919401$var$QueryStore = function() {
    function QueryStore() {
        this.store = {};
    }
    QueryStore.prototype.getStore = function() {
        return this.store;
    };
    QueryStore.prototype.get = function(queryId) {
        return this.store[queryId];
    };
    QueryStore.prototype.initQuery = function(query) {
        var previousQuery = this.store[query.queryId];
        (0, $1DiV8.invariant)(!previousQuery || previousQuery.document === query.document || (0, $bqMzA.equal)(previousQuery.document, query.document), 19);
        var isSetVariables = false;
        var previousVariables = null;
        if (query.storePreviousVariables && previousQuery && previousQuery.networkStatus !== $02a3c2aebc919401$export$bd096ddbd246c79c.loading) {
            if (!(0, $bqMzA.equal)(previousQuery.variables, query.variables)) {
                isSetVariables = true;
                previousVariables = previousQuery.variables;
            }
        }
        var networkStatus;
        if (isSetVariables) networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.setVariables;
        else if (query.isPoll) networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.poll;
        else if (query.isRefetch) networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.refetch;
        else networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.loading;
        var graphQLErrors = [];
        if (previousQuery && previousQuery.graphQLErrors) graphQLErrors = previousQuery.graphQLErrors;
        this.store[query.queryId] = {
            document: query.document,
            variables: query.variables,
            previousVariables: previousVariables,
            networkError: null,
            graphQLErrors: graphQLErrors,
            networkStatus: networkStatus,
            metadata: query.metadata
        };
        if (typeof query.fetchMoreForQueryId === 'string' && this.store[query.fetchMoreForQueryId]) this.store[query.fetchMoreForQueryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.fetchMore;
    };
    QueryStore.prototype.markQueryResult = function(queryId, result, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = null;
        this.store[queryId].graphQLErrors = $02a3c2aebc919401$var$isNonEmptyArray(result.errors) ? result.errors : [];
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.ready;
        if (typeof fetchMoreForQueryId === 'string' && this.store[fetchMoreForQueryId]) this.store[fetchMoreForQueryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.ready;
    };
    QueryStore.prototype.markQueryError = function(queryId, error, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = error;
        this.store[queryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.error;
        if (typeof fetchMoreForQueryId === 'string') this.markQueryResultClient(fetchMoreForQueryId, true);
    };
    QueryStore.prototype.markQueryResultClient = function(queryId, complete) {
        var storeValue = this.store && this.store[queryId];
        if (storeValue) {
            storeValue.networkError = null;
            storeValue.previousVariables = null;
            if (complete) storeValue.networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.ready;
        }
    };
    QueryStore.prototype.stopQuery = function(queryId) {
        delete this.store[queryId];
    };
    QueryStore.prototype.reset = function(observableQueryIds) {
        var _this = this;
        Object.keys(this.store).forEach(function(queryId) {
            if (observableQueryIds.indexOf(queryId) < 0) _this.stopQuery(queryId);
            else _this.store[queryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.loading;
        });
    };
    return QueryStore;
}();
function $02a3c2aebc919401$var$capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
var $02a3c2aebc919401$var$LocalState = function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $jojW6.mergeDeep)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $jojW6.mergeDeep)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function(_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            return (0, $3VFsf.__generator)(this, function(_c) {
                if (document) return [
                    2,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $jojW6.hasDirectives)([
            'client'
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    LocalState.prototype.serverQuery = function(document) {
        return this.resolvers ? (0, $jojW6.removeClientSetsFromDocument)(document) : document;
    };
    LocalState.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var cache = this.cache;
        var newContext = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, context), {
            cache: cache,
            getCacheKey: function(obj) {
                if (cache.config) return cache.config.dataIdFromObject(obj);
                else (0, $1DiV8.invariant)(false, 6);
            }
        });
        return newContext;
    };
    LocalState.prototype.addExportedVariables = function(document, variables, context) {
        if (variables === void 0) variables = {};
        if (context === void 0) context = {};
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            return (0, $3VFsf.__generator)(this, function(_a) {
                if (document) return [
                    2,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2,
                    (0, $3VFsf.__assign)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $12QNw.visit)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === 'always' && arg.value.kind === 'BooleanValue' && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $12QNw.BREAK;
                    }
                }
            }
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $jojW6.buildQueryFromSelectionSet)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) context = {};
        if (variables === void 0) variables = {};
        if (fragmentMatcher === void 0) fragmentMatcher = function() {
            return true;
        };
        if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return (0, $3VFsf.__generator)(this, function(_b) {
                mainDefinition = (0, $jojW6.getMainDefinition)(document);
                fragments = (0, $jojW6.getFragmentDefinitions)(document);
                fragmentMap = (0, $jojW6.createFragmentMap)(fragments);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? $02a3c2aebc919401$var$capitalizeFirstLetter(definitionOperation) : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                return [
                    2,
                    this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, rootValue, execContext) {
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $3VFsf.__generator)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $3VFsf.__awaiter)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $3VFsf.__generator)(this, function(_a) {
                            if (!(0, $jojW6.shouldInclude)(selection, variables)) return [
                                2
                            ];
                            if ((0, $jojW6.isField)(selection)) return [
                                2,
                                this.resolveField(selection, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') resultsToMerge.push((_a = {}, _a[(0, $jojW6.resultKeyNameFromField)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $jojW6.isInlineFragment)(selection)) fragment = selection;
                            else {
                                fragment = fragmentMap[selection.name.value];
                                (0, $1DiV8.invariant)(fragment, 7);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2,
                                    this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2
                            ];
                        });
                    });
                };
                return [
                    2,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $jojW6.mergeDeepArray)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, rootValue, execContext) {
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $3VFsf.__generator)(this, function(_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $jojW6.resultKeyNameFromField)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve(resolve(rootValue, (0, $jojW6.argumentsObjectFromField)(field, variables), execContext.context, {
                            field: field,
                            fragmentMap: execContext.fragmentMap
                        }));
                    }
                }
                return [
                    2,
                    resultPromise.then(function(result) {
                        if (result === void 0) result = defaultResult;
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === 'export' && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === 'as' && arg.value.kind === 'StringValue') execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        if (!field.selectionSet) return result;
                        if (result == null) return result;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, result, execContext);
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, item, execContext);
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, item, execContext);
        }));
    };
    return LocalState;
}();
function $02a3c2aebc919401$var$multiplex(inner) {
    var observers = new Set();
    var sub = null;
    return new $02a3c2aebc919401$var$Observable(function(observer) {
        observers.add(observer);
        sub = sub || inner.subscribe({
            next: function(value) {
                observers.forEach(function(obs) {
                    return obs.next && obs.next(value);
                });
            },
            error: function(error) {
                observers.forEach(function(obs) {
                    return obs.error && obs.error(error);
                });
            },
            complete: function() {
                observers.forEach(function(obs) {
                    return obs.complete && obs.complete();
                });
            }
        });
        return function() {
            if (observers.delete(observer) && !observers.size && sub) {
                sub.unsubscribe();
                sub = null;
            }
        };
    });
}
function $02a3c2aebc919401$var$asyncMap(observable, mapFn) {
    return new $02a3c2aebc919401$var$Observable(function(observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeNextCount = 0;
        var completed = false;
        var handler = {
            next: function(value) {
                ++activeNextCount;
                new Promise(function(resolve) {
                    resolve(mapFn(value));
                }).then(function(result) {
                    --activeNextCount;
                    next && next.call(observer, result);
                    completed && handler.complete();
                }, function(e) {
                    --activeNextCount;
                    error && error.call(observer, e);
                });
            },
            error: function(e) {
                error && error.call(observer, e);
            },
            complete: function() {
                completed = true;
                if (!activeNextCount) complete && complete.call(observer);
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}
var $02a3c2aebc919401$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $02a3c2aebc919401$var$QueryManager = function() {
    function QueryManager(_a) {
        var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function() {
            return undefined;
        } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a.clientAwareness, clientAwareness = _e === void 0 ? {} : _e, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.mutationStore = new $02a3c2aebc919401$var$MutationStore();
        this.queryStore = new $02a3c2aebc919401$var$QueryStore();
        this.clientAwareness = {};
        this.idCounter = 1;
        this.queries = new Map();
        this.fetchQueryRejectFns = new Map();
        this.transformCache = new ((0, $jojW6.canUseWeakMap) ? WeakMap : Map)();
        this.inFlightLinkObservables = new Map();
        this.pollingInfoByQueryId = new Map();
        this.link = link;
        this.queryDeduplication = queryDeduplication;
        this.dataStore = store;
        this.onBroadcast = onBroadcast;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new $02a3c2aebc919401$var$LocalState({
            cache: store.getCache()
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
    }
    QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $1DiV8.InvariantError)(8));
        });
    };
    QueryManager.prototype.mutate = function(_a) {
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var mutationId, generateUpdateQueriesInfo, self;
            var _this = this;
            return (0, $3VFsf.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        (0, $1DiV8.invariant)(mutation, 9);
                        (0, $1DiV8.invariant)(!fetchPolicy || fetchPolicy === 'no-cache', 10);
                        mutationId = this.generateQueryId();
                        mutation = this.transform(mutation).document;
                        this.setQuery(mutationId, function() {
                            return {
                                document: mutation
                            };
                        });
                        variables = this.getVariables(mutation, variables);
                        if (!this.transform(mutation).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _f.sent();
                        _f.label = 2;
                    case 2:
                        generateUpdateQueriesInfo = function() {
                            var ret = {};
                            if (updateQueriesByName) _this.queries.forEach(function(_a, queryId) {
                                var observableQuery = _a.observableQuery;
                                if (observableQuery) {
                                    var queryName = observableQuery.queryName;
                                    if (queryName && $02a3c2aebc919401$var$hasOwnProperty.call(updateQueriesByName, queryName)) ret[queryId] = {
                                        updater: updateQueriesByName[queryName],
                                        query: _this.queryStore.get(queryId)
                                    };
                                }
                            });
                            return ret;
                        };
                        this.mutationStore.initMutation(mutationId, mutation, variables);
                        this.dataStore.markMutationInit({
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            updateQueries: generateUpdateQueriesInfo(),
                            update: updateWithProxyFn,
                            optimisticResponse: optimisticResponse
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                var storeResult;
                                var error;
                                self.getObservableFromLink(mutation, (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, context), {
                                    optimisticResponse: optimisticResponse
                                }), variables, false).subscribe({
                                    next: function(result) {
                                        if ((0, $jojW6.graphQLResultHasError)(result) && errorPolicy === 'none') {
                                            error = new $02a3c2aebc919401$export$26a337512320b8c6({
                                                graphQLErrors: result.errors
                                            });
                                            return;
                                        }
                                        self.mutationStore.markMutationResult(mutationId);
                                        if (fetchPolicy !== 'no-cache') self.dataStore.markMutationResult({
                                            mutationId: mutationId,
                                            result: result,
                                            document: mutation,
                                            variables: variables,
                                            updateQueries: generateUpdateQueriesInfo(),
                                            update: updateWithProxyFn
                                        });
                                        storeResult = result;
                                    },
                                    error: function(err) {
                                        self.mutationStore.markMutationError(mutationId, err);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        self.setQuery(mutationId, function() {
                                            return {
                                                document: null
                                            };
                                        });
                                        reject(new $02a3c2aebc919401$export$26a337512320b8c6({
                                            networkError: err
                                        }));
                                    },
                                    complete: function() {
                                        if (error) self.mutationStore.markMutationError(mutationId, error);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        if (error) {
                                            reject(error);
                                            return;
                                        }
                                        if (typeof refetchQueries === 'function') refetchQueries = refetchQueries(storeResult);
                                        var refetchQueryPromises = [];
                                        if ($02a3c2aebc919401$var$isNonEmptyArray(refetchQueries)) refetchQueries.forEach(function(refetchQuery) {
                                            if (typeof refetchQuery === 'string') self.queries.forEach(function(_a) {
                                                var observableQuery = _a.observableQuery;
                                                if (observableQuery && observableQuery.queryName === refetchQuery) refetchQueryPromises.push(observableQuery.refetch());
                                            });
                                            else {
                                                var queryOptions = {
                                                    query: refetchQuery.query,
                                                    variables: refetchQuery.variables,
                                                    fetchPolicy: 'network-only'
                                                };
                                                if (refetchQuery.context) queryOptions.context = refetchQuery.context;
                                                refetchQueryPromises.push(self.query(queryOptions));
                                            }
                                        });
                                        Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function() {
                                            self.setQuery(mutationId, function() {
                                                return {
                                                    document: null
                                                };
                                            });
                                            if (errorPolicy === 'ignore' && storeResult && (0, $jojW6.graphQLResultHasError)(storeResult)) delete storeResult.errors;
                                            resolve(storeResult);
                                        });
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, fetchType, fetchMoreForQueryId) {
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var _a, metadata, _b, fetchPolicy, _c, context, query, variables, storeResult, isNetworkOnly, needToFetch, _d, complete, result, shouldFetch, requestId, cancel, networkResult;
            var _this = this;
            return (0, $3VFsf.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = options.metadata, metadata = _a === void 0 ? null : _a, _b = options.fetchPolicy, fetchPolicy = _b === void 0 ? 'cache-first' : _b, _c = options.context, context = _c === void 0 ? {} : _c;
                        query = this.transform(options.query).document;
                        variables = this.getVariables(query, options.variables);
                        if (!this.transform(query).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(query, variables, context)
                        ];
                    case 1:
                        variables = _e.sent();
                        _e.label = 2;
                    case 2:
                        options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
                            variables: variables
                        });
                        isNetworkOnly = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
                        needToFetch = isNetworkOnly;
                        if (!isNetworkOnly) {
                            _d = this.dataStore.getCache().diff({
                                query: query,
                                variables: variables,
                                returnPartialData: true,
                                optimistic: false
                            }), complete = _d.complete, result = _d.result;
                            needToFetch = !complete || fetchPolicy === 'cache-and-network';
                            storeResult = result;
                        }
                        shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
                        if ((0, $jojW6.hasDirectives)([
                            'live'
                        ], query)) shouldFetch = true;
                        requestId = this.idCounter++;
                        cancel = fetchPolicy !== 'no-cache' ? this.updateQueryWatch(queryId, query, options) : undefined;
                        this.setQuery(queryId, function() {
                            return {
                                document: query,
                                lastRequestId: requestId,
                                invalidated: true,
                                cancel: cancel
                            };
                        });
                        this.invalidate(fetchMoreForQueryId);
                        this.queryStore.initQuery({
                            queryId: queryId,
                            document: query,
                            storePreviousVariables: shouldFetch,
                            variables: variables,
                            isPoll: fetchType === $02a3c2aebc919401$export$160bafb6ac1e0641.poll,
                            isRefetch: fetchType === $02a3c2aebc919401$export$160bafb6ac1e0641.refetch,
                            metadata: metadata,
                            fetchMoreForQueryId: fetchMoreForQueryId
                        });
                        this.broadcastQueries();
                        if (shouldFetch) {
                            networkResult = this.fetchRequest({
                                requestId: requestId,
                                queryId: queryId,
                                document: query,
                                options: options,
                                fetchMoreForQueryId: fetchMoreForQueryId
                            }).catch(function(error) {
                                if ($02a3c2aebc919401$export$17f5e6bd290bb15d(error)) throw error;
                                else {
                                    if (requestId >= _this.getQuery(queryId).lastRequestId) {
                                        _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                                        _this.invalidate(queryId);
                                        _this.invalidate(fetchMoreForQueryId);
                                        _this.broadcastQueries();
                                    }
                                    throw new $02a3c2aebc919401$export$26a337512320b8c6({
                                        networkError: error
                                    });
                                }
                            });
                            if (fetchPolicy !== 'cache-and-network') return [
                                2,
                                networkResult
                            ];
                            networkResult.catch(function() {});
                        }
                        this.queryStore.markQueryResultClient(queryId, !shouldFetch);
                        this.invalidate(queryId);
                        this.invalidate(fetchMoreForQueryId);
                        if (this.transform(query).hasForcedResolvers) return [
                            2,
                            this.localState.runResolvers({
                                document: query,
                                remoteResult: {
                                    data: storeResult
                                },
                                context: context,
                                variables: variables,
                                onlyRunForcedResolvers: true
                            }).then(function(result) {
                                _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                                _this.broadcastQueries();
                                return result;
                            })
                        ];
                        this.broadcastQueries();
                        return [
                            2,
                            {
                                data: storeResult
                            }
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markQueryResult = function(queryId, result, _a, fetchMoreForQueryId) {
        var fetchPolicy = _a.fetchPolicy, variables = _a.variables, errorPolicy = _a.errorPolicy;
        if (fetchPolicy === 'no-cache') this.setQuery(queryId, function() {
            return {
                newData: {
                    result: result.data,
                    complete: true
                }
            };
        });
        else this.dataStore.markQueryResult(result, this.getQuery(queryId).document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
    };
    QueryManager.prototype.queryListenerForObserver = function(queryId, options, observer) {
        var _this = this;
        function invoke(method, argument) {
            if (observer[method]) try {
                observer[method](argument);
            } catch (e) {}
            else method;
        }
        return function(queryStoreValue, newData) {
            _this.invalidate(queryId, false);
            if (!queryStoreValue) return;
            var _a = _this.getQuery(queryId), observableQuery = _a.observableQuery, document = _a.document;
            var fetchPolicy = observableQuery ? observableQuery.options.fetchPolicy : options.fetchPolicy;
            if (fetchPolicy === 'standby') return;
            var loading = $02a3c2aebc919401$var$isNetworkRequestInFlight(queryStoreValue.networkStatus);
            var lastResult = observableQuery && observableQuery.getLastResult();
            var networkStatusChanged = !!(lastResult && lastResult.networkStatus !== queryStoreValue.networkStatus);
            var shouldNotifyIfLoading = options.returnPartialData || !newData && queryStoreValue.previousVariables || networkStatusChanged && options.notifyOnNetworkStatusChange || fetchPolicy === 'cache-only' || fetchPolicy === 'cache-and-network';
            if (loading && !shouldNotifyIfLoading) return;
            var hasGraphQLErrors = $02a3c2aebc919401$var$isNonEmptyArray(queryStoreValue.graphQLErrors);
            var errorPolicy = observableQuery && observableQuery.options.errorPolicy || options.errorPolicy || 'none';
            if (errorPolicy === 'none' && hasGraphQLErrors || queryStoreValue.networkError) return invoke('error', new $02a3c2aebc919401$export$26a337512320b8c6({
                graphQLErrors: queryStoreValue.graphQLErrors,
                networkError: queryStoreValue.networkError
            }));
            try {
                var data = void 0;
                var isMissing = void 0;
                if (newData) {
                    if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'network-only') _this.setQuery(queryId, function() {
                        return {
                            newData: null
                        };
                    });
                    data = newData.result;
                    isMissing = !newData.complete;
                } else {
                    var lastError = observableQuery && observableQuery.getLastError();
                    var errorStatusChanged = errorPolicy !== 'none' && (lastError && lastError.graphQLErrors) !== queryStoreValue.graphQLErrors;
                    if (lastResult && lastResult.data && !errorStatusChanged) {
                        data = lastResult.data;
                        isMissing = false;
                    } else {
                        var diffResult = _this.dataStore.getCache().diff({
                            query: document,
                            variables: queryStoreValue.previousVariables || queryStoreValue.variables,
                            returnPartialData: true,
                            optimistic: true
                        });
                        data = diffResult.result;
                        isMissing = !diffResult.complete;
                    }
                }
                var stale = isMissing && !(options.returnPartialData || fetchPolicy === 'cache-only');
                var resultFromStore = {
                    data: stale ? lastResult && lastResult.data : data,
                    loading: loading,
                    networkStatus: queryStoreValue.networkStatus,
                    stale: stale
                };
                if (errorPolicy === 'all' && hasGraphQLErrors) resultFromStore.errors = queryStoreValue.graphQLErrors;
                invoke('next', resultFromStore);
            } catch (networkError) {
                invoke('error', new $02a3c2aebc919401$export$26a337512320b8c6({
                    networkError: networkError
                }));
            }
        };
    };
    QueryManager.prototype.transform = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cache = this.dataStore.getCache();
            var transformed = cache.transformDocument(document);
            var forLink = (0, $jojW6.removeConnectionDirectiveFromDocument)(cache.transformForLink(transformed));
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = this.localState.serverQuery(forLink);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: (0, $jojW6.hasClientExports)(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: (0, $jojW6.getDefaultValues)((0, $jojW6.getOperationDefinition)(transformed))
            };
            var add = function(doc) {
                if (doc && !transformCache.has(doc)) transformCache.set(doc, cacheEntry_1);
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options, shouldSubscribe) {
        if (shouldSubscribe === void 0) shouldSubscribe = true;
        (0, $1DiV8.invariant)(options.fetchPolicy !== 'standby', 11);
        options.variables = this.getVariables(options.query, options.variables);
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') options.notifyOnNetworkStatusChange = false;
        var transformedOptions = (0, $3VFsf.__assign)({}, options);
        return new $02a3c2aebc919401$export$6c1b56eac59c9584({
            queryManager: this,
            options: transformedOptions,
            shouldSubscribe: shouldSubscribe
        });
    };
    QueryManager.prototype.query = function(options) {
        var _this = this;
        (0, $1DiV8.invariant)(options.query, 12);
        (0, $1DiV8.invariant)(options.query.kind === 'Document', 13);
        (0, $1DiV8.invariant)(!options.returnPartialData, 14);
        (0, $1DiV8.invariant)(!options.pollInterval, 15);
        return new Promise(function(resolve, reject) {
            var watchedQuery = _this.watchQuery(options, false);
            _this.fetchQueryRejectFns.set("query:" + watchedQuery.queryId, reject);
            watchedQuery.result().then(resolve, reject).then(function() {
                return _this.fetchQueryRejectFns.delete("query:" + watchedQuery.queryId);
            });
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.idCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        this.stopPollingQuery(queryId);
        this.queryStore.stopQuery(queryId);
        this.invalidate(queryId);
    };
    QueryManager.prototype.addQueryListener = function(queryId, listener) {
        this.setQuery(queryId, function(_a) {
            var listeners = _a.listeners;
            listeners.add(listener);
            return {
                invalidated: false
            };
        });
    };
    QueryManager.prototype.updateQueryWatch = function(queryId, document, options) {
        var _this = this;
        var cancel = this.getQuery(queryId).cancel;
        if (cancel) cancel();
        var previousResult = function() {
            var previousResult = null;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            if (observableQuery) {
                var lastResult = observableQuery.getLastResult();
                if (lastResult) previousResult = lastResult.data;
            }
            return previousResult;
        };
        return this.dataStore.getCache().watch({
            query: document,
            variables: options.variables,
            optimistic: true,
            previousResult: previousResult,
            callback: function(newData) {
                _this.setQuery(queryId, function() {
                    return {
                        invalidated: true,
                        newData: newData
                    };
                });
            }
        });
    };
    QueryManager.prototype.addObservableQuery = function(queryId, observableQuery) {
        this.setQuery(queryId, function() {
            return {
                observableQuery: observableQuery
            };
        });
    };
    QueryManager.prototype.removeObservableQuery = function(queryId) {
        var cancel = this.getQuery(queryId).cancel;
        this.setQuery(queryId, function() {
            return {
                observableQuery: null
            };
        });
        if (cancel) cancel();
    };
    QueryManager.prototype.clearStore = function() {
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $1DiV8.InvariantError)(16));
        });
        var resetIds = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) resetIds.push(queryId);
        });
        this.queryStore.reset(resetIds);
        this.mutationStore.reset();
        return this.dataStore.reset();
    };
    QueryManager.prototype.resetStore = function() {
        var _this = this;
        return this.clearStore().then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) {
                var fetchPolicy = observableQuery.options.fetchPolicy;
                observableQuery.resetLastResults();
                if (fetchPolicy !== 'cache-only' && (includeStandby || fetchPolicy !== 'standby')) observableQueryPromises.push(observableQuery.refetch());
                _this.setQuery(queryId, function() {
                    return {
                        newData: null
                    };
                });
                _this.invalidate(queryId);
            }
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.observeQuery = function(queryId, options, observer) {
        this.addQueryListener(queryId, this.queryListenerForObserver(queryId, options, observer));
        return this.fetchQuery(queryId, options);
    };
    QueryManager.prototype.startQuery = function(queryId, options, listener) {
        this.addQueryListener(queryId, listener);
        this.fetchQuery(queryId, options).catch(function() {
            return undefined;
        });
        return queryId;
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, variables = _a.variables;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, {}, variables, false).map(function(result) {
                if (!fetchPolicy || fetchPolicy !== 'no-cache') {
                    _this.dataStore.markSubscriptionResult(result, query, variables);
                    _this.broadcastQueries();
                }
                if ((0, $jojW6.graphQLResultHasError)(result)) throw new $02a3c2aebc919401$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                });
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables).then(makeObservable);
            return new $02a3c2aebc919401$var$Observable(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        this.fetchQueryRejectFns.delete("query:" + queryId);
        this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
        this.getQuery(queryId).subscriptions.forEach(function(x) {
            return x.unsubscribe();
        });
        this.queries.delete(queryId);
    };
    QueryManager.prototype.getCurrentQueryResult = function(observableQuery, optimistic) {
        if (optimistic === void 0) optimistic = true;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query, fetchPolicy = _a.fetchPolicy, returnPartialData = _a.returnPartialData;
        var lastResult = observableQuery.getLastResult();
        var newData = this.getQuery(observableQuery.queryId).newData;
        if (newData && newData.complete) return {
            data: newData.result,
            partial: false
        };
        if (fetchPolicy === 'no-cache' || fetchPolicy === 'network-only') return {
            data: undefined,
            partial: false
        };
        var _b = this.dataStore.getCache().diff({
            query: query,
            variables: variables,
            previousResult: lastResult ? lastResult.data : undefined,
            returnPartialData: true,
            optimistic: optimistic
        }), result = _b.result, complete = _b.complete;
        return {
            data: complete || returnPartialData ? result : void 0,
            partial: !complete
        };
    };
    QueryManager.prototype.getQueryWithPreviousResult = function(queryIdOrObservable) {
        var observableQuery;
        if (typeof queryIdOrObservable === 'string') {
            var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
            (0, $1DiV8.invariant)(foundObserveableQuery, 17);
            observableQuery = foundObserveableQuery;
        } else observableQuery = queryIdOrObservable;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        return {
            previousResult: this.getCurrentQueryResult(observableQuery, false).data,
            variables: variables,
            document: query
        };
    };
    QueryManager.prototype.broadcastQueries = function() {
        var _this = this;
        this.onBroadcast();
        this.queries.forEach(function(info, id) {
            if (info.invalidated) info.listeners.forEach(function(listener) {
                if (listener) listener(_this.queryStore.get(id), info.newData);
            });
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
        var _this = this;
        if (deduplication === void 0) deduplication = this.queryDeduplication;
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _a = this, inFlightLinkObservables_1 = _a.inFlightLinkObservables, link = _a.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $jojW6.getOperationName)(serverQuery) || void 0,
                context: this.prepareContext((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = JSON.stringify(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    byVariables_1.set(varJson_1, observable = $02a3c2aebc919401$var$multiplex((0, $clSzL.execute)(link, operation)));
                    var cleanup = function() {
                        byVariables_1.delete(varJson_1);
                        if (!byVariables_1.size) inFlightLinkObservables_1.delete(serverQuery);
                        cleanupSub_1.unsubscribe();
                    };
                    var cleanupSub_1 = observable.subscribe({
                        next: cleanup,
                        error: cleanup,
                        complete: cleanup
                    });
                }
            } else observable = $02a3c2aebc919401$var$multiplex((0, $clSzL.execute)(link, operation));
        } else {
            observable = $02a3c2aebc919401$var$Observable.of({
                data: {}
            });
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) observable = $02a3c2aebc919401$var$asyncMap(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.fetchRequest = function(_a) {
        var _this = this;
        var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
        var variables = options.variables, _b = options.errorPolicy, errorPolicy = _b === void 0 ? 'none' : _b, fetchPolicy = options.fetchPolicy;
        var resultFromStore;
        var errorsFromStore;
        return new Promise(function(resolve, reject) {
            var observable = _this.getObservableFromLink(document, options.context, variables);
            var fqrfId = "fetchRequest:" + queryId;
            _this.fetchQueryRejectFns.set(fqrfId, reject);
            var cleanup = function() {
                _this.fetchQueryRejectFns.delete(fqrfId);
                _this.setQuery(queryId, function(_a) {
                    var subscriptions = _a.subscriptions;
                    subscriptions.delete(subscription);
                });
            };
            var subscription = observable.map(function(result) {
                if (requestId >= _this.getQuery(queryId).lastRequestId) {
                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                    _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                    _this.invalidate(queryId);
                    _this.invalidate(fetchMoreForQueryId);
                    _this.broadcastQueries();
                }
                if (errorPolicy === 'none' && $02a3c2aebc919401$var$isNonEmptyArray(result.errors)) return reject(new $02a3c2aebc919401$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                }));
                if (errorPolicy === 'all') errorsFromStore = result.errors;
                if (fetchMoreForQueryId || fetchPolicy === 'no-cache') resultFromStore = result.data;
                else {
                    var _a = _this.dataStore.getCache().diff({
                        variables: variables,
                        query: document,
                        optimistic: false,
                        returnPartialData: true
                    }), result_1 = _a.result, complete = _a.complete;
                    if (complete || options.returnPartialData) resultFromStore = result_1;
                }
            }).subscribe({
                error: function(error) {
                    cleanup();
                    reject(error);
                },
                complete: function() {
                    cleanup();
                    resolve({
                        data: resultFromStore,
                        errors: errorsFromStore,
                        loading: false,
                        networkStatus: $02a3c2aebc919401$export$bd096ddbd246c79c.ready,
                        stale: false
                    });
                }
            });
            _this.setQuery(queryId, function(_a) {
                var subscriptions = _a.subscriptions;
                subscriptions.add(subscription);
            });
        });
    };
    QueryManager.prototype.getQuery = function(queryId) {
        return this.queries.get(queryId) || {
            listeners: new Set(),
            invalidated: false,
            document: null,
            newData: null,
            lastRequestId: 1,
            observableQuery: null,
            subscriptions: new Set()
        };
    };
    QueryManager.prototype.setQuery = function(queryId, updater) {
        var prev = this.getQuery(queryId);
        var newInfo = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, prev), updater(prev));
        this.queries.set(queryId, newInfo);
    };
    QueryManager.prototype.invalidate = function(queryId, invalidated) {
        if (invalidated === void 0) invalidated = true;
        if (queryId) this.setQuery(queryId, function() {
            return {
                invalidated: invalidated
            };
        });
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    QueryManager.prototype.checkInFlight = function(queryId) {
        var query = this.queryStore.get(queryId);
        return query && query.networkStatus !== $02a3c2aebc919401$export$bd096ddbd246c79c.ready && query.networkStatus !== $02a3c2aebc919401$export$bd096ddbd246c79c.error;
    };
    QueryManager.prototype.startPollingQuery = function(options, queryId, listener) {
        var _this = this;
        var pollInterval = options.pollInterval;
        (0, $1DiV8.invariant)(pollInterval, 18);
        if (!this.ssrMode) {
            var info = this.pollingInfoByQueryId.get(queryId);
            if (!info) this.pollingInfoByQueryId.set(queryId, info = {});
            info.interval = pollInterval;
            info.options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
                fetchPolicy: 'network-only'
            });
            var maybeFetch_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    if (_this.checkInFlight(queryId)) poll_1();
                    else _this.fetchQuery(queryId, info.options, $02a3c2aebc919401$export$160bafb6ac1e0641.poll).then(poll_1, poll_1);
                }
            };
            var poll_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    clearTimeout(info.timeout);
                    info.timeout = setTimeout(maybeFetch_1, info.interval);
                }
            };
            if (listener) this.addQueryListener(queryId, listener);
            poll_1();
        }
        return queryId;
    };
    QueryManager.prototype.stopPollingQuery = function(queryId) {
        this.pollingInfoByQueryId.delete(queryId);
    };
    return QueryManager;
}();
var $02a3c2aebc919401$var$DataStore = function() {
    function DataStore(initialCache) {
        this.cache = initialCache;
    }
    DataStore.prototype.getCache = function() {
        return this.cache;
    };
    DataStore.prototype.markQueryResult = function(result, document, variables, fetchMoreForQueryId, ignoreErrors) {
        if (ignoreErrors === void 0) ignoreErrors = false;
        var writeWithErrors = !(0, $jojW6.graphQLResultHasError)(result);
        if (ignoreErrors && (0, $jojW6.graphQLResultHasError)(result) && result.data) writeWithErrors = true;
        if (!fetchMoreForQueryId && writeWithErrors) this.cache.write({
            result: result.data,
            dataId: 'ROOT_QUERY',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markSubscriptionResult = function(result, document, variables) {
        if (!(0, $jojW6.graphQLResultHasError)(result)) this.cache.write({
            result: result.data,
            dataId: 'ROOT_SUBSCRIPTION',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markMutationInit = function(mutation) {
        var _this = this;
        if (mutation.optimisticResponse) {
            var optimistic_1;
            if (typeof mutation.optimisticResponse === 'function') optimistic_1 = mutation.optimisticResponse(mutation.variables);
            else optimistic_1 = mutation.optimisticResponse;
            this.cache.recordOptimisticTransaction(function(c) {
                var orig = _this.cache;
                _this.cache = c;
                try {
                    _this.markMutationResult({
                        mutationId: mutation.mutationId,
                        result: {
                            data: optimistic_1
                        },
                        document: mutation.document,
                        variables: mutation.variables,
                        updateQueries: mutation.updateQueries,
                        update: mutation.update
                    });
                } finally{
                    _this.cache = orig;
                }
            }, mutation.mutationId);
        }
    };
    DataStore.prototype.markMutationResult = function(mutation) {
        var _this = this;
        if (!(0, $jojW6.graphQLResultHasError)(mutation.result)) {
            var cacheWrites_1 = [
                {
                    result: mutation.result.data,
                    dataId: 'ROOT_MUTATION',
                    query: mutation.document,
                    variables: mutation.variables
                }
            ];
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) Object.keys(updateQueries_1).forEach(function(id) {
                var _a = updateQueries_1[id], query = _a.query, updater = _a.updater;
                var _b = _this.cache.diff({
                    query: query.document,
                    variables: query.variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _b.result, complete = _b.complete;
                if (complete) {
                    var nextQueryResult = (0, $jojW6.tryFunctionOrLogError)(function() {
                        return updater(currentQueryResult, {
                            mutationResult: mutation.result,
                            queryName: (0, $jojW6.getOperationName)(query.document) || undefined,
                            queryVariables: query.variables
                        });
                    });
                    if (nextQueryResult) cacheWrites_1.push({
                        result: nextQueryResult,
                        dataId: 'ROOT_QUERY',
                        query: query.document,
                        variables: query.variables
                    });
                }
            });
            this.cache.performTransaction(function(c) {
                cacheWrites_1.forEach(function(write) {
                    return c.write(write);
                });
                var update = mutation.update;
                if (update) (0, $jojW6.tryFunctionOrLogError)(function() {
                    return update(c, mutation.result);
                });
            });
        }
    };
    DataStore.prototype.markMutationComplete = function(_a) {
        var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
        if (optimisticResponse) this.cache.removeOptimistic(mutationId);
    };
    DataStore.prototype.markUpdateQueryResult = function(document, variables, newResult) {
        this.cache.write({
            result: newResult,
            dataId: 'ROOT_QUERY',
            variables: variables,
            query: document
        });
    };
    DataStore.prototype.reset = function() {
        return this.cache.reset();
    };
    return DataStore;
}();
var $02a3c2aebc919401$var$version = "2.6.10";
var $02a3c2aebc919401$var$hasSuggestedDevtools = false;
var $02a3c2aebc919401$export$13f5a5f0f1dbab88 = function() {
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, _d = options.assumeImmutableResults, assumeImmutableResults = _d === void 0 ? false : _d, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link && resolvers) link = (0, $clSzL.ApolloLink).empty();
        if (!link || !cache) throw new (0, $1DiV8.InvariantError)(4);
        this.link = link;
        this.cache = cache;
        this.store = new $02a3c2aebc919401$var$DataStore(cache);
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || {};
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        var defaultConnectToDevTools = false;
        if (typeof connectToDevTools === 'undefined' ? defaultConnectToDevTools : connectToDevTools && typeof window !== 'undefined') window.__APOLLO_CLIENT__ = this;
        this.version = $02a3c2aebc919401$var$version;
        this.localState = new $02a3c2aebc919401$var$LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new $02a3c2aebc919401$var$QueryManager({
            link: this.link,
            store: this.store,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.queryStore.getStore(),
                        mutations: _this.queryManager.mutationStore.getStore()
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            }
        });
    }
    ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.defaultOptions.watchQuery), options);
        if (this.disableNetworkFetches && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.defaultOptions.query), options);
        (0, $1DiV8.invariant)(options.fetchPolicy !== 'cache-and-network', 5);
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.defaultOptions.mutate), options);
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function(options) {
        var result = this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeFragment = function(options) {
        var result = this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeData = function(options) {
        var result = this.cache.writeData(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $clSzL.execute)(this.link, payload);
    };
    ApolloClient.prototype.initQueryManager = function() {
        return this.queryManager;
    };
    ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    return ApolloClient;
}();
var $02a3c2aebc919401$export$2e2bcd8739ae039 = $02a3c2aebc919401$export$13f5a5f0f1dbab88;

});
parcelRegister("jojW6", function(module, exports) {

$parcel$export(module.exports, "storeKeyNameFromField", () => $e1dfb923a27ca793$export$54be8689c65f3b56);
$parcel$export(module.exports, "getStoreKeyName", () => $e1dfb923a27ca793$export$3cdb6c178b88cabe);
$parcel$export(module.exports, "argumentsObjectFromField", () => $e1dfb923a27ca793$export$3f5a60fb6a781b4f);
$parcel$export(module.exports, "resultKeyNameFromField", () => $e1dfb923a27ca793$export$7d1ad22471852218);
$parcel$export(module.exports, "isField", () => $e1dfb923a27ca793$export$fb56ad75dd311c12);
$parcel$export(module.exports, "isInlineFragment", () => $e1dfb923a27ca793$export$22a1cdafaf27bcff);
$parcel$export(module.exports, "isIdValue", () => $e1dfb923a27ca793$export$e33b89a9aa87695);
$parcel$export(module.exports, "toIdValue", () => $e1dfb923a27ca793$export$b124f125e34d720a);
$parcel$export(module.exports, "isJsonValue", () => $e1dfb923a27ca793$export$226c1c6d1a5b660a);
$parcel$export(module.exports, "getDirectiveInfoFromField", () => $e1dfb923a27ca793$export$2a7f471142984a91);
$parcel$export(module.exports, "shouldInclude", () => $e1dfb923a27ca793$export$3dc388a5f013b4a5);
$parcel$export(module.exports, "hasDirectives", () => $e1dfb923a27ca793$export$2dafb573e282fe8d);
$parcel$export(module.exports, "hasClientExports", () => $e1dfb923a27ca793$export$8d1e9e5bbfa5d09a);
$parcel$export(module.exports, "getFragmentQueryDocument", () => $e1dfb923a27ca793$export$abbf37c7cf644e41);
$parcel$export(module.exports, "assign", () => $e1dfb923a27ca793$export$e6e34fd1f2686227);
$parcel$export(module.exports, "checkDocument", () => $e1dfb923a27ca793$export$a7d0d8111d2386df);
$parcel$export(module.exports, "getOperationDefinition", () => $e1dfb923a27ca793$export$7a5b1fa979d2c158);
$parcel$export(module.exports, "getOperationName", () => $e1dfb923a27ca793$export$41bca9dc6871dd4e);
$parcel$export(module.exports, "getFragmentDefinitions", () => $e1dfb923a27ca793$export$5320a7ba9466a3df);
$parcel$export(module.exports, "getQueryDefinition", () => $e1dfb923a27ca793$export$d96b2213c1b9d3a9);
$parcel$export(module.exports, "getMainDefinition", () => $e1dfb923a27ca793$export$f431198736b7f96d);
$parcel$export(module.exports, "createFragmentMap", () => $e1dfb923a27ca793$export$193789b4c8246dd4);
$parcel$export(module.exports, "getDefaultValues", () => $e1dfb923a27ca793$export$84c19026e616569e);
$parcel$export(module.exports, "removeDirectivesFromDocument", () => $e1dfb923a27ca793$export$e5ae0530da5fe96c);
$parcel$export(module.exports, "addTypenameToDocument", () => $e1dfb923a27ca793$export$43b332f87950a467);
$parcel$export(module.exports, "removeConnectionDirectiveFromDocument", () => $e1dfb923a27ca793$export$74985f3324559867);
$parcel$export(module.exports, "buildQueryFromSelectionSet", () => $e1dfb923a27ca793$export$57c368c23873f32b);
$parcel$export(module.exports, "removeClientSetsFromDocument", () => $e1dfb923a27ca793$export$8eae69e876ee321e);
$parcel$export(module.exports, "canUseWeakMap", () => $e1dfb923a27ca793$export$772fbc04a0ad4ce9);
$parcel$export(module.exports, "cloneDeep", () => $e1dfb923a27ca793$export$629a2bd3f5a49ecc);
$parcel$export(module.exports, "isProduction", () => $e1dfb923a27ca793$export$f15d00aa73aafac4);
$parcel$export(module.exports, "isTest", () => $e1dfb923a27ca793$export$410cbc2864fa25b5);
$parcel$export(module.exports, "tryFunctionOrLogError", () => $e1dfb923a27ca793$export$50a91acae4904909);
$parcel$export(module.exports, "graphQLResultHasError", () => $e1dfb923a27ca793$export$b4df399e879e53ab);
$parcel$export(module.exports, "mergeDeep", () => $e1dfb923a27ca793$export$dd702b3c8240390c);
$parcel$export(module.exports, "mergeDeepArray", () => $e1dfb923a27ca793$export$160070228be94b08);

var $12QNw = parcelRequire("12QNw");

var $1DiV8 = parcelRequire("1DiV8");

var $3VFsf = parcelRequire("3VFsf");

var $fkrBp = parcelRequire("fkrBp");

var $bqMzA = parcelRequire("bqMzA");

var $6cAn5 = parcelRequire("6cAn5");
function $e1dfb923a27ca793$export$dc071f102752d0eb(value) {
    return [
        'StringValue',
        'BooleanValue',
        'EnumValue'
    ].indexOf(value.kind) > -1;
}
function $e1dfb923a27ca793$export$3ff5e9927c3257c6(value) {
    return [
        'IntValue',
        'FloatValue'
    ].indexOf(value.kind) > -1;
}
function $e1dfb923a27ca793$var$isStringValue(value) {
    return value.kind === 'StringValue';
}
function $e1dfb923a27ca793$var$isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function $e1dfb923a27ca793$var$isIntValue(value) {
    return value.kind === 'IntValue';
}
function $e1dfb923a27ca793$var$isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function $e1dfb923a27ca793$var$isVariable(value) {
    return value.kind === 'Variable';
}
function $e1dfb923a27ca793$var$isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function $e1dfb923a27ca793$var$isListValue(value) {
    return value.kind === 'ListValue';
}
function $e1dfb923a27ca793$var$isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function $e1dfb923a27ca793$var$isNullValue(value) {
    return value.kind === 'NullValue';
}
function $e1dfb923a27ca793$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($e1dfb923a27ca793$var$isIntValue(value) || $e1dfb923a27ca793$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($e1dfb923a27ca793$var$isBooleanValue(value) || $e1dfb923a27ca793$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($e1dfb923a27ca793$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $e1dfb923a27ca793$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($e1dfb923a27ca793$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($e1dfb923a27ca793$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $e1dfb923a27ca793$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($e1dfb923a27ca793$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($e1dfb923a27ca793$var$isNullValue(value)) argObj[name.value] = null;
    else throw new (0, $1DiV8.InvariantError)(17);
}
function $e1dfb923a27ca793$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $e1dfb923a27ca793$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $e1dfb923a27ca793$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $e1dfb923a27ca793$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $e1dfb923a27ca793$var$KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export'
];
function $e1dfb923a27ca793$export$3cdb6c178b88cabe(fieldName, args, directives) {
    if (directives && directives['connection'] && directives['connection']['key']) {
        if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        } else return directives['connection']['key'];
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = (0, (/*@__PURE__*/$parcel$interopDefault($fkrBp)))(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($e1dfb923a27ca793$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
        else completeFieldName += "@" + key;
    });
    return completeFieldName;
}
function $e1dfb923a27ca793$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $e1dfb923a27ca793$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $e1dfb923a27ca793$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $e1dfb923a27ca793$export$fb56ad75dd311c12(selection) {
    return selection.kind === 'Field';
}
function $e1dfb923a27ca793$export$22a1cdafaf27bcff(selection) {
    return selection.kind === 'InlineFragment';
}
function $e1dfb923a27ca793$export$e33b89a9aa87695(idObject) {
    return idObject && idObject.type === 'id' && typeof idObject.generated === 'boolean';
}
function $e1dfb923a27ca793$export$b124f125e34d720a(idConfig, generated) {
    if (generated === void 0) generated = false;
    return (0, $3VFsf.__assign)({
        type: 'id',
        generated: generated
    }, typeof idConfig === 'string' ? {
        id: idConfig,
        typename: undefined
    } : idConfig);
}
function $e1dfb923a27ca793$export$226c1c6d1a5b660a(jsonObject) {
    return jsonObject != null && typeof jsonObject === 'object' && jsonObject.type === 'json';
}
function $e1dfb923a27ca793$var$defaultValueFromVariable(node) {
    throw new (0, $1DiV8.InvariantError)(18);
}
function $e1dfb923a27ca793$export$b3db129ed867b445(node, onVariable) {
    if (onVariable === void 0) onVariable = $e1dfb923a27ca793$var$defaultValueFromVariable;
    switch(node.kind){
        case 'Variable':
            return onVariable(node);
        case 'NullValue':
            return null;
        case 'IntValue':
            return parseInt(node.value, 10);
        case 'FloatValue':
            return parseFloat(node.value);
        case 'ListValue':
            return node.values.map(function(v) {
                return $e1dfb923a27ca793$export$b3db129ed867b445(v, onVariable);
            });
        case 'ObjectValue':
            var value = {};
            for(var _i = 0, _a = node.fields; _i < _a.length; _i++){
                var field = _a[_i];
                value[field.name.value] = $e1dfb923a27ca793$export$b3db129ed867b445(field.value, onVariable);
            }
            return value;
        default:
            return node.value;
    }
}
function $e1dfb923a27ca793$export$2a7f471142984a91(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function(directive) {
            directiveObj_1[directive.name.value] = $e1dfb923a27ca793$export$3f5a60fb6a781b4f(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function $e1dfb923a27ca793$export$3dc388a5f013b4a5(selection, variables) {
    if (variables === void 0) variables = {};
    return $e1dfb923a27ca793$export$b7bdffb7e6f1ef53(selection.directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables[ifArgument.value.name.value];
            (0, $1DiV8.invariant)(evaledValue !== void 0, 13);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function $e1dfb923a27ca793$export$1b217de6ce18b9a(doc) {
    var names = [];
    (0, $12QNw.visit)(doc, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
function $e1dfb923a27ca793$export$2dafb573e282fe8d(names, doc) {
    return $e1dfb923a27ca793$export$1b217de6ce18b9a(doc).some(function(name) {
        return names.indexOf(name) > -1;
    });
}
function $e1dfb923a27ca793$export$8d1e9e5bbfa5d09a(document) {
    return document && $e1dfb923a27ca793$export$2dafb573e282fe8d([
        'client'
    ], document) && $e1dfb923a27ca793$export$2dafb573e282fe8d([
        'export'
    ], document);
}
function $e1dfb923a27ca793$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function $e1dfb923a27ca793$export$b7bdffb7e6f1ef53(directives) {
    return directives ? directives.filter($e1dfb923a27ca793$var$isInclusionDirective).map(function(directive) {
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $1DiV8.invariant)(directiveArguments && directiveArguments.length === 1, 14);
        var ifArgument = directiveArguments[0];
        (0, $1DiV8.invariant)(ifArgument.name && ifArgument.name.value === 'if', 15);
        var ifValue = ifArgument.value;
        (0, $1DiV8.invariant)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 16);
        return {
            directive: directive,
            ifArgument: ifArgument
        };
    }) : [];
}
function $e1dfb923a27ca793$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function(definition) {
        if (definition.kind === 'OperationDefinition') throw new (0, $1DiV8.InvariantError)(11);
        if (definition.kind === 'FragmentDefinition') fragments.push(definition);
    });
    if (typeof actualFragmentName === 'undefined') {
        (0, $1DiV8.invariant)(fragments.length === 1, 12);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, document), {
        definitions: (0, $3VFsf.__spreadArrays)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions)
    });
    return query;
}
function $e1dfb923a27ca793$export$e6e34fd1f2686227(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    sources.forEach(function(source) {
        if (typeof source === 'undefined' || source === null) return;
        Object.keys(source).forEach(function(key) {
            target[key] = source[key];
        });
    });
    return target;
}
function $e1dfb923a27ca793$export$a92e7a440b22bdf0(doc) {
    $e1dfb923a27ca793$export$a7d0d8111d2386df(doc);
    var mutationDef = doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.operation === 'mutation';
    })[0];
    (0, $1DiV8.invariant)(mutationDef, 1);
    return mutationDef;
}
function $e1dfb923a27ca793$export$a7d0d8111d2386df(doc) {
    (0, $1DiV8.invariant)(doc && doc.kind === 'Document', 2);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== 'FragmentDefinition';
    }).map(function(definition) {
        if (definition.kind !== 'OperationDefinition') throw new (0, $1DiV8.InvariantError)(3);
        return definition;
    });
    (0, $1DiV8.invariant)(operations.length <= 1, 4);
    return doc;
}
function $e1dfb923a27ca793$export$7a5b1fa979d2c158(doc) {
    $e1dfb923a27ca793$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition';
    })[0];
}
function $e1dfb923a27ca793$export$78a8e95d8d43ad7f(document) {
    var def = $e1dfb923a27ca793$export$7a5b1fa979d2c158(document);
    (0, $1DiV8.invariant)(def, 5);
    return def;
}
function $e1dfb923a27ca793$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $e1dfb923a27ca793$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'FragmentDefinition';
    });
}
function $e1dfb923a27ca793$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $e1dfb923a27ca793$export$7a5b1fa979d2c158(doc);
    (0, $1DiV8.invariant)(queryDef && queryDef.operation === 'query', 6);
    return queryDef;
}
function $e1dfb923a27ca793$export$772111caef41b3f5(doc) {
    (0, $1DiV8.invariant)(doc.kind === 'Document', 7);
    (0, $1DiV8.invariant)(doc.definitions.length <= 1, 8);
    var fragmentDef = doc.definitions[0];
    (0, $1DiV8.invariant)(fragmentDef.kind === 'FragmentDefinition', 9);
    return fragmentDef;
}
function $e1dfb923a27ca793$export$f431198736b7f96d(queryDoc) {
    $e1dfb923a27ca793$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' || operation === 'mutation' || operation === 'subscription') return definition;
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw new (0, $1DiV8.InvariantError)(10);
}
function $e1dfb923a27ca793$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $e1dfb923a27ca793$export$84c19026e616569e(definition) {
    if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions.filter(function(_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        }).map(function(_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            $e1dfb923a27ca793$export$a1dab82d368d6525(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return $e1dfb923a27ca793$export$e6e34fd1f2686227.apply(void 0, (0, $3VFsf.__spreadArrays)([
            {}
        ], defaultValues));
    }
    return {};
}
function $e1dfb923a27ca793$export$55ead6c9e4eac970(operation) {
    var names = new Set();
    if (operation.variableDefinitions) for(var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++){
        var definition = _a[_i];
        names.add(definition.variable.name.value);
    }
    return names;
}
function $e1dfb923a27ca793$var$filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function(elem, i) {
        if (test.call(this, elem, i, array)) array[target++] = elem;
    }, context);
    array.length = target;
    return array;
}
var $e1dfb923a27ca793$var$TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename'
    }
};
function $e1dfb923a27ca793$var$isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function(selection) {
        return selection.kind === 'FragmentSpread' && $e1dfb923a27ca793$var$isEmpty(fragments[selection.name.value], fragments);
    });
}
function $e1dfb923a27ca793$var$nullIfDocIsEmpty(doc) {
    return $e1dfb923a27ca793$var$isEmpty($e1dfb923a27ca793$export$7a5b1fa979d2c158(doc) || $e1dfb923a27ca793$export$772111caef41b3f5(doc), $e1dfb923a27ca793$export$193789b4c8246dd4($e1dfb923a27ca793$export$5320a7ba9466a3df(doc))) ? null : doc;
}
function $e1dfb923a27ca793$var$getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function(dir) {
            return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
        });
    };
}
function $e1dfb923a27ca793$export$e5ae0530da5fe96c(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, $12QNw.visit)(doc, {
        Variable: {
            enter: function(node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') variablesInUse[node.name.value] = true;
            }
        },
        Field: {
            enter: function(node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function(directive) {
                        return directive.remove;
                    });
                    if (shouldRemoveField && node.directives && node.directives.some($e1dfb923a27ca793$var$getDirectiveMatcher(directives))) {
                        if (node.arguments) node.arguments.forEach(function(arg) {
                            if (arg.value.kind === 'Variable') variablesToRemove.push({
                                name: arg.value.name.value
                            });
                        });
                        if (node.selectionSet) $e1dfb923a27ca793$var$getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function(frag) {
                            fragmentSpreadsToRemove.push({
                                name: frag.name.value
                            });
                        });
                        return null;
                    }
                }
            }
        },
        FragmentSpread: {
            enter: function(node) {
                fragmentSpreadsInUse[node.name.value] = true;
            }
        },
        Directive: {
            enter: function(node) {
                if ($e1dfb923a27ca793$var$getDirectiveMatcher(directives)(node)) return null;
            }
        }
    }));
    if (modifiedDoc && $e1dfb923a27ca793$var$filterInPlace(variablesToRemove, function(v) {
        return !variablesInUse[v.name];
    }).length) modifiedDoc = $e1dfb923a27ca793$export$ecd5bb739c4a8b38(variablesToRemove, modifiedDoc);
    if (modifiedDoc && $e1dfb923a27ca793$var$filterInPlace(fragmentSpreadsToRemove, function(fs) {
        return !fragmentSpreadsInUse[fs.name];
    }).length) modifiedDoc = $e1dfb923a27ca793$export$7c9d17c333033c13(fragmentSpreadsToRemove, modifiedDoc);
    return modifiedDoc;
}
function $e1dfb923a27ca793$export$43b332f87950a467(doc) {
    return (0, $12QNw.visit)($e1dfb923a27ca793$export$a7d0d8111d2386df(doc), {
        SelectionSet: {
            enter: function(node, _key, parent) {
                if (parent && parent.kind === 'OperationDefinition') return;
                var selections = node.selections;
                if (!selections) return;
                var skip = selections.some(function(selection) {
                    return $e1dfb923a27ca793$export$fb56ad75dd311c12(selection) && (selection.name.value === '__typename' || selection.name.value.lastIndexOf('__', 0) === 0);
                });
                if (skip) return;
                var field = parent;
                if ($e1dfb923a27ca793$export$fb56ad75dd311c12(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === 'export';
                })) return;
                return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, node), {
                    selections: (0, $3VFsf.__spreadArrays)(selections, [
                        $e1dfb923a27ca793$var$TYPENAME_FIELD
                    ])
                });
            }
        }
    });
}
var $e1dfb923a27ca793$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) !directive.arguments || directive.arguments.some(function(arg) {
            return arg.name.value === 'key';
        });
        return willRemove;
    }
};
function $e1dfb923a27ca793$export$74985f3324559867(doc) {
    return $e1dfb923a27ca793$export$e5ae0530da5fe96c([
        $e1dfb923a27ca793$var$connectionRemoveConfig
    ], $e1dfb923a27ca793$export$a7d0d8111d2386df(doc));
}
function $e1dfb923a27ca793$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $e1dfb923a27ca793$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $e1dfb923a27ca793$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!$e1dfb923a27ca793$export$fb56ad75dd311c12(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($e1dfb923a27ca793$var$getDirectiveMatcher(directives)) || nestedCheck && $e1dfb923a27ca793$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $e1dfb923a27ca793$export$deed3420cb5d2e1d(directives, doc) {
    $e1dfb923a27ca793$export$a7d0d8111d2386df(doc);
    var parentPath;
    return $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, $12QNw.visit)(doc, {
        SelectionSet: {
            enter: function(node, _key, _parent, path) {
                var currentPath = path.join('-');
                if (!parentPath || currentPath === parentPath || !currentPath.startsWith(parentPath)) {
                    if (node.selections) {
                        var selectionsWithDirectives = node.selections.filter(function(selection) {
                            return $e1dfb923a27ca793$var$hasDirectivesInSelection(directives, selection);
                        });
                        if ($e1dfb923a27ca793$var$hasDirectivesInSelectionSet(directives, node, false)) parentPath = currentPath;
                        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, node), {
                            selections: selectionsWithDirectives
                        });
                    } else return null;
                }
            }
        }
    }));
}
function $e1dfb923a27ca793$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === 'Variable' && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $e1dfb923a27ca793$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $e1dfb923a27ca793$var$getArgumentMatcher(config);
    return $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, $12QNw.visit)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, node), {
                    variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    })
                });
            }
        },
        Field: {
            enter: function(node) {
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $e1dfb923a27ca793$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, $12QNw.visit)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $e1dfb923a27ca793$var$getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function(selection) {
        if (($e1dfb923a27ca793$export$fb56ad75dd311c12(selection) || $e1dfb923a27ca793$export$22a1cdafaf27bcff(selection)) && selection.selectionSet) $e1dfb923a27ca793$var$getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function(frag) {
            return allFragments.push(frag);
        });
        else if (selection.kind === 'FragmentSpread') allFragments.push(selection);
    });
    return allFragments;
}
function $e1dfb923a27ca793$export$57c368c23873f32b(document) {
    var definition = $e1dfb923a27ca793$export$f431198736b7f96d(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') return document;
    var modifiedDoc = (0, $12QNw.visit)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, node), {
                    operation: 'query'
                });
            }
        }
    });
    return modifiedDoc;
}
function $e1dfb923a27ca793$export$8eae69e876ee321e(document) {
    $e1dfb923a27ca793$export$a7d0d8111d2386df(document);
    var modifiedDoc = $e1dfb923a27ca793$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === 'client';
            },
            remove: true
        }
    ], document);
    if (modifiedDoc) modifiedDoc = (0, $12QNw.visit)(modifiedDoc, {
        FragmentDefinition: {
            enter: function(node) {
                if (node.selectionSet) {
                    var isTypenameOnly = node.selectionSet.selections.every(function(selection) {
                        return $e1dfb923a27ca793$export$fb56ad75dd311c12(selection) && selection.name.value === '__typename';
                    });
                    if (isTypenameOnly) return null;
                }
            }
        }
    });
    return modifiedDoc;
}
var $e1dfb923a27ca793$export$772fbc04a0ad4ce9 = typeof WeakMap === 'function' && !(typeof navigator === 'object' && navigator.product === 'ReactNative');
var $e1dfb923a27ca793$var$toString = Object.prototype.toString;
function $e1dfb923a27ca793$export$629a2bd3f5a49ecc(value) {
    return $e1dfb923a27ca793$var$cloneDeepHelper(value, new Map());
}
function $e1dfb923a27ca793$var$cloneDeepHelper(val, seen) {
    switch($e1dfb923a27ca793$var$toString.call(val)){
        case "[object Array]":
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $e1dfb923a27ca793$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            if (seen.has(val)) return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $e1dfb923a27ca793$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}
function $e1dfb923a27ca793$export$4bd44a2aa29d3d6e() {
    if (typeof $6cAn5 !== 'undefined' && "production") return "production";
    return 'development';
}
function $e1dfb923a27ca793$export$f0cb0fda19c18b37(env) {
    return $e1dfb923a27ca793$export$4bd44a2aa29d3d6e() === env;
}
function $e1dfb923a27ca793$export$f15d00aa73aafac4() {
    return $e1dfb923a27ca793$export$f0cb0fda19c18b37('production') === true;
}
function $e1dfb923a27ca793$export$df77466336fe5355() {
    return $e1dfb923a27ca793$export$f0cb0fda19c18b37('development') === true;
}
function $e1dfb923a27ca793$export$410cbc2864fa25b5() {
    return $e1dfb923a27ca793$export$f0cb0fda19c18b37('test') === true;
}
function $e1dfb923a27ca793$export$50a91acae4904909(f) {
    try {
        return f();
    } catch (e) {
        if (console.error) console.error(e);
    }
}
function $e1dfb923a27ca793$export$b4df399e879e53ab(result) {
    return result.errors && result.errors.length;
}
function $e1dfb923a27ca793$var$deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function(prop) {
        if (o[prop] !== null && (typeof o[prop] === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) $e1dfb923a27ca793$var$deepFreeze(o[prop]);
    });
    return o;
}
function $e1dfb923a27ca793$export$7f9c177735b71f18(obj) {
    if ($e1dfb923a27ca793$export$df77466336fe5355() || $e1dfb923a27ca793$export$410cbc2864fa25b5()) {
        var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
        if (!symbolIsPolyfilled) return $e1dfb923a27ca793$var$deepFreeze(obj);
    }
    return obj;
}
var $e1dfb923a27ca793$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $e1dfb923a27ca793$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $e1dfb923a27ca793$export$160070228be94b08(sources);
}
function $e1dfb923a27ca793$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var pastCopies = [];
        target = $e1dfb923a27ca793$var$shallowCopyForMerge(target, pastCopies);
        for(var i = 1; i < count; ++i)target = $e1dfb923a27ca793$var$mergeHelper(target, sources[i], pastCopies);
    }
    return target;
}
function $e1dfb923a27ca793$var$isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function $e1dfb923a27ca793$var$mergeHelper(target, source, pastCopies) {
    if ($e1dfb923a27ca793$var$isObject(source) && $e1dfb923a27ca793$var$isObject(target)) {
        if (Object.isExtensible && !Object.isExtensible(target)) target = $e1dfb923a27ca793$var$shallowCopyForMerge(target, pastCopies);
        Object.keys(source).forEach(function(sourceKey) {
            var sourceValue = source[sourceKey];
            if ($e1dfb923a27ca793$var$hasOwnProperty.call(target, sourceKey)) {
                var targetValue = target[sourceKey];
                if (sourceValue !== targetValue) target[sourceKey] = $e1dfb923a27ca793$var$mergeHelper($e1dfb923a27ca793$var$shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
            } else target[sourceKey] = sourceValue;
        });
        return target;
    }
    return source;
}
function $e1dfb923a27ca793$var$shallowCopyForMerge(value, pastCopies) {
    if (value !== null && typeof value === 'object' && pastCopies.indexOf(value) < 0) {
        if (Array.isArray(value)) value = value.slice(0);
        else value = (0, $3VFsf.__assign)({
            __proto__: Object.getPrototypeOf(value)
        }, value);
        pastCopies.push(value);
    }
    return value;
}
var $e1dfb923a27ca793$var$haveWarned = Object.create({});
function $e1dfb923a27ca793$export$49d47c8e549bfaf9(msg, type) {
    if (type === void 0) type = 'warn';
    if (!$e1dfb923a27ca793$export$f15d00aa73aafac4() && !$e1dfb923a27ca793$var$haveWarned[msg]) {
        if (!$e1dfb923a27ca793$export$410cbc2864fa25b5()) $e1dfb923a27ca793$var$haveWarned[msg] = true;
        if (type === 'error') console.error(msg);
        else console.warn(msg);
    }
}
function $e1dfb923a27ca793$export$c54efeba029d4fe8(data) {
    return JSON.parse(JSON.stringify(data));
}

});
parcelRegister("12QNw", function(module, exports) {

$parcel$export(module.exports, "BREAK", () => $0c2eeee3dc68c900$export$a89c95c098ac2a58);
$parcel$export(module.exports, "visit", () => $0c2eeee3dc68c900$export$bf638b60ea8b89b7);

var $yEDl8 = parcelRequire("yEDl8");

var $98oUl = parcelRequire("98oUl");
var $0c2eeee3dc68c900$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        // or removed in the future.
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
var $0c2eeee3dc68c900$export$a89c95c098ac2a58 = Object.freeze({});
function $0c2eeee3dc68c900$export$bf638b60ea8b89b7(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $0c2eeee3dc68c900$export$4fcd777a40ccf407;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, $98oUl.isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, $yEDl8.default)(node), "."));
            var visitFn = $0c2eeee3dc68c900$export$c9c25cca74db6e70(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $0c2eeee3dc68c900$export$a89c95c098ac2a58) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, $98oUl.isNode)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function $0c2eeee3dc68c900$export$728beebeea393478(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = $0c2eeee3dc68c900$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $0c2eeee3dc68c900$export$a89c95c098ac2a58) skipping[i] = $0c2eeee3dc68c900$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = $0c2eeee3dc68c900$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $0c2eeee3dc68c900$export$a89c95c098ac2a58) skipping[i] = $0c2eeee3dc68c900$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
function $0c2eeee3dc68c900$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === 'function') // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === 'function') // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === 'function') // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === 'function') // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

});
parcelRegister("yEDl8", function(module, exports) {

$parcel$export(module.exports, "default", () => $0682b20f61c706c4$export$2e2bcd8739ae039);

var $7NbHY = parcelRequire("7NbHY");
function $0682b20f61c706c4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $0682b20f61c706c4$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $0682b20f61c706c4$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $0682b20f61c706c4$var$_typeof(obj);
}
var $0682b20f61c706c4$var$MAX_ARRAY_LENGTH = 10;
var $0682b20f61c706c4$var$MAX_RECURSIVE_DEPTH = 2;
function $0682b20f61c706c4$export$2e2bcd8739ae039(value) {
    return $0682b20f61c706c4$var$formatValue(value, []);
}
function $0682b20f61c706c4$var$formatValue(value, seenValues) {
    switch($0682b20f61c706c4$var$_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return $0682b20f61c706c4$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $0682b20f61c706c4$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $0682b20f61c706c4$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : $0682b20f61c706c4$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $0682b20f61c706c4$var$formatArray(value, seenValues);
    return $0682b20f61c706c4$var$formatObject(value, seenValues);
}
function $0682b20f61c706c4$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > $0682b20f61c706c4$var$MAX_RECURSIVE_DEPTH) return '[' + $0682b20f61c706c4$var$getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = $0682b20f61c706c4$var$formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function $0682b20f61c706c4$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $0682b20f61c706c4$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min($0682b20f61c706c4$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($0682b20f61c706c4$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function $0682b20f61c706c4$var$getCustomFn(object) {
    var customInspectFn = object[String((0, $7NbHY.default))];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function $0682b20f61c706c4$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});
parcelRegister("7NbHY", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ac63109fd04dae2$export$2e2bcd8739ae039);
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $5ac63109fd04dae2$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var $5ac63109fd04dae2$export$2e2bcd8739ae039 = $5ac63109fd04dae2$var$nodejsCustomInspectSymbol;

});


parcelRegister("98oUl", function(module, exports) {

$parcel$export(module.exports, "Location", () => $6a682e985d2af3c5$export$18a2be9195644f38);
$parcel$export(module.exports, "Token", () => $6a682e985d2af3c5$export$50792b0e93539fde);
$parcel$export(module.exports, "isNode", () => $6a682e985d2af3c5$export$8ee0fc9ee280b4ee);

var $520Pd = parcelRequire("520Pd");
var $6a682e985d2af3c5$export$18a2be9195644f38 = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $520Pd.default)($6a682e985d2af3c5$export$18a2be9195644f38);
var $6a682e985d2af3c5$export$50792b0e93539fde = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $520Pd.default)($6a682e985d2af3c5$export$50792b0e93539fde);
function $6a682e985d2af3c5$export$8ee0fc9ee280b4ee(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === 'string';
} /**
 * The list of all possible AST node types.
 */ 

});
parcelRegister("520Pd", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a9dc77a0e8a6949$export$2e2bcd8739ae039);

var $fM9AB = parcelRequire("fM9AB");

var $7NbHY = parcelRequire("7NbHY");
function $3a9dc77a0e8a6949$export$2e2bcd8739ae039(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === 'function' || (0, $fM9AB.default)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if (0, $7NbHY.default) classObject.prototype[0, $7NbHY.default] = fn;
}

});
parcelRegister("fM9AB", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7c2c6f03066157d$export$2e2bcd8739ae039);
function $b7c2c6f03066157d$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}

});




parcelRegister("1DiV8", function(module, exports) {

$parcel$export(module.exports, "InvariantError", () => $13081c324be1f9ab$export$cea12affaee22fe8);
$parcel$export(module.exports, "invariant", () => $13081c324be1f9ab$export$f5708dca728d7177);

var $3VFsf = parcelRequire("3VFsf");

var $6cAn5 = parcelRequire("6cAn5");
var $13081c324be1f9ab$var$genericMessage = "Invariant Violation";
var $13081c324be1f9ab$var$_a = Object.setPrototypeOf, $13081c324be1f9ab$var$setPrototypeOf = $13081c324be1f9ab$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $13081c324be1f9ab$var$_a;
var $13081c324be1f9ab$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $13081c324be1f9ab$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $13081c324be1f9ab$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $13081c324be1f9ab$var$genericMessage;
        $13081c324be1f9ab$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $13081c324be1f9ab$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $13081c324be1f9ab$export$cea12affaee22fe8(message);
}
function $13081c324be1f9ab$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $13081c324be1f9ab$var$wrapConsoleMethod("warn");
    invariant.error = $13081c324be1f9ab$var$wrapConsoleMethod("error");
})($13081c324be1f9ab$export$f5708dca728d7177 || ($13081c324be1f9ab$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $13081c324be1f9ab$export$e54fe5b0f43758f7 = {
    env: {}
};
if (typeof $6cAn5 === "object") $13081c324be1f9ab$export$e54fe5b0f43758f7 = $6cAn5;
else try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($13081c324be1f9ab$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $13081c324be1f9ab$var$invariant$1 = $13081c324be1f9ab$export$f5708dca728d7177;
var $13081c324be1f9ab$export$2e2bcd8739ae039 = $13081c324be1f9ab$var$invariant$1;

});

parcelRegister("fkrBp", function(module, exports) {
'use strict';
module.exports = function(data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = {
        cmp: opts
    };
    var cycles = typeof opts.cycles === 'boolean' ? opts.cycles : false;
    var cmp = opts.cmp && function(f) {
        return function(node) {
            return function(a, b) {
                var aobj = {
                    key: a,
                    value: node[a]
                };
                var bobj = {
                    key: b,
                    value: node[b]
                };
                return f(aobj, bobj);
            };
        };
    }(opts.cmp);
    var seen = [];
    return function stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') node = node.toJSON();
        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for(i = 0; i < node.length; i++){
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }
        if (node === null) return 'null';
        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for(i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node[key]);
            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    }(data);
};

});

parcelRegister("bqMzA", function(module, exports) {

$parcel$export(module.exports, "equal", () => $8527cd05038b1b96$export$411ce8e5a71e3069);
var $8527cd05038b1b96$var$_a = Object.prototype, $8527cd05038b1b96$var$toString = $8527cd05038b1b96$var$_a.toString, $8527cd05038b1b96$var$hasOwnProperty = $8527cd05038b1b96$var$_a.hasOwnProperty;
var $8527cd05038b1b96$var$previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */ function $8527cd05038b1b96$export$411ce8e5a71e3069(a, b) {
    try {
        return $8527cd05038b1b96$var$check(a, b);
    } finally{
        $8527cd05038b1b96$var$previousComparisons.clear();
    }
}
function $8527cd05038b1b96$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = $8527cd05038b1b96$var$toString.call(a);
    var bTag = $8527cd05038b1b96$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            if ($8527cd05038b1b96$var$previouslyCompared(a, b)) return true;
            var aKeys = Object.keys(a);
            var bKeys = Object.keys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length) return false;
            // Now make sure they have the same keys.
            for(var k = 0; k < keyCount; ++k){
                if (!$8527cd05038b1b96$var$hasOwnProperty.call(b, aKeys[k])) return false;
            }
            // Finally, check deep equality of all child properties.
            for(var k = 0; k < keyCount; ++k){
                var key = aKeys[k];
                if (!$8527cd05038b1b96$var$check(a[key], b[key])) return false;
            }
            return true;
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]':
            if (a.size !== b.size) return false;
            if ($8527cd05038b1b96$var$previouslyCompared(a, b)) return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while(true){
                var info = aIterator.next();
                if (info.done) break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) return false;
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !$8527cd05038b1b96$var$check(aValue, b.get(aKey))) return false;
            }
            return true;
    }
    // Otherwise the values are not equal.
    return false;
}
function $8527cd05038b1b96$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = $8527cd05038b1b96$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $8527cd05038b1b96$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}
var $8527cd05038b1b96$export$2e2bcd8739ae039 = $8527cd05038b1b96$export$411ce8e5a71e3069;

});


parcelRegister("clSzL", function(module, exports) {

$parcel$export(module.exports, "fromError", () => fromError);
$parcel$export(module.exports, "ApolloLink", () => ApolloLink);
$parcel$export(module.exports, "from", () => from);
$parcel$export(module.exports, "execute", () => execute);
$parcel$export(module.exports, "Observable", () => (parcelRequire("aS6b9")).default);

var $aS6b9 = parcelRequire("aS6b9");

var $1DiV8 = parcelRequire("1DiV8");

var $3VFsf = parcelRequire("3VFsf");

var $jojW6 = parcelRequire("jojW6");
function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context'
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw new (0, $1DiV8.InvariantError)(2);
    }
    return operation;
}
var LinkError = function(_super) {
    (0, $3VFsf.__extends)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error);
function isTerminating(link) {
    return link.request.length <= 1;
}
function toPromise(observable) {
    var completed = false;
    return new Promise(function(resolve, reject) {
        observable.subscribe({
            next: function(data) {
                if (completed) ;
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject
        });
    });
}
var makePromise = toPromise;
function fromPromise(promise) {
    return new (0, $aS6b9.default)(function(observer) {
        promise.then(function(value) {
            observer.next(value);
            observer.complete();
        }).catch(observer.error.bind(observer));
    });
}
function fromError(errorValue) {
    return new (0, $aS6b9.default)(function(observer) {
        observer.error(errorValue);
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== 'string' ? (0, $jojW6.getOperationName)(transformedOperation.query) : '';
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = (0, $3VFsf.__assign)({}, starting);
    var setContext = function(next) {
        if (typeof next === 'function') context = (0, $3VFsf.__assign)({}, context, next(context));
        else context = (0, $3VFsf.__assign)({}, context, next);
    };
    var getContext = function() {
        return (0, $3VFsf.__assign)({}, context);
    };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function() {
            return getKey(operation);
        }
    });
    return operation;
}
function getKey(operation) {
    var query = operation.query, variables = operation.variables, operationName = operation.operationName;
    return JSON.stringify([
        operationName,
        query,
        variables
    ]);
}
function passthrough(op, forward) {
    return forward ? forward(op) : (0, $aS6b9.default).of();
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function empty() {
    return new ApolloLink(function() {
        return (0, $aS6b9.default).of();
    });
}
function from(links) {
    if (links.length === 0) return empty();
    return links.map(toLink).reduce(function(x, y) {
        return x.concat(y);
    });
}
function split(test, left, right) {
    var leftLink = toLink(left);
    var rightLink = toLink(right || new ApolloLink(passthrough));
    if (isTerminating(leftLink) && isTerminating(rightLink)) return new ApolloLink(function(operation) {
        return test(operation) ? leftLink.request(operation) || (0, $aS6b9.default).of() : rightLink.request(operation) || (0, $aS6b9.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return test(operation) ? leftLink.request(operation, forward) || (0, $aS6b9.default).of() : rightLink.request(operation, forward) || (0, $aS6b9.default).of();
    });
}
var concat = function(first, second) {
    var firstLink = toLink(first);
    if (isTerminating(firstLink)) return firstLink;
    var nextLink = toLink(second);
    if (isTerminating(nextLink)) return new ApolloLink(function(operation) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op) || (0, $aS6b9.default).of();
        }) || (0, $aS6b9.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op, forward) || (0, $aS6b9.default).of();
        }) || (0, $aS6b9.default).of();
    });
};
var ApolloLink = function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw new (0, $1DiV8.InvariantError)(1);
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}();
function execute(link, operation) {
    return link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || (0, $aS6b9.default).of();
}

});
parcelRegister("aS6b9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ea3bd7f736c1eb4$export$2e2bcd8739ae039);

var $4osjv = parcelRequire("4osjv");
var $7ea3bd7f736c1eb4$export$77cea355fa80b5f4 = (0, (/*@__PURE__*/$parcel$interopDefault($4osjv)));
var $7ea3bd7f736c1eb4$export$2e2bcd8739ae039 = $7ea3bd7f736c1eb4$export$77cea355fa80b5f4;

});
parcelRegister("4osjv", function(module, exports) {

module.exports = (parcelRequire("k0hXK")).Observable;

});
parcelRegister("k0hXK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Observable = void 0;
function $e901bdc1c9a5edd7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e901bdc1c9a5edd7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e901bdc1c9a5edd7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e901bdc1c9a5edd7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e901bdc1c9a5edd7$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
// === Symbol Support ===
var $e901bdc1c9a5edd7$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $e901bdc1c9a5edd7$var$hasSymbol = function(name) {
    return $e901bdc1c9a5edd7$var$hasSymbols() && Boolean(Symbol[name]);
};
var $e901bdc1c9a5edd7$var$getSymbol = function(name) {
    return $e901bdc1c9a5edd7$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($e901bdc1c9a5edd7$var$hasSymbols() && !$e901bdc1c9a5edd7$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $e901bdc1c9a5edd7$var$SymbolIterator = $e901bdc1c9a5edd7$var$getSymbol('iterator');
var $e901bdc1c9a5edd7$var$SymbolObservable = $e901bdc1c9a5edd7$var$getSymbol('observable');
var $e901bdc1c9a5edd7$var$SymbolSpecies = $e901bdc1c9a5edd7$var$getSymbol('species'); // === Abstract Operations ===
function $e901bdc1c9a5edd7$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $e901bdc1c9a5edd7$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$e901bdc1c9a5edd7$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $e901bdc1c9a5edd7$var$Observable;
}
function $e901bdc1c9a5edd7$var$isObservable(x) {
    return x instanceof $e901bdc1c9a5edd7$var$Observable; // SPEC: Brand check
}
function $e901bdc1c9a5edd7$var$hostReportError(e) {
    if ($e901bdc1c9a5edd7$var$hostReportError.log) $e901bdc1c9a5edd7$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $e901bdc1c9a5edd7$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $e901bdc1c9a5edd7$var$hostReportError(e);
        }
    });
}
function $e901bdc1c9a5edd7$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $e901bdc1c9a5edd7$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $e901bdc1c9a5edd7$var$hostReportError(e);
    }
}
function $e901bdc1c9a5edd7$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $e901bdc1c9a5edd7$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $e901bdc1c9a5edd7$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $e901bdc1c9a5edd7$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $e901bdc1c9a5edd7$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $e901bdc1c9a5edd7$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $e901bdc1c9a5edd7$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $e901bdc1c9a5edd7$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $e901bdc1c9a5edd7$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $e901bdc1c9a5edd7$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $e901bdc1c9a5edd7$var$enqueue(function() {
            return $e901bdc1c9a5edd7$var$flushSubscription(subscription);
        });
        return;
    }
    $e901bdc1c9a5edd7$var$notifySubscription(subscription, type, value);
}
var $e901bdc1c9a5edd7$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        $e901bdc1c9a5edd7$var$_classCallCheck(this, Subscription);
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $e901bdc1c9a5edd7$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    $e901bdc1c9a5edd7$var$_createClass(Subscription, [
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                if (this._state !== 'closed') {
                    $e901bdc1c9a5edd7$var$closeSubscription(this);
                    $e901bdc1c9a5edd7$var$cleanupSubscription(this);
                }
            }
        },
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $e901bdc1c9a5edd7$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        $e901bdc1c9a5edd7$var$_classCallCheck(this, SubscriptionObserver);
        this._subscription = subscription;
    }
    $e901bdc1c9a5edd7$var$_createClass(SubscriptionObserver, [
        {
            key: "next",
            value: function next(value) {
                $e901bdc1c9a5edd7$var$onNotify(this._subscription, 'next', value);
            }
        },
        {
            key: "error",
            value: function error(value) {
                $e901bdc1c9a5edd7$var$onNotify(this._subscription, 'error', value);
            }
        },
        {
            key: "complete",
            value: function complete() {
                $e901bdc1c9a5edd7$var$onNotify(this._subscription, 'complete');
            }
        },
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $e901bdc1c9a5edd7$var$Observable = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        $e901bdc1c9a5edd7$var$_classCallCheck(this, Observable);
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    $e901bdc1c9a5edd7$var$_createClass(Observable, [
        {
            key: "subscribe",
            value: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) observer = {
                    next: observer,
                    error: arguments[1],
                    complete: arguments[2]
                };
                return new $e901bdc1c9a5edd7$var$Subscription(observer, this._subscriber);
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (typeof fn !== 'function') {
                        reject(new TypeError(fn + ' is not a function'));
                        return;
                    }
                    function done() {
                        subscription.unsubscribe();
                        resolve();
                    }
                    var subscription = _this.subscribe({
                        next: function(value) {
                            try {
                                fn(value, done);
                            } catch (e) {
                                reject(e);
                                subscription.unsubscribe();
                            }
                        },
                        error: reject,
                        complete: resolve
                    });
                });
            }
        },
        {
            key: "map",
            value: function map(fn) {
                var _this2 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                return new C(function(observer) {
                    return _this2.subscribe({
                        next: function(value) {
                            try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "filter",
            value: function filter(fn) {
                var _this3 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                return new C(function(observer) {
                    return _this3.subscribe({
                        next: function(value) {
                            try {
                                if (!fn(value)) return;
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "reduce",
            value: function reduce(fn) {
                var _this4 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                var hasSeed = arguments.length > 1;
                var hasValue = false;
                var seed = arguments[1];
                var acc = seed;
                return new C(function(observer) {
                    return _this4.subscribe({
                        next: function(value) {
                            var first = !hasValue;
                            hasValue = true;
                            if (!first || hasSeed) try {
                                acc = fn(acc, value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            else acc = value;
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                            observer.next(acc);
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "concat",
            value: function concat() {
                var _this5 = this;
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                return new C(function(observer) {
                    var subscription;
                    var index = 0;
                    function startNext(next) {
                        subscription = next.subscribe({
                            next: function(v) {
                                observer.next(v);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (index === sources.length) {
                                    subscription = undefined;
                                    observer.complete();
                                } else startNext(C.from(sources[index++]));
                            }
                        });
                    }
                    startNext(_this5);
                    return function() {
                        if (subscription) {
                            subscription.unsubscribe();
                            subscription = undefined;
                        }
                    };
                });
            }
        },
        {
            key: "flatMap",
            value: function flatMap(fn) {
                var _this6 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                return new C(function(observer) {
                    var subscriptions = [];
                    var outer = _this6.subscribe({
                        next: function(value) {
                            if (fn) try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            var inner = C.from(value).subscribe({
                                next: function(value) {
                                    observer.next(value);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    var i = subscriptions.indexOf(inner);
                                    if (i >= 0) subscriptions.splice(i, 1);
                                    completeIfDone();
                                }
                            });
                            subscriptions.push(inner);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            completeIfDone();
                        }
                    });
                    function completeIfDone() {
                        if (outer.closed && subscriptions.length === 0) observer.complete();
                    }
                    return function() {
                        subscriptions.forEach(function(s) {
                            return s.unsubscribe();
                        });
                        outer.unsubscribe();
                    };
                });
            }
        },
        {
            key: $e901bdc1c9a5edd7$var$SymbolObservable,
            value: function() {
                return this;
            }
        }
    ], [
        {
            key: "from",
            value: function from(x) {
                var C = typeof this === 'function' ? this : Observable;
                if (x == null) throw new TypeError(x + ' is not an object');
                var method = $e901bdc1c9a5edd7$var$getMethod(x, $e901bdc1c9a5edd7$var$SymbolObservable);
                if (method) {
                    var observable = method.call(x);
                    if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
                    if ($e901bdc1c9a5edd7$var$isObservable(observable) && observable.constructor === C) return observable;
                    return new C(function(observer) {
                        return observable.subscribe(observer);
                    });
                }
                if ($e901bdc1c9a5edd7$var$hasSymbol('iterator')) {
                    method = $e901bdc1c9a5edd7$var$getMethod(x, $e901bdc1c9a5edd7$var$SymbolIterator);
                    if (method) return new C(function(observer) {
                        $e901bdc1c9a5edd7$var$enqueue(function() {
                            if (observer.closed) return;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _item = _step.value;
                                    observer.next(_item);
                                    if (observer.closed) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            observer.complete();
                        });
                    });
                }
                if (Array.isArray(x)) return new C(function(observer) {
                    $e901bdc1c9a5edd7$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < x.length; ++i){
                            observer.next(x[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
                throw new TypeError(x + ' is not observable');
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                var C = typeof this === 'function' ? this : Observable;
                return new C(function(observer) {
                    $e901bdc1c9a5edd7$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < items.length; ++i){
                            observer.next(items[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: $e901bdc1c9a5edd7$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
module.exports.Observable = $e901bdc1c9a5edd7$var$Observable;
if ($e901bdc1c9a5edd7$var$hasSymbols()) Object.defineProperty($e901bdc1c9a5edd7$var$Observable, Symbol('extensions'), {
    value: {
        symbol: $e901bdc1c9a5edd7$var$SymbolObservable,
        hostReportError: $e901bdc1c9a5edd7$var$hostReportError
    },
    configurable: true
});

});






parcelRegister("8UpTw", function(module, exports) {

$parcel$export(module.exports, "ErrorPage", () => $5a72c35b5a5b98e9$export$c120a0e80fd44ca6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $beRD7 = parcelRequire("beRD7");
const $5a72c35b5a5b98e9$export$c120a0e80fd44ca6 = ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5a72c35b5a5b98e9$var$ErrorWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $beRD7.JSErrorPageAsync), {
        error: error
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5a72c35b5a5b98e9$var$ErrorWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhkvuon _syaz1fxt",
            __cmplp.className
        ])
    });
});

});

parcelRegister("8dXDG", function(module, exports) {

$parcel$export(module.exports, "useExperienceAbort", () => $2df1decadd95b490$export$cc92b7ce453f4403);

var $5uXOq = parcelRequire("5uXOq");

var $l9g16 = parcelRequire("l9g16");
const $2df1decadd95b490$export$cc92b7ce453f4403 = ({ experience: experience, attributes: attributes })=>{
    const experienceTracker = (0, $l9g16.useExperienceContext)();
    const self = (0, $5uXOq.useRef)({
        name: experience,
        attributes: attributes,
        experienceTracker: experienceTracker
    });
    self.current.name = experience;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    return (0, $5uXOq.useCallback)((reason, extraAttributes = {})=>{
        const { current: current } = self;
        current.experienceTracker.abort({
            name: current.name,
            reason: reason,
            attributes: {
                ...current.attributes,
                ...extraAttributes
            }
        });
    }, [
        self
    ]);
};

});


parcelRegister("bTIks", function(module, exports) {

$parcel$export(module.exports, "CREATE_OVERVIEW_EXPERIENCE", () => $43e56627abfe9003$export$9b5e8e07ff330ef2);
$parcel$export(module.exports, "EDIT_OVERVIEW_EXPERIENCE", () => $43e56627abfe9003$export$a58227116ceb8b81);
$parcel$export(module.exports, "DELETE_OVERVIEW_EXPERIENCE", () => $43e56627abfe9003$export$e17a11e4247a14f7);
$parcel$export(module.exports, "MODAL_WIDTH", () => $43e56627abfe9003$export$3d931b64f46140b3);

var $gwIPs = parcelRequire("gwIPs");
const $43e56627abfe9003$var$PACKAGE_NAME = 'jiraBusinessEntityOverview';
const $43e56627abfe9003$export$9b5e8e07ff330ef2 = {
    experience: 'create-overview',
    packageName: $43e56627abfe9003$var$PACKAGE_NAME,
    teamName: 'wanjel'
};
const $43e56627abfe9003$export$a58227116ceb8b81 = {
    experience: 'edit-overview',
    packageName: $43e56627abfe9003$var$PACKAGE_NAME,
    teamName: 'wanjel'
};
const $43e56627abfe9003$export$e17a11e4247a14f7 = {
    experience: 'delete-overview',
    packageName: $43e56627abfe9003$var$PACKAGE_NAME,
    teamName: 'wanjel'
};
const $43e56627abfe9003$export$d03d4e78ea5b909a = (0, $gwIPs.gridSize) * 2;
const $43e56627abfe9003$export$57ee5df6bad94642 = 400;
const $43e56627abfe9003$export$7c9c92ba6b198ac4 = (0, $gwIPs.gridSize) * 3;
const $43e56627abfe9003$export$c4232794452dc6e3 = 480;
const $43e56627abfe9003$export$3d931b64f46140b3 = $43e56627abfe9003$export$c4232794452dc6e3 + $43e56627abfe9003$export$57ee5df6bad94642 + $43e56627abfe9003$export$7c9c92ba6b198ac4 * 2 + $43e56627abfe9003$export$d03d4e78ea5b909a * 2;
const $43e56627abfe9003$var$MODAL_DIALOG_MARGIN = 120;
const $43e56627abfe9003$export$68bc124b0fa13de0 = $43e56627abfe9003$export$3d931b64f46140b3 + $43e56627abfe9003$var$MODAL_DIALOG_MARGIN;

});
parcelRegister("gwIPs", function(module, exports) {

$parcel$export(module.exports, "gridSize", () => $80d528dbc2b11cbc$export$6d8204c2cb2e06b8);
$parcel$export(module.exports, "borderRadius", () => $80d528dbc2b11cbc$export$7a57f79000377ca2);
$parcel$export(module.exports, "contentHorizontalSpacing", () => $80d528dbc2b11cbc$export$22dec01f2c854397);
$parcel$export(module.exports, "layers", () => $80d528dbc2b11cbc$export$7be255094ccdc533);

var $k5uoT = parcelRequire("k5uoT");
const $80d528dbc2b11cbc$export$6d8204c2cb2e06b8 = 8;
const $80d528dbc2b11cbc$export$7a57f79000377ca2 = (0, $k5uoT.borderRadius)();
const $80d528dbc2b11cbc$export$22dec01f2c854397 = 40;
const $80d528dbc2b11cbc$export$dab5ea164c6f81a = 100;
const $80d528dbc2b11cbc$export$7be255094ccdc533 = {
    banner: (0, $k5uoT.layers).navigation(),
    card: (0, $k5uoT.layers).card(),
    dialog: (0, $k5uoT.layers).dialog(),
    navigation: (0, $k5uoT.layers).navigation(),
    // left sidebar overrides the bottom shadow of navigation without this
    leftSidebar: (0, $k5uoT.layers).navigation() - 1,
    // right sidebar shows on top of navigation elements without this
    rightSidebar: (0, $k5uoT.layers).navigation() - 1,
    layer: (0, $k5uoT.layers).layer(),
    blanket: (0, $k5uoT.layers).blanket(),
    modal: (0, $k5uoT.layers).modal(),
    flag: (0, $k5uoT.layers).flag(),
    spotlight: (0, $k5uoT.layers).spotlight(),
    tooltip: (0, $k5uoT.layers).tooltip(),
    mobileBanner: $80d528dbc2b11cbc$export$dab5ea164c6f81a
};
const $80d528dbc2b11cbc$export$b3219800bda33a1f = {
    issueIconSize: 16
};

});


parcelRegister("ePB6h", function(module, exports) {

let $acc29b706d6ed2cd$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $acc29b706d6ed2cd$var$load("ffQaD"),
    $acc29b706d6ed2cd$var$load("kvRbA"),
    $acc29b706d6ed2cd$var$load("kNFvF"),
    $acc29b706d6ed2cd$var$load("fdutx")
]).then(()=>parcelRequire('6gB2z'));

});


parcelRegister("i3a7M", function(module, exports) {

$parcel$export(module.exports, "useOverviewsAnalyticsL1", () => $2236103400b31729$export$209953a8bcc0c02c);

var $5uXOq = parcelRequire("5uXOq");






var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $2236103400b31729$var$OVERVIEWS_NAVIGATION_MENU_ITEM = 'overviewsNavigationMenuItem';
const $2236103400b31729$export$209953a8bcc0c02c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const commonAttributes = (0, $5uXOq.useMemo)(()=>({
            level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
            navigationLayer: (0, $ce9c0831aed9ffb3$export$17ff3f7e02c6ac22)
        }), []);
    // fixed item - create overview (+) button on overviews menu (top level)
    const sendCreateOverviewAnalyticsEvent = (0, $5uXOq.useCallback)(({ overviewLimitReached: overviewLimitReached })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$b887e88d8d0739f6)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
            itemId: 'createOverview',
            overviewLimitReached: overviewLimitReached
        };
        (0, $8zOmE.fireUIAnalytics)(event, $2236103400b31729$var$OVERVIEWS_NAVIGATION_MENU_ITEM, attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // custom item - overview menu item that displays overview name (can be expandable menu or a link)
    const sendOverviewMenuItemAnalyticsEvent = (0, $5uXOq.useCallback)(({ overviewId: overviewId })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$3ac911b122986477),
            itemType: (0, $632bd8725b437a12$export$9cbb0f231a0ab7ea),
            itemId: overviewId
        };
        (0, $8zOmE.fireUIAnalytics)(event, $2236103400b31729$var$OVERVIEWS_NAVIGATION_MENU_ITEM, attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    return {
        sendOverviewMenuItemAnalyticsEvent: sendOverviewMenuItemAnalyticsEvent,
        sendCreateOverviewAnalyticsEvent: sendCreateOverviewAnalyticsEvent
    };
};

});

parcelRegister("92djE", function(module, exports) {

$parcel$export(module.exports, "default", () => $9921e9af9b1e8681$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9921e9af9b1e8681$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createOverview: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-overviews.common.section-actions.create-overview",
        "defaultMessage": "Create overview"
    },
    moreThanTenWarning: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-overviews.common.section-actions.more-than-ten-warning",
        "defaultMessage": "You\u2019ve reached the limit of 10 overviews."
    }
});

});


parcelRegister("VgtWG", function(module, exports) {

$parcel$export(module.exports, "Nav4OverviewsDefault", () => $2bb69cfcdc8635b0$export$b582325fc571fa20);

var $5uXOq = parcelRequire("5uXOq");

var $lnznH = parcelRequire("lnznH");
var $cZa9B = parcelRequire("cZa9B");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $jecJ3 = parcelRequire("jecJ3");

var $jhS4y = parcelRequire("jhS4y");

var $46Cti = parcelRequire("46Cti");

var $c16H2 = parcelRequire("c16H2");

var $338xa = parcelRequire("338xa");

var $dQbFB = parcelRequire("dQbFB");

var $eQV8d = parcelRequire("eQV8d");

var $dUyqZ = parcelRequire("dUyqZ");

var $4zcxJ = parcelRequire("4zcxJ");

var $koeKL = parcelRequire("koeKL");


var $cCqmP = parcelRequire("cCqmP");
function $2bb69cfcdc8635b0$export$b582325fc571fa20({ isExpanded: isExpanded, actionsOnHover: actionsOnHover }) {
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).OVERVIEWS);
    const cloudId = (0, $koeKL.useCloudId)();
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId
        }), [
        cloudId
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $cCqmP.asyncOverviewsContentViewQuery), entryPointParams);
    const triggerRef = (0, $4zcxJ.useExpandableEntryPointTrigger)(entryPointActions);
    // If starting life expanded, make sure to load.
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (isExpanded) entryPointActions.load();
    }, [
        entryPointActions,
        isExpanded
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: (0, $jhS4y.MENU_ID_OVERVIEWS),
        onSystemToggle: (hasExpanded)=>{
            if (hasExpanded) entryPointActions.load();
        },
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) {
                entryPointActions.load();
                sendSectionItemAnalyticsEvent({
                    menuId: (0, $46Cti.L1_MENU_ID).OVERVIEWS,
                    sectionItem: (0, $jecJ3.SECTION_ITEM_OVERVIEW)
                });
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZa9B.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-overviews-default",
        actionsOnHover: actionsOnHover,
        // Prevent double-up of accessible name that occurs in icon+text situation.
        "aria-label": formattedMessage,
        elemBefore: icon,
        ref: triggerRef,
        testId: (0, $dQbFB.getTestId)((0, $jhS4y.MENU_ID_OVERVIEWS))
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnznH.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        // Data stream, will subscribe to load updates.
        entryPointReferenceSubject: entryPointReferenceSubject,
        // Required props for error JSErrorBoundary.
        id: "nav4-sidebar-overviews-default",
        packageName: (0, $cdfe315557fc43d2$export$b8b9d90f9e5bd72b),
        // Optional props for error JSErrorBoundary.
        errorFallback: "flag",
        teamName: (0, $cdfe315557fc43d2$export$d57b6b390e78d90f),
        // Fallback for `Suspense`.
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), null),
        // Props for the root component.
        runtimeProps: entryPointParams
    })));
}

});
parcelRegister("cCqmP", function(module, exports) {

$parcel$export(module.exports, "asyncOverviewsContentViewQuery", () => $68f93ca11a5596c0$export$355176fbb80f2347);

var $i7pdK = parcelRequire("i7pdK");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $68f93ca11a5596c0$export$355176fbb80f2347 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("hhwrG")).then(({ OverviewsContentViewQuery: OverviewsContentViewQuery })=>OverviewsContentViewQuery), {
        moduleId: "6f0ac280",
        moduleName: "OverviewsContentViewQuery",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                queryRef: {
                    parameters: $i7pdK.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("i7pdK", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ae4c5ed97c4768f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<560d7e5e0cd70de1d6c924f49a1b8b29>>
 * @relayHash cf2a8f845ae7c967ae307cc40eb4b07f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e61d234924072f4c43fcca2a72d097f86d33239be52bd1855eefa77b25c7cd4c
const $5ae4c5ed97c4768f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "OverviewsContentViewQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4OverviewsContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "OverviewsContentViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                }
                            ],
                            "concreteType": "JiraWorkManagementGiraOverviewConnection",
                            "kind": "LinkedField",
                            "name": "jwmOverviews",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraWorkManagementGiraOverviewEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraWorkManagementGiraOverview",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e61d234924072f4c43fcca2a72d097f86d33239be52bd1855eefa77b25c7cd4c",
            "metadata": {},
            "name": "OverviewsContentViewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5ae4c5ed97c4768f$var$node.hash = "5c526a403c104de05313b5b30d6f67e2";
var $5ae4c5ed97c4768f$export$2e2bcd8739ae039 = $5ae4c5ed97c4768f$var$node;

});

parcelRegister("hhwrG", function(module, exports) {

let $c94d31324faa6436$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c94d31324faa6436$var$load("ixwr1").then(()=>parcelRequire('cG9Gr'));

});



parcelRegister("aKoWU", function(module, exports) {

$parcel$export(module.exports, "Nav4OverviewsForLanding", () => $3fb52decc5a00e35$export$a2711da4a3d7eaa1);

var $5O4cG = parcelRequire("5O4cG");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $lnznH = parcelRequire("lnznH");
var $cZa9B = parcelRequire("cZa9B");

var $7CMCs = parcelRequire("7CMCs");

var $jecJ3 = parcelRequire("jecJ3");

var $jhS4y = parcelRequire("jhS4y");

var $46Cti = parcelRequire("46Cti");

var $c16H2 = parcelRequire("c16H2");

var $dQbFB = parcelRequire("dQbFB");

var $eQV8d = parcelRequire("eQV8d");

var $dUyqZ = parcelRequire("dUyqZ");

var $l8ruj = parcelRequire("l8ruj");


var $1M5y9 = parcelRequire("1M5y9");
function $3fb52decc5a00e35$export$a2711da4a3d7eaa1({ isExpanded: isExpanded, queryRef: queryRef, actionsOnHover: actionsOnHover }) {
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).OVERVIEWS);
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    const data = (0, $8Uumt.useFragment)((0, $5O4cG.default), queryRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $46Cti.L1_MENU_ID).OVERVIEWS,
                sectionItem: (0, $jecJ3.SECTION_ITEM_OVERVIEW)
            });
        },
        isExpanded: isExpanded,
        menuId: (0, $jhS4y.MENU_ID_OVERVIEWS)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZa9B.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-overviews-landing",
        actionsOnHover: actionsOnHover,
        // Prevent double-up of accessible name that occurs in icon+text situation.
        "aria-label": formattedMessage,
        elemBefore: icon,
        // ref={triggerRef}
        testId: (0, $dQbFB.getTestId)((0, $jhS4y.MENU_ID_OVERVIEWS))
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnznH.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4-sidebar-overviews-landing"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "nav4-sidebar-overviews-landing",
        packageName: (0, $cdfe315557fc43d2$export$b8b9d90f9e5bd72b),
        teamName: (0, $cdfe315557fc43d2$export$d57b6b390e78d90f),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1M5y9.Nav4OverviewsContent), {
        queryRef: data
    })))));
}

});
parcelRegister("5O4cG", function(module, exports) {

$parcel$export(module.exports, "default", () => $773b1024053c443b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<24c44c1cc97a0ce676ed07f685505cfc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $773b1024053c443b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4OverviewsForLanding",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Nav4OverviewsContent"
        }
    ],
    "type": "Query"
};
$773b1024053c443b$var$node.hash = "dca06bec8549dba3e1ff2c708224de6f";
var $773b1024053c443b$export$2e2bcd8739ae039 = $773b1024053c443b$var$node;

});

parcelRegister("1M5y9", function(module, exports) {

$parcel$export(module.exports, "Nav4OverviewsContent", () => $fb2fd91a88d04b6c$export$50145651ea4a827);

var $luy4t = parcelRequire("luy4t");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $gSZmd = parcelRequire("gSZmd");
var $1qQhw = parcelRequire("1qQhw");
var $1FdfO = parcelRequire("1FdfO");

var $jhS4y = parcelRequire("jhS4y");

var $c6x3L = parcelRequire("c6x3L");

var $9Gyp5 = parcelRequire("9Gyp5");

var $lOwQh = parcelRequire("lOwQh");

var $koeKL = parcelRequire("koeKL");

var $hkziz = parcelRequire("hkziz");

var $bbRBT = parcelRequire("bbRBT");
function $fb2fd91a88d04b6c$export$50145651ea4a827({ queryRef: queryRef }) {
    const { isSelectedPath: isSelectedPath } = (0, $c6x3L.useSidebarNav4)();
    const cloudId = (0, $koeKL.useCloudId)();
    const [{ jira: { jwmOverviews: jwmOverviews } }, refetch] = (0, $8Uumt.useRefetchableFragment)((0, $luy4t.default), queryRef);
    (0, $9Gyp5.useRefetchWhenIsSelected)({
        cloudId: cloudId,
        isSelectedPath: isSelectedPath,
        QUERY: $lOwQh.default,
        refetch: refetch,
        menuId: (0, $jhS4y.MENU_ID_OVERVIEWS)
    });
    const items = (0, $5uXOq.useMemo)(()=>{
        const nodes = jwmOverviews?.edges?.filter(Boolean).map((edge)=>edge.node) || [];
        const list = nodes.filter(Boolean).map((node)=>node.name ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bbRBT.OverviewsMenuItem), {
                key: node.id,
                id: node.id,
                name: node.name
            }) : null).filter(Boolean) ?? [];
        return {
            list: list,
            hasItems: Boolean(list.length)
        };
    }, [
        jwmOverviews
    ]);
    if (!items.hasItems) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hkziz.OverviewsEmptyState), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, items.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1qQhw.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1FdfO.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gSZmd.MenuList), null, items.list))));
}

});
parcelRegister("luy4t", function(module, exports) {

$parcel$export(module.exports, "default", () => $12db70c4555ca789$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<36e48bbc800f6fcd05f9ae0af54e02a8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $lOwQh = parcelRequire("lOwQh");
const $12db70c4555ca789$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "metadata": {
        "refetch": {
            "fragmentPathInResult": [],
            "operation": (0, $lOwQh.default)
        }
    },
    "name": "Nav4OverviewsContent",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "cloudId",
                                "variableName": "cloudId"
                            }
                        ],
                        "concreteType": "JiraWorkManagementGiraOverviewConnection",
                        "kind": "LinkedField",
                        "name": "jwmOverviews",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraWorkManagementGiraOverviewEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraWorkManagementGiraOverview",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "id"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "name"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "action": "THROW",
            "path": "jira"
        }
    ],
    "type": "Query"
};
$12db70c4555ca789$var$node.hash = "e24d9b35e956ee89177e09fcc3033bc6";
var $12db70c4555ca789$export$2e2bcd8739ae039 = $12db70c4555ca789$var$node;

});
parcelRegister("lOwQh", function(module, exports) {

$parcel$export(module.exports, "default", () => $396f1fb6c862454c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<abb8f4cb57d30ce17b791d146f8f5c1e>>
 * @relayHash 89a071a83d7086613e54267a83ad5589
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3e49fb6b80c74d3109cdaeee9b0845e45ba88362a09ef2d27ffccd0095c0d334
const $396f1fb6c862454c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "Nav4OverviewsContentQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4OverviewsContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "Nav4OverviewsContentQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                }
                            ],
                            "concreteType": "JiraWorkManagementGiraOverviewConnection",
                            "kind": "LinkedField",
                            "name": "jwmOverviews",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraWorkManagementGiraOverviewEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraWorkManagementGiraOverview",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3e49fb6b80c74d3109cdaeee9b0845e45ba88362a09ef2d27ffccd0095c0d334",
            "metadata": {},
            "name": "Nav4OverviewsContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$396f1fb6c862454c$var$node.hash = "e24d9b35e956ee89177e09fcc3033bc6";
var $396f1fb6c862454c$export$2e2bcd8739ae039 = $396f1fb6c862454c$var$node;

});


parcelRegister("hkziz", function(module, exports) {

$parcel$export(module.exports, "OverviewsEmptyState", () => $ff6bee69ca61a432$export$84d2991bdf490d9e);

var $5uXOq = parcelRequire("5uXOq");

var $dS3PR = parcelRequire("dS3PR");

var $koVbs = parcelRequire("koVbs");

var $7lgBG = parcelRequire("7lgBG");

var $80d0n = parcelRequire("80d0n");
function $ff6bee69ca61a432$export$84d2991bdf490d9e() {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7lgBG.EmptyContentMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        size: "small",
        align: "center",
        color: "color.text.subtlest"
    }, formatMessage((0, $80d0n.messages).noOverviews)));
}

});
parcelRegister("7lgBG", function(module, exports) {

$parcel$export(module.exports, "EmptyContentMenuItem", () => $e3e887a0aac5853d$export$1d5b0e5e21ec7e84);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");

var $1qQhw = parcelRequire("1qQhw");
const $e3e887a0aac5853d$var$styles = {
    box: "_18u01b66"
};
function $e3e887a0aac5853d$export$1d5b0e5e21ec7e84({ children: children }) {
    return /*#__PURE__*/ $5uXOq.createElement((0, $1qQhw.MenuListItem), null, /*#__PURE__*/ $5uXOq.createElement((0, $MHKc7.default), {
        paddingInline: "space.050",
        xcss: $e3e887a0aac5853d$var$styles.box
    }, children));
}

});

parcelRegister("80d0n", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2efe397547e443b7$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $2efe397547e443b7$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    noOverviews: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-overviews.common.empty-state.no-overviews",
        "defaultMessage": "Once you create an overview, it'll show up here."
    }
});

});


parcelRegister("bbRBT", function(module, exports) {

$parcel$export(module.exports, "OverviewsMenuItem", () => $68e0e3e271034bfa$export$1110bfd7980f0ad5);

var $5uXOq = parcelRequire("5uXOq");

var $i3a7M = parcelRequire("i3a7M");

var $jhS4y = parcelRequire("jhS4y");

var $46Cti = parcelRequire("46Cti");

var $5FnJJ = parcelRequire("5FnJJ");

var $dUyqZ = parcelRequire("dUyqZ");
function $68e0e3e271034bfa$export$1110bfd7980f0ad5({ id: id, name: name }) {
    const { icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).OVERVIEWS);
    const { sendOverviewMenuItemAnalyticsEvent: sendOverviewMenuItemAnalyticsEvent } = (0, $i3a7M.useOverviewsAnalyticsL1)();
    const overviewUrl = `/jira/core/overviews/${id}/summary`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        onClick: ()=>{
            sendOverviewMenuItemAnalyticsEvent({
                overviewId: id
            });
        },
        href: overviewUrl,
        menuId: (0, $jhS4y.ENTITY_ID).OVERVIEW(String(id)),
        elemBefore: icon
    }, name);
}

});





parcelRegister("1YUDD", function(module, exports) {

$parcel$export(module.exports, "Nav4Plans", () => $c0a13e2d05128c7b$export$a9599e1720ee6c82);

var $5uXOq = parcelRequire("5uXOq");

var $7Fvqy = parcelRequire("7Fvqy");

var $7CMCs = parcelRequire("7CMCs");

var $l8ruj = parcelRequire("l8ruj");


var $d6uAw = parcelRequire("d6uAw");

var $iUfQY = parcelRequire("iUfQY");
function $c0a13e2d05128c7b$export$a9599e1720ee6c82(props) {
    const isStandardOrFree = (0, $7Fvqy.useIsStandardOrFreeJSW)();
    const isUnlicensedJsw = (0, $7Fvqy.useIsUnlicensedJSW)();
    if (isUnlicensedJsw) return null;
    if (isStandardOrFree) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iUfQY.Nav4PlansPremiumUpsellFeatureGate), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4.sidebar.plans"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "flag",
        id: "plans-section",
        packageName: (0, $b0ee4c2dffa12273$export$b8b9d90f9e5bd72b),
        teamName: (0, $b0ee4c2dffa12273$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d6uAw.Nav4Plans), props)));
}

});
parcelRegister("7Fvqy", function(module, exports) {

$parcel$export(module.exports, "useIsStandardOrFreeJSW", () => $ac0a44b8f9a76c7a$export$5edaea31b41b30b);
$parcel$export(module.exports, "useIsPremiumJSW", () => $ac0a44b8f9a76c7a$export$d245a3118a8b4004);
$parcel$export(module.exports, "useIsUnlicensedJSW", () => $ac0a44b8f9a76c7a$export$47ec61465121ff53);

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");
const $ac0a44b8f9a76c7a$export$a2bbf41e67157372 = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const jswEdition = appEditions ? (0, $ldyPw.getEdition)((0, $efvDm.JIRA_SOFTWARE), appEditions) : undefined;
    return jswEdition === (0, $ldyPw.STANDARD_EDITION);
};
const $ac0a44b8f9a76c7a$export$a55cc88b2381611c = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const jswEdition = appEditions ? (0, $ldyPw.getEdition)((0, $efvDm.JIRA_SOFTWARE), appEditions) : undefined;
    return jswEdition === (0, $ldyPw.FREE_EDITION);
};
const $ac0a44b8f9a76c7a$export$5edaea31b41b30b = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const jswEdition = appEditions ? (0, $ldyPw.getEdition)((0, $efvDm.JIRA_SOFTWARE), appEditions) : undefined;
    return jswEdition === (0, $ldyPw.STANDARD_EDITION) || jswEdition === (0, $ldyPw.FREE_EDITION);
};
const $ac0a44b8f9a76c7a$export$d245a3118a8b4004 = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const jswEdition = appEditions ? (0, $ldyPw.getEdition)((0, $efvDm.JIRA_SOFTWARE), appEditions) : undefined;
    return jswEdition === (0, $ldyPw.PREMIUM_EDITION);
};
const $ac0a44b8f9a76c7a$export$47ec61465121ff53 = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const jswEdition = appEditions ? (0, $ldyPw.getEdition)((0, $efvDm.JIRA_SOFTWARE), appEditions) : undefined;
    return !jswEdition || jswEdition === (0, $ldyPw.UNLICENSED);
};

});

const $b0ee4c2dffa12273$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Plans';
const $b0ee4c2dffa12273$export$d57b6b390e78d90f = 'jet-chronos-team';

parcelRegister("d6uAw", function(module, exports) {

$parcel$export(module.exports, "Nav4Plans", () => $985d33464497955f$export$a9599e1720ee6c82);

var $gSE3m = parcelRequire("gSE3m");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $7Fvqy = parcelRequire("7Fvqy");

var $jhS4y = parcelRequire("jhS4y");

var $c6x3L = parcelRequire("c6x3L");

var $h9iZl = parcelRequire("h9iZl");

var $8QMHF = parcelRequire("8QMHF");

var $4R6GH = parcelRequire("4R6GH");

var $heI7y = parcelRequire("heI7y");

var $b9Pg6 = parcelRequire("b9Pg6");

var $kicJ4 = parcelRequire("kicJ4");

var $iC65q = parcelRequire("iC65q");

var $iUfQY = parcelRequire("iUfQY");
function $985d33464497955f$export$a9599e1720ee6c82({ isExpanded: isExpanded, queryRef: queryRef }) {
    const data = (0, $8Uumt.useFragment)((0, $gSE3m.default), queryRef);
    const hasEditPermissions = data.jira?.advancedRoadmapsNavigation?.hasEditPermissions ?? false;
    const hasCreateSamplePlanPermissions = data.jira?.advancedRoadmapsNavigation?.hasCreateSamplePlanPermissions ?? false;
    const hasGlobalPlansAdminPermissions = data.jira?.advancedRoadmapsNavigation?.hasGlobalPlansAdminPermissions ?? false;
    const actionButtons = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b9Pg6.Nav4PlansActionButtons), {
            hasEditPermissions: hasEditPermissions,
            hasCreateSamplePlanPermissions: hasCreateSamplePlanPermissions,
            hasGlobalPlansAdminPermissions: hasGlobalPlansAdminPermissions
        }), [
        hasEditPermissions,
        hasCreateSamplePlanPermissions,
        hasGlobalPlansAdminPermissions
    ]);
    const [shouldRender] = (0, $h9iZl.useNavigationPlansVisibility)();
    const isPremium = (0, $7Fvqy.useIsPremiumJSW)();
    const [{ hasOpened: shouldShowNudge }] = (0, $heI7y.useHasOpened)();
    if (!shouldRender) return null;
    if (!isPremium) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iUfQY.Nav4PlansPremiumUpsellFeatureGate), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($985d33464497955f$var$Nav4PlansComponent, {
        actionButtons: actionButtons,
        isExpanded: isExpanded,
        hasFragment: data.jira?.hasIsPlansExpanded === 'JiraQuery',
        data: data,
        shouldShowNudge: shouldShowNudge
    });
}
const $985d33464497955f$var$Nav4PlansComponent = (props)=>{
    const { actionButtons: actionButtons, isExpanded: isExpanded, data: data, hasFragment: hasFragment, shouldShowNudge: shouldShowNudge = true } = props;
    const { isInitialSelectedPath: isInitialSelectedPath } = (0, $c6x3L.useSidebarNav4)();
    if (!false && shouldShowNudge && (0, $4R6GH.fg)('jira_onboarding_experiences_a11y_fixes')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $985d33464497955f$var$fullWidthStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8QMHF.NavigationPlansNavItemWrapperNudgeAsync), null, isInitialSelectedPath((0, $jhS4y.MENU_ID_PLANS)) && hasFragment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iC65q.Nav4PlansForLanding), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded,
        queryRef: data
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kicJ4.Nav4PlansDefault), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded
    })));
    return isInitialSelectedPath((0, $jhS4y.MENU_ID_PLANS)) && hasFragment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iC65q.Nav4PlansForLanding), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded,
        queryRef: data
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kicJ4.Nav4PlansDefault), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded
    });
};
const $985d33464497955f$var$fullWidthStyles = (0, $8CUq3.xcss)({
    width: '100%'
});

});
parcelRegister("gSE3m", function(module, exports) {

$parcel$export(module.exports, "default", () => $59ba99e1087de085$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5de776fd06dc4f3b32e6bbfba7f1ef8e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $59ba99e1087de085$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "kind": "RootArgument",
            "name": "isPlansExpanded"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4Plans",
    "selections": [
        {
            "condition": "isPlansExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4PlansForLanding"
                }
            ]
        },
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "condition": "isPlansExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "hasIsPlansExpanded",
                            "kind": "ScalarField",
                            "name": "__typename"
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "JiraAdvancedRoadmapsNavigation",
                    "kind": "LinkedField",
                    "name": "advancedRoadmapsNavigation",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasEditPermissions"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasCreateSamplePlanPermissions"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasGlobalPlansAdminPermissions"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$59ba99e1087de085$var$node.hash = "d94bdd2f938a10104ed5834debf9b43c";
var $59ba99e1087de085$export$2e2bcd8739ae039 = $59ba99e1087de085$var$node;

});

parcelRegister("8QMHF", function(module, exports) {

$parcel$export(module.exports, "NavigationPlansNavItemWrapperNudgeAsync", () => $721bcfa7775fc750$export$e2e248a8ac2b2891);

var $5uXOq = parcelRequire("5uXOq");


var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $721bcfa7775fc750$var$NavigationPlansNavItemLazy = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("hFzjx")).then((exportedModule)=>exportedModule.NavigationPlansNavItemWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/navigation-plans/index.tsx"
});
const $721bcfa7775fc750$export$e2e248a8ac2b2891 = ({ children: children, isInsideMenu: isInsideMenu })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $6784cbc7d62e5d7c$export$46d9a3d441dfd22b),
        fallback: children,
        attributes: {
            nudgeId: (0, $6784cbc7d62e5d7c$export$46d9a3d441dfd22b)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-onboarding-navigation-plans-nudge",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($721bcfa7775fc750$var$NavigationPlansNavItemLazy, {
        nudgeId: (0, $6784cbc7d62e5d7c$export$46d9a3d441dfd22b),
        isInsideMenu: isInsideMenu
    }, children)));

});
parcelRegister("hFzjx", function(module, exports) {

let $cdd1a8a662bf5e90$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cdd1a8a662bf5e90$var$load("56cs9").then(()=>parcelRequire('gf2wp'));

});


parcelRegister("b9Pg6", function(module, exports) {

$parcel$export(module.exports, "Nav4PlansActionButtons", () => $06dac252aee09a8f$export$a7d6536605f62394);

var $5uXOq = parcelRequire("5uXOq");

var $1MV6x = parcelRequire("1MV6x");

var $agyyr = parcelRequire("agyyr");
const $06dac252aee09a8f$export$a7d6536605f62394 = ({ hasEditPermissions: hasEditPermissions, hasCreateSamplePlanPermissions: hasCreateSamplePlanPermissions, hasGlobalPlansAdminPermissions: hasGlobalPlansAdminPermissions })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, hasEditPermissions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1MV6x.CreatePlanMenuButton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $agyyr.MoreMenuButton), {
        hasCreateSamplePlanPermissions: hasCreateSamplePlanPermissions,
        hasGlobalPlansAdminPermissions: hasGlobalPlansAdminPermissions
    }));
};

});
parcelRegister("1MV6x", function(module, exports) {

$parcel$export(module.exports, "CreatePlanMenuButton", () => $672e78f60f326b1f$export$fd3582c8dd19f9f6);

var $5uXOq = parcelRequire("5uXOq");

var $dZbEw = parcelRequire("dZbEw");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");



var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $1xonH = parcelRequire("1xonH");

var $gD5Z0 = parcelRequire("gD5Z0");

var $2NMNM = parcelRequire("2NMNM");

var $8zOmE = parcelRequire("8zOmE");

var $ydGxv = parcelRequire("ydGxv");
const $672e78f60f326b1f$export$fd3582c8dd19f9f6 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [, { openDrawer: openCreateNewPlanWizardDrawer }] = (0, $gD5Z0.useCreateNewPlanWizardDrawer)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const clickHandler = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_PLANS],
            attributes: {
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                itemId: 'createPlan'
            }
        });
        openCreateNewPlanWizardDrawer();
    }, [
        openCreateNewPlanWizardDrawer,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $ydGxv.default).createPlan)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1xonH.CommonNavMenuButton), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage((0, $ydGxv.default).createPlan),
        onClick: clickHandler
    }));
};

});
parcelRegister("gD5Z0", function(module, exports) {

$parcel$export(module.exports, "useCreateNewPlanWizardDrawer", () => $13f82bb8cfc1f7f2$export$f3e7d3fc94eda89a);
$parcel$export(module.exports, "useImportedMessagesForLocale", () => $13f82bb8cfc1f7f2$export$52303468eeac3ad0);

var $5uXOq = parcelRequire("5uXOq");

var $eTXmK = parcelRequire("eTXmK");

var $koVbs = parcelRequire("koVbs");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $4R6GH = parcelRequire("4R6GH");
const $13f82bb8cfc1f7f2$var$CONTROLLER_NAME = 'create-new-plan-wizard-drawer';
const $13f82bb8cfc1f7f2$var$initialState = {
    isOpen: false,
    plan: undefined,
    isPlanCreationComplete: false
};
const $13f82bb8cfc1f7f2$var$Store = (0, $iXqE5.createStore)({
    name: $13f82bb8cfc1f7f2$var$CONTROLLER_NAME,
    initialState: $13f82bb8cfc1f7f2$var$initialState,
    actions: {
        openDrawer: (plan)=>{
            (0, $eTXmK.default)('arj-create-plan-wizard-drawer');
            return (0, $4R6GH.fg)('ensure_plan_create_ufo_event_fires_successfully') ? ({ setState: setState })=>setState({
                    isOpen: true,
                    plan: plan,
                    isPlanCreationComplete: false
                }) : ({ setState: setState })=>setState({
                    isOpen: true,
                    plan: plan
                });
        },
        closeDrawer: ()=>({ setState: setState })=>setState({
                    isOpen: false,
                    plan: undefined
                }),
        setIsPlanCreationComplete: (isPlanCreationComplete = true)=>({ setState: setState })=>(0, $4R6GH.fg)('ensure_plan_create_ufo_event_fires_successfully') ? setState({
                    isPlanCreationComplete: isPlanCreationComplete
                }) : undefined
    }
});
const $13f82bb8cfc1f7f2$export$f3e7d3fc94eda89a = (0, $3sQ5x.createHook)($13f82bb8cfc1f7f2$var$Store);
const $13f82bb8cfc1f7f2$export$9ec7b5762fb72de2 = (0, $gg7kZ.createContainer)($13f82bb8cfc1f7f2$var$Store, {
    onInit: ()=>({ setState: setState }, { isOpen: isOpen, plan: plan })=>{
            setState({
                isOpen: isOpen,
                plan: plan
            });
        }
});
const $13f82bb8cfc1f7f2$var$EXCLUDED_I18N_FILES = [
    'index',
    'languages',
    'en'
];
const $13f82bb8cfc1f7f2$var$FALLBACK_INTL_MESSAGES = Object.freeze({});
const $13f82bb8cfc1f7f2$export$19442c17ab279a67 = async (rawlocale = 'en')=>{
    // Filter out country code as the AFE i18n does not use them e.g en => en-US
    const locale = rawlocale.split('-')[0];
    if (!locale || $13f82bb8cfc1f7f2$var$EXCLUDED_I18N_FILES.includes(locale)) return {
        default: $13f82bb8cfc1f7f2$var$FALLBACK_INTL_MESSAGES
    };
    const packageName = (0, $4R6GH.fg)('finish_jira-portfolio-3-plan-wizard_migration') ? 'jira-portfolio-3-plan-wizard' : 'jira-portfolio-plan-wizard';
    try {
        {
            // eslint-disable-next-line jira/import/webpack-magic-comment-entries
            const i18nModule = await import(`@atlassian/${packageName}/dist/esm/i18n/*.js`);
            const result = i18nModule[locale]();
            return result;
        }
        // eslint-disable-next-line jira/import/webpack-magic-comment-entries
        const result = await import(`@atlassian/${packageName}/dist/cjs/i18n/${locale}`);
        return result;
    } catch  {
        return {
            default: $13f82bb8cfc1f7f2$var$FALLBACK_INTL_MESSAGES
        };
    }
};
const $13f82bb8cfc1f7f2$export$52303468eeac3ad0 = ()=>{
    const { locale: locale } = (0, $koVbs.default)();
    const [state, setState] = (0, $5uXOq.useState)({
        locale: locale,
        loading: true,
        intlMessages: undefined
    });
    (0, $5uXOq.useEffect)(()=>{
        let mounted = true;
        const load = async ()=>{
            // eslint-disable-next-line @typescript-eslint/no-shadow
            setState((state)=>({
                    ...state,
                    loading: true
                }));
            const { default: intlMessages } = await $13f82bb8cfc1f7f2$export$19442c17ab279a67(locale);
            if (!mounted) return;
            // eslint-disable-next-line @typescript-eslint/no-shadow
            setState((state)=>({
                    ...state,
                    loading: false,
                    intlMessages: intlMessages
                }));
        };
        load();
        return ()=>{
            mounted = false;
        };
    }, [
        locale
    ]);
    return state;
};

});

parcelRegister("ydGxv", function(module, exports) {

$parcel$export(module.exports, "default", () => $12c7f7332437bfb0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $12c7f7332437bfb0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createPlan: {
        "id": "navigation-apps-sidebar-nav4-plans.plans.common.action-buttons.create-plan-menu-button.create-plan",
        "defaultMessage": "Create plan"
    }
});

});


parcelRegister("agyyr", function(module, exports) {

$parcel$export(module.exports, "MoreMenuButton", () => $070d86da22a28dce$export$b13d6ccdb9a8b0c5);

var $5uXOq = parcelRequire("5uXOq");

var $dZbEw = parcelRequire("dZbEw");

var $epOG5 = parcelRequire("epOG5");

var $kJpBP = parcelRequire("kJpBP");
var $3Z96c = parcelRequire("3Z96c");
var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $koVbs = parcelRequire("koVbs");



var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $46Cti = parcelRequire("46Cti");

var $eaKdt = parcelRequire("eaKdt");

var $aCS3f = parcelRequire("aCS3f");

var $4LAva = parcelRequire("4LAva");

var $2NMNM = parcelRequire("2NMNM");

var $8zOmE = parcelRequire("8zOmE");

var $ivGXF = parcelRequire("ivGXF");
const $070d86da22a28dce$var$MoreMenuItems = ({ hasCreateSamplePlanPermissions: hasCreateSamplePlanPermissions, hasGlobalPlansAdminPermissions: hasGlobalPlansAdminPermissions })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [, { open: openCreateSamplePlanModal }] = (0, $4LAva.useCreateSamplePlan)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const createDemoPlanClickHandler = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_PLANS],
            attributes: {
                level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                itemId: 'createDemoPlan'
            }
        });
        openCreateSamplePlanModal();
    }, [
        openCreateSamplePlanModal,
        createAnalyticsEvent
    ]);
    const adminSettingsClickHandler = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_PLANS],
            attributes: {
                level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                itemId: 'adminSettings'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), null, (hasCreateSamplePlanPermissions || hasGlobalPlansAdminPermissions) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        isList: true
    }, hasCreateSamplePlanPermissions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        }),
        onClick: createDemoPlanClickHandler
    }, formatMessage((0, $ivGXF.default).createDemoPlan)), hasGlobalPlansAdminPermissions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Z96c.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($epOG5))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        }),
        href: "/jira/plans/settings/permissions",
        onClick: adminSettingsClickHandler
    }, formatMessage((0, $ivGXF.default).adminSettings))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaKdt.HideL1MenuItemSection), {
        menuId: (0, $46Cti.L1_MENU_ID).PLANS
    }));
};
const $070d86da22a28dce$export$b13d6ccdb9a8b0c5 = ({ hasCreateSamplePlanPermissions: hasCreateSamplePlanPermissions, hasGlobalPlansAdminPermissions: hasGlobalPlansAdminPermissions })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const clickHandler = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_PLANS],
            attributes: {
                level: '1',
                componentType: 'fixedItemButton',
                itemId: 'meatballDropdown'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCS3f.MoreNavMenuButton), {
        MenuItems: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($070d86da22a28dce$var$MoreMenuItems, {
                hasCreateSamplePlanPermissions: hasCreateSamplePlanPermissions,
                hasGlobalPlansAdminPermissions: hasGlobalPlansAdminPermissions
            }),
        name: formatMessage((0, $ivGXF.default).plansMoreMenu),
        onOpen: clickHandler
    });
};

});
parcelRegister("4LAva", function(module, exports) {

$parcel$export(module.exports, "useCreateSamplePlan", () => $8f6b3552bc4c872c$export$53d6fde96f096b86);
$parcel$export(module.exports, "CreateSamplePlanProvider", () => $8f6b3552bc4c872c$export$88b99aa46c223622);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $e0K2C = parcelRequire("e0K2C");

var $hK1fQ = parcelRequire("hK1fQ");
const $8f6b3552bc4c872c$var$CONTROLLER_NAME = 'create-sample-plan';
const $8f6b3552bc4c872c$var$initialState = {
    /**
	 * This field controls modal dismissible status
	 */ isOpen: false,
    /**
	 * This field is only used to redirect the user to plan page if the modal is not closed.
	 */ planId: null,
    /**
	 * This field is used to detect the correct redirection creation session,
	 * without this field, we don't know which creation session needs to be redirected
	 * e.g. the user started multiple sample creation and stays on the last one - in this case,
	 * only the last creation needs to be redirected.
	 */ taskId: null,
    /**
	 * Progress of the ongoing task
	 */ progressPercentage: null,
    /**
	 * Once this field has been set to `true`, we'll know we can call the actions returned
	 * by our useCreateSamplePlan hook.
	 */ hasBeenInitialised: false
};
const $8f6b3552bc4c872c$var$actions = {
    open: ()=>({ setState: setState })=>{
            setState({
                isOpen: true
            });
        },
    close: ()=>({ setState: setState })=>{
            const nextState = (({ hasBeenInitialised: hasBeenInitialised, ...rest })=>rest)($8f6b3552bc4c872c$var$initialState);
            setState(nextState);
        },
    setPlanId: (planId)=>({ setState: setState })=>{
            setState({
                planId: planId
            });
        },
    setTaskId: (taskId)=>({ setState: setState })=>{
            setState({
                taskId: taskId
            });
        },
    setProgressPercentage: (progressPercentage)=>({ setState: setState })=>{
            setState({
                progressPercentage: progressPercentage
            });
        },
    submitSamplePlan: ({ planName: planName, flags: { success: SuccessFlag, error: ErrorFlag } })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { showFlag: showFlag, redirectToPlan: redirectToPlan, leadAccountId: leadAccountId })=>{
            try {
                const taskId = await (0, $hK1fQ.createSamplePlanAsync)({
                    body: JSON.stringify({
                        title: planName,
                        leadAccountId: leadAccountId
                    })
                });
                setState({
                    taskId: taskId
                });
                const response = await (0, $hK1fQ.pollCreateSamplePlan)(taskId, (progressPercentage)=>{
                    const { taskId: latestTaskId } = getState();
                    // progressPercentage should reflect the progress of the most recent taskId
                    // If they don't match, skip updating
                    if (taskId !== latestTaskId) return;
                    setState({
                        progressPercentage: progressPercentage
                    });
                });
                const { plan: plan } = response.samplePlan;
                const currentState = getState();
                // We only want to redirect them if the taskId for the current modal is the same as the one for this request
                // Else it might belong to a previous modal
                if (currentState.isOpen && taskId === currentState.taskId) {
                    redirectToPlan(plan.id);
                    dispatch($8f6b3552bc4c872c$var$actions.close());
                } else {
                    const flagId = (0, $e0K2C.CREATE_SUCCESS_FLAG_ID) + plan.id;
                    showFlag({
                        id: flagId,
                        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SuccessFlag, {
                                id: flagId,
                                planName: plan.name,
                                planId: plan.id
                            })
                    });
                }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                // we only want to track errors unrelated to user settings
                if (!(0, $e0K2C.USER_SETTINGS_ERRORS).includes(err.message)) (0, $jcw0u.default)({
                    error: err,
                    meta: {
                        id: `${(0, $e0K2C.ERROR_REPORTING_PACKAGE)}SubmitFailed`,
                        packageName: (0, $e0K2C.ERROR_REPORTING_PACKAGE),
                        teamName: (0, $e0K2C.ERROR_REPORTING_TEAM)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                const props = {
                    id: (0, $e0K2C.CREATE_ERROR_FLAG_ID),
                    errorCode: err.message
                };
                showFlag({
                    id: (0, $e0K2C.CREATE_ERROR_FLAG_ID),
                    render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ErrorFlag, props)
                });
                dispatch($8f6b3552bc4c872c$var$actions.close());
            }
        }
};
const $8f6b3552bc4c872c$var$Store = (0, $iXqE5.createStore)({
    name: $8f6b3552bc4c872c$var$CONTROLLER_NAME,
    initialState: $8f6b3552bc4c872c$var$initialState,
    actions: $8f6b3552bc4c872c$var$actions
});
const $8f6b3552bc4c872c$export$53d6fde96f096b86 = (0, $3sQ5x.createHook)($8f6b3552bc4c872c$var$Store);
const $8f6b3552bc4c872c$export$88b99aa46c223622 = (0, $gg7kZ.createContainer)($8f6b3552bc4c872c$var$Store, {
    onInit: ()=>({ setState: setState }, { isOpen: isOpen = false })=>{
            setState({
                isOpen: isOpen,
                hasBeenInitialised: true
            });
        }
});

});
parcelRegister("e0K2C", function(module, exports) {

$parcel$export(module.exports, "ERROR_REPORTING_PACKAGE", () => $3613c4dc2e67ca96$export$f27a837467ec20e5);
$parcel$export(module.exports, "ERROR_REPORTING_TEAM", () => $3613c4dc2e67ca96$export$cfeee2ee86ead336);
$parcel$export(module.exports, "MAX_PLAN_NAME_LENGTH", () => $3613c4dc2e67ca96$export$62da4a2465b3b309);
$parcel$export(module.exports, "CREATE_SUCCESS_FLAG_ID", () => $3613c4dc2e67ca96$export$d526356745046017);
$parcel$export(module.exports, "CREATE_ERROR_FLAG_ID", () => $3613c4dc2e67ca96$export$abd17266df221a92);
$parcel$export(module.exports, "UNKNOWN_EXCEPTION", () => $3613c4dc2e67ca96$export$cfba07bc71f884c1);
$parcel$export(module.exports, "USER_SETTINGS_ERRORS", () => $3613c4dc2e67ca96$export$4a3e779cd3c10125);
$parcel$export(module.exports, "ERROR_CODE_TITLE_MAPPING", () => $3613c4dc2e67ca96$export$91ec80863c2c2030);
$parcel$export(module.exports, "ERROR_CODE_DESCRIPTION_MAPPING", () => $3613c4dc2e67ca96$export$c43e20911e13ca0);
$parcel$export(module.exports, "ERROR_CODE_DESCRIPTION_MAPPING_ISSUE_TERM_REFRESH", () => $3613c4dc2e67ca96$export$525cba92c9b435f4);
$parcel$export(module.exports, "ERROR_LINK_MAPPING", () => $3613c4dc2e67ca96$export$2c5a783ab3215ce1);

var $2L5wO = parcelRequire("2L5wO");
const $3613c4dc2e67ca96$export$f27a837467ec20e5 = 'jiraPortfolio3CreateSamplePlan';
const $3613c4dc2e67ca96$export$cfeee2ee86ead336 = 'advanced-roadmaps';
const $3613c4dc2e67ca96$var$CONTACT_SUPPORT_URL = 'https://support.atlassian.com/contact';
const $3613c4dc2e67ca96$var$LEARN_MORE_URL = 'https://support.atlassian.com/jira-software-cloud/docs/view-a-sample-advanced-roadmaps-plan/';
const $3613c4dc2e67ca96$export$62da4a2465b3b309 = 255;
const $3613c4dc2e67ca96$export$d526356745046017 = 'samplePlanCreatedSuccessfully';
const $3613c4dc2e67ca96$export$abd17266df221a92 = 'samplePlanError';
const $3613c4dc2e67ca96$export$e6515d2009b1dba7 = 'REQUIRED_FIELDS_CONFIGURED_ON_ISSUE';
const $3613c4dc2e67ca96$var$EMPTY_ISSUE_LINKS = 'EMPTY_ISSUE_LINKS';
const $3613c4dc2e67ca96$var$NO_BROWSE_PROJECTS_PERMISSION = 'NO_BROWSE_PROJECTS_PERMISSION';
const $3613c4dc2e67ca96$var$NO_CREATE_ISSUES_PERMISSION = 'NO_CREATE_ISSUES_PERMISSION';
const $3613c4dc2e67ca96$var$NO_TRANSITION_ISSUES_PERMISSION = 'NO_TRANSITION_ISSUES_PERMISSION';
const $3613c4dc2e67ca96$var$NO_EDIT_ISSUES_PERMISSION = 'NO_EDIT_ISSUES_PERMISSION';
const $3613c4dc2e67ca96$var$WATCHING_DISABLED = 'WATCHING_DISABLED';
const $3613c4dc2e67ca96$export$cfba07bc71f884c1 = 'UNKNOWN_EXCEPTION';
const $3613c4dc2e67ca96$export$4a3e779cd3c10125 = [
    $3613c4dc2e67ca96$export$e6515d2009b1dba7,
    $3613c4dc2e67ca96$var$EMPTY_ISSUE_LINKS,
    $3613c4dc2e67ca96$var$NO_BROWSE_PROJECTS_PERMISSION,
    $3613c4dc2e67ca96$var$NO_CREATE_ISSUES_PERMISSION,
    $3613c4dc2e67ca96$var$NO_TRANSITION_ISSUES_PERMISSION,
    $3613c4dc2e67ca96$var$NO_EDIT_ISSUES_PERMISSION,
    $3613c4dc2e67ca96$var$WATCHING_DISABLED
];
const $3613c4dc2e67ca96$export$91ec80863c2c2030 = {
    [$3613c4dc2e67ca96$export$e6515d2009b1dba7]: (0, $2L5wO.default).configurationErrorTitle,
    [$3613c4dc2e67ca96$var$EMPTY_ISSUE_LINKS]: (0, $2L5wO.default).configurationErrorTitle,
    [$3613c4dc2e67ca96$var$NO_BROWSE_PROJECTS_PERMISSION]: (0, $2L5wO.default).permissionErrorTitle,
    [$3613c4dc2e67ca96$var$NO_CREATE_ISSUES_PERMISSION]: (0, $2L5wO.default).permissionErrorTitle,
    [$3613c4dc2e67ca96$var$NO_TRANSITION_ISSUES_PERMISSION]: (0, $2L5wO.default).permissionErrorTitle,
    [$3613c4dc2e67ca96$var$NO_EDIT_ISSUES_PERMISSION]: (0, $2L5wO.default).permissionErrorTitle,
    [$3613c4dc2e67ca96$var$WATCHING_DISABLED]: (0, $2L5wO.default).configurationErrorTitle,
    [$3613c4dc2e67ca96$export$cfba07bc71f884c1]: (0, $2L5wO.default).tryAgainErrorTitle
};
const $3613c4dc2e67ca96$export$c43e20911e13ca0 = {
    [$3613c4dc2e67ca96$export$e6515d2009b1dba7]: (0, $2L5wO.default).requiredFieldsConfiguredOnIssueError,
    [$3613c4dc2e67ca96$var$EMPTY_ISSUE_LINKS]: (0, $2L5wO.default).emptyIssueLinksError,
    [$3613c4dc2e67ca96$var$NO_BROWSE_PROJECTS_PERMISSION]: (0, $2L5wO.default).noBrowseProjectsPermissionError,
    [$3613c4dc2e67ca96$var$NO_CREATE_ISSUES_PERMISSION]: (0, $2L5wO.default).noCreateIssuesPermissionError,
    [$3613c4dc2e67ca96$var$NO_TRANSITION_ISSUES_PERMISSION]: (0, $2L5wO.default).noTransitionIssuesPermissionError,
    [$3613c4dc2e67ca96$var$NO_EDIT_ISSUES_PERMISSION]: (0, $2L5wO.default).noEditIssuesPermissionError,
    [$3613c4dc2e67ca96$var$WATCHING_DISABLED]: (0, $2L5wO.default).watchingDisabledError,
    [$3613c4dc2e67ca96$export$cfba07bc71f884c1]: (0, $2L5wO.default).unknownExceptionError
};
const $3613c4dc2e67ca96$export$525cba92c9b435f4 = {
    [$3613c4dc2e67ca96$export$e6515d2009b1dba7]: (0, $2L5wO.default).requiredFieldsConfiguredOnIssueErrorIssueTermRefresh,
    [$3613c4dc2e67ca96$var$EMPTY_ISSUE_LINKS]: (0, $2L5wO.default).emptyIssueLinksErrorIssueTermRefresh,
    [$3613c4dc2e67ca96$var$NO_BROWSE_PROJECTS_PERMISSION]: (0, $2L5wO.default).noBrowseProjectsPermissionError,
    [$3613c4dc2e67ca96$var$NO_CREATE_ISSUES_PERMISSION]: (0, $2L5wO.default).noCreateIssuesPermissionErrorIssueTermRefresh,
    [$3613c4dc2e67ca96$var$NO_TRANSITION_ISSUES_PERMISSION]: (0, $2L5wO.default).noTransitionIssuesPermissionErrorIssueTermRefresh,
    [$3613c4dc2e67ca96$var$NO_EDIT_ISSUES_PERMISSION]: (0, $2L5wO.default).noEditIssuesPermissionErrorIssueTermRefresh,
    [$3613c4dc2e67ca96$var$WATCHING_DISABLED]: (0, $2L5wO.default).watchingDisabledErrorIssueTermRefresh,
    [$3613c4dc2e67ca96$export$cfba07bc71f884c1]: (0, $2L5wO.default).unknownExceptionError
};
const $3613c4dc2e67ca96$export$2c5a783ab3215ce1 = {
    [$3613c4dc2e67ca96$export$e6515d2009b1dba7]: {
        text: (0, $2L5wO.default).learnMore,
        href: $3613c4dc2e67ca96$var$LEARN_MORE_URL
    },
    [$3613c4dc2e67ca96$var$EMPTY_ISSUE_LINKS]: {
        text: (0, $2L5wO.default).learnMore,
        href: $3613c4dc2e67ca96$var$LEARN_MORE_URL
    },
    [$3613c4dc2e67ca96$var$NO_BROWSE_PROJECTS_PERMISSION]: {
        text: (0, $2L5wO.default).learnMore,
        href: $3613c4dc2e67ca96$var$LEARN_MORE_URL
    },
    [$3613c4dc2e67ca96$var$NO_CREATE_ISSUES_PERMISSION]: {
        text: (0, $2L5wO.default).learnMore,
        href: $3613c4dc2e67ca96$var$LEARN_MORE_URL
    },
    [$3613c4dc2e67ca96$var$NO_TRANSITION_ISSUES_PERMISSION]: {
        text: (0, $2L5wO.default).learnMore,
        href: $3613c4dc2e67ca96$var$LEARN_MORE_URL
    },
    [$3613c4dc2e67ca96$var$NO_EDIT_ISSUES_PERMISSION]: {
        text: (0, $2L5wO.default).learnMore,
        href: $3613c4dc2e67ca96$var$LEARN_MORE_URL
    },
    [$3613c4dc2e67ca96$var$WATCHING_DISABLED]: {
        text: (0, $2L5wO.default).learnMore,
        href: $3613c4dc2e67ca96$var$LEARN_MORE_URL
    },
    [$3613c4dc2e67ca96$export$cfba07bc71f884c1]: {
        text: (0, $2L5wO.default).contactSupport,
        href: $3613c4dc2e67ca96$var$CONTACT_SUPPORT_URL
    }
};

});
parcelRegister("2L5wO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4969e0d482b1a0a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e4969e0d482b1a0a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    configurationErrorTitle: {
        "id": "portfolio-3-create-sample-plan.common.configuration-error-title",
        "defaultMessage": "Your demo plan couldn't be created because of a configuration error"
    },
    permissionErrorTitle: {
        "id": "portfolio-3-create-sample-plan.common.permission-error-title",
        "defaultMessage": "Your demo plan couldn't be created because you\u2019re missing a required permission"
    },
    tryAgainErrorTitle: {
        "id": "portfolio-3-create-sample-plan.common.try-again-error-title",
        "defaultMessage": "Try to create your demo plan again"
    },
    requiredFieldsConfiguredOnIssueError: {
        "id": "portfolio-3-create-sample-plan.common.required-fields-configured-on-issue-error",
        "defaultMessage": "Your issues have required fields which blocked your demo plan from being created. {readMoreLink}"
    },
    emptyIssueLinksError: {
        "id": "portfolio-3-create-sample-plan.common.empty-issue-links-error",
        "defaultMessage": "Your site doesn't have issue links configured, which are required to create a demo plan. {readMoreLink}"
    },
    noBrowseProjectsPermissionError: {
        "id": "portfolio-3-create-sample-plan.common.no-browse-projects-permission-error",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Browse Projects</permission-type> permission. {readMoreLink}"
    },
    noCreateIssuesPermissionError: {
        "id": "portfolio-3-create-sample-plan.common.no-create-issues-permission-error",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Create Issues</permission-type> permission. {readMoreLink}"
    },
    noTransitionIssuesPermissionError: {
        "id": "portfolio-3-create-sample-plan.common.no-transition-issues-permission-error",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Transition Issues</permission-type> permission. {readMoreLink}"
    },
    noEditIssuesPermissionError: {
        "id": "portfolio-3-create-sample-plan.common.no-edit-issues-permission-error",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Edit Issues</permission-type> permission. {readMoreLink}"
    },
    watchingDisabledError: {
        "id": "portfolio-3-create-sample-plan.common.watching-disabled-error",
        "defaultMessage": "Your demo plan couldn't be created because you have issue watching disabled. {readMoreLink}"
    },
    unknownExceptionError: {
        "id": "portfolio-3-create-sample-plan.common.unknown-exception-error",
        "defaultMessage": "Your demo plan couldn't be created, but we\u2019re not sure why. If the problem persists, contact Atlassian support. {readMoreLink}"
    },
    learnMore: {
        "id": "portfolio-3-create-sample-plan.common.learn-more",
        "defaultMessage": "Learn more"
    },
    contactSupport: {
        "id": "portfolio-3-create-sample-plan.common.contact-support",
        "defaultMessage": "Contact Atlassian support"
    },
    requiredFieldsConfiguredOnIssueErrorIssueTermRefresh: {
        "id": "portfolio-3-create-sample-plan.common.required-fields-configured-on-issue-error-issue-term-refresh",
        "defaultMessage": "Your work items have required fields which blocked your demo plan from being created. {readMoreLink}"
    },
    emptyIssueLinksErrorIssueTermRefresh: {
        "id": "portfolio-3-create-sample-plan.common.empty-issue-links-error-issue-term-refresh",
        "defaultMessage": "Your site doesn't have work item links configured, which are required to create a demo plan. {readMoreLink}"
    },
    noCreateIssuesPermissionErrorIssueTermRefresh: {
        "id": "portfolio-3-create-sample-plan.common.no-create-issues-permission-error-issue-term-refresh",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Create work items</permission-type> permission. {readMoreLink}"
    },
    noTransitionIssuesPermissionErrorIssueTermRefresh: {
        "id": "portfolio-3-create-sample-plan.common.no-transition-issues-permission-error-issue-term-refresh",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Transition work items</permission-type> permission. {readMoreLink}"
    },
    noEditIssuesPermissionErrorIssueTermRefresh: {
        "id": "portfolio-3-create-sample-plan.common.no-edit-issues-permission-error-issue-term-refresh",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Edit work items</permission-type> permission. {readMoreLink}"
    },
    watchingDisabledErrorIssueTermRefresh: {
        "id": "portfolio-3-create-sample-plan.common.watching-disabled-error-issue-term-refresh",
        "defaultMessage": "Your demo plan couldn't be created because you have work item watching disabled. {readMoreLink}"
    }
});

});


parcelRegister("hK1fQ", function(module, exports) {

$parcel$export(module.exports, "createSamplePlanAsync", () => $4a753946a320d2b7$export$fed9130b90cf6213);
$parcel$export(module.exports, "pollCreateSamplePlan", () => $4a753946a320d2b7$export$5d240a69af545c0d);
/**
 * Consider moving into service
 */ 
var $jcw0u = parcelRequire("jcw0u");

var $fnyT4 = parcelRequire("fnyT4");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");

var $e0K2C = parcelRequire("e0K2C");
const $4a753946a320d2b7$var$throwIfNotOk = async (response)=>{
    if (response.ok) return response;
    if (response.status === 500) throw new (0, $jJZqs.default)(response.status, (0, $e0K2C.UNKNOWN_EXCEPTION), response.headers.get((0, $fnyT4.TRACE_ID_HEADER)) ?? undefined, response);
};
const $4a753946a320d2b7$var$throwIfFailed = (result)=>{
    if (result.samplePlan && !result.samplePlan.success) throw new Error(result.samplePlan.error);
};
const $4a753946a320d2b7$var$delay = (ms = 3000)=>new Promise((res)=>setTimeout(res, ms));
const $4a753946a320d2b7$export$fed9130b90cf6213 = async (data)=>{
    const response = await (0, $eusud.performPostRequest)('/rest/jpo/1.0/plans/sampleplan/async', data);
    const { taskId: taskId } = response;
    if (!taskId) throw new Error('Invalid response from createSamplePlan');
    return taskId;
};
const $4a753946a320d2b7$export$5d240a69af545c0d = async (taskId, onUpdate)=>{
    const url = `/rest/jpo/1.0/plans/sampleplan/async/${taskId}`;
    try {
        const response = await fetch(url);
        await $4a753946a320d2b7$var$throwIfNotOk(response);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const raw = await response.json();
        $4a753946a320d2b7$var$throwIfFailed(raw);
        onUpdate(raw.progressPercent);
        if (raw.done) return raw;
        await $4a753946a320d2b7$var$delay();
        return $4a753946a320d2b7$export$5d240a69af545c0d(taskId, onUpdate);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // we only want to track errors unrelated to user settings
        if (!(0, $e0K2C.USER_SETTINGS_ERRORS).includes(error.message)) (0, $jcw0u.default)({
            meta: {
                id: `${(0, $e0K2C.ERROR_REPORTING_PACKAGE)}PollingFailed`,
                packageName: (0, $e0K2C.ERROR_REPORTING_PACKAGE),
                teamName: (0, $e0K2C.ERROR_REPORTING_TEAM)
            },
            attributes: {
                message: 'Polling create sample plan failed'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});


parcelRegister("ivGXF", function(module, exports) {

$parcel$export(module.exports, "default", () => $97d8a8b002f64e68$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $97d8a8b002f64e68$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    adminSettings: {
        "id": "navigation-apps-sidebar-nav4-plans.plans.common.action-buttons.more-menu-button.admin-settings",
        "defaultMessage": "Admin configuration"
    },
    plansMoreMenu: {
        "id": "navigation-apps-sidebar-nav4-plans.plans.common.action-buttons.more-menu-button.plans-more-menu",
        "defaultMessage": "Plans"
    },
    createDemoPlan: {
        "id": "navigation-apps-sidebar-nav4-plans.plans.common.action-buttons.more-menu-button.create-demo-plan",
        "defaultMessage": "Create demo plan"
    }
});

});



parcelRegister("kicJ4", function(module, exports) {

$parcel$export(module.exports, "Nav4PlansDefault", () => $f508957e3c5a5c81$export$8edda76b63bd4bcb);

var $5uXOq = parcelRequire("5uXOq");

var $bUmQV = parcelRequire("bUmQV");

var $lnznH = parcelRequire("lnznH");
var $cZa9B = parcelRequire("cZa9B");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $jecJ3 = parcelRequire("jecJ3");

var $jhS4y = parcelRequire("jhS4y");

var $aGONy = parcelRequire("aGONy");

var $46Cti = parcelRequire("46Cti");

var $c16H2 = parcelRequire("c16H2");

var $338xa = parcelRequire("338xa");

var $dQbFB = parcelRequire("dQbFB");

var $eQV8d = parcelRequire("eQV8d");

var $dUyqZ = parcelRequire("dUyqZ");

var $4zcxJ = parcelRequire("4zcxJ");


var $fb8Lj = parcelRequire("fb8Lj");

var $koeKL = parcelRequire("koeKL");

var $cmvab = parcelRequire("cmvab");

var $9JG4b = parcelRequire("9JG4b");

var $4R6GH = parcelRequire("4R6GH");

var $5layf = parcelRequire("5layf");
const $f508957e3c5a5c81$export$8edda76b63bd4bcb = ({ actionsOnHover: actionsOnHover, isExpanded: isExpanded })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const currentURLPath = (0, $aGONy.useGetCurrentUrlPath)();
    // rename to entryPointParams when cleaning up nav4-show-plans-when-hidden-by-default
    const actualEntryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId
        }), [
        cloudId
    ]);
    // delete this when cleaning up nav4-show-plans-when-hidden-by-default
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            currentURLPath: currentURLPath
        }), [
        cloudId,
        currentURLPath
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $5layf.asyncPlansSectionPlanListViewQuery), (0, $4R6GH.fg)('nav4-show-plans-when-hidden-by-default') ? actualEntryPointParams : entryPointParams);
    const triggerRef = (0, $4zcxJ.useExpandableEntryPointTrigger)(entryPointActions);
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).PLANS);
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    const menuId = (0, $jhS4y.MENU_ID_PLANS);
    // remove the entire useEffect when cleaning up nav4-show-plans-when-hidden-by-default
    // we should be using the route based entry point approach instead
    // https://hello.atlassian.net/wiki/spaces/UAF/pages/2754170095/Tutorial+EntryPoints+in+Routing
    // If starting life expanded, make sure to load.
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $4R6GH.fg)('nav4-show-plans-when-hidden-by-default')) {
            if (isExpanded) entryPointActions.load();
        }
    }, [
        isExpanded,
        entryPointActions
    ]);
    const onSystemToggleCallBack = (0, $5uXOq.useCallback)((hasExpanded)=>{
        if (hasExpanded) entryPointActions.load();
    }, [
        entryPointActions
    ]);
    const onExpansionToggleCallBack = (0, $5uXOq.useCallback)((hasExpanded)=>{
        if (hasExpanded) {
            entryPointActions.load();
            sendSectionItemAnalyticsEvent({
                menuId: (0, $46Cti.L1_MENU_ID).PLANS,
                sectionItem: (0, $jecJ3.SECTION_ITEM_PLANS)
            });
        }
    }, [
        entryPointActions,
        sendSectionItemAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        onSystemToggle: (0, $4R6GH.fg)('nav4-show-plans-when-hidden-by-default') ? onSystemToggleCallBack : (hasExpanded)=>{
            if (hasExpanded) entryPointActions.load();
        },
        onExpansionToggle: (0, $4R6GH.fg)('nav4-show-plans-when-hidden-by-default') ? onExpansionToggleCallBack : (hasExpanded)=>{
            if (hasExpanded) {
                entryPointActions.load();
                sendSectionItemAnalyticsEvent({
                    menuId: (0, $46Cti.L1_MENU_ID).PLANS,
                    sectionItem: (0, $jecJ3.SECTION_ITEM_PLANS)
                });
            }
        },
        menuId: menuId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZa9B.ExpandableMenuItemTrigger), {
        interactionName: (0, $4R6GH.fg)('blu-7837_apply_presstrace_nav4') ? 'nav4-sidebar-plans-default' : undefined,
        actionsOnHover: actionsOnHover,
        "aria-label": formattedMessage,
        elemBefore: icon,
        ref: triggerRef,
        testId: (0, $dQbFB.getTestId)(menuId)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
        gap: "space.100",
        alignItems: "center"
    }, formattedMessage, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cmvab.PaidFeatureAwarenessRenderer), {
        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9JG4b.PaidFeatureAwarenessPremiumLozenge), null),
        placement: "navigation.plans"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnznH.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        // Data stream, will subscribe to load updates
        entryPointReferenceSubject: entryPointReferenceSubject,
        // Required props for error JSErrorBoundary.
        id: "nav4-plans-default",
        packageName: (0, $b0ee4c2dffa12273$export$b8b9d90f9e5bd72b),
        // Optional props for error JSErrorBoundary.
        errorFallback: "flag",
        teamName: (0, $b0ee4c2dffa12273$export$d57b6b390e78d90f),
        // Fallback for Suspense
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), null),
        // Props for the root component
        runtimeProps: entryPointParams
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fb8Lj.Nav4PlansFooter), null)));
};

});
parcelRegister("fb8Lj", function(module, exports) {

$parcel$export(module.exports, "Nav4PlansFooter", () => $42fbc7ad9b24b6aa$export$484b1d8ed55fea0a);

var $5uXOq = parcelRequire("5uXOq");

var $gSZmd = parcelRequire("gSZmd");
var $1qQhw = parcelRequire("1qQhw");
var $1FdfO = parcelRequire("1FdfO");

var $koVbs = parcelRequire("koVbs");



var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $34PKs = parcelRequire("34PKs");

var $2NMNM = parcelRequire("2NMNM");

var $8zOmE = parcelRequire("8zOmE");

var $8jQu6 = parcelRequire("8jQu6");

var $5WlKy = parcelRequire("5WlKy");
const $42fbc7ad9b24b6aa$var$VIEW_ALL_PLANS_HREF = (0, $8jQu6.plansDirectoryRoute).path;
const $42fbc7ad9b24b6aa$export$484b1d8ed55fea0a = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const viewAllPlansClickHandler = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_PLANS],
            attributes: {
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                itemId: 'viewAllPlans'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1qQhw.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1FdfO.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gSZmd.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $34PKs.ViewAllEntityMenuItem), {
        href: $42fbc7ad9b24b6aa$var$VIEW_ALL_PLANS_HREF,
        menuId: (0, $jhS4y.MENU_ID_PLANS_VIEW_ALL),
        onClick: viewAllPlansClickHandler
    }, formatMessage((0, $5WlKy.default).viewAllPlans)))));
};

});
parcelRegister("8jQu6", function(module, exports) {

$parcel$export(module.exports, "plansDirectoryRoute", () => $f8b07af15c3bb184$export$143b4a1ef2ffc051);
const $f8b07af15c3bb184$export$143b4a1ef2ffc051 = {
    name: 'plans-directory',
    path: '/jira/plans'
};

});

parcelRegister("5WlKy", function(module, exports) {

$parcel$export(module.exports, "default", () => $f511387c8725975f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f511387c8725975f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    viewAllPlans: {
        "id": "navigation-apps-sidebar-nav4-plans.plans.common.footer.view-all-plans",
        "defaultMessage": "View all plans"
    }
});

});


parcelRegister("cmvab", function(module, exports) {

$parcel$export(module.exports, "PaidFeatureAwarenessRenderer", () => $3d319632a25c0850$export$64aa988820df8e0f);

var $b6HdT = parcelRequire("b6HdT");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $hYRTO = parcelRequire("hYRTO");

var $cLXfT = parcelRequire("cLXfT");

var $k9JTq = parcelRequire("k9JTq");

var $5oBMG = parcelRequire("5oBMG");

var $ldyPw = parcelRequire("ldyPw");


var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");

var $koeKL = parcelRequire("koeKL");

var $7CMCs = parcelRequire("7CMCs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
const $3d319632a25c0850$export$dc50189dfb775e17 = (props)=>{
    const { component: component } = props;
    const cloudId = (0, $koeKL.useCloudId)();
    const hamsProductKey = (0, $cLXfT.getHamsProductKey)((0, $c06e1abca7c13910$export$1346c9aa3cbb477d));
    const data = (0, $8Uumt.useLazyLoadQuery)((0, $b6HdT.default), {
        cloudId: cloudId,
        hamsProductKey: hamsProductKey
    });
    const entitlement = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement;
    const hasPaymentDetails = entitlement?.transactionAccount?.isBillToPresent === true;
    if (hasPaymentDetails !== false) return props.fallback;
    return (0, $6s1PB.expValEquals)('persistent_paid_feature_awareness_ab', 'cohort', 'variation', 'not-enrolled') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "paidFeatureAwareness",
        attributes: {
            placement: props.placement
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), component) : props.fallback;
};
const $3d319632a25c0850$export$43f5a9f3669b7084 = (props)=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const jswEdition = appEditions.software;
    const productEntitlementDetails = (0, $5oBMG.useProductEntitlementDetails)();
    const jswEntitlementDetails = productEntitlementDetails?.[0, $c06e1abca7c13910$export$1346c9aa3cbb477d];
    const trialEndTime = jswEntitlementDetails?.trialEndTime;
    const currentDate = (0, $5uXOq.useMemo)(()=>Date.now(), []);
    const isOnJSWTrial = Boolean(trialEndTime && currentDate < trialEndTime);
    /** Eligibility criteria (in order of evaluation)
   * - FG must be on
   * - Must be on JSW Premium Trial
   * - Must not have payment details entered (obtained via query)
   * - Must be in variation for experiment (fire exposure at this point)
   */ const isOnJswPremiumTrial = jswEdition === (0, $ldyPw.PREMIUM_EDITION) && isOnJSWTrial;
    return isOnJswPremiumTrial ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3d319632a25c0850$export$dc50189dfb775e17, props) : props.fallback;
};
const $3d319632a25c0850$export$64aa988820df8e0f = (props)=>{
    const { fallback: fallback = null, ...rest } = props;
    return (0, $4R6GH.fg)('persistent_paid_feature_awareness') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "paidFeatureAwarenessBoundary",
        packageName: "@atlassian/jira-paid-feature-awareness-renderer",
        fallback: fallback ? ()=>fallback : 'unmount',
        teamName: "growth-tako",
        sendToPrivacyUnsafeSplunk: true,
        attributes: {
            placement: props.placement
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hYRTO.default), {
        name: "paid-feature-awareness-renderer-placeholder",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3d319632a25c0850$export$43f5a9f3669b7084, {
        fallback: fallback,
        ...rest
    }))) : fallback;
};

});
parcelRegister("b6HdT", function(module, exports) {

$parcel$export(module.exports, "default", () => $96fb09f2fb680d6a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c65e158836bb825b8b10729b53579e23>>
 * @relayHash dd332bbc60ac1be709db56083c130987
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 41d0bebb795cea640c8555aa4316be536054f8f7c4f0550009867fc14f76adf5
const $96fb09f2fb680d6a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "isBillToPresent"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "uiGetPaymentDetailsEnteredQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "uiGetPaymentDetailsEnteredQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ 
                                                    ],
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ]
                                        },
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "41d0bebb795cea640c8555aa4316be536054f8f7c4f0550009867fc14f76adf5",
            "metadata": {},
            "name": "uiGetPaymentDetailsEnteredQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$96fb09f2fb680d6a$var$node.hash = "cd9ff36ba318610ca3a732f7742e9802";
var $96fb09f2fb680d6a$export$2e2bcd8739ae039 = $96fb09f2fb680d6a$var$node;

});

parcelRegister("cLXfT", function(module, exports) {

$parcel$export(module.exports, "getHamsProductKey", () => $be23717f2b4b385d$export$413aba2429285627);
$parcel$export(module.exports, "getHamsProductKeyForProject", () => $be23717f2b4b385d$export$74f585c1245fa1a4);


var $1laI5 = parcelRequire("1laI5");
const $be23717f2b4b385d$export$413aba2429285627 = (applicationKey)=>{
    // JPD key does not have '.ondemand'
    if (applicationKey === (0, $c06e1abca7c13910$export$202f50ee62667e32)) return applicationKey;
    return `${applicationKey}.ondemand`;
};
const $be23717f2b4b385d$export$74f585c1245fa1a4 = (project)=>{
    const application = (0, $1laI5.projectToApplicationKey)(project);
    return $be23717f2b4b385d$export$413aba2429285627(application);
};

});

parcelRegister("5oBMG", function(module, exports) {

$parcel$export(module.exports, "useProductEntitlementDetails", () => $3295ae4955475ae4$export$e02d6385b5d47f5d);

var $9OXo1 = parcelRequire("9OXo1");
const $3295ae4955475ae4$export$e02d6385b5d47f5d = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.productEntitlementDetails || null;
};

});


parcelRegister("9JG4b", function(module, exports) {

$parcel$export(module.exports, "PaidFeatureAwarenessStandardLozenge", () => $2cc69a400fe5eaed$export$7ffe6b10a925635e);
$parcel$export(module.exports, "PaidFeatureAwarenessPremiumLozenge", () => $2cc69a400fe5eaed$export$c759caf4220d9852);

var $5uXOq = parcelRequire("5uXOq");

var $aYAc3 = parcelRequire("aYAc3");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $6J1YC = parcelRequire("6J1YC");
const $2cc69a400fe5eaed$export$7ffe6b10a925635e = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $6J1YC.default).standardTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
        appearance: "new"
    }, formatMessage((0, $6J1YC.default).standardLozenge)));
};
const $2cc69a400fe5eaed$export$c759caf4220d9852 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $6J1YC.default).premiumTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
        appearance: "new"
    }, formatMessage((0, $6J1YC.default).premiumLozenge)));
};

});
parcelRegister("6J1YC", function(module, exports) {

$parcel$export(module.exports, "default", () => $93f00b26671642aa$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $93f00b26671642aa$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    standardLozenge: {
        "id": "paid-feature-awareness.standard-lozenge",
        "defaultMessage": "Standard"
    },
    premiumLozenge: {
        "id": "paid-feature-awareness.premium-lozenge",
        "defaultMessage": "Premium"
    },
    standardGemTooltip: {
        "id": "paid-feature-awareness.standard-gem-tooltip",
        "defaultMessage": "This is a Standard and Premium plan feature"
    },
    standardTooltip: {
        "id": "paid-feature-awareness.standard-lozenge-tooltip",
        "defaultMessage": "This is a Standard plan feature"
    },
    premiumTooltip: {
        "id": "paid-feature-awareness.premium-tooltip",
        "defaultMessage": "This is a Premium plan feature"
    },
    automationTooltip: {
        "id": "paid-feature-awareness.automation-tooltip",
        "defaultMessage": "Automations varies by plan. Free: 100 rule runs/mo; Standard: 1,700 rule runs/mo; Premium: 1000 rule runs per user/mo"
    }
});

});


parcelRegister("5layf", function(module, exports) {

$parcel$export(module.exports, "asyncPlansSectionPlanListViewQuery", () => $fd20310af43be2cc$export$c2f76ac2cce77bea);

var $52dVj = parcelRequire("52dVj");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $fd20310af43be2cc$export$c2f76ac2cce77bea = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("4qBxX")).then((module)=>module.Nav4PlansListViewQuery), {
        moduleId: "90d35cd1",
        moduleName: "Nav4PlansListViewQuery",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                queryRef: {
                    parameters: $52dVj.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("52dVj", function(module, exports) {

$parcel$export(module.exports, "default", () => $31e75d27297f8a2d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<13ada8ab5784924200cecfb33f227c54>>
 * @relayHash b54037546462386bcbf5461949d12fa7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 269fd60bec2d8a735ea27d4119024830098f5c9a3eec94ace82ccb0911de1867

var $95Z36 = parcelRequire("95Z36");
const $31e75d27297f8a2d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            v3 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v5 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "planId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isReadOnly"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "planStatus"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                },
                                v3 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "JiraScenario",
                            "kind": "LinkedField",
                            "name": "scenario",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "scenarioId"
                                },
                                v3 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "defaultNavigationItem",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "url"
                                                }
                                            ],
                                            "type": "JiraSoftwareBuiltInNavigationItem"
                                        },
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ],
                    "type": "JiraPlan"
                },
                v4 /*: any*/ 
            ]
        }
    ], v6 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "Nav4PlansListViewQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "PlansList"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "Nav4PlansListViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "favouritePlans",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "sort": {
                                            "order": "DESC"
                                        },
                                        "type": "PLAN"
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 15
                                }
                            ],
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v5 /*: any*/ 
                                },
                                v6 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "recentPlans",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 20
                                },
                                {
                                    "kind": "Literal",
                                    "name": "types",
                                    "value": [
                                        "PLAN"
                                    ]
                                }
                            ],
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v5 /*: any*/ 
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "269fd60bec2d8a735ea27d4119024830098f5c9a3eec94ace82ccb0911de1867",
            "metadata": {},
            "name": "Nav4PlansListViewQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider": (0, $95Z36.default)
            }
        }
    };
}();
$31e75d27297f8a2d$var$node.hash = "e67bfd2d42ed8352fb6fada08981300c";
var $31e75d27297f8a2d$export$2e2bcd8739ae039 = $31e75d27297f8a2d$var$node;

});

parcelRegister("4qBxX", function(module, exports) {

let $3396b71d2b3c70a5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3396b71d2b3c70a5$var$load("jVUfy").then(()=>parcelRequire('2N2w4'));

});



parcelRegister("iC65q", function(module, exports) {

$parcel$export(module.exports, "Nav4PlansForLanding", () => $7e0bd176a951675e$export$5e6b364538aa2f20);

var $lkgPQ = parcelRequire("lkgPQ");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $bUmQV = parcelRequire("bUmQV");

var $lnznH = parcelRequire("lnznH");
var $cZa9B = parcelRequire("cZa9B");

var $jecJ3 = parcelRequire("jecJ3");

var $jhS4y = parcelRequire("jhS4y");

var $46Cti = parcelRequire("46Cti");

var $c16H2 = parcelRequire("c16H2");

var $dQbFB = parcelRequire("dQbFB");

var $eQV8d = parcelRequire("eQV8d");

var $dUyqZ = parcelRequire("dUyqZ");

var $cmvab = parcelRequire("cmvab");

var $9JG4b = parcelRequire("9JG4b");

var $fb8Lj = parcelRequire("fb8Lj");

var $bQ7Ub = parcelRequire("bQ7Ub");

var $4R6GH = parcelRequire("4R6GH");
function $7e0bd176a951675e$export$5e6b364538aa2f20(props) {
    const { actionsOnHover: actionsOnHover, isExpanded: isExpanded, queryRef: queryRef } = props;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).PLANS);
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    const data = (0, $8Uumt.useFragment)((0, $lkgPQ.default), queryRef);
    const menuId = (0, $jhS4y.MENU_ID_PLANS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $46Cti.L1_MENU_ID).PLANS,
                sectionItem: (0, $jecJ3.SECTION_ITEM_PLANS)
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZa9B.ExpandableMenuItemTrigger), {
        interactionName: (0, $4R6GH.fg)('blu-7837_apply_presstrace_nav4') ? 'nav4-sidebar-plans-landing' : undefined,
        actionsOnHover: actionsOnHover,
        elemBefore: icon,
        testId: (0, $dQbFB.getTestId)(menuId)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
        gap: "space.100",
        alignItems: "center"
    }, formattedMessage, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cmvab.PaidFeatureAwarenessRenderer), {
        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9JG4b.PaidFeatureAwarenessPremiumLozenge), null),
        placement: "navigation.plans"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnznH.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bQ7Ub.PlansList), {
        fragmentRef: data
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fb8Lj.Nav4PlansFooter), null)));
}

});
parcelRegister("lkgPQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $df8c46c4fcd1f5f0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bc8f47418a0aaa6d19370311cfed6f24>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $df8c46c4fcd1f5f0$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4PlansForLanding",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "PlansList"
        }
    ],
    "type": "Query"
};
$df8c46c4fcd1f5f0$var$node.hash = "4a68bb76768003096c8b0a4da492d88a";
var $df8c46c4fcd1f5f0$export$2e2bcd8739ae039 = $df8c46c4fcd1f5f0$var$node;

});

parcelRegister("bQ7Ub", function(module, exports) {

$parcel$export(module.exports, "PlansList", () => $fd1fb502ced6933e$export$610289543b80d1e7);

var $9Ye9m = parcelRequire("9Ye9m");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $gSZmd = parcelRequire("gSZmd");
var $1qQhw = parcelRequire("1qQhw");
var $1FdfO = parcelRequire("1FdfO");
var $2CQvU = parcelRequire("2CQvU");

var $koVbs = parcelRequire("koVbs");

var $jhS4y = parcelRequire("jhS4y");

var $c6x3L = parcelRequire("c6x3L");

var $9Gyp5 = parcelRequire("9Gyp5");

var $gxbcq = parcelRequire("gxbcq");

var $1b6zA = parcelRequire("1b6zA");

var $92lvB = parcelRequire("92lvB");

var $koeKL = parcelRequire("koeKL");

var $aQcVR = parcelRequire("aQcVR");

var $gT8yh = parcelRequire("gT8yh");

var $a6aJc = parcelRequire("a6aJc");
const $fd1fb502ced6933e$var$MAX_RECENT_PLANS = 5;
const $fd1fb502ced6933e$export$610289543b80d1e7 = ({ fragmentRef: fragmentRef })=>{
    const { isSelectedPath: isSelectedPath } = (0, $c6x3L.useSidebarNav4)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { getStableItems: getStableItems } = (0, $1b6zA.useStableItems)();
    const [data, refetch] = (0, $8Uumt.useRefetchableFragment)((0, $9Ye9m.default), fragmentRef);
    (0, $9Gyp5.useRefetchWhenIsSelected)({
        cloudId: cloudId,
        isSelectedPath: isSelectedPath,
        QUERY: $92lvB.default,
        refetch: refetch,
        menuId: (0, $jhS4y.MENU_ID_PLANS)
    });
    const refetchOnChange = (0, $5uXOq.useCallback)(({ onComplete: onComplete })=>{
        refetch({
            cloudId: cloudId
        }, {
            fetchPolicy: 'store-and-network',
            onComplete: onComplete
        });
    }, [
        cloudId,
        refetch
    ]);
    (0, $gxbcq.useSubscribeAndUpdateFavorites)({
        entityTypename: 'JiraPlan',
        favouriteConnectionId: data?.jira.favouritePlans.__id || '',
        recentConnectionId: data?.jira.recentPlans.__id || '',
        refetch: refetchOnChange
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const starred = formatMessage((0, $gT8yh.default).starred);
    const recent = formatMessage((0, $gT8yh.default).recent);
    const favorites = (0, $5uXOq.useMemo)(()=>{
        if (!data) return {
            idSet: new Set(),
            list: [],
            hasItems: false
        };
        const ids = data.jira.favouritePlans.edges?.map((edge)=>edge?.node.id).filter(Boolean) ?? [];
        const list = data.jira.favouritePlans.edges?.filter(Boolean).map((edge)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a6aJc.PlanMenuItem), {
                key: edge.node.planId,
                fragmentRef: edge.node,
                favouriteConnectionId: data.jira.favouritePlans.__id
            })) ?? [];
        return {
            idSet: new Set(ids),
            list: list,
            hasItems: Boolean(list.length)
        };
    }, [
        data
    ]);
    const recentPlans = (0, $5uXOq.useMemo)(()=>{
        if (!data) return {
            list: [],
            hasItems: false
        };
        const nodes = data.jira.recentPlans.edges?.filter(Boolean).filter((edge)=>edge.node.id && !favorites.idSet.has(edge.node.id)).map((edge)=>edge.node).slice(0, $fd1fb502ced6933e$var$MAX_RECENT_PLANS) ?? [];
        const stableOrderedNodes = getStableItems({
            nodes: nodes,
            idKey: 'id'
        });
        const list = stableOrderedNodes.map((node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a6aJc.PlanMenuItem), {
                key: node.planId,
                fragmentRef: node,
                favouriteConnectionId: data.jira.favouritePlans.__id
            }));
        return {
            list: list,
            hasItems: Boolean(list.length)
        };
    }, [
        data,
        favorites.idSet,
        getStableItems
    ]);
    if (!favorites.hasItems && !recentPlans.hasItems) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aQcVR.PlansEmptyContent), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, favorites.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1qQhw.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1FdfO.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2CQvU.MenuSectionHeading), null, starred), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gSZmd.MenuList), null, favorites.list))), recentPlans.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1qQhw.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1FdfO.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2CQvU.MenuSectionHeading), null, recent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gSZmd.MenuList), null, recentPlans.list))));
};

});
parcelRegister("9Ye9m", function(module, exports) {

$parcel$export(module.exports, "default", () => $231987b90f34a9fa$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8ff8a16a0bcc9abd1a27e939d9b4ea35>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $92lvB = parcelRequire("92lvB");
const $231987b90f34a9fa$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "planId"
    }, v3 = {
        "kind": "FragmentSpread",
        "name": "PlanMenuItem"
    }, v4 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "currentURLPath"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "refetch": {
                "fragmentPathInResult": [],
                "operation": (0, $92lvB.default)
            }
        },
        "name": "PlansList",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "favouritePlans",
                                "args": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": {
                                            "sort": {
                                                "order": "DESC"
                                            },
                                            "type": "PLAN"
                                        }
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 15
                                    }
                                ],
                                "concreteType": "JiraFavouriteConnection",
                                "kind": "LinkedField",
                                "name": "favourites",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraFavouriteEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v1 /*: any*/ ,
                                                                    "action": "LOG",
                                                                    "path": "jira.favouritePlans.edges.node.id"
                                                                },
                                                                v2 /*: any*/ ,
                                                                v3 /*: any*/ 
                                                            ],
                                                            "type": "JiraPlan"
                                                        }
                                                    ]
                                                },
                                                "action": "LOG",
                                                "path": "jira.favouritePlans.edges.node"
                                            }
                                        ]
                                    },
                                    v4 /*: any*/ 
                                ]
                            },
                            "action": "LOG",
                            "path": "jira.favouritePlans"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "recentPlans",
                                "args": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Variable",
                                        "name": "currentURL",
                                        "variableName": "currentURLPath"
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 20
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "types",
                                        "value": [
                                            "PLAN"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraSearchableEntityConnection",
                                "kind": "LinkedField",
                                "name": "recentItems",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraSearchableEntityEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v1 /*: any*/ ,
                                                                    "action": "LOG",
                                                                    "path": "jira.recentPlans.edges.node.id"
                                                                },
                                                                v2 /*: any*/ ,
                                                                v3 /*: any*/ 
                                                            ],
                                                            "type": "JiraPlan"
                                                        }
                                                    ]
                                                },
                                                "action": "LOG",
                                                "path": "jira.recentPlans.edges.node"
                                            }
                                        ]
                                    },
                                    v4 /*: any*/ 
                                ]
                            },
                            "action": "LOG",
                            "path": "jira.recentPlans"
                        }
                    ]
                },
                "action": "LOG",
                "path": "jira"
            }
        ],
        "type": "Query"
    };
}();
$231987b90f34a9fa$var$node.hash = "e819441248aed1e08c25170c0c3e028c";
var $231987b90f34a9fa$export$2e2bcd8739ae039 = $231987b90f34a9fa$var$node;

});
parcelRegister("92lvB", function(module, exports) {

$parcel$export(module.exports, "default", () => $1036deebd1a68627$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8cb434f85c9e6ca38bdd72366b279c9e>>
 * @relayHash dc8a00662ff37b67d74342ec40bed340
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d42636d7783b046b016d9b617758731771505ab2695a72eb1ab950f3c0ec1101

var $95Z36 = parcelRequire("95Z36");
const $1036deebd1a68627$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "currentURLPath"
    }, v2 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            v4 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v6 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v3 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "planId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isReadOnly"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "planStatus"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                },
                                v4 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "JiraScenario",
                            "kind": "LinkedField",
                            "name": "scenario",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "scenarioId"
                                },
                                v4 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "defaultNavigationItem",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "url"
                                                }
                                            ],
                                            "type": "JiraSoftwareBuiltInNavigationItem"
                                        },
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ],
                    "type": "JiraPlan"
                },
                v5 /*: any*/ 
            ]
        }
    ], v7 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PlanListQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "currentURLPath",
                            "variableName": "currentURLPath"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "PlansList"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "PlanListQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "favouritePlans",
                            "args": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "sort": {
                                            "order": "DESC"
                                        },
                                        "type": "PLAN"
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 15
                                }
                            ],
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v6 /*: any*/ 
                                },
                                v7 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "recentPlans",
                            "args": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "currentURL",
                                    "variableName": "currentURLPath"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 20
                                },
                                {
                                    "kind": "Literal",
                                    "name": "types",
                                    "value": [
                                        "PLAN"
                                    ]
                                }
                            ],
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v6 /*: any*/ 
                                },
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d42636d7783b046b016d9b617758731771505ab2695a72eb1ab950f3c0ec1101",
            "metadata": {},
            "name": "PlanListQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider": (0, $95Z36.default)
            }
        }
    };
}();
$1036deebd1a68627$var$node.hash = "e819441248aed1e08c25170c0c3e028c";
var $1036deebd1a68627$export$2e2bcd8739ae039 = $1036deebd1a68627$var$node;

});


parcelRegister("aQcVR", function(module, exports) {

$parcel$export(module.exports, "PlansEmptyContent", () => $eeca831f93fd0984$export$2b2efe96e6f14be5);

var $5uXOq = parcelRequire("5uXOq");

var $dS3PR = parcelRequire("dS3PR");

var $koVbs = parcelRequire("koVbs");

var $7lgBG = parcelRequire("7lgBG");

var $8Pg2W = parcelRequire("8Pg2W");
function $eeca831f93fd0984$export$2b2efe96e6f14be5() {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7lgBG.EmptyContentMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        size: "small",
        color: "color.text.subtle"
    }, formatMessage((0, $8Pg2W.default).noPlans)));
}

});
parcelRegister("8Pg2W", function(module, exports) {

$parcel$export(module.exports, "default", () => $07cf8d171bf729c5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $07cf8d171bf729c5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noPlans: {
        "id": "navigation-apps-sidebar-nav4-plans.plans.common.empty-content.no-plans",
        "defaultMessage": "Once you open or create plans, they'll show up here."
    }
});

});


parcelRegister("gT8yh", function(module, exports) {

$parcel$export(module.exports, "default", () => $b67eb75de0b9f683$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b67eb75de0b9f683$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    recent: {
        "id": "navigation-apps-sidebar-nav4-plans.plans.common.plans-list.recent",
        "defaultMessage": "Recent"
    },
    starred: {
        "id": "navigation-apps-sidebar-nav4-plans.plans.common.plans-list.starred",
        "defaultMessage": "Starred"
    }
});

});

parcelRegister("a6aJc", function(module, exports) {

$parcel$export(module.exports, "PlanMenuItem", () => $73683d423a412055$export$5805f023607bba3d);

var $1rvIC = parcelRequire("1rvIC");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $ifnb0 = parcelRequire("ifnb0");



var $jecJ3 = parcelRequire("jecJ3");

var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $5FnJJ = parcelRequire("5FnJJ");

var $2oTRI = parcelRequire("2oTRI");

var $8jQu6 = parcelRequire("8jQu6");

var $9VXkC = parcelRequire("9VXkC");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $9n0dK = parcelRequire("9n0dK");


var $bjtEO = parcelRequire("bjtEO");
const $73683d423a412055$var$VIEW_ALL_PLANS_HREF = (0, $8jQu6.plansDirectoryRoute).path;
const $73683d423a412055$export$5805f023607bba3d = ({ fragmentRef: fragmentRef, favouriteConnectionId: favouriteConnectionId })=>{
    const data = (0, $8Uumt.useFragment)((0, $1rvIC.default), fragmentRef);
    const planId = data?.planId;
    const isStarred = data?.favouriteValue?.isFavourite ?? false;
    const scenarioId = data.scenario.scenarioId;
    const planTitle = data.title || '';
    const planUrl = data.defaultNavigationItem?.url || (0, $9VXkC.generatePath)((0, $2oTRI.softwarePlanTimelineRoute).path, {
        planId: planId,
        scenarioId: scenarioId
    });
    const isReadOnly = data.isReadOnly || false;
    const isArchived = data.planStatus === 'ARCHIVED';
    const analytics = (0, $5uXOq.useMemo)(()=>({
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_PLANS],
            level: 1,
            componentType: (0, $1e554a683893bd46$export$3ac911b122986477),
            itemId: (0, $632bd8725b437a12$export$c303e491e026ebc6),
            planId: planId ?? undefined,
            // TODO BLU-5544 send section via a single <ContextualAnalyticsData instead (which wraps the Starred or Recent panel). Use static object or useMemo, not to have rerendering issues.
            section: isStarred ? (0, $jecJ3.SECTION_ITEM_STARRED) : (0, $jecJ3.SECTION_ITEM_RECENT)
        }), [
        planId,
        isStarred
    ]);
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            planId: planId,
            scenarioId: scenarioId,
            planTitle: planTitle,
            isReadOnly: isReadOnly,
            isArchived: isArchived,
            isStarred: isStarred,
            isUsedForSidebarNav: true,
            favouriteConnectionId: favouriteConnectionId
        }), [
        planId,
        scenarioId,
        planTitle,
        isReadOnly,
        isArchived,
        isStarred,
        favouriteConnectionId
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $bjtEO.asyncPlanActionMenu), entryPointParams);
    const triggerRef = (0, $9n0dK.useHoverEntryPointTrigger)(entryPointActions);
    if (!data) return null;
    return planId && scenarioId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        analytics: analytics,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ifnb0))), {
            label: "",
            color: "currentColor"
        }),
        href: planUrl || $73683d423a412055$var$VIEW_ALL_PLANS_HREF,
        menuId: (0, $jhS4y.ENTITY_ID).PLAN(String(planId)),
        ref: triggerRef,
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "nav4-sidebar-plan-action-menu",
            packageName: (0, $b0ee4c2dffa12273$export$b8b9d90f9e5bd72b),
            errorFallback: "flag",
            teamName: (0, $b0ee4c2dffa12273$export$d57b6b390e78d90f),
            runtimeProps: entryPointParams
        })
    }, planTitle);
};

});
parcelRegister("1rvIC", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d8c7f66b9423475$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ad0f12f4849b9a67be4a9939134d918e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7d8c7f66b9423475$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "PlanMenuItem",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "planId"
            },
            "action": "THROW",
            "path": "planId"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "isReadOnly"
        },
        {
            "kind": "ScalarField",
            "name": "planStatus"
        },
        {
            "concreteType": "JiraFavouriteValue",
            "kind": "LinkedField",
            "name": "favouriteValue",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isFavourite"
                }
            ]
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraScenario",
                "kind": "LinkedField",
                "name": "scenario",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "scenarioId"
                        },
                        "action": "THROW",
                        "path": "scenario.scenarioId"
                    }
                ]
            },
            "action": "THROW",
            "path": "scenario"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "defaultNavigationItem",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "url"
                                }
                            ],
                            "type": "JiraSoftwareBuiltInNavigationItem"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraPlan"
};
$7d8c7f66b9423475$var$node.hash = "7f7a892ec8cae58cbf0430a7e53973c3";
var $7d8c7f66b9423475$export$2e2bcd8739ae039 = $7d8c7f66b9423475$var$node;

});

parcelRegister("2oTRI", function(module, exports) {

$parcel$export(module.exports, "softwarePlanTimelineRoute", () => $946f497d921d5041$export$61abeb6a03d23dd3);
const $946f497d921d5041$export$61abeb6a03d23dd3 = {
    name: 'software-plan-timeline',
    path: '/jira/plans/:planId/scenarios/:scenarioId/timeline'
};

});

parcelRegister("9n0dK", function(module, exports) {

$parcel$export(module.exports, "useHoverEntryPointTrigger", () => $d6bed0b5126727ff$export$129b8109f51bc05b);

var $5uXOq = parcelRequire("5uXOq");

var $47gW9 = parcelRequire("47gW9");
const $d6bed0b5126727ff$export$129b8109f51bc05b = (actions, isActive = true)=>{
    const eventMap = (0, $5uXOq.useMemo)(()=>({
            mouseenter: actions.load,
            focusin: actions.load
        }), [
        actions
    ]);
    return (0, $47gW9.useEntryPointButtonTrigger)(actions, isActive, eventMap);
};

});

parcelRegister("bjtEO", function(module, exports) {

$parcel$export(module.exports, "asyncPlanActionMenu", () => $9dac3a4e8eabd3c7$export$62f1bed3a2f7698);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $9dac3a4e8eabd3c7$export$62f1bed3a2f7698 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("3QnpI")).then(({ AsyncPlanActionMenuContent: AsyncPlanActionMenuContent })=>AsyncPlanActionMenuContent), {
        moduleId: "3038e241",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3QnpI", function(module, exports) {

let $2cc863e4b6352954$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $2cc863e4b6352954$var$load("ffQaD"),
    $2cc863e4b6352954$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("fZ68K"), 4)),
    $2cc863e4b6352954$var$load("bnDM4")
]).then(()=>parcelRequire('k16yv'));

});





parcelRegister("iUfQY", function(module, exports) {

$parcel$export(module.exports, "Nav4PlansPremiumUpsellFeatureGate", () => $dd47fda66af0f6fa$export$87c172423f26b2a0);

var $5uXOq = parcelRequire("5uXOq");

var $jUDIz = parcelRequire("jUDIz");
var $17aWz = parcelRequire("17aWz");
var $lBNLs = parcelRequire("lBNLs");

var $aProA = parcelRequire("aProA");

var $46Cti = parcelRequire("46Cti");

var $4R6GH = parcelRequire("4R6GH");

var $dUyqZ = parcelRequire("dUyqZ");

var $jhS4y = parcelRequire("jhS4y");

var $5FnJJ = parcelRequire("5FnJJ");

var $4mO32 = parcelRequire("4mO32");

var $47gW9 = parcelRequire("47gW9");

var $fzr0K = parcelRequire("fzr0K");

var $eCT4E = parcelRequire("eCT4E");

var $6s1PB = parcelRequire("6s1PB");
const $dd47fda66af0f6fa$var$EMPTY_OBJECT = {};
const $dd47fda66af0f6fa$export$87c172423f26b2a0 = ()=>{
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).PLANS);
    const { entryPointActions: entryPointActions } = (0, $4mO32.useEntryPoint)((0, $fzr0K.planUpsellEntryPoint), (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? $dd47fda66af0f6fa$var$EMPTY_OBJECT : {});
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    if ((0, $4R6GH.fg)('supercharge_timelines_with_plans_kill_switch')) {
        const [stwpConfig, fireStwpExposure] = (0, $6s1PB.UNSAFE_noExposureExp)('supercharge_timelines_with_plans_experiment');
        const stwpCohort = stwpConfig.get('cohort', 'not-enrolled');
        if (stwpCohort === 'variation') {
            const { path: path } = (0, $eCT4E.planUpsellRoute);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
                menuId: (0, $jhS4y.MENU_ID_PLANS),
                elemBefore: icon,
                href: path,
                ref: triggerRef,
                onClick: fireStwpExposure
            }, formattedMessage);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jUDIz.FlyoutMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lBNLs.FlyoutMenuItemTrigger), {
            interactionName: (0, $4R6GH.fg)('blu-7837_apply_presstrace_nav4') ? 'nav4-sidebar-plans-premium-upsell' : undefined,
            elemBefore: icon,
            onClick: fireStwpExposure
        }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $17aWz.FlyoutMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aProA.default), null)));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jUDIz.FlyoutMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lBNLs.FlyoutMenuItemTrigger), {
        interactionName: (0, $4R6GH.fg)('blu-7837_apply_presstrace_nav4') ? 'nav4-sidebar-plans-premium-upsell' : undefined,
        elemBefore: icon
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $17aWz.FlyoutMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aProA.default), null)));
};

});
parcelRegister("aProA", function(module, exports) {

$parcel$export(module.exports, "default", () => $59ef1621dccedbfe$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9yOBd = parcelRequire("9yOBd");

var $l1N8i = parcelRequire("l1N8i");

var $3ZC89 = parcelRequire("3ZC89");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $hxoiH = parcelRequire("hxoiH");

var $iwnVa = parcelRequire("iwnVa");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $liGrj = parcelRequire("liGrj");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");

var $dCm1o = parcelRequire("dCm1o");

var $Mp6qH = parcelRequire("Mp6qH");

var $iIz7a = parcelRequire("iIz7a");

var $gblI8 = parcelRequire("gblI8");
const $59ef1621dccedbfe$var$LEARN_MORE_LINK = 'https://www.atlassian.com/software/jira/guides/advanced-roadmaps/overview#what-are-advanced-roadmaps'; // Statsig experiment `plans_menu_try_it_free_one_stop_shop_modal`
// the control cohort will be shown the modal, whereas the test cohort will be redirected to the billing page instead.
// if the check errors for whatever reason, we still want to show the modal, hence why it defaults to true
const $59ef1621dccedbfe$var$PremiumFeatureGate = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    const { data: { premiumTrialUpgradeLink: premiumTrialUpgradeLink } } = (0, $6s1PB.expVal)('plans_menu_try_it_free_one_stop_shop_modal', 'isOneStopShopModalEnabled', true) ? {
        data: {
            premiumTrialUpgradeLink: undefined
        }
    } : // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $iwnVa.useJswPremiumTrialUpgradeLink)({
        caller: (0, $Mp6qH.PACKAGE_NAME)
    });
    const onStartTrialClick = (_, analyticsEvent)=>{
        if ((0, $dCm1o.isVisualRefreshEnabled)()) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'plansNavigationMenuItem', {
            level: 2,
            componentType: 'fixedItemAction',
            parentItemId: 'plans',
            itemId: 'tryItFree'
        });
        else (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'navigationUpgradeToPremiumFromPlansMenu');
    };
    const onLearnMoreClick = (_, analyticsEvent)=>{
        if ((0, $dCm1o.isVisualRefreshEnabled)()) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'plansNavigationMenuItem', {
            level: 2,
            componentType: 'fixedItemAction',
            parentItemId: 'plans',
            itemId: 'readTheGuide'
        });
        else (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'navigationLearnMoreAboutPremiumFromPlansMenu');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "plansPremiumFeatureGate",
        sourceType: "Modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59ef1621dccedbfe$var$MenuContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59ef1621dccedbfe$var$MenuHeaderContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iIz7a.FeatureGateLogo), {
        alt: "",
        colorMode: colorMode
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59ef1621dccedbfe$var$ContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "small",
        as: "h2"
    }, formatMessage((0, $gblI8.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $59ef1621dccedbfe$var$contentDescriptionStyles
    }, formatMessage((0, $gblI8.default).description))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59ef1621dccedbfe$var$FooterContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59ef1621dccedbfe$var$LearnMoreButton, {
        appearance: "link",
        href: $59ef1621dccedbfe$var$LEARN_MORE_LINK,
        target: "_blank",
        onClick: onLearnMoreClick
    }, formatMessage((0, $gblI8.default).learnMoreLink)), (0, $6s1PB.expVal)('plans_menu_try_it_free_one_stop_shop_modal', 'isOneStopShopModalEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59ef1621dccedbfe$var$TryPremiumButton, {
        onClick: onStartTrialClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3ZC89))), {
            LEGACY_size: "small",
            label: formatMessage((0, $gblI8.default).imageAlt),
            color: "var(--ds-text-inverse, #FFFFFF)"
        })
    }, formatMessage((0, $gblI8.default).startTrialButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59ef1621dccedbfe$var$TryPremiumButtonDirectLink, {
        href: premiumTrialUpgradeLink,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3ZC89))), {
            LEGACY_size: "small",
            label: formatMessage((0, $gblI8.default).imageAlt),
            color: "var(--ds-text-inverse, #FFFFFF)"
        })
    }, formatMessage((0, $gblI8.default).startTrialButton)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null));
};
var $59ef1621dccedbfe$export$2e2bcd8739ae039 = $59ef1621dccedbfe$var$PremiumFeatureGate;
const $59ef1621dccedbfe$var$TryPremiumButton = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $liGrj.PremiumUpgradeModalEntryPointButton), {
        ...props,
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    display: 'flex',
                    alignItems: 'center',
                    background: `linear-gradient(135deg, ${"var(--ds-background-discovery-bold, #6E5DC6)"}, ${"var(--ds-background-brand-bold, #0C66E4)"})`,
                    color: "var(--ds-text-inverse, #FFFFFF)",
                    outline: 'none',
                    boxSizing: 'border-box',
                    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
                    borderRadius: "var(--ds-space-050, 4px)",
                    height: "var(--ds-space-400, 32px)",
                    border: 'none',
                    font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                    gap: "var(--ds-space-025, 2px)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    });
const $59ef1621dccedbfe$var$TryPremiumButtonDirectLink = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
        ...props,
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    display: 'flex',
                    alignItems: 'center',
                    background: `linear-gradient(135deg, ${"var(--ds-background-discovery-bold, #6E5DC6)"}, ${"var(--ds-background-brand-bold, #0C66E4)"})`,
                    color: "var(--ds-text-inverse, #FFFFFF)",
                    outline: 'none',
                    boxSizing: 'border-box',
                    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
                    borderRadius: "var(--ds-space-050, 4px)",
                    height: "var(--ds-space-400, 32px)",
                    border: 'none',
                    font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                    gap: "var(--ds-space-025, 2px)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    });
const $59ef1621dccedbfe$var$LearnMoreButton = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
        ...props,
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    maxWidth: '250px',
                    marginRight: "var(--ds-space-200, 16px)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $59ef1621dccedbfe$var$MenuContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1b66 _11q717kt _189et94y _1dqonqa1 _1h6d3acm _vchhusvi _qjkjusvi _1y1m18uv _p12f4lgm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $59ef1621dccedbfe$var$MenuHeaderContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q7gup1 _2rko1xsr _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _4t3il1r9 _kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $59ef1621dccedbfe$var$ContentContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q7vuon _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
            __cmplp.className
        ])
    });
});
const $59ef1621dccedbfe$var$contentDescriptionStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $59ef1621dccedbfe$var$FooterContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q7vuon _2rko4dok _ca0qidpf _u5f31ejb _n3td1ejb _19bv1ejb _1e0c1txw _4cvr1h6o _1bahesu3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3ZC89", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b007f69ad81895a86b02f3ac63c0846>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2e84a5872037db9e$var$_react = $2e84a5872037db9e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2e84a5872037db9e$var$_premium = $2e84a5872037db9e$var$_interopRequireDefault((parcelRequire("41hx5")));

var $2e84a5872037db9e$var$_premium2 = $2e84a5872037db9e$var$_interopRequireDefault((parcelRequire("8EYBJ")));
function $2e84a5872037db9e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PremiumIcon.
 * This component is PremiumIcon, with `UNSAFE_fallbackIcon` set to "PremiumIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for premium features.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2e84a5872037db9e$var$PremiumIcon = (props)=>/*#__PURE__*/ $2e84a5872037db9e$var$_react.default.createElement($2e84a5872037db9e$var$_premium.default, Object.assign({
        LEGACY_fallbackIcon: $2e84a5872037db9e$var$_premium2.default
    }, props));
$2e84a5872037db9e$var$PremiumIcon.Name = 'PremiumIconMigration';
var $2e84a5872037db9e$var$_default = module.exports.default = $2e84a5872037db9e$var$PremiumIcon;

});
parcelRegister("41hx5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::821d8a868bec01d1b9c95a45239911fb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ed4db10c38a4841$var$_react = $2ed4db10c38a4841$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2ed4db10c38a4841$var$_baseNew = $2ed4db10c38a4841$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $2ed4db10c38a4841$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Premium".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for premium features.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2ed4db10c38a4841$var$PremiumIcon = (props)=>/*#__PURE__*/ $2ed4db10c38a4841$var$_react.default.createElement($2ed4db10c38a4841$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.5 3v1.5H3V3h1.5V1.5H3V0H1.5v1.5H0V3zM8 1c.31 0 .587.19.699.478l1.63 4.193 4.193 1.63a.75.75 0 0 1 0 1.398l-4.193 1.63-1.63 4.193a.75.75 0 0 1-1.398 0l-1.63-4.193L1.478 8.7a.75.75 0 0 1 0-1.398l4.193-1.63L7.3 1.478A.75.75 0 0 1 8 1m0 2.82L6.949 6.521a.75.75 0 0 1-.427.427L3.819 8l2.703 1.051a.75.75 0 0 1 .427.427L8 12.181l1.051-2.703a.75.75 0 0 1 .427-.427L12.181 8 9.478 6.949a.75.75 0 0 1-.427-.427zm5 10.68V16h1.5v-1.5H16V13h-1.5v-1.5H13V13h-1.5v1.5z" clip-rule="evenodd"/>`
    }, props));
$2ed4db10c38a4841$var$PremiumIcon.displayName = 'PremiumIcon';
var $2ed4db10c38a4841$var$_default = module.exports.default = $2ed4db10c38a4841$var$PremiumIcon;

});

parcelRegister("8EYBJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $64e11291068cd489$var$_react = $64e11291068cd489$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $64e11291068cd489$var$_premium = $64e11291068cd489$var$_interopRequireDefault((parcelRequire("41hx5")));
function $64e11291068cd489$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $64e11291068cd489$var$PremiumIcon = (props)=>/*#__PURE__*/ $64e11291068cd489$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M9.276 4.382 7.357 9.247l-4.863 1.917a.78.78 0 0 0 0 1.45l4.863 1.918 1.919 4.863a.78.78 0 0 0 1.45 0h-.001l1.918-4.863 4.864-1.919a.781.781 0 0 0 0-1.45l-4.864-1.916-1.918-4.865a.78.78 0 0 0-.44-.438.78.78 0 0 0-1.01.438m8.297-2.03-.743 1.886-1.884.743a.56.56 0 0 0 0 1.038l1.884.743.743 1.886a.558.558 0 0 0 1.038 0l.745-1.886 1.883-.743a.557.557 0 0 0 0-1.038l-1.883-.743-.745-1.885a.55.55 0 0 0-.314-.314.56.56 0 0 0-.724.314m-.704 13.003-.744 1.883-1.883.744a.55.55 0 0 0-.316.314.56.56 0 0 0 .316.724l1.883.743.744 1.884c.057.144.17.258.314.315a.56.56 0 0 0 .724-.315l.744-1.884 1.883-.743a.557.557 0 0 0 0-1.038l-1.883-.744-.744-1.883a.55.55 0 0 0-.315-.316.56.56 0 0 0-.723.316"/></svg>`
    }, props, {
        newIcon: $64e11291068cd489$var$_premium.default
    }));
$64e11291068cd489$var$PremiumIcon.displayName = 'PremiumIcon';
var $64e11291068cd489$var$_default = module.exports.default = $64e11291068cd489$var$PremiumIcon;

});


parcelRegister("iwnVa", function(module, exports) {

$parcel$export(module.exports, "useJswPremiumTrialUpgradeLink", () => $fc84e0a2b7204935$export$645eda3f5f2163ec);

var $2vSU6 = parcelRequire("2vSU6");


var $ldyPw = parcelRequire("ldyPw");

var $9OXo1 = parcelRequire("9OXo1");

var $7qMMP = parcelRequire("7qMMP");
const $fc84e0a2b7204935$export$645eda3f5f2163ec = ({ deepLink: deepLink = true, skip: skip = false, caller: caller })=>{
    const { productEntitlementDetails: productEntitlementDetails } = (0, $9OXo1.useTenantContext)();
    const jswEntitlement = productEntitlementDetails?.[0, $c06e1abca7c13910$export$1346c9aa3cbb477d];
    const isJswUsingCcp = jswEntitlement?.billingSourceSystem === 'CCP';
    const { data: data, ...rest } = (0, $7qMMP.useGetBillingPageUrl)({
        isUsingCcp: isJswUsingCcp,
        editionToUpgradeTo: deepLink ? (0, $ldyPw.PREMIUM_EDITION) : undefined,
        caller: caller,
        skip: skip,
        subProduct: (0, $2vSU6.SOFTWARE_PROJECT)
    });
    return {
        data: {
            premiumTrialUpgradeLink: data.billingPageUrl
        },
        ...rest
    };
};

});
parcelRegister("7qMMP", function(module, exports) {

$parcel$export(module.exports, "useGetBillingPageUrl", () => $8899a5adc0f59798$export$7b1495b7581dcd01);

var $5uXOq = parcelRequire("5uXOq");

var $cVzoY = parcelRequire("cVzoY");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $14XJw = parcelRequire("14XJw");


var $ldyPw = parcelRequire("ldyPw");

var $16v4H = parcelRequire("16v4H");

var $9OXo1 = parcelRequire("9OXo1");

var $7j7Ij = parcelRequire("7j7Ij");

var $5aye8 = parcelRequire("5aye8");

var $5Q4f1 = parcelRequire("5Q4f1");

var $iHAwr = parcelRequire("iHAwr");
const $8899a5adc0f59798$export$7b1495b7581dcd01 = ({ isUsingCcp: isUsingCcp, editionToUpgradeTo: editionToUpgradeTo, caller: caller, skip: skip = false, subProduct: subProduct, onError: onError })=>{
    const [billingPageUrl, setBillingPageUrl] = (0, $5uXOq.useState)();
    const [loading, setLoading] = (0, $5uXOq.useState)(true);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const contextSubProduct = (0, $16v4H.useSubProduct)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const subProductToUse = subProduct || contextSubProduct;
    (0, $5uXOq.useEffect)(()=>{
        if (skip) return;
        const loadBillingInfo = async ()=>{
            try {
                const explicitlyLicensedProducts = (0, $cVzoY.default)(tenantContext);
                const productKey = (0, $iHAwr.getProductKey)(subProductToUse, explicitlyLicensedProducts);
                const referrerKey = (0, $5aye8.getProductReferrerKey)(productKey);
                // The product key as used by Commerce.
                // JPD product key as used by Commerce does not include .ondemand
                const commerceProductKey = productKey === (0, $c06e1abca7c13910$export$202f50ee62667e32) ? productKey : `${productKey}.ondemand`;
                const entitlementId = productKey ? tenantContext.productEntitlementDetails?.[productKey]?.entitlementId : null;
                if (isUsingCcp) {
                    if (!entitlementId) {
                        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'RetrieveEntitlementId failed', {
                            caller: caller,
                            productKey: productKey,
                            productEntitlementDetails: JSON.stringify(tenantContext.productEntitlementDetails),
                            subProduct: subProductToUse
                        });
                        throw new Error('Empty entitlement ID');
                    }
                    const ccpTransactionAccountId = await (0, $5aye8.getCcpTransactionAccountId)(entitlementId);
                    // List of valid referrer values
                    // https://hello.atlassian.net/wiki/spaces/BILLIONS/pages/2652063891/How+to+Deeplink+to+BAC+s+change+plan#How-to-use-this-deeplink%3F
                    const ccpBaseUrl = `${(0, $5Q4f1.getAdminBaseUrl)()}/billing/o/${orgId}/${ccpTransactionAccountId}/entitlement/${entitlementId}/change-plan?referrer=${referrerKey}&enableMpucup=true`;
                    switch(editionToUpgradeTo){
                        case 0, $ldyPw.STANDARD_EDITION:
                        case 0, $ldyPw.PREMIUM_EDITION:
                            setBillingPageUrl(`${ccpBaseUrl}&offeringName=${(0, $7j7Ij.EDITION_KEY)[editionToUpgradeTo]}`);
                            break;
                        default:
                            setBillingPageUrl(ccpBaseUrl);
                    }
                } else // HAMS Billing System
                switch(editionToUpgradeTo){
                    case 0, $ldyPw.STANDARD_EDITION:
                    case 0, $ldyPw.PREMIUM_EDITION:
                        setBillingPageUrl(`${(0, $5Q4f1.getAdminBaseUrl)()}/s/${tenantContext.cloudId}/billing/applications/change-edition/${commerceProductKey}/${(0, $7j7Ij.EDITION_KEY)[editionToUpgradeTo]}`);
                        break;
                    default:
                        setBillingPageUrl(`${(0, $5Q4f1.getAdminBaseUrl)()}/s/${tenantContext.cloudId}/billing/applications/change-edition/${commerceProductKey}`);
                }
            } catch (e) {
                setError(e);
                if (onError && e instanceof Error) onError(e);
            } finally{
                setLoading(false);
            }
        };
        loadBillingInfo();
    }, [
        caller,
        createAnalyticsEvent,
        editionToUpgradeTo,
        isUsingCcp,
        onError,
        orgId,
        skip,
        subProduct,
        subProductToUse,
        tenantContext,
        tenantContext.cloudId
    ]);
    return {
        data: {
            billingPageUrl: billingPageUrl
        },
        loading: loading,
        error: error
    };
};

});
parcelRegister("cVzoY", function(module, exports) {

$parcel$export(module.exports, "default", () => $386aacc800b616d8$export$2e2bcd8739ae039);

var // eslint-disable-next-line jira/import/no-anonymous-default-export
$386aacc800b616d8$export$2e2bcd8739ae039 = (tenantContext)=>{
    const { licensedProducts: licensedProducts } = tenantContext;
    const result = [];
    licensedProducts[0, $c06e1abca7c13910$export$db515c8cec1e6f79] && result.push((0, $c06e1abca7c13910$export$db515c8cec1e6f79));
    licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61] && result.push((0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61));
    licensedProducts[0, $c06e1abca7c13910$export$1346c9aa3cbb477d] && result.push((0, $c06e1abca7c13910$export$1346c9aa3cbb477d));
    licensedProducts[0, $c06e1abca7c13910$export$202f50ee62667e32] && result.push((0, $c06e1abca7c13910$export$202f50ee62667e32));
    return result;
};

});

parcelRegister("16v4H", function(module, exports) {

$parcel$export(module.exports, "useSubProduct", () => $f7eda04ad2dc7e84$export$16aa2ad52cd8992a);
$parcel$export(module.exports, "subProductFromProjectTypeForAnalytics", () => $f7eda04ad2dc7e84$export$9243583e56af95f6);
$parcel$export(module.exports, "useSubProductForAnalytics", () => $f7eda04ad2dc7e84$export$cbfa57dd4a0c679e);

var $4DPZY = parcelRequire("4DPZY");
const $f7eda04ad2dc7e84$export$246e1e2a5c86a633 = (projectType)=>{
    switch(projectType){
        case 'business':
            return 'core';
        case 'product_discovery':
        case 'software':
            return 'software';
        case 'service_desk':
            return 'serviceDesk';
        default:
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            projectType;
            return 'unknown';
    }
};
const $f7eda04ad2dc7e84$export$16aa2ad52cd8992a = ()=>{
    const [{ data: data }] = (0, $4DPZY.useContainerContext)();
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    if (!data?.project) return null;
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    return $f7eda04ad2dc7e84$export$246e1e2a5c86a633(data.project.type);
};
const $f7eda04ad2dc7e84$export$9243583e56af95f6 = (projectType)=>{
    if (projectType === 'product_discovery') return 'polaris';
    return $f7eda04ad2dc7e84$export$246e1e2a5c86a633(projectType);
};
const $f7eda04ad2dc7e84$export$cbfa57dd4a0c679e = ()=>{
    const [{ data: data }] = (0, $4DPZY.useContainerContext)();
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    if (!data?.project) return null;
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    return $f7eda04ad2dc7e84$export$9243583e56af95f6(data.project.type);
};

});
parcelRegister("4DPZY", function(module, exports) {

$parcel$export(module.exports, "useContainerContext", () => $a65e0c39573f7437$export$c7066c2d215990cf);
$parcel$export(module.exports, "ContainerContextSubscriber", () => $a65e0c39573f7437$export$5b87a78c45d5dd17);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $7xTO3 = parcelRequire("7xTO3");

var $ggg5j = parcelRequire("ggg5j");

var $2YP9W = parcelRequire("2YP9W");

var $6SkQo = parcelRequire("6SkQo");
const $a65e0c39573f7437$var$useProjectContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)((0, $ggg5j.staticProjectSidebarNavigationResource));
    const projectContext = (0, $5uXOq.useMemo)(()=>data && (0, $6SkQo.getProjectContext)(data), [
        data
    ]);
    return [
        {
            data: projectContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $a65e0c39573f7437$var$useUserBoardContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)((0, $7xTO3.staticJSWUserBoardSidebarNavigationResource));
    const userContext = (0, $5uXOq.useMemo)(()=>data && (0, $6SkQo.getUserContext)(data), [
        data
    ]);
    return [
        {
            data: userContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $a65e0c39573f7437$export$c7066c2d215990cf = ()=>{
    const projectContext = $a65e0c39573f7437$var$useProjectContext();
    const userBoardContext = $a65e0c39573f7437$var$useUserBoardContext();
    if (userBoardContext && userBoardContext[0] && userBoardContext[0].data != null) return userBoardContext;
    return projectContext;
};
const $a65e0c39573f7437$export$5b87a78c45d5dd17 = (props)=>{
    const [data, actions] = $a65e0c39573f7437$export$c7066c2d215990cf();
    // @ts-expect-error - TS2345 - Argument of type '{ readonly data: ContainerContext | null; readonly error: Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null; readonly loading: boolean; }' is not assignable to parameter of type 'ContainerContextData'.
    return props.children(data, actions);
};
$a65e0c39573f7437$export$5b87a78c45d5dd17.displayName = 'ContainerContextSubscriber';

});
parcelRegister("6SkQo", function(module, exports) {

$parcel$export(module.exports, "getUserContext", () => $84cf60e2c9c0e289$export$114c35c2c23732ab);
$parcel$export(module.exports, "getProjectContext", () => $84cf60e2c9c0e289$export$d17fffd59c7b3c60);

var $4R6GH = parcelRequire("4R6GH");

var $2vSU6 = parcelRequire("2vSU6");

var $bsuuc = parcelRequire("bsuuc");
const $84cf60e2c9c0e289$export$114c35c2c23732ab = (userBoardNavData)=>{
    const { boardInfo: boardInfo, owner: owner } = userBoardNavData;
    return {
        contextType: 'user',
        user: {
            id: owner.id,
            name: owner.name,
            avatarUrl: owner.avatarUrl,
            profileUrl: owner.profileUrl,
            accountId: owner.accountId
        },
        scope: {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        }
    };
};
const $84cf60e2c9c0e289$var$getScope = (projectNavInfo)=>{
    if (projectNavInfo.projectType === 'jira_software' && projectNavInfo?.jiraSoftwareNavData?.boardInfo) {
        const { boardInfo: boardInfo } = projectNavInfo.jiraSoftwareNavData;
        return {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        };
    }
    return undefined;
};
const $84cf60e2c9c0e289$var$getProjectType = (projectType)=>{
    if (projectType === 'customer_service' && (0, $4R6GH.fg)('jcs_project_type_m3')) return 0, $2vSU6.CUSTOMER_SERVICE_PROJECT;
    switch(projectType){
        case 'business':
            return 0, $2vSU6.CORE_PROJECT;
        case 'software':
            return 0, $2vSU6.SOFTWARE_PROJECT;
        case 'service_desk':
            return 0, $2vSU6.SERVICE_DESK_PROJECT;
        case 'product_discovery':
            return 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $84cf60e2c9c0e289$export$d17fffd59c7b3c60 = (projectNavInfo)=>{
    const project = (0, $bsuuc.extractData)(projectNavInfo);
    const scope = $84cf60e2c9c0e289$var$getScope(projectNavInfo);
    if (project) {
        const projectType = $84cf60e2c9c0e289$var$getProjectType(project.type);
        if (projectType) return {
            contextType: 'project',
            project: {
                key: project.key,
                // @ts-expect-error TS2322: Type 'number' is not assignable to type 'string'
                id: project.id,
                name: project.name,
                type: projectType,
                isSimplified: project.isSimplified,
                avatarUrl: project.avatarUrl,
                style: (0, $bsuuc.getStyle)(project.isSimplified)
            },
            scope: scope
        };
    }
    return null;
};

});



parcelRegister("7j7Ij", function(module, exports) {

$parcel$export(module.exports, "EDITION_KEY", () => $2797dd9db1687273$export$d73720c31c622c1f);

var $ldyPw = parcelRequire("ldyPw");
const $2797dd9db1687273$export$d73720c31c622c1f = {
    STANDARD_EDITION: (0, $ldyPw.STANDARD_EDITION_KEY),
    PREMIUM_EDITION: (0, $ldyPw.PREMIUM_EDITION_KEY)
};

});

parcelRegister("5aye8", function(module, exports) {

$parcel$export(module.exports, "getProductReferrerKey", () => $c065e9df012feb0c$export$b4fb3304d5d8fc5f);
$parcel$export(module.exports, "getCcpTransactionAccountId", () => $c065e9df012feb0c$export$5186b9d213f626fd);

var $7f4tk = parcelRequire("7f4tk");

const $c065e9df012feb0c$export$b4fb3304d5d8fc5f = (productKey)=>{
    if (productKey === (0, $c06e1abca7c13910$export$1346c9aa3cbb477d)) return 'jsw';
    if (productKey === (0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61)) return 'jsm';
    if (productKey === (0, $c06e1abca7c13910$export$202f50ee62667e32)) return 'jpd';
    if (productKey === (0, $c06e1abca7c13910$export$db515c8cec1e6f79)) return 'jwm';
    return null;
};
const $c065e9df012feb0c$export$5186b9d213f626fd = async (entitlementId)=>{
    const entitlementDetails = await (0, $7f4tk.default)(`/gateway/api/ccp/api/v1/entitlements/${entitlementId}/details`);
    if (!entitlementDetails?.transactionAccountId) // TODO: Handle errors properly
    throw Error('Could not get transactionAccountId');
    return (entitlementDetails ?? {}).transactionAccountId;
};

});

parcelRegister("5Q4f1", function(module, exports) {

$parcel$export(module.exports, "getAdminBaseUrl", () => $2c9346932f4dad13$export$76bb37a926058cca);

var $5euJh = parcelRequire("5euJh");
const $2c9346932f4dad13$export$76bb37a926058cca = ()=>`https://${(0, $5euJh.getATLContextDomain)('admin')}`;

});

parcelRegister("iHAwr", function(module, exports) {

$parcel$export(module.exports, "getProductKey", () => $a2785a755bdb8c08$export$d0b7f02493f85477);

const $a2785a755bdb8c08$export$d0b7f02493f85477 = (subProduct, explicitlyLicensedProducts)=>{
    if (subProduct === 'software') return 0, $c06e1abca7c13910$export$1346c9aa3cbb477d;
    if (subProduct === 'serviceDesk') return 0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61;
    // useSubProduct currently doesn't support polaris
    // JPD's subproduct currently falls under to 'software'
    // https://hello.atlassian.net/wiki/spaces/STAR/pages/2940457206/Detach+from+JSW+analytics+subproduct
    if (subProduct === 'polaris') return 0, $c06e1abca7c13910$export$202f50ee62667e32;
    if (subProduct === 'core') return 0, $c06e1abca7c13910$export$db515c8cec1e6f79;
    // If subProduct is null, we may be on a product-agnostic page e.g. "Your Work".
    // If there is only one licensed product, we can infer what the user is using.
    if (explicitlyLicensedProducts.length === 1) return explicitlyLicensedProducts[0];
    return null;
};

});



parcelRegister("liGrj", function(module, exports) {

$parcel$export(module.exports, "PremiumUpgradeModalEntryPointButton", () => $c0d01fc7cb7615a5$export$9901be7804227da7);

var $5uXOq = parcelRequire("5uXOq");

var $9yOBd = parcelRequire("9yOBd");

var $47gW9 = parcelRequire("47gW9");

var $ivDCs = parcelRequire("ivDCs");

var $4mO32 = parcelRequire("4mO32");

var $b3Gth = parcelRequire("b3Gth");
const $c0d01fc7cb7615a5$var$entryPointParams = {};
const $c0d01fc7cb7615a5$export$9901be7804227da7 = (buttonProps)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $b3Gth.entryPointPremiumUpgradeModal), $c0d01fc7cb7615a5$var$entryPointParams);
    const buttonTrigger = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
        ...buttonProps,
        ref: buttonTrigger
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivDCs.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jira-premium-upgrade-modal",
        packageName: "jiraPremiumUpgradeModal",
        errorFallback: "flag",
        runtimeProps: {
            onClose: entryPointActions.unload
        },
        entryPointActions: entryPointActions
    }));
};

});
parcelRegister("ivDCs", function(module, exports) {

$parcel$export(module.exports, "ModalEntryPointContainer", () => $832a9e21b9f9d7ff$export$4d67c6ee49f3d14d);

var $5uXOq = parcelRequire("5uXOq");

var $i8Qvm = parcelRequire("i8Qvm");

var $8Bm0k = parcelRequire("8Bm0k");

var $c5vfY = parcelRequire("c5vfY");
const $832a9e21b9f9d7ff$export$4d67c6ee49f3d14d = ({ entryPointActions: { unload: unload }, entryPointReferenceSubject: entryPointReferenceSubject, errorFallback: errorFallback, runtimeProps: runtimeProps, ...containerProps })=>{
    const entryPointReference = (0, $8Bm0k.useEntryPointSubscription)(entryPointReferenceSubject);
    const props = (0, $5uXOq.useMemo)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ({
            ...runtimeProps,
            onClose () {
                runtimeProps.onClose?.();
                unload();
            }
        }), [
        runtimeProps,
        unload
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, entryPointReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c5vfY.InternalEntryPointContainer), {
        ...containerProps,
        entryPointReference: entryPointReference,
        errorFallback: errorFallback || 'flag',
        placeholderName: "modal-entry-point-container",
        runtimeProps: props
    }));
};

});

parcelRegister("b3Gth", function(module, exports) {

$parcel$export(module.exports, "entryPointPremiumUpgradeModal", () => $a50fd4829307668f$export$7116d5b1a93db8d6);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $a50fd4829307668f$export$7116d5b1a93db8d6 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("3lj1i")).then((module)=>module.PremiumUpgradeModalEntryPoint), {
        moduleId: "1102b440",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3lj1i", function(module, exports) {

let $26f2163bd2555fbe$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $26f2163bd2555fbe$var$load("ffQaD"),
    $26f2163bd2555fbe$var$load("kvRbA"),
    $26f2163bd2555fbe$var$load("kNFvF"),
    $26f2163bd2555fbe$var$load("jU6DJ")
]).then(()=>parcelRequire('5s8iH'));

});



parcelRegister("iIz7a", function(module, exports) {

$parcel$export(module.exports, "FeatureGateLogo", () => $bde809f68e5981c8$export$83d4ce06fb8c3c0);

var $5uXOq = parcelRequire("5uXOq");

var $5qRwM = parcelRequire("5qRwM");

var $6DbpV = parcelRequire("6DbpV");

var $j1jFP = parcelRequire("j1jFP");
const $bde809f68e5981c8$export$83d4ce06fb8c3c0 = ({ colorMode: colorMode, alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
        src: colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($6DbpV))) : (0, (/*@__PURE__*/$parcel$interopDefault($j1jFP))),
        alt: alt
    });

});
parcelRegister("5qRwM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e92bcc4cb7160f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4NS88 = parcelRequire("4NS88");

var $hxoiH = parcelRequire("hxoiH");
const $b3e92bcc4cb7160f$var$baseImageStyles = null; /**
                               * __Image__
                               *
                               * This component can be used interchangeably with the native `img` element. It includes additional functionality, such as theme support.
                               *
                               * - [Examples](https://atlassian.design/components/image/examples)
                               * - [Code](https://atlassian.design/components/image/code)
                               * - [Usage](https://atlassian.design/components/image/usage)
                               */ 
function $b3e92bcc4cb7160f$export$2e2bcd8739ae039({ src: src, srcDark: srcDark, alt: alt, testId: testId, className: className, ...props }) {
    const imgRef = (0, $5uXOq.useRef)(null);
    const providedColorMode = (0, $4NS88.UNSAFE_useColorModeForMigration)();
    const { colorMode: observedColorMode } = (0, $hxoiH.default)();
    const colorMode = providedColorMode || observedColorMode;
    (0, $5uXOq.useEffect)(()=>{
        if (imgRef === null || imgRef.current === null) return;
        if (srcDark && colorMode === 'dark') imgRef.current.src = srcDark;
        else if (src) imgRef.current.src = src;
    }, [
        src,
        srcDark,
        colorMode
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
        alt: alt,
        "data-testid": testId,
        src: src,
        className: (0, $bwpsq.default)([
            "_p12f1osq _4t3i1wug",
            className
        ]),
        ref: imgRef,
        ...props
    });
}

});
parcelRegister("4NS88", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useColorModeForMigration", () => $c865b9b4a27ce99e$export$ce91654eb9fea460);
$parcel$export(module.exports, "default", () => $c865b9b4a27ce99e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $VSDnB = parcelRequire("VSDnB");

var $cSyk1 = parcelRequire("cSyk1");
var $9NXG8 = parcelRequire("9NXG8");
var $8Zdb4 = parcelRequire("8Zdb4");
const $c865b9b4a27ce99e$var$defaultThemeSettings = ()=>({
        dark: 'dark',
        light: 'light',
        spacing: 'spacing',
        typography: (0, $VSDnB.fg)('platform-default-typography-modernized') ? 'typography-modernized' : undefined
    });
const $c865b9b4a27ce99e$var$ColorModeContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $c865b9b4a27ce99e$var$SetColorModeContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $c865b9b4a27ce99e$var$ThemeContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $c865b9b4a27ce99e$var$SetThemeContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
function $c865b9b4a27ce99e$export$ce91654eb9fea460() {
    const value = (0, $5uXOq.useContext)($c865b9b4a27ce99e$var$ColorModeContext);
    return value;
}
function $c865b9b4a27ce99e$export$20f3076712c8dfa() {
    const value = (0, $5uXOq.useContext)($c865b9b4a27ce99e$var$ColorModeContext);
    if (!value) throw new Error('useColorMode must be used within AppProvider.');
    return value;
}
function $c865b9b4a27ce99e$export$e2afe7397c3d11c7() {
    const value = (0, $5uXOq.useContext)($c865b9b4a27ce99e$var$SetColorModeContext);
    if (!value) throw new Error('useSetColorMode must be used within AppProvider.');
    return value;
}
function $c865b9b4a27ce99e$export$93d4e7f90805808f() {
    const theme = (0, $5uXOq.useContext)($c865b9b4a27ce99e$var$ThemeContext);
    const [resolvedTheme, setResolvedTheme] = (0, $5uXOq.useState)(theme || (0, $cSyk1.default)());
    (0, $5uXOq.useEffect)(()=>{
        // We are using theme from context so no need to reference the DOM
        if (theme) return;
        const observer = new (0, $8Zdb4.default)(setResolvedTheme);
        observer.observe();
        return ()=>observer.disconnect();
    }, [
        theme
    ]);
    return resolvedTheme;
}
function $c865b9b4a27ce99e$export$501aa0dcd5527a48() {
    const value = (0, $5uXOq.useContext)($c865b9b4a27ce99e$var$SetThemeContext);
    if (!value) throw new Error('useSetTheme must be used within AppProvider.');
    return value;
}
const $c865b9b4a27ce99e$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
const $c865b9b4a27ce99e$var$prefersDarkModeMql = $c865b9b4a27ce99e$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $c865b9b4a27ce99e$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $c865b9b4a27ce99e$var$prefersDarkModeMql?.matches ? 'dark' : 'light';
    return colorMode;
}
/**
 * __Theme provider__
 *
 * Provides global theming configuration.
 *
 * @internal
 */ function $c865b9b4a27ce99e$var$ThemeProvider({ children: children, defaultColorMode: defaultColorMode, defaultTheme: defaultTheme }) {
    const [chosenColorMode, setChosenColorMode] = (0, $5uXOq.useState)(defaultColorMode);
    const [reconciledColorMode, setReconciledColorMode] = (0, $5uXOq.useState)($c865b9b4a27ce99e$var$getReconciledColorMode(defaultColorMode));
    const [theme, setTheme] = (0, $5uXOq.useState)(()=>({
            ...$c865b9b4a27ce99e$var$defaultThemeSettings(),
            ...defaultTheme
        }));
    const setColorMode = (0, $5uXOq.useCallback)((colorMode)=>{
        setChosenColorMode(colorMode);
        setReconciledColorMode($c865b9b4a27ce99e$var$getReconciledColorMode(colorMode));
    }, []);
    const setPartialTheme = (0, $5uXOq.useCallback)((nextTheme)=>{
        setTheme((theme)=>({
                ...theme,
                ...nextTheme
            }));
    }, []);
    const lastSetGlobalThemePromiseRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        /**
     * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
     * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
     * `data-color-mode` attribute on the root element).
     *
     * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
     * applying the new theme.
     *
     * Without this, we can end up in the following scenario:
     * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
     * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
     * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
     * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
     */ const cleanupLastFnCall = async ()=>{
            if (lastSetGlobalThemePromiseRef.current) {
                const unbindFn = await lastSetGlobalThemePromiseRef.current;
                unbindFn();
                lastSetGlobalThemePromiseRef.current = null;
            }
        };
        const safelySetGlobalTheme = async ()=>{
            await cleanupLastFnCall();
            const promise = (0, $9NXG8.default)({
                ...theme,
                colorMode: reconciledColorMode
            });
            lastSetGlobalThemePromiseRef.current = promise;
        };
        safelySetGlobalTheme();
        return function cleanup() {
            cleanupLastFnCall();
        };
    }, [
        theme,
        reconciledColorMode
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!$c865b9b4a27ce99e$var$prefersDarkModeMql) return;
        const unbindListener = (0, $cBeZP.bind)($c865b9b4a27ce99e$var$prefersDarkModeMql, {
            type: 'change',
            listener: (event)=>{
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($c865b9b4a27ce99e$var$ColorModeContext.Provider, {
        value: reconciledColorMode,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($c865b9b4a27ce99e$var$SetColorModeContext.Provider, {
            value: setColorMode,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($c865b9b4a27ce99e$var$ThemeContext.Provider, {
                value: theme,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($c865b9b4a27ce99e$var$SetThemeContext.Provider, {
                    value: setPartialTheme,
                    children: children
                })
            })
        })
    });
}
var $c865b9b4a27ce99e$export$2e2bcd8739ae039 = $c865b9b4a27ce99e$var$ThemeProvider;

});


parcelRegister("6DbpV", function(module, exports) {
module.exports = new URL("plans-standard-dark.fce82c99.svg", import.meta.url).toString();

});

parcelRegister("j1jFP", function(module, exports) {
module.exports = new URL("plans-standard-light.fde35b0d.svg", import.meta.url).toString();

});


parcelRegister("gblI8", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ba9ec5dc8deac7d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9ba9ec5dc8deac7d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "atlassian-navigation.plans.menu.premium-feature-gate.title",
        "defaultMessage": "Unlock advanced planning tools"
    },
    imageAlt: {
        "id": "atlassian-navigation.plans.menu.premium-feature-gate.image-alt",
        "defaultMessage": "Upgrade to Jira Premium"
    },
    description: {
        "id": "atlassian-navigation.plans.menu.premium-feature-gate.description",
        "defaultMessage": "Boost agility with capacity planning, dependency mapping, and more. Try Jira Premium's high-level cross-team planning tools."
    },
    learnMoreLink: {
        "id": "atlassian-navigation.plans.menu.premium-feature-gate.learn-more-link",
        "defaultMessage": "Read the guide"
    },
    startTrialButton: {
        "id": "atlassian-navigation.plans.menu.premium-feature-gate.start-trial-button",
        "defaultMessage": "Try it free"
    }
});

});


parcelRegister("fzr0K", function(module, exports) {

$parcel$export(module.exports, "planUpsellEntryPoint", () => $8cc471b800a3023f$export$2fc05036b41321cf);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $8cc471b800a3023f$export$2fc05036b41321cf = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("43JCQ")), {
        moduleId: "8a4ffc36",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("43JCQ", function(module, exports) {

let $2f4ad580eaaea925$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $2f4ad580eaaea925$var$load("fliVL"),
    $2f4ad580eaaea925$var$load("fGcMP")
]).then(()=>parcelRequire('gUsws'));

});


parcelRegister("eCT4E", function(module, exports) {

$parcel$export(module.exports, "planUpsellRoute", () => $e26c6899078b71eb$export$bda76e09a8dec9a0);
const $e26c6899078b71eb$export$bda76e09a8dec9a0 = {
    name: 'software-plan-upsell',
    path: '/jira/plans/getting-started'
};

});




parcelRegister("3nmOf", function(module, exports) {

$parcel$export(module.exports, "Nav4Projects", () => $f8e01865477e7c50$export$5baf9fa0c4742f3f);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lwsjn = parcelRequire("lwsjn");

var $l8ruj = parcelRequire("l8ruj");

const $f8e01865477e7c50$export$5baf9fa0c4742f3f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4-sidebar-projects"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "flag",
        id: "projects-section",
        packageName: (0, $4e61701b07fca41a$export$b8b9d90f9e5bd72b),
        teamName: (0, $4e61701b07fca41a$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lwsjn.Nav4Projects), props)));

});
parcelRegister("lwsjn", function(module, exports) {

$parcel$export(module.exports, "Nav4Projects", () => $68918da9ad272fce$export$5baf9fa0c4742f3f);

var $1634p = parcelRequire("1634p");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jhS4y = parcelRequire("jhS4y");

var $c6x3L = parcelRequire("c6x3L");

var $fzcoo = parcelRequire("fzcoo");

var $QXHTz = parcelRequire("QXHTz");

var $8syLG = parcelRequire("8syLG");

var $a9bTe = parcelRequire("a9bTe");
function $68918da9ad272fce$export$5baf9fa0c4742f3f({ isExpanded: isExpanded, queryRef: queryRef }) {
    const data = (0, $8Uumt.useFragment)((0, $1634p.default), queryRef);
    const { isInitialSelectedPath: isInitialSelectedPath } = (0, $c6x3L.useSidebarNav4)();
    const canCreateProject = !!data?.jira?.canCreateProject;
    const actionButtons = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fzcoo.ActionButtons), {
        canCreateProject: canCreateProject
    });
    (0, $a9bTe.useCreateProjectCheckPermissions)();
    if (!data.jira?.hasIsProjectsExpanded && isInitialSelectedPath((0, $jhS4y.MENU_ID_PROJECTS))) // We need to make sure that we're only passing the conditionalal fragment when it is actually
    // available. Due to a lack of support the @alias Relay directive, we need to use another mechanism
    // and in this case we're using a hardcoded __typename to check if the fragment is available.
    // This is a workaround until we can use the @alias directive in Relay. If the hasIsProjectsExpanded
    // attribute is not available, then the fragment won't be either and we shouldn't pass it.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $QXHTz.Nav4ProjectsDefault), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded
    });
    return isInitialSelectedPath((0, $jhS4y.MENU_ID_PROJECTS)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8syLG.Nav4ProjectsForLanding), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded,
        queryRef: data
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $QXHTz.Nav4ProjectsDefault), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded
    });
}

});
parcelRegister("1634p", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf369e5549cfa857$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7b094659bc2a93eca72fcc05bcdf459c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $cf369e5549cfa857$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "kind": "RootArgument",
            "name": "isProjectsExpanded"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4Projects",
    "selections": [
        {
            "condition": "isProjectsExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4ProjectsForLanding"
                }
            ]
        },
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "condition": "isProjectsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "hasIsProjectsExpanded",
                            "kind": "ScalarField",
                            "name": "__typename"
                        }
                    ]
                },
                {
                    "alias": "canCreateProject",
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "CREATE_PROJECT"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "canPerform"
                }
            ]
        }
    ],
    "type": "Query"
};
$cf369e5549cfa857$var$node.hash = "a555601eac0ae7ffe20da1e2ae68ce09";
var $cf369e5549cfa857$export$2e2bcd8739ae039 = $cf369e5549cfa857$var$node;

});

parcelRegister("fzcoo", function(module, exports) {

$parcel$export(module.exports, "ActionButtons", () => $47193506b60deede$export$88c65d2d98aab183);

var $5uXOq = parcelRequire("5uXOq");

var $epOG5 = parcelRequire("epOG5");

var $dZbEw = parcelRequire("dZbEw");

var $3Z96c = parcelRequire("3Z96c");
var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $3bDjY = parcelRequire("3bDjY");

var $Mp6qH = parcelRequire("Mp6qH");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $4OlXf = parcelRequire("4OlXf");

var $6ckjW = parcelRequire("6ckjW");

var $80ha2 = parcelRequire("80ha2");

var $fNJRN = parcelRequire("fNJRN");

var $hUpXm = parcelRequire("hUpXm");

var $eDLAW = parcelRequire("eDLAW");


var $46Cti = parcelRequire("46Cti");

var $1xonH = parcelRequire("1xonH");

var $9eeFp = parcelRequire("9eeFp");

var $eaKdt = parcelRequire("eaKdt");

var $aCS3f = parcelRequire("aCS3f");

var $e9QkH = parcelRequire("e9QkH");

var $4R6GH = parcelRequire("4R6GH");

var $7uwUx = parcelRequire("7uwUx");
function $47193506b60deede$export$88c65d2d98aab183({ onClose: onClose, canCreateProject: canCreateProject }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [, { on: openProjectCreateDrawer }] = (0, $e9QkH.useSwitchModals)((0, $Mp6qH.MODAL_ID).PROJECT_CREATE);
    const { sendMeatBallDropDownAnalyticsEvent: sendMeatBallDropDownAnalyticsEvent, sendCreateProjectAnalyticsEvent: sendCreateProjectAnalyticsEvent } = (0, $fNJRN.useProjectsAnalyticsL1)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        openProjectCreateDrawer();
        sendCreateProjectAnalyticsEvent();
    }, [
        openProjectCreateDrawer,
        sendCreateProjectAnalyticsEvent
    ]);
    const onOpen = (0, $5uXOq.useCallback)(()=>{
        sendMeatBallDropDownAnalyticsEvent();
    }, [
        sendMeatBallDropDownAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, canCreateProject ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $7uwUx.default).createProject)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1xonH.CommonNavMenuButton), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage((0, $7uwUx.default).createProject),
        onClick: (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? onClick : ()=>{
            openProjectCreateDrawer();
            sendCreateProjectAnalyticsEvent();
        }
    })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCS3f.MoreNavMenuButton), {
        ...(0, $4R6GH.fg)('jsm_aiiy_for_nav_item_sidebar') ? {
            name: formatMessage((0, $7uwUx.default).projects)
        } : {},
        onOpen: (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? onOpen : ()=>{
            sendMeatBallDropDownAnalyticsEvent();
        },
        MenuItems: $47193506b60deede$var$MoreMenuItems,
        onClose: onClose
    }));
}
function $47193506b60deede$var$MoreMenuItems({ onClose: onClose }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const href = (0, $5uXOq.useMemo)(()=>(0, $4OlXf.getProjectsNavigationPaths)().projectsViewProjects, []);
    const { sendMeatBallDropDownManageProjectsAnalyticsEvent: sendMeatBallDropDownManageProjectsAnalyticsEvent, sendChangeViewAnalyticsEvent: sendChangeViewAnalyticsEvent } = (0, $hUpXm.useProjectsAnalyticsL2)();
    const { sendChangeViewViewOptionAnalyticsEvent: sendChangeViewViewOptionAnalyticsEvent } = (0, $eDLAW.useProjectsAnalyticsL3)();
    const onCloseWithStopPropagation = (0, $9eeFp.useStopPropagation)((e)=>{
        sendMeatBallDropDownManageProjectsAnalyticsEvent();
        onClose?.(e);
    });
    const onChangeViewOptionChange = (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useCallback)((viewOptionValue)=>{
        const getItemId = ()=>{
            switch(viewOptionValue){
                case (0, $80ha2.ViewOptions).STARRED:
                    return 0, $496585bee7985bb9$export$ed36b1ade72db400;
                case (0, $80ha2.ViewOptions).STARRED_AND_RECENT:
                    return 0, $496585bee7985bb9$export$98d08638c2a90c44;
                case (0, $80ha2.ViewOptions).MOST_RECENT_ONLY:
                    return 0, $496585bee7985bb9$export$f8a73cc0211412ca;
                default:
                    return 0, $496585bee7985bb9$export$98d08638c2a90c44;
            }
        };
        sendChangeViewViewOptionAnalyticsEvent({
            itemId: getItemId()
        });
    }, [
        sendChangeViewViewOptionAnalyticsEvent
    ]) : (viewOptionValue)=>{
        const getItemId = ()=>{
            switch(viewOptionValue){
                case (0, $80ha2.ViewOptions).STARRED:
                    return 0, $496585bee7985bb9$export$ed36b1ade72db400;
                case (0, $80ha2.ViewOptions).STARRED_AND_RECENT:
                    return 0, $496585bee7985bb9$export$98d08638c2a90c44;
                case (0, $80ha2.ViewOptions).MOST_RECENT_ONLY:
                    return 0, $496585bee7985bb9$export$f8a73cc0211412ca;
                default:
                    return 0, $496585bee7985bb9$export$98d08638c2a90c44;
            }
        };
        sendChangeViewViewOptionAnalyticsEvent({
            itemId: getItemId()
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        isList: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Z96c.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($epOG5))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        }),
        href: href,
        onClick: onCloseWithStopPropagation
    }, formatMessage((0, $7uwUx.default).manageProjects))), (0, $6s1PB.expVal)('blu-6315-display-settings-a-part-1', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        hasSeparator: true,
        isList: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6ckjW.ChangeViewMenuItem), {
        onOpen: sendChangeViewAnalyticsEvent,
        onChange: onChangeViewOptionChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaKdt.HideL1MenuItemSection), {
        hasSeparator: false,
        menuId: (0, $46Cti.L1_MENU_ID).PROJECTS,
        hasSection: false
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaKdt.HideL1MenuItemSection), {
        menuId: (0, $46Cti.L1_MENU_ID).PROJECTS,
        hasSection: true
    }));
}

});
parcelRegister("4OlXf", function(module, exports) {

$parcel$export(module.exports, "getProjectsNavigationPaths", () => $318f62ba2cbc5bcb$export$5b37488a9fd89879);
const $318f62ba2cbc5bcb$export$5b37488a9fd89879 = ()=>({
        projectsViewProjects: '/jira/settings/projects/manage',
        projectsViewCategories: '/secure/admin/projectcategories/ViewProjectCategories!default.jspa',
        projectsTrashedProjects: '/jira/settings/projects/trash',
        projectsArchivedProjects: '/jira/settings/projects/archive'
    });

});

parcelRegister("6ckjW", function(module, exports) {

$parcel$export(module.exports, "ChangeViewMenuItem", () => $131fc53490d82838$export$3bc1c3c28804a19b);

var $5uXOq = parcelRequire("5uXOq");

var $bpC55 = parcelRequire("bpC55");

var $bEjt9 = parcelRequire("bEjt9");

var $kJpBP = parcelRequire("kJpBP");

var $7mPT9 = parcelRequire("7mPT9");

var $koVbs = parcelRequire("koVbs");

var $jgJNO = parcelRequire("jgJNO");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $47gW9 = parcelRequire("47gW9");

var $kytLE = parcelRequire("kytLE");

var $koeKL = parcelRequire("koeKL");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $h0Kon = parcelRequire("h0Kon");

var $eDBFR = parcelRequire("eDBFR");

var $h2mzI = parcelRequire("h2mzI");

var $8vLvT = parcelRequire("8vLvT");
const $131fc53490d82838$export$3bc1c3c28804a19b = (0, $7XYc4.componentWithCondition)(()=>(0, $6s1PB.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false), $131fc53490d82838$var$ChangeViewMenuItemNew, $131fc53490d82838$var$ChangeViewMenuItemOld);
function $131fc53490d82838$var$ChangeViewMenuItemOld({ onOpen: onOpen, onChange: onChange }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const onChangeViewMenuItemClick = ()=>{
        if (!isOpen && onOpen) onOpen();
        setIsOpen(!isOpen);
    };
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $h2mzI.ViewOptionsMenuPopupContentEntrypoint), {
        scope: (0, $kytLE.DisplaySettingsScope).PROJECTS,
        onChange: onChange
    });
    const entrypointRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "display-settings-menu-popup-content",
                packageName: "jira-navigation-apps-sidebar-nav4-display-settings",
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h0Kon.Skeleton), null),
                runtimeProps: {}
            }),
        placement: "right-start",
        messageId: "navigation-apps-sidebar-nav4-display-settings.ui.change-view-menu-item.popup",
        messageType: "transactional",
        shouldRenderToParent: true,
        trigger: ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
                ...triggerProps,
                ref: (0, $7mPT9.default)(ref, entrypointRef),
                isSelected: isOpen,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bEjt9))), {
                    label: formatMessage((0, $eDBFR.default).listBulletedIcon),
                    spacing: "spacious",
                    color: "var(--ds-icon, #44546F)"
                }),
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bpC55))), {
                    label: formatMessage((0, $eDBFR.default).chevronRightIcon),
                    size: "small"
                }),
                onClick: onChangeViewMenuItemClick,
                "aria-label": formatMessage((0, $eDBFR.default).changeViewMenuItemLabel),
                "aria-expanded": isOpen,
                "aria-haspopup": "true"
            }, formatMessage((0, $eDBFR.default).changeViewMenuItemLabel))
    });
}
function $131fc53490d82838$var$ChangeViewMenuItemNew({ onOpen: onOpen, onChange: onChange }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const cloudId = (0, $koeKL.useCloudId)();
    const onChangeViewMenuItemClick = ()=>{
        if (!isOpen && onOpen) onOpen();
        setIsOpen(!isOpen);
    };
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $8vLvT.ProjectsViewOptionsEntrypoint), {
        cloudId: cloudId,
        onChange: onChange
    });
    const entrypointRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "display-settings-menu-popup-content",
                packageName: "jira-navigation-apps-sidebar-nav4-display-settings",
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h0Kon.Skeleton), null),
                runtimeProps: {},
                errorFallback: "flag"
            }),
        placement: "right-start",
        // Duplicate messageId due to experiment conditional component
        // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
        messageId: "navigation-apps-sidebar-nav4-display-settings.ui.change-view-menu-item.popup",
        messageType: "transactional",
        shouldRenderToParent: true,
        trigger: ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
                ...triggerProps,
                ref: (0, $7mPT9.default)(ref, entrypointRef),
                isSelected: isOpen,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bEjt9))), {
                    label: formatMessage((0, $eDBFR.default).listBulletedIcon),
                    spacing: "spacious",
                    color: "var(--ds-icon, #44546F)"
                }),
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bpC55))), {
                    label: formatMessage((0, $eDBFR.default).chevronRightIcon),
                    size: "small"
                }),
                onClick: onChangeViewMenuItemClick,
                "aria-label": formatMessage((0, $eDBFR.default).changeViewMenuItemLabel),
                "aria-expanded": isOpen,
                "aria-haspopup": "true",
                testId: "navigation-apps-sidebar-nav4-display-settings.ui.change-view-menu-item.button"
            }, formatMessage((0, $eDBFR.default).changeViewMenuItemLabel))
    });
}

});
parcelRegister("kytLE", function(module, exports) {

$parcel$export(module.exports, "DisplaySettingsScope", () => $63cf99b9cfa7c103$export$5df97773a9667af8);
$parcel$export(module.exports, "DisplaySettingsPropertyKeys", () => $63cf99b9cfa7c103$export$5d9ca2391194d3c8);
$parcel$export(module.exports, "DisplaySettingsAllowedValuesMap", () => $63cf99b9cfa7c103$export$3938c8b7d6f592c);

var $80ha2 = parcelRequire("80ha2");
const $63cf99b9cfa7c103$var$PROJECTS = 'projects';
const $63cf99b9cfa7c103$export$5df97773a9667af8 = {
    PROJECTS: $63cf99b9cfa7c103$var$PROJECTS
};
const $63cf99b9cfa7c103$var$VIEW_OPTION = 'VIEW_OPTION';
const $63cf99b9cfa7c103$export$5d9ca2391194d3c8 = {
    VIEW_OPTION: $63cf99b9cfa7c103$var$VIEW_OPTION
};
const $63cf99b9cfa7c103$export$3938c8b7d6f592c = {
    [$63cf99b9cfa7c103$export$5d9ca2391194d3c8.VIEW_OPTION]: Object.values((0, $80ha2.ViewOptions))
};

});
parcelRegister("80ha2", function(module, exports) {

$parcel$export(module.exports, "ViewOptions", () => $8b62df6457429612$export$8cd3967b7c246658);
$parcel$export(module.exports, "DefaultViewOption", () => $8b62df6457429612$export$8df870734bca67fa);
const $8b62df6457429612$var$STARRED_AND_RECENT = 'STARRED_AND_RECENT';
const $8b62df6457429612$var$STARRED = 'STARRED';
const $8b62df6457429612$var$MOST_RECENT_ONLY = 'MOST_RECENT_ONLY';
const $8b62df6457429612$export$8cd3967b7c246658 = {
    STARRED_AND_RECENT: $8b62df6457429612$var$STARRED_AND_RECENT,
    STARRED: $8b62df6457429612$var$STARRED,
    MOST_RECENT_ONLY: $8b62df6457429612$var$MOST_RECENT_ONLY
};
const $8b62df6457429612$export$8df870734bca67fa = $8b62df6457429612$export$8cd3967b7c246658.STARRED_AND_RECENT;

});


parcelRegister("h0Kon", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $87dff8971b16ac84$export$8f31e4c4a37b8e9c);

var $5uXOq = parcelRequire("5uXOq");

var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");
var $iwwXK = parcelRequire("iwwXK");

var $4DrQd = parcelRequire("4DrQd");

var $6s1PB = parcelRequire("6s1PB");
const $87dff8971b16ac84$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), {
        minWidth: (0, $4DrQd.MENU_GROUP_MIN_WIDTH)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        isList: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), null), (0, $6s1PB.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), null)));

});

parcelRegister("eDBFR", function(module, exports) {

$parcel$export(module.exports, "default", () => $153017ee62a4e587$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $153017ee62a4e587$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    changeViewMenuItemLabel: {
        "id": "navigation-apps-sidebar-nav4-display-settings.change-view-action.change-view-menu-item-label",
        "defaultMessage": "Change view"
    },
    starredAndRecentProjectsLabel: {
        "id": "navigation-apps-sidebar-nav4-display-settings.change-view-action.starred-and-recent-projects-label",
        "defaultMessage": "Starred and recent projects"
    },
    starredProjectsLabel: {
        "id": "navigation-apps-sidebar-nav4-display-settings.change-view-action.starred-projects-label",
        "defaultMessage": "Starred projects only"
    },
    mostRecentOnlyLabel: {
        "id": "navigation-apps-sidebar-nav4-display-settings.change-view-action.most-recent-only-label",
        "defaultMessage": "Most recent project only"
    },
    listBulletedIcon: {
        "id": "navigation-apps-sidebar-nav4-display-settings.change-view-action.list-bulleted-icon",
        "defaultMessage": "List bulleted icon"
    },
    chevronRightIcon: {
        "id": "navigation-apps-sidebar-nav4-display-settings.change-view-action.chevron-right-icon",
        "defaultMessage": "Chevron right icon"
    }
});

});

parcelRegister("h2mzI", function(module, exports) {

$parcel$export(module.exports, "ViewOptionsMenuPopupContentEntrypoint", () => $cdd618e0ad32331d$export$ebd1be9f4df3fdb7);

var $fEDBv = parcelRequire("fEDBv");

var $eufEc = parcelRequire("eufEc");

const $cdd618e0ad32331d$export$ebd1be9f4df3fdb7 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("6lmNZ")).then(({ ViewOptionsWithDisplaySettings: ViewOptionsWithDisplaySettings })=>ViewOptionsWithDisplaySettings), {
        moduleId: "846bfedf",
        priority: "interaction"
    }),
    getPreloadProps: (extraProps)=>({
            queries: {},
            extraProps: extraProps
        })
});

});
parcelRegister("6lmNZ", function(module, exports) {

let $49e664eb30666f53$var$load = (parcelRequire("28QjX"))(4);
module.exports = $49e664eb30666f53$var$load("ftRLE").then(()=>parcelRequire('8wK7s'));

});


parcelRegister("8vLvT", function(module, exports) {

$parcel$export(module.exports, "ProjectsViewOptionsEntrypoint", () => $1a2621f1381c8965$export$cd53b98c3c72dc78);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $azPPd = parcelRequire("azPPd");

const $1a2621f1381c8965$export$cd53b98c3c72dc78 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("eTdqd")).then(({ ProjectsViewOptions: ProjectsViewOptions })=>ProjectsViewOptions), {
        moduleId: "bd6faa13",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, onChange: onChange })=>({
            queries: {
                projectsViewOptions: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $azPPd.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            },
            extraProps: {
                onChange: onChange
            }
        })
});

});
parcelRegister("azPPd", function(module, exports) {

$parcel$export(module.exports, "default", () => $e71402a50e901502$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4a7eabd336a54085b12e6024b67b0182>>
 * @relayHash 367268a979a58b37662cf273a88851ee
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dd468ae0c857364119a123f5e1f38c418844966a4acd4018dddf66eb56286f0b
const $e71402a50e901502$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "displayMode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "projectsViewOptionsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_projectsSidebarMenu",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "projectsViewOptionsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_projectsSidebarMenu",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "dd468ae0c857364119a123f5e1f38c418844966a4acd4018dddf66eb56286f0b",
            "metadata": {},
            "name": "projectsViewOptionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e71402a50e901502$var$node.hash = "fc0b49221c780edfae3aba8b40f0e778";
var $e71402a50e901502$export$2e2bcd8739ae039 = $e71402a50e901502$var$node;

});

parcelRegister("eTdqd", function(module, exports) {

let $ad709d05cdaae7f6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ad709d05cdaae7f6$var$load("8oObc").then(()=>parcelRequire('kwqIJ'));

});



parcelRegister("fNJRN", function(module, exports) {

$parcel$export(module.exports, "useProjectsAnalyticsL1", () => $4b3d1af28d24ea21$export$7d9a1a79b1bd1338);

var $5uXOq = parcelRequire("5uXOq");







var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $aTtGi = parcelRequire("aTtGi");
const $4b3d1af28d24ea21$export$7d9a1a79b1bd1338 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const commonAttributes = (0, $5uXOq.useMemo)(()=>({
            level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
            navigationLayer: (0, $ce9c0831aed9ffb3$export$17ff3f7e02c6ac22)
        }), []);
    // fixed item - view all projects link
    const sendViewAllProjectsAnalyticsEvent = (0, $5uXOq.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
            itemId: (0, $496585bee7985bb9$export$2de7e56f66635690)
        };
        (0, $8zOmE.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // fixed item - more projects flyout trigger
    const sendMoreProjectsAnalyticsEvent = (0, $5uXOq.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
            parentItemId: (0, $496585bee7985bb9$export$44d67b522cbcce6d),
            itemId: (0, $496585bee7985bb9$export$3e2efdbdb3eed97e)
        };
        (0, $8zOmE.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // fixed item - meatball icon button on projects menu (top level)
    const sendMeatBallDropDownAnalyticsEvent = (0, $5uXOq.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$b887e88d8d0739f6)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
            itemId: (0, $496585bee7985bb9$export$f06dfcec5ff912e)
        };
        (0, $8zOmE.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // fixed item - create project (+) button on projects menu (top level)
    const sendCreateProjectAnalyticsEvent = (0, $5uXOq.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$b887e88d8d0739f6)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
            itemId: 'createProject'
        };
        (0, $8zOmE.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // custom item - project menu item that displays project name (can be expandable menu or a link)
    const sendProjectMenuItemAnalyticsEvent = (0, $5uXOq.useCallback)(({ starred: starred, recent: recent, projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$3ac911b122986477),
            itemType: (0, $632bd8725b437a12$export$fe791c4fa892e400),
            itemId: projectId,
            projectType: projectType,
            section: (0, $aTtGi.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $8zOmE.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    const sendProjectMenuContentAnalyticsEvent = (0, $5uXOq.useCallback)(()=>{
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$3ac911b122986477),
            itemId: 'projectsNavigationMenuItemContent'
        };
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'projectsNavigationMenuItemContent rendered', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    return {
        sendViewAllProjectsAnalyticsEvent: sendViewAllProjectsAnalyticsEvent,
        sendMoreProjectsAnalyticsEvent: sendMoreProjectsAnalyticsEvent,
        sendMeatBallDropDownAnalyticsEvent: sendMeatBallDropDownAnalyticsEvent,
        sendCreateProjectAnalyticsEvent: sendCreateProjectAnalyticsEvent,
        sendProjectMenuItemAnalyticsEvent: sendProjectMenuItemAnalyticsEvent,
        sendProjectMenuContentAnalyticsEvent: sendProjectMenuContentAnalyticsEvent
    };
};

});
parcelRegister("aTtGi", function(module, exports) {

$parcel$export(module.exports, "getSectionByStarredOrRecent", () => $085f7c8df53a9d4d$export$542854f16c0127e7);

var $jecJ3 = parcelRequire("jecJ3");
const $085f7c8df53a9d4d$export$542854f16c0127e7 = ({ starred: starred, recent: recent })=>{
    if (starred) return 0, $jecJ3.SECTION_ITEM_STARRED;
    if (recent) return 0, $jecJ3.SECTION_ITEM_RECENT;
    return '';
};

});


parcelRegister("hUpXm", function(module, exports) {

$parcel$export(module.exports, "useProjectsAnalyticsL2", () => $d51064a0c3301a50$export$1e04fadc2cea284c);

var $5uXOq = parcelRequire("5uXOq");







var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $aTtGi = parcelRequire("aTtGi");
const $d51064a0c3301a50$export$1e04fadc2cea284c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const commonAttributes = (0, $5uXOq.useMemo)(()=>({
            level: (0, $951a0ed422513987$export$fe3b012b0224e4e1)
        }), []);
    const sendMeatBallDropDownManageProjectsAnalyticsEvent = (0, $5uXOq.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$64fed82162bd367)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$17bca95234dea43b),
            itemId: 'manageProjects',
            parentItemId: (0, $496585bee7985bb9$export$f06dfcec5ff912e)
        };
        (0, $8zOmE.fireUIAnalytics)(event, (0, $d59b407ab907bf7b$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // board navigation item under each project when project is expandable menu
    const sendBoardNavigationItemInsideProjectsAnalyticsEvent = (0, $5uXOq.useCallback)(({ boardId: boardId, projectId: projectId, recent: recent, starred: starred, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$3ac911b122986477),
            itemId: boardId,
            itemType: (0, $632bd8725b437a12$export$9b8283d5878d2491),
            parentItemId: projectId,
            parentItemType: (0, $632bd8725b437a12$export$fe791c4fa892e400),
            projectType: projectType,
            section: (0, $aTtGi.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $8zOmE.fireUIAnalytics)(event, (0, $d59b407ab907bf7b$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // meatball menu on projects
    const getMeatBallDropDownOnProjectsAnalytics = (0, $5uXOq.useCallback)(({ recent: recent, starred: starred, projectId: projectId, projectType: projectType })=>{
        return {
            ...commonAttributes,
            actionSubjectId: (0, $d59b407ab907bf7b$export$8d155d2412839524),
            componentType: (0, $1e554a683893bd46$export$9bd6c21d500ae611),
            itemId: (0, $496585bee7985bb9$export$f06dfcec5ff912e),
            parentItemId: projectId,
            parentItemType: (0, $632bd8725b437a12$export$fe791c4fa892e400),
            projectType: projectType,
            section: (0, $aTtGi.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
    }, [
        commonAttributes
    ]);
    /** @deprecated, replace with getMeatBallDropDownOnProjectsAnalytics  */ const sendMeatBallDropDownOnProjectsAnalyticsEvent = (0, $5uXOq.useCallback)((params)=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$b887e88d8d0739f6)
        });
        const { actionSubjectId: actionSubjectId, ...attributes } = getMeatBallDropDownOnProjectsAnalytics(params);
        (0, $8zOmE.fireUIAnalytics)(event, actionSubjectId, attributes);
    }, [
        createAnalyticsEvent,
        getMeatBallDropDownOnProjectsAnalytics
    ]);
    // create board button
    const sendCreateBoardOnBoardMenuItemAnalyticsEvent = (0, $5uXOq.useCallback)(({ recent: recent, starred: starred, projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$b887e88d8d0739f6)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$9bd6c21d500ae611),
            itemId: 'createBoard',
            parentItemId: projectId,
            parentItemType: (0, $632bd8725b437a12$export$fe791c4fa892e400),
            projectType: projectType,
            section: (0, $aTtGi.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $8zOmE.fireUIAnalytics)(event, (0, $d59b407ab907bf7b$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // fixed item - view all boards link
    const sendViewAllBoardsAnalyticsEvent = (0, $5uXOq.useCallback)(({ projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
            itemId: 'viewAllBoards',
            parentItemId: projectId,
            parentItemType: (0, $632bd8725b437a12$export$fe791c4fa892e400),
            projectType: projectType
        };
        (0, $8zOmE.fireUIAnalytics)(event, (0, $d59b407ab907bf7b$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // fixed item - Change View in Meatball Menu on Projects section
    const sendChangeViewAnalyticsEvent = (0, $5uXOq.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$64fed82162bd367)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$17bca95234dea43b),
            parentItemId: (0, $496585bee7985bb9$export$44d67b522cbcce6d),
            itemId: (0, $632bd8725b437a12$export$119dad133da0b4a)
        };
        (0, $8zOmE.fireUIAnalytics)(event, (0, $d59b407ab907bf7b$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // fixed item - View All Projects in More Projects flyout
    const sendViewAllProjectsAnalyticsEvent = (0, $5uXOq.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$17bca95234dea43b),
            parentItemId: (0, $496585bee7985bb9$export$3e2efdbdb3eed97e),
            itemId: (0, $496585bee7985bb9$export$2de7e56f66635690)
        };
        (0, $8zOmE.fireUIAnalytics)(event, (0, $d59b407ab907bf7b$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // custom item - project in More Projects flyout
    const sendMoreProjectsFlyoutProjectAnalyticsEvent = (0, $5uXOq.useCallback)(({ projectId: projectId })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$3ac911b122986477),
            parentItemId: (0, $496585bee7985bb9$export$3e2efdbdb3eed97e),
            itemType: (0, $632bd8725b437a12$export$fe791c4fa892e400),
            itemId: projectId
        };
        (0, $8zOmE.fireUIAnalytics)(event, (0, $d59b407ab907bf7b$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    return {
        sendMeatBallDropDownManageProjectsAnalyticsEvent: sendMeatBallDropDownManageProjectsAnalyticsEvent,
        sendMeatBallDropDownOnProjectsAnalyticsEvent: sendMeatBallDropDownOnProjectsAnalyticsEvent,
        sendBoardNavigationItemInsideProjectsAnalyticsEvent: sendBoardNavigationItemInsideProjectsAnalyticsEvent,
        sendCreateBoardOnBoardMenuItemAnalyticsEvent: sendCreateBoardOnBoardMenuItemAnalyticsEvent,
        sendViewAllBoardsAnalyticsEvent: sendViewAllBoardsAnalyticsEvent,
        sendChangeViewAnalyticsEvent: sendChangeViewAnalyticsEvent,
        sendViewAllProjectsAnalyticsEvent: sendViewAllProjectsAnalyticsEvent,
        sendMoreProjectsFlyoutProjectAnalyticsEvent: sendMoreProjectsFlyoutProjectAnalyticsEvent
    };
};

});
const $d59b407ab907bf7b$export$8d155d2412839524 = 'projectsNavigationMenuItem';
const $d59b407ab907bf7b$export$13171e509c859bbf = 'projectSettingsNavigationMenuItem';


parcelRegister("eDLAW", function(module, exports) {

$parcel$export(module.exports, "useProjectsAnalyticsL3", () => $304a05e3ff22f010$export$619b8904be99ed7c);

var $5uXOq = parcelRequire("5uXOq");






var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $aTtGi = parcelRequire("aTtGi");

const $304a05e3ff22f010$export$619b8904be99ed7c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const commonAttributes = (0, $5uXOq.useMemo)(()=>({
            level: (0, $951a0ed422513987$export$f9db6a58b4aabd18)
        }), []);
    // actions inside meatball menu on projects
    const sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent = (0, $5uXOq.useCallback)(({ itemId: itemId, recent: recent, starred: starred, projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$64fed82162bd367)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$56981f28056f258e),
            itemId: itemId,
            parentItemId: projectId,
            parentItemType: (0, $632bd8725b437a12$export$fe791c4fa892e400),
            projectType: projectType,
            section: (0, $aTtGi.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $8zOmE.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // meatball menu on boards
    const sendMeatBallDropDownOnBoardsAnalyticsEvent = (0, $5uXOq.useCallback)(({ recent: recent, starred: starred, boardId: boardId, projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$b887e88d8d0739f6)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$9bd6c21d500ae611),
            itemId: (0, $496585bee7985bb9$export$f06dfcec5ff912e),
            projectId: projectId,
            parentItemId: boardId,
            parentItemType: (0, $632bd8725b437a12$export$9b8283d5878d2491),
            projectType: projectType,
            section: (0, $aTtGi.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $8zOmE.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    const sendChangeViewViewOptionAnalyticsEvent = (0, $5uXOq.useCallback)(({ itemId: itemId })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$64fed82162bd367)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$17bca95234dea43b),
            itemId: itemId,
            parentItemId: (0, $632bd8725b437a12$export$119dad133da0b4a)
        };
        (0, $8zOmE.fireUIAnalytics)(event, (0, $d59b407ab907bf7b$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    return {
        sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent: sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent,
        sendMeatBallDropDownOnBoardsAnalyticsEvent: sendMeatBallDropDownOnBoardsAnalyticsEvent,
        sendChangeViewViewOptionAnalyticsEvent: sendChangeViewViewOptionAnalyticsEvent
    };
};

});

parcelRegister("7uwUx", function(module, exports) {

$parcel$export(module.exports, "default", () => $865591b1f83edfae$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $865591b1f83edfae$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createProject: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.action-buttons.create-project",
        "defaultMessage": "Create project"
    },
    manageProjects: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.action-buttons.manage-projects",
        "defaultMessage": "Manage projects"
    },
    projects: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.action-buttons.projects",
        "defaultMessage": "projects"
    }
});

});


parcelRegister("QXHTz", function(module, exports) {

$parcel$export(module.exports, "Nav4ProjectsDefault", () => $8547587d73014b07$export$373934ae259d74df);

var $5uXOq = parcelRequire("5uXOq");

var $lnznH = parcelRequire("lnznH");
var $cZa9B = parcelRequire("cZa9B");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $jecJ3 = parcelRequire("jecJ3");

var $jhS4y = parcelRequire("jhS4y");

var $aGONy = parcelRequire("aGONy");

var $46Cti = parcelRequire("46Cti");

var $c16H2 = parcelRequire("c16H2");

var $338xa = parcelRequire("338xa");

var $dQbFB = parcelRequire("dQbFB");

var $eQV8d = parcelRequire("eQV8d");

var $dUyqZ = parcelRequire("dUyqZ");

var $4zcxJ = parcelRequire("4zcxJ");

var $90yGq = parcelRequire("90yGq");

var $fY39E = parcelRequire("fY39E");

var $koeKL = parcelRequire("koeKL");

var $4R6GH = parcelRequire("4R6GH");

var $2Ioew = parcelRequire("2Ioew");


var $5GG0x = parcelRequire("5GG0x");

var $6s1PB = parcelRequire("6s1PB");


var $bWLzw = parcelRequire("bWLzw");

var $krpZe = parcelRequire("krpZe");

var $c5WDi = parcelRequire("c5WDi");
function $8547587d73014b07$export$373934ae259d74df(props) {
    const { actionsOnHover: actionsOnHover, isExpanded: isExpanded, simulateLoading: simulateLoading = false } = props;
    const cloudId = (0, $koeKL.useCloudId)();
    const activationId = (0, $fY39E.useActivationId)();
    const atlassianAccountId = (0, $90yGq.useAccountId)();
    const currentURL = (0, $aGONy.useGetCurrentUrl)();
    const entryPointParamsOld = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            currentURL: currentURL,
            activationId: activationId,
            atlassianAccountId: atlassianAccountId
        }), [
        cloudId,
        currentURL,
        activationId,
        atlassianAccountId
    ]);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            tenantContext: {
                cloudId: cloudId,
                activationId: activationId,
                atlassianAccountId: atlassianAccountId
            }
        }), [
        cloudId,
        activationId,
        atlassianAccountId
    ]);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const leftSidebarEPRef = (0, $2Ioew.usePageLayoutEntryPoint)((0, $6d6ccf8a2b2c5b3c$export$50ea883ba6f28ff5));
    const projectsEPRef = leftSidebarEPRef?.entryPoints?.projects;
    const { entryPointActions: entryPointActionsOld, entryPointReferenceSubject: entryPointReferenceSubjectOld } = (0, $4mO32.useEntryPoint)((0, $c5WDi.asyncNav4ProjectsContentViewQuery), entryPointParamsOld);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $krpZe.nav4ProjectsContentEntryPoint), entryPointParams);
    const triggerRef = (0, $4zcxJ.useExpandableEntryPointTrigger)(entryPointActions);
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).PROJECTS);
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    // If starting life expanded, make sure to load.
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route')) // We intentionally won't re-evaluate this if the route changes.
        {
            if (!projectsEPRef && isExpanded) entryPointActions.load();
        } else if (isExpanded) entryPointActionsOld.load();
    }, [
        entryPointActions,
        entryPointActionsOld,
        projectsEPRef,
        isExpanded
    ]);
    const menuId = (0, $jhS4y.MENU_ID_PROJECTS);
    // Create this component once, then keep using it FOREVER.
    // We don't want to keep switching the implementation as the user does SPA transitions.
    // We set the state this to cater for components that may be an entrypoint so that we don't keep switching between the entryPoint version and the non-entryPoint version
    const [entryPointConfig] = (0, $5uXOq.useState)(()=>{
        const epContainerProps = {
            id: 'nav4-sidebar-projects-default',
            packageName: (0, $4e61701b07fca41a$export$b8b9d90f9e5bd72b),
            teamName: (0, $4e61701b07fca41a$export$d57b6b390e78d90f),
            errorFallback: 'flag',
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), null),
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            runtimeProps: entryPointParamsOld
        };
        return {
            Component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5GG0x.RouteEntryPointContainer), {
                    epContainerProps: epContainerProps,
                    jiraEPRef: entryPointReferenceSubject,
                    nestedEPRef: projectsEPRef,
                    placeholderEntryPoint: (0, $krpZe.nav4ProjectsContentEntryPoint)
                })
        };
    });
    const content = ()=>{
        if ((0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(entryPointConfig.Component, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            // Data stream, will subscribe to load updates.
            entryPointReferenceSubject: entryPointReferenceSubjectOld,
            // Required props for error JSErrorBoundary.
            id: "nav4-sidebar-projects-default",
            packageName: (0, $4e61701b07fca41a$export$b8b9d90f9e5bd72b),
            // Optional props for error JSErrorBoundary.
            errorFallback: "flag",
            teamName: (0, $4e61701b07fca41a$export$d57b6b390e78d90f),
            // Fallback for `Suspense`.
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), null),
            // Props for the root component.
            runtimeProps: entryPointParamsOld
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onSystemToggle: (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $5uXOq.useCallback)((hasExpanded)=>{
            if (hasExpanded) {
                if ((0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route')) entryPointActions.load();
                entryPointActionsOld.load();
            }
        }, [
            entryPointActions,
            entryPointActionsOld
        ]) : (hasExpanded)=>{
            if (hasExpanded) {
                if ((0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route')) entryPointActions.load();
                entryPointActionsOld.load();
            }
        },
        onExpansionToggle: (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $5uXOq.useCallback)((hasExpanded)=>{
            if (hasExpanded) {
                if ((0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route')) entryPointActions.load();
                entryPointActionsOld.load();
                sendSectionItemAnalyticsEvent({
                    menuId: (0, $46Cti.L1_MENU_ID).PROJECTS,
                    sectionItem: (0, $jecJ3.SECTION_ITEM_PROJECTS)
                });
            }
        }, [
            entryPointActions,
            entryPointActionsOld,
            sendSectionItemAnalyticsEvent
        ]) : (hasExpanded)=>{
            if (hasExpanded) {
                if ((0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route')) entryPointActions.load();
                entryPointActionsOld.load();
                sendSectionItemAnalyticsEvent({
                    menuId: (0, $46Cti.L1_MENU_ID).PROJECTS,
                    sectionItem: (0, $jecJ3.SECTION_ITEM_PROJECTS)
                });
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZa9B.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-projects-default",
        actionsOnHover: actionsOnHover,
        // Prevent double-up of accessible name that occurs in icon+text situation.
        "aria-label": formattedMessage,
        elemBefore: icon,
        ref: triggerRef,
        testId: (0, $dQbFB.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnznH.ExpandableMenuItemContent), null, simulateLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), null) : content(), !(0, $6s1PB.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWLzw.Footer), null)));
}

});
const $4e61701b07fca41a$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Projects';
const $4e61701b07fca41a$export$d57b6b390e78d90f = 'jira-cosmos';

parcelRegister("bWLzw", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $e368b38fa5e093fd$export$a06f1c675e846f6f);

var $5uXOq = parcelRequire("5uXOq");

var $gSZmd = parcelRequire("gSZmd");
var $1qQhw = parcelRequire("1qQhw");
var $1FdfO = parcelRequire("1FdfO");

var $koVbs = parcelRequire("koVbs");

var $fNJRN = parcelRequire("fNJRN");

var $jhS4y = parcelRequire("jhS4y");

var $34PKs = parcelRequire("34PKs");

var $foR3E = parcelRequire("foR3E");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $bz9Wt = parcelRequire("bz9Wt");

var $59fBA = parcelRequire("59fBA");
const $e368b38fa5e093fd$var$VIEW_ALL_PROJECTS_HREF = (0, $foR3E.projectsDirectoryRoute).path;
function $e368b38fa5e093fd$export$a06f1c675e846f6f({ hasMore: hasMore = false }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { sendViewAllProjectsAnalyticsEvent: sendViewAllProjectsAnalyticsEvent, sendMoreProjectsAnalyticsEvent: sendMoreProjectsAnalyticsEvent } = (0, $fNJRN.useProjectsAnalyticsL1)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1qQhw.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1FdfO.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gSZmd.MenuList), null, (0, $6s1PB.expVal)('blu-7465-projects-search-in-sidebar', 'isEnabled', false) || hasMore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bz9Wt.MoreProjectsFlyout), {
        onClick: sendMoreProjectsAnalyticsEvent
    }, formatMessage((0, $59fBA.default).moreProjects)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $34PKs.ViewAllEntityMenuItem), {
        onClick: (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? sendViewAllProjectsAnalyticsEvent : ()=>{
            sendViewAllProjectsAnalyticsEvent();
        },
        href: $e368b38fa5e093fd$var$VIEW_ALL_PROJECTS_HREF,
        menuId: (0, $jhS4y.MENU_ID_PROJECTS_VIEW_ALL)
    }, formatMessage((0, $59fBA.default).viewAllProjects)))));
}

});
parcelRegister("foR3E", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryRoute", () => $00577c595d2649c4$export$74114064f06cd71b);
const $00577c595d2649c4$export$74114064f06cd71b = {
    name: 'projects-directory',
    path: '/jira/projects',
    exact: true
};

});

parcelRegister("bz9Wt", function(module, exports) {

$parcel$export(module.exports, "MoreProjectsFlyout", () => $54f4086dd6e91de6$export$35a66c7368b171ff);

var $5uXOq = parcelRequire("5uXOq");

var $6L0PY = parcelRequire("6L0PY");

var $jUDIz = parcelRequire("jUDIz");
var $17aWz = parcelRequire("17aWz");
var $lBNLs = parcelRequire("lBNLs");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $47gW9 = parcelRequire("47gW9");

var $aGONy = parcelRequire("aGONy");

var $338xa = parcelRequire("338xa");

var $koeKL = parcelRequire("koeKL");

var $lBNab = parcelRequire("lBNab");

function $54f4086dd6e91de6$export$35a66c7368b171ff(props) {
    const cloudId = (0, $koeKL.useCloudId)();
    const currentURL = (0, $aGONy.useGetCurrentUrl)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $lBNab.MoreProjectsEntrypoint), {
        cloudId: cloudId,
        currentURL: currentURL
    });
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jUDIz.FlyoutMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lBNLs.FlyoutMenuItemTrigger), {
        ...props,
        ref: triggerRef,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6L0PY))), {
            label: "",
            color: "currentColor"
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $17aWz.FlyoutMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "sidebar-nav4-more-projects-flyout",
        packageName: (0, $0c461f297af153e5$export$b8b9d90f9e5bd72b),
        teamName: (0, $0c461f297af153e5$export$d57b6b390e78d90f),
        errorFallback: "flag",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), null),
        runtimeProps: {}
    })));
}

});
parcelRegister("lBNab", function(module, exports) {

$parcel$export(module.exports, "MoreProjectsEntrypoint", () => $20b32f9039f20cdc$export$40b84ce4e7e6a96a);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $k3BmU = parcelRequire("k3BmU");

const $20b32f9039f20cdc$export$40b84ce4e7e6a96a = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("iq0nn")).then(({ MoreProjects: MoreProjects })=>MoreProjects), {
        moduleId: "d4fec86b",
        moduleName: "MoreProjects",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, currentURL: currentURL })=>({
            queries: {
                moreProjects: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $k3BmU.default,
                    variables: {
                        cloudId: cloudId,
                        currentURL: currentURL
                    }
                }
            },
            extraProps: {}
        })
});

});
parcelRegister("k3BmU", function(module, exports) {

$parcel$export(module.exports, "default", () => $009c4b9f9d37e96a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<de7b75f014e5ede9f144ec6965aeef5b>>
 * @relayHash 21c4fb6f39105b62dd5de3f2b4521a5a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 935f2d679ad13fa87ecd43aea656dffb9b51557d2643c0b18f5b8202256a0bd5
const $009c4b9f9d37e96a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "currentURL"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
            {
                "alias": "canBrowseProjects",
                "args": [
                    v1 /*: any*/ ,
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "BROWSE_PROJECTS"
                    }
                ],
                "concreteType": "JiraPermission",
                "kind": "LinkedField",
                "name": "permission",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "hasPermission"
                    }
                ]
            }
        ]
    }, v3 = [
        v1 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "currentURL",
            "variableName": "currentURL"
        }
    ], v4 = [
        {
            "concreteType": "JiraProjectEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ProjectSection_projectNode"
                }
            ]
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        {
            "concreteType": "JiraProjectEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "large"
                                }
                            ]
                        },
                        {
                            "alias": "projectKey",
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "LinkedField",
                            "name": "defaultNavigationItem",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "url"
                                        }
                                    ],
                                    "type": "JiraNavigationItem",
                                    "abstractKey": "__isJiraNavigationItem"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MoreProjectsQuery",
            "selections": [
                v2 /*: any*/ ,
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_projectsSidebarMenu",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "moreFavourites",
                            "plural": false,
                            "selections": v4 /*: any*/ 
                        },
                        {
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "moreRecents",
                            "plural": false,
                            "selections": v4 /*: any*/ 
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MoreProjectsQuery",
            "selections": [
                v2 /*: any*/ ,
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_projectsSidebarMenu",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "moreFavourites",
                            "plural": false,
                            "selections": v6 /*: any*/ 
                        },
                        {
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "moreRecents",
                            "plural": false,
                            "selections": v6 /*: any*/ 
                        },
                        v5 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "935f2d679ad13fa87ecd43aea656dffb9b51557d2643c0b18f5b8202256a0bd5",
            "metadata": {},
            "name": "MoreProjectsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$009c4b9f9d37e96a$var$node.hash = "a23d3ca8f6feee9157283fae848ea6fb";
var $009c4b9f9d37e96a$export$2e2bcd8739ae039 = $009c4b9f9d37e96a$var$node;

});

parcelRegister("iq0nn", function(module, exports) {

let $d68af26682a468ce$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d68af26682a468ce$var$load("jjVbs").then(()=>parcelRequire('efuA7'));

});


const $0c461f297af153e5$export$b8b9d90f9e5bd72b = 'jira-navigation-apps-sidebar-nav4-more-projects';
const $0c461f297af153e5$export$d57b6b390e78d90f = 'jira-cosmos';


parcelRegister("59fBA", function(module, exports) {

$parcel$export(module.exports, "default", () => $db103a2a10f2ba8d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $db103a2a10f2ba8d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    viewAllProjects: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.footer.view-all-projects",
        "defaultMessage": "View all projects"
    },
    moreProjects: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.footer.more-projects",
        "defaultMessage": "More projects"
    }
});

});


parcelRegister("krpZe", function(module, exports) {

$parcel$export(module.exports, "nav4ProjectsContentEntryPoint", () => $2be41113a8ef5aa9$export$a457f9fdcd1ea5d3);

var $4Hv8l = parcelRequire("4Hv8l");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $gdtac = parcelRequire("gdtac");

var $95KxO = parcelRequire("95KxO");

const $2be41113a8ef5aa9$export$a457f9fdcd1ea5d3 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("fiNV9")).then(({ Nav4ProjectsContentViewQuery: Nav4ProjectsContentViewQuery })=>Nav4ProjectsContentViewQuery), {
        moduleId: "90670c8d",
        moduleName: "Nav4ProjectsContentViewQuery",
        priority: "userVisible"
    }),
    getPreloadProps: (params)=>{
        const cloudId = params.tenantContext?.cloudId || '';
        const activationId = params.tenantContext.activationId;
        const atlassianAccountId = params.tenantContext.atlassianAccountId;
        return {
            queries: {
                projects: {
                    parameters: $4Hv8l.default,
                    variables: {
                        cloudId: cloudId,
                        entityAriProjects: (0, $gdtac.JiraNavigationSettingsAri).create({
                            siteId: cloudId,
                            activationId: activationId,
                            navigationSettingScope: 'projects'
                        }).toString(),
                        ownerAri: atlassianAccountId && (0, $95KxO.IdentityUserAri).create({
                            userId: atlassianAccountId
                        }).toString()
                    }
                }
            }
        };
    }
});

});
parcelRegister("4Hv8l", function(module, exports) {

$parcel$export(module.exports, "default", () => $e314997e36328d05$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c2e172597f7eb326acec06e3c81ffbb7>>
 * @relayHash 83b7eeba69a50bbc79563d561ad76b52
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ae7c7f7b4ec66feeac3fa978712ee8dba4e9109b447cd9631f0b81d1a698c216

var $apPdj = parcelRequire("apPdj");

var $bozkj = parcelRequire("bozkj");

var $2in5a = parcelRequire("2in5a");

var $57dih = parcelRequire("57dih");

var $kXP4b = parcelRequire("kXP4b");

var $cN96Q = parcelRequire("cN96Q");

var $i2tXg = parcelRequire("i2tXg");

var $gDHWC = parcelRequire("gDHWC");

var $eiowN = parcelRequire("eiowN");
const $e314997e36328d05$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriProjects"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ownerAri"
    }, v3 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v4 = [
        v3 /*: any*/ 
    ], v5 = {
        "kind": "Literal",
        "name": "first",
        "value": 15
    }, v6 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v10 = {
        "kind": "ScalarField",
        "name": "status"
    }, v11 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v12 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "large"
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "name"
    }, v14 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v15 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            v8 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v17 = {
        "kind": "LinkedField",
        "name": "defaultNavigationItem",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "JiraNavigationItem",
                "abstractKey": "__isJiraNavigationItem"
            },
            v16 /*: any*/ 
        ]
    }, v18 = [
        {
            "kind": "Literal",
            "name": "type",
            "value": "EDIT_PROJECT_CONFIG"
        }
    ], v19 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ], v20 = {
        "alias": "editProjectConfig",
        "args": v18 /*: any*/ ,
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": v19 /*: any*/ ,
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v21 = {
        "args": v18 /*: any*/ ,
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": v19 /*: any*/ ,
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v22 = {
        "kind": "ScalarField",
        "name": "projectStyle"
    }, v23 = {
        "alias": "editPermission",
        "args": v18 /*: any*/ ,
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": v19 /*: any*/ ,
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v24 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v25 = {
        "kind": "ScalarField",
        "name": "softwareBoardCount"
    }, v26 = [
        v8 /*: any*/ ,
        v9 /*: any*/ ,
        v10 /*: any*/ ,
        v11 /*: any*/ ,
        v12 /*: any*/ ,
        v13 /*: any*/ ,
        v14 /*: any*/ ,
        v15 /*: any*/ ,
        v17 /*: any*/ ,
        v20 /*: any*/ ,
        v21 /*: any*/ ,
        v22 /*: any*/ ,
        v23 /*: any*/ ,
        v24 /*: any*/ ,
        v25 /*: any*/ 
    ], v27 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v28 = {
        "kind": "Literal",
        "name": "first",
        "value": 20
    }, v29 = {
        "concreteType": "JiraProjectEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": v26 /*: any*/ 
            }
        ]
    }, v30 = [
        v29 /*: any*/ ,
        v27 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "Nav4ProjectsContentViewQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4ProjectsContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu7436separategrowthrecrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "Nav4ProjectsContentViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "favouriteProjects",
                                    "args": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": {
                                                    "order": "DESC"
                                                },
                                                "type": "PROJECT"
                                            }
                                        },
                                        v5 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v26 /*: any*/ ,
                                                            "type": "JiraProject"
                                                        },
                                                        v16 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v27 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": [
                                        v3 /*: any*/ ,
                                        v28 /*: any*/ 
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "recentProjects",
                                    "plural": false,
                                    "selections": v30 /*: any*/ 
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu7436separategrowthrecrelayprovider",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "canCreateProject",
                                    "args": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "CREATE_PROJECT"
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "canPerform"
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "GrowthRecQuery",
                                    "kind": "LinkedField",
                                    "name": "growthRecommendations",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "fields": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "product",
                                                            "value": "jira"
                                                        },
                                                        {
                                                            "kind": "Variable",
                                                            "name": "tenantId",
                                                            "variableName": "cloudId"
                                                        },
                                                        {
                                                            "kind": "Literal",
                                                            "name": "useCase",
                                                            "value": "jiraProjectMenuRecommendations"
                                                        }
                                                    ],
                                                    "kind": "ObjectValue",
                                                    "name": "context"
                                                },
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 2
                                                }
                                            ],
                                            "kind": "LinkedField",
                                            "name": "recommendations",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "data",
                                                            "plural": true,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "entityId"
                                                                        }
                                                                    ],
                                                                    "type": "GrowthRecJiraTemplateRecommendation"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "GrowthRecRecommendations"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "entityAri",
                                            "variableName": "entityAriProjects"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "ownerAri",
                                            "variableName": "ownerAri"
                                        }
                                    ],
                                    "concreteType": "SettingsNavigationCustomisation",
                                    "kind": "LinkedField",
                                    "name": "settings_navigationCustomisation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "SettingsDisplayPropertyConnection",
                                            "kind": "LinkedField",
                                            "name": "properties",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "SettingsDisplayProperty",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "value"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraProjectsSidebarMenu",
                            "kind": "LinkedField",
                            "name": "jira_projectsSidebarMenu",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "mostRecent",
                                    "plural": false,
                                    "selections": v26 /*: any*/ 
                                },
                                {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "mostRecentFromHistory",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        v22 /*: any*/ ,
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": [
                                        v5 /*: any*/ 
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        v27 /*: any*/ 
                                    ],
                                    "storageKey": "favourites(first:15)"
                                },
                                {
                                    "args": [
                                        v28 /*: any*/ 
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "recents",
                                    "plural": false,
                                    "selections": v30 /*: any*/ ,
                                    "storageKey": "recents(first:20)"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasMore"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "favouriteLimit"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "recentLimit"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "displayMode"
                                },
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ae7c7f7b4ec66feeac3fa978712ee8dba4e9109b447cd9631f0b81d1a698c216",
            "metadata": {},
            "name": "Nav4ProjectsContentViewQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider": (0, $apPdj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider": (0, $bozkj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider": (0, $gDHWC.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu7436separategrowthrecrelayprovider": (0, $2in5a.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider": (0, $57dih.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider": (0, $kXP4b.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": (0, $cN96Q.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider": (0, $i2tXg.default)
            }
        }
    };
}();
$e314997e36328d05$var$node.hash = "147c5d1f620c190c7d67a3ae20325c0e";
(0, $eiowN.PreloadableQueryRegistry).set($e314997e36328d05$var$node.params.id, $e314997e36328d05$var$node);
var $e314997e36328d05$export$2e2bcd8739ae039 = $e314997e36328d05$var$node;

});

parcelRegister("fiNV9", function(module, exports) {

let $b23f42aa635bbba7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b23f42aa635bbba7$var$load("2t7bU").then(()=>parcelRequire('6Hnkk'));

});


parcelRegister("c5WDi", function(module, exports) {

$parcel$export(module.exports, "asyncNav4ProjectsContentViewQuery", () => $6ba297934bb2a480$export$e22bacdc9273cba3);

var $6cYfS = parcelRequire("6cYfS");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $gdtac = parcelRequire("gdtac");

var $95KxO = parcelRequire("95KxO");

const $6ba297934bb2a480$export$e22bacdc9273cba3 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("6ijNk")).then(({ Nav4ProjectsContentViewOldQuery: Nav4ProjectsContentViewOldQuery })=>Nav4ProjectsContentViewOldQuery), {
        moduleId: "f2a58372",
        moduleName: "Nav4ProjectsContentViewOldQuery",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, activationId: activationId, atlassianAccountId: atlassianAccountId })=>({
            queries: {
                projects: {
                    parameters: $6cYfS.default,
                    variables: {
                        cloudId: cloudId,
                        entityAriProjects: (0, $gdtac.JiraNavigationSettingsAri).create({
                            siteId: cloudId,
                            activationId: activationId,
                            navigationSettingScope: 'projects'
                        }).toString(),
                        ownerAri: atlassianAccountId && (0, $95KxO.IdentityUserAri).create({
                            userId: atlassianAccountId
                        }).toString()
                    }
                }
            }
        })
});

});
parcelRegister("6cYfS", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0c67aa043b90c1a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<847cced066d765ee14822246180618fc>>
 * @relayHash 46f11d44371a95d04fcf4a8dd650ed0b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b813de92390fafba56d67be3a45fdfd696702bf4694e85640c9bc152d413bd30

var $apPdj = parcelRequire("apPdj");

var $bozkj = parcelRequire("bozkj");

var $2in5a = parcelRequire("2in5a");

var $57dih = parcelRequire("57dih");

var $kXP4b = parcelRequire("kXP4b");

var $cN96Q = parcelRequire("cN96Q");

var $i2tXg = parcelRequire("i2tXg");

var $gDHWC = parcelRequire("gDHWC");
const $b0c67aa043b90c1a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriProjects"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ownerAri"
    }, v3 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v4 = [
        v3 /*: any*/ 
    ], v5 = {
        "kind": "Literal",
        "name": "first",
        "value": 15
    }, v6 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v10 = {
        "kind": "ScalarField",
        "name": "status"
    }, v11 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v12 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "large"
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "name"
    }, v14 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v15 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            v8 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v17 = {
        "kind": "LinkedField",
        "name": "defaultNavigationItem",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "JiraNavigationItem",
                "abstractKey": "__isJiraNavigationItem"
            },
            v16 /*: any*/ 
        ]
    }, v18 = [
        {
            "kind": "Literal",
            "name": "type",
            "value": "EDIT_PROJECT_CONFIG"
        }
    ], v19 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ], v20 = {
        "alias": "editProjectConfig",
        "args": v18 /*: any*/ ,
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": v19 /*: any*/ ,
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v21 = {
        "args": v18 /*: any*/ ,
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": v19 /*: any*/ ,
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v22 = {
        "kind": "ScalarField",
        "name": "projectStyle"
    }, v23 = {
        "alias": "editPermission",
        "args": v18 /*: any*/ ,
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": v19 /*: any*/ ,
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v24 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v25 = {
        "kind": "ScalarField",
        "name": "softwareBoardCount"
    }, v26 = [
        v8 /*: any*/ ,
        v9 /*: any*/ ,
        v10 /*: any*/ ,
        v11 /*: any*/ ,
        v12 /*: any*/ ,
        v13 /*: any*/ ,
        v14 /*: any*/ ,
        v15 /*: any*/ ,
        v17 /*: any*/ ,
        v20 /*: any*/ ,
        v21 /*: any*/ ,
        v22 /*: any*/ ,
        v23 /*: any*/ ,
        v24 /*: any*/ ,
        v25 /*: any*/ 
    ], v27 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v28 = {
        "kind": "Literal",
        "name": "first",
        "value": 20
    }, v29 = {
        "concreteType": "JiraProjectEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": v26 /*: any*/ 
            }
        ]
    }, v30 = [
        v29 /*: any*/ ,
        v27 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "Nav4ProjectsContentViewOldQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4ProjectsContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu7436separategrowthrecrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "Nav4ProjectsContentViewOldQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "favouriteProjects",
                                    "args": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": {
                                                    "order": "DESC"
                                                },
                                                "type": "PROJECT"
                                            }
                                        },
                                        v5 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v26 /*: any*/ ,
                                                            "type": "JiraProject"
                                                        },
                                                        v16 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v27 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": [
                                        v3 /*: any*/ ,
                                        v28 /*: any*/ 
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "recentProjects",
                                    "plural": false,
                                    "selections": v30 /*: any*/ 
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu7436separategrowthrecrelayprovider",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "canCreateProject",
                                    "args": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "CREATE_PROJECT"
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "canPerform"
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "GrowthRecQuery",
                                    "kind": "LinkedField",
                                    "name": "growthRecommendations",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "fields": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "product",
                                                            "value": "jira"
                                                        },
                                                        {
                                                            "kind": "Variable",
                                                            "name": "tenantId",
                                                            "variableName": "cloudId"
                                                        },
                                                        {
                                                            "kind": "Literal",
                                                            "name": "useCase",
                                                            "value": "jiraProjectMenuRecommendations"
                                                        }
                                                    ],
                                                    "kind": "ObjectValue",
                                                    "name": "context"
                                                },
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 2
                                                }
                                            ],
                                            "kind": "LinkedField",
                                            "name": "recommendations",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "data",
                                                            "plural": true,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "entityId"
                                                                        }
                                                                    ],
                                                                    "type": "GrowthRecJiraTemplateRecommendation"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "GrowthRecRecommendations"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "entityAri",
                                            "variableName": "entityAriProjects"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "ownerAri",
                                            "variableName": "ownerAri"
                                        }
                                    ],
                                    "concreteType": "SettingsNavigationCustomisation",
                                    "kind": "LinkedField",
                                    "name": "settings_navigationCustomisation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "SettingsDisplayPropertyConnection",
                                            "kind": "LinkedField",
                                            "name": "properties",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "SettingsDisplayProperty",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "value"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraProjectsSidebarMenu",
                            "kind": "LinkedField",
                            "name": "jira_projectsSidebarMenu",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "mostRecent",
                                    "plural": false,
                                    "selections": v26 /*: any*/ 
                                },
                                {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "mostRecentFromHistory",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        v22 /*: any*/ ,
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": [
                                        v5 /*: any*/ 
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        v27 /*: any*/ 
                                    ],
                                    "storageKey": "favourites(first:15)"
                                },
                                {
                                    "args": [
                                        v28 /*: any*/ 
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "recents",
                                    "plural": false,
                                    "selections": v30 /*: any*/ ,
                                    "storageKey": "recents(first:20)"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasMore"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "favouriteLimit"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "recentLimit"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "displayMode"
                                },
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b813de92390fafba56d67be3a45fdfd696702bf4694e85640c9bc152d413bd30",
            "metadata": {},
            "name": "Nav4ProjectsContentViewOldQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider": (0, $apPdj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider": (0, $bozkj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider": (0, $gDHWC.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu7436separategrowthrecrelayprovider": (0, $2in5a.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider": (0, $57dih.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider": (0, $kXP4b.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": (0, $cN96Q.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider": (0, $i2tXg.default)
            }
        }
    };
}();
$b0c67aa043b90c1a$var$node.hash = "e9dbe371555b08c40fa0fff884abed7c";
var $b0c67aa043b90c1a$export$2e2bcd8739ae039 = $b0c67aa043b90c1a$var$node;

});

parcelRegister("6ijNk", function(module, exports) {

let $4953c74ec1b6fb07$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4953c74ec1b6fb07$var$load("9hdcr").then(()=>parcelRequire('hNn1a'));

});



parcelRegister("8syLG", function(module, exports) {

$parcel$export(module.exports, "Nav4ProjectsForLanding", () => $34b8fcf67bf73580$export$8c948b59812f90e9);

var $j4EOM = parcelRequire("j4EOM");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $lnznH = parcelRequire("lnznH");
var $cZa9B = parcelRequire("cZa9B");

var $7CMCs = parcelRequire("7CMCs");

var $jecJ3 = parcelRequire("jecJ3");

var $jhS4y = parcelRequire("jhS4y");

var $46Cti = parcelRequire("46Cti");

var $c16H2 = parcelRequire("c16H2");

var $dQbFB = parcelRequire("dQbFB");

var $eQV8d = parcelRequire("eQV8d");

var $dUyqZ = parcelRequire("dUyqZ");

var $jcSAX = parcelRequire("jcSAX");

var $l8ruj = parcelRequire("l8ruj");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");


var $bWLzw = parcelRequire("bWLzw");
function $34b8fcf67bf73580$export$8c948b59812f90e9(props) {
    const { actionsOnHover: actionsOnHover, isExpanded: isExpanded, queryRef: queryRef } = props;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).PROJECTS);
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    const data = (0, $8Uumt.useFragment)((0, $j4EOM.default), queryRef);
    const menuId = (0, $jhS4y.MENU_ID_PROJECTS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $5uXOq.useCallback)((hasExpanded)=>{
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $46Cti.L1_MENU_ID).PROJECTS,
                sectionItem: (0, $jecJ3.SECTION_ITEM_PROJECTS)
            });
        }, [
            sendSectionItemAnalyticsEvent
        ]) : (hasExpanded)=>{
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $46Cti.L1_MENU_ID).PROJECTS,
                sectionItem: (0, $jecJ3.SECTION_ITEM_PROJECTS)
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZa9B.ExpandableMenuItemTrigger), {
        actionsOnHover: actionsOnHover,
        // Prevent double-up of accessible name that occurs in icon + text situation.
        "aria-label": formattedMessage,
        elemBefore: icon,
        testId: (0, $dQbFB.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnznH.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4-sidebar-projects-landing"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "nav4-sidebar-projects-landing",
        packageName: (0, $4e61701b07fca41a$export$b8b9d90f9e5bd72b),
        teamName: (0, $4e61701b07fca41a$export$d57b6b390e78d90f),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jcSAX.Nav4ProjectsContent), {
        queryRef: data
    }))), !(0, $6s1PB.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWLzw.Footer), null)));
}

});
parcelRegister("j4EOM", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea186c046425d9b2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4c21586a3492cb3ed09327f8fd2de9ba>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ea186c046425d9b2$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4ProjectsForLanding",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Nav4ProjectsContent"
        }
    ],
    "type": "Query"
};
$ea186c046425d9b2$var$node.hash = "4d3bdf6d5d5d912aac0901d592694d15";
var $ea186c046425d9b2$export$2e2bcd8739ae039 = $ea186c046425d9b2$var$node;

});

parcelRegister("jcSAX", function(module, exports) {

$parcel$export(module.exports, "Nav4ProjectsContent", () => $610b3e666862e79d$export$74ce18a8a4837259);

var $73EMs = parcelRequire("73EMs");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $i8Qvm = parcelRequire("i8Qvm");

var $6s1PB = parcelRequire("6s1PB");

var $5NM6P = parcelRequire("5NM6P");

var $6Lyip = parcelRequire("6Lyip");

var $e4A2P = parcelRequire("e4A2P");

var $jhS4y = parcelRequire("jhS4y");

var $c6x3L = parcelRequire("c6x3L");

var $9Gyp5 = parcelRequire("9Gyp5");

var $gxbcq = parcelRequire("gxbcq");

var $1b6zA = parcelRequire("1b6zA");

var $1tOff = parcelRequire("1tOff");

var $aq8kS = parcelRequire("aq8kS");

var $4iaU1 = parcelRequire("4iaU1");

var $80ha2 = parcelRequire("80ha2");

var $7RJ5F = parcelRequire("7RJ5F");

var $hohDO = parcelRequire("hohDO");

var $dWDWP = parcelRequire("dWDWP");

var $koeKL = parcelRequire("koeKL");

var $fNJRN = parcelRequire("fNJRN");

var $gKabe = parcelRequire("gKabe");

var $4R6GH = parcelRequire("4R6GH");

var $bWLzw = parcelRequire("bWLzw");

var $dLakp = parcelRequire("dLakp");

var $5alFY = parcelRequire("5alFY");
const $610b3e666862e79d$var$MAX_RECENT_PROJECTS = 5;
const $610b3e666862e79d$export$4319a8d1db123861 = 15;
function $610b3e666862e79d$export$74ce18a8a4837259({ queryRef: queryRef }) {
    const cloudId = (0, $koeKL.useCloudId)();
    const { getStableItems: getStableItems } = (0, $1b6zA.useStableItems)();
    const { isSelectedPath: isSelectedPath } = (0, $c6x3L.useSidebarNav4)();
    const [projectToRestore, setProjectToRestore] = (0, $5uXOq.useState)(null);
    const { sendProjectMenuContentAnalyticsEvent: sendProjectMenuContentAnalyticsEvent } = (0, $fNJRN.useProjectsAnalyticsL1)();
    (0, $5uXOq.useEffect)(()=>{
        sendProjectMenuContentAnalyticsEvent();
    }, [
        sendProjectMenuContentAnalyticsEvent
    ]);
    // https://jplat.jira.atlassian.cloud/browse/BLU-2719
    // We intentionally request 10 starred and 15 recent projects.
    // Then, if all 10 starred projects were recently visited, we still show 5 recent projects as well.
    const data = (0, $8Uumt.useRefetchableFragment)((0, $73EMs.default), queryRef);
    const [{ jira: jira, jira_projectsSidebarMenu: projectsSidebarMenu }, refetch] = data;
    const { jwmLicensing: jwmLicensing } = jira;
    const favouriteLimit = (0, $6s1PB.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false) ? projectsSidebarMenu?.favouriteLimit : $610b3e666862e79d$export$4319a8d1db123861;
    const recentLimit = (0, $6s1PB.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false) ? projectsSidebarMenu?.recentLimit : $610b3e666862e79d$var$MAX_RECENT_PROJECTS;
    const favouriteProjects = $610b3e666862e79d$var$isJiraProjectsSidebarMenuEnabled() ? projectsSidebarMenu?.favourites : jira.favouriteProjects;
    const recentProjects = $610b3e666862e79d$var$isJiraProjectsSidebarMenuEnabled() ? projectsSidebarMenu?.recents : jira.recentProjects;
    // throwing here enforces the mutually exclusive @include/@skip directives which otherwise would be handled by @required
    if (!favouriteProjects || !recentProjects) throw new Error('JiraProjectConnection is missing in Nav4ProjectsContent for favourite or recent projects');
    const mostRecentProject = projectsSidebarMenu?.mostRecent;
    /** Using `mostRecentFromHistory` for the cases where we don't send `currentURL` (see L1MenuItemsQuery)
   * as a temporary fix to correctly display the projects in the sidebar, by checking the `displayMode`
   * and adding `mostRecentFromHistory` to the lists if necessary
   * More info here: https://jplat.atlassian.net/browse/BLU-6987 */ const mostRecentFromHistory = projectsSidebarMenu?.mostRecentFromHistory;
    const displayMode = projectsSidebarMenu?.displayMode;
    const isMostRecentFromHistorySelected = mostRecentFromHistory && isSelectedPath((0, $jhS4y.ENTITY_ID).PROJECT(mostRecentFromHistory.projectKey));
    const entityAriProjects = (0, $7RJ5F.useSidebarSettingsAri)('projects');
    const ownerAri = (0, $7RJ5F.useOwnerAri)();
    const queryVariables = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            entityAriProjects: entityAriProjects,
            ownerAri: ownerAri
        }), [
        cloudId,
        entityAriProjects,
        ownerAri
    ]);
    (0, $9Gyp5.useRefetchWhenIsSelected)({
        cloudId: cloudId,
        isSelectedPath: isSelectedPath,
        QUERY: $dWDWP.default,
        refetch: refetch,
        menuId: (0, $jhS4y.MENU_ID_PROJECTS),
        queryVariables: queryVariables
    });
    const refetchOnChange = (0, $5uXOq.useCallback)(({ onComplete: onComplete })=>{
        refetch(queryVariables, {
            fetchPolicy: 'store-and-network',
            onComplete: onComplete
        });
    }, [
        queryVariables,
        refetch
    ]);
    (0, $gxbcq.useSubscribeAndUpdateFavorites)({
        entityTypename: 'JiraProject',
        favouriteConnectionId: favouriteProjects.__id,
        recentConnectionId: recentProjects.__id,
        refetch: refetchOnChange
    });
    (0, $1tOff.useSyncChangeFavourites)();
    const favorites = (0, $5uXOq.useMemo)(()=>{
        const favoritesList = favouriteProjects.edges?.filter(Boolean).map((edge)=>edge.node) ?? [];
        const isMostRecentFromHistoryInFavoritesList = favoritesList.some((project)=>project.id === mostRecentFromHistory?.id);
        const shouldShowStarredSection = displayMode === (0, $80ha2.ViewOptions).STARRED_AND_RECENT || displayMode === (0, $80ha2.ViewOptions).STARRED;
        const shouldAddMostRecentFromHistoryToFavouritesList = $610b3e666862e79d$var$isJiraProjectsSidebarMenuEnabled() && mostRecentFromHistory && mostRecentFromHistory.isFavourite && shouldShowStarredSection && isMostRecentFromHistorySelected && favoritesList.length > 0 && !isMostRecentFromHistoryInFavoritesList;
        /** `currentURL` is not sent in L1MenuItemsQuery which might re-write projects wrong in the sidebar in some cases
     * i.e. when the user visits Starred project which order # is more than the starred limit
     * so the project should be displayed as the last Starred one
     * With this fix we keep the sidebar in the correct state according to the current route performing
     * the same logic that BE does when it is aware of the `currentURL` */ if (shouldAddMostRecentFromHistoryToFavouritesList) {
            favoritesList.pop();
            favoritesList.push(mostRecentFromHistory);
        }
        const ids = favoritesList.map((project)=>project.id).filter(Boolean) ?? [];
        const list = favoritesList.map((project)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4iaU1.Nav4ProjectMenuItem), {
                key: project.projectKey,
                queryRef: project,
                isCorePremiumUserSeat: jwmLicensing?.currentUserSeatEdition === 'PREMIUM',
                setProjectToRestore: setProjectToRestore,
                // Show onboarding spotlight on the first item
                spotlight: project.id === ids[0] ? (0, $5NM6P.Nav4OnboardingComponentNames).SIDEBAR_PROJECT_SPOTLIGHT : undefined
            });
        }) ?? [];
        const hasNextPage = favouriteProjects.pageInfo?.hasNextPage || (favouriteLimit ? list.length > favouriteLimit : false);
        return {
            idSet: new Set(ids),
            list: list.slice(0, favouriteLimit ?? Infinity),
            hasItems: Boolean(list.length),
            hasNextPage: hasNextPage
        };
    }, [
        favouriteProjects,
        jwmLicensing,
        favouriteLimit,
        displayMode,
        mostRecentFromHistory,
        isMostRecentFromHistorySelected
    ]);
    const recentItems = (0, $5uXOq.useMemo)(()=>{
        const isStarredOnlyMode = displayMode === (0, $80ha2.ViewOptions).STARRED;
        const shouldAddMostRecentFromHistoryToRecentList = $610b3e666862e79d$var$isJiraProjectsSidebarMenuEnabled() && mostRecentFromHistory && !mostRecentFromHistory.isFavourite && isStarredOnlyMode && isMostRecentFromHistorySelected && (recentProjects.edges?.length ?? 0) === 0;
        /** `currentURL` is not sent in L1MenuItemsQuery which might re-write projects wrong in the sidebar in some cases
     * i.e. when Display Mode is STARRED only and the user visits a Recent project
     * so the project should be displayed as the only one in the Recent section
     * With this fix we keep the sidebar in the correct state according to the current route performing
     * the same logic that BE does when it is aware of the `currentURL` */ const nodes = shouldAddMostRecentFromHistoryToRecentList ? [
            mostRecentFromHistory
        ] : recentProjects.edges?.filter(Boolean).filter((edge)=>edge.node.id && !favorites.idSet.has(edge.node.id)).map((edge)=>edge.node).slice(0, recentLimit ?? Infinity) ?? [];
        const stableOrderedNodes = getStableItems({
            nodes: nodes,
            idKey: 'id'
        });
        const firstItemKey = stableOrderedNodes[0]?.projectKey;
        const list = stableOrderedNodes.map((node)=>{
            // Show onboarding spotlight on the first item if there are no favorites
            const showSpotlight = !favorites.hasItems && node.projectKey === firstItemKey;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4iaU1.Nav4ProjectMenuItem), {
                key: node.projectKey,
                queryRef: node,
                isCorePremiumUserSeat: jwmLicensing?.currentUserSeatEdition === 'PREMIUM',
                setProjectToRestore: setProjectToRestore,
                spotlight: showSpotlight ? (0, $5NM6P.Nav4OnboardingComponentNames).SIDEBAR_PROJECT_SPOTLIGHT : undefined
            });
        });
        return {
            list: list,
            hasItems: Boolean(list.length)
        };
    }, [
        recentProjects.edges,
        getStableItems,
        favorites.idSet,
        jwmLicensing?.currentUserSeatEdition,
        favorites.hasItems,
        recentLimit,
        displayMode,
        mostRecentFromHistory,
        isMostRecentFromHistorySelected
    ]);
    const mostRecentProjectItem = (0, $5uXOq.useMemo)(()=>mostRecentProject ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4iaU1.Nav4ProjectMenuItem), {
            key: mostRecentProject.projectKey,
            queryRef: mostRecentProject,
            isCorePremiumUserSeat: jwmLicensing?.currentUserSeatEdition === 'PREMIUM',
            setProjectToRestore: setProjectToRestore,
            spotlight: (0, $5NM6P.Nav4OnboardingComponentNames).SIDEBAR_PROJECT_SPOTLIGHT
        }) : null, [
        mostRecentProject,
        jwmLicensing?.currentUserSeatEdition
    ]);
    const restoreProjectModal = (0, $5uXOq.useCallback)(()=>{
        if (projectToRestore) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hohDO.default), {
            ...projectToRestore,
            onProjectRestoreSuccess: ()=>{
                setProjectToRestore(null);
                refetch(queryVariables, {
                    fetchPolicy: 'store-and-network'
                });
            },
            onProjectRestoreFailure: ()=>{
                setProjectToRestore(null);
            },
            onClose: ()=>setProjectToRestore(null)
        }));
    }, [
        queryVariables,
        projectToRestore,
        refetch
    ]);
    if (!favorites.hasItems && !recentItems.hasItems && !mostRecentProject) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Lyip.OnboardingSpotlightMaybe), {
        spotlight: (0, $5NM6P.Nav4OnboardingComponentNames).SIDEBAR_PROJECT_SPOTLIGHT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aq8kS.Nav4ProjectsEmptyContent), null), (0, $4R6GH.fg)('blu-7436-separate-growth-rec') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gKabe.Nav4Recommendations), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gKabe.Nav4RecommendationsOld), {
        queryRef: data[0]
    }), restoreProjectModal(), (0, $6s1PB.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWLzw.Footer), {
        hasMore: projectsSidebarMenu?.hasMore
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4A2P.UpdateProjectsProvider), {
        favouriteConnectionId: favouriteProjects.__id,
        recentConnectionId: recentProjects.__id
    }, !(0, $6s1PB.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false) && (0, $6s1PB.expVal)('blu-6315-display-settings-a-part-1', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5alFY.Nav4ProjectsSectionsWithDisplaySettings), {
        favoriteItems: favorites,
        recentItems: recentItems,
        queryRef: data[0]
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dLakp.Nav4ProjectsSections), {
        favoriteItems: favorites,
        recentItems: recentItems,
        mostRecentProjectItem: mostRecentProjectItem
    }), (0, $4R6GH.fg)('blu-7436-separate-growth-rec') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gKabe.Nav4Recommendations), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gKabe.Nav4RecommendationsOld), {
        queryRef: data[0]
    }), restoreProjectModal(), (0, $6s1PB.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWLzw.Footer), {
        hasMore: projectsSidebarMenu?.hasMore
    }));
}
function $610b3e666862e79d$var$isJiraProjectsSidebarMenuEnabled() {
    return (0, $6s1PB.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false) || (0, $6s1PB.expVal)('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false);
}

});
parcelRegister("73EMs", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0cd0ab2a500c3f5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b585887dd261359fd46545ef482c3c32>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $dWDWP = parcelRequire("dWDWP");
const $c0cd0ab2a500c3f5$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v1 = {
        "kind": "Literal",
        "name": "first",
        "value": 15
    }, v2 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v5 = {
        "kind": "FragmentSpread",
        "name": "Nav4ProjectMenuItem"
    }, v6 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v7 = {
        "kind": "Variable",
        "name": "currentURL",
        "variableName": "currentURL"
    }, v8 = {
        "kind": "Literal",
        "name": "first",
        "value": 20
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu7436separategrowthrecrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "currentURL"
            },
            {
                "kind": "RootArgument",
                "name": "entityAriProjects"
            },
            {
                "kind": "RootArgument",
                "name": "ownerAri"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "refetch": {
                "fragmentPathInResult": [],
                "operation": (0, $dWDWP.default)
            }
        },
        "name": "Nav4ProjectsContent",
        "selections": [
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu7436separategrowthrecrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "Nav4RecommendationsOld"
                    }
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "entityAri",
                                        "variableName": "entityAriProjects"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "ownerAri",
                                        "variableName": "ownerAri"
                                    }
                                ],
                                "kind": "FragmentSpread",
                                "name": "Nav4ProjectsSectionsWithDisplaySettings"
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "alias": "favouriteProjects",
                                        "args": [
                                            v0 /*: any*/ ,
                                            {
                                                "kind": "Literal",
                                                "name": "filter",
                                                "value": {
                                                    "sort": {
                                                        "order": "DESC"
                                                    },
                                                    "type": "PROJECT"
                                                }
                                            },
                                            v1 /*: any*/ 
                                        ],
                                        "concreteType": "JiraFavouriteConnection",
                                        "kind": "LinkedField",
                                        "name": "favourites",
                                        "plural": false,
                                        "selections": [
                                            v2 /*: any*/ ,
                                            {
                                                "concreteType": "JiraFavouriteEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v3 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "jira.favouriteProjects.edges.node.id"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v4 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "jira.favouriteProjects.edges.node.projectKey"
                                                                        },
                                                                        v5 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraProject"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira.favouriteProjects.edges.node"
                                                    }
                                                ]
                                            },
                                            v6 /*: any*/ 
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.favouriteProjects"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": [
                                            v0 /*: any*/ ,
                                            v7 /*: any*/ ,
                                            v8 /*: any*/ 
                                        ],
                                        "concreteType": "JiraProjectConnection",
                                        "kind": "LinkedField",
                                        "name": "recentProjects",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraProjectEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v3 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira.recentProjects.edges.node.id"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v4 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira.recentProjects.edges.node.projectKey"
                                                                },
                                                                v5 /*: any*/ 
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira.recentProjects.edges.node"
                                                    }
                                                ]
                                            },
                                            v6 /*: any*/ 
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.recentProjects"
                                }
                            ]
                        },
                        {
                            "args": [
                                v0 /*: any*/ 
                            ],
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        }
                    ]
                },
                "action": "THROW",
                "path": "jira"
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": [
                                v0 /*: any*/ ,
                                v7 /*: any*/ 
                            ],
                            "concreteType": "JiraProjectsSidebarMenu",
                            "kind": "LinkedField",
                            "name": "jira_projectsSidebarMenu",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "mostRecent",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v3 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira_projectsSidebarMenu.mostRecent.id"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v4 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira_projectsSidebarMenu.mostRecent.projectKey"
                                        },
                                        v5 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "mostRecentFromHistory",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v3 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira_projectsSidebarMenu.mostRecentFromHistory.id"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v4 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira_projectsSidebarMenu.mostRecentFromHistory.projectKey"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isFavourite"
                                        },
                                        v5 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": [
                                            v1 /*: any*/ 
                                        ],
                                        "concreteType": "JiraProjectConnection",
                                        "kind": "LinkedField",
                                        "name": "favourites",
                                        "plural": false,
                                        "selections": [
                                            v2 /*: any*/ ,
                                            {
                                                "concreteType": "JiraProjectEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v3 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira_projectsSidebarMenu.favourites.edges.node.id"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v4 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira_projectsSidebarMenu.favourites.edges.node.projectKey"
                                                                },
                                                                v5 /*: any*/ 
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira_projectsSidebarMenu.favourites.edges.node"
                                                    }
                                                ]
                                            },
                                            v6 /*: any*/ 
                                        ],
                                        "storageKey": "favourites(first:15)"
                                    },
                                    "action": "THROW",
                                    "path": "jira_projectsSidebarMenu.favourites"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": [
                                            v8 /*: any*/ 
                                        ],
                                        "concreteType": "JiraProjectConnection",
                                        "kind": "LinkedField",
                                        "name": "recents",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraProjectEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v3 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira_projectsSidebarMenu.recents.edges.node.id"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v4 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira_projectsSidebarMenu.recents.edges.node.projectKey"
                                                                },
                                                                v5 /*: any*/ 
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira_projectsSidebarMenu.recents.edges.node"
                                                    }
                                                ]
                                            },
                                            v6 /*: any*/ 
                                        ],
                                        "storageKey": "recents(first:20)"
                                    },
                                    "action": "THROW",
                                    "path": "jira_projectsSidebarMenu.recents"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasMore"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "favouriteLimit"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "recentLimit"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "displayMode"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira_projectsSidebarMenu"
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$c0cd0ab2a500c3f5$var$node.hash = "7509ad6a441a847a4ac6547b12d9c450";
var $c0cd0ab2a500c3f5$export$2e2bcd8739ae039 = $c0cd0ab2a500c3f5$var$node;

});
parcelRegister("dWDWP", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cc98d32cef1447c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<392ebea7bb8e603ecc91f57e53daeaf7>>
 * @relayHash 3b9fc7c7e2f9976a314ad7db10152da5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4f9cccd8b15f56c73d7ff9c32f08a298b19506b7d8c1c3d34de5e1e8544dda66

var $apPdj = parcelRequire("apPdj");

var $bozkj = parcelRequire("bozkj");

var $2in5a = parcelRequire("2in5a");

var $57dih = parcelRequire("57dih");

var $kXP4b = parcelRequire("kXP4b");

var $cN96Q = parcelRequire("cN96Q");

var $i2tXg = parcelRequire("i2tXg");

var $gDHWC = parcelRequire("gDHWC");
const $2cc98d32cef1447c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "currentURL"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "displaySettingsAPart1Enabled"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "displaySettingsPostGaEnabled"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriProjects"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraProjectsSidebarMenuEnabled"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ownerAri"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "separateGrowthRecEnabled"
    }, v8 = {
        "kind": "Variable",
        "name": "currentURL",
        "variableName": "currentURL"
    }, v9 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v10 = {
        "kind": "Literal",
        "name": "first",
        "value": 15
    }, v11 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v13 = {
        "kind": "ScalarField",
        "name": "id"
    }, v14 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v15 = {
        "kind": "ScalarField",
        "name": "status"
    }, v16 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v17 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "large"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "name"
    }, v19 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v20 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v21 = {
        "kind": "InlineFragment",
        "selections": [
            v13 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v22 = {
        "kind": "LinkedField",
        "name": "defaultNavigationItem",
        "plural": false,
        "selections": [
            v12 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "JiraNavigationItem",
                "abstractKey": "__isJiraNavigationItem"
            },
            v21 /*: any*/ 
        ]
    }, v23 = [
        {
            "kind": "Literal",
            "name": "type",
            "value": "EDIT_PROJECT_CONFIG"
        }
    ], v24 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ], v25 = {
        "alias": "editProjectConfig",
        "args": v23 /*: any*/ ,
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": v24 /*: any*/ ,
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v26 = {
        "args": v23 /*: any*/ ,
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": v24 /*: any*/ ,
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v27 = {
        "kind": "ScalarField",
        "name": "projectStyle"
    }, v28 = {
        "alias": "editPermission",
        "args": v23 /*: any*/ ,
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": v24 /*: any*/ ,
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v29 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v30 = {
        "kind": "ScalarField",
        "name": "softwareBoardCount"
    }, v31 = [
        v13 /*: any*/ ,
        v14 /*: any*/ ,
        v15 /*: any*/ ,
        v16 /*: any*/ ,
        v17 /*: any*/ ,
        v18 /*: any*/ ,
        v19 /*: any*/ ,
        v20 /*: any*/ ,
        v22 /*: any*/ ,
        v25 /*: any*/ ,
        v26 /*: any*/ ,
        v27 /*: any*/ ,
        v28 /*: any*/ ,
        v29 /*: any*/ ,
        v30 /*: any*/ 
    ], v32 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v33 = {
        "kind": "Literal",
        "name": "first",
        "value": 20
    }, v34 = {
        "concreteType": "JiraProjectEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": v31 /*: any*/ 
            }
        ]
    }, v35 = [
        v34 /*: any*/ ,
        v32 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "Nav4ProjectsContentQuery",
            "selections": [
                {
                    "args": [
                        v8 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "Nav4ProjectsContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu7436separategrowthrecrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "Nav4ProjectsContentQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v9 /*: any*/ 
                            ],
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "favouriteProjects",
                                    "args": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": {
                                                    "order": "DESC"
                                                },
                                                "type": "PROJECT"
                                            }
                                        },
                                        v10 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v11 /*: any*/ ,
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v31 /*: any*/ ,
                                                            "type": "JiraProject"
                                                        },
                                                        v21 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v32 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": [
                                        v9 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v33 /*: any*/ 
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "recentProjects",
                                    "plural": false,
                                    "selections": v35 /*: any*/ 
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu7436separategrowthrecrelayprovider",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "canCreateProject",
                                    "args": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "CREATE_PROJECT"
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "canPerform"
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "GrowthRecQuery",
                                    "kind": "LinkedField",
                                    "name": "growthRecommendations",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "fields": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "product",
                                                            "value": "jira"
                                                        },
                                                        {
                                                            "kind": "Variable",
                                                            "name": "tenantId",
                                                            "variableName": "cloudId"
                                                        },
                                                        {
                                                            "kind": "Literal",
                                                            "name": "useCase",
                                                            "value": "jiraProjectMenuRecommendations"
                                                        }
                                                    ],
                                                    "kind": "ObjectValue",
                                                    "name": "context"
                                                },
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 2
                                                }
                                            ],
                                            "kind": "LinkedField",
                                            "name": "recommendations",
                                            "plural": false,
                                            "selections": [
                                                v12 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "data",
                                                            "plural": true,
                                                            "selections": [
                                                                v12 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "entityId"
                                                                        }
                                                                    ],
                                                                    "type": "GrowthRecJiraTemplateRecommendation"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "GrowthRecRecommendations"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "entityAri",
                                            "variableName": "entityAriProjects"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "ownerAri",
                                            "variableName": "ownerAri"
                                        }
                                    ],
                                    "concreteType": "SettingsNavigationCustomisation",
                                    "kind": "LinkedField",
                                    "name": "settings_navigationCustomisation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "SettingsDisplayPropertyConnection",
                                            "kind": "LinkedField",
                                            "name": "properties",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "SettingsDisplayProperty",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "value"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v13 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                v9 /*: any*/ ,
                                v8 /*: any*/ 
                            ],
                            "concreteType": "JiraProjectsSidebarMenu",
                            "kind": "LinkedField",
                            "name": "jira_projectsSidebarMenu",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "mostRecent",
                                    "plural": false,
                                    "selections": v31 /*: any*/ 
                                },
                                {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "mostRecentFromHistory",
                                    "plural": false,
                                    "selections": [
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v22 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        v30 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": [
                                        v10 /*: any*/ 
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v11 /*: any*/ ,
                                        v34 /*: any*/ ,
                                        v32 /*: any*/ 
                                    ],
                                    "storageKey": "favourites(first:15)"
                                },
                                {
                                    "args": [
                                        v33 /*: any*/ 
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "recents",
                                    "plural": false,
                                    "selections": v35 /*: any*/ ,
                                    "storageKey": "recents(first:20)"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasMore"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "favouriteLimit"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "recentLimit"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "displayMode"
                                },
                                v13 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4f9cccd8b15f56c73d7ff9c32f08a298b19506b7d8c1c3d34de5e1e8544dda66",
            "metadata": {},
            "name": "Nav4ProjectsContentQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "displaySettingsAPart1Enabled": (0, $apPdj.default),
                "displaySettingsPostGaEnabled": (0, $bozkj.default),
                "jiraProjectsSidebarMenuEnabled": (0, $gDHWC.default),
                "separateGrowthRecEnabled": (0, $2in5a.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider": (0, $apPdj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider": (0, $bozkj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider": (0, $gDHWC.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu7436separategrowthrecrelayprovider": (0, $2in5a.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider": (0, $57dih.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider": (0, $kXP4b.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": (0, $cN96Q.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider": (0, $i2tXg.default)
            }
        }
    };
}();
$2cc98d32cef1447c$var$node.hash = "7509ad6a441a847a4ac6547b12d9c450";
var $2cc98d32cef1447c$export$2e2bcd8739ae039 = $2cc98d32cef1447c$var$node;

});


parcelRegister("5NM6P", function(module, exports) {

$parcel$export(module.exports, "Nav4OnboardingComponentNames", () => $b94a87b237943b7f$export$f813aeb3fcf8b623);
$parcel$export(module.exports, "COMPONENT_TAP_TRAIT_MAP", () => $b94a87b237943b7f$export$c1a4e03cc30032f5);
const $b94a87b237943b7f$export$f813aeb3fcf8b623 = {
    GLOBAL_MODAL: 'nav4GlobalOnboardingModal',
    JIRA_SIDEBAR_TOGGLE_SPOTLIGHT: 'nav4SidebarToggleOnboardingSpotlight',
    // CONFLUENCE_SIDEBAR_TOGGLE_SPOTLIGHT: 'nav4ConfluenceSidebarToggleOnboardingSpotlight', // TODO: Spotlight has not been implemented in Confluence yet so this may change
    SIDEBAR_PROJECT_SPOTLIGHT: 'nav4SidebarProjectsOnboardingSpotlight',
    TAB_NAV_SPOTLIGHT: 'nav4TabNavigationOnboardingSpotlight',
    ATLAS_GLOBAL_MODAL: 'nav4AtlasGlobalOnboardingModal',
    ATLAS_GLOBAL_MODAL2: 'nav4AtlasGlobalOnboardingModal2'
};
const $b94a87b237943b7f$export$c1a4e03cc30032f5 = {
    nav4GlobalOnboardingModal: 'jira-platform_ui_nav4globalonboardingmodal_dismissed_jiraatlassianonboardingnav4_changed',
    nav4SidebarToggleOnboardingSpotlight: 'jira-platform_ui_nav4sidebartoggleonboardingspotlight_dismissed_jiraatlassianonboardingnav4_changed',
    // nav4ConfluenceSidebarToggleOnboardingSpotlight: '', // TODO: Add when Confluence spotlight is implemented
    nav4SidebarProjectsOnboardingSpotlight: 'jira-platform_ui_nav4sidebarprojectsonboardingspotlight_dismissed_jiraatlassianonboardingnav4_changed',
    nav4TabNavigationOnboardingSpotlight: 'jira-platform_ui_nav4tabnavigationonboardingspotlight_dismissed_jiraatlassianonboardingnav4_changed',
    nav4AtlasGlobalOnboardingModal: 'townsquare_ui_atlassianhomeonboardingnav4_dismissed_teamcentral_changed'
};

});

parcelRegister("6Lyip", function(module, exports) {

$parcel$export(module.exports, "OnboardingSpotlightMaybe", () => $ea144642b34a7c1d$export$77e61d078c8501ca);

var $5uXOq = parcelRequire("5uXOq");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $4R6GH = parcelRequire("4R6GH");
function $ea144642b34a7c1d$export$77e61d078c8501ca({ children: children, spotlight: spotlight }) {
    if (!(0, $4R6GH.fg)('blu-2735_nav4_onboarding')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    return spotlight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: spotlight
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
}

});

parcelRegister("e4A2P", function(module, exports) {

$parcel$export(module.exports, "UpdateProjectsProvider", () => $ac3747600c671f53$export$a50917f7cd2aeeda);
$parcel$export(module.exports, "useUpdateProjectsInRelayStoreContext", () => $ac3747600c671f53$export$5105901d98bfdbf1);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");
const $ac3747600c671f53$var$UpdateProjectsContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $ac3747600c671f53$export$c80374615e2c5b2 = ({ environment: environment, favouriteConnectionId: favouriteConnectionId, recentConnectionId: recentConnectionId })=>{
    const removeProjectRecord = (projectDataId)=>{
        (0, $8Uumt.commitLocalUpdate)(environment, (store)=>{
            const favorites = store.get(favouriteConnectionId);
            const recents = store.get(recentConnectionId);
            if (favorites && projectDataId) (0, $8Uumt.ConnectionHandler).deleteNode(favorites, projectDataId);
            if (recents && projectDataId) (0, $8Uumt.ConnectionHandler).deleteNode(recents, projectDataId);
        });
    };
    const archiveProject = (projectDataId)=>{
        (0, $8Uumt.commitLocalUpdate)(environment, (store)=>{
            store.get(projectDataId)?.setValue('ARCHIVED', 'status');
        });
    };
    return {
        deleteProject: removeProjectRecord,
        archiveProject: archiveProject
    };
};
const $ac3747600c671f53$export$a50917f7cd2aeeda = ({ children: children, favouriteConnectionId: favouriteConnectionId, recentConnectionId: recentConnectionId })=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const updateRelayStore = $ac3747600c671f53$export$c80374615e2c5b2({
        environment: environment,
        favouriteConnectionId: favouriteConnectionId,
        recentConnectionId: recentConnectionId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ac3747600c671f53$var$UpdateProjectsContext.Provider, {
        value: updateRelayStore
    }, children);
};
const $ac3747600c671f53$export$5105901d98bfdbf1 = ()=>(0, $5uXOq.useContext)($ac3747600c671f53$var$UpdateProjectsContext);

});

parcelRegister("1tOff", function(module, exports) {

$parcel$export(module.exports, "useSyncChangeFavourites", () => $c9898dbb4141b4e7$export$5f8a0bc021135735);

var $3DEvd = parcelRequire("3DEvd");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $e5wyW = parcelRequire("e5wyW");

var $6s1PB = parcelRequire("6s1PB");

var $kV9ss = parcelRequire("kV9ss");

var $7lK06 = parcelRequire("7lK06");

var $koeKL = parcelRequire("koeKL");
/*
Hook to trigger a mutation to reorder the projects in the sidebar when a project is starred.
This is used to ensure that the newly starred project is placed at the top of the custom order.
*/ function $c9898dbb4141b4e7$var$useSyncChangeFavouritesConditionally() {
    const cloudId = (0, $koeKL.useCloudId)();
    const [commitMutation] = (0, $8Uumt.useMutation)((0, $3DEvd.default));
    const moveFavouriteToTop = (0, $5uXOq.useCallback)((payload)=>{
        // Prevent optimistic updates from triggering setting custom order
        if (payload.type === 'MUTATION' && payload.isOptimistic) return;
        if (payload.isFavourite) {
            const itemId = (0, $kV9ss.JiraProjectAri).parse(payload.entityId).projectId;
            commitMutation({
                variables: {
                    input: {
                        cloudId: cloudId,
                        reorderMode: 'MOVE_TO_TOP',
                        menuItem: {
                            itemId: itemId
                        }
                    }
                }
            });
        }
    }, [
        cloudId,
        commitMutation
    ]);
    (0, $7lK06.useSubscribeToFavorite)('JiraProject', moveFavouriteToTop);
}
const $c9898dbb4141b4e7$export$5f8a0bc021135735 = (0, $e5wyW.functionWithCondition)(()=>(0, $6s1PB.expVal)('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false), $c9898dbb4141b4e7$var$useSyncChangeFavouritesConditionally, ()=>null);

});
parcelRegister("3DEvd", function(module, exports) {

$parcel$export(module.exports, "default", () => $b752384577373649$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5f145a9fc0e0c349898addb6947015ed>>
 * @relayHash 89d92224733780d77fbb241a74448f25
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 45ce9ebeeb324770da17f18706069599a5ab5fe6e213f56b85db3b80833a2f84

var $kXP4b = parcelRequire("kXP4b");

var $cN96Q = parcelRequire("cN96Q");

var $i2tXg = parcelRequire("i2tXg");
const $b752384577373649$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 15
        }
    ], v4 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v5 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v7 = [
        {
            "kind": "Literal",
            "name": "type",
            "value": "EDIT_PROJECT_CONFIG"
        }
    ], v8 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "syncChangeFavouritesMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_reorderProjectsSidebarMenuItem",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "Nav4ProjectMenuItem"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v6 /*: any*/ 
                            ],
                            "storageKey": "favourites(first:15)"
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "syncChangeFavouritesMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_reorderProjectsSidebarMenuItem",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "status"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectType"
                                                },
                                                {
                                                    "concreteType": "JiraAvatar",
                                                    "kind": "LinkedField",
                                                    "name": "avatar",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "large"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "defaultNavigationItem",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "url"
                                                                }
                                                            ],
                                                            "type": "JiraNavigationItem",
                                                            "abstractKey": "__isJiraNavigationItem"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v2 /*: any*/ 
                                                            ],
                                                            "type": "Node",
                                                            "abstractKey": "__isNode"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "alias": "editProjectConfig",
                                                    "args": v7 /*: any*/ ,
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": v8 /*: any*/ ,
                                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                                },
                                                {
                                                    "args": v7 /*: any*/ ,
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": v8 /*: any*/ ,
                                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectStyle"
                                                },
                                                {
                                                    "alias": "editPermission",
                                                    "args": v7 /*: any*/ ,
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": v8 /*: any*/ ,
                                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "webUrl"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "softwareBoardCount"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v6 /*: any*/ 
                            ],
                            "storageKey": "favourites(first:15)"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "45ce9ebeeb324770da17f18706069599a5ab5fe6e213f56b85db3b80833a2f84",
            "metadata": {},
            "name": "syncChangeFavouritesMutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider": (0, $kXP4b.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": (0, $cN96Q.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider": (0, $i2tXg.default)
            }
        }
    };
}();
$b752384577373649$var$node.hash = "386bc86a3d207190cfd88ada4281e551";
var $b752384577373649$export$2e2bcd8739ae039 = $b752384577373649$var$node;

});


parcelRegister("aq8kS", function(module, exports) {

$parcel$export(module.exports, "Nav4ProjectsEmptyContent", () => $960e03f6eb83ee0c$export$7a7cd6cdc84cf8eb);
/* Nav4ProjectsEmptyContent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $dS3PR = parcelRequire("dS3PR");

var $koVbs = parcelRequire("koVbs");

var $7lgBG = parcelRequire("7lgBG");

var $6m6lr = parcelRequire("6m6lr");
function $960e03f6eb83ee0c$export$7a7cd6cdc84cf8eb() {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ $5uXOq.createElement((0, $7lgBG.EmptyContentMenuItem), null, /*#__PURE__*/ $5uXOq.createElement((0, $dS3PR.default), {
        size: "small",
        color: "color.text.subtle"
    }, formatMessage((0, $6m6lr.default).emptyProjectsMessage)));
}

});
parcelRegister("6m6lr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6781a034e171c4cc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6781a034e171c4cc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    emptyProjectsMessage: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.empty-content.empty-projects-message",
        "defaultMessage": "Once you visit or create projects, they'll show up here."
    }
});

});


parcelRegister("4iaU1", function(module, exports) {

$parcel$export(module.exports, "Nav4ProjectMenuItem", () => $0448e2d1aaca7c74$export$6a41b9c2eac627cc);

var $98QWa = parcelRequire("98QWa");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $2vSU6 = parcelRequire("2vSU6");

var $i7frX = parcelRequire("i7frX");

var $enCNl = parcelRequire("enCNl");

var $38b7M = parcelRequire("38b7M");

var $5O6Px = parcelRequire("5O6Px");

var $k2PPW = parcelRequire("k2PPW");

var $Xn42p = parcelRequire("Xn42p");

var $LmW5e = parcelRequire("LmW5e");

var $cG93v = parcelRequire("cG93v");
const $0448e2d1aaca7c74$export$6a41b9c2eac627cc = (0, $LmW5e.memoWithCondition)(()=>(0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1'), ({ queryRef: queryRef, setProjectToRestore: setProjectToRestore, isCorePremiumUserSeat: isCorePremiumUserSeat = false, spotlight: spotlight })=>{
    const data = (0, $8Uumt.useFragment)((0, $98QWa.default), queryRef);
    if (!data) return null;
    if (data.status === 'ARCHIVED') return null;
    const renderMenuItem = (dragAndDropProps = {})=>{
        if ((0, $4R6GH.fg)('jcs_project_type_m3')) switch(data.projectType){
            case 0, $2vSU6.JIRA_PROJECT_TYPE_SERVICE_DESK_PROJECT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38b7M.AsyncJsmProjectMenu), {
                    projectData: data,
                    spotlight: spotlight,
                    ...dragAndDropProps
                });
            case 0, $2vSU6.JIRA_PROJECT_TYPE_CUSTOMER_SERVICE_PROJECT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5O6Px.AsyncJcsProjectMenu), {
                    projectData: data,
                    spotlight: spotlight,
                    ...dragAndDropProps
                });
            case 0, $2vSU6.JIRA_PROJECT_TYPE_PRODUCT_DISCOVERY_PROJECT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $enCNl.AsyncJpdProjectMenu), {
                    projectData: data,
                    spotlight: spotlight,
                    ...dragAndDropProps
                });
            case 0, $2vSU6.JIRA_PROJECT_TYPE_SOFTWARE_PROJECT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k2PPW.JswProjectMenu), {
                    projectData: data,
                    spotlight: spotlight,
                    ...dragAndDropProps
                });
            case 0, $2vSU6.JIRA_PROJECT_TYPE_CORE_PROJECT:
            default:
                // TODO: One day, we will call this JwmProjectMenu, and subsequently JiraProjectMenu (Spork!)
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i7frX.JiraBusinessProjectMenu), {
                    projectData: data,
                    isCorePremiumUserSeat: isCorePremiumUserSeat,
                    spotlight: spotlight,
                    ...dragAndDropProps
                });
        }
        switch(data.projectType){
            case 0, $2vSU6.JIRA_PROJECT_TYPE_SERVICE_DESK_PROJECT:
            case 0, $2vSU6.JIRA_PROJECT_TYPE_CUSTOMER_SERVICE_PROJECT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38b7M.AsyncJsmProjectMenu), {
                    projectData: data,
                    spotlight: spotlight,
                    ...dragAndDropProps
                });
            case 0, $2vSU6.JIRA_PROJECT_TYPE_PRODUCT_DISCOVERY_PROJECT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $enCNl.AsyncJpdProjectMenu), {
                    projectData: data,
                    spotlight: spotlight,
                    ...dragAndDropProps
                });
            case 0, $2vSU6.JIRA_PROJECT_TYPE_SOFTWARE_PROJECT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k2PPW.JswProjectMenu), {
                    projectData: data,
                    spotlight: spotlight,
                    ...dragAndDropProps
                });
            case 0, $2vSU6.JIRA_PROJECT_TYPE_CORE_PROJECT:
            default:
                // TODO: One day, we will call this JwmProjectMenu, and subsequently JiraProjectMenu (Spork!)
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i7frX.JiraBusinessProjectMenu), {
                    projectData: data,
                    isCorePremiumUserSeat: isCorePremiumUserSeat,
                    spotlight: spotlight,
                    ...dragAndDropProps
                });
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Xn42p.ProjectRestoreContext).Provider, {
        value: setProjectToRestore
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cG93v.Nav4ProjectMenuItemContent), {
        renderMenuItem: renderMenuItem
    }));
});

});
parcelRegister("98QWa", function(module, exports) {

$parcel$export(module.exports, "default", () => $f106e3f340d1fe74$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e12d4f314c52bc34112ad7130fbed63f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f106e3f340d1fe74$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4ProjectMenuItem",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "status"
            },
            "action": "THROW",
            "path": "status"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectType"
            },
            "action": "THROW",
            "path": "projectType"
        },
        {
            "kind": "FragmentSpread",
            "name": "JiraBusinessProjectMenu"
        },
        {
            "kind": "FragmentSpread",
            "name": "JsmProjectMenu"
        },
        {
            "kind": "FragmentSpread",
            "name": "JpdProjectMenu"
        },
        {
            "kind": "FragmentSpread",
            "name": "JswProjectMenu"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "JcsProjectMenu"
                }
            ]
        }
    ],
    "type": "JiraProject"
};
$f106e3f340d1fe74$var$node.hash = "02c3a87c3a12d872d12055c4d3fcc2b5";
var $f106e3f340d1fe74$export$2e2bcd8739ae039 = $f106e3f340d1fe74$var$node;

});

parcelRegister("i7frX", function(module, exports) {

$parcel$export(module.exports, "JiraBusinessProjectMenu", () => $1f543ab89d3e759b$export$6145b58afae943e6);

var $47xky = parcelRequire("47xky");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dcP6E = parcelRequire("dcP6E");

var $6Lyip = parcelRequire("6Lyip");

var $lpwtK = parcelRequire("lpwtK");

var $hUpXm = parcelRequire("hUpXm");

var $jhS4y = parcelRequire("jhS4y");

var $5FnJJ = parcelRequire("5FnJJ");

var $ccuaM = parcelRequire("ccuaM");

var $44kzF = parcelRequire("44kzF");

var $itmJb = parcelRequire("itmJb");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $8qvci = parcelRequire("8qvci");

var $7mPT9 = parcelRequire("7mPT9");
const $1f543ab89d3e759b$export$6145b58afae943e6 = ({ projectData: projectData, isCorePremiumUserSeat: isCorePremiumUserSeat = false, spotlight: spotlight, menuItemAnchorRef: menuItemAnchorRef })=>{
    const { sendMeatBallDropDownOnProjectsAnalyticsEvent: sendMeatBallDropDownOnProjectsAnalyticsEvent } = (0, $hUpXm.useProjectsAnalyticsL2)();
    const project = (0, $8Uumt.useFragment)((0, $47xky.default), projectData);
    const routerLinkConfig = (0, $5uXOq.useMemo)(()=>({
            to: project.defaultNavigationItem?.url ?? `/browse/${project.projectKey}`,
            prefetch: 'hover'
        }), [
        project.defaultNavigationItem?.url,
        project.projectKey
    ]);
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const hasChangeThemeFeature = isAdmin || project.editProjectConfig?.canPerform;
    // here we reference the project that is currently displayed in the main content area
    // it can be different from `project` here as `project` refers to any of the projects in the sidebar
    const { data: activeProject } = (0, $lpwtK.useProject)();
    const projectIdOrKey = String(activeProject?.key || activeProject?.id);
    const isCurrentProject = projectIdOrKey === project.projectKey || projectIdOrKey === project.projectId;
    const shouldRenderThemePicker = hasChangeThemeFeature && isCurrentProject;
    const projectActionMenuOnClickHandler = (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useCallback)(()=>{
        const isFavourite = project.isFavourite;
        const projectId = project.projectId;
        const projectType = project.projectType;
        sendMeatBallDropDownOnProjectsAnalyticsEvent({
            // TODO BLU-5544 send section via <ContextualAnalyticsData instead (which wraps the Starred or Recent panel; and each project). Use static object or useMemo, not to have rerendering issues. Then you can also use static object for meatBallDropDownOnProjectsAnalytics. See Jsm and Wanjel components
            starred: isFavourite ?? false,
            recent: !isFavourite,
            projectId: projectId,
            projectType: projectType
        });
    }, [
        project.isFavourite,
        project.projectId,
        project.projectType,
        sendMeatBallDropDownOnProjectsAnalyticsEvent
    ]) : // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useCallback)(()=>{
        const { isFavourite: isFavourite, projectId: projectId, projectType: projectType } = project;
        sendMeatBallDropDownOnProjectsAnalyticsEvent({
            // TODO BLU-5544 send section via <ContextualAnalyticsData instead (which wraps the Starred or Recent panel; and each project). Use static object or useMemo, not to have rerendering issues. Then you can also use static object for meatBallDropDownOnProjectsAnalytics. See Jsm and Wanjel components
            starred: isFavourite ?? false,
            recent: !isFavourite,
            projectId: projectId,
            projectType: projectType
        });
    }, [
        project,
        sendMeatBallDropDownOnProjectsAnalyticsEvent
    ]);
    const additionalMenuItems = (0, $5uXOq.useMemo)(()=>shouldRenderThemePicker && !!activeProject?.id && !(0, $4R6GH.fg)('project_theming_m2_fast_follow_2') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44kzF.ThemePicker), {
            projectId: activeProject.id,
            withAdaptiveColorTheme: false
        }) : undefined, [
        activeProject?.id,
        shouldRenderThemePicker
    ]);
    if ((0, $4R6GH.fg)('blu-6314-drag-and-drop-projects-sidebar-mouse')) {
        const { projectId: projectId, projectKey: projectKey, isFavourite: isFavourite, name: name, avatar: avatar } = project;
        const { state: state, draggableAnchorRef: draggableAnchorRef, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator, dragPreview: dragPreview } = // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $8qvci.useProjectMenuItemDragAndDrop)({
            projectId: projectId,
            projectKey: projectKey,
            isFavourite: isFavourite,
            name: name,
            avatar: avatar
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Lyip.OnboardingSpotlightMaybe), {
            key: project.projectKey,
            spotlight: spotlight
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
            ref: (0, $7mPT9.mergeRefs)(menuItemAnchorRef || null, draggableAnchorRef),
            visualContentRef: dropTargetRef,
            dropIndicator: dropIndicator,
            isDragging: state.type === 'dragging',
            hasDragIndicator: true,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dcP6E.ContainerAvatar), {
                src: project.avatar.large || ''
            }),
            href: routerLinkConfig,
            menuId: (0, $jhS4y.ENTITY_ID).PROJECT(project.projectKey),
            actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ccuaM.ProjectActionMenu), {
                isProjectMenuReorderingEnabled: Boolean(project.isFavourite) && (0, $6s1PB.expVal)('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false),
                projectKey: project.projectKey,
                isCorePremiumUserSeat: isCorePremiumUserSeat,
                additionalMenuItems: additionalMenuItems,
                onClick: projectActionMenuOnClickHandler
            })
        }, project.name), dragPreview);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Lyip.OnboardingSpotlightMaybe), {
        key: project.projectKey,
        spotlight: spotlight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        ref: menuItemAnchorRef,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dcP6E.ContainerAvatar), {
            src: project.avatar.large || ''
        }),
        href: routerLinkConfig,
        menuId: (0, $jhS4y.ENTITY_ID).PROJECT(project.projectKey),
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ccuaM.ProjectActionMenu), {
            isProjectMenuReorderingEnabled: Boolean(project.isFavourite) && (0, $6s1PB.expVal)('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false),
            projectKey: project.projectKey,
            isCorePremiumUserSeat: isCorePremiumUserSeat,
            additionalMenuItems: additionalMenuItems,
            onClick: projectActionMenuOnClickHandler
        })
    }, project.name));
};

});
parcelRegister("47xky", function(module, exports) {

$parcel$export(module.exports, "default", () => $26729977ea3d44a6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dac31c30fe03e7a0b37bf23913873e09>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $26729977ea3d44a6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "JiraBusinessProjectMenu",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "large"
                        },
                        "action": "THROW",
                        "path": "avatar.large"
                    }
                ]
            },
            "action": "THROW",
            "path": "avatar"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW",
            "path": "name"
        },
        {
            "kind": "RequiredField",
            "field": {
                "alias": "projectKey",
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "projectKey"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectId"
            },
            "action": "THROW",
            "path": "projectId"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectType"
            },
            "action": "THROW",
            "path": "projectType"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "LinkedField",
            "name": "defaultNavigationItem",
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        }
                    ],
                    "type": "JiraNavigationItem",
                    "abstractKey": "__isJiraNavigationItem"
                }
            ]
        },
        {
            "alias": "editProjectConfig",
            "args": [
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "EDIT_PROJECT_CONFIG"
                }
            ],
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canPerform"
                }
            ],
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        }
    ],
    "type": "JiraProject"
};
$26729977ea3d44a6$var$node.hash = "72e6a38905e40c49d04bf9ee58ef5d8f";
var $26729977ea3d44a6$export$2e2bcd8739ae039 = $26729977ea3d44a6$var$node;

});

parcelRegister("dcP6E", function(module, exports) {

$parcel$export(module.exports, "ContainerAvatar", () => $99c01944d2dda31e$export$f35a2d11bd6ae97);
/* container-avatar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $99c01944d2dda31e$var$styles = {
    root: "_2rkoiti9 _vchhusvi _4t3igktf _1bsbgktf"
};
const $99c01944d2dda31e$export$f35a2d11bd6ae97 = ({ src: src })=>/*#__PURE__*/ (0, $2OMIu.jsx)("img", {
        src: src,
        alt: "",
        className: (0, $bwpsq.default)([
            $99c01944d2dda31e$var$styles.root
        ])
    });

});

parcelRegister("ccuaM", function(module, exports) {

$parcel$export(module.exports, "ProjectActionMenu", () => $8b67ffb58d27733b$export$b71a0a4e7f29cfd6);

var $5uXOq = parcelRequire("5uXOq");

var $8U6zd = parcelRequire("8U6zd");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $3HwlS = parcelRequire("3HwlS");

var $22OQR = parcelRequire("22OQR");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");

var $03DFc = parcelRequire("03DFc");

var $bMW22 = parcelRequire("bMW22");
const $8b67ffb58d27733b$var$CustomTrigger = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const triggerButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
        ...props,
        ref: ref,
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))), {
            label: formatMessage((0, $bMW22.default).moreActions),
            color: "currentColor",
            spacing: "spacious"
        }),
        testId: "navigation-project-action-menu.ui.themed-button"
    });
    return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $bMW22.default).moreActions),
        hideTooltipOnClick: true
    }, triggerButton) : triggerButton;
});
const $8b67ffb58d27733b$export$b71a0a4e7f29cfd6 = ({ additionalMenuItems: additionalMenuItems, isProjectMenuReorderingEnabled: isProjectMenuReorderingEnabled = false, isCorePremiumUserSeat: isCorePremiumUserSeat = false, withThemedTrigger: withThemedTrigger = false, projectKey: projectKey, onClick: onClick, shouldRenderToParent: shouldRenderToParent, projectName: projectName })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $03DFc.EntryPointContent), {
        ...(0, $4R6GH.fg)('jsm_aiiy_for_nav_item_sidebar') ? {
            projectName: projectName
        } : {},
        isProjectMenuReorderingEnabled: isProjectMenuReorderingEnabled,
        additionalMenuItems: additionalMenuItems,
        onClick: onClick,
        isCorePremiumUserSeat: isCorePremiumUserSeat,
        CustomTrigger: withThemedTrigger && (0, $3HwlS.getWillShowNav4)() ? $8b67ffb58d27733b$var$CustomTrigger : undefined,
        projectKey: projectKey,
        shouldRenderToParent: shouldRenderToParent
    });
};

});
parcelRegister("22OQR", function(module, exports) {

$parcel$export(module.exports, "ThemedButton", () => $87e6157378e1cf19$export$f67fb575035cc7d0);
/* ThemedButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $2rqOp = parcelRequire("2rqOp");
const $87e6157378e1cf19$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($87e6157378e1cf19$var$CustomButton, {
        ...props,
        as: as,
        ref: ref
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $87e6157378e1cf19$var$CustomButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $2rqOp.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1qt3kjry _1g9h1tex _1umfuwj9 _6l8r3x59 _9se5176f _12rallho _zk5uzt2a _18vg2zyf _192e1jcw _fnp717ga _1xjgvy9e _1u0u14e8 _17z218zq _7n83frbu _n2ul1jo4 _1cf1r7td _1d7c1ag4 _nwukvy9e _fsjd4zrn _z1i3eyly",
            __cmplp.className
        ])
    });
});

});

parcelRegister("03DFc", function(module, exports) {

$parcel$export(module.exports, "EntryPointContent", () => $507768618964e449$export$912f81dce8d58e46);

var $5uXOq = parcelRequire("5uXOq");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $koeKL = parcelRequire("koeKL");

var $4R6GH = parcelRequire("4R6GH");

var $2oEQb = parcelRequire("2oEQb");

var $7ju32 = parcelRequire("7ju32");

var $eSIes = parcelRequire("eSIes");
const $507768618964e449$export$912f81dce8d58e46 = ({ CustomTrigger: CustomTrigger, onClick: onClick, additionalMenuItems: additionalMenuItems, isProjectMenuReorderingEnabled: isProjectMenuReorderingEnabled = false, isCorePremiumUserSeat: isCorePremiumUserSeat = false, projectKey: projectKey, shouldRenderToParent: shouldRenderToParent, projectName: projectName })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $2oEQb.projectActionMenuEntryPoint), (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            projectKey: projectKey
        }), [
        cloudId,
        projectKey
    ]));
    const buttonTriggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    const content = (0, $5uXOq.useCallback)((contentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "project-actions-menu-popup-content",
            packageName: "jira-navigation-apps-project-action-menu",
            runtimeProps: (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $5uXOq.useMemo)(()=>({
                    isCorePremiumUserSeat: isCorePremiumUserSeat,
                    additionalMenuItems: additionalMenuItems,
                    isProjectMenuReorderingEnabled: isProjectMenuReorderingEnabled,
                    contentProps: contentProps
                }), [
                contentProps
            ]) : {
                isCorePremiumUserSeat: isCorePremiumUserSeat,
                additionalMenuItems: additionalMenuItems,
                isProjectMenuReorderingEnabled: isProjectMenuReorderingEnabled,
                contentProps: contentProps
            },
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eSIes.Skeleton), null)
        }), [
        entryPointReferenceSubject,
        additionalMenuItems,
        isCorePremiumUserSeat,
        isProjectMenuReorderingEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ju32.MenuContainer), {
        ...(0, $4R6GH.fg)('jsm_aiiy_for_nav_item_sidebar') ? {
            projectName: projectName
        } : {},
        content: content,
        CustomTrigger: CustomTrigger,
        onClick: onClick,
        buttonTriggerRef: buttonTriggerRef,
        shouldRenderToParent: shouldRenderToParent
    });
};

});
parcelRegister("2oEQb", function(module, exports) {

$parcel$export(module.exports, "projectActionMenuEntryPoint", () => $a5951ff1cd0da4db$export$30ec6de22da54fa0);

var $lvLIW = parcelRequire("lvLIW");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");
const $a5951ff1cd0da4db$var$fetchPolicy = 'network-only';

const $a5951ff1cd0da4db$export$30ec6de22da54fa0 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("8aDfc")).then((module)=>module.AsyncMenuWithQuery), {
        moduleId: "eb74dcae",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectKey: projectKey })=>{
        const projectActionMenuQuery = {
            parameters: (0, $lvLIW.default),
            variables: {
                cloudId: cloudId,
                projectKey: projectKey
            },
            options: {
                fetchPolicy: $a5951ff1cd0da4db$var$fetchPolicy
            }
        };
        return {
            queries: {
                projectActionMenuQuery: projectActionMenuQuery
            }
        };
    }
});

});
parcelRegister("lvLIW", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f29594fd996b113$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d360e49d5eb693192c7fbc1eac496f85>>
 * @relayHash a9a48f3ed05422d23cacd580dcce751d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e05d6d8357d9d7fabad007766bd445c51b79afe818cc226061c1c9209b8fd76e
const $8f29594fd996b113$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "e05d6d8357d9d7fabad007766bd445c51b79afe818cc226061c1c9209b8fd76e",
        "metadata": {},
        "name": "async_AsyncMenuContentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $8f29594fd996b113$export$2e2bcd8739ae039 = $8f29594fd996b113$var$node;

});

parcelRegister("8aDfc", function(module, exports) {

let $5f2db2f8f08676e3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5f2db2f8f08676e3$var$load("6KG9e").then(()=>parcelRequire('aSeFh'));

});


parcelRegister("7ju32", function(module, exports) {

$parcel$export(module.exports, "MenuContainer", () => $12b2a0349669ab51$export$b286f91cddfedb5a);

var $5uXOq = parcelRequire("5uXOq");

var $3HwlS = parcelRequire("3HwlS");

var $cDvOQ = parcelRequire("cDvOQ");

var $6jY6G = parcelRequire("6jY6G");

var $jgJNO = parcelRequire("jgJNO");

var $4R6GH = parcelRequire("4R6GH");

var $1aCfv = parcelRequire("1aCfv");
const $12b2a0349669ab51$export$b286f91cddfedb5a = ({ content: content, CustomTrigger: CustomTrigger, onClick: onClick, onClose: onCloseCustom, buttonTriggerRef: buttonTriggerRef, shouldRenderToParent: shouldRenderToParent = true, projectName: projectName })=>{
    const { isOpen: isOpen, onClose: onClose, onToggle: onToggle } = (0, $cDvOQ.useOpenable)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const handleClose = (0, $5uXOq.useCallback)((e)=>{
        try {
            onCloseCustom?.(e);
        } finally{
            onClose();
        }
    }, [
        onCloseCustom,
        onClose
    ]);
    const onClickHandler = (0, $5uXOq.useCallback)(()=>{
        onToggle();
        onClick?.();
    }, [
        onClick,
        onToggle
    ]);
    const trigger = (triggerProps)=>{
        const { ref: ref, ...restTriggerProps } = triggerProps;
        return CustomTrigger ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CustomTrigger, {
            isSelected: isOpen,
            onClick: onClickHandler,
            ref: (element)=>{
                buttonTriggerRef && buttonTriggerRef(element);
                if (typeof ref === 'function') ref(element);
            },
            ...restTriggerProps
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1aCfv.MenuTriggerButton), {
            ...(0, $4R6GH.fg)('jsm_aiiy_for_nav_item_sidebar') ? {
                name: projectName
            } : {},
            isSelected: isOpen,
            onClick: onClickHandler,
            ref: (element)=>{
                buttonTriggerRef && buttonTriggerRef(element);
                if (typeof ref === 'function') ref(element);
            },
            ...restTriggerProps
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        content: content,
        isOpen: isOpen,
        onClose: handleClose,
        placement: "bottom-start",
        messageId: "navigation-project-action-menu.ui.menu-container.popup",
        messageType: "transactional",
        trigger: trigger,
        shouldRenderToParent: // eslint-disable-next-line no-nested-ternary
        (0, $3HwlS.getWillShowNav4)() ? route.name.includes('legacy') ? false : shouldRenderToParent : true,
        strategy: (0, $3HwlS.getWillShowNav4)() ? 'absolute' : 'fixed'
    });
};

});
parcelRegister("1aCfv", function(module, exports) {

$parcel$export(module.exports, "MenuTriggerButton", () => $697832058741b131$export$a24e6f6ddd974e33);

var $5uXOq = parcelRequire("5uXOq");

var $8U6zd = parcelRequire("8U6zd");

var $42CjB = parcelRequire("42CjB");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $UPOcN = parcelRequire("UPOcN");
const $697832058741b131$export$a24e6f6ddd974e33 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onClick: onClick, name: name, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        ...props,
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))), {
                ...iconProps,
                color: "var(--ds-icon, #44546F)",
                size: "small"
            }),
        label: (0, $4R6GH.fg)('jsm_aiiy_for_nav_item_sidebar') ? formatMessage((0, $UPOcN.default).projectActionsMenuName, {
            name: name
        }) : formatMessage((0, $UPOcN.default).projectActionsMenu),
        onClick: onClick,
        ref: ref,
        spacing: "compact",
        appearance: "subtle",
        testId: "navigation-project-action-menu.ui.menu-container.themed-button",
        ...(0, $dCm1o.isVisualRefreshEnabled)() ? {
            isTooltipDisabled: false,
            tooltip: {
                content: formatMessage((0, $UPOcN.default).projectActionsMenu),
                hideTooltipOnClick: true
            }
        } : {}
    });
});

});
parcelRegister("UPOcN", function(module, exports) {

$parcel$export(module.exports, "default", () => $5484f6b90ae9d06c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5484f6b90ae9d06c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    projectActionsMenu: {
        "id": "navigation-project-action-menu.menu-container.project-actions-menu",
        "defaultMessage": "More actions"
    },
    projectActionsMenuName: {
        "id": "navigation-project-action-menu.menu-container.project-actions-menu-name",
        "defaultMessage": "More actions for {name}"
    }
});

});



parcelRegister("eSIes", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $618f6270b8f60e9b$export$8f31e4c4a37b8e9c);

var $5uXOq = parcelRequire("5uXOq");

var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");
var $iwwXK = parcelRequire("iwwXK");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $4DrQd = parcelRequire("4DrQd");
const $618f6270b8f60e9b$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $618f6270b8f60e9b$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), {
        minWidth: (0, $4DrQd.MENU_GROUP_MIN_WIDTH)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        isList: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        hasIcon: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        isList: true,
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        hasIcon: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $618f6270b8f60e9b$var$projectTileSkeleton
    }))));
const $618f6270b8f60e9b$var$wrapperStyles = (0, $8CUq3.xcss)({
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    inlineSize: `${(0, $4DrQd.MENU_GROUP_MIN_WIDTH)}px`
});
const $618f6270b8f60e9b$var$projectTileSkeleton = (0, $8CUq3.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-600, 48px)",
    flex: 1
});

});


parcelRegister("bMW22", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5136b67e6c38f9a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f5136b67e6c38f9a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    projectSettings: {
        "id": "navigation-project-action-menu.project-settings",
        "defaultMessage": "Project settings"
    },
    moreActions: {
        "id": "navigation-project-action-menu.more-actions",
        "defaultMessage": "More actions"
    }
});

});


parcelRegister("44kzF", function(module, exports) {

$parcel$export(module.exports, "ThemePicker", () => $f5453100331219b3$export$75505f096a733fb9);

var $5uXOq = parcelRequire("5uXOq");

var $jgJNO = parcelRequire("jgJNO");

var $kV9ss = parcelRequire("kV9ss");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $kaHBi = parcelRequire("kaHBi");

var $pa9q9 = parcelRequire("pa9q9");

var $7VHMR = parcelRequire("7VHMR");

var $g8I5C = parcelRequire("g8I5C");

var $6jY6G = parcelRequire("6jY6G");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ky2ui = parcelRequire("ky2ui");

var $koeKL = parcelRequire("koeKL");

var $jpH5a = parcelRequire("jpH5a");

var $ca7Zi = parcelRequire("ca7Zi");

var $lwRIP = parcelRequire("lwRIP");

var $3LH0C = parcelRequire("3LH0C");

var $gHWtm = parcelRequire("gHWtm");

var $9yzIq = parcelRequire("9yzIq");
const $f5453100331219b3$var$SOURCE_NAME = 'projectThemePicker';
const $f5453100331219b3$var$messages = (0, $7VHMR.defineMessages)({
    errorFlagTitle: {
        "id": "business-theme-components.theme-picker.error-flag-title",
        "defaultMessage": "Something's gone wrong"
    },
    errorFlagDescription: {
        "id": "business-theme-components.theme-picker.error-flag-description",
        "defaultMessage": "Our team has been notified. If the problem persists, please contact Atlassian Support."
    }
});
const $f5453100331219b3$export$bb0d35c1fc48487f = {
    id: 'open-theme-picker-error',
    type: 'error',
    title: $f5453100331219b3$var$messages.errorFlagTitle,
    description: $f5453100331219b3$var$messages.errorFlagDescription,
    isAutoDismiss: true,
    messageId: 'project-theme-components.ui.theme-picker.popup-entrypoint-error-flag.error.open-theme-picker-error',
    messageType: 'transactional'
};
const $f5453100331219b3$export$75505f096a733fb9 = /*#__PURE__*/ (0, $5uXOq.memo)(({ projectId: projectId, withAdaptiveColorTheme: withAdaptiveColorTheme, shouldRenderToParent: shouldRenderToParent = true })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const projectAri = (0, $kV9ss.JiraProjectAri).create({
        siteId: cloudId,
        projectId: String(projectId)
    }).toString();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $gHWtm.backgroundPickerPopupContentEntryPoint), (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            projectAri: projectAri
        }), [
        cloudId,
        projectAri
    ]));
    const startExperience = (0, $kaHBi.useExperienceStart)((0, $jpH5a.VIEW_THEME_PICKER_EXPERIENCE));
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const [flagShown, setFlagShown] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isThemePickerOpen, setIsThemePickerOpen] = (0, $5uXOq.useState)(false);
    const toggleThemePicker = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (_, analyticsEvent)=>{
        // If we are about to open the theme picker, start the experience
        if (!isThemePickerOpen) startExperience();
        setIsThemePickerOpen((oldValue)=>!oldValue);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent ?? createAnalyticsEvent({}), 'button clicked', 'themePickerButton');
        setFlagShown(false);
    }, [
        isThemePickerOpen,
        startExperience,
        setIsThemePickerOpen,
        createAnalyticsEvent
    ]);
    const renderNudgeWrapper = (0, $5uXOq.useCallback)((children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ky2ui.BackgroundColourNudgeAsync), null, children), []);
    const buttonTrigger = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions, !isThemePickerOpen);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            onOpenChange: setIsThemePickerOpen,
            withAdaptiveColorTheme: withAdaptiveColorTheme
        }), [
        setIsThemePickerOpen,
        withAdaptiveColorTheme
    ]);
    const trigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3LH0C.ThemePickerButtonItem), {
            ...triggerProps,
            isSelected: isThemePickerOpen,
            testId: "project-theme-components.ui.theme-picker.trigger",
            ref: (element)=>{
                buttonTrigger(element);
                if (typeof triggerProps.ref === 'function') triggerProps.ref(element);
            },
            onClick: toggleThemePicker
        }), [
        buttonTrigger,
        isThemePickerOpen,
        toggleThemePicker
    ]);
    const errorFallback = (0, $5uXOq.useCallback)(({ error: error })=>{
        if (!flagShown) {
            showFlag($f5453100331219b3$export$bb0d35c1fc48487f);
            setFlagShown(true);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ca7Zi.ExperienceFailed), {
            experience: (0, $jpH5a.VIEW_THEME_PICKER_EXPERIENCE),
            error: error
        });
    }, [
        flagShown,
        showFlag
    ]);
    const content = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "background-picker-popup-content",
            packageName: "@atlassian/jira-project-theme-components",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yzIq.ThemePickerSkeleton), null),
            errorFallback: errorFallback,
            runtimeProps: runtimeProps
        }), [
        errorFallback,
        entryPointReferenceSubject,
        runtimeProps
    ]);
    const onCloseHandler = (0, $5uXOq.useCallback)(()=>setIsThemePickerOpen(false), [
        setIsThemePickerOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g8I5C.QuickstartNudge), {
        renderWrapper: renderNudgeWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: $f5453100331219b3$var$SOURCE_NAME,
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isThemePickerOpen,
        onClose: onCloseHandler,
        shouldRenderToParent: route.name.includes('legacy') ? false : shouldRenderToParent,
        content: content,
        trigger: trigger,
        placement: "right-start",
        id: (0, $lwRIP.THEME_PICKER_ELEMENT_ID),
        messageId: "project-theme-components.ui.theme-picker.popup.theme-picker",
        messageType: "transactional"
    })));
});

});
parcelRegister("g8I5C", function(module, exports) {

$parcel$export(module.exports, "QuickstartNudge", () => $0174d522ba9dfb06$export$bd61ee610c74db6c);

var $5uXOq = parcelRequire("5uXOq");

var $6OJ73 = parcelRequire("6OJ73");

var $axUP7 = parcelRequire("axUP7");
const $0174d522ba9dfb06$export$bd61ee610c74db6c = (0, $axUP7.withNestingOptimisation)(({ renderWrapper: renderWrapper, children: children })=>{
    const isFullyExpanded = (0, $6OJ73.useIsFullyExpanded)();
    return isFullyExpanded ? renderWrapper(children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
});

});
parcelRegister("6OJ73", function(module, exports) {

$parcel$export(module.exports, "useIsFullyExpanded", () => $c20291d4f7970c77$export$7212b6b01271f5d1);

var $5uXOq = parcelRequire("5uXOq");

var $gPQRI = parcelRequire("gPQRI");
const $c20291d4f7970c77$var$TIMEOUT = 500;
const $c20291d4f7970c77$export$7212b6b01271f5d1 = ()=>{
    const [ready, setReady] = (0, $5uXOq.useState)(false);
    const { isCollapsed: isCollapsed } = (0, $gPQRI.useLeftSidebarState)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            setReady(!isCollapsed);
        }, $c20291d4f7970c77$var$TIMEOUT);
        return ()=>clearTimeout(timeoutId);
    }, [
        isCollapsed
    ]);
    return ready && !isCollapsed;
};

});
parcelRegister("gPQRI", function(module, exports) {

$parcel$export(module.exports, "useLeftSidebarState", () => $b19712b3cdd78134$export$610d81e163a897b3);
$parcel$export(module.exports, "useLeftSidebarController", () => $b19712b3cdd78134$export$900f29014a48fb23);

var $5uXOq = parcelRequire("5uXOq");

var $iqLcb = parcelRequire("iqLcb");

var $3sQ5x = parcelRequire("3sQ5x");

var $5e5zm = parcelRequire("5e5zm");
const $b19712b3cdd78134$var$useSweetStateLeftSidebarState = (0, $3sQ5x.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>({
            ...state.content.leftSidebar,
            shouldRender: !state.isChromeless
        })
});
const $b19712b3cdd78134$export$610d81e163a897b3 = ()=>{
    const [leftSidebar] = $b19712b3cdd78134$var$useSweetStateLeftSidebarState();
    return leftSidebar;
};
const $b19712b3cdd78134$export$900f29014a48fb23 = ()=>{
    const { expandLeftSidebar: expandLeftSidebar, collapseLeftSidebar: collapseLeftSidebar } = (0, $iqLcb.usePageLayoutResize)();
    return (0, $5uXOq.useMemo)(()=>({
            collapseLeftSidebar: collapseLeftSidebar,
            expandLeftSidebar: expandLeftSidebar
        }), [
        collapseLeftSidebar,
        expandLeftSidebar
    ]);
};

});
parcelRegister("iqLcb", function(module, exports) {

$parcel$export(module.exports, "PageLayout", () => $3d7d84f3bc65155e$export$6d1402fb58384e4f);
$parcel$export(module.exports, "Banner", () => $3d7d84f3bc65155e$export$3b4e64e77073e307);
$parcel$export(module.exports, "TopNavigation", () => $3d7d84f3bc65155e$export$8a421bddecb2bf5b);
$parcel$export(module.exports, "LeftPanel", () => $3d7d84f3bc65155e$export$110709f040143804);
$parcel$export(module.exports, "LeftSidebar", () => $3d7d84f3bc65155e$export$3cabf771c4f2de);
$parcel$export(module.exports, "Main", () => $3d7d84f3bc65155e$export$861edd1ccea2f746);
$parcel$export(module.exports, "Content", () => $3d7d84f3bc65155e$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "RightSidebar", () => $3d7d84f3bc65155e$export$84d58c19c21f637f);
$parcel$export(module.exports, "RightPanel", () => $3d7d84f3bc65155e$export$364a989a35814102);
$parcel$export(module.exports, "useCustomSkipLink", () => $3d7d84f3bc65155e$export$ee6b12c2613bdf8e);
$parcel$export(module.exports, "useLeftSidebarFlyoutLock", () => $3d7d84f3bc65155e$export$94561f6055639ef7);
$parcel$export(module.exports, "usePageLayoutResize", () => $3d7d84f3bc65155e$export$10c7104037a7af62);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_BANNER_HEIGHT", () => $3d7d84f3bc65155e$export$991ef8098f87814a);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_PANEL_WIDTH", () => $3d7d84f3bc65155e$export$7eaf986ecb4d5cac);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_SIDEBAR_WIDTH", () => $3d7d84f3bc65155e$export$e95b388ca8c92019);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_PANEL_WIDTH", () => $3d7d84f3bc65155e$export$2ab8b83eed76656c);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_SIDEBAR_WIDTH", () => $3d7d84f3bc65155e$export$ac017575d43f5da);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT", () => $3d7d84f3bc65155e$export$d697087c06fd5e25);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $4ZIaA = parcelRequire("4ZIaA");
var $c8E4X = parcelRequire("c8E4X");
var $eX4XX = parcelRequire("eX4XX");
var $aKz2G = parcelRequire("aKz2G");
var $aj7M6 = parcelRequire("aj7M6");
var $kUAkd = parcelRequire("kUAkd");
var $3WK4F = parcelRequire("3WK4F");
var $4CWca = parcelRequire("4CWca");
var $9xmqY = parcelRequire("9xmqY");
var $31ERv = parcelRequire("31ERv");
var $cIcFn = parcelRequire("cIcFn");
var $j3yGs = parcelRequire("j3yGs");

var $2MLVq = parcelRequire("2MLVq");
var $jjRN8 = parcelRequire("jjRN8");
var $hOWCC = parcelRequire("hOWCC");
var $ZlCus = parcelRequire("ZlCus");
var $1EWMr = parcelRequire("1EWMr");
var $kTus1 = parcelRequire("kTus1");
var $7g4r8 = parcelRequire("7g4r8");

var $3HwlS = parcelRequire("3HwlS");
function $3d7d84f3bc65155e$export$6d1402fb58384e4f(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1EWMr.Root), {
        UNSAFE_dangerouslyHoistSlotSizes: true,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3WK4F.default), props);
}
function $3d7d84f3bc65155e$export$3b4e64e77073e307(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jjRN8.Banner), {
        height: props.height,
        testId: props.testId,
        id: props.id
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4ZIaA.default), props);
}
function $3d7d84f3bc65155e$export$8a421bddecb2bf5b(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7g4r8.TopNav), {
        height: props.height,
        testId: props.testId,
        UNSAFE_theme: props.theme
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $31ERv.default), props);
}
function $3d7d84f3bc65155e$export$110709f040143804(props) {
    // LeftPanel is not supported in new page layout
    return (0, $3HwlS.getWillShowNav4)() ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eX4XX.default), props);
}
function $3d7d84f3bc65155e$export$43ae342508cf8cc9(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kTus1.SideNav), {
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aj7M6.default), props);
}
function $3d7d84f3bc65155e$export$3cabf771c4f2de(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kTus1.SideNav), {
        defaultCollapsed: props.collapsedState === 'collapsed',
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aKz2G.default), props);
}
function $3d7d84f3bc65155e$export$861edd1ccea2f746(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hOWCC.Main), {
        isFixed: props.isFixed,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kUAkd.default), props);
}
function $3d7d84f3bc65155e$export$7c6e2c02157bb7d2(props) {
    return (0, $3HwlS.getWillShowNav4)() ? // There isn't a concept of a `Content` wrapper component in the new page layout
    props.children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c8E4X.default), props);
}
function $3d7d84f3bc65155e$export$84d58c19c21f637f(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2MLVq.Aside), {
        isFixed: props.isFixed,
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9xmqY.default), props);
}
function $3d7d84f3bc65155e$export$364a989a35814102(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ZlCus.Panel), {
        xcss: $3d7d84f3bc65155e$var$rightPanelStyles.root,
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CWca.default), props);
}
const $3d7d84f3bc65155e$export$ee6b12c2613bdf8e = (id, title, index)=>(0, $3HwlS.getWillShowNav4)() ? {} : // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $cIcFn.useCustomSkipLink)(id, title, index);
const $3d7d84f3bc65155e$export$94561f6055639ef7 = ()=>(0, $3HwlS.getWillShowNav4)() ? {} : // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $j3yGs.useLeftSidebarFlyoutLock)();
// A mock value is needed to match the signature of the hook
const $3d7d84f3bc65155e$var$mockPageLayoutResize = {
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    collapseLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    leftSidebarState: {
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true,
        hasInit: false
    },
    setLeftSidebarState: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    toggleLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $3d7d84f3bc65155e$export$10c7104037a7af62 = ()=>(0, $3HwlS.getWillShowNav4)() ? $3d7d84f3bc65155e$var$mockPageLayoutResize : // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $j3yGs.usePageLayoutResize)();
const $3d7d84f3bc65155e$var$rightPanelStyles = {
    root: "_bfhk1bhr"
};
const $3d7d84f3bc65155e$export$991ef8098f87814a = (0, $565cb8192fc4e070$export$ed7cc0d417ee89e);
const $3d7d84f3bc65155e$export$7eaf986ecb4d5cac = (0, $565cb8192fc4e070$export$f963aecf2d4465bd);
const $3d7d84f3bc65155e$export$e95b388ca8c92019 = (0, $565cb8192fc4e070$export$f897e1ed9f8ed251);
const $3d7d84f3bc65155e$export$2ab8b83eed76656c = (0, $565cb8192fc4e070$export$750459958906793);
const $3d7d84f3bc65155e$export$ac017575d43f5da = (0, $565cb8192fc4e070$export$b44ab66843c05a69);
const $3d7d84f3bc65155e$export$d697087c06fd5e25 = (0, $565cb8192fc4e070$export$aeff86a16f13529);

});
parcelRegister("4ZIaA", function(module, exports) {

$parcel$export(module.exports, "default", () => $046aa419aa6d0212$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $8XpIo = parcelRequire("8XpIo");

var $2Pb5D = parcelRequire("2Pb5D");
var $amcy7 = parcelRequire("amcy7");

var $fZqMW = parcelRequire("fZqMW");

var $jUxG6 = parcelRequire("jUxG6");
const $046aa419aa6d0212$var$bannerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $565cb8192fc4e070$export$ed7cc0d417ee89e),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $565cb8192fc4e070$export$238d30785c4bca84)
});
const $046aa419aa6d0212$var$bannerFixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    position: 'fixed',
    zIndex: 2,
    insetBlockStart: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: (0, $565cb8192fc4e070$export$750459958906793),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: (0, $565cb8192fc4e070$export$f963aecf2d4465bd)
});
/**
 * __Banner__
 *
 * Provides a slot for a Banner within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $046aa419aa6d0212$var$Banner = (props)=>{
    const { children: children, height: height = (0, $565cb8192fc4e070$export$be83e7118304b28e), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, skipLinkTitle: skipLinkTitle, id: id } = props;
    const bannerHeight = (0, $8XpIo.resolveDimension)((0, $565cb8192fc4e070$export$bcd94a6a792e7f96), height, shouldPersistHeight);
    (0, $5uXOq.useEffect)(()=>{
        (0, $2Pb5D.default)({
            [(0, $565cb8192fc4e070$export$bcd94a6a792e7f96)]: bannerHeight
        });
        return ()=>{
            (0, $2Pb5D.default)({
                [(0, $565cb8192fc4e070$export$bcd94a6a792e7f96)]: 0
            });
        };
    }, [
        bannerHeight
    ]);
    (0, $amcy7.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fZqMW.default), null, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                $046aa419aa6d0212$var$bannerStyles,
                isFixed && $046aa419aa6d0212$var$bannerFixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $8XpIo.getPageLayoutSlotSelector)('banner')
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jUxG6.default), {
            variableName: (0, $565cb8192fc4e070$export$bcd94a6a792e7f96),
            value: bannerHeight
        }), children));
};
var $046aa419aa6d0212$export$2e2bcd8739ae039 = $046aa419aa6d0212$var$Banner;

});
parcelRegister("8XpIo", function(module, exports) {

$parcel$export(module.exports, "mergeGridStateIntoStorage", () => $45f0612699d6a600$export$f8355a2df0f4a946);
$parcel$export(module.exports, "getGridStateFromStorage", () => $45f0612699d6a600$export$d95e99d8116d17dc);
$parcel$export(module.exports, "removeFromGridStateInStorage", () => $45f0612699d6a600$export$17e3760e0b35f1cd);
$parcel$export(module.exports, "resolveDimension", () => $45f0612699d6a600$export$74732e47915c7839);
$parcel$export(module.exports, "getLeftPanelWidth", () => $45f0612699d6a600$export$b089e01213f07bd);
$parcel$export(module.exports, "getLeftSidebarPercentage", () => $45f0612699d6a600$export$2bca58b6ee823bf7);
$parcel$export(module.exports, "getPageLayoutSlotSelector", () => $45f0612699d6a600$export$e895e3e8b708ae2a);
$parcel$export(module.exports, "getPageLayoutSlotCSSSelector", () => $45f0612699d6a600$export$218ece2c32b7db0e);


var $1Dapo = parcelRequire("1Dapo");
const $45f0612699d6a600$export$f8355a2df0f4a946 = (key, value)=>{
    const storageValue = JSON.parse((0, $1Dapo.default)().getItem((0, $565cb8192fc4e070$export$451e84a45a9e4a75)) || '{}');
    if (value !== null && typeof value === 'object') storageValue[key] = {
        ...storageValue[key],
        ...value
    };
    else storageValue[key] = value;
    (0, $1Dapo.default)().setItem((0, $565cb8192fc4e070$export$451e84a45a9e4a75), JSON.stringify(storageValue));
};
const $45f0612699d6a600$export$d95e99d8116d17dc = (key)=>{
    const storageValue = JSON.parse((0, $1Dapo.default)().getItem((0, $565cb8192fc4e070$export$451e84a45a9e4a75)) || '{}');
    return storageValue[key];
};
const $45f0612699d6a600$export$17e3760e0b35f1cd = (key, secondKey)=>{
    const storageValue = JSON.parse((0, $1Dapo.default)().getItem((0, $565cb8192fc4e070$export$451e84a45a9e4a75)) || '{}');
    if (secondKey && storageValue[key]) delete storageValue[key][secondKey];
    else delete storageValue[key];
    (0, $1Dapo.default)().setItem((0, $565cb8192fc4e070$export$451e84a45a9e4a75), JSON.stringify(storageValue));
};
const $45f0612699d6a600$export$74732e47915c7839 = (key, dimension = 0, shouldPersist = false)=>{
    if (shouldPersist) {
        const cachedGridState = $45f0612699d6a600$export$d95e99d8116d17dc('gridState');
        return cachedGridState && Object.keys(cachedGridState).length > 0 && cachedGridState[key] ? cachedGridState[key] : dimension;
    }
    return dimension;
};
const $45f0612699d6a600$export$b089e01213f07bd = ()=>{
    if (typeof window === 'undefined') return 0;
    return parseInt(window.getComputedStyle(document.documentElement).getPropertyValue(`--${(0, $565cb8192fc4e070$export$f963aecf2d4465bd)}`), 10) || 0;
};
const $45f0612699d6a600$export$2bca58b6ee823bf7 = (currentWidth, maxWidth)=>{
    const total = (currentWidth - (0, $565cb8192fc4e070$export$539e68c09584883a)) / (maxWidth - (0, $565cb8192fc4e070$export$539e68c09584883a));
    if (total < 0) return 0;
    if (total > 1) return 100;
    return Math.floor(total * 100);
};
const $45f0612699d6a600$export$e895e3e8b708ae2a = (slotName)=>({
        [(0, $565cb8192fc4e070$export$5253dd9707b8c3ba)]: slotName
    });
const $45f0612699d6a600$export$218ece2c32b7db0e = (slotName)=>`[${0, $565cb8192fc4e070$export$5253dd9707b8c3ba}='${slotName}']`;

});
parcelRegister("1Dapo", function(module, exports) {

$parcel$export(module.exports, "default", () => $8542dfb7c79e1b98$export$2e2bcd8739ae039);
// Reliably test against conditions like
// localStorage being full or private mode in Safari being a .
// https://gist.github.com/paulirish/5558557
const $8542dfb7c79e1b98$var$isLocalStorageSupported = ()=>{
    try {
        // use an random key to test
        // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
        const testKey = `__test_${Date.now()}__`;
        localStorage.setItem(testKey, testKey);
        localStorage.removeItem(testKey);
        return true;
    } catch (e) {
        return false;
    }
};
const $8542dfb7c79e1b98$var$safeLocalStorage = ()=>{
    if ($8542dfb7c79e1b98$var$isLocalStorageSupported()) return localStorage;
    // Returning a mock object here in the case that this is run in SSR mode
    if (typeof window === 'undefined') return {
        getItem: (_key)=>null,
        setItem: (_key, _value)=>null,
        removeItem: (_key)=>null,
        clear: ()=>null,
        key: (_index)=>null,
        get length () {
            return 0;
        }
    };
    if (window.__localStorageFallback && Object.keys(window.__localStorageFallback).length !== 0) return window.__localStorageFallback;
    const storageAPI = {
        getItem: (key)=>{
            if (window.__localStorageFallback.hasOwnProperty(key)) return window.__localStorageFallback[key];
            return null;
        },
        setItem: (key, value)=>{
            window.__localStorageFallback[key] = String(value);
        },
        removeItem: (key)=>{
            delete window.__localStorageFallback[key];
        },
        clear: ()=>{
            for(const key in window.__localStorageFallback)if (window.__localStorageFallback.hasOwnProperty(key)) delete window.__localStorageFallback[key];
        },
        get length () {
            if (!window.__localStorageFallback) return 0;
            return Object.keys(window.__localStorageFallback).length;
        }
    };
    window.__localStorageFallback = Object.create(storageAPI);
    return window.__localStorageFallback;
};
var $8542dfb7c79e1b98$export$2e2bcd8739ae039 = $8542dfb7c79e1b98$var$safeLocalStorage;

});


parcelRegister("2Pb5D", function(module, exports) {

$parcel$export(module.exports, "default", () => $69aa5d485af555af$export$2e2bcd8739ae039);

var $8XpIo = parcelRequire("8XpIo");
const $69aa5d485af555af$var$publishGridState = (gridState)=>{
    Object.entries(gridState).forEach(([slotName, value])=>{
        if (!value) {
            document.documentElement.style.removeProperty(`--${slotName}`);
            (0, $8XpIo.removeFromGridStateInStorage)('gridState', slotName);
            return;
        }
        //Update the css variable
        document.documentElement.style.setProperty(`--${slotName}`, `${value}px`);
        // also update state in local storage so that
        // it persists across page refresh, across tabs etc
        (0, $8XpIo.mergeGridStateIntoStorage)('gridState', {
            [slotName]: value
        });
    });
};
var $69aa5d485af555af$export$2e2bcd8739ae039 = $69aa5d485af555af$var$publishGridState;

});

parcelRegister("amcy7", function(module, exports) {

$parcel$export(module.exports, "SkipLinksContext", () => $9d139aaa63675775$export$4c5cc3b14c7678a);
$parcel$export(module.exports, "useSkipLinks", () => $9d139aaa63675775$export$c9d9cb2ee9590f87);
$parcel$export(module.exports, "useSkipLink", () => $9d139aaa63675775$export$89d9323301efc7d6);

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");
const $9d139aaa63675775$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $5uXOq.createContext)({
    skipLinksData: [],
    registerSkipLink: (0, $eGmKJ.default),
    unregisterSkipLink: (0, $eGmKJ.default)
});
const $9d139aaa63675775$export$c9d9cb2ee9590f87 = ()=>(0, $5uXOq.useContext)($9d139aaa63675775$export$4c5cc3b14c7678a);
const $9d139aaa63675775$export$89d9323301efc7d6 = (id, skipLinkTitle)=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = $9d139aaa63675775$export$c9d9cb2ee9590f87();
    (0, $5uXOq.useEffect)(()=>{
        if (id && skipLinkTitle) registerSkipLink({
            id: id,
            skipLinkTitle: skipLinkTitle
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        skipLinkTitle,
        registerSkipLink,
        unregisterSkipLink
    ]);
};

});

parcelRegister("fZqMW", function(module, exports) {

$parcel$export(module.exports, "default", () => $be1b215f3de827c6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

const $be1b215f3de827c6$var$focusStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div': {
            boxShadow: `0px 0px 0px 2px inset ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`,
            outline: 'none'
        }
    }
});
/**
 * Sidebars have an outer and inner component,
 * so the nested selector needs to target an extra level deeper.
 */ const $be1b215f3de827c6$var$sidebarFocusStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div > div': {
            boxShadow: `0px 0px 0px 2px inset ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`,
            outline: 'none'
        }
    }
});
/**
 * We don't use `@atlaskit/focus-ring` here,
 * because we need inset focus styles and:
 *
 * 1. If we set them directly to the layout element,
 *    then any child element's background will cover the shadow.
 * 2. We cannot wrap `children` in `FocusRing`,
 *    because there's no guarantee the passed child takes `className`.
 */ const $be1b215f3de827c6$var$SlotFocusRing = ({ children: children, isSidebar: isSidebar = false })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $f8Sb3.ClassNames), null, ({ css: css })=>children({
            className: isSidebar ? css($be1b215f3de827c6$var$sidebarFocusStyles) : css($be1b215f3de827c6$var$focusStyles)
        }));
};
var $be1b215f3de827c6$export$2e2bcd8739ae039 = $be1b215f3de827c6$var$SlotFocusRing;

});

parcelRegister("jUxG6", function(module, exports) {

$parcel$export(module.exports, "default", () => $16bb67776ddc8896$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $h9kUS = parcelRequire("h9kUS");
/**
 * Hoists slot dimension styles to the root element.
 */ const $16bb67776ddc8896$var$SlotDimensions = ({ variableName: variableName, value: value, mobileValue: mobileValue })=>{
    /**
	 * Note don't put multiple variables in multiple lines. eg
	 * <style>
	 *   {css1}
	 *   {css2}
	 * </style>
	 *
	 * React will insert an empty HTML comment in between the text in SSR.
	 * This is not a valid tag and will break the page.
	 * <style>foo<!-- -->bar</style>
	 */ let style = `:root{--${variableName}:${value}px;}`;
    if (mobileValue) style += ` ${(0, $h9kUS.UNSAFE_media).below.sm} { :root{--${variableName}:${mobileValue}px;} }`;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)("style", {
        children: style
    }));
};
var $16bb67776ddc8896$export$2e2bcd8739ae039 = $16bb67776ddc8896$var$SlotDimensions;

});


parcelRegister("c8E4X", function(module, exports) {

$parcel$export(module.exports, "default", () => $a355cc90b3ba1759$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

const $a355cc90b3ba1759$var$contentStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $565cb8192fc4e070$export$d1213e82613ff4df)
});
/**
 * __Content__
 *
 * Provides a slot for your application content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $a355cc90b3ba1759$var$Content = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-testid": testId,
        css: $a355cc90b3ba1759$var$contentStyles
    }, children);
};
var $a355cc90b3ba1759$export$2e2bcd8739ae039 = $a355cc90b3ba1759$var$Content;

});

parcelRegister("eX4XX", function(module, exports) {

$parcel$export(module.exports, "default", () => $0feeff252d3697c9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $8XpIo = parcelRequire("8XpIo");

var $2Pb5D = parcelRequire("2Pb5D");
var $amcy7 = parcelRequire("amcy7");

var $fZqMW = parcelRequire("fZqMW");

var $jUxG6 = parcelRequire("jUxG6");
const $0feeff252d3697c9$var$leftPanelStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $565cb8192fc4e070$export$344062f7cfc9528e)
});
const $0feeff252d3697c9$var$leftPanelFixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $565cb8192fc4e070$export$f963aecf2d4465bd),
    position: 'fixed',
    insetBlockEnd: 0,
    insetBlockStart: 0,
    insetInlineStart: 0
});
/**
 * __Left panel__
 *
 * Provides a slot for a left panel within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $0feeff252d3697c9$var$LeftPanel = (props)=>{
    const { children: children, isFixed: isFixed, width: width = (0, $565cb8192fc4e070$export$c4d6152f86ea28f6), shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const leftPanelWidth = (0, $8XpIo.resolveDimension)((0, $565cb8192fc4e070$export$cbfb0f5b2869b17b), width, shouldPersistWidth);
    (0, $5uXOq.useEffect)(()=>{
        (0, $2Pb5D.default)({
            [(0, $565cb8192fc4e070$export$cbfb0f5b2869b17b)]: leftPanelWidth
        });
        return ()=>{
            (0, $2Pb5D.default)({
                [(0, $565cb8192fc4e070$export$cbfb0f5b2869b17b)]: 0
            });
        };
    }, [
        leftPanelWidth
    ]);
    (0, $amcy7.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fZqMW.default), null, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                $0feeff252d3697c9$var$leftPanelStyles,
                isFixed && $0feeff252d3697c9$var$leftPanelFixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $8XpIo.getPageLayoutSlotSelector)('left-panel')
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jUxG6.default), {
            variableName: (0, $565cb8192fc4e070$export$cbfb0f5b2869b17b),
            value: leftPanelWidth
        }), children));
};
var $0feeff252d3697c9$export$2e2bcd8739ae039 = $0feeff252d3697c9$var$LeftPanel;

});

parcelRegister("aKz2G", function(module, exports) {

$parcel$export(module.exports, "default", () => $24d471261e665f40$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $71YXv = parcelRequire("71YXv");


var $oGXFy = parcelRequire("oGXFy");



var $8XpIo = parcelRequire("8XpIo");

var $2Pb5D = parcelRequire("2Pb5D");
var $j3yGs = parcelRequire("j3yGs");
var $amcy7 = parcelRequire("amcy7");

var $b8DIB = parcelRequire("b8DIB");

var $2QObc = parcelRequire("2QObc");

var $aY3ai = parcelRequire("aY3ai");

var $1hxaZ = parcelRequire("1hxaZ");

var $jUxG6 = parcelRequire("jUxG6");
const $24d471261e665f40$var$openBackdropStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: '100%',
    height: '100%',
    position: 'absolute',
    background: `var(--ds-blanket, ${(0, $829f609a65d26a98$export$486ab785e4bac3c6)})`,
    opacity: 1
});
const $24d471261e665f40$var$hiddenBackdropStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    opacity: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `opacity ${(0, $565cb8192fc4e070$export$3749e1104328fde4)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`
});
/**
 * __Left sidebar__
 *
 * Provides a slot for a left sidebar within the PageLayout.
 *
 * On smaller viewports, the left sidebar can no longer be expanded.  Instead, expanding it will
 * put it into our "flyout mode" to lay overtop (which in desktop is explicitly a hover state).
 * This ensures the contents behind do not reflow oddly and allows for a better experience
 * resizing between mobile and desktop.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $24d471261e665f40$var$LeftSidebar = (props)=>{
    const { children: children, width: width, isFixed: isFixed = true, valueTextLabel: valueTextLabel, resizeButtonLabel: resizeButtonLabel, resizeGrabAreaLabel: resizeGrabAreaLabel, overrides: overrides, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, onFlyoutExpand: onFlyoutExpand, onFlyoutCollapse: onFlyoutCollapse, testId: testId, id: id, skipLinkTitle: skipLinkTitle, collapsedState: collapsedState } = props;
    const flyoutTimerRef = (0, $5uXOq.useRef)();
    const mouseOverEventRef = (0, $5uXOq.useRef)();
    const leftSideBarRef = (0, $5uXOq.useRef)(null);
    const { leftSidebarState: leftSidebarState, setLeftSidebarState: setLeftSidebarState } = (0, $5uXOq.useContext)((0, $j3yGs.SidebarResizeContext));
    const { isFlyoutOpen: isFlyoutOpen, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isLeftSidebarCollapsed: isLeftSidebarCollapsed, leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth, hasInit: hasInit } = leftSidebarState;
    const isLocked = flyoutLockCount > 0;
    const isLockedRef = (0, $5uXOq.useRef)(isLocked);
    const mouseXRef = (0, $5uXOq.useRef)(0);
    const handlerRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        isLockedRef.current = isLocked;
        // I tried a one-time `mousemove` handler that gets attached
        // when the lock releases. This is not robust because
        // the mouse can stay still after release (e.g. using keyboard)
        // and the sidebar will erroneously stay open.
        //
        // The following solution is likely less performant but more robust.
        if (isLocked && !handlerRef.current) {
            handlerRef.current = (event)=>{
                mouseXRef.current = event.clientX;
            };
            document.addEventListener('mousemove', handlerRef.current);
        }
        if (!isLocked && handlerRef.current) {
            if (mouseXRef.current >= lastLeftSidebarWidth) setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: false
                }));
            document.removeEventListener('mousemove', handlerRef.current);
            handlerRef.current = null;
        }
        return ()=>{
            if (handlerRef.current) document.removeEventListener('mousemove', handlerRef.current);
        };
    }, [
        isLocked,
        lastLeftSidebarWidth,
        setLeftSidebarState
    ]);
    const _width = Math.max(width || 0, (0, $565cb8192fc4e070$export$539e68c09584883a));
    const collapsedStateOverrideOpen = collapsedState === 'expanded';
    let leftSidebarWidthOnMount;
    if (collapsedStateOverrideOpen) leftSidebarWidthOnMount = (0, $8XpIo.resolveDimension)((0, $565cb8192fc4e070$export$b6744d31294864fd), _width, !width);
    else if (isLeftSidebarCollapsed || collapsedState === 'collapsed') leftSidebarWidthOnMount = (0, $565cb8192fc4e070$export$46acf8758e9e2636);
    else leftSidebarWidthOnMount = (0, $8XpIo.resolveDimension)((0, $565cb8192fc4e070$export$a30f2e00489a8957), _width, !width || !collapsedStateOverrideOpen && (0, $8XpIo.getGridStateFromStorage)('isLeftSidebarCollapsed'));
    // Update state from cache on mount
    (0, $5uXOq.useEffect)(()=>{
        const cachedCollapsedState = !collapsedStateOverrideOpen && (collapsedState === 'collapsed' || (0, $8XpIo.getGridStateFromStorage)('isLeftSidebarCollapsed') || false);
        const cachedGridState = (0, $8XpIo.getGridStateFromStorage)('gridState') || {};
        let leftSidebarWidth = !width && cachedGridState[0, $565cb8192fc4e070$export$b6744d31294864fd] ? Math.max(cachedGridState[0, $565cb8192fc4e070$export$b6744d31294864fd], (0, $565cb8192fc4e070$export$539e68c09584883a)) : _width;
        const lastLeftSidebarWidth = !width && cachedGridState[0, $565cb8192fc4e070$export$b6744d31294864fd] ? Math.max(cachedGridState[0, $565cb8192fc4e070$export$b6744d31294864fd], (0, $565cb8192fc4e070$export$539e68c09584883a)) : _width;
        if (cachedCollapsedState) leftSidebarWidth = (0, $565cb8192fc4e070$export$46acf8758e9e2636);
        setLeftSidebarState({
            isFlyoutOpen: false,
            isResizing: isResizing,
            isLeftSidebarCollapsed: cachedCollapsedState,
            leftSidebarWidth: leftSidebarWidth,
            lastLeftSidebarWidth: lastLeftSidebarWidth,
            flyoutLockCount: 0,
            isFixed: isFixed,
            hasInit: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Every time other than mount,
    // update the local storage and css variables.
    const notFirstRun = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (notFirstRun.current) {
            (0, $2Pb5D.default)({
                [(0, $565cb8192fc4e070$export$a30f2e00489a8957)]: leftSidebarWidth || leftSidebarWidthOnMount,
                [(0, $565cb8192fc4e070$export$b6744d31294864fd)]: lastLeftSidebarWidth
            });
            (0, $8XpIo.mergeGridStateIntoStorage)('isLeftSidebarCollapsed', isLeftSidebarCollapsed);
        }
        if (!notFirstRun.current) notFirstRun.current = true;
        return ()=>{
            removeMouseOverListener();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        id
    ]);
    const onMouseOver = (event)=>{
        const isMouseOnResizeButton = event.target.matches(`[${(0, $565cb8192fc4e070$export$dac2fb31a9f6844d)}]`) || event.target.matches(`[${(0, $565cb8192fc4e070$export$dac2fb31a9f6844d)}] *`);
        if (isFlyoutOpen || isMouseOnResizeButton || !isLeftSidebarCollapsed) return;
        event.persist();
        flyoutTimerRef.current && clearTimeout(flyoutTimerRef.current);
        if (!mouseOverEventRef.current) mouseOverEventRef.current = (event)=>{
            const leftSidebar = leftSideBarRef.current;
            if (leftSidebar === null || isLockedRef.current) return;
            if (!leftSidebar.contains(event.target)) {
                flyoutTimerRef.current && clearTimeout(flyoutTimerRef.current);
                onFlyoutCollapse && onFlyoutCollapse();
                setLeftSidebarState((current)=>({
                        ...current,
                        isFlyoutOpen: false
                    }));
                removeMouseOverListener();
            }
        };
        document.addEventListener('mouseover', mouseOverEventRef.current, {
            capture: true,
            passive: true
        });
        flyoutTimerRef.current = setTimeout(()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: true
                }));
            onFlyoutExpand && onFlyoutExpand();
        }, (0, $565cb8192fc4e070$export$1074d925b0b82be5));
    };
    const removeMouseOverListener = ()=>{
        mouseOverEventRef.current && document.removeEventListener('mouseover', mouseOverEventRef.current, {
            capture: true,
            passive: true
        });
    };
    (0, $amcy7.useSkipLink)(id, skipLinkTitle);
    const onMouseLeave = (event)=>{
        const isMouseOnResizeButton = event.target.matches(`[${(0, $565cb8192fc4e070$export$dac2fb31a9f6844d)}]`) || event.target.matches(`[${(0, $565cb8192fc4e070$export$dac2fb31a9f6844d)}] *`);
        if (isMouseOnResizeButton || !isLeftSidebarCollapsed || flyoutLockCount > 0) return;
        onFlyoutCollapse && onFlyoutCollapse();
        setTimeout(()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: false
                }));
        }, (0, $565cb8192fc4e070$export$1074d925b0b82be5));
    };
    const mobileMediaQuery = (0, $oGXFy.UNSAFE_useMediaQuery)('below.sm');
    const openMobileFlyout = (0, $5uXOq.useCallback)(()=>{
        if (!mobileMediaQuery?.matches) return;
        setLeftSidebarState((current)=>{
            if (current.isFlyoutOpen) return current;
            return {
                ...current,
                isFlyoutOpen: true
            };
        });
    }, [
        setLeftSidebarState,
        mobileMediaQuery
    ]);
    const closeMobileFlyout = (0, $5uXOq.useCallback)(()=>{
        if (!mobileMediaQuery?.matches) return;
        setLeftSidebarState((current)=>{
            if (!current.isFlyoutOpen) return current;
            return {
                ...current,
                isFlyoutOpen: false
            };
        });
    }, [
        setLeftSidebarState,
        mobileMediaQuery
    ]);
    (0, $oGXFy.UNSAFE_useMediaQuery)('below.sm', (event)=>{
        setLeftSidebarState((current)=>{
            if (event.matches && !current.isLeftSidebarCollapsed) // Sidebar was previously open when resizing downwards, convert the sidebar being open to a flyout being open
            return {
                ...current,
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $565cb8192fc4e070$export$46acf8758e9e2636),
                lastLeftSidebarWidth: current.leftSidebarWidth,
                isFlyoutOpen: true
            };
            else if (!event.matches && current.isFlyoutOpen) // The user is resizing "upwards", eg. going from mobile to desktop.
            // Flyout was previously open, let's keep it open by moving to the un-collapsed sidebar instead
            return {
                ...current,
                isResizing: false,
                isLeftSidebarCollapsed: false,
                leftSidebarWidth: Math.max(current.lastLeftSidebarWidth, (0, $565cb8192fc4e070$export$539e68c09584883a)),
                isFlyoutOpen: false
            };
            return current;
        });
    });
    // Close the flyout when the "escape" key is pressed.
    (0, $71YXv.default)({
        onClose: closeMobileFlyout,
        isDisabled: !isFlyoutOpen
    });
    /**
   * We use both the state and our effect-based ref to protect animation until initialized fully
   */ const isReady = hasInit && notFirstRun.current;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, mobileMediaQuery?.matches && /**
     * On desktop, the `onClick` handlers controls the temporary flyout behavior.
     * This is an intentionally mouse-only experience, it may even be disruptive with keyboard navigation.
     *
     * On mobile, the `onClick` handler controls the toggled flyout behaviour.
     * This is not intended to be how you use this with a keyboard, there is a ResizeButton for this intentionally instead.
     */ // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $24d471261e665f40$var$hiddenBackdropStyles,
            isFlyoutOpen && $24d471261e665f40$var$openBackdropStyles
        ],
        onClick: closeMobileFlyout
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aY3ai.default), {
        ref: leftSideBarRef,
        testId: testId,
        onMouseOver: !mobileMediaQuery?.matches ? onMouseOver : undefined,
        onMouseLeave: !mobileMediaQuery?.matches ? onMouseLeave : undefined,
        onClick: mobileMediaQuery?.matches ? openMobileFlyout : undefined,
        id: id,
        isFixed: isFixed
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jUxG6.default), {
        variableName: (0, $565cb8192fc4e070$export$a30f2e00489a8957),
        value: isReady ? leftSidebarWidth : leftSidebarWidthOnMount,
        mobileValue: (0, $565cb8192fc4e070$export$70740f5ad8360a78)
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2QObc.default), {
        isFixed: isFixed,
        isFlyoutOpen: isFlyoutOpen
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1hxaZ.default), {
        isFlyoutOpen: isFlyoutOpen,
        isLeftSidebarCollapsed: isLeftSidebarCollapsed,
        hasCollapsedState: !isReady && collapsedState === 'collapsed',
        testId: testId && `${testId}-resize-children-wrapper`
    }, children), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $b8DIB.default), {
        testId: testId,
        valueTextLabel: valueTextLabel,
        resizeGrabAreaLabel: resizeGrabAreaLabel,
        resizeButtonLabel: resizeButtonLabel,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        onResizeStart: onResizeStart,
        onResizeEnd: onResizeEnd
    }))));
};
var $24d471261e665f40$export$2e2bcd8739ae039 = $24d471261e665f40$var$LeftSidebar;

});
const $eba99f58997c09b3$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $eba99f58997c09b3$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $eba99f58997c09b3$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
const $eba99f58997c09b3$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';

parcelRegister("oGXFy", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useMediaQuery", () => $76ca3f4294719aa5$export$49e55ae2c03d6045);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $7yA6J = parcelRequire("7yA6J");

var $h9kUS = parcelRequire("h9kUS");
const $76ca3f4294719aa5$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).below.xl.replace('@media ', '').trim())
};
const $76ca3f4294719aa5$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $5uXOq.useRef)(listener);
    (0, $5uXOq.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
	 * We explicitly only react to boolean changes for binding our listener
	 * Changes to the functional reference are ignored.
	 */ const hasListener = !!listener;
    /**
	 * The `matchMedia(…)` return value for our breakpoint query.
	 */ const mq = $76ca3f4294719aa5$var$queries[queryString];
    (0, $7yA6J.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $cBeZP.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});

parcelRegister("j3yGs", function(module, exports) {

$parcel$export(module.exports, "SidebarResizeContext", () => $423fcd7a7dc715d5$export$aa5a712eea4c2ae8);
$parcel$export(module.exports, "usePageLayoutResize", () => $423fcd7a7dc715d5$export$10c7104037a7af62);
$parcel$export(module.exports, "useLeftSidebarFlyoutLock", () => $423fcd7a7dc715d5$export$94561f6055639ef7);

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");
const $423fcd7a7dc715d5$var$leftSidebarState = {
    isFlyoutOpen: false,
    isResizing: false,
    isLeftSidebarCollapsed: false,
    leftSidebarWidth: 0,
    lastLeftSidebarWidth: 0,
    flyoutLockCount: 0,
    isFixed: true,
    hasInit: false
};
const $423fcd7a7dc715d5$export$aa5a712eea4c2ae8 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, $eGmKJ.default),
    collapseLeftSidebar: (0, $eGmKJ.default),
    leftSidebarState: $423fcd7a7dc715d5$var$leftSidebarState,
    setLeftSidebarState: (0, $eGmKJ.default),
    toggleLeftSidebar: (0, $eGmKJ.default)
});
const $423fcd7a7dc715d5$export$10c7104037a7af62 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState, ...context } = (0, $5uXOq.useContext)($423fcd7a7dc715d5$export$aa5a712eea4c2ae8);
    return context;
};
const $423fcd7a7dc715d5$export$94561f6055639ef7 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState } = (0, $5uXOq.useContext)($423fcd7a7dc715d5$export$aa5a712eea4c2ae8);
    (0, $5uXOq.useEffect)(()=>{
        setLeftSidebarState((current)=>({
                ...current,
                flyoutLockCount: current.flyoutLockCount + 1
            }));
        return ()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    flyoutLockCount: current.flyoutLockCount - 1
                }));
        };
    }, [
        setLeftSidebarState
    ]);
};

});

parcelRegister("b8DIB", function(module, exports) {

$parcel$export(module.exports, "default", () => $035100f87b948476$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $cBeZP = parcelRequire("cBeZP");

var $7nRxN = parcelRequire("7nRxN");

var $oGXFy = parcelRequire("oGXFy");


var $8XpIo = parcelRequire("8XpIo");

var $j3yGs = parcelRequire("j3yGs");

var $gYx5U = parcelRequire("gYx5U");

var $7nOWs = parcelRequire("7nOWs");

var $3bMab = parcelRequire("3bMab");
function $035100f87b948476$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $035100f87b948476$var$cssSelector = {
    [(0, $565cb8192fc4e070$export$9ecd22db14e6c70e)]: true
};
const $035100f87b948476$var$resizeControlStyles = {
    name: "ow3ovp",
    styles: "position:absolute;inset-block-end:0;inset-block-start:0;inset-inline-start:100%;outline:none"
};
const $035100f87b948476$var$showResizeButtonStyles = {
    name: "1a6byq5",
    styles: "--ds--resize-button--opacity:1"
};
// @ts-expect-error adding `!important` to style rules is currently a type error
const $035100f87b948476$var$globalResizingStyles = {
    name: "e4avm6",
    styles: "*{cursor:ew-resize !important;user-select:none !important;}iframe{pointer-events:none !important;}"
};
const $035100f87b948476$var$ResizeControl = ({ testId: testId, overrides: overrides, resizeButtonLabel: resizeButtonLabel = 'Current project sidebar', valueTextLabel: valueTextLabel = 'Width', resizeGrabAreaLabel: resizeGrabAreaLabel = 'Resize Current Project Sidebar', onResizeStart: onResizeStart, onResizeEnd: onResizeEnd })=>{
    const { toggleLeftSidebar: toggleLeftSidebar, collapseLeftSidebar: collapseLeftSidebar, leftSidebarState: leftSidebarState, setLeftSidebarState: setLeftSidebarState } = (0, $5uXOq.useContext)((0, $j3yGs.SidebarResizeContext));
    const { isLeftSidebarCollapsed: isLeftSidebarCollapsed } = leftSidebarState;
    const sidebarWidth = (0, $5uXOq.useRef)(leftSidebarState[0, $565cb8192fc4e070$export$a30f2e00489a8957]);
    // Distance of mouse from left sidebar onMouseDown
    const offset = (0, $5uXOq.useRef)(0);
    const keyboardEventTimeout = (0, $5uXOq.useRef)();
    const [isGrabAreaFocused, setIsGrabAreaFocused] = (0, $5uXOq.useState)(false);
    const unbindEvents = (0, $5uXOq.useRef)(null);
    const mobileMediaQuery = (0, $oGXFy.UNSAFE_useMediaQuery)('below.sm');
    // Used in some cases to ensure function references don't have to change
    // TODO: more functions could use `stableSidebarState` rather than `leftSidebarState`
    const stableSidebarState = (0, $5uXOq.useRef)(leftSidebarState);
    (0, $5uXOq.useEffect)(()=>{
        stableSidebarState.current = leftSidebarState;
    }, [
        leftSidebarState
    ]);
    const toggleSideBar = (0, $5uXOq.useCallback)((event)=>{
        // don't cascade down to the LeftSidebarOuter
        event?.stopPropagation();
        toggleLeftSidebar();
    }, [
        toggleLeftSidebar
    ]);
    const onMouseDown = (event)=>{
        if (isLeftSidebarCollapsed) return;
        // Only allow left (primary) clicks to trigger resize as we've received
        // bug reports about right click unexpectedly beginning a resize.
        if (event.button !== 0) return;
        // It is possible for a mousedown to fire during a resize
        // Example: the user presses another pointer button while dragging
        if (leftSidebarState.isResizing) // the resize will be cancelled by our global event listeners
        return;
        offset.current = event.clientX - leftSidebarState[0, $565cb8192fc4e070$export$a30f2e00489a8957] - (0, $8XpIo.getLeftPanelWidth)();
        unbindEvents.current = (0, $cBeZP.bindAll)(window, [
            {
                type: 'mousemove',
                listener: function(event) {
                    onUpdateResize({
                        clientX: event.clientX
                    });
                }
            },
            {
                type: 'mouseup',
                listener: onFinishResizing
            },
            {
                type: 'mousedown',
                // this mousedown event listener is being added in the bubble phase
                // on a higher event target than the resize handle.
                // This means that the original mousedown event that triggers a resize
                // can hit this mousedown handler. To get around that, we only call
                // `onFinishResizing` after an animation frame so we don't pick up the original event
                // Alternatives:
                // 1. Add the window 'mousedown' event listener in the capture phase
                // 👎 A 'mousedown' during a resize would trigger a new resize to start
                // 2. Do 1. and call `event.preventDefault()`, then check for `event.defaultPrevented` inside
                // the grab handle `onMouseDown`
                // 👎 Not ideal to cancel events if we don't have to
                listener: (()=>{
                    let hasFramePassed = false;
                    requestAnimationFrame(()=>{
                        hasFramePassed = true;
                    });
                    return function listener() {
                        if (hasFramePassed) onFinishResizing();
                    };
                })()
            },
            {
                type: 'visibilitychange',
                listener: onFinishResizing
            },
            // A 'click' event should never be hit as the 'mouseup' will come first and cause
            // these event listeners to be unbound. I just added 'click' for extreme safety (paranoia)
            {
                type: 'click',
                listener: onFinishResizing
            },
            {
                type: 'keydown',
                listener: (event)=>{
                    // Can cancel resizing by pressing "Escape"
                    // Will return sidebar to the same size it was before the resizing started
                    if (event.key === 'Escape') {
                        sidebarWidth.current = Math.max(leftSidebarState.lastLeftSidebarWidth, (0, $565cb8192fc4e070$export$46acf8758e9e2636));
                        document.documentElement.style.setProperty(`--${(0, $565cb8192fc4e070$export$a30f2e00489a8957)}`, `${sidebarWidth.current}px`);
                        onFinishResizing();
                    }
                }
            }
        ]);
        document.documentElement.setAttribute((0, $565cb8192fc4e070$export$802bb2c050f3db5c), 'true');
        const newLeftbarState = {
            ...leftSidebarState,
            isResizing: true
        };
        setLeftSidebarState(newLeftbarState);
        onResizeStart && onResizeStart(newLeftbarState);
    };
    const onResizeOffLeftOfScreen = ()=>{
        onUpdateResize.cancel();
        unbindEvents.current?.();
        unbindEvents.current = null;
        document.documentElement.removeAttribute((0, $565cb8192fc4e070$export$802bb2c050f3db5c));
        offset.current = 0;
        collapseLeftSidebar(undefined, true);
    };
    // It is important that `onUpdateResize` is a stable function reference, so that:
    // 1. we ensure we are correctly throttling with `requestAnimationFrame`
    // 2. that a `onUpdateResize` will cancel the one and only pending frame
    // To help ensure `onUpdateResize` is stable, we are putting the last state into a ref
    const [onUpdateResize] = (0, $5uXOq.useState)(()=>(0, $7nRxN.default)(({ clientX: clientX })=>{
            // Allow the sidebar to be 50% of the available page width
            const maxWidth = Math.round(window.innerWidth / 2);
            const leftPanelWidth = (0, $8XpIo.getLeftPanelWidth)();
            const leftSidebarWidth = stableSidebarState.current.leftSidebarWidth;
            const hasResizedOffLeftOfScreen = clientX < 0;
            if (hasResizedOffLeftOfScreen) {
                onResizeOffLeftOfScreen();
                return;
            }
            const delta = Math.max(Math.min(clientX - leftSidebarWidth - leftPanelWidth, maxWidth - leftSidebarWidth - leftPanelWidth), (0, $565cb8192fc4e070$export$46acf8758e9e2636) - leftSidebarWidth - leftPanelWidth);
            sidebarWidth.current = Math.max(leftSidebarWidth + delta - offset.current, (0, $565cb8192fc4e070$export$46acf8758e9e2636));
            document.documentElement.style.setProperty(`--${(0, $565cb8192fc4e070$export$a30f2e00489a8957)}`, `${sidebarWidth.current}px`);
        }));
    const onFinishResizing = ()=>{
        if (isLeftSidebarCollapsed) return;
        document.documentElement.removeAttribute((0, $565cb8192fc4e070$export$802bb2c050f3db5c));
        // TODO: the control flow is pretty strange as the first codepath which calls `collapseLeftSidebar()`
        // does not return an updated state snapshot.
        let updatedLeftSidebarState = null;
        // If it is dragged to below the threshold,
        // collapse the navigation
        if (sidebarWidth.current < (0, $565cb8192fc4e070$export$6949d4f32b161684)) {
            // TODO: for this codepath, `onCollapse` occurs before `onResizeEnd` which seems wrong
            document.documentElement.style.setProperty(`--${(0, $565cb8192fc4e070$export$a30f2e00489a8957)}`, `${(0, $565cb8192fc4e070$export$46acf8758e9e2636)}px`);
            collapseLeftSidebar(undefined, true);
        } else if (sidebarWidth.current > (0, $565cb8192fc4e070$export$6949d4f32b161684) && sidebarWidth.current < (0, $565cb8192fc4e070$export$539e68c09584883a)) {
            document.documentElement.style.setProperty(`--${(0, $565cb8192fc4e070$export$a30f2e00489a8957)}`, `${(0, $565cb8192fc4e070$export$539e68c09584883a)}px`);
            updatedLeftSidebarState = {
                ...leftSidebarState,
                isResizing: false,
                [(0, $565cb8192fc4e070$export$a30f2e00489a8957)]: (0, $565cb8192fc4e070$export$539e68c09584883a),
                lastLeftSidebarWidth: (0, $565cb8192fc4e070$export$539e68c09584883a)
            };
            setLeftSidebarState(updatedLeftSidebarState);
        } else {
            // otherwise resize it to the desired width
            updatedLeftSidebarState = {
                ...leftSidebarState,
                isResizing: false,
                [(0, $565cb8192fc4e070$export$a30f2e00489a8957)]: sidebarWidth.current,
                lastLeftSidebarWidth: sidebarWidth.current
            };
            setLeftSidebarState(updatedLeftSidebarState);
        }
        unbindEvents.current?.();
        unbindEvents.current = null;
        onUpdateResize.cancel();
        sidebarWidth.current = 0;
        offset.current = 0;
        // TODO: no idea why this is in an animation frame
        requestAnimationFrame(()=>{
            setIsGrabAreaFocused(false);
            // Note: the `collapseSidebar` codepath does not return state, so we need to pull it from the ref
            onResizeEnd?.(updatedLeftSidebarState ?? stableSidebarState.current);
        });
    };
    const onKeyDown = (event)=>{
        if (isLeftSidebarCollapsed || !isGrabAreaFocused) return false;
        const { key: key } = event;
        const isLeftOrTopArrow = key === 'ArrowLeft' || key === 'ArrowUp' || key === 'Left' || key === 'Up';
        const isRightOrBottomArrow = key === 'ArrowRight' || key === 'ArrowDown' || key === 'Right' || key === 'Down';
        const isSpaceOrEnter = key === 'Enter' || key === 'Spacebar' || key === ' ';
        if (isSpaceOrEnter) {
            toggleSideBar(event);
            event.preventDefault();
        }
        if (isLeftOrTopArrow || isRightOrBottomArrow) {
            event.preventDefault(); // prevent content scroll
            onResizeStart && onResizeStart(leftSidebarState);
            const step = 10;
            const stepValue = isLeftOrTopArrow ? -step : step;
            const { leftSidebarWidth: leftSidebarWidth } = leftSidebarState;
            const maxWidth = Math.round(window.innerWidth / 2) - (0, $8XpIo.getLeftPanelWidth)();
            const hasModifierKey = event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;
            let width = leftSidebarWidth + stepValue;
            if (width <= (0, $565cb8192fc4e070$export$539e68c09584883a)) {
                width = (0, $565cb8192fc4e070$export$539e68c09584883a);
                document.documentElement.style.setProperty(`--${(0, $565cb8192fc4e070$export$a30f2e00489a8957)}`, `${(0, $565cb8192fc4e070$export$539e68c09584883a) - 20}px`);
            } else if (width > maxWidth) {
                width = maxWidth;
                document.documentElement.style.setProperty(`--${(0, $565cb8192fc4e070$export$a30f2e00489a8957)}`, `${maxWidth + 20}px`);
            } else if (hasModifierKey) width = isRightOrBottomArrow ? maxWidth : (0, $565cb8192fc4e070$export$539e68c09584883a);
            // Nesting the setTimeout within requestAnimationFrame helps
            // the browser schedule the setTimeout call in an efficient manner
            requestAnimationFrame(()=>{
                keyboardEventTimeout.current = window.setTimeout(()=>{
                    keyboardEventTimeout.current && clearTimeout(keyboardEventTimeout.current);
                    document.documentElement.style.setProperty(`--${(0, $565cb8192fc4e070$export$a30f2e00489a8957)}`, `${width}px`);
                    const updatedLeftSidebarState = {
                        ...leftSidebarState,
                        [(0, $565cb8192fc4e070$export$a30f2e00489a8957)]: width,
                        lastLeftSidebarWidth: width
                    };
                    setLeftSidebarState(updatedLeftSidebarState);
                    onResizeEnd && onResizeEnd(updatedLeftSidebarState);
                }, 50);
            });
        }
    };
    const onFocus = (0, $5uXOq.useCallback)(()=>{
        setIsGrabAreaFocused(true);
    }, []);
    const onBlur = (0, $5uXOq.useCallback)(()=>{
        setIsGrabAreaFocused(false);
    }, []);
    const resizeButton = {
        render: (Component, props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)(Component, props),
        ...overrides && overrides.ResizeButton
    };
    // This width is calculated once only on mount.
    // This means resizing the window will cause this value to be incorrect for screen reader users,
    // however this comes with a substantial performance gain and so is considered acceptable.
    const maxAriaWidth = (0, $5uXOq.useMemo)(()=>{
        const innerWidth = typeof window === 'undefined' ? 0 : window.innerWidth;
        return Math.round(innerWidth / 2) - (0, $8XpIo.getLeftPanelWidth)();
    }, []);
    const leftSidebarPercentageExpanded = (0, $8XpIo.getLeftSidebarPercentage)(leftSidebarState.leftSidebarWidth, maxAriaWidth);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...$035100f87b948476$var$cssSelector,
        css: [
            $035100f87b948476$var$resizeControlStyles,
            (isGrabAreaFocused || isLeftSidebarCollapsed) && $035100f87b948476$var$showResizeButtonStyles
        ]
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bMab.default), {
        testId: testId && `${testId}-shadow`
    }), // Only show the GrabArea if we're not on the mobile viewport
    !mobileMediaQuery?.matches && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gYx5U.default), {
        isDisabled: isLeftSidebarCollapsed,
        isLeftSidebarCollapsed: isLeftSidebarCollapsed,
        label: resizeGrabAreaLabel,
        valueTextLabel: valueTextLabel,
        leftSidebarPercentageExpanded: leftSidebarPercentageExpanded,
        onBlur: onBlur,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        testId: testId && `${testId}-grab-area`
    }), resizeButton.render((0, $7nOWs.default), {
        isLeftSidebarCollapsed: mobileMediaQuery?.matches ? !leftSidebarState.isFlyoutOpen : isLeftSidebarCollapsed,
        label: resizeButtonLabel,
        onClick: toggleSideBar,
        testId: testId && `${testId}-resize-button`
    })), leftSidebarState.isResizing ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $f8Sb3.Global), {
        styles: $035100f87b948476$var$globalResizingStyles
    }) : null);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$035100f87b948476$export$2e2bcd8739ae039 = $035100f87b948476$var$ResizeControl;

});
parcelRegister("gYx5U", function(module, exports) {

$parcel$export(module.exports, "default", () => $859a4bb5bdb6af39$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");


function $859a4bb5bdb6af39$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Determines the color of the grab line.
 *
 * Used on internal leaf node, so naming collisions won't matter.
 */ const $859a4bb5bdb6af39$var$varLineColor = '--ds-line';
const $859a4bb5bdb6af39$var$grabAreaStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: "var(--ds-space-200, 16px)",
    height: '100%',
    padding: 0,
    backgroundColor: 'transparent',
    border: 0,
    cursor: 'ew-resize',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    '&:focus': {
        outline: 0
    },
    '&:enabled:hover, &:enabled:focus, &:enabled:active': {
        [$859a4bb5bdb6af39$var$varLineColor]: `var(--ds-border-selected, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`
    }
});
const $859a4bb5bdb6af39$var$grabAreaCollapsedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    height: `calc(100% - ${"var(--ds-space-600, 3rem)"} * 2)`,
    padding: 0,
    position: 'absolute',
    backgroundColor: 'transparent',
    border: 0,
    cursor: 'default',
    insetBlockEnd: 0
});
const $859a4bb5bdb6af39$var$lineStyles = {
    name: "w4swnc",
    styles: "display:block;width:var(--ds-border-width-outline, 2px);height:100%;background-color:var(--ds-line);transition:background-color 200ms"
};
const $859a4bb5bdb6af39$var$grabAreaLineSelector = {
    [(0, $565cb8192fc4e070$export$70c702a8c5895f03)]: true
};
const $859a4bb5bdb6af39$var$grabAreaSelector = {
    [(0, $565cb8192fc4e070$export$48a43f91e4becf4e)]: true
};
const $859a4bb5bdb6af39$var$GrabArea = ({ testId: testId, valueTextLabel: valueTextLabel = 'Width', isDisabled: isDisabled, isLeftSidebarCollapsed: isLeftSidebarCollapsed, label: label, leftSidebarPercentageExpanded: leftSidebarPercentageExpanded, onKeyDown: onKeyDown, onMouseDown: onMouseDown, onBlur: onBlur, onFocus: onFocus, ref: ref, ...rest })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        ...$859a4bb5bdb6af39$var$grabAreaSelector,
        "aria-label": label,
        "data-testid": testId,
        disabled: isDisabled,
        "aria-hidden": isLeftSidebarCollapsed,
        type: "button",
        // The slider role is applied to a button to utilize the native
        // interactive and disabled functionality on the resize slider. While a
        // range input would be more semantically accurate, it does not affect
        // usability.
        role: "slider",
        css: [
            $859a4bb5bdb6af39$var$grabAreaStyles,
            isLeftSidebarCollapsed && $859a4bb5bdb6af39$var$grabAreaCollapsedStyles
        ],
        "aria-orientation": "vertical",
        "aria-valuenow": leftSidebarPercentageExpanded,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuetext": `${valueTextLabel} ${leftSidebarPercentageExpanded}%`,
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        onFocus: onFocus,
        onBlur: onBlur,
        ...rest
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $859a4bb5bdb6af39$var$lineStyles,
        ...$859a4bb5bdb6af39$var$grabAreaLineSelector
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$859a4bb5bdb6af39$export$2e2bcd8739ae039 = $859a4bb5bdb6af39$var$GrabArea;

});

parcelRegister("7nOWs", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ee2fadf0239ec76$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /**
                                                                                                                                                 * @jsxRuntime classic
                                                                                                                                                 * @jsx jsx
                                                                                                                                                 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $3uzfU = parcelRequire("3uzfU");


var $lObw7 = parcelRequire("lObw7");

var $h9kUS = parcelRequire("h9kUS");


function $8ee2fadf0239ec76$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8ee2fadf0239ec76$var$increaseHitAreaStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    position: 'absolute',
    insetBlockEnd: `${"var(--ds-space-negative-300, -24px)"}`,
    insetBlockStart: `${"var(--ds-space-negative-300, -24px)"}`,
    insetInlineEnd: `${"var(--ds-space-negative-150, -12px)"}`,
    insetInlineStart: `${"var(--ds-space-negative-100, -8px)"}`
});
const $8ee2fadf0239ec76$var$mobileStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles -- Ignored via go/DSP-18766
    [(0, $h9kUS.UNSAFE_media).below.sm]: {
        opacity: 1
    }
});
const $8ee2fadf0239ec76$var$resizeIconButtonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: 24,
    height: 24,
    padding: "var(--ds-space-0, 0px)",
    position: 'absolute',
    backgroundColor: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    border: 0,
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    boxShadow: `0 0 0 1px ${(0, $829f609a65d26a98$export$920c0d5c49070351)}, 0 2px 4px 1px ${(0, $829f609a65d26a98$export$920c0d5c49070351)}`,
    color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
    cursor: 'pointer',
    insetBlockStart: "var(--ds-space-400, 32px)",
    insetInlineStart: 0,
    /**
   * The fallback value of 0 ensures that the button is hidden by default,
   * unless some parent (or the button itself) overrides it.
   */ opacity: `var(--ds--resize-button--opacity,0)`,
    outline: 0,
    transform: 'translateX(-50%)',
    transition: `
    background-color ${(0, $lObw7.durations).small}ms linear,
    color ${(0, $lObw7.durations).small}ms linear,
    opacity ${(0, $lObw7.durations).medium}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)}
  `,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        backgroundColor: `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`,
        color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        opacity: 1
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':active, :focus': {
        backgroundColor: `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        opacity: 1
    }
});
const $8ee2fadf0239ec76$var$resizeIconButtonExpandedStyles = {
    name: "1bl2513",
    styles: "transform:rotate(180deg);transform-origin:7px"
};
const $8ee2fadf0239ec76$var$preventDefault = (event)=>event.preventDefault();
const $8ee2fadf0239ec76$var$cssSelector = {
    [(0, $565cb8192fc4e070$export$dac2fb31a9f6844d)]: true
};
const $8ee2fadf0239ec76$var$ResizeButton = ({ isLeftSidebarCollapsed: isLeftSidebarCollapsed, label: label, testId: testId, ...props })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        ...$8ee2fadf0239ec76$var$cssSelector,
        "aria-expanded": !isLeftSidebarCollapsed,
        "aria-label": label,
        type: "button",
        // The error goes away when we remove the spread ...props
        css: [
            $8ee2fadf0239ec76$var$resizeIconButtonStyles,
            $8ee2fadf0239ec76$var$mobileStyles,
            !isLeftSidebarCollapsed && $8ee2fadf0239ec76$var$resizeIconButtonExpandedStyles
        ],
        "data-testid": testId,
        // Prevents focus staying attached to the button when pressed
        onMouseDown: $8ee2fadf0239ec76$var$preventDefault,
        ...props
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3uzfU))), {
        label: "",
        color: "currentColor",
        size: "small"
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $8ee2fadf0239ec76$var$increaseHitAreaStyles
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8ee2fadf0239ec76$export$2e2bcd8739ae039 = $8ee2fadf0239ec76$var$ResizeButton;

});

parcelRegister("3bMab", function(module, exports) {

$parcel$export(module.exports, "default", () => $31b1337ced2d81f3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");


var $dwLzP = parcelRequire("dwLzP");
const $31b1337ced2d81f3$var$colorStops = `
    rgba(0, 0, 0, 0.2) 0px,
    rgba(0, 0, 0, 0.2) 1px,
    rgba(0, 0, 0, 0.1) 1px,
    rgba(0, 0, 0, 0) 100%
  `;
const $31b1337ced2d81f3$var$direction = 'to left';
const $31b1337ced2d81f3$var$transitionDuration = '0.22s';
const $31b1337ced2d81f3$var$shadowStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: 3,
    position: 'absolute',
    background: `var(--ds-border, ${`linear-gradient(${$31b1337ced2d81f3$var$direction}, ${$31b1337ced2d81f3$var$colorStops})`})`,
    insetBlockEnd: 0,
    insetBlockStart: 0,
    insetInlineStart: -1,
    opacity: 0.5,
    pointerEvents: 'none',
    transitionDuration: $31b1337ced2d81f3$var$transitionDuration,
    transitionProperty: 'left, opacity, width',
    transitionTimingFunction: (0, $eba99f58997c09b3$export$57636bb43b1ccbb0)
});
const $31b1337ced2d81f3$var$draggingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: 6,
    background: `var(--ds-background-neutral-subtle, ${`linear-gradient(${$31b1337ced2d81f3$var$direction}, ${$31b1337ced2d81f3$var$colorStops})`})`,
    insetInlineStart: "var(--ds-space-negative-075, -6px)",
    opacity: 0.8
});
const $31b1337ced2d81f3$var$Shadow = ({ testId: testId })=>{
    const isDragging = (0, $dwLzP.default)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-testid": testId,
        css: [
            $31b1337ced2d81f3$var$shadowStyles,
            isDragging && $31b1337ced2d81f3$var$draggingStyles
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$31b1337ced2d81f3$export$2e2bcd8739ae039 = $31b1337ced2d81f3$var$Shadow;

});
parcelRegister("dwLzP", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe6bed85a32a6108$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $fe6bed85a32a6108$var$getIsDragging = ()=>{
    // SSR bail-out because document is undefined on the server
    if (typeof document === 'undefined') return false;
    return document.documentElement.getAttribute((0, $565cb8192fc4e070$export$802bb2c050f3db5c)) === 'true';
};
// TODO: I think this should be derived from the sidebar state,
// and not indirectly from observing an attribute change
const $fe6bed85a32a6108$var$useIsSidebarDragging = ()=>{
    const [isDragging, setIsDragging] = (0, $5uXOq.useState)($fe6bed85a32a6108$var$getIsDragging);
    (0, $5uXOq.useEffect)(()=>{
        const observer = new MutationObserver(()=>{
            setIsDragging($fe6bed85a32a6108$var$getIsDragging);
        });
        observer.observe(document.documentElement, {
            attributeFilter: [
                (0, $565cb8192fc4e070$export$802bb2c050f3db5c)
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return isDragging;
};
var $fe6bed85a32a6108$export$2e2bcd8739ae039 = $fe6bed85a32a6108$var$useIsSidebarDragging;

});



parcelRegister("2QObc", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd36b127ab52f290$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $dWt6p = parcelRequire("dWt6p");

var $h9kUS = parcelRequire("h9kUS");


var $dwLzP = parcelRequire("dwLzP");
function $fd36b127ab52f290$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $fd36b127ab52f290$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $dWt6p.prefersReducedMotion)());
const $fd36b127ab52f290$var$mobileStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $h9kUS.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $565cb8192fc4e070$export$70740f5ad8360a78)}px`,
        position: 'fixed',
        insetBlockEnd: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetBlockStart: `calc(${(0, $565cb8192fc4e070$export$ed7cc0d417ee89e)} + ${(0, $565cb8192fc4e070$export$aeff86a16f13529)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetInlineStart: `${(0, $565cb8192fc4e070$export$f963aecf2d4465bd)}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $565cb8192fc4e070$export$3749e1104328fde4)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`
    }
});
const $fd36b127ab52f290$var$mobileInnerFlyoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $h9kUS.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `min(90vw, ${(0, $565cb8192fc4e070$export$d6e7e8af042815bb)}px)`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: (0, $565cb8192fc4e070$export$d6e7e8af042815bb),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $565cb8192fc4e070$export$3749e1104328fde4)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s, box-shadow ${(0, $565cb8192fc4e070$export$3749e1104328fde4)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`
    }
});
/**
 * This inner wrapper is required to allow the sidebar to be `position: fixed`.
 *
 * If we were to apply `position: fixed` to the outer wrapper, it will be popped
 * out of its flex container and Main would stretch to occupy all the space.
 */ const $fd36b127ab52f290$var$fixedInnerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $565cb8192fc4e070$export$f897e1ed9f8ed251)}`,
    position: 'fixed',
    insetBlockEnd: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: `calc(${(0, $565cb8192fc4e070$export$ed7cc0d417ee89e)} + ${(0, $565cb8192fc4e070$export$aeff86a16f13529)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: `${(0, $565cb8192fc4e070$export$f963aecf2d4465bd)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${(0, $565cb8192fc4e070$export$3749e1104328fde4)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`
});
const $fd36b127ab52f290$var$fixedInnerFlyoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $565cb8192fc4e070$export$d2fa14f05b61e66)
});
/**
 * Static in the sense of `position: static`.
 *
 * It will expand the page height to fit its content.
 */ const $fd36b127ab52f290$var$staticInnerStyles = {
    name: "13udsys",
    styles: "height:100%"
};
const $fd36b127ab52f290$var$draggingStyles = {
    name: "jlx54q",
    styles: "cursor:ew-resize;transition:none"
};
const $fd36b127ab52f290$var$LeftSidebarInner = ({ children: children, isFixed: isFixed = false, isFlyoutOpen: isFlyoutOpen = false })=>{
    const isDragging = (0, $dwLzP.default)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            // mobile viewport styles
            $fd36b127ab52f290$var$mobileStyles,
            isFlyoutOpen && $fd36b127ab52f290$var$mobileInnerFlyoutStyles,
            // generic styles
            !isFixed && $fd36b127ab52f290$var$staticInnerStyles,
            isFixed && $fd36b127ab52f290$var$fixedInnerStyles,
            isFixed && isFlyoutOpen && $fd36b127ab52f290$var$fixedInnerFlyoutStyles,
            isDragging && $fd36b127ab52f290$var$draggingStyles,
            $fd36b127ab52f290$var$prefersReducedMotionStyles
        ]
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fd36b127ab52f290$export$2e2bcd8739ae039 = $fd36b127ab52f290$var$LeftSidebarInner;

});

parcelRegister("aY3ai", function(module, exports) {

$parcel$export(module.exports, "default", () => $579ca93715ca9047$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $dWt6p = parcelRequire("dWt6p");

var $h9kUS = parcelRequire("h9kUS");


var $dwLzP = parcelRequire("dwLzP");

var $8XpIo = parcelRequire("8XpIo");

var $j3yGs = parcelRequire("j3yGs");

var $fZqMW = parcelRequire("fZqMW");
function $579ca93715ca9047$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $579ca93715ca9047$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $dWt6p.prefersReducedMotion)());
const $579ca93715ca9047$var$mobileStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $h9kUS.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $565cb8192fc4e070$export$70740f5ad8360a78),
        cursor: 'pointer',
        opacity: 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $565cb8192fc4e070$export$3749e1104328fde4)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`,
        '&::after': {
            display: 'inline-block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            maxWidth: (0, $565cb8192fc4e070$export$d6e7e8af042815bb),
            content: "''"
        }
    }
});
const $579ca93715ca9047$var$mobileFlyoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $h9kUS.UNSAFE_media).below.sm]: {
        cursor: 'revert'
    }
});
const $579ca93715ca9047$var$outerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $565cb8192fc4e070$export$f897e1ed9f8ed251),
    position: 'relative',
    zIndex: 1,
    marginInlineStart: "var(--ds-space-0, 0px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${(0, $565cb8192fc4e070$export$3749e1104328fde4)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        '--ds--resize-button--opacity': 1
    }
});
const $579ca93715ca9047$var$draggingStyles = {
    name: "jlx54q",
    styles: "cursor:ew-resize;transition:none"
};
/**
 * In fixed mode this element's child is taken out of the document flow.
 * It doesn't take up the width as expected,
 * so the pseudo element forces it to take up the necessary width.
 */ const $579ca93715ca9047$var$fixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::after': {
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $565cb8192fc4e070$export$f897e1ed9f8ed251)}`,
        content: "''"
    }
});
const $579ca93715ca9047$var$flyoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $565cb8192fc4e070$export$d2fa14f05b61e66)
});
const $579ca93715ca9047$var$flyoutFixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $565cb8192fc4e070$export$46acf8758e9e2636)
});
const $579ca93715ca9047$var$selector = (0, $8XpIo.getPageLayoutSlotSelector)('left-sidebar');
const $579ca93715ca9047$var$LeftSidebarOuterComponent = ({ children: children, isFixed: isFixed = false, testId: // NOTE: We explicitly require this via props because of `LeftSidebarWithoutResize`
testId, onMouseLeave: onMouseLeave, onMouseOver: onMouseOver, onClick: onClick, id: id }, ref)=>{
    const isDragging = (0, $dwLzP.default)();
    const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen } } = (0, $5uXOq.useContext)((0, $j3yGs.SidebarResizeContext));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fZqMW.default), {
        isSidebar: true
    }, ({ className: className })=>/**
     * On desktop, the `onMouseOver|onMouseLeave` handlers controls the temporary flyout behavior.
     * This is an intentionally mouse-only experience, it may even be disruptive with keyboard navigation.
     *
     * On mobile, the `onClick` handler controls the toggled flyout behaviour.
     * This is not intended to be how you use this with a keyboard, there is a ResizeButton for this intentionally instead.
     */ // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                // mobile viewport styles
                $579ca93715ca9047$var$mobileStyles,
                isFlyoutOpen && $579ca93715ca9047$var$mobileFlyoutStyles,
                // generic styles
                $579ca93715ca9047$var$outerStyles,
                isFixed && $579ca93715ca9047$var$fixedStyles,
                isFlyoutOpen && $579ca93715ca9047$var$flyoutStyles,
                isFlyoutOpen && isFixed && $579ca93715ca9047$var$flyoutFixedStyles,
                isDragging && $579ca93715ca9047$var$draggingStyles,
                $579ca93715ca9047$var$prefersReducedMotionStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            // We are adding additional functionality for hover, so this should
            // not have associated key events.
            // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
            onMouseOver: onMouseOver,
            onMouseLeave: onMouseLeave,
            onClick: onClick,
            ref: ref,
            ...$579ca93715ca9047$var$selector
        }, children));
};
const $579ca93715ca9047$var$LeftSidebarOuter = /*#__PURE__*/ (0, $5uXOq.forwardRef)($579ca93715ca9047$var$LeftSidebarOuterComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$579ca93715ca9047$export$2e2bcd8739ae039 = $579ca93715ca9047$var$LeftSidebarOuter;

});

parcelRegister("1hxaZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2beb7a521c0e059$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $dWt6p = parcelRequire("dWt6p");


var $2qAWW = parcelRequire("2qAWW");
function $b2beb7a521c0e059$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $b2beb7a521c0e059$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $dWt6p.prefersReducedMotion)());
/**
 * The transition duration is intentionally set to 0ms.
 *
 * A transition is being used here to delay the setting of
 * opacity and visibility so that it syncs collapsing sidebar.
 */ const $b2beb7a521c0e059$var$hideLeftSidebarContentsStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    opacity: 0,
    transition: 'opacity 0ms linear, visibility 0ms linear',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transitionDelay: `${(0, $565cb8192fc4e070$export$3749e1104328fde4) - 100}ms`,
    visibility: 'hidden'
});
const $b2beb7a521c0e059$var$resizableChildrenWrapperStyles = {
    name: "xz78rr",
    styles: "height:100%;opacity:1;overflow:hidden auto;transition:none;visibility:visible"
};
const $b2beb7a521c0e059$var$fixedChildrenWrapperStyles = {
    name: "ax3w45",
    styles: "min-width:240px;height:100%"
};
const $b2beb7a521c0e059$var$ResizableChildrenWrapper = ({ children: children, isLeftSidebarCollapsed: isLeftSidebarCollapsed = false, hasCollapsedState: hasCollapsedState = false, isFlyoutOpen: isFlyoutOpen = false, testId: testId })=>{
    const isCollapsing = (0, $2qAWW.default)();
    const isCollapsed = isLeftSidebarCollapsed || hasCollapsedState;
    const isHidden = isCollapsing || isCollapsed && !isFlyoutOpen;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $b2beb7a521c0e059$var$resizableChildrenWrapperStyles,
            isHidden && $b2beb7a521c0e059$var$hideLeftSidebarContentsStyles,
            $b2beb7a521c0e059$var$prefersReducedMotionStyles
        ],
        "aria-hidden": isHidden,
        "data-testid": testId,
        tabIndex: isHidden ? -1 : 0
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $b2beb7a521c0e059$var$fixedChildrenWrapperStyles
    }, children));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b2beb7a521c0e059$export$2e2bcd8739ae039 = $b2beb7a521c0e059$var$ResizableChildrenWrapper;

});
parcelRegister("2qAWW", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed1c7c9bc9db6ce1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $ed1c7c9bc9db6ce1$var$getIsCollapsing = ()=>{
    // SSR bail-out because document is undefined on the server
    if (typeof document === 'undefined') return false;
    return document.documentElement.getAttribute((0, $565cb8192fc4e070$export$5e5e1875c3fd8f4f)) === 'true';
};
const $ed1c7c9bc9db6ce1$var$useIsSidebarCollapsing = ()=>{
    const [isCollapsing, setIsCollapsing] = (0, $5uXOq.useState)($ed1c7c9bc9db6ce1$var$getIsCollapsing);
    (0, $5uXOq.useEffect)(()=>{
        const observer = new MutationObserver(()=>{
            setIsCollapsing($ed1c7c9bc9db6ce1$var$getIsCollapsing);
        });
        observer.observe(document.documentElement, {
            attributeFilter: [
                (0, $565cb8192fc4e070$export$5e5e1875c3fd8f4f)
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return isCollapsing;
};
var $ed1c7c9bc9db6ce1$export$2e2bcd8739ae039 = $ed1c7c9bc9db6ce1$var$useIsSidebarCollapsing;

});



parcelRegister("aj7M6", function(module, exports) {

$parcel$export(module.exports, "default", () => $c26851ff0e51eadd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $8XpIo = parcelRequire("8XpIo");

var $2Pb5D = parcelRequire("2Pb5D");
var $amcy7 = parcelRequire("amcy7");

var $2QObc = parcelRequire("2QObc");

var $aY3ai = parcelRequire("aY3ai");

var $jUxG6 = parcelRequire("jUxG6");
/**
 * __Left sidebar without resize__
 *
 * Provides a slot for a left sidebar without resize within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $c26851ff0e51eadd$var$LeftSidebarWithoutResize = (props)=>{
    const { children: children, id: id, width: width, isFixed: isFixed, shouldPersistWidth: shouldPersistWidth, testId: testId, skipLinkTitle: skipLinkTitle } = props;
    const leftSidebarWidth = (0, $8XpIo.resolveDimension)((0, $565cb8192fc4e070$export$a30f2e00489a8957), width, shouldPersistWidth);
    (0, $5uXOq.useEffect)(()=>{
        (0, $2Pb5D.default)({
            [(0, $565cb8192fc4e070$export$a30f2e00489a8957)]: leftSidebarWidth
        });
        return ()=>{
            (0, $2Pb5D.default)({
                [(0, $565cb8192fc4e070$export$a30f2e00489a8957)]: 0
            });
        };
    }, [
        leftSidebarWidth
    ]);
    (0, $amcy7.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aY3ai.default), {
        id: id,
        testId: testId,
        isFixed: isFixed
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jUxG6.default), {
        variableName: (0, $565cb8192fc4e070$export$a30f2e00489a8957),
        value: leftSidebarWidth
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2QObc.default), {
        isFixed: isFixed
    }, children));
};
var $c26851ff0e51eadd$export$2e2bcd8739ae039 = $c26851ff0e51eadd$var$LeftSidebarWithoutResize;

});

parcelRegister("kUAkd", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8aae2c1ff30f289$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $dWt6p = parcelRequire("dWt6p");



var $dwLzP = parcelRequire("dwLzP");

var $8XpIo = parcelRequire("8XpIo");

var $j3yGs = parcelRequire("j3yGs");
var $amcy7 = parcelRequire("amcy7");

var $fZqMW = parcelRequire("fZqMW");
function $e8aae2c1ff30f289$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $e8aae2c1ff30f289$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $dWt6p.prefersReducedMotion)());
const $e8aae2c1ff30f289$var$mainStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    minWidth: 0,
    flexGrow: 1,
    marginInlineStart: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `margin-left ${(0, $565cb8192fc4e070$export$3749e1104328fde4)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`
});
const $e8aae2c1ff30f289$var$draggingStyles = {
    name: "1wx2bp",
    styles: "transition:none"
};
/**
 * Adds a negative left margin to main,
 * which transitions at the same speed as the left sidebar's width increase.
 * This give an illusion that the flyout is appearing on top of the main content,
 * while main remains in place.
 */ const $e8aae2c1ff30f289$var$flyoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineStart: `calc(-1 * var(--${(0, $565cb8192fc4e070$export$b6744d31294864fd)}, ${(0, $565cb8192fc4e070$export$991d5285ad765a3d)}px) + ${(0, $565cb8192fc4e070$export$46acf8758e9e2636)}px)`
});
/**
 * __Main__
 *
 * Provides a slot for main content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $e8aae2c1ff30f289$var$Main = (props)=>{
    const { children: children, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    (0, $amcy7.useSkipLink)(id, skipLinkTitle);
    const isDragging = (0, $dwLzP.default)();
    const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen, isFixed: isFixed } } = (0, $5uXOq.useContext)((0, $j3yGs.SidebarResizeContext));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fZqMW.default), null, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("main", {
            "data-testid": testId,
            css: [
                $e8aae2c1ff30f289$var$mainStyles,
                isDragging && $e8aae2c1ff30f289$var$draggingStyles,
                isFlyoutOpen && !isFixed && $e8aae2c1ff30f289$var$flyoutStyles,
                $e8aae2c1ff30f289$var$prefersReducedMotionStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            id: id,
            ...(0, $8XpIo.getPageLayoutSlotSelector)('main')
        }, children));
};
var $e8aae2c1ff30f289$export$2e2bcd8739ae039 = $e8aae2c1ff30f289$var$Main;

});

parcelRegister("3WK4F", function(module, exports) {

$parcel$export(module.exports, "default", () => $864a3c4908a9e1b7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $h9kUS = parcelRequire("h9kUS");


var $hhjNo = parcelRequire("hhjNo");
var $ln2Pp = parcelRequire("ln2Pp");

var $crY4K = parcelRequire("crY4K");
const $864a3c4908a9e1b7$var$pageLayoutSelector = {
    [(0, $565cb8192fc4e070$export$659ee746b31b360d)]: true
};
const $864a3c4908a9e1b7$var$gridTemplateAreasMobile = `
${''}
  "${(0, $565cb8192fc4e070$export$344062f7cfc9528e)} ${(0, $565cb8192fc4e070$export$238d30785c4bca84)}"
  ${''}
  "${(0, $565cb8192fc4e070$export$344062f7cfc9528e)} ${(0, $565cb8192fc4e070$export$bec6dca2e63de4ae)}"
  ${''}
  "${(0, $565cb8192fc4e070$export$344062f7cfc9528e)} ${(0, $565cb8192fc4e070$export$d1213e82613ff4df)}"
 `;
const $864a3c4908a9e1b7$var$gridTemplateAreas = `
${''}
  "${(0, $565cb8192fc4e070$export$344062f7cfc9528e)} ${(0, $565cb8192fc4e070$export$238d30785c4bca84)} ${(0, $565cb8192fc4e070$export$c7139cc2d6110b5f)}"
  ${''}
  "${(0, $565cb8192fc4e070$export$344062f7cfc9528e)} ${(0, $565cb8192fc4e070$export$bec6dca2e63de4ae)} ${(0, $565cb8192fc4e070$export$c7139cc2d6110b5f)}"
${''}
  "${(0, $565cb8192fc4e070$export$344062f7cfc9528e)} ${(0, $565cb8192fc4e070$export$d1213e82613ff4df)} ${(0, $565cb8192fc4e070$export$c7139cc2d6110b5f)}"
 `;
const $864a3c4908a9e1b7$var$gridStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'grid',
    height: '100%',
    gridTemplateAreas: $864a3c4908a9e1b7$var$gridTemplateAreas,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateColumns: `${(0, $565cb8192fc4e070$export$f963aecf2d4465bd)} minmax(0, 1fr) ${(0, $565cb8192fc4e070$export$750459958906793)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateRows: `${(0, $565cb8192fc4e070$export$ed7cc0d417ee89e)} ${(0, $565cb8192fc4e070$export$aeff86a16f13529)} auto`,
    outline: 'none'
});
const $864a3c4908a9e1b7$var$gridStylesMobileStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $h9kUS.UNSAFE_media).below.sm]: {
        gridTemplateAreas: $864a3c4908a9e1b7$var$gridTemplateAreasMobile,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        gridTemplateColumns: `${(0, $565cb8192fc4e070$export$f963aecf2d4465bd)} minmax(0, 1fr)`
    }
});
/**
 * __Page layout__
 *
 * A collection of components which let you compose an application's page layout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $864a3c4908a9e1b7$var$PageLayout = ({ skipLinksLabel: skipLinksLabel = (0, $565cb8192fc4e070$export$206a08f7f8beb554), children: children, testId: testId, onLeftSidebarExpand: onLeftSidebarExpand, onLeftSidebarCollapse: onLeftSidebarCollapse })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ln2Pp.SkipLinksController), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $crY4K.SkipLinkWrapper), {
        skipLinksLabel: skipLinksLabel
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...$864a3c4908a9e1b7$var$pageLayoutSelector,
        "data-testid": testId,
        css: [
            $864a3c4908a9e1b7$var$gridStyles,
            $864a3c4908a9e1b7$var$gridStylesMobileStyles
        ],
        tabIndex: -1,
        "data-vc": "page-layout"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $hhjNo.SidebarResizeController), {
        onLeftSidebarCollapse: onLeftSidebarCollapse,
        onLeftSidebarExpand: onLeftSidebarExpand
    }, children))));
};
var $864a3c4908a9e1b7$export$2e2bcd8739ae039 = $864a3c4908a9e1b7$var$PageLayout;

});
parcelRegister("hhjNo", function(module, exports) {

$parcel$export(module.exports, "SidebarResizeController", () => $592e749dad0a6cf7$export$850bd1bba41f1448);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $eGmKJ = parcelRequire("eGmKJ");

var $dWt6p = parcelRequire("dWt6p");

var $oGXFy = parcelRequire("oGXFy");


var $8XpIo = parcelRequire("8XpIo");

var $j3yGs = parcelRequire("j3yGs");
const $592e749dad0a6cf7$var$handleDataAttributesAndCb = (callback = (0, $eGmKJ.default), leftSidebarState)=>{
    document.documentElement.removeAttribute((0, $565cb8192fc4e070$export$5e5e1875c3fd8f4f));
    callback(leftSidebarState);
};
const $592e749dad0a6cf7$var$leftSidebarSelector = (0, $8XpIo.getPageLayoutSlotCSSSelector)('left-sidebar');
const $592e749dad0a6cf7$export$850bd1bba41f1448 = ({ children: children, onLeftSidebarExpand: onExpand, onLeftSidebarCollapse: onCollapse })=>{
    const [leftSidebarState, setLeftSidebarState] = (0, $5uXOq.useState)({
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true,
        hasInit: false
    });
    const { leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isFixed: isFixed, isLeftSidebarCollapsed: isLeftSidebarCollapsed, isFlyoutOpen: isFlyoutOpen, hasInit: hasInit } = leftSidebarState;
    // We put the latest callbacks into a ref so we can always have the latest
    // functions in our transitionend listeners
    const stableRef = (0, $5uXOq.useRef)({
        onExpand: onExpand,
        onCollapse: onCollapse
    });
    (0, $5uXOq.useEffect)(()=>{
        stableRef.current = {
            onExpand: onExpand,
            onCollapse: onCollapse
        };
    }, [
        onExpand,
        onCollapse
    ]);
    const transition = (0, $5uXOq.useRef)(null);
    const mobileMediaQuery = (0, $oGXFy.UNSAFE_useMediaQuery)('below.sm');
    const isOpen = mobileMediaQuery?.matches ? isFlyoutOpen : !isLeftSidebarCollapsed;
    const expandLeftSidebar = (0, $5uXOq.useCallback)(()=>{
        if (isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't expand at mobile widths; instead we use a flyout which is treated the same otherwise
        if (mobileMediaQuery?.matches) {
            const flyoutOpenSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $565cb8192fc4e070$export$46acf8758e9e2636),
                lastLeftSidebarWidth: leftSidebarWidth,
                isFlyoutOpen: true,
                flyoutLockCount: 0,
                isFixed: isFixed,
                hasInit: hasInit
            };
            setLeftSidebarState(flyoutOpenSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onExpand` still
            transition.current?.complete();
            $592e749dad0a6cf7$var$handleDataAttributesAndCb(stableRef.current.onExpand, flyoutOpenSidebarState);
            return;
        }
        if (isResizing || !isLeftSidebarCollapsed || // already expanding
        transition.current?.action === 'expand') return;
        // flush existing transition
        transition.current?.complete();
        const width = Math.max(lastLeftSidebarWidth, (0, $565cb8192fc4e070$export$539e68c09584883a));
        const updatedLeftSidebarState = {
            isLeftSidebarCollapsed: false,
            isFlyoutOpen: false,
            leftSidebarWidth: width,
            lastLeftSidebarWidth: lastLeftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed,
            hasInit: hasInit
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $592e749dad0a6cf7$var$handleDataAttributesAndCb(stableRef.current.onExpand, updatedLeftSidebarState);
        }
        const sidebar = document.querySelector($592e749dad0a6cf7$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if ((0, $dWt6p.isReducedMotion)() || !sidebar) {
            finish();
            return;
        }
        const unbindEvent = (0, $cBeZP.bind)(sidebar, {
            type: 'transitionend',
            listener (event) {
                if (event.target === sidebar && event.propertyName === 'width') transition.current?.complete();
            }
        });
        const value = {
            action: 'expand',
            complete: ()=>{
                value.abort();
                finish();
            },
            abort: ()=>{
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        lastLeftSidebarWidth,
        flyoutLockCount,
        isFixed,
        leftSidebarWidth,
        hasInit
    ]);
    const collapseLeftSidebar = (0, $5uXOq.useCallback)((event, collapseWithoutTransition)=>{
        if (!isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't collapse at mobile widths; instead we close the flyout.
        if (mobileMediaQuery?.matches) {
            const flyoutCloseSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $565cb8192fc4e070$export$46acf8758e9e2636),
                lastLeftSidebarWidth: lastLeftSidebarWidth,
                isFlyoutOpen: false,
                flyoutLockCount: 0,
                isFixed: isFixed,
                hasInit: hasInit
            };
            setLeftSidebarState(flyoutCloseSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onCollapse` still
            transition.current?.complete();
            $592e749dad0a6cf7$var$handleDataAttributesAndCb(stableRef.current.onCollapse, flyoutCloseSidebarState);
            return;
        }
        if (isResizing || isLeftSidebarCollapsed || // already collapsing
        transition.current?.action === 'collapse') return;
        // flush existing transition
        transition.current?.complete();
        // data-attribute is used as a CSS selector to sync the hiding/showing
        // of the nav contents with expand/collapse animation
        document.documentElement.setAttribute((0, $565cb8192fc4e070$export$5e5e1875c3fd8f4f), 'true');
        const updatedLeftSidebarState = {
            isLeftSidebarCollapsed: true,
            isFlyoutOpen: false,
            leftSidebarWidth: (0, $565cb8192fc4e070$export$46acf8758e9e2636),
            lastLeftSidebarWidth: leftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed,
            hasInit: hasInit
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $592e749dad0a6cf7$var$handleDataAttributesAndCb(stableRef.current.onCollapse, updatedLeftSidebarState);
        }
        const sidebar = document.querySelector($592e749dad0a6cf7$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if (collapseWithoutTransition || (0, $dWt6p.isReducedMotion)() || !sidebar) {
            finish();
            return;
        }
        const unbindEvent = (0, $cBeZP.bind)(sidebar, {
            type: 'transitionend',
            listener (event) {
                if (sidebar === event.target && event.propertyName === 'width') transition.current?.complete();
            }
        });
        const value = {
            action: 'collapse',
            complete: ()=>{
                value.abort();
                finish();
            },
            abort: ()=>{
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        flyoutLockCount,
        isFixed,
        lastLeftSidebarWidth,
        hasInit
    ]);
    /**
	 * Conditionally toggle the expanding or collapsing the sidebars.
	 * This supports our mobile flyout mode as well.
	 */ const toggleLeftSidebar = (0, $5uXOq.useCallback)((event, collapseWithoutTransition)=>{
        if (isOpen) collapseLeftSidebar(event, collapseWithoutTransition);
        else expandLeftSidebar();
    }, [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar
    ]);
    // Make sure we finish any lingering transitions when unmounting
    (0, $5uXOq.useEffect)(function mount() {
        return function unmount() {
            transition.current?.abort();
        };
    }, []);
    const context = (0, $5uXOq.useMemo)(()=>({
            isLeftSidebarCollapsed: !isOpen,
            expandLeftSidebar: expandLeftSidebar,
            collapseLeftSidebar: collapseLeftSidebar,
            leftSidebarState: leftSidebarState,
            setLeftSidebarState: setLeftSidebarState,
            toggleLeftSidebar: toggleLeftSidebar
        }), [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar,
        leftSidebarState,
        toggleLeftSidebar
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j3yGs.SidebarResizeContext).Provider, {
        value: context,
        children: children
    });
};

});

parcelRegister("ln2Pp", function(module, exports) {

$parcel$export(module.exports, "SkipLinksController", () => $66b4ac88f2caca0d$export$da7be99d6a868f3d);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");


var $amcy7 = parcelRequire("amcy7");
const $66b4ac88f2caca0d$var$byDOMOrder = (a, b)=>{
    const elems = Array.from(document.querySelectorAll(`[${(0, $565cb8192fc4e070$export$5253dd9707b8c3ba)}]`));
    const elemA = document.getElementById(a.id);
    const elemB = document.getElementById(b.id);
    const indexA = a.listIndex ?? elems.indexOf(elemA);
    const indexB = b.listIndex ?? elems.indexOf(elemB);
    /**
	 * If they are tied it is because one (or both) is
	 * a custom skiplink with a set index.
	 *
	 * Give the custom skiplink priority.
	 */ if (indexA === indexB) {
        if (a.listIndex !== undefined) return -1;
        else return 1;
    }
    return indexA - indexB;
};
const $66b4ac88f2caca0d$export$da7be99d6a868f3d = ({ children: children })=>{
    const [links, setLinks] = (0, $5uXOq.useState)([]);
    const registerSkipLink = (0, $5uXOq.useRef)((skipLinkData)=>{
        // Don't add duplicate SkipLinks
        setLinks((oldLinks)=>{
            if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
            return [
                ...oldLinks,
                skipLinkData
            ].sort($66b4ac88f2caca0d$var$byDOMOrder);
        });
    });
    const unregisterSkipLink = (0, $5uXOq.useRef)((id)=>{
        setLinks((links)=>links.filter((link)=>link.id !== id));
    });
    const context = {
        registerSkipLink: registerSkipLink.current,
        skipLinksData: links,
        unregisterSkipLink: unregisterSkipLink.current
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $amcy7.SkipLinksContext).Provider, {
        value: context,
        children: children
    });
};

});

parcelRegister("crY4K", function(module, exports) {

$parcel$export(module.exports, "SkipLinkWrapper", () => $c39a22bbdce5fcea$export$4241a460557ba901);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /**
                                                                          * @jsxRuntime classic
                                                                          * @jsx jsx
                                                                          */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $e4yMr = parcelRequire("e4yMr");

var $dWt6p = parcelRequire("dWt6p");



var $amcy7 = parcelRequire("amcy7");
function $c39a22bbdce5fcea$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $c39a22bbdce5fcea$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $dWt6p.prefersReducedMotion)());
const $c39a22bbdce5fcea$var$skipLinkStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    margin: "var(--ds-space-250, 10px)",
    padding: '0.8rem 1rem',
    position: 'fixed',
    zIndex: -1,
    background: "var(--ds-surface-overlay, white)",
    border: 'none',
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $829f609a65d26a98$export$920c0d5c49070351)}, 0 2px 10px ${(0, $829f609a65d26a98$export$920c0d5c49070351)}, 0 0 20px -4px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
    insetInlineStart: -999999,
    opacity: 0,
    transform: 'translateY(-50%)',
    transition: `transform 0.3s ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)}`,
    '&:focus-within': {
        zIndex: 2147483640,
        insetInlineStart: 0,
        opacity: 1,
        transform: 'translateY(0%)'
    }
});
const $c39a22bbdce5fcea$var$skipLinkHeadingStyles = {
    name: "1blmyc0",
    styles: "font-weight:var(--ds-font-weight-semibold, 600)"
};
const $c39a22bbdce5fcea$var$skipLinkListStyles = {
    name: "1xay72g",
    styles: "list-style-position:outside;list-style-type:none;margin-block-start:var(--ds-space-050, 4px);padding-inline-start:0"
};
const $c39a22bbdce5fcea$var$skipLinkListItemStyles = {
    name: "19m435s",
    styles: "margin-block-start:0"
};
const $c39a22bbdce5fcea$var$assignIndex = (num, arr)=>{
    if (!arr.includes(num)) return num;
    return $c39a22bbdce5fcea$var$assignIndex(num + 1, arr);
};
const $c39a22bbdce5fcea$export$4241a460557ba901 = ({ skipLinksLabel: skipLinksLabel })=>{
    const { skipLinksData: skipLinksData } = (0, $amcy7.useSkipLinks)();
    if (skipLinksData.length === 0) return null;
    const sortSkipLinks = (arr)=>{
        const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
        if (customLinks.length === 0) return arr;
        const usedIndexes = customLinks.map((a)=>a.listIndex);
        const regularLinksWithIdx = arr.filter((link)=>link.listIndex === undefined).map((link, idx, currArr)=>{
            const listIndex = $c39a22bbdce5fcea$var$assignIndex(idx, usedIndexes);
            usedIndexes.push(listIndex);
            return {
                ...link,
                listIndex: listIndex
            };
        });
        return [
            ...customLinks,
            ...regularLinksWithIdx
        ].sort((a, b)=>a.listIndex - b.listIndex);
    };
    const escapeHandler = (event)=>{
        if (event.keyCode === 27) {
            const container = document.querySelector(`[${(0, $565cb8192fc4e070$export$659ee746b31b360d)}="true"]`);
            if (container !== null) container.focus();
        }
    };
    const attachEscHandler = ()=>window.addEventListener('keydown', escapeHandler, false);
    const removeEscHandler = ()=>window.removeEventListener('keydown', escapeHandler, false);
    const emptyLabelOverride = !!skipLinksLabel?.match(/^\s+$/);
    const label = skipLinksLabel || (0, $565cb8192fc4e070$export$206a08f7f8beb554);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        onFocus: attachEscHandler,
        onBlur: removeEscHandler,
        css: [
            $c39a22bbdce5fcea$var$skipLinkStyles,
            $c39a22bbdce5fcea$var$prefersReducedMotionStyles
        ],
        "data-skip-link-wrapper": true
    }, emptyLabelOverride ? null : /*#__PURE__*/ (0, $f8Sb3.jsx)("p", {
        css: $c39a22bbdce5fcea$var$skipLinkHeadingStyles
    }, label), /*#__PURE__*/ (0, $f8Sb3.jsx)("ol", {
        css: $c39a22bbdce5fcea$var$skipLinkListStyles
    }, sortSkipLinks(skipLinksData).map(({ id: id, skipLinkTitle: skipLinkTitle })=>/*#__PURE__*/ (0, $f8Sb3.jsx)($c39a22bbdce5fcea$export$ef95c37428582a65, {
            key: id,
            href: `#${id}`,
            isFocusable: true
        }, skipLinkTitle)))));
};
const $c39a22bbdce5fcea$var$handleBlur = (event)=>{
    // @ts-ignore
    event.target.removeAttribute('tabindex');
    // @ts-ignore
    event.target.removeEventListener('blur', $c39a22bbdce5fcea$var$handleBlur);
};
const $c39a22bbdce5fcea$var$focusTargetRef = (href)=>(event)=>{
        event.preventDefault();
        const targetRef = document.querySelector(href);
        // @ts-ignore
        const key = event.which || event.keycode;
        // if it is a keypress and the key is not
        // space or enter, just ignore it.
        if (key && key !== 13 && key !== 32) return;
        if (targetRef) {
            targetRef.setAttribute('tabindex', '-1');
            // @ts-ignore
            targetRef.addEventListener('blur', $c39a22bbdce5fcea$var$handleBlur);
            // @ts-ignore
            targetRef.focus();
            document.activeElement && document.activeElement.scrollIntoView({
                behavior: 'smooth'
            });
            window.scrollTo(0, 0);
        }
        return false;
    };
const $c39a22bbdce5fcea$export$ef95c37428582a65 = ({ href: href, children: children, isFocusable: isFocusable })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("li", {
        css: $c39a22bbdce5fcea$var$skipLinkListItemStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $e4yMr.default), {
        tabIndex: isFocusable ? 0 : -1,
        href: href,
        onClick: $c39a22bbdce5fcea$var$focusTargetRef(href)
    }, children));
};

});


parcelRegister("4CWca", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9295d31affd013c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $8XpIo = parcelRequire("8XpIo");

var $2Pb5D = parcelRequire("2Pb5D");
var $amcy7 = parcelRequire("amcy7");

var $fZqMW = parcelRequire("fZqMW");

var $jUxG6 = parcelRequire("jUxG6");
const $d9295d31affd013c$var$baseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $565cb8192fc4e070$export$c7139cc2d6110b5f)
});
const $d9295d31affd013c$var$fixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $565cb8192fc4e070$export$750459958906793),
    position: 'fixed',
    insetBlockEnd: 0,
    insetBlockStart: 0,
    insetInlineEnd: 0
});
/**
 * __Right panel__
 *
 * Provides a slot for a right panel within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $d9295d31affd013c$var$RightPanel = (props)=>{
    const { children: children, isFixed: isFixed, width: width = (0, $565cb8192fc4e070$export$c3e41153b9288bcf), shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const rightPanelWidth = (0, $8XpIo.resolveDimension)((0, $565cb8192fc4e070$export$fa34f417972d6341), width, shouldPersistWidth);
    (0, $5uXOq.useEffect)(()=>{
        (0, $2Pb5D.default)({
            [(0, $565cb8192fc4e070$export$fa34f417972d6341)]: rightPanelWidth
        });
        return ()=>{
            (0, $2Pb5D.default)({
                [(0, $565cb8192fc4e070$export$fa34f417972d6341)]: 0
            });
        };
    }, [
        rightPanelWidth
    ]);
    (0, $amcy7.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fZqMW.default), null, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                $d9295d31affd013c$var$baseStyles,
                isFixed && $d9295d31affd013c$var$fixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $8XpIo.getPageLayoutSlotSelector)('right-panel')
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jUxG6.default), {
            variableName: (0, $565cb8192fc4e070$export$fa34f417972d6341),
            value: rightPanelWidth
        }), children));
};
var $d9295d31affd013c$export$2e2bcd8739ae039 = $d9295d31affd013c$var$RightPanel;

});

parcelRegister("9xmqY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a07a1808f1030823$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $8XpIo = parcelRequire("8XpIo");

var $2Pb5D = parcelRequire("2Pb5D");
var $amcy7 = parcelRequire("amcy7");

var $fZqMW = parcelRequire("fZqMW");

var $jUxG6 = parcelRequire("jUxG6");
function $a07a1808f1030823$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * This inner wrapper is required to allow the sidebar to be `position: fixed`.
 *
 * If we were to apply `position: fixed` to the outer wrapper, it will be popped
 * out of its flex container and Main would stretch to occupy all the space.
 */ const $a07a1808f1030823$var$fixedInnerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $565cb8192fc4e070$export$b44ab66843c05a69),
    position: 'fixed',
    insetBlockEnd: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: `calc(${(0, $565cb8192fc4e070$export$ed7cc0d417ee89e)} + ${(0, $565cb8192fc4e070$export$aeff86a16f13529)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: `calc(${(0, $565cb8192fc4e070$export$750459958906793)})`
});
const $a07a1808f1030823$var$staticInnerStyles = {
    name: "13udsys",
    styles: "height:100%"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $a07a1808f1030823$var$outerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: (0, $565cb8192fc4e070$export$b44ab66843c05a69)
});
/**
 * In fixed mode this element's child is taken out of the document flow.
 * It doesn't take up the width as expected,
 * so the pseudo element forces it to take up the necessary width.
 */ const $a07a1808f1030823$var$fixedOuterStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&::after': {
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $565cb8192fc4e070$export$b44ab66843c05a69),
        content: "''"
    }
});
/**
 * __Right sidebar__
 *
 * Provides a slot for a right sidebar within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $a07a1808f1030823$var$RightSidebar = (props)=>{
    const { children: children, width: width = (0, $565cb8192fc4e070$export$b92df8810d2fcd01), isFixed: isFixed, shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const rightSidebarWidth = (0, $8XpIo.resolveDimension)((0, $565cb8192fc4e070$export$c103b605cd368aed), width, shouldPersistWidth);
    (0, $5uXOq.useEffect)(()=>{
        (0, $2Pb5D.default)({
            [(0, $565cb8192fc4e070$export$c103b605cd368aed)]: rightSidebarWidth
        });
        return ()=>{
            (0, $2Pb5D.default)({
                [(0, $565cb8192fc4e070$export$c103b605cd368aed)]: 0
            });
        };
    }, [
        rightSidebarWidth,
        id
    ]);
    (0, $amcy7.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fZqMW.default), {
        isSidebar: true
    }, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            "data-testid": testId,
            css: [
                $a07a1808f1030823$var$outerStyles,
                isFixed && $a07a1808f1030823$var$fixedOuterStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            id: id,
            ...(0, $8XpIo.getPageLayoutSlotSelector)('right-sidebar')
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jUxG6.default), {
            variableName: (0, $565cb8192fc4e070$export$c103b605cd368aed),
            value: rightSidebarWidth
        }), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                isFixed && $a07a1808f1030823$var$fixedInnerStyles,
                !isFixed && $a07a1808f1030823$var$staticInnerStyles
            ]
        }, children)));
};
var $a07a1808f1030823$export$2e2bcd8739ae039 = $a07a1808f1030823$var$RightSidebar;

});

parcelRegister("31ERv", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bf5fc6d75e2417f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $8XpIo = parcelRequire("8XpIo");

var $2Pb5D = parcelRequire("2Pb5D");
var $amcy7 = parcelRequire("amcy7");

var $fZqMW = parcelRequire("fZqMW");

var $jUxG6 = parcelRequire("jUxG6");
const $7bf5fc6d75e2417f$var$topNavigationStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $565cb8192fc4e070$export$aeff86a16f13529),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $565cb8192fc4e070$export$bec6dca2e63de4ae)
});
const $7bf5fc6d75e2417f$var$fixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    position: 'fixed',
    zIndex: 2,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: (0, $565cb8192fc4e070$export$ed7cc0d417ee89e),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: (0, $565cb8192fc4e070$export$750459958906793),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: (0, $565cb8192fc4e070$export$f963aecf2d4465bd)
});
/**
 * __Top navigation__
 *
 * Provides a slot for top navigation within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $7bf5fc6d75e2417f$var$TopNavigation = (props)=>{
    const { children: children, height: height = (0, $565cb8192fc4e070$export$4a98ee0bd1ae362), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const topNavigationHeight = (0, $8XpIo.resolveDimension)((0, $565cb8192fc4e070$export$3a6a779d9181047c), height, shouldPersistHeight);
    (0, $5uXOq.useEffect)(()=>{
        (0, $2Pb5D.default)({
            [(0, $565cb8192fc4e070$export$3a6a779d9181047c)]: topNavigationHeight
        });
        return ()=>{
            (0, $2Pb5D.default)({
                [(0, $565cb8192fc4e070$export$3a6a779d9181047c)]: 0
            });
        };
    }, [
        topNavigationHeight
    ]);
    (0, $amcy7.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fZqMW.default), null, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                $7bf5fc6d75e2417f$var$topNavigationStyles,
                isFixed && $7bf5fc6d75e2417f$var$fixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $8XpIo.getPageLayoutSlotSelector)('top-navigation')
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jUxG6.default), {
            variableName: (0, $565cb8192fc4e070$export$3a6a779d9181047c),
            value: topNavigationHeight
        }), children));
};
var $7bf5fc6d75e2417f$export$2e2bcd8739ae039 = $7bf5fc6d75e2417f$var$TopNavigation;

});

parcelRegister("cIcFn", function(module, exports) {

$parcel$export(module.exports, "useCustomSkipLink", () => $a8132564ed4ca271$export$ee6b12c2613bdf8e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $amcy7 = parcelRequire("amcy7");
const $a8132564ed4ca271$export$ee6b12c2613bdf8e = (id, skipLinkTitle, listIndex = 0)=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = (0, $amcy7.useSkipLinks)();
    (0, $5uXOq.useEffect)(()=>{
        registerSkipLink({
            id: id,
            skipLinkTitle: skipLinkTitle,
            listIndex: listIndex
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        listIndex,
        skipLinkTitle,
        registerSkipLink,
        unregisterSkipLink
    ]);
};

});

parcelRegister("2MLVq", function(module, exports) {

$parcel$export(module.exports, "Aside", () => $77d6f7adcd563578$export$ac3bdfe4cb17f64e);
/* aside.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lp9re = parcelRequire("lp9re");

var $VSDnB = parcelRequire("VSDnB");

var $h9kUS = parcelRequire("h9kUS");

var $585q9 = parcelRequire("585q9");

var $ilnvx = parcelRequire("ilnvx");

var $8oF23 = parcelRequire("8oF23");

var $2WR37 = parcelRequire("2WR37");

var $8mXqE = parcelRequire("8mXqE");

var $fVO1C = parcelRequire("fVO1C");

var $2HiMp = parcelRequire("2HiMp");
const $77d6f7adcd563578$var$panelSplitterResizingVar = '--n_asdRsz';
/**
 * The bounds for Aside and Panel are purposely set to support the current usage in Jira.
 *
 * Jira sets the slot's width to `0px` when there is no active content to display in it.
 *   - This means the min width needs to support `0px`.
 * The Conversation Assistant component in Jira (rendered in a nav3 RightSidebar, or a nav4 Aside) has a custom resizing
 * implementation, which has a maximum width of `50vw`.
 *   - This means the max width needs to support `50vw`.
 *
 * This is not the final implementation and will be updated once Jira's usage has been fixed.
 * Ticket to track this is: https://jplat.atlassian.net/browse/BLU-3951
 *
 * We're using two different bounds for each slot here, to support the `0px` min width when programatically set using the
 * `defaultWidth` prop, and another one that is used when resizing the slots which has a sensible min width.
 */ const $77d6f7adcd563578$var$asideWidthSlotBounds = {
    min: '0px',
    max: '50vw'
};
const $77d6f7adcd563578$var$asideWidthResizeBounds = {
    min: '120px',
    max: '50vw'
};
function $77d6f7adcd563578$var$getResizeBounds() {
    return $77d6f7adcd563578$var$asideWidthResizeBounds;
}
const $77d6f7adcd563578$var$styles = {
    root: "_nd5lns35 _vchhusvi _kqswh2mm _glte1kzp _ndwch9n0",
    fixedContentArea: "_1reo1wug _18m91wug _152timx3 _165teqxy _13wn1if8",
    fullHeight: "_4t3i1osq"
};
function $77d6f7adcd563578$export$ac3bdfe4cb17f64e({ children: children, xcss: xcss, isFixed: isFixedProp, defaultWidth: defaultWidth = 330, label: label = 'Aside', skipLinkLabel: skipLinkLabel = label, testId: testId, id: providedId }) {
    const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, $8oF23.DangerouslyHoistSlotSizes));
    const id = (0, $8mXqE.useLayoutId)({
        providedId: providedId
    });
    const isFixed = (0, $VSDnB.fg)('platform_dst_nav4_disable_is_fixed_prop') ? true : isFixedProp;
    /**
   * Don't show the skip link if the slot has 0 width.
   *
   * Remove `isHidden` usage after https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $585q9.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: defaultWidth === 0
    });
    const ref = (0, $5uXOq.useRef)(null);
    const [width, setWidth] = (0, $5uXOq.useState)(defaultWidth);
    // Used to track the previous value of the `defaultWidth` prop, for logging dev warnings when it changes.
    const previousWidthProp = (0, $lp9re.default)(defaultWidth);
    /**
   * Updates the width state based on changes to `defaultWidth`.
   * This is temporary and needed to support the current usage in Jira, and will be removed once it is no longer needed.
   * https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $5uXOq.useEffect)(()=>{
        setWidth(defaultWidth);
    }, [
        defaultWidth
    ]);
    // Putting the warning in a separate effect to avoid adding `previousWidthProp` as an effect dependency when updating width.
    (0, $5uXOq.useEffect)(()=>{}, [
        defaultWidth,
        previousWidthProp
    ]);
    const asideVariableWidth = `clamp(${$77d6f7adcd563578$var$asideWidthSlotBounds.min}, ${width}px, ${$77d6f7adcd563578$var$asideWidthSlotBounds.max})`;
    (0, $2HiMp.useResizingWidthCssVarOnRootElement)({
        isEnabled: dangerouslyHoistSlotSizes && (0, $VSDnB.fg)('platform_design_system_nav4_live_resizing_css_vars'),
        panelId: (0, $ilnvx.asidePanelSplitterId),
        cssVar: $77d6f7adcd563578$var$panelSplitterResizingVar
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("aside", {
        id: id,
        "data-layout-slot": true,
        "aria-label": label,
        className: (0, $bwpsq.default)([
            $77d6f7adcd563578$var$styles.root,
            xcss
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
        style: {
            [(0, $ilnvx.asideVar)]: asideVariableWidth
        },
        "data-testid": testId,
        ref: ref,
        children: [
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WR37.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $ilnvx.UNSAFE_asideLayoutVar),
                value: "0px",
                mediaQuery: (0, $h9kUS.media).above.md,
                responsiveValue: (0, $VSDnB.fg)('platform_design_system_nav4_live_resizing_css_vars') ? `var(${$77d6f7adcd563578$var$panelSplitterResizingVar}, ${asideVariableWidth})` : asideVariableWidth
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVO1C.PanelSplitterProvider), {
                panelId: (0, $ilnvx.asidePanelSplitterId),
                panelRef: ref,
                panelWidth: width,
                onCompleteResize: setWidth,
                getResizeBounds: $77d6f7adcd563578$var$getResizeBounds,
                resizingCssVar: $77d6f7adcd563578$var$panelSplitterResizingVar,
                position: "start",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    "data-testid": testId ? `${testId}--inner` : undefined,
                    className: (0, $bwpsq.default)([
                        $77d6f7adcd563578$var$styles.fullHeight,
                        isFixed && $77d6f7adcd563578$var$styles.fixedContentArea
                    ]),
                    children: children
                })
            })
        ]
    });
}

});
parcelRegister("585q9", function(module, exports) {

$parcel$export(module.exports, "SkipLinksContext", () => $ac664e290f9d7ee4$export$4c5cc3b14c7678a);
$parcel$export(module.exports, "useSkipLinkInternal", () => $ac664e290f9d7ee4$export$707b94c26b8b75aa);
$parcel$export(module.exports, "useSkipLink", () => $ac664e290f9d7ee4$export$89d9323301efc7d6);

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");
const $ac664e290f9d7ee4$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $5uXOq.createContext)({
    registerSkipLink: (0, $eGmKJ.default),
    unregisterSkipLink: (0, $eGmKJ.default)
});
const $ac664e290f9d7ee4$var$useSkipLinks = ()=>(0, $5uXOq.useContext)($ac664e290f9d7ee4$export$4c5cc3b14c7678a);
const $ac664e290f9d7ee4$export$707b94c26b8b75aa = ({ id: id, label: label, listIndex: listIndex, onBeforeNavigate: onBeforeNavigate, isHidden: isHidden })=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = $ac664e290f9d7ee4$var$useSkipLinks();
    (0, $5uXOq.useEffect)(()=>{
        if (isHidden) /**
			 * Skip links are hidden for slots with 0 height or width.
			 * They should not be registered.
			 */ return;
        registerSkipLink({
            id: id,
            label: label,
            listIndex: listIndex,
            onBeforeNavigate: onBeforeNavigate,
            isHidden: isHidden
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        isHidden,
        label,
        listIndex,
        onBeforeNavigate,
        registerSkipLink,
        unregisterSkipLink
    ]);
};
const $ac664e290f9d7ee4$export$89d9323301efc7d6 = (/**
	 * The unique ID for the skip link.
	 * You can use the `useSkipLinkId` hook to generate a unique ID.
	 */ id, /**
	 * The label for the skip link.
	 */ label, /**
	 * You can optionally set the position of the skip link in the list of skip links.
	 * Positions are zero-indexed.
	 */ listIndex)=>{
    $ac664e290f9d7ee4$export$707b94c26b8b75aa({
        id: id,
        label: label,
        listIndex: listIndex
    });
};

});

parcelRegister("ilnvx", function(module, exports) {

$parcel$export(module.exports, "sideNavVar", () => $7e0cfbaebce245b0$export$951bf5156e86d974);
$parcel$export(module.exports, "asideVar", () => $7e0cfbaebce245b0$export$594e6a30db7c057e);
$parcel$export(module.exports, "panelVar", () => $7e0cfbaebce245b0$export$db0c2e1d744fb281);
$parcel$export(module.exports, "bannerMountedVar", () => $7e0cfbaebce245b0$export$515a0b1baafe906c);
$parcel$export(module.exports, "topNavMountedVar", () => $7e0cfbaebce245b0$export$60ef3a7b1ed42328);
$parcel$export(module.exports, "sideNavLiveWidthVar", () => $7e0cfbaebce245b0$export$1216dacffd1e9e65);
$parcel$export(module.exports, "sideNavPanelSplitterId", () => $7e0cfbaebce245b0$export$5db28b16b6e686bc);
$parcel$export(module.exports, "asidePanelSplitterId", () => $7e0cfbaebce245b0$export$de580d653bac8ad9);
$parcel$export(module.exports, "panelPanelSplitterId", () => $7e0cfbaebce245b0$export$3452dcb65711af44);
$parcel$export(module.exports, "UNSAFE_topNavVar", () => $7e0cfbaebce245b0$export$855f5a09f5c99ac);
$parcel$export(module.exports, "UNSAFE_bannerVar", () => $7e0cfbaebce245b0$export$26354f9814213292);
$parcel$export(module.exports, "UNSAFE_sideNavLayoutVar", () => $7e0cfbaebce245b0$export$6bfc931a04ec5741);
$parcel$export(module.exports, "UNSAFE_asideLayoutVar", () => $7e0cfbaebce245b0$export$bbbace2ff0c7ae1b);
$parcel$export(module.exports, "UNSAFE_panelLayoutVar", () => $7e0cfbaebce245b0$export$753bf7651b25db91);
$parcel$export(module.exports, "UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY", () => $7e0cfbaebce245b0$export$6460bd6a2446260);
$parcel$export(module.exports, "UNSAFE_MAIN_INLINE_START_FOR_LEGACY_PAGES_ONLY", () => $7e0cfbaebce245b0$export$3055529fab2b4edf);
$parcel$export(module.exports, "UNSAFE_MAIN_INLINE_END_FOR_LEGACY_PAGES_ONLY", () => $7e0cfbaebce245b0$export$166d8fd766c3eb92);
/**
 * These variables are shared across the different page layout slots.
 * This violates the [UI styling standard](https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-imported-style-values/usage).
 * We have chosen to ignore this rule to prevent duplicating them across the different slots, and to provide a high level view of them and how they relate.
 */ // These are "compressed" to discourage usage.
const $7e0cfbaebce245b0$export$951bf5156e86d974 = '--n_sNvw';
const $7e0cfbaebce245b0$export$594e6a30db7c057e = '--n_asDw';
const $7e0cfbaebce245b0$export$db0c2e1d744fb281 = '--n_pnlW';
const $7e0cfbaebce245b0$export$515a0b1baafe906c = '--n_bnrM';
const $7e0cfbaebce245b0$export$60ef3a7b1ed42328 = '--n_tNvM';
const $7e0cfbaebce245b0$export$1216dacffd1e9e65 = '--n_sNvlw';
const $7e0cfbaebce245b0$export$5db28b16b6e686bc = Symbol('SideNav PanelSplitter');
const $7e0cfbaebce245b0$export$de580d653bac8ad9 = Symbol('Aside PanelSplitter');
const $7e0cfbaebce245b0$export$3452dcb65711af44 = Symbol('Panel PanelSplitter');
const $7e0cfbaebce245b0$export$2874e68531ce3163 = `calc(100vh - var(--n_bnrM, 0px) - var(--n_tNvM, 0px))`;
const $7e0cfbaebce245b0$export$bfabd8c2c572ad29 = `calc(var(--n_bnrM, 0px) + var(--n_tNvM, 0px))`;
const $7e0cfbaebce245b0$export$855f5a09f5c99ac = '--topNavigationHeight';
const $7e0cfbaebce245b0$export$26354f9814213292 = '--bannerHeight';
const $7e0cfbaebce245b0$export$6bfc931a04ec5741 = '--leftSidebarWidth';
const $7e0cfbaebce245b0$export$bbbace2ff0c7ae1b = '--rightSidebarWidth';
const $7e0cfbaebce245b0$export$753bf7651b25db91 = '--rightPanelWidth';
const $7e0cfbaebce245b0$export$6460bd6a2446260 = `calc(var(${$7e0cfbaebce245b0$export$26354f9814213292}, 0px) + var(${$7e0cfbaebce245b0$export$855f5a09f5c99ac}, 0px))`;
const $7e0cfbaebce245b0$export$3055529fab2b4edf = `var(${$7e0cfbaebce245b0$export$6bfc931a04ec5741}, 0px)`;
const $7e0cfbaebce245b0$export$166d8fd766c3eb92 = `calc(var(${$7e0cfbaebce245b0$export$bbbace2ff0c7ae1b}, 0px) + var(${$7e0cfbaebce245b0$export$753bf7651b25db91}, 0px))`;
const $7e0cfbaebce245b0$export$61156ceb1a99f6a0 = {
    topBar: 4,
    banner: 4,
    sideNav: 2,
    panelSmallViewports: 1
};

});

parcelRegister("8oF23", function(module, exports) {

$parcel$export(module.exports, "DangerouslyHoistSlotSizes", () => $1ee0f763875d3fec$export$66e2c1a0115af861);

var $5uXOq = parcelRequire("5uXOq");
const $1ee0f763875d3fec$export$66e2c1a0115af861 = /*#__PURE__*/ (0, $5uXOq.createContext)(false);

});

parcelRegister("2WR37", function(module, exports) {

$parcel$export(module.exports, "HoistCssVarToLocalGrid", () => $cbb560d7ba4917d9$export$cfa3cd08d675e56e);
$parcel$export(module.exports, "DangerouslyHoistCssVarToDocumentRoot", () => $cbb560d7ba4917d9$export$9f45a1325e3cdfb8);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $1EWMr = parcelRequire("1EWMr");
const $cbb560d7ba4917d9$export$cfa3cd08d675e56e = ({ variableName: variableName, value: value })=>/*#__PURE__*/ (0, $2OMIu.jsx)("style", {
        children: `#${(0, $1EWMr.gridRootId)} { ${variableName}: ${value}px }`
    });
const $cbb560d7ba4917d9$var$getCssStringValue = (value)=>typeof value === 'number' ? `${value}px` : value;
const $cbb560d7ba4917d9$export$9f45a1325e3cdfb8 = ({ variableName: variableName, value: value, mediaQuery: mediaQuery, responsiveValue: responsiveValue })=>{
    /**
	 * Note don't put multiple variables in multiple lines. eg
	 * <style>
	 *   {css1}
	 *   {css2}
	 * </style>
	 *
	 * React will insert an empty HTML comment in between the text in SSR.
	 * This is not a valid tag and will break the page.
	 * <style>foo<!-- -->bar</style>
	 */ let style = `:root { ${variableName}: ${$cbb560d7ba4917d9$var$getCssStringValue(value)} }`;
    if (mediaQuery && responsiveValue) style += ` ${mediaQuery} { :root { ${variableName}: ${$cbb560d7ba4917d9$var$getCssStringValue(responsiveValue)} } }`;
    return(// Using a global style is required for SSR, as we can't use React hooks
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
    /*#__PURE__*/ (0, $2OMIu.jsx)("style", {
        children: style
    }));
};

});
parcelRegister("1EWMr", function(module, exports) {

$parcel$export(module.exports, "gridRootId", () => $f4db93acd3b1ab5b$export$a6d827031bcb31d1);
$parcel$export(module.exports, "Root", () => $f4db93acd3b1ab5b$export$be92b6f5f03c0fe9);
/* root.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $dlnxJ = parcelRequire("dlnxJ");

var $iuUiD = parcelRequire("iuUiD");

var $ivVtd = parcelRequire("ivVtd");

var $3Z6qh = parcelRequire("3Z6qh");

var $8oF23 = parcelRequire("8oF23");

var $5rLY7 = parcelRequire("5rLY7");

var $jDR0c = parcelRequire("jDR0c");

var $UTmRP = parcelRequire("UTmRP");
const $f4db93acd3b1ab5b$export$a6d827031bcb31d1 = 'unsafe-design-system-page-layout-root';
const $f4db93acd3b1ab5b$var$styles = {
    root: "_1e0c11p5 _1tke1kxc _1lmcq9em _yv0ei47z _2z0516ab _1ciragmp _12fkuz0r _12qzrxre _1rqt70if _xkmgbaui _jbc7rxre _tyve1jg8"
};
function $f4db93acd3b1ab5b$export$be92b6f5f03c0fe9({ children: children, xcss: xcss, UNSAFE_dangerouslyHoistSlotSizes: UNSAFE_dangerouslyHoistSlotSizes = false, skipLinksLabel: skipLinksLabel = 'Skip to:', testId: testId }) {
    const ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        var child;
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $UTmRP.SideNavVisibilityProvider), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jDR0c.SideNavToggleButtonProvider), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5rLY7.SideNavElementProvider), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Z6qh.TopNavStartProvider), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dlnxJ.OpenLayerObserver), {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8oF23.DangerouslyHoistSlotSizes).Provider, {
                            value: UNSAFE_dangerouslyHoistSlotSizes,
                            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $ivVtd.SkipLinksProvider), {
                                children: [
                                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iuUiD.SkipLinksContainer), {
                                        label: skipLinksLabel,
                                        testId: testId
                                    }),
                                    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                                        ref: ref,
                                        className: (0, $bwpsq.default)([
                                            $f4db93acd3b1ab5b$var$styles.root,
                                            xcss
                                        ]),
                                        id: $f4db93acd3b1ab5b$export$a6d827031bcb31d1,
                                        "data-testid": testId,
                                        children: children
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        })
    });
}

});
parcelRegister("dlnxJ", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserver", () => $db6ff2d140327fd6$export$97afddda23bcd287);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");

var $kEhTY = parcelRequire("kEhTY");
/**
 * Layers that are registered without a namespace are grouped under this fallback namespace.
 */ const $db6ff2d140327fd6$var$noNamespaceSymbol = Symbol('no-namespace');
/**
 * Returns the number of open layers across all namespaces.
 * It calculates the sum of the set sizes in the map, which corresponds to the number of open layers.
 */ function $db6ff2d140327fd6$var$getTotalOpenLayerCount(registry) {
    return Array.from(registry.values()).reduce((acc, listeners)=>acc + listeners.size, 0);
}
/**
 * Returns the layer count change listeners set for the namespace.
 * If there are no listeners registered for the namespace yet, it creates a new set
 * and adds it to the registry, then returns the new set.
 */ function $db6ff2d140327fd6$var$getListeners({ registry: registry, namespace: namespace }) {
    // 1. If there are existing listeners for this namespace, return the existing set.
    const existingListeners = registry.get(namespace);
    if (existingListeners) return existingListeners;
    // 2. If there are no existing listeners for this namespace, create a new set for this namespace
    // and add it to the registry, then return the new set.
    const newSet = new Set();
    registry.set(namespace, newSet);
    return newSet;
}
/**
 * Returns an instance of the open layer observer API. It internally keeps track of the number of open layers and
 * exposes methods to get the current count, increment/decrement the count, and subscribe to changes.
 */ function $db6ff2d140327fd6$var$createInternalAPI() {
    /**
	 * The layer count change listeners for each namespace.
	 */ const namespaceToChangeListenerRegistry = new Map();
    /**
	 * The `onClose` listeners for each namespace.
	 * Each layer provides an `onClose` callback. **When the layer is open**, its `onClose`
	 * callback is registered in this set.
	 *
	 * This data structure is also used determine the number of open layers.
	 */ const namespaceToLayerCloseListenerRegistry = new Map();
    /**
	 * Calls the appropriate layer count change listeners after the number of open layers has changed.
	 */ function callChangeListeners({ namespace: namespace, newCount: newCount }) {
        // 1. Call listeners registered to the specific namespace
        if (namespace) {
            const listenersForNamespace = namespaceToChangeListenerRegistry.get(namespace);
            // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
            // iterating over it.
            Array.from(listenersForNamespace ?? []).forEach((listener)=>listener({
                    count: newCount
                }));
        }
        // 2. Call listeners registered without a specific namespace
        const noNamespaceListeners = namespaceToChangeListenerRegistry.get($db6ff2d140327fd6$var$noNamespaceSymbol);
        // Return early if no listeners
        if (!noNamespaceListeners) return;
        // For the listeners without a specific namespace, we need to provide the sum of all namespace counts
        // as the callback `count` arg.
        const totalCount = $db6ff2d140327fd6$var$getTotalOpenLayerCount(namespaceToLayerCloseListenerRegistry);
        Array.from(noNamespaceListeners).forEach((listener)=>listener({
                count: totalCount
            }));
    }
    /**
	 * Returns the current count of open layers.
	 *
	 * If a namespace is provided, the count for that namespace is returned.
	 * Otherwise, the sum of all namespace counts is returned.
	 */ function getCount({ namespace: namespace } = {}) {
        if (namespace) return namespaceToLayerCloseListenerRegistry.get(namespace)?.size ?? 0;
        // A specific namespace was not requested, so we return the sum across all namespaces.
        return $db6ff2d140327fd6$var$getTotalOpenLayerCount(namespaceToLayerCloseListenerRegistry);
    }
    /**
	 * Adds a listener that will be called when the number of open layers changes.
	 *
	 * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
	 */ function onChange(listener, { namespace: providedNamespace } = {}) {
        /**
		 * We are wrapping the passed listener in a function to ensure that each call to `onChange` creates a unique
		 * function reference. This is to handle scenarios where the same function is provided to several different `onChange`
		 * calls - we want to ensure that each call to `unsubscribe` only removes the specific listener registration that was added.
		 */ function wrapped(...args) {
            listener(...args);
        }
        const namespace = providedNamespace ?? $db6ff2d140327fd6$var$noNamespaceSymbol;
        const listenersForNamespace = $db6ff2d140327fd6$var$getListeners({
            namespace: namespace,
            registry: namespaceToChangeListenerRegistry
        });
        listenersForNamespace.add(wrapped);
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToChangeListenerRegistry.delete(namespace);
        };
    }
    /**
	 * Adds a listener to the registry that tells the observer how to close the layer component.
	 * The listener should only be added if the layer is open. This is handled by `useNotifyOpenLayerObserver`.
	 *
	 * All close listeners will be called by the observer when `closeLayers` is called.
	 *
	 * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
	 */ function onClose(listener, { namespace: providedNamespace }) {
        /**
		 * We are wrapping the passed listener in a function to ensure that each call to `onClose` creates a unique
		 * function reference. This is to handle scenarios where the same function is provided to several different `onClose`
		 * calls - we want to ensure that each call to `unsubscribe` only removes the specific listener registration that was added.
		 */ function wrapped() {
            listener();
        }
        const namespace = providedNamespace ?? $db6ff2d140327fd6$var$noNamespaceSymbol;
        const listenersForNamespace = $db6ff2d140327fd6$var$getListeners({
            namespace: namespace,
            registry: namespaceToLayerCloseListenerRegistry
        });
        listenersForNamespace.add(wrapped);
        callChangeListeners({
            namespace: providedNamespace,
            newCount: listenersForNamespace.size
        });
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            callChangeListeners({
                namespace: providedNamespace,
                newCount: listenersForNamespace.size
            });
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToLayerCloseListenerRegistry.delete(namespace);
        };
    }
    /**
	 * Closes all open layers registered across all namespaces.
	 */ function closeLayers() {
        // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
        // iterating over it.
        Array.from(namespaceToLayerCloseListenerRegistry.values()).forEach((listeners)=>{
            Array.from(listeners).forEach((listener)=>listener());
        });
    }
    const internalAPI = {
        getCount: getCount,
        onChange: onChange,
        onClose: onClose,
        closeLayers: closeLayers
    };
    return internalAPI;
}
function $db6ff2d140327fd6$export$97afddda23bcd287({ children: children }) {
    // Using state to ensure a stable reference to a single instance.
    const [internalAPI] = (0, $5uXOq.useState)(()=>$db6ff2d140327fd6$var$createInternalAPI());
    const parentContext = (0, $5uXOq.useContext)((0, $kEhTY.OpenLayerObserverContext));
    // We don't expect a parent context. If there is one, that means this component is nested within another `OpenLayerObserver`
    // - which we don't support.
    (0, $3joPi.default)(parentContext === null, '`OpenLayerObserver` cannot be nested within another `OpenLayerObserver`.');
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kEhTY.OpenLayerObserverContext).Provider, {
        value: internalAPI,
        children: children
    });
}

});

parcelRegister("iuUiD", function(module, exports) {

$parcel$export(module.exports, "SkipLinksContainer", () => $8a6fecf6d9ada26f$export$fce25a0c32fbc1e1);
/* skip-links-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cgL5K = parcelRequire("cgL5K");

var $4SKIy = parcelRequire("4SKIy");

var $hgvjm = parcelRequire("hgvjm");
const $8a6fecf6d9ada26f$var$styles = {
    root: "_zulp1b66 _2rkoglpi _1rjcutpp _18zrutpp _1e0c1txw _2lx21bp4 _kqsw1n9t _1e02v47k _152tv47k _bfhk1bhr _16qs1cd0 _1pby1mrw _tzy4idpf _lcxvglyw _1digjh3g _1mygkb7n _18eu1wug",
    skipLinkList: "_zulp1b66 _1e0c1txw _2lx21bp4 _1x8w11lx _2mzuglyw _1pfhze3t _bozgze3t"
};
/**
 * Keydown handler to hide the skip links when escape is pressed.
 *
 * TODO: consider removing this, it doesn't make a lot of sense.
 * The skip links look like a popup but in reality they aren't.
 * Even though we hide them if you press TAB it will reopen the list and move to the next one...
 */ const $8a6fecf6d9ada26f$var$closeOnEscape = (event)=>{
    if (event.key !== 'Escape') return;
    const activeElement = document.activeElement;
    if (activeElement instanceof HTMLElement) activeElement.blur();
};
const $8a6fecf6d9ada26f$var$isOnlyWhitespaceRegex = /^\s*$/;
const $8a6fecf6d9ada26f$export$fce25a0c32fbc1e1 = ({ label: label, testId: testId })=>{
    const sortedSkipLinks = (0, $4SKIy.useSortedSkipLinks)();
    if (sortedSkipLinks.length === 0) return null;
    const isEmptyLabel = $8a6fecf6d9ada26f$var$isOnlyWhitespaceRegex.test(label);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        onKeyDown: $8a6fecf6d9ada26f$var$closeOnEscape,
        "data-testid": testId ? `${testId}--skip-links-container` : undefined,
        className: (0, $bwpsq.default)([
            $8a6fecf6d9ada26f$var$styles.root
        ]),
        children: [
            !isEmptyLabel && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgL5K.default), {
                weight: "bold",
                testId: testId ? `${testId}--skip-links-container--label` : undefined,
                children: label
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("ol", {
                className: (0, $bwpsq.default)([
                    $8a6fecf6d9ada26f$var$styles.skipLinkList
                ]),
                children: sortedSkipLinks.map(({ id: id, label: label, onBeforeNavigate: onBeforeNavigate })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $hgvjm.SkipLink), {
                        id: id,
                        onBeforeNavigate: onBeforeNavigate,
                        children: label
                    }, id))
            })
        ]
    });
};

});
parcelRegister("4SKIy", function(module, exports) {

$parcel$export(module.exports, "SkipLinksDataContext", () => $a6322a25f6b08ecb$export$e9ab38ce6147d3d2);
$parcel$export(module.exports, "useSortedSkipLinks", () => $a6322a25f6b08ecb$export$b0b0d4fc1b356759);

var $5uXOq = parcelRequire("5uXOq");
const $a6322a25f6b08ecb$export$e9ab38ce6147d3d2 = /*#__PURE__*/ (0, $5uXOq.createContext)([]);
const $a6322a25f6b08ecb$var$assignIndex = (num, arr)=>{
    if (!arr.includes(num)) return num;
    return $a6322a25f6b08ecb$var$assignIndex(num + 1, arr);
};
const $a6322a25f6b08ecb$var$sortSkipLinks = (arr)=>{
    const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
    if (customLinks.length === 0) return arr;
    const usedIndexes = customLinks.map((a)=>a.listIndex);
    const regularLinksWithIdx = arr.filter((link)=>link.listIndex === undefined).map((link, idx)=>{
        const listIndex = $a6322a25f6b08ecb$var$assignIndex(idx, usedIndexes);
        usedIndexes.push(listIndex);
        return {
            ...link,
            listIndex: listIndex
        };
    });
    return [
        ...customLinks,
        ...regularLinksWithIdx
    ].sort((a, b)=>a.listIndex - b.listIndex);
};
const $a6322a25f6b08ecb$export$b0b0d4fc1b356759 = ()=>{
    const skipLinksData = (0, $5uXOq.useContext)($a6322a25f6b08ecb$export$e9ab38ce6147d3d2);
    return (0, $5uXOq.useMemo)(()=>{
        return $a6322a25f6b08ecb$var$sortSkipLinks(skipLinksData);
    }, [
        skipLinksData
    ]);
};

});

parcelRegister("hgvjm", function(module, exports) {

$parcel$export(module.exports, "SkipLink", () => $ca929d4ef6b95820$export$ef95c37428582a65);
/* skip-link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $jhmo0 = parcelRequire("jhmo0");
const $ca929d4ef6b95820$var$styles = {
    skipLinkListItem: "_1pfhze3t"
};
/**
 * Used for moving focus to the corresponding slot or custom target after clicking on a skip link.
 */ function $ca929d4ef6b95820$var$focusElement(element) {
    /**
   * Elements without an explicit `tabindex` attribute are not guaranteed to be focusable:
   * https://html.spec.whatwg.org/multipage/interaction.html#attr-tabindex
   *
   * Our slots are not interactive, so this is required.
   *
   * In the future we may want to check if there is an existing `tabindex` attribute,
   * as custom skip linked elements might already have one.
   */ element.setAttribute('tabindex', '-1');
    /**
   * Cleanup the `tabindex` attribute we set when the slot or custom target loses focus.
   *
   * This is preferable to always having `tabindex="-1"` because always applying the tab index can:
   *
   * - mess with click events
   * - potentially cause a focus ring to be always visible
   */ (0, $cBeZP.bind)(element, {
        type: 'blur',
        listener () {
            element.removeAttribute('tabindex');
        },
        options: {
            // Using a one-time listener so it cleans itself up
            once: true
        }
    });
    /**
   * Move focus to the slot or custom target.
   *
   * Calling `.focus()` will also scroll the element into view:
   * https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus
   */ element.focus({
        // Forces the focus ring to appear after moving focus to the slot
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#focusvisible
        // @ts-expect-error - new and not in types yet
        focusVisible: true
    });
}
const $ca929d4ef6b95820$export$ef95c37428582a65 = ({ id: id, children: children, onBeforeNavigate: onBeforeNavigate })=>{
    const href = `#${id}`;
    const onClick = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
        // Intentionally not using `document.querySelector` because many valid IDs are not valid selectors.
        const target = document.getElementById(id);
        if (!target) return;
        /**
     * Internal slots can attach an `onBeforeNavigate` callback.
     *
     * Side nav uses this to ensure it is expanded.
     */ onBeforeNavigate?.();
        $ca929d4ef6b95820$var$focusElement(target);
        /**
     * We should look into removing this, or only calling it in specific cases.
     *
     * It means if the skip link element is in the window scroll container
     * then it might not get scrolled into view properly.
     *
     * This is not an issue for the default slots on desktop, but could break custom skip links or
     * even `Aside` on mobile.
     *
     * Keeping existing behavior for now because resetting the window scroll is actually good for some cases.
     * E.g. jumping to main / aside it makes sense to look at the start of the content.
     */ window.scrollTo(0, 0);
    }, [
        id,
        onBeforeNavigate
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("li", {
        className: (0, $bwpsq.default)([
            $ca929d4ef6b95820$var$styles.skipLinkListItem
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jhmo0.default), {
            /**
     * It looks like Safari handles link clicks during `pointerdown` unless it has an explicit `tabIndex={0}` :/
     *
     * Adding this explicitly makes the behavior consistent between browsers and lets us `event.preventDefault()`
     * in the `onClick` handler.
     */ tabIndex: 0,
            href: href,
            onClick: onClick,
            children: children
        })
    });
};

});


parcelRegister("ivVtd", function(module, exports) {

$parcel$export(module.exports, "SkipLinksProvider", () => $04aeed0b84d4da87$export$fe514f9f7b03d46f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $585q9 = parcelRequire("585q9");

var $4SKIy = parcelRequire("4SKIy");
const $04aeed0b84d4da87$var$getByDomOrderSortFunction = ()=>{
    const layoutSlots = Array.from(document.querySelectorAll(`[data-layout-slot]`));
    return (a, b)=>{
        const indexA = a.listIndex ?? layoutSlots.indexOf(document.getElementById(a.id));
        const indexB = b.listIndex ?? layoutSlots.indexOf(document.getElementById(b.id));
        /**
		 * If they are tied it is because one (or both) is
		 * a custom skiplink with a set index.
		 *
		 * Give the custom skiplink priority.
		 */ if (indexA === indexB) {
            if (a.listIndex !== undefined) return -1;
            else return 1;
        }
        return indexA - indexB;
    };
};
const $04aeed0b84d4da87$export$fe514f9f7b03d46f = ({ children: children })=>{
    const [links, setLinks] = (0, $5uXOq.useState)([]);
    const registerSkipLink = (0, $5uXOq.useCallback)((skipLinkData)=>{
        // Don't add duplicate skip links
        setLinks((oldLinks)=>{
            if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
            return [
                ...oldLinks,
                skipLinkData
            ].sort($04aeed0b84d4da87$var$getByDomOrderSortFunction());
        });
    }, []);
    const unregisterSkipLink = (0, $5uXOq.useCallback)((id)=>{
        setLinks((links)=>links.filter((link)=>link.id !== id));
    }, []);
    const contextValue = (0, $5uXOq.useMemo)(()=>{
        const data = {
            registerSkipLink: registerSkipLink,
            unregisterSkipLink: unregisterSkipLink
        };
        return data;
    }, [
        registerSkipLink,
        unregisterSkipLink
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $585q9.SkipLinksContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4SKIy.SkipLinksDataContext).Provider, {
            value: links,
            children: children
        })
    });
};

});

parcelRegister("3Z6qh", function(module, exports) {

$parcel$export(module.exports, "TopNavStartProvider", () => $ac9d25344fa2e979$export$bc9d0ad0bce43e75);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7NFvZ = parcelRequire("7NFvZ");
const $ac9d25344fa2e979$export$bc9d0ad0bce43e75 = ({ children: children })=>{
    const [element, setElement] = (0, $5uXOq.useState)(null);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7NFvZ.TopNavStartElement).Provider, {
        value: element,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7NFvZ.TopNavStartAttachRef).Provider, {
            value: setElement,
            children: children
        })
    });
};

});

parcelRegister("5rLY7", function(module, exports) {

$parcel$export(module.exports, "SideNavElementProvider", () => $60c376fb0d7017f3$export$85c1ff84bbf6e6dc);
$parcel$export(module.exports, "useSideNavRef", () => $60c376fb0d7017f3$export$fa4d0cff03b1ea4f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $60c376fb0d7017f3$var$SideNavRefContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    current: null
});
function $60c376fb0d7017f3$export$85c1ff84bbf6e6dc({ children: children }) {
    const sideNavRef = (0, $5uXOq.useRef)(null);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($60c376fb0d7017f3$var$SideNavRefContext.Provider, {
        value: sideNavRef,
        children: children
    });
}
function $60c376fb0d7017f3$export$fa4d0cff03b1ea4f() {
    return (0, $5uXOq.useContext)($60c376fb0d7017f3$var$SideNavRefContext);
}

});

parcelRegister("jDR0c", function(module, exports) {

$parcel$export(module.exports, "SideNavToggleButtonProvider", () => $e430d141e8d30234$export$ceb8e60e9790fc0f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eZOeM = parcelRequire("eZOeM");
const $e430d141e8d30234$export$ceb8e60e9790fc0f = ({ children: children })=>{
    const [element, setElement] = (0, $5uXOq.useState)(null);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZOeM.SideNavToggleButtonElement).Provider, {
        value: element,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZOeM.SideNavToggleButtonAttachRef).Provider, {
            value: setElement,
            children: children
        })
    });
};

});

parcelRegister("UTmRP", function(module, exports) {

$parcel$export(module.exports, "SideNavVisibilityProvider", () => $2510be1036df6cd8$export$aac8e996360f6ad9);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $b0CFU = parcelRequire("b0CFU");
const $2510be1036df6cd8$export$aac8e996360f6ad9 = ({ children: children })=>{
    // Defaults to null so we can determine if the value has been set yet (for SSR)
    const [sideNavState, setSideNavState] = (0, $5uXOq.useState)(null);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b0CFU.SideNavVisibilityState).Provider, {
        value: sideNavState,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b0CFU.SetSideNavVisibilityState).Provider, {
            value: setSideNavState,
            children: children
        })
    });
};

});



parcelRegister("8mXqE", function(module, exports) {

$parcel$export(module.exports, "useSkipLinkId", () => $57190c324e1ec006$export$fa3cfac0c8e29c5c);
$parcel$export(module.exports, "useLayoutId", () => $57190c324e1ec006$export$110c3550c7c1c9aa);

var $9KnKW = parcelRequire("9KnKW");
function $57190c324e1ec006$export$fa3cfac0c8e29c5c() {
    const uniqueId = (0, $9KnKW.useId)();
    return uniqueId;
}
function $57190c324e1ec006$export$110c3550c7c1c9aa({ providedId: providedId } = {}) {
    const uniqueId = $57190c324e1ec006$export$fa3cfac0c8e29c5c();
    const id = providedId ? providedId : uniqueId;
    return id;
}

});

parcelRegister("fVO1C", function(module, exports) {

$parcel$export(module.exports, "PanelSplitterProvider", () => $0739b5288fba2b3a$export$f662bfb764348932);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $9NI3h = parcelRequire("9NI3h");
const $0739b5288fba2b3a$export$f662bfb764348932 = ({ panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, getResizeBounds: getResizeBounds, resizingCssVar: resizingCssVar, panelRef: panelRef, position: position = 'end', isEnabled: isEnabled = true, children: children })=>{
    const portalRef = (0, $5uXOq.useRef)(null);
    const context = (0, $5uXOq.useMemo)(()=>({
            panelId: panelId,
            panelWidth: panelWidth,
            onCompleteResize: onCompleteResize,
            getResizeBounds: getResizeBounds,
            portalRef: portalRef,
            resizingCssVar: resizingCssVar,
            position: position,
            panelRef: panelRef,
            isEnabled: isEnabled
        }), [
        panelId,
        panelWidth,
        onCompleteResize,
        getResizeBounds,
        resizingCssVar,
        position,
        panelRef,
        isEnabled
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9NI3h.PanelSplitterContext).Provider, {
                value: context,
                children: children
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                ref: portalRef
            })
        ]
    });
};

});
parcelRegister("9NI3h", function(module, exports) {

$parcel$export(module.exports, "PanelSplitterContext", () => $ec571489384d3ca6$export$7a4054f2c546f2cd);

var $5uXOq = parcelRequire("5uXOq");
const $ec571489384d3ca6$export$7a4054f2c546f2cd = /*#__PURE__*/ (0, $5uXOq.createContext)(null);

});


parcelRegister("2HiMp", function(module, exports) {

$parcel$export(module.exports, "useResizingWidthCssVarOnRootElement", () => $ef753172dcf77156$export$d4931ecf0fbcc8fc);

var $5uXOq = parcelRequire("5uXOq");

var $4hDdm = parcelRequire("4hDdm");

var $7gWdR = parcelRequire("7gWdR");

var $3AWiS = parcelRequire("3AWiS");
function $ef753172dcf77156$export$d4931ecf0fbcc8fc({ isEnabled: isEnabled = true, cssVar: cssVar, panelId: panelId }) {
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnabled) return;
        return (0, $4hDdm.combine)((0, $7gWdR.monitorForElements)({
            canMonitor ({ source: source }) {
                return source.data.panelId === panelId;
            },
            onDrag ({ source: source }) {
                if (!(0, $3AWiS.isPanelSplitterDragData)(source.data)) return;
                /**
					 * Copies the resizing width value to the `<html>` element.
					 *
					 * Required to reflect the live width of the side navigation.
					 *
					 * Used by:
					 *   - Legacy `--leftSidebarWidth` variable
					 *   - Panel slot max-width constraint
					 *
					 * When the legacy `--leftSidebarWidth` variable is no longer needed,
					 * we could consider writing to the `Panel` element instead.
					 */ document.documentElement.style.setProperty(cssVar, source.data.resizingWidth);
            },
            onDrop () {
                document.documentElement.style.removeProperty(cssVar);
            }
        }));
    }, [
        cssVar,
        isEnabled,
        panelId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnabled) return;
        /**
		 * Ensures that the resizing CSS var on the `<html>` element is cleaned up properly
		 * if the component unmounts during a drag.
		 */ return function cleanupGlobalResizingCssVar() {
            document.documentElement.style.removeProperty(cssVar);
        };
    }, [
        cssVar,
        isEnabled
    ]);
}

});
parcelRegister("3AWiS", function(module, exports) {

$parcel$export(module.exports, "isPanelSplitterDragData", () => $f535d623adcb2c41$export$e239b3966b677000);
$parcel$export(module.exports, "PanelSplitter", () => $f535d623adcb2c41$export$db67e3f8d3d6da0f);
/* panel-splitter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cBeZP = parcelRequire("cBeZP");

var $7nsd3 = parcelRequire("7nsd3");

var $3joPi = parcelRequire("3joPi");

var $9KnKW = parcelRequire("9KnKW");

var $98OXW = parcelRequire("98OXW");

var $e4cTf = parcelRequire("e4cTf");

var $4hDdm = parcelRequire("4hDdm");

var $7gWdR = parcelRequire("7gWdR");
parcelRequire("4dYas");
var $kLEEo = parcelRequire("kLEEo");
parcelRequire("hjhoK");
var $akFFC = parcelRequire("akFFC");
parcelRequire("fmZmH");
var $3C4FG = parcelRequire("3C4FG");

var $jldZL = parcelRequire("jldZL");

var $9NI3h = parcelRequire("9NI3h");

var $gRo7J = parcelRequire("gRo7J");

var $lVIfq = parcelRequire("lVIfq");

var $fAx1P = parcelRequire("fAx1P");

var $ay5e1 = parcelRequire("ay5e1");

var $1ICwz = parcelRequire("1ICwz");
const $f535d623adcb2c41$var$containerStyles = {
    root: "_12ji1r31 _1qu2glyw _12y31o36 _1e0cglyw _kqswstnw _u7coidpf _152tidpf _1pbykb7n _181n1ule",
    positionEnd: "_rjxpftgi",
    positionStart: "_1e02zeo2"
};
const $f535d623adcb2c41$var$grabAreaStyles = {
    root: "_1bsbl52n _4t3i1osq _kqswstnw _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _syaz3acm _bfhk18uv _k8m01ylx _1oec1yx9 _1lww5cps _d0aluf7j _1gavfnf5 _vp7gaqb7 _30l3aqb7 _1dr21ylx _1s5z1ylx _1cg4fnf5 _le1bfnf5 _1gglglyw _9h8h16c2"
};
const $f535d623adcb2c41$var$lineStyles = {
    root: "_kqswstnw _1e0c1ule _1bsbjfq9 _4t3i1osq _syaz1kw7 _bfhk1r31 _1e021v6z"
};
const $f535d623adcb2c41$var$panelSplitterDragDataSymbol = Symbol('panel-splitter-drag-data');
function $f535d623adcb2c41$var$signPanelSplitterDragData(data) {
    return {
        ...data,
        [$f535d623adcb2c41$var$panelSplitterDragDataSymbol]: true
    };
}
function $f535d623adcb2c41$export$e239b3966b677000(data) {
    return data[$f535d623adcb2c41$var$panelSplitterDragDataSymbol] === true;
}
const $f535d623adcb2c41$var$PortaledPanelSplitter = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId })=>{
    const splitterRef = (0, $5uXOq.useRef)(null);
    const panelSplitterContext = (0, $5uXOq.useContext)((0, $9NI3h.PanelSplitterContext));
    (0, $3joPi.default)(panelSplitterContext, 'Panel splitter context must be set');
    const { panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, getResizeBounds: getResizeBounds, panelRef: panelRef, resizingCssVar: resizingCssVar, portalRef: portalRef, position: position, isEnabled: isEnabled } = panelSplitterContext;
    (0, $3joPi.default)(portalRef.current, 'Portal ref must be set');
    const direction = (0, $1ICwz.useTextDirection)(portalRef.current);
    const labelId = (0, $9KnKW.useId)();
    // Separate state used for the input range width to remove the UI's dependency on the "persisted" layout state value being updated
    const [rangeInputValue, setRangeInputValue] = (0, $5uXOq.useState)(panelWidth);
    /**
   * We are using state to store the resize bounds _converted into pixel units_, so that we can update them when the window is resized.
   * Otherwise they can become out of sync with the actual viewport size, and cause a broken experience (inaccurate width percentage)
   * when the user tries to resize using the keyboard.
   */ const [rangeInputBounds, setRangeInputBounds] = (0, $5uXOq.useState)({
        // Using placeholder values here for the initial render. These will be calculated and updated when the range input is focused.
        min: 200,
        max: 500
    });
    const openLayerObserver = (0, $e4cTf.useOpenLayerObserver)();
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnabled) return;
        const splitter = splitterRef.current;
        (0, $3joPi.default)(splitter, 'Splitter ref must be set');
        return (0, $4hDdm.combine)((0, $kLEEo.blockDraggingToIFrames)({
            element: splitter
        }), (0, $7gWdR.draggable)({
            element: splitter,
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                // We will be moving the line to indicate a drag. We can disable the native drag preview
                (0, $akFFC.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                });
                // We don't want any native drop animation for when the user does not drop on a drop target. We want the drag to finish immediately
                (0, $3C4FG.preventUnhandled).start();
            },
            getInitialData () {
                (0, $3joPi.default)(panelRef.current, 'Panel ref must be set');
                const initialWidth = (0, $fAx1P.getPixelWidth)(panelRef.current);
                /**
         * The drag calculations require the actual computed width of the element
         * For example, if the panel has loaded with a width of 2000px, but the max bound is 1000px and is visually 1000px (due to the CSS `clamp()`),
         * the drag calculations should use the actual width of 1000px, not the width in state of 2000px.
         */ return $f535d623adcb2c41$var$signPanelSplitterDragData({
                    panelId: panelId,
                    initialWidth: initialWidth,
                    resizingWidth: `${initialWidth}px`,
                    resizeBounds: getResizeBounds()
                });
            },
            onDragStart ({ source: source }) {
                (0, $3joPi.default)($f535d623adcb2c41$export$e239b3966b677000(source.data));
                onResizeStart?.({
                    initialWidth: source.data.initialWidth
                });
                // Close any open layers when the user starts resizing
                openLayerObserver?.closeLayers();
            },
            onDrag ({ location: location, source: source }) {
                (0, $3joPi.default)($f535d623adcb2c41$export$e239b3966b677000(source.data));
                const { initialWidth: initialWidth, resizeBounds: resizeBounds } = source.data;
                /**
         * How wide the element would be if there were no width constraints,
         * based on the pointer's position.
         */ const targetWidth = (0, $fAx1P.getWidthFromDragLocation)({
                    initialWidth: initialWidth,
                    location: location,
                    direction: direction,
                    position: position
                });
                const resizingWidth = `clamp(${resizeBounds.min}, ${targetWidth}px, ${resizeBounds.max})`;
                panelRef.current?.style.setProperty(resizingCssVar, resizingWidth);
                source.data.resizingWidth = resizingWidth;
            },
            onDrop ({ source: source }) {
                (0, $3joPi.default)($f535d623adcb2c41$export$e239b3966b677000(source.data));
                (0, $3C4FG.preventUnhandled).stop();
                (0, $3joPi.default)(panelRef.current, 'Panel ref must be set');
                (0, $3joPi.default)($f535d623adcb2c41$export$e239b3966b677000(source.data));
                const finalWidth = (0, $fAx1P.getPixelWidth)(panelRef.current);
                onCompleteResize(finalWidth);
                onResizeEnd?.({
                    initialWidth: source.data.initialWidth,
                    finalWidth: finalWidth
                });
                panelRef.current.style.removeProperty(resizingCssVar);
            }
        }));
    }, [
        onCompleteResize,
        onResizeStart,
        onResizeEnd,
        panelRef,
        resizingCssVar,
        panelWidth,
        direction,
        position,
        isEnabled,
        openLayerObserver,
        panelId,
        getResizeBounds
    ]);
    const onResizeStartStableRef = (0, $98OXW.default)(onResizeStart);
    const onResizeEndStableRef = (0, $98OXW.default)(onResizeEnd);
    const [keyboardResizeManager] = (0, $5uXOq.useState)(()=>(0, $ay5e1.createKeyboardResizeManager)({
            onResizeStart: (...args)=>{
                // Close any open layers when the user starts resizing with keyboard
                openLayerObserver?.closeLayers();
                onResizeStartStableRef.current?.(...args);
            },
            onResizeEnd: (...args)=>onResizeEndStableRef.current?.(...args)
        }));
    const handleSliderInputChange = (0, $5uXOq.useCallback)((event)=>{
        const value = parseInt(event.target.value);
        setRangeInputValue(value);
        /**
     * We are intentionally _not_ debouncing `onCompleteResize` as we want it to be called anytime the user changes the range input value.
     * It is an internal-only callback - it's provided by `PanelSplitterProvider`, and used by layout slots to update their layout width state.
     */ onCompleteResize(value);
        keyboardResizeManager.onResize({
            initialWidth: panelWidth,
            finalWidth: value
        });
    }, [
        onCompleteResize,
        panelWidth,
        keyboardResizeManager
    ]);
    const resizeEventListenerCleanupFn = (0, $5uXOq.useRef)(null);
    const handleSliderFocus = (0, $5uXOq.useCallback)(()=>{
        /**
     * We are only updating the range input's properties when the element is focused, as a performance optimisation.
     * It isn't necessary to recalculate these values until the element is going to be used.
     */ // Clean up any left over listeners in case `focus` was triggered again without `blur`.
        resizeEventListenerCleanupFn.current?.();
        // Update the range input value to match the current panel width.
        setRangeInputValue(panelWidth);
        const resizeBounds = getResizeBounds();
        // Update the range input bounds to ensure they are accurate (in case the viewport was previously resized)
        setRangeInputBounds({
            min: (0, $gRo7J.convertResizeBoundToPixels)(resizeBounds.min),
            max: (0, $gRo7J.convertResizeBoundToPixels)(resizeBounds.max)
        });
        /**
     * _While the slider element is focused_, add a window resize event listener to update the range input bounds
     * when the window is resized. This is needed to ensure the min and max widths accurately reflect the viewport
     * size - in case they are provided in vw units.
     *
     * This listener is cleaned up when the element is blurred.
     */ resizeEventListenerCleanupFn.current = (0, $cBeZP.bind)(window, {
            type: 'resize',
            listener: function updateState() {
                const resizeBounds = getResizeBounds();
                setRangeInputBounds({
                    min: (0, $gRo7J.convertResizeBoundToPixels)(resizeBounds.min),
                    max: (0, $gRo7J.convertResizeBoundToPixels)(resizeBounds.max)
                });
            }
        });
    }, [
        panelWidth,
        getResizeBounds
    ]);
    const handleSliderBlur = (0, $5uXOq.useCallback)(()=>{
        // Remove the resize event listener when the range input is blurred.
        resizeEventListenerCleanupFn.current?.();
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        return function cleanup() {
            // Cleanup the resize event listener when the component is unmounted.
            resizeEventListenerCleanupFn.current?.();
        };
    }, []);
    const ariaValueText = (0, $5uXOq.useMemo)(()=>`${(0, $lVIfq.getPercentageWithinPixelBounds)({
            currentWidth: rangeInputValue,
            resizeBounds: rangeInputBounds
        })}% width`, [
        rangeInputValue,
        rangeInputBounds
    ]);
    if (!isEnabled) return null;
    return /*#__PURE__*/ (0, $7nsd3.createPortal)(/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId ? `${testId}-container` : undefined,
        className: (0, $bwpsq.default)([
            $f535d623adcb2c41$var$containerStyles.root,
            position === 'start' && $f535d623adcb2c41$var$containerStyles.positionStart,
            position === 'end' && $f535d623adcb2c41$var$containerStyles.positionEnd
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            ref: splitterRef,
            "data-testid": testId,
            className: (0, $bwpsq.default)([
                $f535d623adcb2c41$var$grabAreaStyles.root
            ]),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $jldZL.default), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                            type: "range",
                            value: rangeInputValue,
                            step: 20,
                            min: rangeInputBounds.min,
                            max: rangeInputBounds.max,
                            "aria-valuetext": ariaValueText,
                            "aria-labelledby": labelId,
                            onChange: handleSliderInputChange,
                            onFocus: handleSliderFocus,
                            onBlur: handleSliderBlur
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                            id: labelId,
                            children: label
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    className: (0, $bwpsq.default)([
                        $f535d623adcb2c41$var$lineStyles.root
                    ])
                })
            ]
        })
    }), portalRef.current);
};
// Ensures that the component is only rendered on a client. Uses a `useEffect`, which is not run on servers.
const $f535d623adcb2c41$var$ClientOnly = ({ children: children })=>{
    const [hasMounted, setHasMounted] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        setHasMounted(true);
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: hasMounted ? children : null
    });
};
const $f535d623adcb2c41$export$db67e3f8d3d6da0f = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)($f535d623adcb2c41$var$ClientOnly, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($f535d623adcb2c41$var$PortaledPanelSplitter, {
            label: label,
            onResizeStart: onResizeStart,
            onResizeEnd: onResizeEnd,
            testId: testId
        })
    });

});
parcelRegister("e4cTf", function(module, exports) {

$parcel$export(module.exports, "useOpenLayerObserver", () => $ea3ab92c791f0d5d$export$750f5b0d6c51617e);

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");

var $kEhTY = parcelRequire("kEhTY");
function $ea3ab92c791f0d5d$export$750f5b0d6c51617e() {
    const context = (0, $5uXOq.useContext)((0, $kEhTY.OpenLayerObserverContext));
    (0, $3joPi.default)(context, 'useOpenLayerObserver must be used within an OpenLayerObserver');
    const publicAPI = (0, $5uXOq.useMemo)(()=>({
            getCount: context.getCount,
            onChange: context.onChange,
            closeLayers: context.closeLayers
        }), [
        context.getCount,
        context.onChange,
        context.closeLayers
    ]);
    return publicAPI;
}

});

parcelRegister("4dYas", function(module, exports) {

$parcel$export(module.exports, "blockDraggingToIFrames", () => (parcelRequire("kLEEo")).blockDraggingToIFrames);

var $kLEEo = parcelRequire("kLEEo");

});
parcelRegister("kLEEo", function(module, exports) {

$parcel$export(module.exports, "blockDraggingToIFrames", () => $85c97841a27447ca$export$6ae1d8fab001518c);

var $40DDD = parcelRequire("40DDD");

var $3zl3q = parcelRequire("3zl3q");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $85c97841a27447ca$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
    const originalValue = el.style.getPropertyValue(property);
    const originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
let $85c97841a27447ca$var$isActive = false;
/**
 * Start blocking dragging to iframes. Only to be called once a drag has started.
 */ function $85c97841a27447ca$var$tryStart() {
    // There can technically be multiple registrations on the same element.
    // Adding a guard to ensure that only one registration does the blocking.
    if ($85c97841a27447ca$var$isActive) return;
    $85c97841a27447ca$var$isActive = true;
    // At this stage, we are also not watching for new iframe elements being added to the page
    // (we _could_ do that as a future change)
    const iframeCleanups = Array.from(document.querySelectorAll('iframe')).map((iframe)=>$85c97841a27447ca$var$setStyle(iframe, {
            property: 'pointer-events',
            rule: 'none',
            priority: 'important'
        }));
    // Not returning the cleanup function.
    // This code will clean itself up when the interaction ends in `onDrop()`.
    // Once a drag has started we are blocking iframes until the interaction is finished.
    const cleanup = (0, $3zl3q.combine)(...iframeCleanups, // We only need this monitor for listening to the drop
    // as our monitor in `blockDraggingToIFrames()` will only
    // call this function when the drag has started
    (0, $40DDD.monitorForElements)({
        onDrop () {
            cleanup();
        }
    }), function release() {
        $85c97841a27447ca$var$isActive = false;
    });
}
function $85c97841a27447ca$export$6ae1d8fab001518c({ element: element }) {
    return (0, $40DDD.monitorForElements)({
        onGenerateDragPreview ({ source: source }) {
            // only starting if we are dragging the provided element
            if (source.element === element) $85c97841a27447ca$var$tryStart();
        }
    });
}

});


parcelRegister("hjhoK", function(module, exports) {

$parcel$export(module.exports, "disableNativeDragPreview", () => (parcelRequire("akFFC")).disableNativeDragPreview);

var $akFFC = parcelRequire("akFFC");

});
parcelRegister("akFFC", function(module, exports) {

$parcel$export(module.exports, "disableNativeDragPreview", () => $1774d76ee1100c7d$export$c588cb30ff3b876e);
// In order to disable the native drag preview you can
// use `event.dataTransfer.setDragImage()` to set a small
// invisible image as the drag preview.
// There are alternative techniques,
// (eg setting opacity to in onGenerateDragPreview and then 1 in onDragStart)
// but the technique in this file worked best across browsers and platforms
// Here we are preloading the image so that it is ready for the first drag.
// Even though the image is base64 encoded, the browser queues an async task
// to decode the image. The image needs to be decoded before it can be used
const $1774d76ee1100c7d$var$tinyTransparentImage = (()=>{
    // SSR safe
    if (typeof window === 'undefined') return null;
    // Image generated by: https://png-pixel.com/
    // It is a 1x1 transparent gif
    // It is the smallest possible transparent image we could find that works on all platforms
    // Note: using an encoded SVG would be nicer code, but it doesn't work on iOS
    const img = new Image();
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    return img;
})();
function $1774d76ee1100c7d$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
    if (nativeSetDragImage && $1774d76ee1100c7d$var$tinyTransparentImage) nativeSetDragImage($1774d76ee1100c7d$var$tinyTransparentImage, 0, 0);
}

});


parcelRegister("fmZmH", function(module, exports) {

$parcel$export(module.exports, "preventUnhandled", () => (parcelRequire("3C4FG")).preventUnhandled);

var $3C4FG = parcelRequire("3C4FG");

});
parcelRegister("3C4FG", function(module, exports) {

$parcel$export(module.exports, "preventUnhandled", () => $bc1937186f99453b$export$453c0582481cc59d);

var $cBeZP = parcelRequire("cBeZP");

var $h5V4I = parcelRequire("h5V4I");
function $bc1937186f99453b$var$acceptDrop(event) {
    // if the event is already prevented the event we don't need to do anything
    if (event.defaultPrevented) return;
    // Using "move" as the drop effect as that uses the standard
    // cursor. Doing this so the user doesn't think they are dropping
    // on the page
    // Note: using "none" will not allow a "drop" to occur, so we are using "move"
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    // cancel the default browser behaviour
    // doing this will tell the browser that we have handled the drop
    event.preventDefault();
}
let $bc1937186f99453b$var$unbindEvents = null;
/**
 * Block drag operations outside of `@atlaskit/pragmatic-drag-and-drop`
 */ function $bc1937186f99453b$var$start() {
    $bc1937186f99453b$var$cleanup();
    $bc1937186f99453b$var$unbindEvents = (0, $cBeZP.bindAll)(window, [
        {
            type: 'dragover',
            listener: $bc1937186f99453b$var$acceptDrop
        },
        {
            type: 'dragenter',
            listener: $bc1937186f99453b$var$acceptDrop
        },
        {
            type: 'drop',
            listener (event) {
                // our lifecycle manager already prevents events, but just being super safe
                event.preventDefault();
                // not setting dropEffect, as `drop.dropEffect` has already been published to the user
                // (lifecycle-manager binds events in the capture phase)
                // we don't need to wait for "dragend", and "dragend" might not even happen,
                // such as when the draggable has been removed during a drag.
                $bc1937186f99453b$var$cleanup();
            }
        },
        {
            type: 'dragend',
            listener: $bc1937186f99453b$var$cleanup
        },
        ...(0, $h5V4I.getBindingsForBrokenDrags)({
            onDragEnd: $bc1937186f99453b$var$cleanup
        })
    ], // being clear that these are added in the bubble phase
    {
        capture: false
    });
}
function $bc1937186f99453b$var$cleanup() {
    $bc1937186f99453b$var$unbindEvents?.();
    $bc1937186f99453b$var$unbindEvents = null;
}
/**
 * TODO: for next major, we could look at do the following:
 *
 * ```diff
 * - preventUnhandled.start();
 * - preventUnhandled.stop();
 * + const stop = preventUnhandled();
 * ```
 */ function $bc1937186f99453b$var$stop() {
    /**
	 * if `stop()` is called in a `"drop"` event, then `event.preventDefault()` won't be called.
	 * Our `"drop"` listener calls `event.preventDefault()` for handled drop events
	 * ("drop" events caused by dropping over a drop target)
	 * `preventUnhandled()` causes every element to become a drop target (according to the browser)
	 *
	 * To opt out of the default behaviour for a `"drop"` event, we need to make sure
	 * that we cancel it.
	 *
	 * The `"drop"` event listener in core is in the `capture` phase, so people calling
	 * `preventUnhandled.stop()` in `onDrop()` will remove the `"drop"` event listener in this
	 * file before it has the chance to cancel the event.
	 *
	 * Being sneaky and using the `window.event` global to sniff out the current event
	 */ if (window.event?.type === 'drop') window.event?.preventDefault();
    $bc1937186f99453b$var$cleanup();
}
const $bc1937186f99453b$export$453c0582481cc59d = {
    start: $bc1937186f99453b$var$start,
    stop: $bc1937186f99453b$var$stop
};

});


parcelRegister("gRo7J", function(module, exports) {

$parcel$export(module.exports, "convertResizeBoundToPixels", () => $4ac469c14ce45896$export$3d412b3011b66f82);
function $4ac469c14ce45896$export$3d412b3011b66f82(resizeBound) {
    if (resizeBound.endsWith('vw')) {
        // Max width was provided in `vw` units, so is relative to the viewport width.
        // e.g. 50vw = 50% of the viewport width.
        // `parseInt` will remove the `vw` suffix.
        const maxWidthFraction = parseInt(resizeBound) / 100;
        return Math.floor(window.innerWidth * maxWidthFraction);
    }
    // Max width was provided in `px` units, so we can parse it directly.
    // `parseInt` will remove the `px` suffix.
    return Math.floor(parseInt(resizeBound));
}

});

parcelRegister("lVIfq", function(module, exports) {

$parcel$export(module.exports, "getPercentageWithinPixelBounds", () => $eb54cea8a4880815$export$b5423678cdf09f5);
function $eb54cea8a4880815$export$b5423678cdf09f5({ currentWidth: currentWidth, resizeBounds: resizeBounds }) {
    const resizeRange = resizeBounds.max - resizeBounds.min;
    const widthAsPercentage = (currentWidth - resizeBounds.min) / resizeRange * 100;
    if (widthAsPercentage < 0) return 0;
    if (widthAsPercentage > 100) return 100;
    return Math.floor(widthAsPercentage);
}

});

parcelRegister("fAx1P", function(module, exports) {

$parcel$export(module.exports, "getWidthFromDragLocation", () => $e9a4e6873a340be1$export$e360234971cb95b8);
$parcel$export(module.exports, "getPixelWidth", () => $e9a4e6873a340be1$export$d942790ad00c41f9);
const $e9a4e6873a340be1$export$e360234971cb95b8 = ({ initialWidth: initialWidth, location: location, direction: direction, position: position })=>{
    const diffX = location.current.input.clientX - location.initial.input.clientX;
    // Resize line is positioned at the inline-end (right) of the element.
    // If the direction is left-to-right, the width will increase when the mouse is moved to the right, and vice versa.
    if (position === 'end') return direction === 'ltr' ? initialWidth + diffX : initialWidth - diffX;
    // Resize line is positioned at the inline-start (left) of the element.
    // If the direction is left-to-right, the width will decrease when the mouse is moved to the right, and vice versa.
    return direction === 'ltr' ? initialWidth - diffX : initialWidth + diffX;
};
const $e9a4e6873a340be1$export$d942790ad00c41f9 = (element)=>{
    const { width: width } = window.getComputedStyle(element);
    return parseInt(width);
};

});

parcelRegister("ay5e1", function(module, exports) {

$parcel$export(module.exports, "createKeyboardResizeManager", () => $c3821cbf3d3af233$export$f7d3d5dae65f74aa);
/**
 * The debounce time for the PanelSplitter resize callback functions.
 *
 * - For `onResizeStart`, it will call the callback immediately, but not
 * again until the user stops resizing and this wait time has passed.
 * - For `onResizeEnd`, it will call the callback only after this time has
 * passed since the last resize event.
 */ const $c3821cbf3d3af233$var$resizeCallbackDebounceTimeMs = 500;
function $c3821cbf3d3af233$export$f7d3d5dae65f74aa({ onResizeStart: onResizeStart, onResizeEnd: onResizeEnd }) {
    let resizingState = {
        type: 'idle'
    };
    /**
	 * Starts a timer to reset the state to idle and call `onResizeEnd` after a wait time.
	 */ function startResizeEndTimer({ initialWidth: initialWidth, finalWidth: finalWidth }) {
        const markResizeAsEndedTimeout = setTimeout(()=>{
            onResizeEnd({
                initialWidth: initialWidth,
                finalWidth: finalWidth
            });
            resizingState = {
                type: 'idle'
            };
        }, $c3821cbf3d3af233$var$resizeCallbackDebounceTimeMs);
        resizingState = {
            type: 'resizing',
            initialWidth: initialWidth,
            abort () {
                clearTimeout(markResizeAsEndedTimeout);
            }
        };
    }
    function onResize({ initialWidth: initialWidth, finalWidth: finalWidth }) {
        if (resizingState.type === 'idle') {
            // If the state was idle, this counts as a resize start event.
            onResizeStart({
                initialWidth: initialWidth
            });
            startResizeEndTimer({
                initialWidth: initialWidth,
                finalWidth: finalWidth
            });
            return;
        }
        if (resizingState.type === 'resizing') {
            // If the state was already resizing, clear the existing timeout and start a new one.
            resizingState.abort();
            startResizeEndTimer({
                initialWidth: resizingState.initialWidth,
                finalWidth: finalWidth
            });
            return;
        }
    }
    return {
        onResize: onResize
    };
}

});

parcelRegister("1ICwz", function(module, exports) {

$parcel$export(module.exports, "useTextDirection", () => $19142174bc5bbe23$export$cf24a79f32f45545);

var $5uXOq = parcelRequire("5uXOq");
const $19142174bc5bbe23$export$cf24a79f32f45545 = (element)=>(0, $5uXOq.useMemo)(()=>{
        const { direction: direction } = window.getComputedStyle(element);
        return direction === 'rtl' ? 'rtl' : 'ltr';
    }, [
        element
    ]);

});




parcelRegister("jjRN8", function(module, exports) {

$parcel$export(module.exports, "Banner", () => $365358079a8d32db$export$3b4e64e77073e307);
/* banner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $585q9 = parcelRequire("585q9");

var $ilnvx = parcelRequire("ilnvx");

var $8oF23 = parcelRequire("8oF23");

var $2WR37 = parcelRequire("2WR37");

var $8mXqE = parcelRequire("8mXqE");
const $365358079a8d32db$var$styles = {
    root: "_nd5ldkfm _1reo15vq _18m915vq _4t3iutvi _152tidpf _kqsw1if8 _1pbyegat"
};
function $365358079a8d32db$export$3b4e64e77073e307({ children: children, xcss: xcss, height: // 48px has been chosen to align with the height of the Banner component from `@atlaskit/banner`.
height = (0, $VSDnB.fg)('platform_dst_nav4_banner_default_height') ? 48 : 64, skipLinkLabel: skipLinkLabel = 'Banner', testId: testId, id: providedId }) {
    const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, $8oF23.DangerouslyHoistSlotSizes));
    const id = (0, $8mXqE.useLayoutId)({
        providedId: providedId
    });
    /**
   * Don't show the skip link if the slot has 0 height.
   */ (0, $585q9.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: height === 0
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        id: id,
        "data-layout-slot": true,
        className: (0, $bwpsq.default)([
            $365358079a8d32db$var$styles.root,
            xcss
        ]),
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WR37.HoistCssVarToLocalGrid), {
                variableName: (0, $ilnvx.bannerMountedVar),
                value: height
            }),
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WR37.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $ilnvx.UNSAFE_bannerVar),
                value: height
            }),
            children
        ]
    });
}

});

parcelRegister("hOWCC", function(module, exports) {

$parcel$export(module.exports, "Main", () => $325f1d6156df91d8$export$861edd1ccea2f746);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $585q9 = parcelRequire("585q9");

var $8mXqE = parcelRequire("8mXqE");

var $2GcIE = parcelRequire("2GcIE");
const $325f1d6156df91d8$var$mainElementStyles = {
    root: "_nd5l1gzg _19121cl4 _qwfh1wug",
    fixedContentArea: "_1reo1wug _18m91wug _152timx3 _165teqxy _13wn1if8"
};
function $325f1d6156df91d8$export$861edd1ccea2f746({ children: children, isFixed: isFixedProp, xcss: xcss, skipLinkLabel: skipLinkLabel = 'Main Content', testId: testId, id: providedId }) {
    const id = (0, $8mXqE.useLayoutId)({
        providedId: providedId
    });
    const isFixed = (0, $VSDnB.fg)('platform_dst_nav4_disable_is_fixed_prop') ? true : isFixedProp;
    (0, $585q9.useSkipLink)(id, skipLinkLabel);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            id: id,
            "data-layout-slot": true,
            className: (0, $bwpsq.default)([
                $325f1d6156df91d8$var$mainElementStyles.root,
                isFixed && $325f1d6156df91d8$var$mainElementStyles.fixedContentArea,
                xcss
            ]),
            role: "main",
            "data-testid": testId,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2GcIE.MainStickyContext).Provider, {
                value: Boolean(isFixed),
                children: children
            })
        })
    });
}

});
parcelRegister("2GcIE", function(module, exports) {

$parcel$export(module.exports, "MainStickyContext", () => $7ccaf10616775f74$export$3b369e2c6c1ec840);

var $5uXOq = parcelRequire("5uXOq");
const $7ccaf10616775f74$export$3b369e2c6c1ec840 = /*#__PURE__*/ (0, $5uXOq.createContext)(false);

});


parcelRegister("ZlCus", function(module, exports) {

$parcel$export(module.exports, "Panel", () => $05534568732462ab$export$2ddb90ad54e5f587);
/* panel.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $h9kUS = parcelRequire("h9kUS");

var $585q9 = parcelRequire("585q9");

var $ilnvx = parcelRequire("ilnvx");

var $8oF23 = parcelRequire("8oF23");

var $2WR37 = parcelRequire("2WR37");

var $8mXqE = parcelRequire("8mXqE");

var $fVO1C = parcelRequire("fVO1C");

var $5rLY7 = parcelRequire("5rLY7");

var $2HiMp = parcelRequire("2HiMp");
const $05534568732462ab$var$panelSplitterResizingVar = '--n_pnlRsz';
/**
 * The bounds for Aside and Panel are purposely set to support the current usage in Jira.
 *
 * Jira sets the slot's width to `0px` when there is no active content to display in it.
 *   - This means the min width needs to support `0px`.
 * The Conversation Assistant component in Jira (rendered in a nav3 RightSidebar, or a nav4 Aside) has a custom resizing
 * implementation, which has a maximum width of `50vw`.
 *   - This means the max width needs to support `50vw`.
 *
 * This is not the final implementation and will be updated once Jira's usage has been fixed.
 * Ticket to track this is: https://jplat.atlassian.net/browse/BLU-3951
 *
 * We're using two different bounds for each slot here, to support the `0px` min width when programatically set using the
 * `defaultWidth` prop, and another one that is used when resizing the slots which has a sensible min width.
 */ const $05534568732462ab$var$oldPanelWidthSlotBounds = {
    min: '0px',
    max: '50vw'
};
const $05534568732462ab$var$oldPanelWidthResizeBounds = {
    min: '120px',
    max: '50vw'
};
function $05534568732462ab$var$getOldResizeBounds() {
    return $05534568732462ab$var$oldPanelWidthResizeBounds;
}
/**
 * We typically use the `defaultWidth` as the minimum resizing width,
 * but for large default widths we fallback to a standard value.
 *
 * This standard value of `400px` is to align with the Global Preview Panels.
 */ const $05534568732462ab$var$fallbackResizeMinWidth = 400;
const $05534568732462ab$var$styles = {
    root: "_nd5l1b6c _10fph9n0 _vchhusvi _1pbykb7n _4t3ieqxy _kqsw1if8 _152timx3 _bfhk1bhr _14b54rrg _4ap3vuon _1dhy1c6w _9sns1wug",
    border: "_191wglyw _16qs1cd0 _1w6ezgxb _scbpglyw",
    scrollContainer: "_1reo1wug _18m91wug _4t3i1osq",
    hidden: "_1e0cglyw",
    oldMobileWidth: "_1bsb1adv",
    newMobileWidth: "_1bsb1dxx"
};
function $05534568732462ab$export$2ddb90ad54e5f587({ children: children, defaultWidth: defaultWidth = 365, label: label = 'Panel', skipLinkLabel: skipLinkLabel = label, testId: testId, id: providedId, xcss: xcss, hasBorder: hasBorder = (0, $VSDnB.fg)('platform_design_system_nav4_panel_default_border') }) {
    const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, $8oF23.DangerouslyHoistSlotSizes));
    const id = (0, $8mXqE.useLayoutId)({
        providedId: providedId
    });
    /**
   * Don't show the skip link if the slot has 0 width.
   *
   * Remove `isHidden` usage after https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $585q9.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: defaultWidth === 0
    });
    const ref = (0, $5uXOq.useRef)(null);
    const [width, setWidth] = (0, $5uXOq.useState)(defaultWidth);
    // Used to track the previous value of the `defaultWidth` prop, for logging dev warnings when it changes.
    const defaultWidthRef = (0, $5uXOq.useRef)(defaultWidth);
    /**
   * TODO: Remove this useEffect once the `width: 0` usage is removed from Jira.
   * It updates the width state based on changes to `defaultWidth`, as a temporary stopgap to support Jira's current usage.
   * https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $5uXOq.useEffect)(()=>{
        if (defaultWidthRef.current === defaultWidth) return;
        defaultWidthRef.current = defaultWidth;
        setWidth(defaultWidth);
    }, [
        defaultWidth
    ]);
    const sideNavRef = (0, $5rLY7.useSideNavRef)();
    /**
   * The minimum width that the panel can be resized to by the user.
   *
   * We only use the `defaultWidth` up to a point to avoid huge panels.
   */ const minWidth = Math.min(defaultWidth, $05534568732462ab$var$fallbackResizeMinWidth);
    const getNewResizeBounds = (0, $5uXOq.useCallback)(()=>{
        const sideNavWidth = sideNavRef.current?.offsetWidth ?? 0;
        /**
     * The panel should not resize larger than the page content, equivalent to the `Main` + `Aside` slots.
     *
     * This maximum width is equivalent to half the viewport width, after removing the sidebar width.
     */ const maxWidth = Math.round((window.innerWidth - sideNavWidth) / 2);
        return {
            min: `${minWidth}px`,
            max: `${maxWidth}px`
        };
    }, [
        minWidth,
        sideNavRef
    ]);
    const panelWidthSlotBounds = (0, $VSDnB.fg)('platform_design_system_nav4_preview_panel_support') ? {
        min: `${minWidth}px`,
        // `sideNavLiveWidthVar` is not defined if the `SideNav` is not mounted, so we fallback to `0px`.
        max: `round(nearest, calc((100vw - var(${0, $ilnvx.sideNavLiveWidthVar}, 0px)) / 2), 1px)`
    } : $05534568732462ab$var$oldPanelWidthSlotBounds;
    const panelVariableWidth = `clamp(${panelWidthSlotBounds.min}, ${width}px, ${panelWidthSlotBounds.max})`;
    (0, $2HiMp.useResizingWidthCssVarOnRootElement)({
        isEnabled: dangerouslyHoistSlotSizes && (0, $VSDnB.fg)('platform_design_system_nav4_live_resizing_css_vars'),
        cssVar: $05534568732462ab$var$panelSplitterResizingVar,
        panelId: (0, $ilnvx.panelPanelSplitterId)
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("section", {
        id: id,
        "data-layout-slot": true,
        "aria-label": label,
        className: (0, $bwpsq.default)([
            $05534568732462ab$var$styles.root,
            defaultWidth === 0 && $05534568732462ab$var$styles.hidden,
            hasBorder && $05534568732462ab$var$styles.border,
            (0, $VSDnB.fg)('platform_design_system_nav4_panel_mobile_width_fix') ? $05534568732462ab$var$styles.newMobileWidth : $05534568732462ab$var$styles.oldMobileWidth,
            xcss
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            [(0, $ilnvx.panelVar)]: panelVariableWidth,
            '--minWidth': (0, $VSDnB.fg)('platform_design_system_nav4_panel_mobile_width_fix') ? `${minWidth}px` : undefined
        },
        "data-testid": testId,
        ref: ref,
        children: [
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WR37.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $ilnvx.UNSAFE_panelLayoutVar),
                value: "0px",
                mediaQuery: (0, $h9kUS.media).above.lg,
                responsiveValue: (0, $VSDnB.fg)('platform_design_system_nav4_live_resizing_css_vars') ? `var(${$05534568732462ab$var$panelSplitterResizingVar}, ${panelVariableWidth})` : panelVariableWidth
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVO1C.PanelSplitterProvider), {
                panelId: (0, $ilnvx.panelPanelSplitterId),
                panelRef: ref,
                panelWidth: width,
                onCompleteResize: setWidth,
                getResizeBounds: (0, $VSDnB.fg)('platform_design_system_nav4_preview_panel_support') ? getNewResizeBounds : $05534568732462ab$var$getOldResizeBounds,
                resizingCssVar: $05534568732462ab$var$panelSplitterResizingVar,
                position: "start",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $05534568732462ab$var$styles.scrollContainer
                    ]),
                    children: children
                })
            })
        ]
    });
}

});

parcelRegister("kTus1", function(module, exports) {

$parcel$export(module.exports, "SideNav", () => $be4966f89908f895$export$1a35787d6353cf6a);
/* side-nav.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cBeZP = parcelRequire("cBeZP");

var $7nsd3 = parcelRequire("7nsd3");

var $5JjdN = parcelRequire("5JjdN");

var $lJmpK = parcelRequire("lJmpK");
var $e4cTf = parcelRequire("e4cTf");

var $VSDnB = parcelRequire("VSDnB");

var $7gWdR = parcelRequire("7gWdR");

var $h9kUS = parcelRequire("h9kUS");

var $585q9 = parcelRequire("585q9");

var $7NFvZ = parcelRequire("7NFvZ");

var $ilnvx = parcelRequire("ilnvx");

var $8oF23 = parcelRequire("8oF23");

var $2WR37 = parcelRequire("2WR37");

var $8mXqE = parcelRequire("8mXqE");

var $fVO1C = parcelRequire("fVO1C");

var $2HiMp = parcelRequire("2HiMp");

var $5rLY7 = parcelRequire("5rLY7");


var $eZOeM = parcelRequire("eZOeM");

var $fD6iO = parcelRequire("fD6iO");

var $ecbZX = parcelRequire("ecbZX");

var $27t8Q = parcelRequire("27t8Q");

var $6qnkT = parcelRequire("6qnkT");

var $b0CFU = parcelRequire("b0CFU");
const $be4966f89908f895$var$panelSplitterResizingVar = '--n_snvRsz';
const $be4966f89908f895$var$widthResizeBounds = {
    min: '240px',
    max: '50vw'
};
function $be4966f89908f895$var$getResizeBounds() {
    return $be4966f89908f895$var$widthResizeBounds;
}
const $be4966f89908f895$var$openLayerObserverSideNavNamespace = 'side-nav';
const $be4966f89908f895$var$styles = {
    root: "_nd5l1b6c _bfhk1bhr _16qs1cd0 _vchhusvi _4t3ieqxy _152timx3 _kqsw1if8 _1bsb1ego _1pbycs5v _14b5hc79 _qilnk0mc _4ap3vuon _scbpglyw",
    oldBorder: "_t51zzgxb",
    newBorder: "_191wglyw _t51zglyw _p5clzgxb",
    newBorderFlyoutOpen: "_p5clglyw",
    flyoutOpen: "_qiln1gzg _4ap31bhr _scbp1cd0 _139f8iot _1tpvfnf5 _sylc1a5r _oyeijq3t",
    flyoutAnimateClosed: "_1e0cglyw _qiln1gzg _139f8iot _1tpvfnf5 _sylc1a5r _1uwsjq3t",
    flexContainer: "_4t3i1osq _1e0c1txw _2lx21bp4 _1bah1yb4",
    hiddenMobileAndDesktop: "_1e0cglyw",
    hiddenMobileOnly: "_1e0cglyw _dm2518uv",
    hiddenDesktopOnly: "_dm25glyw"
};
/**
 * We need an additional component layer so we can wrap the side nav in a `OpenLayerObserver` and have access to the
 * context value.
 */ function $be4966f89908f895$var$SideNavInternal({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, testId: testId, label: label = 'Sidebar', skipLinkLabel: skipLinkLabel = label, onExpand: onExpand, onCollapse: onCollapse, id: providedId }) {
    const id = (0, $8mXqE.useLayoutId)({
        providedId: providedId
    });
    const expandSideNav = (0, $fD6iO.useExpandSideNav)();
    /**
   * Called after clicking on the side nav skip link, and ensures the side nav is expanded so that it is focusable.
   *
   * We need to update the DOM synchronously because `.focus()` is called synchronously after this state update.
   */ const synchronouslyExpandSideNav = (0, $5uXOq.useCallback)(()=>{
        (0, $7nsd3.flushSync)(()=>{
            /**
       * Calling this unconditionally and relying on it to avoid no-op renders.
       *
       * We _could_ call it conditionally, but we'd be duplicating the screen size checks `expandSideNav` makes.
       */ expandSideNav();
        });
    }, [
        expandSideNav
    ]);
    (0, $585q9.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        onBeforeNavigate: synchronouslyExpandSideNav
    });
    const sideNavState = (0, $5uXOq.useContext)((0, $b0CFU.SideNavVisibilityState));
    const setSideNavState = (0, $5uXOq.useContext)((0, $b0CFU.SetSideNavVisibilityState));
    const { isExpandedOnDesktop: isExpandedOnDesktop, isExpandedOnMobile: isExpandedOnMobile } = (0, $ecbZX.useSideNavVisibility)({
        defaultCollapsed: defaultCollapsed
    });
    // We are placing `defaultCollapsed` into a state container so we can have a stable reference to the initial value.
    // This is so we can use it in an effect _that only runs once_, after the initial render on the client,
    // to sync the side nav context (provided in `<Root>`) with the `defaultCollapsed` prop provided to `<SideNav>`.
    const [initialDefaultCollapsed] = (0, $5uXOq.useState)(defaultCollapsed);
    const [width, setWidth] = (0, $5uXOq.useState)(defaultWidth);
    const clampedWidth = `clamp(${$be4966f89908f895$var$widthResizeBounds.min}, ${width}px, ${$be4966f89908f895$var$widthResizeBounds.max})`;
    const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, $8oF23.DangerouslyHoistSlotSizes));
    const navRef = (0, $5uXOq.useRef)(null);
    /**
   * Used to share the side nav element with the `Panel`,
   * which observes the side nav to determine its maximum width.
   */ const sharedRef = (0, $5rLY7.useSideNavRef)();
    const mergedRef = (0, $5JjdN.default)([
        navRef,
        sharedRef
    ]);
    const toggleButtonElement = (0, $5uXOq.useContext)((0, $eZOeM.SideNavToggleButtonElement));
    const topNavStartElement = (0, $5uXOq.useContext)((0, $7NFvZ.TopNavStartElement));
    const devTimeOnlyAttributes = {};
    const openLayerObserver = (0, $e4cTf.useOpenLayerObserver)();
    const flyoutStateRef = (0, $5uXOq.useRef)({
        type: 'not-active'
    });
    const isFlyoutVisible = sideNavState?.flyout === 'open';
    const updateFlyoutState = (0, $5uXOq.useMemo)(()=>{
        function tryAbortPendingClose() {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
        }
        function open() {
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: 'open'
            };
            setSideNavState((currentState)=>{
                if (currentState?.desktop === 'collapsed' && currentState?.flyout !== 'open') return {
                    desktop: currentState.desktop,
                    mobile: currentState.mobile,
                    flyout: 'open'
                };
                return currentState;
            });
        }
        function close() {
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: 'not-active'
            };
            setSideNavState((currentState)=>{
                if (currentState?.desktop === 'collapsed' && currentState?.flyout === 'open') return {
                    desktop: currentState.desktop,
                    mobile: currentState.mobile,
                    flyout: 'triggered-animate-close'
                };
                return currentState;
            });
        }
        return function onAction(action) {
            if (action === 'drag-from-flyout-started') {
                open();
                flyoutStateRef.current = {
                    type: 'is-dragging-from-flyout'
                };
                return;
            }
            if (action === 'drag-from-flyout-finished') {
                open();
                return;
            }
            // ignoring all actions until the drag is finished
            if (flyoutStateRef.current.type === 'is-dragging-from-flyout') return;
            if (action === 'open') {
                open();
                return;
            }
            if (action === 'waiting-for-close') {
                if (flyoutStateRef.current.type === 'waiting-for-close') return;
                // A timeout is used to close the flyout after a delay when the user mouses out of the flyout area, and to allow
                // us to cancel the close if the user mouses back in.
                const timeout = setTimeout(()=>{
                    updateFlyoutState('ready-to-close');
                }, (0, $94307ebc0fda0ded$export$a7801e29f563faad));
                flyoutStateRef.current = {
                    type: 'waiting-for-close',
                    abort () {
                        clearTimeout(timeout);
                    }
                };
                return;
            }
            if (action === 'ready-to-close') {
                // If there are no open layers, we can close the flyout.
                if (openLayerObserver.getCount({
                    namespace: $be4966f89908f895$var$openLayerObserverSideNavNamespace
                }) === 0) {
                    close();
                    return;
                }
                flyoutStateRef.current = {
                    type: 'ready-to-close'
                };
                return;
            }
            if (action === 'force-close') {
                close();
                return;
            }
        };
    }, [
        openLayerObserver,
        setSideNavState
    ]);
    const toggleVisibility = (0, $6qnkT.useToggleSideNav)();
    (0, $5uXOq.useEffect)(()=>{
        // Sync the visibility in context (provided in `<Root>`) with the local `defaultCollapsed` prop provided to `SideNav`
        // after SSR hydration. This should only run once, after the initial render on the client.
        setSideNavState({
            desktop: initialDefaultCollapsed ? 'collapsed' : 'expanded',
            mobile: 'collapsed',
            flyout: 'closed'
        });
    }, [
        initialDefaultCollapsed,
        setSideNavState
    ]);
    const handleExpand = (0, $5uXOq.useCallback)(({ screen: screen })=>{
        onExpand?.({
            screen: screen
        });
        // When the side nav gets expanded, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to expand.
        updateFlyoutState('force-close');
    }, [
        onExpand,
        updateFlyoutState
    ]);
    const handleCollapse = (0, $5uXOq.useCallback)(({ screen: screen })=>{
        onCollapse?.({
            screen: screen
        });
        // When the side nav gets collapsed, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to collapse.
        updateFlyoutState('force-close');
    }, [
        onCollapse,
        updateFlyoutState
    ]);
    (0, $27t8Q.useSideNavVisibilityCallbacks)({
        onExpand: handleExpand,
        onCollapse: handleCollapse,
        isExpandedOnDesktop: isExpandedOnDesktop,
        isExpandedOnMobile: isExpandedOnMobile
    });
    (0, $5uXOq.useEffect)(()=>{
        const mediaQueryList = window.matchMedia('(min-width: 64rem)');
        return (0, $cBeZP.bind)(mediaQueryList, {
            type: 'change',
            listener () {
                if (mediaQueryList.matches) // We're transitioning from tablet to desktop viewport size.
                // We forcibly show the side nav if it was shown on mobile.
                {
                    if (isExpandedOnMobile && !isExpandedOnDesktop) toggleVisibility();
                }
            }
        });
    }, [
        toggleVisibility,
        isExpandedOnDesktop,
        isExpandedOnMobile
    ]);
    /**
   * Close the mobile side nav if there is a click outside.
   *
   * Binding/unbinding on changes to `isExpandedOnMobile` instead of window size changes for simplicity.
   * If we listened to window size changes we'd need nested `bind()` calls.
   */ (0, $5uXOq.useEffect)(()=>{
        if (!isExpandedOnMobile) return;
        /**
     * The expected URL fragment used by the side nav skip link.
     */ const skipLinkUrlFragment = `#${id}`;
        return (0, $cBeZP.bind)(window, {
            type: 'click',
            listener (event) {
                if (window.matchMedia('(min-width: 64rem)').matches) // Clicks on desktop should do nothing
                return;
                const sideNav = navRef.current;
                if (!sideNav || !(event.target instanceof Node)) // Ignore if our element references are invalid
                return;
                if (sideNav.contains(event.target)) // Clicks inside the side nav should not close it
                return;
                if (toggleButtonElement?.contains(event.target)) // Clicks on the toggle button will already toggle the side nav,
                // so we need to ignore it or we end up doing a double toggle
                return;
                if (event.target instanceof HTMLAnchorElement && /**
         * Intentionally using `.getAttribute()` for simplicity to match exactly what we expect
         * for skip links.
         *
         * Alternatives considered:
         *
         * - Using `.href` returns a full URL, which would then require extra parsing.
         * - Using `.hash` could incorrectly capture `<a href="/another-page#skip-link-id>` so we'd need extra checks.
         *
         * This approach has an edge case of `<a href="/same-page#skip-link-id>` not being captured,
         * but we are okay with that trade-off.
         */ event.target.getAttribute('href') === skipLinkUrlFragment) // This was a click on a link to the side nav, so we shouldn't try to collapse the SideNav.
                // It was most likely the skip link, although anyone can render a link with the ID.
                // In either case keeping the SideNav expanded makes sense.
                return;
                toggleVisibility();
            }
        });
    }, [
        id,
        isExpandedOnMobile,
        toggleButtonElement,
        toggleVisibility
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $cBeZP.bind)(toggleButtonElement, {
            type: 'mouseenter',
            listener () {
                // Only flyout the side nav if the user hovered while the side nav was collapsed
                if (isExpandedOnDesktop) return;
                // Only flyout the side nav on desktop viewports
                const { matches: matches } = window.matchMedia('(min-width: 64rem)');
                if (matches) updateFlyoutState('open');
            }
        });
    }, [
        updateFlyoutState,
        toggleButtonElement,
        isExpandedOnDesktop
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $cBeZP.bind)(toggleButtonElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        toggleButtonElement,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $cBeZP.bind)(navRef.current, {
            type: 'mouseenter',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                // The user mouses has moused back over the side nav
                updateFlyoutState('open');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState,
        isExpandedOnDesktop
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $cBeZP.bind)(navRef.current, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const nav = navRef.current;
        if (!nav) return;
        if (!isFlyoutVisible) return;
        // Using a monitor rather than a drop target. Rationale:
        // - We are not creating a drop target for the users to drop on,
        //   we are just interested in listening to events within an element
        // - We do not want to impact `location.{*}.dropTargets` in events
        return (0, $7gWdR.monitorForElements)({
            canMonitor ({ source: source }) {
                return nav.contains(source.element);
            },
            onGenerateDragPreview () {
                updateFlyoutState('drag-from-flyout-started');
            },
            onDrop ({ location: location }) {
                // Always marking the drag and done
                updateFlyoutState('drag-from-flyout-finished');
                // If the user dropped outside of the flyout, we will close the flyout
                const underUsersPointer = document.elementFromPoint(location.current.input.clientX, location.current.input.clientY);
                if (!nav.contains(underUsersPointer)) updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!topNavStartElement || !toggleButtonElement) return;
        return (0, $cBeZP.bind)(topNavStartElement, {
            type: 'mouseover',
            listener (event) {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                if (event.target === topNavStartElement) {
                    // The mouse is directly over the TopNavStart element, so cancel any pending flyout closes.
                    updateFlyoutState('open');
                    return;
                }
                if (event.target instanceof Element && toggleButtonElement.contains(event.target)) // The mouse is over the toggle button or any of its children, so we don't want to close the flyout.
                // We also don't need to cancel any pending closes, as we have separate event listeners for the toggle button mouse events.
                return;
                // The user has moused over a child element of the TopNavStart element that isn't the toggle button, e.g. the app switcher or nav logo,
                // so we should close the flyout (with a delay).
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        topNavStartElement,
        isFlyoutVisible,
        toggleButtonElement,
        isExpandedOnDesktop,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!topNavStartElement) return;
        return (0, $cBeZP.bind)(topNavStartElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                // The mouse has left the TopNavStart element, so we should close the flyout with a delay.
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        topNavStartElement,
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Close the flyout if there are no more layers open and the user is not mousing over the
        // flyout areas (side nav, TopNavStart element)
        return openLayerObserver.onChange(({ count: count })=>{
            if (flyoutStateRef.current.type === 'ready-to-close' && count === 0) updateFlyoutState('force-close');
        }, {
            namespace: $be4966f89908f895$var$openLayerObserverSideNavNamespace
        });
    }, [
        openLayerObserver,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Clear flyout close timer if being unmounted
        return function cleanupPendingFlyoutClose() {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
        };
    }, []);
    (0, $2HiMp.useResizingWidthCssVarOnRootElement)({
        isEnabled: (0, $VSDnB.fg)('platform_design_system_nav4_preview_panel_support'),
        cssVar: $be4966f89908f895$var$panelSplitterResizingVar,
        panelId: (0, $ilnvx.sideNavPanelSplitterId)
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("nav", {
        id: id,
        ...devTimeOnlyAttributes,
        "data-layout-slot": true,
        "aria-label": label,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop
            [(0, $ilnvx.sideNavVar)]: clampedWidth
        },
        ref: (0, $VSDnB.fg)('platform_design_system_nav4_preview_panel_support') ? mergedRef : navRef,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            $be4966f89908f895$var$styles.root,
            (0, $VSDnB.fg)('platform_design_system_nav4_sidenav_border') ? $be4966f89908f895$var$styles.newBorder : $be4966f89908f895$var$styles.oldBorder,
            isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $be4966f89908f895$var$styles.hiddenMobileOnly,
            !isExpandedOnDesktop && isExpandedOnMobile && !isFlyoutVisible && $be4966f89908f895$var$styles.hiddenDesktopOnly,
            !isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $be4966f89908f895$var$styles.hiddenMobileAndDesktop,
            sideNavState?.flyout === 'open' && $be4966f89908f895$var$styles.flyoutOpen,
            sideNavState?.flyout === 'open' && (0, $VSDnB.fg)('platform_design_system_nav4_sidenav_border') && $be4966f89908f895$var$styles.newBorderFlyoutOpen,
            sideNavState?.flyout === 'triggered-animate-close' && $be4966f89908f895$var$styles.flyoutAnimateClosed
        ]),
        children: [
            (0, $VSDnB.fg)('platform_design_system_nav4_preview_panel_support') && // This CSS var is used by the `Panel` slot to enforce its maximum width constraint.
            // When we remove the UNSAFE legacy usage, we can change this to `HoistCssVarToLocalGrid`
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WR37.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $ilnvx.sideNavLiveWidthVar),
                value: "0px",
                mediaQuery: (0, $h9kUS.media).above.md,
                responsiveValue: isExpandedOnDesktop ? `var(${$be4966f89908f895$var$panelSplitterResizingVar}, ${clampedWidth})` : 0
            }),
            dangerouslyHoistSlotSizes && ((0, $VSDnB.fg)('platform_design_system_nav4_preview_panel_support') ? // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WR37.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $ilnvx.UNSAFE_sideNavLayoutVar),
                value: `var(${(0, $ilnvx.sideNavLiveWidthVar)})`
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WR37.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $ilnvx.UNSAFE_sideNavLayoutVar),
                value: "0px",
                mediaQuery: (0, $h9kUS.media).above.md,
                responsiveValue: isExpandedOnDesktop ? clampedWidth : 0
            })),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVO1C.PanelSplitterProvider), {
                panelId: (0, $ilnvx.sideNavPanelSplitterId),
                panelRef: navRef,
                panelWidth: width,
                onCompleteResize: setWidth,
                getResizeBounds: $be4966f89908f895$var$getResizeBounds,
                resizingCssVar: $be4966f89908f895$var$panelSplitterResizingVar,
                isEnabled: isExpandedOnDesktop && !isFlyoutVisible,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $be4966f89908f895$var$styles.flexContainer
                    ]),
                    children: children
                })
            })
        ]
    });
}
function $be4966f89908f895$export$1a35787d6353cf6a({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, testId: testId, label: label, skipLinkLabel: // Default value is defined in `SideNavInternal`
skipLinkLabel = label, onExpand: // Default value is defined in `SideNavInternal`
onExpand, onCollapse: onCollapse, id: id }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lJmpK.OpenLayerObserverNamespaceProvider), {
        namespace: $be4966f89908f895$var$openLayerObserverSideNavNamespace,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($be4966f89908f895$var$SideNavInternal, {
            defaultCollapsed: defaultCollapsed,
            defaultWidth: defaultWidth,
            testId: testId,
            label: label,
            skipLinkLabel: skipLinkLabel,
            onExpand: onExpand,
            onCollapse: onCollapse,
            id: id,
            children: children
        })
    });
}

});
parcelRegister("lJmpK", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserverNamespaceProvider", () => $68ced8fafd297685$export$327d0d2a7ae6f7cc);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");

var $6uI1O = parcelRequire("6uI1O");

var $7e96v = parcelRequire("7e96v");
function $68ced8fafd297685$export$327d0d2a7ae6f7cc({ children: children, namespace: namespace }) {
    // If there is an existing namespace context being provided, throw an invariant.
    // This use case is not supported at this time.
    const parentContext = (0, $7e96v.useOpenLayerObserverNamespace)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $3joPi.default)(parentContext === null, `An OpenLayerObserver namespace already exists in this component tree: ${parentContext}. Nesting OpenLayerObserverNamespaceProvider is not supported.`);
    }, [
        parentContext
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6uI1O.OpenLayerObserverNamespaceContext).Provider, {
        value: namespace,
        children: children
    });
}

});

// Note: this value has been pulled into a separate file to better
// support testing with Playwright. Playwright did not like importing
// an exported value from `sidenav.tsx` which has `@jsxRuntime classic`.
//
// Error:
// > importSource cannot be set when runtime is classic.
/**
 * How long the flyout should remain open after the users
 * pointer has left the side nav flyout
 */ const $94307ebc0fda0ded$export$a7801e29f563faad = 400;

parcelRegister("27t8Q", function(module, exports) {

$parcel$export(module.exports, "useSideNavVisibilityCallbacks", () => $cb86acb1b056338b$export$1904b8f2577aba9a);

var $5uXOq = parcelRequire("5uXOq");

var $lp9re = parcelRequire("lp9re");
function $cb86acb1b056338b$export$1904b8f2577aba9a({ onExpand: onExpand, onCollapse: onCollapse, isExpandedOnDesktop: isExpandedOnDesktop, isExpandedOnMobile: isExpandedOnMobile }) {
    // Wrapping in refs so we can call them in `useEffect` without changes to them triggering the `useEffect`
    const onExpandRef = (0, $5uXOq.useRef)(onExpand);
    const onCollapseRef = (0, $5uXOq.useRef)(onCollapse);
    (0, $5uXOq.useEffect)(()=>{
        onExpandRef.current = onExpand;
        onCollapseRef.current = onCollapse;
    }, [
        onExpand,
        onCollapse
    ]);
    const previousIsExpandedOnDesktop = (0, $lp9re.default)(isExpandedOnDesktop);
    (0, $5uXOq.useEffect)(()=>{
        if (previousIsExpandedOnDesktop === undefined || previousIsExpandedOnDesktop === isExpandedOnDesktop) /**
			 * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
			 *
			 * The previous value can be equal to the current one if the component re-renders due to something else changing.
			 *
			 * In both cases the value hasn't changed and we don't want to notify consumers.
			 */ return;
        if (isExpandedOnDesktop) onExpandRef.current?.({
            screen: 'desktop'
        });
        else onCollapseRef.current?.({
            screen: 'desktop'
        });
    }, [
        previousIsExpandedOnDesktop,
        isExpandedOnDesktop
    ]);
    const previousIsExpandedOnMobile = (0, $lp9re.default)(isExpandedOnMobile);
    (0, $5uXOq.useEffect)(()=>{
        if (previousIsExpandedOnMobile === undefined || previousIsExpandedOnMobile === isExpandedOnMobile) /**
			 * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
			 *
			 * The previous value can be equal to the current one if the component re-renders due to something else changing.
			 *
			 * In both cases the value hasn't changed and we don't want to notify consumers.
			 */ return;
        if (isExpandedOnMobile) onExpandRef.current?.({
            screen: 'mobile'
        });
        else onCollapseRef.current?.({
            screen: 'mobile'
        });
    }, [
        previousIsExpandedOnMobile,
        isExpandedOnMobile
    ]);
}

});


parcelRegister("7g4r8", function(module, exports) {

$parcel$export(module.exports, "TopNav", () => $c8c2cc49c7ec13a9$export$41d0d88a6b0e456f);
/* top-nav.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $585q9 = parcelRequire("585q9");

var $lLCVr = parcelRequire("lLCVr");

var $9SFxq = parcelRequire("9SFxq");

var $ilnvx = parcelRequire("ilnvx");

var $8oF23 = parcelRequire("8oF23");

var $2WR37 = parcelRequire("2WR37");

var $8mXqE = parcelRequire("8mXqE");
const $c8c2cc49c7ec13a9$var$styles = {
    root: "_nd5l8cbt _zulpu2gc _18zrutpp _179rzgxb _1e0c11p5 _yv0e1mfv _4cvr1h6o _bfhkvuon _vchhusvi _4t3i1dgc _152t1nws _kqsw1if8 _1pbyegat _d6vu1bgi",
    oldLayoutStyles: "_1rqtc57g",
    newLayoutStyles: "_1j8b18ax"
};
function $c8c2cc49c7ec13a9$export$41d0d88a6b0e456f({ children: children, xcss: xcss, height: height = 48, skipLinkLabel: skipLinkLabel = 'Top Bar', testId: testId, id: providedId, UNSAFE_theme: UNSAFE_theme }) {
    const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, $8oF23.DangerouslyHoistSlotSizes));
    const id = (0, $8mXqE.useLayoutId)({
        providedId: providedId
    });
    (0, $585q9.useSkipLink)(id, skipLinkLabel);
    const customTheme = (0, $9SFxq.useCustomTheme)(UNSAFE_theme);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lLCVr.HasCustomThemeContext).Provider, {
        value: customTheme.isEnabled,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("header", {
            id: id,
            "data-layout-slot": true,
            className: (0, $bwpsq.default)([
                $c8c2cc49c7ec13a9$var$styles.root,
                (0, $VSDnB.fg)('platform_design_system_nav4_top_nav_columns') ? $c8c2cc49c7ec13a9$var$styles.newLayoutStyles : $c8c2cc49c7ec13a9$var$styles.oldLayoutStyles,
                xcss
            ]),
            "data-testid": testId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: customTheme.isEnabled ? customTheme.style : undefined,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WR37.HoistCssVarToLocalGrid), {
                    variableName: (0, $ilnvx.topNavMountedVar),
                    value: height
                }),
                dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
                // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
                // When they aren't needed anymore we can delete them wholesale.
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WR37.DangerouslyHoistCssVarToDocumentRoot), {
                    variableName: (0, $ilnvx.UNSAFE_topNavVar),
                    value: height
                }),
                children
            ]
        })
    });
}

});
parcelRegister("9SFxq", function(module, exports) {

$parcel$export(module.exports, "useCustomTheme", () => $a4aaf4b86ce4bd3e$export$c0c5f5b297b77726);

var $5uXOq = parcelRequire("5uXOq");

var $4ho76 = parcelRequire("4ho76");
function $a4aaf4b86ce4bd3e$export$c0c5f5b297b77726(theme) {
    const value = (0, $5uXOq.useMemo)(()=>{
        if (!theme?.backgroundColor || !theme?.highlightColor) return {
            isEnabled: false
        };
        /**
			 * Re-creating the `theme` object from it's pieces.
			 *
			 * _Technically_ we could just use `theme`, but that would involve an eslint opt out
			 * as we would be leveraging a value (`theme`) not in the dependency array.
			 *
			 * The current approach is the most correct™️ and avoids foot guns.
			 * We are only using values in the effect that are defined in the dependency array 🙌
			 */ const value = {
            backgroundColor: theme.backgroundColor,
            highlightColor: theme.highlightColor
        };
        const style = (0, $4ho76.getCustomThemeStyles)(value);
        if (!style) // Either the `backgroundColor` or `highlightColor` could not be parsed
        return {
            isEnabled: false
        };
        return {
            isEnabled: true,
            style: style
        };
    }, // Using individual properties as keys for improved memoization.
    // Now this effect will only run if the values change rather than
    // the reference to the object (which might be new on every call)
    [
        theme?.backgroundColor,
        theme?.highlightColor
    ]);
    return value;
}

});
parcelRegister("4ho76", function(module, exports) {

$parcel$export(module.exports, "getCustomThemeStyles", () => $20b90a70389cbaea$export$3986d75fe2da3239);

var $4xv02 = parcelRequire("4xv02");

var $8l1C4 = parcelRequire("8l1C4");

var $89F5e = parcelRequire("89F5e");

var $essik = parcelRequire("essik");

var $i38OJ = parcelRequire("i38OJ");

var $es68b = parcelRequire("es68b");
function $20b90a70389cbaea$var$toRGBString({ r: r, g: g, b: b }) {
    return `rgb(${r}, ${g}, ${b})`;
}
function $20b90a70389cbaea$var$toRGBAString({ r: r, g: g, b: b, a: a }) {
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
// Using raw hex codes because custom colors break out of the tokens model
// We will need to invert the colors based on backgroundColor independently of the app's color mode (dark/light)
// Values here are not final
const $20b90a70389cbaea$var$buttonStyles = {
    light: {
        [(0, $8l1C4.themedButtonBackground)]: 'transparent',
        [(0, $8l1C4.themedButtonBackgroundHovered)]: (0, $i38OJ.palette).Neutral200A,
        [(0, $8l1C4.themedButtonBackgroundPressed)]: (0, $i38OJ.palette).Neutral300A,
        [(0, $8l1C4.themedButtonBorder)]: (0, $i38OJ.palette).Neutral300A,
        [(0, $8l1C4.themedButtonSelectedBackground)]: (0, $i38OJ.palette).Neutral300A,
        [(0, $8l1C4.themedButtonSelectedBackgroundHovered)]: (0, $i38OJ.palette).Neutral400A,
        [(0, $8l1C4.themedButtonSelectedBackgroundPressed)]: (0, $i38OJ.palette).Neutral500A,
        [(0, $8l1C4.themedButtonDisabledText)]: (0, $i38OJ.palette).Neutral400A,
        [(0, $8l1C4.themedButtonDisabledBackground)]: (0, $i38OJ.palette).Neutral100A
    },
    dark: {
        [(0, $8l1C4.themedButtonBackground)]: 'transparent',
        [(0, $8l1C4.themedButtonBackgroundHovered)]: (0, $i38OJ.palette).DarkNeutral200A,
        [(0, $8l1C4.themedButtonBackgroundPressed)]: (0, $i38OJ.palette).DarkNeutral300A,
        [(0, $8l1C4.themedButtonBorder)]: (0, $i38OJ.palette).DarkNeutral300A,
        [(0, $8l1C4.themedButtonSelectedBackground)]: (0, $i38OJ.palette).DarkNeutral300A,
        [(0, $8l1C4.themedButtonSelectedBackgroundHovered)]: (0, $i38OJ.palette).DarkNeutral400A,
        [(0, $8l1C4.themedButtonSelectedBackgroundPressed)]: (0, $i38OJ.palette).DarkNeutral500A,
        [(0, $8l1C4.themedButtonDisabledText)]: (0, $i38OJ.palette).DarkNeutral400A,
        [(0, $8l1C4.themedButtonDisabledBackground)]: (0, $i38OJ.palette).DarkNeutral100A
    }
};
const $20b90a70389cbaea$var$logoStyles = {
    light: {
        [(0, $4xv02.themedLogoIcon)]: (0, $i38OJ.palette).DarkNeutral0,
        [(0, $4xv02.themedLogoText)]: (0, $i38OJ.palette).DarkNeutral0
    },
    dark: {
        [(0, $4xv02.themedLogoIcon)]: (0, $i38OJ.palette).Neutral0,
        [(0, $4xv02.themedLogoText)]: (0, $i38OJ.palette).Neutral0
    }
};
function $20b90a70389cbaea$export$3986d75fe2da3239({ backgroundColor: backgroundColor, highlightColor: highlightColor }) {
    const backgroundRgb = typeof backgroundColor === 'string' ? (0, $essik.parseHex)(backgroundColor) : backgroundColor;
    const highlightRgb = typeof highlightColor === 'string' ? (0, $essik.parseHex)(highlightColor) : highlightColor;
    if (!backgroundRgb || !highlightRgb) return null;
    const textColor = (0, $89F5e.getTextColor)(backgroundRgb);
    const colorMode = (0, $89F5e.getColorMode)(backgroundRgb);
    const highlightTextColor = (0, $89F5e.getTextColor)(highlightRgb);
    return {
        backgroundColor: $20b90a70389cbaea$var$toRGBString(backgroundRgb),
        color: textColor.hex,
        ...$20b90a70389cbaea$var$buttonStyles[colorMode],
        ...$20b90a70389cbaea$var$logoStyles[colorMode],
        ...$20b90a70389cbaea$var$getSelectedStyles({
            backgroundColor: backgroundRgb,
            colorMode: colorMode
        }),
        /**
		 * Search colors are the same as Nav 3
		 */ [(0, $es68b.themedSearchBorder)]: $20b90a70389cbaea$var$toRGBAString({
            ...textColor.rgb,
            a: 0.5
        }),
        [(0, $es68b.themedSearchBorderFocused)]: $20b90a70389cbaea$var$toRGBAString({
            ...highlightRgb,
            a: 0.8
        }),
        /**
		 * Primary button colors are the same as Nav 3,
		 * except the text color which can sometimes differ because we're
		 * now following WCAG
		 */ [(0, $8l1C4.themedButtonPrimaryBackground)]: $20b90a70389cbaea$var$toRGBString(highlightRgb),
        [(0, $8l1C4.themedButtonPrimaryBackgroundHovered)]: $20b90a70389cbaea$var$toRGBAString({
            ...highlightRgb,
            a: 0.8
        }),
        [(0, $8l1C4.themedButtonPrimaryBackgroundPressed)]: $20b90a70389cbaea$var$toRGBAString({
            ...highlightRgb,
            a: 0.65
        }),
        [(0, $8l1C4.themedButtonPrimaryText)]: highlightTextColor.hex
    };
}
/**
 * Precomputed RGBA values for the selected backgrounds
 */ const $20b90a70389cbaea$var$selectedBackgroundRGBA = {
    light: (0, $i38OJ.paletteRgba).Neutral300A,
    dark: (0, $i38OJ.paletteRgba).DarkNeutral300A
};
function $20b90a70389cbaea$var$getSelectedStyles({ backgroundColor: backgroundColor, colorMode: colorMode }) {
    /**
	 * The background color of the selected button in its default state.
	 *
	 * We are referring to this as a foreground color because it is semi-transparent,
	 * so is not the actual color displayed when the button is on top of a background color.
	 */ const foregroundColor = $20b90a70389cbaea$var$selectedBackgroundRGBA[colorMode];
    /**
	 * The blended color seen when the selected background is over the top bar.
	 */ const blendedBackground = (0, $89F5e.simpleAlphaComposite)({
        background: backgroundColor,
        foreground: foregroundColor
    });
    return {
        [(0, $8l1C4.themedButtonSelectedText)]: (0, $89F5e.getTextColor)(blendedBackground).hex,
        // Border colors are chosen to match the text, while remaining in the palette
        [(0, $8l1C4.themedButtonSelectedBorder)]: (0, $89F5e.isLight)(blendedBackground) ? (0, $i38OJ.palette).Neutral1100 : (0, $i38OJ.palette).DarkNeutral1100
    };
}

});
parcelRegister("89F5e", function(module, exports) {

$parcel$export(module.exports, "isLight", () => $4fbdcc97a7190551$export$44af652f4cca9039);
$parcel$export(module.exports, "getColorMode", () => $4fbdcc97a7190551$export$5573a5bab3e074b5);
$parcel$export(module.exports, "getTextColor", () => $4fbdcc97a7190551$export$5357fe757c335c0d);
$parcel$export(module.exports, "simpleAlphaComposite", () => $4fbdcc97a7190551$export$e5e64c30bee1469b);
/**
 * Removes sRGB gamma correction from the provided channel.
 * The resulting linear channel directly corresponds to subpixel intensity.
 *
 * Expects a normalized sRGB value (between 0 and 1)
 *
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $4fbdcc97a7190551$var$linearizeRGBChannel(channel) {
    return channel <= 0.04045 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
}
/**
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $4fbdcc97a7190551$var$relativeLuminanceW3C({ r: r, g: g, b: b }) {
    /**
	 * Normalized sRGB - each channel is between 0 and 1
	 */ const normal = {
        r: r / 255,
        g: g / 255,
        b: b / 255
    };
    /**
	 * linear RGB - the gamma correction of sRGB is removed and
	 * the channels correspond directly to subpixel intensity
	 */ const linear = {
        r: $4fbdcc97a7190551$var$linearizeRGBChannel(normal.r),
        g: $4fbdcc97a7190551$var$linearizeRGBChannel(normal.g),
        b: $4fbdcc97a7190551$var$linearizeRGBChannel(normal.b)
    };
    // For linear RGB, the relative luminance of a color is defined as:
    const L = 0.2126 * linear.r + 0.7152 * linear.g + 0.0722 * linear.b;
    return L;
}
/**
 * This is the intersection point for W3C contrast ratio against:
 *
 * 1. black
 * 2. white
 *
 * In other words, the background luminance for which W3C contrast is equal
 * for both white and black text.
 *
 * Using a precomputed flip point means we can save a lot of calculations.
 *
 * This is only the theoretical flip point, and we can adjust it as needed.
 */ const $4fbdcc97a7190551$var$flipLuminance = 0.179129;
function $4fbdcc97a7190551$export$44af652f4cca9039(color) {
    return $4fbdcc97a7190551$var$relativeLuminanceW3C(color) >= $4fbdcc97a7190551$var$flipLuminance;
}
function $4fbdcc97a7190551$export$5573a5bab3e074b5(backgroundColor) {
    if ($4fbdcc97a7190551$var$relativeLuminanceW3C(backgroundColor) >= $4fbdcc97a7190551$var$flipLuminance) return 'light';
    return 'dark';
}
const $4fbdcc97a7190551$var$textColor = {
    light: {
        hex: '#000',
        rgb: {
            r: 0,
            g: 0,
            b: 0
        }
    },
    dark: {
        hex: '#FFF',
        rgb: {
            r: 255,
            g: 255,
            b: 255
        }
    }
};
function $4fbdcc97a7190551$export$5357fe757c335c0d(backgroundColor) {
    const colorMode = $4fbdcc97a7190551$export$5573a5bab3e074b5(backgroundColor);
    return $4fbdcc97a7190551$var$textColor[colorMode];
}
function $4fbdcc97a7190551$export$e5e64c30bee1469b({ background: background, foreground: foreground }) {
    return {
        r: foreground.a * foreground.r + background.r * (1 - foreground.a),
        g: foreground.a * foreground.g + background.g * (1 - foreground.a),
        b: foreground.a * foreground.b + background.b * (1 - foreground.a)
    };
}

});

parcelRegister("essik", function(module, exports) {

$parcel$export(module.exports, "parseHex", () => $352c93155f572157$export$103711ef09c6edec);
// valid hex color (optional alpha channel) - 3, 4, 6, or 8 digits after the #
const $352c93155f572157$var$isValidHex = (hex)=>// Not using `([a-f0-9]{3,4}){1,2}` because that allows 7 digits which is invalid
    /^#(([a-f0-9]{3,4})|([a-f0-9][a-f0-9]){3,4})$/i.test(hex);
function $352c93155f572157$export$103711ef09c6edec(color) {
    if (!$352c93155f572157$var$isValidHex(color)) return null;
    let channels;
    if (color.length <= 5) // Hex code is shorthand - RGB channels are one digit
    channels = {
        r: color[1].repeat(2),
        g: color[2].repeat(2),
        b: color[3].repeat(2)
    };
    else // Hex code is longhand - RGB channels are two digits
    channels = {
        r: color.slice(1, 3),
        g: color.slice(3, 5),
        b: color.slice(5, 7)
    };
    return {
        r: parseInt(channels.r, 16),
        g: parseInt(channels.g, 16),
        b: parseInt(channels.b, 16)
    };
}

});

parcelRegister("i38OJ", function(module, exports) {

$parcel$export(module.exports, "palette", () => $3c1e0f0bc82f150b$export$eaad8caa32d2521d);
$parcel$export(module.exports, "paletteRgba", () => $3c1e0f0bc82f150b$export$c9b84419dae66a82);
/**
 * Copied from the brand refresh palette.
 *
 * Ideally we'd codegen this but the brand refresh palette isn't exposed
 * through public API and we shouldn't use the private API of another package.
 */ const $3c1e0f0bc82f150b$export$eaad8caa32d2521d = {
    'DarkNeutral-100': '#111213',
    'DarkNeutral-100A': '#01040475',
    DarkNeutral0: '#18191A',
    DarkNeutral100: '#1F1F21',
    DarkNeutral100A: '#BDBDBD0A',
    DarkNeutral200: '#242528',
    DarkNeutral200A: '#CECED912',
    DarkNeutral250: '#2B2C2F',
    DarkNeutral250A: '#D9DAE71A',
    DarkNeutral300: '#303134',
    DarkNeutral300A: '#E3E4F21F',
    DarkNeutral350: '#3D3F43',
    DarkNeutral350A: '#E8EDFD2E',
    DarkNeutral400: '#4B4D51',
    DarkNeutral400A: '#E5E9F640',
    DarkNeutral500: '#63666B',
    DarkNeutral500A: '#E9F0FB5C',
    DarkNeutral600: '#7E8188',
    DarkNeutral700: '#96999E',
    DarkNeutral800: '#A9ABAF',
    DarkNeutral900: '#BFC1C4',
    DarkNeutral1000: '#CECFD2',
    DarkNeutral1100: '#E2E3E4',
    Neutral0: '#FFFFFF',
    Neutral100: '#F8F8F8',
    Neutral100A: '#17171708',
    Neutral200: '#F0F1F2',
    Neutral200A: '#0515240F',
    Neutral300: '#DDDEE1',
    Neutral300A: '#0B120E24',
    Neutral400: '#B7B9BE',
    Neutral400A: '#080F214A',
    Neutral500: '#8C8F97',
    Neutral500A: '#050C1F75',
    Neutral600: '#7D818A',
    Neutral700: '#6B6E76',
    Neutral800: '#505258',
    Neutral900: '#3B3D42',
    Neutral1000: '#292A2E',
    Neutral1100: '#1E1F21'
};
const $3c1e0f0bc82f150b$export$c9b84419dae66a82 = {
    DarkNeutral300A: {
        r: 0xe3,
        g: 0xe4,
        b: 0xf2,
        a: 0x1f / 255
    },
    Neutral300A: {
        r: 0x0b,
        g: 0x12,
        b: 0x0e,
        a: 0x24 / 255
    }
};

});







parcelRegister("axUP7", function(module, exports) {

$parcel$export(module.exports, "withNestingOptimisation", () => $c861ce2b697701b9$export$ee1cb2a8280d8710);

var $5uXOq = parcelRequire("5uXOq");

var $j9VTE = parcelRequire("j9VTE");

var $9sGI6 = parcelRequire("9sGI6");
const $c861ce2b697701b9$export$ee1cb2a8280d8710 = (Component)=>{
    const WithNestingOptimisation = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
        const children = // @ts-expect-error - Property 'children' does not exist on type 'Props'.ts(2339)
        typeof props === 'object' && props != null ? props.children : null;
        return (0, $j9VTE.useShouldNestedElementRender)().shouldRender && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
            ...props,
            ref: ref
        }) : children;
    });
    WithNestingOptimisation.displayName = `withNestingOptimisation(${(0, $9sGI6.getDisplayName)(Component)})`;
    return WithNestingOptimisation;
};

});
parcelRegister("9sGI6", function(module, exports) {

$parcel$export(module.exports, "getDisplayName", () => $0d4ebae82d1d47ab$export$be63e0664592e141);
$parcel$export(module.exports, "default", () => $0d4ebae82d1d47ab$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $0d4ebae82d1d47ab$export$be63e0664592e141 = (WrappedComponent)=>{
    if (WrappedComponent.displayName != null && WrappedComponent.displayName !== '') return WrappedComponent.displayName;
    if (WrappedComponent.name != null && WrappedComponent.name !== '') return WrappedComponent.name;
    return 'Component';
};
/**
 * @deprecated Just pass the props explicitly or create a new component that provides them. Do not use HOCs.
 */ const $0d4ebae82d1d47ab$var$withInjectedProps = (WrappedComponent, injectedProps)=>{
    const WithInjectedProps = (props)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...injectedProps,
            ...props
        });
    WithInjectedProps.displayName = `withInjectedProps(${$0d4ebae82d1d47ab$export$be63e0664592e141(WrappedComponent)})`;
    return WithInjectedProps;
};
var $0d4ebae82d1d47ab$export$2e2bcd8739ae039 = $0d4ebae82d1d47ab$var$withInjectedProps;

});



parcelRegister("ky2ui", function(module, exports) {

$parcel$export(module.exports, "BackgroundColourNudgeAsync", () => $cb3deafbb4dbbb82$export$a3dbb521061a599a);

var $5uXOq = parcelRequire("5uXOq");

var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $cb3deafbb4dbbb82$var$BackgroundColourNudgeLazy = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("itvQz")).then((exportedModule)=>exportedModule.BackgroundColourNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges-jwm-background-color/src/index.tsx"
});
const $cb3deafbb4dbbb82$export$a3dbb521061a599a = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $d231c4839441ff18$export$eb0b199de90a7ec2),
        fallback: children,
        attributes: {
            nudgeId: (0, $d231c4839441ff18$export$eb0b199de90a7ec2)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "background-colour-onboarding-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cb3deafbb4dbbb82$var$BackgroundColourNudgeLazy, null, children)));
$cb3deafbb4dbbb82$export$a3dbb521061a599a.displayName = 'BackgroundColourNudgeAsync';

});
// JWM Background Colour tour
const $d231c4839441ff18$export$eb0b199de90a7ec2 = 'backgroundColorNudge';

parcelRegister("itvQz", function(module, exports) {

let $d733a39467fe46a6$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d733a39467fe46a6$var$load("76n7a"),
    $d733a39467fe46a6$var$load("l253H"),
    $d733a39467fe46a6$var$load("bw1yb")
]).then(()=>parcelRequire('8uIuW'));

});


parcelRegister("jpH5a", function(module, exports) {

$parcel$export(module.exports, "VIEW_THEME_PICKER_EXPERIENCE", () => $34fd6f1472f32723$export$9a8c95b97c1ee885);
const $34fd6f1472f32723$export$47a1a20f3722c8ce = {
    experience: 'viewThemePicker',
    packageName: 'jiraBusinessThemeComponents',
    teamName: 'work-management-frontier'
};
const $34fd6f1472f32723$export$9a8c95b97c1ee885 = {
    experience: 'viewThemePicker',
    analyticsSource: 'jiraProjectThemeComponents',
    teamName: 'work-management-frontier'
};

});

parcelRegister("ca7Zi", function(module, exports) {

$parcel$export(module.exports, "useExperienceFail", () => $99088cc1a7014505$export$606da7704d8eaf06);
$parcel$export(module.exports, "ExperienceFailed", () => $99088cc1a7014505$export$ae65a9e09c4516b3);
$parcel$export(module.exports, "ExperienceSuccess", () => $99088cc1a7014505$export$4962f3898bd5c829);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $93jKl = parcelRequire("93jKl");

var $3bQtK = parcelRequire("3bQtK");

var $jJZqs = parcelRequire("jJZqs");
const $99088cc1a7014505$export$606da7704d8eaf06 = ({ experience: experience, experienceId: experienceId, analyticsSource: analyticsSource, teamName: teamName })=>{
    const onExperienceFail = (0, $93jKl.useExperienceFail)({
        experience: experience
    });
    const onFail = (0, $5uXOq.useCallback)((location, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error, extraAttributes)=>{
        const relevantError = error?.networkError ?? error;
        if (relevantError instanceof (0, $jJZqs.ValidationError) && relevantError.message === '' && relevantError.errors.length) relevantError.message = relevantError.errors[0].error;
        extraAttributes !== undefined ? onExperienceFail(location, relevantError, extraAttributes) : onExperienceFail(location, relevantError);
        (0, $jcw0u.default)({
            meta: {
                id: `experience-tracker-${experienceId ?? experience}`,
                packageName: analyticsSource,
                teamName: teamName
            },
            attributes: {
                location: location
            },
            error: relevantError,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        onExperienceFail,
        experienceId,
        experience,
        analyticsSource,
        teamName
    ]);
    return onFail;
};
const $99088cc1a7014505$export$ae65a9e09c4516b3 = /*#__PURE__*/ (0, $5uXOq.memo)(({ experience: experience, error: error, attributes: attributes })=>{
    const onFail = $99088cc1a7014505$export$606da7704d8eaf06(experience);
    (0, $5uXOq.useEffect)(()=>{
        onFail(experience.experience, error, attributes);
    }, [
        attributes,
        error,
        experience,
        onFail
    ]);
    return null;
});
const $99088cc1a7014505$export$4962f3898bd5c829 = /*#__PURE__*/ (0, $5uXOq.memo)(({ experience: experience, attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bQtK.ExperienceSuccess), {
        experience: experience.experience,
        attributes: {
            ...experience.experienceId == null ? undefined : {
                experienceId: experience.experienceId
            },
            ...attributes
        }
    }));

});

parcelRegister("lwRIP", function(module, exports) {

$parcel$export(module.exports, "CREATE_CUSTOM_BACKGROUND_EXPERIENCE", () => $9162f72ca6991e19$export$46e0706742711dad);
$parcel$export(module.exports, "UPDATE_ALT_TEXT_EXPERIENCE", () => $9162f72ca6991e19$export$678653f2c10961c5);
$parcel$export(module.exports, "DELETE_CUSTOM_BACKGROUND_EXPERIENCE", () => $9162f72ca6991e19$export$f84f0c56982ddf9a);
$parcel$export(module.exports, "THEME_PICKER_ELEMENT_ID", () => $9162f72ca6991e19$export$8dde8522a4856b87);
const $9162f72ca6991e19$export$91a4460f34f2ee75 = {
    experience: 'createCustomBackground',
    packageName: 'jiraBusinessThemeComponents',
    teamName: 'work-management-frontier'
};
const $9162f72ca6991e19$export$46e0706742711dad = {
    experience: 'createCustomBackground',
    analyticsSource: 'jiraProjectThemeComponents',
    teamName: 'work-management-frontier'
};
const $9162f72ca6991e19$export$3b5b01b3ae53bee3 = {
    experience: 'updateCustomBackground',
    packageName: 'jiraBusinessThemeComponents',
    teamName: 'work-management-frontier'
};
const $9162f72ca6991e19$export$678653f2c10961c5 = {
    experience: 'updateCustomBackground',
    analyticsSource: 'jiraProjectThemeComponents',
    teamName: 'work-management-frontier'
};
const $9162f72ca6991e19$export$da5da525dec4b73a = {
    experience: 'deleteCustomBackground',
    packageName: 'jiraBusinessThemeComponents',
    teamName: 'work-management-frontier'
};
const $9162f72ca6991e19$export$f84f0c56982ddf9a = {
    experience: 'deleteCustomBackground',
    analyticsSource: 'jiraProjectThemeComponents',
    teamName: 'work-management-frontier'
};
const $9162f72ca6991e19$export$8dde8522a4856b87 = 'background-picker-popup-wrapper';

});

parcelRegister("3LH0C", function(module, exports) {

$parcel$export(module.exports, "ThemePickerButtonItem", () => $bf1403620c7d37d2$export$27d1624818d3e0be);

var $5uXOq = parcelRequire("5uXOq");

var $3uzfU = parcelRequire("3uzfU");

var $dmnFy = parcelRequire("dmnFy");

var $kJpBP = parcelRequire("kJpBP");

var $koVbs = parcelRequire("koVbs");

var $eCaG4 = parcelRequire("eCaG4");
const $bf1403620c7d37d2$export$27d1624818d3e0be = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onClick: onClick, isSelected: isSelected, testId: testId, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dmnFy))), {
            label: "",
            LEGACY_size: "medium",
            spacing: "spacious"
        }),
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3uzfU))), {
            label: "",
            LEGACY_size: "medium",
            spacing: "spacious",
            size: "small"
        }),
        onClick: onClick,
        testId: testId,
        isSelected: isSelected,
        ref: ref,
        ...props
    }, formatMessage((0, $eCaG4.default).setProjectBackgroundMenuItem));
}));

});
parcelRegister("dmnFy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7b72e4cfb1948d4b5694556923ff149>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9b9fb0a3472b1330$var$_react = $9b9fb0a3472b1330$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9b9fb0a3472b1330$var$_paintBucket = $9b9fb0a3472b1330$var$_interopRequireDefault((parcelRequire("ciYaM")));

var $9b9fb0a3472b1330$var$_backgroundColor = $9b9fb0a3472b1330$var$_interopRequireDefault((parcelRequire("dRNbD")));
function $9b9fb0a3472b1330$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PaintBucketIcon.
 * This component is PaintBucketIcon, with `UNSAFE_fallbackIcon` set to "EditorBackgroundColorIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Customize fill color.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9b9fb0a3472b1330$var$PaintBucketIcon = (props)=>/*#__PURE__*/ $9b9fb0a3472b1330$var$_react.default.createElement($9b9fb0a3472b1330$var$_paintBucket.default, Object.assign({
        LEGACY_fallbackIcon: $9b9fb0a3472b1330$var$_backgroundColor.default
    }, props));
$9b9fb0a3472b1330$var$PaintBucketIcon.Name = 'PaintBucketIconMigration';
var $9b9fb0a3472b1330$var$_default = module.exports.default = $9b9fb0a3472b1330$var$PaintBucketIcon;

});
parcelRegister("ciYaM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83080ad07e1bfea64637edcdcb5973cb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8f55d7939f8010e4$var$_react = $8f55d7939f8010e4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8f55d7939f8010e4$var$_baseNew = $8f55d7939f8010e4$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $8f55d7939f8010e4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PaintBucket".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Customize fill color.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8f55d7939f8010e4$var$PaintBucketIcon = (props)=>/*#__PURE__*/ $8f55d7939f8010e4$var$_react.default.createElement($8f55d7939f8010e4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.655.095 13.78 8.22a.75.75 0 0 1 0 1.06l-5.616 5.617a2 2 0 0 1-2.828 0L.604 10.164a2 2 0 0 1 0-2.828L5.689 2.25 4.595 1.155zM6.75 3.31 2.06 8h9.38zm4.69 6.19H2.06l4.336 4.335a.5.5 0 0 0 .708 0z" clip-rule="evenodd"/><path fill="currentcolor" d="M14.5 12a.75.75 0 0 0-.654.383v.002l-.003.003-.007.013-.026.046a16 16 0 0 0-.36.695 8 8 0 0 0-.283.642c-.068.176-.167.457-.167.716a1.5 1.5 0 0 0 3 0c0-.259-.1-.54-.167-.716a8 8 0 0 0-.284-.642 16 16 0 0 0-.36-.695l-.025-.046-.007-.013-.002-.004-.001-.001A.75.75 0 0 0 14.5 12"/>`
    }, props));
$8f55d7939f8010e4$var$PaintBucketIcon.displayName = 'PaintBucketIcon';
var $8f55d7939f8010e4$var$_default = module.exports.default = $8f55d7939f8010e4$var$PaintBucketIcon;

});

parcelRegister("dRNbD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a186610b26bee8b1$var$_react = $a186610b26bee8b1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $a186610b26bee8b1$var$_paintBucket = $a186610b26bee8b1$var$_interopRequireDefault((parcelRequire("ciYaM")));
function $a186610b26bee8b1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a186610b26bee8b1$var$EditorBackgroundColorIcon = (props)=>/*#__PURE__*/ $a186610b26bee8b1$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m7.818 12.56 4.243 4.243 4.242-4.242-4.242-4.243zm-1.414 1.415a1.995 1.995 0 0 1 0-2.828l4.243-4.243a1.995 1.995 0 0 1 2.828 0l4.243 4.243c.78.78.786 2.041 0 2.828l-4.243 4.243a1.996 1.996 0 0 1-2.828 0zM6.5 13h11l-5.44 5.218zm2.732-8.925a1 1 0 0 1 1.414 0l3.536 3.536-1.414 1.414L9.232 5.49a1 1 0 0 1 0-1.415M18 16s1.5 2 1.5 3.5c0 1-1 1.5-1.5 1.5s-1.5-.4-1.5-1.5C16.5 18 18 16 18 16"/></svg>`
    }, props, {
        newIcon: $a186610b26bee8b1$var$_paintBucket.default
    }));
$a186610b26bee8b1$var$EditorBackgroundColorIcon.displayName = 'EditorBackgroundColorIcon';
var $a186610b26bee8b1$var$_default = module.exports.default = $a186610b26bee8b1$var$EditorBackgroundColorIcon;

});


parcelRegister("eCaG4", function(module, exports) {

$parcel$export(module.exports, "default", () => $375a1027f7dcdae1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $375a1027f7dcdae1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    setProjectBackgroundMenuItem: {
        "id": "business-theme-components.theme-picker-button-item.set-project-background-menu-item",
        "defaultMessage": "Set project background"
    }
});

});


parcelRegister("gHWtm", function(module, exports) {

$parcel$export(module.exports, "backgroundPickerPopupContentEntryPoint", () => $52bb029027935944$export$e02fb03d7ff1aabe);

var $22q3R = parcelRequire("22q3R");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");
const $52bb029027935944$var$fetchPolicy = 'network-only';

const $52bb029027935944$export$e02fb03d7ff1aabe = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("6lGsN")).then((module)=>module.BackgroundPickerPopupContent), {
        moduleId: "e1737386",
        moduleName: "PopupContent",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectAri: projectAri })=>{
        const popupContentQuery = {
            parameters: (0, $22q3R.default),
            variables: {
                cloudId: cloudId,
                entityId: projectAri,
                durationInSeconds: 900,
                imageCount: 50
            },
            options: {
                fetchPolicy: $52bb029027935944$var$fetchPolicy
            }
        };
        return {
            queries: {
                popupContentQuery: popupContentQuery
            }
        };
    }
});

});
parcelRegister("22q3R", function(module, exports) {

$parcel$export(module.exports, "default", () => $201654d4ad1f249e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<271df4939a3f94b3a679eedb3fe369f3>>
 * @relayHash 6fd96fa79cd88f4daa1afa95da0e618f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a3cdad9d85a286735d160e36b6fc0ee43535f10938f2aeaa4af8baeaabc58549
const $201654d4ad1f249e$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a3cdad9d85a286735d160e36b6fc0ee43535f10938f2aeaa4af8baeaabc58549",
        "metadata": {},
        "name": "PopupContentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $201654d4ad1f249e$export$2e2bcd8739ae039 = $201654d4ad1f249e$var$node;

});

parcelRegister("6lGsN", function(module, exports) {

let $49f5a4976207582d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $49f5a4976207582d$var$load("kNFvF"),
    $49f5a4976207582d$var$load("80Kqm")
]).then(()=>parcelRequire('97vnf'));

});


parcelRegister("9yzIq", function(module, exports) {

$parcel$export(module.exports, "ThemePickerSkeleton", () => $828cc9a1e99f3131$export$c3dc17aa42c33254);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");
const $828cc9a1e99f3131$export$c3dc17aa42c33254 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $828cc9a1e99f3131$var$skeletonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "medium"
    }));
const $828cc9a1e99f3131$var$skeletonStyles = (0, $8CUq3.xcss)({
    width: '346px',
    height: '240px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});

});


parcelRegister("8qvci", function(module, exports) {

$parcel$export(module.exports, "useProjectMenuItemDragAndDrop", () => $c783d1f145981443$export$1496323130e2da11);

var $5uXOq = parcelRequire("5uXOq");

var $2od0u = parcelRequire("2od0u");

var $dcP6E = parcelRequire("dcP6E");

var $5HnsC = parcelRequire("5HnsC");
const $c783d1f145981443$export$1496323130e2da11 = (props)=>{
    const { projectId: projectId, projectKey: projectKey, isFavourite: isFavourite, name: name, avatar: avatar } = props;
    return (0, $2od0u.useMenuItemDragAndDrop)({
        draggable: {
            getInitialData: ()=>({
                    id: projectId,
                    key: projectKey,
                    isFavourite: isFavourite,
                    name: name,
                    avatar: avatar.large || '',
                    type: (0, $5HnsC.NAV4_PROJECT_MENU_ITEM_DRAG_AND_DROP)
                }),
            getDragPreviewPieces: ()=>({
                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dcP6E.ContainerAvatar), {
                        src: avatar.large || ''
                    }),
                    content: name
                })
        },
        dropTarget: {
            getData: ()=>({
                    id: projectId,
                    key: projectKey,
                    isFavourite: isFavourite,
                    name: name,
                    avatar: avatar.large || '',
                    type: (0, $5HnsC.NAV4_PROJECT_MENU_ITEM_DRAG_AND_DROP)
                }),
            getOperations: ()=>({
                    'reorder-after': 'available',
                    'reorder-before': 'available'
                }),
            canDrop: ({ source: source })=>source.data.type === (0, $5HnsC.NAV4_PROJECT_MENU_ITEM_DRAG_AND_DROP)
        }
    });
};

});
parcelRegister("2od0u", function(module, exports) {

$parcel$export(module.exports, "useMenuItemDragAndDrop", () => $010a8f70f7dc1045$export$fe281fdb09fbf0c8);
/* use-menu-item-drag-and-drop.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $3joPi = parcelRequire("3joPi");

var $7gWdR = parcelRequire("7gWdR");
parcelRequire("2Uxmu");
var $hJNa8 = parcelRequire("hJNa8");
parcelRequire("erBEN");
var $kpXwZ = parcelRequire("kpXwZ");

var $7yA3r = parcelRequire("7yA3r");

var $h6xiH = parcelRequire("h6xiH");

var $7XuAO = parcelRequire("7XuAO");
const $010a8f70f7dc1045$var$idle = {
    type: 'idle'
};
function $010a8f70f7dc1045$export$fe281fdb09fbf0c8({ draggable: draggableArgs, dropTarget: dropTargetArgs }) {
    const draggableAnchorRef = (0, $5uXOq.useRef)(null);
    const draggableButtonRef = (0, $5uXOq.useRef)(null);
    const dropTargetRef = (0, $5uXOq.useRef)(null);
    const [internalState, setInternalState] = (0, $5uXOq.useState)($010a8f70f7dc1045$var$idle);
    const getDraggableElement = (0, $5uXOq.useCallback)(()=>{
        return draggableAnchorRef.current ?? draggableButtonRef.current ?? null;
    }, []);
    // Set up draggable
    (0, $5uXOq.useEffect)(()=>{
        // Don't set up a draggable if there are no draggable args
        if (!draggableArgs) return;
        const element = getDraggableElement();
        (0, $3joPi.default)(element, `draggableAnchorRef or draggableButtonRef not set`);
        return (0, $7gWdR.draggable)({
            element: element,
            getInitialData: draggableArgs.getInitialData,
            canDrag: draggableArgs.canDrag,
            onGenerateDragPreview ({ nativeSetDragImage: nativeSetDragImage, source: source, location: location }) {
                (0, $kpXwZ.setCustomNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage,
                    getOffset: (0, $hJNa8.pointerOutsideOfPreview)({
                        x: "var(--ds-space-200, 16px)",
                        y: "var(--ds-space-100, 8px)"
                    }),
                    render ({ container: container }) {
                        const args = {
                            dragHandle: source.dragHandle,
                            element: source.element,
                            input: location.current.input
                        };
                        setInternalState({
                            type: 'preview',
                            container: container,
                            ui: draggableArgs.getDragPreviewPieces(args)
                        });
                    }
                });
            },
            onDragStart () {
                setInternalState({
                    type: 'dragging'
                });
            },
            onDrop () {
                setInternalState($010a8f70f7dc1045$var$idle);
            }
        });
    }, [
        draggableArgs,
        getDraggableElement
    ]);
    // Set up drop target
    (0, $5uXOq.useEffect)(()=>{
        if (!dropTargetArgs) return;
        // Don't need to provide a draggable element to have a drop target.
        // Using this element in our `canDrop` check
        const draggableElement = getDraggableElement();
        const dropTarget = dropTargetRef.current;
        (0, $3joPi.default)(dropTarget, `dropTargetRef was not set`);
        return (0, $7gWdR.dropTargetForElements)({
            element: dropTarget,
            // cannot drop on self
            canDrop: (args)=>{
                // cannot drop on self
                if (args.source.element === draggableElement) return false;
                if (dropTargetArgs.canDrop) return dropTargetArgs.canDrop(args);
                return true;
            },
            // menu items are always sticky, and the GroupDropIndicator should clear stickiness
            getIsSticky: ()=>true,
            getData (args) {
                const data = dropTargetArgs.getData?.(args) ?? {};
                const operations = dropTargetArgs.getOperations(args);
                return (0, $7XuAO.attachInstruction)(data, {
                    input: args.input,
                    element: args.element,
                    operations: operations
                });
            },
            onDragStart ({ self: self }) {
                const instruction = (0, $7XuAO.extractInstruction)(self.data);
                setInternalState({
                    type: 'is-over',
                    instruction: instruction
                });
            },
            onDrag ({ self: self }) {
                const instruction = (0, $7XuAO.extractInstruction)(self.data);
                setInternalState((current)=>{
                    if (current.type === 'is-over' && instruction?.operation === current.instruction?.operation && instruction?.blocked === current.instruction?.blocked) return current;
                    return {
                        type: 'is-over',
                        instruction: instruction
                    };
                });
            },
            onDragLeave () {
                setInternalState($010a8f70f7dc1045$var$idle);
            },
            onDrop () {
                setInternalState($010a8f70f7dc1045$var$idle);
            },
            onDragEnter ({ self: self }) {
                const instruction = (0, $7XuAO.extractInstruction)(self.data);
                setInternalState({
                    type: 'is-over',
                    instruction: instruction
                });
            }
        });
    }, [
        dropTargetArgs,
        getDraggableElement
    ]);
    const dragPreview = (()=>{
        if (internalState.type !== 'preview') return null;
        return /*#__PURE__*/ (0, $7nsd3.createPortal)(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $7yA3r.DragPreview), {
            elemBefore: internalState.ui.elemBefore,
            children: internalState.ui.content
        }), internalState.container);
    })();
    const dropIndicator = internalState.type === 'is-over' && internalState.instruction && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h6xiH.DropIndicator), {
        instruction: internalState.instruction
    });
    const state = (0, $5uXOq.useMemo)(()=>{
        if (internalState.type === 'preview') return {
            type: 'preview'
        };
        // returning a new object to avoid modification of our `internalState` object
        return {
            ...internalState
        };
    }, [
        internalState
    ]);
    return {
        state: state,
        draggableButtonRef: draggableButtonRef,
        dropTargetRef: dropTargetRef,
        draggableAnchorRef: draggableAnchorRef,
        dragPreview: dragPreview,
        dropIndicator: dropIndicator
    };
}

});
parcelRegister("2Uxmu", function(module, exports) {

$parcel$export(module.exports, "pointerOutsideOfPreview", () => (parcelRequire("hJNa8")).pointerOutsideOfPreview);

var $hJNa8 = parcelRequire("hJNa8");

});
parcelRegister("hJNa8", function(module, exports) {

$parcel$export(module.exports, "pointerOutsideOfPreview", () => $4030604dbfde028c$export$427e20518819fabc);

var $6XFIM = parcelRequire("6XFIM");

var $6NnQH = parcelRequire("6NnQH");

var $5WRPG = parcelRequire("5WRPG");
function $4030604dbfde028c$export$427e20518819fabc(point) {
    return function getOffset({ container: container }) {
        /**
		 * **Approach: transparent borders.**
		 *
		 * The only reliable cross browser technique found to push a
		 * drag preview away from the cursor is to use transparent borders on the container.
		 *
		 * **🙅📱 Not pushing the preview away on touch devices**
		 *
		 * _On iOS_
		 *
		 * Safari will set the transparent border color to be black
		 *
		 * `iOS@18.4.1` on May 7th 2025:
		 * - If you set the background color on the `container` the border color will be that
		 * - Setting a transparent background color on the `container` still results in a
		 *   black border
		 * - The `<body>` text or background color does not change the black border color
		 *
		 * While dragging, the drag preview will shift under the center of the users pointer.
		 * So if you start at {x: 0, y: 0} (top left), almost immediately the preview will move
		 * to be under the middle of the users pointer.
		 *
		 * _On Android_
		 *
		 * Chrome will put the center of the drag preview under the users pointer immediately.
		 *
		 * Tested on `Chrome@137` on `Android 14` on June 20th 2025
		 *
		 * _What we do_
		 *
		 * We don't add the transparent border
		 *
		 * - Avoid the black color on iOS
		 * - It isn't needed on Android anyway as the preview will be under the center
		 *   of the users pointer
		 *
		 * We put the center of the drag preview under the users pointer
		 *
		 * - Avoids the drag preview quickly moving from a top corner to be centered under
		 *   the users pointer on iOS
		 * - It will be under the center on Android no matter what we do
		 *
		 * We previously had a isTouchDevice() check, but it felt safer for now
		 * to have a more targeted check, as these are the devices that have been
		 * tested on.
		 */ if ((0, $6NnQH.isSafariOnIOS)() || (0, $6XFIM.isAndroid)()) return (0, $5WRPG.centerUnderPointer)({
            container: container
        });
        Object.assign(container.style, {
            borderInlineStart: `${point.x} solid transparent`,
            borderTop: `${point.y} solid transparent`
        });
        // Unfortunate that we need to use `getComputedStyle`,
        // but it's only a single call when the drag is starting.
        const computed = window.getComputedStyle(container);
        if (computed.direction === 'rtl') {
            // The DOMRect will include the new border we added
            const box = container.getBoundingClientRect();
            // Use the top right corner (including the new border) as the offset.
            // The border will push the preview away from the pointer.
            return {
                x: box.width,
                y: 0
            };
        }
        // Use the top left corner as the offset. The border will
        // push the preview away from the pointer.
        return {
            x: 0,
            y: 0
        };
    };
}

});
parcelRegister("6NnQH", function(module, exports) {

$parcel$export(module.exports, "isSafariOnIOS", () => $023dae56098ed162$export$52fc40c68fea4952);

var $jjNE9 = parcelRequire("jjNE9");

var $6aABs = parcelRequire("6aABs");
const $023dae56098ed162$export$52fc40c68fea4952 = (0, $jjNE9.once)(function isSafariOnIOS() {
    return (0, $6aABs.isSafari)() && 'ontouchend' in document;
});

});

parcelRegister("5WRPG", function(module, exports) {

$parcel$export(module.exports, "centerUnderPointer", () => $a6dfccb4849ae59e$export$81d8e72a15eef435);
const $a6dfccb4849ae59e$export$81d8e72a15eef435 = function centerUnderPointer({ container: container }) {
    const rect = container.getBoundingClientRect();
    return {
        x: rect.width / 2,
        y: rect.height / 2
    };
};

});



parcelRegister("erBEN", function(module, exports) {

$parcel$export(module.exports, "setCustomNativeDragPreview", () => (parcelRequire("kpXwZ")).setCustomNativeDragPreview);

var $kpXwZ = parcelRequire("kpXwZ");

});
parcelRegister("kpXwZ", function(module, exports) {

$parcel$export(module.exports, "setCustomNativeDragPreview", () => $39163240d699f88a$export$52d889c66db0f96e);

var $40DDD = parcelRequire("40DDD");

var $6aABs = parcelRequire("6aABs");

/** By default we use the build in values for the native drag preview: {x: 0, y: 0} */ function $39163240d699f88a$var$defaultOffset() {
    return {
        x: 0,
        y: 0
    };
}
function $39163240d699f88a$export$52d889c66db0f96e({ render: render, nativeSetDragImage: nativeSetDragImage, getOffset: getOffset = $39163240d699f88a$var$defaultOffset }) {
    const container = document.createElement('div');
    Object.assign(container.style, {
        // Ensuring we don't cause reflow when adding the element to the page
        // Using `position:fixed` rather than `position:absolute` so we are
        // positioned on the current viewport.
        // `position:fixed` also creates a new stacking context, so we don't need to do that here
        position: 'fixed',
        // According to `mdn`, the element can be offscreen:
        // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage#imgelement
        //
        // However, that  information does not appear in the specs:
        // https://html.spec.whatwg.org/multipage/dnd.html#dom-datatransfer-setdragimage-dev
        //
        // If the element is _completely_ offscreen, Safari@17.1 will cancel the drag
        top: 0,
        left: 0,
        // Using maximum possible z-index so that this element will always be on top
        // https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
        // Did not use `layers` in `@atlaskit/theme` because:
        // 1. This element is not a 'layer' in the conventional sense, as this element
        //    is only created for a single frame for the browser to take a photo of it,
        //    and then it is destroyed
        // 2. Did not want to add a dependency onto `@atlaskit/theme`
        // 3. Want to always be on top of product UI which might have higher z-index's
        zIndex: (0, $ff68169bc3de57ec$export$7d0a15ee70427305),
        // Avoiding any additional events caused by the new element (being super safe)
        pointerEvents: 'none'
    });
    document.body.append(container);
    const unmount = render({
        container: container
    });
    /**
	 * Some frameworks (eg `react`) don't render into the container until the next microtask.
	 * - This will run before the browser takes it's picture of the element
	 * - This will run before the animation frame that removes `container`.
	 * */ queueMicrotask(()=>{
        const previewOffset = getOffset({
            container: container
        });
        /**
		 * **Problem**
		 * On `Safari@17.1` if a drag preview element has some opacity,
		 * Safari will include elements behind the drag preview element
		 * in the drag preview.
		 * Bug: https://bugs.webkit.org/show_bug.cgi?id=266025
		 *
		 * **Fix**
		 * We push the drag preview so it is _almost_ completely offscreen so that
		 * there won't be any elements behind the drag preview element.
		 * If the element is _completely_ offscreen, then the drag is cancelled by Safari.
		 *
		 * Using `-0.0001` so that any potential "see through" on the drag preview element
		 * is effectively invisible 👻
		 *
		 * **Unsuccessful alternatives**
		 * Setting a background color (eg "white") on the `container`
		 * → Wrecks the opacity of the drag preview element
		 *
		 * Adding a parent element of the `container` with a background color (eg "white")
		 * → Wrecks the opacity of the drag preview element
		 */ if ((0, $6aABs.isSafari)()) {
            const rect = container.getBoundingClientRect();
            // We cannot apply this fix if nothing has been rendered into the `container`
            if (rect.width === 0) return;
            container.style.left = `-${rect.width - 0.0001}px`;
        }
        nativeSetDragImage?.(container, previewOffset.x, previewOffset.y);
    });
    function cleanup() {
        unbindMonitor();
        unmount?.();
        document.body.removeChild(container);
    }
    const unbindMonitor = (0, $40DDD.monitorForElements)({
        // Remove portal in the dragstart event so that the user will never see it
        onDragStart: cleanup,
        // Backup: remove portal when the drop finishes (this would be an error case)
        onDrop: cleanup
    });
}

});
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $ff68169bc3de57ec$export$7d0a15ee70427305 = 2147483647;



parcelRegister("7yA3r", function(module, exports) {

$parcel$export(module.exports, "DragPreview", () => $bde38b0290918a3d$export$905ab40ac2179daa);
/* drag-preview.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fknot = parcelRequire("fknot");

var $fdP8o = parcelRequire("fdP8o");

var $4qwFZ = parcelRequire("4qwFZ");
// Using JavaScript for detecting Safari, as I could not find a reliable way to do it with CSS.
function $bde38b0290918a3d$var$isSafari() {
    if (typeof window === 'undefined') return false;
    const { userAgent: userAgent } = navigator;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
}
const $bde38b0290918a3d$var$dragPreviewStyles = {
    root: "_2rkoglpi _189ee4h9 _1h6dmuej _1dqonqa1 _bfhkvuon _y4ti1b66 _p12fgx0z",
    safariFix: "_1ul9uuw1"
};
function $bde38b0290918a3d$export$905ab40ac2179daa({ elemBefore: elemBefore, children: children }) {
    return(// Resetting the expandable menu items to 0.
    // This is to prevent our hidden element from pushing
    // the drag preview further away from the users pointer
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fknot.ExpandableMenuItemLevelContext).Provider, {
        value: 0,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $bwpsq.default)([
                $bde38b0290918a3d$var$dragPreviewStyles.root,
                $bde38b0290918a3d$var$isSafari() && $bde38b0290918a3d$var$dragPreviewStyles.safariFix
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fdP8o.MenuItemBase), {
                elemBefore: elemBefore ?? (0, $4qwFZ.COLLAPSE_ELEM_BEFORE),
                children: children
            })
        })
    }));
}

});

parcelRegister("h6xiH", function(module, exports) {

$parcel$export(module.exports, "DropIndicator", () => $bafd4305cb994349$export$62ed72bc21f6b8a6);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $kOHxT = parcelRequire("kOHxT");

var $5uJ9N = parcelRequire("5uJ9N");
const $bafd4305cb994349$var$axisLookup = {
    vertical: {
        start: 'top',
        end: 'bottom'
    },
    horizontal: {
        start: 'left',
        end: 'right'
    }
};
function $bafd4305cb994349$export$62ed72bc21f6b8a6({ instruction: instruction, lineGap: lineGap, lineType: lineType }) {
    const appearance = instruction.blocked ? 'warning' : 'default';
    const axis = $bafd4305cb994349$var$axisLookup[instruction.axis];
    if (instruction.operation === 'combine') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kOHxT.DropIndicator), {
        appearance: appearance
    });
    if (instruction.operation === 'reorder-before') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uJ9N.DropIndicator), {
        edge: axis.start,
        appearance: appearance,
        gap: lineGap,
        type: lineType
    });
    if (instruction.operation === 'reorder-after') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uJ9N.DropIndicator), {
        edge: axis.end,
        appearance: appearance,
        gap: lineGap,
        type: lineType
    });
    return null;
}

});
parcelRegister("kOHxT", function(module, exports) {

$parcel$export(module.exports, "DropIndicator", () => $4bfe81de297be269$export$62ed72bc21f6b8a6);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $aUWFB = parcelRequire("aUWFB");

var $choBO = parcelRequire("choBO");
function $4bfe81de297be269$export$62ed72bc21f6b8a6({ appearance: appearance = 'default', indent: indent }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aUWFB.Border), {
        strokeColor: (0, $choBO.presetStrokeColors)[appearance],
        indent: indent
    });
}
var // For React.lazy
$4bfe81de297be269$export$2e2bcd8739ae039 = $4bfe81de297be269$export$62ed72bc21f6b8a6;

});
parcelRegister("aUWFB", function(module, exports) {

$parcel$export(module.exports, "Border", () => $dabba09cdf2af051$export$d8e9c9d63e86d41e);
/* border.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $choBO = parcelRequire("choBO");
const $dabba09cdf2af051$var$styles = null;
function $dabba09cdf2af051$export$d8e9c9d63e86d41e({ strokeColor: strokeColor = (0, $choBO.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $choBO.presetStrokeWidth), borderRadius: borderRadius = '3px', indent: // TODO: update to border.radius (4px) token
indent = '0px' }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            '--border-radius': borderRadius,
            '--indent': indent
        },
        className: (0, $bwpsq.default)([
            "_19it1ebc _2rko1koq _kqswstnw _152tidpf _u7coidpf _rjxpidpf _1e02armj _lcxvglyw"
        ])
    });
}
var // For React.lazy
$dabba09cdf2af051$export$2e2bcd8739ae039 = $dabba09cdf2af051$export$d8e9c9d63e86d41e;

});
parcelRegister("choBO", function(module, exports) {

$parcel$export(module.exports, "presetStrokeColors", () => $9f99301ec58274c5$export$477fafec326bfca0);
$parcel$export(module.exports, "presetStrokeWidth", () => $9f99301ec58274c5$export$45db03aa04b685e3);
const $9f99301ec58274c5$export$477fafec326bfca0 = {
    default: "var(--ds-border-selected, #0C66E4)",
    warning: "var(--ds-border-warning, #E56910)"
};
const $9f99301ec58274c5$export$45db03aa04b685e3 = "var(--ds-border-width-outline, 2px)";

});



parcelRegister("5uJ9N", function(module, exports) {

$parcel$export(module.exports, "DropIndicator", () => $057503bea847bf4c$export$62ed72bc21f6b8a6);
$parcel$export(module.exports, "default", () => $057503bea847bf4c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $40bhS = parcelRequire("40bhS");

var $choBO = parcelRequire("choBO");
function $057503bea847bf4c$export$62ed72bc21f6b8a6({ appearance: appearance = 'default', edge: edge, gap: gap, indent: indent, type: type }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $40bhS.Line), {
        edge: edge,
        gap: gap,
        strokeColor: (0, $choBO.presetStrokeColors)[appearance],
        type: type,
        indent: indent
    });
}
var // This default export is intended for usage with React.lazy
$057503bea847bf4c$export$2e2bcd8739ae039 = $057503bea847bf4c$export$62ed72bc21f6b8a6;

});
parcelRegister("40bhS", function(module, exports) {

$parcel$export(module.exports, "Line", () => $5554523a258e458d$export$17d680238e50603e);
/* line.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $choBO = parcelRequire("choBO");
const $5554523a258e458d$var$edgeToOrientationMap = {
    top: 'horizontal',
    bottom: 'horizontal',
    left: 'vertical',
    right: 'vertical'
};
const $5554523a258e458d$var$baseStyles = {
    root: "_1e0c1ule _kqswstnw _1pbykb7n _lcxvglyw _bfhkys7w _rfx31ssb _3l8810ly _kzdanqa1 _15m6ys7w _cfu11ld9 _1kt9b3bt _1cs8stnw _13y0usvi _1mp4vjfa _kfgtvjfa"
};
const $5554523a258e458d$var$orientationStyles = {
    horizontal: "_4t3i10ly _1e02fghn _rjxpidpf _z5wtuj5p",
    vertical: "_1bsb10ly _154ifghn _94n5idpf _1aukuj5p"
};
const $5554523a258e458d$var$edgeStyles = {
    top: "_154ihv0e _1auk70hn",
    right: "_1xi2hv0e _ooun70hn",
    bottom: "_94n5hv0e _19wo70hn",
    left: "_1ltvhv0e _qnec70hn"
};
const $5554523a258e458d$var$lineStartFrom = {
    // - half the terminal bleeding out the containing element
    // - half the terminal inside the containing element (we need to position the line next to this)
    terminal: ({ indent: indent })=>`calc(var(--terminal-radius) + ${indent})`,
    // The full terminal is inside the containing element (we need to position the line next to this)
    'terminal-no-bleed': ({ indent: indent })=>`calc(var(--terminal-diameter) + ${indent})`,
    // No terminal to worry about, line should take up all the space
    'no-terminal': ({ indent: indent })=>indent
};
function $5554523a258e458d$export$17d680238e50603e({ edge: edge, gap: gap = '0px', indent: indent = '0px', strokeColor: strokeColor = (0, $choBO.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $choBO.presetStrokeWidth), type: type = 'terminal' }) {
    const orientation = $5554523a258e458d$var$edgeToOrientationMap[edge];
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            // ## All
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            // Shift line and terminal on the main access to account for gaps between items
            '--main-axis-offset': `calc(-0.5 * (${gap} + var(--stroke-width)))`,
            // ## Line
            // If there is a terminal, we want the line to start from next to it
            '--line-main-axis-start': $5554523a258e458d$var$lineStartFrom[type]({
                indent: indent
            }),
            // ## Terminal
            '--terminal-display': type === 'no-terminal' ? 'none' : 'block',
            '--terminal-diameter': 'calc(var(--stroke-width) * 4)',
            '--terminal-radius': 'calc(var(--terminal-diameter) / 2)',
            // The line is positioned to account for the the terminal (--line-main-axis-start).
            // The terminal is rendered relative to the line (it's a `::before`)
            // We need to pull the terminal backwards so it sits before the start of the line
            '--terminal-main-axis-start': 'calc(-1 * var(--terminal-diameter))',
            // Pull the terminal backwards on the cross axis (eg "up" on "vertical")
            // so the center of the terminal lines up with the center of the line
            '--terminal-cross-axis-offset': 'calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)'
        },
        className: (0, $bwpsq.default)([
            $5554523a258e458d$var$baseStyles.root,
            $5554523a258e458d$var$orientationStyles[orientation],
            $5554523a258e458d$var$edgeStyles[edge]
        ])
    });
}
var // For React.lazy
$5554523a258e458d$export$2e2bcd8739ae039 = $5554523a258e458d$export$17d680238e50603e;

});



parcelRegister("7XuAO", function(module, exports) {

$parcel$export(module.exports, "attachInstruction", () => $ca0cd6fb51d2a87a$export$267ad49d812c2c7f);
$parcel$export(module.exports, "extractInstruction", () => $ca0cd6fb51d2a87a$export$c8ffecbe249dc8f8);

var $l0Z5B = parcelRequire("l0Z5B");
// using a symbol so we can guarantee a key with a unique value
const $ca0cd6fb51d2a87a$var$uniqueKey = Symbol('list-item-instruction');
const $ca0cd6fb51d2a87a$var$axisLookup = {
    vertical: {
        start: 'top',
        end: 'bottom',
        size: 'height',
        point: 'y'
    },
    horizontal: {
        start: 'left',
        end: 'right',
        size: 'width',
        point: 'x'
    }
};
function $ca0cd6fb51d2a87a$var$reorderAndCombine({ client: client, borderBox: borderBox, axis: axis }) {
    const quarterOfSize = borderBox[axis.size] / 4;
    // In the top 1/4: reorder-before
    // On the line: reorder-before to give a slight preference to reordering
    if (client[axis.point] <= borderBox[axis.start] + quarterOfSize) return 'reorder-before';
    // In the bottom 1/4: reorder-after
    // On the line: reorder-after to give a slight preference to reordering
    if (client[axis.point] >= borderBox[axis.end] - quarterOfSize) return 'reorder-after';
    return 'combine';
}
function $ca0cd6fb51d2a87a$var$reorder({ client: client, borderBox: borderBox, axis: axis }) {
    const halfSize = borderBox[axis.size] / 2;
    // In the top 1/2: reorder-before
    // On the line: reorder-after to give a slight preference to moving forward
    if (client[axis.point] < borderBox[axis.start] + halfSize) return 'reorder-before';
    return 'reorder-after';
}
// Note: not using `memoize-one` as all we need is a cached value.
// We do not need to avoid executing an expensive function.
const $ca0cd6fb51d2a87a$var$memoizeInstruction = (0, $l0Z5B.stable)();
function $ca0cd6fb51d2a87a$var$isPossible(...values) {
    return values.every((value)=>value === 'available' || value === 'blocked');
}
function $ca0cd6fb51d2a87a$var$isNotAvailable(...values) {
    return values.every((value)=>value === 'not-available');
}
function $ca0cd6fb51d2a87a$export$267ad49d812c2c7f(userData, { operations: operations, element: element, input: input, axis: axisValue = 'vertical' }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const borderBox = element.getBoundingClientRect();
    const axis = $ca0cd6fb51d2a87a$var$axisLookup[axisValue];
    const combine = operations.combine ?? 'not-available';
    const reorderAbove = operations['reorder-before'] ?? 'not-available';
    const reorderBelow = operations['reorder-after'] ?? 'not-available';
    const operation = (()=>{
        // Combining not possible
        if (!$ca0cd6fb51d2a87a$var$isPossible(combine)) {
            // can reorder above and below
            if ($ca0cd6fb51d2a87a$var$isPossible(reorderAbove, reorderBelow)) return $ca0cd6fb51d2a87a$var$reorder({
                client: client,
                borderBox: borderBox,
                axis: axis
            });
            // can only reorder above
            if ($ca0cd6fb51d2a87a$var$isPossible(reorderAbove)) return 'reorder-before';
            // can only reorder below
            if ($ca0cd6fb51d2a87a$var$isPossible(reorderBelow)) return 'reorder-after';
            // no `true` values - no Outcome available.
            return null;
        }
        // combining is available
        const result = $ca0cd6fb51d2a87a$var$reorderAndCombine({
            client: client,
            borderBox: borderBox,
            axis: axis
        });
        if (result === 'reorder-after') return $ca0cd6fb51d2a87a$var$isNotAvailable(reorderBelow) ? 'combine' : result;
        if (result === 'reorder-before') return $ca0cd6fb51d2a87a$var$isNotAvailable(reorderAbove) ? 'combine' : result;
        return result;
    })();
    // We cannot attach an instruction - all values passed where `false` or no values passed
    if (!operation) return userData;
    const instruction = {
        operation: operation,
        blocked: operations[operation] === 'blocked',
        axis: axisValue
    };
    const memoized = $ca0cd6fb51d2a87a$var$memoizeInstruction(instruction);
    return {
        ...userData,
        [$ca0cd6fb51d2a87a$var$uniqueKey]: memoized
    };
}
function $ca0cd6fb51d2a87a$export$c8ffecbe249dc8f8(userData) {
    return userData[$ca0cd6fb51d2a87a$var$uniqueKey] ?? null;
}

});
parcelRegister("l0Z5B", function(module, exports) {

$parcel$export(module.exports, "isShallowEqual", () => $75d7ad3b386681e2$export$2225b4c39d37f8b3);
$parcel$export(module.exports, "stable", () => $75d7ad3b386681e2$export$3f55479a3469259f);
function $75d7ad3b386681e2$export$2225b4c39d37f8b3(a, b) {
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    return aKeys.every((key)=>Object.is(a[key], b[key]));
}
function $75d7ad3b386681e2$export$3f55479a3469259f(isEqual = $75d7ad3b386681e2$export$2225b4c39d37f8b3) {
    let cache = null;
    return (value)=>{
        if (cache && isEqual(cache.value, value)) return cache.value;
        cache = {
            value: value
        };
        return cache.value;
    };
}

});



parcelRegister("5HnsC", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $b2a7a8d3e422437f$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $b2a7a8d3e422437f$export$d57b6b390e78d90f);
$parcel$export(module.exports, "ANALYTIC_PAYLOAD", () => $b2a7a8d3e422437f$export$4a2242445a67aef7);
$parcel$export(module.exports, "NAV4_PROJECT_MENU_ITEM_DRAG_AND_DROP", () => $b2a7a8d3e422437f$export$e320e335fe38c28a);




var $jecJ3 = parcelRequire("jecJ3");

const $b2a7a8d3e422437f$export$b8b9d90f9e5bd72b = 'jira-navigation-apps-sidebar-nav4-projects-customise-order';
const $b2a7a8d3e422437f$export$d57b6b390e78d90f = 'jira-cosmos';
const $b2a7a8d3e422437f$export$4a2242445a67aef7 = {
    UPDATED_ORDER: {
        action: 'updated',
        actionSubject: 'sidebarNavigationItems',
        actionSubjectId: (0, $d59b407ab907bf7b$export$8d155d2412839524)
    },
    ATTRIBUTES: {
        level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
        componentType: (0, $1e554a683893bd46$export$3ac911b122986477),
        itemType: (0, $632bd8725b437a12$export$fe791c4fa892e400),
        section: (0, $jecJ3.SECTION_ITEM_STARRED)
    }
};
const $b2a7a8d3e422437f$export$e320e335fe38c28a = 'nav4-sidebar-project-menu-item-drag-and-drop';

});



parcelRegister("enCNl", function(module, exports) {

$parcel$export(module.exports, "AsyncJpdProjectMenu", () => $438c4e2b82a869b9$export$b446e65eeda5c1fb);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $7VBev = parcelRequire("7VBev");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $438c4e2b82a869b9$var$LazySidebarContent = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("9X2OS")).then(({ JpdProjectMenu: JpdProjectMenu })=>JpdProjectMenu), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/content/projects/jpd-project-menu/src/ui/index.tsx"
});
const $438c4e2b82a869b9$export$b446e65eeda5c1fb = /*#__PURE__*/ (0, $5uXOq.memo)(({ projectData: projectData, spotlight: spotlight, menuItemButtonRef: menuItemButtonRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.jpd-project-menu",
        packageName: "jiraNavigationAppsSidebarNav4JPDProjectMenu",
        ufoName: "nav4.sidebar.jpd-project-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.jpd-project-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VBev.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($438c4e2b82a869b9$var$LazySidebarContent, {
        projectData: projectData,
        spotlight: spotlight,
        menuItemButtonRef: menuItemButtonRef
    }))));

});
parcelRegister("cljJ9", function(module, exports) {

$parcel$export(module.exports, "SidebarBoundary", () => $f6d5489447b9aa6b$export$1edc778464f08256);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $8dXDG = parcelRequire("8dXDG");

var $93jKl = parcelRequire("93jKl");

var $cfDZ3 = parcelRequire("cfDZ3");

var $l8ruj = parcelRequire("l8ruj");

var $cKjfv = parcelRequire("cKjfv");

var $6Jt8x = parcelRequire("6Jt8x");
const $f6d5489447b9aa6b$export$1edc778464f08256 = ({ children: children, id: id, packageName: packageName, teamName: teamName, ufoName: ufoName = '' })=>{
    const { experience: experience, attributes: attributes } = (0, $cKjfv.useSidebarExperience)();
    const onFail = (0, $93jKl.useExperienceFail)({
        experience: experience,
        attributes: attributes
    });
    const onAbort = (0, $8dXDG.useExperienceAbort)({
        experience: experience,
        attributes: attributes
    });
    const userLocation = (0, $cfDZ3.getUserLocation)();
    const isNotSSR = !false;
    const extraEventData = (0, $5uXOq.useMemo)(()=>({
            userLocation: userLocation
        }), [
        userLocation
    ]);
    const fallback = (0, $5uXOq.useCallback)(({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Jt8x.Fallback), {
            error: error
        }), []);
    const handleError = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (location, error)=>{
        const { statusCode: statusCode } = error;
        if (statusCode >= 400 && statusCode < 500) onAbort('Sidebar failed with validation error', {
            error: error
        });
        else onFail(location, error);
    }, [
        onAbort,
        onFail
    ]);
    const UFOSegmentORFragment = ufoName ? (0, $l8ruj.default) : (0, $5uXOq.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(UFOSegmentORFragment, {
        name: ufoName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: id,
        packageName: packageName,
        extraEventData: extraEventData,
        fallback: fallback,
        teamName: teamName,
        onError: handleError
    }, isNotSSR && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cKjfv.SidebarStart), null), children));
};

});
parcelRegister("6Jt8x", function(module, exports) {

$parcel$export(module.exports, "Fallback", () => $d1b1aff7b337b0d4$export$fb8d7f40caaeea67);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $MHKc7 = parcelRequire("MHKc7");
var $414Wj = parcelRequire("414Wj");
var $dS3PR = parcelRequire("dS3PR");

var $kobfu = parcelRequire("kobfu");

var $7q5TP = parcelRequire("7q5TP");

var $koVbs = parcelRequire("koVbs");

var $5Ntjt = parcelRequire("5Ntjt");
const $d1b1aff7b337b0d4$var$styles = {
    wrapper: "_zulpu2gc _bfhkm7j4 _syaz1gjq _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _y3gn1h6o _4cvr1h6o",
    error: "_2rkogqwt _bfhk1v33 _syaz131l _ca0qv77o _n3tdv77o _19bv1b66 _u5f31b66"
};
const $d1b1aff7b337b0d4$export$fb8d7f40caaeea67 = ({ error: error })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $414Wj.default), {
        xcss: $d1b1aff7b337b0d4$var$styles.wrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7q5TP.default), {
        width: "40px",
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall"
    }, formatMessage((0, $5Ntjt.default).errorHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), null, formatMessage((0, $5Ntjt.default).errorBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        xcss: $d1b1aff7b337b0d4$var$styles.error
    }, "ERROR: ", (0, $kobfu.getErrorHash)(error)));
};

});
parcelRegister("5Ntjt", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ef9823ba7f6e404$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9ef9823ba7f6e404$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorHeading: {
        "id": "navigation-apps-sidebar-nav4-common.sidebar-boundary.fallback.error-heading",
        "defaultMessage": "Something went wrong"
    },
    errorBody: {
        "id": "navigation-apps-sidebar-nav4-common.sidebar-boundary.fallback.error-body",
        "defaultMessage": "Try refreshing or navigating to another page."
    }
});

});



parcelRegister("7VBev", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $af3b5ba721400353$export$8f31e4c4a37b8e9c);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $bgrar = parcelRequire("bgrar");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");
const $af3b5ba721400353$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200",
        xcss: $af3b5ba721400353$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $af3b5ba721400353$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $af3b5ba721400353$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bgrar.default), {
        columnGap: "space.100",
        rowGap: "space.050",
        alignItems: "center",
        templateAreas: [
            'avatar name',
            'avatar type'
        ],
        templateColumns: "min-content 1fr",
        xcss: $af3b5ba721400353$var$projectHeading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $af3b5ba721400353$var$projectAvatar,
        style: {
            gridArea: 'avatar'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $af3b5ba721400353$var$projectName,
        style: {
            gridArea: 'name'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $af3b5ba721400353$var$projectType,
        style: {
            gridArea: 'type'
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $af3b5ba721400353$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $af3b5ba721400353$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $af3b5ba721400353$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $af3b5ba721400353$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $af3b5ba721400353$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $af3b5ba721400353$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $af3b5ba721400353$var$menuItem
    })));
const $af3b5ba721400353$var$containerStyles = (0, $8CUq3.xcss)({
    height: '100%',
    padding: 'space.200'
});
const $af3b5ba721400353$var$backButton = (0, $8CUq3.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100'
});
const $af3b5ba721400353$var$headingSkeleton = (0, $8CUq3.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100',
    flex: 1
});
const $af3b5ba721400353$var$projectHeading = (0, $8CUq3.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.100'
});
const $af3b5ba721400353$var$projectAvatar = (0, $8CUq3.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100'
});
const $af3b5ba721400353$var$projectName = (0, $8CUq3.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-200, 16px)",
    borderRadius: 'border.radius.100'
});
const $af3b5ba721400353$var$projectType = (0, $8CUq3.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-100, 8px)",
    borderRadius: 'border.radius.100'
});
const $af3b5ba721400353$var$menuItem = (0, $8CUq3.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});

});
parcelRegister("bgrar", function(module, exports) {

$parcel$export(module.exports, "default", () => $caed9dac4f56dc1e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $55sHU = parcelRequire("55sHU");

var $8CUq3 = parcelRequire("8CUq3");
function $caed9dac4f56dc1e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $caed9dac4f56dc1e$var$gridTemplateAreasVar = '--ds-grid--grid-template-areas';
const $caed9dac4f56dc1e$var$gridTemplateColumnsVar = '--ds-grid--grid-template-columns';
const $caed9dac4f56dc1e$var$gridTemplateRowsVar = '--ds-grid--grid-template-rows';
const $caed9dac4f56dc1e$var$justifyContentMap = {
    start: {
        name: "j1lm6p",
        styles: "justify-content:start"
    },
    center: {
        name: "f7ay7b",
        styles: "justify-content:center"
    },
    end: {
        name: "jab4lt",
        styles: "justify-content:end"
    },
    'space-between': {
        name: "2o6p8u",
        styles: "justify-content:space-between"
    },
    'space-around': {
        name: "46cjum",
        styles: "justify-content:space-around"
    },
    'space-evenly': {
        name: "16166rn",
        styles: "justify-content:space-evenly"
    },
    stretch: {
        name: "11z2bqs",
        styles: "justify-content:stretch"
    }
};
const $caed9dac4f56dc1e$var$justifyItemsMap = {
    start: {
        name: "lno2ya",
        styles: "justify-items:start"
    },
    center: {
        name: "1wg53za",
        styles: "justify-items:center"
    },
    end: {
        name: "3f7lhf",
        styles: "justify-items:end"
    },
    stretch: {
        name: "16hnylu",
        styles: "justify-items:stretch"
    }
};
const $caed9dac4f56dc1e$var$alignContentMap = {
    start: {
        name: "iqu4as",
        styles: "align-content:start"
    },
    center: {
        name: "13vy23x",
        styles: "align-content:center"
    },
    end: {
        name: "1fj2toh",
        styles: "align-content:end"
    },
    'space-between': {
        name: "1pem0lx",
        styles: "align-content:space-between"
    },
    'space-around': {
        name: "127p7gk",
        styles: "align-content:space-around"
    },
    'space-evenly': {
        name: "kcqjal",
        styles: "align-content:space-evenly"
    },
    stretch: {
        name: "1f8yzab",
        styles: "align-content:stretch"
    }
};
const $caed9dac4f56dc1e$var$alignItemsMap = {
    start: {
        name: "yvwru5",
        styles: "align-items:start"
    },
    center: {
        name: "1h3rtzg",
        styles: "align-items:center"
    },
    baseline: {
        name: "fzr848",
        styles: "align-items:baseline"
    },
    end: {
        name: "uj5xqj",
        styles: "align-items:end"
    }
};
const $caed9dac4f56dc1e$var$baseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'grid',
    boxSizing: 'border-box',
    gridTemplateAreas: `var(${$caed9dac4f56dc1e$var$gridTemplateAreasVar})`,
    gridTemplateColumns: `var(${$caed9dac4f56dc1e$var$gridTemplateColumnsVar})`,
    gridTemplateRows: `var(${$caed9dac4f56dc1e$var$gridTemplateRowsVar})`
});
const $caed9dac4f56dc1e$var$gridAutoFlowMap = {
    row: {
        name: "k3yepi",
        styles: "grid-auto-flow:row"
    },
    column: {
        name: "qu4z1d",
        styles: "grid-auto-flow:column"
    },
    dense: {
        name: "mgx7bc",
        styles: "grid-auto-flow:dense"
    },
    'row dense': {
        name: "1u50cee",
        styles: "grid-auto-flow:row dense"
    },
    'column dense': {
        name: "5ak4pc",
        styles: "grid-auto-flow:column dense"
    }
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $caed9dac4f56dc1e$var$Grid = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, templateAreas: gridTemplateAreas, templateRows: gridTemplateRows, templateColumns: gridTemplateColumns, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    const resolvedStyles = (0, $8CUq3.parseXcss)(xcss);
    /**
   * We use CSS variables to allow for dynamic grid templates instead of dynamically setting to `props.style`
   * This allows `props.xcss` to override them as `style={{ gridTemplateAreas }}` would have higher specificity.
   *
   * This must be reset to `initial` if `gridTemplateAreas` is not set, otherwise nested grids will break!
   *
   * NOTE: If we disallow `grid-template-areas` (etc) to be set via `props.xcss`, we can remove this.
   */ const style = (0, $5uXOq.useMemo)(()=>({
            [$caed9dac4f56dc1e$var$gridTemplateAreasVar]: gridTemplateAreas ? gridTemplateAreas.map((str)=>`"${str}"`).join('\n') || 'initial' : 'initial',
            [$caed9dac4f56dc1e$var$gridTemplateColumnsVar]: gridTemplateColumns || 'initial',
            [$caed9dac4f56dc1e$var$gridTemplateRowsVar]: gridTemplateRows || 'initial'
        }), [
        gridTemplateAreas,
        gridTemplateColumns,
        gridTemplateRows
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $caed9dac4f56dc1e$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $55sHU.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $55sHU.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $55sHU.spaceStylesMap).rowGap[rowGap],
            alignItems && $caed9dac4f56dc1e$var$alignItemsMap[alignItems],
            alignContent && $caed9dac4f56dc1e$var$alignContentMap[alignContent],
            justifyContent && $caed9dac4f56dc1e$var$justifyContentMap[justifyContent],
            autoFlow && $caed9dac4f56dc1e$var$gridAutoFlowMap[autoFlow],
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$caed9dac4f56dc1e$var$Grid.displayName = 'Grid';
var $caed9dac4f56dc1e$export$2e2bcd8739ae039 = $caed9dac4f56dc1e$var$Grid;

});


parcelRegister("9X2OS", function(module, exports) {

let $73ebcfad27ef3e50$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $73ebcfad27ef3e50$var$load("3yAl4"),
    $73ebcfad27ef3e50$var$load("lJSD0")
]).then(()=>parcelRequire('eaE9P'));

});


parcelRegister("38b7M", function(module, exports) {

$parcel$export(module.exports, "AsyncJsmProjectMenu", () => $044e27f3d755a1d3$export$bf0d7afec25f82d7);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $7VBev = parcelRequire("7VBev");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $044e27f3d755a1d3$var$LazySidebarContent = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("7t2TE")).then(({ JsmProjectMenu: JsmProjectMenu })=>JsmProjectMenu), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/content/projects/jsm-project-menu/src/ui/project-menu/index.tsx"
});
const $044e27f3d755a1d3$export$bf0d7afec25f82d7 = /*#__PURE__*/ (0, $5uXOq.memo)(({ projectData: projectData, spotlight: spotlight, menuItemButtonRef: menuItemButtonRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.jsm-project-menu",
        packageName: "jiraNavigationAppsSidebarNav4JsmProjectMenu",
        teamName: "jsm-getting-started",
        ufoName: "nav4.sidebar.jsm-project-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.jsm-project-menu.loading-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VBev.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($044e27f3d755a1d3$var$LazySidebarContent, {
        projectData: projectData,
        spotlight: spotlight,
        menuItemButtonRef: menuItemButtonRef
    }))));

});
parcelRegister("7t2TE", function(module, exports) {

let $56fd7d0733ec1b8b$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $56fd7d0733ec1b8b$var$load("ffQaD"),
    $56fd7d0733ec1b8b$var$load("kvRbA"),
    $56fd7d0733ec1b8b$var$load("76n7a"),
    $56fd7d0733ec1b8b$var$load("l253H"),
    $56fd7d0733ec1b8b$var$load("gVlGa")
]).then(()=>parcelRequire('22eIY'));

});


parcelRegister("5O6Px", function(module, exports) {

$parcel$export(module.exports, "AsyncJcsProjectMenu", () => $c5af8783ef1f4a9b$export$30175e6def84a269);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $7VBev = parcelRequire("7VBev");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $c5af8783ef1f4a9b$var$LazySidebarContent = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("9hcPh")).then(({ JcsProjectMenu: JcsProjectMenu })=>JcsProjectMenu), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/content/projects/jcs-project-menu/src/ui/project-menu/JcsProjectMenu.tsx"
});
const $c5af8783ef1f4a9b$export$30175e6def84a269 = /*#__PURE__*/ (0, $5uXOq.memo)(({ projectData: projectData, spotlight: spotlight, menuItemButtonRef: menuItemButtonRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.jcs-project-menu",
        packageName: "jiraNavigationAppsSidebarNav4JcsProjectMenu",
        teamName: "Boysenberry",
        ufoName: "nav4.sidebar.jcs-project-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.jcs-project-menu.loading-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VBev.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c5af8783ef1f4a9b$var$LazySidebarContent, {
        projectData: projectData,
        spotlight: spotlight,
        menuItemButtonRef: menuItemButtonRef
    }))));

});
parcelRegister("9hcPh", function(module, exports) {

let $6c0fa6911ad83ab0$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6c0fa6911ad83ab0$var$load("ffQaD"),
    $6c0fa6911ad83ab0$var$load("kvRbA"),
    $6c0fa6911ad83ab0$var$load("cGQGY")
]).then(()=>parcelRequire('77zn3'));

});


parcelRegister("k2PPW", function(module, exports) {

$parcel$export(module.exports, "JswProjectMenu", () => $37f44a28095ceb78$export$6bfce83b67850c4);

var $erlTu = parcelRequire("erlTu");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $2vSU6 = parcelRequire("2vSU6");

var $c1pSA = parcelRequire("c1pSA");

var $igsK5 = parcelRequire("igsK5");
const $37f44a28095ceb78$export$6bfce83b67850c4 = ({ projectData: projectData, spotlight: spotlight, menuItemAnchorRef: menuItemAnchorRef, menuItemButtonRef: menuItemButtonRef })=>{
    const project = (0, $8Uumt.useFragment)((0, $erlTu.default), projectData);
    if (project.softwareBoardCount && project.softwareBoardCount > 0 && project.projectStyle === (0, $2vSU6.COMPANY_MANAGED_PROJECT)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c1pSA.JswExpandableProject), {
        projectData: project,
        spotlight: spotlight,
        menuItemButtonRef: menuItemButtonRef
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $igsK5.JswNonExpandableProject), {
        projectData: project,
        spotlight: spotlight,
        menuItemAnchorRef: menuItemAnchorRef
    });
};

});
parcelRegister("erlTu", function(module, exports) {

$parcel$export(module.exports, "default", () => $40b193e92809e464$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<142350677583825fa114d01e8067ae41>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $40b193e92809e464$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "JswProjectMenu",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "softwareBoardCount"
        },
        {
            "kind": "ScalarField",
            "name": "projectStyle"
        },
        {
            "kind": "FragmentSpread",
            "name": "JswNonExpandableProject"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "JswExpandableProject"
                }
            ]
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "JswExpandableProjectNew"
                }
            ]
        }
    ],
    "type": "JiraProject"
};
$40b193e92809e464$var$node.hash = "ef673d7daab31033c619bf95c78cd4b4";
var $40b193e92809e464$export$2e2bcd8739ae039 = $40b193e92809e464$var$node;

});

parcelRegister("c1pSA", function(module, exports) {

$parcel$export(module.exports, "JswExpandableProject", () => $fb08c4a99aac50be$export$a77599e713340697);

var $hAJ2D = parcelRequire("hAJ2D");

var $kKbGS = parcelRequire("kKbGS");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dcP6E = parcelRequire("dcP6E");
var $lnznH = parcelRequire("lnznH");
var $cZa9B = parcelRequire("cZa9B");

var $6Lyip = parcelRequire("6Lyip");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $kavsL = parcelRequire("kavsL");

var $fNJRN = parcelRequire("fNJRN");

var $jhS4y = parcelRequire("jhS4y");

var $c16H2 = parcelRequire("c16H2");

var $338xa = parcelRequire("338xa");

var $7C7jZ = parcelRequire("7C7jZ");

var $dQbFB = parcelRequire("dQbFB");

var $4zcxJ = parcelRequire("4zcxJ");

var $76MhN = parcelRequire("76MhN");

var $koeKL = parcelRequire("koeKL");

var $4R6GH = parcelRequire("4R6GH");

var $9n0dK = parcelRequire("9n0dK");

var $5GG0x = parcelRequire("5GG0x");


var $2Ioew = parcelRequire("2Ioew");

var $bmKPg = parcelRequire("bmKPg");

var $cSD7y = parcelRequire("cSD7y");

var $60FHh = parcelRequire("60FHh");

var $7mPT9 = parcelRequire("7mPT9");

var $eIGIx = parcelRequire("eIGIx");

var $8qvci = parcelRequire("8qvci");


var $dwZUI = parcelRequire("dwZUI");

var $gfIrU = parcelRequire("gfIrU");

var $1kZCN = parcelRequire("1kZCN");
const $fb08c4a99aac50be$var$JswExpandableProjectOld = ({ projectData: projectData, spotlight: spotlight, menuItemButtonRef: menuItemButtonRef })=>{
    const { sendProjectMenuItemAnalyticsEvent: sendProjectMenuItemAnalyticsEvent } = (0, $fNJRN.useProjectsAnalyticsL1)();
    const project = (0, $8Uumt.useFragment)((0, $kKbGS.default), projectData);
    const cloudId = (0, $koeKL.useCloudId)();
    const entryPointParamsOld = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            projectId: project.id,
            noOfBoardsToFetch: (0, $ba4e5f586c2a87d8$export$420a3ee5deb615a9)
        }), [
        cloudId,
        project.id
    ]);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            tenantContext: {
                cloudId: cloudId
            },
            context: {
                match: {
                    params: {
                        projectKey: project.projectKey
                    }
                }
            }
        }), [
        cloudId,
        project.projectKey
    ]);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const leftSidebarEPRef = (0, $2Ioew.usePageLayoutEntryPoint)((0, $6d6ccf8a2b2c5b3c$export$50ea883ba6f28ff5));
    const boardsEPRef = leftSidebarEPRef?.entryPoints?.boards;
    const [projectKey] = (0, $bmKPg.usePathParam)('projectKey');
    const shouldRenderBoardsEntryPoint = project.projectKey === projectKey;
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $dwZUI.nav4JSWProjectEntryPoint), entryPointParams);
    const { entryPointActions: entryPointActionsOld, entryPointReferenceSubject: entryPointReferenceSubjectOld } = (0, $4mO32.useEntryPoint)((0, $gfIrU.asyncJswExpandableProjectQuery), entryPointParamsOld);
    const actionsOnHoverEntryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            projectId: project.id
        }), [
        cloudId,
        project.id
    ]);
    const { entryPointActions: actionsOnHoverEntryPointActions, entryPointReferenceSubject: actionsOnHoverEntryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $1kZCN.asyncActionsOnHover), actionsOnHoverEntryPointParams);
    const triggerRef = (0, $4zcxJ.useExpandableEntryPointTrigger)(entryPointActions);
    const triggerRefOld = (0, $4zcxJ.useExpandableEntryPointTrigger)(entryPointActionsOld);
    const actionsOnHoverCollapsedRef = (0, $9n0dK.useHoverEntryPointTrigger)(actionsOnHoverEntryPointActions);
    const { getLinkProps: getLinkProps } = (0, $7C7jZ.useGetLinkProps)();
    // Create this component once, then keep using it FOREVER.
    // We don't want to keep switching the implementation as the user does SPA transitions.
    const [entryPointConfig] = (0, $5uXOq.useState)(()=>{
        const epContainerProps = {
            id: 'jsw-expandable-project',
            packageName: (0, $ba4e5f586c2a87d8$export$b8b9d90f9e5bd72b),
            teamName: (0, $ba4e5f586c2a87d8$export$d57b6b390e78d90f),
            errorFallback: 'flag',
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), null),
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            runtimeProps: entryPointParams
        };
        return {
            Component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5GG0x.RouteEntryPointContainer), {
                    epContainerProps: epContainerProps,
                    jiraEPRef: entryPointReferenceSubject,
                    nestedEPRef: boardsEPRef,
                    placeholderEntryPoint: (0, $dwZUI.nav4JSWProjectEntryPoint),
                    shouldRenderNestedEntryPoint: shouldRenderBoardsEntryPoint
                })
        };
    });
    const content = ()=>{
        if ((0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(entryPointConfig.Component, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            // Data stream, will subscribe to load updates.
            entryPointReferenceSubject: entryPointReferenceSubjectOld,
            // Required props for error JSErrorBoundary.
            id: "jsw-expandable-project",
            packageName: (0, $ba4e5f586c2a87d8$export$b8b9d90f9e5bd72b),
            // Optional props for error JSErrorBoundary.
            errorFallback: "flag",
            teamName: (0, $ba4e5f586c2a87d8$export$d57b6b390e78d90f),
            // Fallback for `Suspense`.
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), null),
            // Props for the root component.
            runtimeProps: entryPointParamsOld
        });
    };
    const onSystemToggle = (0, $eIGIx.useCallbackWithCondition)((hasExpanded)=>{
        if (hasExpanded) {
            if ((0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route')) entryPointActions.load();
            else entryPointActionsOld.load();
            actionsOnHoverEntryPointActions.load();
        }
    }, [
        actionsOnHoverEntryPointActions,
        entryPointActions,
        entryPointActionsOld
    ], ()=>(0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1'));
    const onExpansionToggle = (0, $eIGIx.useCallbackWithCondition)((hasExpanded)=>{
        if (hasExpanded) {
            if ((0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route')) entryPointActions.load();
            else entryPointActionsOld.load();
            actionsOnHoverEntryPointActions.load();
            sendProjectMenuItemAnalyticsEvent({
                starred: project.isFavourite ?? false,
                recent: !project.isFavourite,
                projectId: project.projectId,
                projectType: project.projectType
            });
        }
    }, [
        actionsOnHoverEntryPointActions,
        entryPointActions,
        entryPointActionsOld,
        project.isFavourite,
        project.projectId,
        project.projectType,
        sendProjectMenuItemAnalyticsEvent
    ], ()=>(0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1'));
    const onClick = (0, $eIGIx.useCallbackWithCondition)((ev)=>{
        if ((0, $kavsL.isNormalClick)(ev)) ev.preventDefault();
    }, [], ()=>(0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1'));
    if (!project) return null;
    const menuId = (0, $jhS4y.ENTITY_ID).PROJECT(project.projectKey);
    if ((0, $4R6GH.fg)('blu-6314-drag-and-drop-projects-sidebar-mouse')) {
        const { projectId: projectId, projectKey: pk, isFavourite: isFavourite, name: name, avatar: avatar } = project;
        const { state: state, draggableAnchorRef: draggableAnchorRef, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator, dragPreview: dragPreview } = // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $8qvci.useProjectMenuItemDragAndDrop)({
            projectId: projectId,
            projectKey: pk,
            isFavourite: isFavourite,
            name: name,
            avatar: avatar
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
            menuId: menuId,
            onSystemToggle: onSystemToggle,
            collapsedRef: actionsOnHoverCollapsedRef,
            onExpansionToggle: onExpansionToggle,
            dropIndicator: dropIndicator,
            dropTargetRef: dropTargetRef,
            isDragging: state.type === 'dragging'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Lyip.OnboardingSpotlightMaybe), {
            key: project.projectKey,
            spotlight: spotlight
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZa9B.ExpandableMenuItemTrigger), {
            ...getLinkProps((0, $76MhN.removeBaseUrl)(project.webUrl)),
            actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
                entryPointReferenceSubject: actionsOnHoverEntryPointReferenceSubject,
                id: "jsw-expandable-project-actions",
                packageName: (0, $ba4e5f586c2a87d8$export$b8b9d90f9e5bd72b),
                errorFallback: "flag",
                teamName: (0, $ba4e5f586c2a87d8$export$d57b6b390e78d90f),
                runtimeProps: actionsOnHoverEntryPointParams
            }),
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dcP6E.ContainerAvatar), {
                src: project.avatar.large
            }),
            ref: (0, $7mPT9.mergeRefs)(draggableAnchorRef, ...[
                (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route') ? triggerRef : triggerRefOld,
                menuItemButtonRef
            ].filter(Boolean)),
            onClick: onClick,
            testId: (0, $dQbFB.getTestId)(menuId),
            hasDragIndicator: true,
            isDragging: state.type === 'dragging'
        }, project.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnznH.ExpandableMenuItemContent), null, content())), dragPreview);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        menuId: menuId,
        onSystemToggle: onSystemToggle,
        collapsedRef: actionsOnHoverCollapsedRef,
        onExpansionToggle: onExpansionToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Lyip.OnboardingSpotlightMaybe), {
        key: project.projectKey,
        spotlight: spotlight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZa9B.ExpandableMenuItemTrigger), {
        ...getLinkProps((0, $76MhN.removeBaseUrl)(project.webUrl)),
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: actionsOnHoverEntryPointReferenceSubject,
            id: "jsw-expandable-project-actions",
            packageName: (0, $ba4e5f586c2a87d8$export$b8b9d90f9e5bd72b),
            errorFallback: "flag",
            teamName: (0, $ba4e5f586c2a87d8$export$d57b6b390e78d90f),
            runtimeProps: actionsOnHoverEntryPointParams
        }),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dcP6E.ContainerAvatar), {
            src: project.avatar.large
        }),
        ref: (0, $7mPT9.mergeRefs)(...[
            (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route') ? triggerRef : triggerRefOld,
            menuItemButtonRef
        ].filter(Boolean)),
        onClick: onClick,
        testId: (0, $dQbFB.getTestId)(menuId)
    }, project.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnznH.ExpandableMenuItemContent), null, content()));
};
const $fb08c4a99aac50be$var$JswExpandableProjectNew = ({ projectData: projectData, spotlight: spotlight, menuItemButtonRef: menuItemButtonRef })=>{
    const { sendProjectMenuItemAnalyticsEvent: sendProjectMenuItemAnalyticsEvent } = (0, $fNJRN.useProjectsAnalyticsL1)();
    const project = (0, $8Uumt.useFragment)((0, $hAJ2D.default), projectData);
    const cloudId = (0, $koeKL.useCloudId)();
    const entryPointParamsOld = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            projectId: project.id,
            noOfBoardsToFetch: (0, $ba4e5f586c2a87d8$export$420a3ee5deb615a9)
        }), [
        cloudId,
        project.id
    ]);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            tenantContext: {
                cloudId: cloudId
            },
            context: {
                match: {
                    params: {
                        projectKey: project.projectKey
                    }
                }
            }
        }), [
        cloudId,
        project.projectKey
    ]);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const leftSidebarEPRef = (0, $2Ioew.usePageLayoutEntryPoint)((0, $6d6ccf8a2b2c5b3c$export$50ea883ba6f28ff5));
    const boardsEPRef = leftSidebarEPRef?.entryPoints?.boards;
    const [projectKey] = (0, $bmKPg.usePathParam)('projectKey');
    const shouldRenderBoardsEntryPoint = project.projectKey === projectKey;
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $dwZUI.nav4JSWProjectEntryPoint), entryPointParams);
    const { entryPointActions: entryPointActionsOld, entryPointReferenceSubject: entryPointReferenceSubjectOld } = (0, $4mO32.useEntryPoint)((0, $gfIrU.asyncJswExpandableProjectQuery), entryPointParamsOld);
    const triggerRef = (0, $4zcxJ.useExpandableEntryPointTrigger)(entryPointActions);
    const triggerRefOld = (0, $4zcxJ.useExpandableEntryPointTrigger)(entryPointActionsOld);
    const { getLinkProps: getLinkProps } = (0, $7C7jZ.useGetLinkProps)();
    // Create this component once, then keep using it FOREVER.
    // We don't want to keep switching the implementation as the user does SPA transitions.
    const [entryPointConfig] = (0, $5uXOq.useState)(()=>{
        const epContainerProps = {
            id: 'jsw-expandable-project',
            packageName: (0, $ba4e5f586c2a87d8$export$b8b9d90f9e5bd72b),
            teamName: (0, $ba4e5f586c2a87d8$export$d57b6b390e78d90f),
            errorFallback: 'flag',
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), null),
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            runtimeProps: entryPointParams
        };
        return {
            Component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5GG0x.RouteEntryPointContainer), {
                    epContainerProps: epContainerProps,
                    jiraEPRef: entryPointReferenceSubject,
                    nestedEPRef: boardsEPRef,
                    placeholderEntryPoint: (0, $dwZUI.nav4JSWProjectEntryPoint),
                    shouldRenderNestedEntryPoint: shouldRenderBoardsEntryPoint
                })
        };
    });
    const content = ()=>{
        if ((0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(entryPointConfig.Component, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            // Data stream, will subscribe to load updates.
            entryPointReferenceSubject: entryPointReferenceSubjectOld,
            // Required props for error JSErrorBoundary.
            id: "jsw-expandable-project",
            packageName: (0, $ba4e5f586c2a87d8$export$b8b9d90f9e5bd72b),
            // Optional props for error JSErrorBoundary.
            errorFallback: "flag",
            teamName: (0, $ba4e5f586c2a87d8$export$d57b6b390e78d90f),
            // Fallback for `Suspense`.
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), null),
            // Props for the root component.
            runtimeProps: entryPointParamsOld
        });
    };
    const onSystemToggle = (0, $eIGIx.useCallbackWithCondition)((hasExpanded)=>{
        if (hasExpanded) {
            if ((0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route')) entryPointActions.load();
            else entryPointActionsOld.load();
        }
    }, [
        entryPointActions,
        entryPointActionsOld
    ], ()=>(0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1'));
    const onExpansionToggle = (0, $eIGIx.useCallbackWithCondition)((hasExpanded)=>{
        if (hasExpanded) {
            if ((0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route')) entryPointActions.load();
            else entryPointActionsOld.load();
            sendProjectMenuItemAnalyticsEvent({
                starred: project.isFavourite ?? false,
                recent: !project.isFavourite,
                projectId: project.projectId,
                projectType: project.projectType
            });
        }
    }, [
        entryPointActions,
        entryPointActionsOld,
        project.isFavourite,
        project.projectId,
        project.projectType,
        sendProjectMenuItemAnalyticsEvent
    ], ()=>(0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1'));
    const onClick = (0, $eIGIx.useCallbackWithCondition)((ev)=>{
        if ((0, $kavsL.isNormalClick)(ev)) ev.preventDefault();
    }, [], ()=>(0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1'));
    if (!project) return null;
    const menuId = (0, $jhS4y.ENTITY_ID).PROJECT(project.projectKey);
    if ((0, $4R6GH.fg)('blu-6314-drag-and-drop-projects-sidebar-mouse')) {
        const { projectId: projectId, projectKey: pk, isFavourite: isFavourite, name: name, avatar: avatar } = project;
        const { state: state, draggableAnchorRef: draggableAnchorRef, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator, dragPreview: dragPreview } = // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $8qvci.useProjectMenuItemDragAndDrop)({
            projectId: projectId,
            projectKey: pk,
            isFavourite: isFavourite,
            name: name,
            avatar: avatar
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
            menuId: menuId,
            onSystemToggle: onSystemToggle,
            onExpansionToggle: onExpansionToggle,
            dropIndicator: dropIndicator,
            dropTargetRef: dropTargetRef,
            isDragging: state.type === 'dragging'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Lyip.OnboardingSpotlightMaybe), {
            key: project.projectKey,
            spotlight: spotlight
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZa9B.ExpandableMenuItemTrigger), {
            ...getLinkProps((0, $76MhN.removeBaseUrl)(project.webUrl)),
            actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $60FHh.ProjectActions), {
                projectFragment: project
            }),
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dcP6E.ContainerAvatar), {
                src: project.avatar.large
            }),
            ref: (0, $7mPT9.mergeRefs)(draggableAnchorRef, ...[
                (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route') ? triggerRef : triggerRefOld,
                menuItemButtonRef
            ].filter(Boolean)),
            onClick: onClick,
            testId: (0, $dQbFB.getTestId)(menuId),
            hasDragIndicator: true,
            isDragging: state.type === 'dragging'
        }, project.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnznH.ExpandableMenuItemContent), null, content())), dragPreview);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        menuId: menuId,
        onSystemToggle: onSystemToggle,
        onExpansionToggle: onExpansionToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Lyip.OnboardingSpotlightMaybe), {
        key: project.projectKey,
        spotlight: spotlight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZa9B.ExpandableMenuItemTrigger), {
        ...getLinkProps((0, $76MhN.removeBaseUrl)(project.webUrl)),
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $60FHh.ProjectActions), {
            projectFragment: project
        }),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dcP6E.ContainerAvatar), {
            src: project.avatar.large
        }),
        ref: (0, $7mPT9.mergeRefs)(...[
            (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route') ? triggerRef : triggerRefOld,
            menuItemButtonRef
        ].filter(Boolean)),
        onClick: onClick,
        testId: (0, $dQbFB.getTestId)(menuId)
    }, project.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnznH.ExpandableMenuItemContent), null, content()));
};
const $fb08c4a99aac50be$export$a77599e713340697 = (0, $cSD7y.componentWithFG)('project-actions-sync-iv-llc', $fb08c4a99aac50be$var$JswExpandableProjectNew, $fb08c4a99aac50be$var$JswExpandableProjectOld);

});
parcelRegister("hAJ2D", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2297a8762a50b30$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b0539709d32aef0321d580c26487ecb9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c2297a8762a50b30$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "JswExpandableProjectNew",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "alias": "projectKey",
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "projectKey"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectId"
            },
            "action": "THROW",
            "path": "projectId"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "large"
                        },
                        "action": "THROW",
                        "path": "avatar.large"
                    }
                ]
            },
            "action": "THROW",
            "path": "avatar"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW",
            "path": "name"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "webUrl"
            },
            "action": "THROW",
            "path": "webUrl"
        },
        {
            "kind": "FragmentSpread",
            "name": "ProjectActions"
        }
    ],
    "type": "JiraProject"
};
$c2297a8762a50b30$var$node.hash = "10a0c9f1c3e33b86d8b25d5721530355";
var $c2297a8762a50b30$export$2e2bcd8739ae039 = $c2297a8762a50b30$var$node;

});

parcelRegister("kKbGS", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c3bea37742d5a83$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9727aa71a5cdff573b12535f712a837b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6c3bea37742d5a83$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "JswExpandableProject",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "alias": "projectKey",
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "projectKey"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectId"
            },
            "action": "THROW",
            "path": "projectId"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "large"
                        },
                        "action": "THROW",
                        "path": "avatar.large"
                    }
                ]
            },
            "action": "THROW",
            "path": "avatar"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW",
            "path": "name"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "webUrl"
            },
            "action": "THROW",
            "path": "webUrl"
        }
    ],
    "type": "JiraProject"
};
$6c3bea37742d5a83$var$node.hash = "bc82624e777151d194c0c11c3eca6c58";
var $6c3bea37742d5a83$export$2e2bcd8739ae039 = $6c3bea37742d5a83$var$node;

});

parcelRegister("kavsL", function(module, exports) {

$parcel$export(module.exports, "isNormalClick", () => $e059487e30c8155a$export$729f3684d5c2b9b9);
const $e059487e30c8155a$export$729f3684d5c2b9b9 = (e)=>!('button' in e && e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);

});

parcelRegister("7C7jZ", function(module, exports) {

$parcel$export(module.exports, "useGetLinkProps", () => $a1cefbecfd084e6c$export$a3307878c8496d13);

var $5uXOq = parcelRequire("5uXOq");

var $9VXkC = parcelRequire("9VXkC");

var $3TY9o = parcelRequire("3TY9o");
const $a1cefbecfd084e6c$export$a3307878c8496d13 = ()=>{
    const location = (0, $3TY9o.useLocation)();
    const getLinkProps = (0, $5uXOq.useCallback)((menuItemPath, options)=>$a1cefbecfd084e6c$var$getMenuLinkPropsFromUrlPath({
            currentPath: location.pathname,
            menuItemPath: menuItemPath,
            options: options
        }), [
        location.pathname
    ]);
    const getLinkPropsFromRoute = (0, $5uXOq.useCallback)((menuItemRoute, pathParamValues = {}, options)=>{
        const menuItemPath = (0, $9VXkC.generatePath)(menuItemRoute.path, pathParamValues);
        return getLinkProps(menuItemPath, options);
    }, [
        getLinkProps
    ]);
    return {
        getLinkPropsFromRoute: getLinkPropsFromRoute,
        getLinkProps: /**
		 * Consider using getLinkPropsFromRoute instead, to be able to reuse the page route object, rather than copying its url path around.
		 */ getLinkProps
    };
};
const $a1cefbecfd084e6c$var$defaultOptions = {
    shouldMatchExactPath: true
};
const $a1cefbecfd084e6c$var$getMenuLinkPropsFromUrlPath = ({ currentPath: currentPath, menuItemPath: menuItemPath, options: options })=>{
    const { shouldMatchExactPath: shouldMatchExactPath } = {
        ...$a1cefbecfd084e6c$var$defaultOptions,
        ...options
    };
    return {
        href: menuItemPath,
        isSelected: shouldMatchExactPath ? currentPath.replace(/\/$/, '') === menuItemPath.replace(/\/$/, '') : currentPath.includes(menuItemPath.replace(/\/$/, ''))
    };
};

});

parcelRegister("76MhN", function(module, exports) {

$parcel$export(module.exports, "removeBaseUrl", () => $710c5248ed45c131$export$d401b6140b158f69);
/**
 * Removes the base URL from the given URL string.
 *
 * @param url - The URL string from which to remove the base URL.
 * @returns The URL string with the base URL removed.
 */ const $710c5248ed45c131$export$d401b6140b158f69 = (url)=>url.replace(/https?:\/\/[^/]+/, '');

});

parcelRegister("60FHh", function(module, exports) {

$parcel$export(module.exports, "ProjectActions", () => $0230a4e09f5a8c38$export$7f68bfd3564d5c6f);

var $5jRC6 = parcelRequire("5jRC6");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dZbEw = parcelRequire("dZbEw");

var $bUmQV = parcelRequire("bUmQV");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $hUpXm = parcelRequire("hUpXm");

var $1xonH = parcelRequire("1xonH");

var $ccuaM = parcelRequire("ccuaM");

var $brwH6 = parcelRequire("brwH6");

var $44kzF = parcelRequire("44kzF");

var $lmBAt = parcelRequire("lmBAt");

var $a2e2Q = parcelRequire("a2e2Q");

var $lODMY = parcelRequire("lODMY");

var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");

var $7TnTU = parcelRequire("7TnTU");

var $jzmXi = parcelRequire("jzmXi");
const $0230a4e09f5a8c38$export$70911e2dbc8f12b6 = (0, $lODMY.createRouterSelector)((state)=>state.match);
const $0230a4e09f5a8c38$var$Trigger = ({ triggerRef: triggerRef, isFavourite: isFavourite, projectId: projectId, projectType: projectType, setCreateBoardButtonRef: setCreateBoardButtonRef, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { sendCreateBoardOnBoardMenuItemAnalyticsEvent: sendCreateBoardOnBoardMenuItemAnalyticsEvent } = (0, $hUpXm.useProjectsAnalyticsL2)();
    // callback to set button element to local ref.
    // to be used as prop for setting focus back to button after modal close.
    const setRef = (0, $5uXOq.useCallback)((buttonElement)=>{
        setCreateBoardButtonRef(buttonElement);
        if (typeof triggerRef === 'function') triggerRef(buttonElement);
    }, [
        setCreateBoardButtonRef,
        triggerRef
    ]);
    const onCommonNavMenuButtonClick = (0, $5uXOq.useCallback)((event)=>{
        const { onClick: onClick } = props;
        onClick?.(event);
        sendCreateBoardOnBoardMenuItemAnalyticsEvent({
            starred: isFavourite ?? false,
            recent: !isFavourite,
            projectId: projectId,
            projectType: projectType
        });
    }, [
        isFavourite,
        projectId,
        projectType,
        props,
        sendCreateBoardOnBoardMenuItemAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $jzmXi.default).createBoard)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1xonH.CommonNavMenuButton), {
        ...props,
        onClick: onCommonNavMenuButtonClick,
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage((0, $jzmXi.default).createBoard),
        ref: setRef
    }));
};
const $0230a4e09f5a8c38$export$7f68bfd3564d5c6f = ({ projectFragment: projectFragment, isCorePremiumUserSeat: isCorePremiumUserSeat = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { sendMeatBallDropDownOnProjectsAnalyticsEvent: sendMeatBallDropDownOnProjectsAnalyticsEvent, sendCreateBoardOnBoardMenuItemAnalyticsEvent: sendCreateBoardOnBoardMenuItemAnalyticsEvent } = (0, $hUpXm.useProjectsAnalyticsL2)();
    const match = (0, $lmBAt.getIsSoftwareThemingEnabled)() ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $0230a4e09f5a8c38$export$70911e2dbc8f12b6() : undefined;
    const createBoardButtonRef = (0, $5uXOq.useRef)(null);
    const { hasSoftwareTheming: hasSoftwareTheming } = (0, $lmBAt.getIsSoftwareThemingEnabled)() ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $a2e2Q.useSoftwareProjectTheming)() : {
        hasSoftwareTheming: false
    };
    const project = (0, $8Uumt.useFragment)((0, $5jRC6.default), projectFragment);
    const onProjectActionMenuClick = (0, $5uXOq.useCallback)(()=>{
        sendMeatBallDropDownOnProjectsAnalyticsEvent({
            starred: project.isFavourite ?? false,
            recent: !project.isFavourite,
            projectId: project.projectId,
            projectType: project.projectType
        });
    }, [
        project.isFavourite,
        project.projectId,
        project.projectType,
        sendMeatBallDropDownOnProjectsAnalyticsEvent
    ]);
    const canChangeTheme = (0, $5uXOq.useMemo)(()=>{
        const canEditProjectConfig = project?.editPermission?.canPerform ?? false;
        const currentProjectKey = match?.params?.projectKey || match?.params?.issueKey?.split('-')[0];
        return currentProjectKey === project.projectKey && canEditProjectConfig && hasSoftwareTheming;
    }, [
        hasSoftwareTheming,
        match?.params?.issueKey,
        match?.params?.projectKey,
        project?.editPermission?.canPerform,
        project.projectKey
    ]);
    const additionalMenuItems = (0, $5uXOq.useMemo)(()=>{
        return canChangeTheme && !(0, $4R6GH.fg)('project_theming_m2_fast_follow_2') && (0, $lmBAt.getIsSoftwareThemingEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44kzF.ThemePicker), {
            projectId: Number(project.projectId),
            withAdaptiveColorTheme: true
        });
    }, [
        canChangeTheme,
        project.projectId
    ]);
    const projectActionMenu = (0, $5uXOq.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ccuaM.ProjectActionMenu), {
            ...(0, $4R6GH.fg)('jsm_aiiy_for_nav_item_sidebar') ? {
                projectName: project.name
            } : {},
            onClick: (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? onProjectActionMenuClick : ()=>{
                sendMeatBallDropDownOnProjectsAnalyticsEvent({
                    starred: project.isFavourite ?? false,
                    recent: !project.isFavourite,
                    projectId: project.projectId,
                    projectType: project.projectType
                });
            },
            additionalMenuItems: (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? additionalMenuItems : canChangeTheme && !(0, $4R6GH.fg)('project_theming_m2_fast_follow_2') && (0, $lmBAt.getIsSoftwareThemingEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44kzF.ThemePicker), {
                projectId: Number(project.projectId),
                withAdaptiveColorTheme: true
            }),
            projectKey: project.projectKey,
            isCorePremiumUserSeat: isCorePremiumUserSeat,
            isProjectMenuReorderingEnabled: project?.isFavourite === true && (0, $6s1PB.expVal)('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false)
        });
    }, [
        project.name,
        project.projectKey,
        project.projectId,
        project.isFavourite,
        project.projectType,
        onProjectActionMenuClick,
        additionalMenuItems,
        isCorePremiumUserSeat,
        canChangeTheme,
        sendMeatBallDropDownOnProjectsAnalyticsEvent
    ]);
    const setCreateBoardButtonRef = (0, $5uXOq.useCallback)((instance)=>{
        createBoardButtonRef.current = instance;
    }, [
        createBoardButtonRef
    ]);
    const renderTrigger = (0, $5uXOq.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0230a4e09f5a8c38$var$Trigger, {
            ...props,
            isFavourite: project.isFavourite ?? false,
            projectId: project.projectId,
            projectType: project.projectType,
            setCreateBoardButtonRef: setCreateBoardButtonRef
        }), [
        project.isFavourite,
        project.projectId,
        project.projectType,
        setCreateBoardButtonRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
        gap: "space.050",
        alignItems: "center"
    }, (0, $7TnTU.isCompanyManagedSoftwareProject)(project.projectStyle, project.projectType) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $brwH6.BoardCreate), {
        projectId: project.projectId,
        projectAvatar: project.avatar?.large || undefined,
        triggerRef: createBoardButtonRef,
        renderTrigger: (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? renderTrigger : ({ triggerRef: triggerRef, ...props })=>{
            // callback to set button element to local ref.
            // to be used as prop for setting focus back to button after modal close.
            const setRef = (buttonElement)=>{
                createBoardButtonRef.current = buttonElement;
                if (typeof triggerRef === 'function') triggerRef(buttonElement);
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: formatMessage((0, $jzmXi.default).createBoard)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1xonH.CommonNavMenuButton), {
                ...props,
                onClick: (event)=>{
                    const { onClick: onClick } = props;
                    onClick?.(event);
                    sendCreateBoardOnBoardMenuItemAnalyticsEvent({
                        starred: project.isFavourite ?? false,
                        recent: !project.isFavourite,
                        projectId: project.projectId,
                        projectType: project.projectType
                    });
                },
                icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
                        ...iconProps,
                        size: "small"
                    }),
                label: formatMessage((0, $jzmXi.default).createBoard),
                ref: setRef
            }));
        }
    })), projectActionMenu);
};

});
parcelRegister("5jRC6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a16e1f422bc99009$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c34639a0df2f061c18a7a40ece1e540c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a16e1f422bc99009$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "ProjectActions",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        },
        {
            "kind": "RequiredField",
            "field": {
                "alias": "projectKey",
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "projectKey"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectId"
            },
            "action": "THROW",
            "path": "projectId"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "projectStyle"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectType"
            },
            "action": "THROW",
            "path": "projectType"
        },
        {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "large"
                }
            ]
        },
        {
            "alias": "editPermission",
            "args": [
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "EDIT_PROJECT_CONFIG"
                }
            ],
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canPerform"
                }
            ],
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        }
    ],
    "type": "JiraProject"
};
$a16e1f422bc99009$var$node.hash = "cdc45e3fd37dbc5832b2e4ea71201f60";
var $a16e1f422bc99009$export$2e2bcd8739ae039 = $a16e1f422bc99009$var$node;

});

parcelRegister("brwH6", function(module, exports) {

$parcel$export(module.exports, "BoardCreate", () => $07d90eee58b2fab1$export$c753ba73bc24874c);

var $5uXOq = parcelRequire("5uXOq");

var $6prxh = parcelRequire("6prxh");

var $1P6DN = parcelRequire("1P6DN");
const $07d90eee58b2fab1$export$c753ba73bc24874c = ({ projectId: projectId, projectAvatar: projectAvatar, renderTrigger: renderTrigger, triggerRef: triggerRef })=>{
    if (!projectId) {
        (0, $6prxh.fireBoardCreateErrorAnalytics)({
            error: new Error('Failed to load board create flyout menu: projectId undefined'),
            attributes: {
                projectId: projectId
            },
            id: 'loadFlyoutMenu'
        });
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1P6DN.BoardCreateFlyoutMenu), {
        renderTrigger: renderTrigger,
        projectId: projectId,
        projectAvatar: projectAvatar,
        triggerRef: triggerRef
    });
};

});
parcelRegister("6prxh", function(module, exports) {

$parcel$export(module.exports, "fireBoardCreateErrorAnalytics", () => $a085e033b99a140e$export$77dbc1f87d29b068);
$parcel$export(module.exports, "descriptionMapping", () => $a085e033b99a140e$export$56900bfb74887fe8);

var $jcw0u = parcelRequire("jcw0u");

var $h3KSk = parcelRequire("h3KSk");

var $6p4sE = parcelRequire("6p4sE");
const $a085e033b99a140e$export$77dbc1f87d29b068 = ({ attributes: attributes, id: id, error: error })=>{
    (0, $jcw0u.default)({
        error: error,
        attributes: attributes,
        meta: {
            id: `jiraSoftwareBoardCreate_${id}`,
            packageName: (0, $h3KSk.BOARD_CREATE_PACKAGE_NAME),
            teamName: (0, $h3KSk.TEAM_NAME)
        }
    });
};
const $a085e033b99a140e$export$56900bfb74887fe8 = {
    [(0, $h3KSk.BOARD_TYPES).KANBAN]: (0, $6p4sE.default).kanbanBoardCreationDescription,
    [(0, $h3KSk.BOARD_TYPES).SCRUM]: (0, $6p4sE.default).scrumBoardCreationDescription
};

});
parcelRegister("h3KSk", function(module, exports) {

$parcel$export(module.exports, "FLYOUT_MENU_CONTENT_ID", () => $f576620d788b19e6$export$ff67d81ebedcc801);
$parcel$export(module.exports, "BOARD_CREATE_PACKAGE_NAME", () => $f576620d788b19e6$export$3df8123340981894);
$parcel$export(module.exports, "TEAM_NAME", () => $f576620d788b19e6$export$d57b6b390e78d90f);
$parcel$export(module.exports, "BOARD_TYPES", () => $f576620d788b19e6$export$165dc6fdd115b0c1);
$parcel$export(module.exports, "BOARD_SOURCE_FIELDS", () => $f576620d788b19e6$export$318250ad9945de5c);
$parcel$export(module.exports, "BOARD_SOURCE_FIELDS_JQLTERM", () => $f576620d788b19e6$export$9f85086c10bd31f5);
$parcel$export(module.exports, "PICKER_SEARCH_DEBOUNCE_TIME", () => $f576620d788b19e6$export$f487cf015ececc3a);
$parcel$export(module.exports, "VALIDATION_ERROR_EMPTY", () => $f576620d788b19e6$export$7b060a5763a6e199);
$parcel$export(module.exports, "BOARD_NAME_LIMIT", () => $f576620d788b19e6$export$d760e95d248dc3a3);
const $f576620d788b19e6$export$edded98b84a6f50f = 'jsw-board-create';
const $f576620d788b19e6$export$ff67d81ebedcc801 = 'jsw-board-create-flyout-menu-content';
const $f576620d788b19e6$export$3df8123340981894 = 'jiraSoftwareBoardCreate';
const $f576620d788b19e6$export$d57b6b390e78d90f = 'a4t-pandora';
const $f576620d788b19e6$export$165dc6fdd115b0c1 = {
    KANBAN: 'KANBAN',
    SCRUM: 'SCRUM'
};
const $f576620d788b19e6$export$318250ad9945de5c = {
    TEAM: 'team',
    ISSUE_TYPES: 'issueTypes',
    LABELS: 'labels',
    SAVED_FILTER: 'savedFilter'
};
const $f576620d788b19e6$export$9f85086c10bd31f5 = {
    [$f576620d788b19e6$export$318250ad9945de5c.ISSUE_TYPES]: 'type',
    [$f576620d788b19e6$export$318250ad9945de5c.LABELS]: 'labels'
};
const $f576620d788b19e6$export$f487cf015ececc3a = 500;
const $f576620d788b19e6$export$7b060a5763a6e199 = 'VALIDATION_ERROR_EMPTY';
const $f576620d788b19e6$export$d760e95d248dc3a3 = 155;

});

parcelRegister("6p4sE", function(module, exports) {

$parcel$export(module.exports, "default", () => $30e80f50e57185ba$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $30e80f50e57185ba$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    boardCreationTitle: {
        "id": "software-board-create.common.board-creation-title",
        "defaultMessage": "Create a board"
    },
    scrumBoardCreationHeader: {
        "id": "software-board-create.common.scrum-board-creation-header",
        "defaultMessage": "Scrum"
    },
    scrumBoardCreationDescription: {
        "id": "software-board-create.common.scrum-board-creation-description",
        "defaultMessage": "Sprint towards your team objectives with a board, backlog, and reports."
    },
    kanbanBoardCreationHeader: {
        "id": "software-board-create.common.kanban-board-creation-header",
        "defaultMessage": "Kanban"
    },
    kanbanBoardCreationDescription: {
        "id": "software-board-create.common.kanban-board-creation-description",
        "defaultMessage": "Manage a continuous delivery of work with a kanban board and reports."
    },
    loadSavedFiltersErrorTitle: {
        "id": "software-board-create.common.load-saved-filters-error-title",
        "defaultMessage": "We can\u2019t load saved filters right now"
    },
    loadSavedFiltersErrorDescription: {
        "id": "software-board-create.common.load-saved-filters-error-description",
        "defaultMessage": "Refresh the page and try again."
    },
    requiredFieldsHeader: {
        "id": "software-board-create.common.required-fields-header",
        "defaultMessage": "Required fields are marked with an asterisk *"
    }
});

});


parcelRegister("1P6DN", function(module, exports) {

$parcel$export(module.exports, "BoardCreateFlyoutMenu", () => $585e525931061bc7$export$6a893f4168172b4e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $BLPHT = parcelRequire("BLPHT");

var $dZbEw = parcelRequire("dZbEw");

var $3nfCi = parcelRequire("3nfCi");
const $585e525931061bc7$export$a27652ddcad2c9dc = ({ triggerRef: triggerRef, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        ...props,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))),
        label: "create board",
        ref: triggerRef,
        testId: "software-board-create.ui.flyout-menu.trigger"
    });
};
const $585e525931061bc7$export$6a893f4168172b4e = ({ renderTrigger: Trigger = $585e525931061bc7$export$a27652ddcad2c9dc, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        trigger: Trigger,
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3nfCi.AsyncFlyoutMenuContent), props));

});
parcelRegister("3nfCi", function(module, exports) {

$parcel$export(module.exports, "AsyncFlyoutMenuContent", () => $ec0472afe4c77c87$export$3f0e1916911c9d6a);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $h3KSk = parcelRequire("h3KSk");

var $37QrD = parcelRequire("37QrD");

var $jFvRN = parcelRequire("jFvRN");
const $ec0472afe4c77c87$var$entryPointParams = {};
const $ec0472afe4c77c87$export$3f0e1916911c9d6a = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $37QrD.flyoutMenuContentEntryPoint), $ec0472afe4c77c87$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: (0, $h3KSk.FLYOUT_MENU_CONTENT_ID),
        packageName: (0, $h3KSk.BOARD_CREATE_PACKAGE_NAME),
        teamName: (0, $h3KSk.TEAM_NAME),
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jFvRN.FlyoutMenuContentFallback), null),
        errorFallback: "flag",
        runtimeProps: props
    });
};

});
parcelRegister("37QrD", function(module, exports) {

$parcel$export(module.exports, "flyoutMenuContentEntryPoint", () => $dfaa4ef5476ceb15$export$e6b36ab0519985d7);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $dfaa4ef5476ceb15$export$e6b36ab0519985d7 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("kWGoR"))), {
        moduleId: "53a3dd04",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("kWGoR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "FlyoutContentContainer", () => $1c9edbc1633491d5$export$b7a36d8992ebabdb);
$parcel$export(module.exports, "default", () => $1c9edbc1633491d5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $aRoVz = parcelRequire("aRoVz");

var $8EsNC = parcelRequire("8EsNC");

var $8mG85 = parcelRequire("8mG85");

var $c8oLN = parcelRequire("c8oLN");
var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $h3KSk = parcelRequire("h3KSk");

var $6p4sE = parcelRequire("6p4sE");

var $iCBgO = parcelRequire("iCBgO");
const $1c9edbc1633491d5$export$b7a36d8992ebabdb = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1c9edbc1633491d5$var$menuContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1c9edbc1633491d5$var$headerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1c9edbc1633491d5$var$headerStyles
    }, formatMessage((0, $6p4sE.default).boardCreationTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c8oLN.default), {
        block: "space.050"
    }, children));
};
const $1c9edbc1633491d5$var$BoardCreateFlyoutMenuContent = ({ props: { projectId: projectId, projectAvatar: projectAvatar, triggerRef: triggerRef } })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const dropdownItems = (0, $5uXOq.useMemo)(()=>{
        const items = [
            {
                boardType: (0, $h3KSk.BOARD_TYPES).SCRUM,
                title: formatMessage((0, $6p4sE.default).scrumBoardCreationHeader),
                description: formatMessage((0, $6p4sE.default).scrumBoardCreationDescription),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8mG85))), {
                    label: "",
                    color: "var(--ds-icon, #44546F)"
                })
            },
            {
                boardType: (0, $h3KSk.BOARD_TYPES).KANBAN,
                title: formatMessage((0, $6p4sE.default).kanbanBoardCreationHeader),
                description: formatMessage((0, $6p4sE.default).kanbanBoardCreationDescription),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8EsNC))), {
                    label: "",
                    color: "var(--ds-icon, #44546F)"
                })
            }
        ];
        return items.map(({ boardType: boardType, ...props }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iCBgO.DropdownItemContainer), {
                key: boardType,
                entryPointProps: {
                    boardType: boardType,
                    projectId: projectId,
                    projectAvatar: projectAvatar,
                    triggerRef: triggerRef
                },
                index: index,
                ...props
            }));
    }, [
        formatMessage,
        projectId,
        projectAvatar,
        triggerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1c9edbc1633491d5$export$b7a36d8992ebabdb, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, dropdownItems));
};
var $1c9edbc1633491d5$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($1c9edbc1633491d5$var$BoardCreateFlyoutMenuContent);
const $1c9edbc1633491d5$var$headerStyles = (0, $8CUq3.xcss)({
    font: 'font.heading.xxsmall',
    color: 'color.text.subtlest'
});
const $1c9edbc1633491d5$var$menuContainerStyles = (0, $8CUq3.xcss)({
    width: '273px',
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});
const $1c9edbc1633491d5$var$headerContainerStyles = (0, $8CUq3.xcss)({
    height: 'space.200',
    padding: 'space.200',
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});

});
parcelRegister("8mG85", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3028194b67909de4178ae7b995e8e7b7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $61710ed7f2aa84a3$var$_react = $61710ed7f2aa84a3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $61710ed7f2aa84a3$var$_baseNew = $61710ed7f2aa84a3$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $61710ed7f2aa84a3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sprint".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sprints in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $61710ed7f2aa84a3$var$SprintIcon = (props)=>/*#__PURE__*/ $61710ed7f2aa84a3$var$_react.default.createElement($61710ed7f2aa84a3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A4.75 4.75 0 0 0 8 11h5.44l-2.22-2.22 1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H0V11h3.938A6.25 6.25 0 1 1 14.25 6.25h-1.5A4.75 4.75 0 0 0 8 1.5" clip-rule="evenodd"/>`
    }, props));
$61710ed7f2aa84a3$var$SprintIcon.displayName = 'SprintIcon';
var $61710ed7f2aa84a3$var$_default = module.exports.default = $61710ed7f2aa84a3$var$SprintIcon;

});

parcelRegister("c8oLN", function(module, exports) {

$parcel$export(module.exports, "default", () => $e401c8401021557f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8CUq3 = parcelRequire("8CUq3");
function $e401c8401021557f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e401c8401021557f$var$baseStyles = {
    name: "1khn195",
    styles: "box-sizing:border-box"
};
const $e401c8401021557f$var$blockBleedMap = {
    'space.025': {
        name: "9w2fxh",
        styles: "margin-block:var(--ds-space-negative-025, -0.125rem)"
    },
    'space.050': {
        name: "1qhe0y6",
        styles: "margin-block:var(--ds-space-negative-050, -0.25rem)"
    },
    'space.100': {
        name: "s0o2nz",
        styles: "margin-block:var(--ds-space-negative-100, -0.5rem)"
    },
    'space.150': {
        name: "151e4o3",
        styles: "margin-block:var(--ds-space-negative-150, -0.75rem)"
    },
    'space.200': {
        name: "16sn062",
        styles: "margin-block:var(--ds-space-negative-200, -1rem)"
    }
};
const $e401c8401021557f$var$inlineBleedMap = {
    'space.025': {
        name: "16oxh68",
        styles: "margin-inline:var(--ds-space-negative-025, -0.125rem)"
    },
    'space.050': {
        name: "tdc6fz",
        styles: "margin-inline:var(--ds-space-negative-050, -0.25rem)"
    },
    'space.100': {
        name: "crujrn",
        styles: "margin-inline:var(--ds-space-negative-100, -0.5rem)"
    },
    'space.150': {
        name: "y28d58",
        styles: "margin-inline:var(--ds-space-negative-150, -0.75rem)"
    },
    'space.200': {
        name: "1vfkteg",
        styles: "margin-inline:var(--ds-space-negative-200, -1rem)"
    }
};
/**
 * __Bleed__
 *
 * `Bleed` is a primitive layout component that controls negative whitespace.
 *
 * - [Examples](https://atlassian.design/components/primitives/bleed/examples)
 * - [Code](https://atlassian.design/components/primitives/bleed/code)
 */ const $e401c8401021557f$var$Bleed = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ children: children, testId: testId, inline: inline, block: block, all: all, xcss: xcss })=>{
    const resolvedStyles = (0, $8CUq3.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $e401c8401021557f$var$baseStyles,
            (inline || all) && $e401c8401021557f$var$inlineBleedMap[inline || all],
            (block || all) && $e401c8401021557f$var$blockBleedMap[block || all],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }, children);
});
$e401c8401021557f$var$Bleed.displayName = 'Bleed';
var $e401c8401021557f$export$2e2bcd8739ae039 = $e401c8401021557f$var$Bleed;

});

parcelRegister("iCBgO", function(module, exports) {

$parcel$export(module.exports, "DropdownItemContainer", () => $8729a548ec5065a8$export$cfb1162696b4c012);

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $lXAdy = parcelRequire("lXAdy");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $h3KSk = parcelRequire("h3KSk");

var $gPHY5 = parcelRequire("gPHY5");

var $4MxwN = parcelRequire("4MxwN");

var $aDXGG = parcelRequire("aDXGG");
const $8729a548ec5065a8$export$cfb1162696b4c012 = ({ entryPointProps: entryPointProps, title: title, description: description, icon: icon, index: index })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const triggerRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (index === 0 && triggerRef.current) triggerRef.current.focus();
    }, [
        index
    ]);
    const handleOnDropdownItemClick = (0, $5uXOq.useCallback)(()=>{
        const boardTypePascalCase = entryPointProps.boardType === (0, $h3KSk.BOARD_TYPES).SCRUM ? 'Scrum' : 'Kanban';
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'dropdownItem',
            action: 'clicked'
        }), `create${boardTypePascalCase}Board`);
    }, [
        createAnalyticsEvent,
        entryPointProps.boardType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXAdy.ModalEntryPointDropdownItemTrigger), {
        "aria-label": formatMessage((0, $aDXGG.default).createBoardLabel, {
            boardType: entryPointProps.boardType.toLowerCase()
        }),
        forwardedRef: triggerRef,
        entryPoint: (0, $gPHY5.boardCreateModalEntryPoint),
        testId: "software-board-create.ui.flyout-menu.flyout-menu-content.dropdown-item-container.dropdown-item-trigger",
        interactionName: "open-create-board-modal",
        entryPointProps: entryPointProps,
        Fallback: (0, $4MxwN.BoardCreateModalFallback),
        onClick: handleOnDropdownItemClick,
        useInternalModal: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        alignInline: "center",
        xcss: $8729a548ec5065a8$var$itemIconBackgroundStyles
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "medium"
    }, description))));
};
const $8729a548ec5065a8$var$ICON_BACKGROUND_CONTAINER_SIZE = '32px';
const $8729a548ec5065a8$var$itemIconBackgroundStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.neutral',
    width: $8729a548ec5065a8$var$ICON_BACKGROUND_CONTAINER_SIZE,
    height: $8729a548ec5065a8$var$ICON_BACKGROUND_CONTAINER_SIZE,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "2px" and fallback "3px" do not match and can't be replaced automatically.
    borderRadius: "var(--ds-border-radius-050, 3px)",
    padding: 'space.050',
    flexShrink: 0
});

});
parcelRegister("lXAdy", function(module, exports) {

$parcel$export(module.exports, "ModalEntryPointDropdownItemTrigger", () => $d1639b87be26e4ed$export$82b29db923c97084);

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $2KAtx = parcelRequire("2KAtx");
const $d1639b87be26e4ed$export$82b29db923c97084 = ({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorAttributes: errorAttributes, Fallback: Fallback, interactionName: interactionName, modalTitle: modalTitle, modalProps: modalProps, useInternalModal: useInternalModal, forwardedRef: forwardedRef, ...dropdownProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        forwardedRef: forwardedRef,
        entryPoint: entryPoint,
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        errorAttributes: errorAttributes,
        Fallback: Fallback,
        interactionName: interactionName,
        title: modalTitle,
        modalProps: modalProps,
        useInternalModal: useInternalModal
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
            ref: ref,
            ...dropdownProps
        }, children));
};

});

parcelRegister("gPHY5", function(module, exports) {

$parcel$export(module.exports, "boardCreateModalEntryPoint", () => $7eac46aad6713698$export$ae34a65266b8e906);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $7eac46aad6713698$export$ae34a65266b8e906 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("4MxwN"))), {
        moduleId: "6c073853",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4MxwN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "BoardCreateModalFallback", () => $be001cef457a59e7$export$303db58b19f6b446);
$parcel$export(module.exports, "default", () => $be001cef457a59e7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $9fuVs = parcelRequire("9fuVs");

var $koVbs = parcelRequire("koVbs");

var $7NYq5 = parcelRequire("7NYq5");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $6p4sE = parcelRequire("6p4sE");

var $6prxh = parcelRequire("6prxh");

var $2NRUh = parcelRequire("2NRUh");

var $keWq7 = parcelRequire("keWq7");

var $4K4Ab = parcelRequire("4K4Ab");
const $be001cef457a59e7$var$MODAL_WIDTH = 1000;
const $be001cef457a59e7$var$MODAL_HEIGHT = 551;
const $be001cef457a59e7$export$303db58b19f6b446 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        height: $be001cef457a59e7$var$MODAL_HEIGHT,
        width: $be001cef457a59e7$var$MODAL_WIDTH,
        label: formatMessage((0, $4K4Ab.default).loadingLabel),
        messageId: "software-board-create.ui.modal.modal.board-create-modal-fallback",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $keWq7.BoardCreateFormFallback), null));
};
const $be001cef457a59e7$var$BoardCreateModal = ({ boardType: boardType, projectId: projectId, onClose: onClose, triggerRef: triggerRef })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleOnClose = (_mouseEvent, _analyticEvent, didSubmit)=>{
        const event = createAnalyticsEvent({
            action: 'closed',
            actionSubject: 'modalDialog'
        });
        (0, $8zOmE.fireUIAnalytics)(event, 'createNewBoardModal', {
            didSubmit: !!didSubmit,
            boardType: boardType.toLowerCase()
        });
        onClose?.();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        testId: "software-board-create.ui.modal",
        onClose: handleOnClose,
        width: $be001cef457a59e7$var$MODAL_WIDTH,
        height: $be001cef457a59e7$var$MODAL_HEIGHT,
        messageId: "software-board-create.ui.modal.modal.board-create-modal",
        messageType: "transactional",
        label: `${formatMessage((0, $6p4sE.default).boardCreationTitle)}. ${formatMessage((0, $6prxh.descriptionMapping)[boardType])}`,
        shouldReturnFocus: triggerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $keWq7.BoardCreateForm), {
        projectId: projectId,
        boardType: boardType,
        onClose: handleOnClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            boardType: boardType.toLowerCase()
        }
    }));
};
const $be001cef457a59e7$var$BoardCreateModalWithContext = ({ props: { projectAvatar: projectAvatar, ...restProps } })=>{
    const value = (0, $5uXOq.useMemo)(()=>({
            projectId: restProps.projectId,
            projectAvatar: projectAvatar
        }), [
        restProps.projectId,
        projectAvatar
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2NRUh.BoardCreateContext).Provider, {
        value: value
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "createNewBoard",
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($be001cef457a59e7$var$BoardCreateModal, restProps))));
};
var $be001cef457a59e7$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($be001cef457a59e7$var$BoardCreateModalWithContext);

});
parcelRegister("2NRUh", function(module, exports) {

$parcel$export(module.exports, "BoardCreateContext", () => $267ce53d896f9c4d$export$5169319147995508);
$parcel$export(module.exports, "useBoardCreateContext", () => $267ce53d896f9c4d$export$768ffccd7d71d6d9);

var $5uXOq = parcelRequire("5uXOq");
const $267ce53d896f9c4d$var$initialContext = {
    projectId: undefined,
    projectAvatar: undefined
};
const $267ce53d896f9c4d$export$5169319147995508 = /*#__PURE__*/ (0, $5uXOq.createContext)($267ce53d896f9c4d$var$initialContext);
const $267ce53d896f9c4d$export$768ffccd7d71d6d9 = ()=>(0, $5uXOq.useContext)($267ce53d896f9c4d$export$5169319147995508);

});

parcelRegister("keWq7", function(module, exports) {

$parcel$export(module.exports, "BoardCreateFormFallback", () => $c2504b6b008fc3bd$export$efb232229a99ba7b);
$parcel$export(module.exports, "BoardCreateForm", () => $c2504b6b008fc3bd$export$bc90d453a0e513ff);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $efXp3 = parcelRequire("efXp3");
var $8jRgk = parcelRequire("8jRgk");
var $3lQ26 = parcelRequire("3lQ26");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $1DVhQ = parcelRequire("1DVhQ");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $BUgEw = parcelRequire("BUgEw");

var $hBw29 = parcelRequire("hBw29");

var $cPVty = parcelRequire("cPVty");

var $aDJ8l = parcelRequire("aDJ8l");

var $2ze4l = parcelRequire("2ze4l");

var $7GuB2 = parcelRequire("7GuB2");

var $g5ZcC = parcelRequire("g5ZcC");

var $iizLc = parcelRequire("iizLc");
const $c2504b6b008fc3bd$export$efb232229a99ba7b = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $c2504b6b008fc3bd$var$formContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.1000",
        xcss: $c2504b6b008fc3bd$var$formContentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        xcss: $c2504b6b008fc3bd$var$columnStyles,
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        width: "150px",
        height: "20px",
        borderRadius: "3px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        width: "100%",
        height: "12px",
        borderRadius: "3px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        width: "20%",
        height: "12px",
        borderRadius: "3px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        width: "100px",
        height: "12px",
        borderRadius: "3px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        width: "100%",
        height: "30px",
        borderRadius: "3px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        width: "200px",
        height: "12px",
        borderRadius: "3px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        width: "100%",
        height: "30px",
        borderRadius: "3px"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        justifyContent: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        width: "70px",
        height: "32px",
        borderRadius: "3px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        width: "70px",
        height: "32px",
        borderRadius: "3px"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        xcss: $c2504b6b008fc3bd$var$columnStyles,
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        width: "150px",
        height: "20px",
        borderRadius: "3px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        width: "412px",
        height: "307px",
        borderRadius: "16px"
    }))));
};
const $c2504b6b008fc3bd$export$bc90d453a0e513ff = ({ boardType: boardType, projectId: projectId, onClose: onClose })=>{
    const { submit: submit } = (0, $BUgEw.useBoardCreateController)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleOnSubmit = (0, $5uXOq.useCallback)(async (data)=>{
        const errors = (0, $iizLc.validateFormData)(data);
        const hasValidationErrors = errors.boardName || errors.sourceType || errors.sourceValue;
        let sourceValueLength = 0;
        if (data.sourceValue != null) sourceValueLength = Array.isArray(data.sourceValue) ? data.sourceValue.length : 1;
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $8zOmE.fireUIAnalytics)(event, 'createNewBoard', {
            sourceType: data.sourceType,
            sourceValueLength: sourceValueLength,
            errors: hasValidationErrors && errors
        });
        if (hasValidationErrors) return errors;
        await submit({
            boardType: boardType,
            formValues: data,
            locationProjectId: projectId ?? '',
            onSuccess: ()=>onClose(undefined, undefined, true)
        });
    }, [
        createAnalyticsEvent,
        submit,
        boardType,
        projectId,
        onClose
    ]);
    const resetSourceValue = (0, $5uXOq.useCallback)((setFieldValue)=>()=>setFieldValue((0, $g5ZcC.SOURCE_VALUE_FIELD_NAME), undefined), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $c2504b6b008fc3bd$var$formContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $efXp3.default), {
        onSubmit: handleOnSubmit
    }, ({ formProps: formProps, submitting: submitting, setFieldValue: setFieldValue })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", {
            ...formProps,
            noValidate: true,
            className: (0, $bwpsq.default)([
                "_18m91wug _1bsb1osq"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            gap: "space.1000",
            xcss: $c2504b6b008fc3bd$var$formContentStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            xcss: $c2504b6b008fc3bd$var$columnStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBw29.ModalHeader), {
            type: boardType
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $c2504b6b008fc3bd$var$formFieldsContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3lQ26.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ze4l.BoardNameField), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3lQ26.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7GuB2.SourceTypePicker), {
            resetSourceValue: resetSourceValue(setFieldValue)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g5ZcC.SourceValuePicker), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $c2504b6b008fc3bd$var$buttonGroupContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8jRgk.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aDJ8l.FormActions), {
            submitting: submitting,
            onClose: onClose
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            xcss: $c2504b6b008fc3bd$var$columnStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cPVty.ModalIllustration), null))))));
};
const $c2504b6b008fc3bd$var$formStyles = null;
const $c2504b6b008fc3bd$var$formContentStyles = (0, $8CUq3.xcss)({
    height: '100%',
    width: '100%'
});
const $c2504b6b008fc3bd$var$columnStyles = (0, $8CUq3.xcss)({
    width: 'calc(50% - 40px)',
    // space.1000 is 80px, thus 40px is the space on each side
    flex: 'none',
    paddingTop: 'space.200'
});
const $c2504b6b008fc3bd$var$formFieldsContainerStyles = (0, $8CUq3.xcss)({
    flexGrow: 1
});
const $c2504b6b008fc3bd$var$buttonGroupContainerStyles = (0, $8CUq3.xcss)({
    alignSelf: 'end',
    justifySelf: 'end'
});
const $c2504b6b008fc3bd$var$formContainerStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.600',
    paddingLeft: 'space.600',
    paddingRight: 'space.600',
    paddingBottom: 'space.500',
    height: '100%'
});

});
parcelRegister("efXp3", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $987e2ff089e89967$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $987e2ff089e89967$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $987e2ff089e89967$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lqWDn = parcelRequire("lqWDn");

var $8tHJX = parcelRequire("8tHJX");

var $gZL7V = parcelRequire("gZL7V");
const $987e2ff089e89967$export$c24727297075ec6a = /*#__PURE__*/ (0, $5uXOq.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $987e2ff089e89967$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
function $987e2ff089e89967$export$2e2bcd8739ae039(props) {
    const formRef = (0, $5uXOq.useRef)(null);
    const onSubmitRef = (0, $5uXOq.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    const [form] = (0, $5uXOq.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $lqWDn.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(values, name, value);
                    }
                }
            }
        });
        (0, $8tHJX.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $5uXOq.useState)({
        dirty: false,
        submitting: false
    });
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $5uXOq.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
	 * This method is needed in FormContext to use it on the field level
	 * to check the current value of the field in case of the component re-mounting.
	 */ const getCurrentValue = (0, $5uXOq.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $5uXOq.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    const childrenContent = (()=>{
        if (typeof children === 'function') {
            const result = children.length > 0 ? children({
                formProps: {
                    onSubmit: handleSubmit,
                    ref: formRef,
                    onKeyDown: handleKeyDown
                },
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: ()=>form.getState(),
                getValues: ()=>form.getState().values,
                setFieldValue: form.change
            }) : children();
            return result === undefined ? null : result;
        }
        return children;
    })();
    return /*#__PURE__*/ (0, $2OMIu.jsx)($987e2ff089e89967$export$c24727297075ec6a.Provider, {
        value: FormContextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($987e2ff089e89967$export$c17cf6b332a82dbc.Provider, {
            value: isDisabled,
            children: childrenContent
        })
    });
}

});
parcelRegister("lqWDn", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $f9a9822f8af64e2a$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $f9a9822f8af64e2a$export$97cd7fc25dd32915);
$parcel$export(module.exports, "ARRAY_ERROR", () => $f9a9822f8af64e2a$export$735bebc8ffabf28a);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $f9a9822f8af64e2a$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $f9a9822f8af64e2a$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $f9a9822f8af64e2a$export$f681a8129d2e9d28);

var $bS32t = parcelRequire("bS32t");

var $ddEsc = parcelRequire("ddEsc");
//      
var $f9a9822f8af64e2a$var$charCodeOfDot = ".".charCodeAt(0);
var $f9a9822f8af64e2a$var$reEscapeChar = /\\(\\)?/g;
var $f9a9822f8af64e2a$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f9a9822f8af64e2a$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $f9a9822f8af64e2a$var$charCodeOfDot) result.push("");
    string.replace($f9a9822f8af64e2a$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($f9a9822f8af64e2a$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $f9a9822f8af64e2a$var$keysCache = {};
var $f9a9822f8af64e2a$var$keysRegex = /[.[\]]+/;
var $f9a9822f8af64e2a$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($f9a9822f8af64e2a$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $f9a9822f8af64e2a$var$keysCache[key] = key.split($f9a9822f8af64e2a$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $f9a9822f8af64e2a$var$keysCache[key] = $f9a9822f8af64e2a$var$stringToPath(key);
    }
    return $f9a9822f8af64e2a$var$keysCache[key];
};
//      
var $f9a9822f8af64e2a$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $f9a9822f8af64e2a$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $f9a9822f8af64e2a$var$_toPropertyKey(arg) {
    var key = $f9a9822f8af64e2a$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $f9a9822f8af64e2a$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $f9a9822f8af64e2a$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $ddEsc.default)(current, [
                key
            ].map($f9a9822f8af64e2a$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $bS32t.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $f9a9822f8af64e2a$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $f9a9822f8af64e2a$var$setInRecursor(state, 0, $f9a9822f8af64e2a$var$toPath(key), value1, destroyArrays);
};
var $f9a9822f8af64e2a$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $f9a9822f8af64e2a$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $f9a9822f8af64e2a$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(values, name);
    var error = $f9a9822f8af64e2a$export$c52e5867d5879e24(errors, name);
    if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) error = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
    var submitError = submitErrors && $f9a9822f8af64e2a$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $f9a9822f8af64e2a$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $f9a9822f8af64e2a$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $f9a9822f8af64e2a$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $f9a9822f8af64e2a$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f9a9822f8af64e2a$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $f9a9822f8af64e2a$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $f9a9822f8af64e2a$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$41e855cb628c1b55, $f9a9822f8af64e2a$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $f9a9822f8af64e2a$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $f9a9822f8af64e2a$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3, $f9a9822f8af64e2a$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $f9a9822f8af64e2a$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$f9a9822f8af64e2a$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $f9a9822f8af64e2a$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $f9a9822f8af64e2a$export$83d89fbfd8236492 = "4.20.10";
var $f9a9822f8af64e2a$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $f9a9822f8af64e2a$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $f9a9822f8af64e2a$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $f9a9822f8af64e2a$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $f9a9822f8af64e2a$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $f9a9822f8af64e2a$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $f9a9822f8af64e2a$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $f9a9822f8af64e2a$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $bS32t.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $bS32t.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $bS32t.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $bS32t.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $bS32t.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $f9a9822f8af64e2a$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $f9a9822f8af64e2a$export$e6bdf135a54e021b,
                    shallowEqual: $f9a9822f8af64e2a$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $bS32t.default)({}, state.formState.values)); // clone to avoid writing
            if ($f9a9822f8af64e2a$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f9a9822f8af64e2a$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $f9a9822f8af64e2a$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $bS32t.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $f9a9822f8af64e2a$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) {
                    var existing = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$f9a9822f8af64e2a$export$735bebc8ffabf28a] = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
                    merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$f9a9822f8af64e2a$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $f9a9822f8af64e2a$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $f9a9822f8af64e2a$var$notify(fieldSubscriber, fieldState, lastFieldState, $f9a9822f8af64e2a$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $f9a9822f8af64e2a$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$f9a9822f8af64e2a$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f9a9822f8af64e2a$var$hasAnyError(formState.submitErrors));
        var nextFormState = $f9a9822f8af64e2a$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $f9a9822f8af64e2a$var$notify(state.subscribers, nextFormState, lastFormState, $f9a9822f8af64e2a$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $bS32t.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $bS32t.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $f9a9822f8af64e2a$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $f9a9822f8af64e2a$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $f9a9822f8af64e2a$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $f9a9822f8af64e2a$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $f9a9822f8af64e2a$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $f9a9822f8af64e2a$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f9a9822f8af64e2a$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("8tHJX", function(module, exports) {

$parcel$export(module.exports, "default", () => $62c2f612c5adb35a$export$2e2bcd8739ae039);

var $lqWDn = parcelRequire("lqWDn");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $62c2f612c5adb35a$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $62c2f612c5adb35a$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $62c2f612c5adb35a$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $lqWDn.getIn)(errors, input.name);
    });
};
//      
var $62c2f612c5adb35a$var$noop = function noop() {};
var $62c2f612c5adb35a$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $62c2f612c5adb35a$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $62c2f612c5adb35a$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $62c2f612c5adb35a$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $62c2f612c5adb35a$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$62c2f612c5adb35a$export$2e2bcd8739ae039 = $62c2f612c5adb35a$var$createDecorator;

});

parcelRegister("gZL7V", function(module, exports) {

var $ajB7H = parcelRequire("ajB7H");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $c5f6e64373be0bfc$var$set(object, path, value) {
    return object == null ? object : $ajB7H(object, path, value);
}
module.exports = $c5f6e64373be0bfc$var$set;

});


parcelRegister("8jRgk", function(module, exports) {

$parcel$export(module.exports, "default", () => $09f31c1f2cf95b88$export$2e2bcd8739ae039);
/* form-footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $09f31c1f2cf95b88$var$formFooterWrapperStyles = null;
const $09f31c1f2cf95b88$var$justifyContentStyles = null;
function $09f31c1f2cf95b88$export$2e2bcd8739ae039({ align: align = 'end', children: children }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("footer", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bahesu3 _1pfh1ejb",
            align === 'start' && "_1bah1y6m"
        ]),
        children: children
    });
}

});

parcelRegister("3lQ26", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e71eeb72c100e3$export$2e2bcd8739ae039);
/* form-section.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l1N8i = parcelRequire("l1N8i");
const $b3e71eeb72c100e3$var$formSectionDescriptionStyles = null;
const $b3e71eeb72c100e3$var$formSectionWrapperStyles = null;
const $b3e71eeb72c100e3$var$FormSectionWrapper = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/design-system/use-primitives
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1pfh1ejb"
        ]),
        children: children
    });
};
const $b3e71eeb72c100e3$var$FormSectionDescription = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/design-system/use-primitives
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1pfhu2gc"
        ]),
        children: children
    });
};
/**
 * __Form section__.
 *
 * A form section is used to define a section of a form layout. This contains a section title, content
 * and a description of the section.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout).
 */ const $b3e71eeb72c100e3$var$FormSection = ({ children: children, description: description, title: title })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)($b3e71eeb72c100e3$var$FormSectionWrapper, {
        children: [
            title && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                size: "medium",
                children: title
            }),
            description && /*#__PURE__*/ (0, $2OMIu.jsx)($b3e71eeb72c100e3$var$FormSectionDescription, {
                children: description
            }),
            children
        ]
    });
};
var $b3e71eeb72c100e3$export$2e2bcd8739ae039 = $b3e71eeb72c100e3$var$FormSection;

});

parcelRegister("BUgEw", function(module, exports) {

$parcel$export(module.exports, "useBoardCreateController", () => $6954e7e33c19033d$export$b1247ee6c4be437f);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $kV9ss = parcelRequire("kV9ss");

var $koVbs = parcelRequire("koVbs");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $93jKl = parcelRequire("93jKl");

var $4DrQd = parcelRequire("4DrQd");

var $7Cqm7 = parcelRequire("7Cqm7");

var $koeKL = parcelRequire("koeKL");

var $lVJAU = parcelRequire("lVJAU");

var $iJZ8l = parcelRequire("iJZ8l");

var $eCBf9 = parcelRequire("eCBf9");

var $6prxh = parcelRequire("6prxh");

var $h3KSk = parcelRequire("h3KSk");

var $6fAG8 = parcelRequire("6fAG8");

var $96pTU = parcelRequire("96pTU");

var $16xB9 = parcelRequire("16xB9");

var $3i0DH = parcelRequire("3i0DH");
const $6954e7e33c19033d$var$EXPERIENCE = 'createBoard';
const $6954e7e33c19033d$export$43cdff4ae424f89f = ()=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const cloudId = (0, $koeKL.useCloudId)();
    return (0, $5uXOq.useCallback)(({ id: id, projectId: projectId })=>{
        (0, $8Uumt.commitLocalUpdate)(environment, (store)=>{
            try {
                if (!id) throw new Error('Failed to add board to project, missing id');
                if (!projectId) throw new Error('Failed to add board to project, missing projectId');
                const projectRelayDataId = (0, $iJZ8l.default)({
                    id: (0, $kV9ss.JiraProjectAri).create({
                        siteId: cloudId,
                        projectId: String(projectId)
                    })
                }, 'JiraProject');
                if (!projectRelayDataId) throw new Error(`Failed to create project relay data id, projectId: ${projectId}`);
                const project = store.get(projectRelayDataId);
                if (!project) throw new Error(`Failed to find the project, projectId: ${projectId}`);
                const projectBoardsConnection = project.getLinkedRecord('boards', {
                    first: (0, $4DrQd.NO_OF_BOARDS_TO_SHOW)
                });
                if (!projectBoardsConnection) throw new Error('Failed to find the project-boards connection');
                const newNode = store.get(id);
                if (!newNode) throw new Error(`Failed to find the new board, id: ${id}`);
                const newEdge = (0, $8Uumt.ConnectionHandler).createEdge(store, projectBoardsConnection, newNode, 'JiraBoardEdge');
                (0, $8Uumt.ConnectionHandler).insertEdgeBefore(projectBoardsConnection, newEdge);
            } catch (error) {
                (0, $6prxh.fireBoardCreateErrorAnalytics)({
                    id: 'addBoardToProject',
                    error: error instanceof Error ? error : new Error(`Failed to add board to project: ${error}`)
                });
            }
        });
    }, [
        environment,
        cloudId
    ]);
};
const $6954e7e33c19033d$export$b1247ee6c4be437f = ()=>{
    const { handleMutation: handleMutation } = (0, $6fAG8.useBoardCreateMutation)();
    const { showSuccessFlag: showSuccessFlag, showErrorFlag: showErrorFlag } = (0, $96pTU.useBoardCreateFlag)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const addBoardToProject = $6954e7e33c19033d$export$43cdff4ae424f89f();
    const isBacklogRoute = (0, $7Cqm7.useIsBacklogRoute)();
    const onExperienceStart = (0, $kaHBi.useExperienceStart)({
        experience: $6954e7e33c19033d$var$EXPERIENCE,
        analyticsSource: (0, $h3KSk.BOARD_CREATE_PACKAGE_NAME)
    });
    const onExperienceSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: $6954e7e33c19033d$var$EXPERIENCE
    });
    const onExperienceFail = (0, $93jKl.useExperienceFail)({
        experience: $6954e7e33c19033d$var$EXPERIENCE
    });
    const submit = (0, $5uXOq.useCallback)(async ({ boardType: boardType, locationProjectId: locationProjectId, formValues: formValues, onSuccess: onSuccess, onError: onError })=>{
        const input = (0, $3i0DH.transformInput)({
            boardType: boardType,
            locationProjectId: locationProjectId,
            formValues: formValues
        });
        try {
            onExperienceStart();
            const result = await handleMutation(input);
            if (!result?.jira?.createBoard?.success) throw result?.jira?.createBoard?.errors?.length ? new (0, $eCBf9.MutationError)(result?.jira?.createBoard?.errors?.[0]) : new Error('Failed to create board');
            onSuccess?.(result);
            showSuccessFlag({
                title: formatMessage((0, $16xB9.default).successTitle)
            });
            addBoardToProject({
                projectId: locationProjectId,
                id: result.jira?.createBoard?.board?.__id
            });
            onExperienceSuccess();
            const resultBoardId = result?.jira?.createBoard?.board?.boardId;
            const resultBoardType = result?.jira?.createBoard?.board?.boardType;
            const boardUrl = (0, $3i0DH.buildBoardUrl)(result?.jira?.createBoard?.board?.boardUrl, resultBoardType);
            if (!boardUrl) (0, $6prxh.fireBoardCreateErrorAnalytics)({
                error: new Error('Failed to generate board URL after board creation'),
                attributes: {
                    boardId: resultBoardId,
                    boardType: resultBoardType
                },
                id: 'generateUrl'
            });
            else resultBoardType === 'SCRUM' && isBacklogRoute ? (0, $3i0DH.redirectToBacklog)(boardUrl) : push(boardUrl);
        } catch (error) {
            let errMsg;
            if (error instanceof (0, $eCBf9.MutationError) && error.message) errMsg = error.message;
            onError?.(errMsg || error);
            showErrorFlag({
                title: formatMessage((0, $16xB9.default).errorTitle),
                description: errMsg || formatMessage((0, $16xB9.default).errorDescription)
            });
            (0, $6prxh.fireBoardCreateErrorAnalytics)({
                error: new Error(`Failed to create board: ${errMsg || error}`),
                id: 'createBoard'
            });
            onExperienceFail((0, $h3KSk.BOARD_CREATE_PACKAGE_NAME), // eslint-disable-next-line no-nested-ternary
            errMsg ? new Error(errMsg) : error instanceof Error ? error : new Error(String(error)));
        }
    }, [
        onExperienceStart,
        handleMutation,
        showSuccessFlag,
        formatMessage,
        addBoardToProject,
        onExperienceSuccess,
        isBacklogRoute,
        push,
        showErrorFlag,
        onExperienceFail
    ]);
    return {
        submit: submit
    };
};

});
parcelRegister("7Cqm7", function(module, exports) {

$parcel$export(module.exports, "useIsBacklogRoute", () => $6df6a0c87d7ecf35$export$1894da4846b402db);

var $5uXOq = parcelRequire("5uXOq");

var $6jY6G = parcelRequire("6jY6G");
const $6df6a0c87d7ecf35$export$1894da4846b402db = ()=>{
    const { name: name } = (0, $6jY6G.useCurrentRoute)();
    return (0, $5uXOq.useMemo)(()=>name === 'rapidboard-backlog' || name === 'rapidboard-user-backlog' || name === 'rapidboard-backlog-embed', [
        name
    ]);
};

});

parcelRegister("eCBf9", function(module, exports) {

$parcel$export(module.exports, "MutationError", () => $5fe48c9a5d56428c$export$10c788363424e94e);
class $5fe48c9a5d56428c$export$10c788363424e94e extends Error {
    constructor(payload){
        super(payload.message ?? undefined);
        this.message = payload.message ?? '';
        this.extensions = payload.extensions;
        this.statusCode = payload.extensions?.statusCode ?? null;
        this.errorType = payload.extensions?.errorType ?? null;
    }
}

});

parcelRegister("6fAG8", function(module, exports) {

$parcel$export(module.exports, "useBoardCreateMutation", () => $1f641104976de7c6$export$99c7414664697f66);

var $h3EhD = parcelRequire("h3EhD");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $koeKL = parcelRequire("koeKL");
const $1f641104976de7c6$export$99c7414664697f66 = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const [commit] = (0, $8Uumt.useMutation)((0, $h3EhD.default));
    const handleMutation = (0, $5uXOq.useCallback)(async (input)=>new Promise((resolve, reject)=>{
            commit({
                variables: {
                    cloudId: cloudId,
                    input: input
                },
                onCompleted: (result)=>{
                    resolve(result);
                },
                onError: (error)=>{
                    reject(error);
                }
            });
        }), [
        cloudId,
        commit
    ]);
    return {
        handleMutation: handleMutation
    };
};

});
parcelRegister("h3EhD", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d774c68c24dc8f2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<96b4cce51ba6e0ff7c8004e93170ae98>>
 * @relayHash f07c5fbb5fc9fda47c89b1ea4e0b6538
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 39733200dfeb8f5ca8e119e986adf5ee373acba404794290d4a84a17b45673c2
const $9d774c68c24dc8f2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "concreteType": "JiraBoard",
        "kind": "LinkedField",
        "name": "board",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "boardId"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            },
            v2 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "boardType"
            },
            {
                "kind": "ScalarField",
                "name": "boardUrl"
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__id"
                    }
                ]
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "success"
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v7 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useBoardCreateMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCreateBoardPayload",
                            "kind": "LinkedField",
                            "name": "createBoard",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useBoardCreateMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCreateBoardPayload",
                            "kind": "LinkedField",
                            "name": "createBoard",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v2 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "39733200dfeb8f5ca8e119e986adf5ee373acba404794290d4a84a17b45673c2",
            "metadata": {},
            "name": "useBoardCreateMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$9d774c68c24dc8f2$var$node.hash = "6559f8aeeafe0e444aad2224af38c3cb";
var $9d774c68c24dc8f2$export$2e2bcd8739ae039 = $9d774c68c24dc8f2$var$node;

});


parcelRegister("96pTU", function(module, exports) {

$parcel$export(module.exports, "useBoardCreateFlag", () => $0104309d6559195a$export$b93e10fcc9489915);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");
const $0104309d6559195a$export$b93e10fcc9489915 = ()=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const showSuccessFlag = (0, $5uXOq.useCallback)(({ title: title, description: description })=>{
        showFlag({
            type: 'success',
            title: title,
            description: description,
            isAutoDismiss: true,
            messageId: 'software-board-create.controllers.use-board-create-flag.show-flag.success',
            messageType: 'transactional'
        });
    }, [
        showFlag
    ]);
    const showErrorFlag = (0, $5uXOq.useCallback)(({ title: title, description: description })=>{
        showFlag({
            type: 'error',
            title: title,
            description: description,
            isAutoDismiss: true,
            messageId: 'software-board-create.controllers.use-board-create-flag.show-flag.error',
            messageType: 'transactional'
        });
    }, [
        showFlag
    ]);
    return {
        showSuccessFlag: showSuccessFlag,
        showErrorFlag: showErrorFlag
    };
};

});

parcelRegister("16xB9", function(module, exports) {

$parcel$export(module.exports, "default", () => $01c40c2337fb8cba$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $01c40c2337fb8cba$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    successTitle: {
        "id": "software-board-create.controllers.use-board-create-controller.success-title",
        "defaultMessage": "Board successfully created"
    },
    errorTitle: {
        "id": "software-board-create.controllers.use-board-create-controller.error-title",
        "defaultMessage": "We couldn\u2019t create the board"
    },
    errorDescription: {
        "id": "software-board-create.controllers.use-board-create-controller.error-description",
        "defaultMessage": "Refresh the page and try again."
    }
});

});

parcelRegister("3i0DH", function(module, exports) {

$parcel$export(module.exports, "transformInput", () => $e5dcc01ab0bf80c8$export$28b8f0b21b2796a2);
$parcel$export(module.exports, "buildBoardUrl", () => $e5dcc01ab0bf80c8$export$d807737c3f4eaba6);
$parcel$export(module.exports, "redirectToBacklog", () => $e5dcc01ab0bf80c8$export$594b405ab77720dc);

var $h3KSk = parcelRequire("h3KSk");
const $e5dcc01ab0bf80c8$var$formatFieldInput = (input)=>{
    if (!input.sourceType || input.sourceType === (0, $h3KSk.BOARD_SOURCE_FIELDS).SAVED_FILTER || !input.sourceValue) return null;
    const { sourceType: sourceType, sourceValue: sourceValue } = input;
    switch(sourceType){
        case (0, $h3KSk.BOARD_SOURCE_FIELDS).TEAM:
            return {
                teams: [
                    {
                        teamId: sourceValue.id
                    }
                ]
            };
        case (0, $h3KSk.BOARD_SOURCE_FIELDS).ISSUE_TYPES:
            return {
                issueTypes: sourceValue.map(({ value: value })=>({
                        issueTypeId: value
                    }))
            };
        case (0, $h3KSk.BOARD_SOURCE_FIELDS).LABELS:
            return {
                labels: sourceValue.map(({ value: value })=>({
                        name: value
                    }))
            };
        default:
            {
                const _exhaustiveCheck = sourceType;
                return null;
            }
    }
};
const $e5dcc01ab0bf80c8$var$getCreateBoardSource = (formValues, locationProjectId)=>{
    if (formValues?.sourceType === (0, $h3KSk.BOARD_SOURCE_FIELDS).SAVED_FILTER) return {
        savedFilterId: formValues.sourceValue?.value ? Number(formValues.sourceValue.value) : null
    };
    return {
        fieldInput: {
            projects: [
                {
                    projectId: locationProjectId
                }
            ],
            ...formValues.sourceType && formValues.sourceValue && $e5dcc01ab0bf80c8$var$formatFieldInput(formValues)
        }
    };
};
const $e5dcc01ab0bf80c8$export$28b8f0b21b2796a2 = ({ boardType: boardType, locationProjectId: locationProjectId, formValues: formValues })=>({
        createBoardSource: $e5dcc01ab0bf80c8$var$getCreateBoardSource(formValues, locationProjectId),
        location: {
            locationId: locationProjectId,
            locationType: 'PROJECT'
        },
        name: formValues.boardName,
        preset: boardType
    });
const $e5dcc01ab0bf80c8$export$d807737c3f4eaba6 = (boardUrl, boardType)=>{
    if (!boardUrl) return null;
    return `${boardUrl}${boardType === 'SCRUM' ? '/backlog' : ''}`;
};
const $e5dcc01ab0bf80c8$export$594b405ab77720dc = (backlogUrl)=>{
    // This is a temporary fix for the redirection issue and will be addressed in BLU-5254
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href = backlogUrl;
};

});


parcelRegister("hBw29", function(module, exports) {

$parcel$export(module.exports, "ModalHeader", () => $36f6cf40bfe43457$export$f50a68e3694789ee);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $414Wj = parcelRequire("414Wj");
var $dS3PR = parcelRequire("dS3PR");

var $koVbs = parcelRequire("koVbs");

var $6p4sE = parcelRequire("6p4sE");

var $6prxh = parcelRequire("6prxh");
const $36f6cf40bfe43457$export$f50a68e3694789ee = ({ type: type })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ $5uXOq.createElement((0, $414Wj.default), {
        space: "space.100"
    }, /*#__PURE__*/ $5uXOq.createElement("h4", {
        className: (0, $bwpsq.default)([
            "_11c8lodh _k48pmoej _syaz1fxt"
        ])
    }, formatMessage((0, $6p4sE.default).boardCreationTitle)), /*#__PURE__*/ $5uXOq.createElement((0, $dS3PR.default), {
        size: "medium",
        color: "color.text.accent.gray.bolder"
    }, (0, $6prxh.descriptionMapping)[type] && formatMessage((0, $6prxh.descriptionMapping)[type])), /*#__PURE__*/ $5uXOq.createElement((0, $dS3PR.default), {
        as: "em",
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $6p4sE.default).requiredFieldsHeader)));
};
const $36f6cf40bfe43457$var$modalHeaderStyles = null;

});

parcelRegister("cPVty", function(module, exports) {

$parcel$export(module.exports, "ModalIllustration", () => $9f435b77d548b26f$export$dc26d3e21d436b08);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $bUa6y = parcelRequire("bUa6y");

var $414Wj = parcelRequire("414Wj");

var $2YF0r = parcelRequire("2YF0r");

var $koVbs = parcelRequire("koVbs");

var $evWvw = parcelRequire("evWvw");
const $9f435b77d548b26f$export$dc26d3e21d436b08 = ()=>{
    const state = (0, $bUa6y.useFormState)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $414Wj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("h5", {
        className: (0, $bwpsq.default)([
            "_11c8nbxd _1reo15vq _18m915vq _k48p1pd9 _syaz1gjq _18u01axu _1bto1l2s _o5721q9c _p12fp3fh"
        ])
    }, state?.values.boardName?.trim() || formatMessage((0, $evWvw.default).illustrationPlaceHolderHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $414Wj.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2YF0r.default), {
        alt: formatMessage((0, $evWvw.default).illustrationAltText),
        height: "334px"
    })));
};
const $9f435b77d548b26f$var$modalIllustrationHeaderStyles = null;

});
parcelRegister("bUa6y", function(module, exports) {

$parcel$export(module.exports, "useFormState", () => $0ed03f14f588391e$export$606f11b2eb45ecc6);

var $5uXOq = parcelRequire("5uXOq");

var $efXp3 = parcelRequire("efXp3");
// Constantized to avoid a new object reference built every call
const $0ed03f14f588391e$var$defaultSubscriptionConfig = {
    values: true
};
/**
 * Build a simple hash for a given subscription object for use in a `useMemo` dependencies array.
 * This is because `{ values: true } !== { values: true }`, but `'values:true|' === 'values:true|'`
 *
 * @example { values: true, dirty: false } => 'values:true|dirty:false|'
 */ const $0ed03f14f588391e$var$getSubscriptionHash = (subscriptionConfig)=>{
    let hash = '';
    for(const key in subscriptionConfig)if (subscriptionConfig.hasOwnProperty(key)) hash += `${key}:${subscriptionConfig[key]}|`;
    return hash;
};
const $0ed03f14f588391e$export$606f11b2eb45ecc6 = (subscriptionConfig = $0ed03f14f588391e$var$defaultSubscriptionConfig)=>{
    const { subscribe: subscribe } = (0, $5uXOq.useContext)((0, $efXp3.FormContext));
    const [state, setState] = (0, $5uXOq.useState)();
    /**
	 * A hash for us to shallow compare the subscriptionConfig object to react to shallow changes, but avoid referential changes.
	 * We avoid computing the hash if the subscription config has referential equality altogether.
	 */ const subscriptionConfigHash = (0, $5uXOq.useMemo)(()=>$0ed03f14f588391e$var$getSubscriptionHash(subscriptionConfig), [
        subscriptionConfig
    ]);
    /**
	 * Return a memoized version of the subscription config to only react to shallow changes, not referential changes.
	 * Eg. calling `useFormState({ values: true })` twice will result in two different objects by reference, but not by shallow comparison.
	 * This will ensure we don't re-subscribe to the form state when the subscription config is the same.
	 */ const config = (0, $5uXOq.useMemo)(()=>subscriptionConfig, // eslint-disable-next-line react-hooks/exhaustive-deps -- intentionally controlled with a hash to have an explicit shallow comparison
    [
        subscriptionConfigHash
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = subscribe((formState)=>{
            setState(formState);
        }, config);
        return ()=>unsubscribe();
    }, [
        subscribe,
        config
    ]);
    return state;
};

});

parcelRegister("2YF0r", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bda248573ba546d$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $9Mp09 = parcelRequire("9Mp09");
const $1bda248573ba546d$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($9Mp09)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($9Mp09))
});
var $1bda248573ba546d$export$2e2bcd8739ae039 = $1bda248573ba546d$var$Illustration;
const $1bda248573ba546d$export$a179c88182cb9d56 = [
    0,
    0,
    448,
    334
];

});
parcelRegister("9Mp09", function(module, exports) {
module.exports = new URL("bug-and-task-cards-in-a-column.455dfa61.svg", import.meta.url).toString();

});


parcelRegister("evWvw", function(module, exports) {

$parcel$export(module.exports, "default", () => $a855b2f67ecf66fc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a855b2f67ecf66fc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    illustrationPlaceHolderHeader: {
        "id": "software-board-create.modal.illustration.illustration-place-holder-header",
        "defaultMessage": "New board"
    },
    illustrationAltText: {
        "id": "software-board-create.modal.illustration.illustration-alt-text",
        "defaultMessage": "Bug and task cards in a board column"
    }
});

});


parcelRegister("aDJ8l", function(module, exports) {

$parcel$export(module.exports, "FormActions", () => $015f57e976cf5b77$export$9494d5a5e5299081);

var $5uXOq = parcelRequire("5uXOq");

var $ldJSL = parcelRequire("ldJSL");

var $eCeGD = parcelRequire("eCeGD");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $iLQ6N = parcelRequire("iLQ6N");
const $015f57e976cf5b77$export$9494d5a5e5299081 = ({ onClose: onClose, submitting: submitting })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $015f57e976cf5b77$var$buttonGroupContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "subtle",
        isDisabled: submitting,
        onClick: onClose,
        testId: "software-board-create.ui.modal.form.actions.board-create-cancel-button"
    }, formatMessage((0, $iLQ6N.default).modalCancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "primary",
        type: "submit",
        isLoading: submitting,
        testId: "software-board-create.ui.modal.form.actions.board-create-confirm-button"
    }, formatMessage((0, $iLQ6N.default).modalConfirmButton))));
};
const $015f57e976cf5b77$var$buttonGroupContainerStyles = (0, $8CUq3.xcss)({
    paddingBottom: 'space.100'
});

});
parcelRegister("iLQ6N", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ebfc75c64d3ab56$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7ebfc75c64d3ab56$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    modalConfirmButton: {
        "id": "software-board-create.modal.form.actions.modal-confirm-button",
        "defaultMessage": "Create"
    },
    modalCancelButton: {
        "id": "software-board-create.modal.form.actions.modal-cancel-button",
        "defaultMessage": "Cancel"
    }
});

});


parcelRegister("2ze4l", function(module, exports) {

$parcel$export(module.exports, "BoardNameField", () => $a633258a18403e34$export$f710d048b5529d22);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $qfj8c = parcelRequire("qfj8c");
var $7O4UO = parcelRequire("7O4UO");
var $bUa6y = parcelRequire("bUa6y");

var $kY99m = parcelRequire("kY99m");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $h3KSk = parcelRequire("h3KSk");

var $4D12X = parcelRequire("4D12X");
const $a633258a18403e34$export$f710d048b5529d22 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const formState = (0, $bUa6y.useFormState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [value, setValue] = (0, $5uXOq.useState)('');
    const hasEdited = (0, $5uXOq.useRef)(false);
    const debouncedHandleOnChange = (0, $5uXOq.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(()=>{
        if (!hasEdited.current) {
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'changed',
                actionSubject: 'input'
            }), 'boardName');
            hasEdited.current = true;
        }
    }, 300)).current;
    const handleOnChange = (0, $5uXOq.useCallback)((event)=>{
        setValue(event.currentTarget.value);
        const newValue = event.currentTarget.value;
        setValue(newValue);
        debouncedHandleOnChange();
    }, [
        debouncedHandleOnChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        label: formatMessage((0, $4D12X.default).boardNameFieldLabel),
        name: "boardName",
        isRequired: true
    }, ({ fieldProps: { onChange: onChange, ...rest }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
            ...rest,
            placeholder: formatMessage((0, $4D12X.default).boardNameFieldPlaceholder),
            maxLength: (0, $h3KSk.BOARD_NAME_LIMIT),
            testId: "software-board-create.ui.modal.form.board-name.board-name-input",
            value: value,
            onChange: (event)=>{
                handleOnChange(event);
                onChange(event);
            }
        }), error === (0, $h3KSk.VALIDATION_ERROR_EMPTY) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), {
            testId: "software-board-create.ui.modal.form.board-name.board-name-error"
        }, formatMessage((0, $4D12X.default).boardNameEmptyError)), formState?.values.boardName && formState.values.boardName.length >= (0, $h3KSk.BOARD_NAME_LIMIT) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.HelperMessage), null, formatMessage((0, $4D12X.default).boardNameMaxChars, {
            maxLength: (0, $h3KSk.BOARD_NAME_LIMIT)
        }))));
};

});
parcelRegister("qfj8c", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", () => $b2d5b368fed948c9$export$8fbe3c7d0ed2c683);
$parcel$export(module.exports, "ErrorMessage", () => $b2d5b368fed948c9$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "ValidMessage", () => $b2d5b368fed948c9$export$5505afb209a532c8);
$parcel$export(module.exports, "MessageWrapper", () => $b2d5b368fed948c9$export$ec445f12f63100a5);
/* messages.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dD7Zc = parcelRequire("dD7Zc");

var $a9R4o = parcelRequire("a9R4o");

var $dRN65 = parcelRequire("dRN65");
const $b2d5b368fed948c9$var$messageStyles = null;
const $b2d5b368fed948c9$var$messageAppearanceStyles = {
    default: "_syaz1wmz",
    error: "_syaze6sf",
    valid: "_syazy73q"
};
const $b2d5b368fed948c9$var$iconWrapperStyles = {
    root: "_1e0c1txw _4t3i7vkz _4cvr1h6o"
};
const $b2d5b368fed948c9$var$IconWrapper = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            $b2d5b368fed948c9$var$iconWrapperStyles.root
        ]),
        children: children
    });
const $b2d5b368fed948c9$var$messageIcons = {
    error: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "error",
        size: "small"
    }),
    valid: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a9R4o))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "success",
        size: "small"
    })
};
const $b2d5b368fed948c9$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
    const icon = $b2d5b368fed948c9$var$messageIcons[appearance];
    const messageRef = (0, $5uXOq.useRef)(null);
    const [hasMessageWrapper, setHasMessageWrapper] = (0, $5uXOq.useState)(false);
    const { isWrapper: isWrapper } = (0, $5uXOq.useContext)($b2d5b368fed948c9$var$MessageWrapperContext);
    (0, $5uXOq.useEffect)(()=>{
        if (messageRef.current) setHasMessageWrapper(isWrapper);
    }, [
        isWrapper
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": testId,
        id: fieldId,
        ref: messageRef,
        // For backwards compatability, if there is a wrapper, aria-live is not needed
        "aria-live": !hasMessageWrapper ? 'polite' : undefined,
        className: (0, $bwpsq.default)([
            "_zulp12x7 _11c8dcr7 _1e0c1txw _1bah1q9y _1pfh1b66",
            $b2d5b368fed948c9$var$messageAppearanceStyles[appearance]
        ]),
        children: [
            icon && /*#__PURE__*/ (0, $2OMIu.jsx)($b2d5b368fed948c9$var$IconWrapper, {
                children: icon
            }),
            content
        ]
    });
};
const $b2d5b368fed948c9$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dRN65.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $2OMIu.jsx)($b2d5b368fed948c9$var$Message, {
                fieldId: fieldId ? `${fieldId}-helper` : undefined,
                testId: testId,
                children: children
            })
    });
const $b2d5b368fed948c9$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dRN65.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $2OMIu.jsx)($b2d5b368fed948c9$var$Message, {
                appearance: "error",
                fieldId: fieldId ? `${fieldId}-error` : undefined,
                testId: testId,
                children: children
            })
    });
const $b2d5b368fed948c9$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dRN65.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $2OMIu.jsx)($b2d5b368fed948c9$var$Message, {
                appearance: "valid",
                fieldId: fieldId ? `${fieldId}-valid` : undefined,
                testId: testId,
                children: children
            })
    });
/**
 * __Message wrapper context__
 *
 * A message wrapper context allows the children to check
 * if it is contained within the MessageWrapper.
 */ const $b2d5b368fed948c9$var$MessageWrapperContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isWrapper: false
});
const $b2d5b368fed948c9$export$ec445f12f63100a5 = ({ children: children })=>{
    const contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)($b2d5b368fed948c9$var$MessageWrapperContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "aria-live": "polite",
            "data-testid": "message-wrapper",
            children: children
        })
    });
};

});
parcelRegister("a9R4o", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cff7f76982b85a3455ee52aa89d66175>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7653e93bf7da1948$var$_react = $7653e93bf7da1948$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7653e93bf7da1948$var$_success = $7653e93bf7da1948$var$_interopRequireDefault((parcelRequire("b0JGA")));

var $7653e93bf7da1948$var$_success2 = $7653e93bf7da1948$var$_interopRequireDefault((parcelRequire("kJ541")));
function $7653e93bf7da1948$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SuccessIcon.
 * This component is SuccessIcon, with `UNSAFE_fallbackIcon` set to "EditorSuccessIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7653e93bf7da1948$var$SuccessIcon = (props)=>/*#__PURE__*/ $7653e93bf7da1948$var$_react.default.createElement($7653e93bf7da1948$var$_success.default, Object.assign({
        LEGACY_fallbackIcon: $7653e93bf7da1948$var$_success2.default
    }, props));
$7653e93bf7da1948$var$SuccessIcon.Name = 'SuccessIconMigration';
var $7653e93bf7da1948$var$_default = module.exports.default = $7653e93bf7da1948$var$SuccessIcon;

});
parcelRegister("kJ541", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f16bf031974cd311$var$_react = $f16bf031974cd311$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $f16bf031974cd311$var$_success = $f16bf031974cd311$var$_interopRequireDefault((parcelRequire("b0JGA")));
function $f16bf031974cd311$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f16bf031974cd311$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $f16bf031974cd311$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
    }, props, {
        newIcon: $f16bf031974cd311$var$_success.default
    }));
$f16bf031974cd311$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $f16bf031974cd311$var$_default = module.exports.default = $f16bf031974cd311$var$EditorSuccessIcon;

});


parcelRegister("dRN65", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $706cd4dbd4574fd7$export$3c4232819458a302);

var $5uXOq = parcelRequire("5uXOq");
const $706cd4dbd4574fd7$export$3c4232819458a302 = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);

});


parcelRegister("7O4UO", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e20204ce79b642c$export$2e2bcd8739ae039);
/* field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("3joPi");

var $9KnKW = parcelRequire("9KnKW");

var $dRN65 = parcelRequire("dRN65");

var $efXp3 = parcelRequire("efXp3");

var $2x3Cb = parcelRequire("2x3Cb");

var $kxqHl = parcelRequire("kxqHl");

var $6cAn5 = parcelRequire("6cAn5");
const $7e20204ce79b642c$var$fieldWrapperStyles = null;
function $7e20204ce79b642c$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $7e20204ce79b642c$var$isFunction(x) {
    return typeof x === 'function';
}
function $7e20204ce79b642c$var$usePreviousRef(current) {
    const ref = (0, $5uXOq.useRef)(current);
    // will be updated on the next render
    (0, $5uXOq.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $7e20204ce79b642c$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $7e20204ce79b642c$export$2e2bcd8739ae039(props) {
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $5uXOq.useContext)((0, $efXp3.FormContext));
    const isDisabled = (0, $5uXOq.useContext)((0, $efXp3.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $7e20204ce79b642c$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $7e20204ce79b642c$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$7e20204ce79b642c$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $5uXOq.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explicitly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $7e20204ce79b642c$var$usePreviousRef(state);
    (0, $5uXOq.useEffect)(()=>{
        typeof $6cAn5;
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $7e20204ce79b642c$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($7e20204ce79b642c$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    const uid = (0, $9KnKW.useId)();
    const fieldId = (0, $5uXOq.useMemo)(()=>{
        return props.id ? props.id : `${props.name}-${uid}`;
    }, [
        props.id,
        props.name,
        uid
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": props.testId,
        className: (0, $bwpsq.default)([
            "_1pfhu2gc"
        ]),
        children: [
            props.label && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2x3Cb.Label), {
                htmlFor: fieldId,
                id: `${fieldId}-label`,
                testId: props.testId && `${props.testId}--label`,
                children: [
                    props.label,
                    props.isRequired && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kxqHl.default), {}),
                    props.elementAfterLabel
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dRN65.FieldId).Provider, {
                value: fieldId,
                children: props.children({
                    fieldProps: extendedFieldProps,
                    error: state.error,
                    valid: state.valid,
                    meta: state.meta
                })
            })
        ]
    });
}

});
parcelRegister("2x3Cb", function(module, exports) {

$parcel$export(module.exports, "Label", () => $987b76a5b7a0ea9b$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $987b76a5b7a0ea9b$export$ed247974535929c7);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $987b76a5b7a0ea9b$var$fieldsetLabelStyles = null;
const $987b76a5b7a0ea9b$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
const $987b76a5b7a0ea9b$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("legend", {
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
};

});

parcelRegister("kxqHl", function(module, exports) {

$parcel$export(module.exports, "default", () => $d55ac25356e81a33$export$2e2bcd8739ae039);
/* required-asterisk.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d55ac25356e81a33$var$requiredIndicatorStyles = null;
function $d55ac25356e81a33$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, $bwpsq.default)([
            "_syaz1ick _ect41gqc _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("4D12X", function(module, exports) {

$parcel$export(module.exports, "default", () => $37b6bea23dba762b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $37b6bea23dba762b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    boardNameFieldLabel: {
        "id": "software-board-create.modal.form.board-name.board-name-field-label",
        "defaultMessage": "Name this board"
    },
    boardNameFieldPlaceholder: {
        "id": "software-board-create.modal.form.board-name.board-name-field-placeholder",
        "defaultMessage": "Enter a name for this board"
    },
    boardNameEmptyError: {
        "id": "software-board-create.modal.form.board-name.board-name-empty-error",
        "defaultMessage": "Enter a board name"
    },
    boardNameMaxChars: {
        "id": "software-board-create.modal.form.board-name.board-name-max-chars",
        "defaultMessage": "Maximum {maxLength, plural, one {# character} other {# characters}}"
    }
});

});


parcelRegister("7GuB2", function(module, exports) {

$parcel$export(module.exports, "SourceTypePicker", () => $24e530c3fc1a0dce$export$879aac32ab2e56ba);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $183uB = parcelRequire("183uB");

var $8Rkzz = parcelRequire("8Rkzz");

var $ujWmd = parcelRequire("ujWmd");

var $qfj8c = parcelRequire("qfj8c");
var $7O4UO = parcelRequire("7O4UO");

var $kgoHi = parcelRequire("kgoHi");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $bChGW = parcelRequire("bChGW");
var $7K5PP = parcelRequire("7K5PP");

var $i0vxP = parcelRequire("i0vxP");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $2NRUh = parcelRequire("2NRUh");

var $kJMdt = parcelRequire("kJMdt");

var $c6RuI = parcelRequire("c6RuI");
const $24e530c3fc1a0dce$export$7b060a5763a6e199 = 'VALIDATION_ERROR_EMPTY';
const $24e530c3fc1a0dce$var$formatOptionLabel = (option)=>{
    const { icon: Icon, title: title, description: description } = option;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        gap: "space.150",
        xcss: $24e530c3fc1a0dce$var$optionStyles
    }, typeof Icon === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        src: Icon,
        size: "xsmall",
        appearance: "square",
        borderColor: "transparent"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
        label: "",
        name: "projectIcon"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, title), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "UNSAFE_small",
        color: "color.text.subtlest"
    }, description)));
};
const $24e530c3fc1a0dce$var$SingleValue = (props)=>{
    const { data: { selectedTitle: selectedTitle, icon: Icon } } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).SingleValue, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        gap: "space.100"
    }, typeof Icon === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        src: Icon,
        size: "xsmall",
        appearance: "square",
        name: "avatar"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage(selectedTitle, {
        strong: (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                as: "strong"
            }, children)
    }))));
};
const $24e530c3fc1a0dce$export$77e74af9508bfdeb = ()=>(0, $5uXOq.useState)();
const $24e530c3fc1a0dce$var$controlStyles = {
    focused: "_1u6l142n _4cvx1p6i _1dbzzucj"
};
const $24e530c3fc1a0dce$var$groupStyles = {
    root: "_1vedyh40 _fgngnqa1 _1itxmuej"
};
const $24e530c3fc1a0dce$export$879aac32ab2e56ba = ({ resetSourceValue: resetSourceValue })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [selected, setSelected] = $24e530c3fc1a0dce$export$77e74af9508bfdeb();
    const { projectAvatar: projectAvatar } = (0, $2NRUh.useBoardCreateContext)();
    const optionGroups = (0, $5uXOq.useMemo)(()=>(0, $c6RuI.getOptionGroups)({
            formatMessage: formatMessage,
            projectAvatar: projectAvatar
        }), [
        formatMessage,
        projectAvatar
    ]);
    const flattenedOptions = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($183uB)))(optionGroups.map((group)=>group.options)), [
        optionGroups
    ]);
    const handleChange = (0, $5uXOq.useCallback)((onFieldChange)=>(value)=>{
            const option = value?.value || null;
            resetSourceValue();
            setSelected(option);
            onFieldChange(option);
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'select',
                action: 'changed'
            }), 'boardSourceType', {
                sourceType: option
            });
        }, [
        createAnalyticsEvent,
        resetSourceValue,
        setSelected
    ]);
    const handleOnMenuOpen = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'select',
            action: 'opened'
        }), 'boardSourceType');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        name: "sourceType",
        label: formatMessage((0, $kJMdt.default).sourceTypeFieldLabel),
        defaultValue: undefined,
        isRequired: true
    }, ({ fieldProps: { onChange: onFieldChange, ...rest }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i0vxP.default), {
            onEscape: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
            ...rest,
            "aria-label": formatMessage((0, $kJMdt.default).sourceTypePickerAriaLabel),
            options: optionGroups,
            isSearchable: false,
            formatOptionLabel: $24e530c3fc1a0dce$var$formatOptionLabel,
            components: {
                SingleValue: $24e530c3fc1a0dce$var$SingleValue,
                Control: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Control, {
                        ...props,
                        xcss: props.isFocused && $24e530c3fc1a0dce$var$controlStyles.focused
                    }),
                Group: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Group, {
                        ...props,
                        xcss: $24e530c3fc1a0dce$var$groupStyles.root
                    })
            },
            placeholder: formatMessage((0, $kJMdt.default).selectPlaceholder),
            menuPosition: "fixed",
            classNamePrefix: "source-type-picker",
            onChange: handleChange(onFieldChange),
            value: flattenedOptions.find((option)=>option.value === selected),
            styles: {
                control: (base, state)=>({
                        ...base,
                        borderColor: state.isFocused ? "var(--ds-border-focused, #388BFF)" : base.borderColor,
                        ':focus-within': {
                            boxShadow: state.isFocused ? `inset 0px 0px 0px 1px ${"var(--ds-border-focused, #388BFF)"}` : base.boxShadow
                        },
                        ':hover': {
                            borderColor: state.isFocused ? "var(--ds-border-focused, #388BFF)" : base.borderColor,
                            boxShadow: state.isFocused ? 'elevation.shadow.raised' : base.boxShadow
                        }
                    }),
                option: (base)=>({
                        ...base,
                        // padding inside the option so hover covers the element
                        padding: `${"var(--ds-space-100, 8px)"} 0 ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-300, 24px)"}`
                    }),
                group: (base)=>({
                        ...base,
                        padding: 0,
                        ':not(:last-of-type)': {
                            borderBottomWidth: '2px',
                            borderBottomStyle: 'solid',
                            borderBottomColor: "var(--ds-border, #091E4224)"
                        }
                    }),
                groupHeading: (base)=>({
                        ...base,
                        margin: 0
                    }),
                menuList: (base)=>({
                        ...base,
                        padding: 0,
                        maxHeight: 325
                    })
            },
            onMenuOpen: handleOnMenuOpen
        })), error === $24e530c3fc1a0dce$export$7b060a5763a6e199 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), {
            testId: "software-board-create.ui.modal.form.source-type-picker.error"
        }, formatMessage((0, $kJMdt.default).sourceTypeEmptyError))));
};
const $24e530c3fc1a0dce$var$optionStyles = (0, $8CUq3.xcss)({
    minHeight: '40px'
});

});
parcelRegister("bChGW", function(module, exports) {

$parcel$export(module.exports, "components", () => $ea75c1778b4e3ad2$export$9b5ac10f59f76296);
$parcel$export(module.exports, "defaultComponents", () => $ea75c1778b4e3ad2$export$71abc632aa29e6fe);

var $h1QWG = parcelRequire("h1QWG");

var $eZFhY = parcelRequire("eZFhY");

var $i48X9 = parcelRequire("i48X9");

var $95iuW = parcelRequire("95iuW");

var $dS5G5 = parcelRequire("dS5G5");

var $aA8TC = parcelRequire("aA8TC");

var $hqcPo = parcelRequire("hqcPo");

var $8l2RA = parcelRequire("8l2RA");

var $kKm82 = parcelRequire("kKm82");

var $hpcbi = parcelRequire("hpcbi");
const $ea75c1778b4e3ad2$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $95iuW.ClearIndicator),
    Control: (0, $eZFhY.default),
    DropdownIndicator: (0, $95iuW.DropdownIndicator),
    Group: (0, $i48X9.default),
    GroupHeading: (0, $i48X9.GroupHeading),
    IndicatorsContainer: (0, $h1QWG.IndicatorsContainer),
    Input: (0, $dS5G5.default),
    LoadingIndicator: (0, $95iuW.LoadingIndicator),
    Menu: (0, $aA8TC.default),
    MenuList: (0, $aA8TC.MenuList),
    MenuPortal: (0, $aA8TC.MenuPortal),
    LoadingMessage: (0, $aA8TC.LoadingMessage),
    NoOptionsMessage: (0, $aA8TC.NoOptionsMessage),
    MultiValue: (0, $hqcPo.default),
    MultiValueContainer: (0, $hqcPo.MultiValueContainer),
    MultiValueLabel: (0, $hqcPo.MultiValueLabel),
    MultiValueRemove: (0, $hqcPo.MultiValueRemove),
    Option: (0, $8l2RA.default),
    Placeholder: (0, $kKm82.default),
    SelectContainer: (0, $h1QWG.SelectContainer),
    SingleValue: (0, $hpcbi.default),
    ValueContainer: (0, $h1QWG.ValueContainer)
};
const $ea75c1778b4e3ad2$export$71abc632aa29e6fe = (props)=>({
        ...$ea75c1778b4e3ad2$export$9b5ac10f59f76296,
        ...props.components
    });

});
parcelRegister("h1QWG", function(module, exports) {

$parcel$export(module.exports, "containerCSS", () => $78186faf13ea75d3$export$949392aeaf7d2e3a);
$parcel$export(module.exports, "SelectContainer", () => $78186faf13ea75d3$export$446eebadefe1123b);
$parcel$export(module.exports, "valueContainerCSS", () => $78186faf13ea75d3$export$47aec73c7aa6b9aa);
$parcel$export(module.exports, "ValueContainer", () => $78186faf13ea75d3$export$4dc9f58ad9a1a000);
$parcel$export(module.exports, "indicatorsContainerCSS", () => $78186faf13ea75d3$export$9d74e3c8b5868ad7);
$parcel$export(module.exports, "IndicatorsContainer", () => $78186faf13ea75d3$export$d0ffd7e649cab6f);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $agFN9 = parcelRequire("agFN9");
const $78186faf13ea75d3$export$949392aeaf7d2e3a = (props)=>(0, $agFN9.containerCSS)();
const $78186faf13ea75d3$export$446eebadefe1123b = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $agFN9.SelectContainer), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $agFN9.SelectContainer), {
        ...props
    });
const $78186faf13ea75d3$export$47aec73c7aa6b9aa = (props)=>(0, $agFN9.valueContainerCSS)();
const $78186faf13ea75d3$export$4dc9f58ad9a1a000 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $agFN9.ValueContainer), {
        ...props
    });
const $78186faf13ea75d3$export$9d74e3c8b5868ad7 = ()=>(0, $agFN9.indicatorsContainerCSS)();
const $78186faf13ea75d3$export$d0ffd7e649cab6f = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $agFN9.IndicatorsContainer), {
        ...props
    });

});
parcelRegister("agFN9", function(module, exports) {

$parcel$export(module.exports, "containerCSS", () => $0e7e14a3e3f4b78e$export$949392aeaf7d2e3a);
$parcel$export(module.exports, "SelectContainer", () => $0e7e14a3e3f4b78e$export$446eebadefe1123b);
$parcel$export(module.exports, "valueContainerCSS", () => $0e7e14a3e3f4b78e$export$47aec73c7aa6b9aa);
$parcel$export(module.exports, "ValueContainer", () => $0e7e14a3e3f4b78e$export$4dc9f58ad9a1a000);
$parcel$export(module.exports, "indicatorsContainerCSS", () => $0e7e14a3e3f4b78e$export$9d74e3c8b5868ad7);
$parcel$export(module.exports, "IndicatorsContainer", () => $0e7e14a3e3f4b78e$export$d0ffd7e649cab6f);
/* containers.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $VSDnB = parcelRequire("VSDnB");

var $gyjU7 = parcelRequire("gyjU7");
const $0e7e14a3e3f4b78e$export$949392aeaf7d2e3a = ()=>({});
const $0e7e14a3e3f4b78e$var$containerStyles = {
    default: "_11c82smr _kqswh2mm _lcxv1rj4",
    rtl: "_1eim1xrj",
    disabled: "_80om13gf",
    ff_safari_input_fix: "_11c81ixg _1tn22smr"
};
const $0e7e14a3e3f4b78e$export$446eebadefe1123b = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl, xcss: xcss } = props;
    const { className: className, css: css } = (0, $gyjU7.getStyleProps)(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $0e7e14a3e3f4b78e$var$containerStyles.default,
            isRtl && $0e7e14a3e3f4b78e$var$containerStyles.rtl,
            isDisabled && $0e7e14a3e3f4b78e$var$containerStyles.disabled,
            (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') && $0e7e14a3e3f4b78e$var$containerStyles.ff_safari_input_fix,
            (0, $DEWI6.cx)(className, xcss, '-container')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        children: children
    });
};
const $0e7e14a3e3f4b78e$export$47aec73c7aa6b9aa = ()=>({});
const $0e7e14a3e3f4b78e$var$valueContainerStyles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o _1e0c11p5 _1n261g80 _8am5i4x0 _kqswh2mm _ca0qv77o _u5f312x7 _n3tdv77o _19bv12x7",
    flex: "_1e0c1txw",
    compact: "_ca0qze3t _u5f312x7 _n3tdze3t _19bv12x7"
};
const $0e7e14a3e3f4b78e$export$4dc9f58ad9a1a000 = (props)=>{
    const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue, isCompact: isCompact, xcss: xcss, selectProps: { controlShouldRenderValue: controlShouldRenderValue } } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $0e7e14a3e3f4b78e$var$valueContainerStyles.default,
            isMulti && hasValue && controlShouldRenderValue && $0e7e14a3e3f4b78e$var$valueContainerStyles.flex,
            isCompact && $0e7e14a3e3f4b78e$var$valueContainerStyles.compact,
            (0, $DEWI6.cx)(className, xcss, '-ValueContainer')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        children: children
    });
};
const $0e7e14a3e3f4b78e$export$9d74e3c8b5868ad7 = ()=>({});
const $0e7e14a3e3f4b78e$var$indicatorContainerStyles = null;
const $0e7e14a3e3f4b78e$export$d0ffd7e649cab6f = (props)=>{
    const { children: children, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'indicatorsContainer', {
        indicators: true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _1wpz1fhb _y4ti1b66",
            (0, $DEWI6.cx)(className, xcss, '-IndicatorsContainer')
        ]),
        ...innerProps,
        children: children
    });
};

});
parcelRegister("gyjU7", function(module, exports) {

$parcel$export(module.exports, "noop", () => $109d3f9af5469308$export$8793edee2d425525);
$parcel$export(module.exports, "classNames", () => $109d3f9af5469308$export$ce4ab0c55987d1ff);
$parcel$export(module.exports, "cleanValue", () => $109d3f9af5469308$export$33f062f47f21a01);
$parcel$export(module.exports, "cleanCommonProps", () => $109d3f9af5469308$export$8e9fd4287627890c);
$parcel$export(module.exports, "getStyleProps", () => $109d3f9af5469308$export$26417cabd806a658);
$parcel$export(module.exports, "handleInputChange", () => $109d3f9af5469308$export$2096bae78ecda911);
$parcel$export(module.exports, "isDocumentElement", () => $109d3f9af5469308$export$d8a62a489b442872);
$parcel$export(module.exports, "normalizedHeight", () => $109d3f9af5469308$export$2e0654fad740d2e4);
$parcel$export(module.exports, "getScrollTop", () => $109d3f9af5469308$export$c4a223a8ba9e4ea5);
$parcel$export(module.exports, "scrollTo", () => $109d3f9af5469308$export$3f99968195accfaf);
$parcel$export(module.exports, "getScrollParent", () => $109d3f9af5469308$export$cfa2225e87938781);
$parcel$export(module.exports, "animatedScrollTo", () => $109d3f9af5469308$export$858c30343199f3af);
$parcel$export(module.exports, "scrollIntoView", () => $109d3f9af5469308$export$53a0910f038337bd);
$parcel$export(module.exports, "getBoundingClientObj", () => $109d3f9af5469308$export$7807c2a424c2f6d1);
$parcel$export(module.exports, "isTouchCapable", () => $109d3f9af5469308$export$56963d77dbffdde7);
$parcel$export(module.exports, "isMobileDevice", () => $109d3f9af5469308$export$44f917bf91becd01);
$parcel$export(module.exports, "supportsPassiveEvents", () => $109d3f9af5469308$export$b0622a6911dbeaf5);
$parcel$export(module.exports, "notNullish", () => $109d3f9af5469308$export$aedb69ff3e31596c);
$parcel$export(module.exports, "valueTernary", () => $109d3f9af5469308$export$40fb9515c784cc3b);
$parcel$export(module.exports, "singleValueAsValue", () => $109d3f9af5469308$export$dea4763e29237f4c);
$parcel$export(module.exports, "multiValueAsValue", () => $109d3f9af5469308$export$d1ca752ec761b95b);
$parcel$export(module.exports, "removeProps", () => $109d3f9af5469308$export$4213b25a1c4e877);
$parcel$export(module.exports, "filterUnsupportedSelectors", () => $109d3f9af5469308$export$bf2eda47afa5f369);
const $109d3f9af5469308$export$8793edee2d425525 = ()=>{};
// ==============================
// Class Name Prefixer
// ==============================
/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $109d3f9af5469308$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $109d3f9af5469308$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
    const arr = [
        ...classNameList
    ];
    if (state && prefix) {
        for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$109d3f9af5469308$var$applyPrefixToName(prefix, key)}`);
    }
    return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
}
const $109d3f9af5469308$export$33f062f47f21a01 = (value)=>{
    if ($109d3f9af5469308$var$isArray(value)) return value.filter(Boolean);
    if (typeof value === 'object' && value !== null) return [
        value
    ];
    return [];
};
const $109d3f9af5469308$export$8e9fd4287627890c = (props)=>{
    //className
    const { className: className, clearValue: clearValue, cx: cx, xcss: xcss, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, ...innerProps } = props;
    return {
        ...innerProps
    };
};
const $109d3f9af5469308$export$26417cabd806a658 = (props, name, classNamesState)=>{
    const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState ?? {}, getClassNames(name, props), className)
    };
};
function $109d3f9af5469308$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        const newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $109d3f9af5469308$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $109d3f9af5469308$export$2e0654fad740d2e4(el) {
    if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.innerHeight;
    return el.clientHeight;
}
function $109d3f9af5469308$export$c4a223a8ba9e4ea5(el) {
    if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $109d3f9af5469308$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($109d3f9af5469308$export$d8a62a489b442872(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $109d3f9af5469308$export$cfa2225e87938781(element) {
    let style = getComputedStyle(element);
    const excludeStaticParent = style.position === 'absolute';
    const overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(let parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
 * @param t: time (elapsed)
 * @param b: initial value
 * @param c: amount of change
 * @param d: duration
 */ function $109d3f9af5469308$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $109d3f9af5469308$export$858c30343199f3af(element, to, duration = 200, callback = $109d3f9af5469308$export$8793edee2d425525) {
    const start = $109d3f9af5469308$export$c4a223a8ba9e4ea5(element);
    const change = to - start;
    const increment = 10;
    let currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        const val = $109d3f9af5469308$var$easeOutCubic(currentTime, start, change, duration);
        $109d3f9af5469308$export$3f99968195accfaf(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $109d3f9af5469308$export$53a0910f038337bd(menuEl, focusedEl) {
    const menuRect = menuEl.getBoundingClientRect();
    const focusedRect = focusedEl.getBoundingClientRect();
    const overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $109d3f9af5469308$export$7807c2a424c2f6d1(element) {
    const rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
function $109d3f9af5469308$export$56963d77dbffdde7() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
function $109d3f9af5469308$export$44f917bf91becd01() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
let $109d3f9af5469308$var$passiveOptionAccessed = false;
const $109d3f9af5469308$var$options = {
    get passive () {
        return $109d3f9af5469308$var$passiveOptionAccessed = true;
    }
};
// check for SSR
const $109d3f9af5469308$var$w = typeof window !== 'undefined' ? window : {};
if ($109d3f9af5469308$var$w.addEventListener && $109d3f9af5469308$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $109d3f9af5469308$var$w.addEventListener('p', $109d3f9af5469308$export$8793edee2d425525, $109d3f9af5469308$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $109d3f9af5469308$var$w.removeEventListener('p', $109d3f9af5469308$export$8793edee2d425525, false);
}
const $109d3f9af5469308$export$b0622a6911dbeaf5 = $109d3f9af5469308$var$passiveOptionAccessed;
function $109d3f9af5469308$export$aedb69ff3e31596c(item) {
    return item != null;
}
function $109d3f9af5469308$var$isArray(arg) {
    return Array.isArray(arg);
}
function $109d3f9af5469308$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $109d3f9af5469308$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}
function $109d3f9af5469308$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}
const $109d3f9af5469308$export$4213b25a1c4e877 = (propsObj, ...properties)=>{
    let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
    return propsMap.reduce((newProps, [key, val])=>{
        newProps[key] = val;
        return newProps;
    }, {});
};
const $109d3f9af5469308$export$bf2eda47afa5f369 = (styles)=>{
    const unsupportedSelectors = [
        ':',
        '[',
        '>',
        '+',
        '~',
        ' ',
        '*',
        '#',
        '.',
        '@',
        '&',
        '|',
        '^',
        '$',
        '='
    ];
    return Object.keys(styles).reduce((filteredStyles, key)=>{
        if (!unsupportedSelectors.some((selector)=>key.includes(selector))) filteredStyles[key] = styles[key];
        return filteredStyles;
    }, {});
};

});



parcelRegister("eZFhY", function(module, exports) {

$parcel$export(module.exports, "css", () => $728816cb4150b6bc$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $728816cb4150b6bc$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8JQpT = parcelRequire("8JQpT");
const $728816cb4150b6bc$export$dbf350e5966cf602 = (props)=>{
    return (0, $8JQpT.css)();
};
const $728816cb4150b6bc$var$Control = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $8JQpT.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$728816cb4150b6bc$export$2e2bcd8739ae039 = $728816cb4150b6bc$var$Control;

});
parcelRegister("8JQpT", function(module, exports) {

$parcel$export(module.exports, "css", () => $2fb743295de83222$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $2fb743295de83222$export$2e2bcd8739ae039);
/* control.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $gyjU7 = parcelRequire("gyjU7");
const $2fb743295de83222$var$styles = {
    default: "_12ji1r31 _1qu2glyw _12y3idpf _2rkosqtm _v564r5cv _1h6d1elr _1dqonqa1 _189ee4h9 _4cvr1h6o _80om73ad _1e0c1txw _1n261g80 _1bah1yb4 _kqswh2mm _bfhk1j9a _1tke1ylp _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _15peftgi _1ke8ftgi _jaboglyw _1u6l1bml _4cvx1elr _123b1h4p _d0altlke _irr31d5g _1oglgxqn",
    compact: "_1tkezwfg",
    invalid: "_1h6d1bqt _16qsizbr _1u6lizbr _4cvx1bqt",
    focusedInvalid: "_16qsq049",
    disabled: "_1h6dsyzs _lcxvglyw _bfhksyzs _1u6llkwx",
    focused: "_1h6d1p6i _bfhkr01l _16qsq049 _1u6lq049 _4cvx1p6i _irr3r01l",
    subtle: "_1h6d3acm _bfhk18uv _1u6lnruj",
    subtleFocused: "_bfhkvuon",
    none: "_1h6d3acm _bfhk18uv _1u6lnruj _4cvx3acm _irr318uv"
};
const $2fb743295de83222$export$dbf350e5966cf602 = ()=>({});
const $2fb743295de83222$var$Control = (props)=>{
    const { children: children, appearance: appearance, isCompact: isCompact, isDisabled: isDisabled, isFocused: isFocused, isInvalid: isInvalid, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $2fb743295de83222$var$styles.default,
            isDisabled && $2fb743295de83222$var$styles.disabled,
            isInvalid && $2fb743295de83222$var$styles.invalid,
            isCompact && $2fb743295de83222$var$styles.compact,
            appearance === 'subtle' && $2fb743295de83222$var$styles.subtle,
            appearance === 'subtle' && isFocused && $2fb743295de83222$var$styles.subtleFocused,
            isFocused && $2fb743295de83222$var$styles.focused,
            appearance === 'none' && $2fb743295de83222$var$styles.none,
            (0, $DEWI6.cx)(className, xcss, '-control')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        "aria-disabled": isDisabled || undefined,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2fb743295de83222$export$2e2bcd8739ae039 = $2fb743295de83222$var$Control;

});


parcelRegister("i48X9", function(module, exports) {

$parcel$export(module.exports, "groupCSS", () => $902e86f4b4fe337b$export$b6794329c1460634);
$parcel$export(module.exports, "groupHeadingCSS", () => $902e86f4b4fe337b$export$e5a7fbb542efcb7d);
$parcel$export(module.exports, "GroupHeading", () => $902e86f4b4fe337b$export$85c8b41a3cd87edc);
$parcel$export(module.exports, "default", () => $902e86f4b4fe337b$export$2e2bcd8739ae039);
/* group.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $OON7h = parcelRequire("OON7h");
const $902e86f4b4fe337b$export$b6794329c1460634 = (props)=>(0, $OON7h.groupCSS)();
const $902e86f4b4fe337b$var$Group = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $OON7h.default), {
        ...props
    });
const $902e86f4b4fe337b$export$e5a7fbb542efcb7d = (props)=>(0, $OON7h.groupHeadingCSS)();
const $902e86f4b4fe337b$export$85c8b41a3cd87edc = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $OON7h.GroupHeading), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$902e86f4b4fe337b$export$2e2bcd8739ae039 = $902e86f4b4fe337b$var$Group;

});
parcelRegister("OON7h", function(module, exports) {

$parcel$export(module.exports, "groupCSS", () => $a3ce5541021fbdcc$export$b6794329c1460634);
$parcel$export(module.exports, "groupHeadingCSS", () => $a3ce5541021fbdcc$export$e5a7fbb542efcb7d);
$parcel$export(module.exports, "GroupHeading", () => $a3ce5541021fbdcc$export$85c8b41a3cd87edc);
$parcel$export(module.exports, "default", () => $a3ce5541021fbdcc$export$2e2bcd8739ae039);
/* group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $gyjU7 = parcelRequire("gyjU7");
const $a3ce5541021fbdcc$var$styles = {
    root: "_n3tdu2gc _ca0qu2gc"
};
const $a3ce5541021fbdcc$export$b6794329c1460634 = ()=>({});
const $a3ce5541021fbdcc$var$Group = (props)=>{
    const { children: children, cx: builtinCX, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, selectProps: selectProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'group', {
        group: true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $a3ce5541021fbdcc$var$styles.root,
            (0, $DEWI6.cx)(className, xcss, innerProps?.className, '-Group')
        ]),
        children: [
            label && /*#__PURE__*/ (0, $2OMIu.jsx)(Heading, {
                ...headingProps,
                selectProps: selectProps,
                getStyles: getStyles,
                getClassNames: getClassNames,
                cx: builtinCX,
                children: label
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                children: children
            })
        ]
    });
};
const $a3ce5541021fbdcc$var$headingStyles = null;
const $a3ce5541021fbdcc$export$e5a7fbb542efcb7d = ()=>({});
const $a3ce5541021fbdcc$export$85c8b41a3cd87edc = (props)=>{
    const { xcss: xcss } = props;
    const { data: data, ...innerProps } = (0, $gyjU7.cleanCommonProps)(props);
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'groupHeading', {
        'group-heading': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            "_11c81o8v _1e0c1ule _syaz1gjq _80om73ad _k48pmoej _6rthpd1z _y4tiutpp _bozgutpp _1p1dglyw",
            (0, $DEWI6.cx)(className, xcss, '-group')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a3ce5541021fbdcc$export$2e2bcd8739ae039 = $a3ce5541021fbdcc$var$Group;

});


parcelRegister("95iuW", function(module, exports) {

$parcel$export(module.exports, "dropdownIndicatorCSS", () => $13f090f36c42825d$export$e1687335805e1230);
$parcel$export(module.exports, "DropdownIndicator", () => $13f090f36c42825d$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "clearIndicatorCSS", () => $13f090f36c42825d$export$9c0419fd944c1def);
$parcel$export(module.exports, "ClearIndicator", () => $13f090f36c42825d$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "loadingIndicatorCSS", () => $13f090f36c42825d$export$1d3f24cde248e6b5);
$parcel$export(module.exports, "LoadingIndicator", () => $13f090f36c42825d$export$7c20be4c1d342248);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7FTuF = parcelRequire("7FTuF");
const $13f090f36c42825d$export$e1687335805e1230 = (props)=>(0, $7FTuF.dropdownIndicatorCSS)();
const $13f090f36c42825d$export$ec98719d3db7f2e4 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $7FTuF.DropdownIndicator), {
        ...props
    });
const $13f090f36c42825d$export$9c0419fd944c1def = (props)=>(0, $7FTuF.clearIndicatorCSS)();
const $13f090f36c42825d$export$ecf9cf59142dd54a = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $7FTuF.ClearIndicator), {
        ...props
    });
const $13f090f36c42825d$export$1d3f24cde248e6b5 = (props)=>(0, $7FTuF.loadingIndicatorCSS)();
const $13f090f36c42825d$export$7c20be4c1d342248 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $7FTuF.LoadingIndicator), {
        ...props
    });

});
parcelRegister("7FTuF", function(module, exports) {

$parcel$export(module.exports, "dropdownIndicatorCSS", () => $a7cf25f9e9baf2e9$export$e1687335805e1230);
$parcel$export(module.exports, "DropdownIndicator", () => $a7cf25f9e9baf2e9$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "clearIndicatorCSS", () => $a7cf25f9e9baf2e9$export$9c0419fd944c1def);
$parcel$export(module.exports, "ClearIndicator", () => $a7cf25f9e9baf2e9$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "loadingIndicatorCSS", () => $a7cf25f9e9baf2e9$export$1d3f24cde248e6b5);
$parcel$export(module.exports, "LoadingIndicator", () => $a7cf25f9e9baf2e9$export$7c20be4c1d342248);
/* indicators.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $kEVMo = parcelRequire("kEVMo");

var $ip0rq = parcelRequire("ip0rq");

var $c0aEF = parcelRequire("c0aEF");
var $3Lty3 = parcelRequire("3Lty3");

var $eZJjh = parcelRequire("eZJjh");

var $gyjU7 = parcelRequire("gyjU7");
// ==============================
// Dropdown & Clear Icons
// ==============================
const $a7cf25f9e9baf2e9$var$iconContainerStyles = {
    root: "_kkk2n7od _12ji1r31 _1qu219ly _12y31o36 _1e0c1txw _4cvr1h6o _1bah1h6o _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o"
};
const $a7cf25f9e9baf2e9$var$dropdownWrapperStyles = {
    root: "_ca0q12x7 _u5f312x7 _n3td12x7 _19bv12x7"
};
const $a7cf25f9e9baf2e9$var$dropdownStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz1gjq _ca0q12x7 _u5f3v77o _n3td12x7 _19bvv77o _30l31gjq",
    compact: "_ca0qidpf _n3tdidpf",
    disabled: "_syaz1lh4"
};
const $a7cf25f9e9baf2e9$export$e1687335805e1230 = ()=>({});
const $a7cf25f9e9baf2e9$export$ec98719d3db7f2e4 = (props)=>{
    const { innerProps: innerProps, children: children, isDisabled: isDisabled, isCompact: isCompact, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $a7cf25f9e9baf2e9$var$dropdownStyles.default,
            isDisabled && $a7cf25f9e9baf2e9$var$dropdownStyles.disabled,
            isCompact && $a7cf25f9e9baf2e9$var$dropdownStyles.compact,
            (0, $DEWI6.cx)(className, xcss, '-indicatorContainer')
        ]),
        ...innerProps,
        children: children ? children : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
            as: "span",
            xcss: $a7cf25f9e9baf2e9$var$dropdownWrapperStyles.root,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kEVMo))), {
                color: "currentColor",
                label: "open",
                LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)",
                size: "small"
            })
        })
    });
};
const $a7cf25f9e9baf2e9$export$9c0419fd944c1def = ()=>({});
const $a7cf25f9e9baf2e9$var$clearIndicatorStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz131l _ca0q12x7 _u5f3v77o _n3td12x7 _19bvv77o _30l31gjq",
    compact: "_ca0qidpf _n3tdidpf"
};
const $a7cf25f9e9baf2e9$export$ecf9cf59142dd54a = (props)=>{
    const { innerProps: innerProps, clearControlLabel: clearControlLabel = 'clear', isCompact: isCompact, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $a7cf25f9e9baf2e9$var$clearIndicatorStyles.default,
            isCompact && $a7cf25f9e9baf2e9$var$clearIndicatorStyles.compact,
            (0, $DEWI6.cx)(className, xcss, '-indicatorContainer')
        ]),
        ...innerProps,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
            xcss: $a7cf25f9e9baf2e9$var$iconContainerStyles.root,
            tabIndex: -1,
            "aria-label": clearControlLabel,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ip0rq))), {
                label: "",
                color: "currentColor",
                LEGACY_size: "small",
                LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)",
                size: "small"
            })
        })
    });
};
const $a7cf25f9e9baf2e9$export$1d3f24cde248e6b5 = ()=>({});
const $a7cf25f9e9baf2e9$var$loadingIndicatorStyles = {
    default: "_ca0q12x7 _u5f3u2gc _n3td12x7 _19bvu2gc",
    compact: "_ca0qidpf _n3tdidpf"
};
const $a7cf25f9e9baf2e9$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, isCompact: isCompact, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)({
        ...restProps,
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }, 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $a7cf25f9e9baf2e9$var$loadingIndicatorStyles.default,
            isCompact && $a7cf25f9e9baf2e9$var$loadingIndicatorStyles.compact,
            (0, $DEWI6.cx)(className, xcss, '-loadingIndicator')
        ]),
        ...innerProps,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
            size: "small"
        })
    });
};

});


parcelRegister("dS5G5", function(module, exports) {

$parcel$export(module.exports, "inputCSS", () => $1c949ac6f5985b40$export$14a7781d0ca7abea);
$parcel$export(module.exports, "default", () => $1c949ac6f5985b40$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dIuKO = parcelRequire("dIuKO");
const $1c949ac6f5985b40$export$14a7781d0ca7abea = (props)=>(0, $dIuKO.inputCSS)();
const $1c949ac6f5985b40$var$Input = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dIuKO.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1c949ac6f5985b40$export$2e2bcd8739ae039 = $1c949ac6f5985b40$var$Input;

});
parcelRegister("dIuKO", function(module, exports) {

$parcel$export(module.exports, "inputCSS", () => $6599751c7dd5cc6c$export$14a7781d0ca7abea);
$parcel$export(module.exports, "default", () => $6599751c7dd5cc6c$export$2e2bcd8739ae039);
/* input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $gyjU7 = parcelRequire("gyjU7");
const $6599751c7dd5cc6c$export$14a7781d0ca7abea = ()=>({});
const $6599751c7dd5cc6c$var$inputStyles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _1e0c1n7u _yv0e12qd _syaz1fxt _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq"
};
const $6599751c7dd5cc6c$var$nativeInnputStyles = null;
const $6599751c7dd5cc6c$var$hidden = null;
const $6599751c7dd5cc6c$var$Input = (props)=>{
    const { cx: builtinCX, value: value, xcss: xcss } = props;
    const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, testId: testId, ...innerProps } = (0, $gyjU7.cleanCommonProps)(props);
    const dataId = testId ? `${testId}-select--input` : null;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'input', {
        'input-container': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $6599751c7dd5cc6c$var$inputStyles.root,
            isDisabled && $6599751c7dd5cc6c$var$inputStyles.disabled,
            (0, $DEWI6.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $bwpsq.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _syaz1kw7 _tzy4kb7n",
                isHidden && "_tzy4idpf",
                builtinCX({
                    input: true
                }, inputClassName, '-input')
            ]),
            ref: innerRef,
            disabled: isDisabled,
            "data-testid": dataId,
            ...innerProps
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6599751c7dd5cc6c$export$2e2bcd8739ae039 = $6599751c7dd5cc6c$var$Input;

});


parcelRegister("aA8TC", function(module, exports) {

$parcel$export(module.exports, "menuCSS", () => $1fde8cb844828ae2$export$a228922d5ca42a79);
$parcel$export(module.exports, "MenuPlacer", () => $1fde8cb844828ae2$export$f32337f3a7617699);
$parcel$export(module.exports, "default", () => $1fde8cb844828ae2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "menuListCSS", () => $1fde8cb844828ae2$export$abafed69cff95d5e);
$parcel$export(module.exports, "MenuList", () => $1fde8cb844828ae2$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "noOptionsMessageCSS", () => $1fde8cb844828ae2$export$cf0e22534d8b0074);
$parcel$export(module.exports, "loadingMessageCSS", () => $1fde8cb844828ae2$export$98ec46397a8cb3cd);
$parcel$export(module.exports, "NoOptionsMessage", () => $1fde8cb844828ae2$export$d58b72b7d3c4072c);
$parcel$export(module.exports, "LoadingMessage", () => $1fde8cb844828ae2$export$e928a71d039d3102);
$parcel$export(module.exports, "menuPortalCSS", () => $1fde8cb844828ae2$export$1dbbeb9648d1fdc9);
$parcel$export(module.exports, "MenuPortal", () => $1fde8cb844828ae2$export$793392f970497feb);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5aZmi = parcelRequire("5aZmi");
const $1fde8cb844828ae2$export$a228922d5ca42a79 = (props)=>(0, $5aZmi.menuCSS)();
const $1fde8cb844828ae2$export$f32337f3a7617699 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5aZmi.MenuPlacer), {
        ...props
    });
const $1fde8cb844828ae2$var$Menu = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5aZmi.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1fde8cb844828ae2$export$2e2bcd8739ae039 = $1fde8cb844828ae2$var$Menu;
const $1fde8cb844828ae2$export$abafed69cff95d5e = (props)=>(0, $5aZmi.menuListCSS)();
const $1fde8cb844828ae2$export$d4c4e98c5044dc8 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5aZmi.MenuList), {
        ...props
    });
// ==============================
// Menu Notices
// ==============================
const $1fde8cb844828ae2$var$noticeCSS = ({})=>({
        textAlign: 'center',
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`
    });
const $1fde8cb844828ae2$export$cf0e22534d8b0074 = $1fde8cb844828ae2$var$noticeCSS;
const $1fde8cb844828ae2$export$98ec46397a8cb3cd = $1fde8cb844828ae2$var$noticeCSS;
const $1fde8cb844828ae2$export$d58b72b7d3c4072c = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5aZmi.NoOptionsMessage), {
        ...props
    });
const $1fde8cb844828ae2$export$e928a71d039d3102 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5aZmi.LoadingMessage), {
        ...props
    });
const $1fde8cb844828ae2$export$1dbbeb9648d1fdc9 = (props)=>(0, $5aZmi.menuPortalCSS)();
const $1fde8cb844828ae2$export$793392f970497feb = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5aZmi.MenuPortal), {
        ...props
    });

});
parcelRegister("5aZmi", function(module, exports) {

$parcel$export(module.exports, "menuCSS", () => $76c1fc1d7ab61474$export$a228922d5ca42a79);
$parcel$export(module.exports, "MenuPlacer", () => $76c1fc1d7ab61474$export$f32337f3a7617699);
$parcel$export(module.exports, "default", () => $76c1fc1d7ab61474$export$2e2bcd8739ae039);
$parcel$export(module.exports, "menuListCSS", () => $76c1fc1d7ab61474$export$abafed69cff95d5e);
$parcel$export(module.exports, "MenuList", () => $76c1fc1d7ab61474$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "NoOptionsMessage", () => $76c1fc1d7ab61474$export$d58b72b7d3c4072c);
$parcel$export(module.exports, "LoadingMessage", () => $76c1fc1d7ab61474$export$e928a71d039d3102);
$parcel$export(module.exports, "menuPortalCSS", () => $76c1fc1d7ab61474$export$1dbbeb9648d1fdc9);
$parcel$export(module.exports, "MenuPortal", () => $76c1fc1d7ab61474$export$793392f970497feb);
/* menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $g9RrE = parcelRequire("g9RrE");

var $7nsd3 = parcelRequire("7nsd3");

var $hrqx3 = parcelRequire("hrqx3");

var $dS3PR = parcelRequire("dS3PR");

var $gyjU7 = parcelRequire("gyjU7");
function $76c1fc1d7ab61474$var$getMenuPlacement({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
    const scrollParent = (0, $gyjU7.getScrollParent)(menuEl);
    const defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    const { height: scrollHeight } = scrollParent.getBoundingClientRect();
    const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
    const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
    const viewHeight = isFixedPosition ? window.innerHeight : (0, $gyjU7.normalizedHeight)(scrollParent);
    const scrollTop = (0, $gyjU7.getScrollTop)(scrollParent);
    const menuTopFromParent = menuTop;
    const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    const viewSpaceAbove = containerTop - marginTop;
    const viewSpaceBelow = viewHeight - menuTopFromParent;
    const scrollSpaceAbove = viewSpaceAbove + scrollTop;
    const scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    const scrollUp = scrollTop + menuTop - marginTop;
    const scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $gyjU7.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) (0, $gyjU7.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                let constrainedHeight = preferredMaxHeight;
                const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) (0, $gyjU7.scrollTo)(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $gyjU7.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                let constrainedHeight = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) (0, $gyjU7.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error(`Invalid placement provided "${preferredPlacement}".`);
    }
    return defaultState;
}
const $76c1fc1d7ab61474$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
const $76c1fc1d7ab61474$var$menuStyles = {
    root: "_2rkoglpi _kqswstnw _1bsb1osq _1pbykb7n _otyru2gc _19pku2gc _bfhk1bhr _16qs17uf",
    bottom: "_154i1osq",
    top: "_94n51osq"
};
const $76c1fc1d7ab61474$export$a228922d5ca42a79 = ()=>({});
const $76c1fc1d7ab61474$var$PortalPlacementContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $76c1fc1d7ab61474$export$f32337f3a7617699 = (props)=>{
    const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView } = props;
    const { setPortalPlacement: setPortalPlacement } = (0, $5uXOq.useContext)($76c1fc1d7ab61474$var$PortalPlacementContext) || {};
    const ref = (0, $5uXOq.useRef)(null);
    const [maxHeight, setMaxHeight] = (0, $5uXOq.useState)(maxMenuHeight);
    const [placement, setPlacement] = (0, $5uXOq.useState)(null);
    // The minimum height of the control
    const controlHeight = 38;
    (0, $hrqx3.default)(()=>{
        const menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        const isFixedPosition = menuPosition === 'fixed';
        const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        const state = $76c1fc1d7ab61474$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement?.(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: {
            ...props,
            placement: placement || $76c1fc1d7ab61474$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        }
    });
};
const $76c1fc1d7ab61474$var$Menu = (props)=>{
    const { children: children, innerRef: innerRef, innerProps: innerProps, placement: placement = 'bottom', xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'menu', {
        menu: true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $76c1fc1d7ab61474$var$menuStyles.root,
            $76c1fc1d7ab61474$var$menuStyles[placement],
            (0, $DEWI6.cx)(xcss, className, '-menu')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ref: innerRef,
        ...innerProps,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$76c1fc1d7ab61474$export$2e2bcd8739ae039 = $76c1fc1d7ab61474$var$Menu;
const $76c1fc1d7ab61474$export$abafed69cff95d5e = ()=>({});
const $76c1fc1d7ab61474$var$menuListStyles = null;
const $76c1fc1d7ab61474$export$d4c4e98c5044dc8 = (props)=>{
    const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti, maxHeight: maxHeight, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            "_kqswh2mm _18m91wug _85i5u2gc _1q51u2gc _8am5i4x0",
            (0, $DEWI6.cx)(className, xcss, '-MenuList')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            ...css,
            maxHeight: maxHeight
        },
        ref: innerRef,
        ...innerProps,
        tabIndex: -1,
        children: children
    });
};
// ==============================
// Menu Notices
// ==============================
const $76c1fc1d7ab61474$var$noticeCSS = ()=>({});
const $76c1fc1d7ab61474$var$noticeStyles = null;
const $76c1fc1d7ab61474$export$cf0e22534d8b0074 = $76c1fc1d7ab61474$var$noticeCSS;
const $76c1fc1d7ab61474$export$98ec46397a8cb3cd = $76c1fc1d7ab61474$var$noticeCSS;
const $76c1fc1d7ab61474$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)({
        ...restProps,
        children: children,
        innerProps: innerProps
    }, 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $DEWI6.cx)(className, xcss, '-NoOptionsMessage')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option",
        ...innerProps,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
            color: "color.text.subtle",
            children: children
        })
    });
};
const $76c1fc1d7ab61474$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)({
        ...restProps,
        children: children,
        innerProps: innerProps
    }, 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $DEWI6.cx)(className, xcss, '-LoadingMessage')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
            color: "color.text.subtle",
            children: children
        })
    });
};
const $76c1fc1d7ab61474$export$1dbbeb9648d1fdc9 = ()=>({});
const $76c1fc1d7ab61474$var$menuPortalStyles = {
    root: "_1pbykb7n _1ltva1vk _kqswcp1v _154i1nmo _1bsb1qxj"
};
const $76c1fc1d7ab61474$export$793392f970497feb = (props)=>{
    const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition, xcss: xcss } = props;
    const menuPortalRef = (0, $5uXOq.useRef)(null);
    const cleanupRef = (0, $5uXOq.useRef)(null);
    const [placement, setPortalPlacement] = (0, $5uXOq.useState)($76c1fc1d7ab61474$var$coercePlacement(menuPlacement));
    const portalPlacementContext = (0, $5uXOq.useMemo)(()=>({
            setPortalPlacement: setPortalPlacement
        }), []);
    const [computedPosition, setComputedPosition] = (0, $5uXOq.useState)(null);
    const updateComputedPosition = (0, $5uXOq.useCallback)(()=>{
        if (!controlElement) return;
        const rect = (0, $gyjU7.getBoundingClientObj)(controlElement);
        const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        const offset = rect[placement] + scrollDistance;
        if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition?.offset,
        computedPosition?.rect.left,
        computedPosition?.rect.width
    ]);
    (0, $hrqx3.default)(()=>{
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    const runAutoUpdate = (0, $5uXOq.useCallback)(()=>{
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $g9RrE.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $hrqx3.default)(()=>{
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    const setMenuPortalElement = (0, $5uXOq.useCallback)((menuPortalElement)=>{
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)({
        ...props,
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }, 'menuPortal', {
        'menu-portal': true
    });
    // same wrapper element whether fixed or portalled
    const menuWrapper = /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $76c1fc1d7ab61474$var$menuPortalStyles.root,
            (0, $DEWI6.cx)(className, xcss, '-MenuPortal')
        ]),
        ref: setMenuPortalElement,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            '--menu-left': `${computedPosition.rect.left}px`,
            '--menu-position': menuPosition,
            '--menu-top': `${computedPosition.offset}px`,
            '--menu-width': `${computedPosition.rect.width}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...css
        },
        ...innerProps,
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($76c1fc1d7ab61474$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext,
        children: appendTo ? /*#__PURE__*/ (0, $7nsd3.createPortal)(menuWrapper, appendTo) : menuWrapper
    });
};

});
parcelRegister("g9RrE", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $bc36f1aefc070984$export$deee3a793edee05f);

var $gSfPF = parcelRequire("gSfPF");
var $cVo0M = parcelRequire("cVo0M");

var $cVo0M = parcelRequire("cVo0M");

var $f8LYQ = parcelRequire("f8LYQ");
function $bc36f1aefc070984$var$getCssDimensions(element) {
    const css = (0, $f8LYQ.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $f8LYQ.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $cVo0M.round)(width) !== offsetWidth || (0, $cVo0M.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $bc36f1aefc070984$var$unwrapElement(element) {
    return !(0, $f8LYQ.isElement)(element) ? element.contextElement : element;
}
function $bc36f1aefc070984$var$getScale(element) {
    const domElement = $bc36f1aefc070984$var$unwrapElement(element);
    if (!(0, $f8LYQ.isHTMLElement)(domElement)) return (0, $cVo0M.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $bc36f1aefc070984$var$getCssDimensions(domElement);
    let x = ($ ? (0, $cVo0M.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $cVo0M.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $bc36f1aefc070984$var$noOffsets = /*#__PURE__*/ (0, $cVo0M.createCoords)(0);
function $bc36f1aefc070984$var$getVisualOffsets(element) {
    const win = (0, $f8LYQ.getWindow)(element);
    if (!(0, $f8LYQ.isWebKit)() || !win.visualViewport) return $bc36f1aefc070984$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $bc36f1aefc070984$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $f8LYQ.getWindow)(element)) return false;
    return isFixed;
}
function $bc36f1aefc070984$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $bc36f1aefc070984$var$unwrapElement(element);
    let scale = (0, $cVo0M.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $f8LYQ.isElement)(offsetParent)) scale = $bc36f1aefc070984$var$getScale(offsetParent);
        } else scale = $bc36f1aefc070984$var$getScale(element);
    }
    const visualOffsets = $bc36f1aefc070984$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $bc36f1aefc070984$var$getVisualOffsets(domElement) : (0, $cVo0M.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $f8LYQ.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $f8LYQ.isElement)(offsetParent) ? (0, $f8LYQ.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $f8LYQ.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $bc36f1aefc070984$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $f8LYQ.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $f8LYQ.getWindow)(currentIFrame);
            currentIFrame = (0, $f8LYQ.getFrameElement)(currentWin);
        }
    }
    return (0, $cVo0M.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $bc36f1aefc070984$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $f8LYQ.getNodeScroll)(element).scrollLeft;
    if (!rect) return $bc36f1aefc070984$var$getBoundingClientRect((0, $f8LYQ.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $bc36f1aefc070984$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $f8LYQ.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $f8LYQ.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $cVo0M.createCoords)(1);
    const offsets = (0, $cVo0M.createCoords)(0);
    const isOffsetParentAnElement = (0, $f8LYQ.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $f8LYQ.getNodeName)(offsetParent) !== 'body' || (0, $f8LYQ.isOverflowElement)(documentElement)) scroll = (0, $f8LYQ.getNodeScroll)(offsetParent);
        if ((0, $f8LYQ.isHTMLElement)(offsetParent)) {
            const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent);
            scale = $bc36f1aefc070984$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, true) : (0, $cVo0M.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $bc36f1aefc070984$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $bc36f1aefc070984$var$getDocumentRect(element) {
    const html = (0, $f8LYQ.getDocumentElement)(element);
    const scroll = (0, $f8LYQ.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $cVo0M.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $cVo0M.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $bc36f1aefc070984$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $f8LYQ.getComputedStyle)(body).direction === 'rtl') x += (0, $cVo0M.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $bc36f1aefc070984$var$getViewportRect(element, strategy) {
    const win = (0, $f8LYQ.getWindow)(element);
    const html = (0, $f8LYQ.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $f8LYQ.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $bc36f1aefc070984$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $f8LYQ.isHTMLElement)(element) ? $bc36f1aefc070984$var$getScale(element) : (0, $cVo0M.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $bc36f1aefc070984$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $bc36f1aefc070984$var$getDocumentRect((0, $f8LYQ.getDocumentElement)(element));
    else if ((0, $f8LYQ.isElement)(clippingAncestor)) rect = $bc36f1aefc070984$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $bc36f1aefc070984$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $cVo0M.rectToClientRect)(rect);
}
function $bc36f1aefc070984$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $f8LYQ.getParentNode)(element);
    if (parentNode === stopNode || !(0, $f8LYQ.isElement)(parentNode) || (0, $f8LYQ.isLastTraversableNode)(parentNode)) return false;
    return (0, $f8LYQ.getComputedStyle)(parentNode).position === 'fixed' || $bc36f1aefc070984$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $bc36f1aefc070984$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $f8LYQ.getOverflowAncestors)(element, [], false).filter((el)=>(0, $f8LYQ.isElement)(el) && (0, $f8LYQ.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $f8LYQ.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $f8LYQ.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $f8LYQ.isElement)(currentNode) && !(0, $f8LYQ.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $f8LYQ.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $f8LYQ.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, $f8LYQ.isOverflowElement)(currentNode) && !currentNodeIsContaining && $bc36f1aefc070984$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $f8LYQ.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $bc36f1aefc070984$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $f8LYQ.isTopLayer)(element) ? [] : $bc36f1aefc070984$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $cVo0M.max)(rect.top, accRect.top);
        accRect.right = (0, $cVo0M.min)(rect.right, accRect.right);
        accRect.bottom = (0, $cVo0M.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $cVo0M.max)(rect.left, accRect.left);
        return accRect;
    }, $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $bc36f1aefc070984$var$getDimensions(element) {
    const { width: width, height: height } = $bc36f1aefc070984$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $bc36f1aefc070984$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $f8LYQ.isHTMLElement)(offsetParent);
    const documentElement = (0, $f8LYQ.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $cVo0M.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $f8LYQ.getNodeName)(offsetParent) !== 'body' || (0, $f8LYQ.isOverflowElement)(documentElement)) scroll = (0, $f8LYQ.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $bc36f1aefc070984$var$getWindowScrollBarX(documentElement);
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll) : (0, $cVo0M.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $bc36f1aefc070984$var$isStaticPositioned(element) {
    return (0, $f8LYQ.getComputedStyle)(element).position === 'static';
}
function $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $f8LYQ.isHTMLElement)(element) || (0, $f8LYQ.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $f8LYQ.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $bc36f1aefc070984$var$getOffsetParent(element, polyfill) {
    const win = (0, $f8LYQ.getWindow)(element);
    if ((0, $f8LYQ.isTopLayer)(element)) return win;
    if (!(0, $f8LYQ.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $f8LYQ.getParentNode)(element);
        while(svgOffsetParent && !(0, $f8LYQ.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $f8LYQ.isElement)(svgOffsetParent) && !$bc36f1aefc070984$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $f8LYQ.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $f8LYQ.isTableElement)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent))offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $f8LYQ.isLastTraversableNode)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent) && !(0, $f8LYQ.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $f8LYQ.getContainingBlock)(element) || win;
}
const $bc36f1aefc070984$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $bc36f1aefc070984$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $bc36f1aefc070984$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $bc36f1aefc070984$var$isRTL(element) {
    return (0, $f8LYQ.getComputedStyle)(element).direction === 'rtl';
}
const $bc36f1aefc070984$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $f8LYQ.getDocumentElement,
    getClippingRect: $bc36f1aefc070984$var$getClippingRect,
    getOffsetParent: $bc36f1aefc070984$var$getOffsetParent,
    getElementRects: $bc36f1aefc070984$var$getElementRects,
    getClientRects: $bc36f1aefc070984$var$getClientRects,
    getDimensions: $bc36f1aefc070984$var$getDimensions,
    getScale: $bc36f1aefc070984$var$getScale,
    isElement: $f8LYQ.isElement,
    isRTL: $bc36f1aefc070984$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $bc36f1aefc070984$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $f8LYQ.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $cVo0M.floor)(top);
        const insetRight = (0, $cVo0M.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $cVo0M.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $cVo0M.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $cVo0M.max)(0, (0, $cVo0M.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $bc36f1aefc070984$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $bc36f1aefc070984$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $f8LYQ.getOverflowAncestors)(referenceEl) : [],
        ...(0, $f8LYQ.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $bc36f1aefc070984$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $bc36f1aefc070984$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $bc36f1aefc070984$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $bc36f1aefc070984$export$37b6bde19b108ecc = (0, $gSfPF.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $bc36f1aefc070984$export$cc800923e997bb8 = (0, $gSfPF.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $bc36f1aefc070984$export$91fb6ecbd551914 = (0, $gSfPF.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $bc36f1aefc070984$export$fba63a578e423eb = (0, $gSfPF.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $bc36f1aefc070984$export$8a83211c878a3f1f = (0, $gSfPF.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $bc36f1aefc070984$export$346677f925de839c = (0, $gSfPF.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $bc36f1aefc070984$export$fe8985bb6374093c = (0, $gSfPF.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $bc36f1aefc070984$export$f2120bbfa5450bd2 = (0, $gSfPF.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $bc36f1aefc070984$export$18c8ad048e32c7d5 = (0, $gSfPF.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $bc36f1aefc070984$export$7bf07e38f3dc4b69 = (0, $gSfPF.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $bc36f1aefc070984$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $bc36f1aefc070984$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $gSfPF.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("gSfPF", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $c48df878d8118962$export$48a53dcb22e581d0);
$parcel$export(module.exports, "detectOverflow", () => $c48df878d8118962$export$37b6bde19b108ecc);
$parcel$export(module.exports, "arrow", () => $c48df878d8118962$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "autoPlacement", () => $c48df878d8118962$export$91fb6ecbd551914);
$parcel$export(module.exports, "flip", () => $c48df878d8118962$export$8a83211c878a3f1f);
$parcel$export(module.exports, "hide", () => $c48df878d8118962$export$fe8985bb6374093c);
$parcel$export(module.exports, "inline", () => $c48df878d8118962$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "offset", () => $c48df878d8118962$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $c48df878d8118962$export$fba63a578e423eb);
$parcel$export(module.exports, "limitShift", () => $c48df878d8118962$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "size", () => $c48df878d8118962$export$346677f925de839c);
$parcel$export(module.exports, "rectToClientRect", () => (parcelRequire("cVo0M")).rectToClientRect);

var $cVo0M = parcelRequire("cVo0M");
function $c48df878d8118962$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $cVo0M.getSideAxis)(placement);
    const alignmentAxis = (0, $cVo0M.getAlignmentAxis)(placement);
    const alignLength = (0, $cVo0M.getAxisLength)(alignmentAxis);
    const side = (0, $cVo0M.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $cVo0M.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $c48df878d8118962$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $c48df878d8118962$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $cVo0M.evaluate)(options, state);
    const paddingObject = (0, $cVo0M.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $cVo0M.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $cVo0M.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $c48df878d8118962$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $cVo0M.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $cVo0M.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $cVo0M.getAlignmentAxis)(placement);
            const length = (0, $cVo0M.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $cVo0M.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $cVo0M.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $cVo0M.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $cVo0M.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $c48df878d8118962$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $cVo0M.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $cVo0M.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $cVo0M.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $cVo0M.getAlignment)(placement) === alignment || (autoAlignment ? (0, $cVo0M.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $c48df878d8118962$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $cVo0M.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $cVo0M.placements) ? $c48df878d8118962$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $cVo0M.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $cVo0M.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $cVo0M.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $cVo0M.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $c48df878d8118962$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $cVo0M.getSide)(placement);
            const initialSideAxis = (0, $cVo0M.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $cVo0M.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $cVo0M.getOppositePlacement)(initialPlacement)
            ] : (0, $cVo0M.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $cVo0M.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $cVo0M.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $cVo0M.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $c48df878d8118962$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $c48df878d8118962$var$isAnySideFullyClipped(overflow) {
    return (0, $cVo0M.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $c48df878d8118962$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $c48df878d8118962$var$getBoundingRect(rects) {
    const minX = (0, $cVo0M.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $cVo0M.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $cVo0M.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $cVo0M.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $c48df878d8118962$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $cVo0M.rectToClientRect)($c48df878d8118962$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $c48df878d8118962$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $cVo0M.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $c48df878d8118962$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $cVo0M.rectToClientRect)($c48df878d8118962$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $cVo0M.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $cVo0M.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $cVo0M.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $cVo0M.getSide)(placement) === 'left';
                    const maxRight = (0, $cVo0M.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $cVo0M.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $c48df878d8118962$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $cVo0M.getSide)(placement);
    const alignment = (0, $cVo0M.getAlignment)(placement);
    const isVertical = (0, $cVo0M.getSideAxis)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $cVo0M.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $c48df878d8118962$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $c48df878d8118962$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $c48df878d8118962$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $cVo0M.getSideAxis)((0, $cVo0M.getSide)(placement));
            const mainAxis = (0, $cVo0M.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $cVo0M.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $cVo0M.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $c48df878d8118962$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $cVo0M.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $cVo0M.getSideAxis)(placement);
            const mainAxis = (0, $cVo0M.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $cVo0M.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, $cVo0M.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $c48df878d8118962$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $cVo0M.getSide)(placement);
            const alignment = (0, $cVo0M.getAlignment)(placement);
            const isYAxis = (0, $cVo0M.getSideAxis)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $cVo0M.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $cVo0M.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $cVo0M.max)(overflow.left, 0);
                const xMax = (0, $cVo0M.max)(overflow.right, 0);
                const yMin = (0, $cVo0M.max)(overflow.top, 0);
                const yMax = (0, $cVo0M.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $cVo0M.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $cVo0M.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("cVo0M", function(module, exports) {

$parcel$export(module.exports, "sides", () => $968d6f1d7e429938$export$832b6fa47fa053d2);
$parcel$export(module.exports, "placements", () => $968d6f1d7e429938$export$803cd8101b6c182b);
$parcel$export(module.exports, "min", () => $968d6f1d7e429938$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $968d6f1d7e429938$export$8960430cfd85939f);
$parcel$export(module.exports, "round", () => $968d6f1d7e429938$export$2077e0241d6afd3c);
$parcel$export(module.exports, "floor", () => $968d6f1d7e429938$export$a3fe094919f356fd);
$parcel$export(module.exports, "createCoords", () => $968d6f1d7e429938$export$a397704b5e280835);
$parcel$export(module.exports, "clamp", () => $968d6f1d7e429938$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "evaluate", () => $968d6f1d7e429938$export$fef61f332f2c0afc);
$parcel$export(module.exports, "getSide", () => $968d6f1d7e429938$export$3c915306cb7fc97a);
$parcel$export(module.exports, "getAlignment", () => $968d6f1d7e429938$export$f0989780f32bfcda);
$parcel$export(module.exports, "getOppositeAxis", () => $968d6f1d7e429938$export$8a000a963141ac32);
$parcel$export(module.exports, "getAxisLength", () => $968d6f1d7e429938$export$320bd9d53520c68a);
$parcel$export(module.exports, "getSideAxis", () => $968d6f1d7e429938$export$f28e8f882010718a);
$parcel$export(module.exports, "getAlignmentAxis", () => $968d6f1d7e429938$export$2b57e0052a6d6d4c);
$parcel$export(module.exports, "getAlignmentSides", () => $968d6f1d7e429938$export$be42861551f17911);
$parcel$export(module.exports, "getOppositePlacement", () => $968d6f1d7e429938$export$9c5e28bad23365fa);
$parcel$export(module.exports, "getExpandedPlacements", () => $968d6f1d7e429938$export$496432a3699e50b1);
$parcel$export(module.exports, "getOppositeAlignmentPlacement", () => $968d6f1d7e429938$export$2b182c584985588b);
$parcel$export(module.exports, "getOppositeAxisPlacements", () => $968d6f1d7e429938$export$a9b6fb18fd92c3ec);
$parcel$export(module.exports, "getPaddingObject", () => $968d6f1d7e429938$export$598c291c29bc2e71);
$parcel$export(module.exports, "rectToClientRect", () => $968d6f1d7e429938$export$ee05aea0aeecbad4);
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $968d6f1d7e429938$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $968d6f1d7e429938$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $968d6f1d7e429938$export$803cd8101b6c182b = /*#__PURE__*/ $968d6f1d7e429938$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[0], side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[1]), []);
const $968d6f1d7e429938$export$96ec731ed4dcb222 = Math.min;
const $968d6f1d7e429938$export$8960430cfd85939f = Math.max;
const $968d6f1d7e429938$export$2077e0241d6afd3c = Math.round;
const $968d6f1d7e429938$export$a3fe094919f356fd = Math.floor;
const $968d6f1d7e429938$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $968d6f1d7e429938$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $968d6f1d7e429938$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $968d6f1d7e429938$export$7d15b64cf5a3a4c4(start, value, end) {
    return $968d6f1d7e429938$export$8960430cfd85939f(start, $968d6f1d7e429938$export$96ec731ed4dcb222(value, end));
}
function $968d6f1d7e429938$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $968d6f1d7e429938$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $968d6f1d7e429938$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $968d6f1d7e429938$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $968d6f1d7e429938$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $968d6f1d7e429938$export$f28e8f882010718a(placement) {
    return [
        'top',
        'bottom'
    ].includes($968d6f1d7e429938$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement) {
    return $968d6f1d7e429938$export$8a000a963141ac32($968d6f1d7e429938$export$f28e8f882010718a(placement));
}
function $968d6f1d7e429938$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
    const alignmentAxis = $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement);
    const length = $968d6f1d7e429938$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $968d6f1d7e429938$export$496432a3699e50b1(placement) {
    const oppositePlacement = $968d6f1d7e429938$export$9c5e28bad23365fa(placement);
    return [
        $968d6f1d7e429938$export$2b182c584985588b(placement),
        oppositePlacement,
        $968d6f1d7e429938$export$2b182c584985588b(oppositePlacement)
    ];
}
function $968d6f1d7e429938$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$968d6f1d7e429938$var$oppositeAlignmentMap[alignment]);
}
function $968d6f1d7e429938$var$getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $968d6f1d7e429938$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
    let list = $968d6f1d7e429938$var$getSideList($968d6f1d7e429938$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($968d6f1d7e429938$export$2b182c584985588b));
    }
    return list;
}
function $968d6f1d7e429938$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$968d6f1d7e429938$var$oppositeSideMap[side]);
}
function $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $968d6f1d7e429938$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $968d6f1d7e429938$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("f8LYQ", function(module, exports) {

$parcel$export(module.exports, "getNodeName", () => $b05cd24baa7455b6$export$651544f548703224);
$parcel$export(module.exports, "getWindow", () => $b05cd24baa7455b6$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getDocumentElement", () => $b05cd24baa7455b6$export$e495491855dc5418);
$parcel$export(module.exports, "isElement", () => $b05cd24baa7455b6$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $b05cd24baa7455b6$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isOverflowElement", () => $b05cd24baa7455b6$export$989e911fa9af580a);
$parcel$export(module.exports, "getComputedStyle", () => $b05cd24baa7455b6$export$3735103072e4a80);
$parcel$export(module.exports, "isTableElement", () => $b05cd24baa7455b6$export$71535ffaa902797f);
$parcel$export(module.exports, "isTopLayer", () => $b05cd24baa7455b6$export$89e651af02346cd4);
$parcel$export(module.exports, "isContainingBlock", () => $b05cd24baa7455b6$export$d6c4e8150c35fed1);
$parcel$export(module.exports, "isWebKit", () => $b05cd24baa7455b6$export$78551043582a6a98);
$parcel$export(module.exports, "getContainingBlock", () => $b05cd24baa7455b6$export$940d8225183e1404);
$parcel$export(module.exports, "getParentNode", () => $b05cd24baa7455b6$export$4e12058fc4d51d56);
$parcel$export(module.exports, "isLastTraversableNode", () => $b05cd24baa7455b6$export$d1162fb0b6d4cd51);
$parcel$export(module.exports, "getNodeScroll", () => $b05cd24baa7455b6$export$dc8fc79fa2800137);
$parcel$export(module.exports, "getOverflowAncestors", () => $b05cd24baa7455b6$export$3b57c1601291186b);
$parcel$export(module.exports, "getFrameElement", () => $b05cd24baa7455b6$export$7bf1f8740e3e34af);
function $b05cd24baa7455b6$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $b05cd24baa7455b6$export$651544f548703224(node) {
    if ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $b05cd24baa7455b6$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $b05cd24baa7455b6$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $b05cd24baa7455b6$export$8ee0fc9ee280b4ee(value) {
    if (!$b05cd24baa7455b6$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Node;
}
function $b05cd24baa7455b6$export$45a5e7f76e0caa8d(value) {
    if (!$b05cd24baa7455b6$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Element;
}
function $b05cd24baa7455b6$export$1b3bfaa9684536aa(value) {
    if (!$b05cd24baa7455b6$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).HTMLElement;
}
function $b05cd24baa7455b6$export$af51f0f06c0f328a(value) {
    if (!$b05cd24baa7455b6$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $b05cd24baa7455b6$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $b05cd24baa7455b6$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function $b05cd24baa7455b6$export$71535ffaa902797f(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($b05cd24baa7455b6$export$651544f548703224(element));
}
function $b05cd24baa7455b6$export$89e651af02346cd4(element) {
    return [
        ':popover-open',
        ':modal'
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $b05cd24baa7455b6$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $b05cd24baa7455b6$export$78551043582a6a98();
    const css = $b05cd24baa7455b6$export$45a5e7f76e0caa8d(elementOrCss) ? $b05cd24baa7455b6$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function $b05cd24baa7455b6$export$940d8225183e1404(element) {
    let currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(element);
    while($b05cd24baa7455b6$export$1b3bfaa9684536aa(currentNode) && !$b05cd24baa7455b6$export$d1162fb0b6d4cd51(currentNode)){
        if ($b05cd24baa7455b6$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($b05cd24baa7455b6$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $b05cd24baa7455b6$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function $b05cd24baa7455b6$export$d1162fb0b6d4cd51(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes($b05cd24baa7455b6$export$651544f548703224(node));
}
function $b05cd24baa7455b6$export$3735103072e4a80(element) {
    return $b05cd24baa7455b6$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $b05cd24baa7455b6$export$dc8fc79fa2800137(element) {
    if ($b05cd24baa7455b6$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $b05cd24baa7455b6$export$4e12058fc4d51d56(node) {
    if ($b05cd24baa7455b6$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $b05cd24baa7455b6$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $b05cd24baa7455b6$export$e495491855dc5418(node);
    return $b05cd24baa7455b6$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $b05cd24baa7455b6$export$7cd01a57c8ca906c(node) {
    const parentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(node);
    if ($b05cd24baa7455b6$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($b05cd24baa7455b6$export$1b3bfaa9684536aa(parentNode) && $b05cd24baa7455b6$export$989e911fa9af580a(parentNode)) return parentNode;
    return $b05cd24baa7455b6$export$7cd01a57c8ca906c(parentNode);
}
function $b05cd24baa7455b6$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $b05cd24baa7455b6$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $b05cd24baa7455b6$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $b05cd24baa7455b6$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $b05cd24baa7455b6$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $b05cd24baa7455b6$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $b05cd24baa7455b6$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $b05cd24baa7455b6$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});


parcelRegister("hrqx3", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb2989fd9beaabfa$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
var $cb2989fd9beaabfa$export$2e2bcd8739ae039 = (0, $5uXOq.useLayoutEffect);

});



parcelRegister("hqcPo", function(module, exports) {

$parcel$export(module.exports, "multiValueCSS", () => $20933ad7b05a0c37$export$23c213f7717186af);
$parcel$export(module.exports, "multiValueLabelCSS", () => $20933ad7b05a0c37$export$f40612612e0af964);
$parcel$export(module.exports, "multiValueRemoveCSS", () => $20933ad7b05a0c37$export$283467f6c4ac142b);
$parcel$export(module.exports, "MultiValueContainer", () => $20933ad7b05a0c37$export$cf9cf2a30a59265c);
$parcel$export(module.exports, "MultiValueLabel", () => $20933ad7b05a0c37$export$544aeea2a5ce08ee);
$parcel$export(module.exports, "MultiValueRemove", () => $20933ad7b05a0c37$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "default", () => $20933ad7b05a0c37$export$2e2bcd8739ae039);
/* multi-value.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $iBgL9 = parcelRequire("iBgL9");
const $20933ad7b05a0c37$export$23c213f7717186af = (props)=>(0, $iBgL9.multiValueCSS)();
const $20933ad7b05a0c37$export$f40612612e0af964 = (props)=>(0, $iBgL9.multiValueLabelCSS)();
const $20933ad7b05a0c37$export$283467f6c4ac142b = (props)=>(0, $iBgL9.multiValueRemoveCSS)();
const $20933ad7b05a0c37$export$cf9cf2a30a59265c = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $iBgL9.MultiValueContainer), {
        ...props
    });
const $20933ad7b05a0c37$export$544aeea2a5ce08ee = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $iBgL9.MultiValueLabel), {
        ...props
    });
function $20933ad7b05a0c37$export$8e1fd1a40e7a2f4a(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iBgL9.MultiValueRemove), {
        ...props
    });
}
const $20933ad7b05a0c37$var$MultiValue = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $iBgL9.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$20933ad7b05a0c37$export$2e2bcd8739ae039 = $20933ad7b05a0c37$var$MultiValue;

});
parcelRegister("iBgL9", function(module, exports) {

$parcel$export(module.exports, "multiValueCSS", () => $a2bd6c7425e95809$export$23c213f7717186af);
$parcel$export(module.exports, "multiValueLabelCSS", () => $a2bd6c7425e95809$export$f40612612e0af964);
$parcel$export(module.exports, "multiValueRemoveCSS", () => $a2bd6c7425e95809$export$283467f6c4ac142b);
$parcel$export(module.exports, "MultiValueContainer", () => $a2bd6c7425e95809$export$cf9cf2a30a59265c);
$parcel$export(module.exports, "MultiValueLabel", () => $a2bd6c7425e95809$export$544aeea2a5ce08ee);
$parcel$export(module.exports, "MultiValueRemove", () => $a2bd6c7425e95809$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "default", () => $a2bd6c7425e95809$export$2e2bcd8739ae039);
/* multi-value.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $i28qQ = parcelRequire("i28qQ");

var $673MF = parcelRequire("673MF");

var $VSDnB = parcelRequire("VSDnB");

var $gyjU7 = parcelRequire("gyjU7");
const $a2bd6c7425e95809$var$multiValueStyles = {
    root: "_2rkogqwt _1e0c1txw _1ul9ze3t _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _bfhkm7j4 _p12f1osq _syazjpor _3yq3glyw",
    disabled: "_syaz1lh4 _bfhkm7j4",
    focused: "_syaz1wum _bfhkfg4m _16qs17si _1aewe4h9 _6up53acm _1xdnnqa1",
    refresh: "_2rkoiti9 _1h6d14je _1dqonqa1 _189ee4h9 _bfhk1j9a"
};
const $a2bd6c7425e95809$export$23c213f7717186af = ()=>({});
const $a2bd6c7425e95809$export$f40612612e0af964 = ()=>({});
const $a2bd6c7425e95809$var$multiValueLabelStyles = {
    root: "_1reo15vq _18m915vq _2rkogqwt _11c8dcr7 _o5721q9c _ca0qv77o _u5f3v77o _n3tdv77o _19bv12x7 _syaz1kw7",
    disabled: "_syaz1lh4",
    ellipsis: "_1bto1l2s",
    refresh: "_11c82smr _ca0qidpf _n3tdidpf _19bv1b66"
};
const $a2bd6c7425e95809$export$283467f6c4ac142b = ()=>({});
const $a2bd6c7425e95809$var$multiValueRemoveStyles = {
    focused: "_bfhk1km6 _lswu1rrc",
    root: "_2rkovtp2 _4cvr1h6o _1e0c1txw _lswu1dx5 _19bvv77o _u5f3v77o _irr31yvi _13br1jjn _1di61io2 _i5f81jjn",
    refresh: "_19itglyw _2rkoglpi _bfhk1w7a _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _syaz1fxt _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _2hwxv77o _1ah312gs _irr3166n _1di61dty"
};
const $a2bd6c7425e95809$export$cf9cf2a30a59265c = ({ children: children, innerProps: innerProps, isFocused: isFocused, isDisabled: isDisabled, className: className, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $a2bd6c7425e95809$var$multiValueStyles.root,
            isDisabled && $a2bd6c7425e95809$var$multiValueStyles.disabled,
            isFocused && $a2bd6c7425e95809$var$multiValueStyles.focused,
            (0, $VSDnB.fg)('platform-component-visual-refresh') && $a2bd6c7425e95809$var$multiValueStyles.refresh,
            (0, $DEWI6.cx)(className, xcss, '-multiValue')
        ]),
        children: children
    });
};
const $a2bd6c7425e95809$export$544aeea2a5ce08ee = ({ children: children, innerProps: innerProps, isDisabled: isDisabled, hasEllipsis: hasEllipsis, className: className, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $a2bd6c7425e95809$var$multiValueLabelStyles.root,
            isDisabled && $a2bd6c7425e95809$var$multiValueLabelStyles.disabled,
            hasEllipsis && $a2bd6c7425e95809$var$multiValueLabelStyles.ellipsis,
            (0, $VSDnB.fg)('platform-component-visual-refresh') && $a2bd6c7425e95809$var$multiValueLabelStyles.refresh,
            (0, $DEWI6.cx)(className, xcss, '-MultiValueLabel')
        ]),
        children: children
    });
};
const $a2bd6c7425e95809$var$disabledStyles = null;
const $a2bd6c7425e95809$var$enabledStyles = null;
function $a2bd6c7425e95809$export$8e1fd1a40e7a2f4a({ isDisabled: isDisabled, isFocused: isFocused, innerProps: innerProps, className: className, xcss: xcss }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $a2bd6c7425e95809$var$multiValueRemoveStyles.root,
            isFocused && $a2bd6c7425e95809$var$multiValueRemoveStyles.focused,
            (0, $VSDnB.fg)('platform-component-visual-refresh') && $a2bd6c7425e95809$var$multiValueRemoveStyles.refresh,
            (0, $DEWI6.cx)(className, xcss, '-MultiValueRemove')
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon',
            className: (0, $bwpsq.default)([
                isDisabled && "_1e0cglyw",
                !isDisabled && "_1e0c1kw7"
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i28qQ))), {
                label: "",
                color: "currentColor",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($673MF))),
                LEGACY_primaryColor: "transparent",
                LEGACY_secondaryColor: "inherit",
                LEGACY_size: "small",
                size: "small"
            })
        })
    });
}
const $a2bd6c7425e95809$var$MultiValue = (props)=>{
    const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, isFocused: isFocused, removeProps: removeProps, selectProps: selectProps, cropWithEllipsis: cropWithEllipsis } = props;
    const { Container: Container, Label: Label, Remove: Remove } = components;
    const ariaLabel = typeof children === 'string' ? children : data.label;
    const { css: containerCss, className: containerClassName } = (0, $gyjU7.getStyleProps)(props, 'multiValue', {
        'multi-value': true,
        'multi-value--is-disabled': isDisabled
    });
    const { css: labelCss, className: labelClassName } = (0, $gyjU7.getStyleProps)(props, 'multiValueLabel', {
        'multi-value__label': true
    });
    const { css: removeCss, className: removeClassName } = (0, $gyjU7.getStyleProps)(props, 'multiValueRemove', {
        'multi-value__remove': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)(Container, {
        data: data,
        innerProps: {
            style: containerCss,
            className: containerClassName,
            ...innerProps
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: containerClassName,
        isFocused: isFocused,
        isDisabled: isDisabled,
        selectProps: selectProps,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)(Label, {
                data: data,
                innerProps: {
                    style: labelCss,
                    className: labelClassName
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: labelClassName,
                hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
                selectProps: selectProps,
                children: children
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)(Remove, {
                data: data,
                innerProps: {
                    style: removeCss,
                    className: removeClassName,
                    role: 'button',
                    tabIndex: -1,
                    'aria-label': `${ariaLabel || 'option'}, remove`,
                    ...removeProps
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: removeClassName,
                isDisabled: isDisabled,
                selectProps: selectProps
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a2bd6c7425e95809$export$2e2bcd8739ae039 = $a2bd6c7425e95809$var$MultiValue;

});


parcelRegister("8l2RA", function(module, exports) {

$parcel$export(module.exports, "optionCSS", () => $6e6d67a90b457dc1$export$ef897119b7e920ba);
$parcel$export(module.exports, "default", () => $6e6d67a90b457dc1$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3ttih = parcelRequire("3ttih");
const $6e6d67a90b457dc1$export$ef897119b7e920ba = (props)=>(0, $3ttih.optionCSS)();
const $6e6d67a90b457dc1$var$Option = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3ttih.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6e6d67a90b457dc1$export$2e2bcd8739ae039 = $6e6d67a90b457dc1$var$Option;

});
parcelRegister("3ttih", function(module, exports) {

$parcel$export(module.exports, "optionCSS", () => $067c79fba4bdfbb2$export$ef897119b7e920ba);
$parcel$export(module.exports, "default", () => $067c79fba4bdfbb2$export$2e2bcd8739ae039);
/* option.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $gyjU7 = parcelRequire("gyjU7");
const $067c79fba4bdfbb2$export$ef897119b7e920ba = ()=>({});
const $067c79fba4bdfbb2$var$optionStyles = {
    root: "_1rjc12x7 _18zrutpp _syaz1fxt _80om73ad _1e0c1ule _1wyb1kw7 _1bsb1osq _uiztglyw _18ql1j7p _1di61dty",
    disabled: "_syaz1lh4 _80om13gf _bfhk18uv _16qsglyw _1di618uv _1pknglyw",
    focused: "_bfhk166n _16qsu4to _1pknj1ic",
    selected: "_syazaqb7 _bfhkfg4m _16qsu4to _1di619ru _1pknj1ic",
    focusedSelected: "_bfhki1yw"
};
const $067c79fba4bdfbb2$var$Option = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $067c79fba4bdfbb2$var$optionStyles.root,
            isFocused && $067c79fba4bdfbb2$var$optionStyles.focused,
            isSelected && $067c79fba4bdfbb2$var$optionStyles.selected,
            isFocused && isSelected && $067c79fba4bdfbb2$var$optionStyles.focusedSelected,
            isDisabled && $067c79fba4bdfbb2$var$optionStyles.disabled,
            (0, $DEWI6.cx)(className, xcss, '-option')
        ]),
        ref: innerRef,
        ...innerProps,
        tabIndex: -1,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$067c79fba4bdfbb2$export$2e2bcd8739ae039 = $067c79fba4bdfbb2$var$Option;

});


parcelRegister("kKm82", function(module, exports) {

$parcel$export(module.exports, "placeholderCSS", () => $889d652a9d0dc097$export$5f3ffacd6594d90f);
$parcel$export(module.exports, "default", () => $889d652a9d0dc097$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dw3lH = parcelRequire("dw3lH");
const $889d652a9d0dc097$export$5f3ffacd6594d90f = (props)=>(0, $dw3lH.placeholderCSS)();
const $889d652a9d0dc097$var$Placeholder = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dw3lH.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$889d652a9d0dc097$export$2e2bcd8739ae039 = $889d652a9d0dc097$var$Placeholder;

});
parcelRegister("dw3lH", function(module, exports) {

$parcel$export(module.exports, "placeholderCSS", () => $7011c54f7352f26b$export$5f3ffacd6594d90f);
$parcel$export(module.exports, "default", () => $7011c54f7352f26b$export$2e2bcd8739ae039);
/* placeholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $gyjU7 = parcelRequire("gyjU7");
const $7011c54f7352f26b$export$5f3ffacd6594d90f = ()=>({});
const $7011c54f7352f26b$var$placeholderStyles = {
    root: "_nd5l1sux _19pkidpf _2hwxv77o _otyridpf _18u0v77o _syaz131l",
    disabled: "_syaz1lh4"
};
const $7011c54f7352f26b$var$Placeholder = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'placeholder', {
        placeholder: true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $7011c54f7352f26b$var$placeholderStyles.root,
            isDisabled && $7011c54f7352f26b$var$placeholderStyles.disabled,
            (0, $DEWI6.cx)(className, xcss, '-placeholder')
        ]),
        ...innerProps,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7011c54f7352f26b$export$2e2bcd8739ae039 = $7011c54f7352f26b$var$Placeholder;

});


parcelRegister("hpcbi", function(module, exports) {

$parcel$export(module.exports, "css", () => $aff94346c62a222f$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $aff94346c62a222f$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5Zgwp = parcelRequire("5Zgwp");
const $aff94346c62a222f$export$dbf350e5966cf602 = (props)=>(0, $5Zgwp.css)();
const $aff94346c62a222f$var$SingleValue = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5Zgwp.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$aff94346c62a222f$export$2e2bcd8739ae039 = $aff94346c62a222f$var$SingleValue;

});
parcelRegister("5Zgwp", function(module, exports) {

$parcel$export(module.exports, "css", () => $11f234ca28812396$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $11f234ca28812396$export$2e2bcd8739ae039);
/* single-value.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $gyjU7 = parcelRequire("gyjU7");
const $11f234ca28812396$export$dbf350e5966cf602 = ()=>({});
const $11f234ca28812396$var$styles = {
    root: "_nd5l1sux _1reo15vq _18m915vq _p12f1osq _1bto1l2s _o5721q9c _19pkidpf _2hwxv77o _otyridpf _18u0v77o _syaz1fxt",
    disalbed: "_syaz1lh4"
};
const $11f234ca28812396$var$SingleValue = (props)=>{
    const { children: children, isDisabled: isDisabled, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $11f234ca28812396$var$styles.root,
            isDisabled && $11f234ca28812396$var$styles.disalbed,
            (0, $DEWI6.cx)(className, xcss, '-singleValue')
        ]),
        ...innerProps,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$11f234ca28812396$export$2e2bcd8739ae039 = $11f234ca28812396$var$SingleValue;

});



parcelRegister("7K5PP", function(module, exports) {

$parcel$export(module.exports, "SelectWithoutAnalytics", () => $c2d344e1481a2d3b$export$d1de3b251ccaa8a3);
$parcel$export(module.exports, "default", () => $c2d344e1481a2d3b$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gB4mS = parcelRequire("gB4mS");
var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $eAthk = parcelRequire("eAthk");

var $3c98u = parcelRequire("3c98u");
const $c2d344e1481a2d3b$var$packageName = "platform-pkg";
const $c2d344e1481a2d3b$var$packageVersion = "0.0.0-use.local";
const $c2d344e1481a2d3b$export$d1de3b251ccaa8a3 = (0, $3c98u.default)((0, $eAthk.default));
const $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit = (0, $gB4mS.default)('atlaskit');
const $c2d344e1481a2d3b$var$Select = (0, $994MI.default)({
    componentName: 'select',
    packageName: $c2d344e1481a2d3b$var$packageName,
    packageVersion: $c2d344e1481a2d3b$var$packageVersion
})((0, $cb25w.default)({
    onChange: $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $c2d344e1481a2d3b$var$packageName,
            packageVersion: $c2d344e1481a2d3b$var$packageVersion
        }
    })
})($c2d344e1481a2d3b$export$d1de3b251ccaa8a3));
var $c2d344e1481a2d3b$export$2e2bcd8739ae039 = $c2d344e1481a2d3b$var$Select;

});
parcelRegister("eAthk", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d0cf20527a3a891$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useAsync", () => (parcelRequire("iaInK")).default);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2QhWf = parcelRequire("2QhWf");

var $iaInK = parcelRequire("iaInK");

var $9uJ4X = parcelRequire("9uJ4X");
const $6d0cf20527a3a891$var$AsyncSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    // when isAsync is true, options are not provided and async props are used, we will enable async
    const isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
    const stateManagedProps = (0, $iaInK.default)(props);
    // when isAsync is falsy or isAsyncEnabledInBaseSelect is true, we use async props, otherwise we use base props
    let selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
    const selectProps = (0, $9uJ4X.default)(selectAsyncProps);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2QhWf.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6d0cf20527a3a891$export$2e2bcd8739ae039 = $6d0cf20527a3a891$var$AsyncSelect;

});
parcelRegister("2QhWf", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8e863683b34816f$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2Z7Iz = parcelRequire("2Z7Iz");

var $VSDnB = parcelRequire("VSDnB");

var $eEtcC = parcelRequire("eEtcC");

var $bChGW = parcelRequire("bChGW");

var $jtVgE = parcelRequire("jtVgE");
var $9cRAr = parcelRequire("9cRAr");
var $galqx = parcelRequire("galqx");

var $7uagk = parcelRequire("7uagk");

var $81i5b = parcelRequire("81i5b");

var $aA8TC = parcelRequire("aA8TC");

var $5JAlL = parcelRequire("5JAlL");

var $7VXAu = parcelRequire("7VXAu");

var $gyjU7 = parcelRequire("gyjU7");
const $d8e863683b34816f$export$9c21a3269931e1e6 = {
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $gyjU7.isTouchCapable)(),
    captureMenuScroll: !(0, $gyjU7.isTouchCapable)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $5JAlL.createFilter)(),
    formatGroupLabel: (0, $eEtcC.formatGroupLabel),
    getOptionLabel: (0, $eEtcC.getOptionLabel),
    getOptionValue: (0, $eEtcC.getOptionValue),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $eEtcC.isOptionDisabled),
    loadingMessage: ()=>'Loading...',
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $gyjU7.isMobileDevice)(),
    noOptionsMessage: ()=>'No options',
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    UNSAFE_is_experimental_generic: false
};
function $d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, index) {
    const isDisabled = $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue);
    const isSelected = $d8e863683b34816f$var$isOptionSelected(props, option, selectValue);
    const label = $d8e863683b34816f$var$getOptionLabel(props, option);
    const value = $d8e863683b34816f$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $d8e863683b34816f$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map((groupOrOption, groupOrOptionIndex)=>{
        //@ts-ignore
        if ('options' in groupOrOption) {
            const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$d8e863683b34816f$var$isFocusable(props, categorizedOption));
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        const categorizedOption = $d8e863683b34816f$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $d8e863683b34816f$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $gyjU7.notNullish));
}
function $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $d8e863683b34816f$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                data: option.data,
                id: `${optionId}-${categorizedOption.index}-${option.index}`
            })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: `${optionId}-${categorizedOption.index}`
        });
        return optionsAccumulator;
    }, []);
}
function $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) {
    return $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue));
}
function $d8e863683b34816f$var$isFocusable(props, categorizedOption) {
    const { inputValue: inputValue = '' } = props;
    const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
    return (!$d8e863683b34816f$var$shouldHideSelectedOptions(props) || !isSelected) && $d8e863683b34816f$var$filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $d8e863683b34816f$var$getNextFocusedValue(state, nextSelectValue) {
    const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
    const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $d8e863683b34816f$var$getNextFocusedOption(state, options) {
    const { focusedOption: lastFocusedOption } = state;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
const $d8e863683b34816f$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
    const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
    return focusedOptionId || null;
};
const $d8e863683b34816f$var$getOptionLabel = (props, data)=>{
    return props.getOptionLabel(data);
};
const $d8e863683b34816f$var$getOptionValue = (props, data)=>{
    return props.getOptionValue(data);
};
function $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $d8e863683b34816f$var$isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    const candidate = $d8e863683b34816f$var$getOptionValue(props, option);
    return selectValue.some((i)=>$d8e863683b34816f$var$getOptionValue(props, i) === candidate);
}
function $d8e863683b34816f$var$filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
const $d8e863683b34816f$var$shouldHideSelectedOptions = (props)=>{
    const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
let $d8e863683b34816f$var$instanceId = 1;
class $d8e863683b34816f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = $d8e863683b34816f$export$9c21a3269931e1e6;
    }
    // Lifecycle
    // ------------------------------
    constructor(props){
        super(props), this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            focusedValueId: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        }, // Misc. Instance Properties
        // ------------------------------
        this.blockOptionHover = false, this.isComposing = false, this.initialTouchX = 0, this.initialTouchY = 0, this.openAfterFocus = false, this.scrollToFocusedOptionOnUpdate = false, // Refs
        // ------------------------------
        this.controlRef = null, this.getControlRef = (ref)=>{
            this.controlRef = ref;
        }, this.focusedOptionRef = null, this.getFocusedOptionRef = (ref)=>{
            this.focusedOptionRef = ref;
        }, this.menuListRef = null, this.getMenuListRef = (ref)=>{
            this.menuListRef = ref;
        }, this.inputRef = null, this.getInputRef = (ref)=>{
            this.inputRef = ref;
        }, // aliased for consumers
        this.focus = this.focusInput, this.blur = this.blurInput, this.onChange = (newValue, actionMeta)=>{
            const { onChange: onChange, name: name } = this.props;
            actionMeta.name = name;
            this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        }, this.setValue = (newValue, action, option)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
            this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            this.setState({
                clearFocusValueOnUpdate: true
            });
            this.onChange(newValue, {
                action: action,
                option: option
            });
        }, this.selectOption = (newValue)=>{
            const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
            const isDisabled = this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                const candidate = this.getOptionValue(newValue);
                this.setValue((0, $gyjU7.multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) this.setValue((0, $gyjU7.multiValueAsValue)([
                    ...selectValue,
                    newValue
                ]), 'select-option', newValue);
                else this.setValue((0, $gyjU7.singleValueAsValue)(newValue), 'select-option');
            } else {
                this.ariaOnChange((0, $gyjU7.singleValueAsValue)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) this.blurInput();
        }, this.removeValue = (removedValue)=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const candidate = this.getOptionValue(removedValue);
            const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
            const newValue = (0, $gyjU7.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            this.focusInput();
        }, this.clearValue = ()=>{
            const { selectValue: selectValue } = this.state;
            this.onChange((0, $gyjU7.valueTernary)(this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        }, this.popValue = ()=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const lastSelectedValue = selectValue[selectValue.length - 1];
            const newValueArray = selectValue.slice(0, selectValue.length - 1);
            const newValue = (0, $gyjU7.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        }, // ==============================
        // Getters
        // ==============================
        this.getFocusedOptionId = (focusedOption)=>{
            return $d8e863683b34816f$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
        }, this.getFocusableOptionsWithIds = ()=>{
            return $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
        }, this.getValue = ()=>this.state.selectValue, this.cx = (...args)=>(0, $gyjU7.classNames)(this.props.classNamePrefix, ...args), this.getOptionLabel = (data)=>{
            return $d8e863683b34816f$var$getOptionLabel(this.props, data);
        }, this.getOptionValue = (data)=>{
            return $d8e863683b34816f$var$getOptionValue(this.props, data);
        }, this.getStyles = (key, props)=>{
            const base = (0, $7VXAu.defaultStyles)[key](props);
            base.boxSizing = 'border-box';
            const custom = this.props.styles[key];
            if (!custom) return base;
            const customStyles = (0, $gyjU7.filterUnsupportedSelectors)(custom(base, props));
            return customStyles;
        }, this.getClassNames = (key, props)=>this.props.classNames[key]?.(props), this.getElementId = (element)=>{
            return `${this.state.instancePrefix}-${element}`;
        }, this.getComponents = ()=>{
            return (0, $bChGW.defaultComponents)(this.props);
        }, this.buildCategorizedOptions = ()=>$d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [], this.buildFocusableOptions = ()=>$d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions()), this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [], // ==============================
        // Helpers
        // ==============================
        this.ariaOnChange = (value, actionMeta)=>{
            this.setState({
                ariaSelection: {
                    value: value,
                    ...actionMeta
                }
            });
        }, // ==============================
        // Mouse Handlers
        // ==============================
        this.onMenuMouseDown = (event)=>{
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            this.focusInput();
        }, this.onMenuMouseMove = (event)=>{
            this.blockOptionHover = false;
        }, this.onControlMouseDown = (event)=>{
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
            }
            const { openMenuOnClick: openMenuOnClick } = this.props;
            if (!this.state.isFocused) {
                if (openMenuOnClick) this.openAfterFocus = true;
                this.focusInput();
            } else if (!this.props.menuIsOpen) {
                if (openMenuOnClick) this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        }, this.onDropdownIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (this.props.isDisabled) return;
            const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
            this.focusInput();
            if (menuIsOpen) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            } else this.openMenu('first');
            event.preventDefault();
        }, this.onClearIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            this.clearValue();
            event.preventDefault();
            this.openAfterFocus = false;
            if (event.type === 'touchend') this.focusInput();
            else setTimeout(()=>this.focusInput());
        }, this.onScroll = (event)=>{
            if (typeof this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $gyjU7.isDocumentElement)(event.target)) this.props.onMenuClose();
            } else if (typeof this.props.closeMenuOnScroll === 'function') {
                if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
            }
        }, this.onCompositionStart = ()=>{
            this.isComposing = true;
        }, this.onCompositionEnd = ()=>{
            this.isComposing = false;
        }, this.onTouchStart = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            this.initialTouchX = touch.clientX;
            this.initialTouchY = touch.clientY;
            this.userIsDragging = false;
        }, this.onTouchMove = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            const deltaX = Math.abs(touch.clientX - this.initialTouchX);
            const deltaY = Math.abs(touch.clientY - this.initialTouchY);
            const moveThreshold = 5;
            this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        }, this.onTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
            // reset move vars
            this.initialTouchX = 0;
            this.initialTouchY = 0;
        }, this.onControlTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onControlMouseDown(event);
        }, this.onClearIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onClearIndicatorMouseDown(event);
        }, this.onDropdownIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onDropdownIndicatorMouseDown(event);
        }, // ==============================
        // Focus Handlers
        // ==============================
        this.handleInputChange = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            const inputValue = event.currentTarget.value;
            this.setState({
                inputIsHiddenAfterUpdate: false
            });
            this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!this.props.menuIsOpen) this.onMenuOpen();
        }, this.onInputFocus = (event)=>{
            if (this.props.onFocus) this.props.onFocus(event);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (this.openAfterFocus || this.props.openMenuOnFocus) this.openMenu('first');
            this.openAfterFocus = false;
        }, this.onInputBlur = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                this.inputRef.focus();
                return;
            }
            if (this.props.onBlur) this.props.onBlur(event);
            this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            if ((0, $VSDnB.fg)('platform_dst_select_menu_close_on_blur')) // when fg is enabled, we only call onMenuClose when this.props.menuIsOpen is true.
            this.props.menuIsOpen && this.onMenuClose();
            else this.onMenuClose();
            this.setState({
                focusedValue: null,
                isFocused: false
            });
        }, this.onOptionHover = (focusedOption)=>{
            if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
            const options = this.getFocusableOptions();
            const focusedOptionIndex = options.indexOf(focusedOption);
            this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
            });
        }, this.shouldHideSelectedOptions = ()=>{
            return $d8e863683b34816f$var$shouldHideSelectedOptions(this.props);
        }, // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        this.onValueInputFocus = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            this.focus();
        }, // ==============================
        // Keyboard Handlers
        // ==============================
        this.onKeyDown = (event)=>{
            const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus } = this.props;
            const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) this.popValue();
                        else if (isClearable) this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                    this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (focusedValue) this.removeValue(focusedValue);
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (this.isComposing) return;
                        this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) this.clearValue();
                    break;
                case ' ':
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) this.focusOption('up');
                    else this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) this.focusOption('down');
                    else this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        }, this.handleOpenLayerObserverCloseSignal = ()=>{
            this.onMenuClose();
        };
        this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$d8e863683b34816f$var$instanceId);
        this.state.selectValue = (0, $gyjU7.cleanValue)(props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (props.menuIsOpen) {
            const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
            const focusableOptions = this.buildFocusableOptions();
            const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
            this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            this.state.focusedOption = focusableOptions[optionIndex];
            this.state.focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
    }
    static getDerivedStateFromProps(props, state) {
        const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
        const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
        const selectValue = (0, $gyjU7.cleanValue)(value);
        let newMenuOptionsState = {};
        if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
            const focusableOptions = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) : [];
            const focusableOptionsWithIds = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
            const focusedValue = clearFocusValueOnUpdate ? $d8e863683b34816f$var$getNextFocusedValue(state, selectValue) : null;
            const focusedOption = $d8e863683b34816f$var$getNextFocusedOption(state, focusableOptions);
            const focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
            newMenuOptionsState = {
                selectValue: selectValue,
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionId,
                focusableOptionsWithIds: focusableOptionsWithIds,
                focusedValue: focusedValue,
                clearFocusValueOnUpdate: false
            };
        }
        // some updates should toggle the state of the input visibility
        const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
            inputIsHidden: inputIsHiddenAfterUpdate,
            inputIsHiddenAfterUpdate: undefined
        } : {};
        let newAriaSelection = ariaSelection;
        let hasKeptFocus = isFocused && prevWasFocused;
        if (isFocused && !hasKeptFocus) {
            // If `value` or `defaultValue` props are not empty then announce them
            // when the Select is initially focused
            newAriaSelection = {
                value: (0, $gyjU7.valueTernary)(isMulti, selectValue, selectValue[0] || null),
                options: selectValue,
                action: 'initial-input-focus'
            };
            hasKeptFocus = !prevWasFocused;
        }
        // If the 'initial-input-focus' action has been set already
        // then reset the ariaSelection to null
        if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
        return {
            ...newMenuOptionsState,
            ...newInputIsHiddenState,
            prevProps: props,
            ariaSelection: newAriaSelection,
            prevWasFocused: hasKeptFocus
        };
    }
    componentDidMount() {
        this.startListeningComposition();
        this.startListeningToTouch();
        if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('scroll', this.onScroll, true);
        if (this.props.autoFocus) this.focusInput();
        // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
        if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $gyjU7.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
    }
    componentDidUpdate(prevProps) {
        const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
        const { isFocused: isFocused } = this.state;
        if (// ensure focus is restored correctly when the control becomes enabled
        isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
        isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
        if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
        this.setState({
            isFocused: false
        }, this.onMenuClose);
        else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
        this.setState({
            isFocused: true
        });
        // scroll the focused option into view if necessary
        if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
            (0, $gyjU7.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
            this.scrollToFocusedOptionOnUpdate = false;
        }
    }
    componentWillUnmount() {
        this.stopListeningComposition();
        this.stopListeningToTouch();
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('scroll', this.onScroll, true);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
    onMenuOpen() {
        this.props.onMenuOpen();
    }
    onMenuClose() {
        this.onInputChange('', {
            action: 'menu-close',
            prevInputValue: this.props.inputValue
        });
        this.props.onMenuClose();
    }
    onInputChange(newValue, actionMeta) {
        this.props.onInputChange(newValue, actionMeta);
    }
    // ==============================
    // Methods
    // ==============================
    focusInput() {
        if (!this.inputRef) return;
        this.inputRef.focus();
    }
    blurInput() {
        if (!this.inputRef) return;
        this.inputRef.blur();
    }
    openMenu(focusOption) {
        const { selectValue: selectValue, isFocused: isFocused } = this.state;
        const focusableOptions = this.buildFocusableOptions();
        let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
        if (!this.props.isMulti) {
            const selectedIndex = focusableOptions.indexOf(selectValue[0]);
            if (selectedIndex > -1) openAtIndex = selectedIndex;
        }
        const focusedOption = focusableOptions[openAtIndex];
        // only scroll if the menu isn't already open
        this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
        this.setState({
            inputIsHiddenAfterUpdate: false,
            focusedValue: null,
            focusedOption: focusedOption,
            focusedOptionId: this.getFocusedOptionId(focusedOption)
        }, ()=>this.onMenuOpen());
        (0, $2Z7Iz.isSafari)() && focusedOption && this.updateInputLabel(this.calculateInputLabel(focusedOption, openAtIndex));
    }
    updateInputLabel(inputLabel) {
        if (inputLabel) {
            this.inputRef?.setAttribute('aria-label', inputLabel);
            setTimeout(()=>{
                const normalizedLabel = this.props['aria-label'] || this.props.label;
                if (normalizedLabel) this.inputRef?.setAttribute('aria-label', normalizedLabel);
                else this.inputRef?.removeAttribute('aria-label');
            }, 500);
        }
    }
    calculateInputLabel(focusedOption, optionIndex) {
        const { options: options } = this.props;
        const isOptionsGrouped = options?.every((obj)=>typeof obj === 'object' && obj !== null && 'options' in obj);
        let inputLabel = this.getOptionLabel(focusedOption);
        const isOptionFocused = (option)=>{
            return this.getOptionLabel(option) === inputLabel;
        };
        const groupData = options?.find((option)=>{
            const groupCandidate = option;
            return groupCandidate.options?.some(isOptionFocused) ?? false;
        });
        if (isOptionsGrouped) {
            const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
            const totalLength = options?.reduce((acc, currentGroup)=>{
                const group = currentGroup;
                acc += group?.options?.length;
                return acc;
            }, 0);
            inputLabel = `${inputLabel}, ${groupData?.label} (${groupOptionIndex + 1} of ${totalLength})`;
        } else inputLabel = `${inputLabel} (${optionIndex + 1} of ${options?.length})`;
        return inputLabel;
    }
    focusValue(direction) {
        const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
        // Only multiselects support value focusing
        if (!this.props.isMulti) return;
        this.setState({
            focusedOption: null
        });
        let focusedIndex = selectValue.indexOf(focusedValue);
        if (!focusedValue) focusedIndex = -1;
        const lastIndex = selectValue.length - 1;
        let nextFocus = -1;
        if (!selectValue.length) return;
        switch(direction){
            case 'previous':
                if (focusedIndex === 0) // don't cycle from the start to the end
                nextFocus = 0;
                else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                nextFocus = lastIndex;
                else nextFocus = focusedIndex - 1;
                break;
            case 'next':
                if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                break;
        }
        this.setState({
            inputIsHidden: nextFocus !== -1,
            focusedValue: selectValue[nextFocus],
            focusedValueId: `${this.getElementId('selected-value')}-${nextFocus}-remove`,
            focusedOption: null,
            focusedOptionId: null
        });
    }
    focusOption(direction = 'first') {
        const { pageSize: pageSize } = this.props;
        const { focusedOption: focusedOption } = this.state;
        const options = this.getFocusableOptions();
        if (!options.length) return;
        let nextFocus = 0; // handles 'first'
        let focusedIndex = options.indexOf(focusedOption);
        if (!focusedOption) focusedIndex = -1;
        if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
        else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
        else if (direction === 'pageup') {
            nextFocus = focusedIndex - pageSize;
            if (nextFocus < 0) nextFocus = 0;
        } else if (direction === 'pagedown') {
            nextFocus = focusedIndex + pageSize;
            if (nextFocus > options.length - 1) nextFocus = options.length - 1;
        } else if (direction === 'last') nextFocus = options.length - 1;
        this.scrollToFocusedOptionOnUpdate = true;
        this.setState({
            focusedOption: options[nextFocus],
            focusedValue: null,
            focusedValueId: null,
            focusedOptionId: this.getFocusedOptionId(options[nextFocus])
        });
    }
    getCommonProps() {
        const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
        const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
        const hasValue = this.hasValue();
        return {
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getClassNames: getClassNames,
            getValue: getValue,
            hasValue: hasValue,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: props,
            setValue: setValue
        };
    }
    hasValue() {
        const { selectValue: selectValue } = this.state;
        return selectValue.length > 0;
    }
    hasOptions() {
        return !!this.getFocusableOptions().length;
    }
    isClearable() {
        const { isClearable: isClearable, isMulti: isMulti } = this.props;
        // single select, by default, IS NOT clearable
        // multi select, by default, IS clearable
        if (isClearable === undefined) return isMulti;
        return isClearable;
    }
    isOptionDisabled(option, selectValue) {
        return $d8e863683b34816f$var$isOptionDisabled(this.props, option, selectValue);
    }
    isOptionSelected(option, selectValue) {
        return $d8e863683b34816f$var$isOptionSelected(this.props, option, selectValue);
    }
    filterOption(option, inputValue) {
        return $d8e863683b34816f$var$filterOption(this.props, option, inputValue);
    }
    formatOptionLabel(data, context) {
        if (typeof this.props.formatOptionLabel === 'function') {
            const { inputValue: inputValue } = this.props;
            const { selectValue: selectValue } = this.state;
            return this.props.formatOptionLabel(data, {
                context: context,
                inputValue: inputValue,
                selectValue: selectValue
            });
        } else return this.getOptionLabel(data);
    }
    formatGroupLabel(data) {
        return this.props.formatGroupLabel(data);
    }
    calculateDescription() {
        const descriptionProp = this.props['aria-describedby'] || this.props.descriptionId;
        const { isMulti: isMulti } = this.props;
        const hasValue = this.state.selectValue.length > 0;
        // Determine base description based on selection state
        const baseDescriptionId = hasValue ? isMulti ? '' : this.getElementId('single-value') : this.getElementId('placeholder');
        // Fast path for single select with no description prop
        if (!isMulti && !descriptionProp) return {
            'aria-describedby': baseDescriptionId
        };
        // Build the describedby string efficiently
        let describedBy = baseDescriptionId;
        // Add description prop if it exists
        if (descriptionProp) describedBy = describedBy ? `${descriptionProp} ${describedBy}` : descriptionProp;
        // For multi-select, always add multi-message ID
        if (isMulti) {
            const multiMessage = this.getElementId('multi-message');
            describedBy = describedBy ? `${describedBy} ${multiMessage}` : multiMessage;
        }
        return {
            'aria-describedby': describedBy
        };
    }
    // ==============================
    // Composition Handlers
    // ==============================
    startListeningComposition() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionstart', this.onCompositionStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionend', this.onCompositionEnd, false);
        }
    }
    stopListeningComposition() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionstart', this.onCompositionStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionend', this.onCompositionEnd);
        }
    }
    // ==============================
    // Touch Handlers
    // ==============================
    startListeningToTouch() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchstart', this.onTouchStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchmove', this.onTouchMove, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchend', this.onTouchEnd, false);
        }
    }
    stopListeningToTouch() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchstart', this.onTouchStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchmove', this.onTouchMove);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchend', this.onTouchEnd);
        }
    }
    // ==============================
    // Renderers
    // ==============================
    renderInput() {
        const { form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex = 0, testId: testId } = this.props;
        const { Input: Input } = this.getComponents();
        const { inputIsHidden: inputIsHidden } = this.state;
        const { commonProps: commonProps } = this;
        const id = inputId || this.getElementId('input');
        // aria attributes makes the JSX "noisy", separated for clarity
        const ariaAttributes = {
            'aria-autocomplete': 'both',
            'aria-errormessage': this.props['aria-errormessage'],
            'aria-expanded': menuIsOpen,
            // TODO: aria-haspopup is implied as listbox with role="combobox" and was deprecated for aria 1.2, we still might need to keep it for back compat
            'aria-haspopup': this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
            'aria-invalid': this.props['aria-invalid'] || isInvalid,
            'aria-label': this.props['aria-label'] || label,
            'aria-labelledby': this.props['aria-labelledby'] || labelId,
            'aria-required': required || isRequired,
            role: 'combobox',
            'aria-activedescendant': this.props['UNSAFE_is_experimental_generic'] ? undefined : this.state.focusedOptionId || this.state.focusedValueId || undefined,
            ...menuIsOpen && {
                'aria-controls': this.getElementId('listbox')
            },
            // TODO: Might need to remove this
            ...!isSearchable && {
                'aria-readonly': true
            },
            ...this.calculateDescription()
        };
        if (!isSearchable) // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jtVgE.default), {
            id: id,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: (0, $gyjU7.noop),
            onFocus: this.onInputFocus,
            disabled: isDisabled,
            tabIndex: tabIndex,
            inputMode: "none",
            form: form,
            value: "",
            "data-testid": testId && `${testId}-select--input`,
            ...ariaAttributes
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)(Input, {
            ...commonProps,
            autoCapitalize: "none",
            autoComplete: "off",
            autoCorrect: "off",
            id: id,
            testId: testId,
            innerRef: this.getInputRef,
            isDisabled: isDisabled,
            isHidden: inputIsHidden,
            onBlur: this.onInputBlur,
            onChange: this.handleInputChange,
            onFocus: this.onInputFocus,
            spellCheck: "false",
            tabIndex: tabIndex,
            form: form,
            type: "text",
            value: inputValue,
            ...ariaAttributes
        });
    }
    renderPlaceholderOrValue() {
        const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder, testId: testId } = this.props;
        const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
        if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, $5uXOq.createElement)(Placeholder, {
            ...commonProps,
            key: "placeholder",
            isDisabled: isDisabled,
            isFocused: isFocused,
            innerProps: {
                id: this.getElementId('placeholder'),
                ...testId && {
                    'data-testid': `${testId}-select--placeholder`
                }
            }
        }, placeholder);
        if (isMulti) return selectValue.map((opt, index)=>{
            const isOptionFocused = opt === focusedValue;
            const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
            return /*#__PURE__*/ (0, $5uXOq.createElement)(MultiValue, {
                ...commonProps,
                components: {
                    Container: MultiValueContainer,
                    Label: MultiValueLabel,
                    Remove: MultiValueRemove
                },
                isFocused: isOptionFocused,
                isDisabled: isDisabled,
                key: key,
                index: index,
                removeProps: {
                    onClick: ()=>this.removeValue(opt),
                    onTouchEnd: ()=>this.removeValue(opt),
                    onMouseDown: (e)=>{
                        e.preventDefault();
                    },
                    ...testId && {
                        'data-testid': `${testId}-select--multivalue-${index}-remove`
                    },
                    id: `${this.getElementId('selected-value')}-${index}-remove`
                },
                data: opt,
                innerProps: {
                    ...testId && {
                        'data-testid': `${testId}-select--multivalue-${index}`
                    },
                    id: `${this.getElementId('selected-value')}-${index}`
                }
            }, this.formatOptionLabel(opt, 'value'));
        });
        if (inputValue) return null;
        const singleValue = selectValue[0];
        return /*#__PURE__*/ (0, $2OMIu.jsx)(SingleValue, {
            ...commonProps,
            data: singleValue,
            isDisabled: isDisabled,
            innerProps: {
                id: this.getElementId('single-value')
            },
            children: this.formatOptionLabel(singleValue, 'value')
        });
    }
    renderClearIndicator() {
        const { ClearIndicator: ClearIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { clearControlLabel: clearControlLabel, isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
        const innerProps = {
            onMouseDown: this.onClearIndicatorMouseDown,
            onTouchEnd: this.onClearIndicatorTouchEnd,
            ...testId && {
                'data-testid': `${testId}-select--clear-indicator`
            }
        };
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $2OMIu.jsx)(ClearIndicator, {
            clearControlLabel: clearControlLabel,
            ...commonProps,
            innerProps: innerProps,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderLoadingIndicator() {
        const { LoadingIndicator: LoadingIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!LoadingIndicator || !isLoading) return null;
        const isCompact = spacing === 'compact';
        const innerProps = {
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)(LoadingIndicator, {
            "data-testid": testId && `${testId}-select--loading-indicator`,
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderDropdownIndicator() {
        const { DropdownIndicator: DropdownIndicator } = this.getComponents();
        if (!DropdownIndicator) return null;
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        const isCompact = spacing === 'compact';
        const innerProps = {
            onMouseDown: this.onDropdownIndicatorMouseDown,
            onTouchEnd: this.onDropdownIndicatorTouchEnd,
            'aria-hidden': 'true',
            ...testId && {
                'data-testid': `${testId}-select--dropdown-indicator`
            }
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)(DropdownIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderMenu() {
        const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { focusedOption: focusedOption } = this.state;
        const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom, testId: testId } = this.props;
        if (!menuIsOpen) return null;
        // TODO: Internal Option Type here
        const render = (props, id, headingId)=>{
            const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
            const isFocused = focusedOption === data;
            const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
            const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
            const optionId = `${this.getElementId('option')}-${id}`;
            const innerProps = {
                id: optionId,
                onClick: onSelect,
                onMouseMove: onHover,
                onMouseOver: onHover,
                role: this.props['UNSAFE_is_experimental_generic'] ? 'listitem' : 'option',
                'aria-selected': this.props['UNSAFE_is_experimental_generic'] ? undefined : isSelected,
                // We don't want aria-disabled if it's false. It's just noisy.
                'aria-disabled': !isDisabled ? undefined : isDisabled,
                'aria-describedby': headingId,
                ...testId && {
                    'data-testid': `${testId}-select--option-${id}`
                }
            };
            return /*#__PURE__*/ (0, $5uXOq.createElement)(Option, {
                ...commonProps,
                innerProps: innerProps,
                data: data,
                isDisabled: isDisabled,
                isSelected: isSelected,
                key: optionId,
                label: label,
                type: type,
                value: value,
                isFocused: isFocused,
                innerRef: isFocused ? this.getFocusedOptionRef : undefined
            }, this.formatOptionLabel(props.data, 'menu'));
        };
        let menuUI;
        if (this.hasOptions()) {
            const items = this.getCategorizedOptions();
            menuUI = items.map((item)=>{
                if (item.type === 'group') {
                    const { data: data, options: options, index: groupIndex } = item;
                    const groupId = `${this.getElementId('group')}-${groupIndex}`;
                    const headingId = `${groupId}-heading`;
                    return /*#__PURE__*/ (0, $5uXOq.createElement)(Group, {
                        ...commonProps,
                        key: groupId,
                        data: data,
                        options: options,
                        Heading: GroupHeading,
                        headingProps: {
                            id: headingId,
                            data: item.data,
                            ...testId && {
                                'data-testid': `${testId}-select--group-${groupIndex}-heading`
                            }
                        },
                        label: this.formatGroupLabel(item.data)
                    }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                } else if (item.type === 'option') return render(item, `${item.index}`);
            });
        } else if (isLoading) {
            const message = loadingMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $2OMIu.jsx)(LoadingMessage, {
                ...commonProps,
                children: message
            });
        } else {
            const message = noOptionsMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $2OMIu.jsx)(NoOptionsMessage, {
                ...commonProps,
                innerProps: {
                    ...testId && {
                        'data-testid': `${testId}-select--no-options`
                    }
                },
                children: message
            });
        }
        const menuPlacementProps = {
            minMenuHeight: minMenuHeight,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView
        };
        const menuElement = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aA8TC.MenuPlacer), {
            ...commonProps,
            ...menuPlacementProps,
            children: ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>/*#__PURE__*/ (0, $2OMIu.jsx)(Menu, {
                    ...commonProps,
                    ...menuPlacementProps,
                    innerRef: ref,
                    innerProps: {
                        onMouseDown: this.onMenuMouseDown,
                        onMouseMove: this.onMenuMouseMove,
                        id: this.props.components.Menu ? this.getElementId('listbox') : undefined,
                        ...testId && {
                            'data-testid': `${testId}-select--listbox-container`
                        }
                    },
                    isLoading: isLoading,
                    placement: placement,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $galqx.default), {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll,
                        children: (scrollTargetRef)=>/*#__PURE__*/ (0, $2OMIu.jsx)(MenuList, {
                                ...commonProps,
                                innerRef: (instance)=>{
                                    this.getMenuListRef(instance);
                                    scrollTargetRef(instance);
                                },
                                innerProps: {
                                    role: this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
                                    ...this.props['UNSAFE_is_experimental_generic'] && {
                                        'aria-labelledby': this.inputRef?.id || this.getElementId('input')
                                    },
                                    'aria-multiselectable': !commonProps.isMulti || this.props['UNSAFE_is_experimental_generic'] ? undefined : commonProps.isMulti,
                                    id: this.getElementId('listbox'),
                                    ...testId && {
                                        'data-testid': `${testId}-select--listbox`
                                    },
                                    // add aditional label on listbox for safari to announce first option
                                    ...(0, $2Z7Iz.isSafari)() && !this.props['UNSAFE_is_experimental_generic'] && {
                                        'aria-describedby': this.inputRef?.id || this.getElementId('input')
                                    }
                                },
                                isLoading: isLoading,
                                maxHeight: maxHeight,
                                focusedOption: focusedOption,
                                children: this.props['UNSAFE_is_experimental_generic'] ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                                    role: "list",
                                    children: menuUI
                                }) : menuUI
                            })
                    })
                })
        });
        // positioning behaviour is almost identical for portalled and fixed,
        // so we use the same component. the actual portalling logic is forked
        // within the component based on `menuPosition`
        return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ (0, $2OMIu.jsx)(MenuPortal, {
            ...commonProps,
            appendTo: menuPortalTarget,
            controlElement: this.controlRef,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            children: menuElement
        }) : menuElement;
    }
    renderFormField() {
        const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
        const { selectValue: selectValue } = this.state;
        if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9cRAr.default), {
            name: name,
            onFocus: this.onValueInputFocus
        });
        if (!name || isDisabled) return;
        if (isMulti) {
            if (delimiter) {
                const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                return /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            } else {
                const input = selectValue.length > 0 ? selectValue.map((opt, i)=>/*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                        name: name,
                        type: "hidden",
                        value: this.getOptionValue(opt)
                    }, `i-${i}`)) : /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: ""
                });
                return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    children: input
                });
            }
        } else {
            const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
            return /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                name: name,
                type: "hidden",
                value: value
            });
        }
    }
    renderLiveRegion() {
        const { commonProps: commonProps } = this;
        const { ariaSelection: ariaSelection, isFocused: isFocused, selectValue: selectValue } = this.state;
        const focusableOptions = this.getFocusableOptions();
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $81i5b.default), {
            ...commonProps,
            id: this.getElementId('live-region'),
            ariaSelection: ariaSelection,
            isFocused: isFocused,
            selectValue: selectValue,
            focusableOptions: focusableOptions
        });
    }
    renderMultiselectMessage() {
        // In the future, when we actually support touch devices, we'll need to update this to not be keyboard specific.
        // Also, since this is rendered onscreen, it should be transtlated automatically.
        const msg = `, multiple selections available, ${this.state.selectValue.length ? 'Use left or right arrow keys to navigate selected items' : ''}`;
        return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            id: this.getElementId('multi-message'),
            hidden: true,
            children: msg
        }));
    }
    render() {
        const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
        const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen, isInvalid: isInvalid, testId: testId, appearance: appearance = 'default', spacing: spacing = 'default' } = this.props;
        const { isFocused: isFocused } = this.state;
        const commonProps = this.commonProps = this.getCommonProps();
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $2OMIu.jsxs)(SelectContainer, {
            ...commonProps,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            innerProps: {
                id: id,
                onKeyDown: this.onKeyDown,
                ...testId && {
                    'data-testid': testId && `${testId}-select--container`
                }
            },
            isDisabled: isDisabled,
            isFocused: isFocused,
            children: [
                this.renderLiveRegion(),
                commonProps.isMulti && this.renderMultiselectMessage(),
                /*#__PURE__*/ (0, $2OMIu.jsxs)(Control, {
                    ...commonProps,
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd,
                        ...testId && {
                            'data-testid': `${testId}-select--control`
                        }
                    },
                    appearance: appearance,
                    isInvalid: isInvalid,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen,
                    isCompact: isCompact,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsxs)(ValueContainer, {
                            ...commonProps,
                            isDisabled: isDisabled,
                            isCompact: isCompact,
                            innerProps: {
                                ...testId && {
                                    'data-testid': `${testId}-select--value-container`
                                },
                                ...commonProps.isMulti && commonProps.hasValue && !(0, $2Z7Iz.isAppleDevice)() && {
                                    // Required to keep JAWS from popping out of forms mode when using LEFT/RIGHT arrow keys.
                                    // This is Jedi Master level ARIA and not taken lightly. Do not modify without consulting
                                    // DST Accessibility.
                                    role: 'application'
                                }
                            },
                            children: [
                                this.renderPlaceholderOrValue(),
                                this.renderInput()
                            ]
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsxs)(IndicatorsContainer, {
                            ...commonProps,
                            isDisabled: isDisabled,
                            innerProps: {
                                ...testId && {
                                    'data-testid': `${testId}-select--indicators-container`
                                }
                            },
                            children: [
                                this.renderClearIndicator(),
                                this.renderLoadingIndicator(),
                                this.renderDropdownIndicator()
                            ]
                        })
                    ]
                }),
                this.renderMenu(),
                this.renderFormField(),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7uagk.NotifyOpenLayerObserver), {
                    isOpen: this.props.menuIsOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                })
            ]
        });
    }
}

});
parcelRegister("eEtcC", function(module, exports) {

$parcel$export(module.exports, "formatGroupLabel", () => $1a3d0f2eb875e1af$export$f4da216a6ca54656);
$parcel$export(module.exports, "getOptionLabel", () => $1a3d0f2eb875e1af$export$dac6ace3020563ca);
$parcel$export(module.exports, "getOptionValue", () => $1a3d0f2eb875e1af$export$40be908210c5a79c);
$parcel$export(module.exports, "isOptionDisabled", () => $1a3d0f2eb875e1af$export$56bd0c8d90db075);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $1a3d0f2eb875e1af$export$f4da216a6ca54656 = (group)=>group.label;
const $1a3d0f2eb875e1af$export$dac6ace3020563ca = (option)=>option.label;
const $1a3d0f2eb875e1af$export$40be908210c5a79c = (option)=>option.value;
const $1a3d0f2eb875e1af$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;

});

parcelRegister("jtVgE", function(module, exports) {

$parcel$export(module.exports, "default", () => $afe53037961824c2$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c8F86 = parcelRequire("c8F86");
function $afe53037961824c2$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c8F86.default), {
        ...props
    });
}

});
parcelRegister("c8F86", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb54a2dcae79e275$export$2e2bcd8739ae039);
/* dummy-input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gyjU7 = parcelRequire("gyjU7");
const $fb54a2dcae79e275$var$dummyInputStyles = null;
function $fb54a2dcae79e275$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
    // Remove animation props not meant for HTML elements
    const filteredProps = (0, $gyjU7.removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
        ref: innerRef,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _nd5l1sux _12ji1r31 _1qu2glyw _12y3idpf _1bsbt94y _kqswh2mm _1n5d3acm _syaz3acm _1e02p1rm _tzy4idpf _t9ec1kuz",
            "-dummyInput"
        ]),
        ...filteredProps
    });
}

});


parcelRegister("9cRAr", function(module, exports) {

$parcel$export(module.exports, "default", () => $a388fa48a9e96271$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $hU6tE = parcelRequire("hU6tE");
const $a388fa48a9e96271$var$RequiredInput = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $hU6tE.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a388fa48a9e96271$export$2e2bcd8739ae039 = $a388fa48a9e96271$var$RequiredInput;

});
parcelRegister("hU6tE", function(module, exports) {

$parcel$export(module.exports, "default", () => $945267b00a632302$export$2e2bcd8739ae039);
/* required-input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eGmKJ = parcelRequire("eGmKJ");
const $945267b00a632302$var$styles = null;
const $945267b00a632302$var$RequiredInput = ({ name: name, onFocus: onFocus })=>/*#__PURE__*/ (0, $2OMIu.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_1bsb1osq _kqswstnw _u7coidpf _rjxpidpf _1e02idpf _jqf61a21 _tzy4idpf _lcxvglyw",
            "-requiredInput"
        ]),
        onFocus: onFocus,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $eGmKJ.default)
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$945267b00a632302$export$2e2bcd8739ae039 = $945267b00a632302$var$RequiredInput;

});


parcelRegister("galqx", function(module, exports) {

$parcel$export(module.exports, "default", () => $e15a49c0b3452f71$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $59IMp = parcelRequire("59IMp");

var $3jzRI = parcelRequire("3jzRI");
const $e15a49c0b3452f71$var$blurSelectInput = (event)=>{
    const element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $e15a49c0b3452f71$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const setScrollCaptureTarget = (0, $59IMp.default)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    const setScrollLockTarget = (0, $3jzRI.default)({
        isEnabled: lockEnabled
    });
    const targetRef = (element)=>{
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            lockEnabled && // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                onClick: $e15a49c0b3452f71$var$blurSelectInput,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    position: 'fixed',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetBlockEnd: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetBlockStart: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetInlineEnd: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetInlineStart: 0
                }
            }),
            children(targetRef)
        ]
    });
}

});
parcelRegister("59IMp", function(module, exports) {

$parcel$export(module.exports, "default", () => $96c08116303d9e3a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gyjU7 = parcelRequire("gyjU7");
const $96c08116303d9e3a$var$cancelScroll = (event)=>{
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $96c08116303d9e3a$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const isBottom = (0, $5uXOq.useRef)(false);
    const isTop = (0, $5uXOq.useRef)(false);
    const touchStart = (0, $5uXOq.useRef)(0);
    const scrollTarget = (0, $5uXOq.useRef)(null);
    const handleEventDelta = (0, $5uXOq.useCallback)((event, delta)=>{
        if (scrollTarget.current === null) return;
        const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
        const target = scrollTarget.current;
        const isDeltaPositive = delta > 0;
        const availableScroll = scrollHeight - clientHeight - scrollTop;
        let shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $96c08116303d9e3a$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    const onWheel = (0, $5uXOq.useCallback)((event)=>{
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    const onTouchStart = (0, $5uXOq.useCallback)((event)=>{
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    const onTouchMove = (0, $5uXOq.useCallback)((event)=>{
        const deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    const startListening = (0, $5uXOq.useCallback)((el)=>{
        // bail early if no element is available to attach to
        if (!el) return;
        const notPassive = (0, $gyjU7.supportsPassiveEvents) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    const stopListening = (0, $5uXOq.useCallback)((el)=>{
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        startListening(element);
        return ()=>{
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});

parcelRegister("3jzRI", function(module, exports) {

$parcel$export(module.exports, "default", () => $840302f0f43020c5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $840302f0f43020c5$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
const $840302f0f43020c5$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $840302f0f43020c5$var$preventTouchMove(e) {
    e.preventDefault();
}
function $840302f0f43020c5$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $840302f0f43020c5$var$preventInertiaScroll() {
    const top = this.scrollTop;
    const totalScroll = this.scrollHeight;
    const currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $840302f0f43020c5$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
const $840302f0f43020c5$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
let $840302f0f43020c5$var$activeScrollLocks = 0;
const $840302f0f43020c5$var$listenerOptions = {
    capture: false,
    passive: false
};
function $840302f0f43020c5$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
    const originalStyles = (0, $5uXOq.useRef)({});
    const scrollTarget = (0, $5uXOq.useRef)(null);
    const addScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
        if (!$840302f0f43020c5$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
            const val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) {
            const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            const clientWidth = document.body ? document.body.clientWidth : 0;
            const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($840302f0f43020c5$var$LOCK_STYLES).forEach((key)=>{
                const val = $840302f0f43020c5$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
        }
        // account for touch devices
        if (target && $840302f0f43020c5$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $840302f0f43020c5$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    const removeScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
        if (!$840302f0f43020c5$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        // safely decrement active scroll locks
        $840302f0f43020c5$var$activeScrollLocks = Math.max($840302f0f43020c5$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
            const val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $840302f0f43020c5$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        addScrollLock(element);
        return ()=>{
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});


parcelRegister("7uagk", function(module, exports) {

$parcel$export(module.exports, "NotifyOpenLayerObserver", () => $7a4261c0e93bff6e$export$17baa7c95b6ba1b8);

var $9Mkr0 = parcelRequire("9Mkr0");
function $7a4261c0e93bff6e$export$17baa7c95b6ba1b8({ isOpen: isOpen, onClose: onClose }) {
    // @ts-ignore - hot-116676
    (0, $9Mkr0.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}

});

parcelRegister("81i5b", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3ccfcdca5695e58$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7ZLLh = parcelRequire("7ZLLh");
const $a3ccfcdca5695e58$var$LiveRegion = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $7ZLLh.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a3ccfcdca5695e58$export$2e2bcd8739ae039 = $a3ccfcdca5695e58$var$LiveRegion;

});
parcelRegister("7ZLLh", function(module, exports) {

$parcel$export(module.exports, "default", () => $419a6948853c8feb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dQlbw = parcelRequire("dQlbw");

var $7lhj2 = parcelRequire("7lhj2");
const $419a6948853c8feb$var$LiveRegion = (props)=>{
    const { ariaSelection: ariaSelection, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id } = props;
    const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isOptionDisabled: isOptionDisabled, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, isLoading: isLoading } = selectProps;
    const ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    const messages = (0, $5uXOq.useMemo)(()=>({
            ...(0, $dQlbw.defaultAriaLiveMessages),
            ...ariaLiveMessages || {}
        }), [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    const ariaSelected = (0, $5uXOq.useMemo)(()=>{
        let message = '';
        if (menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
            // select-option when !isMulti does not return option so we assume selected option is value
            const asOption = (val)=>!Array.isArray(val) ? val : null;
            // If there is just one item from the action then get its label
            const selected = removedValue || option || asOption(value);
            const label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            const multiSelected = selectedOptions || removedValues || undefined;
            const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (!label && !labels.length) // return empty string if no labels provided
            return '';
            const onChangeProps = {
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels,
                ...ariaSelection
            };
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        menuIsOpen
    ]);
    const ariaResults = (0, $5uXOq.useMemo)(()=>{
        let resultsMsg = '';
        if (isLoading) resultsMsg = 'Loading. ';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            const resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = 'No options. ';
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
    const ScreenReaderText = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                id: "aria-selection",
                children: ariaSelected
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                id: "aria-results",
                children: ariaResults
            })
        ]
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7lhj2.default), {
                id: id,
                children: isInitialFocus && ScreenReaderText
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7lhj2.default), {
                "aria-live": ariaLive,
                role: "status",
                children: isFocused && !isInitialFocus && ScreenReaderText
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$419a6948853c8feb$export$2e2bcd8739ae039 = $419a6948853c8feb$var$LiveRegion;

});
parcelRegister("dQlbw", function(module, exports) {

$parcel$export(module.exports, "defaultAriaLiveMessages", () => $d3258ad64818881e$export$a7265767c78f9bae);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ const $d3258ad64818881e$export$a7265767c78f9bae = {
    onChange: (props)=>{
        const { action: action, label: label = '', isDisabled: isDisabled } = props;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return label.length ? `option ${label}, deselected` : '';
            case 'clear':
                return 'All selected options have been cleared.';
            case 'select-option':
                return label.length && !isDisabled ? `option ${label}, selected.` : '';
            default:
                return '';
        }
    },
    onFilter: (props)=>{
        const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
        return inputValue ? `${resultsMessage} for search term ${inputValue}.` : '';
    }
};

});

parcelRegister("7lhj2", function(module, exports) {

$parcel$export(module.exports, "default", () => $59ce650310f44beb$export$2e2bcd8739ae039);
/* a11y-text.tsx generated by @compiled/babel-plugin v0.36.1 */ // Assistive text to describe visual elements. Hidden for sighted users.

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $59ce650310f44beb$var$styles = null;
const $59ce650310f44beb$var$A11yText = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _1pbydx66 _ogto7mnp _jqf6ydhy _uiztglyw _o5721q9c",
            "-a11yText"
        ]),
        ...props
    });
var $59ce650310f44beb$export$2e2bcd8739ae039 = $59ce650310f44beb$var$A11yText;

});



parcelRegister("5JAlL", function(module, exports) {

$parcel$export(module.exports, "createFilter", () => $2c9d8148d5bbcfb3$export$5d81789ff4aeccdf);

var $8QpSo = parcelRequire("8QpSo");

var $bXu2O = parcelRequire("bXu2O");
const $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput = (0, $8QpSo.default)((0, $bXu2O.stripDiacritics));
const $2c9d8148d5bbcfb3$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
const $2c9d8148d5bbcfb3$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
const $2c9d8148d5bbcfb3$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
        if (option.data.__isNew__) return true;
        const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $2c9d8148d5bbcfb3$var$defaultStringify,
            trim: true,
            matchFrom: 'any',
            ...config
        };
        let input = trim ? $2c9d8148d5bbcfb3$var$trimString(rawInput) : rawInput;
        let candidate = trim ? $2c9d8148d5bbcfb3$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $bXu2O.stripDiacritics)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };

});
parcelRegister("bXu2O", function(module, exports) {

$parcel$export(module.exports, "stripDiacritics", () => $df93339199dda18e$export$b5bee4b27048330b);
const $df93339199dda18e$var$diacritics = [
    {
        base: 'A',
        letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
    },
    {
        base: 'AA',
        letters: '\uA732'
    },
    {
        base: 'AE',
        letters: '\u00C6\u01FC\u01E2'
    },
    {
        base: 'AO',
        letters: '\uA734'
    },
    {
        base: 'AU',
        letters: '\uA736'
    },
    {
        base: 'AV',
        letters: '\uA738\uA73A'
    },
    {
        base: 'AY',
        letters: '\uA73C'
    },
    {
        base: 'B',
        letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
    },
    {
        base: 'C',
        letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
    },
    {
        base: 'D',
        letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
    },
    {
        base: 'DZ',
        letters: '\u01F1\u01C4'
    },
    {
        base: 'Dz',
        letters: '\u01F2\u01C5'
    },
    {
        base: 'E',
        letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
    },
    {
        base: 'F',
        letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
    },
    {
        base: 'G',
        letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
    },
    {
        base: 'H',
        letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
    },
    {
        base: 'I',
        letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
    },
    {
        base: 'J',
        letters: '\u004A\u24BF\uFF2A\u0134\u0248'
    },
    {
        base: 'K',
        letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
    },
    {
        base: 'L',
        letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
    },
    {
        base: 'LJ',
        letters: '\u01C7'
    },
    {
        base: 'Lj',
        letters: '\u01C8'
    },
    {
        base: 'M',
        letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
    },
    {
        base: 'N',
        letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
    },
    {
        base: 'NJ',
        letters: '\u01CA'
    },
    {
        base: 'Nj',
        letters: '\u01CB'
    },
    {
        base: 'O',
        letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
    },
    {
        base: 'OI',
        letters: '\u01A2'
    },
    {
        base: 'OO',
        letters: '\uA74E'
    },
    {
        base: 'OU',
        letters: '\u0222'
    },
    {
        base: 'P',
        letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
    },
    {
        base: 'Q',
        letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
    },
    {
        base: 'R',
        letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
    },
    {
        base: 'S',
        letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
    },
    {
        base: 'T',
        letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
    },
    {
        base: 'TZ',
        letters: '\uA728'
    },
    {
        base: 'U',
        letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
    },
    {
        base: 'V',
        letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
    },
    {
        base: 'VY',
        letters: '\uA760'
    },
    {
        base: 'W',
        letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
    },
    {
        base: 'X',
        letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
    },
    {
        base: 'Y',
        letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
    },
    {
        base: 'Z',
        letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
    },
    {
        base: 'a',
        letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
    },
    {
        base: 'aa',
        letters: '\uA733'
    },
    {
        base: 'ae',
        letters: '\u00E6\u01FD\u01E3'
    },
    {
        base: 'ao',
        letters: '\uA735'
    },
    {
        base: 'au',
        letters: '\uA737'
    },
    {
        base: 'av',
        letters: '\uA739\uA73B'
    },
    {
        base: 'ay',
        letters: '\uA73D'
    },
    {
        base: 'b',
        letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
    },
    {
        base: 'c',
        letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
    },
    {
        base: 'd',
        letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
    },
    {
        base: 'dz',
        letters: '\u01F3\u01C6'
    },
    {
        base: 'e',
        letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
    },
    {
        base: 'f',
        letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
    },
    {
        base: 'g',
        letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
    },
    {
        base: 'h',
        letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
    },
    {
        base: 'hv',
        letters: '\u0195'
    },
    {
        base: 'i',
        letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
    },
    {
        base: 'j',
        letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
    },
    {
        base: 'k',
        letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
    },
    {
        base: 'l',
        letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
    },
    {
        base: 'lj',
        letters: '\u01C9'
    },
    {
        base: 'm',
        letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
    },
    {
        base: 'n',
        letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
    },
    {
        base: 'nj',
        letters: '\u01CC'
    },
    {
        base: 'o',
        letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
    },
    {
        base: 'oi',
        letters: '\u01A3'
    },
    {
        base: 'ou',
        letters: '\u0223'
    },
    {
        base: 'oo',
        letters: '\uA74F'
    },
    {
        base: 'p',
        letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
    },
    {
        base: 'q',
        letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
    },
    {
        base: 'r',
        letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
    },
    {
        base: 's',
        letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
    },
    {
        base: 't',
        letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
    },
    {
        base: 'tz',
        letters: '\uA729'
    },
    {
        base: 'u',
        letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
    },
    {
        base: 'v',
        letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
    },
    {
        base: 'vy',
        letters: '\uA761'
    },
    {
        base: 'w',
        letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
    },
    {
        base: 'x',
        letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
    },
    {
        base: 'y',
        letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
    },
    {
        base: 'z',
        letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
    }
];
const $df93339199dda18e$var$anyDiacritic = new RegExp('[' + $df93339199dda18e$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
const $df93339199dda18e$var$diacriticToBase = {};
for(let i = 0; i < $df93339199dda18e$var$diacritics.length; i++){
    let diacritic = $df93339199dda18e$var$diacritics[i];
    for(let j = 0; j < diacritic.letters.length; j++)$df93339199dda18e$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
}
const $df93339199dda18e$export$b5bee4b27048330b = (str)=>{
    return str.replace($df93339199dda18e$var$anyDiacritic, (match)=>$df93339199dda18e$var$diacriticToBase[match]);
};

});


parcelRegister("7VXAu", function(module, exports) {

$parcel$export(module.exports, "defaultStyles", () => $11d0fd648d1f51c0$export$214b055320e0bf32);
$parcel$export(module.exports, "mergeStyles", () => $11d0fd648d1f51c0$export$e618dc39ac9ad607);

var $h1QWG = parcelRequire("h1QWG");

var $eZFhY = parcelRequire("eZFhY");

var $i48X9 = parcelRequire("i48X9");

var $95iuW = parcelRequire("95iuW");

var $dS5G5 = parcelRequire("dS5G5");

var $aA8TC = parcelRequire("aA8TC");

var $hqcPo = parcelRequire("hqcPo");

var $8l2RA = parcelRequire("8l2RA");

var $kKm82 = parcelRequire("kKm82");

var $hpcbi = parcelRequire("hpcbi");
const $11d0fd648d1f51c0$export$214b055320e0bf32 = {
    clearIndicator: (0, $95iuW.clearIndicatorCSS),
    container: (0, $h1QWG.containerCSS),
    control: (0, $eZFhY.css),
    dropdownIndicator: (0, $95iuW.dropdownIndicatorCSS),
    group: (0, $i48X9.groupCSS),
    groupHeading: (0, $i48X9.groupHeadingCSS),
    indicatorsContainer: (0, $h1QWG.indicatorsContainerCSS),
    input: (0, $dS5G5.inputCSS),
    loadingIndicator: (0, $95iuW.loadingIndicatorCSS),
    loadingMessage: (0, $aA8TC.loadingMessageCSS),
    menu: (0, $aA8TC.menuCSS),
    menuList: (0, $aA8TC.menuListCSS),
    menuPortal: (0, $aA8TC.menuPortalCSS),
    multiValue: (0, $hqcPo.multiValueCSS),
    multiValueLabel: (0, $hqcPo.multiValueLabelCSS),
    multiValueRemove: (0, $hqcPo.multiValueRemoveCSS),
    noOptionsMessage: (0, $aA8TC.noOptionsMessageCSS),
    option: (0, $8l2RA.optionCSS),
    placeholder: (0, $kKm82.placeholderCSS),
    singleValue: (0, $hpcbi.css),
    valueContainer: (0, $h1QWG.valueContainerCSS)
};
function $11d0fd648d1f51c0$export$e618dc39ac9ad607(source, target = {}) {
    // initialize with source styles
    const styles = {
        ...source
    };
    // massage in target styles
    Object.keys(target).forEach((keyAsString)=>{
        const key = keyAsString;
        if (source[key]) styles[key] = (rsCss, props)=>{
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}

});


parcelRegister("iaInK", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e85c90096c52fe4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gyjU7 = parcelRequire("gyjU7");
function $7e85c90096c52fe4$export$2e2bcd8739ae039({ defaultOptions: propsDefaultOptions = false, cacheOptions: cacheOptions = false, loadOptions: propsLoadOptions, options: propsOptions, isLoading: propsIsLoading = false, onInputChange: propsOnInputChange, filterOption: filterOption = null, ...restSelectProps }) {
    const { inputValue: propsInputValue } = restSelectProps;
    const lastRequest = (0, $5uXOq.useRef)(undefined);
    const mounted = (0, $5uXOq.useRef)(false);
    const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
    const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : '');
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(propsDefaultOptions === true);
    const [loadedInputValue, setLoadedInputValue] = (0, $5uXOq.useState)(undefined);
    const [loadedOptions, setLoadedOptions] = (0, $5uXOq.useState)([]);
    const [passEmptyOptions, setPassEmptyOptions] = (0, $5uXOq.useState)(false);
    const [optionsCache, setOptionsCache] = (0, $5uXOq.useState)({});
    const [prevDefaultOptions, setPrevDefaultOptions] = (0, $5uXOq.useState)(undefined);
    const [prevCacheOptions, setPrevCacheOptions] = (0, $5uXOq.useState)(undefined);
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $5uXOq.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    const loadOptions = (0, $5uXOq.useCallback)((inputValue, callback)=>{
        if (!propsLoadOptions) return callback();
        const loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, ()=>callback());
    }, [
        propsLoadOptions
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (propsDefaultOptions === true) loadOptions(stateInputValue, (options)=>{
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onInputChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
        const inputValue = (0, $gyjU7.handleInputChange)(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            const request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, (options)=>{
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? {
                    ...optionsCache,
                    [inputValue]: options
                } : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    const options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return {
        ...restSelectProps,
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    };
}

});

parcelRegister("9uJ4X", function(module, exports) {

$parcel$export(module.exports, "default", () => $72b6d9d338d10de1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $72b6d9d338d10de1$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
    const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
    const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $5uXOq.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
    const [stateValue, setStateValue] = (0, $5uXOq.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const onChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    const onInputChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
        let newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    const onMenuOpen = (0, $5uXOq.useCallback)(()=>{
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    const onMenuClose = (0, $5uXOq.useCallback)(()=>{
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    const value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return {
        ...restSelectProps,
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    };
}

});


parcelRegister("3c98u", function(module, exports) {

$parcel$export(module.exports, "default", () => $628a0199069e875a$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $628a0199069e875a$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { ariaLiveMessages: ariaLiveMessages, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $5uXOq.useRef)(null);
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, $5uXOq.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
            ref: internalSelectRef,
            ariaLiveMessages: ariaLiveMessages,
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === 'error',
            ...restProps,
            // indicates react-select to be async by default using the base Select component
            // so that makers can pass all async props on the base select to async load options.
            isAsync: true
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});


parcelRegister("i0vxP", function(module, exports) {

$parcel$export(module.exports, "default", () => $e488d7f69150a6e1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fW62l = parcelRequire("fW62l");
class $e488d7f69150a6e1$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            onEscape: null,
            onEnter: null,
            onBlur: null,
            className: undefined
        };
    }
    componentDidMount() {
        // AK Modal uses document.addEventListener() so we also have to use addEventListener.
        // We can't rely on React Synthetic events as stopPropagation won't work
        // This is due to the way React handles events
        // https://github.com/facebook/react/issues/7094
        if (this.ref) this.ref.addEventListener('keydown', this.handleKeyDown);
    }
    componentWillUnmount() {
        if (this.ref) this.ref.removeEventListener('keydown', this.handleKeyDown);
    }
    render() {
        return(// @ts-expect-error - TS2322 - Type '(() => void) | null' is not assignable to type 'FocusEventHandler<HTMLDivElement> | undefined'.
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            onBlur: this.props.onBlur,
            ref: this.setRef,
            className: this.props.className
        }, this.props.children));
    }
    constructor(...args){
        super(...args), this.setRef = (ref)=>{
            this.ref = ref;
        }, this.handleKeyDown = (event)=>{
            switch(event.keyCode){
                case (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('escape'):
                    if (this.props.onEscape) {
                        this.props.onEscape(event);
                        event.stopPropagation();
                    }
                    break;
                case (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('enter'):
                    if (this.props.onEnter) {
                        this.props.onEnter(event);
                        event.stopPropagation();
                    }
                    break;
                default:
                    break;
            }
        };
    }
}

});
parcelRegister("fW62l", function(module, exports) {
// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */ function keyCode(searchInput) {
    // Keyboard Events
    if (searchInput && 'object' === typeof searchInput) {
        var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
        if (hasKeyCode) searchInput = hasKeyCode;
    }
    // Numbers
    if ('number' === typeof searchInput) return names[searchInput];
    // Everything else (cast to string)
    var search = String(searchInput);
    // check codes
    var foundNamedKey = codes[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // check aliases
    var foundNamedKey = aliases[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // weird character?
    if (search.length === 1) return search.charCodeAt(0);
    return undefined;
}
/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */ keyCode.isEventKey = function isEventKey(event, nameOrCode) {
    if (event && 'object' === typeof event) {
        var keyCode = event.which || event.keyCode || event.charCode;
        if (keyCode === null || keyCode === undefined) return false;
        if (typeof nameOrCode === 'string') {
            // check codes
            var foundNamedKey = codes[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
            // check aliases
            var foundNamedKey = aliases[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
        } else if (typeof nameOrCode === 'number') return nameOrCode === keyCode;
        return false;
    }
};
exports = module.exports = keyCode;
/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */ var codes = exports.code = exports.codes = {
    'backspace': 8,
    'tab': 9,
    'enter': 13,
    'shift': 16,
    'ctrl': 17,
    'alt': 18,
    'pause/break': 19,
    'caps lock': 20,
    'esc': 27,
    'space': 32,
    'page up': 33,
    'page down': 34,
    'end': 35,
    'home': 36,
    'left': 37,
    'up': 38,
    'right': 39,
    'down': 40,
    'insert': 45,
    'delete': 46,
    'command': 91,
    'left command': 91,
    'right command': 93,
    'numpad *': 106,
    'numpad +': 107,
    'numpad -': 109,
    'numpad .': 110,
    'numpad /': 111,
    'num lock': 144,
    'scroll lock': 145,
    'my computer': 182,
    'my calculator': 183,
    ';': 186,
    '=': 187,
    ',': 188,
    '-': 189,
    '.': 190,
    '/': 191,
    '`': 192,
    '[': 219,
    '\\': 220,
    ']': 221,
    "'": 222
};
// Helper aliases
var aliases = exports.aliases = {
    'windows': 91,
    "\u21E7": 16,
    "\u2325": 18,
    "\u2303": 17,
    "\u2318": 91,
    'ctl': 17,
    'control': 17,
    'option': 18,
    'pause': 19,
    'break': 19,
    'caps': 20,
    'return': 13,
    'escape': 27,
    'spc': 32,
    'spacebar': 32,
    'pgup': 33,
    'pgdn': 34,
    'ins': 45,
    'del': 46,
    'cmd': 91
};
/*!
 * Programatically add the following
 */ // lower case chars
for(i = 97; i < 123; i++)codes[String.fromCharCode(i)] = i - 32;
// numbers
for(var i = 48; i < 58; i++)codes[i - 48] = i;
// function keys
for(i = 1; i < 13; i++)codes['f' + i] = i + 111;
// numpad keys
for(i = 0; i < 10; i++)codes['numpad ' + i] = i + 96;
/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */ var names = exports.names = exports.title = {} // title for backward compat
;
// Create reverse mapping
for(i in codes)names[codes[i]] = i;
// Add aliases
for(var alias in aliases)codes[alias] = aliases[alias];

});


parcelRegister("kJMdt", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1d6d450ba6ea5ae$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c1d6d450ba6ea5ae$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    selectPlaceholder: {
        "id": "software-board-create.modal.form.source-type-picker.select-placeholder",
        "defaultMessage": "Select"
    },
    sourceTypeFieldLabel: {
        "id": "software-board-create.modal.form.source-type-picker.source-type-field-label",
        "defaultMessage": "Choose what to include in this board"
    },
    teamTitle: {
        "id": "software-board-create.modal.form.source-type-picker.team-title",
        "defaultMessage": "Team"
    },
    teamSelectedTitle: {
        "id": "software-board-create.modal.form.source-type-picker.team-selected-title",
        "defaultMessage": "Issues based on <strong>Team</strong>"
    },
    teamDescription: {
        "id": "software-board-create.modal.form.source-type-picker.team-description",
        "defaultMessage": "Show all issues assigned to a team"
    },
    issueTypesTitle: {
        "id": "software-board-create.modal.form.source-type-picker.issue-types-title",
        "defaultMessage": "Issue type"
    },
    issueTypesSelectedTitle: {
        "id": "software-board-create.modal.form.source-type-picker.issue-types-selected-title",
        "defaultMessage": "Issues based on <strong>Issue type</strong>"
    },
    issueTypesDescription: {
        "id": "software-board-create.modal.form.source-type-picker.issue-types-description",
        "defaultMessage": "Show all issues associated with an issue type"
    },
    labelsTitle: {
        "id": "software-board-create.modal.form.source-type-picker.labels-title",
        "defaultMessage": "Label"
    },
    labelsSelectedTitle: {
        "id": "software-board-create.modal.form.source-type-picker.labels-selected-title",
        "defaultMessage": "Issues based on <strong>Label</strong>"
    },
    labelsDescription: {
        "id": "software-board-create.modal.form.source-type-picker.labels-description",
        "defaultMessage": "Show all issues tagged with a specific label"
    },
    allIssuesFromProjectTitle: {
        "id": "software-board-create.modal.form.source-type-picker.all-issues-from-project-title",
        "defaultMessage": "All issues from your project"
    },
    allIssuesFromProjectSelectedTitle: {
        "id": "software-board-create.modal.form.source-type-picker.all-issues-from-project-selected-title",
        "defaultMessage": "Issues based on <strong>All issues from your project</strong>"
    },
    savedFilterTitle: {
        "id": "software-board-create.modal.form.source-type-picker.saved-filter-title",
        "defaultMessage": "Advanced"
    },
    savedFilterSelectedTitle: {
        "id": "software-board-create.modal.form.source-type-picker.saved-filter-selected-title",
        "defaultMessage": "Issues based on a <strong>Saved filter</strong>"
    },
    savedFilterDescription: {
        "id": "software-board-create.modal.form.source-type-picker.saved-filter-description",
        "defaultMessage": "Show issues from a saved JQL filter"
    },
    sourceTypePickerAriaLabel: {
        "id": "software-board-create.modal.form.source-type-picker.source-type-picker-aria-label",
        "defaultMessage": "Select what to include in this board"
    },
    sourceTypeEmptyError: {
        "id": "software-board-create.modal.form.source-type-picker.source-type-empty-error",
        "defaultMessage": "Select what to include in this board"
    },
    teamSelectedTitleIssueTerminologyRefreshM4: {
        "id": "software-board-create.modal.form.source-type-picker.team-selected-title-issue-terminology-refresh-m4",
        "defaultMessage": "Work items based on <strong>Team</strong>"
    },
    teamDescriptionIssueTerminologyRefreshM4: {
        "id": "software-board-create.modal.form.source-type-picker.team-description-issue-terminology-refresh-m4",
        "defaultMessage": "Show all work items assigned to a team"
    },
    issueTypesTitleIssueTerminologyRefreshM4: {
        "id": "software-board-create.modal.form.source-type-picker.issue-types-title-issue-terminology-refresh-m4",
        "defaultMessage": "Work type"
    },
    issueTypesSelectedTitleIssueTerminologyRefreshM4: {
        "id": "software-board-create.modal.form.source-type-picker.issue-types-selected-title-issue-terminology-refresh-m4",
        "defaultMessage": "Work items based on <strong>work type</strong>"
    },
    issueTypesDescriptionIssueTerminologyRefreshM4: {
        "id": "software-board-create.modal.form.source-type-picker.issue-types-description-issue-terminology-refresh-m4",
        "defaultMessage": "Show all work items associated with a work type"
    },
    labelsSelectedTitleIssueTerminologyRefreshM4: {
        "id": "software-board-create.modal.form.source-type-picker.labels-selected-title-issue-terminology-refresh-m4",
        "defaultMessage": "Work items based on <strong>label</strong>"
    },
    labelsDescriptionIssueTerminologyRefreshM4: {
        "id": "software-board-create.modal.form.source-type-picker.labels-description-issue-terminology-refresh-m4",
        "defaultMessage": "Show all work items tagged with a specific label"
    },
    allIssuesFromProjectTitleIssueTerminologyRefreshM4: {
        "id": "software-board-create.modal.form.source-type-picker.all-issues-from-project-title-issue-terminology-refresh-m4",
        "defaultMessage": "All work items from your project"
    },
    allIssuesFromProjectSelectedTitleIssueTerminologyRefreshM4: {
        "id": "software-board-create.modal.form.source-type-picker.all-issues-from-project-selected-title-issue-terminology-refresh-m4",
        "defaultMessage": "Work items based on <strong>All work items from your project</strong>"
    },
    savedFilterSelectedTitleIssueTerminologyRefreshM4: {
        "id": "software-board-create.modal.form.source-type-picker.saved-filter-selected-title-issue-terminology-refresh-m4",
        "defaultMessage": "Work items based on a <strong>Saved filter</strong>"
    },
    savedFilterDescriptionIssueTerminologyRefreshM4: {
        "id": "software-board-create.modal.form.source-type-picker.saved-filter-description-issue-terminology-refresh-m4",
        "defaultMessage": "Show work items from a saved JQL filter"
    }
});

});

parcelRegister("c6RuI", function(module, exports) {

$parcel$export(module.exports, "getOptionGroups", () => $febdc73d67318f4a$export$eec1253b95a159cc);

var $2o8gl = parcelRequire("2o8gl");

var $lfDf7 = parcelRequire("lfDf7");

var $bB6uF = parcelRequire("bB6uF");

var $kYQTv = parcelRequire("kYQTv");

var $dXQDI = parcelRequire("dXQDI");

var $4R6GH = parcelRequire("4R6GH");

var $h3KSk = parcelRequire("h3KSk");

var $kJMdt = parcelRequire("kJMdt");
const $febdc73d67318f4a$export$eec1253b95a159cc = ({ formatMessage: formatMessage, projectAvatar: projectAvatar })=>{
    const allIssuesFromProjectTitleMessage = (0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $kJMdt.default).allIssuesFromProjectTitleIssueTerminologyRefreshM4 : (0, $kJMdt.default).allIssuesFromProjectTitle;
    const allIssuesFromProjectSelectedTitleMessage = (0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $kJMdt.default).allIssuesFromProjectSelectedTitleIssueTerminologyRefreshM4 : (0, $kJMdt.default).allIssuesFromProjectSelectedTitle;
    const teamSelectedTitleMessage = (0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $kJMdt.default).teamSelectedTitleIssueTerminologyRefreshM4 : (0, $kJMdt.default).teamSelectedTitle;
    const teamDescriptionMessage = (0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $kJMdt.default).teamDescriptionIssueTerminologyRefreshM4 : (0, $kJMdt.default).teamDescription;
    const issueTypesTitleMessage = (0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $kJMdt.default).issueTypesTitleIssueTerminologyRefreshM4 : (0, $kJMdt.default).issueTypesTitle;
    const issueTypesSelectedTitleMessage = (0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $kJMdt.default).issueTypesSelectedTitleIssueTerminologyRefreshM4 : (0, $kJMdt.default).issueTypesSelectedTitle;
    const issueTypesDescriptionMessage = (0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $kJMdt.default).issueTypesDescriptionIssueTerminologyRefreshM4 : (0, $kJMdt.default).issueTypesDescription;
    const labelsSelectedTitleMessage = (0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $kJMdt.default).labelsSelectedTitleIssueTerminologyRefreshM4 : (0, $kJMdt.default).labelsSelectedTitle;
    const labelsDescriptionMessage = (0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $kJMdt.default).labelsDescriptionIssueTerminologyRefreshM4 : (0, $kJMdt.default).labelsDescription;
    const savedFilterSelectedTitleMessage = (0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $kJMdt.default).savedFilterSelectedTitleIssueTerminologyRefreshM4 : (0, $kJMdt.default).savedFilterSelectedTitle;
    const savedFilterDescriptionMessage = (0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $kJMdt.default).savedFilterDescriptionIssueTerminologyRefreshM4 : (0, $kJMdt.default).savedFilterDescription;
    return [
        {
            options: [
                {
                    label: formatMessage(allIssuesFromProjectTitleMessage),
                    title: formatMessage(allIssuesFromProjectTitleMessage),
                    selectedTitle: allIssuesFromProjectSelectedTitleMessage,
                    value: null,
                    icon: projectAvatar || (0, (/*@__PURE__*/$parcel$interopDefault($dXQDI)))
                }
            ]
        },
        {
            options: [
                {
                    label: formatMessage((0, $kJMdt.default).teamTitle),
                    title: formatMessage((0, $kJMdt.default).teamTitle),
                    selectedTitle: teamSelectedTitleMessage,
                    description: formatMessage(teamDescriptionMessage),
                    value: (0, $h3KSk.BOARD_SOURCE_FIELDS).TEAM,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($kYQTv)))
                },
                {
                    label: formatMessage(issueTypesTitleMessage),
                    title: formatMessage(issueTypesTitleMessage),
                    selectedTitle: issueTypesSelectedTitleMessage,
                    description: formatMessage(issueTypesDescriptionMessage),
                    value: (0, $h3KSk.BOARD_SOURCE_FIELDS).ISSUE_TYPES,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($lfDf7)))
                },
                {
                    label: formatMessage((0, $kJMdt.default).labelsTitle),
                    title: formatMessage((0, $kJMdt.default).labelsTitle),
                    selectedTitle: labelsSelectedTitleMessage,
                    description: formatMessage(labelsDescriptionMessage),
                    value: (0, $h3KSk.BOARD_SOURCE_FIELDS).LABELS,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($bB6uF)))
                }
            ]
        },
        {
            options: [
                {
                    label: formatMessage((0, $kJMdt.default).savedFilterTitle),
                    title: formatMessage((0, $kJMdt.default).savedFilterTitle),
                    selectedTitle: savedFilterSelectedTitleMessage,
                    description: formatMessage(savedFilterDescriptionMessage),
                    value: (0, $h3KSk.BOARD_SOURCE_FIELDS).SAVED_FILTER,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($2o8gl)))
                }
            ]
        }
    ];
};

});
parcelRegister("2o8gl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::289d4f542a1ed26db6d28b87ad2efcf4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1bd43b75b5db29b6$var$_react = $1bd43b75b5db29b6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1bd43b75b5db29b6$var$_filter = $1bd43b75b5db29b6$var$_interopRequireDefault((parcelRequire("jX361")));

var $1bd43b75b5db29b6$var$_filter2 = $1bd43b75b5db29b6$var$_interopRequireDefault((parcelRequire("bTqXB")));
function $1bd43b75b5db29b6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FilterIcon.
 * This component is FilterIcon, with `UNSAFE_fallbackIcon` set to "FilterIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for filterting data or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1bd43b75b5db29b6$var$FilterIcon = (props)=>/*#__PURE__*/ $1bd43b75b5db29b6$var$_react.default.createElement($1bd43b75b5db29b6$var$_filter.default, Object.assign({
        LEGACY_fallbackIcon: $1bd43b75b5db29b6$var$_filter2.default
    }, props));
$1bd43b75b5db29b6$var$FilterIcon.Name = 'FilterIconMigration';
var $1bd43b75b5db29b6$var$_default = module.exports.default = $1bd43b75b5db29b6$var$FilterIcon;

});
parcelRegister("bTqXB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a89be8174ef75ee$var$_react = $8a89be8174ef75ee$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $8a89be8174ef75ee$var$_filter = $8a89be8174ef75ee$var$_interopRequireDefault((parcelRequire("jX361")));
function $8a89be8174ef75ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8a89be8174ef75ee$var$FilterIcon = (props)=>/*#__PURE__*/ $8a89be8174ef75ee$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 13h10l1-2H6zM3.99 6c-.55 0-.79.41-.55.9L4 8h16l.55-1.1c.25-.5.01-.9-.54-.9zm6.79 11.56a.87.87 0 0 0 .73.44h.99c.28 0 .61-.2.73-.44L14 16h-4z"/></svg>`
    }, props, {
        newIcon: $8a89be8174ef75ee$var$_filter.default
    }));
$8a89be8174ef75ee$var$FilterIcon.displayName = 'FilterIcon';
var $8a89be8174ef75ee$var$_default = module.exports.default = $8a89be8174ef75ee$var$FilterIcon;

});


parcelRegister("bB6uF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f496fbd618fe5795b7e6b61ffefa90fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87182fe6ca83cdb6$var$_react = $87182fe6ca83cdb6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $87182fe6ca83cdb6$var$_tag = $87182fe6ca83cdb6$var$_interopRequireDefault((parcelRequire("eKl4L")));

var $87182fe6ca83cdb6$var$_label = $87182fe6ca83cdb6$var$_interopRequireDefault((parcelRequire("cL0IW")));
function $87182fe6ca83cdb6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for TagIcon.
 * This component is TagIcon, with `UNSAFE_fallbackIcon` set to "LabelIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tags in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $87182fe6ca83cdb6$var$TagIcon = (props)=>/*#__PURE__*/ $87182fe6ca83cdb6$var$_react.default.createElement($87182fe6ca83cdb6$var$_tag.default, Object.assign({
        LEGACY_fallbackIcon: $87182fe6ca83cdb6$var$_label.default
    }, props));
$87182fe6ca83cdb6$var$TagIcon.Name = 'TagIconMigration';
var $87182fe6ca83cdb6$var$_default = module.exports.default = $87182fe6ca83cdb6$var$TagIcon;

});
parcelRegister("eKl4L", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::338651941b03ec38a528c6808ae2ffcd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $abc5b5ca44dcd9b7$var$_react = $abc5b5ca44dcd9b7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $abc5b5ca44dcd9b7$var$_baseNew = $abc5b5ca44dcd9b7$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $abc5b5ca44dcd9b7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Tag".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tags in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $abc5b5ca44dcd9b7$var$TagIcon = (props)=>/*#__PURE__*/ $abc5b5ca44dcd9b7$var$_react.default.createElement($abc5b5ca44dcd9b7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2"/><path fill="currentcolor" fill-rule="evenodd" d="M9.286 1a3.25 3.25 0 0 0-2.299.952L1.604 7.336a2 2 0 0 0 0 2.828l4.232 4.232a2 2 0 0 0 2.828 0l5.384-5.383A3.25 3.25 0 0 0 15 6.714V3a2 2 0 0 0-2-2zM8.048 3.013A1.75 1.75 0 0 1 9.286 2.5H13a.5.5 0 0 1 .5.5v3.714c0 .465-.184.91-.513 1.238l-5.383 5.384a.5.5 0 0 1-.708 0L2.664 9.104a.5.5 0 0 1 0-.708z" clip-rule="evenodd"/>`
    }, props));
$abc5b5ca44dcd9b7$var$TagIcon.displayName = 'TagIcon';
var $abc5b5ca44dcd9b7$var$_default = module.exports.default = $abc5b5ca44dcd9b7$var$TagIcon;

});

parcelRegister("cL0IW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $949a6f91366cfd9f$var$_react = $949a6f91366cfd9f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $949a6f91366cfd9f$var$_tag = $949a6f91366cfd9f$var$_interopRequireDefault((parcelRequire("eKl4L")));
function $949a6f91366cfd9f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $949a6f91366cfd9f$var$LabelIcon = (props)=>/*#__PURE__*/ $949a6f91366cfd9f$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.433 5.428-4.207.6A2 2 0 0 0 5.53 7.727l-.6 4.207a1 1 0 0 0 .281.849l6.895 6.894a1 1 0 0 0 1.414 0l5.657-5.657a1 1 0 0 0 0-1.414L12.282 5.71a1 1 0 0 0-.849-.283m-.647 5.858A1.666 1.666 0 1 1 8.43 8.929a1.666 1.666 0 0 1 2.357 2.357"/></svg>`
    }, props, {
        newIcon: $949a6f91366cfd9f$var$_tag.default
    }));
$949a6f91366cfd9f$var$LabelIcon.displayName = 'LabelIcon';
var $949a6f91366cfd9f$var$_default = module.exports.default = $949a6f91366cfd9f$var$LabelIcon;

});


parcelRegister("kYQTv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e476e34ec44b4dd59a1269a5572f39d6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f46270f5595a12ea$var$_react = $f46270f5595a12ea$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f46270f5595a12ea$var$_teams = $f46270f5595a12ea$var$_interopRequireDefault((parcelRequire("c781K")));

var $f46270f5595a12ea$var$_teams2 = $f46270f5595a12ea$var$_interopRequireDefault((parcelRequire("8E9tB")));
function $f46270f5595a12ea$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for TeamsIcon.
 * This component is TeamsIcon, with `UNSAFE_fallbackIcon` set to "TeamsIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for teams in Atlassian.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f46270f5595a12ea$var$TeamsIcon = (props)=>/*#__PURE__*/ $f46270f5595a12ea$var$_react.default.createElement($f46270f5595a12ea$var$_teams.default, Object.assign({
        LEGACY_fallbackIcon: $f46270f5595a12ea$var$_teams2.default
    }, props));
$f46270f5595a12ea$var$TeamsIcon.Name = 'TeamsIconMigration';
var $f46270f5595a12ea$var$_default = module.exports.default = $f46270f5595a12ea$var$TeamsIcon;

});
parcelRegister("8E9tB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $64b968f6017085d1$var$_react = $64b968f6017085d1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $64b968f6017085d1$var$_teams = $64b968f6017085d1$var$_interopRequireDefault((parcelRequire("c781K")));
function $64b968f6017085d1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $64b968f6017085d1$var$TeamsIcon = (props)=>/*#__PURE__*/ $64b968f6017085d1$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M9 7.2a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0m1.8 0a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0m7.8 0a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0m1.8 0a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0m1.2 9.3a4.5 4.5 0 0 0-4.5-4.5h-1.378c-.484 0-1.275.127-1.875.41l.77 1.627c.14-.066.342-.129.566-.174s.421-.063.539-.063H17.1a2.7 2.7 0 0 1 2.7 2.7V18a.6.6 0 0 1-.6.6h-3.478a2.7 2.7 0 0 1-2.538-1.777l-.676-1.86A4.5 4.5 0 0 0 8.278 12H6.9a4.5 4.5 0 0 0-4.5 4.5V18a2.4 2.4 0 0 0 2.4 2.4h4.8v-1.8H4.8a.6.6 0 0 1-.6-.6v-1.5a2.7 2.7 0 0 1 2.7-2.7h1.378a2.7 2.7 0 0 1 2.538 1.777l.676 1.86a4.5 4.5 0 0 0 4.23 2.963H19.2a2.4 2.4 0 0 0 2.4-2.4z" clip-rule="evenodd"/></svg>`
    }, props, {
        newIcon: $64b968f6017085d1$var$_teams.default
    }));
$64b968f6017085d1$var$TeamsIcon.displayName = 'TeamsIcon';
var $64b968f6017085d1$var$_default = module.exports.default = $64b968f6017085d1$var$TeamsIcon;

});




parcelRegister("g5ZcC", function(module, exports) {

$parcel$export(module.exports, "SOURCE_VALUE_FIELD_NAME", () => $327b54d1894940ae$export$2acdb7270c211b02);
$parcel$export(module.exports, "SourceValuePicker", () => $327b54d1894940ae$export$427e84d70337182b);

var $5uXOq = parcelRequire("5uXOq");

var $qfj8c = parcelRequire("qfj8c");
var $7O4UO = parcelRequire("7O4UO");
var $bUa6y = parcelRequire("bUa6y");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $6prxh = parcelRequire("6prxh");

var $lq9tz = parcelRequire("lq9tz");

var $6r4tP = parcelRequire("6r4tP");
const $327b54d1894940ae$export$7b060a5763a6e199 = 'VALIDATION_ERROR_EMPTY';
const $327b54d1894940ae$export$2acdb7270c211b02 = 'sourceValue';
const $327b54d1894940ae$export$427e84d70337182b = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const formState = (0, $bUa6y.useFormState)();
    const sourceType = formState?.values.sourceType;
    if (!sourceType) return null;
    const boardSource = (0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $6r4tP.boardSourceFieldComponentMap) : (0, $6r4tP.boardSourceFieldComponentMapOld);
    const mappedSource = boardSource[sourceType];
    if (!mappedSource) {
        (0, $6prxh.fireBoardCreateErrorAnalytics)({
            error: new Error(`No source field component found for ${sourceType}`),
            id: 'unmappedSourceType'
        });
        return null;
    }
    const { component: PickerComponent, extraProps: extraProps, label: label } = mappedSource;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        key: `sourceValue-${sourceType}`,
        name: $327b54d1894940ae$export$2acdb7270c211b02,
        label: formatMessage(label),
        isRequired: true
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(PickerComponent, {
            key: `sourceValue-${sourceType}-picker`,
            label: formatMessage(label),
            ...fieldProps,
            ...extraProps
        }), error === $327b54d1894940ae$export$7b060a5763a6e199 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), {
            testId: "software-board-create.ui.modal.form.source-value-picker.error"
        }, formatMessage((0, $lq9tz.default).sourceValueEmptyError))));
};

});
parcelRegister("lq9tz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bce06a89957b13f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6bce06a89957b13f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issueTypeFieldLabel: {
        "id": "software-board-create.modal.form.source-value-picker.issue-type-field-label",
        "defaultMessage": "Issue type"
    },
    teamFieldLabel: {
        "id": "software-board-create.modal.form.source-value-picker.team-field-label",
        "defaultMessage": "Team"
    },
    labelsFieldLabel: {
        "id": "software-board-create.modal.form.source-value-picker.labels-field-label",
        "defaultMessage": "Label"
    },
    savedFilterLabel: {
        "id": "software-board-create.modal.form.source-value-picker.saved-filter-label",
        "defaultMessage": "Select a saved filter"
    },
    sourceValueEmptyError: {
        "id": "software-board-create.modal.form.source-value-picker.source-value-empty-error",
        "defaultMessage": "Please select a value"
    },
    issueTypeFieldLabelIssueTerminologyRefreshM4: {
        "id": "software-board-create.modal.form.source-value-picker.issue-type-field-label-issue-terminology-refresh-m4",
        "defaultMessage": "Work type"
    }
});

});

parcelRegister("6r4tP", function(module, exports) {

$parcel$export(module.exports, "boardSourceFieldComponentMap", () => $735afc375e726c9d$export$69996e7483e1a92f);
$parcel$export(module.exports, "boardSourceFieldComponentMapOld", () => $735afc375e726c9d$export$c6355b6dd89ea597);

var $h3KSk = parcelRequire("h3KSk");

var $aoE9s = parcelRequire("aoE9s");

var $lq9tz = parcelRequire("lq9tz");

var $bVi3d = parcelRequire("bVi3d");

var $d8KW7 = parcelRequire("d8KW7");
const $735afc375e726c9d$export$69996e7483e1a92f = {
    [(0, $h3KSk.BOARD_SOURCE_FIELDS).ISSUE_TYPES]: {
        component: (0, $aoE9s.GenericPicker),
        label: (0, $lq9tz.default).issueTypeFieldLabelIssueTerminologyRefreshM4,
        id: (0, $h3KSk.BOARD_SOURCE_FIELDS).ISSUE_TYPES,
        extraProps: {
            jqlTerm: (0, $h3KSk.BOARD_SOURCE_FIELDS_JQLTERM)[(0, $h3KSk.BOARD_SOURCE_FIELDS).ISSUE_TYPES]
        }
    },
    [(0, $h3KSk.BOARD_SOURCE_FIELDS).TEAM]: {
        component: (0, $d8KW7.TeamPicker),
        label: (0, $lq9tz.default).teamFieldLabel,
        id: (0, $h3KSk.BOARD_SOURCE_FIELDS).TEAM
    },
    [(0, $h3KSk.BOARD_SOURCE_FIELDS).LABELS]: {
        component: (0, $aoE9s.GenericPicker),
        label: (0, $lq9tz.default).labelsFieldLabel,
        id: (0, $h3KSk.BOARD_SOURCE_FIELDS).LABELS,
        extraProps: {
            jqlTerm: (0, $h3KSk.BOARD_SOURCE_FIELDS_JQLTERM)[(0, $h3KSk.BOARD_SOURCE_FIELDS).LABELS]
        }
    },
    [(0, $h3KSk.BOARD_SOURCE_FIELDS).SAVED_FILTER]: {
        component: (0, $bVi3d.SavedFilterPicker),
        label: (0, $lq9tz.default).savedFilterLabel,
        id: (0, $h3KSk.BOARD_SOURCE_FIELDS).SAVED_FILTER
    }
};
const $735afc375e726c9d$export$c6355b6dd89ea597 = {
    [(0, $h3KSk.BOARD_SOURCE_FIELDS).ISSUE_TYPES]: {
        component: (0, $aoE9s.GenericPicker),
        label: (0, $lq9tz.default).issueTypeFieldLabel,
        id: (0, $h3KSk.BOARD_SOURCE_FIELDS).ISSUE_TYPES,
        extraProps: {
            jqlTerm: (0, $h3KSk.BOARD_SOURCE_FIELDS_JQLTERM)[(0, $h3KSk.BOARD_SOURCE_FIELDS).ISSUE_TYPES]
        }
    },
    [(0, $h3KSk.BOARD_SOURCE_FIELDS).TEAM]: {
        component: (0, $d8KW7.TeamPicker),
        label: (0, $lq9tz.default).teamFieldLabel,
        id: (0, $h3KSk.BOARD_SOURCE_FIELDS).TEAM
    },
    [(0, $h3KSk.BOARD_SOURCE_FIELDS).LABELS]: {
        component: (0, $aoE9s.GenericPicker),
        label: (0, $lq9tz.default).labelsFieldLabel,
        id: (0, $h3KSk.BOARD_SOURCE_FIELDS).LABELS,
        extraProps: {
            jqlTerm: (0, $h3KSk.BOARD_SOURCE_FIELDS_JQLTERM)[(0, $h3KSk.BOARD_SOURCE_FIELDS).LABELS]
        }
    },
    [(0, $h3KSk.BOARD_SOURCE_FIELDS).SAVED_FILTER]: {
        component: (0, $bVi3d.SavedFilterPicker),
        label: (0, $lq9tz.default).savedFilterLabel,
        id: (0, $h3KSk.BOARD_SOURCE_FIELDS).SAVED_FILTER
    }
};

});
parcelRegister("aoE9s", function(module, exports) {

$parcel$export(module.exports, "GenericPicker", () => $e447e0e5a912af84$export$37d6fee5be00e6be);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $8Rkzz = parcelRequire("8Rkzz");

var $ujWmd = parcelRequire("ujWmd");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $d7FF4 = parcelRequire("d7FF4");

var $i0vxP = parcelRequire("i0vxP");

var $koVbs = parcelRequire("koVbs");

var $h3KSk = parcelRequire("h3KSk");

var $1eigM = parcelRequire("1eigM");

var $hp64R = parcelRequire("hp64R");
const $e447e0e5a912af84$var$formatOptionLabel = (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center"
    }, option.avatar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $e447e0e5a912af84$var$imgStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        appearance: "square",
        size: "xsmall",
        src: option.avatar,
        borderColor: "transparent"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e447e0e5a912af84$var$optionStyles
    }, option.label));
const $e447e0e5a912af84$export$37d6fee5be00e6be = ({ onChange: onChange, value: value, jqlTerm: jqlTerm, isInvalid: isInvalid, label: label })=>{
    const { loadOptions: loadOptions, isLoading: isLoading } = (0, $1eigM.useLoadOptionsController)();
    const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)();
    const [menuIsOpen, setMenuIsOpen] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    (0, $5uXOq.useEffect)(()=>{
        loadOptions(jqlTerm)('').then((options)=>setDefaultOptions(options));
    }, [
        jqlTerm,
        loadOptions
    ]);
    const debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((searchString, callback)=>loadOptions(jqlTerm)(searchString).then((options)=>callback(options)), (0, $h3KSk.PICKER_SEARCH_DEBOUNCE_TIME));
    const handleOnKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if (!menuIsOpen && (event.key === 'ArrowUp' || event.key === 'ArrowDown')) setMenuIsOpen(true);
        // close the menu when focusing on multi value to prevent enter key from propagating
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') setMenuIsOpen(false);
        // prevent form submission error
        if (event.key === 'Enter' && !menuIsOpen) event.preventDefault();
    }, [
        menuIsOpen
    ]);
    return /* Prevent ESC press on Select bubbling up to the modal */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i0vxP.default), {
        onEscape: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d7FF4.default), {
        "aria-label": label,
        isMulti: true,
        isLoading: isLoading,
        formatOptionLabel: $e447e0e5a912af84$var$formatOptionLabel,
        defaultOptions: defaultOptions,
        loadOptions: debouncedLoadOptions,
        onChange: onChange,
        value: value,
        placeholder: formatMessage((0, $hp64R.default).genericPickerPlaceholder),
        menuPosition: "fixed",
        classNamePrefix: "source-value-picker",
        isInvalid: isInvalid,
        onFocus: ()=>setMenuIsOpen(true),
        onBlur: ()=>setMenuIsOpen(false),
        menuIsOpen: menuIsOpen,
        blurInputOnSelect: false,
        onKeyDown: handleOnKeyDown
    }));
};
const $e447e0e5a912af84$var$imgStyles = (0, $8CUq3.xcss)({
    paddingRight: 'space.100'
});
const $e447e0e5a912af84$var$optionStyles = (0, $8CUq3.xcss)({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});

});
parcelRegister("d7FF4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac4d84cf4438daea$export$2e2bcd8739ae039);

var $eAthk = parcelRequire("eAthk");

var $3c98u = parcelRequire("3c98u");
const $ac4d84cf4438daea$var$AsyncSelect = (0, $3c98u.default)((0, $eAthk.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ac4d84cf4438daea$export$2e2bcd8739ae039 = $ac4d84cf4438daea$var$AsyncSelect;

});

parcelRegister("1eigM", function(module, exports) {

$parcel$export(module.exports, "useLoadOptionsController", () => $7d96f2b549b45260$export$50422aa3bb02e176);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $h3KSk = parcelRequire("h3KSk");

var $6prxh = parcelRequire("6prxh");

var $hN9Wa = parcelRequire("hN9Wa");

var $2NRUh = parcelRequire("2NRUh");

var $96pTU = parcelRequire("96pTU");

var $cOgwf = parcelRequire("cOgwf");
const $7d96f2b549b45260$var$errorMessageMapOld = {
    [(0, $h3KSk.BOARD_SOURCE_FIELDS_JQLTERM)[(0, $h3KSk.BOARD_SOURCE_FIELDS).ISSUE_TYPES]]: {
        title: (0, $cOgwf.default).failedToLoadIssueTypesTitle,
        description: (0, $cOgwf.default).failedToLoadIssueTypesDescription
    },
    [(0, $h3KSk.BOARD_SOURCE_FIELDS_JQLTERM)[(0, $h3KSk.BOARD_SOURCE_FIELDS).LABELS]]: {
        title: (0, $cOgwf.default).failedToLoadLabelsTitle,
        description: (0, $cOgwf.default).failedToLoadLabelsDescription
    },
    DEFAULT: {
        title: (0, $cOgwf.default).failedToLoadOptionsTitle,
        description: (0, $cOgwf.default).failedToLoadOptionsTitle
    }
};
const $7d96f2b549b45260$var$errorMessageMap = {
    [(0, $h3KSk.BOARD_SOURCE_FIELDS_JQLTERM)[(0, $h3KSk.BOARD_SOURCE_FIELDS).ISSUE_TYPES]]: {
        title: (0, $cOgwf.default).failedToLoadIssueTypesTitleIssueTerminologyRefreshM4,
        description: (0, $cOgwf.default).failedToLoadIssueTypesDescription
    },
    [(0, $h3KSk.BOARD_SOURCE_FIELDS_JQLTERM)[(0, $h3KSk.BOARD_SOURCE_FIELDS).LABELS]]: {
        title: (0, $cOgwf.default).failedToLoadLabelsTitle,
        description: (0, $cOgwf.default).failedToLoadLabelsDescription
    },
    DEFAULT: {
        title: (0, $cOgwf.default).failedToLoadOptionsTitle,
        description: (0, $cOgwf.default).failedToLoadOptionsTitle
    }
};
const $7d96f2b549b45260$export$4dface15d86304a4 = ()=>(0, $5uXOq.useState)(false);
const $7d96f2b549b45260$export$50422aa3bb02e176 = ()=>{
    const { projectId: projectId } = (0, $2NRUh.useBoardCreateContext)();
    const jqlBuilderFetch = (0, $hN9Wa.useJQLBuilderFetch)({
        projectId: projectId
    });
    const [isLoading, setIsLoading] = $7d96f2b549b45260$export$4dface15d86304a4();
    const { showErrorFlag: showErrorFlag } = (0, $96pTU.useBoardCreateFlag)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const loadOptions = (0, $5uXOq.useCallback)((jqlTerm)=>async (searchString)=>{
            setIsLoading(true);
            const errorMessages = (0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? $7d96f2b549b45260$var$errorMessageMap : $7d96f2b549b45260$var$errorMessageMapOld;
            return jqlBuilderFetch(jqlTerm, searchString).catch((error)=>{
                const errorText = errorMessages[jqlTerm] || errorMessages.DEFAULT;
                showErrorFlag({
                    title: formatMessage(errorText.title),
                    description: formatMessage(errorText.description)
                });
                (0, $6prxh.fireBoardCreateErrorAnalytics)({
                    error: new Error(`Failed to fetch picker options: ${error}`),
                    attributes: {
                        jqlTerm: jqlTerm
                    },
                    id: 'fetchPickerOptions'
                });
                return [];
            }).finally(()=>{
                setIsLoading(false);
            });
        }, [
        formatMessage,
        jqlBuilderFetch,
        setIsLoading,
        showErrorFlag
    ]);
    return {
        loadOptions: loadOptions,
        isLoading: isLoading
    };
};

});
parcelRegister("hN9Wa", function(module, exports) {

$parcel$export(module.exports, "useJQLBuilderFetch", () => $270d18388ecfb4c0$export$a8efb2384cee4751);

var $5xKik = parcelRequire("5xKik");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $koeKL = parcelRequire("koeKL");
const $270d18388ecfb4c0$export$a8efb2384cee4751 = ({ projectId: projectId })=>{
    if (projectId === undefined) throw new Error('Project ID is undefined');
    const cloudId = (0, $koeKL.useCloudId)();
    const environment = (0, $8Uumt.useRelayEnvironment)();
    return (0, $5uXOq.useCallback)(async (jqlTerm, searchString)=>(0, $8Uumt.fetchQuery)(environment, (0, $5xKik.default), {
            cloudId: cloudId,
            jqlTerm: jqlTerm,
            jql: `project = ${projectId}`,
            searchString: searchString
        }).toPromise().then((response)=>{
            if (response?.jira?.jqlBuilder?.fieldValues?.edges) {
                const data = response.jira.jqlBuilder.fieldValues.edges.map((edge)=>{
                    if (jqlTerm === 'type') return {
                        label: edge?.node?.displayName || '',
                        value: edge?.node?.issueTypes && edge?.node?.issueTypes[0]?.issueTypeId || '',
                        avatar: edge?.node?.issueTypes && edge?.node?.issueTypes[0].avatar?.small || ''
                    };
                    return {
                        label: edge?.node?.displayName || '',
                        value: edge?.node?.displayName || ''
                    };
                }) || [];
                return data;
            }
            throw new Error('No response');
        }), [
        cloudId,
        environment,
        projectId
    ]);
};

});
parcelRegister("5xKik", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fa4b5f990b2941c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<88e6b74d9cd0f6199e352d7287cdc139>>
 * @relayHash 550be86a84988bdbd21f24b80ceb24b9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9c1b5bc55b0e3a4a61ff20a7b89ec0bf355a6530849d7e75a79eb5d499feda60
const $2fa4b5f990b2941c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jqlTerm"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchString"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "jqlContext",
            "variableName": "jql"
        },
        {
            "kind": "Variable",
            "name": "jqlTerm",
            "variableName": "jqlTerm"
        },
        {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "searchString"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v7 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v8 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            v6 /*: any*/ 
        ],
        "type": "JiraJqlLabelFieldValue"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useJqlBuilderFetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "JiraJqlFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldValues",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraJqlFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        v8 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueTypeFieldValue"
                                                        },
                                                        v9 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useJqlBuilderFetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "JiraJqlFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldValues",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraJqlFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "id"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueTypeFieldValue"
                                                        },
                                                        v9 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9c1b5bc55b0e3a4a61ff20a7b89ec0bf355a6530849d7e75a79eb5d499feda60",
            "metadata": {},
            "name": "useJqlBuilderFetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$2fa4b5f990b2941c$var$node.hash = "f9c373fe0144a8b52692f108c8ed6461";
var $2fa4b5f990b2941c$export$2e2bcd8739ae039 = $2fa4b5f990b2941c$var$node;

});


parcelRegister("cOgwf", function(module, exports) {

$parcel$export(module.exports, "default", () => $df0d6f28e92c570a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $df0d6f28e92c570a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    failedToLoadIssueTypesTitle: {
        "id": "software-board-create.controllers.use-load-options-controller.failed-to-load-issue-types-title",
        "defaultMessage": "We can\u2019t load issue types right now"
    },
    failedToLoadIssueTypesDescription: {
        "id": "software-board-create.controllers.use-load-options-controller.failed-to-load-issue-types-description",
        "defaultMessage": "Refresh the page and try again."
    },
    failedToLoadLabelsTitle: {
        "id": "software-board-create.controllers.use-load-options-controller.failed-to-load-labels-title",
        "defaultMessage": "We can\u2019t load labels right now"
    },
    failedToLoadLabelsDescription: {
        "id": "software-board-create.controllers.use-load-options-controller.failed-to-load-labels-description",
        "defaultMessage": "Refresh the page and try again."
    },
    failedToLoadOptionsTitle: {
        "id": "software-board-create.controllers.use-load-options-controller.failed-to-load-options-title",
        "defaultMessage": "Something went wrong"
    },
    failedToLoadOptionsDescription: {
        "id": "software-board-create.controllers.use-load-options-controller.failed-to-load-options-description",
        "defaultMessage": "Refresh the page and try again."
    },
    failedToLoadIssueTypesTitleIssueTerminologyRefreshM4: {
        "id": "software-board-create.controllers.use-load-options-controller.failed-to-load-issue-types-title-issue-terminology-refresh-m4",
        "defaultMessage": "We can\u2019t load work types right now"
    }
});

});


parcelRegister("hp64R", function(module, exports) {

$parcel$export(module.exports, "default", () => $92cf92e0de820ada$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $92cf92e0de820ada$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    // Delete genericPickerAriaLabel when cleaning up nav4_simplified_board_create_beta
    genericPickerAriaLabel: {
        "id": "software-board-create.modal.form.source-value-picker.generic-picker.generic-picker-aria-label",
        "defaultMessage": "Select an option"
    },
    genericPickerPlaceholder: {
        "id": "software-board-create.modal.form.source-value-picker.generic-picker.generic-picker-placeholder",
        "defaultMessage": "Select"
    }
});

});


parcelRegister("bVi3d", function(module, exports) {

$parcel$export(module.exports, "SavedFilterPicker", () => $42f519acc50d59d9$export$7408ad1ebc985020);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $8Rkzz = parcelRequire("8Rkzz");

var $2o8gl = parcelRequire("2o8gl");

var $bUmQV = parcelRequire("bUmQV");

var $d7FF4 = parcelRequire("d7FF4");

var $i0vxP = parcelRequire("i0vxP");

var $koVbs = parcelRequire("koVbs");

var $h3KSk = parcelRequire("h3KSk");

var $j7OAx = parcelRequire("j7OAx");

var $jkPTf = parcelRequire("jkPTf");
const $42f519acc50d59d9$var$formatOptionLabel = (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2o8gl))), {
        spacing: "spacious",
        label: option.label
    }), option.label);
const $42f519acc50d59d9$export$7408ad1ebc985020 = ({ onChange: onChange, value: value, isInvalid: isInvalid, label: label })=>{
    const { loadOptions: loadOptions, isLoading: isLoading } = (0, $j7OAx.useLoadSavedFiltersController)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((searchString, callback)=>loadOptions(searchString).then((options)=>callback(options)), (0, $h3KSk.PICKER_SEARCH_DEBOUNCE_TIME));
    return /* Prevent ESC press on Select bubbling up to the modal */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i0vxP.default), {
        onEscape: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d7FF4.default), {
        "aria-label": label,
        isLoading: isLoading,
        formatOptionLabel: $42f519acc50d59d9$var$formatOptionLabel,
        defaultOptions: true,
        loadOptions: debouncedLoadOptions,
        onChange: onChange,
        value: value,
        placeholder: formatMessage((0, $jkPTf.default).savedFilterPickerPlaceholder),
        menuPosition: "fixed",
        classNamePrefix: "source-value-picker",
        isInvalid: isInvalid
    }));
};

});
parcelRegister("j7OAx", function(module, exports) {

$parcel$export(module.exports, "useLoadSavedFiltersController", () => $c506adadb53c5f15$export$bb3a63b49faf836c);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $6p4sE = parcelRequire("6p4sE");

var $6prxh = parcelRequire("6prxh");

var $96S1K = parcelRequire("96S1K");

var $96pTU = parcelRequire("96pTU");
const $c506adadb53c5f15$export$4dface15d86304a4 = ()=>(0, $5uXOq.useState)(false);
const $c506adadb53c5f15$export$bb3a63b49faf836c = ()=>{
    const savedFiltersFetch = (0, $96S1K.useSavedFiltersFetch)();
    const [isLoading, setIsLoading] = $c506adadb53c5f15$export$4dface15d86304a4();
    const { showErrorFlag: showErrorFlag } = (0, $96pTU.useBoardCreateFlag)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const loadOptions = (0, $5uXOq.useCallback)(async (searchString)=>{
        setIsLoading(true);
        return savedFiltersFetch(searchString).catch((error)=>{
            showErrorFlag({
                title: formatMessage((0, $6p4sE.default).loadSavedFiltersErrorTitle),
                description: formatMessage((0, $6p4sE.default).loadSavedFiltersErrorDescription)
            });
            (0, $6prxh.fireBoardCreateErrorAnalytics)({
                error: new Error(`Failed to fetch saved filters: ${error}`),
                id: 'fetchSavedFilters'
            });
            return [];
        }).finally(()=>{
            setIsLoading(false);
        });
    }, [
        formatMessage,
        savedFiltersFetch,
        setIsLoading,
        showErrorFlag
    ]);
    return {
        loadOptions: loadOptions,
        isLoading: isLoading
    };
};

});
parcelRegister("96S1K", function(module, exports) {

$parcel$export(module.exports, "useSavedFiltersFetch", () => $c60033a932502cc6$export$919a4c273fb6b0e5);

var $hNMmP = parcelRequire("hNMmP");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $koeKL = parcelRequire("koeKL");
const $c60033a932502cc6$export$919a4c273fb6b0e5 = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const environment = (0, $8Uumt.useRelayEnvironment)();
    return (0, $5uXOq.useCallback)(async (searchString)=>(0, $8Uumt.fetchQuery)(environment, (0, $hNMmP.default), {
            cloudId: cloudId,
            searchString: searchString
        }).toPromise().then((response)=>{
            if (response?.jira?.savedFilters?.edges) {
                const data = response.jira.savedFilters.edges.map((edge)=>{
                    return {
                        label: edge?.node?.name || '',
                        value: edge?.node?.filterId || ''
                    };
                }) || [];
                return data;
            }
            throw new Error('No response');
        }), [
        cloudId,
        environment
    ]);
};

});
parcelRegister("hNMmP", function(module, exports) {

$parcel$export(module.exports, "default", () => $15727aff43405dba$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7661fff4909318f923a859e991c3f990>>
 * @relayHash 6e5fec99171872e06e6faef5354994ff
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1c54fe404b07b4a4533c203ab6c68bf936d5a086953aa1a446da9bec5a0a67f5
const $15727aff43405dba$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "searchString"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        },
        {
            "kind": "Variable",
            "name": "keyword",
            "variableName": "searchString"
        }
    ], v2 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "filterId"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ],
        "type": "JiraCustomFilter"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSavedFiltersFetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v1 /*: any*/ ,
                                "concreteType": "JiraFilterConnection",
                                "kind": "LinkedField",
                                "name": "savedFilters",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraFilterEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ 
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "jira.savedFilters.edges.node"
                                            }
                                        ]
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.savedFilters"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSavedFiltersFetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraFilterConnection",
                            "kind": "LinkedField",
                            "name": "savedFilters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraFilterEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1c54fe404b07b4a4533c203ab6c68bf936d5a086953aa1a446da9bec5a0a67f5",
            "metadata": {},
            "name": "useSavedFiltersFetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$15727aff43405dba$var$node.hash = "69a6cd0661c8d852b37f79d9513a1db0";
var $15727aff43405dba$export$2e2bcd8739ae039 = $15727aff43405dba$var$node;

});



parcelRegister("jkPTf", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4a2c8c458ce637b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b4a2c8c458ce637b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    // Delete savedFilterPickerAriaLabel when cleaning up nav4_simplified_board_create_beta
    savedFilterPickerAriaLabel: {
        "id": "software-board-create.modal.form.source-value-picker.saved-filter-picker.saved-filter-picker-aria-label",
        "defaultMessage": "Select an option"
    },
    savedFilterPickerPlaceholder: {
        "id": "software-board-create.modal.form.source-value-picker.saved-filter-picker.saved-filter-picker-placeholder",
        "defaultMessage": "Select"
    }
});

});


parcelRegister("d8KW7", function(module, exports) {

$parcel$export(module.exports, "TeamPicker", () => $6335ae6b67167392$export$3529dc978be43e9d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $dqoiX = parcelRequire("dqoiX");

var $i0vxP = parcelRequire("i0vxP");

var $b71gk = parcelRequire("b71gk");

var $koVbs = parcelRequire("koVbs");

var $8vFwj = parcelRequire("8vFwj");

var $hgQ4J = parcelRequire("hgQ4J");

var $koeKL = parcelRequire("koeKL");

var $ghnVw = parcelRequire("ghnVw");
const $6335ae6b67167392$var$TEAM_A11Y_LABEL_ID = 'software-board-create.source-value.team';
const $6335ae6b67167392$export$3529dc978be43e9d = ({ onChange: onChange, value: value, isInvalid: isInvalid, label: label })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const handleOnCreate = (0, $5uXOq.useCallback)((team)=>{
        if (!team) return;
        // wait for the team to be created before updating the value
        setTimeout(()=>{
            onChange(team);
        }, 1000);
    }, [
        onChange
    ]);
    const [createTeamDialog, createTeamDialogTrigger] = (0, $8vFwj.useCreateTeamDialog)({
        onCreate: handleOnCreate
    });
    const handleChange = (team)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        onChange?.(team || null);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6335ae6b67167392$var$TeamPickerEditWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
        id: $6335ae6b67167392$var$TEAM_A11Y_LABEL_ID
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i0vxP.default), {
        onEscape: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hgQ4J.TeamPickerEdit), {
        siteId: cloudId,
        isCompact: false,
        hasNoTeamOption: false,
        createTeamDialogTrigger: createTeamDialogTrigger,
        placeholder: formatMessage((0, $ghnVw.default).placeholder),
        onChange: handleChange,
        defaultValue: value,
        isDropdownMenuFixedAndLayered: true,
        isInvalid: isInvalid,
        isClearable: false,
        "aria-labelledby": $6335ae6b67167392$var$TEAM_A11Y_LABEL_ID
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "board-create-team-create-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", {
        tabIndex: -1,
        name: "create-team-dialog-form",
        onSubmit: (e)=>{
            e.stopPropagation();
        },
        className: (0, $bwpsq.default)([
            "_1e0cglyw"
        ])
    }, createTeamDialog)));
};
const $6335ae6b67167392$var$removeFormSpaceStyle = null; // TODO: remove this after select compiled migration
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $6335ae6b67167392$var$TeamPickerEditWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_b9cj1fu0 _t0z71fu0",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8vFwj", function(module, exports) {

$parcel$export(module.exports, "useCreateTeamDialog", () => $e708dcb0d93e7fe3$export$e8b8170429d616be);

var $5uXOq = parcelRequire("5uXOq");

var $euiLX = parcelRequire("euiLX");

var $pa9q9 = parcelRequire("pa9q9");

var $1wpPp = parcelRequire("1wpPp");

var $4ywcn = parcelRequire("4ywcn");

var $8igKv = parcelRequire("8igKv");

var $koVbs = parcelRequire("koVbs");

var $lfTZh = parcelRequire("lfTZh");

var $cYlk7 = parcelRequire("cYlk7");

var $14XJw = parcelRequire("14XJw");

var $9OXo1 = parcelRequire("9OXo1");

var $0Wtmq = parcelRequire("0Wtmq");

var $kxZPA = parcelRequire("kxZPA");

const $e708dcb0d93e7fe3$export$75096afde50756fd = (0, $kxZPA.lazy)(()=>(parcelRequire("gQzjM")).then((module)=>module.TeamCreateDialog), {
    moduleId: "../platform/packages/people-and-teams/people-teams/src/index.ts"
});
const $e708dcb0d93e7fe3$export$e8b8170429d616be = (props = {})=>{
    const { locale: locale } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const [inputTeamName, setInputTeamName] = (0, $5uXOq.useState)('');
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { cloudId: cloudId, atlassianAccountId: atlassianAccountId } = tenantContext;
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const { data: { user: user } } = (0, $cYlk7.useCurrentUser)();
    if (!atlassianAccountId && !user.accountId) throw new Error('Missing current user id');
    const addFlag = (0, $5uXOq.useCallback)(({ appearance: appearance, ...flagProps })=>{
        if (appearance === 'success' || appearance === 'normal') showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4ywcn.default), {
                messageId: "issue-field-create-team-dialog.ui.use-create-team-dialog.success-flag",
                messageType: "transactional",
                ...flagProps,
                ...serviceProps
            }));
        if (appearance === 'warning') showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8igKv.default), {
                messageId: "issue-field-create-team-dialog.ui.use-create-team-dialog.warning-flag",
                messageType: "transactional",
                ...flagProps,
                ...serviceProps
            }));
        if (appearance === 'error') showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wpPp.default), {
                messageId: "issue-field-create-team-dialog.ui.use-create-team-dialog.error-flag",
                messageType: "transactional",
                ...flagProps,
                ...serviceProps
            }));
    }, [
        showFlag
    ]);
    const { onCancel: onCancel } = {
        onCancel: ()=>null,
        ...props
    };
    const callback = (0, $5uXOq.useCallback)((teamName)=>{
        setInputTeamName(teamName);
        setIsOpen(true);
    }, []);
    const handleOnClose = ()=>{
        setIsOpen(false);
        onCancel();
    };
    const handleOnCreate = (team)=>{
        const formattedTeam = {
            ...team,
            name: team.displayName
        };
        props.onCreate?.(formattedTeam);
    };
    return [
        isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "team-create-dialog"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0Wtmq.PeopleAndTeamsConfigurationProvider), {
            product: "jira",
            locale: (0, $euiLX.default)(locale)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e708dcb0d93e7fe3$export$75096afde50756fd, {
            cloudId: cloudId,
            orgId: orgId,
            product: "jira",
            principalId: atlassianAccountId || user.accountId || '',
            onClose: handleOnClose,
            onCreateTeamSuccess: handleOnCreate,
            extraAnalyticsAttrs: props.analyticsCtx,
            enableMembershipSettingsChoice: true,
            currentUser: user.accountId ? {
                id: user.accountId,
                fullName: user.userFullname,
                // @ts-expect-error - TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
                avatarUrl: user.avatarUrls && user.avatarUrls['48x48'],
                ...user
            } : undefined,
            prepopulatedFields: {
                teamName: inputTeamName
            },
            addFlag: addFlag
        }))) : null,
        callback
    ];
};

});
parcelRegister("euiLX", function(module, exports) {

$parcel$export(module.exports, "default", () => $838bf5d423642311$export$2e2bcd8739ae039);
/**
 * This function is being used to address locale discrepancies in Atlassian products:
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ const $838bf5d423642311$export$852ff24d0930c62f = (locale)=>{
    const standardizedLocale = locale.replace('_', '-');
    switch(standardizedLocale){
        case 'en-GB':
        case 'en-US':
        case 'en-XA':
        case 'en-XB':
        case 'en-ZZ':
        case 'pt-BR':
        case 'zh-CN':
        case 'zh-TW':
            return standardizedLocale;
        case 'en-UK':
            return 'en-GB';
        case 'en':
            return 'en-US';
        default:
            return standardizedLocale.split('-')[0];
    }
};
var $838bf5d423642311$export$2e2bcd8739ae039 = $838bf5d423642311$export$852ff24d0930c62f;

});

parcelRegister("1wpPp", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ebed3b5115fbfc5$export$2e2bcd8739ae039);

var $3KRpp = parcelRequire("3KRpp");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$2ebed3b5115fbfc5$export$2e2bcd8739ae039 = (0, $3KRpp.ErrorFlag);

});
parcelRegister("3KRpp", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $ef767762d5402ccf$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $ef767762d5402ccf$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $ef767762d5402ccf$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $ef767762d5402ccf$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $ef767762d5402ccf$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $ef767762d5402ccf$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $ef767762d5402ccf$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $ef767762d5402ccf$export$a2c3479950310d7d);

var $5uXOq = parcelRequire("5uXOq");

var $iNWLk = parcelRequire("iNWLk");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$ForPaintJiraCommonFlag = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("8XC7W")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$AfterPaintJiraCommonFlag = (0, $kxZPA.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("8XC7W")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $ef767762d5402ccf$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintJiraCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintJiraCommonFlag, props);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$ForPaintFlagGroup = (0, $kxZPA.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("a8Hbj")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$AfterPaintFlagGroup = (0, $kxZPA.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("a8Hbj")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $ef767762d5402ccf$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintFlagGroup, props);
const $ef767762d5402ccf$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, props));
const $ef767762d5402ccf$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $ef767762d5402ccf$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $ef767762d5402ccf$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $ef767762d5402ccf$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $ef767762d5402ccf$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $ef767762d5402ccf$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $ef767762d5402ccf$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$FlagGroupImpl, props));

});
parcelRegister("iNWLk", function(module, exports) {

$parcel$export(module.exports, "FlagsBoundary", () => $6377b132f88aa82c$export$8b4a0fffcddd96f4);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");
const $6377b132f88aa82c$export$8b4a0fffcddd96f4 = ({ children: children, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "flags",
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "flags-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, children));

});

parcelRegister("8XC7W", function(module, exports) {

let $686168aa9b882863$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $686168aa9b882863$var$load("ffQaD"),
    $686168aa9b882863$var$load("kvRbA"),
    $686168aa9b882863$var$load("76n7a"),
    $686168aa9b882863$var$load("l253H"),
    $686168aa9b882863$var$load("eH8ke")
]).then(()=>parcelRequire('8ZHDV'));

});

parcelRegister("a8Hbj", function(module, exports) {

let $761c25b21fad9e16$var$load = (parcelRequire("28QjX"))(4);
module.exports = $761c25b21fad9e16$var$load("1PJIF").then(()=>parcelRequire('5pz6a'));

});



parcelRegister("4ywcn", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a612b92e24f3853$export$2e2bcd8739ae039);

var $3KRpp = parcelRequire("3KRpp");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$1a612b92e24f3853$export$2e2bcd8739ae039 = (0, $3KRpp.SuccessFlag);

});

parcelRegister("8igKv", function(module, exports) {

$parcel$export(module.exports, "default", () => $87b804070d792a00$export$2e2bcd8739ae039);

var $3KRpp = parcelRequire("3KRpp");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$87b804070d792a00$export$2e2bcd8739ae039 = (0, $3KRpp.WarningFlag);

});

parcelRegister("cYlk7", function(module, exports) {

$parcel$export(module.exports, "useCurrentUser", () => $cdd4ab536fcf9459$export$3901076af3749fa9);

var $5uXOq = parcelRequire("5uXOq");

var $lzeFL = parcelRequire("lzeFL");

var $9OXo1 = parcelRequire("9OXo1");

var $leRCk = parcelRequire("leRCk");
const $cdd4ab536fcf9459$var$useCurrentUserBasic = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return (0, $5uXOq.useMemo)(()=>({
            data: {
                user: {
                    accountId: tenantContext.atlassianAccountId,
                    isAdmin: tenantContext.isAdmin,
                    isAnonymous: tenantContext.isAnonymous,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    locale: tenantContext.locale || (0, $lzeFL.defaultLocale),
                    siteAdminStatus: tenantContext.siteAdminStatus,
                    userFullname: tenantContext.userFullname || ''
                }
            },
            loading: false,
            error: null
        }), [
        tenantContext.atlassianAccountId,
        tenantContext.isAdmin,
        tenantContext.isAnonymous,
        tenantContext.isSiteAdmin,
        tenantContext.locale,
        tenantContext.siteAdminStatus,
        tenantContext.userFullname
    ]);
};
const $cdd4ab536fcf9459$var$useCurrentUserFull = ()=>{
    const { data: dataBasic } = $cdd4ab536fcf9459$var$useCurrentUserBasic();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const [{ data: data, loading: loading, error: error }, { fetch: fetch }] = (0, $leRCk.useUserSubscriber)();
    (0, $5uXOq.useEffect)(()=>{
        tenantContext.atlassianAccountId && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        fetch({
            params: {
                accountId: tenantContext.atlassianAccountId
            }
        }, false);
    }, [
        fetch,
        tenantContext.atlassianAccountId
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            data: {
                ...dataBasic,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                user: {
                    ...dataBasic.user,
                    ...data
                }
            },
            loading: loading,
            error: error
        }), [
        data,
        dataBasic,
        error,
        loading
    ]);
};
const $cdd4ab536fcf9459$export$3901076af3749fa9 = ()=>// eslint-disable-next-line react-hooks/react-compiler
    (0, $9OXo1.useTenantContext)().isAnonymous ? $cdd4ab536fcf9459$var$useCurrentUserBasic() : $cdd4ab536fcf9459$var$useCurrentUserFull(); // eslint-disable-line react-hooks/rules-of-hooks
const $cdd4ab536fcf9459$export$6414ebbbfff99d4c = ({ children: children })=>{
    const result = $cdd4ab536fcf9459$export$3901076af3749fa9();
    return children(result);
};

});
parcelRegister("leRCk", function(module, exports) {

$parcel$export(module.exports, "UserContainer", () => $46a581f1f6efe569$export$7ff085589970ee0a);
$parcel$export(module.exports, "useUserSubscriber", () => $46a581f1f6efe569$export$4e61bbf568682a96);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $314C6 = parcelRequire("314C6");
const $46a581f1f6efe569$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $46a581f1f6efe569$var$Store = (0, $iXqE5.createStore)({
    name: 'user',
    initialState: $46a581f1f6efe569$var$initialState,
    actions: $314C6
});
const $46a581f1f6efe569$export$7ff085589970ee0a = (0, $gg7kZ.createContainer)($46a581f1f6efe569$var$Store);
const $46a581f1f6efe569$export$4e61bbf568682a96 = (0, $3sQ5x.createHook)($46a581f1f6efe569$var$Store);

});
parcelRegister("314C6", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $acdfee9161693eca$export$e7aa7bc5c1b3cfb3);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iF3m5 = parcelRequire("iF3m5");
const $acdfee9161693eca$export$e7aa7bc5c1b3cfb3 = ({ params: params, header: header }, forceRefetch = false)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!params || currentState.loading || currentState.data && !forceRefetch) return;
        setState({
            loading: true
        });
        try {
            const data = await (0, $iF3m5.fetchData)({
                params: params,
                header: header
            });
            setState({
                data: data,
                loading: false,
                error: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err,
                loading: false
            });
        }
    };

});
parcelRegister("iF3m5", function(module, exports) {

$parcel$export(module.exports, "fetchData", () => $d22d4c6d892f61f1$export$8134c072fddab6a5);

var $ebyGx = parcelRequire("ebyGx");

var $8QpSo = parcelRequire("8QpSo");

var $eusud = parcelRequire("eusud");

var $4R6GH = parcelRequire("4R6GH");

var $e5wyW = parcelRequire("e5wyW");

var $6Z846 = parcelRequire("6Z846");
const $d22d4c6d892f61f1$export$5e5a6664039ed1cc = ({ params: params, header: header })=>{
    const queryParams = {
        ...params,
        expand: Object.keys(params.expand || {}).filter((key)=>params.expand && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            params.expand[key])
    };
    const query = (0, $ebyGx.stringify)(queryParams, {
        arrayFormat: 'none'
    });
    const queryString = query ? `?${query}` : '';
    const requestUrl = `/rest/api/2/user${queryString}`;
    // @ts-expect-error - TS2345 - Argument of type '{ headers: HeaderParamForceAccountId; } | {}' is not assignable to parameter of type 'RequestInit | undefined'.
    return (0, $eusud.performGetRequest)(requestUrl, header ? {
        headers: header
    } : {});
};
const $d22d4c6d892f61f1$var$fetchDataNew = (0, $8QpSo.default)($d22d4c6d892f61f1$export$5e5a6664039ed1cc, (newArgs, lastArgs)=>// compare params and headers to see if it should be memoised.
    (0, $6Z846.isShallowEqual)(newArgs[0].params, lastArgs[0].params) && (0, $6Z846.isShallowEqual)(newArgs[0].header, lastArgs[0].header));
const $d22d4c6d892f61f1$export$8134c072fddab6a5 = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('user-iv-llc-unnecessary-api'), $d22d4c6d892f61f1$var$fetchDataNew, $d22d4c6d892f61f1$export$5e5a6664039ed1cc);

});




parcelRegister("0Wtmq", function(module, exports) {

$parcel$export(module.exports, "PeopleAndTeamsConfigurationProvider", () => $7fcc2b6dd0426004$export$d3f5bd36d1c6597e);
$parcel$export(module.exports, "usePeopleAndTeamsConfigurationContext", () => $7fcc2b6dd0426004$export$130340d16a670190);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $btDaU = parcelRequire("btDaU");

var $fkT8h = parcelRequire("fkT8h");

var $9Xnkh = parcelRequire("9Xnkh");

var $epGv3 = parcelRequire("epGv3");
const $7fcc2b6dd0426004$export$8a37839ac1e08b25 = /*#__PURE__*/ (0, $5uXOq.createContext)((0, $9Xnkh.DEFAULT_CONTEXT));
const $7fcc2b6dd0426004$export$3bf19eb896b777b8 = ({ children: children, locale: locale, product: product, teamPermissions: teamPermissions, orgId: orgId, teamPermissionCheckEnabled: teamPermissionCheckEnabled = false })=>{
    const overrides = (0, $epGv3.usePeopleAndTeamsConfigurationOverrides)(teamPermissionCheckEnabled, orgId, teamPermissions);
    const artifact = (0, $fkT8h.usePeopleAndTeamsRemoteArtifact)(product, locale, overrides);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($7fcc2b6dd0426004$export$8a37839ac1e08b25.Provider, {
        value: artifact || (0, $9Xnkh.DEFAULT_CONTEXT),
        children: children
    });
};
const $7fcc2b6dd0426004$export$d3f5bd36d1c6597e = ({ children: children, locale: locale, product: product, teamPermissions: teamPermissions, teamPermissionCheckEnabled: teamPermissionCheckEnabled, orgId: orgId, ...flightDeckProps })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $btDaU.FlightDeckProvider), {
        product: product,
        ...flightDeckProps,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($7fcc2b6dd0426004$export$3bf19eb896b777b8, {
            locale: locale,
            product: product,
            teamPermissions: teamPermissions,
            teamPermissionCheckEnabled: teamPermissionCheckEnabled,
            orgId: orgId,
            children: children
        })
    });
};
const $7fcc2b6dd0426004$export$130340d16a670190 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($7fcc2b6dd0426004$export$8a37839ac1e08b25);

});
parcelRegister("btDaU", function(module, exports) {

$parcel$export(module.exports, "FlightDeckProvider", () => $85b0ca77dee62619$export$56da85ac9d40dbcd);
$parcel$export(module.exports, "useFlightDeckContext", () => $85b0ca77dee62619$export$73c96350a5e69ec);
$parcel$export(module.exports, "useFlightDeckArtifact", () => $85b0ca77dee62619$export$3b241cde208d2c5e);

var $5uXOq = parcelRequire("5uXOq");

var $6HV40 = parcelRequire("6HV40");
const $85b0ca77dee62619$export$ca1b33377afa620 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    getArtifact: null
});
function $85b0ca77dee62619$export$56da85ac9d40dbcd({ children: children, product: product, config: config, fallbackArtifacts: fallbackArtifacts }) {
    const flightDeckClient = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        return new (0, $6HV40.default)(product, {
            handlers: {
                captureException: config === null || config === void 0 ? void 0 : config.captureException
            }
        }, fallbackArtifacts);
    }, [
        product,
        config === null || config === void 0 ? void 0 : config.captureException,
        fallbackArtifacts
    ]);
    const getArtifact = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(async (name, dimensions)=>{
        return flightDeckClient.fetchConfigFromFlightDeck({
            name: name,
            dimensions: dimensions
        });
    }, [
        flightDeckClient
    ]);
    const providerValue = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>({
            getArtifact: getArtifact
        }), [
        getArtifact
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($85b0ca77dee62619$export$ca1b33377afa620.Provider, {
        value: providerValue
    }, children);
}
const $85b0ca77dee62619$export$73c96350a5e69ec = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($85b0ca77dee62619$export$ca1b33377afa620);
function $85b0ca77dee62619$export$3b241cde208d2c5e(key, dimensions) {
    const [artifact, setArtifact] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState();
    const { getArtifact: getArtifact } = $85b0ca77dee62619$export$73c96350a5e69ec();
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        if (!getArtifact) throw new Error("Flight Deck Context not provided");
        getArtifact(key, dimensions).then((resp)=>setArtifact(resp))// we don't need to do anything with the error as it is already instrumented in the flightDeckClient
        .catch();
    }, [
        dimensions,
        key,
        getArtifact,
        setArtifact
    ]);
    return artifact;
}

});
parcelRegister("6HV40", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e2305dbe349082f$export$2e2bcd8739ae039);

var $eHiP8 = parcelRequire("eHiP8");

var $6fYNv = parcelRequire("6fYNv");

var $jtD64 = parcelRequire("jtD64");

var $fynqv = parcelRequire("fynqv");

var $lKWnb = parcelRequire("lKWnb");

var $4r7nA = parcelRequire("4r7nA");

var $814TT = parcelRequire("814TT");
function $4e2305dbe349082f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4e2305dbe349082f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4e2305dbe349082f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eHiP8.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4e2305dbe349082f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $4e2305dbe349082f$var$STORAGE_KEY_BASE = "@atlassiansox/flight-deck-frontend-client";
const $4e2305dbe349082f$var$RETRIABLE_FD_ERROR_MESSAGES = [
    "Failed to fetch",
    "NetworkError when attempting to fetch resource.",
    "Load failed"
];
class $4e2305dbe349082f$export$2e2bcd8739ae039 {
    constructor(product, options = {
        handlers: {}
    }, fallbackArtifacts = []){
        (0, $eHiP8.default)(this, "fallbackArtifactMap", new Map());
        (0, $eHiP8.default)(this, "fetchFromFlightDeckPromises", new Map());
        this.expiryMS = options.expiryMS;
        this.handlers = options.handlers;
        this.product = product;
        this.storageClient = new (0, $jtD64.default)($4e2305dbe349082f$var$STORAGE_KEY_BASE, options);
        fallbackArtifacts.forEach((artifact)=>this.fallbackArtifactMap.set((0, $4r7nA.artifactKey)(artifact.name, artifact.dimensions), artifact.value));
        this.captureException = this.captureException.bind(this);
    }
    captureException(e, tags) {
        if (this.handlers.captureException) this.handlers.captureException(e, tags);
    }
    async fetchAndCacheArtifact(artifact, retryConfig) {
        const response = await (0, $6fYNv.retryOnException)(async ()=>{
            try {
                // await the result here so that we capture any errors
                const result = await (0, $fynqv.fetchFlightDeckConfiguration)(artifact.name, artifact.dimensions);
                return result;
            } catch (error) {
                throw new (0, $lKWnb.default)({
                    artifact: artifact.key,
                    dimensions: artifact.dimensions,
                    error: error
                });
            }
        }, {
            captureException: this.captureException,
            retryOn: (err)=>$4e2305dbe349082f$var$RETRIABLE_FD_ERROR_MESSAGES.includes(err.message),
            intervalsMS: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.intervalsMS,
            onRetry: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.onRetry
        });
        if (!response) {
            const missingArtifactError = new Error(`Missing artifact: ${artifact.key}`);
            this.captureException(missingArtifactError);
            throw missingArtifactError;
        }
        this.storageClient.setItemWithExpiry(artifact.key, response, this.expiryMS);
        // Clear the in-flight check
        this.fetchFromFlightDeckPromises.delete(artifact.key);
        return response;
    }
    async fetchArtifactPromise(artifact, retryConfig) {
        // Check for in-flight requests for this artifact
        if (this.fetchFromFlightDeckPromises.has(artifact.key)) return this.fetchFromFlightDeckPromises.get(artifact.key);
        const fetchPromise = this.fetchAndCacheArtifact(artifact, retryConfig);
        this.fetchFromFlightDeckPromises.set(artifact.key, fetchPromise);
        return fetchPromise;
    }
    async fetchConfigFromFlightDeck(artifact, retryConfig) {
        const experience = (0, $814TT.flightDeckClientExperience)();
        experience.start();
        try {
            const artifactWithKey = $4e2305dbe349082f$var$_objectSpread($4e2305dbe349082f$var$_objectSpread({}, artifact), {}, {
                key: (0, $4r7nA.artifactKey)(artifact.name, artifact.dimensions)
            });
            experience.addMetadata({
                key: artifactWithKey.key,
                product: this.product
            });
            // Create the promise to fetch the config, we only need to await this if we don't have local config
            const artifactPromise = this.fetchArtifactPromise(artifactWithKey, retryConfig);
            // Check local storage for the artifact
            const localConfig = this.storageClient.getItem(artifactWithKey.key);
            if (localConfig) {
                experience.addMetadata({
                    configSource: "localStorage"
                });
                return localConfig;
            }
            // Was a fallback config provided?
            if (this.fallbackArtifactMap.has(artifactWithKey.key)) {
                experience.addMetadata({
                    configSource: "fallback"
                });
                return this.fallbackArtifactMap.get(artifactWithKey.key);
            }
            experience.addMetadata({
                configSource: "fetch"
            });
            // No local copies of config, await FD fetch promise here so that we can capture any errors & fail the experience
            const result = await artifactPromise;
            return result;
        } catch (e) {
            experience.failure({
                metadata: {
                    error: (0, $814TT.exceptionToMetadata)(e)
                }
            });
            throw e;
        } finally{
            // if the experience has been failed in the "catch" block, calling "success" will have no effect
            experience.success();
        }
    }
}

});
parcelRegister("6fYNv", function(module, exports) {

$parcel$export(module.exports, "retryOnException", () => $0dab620feb4778b8$export$1d94629c94e7a17f);
$parcel$export(module.exports, "FailedFetchError", () => (parcelRequire("6sAya")).default);

var $lLItl = parcelRequire("lLItl");

var $daTxP = parcelRequire("daTxP");

var $6sAya = parcelRequire("6sAya");
const $0dab620feb4778b8$export$5c069c93d2b7493f = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
const $0dab620feb4778b8$var$NO_CALLS_ERROR = 'No calls made';
const $0dab620feb4778b8$export$1d94629c94e7a17f = async (invokeOperation, { intervalsMS: intervalsMS = (0, $daTxP.NO_RETRIES), retryOn: retryOn = [
    (0, $6sAya.default)
], captureException: captureException, onRetry: onRetry })=>{
    const intervals = [
        ...intervalsMS
    ];
    let nextMSInterval = 0;
    let error = new Error($0dab620feb4778b8$var$NO_CALLS_ERROR);
    while(nextMSInterval !== undefined)try {
        if (nextMSInterval > 0) await $0dab620feb4778b8$export$5c069c93d2b7493f(nextMSInterval);
        if (onRetry && error.message !== $0dab620feb4778b8$var$NO_CALLS_ERROR) onRetry(error);
        return await invokeOperation();
    } catch (e) {
        error = (0, $lLItl.default)(e);
        if (captureException) captureException(error);
        // Retry ONLY when the error is an instance of one of the provided `retryOn` errors, or passes the `retryOn` test.
        // You need to ensure you are throwing one of the `retryOn` errors if that is the method you are using.
        if (typeof retryOn === 'function' ? retryOn(error) : retryOn.some((err)=>error instanceof err)) nextMSInterval = intervals.shift();
        else nextMSInterval = undefined;
    }
    throw error;
};

});
parcelRegister("lLItl", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7435f92b90f1f57$export$2e2bcd8739ae039);
const $b7435f92b90f1f57$var$convertToError = (e)=>{
    let error;
    if (e instanceof Error) error = e;
    else if (typeof e === 'string') error = new Error(e);
    else if (typeof e === 'object') try {
        error = new Error('Object error instance thrown for operation: ' + JSON.stringify(e));
    } catch (jsonError) {
        error = new Error('Object serialisation error thrown during operation: ' + String(e));
    }
    else error = new Error('No error instance thrown for operation: ' + String(e));
    return error;
};
var $b7435f92b90f1f57$export$2e2bcd8739ae039 = $b7435f92b90f1f57$var$convertToError;

});

parcelRegister("daTxP", function(module, exports) {

$parcel$export(module.exports, "NO_RETRIES", () => $6d1feaff7ce645cb$export$a0a1c8f90becc136);
const $6d1feaff7ce645cb$export$a0a1c8f90becc136 = [];
const $6d1feaff7ce645cb$export$972171517b12aa4 = [
    0,
    0
];
const $6d1feaff7ce645cb$export$746d2203ed8cdc40 = [
    0,
    50,
    100
];
const $6d1feaff7ce645cb$export$f6858378b665f957 = [
    100,
    500,
    1000
];

});

parcelRegister("6sAya", function(module, exports) {

$parcel$export(module.exports, "default", () => $b434fbcc8a3be4d5$export$2e2bcd8739ae039);
class $b434fbcc8a3be4d5$export$2e2bcd8739ae039 extends Error {
    constructor({ error: error, path: path, method: method }){
        super();
        this.name = 'FailedFetchError';
        this.message = error.message || 'Unknown fetch error';
        this.stack = error.stack;
        this.originalName = error.name;
        this.method = method;
        const p = path.split('?')[0];
        this.path = /^[/-a-z]+$/i.test(p) ? p : '';
    }
}

});


parcelRegister("jtD64", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fec5df08c1bfd78$export$2e2bcd8739ae039);

var $fvm5n = parcelRequire("fvm5n");
const $7fec5df08c1bfd78$var$DEFAULT_STORAGE_ENGINE = 'localStorage';
class $7fec5df08c1bfd78$export$2e2bcd8739ae039 {
    constructor(clientKey, options){
        this.getItem = (key, { useExpiredItem: useExpiredItem } = {
            useExpiredItem: false
        })=>{
            const item = this.client.getItem(this.itemKey(key));
            if (item) try {
                const parsedItem = JSON.parse(item);
                // item is expired
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    /**
					 * Commented out removing this item, as it is a slightly different state
					 * to the item not existing that we may want to preserve.
					 *  this.client.removeItem(this.itemKey(key));
					 */ if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                this.captureException(e);
            }
            return undefined;
        };
        this.removeItem = (key)=>{
            try {
                this.client.removeItem(this.itemKey(key));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.setItemWithExpiry = (key, value, expireInMS)=>{
            const itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                this.client.setItem(this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.clientKey = clientKey;
        this.handlers = options?.handlers;
        const storageEngine = options?.storageEngine || $7fec5df08c1bfd78$var$DEFAULT_STORAGE_ENGINE;
        if (!Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $fvm5n.mockWindowStorage)([
            storageEngine
        ]);
        this.client = window[storageEngine];
    }
    captureException(e, tags) {
        if (this.handlers?.captureException) this.handlers?.captureException(e, tags);
    }
    itemKey(key) {
        return `${this.clientKey}_${key}`;
    }
}

});
parcelRegister("fvm5n", function(module, exports) {

$parcel$export(module.exports, "mockWindowStorage", () => $e2c0533271428186$export$efebfe7859cae3c7);
/**
 * This can be used to mock local storage for Edge and other browsers that have disabled local storage setting
 */ const $e2c0533271428186$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function(id) {
        return delete this._data[id];
    },
    clear: function() {
        return this._data = {};
    },
    key: function(index) {
        return Object.keys(this._data)[index];
    }
};
const $e2c0533271428186$export$efebfe7859cae3c7 = (storageToMock = [
    'localStorage',
    'sessionStorage'
])=>{
    for (const storageToMockElement of storageToMock)Object.defineProperty(window, storageToMockElement, {
        value: {
            ...$e2c0533271428186$export$c65e688d8b365035
        },
        configurable: true
    });
};

});


parcelRegister("fynqv", function(module, exports) {

$parcel$export(module.exports, "fetchFlightDeckConfiguration", () => $b52c33ff29e619cd$export$6026918e023c9101);

var $euiLX = parcelRequire("euiLX");

var $6l8hg = parcelRequire("6l8hg");

var $3TdLx = parcelRequire("3TdLx");

var $3Oidj = parcelRequire("3Oidj");

var $d5LIN = parcelRequire("d5LIN");

var $95uqQ = parcelRequire("95uqQ");

var $kJG1r = parcelRequire("kJG1r");
/**
 * Arguments for passing in dimensions that the artifact might vary on.
 * For more details see: https://developer.atlassian.com/platform/flight-deck/getting-your-capability-onto-flight-deck/dimensions/
 */ /**
 * default to using prod instance since artifacts that don't depend on environment should be using the prod instance.
 */ const $b52c33ff29e619cd$var$defaultEnvType = "prod";
/**
 * default to using commercial instance.
 */ const $b52c33ff29e619cd$var$defaultPerimeter = "commercial";
async function $b52c33ff29e619cd$export$6026918e023c9101(artifactName, dim = {}) {
    var _dim$environmentType, _dim$perimeter;
    const environmentType = (_dim$environmentType = dim.environmentType) !== null && _dim$environmentType !== void 0 ? _dim$environmentType : $b52c33ff29e619cd$var$defaultEnvType;
    const perimeter = (_dim$perimeter = dim.perimeter) !== null && _dim$perimeter !== void 0 ? _dim$perimeter : $b52c33ff29e619cd$var$defaultPerimeter;
    const environment = $b52c33ff29e619cd$var$getEnvFromEnvType(environmentType);
    const locale = dim.locale && (0, $euiLX.default)(dim.locale);
    const artifactDimensions = {
        perimeter: perimeter,
        environment: environment,
        locale: locale
    };
    const client = await $b52c33ff29e619cd$var$getConfigClient(environmentType, perimeter);
    return client.getArtifact(artifactName, artifactDimensions);
}
async function $b52c33ff29e619cd$export$4abbe3ae0811355(dim = {}) {
    var _dim$environmentType2, _dim$perimeter2;
    const client = await $b52c33ff29e619cd$var$getConfigClient((_dim$environmentType2 = dim.environmentType) !== null && _dim$environmentType2 !== void 0 ? _dim$environmentType2 : $b52c33ff29e619cd$var$defaultEnvType, (_dim$perimeter2 = dim.perimeter) !== null && _dim$perimeter2 !== void 0 ? _dim$perimeter2 : $b52c33ff29e619cd$var$defaultPerimeter);
    return client.getLatestVersionMetadata();
}
async function $b52c33ff29e619cd$var$getConfigClient(env, perimeter) {
    const fetchArtifactExperience = await (0, $95uqQ.getFlightDeckFetchExperience)();
    const fetchVersionMetadataExperience = await (0, $95uqQ.getVersionMetadataFetchExperience)();
    return new (0, $d5LIN.ConfigClient)(new (0, $3TdLx.BifrostDataSource)(new (0, $3Oidj.BifrostHttpClientImpl)(env, perimeter), (0, $6l8hg.Versions).ManifestVersion), "Bifrost", fetchArtifactExperience, fetchVersionMetadataExperience);
}
/**
 *
 * This function is necessary since all artifacts are tagged using an environment,
 * so to get an artifact we need to specify an environment. However, users only
 * specify an environmentType since that's all that matters to them. Flight Deck
 * ensures that frontend artifacts don't vary based on region so this is safe to do.
 *
 * @param environmentDependentDimensions
 * @returns a specific environment that has that envtype
 */ function $b52c33ff29e619cd$var$getEnvFromEnvType(environment) {
    if (environment === undefined || environment === "prod") return "prod-west";
    switch(environment){
        case "stg":
            return "stg-west";
        case "adev":
            return "adev";
        case "ddev":
            return "ddev";
        case "pdev":
            return "pdev-apse2";
        case "fedex":
            return "stg-apse";
    }
}

});
parcelRegister("6l8hg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = module.exports.ConfigRegistryDataSource = module.exports.checkManifest = module.exports.parseVersionMetadata = module.exports.parseArtifactManifest = module.exports.tryGetArtifactData = module.exports.getArtifactFromSource = module.exports.Either = void 0;

var $auuB0 = parcelRequire("auuB0");
Object.defineProperty(module.exports, "Either", {
    enumerable: true,
    get: function() {
        return $auuB0.Either;
    }
});

var $2v7c1 = parcelRequire("2v7c1");
Object.defineProperty(module.exports, "getArtifactFromSource", {
    enumerable: true,
    get: function() {
        return $2v7c1.getArtifactFromSource;
    }
});
Object.defineProperty(module.exports, "tryGetArtifactData", {
    enumerable: true,
    get: function() {
        return $2v7c1.tryGetArtifactData;
    }
});

var $8Xjp5 = parcelRequire("8Xjp5");
Object.defineProperty(module.exports, "parseArtifactManifest", {
    enumerable: true,
    get: function() {
        return $8Xjp5.parseArtifactManifest;
    }
});

var $1NPzc = parcelRequire("1NPzc");
Object.defineProperty(module.exports, "parseVersionMetadata", {
    enumerable: true,
    get: function() {
        return $1NPzc.parseVersionMetadata;
    }
});

var $5LTws = parcelRequire("5LTws");
Object.defineProperty(module.exports, "checkManifest", {
    enumerable: true,
    get: function() {
        return $5LTws.checkManifest;
    }
});

var $6FHvZ = parcelRequire("6FHvZ");
Object.defineProperty(module.exports, "ConfigRegistryDataSource", {
    enumerable: true,
    get: function() {
        return $6FHvZ.ConfigRegistryDataSource;
    }
});

var $3ijEk = parcelRequire("3ijEk");
Object.defineProperty(module.exports, "BaseUrls", {
    enumerable: true,
    get: function() {
        return $3ijEk.BaseUrls;
    }
});
Object.defineProperty(module.exports, "Versions", {
    enumerable: true,
    get: function() {
        return $3ijEk.Versions;
    }
});

});
parcelRegister("auuB0", function(module, exports) {
"use strict";
var $7a34706d0f0f02a3$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Either = void 0;
var $7a34706d0f0f02a3$var$Either = /** @class */ function() {
    function Either() {}
    Either.prototype.map = function(f) {
        return this.flatMap(function(a) {
            return Either.right(f(a));
        });
    };
    Either.right = function(value) {
        return new $7a34706d0f0f02a3$var$Right(value);
    };
    Either.left = function(error) {
        return new $7a34706d0f0f02a3$var$Left(error);
    };
    return Either;
}();
module.exports.Either = $7a34706d0f0f02a3$var$Either;
var $7a34706d0f0f02a3$var$Right = /** @class */ function(_super) {
    $7a34706d0f0f02a3$var$__extends(Right, _super);
    function Right(r) {
        var _this = _super.call(this) || this;
        _this.right = r;
        return _this;
    }
    Right.prototype.bimap = function(_f, g) {
        return $7a34706d0f0f02a3$var$Either.right(g(this.right));
    };
    Right.prototype.flatMap = function(f) {
        return f(this.right);
    };
    Right.prototype.fold = function(_onLeft, onRight) {
        return onRight(this.right);
    };
    Right.prototype.leftMap = function(_f) {
        return $7a34706d0f0f02a3$var$Either.right(this.right);
    };
    return Right;
}($7a34706d0f0f02a3$var$Either);
var $7a34706d0f0f02a3$var$Left = /** @class */ function(_super) {
    $7a34706d0f0f02a3$var$__extends(Left, _super);
    function Left(e) {
        var _this = _super.call(this) || this;
        _this.left = e;
        return _this;
    }
    Left.prototype.bimap = function(f, _g) {
        return $7a34706d0f0f02a3$var$Either.left(f(this.left));
    };
    Left.prototype.flatMap = function(_f) {
        return $7a34706d0f0f02a3$var$Either.left(this.left);
    };
    Left.prototype.fold = function(onLeft, _onRight) {
        return onLeft(this.left);
    };
    Left.prototype.leftMap = function(f) {
        return $7a34706d0f0f02a3$var$Either.left(f(this.left));
    };
    return Left;
}($7a34706d0f0f02a3$var$Either);

});

parcelRegister("2v7c1", function(module, exports) {
"use strict";
var $1d240e683f64836f$var$__assign = module.exports && module.exports.__assign || function() {
    $1d240e683f64836f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1d240e683f64836f$var$__assign.apply(this, arguments);
};
var $1d240e683f64836f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $1d240e683f64836f$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.tryGetArtifactData = module.exports.getArtifactFromSource = void 0;

var $hdDPm = parcelRequire("hdDPm");

var $6l8hg = parcelRequire("6l8hg");

var $9te7V = parcelRequire("9te7V");

var $9P145 = parcelRequire("9P145");

var $3evgk = parcelRequire("3evgk");
function $1d240e683f64836f$var$getArtifactFromSource(dataSource, specifiedDimensions, deniedArtifactType) {
    return $1d240e683f64836f$var$__awaiter(this, void 0, void 0, function() {
        var manifestResult;
        var _this = this;
        return $1d240e683f64836f$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        dataSource.getManifest(specifiedDimensions.name, specifiedDimensions.version)
                    ];
                case 1:
                    manifestResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        manifestResult.fold(function(error) {
                            return Promise.resolve({
                                type: "manifest-fetch-error",
                                error: error
                            });
                        }, function(manifest) {
                            return $1d240e683f64836f$var$__awaiter(_this, void 0, void 0, function() {
                                var manifestCheckResult, publishMetadata, dimensionContextResult;
                                return $1d240e683f64836f$var$__generator(this, function(_a) {
                                    manifestCheckResult = (0, $6l8hg.checkManifest)(manifest, {
                                        name: specifiedDimensions.name,
                                        version: specifiedDimensions.version
                                    });
                                    if (manifestCheckResult.key !== "success") return [
                                        2 /*return*/ ,
                                        {
                                            type: manifestCheckResult.key
                                        }
                                    ];
                                    publishMetadata = manifest.publishMetadata;
                                    if (manifest.frontend && deniedArtifactType === "frontend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "frontend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    else if (!manifest.frontend && deniedArtifactType === "backend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "backend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    dimensionContextResult = (0, $9te7V.getDimensionContext)(specifiedDimensions, manifest);
                                    switch(dimensionContextResult.type){
                                        case "missing-dimension-specification":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "missing-dimension-specification",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "unsupported-value-specified-for-supported-dimension":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "unsupported-value-specified-for-supported-dimension",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "success":
                                            return [
                                                2 /*return*/ ,
                                                $1d240e683f64836f$var$getArtifact(dataSource, manifest, dimensionContextResult.dimensionContext)
                                            ];
                                        default:
                                            (0, $9P145.assertUnreachable)(dimensionContextResult);
                                    }
                                    return [
                                        2 /*return*/ 
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
module.exports.getArtifactFromSource = $1d240e683f64836f$var$getArtifactFromSource;
function $1d240e683f64836f$var$getArtifact(dataSource, manifest, dimensionContext) {
    return $1d240e683f64836f$var$__awaiter(this, void 0, void 0, function() {
        var publishMetadata, tag, artifactResult;
        var _this = this;
        return $1d240e683f64836f$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    publishMetadata = manifest.publishMetadata;
                    try {
                        tag = (0, $hdDPm.interpolateTagScheme)(manifest.tagScheme, $1d240e683f64836f$var$__assign($1d240e683f64836f$var$__assign({}, dimensionContext), {
                            name: manifest.name
                        }));
                    } catch (e) {
                        return [
                            2 /*return*/ ,
                            {
                                type: "tag-scheme-interpolation-error",
                                publishMetadata: publishMetadata
                            }
                        ];
                    }
                    return [
                        4 /*yield*/ ,
                        dataSource.getArtifact(manifest.name, tag)
                    ];
                case 1:
                    artifactResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        artifactResult.fold(function(error) {
                            return Promise.resolve({
                                type: "artifact-fetch-error",
                                error: error,
                                publishMetadata: publishMetadata
                            });
                        }, function(data) {
                            return $1d240e683f64836f$var$__awaiter(_this, void 0, void 0, function() {
                                return $1d240e683f64836f$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        {
                                            type: "success",
                                            data: data,
                                            publishMetadata: publishMetadata,
                                            artifactVersion: dimensionContext["version"]
                                        }
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $1d240e683f64836f$var$tryGetArtifactData(artifact, dataSourceName) {
    switch(artifact.type){
        case "manifest-fetch-error":
            throw new Error("Unable to fetch manifest due to ".concat(dataSourceName, " response error: ").concat((0, $3evgk.toPrettyJson)(artifact.error)));
        case "artifact-fetch-error":
            throw new Error("Unable to fetch artifact due to ".concat(dataSourceName, " response error: ").concat((0, $3evgk.toPrettyJson)(artifact.error)));
        case "denied-artifact-type":
            throw new Error("No artifacts should be denied, but type ".concat(artifact.deniedType, " was denied."));
        case "unsupported-value-specified-for-supported-dimension":
            throw new Error("An unsupported value was specified for a supported dimension");
        case "missing-dimension-specification":
            throw new Error("A required dimension specification was missing");
        case "tag-scheme-interpolation-error":
            throw new Error("Ran into failure when trying to interpolate tag scheme");
        case "mismatched-manifest-name":
            throw new Error("Manifest has been corrupted. Manifest name is mismatched.");
        case "mismatched-manifest-version":
            throw new Error("Manifest has been corrupted. Manifest version is mismatched.");
        case "success":
            return artifact.data;
        default:
            (0, $9P145.assertUnreachable)(artifact);
    }
}
module.exports.tryGetArtifactData = $1d240e683f64836f$var$tryGetArtifactData;

});
parcelRegister("hdDPm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getVersionMetadataTag = module.exports.getDataTagForManifest = module.exports.getDimensionsFromTagScheme = module.exports.generateTagScheme = module.exports.interpolateTagScheme = void 0;
const $c8928b7419a5cc69$var$TAG_SCHEME_VERSION = 2;
function $c8928b7419a5cc69$var$interpolateTagScheme(tagSchema, context) {
    const dimensions = Array.from($c8928b7419a5cc69$var$getDimensionsFromTagScheme(tagSchema));
    return dimensions.reduce((interpolatedTagScheme, dimension)=>{
        if (context.hasOwnProperty(dimension)) return interpolatedTagScheme.replace(new RegExp(`\\$${dimension}\\$`, "g"), context[dimension]);
        else {
            const contextAsJson = $c8928b7419a5cc69$var$toPrettyJson(context);
            throw new Error(`Bad variable "${dimension}" found enclosed in '$', so cannot infer
                     filename for artifact from tag schema: was expecting that
                     '${dimension}' would be a known dimension passed in context. This
                     is most likely a bug in Flight Deck. To help you debug, the Context
                     received was:\n"${contextAsJson}"\nOne of the keys in that object should
                     have been '${contextAsJson}'.`);
        }
    }, tagSchema);
}
module.exports.interpolateTagScheme = $c8928b7419a5cc69$var$interpolateTagScheme;
/**
 *
 * @param dimensions - the dimensions that this tag scheme needs to use
 *
 * @param supportedDimensionPrefixes - a map of those dimensions to
 * shortened versions (ie name to n)
 *
 *  @param effectiveContextDimension - maps dimensions down into dimensions supported
 *  by original context. NOTE:
 *
 *  There is only 1 correct implementation of this function, but
 *  it is not defined in this module because the most typesafe
 *  (least error prone) definition of this function requires referencing
 *  the specific dimension types (specific available dimensions), and
 *  we are intentionally keeping this module unaware of the specific
 *  dimensions to enable adding/changing dimensions easily in consumers
 *  which use this tags library. So therefore we define effectiveContextDimension
 *  outside of this package, but accept it as an argument. Note that in this
 *  package we redefine the meaning of common Flight Deck types (e.g.
 *  Dimension == string, rather than the specific subset of supported
 *  dimension strings), so when generateTagScheme is called then effectiveContextDimension
 *  needs to be cast (using `as`) in order to have the types
 *
 * @returns a generated schema
 */ function $c8928b7419a5cc69$var$generateTagScheme(dimensions, supportedDimensionPrefixes, effectiveContextDimension = (d)=>d) {
    const effectiveDimensions = new Set([
        ...dimensions
    ].map(effectiveContextDimension));
    for (const dimensionToInclude of effectiveDimensions){
        if (!supportedDimensionPrefixes.has(effectiveContextDimension(dimensionToInclude))) throw new Error([
            `Building a tag scheme failed! The dimension '${dimensionToInclude}' is not `,
            `recognized as a dimension (known dimensions are ${[
                ...supportedDimensionPrefixes.keys()
            ].join(", ")}!`
        ].join(" "));
    }
    // pad the version number to 3 digits (e.g. 001, 002, 003, etc) so that artifacts will sort by
    // version when sorted lexicographically (helpful for debugging)
    const padded_version = $c8928b7419a5cc69$var$TAG_SCHEME_VERSION.toString().padStart(3, "0");
    // IMPORTANT! Update {@link TAG_SCHEME_VERSION} if you change the tagging scheme logic!
    let tagScheme = `v${padded_version}`;
    for (const entry of supportedDimensionPrefixes.entries()){
        const [dimension, prefix] = entry;
        if (effectiveDimensions.has(dimension)) // We avoid using `:` or `/` or `\` as separator characters because these characters have
        // meaning on certain filesystems that make them painful to work with; we also don't use
        // ` ` or similar because whitespace characters are the default values used by shells
        // to word-split, which makes scripting harder (see https://bash.cyberciti.biz/guide/$IFS ).
        tagScheme += `-${prefix}_$${dimension}$`;
    }
    return tagScheme;
}
module.exports.generateTagScheme = $c8928b7419a5cc69$var$generateTagScheme;
// Important! Context: Front end client will be using old version of tags.When we make changes to this function
// we need to be extra cautious that it will be compatible with older versions
// Step -1
// we have test in frontend package :integration-test/frontend/frontend-fetch.spec.ts to test oldest front end client
// make sure we add sample artifact to the test which will test newest functionality against oldest client
// Step-2
// Update manifest version across flight-deck
// step-3
// update manifest version in poop-deck repo
// step-4
// communicate with external customers and #flight-deck channel announcements
// step-5
// Update oldest supported version in integration-test/frontend/frontend-fetch.spec.ts and the test will be passed
function $c8928b7419a5cc69$var$getDimensionsFromTagScheme(tagSchema) {
    // regex to get all dimensions
    // for a dimension:
    // \$ means the expression starts with a `$` sign
    // [A-Za-z]+ means dollar sign is followed by one or more alphabetical chars
    // \$ means the dimension ends with a `$` sign
    const dimensionsFormat = /\$([A-Za-z]+)\$/g;
    // regex to ensure that we have the right format
    // for the dimension format:
    // ^v means it must start with a v
    // \d{3} means it is followed by three digits
    // ?: tries to match the expression without capturing the group
    // -[a-z]_ means expression starts with `-<single lowercase a-z char>_`
    // (\$[A-Za-z]+\$) defines that a dimension is in the format `<one or more alphabetical chars>` and this group is captured.
    // + means we could have one or more dimensions.
    // $ means we must end at the end of a dimension.
    const tagSchemeFormat = /^v\d{3}(?:-[a-z]_(\$[A-Za-z]+\$))+$/;
    const isValidTag = tagSchemeFormat.test(tagSchema);
    if (!isValidTag) throw new Error(`The provided tag scheme: "${tagSchema}" is invalid.
                Tag schemes must have the following format:
                v<3 digit number>-<letter>$<dimension_name>$
                where -<letter>$<dimension_name>$ can be repeated
                and all characters of <letter> and <dimension_name>
                must be alphabetical characters
                e.g "v001-n_$name$-d_$dimension$" is a valid tag scheme`);
    const allDim = Array.from(tagSchema.matchAll(dimensionsFormat));
    try {
        // Grab the second element of each element in matches
        const captures = allDim.map(([_, capture])=>capture);
        const dimensions = new Set(captures);
        return dimensions;
    } catch (e) {
        throw new Error(`Could not capture dimensions. Expected dimension format to look like 
             ${dimensionsFormat}`);
    }
}
module.exports.getDimensionsFromTagScheme = $c8928b7419a5cc69$var$getDimensionsFromTagScheme;
function $c8928b7419a5cc69$var$getDataTagForManifest(artifactName, manifestVersion, artifactVersion) {
    return artifactVersion === undefined ? `${artifactName}_manifest_${manifestVersion}` : `${artifactName}_${artifactVersion}_manifest_${manifestVersion}`;
}
module.exports.getDataTagForManifest = $c8928b7419a5cc69$var$getDataTagForManifest;
function $c8928b7419a5cc69$var$getVersionMetadataTag(version) {
    return version ? `version_metadata_${version}` : "version_metadata";
}
module.exports.getVersionMetadataTag = $c8928b7419a5cc69$var$getVersionMetadataTag;
function $c8928b7419a5cc69$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});

parcelRegister("9te7V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDimensionContext = void 0;
/**
 * Resolves a record of Dimensions and their values based on the manifest
 * and the user specified dimensions values.
 *
 * If a dimension is not specified by the user, then the fallback value
 * will be used as the value for that dimension. If the fallback value
 * does not exist in this case, then a "missing-dimension-specification"
 * result will be reported.
 *
 * If a dimension value specified by the user is not part of the list
 * of supported values, then the dimension value will be the fallback
 * value defined. If a fallback value does not exist for that dimension,
 * then an "unsupported-value-specified-for-supported-dimension" result
 * will be reported.
 *
 * Otherwise, a "success" result will be reported on a valid context
 * resolution.
 *
 * @param specifiedDimensions the dimensions the user specified
 * @param manifest the manifest to validate and fallback user specifications
 * @returns a record of Dimensions and their valid values, or an error type
 *      if a record of valid values could not be derived from the user input
 */ function $6e51c7c28a67d567$var$getDimensionContext(specifiedDimensions, manifest) {
    var dimensionToValues = {};
    for(var dimension in manifest.dimensions){
        var manifestDimensionSpecs = manifest.dimensions[dimension];
        var dimensionValue = specifiedDimensions[dimension];
        var fallback = manifestDimensionSpecs.fallback;
        if (dimensionValue === undefined) {
            if (fallback === undefined) return {
                type: "missing-dimension-specification"
            };
            else dimensionValue = fallback;
        }
        if (!manifestDimensionSpecs.supported.includes(dimensionValue)) {
            if (fallback === undefined) return {
                type: "unsupported-value-specified-for-supported-dimension"
            };
            else dimensionValue = fallback;
        }
        dimensionToValues[dimension] = dimensionValue;
    }
    return {
        type: "success",
        dimensionContext: dimensionToValues
    };
}
module.exports.getDimensionContext = $6e51c7c28a67d567$var$getDimensionContext;

});

parcelRegister("9P145", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertUnreachable = void 0;
function $7269b3f523ad10e5$var$assertUnreachable(_x) {
    throw new Error("This function should never be called. This is for yielding compile errors on non-exhaustive case checking.");
}
module.exports.assertUnreachable = $7269b3f523ad10e5$var$assertUnreachable;

});

parcelRegister("3evgk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toPrettyJson = module.exports.toJson = void 0;
function $25aaedf68a816fe7$var$toJson(buffer) {
    return JSON.parse(buffer.toString());
}
module.exports.toJson = $25aaedf68a816fe7$var$toJson;
function $25aaedf68a816fe7$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}
module.exports.toPrettyJson = $25aaedf68a816fe7$var$toPrettyJson;

});


parcelRegister("8Xjp5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseArtifactManifest = void 0;

var $4DuZk = parcelRequire("4DuZk");
function $6852e290d659d0bd$var$parseMetricTags(metricTags) {
    var unparsedMetricTags = (0, $4DuZk.parseUnknownObject)(metricTags);
    var parsedMetricTags = {};
    for(var _i = 0, _a = Object.keys(unparsedMetricTags); _i < _a.length; _i++){
        var key = _a[_i];
        var tag = (0, $4DuZk.parseString)(unparsedMetricTags[key]);
        parsedMetricTags[key] = tag;
    }
    return parsedMetricTags;
}
function $6852e290d659d0bd$var$parsePublishMetadata(publishMetadata) {
    var unparsedPublishMetadata = (0, $4DuZk.parseUnknownObject)(publishMetadata);
    var metricTags = "metricTags" in unparsedPublishMetadata ? $6852e290d659d0bd$var$parseMetricTags(unparsedPublishMetadata.metricTags) : undefined;
    return {
        metricTags: metricTags
    };
}
function $6852e290d659d0bd$var$parseDimensions(dimensions) {
    var unparsedDimensions = (0, $4DuZk.parseUnknownObject)(dimensions);
    var supported = (0, $4DuZk.parseArray)(unparsedDimensions.supported).map($4DuZk.parseString);
    var fallback = (0, $4DuZk.parseUndefinedOr)($4DuZk.parseString, unparsedDimensions.fallback);
    return {
        fallback: fallback,
        supported: supported
    };
}
function $6852e290d659d0bd$var$parseDimensionsRecord(dimensionRecord) {
    var parsedDimensionRecord = {};
    var unparsedDimensionRecord = (0, $4DuZk.parseUnknownObject)(dimensionRecord);
    for(var _i = 0, _a = Object.keys(unparsedDimensionRecord); _i < _a.length; _i++){
        var key = _a[_i];
        var dimensionsSpec = $6852e290d659d0bd$var$parseDimensions(unparsedDimensionRecord[key]);
        parsedDimensionRecord[key] = dimensionsSpec;
    }
    return parsedDimensionRecord;
}
function $6852e290d659d0bd$var$parseArtifactManifest(potentialArtifactManifest) {
    var unparsedArtifactManifest = (0, $4DuZk.parseUnknownObject)(potentialArtifactManifest);
    var name = (0, $4DuZk.parseString)(unparsedArtifactManifest.name);
    var tagScheme = (0, $4DuZk.parseString)(unparsedArtifactManifest.tagScheme);
    var frontend = (0, $4DuZk.parseUndefinedOr)($4DuZk.parseBoolean, unparsedArtifactManifest.frontend);
    var dimensions = $6852e290d659d0bd$var$parseDimensionsRecord(unparsedArtifactManifest.dimensions);
    var publishMetadata = $6852e290d659d0bd$var$parsePublishMetadata(unparsedArtifactManifest.publishMetadata);
    return {
        name: name,
        frontend: frontend,
        tagScheme: tagScheme,
        dimensions: dimensions,
        publishMetadata: publishMetadata
    };
}
module.exports.parseArtifactManifest = $6852e290d659d0bd$var$parseArtifactManifest;

});
parcelRegister("4DuZk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseUndefinedOr = module.exports.parseUnknownObject = module.exports.parseBoolean = module.exports.parseArray = module.exports.parseString = void 0;
function $3602d78656005db6$var$parseString(string) {
    if (typeof string === "string") return string;
    throw new Error("Couldn't parse String");
}
module.exports.parseString = $3602d78656005db6$var$parseString;
function $3602d78656005db6$var$parseArray(array) {
    if (Array.isArray(array)) return array;
    throw new Error("Couldn't parse List or Undefined");
}
module.exports.parseArray = $3602d78656005db6$var$parseArray;
function $3602d78656005db6$var$parseBoolean(boolean) {
    if (typeof boolean === "boolean") return boolean;
    throw new Error("Couldn't parse Boolean or undefined");
}
module.exports.parseBoolean = $3602d78656005db6$var$parseBoolean;
function $3602d78656005db6$var$parseUnknownObject(object) {
    if (typeof object === "object") return object;
    throw new Error("Couldn't parse object");
}
module.exports.parseUnknownObject = $3602d78656005db6$var$parseUnknownObject;
function $3602d78656005db6$var$parseUndefinedOr(parse, thing) {
    if (typeof thing === "undefined") return thing;
    else return parse(thing);
}
module.exports.parseUndefinedOr = $3602d78656005db6$var$parseUndefinedOr;

});


parcelRegister("1NPzc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseVersionMetadata = void 0;

var $4DuZk = parcelRequire("4DuZk");
function $15025e265438bcca$var$parseVersionMetadata(possiblyVersionMetadata) {
    var unknownObject = (0, $4DuZk.parseUnknownObject)(possiblyVersionMetadata);
    var version = (0, $4DuZk.parseString)(unknownObject.version);
    var publishTime = new Date((0, $4DuZk.parseString)(unknownObject.publishTime));
    var sidecarImageDigestVersion = (0, $4DuZk.parseString)(unknownObject.sidecarImageDigestVersion);
    return {
        version: version,
        publishTime: publishTime,
        sidecarImageDigestVersion: sidecarImageDigestVersion
    };
}
module.exports.parseVersionMetadata = $15025e265438bcca$var$parseVersionMetadata;

});

parcelRegister("5LTws", function(module, exports) {
"use strict";
var $433c69239a917447$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkManifest = void 0;
/**
 * @param manifest manifest retrieved from data source
 * @param request request used to retrieve manifest (ie the artifact name and version specified)
 * @returns the manifest, but now it is guaranteed that the manifest name is the same as the requested name,
 * the version is the same as the requested version (if one is requested) and the version dimension (if it exists)
 * specifies exactly one version
 */ function $433c69239a917447$var$checkManifest(manifest, request) {
    if (manifest.name !== request.name) return {
        key: "mismatched-manifest-name"
    };
    var manifestVersionDimension = manifest.dimensions.version;
    if (request.version) {
        var manifestVersions = manifestVersionDimension ? $433c69239a917447$var$__spreadArray([
            manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.fallback
        ], manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.supported, true).filter(function(s) {
            return !!s;
        }) : [];
        var allVersionsMatch = manifestVersions.every(function(v) {
            return v === request.version;
        });
        if (!allVersionsMatch || manifestVersions.length === 0) return {
            key: "mismatched-manifest-version"
        };
    }
    return {
        key: "success"
    };
}
module.exports.checkManifest = $433c69239a917447$var$checkManifest;

});

parcelRegister("6FHvZ", function(module, exports) {
"use strict";
var $4db8538ddb439aee$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $4db8538ddb439aee$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConfigRegistryDataSource = void 0;

var $hdDPm = parcelRequire("hdDPm");

var $auuB0 = parcelRequire("auuB0");

var $8Xjp5 = parcelRequire("8Xjp5");

var $1NPzc = parcelRequire("1NPzc");
var $4db8538ddb439aee$var$ConfigRegistryDataSource = /** @class */ function() {
    function ConfigRegistryDataSource(manifestVersion, configRegistryHttpClient) {
        this.manifestVersion = manifestVersion;
        this.configRegistryHttpClient = configRegistryHttpClient;
    }
    ConfigRegistryDataSource.prototype.getManifest = function(artifactName, artifactVersion) {
        return $4db8538ddb439aee$var$__awaiter(this, void 0, void 0, function() {
            var tag, configRegistryResponse, e_1;
            return $4db8538ddb439aee$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        tag = (0, $hdDPm.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 2:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.leftMap(function(e) {
                                return e;
                            }).map($8Xjp5.parseArtifactManifest)
                        ];
                    case 3:
                        e_1 = _a.sent();
                        return [
                            2 /*return*/ ,
                            $auuB0.Either.left({
                                key: "config-registry-error",
                                error: e_1
                            })
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getArtifact = function(_artifactName, tag) {
        return $4db8538ddb439aee$var$__awaiter(this, void 0, void 0, function() {
            return $4db8538ddb439aee$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getLatestVersionMetadata = function() {
        return $4db8538ddb439aee$var$__awaiter(this, void 0, void 0, function() {
            var dataTag, configRegistryResponse;
            return $4db8538ddb439aee$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        dataTag = (0, $hdDPm.getVersionMetadataTag)();
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(dataTag)
                        ];
                    case 1:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.bimap(function(error) {
                                return error;
                            }, function(response) {
                                return (0, $1NPzc.parseVersionMetadata)(response);
                            })
                        ];
                }
            });
        });
    };
    return ConfigRegistryDataSource;
}();
module.exports.ConfigRegistryDataSource = $4db8538ddb439aee$var$ConfigRegistryDataSource;

});

parcelRegister("3ijEk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = void 0;
var $26624b831163931e$var$BaseUrls = /** @class */ function() {
    function BaseUrls() {}
    BaseUrls.ConfigRegistryProd = "https://config-registry.prod.atl-paas.net";
    return BaseUrls;
}();
module.exports.BaseUrls = $26624b831163931e$var$BaseUrls;
var $26624b831163931e$var$Versions = /** @class */ function() {
    function Versions() {}
    Versions.ManifestVersion = "v1";
    return Versions;
}();
module.exports.Versions = $26624b831163931e$var$Versions;

});


parcelRegister("3TdLx", function(module, exports) {

$parcel$export(module.exports, "BifrostDataSource", () => $2d512fbe779401ec$export$2cb8d79200775058);

var $6l8hg = parcelRequire("6l8hg");

var $hdDPm = parcelRequire("hdDPm");
class $2d512fbe779401ec$export$2cb8d79200775058 {
    constructor(bifrostClient, manifestVersion){
        this.bifrostClient = bifrostClient;
        this.manifestVersion = manifestVersion;
    }
    async getLatestVersionMetadata() {
        const tag = (0, $hdDPm.getVersionMetadataTag)();
        const bifrostResponse = await this.bifrostClient.getBlob(`${tag}.json`);
        return bifrostResponse.fold((error)=>{
            return (0, $6l8hg.Either).left(error);
        }, (response)=>{
            try {
                const parsedVersionMetadata = (0, $6l8hg.parseVersionMetadata)(response);
                return (0, $6l8hg.Either).right(parsedVersionMetadata);
            } catch (e) {
                const error = {
                    key: "invalid-version-metadata"
                };
                return (0, $6l8hg.Either).left(error);
            }
        });
    }
    async getManifest(artifactName, artifactVersion) {
        const manifestTag = (0, $hdDPm.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
        const bifrostResponse = await this.bifrostClient.getBlob(`${manifestTag}.json`, artifactName);
        return bifrostResponse.fold((error)=>{
            return (0, $6l8hg.Either).left(error);
        }, (response)=>{
            try {
                const parsedArtifact = (0, $6l8hg.parseArtifactManifest)(response);
                return (0, $6l8hg.Either).right(parsedArtifact);
            } catch (e) {
                const error = {
                    key: "invalid-manifest"
                };
                return (0, $6l8hg.Either).left(error);
            }
        });
    }
    async getArtifact(artifactName, tag) {
        return this.bifrostClient.getBlob(`${tag}.json`, artifactName);
    }
}

});

parcelRegister("3Oidj", function(module, exports) {

$parcel$export(module.exports, "BifrostHttpClientImpl", () => $2c642b791ff52615$export$45c6d12ca9c14f83);

var $6l8hg = parcelRequire("6l8hg");
function $2c642b791ff52615$export$f654b28f82155665(env, perimeter) {
    if (perimeter === "commercial") switch(env){
        case "adev":
        case "ddev":
        case "pdev":
        case "stg":
            return "https://fd-config-bifrost.stg-east.frontend.public.atl-paas.net";
        case "prod":
            return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
    }
    else if (perimeter === "fedramp-moderate") switch(env){
        case "stg":
            return "https://fd-config-bifrost.stg.frontend.cdn.atlassian-us-gov-mod.com";
        case "prod":
            return "https://fd-config-bifrost.frontend.cdn.atlassian-us-gov-mod.com";
    }
    return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
}
class $2c642b791ff52615$export$45c6d12ca9c14f83 {
    constructor(env, perimeter){
        this.baseUrl = $2c642b791ff52615$export$f654b28f82155665(env, perimeter);
    }
    async getBlob(tag) {
        const endpoint = `${this.baseUrl}/assets/${tag}`;
        return new Promise((resolve)=>fetch(endpoint).then((response)=>{
                if (!response.ok) resolve((0, $6l8hg.Either).left({
                    key: "unexpected-response-code",
                    httpResponseCode: response.status,
                    httpResponseStatusText: response.statusText
                }));
                response.json().then((json)=>resolve((0, $6l8hg.Either).right(json)));
            }).catch((error)=>resolve((0, $6l8hg.Either).left({
                    key: "failed-fetch",
                    error: "message" in error ? error.message : "unknown error"
                }))));
    }
}

});

parcelRegister("d5LIN", function(module, exports) {

$parcel$export(module.exports, "ConfigClient", () => $9880c2778e17f5cd$export$8489e2f039bfcc4c);

var $eHiP8 = parcelRequire("eHiP8");

var $6l8hg = parcelRequire("6l8hg");

var $4gZ5I = parcelRequire("4gZ5I");
function $9880c2778e17f5cd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9880c2778e17f5cd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9880c2778e17f5cd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eHiP8.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9880c2778e17f5cd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $9880c2778e17f5cd$export$8489e2f039bfcc4c {
    constructor(dataSource, dataSourceName, fetchArtifactExperience, versionMetadataExperience){
        this.fetchArtifactExperience = fetchArtifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
        this.dataSource = new (0, $4gZ5I.ExperienceDataSourceWrapper)(dataSource, this.fetchArtifactExperience, this.versionMetadataExperience);
        this.dataSourceName = dataSourceName;
    }
    async getArtifact(artifactName, dimensions) {
        this.fetchArtifactExperience.addMetadata(dimensions);
        this.fetchArtifactExperience.start();
        const specifiedDimensions = $9880c2778e17f5cd$var$_objectSpread($9880c2778e17f5cd$var$_objectSpread({}, dimensions), {}, {
            name: artifactName
        });
        const artifact = await (0, $6l8hg.getArtifactFromSource)(this.dataSource, specifiedDimensions, "backend").catch((e)=>({
                type: "artifact-fetch-error",
                publishMetadata: {},
                error: {
                    key: "unexpected-error",
                    error: e
                }
            }));
        if (artifact.type === "success") this.fetchArtifactExperience.success();
        else {
            this.fetchArtifactExperience.addMetadata({
                errorType: artifact.type,
                error: "error" in artifact ? artifact.error.key : undefined
            });
            this.fetchArtifactExperience.failure();
        }
        return (0, $6l8hg.tryGetArtifactData)(artifact, this.dataSourceName);
    }
    async getLatestVersionMetadata() {
        this.versionMetadataExperience.start();
        const getVersionMetadataResult = await this.dataSource.getLatestVersionMetadata();
        return getVersionMetadataResult.fold((error)=>{
            this.versionMetadataExperience.addMetadata({
                error: error.key
            });
            this.versionMetadataExperience.failure();
            throw new Error(`Unable to get latest version metadata from ${this.dataSourceName} due to error: ${error.key}`);
        }, (data)=>{
            this.versionMetadataExperience.success();
            return data;
        });
    }
}

});
parcelRegister("4gZ5I", function(module, exports) {

$parcel$export(module.exports, "ExperienceDataSourceWrapper", () => $31c80b8146ec82d5$export$1cc944571619e6e8);
/**
 * Wraps a standard Datasource as defined by @atlassiansox/flight-deck-core && uses
 * the experience to mark when events happen.
 */ class $31c80b8146ec82d5$export$1cc944571619e6e8 {
    constructor(dataSource, artifactExperience, versionMetadataExperience){
        this.dataSource = dataSource;
        this.artifactExperience = artifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
    }
    getLatestVersionMetadata() {
        this.versionMetadataExperience.mark("start-fetch-metadata");
        const result = this.dataSource.getLatestVersionMetadata();
        this.versionMetadataExperience.mark("end-fetch-metadata");
        return result;
    }
    async getManifest(artifactName, artifactVersion) {
        this.artifactExperience.mark("start-fetch-artifact");
        const result = await this.dataSource.getManifest(artifactName, artifactVersion);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getManifestError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-artifact");
        return result;
    }
    async getArtifact(artifactName, tag) {
        this.artifactExperience.mark("start-fetch-manifest");
        const result = await this.dataSource.getArtifact(artifactName, tag);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getArtifactError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-manifest");
        return result;
    }
}

});


parcelRegister("95uqQ", function(module, exports) {

$parcel$export(module.exports, "getFlightDeckFetchExperience", () => $69dc2fdcb553c857$export$a3006f8f221c0a3b);
$parcel$export(module.exports, "getVersionMetadataFetchExperience", () => $69dc2fdcb553c857$export$c3ac7702bfd47c1b);
const $69dc2fdcb553c857$var$SAMPLING_RATE = 10;
class $69dc2fdcb553c857$var$UFOExperienceWrapper {
    constructor(experience){
        this.experience = experience;
    }
    start(startTime) {
        return this.experience.start(startTime);
    }
    success() {
        return this.experience.success();
    }
    failure() {
        return this.experience.failure();
    }
    addMetadata(data) {
        return this.experience.addMetadata(data);
    }
    mark(mark) {
        return this.experience.mark(mark);
    }
}
class $69dc2fdcb553c857$export$5e7536cf7bc56fee {
    start() {
        return Promise.resolve();
    }
    success() {
        return Promise.resolve(null);
    }
    failure() {
        return Promise.resolve(null);
    }
    mark() {
        return;
    }
    addMetadata() {
        return;
    }
}

async function $69dc2fdcb553c857$var$flightDeckSDKOperationExperience(id, timings, metadata) {
    try {
        // only emit metrics 1 in every 10 times a Flight Deck Configuration is fetched
        // to not flood Perf Portal with logs.
        if (Math.random() * 100 > $69dc2fdcb553c857$var$SAMPLING_RATE) return new $69dc2fdcb553c857$export$5e7536cf7bc56fee();
        const { UFOExperience: UFOExperience, ExperienceTypes: ExperienceTypes, ExperiencePerformanceTypes: ExperiencePerformanceTypes } = await (parcelRequire("3fucY"));
        const ufoExperience = new UFOExperience(id, {
            type: ExperienceTypes.Operation,
            performanceType: ExperiencePerformanceTypes.Custom,
            platform: {
                component: "flight-deck-client"
            },
            timings: timings
        });
        ufoExperience.addMetadata(metadata);
        return new $69dc2fdcb553c857$var$UFOExperienceWrapper(ufoExperience);
    } catch (_unused) {
        return new $69dc2fdcb553c857$export$5e7536cf7bc56fee();
    }
}
const $69dc2fdcb553c857$export$a3006f8f221c0a3b = ()=>$69dc2fdcb553c857$var$flightDeckSDKOperationExperience("fetch", [
        {
            key: "fetch-artifact",
            endMark: "end-fetch-artifact",
            startMark: "start-fetch-artifact"
        },
        {
            key: "fetch-manifest",
            endMark: "end-fetch-manifest",
            startMark: "start-fetch-manifest"
        }
    ], {});
const $69dc2fdcb553c857$export$c3ac7702bfd47c1b = ()=>$69dc2fdcb553c857$var$flightDeckSDKOperationExperience("fetch-version-metadata", [
        {
            key: "fetch-metadata",
            startMark: "start-fetch-metadata",
            endMark: "end-fetch-metadata"
        }
    ], {});

});
parcelRegister("3fucY", function(module, exports) {

let $25da34894d2180a6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $25da34894d2180a6$var$load("zeQjY").then(()=>parcelRequire('8GXI8'));

});


parcelRegister("kJG1r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = module.exports.parseConfigWithTargeting = void 0;

var $fiwxX = parcelRequire("fiwxX");
Object.defineProperty(module.exports, "parseConfigWithTargeting", {
    enumerable: true,
    get: function() {
        return $fiwxX.parseConfigWithTargeting;
    }
});

var $hTlW1 = parcelRequire("hTlW1");
Object.defineProperty(module.exports, "TargetedConfig", {
    enumerable: true,
    get: function() {
        return $hTlW1.TargetedConfig;
    }
});

});
parcelRegister("fiwxX", function(module, exports) {
"use strict";
var $b231c88986716fb9$var$__assign = module.exports && module.exports.__assign || function() {
    $b231c88986716fb9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b231c88986716fb9$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseConfigWithTargeting = void 0;

var $hTlW1 = parcelRequire("hTlW1");
/**
 * For a given configuration, return the same configuration back
 * with {@link TargetedConfig} substituted where applicable.
 *
 * So anywhere in the JSON that has the objects:
 * ```
 * {
 *   "defaultConfig": ...
 * }
 * ```
 *
 * OR
 *
 * ```
 * {
 *   "defaultConfig": ...
 *   "targeting": {
 *     "targets": [...]
 *     "targetedConfig": ...
 *   }
 * }
 * ```
 *
 * become an instance of {@link TargetedConfig}.
 *
 * @param config configuration that may contain unparsed {@link TargetedConfig}
 * @returns the same configuration with targeted config sub-objects transformed
 *     into {@link TargetedConfig}
 */ function $b231c88986716fb9$var$parseConfigWithTargeting(data) {
    // All "object" types will also need to have a null check because null is an "object", but an
    // invalid one for this use case.
    if (typeof data === "object") {
        if (Array.isArray(data)) return data.map(function(element) {
            return $b231c88986716fb9$var$parseConfigWithTargeting(element);
        });
        else if (data) {
            var parsedObject_1 = data;
            var keys = Object.keys(parsedObject_1);
            if (keys.length === 1 && parsedObject_1.defaultConfig) return new $hTlW1.TargetedConfig({
                defaultConfig: $b231c88986716fb9$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
            });
            else if (keys.length === 2 && parsedObject_1.defaultConfig && parsedObject_1.targeting) {
                var parseResult = $b231c88986716fb9$var$parseTargeting(parsedObject_1.targeting);
                if (parseResult.type === "match") return new $hTlW1.TargetedConfig({
                    targeting: parseResult.result,
                    defaultConfig: $b231c88986716fb9$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
                });
            }
            return keys.reduce(function(accObject, key) {
                var _a;
                return $b231c88986716fb9$var$__assign($b231c88986716fb9$var$__assign({}, accObject), (_a = {}, _a[key] = $b231c88986716fb9$var$parseConfigWithTargeting(parsedObject_1[key]), _a));
            }, {});
        } else return null;
    } else return data;
}
module.exports.parseConfigWithTargeting = $b231c88986716fb9$var$parseConfigWithTargeting;
function $b231c88986716fb9$var$parseTargeting(targeting) {
    if (typeof targeting === "object" && targeting && !Array.isArray(targeting)) {
        var targetingKeyValue = targeting;
        var targetingKeys = Object.keys(targetingKeyValue);
        if (targetingKeys.length == 2 && targetingKeyValue.targets && targetingKeyValue.targetedConfig) return {
            type: "match",
            result: {
                targets: $b231c88986716fb9$var$parseTargets(targetingKeyValue.targets),
                targetedConfig: $b231c88986716fb9$var$parseConfigWithTargeting(targetingKeyValue.targetedConfig)
            }
        };
    }
    return {
        type: "no-match"
    };
}
function $b231c88986716fb9$var$parseTargets(targets) {
    if (Array.isArray(targets)) return targets.map(function(target) {
        return {
            orgIds: $b231c88986716fb9$var$parseIdentifierList(target.orgIds),
            siteIds: $b231c88986716fb9$var$parseIdentifierList(target.siteIds),
            userIds: $b231c88986716fb9$var$parseIdentifierList(target.userIds)
        };
    });
    else throw new Error("The targets for Flight Deck targeted configuration must come in an array.");
}
function $b231c88986716fb9$var$parseIdentifierList(identifierList) {
    if (identifierList === undefined) return undefined;
    if (Array.isArray(identifierList)) return identifierList.map(function(id) {
        if (typeof id === "string") return id;
        else throw new Error("Identifiers for targets must be strings!");
    });
    else throw new Error("Identifier list must be an array!");
}

});
parcelRegister("hTlW1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = void 0;
/**
 * Defines a part of the overall configuration that has different
 * values based on the intended target. The target is a specification
 * of a combination of site id, user id and org id.
 */ var $d068968b22fc3b5a$var$TargetedConfig = /** @class */ function() {
    function TargetedConfig(targetedConfigDefinition) {
        this.targetedConfigDefinition = targetedConfigDefinition;
    }
    /**
     * Determines whether to use the targeted configuration value or the default value
     * depending on whether the specified values match any of the target's rules.
     *
     * @param target the values to use to evaluate the config
     * @returns the {@link TargetingResult}, which would be the default value
     *     if the specified target did not match, or the targeted value if there
     *     was a match
     */ TargetedConfig.prototype.resolve = function(target) {
        var targeting = this.targetedConfigDefinition.targeting;
        if (targeting) {
            var targeted = targeting.targets.some(function(configuredTarget) {
                var criteria = [];
                if (configuredTarget.orgIds) criteria.push({
                    allowList: configuredTarget.orgIds,
                    identifier: target.orgId
                });
                if (configuredTarget.siteIds) criteria.push({
                    allowList: configuredTarget.siteIds,
                    identifier: target.siteId
                });
                if (configuredTarget.userIds) criteria.push({
                    allowList: configuredTarget.userIds,
                    identifier: target.userId
                });
                if (criteria.length === 0) return false;
                else return criteria.every(function(criteria) {
                    return $d068968b22fc3b5a$var$resolveForTargetCriteria(criteria);
                });
            });
            if (targeted) return {
                type: "targeted",
                value: targeting.targetedConfig
            };
        }
        return {
            type: "default",
            value: this.targetedConfigDefinition.defaultConfig
        };
    };
    return TargetedConfig;
}();
module.exports.TargetedConfig = $d068968b22fc3b5a$var$TargetedConfig;
function $d068968b22fc3b5a$var$resolveForTargetCriteria(criteria) {
    return !!criteria.identifier && criteria.allowList.includes(criteria.identifier);
}

});




parcelRegister("lKWnb", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd6b2c7e02ec3fe7$export$2e2bcd8739ae039);
class $fd6b2c7e02ec3fe7$export$2e2bcd8739ae039 extends Error {
    constructor({ artifact: artifact, dimensions: dimensions, error: error }){
        super(error instanceof Error && error.message ? error.message : "Unknown Flight Deck SDK error");
        this.name = "FlightDeckSDKError";
        this.error = error;
        this.artifact = artifact;
        this.environmentType = dimensions === null || dimensions === void 0 ? void 0 : dimensions.environmentType;
        this.locale = dimensions === null || dimensions === void 0 ? void 0 : dimensions.locale;
    }
}
const $fd6b2c7e02ec3fe7$export$1d76d155060824c9 = (e)=>e instanceof $fd6b2c7e02ec3fe7$export$2e2bcd8739ae039;

});

parcelRegister("4r7nA", function(module, exports) {

$parcel$export(module.exports, "artifactKey", () => $33af6871e9658618$export$e3553dc63541d477);
const $33af6871e9658618$export$e3553dc63541d477 = (artifactName, dimensions)=>{
    return `${artifactName}${dimensions ? "_" + Object.keys(dimensions).sort().map((key)=>dimensions[key]).filter(Boolean).join("_") : ""}`;
};

});

parcelRegister("814TT", function(module, exports) {

$parcel$export(module.exports, "flightDeckClientExperience", () => $5d6237e1ec8a6bfc$export$1e3a41a51f6457c5);
$parcel$export(module.exports, "exceptionToMetadata", () => $5d6237e1ec8a6bfc$export$f33622abb5224195);

var $eHiP8 = parcelRequire("eHiP8");

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
function $5d6237e1ec8a6bfc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5d6237e1ec8a6bfc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5d6237e1ec8a6bfc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eHiP8.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5d6237e1ec8a6bfc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $5d6237e1ec8a6bfc$export$6061a1a9a61f2e21 = ()=>new (0, $duUGa.UFOExperience)("fetch", {
        type: (0, $atdLB.ExperienceTypes).Operation,
        performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "flight-deck-client"
        }
    });
const $5d6237e1ec8a6bfc$export$1e3a41a51f6457c5 = ()=>new (0, $duUGa.UFOExperience)("retrieve-artifact", {
        type: (0, $atdLB.ExperienceTypes).Operation,
        performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "flight-deck-client"
        }
    });
const $5d6237e1ec8a6bfc$export$f33622abb5224195 = (e)=>{
    return e instanceof Error ? $5d6237e1ec8a6bfc$var$_objectSpread($5d6237e1ec8a6bfc$var$_objectSpread({}, e), {}, {
        cause: undefined
    }) : "unknown";
};

});



parcelRegister("fkT8h", function(module, exports) {

$parcel$export(module.exports, "usePeopleAndTeamsRemoteArtifact", () => $540fc5e41500614e$export$233293b7afb7b362);

var $5uXOq = parcelRequire("5uXOq");

var $btDaU = parcelRequire("btDaU");

var $a5HGt = parcelRequire("a5HGt");
const $540fc5e41500614e$var$transformArtifactsWithOverrides = (artifact, overrideKeys)=>{
    if (!artifact?.overrides?.length || overrideKeys.length === 0) return artifact;
    return overrideKeys.reduce((acc, overrideKey)=>{
        return {
            ...acc,
            ...artifact.overrides && artifact.overrides.find((override)=>override.key === overrideKey)?.item || null
        };
    }, artifact);
};
const $540fc5e41500614e$export$233293b7afb7b362 = (product, locale, overridesKeys)=>{
    const dimensions = (0, $5uXOq.useMemo)(()=>({
            ...(0, $a5HGt.FD_CLIENT_FETCH_PROPS).dimensions,
            locale: locale
        }), [
        locale
    ]);
    const artifact = (0, $btDaU.useFlightDeckArtifact)((0, $a5HGt.FD_CLIENT_FETCH_PROPS).name, dimensions);
    /**
	 * FlightDeck doesn't allow custom, a 'product', dimension so we must handle this ourselves.
	 * We can probably remove this memo once that functionality is available
	 */ return (0, $5uXOq.useMemo)(()=>{
        const productArtifact = artifact ? product in artifact['people-menu'] ? artifact['people-menu'][product] : artifact['people-menu'].default : null;
        return {
            ['people-menu']: $540fc5e41500614e$var$transformArtifactsWithOverrides(productArtifact, overridesKeys ? overridesKeys['people-menu'] : [])
        };
    }, [
        artifact,
        product,
        overridesKeys
    ]);
};

});
parcelRegister("a5HGt", function(module, exports) {

$parcel$export(module.exports, "FD_CLIENT_FETCH_PROPS", () => $72142315cc1ea029$export$c270c412a04ff3e6);

var $c04PQ = parcelRequire("c04PQ");
const $72142315cc1ea029$export$953923d576277fd6 = 'people-and-teams-configuration-service';
const $72142315cc1ea029$export$71f196808ce40e60 = 'prod';
const $72142315cc1ea029$export$6392ca3738ed1e9 = 'fedramp-moderate';
const $72142315cc1ea029$export$e836203c1e95eac3 = 'commercial';
const $72142315cc1ea029$export$c270c412a04ff3e6 = {
    name: $72142315cc1ea029$export$953923d576277fd6,
    dimensions: {
        environmentType: $72142315cc1ea029$export$71f196808ce40e60,
        perimeter: (0, $c04PQ.isFedRamp)() ? $72142315cc1ea029$export$6392ca3738ed1e9 : $72142315cc1ea029$export$e836203c1e95eac3
    }
};

});


parcelRegister("9Xnkh", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CONTEXT", () => $68376ad28bbe1625$export$9c542858adf7dcd0);
const $68376ad28bbe1625$export$9c542858adf7dcd0 = {
    ['people-menu']: null
};

});

parcelRegister("epGv3", function(module, exports) {

$parcel$export(module.exports, "usePeopleAndTeamsConfigurationOverrides", () => $9b52f5c51e77c65a$export$66d7d96ce076bcd6);

var $95nUS = parcelRequire("95nUS");

var $5wXDQ = parcelRequire("5wXDQ");
const $9b52f5c51e77c65a$export$66d7d96ce076bcd6 = (teamPermissionCheckEnabled, orgId, teamPermissionsProps)=>{
    const { permissions: teamPermissionsFromHook } = (0, $95nUS.useTeamsPermissionsService)(orgId, {
        enabled: teamPermissionCheckEnabled && !teamPermissionsProps
    });
    const teamPermissions = teamPermissionsProps || teamPermissionsFromHook;
    return {
        'people-menu': [
            ...!teamPermissions?.canCreateTeams ? [
                (0, $5wXDQ.PeopleMenuOverrides).createTeamsDisabled
            ] : [],
            ...!teamPermissions?.canViewTeams ? [
                (0, $5wXDQ.PeopleMenuOverrides).viewTeamsDisabled
            ] : []
        ]
    };
};

});
parcelRegister("95nUS", function(module, exports) {

$parcel$export(module.exports, "useTeamsPermissionsService", () => $6e4bacc142514b25$export$b24dcbe1ec677a8);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $3mE7N = parcelRequire("3mE7N");

var $lXyXX = parcelRequire("lXyXX");
const $6e4bacc142514b25$export$b24dcbe1ec677a8 = (scope, { enabled: enabled, attributes: attributes } = {
    enabled: false,
    attributes: {}
})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    // backwards compatibility allow orgId to be passed as a string
    const { orgId: orgId, cloudId: cloudId } = typeof scope === 'string' || !scope ? {
        orgId: scope,
        cloudId: undefined
    } : scope;
    const [state, { getPermissions: getPermissions }] = (0, $lXyXX.useTeamsPermissionsStore)();
    const fetchData = (0, $5uXOq.useCallback)(async ()=>{
        getPermissions({
            orgId: orgId,
            cloudId: cloudId,
            enabled: enabled
        }, {
            onFetch: ()=>(0, $3mE7N.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'fetched',
                    actionSubject: 'use-team-permissions',
                    attributes: {
                        userId: attributes?.userId,
                        orgId: orgId,
                        cloudId: cloudId
                    }
                })
        });
    }, [
        orgId,
        cloudId,
        enabled,
        getPermissions,
        createAnalyticsEvent,
        attributes?.userId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    return {
        loading: state.isLoading,
        data: state.permissionsResponse,
        error: state.error,
        ...state
    };
};

});
parcelRegister("3mE7N", function(module, exports) {

$parcel$export(module.exports, "fireOperationalEvent", () => $f93bde5d7fdaaaab$export$a1fb57756f0de62b);
$parcel$export(module.exports, "fireScreenEvent", () => $f93bde5d7fdaaaab$export$59608e0169622110);
$parcel$export(module.exports, "fireTrackEvent", () => $f93bde5d7fdaaaab$export$574d2f19a52d67ca);
$parcel$export(module.exports, "fireUIEvent", () => $f93bde5d7fdaaaab$export$7eca133280843f9e);
$parcel$export(module.exports, "isSeriousError", () => $f93bde5d7fdaaaab$export$91c413c8a5c77e19);
const $f93bde5d7fdaaaab$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $f93bde5d7fdaaaab$var$runItLater = (cb)=>{
    if (window.requestIdleCallback === 'function') return window.requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $f93bde5d7fdaaaab$var$fireEvent = (kind)=>(createAnalyticsEvent, body)=>{
        if (!createAnalyticsEvent) return;
        $f93bde5d7fdaaaab$var$runItLater(()=>{
            createAnalyticsEvent({
                eventType: kind,
                ...body
            }).fire($f93bde5d7fdaaaab$var$ANALYTICS_CHANNEL);
        });
    };
const $f93bde5d7fdaaaab$export$a1fb57756f0de62b = $f93bde5d7fdaaaab$var$fireEvent('operational');
const $f93bde5d7fdaaaab$export$59608e0169622110 = $f93bde5d7fdaaaab$var$fireEvent('screen');
const $f93bde5d7fdaaaab$export$574d2f19a52d67ca = $f93bde5d7fdaaaab$var$fireEvent('track');
const $f93bde5d7fdaaaab$export$7eca133280843f9e = $f93bde5d7fdaaaab$var$fireEvent('ui');
const $f93bde5d7fdaaaab$export$91c413c8a5c77e19 = (error)=>{
    if (!error) return false;
    // Check for ' 403' with space beforehand to not count urls containing 403 in cloud or team id
    if ('status' in error && error['status'] === 403 || error?.message?.includes(' 403')) return false;
    if ('status' in error && error['status'] === 401 || error?.message?.includes(' 401')) return false;
    if ('status' in error && error['status'] === 429 || error?.message?.includes(' 429')) return false;
    if (error.message === 'Failed to fetch') return false;
    return true;
};

});

parcelRegister("lXyXX", function(module, exports) {

$parcel$export(module.exports, "useTeamsPermissionsStore", () => $20332b07e72ce3e2$export$4e7a1c55cba5a168);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $1K4T6 = parcelRequire("1K4T6");
var $dmOdc = parcelRequire("dmOdc");

var $ddoT6 = parcelRequire("ddoT6");
const $20332b07e72ce3e2$var$actions = {
    getPermissions: ({ orgId: orgId, cloudId: cloudId, enabled: enabled }, { onFetch: onFetch })=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const { hasLoaded: hasLoaded, isLoading: isLoading } = getState();
            if (hasLoaded || isLoading || !enabled || !orgId || !cloudId) return;
            try {
                setState({
                    isLoading: true
                });
                (0, $dmOdc.teamsClient).setContext({
                    orgId: orgId,
                    cloudId: cloudId
                });
                const response = await (0, $dmOdc.teamsClient).getPermissions();
                dispatch($20332b07e72ce3e2$var$actions.setPermissions(response.permissions));
                onFetch?.();
            } catch (error) {
                dispatch($20332b07e72ce3e2$var$actions.setError(error instanceof (0, $1K4T6.HttpError) ? error : new Error('Failed to fetch permissions')));
            }
        },
    setError: (error)=>({ setState: setState })=>{
            setState({
                hasLoaded: true,
                isLoading: false,
                error: error
            });
        },
    setLoading: (isLoading)=>({ setState: setState })=>{
            setState({
                isLoading: isLoading
            });
        },
    setPermissions: (permissions)=>({ setState: setState })=>{
            setState({
                hasLoaded: true,
                isLoading: false,
                permissions: (0, $ddoT6.transformPermissions)(permissions),
                permissionsResponse: {
                    permissions: permissions
                }
            });
        }
};
const $20332b07e72ce3e2$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        error: undefined,
        hasLoaded: false,
        isLoading: false,
        permissions: {
            canCreateTeams: true,
            canViewTeams: true,
            canAdminTeams: false
        }
    },
    actions: $20332b07e72ce3e2$var$actions,
    name: 'teams-permissions'
});
const $20332b07e72ce3e2$export$4e7a1c55cba5a168 = (0, $3sQ5x.createHook)($20332b07e72ce3e2$var$Store);

});
parcelRegister("1K4T6", function(module, exports) {

$parcel$export(module.exports, "StatusCode", () => $5767c51dc6f9e25d$export$f66f92b8741acd5b);
$parcel$export(module.exports, "isAuthError", () => $5767c51dc6f9e25d$export$cde1786a482f9a1c);
$parcel$export(module.exports, "isErrorStatusCode", () => $5767c51dc6f9e25d$export$9677d7c364ada66c);
$parcel$export(module.exports, "DefaultError", () => $5767c51dc6f9e25d$export$c73ca302efeda3b4);
$parcel$export(module.exports, "SLOIgnoreError", () => $5767c51dc6f9e25d$export$d87f401f8106d7a2);
$parcel$export(module.exports, "HttpError", () => $5767c51dc6f9e25d$export$65bd6083489bd8bb);
$parcel$export(module.exports, "SLOIgnoreHttpError", () => $5767c51dc6f9e25d$export$826a3d65b8435adf);
$parcel$export(module.exports, "GraphQLError", () => $5767c51dc6f9e25d$export$92d6ed0888e7cb7f);
$parcel$export(module.exports, "isNetworkError", () => $5767c51dc6f9e25d$export$476aa014e2fd89d5);
var $5767c51dc6f9e25d$export$fe4bb20808298551 = /*#__PURE__*/ function(ErrorCategory) {
    ErrorCategory["NotFound"] = "NotFound";
    ErrorCategory["NotPermitted"] = "NotPermitted";
    ErrorCategory["MalformedInput"] = "MalformedInput";
    ErrorCategory["Internal"] = "Internal";
    return ErrorCategory;
}({});
var $5767c51dc6f9e25d$export$f66f92b8741acd5b = /*#__PURE__*/ function(StatusCode) {
    StatusCode[StatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    StatusCode[StatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    StatusCode[StatusCode["TIMEOUT"] = 408] = "TIMEOUT";
    StatusCode[StatusCode["GONE"] = 410] = "GONE";
    StatusCode[StatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
    return StatusCode;
}({});
function $5767c51dc6f9e25d$export$cde1786a482f9a1c(error) {
    return $5767c51dc6f9e25d$export$9677d7c364ada66c(401, error) || $5767c51dc6f9e25d$export$9677d7c364ada66c(403, error);
}
function $5767c51dc6f9e25d$export$9677d7c364ada66c(statusCode, error) {
    if (!error) return false;
    if (error['status'] === statusCode || // error can be `ProperNetworkError` from `packages/graphql-client/src/links/error.ts`
    error['statusCode'] === statusCode) return true;
    const reg = new RegExp(`status (code)?.*(${statusCode})`);
    return !!error?.message?.match(reg);
}
function $5767c51dc6f9e25d$export$7c7624f23566b6ff(statusCode, message) {
    const reg = new RegExp(`status .*(${statusCode})`);
    return reg.test(message);
}
var $5767c51dc6f9e25d$export$c33cd4757598521c = /*#__PURE__*/ function(TeamErrorType) {
    TeamErrorType["TEAM_NOT_ACTIVE"] = "Team must be active";
    return TeamErrorType;
}({});
// Extending new custom Error types with `Object.setPrototypeOf`
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/setPrototypeOf
class $5767c51dc6f9e25d$var$CommonError extends Error {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        this.message = message || 'UnknownError';
        this.stack = new Error(message).stack || '';
    }
}
class $5767c51dc6f9e25d$export$c73ca302efeda3b4 extends $5767c51dc6f9e25d$var$CommonError {
    constructor({ message: message }){
        super(message || 'UnknownError');
        Object.setPrototypeOf(this, $5767c51dc6f9e25d$export$c73ca302efeda3b4.prototype);
    }
}
class $5767c51dc6f9e25d$export$d87f401f8106d7a2 extends $5767c51dc6f9e25d$var$CommonError {
    constructor({ message: message }){
        super(`SentryIgnore: ${message || 'UnknownError'}`);
        Object.setPrototypeOf(this, $5767c51dc6f9e25d$export$d87f401f8106d7a2.prototype);
    }
}
class $5767c51dc6f9e25d$export$65bd6083489bd8bb extends $5767c51dc6f9e25d$var$CommonError {
    constructor({ message: message, status: status, traceId: traceId, path: path }){
        super(message);
        Object.setPrototypeOf(this, $5767c51dc6f9e25d$export$65bd6083489bd8bb.prototype);
        this.status = status;
        this.traceId = traceId;
        this.path = path;
    }
}
class $5767c51dc6f9e25d$export$826a3d65b8435adf extends $5767c51dc6f9e25d$export$65bd6083489bd8bb {
    constructor(props){
        super(props);
        Object.setPrototypeOf(this, $5767c51dc6f9e25d$export$826a3d65b8435adf.prototype);
    }
}
class $5767c51dc6f9e25d$export$92d6ed0888e7cb7f extends $5767c51dc6f9e25d$var$CommonError {
    constructor({ message: message, category: category = 'default', fields: fields }){
        super(message);
        Object.setPrototypeOf(this, $5767c51dc6f9e25d$export$92d6ed0888e7cb7f.prototype);
        this.category = category;
        if (fields) this.fields = fields;
    }
    static{
        this.from = (rawErrors)=>{
            const firstError = rawErrors[0];
            const errorData = {
                category: firstError.category,
                message: firstError.message
            };
            if (firstError.fields) errorData.fields = firstError.fields.reduce((obj, item)=>{
                obj[item.field] = item.message;
                return obj;
            }, {});
            return new $5767c51dc6f9e25d$export$92d6ed0888e7cb7f(errorData);
        };
    }
}
function $5767c51dc6f9e25d$export$476aa014e2fd89d5(error) {
    return error && !!error.message && // Firefox
    (error.message.includes('NetworkError') || // Chrome
    error.message.startsWith('Failed to fetch') || error.message.includes('GraphQL error: Failed to fetch') || // cancel by users or unknown reason
    error.message.includes('GraphQL error: The operation was aborted') || error.message.includes('GraphQL error: cancelled') || error.message.includes('Abgebrochen') || error.message.includes("\u043E\u0442\u043C\u0435\u043D\u0435\u043D\u043E") || error.message.includes("\u0421\u0435\u0442\u0435\u0432\u043E\u0435 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043F\u043E\u0442\u0435\u0440\u044F\u043D\u043E.") || error.message.includes('anulowane') || error.message.includes("annul\xe9") || error.message.includes("\u5DF2\u53D6\u6D88") || error.message.includes('cancelado') || error.message.includes("\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3057\u305F") || error.message.includes('cancelled') || error.message.includes('Network error') || // GraphQL-wrapping network error
    !!(error['graphQLErrors'] && error['networkError']));
}

});

parcelRegister("dmOdc", function(module, exports) {

$parcel$export(module.exports, "teamsClient", () => $1a92ea71d53eeb2b$export$5ed932c3646b89c6);

var $hzxsr = parcelRequire("hzxsr");

var $gTh2z = parcelRequire("gTh2z");

var $cHmJ2 = parcelRequire("cHmJ2");

var $49fYn = parcelRequire("49fYn");

var $gnKBB = parcelRequire("gnKBB");

var $7pLOg = parcelRequire("7pLOg");

var $8MCmh = parcelRequire("8MCmh");

var $13Kx5 = parcelRequire("13Kx5");

var $h46cM = parcelRequire("h46cM");

var $1B4EX = parcelRequire("1B4EX");

var $7thbw = parcelRequire("7thbw");

var $60KbN = parcelRequire("60KbN");

var $doDlD = parcelRequire("doDlD");

var $93qCC = parcelRequire("93qCC");

var $9zuJU = parcelRequire("9zuJU");
class $1a92ea71d53eeb2b$export$db59823f35bf78ce {
    constructor(/**
		 * @param {ClientContextProps} context - Context including CloudId & OrgId to be used for all requests
		 */ context){
        this._aggClient = (0, $gTh2z.aggClient);
        this._directoryClient = (0, $49fYn.directoryClient);
        this._legionClient = (0, $8MCmh.defaultLegionClient);
        this._mutabilityClient = (0, $13Kx5.default);
        this._permsClient = (0, $1B4EX.default);
        this._publicApiClient = (0, $7thbw.default);
        this._invitationsClient = (0, $7pLOg.default);
        this._userPreferencesClient = (0, $9zuJU.default);
        this._objectResolverClient = (0, $h46cM.default);
        this._teamsInSlackClient = (0, $93qCC.default);
        this._collaborationGraphClient = (0, $cHmJ2.default);
        this._identityClient = (0, $gnKBB.default);
        this._teamCentralClient = (0, $doDlD.default);
        this._replinesClient = (0, $60KbN.default);
        if (context) this.setContext(context);
    }
    async measurePerformance(name, fn) {
        const exp = (0, $hzxsr.TEAMS_CLIENT_EXPERIENCES).get(name);
        if (!exp) return fn();
        exp.start();
        try {
            const result = await fn();
            exp.success();
            return result;
        } catch (e) {
            exp.failWithError(e);
            throw e;
        }
    }
    /**
	 * Sets the base URL to be used in the client requests
	 * @param {string} baseUrl - The new base URL
	 */ setBaseUrl(baseUrl) {
        this._aggClient.setBaseUrl(baseUrl);
        this._directoryClient.setBaseUrl(baseUrl);
    }
    /**
	 * Sets context including CloudId & OrgId to be used for all requests
	 */ setContext(context) {
        this._aggClient.setContext(context);
        this._directoryClient.setContext(context);
        this._legionClient.setContext(context);
        this._permsClient.setContext(context);
        this._mutabilityClient.setContext(context);
        this._publicApiClient.setContext(context);
        this._invitationsClient.setContext(context);
        this._replinesClient.setContext(context);
    }
    setTeamCentralContext(baseUrl, context) {
        this._teamCentralClient.setContext(context);
        this._teamCentralClient.setBaseUrl(baseUrl);
    }
    /**
	 * @private
	 * @deprecated use setBaseUrl instead
	 */ setDirectoryBaseUrl(baseUrl) {
        // eslint-disable-next-line no-console
        console.warn('setDirectoryBaseUrl is deprecated, use setBaseUrl instead');
        return this._directoryClient.setBaseUrl(baseUrl);
    }
    /**
	 * Fetches Browse user settings
	 */ async querySettings(cloudId, product) {
        if (cloudId) this.setContext({
            cloudId: cloudId
        });
        return this.measurePerformance('querySettings', async ()=>{
            if (!product) throw new Error('Product is required');
            const response = await this._legionClient.retrieveBrowseUserPermission(product);
            return {
                'internal.browse-users-allowed': response.canSearchUsers
            };
        });
    }
    /**
	 * This will return all of the teams-related permissions that your user has for the org and site in the client context.
	 */ async getPermissions() {
        return this.measurePerformance('getPermissions', ()=>this._legionClient.getPermissions());
    }
    /**
	 * Fetches feature flags from Directory
	 * @deprecated As part of decommisioning pf-directoy
	 */ async queryFeatureFlags(...args) {
        return this.measurePerformance('queryFeatureFlags', ()=>this._directoryClient.queryFeatureFlags(...args));
    }
    /**
	 * Get user information of members of a team, paginated
	 * @param {string} teamId
	 * @returns {Promise}
	 */ async queryTeamMemberships(teamId, membershipState = [
        'FULL_MEMBER'
    ], pageInfo = {
        first: 100
    }) {
        return this._aggClient.queryTeamMemberships(teamId, membershipState, pageInfo);
    }
    /**
	 * Get user information given an user id
	 * @param {string} userId
	 * @returns {Promise}
	 */ async queryAGGUser(userId) {
        return this._aggClient.queryAGGUser(userId);
    }
    /**
	 * Get user information of a member of a team
	 * @param {string} userId
	 * @returns {Promise<CloudUser>}
	 */ queryUser(...args) {
        return this.measurePerformance('queryUser', ()=>this._directoryClient.queryUser(...args));
    }
    setLegionRootUrl(url) {
        return this._legionClient.setRootUrl(url);
    }
    /**
	 *
	 * @param teamId
	 * @returns {Promise<TeamWithImageUrls>}
	 */ async getTeamById(teamId) {
        return this.measurePerformance('getTeamById', ()=>this._legionClient.getTeamById(teamId));
    }
    /**
	 * Search teams based on query
	 */ async getAllTeams(...args) {
        return this.measurePerformance('getAllTeams', ()=>this._legionClient.getAllTeams(...args));
    }
    /**
	 * Update team details
	 */ async updateTeamById(...args) {
        return this.measurePerformance('updateTeamById', ()=>this._legionClient.updateTeamById(...args));
    }
    /**
	 * @private
	 * @deprecated use addUsersToTeam instead
	 */ async inviteUsersToTeam(...args) {
        return this.measurePerformance('inviteUsersToTeam', ()=>this._legionClient.inviteUsersToTeam(...args));
    }
    /**
	 * Get the current user's team membership
	 */ async getMyTeamMembership(...args) {
        return this.measurePerformance('getMyTeamMembership', ()=>this._legionClient.getMyTeamMembership(...args));
    }
    /**
	 * Get a teams "Links"
	 */ async getTeamLinksByTeamId(teamId) {
        return this.measurePerformance('getTeamLinksByTeamId', ()=>this._legionClient.getTeamLinksByTeamId(teamId));
    }
    /**
	 * Create a team link
	 */ async createTeamLink(...args) {
        return this.measurePerformance('createTeamLink', ()=>this._legionClient.createTeamLink(...args));
    }
    /**
	 * Update a team link
	 */ async updateTeamLink(...args) {
        return this.measurePerformance('updateTeamLink', ()=>this._legionClient.updateTeamLink(...args));
    }
    /**
	 * Delete a team link
	 */ async deleteTeamLink(...args) {
        return this.measurePerformance('deleteTeamLink', ()=>this._legionClient.deleteTeamLink(...args));
    }
    /**
	 * Reorder a team link
	 */ async reorderTeamLink(...args) {
        return this.measurePerformance('reorderTeamLink', ()=>this._legionClient.reorderTeamLink(...args));
    }
    /**
	 * Get org's eligibility for managed teams
	 */ async getOrgEligibilityForManagedTeams() {
        return this.measurePerformance('getOrgEligibilityForManagedTeams', ()=>this._legionClient.getOrgEligibilityForManagedTeams());
    }
    /**
	 * @deprecated Invitation status no longer exists
	 * Accept a team invitation
	 */ async acceptTeamInvitation(...args) {
        return this.measurePerformance('acceptTeamInvitation', ()=>this._legionClient.acceptTeamInvitation(...args));
    }
    /**
	 * @deprecated Invitation status no longer exists
	 * Decline a team invitation
	 */ async declineTeamInvitation(...args) {
        return this.measurePerformance('declineTeamInvitation', ()=>this._legionClient.declineTeamInvitation(...args));
    }
    /**
	 * Add current user to a team
	 */ async selfJoinTeam(...args) {
        return this.measurePerformance('selfJoinTeam', ()=>this._legionClient.selfJoinTeam(...args));
    }
    /**
	 * Cancel a join request to a private team
	 */ async cancelJoinRequest(teamId) {
        return this.measurePerformance('cancelJoinRequest', ()=>this._legionClient.cancelJoinRequest(teamId));
    }
    /**
	 * Accept a join request to a private team
	 */ async acceptJoinRequest(...args) {
        return this.measurePerformance('acceptJoinRequest', ()=>this._legionClient.acceptJoinRequest(...args));
    }
    /**
	 * Decline a join request to a private team
	 */ async declineJoinRequest(...args) {
        return this.measurePerformance('declineJoinRequest', ()=>this._legionClient.declineJoinRequest(...args));
    }
    /**
	 * @deprecated use removeTeamMemberships instead
	 */ async deleteTeamMembership(...args) {
        return this.measurePerformance('deleteTeamMembership', ()=>this._legionClient.deleteTeamMembership(...args));
    }
    /**
	 * @deprecated INVITED status has been deprecated
	 */ async revokeTeamInvite(...args) {
        return this.measurePerformance('revokeTeamInvite', ()=>this._legionClient.revokeTeamInvite(...args));
    }
    /**
	 * Delete a team
	 */ async deleteTeam(teamId) {
        return this.measurePerformance('deleteTeam', ()=>this._legionClient.deleteTeam(teamId));
    }
    /**
	 * @private
	 * @deprecated should be other means to solve this issue
	 */ async isSingleFullMemberTeam(teamId) {
        return this._legionClient.isSingleFullMemberTeam(teamId);
    }
    /**
	 * Create a team
	 */ async createTeam(...args) {
        return this.measurePerformance('createTeam', ()=>this._legionClient.createTeam(...args));
    }
    /**
	 * Create containers for a team
	 */ async createTeamContainers(...args) {
        return this.measurePerformance('createTeamContainers', ()=>this._legionClient.createTeamContainers(...args));
    }
    /**
	 * Create a external team
	 * @param {string} groupDescription - The description of the group, which will be used as the team description. The group name will be fetched from the identity service, so it does not need to be provided.
	 * @param {ExternalReference} externalReference
	 */ async createExternalTeam(...args) {
        return this.measurePerformance('createExternalTeam', ()=>this._legionClient.createExternalTeam(...args));
    }
    /**
	 * Get linked teams for a groups in bulk
	 * @param {string} groupIds - The group ids to fetch linked teams for
	 */ async getLinkedTeamsBulk(...args) {
        return this.measurePerformance('getLinkedTeamsBulk', ()=>this._legionClient.getLinkedTeamsBulk(...args));
    }
    /**
	 * Get Org scope
	 */ async getOrgScope(...args) {
        return this.measurePerformance('getOrgScope', ()=>this._legionClient.getOrgScope(...args));
    }
    /**
	 * Restore soft-deleted team and sync to group
	 */ async restoreTeamToSyncedGroup(...args) {
        return this.measurePerformance('restoreTeamToSyncedGroup', ()=>this._legionClient.restoreTeamToSyncedGroup(...args));
    }
    /**
	 * Get the difference between a team and a group
	 * @param teamId
	 * @param {ExternalReference} externalReference
	 * @returns {Promise<TeamAndGroupDifference>}
	 */ async getTeamAndGroupDiff(...args) {
        return this.measurePerformance('getTeamAndGroupDiff', ()=>this._legionClient.getTeamAndGroupDiff(...args));
    }
    /**
	 * Link an existing team to a group
	 * @param teamId
	 * @param {ExternalReference} externalReference
	 */ async linkExistingTeamToGroup(...args) {
        return this.measurePerformance('linkExistingTeamToGroup', ()=>this._legionClient.linkExistingTeamToGroup(...args));
    }
    /**
	 *
	 * @param teamId
	 * @returns {Promise<LinkedTeamsProfileDetails>}
	 */ async getTeamProfileDetailsByTeamId(...args) {
        return this.measurePerformance('getTeamProfileDetails', ()=>this._legionClient.getTeamProfileDetails(...args));
    }
    /**
	 *
	 * @param teamId
	 * @returns {Promise<SoftDeletedTeam>}
	 */ async getSoftDeletdTeamById(teamId) {
        return this.measurePerformance('getSoftDeletedTeamById', ()=>this._legionClient.getSoftDeletedTeamById(teamId));
    }
    /**
	 * Shoud only be used within Teams (P&T) packages
	 * @param userId
	 * @returns {Promise<SoftDeletedTeam>}
	 */ async getUserInSiteUserBase(userId) {
        return this.measurePerformance('getUserInSiteUserBase', ()=>this._legionClient.getUserInSiteUserBase(userId));
    }
    trimTeamARI(teamId = '') {
        return this._legionClient.trimTeamARI(teamId);
    }
    /**
	 * Get user profile with mutability constraints
	 */ async getProfileWithMutability(...args) {
        return this.measurePerformance('getProfileWithMutability', ()=>this._mutabilityClient.getProfileWithMutability(...args));
    }
    /**
	 * Is the current user a site admin
	 */ getIsSiteAdmin(...args) {
        return this.measurePerformance('getIsSiteAdmin', ()=>this._permsClient.getIsSiteAdmin(...args));
    }
    /**
	 * Add users to a team
	 */ addUsersToTeam(...args) {
        return this.measurePerformance('addUsersToTeam', ()=>this._publicApiClient.addUsersToTeam(...args));
    }
    /**
	 * Remove users from a team
	 */ removeTeamMemberships(...args) {
        return this.measurePerformance('removeTeamMemberships', ()=>this._publicApiClient.removeTeamMemberships(...args));
    }
    /**
	 * Restore a deleted team
	 */ restoreTeam(...args) {
        return this.measurePerformance('restoreTeam', ()=>this._publicApiClient.restoreTeam(...args));
    }
    getRecommendedProducts(...args) {
        return this.measurePerformance('getRecommendedProducts', ()=>this._invitationsClient.getProductRecommendations(...args));
    }
    joinOrRequestDefaultAccessToProductsBulk(...args) {
        return this.measurePerformance('joinOrRequestDefaultAccessToProductsBulk', ()=>this._invitationsClient.joinOrRequestDefaultAccessToProductsBulk(...args));
    }
    /**
	 * Get token to upload media for a team
	 */ async getWriteTeamMediaToken() {
        return this.measurePerformance('getWriteTeamMediaToken', ()=>this._legionClient.getWriteMediaToken());
    }
    /**
	 * Get token to read media for a user
	 */ async getReadMediaToken(...args) {
        return this.measurePerformance('getReadMediaToken', ()=>this._userPreferencesClient.getReadMediaToken(...args));
    }
    /**
	 * Get token to upload media for a user
	 */ async getWriteUserMediaToken() {
        return this.measurePerformance('getWriteUserMediaToken', ()=>this._userPreferencesClient.getWriteMediaToken());
    }
    /**
	 * Update header image for a user
	 */ async updateUserHeaderImage(headerImageId) {
        return this.measurePerformance('updateUserHeaderImage', ()=>this._userPreferencesClient.updateUserHeaderImage(headerImageId));
    }
    /**
	 * Fetch user containers from collboration graph
	 */ async getUserContainers(...args) {
        return this.measurePerformance('getUserContainers', ()=>this._collaborationGraphClient.getUserContainers(...args));
    }
    /**
	 * Fetch mutatability of external managed user fields
	 */ async getUserManageConfig(...args) {
        return this.measurePerformance('getUserManageConfig', ()=>this._identityClient.getUserManageConfig(...args));
    }
    /**
	 * Fetch user avatar uploaded status
	 */ async getMyAvatarUploadedStatus(...args) {
        return this.measurePerformance('getMyAvatarUploadedStatus', ()=>this._identityClient.getMyAvatarUploadedStatus(...args));
    }
    /**
	 * Delete user avatar
	 */ async deleteAvatar(...args) {
        return this.measurePerformance('deleteUserAvatar', ()=>this._identityClient.deleteAvatar(...args));
    }
    async fetchUserAvatarInfo(...args) {
        return this.measurePerformance('fetchUserAvatarInfo', ()=>this._identityClient.fetchUserAvatarInfo(...args));
    }
    /**
	 * Fetch Team link icons
	 */ async getTeamLinkIcons(...args) {
        return this.measurePerformance('getTeamLinkIcons', ()=>this._objectResolverClient.getTeamLinkIcons(...args));
    }
    /**
	 * Fetch ARI from URL
	 */ async getAriFromUrl(...args) {
        return this.measurePerformance('getAriFromUrl', ()=>this._objectResolverClient.getAriFromUrl(...args));
    }
    /**
	 * Fetch team in slack details
	 */ async getTeamInSlack(...args) {
        return this.measurePerformance('getTeamInSlack', ()=>this._teamsInSlackClient.getTeamInSlack(...args));
    }
    /**
	 * Delete team in slack
	 */ async disconnectTeamInSlack(...args) {
        return this.measurePerformance('disconnectTeamInSlack', ()=>this._teamsInSlackClient.disconnectTeamInSlack(...args));
    }
    /**
	 * Update team in slack
	 */ async updateTeamInSlack(...args) {
        return this.measurePerformance('updateTeamInSlack', ()=>this._teamsInSlackClient.updateTeamInSlack(...args));
    }
    /**
	 * Update user details
	 */ async updateUser(...args) {
        return this.measurePerformance('updateUser', ()=>this._identityClient.updateUser(...args));
    }
    async updateUserAvatar(...args) {
        return this.measurePerformance('updateUserAvatar', ()=>this._identityClient.updateUserAvatar(...args));
    }
    async addTeamWatcher(...args) {
        return this._teamCentralClient.addTeamWatcher(...args);
    }
    async removeTeamWatcher(...args) {
        return this._teamCentralClient.removeTeamWatcher(...args);
    }
    async deleteKudos(...args) {
        return this._teamCentralClient.deleteKudos(...args);
    }
    async queryTagList(...args) {
        return this._teamCentralClient.queryTagList(...args);
    }
    async createTag(...args) {
        return this._teamCentralClient.createTag(...args);
    }
    async createHelpPointer(...args) {
        return this._teamCentralClient.createHelpPointer(...args);
    }
    async updateHelpPointer(...args) {
        return this._teamCentralClient.updateHelpPointer(...args);
    }
    async deleteHelpPointer(...args) {
        return this._teamCentralClient.deleteHelpPointer(...args);
    }
    async getUserTenure(...args) {
        return this.measurePerformance('getUserTenure', ()=>this._replinesClient.getUserTenure(...args));
    }
}
const $1a92ea71d53eeb2b$export$5ed932c3646b89c6 = new $1a92ea71d53eeb2b$export$db59823f35bf78ce();

});
parcelRegister("hzxsr", function(module, exports) {

$parcel$export(module.exports, "TEAMS_CLIENT_EXPERIENCES", () => $e069606520fb7fe4$export$879344107b04120c);

var $7Zbvr = parcelRequire("7Zbvr");

var $baNgi = parcelRequire("baNgi");
const $e069606520fb7fe4$var$TeamsClientExperienceKeyList = [
    'getAllTeams',
    'getTeamById',
    'updateTeamById',
    'querySettings',
    'queryFeatureFlags',
    'queryTeamMemberships',
    'queryUser',
    'inviteUsersToTeam',
    'getMyTeamMembership',
    'getTeamLinksByTeamId',
    'createTeamLink',
    'updateTeamLink',
    'deleteTeamLink',
    'reorderTeamLink',
    'acceptTeamInvitation',
    'declineTeamInvitation',
    'selfJoinTeam',
    'cancelJoinRequest',
    'acceptJoinRequest',
    'declineJoinRequest',
    'deleteTeamMembership',
    'revokeTeamInvite',
    'deleteTeam',
    'isSingleFullMemberTeam',
    'createTeam',
    'createTeamContainers',
    'createExternalTeam',
    'getProfileWithMutability',
    'getIsSiteAdmin',
    'addUsersToTeam',
    'removeTeamMemberships',
    'getRecommendedProducts',
    'joinOrRequestDefaultAccessToProductsBulk',
    'getReadMediaToken',
    'getWriteUserMediaToken',
    'updateUserHeaderImage',
    'getWriteTeamMediaToken',
    'getSoftDeletedTeamById',
    'restoreTeam',
    'getUserInSiteUserBase',
    'getLinkedTeamsBulk',
    'getTeamProfileDetails',
    'getUserContainers',
    'getPermissions',
    'getUserManageConfig',
    'getMyAvatarUploadedStatus',
    'deleteUserAvatar',
    'getTeamLinkIcons',
    'getTeamInSlack',
    'getOrgScope',
    'restoreTeamToSyncedGroup',
    'getTeamAndGroupDiff',
    'linkExistingTeamToGroup',
    'fetchUserAvatarInfo',
    'getOrgEligibilityForManagedTeams',
    'updateUser',
    'updateUserAvatar',
    'disconnectTeamInSlack',
    'updateTeamInSlack',
    'getUserTenure',
    'getAriFromUrl'
];
const $e069606520fb7fe4$export$879344107b04120c = new Map([
    ...$e069606520fb7fe4$var$TeamsClientExperienceKeyList.map((key)=>[
            key,
            // camelCase to kebab-case
            new (0, $baNgi.TeamsUFOExperience)(`teams-client-${key.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()}`, {
                type: (0, $7Zbvr.ExperienceTypes).Operation,
                performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).Custom,
                platform: {
                    component: 'people'
                }
            })
        ])
]);

});
parcelRegister("7Zbvr", function(module, exports) {

$parcel$export(module.exports, "ExperienceTypes", () => $e40e68027603de60$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $e40e68027603de60$export$cc26007c03242fff);
var $e40e68027603de60$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $e40e68027603de60$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});

parcelRegister("baNgi", function(module, exports) {

$parcel$export(module.exports, "TeamsUFOExperience", () => $01e6318fcd37fd21$export$9a18529d1e90e81a);

var $boHLC = parcelRequire("boHLC");

var $1K4T6 = parcelRequire("1K4T6");

var $139Gm = parcelRequire("139Gm");
class $01e6318fcd37fd21$export$9a18529d1e90e81a extends (0, $boHLC.UFOExperience) {
    abortWithError(error, reason) {
        return super.abort({
            metadata: {
                error: (0, $139Gm.createErrorMetadata)(error),
                reason: reason
            }
        });
    }
    failWithError(error) {
        if (error instanceof Error) {
            if ((0, $1K4T6.isAuthError)(error)) return this.abortWithError(error, 'Abort due to user unauthenticated');
            if ((0, $1K4T6.isErrorStatusCode)((0, $1K4T6.StatusCode).GONE, error)) return this.abortWithError(error, 'Abort due to unavailable resource');
            if ((0, $139Gm.isIgnoredError)(error)) return this.abortWithError(error, 'Abort due to an error in ignore list');
            if ((0, $1K4T6.isNetworkError)(error)) return this.abortWithError(error, 'Abort due to network error');
            return super.failure({
                metadata: {
                    error: (0, $139Gm.createErrorMetadata)(error),
                    packageVersion: "0.0.0-use.local",
                    packageName: "platform-pkg"
                }
            });
        }
        return super.failure({
            metadata: {
                error: 'unknown error',
                packageVersion: "0.0.0-use.local",
                packageName: "platform-pkg"
            }
        });
    }
}

});
parcelRegister("boHLC", function(module, exports) {

$parcel$export(module.exports, "UFOExperience", () => $69d53cdb5241e240$export$c00d22927c60484a);

var $iLwDN = parcelRequire("iLwDN");
class $69d53cdb5241e240$export$c00d22927c60484a extends (0, $iLwDN.UFOAbstractExperience) {
}

});
parcelRegister("iLwDN", function(module, exports) {

$parcel$export(module.exports, "UFOAbstractExperience", () => $cc70575b2203e361$export$d31c89db257648c);

var $7Jxgt = parcelRequire("7Jxgt");


var $1vlV8 = parcelRequire("1vlV8");

var $dCAsn = parcelRequire("dCAsn");

var $dlucd = parcelRequire("dlucd");

var $blQsS = parcelRequire("blQsS");

var $9tjMO = parcelRequire("9tjMO");

var $1CRHx = parcelRequire("1CRHx");

var $jZA09 = parcelRequire("jZA09");

var $hM2B6 = parcelRequire("hM2B6");

var $7Zbvr = parcelRequire("7Zbvr");
const $cc70575b2203e361$var$getPageVisibleState = ()=>{
    return !(0, $1CRHx.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $blQsS.PageVisibleState).VISIBLE : (0, $blQsS.PageVisibleState).HIDDEN;
};
const $cc70575b2203e361$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $9tjMO.roundPerfNow)();
};
class $cc70575b2203e361$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $jZA09.UFOExperienceState).NOT_STARTED;
        this.instanceId = null // for concurrent
        ;
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $blQsS.PageVisibleState).MIXED;
            (0, $dlucd.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $cc70575b2203e361$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $7Zbvr.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $7Zbvr.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $dCAsn.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $hM2B6.canTransition)(this.state, newState)) {
            (0, $dCAsn.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $jZA09.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $cc70575b2203e361$export$c753e8669d30c8ad(timestamp);
                this.uuid = (0, $7Jxgt.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $cc70575b2203e361$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $1vlV8.getGlobalEventStream)().push((0, $1vlV8.unsubscribeEvent)((0, $blQsS.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $dCAsn.ufolog)('this.parent', this.parent);
                (0, $1vlV8.getGlobalEventStream)().push((0, $1vlV8.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $dCAsn.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $dCAsn.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $jZA09.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $cc70575b2203e361$var$getPageVisibleState();
            (0, $dlucd.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $dCAsn.ufolog)('subscribed', this.id);
                (0, $1vlV8.getGlobalEventStream)().push((0, $1vlV8.subscribeEvent)((0, $blQsS.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $blQsS.FMP_MARK) && name !== (0, $blQsS.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $dCAsn.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $cc70575b2203e361$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $jZA09.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $blQsS.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $blQsS.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $dCAsn.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $dlucd.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $jZA09.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $jZA09.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $jZA09.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $dCAsn.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $bbbd8b5766b053fb$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
// temp solution until we can get it automated
const $bbbd8b5766b053fb$export$2295b861f318254a = '0.1.5';

parcelRegister("1vlV8", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventStream", () => $d117cb8be5e8747a$export$6123a44dc2384540);
$parcel$export(module.exports, "subscribeEvent", () => $d117cb8be5e8747a$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $d117cb8be5e8747a$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $d117cb8be5e8747a$export$7c957416596ca127);

var $dCAsn = parcelRequire("dCAsn");

var $blQsS = parcelRequire("blQsS");
const $d117cb8be5e8747a$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $d117cb8be5e8747a$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $d117cb8be5e8747a$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $d117cb8be5e8747a$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $dCAsn.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $d117cb8be5e8747a$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $blQsS.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $d117cb8be5e8747a$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $blQsS.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $d117cb8be5e8747a$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $blQsS.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("dCAsn", function(module, exports) {

$parcel$export(module.exports, "ufolog", () => $c8856379f9e2d7e8$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $c8856379f9e2d7e8$export$d53d07b6034c4560);
class $c8856379f9e2d7e8$var$UFOLogger {
    static{
        this.UFOprefix = "[ufo\uD83D\uDEF8]";
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($c8856379f9e2d7e8$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($c8856379f9e2d7e8$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $c8856379f9e2d7e8$export$4ab84f6f04f6566d = new $c8856379f9e2d7e8$var$UFOLogger();
const $c8856379f9e2d7e8$export$b4958caff08a0960 = (...args)=>{
    $c8856379f9e2d7e8$export$4ab84f6f04f6566d.log(...args);
};
const $c8856379f9e2d7e8$export$d53d07b6034c4560 = (...args)=>{
    $c8856379f9e2d7e8$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("blQsS", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $2d245cff606eb60d$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $2d245cff606eb60d$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $2d245cff606eb60d$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $2d245cff606eb60d$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $2d245cff606eb60d$export$837e0f79a8056912);
var $2d245cff606eb60d$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $2d245cff606eb60d$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $2d245cff606eb60d$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $2d245cff606eb60d$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $2d245cff606eb60d$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $2d245cff606eb60d$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $2d245cff606eb60d$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $2d245cff606eb60d$export$9f2bf58999404c75 = 'fmp';
const $2d245cff606eb60d$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("dlucd", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", () => $46b8336a04974a29$export$13e680397ec8f3eb);

var $1CRHx = parcelRequire("1CRHx");
class $46b8336a04974a29$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ if ((0, $1CRHx.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $46b8336a04974a29$export$13e680397ec8f3eb = new $46b8336a04974a29$var$VisibilityChangeObserver();

});
parcelRegister("1CRHx", function(module, exports) {

$parcel$export(module.exports, "isWindowObjectAvailable", () => $5d24ea5e24f61a4f$export$15e172712955e18f);
const $5d24ea5e24f61a4f$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});


parcelRegister("9tjMO", function(module, exports) {

$parcel$export(module.exports, "roundPerfNow", () => $29608d3bcf65c265$export$5f490af6b2b115cf);
const $29608d3bcf65c265$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("jZA09", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceState", () => $175f7a63840c5fab$export$81b70111112841a0);
const $175f7a63840c5fab$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("hM2B6", function(module, exports) {

$parcel$export(module.exports, "canTransition", () => $6edf4365ea9733d4$export$178881f329fdb81f);

var $jZA09 = parcelRequire("jZA09");
const $6edf4365ea9733d4$var$UFOStateAvailableTransitions = {
    [(0, $jZA09.UFOExperienceState).NOT_STARTED.id]: [
        (0, $jZA09.UFOExperienceState).STARTED.id
    ],
    [(0, $jZA09.UFOExperienceState).STARTED.id]: [
        (0, $jZA09.UFOExperienceState).IN_PROGRESS.id,
        (0, $jZA09.UFOExperienceState).BLOCKED.id,
        (0, $jZA09.UFOExperienceState).SUCCEEDED.id,
        (0, $jZA09.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $jZA09.UFOExperienceState).FAILED.id,
        (0, $jZA09.UFOExperienceState).ABORTED.id
    ],
    [(0, $jZA09.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $jZA09.UFOExperienceState).BLOCKED.id,
        (0, $jZA09.UFOExperienceState).SUCCEEDED.id,
        (0, $jZA09.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $jZA09.UFOExperienceState).FAILED.id,
        (0, $jZA09.UFOExperienceState).ABORTED.id
    ],
    [(0, $jZA09.UFOExperienceState).BLOCKED.id]: [
        (0, $jZA09.UFOExperienceState).RECOVERED.id,
        (0, $jZA09.UFOExperienceState).ABORTED.id
    ],
    [(0, $jZA09.UFOExperienceState).RECOVERED.id]: [
        (0, $jZA09.UFOExperienceState).STARTED.id,
        (0, $jZA09.UFOExperienceState).SUCCEEDED.id,
        (0, $jZA09.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $jZA09.UFOExperienceState).FAILED.id,
        (0, $jZA09.UFOExperienceState).ABORTED.id
    ],
    [(0, $jZA09.UFOExperienceState).SUCCEEDED.id]: [
        (0, $jZA09.UFOExperienceState).STARTED.id
    ],
    [(0, $jZA09.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $jZA09.UFOExperienceState).SUCCEEDED.id,
        (0, $jZA09.UFOExperienceState).FAILED.id,
        (0, $jZA09.UFOExperienceState).ABORTED.id
    ],
    [(0, $jZA09.UFOExperienceState).FAILED.id]: [
        (0, $jZA09.UFOExperienceState).STARTED.id
    ],
    [(0, $jZA09.UFOExperienceState).ABORTED.id]: [
        (0, $jZA09.UFOExperienceState).STARTED.id
    ]
};
const $6edf4365ea9733d4$export$178881f329fdb81f = (state1, state2)=>{
    return $6edf4365ea9733d4$var$UFOStateAvailableTransitions[state1.id] && $6edf4365ea9733d4$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});



parcelRegister("139Gm", function(module, exports) {

$parcel$export(module.exports, "createErrorMetadata", () => $07d4c8a32da63d6e$export$7286a0fb7b5aab6b);
$parcel$export(module.exports, "isIgnoredError", () => $07d4c8a32da63d6e$export$a8da197a8bcc7e95);

var $1K4T6 = parcelRequire("1K4T6");
const $07d4c8a32da63d6e$export$7286a0fb7b5aab6b = (error)=>({
        error: {
            name: error.name,
            message: error.message,
            stack: error.stack,
            traceId: error instanceof (0, $1K4T6.HttpError) ? error.traceId : undefined,
            status: error instanceof (0, $1K4T6.HttpError) ? error.status : undefined
        }
    });
const $07d4c8a32da63d6e$var$ignoredErrors = [
    'SLOIgnoreError',
    'SLOIgnoreHttpError'
];
const $07d4c8a32da63d6e$export$a8da197a8bcc7e95 = (error)=>{
    const errorName = error?.constructor.name;
    if (!errorName) return false;
    return $07d4c8a32da63d6e$var$ignoredErrors.includes(errorName);
};

});



parcelRegister("gTh2z", function(module, exports) {

$parcel$export(module.exports, "aggClient", () => $68dbf55e48e6d3f1$export$464c991dbf0b2393);

var $7FbBq = parcelRequire("7FbBq");

var $aOgFy = parcelRequire("aOgFy");

var $cPPyF = parcelRequire("cPPyF");

var $6laLp = parcelRequire("6laLp");

var $7KcJC = parcelRequire("7KcJC");

var $iPviR = parcelRequire("iPviR");

var $dEcp8 = parcelRequire("dEcp8");
class $68dbf55e48e6d3f1$export$b44e5dafe13af7b3 extends (0, $cPPyF.BaseGraphQlClient) {
    constructor(baseUrl, config){
        super(`${baseUrl}/graphql`, config);
    }
    setBaseUrl(baseUrl) {
        this.setServiceUrl(`${baseUrl}/graphql`);
    }
    async queryTeamMemberships(teamId, membershipState = [
        'FULL_MEMBER'
    ], pageInfo = {
        first: 100
    }) {
        const response = await this.makeGraphQLRequest({
            query: (0, $7KcJC.default),
            variables: {
                teamId: teamId,
                membershipState: membershipState,
                siteId: this.getCloudId(),
                ...pageInfo
            }
        }, {
            operationName: 'TeamMembership'
        });
        return {
            edges: response.team.teamV2.members.edges.map(({ node: node })=>({
                    membershipId: {
                        teamId: teamId,
                        memberId: (0, $7FbBq.toUserId)(node.member.id)
                    },
                    state: node.state,
                    role: node.role,
                    user: {
                        id: (0, $7FbBq.toUserId)(node.member.id),
                        fullName: node.member.name,
                        avatarUrl: node.member.picture,
                        status: node.member.accountStatus,
                        title: node.member.extendedProfile?.jobTitle ?? undefined,
                        userType: (0, $dEcp8.toUserType)({
                            appType: node.member.appType
                        })
                    }
                })),
            pageInfo: response.team.teamV2.members.pageInfo
        };
    }
    async queryAGGUser(userId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $iPviR.TeamsUserQuery),
            variables: {
                userId: userId
            }
        }, {
            operationName: 'TeamsUserQuery'
        });
        return response.user;
    }
}
const $68dbf55e48e6d3f1$export$464c991dbf0b2393 = new $68dbf55e48e6d3f1$export$b44e5dafe13af7b3((0, $aOgFy.DEFAULT_CONFIG).stargateRoot, {
    logException: $6laLp.logException
});

});
parcelRegister("7FbBq", function(module, exports) {

$parcel$export(module.exports, "toUserId", () => $17ec50633f4e2e7f$export$1d0eef1d33b05366);
$parcel$export(module.exports, "toTeamARI", () => $17ec50633f4e2e7f$export$2bcc6e4924859c6f);

const $17ec50633f4e2e7f$export$caac29844ad91f64 = (ari)=>ari.startsWith((0, $11a0bc56687bdc88$export$470b0d72e4fdc43a));
const $17ec50633f4e2e7f$export$1d0eef1d33b05366 = (ari)=>{
    if ($17ec50633f4e2e7f$export$caac29844ad91f64(ari)) return ari.replace((0, $11a0bc56687bdc88$export$470b0d72e4fdc43a), '');
    throw new Error('Invalid UserARI');
};
const $17ec50633f4e2e7f$export$fca6a88adb58674a = (userId)=>{
    return $17ec50633f4e2e7f$export$caac29844ad91f64(userId) ? userId : `${0, $11a0bc56687bdc88$export$470b0d72e4fdc43a}${userId}`;
};
const $17ec50633f4e2e7f$export$7b81d5dfd83c8166 = (ari)=>ari.startsWith((0, $11a0bc56687bdc88$export$cfedc369802e0c68));
const $17ec50633f4e2e7f$export$e78216c959b9f3af = (ari)=>{
    if ($17ec50633f4e2e7f$export$7b81d5dfd83c8166(ari)) return ari.replace((0, $11a0bc56687bdc88$export$cfedc369802e0c68), '');
    throw new Error('Invalid TeamARI');
};
const $17ec50633f4e2e7f$export$2bcc6e4924859c6f = (teamId)=>{
    return $17ec50633f4e2e7f$export$7b81d5dfd83c8166(teamId) ? teamId : `${0, $11a0bc56687bdc88$export$cfedc369802e0c68}${teamId}`;
};

});
const $11a0bc56687bdc88$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $11a0bc56687bdc88$export$cfedc369802e0c68 = 'ari:cloud:identity::team/';


parcelRegister("aOgFy", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CONFIG", () => $63e5f3a0103519a1$export$c2f8e0cc249a8d8f);
const $63e5f3a0103519a1$export$c2f8e0cc249a8d8f = {
    stargateRoot: '/gateway/api',
    permsServiceUrl: '/gateway/api/permissions',
    publicApiRoot: '/gateway/api/public',
    invitationsServiceUrl: '/gateway/api/invitations',
    collaborationGraphUrl: '/gateway/api/collaboration'
};

});

parcelRegister("cPPyF", function(module, exports) {

$parcel$export(module.exports, "BaseGraphQlClient", () => $50423a8c851cd9c1$export$42f6d6baced34b2d);

var $1K4T6 = parcelRequire("1K4T6");

var $cIUqK = parcelRequire("cIUqK");

var $e5X66 = parcelRequire("e5X66");
class $50423a8c851cd9c1$export$42f6d6baced34b2d extends (0, $cIUqK.BaseClient) {
    constructor(serviceUrl, config){
        super(config);
        this.serviceUrl = serviceUrl;
    }
    setServiceUrl(serviceUrl) {
        this.serviceUrl = serviceUrl;
    }
    async makeGraphQLRequest(body, options = {}) {
        try {
            return (0, $e5X66.handleGraphQLRequest)(this.serviceUrl, body, options);
        } catch (error) {
            if (error instanceof (0, $1K4T6.GraphQLError)) throw error;
            this.logException(error, 'UnknownError in GraphQLClient.makeGraphQLRequestWithoutRetries');
            throw new (0, $1K4T6.DefaultError)({});
        }
    }
}

});
parcelRegister("cIUqK", function(module, exports) {

$parcel$export(module.exports, "BaseClient", () => $f6a5ca6563f596bf$export$4f22f74eddb7716a);

var $6laLp = parcelRequire("6laLp");
class $f6a5ca6563f596bf$export$4f22f74eddb7716a {
    constructor(config){
        this.cache = {};
        this.logException = (ex, name, context)=>{
            (0, $6laLp.logException)(ex, name, context);
            this.config.logException(ex, name, context);
        };
        this.config = config;
        this.context = {
            cloudId: 'None'
        };
    }
    setContext(context) {
        this.context = {
            ...context,
            cloudId: context.cloudId || 'None'
        };
    }
    getContext() {
        return this.context;
    }
    /**
	 *
	 * @param localValue is used for backwards compatibility
	 * @returns
	 */ getOrgId(localValue) {
        const orgId = localValue || this.getContext().orgId;
        if (!orgId) {
            const err = new Error('No orgId set');
            this.logException(err, 'No orgId set');
            throw err;
        }
        return orgId;
    }
    /**
	 *
	 * @param localValue is used for backwards compatibility
	 * @returns
	 */ getCloudId(localValue) {
        return localValue || this.getContext().cloudId;
    }
    keyWithContext(key) {
        return `${this.getContext().cloudId}-${this.getContext().orgId ?? 'no-org-id'}-${this.getContext().userId ?? 'no-user-id'}-${key}`;
    }
    // Default expiration is 5 minutes
    cacheValue(key, value, expiryMs = 300000) {
        this.cache[this.keyWithContext(key)] = {
            data: value,
            expiration: Date.now() + expiryMs
        };
    }
    getCachedValue(key) {
        const record = this.cache[this.keyWithContext(key)];
        if (record && record.expiration > Date.now()) return record.data;
        return undefined;
    }
}

});
parcelRegister("6laLp", function(module, exports) {

$parcel$export(module.exports, "logException", () => $b8ae333ac130caf8$export$f86b2a1a2ce291b3);
$parcel$export(module.exports, "logErrorMessage", () => $b8ae333ac130caf8$export$ece28f5cfa04608);
$parcel$export(module.exports, "logInfoMessage", () => $b8ae333ac130caf8$export$386587bcf05ee8ea);
$parcel$export(module.exports, "logExceptionWithPackageContext", () => $b8ae333ac130caf8$export$7208e9272a946c36);
$parcel$export(module.exports, "logErrorMessageWithPackageContext", () => $b8ae333ac130caf8$export$dbd2da61a76fb8d2);
$parcel$export(module.exports, "logInfoMessageWithPackageContext", () => $b8ae333ac130caf8$export$f242834c5699e597);
$parcel$export(module.exports, "createErrorHandlerWithPackageContext", () => $b8ae333ac130caf8$export$6b2a307bf7c6c1dc);
$parcel$export(module.exports, "addBreadcrumb", () => $b8ae333ac130caf8$export$efda9a273d7a036d);
// See Sentry accepted options in here https://docs.sentry.io/error-reporting/configuration/?platform=javascript

var $6jQUd = parcelRequire("6jQUd");
function $b8ae333ac130caf8$var$decorateScope(scope, context) {
    const { tags: tags, ...otherContext } = context;
    if (tags) scope.setTags(tags);
    if (Object.keys(otherContext).length) scope.setExtras(otherContext);
    return scope;
}
async function $b8ae333ac130caf8$export$f86b2a1a2ce291b3(ex, name, context = {}) {
    try {
        const sentryClient = await (0, $6jQUd.getSentryClient)();
        if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
        sentryClient.withScope((scope)=>{
            $b8ae333ac130caf8$var$decorateScope(scope, context);
            scope.setTag('name', name);
            scope.setTag('packageName', context.packageName ?? 'unknown');
            scope.setTag('packageVersion', context.packageVersion ?? 'unknown');
            sentryClient.captureException(ex, scope);
        });
    } catch  {
    // silence sentry exceptions
    }
}
async function $b8ae333ac130caf8$var$logMessage(severity, message, context = {}) {
    const sentryClient = await (0, $6jQUd.getSentryClient)();
    if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
    sentryClient.withScope((scope)=>{
        $b8ae333ac130caf8$var$decorateScope(scope, context);
        // The Severity enum is being replaced by SeverityLevel type in v7 anyway
        scope.setLevel(severity);
        scope.setTag('packageName', context.packageName ?? 'unknown');
        scope.setTag('packageVersion', context.packageVersion ?? 'unknown');
        sentryClient.captureMessage(message, scope);
    });
}
function $b8ae333ac130caf8$export$ece28f5cfa04608(message, context = {}) {
    $b8ae333ac130caf8$var$logMessage('error', message, context).catch(()=>{});
}
function $b8ae333ac130caf8$export$386587bcf05ee8ea(message, context = {}) {
    $b8ae333ac130caf8$var$logMessage('info', message, context).catch(()=>{});
}
const $b8ae333ac130caf8$export$9edc7d6f1c33ddc = (details)=>{
    return (error, message, tags = {})=>{
        $b8ae333ac130caf8$export$f86b2a1a2ce291b3(error, message, {
            tags: {
                ...details,
                ...tags
            }
        });
    };
};
const $b8ae333ac130caf8$export$7208e9272a946c36 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $b8ae333ac130caf8$export$f86b2a1a2ce291b3(args[0], args[1], {
            ...args[2],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $b8ae333ac130caf8$export$dbd2da61a76fb8d2 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $b8ae333ac130caf8$export$ece28f5cfa04608(args[0], {
            ...args[1],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $b8ae333ac130caf8$export$f242834c5699e597 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $b8ae333ac130caf8$export$386587bcf05ee8ea(args[0], {
            ...args[1],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $b8ae333ac130caf8$export$6b2a307bf7c6c1dc = (packageContext)=>(...args)=>$b8ae333ac130caf8$export$9edc7d6f1c33ddc({
            ...args[0],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
async function $b8ae333ac130caf8$export$efda9a273d7a036d(crumb) {
    const sentryClient = await (0, $6jQUd.getSentryClient)();
    sentryClient.withScope((scope)=>{
        scope.addBreadcrumb(typeof crumb === 'string' ? {
            message: crumb
        } : crumb);
    });
}

});
parcelRegister("6jQUd", function(module, exports) {

$parcel$export(module.exports, "sentryClient", () => $1a080a899118f506$export$ac71c212168fcd2b);
$parcel$export(module.exports, "setSentryClient", () => $1a080a899118f506$export$7d446c6f4e54de82);
$parcel$export(module.exports, "getSentryClient", () => $1a080a899118f506$export$f553e8b08ef59d31);
$parcel$export(module.exports, "setupSentryClient", () => $1a080a899118f506$export$d8bd0edf6c978788);

var $cESX7 = parcelRequire("cESX7");

var $f90f5 = parcelRequire("f90f5");
let $1a080a899118f506$export$ac71c212168fcd2b;
const $1a080a899118f506$export$7d446c6f4e54de82 = (client)=>{
    $1a080a899118f506$export$ac71c212168fcd2b = client;
};
const $1a080a899118f506$export$f553e8b08ef59d31 = async ()=>{
    if (!$1a080a899118f506$export$ac71c212168fcd2b) await $1a080a899118f506$export$d8bd0edf6c978788({});
    return $1a080a899118f506$export$ac71c212168fcd2b;
};
async function $1a080a899118f506$export$d8bd0edf6c978788({ appName: appName, env: env }) {
    const sentryClient = await $1a080a899118f506$var$requireSentryLib();
    if (!sentryClient) return;
    // initialiseSentry sets the sentry client
    (0, $f90f5.initialiseSentry)(sentryClient, {
        initialScope: {
            tags: {
                renderMode: appName || 'unknown',
                productBuild: // @ts-ignore Jira  - window.BUILD_KEY, confluence - window.__buildInfo
                window.BUILD_KEY || window.__buildInfo?.FRONTEND_VERSION || 'unknown',
                product: $1a080a899118f506$var$getProduct()
            }
        },
        env: env,
        noGlobals: true,
        dsn: (0, $cESX7.SENTRY_DSN),
        attachStacktrace: true
    });
}

async function $1a080a899118f506$var$requireSentryLib() {
    // saving ~40K
    try {
        return (parcelRequire("61QSy"));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('Ignoring rejected promise when loading sentry resource.', error);
    }
}
function $1a080a899118f506$var$getProduct() {
    const path = window.location.pathname;
    if (path.includes('/jira/people')) return 'jira';
    else if (path.includes('/wiki/people')) return 'confluence';
    return 'unknown';
}

});
parcelRegister("cESX7", function(module, exports) {

$parcel$export(module.exports, "SENTRY_DSN", () => $7172257c54583cfa$export$6faa4a850bc4d0ce);

var $c04PQ = parcelRequire("c04PQ");
const $7172257c54583cfa$export$9cf97fd92bea5d81 = '1dc056d49dfe4df8961dc1b810e4620d';
const $7172257c54583cfa$export$68c35ed3898e185a = '5988845';
const $7172257c54583cfa$export$b03be5cdb5af5197 = '067abcc494be9a87b3cdf9416f2b97d5';
const $7172257c54583cfa$export$97db6664a1e55fa6 = '47';
const $7172257c54583cfa$var$SENTRY_COMMERCIAL_DSN = `https://${$7172257c54583cfa$export$9cf97fd92bea5d81}@o55978.ingest.sentry.io/${$7172257c54583cfa$export$68c35ed3898e185a}`;
const $7172257c54583cfa$var$SENTRY_FEDRAMP_DSN = `https://${$7172257c54583cfa$export$b03be5cdb5af5197}@sentry.atlassian-us-gov-mod.com/${$7172257c54583cfa$export$97db6664a1e55fa6}`;
const $7172257c54583cfa$export$6faa4a850bc4d0ce = (0, $c04PQ.isFedRamp)() ? $7172257c54583cfa$var$SENTRY_FEDRAMP_DSN : $7172257c54583cfa$var$SENTRY_COMMERCIAL_DSN;

});

parcelRegister("f90f5", function(module, exports) {

$parcel$export(module.exports, "initialiseSentry", () => $bb873a2430dbd9e0$export$357606956af25316);

var $lqMqM = parcelRequire("lqMqM");

var $6jQUd = parcelRequire("6jQUd");
const $bb873a2430dbd9e0$var$DISABLED_INTEGRATIONS = [
    'onerror',
    'onunhandledrejection',
    // In Jira this integration is being initialised twice, resulting in no events being sent to Sentry
    'Dedupe'
];
async function $bb873a2430dbd9e0$export$357606956af25316(client, options) {
    if (0, $6jQUd.sentryClient) return;
    if (!client) return;
    (0, $6jQUd.setSentryClient)(client);
    const sentryConfig = (0, $lqMqM.getSentryConfig)(options);
    (0, $6jQUd.sentryClient).init({
        ...sentryConfig,
        integrations: function(integrations) {
            return integrations.filter(function(integration) {
                return $bb873a2430dbd9e0$var$DISABLED_INTEGRATIONS.indexOf(integration.name) === -1;
            });
        }
    });
}

});
parcelRegister("lqMqM", function(module, exports) {

$parcel$export(module.exports, "getSentryConfig", () => $0ea77fabdacad2ed$export$5580e6304e95c792);

var $cESX7 = parcelRequire("cESX7");
const $0ea77fabdacad2ed$var$DEFAULT_SENTRY_CONFIG = {
    whitelistUrls: [
        /atl-paas.net/,
        // test local host
        /localhost/
    ],
    ignoreErrors: [
        /^SentryIgnore:/,
        // Network related errors
        'The operation was aborted',
        'Software caused connection abort',
        'GraphQL error: Failed to fetch',
        'TypeError: Failed to fetch',
        'TypeError: NetworkError when attempting to fetch resource.',
        'AbortError: The user aborted a request.',
        /^network error/i,
        /^network failure/i,
        /^NetworkError/i,
        /^Unexpected token ..*/
    ],
    ignoreUrls: [
        // Chrome extensions
        /extensions\//i,
        /^chrome:\/\//i
    ],
    dsn: (0, $cESX7.SENTRY_DSN),
    attachStacktrace: true
};
function $0ea77fabdacad2ed$export$5580e6304e95c792(options) {
    const { env: env, version: version, noGlobals: _, ...otherOptions } = options;
    return {
        ...otherOptions,
        ...$0ea77fabdacad2ed$var$DEFAULT_SENTRY_CONFIG,
        // Standalone __VERSION__ is set from `bin/set-release-version.sh`
        // when building to deploy to production
        release: `${"platform-pkg"}@${"0.0.0-use.local"}` || // @ts-ignore Jira  - window.BUILD_KEY
        window.BUILD_KEY || // @ts-ignore Confluence - window.__buildInfo
        window.__buildInfo?.FRONTEND_VERSION || '---',
        environment: env || 'prod'
    };
}

});


parcelRegister("61QSy", function(module, exports) {

let $463bdab5e8d2e224$var$load = (parcelRequire("28QjX"))(4);
module.exports = $463bdab5e8d2e224$var$load("cc1Au").then(()=>parcelRequire('godCI'));

});




parcelRegister("e5X66", function(module, exports) {

$parcel$export(module.exports, "handleGraphQLRequest", () => $dacc5a55576333f2$export$7feffc86760ee7ce);

var $1K4T6 = parcelRequire("1K4T6");

var $4F5SC = parcelRequire("4F5SC");

var $hdjej = parcelRequire("hdjej");
async function $dacc5a55576333f2$export$93d33e3b46bf00e7(serviceUrl, body, options = {}) {
    const operationNameQuery = options.operationName ? `?q=${options.operationName}` : '';
    const errorPolicy = options.errorPolicy || 'none';
    const url = serviceUrl + operationNameQuery;
    const request = fetch(url, {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        credentials: 'include',
        body: JSON.stringify(body)
    }).then((res)=>{
        if (res.status < 300 || res.status === 400) return res.json();
        else throw res;
    });
    try {
        const response = await request;
        const errors = response.errors;
        if (errors) {
            if (errorPolicy === 'none') throw (0, $1K4T6.GraphQLError).from(errors);
            else if (errorPolicy === 'all') // Set timeout will postpone error throwing and de-touch it to another event loop,
            // so we can return data along with throwing error
            return new Promise((resolve, reject)=>{
                setTimeout(()=>{
                    reject((0, $1K4T6.GraphQLError).from(errors));
                }, 0);
            });
        }
        return response.data;
    } catch (error) {
        if (error instanceof Response) return {
            response: error
        };
        if (Object(error).hasOwnProperty('response')) throw error;
        return error;
    }
}
async function $dacc5a55576333f2$export$7feffc86760ee7ce(serviceUrl, body, options = {}) {
    const makeGraphQLRequestWithRetries = (0, $4F5SC.withExponentialBackoff)($dacc5a55576333f2$export$93d33e3b46bf00e7, {
        initial: (0, $4F5SC.EXPONENTIAL_BACKOFF_RETRY_POLICY).INITIAL_DELAY,
        jitter: (0, $4F5SC.EXPONENTIAL_BACKOFF_RETRY_POLICY).JITTER,
        max: (0, $4F5SC.EXPONENTIAL_BACKOFF_RETRY_POLICY).MAX_RETRIES,
        retryIf: (data)=>{
            return (0, $4F5SC.isFetchResponse)(data) && (0, $4F5SC.is5xx)(data.response.status);
        }
    });
    const result = await makeGraphQLRequestWithRetries(serviceUrl, body, options);
    const response = result?.response;
    if (response) {
        const status = response.status;
        const statusText = response.statusText;
        const traceId = response.headers.get('atl-traceid');
        (0, $hdjej.handleResponse)(response);
        if (status > 400 && status <= 599) throw new (0, $1K4T6.HttpError)({
            message: statusText,
            status: status,
            traceId: traceId ?? undefined
        });
    }
    return result;
}

});
parcelRegister("4F5SC", function(module, exports) {

$parcel$export(module.exports, "EXPONENTIAL_BACKOFF_RETRY_POLICY", () => $0bcb1394a3249358$export$8f4286bf21155381);
$parcel$export(module.exports, "is5xx", () => $0bcb1394a3249358$export$55b2fbd5d4a32495);
$parcel$export(module.exports, "isFetchResponse", () => $0bcb1394a3249358$export$81f27058be86d7ea);
$parcel$export(module.exports, "withExponentialBackoff", () => $0bcb1394a3249358$export$20eaa22f2295996f);
$parcel$export(module.exports, "fetchWithExponentialBackoff", () => $0bcb1394a3249358$export$b4c0bf5325504bf3);
const $0bcb1394a3249358$export$8f4286bf21155381 = {
    INITIAL_DELAY: 200,
    MAX_RETRIES: 5,
    JITTER: true
};
function $0bcb1394a3249358$export$55b2fbd5d4a32495(status) {
    return 500 <= status && status <= 599;
}
function $0bcb1394a3249358$export$81f27058be86d7ea(data) {
    if (!data || !data.hasOwnProperty('response')) return false;
    return data.response instanceof Response;
}
// tslint:disable-next-line no-any
const $0bcb1394a3249358$var$defaultRetryIfCallback = (a)=>!a;
const $0bcb1394a3249358$var$defaultOptions = {
    initial: 200,
    jitter: false,
    max: 5,
    retryIf: $0bcb1394a3249358$var$defaultRetryIfCallback
};
function $0bcb1394a3249358$export$20eaa22f2295996f(toTry, hofOptions = $0bcb1394a3249358$var$defaultOptions) {
    const { initial: initial, jitter: jitter, max: max, retryIf: retryIf } = hofOptions;
    // Initialize max retry decrementing counter (range of max...0)
    let attemptsRemaining = max;
    // Initialize delay. This will exponentially increase each retry (delay = intial * 2^n)
    let delay = initial;
    /**
	 * This function calls itself recursively until `retryIf` evaluates false or the retry limit is reached.
	 * The functioned-to-be-retried is called on each recursion.
	 */ return async function tryWithExponentialBackoff(...args) {
        // "An attempt was made"
        const result = await toTry(...args);
        --attemptsRemaining;
        // If tried function was unsuccessful and there are still retries remaining, retry!
        if (retryIf && retryIf(result) && attemptsRemaining > 0) {
            // Wait for delay
            await new Promise((resolve)=>setTimeout(resolve, jitter ? Math.random() * delay : delay));
            // Exponentially increase delay
            delay *= 2;
            // Initiate retry
            return tryWithExponentialBackoff(...args);
        }
        // Return result of tried function if it is successful or if the retry limit
        // was reached regardless of success.
        return result;
    };
}
const $0bcb1394a3249358$export$b4c0bf5325504bf3 = $0bcb1394a3249358$export$20eaa22f2295996f((url, init)=>fetch(url, init), {
    initial: $0bcb1394a3249358$export$8f4286bf21155381.INITIAL_DELAY,
    jitter: $0bcb1394a3249358$export$8f4286bf21155381.JITTER,
    max: $0bcb1394a3249358$export$8f4286bf21155381.MAX_RETRIES,
    retryIf: (response)=>$0bcb1394a3249358$export$55b2fbd5d4a32495(response.status)
});

});

parcelRegister("hdjej", function(module, exports) {

$parcel$export(module.exports, "handleResponse", () => $9c1b9c6605e9f581$export$c113a67a6762ad2e);
/**
 * Our REST clients are initialised when their module loads which makes it tricky for them to consume the `statusCodeHandlers` prop passed to App from the host application.
 * This is a temporary measure to enable the clients to consume `statusCodeHandlers`.
 * The long term solution is to replace our REST clients with Apollo client custom resolvers
 * This will unify all remote data handling under the apollo-client module which is able to easily receive `statusCodeHandlers` as it is initialised within the React portion of our app.
 */ const $9c1b9c6605e9f581$export$8c005e458e12d501 = {
    handlers: {},
    get () {
        return $9c1b9c6605e9f581$export$8c005e458e12d501.handlers;
    },
    setHandlers (handlers) {
        $9c1b9c6605e9f581$export$8c005e458e12d501.handlers = handlers;
    }
};
function $9c1b9c6605e9f581$export$c113a67a6762ad2e(response) {
    const { status: status } = response;
    const handler = $9c1b9c6605e9f581$export$8c005e458e12d501.get()[status];
    if (typeof handler === 'function') handler(response);
}

});



parcelRegister("7KcJC", function(module, exports) {

$parcel$export(module.exports, "default", () => $db20d2370669efd9$export$2e2bcd8739ae039);
const $db20d2370669efd9$var$TeamMembershipQuery = `query app_user_characteristics($teamId: ID!, $siteId: String!, $membershipState: [TeamMembershipState!]!, $first: Int!, $after: String) {
    team {
      teamV2(
        id: $teamId
        siteId: $siteId
      ) @optIn(to: "Team-v2") {
        members(state: $membershipState, first: $first, after: $after) {
          edges {
            node {
              member {
                id
                name
                picture
                accountStatus
                ... on AtlassianAccountUser {
                  extendedProfile {
                    jobTitle
                  }
                }
                ... on AppUser {
                  appType
                }
              }
              role
              state
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    }
  }`;
var $db20d2370669efd9$export$2e2bcd8739ae039 = $db20d2370669efd9$var$TeamMembershipQuery;

});

parcelRegister("iPviR", function(module, exports) {

$parcel$export(module.exports, "TeamsUserQuery", () => $35ae14e4e07b2810$export$9963ed3cbf7b791c);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");
const $35ae14e4e07b2810$export$9963ed3cbf7b791c = (0, $1c8Um.print)((0, $5cllN.default)`
	query TeamsUserQuery($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				locale
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					department
					location
					phoneNumbers {
						type
						value
					}
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				locale
				zoneinfo
			}
			... on AppUser {
				appType
			}
		}
	}
`);

});
parcelRegister("1c8Um", function(module, exports) {

$parcel$export(module.exports, "print", () => $0dedd2672864572f$export$c2d084dc44961371);

var $12QNw = parcelRequire("12QNw");

var $541Mz = parcelRequire("541Mz");
function $0dedd2672864572f$export$c2d084dc44961371(ast) {
    return (0, $12QNw.visit)(ast, {
        leave: $0dedd2672864572f$var$printDocASTReducer
    });
}
var $0dedd2672864572f$var$MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future
var $0dedd2672864572f$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return '$' + node.name;
    },
    // Document
    Document: function Document(node) {
        return $0dedd2672864572f$var$join(node.definitions, '\n\n') + '\n';
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $0dedd2672864572f$var$wrap('(', $0dedd2672864572f$var$join(node.variableDefinitions, ', '), ')');
        var directives = $0dedd2672864572f$var$join(node.directives, ' ');
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === 'query' ? selectionSet : $0dedd2672864572f$var$join([
            op,
            $0dedd2672864572f$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], ' ');
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ': ' + type + $0dedd2672864572f$var$wrap(' = ', defaultValue) + $0dedd2672864572f$var$wrap(' ', $0dedd2672864572f$var$join(directives, ' '));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $0dedd2672864572f$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        var prefix = $0dedd2672864572f$var$wrap('', alias, ': ') + name;
        var argsLine = prefix + $0dedd2672864572f$var$wrap('(', $0dedd2672864572f$var$join(args, ', '), ')');
        if (argsLine.length > $0dedd2672864572f$var$MAX_LINE_LENGTH) argsLine = prefix + $0dedd2672864572f$var$wrap('(\n', $0dedd2672864572f$var$indent($0dedd2672864572f$var$join(args, '\n')), '\n)');
        return $0dedd2672864572f$var$join([
            argsLine,
            $0dedd2672864572f$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ': ' + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return '...' + name + $0dedd2672864572f$var$wrap(' ', $0dedd2672864572f$var$join(directives, ' '));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $0dedd2672864572f$var$join([
            '...',
            $0dedd2672864572f$var$wrap('on ', typeCondition),
            $0dedd2672864572f$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($0dedd2672864572f$var$wrap('(', $0dedd2672864572f$var$join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat($0dedd2672864572f$var$wrap('', $0dedd2672864572f$var$join(directives, ' '), ' ')) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, $541Mz.printBlockString)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? 'true' : 'false';
    },
    NullValue: function NullValue() {
        return 'null';
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return '[' + $0dedd2672864572f$var$join(values, ', ') + ']';
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return '{' + $0dedd2672864572f$var$join(fields, ', ') + '}';
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ': ' + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return '@' + name + $0dedd2672864572f$var$wrap('(', $0dedd2672864572f$var$join(args, ', '), ')');
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return '[' + type + ']';
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + '!';
    },
    // Type System Definitions
    SchemaDefinition: $0dedd2672864572f$var$addDescription(function(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $0dedd2672864572f$var$join([
            'schema',
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(operationTypes)
        ], ' ');
    }),
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ': ' + type;
    },
    ScalarTypeDefinition: $0dedd2672864572f$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $0dedd2672864572f$var$join([
            'scalar',
            name,
            $0dedd2672864572f$var$join(directives, ' ')
        ], ' ');
    }),
    ObjectTypeDefinition: $0dedd2672864572f$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $0dedd2672864572f$var$join([
            'type',
            name,
            $0dedd2672864572f$var$wrap('implements ', $0dedd2672864572f$var$join(interfaces, ' & ')),
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(fields)
        ], ' ');
    }),
    FieldDefinition: $0dedd2672864572f$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + ($0dedd2672864572f$var$hasMultilineItems(args) ? $0dedd2672864572f$var$wrap('(\n', $0dedd2672864572f$var$indent($0dedd2672864572f$var$join(args, '\n')), '\n)') : $0dedd2672864572f$var$wrap('(', $0dedd2672864572f$var$join(args, ', '), ')')) + ': ' + type + $0dedd2672864572f$var$wrap(' ', $0dedd2672864572f$var$join(directives, ' '));
    }),
    InputValueDefinition: $0dedd2672864572f$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $0dedd2672864572f$var$join([
            name + ': ' + type,
            $0dedd2672864572f$var$wrap('= ', defaultValue),
            $0dedd2672864572f$var$join(directives, ' ')
        ], ' ');
    }),
    InterfaceTypeDefinition: $0dedd2672864572f$var$addDescription(function(_ref26) {
        var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
        return $0dedd2672864572f$var$join([
            'interface',
            name,
            $0dedd2672864572f$var$wrap('implements ', $0dedd2672864572f$var$join(interfaces, ' & ')),
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(fields)
        ], ' ');
    }),
    UnionTypeDefinition: $0dedd2672864572f$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $0dedd2672864572f$var$join([
            'union',
            name,
            $0dedd2672864572f$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $0dedd2672864572f$var$join(types, ' | ') : ''
        ], ' ');
    }),
    EnumTypeDefinition: $0dedd2672864572f$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $0dedd2672864572f$var$join([
            'enum',
            name,
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(values)
        ], ' ');
    }),
    EnumValueDefinition: $0dedd2672864572f$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $0dedd2672864572f$var$join([
            name,
            $0dedd2672864572f$var$join(directives, ' ')
        ], ' ');
    }),
    InputObjectTypeDefinition: $0dedd2672864572f$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $0dedd2672864572f$var$join([
            'input',
            name,
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(fields)
        ], ' ');
    }),
    DirectiveDefinition: $0dedd2672864572f$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return 'directive @' + name + ($0dedd2672864572f$var$hasMultilineItems(args) ? $0dedd2672864572f$var$wrap('(\n', $0dedd2672864572f$var$indent($0dedd2672864572f$var$join(args, '\n')), '\n)') : $0dedd2672864572f$var$wrap('(', $0dedd2672864572f$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $0dedd2672864572f$var$join(locations, ' | ');
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $0dedd2672864572f$var$join([
            'extend schema',
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(operationTypes)
        ], ' ');
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $0dedd2672864572f$var$join([
            'extend scalar',
            name,
            $0dedd2672864572f$var$join(directives, ' ')
        ], ' ');
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $0dedd2672864572f$var$join([
            'extend type',
            name,
            $0dedd2672864572f$var$wrap('implements ', $0dedd2672864572f$var$join(interfaces, ' & ')),
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(fields)
        ], ' ');
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
        return $0dedd2672864572f$var$join([
            'extend interface',
            name,
            $0dedd2672864572f$var$wrap('implements ', $0dedd2672864572f$var$join(interfaces, ' & ')),
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(fields)
        ], ' ');
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $0dedd2672864572f$var$join([
            'extend union',
            name,
            $0dedd2672864572f$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $0dedd2672864572f$var$join(types, ' | ') : ''
        ], ' ');
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $0dedd2672864572f$var$join([
            'extend enum',
            name,
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(values)
        ], ' ');
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $0dedd2672864572f$var$join([
            'extend input',
            name,
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(fields)
        ], ' ');
    }
};
function $0dedd2672864572f$var$addDescription(cb) {
    return function(node) {
        return $0dedd2672864572f$var$join([
            node.description,
            cb(node)
        ], '\n');
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $0dedd2672864572f$var$join(maybeArray) {
    var _maybeArray$filter$jo;
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $0dedd2672864572f$var$block(array) {
    return $0dedd2672864572f$var$wrap('{\n', $0dedd2672864572f$var$indent($0dedd2672864572f$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $0dedd2672864572f$var$wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $0dedd2672864572f$var$indent(str) {
    return $0dedd2672864572f$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $0dedd2672864572f$var$isMultiline(str) {
    return str.indexOf('\n') !== -1;
}
function $0dedd2672864572f$var$hasMultilineItems(maybeArray) {
    return maybeArray != null && maybeArray.some($0dedd2672864572f$var$isMultiline);
}

});
parcelRegister("541Mz", function(module, exports) {

$parcel$export(module.exports, "dedentBlockStringValue", () => $3afeb56b3b6851c5$export$fd88c0b652c46ccc);
$parcel$export(module.exports, "printBlockString", () => $3afeb56b3b6851c5$export$adb6ca997eeb1f45);
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $3afeb56b3b6851c5$export$fd88c0b652c46ccc(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $3afeb56b3b6851c5$export$3c95bfdc680af0c(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && $3afeb56b3b6851c5$var$isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && $3afeb56b3b6851c5$var$isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join('\n');
}
function $3afeb56b3b6851c5$var$isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== ' ' && str[i] !== '\t') return false;
    }
    return true;
}
function $3afeb56b3b6851c5$export$3c95bfdc680af0c(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
function $3afeb56b3b6851c5$export$adb6ca997eeb1f45(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf('\n') === -1;
    var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === '\\';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ''; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
    result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
    if (printAsMultipleLines) result += '\n';
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

});


parcelRegister("5cllN", function(module, exports) {

$parcel$export(module.exports, "gql", () => $3c8ea2810a9abcde$export$72e4926bf8358653);
$parcel$export(module.exports, "default", () => $3c8ea2810a9abcde$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $8uUC9 = parcelRequire("8uUC9");
var $3c8ea2810a9abcde$var$docCache = new Map();
var $3c8ea2810a9abcde$var$fragmentSourceMap = new Map();
var $3c8ea2810a9abcde$var$printFragmentWarnings = true;
var $3c8ea2810a9abcde$var$experimentalFragmentVariables = false;
function $3c8ea2810a9abcde$var$normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function $3c8ea2810a9abcde$var$cacheKeyFromLoc(loc) {
    return $3c8ea2810a9abcde$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $3c8ea2810a9abcde$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $3c8ea2810a9abcde$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $3c8ea2810a9abcde$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($3c8ea2810a9abcde$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $3c8ea2810a9abcde$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, ast), {
        definitions: definitions
    });
}
function $3c8ea2810a9abcde$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === 'object') workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $3c8ea2810a9abcde$var$parseDocument(source) {
    var cacheKey = $3c8ea2810a9abcde$var$normalize(source);
    if (!$3c8ea2810a9abcde$var$docCache.has(cacheKey)) {
        var parsed = (0, $8uUC9.parse)(source, {
            experimentalFragmentVariables: $3c8ea2810a9abcde$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $3c8ea2810a9abcde$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') throw new Error('Not a valid GraphQL document.');
        $3c8ea2810a9abcde$var$docCache.set(cacheKey, $3c8ea2810a9abcde$var$stripLoc($3c8ea2810a9abcde$var$processFragments(parsed)));
    }
    return $3c8ea2810a9abcde$var$docCache.get(cacheKey);
}
function $3c8ea2810a9abcde$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === 'string') literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === 'Document') result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $3c8ea2810a9abcde$var$parseDocument(result);
}
function $3c8ea2810a9abcde$export$657554ef4dc7ac2d() {
    $3c8ea2810a9abcde$var$docCache.clear();
    $3c8ea2810a9abcde$var$fragmentSourceMap.clear();
}
function $3c8ea2810a9abcde$export$e4294e638636c6ab() {
    $3c8ea2810a9abcde$var$printFragmentWarnings = false;
}
function $3c8ea2810a9abcde$export$78cf889af350c840() {
    $3c8ea2810a9abcde$var$experimentalFragmentVariables = true;
}
function $3c8ea2810a9abcde$export$5290df9bbbd3cfa() {
    $3c8ea2810a9abcde$var$experimentalFragmentVariables = false;
}
var $3c8ea2810a9abcde$var$extras = {
    gql: $3c8ea2810a9abcde$export$72e4926bf8358653,
    resetCaches: $3c8ea2810a9abcde$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $3c8ea2810a9abcde$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $3c8ea2810a9abcde$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $3c8ea2810a9abcde$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $3c8ea2810a9abcde$var$extras.gql, gql_1.resetCaches = $3c8ea2810a9abcde$var$extras.resetCaches, gql_1.disableFragmentWarnings = $3c8ea2810a9abcde$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $3c8ea2810a9abcde$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $3c8ea2810a9abcde$var$extras.disableExperimentalFragmentVariables;
})($3c8ea2810a9abcde$export$72e4926bf8358653 || ($3c8ea2810a9abcde$export$72e4926bf8358653 = {}));
$3c8ea2810a9abcde$export$72e4926bf8358653["default"] = $3c8ea2810a9abcde$export$72e4926bf8358653;
var $3c8ea2810a9abcde$export$2e2bcd8739ae039 = $3c8ea2810a9abcde$export$72e4926bf8358653;

});
parcelRegister("8uUC9", function(module, exports) {

$parcel$export(module.exports, "parse", () => $62fd0a8327627af8$export$98e6a39c04603d36);

var $7ZXKi = parcelRequire("7ZXKi");

var $bzIlO = parcelRequire("bzIlO");

var $98oUl = parcelRequire("98oUl");

var $2z7TS = parcelRequire("2z7TS");

var $6vk4Q = parcelRequire("6vk4Q");

var $jADQJ = parcelRequire("jADQJ");

var $jkcJk = parcelRequire("jkcJk");
function $62fd0a8327627af8$export$98e6a39c04603d36(source, options) {
    var parser = new $62fd0a8327627af8$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $62fd0a8327627af8$export$5303528d1070ff6f(source, options) {
    var parser = new $62fd0a8327627af8$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $2z7TS.TokenKind).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, $2z7TS.TokenKind).EOF);
    return value;
}
function $62fd0a8327627af8$export$28b8f402ccc88182(source, options) {
    var parser = new $62fd0a8327627af8$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $2z7TS.TokenKind).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, $2z7TS.TokenKind).EOF);
    return type;
}
var $62fd0a8327627af8$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = (0, $6vk4Q.isSource)(source) ? source : new (0, $6vk4Q.Source)(source);
        this._lexer = new (0, $jkcJk.Lexer)(sourceObj);
        this._options = options;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken((0, $2z7TS.TokenKind).NAME);
        return {
            kind: (0, $bzIlO.Kind).NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
     /**
   * Document : Definition+
   */ ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: (0, $bzIlO.Kind).DOCUMENT,
            definitions: this.many((0, $2z7TS.TokenKind).SOF, this.parseDefinition, (0, $2z7TS.TokenKind).EOF),
            loc: this.loc(start)
        };
    } /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */ ;
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek((0, $2z7TS.TokenKind).NAME)) switch(this._lexer.token.value){
            case 'query':
            case 'mutation':
            case 'subscription':
                return this.parseOperationDefinition();
            case 'fragment':
                return this.parseFragmentDefinition();
            case 'schema':
            case 'scalar':
            case 'type':
            case 'interface':
            case 'union':
            case 'enum':
            case 'input':
            case 'directive':
                return this.parseTypeSystemDefinition();
            case 'extend':
                return this.parseTypeSystemExtension();
        }
        else if (this.peek((0, $2z7TS.TokenKind).BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
     /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek((0, $2z7TS.TokenKind).BRACE_L)) return {
            kind: (0, $bzIlO.Kind).OPERATION_DEFINITION,
            operation: 'query',
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek((0, $2z7TS.TokenKind).NAME)) name = this.parseName();
        return {
            kind: (0, $bzIlO.Kind).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * OperationType : one of query mutation subscription
   */ ;
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken((0, $2z7TS.TokenKind).NAME);
        switch(operationToken.value){
            case 'query':
                return 'query';
            case 'mutation':
                return 'mutation';
            case 'subscription':
                return 'subscription';
        }
        throw this.unexpected(operationToken);
    } /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ ;
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany((0, $2z7TS.TokenKind).PAREN_L, this.parseVariableDefinition, (0, $2z7TS.TokenKind).PAREN_R);
    } /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: (0, $bzIlO.Kind).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $2z7TS.TokenKind).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $2z7TS.TokenKind).EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    } /**
   * Variable : $ Name
   */ ;
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken((0, $2z7TS.TokenKind).DOLLAR);
        return {
            kind: (0, $bzIlO.Kind).VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } /**
   * SelectionSet : { Selection+ }
   */ ;
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: (0, $bzIlO.Kind).SELECTION_SET,
            selections: this.many((0, $2z7TS.TokenKind).BRACE_L, this.parseSelection, (0, $2z7TS.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ ;
    _proto.parseSelection = function parseSelection() {
        return this.peek((0, $2z7TS.TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
    } /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ ;
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken((0, $2z7TS.TokenKind).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: (0, $bzIlO.Kind).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $2z7TS.TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    } /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ ;
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $2z7TS.TokenKind).PAREN_L, item, (0, $2z7TS.TokenKind).PAREN_R);
    } /**
   * Argument[Const] : Name : Value[?Const]
   */ ;
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $2z7TS.TokenKind).COLON);
        return {
            kind: (0, $bzIlO.Kind).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: (0, $bzIlO.Kind).ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken((0, $2z7TS.TokenKind).COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
     /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken((0, $2z7TS.TokenKind).SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $2z7TS.TokenKind).NAME)) return {
            kind: (0, $bzIlO.Kind).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: (0, $bzIlO.Kind).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ ;
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var _this$_options;
        var start = this._lexer.token;
        this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) return {
            kind: (0, $bzIlO.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: (0, $bzIlO.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentName : Name but not `on`
   */ ;
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
     /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case (0, $2z7TS.TokenKind).BRACKET_L:
                return this.parseList(isConst);
            case (0, $2z7TS.TokenKind).BRACE_L:
                return this.parseObject(isConst);
            case (0, $2z7TS.TokenKind).INT:
                this._lexer.advance();
                return {
                    kind: (0, $bzIlO.Kind).INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $2z7TS.TokenKind).FLOAT:
                this._lexer.advance();
                return {
                    kind: (0, $bzIlO.Kind).FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $2z7TS.TokenKind).STRING:
            case (0, $2z7TS.TokenKind).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $2z7TS.TokenKind).NAME:
                this._lexer.advance();
                switch(token.value){
                    case 'true':
                        return {
                            kind: (0, $bzIlO.Kind).BOOLEAN,
                            value: true,
                            loc: this.loc(token)
                        };
                    case 'false':
                        return {
                            kind: (0, $bzIlO.Kind).BOOLEAN,
                            value: false,
                            loc: this.loc(token)
                        };
                    case 'null':
                        return {
                            kind: (0, $bzIlO.Kind).NULL,
                            loc: this.loc(token)
                        };
                    default:
                        return {
                            kind: (0, $bzIlO.Kind).ENUM,
                            value: token.value,
                            loc: this.loc(token)
                        };
                }
            case (0, $2z7TS.TokenKind).DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: (0, $bzIlO.Kind).STRING,
            value: token.value,
            block: token.kind === (0, $2z7TS.TokenKind).BLOCK_STRING,
            loc: this.loc(token)
        };
    } /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ ;
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: (0, $bzIlO.Kind).LIST,
            values: this.any((0, $2z7TS.TokenKind).BRACKET_L, item, (0, $2z7TS.TokenKind).BRACKET_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */ ;
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: (0, $bzIlO.Kind).OBJECT,
            fields: this.any((0, $2z7TS.TokenKind).BRACE_L, item, (0, $2z7TS.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectField[Const] : Name : Value[?Const]
   */ ;
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $2z7TS.TokenKind).COLON);
        return {
            kind: (0, $bzIlO.Kind).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
     /**
   * Directives[Const] : Directive[?Const]+
   */ ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek((0, $2z7TS.TokenKind).AT))directives.push(this.parseDirective(isConst));
        return directives;
    } /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */ ;
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken((0, $2z7TS.TokenKind).AT);
        return {
            kind: (0, $bzIlO.Kind).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
     /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken((0, $2z7TS.TokenKind).BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken((0, $2z7TS.TokenKind).BRACKET_R);
            type = {
                kind: (0, $bzIlO.Kind).LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $2z7TS.TokenKind).BANG)) return {
            kind: (0, $bzIlO.Kind).NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    } /**
   * NamedType : Name
   */ ;
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: (0, $bzIlO.Kind).NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
     /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $2z7TS.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaDefinition();
            case 'scalar':
                return this.parseScalarTypeDefinition();
            case 'type':
                return this.parseObjectTypeDefinition();
            case 'interface':
                return this.parseInterfaceTypeDefinition();
            case 'union':
                return this.parseUnionTypeDefinition();
            case 'enum':
                return this.parseEnumTypeDefinition();
            case 'input':
                return this.parseInputObjectTypeDefinition();
            case 'directive':
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek((0, $2z7TS.TokenKind).STRING) || this.peek((0, $2z7TS.TokenKind).BLOCK_STRING);
    } /**
   * Description : StringValue
   */ ;
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    } /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */ ;
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.many((0, $2z7TS.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $2z7TS.TokenKind).BRACE_R);
        return {
            kind: (0, $bzIlO.Kind).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * OperationTypeDefinition : OperationType : NamedType
   */ ;
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken((0, $2z7TS.TokenKind).COLON);
        var type = this.parseNamedType();
        return {
            kind: (0, $bzIlO.Kind).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ ;
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $bzIlO.Kind).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $bzIlO.Kind).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ ;
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var _this$_options2;
        if (!this.expectOptionalKeyword('implements')) return [];
        if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
            var types = []; // Optional leading ampersand
            this.expectOptionalToken((0, $2z7TS.TokenKind).AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, $2z7TS.TokenKind).AMP) || this.peek((0, $2z7TS.TokenKind).NAME));
            return types;
        }
        return this.delimitedMany((0, $2z7TS.TokenKind).AMP, this.parseNamedType);
    } /**
   * FieldsDefinition : { FieldDefinition+ }
   */ ;
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        var _this$_options3;
        // Legacy support for the SDL?
        if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek((0, $2z7TS.TokenKind).BRACE_L) && this._lexer.lookahead().kind === (0, $2z7TS.TokenKind).BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany((0, $2z7TS.TokenKind).BRACE_L, this.parseFieldDefinition, (0, $2z7TS.TokenKind).BRACE_R);
    } /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ ;
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken((0, $2z7TS.TokenKind).COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $bzIlO.Kind).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ ;
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany((0, $2z7TS.TokenKind).PAREN_L, this.parseInputValueDef, (0, $2z7TS.TokenKind).PAREN_R);
    } /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken((0, $2z7TS.TokenKind).COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken((0, $2z7TS.TokenKind).EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $bzIlO.Kind).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $bzIlO.Kind).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ ;
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: (0, $bzIlO.Kind).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ ;
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $2z7TS.TokenKind).EQUALS) ? this.delimitedMany((0, $2z7TS.TokenKind).PIPE, this.parseNamedType) : [];
    } /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ ;
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: (0, $bzIlO.Kind).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */ ;
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany((0, $2z7TS.TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, $2z7TS.TokenKind).BRACE_R);
    } /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */ ;
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $bzIlO.Kind).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ ;
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: (0, $bzIlO.Kind).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */ ;
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany((0, $2z7TS.TokenKind).BRACE_L, this.parseInputValueDef, (0, $2z7TS.TokenKind).BRACE_R);
    } /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $2z7TS.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    } /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */ ;
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany((0, $2z7TS.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $2z7TS.TokenKind).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: (0, $bzIlO.Kind).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ ;
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: (0, $bzIlO.Kind).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ ;
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $bzIlO.Kind).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ ;
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $bzIlO.Kind).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ ;
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: (0, $bzIlO.Kind).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ ;
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: (0, $bzIlO.Kind).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ ;
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $bzIlO.Kind).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */ ;
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $2z7TS.TokenKind).AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        var locations = this.parseDirectiveLocations();
        return {
            kind: (0, $bzIlO.Kind).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    } /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ ;
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        return this.delimitedMany((0, $2z7TS.TokenKind).PIPE, this.parseDirectiveLocation);
    } /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ ;
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ((0, $jADQJ.DirectiveLocation)[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
     /**
   * Returns a location object, used to identify the place in the source that created a given parsed object.
   */ ;
    _proto.loc = function loc(startToken) {
        var _this$_options4;
        if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) return new (0, $98oUl.Location)(startToken, this._lexer.lastToken, this._lexer.source);
    } /**
   * Determines if the next token is of a given kind
   */ ;
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, $7ZXKi.syntaxError)(this._lexer.source, token.start, "Expected ".concat($62fd0a8327627af8$var$getTokenKindDesc(kind), ", found ").concat($62fd0a8327627af8$var$getTokenDesc(token), "."));
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and return undefined.
   */ ;
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    } /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $2z7TS.TokenKind).NAME && token.value === value) this._lexer.advance();
        else throw (0, $7ZXKi.syntaxError)(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat($62fd0a8327627af8$var$getTokenDesc(token), "."));
    } /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ ;
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $2z7TS.TokenKind).NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    } /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ ;
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $7ZXKi.syntaxError)(this._lexer.source, token.start, "Unexpected ".concat($62fd0a8327627af8$var$getTokenDesc(token), "."));
    } /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    } /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ ;
    _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    };
    return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */ function $62fd0a8327627af8$var$getTokenDesc(token) {
    var value = token.value;
    return $62fd0a8327627af8$var$getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $62fd0a8327627af8$var$getTokenKindDesc(kind) {
    return (0, $jkcJk.isPunctuatorTokenKind)(kind) ? "\"".concat(kind, "\"") : kind;
}

});
parcelRegister("7ZXKi", function(module, exports) {

$parcel$export(module.exports, "syntaxError", () => $5d2c9324f08528ec$export$bbee0c6176c019d4);

var $g5yZB = parcelRequire("g5yZB");
function $5d2c9324f08528ec$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $g5yZB.GraphQLError)("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}

});
parcelRegister("g5yZB", function(module, exports) {

$parcel$export(module.exports, "GraphQLError", () => $bb6841c873fb42f5$export$92d6ed0888e7cb7f);

var $a1qmV = parcelRequire("a1qmV");

var $cJPdE = parcelRequire("cJPdE");

var $6DBwa = parcelRequire("6DBwa");

var $3DTMg = parcelRequire("3DTMg");

var $4Zjco = parcelRequire("4Zjco");
function $bb6841c873fb42f5$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $bb6841c873fb42f5$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $bb6841c873fb42f5$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $bb6841c873fb42f5$var$_typeof(obj);
}
function $bb6841c873fb42f5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bb6841c873fb42f5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $bb6841c873fb42f5$var$ownKeys(Object(source), true).forEach(function(key) {
            $bb6841c873fb42f5$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $bb6841c873fb42f5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $bb6841c873fb42f5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bb6841c873fb42f5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bb6841c873fb42f5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $bb6841c873fb42f5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $bb6841c873fb42f5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $bb6841c873fb42f5$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $bb6841c873fb42f5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $bb6841c873fb42f5$var$_setPrototypeOf(subClass, superClass);
}
function $bb6841c873fb42f5$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $bb6841c873fb42f5$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $bb6841c873fb42f5$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bb6841c873fb42f5$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bb6841c873fb42f5$var$_possibleConstructorReturn(this, result);
    };
}
function $bb6841c873fb42f5$var$_possibleConstructorReturn(self, call) {
    if (call && ($bb6841c873fb42f5$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $bb6841c873fb42f5$var$_assertThisInitialized(self);
}
function $bb6841c873fb42f5$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $bb6841c873fb42f5$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $bb6841c873fb42f5$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$bb6841c873fb42f5$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $bb6841c873fb42f5$var$_construct(Class, arguments, $bb6841c873fb42f5$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $bb6841c873fb42f5$var$_setPrototypeOf(Wrapper, Class);
    };
    return $bb6841c873fb42f5$var$_wrapNativeSuper(Class);
}
function $bb6841c873fb42f5$var$_construct(Parent, args, Class) {
    if ($bb6841c873fb42f5$var$_isNativeReflectConstruct()) $bb6841c873fb42f5$var$_construct = Reflect.construct;
    else $bb6841c873fb42f5$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $bb6841c873fb42f5$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $bb6841c873fb42f5$var$_construct.apply(null, arguments);
}
function $bb6841c873fb42f5$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $bb6841c873fb42f5$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $bb6841c873fb42f5$var$_setPrototypeOf(o, p) {
    $bb6841c873fb42f5$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $bb6841c873fb42f5$var$_setPrototypeOf(o, p);
}
function $bb6841c873fb42f5$var$_getPrototypeOf(o) {
    $bb6841c873fb42f5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $bb6841c873fb42f5$var$_getPrototypeOf(o);
}
var $bb6841c873fb42f5$export$92d6ed0888e7cb7f = /*#__PURE__*/ function(_Error) {
    $bb6841c873fb42f5$var$_inherits(GraphQLError, _Error);
    var _super = $bb6841c873fb42f5$var$_createSuper(GraphQLError);
    /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _nodeLocations, _nodeLocations2, _nodeLocations3;
        var _this;
        $bb6841c873fb42f5$var$_classCallCheck(this, GraphQLError);
        _this = _super.call(this, message);
        _this.name = 'GraphQLError';
        _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        _this.nodes = $bb6841c873fb42f5$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        var nodeLocations = [];
        for(var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++){
            var _this$nodes;
            var _ref4 = _ref3[_i2];
            var loc = _ref4.loc;
            if (loc != null) nodeLocations.push(loc);
        }
        nodeLocations = $bb6841c873fb42f5$var$undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.
        _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
        _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function(loc) {
            return loc.start;
        });
        _this.locations = positions && source ? positions.map(function(pos) {
            return (0, $3DTMg.getLocation)(source, pos);
        }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function(loc) {
            return (0, $3DTMg.getLocation)(loc.source, loc.start);
        });
        _this.path = path !== null && path !== void 0 ? path : undefined;
        var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;
        if (extensions == null && (0, $cJPdE.default)(originalExtensions)) _this.extensions = $bb6841c873fb42f5$var$_objectSpread({}, originalExtensions);
        else _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
         // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
        // This ensures that the simplest possible GraphQL service adheres to the spec.
        Object.defineProperties($bb6841c873fb42f5$var$_assertThisInitialized(_this), {
            message: {
                enumerable: true
            },
            locations: {
                enumerable: _this.locations != null
            },
            path: {
                enumerable: _this.path != null
            },
            extensions: {
                enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        if (originalError !== null && originalError !== void 0 && originalError.stack) {
            Object.defineProperty($bb6841c873fb42f5$var$_assertThisInitialized(_this), 'stack', {
                value: originalError.stack,
                writable: true,
                configurable: true
            });
            return $bb6841c873fb42f5$var$_possibleConstructorReturn(_this);
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
        if (Error.captureStackTrace) Error.captureStackTrace($bb6841c873fb42f5$var$_assertThisInitialized(_this), GraphQLError);
        else Object.defineProperty($bb6841c873fb42f5$var$_assertThisInitialized(_this), 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    $bb6841c873fb42f5$var$_createClass(GraphQLError, [
        {
            key: "toString",
            value: function toString() {
                return $bb6841c873fb42f5$export$55ee1551a3f962e6(this);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return $bb6841c873fb42f5$export$7b5b869ee98c16ab(this);
            } // FIXME: workaround to not break chai comparisons, should be remove in v16
        },
        {
            key: (0, $6DBwa.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Object';
            }
        }
    ]);
    return GraphQLError;
}(/*#__PURE__*/ $bb6841c873fb42f5$var$_wrapNativeSuper(Error));
function $bb6841c873fb42f5$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $bb6841c873fb42f5$export$55ee1551a3f962e6(error) {
    var output = error.message;
    if (error.nodes) for(var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++){
        var node = _error$nodes2[_i4];
        if (node.loc) output += '\n\n' + (0, $4Zjco.printLocation)(node.loc);
    }
    else if (error.source && error.locations) for(var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++){
        var location = _error$locations2[_i6];
        output += '\n\n' + (0, $4Zjco.printSourceLocation)(error.source, location);
    }
    return output;
}
function $bb6841c873fb42f5$export$7b5b869ee98c16ab(error) {
    var _error$message;
    error || (0, $a1qmV.default)(0, 'Received null or undefined error.');
    var message = (_error$message = error.message) !== null && _error$message !== void 0 ? _error$message : 'An unknown error occurred.';
    var locations = error.locations;
    var path = error.path;
    var extensions = error.extensions;
    return extensions && Object.keys(extensions).length > 0 ? {
        message: message,
        locations: locations,
        path: path,
        extensions: extensions
    } : {
        message: message,
        locations: locations,
        path: path
    };
} /**
 * @see https://github.com/graphql/graphql-spec/blob/master/spec/Section%207%20--%20Response.md#errors
 */ 

});
parcelRegister("a1qmV", function(module, exports) {

$parcel$export(module.exports, "default", () => $74be73ae076c40a2$export$2e2bcd8739ae039);
function $74be73ae076c40a2$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("cJPdE", function(module, exports) {

$parcel$export(module.exports, "default", () => $94616b0c7295e50a$export$2e2bcd8739ae039);
function $94616b0c7295e50a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $94616b0c7295e50a$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $94616b0c7295e50a$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $94616b0c7295e50a$var$_typeof(obj);
}
function $94616b0c7295e50a$export$2e2bcd8739ae039(value) {
    return $94616b0c7295e50a$var$_typeof(value) == 'object' && value !== null;
}

});

parcelRegister("6DBwa", function(module, exports) {

$parcel$export(module.exports, "SYMBOL_TO_STRING_TAG", () => $4d537cd703fb8e64$export$5deadc579ccc7c9c);
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $4d537cd703fb8e64$export$f6cdee3c26d6da57 = typeof Symbol === 'function' && Symbol.iterator != null ? Symbol.iterator : '@@iterator'; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var $4d537cd703fb8e64$export$8d0083df0471478e = typeof Symbol === 'function' && Symbol.asyncIterator != null ? Symbol.asyncIterator : '@@asyncIterator'; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $4d537cd703fb8e64$export$5deadc579ccc7c9c = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';

});

parcelRegister("3DTMg", function(module, exports) {

$parcel$export(module.exports, "getLocation", () => $2a7047dfe88e1e3e$export$e7fd20fad3cf4b5f);
/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $2a7047dfe88e1e3e$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

});

parcelRegister("4Zjco", function(module, exports) {

$parcel$export(module.exports, "printLocation", () => $3a1bc06740b7fb42$export$96a9681e539deed);
$parcel$export(module.exports, "printSourceLocation", () => $3a1bc06740b7fb42$export$867940333fd9f869);

var $3DTMg = parcelRequire("3DTMg");
function $3a1bc06740b7fb42$export$96a9681e539deed(location) {
    return $3a1bc06740b7fb42$export$867940333fd9f869(location.source, (0, $3DTMg.getLocation)(location.source, location.start));
}
function $3a1bc06740b7fb42$export$867940333fd9f869(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $3a1bc06740b7fb42$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $3a1bc06740b7fb42$var$printPrefixedLines([
            [
                "".concat(lineNum),
                subLines[0]
            ]
        ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                '',
                subLine
            ];
        }), [
            [
                ' ',
                $3a1bc06740b7fb42$var$whitespace(subLineColumnNum - 1) + '^'
            ],
            [
                '',
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + $3a1bc06740b7fb42$var$printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            '',
            $3a1bc06740b7fb42$var$whitespace(columnNum - 1) + '^'
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function $3a1bc06740b7fb42$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $3a1bc06740b7fb42$var$leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
    }).join('\n');
}
function $3a1bc06740b7fb42$var$whitespace(len) {
    return Array(len + 1).join(' ');
}
function $3a1bc06740b7fb42$var$leftPad(len, str) {
    return $3a1bc06740b7fb42$var$whitespace(len - str.length) + str;
}

});



parcelRegister("bzIlO", function(module, exports) {

$parcel$export(module.exports, "Kind", () => $86d55dbd37d1d598$export$a84bdc57c5122798);
/**
 * The set of allowed kind values for AST nodes.
 */ var $86d55dbd37d1d598$export$a84bdc57c5122798 = Object.freeze({
    // Name
    NAME: 'Name',
    // Document
    DOCUMENT: 'Document',
    OPERATION_DEFINITION: 'OperationDefinition',
    VARIABLE_DEFINITION: 'VariableDefinition',
    SELECTION_SET: 'SelectionSet',
    FIELD: 'Field',
    ARGUMENT: 'Argument',
    // Fragments
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_FRAGMENT: 'InlineFragment',
    FRAGMENT_DEFINITION: 'FragmentDefinition',
    // Values
    VARIABLE: 'Variable',
    INT: 'IntValue',
    FLOAT: 'FloatValue',
    STRING: 'StringValue',
    BOOLEAN: 'BooleanValue',
    NULL: 'NullValue',
    ENUM: 'EnumValue',
    LIST: 'ListValue',
    OBJECT: 'ObjectValue',
    OBJECT_FIELD: 'ObjectField',
    // Directives
    DIRECTIVE: 'Directive',
    // Types
    NAMED_TYPE: 'NamedType',
    LIST_TYPE: 'ListType',
    NON_NULL_TYPE: 'NonNullType',
    // Type System Definitions
    SCHEMA_DEFINITION: 'SchemaDefinition',
    OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
    // Type Definitions
    SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
    OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
    FIELD_DEFINITION: 'FieldDefinition',
    INPUT_VALUE_DEFINITION: 'InputValueDefinition',
    INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
    UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
    ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
    ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
    INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
    // Directive Definitions
    DIRECTIVE_DEFINITION: 'DirectiveDefinition',
    // Type System Extensions
    SCHEMA_EXTENSION: 'SchemaExtension',
    // Type Extensions
    SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
    OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
    INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
    UNION_TYPE_EXTENSION: 'UnionTypeExtension',
    ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
    INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
}); /**
 * The enum type representing the possible kind values of AST nodes.
 */ 

});

parcelRegister("2z7TS", function(module, exports) {

$parcel$export(module.exports, "TokenKind", () => $1de4fa7b8080613f$export$8b9d26ab11394711);
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $1de4fa7b8080613f$export$8b9d26ab11394711 = Object.freeze({
    SOF: '<SOF>',
    EOF: '<EOF>',
    BANG: '!',
    DOLLAR: '$',
    AMP: '&',
    PAREN_L: '(',
    PAREN_R: ')',
    SPREAD: '...',
    COLON: ':',
    EQUALS: '=',
    AT: '@',
    BRACKET_L: '[',
    BRACKET_R: ']',
    BRACE_L: '{',
    PIPE: '|',
    BRACE_R: '}',
    NAME: 'Name',
    INT: 'Int',
    FLOAT: 'Float',
    STRING: 'String',
    BLOCK_STRING: 'BlockString',
    COMMENT: 'Comment'
}); /**
 * The enum type representing the token kinds values.
 */ 

});

parcelRegister("6vk4Q", function(module, exports) {

$parcel$export(module.exports, "Source", () => $4bc536350d5671b9$export$1d2df86270c81ecb);
$parcel$export(module.exports, "isSource", () => $4bc536350d5671b9$export$75135ee9ed6e435b);

var $6DBwa = parcelRequire("6DBwa");

var $yEDl8 = parcelRequire("yEDl8");

var $a1qmV = parcelRequire("a1qmV");

var $6B4dU = parcelRequire("6B4dU");
function $4bc536350d5671b9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4bc536350d5671b9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4bc536350d5671b9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4bc536350d5671b9$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $4bc536350d5671b9$export$1d2df86270c81ecb = /*#__PURE__*/ function() {
    function Source(body) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
        var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            line: 1,
            column: 1
        };
        typeof body === 'string' || (0, $a1qmV.default)(0, "Body must be a string. Received: ".concat((0, $yEDl8.default)(body), "."));
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $a1qmV.default)(0, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $a1qmV.default)(0, 'column in locationOffset is 1-indexed and must be positive.');
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    $4bc536350d5671b9$var$_createClass(Source, [
        {
            key: (0, $6DBwa.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Source';
            }
        }
    ]);
    return Source;
}();
function $4bc536350d5671b9$export$75135ee9ed6e435b(source) {
    return (0, $6B4dU.default)(source, $4bc536350d5671b9$export$1d2df86270c81ecb);
}

});
parcelRegister("6B4dU", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cd9796d6ab57d14$export$2e2bcd8739ae039);

function $4cd9796d6ab57d14$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $4cd9796d6ab57d14$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $4cd9796d6ab57d14$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $4cd9796d6ab57d14$var$_typeof(obj);
}
var /**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */ // See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
$4cd9796d6ab57d14$export$2e2bcd8739ae039 = // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
    return value instanceof constructor;
};

});


parcelRegister("jADQJ", function(module, exports) {

$parcel$export(module.exports, "DirectiveLocation", () => $e4304a67ae3cac6f$export$b45ffd2948484c41);
/**
 * The set of allowed directive location values.
 */ var $e4304a67ae3cac6f$export$b45ffd2948484c41 = Object.freeze({
    // Request Definitions
    QUERY: 'QUERY',
    MUTATION: 'MUTATION',
    SUBSCRIPTION: 'SUBSCRIPTION',
    FIELD: 'FIELD',
    FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
    FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
    INLINE_FRAGMENT: 'INLINE_FRAGMENT',
    VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
    // Type System Definitions
    SCHEMA: 'SCHEMA',
    SCALAR: 'SCALAR',
    OBJECT: 'OBJECT',
    FIELD_DEFINITION: 'FIELD_DEFINITION',
    ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
    INTERFACE: 'INTERFACE',
    UNION: 'UNION',
    ENUM: 'ENUM',
    ENUM_VALUE: 'ENUM_VALUE',
    INPUT_OBJECT: 'INPUT_OBJECT',
    INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
}); /**
 * The enum type representing the directive location values.
 */ 

});

parcelRegister("jkcJk", function(module, exports) {

$parcel$export(module.exports, "Lexer", () => $e119c27db9a87f5b$export$6168dc8908a6c652);
$parcel$export(module.exports, "isPunctuatorTokenKind", () => $e119c27db9a87f5b$export$59ac0f4da287406a);

var $7ZXKi = parcelRequire("7ZXKi");

var $98oUl = parcelRequire("98oUl");

var $2z7TS = parcelRequire("2z7TS");

var $541Mz = parcelRequire("541Mz");
var $e119c27db9a87f5b$export$6168dc8908a6c652 = /*#__PURE__*/ function() {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ function Lexer(source) {
        var startOfFileToken = new (0, $98oUl.Token)((0, $2z7TS.TokenKind).SOF, 0, 0, 0, 0, null);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ var _proto = Lexer.prototype;
    _proto.advance = function advance() {
        this.lastToken = this.token;
        var token = this.token = this.lookahead();
        return token;
    } /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ ;
    _proto.lookahead = function lookahead() {
        var token = this.token;
        if (token.kind !== (0, $2z7TS.TokenKind).EOF) do {
            var _token$next;
            // Note: next is only mutable during parsing, so we cast to allow this.
            token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = $e119c27db9a87f5b$var$readToken(this, token);
        }while (token.kind === (0, $2z7TS.TokenKind).COMMENT);
        return token;
    };
    return Lexer;
}();
function $e119c27db9a87f5b$export$59ac0f4da287406a(kind) {
    return kind === (0, $2z7TS.TokenKind).BANG || kind === (0, $2z7TS.TokenKind).DOLLAR || kind === (0, $2z7TS.TokenKind).AMP || kind === (0, $2z7TS.TokenKind).PAREN_L || kind === (0, $2z7TS.TokenKind).PAREN_R || kind === (0, $2z7TS.TokenKind).SPREAD || kind === (0, $2z7TS.TokenKind).COLON || kind === (0, $2z7TS.TokenKind).EQUALS || kind === (0, $2z7TS.TokenKind).AT || kind === (0, $2z7TS.TokenKind).BRACKET_L || kind === (0, $2z7TS.TokenKind).BRACKET_R || kind === (0, $2z7TS.TokenKind).BRACE_L || kind === (0, $2z7TS.TokenKind).PIPE || kind === (0, $2z7TS.TokenKind).BRACE_R;
}
function $e119c27db9a87f5b$var$printCharCode(code) {
    return isNaN(code) ? (0, $2z7TS.TokenKind).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"");
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $e119c27db9a87f5b$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = prev.end;
    while(pos < bodyLength){
        var code = body.charCodeAt(pos);
        var _line = lexer.line;
        var _col = 1 + pos - lexer.lineStart; // SourceCharacter
        switch(code){
            case 0xfeff:
            case 9:
            case 32:
            case 44:
                //  ,
                ++pos;
                continue;
            case 10:
                //  \n
                ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 13:
                //  \r
                if (body.charCodeAt(pos + 1) === 10) pos += 2;
                else ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 33:
                //  !
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).BANG, pos, pos + 1, _line, _col, prev);
            case 35:
                //  #
                return $e119c27db9a87f5b$var$readComment(source, pos, _line, _col, prev);
            case 36:
                //  $
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).DOLLAR, pos, pos + 1, _line, _col, prev);
            case 38:
                //  &
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).AMP, pos, pos + 1, _line, _col, prev);
            case 40:
                //  (
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).PAREN_L, pos, pos + 1, _line, _col, prev);
            case 41:
                //  )
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).PAREN_R, pos, pos + 1, _line, _col, prev);
            case 46:
                //  .
                if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).SPREAD, pos, pos + 3, _line, _col, prev);
                break;
            case 58:
                //  :
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).COLON, pos, pos + 1, _line, _col, prev);
            case 61:
                //  =
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).EQUALS, pos, pos + 1, _line, _col, prev);
            case 64:
                //  @
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).AT, pos, pos + 1, _line, _col, prev);
            case 91:
                //  [
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).BRACKET_L, pos, pos + 1, _line, _col, prev);
            case 93:
                //  ]
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).BRACKET_R, pos, pos + 1, _line, _col, prev);
            case 123:
                // {
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).BRACE_L, pos, pos + 1, _line, _col, prev);
            case 124:
                // |
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).PIPE, pos, pos + 1, _line, _col, prev);
            case 125:
                // }
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).BRACE_R, pos, pos + 1, _line, _col, prev);
            case 34:
                //  "
                if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return $e119c27db9a87f5b$var$readBlockString(source, pos, _line, _col, prev, lexer);
                return $e119c27db9a87f5b$var$readString(source, pos, _line, _col, prev);
            case 45:
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                //  9
                return $e119c27db9a87f5b$var$readNumber(source, pos, code, _line, _col, prev);
            case 65:
            case 66:
            case 67:
            case 68:
            case 69:
            case 70:
            case 71:
            case 72:
            case 73:
            case 74:
            case 75:
            case 76:
            case 77:
            case 78:
            case 79:
            case 80:
            case 81:
            case 82:
            case 83:
            case 84:
            case 85:
            case 86:
            case 87:
            case 88:
            case 89:
            case 90:
            case 95:
            case 97:
            case 98:
            case 99:
            case 100:
            case 101:
            case 102:
            case 103:
            case 104:
            case 105:
            case 106:
            case 107:
            case 108:
            case 109:
            case 110:
            case 111:
            case 112:
            case 113:
            case 114:
            case 115:
            case 116:
            case 117:
            case 118:
            case 119:
            case 120:
            case 121:
            case 122:
                // z
                return $e119c27db9a87f5b$var$readName(source, pos, _line, _col, prev);
        }
        throw (0, $7ZXKi.syntaxError)(source, pos, $e119c27db9a87f5b$var$unexpectedCharacterMessage(code));
    }
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $e119c27db9a87f5b$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($e119c27db9a87f5b$var$printCharCode(code), ".");
    if (code === 39) // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
    return "Cannot parse the unexpected character ".concat($e119c27db9a87f5b$var$printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $e119c27db9a87f5b$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $e119c27db9a87f5b$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, $7ZXKi.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat($e119c27db9a87f5b$var$printCharCode(code), "."));
    } else {
        position = $e119c27db9a87f5b$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $e119c27db9a87f5b$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = $e119c27db9a87f5b$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 46 || $e119c27db9a87f5b$var$isNameStart(code)) throw (0, $7ZXKi.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($e119c27db9a87f5b$var$printCharCode(code), "."));
    return new (0, $98oUl.Token)(isFloat ? (0, $2z7TS.TokenKind).FLOAT : (0, $2z7TS.TokenKind).INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $e119c27db9a87f5b$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $7ZXKi.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($e119c27db9a87f5b$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $e119c27db9a87f5b$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $7ZXKi.syntaxError)(source, position, "Invalid character within String: ".concat($e119c27db9a87f5b$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += '/';
                    break;
                case 92:
                    value += '\\';
                    break;
                case 98:
                    value += '\b';
                    break;
                case 102:
                    value += '\f';
                    break;
                case 110:
                    value += '\n';
                    break;
                case 114:
                    value += '\r';
                    break;
                case 116:
                    value += '\t';
                    break;
                case 117:
                    // uXXXX
                    var charCode = $e119c27db9a87f5b$var$uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, $7ZXKi.syntaxError)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $7ZXKi.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $7ZXKi.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $e119c27db9a87f5b$var$readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).BLOCK_STRING, start, position + 3, line, col, prev, (0, $541Mz.dedentBlockStringValue)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $7ZXKi.syntaxError)(source, position, "Invalid character within String: ".concat($e119c27db9a87f5b$var$printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $7ZXKi.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $e119c27db9a87f5b$var$uniCharCode(a, b, c, d) {
    return $e119c27db9a87f5b$var$char2hex(a) << 12 | $e119c27db9a87f5b$var$char2hex(b) << 8 | $e119c27db9a87f5b$var$char2hex(c) << 4 | $e119c27db9a87f5b$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $e119c27db9a87f5b$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $e119c27db9a87f5b$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z
function $e119c27db9a87f5b$var$isNameStart(code) {
    return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}

});




parcelRegister("dEcp8", function(module, exports) {

$parcel$export(module.exports, "toUserType", () => $ed1cf12a11d1cbd9$export$6b53fef091c7e27d);
function $ed1cf12a11d1cbd9$export$6b53fef091c7e27d({ isBot: isBot, appType: appType }) {
    // Note, the order of these checks is important
    if (appType?.toLocaleLowerCase() === 'agent') return 'agent';
    if (isBot) return 'bot';
    return 'user';
}

});


parcelRegister("cHmJ2", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a1db79055c7f98d$export$2e2bcd8739ae039);

var $aOgFy = parcelRequire("aOgFy");

var $hrPaF = parcelRequire("hrPaF");
var $6a1db79055c7f98d$var$CONTAINER_TYPE = /*#__PURE__*/ function(CONTAINER_TYPE) {
    CONTAINER_TYPE["JIRA_PROJECT"] = "jiraProject";
    CONTAINER_TYPE["CONFLUENCE_SPACE"] = "confluenceSpace";
    return CONTAINER_TYPE;
}($6a1db79055c7f98d$var$CONTAINER_TYPE || {});
var $6a1db79055c7f98d$var$ENTITY_TYPE = /*#__PURE__*/ function(ENTITY_TYPE) {
    ENTITY_TYPE["CONTAINER"] = "CONTAINER";
    ENTITY_TYPE["USER"] = "USER";
    return ENTITY_TYPE;
}($6a1db79055c7f98d$var$ENTITY_TYPE || {});
class $6a1db79055c7f98d$export$cd5b4a06db0ea4e2 extends (0, $hrPaF.RestClient) {
    getUserContainers({ userId: userId, principalId: principalId, siteId: siteId, sessionId: sessionId, maxNumberOfResults: maxNumberOfResults }) {
        return this.postResource('/v1/collaborationgraph/user/container', {
            context: {
                contextType: 'atlassianDirectory',
                principalId: principalId,
                siteId: siteId,
                sessionId: sessionId
            },
            containerTypes: [
                'confluenceSpace',
                'jiraProject'
            ],
            maxNumberOfResults: maxNumberOfResults,
            userId: userId,
            expanded: true
        });
    }
}
var $6a1db79055c7f98d$export$2e2bcd8739ae039 = new $6a1db79055c7f98d$export$cd5b4a06db0ea4e2({
    serviceUrl: (0, $aOgFy.DEFAULT_CONFIG).collaborationGraphUrl
});

});
parcelRegister("hrPaF", function(module, exports) {

$parcel$export(module.exports, "RestClient", () => $0c6f97fa956e6402$export$ea8b5b3aea9558ce);

var $bxYf9 = parcelRequire("bxYf9");

var $1K4T6 = parcelRequire("1K4T6");

var $4F5SC = parcelRequire("4F5SC");

var $hdjej = parcelRequire("hdjej");

var $cIUqK = parcelRequire("cIUqK");

var $9WYOs = parcelRequire("9WYOs");

var $gnGnQ = parcelRequire("gnGnQ");

var $cKoHA = parcelRequire("cKoHA");

var $3lXoL = parcelRequire("3lXoL");
const $0c6f97fa956e6402$var$defaultFetchOptions = {
    credentials: 'include',
    headers: {
        Accept: 'application/json'
    },
    mode: 'cors'
};
let $0c6f97fa956e6402$var$incrementRedirectCount;
let $0c6f97fa956e6402$var$clearRedirectCount;
$0c6f97fa956e6402$export$7a0fc52d8c359feb();
function $0c6f97fa956e6402$export$7a0fc52d8c359feb() {
    $0c6f97fa956e6402$var$incrementRedirectCount = (0, (/*@__PURE__*/$parcel$interopDefault($bxYf9)))(()=>(0, $9WYOs.setCookie)((0, $9WYOs.REDIRECT_COUNT), (0, $9WYOs.getCookieAsInteger)((0, $9WYOs.REDIRECT_COUNT)) + 1));
    $0c6f97fa956e6402$var$clearRedirectCount = (0, (/*@__PURE__*/$parcel$interopDefault($bxYf9)))(()=>(0, $9WYOs.clearCookie)((0, $9WYOs.REDIRECT_COUNT)));
}
class $0c6f97fa956e6402$export$ea8b5b3aea9558ce extends (0, $cIUqK.BaseClient) {
    constructor({ serviceUrl: serviceUrl = '', config: config = {
        logException: ()=>{}
    } }){
        super(config), /**
	 * This function is necessary for if `statusCodeHandler` prescribes a login
	 * redirect upon a 401 response.
	 * While the default redirect behaviour may be overriden, this function has
	 * been kept separate to ensure it cannot be overriden, lest a host
	 * application supply embeddable-directory with a custom handler that suffers
	 * the infinite redirect bug.
	 */ this.preventInfiniteRedirectLoop = (response)=>{
            if (!response.ok) {
                const responseStatusCode = response.status;
                if (responseStatusCode === 401) $0c6f97fa956e6402$var$incrementRedirectCount();
            } else $0c6f97fa956e6402$var$clearRedirectCount();
        };
        this.serviceUrl = serviceUrl;
    }
    setServiceUrl(serviceUrl) {
        this.serviceUrl = serviceUrl;
    }
    async getResource(path, fetchOptions = {}) {
        return this.makeRequest(path, fetchOptions);
    }
    async getResourceCached(path, fetchOptions = {}, cacheOptions) {
        const cacheKey = path;
        const cacheRecord = this.getCachedValue(cacheKey);
        if (cacheRecord) return cacheRecord;
        const response = await this.getResource(path, fetchOptions);
        this.cacheValue(cacheKey, response, cacheOptions?.expiration);
        return response;
    }
    async postResource(path, data, fetchOptions = {}) {
        return this.postResourceRaw(path, JSON.stringify(data), fetchOptions);
    }
    async postResourceRaw(path, data, fetchOptions = {}) {
        fetchOptions = {
            method: 'post',
            headers: {},
            ...fetchOptions
        };
        if (data) fetchOptions = {
            body: data,
            ...fetchOptions,
            headers: {
                'Content-Type': 'application/json',
                ...fetchOptions.headers
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async patchResource(path, data) {
        let fetchOptions = {
            /**
			 * PATCH must be uppercase as per fetch spec only
			 * DELETE, GET, HEAD, OPTIONS, POST, and PUT methods
			 * are normalised to uppercase.
			 *
			 * https://github.com/github/fetch/issues/37
			 * https://fetch.spec.whatwg.org/#methods
			 */ method: 'PATCH'
        };
        if (data) fetchOptions = {
            ...fetchOptions,
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async putResource(path, data, additionalFetchOptions = {}) {
        const fetchOptions = {
            method: 'put'
        };
        if (data) Object.assign(fetchOptions, {
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return this.makeRequest(path, {
            ...fetchOptions,
            ...additionalFetchOptions
        });
    }
    async deleteResource(path, options = {}) {
        const fetchOptions = {
            ...options,
            method: 'delete'
        };
        return this.makeRequest(path, fetchOptions);
    }
    async makeRequest(path, additionalFetchOptions = {
        shouldLogError: (e)=>e.status !== 429
    }) {
        const url = this.serviceUrl + path;
        const options = {
            ...$0c6f97fa956e6402$var$defaultFetchOptions,
            ...additionalFetchOptions
        };
        const response = await (0, $4F5SC.fetchWithExponentialBackoff)(url, options);
        this.preventInfiniteRedirectLoop(response);
        (0, $hdjej.handleResponse)(response);
        const responseStatusCode = response.status;
        const traceId = response.headers.get('atl-traceid');
        if (!response.ok) {
            if (responseStatusCode === 401) throw new (0, $1K4T6.SLOIgnoreError)({
                message: 'Unauthorized Request - incrementing redirect count'
            });
            else {
                const message = await (0, $gnGnQ.parseErrorMessage)(response);
                const httpError = new (0, $1K4T6.HttpError)({
                    message: message,
                    status: responseStatusCode,
                    traceId: traceId ?? undefined,
                    path: path
                });
                if (options.shouldLogError && options.shouldLogError(httpError)) this.logException(httpError, (0, $3lXoL.stripUUIDFromPath)(path), {
                    method: options.method || 'GET',
                    url: url,
                    status: responseStatusCode
                });
                throw httpError;
            }
        }
        return additionalFetchOptions.ignoreResponse ? null : (0, $cKoHA.parseResponse)(response);
    }
}

});
parcelRegister("9WYOs", function(module, exports) {

$parcel$export(module.exports, "REDIRECT_COUNT", () => $bf41c8766f9a88e5$export$f6101897f0230549);
$parcel$export(module.exports, "setCookie", () => $bf41c8766f9a88e5$export$110700823644f4a6);
$parcel$export(module.exports, "getCookieAsInteger", () => $bf41c8766f9a88e5$export$6a289e5003f59269);
$parcel$export(module.exports, "clearCookie", () => $bf41c8766f9a88e5$export$ad3506281d5a5e5d);
const $bf41c8766f9a88e5$export$f6101897f0230549 = 'redirectCount';
const $bf41c8766f9a88e5$export$5a7d8afb87170e45 = 'avatar.csrf.token';
function $bf41c8766f9a88e5$export$110700823644f4a6(key, value) {
    document.cookie = `${key}=${value};path=/;max-age=30`;
}
function $bf41c8766f9a88e5$export$6a289e5003f59269(key, defaultValue = 0) {
    const regex = new RegExp(`${key}=(\\d+)`);
    const result = document.cookie.match(regex);
    return result ? parseInt(result[1], 10) : defaultValue;
}
function $bf41c8766f9a88e5$export$ad3506281d5a5e5d(key) {
    document.cookie = `${key}=doesntmatter;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
}

});

parcelRegister("gnGnQ", function(module, exports) {

$parcel$export(module.exports, "parseErrorMessage", () => $dbd61437f2184940$export$91c32f1b22d29b2d);
async function $dbd61437f2184940$export$91c32f1b22d29b2d(response) {
    let json;
    const text = await response.text();
    try {
        json = JSON.parse(text);
    } catch (err) {
        return text;
    }
    delete json.timestamp; // to dedupe sentry, scrub non-unique 'timestamp' field from the error body
    if (json.error) return `${json.status || 'UNKNOWN_STATUS'} ${json.error || 'MISSING_ERROR_MESSAGE'}`;
    else if (json.status) return `${json.status} MISSING_ERROR_MESSAGE`;
    else if (json.errors) {
        const errs = json.errors.map((error)=>typeof error === 'string' ? error : error.code || error.message || 'MISSING_ERROR_MESSAGE');
        return errs.join('\n - ');
    }
    return JSON.stringify(json);
}

});

parcelRegister("cKoHA", function(module, exports) {

$parcel$export(module.exports, "parseResponse", () => $571f67df8e1c13fb$export$ba14d9a5a581e827);
function $571f67df8e1c13fb$export$ba14d9a5a581e827(response) {
    const responseStatusCode = response.status;
    if (responseStatusCode === 204 || responseStatusCode === 202) return null;
    const contentType = response.headers.get('content-type');
    if (!contentType || contentType.includes('text/html') || contentType.includes('text/plain')) return response.text();
    if (contentType.includes('application/json')) return response.json();
    return null;
}

});

parcelRegister("3lXoL", function(module, exports) {

$parcel$export(module.exports, "stripUUIDFromPath", () => $a95ff77b07a38502$export$6bd073e2c6dda996);
const $a95ff77b07a38502$var$UUID_REGEX = new RegExp(/((\w{4,12}-?)){5}/g);
const $a95ff77b07a38502$export$6bd073e2c6dda996 = (path)=>{
    return path.replace($a95ff77b07a38502$var$UUID_REGEX, '<UUID>');
};

});



parcelRegister("49fYn", function(module, exports) {

$parcel$export(module.exports, "directoryClient", () => $4b31d9e631f37e0f$export$ead519165de472de);

var $aOgFy = parcelRequire("aOgFy");

var $cPPyF = parcelRequire("cPPyF");

var $6laLp = parcelRequire("6laLp");
const $4b31d9e631f37e0f$export$28456d095a642fd = 'internal.browse-users-allowed';
const $4b31d9e631f37e0f$var$buildTeamMembershipQuery = (teamId, membershipState)=>({
        query: `query TeamMembership($teamId: String!, $membershipState: [TeamMembershipStatus]) {
    TeamMembership: TeamMembership(teamId: $teamId, membershipStates: $membershipState) {
      user: profile {
        id,
        fullName,
        title,
        avatarUrl,
        timezone,
        status
      },
      state:membershipStatus,
      role,
      membershipId {
        teamId, memberId
      }
    }
  }`,
        variables: {
            teamId: teamId,
            membershipState: membershipState
        }
    });
const $4b31d9e631f37e0f$var$buildUserQuery = (userId, cloudId)=>({
        query: `query CloudUser($userId: String!, $cloudId: String!) {
    CloudUser(userId: $userId, cloudId: $cloudId) {
      avatarUrl
      id
      fullName
      title
    }
  }`,
        variables: {
            userId: userId,
            cloudId: cloudId
        }
    });
const $4b31d9e631f37e0f$var$delay = (millis)=>new Promise((resolve)=>{
        setTimeout(resolve, millis);
    });
class $4b31d9e631f37e0f$export$c8a50bf6c196fc10 extends (0, $cPPyF.BaseGraphQlClient) {
    constructor(baseUrl, config){
        super(`${baseUrl}/directory/graphql`, config);
    }
    setBaseUrl(baseUrl) {
        this.setServiceUrl(`${baseUrl}/directory/graphql`);
    }
    async queryFeatureFlags(/**
   * @private
   * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
   */ cloudId, flags) {
        const queryFeatureFlags = {
            query: `query FeatureFlags($cloudId: String!, $flags: [String]!) {
        FeatureFlags(cloudId: $cloudId, flags: $flags) {
          flag
          enabled
        }
      }`,
            variables: {
                cloudId: this.getCloudId(cloudId),
                flags: flags
            }
        };
        const { FeatureFlags: FeatureFlags } = await this.makeGraphQLRequest(queryFeatureFlags, {
            operationName: 'FeatureFlags'
        });
        return FeatureFlags.map(({ flag: flag, enabled: enabled })=>[
                flag,
                enabled
            ]).reduce((acc, val)=>(acc[val[0]] = val[1], acc), {});
    }
    canRetryError(pendingRetries, error) {
        return pendingRetries > 0 && !!error && typeof error === 'object' && 'category' in error && error.category === 'NotFound';
    }
    /**
   * Get user information of all members of a team
   * @param {string} teamId
   * @returns {Promise}
   * @private
   * @deprecated use AGG instead
   */ queryTeamMemberships(teamId, membershipStatus = [
        'FULL_MEMBER'
    ]) {
        // eslint-disable-next-line no-console
        console.warn('Directory queryTeamMemberships is deprecated, use AGG instead');
        const teamMembershipsQuery = $4b31d9e631f37e0f$var$buildTeamMembershipQuery(teamId, membershipStatus);
        const performRequest = async (pendingRetries = 3, backoffMaxDelay = 2000)=>{
            try {
                return await this.makeGraphQLRequest(teamMembershipsQuery, {
                    operationName: 'TeamMembership'
                });
            } catch (error) {
                if (this.canRetryError(pendingRetries, error)) {
                    await $4b31d9e631f37e0f$var$delay(backoffMaxDelay / pendingRetries);
                    return performRequest(pendingRetries - 1);
                }
                throw error;
            }
        };
        return performRequest().then(({ TeamMembership: TeamMembership })=>TeamMembership);
    }
    /**
   * Get user information of all members of a team
   * @param {string} userId
   * @returns {Promise}
   */ queryUser(userId, /**
   * @private
   * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
   */ cloudId) {
        const userQuery = $4b31d9e631f37e0f$var$buildUserQuery(userId, this.getCloudId(cloudId));
        const performRequest = async (pendingRetries = 3, backoffMaxDelay = 2000)=>{
            try {
                return await this.makeGraphQLRequest(userQuery, {
                    operationName: 'CloudUser'
                });
            } catch (error) {
                if (this.canRetryError(pendingRetries, error)) {
                    await $4b31d9e631f37e0f$var$delay(backoffMaxDelay / pendingRetries);
                    return performRequest(pendingRetries - 1);
                }
                throw error;
            }
        };
        return performRequest();
    }
}
const $4b31d9e631f37e0f$export$ead519165de472de = new $4b31d9e631f37e0f$export$c8a50bf6c196fc10((0, $aOgFy.DEFAULT_CONFIG).stargateRoot, {
    logException: $6laLp.logException
});

});

parcelRegister("gnKBB", function(module, exports) {

$parcel$export(module.exports, "default", () => $38997081039c300e$export$2e2bcd8739ae039);

var $aOgFy = parcelRequire("aOgFy");

var $hrPaF = parcelRequire("hrPaF");

var $hcbtx = parcelRequire("hcbtx");
const $38997081039c300e$var$defaultConfig = {
    serviceUrl: `${(0, $aOgFy.DEFAULT_CONFIG).stargateRoot}/users`
};
class $38997081039c300e$export$f9c003efee04f318 extends (0, $hrPaF.RestClient) {
    constructor(config = {}){
        super({
            ...$38997081039c300e$var$defaultConfig,
            ...config
        });
    }
    async getUserManageConfig(userId) {
        return this.getResourceCached(`/${userId}/manage`).then((resp)=>{
            return (0, $hcbtx.transformUserManageConfig)(resp);
        });
    }
    /**
	 * @deprecated
	 * User fetchUserAvatarInfo instead
	 */ async getMyAvatarUploadedStatus(userId) {
        return this.fetchUserAvatarInfo(userId);
    }
    async deleteAvatar(userId) {
        return this.deleteResource(`/${userId}/manage/avatar`);
    }
    async fetchUserAvatarInfo(userId) {
        return this.getResource(`/${userId}/manage/avatar`);
    }
    async updateUser({ id: id, ...user }) {
        return this.patchResource(`/${id}/manage/profile`, (0, $hcbtx.toManageAPIInput)(user));
    }
    async updateUserAvatar({ id: id, fileURI: fileURI }) {
        const fileObject = (0, $hcbtx.dataURItoFile)(fileURI);
        const formData = new FormData();
        formData.append('file', fileObject);
        const response = await this.makeRequest(`/${id}/manage/avatar`, {
            method: 'PUT',
            body: formData
        });
        return response.url;
    }
}
var $38997081039c300e$export$2e2bcd8739ae039 = new $38997081039c300e$export$f9c003efee04f318();

});
parcelRegister("hcbtx", function(module, exports) {

$parcel$export(module.exports, "transformUserManageConfig", () => $e90b5aaa9134b760$export$d7725d3d27b80a68);
$parcel$export(module.exports, "toManageAPIInput", () => $e90b5aaa9134b760$export$7b103107c889cb67);
$parcel$export(module.exports, "dataURItoFile", () => $e90b5aaa9134b760$export$80d19edb7b1ae293);
parcelRequire("fzTVj");
var $iwMEb = parcelRequire("iwMEb");
// Key (left-side) is field name which is used in our app.
// Value (right-side) is field name which is used by data in services
const $e90b5aaa9134b760$var$PROFILE_PROPS_MAP = new Map([
    [
        'id',
        'account_id'
    ],
    [
        'fullName',
        'name'
    ],
    [
        'nickname',
        'nickname'
    ],
    [
        'timezone',
        'zoneinfo'
    ],
    [
        'locale',
        'locale'
    ],
    [
        'avatarUrl',
        'picture'
    ],
    [
        'email',
        'email'
    ]
]);
// Key (left-side) is field name which is used in our app.
// Value (right-side) is field name which is used by data in services
const $e90b5aaa9134b760$var$EXTENDED_PROFILE_PROPS_MAP = new Map([
    [
        'title',
        'job_title'
    ],
    [
        'department',
        'department'
    ],
    [
        'companyName',
        'organization'
    ],
    [
        'location',
        'location'
    ],
    [
        'phoneNumber',
        'phone_number'
    ]
]);
const $e90b5aaa9134b760$export$5299664357e4f3dd = (res)=>{
    const data = res.account;
    const extendedData = data && data.extended_profile || {};
    if (!data) return null;
    const timeZone = data.zoneinfo;
    const localTime = ({ format: format })=>{
        if (!timeZone) return null;
        try {
            return (0, $iwMEb.default)(new Date(), timeZone, format);
        } catch (error) {
            // TODO: PTC-4908 send error to sentry for reporting
            return null;
        }
    };
    const profileProps = Array.from($e90b5aaa9134b760$var$PROFILE_PROPS_MAP.keys()).reduce((acc, key)=>{
        if ($e90b5aaa9134b760$var$PROFILE_PROPS_MAP.has(key)) acc[key] = data[$e90b5aaa9134b760$var$PROFILE_PROPS_MAP.get(key)];
        return acc;
    }, {});
    const extendedProfileProps = Array.from($e90b5aaa9134b760$var$EXTENDED_PROFILE_PROPS_MAP.keys()).reduce((acc, key)=>{
        if ($e90b5aaa9134b760$var$EXTENDED_PROFILE_PROPS_MAP.has(key)) acc[key] = extendedData[$e90b5aaa9134b760$var$EXTENDED_PROFILE_PROPS_MAP.get(key)];
        return acc;
    }, {});
    return {
        ...profileProps,
        ...extendedProfileProps,
        localTime: localTime
    };
};
var $e90b5aaa9134b760$export$ed12481c953b8653 = /*#__PURE__*/ function(FieldType) {
    FieldType["FullName"] = "fullName";
    FieldType["Nickname"] = "nickname";
    FieldType["Title"] = "title";
    FieldType["Department"] = "department";
    FieldType["CompanyName"] = "companyName";
    FieldType["Location"] = "location";
    FieldType["Timezone"] = "timezone";
    FieldType["Email"] = "email";
    FieldType["PhoneNumber"] = "phoneNumber";
    FieldType["Avatar"] = "picture";
    FieldType["Language"] = "language";
    FieldType["LocalTime"] = "localTime";
    FieldType["RemoteWeekdayIndex"] = "remoteWeekdayIndex";
    FieldType["RemoteWeekdayString"] = "remoteWeekdayString";
    FieldType["RemoteTimeString"] = "remoteTimeString";
    return FieldType;
}({});
const $e90b5aaa9134b760$export$78158d2c2c6998d9 = {
    fullName: 'name',
    nickname: 'nickname',
    timezone: 'zoneinfo',
    locale: 'locale',
    email: 'email',
    // extended profile
    title: 'extended_profile.job_title',
    phoneNumber: 'extended_profile.phone_number',
    companyName: 'extended_profile.organization',
    department: 'extended_profile.department',
    location: 'extended_profile.location'
};
const $e90b5aaa9134b760$export$2ff7b92b9e1bb4d2 = {
    email: 'email.initiateChange',
    picture: 'avatar'
};
const $e90b5aaa9134b760$var$getFieldConfig = (data, field)=>{
    if ((field === 'email' || field === 'picture') && $e90b5aaa9134b760$export$2ff7b92b9e1bb4d2[field]) return data[$e90b5aaa9134b760$export$2ff7b92b9e1bb4d2[field]];
    const mappedFieldKey = field in $e90b5aaa9134b760$export$78158d2c2c6998d9 ? $e90b5aaa9134b760$export$78158d2c2c6998d9[field] : undefined;
    if (!mappedFieldKey) return undefined;
    const profileWrite = data['profile.write'];
    return profileWrite[mappedFieldKey];
};
const $e90b5aaa9134b760$var$convertFieldKeyToFieldType = (key)=>{
    // Check if the key can be mapped to a FieldType value
    if (Object.values($e90b5aaa9134b760$export$ed12481c953b8653).includes(key)) return key;
    return undefined;
};
const $e90b5aaa9134b760$var$getMutabilityConstraintFor = (data, field)=>{
    const fieldConfig = $e90b5aaa9134b760$var$getFieldConfig(data, field);
    if (!fieldConfig || fieldConfig.allowed) return undefined;
    const convertedField = $e90b5aaa9134b760$var$convertFieldKeyToFieldType(field);
    if (!convertedField) return undefined;
    const reason = fieldConfig.reason;
    return {
        field: convertedField,
        reason: reason && reason.key || null
    };
};
const $e90b5aaa9134b760$export$d7725d3d27b80a68 = (data)=>({
        mutabilityConstraints: Object.keys($e90b5aaa9134b760$export$78158d2c2c6998d9).map((field)=>$e90b5aaa9134b760$var$getMutabilityConstraintFor(data, field)).filter((constraint)=>constraint !== undefined)
    });
const $e90b5aaa9134b760$export$7b103107c889cb67 = (input)=>{
    const output = {
        extended_profile: {}
    };
    Object.keys(input).forEach((key)=>{
        if ($e90b5aaa9134b760$var$PROFILE_PROPS_MAP.has(key)) output[$e90b5aaa9134b760$var$PROFILE_PROPS_MAP.get(key)] = input[key];
        if ($e90b5aaa9134b760$var$EXTENDED_PROFILE_PROPS_MAP.has(key)) output.extended_profile[$e90b5aaa9134b760$var$EXTENDED_PROFILE_PROPS_MAP.get(key)] = input[key];
    });
    return output;
};
function $e90b5aaa9134b760$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const byteString = dataURI.split(',')[0].includes('base64') ? atob(dataURI.split(',')[1]) : decodeURIComponent(dataURI.split(',')[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        mimeString = 'unknown';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 and Safari does not support the File constructor.
        return blob;
    }
}

});
parcelRegister("fzTVj", function(module, exports) {

$parcel$export(module.exports, "formatInTimeZone", () => (parcelRequire("iwMEb")).default);
// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.


var $iwMEb = parcelRequire("iwMEb");





});
parcelRegister("iwMEb", function(module, exports) {

$parcel$export(module.exports, "default", () => $037b1cb35b9ac277$export$2e2bcd8739ae039);

var $fwbX5 = parcelRequire("fwbX5");

var $3bby5 = parcelRequire("3bby5");

var $iEBtW = parcelRequire("iEBtW");
function $037b1cb35b9ac277$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($fwbX5)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $3bby5.default)((0, $iEBtW.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("fwbX5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b4c31d9870379ac2$var$cloneObject;

var $b4c31d9870379ac2$var$_index = $b4c31d9870379ac2$var$_interopRequireDefault((parcelRequire("cpl5v")));
function $b4c31d9870379ac2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b4c31d9870379ac2$var$cloneObject(dirtyObject) {
    return (0, $b4c31d9870379ac2$var$_index.default)({}, dirtyObject);
}
module.exports = module.exports.default;

});
parcelRegister("cpl5v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $90882d6ff669df4d$var$assign;
function $90882d6ff669df4d$var$assign(target, dirtyObject) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    dirtyObject = dirtyObject || {};
    for(var property in dirtyObject)if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) target[property] = dirtyObject[property];
    return target;
}
module.exports = module.exports.default;

});


parcelRegister("3bby5", function(module, exports) {

$parcel$export(module.exports, "default", () => $250b5b880d4c3a29$export$2e2bcd8739ae039);

var $aR9Qf = parcelRequire("aR9Qf");

var $5wWnR = parcelRequire("5wWnR");

var $sNI8p = parcelRequire("sNI8p");
var $250b5b880d4c3a29$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $250b5b880d4c3a29$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($250b5b880d4c3a29$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $sNI8p.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $5wWnR.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($aR9Qf)))(dirtyDate, formatStr, options);
}

});
parcelRegister("aR9Qf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7e767cfeba790ebe$var$format;

var $7e767cfeba790ebe$var$_index = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("ck8JK")));

var $7e767cfeba790ebe$var$_index2 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("kvNR5")));

var $7e767cfeba790ebe$var$_index3 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("bQkcE")));

var $7e767cfeba790ebe$var$_index4 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $7e767cfeba790ebe$var$_index5 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("3ckvK")));

var $7e767cfeba790ebe$var$_index6 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("awKAW")));

var $7e767cfeba790ebe$var$_index7 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("jGQTC")));

var $5qguX = parcelRequire("5qguX");

var $7e767cfeba790ebe$var$_index9 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("aSksP")));

var $7e767cfeba790ebe$var$_index10 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $7e767cfeba790ebe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $7e767cfeba790ebe$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $7e767cfeba790ebe$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $7e767cfeba790ebe$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $7e767cfeba790ebe$var$doubleQuoteRegExp = /''/g;
var $7e767cfeba790ebe$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function $7e767cfeba790ebe$var$format(dirtyDate, dirtyFormatStr, dirtyOptions) {
    (0, $7e767cfeba790ebe$var$_index10.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var locale = options.locale || $7e767cfeba790ebe$var$_index2.default;
    var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $7e767cfeba790ebe$var$_index9.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $7e767cfeba790ebe$var$_index9.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $7e767cfeba790ebe$var$_index9.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $7e767cfeba790ebe$var$_index9.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $7e767cfeba790ebe$var$_index4.default)(dirtyDate);
    if (!(0, $7e767cfeba790ebe$var$_index.default)(originalDate)) throw new RangeError('Invalid time value');
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $7e767cfeba790ebe$var$_index7.default)(originalDate);
    var utcDate = (0, $7e767cfeba790ebe$var$_index3.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($7e767cfeba790ebe$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = $7e767cfeba790ebe$var$_index6.default[firstCharacter];
            return longFormatter(substring, locale.formatLong, formatterOptions);
        }
        return substring;
    }).join('').match($7e767cfeba790ebe$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $7e767cfeba790ebe$var$cleanEscapedString(substring);
        var formatter = $7e767cfeba790ebe$var$_index5.default[firstCharacter];
        if (formatter) {
            if (!options.useAdditionalWeekYearTokens && (0, $5qguX.isProtectedWeekYearToken)(substring)) (0, $5qguX.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
            if (!options.useAdditionalDayOfYearTokens && (0, $5qguX.isProtectedDayOfYearToken)(substring)) (0, $5qguX.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($7e767cfeba790ebe$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $7e767cfeba790ebe$var$cleanEscapedString(input) {
    return input.match($7e767cfeba790ebe$var$escapedStringRegExp)[1].replace($7e767cfeba790ebe$var$doubleQuoteRegExp, "'");
}
module.exports = module.exports.default;

});
parcelRegister("ck8JK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8f8e2146dfa1d727$var$isValid;

var $8f8e2146dfa1d727$var$_index = $8f8e2146dfa1d727$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $8f8e2146dfa1d727$var$_index2 = $8f8e2146dfa1d727$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $8f8e2146dfa1d727$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */ function $8f8e2146dfa1d727$var$isValid(dirtyDate) {
    (0, $8f8e2146dfa1d727$var$_index2.default)(1, arguments);
    var date = (0, $8f8e2146dfa1d727$var$_index.default)(dirtyDate);
    return !isNaN(date);
}
module.exports = module.exports.default;

});
parcelRegister("2pWQP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1c2b912e6615b0b5$var$toDate;

var $1c2b912e6615b0b5$var$_index = $1c2b912e6615b0b5$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $1c2b912e6615b0b5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $1c2b912e6615b0b5$var$toDate(argument) {
    (0, $1c2b912e6615b0b5$var$_index.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument); // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}
module.exports = module.exports.default;

});
parcelRegister("6eBfj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $48a0f126c2293ab3$var$requiredArgs;
function $48a0f126c2293ab3$var$requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}
module.exports = module.exports.default;

});



parcelRegister("kvNR5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eeed6020e120f946$var$_index = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("5u9TK")));

var $eeed6020e120f946$var$_index2 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("e7AgV")));

var $eeed6020e120f946$var$_index3 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("8U2eY")));

var $eeed6020e120f946$var$_index4 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("b9d75")));

var $eeed6020e120f946$var$_index5 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("hHwuU")));
function $eeed6020e120f946$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $eeed6020e120f946$var$locale = {
    code: 'en-US',
    formatDistance: $eeed6020e120f946$var$_index.default,
    formatLong: $eeed6020e120f946$var$_index2.default,
    formatRelative: $eeed6020e120f946$var$_index3.default,
    localize: $eeed6020e120f946$var$_index4.default,
    match: $eeed6020e120f946$var$_index5.default,
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
var $eeed6020e120f946$var$_default = $eeed6020e120f946$var$locale;
module.exports.default = $eeed6020e120f946$var$_default;
module.exports = module.exports.default;

});
parcelRegister("5u9TK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3fe76ea3cd34e32f$var$formatDistance;
var $3fe76ea3cd34e32f$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
function $3fe76ea3cd34e32f$var$formatDistance(token, count, options) {
    options = options || {};
    var result;
    if (typeof $3fe76ea3cd34e32f$var$formatDistanceLocale[token] === 'string') result = $3fe76ea3cd34e32f$var$formatDistanceLocale[token];
    else if (count === 1) result = $3fe76ea3cd34e32f$var$formatDistanceLocale[token].one;
    else result = $3fe76ea3cd34e32f$var$formatDistanceLocale[token].other.replace('{{count}}', count);
    if (options.addSuffix) {
        if (options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
}
module.exports = module.exports.default;

});

parcelRegister("e7AgV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a47ddb0366100c31$var$_index = $a47ddb0366100c31$var$_interopRequireDefault((parcelRequire("4raqC")));
function $a47ddb0366100c31$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a47ddb0366100c31$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $a47ddb0366100c31$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $a47ddb0366100c31$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $a47ddb0366100c31$var$formatLong = {
    date: (0, $a47ddb0366100c31$var$_index.default)({
        formats: $a47ddb0366100c31$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $a47ddb0366100c31$var$_index.default)({
        formats: $a47ddb0366100c31$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $a47ddb0366100c31$var$_index.default)({
        formats: $a47ddb0366100c31$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $a47ddb0366100c31$var$_default = $a47ddb0366100c31$var$formatLong;
module.exports.default = $a47ddb0366100c31$var$_default;
module.exports = module.exports.default;

});
parcelRegister("4raqC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $33b1c5e9f7814c0e$var$buildFormatLongFn;
function $33b1c5e9f7814c0e$var$buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}
module.exports = module.exports.default;

});


parcelRegister("8U2eY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $67b54aa1e07b4b42$var$formatRelative;
var $67b54aa1e07b4b42$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
function $67b54aa1e07b4b42$var$formatRelative(token, _date, _baseDate, _options) {
    return $67b54aa1e07b4b42$var$formatRelativeLocale[token];
}
module.exports = module.exports.default;

});

parcelRegister("b9d75", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $81dab50370972ecd$var$_index = $81dab50370972ecd$var$_interopRequireDefault((parcelRequire("llBmH")));
function $81dab50370972ecd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $81dab50370972ecd$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $81dab50370972ecd$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $81dab50370972ecd$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $81dab50370972ecd$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $81dab50370972ecd$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $81dab50370972ecd$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
function $81dab50370972ecd$var$ordinalNumber(dirtyNumber, _dirtyOptions) {
    var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`:
    //
    //   var options = dirtyOptions || {}
    //   var unit = String(options.unit)
    //
    // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
}
var $81dab50370972ecd$var$localize = {
    ordinalNumber: $81dab50370972ecd$var$ordinalNumber,
    era: (0, $81dab50370972ecd$var$_index.default)({
        values: $81dab50370972ecd$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $81dab50370972ecd$var$_index.default)({
        values: $81dab50370972ecd$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $81dab50370972ecd$var$_index.default)({
        values: $81dab50370972ecd$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $81dab50370972ecd$var$_index.default)({
        values: $81dab50370972ecd$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $81dab50370972ecd$var$_index.default)({
        values: $81dab50370972ecd$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $81dab50370972ecd$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $81dab50370972ecd$var$_default = $81dab50370972ecd$var$localize;
module.exports.default = $81dab50370972ecd$var$_default;
module.exports = module.exports.default;

});
parcelRegister("llBmH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f8a88b0d5d631bc1$var$buildLocalizeFn;
function $f8a88b0d5d631bc1$var$buildLocalizeFn(args) {
    return function(dirtyIndex, dirtyOptions) {
        var options = dirtyOptions || {};
        var context = options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challange you to try to remove it!
        return valuesArray[index];
    };
}
module.exports = module.exports.default;

});


parcelRegister("hHwuU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ce2fa922bf4a591b$var$_index = $ce2fa922bf4a591b$var$_interopRequireDefault((parcelRequire("1IY7t")));

var $ce2fa922bf4a591b$var$_index2 = $ce2fa922bf4a591b$var$_interopRequireDefault((parcelRequire("liduU")));
function $ce2fa922bf4a591b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $ce2fa922bf4a591b$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $ce2fa922bf4a591b$var$parseOrdinalNumberPattern = /\d+/i;
var $ce2fa922bf4a591b$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $ce2fa922bf4a591b$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $ce2fa922bf4a591b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $ce2fa922bf4a591b$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $ce2fa922bf4a591b$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $ce2fa922bf4a591b$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $ce2fa922bf4a591b$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $ce2fa922bf4a591b$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $ce2fa922bf4a591b$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $ce2fa922bf4a591b$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $ce2fa922bf4a591b$var$match = {
    ordinalNumber: (0, $ce2fa922bf4a591b$var$_index.default)({
        matchPattern: $ce2fa922bf4a591b$var$matchOrdinalNumberPattern,
        parsePattern: $ce2fa922bf4a591b$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ce2fa922bf4a591b$var$_index2.default)({
        matchPatterns: $ce2fa922bf4a591b$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ce2fa922bf4a591b$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ce2fa922bf4a591b$var$_index2.default)({
        matchPatterns: $ce2fa922bf4a591b$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ce2fa922bf4a591b$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $ce2fa922bf4a591b$var$_index2.default)({
        matchPatterns: $ce2fa922bf4a591b$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ce2fa922bf4a591b$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ce2fa922bf4a591b$var$_index2.default)({
        matchPatterns: $ce2fa922bf4a591b$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ce2fa922bf4a591b$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ce2fa922bf4a591b$var$_index2.default)({
        matchPatterns: $ce2fa922bf4a591b$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $ce2fa922bf4a591b$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $ce2fa922bf4a591b$var$_default = $ce2fa922bf4a591b$var$match;
module.exports.default = $ce2fa922bf4a591b$var$_default;
module.exports = module.exports.default;

});
parcelRegister("1IY7t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $141888fa04c95812$var$buildMatchPatternFn;
function $141888fa04c95812$var$buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
module.exports = module.exports.default;

});

parcelRegister("liduU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f805bfb7f96f3bcc$var$buildMatchFn;
function $f805bfb7f96f3bcc$var$buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $f805bfb7f96f3bcc$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $f805bfb7f96f3bcc$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $f805bfb7f96f3bcc$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $f805bfb7f96f3bcc$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}
module.exports = module.exports.default;

});



parcelRegister("bQkcE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $89f438ee982b4fb2$var$subMilliseconds;

var $89f438ee982b4fb2$var$_index = $89f438ee982b4fb2$var$_interopRequireDefault((parcelRequire("aSksP")));

var $89f438ee982b4fb2$var$_index2 = $89f438ee982b4fb2$var$_interopRequireDefault((parcelRequire("7f9OM")));

var $89f438ee982b4fb2$var$_index3 = $89f438ee982b4fb2$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $89f438ee982b4fb2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function $89f438ee982b4fb2$var$subMilliseconds(dirtyDate, dirtyAmount) {
    (0, $89f438ee982b4fb2$var$_index3.default)(2, arguments);
    var amount = (0, $89f438ee982b4fb2$var$_index.default)(dirtyAmount);
    return (0, $89f438ee982b4fb2$var$_index2.default)(dirtyDate, -amount);
}
module.exports = module.exports.default;

});
parcelRegister("aSksP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7eaed23c7cdcf6c0$var$toInteger;
function $7eaed23c7cdcf6c0$var$toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}
module.exports = module.exports.default;

});

parcelRegister("7f9OM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $54618cc00c3fb8fc$var$addMilliseconds;

var $54618cc00c3fb8fc$var$_index = $54618cc00c3fb8fc$var$_interopRequireDefault((parcelRequire("aSksP")));

var $54618cc00c3fb8fc$var$_index2 = $54618cc00c3fb8fc$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $54618cc00c3fb8fc$var$_index3 = $54618cc00c3fb8fc$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $54618cc00c3fb8fc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function $54618cc00c3fb8fc$var$addMilliseconds(dirtyDate, dirtyAmount) {
    (0, $54618cc00c3fb8fc$var$_index3.default)(2, arguments);
    var timestamp = (0, $54618cc00c3fb8fc$var$_index2.default)(dirtyDate).getTime();
    var amount = (0, $54618cc00c3fb8fc$var$_index.default)(dirtyAmount);
    return new Date(timestamp + amount);
}
module.exports = module.exports.default;

});


parcelRegister("3ckvK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2542672a600cd2b8$var$_index = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("kFGp1")));

var $2542672a600cd2b8$var$_index2 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("3xdEO")));

var $2542672a600cd2b8$var$_index3 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("6Falt")));

var $2542672a600cd2b8$var$_index4 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("gUvh1")));

var $2542672a600cd2b8$var$_index5 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("46m4m")));

var $2542672a600cd2b8$var$_index6 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("3ihh3")));

var $2542672a600cd2b8$var$_index7 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("bQ2eo")));
function $2542672a600cd2b8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $2542672a600cd2b8$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $2542672a600cd2b8$var$formatters = {
    // Era
    G: function(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return $2542672a600cd2b8$var$_index.default.y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        var signedWeekYear = (0, $2542672a600cd2b8$var$_index6.default)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $2542672a600cd2b8$var$_index7.default)(twoDigitYear, 2);
        } // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
         // Padding
        return (0, $2542672a600cd2b8$var$_index7.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        var isoWeekYear = (0, $2542672a600cd2b8$var$_index4.default)(date); // Padding
        return (0, $2542672a600cd2b8$var$_index7.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        var year = date.getUTCFullYear();
        return (0, $2542672a600cd2b8$var$_index7.default)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $2542672a600cd2b8$var$_index7.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $2542672a600cd2b8$var$_index7.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return $2542672a600cd2b8$var$_index.default.M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $2542672a600cd2b8$var$_index7.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        var week = (0, $2542672a600cd2b8$var$_index5.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $2542672a600cd2b8$var$_index7.default)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        var isoWeek = (0, $2542672a600cd2b8$var$_index3.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $2542672a600cd2b8$var$_index7.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return $2542672a600cd2b8$var$_index.default.d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        var dayOfYear = (0, $2542672a600cd2b8$var$_index2.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $2542672a600cd2b8$var$_index7.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $2542672a600cd2b8$var$_index7.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $2542672a600cd2b8$var$_index7.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $2542672a600cd2b8$var$_index7.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return $2542672a600cd2b8$var$_index.default.h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return $2542672a600cd2b8$var$_index.default.H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $2542672a600cd2b8$var$_index7.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $2542672a600cd2b8$var$_index7.default)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return $2542672a600cd2b8$var$_index.default.m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return $2542672a600cd2b8$var$_index.default.s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return $2542672a600cd2b8$var$_index.default.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $2542672a600cd2b8$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $2542672a600cd2b8$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $2542672a600cd2b8$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $2542672a600cd2b8$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $2542672a600cd2b8$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $2542672a600cd2b8$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $2542672a600cd2b8$var$_index7.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $2542672a600cd2b8$var$_index7.default)(timestamp, token.length);
    }
};
function $2542672a600cd2b8$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $2542672a600cd2b8$var$_index7.default)(minutes, 2);
}
function $2542672a600cd2b8$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $2542672a600cd2b8$var$_index7.default)(Math.abs(offset) / 60, 2);
    }
    return $2542672a600cd2b8$var$formatTimezone(offset, dirtyDelimiter);
}
function $2542672a600cd2b8$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $2542672a600cd2b8$var$_index7.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $2542672a600cd2b8$var$_index7.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $2542672a600cd2b8$var$_default = $2542672a600cd2b8$var$formatters;
module.exports.default = $2542672a600cd2b8$var$_default;
module.exports = module.exports.default;

});
parcelRegister("kFGp1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0c88744bd108133$var$_index = $f0c88744bd108133$var$_interopRequireDefault((parcelRequire("bQ2eo")));
function $f0c88744bd108133$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $f0c88744bd108133$var$formatters = {
    // Year
    y: function(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $f0c88744bd108133$var$_index.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $f0c88744bd108133$var$_index.default)(month + 1, 2);
    },
    // Day of the month
    d: function(date, token) {
        return (0, $f0c88744bd108133$var$_index.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function(date, token) {
        return (0, $f0c88744bd108133$var$_index.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function(date, token) {
        return (0, $f0c88744bd108133$var$_index.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function(date, token) {
        return (0, $f0c88744bd108133$var$_index.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function(date, token) {
        return (0, $f0c88744bd108133$var$_index.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $f0c88744bd108133$var$_index.default)(fractionalSeconds, token.length);
    }
};
var $f0c88744bd108133$var$_default = $f0c88744bd108133$var$formatters;
module.exports.default = $f0c88744bd108133$var$_default;
module.exports = module.exports.default;

});
parcelRegister("bQ2eo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $89e6481d20123ee2$var$addLeadingZeros;
function $89e6481d20123ee2$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
module.exports = module.exports.default;

});


parcelRegister("3xdEO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $292f0c3a5495486a$var$getUTCDayOfYear;

var $292f0c3a5495486a$var$_index = $292f0c3a5495486a$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $292f0c3a5495486a$var$_index2 = $292f0c3a5495486a$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $292f0c3a5495486a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $292f0c3a5495486a$var$MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $292f0c3a5495486a$var$getUTCDayOfYear(dirtyDate) {
    (0, $292f0c3a5495486a$var$_index2.default)(1, arguments);
    var date = (0, $292f0c3a5495486a$var$_index.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $292f0c3a5495486a$var$MILLISECONDS_IN_DAY) + 1;
}
module.exports = module.exports.default;

});

parcelRegister("6Falt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4d9e98caba6dac2d$var$getUTCISOWeek;

var $4d9e98caba6dac2d$var$_index = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $4d9e98caba6dac2d$var$_index2 = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("6nDqw")));

var $4d9e98caba6dac2d$var$_index3 = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("hI2kM")));

var $4d9e98caba6dac2d$var$_index4 = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $4d9e98caba6dac2d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $4d9e98caba6dac2d$var$MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $4d9e98caba6dac2d$var$getUTCISOWeek(dirtyDate) {
    (0, $4d9e98caba6dac2d$var$_index4.default)(1, arguments);
    var date = (0, $4d9e98caba6dac2d$var$_index.default)(dirtyDate);
    var diff = (0, $4d9e98caba6dac2d$var$_index2.default)(date).getTime() - (0, $4d9e98caba6dac2d$var$_index3.default)(date).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $4d9e98caba6dac2d$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});
parcelRegister("6nDqw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4a53796a96b58804$var$startOfUTCISOWeek;

var $4a53796a96b58804$var$_index = $4a53796a96b58804$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $4a53796a96b58804$var$_index2 = $4a53796a96b58804$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $4a53796a96b58804$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $4a53796a96b58804$var$startOfUTCISOWeek(dirtyDate) {
    (0, $4a53796a96b58804$var$_index2.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $4a53796a96b58804$var$_index.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});

parcelRegister("hI2kM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ce485b424b643216$var$startOfUTCISOWeekYear;

var $ce485b424b643216$var$_index = $ce485b424b643216$var$_interopRequireDefault((parcelRequire("gUvh1")));

var $ce485b424b643216$var$_index2 = $ce485b424b643216$var$_interopRequireDefault((parcelRequire("6nDqw")));

var $ce485b424b643216$var$_index3 = $ce485b424b643216$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $ce485b424b643216$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $ce485b424b643216$var$startOfUTCISOWeekYear(dirtyDate) {
    (0, $ce485b424b643216$var$_index3.default)(1, arguments);
    var year = (0, $ce485b424b643216$var$_index.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $ce485b424b643216$var$_index2.default)(fourthOfJanuary);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("gUvh1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c4fa22996f39566a$var$getUTCISOWeekYear;

var $c4fa22996f39566a$var$_index = $c4fa22996f39566a$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $c4fa22996f39566a$var$_index2 = $c4fa22996f39566a$var$_interopRequireDefault((parcelRequire("6nDqw")));

var $c4fa22996f39566a$var$_index3 = $c4fa22996f39566a$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $c4fa22996f39566a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $c4fa22996f39566a$var$getUTCISOWeekYear(dirtyDate) {
    (0, $c4fa22996f39566a$var$_index3.default)(1, arguments);
    var date = (0, $c4fa22996f39566a$var$_index.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $c4fa22996f39566a$var$_index2.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $c4fa22996f39566a$var$_index2.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});



parcelRegister("46m4m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2fc8d772b38d0976$var$getUTCWeek;

var $2fc8d772b38d0976$var$_index = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $2fc8d772b38d0976$var$_index2 = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("clhRK")));

var $2fc8d772b38d0976$var$_index3 = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("cbqvD")));

var $2fc8d772b38d0976$var$_index4 = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $2fc8d772b38d0976$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $2fc8d772b38d0976$var$MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $2fc8d772b38d0976$var$getUTCWeek(dirtyDate, options) {
    (0, $2fc8d772b38d0976$var$_index4.default)(1, arguments);
    var date = (0, $2fc8d772b38d0976$var$_index.default)(dirtyDate);
    var diff = (0, $2fc8d772b38d0976$var$_index2.default)(date, options).getTime() - (0, $2fc8d772b38d0976$var$_index3.default)(date, options).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $2fc8d772b38d0976$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});
parcelRegister("clhRK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8fc54dfcfb604fc4$var$startOfUTCWeek;

var $8fc54dfcfb604fc4$var$_index = $8fc54dfcfb604fc4$var$_interopRequireDefault((parcelRequire("aSksP")));

var $8fc54dfcfb604fc4$var$_index2 = $8fc54dfcfb604fc4$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $8fc54dfcfb604fc4$var$_index3 = $8fc54dfcfb604fc4$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $8fc54dfcfb604fc4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $8fc54dfcfb604fc4$var$startOfUTCWeek(dirtyDate, dirtyOptions) {
    (0, $8fc54dfcfb604fc4$var$_index3.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $8fc54dfcfb604fc4$var$_index.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $8fc54dfcfb604fc4$var$_index.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $8fc54dfcfb604fc4$var$_index2.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});

parcelRegister("cbqvD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8deb134e55cb5294$var$startOfUTCWeekYear;

var $8deb134e55cb5294$var$_index = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("aSksP")));

var $8deb134e55cb5294$var$_index2 = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("3ihh3")));

var $8deb134e55cb5294$var$_index3 = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("clhRK")));

var $8deb134e55cb5294$var$_index4 = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $8deb134e55cb5294$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $8deb134e55cb5294$var$startOfUTCWeekYear(dirtyDate, dirtyOptions) {
    (0, $8deb134e55cb5294$var$_index4.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $8deb134e55cb5294$var$_index.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $8deb134e55cb5294$var$_index.default)(options.firstWeekContainsDate);
    var year = (0, $8deb134e55cb5294$var$_index2.default)(dirtyDate, dirtyOptions);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $8deb134e55cb5294$var$_index3.default)(firstWeek, dirtyOptions);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("3ihh3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $266073c9a73c0f7b$var$getUTCWeekYear;

var $266073c9a73c0f7b$var$_index = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("aSksP")));

var $266073c9a73c0f7b$var$_index2 = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $266073c9a73c0f7b$var$_index3 = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("clhRK")));

var $266073c9a73c0f7b$var$_index4 = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $266073c9a73c0f7b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $266073c9a73c0f7b$var$getUTCWeekYear(dirtyDate, dirtyOptions) {
    (0, $266073c9a73c0f7b$var$_index4.default)(1, arguments);
    var date = (0, $266073c9a73c0f7b$var$_index2.default)(dirtyDate, dirtyOptions);
    var year = date.getUTCFullYear();
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $266073c9a73c0f7b$var$_index.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $266073c9a73c0f7b$var$_index.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $266073c9a73c0f7b$var$_index3.default)(firstWeekOfNextYear, dirtyOptions);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $266073c9a73c0f7b$var$_index3.default)(firstWeekOfThisYear, dirtyOptions);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});




parcelRegister("awKAW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $7aa109506ceedd4b$var$dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
}
function $7aa109506ceedd4b$var$timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
}
function $7aa109506ceedd4b$var$dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/);
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $7aa109506ceedd4b$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $7aa109506ceedd4b$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $7aa109506ceedd4b$var$timeLongFormatter(timePattern, formatLong));
}
var $7aa109506ceedd4b$var$longFormatters = {
    p: $7aa109506ceedd4b$var$timeLongFormatter,
    P: $7aa109506ceedd4b$var$dateTimeLongFormatter
};
var $7aa109506ceedd4b$var$_default = $7aa109506ceedd4b$var$longFormatters;
module.exports.default = $7aa109506ceedd4b$var$_default;
module.exports = module.exports.default;

});

parcelRegister("jGQTC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e55af8a2cb6edd32$var$getTimezoneOffsetInMilliseconds;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $e55af8a2cb6edd32$var$getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}
module.exports = module.exports.default;

});

parcelRegister("5qguX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isProtectedDayOfYearToken = $3f2c2dab40599caa$var$isProtectedDayOfYearToken;
module.exports.isProtectedWeekYearToken = $3f2c2dab40599caa$var$isProtectedWeekYearToken;
module.exports.throwProtectedError = $3f2c2dab40599caa$var$throwProtectedError;
var $3f2c2dab40599caa$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $3f2c2dab40599caa$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $3f2c2dab40599caa$var$isProtectedDayOfYearToken(token) {
    return $3f2c2dab40599caa$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $3f2c2dab40599caa$var$isProtectedWeekYearToken(token) {
    return $3f2c2dab40599caa$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $3f2c2dab40599caa$var$throwProtectedError(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
}

});


parcelRegister("5wWnR", function(module, exports) {

$parcel$export(module.exports, "default", () => $406d3abc4f70c331$export$2e2bcd8739ae039);

var $1nruv = parcelRequire("1nruv");

var $6ZkUj = parcelRequire("6ZkUj");
var $406d3abc4f70c331$var$MILLISECONDS_IN_MINUTE = 60000;
var $406d3abc4f70c331$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $406d3abc4f70c331$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $406d3abc4f70c331$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $406d3abc4f70c331$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $406d3abc4f70c331$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $406d3abc4f70c331$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $406d3abc4f70c331$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $406d3abc4f70c331$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $406d3abc4f70c331$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $406d3abc4f70c331$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $406d3abc4f70c331$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $406d3abc4f70c331$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $1nruv.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $1nruv.default)('long', date, options);
        }
    }
};
function $406d3abc4f70c331$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $6ZkUj.default)(timeZone, originalDate, true) / $406d3abc4f70c331$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $406d3abc4f70c331$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $406d3abc4f70c331$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $406d3abc4f70c331$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $406d3abc4f70c331$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $406d3abc4f70c331$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $406d3abc4f70c331$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $406d3abc4f70c331$var$formatTimezone(offset, dirtyDelimeter);
}
function $406d3abc4f70c331$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $406d3abc4f70c331$var$addLeadingZeros(minutes, 2);
}
var $406d3abc4f70c331$export$2e2bcd8739ae039 = $406d3abc4f70c331$var$formatters;

});
parcelRegister("1nruv", function(module, exports) {

$parcel$export(module.exports, "default", () => $100d43922c522b8e$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $100d43922c522b8e$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $100d43922c522b8e$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $100d43922c522b8e$var$partsTimeZone(dtf, date) : $100d43922c522b8e$var$hackyTimeZone(dtf, date);
}
function $100d43922c522b8e$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $100d43922c522b8e$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $100d43922c522b8e$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("6ZkUj", function(module, exports) {

$parcel$export(module.exports, "default", () => $5168a8572a4ea5fa$export$2e2bcd8739ae039);

var $lLNDp = parcelRequire("lLNDp");

var $h3kEp = parcelRequire("h3kEp");
var $5168a8572a4ea5fa$var$MILLISECONDS_IN_HOUR = 3600000;
var $5168a8572a4ea5fa$var$MILLISECONDS_IN_MINUTE = 60000;
var $5168a8572a4ea5fa$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $5168a8572a4ea5fa$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $5168a8572a4ea5fa$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $5168a8572a4ea5fa$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$5168a8572a4ea5fa$var$validateTimezone(hours)) return NaN;
        return -(hours * $5168a8572a4ea5fa$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $5168a8572a4ea5fa$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$5168a8572a4ea5fa$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $5168a8572a4ea5fa$var$MILLISECONDS_IN_HOUR + minutes * $5168a8572a4ea5fa$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($5168a8572a4ea5fa$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $5168a8572a4ea5fa$var$toUtcDate(date);
        var offset = $5168a8572a4ea5fa$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $5168a8572a4ea5fa$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $5168a8572a4ea5fa$var$toUtcDate(date) {
    return (0, $h3kEp.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $5168a8572a4ea5fa$var$calcOffset(date, timezoneString) {
    var tokens = (0, $lLNDp.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $h3kEp.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $5168a8572a4ea5fa$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $5168a8572a4ea5fa$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $5168a8572a4ea5fa$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $5168a8572a4ea5fa$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $5168a8572a4ea5fa$var$validIANATimezoneCache = {};
function $5168a8572a4ea5fa$var$isValidTimezoneIANAString(timeZoneString) {
    if ($5168a8572a4ea5fa$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $5168a8572a4ea5fa$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("lLNDp", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd947d245dec6ea5$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $fd947d245dec6ea5$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $fd947d245dec6ea5$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $fd947d245dec6ea5$var$partsOffset(dtf, date) : $fd947d245dec6ea5$var$hackyOffset(dtf, date);
}
var $fd947d245dec6ea5$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $fd947d245dec6ea5$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $fd947d245dec6ea5$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $fd947d245dec6ea5$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $fd947d245dec6ea5$var$dtfCache = {};
function $fd947d245dec6ea5$var$getDateTimeFormat(timeZone) {
    if (!$fd947d245dec6ea5$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $fd947d245dec6ea5$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $fd947d245dec6ea5$var$dtfCache[timeZone];
}

});

parcelRegister("h3kEp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6a2bc4b1d0fb732$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $c6a2bc4b1d0fb732$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("sNI8p", function(module, exports) {

$parcel$export(module.exports, "default", () => $05692d2dadd400c6$export$2e2bcd8739ae039);

var $aSksP = parcelRequire("aSksP");

var $jGQTC = parcelRequire("jGQTC");

var $6ZkUj = parcelRequire("6ZkUj");

var $7koqM = parcelRequire("7koqM");
var $05692d2dadd400c6$var$MILLISECONDS_IN_HOUR = 3600000;
var $05692d2dadd400c6$var$MILLISECONDS_IN_MINUTE = 60000;
var $05692d2dadd400c6$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $05692d2dadd400c6$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $7koqM.default)
};
function $05692d2dadd400c6$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $05692d2dadd400c6$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($aSksP)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $05692d2dadd400c6$var$splitDateString(argument);
    var parseYearResult = $05692d2dadd400c6$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $05692d2dadd400c6$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $05692d2dadd400c6$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $6ZkUj.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $05692d2dadd400c6$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $05692d2dadd400c6$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $05692d2dadd400c6$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $05692d2dadd400c6$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $05692d2dadd400c6$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $05692d2dadd400c6$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $05692d2dadd400c6$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $05692d2dadd400c6$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $05692d2dadd400c6$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $05692d2dadd400c6$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $05692d2dadd400c6$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$05692d2dadd400c6$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $05692d2dadd400c6$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$05692d2dadd400c6$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $05692d2dadd400c6$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$05692d2dadd400c6$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $05692d2dadd400c6$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$05692d2dadd400c6$var$validateWeekDate(year, week)) return new Date(NaN);
        return $05692d2dadd400c6$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $05692d2dadd400c6$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$05692d2dadd400c6$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $05692d2dadd400c6$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $05692d2dadd400c6$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $05692d2dadd400c6$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$05692d2dadd400c6$var$validateTime(hours)) return NaN;
        return hours % 24 * $05692d2dadd400c6$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $05692d2dadd400c6$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$05692d2dadd400c6$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $05692d2dadd400c6$var$MILLISECONDS_IN_HOUR + minutes * $05692d2dadd400c6$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $05692d2dadd400c6$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$05692d2dadd400c6$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $05692d2dadd400c6$var$MILLISECONDS_IN_HOUR + minutes * $05692d2dadd400c6$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $05692d2dadd400c6$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $05692d2dadd400c6$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $05692d2dadd400c6$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $05692d2dadd400c6$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $05692d2dadd400c6$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $05692d2dadd400c6$var$isLeapYearIndex(year);
        if (isLeapYear && date > $05692d2dadd400c6$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $05692d2dadd400c6$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $05692d2dadd400c6$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $05692d2dadd400c6$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $05692d2dadd400c6$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $05692d2dadd400c6$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("7koqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $555d5a1d4b17cc17$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $555d5a1d4b17cc17$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $555d5a1d4b17cc17$export$2e2bcd8739ae039 = $555d5a1d4b17cc17$var$tzPattern;

});



parcelRegister("iEBtW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9490987520dece7$export$2e2bcd8739ae039);

var $6ZkUj = parcelRequire("6ZkUj");

var $sNI8p = parcelRequire("sNI8p");
function $d9490987520dece7$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $sNI8p.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $6ZkUj.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});





parcelRegister("7pLOg", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9ae585c7017b5f5$export$2e2bcd8739ae039);

var $aOgFy = parcelRequire("aOgFy");

var $hrPaF = parcelRequire("hrPaF");

var $6laLp = parcelRequire("6laLp");

var $9yQ7J = parcelRequire("9yQ7J");
const $b9ae585c7017b5f5$var$PRODUCT_RECCOMENDATIONS = '/v1/product-recommendations';
const $b9ae585c7017b5f5$var$PRODUCT_JOIN_OR_REQUEST_BULK = '/v1/access-requests/bulk/request';
const $b9ae585c7017b5f5$var$ALL_SUPPORTED_PRODUCTS = [
    'confluence',
    'jira',
    'jira-core',
    'jira-servicedesk',
    'jira-software',
    'jira-incident-manager',
    'jira-product-discovery',
    'opsgenie',
    'statuspage',
    'avocado',
    'townsquare',
    'compass',
    'avp',
    'beacon',
    'mercury'
];
class $b9ae585c7017b5f5$export$3209eb31343f39d extends (0, $hrPaF.RestClient) {
    constructor(serviceUrl, config){
        super({
            serviceUrl: serviceUrl,
            config: config
        });
    }
    async getProductRecommendationsInner(supportedProducts = $b9ae585c7017b5f5$var$ALL_SUPPORTED_PRODUCTS, capabilities) {
        try {
            const orgId = this.getOrgId();
            const queryProducts = supportedProducts && supportedProducts.length > 0 ? supportedProducts : $b9ae585c7017b5f5$var$ALL_SUPPORTED_PRODUCTS;
            const productQueryParams = queryProducts.map((product)=>`product=${product}`).join('&');
            const capabilityQueryParams = capabilities && capabilities.length > 0 ? '&' + capabilities.map((capability)=>`capability=${capability}`).join('&') : '';
            const url = `${$b9ae585c7017b5f5$var$PRODUCT_RECCOMENDATIONS}?orgId=${orgId}&${productQueryParams}${capabilityQueryParams}`;
            return await this.getResource(url);
        } catch (error) {
            this.logException(error, 'An error occurred while getting product recommendations.');
            throw error;
        }
    }
    async getProductRecommendations(supportedProducts = $b9ae585c7017b5f5$var$ALL_SUPPORTED_PRODUCTS, capabilities) {
        // This endpoint may return duplicate resource ARIs with a different mode.
        const result = await this.getProductRecommendationsInner(supportedProducts, capabilities);
        try {
            const deduplicatedResult = (0, $9yQ7J.removeDuplicateRecommendations)(result);
            return deduplicatedResult;
        } catch (error) {
            this.logException(error, 'An error occurred while deduplicating product recommendations.');
            throw error;
        }
    }
    async joinOrRequestDefaultAccessToProductsBulk(simplifiedRequest) {
        if (simplifiedRequest.productAris.length === 0) return Promise.resolve([]);
        try {
            const resources = simplifiedRequest.productAris.map((ari)=>({
                    ari: ari,
                    role: 'product/member'
                }));
            const request = {
                resources: resources,
                note: simplifiedRequest.note,
                accessMode: simplifiedRequest.accessMode,
                source: simplifiedRequest.source
            };
            return await this.postResource($b9ae585c7017b5f5$var$PRODUCT_JOIN_OR_REQUEST_BULK, request);
        } catch (error) {
            this.logException(error, 'An error occurred while joining or requesting access to products.');
            throw error;
        }
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$b9ae585c7017b5f5$export$2e2bcd8739ae039 = new $b9ae585c7017b5f5$export$3209eb31343f39d((0, $aOgFy.DEFAULT_CONFIG).invitationsServiceUrl, {
    logException: $6laLp.logException
});

});
parcelRegister("9yQ7J", function(module, exports) {

$parcel$export(module.exports, "removeDuplicateRecommendations", () => $3c835b25600ef74b$export$d9d1c981635dd213);
/**
 * Determines which capability is more desirable.
 * Users desire direct access over request access since it's instant.
 * @returns 0 if equal, -1 if a is more desirable, 1 if b is more desirable.
 */ const $3c835b25600ef74b$var$compareCapability = (a, b)=>{
    if (a === b) return 0;
    return a === 'DIRECT_ACCESS' ? -1 : 1;
};
/**
 * Determines which mode is more desirable.
 * Atlassian prefers to provide open access over domain restricted access.
 * Both of these modes have already been enabled by an admin.
 * If mode is undefined, it is deemed least desirable.
 * @returns 0 if equal, -1 if a is more open, 1 if b is more open.
 */ const $3c835b25600ef74b$var$compareMode = (a, b)=>{
    if (a === b) return 0;
    if (!a) return 1;
    if (!b) return -1;
    return a === 'OPEN' ? -1 : 1;
};
/**
 * Determine if a recommendation is more desirable than another.
 * Atlassian prefers a better capability over any mode setting.
 * The mode will only be compared if the capabilities are equal.
 * If both capability and mode are equal, the recommendations are considered the same.
 *
 * Assumes recommendations have the same resource ID.
 * Do not compare recommendations with different resource IDs, as it does not make sense.
 *
 * @returns 0 if capability and mode are equal, -1 if a is more desirable, 1 if b is more desirable.
 */ const $3c835b25600ef74b$var$compareRecommendations = (a, b)=>{
    if (a.resourceId !== b.resourceId) throw new Error('Recommendations must have the same resource ID');
    if ($3c835b25600ef74b$var$compareCapability(a.capability, b.capability) < 0) return -1;
    else if ($3c835b25600ef74b$var$compareCapability(a.capability, b.capability) > 0) return 1;
    else if ($3c835b25600ef74b$var$compareMode(a.mode, b.mode) < 0) return -1;
    else if ($3c835b25600ef74b$var$compareMode(a.mode, b.mode) > 0) return 1;
    return 0;
};
const $3c835b25600ef74b$var$toRecommendation = (recommendation)=>{
    const { capability: capability, ...rest } = recommendation;
    return {
        ...rest
    };
};
const $3c835b25600ef74b$export$d9d1c981635dd213 = (recommendations)=>{
    const { DIRECT_ACCESS: DIRECT_ACCESS, REQUEST_ACCESS: REQUEST_ACCESS } = recommendations.capability;
    const uniqueRecommendations = {};
    const allRecommendations = [
        ...DIRECT_ACCESS.map((recommendation)=>({
                ...recommendation,
                capability: 'DIRECT_ACCESS'
            })),
        ...REQUEST_ACCESS.map((recommendation)=>({
                ...recommendation,
                capability: 'REQUEST_ACCESS'
            }))
    ];
    allRecommendations.forEach((recommendation)=>{
        const existing = uniqueRecommendations[recommendation.resourceId];
        if (existing && $3c835b25600ef74b$var$compareRecommendations(existing, recommendation) <= 0) return;
        uniqueRecommendations[recommendation.resourceId] = recommendation;
    });
    const allUniqueRecommendations = Object.values(uniqueRecommendations);
    return {
        capability: {
            DIRECT_ACCESS: allUniqueRecommendations.filter((recommendation)=>recommendation.capability === 'DIRECT_ACCESS').map($3c835b25600ef74b$var$toRecommendation),
            REQUEST_ACCESS: allUniqueRecommendations.filter((recommendation)=>recommendation.capability === 'REQUEST_ACCESS').map($3c835b25600ef74b$var$toRecommendation)
        }
    };
};

});


parcelRegister("8MCmh", function(module, exports) {

$parcel$export(module.exports, "defaultLegionClient", () => $2443af7a75778c61$export$95c697fe95d86a77);

var $aOgFy = parcelRequire("aOgFy");

var $hrPaF = parcelRequire("hrPaF");
const $2443af7a75778c61$var$v3UrlPath = `/v3/teams`;
const $2443af7a75778c61$var$v4UrlPath = `/v4/teams`;
class $2443af7a75778c61$export$68a6a391e3cf23be extends (0, $hrPaF.RestClient) {
    constructor(serviceUrl){
        super({
            serviceUrl: serviceUrl
        });
        this.serviceUrlRoot = serviceUrl;
    }
    setRootUrl(url) {
        if (url === this.serviceUrlRoot) return;
        this.serviceUrlRoot = url;
        this.setServiceUrl(url);
    }
    async getTeamById(teamId) {
        const siteId = this.getCloudId();
        const teamResponse = await this.getResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}?siteId=${siteId}`);
        return this.mapTeamResponseV4ToTeam(teamResponse);
    }
    async getAllTeams(allTeamsQuery) {
        try {
            const orgId = this.getOrgId(allTeamsQuery.orgId);
            const siteId = this.getCloudId();
            const { entities: entities, cursor: cursor } = await this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/search`, {
                organizationId: orgId,
                siteId: siteId,
                limit: allTeamsQuery.limit,
                query: allTeamsQuery.searchQuery,
                cursor: allTeamsQuery.cursor || '',
                sortBy: allTeamsQuery.useDefaultSort ? null : [
                    {
                        field: 'displayName',
                        order: 'asc'
                    }
                ],
                membership: {
                    memberAccountIds: allTeamsQuery.memberAccountIds
                },
                showEmptyTeams: allTeamsQuery.showEmptyTeams
            });
            const teams = entities.map((t)=>this.mapTeamSearchResponseV4ToTeamWithMembership(t));
            return {
                cursor: cursor,
                teams: teams
            };
        } catch (error) {
            this.logException(error, 'getAllTeams');
            return {
                cursor: '',
                teams: [],
                error: error instanceof Error ? error : undefined
            };
        }
    }
    async updateTeamById(teamId, data) {
        const teamResponse = await this.patchResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}`, data);
        return this.mapTeamResponseV4ToTeam(teamResponse);
    }
    /**
	 * @private
	 * @deprecated use publicApiClient.addUsersToTeam instead
	 */ async inviteUsersToTeam(teamId, users, originQuery) {
        if (!users || users.length === 0) return Promise.resolve([]);
        const emails = [];
        const ids = [];
        users.forEach((user)=>{
            if (user.id) ids.push(user.id);
            else if (user.email) emails.push(user.email);
        });
        const url = `${$2443af7a75778c61$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/invite?${this.constructProductOriginParams(originQuery)}`;
        return this.postResource(url, {
            emailAddresses: emails,
            atlassianAccounts: ids
        });
    }
    async getMyTeamMembership(teamId) {
        return this.getResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/me?siteId=${this.getCloudId()}`, {
            shouldLogError: (e)=>e.status !== 400
        });
    }
    async getTeamLinksByTeamId(teamId) {
        let siteId = this.getCloudId();
        let response = await this.getResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links?siteId=${siteId}`);
        return this.mapLegionTeamLinksResponseV4ToTeamLinkResponse(response);
    }
    async createTeamLink(teamId, link) {
        const sanitisedTeamLink = {
            contentTitle: link.contentTitle.trim(),
            linkUri: link.linkUri.trim(),
            description: link.description.trim(),
            ...link.creationTime ? {
                creationTime: link.creationTime.trim()
            } : {},
            ...link.teamId ? {
                teamId: link.teamId.trim()
            } : {}
        };
        const response = await this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links`, sanitisedTeamLink);
        return this.mapLegionTeamLinkResponseV4ToTeamLink(response);
    }
    async updateTeamLink(teamId, linkId, { linkUri: linkUri, ...linkFields }) {
        const response = await this.putResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/${linkId}`, {
            linkUri: linkUri.trim(),
            ...linkFields
        });
        return this.mapLegionTeamLinkResponseV4ToTeamLink(response);
    }
    async deleteTeamLink(teamId, linkId) {
        return this.deleteResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/${linkId}`);
    }
    async reorderTeamLink(teamId, linkId, newPosition) {
        const queryArgs = `?linkId=${linkId}&newPosition=${newPosition}`;
        return this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/order${queryArgs}`);
    }
    async getOrgEligibilityForManagedTeams() {
        const orgId = this.getOrgId();
        if (!orgId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getOrgEligibilityForManagedTeams');
            throw err;
        }
        return this.getResourceCached(`${$2443af7a75778c61$var$v4UrlPath}/org/${orgId}/premium/eligibility`);
    }
    /**
	 * @private
	 * @deprecated in V4, as no invitation status for team membership anymore.
	 */ async acceptTeamInvitation(teamId) {
        return this.postResource(`${$2443af7a75778c61$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/accept`);
    }
    /**
	 * @private
	 * @deprecated in V4, as no invitation status for team membership anymore.
	 */ async declineTeamInvitation(teamId) {
        return this.postResource(`${$2443af7a75778c61$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/decline`);
    }
    async selfJoinTeam(// TODO Test me
    teamId, originQuery) {
        const url = `${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/join?${this.constructProductOriginParams(originQuery)}`;
        return this.postResource(url);
    }
    async cancelJoinRequest(teamId) {
        return this.deleteResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/request`);
    }
    async acceptJoinRequest(teamId, memberId) {
        return this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/${memberId}/request/accept`);
    }
    async declineJoinRequest(teamId, memberId) {
        return this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/${memberId}/request/decline`);
    }
    /**
	 * @private
	 * @deprecated use publicApiClient.removeTeamMemberships instead
	 */ async deleteTeamMembership(teamId, memberId) {
        return this.deleteResource(`${$2443af7a75778c61$var$v3UrlPath}/${this.trimTeamARI(teamId)}/members/${memberId}`);
    }
    /**
	 * @private
	 * @deprecated INVITED status has been deprecated
	 */ async revokeTeamInvite(teamId, memberId) {
        return this.deleteResource(`${$2443af7a75778c61$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/${memberId}/revoke`);
    }
    async deleteTeam(teamId) {
        return this.deleteResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}`);
    }
    /**
	 * @private
	 * @deprecated should be other means to solve this issue
	 */ async isSingleFullMemberTeam(teamId) {
        // This is still not working...
        const members = await this.getResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/members?size=2&membershipState=FULL_MEMBER&siteId=${this.getCloudId()}`);
        return members.entities.length === 1;
    }
    async createTeam(displayName, originQuery, members, membershipSettings = 'OPEN') {
        const organizationId = this.getContext().orgId;
        if (!organizationId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'createTeam');
            throw err;
        }
        const url = `${$2443af7a75778c61$var$v4UrlPath}?${this.constructProductOriginParams(originQuery)}`;
        const legionTeam = await this.postResource(url, {
            displayName: displayName,
            description: '',
            membershipSettings: membershipSettings,
            siteId: this.getCloudId(),
            organizationId: organizationId,
            members: [
                ...new Set(members)
            ]
        });
        return this.mapTeamCreateResponseV4ToTeam(legionTeam);
    }
    async createExternalTeam(description, externalReference, teamName, siteId) {
        const organizationId = this.getContext().orgId;
        const cloudId = this.getContext().cloudId;
        if (!organizationId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'createTeam');
            throw err;
        }
        const url = `${$2443af7a75778c61$var$v4UrlPath}/external?origin.cloudId=${encodeURIComponent(this.getCloudId(siteId || cloudId))}`;
        const legionExternalTeam = await this.postResource(url, {
            description: description,
            externalReference: externalReference,
            organizationId: organizationId,
            siteId: siteId || cloudId,
            displayName: teamName
        });
        return this.mapTeamCreateResponseV4ToTeam(legionExternalTeam);
    }
    async getTeamAndGroupDiff(teamId, externalReference) {
        const siteId = this.getCloudId();
        return this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/external/diff`, {
            siteId: siteId,
            externalReference: externalReference
        });
    }
    async linkExistingTeamToGroup(teamId, externalReference) {
        const siteId = this.getCloudId();
        return this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/external/link`, {
            externalReference: externalReference,
            siteId: siteId
        });
    }
    async getWriteMediaToken() {
        return this.getResource('/v4/teams/header-image/media-upload').then((response)=>({
                ...response,
                baseUrl: response.baseUrl?.endsWith('/') ? response.baseUrl.slice(0, -1) : response.baseUrl
            }));
    }
    async getSoftDeletedTeamById(teamId) {
        const orgId = this.getOrgId();
        const siteId = this.getCloudId();
        return this.getResource(`${$2443af7a75778c61$var$v4UrlPath}/org/${orgId}/soft-deleted/${this.trimTeamARI(teamId)}?siteId=${siteId}`).then((response)=>({
                ...response.teamResponse,
                id: teamId
            }));
    }
    /**
	 * Shoud only be used within Teams (P&T) packages
	 */ async getUserInSiteUserBase(userId) {
        const siteId = this.getCloudId();
        return this.getResource(`/teams/site/${siteId}/users/${userId}/exists`, {
            headers: {
                Accept: 'application/json',
                'X-header-client-id': 'ptc-fe'
            }
        });
    }
    async retrieveBrowseUserPermission(product) {
        return this.getResourceCached(`/teams/site/${this.getCloudId()}/canSearchUsers?product=${product}`, undefined, // 2 minute expiration, resolves duplicate calls in initial load
        {
            expiration: 120000
        });
    }
    async getPermissions() {
        const orgId = this.getContext().orgId;
        const siteId = this.getCloudId();
        if (!orgId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getPermissions');
            throw err;
        }
        return this.getResourceCached(`${$2443af7a75778c61$var$v4UrlPath}/permission/self/organization/${orgId}?siteId=${siteId}`);
    }
    async getLinkedTeamsBulk(groupIds) {
        const organizationId = this.getContext().orgId;
        if (!organizationId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getLinkedTeamsBulk');
            throw err;
        }
        const legionExternalTeam = await this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/external/bulk`, {
            organizationId: organizationId,
            source: 'ATLASSIAN_GROUP',
            externalIds: groupIds
        });
        return legionExternalTeam;
    }
    async getTeamProfileDetails(teamId) {
        const siteId = this.getCloudId();
        if (!siteId) {
            const err = new Error('Site ID is required');
            this.logException(err, 'getTeamProfileDetails');
            throw err;
        }
        const linkedTeamsProfileDetails = await this.getResource(`${$2443af7a75778c61$var$v4UrlPath}/${teamId}/profile?siteId=${this.getCloudId()}`);
        return linkedTeamsProfileDetails;
    }
    async getOrgScope() {
        const orgId = this.getContext().orgId;
        if (!orgId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getOrgScope');
            throw err;
        }
        const orgScope = await this.getResourceCached(`${$2443af7a75778c61$var$v4UrlPath}/org/${orgId}/scope`);
        return orgScope;
    }
    async restoreTeamToSyncedGroup(teamId, externalReference) {
        const siteId = this.getCloudId();
        return await this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/${teamId}/external/restore`, {
            externalReference: externalReference,
            siteId: siteId
        });
    }
    async createTeamContainers(payload) {
        return this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/containers`, {
            ...payload
        });
    }
    // some Legion APIs return team id with the team ARI
    trimTeamARI(teamId = '') {
        const OLD_TEAM_ARI_PREFIX = 'ari:cloud:teams::team/';
        const TEAM_ARI_PREFIX = 'ari:cloud:identity::team/';
        return teamId.replace(TEAM_ARI_PREFIX, '').replace(OLD_TEAM_ARI_PREFIX, ''); // PTC-4213 will remove the references to the old team ARI
    }
    constructProductOriginParams(originQuery) {
        const product = (originQuery.product || '').toUpperCase();
        const queries = [
            `origin.cloudId=${encodeURIComponent(this.getCloudId(originQuery.cloudId))}`
        ];
        if (product) queries.push(`origin.product=${encodeURIComponent(product)}`);
        return queries.join('&');
    }
    mapTeamResponseV4ToTeam(teamResponse) {
        return {
            id: teamResponse.id,
            displayName: teamResponse.displayName,
            description: teamResponse.description,
            state: teamResponse.state,
            membershipSettings: teamResponse.membershipSettings,
            organizationId: teamResponse.organizationId,
            restriction: 'ORG_MEMBERS',
            creatorId: teamResponse.creatorId,
            permission: teamResponse.permission,
            orgId: teamResponse.organizationId,
            smallHeaderImageUrl: teamResponse.smallHeaderImageUrl,
            largeHeaderImageUrl: teamResponse.largeHeaderImageUrl,
            smallAvatarImageUrl: teamResponse.smallAvatarImageUrl,
            largeAvatarImageUrl: teamResponse.largeAvatarImageUrl,
            scopeMode: teamResponse.scopeMode,
            isVerified: teamResponse.isVerified,
            ...teamResponse.externalReference && {
                externalReference: {
                    id: teamResponse.externalReference.id,
                    source: teamResponse.externalReference.source
                }
            }
        };
    }
    mapTeamCreateResponseV4ToTeam(teamResponse) {
        return {
            id: teamResponse.id,
            displayName: teamResponse.displayName,
            description: teamResponse.description,
            state: teamResponse.state,
            membershipSettings: teamResponse.membershipSettings,
            organizationId: teamResponse.organizationId,
            restriction: 'ORG_MEMBERS',
            creatorId: teamResponse.creatorId,
            permission: teamResponse.permission,
            orgId: teamResponse.organizationId,
            memberIds: teamResponse.membership?.members?.map((m)=>m.membershipId.memberId) || [],
            membership: teamResponse.membership
        };
    }
    mapTeamSearchResponseV4ToTeamWithMembership(teamResponse) {
        return {
            id: teamResponse.id,
            displayName: teamResponse.displayName,
            description: teamResponse.description,
            state: teamResponse.state,
            membershipSettings: teamResponse.membershipSettings,
            organizationId: teamResponse.organizationId,
            restriction: 'ORG_MEMBERS',
            smallHeaderImageUrl: teamResponse.smallHeaderImageUrl,
            largeAvatarImageUrl: teamResponse.largeAvatarImageUrl,
            smallAvatarImageUrl: teamResponse.smallAvatarImageUrl,
            largeHeaderImageUrl: teamResponse.largeHeaderImageUrl,
            memberCount: teamResponse.memberCount,
            includesYou: teamResponse.includesYou,
            memberIds: [],
            members: [],
            membership: {
                members: [],
                errors: []
            },
            isVerified: teamResponse.isVerified
        };
    }
    mapLegionTeamLinksResponseV3ToTeamLinkResponse(response) {
        return {
            entities: response.entities.map(this.mapLegionTeamLinkResponseV3ToTeamLink)
        };
    }
    mapLegionTeamLinksResponseV4ToTeamLinkResponse(response) {
        return {
            entities: response.entities.map(this.mapLegionTeamLinkResponseV4ToTeamLink)
        };
    }
    mapLegionTeamLinkResponseV3ToTeamLink(legionLinkResponseV3) {
        return {
            contentTitle: legionLinkResponseV3.contentTitle,
            description: legionLinkResponseV3.description,
            creationTime: legionLinkResponseV3.creationTime,
            linkUri: legionLinkResponseV3.linkUri,
            linkId: legionLinkResponseV3.linkId,
            teamId: legionLinkResponseV3.teamId
        };
    }
    mapLegionTeamLinkResponseV4ToTeamLink(legionLinkResponseV4) {
        return {
            contentTitle: legionLinkResponseV4.contentTitle,
            description: legionLinkResponseV4.description,
            linkUri: legionLinkResponseV4.linkUri,
            linkId: legionLinkResponseV4.linkId,
            teamId: legionLinkResponseV4.teamId
        };
    }
}
const $2443af7a75778c61$export$95c697fe95d86a77 = new $2443af7a75778c61$export$68a6a391e3cf23be((0, $aOgFy.DEFAULT_CONFIG).stargateRoot);

});

parcelRegister("13Kx5", function(module, exports) {

$parcel$export(module.exports, "default", () => $96e9f24df4d329d9$export$2e2bcd8739ae039);

var $1K4T6 = parcelRequire("1K4T6");

var $aOgFy = parcelRequire("aOgFy");

var $hrPaF = parcelRequire("hrPaF");
const $96e9f24df4d329d9$var$defaultConfig = {
    serviceUrl: `${(0, $aOgFy.DEFAULT_CONFIG).stargateRoot}/users/manage`
};
const $96e9f24df4d329d9$var$NOT_EDITABLE = 'not_editable';
const $96e9f24df4d329d9$var$NOT_EDITABLE_FIELD = 'field';
const $96e9f24df4d329d9$var$NOT_EDITABLE_REASON = 'reason';
class $96e9f24df4d329d9$export$1f387592ab3ca6d0 extends (0, $hrPaF.RestClient) {
    constructor(config = {}){
        super({
            ...$96e9f24df4d329d9$var$defaultConfig,
            ...config
        });
    }
    async getProfileWithMutability(userId) {
        return this.getResource(`/${userId}/profile`).then((resp)=>{
            return $96e9f24df4d329d9$var$mapToMutabilityConstraints(resp);
        });
    }
}
function $96e9f24df4d329d9$var$mapToMutabilityConstraints(json) {
    let constraints = [];
    if (json[$96e9f24df4d329d9$var$NOT_EDITABLE] != null) for (const value of json[$96e9f24df4d329d9$var$NOT_EDITABLE])constraints = constraints.concat({
        field: value[$96e9f24df4d329d9$var$NOT_EDITABLE_FIELD],
        reason: $96e9f24df4d329d9$var$determineReason(value[$96e9f24df4d329d9$var$NOT_EDITABLE_REASON])
    });
    return constraints;
}
function $96e9f24df4d329d9$var$determineReason(value) {
    switch(value){
        case 'managed':
        case 'ext.dir.scim':
        case 'ext.dir.google':
            return value;
        default:
            throw new (0, $1K4T6.DefaultError)({
                message: `Unknown mutability constraint reason: ${value}`
            });
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$96e9f24df4d329d9$export$2e2bcd8739ae039 = new $96e9f24df4d329d9$export$1f387592ab3ca6d0();

});

parcelRegister("h46cM", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f2e78061b0eb028$export$2e2bcd8739ae039);

var $aOgFy = parcelRequire("aOgFy");

var $hrPaF = parcelRequire("hrPaF");

var $hjCdE = parcelRequire("hjCdE");
const $6f2e78061b0eb028$var$defaultConfig = {
    serviceUrl: `${(0, $aOgFy.DEFAULT_CONFIG).stargateRoot}`
};
class $6f2e78061b0eb028$export$a78b00aedb6cb3e9 extends (0, $hrPaF.RestClient) {
    constructor(config = {}){
        super({
            ...$6f2e78061b0eb028$var$defaultConfig,
            ...config
        });
    }
    async getTeamLinkIcons(teamLinkUrls) {
        const requestBody = teamLinkUrls.map((url)=>({
                resourceUrl: url
            }));
        return this.postResourceRaw(`/object-resolver/resolve/batch`, JSON.stringify(requestBody)).then((0, $hjCdE.transformIconData));
    }
    async getAriFromUrl(url) {
        return this.postResourceRaw(`/object-resolver/converter/toAri`, JSON.stringify({
            resourceUrl: url
        })).then((response)=>response?.data?.ari);
    }
}
var $6f2e78061b0eb028$export$2e2bcd8739ae039 = new $6f2e78061b0eb028$export$a78b00aedb6cb3e9();

});
parcelRegister("hjCdE", function(module, exports) {

$parcel$export(module.exports, "transformIconData", () => $9290a635b7c41737$export$39f4468adf4cb57c);

var $FZDfl = parcelRequire("FZDfl");
const $9290a635b7c41737$export$c64ca1c808335e8b = (jsonLd)=>{
    const { url: url, generator: { name: name, icon: icon } } = jsonLd;
    switch(name){
        case (0, $FZDfl.ProviderNames).CONFLUENCE:
            return {
                linkUrl: url,
                iconUrl: $9290a635b7c41737$var$getConfluenceFavicon(url),
                productName: name
            };
        case (0, $FZDfl.ProviderNames).JIRA:
            return {
                linkUrl: url,
                iconUrl: $9290a635b7c41737$var$getJiraFavicon(url),
                productName: name
            };
        default:
            return {
                linkUrl: url,
                iconUrl: typeof icon === 'object' ? icon['url'] : icon,
                productName: name
            };
    }
};
const $9290a635b7c41737$var$isIconItemSuccess = (response)=>{
    return response.status === 200;
};
const $9290a635b7c41737$export$39f4468adf4cb57c = (batchResp)=>batchResp.filter($9290a635b7c41737$var$isIconItemSuccess).map((resp)=>resp.body.data).map($9290a635b7c41737$export$c64ca1c808335e8b).filter((linkIconData)=>linkIconData.iconUrl !== undefined);
const $9290a635b7c41737$var$getConfluenceFavicon = (url)=>`https://${new URL(url).hostname}/wiki/favicon.ico`;
const $9290a635b7c41737$var$getJiraFavicon = (url)=>`https://${new URL(url).hostname}/favicon.ico`;

});
parcelRegister("FZDfl", function(module, exports) {

$parcel$export(module.exports, "ProviderNames", () => $584160994f259bf9$export$132d457a8475f4c8);
/**
 * This type matches the props for the TeamLinkIcon component in embeddable-directory
 */ var $584160994f259bf9$export$132d457a8475f4c8 = /*#__PURE__*/ function(ProviderNames) {
    ProviderNames["CONFLUENCE"] = "Confluence";
    ProviderNames["JIRA"] = "Jira";
    return ProviderNames;
}({});

});



parcelRegister("1B4EX", function(module, exports) {

$parcel$export(module.exports, "default", () => $4da5dc8a7e4131fb$export$2e2bcd8739ae039);

var $aOgFy = parcelRequire("aOgFy");

var $hrPaF = parcelRequire("hrPaF");
class $4da5dc8a7e4131fb$export$23820d8d740dd467 extends (0, $hrPaF.RestClient) {
    getIsSiteAdmin(/**
		 * @private
		 * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
		 */ cloudId) {
        return this.postResource('/permitted', {
            permissionId: 'manage',
            resourceId: `ari:cloud:platform::site/${this.getCloudId(cloudId)}`
        }).then((response)=>response.permitted);
    }
}
var /**
 * REST Client to make calls to resources on the activity service.
 *
 * @type {RestClient}
 */ // eslint-disable-next-line import/no-anonymous-default-export
$4da5dc8a7e4131fb$export$2e2bcd8739ae039 = new $4da5dc8a7e4131fb$export$23820d8d740dd467({
    serviceUrl: (0, $aOgFy.DEFAULT_CONFIG).permsServiceUrl
});

});

parcelRegister("7thbw", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc096c4ff7130f7b$export$2e2bcd8739ae039);

var $1K4T6 = parcelRequire("1K4T6");

var $aOgFy = parcelRequire("aOgFy");

var $hrPaF = parcelRequire("hrPaF");
const $cc096c4ff7130f7b$var$V1_URL = '/teams/v1';
const $cc096c4ff7130f7b$var$SENTRY_IGNORED_ERROR_MESSAGES_CREATE = [
    'TEAM_NOT_FOUND'
];
class $cc096c4ff7130f7b$export$38575d07403d67c extends (0, $hrPaF.RestClient) {
    constructor(serviceUrlRoot){
        super({
            serviceUrl: serviceUrlRoot
        });
    }
    async addUsersToTeam(teamId, members) {
        if (!members || members.length === 0) {
            const missingMembersError = new Error('Missing members to add');
            this.logException(missingMembersError, 'addUsersToTeam');
            throw missingMembersError;
        }
        const membersWithIds = members.filter((member)=>!!member.accountId);
        if (membersWithIds.length !== members.length) this.logException(new Error('Missing accountIds for some members'), 'addUsersToTeam');
        if (membersWithIds.length === 0) {
            const missingMembersError = new Error('Missing accountIds for all members');
            this.logException(missingMembersError, 'addUsersToTeam');
            throw missingMembersError;
        }
        try {
            const orgId = this.getOrgId();
            const url = `${$cc096c4ff7130f7b$var$V1_URL}/org/${orgId}/teams/${teamId}/members/add`;
            const response = await this.postResource(url, {
                members: membersWithIds
            });
            return response;
        } catch (e) {
            this.logException(e, 'addUsersToTeam');
            if (e instanceof (0, $1K4T6.HttpError) && $cc096c4ff7130f7b$var$SENTRY_IGNORED_ERROR_MESSAGES_CREATE.includes(e.message)) throw new (0, $1K4T6.SLOIgnoreHttpError)(e);
            throw e;
        }
    }
    async removeTeamMemberships(teamId, members) {
        if (!members || members.length === 0) {
            const missingMembersError = new Error('Missing members to remove');
            this.logException(missingMembersError, 'removeTeamMemberships');
            throw missingMembersError;
        }
        const membersWithIds = members.filter((member)=>!!member.accountId);
        if (membersWithIds.length !== members.length) this.logException(new Error('Missing accountIds for some members'), 'addUsersToTeam');
        if (membersWithIds.length === 0) {
            const missingMembersError = new Error('Missing accountIds for all members');
            this.logException(missingMembersError, 'removeTeamMemberships');
            throw missingMembersError;
        }
        try {
            const orgId = this.getOrgId();
            const url = `${$cc096c4ff7130f7b$var$V1_URL}/org/${orgId}/teams/${teamId}/members/remove`;
            const response = await this.postResource(url, {
                members: membersWithIds
            });
            return response;
        } catch (e) {
            this.logException(e, 'removeTeamMemberships');
            throw e;
        }
    }
    async getTeamDetails(teamId) {
        try {
            const orgId = this.getOrgId();
            const url = `${$cc096c4ff7130f7b$var$V1_URL}/org/${orgId}/teams/${teamId}`;
            const response = await this.getResource(url);
            return response;
        } catch (e) {
            this.logException(e, 'getTeamDetails');
            throw e;
        }
    }
    async getTeamMembers(teamId, first = 50, after) {
        try {
            const orgId = this.getOrgId();
            const url = `${$cc096c4ff7130f7b$var$V1_URL}/org/${orgId}/teams/${teamId}/members`;
            const response = await this.postResource(url, {
                after: after,
                first: first
            });
            return response;
        } catch (e) {
            this.logException(e, 'getTeamMembers');
            throw e;
        }
    }
    async restoreTeam(teamId) {
        try {
            const orgId = this.getOrgId();
            const url = `${$cc096c4ff7130f7b$var$V1_URL}/org/${orgId}/teams/${teamId}/restore`;
            return this.postResource(url);
        } catch (e) {
            this.logException(e, 'restoreTeam');
            throw e;
        }
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$cc096c4ff7130f7b$export$2e2bcd8739ae039 = new $cc096c4ff7130f7b$export$38575d07403d67c((0, $aOgFy.DEFAULT_CONFIG).publicApiRoot);

});

parcelRegister("60KbN", function(module, exports) {

$parcel$export(module.exports, "default", () => $3da0a8fba8b7733c$export$2e2bcd8739ae039);

var $aOgFy = parcelRequire("aOgFy");

var $hrPaF = parcelRequire("hrPaF");
const $3da0a8fba8b7733c$var$defaultConfig = {
    serviceUrl: `${(0, $aOgFy.DEFAULT_CONFIG).stargateRoot}/user-tenure/v1`
};
class $3da0a8fba8b7733c$export$e019a6241c871c27 extends (0, $hrPaF.RestClient) {
    constructor(config = {}){
        super({
            ...$3da0a8fba8b7733c$var$defaultConfig,
            ...config
        });
    }
    async getUserTenure(userId) {
        const orgId = this.getOrgId();
        return this.getResource(`/${orgId}/${userId}`).then((response)=>({
                ...response,
                userHireDate: new Date(response.userHireDate)
            })).catch((error)=>{
            throw new Error('Failed to fetch user tenure');
        });
    }
}
var $3da0a8fba8b7733c$export$2e2bcd8739ae039 = new $3da0a8fba8b7733c$export$e019a6241c871c27();

});

parcelRegister("doDlD", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d5edd21520bfcf7$export$2e2bcd8739ae039);

var $aOgFy = parcelRequire("aOgFy");

var $cPPyF = parcelRequire("cPPyF");

var $6laLp = parcelRequire("6laLp");

var $5q4oc = parcelRequire("5q4oc");

var $7HzJi = parcelRequire("7HzJi");

var $6MiDV = parcelRequire("6MiDV");

var $9rfX5 = parcelRequire("9rfX5");

var $1KerR = parcelRequire("1KerR");

var $ey2Vf = parcelRequire("ey2Vf");

var $h8V8v = parcelRequire("h8V8v");

var $7sahj = parcelRequire("7sahj");

var $1jHJB = parcelRequire("1jHJB");
class $7d5edd21520bfcf7$export$de0359e19b851166 extends (0, $cPPyF.BaseGraphQlClient) {
    constructor(baseUrl, config){
        super((0, $1jHJB.getUnshardedTeamCentralGraphqlUrl)(baseUrl), config);
    }
    // Team central url is a bit special, that it depends on cloudId.
    setBaseUrl(baseUrl) {
        const cloudId = this.getCloudId();
        this.setServiceUrl(cloudId && cloudId !== 'None' ? (0, $1jHJB.getTeamCentralGraphqlUrl)(baseUrl, cloudId) : (0, $1jHJB.getUnshardedTeamCentralGraphqlUrl)(baseUrl));
    }
    async addTeamWatcher(teamId, cloudId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $5q4oc.AddTeamWatcherMutation),
            variables: {
                teamId: teamId,
                cloudId: cloudId
            }
        }, {
            operationName: 'addTeamWatcher'
        });
        return response.addTeamWatcher;
    }
    async removeTeamWatcher(teamId, cloudId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $h8V8v.RemoveTeamWatcherMutation),
            variables: {
                teamId: teamId,
                cloudId: cloudId
            }
        }, {
            operationName: 'removeTeamWatcher'
        });
        return response.removeTeamWatcher;
    }
    async deleteKudos(id) {
        const response = await this.makeGraphQLRequest({
            query: (0, $ey2Vf.KudosDeleteMutation),
            variables: {
                id: id
            }
        }, {
            operationName: 'DeleteKudos'
        });
        return response.deleteKudos;
    }
    async queryTagList(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $7sahj.TagListQuery),
            variables: variables
        }, {
            operationName: 'TagListByCloudId'
        });
        return response.tagSearchByCloudId;
    }
    async createTag(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $7HzJi.CreateTagMutation),
            variables: variables
        }, {
            operationName: 'createTagForCloudId'
        });
        return response.createTagForCloudId;
    }
    async createHelpPointer(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $6MiDV.HelpPointerCreateMutation),
            variables: variables
        }, {
            operationName: 'CreateHelpPointer'
        });
        return response.createHelpPointer;
    }
    async updateHelpPointer(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $1KerR.HelpPointerUpdateMutation),
            variables: variables
        }, {
            operationName: 'UpdateHelpPointer'
        });
        return response.updateHelpPointer;
    }
    async deleteHelpPointer(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $9rfX5.HelpPointerDeleteMutation),
            variables: variables
        }, {
            operationName: 'DeleteHelpPointer'
        });
        return response.deleteHelpPointer;
    }
}
var $7d5edd21520bfcf7$export$2e2bcd8739ae039 = new $7d5edd21520bfcf7$export$de0359e19b851166((0, $aOgFy.DEFAULT_CONFIG).stargateRoot, {
    logException: $6laLp.logException
});

});
parcelRegister("5q4oc", function(module, exports) {

$parcel$export(module.exports, "AddTeamWatcherMutation", () => $7a30a844cfa52ad0$export$2af9f827ad8bcf83);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");
const $7a30a844cfa52ad0$export$2af9f827ad8bcf83 = (0, $1c8Um.print)((0, $5cllN.default)`
	mutation addTeamWatcher($teamId: String!, $cloudId: String) {
		addTeamWatcher(input: { teamId: $teamId, cloudId: $cloudId }) {
			isWatching
			__typename
		}
	}
`);

});

parcelRegister("7HzJi", function(module, exports) {

$parcel$export(module.exports, "CreateTagMutation", () => $794445a2ca2b8bda$export$5e59562b4f09e8ef);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");
const $794445a2ca2b8bda$export$5e59562b4f09e8ef = (0, $1c8Um.print)((0, $5cllN.default)`
	mutation createTagForCloudId($name: String!, $cloudId: String!) {
		createTagForCloudId(input: { name: $name, cloudId: $cloudId }) {
			tag {
				id
				uuid
				name
			}
		}
	}
`);

});

parcelRegister("6MiDV", function(module, exports) {

$parcel$export(module.exports, "HelpPointerCreateMutation", () => $b73f166b153fa007$export$a563da8c932d52b1);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");
const $b73f166b153fa007$export$a563da8c932d52b1 = (0, $1c8Um.print)((0, $5cllN.default)`
	mutation CreateHelpPointer(
		$cloudId: String!
		$description: String
		$icon: IconInput
		$tagUuids: [UUID]
		$link: String!
		$name: String!
		$teamId: String!
		$type: HelpPointerType!
	) {
		createHelpPointer(
			input: {
				cloudId: $cloudId
				description: $description
				icon: $icon
				tagUuids: $tagUuids
				link: $link
				name: $name
				teamId: $teamId
				type: $type
			}
		) {
			helpPointer {
				id
			}
		}
	}
`);

});

parcelRegister("9rfX5", function(module, exports) {

$parcel$export(module.exports, "HelpPointerDeleteMutation", () => $666c98623886084e$export$558c9434019572a1);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");
const $666c98623886084e$export$558c9434019572a1 = (0, $1c8Um.print)((0, $5cllN.default)`
	mutation DeleteHelpPointer($id: ID!) {
		deleteHelpPointer(input: { id: $id }) {
			success
		}
	}
`);

});

parcelRegister("1KerR", function(module, exports) {

$parcel$export(module.exports, "HelpPointerUpdateMutation", () => $32a0765e7f988b7b$export$95b572ae48a37250);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");
const $32a0765e7f988b7b$export$95b572ae48a37250 = (0, $1c8Um.print)((0, $5cllN.default)`
	mutation UpdateHelpPointer(
		$id: ID!
		$description: String
		$teamId: String
		$newTeamName: String
		$icon: IconInput
		$tagUuids: [UUID]
		$link: String
		$name: String
		$type: HelpPointerType
	) {
		updateHelpPointer(
			input: {
				id: $id
				description: $description
				icon: $icon
				tagUuids: $tagUuids
				link: $link
				teamId: $teamId
				newTeamName: $newTeamName
				name: $name
				type: $type
			}
		) {
			helpPointer {
				id
			}
		}
	}
`);

});

parcelRegister("ey2Vf", function(module, exports) {

$parcel$export(module.exports, "KudosDeleteMutation", () => $affb8baa13372318$export$fc4c702e715ad2a4);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");
const $affb8baa13372318$export$fc4c702e715ad2a4 = (0, $1c8Um.print)((0, $5cllN.default)`
	mutation DeleteKudos($id: ID!) {
		deleteKudos(input: { id: $id }) {
			success
			kudos {
				id
			}
		}
	}
`);

});

parcelRegister("h8V8v", function(module, exports) {

$parcel$export(module.exports, "RemoveTeamWatcherMutation", () => $d9ec6e4b42d9aba6$export$d1957676c49feb6a);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");
const $d9ec6e4b42d9aba6$export$d1957676c49feb6a = (0, $1c8Um.print)((0, $5cllN.default)`
	mutation removeTeamWatcher($teamId: String!, $cloudId: String) {
		removeTeamWatcher(input: { teamId: $teamId, cloudId: $cloudId }) {
			isWatching
			__typename
		}
	}
`);

});

parcelRegister("7sahj", function(module, exports) {

$parcel$export(module.exports, "TagListQuery", () => $9c83200124dcc1a5$export$2c592b5c06672873);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");
const $9c83200124dcc1a5$export$2c592b5c06672873 = (0, $1c8Um.print)((0, $5cllN.default)`
	query TagListByCloudId($q: String!, $cloudId: String!, $first: Int) {
		tagSearchByCloudId(q: $q, cloudId: $cloudId, first: $first) {
			edges {
				node {
					id
					uuid
					name
					projects {
						count
					}

					goals {
						count
					}

					helpLinks {
						count
					}
				}
			}
		}
	}
`);

});

parcelRegister("1jHJB", function(module, exports) {

$parcel$export(module.exports, "getTeamCentralGraphqlUrl", () => $b11c2e8c473887f3$export$ada1892306a6b676);
$parcel$export(module.exports, "getUnshardedTeamCentralGraphqlUrl", () => $b11c2e8c473887f3$export$71356c4826ea823a);
const $b11c2e8c473887f3$export$ada1892306a6b676 = (baseUrl, cloudId)=>`${baseUrl}/townsquare/s/${cloudId}/graphql`;
const $b11c2e8c473887f3$export$71356c4826ea823a = (baseUrl)=>`${baseUrl}/watermelon/graphql`;

});


parcelRegister("93qCC", function(module, exports) {

$parcel$export(module.exports, "default", () => $105914cb6e0318f1$export$2e2bcd8739ae039);

var $aOgFy = parcelRequire("aOgFy");

var $hrPaF = parcelRequire("hrPaF");
const $105914cb6e0318f1$var$defaultConfig = {
    serviceUrl: `${(0, $aOgFy.DEFAULT_CONFIG).stargateRoot}/teamsslack/api/team`
};
class $105914cb6e0318f1$export$9509cbc6b0605446 extends (0, $hrPaF.RestClient) {
    constructor(config = {}){
        super({
            ...$105914cb6e0318f1$var$defaultConfig,
            ...config
        });
    }
    async getTeamInSlack(teamId, teamName) {
        return this.getResource(`/${teamId}?teamName=${encodeURIComponent(teamName)}`).then((response)=>({
                id: teamId,
                ...response
            }));
    }
    async disconnectTeamInSlack(teamId) {
        return this.deleteResource(`/${teamId}`).then((response)=>({
                id: teamId,
                ...response
            }));
    }
    async updateTeamInSlack(teamId, channelId, usergroupHandle) {
        return this.postResource(`/${teamId}?channel=${channelId}&groupName=${usergroupHandle}`).then((response)=>({
                id: teamId,
                ...response
            }));
    }
}
var $105914cb6e0318f1$export$2e2bcd8739ae039 = new $105914cb6e0318f1$export$9509cbc6b0605446();

});

parcelRegister("9zuJU", function(module, exports) {

$parcel$export(module.exports, "default", () => $257161ecf26ea5c9$export$2e2bcd8739ae039);

var $aOgFy = parcelRequire("aOgFy");

var $hrPaF = parcelRequire("hrPaF");
const $257161ecf26ea5c9$var$buildGetReadTokenURL = (accountId)=>`/api/user-image/${accountId}/header-image/read`;
class $257161ecf26ea5c9$export$3c27e20d1b94924 extends (0, $hrPaF.RestClient) {
    async getReadMediaToken(accountId) {
        return this.getResource($257161ecf26ea5c9$var$buildGetReadTokenURL(accountId)).then((response)=>response);
    }
    async getWriteMediaToken() {
        return this.getResource('/api/user-image/header-image/write').then((response)=>response);
    }
    async updateUserHeaderImage(headerImageId) {
        return await this.putResource('/api/user-image/self/header-image', {
            headerImageId: headerImageId
        });
    }
}
var $257161ecf26ea5c9$export$2e2bcd8739ae039 = new $257161ecf26ea5c9$export$3c27e20d1b94924({
    serviceUrl: (0, $aOgFy.DEFAULT_CONFIG).stargateRoot
});

});


parcelRegister("ddoT6", function(module, exports) {

$parcel$export(module.exports, "transformPermissions", () => $e6270b31ac69c64a$export$7fe0bfa353103198);
const $e6270b31ac69c64a$export$7fe0bfa353103198 = (permissions)=>{
    return permissions.reduce((acc, permission)=>{
        switch(permission){
            case 'CAN_CREATE_TEAMS':
                return {
                    ...acc,
                    canCreateTeams: true
                };
            case 'CAN_VIEW_TEAMS':
                return {
                    ...acc,
                    canViewTeams: true
                };
            case 'CAN_ADMIN_TEAMS':
                return {
                    ...acc,
                    canAdminTeams: true
                };
            default:
                return acc;
        }
    }, {
        canCreateTeams: false,
        canViewTeams: false,
        canAdminTeams: false
    });
};

});



parcelRegister("5wXDQ", function(module, exports) {

$parcel$export(module.exports, "PeopleMenuOverrides", () => $0d7d2d743503c251$export$c6e6fe52d34907dc);
var $0d7d2d743503c251$export$c6e6fe52d34907dc = /*#__PURE__*/ function(PeopleMenuOverrides) {
    PeopleMenuOverrides["createTeamsDisabled"] = "create-teams-disabled";
    PeopleMenuOverrides["viewTeamsDisabled"] = "view-teams-disabled";
    return PeopleMenuOverrides;
}({});

});



parcelRegister("gQzjM", function(module, exports) {

let $c43ce614c8439318$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c43ce614c8439318$var$load("4B8pt").then(()=>parcelRequire('75dcc'));

});


parcelRegister("hgQ4J", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "TeamPickerEdit", () => $a2ba033eb79fbb50$export$cb5f622bec189851);
$parcel$export(module.exports, "TeamPickerEditEntryPointContent", () => $a2ba033eb79fbb50$export$93a79bad2594cfb5);
$parcel$export(module.exports, "default", () => $a2ba033eb79fbb50$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iM1TE = parcelRequire("iM1TE");

var $hEuz8 = parcelRequire("hEuz8");

var $koVbs = parcelRequire("koVbs");

var $lElIo = parcelRequire("lElIo");

var $14XJw = parcelRequire("14XJw");

var $4R6GH = parcelRequire("4R6GH");


var $4vyX4 = parcelRequire("4vyX4");

var $lWune = parcelRequire("lWune");

var $fAxaP = parcelRequire("fAxaP");
// FIXME: These are overrides for @atlaskit/select@15.6 -> react-select@4.3.x
//        Once @atlaskit/select@15.6 resolution has been removed from package.json
//        these should be removed as well. See PTC-6238.
const $a2ba033eb79fbb50$var$stylesOverrides = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    valueContainer: (base)=>({
            ...base,
            display: 'grid'
        }),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    placeholder: (base)=>({
            ...base,
            position: undefined,
            top: undefined,
            left: undefined,
            transform: undefined
        })
};
const $a2ba033eb79fbb50$export$cb5f622bec189851 = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { siteId: siteId, defaultValue: defaultValue, isClearable: isClearable = true, isDisabled: isDisabled = false, isInvalid: isInvalid = false, autoFocus: autoFocus = false, width: width = '100%', debounceTime: debounceTime = 300, onChange: onChange, placeholder: placeholder = formatMessage((0, $4vyX4.default).placeholderTeamEditSelector), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, styles: styles, noValueText: noValueText, createTeamDialogTrigger: createTeamDialogTrigger, isCompact: isCompact = true, hasNoTeamOption: hasNoTeamOption = true, description: description, ...fieldProps } = props;
    const [isCreateButtonFocused, setIsCreateButtonFocused] = (0, $5uXOq.useState)(false);
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const [hasTeams, setHasTeams] = (0, $5uXOq.useState)(true);
    const formattedNoValueText = formatMessage((0, $4vyX4.default).defaultNoValueText);
    const [updatedPlaceholder, setUpdatedPlaceholder] = (0, $5uXOq.useState)(placeholder);
    const [inputQuery, setInputQuery] = (0, $5uXOq.useState)('');
    const finalStyles = {
        ...(0, $lElIo.defaultSelectStyles),
        ...styles || {},
        ...$a2ba033eb79fbb50$var$stylesOverrides
    };
    const maybeAddNoTeamOption = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'users' implicitly has an 'any' type.
    (users, query)=>{
        setHasTeams(!(users.length === 0 && query.length === 0));
        if (query === '' && !!defaultValue && hasNoTeamOption) return [
            {
                avatarUrl: (0, (/*@__PURE__*/$parcel$interopDefault($hEuz8))),
                id: (0, $7808beff4be6dc7e$export$53782b65600ab96d),
                name: noValueText ?? formattedNoValueText,
                isVerified: false
            }
        ].concat(users);
        setIsCreateButtonFocused(query.length > 0 && users.length === 0);
        return users;
    }, [
        defaultValue,
        noValueText,
        formattedNoValueText,
        hasNoTeamOption
    ]);
    const handleOnChange = (newValue, actionType)=>{
        if (Array.isArray(newValue)) return;
        if (onChange) {
            onChange(newValue?.id === (0, $7808beff4be6dc7e$export$53782b65600ab96d) || !newValue ? null : newValue, actionType);
            setUpdatedPlaceholder(newValue?.id === (0, $7808beff4be6dc7e$export$53782b65600ab96d) || !newValue ? formattedNoValueText : placeholder);
        }
    };
    const handleCreateTeam = (0, $5uXOq.useCallback)(()=>{
        createTeamDialogTrigger(inputQuery);
    }, [
        inputQuery,
        createTeamDialogTrigger
    ]);
    const handleOnKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if (isCreateButtonFocused && event.key === 'Enter') handleCreateTeam();
    }, [
        isCreateButtonFocused,
        handleCreateTeam
    ]);
    const handleOnInputChange = (0, $5uXOq.useCallback)((query)=>{
        setInputQuery(query || '');
    }, [
        setInputQuery
    ]);
    const footer = (0, $5uXOq.useMemo)(()=>hasTeams && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lWune.CreateTeamOption), {
            isFocused: isCreateButtonFocused,
            onClick: handleCreateTeam
        }), [
        hasTeams,
        handleCreateTeam,
        isCreateButtonFocused
    ]);
    const noOptionsMessage = (0, $5uXOq.useMemo)(()=>!hasTeams ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fAxaP.TeamPickerEmptyState), {
                onActionClick: handleCreateTeam
            }) : undefined, [
        hasTeams,
        handleCreateTeam
    ]);
    const menuListStyle = (0, $5uXOq.useMemo)(()=>!hasTeams ? {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            menuList: (base)=>({
                    ...base,
                    maxHeight: '350px'
                })
        } : {}, [
        hasTeams
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iM1TE.default), {
        // Setting width=100% will allow dropdown to size correctly
        width: width,
        autoFocus: autoFocus,
        appearance: isCompact ? 'compact' : 'normal',
        debounceTime: debounceTime,
        fieldId: "team",
        filterOptions: maybeAddNoTeamOption,
        footer: footer,
        includeGroups: false,
        includeTeams: true,
        includeUsers: false,
        isClearable: isClearable,
        isMulti: false,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        productKey: "jira",
        siteId: siteId,
        value: defaultValue,
        onChange: handleOnChange,
        orgId: orgId,
        placeholder: updatedPlaceholder,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        styles: {
            ...finalStyles,
            ...menuListStyle
        },
        onInputChange: handleOnInputChange,
        onKeyDown: handleOnKeyDown,
        noOptionsMessage: noOptionsMessage,
        ariaLabel: (0, $4R6GH.fg)('jfp_a11y_issue_create_form_field_with_description') ? `${updatedPlaceholder} ${description}` : updatedPlaceholder,
        ariaLabelledBy: fieldProps['aria-labelledby'],
        placeholderAvatar: "team"
    });
};
const $a2ba033eb79fbb50$export$93a79bad2594cfb5 = ({ props: props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2ba033eb79fbb50$export$cb5f622bec189851, props);
var $a2ba033eb79fbb50$export$2e2bcd8739ae039 = $a2ba033eb79fbb50$export$cb5f622bec189851;

});
parcelRegister("iM1TE", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b137a2d3db08fbd$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $hOhJj = parcelRequire("hOhJj");

var $lO1N9 = parcelRequire("lO1N9");

var $adPMl = parcelRequire("adPMl");
const $2b137a2d3db08fbd$var$SmartUserPickerWithIntlProvider = (props)=>{
    const ufoId = props.inputId || props.fieldId;
    (0, $adPMl.useUFOConcurrentExperience)((0, $adPMl.smartUserPickerRenderedUfoExperience), ufoId);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $adPMl.UfoErrorBoundary), {
        id: ufoId,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lO1N9.default), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hOhJj.SmartUserPicker), {
                ...props
            })
        })
    });
};
var $2b137a2d3db08fbd$export$2e2bcd8739ae039 = $2b137a2d3db08fbd$var$SmartUserPickerWithIntlProvider;

});
parcelRegister("hOhJj", function(module, exports) {

$parcel$export(module.exports, "SmartUserPicker", () => $04b57dfeec197d1a$export$9eedb6e5d313efdb);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $7Jxgt = parcelRequire("7Jxgt");

var $cb25w = parcelRequire("cb25w");

var $8QpSo = parcelRequire("8QpSo");

var $8RXs9 = parcelRequire("8RXs9");

var $jZA09 = parcelRequire("jZA09");

var $cr0SA = parcelRequire("cr0SA");
var $3smIt = parcelRequire("3smIt");

var $4Mwus = parcelRequire("4Mwus");

var $lO1N9 = parcelRequire("lO1N9");

var $3Q8Js = parcelRequire("3Q8Js");
var $bjnDn = parcelRequire("bjnDn");

var $adPMl = parcelRequire("adPMl");
const $04b57dfeec197d1a$var$DEFAULT_DEBOUNCE_TIME_MS = 150;
const $04b57dfeec197d1a$var$ufoEndStateConfig = (fieldId)=>{
    return {
        metadata: {
            contextType: fieldId
        }
    };
};
const $04b57dfeec197d1a$var$hasContextChanged = (oldContext, newContext)=>oldContext.siteId !== newContext.siteId || oldContext.orgId !== newContext.orgId || oldContext.productKey !== newContext.productKey || oldContext.principalId !== newContext.principalId || oldContext.containerId !== newContext.containerId || oldContext.objectId !== newContext.objectId || oldContext.childObjectId !== newContext.childObjectId;
const $04b57dfeec197d1a$var$stringContains = (str, substr)=>{
    if (str === null || str === undefined) return false;
    if (substr === null || substr === '' || substr === undefined) return true;
    return str.toLowerCase().includes(substr.toLowerCase());
};
const $04b57dfeec197d1a$var$getUsersForAnalytics = (users)=>(users || []).map(({ id: id, type: type })=>({
            id: id,
            type: type
        }));
const $04b57dfeec197d1a$var$checkIf500Event = (statusCode)=>500 <= statusCode && statusCode < 600;
class $04b57dfeec197d1a$export$9b9bd453d1d4e4ce extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            baseUrl: '',
            includeUsers: true,
            includeGroups: false,
            includeTeams: false,
            includeNonLicensedUsers: false,
            prefetch: false,
            principalId: 'Context',
            debounceTime: $04b57dfeec197d1a$var$DEFAULT_DEBOUNCE_TIME_MS
        };
    }
    constructor(props){
        super(props), this.state = {
            users: [],
            loading: false,
            closed: true,
            query: '',
            defaultValue: [],
            bootstrapOptions: []
        }, this.abortOptionsShownUfoExperience = ()=>{
            if (this.optionsShownUfoExperienceInstance.state.id === (0, $jZA09.UFOExperienceState).STARTED.id) // There may be an existing UFO timing running from previous key entry or focus,
            // so abort it and restart it just in case.
            this.optionsShownUfoExperienceInstance.abort();
        }, this.startOptionsShownUfoExperience = ()=>{
            this.abortOptionsShownUfoExperience();
            this.optionsShownUfoExperienceInstance.start();
        }, this.fireEvent = (eventCreator, ...args)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) (0, $4Mwus.createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, ...args))(createAnalyticsEvent);
        }, this.filterOptions = (users, query, propFilterOptions)=>propFilterOptions ? propFilterOptions(users, query) : users, this.memoizedFilterOptions = (0, $8QpSo.default)(this.filterOptions), this.getUsers = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(async ()=>{
            const { query: query, sessionId: sessionId, closed: closed } = this.state;
            const { baseUrl: baseUrl, childObjectId: childObjectId, containerId: containerId, fieldId: fieldId, includeGroups: includeGroups, includeTeams: includeTeams, includeUsers: includeUsers, includeNonLicensedUsers: includeNonLicensedUsers, intl: intl, maxOptions: maxOptions, objectId: objectId, onEmpty: onEmpty, onError: onError, overrideByline: overrideByline, orgId: orgId, principalId: principalId, productAttributes: productAttributes, productKey: productKey, searchQueryFilter: searchQueryFilter, siteId: siteId } = this.props;
            const maxNumberOfResults = maxOptions || 100;
            const startTime = window.performance.now();
            const recommendationsRequest = {
                baseUrl: baseUrl,
                context: {
                    containerId: containerId,
                    contextType: fieldId,
                    objectId: objectId,
                    principalId: principalId,
                    productKey: productKey,
                    siteId: siteId,
                    organizationId: orgId,
                    childObjectId: childObjectId,
                    sessionId: sessionId,
                    productAttributes: productAttributes
                },
                includeUsers: includeUsers,
                includeGroups: includeGroups,
                includeTeams: includeTeams,
                includeNonLicensedUsers: includeNonLicensedUsers,
                maxNumberOfResults: maxNumberOfResults,
                query: query,
                searchQueryFilter: searchQueryFilter
            };
            try {
                this.fireEvent((0, $4Mwus.requestUsersEvent));
                const recommendedUsers = await (0, $3Q8Js.default)(recommendationsRequest, intl);
                if (overrideByline) {
                    for (let option of recommendedUsers)if ((0, $3smIt.isUser)(option) || (0, $3smIt.isExternalUser)(option) || (0, $3smIt.isTeam)(option)) option.byline = overrideByline(option);
                }
                const elapsedTimeMilli = window.performance.now() - startTime;
                const displayedUsers = recommendedUsers.length === 0 && onEmpty ? await onEmpty(query) ?? [] : recommendedUsers;
                this.setState((state)=>{
                    const applicable = state.query === query;
                    const users = applicable ? displayedUsers : state.users;
                    const loading = !applicable;
                    this.fireEvent((0, $4Mwus.successfulRequestUsersEvent), {
                        users: $04b57dfeec197d1a$var$getUsersForAnalytics(recommendedUsers),
                        elapsedTimeMilli: elapsedTimeMilli,
                        displayedUsers: $04b57dfeec197d1a$var$getUsersForAnalytics(displayedUsers),
                        productAttributes: productAttributes,
                        applicable: applicable
                    });
                    return {
                        users: users,
                        loading: loading
                    };
                });
            } catch (e) {
                const is5xxEvent = $04b57dfeec197d1a$var$checkIf500Event(e.statusCode);
                if (!closed && !onError && is5xxEvent) // If the user lookup fails while the menu is open, and the consumer is not providing a
                // fallback data source via the onError prop, then send UFO failure
                this.optionsShownUfoExperienceInstance.failure($04b57dfeec197d1a$var$ufoEndStateConfig(this.props.fieldId));
                this.setState({
                    users: []
                });
                let onErrorProducedError = false;
                let defaultUsers = [];
                try {
                    defaultUsers = onError ? await onError(e, recommendationsRequest) || [] : [];
                } catch (error) {
                    onErrorProducedError = true;
                }
                if (onErrorProducedError && is5xxEvent) // Log error from fallback data source `onError` to UFO
                this.optionsShownUfoExperienceInstance.failure($04b57dfeec197d1a$var$ufoEndStateConfig(this.props.fieldId));
                if (!is5xxEvent && (!onError && !closed || onErrorProducedError)) this.abortOptionsShownUfoExperience();
                this.setState({
                    users: defaultUsers,
                    loading: false
                });
                const elapsedTimeMilli = window.performance.now() - startTime;
                this.fireEvent((0, $4Mwus.failedRequestUsersEvent), {
                    elapsedTimeMilli: elapsedTimeMilli,
                    productAttributes: productAttributes
                });
            }
        }, this.props.debounceTime ?? 0), this.onInputChange = (newQuery, sessionId)=>{
            const query = newQuery || '';
            const { closed: closed } = this.state;
            if (query === this.state.query) return;
            if (!closed) {
                // If the input has been typed into and the dropdown has not been closed
                // (i.e. input blurred) then start the UFO timer.
                // If there's a previous UFO timer running for the same "options shown" experience,
                // it will be aborted first.
                this.startOptionsShownUfoExperience();
                this.setState({
                    loading: true,
                    query: query,
                    sessionId: sessionId
                });
                if (this.props.onInputChange) this.props.onInputChange(query, sessionId);
            }
        }, this.filterUsers = ()=>{
            const { loading: loading, users: users, query: query } = this.state;
            const filteredUsers = this.memoizedFilterOptions(users, query, this.props.filterOptions);
            //If bootstrapOptions have been passed in and it is bootstrap
            if (this.props.bootstrapOptions && this.props.bootstrapOptions.length !== 0 && query === '') {
                const bootstrapFilteredUsers = this.memoizedFilterOptions(this.props.bootstrapOptions, query, this.props.filterOptions);
                this.fireEvent((0, $4Mwus.filterUsersEvent), {
                    filtered: $04b57dfeec197d1a$var$getUsersForAnalytics(bootstrapFilteredUsers),
                    all: $04b57dfeec197d1a$var$getUsersForAnalytics(this.props.bootstrapOptions)
                });
                return bootstrapFilteredUsers;
            }
            // while when not loading just return already filtered result from server.
            if (!loading) return filteredUsers;
            const queryFilteredUsers = filteredUsers.filter((user)=>$04b57dfeec197d1a$var$stringContains(user.name, query));
            this.fireEvent((0, $4Mwus.filterUsersEvent), {
                filtered: $04b57dfeec197d1a$var$getUsersForAnalytics(queryFilteredUsers),
                all: $04b57dfeec197d1a$var$getUsersForAnalytics(users)
            });
            // when loading filter previous result.
            return filteredUsers;
        }, this.onFocus = (sessionId)=>{
            const state = {
                query: '',
                closed: false
            };
            this.startOptionsShownUfoExperience();
            if (this.state.users.length === 0) {
                state.sessionId = sessionId;
                state.loading = true;
            } else this.fireEvent((0, $4Mwus.preparedUsersLoadedEvent), {
                users: $04b57dfeec197d1a$var$getUsersForAnalytics(this.state.users),
                preparedSessionId: this.state.sessionId,
                sessionId: sessionId
            });
            this.setState((currentState)=>({
                    ...currentState,
                    ...state
                }));
            if (this.props.onFocus) this.props.onFocus(sessionId);
        }, this.onBlur = (sessionId)=>{
            this.getUsers.cancel();
            this.abortOptionsShownUfoExperience();
            // clear old users if query is populated so that on refocus,
            // the old list is not shown
            const users = this.state.query.length === 0 ? this.state.users : [];
            this.setState({
                loading: false,
                closed: true,
                users: users
            });
            if (this.props.onBlur) this.props.onBlur(sessionId);
        };
        this.optionsShownUfoExperienceInstance = (0, $adPMl.smartUserPickerOptionsShownUfoExperience).getInstance(props.inputId || props.fieldId);
    }
    async componentDidMount() {
        try {
            const value = await (0, $bjnDn.default)(this.props.baseUrl, this.props.defaultValue, this.props.productKey, this.props.siteId);
            this.setState({
                defaultValue: value
            });
        } catch (e) {
            const defaultValue = await (this.props.onValueError ? this.props.onValueError(e, this.props.defaultValue) || Promise.resolve([]) : Promise.resolve([]));
            this.setState({
                defaultValue: defaultValue
            });
        }
        const { prefetch: prefetch } = this.props;
        if (prefetch) {
            const sessionId = (0, $7Jxgt.v4)();
            this.fireEvent((0, $4Mwus.mountedWithPrefetchEvent), {
                sessionId: sessionId
            });
            this.setState({
                sessionId: sessionId
            });
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if ($04b57dfeec197d1a$var$hasContextChanged(prevProps, this.props) || this.props.fieldId !== prevProps.fieldId) this.setState({
            users: []
        });
        if ((this.state.sessionId !== prevState.sessionId || this.state.query !== prevState.query) && (this.state.query !== '' || !this.props.bootstrapOptions)) this.getUsers();
        else if (!this.state.closed && !this.state.loading) // If the component has rendered (including its dropdown list) and it
        // is not loading anything further, send the success UFO event
        {
            if (![
                (0, $jZA09.UFOExperienceState).FAILED.id,
                (0, $jZA09.UFOExperienceState).SUCCEEDED.id,
                (0, $jZA09.UFOExperienceState).ABORTED.id
            ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success($04b57dfeec197d1a$var$ufoEndStateConfig(this.props.fieldId));
        }
    }
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lO1N9.default), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cr0SA.UserPicker), {
                ...this.props,
                onInputChange: this.onInputChange,
                onBlur: this.onBlur,
                onFocus: this.onFocus,
                defaultValue: this.state.defaultValue,
                isLoading: this.props.isLoading || this.state.loading && !this.state.closed && (!this.props.bootstrapOptions || this.state.query !== ''),
                options: this.filterUsers()
            })
        });
    }
}
const $04b57dfeec197d1a$export$9eedb6e5d313efdb = (0, $cb25w.default)()((0, $8RXs9.default)($04b57dfeec197d1a$export$9b9bd453d1d4e4ce));

});
parcelRegister("cr0SA", function(module, exports) {

$parcel$export(module.exports, "UserPicker", () => $ee13645786fb45b4$export$83e0c73b09b3a9cd);
/* UserPicker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $cb25w = parcelRequire("cb25w");

var $iOwNT = parcelRequire("iOwNT");
var $7K5PP = parcelRequire("7K5PP");

var $jZA09 = parcelRequire("jZA09");

var $5uXOq = parcelRequire("5uXOq");

var $d3gzD = parcelRequire("d3gzD");

var $2wgOn = parcelRequire("2wgOn");

var $dyegP = parcelRequire("dyegP");

var $fuG1P = parcelRequire("fuG1P");

var $hcX3V = parcelRequire("hcX3V");

var $hrO1B = parcelRequire("hrO1B");

var $2vFqP = parcelRequire("2vFqP");

var $pk97C = parcelRequire("pk97C");

var $7Jxgt = parcelRequire("7Jxgt");

var $VSDnB = parcelRequire("VSDnB");
class $ee13645786fb45b4$export$164f4d95e5d7e2f5 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.ufoId = (0, $7Jxgt.v4)();
        const experienceForId = (0, $pk97C.userPickerRenderedUfoExperience).getInstance(this.ufoId);
        if (![
            (0, $jZA09.UFOExperienceState).IN_PROGRESS.id,
            (0, $jZA09.UFOExperienceState).STARTED.id
        ].includes(experienceForId.state.id)) experienceForId.start();
    }
    static{
        this.defaultProps = {
            width: 350,
            isMulti: false
        };
    }
    componentDidMount() {
        const experienceForId = (0, $pk97C.userPickerRenderedUfoExperience).getInstance(this.ufoId);
        // Send UFO success if the experience is still in progress i.e. hasn't failed
        if ([
            (0, $jZA09.UFOExperienceState).IN_PROGRESS.id,
            (0, $jZA09.UFOExperienceState).STARTED.id
        ].includes(experienceForId.state.id)) experienceForId.success();
    }
    render() {
        const { emailLabel: emailLabel, allowEmail: allowEmail, suggestEmailsForDomain: suggestEmailsForDomain, isMulti: isMulti, isValidEmail: isValidEmail, anchor: anchor, menuPortalTarget: menuPortalTarget, menuPosition: menuPosition, menuShouldBlockScroll: menuShouldBlockScroll, captureMenuScroll: captureMenuScroll, closeMenuOnScroll: closeMenuOnScroll, loadUserSource: loadUserSource, required: required = false, showClearIndicator: showClearIndicator = false } = this.props;
        const width = this.props.width;
        const SelectComponent = allowEmail ? (0, $iOwNT.default) : (0, $7K5PP.default);
        const creatableProps = suggestEmailsForDomain ? (0, $hcX3V.getCreatableSuggestedEmailProps)(suggestEmailsForDomain, isValidEmail) : (0, $fuG1P.getCreatableProps)(isValidEmail);
        const defaultPickerProps = {
            closeMenuOnScroll: closeMenuOnScroll,
            menuPortalTarget: menuPortalTarget,
            menuPosition: menuPosition,
            menuShouldBlockScroll: menuShouldBlockScroll,
            captureMenuScroll: captureMenuScroll,
            required: required
        };
        const pickerProps = allowEmail ? {
            ...defaultPickerProps,
            ...creatableProps,
            emailLabel: emailLabel
        } : {
            ...defaultPickerProps
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $pk97C.UfoErrorBoundary), {
            id: this.ufoId,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hrO1B.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2vFqP.ExusUserSourceProvider), {
                    fetchUserSource: loadUserSource,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d3gzD.BaseUserPickerWithoutAnalytics), {
                        ...this.props,
                        forwardedRef: this.props.forwardedRef,
                        width: width,
                        SelectComponent: SelectComponent,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        styles: (0, $2wgOn.getStyles)(width, isMulti, this.props.appearance === 'compact', this.props.styles, this.props.isInvalid, // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                        (0, $VSDnB.fg)('platform-component-visual-refresh')),
                        components: (0, $dyegP.getComponents)(isMulti, anchor, showClearIndicator && (0, $VSDnB.fg)('user-picker-show-clear-indicator'), this.props?.components ? this.props.components : {}),
                        pickerProps: pickerProps
                    })
                })
            })
        });
    }
}
const $ee13645786fb45b4$export$83e0c73b09b3a9cd = (0, $cb25w.default)()($ee13645786fb45b4$export$164f4d95e5d7e2f5);

});
parcelRegister("iOwNT", function(module, exports) {

$parcel$export(module.exports, "default", () => $59b6485f0cb008dd$export$2e2bcd8739ae039);

var $9OU1i = parcelRequire("9OU1i");

var $3c98u = parcelRequire("3c98u");
const $59b6485f0cb008dd$var$CreatableSelect = (0, $3c98u.default)((0, $9OU1i.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$59b6485f0cb008dd$export$2e2bcd8739ae039 = $59b6485f0cb008dd$var$CreatableSelect;

});
parcelRegister("9OU1i", function(module, exports) {

$parcel$export(module.exports, "default", () => $b29f1caecd9c7d5a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useCreatable", () => (parcelRequire("2HH7Y")).default);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2QhWf = parcelRequire("2QhWf");

var $2HH7Y = parcelRequire("2HH7Y");

var $9uJ4X = parcelRequire("9uJ4X");
const $b29f1caecd9c7d5a$var$CreatableSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const creatableProps = (0, $9uJ4X.default)(props);
    const selectProps = (0, $2HH7Y.default)(creatableProps);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2QhWf.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b29f1caecd9c7d5a$export$2e2bcd8739ae039 = $b29f1caecd9c7d5a$var$CreatableSelect;

});
parcelRegister("2HH7Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $994aeb783b6f955a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eEtcC = parcelRequire("eEtcC");

var $gyjU7 = parcelRequire("gyjU7");
const $994aeb783b6f955a$var$compareOption = (inputValue = '', option, accessors)=>{
    const candidate = String(inputValue).toLowerCase();
    const optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    const optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
const $994aeb783b6f955a$var$builtins = {
    formatCreateLabel: (inputValue)=>`Create "${inputValue}"`,
    isValidNewOption: (inputValue, selectValue, selectOptions, accessors)=>!(!inputValue || selectValue.some((option)=>$994aeb783b6f955a$var$compareOption(inputValue, option, accessors)) || selectOptions.some((option)=>$994aeb783b6f955a$var$compareOption(inputValue, option, accessors))),
    getNewOptionData: (inputValue, optionLabel)=>({
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        })
};
function $994aeb783b6f955a$export$2e2bcd8739ae039({ allowCreateWhileLoading: allowCreateWhileLoading = false, createOptionPosition: createOptionPosition = 'last', formatCreateLabel: formatCreateLabel = $994aeb783b6f955a$var$builtins.formatCreateLabel, isValidNewOption: isValidNewOption = $994aeb783b6f955a$var$builtins.isValidNewOption, getNewOptionData: //@ts-ignore
getNewOptionData = $994aeb783b6f955a$var$builtins.getNewOptionData, onCreateOption: onCreateOption, options: propsOptions = [], onChange: propsOnChange, ...restSelectProps }) {
    const { getOptionValue: getOptionValue = (0, $eEtcC.getOptionValue), getOptionLabel: getOptionLabel = (0, $eEtcC.getOptionLabel), inputValue: inputValue, isLoading: isLoading, isMulti: isMulti, value: value, name: name } = restSelectProps;
    const newOption = (0, $5uXOq.useMemo)(()=>isValidNewOption(inputValue, (0, $gyjU7.cleanValue)(value), propsOptions, {
            getOptionValue: getOptionValue,
            getOptionLabel: getOptionLabel
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel,
        getOptionValue,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    const options = (0, $5uXOq.useMemo)(()=>(allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption,
            ...propsOptions
        ] : [
            ...propsOptions,
            newOption
        ] : propsOptions, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    const onChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        const valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                const newOptionData = getNewOptionData(inputValue, inputValue);
                const newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $gyjU7.valueTernary)(isMulti, [
                    ...(0, $gyjU7.cleanValue)(value),
                    newOptionData
                ], newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return {
        ...restSelectProps,
        options: options,
        onChange: onChange
    };
}

});



parcelRegister("d3gzD", function(module, exports) {

$parcel$export(module.exports, "BaseUserPickerWithoutAnalytics", () => $d045e9522a427a64$export$b4ff48c8d43b18c3);

var $2OMIu = parcelRequire("2OMIu");

var $cb25w = parcelRequire("cb25w");

var $VSDnB = parcelRequire("VSDnB");

var $jZA09 = parcelRequire("jZA09");

var $lFKmC = parcelRequire("lFKmC");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $7Jxgt = parcelRequire("7Jxgt");

var $fUmMr = parcelRequire("fUmMr");

var $78Gdn = parcelRequire("78Gdn");

var $8fG8p = parcelRequire("8fG8p");

var $3smIt = parcelRequire("3smIt");

var $01LKK = parcelRequire("01LKK");

var $pk97C = parcelRequire("pk97C");
const $d045e9522a427a64$var$loadingMessage = ()=>null;
const $d045e9522a427a64$var$classNamePrefix = 'fabric-user-picker';
class $d045e9522a427a64$export$b4ff48c8d43b18c3 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            isMulti: false,
            subtle: false,
            noBorder: false,
            textFieldBackgroundColor: false,
            isClearable: true,
            loadOptionsErrorMessage: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $8fG8p.messages).errorMessage
                }),
            openMenuOnClick: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const derivedState = {};
        if (nextProps.isDisabled || nextProps.disableInput) derivedState.menuIsOpen = false;
        if (nextProps.open !== undefined) derivedState.menuIsOpen = nextProps.open;
        if (nextProps.value !== undefined) derivedState.value = (0, $3smIt.optionToSelectableOptions)(nextProps.value);
        else if ((0, $3smIt.isDefaultValuePopulated)(nextProps.defaultValue) && !prevState.isDefaultSet) {
            derivedState.value = (0, $3smIt.optionToSelectableOptions)(nextProps.defaultValue);
            derivedState.isDefaultSet = true;
        }
        if (nextProps.search !== undefined && nextProps.search !== prevState.inputValue) derivedState.inputValue = nextProps.search;
        if (nextProps.options !== undefined) derivedState.options = nextProps.options;
        return derivedState;
    }
    constructor(props){
        super(props), this.getSessionId = ()=>this.session && this.session.id ? this.session.id : undefined, this.withSelectRef = (callback)=>()=>{
                if (this.selectRef) callback(this.selectRef);
            }, this.nextOption = this.withSelectRef((select)=>select.focusOption('down')), this.previousOption = this.withSelectRef((select)=>select.focusOption('up')), this.focus = ()=>{
            if (this.selectRef && this.selectRef.focus) this.selectRef.focus();
        }, this.blur = ()=>{
            if (this.selectRef && this.selectRef.blur) this.selectRef.blur();
        }, this.selectOption = this.withSelectRef((select)=>{
            const focusedOption = select.state.focusedOption;
            select.selectOption(focusedOption);
        }), // value = null if user deletes the last item in the user picker
        this.handleChange = (value, { action: action, removedValue: removedValue, option: option })=>{
            if (removedValue && removedValue.data.fixed) return;
            this.resetInputState();
            const { onChange: onChange, onSelection: onSelection, onClear: onClear, isMulti: isMulti } = this.props;
            (0, $3smIt.callCallback)(onChange, (0, $3smIt.extractOptionValue)(value), action);
            switch(action){
                case 'select-option':
                    if (value) (0, $3smIt.callCallback)(onSelection, (0, $3smIt.extractOptionValue)(value), this.getSessionId(), this);
                    this.fireEvent((0, $fUmMr.selectEvent), isMulti ? option : value);
                    this.session = isMulti ? (0, $fUmMr.startSession)() : undefined;
                    break;
                case 'clear':
                    (0, $3smIt.callCallback)(onClear);
                    this.fireEvent((0, $fUmMr.clearEvent));
                    break;
                case 'remove-value':
                case 'pop-value':
                    if (removedValue) this.fireEvent((0, $fUmMr.deleteEvent), removedValue.data);
                    break;
            }
            this.fireEvent((0, $fUmMr.searchedEvent));
            if (removedValue && this.state.value && Array.isArray(this.state.value)) {
                const remainingValues = this.state.value.filter((val)=>val.data.id !== removedValue.data.id);
                this.setState({
                    value: remainingValues ? remainingValues : [],
                    menuIsOpen: true
                });
            }
            if (!this.props.value) this.setState({
                value: value ? value : []
            });
        }, this.handleSelectRef = (ref)=>{
            this.selectRef = ref;
        }, this.addOptions = (0, $78Gdn.batchByKey)((request, newOptions)=>{
            const { resolving: resolving } = this.state;
            this.setState(({ inflightRequest: inflightRequest, options: options, count: count })=>{
                if (inflightRequest.toString() === request) return {
                    options: (resolving ? options : []).concat(newOptions.reduce((nextOptions, item)=>Array.isArray(item) ? nextOptions.concat(item[0]) : nextOptions.concat(item), [])),
                    count: count - newOptions.length,
                    resolving: count - newOptions.length !== 0
                };
                return null;
            });
        }), this.handleLoadOptionsError = ()=>{
            const { count: count } = this.state;
            const newCount = count - 1;
            const resolving = newCount !== 0;
            let showError = false;
            if (!resolving) showError = true;
            this.setState({
                count: newCount,
                resolving: resolving,
                showError: showError
            });
            this.fireEvent((0, $fUmMr.failedEvent));
        }, this.debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) {
                const inflightRequest = this.state.inflightRequest + 1;
                const result = this.session && this.session.id ? loadOptions(search, this.session.id) : loadOptions(search);
                const addOptions = this.addOptions.bind(this, inflightRequest.toString());
                let count = 0;
                if ((0, $3smIt.isIterable)(result)) for (const value of result){
                    Promise.resolve(value).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                else {
                    Promise.resolve(result).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                this.setState({
                    inflightRequest: inflightRequest,
                    count: count,
                    resolving: count !== 0,
                    options: []
                });
            }
        }, 200), this.abortOptionsShownUfoExperience = ()=>{
            if (this.optionsShownUfoExperienceInstance.state.id === (0, $jZA09.UFOExperienceState).STARTED.id) // There may be an existing UFO timing running from previous key entry or focus,
            // so abort it and restart it just in case.
            this.optionsShownUfoExperienceInstance.abort();
        }, this.startOptionsShownUfoExperience = ()=>{
            this.abortOptionsShownUfoExperience();
            this.optionsShownUfoExperienceInstance.start();
        }, this.executeLoadOptions = (search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) this.setState({
                resolving: true,
                showError: false
            }, ()=>this.debouncedLoadOptions(search));
        }, this.handleFocus = (event)=>{
            const { value: value, menuIsOpen: menuIsOpen } = this.state;
            if (!menuIsOpen || !this.session) this.startSession();
            this.startOptionsShownUfoExperience();
            (0, $3smIt.callCallback)(this.props.onFocus, this.getSessionId());
            if (!this.isMenuOpenOnClickForSingleSelect) {
                this.setState({
                    menuIsOpen: true
                });
                if (!this.props.isMulti && (0, $3smIt.isSingleValue)(value)) {
                    const input = event.target;
                    this.setState({
                        inputValue: value.label
                    }, ()=>{
                        if (input instanceof HTMLInputElement) input.setSelectionRange(0, value.label.length);
                    });
                }
            }
        }, this.resetInputState = ()=>{
            // Prevent filter if query typed, then blurred with no selection
            this.setState({
                inputValue: ''
            });
            (0, $3smIt.callCallback)(this.props.onInputChange, '', this.getSessionId());
        }, this.handleBlur = ()=>{
            (0, $3smIt.callCallback)(this.props.onBlur, this.getSessionId());
            if ((0, $3smIt.isPopupUserPickerByComponent)(this.props.SelectComponent)) return;
            this.resetInputState();
            this.abortOptionsShownUfoExperience();
            this.setState({
                menuIsOpen: false,
                initialFocusHandled: false,
                options: []
            });
        }, this.handleOpen = ()=>{
            (0, $3smIt.callCallback)(this.props.onOpen, this.getSessionId());
            this.setState({
                menuIsOpen: true
            });
        }, this.handleClose = ()=>{
            this.resetInputState();
            (0, $3smIt.callCallback)(this.props.onClose, this.getSessionId());
            this.setState({
                menuIsOpen: false,
                options: []
            });
        }, this.handleInputChange = (search, { action: action })=>{
            if (action === 'input-change' || action === 'set-value') {
                (0, $3smIt.callCallback)(this.props.onInputChange, search, this.getSessionId());
                this.setState({
                    inputValue: search
                });
                this.startOptionsShownUfoExperience();
            }
        }, this.fireEvent = (eventCreator, ...args)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) (0, $fUmMr.createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, this.session, this.journeyId, ...args))(createAnalyticsEvent);
        }, this.startSession = ()=>{
            this.session = (0, $fUmMr.startSession)();
            this.journeyId = this.getSessionId();
            this.fireEvent((0, $fUmMr.focusEvent));
        }, this.handleKeyDown = (event)=>{
            if (!this.isMenuOpenOnClickForSingleSelect) {
                // Escape
                if (event.keyCode === 27) this.blur();
                // Space
                if (event.keyCode === 32 && !this.state.inputValue) {
                    event.preventDefault();
                    !this.props.disableInput && this.setState({
                        inputValue: ' '
                    });
                }
            }
            if (this.session) {
                this.session.lastKey = event.keyCode;
                switch(event.keyCode){
                    // KeyUp 38
                    case 38:
                        this.session.upCount++;
                        break;
                    // KeyDown 40
                    case 40:
                        this.session.downCount++;
                        break;
                }
            }
            this.props.onKeyDown && this.props.onKeyDown(event);
        }, this.handleClearIndicatorHover = (hoveringClearIndicator)=>{
            this.setState({
                hoveringClearIndicator: hoveringClearIndicator
            });
        }, this.getOptions = ()=>{
            const options = (0, $3smIt.getOptions)(this.state.options) || [];
            const { maxOptions: maxOptions, isMulti: isMulti, groupByTypeOrder: groupByTypeOrder } = this.props;
            if (maxOptions === 0) return [];
            if (maxOptions && maxOptions > 0 && maxOptions < options.length) {
                const { value: value } = this.state;
                let filteredOptions = options;
                // Filter out previously selected options
                if (isMulti && Array.isArray(value)) {
                    const valueIds = value.map((item)=>item.data.id);
                    filteredOptions = options.filter((option)=>valueIds.indexOf(option.data.id) === -1);
                }
                return groupByTypeOrder && (0, $VSDnB.fg)('support_group_by_type_for_user_picker') ? (0, $01LKK.groupOptionsByType)(filteredOptions.slice(0, maxOptions), groupByTypeOrder) : filteredOptions.slice(0, maxOptions);
            }
            return groupByTypeOrder && (0, $VSDnB.fg)('support_group_by_type_for_user_picker') ? (0, $01LKK.groupOptionsByType)(options, groupByTypeOrder) : options;
        }, this.getAppearance = ()=>this.props.appearance ? this.props.appearance : 'normal', this.handleClickDraggableParentComponent = ()=>{
            if (this.state.initialFocusHandled) {
                // As <Select /> is already focused, calling this.selectRef.current.focus() again no longer triggers its own handlers (i.e. onMenuOpen, onMenuClose)
                // We have to manually handle the open and close states of the dropdown menu based on a user's click from this point onwards to prevent the bug
                if (this.state.menuIsOpen) this.handleClose();
                else this.handleOpen();
            } else if (!this.state.menuIsOpen && !this.isMenuOpenOnClickForSingleSelect) {
                // Trigger focus state when ValueContainer is clicked for the first time
                // The focused state will then invoke <Select /> instance's own handlers (e.g. onMenuOpen, onMenuClose)
                // to manage the state of the dropdown menu
                this.focus();
                this.setState(()=>({
                        initialFocusHandled: true
                    }));
            }
        };
        this.state = {
            options: [],
            isDefaultSet: false,
            inflightRequest: 0,
            count: 0,
            hoveringClearIndicator: false,
            menuIsOpen: !!this.props.open,
            inputValue: props.search || '',
            resolving: false,
            showError: false,
            initialFocusHandled: false
        };
        this.optionsShownUfoExperienceInstance = (0, $pk97C.userPickerOptionsShownUfoExperience).getInstance((0, $7Jxgt.v4)());
        if (this.props.forwardedRef) {
            const refValue = {
                focus: this.focus,
                blur: this.blur
            };
            if (typeof this.props.forwardedRef === 'function') this.props.forwardedRef(refValue);
            else this.props.forwardedRef.current = refValue;
        }
    }
    get isMenuOpenOnClickForSingleSelect() {
        return this.props.openMenuOnClick && !this.props.isMulti;
    }
    componentDidMount() {
        const { open: open, search: search } = this.props;
        // load options when the picker open
        if (open) {
            if (!this.session) this.startSession();
            this.executeLoadOptions(search);
        }
    }
    componentDidUpdate(_, prevState) {
        const { menuIsOpen: menuIsOpen, options: options, resolving: resolving, count: count, inputValue: inputValue } = this.state;
        // Create a new session when the menu is opened and there is no session
        if (menuIsOpen && !prevState.menuIsOpen && !this.session) this.startSession();
        // Load options when user picker opens or when input value changes
        if (menuIsOpen && !prevState.menuIsOpen || inputValue !== prevState.inputValue) this.executeLoadOptions(inputValue);
        if (!menuIsOpen && prevState.menuIsOpen && this.session) {
            this.fireEvent((0, $fUmMr.cancelEvent), prevState);
            this.session = undefined;
        }
        if (menuIsOpen && (!prevState.menuIsOpen && options.length > 0 || options.length !== prevState.options.length)) this.fireEvent((0, $fUmMr.searchedEvent));
        if (this.state.inputValue !== prevState.inputValue) {
            if (this.session) this.session.inputChangeTime = Date.now();
        }
        if (menuIsOpen && (!_.loadOptions || prevState.menuIsOpen) && count === 0 && !resolving && [
            (0, $jZA09.UFOExperienceState).STARTED.id,
            (0, $jZA09.UFOExperienceState).IN_PROGRESS.id
        ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success();
    }
    get ariaProps() {
        const ariaLabels = Object.keys(this.props).filter((key)=>key.startsWith('aria-'));
        const props = {
            ...this.props
        };
        return ariaLabels.reduce((obj, key)=>({
                ...obj,
                [key]: props[key]
            }), {});
    }
    render() {
        const { isMulti: isMulti, isLoading: isLoading, subtle: subtle, noBorder: noBorder, placeholder: placeholder, isClearable: isClearable, isDisabled: isDisabled, isInvalid: isInvalid, clearValueLabel: clearValueLabel, menuMinWidth: menuMinWidth, menuPortalTarget: menuPortalTarget, loadOptionsErrorMessage: loadOptionsErrorMessage, addMoreMessage: addMoreMessage, noOptionsMessage: noOptionsMessage, footer: footer, disableInput: disableInput, components: components, pickerProps: pickerProps, SelectComponent: SelectComponent, styles: styles, autoFocus: autoFocus, fieldId: fieldId, inputId: inputId, maxPickerHeight: maxPickerHeight, textFieldBackgroundColor: textFieldBackgroundColor, ariaLabelledBy: ariaLabelledBy, ariaDescribedBy: ariaDescribedBy, ariaLive: ariaLive, ariaLabel: ariaLabel, name: name, header: header, required: required, UNSAFE_hasDraggableParentComponent: UNSAFE_hasDraggableParentComponent, placeholderAvatar: placeholderAvatar } = this.props;
        const { count: count, hoveringClearIndicator: hoveringClearIndicator, menuIsOpen: menuIsOpen, value: value, inputValue: inputValue, resolving: resolving, showError: showError } = this.state;
        const appearance = this.getAppearance();
        // these props override the default select menu open and close
        const menuOpenDeciderProps = {
            ...!this.isMenuOpenOnClickForSingleSelect && {
                menuIsOpen: menuIsOpen,
                blurInputOnSelect: !isMulti,
                openMenuOnFocus: true
            }
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)(SelectComponent, {
            name: name,
            value: value,
            autoFocus: autoFocus !== undefined ? autoFocus : menuIsOpen,
            "aria-labelledby": ariaLabelledBy,
            "aria-describedby": ariaDescribedBy,
            "aria-live": ariaLive,
            "aria-required": required,
            required: required,
            ref: this.handleSelectRef,
            isMulti: isMulti,
            options: this.getOptions(),
            styles: styles,
            enableAnimation: isMulti,
            components: components,
            inputValue: inputValue,
            isLoading: count > 0 || resolving || isLoading,
            loadingMessage: $d045e9522a427a64$var$loadingMessage,
            menuPlacement: "auto",
            placeholder: placeholder ?? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $8fG8p.messages).placeholder
            }),
            label: ariaLabel,
            addMoreMessage: addMoreMessage,
            classNamePrefix: $d045e9522a427a64$var$classNamePrefix,
            hoveringClearIndicator: hoveringClearIndicator,
            appearance: appearance,
            isClearable: isClearable,
            noBorder: noBorder,
            subtle: subtle,
            closeMenuOnSelect: !isMulti,
            noOptionsMessage: showError ? loadOptionsErrorMessage : typeof noOptionsMessage === 'function' ? noOptionsMessage : ()=>noOptionsMessage,
            footer: footer,
            isDisabled: isDisabled,
            isInvalid: isInvalid,
            isFocused: menuIsOpen,
            backspaceRemovesValue: isMulti,
            filterOption: null,
            clearValueLabel: clearValueLabel,
            menuMinWidth: menuMinWidth,
            menuPortalTarget: menuPortalTarget,
            disableInput: disableInput || isDisabled,
            instanceId: fieldId,
            inputId: inputId,
            onChange: this.handleChange,
            onMenuOpen: this.handleOpen,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            onMenuClose: this.handleClose,
            onInputChange: this.handleInputChange,
            onClearIndicatorHover: this.handleClearIndicatorHover,
            onKeyDown: this.handleKeyDown,
            maxPickerHeight: maxPickerHeight,
            textFieldBackgroundColor: textFieldBackgroundColor,
            header: header,
            placeholderAvatar: placeholderAvatar,
            ...this.ariaProps,
            ...pickerProps,
            ...UNSAFE_hasDraggableParentComponent && {
                onValueContainerClick: this.handleClickDraggableParentComponent
            },
            ...menuOpenDeciderProps
        });
    }
}
const $d045e9522a427a64$export$d099ade7b4f4d2a4 = (0, $cb25w.default)()($d045e9522a427a64$export$b4ff48c8d43b18c3);

});
parcelRegister("fUmMr", function(module, exports) {

$parcel$export(module.exports, "startSession", () => $e345c0b18a65d683$export$c0d84948cecf78d8);
$parcel$export(module.exports, "createAndFireEventInElementsChannel", () => $e345c0b18a65d683$export$53eef0dcd9611650);
$parcel$export(module.exports, "focusEvent", () => $e345c0b18a65d683$export$e7818c470f37c4bd);
$parcel$export(module.exports, "clearEvent", () => $e345c0b18a65d683$export$7b5800e732182efb);
$parcel$export(module.exports, "deleteEvent", () => $e345c0b18a65d683$export$95711ec6c6227e9a);
$parcel$export(module.exports, "cancelEvent", () => $e345c0b18a65d683$export$e9caaaecfee38128);
$parcel$export(module.exports, "selectEvent", () => $e345c0b18a65d683$export$48143d759475d90f);
$parcel$export(module.exports, "searchedEvent", () => $e345c0b18a65d683$export$911fb7184b6037eb);
$parcel$export(module.exports, "failedEvent", () => $e345c0b18a65d683$export$c2aec355fef65c9c);
$parcel$export(module.exports, "userInfoEvent", () => $e345c0b18a65d683$export$f541f04954b0c11e);

var $gB4mS = parcelRequire("gB4mS");

var $7Jxgt = parcelRequire("7Jxgt");

var $3smIt = parcelRequire("3smIt");
const $e345c0b18a65d683$var$packageName = "platform-pkg";
const $e345c0b18a65d683$var$packageVersion = "0.0.0-use.local";
const $e345c0b18a65d683$var$UUID_REGEXP_TEAMS_GROUPS = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $e345c0b18a65d683$var$UUID_REGEXP_OLD_AAID = /^[a-fA-F0-9]{1,8}:[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $e345c0b18a65d683$var$UUID_REGEXP_NEW_AAID = /^[a-fA-F0-9]{24,24}$/;
const $e345c0b18a65d683$export$c0d84948cecf78d8 = ()=>({
        id: (0, $7Jxgt.v4)(),
        start: Date.now(),
        inputChangeTime: Date.now(),
        upCount: 0,
        downCount: 0,
        lastKey: undefined
    });
const $e345c0b18a65d683$export$53eef0dcd9611650 = (0, $gB4mS.default)('fabric-elements');
const $e345c0b18a65d683$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            packageName: $e345c0b18a65d683$var$packageName,
            packageVersion: $e345c0b18a65d683$var$packageVersion,
            ...attributes
        }
    });
const $e345c0b18a65d683$var$checkValidId = (id)=>{
    return $e345c0b18a65d683$var$UUID_REGEXP_NEW_AAID.test(id) || $e345c0b18a65d683$var$UUID_REGEXP_OLD_AAID.test(id) || $e345c0b18a65d683$var$UUID_REGEXP_TEAMS_GROUPS.test(id);
};
const $e345c0b18a65d683$var$optionData2Analytics = (option)=>{
    const { id: id, type: type } = option;
    // id's of email types are emails which is PII
    const validatedData = {
        id: $e345c0b18a65d683$var$checkValidId(id) ? id : null,
        type: type || null
    };
    if ((0, $3smIt.isExternalUser)(option)) return {
        ...validatedData,
        type: 'external_user',
        sources: option.sources,
        externalUserType: option.externalUserType
    };
    if ((0, $3smIt.isCustom)(option) && option.analyticsType) return {
        ...validatedData,
        type: option.analyticsType
    };
    return validatedData;
};
const $e345c0b18a65d683$var$buildValueForAnalytics = (value)=>{
    if (value) {
        const valueToConvert = Array.isArray(value) ? value : [
            value
        ];
        return valueToConvert.map(({ data: data })=>$e345c0b18a65d683$var$optionData2Analytics(data));
    }
    return [];
};
const $e345c0b18a65d683$var$createDefaultPickerAttributes = (props, session, journeyId)=>({
        context: props.fieldId,
        sessionId: $e345c0b18a65d683$var$sessionId(session),
        pickerType: $e345c0b18a65d683$var$pickerType(props),
        journeyId: journeyId
    });
const $e345c0b18a65d683$export$e7818c470f37c4bd = (props, state, session, journeyId)=>$e345c0b18a65d683$var$createEvent('ui', 'focused', 'userPicker', {
        ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId),
        values: $e345c0b18a65d683$var$buildValueForAnalytics(state.value)
    });
const $e345c0b18a65d683$export$7b5800e732182efb = (props, state, session, journeyId)=>$e345c0b18a65d683$var$createEvent('ui', 'cleared', 'userPicker', {
        ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId),
        pickerOpen: state.menuIsOpen,
        values: $e345c0b18a65d683$var$values(state)
    });
const $e345c0b18a65d683$export$95711ec6c6227e9a = (props, state, session, journeyId, ...args)=>$e345c0b18a65d683$var$createEvent('ui', 'deleted', 'userPickerItem', {
        context: props.fieldId,
        sessionId: $e345c0b18a65d683$var$sessionId(session),
        journeyId: journeyId,
        value: $e345c0b18a65d683$var$optionData2Analytics(args[0]),
        pickerOpen: state.menuIsOpen
    });
const $e345c0b18a65d683$export$e9caaaecfee38128 = (props, _, session, journeyId, ...args)=>$e345c0b18a65d683$var$createEvent('ui', 'cancelled', 'userPicker', {
        ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $e345c0b18a65d683$var$sessionDuration(session),
        queryLength: $e345c0b18a65d683$var$queryLength(args[0]),
        spaceInQuery: $e345c0b18a65d683$var$spaceInQuery(args[0]),
        upKeyCount: $e345c0b18a65d683$var$upKeyCount(session),
        downKeyCount: $e345c0b18a65d683$var$downKeyCount(session)
    });
const $e345c0b18a65d683$export$48143d759475d90f = (props, state, session, journeyId, ...args)=>{
    return $e345c0b18a65d683$var$createEvent('ui', $e345c0b18a65d683$var$selectEventType(session), 'userPicker', {
        ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $e345c0b18a65d683$var$sessionDuration(session),
        position: $e345c0b18a65d683$var$position(state, args[0]),
        queryLength: $e345c0b18a65d683$var$queryLength(state),
        spaceInQuery: $e345c0b18a65d683$var$spaceInQuery(state),
        upKeyCount: $e345c0b18a65d683$var$upKeyCount(session),
        downKeyCount: $e345c0b18a65d683$var$downKeyCount(session),
        result: $e345c0b18a65d683$var$result(args[0]),
        numberOfResults: $e345c0b18a65d683$var$numberOfResults(state)
    });
};
const $e345c0b18a65d683$export$911fb7184b6037eb = (props, state, session, journeyId)=>{
    const searchResults = $e345c0b18a65d683$var$results(state);
    return $e345c0b18a65d683$var$createEvent('operational', 'searched', 'userPicker', {
        ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $e345c0b18a65d683$var$sessionDuration(session),
        durationSinceInputChange: $e345c0b18a65d683$var$durationSinceInputChange(session),
        queryLength: $e345c0b18a65d683$var$queryLength(state),
        isLoading: $e345c0b18a65d683$var$isLoading(props, state),
        results: searchResults,
        numberOfResults: searchResults.length
    });
};
const $e345c0b18a65d683$export$c2aec355fef65c9c = (props, _, session, journeyId)=>$e345c0b18a65d683$var$createEvent('operational', 'failed', 'userPicker', {
        ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId)
    });
const $e345c0b18a65d683$export$f541f04954b0c11e = (sources, accountId)=>$e345c0b18a65d683$var$createEvent('ui', 'displayed', 'userInfo', {
        sources: sources,
        // accountId can be PII if it is an email so check that it's an AAID first
        accountId: $e345c0b18a65d683$var$checkValidId(accountId) ? accountId : null
    });
function $e345c0b18a65d683$var$queryLength(state) {
    return state.inputValue.length;
}
function $e345c0b18a65d683$var$selectEventType(session) {
    return session && session.lastKey === 13 ? 'pressed' : 'clicked';
}
function $e345c0b18a65d683$var$upKeyCount(session) {
    return session ? session.upCount : null;
}
function $e345c0b18a65d683$var$downKeyCount(session) {
    return session ? session.downCount : null;
}
function $e345c0b18a65d683$var$spaceInQuery(state) {
    return state.inputValue.indexOf(' ') !== -1;
}
function $e345c0b18a65d683$var$sessionDuration(session) {
    return session ? Date.now() - session.start : null;
}
function $e345c0b18a65d683$var$durationSinceInputChange(session) {
    return session ? Date.now() - session.inputChangeTime : null;
}
function $e345c0b18a65d683$var$sessionId(session) {
    return session && session.id;
}
function $e345c0b18a65d683$var$position(state, value) {
    return value ? state.options.findIndex((option)=>option === value.data) : -1;
}
function $e345c0b18a65d683$var$pickerType(props) {
    return props.isMulti ? 'multi' : 'single';
}
function $e345c0b18a65d683$var$result(option) {
    return option ? $e345c0b18a65d683$var$optionData2Analytics(option.data) : null;
}
function $e345c0b18a65d683$var$results(state) {
    return (state.options || []).map($e345c0b18a65d683$var$optionData2Analytics);
}
function $e345c0b18a65d683$var$isLoading(props, state) {
    return state.count > 0 || props.isLoading;
}
function $e345c0b18a65d683$var$values(state) {
    return state.value ? Array.isArray(state.value) ? state.value.map((option)=>$e345c0b18a65d683$var$optionData2Analytics(option.data)) : [
        $e345c0b18a65d683$var$optionData2Analytics(state.value.data)
    ] : [];
}
function $e345c0b18a65d683$var$numberOfResults(state) {
    return (state.options || []).length;
}

});
parcelRegister("3smIt", function(module, exports) {

$parcel$export(module.exports, "isExternalUser", () => $02015d62698c11ec$export$f6058dbcb5980cb);
$parcel$export(module.exports, "isUser", () => $02015d62698c11ec$export$2e44165f1da65304);
$parcel$export(module.exports, "isTeam", () => $02015d62698c11ec$export$f8c4277cb588611f);
$parcel$export(module.exports, "isGroup", () => $02015d62698c11ec$export$d7976824e9f55785);
$parcel$export(module.exports, "isEmail", () => $02015d62698c11ec$export$7fbbfbca30081d0);
$parcel$export(module.exports, "isCustom", () => $02015d62698c11ec$export$d3a8f0b77e9737fc);
$parcel$export(module.exports, "isDefaultValuePopulated", () => $02015d62698c11ec$export$d6978985a41b0c8);
$parcel$export(module.exports, "extractOptionValue", () => $02015d62698c11ec$export$7ae97131df521bff);
$parcel$export(module.exports, "isIterable", () => $02015d62698c11ec$export$9652023d9040757);
$parcel$export(module.exports, "getOptions", () => $02015d62698c11ec$export$d2312e68e1f5ad00);
$parcel$export(module.exports, "optionToSelectableOptions", () => $02015d62698c11ec$export$e6fda14a194bcbcc);
$parcel$export(module.exports, "getAvatarSize", () => $02015d62698c11ec$export$695fb564e621339a);
$parcel$export(module.exports, "isChildInput", () => $02015d62698c11ec$export$3c62cf9a01367f27);
$parcel$export(module.exports, "isSingleValue", () => $02015d62698c11ec$export$203c2bd2662d1ca2);
$parcel$export(module.exports, "hasValue", () => $02015d62698c11ec$export$96bdbc84526f3739);
$parcel$export(module.exports, "callCallback", () => $02015d62698c11ec$export$df325aa844b03c31);
$parcel$export(module.exports, "getAvatarUrl", () => $02015d62698c11ec$export$b4f8f1f54acec99b);
$parcel$export(module.exports, "isPopupUserPickerByComponent", () => $02015d62698c11ec$export$4f60a74234178416);
$parcel$export(module.exports, "isLozengeText", () => $02015d62698c11ec$export$5419897287f5f1c7);

var $8QpSo = parcelRequire("8QpSo");


var $b9dFI = parcelRequire("b9dFI");
const $02015d62698c11ec$export$f6058dbcb5980cb = (option)=>option.type === (0, $f93312f7d4958f08$export$50042ec1d2e00e63) || Boolean(option.isExternal);
const $02015d62698c11ec$export$2e44165f1da65304 = (option)=>option.type === undefined || option.type === (0, $f93312f7d4958f08$export$8436e53e45ffe15b);
const $02015d62698c11ec$export$f8c4277cb588611f = (option)=>option.type === (0, $f93312f7d4958f08$export$26bc40b960693765);
const $02015d62698c11ec$export$d7976824e9f55785 = (option)=>option.type === (0, $f93312f7d4958f08$export$d460f747b73abb10);
const $02015d62698c11ec$export$7fbbfbca30081d0 = (option)=>option.type === (0, $f93312f7d4958f08$export$6662b3461398ef8c);
const $02015d62698c11ec$export$d3a8f0b77e9737fc = (option)=>option.type === (0, $f93312f7d4958f08$export$eafd0979afa5b224);
const $02015d62698c11ec$export$d6978985a41b0c8 = (value)=>value && !Array.isArray(value) || Array.isArray(value) && value.length > 0;
const $02015d62698c11ec$var$isOptionData = (option)=>option.name !== undefined;
const $02015d62698c11ec$export$3f993c492bd6c728 = (option)=>{
    if ($02015d62698c11ec$var$isOptionData(option)) return {
        data: option,
        isDisabled: option.isDisabled,
        label: option.name,
        value: option.id
    };
    else return {
        data: {
            ...option,
            name: option.id
        },
        isDisabled: option.isDisabled,
        label: option.id,
        value: option.id
    };
};
const $02015d62698c11ec$export$7ae97131df521bff = (value)=>{
    if (!value) return undefined;
    if (Array.isArray(value)) return value.map(({ data: option })=>option);
    return value.data;
};
const $02015d62698c11ec$export$9652023d9040757 = (a)=>typeof a?.[Symbol.iterator] === 'function';
const $02015d62698c11ec$export$d2312e68e1f5ad00 = (0, $8QpSo.default)((options)=>options.map($02015d62698c11ec$export$3f993c492bd6c728));
const $02015d62698c11ec$export$e6fda14a194bcbcc = (0, $8QpSo.default)((defaultValue)=>{
    if (!defaultValue) return null;
    if (Array.isArray(defaultValue)) return defaultValue.map($02015d62698c11ec$export$3f993c492bd6c728);
    return $02015d62698c11ec$export$3f993c492bd6c728(defaultValue);
});
const $02015d62698c11ec$export$695fb564e621339a = (appearance)=>appearance === 'big' ? 'medium' : appearance === 'multi' ? 'xsmall' : 'small';
const $02015d62698c11ec$export$3c62cf9a01367f27 = (child)=>child && typeof child === 'object' && child.props && child.props.type === 'text';
const $02015d62698c11ec$export$203c2bd2662d1ca2 = (value)=>!!value && !Array.isArray(value);
const $02015d62698c11ec$export$96bdbc84526f3739 = (value)=>!!value && value.trim().length > 0;
const $02015d62698c11ec$export$df325aa844b03c31 = (callback, ...args)=>{
    if (typeof callback === 'function') try {
        //  there is mystery error in IE 11, so we need this try-catch
        return callback(...args);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('@atlassian/user-select: an error happening in `callCallback`: ', error);
    }
};
const $02015d62698c11ec$export$b4f8f1f54acec99b = (optionData)=>{
    if ($02015d62698c11ec$export$2e44165f1da65304(optionData) || $02015d62698c11ec$export$f8c4277cb588611f(optionData) || $02015d62698c11ec$export$d3a8f0b77e9737fc(optionData)) return optionData.avatarUrl;
    return undefined;
};
const $02015d62698c11ec$export$4f60a74234178416 = (SelectComponent)=>SelectComponent === (0, $b9dFI.default);
const $02015d62698c11ec$export$7add003953ca6733 = (selectProps)=>selectProps.searchThreshold === -1;
const $02015d62698c11ec$export$5419897287f5f1c7 = (lozengeProp)=>{
    return lozengeProp?.hasOwnProperty('text') || false;
};

});
const $f93312f7d4958f08$export$8436e53e45ffe15b = 'user';
const $f93312f7d4958f08$export$50042ec1d2e00e63 = 'external_user';
const $f93312f7d4958f08$export$26bc40b960693765 = 'team';
const $f93312f7d4958f08$export$d460f747b73abb10 = 'group';
const $f93312f7d4958f08$export$6662b3461398ef8c = 'email';
const $f93312f7d4958f08$export$eafd0979afa5b224 = 'custom';

parcelRegister("b9dFI", function(module, exports) {

$parcel$export(module.exports, "default", () => $768d8504b373d7ff$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $7nsd3 = parcelRequire("7nsd3");

var $ao4Ml = parcelRequire("ao4Ml");

var $5n5w4 = parcelRequire("5n5w4");
var $283js = parcelRequire("283js");
var $iGDLS = parcelRequire("iGDLS");

var $4wJSY = parcelRequire("4wJSY");

var $9KnKW = parcelRequire("9KnKW");

var $7VXAu = parcelRequire("7VXAu");


var $7K5PP = parcelRequire("7K5PP");

var $hT6ku = parcelRequire("hT6ku");

var $9DWu0 = parcelRequire("9DWu0");
/**
 * Are we rendering on the client or server?
 */ const $768d8504b373d7ff$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
// ==============================
// Class
// ==============================
const $768d8504b373d7ff$var$modifiers = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                8
            ]
        }
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: 5,
            boundary: 'clippingParents',
            altAxis: true,
            altBoundary: true
        }
    }
];
const $768d8504b373d7ff$var$defaultPopperProps = {
    modifiers: $768d8504b373d7ff$var$modifiers,
    placement: 'bottom-start'
};
const $768d8504b373d7ff$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
class $768d8504b373d7ff$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            closeMenuOnSelect: true,
            shouldCloseMenuOnTab: true,
            components: {},
            maxMenuHeight: 300,
            maxMenuWidth: 440,
            minMenuWidth: 220,
            popperProps: {},
            isSearchable: true,
            searchThreshold: 5,
            styles: {},
            options: []
        };
    }
    static getDerivedStateFromProps(props, state) {
        const newState = {};
        // Merge consumer and default popper props
        const mergedPopperProps = {
            ...$768d8504b373d7ff$var$defaultPopperProps,
            ...props.popperProps
        };
        if (!(0, $4wJSY.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
        // Merge consumer and default components
        const mergedComponents = {
            ...(0, $hT6ku.defaultComponents),
            ...props.components
        };
        if (!(0, $4wJSY.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
        if (!$768d8504b373d7ff$var$isEmpty(newState)) return newState;
        return null;
    }
    componentDidMount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick = (0, $cBeZP.bind)(window, {
            type: 'click',
            listener: this.handleClick,
            options: {
                capture: true
            }
        });
    }
    componentWillUnmount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick?.();
        this.unbindWindowClick = null;
        this.unbindWindowKeydown?.();
        this.unbindWindowKeydown = null;
    }
    componentDidUpdate(prevProps) {
        const { isOpen: isOpen } = this.props;
        if (prevProps.isOpen !== isOpen) {
            if (isOpen === true) this.open({
                controlOverride: true
            });
            else if (isOpen === false) this.close({
                controlOverride: true
            });
        }
    }
    render() {
        const { target: target } = this.props;
        const { isOpen: isOpen } = this.state;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5n5w4.Manager), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9KnKW.IdProvider), {
                    postfix: "-popup-select",
                    children: ({ id: id })=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iGDLS.Reference), {
                                    children: ({ ref: ref })=>target && target({
                                            isOpen: isOpen,
                                            onKeyDown: this.handleTargetKeyDown,
                                            ref: this.resolveTargetRef(ref),
                                            // Should technically be 'dialog' by default instead of 'true' via AriaAttributes, but will require further changes.
                                            // See go/DSP-22283
                                            'aria-haspopup': 'true',
                                            'aria-expanded': isOpen,
                                            'aria-controls': isOpen ? id : undefined
                                        })
                                }),
                                this.renderSelect(id)
                            ]
                        })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9DWu0.NotifyOpenLayerObserver), {
                    isOpen: this.state.isOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.menuRef = null, this.selectRef = null, this.targetRef = null, this.unbindWindowClick = null, this.unbindWindowKeydown = null, this.defaultStyles = {
            groupHeading: (provided)=>({
                    ...provided,
                    color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$eaa8c8a70ac22806})`
                })
        }, this.isOpenControlled = this.props.isOpen !== undefined, this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen, this.state = {
            focusLockEnabled: false,
            isOpen: this.defaultOpenState ?? false,
            mergedComponents: (0, $hT6ku.defaultComponents),
            mergedPopperProps: $768d8504b373d7ff$var$defaultPopperProps
        }, // Event Handlers
        // ==============================
        this.handleTargetKeyDown = (event)=>{
            switch(event.key){
                case 'ArrowDown':
                    this.open();
                    break;
                default:
            }
        }, this.handleKeyDown = (event)=>{
            //We shouldn't close PopupSelect on tab event if there are custom interactive element.
            const tabEvent = event.key === 'Tab' && event.shiftKey || event.key === 'Tab';
            if (this.props.shouldCloseMenuOnTab && tabEvent) this.close();
            switch(event.key){
                case 'Escape':
                case 'Esc':
                    this.close();
                    break;
                default:
            }
            if (this.props.onKeyDown) /* @ts-ignore - updating type of event React.KeyboardEvent effects the unbindWindowsKeyDown listener. Check if this can be fixed once the component gets refactor to functional */ this.props.onKeyDown(event);
        }, this.handleClick = ({ target: target })=>{
            const { isOpen: isOpen } = this.state;
            // appease flow
            if (!(target instanceof Element)) return;
            // NOTE: Why not use the <Blanket /> component to close?
            // We don't want to interupt the user's flow. Taking this approach allows
            // user to click "through" to other elements and close the popout.
            if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
            // open on target click -- we can't trust consumers to spread the onClick
            // property to the target
            if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
        }, this.handleSelectChange = (value, actionMeta)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
            if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
            if (onChange) onChange(value, actionMeta);
        }, this.handleFirstPopperUpdate = ()=>{
            // When the popup opens it's focused into. Since the popup is inside a portal, it's position is
            // initially set to 0,0 - this causes the window scroll position to jump to the top. To prevent
            // this we defer enabling the focus-lock until after Popper has positioned the popup the first time.
            this.setState({
                focusLockEnabled: true
            });
        }, // Internal Lifecycle
        // ==============================
        /**
   * Opens the popup
   *
   * @param options.controlOverride  - Force the popup to open when it's open state is being controlled
   */ this.open = (options)=>{
            const { onOpen: onOpen, onMenuOpen: onMenuOpen } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup opening if it's open state is already being controlled
            return;
            if (onOpen) onOpen();
            if (onMenuOpen) onMenuOpen();
            this.setState({
                isOpen: true
            }, ()=>{
                if (this.selectRef) this.selectRef.select?.openMenu('first');
            });
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown = (0, $cBeZP.bind)(window, {
                type: 'keydown',
                listener: this.handleKeyDown,
                options: {
                    capture: true
                }
            });
        }, /**
   * Closes the popup
   *
   * @param options.controlOverride  - Force the popup to close when it's open state is being controlled
   */ this.close = (options)=>{
            //@ts-ignore react-select unsupported props
            const { onClose: onClose, onMenuClose: onMenuClose } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup closing if it's open state is already being controlled
            return;
            if (onClose) onClose();
            if (onMenuClose) onMenuClose();
            this.setState({
                isOpen: false
            });
            this.setState({
                focusLockEnabled: false
            });
            if (this.targetRef != null) this.targetRef.focus();
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        }, // Refs
        // ==============================
        this.resolveTargetRef = (popperRef)=>(ref)=>{
                // avoid thrashing fn calls
                if (!this.targetRef && popperRef && ref) {
                    this.targetRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                }
            }, this.resolveMenuRef = (popperRef)=>(ref)=>{
                this.menuRef = ref;
                if (typeof popperRef === 'function') popperRef(ref);
                else popperRef.current = ref;
            }, this.getSelectRef = (ref)=>{
            this.selectRef = ref;
        }, // Utils
        // ==============================
        // account for groups when counting options
        // this may need to be recursive, right now it just counts one level
        this.getItemCount = ()=>{
            const { options: options } = this.props;
            let count = 0;
            options.forEach((groupOrOption)=>{
                if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                else count++;
            });
            return count;
        }, this.getMaxHeight = ()=>{
            const { maxMenuHeight: maxMenuHeight } = this.props;
            if (!this.selectRef) return maxMenuHeight;
            // subtract the control height to maintain consistency
            const showSearchControl = this.showSearchControl();
            const controlRef = this.selectRef.select?.controlRef;
            const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
            const maxHeight = maxMenuHeight - offsetHeight;
            return maxHeight;
        }, // if the threshold is exceeded, AND isSearchable is true, then display the search control
        this.showSearchControl = ()=>{
            const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
            return isSearchable && this.getItemCount() > searchThreshold;
        }, // Renderers
        // ==============================
        this.renderSelect = (id)=>{
            const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: target, testId: testId, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, ...props } = this.props;
            const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
            const showSearchControl = this.showSearchControl();
            const portalDestination = $768d8504b373d7ff$var$canUseDOM() ? document.body : null;
            if (!portalDestination || !isOpen) return null;
            const selectComponents = {
                ...mergedComponents,
                Control: showSearchControl ? mergedComponents.Control : (0, $hT6ku.DummyControl)
            };
            const getLabel = ()=>{
                if (label) return label;
                else if (typeof placeholder === 'string') return placeholder;
            };
            const popper = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $283js.Popper), {
                ...mergedPopperProps,
                onFirstUpdate: (state)=>{
                    this.handleFirstPopperUpdate();
                    mergedPopperProps.onFirstUpdate?.(state);
                },
                children: ({ placement: placement, ref: ref, style: style })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $hT6ku.MenuDialog), {
                        // There is not a limited amount of values for the widths, so they need to remain dynamic.
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        style: {
                            ...style,
                            maxWidth: maxMenuWidth,
                            minWidth: minMenuWidth
                        },
                        "data-placement": placement,
                        id: id,
                        testId: testId,
                        ref: this.resolveMenuRef(ref),
                        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $ao4Ml.default), {
                            disabled: !focusLockEnabled,
                            returnFocus: true,
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7K5PP.default), {
                                    label: getLabel(),
                                    backspaceRemovesValue: false,
                                    controlShouldRenderValue: false,
                                    isClearable: false,
                                    tabSelectsValue: false,
                                    menuIsOpen: true,
                                    placeholder: placeholder,
                                    ref: this.getSelectRef,
                                    ...props,
                                    isSearchable: showSearchControl,
                                    styles: (0, $7VXAu.mergeStyles)(this.defaultStyles, props.styles || {}),
                                    maxMenuHeight: this.getMaxHeight(),
                                    components: selectComponents,
                                    onChange: this.handleSelectChange,
                                    testId: testId
                                }),
                                footer
                            ]
                        })
                    })
            });
            return mergedPopperProps.strategy === 'fixed' ? popper : /*#__PURE__*/ (0, $7nsd3.createPortal)(popper, portalDestination);
        }, this.handleOpenLayerObserverCloseSignal = ()=>{
            this.close();
        };
    }
}

});
parcelRegister("5n5w4", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $3e93612641040812$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $3e93612641040812$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $3e93612641040812$export$d0d38e7dec7a1a61);

var $5uXOq = parcelRequire("5uXOq");
var $3e93612641040812$export$3dbd3405086fec7b = $5uXOq.createContext();
var $3e93612641040812$export$cbabb21c2529b130 = $5uXOq.createContext();
function $3e93612641040812$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $5uXOq.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $5uXOq.useRef(false);
    $5uXOq.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $5uXOq.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $5uXOq.createElement($3e93612641040812$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $5uXOq.createElement($3e93612641040812$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("283js", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $18cee5f949ac4034$export$badac9ada3a0bdf9);

var $5uXOq = parcelRequire("5uXOq");

var $5n5w4 = parcelRequire("5n5w4");

var $eclLw = parcelRequire("eclLw");

var $fNOWl = parcelRequire("fNOWl");
var $18cee5f949ac4034$var$NOOP = function NOOP() {
    return void 0;
};
var $18cee5f949ac4034$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $18cee5f949ac4034$var$EMPTY_MODIFIERS = [];
function $18cee5f949ac4034$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $18cee5f949ac4034$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $5uXOq.useContext((0, $5n5w4.ManagerReferenceNodeContext));
    var _React$useState = $5uXOq.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $5uXOq.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $5uXOq.useEffect(function() {
        (0, $eclLw.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $5uXOq.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $fNOWl.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $5uXOq.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $18cee5f949ac4034$var$NOOP,
            update: update || $18cee5f949ac4034$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $eclLw.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("eclLw", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", () => $a56311d537d20f47$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $a56311d537d20f47$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $a56311d537d20f47$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $a56311d537d20f47$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $a56311d537d20f47$export$700979bc83e7db82);

var $5uXOq = parcelRequire("5uXOq");
var $a56311d537d20f47$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $a56311d537d20f47$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $a56311d537d20f47$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $a56311d537d20f47$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $a56311d537d20f47$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $a56311d537d20f47$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $5uXOq.useLayoutEffect : $5uXOq.useEffect;

});

parcelRegister("fNOWl", function(module, exports) {

$parcel$export(module.exports, "usePopper", () => $b812f23d0bbb9e85$export$f4d5bf230a36dd6e);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $8Pv9O = parcelRequire("8Pv9O");

var $lHrkK = parcelRequire("lHrkK");

var $eclLw = parcelRequire("eclLw");
var $b812f23d0bbb9e85$var$EMPTY_MODIFIERS = [];
var $b812f23d0bbb9e85$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $5uXOq.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $b812f23d0bbb9e85$var$EMPTY_MODIFIERS
    };
    var _React$useState = $5uXOq.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $5uXOq.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $7nsd3.flushSync(function() {
                    setState({
                        styles: (0, $eclLw.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $eclLw.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $5uXOq.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($lHrkK)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $5uXOq.useRef();
    (0, $eclLw.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $eclLw.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $8Pv9O.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("8Pv9O", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $66db415bc009fd50$export$8f7491d57c8f97a9);

var $dsn8Y = parcelRequire("dsn8Y");

var $4TVC8 = parcelRequire("4TVC8");

var $j8nKB = parcelRequire("j8nKB");

var $baic6 = parcelRequire("baic6");

var $1AoLg = parcelRequire("1AoLg");

var $gy4Xr = parcelRequire("gy4Xr");

var $3dDWl = parcelRequire("3dDWl");

var $1DdSC = parcelRequire("1DdSC");

var $gzAfz = parcelRequire("gzAfz");

var $6iLAT = parcelRequire("6iLAT");


var $66db415bc009fd50$export$d34966752335dd47 = [
    (0, $4TVC8.default),
    (0, $j8nKB.default),
    (0, $baic6.default),
    (0, $1AoLg.default),
    (0, $gy4Xr.default),
    (0, $3dDWl.default),
    (0, $1DdSC.default),
    (0, $gzAfz.default),
    (0, $6iLAT.default)
];
var $66db415bc009fd50$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $dsn8Y.popperGenerator)({
    defaultModifiers: $66db415bc009fd50$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("dsn8Y", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $9cbfd7bdb6a4f3f1$export$ed5e13716264f202);

var $gvlia = parcelRequire("gvlia");

var $jkGDj = parcelRequire("jkGDj");

var $2r6BH = parcelRequire("2r6BH");

var $gbHJy = parcelRequire("gbHJy");

var $kcmIg = parcelRequire("kcmIg");

var $a8clb = parcelRequire("a8clb");

var $i9xH7 = parcelRequire("i9xH7");


var $gmkfg = parcelRequire("gmkfg");
var $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $9cbfd7bdb6a4f3f1$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $9cbfd7bdb6a4f3f1$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $gmkfg.isElement)(reference) ? (0, $2r6BH.default)(reference) : reference.contextElement ? (0, $2r6BH.default)(reference.contextElement) : [],
                    popper: (0, $2r6BH.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $kcmIg.default)((0, $i9xH7.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$9cbfd7bdb6a4f3f1$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $gvlia.default)(reference, (0, $gbHJy.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $jkGDj.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $a8clb.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$9cbfd7bdb6a4f3f1$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $9cbfd7bdb6a4f3f1$export$8f7491d57c8f97a9 = /*#__PURE__*/ $9cbfd7bdb6a4f3f1$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("gvlia", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0400ebb908e52cb$export$2e2bcd8739ae039);

var $g2O7Z = parcelRequire("g2O7Z");

var $9FFjG = parcelRequire("9FFjG");

var $f5IBt = parcelRequire("f5IBt");

var $gmkfg = parcelRequire("gmkfg");

var $imzt5 = parcelRequire("imzt5");

var $eVELE = parcelRequire("eVELE");

var $c6EdA = parcelRequire("c6EdA");

var $90xPK = parcelRequire("90xPK");
function $c0400ebb908e52cb$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $90xPK.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $90xPK.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $c0400ebb908e52cb$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $gmkfg.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $gmkfg.isHTMLElement)(offsetParent) && $c0400ebb908e52cb$var$isElementScaled(offsetParent);
    var documentElement = (0, $eVELE.default)(offsetParent);
    var rect = (0, $g2O7Z.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $f5IBt.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $c6EdA.default)(documentElement)) scroll = (0, $9FFjG.default)(offsetParent);
        if ((0, $gmkfg.isHTMLElement)(offsetParent)) {
            offsets = (0, $g2O7Z.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $imzt5.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("g2O7Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $bae3b796a534b2cf$export$2e2bcd8739ae039);

var $gmkfg = parcelRequire("gmkfg");

var $90xPK = parcelRequire("90xPK");

var $1Prpe = parcelRequire("1Prpe");

var $d8bsQ = parcelRequire("d8bsQ");
function $bae3b796a534b2cf$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $gmkfg.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $90xPK.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $90xPK.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $gmkfg.isElement)(element) ? (0, $1Prpe.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $d8bsQ.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("gmkfg", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $be8e67adfa808002$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $be8e67adfa808002$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $be8e67adfa808002$export$af51f0f06c0f328a);

var $1Prpe = parcelRequire("1Prpe");
function $be8e67adfa808002$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $1Prpe.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $be8e67adfa808002$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $1Prpe.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $be8e67adfa808002$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $1Prpe.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("1Prpe", function(module, exports) {

$parcel$export(module.exports, "default", () => $154fd01b154b825f$export$2e2bcd8739ae039);
function $154fd01b154b825f$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("90xPK", function(module, exports) {

$parcel$export(module.exports, "max", () => $68ee5bce69e9df7e$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $68ee5bce69e9df7e$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $68ee5bce69e9df7e$export$2077e0241d6afd3c);
var $68ee5bce69e9df7e$export$8960430cfd85939f = Math.max;
var $68ee5bce69e9df7e$export$96ec731ed4dcb222 = Math.min;
var $68ee5bce69e9df7e$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("d8bsQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $98f4ea48bb7f7060$export$2e2bcd8739ae039);

var $j5Xhq = parcelRequire("j5Xhq");
function $98f4ea48bb7f7060$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $j5Xhq.default)());
}

});
parcelRegister("j5Xhq", function(module, exports) {

$parcel$export(module.exports, "default", () => $de6c77c242bcf4cf$export$2e2bcd8739ae039);
function $de6c77c242bcf4cf$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("9FFjG", function(module, exports) {

$parcel$export(module.exports, "default", () => $70a7fdf85bb2e8b8$export$2e2bcd8739ae039);

var $8YTLN = parcelRequire("8YTLN");

var $1Prpe = parcelRequire("1Prpe");

var $gmkfg = parcelRequire("gmkfg");

var $i1ad3 = parcelRequire("i1ad3");
function $70a7fdf85bb2e8b8$export$2e2bcd8739ae039(node) {
    if (node === (0, $1Prpe.default)(node) || !(0, $gmkfg.isHTMLElement)(node)) return (0, $8YTLN.default)(node);
    else return (0, $i1ad3.default)(node);
}

});
parcelRegister("8YTLN", function(module, exports) {

$parcel$export(module.exports, "default", () => $689f300ec0defb42$export$2e2bcd8739ae039);

var $1Prpe = parcelRequire("1Prpe");
function $689f300ec0defb42$export$2e2bcd8739ae039(node) {
    var win = (0, $1Prpe.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("i1ad3", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1e03d69dfb9832f$export$2e2bcd8739ae039);
function $d1e03d69dfb9832f$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("f5IBt", function(module, exports) {

$parcel$export(module.exports, "default", () => $afc9ebf0aa1487e4$export$2e2bcd8739ae039);
function $afc9ebf0aa1487e4$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("imzt5", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5e5cb506db8cdcb$export$2e2bcd8739ae039);

var $g2O7Z = parcelRequire("g2O7Z");

var $eVELE = parcelRequire("eVELE");

var $8YTLN = parcelRequire("8YTLN");
function $d5e5cb506db8cdcb$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $g2O7Z.default)((0, $eVELE.default)(element)).left + (0, $8YTLN.default)(element).scrollLeft;
}

});
parcelRegister("eVELE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ade6032ba4b824fe$export$2e2bcd8739ae039);

var $gmkfg = parcelRequire("gmkfg");
function $ade6032ba4b824fe$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $gmkfg.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("c6EdA", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d053e13cecc73ee$export$2e2bcd8739ae039);

var $1ix2F = parcelRequire("1ix2F");
function $8d053e13cecc73ee$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $1ix2F.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("1ix2F", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f211a5db2cb1d1b$export$2e2bcd8739ae039);

var $1Prpe = parcelRequire("1Prpe");
function $0f211a5db2cb1d1b$export$2e2bcd8739ae039(element) {
    return (0, $1Prpe.default)(element).getComputedStyle(element);
}

});



parcelRegister("jkGDj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e130f49f6e9ebcb4$export$2e2bcd8739ae039);

var $g2O7Z = parcelRequire("g2O7Z");
function $e130f49f6e9ebcb4$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $g2O7Z.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("2r6BH", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c633a6ac170841a$export$2e2bcd8739ae039);

var $k82dT = parcelRequire("k82dT");

var $eTUzl = parcelRequire("eTUzl");

var $1Prpe = parcelRequire("1Prpe");

var $c6EdA = parcelRequire("c6EdA");
function $1c633a6ac170841a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $k82dT.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $1Prpe.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $c6EdA.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($1c633a6ac170841a$export$2e2bcd8739ae039((0, $eTUzl.default)(target)));
}

});
parcelRegister("k82dT", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea7647704a508683$export$2e2bcd8739ae039);

var $eTUzl = parcelRequire("eTUzl");

var $c6EdA = parcelRequire("c6EdA");

var $f5IBt = parcelRequire("f5IBt");

var $gmkfg = parcelRequire("gmkfg");
function $ea7647704a508683$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $f5IBt.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $gmkfg.isHTMLElement)(node) && (0, $c6EdA.default)(node)) return node;
    return $ea7647704a508683$export$2e2bcd8739ae039((0, $eTUzl.default)(node));
}

});
parcelRegister("eTUzl", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad921528f26834dd$export$2e2bcd8739ae039);

var $f5IBt = parcelRequire("f5IBt");

var $eVELE = parcelRequire("eVELE");

var $gmkfg = parcelRequire("gmkfg");
function $ad921528f26834dd$export$2e2bcd8739ae039(element) {
    if ((0, $f5IBt.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $gmkfg.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $eVELE.default)(element) // fallback
    );
}

});



parcelRegister("gbHJy", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc8f9908a1e4106f$export$2e2bcd8739ae039);

var $1Prpe = parcelRequire("1Prpe");

var $f5IBt = parcelRequire("f5IBt");

var $1ix2F = parcelRequire("1ix2F");

var $gmkfg = parcelRequire("gmkfg");

var $6hs9X = parcelRequire("6hs9X");

var $eTUzl = parcelRequire("eTUzl");

var $j5Xhq = parcelRequire("j5Xhq");
function $bc8f9908a1e4106f$var$getTrueOffsetParent(element) {
    if (!(0, $gmkfg.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $1ix2F.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $bc8f9908a1e4106f$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $j5Xhq.default)());
    var isIE = /Trident/i.test((0, $j5Xhq.default)());
    if (isIE && (0, $gmkfg.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $1ix2F.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $eTUzl.default)(element);
    if ((0, $gmkfg.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $gmkfg.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $f5IBt.default)(currentNode)) < 0){
        var css = (0, $1ix2F.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $bc8f9908a1e4106f$export$2e2bcd8739ae039(element) {
    var window = (0, $1Prpe.default)(element);
    var offsetParent = $bc8f9908a1e4106f$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $6hs9X.default)(offsetParent) && (0, $1ix2F.default)(offsetParent).position === 'static')offsetParent = $bc8f9908a1e4106f$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $f5IBt.default)(offsetParent) === 'html' || (0, $f5IBt.default)(offsetParent) === 'body' && (0, $1ix2F.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $bc8f9908a1e4106f$var$getContainingBlock(element) || window;
}

});
parcelRegister("6hs9X", function(module, exports) {

$parcel$export(module.exports, "default", () => $492a2c861940c94d$export$2e2bcd8739ae039);

var $f5IBt = parcelRequire("f5IBt");
function $492a2c861940c94d$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $f5IBt.default)(element)) >= 0;
}

});


parcelRegister("kcmIg", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb468bf0752088cc$export$2e2bcd8739ae039);

var $kJPed = parcelRequire("kJPed");
function $eb468bf0752088cc$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $eb468bf0752088cc$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $eb468bf0752088cc$var$order(modifiers); // order based on phase
    return (0, $kJPed.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("kJPed", function(module, exports) {

$parcel$export(module.exports, "top", () => $f18fbf7b212a7c8e$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $f18fbf7b212a7c8e$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $f18fbf7b212a7c8e$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $f18fbf7b212a7c8e$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $f18fbf7b212a7c8e$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $f18fbf7b212a7c8e$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $f18fbf7b212a7c8e$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $f18fbf7b212a7c8e$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $f18fbf7b212a7c8e$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $f18fbf7b212a7c8e$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $f18fbf7b212a7c8e$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $f18fbf7b212a7c8e$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $f18fbf7b212a7c8e$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $f18fbf7b212a7c8e$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $f18fbf7b212a7c8e$export$d087d3878fdf71d5);
var $f18fbf7b212a7c8e$export$1e95b668f3b82d = 'top';
var $f18fbf7b212a7c8e$export$40e543e69a8b3fbb = 'bottom';
var $f18fbf7b212a7c8e$export$79ffe56a765070d2 = 'right';
var $f18fbf7b212a7c8e$export$eabcd2c8791e7bf4 = 'left';
var $f18fbf7b212a7c8e$export$dfb5619354ba860 = 'auto';
var $f18fbf7b212a7c8e$export$aec2ce47c367b8c3 = [
    $f18fbf7b212a7c8e$export$1e95b668f3b82d,
    $f18fbf7b212a7c8e$export$40e543e69a8b3fbb,
    $f18fbf7b212a7c8e$export$79ffe56a765070d2,
    $f18fbf7b212a7c8e$export$eabcd2c8791e7bf4
];
var $f18fbf7b212a7c8e$export$b3571188c770cc5a = 'start';
var $f18fbf7b212a7c8e$export$bd5df0f255a350f8 = 'end';
var $f18fbf7b212a7c8e$export$390fd549c5303b4d = 'clippingParents';
var $f18fbf7b212a7c8e$export$d7b7311ec04a3e8f = 'viewport';
var $f18fbf7b212a7c8e$export$ae5ab1c730825774 = 'popper';
var $f18fbf7b212a7c8e$export$ca50aac9f3ba507f = 'reference';
var $f18fbf7b212a7c8e$export$368f9a87e87fa4e1 = /*#__PURE__*/ $f18fbf7b212a7c8e$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $f18fbf7b212a7c8e$export$b3571188c770cc5a,
        placement + "-" + $f18fbf7b212a7c8e$export$bd5df0f255a350f8
    ]);
}, []);
var $f18fbf7b212a7c8e$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($f18fbf7b212a7c8e$export$aec2ce47c367b8c3, [
    $f18fbf7b212a7c8e$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $f18fbf7b212a7c8e$export$b3571188c770cc5a,
        placement + "-" + $f18fbf7b212a7c8e$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $f18fbf7b212a7c8e$export$421679a7c3d56e = 'beforeRead';
var $f18fbf7b212a7c8e$export$aafa59e2e03f2942 = 'read';
var $f18fbf7b212a7c8e$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $f18fbf7b212a7c8e$export$c65e99957a05207c = 'beforeMain';
var $f18fbf7b212a7c8e$export$f22da7240b7add18 = 'main';
var $f18fbf7b212a7c8e$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $f18fbf7b212a7c8e$export$8d4d2d70e7d46032 = 'beforeWrite';
var $f18fbf7b212a7c8e$export$68d8715fc104d294 = 'write';
var $f18fbf7b212a7c8e$export$70a6e5159acce2e6 = 'afterWrite';
var $f18fbf7b212a7c8e$export$d087d3878fdf71d5 = [
    $f18fbf7b212a7c8e$export$421679a7c3d56e,
    $f18fbf7b212a7c8e$export$aafa59e2e03f2942,
    $f18fbf7b212a7c8e$export$6964f6c886723980,
    $f18fbf7b212a7c8e$export$c65e99957a05207c,
    $f18fbf7b212a7c8e$export$f22da7240b7add18,
    $f18fbf7b212a7c8e$export$bab79516f2d662fe,
    $f18fbf7b212a7c8e$export$8d4d2d70e7d46032,
    $f18fbf7b212a7c8e$export$68d8715fc104d294,
    $f18fbf7b212a7c8e$export$70a6e5159acce2e6
];

});


parcelRegister("a8clb", function(module, exports) {

$parcel$export(module.exports, "default", () => $7604395822cc5d61$export$2e2bcd8739ae039);
function $7604395822cc5d61$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("i9xH7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3733441fcf2e882$export$2e2bcd8739ae039);
function $d3733441fcf2e882$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("4TVC8", function(module, exports) {

$parcel$export(module.exports, "default", () => $3918fd6b815bcf57$export$2e2bcd8739ae039);

var $1Prpe = parcelRequire("1Prpe");
var $3918fd6b815bcf57$var$passive = {
    passive: true
};
function $3918fd6b815bcf57$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $1Prpe.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $3918fd6b815bcf57$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $3918fd6b815bcf57$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $3918fd6b815bcf57$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $3918fd6b815bcf57$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $3918fd6b815bcf57$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $3918fd6b815bcf57$var$effect,
    data: {}
};

});

parcelRegister("j8nKB", function(module, exports) {

$parcel$export(module.exports, "default", () => $dee1300a39219bb5$export$2e2bcd8739ae039);

var $dJ0Jl = parcelRequire("dJ0Jl");
function $dee1300a39219bb5$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $dJ0Jl.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $dee1300a39219bb5$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $dee1300a39219bb5$var$popperOffsets,
    data: {}
};

});
parcelRegister("dJ0Jl", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fe00b5c334118ac$export$2e2bcd8739ae039);

var $QXpw1 = parcelRequire("QXpw1");

var $cGRJ4 = parcelRequire("cGRJ4");

var $9GF9F = parcelRequire("9GF9F");

var $kJPed = parcelRequire("kJPed");
function $9fe00b5c334118ac$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $QXpw1.default)(placement) : null;
    var variation = placement ? (0, $cGRJ4.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $kJPed.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $kJPed.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $kJPed.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $kJPed.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $9GF9F.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $kJPed.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $kJPed.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("QXpw1", function(module, exports) {

$parcel$export(module.exports, "default", () => $09f2f123ac4a9fdf$export$2e2bcd8739ae039);

function $09f2f123ac4a9fdf$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("cGRJ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $93d315208040ceed$export$2e2bcd8739ae039);
function $93d315208040ceed$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("9GF9F", function(module, exports) {

$parcel$export(module.exports, "default", () => $70d7f5cda4210aa3$export$2e2bcd8739ae039);
function $70d7f5cda4210aa3$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("baic6", function(module, exports) {

$parcel$export(module.exports, "default", () => $820ebddbe0682e4f$export$2e2bcd8739ae039);

var $kJPed = parcelRequire("kJPed");

var $gbHJy = parcelRequire("gbHJy");

var $1Prpe = parcelRequire("1Prpe");

var $eVELE = parcelRequire("eVELE");

var $1ix2F = parcelRequire("1ix2F");

var $QXpw1 = parcelRequire("QXpw1");

var $cGRJ4 = parcelRequire("cGRJ4");

var $90xPK = parcelRequire("90xPK");
var $820ebddbe0682e4f$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $820ebddbe0682e4f$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $90xPK.round)(x * dpr) / dpr || 0,
        y: (0, $90xPK.round)(y * dpr) / dpr || 0
    };
}
function $820ebddbe0682e4f$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $kJPed.left);
    var sideY = (0, $kJPed.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $gbHJy.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $1Prpe.default)(popper)) {
            offsetParent = (0, $eVELE.default)(popper);
            if ((0, $1ix2F.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $kJPed.top) || (placement === (0, $kJPed.left) || placement === (0, $kJPed.right)) && variation === (0, $kJPed.end)) {
            sideY = (0, $kJPed.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $kJPed.left) || (placement === (0, $kJPed.top) || placement === (0, $kJPed.bottom)) && variation === (0, $kJPed.end)) {
            sideX = (0, $kJPed.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $820ebddbe0682e4f$var$unsetSides);
    var _ref4 = roundOffsets === true ? $820ebddbe0682e4f$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $1Prpe.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $820ebddbe0682e4f$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $QXpw1.default)(state.placement),
        variation: (0, $cGRJ4.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $820ebddbe0682e4f$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $820ebddbe0682e4f$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $820ebddbe0682e4f$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $820ebddbe0682e4f$var$computeStyles,
    data: {}
};

});

parcelRegister("1AoLg", function(module, exports) {

$parcel$export(module.exports, "default", () => $127c5c56b9511f5f$export$2e2bcd8739ae039);

var $f5IBt = parcelRequire("f5IBt");

var $gmkfg = parcelRequire("gmkfg");
// and applies them to the HTMLElements such as popper and arrow
function $127c5c56b9511f5f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $gmkfg.isHTMLElement)(element) || !(0, $f5IBt.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $127c5c56b9511f5f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $gmkfg.isHTMLElement)(element) || !(0, $f5IBt.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $127c5c56b9511f5f$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $127c5c56b9511f5f$var$applyStyles,
    effect: $127c5c56b9511f5f$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("gy4Xr", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0c3aad300d72ee1$export$2e2bcd8739ae039);

var $QXpw1 = parcelRequire("QXpw1");

var $kJPed = parcelRequire("kJPed");
function $c0c3aad300d72ee1$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $QXpw1.default)(placement);
    var invertDistance = [
        (0, $kJPed.left),
        (0, $kJPed.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $kJPed.left),
        (0, $kJPed.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $c0c3aad300d72ee1$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $kJPed.placements).reduce(function(acc, placement) {
        acc[placement] = $c0c3aad300d72ee1$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $c0c3aad300d72ee1$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $c0c3aad300d72ee1$var$offset
};

});

parcelRegister("3dDWl", function(module, exports) {

$parcel$export(module.exports, "default", () => $258191447a7022df$export$2e2bcd8739ae039);

var $jwSgb = parcelRequire("jwSgb");

var $QXpw1 = parcelRequire("QXpw1");

var $4tIVJ = parcelRequire("4tIVJ");

var $kgkit = parcelRequire("kgkit");

var $cqF2x = parcelRequire("cqF2x");

var $kJPed = parcelRequire("kJPed");

var $cGRJ4 = parcelRequire("cGRJ4");
function $258191447a7022df$var$getExpandedFallbackPlacements(placement) {
    if ((0, $QXpw1.default)(placement) === (0, $kJPed.auto)) return [];
    var oppositePlacement = (0, $jwSgb.default)(placement);
    return [
        (0, $4tIVJ.default)(placement),
        oppositePlacement,
        (0, $4tIVJ.default)(oppositePlacement)
    ];
}
function $258191447a7022df$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $QXpw1.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $jwSgb.default)(preferredPlacement)
    ] : $258191447a7022df$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $QXpw1.default)(placement) === (0, $kJPed.auto) ? (0, $cqF2x.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $QXpw1.default)(placement);
        var isStartVariation = (0, $cGRJ4.default)(placement) === (0, $kJPed.start);
        var isVertical = [
            (0, $kJPed.top),
            (0, $kJPed.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $kgkit.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $kJPed.right) : (0, $kJPed.left) : isStartVariation ? (0, $kJPed.bottom) : (0, $kJPed.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $jwSgb.default)(mainVariationSide);
        var altVariationSide = (0, $jwSgb.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $258191447a7022df$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $258191447a7022df$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("jwSgb", function(module, exports) {

$parcel$export(module.exports, "default", () => $e37b1862c86f39c4$export$2e2bcd8739ae039);
var $e37b1862c86f39c4$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $e37b1862c86f39c4$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $e37b1862c86f39c4$var$hash[matched];
    });
}

});

parcelRegister("4tIVJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $342cb90cb2622617$export$2e2bcd8739ae039);
var $342cb90cb2622617$var$hash = {
    start: 'end',
    end: 'start'
};
function $342cb90cb2622617$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $342cb90cb2622617$var$hash[matched];
    });
}

});

parcelRegister("kgkit", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec050bcf5e349283$export$2e2bcd8739ae039);

var $dknpr = parcelRequire("dknpr");

var $eVELE = parcelRequire("eVELE");

var $g2O7Z = parcelRequire("g2O7Z");

var $dJ0Jl = parcelRequire("dJ0Jl");

var $h8W1z = parcelRequire("h8W1z");

var $kJPed = parcelRequire("kJPed");

var $gmkfg = parcelRequire("gmkfg");

var $gIXWB = parcelRequire("gIXWB");

var $50KfK = parcelRequire("50KfK");
function $ec050bcf5e349283$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $kJPed.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $kJPed.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $kJPed.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $gIXWB.default)(typeof padding !== 'number' ? padding : (0, $50KfK.default)(padding, (0, $kJPed.basePlacements)));
    var altContext = elementContext === (0, $kJPed.popper) ? (0, $kJPed.reference) : (0, $kJPed.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $dknpr.default)((0, $gmkfg.isElement)(element) ? element : element.contextElement || (0, $eVELE.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $g2O7Z.default)(state.elements.reference);
    var popperOffsets = (0, $dJ0Jl.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $h8W1z.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $kJPed.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $kJPed.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $kJPed.right),
                (0, $kJPed.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $kJPed.top),
                (0, $kJPed.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("dknpr", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b3f4d3932acb3b2$export$2e2bcd8739ae039);

var $kJPed = parcelRequire("kJPed");

var $3V2hG = parcelRequire("3V2hG");

var $9NXD7 = parcelRequire("9NXD7");

var $2r6BH = parcelRequire("2r6BH");

var $gbHJy = parcelRequire("gbHJy");

var $eVELE = parcelRequire("eVELE");

var $1ix2F = parcelRequire("1ix2F");

var $gmkfg = parcelRequire("gmkfg");

var $g2O7Z = parcelRequire("g2O7Z");

var $eTUzl = parcelRequire("eTUzl");

var $j6yPg = parcelRequire("j6yPg");

var $f5IBt = parcelRequire("f5IBt");

var $h8W1z = parcelRequire("h8W1z");

var $90xPK = parcelRequire("90xPK");
function $9b3f4d3932acb3b2$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $g2O7Z.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $kJPed.viewport) ? (0, $h8W1z.default)((0, $3V2hG.default)(element, strategy)) : (0, $gmkfg.isElement)(clippingParent) ? $9b3f4d3932acb3b2$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $h8W1z.default)((0, $9NXD7.default)((0, $eVELE.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $9b3f4d3932acb3b2$var$getClippingParents(element) {
    var clippingParents = (0, $2r6BH.default)((0, $eTUzl.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $1ix2F.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $gmkfg.isHTMLElement)(element) ? (0, $gbHJy.default)(element) : element;
    if (!(0, $gmkfg.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $gmkfg.isElement)(clippingParent) && (0, $j6yPg.default)(clippingParent, clipperElement) && (0, $f5IBt.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $9b3f4d3932acb3b2$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $9b3f4d3932acb3b2$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $90xPK.max)(rect.top, accRect.top);
        accRect.right = (0, $90xPK.min)(rect.right, accRect.right);
        accRect.bottom = (0, $90xPK.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $90xPK.max)(rect.left, accRect.left);
        return accRect;
    }, $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("3V2hG", function(module, exports) {

$parcel$export(module.exports, "default", () => $2da877912142c34b$export$2e2bcd8739ae039);

var $1Prpe = parcelRequire("1Prpe");

var $eVELE = parcelRequire("eVELE");

var $imzt5 = parcelRequire("imzt5");

var $d8bsQ = parcelRequire("d8bsQ");
function $2da877912142c34b$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $1Prpe.default)(element);
    var html = (0, $eVELE.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $d8bsQ.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $imzt5.default)(element),
        y: y
    };
}

});

parcelRegister("9NXD7", function(module, exports) {

$parcel$export(module.exports, "default", () => $7236f1f1532b7fe8$export$2e2bcd8739ae039);

var $eVELE = parcelRequire("eVELE");

var $1ix2F = parcelRequire("1ix2F");

var $imzt5 = parcelRequire("imzt5");

var $8YTLN = parcelRequire("8YTLN");

var $90xPK = parcelRequire("90xPK");
function $7236f1f1532b7fe8$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $eVELE.default)(element);
    var winScroll = (0, $8YTLN.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $90xPK.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $90xPK.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $imzt5.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $1ix2F.default)(body || html).direction === 'rtl') x += (0, $90xPK.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("j6yPg", function(module, exports) {

$parcel$export(module.exports, "default", () => $de89978be23479c4$export$2e2bcd8739ae039);

var $gmkfg = parcelRequire("gmkfg");
function $de89978be23479c4$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $gmkfg.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("h8W1z", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7b0316bb2f8fd97$export$2e2bcd8739ae039);
function $c7b0316bb2f8fd97$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("gIXWB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2cf410c4fe133f4$export$2e2bcd8739ae039);

var $1ANH0 = parcelRequire("1ANH0");
function $c2cf410c4fe133f4$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $1ANH0.default)(), paddingObject);
}

});
parcelRegister("1ANH0", function(module, exports) {

$parcel$export(module.exports, "default", () => $128fb32b18b92ffa$export$2e2bcd8739ae039);
function $128fb32b18b92ffa$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("50KfK", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a60d4b4ac4f93e5$export$2e2bcd8739ae039);
function $3a60d4b4ac4f93e5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("cqF2x", function(module, exports) {

$parcel$export(module.exports, "default", () => $90c7bf65fbdbec33$export$2e2bcd8739ae039);

var $cGRJ4 = parcelRequire("cGRJ4");

var $kJPed = parcelRequire("kJPed");

var $kgkit = parcelRequire("kgkit");

var $QXpw1 = parcelRequire("QXpw1");
function $90c7bf65fbdbec33$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $kJPed.placements) : _options$allowedAutoP;
    var variation = (0, $cGRJ4.default)(placement);
    var placements = variation ? flipVariations ? (0, $kJPed.variationPlacements) : (0, $kJPed.variationPlacements).filter(function(placement) {
        return (0, $cGRJ4.default)(placement) === variation;
    }) : (0, $kJPed.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $kgkit.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $QXpw1.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("1DdSC", function(module, exports) {

$parcel$export(module.exports, "default", () => $13043339457d5bc5$export$2e2bcd8739ae039);

var $kJPed = parcelRequire("kJPed");

var $QXpw1 = parcelRequire("QXpw1");

var $9GF9F = parcelRequire("9GF9F");

var $dNtrn = parcelRequire("dNtrn");

var $4WpIh = parcelRequire("4WpIh");

var $jkGDj = parcelRequire("jkGDj");

var $gbHJy = parcelRequire("gbHJy");

var $kgkit = parcelRequire("kgkit");

var $cGRJ4 = parcelRequire("cGRJ4");

var $1ANH0 = parcelRequire("1ANH0");

var $90xPK = parcelRequire("90xPK");
function $13043339457d5bc5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $kgkit.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $QXpw1.default)(state.placement);
    var variation = (0, $cGRJ4.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $9GF9F.default)(basePlacement);
    var altAxis = (0, $dNtrn.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $kJPed.top) : (0, $kJPed.left);
        var altSide = mainAxis === 'y' ? (0, $kJPed.bottom) : (0, $kJPed.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $kJPed.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $kJPed.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $jkGDj.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $1ANH0.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $4WpIh.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $gbHJy.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $4WpIh.within)(tether ? (0, $90xPK.min)(min, tetherMin) : min, offset, tether ? (0, $90xPK.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $kJPed.top) : (0, $kJPed.left);
        var _altSide = mainAxis === 'x' ? (0, $kJPed.bottom) : (0, $kJPed.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $kJPed.top),
            (0, $kJPed.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $4WpIh.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $4WpIh.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $13043339457d5bc5$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $13043339457d5bc5$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("dNtrn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0b6b03fadcbdfd7$export$2e2bcd8739ae039);
function $a0b6b03fadcbdfd7$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("4WpIh", function(module, exports) {

$parcel$export(module.exports, "within", () => $3990864f59117d05$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $3990864f59117d05$export$86c8af6d3ef0b4a);

var $90xPK = parcelRequire("90xPK");
function $3990864f59117d05$export$f28d906d67a997f3(min, value, max) {
    return (0, $90xPK.max)(min, (0, $90xPK.min)(value, max));
}
function $3990864f59117d05$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $3990864f59117d05$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("gzAfz", function(module, exports) {

$parcel$export(module.exports, "default", () => $c10c08bd5e0ed9fb$export$2e2bcd8739ae039);

var $QXpw1 = parcelRequire("QXpw1");

var $jkGDj = parcelRequire("jkGDj");

var $j6yPg = parcelRequire("j6yPg");

var $gbHJy = parcelRequire("gbHJy");

var $9GF9F = parcelRequire("9GF9F");

var $4WpIh = parcelRequire("4WpIh");

var $gIXWB = parcelRequire("gIXWB");

var $50KfK = parcelRequire("50KfK");

var $kJPed = parcelRequire("kJPed");
var $c10c08bd5e0ed9fb$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $gIXWB.default)(typeof padding !== 'number' ? padding : (0, $50KfK.default)(padding, (0, $kJPed.basePlacements)));
};
function $c10c08bd5e0ed9fb$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $QXpw1.default)(state.placement);
    var axis = (0, $9GF9F.default)(basePlacement);
    var isVertical = [
        (0, $kJPed.left),
        (0, $kJPed.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $c10c08bd5e0ed9fb$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $jkGDj.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $kJPed.top) : (0, $kJPed.left);
    var maxProp = axis === 'y' ? (0, $kJPed.bottom) : (0, $kJPed.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $gbHJy.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $4WpIh.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $c10c08bd5e0ed9fb$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $j6yPg.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $c10c08bd5e0ed9fb$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $c10c08bd5e0ed9fb$var$arrow,
    effect: $c10c08bd5e0ed9fb$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("6iLAT", function(module, exports) {

$parcel$export(module.exports, "default", () => $496957b0c691a0ed$export$2e2bcd8739ae039);

var $kJPed = parcelRequire("kJPed");

var $kgkit = parcelRequire("kgkit");
function $496957b0c691a0ed$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $496957b0c691a0ed$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $kJPed.top),
        (0, $kJPed.right),
        (0, $kJPed.bottom),
        (0, $kJPed.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $496957b0c691a0ed$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $kgkit.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $kgkit.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $496957b0c691a0ed$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $496957b0c691a0ed$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $496957b0c691a0ed$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $496957b0c691a0ed$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $496957b0c691a0ed$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $496957b0c691a0ed$var$hide
};

});




parcelRegister("iGDLS", function(module, exports) {

$parcel$export(module.exports, "Reference", () => $d9aafffd117cbcc1$export$e0be378c32fb70a7);

var $5uXOq = parcelRequire("5uXOq");

var $hBYjV = parcelRequire("hBYjV");

var $5n5w4 = parcelRequire("5n5w4");

var $eclLw = parcelRequire("eclLw");
function $d9aafffd117cbcc1$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $5uXOq.useContext((0, $5n5w4.ManagerReferenceNodeSetterContext));
    var refHandler = $5uXOq.useCallback(function(node) {
        (0, $eclLw.setRef)(innerRef, node);
        (0, $eclLw.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $5uXOq.useEffect(function() {
        return function() {
            return (0, $eclLw.setRef)(innerRef, null);
        };
    }, []);
    $5uXOq.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($hBYjV)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $eclLw.unwrapArray)(children)({
        ref: refHandler
    });
}

});

parcelRegister("4wJSY", function(module, exports) {

$parcel$export(module.exports, "shallowEqualObjects", () => $34bdbe885d924a05$export$3e67810a3f0e9f1c);
function $34bdbe885d924a05$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $34bdbe885d924a05$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $34bdbe885d924a05$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $34bdbe885d924a05$export$967a6b9924a689f7(a, b);
    return $34bdbe885d924a05$export$3e67810a3f0e9f1c(a, b);
}

});

parcelRegister("hT6ku", function(module, exports) {

$parcel$export(module.exports, "MenuDialog", () => $3f79b132df1e01ff$export$c94219dad7c0e37d);
$parcel$export(module.exports, "DummyControl", () => $3f79b132df1e01ff$export$87ce933b7fc29b8c);
$parcel$export(module.exports, "defaultComponents", () => $3f79b132df1e01ff$export$71abc632aa29e6fe);
/* components.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gMMNe = parcelRequire("gMMNe");

var $bChGW = parcelRequire("bChGW");

var $jldZL = parcelRequire("jldZL");
const $3f79b132df1e01ff$var$menuDialogStyles = null;
const $3f79b132df1e01ff$export$c94219dad7c0e37d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, id: id, style: style, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        id: id,
        "data-testid": testId && `${testId}--menu`,
        className: (0, $bwpsq.default)([
            "_2rkoiti9 _1pby16oo _bfhk1bhr _16qseva7"
        ]),
        children: children
    });
});
// ==============================
// Custom Components
// ==============================
const $3f79b132df1e01ff$var$dropdownStyles = null;
const $3f79b132df1e01ff$var$DropdownIndicator = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1bsbzwfg _12l2v77o _y3gn1h6o"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gMMNe))), {
            color: "currentColor",
            label: ""
        })
    });
const $3f79b132df1e01ff$var$controlStyles = null;
const $3f79b132df1e01ff$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: innerRef,
        className: (0, $bwpsq.default)([
            "_85i51b66 _1q51u2gc _y4tiu2gc _bozgu2gc"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).Control, {
            ...props,
            innerProps: innerProps
        })
    });
const $3f79b132df1e01ff$export$87ce933b7fc29b8c = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $jldZL.default), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).Control, {
            ...props
        })
    });
// NOTE `props` intentionally omitted from `Fragment`
const $3f79b132df1e01ff$var$Menu = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...innerProps,
        children: children
    });
// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
const $3f79b132df1e01ff$var$ClearIndicator = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).ClearIndicator, {
        ...props
    });
const $3f79b132df1e01ff$var$MultiValueRemove = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).MultiValueRemove, {
        ...props
    });
const $3f79b132df1e01ff$export$71abc632aa29e6fe = {
    Control: $3f79b132df1e01ff$var$Control,
    DropdownIndicator: $3f79b132df1e01ff$var$DropdownIndicator,
    Menu: $3f79b132df1e01ff$var$Menu,
    ClearIndicator: $3f79b132df1e01ff$var$ClearIndicator,
    MultiValueRemove: $3f79b132df1e01ff$var$MultiValueRemove
};

});
parcelRegister("gMMNe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bd994b90fa78030d2d1c292998636115>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c386fa4cb21167b0$var$_react = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c386fa4cb21167b0$var$_search = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("hyOJh")));

var $c386fa4cb21167b0$var$_search2 = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("77ZoC")));
function $c386fa4cb21167b0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SearchIcon.
 * This component is SearchIcon, with `UNSAFE_fallbackIcon` set to "EditorSearchIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c386fa4cb21167b0$var$SearchIcon = (props)=>/*#__PURE__*/ $c386fa4cb21167b0$var$_react.default.createElement($c386fa4cb21167b0$var$_search.default, Object.assign({
        LEGACY_fallbackIcon: $c386fa4cb21167b0$var$_search2.default
    }, props));
$c386fa4cb21167b0$var$SearchIcon.Name = 'SearchIconMigration';
var $c386fa4cb21167b0$var$_default = module.exports.default = $c386fa4cb21167b0$var$SearchIcon;

});
parcelRegister("77ZoC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5308cfd5e45a5605$var$_react = $5308cfd5e45a5605$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $5308cfd5e45a5605$var$_search = $5308cfd5e45a5605$var$_interopRequireDefault((parcelRequire("hyOJh")));
function $5308cfd5e45a5605$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5308cfd5e45a5605$var$EditorSearchIcon = (props)=>/*#__PURE__*/ $5308cfd5e45a5605$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14.823 15.883a5.5 5.5 0 1 1 1.06-1.06l2.647 2.647c.293.293.53.59 0 1.06s-.767.293-1.06 0zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
    }, props, {
        newIcon: $5308cfd5e45a5605$var$_search.default
    }));
$5308cfd5e45a5605$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
var $5308cfd5e45a5605$var$_default = module.exports.default = $5308cfd5e45a5605$var$EditorSearchIcon;

});



parcelRegister("9DWu0", function(module, exports) {

$parcel$export(module.exports, "NotifyOpenLayerObserver", () => $072287da151cf77b$export$17baa7c95b6ba1b8);

var $9Mkr0 = parcelRequire("9Mkr0");
function $072287da151cf77b$export$17baa7c95b6ba1b8({ isOpen: isOpen, onClose: onClose }) {
    // @ts-ignore error TS2353: Object literal may only specify known properties, and &#39;onClose&#39; does not exist in type &#39;{ isOpen?: boolean | undefined; }&#39;.
    (0, $9Mkr0.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}

});




parcelRegister("78Gdn", function(module, exports) {

$parcel$export(module.exports, "batchByKey", () => $2e9cc1cdc768945e$export$da86c38211c1c0a8);
function $2e9cc1cdc768945e$export$da86c38211c1c0a8(callback) {
    const calls = {};
    return (key, ...args)=>{
        if (!calls[key]) {
            window.setTimeout(()=>{
                callback(key, calls[key]);
                delete calls[key];
            });
            calls[key] = [];
        }
        calls[key].push(args);
    };
}

});

parcelRegister("8fG8p", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7b21650c04984462$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $7b21650c04984462$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    placeholder: {
        id: 'fabric.elements.user-picker.placeholder',
        defaultMessage: 'Enter people or teams...',
        description: 'Placeholder description for empty user/team/email select field.'
    },
    addMore: {
        id: 'fabric.elements.user-picker.placeholder.add-more',
        defaultMessage: 'add more people...',
        description: 'Placeholder for multi user picker when the field is not empty.'
    },
    remove: {
        id: 'fabric.elements.user-picker.multi.remove-item',
        defaultMessage: 'Remove',
        description: 'Tooltip for the single item remove button in a multi user select field.'
    },
    clear: {
        id: 'fabric.elements.user-picker.single.clear',
        defaultMessage: 'Clear',
        description: 'Tooltip for clear button in the single user select field.'
    },
    errorMessage: {
        id: 'fabric.elements.user-picker.error.message',
        defaultMessage: 'Something went wrong',
        description: 'Error message to display when options fail to load.'
    },
    memberCountWithoutYou: {
        id: 'fabric.elements.user-picker.team.member.count',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}",
        description: 'Byline to show the number of members in the team when the current user is not a member of the team'
    },
    memberCountWithYou: {
        id: 'fabric.elements.user-picker.team.member.count.including.you',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you",
        description: 'Byline to show the number of members in the team when the current user is also a member of the team'
    },
    plus50MembersWithoutYou: {
        id: 'fabric.elements.user-picker.team.member.50plus',
        defaultMessage: "Team \u2022 50+ members",
        description: 'Byline to show the number of members in the team when the number exceeds 50'
    },
    plus50MembersWithYou: {
        id: 'fabric.elements.user-picker.team.member.50plus.including.you',
        defaultMessage: "Team \u2022 50+ members, including you",
        description: 'Byline to show the number of members in the team when the number exceeds 50 and also includes the current user'
    },
    addEmail: {
        id: 'fabric.elements.user-picker.email.add',
        defaultMessage: 'Add user',
        description: 'Byline for valid email option.'
    },
    selectToAddEmail: {
        id: 'fabric.elements.user-picker.email.select.to.add',
        defaultMessage: 'Select an email address',
        description: 'Byline for valid email option.'
    },
    continueToAddEmail: {
        id: 'fabric.elements.user-picker.email.add.potential',
        defaultMessage: 'Enter an email address',
        description: 'Byline for a potentially valid email option.'
    },
    groupByline: {
        id: 'fabric.elements.user-picker.group.byline',
        defaultMessage: 'Admin-managed group',
        description: 'Byline for admin-managed groups'
    },
    externalUserSourcesHeading: {
        id: 'fabric.elements.user-picker.external.sourced.from',
        defaultMessage: 'Found in:',
        description: 'From where the external user is coming'
    },
    externalUserSourcesError: {
        id: 'fabric.elements.user-picker.external.sourced.error',
        defaultMessage: "We can't connect you right now.",
        description: "Error message when we can't fetch a user's import sources"
    },
    slackProvider: {
        id: 'fabric.elements.user-picker.slack.provider',
        defaultMessage: 'Slack',
        description: 'This external user is sourced from Slack provider'
    },
    googleProvider: {
        id: 'fabric.elements.user-picker.google.provider',
        defaultMessage: 'Google',
        description: 'This external user is sourced from Google provider'
    },
    microsoftProvider: {
        id: 'fabric.elements.user-picker.microsoft.provider',
        defaultMessage: 'Microsoft',
        description: 'This external user is sourced from Microsoft provider'
    },
    gitHubProvider: {
        id: 'fabric.elements.user-picker.github.provider',
        defaultMessage: 'GitHub',
        description: 'This external user is sourced from GitHub provider'
    },
    jiraSource: {
        id: 'fabric.elements.user-picker.source.jira',
        defaultMessage: 'Jira',
        description: 'This external user is sourced from Jira'
    },
    confluenceSource: {
        id: 'fabric.elements.user-picker.source.confluence',
        defaultMessage: 'Confluence',
        description: 'This external user is sourced from Confluence'
    },
    otherAtlassianSource: {
        id: 'fabric.elements.user-picker.source.other-atlassian',
        defaultMessage: 'Other Atlassian products',
        description: 'This external user is sourced from Atlassian products other than Jira and Confluence'
    },
    memberLozengeText: {
        id: 'fabric.elements.user-picker.member.lozenge.text',
        defaultMessage: 'MEMBER',
        description: 'Text within the Lozenge when the user is a workspace member'
    },
    guestLozengeText: {
        id: 'fabric.elements.user-picker.guest.lozenge.text',
        defaultMessage: 'GUEST',
        description: 'Text within the lozenge when the user is a guest of confluence'
    },
    guestUserLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.user',
        defaultMessage: 'Guests can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for guest lozenge showing that a user is a guest in Confluence'
    },
    guestGroupLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.group',
        defaultMessage: 'Guest groups can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for lozenge showing that a group is for guests in Confluence'
    },
    userTypeLabel: {
        id: 'fabric.elements.user-picker.user.type.label',
        defaultMessage: 'People',
        description: 'Label for user type'
    },
    teamTypeLabel: {
        id: 'fabric.elements.user-picker.team.type.label',
        defaultMessage: 'Teams',
        description: 'Label for team type'
    },
    emailTypeLabel: {
        id: 'fabric.elements.user-picker.email.type.label',
        defaultMessage: 'Emails',
        description: 'Label for email type'
    },
    groupTypeLabel: {
        id: 'fabric.elements.user-picker.group.type.label',
        defaultMessage: 'Groups',
        description: 'Label for group type'
    },
    externalUserTypeLabel: {
        id: 'fabric.elements.user-picker.external.user.type.label',
        defaultMessage: 'External Users',
        description: 'Label for external user type'
    },
    customTypeLabel: {
        id: 'fabric.elements.user-picker.custom.type.label',
        defaultMessage: 'Customs',
        description: 'Label for custom type'
    },
    otherTypeLabel: {
        id: 'fabric.elements.user-picker.other.type.label',
        defaultMessage: 'Others',
        description: 'Label for other type'
    }
});

});

parcelRegister("01LKK", function(module, exports) {

$parcel$export(module.exports, "groupOptionsByType", () => $846290178b7bfe5f$export$393a985f7dd07cfe);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $8QpSo = parcelRequire("8QpSo");

var $8fG8p = parcelRequire("8fG8p");
const $846290178b7bfe5f$var$getLabelForType = (type)=>{
    switch(type){
        case 'user':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $8fG8p.messages).userTypeLabel
            });
        case 'team':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $8fG8p.messages).teamTypeLabel
            });
        case 'group':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $8fG8p.messages).groupTypeLabel
            });
        case 'custom':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $8fG8p.messages).customTypeLabel
            });
        case 'external_user':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $8fG8p.messages).externalUserTypeLabel
            });
        default:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $8fG8p.messages).otherTypeLabel
            });
    }
};
const $846290178b7bfe5f$export$393a985f7dd07cfe = (0, $8QpSo.default)((options, groupByTypeOrder)=>{
    // If groupByTypeOrder is empty, just return the original options
    if (groupByTypeOrder.length === 0) return options;
    const groupedMap = new Map();
    options.forEach((option)=>{
        const type = option.data.type || 'other';
        if (!groupedMap.has(type)) groupedMap.set(type, []);
        groupedMap.get(type).push(option);
    });
    const result = [];
    // add groups in the specified order
    // type is not in groupByTypeOrder, don't add it to the result
    groupByTypeOrder.forEach((type)=>{
        if (groupedMap.has(type)) {
            result.push({
                label: $846290178b7bfe5f$var$getLabelForType(type),
                options: groupedMap.get(type)
            });
            groupedMap.delete(type);
        }
    });
    return result;
});

});

parcelRegister("pk97C", function(module, exports) {

$parcel$export(module.exports, "userPickerRenderedUfoExperience", () => $06ebadcdd7d5e231$export$b49757166e1acfc2);
$parcel$export(module.exports, "userPickerOptionsShownUfoExperience", () => $06ebadcdd7d5e231$export$135a264e0da507ae);
$parcel$export(module.exports, "UfoErrorBoundary", () => $06ebadcdd7d5e231$export$5ef1c2550074a375);

var $5uXOq = parcelRequire("5uXOq");

var $cBycP = parcelRequire("cBycP");
var $7Zbvr = parcelRequire("7Zbvr");
var $jZA09 = parcelRequire("jZA09");
const $06ebadcdd7d5e231$export$b49757166e1acfc2 = new (0, $cBycP.ConcurrentExperience)('user-picker-rendered', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $7Zbvr.ExperienceTypes).Load,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).PageSegmentLoad
});
const $06ebadcdd7d5e231$export$135a264e0da507ae = new (0, $cBycP.ConcurrentExperience)('user-picker-options-shown', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $7Zbvr.ExperienceTypes).Operation,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult
});
class $06ebadcdd7d5e231$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidCatch() {
        const instance = $06ebadcdd7d5e231$export$b49757166e1acfc2.getInstance(this.props.id);
        if (instance.state.id !== (0, $jZA09.UFOExperienceState).FAILED.id) instance.failure();
    }
    render() {
        return this.props.children;
    }
}

});
parcelRegister("cBycP", function(module, exports) {

$parcel$export(module.exports, "ConcurrentExperience", () => $d4c0ab33dd6972cc$export$ac1cddfee07ba6ac);

var $dCAsn = parcelRequire("dCAsn");

var $boHLC = parcelRequire("boHLC");
class $d4c0ab33dd6972cc$export$ac1cddfee07ba6ac {
    constructor(experienceId, config){
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $boHLC.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $dCAsn.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
}

});



parcelRegister("2wgOn", function(module, exports) {

$parcel$export(module.exports, "getStyles", () => $01bdbab7be42e070$export$ffd58b7f6f099a57);
$parcel$export(module.exports, "getPopupStyles", () => $01bdbab7be42e070$export$4e983f376ad8a3af);


var $8QpSo = parcelRequire("8QpSo");

var $7VXAu = parcelRequire("7VXAu");
const $01bdbab7be42e070$export$59c188914e58c94b = "var(--ds-space-075, 6px)";
const $01bdbab7be42e070$export$53937c04f7dfc2ae = 6;
const $01bdbab7be42e070$export$2c62ba763e976c54 = 39;
const $01bdbab7be42e070$export$ffd58b7f6f099a57 = (0, $8QpSo.default)((width, isMulti, isCompact, overrideStyles, isInvalid, isVisualRefresh, isPopupStyles)=>{
    let styles = {
        menu: (css, state)=>({
                ...css,
                width: width,
                minWidth: state.selectProps.menuMinWidth,
                zIndex: '400'
            }),
        menuList: (css)=>({
                ...css,
                zIndex: '400'
            }),
        control: (css, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                width: width,
                borderColor: isInvalid ? `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})` : state.isFocused ? `var(--ds-border-focused, ${css.borderColor})` : state.selectProps.subtle || state.selectProps.noBorder ? 'transparent' : `var(--ds-border-input, ${0, $829f609a65d26a98$export$7c87d337fb91a97d})`,
                backgroundColor: state.isFocused ? `var(--ds-background-input, ${css['backgroundColor']})` : state.selectProps.subtle ? 'transparent' : state.selectProps.textFieldBackgroundColor ? `var(--ds-background-input, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})` : `var(--ds-background-input, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`,
                '&:hover .fabric-user-picker__clear-indicator': {
                    opacity: 1
                },
                ':hover': {
                    ...css[':hover'],
                    borderColor: isInvalid ? `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})` : state.isFocused ? css[':hover'] ? `var(--ds-border-focused, ${css[':hover'].borderColor})` : `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : state.selectProps.subtle ? 'transparent' : `var(--ds-border-input, ${0, $829f609a65d26a98$export$7c87d337fb91a97d})`,
                    backgroundColor: state.selectProps.subtle && state.selectProps.hoveringClearIndicator ? `var(--ds-background-danger, ${0, $829f609a65d26a98$export$4b84fd0e2c617bd})` : state.isFocused ? css[':hover'] ? `var(--ds-background-input, ${css[':hover'].backgroundColor})` : `var(--ds-background-input, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : state.isDisabled ? `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})` : `var(--ds-background-input-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`
                },
                padding: 0,
                minHeight: isCompact ? 'none' : 44,
                /* IE 11 needs to set height explicitly to be vertical align when being in not compact mode */ height: isCompact || isMulti ? '100%' : 44,
                maxWidth: '100%'
            };
        },
        clearIndicator: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, paddingLeft: paddingLeft, paddingRight: paddingRight, ...css })=>({
                ...css,
                // By default show clear indicator, except for on devices where "hover" is supported.
                // This means mobile devices (which do not support hover) will be able to see the clear indicator.
                opacity: 1,
                '@media (hover: hover) and (pointer: fine)': {
                    opacity: 0
                },
                transition: css.transition + ', opacity 150ms',
                paddingTop: 0,
                padding: 0,
                ':hover': {
                    color: `var(--ds-icon-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`
                }
            }),
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        valueContainer: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, position: position, ...css }, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                gridTemplateColumns: 'auto 1fr',
                paddingTop: isCompact ? 0 : $01bdbab7be42e070$export$59c188914e58c94b,
                paddingBottom: isCompact ? 0 : $01bdbab7be42e070$export$59c188914e58c94b,
                paddingLeft: isMulti ? $01bdbab7be42e070$export$59c188914e58c94b : 0,
                overflowX: 'hidden',
                overflowY: 'auto',
                scrollbarWidth: 'none',
                maxHeight: state.selectProps.maxPickerHeight || '100%',
                '::-webkit-scrollbar': {
                    width: 0,
                    background: 'transparent'
                }
            };
        },
        multiValue: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'default'
            }),
        multiValueLabel: (css)=>({
                ...css,
                display: 'flex'
            }),
        multiValueRemove: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'pointer'
            }),
        placeholder: (css, state)=>{
            // fix styling in IE 11: when the position is absolute and `left` prop is not defined,
            // IE and other browsers auto calculate value of "left" prop differently,
            // so we want to explicitly set value for the `left` property
            if (css.position === 'absolute' && !css.left) css.left = `${$01bdbab7be42e070$export$59c188914e58c94b}px`;
            return {
                ...css,
                gridArea: '1/2/2/3',
                paddingLeft: state.selectProps.isMulti ? 0 : $01bdbab7be42e070$export$59c188914e58c94b,
                /* Margin left right of 2px set by default */ // margin: `0 ${BORDER_PADDING}px`,
                margin: 0,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            };
        },
        option: (css)=>{
            if (isVisualRefresh) return {
                ...css,
                overflow: 'hidden',
                paddingLeft: isPopupStyles ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)",
                paddingRight: isPopupStyles ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)"
            };
            return {
                ...css,
                overflow: 'hidden'
            };
        },
        input: (css, state)=>({
                ...css,
                gridArea: '1/2/2/3',
                gridTemplateColumns: isMulti && state.placeholder ? '0 123px' : css.gridTemplateColumns,
                /* Necessary to make input height and tag height the same. */ margin: `${"var(--ds-space-050, 4px)"} 0`,
                /* Padding top and bottom of 2 is set by default. */ paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: state.selectProps.isMulti ? 0 : $01bdbab7be42e070$export$59c188914e58c94b,
                '& input::placeholder': {
                    /* Chrome, Firefox, Opera, Safari 10.1+ */ color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$d6447c357493214f})`,
                    opacity: 1 /* Firefox */ 
                },
                '& input:-ms-input-placeholder': {
                    /* Internet Explorer 10-11 */ color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$d6447c357493214f})`
                }
            }),
        singleValue: (css)=>({
                ...css,
                margin: 0,
                gridArea: '1/2/2/3'
            })
    };
    return overrideStyles ? (0, $7VXAu.mergeStyles)(styles, overrideStyles) : styles;
});
const $01bdbab7be42e070$export$4e983f376ad8a3af = (0, $8QpSo.default)((width, isMulti, overrideStyles, isVisualRefresh)=>({
        ...$01bdbab7be42e070$export$ffd58b7f6f099a57(width, isMulti, false, overrideStyles, false, isVisualRefresh, true)
    }));

});

parcelRegister("dyegP", function(module, exports) {

$parcel$export(module.exports, "getComponents", () => $27e51ea041192381$export$4e811121b221213b);
$parcel$export(module.exports, "getPopupComponents", () => $27e51ea041192381$export$19205fd341a6bb08);

var $8QpSo = parcelRequire("8QpSo");

var $dqbw8 = parcelRequire("dqbw8");

var $8Y8Qe = parcelRequire("8Y8Qe");

var $fIpmY = parcelRequire("fIpmY");

var $3QONt = parcelRequire("3QONt");

var $6Kkci = parcelRequire("6Kkci");

var $OxpB4 = parcelRequire("OxpB4");

var $ee8bl = parcelRequire("ee8bl");

var $h3ej5 = parcelRequire("h3ej5");

var $6Ks8i = parcelRequire("6Ks8i");

var $lYehz = parcelRequire("lYehz");

var $7mofJ = parcelRequire("7mofJ");
const $27e51ea041192381$export$4e811121b221213b = (0, $8QpSo.default)((multi, anchor, showClearIndicator, customComponents)=>{
    if (anchor) return {
        Control: anchor,
        Option: $3QONt.Option
    };
    else return {
        MultiValue: $8Y8Qe.MultiValue,
        DropdownIndicator: null,
        SingleValue: $6Kkci.SingleValue,
        ClearIndicator: showClearIndicator || !multi ? (0, $dqbw8.ClearIndicator) : null,
        Option: $3QONt.Option,
        ValueContainer: multi ? (0, $fIpmY.MultiValueContainer) : (0, $ee8bl.SingleValueContainer),
        Input: $OxpB4.Input,
        Menu: $lYehz.Menu,
        Control: $7mofJ.default,
        ...customComponents ? customComponents : {}
    };
});
const $27e51ea041192381$export$19205fd341a6bb08 = (0, $8QpSo.default)((hasPopupTitle)=>{
    const baseProps = {
        DropdownIndicator: null,
        SingleValue: $6Kkci.SingleValue,
        ClearIndicator: $dqbw8.ClearIndicator,
        Option: $3QONt.Option,
        ValueContainer: (0, $ee8bl.SingleValueContainer),
        Input: (0, $h3ej5.PopupInput)
    };
    if (hasPopupTitle) return {
        ...baseProps,
        Control: (0, $6Ks8i.PopupControl)
    };
    return baseProps;
});

});
parcelRegister("dqbw8", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $11bf495008933d24$export$ecf9cf59142dd54a);
/* ClearIndicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");

const $11bf495008933d24$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("7LtDy")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $11bf495008933d24$var$clearIndicatorStyles = {
    root: "_v5641ppt _tzy4kb7n _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _30l3s4qr _1mhjgrf3"
};
class $11bf495008933d24$export$ecf9cf59142dd54a extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        const { //@ts-ignore react-select unsupported props
        selectProps: { clearValueLabel: clearValueLabel } } = this.props;
        const Indicator = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).ClearIndicator, {
            ...this.props,
            innerProps: {
                ...this.props.innerProps,
                onMouseDown: this.handleMouseDown
            },
            xcss: $11bf495008933d24$var$clearIndicatorStyles.root
        });
        return clearValueLabel ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Suspense, {
            fallback: Indicator,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($11bf495008933d24$var$AsyncTooltip, {
                content: clearValueLabel,
                children: Indicator
            })
        }) : Indicator;
    }
    constructor(...args){
        super(...args), this.handleMouseDown = (event)=>{
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            // Prevent focus when clear on blurred state
            const { clearValue: clearValue, selectProps: selectProps } = this.props;
            clearValue();
            //@ts-ignore react-select unsupported props
            if (selectProps && !selectProps.isFocused) event.stopPropagation();
        };
    }
}

});
parcelRegister("7LtDy", function(module, exports) {

let $5a73e97eb510a942$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5a73e97eb510a942$var$load("9EQz0").then(()=>parcelRequire('8hfZh'));

});


parcelRegister("8Y8Qe", function(module, exports) {

$parcel$export(module.exports, "MultiValue", () => $65368b71d1856c3a$export$419cdf50db8b579);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $bChGW = parcelRequire("bChGW");

var $f8Sb3 = parcelRequire("f8Sb3");

var $dW8NE = parcelRequire("dW8NE");

var $5pJx4 = parcelRequire("5pJx4");

var $3smIt = parcelRequire("3smIt");

var $4hqZ5 = parcelRequire("4hqZ5");

var $fuhQD = parcelRequire("fuhQD");
function $65368b71d1856c3a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $65368b71d1856c3a$export$118122ebc1e626fa = (valueContainer, control)=>{
    const { top: top, height: height } = valueContainer.getBoundingClientRect();
    const { height: controlHeight } = control.getBoundingClientRect();
    if (top - height < 0) valueContainer.scrollIntoView();
    if (top + height > controlHeight) valueContainer.scrollIntoView(false);
};
const $65368b71d1856c3a$var$groupTagContainer = (0, $8CUq3.xcss)({
    paddingLeft: 'space.025',
    marginTop: 'space.025'
});
const $65368b71d1856c3a$var$nameWrapper = {
    name: "1ebbz80",
    styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);padding-left:var(--ds-space-050, 4px)"
};
class $65368b71d1856c3a$export$419cdf50db8b579 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props), this.getElemBefore = ()=>{
            const { data: { data: data } } = this.props;
            if ((0, $3smIt.isEmail)(data)) // This element is a decorative icon and does not require a label
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dW8NE.AddOptionAvatar), {
                isLozenge: true
            });
            if ((0, $3smIt.isGroup)(data)) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
                xcss: $65368b71d1856c3a$var$groupTagContainer
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4hqZ5))), {
                LEGACY_margin: "-2px 0 0 0",
                color: "currentColor",
                label: "" // This element is a decorative icon and does not require a label
                ,
                LEGACY_size: "small"
            }));
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5pJx4.SizeableAvatar), {
                appearance: "multi",
                src: (0, $3smIt.getAvatarUrl)(data),
                type: (0, $3smIt.isTeam)(data) ? 'team' : 'person'
            });
        }, this.getElemAfter = ()=>{
            const { data: { data: data } } = this.props;
            if ((0, $3smIt.isTeam)(data) && data.verified) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fuhQD.VerifiedTeamIcon), null);
            return null;
        };
        this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef();
    }
    componentDidUpdate() {
        const { isFocused: isFocused } = this.props;
        if (isFocused && this.containerRef.current && this.containerRef.current.parentElement && this.containerRef.current.parentElement.parentElement) $65368b71d1856c3a$export$118122ebc1e626fa(this.containerRef.current, this.containerRef.current.parentElement.parentElement);
    }
    shouldComponentUpdate(nextProps) {
        const { data: { label: label, data: data }, innerProps: innerProps, isFocused: isFocused } = this.props;
        const { data: { label: nextLabel, data: nextData }, innerProps: nextInnerProps, isFocused: nextIsFocused } = nextProps;
        // We can ignore onRemove here because it is an anonymous function
        // that will be recreated every time but with the same implementation.
        return data !== nextData || label !== nextLabel || innerProps !== nextInnerProps || isFocused !== nextIsFocused;
    }
    render() {
        const { children: children, innerProps: innerProps, ...rest } = this.props;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bChGW.components).MultiValue, {
            ...rest,
            innerProps: {
                ref: this.containerRef
            },
            cropWithEllipsis: false
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $f5TWP.default), {
            alignBlock: "center"
        }, this.getElemBefore(), " ", /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $65368b71d1856c3a$var$nameWrapper
        }, children), this.getElemAfter()));
    }
}

});
parcelRegister("dW8NE", function(module, exports) {

$parcel$export(module.exports, "AddOptionAvatar", () => $f3236d5a67f7ff1f$export$df396db45e491922);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $aVnO1 = parcelRequire("aVnO1");


var $f8Sb3 = parcelRequire("f8Sb3");
parcelRequire("5uXOq");
const $f3236d5a67f7ff1f$var$getEmailAvatarWrapperStyle = (isLozenge)=>{
    const padding = isLozenge ? `${"var(--ds-space-0, 0px)"}` : `${"var(--ds-space-050, 4px)"}`;
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: padding,
        backgroundColor: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        marginLeft: "var(--ds-space-025, 2px)"
    });
};
const $f3236d5a67f7ff1f$export$df396db45e491922 = ({ isLozenge: isLozenge, label: label })=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $f3236d5a67f7ff1f$var$getEmailAvatarWrapperStyle(isLozenge)
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aVnO1))), {
        testId: "add-option-avatar-email-icon",
        label: label || '',
        LEGACY_size: isLozenge ? 'small' : 'medium',
        LEGACY_margin: "0 0 0 -2px",
        color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
    })));
};

});
parcelRegister("aVnO1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b2014ecb862bd114df9c4eca3bb7d0c3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f41b19bed4136e0$var$_react = $7f41b19bed4136e0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7f41b19bed4136e0$var$_email = $7f41b19bed4136e0$var$_interopRequireDefault((parcelRequire("eRB05")));

var $7f41b19bed4136e0$var$_email2 = $7f41b19bed4136e0$var$_interopRequireDefault((parcelRequire("5bEkJ")));
function $7f41b19bed4136e0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EmailIcon.
 * This component is EmailIcon, with `UNSAFE_fallbackIcon` set to "EmailIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7f41b19bed4136e0$var$EmailIcon = (props)=>/*#__PURE__*/ $7f41b19bed4136e0$var$_react.default.createElement($7f41b19bed4136e0$var$_email.default, Object.assign({
        LEGACY_fallbackIcon: $7f41b19bed4136e0$var$_email2.default
    }, props));
$7f41b19bed4136e0$var$EmailIcon.Name = 'EmailIconMigration';
var $7f41b19bed4136e0$var$_default = module.exports.default = $7f41b19bed4136e0$var$EmailIcon;

});
parcelRegister("5bEkJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3c6d443366bf8cbb$var$_react = $3c6d443366bf8cbb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $3c6d443366bf8cbb$var$_email = $3c6d443366bf8cbb$var$_interopRequireDefault((parcelRequire("eRB05")));
function $3c6d443366bf8cbb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3c6d443366bf8cbb$var$EmailIcon = (props)=>/*#__PURE__*/ $3c6d443366bf8cbb$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 7v10h14V7zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2z"/><path d="M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 0 0 4.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.12 1.12 0 0 1-1.583 0z"/></g></svg>`
    }, props, {
        newIcon: $3c6d443366bf8cbb$var$_email.default
    }));
$3c6d443366bf8cbb$var$EmailIcon.displayName = 'EmailIcon';
var $3c6d443366bf8cbb$var$_default = module.exports.default = $3c6d443366bf8cbb$var$EmailIcon;

});



parcelRegister("5pJx4", function(module, exports) {

$parcel$export(module.exports, "SizeableAvatar", () => $50cd04ab4dcbd6e5$export$44d81a88129649da);

var $2OMIu = parcelRequire("2OMIu");

var $ujWmd = parcelRequire("ujWmd");

var $fwSAz = parcelRequire("fwSAz");

var $5uXOq = parcelRequire("5uXOq");

var $3smIt = parcelRequire("3smIt");
class $50cd04ab4dcbd6e5$export$44d81a88129649da extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        const { src: src, presence: presence, appearance: appearance, type: type = 'person' } = this.props;
        const props = {
            size: (0, $3smIt.getAvatarSize)(appearance),
            src: src,
            borderColor: 'transparent',
            presence: presence
        };
        return type === 'team' ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fwSAz.default), {
            ...props
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ujWmd.default), {
            ...props
        });
    }
}

});
parcelRegister("fwSAz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cdf5ede1a400c9d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");


var $2w1D3 = parcelRequire("2w1D3");

var $ggnNZ = parcelRequire("ggnNZ");
const $6cdf5ede1a400c9d$export$ebe0b8fe8b6acbfd = `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
const $6cdf5ede1a400c9d$export$72502e51aebdd94e = `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`;
function $6cdf5ede1a400c9d$export$2e2bcd8739ae039({ testId: testId, src: src, size: size = 'medium', ...props }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ujWmd.default), {
        appearance: (0, $ggnNZ.isSquareIcon)(src) ? 'square' : 'circle',
        ...props,
        size: size,
        src: src,
        testId: `${testId}-team-avatar`,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2w1D3.TeamAvatarImage), {
            src: src,
            size: size,
            testId: testId
        })
    });
}

});
parcelRegister("2w1D3", function(module, exports) {

$parcel$export(module.exports, "TeamAvatarImage", () => $7d2527153712d181$export$ac3673635a5387be);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $vIiRg = parcelRequire("vIiRg");
var $cEPfF = parcelRequire("cEPfF");

var $fptva = parcelRequire("fptva");

var $h8cgU = parcelRequire("h8cgU");

var $VSDnB = parcelRequire("VSDnB");


var $4jyNe = parcelRequire("4jyNe");

var $3WiFt = parcelRequire("3WiFt");
function $7d2527153712d181$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7d2527153712d181$var$ICON_BACKGROUND = `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
const $7d2527153712d181$var$ICON_COLOR = `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`;
// used in a size calculation so can't be a token. Without this the avatar looks very squished
const $7d2527153712d181$var$ICON_PADDING = 4;
const $7d2527153712d181$var$avatarDefaultIconStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    backgroundColor: $7d2527153712d181$var$ICON_COLOR,
    borderRadius: '50%',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center'
});
const $7d2527153712d181$var$SIZES = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
const $7d2527153712d181$var$nestedAvatarStyles = Object.entries((0, $vIiRg.AVATAR_SIZES)).reduce((styles, [key, size])=>{
    return {
        ...styles,
        [key]: /*#__PURE__*/ (0, $f8Sb3.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${size}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${size}px`,
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '& svg': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: `${size - $7d2527153712d181$var$ICON_PADDING}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: `${size - $7d2527153712d181$var$ICON_PADDING}px`
            }
        })
    };
}, {});
const $7d2527153712d181$var$avatarImageStyles = {
    name: "n68006",
    styles: "display:flex;flex:1 1 100%;width:100%;height:100%"
};
const $7d2527153712d181$export$9cfabd93718c0a2e = ({ alt: alt = '', src: src, size: size, testId: testId })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $5uXOq.useState)(false);
    // If src changes, reset state
    (0, $5uXOq.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) {
        if ((0, $VSDnB.fg)('enable-team-avatar-switch')) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4jyNe.FallbackAvatar), {
            "aria-label": alt,
            width: $7d2527153712d181$var$SIZES[size],
            height: $7d2527153712d181$var$SIZES[size],
            "data-testid": testId
        });
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            css: [
                $7d2527153712d181$var$avatarDefaultIconStyles,
                $7d2527153712d181$var$nestedAvatarStyles[size]
            ]
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fptva))), {
            label: alt,
            color: $7d2527153712d181$var$ICON_BACKGROUND,
            LEGACY_secondaryColor: $7d2527153712d181$var$ICON_COLOR,
            testId: testId && `${testId}--team`,
            spacing: "spacious",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($h8cgU)))
        }));
    }
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cEPfF.AvatarContent), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("img", {
        src: src,
        alt: alt,
        "data-testid": testId && `${testId}--image`,
        css: $7d2527153712d181$var$avatarImageStyles,
        onError: ()=>setHasImageErrored(true)
    }));
};
const $7d2527153712d181$export$ac3673635a5387be = (props)=>{
    if ((0, $VSDnB.fg)('team-avatar-radii')) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3WiFt.TeamAvatarImage), props);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($7d2527153712d181$export$9cfabd93718c0a2e, props);
};

});
parcelRegister("vIiRg", function(module, exports) {

$parcel$export(module.exports, "AVATAR_SIZES", () => $32eb610dda6e4a8d$export$9a270941bcff7e77);
$parcel$export(module.exports, "AVATAR_RADIUS", () => $32eb610dda6e4a8d$export$e6da6efe4d1a5c9b);
$parcel$export(module.exports, "BORDER_WIDTH", () => $32eb610dda6e4a8d$export$e2bd4c1faded7921);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $k5uoT = parcelRequire("k5uoT");
const $32eb610dda6e4a8d$export$9a270941bcff7e77 = {
    xsmall: (0, $k5uoT.gridSize)() * 2,
    small: (0, $k5uoT.gridSize)() * 3,
    medium: (0, $k5uoT.gridSize)() * 4,
    large: (0, $k5uoT.gridSize)() * 5,
    xlarge: (0, $k5uoT.gridSize)() * 12,
    xxlarge: (0, $k5uoT.gridSize)() * 16
};
const $32eb610dda6e4a8d$export$e6da6efe4d1a5c9b = {
    xsmall: 2,
    small: 2,
    medium: 3,
    large: 3,
    xlarge: 6,
    xxlarge: 12
};
const $32eb610dda6e4a8d$export$e2bd4c1faded7921 = 2;
const $32eb610dda6e4a8d$export$89a980dfdf90df51 = 0.9;
const $32eb610dda6e4a8d$export$3c061e31594ebabe = '--avatar-background-color';
const $32eb610dda6e4a8d$export$fdc820179f1f9be4 = {
    small: 12,
    medium: 14,
    large: 15,
    xlarge: 18
};
const $32eb610dda6e4a8d$export$382610e783aa2ae8 = {
    small: 0,
    medium: 0,
    large: 1,
    xlarge: 7
};

});

parcelRegister("h8cgU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c78cb3eb85357720$var$_react = $c78cb3eb85357720$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $c78cb3eb85357720$var$_peopleGroup = $c78cb3eb85357720$var$_interopRequireDefault((parcelRequire("fptva")));
function $c78cb3eb85357720$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c78cb3eb85357720$var$PeopleIcon = (props)=>/*#__PURE__*/ $c78cb3eb85357720$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><path d="M13 12a1.997 1.997 0 0 0-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3 3 0 0 1 12.997 12z"/></g></svg>`
    }, props, {
        newIcon: $c78cb3eb85357720$var$_peopleGroup.default
    }));
$c78cb3eb85357720$var$PeopleIcon.displayName = 'PeopleIcon';
var $c78cb3eb85357720$var$_default = module.exports.default = $c78cb3eb85357720$var$PeopleIcon;

});

parcelRegister("4jyNe", function(module, exports) {

$parcel$export(module.exports, "FallbackAvatar", () => $c800ab58c4d12cbb$export$eb63dcc490f6bbcd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
const $c800ab58c4d12cbb$var$styles = {
    wrapper: "_1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o"
};
function $c800ab58c4d12cbb$export$eb63dcc490f6bbcd(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $c800ab58c4d12cbb$var$styles.wrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                    clipPath: "url(#clip0_2032_552)",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "#DCDFE4"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z",
                            fill: "#44546F"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                        id: "clip0_2032_552",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
}

});

parcelRegister("3WiFt", function(module, exports) {

$parcel$export(module.exports, "TeamAvatarImage", () => $ed1385df3f8966b5$export$ac3673635a5387be);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $a9yTd = parcelRequire("a9yTd");
const $ed1385df3f8966b5$var$boxShadowCssVar = '--avatar-box-shadow';
const $ed1385df3f8966b5$var$bgColorCssVar = '--avatar-bg-color';
/**
 * We need to maintan the container styles manually until Avatar provides the correct border radius.
 * After that we can return to wrapping in <AvatarContent> rather than span
 */ const $ed1385df3f8966b5$var$containerStyles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk18uv _aetrf705 _1peqidpf _11fnglyw",
    circle: "_2rko1q5u _14mj1q5u",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peqs237"
};
const $ed1385df3f8966b5$var$unboundStyles = {
    root: "_vchh18uv _bfhkcxp3 _16qs1nhn",
    interactive: "_80omtlke _4tpuw83z _ez1ykb7n _gcm11et6 _eeh8kb7n _jlxit94y"
};
const $ed1385df3f8966b5$var$avatarImageStyles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq"
};
const $ed1385df3f8966b5$var$SIZES = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
const $ed1385df3f8966b5$var$borderRadiusMap = {
    xsmall: "_2rko1y44",
    small: "_2rkoi2wt",
    medium: "_2rkoftgi",
    large: "_2rko19bv",
    xlarge: "_2rko1tcg",
    xxlarge: "_2rkozwfg"
};
const $ed1385df3f8966b5$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $ed1385df3f8966b5$export$ac3673635a5387be = ({ alt: alt = '', src: src, size: size, testId: testId })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $5uXOq.useState)(false);
    // If src changes, reset state
    (0, $5uXOq.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a9yTd.FallbackAvatar), {
        "aria-label": alt,
        width: $ed1385df3f8966b5$var$SIZES[size],
        height: $ed1385df3f8966b5$var$SIZES[size],
        "data-testid": testId
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId,
        "aria-label": alt,
        className: (0, $bwpsq.default)([
            $ed1385df3f8966b5$var$unboundStyles.root,
            $ed1385df3f8966b5$var$containerStyles.root,
            $ed1385df3f8966b5$var$borderRadiusMap[size],
            $ed1385df3f8966b5$var$widthHeightMap[size]
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
            src: src,
            alt: alt,
            "data-testId": testId && `${testId}--image`,
            onError: ()=>setHasImageErrored(true),
            className: (0, $bwpsq.default)([
                $ed1385df3f8966b5$var$avatarImageStyles.image
            ])
        })
    });
};

});
parcelRegister("a9yTd", function(module, exports) {

$parcel$export(module.exports, "FallbackAvatar", () => $dc76f912cc56de65$export$eb63dcc490f6bbcd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
const $dc76f912cc56de65$var$styles = {
    wrapper: "_1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o"
};
function $dc76f912cc56de65$export$eb63dcc490f6bbcd(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $dc76f912cc56de65$var$styles.wrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                    clipPath: "url(#clip0_2032_552)",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "#DCDFE4"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z",
                            fill: "#44546F"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                        id: "clip0_2032_552",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
}

});



parcelRegister("ggnNZ", function(module, exports) {

$parcel$export(module.exports, "isSquareIcon", () => $cf7e4fad001aa258$export$d5a05ffb65695bc0);

var $VSDnB = parcelRequire("VSDnB");
function $cf7e4fad001aa258$export$d5a05ffb65695bc0(src) {
    if (!src) return false;
    try {
        const url = new URL(src);
        const host = url.host;
        const path = url.pathname;
        if ((host.startsWith('ptc-directory-sited-static') || host.startsWith('teams-directory-frontend')) && path.includes('teams/avatars/v4') && (0, $VSDnB.fg)('enable-team-avatar-switch')) return true;
    } catch  {
    // The src wasn't a URL, so it's obviously not the refreshed avatar.
    }
    return false;
}

});



parcelRegister("4hqZ5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ff23a711b4b109cded01cd0a5945034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $31ddae7439c341a9$var$_react = $31ddae7439c341a9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $31ddae7439c341a9$var$_peopleGroup = $31ddae7439c341a9$var$_interopRequireDefault((parcelRequire("fptva")));

var $31ddae7439c341a9$var$_people = $31ddae7439c341a9$var$_interopRequireDefault((parcelRequire("h8cgU")));
function $31ddae7439c341a9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PeopleGroupIcon.
 * This component is PeopleGroupIcon, with `UNSAFE_fallbackIcon` set to "PeopleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $31ddae7439c341a9$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $31ddae7439c341a9$var$_react.default.createElement($31ddae7439c341a9$var$_peopleGroup.default, Object.assign({
        LEGACY_fallbackIcon: $31ddae7439c341a9$var$_people.default
    }, props));
$31ddae7439c341a9$var$PeopleGroupIcon.Name = 'PeopleGroupIconMigration';
var $31ddae7439c341a9$var$_default = module.exports.default = $31ddae7439c341a9$var$PeopleGroupIcon;

});

parcelRegister("fuhQD", function(module, exports) {

$parcel$export(module.exports, "VerifiedTeamIcon", () => $a137cc376204c926$export$d7949f68d31e5edd);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $gqGjQ = parcelRequire("gqGjQ");

var $fGmbh = parcelRequire("fGmbh");

var $3bDjY = parcelRequire("3bDjY");

var $27dJz = parcelRequire("27dJz");
const $a137cc376204c926$export$d7949f68d31e5edd = ({ label: label = 'Verified Team', showTooltip: showTooltip, customTooltipContent: customTooltipContent })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const tooltipContent = showTooltip ? customTooltipContent || formatMessage((0, $27dJz.messages).verifiedIconDefaultTooltip) : undefined;
    return tooltipContent ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: tooltipContent,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
            tabIndex: 0,
            role: "button",
            "data-testid": "verified-team-icon",
            children: [
                ' ',
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gqGjQ))), {
                    color: "var(--ds-icon-accent-blue, #1D7AFC)",
                    LEGACY_size: "medium",
                    label: tooltipContent,
                    spacing: "spacious",
                    LEGACY_fallbackIcon: (0, $fGmbh.default)
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gqGjQ))), {
        color: "var(--ds-icon-accent-blue, #1D7AFC)",
        LEGACY_size: "medium",
        spacing: "spacious",
        label: label,
        LEGACY_fallbackIcon: (0, $fGmbh.default)
    });
};

});
parcelRegister("gqGjQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e3a26defb7fafbfaa404238ab66b0242>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bf5fe6b7538334be$var$_react = $bf5fe6b7538334be$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $bf5fe6b7538334be$var$_baseNew = $bf5fe6b7538334be$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $bf5fe6b7538334be$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusVerified".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing verified content.
Filled status icons provide higher visual contrast draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bf5fe6b7538334be$var$StatusVerifiedIcon = (props)=>/*#__PURE__*/ $bf5fe6b7538334be$var$_react.default.createElement($bf5fe6b7538334be$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.85.444a1.713 1.713 0 0 1 2.301 0L10.3 1.486a.2.2 0 0 0 .15.055L12 1.48a1.71 1.71 0 0 1 1.762 1.479l.21 1.537a.2.2 0 0 0 .081.139l1.226.95c.696.54.87 1.52.4 2.266l-.828 1.312a.2.2 0 0 0-.027.158l.328 1.516a1.713 1.713 0 0 1-1.151 1.993l-1.477.474a.2.2 0 0 0-.123.103l-.723 1.372a1.713 1.713 0 0 1-2.162.787l-1.435-.587a.2.2 0 0 0-.161 0l-1.436.587a1.713 1.713 0 0 1-2.162-.787l-.723-1.372a.22.22 0 0 0-.124-.103L2 12.83a1.713 1.713 0 0 1-1.15-1.993l.327-1.516a.2.2 0 0 0-.027-.158L.322 7.852a1.713 1.713 0 0 1 .4-2.266l1.225-.95a.2.2 0 0 0 .081-.14l.21-1.536a1.71 1.71 0 0 1 1.763-1.48l1.55.06a.2.2 0 0 0 .15-.055zm-.1 9.384L4.826 7.519l-1.152.961 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$bf5fe6b7538334be$var$StatusVerifiedIcon.displayName = 'StatusVerifiedIcon';
var $bf5fe6b7538334be$var$_default = module.exports.default = $bf5fe6b7538334be$var$StatusVerifiedIcon;

});

parcelRegister("fGmbh", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9bd2ad2ea16bb95$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $d9bd2ad2ea16bb95$var$VerifiedIconGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "33",
        height: "32",
        viewBox: "0 0 33 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.6666 6.65507C17.7592 4.89362 15.2407 4.89362 14.3332 6.65507C13.7879 7.7135 12.5577 8.22306 11.4237 7.86022C9.53648 7.25639 7.75565 9.03721 8.35949 10.9244C8.72232 12.0584 8.21276 13.2886 7.15434 13.8339C5.39289 14.7414 5.39289 17.2599 7.15434 18.1674C8.21276 18.7127 8.72232 19.9429 8.35949 21.0769C7.75565 22.9641 9.53648 24.7449 11.4237 24.1411C12.5577 23.7783 13.7879 24.2878 14.3332 25.3462C15.2407 27.1077 17.7592 27.1077 18.6666 25.3462C19.212 24.2878 20.4421 23.7783 21.5761 24.1411C23.4634 24.7449 25.2442 22.9641 24.6404 21.0769C24.2775 19.9429 24.7871 18.7127 25.8455 18.1674C27.607 17.2599 27.607 14.7414 25.8455 13.8339C24.7871 13.2886 24.2775 12.0584 24.6404 10.9244C25.2442 9.03721 23.4634 7.25639 21.5761 7.86022C20.4421 8.22306 19.212 7.7135 18.6666 6.65507ZM20.7898 12.7002L20.8932 12.7923C21.323 13.2221 21.3537 13.8998 20.9853 14.365L20.8932 14.4684L16.1524 19.2091C15.7226 19.6389 15.0449 19.6696 14.5797 19.3012L14.4764 19.2091L12.106 16.8388C11.6431 16.3759 11.6431 15.6255 12.106 15.1627C12.5358 14.7329 13.2135 14.7022 13.6787 15.0706L13.7821 15.1627L15.3146 16.6944L19.2171 12.7923C19.6469 12.3625 20.3246 12.3318 20.7898 12.7002Z",
            fill: "currentColor"
        })
    });
/**
 * __VerifiedIcon__
 */ const $d9bd2ad2ea16bb95$var$VerifiedIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $d9bd2ad2ea16bb95$var$VerifiedIconGlyph
    });
var $d9bd2ad2ea16bb95$export$2e2bcd8739ae039 = $d9bd2ad2ea16bb95$var$VerifiedIcon;

});

parcelRegister("27dJz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $952fb45ddff9712a$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $952fb45ddff9712a$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    verifiedIconDefaultTooltip: {
        id: 'ptc-directory.team-profile-page.team-name.verified-team.icon.tooltip',
        defaultMessage: 'Managed teams are verified because they can only be changed by an admin.',
        description: 'Tooltip text for the verified team icon'
    }
});

});



parcelRegister("fIpmY", function(module, exports) {

$parcel$export(module.exports, "MultiValueContainer", () => $0a44bca42d442dd9$export$cf9cf2a30a59265c);
/* MultiValueContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bChGW = parcelRequire("bChGW");

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $ousew = parcelRequire("ousew");

var $8fG8p = parcelRequire("8fG8p");

var $3smIt = parcelRequire("3smIt");

var $jNYXM = parcelRequire("jNYXM");
const $0a44bca42d442dd9$var$valueContainerStyles = {
    root: "_yv0e5bpd _ca0q12x7 _n3td12x7 _19bv12x7 _1reo15vq _18m91wug _1fjgglyw _c71l1osq _1suq18uv _1ke8idpf"
};
class $0a44bca42d442dd9$export$cf9cf2a30a59265c extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    static getDerivedStateFromProps(nextProps, prevState) {
        return {
            valueSize: nextProps.getValue ? nextProps.getValue().length : 0,
            previousValueSize: prevState.valueSize
        };
    }
    constructor(props){
        super(props), this.timeoutId = null, this.scrollToBottom = ()=>{
            this.timeoutId = window.setTimeout(()=>{
                const { ref: { current: current } } = this.valueContainerInnerProps;
                if (current !== null) {
                    const container = (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).findDOMNode(current);
                    if (container instanceof HTMLDivElement) container.scrollTop = container.scrollHeight;
                }
                this.timeoutId = null;
            });
        }, this.showPlaceholder = ()=>{
            const { selectProps: { value: value } } = this.props;
            return value && value.length > 0;
        }, this.addPlaceholder = (placeholder)=>{
            const children = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(this.props.children, (child)=>(0, $3smIt.isChildInput)(child) && this.showPlaceholder() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
                    placeholder: placeholder
                }) : child);
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
                children: children
            });
        }, this.renderChildren = ()=>{
            const { //@ts-ignore react-select unsupported props
            selectProps: { addMoreMessage: addMoreMessage, isDisabled: isDisabled } } = this.props;
            // Do not render "Add more..." message if picker is disabled
            if (isDisabled) return this.props.children;
            if (addMoreMessage === undefined) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $8fG8p.messages).addMore,
                children: (addMore)=>{
                    let addMoreMessages = addMore;
                    if (addMore && typeof addMore === 'string') addMoreMessages = [
                        addMore
                    ];
                    const placeholder = addMoreMessages?.join('') ?? '';
                    return this.addPlaceholder(placeholder);
                }
            });
            return this.addPlaceholder(addMoreMessage);
        }, //@ts-ignore react-select unsupported props
        this.onValueContainerClick = this.props.selectProps.onValueContainerClick;
        this.state = {
            valueSize: 0,
            previousValueSize: 0
        };
        this.valueContainerInnerProps = {
            ref: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef()
        };
    }
    componentDidUpdate() {
        const { previousValueSize: previousValueSize, valueSize: valueSize } = this.state;
        //@ts-ignore react-select unsupported props
        const { isFocused: isFocused } = this.props.selectProps;
        if (valueSize > previousValueSize && isFocused) {
            if (this.timeoutId) {
                window.clearTimeout(this.timeoutId);
                this.timeoutId = null;
            }
            this.scrollToBottom();
        }
    }
    componentWillUnmount() {
        if (this.timeoutId) window.clearTimeout(this.timeoutId);
    }
    render() {
        const { children: children, innerProps: innerProps, ...valueContainerProps } = this.props;
        const props = {
            ...valueContainerProps,
            innerProps: this.valueContainerInnerProps
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jNYXM.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).ValueContainer, {
                ...props,
                xcss: $0a44bca42d442dd9$var$valueContainerStyles.root,
                children: this.renderChildren()
            })
        });
    }
}

});
parcelRegister("jNYXM", function(module, exports) {

$parcel$export(module.exports, "default", () => $4661c12157fe2c0e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $4661c12157fe2c0e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Conditional wrapper for the ValueContainer in Select. Provides a workaround
 * for issues using react-select on react-beautiful-dnd Draggable elements.
 * @returns
 */ var $4661c12157fe2c0e$var$_ref = {
    name: "1ff36h2",
    styles: "flex-grow:1"
};
const $4661c12157fe2c0e$var$ValueContainerWrapper = ({ children: children, isEnabled: isEnabled, onMouseDown: onMouseDown })=>{
    return isEnabled ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, jsx-a11y/no-static-element-interactions -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $4661c12157fe2c0e$var$_ref,
        onMouseDown: onMouseDown
    }, children) : children;
};
var $4661c12157fe2c0e$export$2e2bcd8739ae039 = $4661c12157fe2c0e$var$ValueContainerWrapper;

});


parcelRegister("3QONt", function(module, exports) {

$parcel$export(module.exports, "Option", () => $99bbff5d4b124ec0$export$36d18380658d5d20);

var $2OMIu = parcelRequire("2OMIu");

var $MHKc7 = parcelRequire("MHKc7");

var $bChGW = parcelRequire("bChGW");

var $3bDjY = parcelRequire("3bDjY");

var $5uXOq = parcelRequire("5uXOq");

var $7SChb = parcelRequire("7SChb");

var $IMPHa = parcelRequire("IMPHa");

var $8QliZ = parcelRequire("8QliZ");

var $jC9IK = parcelRequire("jC9IK");

var $3SqqV = parcelRequire("3SqqV");

var $f4ndh = parcelRequire("f4ndh");

var $3smIt = parcelRequire("3smIt");

var $M0UM1 = parcelRequire("M0UM1");
const $99bbff5d4b124ec0$var$defaultOption = ({ data: { data: data }, isSelected: isSelected, status: status })=>// @ts-expect-error - <UserOption> expects `data` to be of User interface, but data is OptionData interface by default. Check if the `user` props in UserOption should also accept OptionData or refactor this file to accept generics
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7SChb.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
const $99bbff5d4b124ec0$var$dataOption = ({ data: { data: data }, isSelected: isSelected, status: status, selectProps: selectProps })=>{
    if ((0, $3smIt.isExternalUser)(data)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $IMPHa.default), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $3smIt.isUser)(data)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7SChb.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $3smIt.isEmail)(data)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3SqqV.default), {
        email: data,
        emailValidity: (0, $M0UM1.isValidEmail)(data.id),
        isSelected: isSelected,
        label: selectProps.emailLabel
    });
    if ((0, $3smIt.isTeam)(data)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8QliZ.default), {
        team: data,
        isSelected: isSelected
    });
    if ((0, $3smIt.isGroup)(data)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jC9IK.default), {
        group: data,
        isSelected: isSelected
    });
    if ((0, $3smIt.isCustom)(data)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4ndh.default), {
        data: data,
        isSelected: isSelected
    });
    return null;
};
const $99bbff5d4b124ec0$var$dataOptionWithTooltip = (props)=>{
    if (props.data?.data?.tooltip) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: props.data?.data?.tooltip,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                ...tooltipProps,
                children: $99bbff5d4b124ec0$var$dataOption(props)
            })
    });
    return $99bbff5d4b124ec0$var$dataOption(props);
};
const $99bbff5d4b124ec0$export$36d18380658d5d20 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).Option, {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Suspense, {
            fallback: $99bbff5d4b124ec0$var$defaultOption(props),
            children: $99bbff5d4b124ec0$var$dataOptionWithTooltip(props)
        })
    });

});
parcelRegister("7SChb", function(module, exports) {

$parcel$export(module.exports, "UserOption", () => $f97ab606ddc0972b$export$8e59f78010871662);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 

var $f8Sb3 = parcelRequire("f8Sb3");

var $5uXOq = parcelRequire("5uXOq");

var $bfXHv = parcelRequire("bfXHv");

var $1Y8bw = parcelRequire("1Y8bw");

var $5pJx4 = parcelRequire("5pJx4");

var $3smIt = parcelRequire("3smIt");

var $VSDnB = parcelRequire("VSDnB");
class $f97ab606ddc0972b$export$8e59f78010871662 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bfXHv.AvatarItemOption), {
            avatar: this.renderAvatar(),
            lozenge: this.getLozengeProps(),
            isDisabled: this.props.user.isDisabled,
            primaryText: this.getPrimaryText(),
            secondaryText: this.renderSecondaryText()
        });
    }
    constructor(...args){
        super(...args), this.getPrimaryText = ()=>{
            const { user: { name: name, publicName: publicName, highlight: highlight } } = this.props;
            const result = [
                /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
                    key: "name",
                    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    css: (0, $bfXHv.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-text, ${0, $829f609a65d26a98$export$7d61b15e0da132af})`)
                }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1Y8bw.HighlightText), {
                    highlights: highlight && highlight.name
                }, name))
            ];
            if ((0, $3smIt.hasValue)(publicName) && name.trim() !== publicName.trim()) result.push(/*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
                key: "publicName"
            }, ' ', /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $bfXHv.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`)
            }, "(", /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1Y8bw.HighlightText), {
                highlights: highlight && highlight.publicName
            }, publicName), ")")));
            return result;
        }, this.renderSecondaryText = ()=>this.props.user.byline ? /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $bfXHv.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`)
            }, this.props.user.byline) : undefined, this.renderAvatar = ()=>{
            const { user: { avatarUrl: avatarUrl }, status: status } = this.props;
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5pJx4.SizeableAvatar), {
                appearance: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                (0, $VSDnB.fg)('platform-component-visual-refresh') ? 'medium' : 'big',
                src: avatarUrl,
                presence: status
            });
        }, this.getLozengeProps = ()=>typeof this.props.user.lozenge === 'string' ? {
                text: this.props.user.lozenge
            } : this.props.user.lozenge;
    }
}

});
parcelRegister("bfXHv", function(module, exports) {

$parcel$export(module.exports, "textWrapper", () => $9d51fec62de0f8e9$export$aa6223da92b253dd);
$parcel$export(module.exports, "AvatarItemOption", () => $9d51fec62de0f8e9$export$164a9d9b3b86dd0c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $aYAc3 = parcelRequire("aYAc3");

var $3smIt = parcelRequire("3smIt");
function $9d51fec62de0f8e9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

const $9d51fec62de0f8e9$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("7LtDy")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $9d51fec62de0f8e9$var$wrapper = (isDisabled)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        alignItems: 'center',
        boxSizing: 'border-box',
        display: 'flex',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1,
        outline: 'none',
        margin: 0,
        width: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: isDisabled ? "var(--ds-opacity-disabled, 0.4)" : undefined
    });
const $9d51fec62de0f8e9$var$optionWrapper = {
    name: "13552d7",
    styles: "max-width:100%;min-width:0;line-height:1.4;padding-left:var(--ds-space-100, 8px)"
};
const $9d51fec62de0f8e9$var$getTextStyle = (isSecondary)=>{
    const secondaryCssArgs = isSecondary ? {
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
    } : {};
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        margin: 0,
        overflowX: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...secondaryCssArgs
    });
};
const $9d51fec62de0f8e9$var$additionalInfo = {
    name: "1hvgowa",
    styles: "float:right;margin-left:var(--ds-space-100, 8px)"
};
const $9d51fec62de0f8e9$export$aa6223da92b253dd = (color)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'inline',
        color: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color
    });
const $9d51fec62de0f8e9$export$164a9d9b3b86dd0c = ({ avatar: avatar, isDisabled: isDisabled, lozenge: lozenge, primaryText: primaryText, secondaryText: secondaryText })=>{
    const renderLozenge = ()=>{
        if ((0, $3smIt.isLozengeText)(lozenge)) {
            if (lozenge?.tooltip) // Note that entire Lozenge must be wrapped in the Tooltip (rather than just the
            // Lozenge text) or tooltip won't work
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Suspense, {
                fallback: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aYAc3.default), lozenge, lozenge.text)
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)($9d51fec62de0f8e9$var$AsyncTooltip, {
                content: lozenge.tooltip
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aYAc3.default), lozenge, lozenge.text)));
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aYAc3.default), lozenge, lozenge.text);
        }
        return lozenge;
    };
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $9d51fec62de0f8e9$var$wrapper(isDisabled)
    }, avatar, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $9d51fec62de0f8e9$var$optionWrapper
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $9d51fec62de0f8e9$var$getTextStyle()
    }, primaryText), secondaryText && /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $9d51fec62de0f8e9$var$getTextStyle(true)
    }, secondaryText))), lozenge && /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $9d51fec62de0f8e9$var$additionalInfo
    }, renderLozenge())));
};

});

parcelRegister("1Y8bw", function(module, exports) {

$parcel$export(module.exports, "HighlightText", () => $dbc13bb98bfc2c59$export$bb02e7bc6e1a7119);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
class $dbc13bb98bfc2c59$export$bb02e7bc6e1a7119 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        const { children: children, highlights: highlights } = this.props;
        const parts = [];
        let lastIndex = 0;
        if (highlights) highlights.sort((a, b)=>a.start - b.start).reduce((highlights, highlight)=>{
            const lastHighlight = highlights[highlights.length - 1];
            if (!lastHighlight || highlight.start > lastHighlight.end + 1) return highlights.concat(highlight);
            if (highlight.end > lastHighlight.end) lastHighlight.end = highlight.end;
            return highlights;
        }, []).forEach((highlight)=>{
            const { start: start, end: end } = highlight;
            if (start >= end) return;
            if (start > lastIndex) parts.push({
                value: children.substring(lastIndex, start),
                matches: false
            });
            parts.push({
                value: children.substring(start, end + 1),
                matches: true
            });
            lastIndex = end + 1;
        });
        if (lastIndex < children.length) parts.push({
            value: children.substring(lastIndex, children.length),
            matches: false
        });
        return parts.map((part, index)=>{
            if (part.matches) return /*#__PURE__*/ (0, $2OMIu.jsx)("b", {
                children: part.value
            }, index);
            return part.value;
        });
    }
}

});


parcelRegister("IMPHa", function(module, exports) {

$parcel$export(module.exports, "default", () => $244ad38dc6a6e0e3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $244ad38dc6a6e0e3$var$AsyncExternalUserOption = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("gT7hv")).then((module)=>{
        return {
            default: module.ExternalUserOption
        };
    }));
var $244ad38dc6a6e0e3$export$2e2bcd8739ae039 = $244ad38dc6a6e0e3$var$AsyncExternalUserOption;

});
parcelRegister("gT7hv", function(module, exports) {

let $c4b76e5519d7804b$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c4b76e5519d7804b$var$load("76n7a"),
    $c4b76e5519d7804b$var$load("l253H"),
    $c4b76e5519d7804b$var$load("ffQaD"),
    $c4b76e5519d7804b$var$load("kvRbA"),
    $c4b76e5519d7804b$var$load("5VpQx")
]).then(()=>parcelRequire('358Ik'));

});


parcelRegister("8QliZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e55a6473b89765e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $6e55a6473b89765e$var$AsyncTeamOption = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("g6gqU")).then((module)=>{
        return {
            default: module.TeamOption
        };
    }));
var $6e55a6473b89765e$export$2e2bcd8739ae039 = $6e55a6473b89765e$var$AsyncTeamOption;

});
parcelRegister("g6gqU", function(module, exports) {

let $bb89f424849bb75d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bb89f424849bb75d$var$load("k9jju").then(()=>parcelRequire('8Pt0F'));

});


parcelRegister("jC9IK", function(module, exports) {

$parcel$export(module.exports, "default", () => $d883d47691bcfd0f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $d883d47691bcfd0f$var$AsyncGroupOption = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("itjaq")).then((module)=>{
        return {
            default: module.GroupOption
        };
    }));
var $d883d47691bcfd0f$export$2e2bcd8739ae039 = $d883d47691bcfd0f$var$AsyncGroupOption;

});
parcelRegister("itjaq", function(module, exports) {

let $d729cda1eb2cfa2f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d729cda1eb2cfa2f$var$load("ioajZ").then(()=>parcelRequire('ctysX'));

});


parcelRegister("3SqqV", function(module, exports) {

$parcel$export(module.exports, "default", () => $120c09dc4c3dec5f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $120c09dc4c3dec5f$var$AsyncEmailOption = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("8Wiyo")).then((module)=>{
        return {
            default: module.EmailOption
        };
    }));
var $120c09dc4c3dec5f$export$2e2bcd8739ae039 = $120c09dc4c3dec5f$var$AsyncEmailOption;

});
parcelRegister("8Wiyo", function(module, exports) {

let $682221e12a9af171$var$load = (parcelRequire("28QjX"))(4);
module.exports = $682221e12a9af171$var$load("9zytF").then(()=>parcelRequire('4CChz'));

});


parcelRegister("f4ndh", function(module, exports) {

$parcel$export(module.exports, "default", () => $57cc7ffb924c0e65$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $57cc7ffb924c0e65$var$AsyncCustomOption = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("W94KR")).then((module)=>{
        return {
            default: module.CustomOption
        };
    }));
var $57cc7ffb924c0e65$export$2e2bcd8739ae039 = $57cc7ffb924c0e65$var$AsyncCustomOption;

});
parcelRegister("W94KR", function(module, exports) {

let $0aec75234bb4e828$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0aec75234bb4e828$var$load("bkE8d").then(()=>parcelRequire('iphiD'));

});


parcelRegister("M0UM1", function(module, exports) {

$parcel$export(module.exports, "isValidEmail", () => $8e40db00ccd032ac$export$371e338370561054);
const $8e40db00ccd032ac$var$validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
const $8e40db00ccd032ac$var$potentialRegex = /^[^\s@]+@[^\s@]*$/i;
const $8e40db00ccd032ac$export$371e338370561054 = (inputText)=>{
    if (inputText.match($8e40db00ccd032ac$var$validRegex)) return 'VALID';
    if (inputText.match($8e40db00ccd032ac$var$potentialRegex)) return 'POTENTIAL';
    return 'INVALID';
};

});


parcelRegister("6Kkci", function(module, exports) {

$parcel$export(module.exports, "SingleValue", () => $667e1159563155af$export$1949dac661ba6e3a);
/* SingleValue.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bChGW = parcelRequire("bChGW");

var $5pJx4 = parcelRequire("5pJx4");

var $3smIt = parcelRequire("3smIt");

var $fuhQD = parcelRequire("fuhQD");

var $MHKc7 = parcelRequire("MHKc7");
var $bUmQV = parcelRequire("bUmQV");
var $c0aEF = parcelRequire("c0aEF");
const $667e1159563155af$var$styles = {
    avatarItem: "_1reo15vq _18m915vq _4cvr1h6o _1ul953f4",
    avatarItemTextWrapper: "_16jlkb7n _1o9zkb7n _i0dl1osq _1ul9idpf _p12f1osq _bozgu2gc _vwz419ii",
    avatarItemText: "_syaz1fxt _1reo15vq _1bto1l2s _o5721q9c"
};
const $667e1159563155af$var$ElementAfter = (props)=>{
    const { data: { data: data } } = props;
    if ((0, $3smIt.isTeam)(data) && data.verified) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fuhQD.VerifiedTeamIcon), {});
    return null;
};
const $667e1159563155af$export$1949dac661ba6e3a = (props)=>{
    const { data: { label: label, data: data }, //@ts-ignore react-select unsupported props
    selectProps: { appearance: appearance, isFocused: isFocused } } = props;
    return !isFocused ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).SingleValue, {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bUmQV.default), {
            xcss: $667e1159563155af$var$styles.avatarItem,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5pJx4.SizeableAvatar), {
                    src: (0, $3smIt.getAvatarUrl)(data),
                    appearance: appearance,
                    type: (0, $3smIt.isTeam)(data) ? 'team' : 'person'
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    xcss: $667e1159563155af$var$styles.avatarItem,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            $667e1159563155af$var$styles.avatarItemTextWrapper
                        ]),
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            xcss: $667e1159563155af$var$styles.avatarItemText,
                            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                                alignBlock: "center",
                                children: [
                                    label,
                                    /*#__PURE__*/ (0, $2OMIu.jsx)($667e1159563155af$var$ElementAfter, {
                                        ...props
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    }) : null;
};

});

parcelRegister("OxpB4", function(module, exports) {

$parcel$export(module.exports, "Input", () => $98c53988263e2c5c$export$f5b8910cec6cf069);
/* Input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");
const $98c53988263e2c5c$var$inputStyles = {
    root: "_5ce6131l _1ir3kb7n _h5gq131l"
};
class $98c53988263e2c5c$export$f5b8910cec6cf069 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    /**
   * Overrides the default behaviour of react-select lib
   *
   * The getter is a workaround for original behaviour of the react-select lib.
   * Placeholder and Input are linked not via label, aria-label or aria-labeledby, but through aria-describedby.
   * Basically in the getter we reassign Placeholder ID from aria-describedby to aria-labelledby
   * {@link https://github.com/JedWatson/react-select/issues/5651#issue-1731353197 GitHub}
   */ get ariaLabelledBy() {
        return this.props['aria-labelledby'] ?? this.props['aria-describedby'];
    }
    get ariaDescribedBy() {
        return this.props.selectProps?.['aria-describedby'] ?? this.props['aria-describedby'];
    }
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).Input, {
            ...this.props,
            "aria-labelledby": this.ariaLabelledBy,
            "aria-describedby": this.ariaDescribedBy,
            innerRef: this.props.innerRef,
            onKeyPress: this.handleKeyPress,
            xcss: $98c53988263e2c5c$var$inputStyles.root
        });
    }
    constructor(...args){
        super(...args), // onKeyPress is used instead as
        // react-select is using onKeyDown for capturing keyboard input
        this.handleKeyPress = (e)=>{
            if (e.key === 'Enter') e.preventDefault();
            //@ts-ignore react-select unsupported props
            if (this.props.selectProps?.disableInput) e.preventDefault();
        };
    }
}

});

parcelRegister("ee8bl", function(module, exports) {

$parcel$export(module.exports, "SingleValueContainer", () => $bd8914f05f01f9cc$export$afa5f855316c6a48);
/* SingleValueContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");

var $5pJx4 = parcelRequire("5pJx4");

var $jNYXM = parcelRequire("jNYXM");
const $bd8914f05f01f9cc$var$valueContainerStyles = {
    root: "_yv0e5bpd _ca0q12x7 _n3td12x7 _19bvze3t _1reo15vq _18m91wug _1fjgglyw _c71l1osq _1suq18uv _1ke8idpf"
};
const $bd8914f05f01f9cc$var$placeholderIconContainer = null;
const $bd8914f05f01f9cc$var$wrapperStyle = null;
const $bd8914f05f01f9cc$var$showUserAvatar = (inputValue, value)=>value && value.data && inputValue === value.label;
class $bd8914f05f01f9cc$export$afa5f855316c6a48 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { children: children, ...valueContainerProps } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jNYXM.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bChGW.components).ValueContainer, {
                ...valueContainerProps,
                xcss: $bd8914f05f01f9cc$var$valueContainerStyles.root,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            "_nd5l1kqh _19bv12x7 _vwz4idpf"
                        ]),
                        children: this.renderAvatar()
                    }),
                    children
                ]
            })
        });
    }
    constructor(...args){
        super(...args), this.renderAvatar = ()=>{
            const { hasValue: hasValue, //@ts-ignore react-select unsupported props
            selectProps: { appearance: appearance, isFocused: isFocused, inputValue: inputValue, value: value, placeholderAvatar: placeholderAvatar } } = this.props;
            if (isFocused || !hasValue) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5pJx4.SizeableAvatar), {
                appearance: appearance,
                type: placeholderAvatar,
                src: $bd8914f05f01f9cc$var$showUserAvatar(inputValue, value) ? value.data.avatarUrl : undefined
            });
            return null;
        }, //@ts-ignore react-select unsupported props
        this.onValueContainerClick = this.props.selectProps.onValueContainerClick, this.Wrapper = ({ children: children })=>{
            return this.onValueContainerClick ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                onMouseDown: this.onValueContainerClick,
                className: (0, $bwpsq.default)([
                    "_16jlkb7n"
                ]),
                children: children
            }) : children;
        };
    }
}

});

parcelRegister("h3ej5", function(module, exports) {

$parcel$export(module.exports, "PopupInput", () => $be92b88945d06137$export$d8edbfd510a7db82);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $OxpB4 = parcelRequire("OxpB4");
class $be92b88945d06137$export$d8edbfd510a7db82 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidMount() {
        if (this.ref) // @ts-ignore
        this.ref.select();
    }
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $OxpB4.Input), {
            ...this.props,
            innerRef: this.handleInnerRef
        });
    }
    constructor(...args){
        super(...args), this.ref = null, this.handleInnerRef = (ref)=>{
            this.ref = ref;
            if (this.props.innerRef) this.props.innerRef(ref);
        };
    }
}

});

parcelRegister("6Ks8i", function(module, exports) {

$parcel$export(module.exports, "PopupControl", () => $77b9c0d4ebdf44c2$export$a0cb1b4352357fcc);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $7mofJ = parcelRequire("7mofJ");
const $77b9c0d4ebdf44c2$var$controlWrapper = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    flexDirection: 'column',
    padding: `0px ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
});
const $77b9c0d4ebdf44c2$var$labelStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    paddingBottom: "var(--ds-space-050, 4px)",
    paddingLeft: "var(--ds-space-0, 0px)",
    paddingRight: "var(--ds-space-0, 0px)",
    paddingTop: "var(--ds-space-250, 20px)"
});
class $77b9c0d4ebdf44c2$export$a0cb1b4352357fcc extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        const { //@ts-ignore react-select unsupported props
        selectProps: { popupTitle: popupTitle } } = this.props;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $77b9c0d4ebdf44c2$var$controlWrapper
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $77b9c0d4ebdf44c2$var$labelStyle
        }, popupTitle), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7mofJ.default), this.props));
    }
}

});
parcelRegister("7mofJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eb2a834f44e793b$export$2e2bcd8739ae039);
/* Control.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");

var $DEWI6 = parcelRequire("DEWI6");
const $6eb2a834f44e793b$var$controlStyles = {
    invalid: "_1h6d1bqt _4cvx1bqt",
    focused: "_1h6d1p6i _bfhk1j9a _4cvx1p6i _irr31j9a",
    disabled: "_irr3syzs",
    subtle: "_1h6d3acm _bfhk18uv _4cvx3acm _irr31gly",
    root: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1h6d1elr _bfhk1j9a _p12f1osq _14regrf3 _4cvx1elr _irr31d5g _1a98zg3v",
    compact: "_1tke1wug"
};
const $6eb2a834f44e793b$var$Control = (props)=>{
    const isCompact = props.appearance === 'compact';
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).Control, {
        ...props,
        xcss: (0, $DEWI6.cx)($6eb2a834f44e793b$var$controlStyles.root, isCompact && $6eb2a834f44e793b$var$controlStyles.compact, (props.selectProps.subtle || props.selectProps.noBorder) && $6eb2a834f44e793b$var$controlStyles.subtle, props.isFocused && $6eb2a834f44e793b$var$controlStyles.focused, props.isInvalid && $6eb2a834f44e793b$var$controlStyles.invalid, props.isDisabled && $6eb2a834f44e793b$var$controlStyles.disabled)
    });
};
var $6eb2a834f44e793b$export$2e2bcd8739ae039 = $6eb2a834f44e793b$var$Control;

});


parcelRegister("lYehz", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $9f291598157d275c$export$d9b273488cd8ce6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");

var $f8Sb3 = parcelRequire("f8Sb3");
const $9f291598157d275c$var$getFooterStyle = ()=>{
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`
    });
};
class $9f291598157d275c$export$d9b273488cd8ce6f extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bChGW.components).Menu, this.props, this.props.selectProps.header, this.props.children, this.props.selectProps.footer && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $9f291598157d275c$var$getFooterStyle()
        }, this.props.selectProps.footer));
    }
}

});


parcelRegister("fuG1P", function(module, exports) {

$parcel$export(module.exports, "getCreatableProps", () => $3865687a924ab788$export$36f97d8afa97203d);

var $8QpSo = parcelRequire("8QpSo");


var $M0UM1 = parcelRequire("M0UM1");

var $3smIt = parcelRequire("3smIt");
const $3865687a924ab788$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $3865687a924ab788$var$isValidNewOption = (isValidEmail = (0, $M0UM1.isValidEmail))=>(inputValue)=>inputValue && $3865687a924ab788$var$validOption.includes(isValidEmail(inputValue));
const $3865687a924ab788$var$getNewOptionData = (inputValue)=>({
        label: inputValue,
        value: inputValue,
        data: {
            id: inputValue,
            name: inputValue,
            type: (0, $f93312f7d4958f08$export$6662b3461398ef8c)
        }
    });
const $3865687a924ab788$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
const $3865687a924ab788$var$isOptionDisabled = (isValidEmail = (0, $M0UM1.isValidEmail))=>(option)=>{
        if ((0, $3smIt.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
function $3865687a924ab788$var$creatableProps(isValidEmail) {
    return {
        allowCreateWhileLoading: true,
        createOptionPosition: 'first',
        isValidNewOption: $3865687a924ab788$var$isValidNewOption(isValidEmail),
        getNewOptionData: $3865687a924ab788$var$getNewOptionData,
        formatCreateLabel: $3865687a924ab788$var$formatCreateLabel,
        isOptionDisabled: $3865687a924ab788$var$isOptionDisabled(isValidEmail)
    };
}
const $3865687a924ab788$export$36f97d8afa97203d = (0, $8QpSo.default)($3865687a924ab788$var$creatableProps);

});

parcelRegister("hcX3V", function(module, exports) {

$parcel$export(module.exports, "getCreatableSuggestedEmailProps", () => $fd587de6edc26aae$export$34b9dd2dd6a225e5);

var $8QpSo = parcelRequire("8QpSo");


var $M0UM1 = parcelRequire("M0UM1");

var $3smIt = parcelRequire("3smIt");
const $fd587de6edc26aae$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $fd587de6edc26aae$var$isValidNewOption = (inputValue)=>inputValue && inputValue.length > 0;
// Generates suggested option data based on user input and validity of the input (if it is an email or not);
const $fd587de6edc26aae$var$getNewOptionData = (isValidEmail = (0, $M0UM1.isValidEmail), emailDomain)=>(inputValue)=>{
        if (!inputValue) return null;
        const isEmail = inputValue && $fd587de6edc26aae$var$validOption.includes(isValidEmail(inputValue));
        const value = isEmail ? inputValue : `${inputValue.replace(/\s+/g, '.').toLocaleLowerCase()}@${emailDomain}`;
        return {
            label: value,
            value: value,
            data: {
                id: value,
                name: value,
                type: (0, $f93312f7d4958f08$export$6662b3461398ef8c),
                suggestion: true
            }
        };
    };
const $fd587de6edc26aae$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
// Option will not be selectable until the email value is valid and can actually be invited
const $fd587de6edc26aae$var$isOptionDisabled = (isValidEmail = (0, $M0UM1.isValidEmail))=>(option)=>{
        if ((0, $3smIt.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
const $fd587de6edc26aae$export$34b9dd2dd6a225e5 = (0, $8QpSo.default)((emailDomain, isValidEmail)=>({
        allowCreateWhileLoading: true,
        createOptionPosition: 'last',
        isValidNewOption: $fd587de6edc26aae$var$isValidNewOption,
        getNewOptionData: $fd587de6edc26aae$var$getNewOptionData(isValidEmail, emailDomain),
        formatCreateLabel: $fd587de6edc26aae$var$formatCreateLabel,
        isOptionDisabled: $fd587de6edc26aae$var$isOptionDisabled(isValidEmail)
    }));

});

parcelRegister("hrO1B", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ce4a8fbf6631c4e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
var $koVbs = parcelRequire("koVbs");

var $55C8M = parcelRequire("55C8M");
const $9ce4a8fbf6631c4e$var$EMPTY = {};
const $9ce4a8fbf6631c4e$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState($9ce4a8fbf6631c4e$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        let aborted = false;
        setMessages($9ce4a8fbf6631c4e$var$EMPTY);
        (0, $55C8M.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $9ce4a8fbf6631c4e$var$MessagesIntlProvider = (props)=>{
    const intl = (0, $koVbs.default)();
    const { children: children } = props;
    const messages = $9ce4a8fbf6631c4e$var$useI18n(intl.locale);
    const mergedMessages = (0, $5uXOq.useMemo)(()=>{
        return {
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        locale: intl.locale,
        messages: mergedMessages,
        children: children
    });
};
var $9ce4a8fbf6631c4e$export$2e2bcd8739ae039 = $9ce4a8fbf6631c4e$var$MessagesIntlProvider;

});
parcelRegister("55C8M", function(module, exports) {

$parcel$export(module.exports, "getMessagesForLocale", () => $0d1c237fd5360db1$export$d0a3169680473b6c);
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 






























const $0d1c237fd5360db1$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("7TrNZ")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("3lWdn")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("gNYF5")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("jx20s")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("9aFUO")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("hcdBd")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("kaMOK")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("165FN")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("dvcHU")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("5pesY")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("eSVh1")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("8HbNS")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("Mrs7A")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("4ye7l")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("4I12K")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("aARxM")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("bxBuP")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("aQg55")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("htQcP")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("d5lg2")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("lXPIH")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("41gMk")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("9DVE4")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("8Jioj")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("2jTS5")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("9TVGV")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("6VgXS")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("lXFa5")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("3gRXd")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("ffFsD")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $0d1c237fd5360db1$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("jx20s")).then((mod)=>mod.default);
            }
    }
};

});
parcelRegister("7TrNZ", function(module, exports) {

let $5bf33d009296abd9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5bf33d009296abd9$var$load("cv5rt").then(()=>parcelRequire('gXZJY'));

});

parcelRegister("3lWdn", function(module, exports) {

let $27107d7ab4c49873$var$load = (parcelRequire("28QjX"))(4);
module.exports = $27107d7ab4c49873$var$load("ONW5s").then(()=>parcelRequire('4a4Fm'));

});

parcelRegister("gNYF5", function(module, exports) {

let $c3c04714a27b2410$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c3c04714a27b2410$var$load("gkfia").then(()=>parcelRequire('l8jlf'));

});

parcelRegister("jx20s", function(module, exports) {

let $e382a7ce8bb2b99b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e382a7ce8bb2b99b$var$load("6hHYZ").then(()=>parcelRequire('8JpVG'));

});

parcelRegister("9aFUO", function(module, exports) {

let $6ad58fbedf6184c4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6ad58fbedf6184c4$var$load("eLwwW").then(()=>parcelRequire('e3biM'));

});

parcelRegister("hcdBd", function(module, exports) {

let $c84e1b2a445ef131$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c84e1b2a445ef131$var$load("6eYlN").then(()=>parcelRequire('dnuc7'));

});

parcelRegister("kaMOK", function(module, exports) {

let $eafa9bf48b2fac51$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eafa9bf48b2fac51$var$load("31PjN").then(()=>parcelRequire('l3vqz'));

});

parcelRegister("165FN", function(module, exports) {

let $0ccac092711a19a9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0ccac092711a19a9$var$load("8IqzF").then(()=>parcelRequire('4oZES'));

});

parcelRegister("dvcHU", function(module, exports) {

let $9d480705cbcaa25e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9d480705cbcaa25e$var$load("256dS").then(()=>parcelRequire('2WBzr'));

});

parcelRegister("5pesY", function(module, exports) {

let $3efa8242ee690e64$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3efa8242ee690e64$var$load("kDYdC").then(()=>parcelRequire('bfZBm'));

});

parcelRegister("eSVh1", function(module, exports) {

let $ad62892a05474011$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ad62892a05474011$var$load("lP2Aa").then(()=>parcelRequire('1tcJ6'));

});

parcelRegister("8HbNS", function(module, exports) {

let $654b7ed3d6586020$var$load = (parcelRequire("28QjX"))(4);
module.exports = $654b7ed3d6586020$var$load("ld26n").then(()=>parcelRequire('4duqz'));

});

parcelRegister("Mrs7A", function(module, exports) {

let $0919c7516734ef5d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0919c7516734ef5d$var$load("3q19A").then(()=>parcelRequire('dizwu'));

});

parcelRegister("4ye7l", function(module, exports) {

let $350549d1fd60171a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $350549d1fd60171a$var$load("helYz").then(()=>parcelRequire('9N5CX'));

});

parcelRegister("4I12K", function(module, exports) {

let $36dc14a553266047$var$load = (parcelRequire("28QjX"))(4);
module.exports = $36dc14a553266047$var$load("lGJ1k").then(()=>parcelRequire('aZBlm'));

});

parcelRegister("aARxM", function(module, exports) {

let $7b66ccdcda2149d7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7b66ccdcda2149d7$var$load("TA9hJ").then(()=>parcelRequire('fGwOM'));

});

parcelRegister("bxBuP", function(module, exports) {

let $866fdcbffc96f227$var$load = (parcelRequire("28QjX"))(4);
module.exports = $866fdcbffc96f227$var$load("9FIYu").then(()=>parcelRequire('NLRKB'));

});

parcelRegister("aQg55", function(module, exports) {

let $7e4b3c14f09d0c24$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7e4b3c14f09d0c24$var$load("9moVt").then(()=>parcelRequire('cHWkp'));

});

parcelRegister("htQcP", function(module, exports) {

let $cb9da419ae7374ca$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cb9da419ae7374ca$var$load("bIWCv").then(()=>parcelRequire('d6RJ6'));

});

parcelRegister("d5lg2", function(module, exports) {

let $986c3b57115de466$var$load = (parcelRequire("28QjX"))(4);
module.exports = $986c3b57115de466$var$load("fEUOy").then(()=>parcelRequire('bPIQC'));

});

parcelRegister("lXPIH", function(module, exports) {

let $ffd73a290ae80ed0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ffd73a290ae80ed0$var$load("j43ie").then(()=>parcelRequire('foWaf'));

});

parcelRegister("41gMk", function(module, exports) {

let $2ed4454a726f498f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2ed4454a726f498f$var$load("GRoHb").then(()=>parcelRequire('d41ym'));

});

parcelRegister("9DVE4", function(module, exports) {

let $705478ba40008bec$var$load = (parcelRequire("28QjX"))(4);
module.exports = $705478ba40008bec$var$load("7wDic").then(()=>parcelRequire('77rKe'));

});

parcelRegister("8Jioj", function(module, exports) {

let $65b0cac59b8f215e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $65b0cac59b8f215e$var$load("ik6sd").then(()=>parcelRequire('lwY85'));

});

parcelRegister("2jTS5", function(module, exports) {

let $1b08b2041f62e4db$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1b08b2041f62e4db$var$load("4vjX8").then(()=>parcelRequire('j3ZnO'));

});

parcelRegister("9TVGV", function(module, exports) {

let $7356006d07924f6b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7356006d07924f6b$var$load("jr7Jf").then(()=>parcelRequire('I9Pmk'));

});

parcelRegister("6VgXS", function(module, exports) {

let $50a539c60c886dd1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $50a539c60c886dd1$var$load("eQIEO").then(()=>parcelRequire('h4y14'));

});

parcelRegister("lXFa5", function(module, exports) {

let $ffcf0986a701d607$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ffcf0986a701d607$var$load("ex1MV").then(()=>parcelRequire('6gWmN'));

});

parcelRegister("3gRXd", function(module, exports) {

let $261cb7dfe9582ffc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $261cb7dfe9582ffc$var$load("kGDgz").then(()=>parcelRequire('haTkv'));

});

parcelRegister("ffFsD", function(module, exports) {

let $b1a86afc6c5e51e5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b1a86afc6c5e51e5$var$load("5JcYp").then(()=>parcelRequire('lbgbB'));

});



parcelRegister("2vFqP", function(module, exports) {

$parcel$export(module.exports, "ExusUserSourceProvider", () => $4629e0617f660bbc$export$bcd5c65b586ee3c3);
$parcel$export(module.exports, "useUserSource", () => $4629e0617f660bbc$export$c6c0c1a2bac363f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $4629e0617f660bbc$var$ExusUserSourceContext = /*#__PURE__*/ (0, $5uXOq.createContext)({});
const $4629e0617f660bbc$export$bcd5c65b586ee3c3 = ({ fetchUserSource: fetchUserSource, children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)($4629e0617f660bbc$var$ExusUserSourceContext.Provider, {
        value: {
            fetchUserSource: fetchUserSource
        },
        children: children
    });
const $4629e0617f660bbc$export$c6c0c1a2bac363f = (accountId, shouldFetchSources, existingSources)=>{
    const { fetchUserSource: fetchUserSource } = (0, $5uXOq.useContext)($4629e0617f660bbc$var$ExusUserSourceContext);
    const [externalSources, setExternalSources] = (0, $5uXOq.useState)([]);
    const [loading, setLoading] = (0, $5uXOq.useState)(true);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const abortController = (0, $5uXOq.useMemo)(()=>{
        if (typeof AbortController === 'undefined') return;
        return new AbortController();
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        let isMounted = true;
        const cleanup = ()=>{
            abortController?.abort();
            isMounted = false;
        };
        if (!fetchUserSource || !shouldFetchSources) {
            setLoading(false);
            return cleanup;
        }
        fetchUserSource(accountId, abortController?.signal).then((externalSources)=>{
            if (!isMounted) return;
            setLoading(false);
            const externalSourceTypes = externalSources.map((source)=>source.sourceType);
            setExternalSources(externalSourceTypes);
        }).catch((error)=>{
            if (!isMounted) return;
            setLoading(false);
            setError(error);
        });
        return cleanup;
    }, [
        fetchUserSource,
        accountId,
        abortController,
        shouldFetchSources
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            sources: Array.from(new Set([
                ...existingSources ?? [],
                ...externalSources
            ])),
            loading: loading,
            error: error
        }), [
        error,
        existingSources,
        externalSources,
        loading
    ]);
};

});


parcelRegister("4Mwus", function(module, exports) {

$parcel$export(module.exports, "createAndFireEventInElementsChannel", () => $e9f71e1c1698f563$export$53eef0dcd9611650);
$parcel$export(module.exports, "preparedUsersLoadedEvent", () => $e9f71e1c1698f563$export$185f4c3d9b7ef9bf);
$parcel$export(module.exports, "mountedWithPrefetchEvent", () => $e9f71e1c1698f563$export$9cfb4251e50d7b91);
$parcel$export(module.exports, "filterUsersEvent", () => $e9f71e1c1698f563$export$fbba77127d7cb173);
$parcel$export(module.exports, "requestUsersEvent", () => $e9f71e1c1698f563$export$1762ed8845ff2d9b);
$parcel$export(module.exports, "successfulRequestUsersEvent", () => $e9f71e1c1698f563$export$bfc020018aa738d0);
$parcel$export(module.exports, "failedRequestUsersEvent", () => $e9f71e1c1698f563$export$738aca68b593db8e);

var $gB4mS = parcelRequire("gB4mS");

var $7Jxgt = parcelRequire("7Jxgt");
const $e9f71e1c1698f563$var$packageName = "platform-pkg";
const $e9f71e1c1698f563$var$packageVersion = "0.0.0-use.local";
const $e9f71e1c1698f563$export$c0d84948cecf78d8 = ()=>({
        id: (0, $7Jxgt.v4)(),
        start: Date.now(),
        inputChangeTime: Date.now(),
        upCount: 0,
        downCount: 0,
        lastKey: undefined
    });
const $e9f71e1c1698f563$export$53eef0dcd9611650 = (0, $gB4mS.default)('fabric-elements');
const $e9f71e1c1698f563$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            packageName: $e9f71e1c1698f563$var$packageName,
            packageVersion: $e9f71e1c1698f563$var$packageVersion,
            ...attributes
        }
    });
const $e9f71e1c1698f563$var$createDefaultSmartPickerAttributes = (props, state)=>{
    const { fieldId: fieldId, objectId: objectId, containerId: containerId, childObjectId: childObjectId, prefetch: prefetch, maxOptions: maxOptions, includeTeams: includeTeams, productKey: productKey, principalId: principalId, siteId: siteId, orgId: orgId, filterOptions: filterOptions } = props;
    const { sessionId: sessionId, query: query } = state;
    const maxNumberOfResults = maxOptions || 100;
    return {
        context: fieldId,
        childObjectId: childObjectId,
        containerId: containerId,
        hasFilterOptions: Boolean(filterOptions),
        includeTeams: includeTeams,
        maxNumberOfResults: maxNumberOfResults,
        objectId: objectId,
        prefetch: prefetch,
        principalId: principalId,
        productKey: productKey,
        queryLength: (query || '').length,
        siteId: siteId,
        orgId: orgId,
        sessionId: sessionId
    };
};
const $e9f71e1c1698f563$var$createSmartUserPickerEvent = (action, actionSubect, attributes = {})=>({
        source: 'smart-user-picker',
        ...$e9f71e1c1698f563$var$createEvent('operational', action, actionSubect, attributes)
    });
const $e9f71e1c1698f563$export$185f4c3d9b7ef9bf = (props, state, attributes = {})=>$e9f71e1c1698f563$var$createSmartUserPickerEvent('loaded', 'preparedUsers', {
        ...$e9f71e1c1698f563$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $e9f71e1c1698f563$export$9cfb4251e50d7b91 = (props, state, attributes = {})=>$e9f71e1c1698f563$var$createSmartUserPickerEvent('mounted', 'prefetch', {
        ...$e9f71e1c1698f563$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $e9f71e1c1698f563$export$fbba77127d7cb173 = (props, state, attributes = {})=>$e9f71e1c1698f563$var$createSmartUserPickerEvent('filtered', 'users', {
        ...$e9f71e1c1698f563$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $e9f71e1c1698f563$export$1762ed8845ff2d9b = (props, state, attributes = {})=>$e9f71e1c1698f563$var$createSmartUserPickerEvent('requested', 'users', {
        ...$e9f71e1c1698f563$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $e9f71e1c1698f563$export$bfc020018aa738d0 = (props, state, attributes = {})=>$e9f71e1c1698f563$var$createSmartUserPickerEvent('successful', 'usersRequest', {
        ...$e9f71e1c1698f563$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $e9f71e1c1698f563$export$738aca68b593db8e = (props, state, attributes = {})=>$e9f71e1c1698f563$var$createSmartUserPickerEvent('failed', 'usersRequest', {
        ...$e9f71e1c1698f563$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });

});

parcelRegister("lO1N9", function(module, exports) {

$parcel$export(module.exports, "default", () => $56606639d6bbed24$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");
var $i5FdW = parcelRequire("i5FdW");

var $j8CnN = parcelRequire("j8CnN");
const $56606639d6bbed24$var$EMPTY = {};
const $56606639d6bbed24$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState($56606639d6bbed24$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        let aborted = false;
        setMessages($56606639d6bbed24$var$EMPTY);
        (0, $j8CnN.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $56606639d6bbed24$var$MessagesIntlProvider = (props)=>{
    const { intl: intl, children: children } = props;
    const messages = $56606639d6bbed24$var$useI18n(intl.locale);
    const mergedMessages = (0, $5uXOq.useMemo)(()=>{
        return {
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        locale: intl.locale,
        messages: mergedMessages,
        children: children
    });
};
var $56606639d6bbed24$export$2e2bcd8739ae039 = (0, $8RXs9.default)($56606639d6bbed24$var$MessagesIntlProvider);

});
parcelRegister("j8CnN", function(module, exports) {

$parcel$export(module.exports, "getMessagesForLocale", () => $2d5115da3ffac2ef$export$d0a3169680473b6c);
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 





























const $2d5115da3ffac2ef$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("hob2N")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("lC9MW")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("8ixEi")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("gZyyz")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("5H1aF")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("49T1Q")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("hF9Sl")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("52jiR")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("BSoaB")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("kN8bS")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("b0bXm")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("a5kHZ")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("5lbHl")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("qndXj")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("2XGVI")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("hSVCm")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("hDXjU")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("inZM3")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("c6rhA")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("kaSBx")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("ecrwY")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("eIZMu")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("4vQU9")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("4oA0d")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("2dfMX")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("bKKdh")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("asRtu")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("kvhp3")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("6Ssvo")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $2d5115da3ffac2ef$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("gZyyz")).then((mod)=>mod.default);
            }
    }
};

});
parcelRegister("hob2N", function(module, exports) {

let $ca8d3eaf81297afa$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ca8d3eaf81297afa$var$load("5yr7a").then(()=>parcelRequire('hTttX'));

});

parcelRegister("lC9MW", function(module, exports) {

let $fbc4bd5c14468f78$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fbc4bd5c14468f78$var$load("9m1m1").then(()=>parcelRequire('fO125'));

});

parcelRegister("8ixEi", function(module, exports) {

let $60aa1b22031a3006$var$load = (parcelRequire("28QjX"))(4);
module.exports = $60aa1b22031a3006$var$load("cPL9a").then(()=>parcelRequire('i9hQB'));

});

parcelRegister("gZyyz", function(module, exports) {

let $c5ed260ec2a3ebd5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c5ed260ec2a3ebd5$var$load("gR9lo").then(()=>parcelRequire('fbTE6'));

});

parcelRegister("5H1aF", function(module, exports) {

let $4251e072d1a7d0ed$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4251e072d1a7d0ed$var$load("6ORqd").then(()=>parcelRequire('2jzdD'));

});

parcelRegister("49T1Q", function(module, exports) {

let $3072b040dc823420$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3072b040dc823420$var$load("1nsOG").then(()=>parcelRequire('9zjC3'));

});

parcelRegister("hF9Sl", function(module, exports) {

let $cdbded122cdbfbf0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cdbded122cdbfbf0$var$load("i2Mlg").then(()=>parcelRequire('3f70t'));

});

parcelRegister("52jiR", function(module, exports) {

let $3aac1ce25b301594$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3aac1ce25b301594$var$load("b3LV2").then(()=>parcelRequire('kK8ZL'));

});

parcelRegister("BSoaB", function(module, exports) {

let $071da54e7a005c75$var$load = (parcelRequire("28QjX"))(4);
module.exports = $071da54e7a005c75$var$load("bhbid").then(()=>parcelRequire('lGM67'));

});

parcelRegister("kN8bS", function(module, exports) {

let $f22ebcb792dcb433$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f22ebcb792dcb433$var$load("jhKC9").then(()=>parcelRequire('jXmR0'));

});

parcelRegister("b0bXm", function(module, exports) {

let $8028f813f42bac77$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8028f813f42bac77$var$load("2ttjH").then(()=>parcelRequire('47jiC'));

});

parcelRegister("a5kHZ", function(module, exports) {

let $757a6f45fa14e89e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $757a6f45fa14e89e$var$load("kIyd3").then(()=>parcelRequire('lzA6o'));

});

parcelRegister("5lbHl", function(module, exports) {

let $3e37fce68ffe5148$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3e37fce68ffe5148$var$load("gWVRl").then(()=>parcelRequire('hsl5L'));

});

parcelRegister("qndXj", function(module, exports) {

let $04f471a4c0daf70a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $04f471a4c0daf70a$var$load("5ax0n").then(()=>parcelRequire('l7zWx'));

});

parcelRegister("2XGVI", function(module, exports) {

let $228264731e721e88$var$load = (parcelRequire("28QjX"))(4);
module.exports = $228264731e721e88$var$load("ainDE").then(()=>parcelRequire('hbdA6'));

});

parcelRegister("hSVCm", function(module, exports) {

let $d0542c7c0741a066$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d0542c7c0741a066$var$load("gWMGd").then(()=>parcelRequire('7V1eq'));

});

parcelRegister("hDXjU", function(module, exports) {

let $cd8417ef39f455f2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cd8417ef39f455f2$var$load("1I00e").then(()=>parcelRequire('dyLwU'));

});

parcelRegister("inZM3", function(module, exports) {

let $d62a4b03d22ba2fd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d62a4b03d22ba2fd$var$load("9nvFy").then(()=>parcelRequire('jHvZz'));

});

parcelRegister("c6rhA", function(module, exports) {

let $8cfb3558ec2d5c98$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8cfb3558ec2d5c98$var$load("9cwnq").then(()=>parcelRequire('98VHa'));

});

parcelRegister("kaSBx", function(module, exports) {

let $eaff19225745c390$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eaff19225745c390$var$load("8o3P2").then(()=>parcelRequire('3jBFZ'));

});

parcelRegister("ecrwY", function(module, exports) {

let $a5678abbf86327d9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a5678abbf86327d9$var$load("blljt").then(()=>parcelRequire('bxjPN'));

});

parcelRegister("eIZMu", function(module, exports) {

let $ab85192a8dc7056c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ab85192a8dc7056c$var$load("i2wZ7").then(()=>parcelRequire('9rrms'));

});

parcelRegister("4vQU9", function(module, exports) {

let $34931876365e7ccb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $34931876365e7ccb$var$load("5w5Mm").then(()=>parcelRequire('fcT12'));

});

parcelRegister("4oA0d", function(module, exports) {

let $333554a7ebc3e27f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $333554a7ebc3e27f$var$load("3uifh").then(()=>parcelRequire('aEMJ7'));

});

parcelRegister("2dfMX", function(module, exports) {

let $19c90af388719c67$var$load = (parcelRequire("28QjX"))(4);
module.exports = $19c90af388719c67$var$load("dO3PN").then(()=>parcelRequire('iMCZJ'));

});

parcelRegister("bKKdh", function(module, exports) {

let $88e7d696c3ba8032$var$load = (parcelRequire("28QjX"))(4);
module.exports = $88e7d696c3ba8032$var$load("05auF").then(()=>parcelRequire('3fBNA'));

});

parcelRegister("asRtu", function(module, exports) {

let $79e5ffded95d2f46$var$load = (parcelRequire("28QjX"))(4);
module.exports = $79e5ffded95d2f46$var$load("9b0Br").then(()=>parcelRequire('XsSGE'));

});

parcelRegister("kvhp3", function(module, exports) {

let $eed433d053f3a965$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eed433d053f3a965$var$load("2M8g7").then(()=>parcelRequire('gyRwx'));

});

parcelRegister("6Ssvo", function(module, exports) {

let $501de5cd6039a203$var$load = (parcelRequire("28QjX"))(4);
module.exports = $501de5cd6039a203$var$load("19P2f").then(()=>parcelRequire('8nTzb'));

});



parcelRegister("3Q8Js", function(module, exports) {

$parcel$export(module.exports, "default", () => $94c7434acb15702b$export$2e2bcd8739ae039);

var $f5wjp = parcelRequire("f5wjp");

var $lrQGi = parcelRequire("lrQGi");
const $94c7434acb15702b$var$getUserRecommendations = (request, intl)=>{
    const url = (0, $lrQGi.config).getRecommendationServiceUrl(request.baseUrl || '');
    return fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            context: request.context,
            includeUsers: request.includeUsers,
            includeGroups: request.includeGroups,
            includeTeams: request.includeTeams,
            includeNonLicensedUsers: request.includeNonLicensedUsers,
            maxNumberOfResults: request.maxNumberOfResults,
            performSearchQueryOnly: false,
            searchQuery: {
                cpusQueryHighlights: {
                    query: '',
                    field: ''
                },
                ...request.context?.productAttributes?.isEntitledConfluenceExternalCollaborator && {
                    productAccessPermissionIds: [
                        'write',
                        'external-collaborator-write'
                    ]
                },
                customQuery: '',
                customerDirectoryId: '',
                filter: request.searchQueryFilter || '',
                minimumAccessLevel: 'APPLICATION',
                queryString: request.query,
                restrictTo: {
                    userIds: [],
                    groupIds: []
                },
                searchUserbase: false
            }
        })
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling smart service, statusCode=${response.status}, statusText=${response.statusText}`,
            statusCode: response.status
        });
    }).then((response)=>(0, $f5wjp.transformUsers)(response, intl));
};
var $94c7434acb15702b$export$2e2bcd8739ae039 = $94c7434acb15702b$var$getUserRecommendations;

});
parcelRegister("f5wjp", function(module, exports) {

$parcel$export(module.exports, "transformUsers", () => $ba878881f0891deb$export$fb8c90bfc4beaa59);


var $Jzvpo = parcelRequire("Jzvpo");

var $60uqU = parcelRequire("60uqU");
const $ba878881f0891deb$var$getLozenzeProperties = (entity, intl)=>{
    if (entity.attributes?.workspaceMember) return intl.formatMessage((0, $Jzvpo.messages).memberLozengeText);
    if (entity.attributes?.isConfluenceExternalCollaborator) {
        const lozengeTooltipMessage = entity.entityType === (0, $60uqU.EntityType).GROUP ? (0, $Jzvpo.messages).guestGroupLozengeTooltip : (0, $Jzvpo.messages).guestUserLozengeTooltip;
        return {
            text: intl.formatMessage((0, $Jzvpo.messages).guestLozengeText),
            tooltip: intl.formatMessage(lozengeTooltipMessage),
            appearance: 'default'
        };
    }
    return undefined;
};
const $ba878881f0891deb$var$transformUser = (item, intl)=>{
    const type = item.entityType;
    if (type === (0, $60uqU.EntityType).USER) {
        const user = item;
        const lozenge = $ba878881f0891deb$var$getLozenzeProperties(user, intl);
        return {
            id: user.id,
            type: user.nonLicensedUser ? (0, $f93312f7d4958f08$export$50042ec1d2e00e63) : (0, $f93312f7d4958f08$export$8436e53e45ffe15b),
            avatarUrl: user.avatarUrl,
            name: user.name,
            email: user.email,
            title: user.title,
            lozenge: lozenge,
            tooltip: user.name,
            isExternal: Boolean(user.nonLicensedUser),
            sources: user.nonLicensedUser ? [
                'other-atlassian'
            ] : undefined
        };
    }
    if (type === (0, $60uqU.EntityType).TEAM) {
        const team = item;
        return {
            id: team.id,
            type: (0, $f93312f7d4958f08$export$26bc40b960693765),
            description: team.description || '',
            name: team.displayName || '',
            memberCount: team.memberCount,
            members: team.members,
            includesYou: team.includesYou,
            avatarUrl: team.largeAvatarImageUrl || team.smallAvatarImageUrl,
            tooltip: team.displayName,
            verified: team.verified
        };
    }
    if (type === (0, $60uqU.EntityType).GROUP) {
        const group = item;
        const lozenge = $ba878881f0891deb$var$getLozenzeProperties(group, intl);
        return {
            id: group.id,
            type: (0, $f93312f7d4958f08$export$d460f747b73abb10),
            name: group.name || '',
            lozenge: lozenge
        };
    }
    return;
};
const $ba878881f0891deb$export$fb8c90bfc4beaa59 = (serverResponse, intl)=>(serverResponse.recommendedUsers || []).map((item)=>$ba878881f0891deb$var$transformUser(item, intl)).filter((user)=>!!user).map((user)=>user);

});
parcelRegister("Jzvpo", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0fd0da3298001d54$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $0fd0da3298001d54$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    externalUserSourcesHeading: {
        id: 'fabric.elements.user-picker.external.sourced.from',
        defaultMessage: 'Found in:',
        description: 'From where the external user is coming'
    },
    slackProvider: {
        id: 'fabric.elements.user-picker.slack.provider',
        defaultMessage: 'Slack',
        description: 'This external user is sourced from Slack provider'
    },
    googleProvider: {
        id: 'fabric.elements.user-picker.google.provider',
        defaultMessage: 'Google',
        description: 'This external user is sourced from Google provider'
    },
    microsoftProvider: {
        id: 'fabric.elements.user-picker.microsoft.provider',
        defaultMessage: 'Microsoft',
        description: 'This external user is sourced from Microsoft provider'
    },
    gitHubProvider: {
        id: 'fabric.elements.user-picker.github.provider',
        defaultMessage: 'GitHub',
        description: 'This external user is sourced from GitHub provider'
    },
    memberLozengeText: {
        id: 'fabric.elements.user-picker.member.lozenge.text',
        defaultMessage: 'MEMBER',
        description: 'Text within the Lozenge when the user is a workspace member'
    },
    guestLozengeText: {
        id: 'fabric.elements.user-picker.guest.lozenge.text',
        defaultMessage: 'GUEST',
        description: 'Text within the lozenge when the user is a guest of confluence'
    },
    guestUserLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.user',
        defaultMessage: 'Guests can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for guest lozenge showing that a user is a guest in Confluence'
    },
    guestGroupLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.group',
        defaultMessage: 'Guest groups can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for lozenge showing that a group is for guests in Confluence'
    }
});

});

parcelRegister("60uqU", function(module, exports) {

$parcel$export(module.exports, "EntityType", () => $e9a061fa52eafd84$export$8eda7e02f8f033b2);
var $e9a061fa52eafd84$export$8eda7e02f8f033b2 = /*#__PURE__*/ function(EntityType) {
    EntityType["USER"] = "USER";
    EntityType["TEAM"] = "TEAM";
    EntityType["GROUP"] = "GROUP";
    return EntityType;
}({});

});


parcelRegister("lrQGi", function(module, exports) {

$parcel$export(module.exports, "config", () => $8648972412521072$export$e506a1d27d1eaa20);
const $8648972412521072$export$e506a1d27d1eaa20 = {
    getRecommendationServiceUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/v1/recommendations` : '/gateway/api/v1/recommendations';
    },
    getUsersServiceUrl (productKey, baseUrl = '') {
        return productKey === 'jira' ? `${baseUrl}/rest/api/3/user/bulk` : `${baseUrl}/wiki/rest/api/user/bulk`;
    },
    getGraphQLUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/graphql` : `/gateway/api/graphql`;
    },
    getTeamsUrl (id, baseUrl, siteId) {
        return baseUrl ? `${baseUrl}/gateway/api/v4/teams/${id}?siteId=${siteId ?? 'None'}` : `/gateway/api/v4/teams/${id}?siteId=${siteId ?? 'None'}`;
    }
};

});


parcelRegister("bjnDn", function(module, exports) {

$parcel$export(module.exports, "default", () => $44f7a8d9e6b8d706$export$2e2bcd8739ae039);


var $lrQGi = parcelRequire("lrQGi");

var $gNcwE = parcelRequire("gNcwE");

var $ePY59 = parcelRequire("ePY59");

var $jN74Q = parcelRequire("jN74Q");
const $44f7a8d9e6b8d706$var$getHydratedUsersFromProducts = (request)=>{
    const url = `${(0, $lrQGi.config).getUsersServiceUrl(request.productKey, request.baseUrl)}`;
    let params = new URLSearchParams();
    request.accountIds.map((id)=>params.append('accountId', id));
    params.append('maxResults', '2000');
    return fetch(`${url}?${params}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        }
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling users service, statusCode=${response.status}, statusText=${response.statusText}`
        });
    }).then(request.productKey === 'jira' ? $44f7a8d9e6b8d706$var$transformJiraUsers : $44f7a8d9e6b8d706$var$transformConfluenceUsers);
};
const $44f7a8d9e6b8d706$var$transformJiraUsers = (userResponse)=>userResponse.values.map($44f7a8d9e6b8d706$var$transformJiraUser).filter((user)=>!!user).map((user)=>user);
const $44f7a8d9e6b8d706$var$transformJiraUser = (item)=>{
    if (!item) return null;
    return {
        id: item.accountId,
        type: (0, $f93312f7d4958f08$export$8436e53e45ffe15b),
        avatarUrl: item.avatarUrls ? item.avatarUrls['16x16'] : '',
        name: item.displayName,
        email: item.emailAddress
    };
};
const $44f7a8d9e6b8d706$var$transformConfluenceUsers = (userResponse)=>userResponse.results.map($44f7a8d9e6b8d706$var$transformConfluenceUser).filter((user)=>!!user).map((user)=>user);
const $44f7a8d9e6b8d706$var$transformConfluenceUser = (item)=>{
    if (!item) return null;
    return {
        id: item.accountId,
        type: (0, $f93312f7d4958f08$export$8436e53e45ffe15b),
        avatarUrl: item.profilePicture ? item.profilePicture.path : '',
        name: item.publicName,
        email: item.email
    };
};
const $44f7a8d9e6b8d706$var$sortResults = (options, sortIds)=>{
    const resultsMap = new Map(options.map((option)=>[
            option && option.id,
            option
        ]));
    return sortIds.map((option)=>{
        const user = resultsMap.get(option.id);
        if (user) return user;
        return {
            id: option.id,
            type: option.type,
            name: (0, $jN74Q.UNKNOWN)
        };
    });
};
const $44f7a8d9e6b8d706$var$isOptionData = (option)=>{
    return option.name !== undefined;
};
const $44f7a8d9e6b8d706$var$hydrateTeamIds = async (baseUrl, values, siteId)=>{
    if (values.length === 0) return [];
    const legionPromises = values.map((value)=>(0, $ePY59.default)({
            baseUrl: baseUrl,
            id: value.id,
            siteId: siteId
        }));
    return await Promise.all(legionPromises);
};
const $44f7a8d9e6b8d706$var$hydrateAccountIds = async (baseUrl, productKey, values)=>{
    if (values.length === 0) return [];
    const accountIds = values.map((val)=>val.id);
    //if we are not jira or confluence then use PRS platform hydration
    return productKey === 'jira' || productKey === 'confluence' ? await $44f7a8d9e6b8d706$var$getHydratedUsersFromProducts({
        baseUrl: baseUrl,
        productKey: productKey,
        accountIds: accountIds
    }) : await (0, $gNcwE.default)(baseUrl, accountIds);
};
async function $44f7a8d9e6b8d706$var$hydrateDefaultValues(baseUrl, value, productKey, siteId) {
    //return if no value
    if (!value || Array.isArray(value) && value.length === 0) return [];
    const values = Array.isArray(value) ? value : [
        value
    ];
    // return if all hydrated
    if (!values.some((val)=>!$44f7a8d9e6b8d706$var$isOptionData(val))) return value;
    const [hydratedUsers, hydratedTeams] = await Promise.all([
        $44f7a8d9e6b8d706$var$hydrateAccountIds(baseUrl, productKey, values.filter((val)=>!$44f7a8d9e6b8d706$var$isOptionData(val) && val.type === 'user')),
        $44f7a8d9e6b8d706$var$hydrateTeamIds(baseUrl, values.filter((val)=>!$44f7a8d9e6b8d706$var$isOptionData(val) && val.type === 'team'), siteId)
    ]);
    const hydratedOptions = values.filter((val)=>$44f7a8d9e6b8d706$var$isOptionData(val)).map((val)=>val).concat(hydratedUsers).concat(hydratedTeams);
    return $44f7a8d9e6b8d706$var$sortResults(hydratedOptions, values);
}
var $44f7a8d9e6b8d706$export$2e2bcd8739ae039 = $44f7a8d9e6b8d706$var$hydrateDefaultValues;

});
parcelRegister("gNcwE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d23ee2bd503b8568$export$2e2bcd8739ae039);

var $jN74Q = parcelRequire("jN74Q");

var $3CXSS = parcelRequire("3CXSS");

var $lrQGi = parcelRequire("lrQGi");
/**
 * @param  {string} accountIds ids to hydrate
 * @return GraphQL Query
 */ const $d23ee2bd503b8568$var$buildUsersQuery = (accountIds)=>({
        query: `query usersQuery($accountIds: [ID!]!) {
    users(accountIds: $accountIds) {
      name
      accountId
      picture
    }
  }`,
        variables: {
            accountIds: accountIds
        }
    });
const $d23ee2bd503b8568$var$makeRequest = async (url, accountIds)=>{
    const query = $d23ee2bd503b8568$var$buildUsersQuery(accountIds);
    return await (0, $3CXSS.graphqlQuery)(url, query);
};
const $d23ee2bd503b8568$var$modifyResponse = (users)=>users.map(({ accountId: accountId, name: name, picture: picture })=>({
            avatarUrl: picture,
            id: accountId,
            name: name,
            type: 'user'
        }));
const $d23ee2bd503b8568$var$getHydratedUsers = (baseUrl, userIds)=>{
    const url = (0, $lrQGi.config).getGraphQLUrl(baseUrl);
    return new Promise((resolve)=>{
        $d23ee2bd503b8568$var$makeRequest(url, userIds).then((data)=>{
            resolve($d23ee2bd503b8568$var$modifyResponse(data.users));
        }).catch(()=>{
            // on network error, return original list with label 'Unknown'
            resolve(userIds.map((id)=>({
                    ...(0, $jN74Q.UNKNOWN_USER),
                    id: id
                })));
        });
    });
};
var $d23ee2bd503b8568$export$2e2bcd8739ae039 = $d23ee2bd503b8568$var$getHydratedUsers;

});
parcelRegister("jN74Q", function(module, exports) {

$parcel$export(module.exports, "UNKNOWN", () => $0ddad3c1364f0383$export$78244dbb77cfa6b6);
$parcel$export(module.exports, "UNKNOWN_USER", () => $0ddad3c1364f0383$export$d1f5101c0939e3fe);
$parcel$export(module.exports, "UNKNOWN_TEAM", () => $0ddad3c1364f0383$export$8144dcfc9025ca57);
const $0ddad3c1364f0383$export$78244dbb77cfa6b6 = 'Unknown';
const $0ddad3c1364f0383$export$d1f5101c0939e3fe = {
    id: $0ddad3c1364f0383$export$78244dbb77cfa6b6,
    name: $0ddad3c1364f0383$export$78244dbb77cfa6b6,
    type: 'user'
};
const $0ddad3c1364f0383$export$8144dcfc9025ca57 = {
    id: $0ddad3c1364f0383$export$78244dbb77cfa6b6,
    name: $0ddad3c1364f0383$export$78244dbb77cfa6b6,
    type: 'team'
};

});

parcelRegister("3CXSS", function(module, exports) {

$parcel$export(module.exports, "graphqlQuery", () => $2c71ea00102d5220$export$74eb8d79ae3e02b5);
const $2c71ea00102d5220$var$buildHeaders = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
function $2c71ea00102d5220$export$74eb8d79ae3e02b5(serviceUrl, query) {
    const headers = $2c71ea00102d5220$var$buildHeaders();
    return fetch(new Request(`${serviceUrl}`, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    })).then((response)=>{
        if (!response.ok) return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
        return response;
    }).then((response)=>response.json()).then((json)=>{
        if (json.errors) return Promise.reject({
            reason: json.errors[0]?.category || 'default'
        });
        return json.data;
    });
}

});


parcelRegister("ePY59", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f36f3458a567667$export$2e2bcd8739ae039);

var $lrQGi = parcelRequire("lrQGi");

var $jN74Q = parcelRequire("jN74Q");
const $8f36f3458a567667$var$transformTeam = (team, id)=>{
    return {
        id: id,
        name: team.displayName,
        type: 'team',
        avatarUrl: team.smallAvatarImageUrl
    };
};
const $8f36f3458a567667$var$hydrateTeamFromLegion = (request)=>{
    const url = (0, $lrQGi.config).getTeamsUrl(request.id, request.baseUrl, request.siteId);
    return fetch(url, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        }
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling Legion, statusCode=${response.status}, statusText=${response.statusText}`
        });
    }).then((response)=>{
        return $8f36f3458a567667$var$transformTeam(response, request.id);
    }).catch(()=>({
            ...(0, $jN74Q.UNKNOWN_TEAM),
            id: request.id
        }));
};
var $8f36f3458a567667$export$2e2bcd8739ae039 = $8f36f3458a567667$var$hydrateTeamFromLegion;

});


parcelRegister("adPMl", function(module, exports) {

$parcel$export(module.exports, "smartUserPickerRenderedUfoExperience", () => $55e968402cb7b08a$export$df77da4c0210f1c1);
$parcel$export(module.exports, "smartUserPickerOptionsShownUfoExperience", () => $55e968402cb7b08a$export$a0e7cca3ab9586eb);
$parcel$export(module.exports, "useUFOConcurrentExperience", () => $55e968402cb7b08a$export$e5e0512991825310);
$parcel$export(module.exports, "UfoErrorBoundary", () => $55e968402cb7b08a$export$5ef1c2550074a375);

var $5uXOq = parcelRequire("5uXOq");

var $cBycP = parcelRequire("cBycP");
var $7Zbvr = parcelRequire("7Zbvr");
var $jZA09 = parcelRequire("jZA09");
const $55e968402cb7b08a$var$COMPONENT_NAME = 'smart-user-picker';
const $55e968402cb7b08a$export$df77da4c0210f1c1 = new (0, $cBycP.ConcurrentExperience)('smart-user-picker-rendered', {
    platform: {
        component: $55e968402cb7b08a$var$COMPONENT_NAME
    },
    type: (0, $7Zbvr.ExperienceTypes).Load,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).PageSegmentLoad
});
const $55e968402cb7b08a$export$a0e7cca3ab9586eb = new (0, $cBycP.ConcurrentExperience)('smart-user-picker-options-shown', {
    platform: {
        component: $55e968402cb7b08a$var$COMPONENT_NAME
    },
    type: (0, $7Zbvr.ExperienceTypes).Operation,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult
});
const $55e968402cb7b08a$export$e5e0512991825310 = (experience, id)=>{
    const experienceForId = experience.getInstance(id);
    // Equivalent to componentWillMount - replace with @atlaskit/ufo's
    // useUFOComponentExperience when it supports ConcurrentExperience.
    (0, $5uXOq.useState)(()=>{
        experienceForId.start();
    });
    // Replace with @atlaskit/ufo's <ExperienceSuccess> when it supports ConcurrentExperience
    (0, $5uXOq.useEffect)(()=>{
        if (experienceForId.state !== (0, $jZA09.UFOExperienceState)['FAILED']) experienceForId.success();
        return ()=>{
            if ([
                (0, $jZA09.UFOExperienceState)['STARTED'],
                (0, $jZA09.UFOExperienceState)['IN_PROGRESS']
            ].includes(experienceForId.state)) experienceForId.abort();
        };
    // We only want this useEffect to run once after component mount, so no deps are needed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
class $55e968402cb7b08a$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidCatch() {
        $55e968402cb7b08a$export$df77da4c0210f1c1.getInstance(this.props.id).failure();
    }
    render() {
        return this.props.children;
    }
}

});



parcelRegister("hEuz8", function(module, exports) {
module.exports = new URL("team-two-people.dd270d21.svg", import.meta.url).toString();

});

parcelRegister("lElIo", function(module, exports) {

$parcel$export(module.exports, "defaultSelectStyles", () => $f1f1a093823579de$export$b12192ea1a215e5f);
$parcel$export(module.exports, "indicatorFixSelectStyles", () => $f1f1a093823579de$export$eca30945eaf474dd);

var $gwIPs = parcelRequire("gwIPs");
const $f1f1a093823579de$export$b12192ea1a215e5f = {
    menuPortal: (base)=>({
            ...base,
            zIndex: (0, $gwIPs.layers).modal
        }),
    menu: (base)=>({
            ...base,
            zIndex: (0, $gwIPs.layers).modal
        })
};
const $f1f1a093823579de$var$inputIconPaddingLeft = "var(--ds-space-025, 2px)";
const $f1f1a093823579de$var$inputIconPaddingRight = "var(--ds-space-050, 4px)";
const $f1f1a093823579de$export$eca30945eaf474dd = {
    // need to apply same padding to both loadingIndicator and clearIndicator - not to have input query jumping between lines e.g. in multi-select
    loadingIndicator: (base)=>({
            ...base,
            paddingLeft: $f1f1a093823579de$var$inputIconPaddingLeft,
            paddingRight: $f1f1a093823579de$var$inputIconPaddingRight
        }),
    clearIndicator: (base)=>({
            ...base,
            paddingLeft: $f1f1a093823579de$var$inputIconPaddingLeft,
            paddingRight: $f1f1a093823579de$var$inputIconPaddingRight
        })
};
const $f1f1a093823579de$export$a9f371909ef7b4d6 = {
    container: (base)=>({
            ...base,
            border: `${"var(--ds-space-025, 2px)"} solid ${"var(--ds-border-danger, #E2483D)"}`,
            borderRadius: "var(--ds-space-050, 4px)"
        })
};

});

const $7808beff4be6dc7e$export$53782b65600ab96d = '__UNASSIGNED_TEAM__';
const $7808beff4be6dc7e$export$3f4352abc4ee4b48 = '__CREATE_TEAM__';

parcelRegister("4vyX4", function(module, exports) {

$parcel$export(module.exports, "default", () => $8457da62d9869465$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8457da62d9869465$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "issue-field-team.error-title",
        "defaultMessage": "We couldn't set the team value"
    },
    errorMessage: {
        "id": "issue-field-team.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    },
    teamErrorViewTooltip: {
        "id": "issue-field-team.team-error-view-tooltip",
        "defaultMessage": "This team may have been deleted, or you do not have access"
    },
    teamErrorViewText: {
        "id": "issue-field-team.team-error-view-text",
        "defaultMessage": "Not available"
    },
    placeholderTeamEditSelector: {
        "id": "issue-field-team.placeholder-team-edit-selector",
        "defaultMessage": "Choose a team"
    },
    defaultNoValueText: {
        "id": "issue-field-team.default-no-value-text",
        "defaultMessage": "None"
    },
    noValueTextExperiment: {
        "id": "issue-field-team.no-value-text-experiment",
        "defaultMessage": "Add team"
    },
    createTeamButtonText: {
        "id": "issue-field-team.create-team-button-text",
        "defaultMessage": "Create a team"
    },
    emptyStateDescription: {
        "id": "issue-field-team.empty-state-description",
        "defaultMessage": "Create a team to assign work across Jira and track it on your team\u2019s profile"
    },
    noOptionsMessage: {
        "id": "issue-field-team.no-options-message",
        "defaultMessage": "No options"
    }
});

});

parcelRegister("lWune", function(module, exports) {

$parcel$export(module.exports, "CreateTeamOption", () => $3964fd12f1894d2f$export$8920795307e75f7e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aHOY1 = parcelRequire("aHOY1");

var $f4ndh = parcelRequire("f4ndh");

var $9PWHG = parcelRequire("9PWHG");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");


var $4vyX4 = parcelRequire("4vyX4");

var $7xOrU = parcelRequire("7xOrU");
function $3964fd12f1894d2f$export$8920795307e75f7e({ onClick: onClick, isFocused: isFocused }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const formattedCreateTeamText = formatMessage((0, $4vyX4.default).createTeamButtonText);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleCreateTeamOptionClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createTeamInline', {
            teamsFieldEmptyState: false
        });
        onClick();
    }, [
        onClick,
        createAnalyticsEvent
    ]);
    const { canCreateTeams: canCreateTeams } = (0, $7xOrU.useTeamPermissions)();
    return canCreateTeams ? // eslint-disable-next-line jira/restricted/react-suspense
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Suspense, {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aHOY1.default), {
        inline: "space.200",
        block: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3964fd12f1894d2f$var$CreateButtonBorder, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3964fd12f1894d2f$var$Container, {
        onClick: handleCreateTeamOptionClick,
        isFocused: isFocused,
        "data-testid": "issue-field-team.ui.edit-mode.create-team-option.create-team-inline-option"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3964fd12f1894d2f$var$OptionDataWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f4ndh.default), {
        isSelected: false,
        data: {
            id: (0, $7808beff4be6dc7e$export$3f4352abc4ee4b48),
            name: formattedCreateTeamText,
            type: 'custom',
            avatarUrl: (0, (/*@__PURE__*/$parcel$interopDefault($9PWHG)))
        }
    }))))) : null;
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3964fd12f1894d2f$var$CreateButtonBorder = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_x3dozgxb",
            __cmplp.className
        ])
    });
});
const $3964fd12f1894d2f$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFocused: isFocused, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkv77o _1bsb1osq _4t3i1osq _irr3166n _1dbzu4to",
            __cmplp.isFocused ? "_bfhk166n" : "_bfhk18uv",
            __cmplp.isFocused ? "_16qsu4to" : "_16qsglyw",
            __cmplp.className
        ])
    });
});
const $3964fd12f1894d2f$var$OptionDataWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0q12x7 _u5f3utpp _n3td12x7 _19bvutpp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aHOY1", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0b539b4cf09c3fa$export$2e2bcd8739ae039);
/* bleed.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
// NOTE: This maintains a full map of 10 styles as Bleed is a bit of a semantic outlier
const $f0b539b4cf09c3fa$var$styles = {
    root: "_vchhusvi",
    'inline.space.025': "_195g4pxn",
    'inline.space.050': "_195ggp71",
    'inline.space.100': "_195gtdkl",
    'inline.space.150': "_195gkqjj",
    'inline.space.200': "_195g1e8l",
    'block.space.025': "_1mou4pxn",
    'block.space.050': "_1mougp71",
    'block.space.100': "_1moutdkl",
    'block.space.150': "_1moukqjj",
    'block.space.200': "_1mou1e8l"
};
/**
 * __Bleed__
 *
 * `Bleed` is a primitive layout component that controls negative whitespace.
 *
 * - [Examples](https://atlassian.design/components/primitives/bleed/examples)
 * - [Code](https://atlassian.design/components/primitives/bleed/code)
 */ const $f0b539b4cf09c3fa$var$Bleed = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ children: children, testId: testId, inline: inline, block: block, all: all, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            $f0b539b4cf09c3fa$var$styles.root,
            all && $f0b539b4cf09c3fa$var$styles[`inline.${all}`],
            inline && $f0b539b4cf09c3fa$var$styles[`inline.${inline}`],
            all && $f0b539b4cf09c3fa$var$styles[`block.${all}`],
            block && $f0b539b4cf09c3fa$var$styles[`block.${block}`],
            xcss
        ]),
        "data-testid": testId,
        children: children
    });
});
$f0b539b4cf09c3fa$var$Bleed.displayName = 'Bleed';
var $f0b539b4cf09c3fa$export$2e2bcd8739ae039 = $f0b539b4cf09c3fa$var$Bleed;

});

parcelRegister("9PWHG", function(module, exports) {
module.exports = new URL("team-two-people-with-plus.5493a468.svg", import.meta.url).toString();

});

parcelRegister("7xOrU", function(module, exports) {

$parcel$export(module.exports, "useTeamPermissions", () => $dbab4d033b21c1e7$export$8cbbe0c59dd60253);

var $14XJw = parcelRequire("14XJw");

var $9OXo1 = parcelRequire("9OXo1");

var $95nUS = parcelRequire("95nUS");
const $dbab4d033b21c1e7$export$8cbbe0c59dd60253 = ()=>{
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const { permissions: permissions } = (0, $95nUS.useTeamsPermissionsService)({
        orgId: orgId,
        cloudId: cloudId
    }, {
        enabled: false
    });
    return permissions;
};

});


parcelRegister("fAxaP", function(module, exports) {

$parcel$export(module.exports, "TeamPickerEmptyState", () => $93f56cb34a904dc8$export$f53d61da818dafb4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $el82k = parcelRequire("el82k");

var $ousew = parcelRequire("ousew");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4vyX4 = parcelRequire("4vyX4");

var $7xOrU = parcelRequire("7xOrU");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $93f56cb34a904dc8$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1fxt _otyr1ejb _19pkze3t",
            __cmplp.className
        ])
    });
});
const $93f56cb34a904dc8$var$imageWrapperStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.200'
});
const $93f56cb34a904dc8$export$f53d61da818dafb4 = ({ onActionClick: onActionClick })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { canCreateTeams: canCreateTeams } = (0, $7xOrU.useTeamPermissions)();
    const handleCreateTeamOptionClick = ()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createTeamInline', {
            teamsFieldEmptyState: true
        });
        onActionClick();
    };
    return canCreateTeams ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlock: "space.200",
        testId: "issue-field-team.ui.edit-mode.team-picker-empty-state.empty-state"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $93f56cb34a904dc8$var$imageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $el82k.default), {
        alt: "",
        width: 130,
        height: 122
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($93f56cb34a904dc8$var$Description, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $4vyX4.default).emptyStateDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "primary",
        onClick: handleCreateTeamOptionClick,
        testId: "issue-field-team.ui.edit-mode.team-picker-empty-state.create-team-button",
        interactionName: "auto-generated.issue-field-team.ui.edit-mode.team-picker-empty-state.create-team-button.button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $4vyX4.default).createTeamButtonText))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $4vyX4.default).noOptionsMessage);
};

});
parcelRegister("el82k", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce20a57a3049c2d5$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $dCLgq = parcelRequire("dCLgq");

var $611kj = parcelRequire("611kj");
const $ce20a57a3049c2d5$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($611kj)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($611kj))
});
var $ce20a57a3049c2d5$export$2e2bcd8739ae039 = $ce20a57a3049c2d5$var$Illustration;
// for advanced use only
const $ce20a57a3049c2d5$export$a179c88182cb9d56 = [
    0,
    0,
    130,
    122
];

});
parcelRegister("611kj", function(module, exports) {
module.exports = new URL("people-and-tasks.dedc2456.svg", import.meta.url).toString();

});




parcelRegister("ghnVw", function(module, exports) {

$parcel$export(module.exports, "default", () => $032f58b3b8fec432$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $032f58b3b8fec432$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    placeholder: {
        "id": "software-board-create.modal.form.source-value-picker.team-picker.placeholder",
        "defaultMessage": "Select"
    }
});

});




parcelRegister("iizLc", function(module, exports) {

$parcel$export(module.exports, "validateFormData", () => $cafe185f92d40f5f$export$cc0ea38c9ab56613);

var $h3KSk = parcelRequire("h3KSk");
const $cafe185f92d40f5f$var$validateBoardName = (value)=>{
    return !value || value.trim().length === 0 ? (0, $h3KSk.VALIDATION_ERROR_EMPTY) : undefined;
};
const $cafe185f92d40f5f$var$validateSourceType = (value)=>{
    return value === undefined ? (0, $h3KSk.VALIDATION_ERROR_EMPTY) : undefined;
};
const $cafe185f92d40f5f$var$validateSourceValue = (value)=>{
    if (Array.isArray(value) && !value.length || !Array.isArray(value) && !value) return 0, $h3KSk.VALIDATION_ERROR_EMPTY;
};
const $cafe185f92d40f5f$export$cc0ea38c9ab56613 = (data)=>({
        boardName: $cafe185f92d40f5f$var$validateBoardName(data.boardName),
        sourceType: $cafe185f92d40f5f$var$validateSourceType(data.sourceType),
        sourceValue: data.sourceType ? $cafe185f92d40f5f$var$validateSourceValue(data.sourceValue) : undefined
    });

});


parcelRegister("4K4Ab", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc97b5447a838fc3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cc97b5447a838fc3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    // Delete createBoardDialogLabel when cleaning up nav4_simplified_board_create_beta
    createBoardDialogLabel: {
        "id": "software-board-create.modal.create-board-dialog-label",
        "defaultMessage": "Create board dialog, {boardDescription}"
    },
    loadingLabel: {
        "id": "software-board-create.modal.loading-label",
        "defaultMessage": "Loading"
    }
});

});



parcelRegister("aDXGG", function(module, exports) {

$parcel$export(module.exports, "default", () => $caddba559d8e417f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $caddba559d8e417f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createBoardLabel: {
        "id": "software-board-create.flyout-menu.flyout-menu-content.dropdown-item-container.create-board-label",
        "defaultMessage": "Create a {boardType} board"
    }
});

});




parcelRegister("jFvRN", function(module, exports) {

$parcel$export(module.exports, "FlyoutMenuContentFallback", () => $1f33e86f0e9f6b4d$export$aad294dc6c6989e8);

var $5uXOq = parcelRequire("5uXOq");

var $iwwXK = parcelRequire("iwwXK");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $kWGoR = parcelRequire("kWGoR");

var $gzrSn = parcelRequire("gzrSn");
const $1f33e86f0e9f6b4d$export$aad294dc6c6989e8 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kWGoR.FlyoutContentContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlockStart: "space.100",
        xcss: $1f33e86f0e9f6b4d$var$skeletonItemContainerStyles,
        role: "menuitem",
        "aria-label": formatMessage((0, $gzrSn.default).loadingLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        hasIcon: true,
        width: "100%"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlockStart: "space.100",
        xcss: $1f33e86f0e9f6b4d$var$skeletonItemContainerStyles,
        role: "menuitem",
        "aria-label": formatMessage((0, $gzrSn.default).loadingLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        hasIcon: true,
        width: "100%"
    })));
};
const $1f33e86f0e9f6b4d$var$skeletonItemContainerStyles = (0, $8CUq3.xcss)({
    height: '56px'
});

});
parcelRegister("gzrSn", function(module, exports) {

$parcel$export(module.exports, "default", () => $f92c872d37e78842$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f92c872d37e78842$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    loadingLabel: {
        "id": "software-board-create.flyout-menu.flyout-menu-content.flyout-menu-content-fallback.loading-label",
        "defaultMessage": "Loading"
    }
});

});





parcelRegister("a2e2Q", function(module, exports) {

$parcel$export(module.exports, "getSoftwareThemedRoutes", () => $376b82e4729cc4d4$export$8b0967e3892c7b59);
$parcel$export(module.exports, "useSoftwareProjectTheming", () => $376b82e4729cc4d4$export$4c26676caf6bb553);

var $5uXOq = parcelRequire("5uXOq");

var $lODMY = parcelRequire("lODMY");

var $dAfqg = parcelRequire("dAfqg");

var $2vSU6 = parcelRequire("2vSU6");

var $lmBAt = parcelRequire("lmBAt");

var $6s1PB = parcelRequire("6s1PB");

var $e5wyW = parcelRequire("e5wyW");

var $86GR9 = parcelRequire("86GR9");
const $376b82e4729cc4d4$var$defaultValues = {
    hasSoftwareTheming: false,
    isSoftwareFullTheming: false,
    isSoftwareProject: false
};
const $376b82e4729cc4d4$export$c4b7ea2942f2d0e = (0, $lODMY.createRouterSelector)((state)=>state.route.name);
const $376b82e4729cc4d4$export$8838ccecebb0c319 = (0, $lODMY.createRouterSelector)((state)=>state.match.url);
const $376b82e4729cc4d4$export$52b606e2ebcbaae2 = ()=>{
    if (!(0, $lmBAt.getIsSoftwareThemingEnabled)()) return $376b82e4729cc4d4$var$defaultValues;
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data: projectData } = (0, $dAfqg.useProjectContext)();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const currentRoute = $376b82e4729cc4d4$export$c4b7ea2942f2d0e();
    const isSoftwareProject = projectData?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    // temporarily disable theming for calendar
    // the logic matches with the one in src/packages/platform/project-theme/page-container/src/controllers/project-theme/index.tsx
    const isSoftwareCalendarRoute = currentRoute === 'software-calendar' || currentRoute === 'software-calendar-classic';
    if (isSoftwareCalendarRoute && !(0, $lmBAt.getIsSoftwareThemingM2Enabled)()) return {
        hasSoftwareTheming: false,
        isSoftwareFullTheming: false,
        isSoftwareProject: isSoftwareProject
    };
    const hasSoftwareTheming = (0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? isSoftwareProject && (0, $86GR9.SOFTWARE_THEME_ROUTES_M2).has(currentRoute) : isSoftwareProject && (0, $86GR9.SOFTWARE_THEME_ROUTES).has(currentRoute) && !isSoftwareCalendarRoute;
    const isSoftwareFullTheming = (0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? hasSoftwareTheming && (0, $86GR9.SOFTWARE_FULL_THEME_ROUTES_M2).has(currentRoute) : hasSoftwareTheming && (0, $86GR9.SOFTWARE_FULL_THEME_ROUTES).has(currentRoute);
    return {
        hasSoftwareTheming: hasSoftwareTheming,
        isSoftwareFullTheming: isSoftwareFullTheming,
        isSoftwareProject: isSoftwareProject
    };
};
const $376b82e4729cc4d4$export$8b0967e3892c7b59 = ()=>{
    const allThemedSoftwareProjectRoutes = (0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? (0, $86GR9.SOFTWARE_THEME_ROUTES_M2) : (0, $86GR9.SOFTWARE_THEME_ROUTES);
    const fullThemedSoftwareProjectRoutes = (0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? (0, $86GR9.SOFTWARE_FULL_THEME_ROUTES_M2) : (0, $86GR9.SOFTWARE_FULL_THEME_ROUTES);
    // Enable theming for the shared routes no matter which milestone we are in
    allThemedSoftwareProjectRoutes.add('project-pages');
    allThemedSoftwareProjectRoutes.add('project-components');
    fullThemedSoftwareProjectRoutes.add('project-pages');
    return {
        allThemedSoftwareProjectRoutes: allThemedSoftwareProjectRoutes,
        fullThemedSoftwareProjectRoutes: fullThemedSoftwareProjectRoutes
    };
};
const $376b82e4729cc4d4$var$useSoftwareProjectThemingSimplified = ()=>{
    const currentRoute = $376b82e4729cc4d4$export$c4b7ea2942f2d0e();
    const currentUrl = $376b82e4729cc4d4$export$8838ccecebb0c319();
    const { allThemedSoftwareProjectRoutes: allThemedSoftwareProjectRoutes, fullThemedSoftwareProjectRoutes: fullThemedSoftwareProjectRoutes } = $376b82e4729cc4d4$export$8b0967e3892c7b59();
    const isSoftwareProject = allThemedSoftwareProjectRoutes.has(currentRoute) && (currentUrl.includes('/jira/software/projects/') || currentUrl.includes('/jira/software/c/projects/') || currentRoute === 'issue');
    const isSoftwareCalendarRoute = currentRoute === 'software-calendar' || currentRoute === 'software-calendar-classic';
    return (0, $5uXOq.useMemo)(()=>{
        if (!isSoftwareProject || !(0, $lmBAt.getIsSoftwareThemingEnabled)()) return $376b82e4729cc4d4$var$defaultValues;
        // temporarily disable theming for calendar
        // the logic matches with the one in src/packages/platform/project-theme/page-container/src/controllers/project-theme/index.tsx
        if (isSoftwareCalendarRoute && !(0, $lmBAt.getIsSoftwareThemingM2Enabled)()) return {
            hasSoftwareTheming: false,
            isSoftwareFullTheming: false,
            isSoftwareProject: isSoftwareProject
        };
        return {
            hasSoftwareTheming: allThemedSoftwareProjectRoutes.has(currentRoute),
            isSoftwareFullTheming: fullThemedSoftwareProjectRoutes.has(currentRoute),
            isSoftwareProject: isSoftwareProject
        };
    }, [
        isSoftwareProject,
        isSoftwareCalendarRoute,
        allThemedSoftwareProjectRoutes,
        currentRoute,
        fullThemedSoftwareProjectRoutes
    ]);
};
const $376b82e4729cc4d4$export$4c26676caf6bb553 = (0, $e5wyW.functionWithCondition)(()=>(0, $6s1PB.expVal)('performance_improvement_in_use_project_theme', 'isEnabled', false), $376b82e4729cc4d4$var$useSoftwareProjectThemingSimplified, $376b82e4729cc4d4$export$52b606e2ebcbaae2);

});
parcelRegister("86GR9", function(module, exports) {

$parcel$export(module.exports, "SOFTWARE_FULL_THEME_ROUTES", () => $ef531902bffb6540$export$891915f6cf3ec6e7);
$parcel$export(module.exports, "SOFTWARE_FULL_THEME_ROUTES_M2", () => $ef531902bffb6540$export$1c7e7f18d2f498fe);
$parcel$export(module.exports, "SOFTWARE_THEME_ROUTES", () => $ef531902bffb6540$export$4edc7739f219df7c);
$parcel$export(module.exports, "SOFTWARE_THEME_ROUTES_M2", () => $ef531902bffb6540$export$587ac1561f46cfdc);
// consolidate the software themed routes to src/packages/platform/project-theme/page-container/src/controllers/project-theme/constants.tsx
// when we migrate the software project theming to business
const $ef531902bffb6540$export$671a416a5ddfe0ea = new Set([
    'issue',
    'software-backlog',
    'rapidboard-backlog',
    'software-timeline',
    'software-timeline-classic',
    'software-issue-navigator',
    'issue-navigator-classic'
]);
const $ef531902bffb6540$export$891915f6cf3ec6e7 = new Set([
    'software-boards',
    'rapidboard-board',
    'software-calendar',
    'software-calendar-classic',
    'software-list',
    'software-list-classic',
    'software-summary',
    'software-summary-classic'
]);
const $ef531902bffb6540$export$7a3cdcc7c971b71e = new Set([
    'issue',
    'software-timeline',
    'software-timeline-classic',
    'software-issue-navigator',
    'issue-navigator-classic'
]);
const $ef531902bffb6540$export$1c7e7f18d2f498fe = new Set([
    'software-boards',
    'rapidboard-board',
    'software-calendar',
    'software-calendar-classic',
    'software-list',
    'software-list-classic',
    'software-summary',
    'software-summary-classic',
    'software-backlog',
    'rapidboard-backlog',
    'project-pages',
    'software-form-classic',
    'software-form',
    'software-form-builder-classic',
    'software-form-builder'
]);
const $ef531902bffb6540$export$4edc7739f219df7c = new Set([
    ...$ef531902bffb6540$export$671a416a5ddfe0ea,
    ...$ef531902bffb6540$export$891915f6cf3ec6e7
]);
const $ef531902bffb6540$export$587ac1561f46cfdc = new Set([
    ...$ef531902bffb6540$export$7a3cdcc7c971b71e,
    ...$ef531902bffb6540$export$1c7e7f18d2f498fe
]);

});


parcelRegister("7TnTU", function(module, exports) {

$parcel$export(module.exports, "isCompanyManagedSoftwareProject", () => $9eab6e02685f3c3c$export$531964df831b0883);

var $2vSU6 = parcelRequire("2vSU6");
const $9eab6e02685f3c3c$export$531964df831b0883 = (projectStyle, projectType)=>projectStyle === 'COMPANY_MANAGED_PROJECT' && projectType === (0, $2vSU6.JIRA_PROJECT_TYPE_SOFTWARE_PROJECT);

});

parcelRegister("jzmXi", function(module, exports) {

$parcel$export(module.exports, "default", () => $af5b5398f44bbc0e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $af5b5398f44bbc0e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createBoard: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-common.project-actions.create-board",
        "defaultMessage": "Create board"
    }
});

});


const $ba4e5f586c2a87d8$export$b8b9d90f9e5bd72b = '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-content-projects-jsw-project-menu';
const $ba4e5f586c2a87d8$export$d57b6b390e78d90f = 'jira-cosmos';
const $ba4e5f586c2a87d8$export$420a3ee5deb615a9 = 25;
const $ba4e5f586c2a87d8$export$99240e55cc48c47e = 5;

parcelRegister("gfIrU", function(module, exports) {

$parcel$export(module.exports, "asyncJswExpandableProjectQuery", () => $92e535ad3861e9a5$export$ae81f6dde63e63eb);

var $3PSm1 = parcelRequire("3PSm1");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $92e535ad3861e9a5$export$ae81f6dde63e63eb = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("kpexW")).then(({ JswExpandableProjectOldQuery: JswExpandableProjectOldQuery })=>JswExpandableProjectOldQuery), {
        moduleId: "5e8272e2",
        moduleName: "JswExpandableProjectOldQuery",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectId: projectId, noOfBoardsToFetch: noOfBoardsToFetch })=>({
            queries: {
                projects: {
                    parameters: $3PSm1.default,
                    variables: {
                        cloudId: cloudId,
                        projectId: projectId,
                        noOfBoardsToFetch: noOfBoardsToFetch
                    }
                }
            }
        })
});

});
parcelRegister("3PSm1", function(module, exports) {

$parcel$export(module.exports, "default", () => $afb0cda5798853d0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<785072f51d21d16958bb928643423d65>>
 * @relayHash 33626f82049926e0af6bb735ebc05da6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2a879e0600cdbac62dfd1ca3ebcdb31a9c6c6ec5059915ec1118fc00b8b38b1c
const $afb0cda5798853d0$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "noOfBoardsToFetch"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "projectId"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v5 = {
        "kind": "ScalarField",
        "name": "boardId"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            v3 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "JswExpandableProjectOldQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "noOfBoardsToFetch",
                                                    "variableName": "noOfBoardsToFetch"
                                                }
                                            ],
                                            "kind": "FragmentSpread",
                                            "name": "JswBoards"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProject"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "JswExpandableProjectOldQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProject",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "projectKey",
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                },
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "first",
                                            "variableName": "noOfBoardsToFetch"
                                        }
                                    ],
                                    "concreteType": "JiraBoardConnection",
                                    "kind": "LinkedField",
                                    "name": "boards",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraBoardEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraBoard",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "defaultNavigationItem",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ],
                                                                    "type": "JiraNavigationItem",
                                                                    "abstractKey": "__isJiraNavigationItem"
                                                                },
                                                                v7 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraFavouriteValue",
                                                            "kind": "LinkedField",
                                                            "name": "favouriteValue",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                v3 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardType"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "canEdit"
                                                        },
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__id"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "mostRecentlyViewedBoard",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v5 /*: any*/ 
                                            ],
                                            "type": "JiraBoard"
                                        },
                                        v7 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "softwareBoardCount"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2a879e0600cdbac62dfd1ca3ebcdb31a9c6c6ec5059915ec1118fc00b8b38b1c",
            "metadata": {},
            "name": "JswExpandableProjectOldQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$afb0cda5798853d0$var$node.hash = "33dadadc55cb4a4fdb3886a96ace3059";
var $afb0cda5798853d0$export$2e2bcd8739ae039 = $afb0cda5798853d0$var$node;

});

parcelRegister("kpexW", function(module, exports) {

let $edb16d0bbccd036d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $edb16d0bbccd036d$var$load("8DbUg").then(()=>parcelRequire('ccqpg'));

});


parcelRegister("1kZCN", function(module, exports) {

$parcel$export(module.exports, "asyncActionsOnHover", () => $3285e20e48e12804$export$4e4f732777dcde68);

var $ccPtS = parcelRequire("ccPtS");

var $fEDBv = parcelRequire("fEDBv");

var $eufEc = parcelRequire("eufEc");

const $3285e20e48e12804$export$4e4f732777dcde68 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("6w2fy")).then(({ ActionsOnHoverQuery: ActionsOnHoverQuery })=>ActionsOnHoverQuery), {
        moduleId: "3853243e",
        moduleName: "ActionsOnHoverQuery",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectId: projectId })=>({
            queries: {
                projects: {
                    parameters: $ccPtS.default,
                    variables: {
                        cloudId: cloudId,
                        projectId: projectId
                    }
                }
            }
        })
});

});
parcelRegister("ccPtS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f97f343b17868234$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d6f7c7531137ebe3f9af4a6c149bd13e>>
 * @relayHash 03553805160a344a9d0039316b042c23
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b67b468d0fb5195714462fea040b6655e239df9406944227ddfe13bd558e05c5

var $cN96Q = parcelRequire("cN96Q");
const $f97f343b17868234$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectId"
    }, v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "projectId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ActionsOnHoverQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ProjectActions"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProject"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "ActionsOnHoverQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProject",
                            "plural": false,
                            "selections": [
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        }
                                    ]
                                },
                                {
                                    "alias": "projectKey",
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectStyle"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                },
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "large"
                                        }
                                    ]
                                },
                                {
                                    "alias": "editPermission",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "EDIT_PROJECT_CONFIG"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "canPerform"
                                        }
                                    ],
                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b67b468d0fb5195714462fea040b6655e239df9406944227ddfe13bd558e05c5",
            "metadata": {},
            "name": "ActionsOnHoverQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": (0, $cN96Q.default)
            }
        }
    };
}();
$f97f343b17868234$var$node.hash = "f0643500ca76c97a30caef500db5e047";
var $f97f343b17868234$export$2e2bcd8739ae039 = $f97f343b17868234$var$node;

});

parcelRegister("6w2fy", function(module, exports) {

let $4be77a0918d84c5c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4be77a0918d84c5c$var$load("2yaCV").then(()=>parcelRequire('l3z6A'));

});



parcelRegister("igsK5", function(module, exports) {

$parcel$export(module.exports, "JswNonExpandableProject", () => $503472fd334f467b$export$cbea0eaf70f0156d);

var $3Ycm4 = parcelRequire("3Ycm4");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dcP6E = parcelRequire("dcP6E");

var $6Lyip = parcelRequire("6Lyip");

var $fNJRN = parcelRequire("fNJRN");

var $jhS4y = parcelRequire("jhS4y");

var $5FnJJ = parcelRequire("5FnJJ");

var $60FHh = parcelRequire("60FHh");

var $4R6GH = parcelRequire("4R6GH");

var $7mPT9 = parcelRequire("7mPT9");

var $8qvci = parcelRequire("8qvci");
const $503472fd334f467b$export$cbea0eaf70f0156d = ({ projectData: projectData, spotlight: spotlight, menuItemAnchorRef: menuItemAnchorRef })=>{
    const { sendProjectMenuItemAnalyticsEvent: sendProjectMenuItemAnalyticsEvent } = (0, $fNJRN.useProjectsAnalyticsL1)();
    const project = (0, $8Uumt.useFragment)((0, $3Ycm4.default), projectData);
    const routerLinkConfig = (0, $5uXOq.useMemo)(()=>({
            to: project.defaultNavigationItem?.url ?? `/browse/${project.projectKey}`,
            prefetch: 'hover'
        }), [
        project.defaultNavigationItem?.url,
        project.projectKey
    ]);
    if ((0, $4R6GH.fg)('blu-6314-drag-and-drop-projects-sidebar-mouse')) {
        const { projectId: projectId, projectKey: projectKey, isFavourite: isFavourite, name: name, avatar: avatar } = project;
        const { state: state, draggableAnchorRef: draggableAnchorRef, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator, dragPreview: dragPreview } = // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $8qvci.useProjectMenuItemDragAndDrop)({
            projectId: projectId,
            projectKey: projectKey,
            isFavourite: isFavourite,
            name: name,
            avatar: avatar
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Lyip.OnboardingSpotlightMaybe), {
            key: project.projectKey,
            spotlight: spotlight
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
            ref: (0, $7mPT9.mergeRefs)(menuItemAnchorRef || null, draggableAnchorRef || null),
            visualContentRef: dropTargetRef,
            dropIndicator: dropIndicator,
            isDragging: state.type === 'dragging',
            hasDragIndicator: true,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dcP6E.ContainerAvatar), {
                src: project.avatar.large || ''
            }),
            href: routerLinkConfig,
            menuId: (0, $jhS4y.ENTITY_ID).PROJECT(project.projectKey),
            onClick: (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $5uXOq.useCallback)(()=>{
                sendProjectMenuItemAnalyticsEvent({
                    starred: project.isFavourite ?? false,
                    recent: !project.isFavourite,
                    projectId: project.projectId,
                    projectType: project.projectType
                });
            }, [
                project.isFavourite,
                project.projectId,
                project.projectType,
                sendProjectMenuItemAnalyticsEvent
            ]) : ()=>{
                sendProjectMenuItemAnalyticsEvent({
                    starred: project.isFavourite ?? false,
                    recent: !project.isFavourite,
                    projectId: project.projectId,
                    projectType: project.projectType
                });
            },
            actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $60FHh.ProjectActions), {
                projectFragment: project
            })
        }, project.name), dragPreview);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Lyip.OnboardingSpotlightMaybe), {
        key: project.projectKey,
        spotlight: spotlight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        ref: menuItemAnchorRef,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dcP6E.ContainerAvatar), {
            src: project.avatar.large || ''
        }),
        href: routerLinkConfig,
        menuId: (0, $jhS4y.ENTITY_ID).PROJECT(project.projectKey),
        onClick: (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $5uXOq.useCallback)(()=>{
            sendProjectMenuItemAnalyticsEvent({
                starred: project.isFavourite ?? false,
                recent: !project.isFavourite,
                projectId: project.projectId,
                projectType: project.projectType
            });
        }, [
            project.isFavourite,
            project.projectId,
            project.projectType,
            sendProjectMenuItemAnalyticsEvent
        ]) : ()=>{
            sendProjectMenuItemAnalyticsEvent({
                starred: project.isFavourite ?? false,
                recent: !project.isFavourite,
                projectId: project.projectId,
                projectType: project.projectType
            });
        },
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $60FHh.ProjectActions), {
            projectFragment: project
        })
    }, project.name));
};

});
parcelRegister("3Ycm4", function(module, exports) {

$parcel$export(module.exports, "default", () => $308da0e532a359a0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ec9c647dc6ce90744c0c4748168b513d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $308da0e532a359a0$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "JswNonExpandableProject",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectId"
            },
            "action": "THROW",
            "path": "projectId"
        },
        {
            "kind": "RequiredField",
            "field": {
                "alias": "projectKey",
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "projectKey"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "large"
                        },
                        "action": "THROW",
                        "path": "avatar.large"
                    }
                ]
            },
            "action": "THROW",
            "path": "avatar"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW",
            "path": "name"
        },
        {
            "kind": "LinkedField",
            "name": "defaultNavigationItem",
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        }
                    ],
                    "type": "JiraNavigationItem",
                    "abstractKey": "__isJiraNavigationItem"
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "ProjectActions"
        }
    ],
    "type": "JiraProject"
};
$308da0e532a359a0$var$node.hash = "1c2cfe3c81902a2ea33e2fc3b9f6c4bb";
var $308da0e532a359a0$export$2e2bcd8739ae039 = $308da0e532a359a0$var$node;

});



parcelRegister("Xn42p", function(module, exports) {

$parcel$export(module.exports, "ProjectRestoreContext", () => $992f13279a3a116d$export$bc50e4f0d149dd7c);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");
const $992f13279a3a116d$export$bc50e4f0d149dd7c = /*#__PURE__*/ (0, $5uXOq.createContext)((0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))));

});

parcelRegister("cG93v", function(module, exports) {

$parcel$export(module.exports, "Nav4ProjectMenuItemContent", () => $16c1a3222b0fc2af$export$d09ad10bd1a587d1);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $5JXQF = parcelRequire("5JXQF");

var $7XYc4 = parcelRequire("7XYc4");
const $16c1a3222b0fc2af$export$d09ad10bd1a587d1 = (0, $7XYc4.componentWithCondition)(()=>(0, $6s1PB.expVal)('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false), (0, $5JXQF.ContentWithDragAndDrop), $16c1a3222b0fc2af$var$Content);
function $16c1a3222b0fc2af$var$Content({ renderMenuItem: renderMenuItem }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderMenuItem());
}

});
parcelRegister("5JXQF", function(module, exports) {

$parcel$export(module.exports, "ContentWithDragAndDrop", () => $e967187c5de267eb$export$97d3213e96ec57ec);

var $5uXOq = parcelRequire("5uXOq");

var $jg05V = parcelRequire("jg05V");
function $e967187c5de267eb$export$97d3213e96ec57ec({ renderMenuItem: renderMenuItem }) {
    const menuItemButtonRef = (0, $5uXOq.useRef)(null);
    const menuItemAnchorRef = (0, $5uXOq.useRef)(null);
    const shouldRestoreFocusRef = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (shouldRestoreFocusRef.current) // .focus() seems to be more reliable in the next task when used with VoiceOver
        setTimeout(()=>{
            (menuItemButtonRef.current ?? menuItemAnchorRef.current)?.focus();
            shouldRestoreFocusRef.current = false;
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jg05V.FocusRestorationContext).Provider, {
        value: {
            shouldRestoreFocusRef: shouldRestoreFocusRef
        }
    }, renderMenuItem({
        menuItemAnchorRef: menuItemAnchorRef,
        menuItemButtonRef: menuItemButtonRef
    }));
}

});
parcelRegister("jg05V", function(module, exports) {

$parcel$export(module.exports, "FocusRestorationContext", () => $0510b0cb01f3383b$export$ee843363a931c6f7);

var $5uXOq = parcelRequire("5uXOq");
const $0510b0cb01f3383b$export$ee843363a931c6f7 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    shouldRestoreFocusRef: {
        current: false
    }
});

});




parcelRegister("7RJ5F", function(module, exports) {

$parcel$export(module.exports, "useSidebarSettingsAri", () => $2c44717735ecf81e$export$c020d957682d50c);
$parcel$export(module.exports, "useOwnerAri", () => $2c44717735ecf81e$export$7eaf80e428ccd5b3);

var $5uXOq = parcelRequire("5uXOq");

var $koeKL = parcelRequire("koeKL");

var $90yGq = parcelRequire("90yGq");

var $fY39E = parcelRequire("fY39E");

var $dXz5Y = parcelRequire("dXz5Y");
const $2c44717735ecf81e$export$c020d957682d50c = (menuName, parentType, parentId)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const activationId = (0, $fY39E.useActivationId)();
    return (0, $5uXOq.useMemo)(()=>(0, $dXz5Y.createSidebarSettingsAri)(cloudId, activationId, menuName, parentType, parentId), [
        cloudId,
        activationId,
        menuName,
        parentType,
        parentId
    ]);
};
const $2c44717735ecf81e$export$7eaf80e428ccd5b3 = ()=>{
    const accountId = (0, $90yGq.useAccountId)() || 'unidentified';
    return (0, $5uXOq.useMemo)(()=>(0, $dXz5Y.createIdentityUserAri)(accountId), [
        accountId
    ]);
};

});
parcelRegister("dXz5Y", function(module, exports) {

$parcel$export(module.exports, "createSidebarSettingsAri", () => $a0022f7ced10bcdf$export$53e9bd7d6d946a5d);
$parcel$export(module.exports, "createIdentityUserAri", () => $a0022f7ced10bcdf$export$caf08cda0abeee7a);

var $gdtac = parcelRequire("gdtac");

var $95KxO = parcelRequire("95KxO");
const $a0022f7ced10bcdf$export$1fd3c0096c24b2bb = (menuName, parentType, parentId)=>{
    if (parentType === undefined !== (parentId === undefined)) throw new Error('Invalid Navigation Setting Scope parentType and parentId must be defined together');
    if (parentType !== undefined && parentId !== undefined) return `${parentType}/${parentId}/${menuName}`;
    return menuName;
};
const $a0022f7ced10bcdf$export$b1bae424ff62eaf3 = (scope)=>{
    const [parentTypeOrMenuName, parentId, menuName] = scope.split('/');
    if (parentTypeOrMenuName && !parentId && !menuName) return {
        menuName: parentTypeOrMenuName
    };
    if (parentTypeOrMenuName && parentId && menuName) return {
        parentType: parentTypeOrMenuName,
        parentId: parentId,
        menuName: menuName
    };
    throw new Error('Invalid Navigation Setting Scope format');
};
const $a0022f7ced10bcdf$export$53e9bd7d6d946a5d = (cloudId, activationId, menuName, parentType, parentId)=>{
    return (0, $gdtac.JiraNavigationSettingsAri).create({
        siteId: cloudId,
        activationId: activationId,
        navigationSettingScope: $a0022f7ced10bcdf$export$1fd3c0096c24b2bb(menuName, parentType, parentId)
    }).toString();
};
const $a0022f7ced10bcdf$export$cc210794adbf70e7 = (ariLikeString)=>{
    const ari = (0, $gdtac.JiraNavigationSettingsAri).parse(ariLikeString);
    return $a0022f7ced10bcdf$export$b1bae424ff62eaf3(ari.navigationSettingScope);
};
const $a0022f7ced10bcdf$export$caf08cda0abeee7a = (userId)=>{
    return (0, $95KxO.IdentityUserAri).create({
        userId: userId
    }).toString();
};

});


parcelRegister("hohDO", function(module, exports) {

$parcel$export(module.exports, "default", () => $53f5333898bb26f9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $2NMNM = parcelRequire("2NMNM");

var $fVnbM = parcelRequire("fVnbM");
var $2rqOp = parcelRequire("2rqOp");

var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");

var $9fuVs = parcelRequire("9fuVs");

var $2vSU6 = parcelRequire("2vSU6");

var $34Vv8 = parcelRequire("34Vv8");

var $az4zD = parcelRequire("az4zD");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");

var $1ppIJ = parcelRequire("1ppIJ");

var $24wrg = parcelRequire("24wrg");

var $izP7o = parcelRequire("izP7o");

var $7Cf8E = parcelRequire("7Cf8E");

var $1OpzN = parcelRequire("1OpzN");
const $53f5333898bb26f9$export$a43ae427db1e9df7 = 'restore-from-trash';
const $53f5333898bb26f9$export$ec2a19e79c04c9d2 = 'restore-from-archive';
const $53f5333898bb26f9$export$cee26a329c363b31 = (props)=>{
    const { isProjectSimplified: isProjectSimplified, projectType: projectType, projectName: projectName, baseUrl: baseUrl = '', projectId: projectId, projectKey: projectKey, projectInactiveDate: projectInactiveDate, intl: { formatMessage: formatMessage }, onClose: onClose, onProjectRestoreSuccess: onProjectRestoreSuccess, onProjectRestoreFailure: onProjectRestoreFailure, flagService: { showFlag: showFlag } } = props;
    const [isRestoring, restoreProject] = (0, $24wrg.useProjectRestoreService)({
        baseUrl: baseUrl,
        projectId: projectId
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const attributes = {
        projectType: projectType,
        isProjectSimplified: isProjectSimplified
    };
    const onSuccess = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'restored'
        });
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'project restored', projectId.toString(), {
            ...attributes,
            durationInTrash: (0, $1OpzN.getDurationInTrash)(projectInactiveDate)
        });
        onProjectRestoreSuccess();
        if (projectType === (0, $2vSU6.SERVICE_DESK_PROJECT)) showFlag({
            messageId: 'project-restore-modal.ui.show-flag.success.restore-service-desk-success',
            messageType: 'transactional',
            type: 'success',
            title: (0, $izP7o.default).restoreServiceDeskSuccessMessageTitle,
            description: (0, $izP7o.default).restoreServiceDeskSuccessMessageContent,
            testId: 'project-restore-modal.ui.flags.success-flag',
            actions: [
                {
                    content: (0, $izP7o.default).restoreServiceDeskSuccessMessageActionEmailSettings,
                    href: `/jira/servicedesk/projects/${projectKey}/settings/email`
                }
            ]
        });
        else showFlag({
            messageId: 'project-restore-modal.ui.show-flag.success.restore-success',
            messageType: 'transactional',
            type: 'success',
            title: (0, $izP7o.default).restoreSuccessMessageTitle,
            testId: 'project-restore-modal.ui.flags.success-flag'
        });
    };
    const onFailure = (error)=>{
        onProjectRestoreFailure(error);
        if (// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        error.statusCode?.toString().startsWith('4') && error.message) showFlag({
            messageId: 'project-restore-modal.ui.show-flag.error.restore-error',
            messageType: 'transactional',
            type: 'error',
            title: [
                (0, $izP7o.default).restoreErrorMessageTitle,
                {
                    projectName: projectName
                }
            ],
            description: [
                (0, $izP7o.default).restoreErrorMessageDescriptionRenderErrorNonFinal,
                {
                    projectName: projectName,
                    error: error.message,
                    br: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null)
                }
            ],
            testId: 'project-restore-modal.ui.flags.failure-flag'
        });
        else showFlag({
            messageId: 'project-restore-modal.ui.show-flag.error.restore-error.1',
            messageType: 'transactional',
            type: 'error',
            title: [
                (0, $izP7o.default).restoreErrorMessageTitle,
                {
                    projectName: projectName
                }
            ],
            description: [
                (0, $izP7o.default).restoreErrorMessageDescription,
                {
                    projectName: projectName
                }
            ],
            testId: 'project-restore-modal.ui.flags.failure-flag'
        });
    };
    const onRestore = (e, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'restoreProjectButton');
        restoreProject({
            onSuccess: onSuccess,
            onFailure: onFailure
        });
    };
    // Unstable components cause bugs and performance problems - please fix this! go/unstable-components
    // eslint-disable-next-line react/no-unstable-nested-components
    const ModalDialogDescription = ()=>// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Cf8E.ModalMessageContent), {
            projectType: projectType
        }));
    const onCancelOrNoop = !isRestoring ? onClose : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "restoreProject",
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
        attributes: attributes,
        containerId: `${projectId}`,
        containerType: "project"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1ppIJ.ModalDialog), {
        messageId: "project-restore-modal.ui.modal-dialog",
        messageType: "transactional",
        onClose: onCancelOrNoop,
        autoFocus: false,
        width: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), null, formatMessage(projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) ? (0, $izP7o.default).jsmModalHeader : (0, $izP7o.default).modalHeader, {
        projectName: projectName
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ModalDialogDescription, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle-link",
        onClick: onCancelOrNoop,
        isDisabled: isRestoring,
        testId: "project-restore-modal.ui.close-button-wrapper"
    }, formatMessage((0, $izP7o.default).cancelRestoreButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2rqOp.default), {
        appearance: "primary",
        onClick: onRestore,
        isDisabled: isRestoring,
        isLoading: isRestoring,
        testId: "project-restore-modal.ui.restore-button-wrapper"
    }, formatMessage((0, $izP7o.default).confirmRestoreButton))))));
};
const $53f5333898bb26f9$export$9c21a3269931e1e6 = {
    isRestoring: false,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $53f5333898bb26f9$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)((0, $34Vv8.default)($53f5333898bb26f9$export$cee26a329c363b31));

});
parcelRegister("34Vv8", function(module, exports) {

$parcel$export(module.exports, "default", () => $827c4d80e4d41b48$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");
const $827c4d80e4d41b48$var$withFlagService = (WrappedComponent)=>{
    return (props)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            flagService: (0, $pa9q9.flagService)
        });
};
var $827c4d80e4d41b48$export$2e2bcd8739ae039 = $827c4d80e4d41b48$var$withFlagService;

});

parcelRegister("24wrg", function(module, exports) {

$parcel$export(module.exports, "useProjectRestoreService", () => $45f308a92ac01734$export$3726936b35df382d);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $4R6GH = parcelRequire("4R6GH");

var $64c16 = parcelRequire("64c16");
const $45f308a92ac01734$export$3726936b35df382d = ({ baseUrl: baseUrl, projectId: projectId })=>{
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const restoreProject = ({ onSuccess: onSuccess, onFailure: onFailure })=>{
        const url = (0, $64c16.getProjectRestoreUrl)(baseUrl, projectId);
        setLoading(true);
        (0, $eusud.performPostRequest)(url).then(()=>{
            setLoading(false);
            onSuccess();
        }).catch((error)=>{
            if (!(error.statusCode === 409 && (0, $4R6GH.fg)('hix-6266_-_no_error_fired_for_409_project_restore'))) (0, $jcw0u.default)({
                meta: {
                    id: 'useProjectRestoreService',
                    packageName: 'jiraProjectRestoreModal'
                },
                error: error,
                attributes: {
                    projectId: projectId,
                    errorStatusCode: error.statusCode
                }
            });
            setLoading(false);
            onFailure(error);
        });
    };
    return [
        loading,
        restoreProject
    ];
};

});
parcelRegister("64c16", function(module, exports) {

$parcel$export(module.exports, "getProjectRestoreUrl", () => $d662aeed5fd2bfed$export$f120ca318b319edc);
const $d662aeed5fd2bfed$export$f120ca318b319edc = (baseUrl, projectId)=>`/rest/api/2/project/${projectId}/restore`;

});


parcelRegister("izP7o", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e2e27b03d33852c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3e2e27b03d33852c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    modalHeader: {
        "id": "project-restore-modal.modal-header",
        "defaultMessage": "Restore project?"
    },
    jsmModalHeader: {
        "id": "project-restore-modal.jsm-modal-header",
        "defaultMessage": "Restore this service project?"
    },
    jsmExplainWhatProjectRestoreDoes: {
        "id": "project-restore-modal.jsm-explain-what-project-restore-does",
        "defaultMessage": "Once restored, this service project will work as normal. It will appear in directories and requests will appear in search results."
    },
    confirmRestoreButton: {
        "id": "project-restore-modal.confirm-restore-button",
        "defaultMessage": "Restore"
    },
    cancelRestoreButton: {
        "id": "project-restore-modal.cancel-restore-button",
        "defaultMessage": "Cancel"
    },
    restoreSuccessMessageTitle: {
        "id": "project-restore-modal.restore-success-message-title",
        "defaultMessage": "Project successfully restored"
    },
    restoreServiceDeskSuccessMessageTitle: {
        "id": "project-restore-modal.restore-service-desk-success-message-title",
        "defaultMessage": "Service project restored"
    },
    restoreServiceDeskSuccessMessageContent: {
        "id": "project-restore-modal.restore-service-desk-success-message-content",
        "defaultMessage": "You may need to turn on email support for your service project to work as normal."
    },
    restoreServiceDeskSuccessMessageActionEmailSettings: {
        "id": "project-restore-modal.restore-service-desk-success-message-action-email-settings",
        "defaultMessage": "Go to email settings"
    },
    restoreErrorMessageTitle: {
        "id": "project-restore-modal.restore-error-message-title",
        "defaultMessage": "Something went wrong"
    },
    restoreErrorMessageDescription: {
        "id": "project-restore-modal.restore-error-message-description",
        "defaultMessage": "We couldn\u2019t restore the \u201C{projectName}\u201D project. Try again."
    },
    restoreErrorMessageDescriptionRenderErrorNonFinal: {
        "id": "project-restore-modal.restore-error-message-description-render-error-non-final",
        "defaultMessage": "We couldn\u2019t restore the \u201C{projectName}\u201D project.{br}{error}"
    }
});

});

parcelRegister("7Cf8E", function(module, exports) {

$parcel$export(module.exports, "ModalMessageContent", () => $db408ba139d077c4$export$6c33ff8e4ab0adf4);

var $5uXOq = parcelRequire("5uXOq");

var $41j30 = parcelRequire("41j30");

var $2vSU6 = parcelRequire("2vSU6");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");


var $h33Ak = parcelRequire("h33Ak");
const $db408ba139d077c4$var$isServiceDesk = (projectType)=>projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);
const $db408ba139d077c4$export$49587436f0d2c314 = ({ projectType: projectType })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const getMessage = ()=>{
        let message;
        if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) message = $db408ba139d077c4$var$isServiceDesk(projectType) ? (0, $h33Ak.default).jsmExplainWhatProjectRestoreDoesIssueTermRefresh : (0, $h33Ak.default).explainWhatProjectRestoreDoesPart1IssueTermRefresh;
        else message = $db408ba139d077c4$var$isServiceDesk(projectType) ? (0, $h33Ak.default).jsmExplainWhatProjectRestoreDoes : (0, $h33Ak.default).explainWhatProjectRestoreDoesPart1;
        return message;
    };
    const formattedMessage = formatMessage(getMessage());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, formattedMessage, "\xa0");
};
const $db408ba139d077c4$export$d608ae2ec728a3cf = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $41j30.default), {
        href: (0, $14d5c91aea6dd559$export$367c841df4ac5730),
        target: "_blank"
    }, formatMessage((0, $h33Ak.default).jsmLearnMoreAboutTrashAndRestore));
};
const $db408ba139d077c4$export$6c33ff8e4ab0adf4 = ({ projectType: projectType })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db408ba139d077c4$export$49587436f0d2c314, {
        projectType: projectType
    }), $db408ba139d077c4$var$isServiceDesk(projectType) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db408ba139d077c4$export$d608ae2ec728a3cf, null));

});
parcelRegister("41j30", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c2f3c33a6194375$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8oe80 = parcelRequire("8oe80");

var $hjSul = parcelRequire("hjSul");
function $7c2f3c33a6194375$var$Link(props) {
    const { children: children, ...rest } = props;
    // eslint-disable-next-line react-hooks/react-compiler
    delete rest.createAnalyticsEvent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), rest, children);
}
var $7c2f3c33a6194375$export$2e2bcd8739ae039 = (0, $8oe80.default)('link', {
    onClick: 'clicked'
})($7c2f3c33a6194375$var$Link);

});
parcelRegister("8oe80", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd6b229cbb45328e$export$2e2bcd8739ae039);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");
const $cd6b229cbb45328e$export$871de8747c9eaa88 = (props)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            ...result,
            [key]: {
                action: props[key]
            }
        }), {});
/**
 * Augments component's callbacks with analytics event as the last attribute, but does fires them
 * @example
 * ```tsx
 * // adds componentName into AnalyticsContext and adds pre-backed 'clicked' event to onClick arguments
 *  const componentWithAnalytics('FooComponent', { onClick: 'clicked' })(Foo)
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $cd6b229cbb45328e$var$componentWithAnalytics(componentName, eventActions) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(WrappedComponent) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $994MI.default)({
            componentName: componentName
        })((0, $cb25w.default)($cd6b229cbb45328e$export$871de8747c9eaa88(eventActions))(WrappedComponent));
    };
}
var $cd6b229cbb45328e$export$2e2bcd8739ae039 = $cd6b229cbb45328e$var$componentWithAnalytics;

});


const $14d5c91aea6dd559$export$37312a67c3e314c6 = 'PROJECT_RESTORE_MODAL_LOAD_START_MARK_KEY';
const $14d5c91aea6dd559$export$367c841df4ac5730 = 'https://support.atlassian.com/jira-service-management-cloud/docs/trash-and-restore-a-project/';

parcelRegister("h33Ak", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3c890d2f3f15262$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f3c890d2f3f15262$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    explainWhatProjectRestoreDoesPart1: {
        "id": "project-restore-modal.modal-message.explain-what-project-restore-does-part-1",
        "defaultMessage": "The project along with its issues, Jira components, attachments, and versions will be restored."
    },
    jsmExplainWhatProjectRestoreDoes: {
        "id": "project-restore-modal.modal-message.jsm-explain-what-project-restore-does",
        "defaultMessage": "Once restored, this service project will appear in directories and its issues will appear in search results. You may need to turn on email support for this service project to work as normal."
    },
    jsmLearnMoreAboutTrashAndRestore: {
        "id": "project-restore-modal.modal-message.jsm-learn-more-about-trash-and-restore",
        "defaultMessage": "Learn more about trash and restore."
    },
    explainWhatProjectRestoreDoesPart1IssueTermRefresh: {
        "id": "project-restore-modal.modal-message.explain-what-project-restore-does-part-1-issue-term-refresh",
        "defaultMessage": "The project along with its work items, Jira components, attachments, and versions will be restored"
    },
    jsmExplainWhatProjectRestoreDoesIssueTermRefresh: {
        "id": "project-restore-modal.modal-message.jsm-explain-what-project-restore-does-issue-term-refresh",
        "defaultMessage": "Once restored, this service project will appear in directories and its work items will appear in search results. You may need to turn on email support for this service project to work as normal."
    }
});

});


parcelRegister("1OpzN", function(module, exports) {

$parcel$export(module.exports, "getDurationInTrash", () => $ba4edd4ad4308bc8$export$d40938201f7514c5);

var $4mBKK = parcelRequire("4mBKK");

var $jovBr = parcelRequire("jovBr");

var $eZDAP = parcelRequire("eZDAP");
const $ba4edd4ad4308bc8$export$d40938201f7514c5 = (projectTrashedDate)=>{
    const parsedProjectTrashedDate = (0, $jovBr.default)((0, $eZDAP.default)(projectTrashedDate)) ? (0, $eZDAP.default)(projectTrashedDate) : new Date(projectTrashedDate);
    return (0, $4mBKK.default)(new Date(), parsedProjectTrashedDate);
};

});


parcelRegister("gKabe", function(module, exports) {

$parcel$export(module.exports, "Nav4Recommendations", () => $020c59a125f3184a$export$dfe7a31b75b5edeb);
$parcel$export(module.exports, "Nav4RecommendationsOld", () => $020c59a125f3184a$export$69b3eee550308510);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");


var $fHabr = parcelRequire("fHabr");

var $5UxNF = parcelRequire("5UxNF");
const $020c59a125f3184a$export$dfe7a31b75b5edeb = /*#__PURE__*/ (0, $5uXOq.memo)($020c59a125f3184a$var$RecommendationsQuery);
const $020c59a125f3184a$export$69b3eee550308510 = /*#__PURE__*/ (0, $5uXOq.memo)($020c59a125f3184a$var$RecommendationsOld);
function $020c59a125f3184a$var$RecommendationsOld({ queryRef: queryRef }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "growth-recommendation-old",
        fallback: "flag",
        packageName: (0, $6dbca5c36e867ae8$export$b8b9d90f9e5bd72b),
        teamName: (0, $6dbca5c36e867ae8$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "recommendations"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fHabr.Nav4RecommendationsOld), {
        queryRef: queryRef
    })));
}
function $020c59a125f3184a$var$RecommendationsQuery() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "growth-recommendations",
        fallback: "unmount",
        packageName: (0, $6dbca5c36e867ae8$export$b8b9d90f9e5bd72b),
        teamName: (0, $6dbca5c36e867ae8$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "recommendations"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5UxNF.Nav4Recommendations), null)));
}

});
const $6dbca5c36e867ae8$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4GrowthRecommendations';
const $6dbca5c36e867ae8$export$d57b6b390e78d90f = 'jira-cosmos';
const $6dbca5c36e867ae8$export$aefe1c8741b24a28 = 'https://www.atlassian.com/legal/privacy-policy';

parcelRegister("fHabr", function(module, exports) {

$parcel$export(module.exports, "Nav4RecommendationsOld", () => $9dab39d497e23298$export$69b3eee550308510);

var $g0WQp = parcelRequire("g0WQp");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $btuiY = parcelRequire("btuiY");
/*
At the moment, growthRecommendations fragment in GQL returns different response each time. This results in a behaviour where recommendation component in UI sometimes appear and disappear
as user interacts with the page.

Further observations were:
1) User clicks on a page. It may causes a change in url. this results in the refetch of Nav4ProjectsContent fragment to keep projects recent section up-to-date.
As part of this refetch, growthRecommendations is also refetched as it is part of the same fragment.

2) On each refetch, backend returns different entity ids for recommendations.
3) As a result, It causes the behavior where a recommendation appears and then disappears on different user interactions.

In order to solve it, a below cache is implemented. The purpose of which is to cache the first response and then use it to render the recommendations component which will also be wrapped
in a memo to avoid further re-renders.
*/ const $9dab39d497e23298$var$cache = {
    growthRecommendations: []
};
function $9dab39d497e23298$export$69b3eee550308510({ queryRef: queryRef }) {
    const data = (0, $8Uumt.useFragment)((0, $g0WQp.default), queryRef);
    const canCreateProject = data?.jira?.canCreateProject ?? false;
    const recommendations = (0, $5uXOq.useMemo)(()=>{
        const appRecommendations = data?.growthRecommendations?.recommendations?.data?.map((item)=>item.entityId).filter(Boolean) ?? [];
        if ($9dab39d497e23298$var$cache.growthRecommendations.length === 0 && appRecommendations.length > 0) // eslint-disable-next-line react-hooks/react-compiler
        $9dab39d497e23298$var$cache.growthRecommendations = appRecommendations;
        /*
    	if user has no permission for creating a project, then we want early return to performance benefit.
    	This is because, currently there are only one recommendations 1) JPD Recommendation
    	Which requires create project permission before user can be considered eligible
    */ return Boolean(canCreateProject) && $9dab39d497e23298$var$cache.growthRecommendations.length > 0 && (0, $4R6GH.fg)('blu-3929-sidebar-menu-recommended') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $btuiY.Recommendations), {
            appRecommendations: $9dab39d497e23298$var$cache.growthRecommendations
        }) : null;
    }, [
        canCreateProject,
        data
    ]);
    return recommendations;
}

});
parcelRegister("g0WQp", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca37805f15a82a78$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<023ac434f8b5307ab82de3d83e0915ba>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ca37805f15a82a78$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4RecommendationsOld",
    "selections": [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "alias": "canCreateProject",
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "CREATE_PROJECT"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "canPerform"
                }
            ]
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "fields": [
                                        {
                                            "kind": "Literal",
                                            "name": "product",
                                            "value": "jira"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "tenantId",
                                            "variableName": "cloudId"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "useCase",
                                            "value": "jiraProjectMenuRecommendations"
                                        }
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "context"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 2
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "entityId"
                                                        }
                                                    ],
                                                    "type": "GrowthRecJiraTemplateRecommendation"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "GrowthRecRecommendations"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$ca37805f15a82a78$var$node.hash = "17bec39a2107f352a24536084815accc";
var $ca37805f15a82a78$export$2e2bcd8739ae039 = $ca37805f15a82a78$var$node;

});

parcelRegister("btuiY", function(module, exports) {

$parcel$export(module.exports, "Recommendations", () => $f6ef8ac59a42f476$export$ebd86fc7badb9a5d);

var $5uXOq = parcelRequire("5uXOq");

var $gSZmd = parcelRequire("gSZmd");
var $1qQhw = parcelRequire("1qQhw");
var $1FdfO = parcelRequire("1FdfO");
var $2CQvU = parcelRequire("2CQvU");

var $koVbs = parcelRequire("koVbs");

var $25tyu = parcelRequire("25tyu");

var $jl3Bs = parcelRequire("jl3Bs");

var $4mmmE = parcelRequire("4mmmE");
const $f6ef8ac59a42f476$export$ebd86fc7badb9a5d = ({ appRecommendations: appRecommendations })=>{
    const [isDismissed, setIsDismissed] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const selectedRecommendationState = (0, $25tyu.useSelectedRecommendation)({
        appRecommendations: appRecommendations
    });
    const onDismissRecommendation = (0, $5uXOq.useCallback)(()=>{
        setIsDismissed(true);
    }, []);
    if (!selectedRecommendationState?.recommendationKey) return null;
    const selectedRecommendation = (0, $4mmmE.recommendationsList).find((recommendation)=>recommendation.key === selectedRecommendationState.recommendationKey);
    return selectedRecommendation && !isDismissed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1qQhw.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1FdfO.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2CQvU.MenuSectionHeading), null, formatMessage((0, $jl3Bs.default).sectionTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gSZmd.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(selectedRecommendation.Component, {
        recommendationKey: selectedRecommendation.key,
        dismissRecommendation: onDismissRecommendation
    })))));
};

});
parcelRegister("25tyu", function(module, exports) {

$parcel$export(module.exports, "useSelectedRecommendation", () => $6b2ce5b5c74ec887$export$6a60b75e3f5ce2aa);
// import shuffle from 'lodash/shuffle';

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $4mmmE = parcelRequire("4mmmE");

var $lCqSu = parcelRequire("lCqSu");
const $6b2ce5b5c74ec887$export$6a60b75e3f5ce2aa = ({ appRecommendations: appRecommendations })=>{
    const recommendationContext = (0, $lCqSu.useRecommendationContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    // NOTE: having shufle here will cause different order of data on SSR and client resulting in a UI change after first render
    // which may not seem like a good UX
    // const shuffledRecommendations = shuffle(recommendations);
    /* 	useMemo here prevents running this code each time user navigates a different route which triggers
		re-render of projects which then re-renders Recommendations component.
		memoisation also prevents sending operational analytics on each re-render
	*/ const recommendationStatus = (0, $5uXOq.useMemo)(()=>(0, $4mmmE.recommendationsList).map((recommendation)=>{
            if (!recommendationContext) return {
                key: recommendation.key,
                isEnabled: false
            };
            const isEnabled = recommendation.shouldRender(recommendationContext, createAnalyticsEvent({}), appRecommendations);
            return {
                key: recommendation.key,
                isEnabled: isEnabled
            };
        }), [
        appRecommendations,
        createAnalyticsEvent,
        recommendationContext
    ]);
    if (!recommendationContext) return {
        recommendationKey: null
    };
    const selectedRecommendation = recommendationStatus.find((result)=>result.isEnabled);
    return {
        recommendationKey: selectedRecommendation?.key || null
    };
};

});
parcelRegister("4mmmE", function(module, exports) {

$parcel$export(module.exports, "recommendationsList", () => $2e5f5f6a93849a03$export$2ff783c2bb2ac3b1);

var $cf2Z3 = parcelRequire("cf2Z3");
const $2e5f5f6a93849a03$var$createRecommendationsList = ()=>{
    const recommendationsList = [];
    recommendationsList.push((0, $cf2Z3.jpdRecommendation));
    // Add your own templates
    return recommendationsList;
};
const $2e5f5f6a93849a03$export$2ff783c2bb2ac3b1 = $2e5f5f6a93849a03$var$createRecommendationsList();

});
parcelRegister("cf2Z3", function(module, exports) {

$parcel$export(module.exports, "jpdRecommendation", () => $08d0fa98c47a849b$export$f0837513113a320d);

var $5uXOq = parcelRequire("5uXOq");

var $jFnH8 = parcelRequire("jFnH8");

var $bHpB9 = parcelRequire("bHpB9");
var $jWY5k = parcelRequire("jWY5k");

var $fVnbM = parcelRequire("fVnbM");

var $letJZ = parcelRequire("letJZ");

var $aYAc3 = parcelRequire("aYAc3");

var $dS3PR = parcelRequire("dS3PR");

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");







var $5FnJJ = parcelRequire("5FnJJ");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $90yGq = parcelRequire("90yGq");

var $2tT7R = parcelRequire("2tT7R");

var $cmVQ7 = parcelRequire("cmVQ7");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $ldyPw = parcelRequire("ldyPw");

var $hA8GQ = parcelRequire("hA8GQ");


var $i49ho = parcelRequire("i49ho");

var $83krH = parcelRequire("83krH");

var $ZxyRh = parcelRequire("ZxyRh");

var $eVIeT = parcelRequire("eVIeT");
const $08d0fa98c47a849b$export$da956fe610b96f73 = ({ recommendationKey: recommendationKey, dismissRecommendation: dismissRecommendation })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const crossFlow = (0, $bHpB9.useCrossFlow)();
    const accountId = (0, $90yGq.useAccountId)();
    const environment = (0, $2tT7R.useEnvironment)();
    const jpdCloudCCPProductID = (0, $i49ho.getProductTypeCcpReferenceIdMapForEnv)(environment).PRODUCT_DISCOVERY;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { fireViewedUIEvent: fireViewedUIEvent, fireInteractedUIEvent: fireInteractedUIEvent } = (0, $cmVQ7.useFireCrossFlowAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (crossFlow.isEnabled) fireViewedUIEvent({
            action: 'viewed',
            actionSubject: 'section',
            actionSubjectId: 'projectsMenu'
        }, {
            recommendedProductIds: [
                jpdCloudCCPProductID
            ],
            source: 'projectsMenuSection'
        }, {
            navigationVersion: 'v4',
            jpdRecommendationInNav4Cohort: (0, $6s1PB.expVal)('grw-997_-_display_jpd_roadmap_in_jira_nav_4', 'recommendation', 'not-enrolled')
        });
        else (0, $jcw0u.default)({
            error: new Error(crossFlow.reason),
            meta: {
                id: crossFlow.reason,
                packageName: 'jiraAtlassianNavigationRecommendations'
            }
        });
    }, [
        createAnalyticsEvent,
        crossFlow,
        fireViewedUIEvent,
        jpdCloudCCPProductID
    ]);
    const jpdRecommendationContent = (0, $5uXOq.useMemo)(()=>{
        // GALILEO-3955 START
        return (0, $6s1PB.expValEquals)('grw-997_-_display_jpd_roadmap_in_jira_nav_4', 'recommendation', 'template') // GALILEO-3955 END
         ? {
            projectTitle: (0, $83krH.default).projectTitleProductRoadmap,
            projectKey: (0, $i49ho.JPD_ROADMAP_KEY),
            projectAvatar: (0, $eVIeT.default)
        } : {
            projectTitle: (0, $83krH.default).projectTitle,
            projectKey: (0, $i49ho.JPD_KEY),
            projectAvatar: (0, $letJZ.JiraProductDiscoveryIcon)
        };
    }, []);
    const onLearnMoreClicked = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: (0, $ce8062101363feb9$export$64fed82162bd367),
            action: 'clicked'
        }), (0, $d59b407ab907bf7b$export$8d155d2412839524), {
            level: (0, $951a0ed422513987$export$f9db6a58b4aabd18),
            componentType: (0, $1e554a683893bd46$export$56981f28056f258e),
            parentItemType: (0, $632bd8725b437a12$export$9a778ca616c24a93),
            parentItemId: (0, $496585bee7985bb9$export$de9ad1ebeca97ec1),
            itemId: (0, $496585bee7985bb9$export$ce0bea1467165424),
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        });
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'learnMore'
        }, {
            source: 'projectsMenuSection',
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        }, {
            navigationVersion: 'v4'
        });
    }, [
        createAnalyticsEvent,
        fireInteractedUIEvent,
        jpdCloudCCPProductID
    ]);
    const onDismissClicked = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: (0, $ce8062101363feb9$export$64fed82162bd367),
            action: 'clicked'
        }), (0, $d59b407ab907bf7b$export$8d155d2412839524), {
            level: (0, $951a0ed422513987$export$f9db6a58b4aabd18),
            componentType: (0, $1e554a683893bd46$export$56981f28056f258e),
            parentItemType: (0, $632bd8725b437a12$export$9a778ca616c24a93),
            parentItemId: (0, $496585bee7985bb9$export$de9ad1ebeca97ec1),
            itemId: (0, $496585bee7985bb9$export$5c09fa42f8d45ed8),
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        });
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'dismissRecommendation'
        }, {
            source: 'projectsMenuSection',
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        }, {
            navigationVersion: 'v4'
        });
        dismissRecommendation();
        if (accountId) (0, $89SaW.setUserProperties)(accountId, (0, $i49ho.JPD_RECOMMENDATION_DISMISS_USER_PROPERTY), 'true').catch((error)=>{
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'dismissJpdRecommendation',
                    packageName: (0, $6dbca5c36e867ae8$export$b8b9d90f9e5bd72b),
                    teamName: 'navigation'
                }
            });
        });
    }, [
        accountId,
        createAnalyticsEvent,
        dismissRecommendation,
        fireInteractedUIEvent,
        jpdCloudCCPProductID
    ]);
    const openCrossFlow = (0, $5uXOq.useCallback)(async (templateId)=>{
        const extensions = (0, $jFnH8.createProvisioningPageExtensions)({
            actions: {
                primary: {
                    behaviour: (0, $jFnH8.Behaviours).LAND,
                    prompt: (0, $jFnH8.Prompts).NEXT,
                    options: {
                        targetTab: (0, $jFnH8.TargetTabs).SAME,
                        urlParams: {
                            templateId: templateId
                        }
                    }
                }
            }
        });
        if (crossFlow.isEnabled) crossFlow.api.open({
            journey: (0, $bHpB9.Journeys).GET_STARTED,
            targetProduct: (0, $jWY5k.Targets).JIRA_PRODUCT_DISCOVERY,
            sourceComponent: 'projectsMenu',
            sourceContext: 'tryThisRecommendation',
            extensions: extensions
        });
    }, [
        crossFlow
    ]);
    const onRecommendationClicked = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
            action: 'clicked'
        }), (0, $d59b407ab907bf7b$export$8d155d2412839524), {
            level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
            componentType: (0, $1e554a683893bd46$export$3ac911b122986477),
            itemType: (0, $632bd8725b437a12$export$9a778ca616c24a93),
            itemId: (0, $496585bee7985bb9$export$de9ad1ebeca97ec1),
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        });
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'tryThisRecommendation'
        }, {
            source: 'projectsMenuSection',
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        }, {
            navigationVersion: 'v4'
        });
        openCrossFlow(jpdRecommendationContent.projectKey);
    }, [
        createAnalyticsEvent,
        fireInteractedUIEvent,
        jpdCloudCCPProductID,
        jpdRecommendationContent.projectKey,
        openCrossFlow
    ]);
    const recommendationActionMenuClickHandler = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'button',
            action: 'clicked'
        }), (0, $d59b407ab907bf7b$export$8d155d2412839524), {
            level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
            componentType: (0, $1e554a683893bd46$export$9bd6c21d500ae611),
            parentItemType: (0, $632bd8725b437a12$export$9a778ca616c24a93),
            parentItemId: (0, $496585bee7985bb9$export$de9ad1ebeca97ec1),
            itemId: (0, $496585bee7985bb9$export$f06dfcec5ff912e)
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(jpdRecommendationContent.projectAvatar, {
            appearance: "brand",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
            appearance: "new",
            isBold: false
        }, formatMessage((0, $83krH.default).lozengeText)),
        href: "",
        menuId: recommendationKey,
        onClick: onRecommendationClicked,
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hA8GQ.RecommendationActionMenu), {
            onClick: recommendationActionMenuClickHandler,
            onLearnMoreClicked: onLearnMoreClicked,
            onDismissClicked: onDismissClicked,
            primaryCta: formatMessage((0, $83krH.default).reasonsModalButtonOk),
            body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $83krH.default).reasonsModalExplanation, {
                strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
                        as: "strong"
                    }, chunks)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("ul", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", null, formatMessage((0, $83krH.default).reasonsModalBulletOneSpork)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", null, formatMessage((0, $83krH.default).reasonsModalBulletTwo))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                appearance: "link",
                spacing: "none",
                href: (0, $6dbca5c36e867ae8$export$aefe1c8741b24a28),
                target: "_blank"
            }, formatMessage((0, $83krH.default).privacyPolicy))),
            title: formatMessage((0, $83krH.default).reasonsModalTitle)
        })
    }, formatMessage(jpdRecommendationContent.projectTitle)));
};
const $08d0fa98c47a849b$var$checkEligibility = (recommendationContext, appRecommendations)=>{
    const { areProductSuggestionsEnabled: areProductSuggestionsEnabled, licensedProducts: licensedProducts, accountId: accountId, edition: edition, jsmEdition: jsmEdition, coreEdition: coreEdition, customerServiceEdition: customerServiceEdition, jpdRecommendationDismissed: jpdRecommendationDismissed } = recommendationContext;
    if ((0, $4R6GH.fg)('grw-1467_jpd_reco_eligibility_override_gate')) return {
        isEligible: true,
        reason: 'Eligibility override gate is enabled'
    };
    if (!accountId) return {
        isEligible: false,
        reason: 'Account Id is null'
    };
    if (!areProductSuggestionsEnabled) return {
        isEligible: false,
        reason: 'Product suggestions are disabled'
    };
    if ((0, $ZxyRh.hasJpdLicense)(licensedProducts)) return {
        isEligible: false,
        reason: 'Instance has JPD license'
    };
    if (jpdRecommendationDismissed) return {
        isEligible: false,
        reason: 'JPD recommendation dismissed'
    };
    if (!appRecommendations?.some((entityId)=>entityId === (0, $i49ho.JPD_ENTITY_ID))) return {
        isEligible: false,
        reason: 'JPD was not in the recommend apps'
    };
    // GALILEO-3955 START
    const hasStandardOrPremiumEditions = [
        edition ?? (0, $ldyPw.UNLICENSED),
        jsmEdition ?? (0, $ldyPw.UNLICENSED),
        coreEdition ?? (0, $ldyPw.UNLICENSED),
        customerServiceEdition ?? (0, $ldyPw.UNLICENSED)
    ].some((ed)=>ed === (0, $ldyPw.STANDARD_EDITION) || ed === (0, $ldyPw.PREMIUM_EDITION));
    if (hasStandardOrPremiumEditions && (0, $4R6GH.fg)('grw-997-jpd-template-in-nav4')) return {
        isEligible: false,
        reason: 'At least one Jira edition is not free and grw-997-jpd-template-in-nav4 gate is enabled'
    };
    // GALILEO-3955 END
    return {
        isEligible: true,
        reason: 'Pass all checks'
    };
};
const $08d0fa98c47a849b$export$f0837513113a320d = {
    key: (0, $i49ho.JPD_RECOMMENDATION_KEY),
    shouldRender: (recommendationContext, analyticsEvent, appRecommendations)=>{
        const { isEligible: isEligible, reason: reason } = $08d0fa98c47a849b$var$checkEligibility(recommendationContext, appRecommendations);
        if ((0, $4R6GH.fg)('pm_jpd_reco_operational_event_activated')) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'jiraAtlassianNavigation.loadJpdRecommendation succeeded', {
            reason: reason,
            isEligible: isEligible
        });
        return isEligible;
    },
    Component: $08d0fa98c47a849b$export$da956fe610b96f73
};

});
parcelRegister("2tT7R", function(module, exports) {

$parcel$export(module.exports, "useEnvironment", () => $6bd66e47d4948917$export$ea7ed2425832167d);
$parcel$export(module.exports, "useIsStagingOrDevOrLocal", () => $6bd66e47d4948917$export$b0d8f74f433a09c9);

var $9OXo1 = parcelRequire("9OXo1");
const $6bd66e47d4948917$var$ENVIRONMENT = {
    STAGING: 'staging',
    DEV: 'dev',
    LOCAL: 'local',
    PROD: 'prod'
};
const $6bd66e47d4948917$export$ea7ed2425832167d = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext?.environment || $6bd66e47d4948917$var$ENVIRONMENT.PROD;
};
const $6bd66e47d4948917$export$b0d8f74f433a09c9 = ()=>{
    const env = $6bd66e47d4948917$export$ea7ed2425832167d();
    return env === $6bd66e47d4948917$var$ENVIRONMENT.STAGING || env === $6bd66e47d4948917$var$ENVIRONMENT.DEV || env === $6bd66e47d4948917$var$ENVIRONMENT.LOCAL;
};

});

parcelRegister("hA8GQ", function(module, exports) {

$parcel$export(module.exports, "RecommendationActionMenu", () => $8bb3d181661250df$export$ff27431731859712);

var $5uXOq = parcelRequire("5uXOq");

var $8U6zd = parcelRequire("8U6zd");

var $3Z96c = parcelRequire("3Z96c");
var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $2KAtx = parcelRequire("2KAtx");

var $iMEh3 = parcelRequire("iMEh3");

var $7ju32 = parcelRequire("7ju32");

var $lAku7 = parcelRequire("lAku7");

var $22OQR = parcelRequire("22OQR");

var $dCm1o = parcelRequire("dCm1o");

var $aBLQn = parcelRequire("aBLQn");
const $8bb3d181661250df$var$MENU_TEST_ID = 'recommendations-common.ui.recommendation-popup-menu.menu-group';
const $8bb3d181661250df$var$CustomTrigger = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const TooltipContainer = (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $3bDjY.default) : (0, $5uXOq.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TooltipContainer, {
        hideTooltipOnClick: true,
        content: formatMessage((0, $aBLQn.default).moreActions),
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
        ...props,
        ref: ref,
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))), {
            label: formatMessage((0, $aBLQn.default).moreActions),
            color: "currentColor",
            spacing: "spacious"
        }),
        testId: "navigation-apps-sidebar-nav4-sidebars-content-growth-recommendations.common.ui.recommendation-action-menu.themed-button"
    }));
});
const $8bb3d181661250df$var$LearnMoreTrigger = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onLearnMoreClicked: onLearnMoreClicked }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Z96c.default), {
        ref: ref,
        onClick: onLearnMoreClicked
    }, formatMessage((0, $aBLQn.default).whyAmISeeingThis));
});
const $8bb3d181661250df$export$ff27431731859712 = ({ onClick: onClick, onLearnMoreClicked: onLearnMoreClicked, onDismissClicked: onDismissClicked, body: body, primaryCta: primaryCta, title: title })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            body: body,
            primaryCta: primaryCta,
            title: title
        }), [
        body,
        primaryCta,
        title
    ]);
    const modalProps = (0, $5uXOq.useMemo)(()=>({
            width: 400,
            height: 440
        }), []);
    const MenuItems = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), {
            testId: $8bb3d181661250df$var$MENU_TEST_ID
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
            isList: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Z96c.default), {
            onClick: ()=>onDismissClicked()
        }, formatMessage((0, $aBLQn.default).dismissButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
            entryPoint: (0, $iMEh3.GrowthRecommendationsEntrypoint),
            entryPointProps: entryPointParams,
            modalProps: modalProps,
            useInternalModal: false
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8bb3d181661250df$var$LearnMoreTrigger, {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                ref: ref,
                onLearnMoreClicked: onLearnMoreClicked
            })))), [
        entryPointParams,
        formatMessage,
        modalProps,
        onDismissClicked,
        onLearnMoreClicked
    ]);
    const content = (contentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lAku7.MenuContent), {
            ...contentProps,
            MenuItems: MenuItems
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ju32.MenuContainer), {
        content: content,
        onClick: onClick,
        CustomTrigger: $8bb3d181661250df$var$CustomTrigger
    });
};

});
parcelRegister("iMEh3", function(module, exports) {

$parcel$export(module.exports, "GrowthRecommendationsEntrypoint", () => $657424a8590f6b4d$export$f926c2f51211d688);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $657424a8590f6b4d$export$f926c2f51211d688 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("drSu9")).then(({ GrowthRecommendationModal: GrowthRecommendationModal })=>GrowthRecommendationModal), {
        moduleId: "356e09a2",
        moduleName: "GrowthRecommendationModal",
        priority: "interaction"
    }),
    getPreloadProps: (props)=>({
            queries: {},
            props: props
        })
});

});
parcelRegister("drSu9", function(module, exports) {

let $9ca80f9a192f0332$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9ca80f9a192f0332$var$load("YzYU7").then(()=>parcelRequire('jcyQJ'));

});


parcelRegister("lAku7", function(module, exports) {

$parcel$export(module.exports, "MenuContent", () => $9ef97abb06f2bc76$export$479f0f2f71193efe);

var $5uXOq = parcelRequire("5uXOq");

var $eZUJu = parcelRequire("eZUJu");

var $MHKc7 = parcelRequire("MHKc7");

var $4DrQd = parcelRequire("4DrQd");
const $9ef97abb06f2bc76$var$stopEventPropagation = (event)=>event.stopPropagation();
const $9ef97abb06f2bc76$export$479f0f2f71193efe = ({ MenuItems: MenuItems, onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        onMouseEnter: $9ef97abb06f2bc76$var$stopEventPropagation,
        onMouseLeave: $9ef97abb06f2bc76$var$stopEventPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), {
        minWidth: (0, $4DrQd.MENU_GROUP_MIN_WIDTH)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItems, {
        onClose: onClose
    })));

});

parcelRegister("aBLQn", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd4cafb5aa64f8e3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fd4cafb5aa64f8e3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    whyAmISeeingThis: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.recommendations.common.recommendation-action-menu.why-am-i-seeing-this",
        "defaultMessage": "Why am I seeing this?"
    },
    moreActions: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.recommendations.common.recommendation-action-menu.more-actions",
        "defaultMessage": "More actions"
    },
    dismissButtonText: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.recommendations.common.recommendation-action-menu.dismiss-button-text",
        "defaultMessage": "Not interested"
    },
    reasonsModalTitle: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-title",
        "defaultMessage": "Why am I seeing this?"
    },
    reasonsModalExplanation: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-explanation",
        "defaultMessage": "We think <strong>Jira Product Discovery</strong> will improve your team's productivity. The recommendation is based on:"
    },
    reasonsModalBulletOneSpork: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-one-spork",
        "defaultMessage": "the tools you use (Jira)"
    },
    reasonsModalBulletTwo: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-two",
        "defaultMessage": "the way you use your existing tools and products"
    },
    privacyPolicy: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.privacy-policy",
        "defaultMessage": "Learn more about your data privacy with Atlassian"
    },
    reasonsModalButtonOk: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-button-ok",
        "defaultMessage": "Ok"
    }
});

});


parcelRegister("i49ho", function(module, exports) {

$parcel$export(module.exports, "JPD_RECOMMENDATION_KEY", () => $bfae2422736e9114$export$3e6ff24c4f517c4f);
$parcel$export(module.exports, "JPD_KEY", () => $bfae2422736e9114$export$a9c4e38d8a74acd2);
$parcel$export(module.exports, "JPD_ROADMAP_KEY", () => $bfae2422736e9114$export$c11145b8eb60b18b);
$parcel$export(module.exports, "JPD_RECOMMENDATION_DISMISS_USER_PROPERTY", () => $bfae2422736e9114$export$52b9dedc0088f8);
$parcel$export(module.exports, "JPD_ENTITY_ID", () => $bfae2422736e9114$export$909712ccf16883d);
$parcel$export(module.exports, "getProductTypeCcpReferenceIdMapForEnv", () => $bfae2422736e9114$export$29629758934356a6);

var $iDfVE = parcelRequire("iDfVE");
const $bfae2422736e9114$export$3e6ff24c4f517c4f = 'jpd-recommendation';
const $bfae2422736e9114$export$a9c4e38d8a74acd2 = 'jpd.product-discovery';
const $bfae2422736e9114$export$c11145b8eb60b18b = 'jpd.product-roadmap';
const $bfae2422736e9114$export$52b9dedc0088f8 = 'JpdRecommendationDismissed';
const $bfae2422736e9114$export$909712ccf16883d = 'jira.polaris:discovery';
const $bfae2422736e9114$export$29629758934356a6 = (environment)=>{
    const env = environment === 'prod' ? 'prod' : 'staging';
    return {
        BUSINESS: (0, $iDfVE.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_work_management_cloud,
        SOFTWARE: (0, $iDfVE.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_software_cloud,
        SERVICE_DESK: (0, $iDfVE.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_service_management_cloud,
        PRODUCT_DISCOVERY: (0, $iDfVE.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_product_discovery
    };
};

});

parcelRegister("83krH", function(module, exports) {

$parcel$export(module.exports, "default", () => $5045a396714061a7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5045a396714061a7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    projectTitle: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.project-title",
        "defaultMessage": "New discovery project"
    },
    projectTitleProductRoadmap: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.project-title-product-roadmap",
        "defaultMessage": "Create a roadmap"
    },
    lozengeText: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.lozenge-text",
        "defaultMessage": "try"
    },
    reasonsModalTitle: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-title",
        "defaultMessage": "Why am I seeing this?"
    },
    reasonsModalExplanation: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-explanation",
        "defaultMessage": "We think <strong>Jira Product Discovery</strong> will improve your team's productivity. The recommendation is based on:"
    },
    reasonsModalBulletOneSpork: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-one-spork",
        "defaultMessage": "the tools you use (Jira)"
    },
    reasonsModalBulletTwo: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-two",
        "defaultMessage": "the way you use your existing tools and products"
    },
    privacyPolicy: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.privacy-policy",
        "defaultMessage": "Learn more about your data privacy with Atlassian"
    },
    reasonsModalButtonOk: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-button-ok",
        "defaultMessage": "Ok"
    }
});

});

parcelRegister("ZxyRh", function(module, exports) {

$parcel$export(module.exports, "hasJpdLicense", () => $a544ca433acda2ae$export$2ea69a0925803655);
const $a544ca433acda2ae$export$2ea69a0925803655 = (licensedProducts)=>licensedProducts['jira-product-discovery'] === true;

});

parcelRegister("eVIeT", function(module, exports) {

$parcel$export(module.exports, "default", () => $5323fd484856ad72$export$2e2bcd8739ae039);
/* product-roadmap-project-avatar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");

var $W9spz = parcelRequire("W9spz");
const $5323fd484856ad72$var$ProductRoadmapProjectAvatar = ()=>{
    return /*#__PURE__*/ $5uXOq.createElement((0, $ujWmd.default), {
        appearance: "square",
        borderColor: "transparent",
        size: "small",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($W9spz)))
    });
};
var $5323fd484856ad72$export$2e2bcd8739ae039 = $5323fd484856ad72$var$ProductRoadmapProjectAvatar;

});
parcelRegister("W9spz", function(module, exports) {
module.exports = new URL("template-roadmap-icon.873220f8.svg", import.meta.url).toString();

});




parcelRegister("lCqSu", function(module, exports) {

$parcel$export(module.exports, "useRecommendationContext", () => $d48e361b6db9225d$export$3321c0b02f750bcc);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4dc0x = parcelRequire("4dc0x");

var $51Yl2 = parcelRequire("51Yl2");

var $lXNZG = parcelRequire("lXNZG");

var $90yGq = parcelRequire("90yGq");

var $k9JTq = parcelRequire("k9JTq");

var $DVljb = parcelRequire("DVljb");

var $9OXo1 = parcelRequire("9OXo1");

var $2YP9W = parcelRequire("2YP9W");
const $d48e361b6db9225d$export$3321c0b02f750bcc = ()=>{
    const locale = (0, $DVljb.useLocale)();
    const accountId = (0, $90yGq.useAccountId)();
    const { cloudId: cloudId, licensedProducts: licensedProducts, firstActivationDateMs: firstActivationDateMs, areProductSuggestionsEnabled: areProductSuggestionsEnabled } = (0, $9OXo1.useTenantContext)();
    const { software: edition, serviceDesk: jsmEdition, customerService: customerServiceEdition, core: coreEdition } = (0, $k9JTq.useAppEditions)();
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const jpdRecommendationDismissedResourceData = (0, $2YP9W.useResource)((0, $lXNZG.jpdRecommendationDismissedResource));
    const jpdRecommendationDismissed = jpdRecommendationDismissedResourceData?.data?.hasDismissed ?? false;
    const { data: userTraitsData } = (0, $2YP9W.useResource)((0, $51Yl2.fetchUserTraitsResource));
    const { data: siteTraitsData } = (0, $2YP9W.useResource)((0, $4dc0x.fetchSiteTraitsResource));
    return (0, $5uXOq.useMemo)(()=>({
            locale: locale,
            cloudId: cloudId,
            accountId: accountId,
            licensedProducts: licensedProducts,
            edition: edition,
            jsmEdition: jsmEdition,
            coreEdition: coreEdition,
            customerServiceEdition: customerServiceEdition,
            firstActivationDateMs: firstActivationDateMs,
            areProductSuggestionsEnabled: areProductSuggestionsEnabled,
            environment: environment,
            jpdRecommendationDismissed: jpdRecommendationDismissed,
            userTraitsData: userTraitsData,
            siteTraitsData: siteTraitsData
        }), [
        locale,
        cloudId,
        accountId,
        licensedProducts,
        edition,
        jsmEdition,
        coreEdition,
        customerServiceEdition,
        firstActivationDateMs,
        areProductSuggestionsEnabled,
        environment,
        jpdRecommendationDismissed,
        userTraitsData,
        siteTraitsData
    ]);
};

});
parcelRegister("DVljb", function(module, exports) {

$parcel$export(module.exports, "useLocale", () => $7c760643dc748494$export$43bb16f9c6d9e3f7);
$parcel$export(module.exports, "useNativeLocale", () => $7c760643dc748494$export$31652d9c30d7d3f3);

var $5uXOq = parcelRequire("5uXOq");

var $lzeFL = parcelRequire("lzeFL");

var $9OXo1 = parcelRequire("9OXo1");
const $7c760643dc748494$export$43bb16f9c6d9e3f7 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.locale || (0, $lzeFL.defaultLocale);
};
const $7c760643dc748494$export$31652d9c30d7d3f3 = ()=>{
    const locale = $7c760643dc748494$export$43bb16f9c6d9e3f7();
    const standardizedLocale = (0, $5uXOq.useMemo)(()=>(0, $lzeFL.standardizeLocale)(locale), [
        locale
    ]);
    return standardizedLocale;
};

});



parcelRegister("jl3Bs", function(module, exports) {

$parcel$export(module.exports, "default", () => $17579479487d4752$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $17579479487d4752$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    sectionTitle: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-growth-recommendations.section-title",
        "defaultMessage": "Recommended"
    }
});

});



parcelRegister("5UxNF", function(module, exports) {

$parcel$export(module.exports, "Nav4Recommendations", () => $2717b8c67ab052cf$export$dfe7a31b75b5edeb);

var $hI8rs = parcelRequire("hI8rs");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $hI8rs = parcelRequire("hI8rs");

var $dbNrA = parcelRequire("dbNrA");

var $koeKL = parcelRequire("koeKL");

var $90yGq = parcelRequire("90yGq");

var $btuiY = parcelRequire("btuiY");
/*
At the moment, growthRecommendations fragment in GQL returns different response each time. This results in a behaviour where recommendation component in UI sometimes appear and disappear
as user interacts with the page.

Further observations were:
1) User clicks on a page. It may causes a change in url. this results in the refetch of Nav4ProjectsContent fragment to keep projects recent section up-to-date.
As part of this refetch, growthRecommendations is also refetched as it is part of the same fragment.

2) On each refetch, backend returns different entity ids for recommendations.
3) As a result, It causes the behavior where a recommendation appears and then disappears on different user interactions.

In order to solve it, a below cache is implemented. The purpose of which is to cache the first response and then use it to render the recommendations component which will also be wrapped
in a memo to avoid further re-renders.
*/ const $2717b8c67ab052cf$var$cache = {
    growthRecommendations: []
};
function $2717b8c67ab052cf$export$dfe7a31b75b5edeb() {
    const [queryRef, loadQuery] = (0, $8Uumt.useQueryLoader)((0, $hI8rs.default));
    const cloudId = (0, $koeKL.useCloudId)();
    const userId = (0, $90yGq.useAccountId)();
    (0, $5uXOq.useEffect)(()=>{
        if (cloudId) loadQuery({
            cloudId: cloudId
        });
    }, [
        cloudId,
        loadQuery
    ]);
    if (!queryRef) return null;
    if (!(0, $4R6GH.fg)('optout_all_messages_grw-1467')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2717b8c67ab052cf$var$Nav4RecommendationsInner, {
        queryRef: queryRef
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dbNrA.default), {
        touchpointId: "grw-1467-jpd-recommendation-nav4",
        cloudId: cloudId,
        userId: userId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2717b8c67ab052cf$var$Nav4RecommendationsInner, {
        queryRef: queryRef
    }));
}
const $2717b8c67ab052cf$var$Nav4RecommendationsInner = ({ queryRef: queryRef })=>{
    const data = (0, $8Uumt.usePreloadedQuery)((0, $hI8rs.default), queryRef);
    const canCreateProject = data?.jira?.canCreateProject ?? false;
    const recommendations = (0, $5uXOq.useMemo)(()=>{
        const appRecommendations = data?.growthRecommendations?.recommendations?.data?.map((item)=>item.entityId).filter(Boolean) ?? [];
        if ($2717b8c67ab052cf$var$cache.growthRecommendations.length === 0 && appRecommendations.length > 0) // eslint-disable-next-line react-hooks/react-compiler
        $2717b8c67ab052cf$var$cache.growthRecommendations = appRecommendations;
        /*
    	if user has no permission for creating a project, then we want early return to performance benefit.
    	This is because, currently there are only one recommendations 1) JPD Recommendation
    	Which requires create project permission before user can be considered eligible
    */ return Boolean(canCreateProject) && $2717b8c67ab052cf$var$cache.growthRecommendations.length > 0 && (0, $4R6GH.fg)('blu-3929-sidebar-menu-recommended') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $btuiY.Recommendations), {
            appRecommendations: $2717b8c67ab052cf$var$cache.growthRecommendations
        }) : null;
    }, [
        canCreateProject,
        data
    ]);
    return recommendations;
};

});
parcelRegister("hI8rs", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5d391a7e6773d6b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fca34214df57e91bcc6b333185773418>>
 * @relayHash 60d19155b9cdae4e64b4f7c449f4752d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2ae6071654511a4527a0abd92d665dfad5552a83d6d7c2b1c9bb45d8c1b6d8eb
const $e5d391a7e6773d6b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
            {
                "alias": "canCreateProject",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "cloudId",
                        "variableName": "cloudId"
                    },
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "CREATE_PROJECT"
                    }
                ],
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ]
    }, v2 = [
        {
            "fields": [
                {
                    "kind": "Literal",
                    "name": "product",
                    "value": "jira"
                },
                {
                    "kind": "Variable",
                    "name": "tenantId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Literal",
                    "name": "useCase",
                    "value": "jiraProjectMenuRecommendations"
                }
            ],
            "kind": "ObjectValue",
            "name": "context"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 2
        }
    ], v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "entityId"
            }
        ],
        "type": "GrowthRecJiraTemplateRecommendation"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "Nav4RecommendationsQuery",
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "GrowthRecRecommendations"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "Nav4RecommendationsQuery",
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v3 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "GrowthRecRecommendations"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2ae6071654511a4527a0abd92d665dfad5552a83d6d7c2b1c9bb45d8c1b6d8eb",
            "metadata": {},
            "name": "Nav4RecommendationsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e5d391a7e6773d6b$var$node.hash = "37e580905a6bb12dfab4ae64833a88d6";
var $e5d391a7e6773d6b$export$2e2bcd8739ae039 = $e5d391a7e6773d6b$var$node;

});

parcelRegister("dbNrA", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bafe9bf940a1b69$export$2e2bcd8739ae039);

var $6WDs0 = parcelRequire("6WDs0");
function $4bafe9bf940a1b69$export$2e2bcd8739ae039({ touchpointId: touchpointId, cloudId: cloudId, userId: userId, children: children, fallback: fallback, options: options }) {
    const { optoutStatus: optoutStatus } = (0, $6WDs0.useIsOptoutAllMessages)(touchpointId, cloudId, userId, options);
    if (options?.isDisabled) return children;
    if (optoutStatus !== 'no-opt-out') {
        if (fallback) {
            if (typeof fallback === 'function') return fallback({
                optoutStatus: optoutStatus
            });
            return fallback;
        }
        return null;
    }
    return children;
}

});



parcelRegister("dLakp", function(module, exports) {

$parcel$export(module.exports, "Nav4ProjectsSections", () => $97139f6e94a9aa7c$export$f0f2073bdea7c56e);

var $5uXOq = parcelRequire("5uXOq");

var $di4cw = parcelRequire("di4cw");

var $aeBua = parcelRequire("aeBua");

var $gtmvt = parcelRequire("gtmvt");
const $97139f6e94a9aa7c$export$f0f2073bdea7c56e = ({ favoriteItems: favoriteItems, recentItems: recentItems, mostRecentProjectItem: mostRecentProjectItem })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aeBua.RenderStarredSection), {
        favoriteItems: favoriteItems
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $di4cw.RenderRecentSection), {
        recentItems: recentItems
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gtmvt.RenderMostRecentProjectSection), {
        projectItem: mostRecentProjectItem
    }));

});
parcelRegister("di4cw", function(module, exports) {

$parcel$export(module.exports, "RenderRecentSection", () => $28c743f7f4fa9a2a$export$d2b3549b269002a1);

var $5uXOq = parcelRequire("5uXOq");

var $gSZmd = parcelRequire("gSZmd");
var $1qQhw = parcelRequire("1qQhw");
var $1FdfO = parcelRequire("1FdfO");
var $2CQvU = parcelRequire("2CQvU");

var $koVbs = parcelRequire("koVbs");

var $7nWhn = parcelRequire("7nWhn");
function $28c743f7f4fa9a2a$export$d2b3549b269002a1({ recentItems: recentItems }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return recentItems.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1qQhw.MenuListItem), {
        testId: "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.ui.content.recent-section.recent-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1FdfO.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2CQvU.MenuSectionHeading), null, formatMessage((0, $7nWhn.default).recent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gSZmd.MenuList), null, recentItems.list)));
}

});
parcelRegister("7nWhn", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2425df2f0841aa4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b2425df2f0841aa4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    recent: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.content.recent",
        "defaultMessage": "Recent"
    },
    starred: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.content.starred",
        "defaultMessage": "Starred"
    },
    viewAllStarred: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.content.view-all-starred",
        "defaultMessage": "View all starred"
    }
});

});


parcelRegister("aeBua", function(module, exports) {

$parcel$export(module.exports, "RenderStarredSection", () => $a33f6147b8b5cd30$export$e2cc6b3e240d5148);

var $5uXOq = parcelRequire("5uXOq");

var $gSZmd = parcelRequire("gSZmd");
var $1qQhw = parcelRequire("1qQhw");
var $1FdfO = parcelRequire("1FdfO");
var $2CQvU = parcelRequire("2CQvU");

var $koVbs = parcelRequire("koVbs");

var $jhS4y = parcelRequire("jhS4y");

var $5FnJJ = parcelRequire("5FnJJ");

var $7XYc4 = parcelRequire("7XYc4");

var $6s1PB = parcelRequire("6s1PB");

var $4s8PW = parcelRequire("4s8PW");

var $7nWhn = parcelRequire("7nWhn");
const $a33f6147b8b5cd30$var$VIEW_ALL_STARRED_HREF = '/jira/your-work?starred';
const $a33f6147b8b5cd30$export$e2cc6b3e240d5148 = (0, $7XYc4.componentWithCondition)(()=>(0, $6s1PB.expVal)('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false), $a33f6147b8b5cd30$var$StarredSectionWithFocusRestoration, $a33f6147b8b5cd30$var$StarredSection);
function $a33f6147b8b5cd30$var$StarredSectionWithFocusRestoration({ favoriteItems: favoriteItems }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    // Will implement focus restoration logic in next PR
    return favoriteItems.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4s8PW.ProjectsDroppableGroupIndicator), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1qQhw.MenuListItem), {
        testId: "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.ui.content.starred-section.starred-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1FdfO.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2CQvU.MenuSectionHeading), null, formatMessage((0, $7nWhn.default).starred)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gSZmd.MenuList), null, favoriteItems.list))), favoriteItems.hasNextPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        href: $a33f6147b8b5cd30$var$VIEW_ALL_STARRED_HREF,
        menuId: (0, $jhS4y.MENU_ID_PROJECTS_VIEW_ALL_STARRED)
    }, formatMessage((0, $7nWhn.default).viewAllStarred)));
}
function $a33f6147b8b5cd30$var$StarredSection({ favoriteItems: favoriteItems }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return favoriteItems.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4s8PW.ProjectsDroppableGroupIndicator), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1qQhw.MenuListItem), {
        testId: "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.ui.content.starred-section.starred-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1FdfO.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2CQvU.MenuSectionHeading), null, formatMessage((0, $7nWhn.default).starred)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gSZmd.MenuList), null, favoriteItems.list))), favoriteItems.hasNextPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        href: $a33f6147b8b5cd30$var$VIEW_ALL_STARRED_HREF,
        menuId: (0, $jhS4y.MENU_ID_PROJECTS_VIEW_ALL_STARRED)
    }, formatMessage((0, $7nWhn.default).viewAllStarred)));
}

});
parcelRegister("4s8PW", function(module, exports) {

$parcel$export(module.exports, "ProjectsDroppableGroupIndicator", () => $439ddf3889c1ad8b$export$2fb821b6490fad6e);

var $5uXOq = parcelRequire("5uXOq");

var $4Y9D7 = parcelRequire("4Y9D7");

var $4R6GH = parcelRequire("4R6GH");

var $3cxR8 = parcelRequire("3cxR8");
const $439ddf3889c1ad8b$export$2fb821b6490fad6e = (props)=>{
    const { children: children } = props;
    const dropTarget = (0, $3cxR8.useDropTargetForProjects)();
    if ((0, $4R6GH.fg)('blu-6314-drag-and-drop-projects-sidebar-mouse')) {
        const { ref: ref, state: state } = dropTarget;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Y9D7.GroupDropIndicator), {
            isActive: state === 'is-over',
            ref: ref
        }, children);
    }
    return props.children;
};

});
parcelRegister("4Y9D7", function(module, exports) {

$parcel$export(module.exports, "GroupDropIndicator", () => $0e2b5955ffe8b2e5$export$cb7fd016127fc6fc);
/* group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $0e2b5955ffe8b2e5$var$activeStyles = null;
const $0e2b5955ffe8b2e5$export$cb7fd016127fc6fc = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function GroupDropIndicator({ children: children, isActive: isActive, testId: testId }, forwardedRef) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: forwardedRef,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            isActive && "_2rkogqwt _bfhk33gi _1cwg12x7 _12y31bk5 _1qu2nqa1 _12ji1yqz"
        ]),
        children: children
    });
});

});

parcelRegister("3cxR8", function(module, exports) {

$parcel$export(module.exports, "useDropTargetForProjects", () => $f8c76a3cff3672f8$export$bf27ec69454698cb);

var $5uXOq = parcelRequire("5uXOq");

var $7gWdR = parcelRequire("7gWdR");

var $7XuAO = parcelRequire("7XuAO");

var $4R6GH = parcelRequire("4R6GH");

var $e5wyW = parcelRequire("e5wyW");

var $dtNal = parcelRequire("dtNal");


var $dyGw2 = parcelRequire("dyGw2");
const $f8c76a3cff3672f8$var$useDropTargetForProjectsConditionally = ()=>{
    const ref = (0, $5uXOq.useRef)(null);
    const [state, setState] = (0, $5uXOq.useState)();
    const updateFavouriteOrder = (0, $dyGw2.useUpdateFavouriteOrder)();
    (0, $5uXOq.useEffect)(()=>{
        const element = ref.current;
        // might have no projects
        if (!element) return;
        return (0, $7gWdR.dropTargetForElements)({
            element: element,
            canDrop: ({ source: source })=>{
                return (0, $dtNal.isDraggableProject)(source.data);
            },
            onDragStart () {
                setState('is-over');
            },
            onDragEnter () {
                setState('is-over');
            },
            onDragLeave () {
                setState('idle');
            },
            onDrop ({ source: source, location: location }) {
                setState('idle');
                const dragging = source.data;
                const [innerMost] = location.current.dropTargets;
                const dropTargetData = innerMost.data;
                if (!(0, $dtNal.isDraggableProject)(dragging) || !(0, $dtNal.isDraggableProject)(dropTargetData)) return;
                const instruction = (0, $7XuAO.extractInstruction)(dropTargetData);
                const operation = instruction && $f8c76a3cff3672f8$var$instructionToOperation(instruction);
                if (operation) updateFavouriteOrder(operation, dragging.id, dropTargetData.id);
            }
        });
    });
    return {
        ref: ref,
        state: state
    };
};
const $f8c76a3cff3672f8$export$bf27ec69454698cb = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('blu-6314-drag-and-drop-projects-sidebar-mouse'), $f8c76a3cff3672f8$var$useDropTargetForProjectsConditionally, ()=>({
        ref: {
            current: null
        },
        state: undefined
    }));
const $f8c76a3cff3672f8$var$instructionToOperation = (instruction)=>{
    switch(instruction?.operation){
        case 'reorder-before':
            return 0, $053b7304f26ee4ca$export$4cff6e48b6cc73b5;
        case 'reorder-after':
            return 0, $053b7304f26ee4ca$export$e0420f7fed62e74b;
        default:
            return null;
    }
};

});
parcelRegister("dtNal", function(module, exports) {

$parcel$export(module.exports, "isDraggableProject", () => $57cfb8a9afe997f2$export$1338b07381f36262);

var $5HnsC = parcelRequire("5HnsC");
const $57cfb8a9afe997f2$export$1338b07381f36262 = (data)=>{
    return Boolean(data.type === (0, $5HnsC.NAV4_PROJECT_MENU_ITEM_DRAG_AND_DROP));
};

});

const $053b7304f26ee4ca$export$5ff59e4f08b9b299 = 'MOVE_TO_TOP';
const $053b7304f26ee4ca$export$9964b4a63620a911 = 'MOVE_UP';
const $053b7304f26ee4ca$export$2692a384035c5ef7 = 'MOVE_DOWN';
const $053b7304f26ee4ca$export$a5a45050b97fca24 = 'MOVE_TO_BOTTOM';
const $053b7304f26ee4ca$export$e0420f7fed62e74b = 'AFTER';
const $053b7304f26ee4ca$export$4cff6e48b6cc73b5 = 'BEFORE';

parcelRegister("dyGw2", function(module, exports) {

$parcel$export(module.exports, "useUpdateFavouriteOrder", () => $d8a2f9705b8500d4$export$63ac7262a5a1464f);

var $ex76y = parcelRequire("ex76y");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $koeKL = parcelRequire("koeKL");

var $fY39E = parcelRequire("fY39E");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $eCBf9 = parcelRequire("eCBf9");

var $5HnsC = parcelRequire("5HnsC");

var $ez27M = parcelRequire("ez27M");

var $5NI6g = parcelRequire("5NI6g");

var $ekWKc = parcelRequire("ekWKc");

var $uSTZW = parcelRequire("uSTZW");
const $d8a2f9705b8500d4$export$63ac7262a5a1464f = (favouriteConnectionId)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const activationId = (0, $fY39E.useActivationId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [commitMutation] = (0, $8Uumt.useMutation)((0, $ex76y.default));
    const handleError = (0, $5NI6g.useHandleError)();
    const updateFavouriteOrder = (0, $5uXOq.useCallback)((operation, projectId, options)=>{
        // Clean up ProjectId[] call signature with flag blu-6314-drag-and-drop-projects-sidebar-mouse
        const projectIds = Array.isArray(options) && options;
        const relativeProjectId = !Array.isArray(options) ? options : undefined;
        commitMutation({
            variables: {
                input: {
                    cloudId: cloudId,
                    reorderMode: operation,
                    menuItem: {
                        itemId: projectId
                    },
                    // include relative menu item if provided
                    ...relativeProjectId && {
                        relativeMenuItem: {
                            itemId: relativeProjectId
                        }
                    }
                }
            },
            optimisticUpdater: (store)=>{
                // Clean up old optimistic updater with flag blu-6314-drag-and-drop-projects-sidebar-mouse
                if (favouriteConnectionId && projectIds) (0, $ekWKc.optimisticUpdater)(store, favouriteConnectionId, operation, projectIds, projectId);
                else (0, $uSTZW.optimisticUpdater)(store, operation, projectId, cloudId, activationId, relativeProjectId);
            },
            onCompleted: (_, errors)=>{
                if (errors && errors.length > 0) {
                    const error = new (0, $eCBf9.MutationError)(errors[0]);
                    handleError(error);
                } else {
                    const analyticsEvent = createAnalyticsEvent({});
                    (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, {
                        ...(0, $5HnsC.ANALYTIC_PAYLOAD).UPDATED_ORDER,
                        attributes: {
                            ...(0, $5HnsC.ANALYTIC_PAYLOAD).ATTRIBUTES,
                            itemId: projectId,
                            action: (0, $ez27M.menuItemReorderOperationToAction)(operation)
                        }
                    });
                }
            },
            onError: (error)=>{
                handleError(new (0, $eCBf9.MutationError)(error));
            }
        });
    }, [
        commitMutation,
        cloudId,
        activationId,
        favouriteConnectionId,
        handleError,
        createAnalyticsEvent
    ]);
    return updateFavouriteOrder;
};

});
parcelRegister("ex76y", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b71150f3ca8e167$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<24454a01f4271ea953317eafa137e981>>
 * @relayHash 101a39e3bfad9162ed7479e2adf18bd8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cfa36f3a72e463c9e26c89343b6e498ae095af864e4eee0df3d31e2d4949aa59

var $kXP4b = parcelRequire("kXP4b");

var $cN96Q = parcelRequire("cN96Q");

var $i2tXg = parcelRequire("i2tXg");
const $6b71150f3ca8e167$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 15
        }
    ], v4 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v5 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v7 = [
        {
            "kind": "Literal",
            "name": "type",
            "value": "EDIT_PROJECT_CONFIG"
        }
    ], v8 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "updateFavouriteOrderMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_reorderProjectsSidebarMenuItem",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "Nav4ProjectMenuItem"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v6 /*: any*/ 
                            ],
                            "storageKey": "favourites(first:15)"
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "updateFavouriteOrderMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_reorderProjectsSidebarMenuItem",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "status"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectType"
                                                },
                                                {
                                                    "concreteType": "JiraAvatar",
                                                    "kind": "LinkedField",
                                                    "name": "avatar",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "large"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "defaultNavigationItem",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "url"
                                                                }
                                                            ],
                                                            "type": "JiraNavigationItem",
                                                            "abstractKey": "__isJiraNavigationItem"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v2 /*: any*/ 
                                                            ],
                                                            "type": "Node",
                                                            "abstractKey": "__isNode"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "alias": "editProjectConfig",
                                                    "args": v7 /*: any*/ ,
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": v8 /*: any*/ ,
                                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                                },
                                                {
                                                    "args": v7 /*: any*/ ,
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": v8 /*: any*/ ,
                                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectStyle"
                                                },
                                                {
                                                    "alias": "editPermission",
                                                    "args": v7 /*: any*/ ,
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": v8 /*: any*/ ,
                                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "webUrl"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "softwareBoardCount"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v6 /*: any*/ 
                            ],
                            "storageKey": "favourites(first:15)"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "cfa36f3a72e463c9e26c89343b6e498ae095af864e4eee0df3d31e2d4949aa59",
            "metadata": {},
            "name": "updateFavouriteOrderMutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider": (0, $kXP4b.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": (0, $cN96Q.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider": (0, $i2tXg.default)
            }
        }
    };
}();
$6b71150f3ca8e167$var$node.hash = "3fb3d322be947c54af429676ea108ccc";
var $6b71150f3ca8e167$export$2e2bcd8739ae039 = $6b71150f3ca8e167$var$node;

});

parcelRegister("ez27M", function(module, exports) {

$parcel$export(module.exports, "menuItemReorderOperationToAction", () => $21d6fc63cb38d227$export$8357c82608ac73da);

const $21d6fc63cb38d227$export$8357c82608ac73da = (operation)=>{
    switch(operation){
        case 0, $053b7304f26ee4ca$export$5ff59e4f08b9b299:
            return 'moveToTop';
        case 0, $053b7304f26ee4ca$export$9964b4a63620a911:
            return 'moveUp';
        case 0, $053b7304f26ee4ca$export$2692a384035c5ef7:
            return 'moveDown';
        case 0, $053b7304f26ee4ca$export$a5a45050b97fca24:
            return 'moveToBottom';
        case 0, $053b7304f26ee4ca$export$e0420f7fed62e74b:
            return 'dragged';
        case 0, $053b7304f26ee4ca$export$4cff6e48b6cc73b5:
            return 'dragged';
        default:
            return '';
    }
};

});

parcelRegister("5NI6g", function(module, exports) {

$parcel$export(module.exports, "useHandleError", () => $700bdac2b6f032ff$export$7ab84fea33af0d21);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $jcw0u = parcelRequire("jcw0u");

var $5HnsC = parcelRequire("5HnsC");

var $kTDDm = parcelRequire("kTDDm");
const $700bdac2b6f032ff$var$FLAG = {
    type: 'error',
    title: (0, $kTDDm.default).defaultErrorTitle,
    description: (0, $kTDDm.default).defaultErrorMessage,
    messageId: 'navigation-apps-sidebar-nav4-projects-customise-order.services.update-favourite-order.flag.error',
    messageType: 'transactional'
};
function $700bdac2b6f032ff$export$7ab84fea33af0d21() {
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const handleError = (0, $5uXOq.useCallback)((error)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'useUpdateFavouriteOrder',
                packageName: (0, $5HnsC.PACKAGE_NAME),
                teamName: (0, $5HnsC.TEAM_NAME)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        showFlag($700bdac2b6f032ff$var$FLAG);
    }, [
        showFlag
    ]);
    return handleError;
}

});
parcelRegister("kTDDm", function(module, exports) {

$parcel$export(module.exports, "default", () => $3872d0f063c2e0a5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3872d0f063c2e0a5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    defaultErrorMessage: {
        "id": "jira-navigation-apps-sidebar-nav4-projects-customise-order.default-error-message",
        "defaultMessage": "Check your connection and try again."
    },
    defaultErrorTitle: {
        "id": "jira-navigation-apps-sidebar-nav4-projects-customise-order.default-error-title",
        "defaultMessage": "We couldn't update your view."
    }
});

});


parcelRegister("ekWKc", function(module, exports) {

$parcel$export(module.exports, "optimisticUpdater", () => $8ae6b27f86e9efd1$export$32fd5c97e0eb451);

var $l4Kia = parcelRequire("l4Kia");
function $8ae6b27f86e9efd1$export$32fd5c97e0eb451(store, favouriteConnectionId, operation, projectIds, targetProjectId) {
    if (!projectIds.length || projectIds.length <= 1) return;
    const favoriteConnection = store.get(favouriteConnectionId);
    if (!favoriteConnection) return;
    // Retrieve all edges from the connection
    const edges = favoriteConnection.getLinkedRecords('edges') ?? [];
    if (!edges.length || edges.length <= 1) return;
    const sortedProjectIds = (0, $l4Kia.reorder)(operation, projectIds, targetProjectId);
    // Create a Set to check if sortedProjectIds has different ids from the Relay records
    const projectIdSet = new Set(sortedProjectIds);
    // Create a Map to store projectId -> edge
    const projectIdToEdgeMap = new Map();
    for (const edge of edges){
        const node = edge.getLinkedRecord('node');
        const projectId = String(node?.getValue('projectId'));
        if (projectId) {
            // Exit if the Relay record doesn't match the sortedProjectIds
            if (!projectIdSet.has(projectId)) return;
            projectIdToEdgeMap.set(projectId, edge);
        }
    }
    // Reconstruct edges array in the order specified by sortedProjectIds
    const sortedEdges = [];
    for (const projectId of sortedProjectIds){
        const edge = projectIdToEdgeMap.get(projectId);
        if (edge) sortedEdges.push(edge);
    }
    // Update the connection with the newly ordered edges
    favoriteConnection.setLinkedRecords(sortedEdges, 'edges');
}

});
parcelRegister("l4Kia", function(module, exports) {

$parcel$export(module.exports, "reorder", () => $230dbfc2be03a062$export$fc77a6137e3f91c);

const $230dbfc2be03a062$export$f2c5cc4c3f787c3e = (projectsList, projectId)=>{
    const filteredList = projectsList.filter((id)=>id !== projectId);
    return [
        projectId,
        ...filteredList
    ];
};
const $230dbfc2be03a062$export$8ff471d483515a76 = (projectsList, projectId)=>{
    const filteredList = projectsList.filter((id)=>id !== projectId);
    return [
        ...filteredList,
        projectId
    ];
};
const $230dbfc2be03a062$export$44935f8a884b57b9 = (projectsList, projectId)=>{
    const index = projectsList.indexOf(projectId);
    if (index > 0) {
        const newList = [
            ...projectsList
        ];
        newList.splice(index, 1);
        newList.splice(index - 1, 0, projectId);
        return newList;
    }
    return projectsList;
};
const $230dbfc2be03a062$export$8eba228b343b3599 = (projectsList, projectId)=>{
    const index = projectsList.indexOf(projectId);
    if (index >= 0) {
        const newList = [
            ...projectsList
        ];
        newList.splice(index, 1);
        newList.splice(index + 1, 0, projectId);
        return newList;
    }
    return projectsList;
};
const $230dbfc2be03a062$export$86b68c7dbeb53c22 = (projectsList, projectId, relativeProject)=>{
    const index = projectsList.indexOf(relativeProject);
    if (index >= 0) {
        const filteredList = projectsList.filter((id)=>id !== projectId);
        const newList = [
            ...filteredList
        ];
        newList.splice(filteredList.indexOf(relativeProject), 0, projectId);
        return newList;
    }
    return projectsList;
};
const $230dbfc2be03a062$export$c4f94c8b3850a5a9 = (projectsList, projectId, relativeProject)=>{
    const index = projectsList.indexOf(relativeProject);
    if (index >= 0) {
        const filteredList = projectsList.filter((id)=>id !== projectId);
        const newList = [
            ...filteredList
        ];
        newList.splice(filteredList.indexOf(relativeProject) + 1, 0, projectId);
        return newList;
    }
    return projectsList;
};
const $230dbfc2be03a062$export$4583b779aad6d7dc = (projectsList, projectId)=>{
    return [
        projectId,
        ...projectsList
    ];
};
const $230dbfc2be03a062$export$a7bc06cf61a60193 = (projectsList, projectId)=>{
    return [
        ...projectsList,
        projectId
    ];
};
const $230dbfc2be03a062$export$fc77a6137e3f91c = (operation, projectIds, projectId, relativeId)=>{
    switch(operation){
        case 0, $053b7304f26ee4ca$export$5ff59e4f08b9b299:
            return $230dbfc2be03a062$export$f2c5cc4c3f787c3e(projectIds, projectId);
        case 0, $053b7304f26ee4ca$export$9964b4a63620a911:
            return $230dbfc2be03a062$export$44935f8a884b57b9(projectIds, projectId);
        case 0, $053b7304f26ee4ca$export$2692a384035c5ef7:
            return $230dbfc2be03a062$export$8eba228b343b3599(projectIds, projectId);
        case 0, $053b7304f26ee4ca$export$a5a45050b97fca24:
            return $230dbfc2be03a062$export$8ff471d483515a76(projectIds, projectId);
        case 0, $053b7304f26ee4ca$export$4cff6e48b6cc73b5:
            return relativeId ? $230dbfc2be03a062$export$86b68c7dbeb53c22(projectIds, projectId, relativeId) : projectIds;
        case 0, $053b7304f26ee4ca$export$e0420f7fed62e74b:
            return relativeId ? $230dbfc2be03a062$export$c4f94c8b3850a5a9(projectIds, projectId, relativeId) : projectIds;
        default:
            return projectIds;
    }
};

});


parcelRegister("uSTZW", function(module, exports) {

$parcel$export(module.exports, "optimisticUpdater", () => $47180b5c7a218774$export$32fd5c97e0eb451);

var $eJAI4 = parcelRequire("eJAI4");

var $iJZ8l = parcelRequire("iJZ8l");

var $l4Kia = parcelRequire("l4Kia");
function $47180b5c7a218774$export$32fd5c97e0eb451(store, operation, targetProjectId, cloudId, activationId, relativeProjectId) {
    // Following the format generated by JiraNavigationProjectsSidebarMenuFacade
    const assumedAri = (0, $eJAI4.JiraNavigationMenuAri).create({
        siteId: cloudId,
        activationId: activationId,
        navigationItemScope: 'projects'
    });
    // Relay ID format for SidebarMenu favourites query. Modify to match query if changed
    const dataID = (0, $iJZ8l.default)({
        id: assumedAri
    }, 'JiraProjectsSidebarMenu:favourites(first:15)');
    const favoriteConnection = store.get(`client:${dataID}`);
    if (!favoriteConnection) return;
    const edges = favoriteConnection.getLinkedRecords('edges') ?? [];
    if (!edges.length || edges.length <= 1) return;
    const projectIdToEdgeMap = edges.reduce((map, edge)=>{
        const projectId = edge.getLinkedRecord('node')?.getValue('projectId')?.toString();
        return projectId ? map.set(projectId, edge) : map;
    }, new Map());
    const projectIds = Array.from(projectIdToEdgeMap.keys());
    const sortedProjectIds = (0, $l4Kia.reorder)(operation, projectIds, targetProjectId, relativeProjectId);
    const sortedEdges = sortedProjectIds.map((projectId)=>projectIdToEdgeMap.get(projectId) ?? null);
    favoriteConnection.setLinkedRecords(sortedEdges, 'edges');
}

});
parcelRegister("eJAI4", function(module, exports) {

$parcel$export(module.exports, "JiraNavigationMenuAri", () => $aba1be71a9aa0879$export$26b4b250c46b1789);

var $cVUHs = parcelRequire("cVUHs");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/navigation-menu/manifest.ts
var $aba1be71a9aa0879$var$jiraNavigationMenuAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $cVUHs.JiraNavigationMenuAriResourceOwner),
    resourceType: (0, $cVUHs.JiraNavigationMenuAriResourceType),
    resourceIdSlug: "activation/{activationId}/{navigationItemScope}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        navigationItemScope: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/navigation-menu/index.ts
var $aba1be71a9aa0879$export$26b4b250c46b1789 = class _JiraNavigationMenuAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._navigationItemScope = opts.resourceIdSegmentValues.navigationItemScope;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get navigationItemScope() {
        return this._navigationItemScope;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $aba1be71a9aa0879$var$jiraNavigationMenuAriStaticOpts.qualifier,
            platformQualifier: $aba1be71a9aa0879$var$jiraNavigationMenuAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $aba1be71a9aa0879$var$jiraNavigationMenuAriStaticOpts.resourceOwner,
            resourceType: $aba1be71a9aa0879$var$jiraNavigationMenuAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.navigationItemScope}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                navigationItemScope: opts.navigationItemScope
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $aba1be71a9aa0879$var$jiraNavigationMenuAriStaticOpts);
        return new _JiraNavigationMenuAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $aba1be71a9aa0879$var$jiraNavigationMenuAriStaticOpts);
        return new _JiraNavigationMenuAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            navigationItemScope: this.navigationItemScope
        };
    }
};

});
parcelRegister("cVUHs", function(module, exports) {

$parcel$export(module.exports, "JiraNavigationMenuAriResourceOwner", () => $96a6ca576433eedc$export$9cc7dbdedb3b99ab);
$parcel$export(module.exports, "JiraNavigationMenuAriResourceType", () => $96a6ca576433eedc$export$56f5cd8ea2092034);
// src/jira/navigation-menu/types.ts
var $96a6ca576433eedc$export$9cc7dbdedb3b99ab = "jira", $96a6ca576433eedc$export$56f5cd8ea2092034 = "navigation-menu";

});







parcelRegister("gtmvt", function(module, exports) {

$parcel$export(module.exports, "RenderMostRecentProjectSection", () => $42eb6b65ca7d8cb1$export$6269b4a1c127cf98);

var $5uXOq = parcelRequire("5uXOq");

var $1qQhw = parcelRequire("1qQhw");
var $1FdfO = parcelRequire("1FdfO");
const $42eb6b65ca7d8cb1$export$6269b4a1c127cf98 = ({ projectItem: projectItem })=>{
    return !!projectItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1qQhw.MenuListItem), {
        testId: "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.ui.content.most-recent-project-section.most-recent-project-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1FdfO.MenuSection), null, projectItem));
};

});


parcelRegister("5alFY", function(module, exports) {

$parcel$export(module.exports, "Nav4ProjectsSectionsWithDisplaySettings", () => $34081a9b213852ea$export$f5fa44865e47a204);

var $ggBBt = parcelRequire("ggBBt");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jhS4y = parcelRequire("jhS4y");

var $80ha2 = parcelRequire("80ha2");

var $c6x3L = parcelRequire("c6x3L");

var $kytLE = parcelRequire("kytLE");

var $aeBua = parcelRequire("aeBua");

var $di4cw = parcelRequire("di4cw");
const $34081a9b213852ea$var$isDisplaySettingsKey = (value)=>{
    const keys = Object.values((0, $kytLE.DisplaySettingsPropertyKeys));
    return keys.includes(value);
};
const $34081a9b213852ea$var$getNavigationCustomisation = (nodes, viewOption, defaultValue)=>{
    return nodes?.find((node)=>node?.key && $34081a9b213852ea$var$isDisplaySettingsKey(node.key) && (0, $kytLE.DisplaySettingsPropertyKeys)[node.key] === viewOption)?.value || defaultValue;
};
const $34081a9b213852ea$export$f5fa44865e47a204 = ({ favoriteItems: favoriteItems, recentItems: recentItems, queryRef: queryRef })=>{
    const data = (0, $8Uumt.useFragment)((0, $ggBBt.default), queryRef);
    const selectedViewOption = $34081a9b213852ea$var$getNavigationCustomisation(data.settings_navigationCustomisation?.properties?.nodes, (0, $kytLE.DisplaySettingsPropertyKeys).VIEW_OPTION, (0, $80ha2.DefaultViewOption));
    const { isSelectedPath: isSelectedPath } = (0, $c6x3L.useSidebarNav4)();
    const isStarredViewOptionSelected = selectedViewOption === (0, $80ha2.ViewOptions).STARRED;
    const isStarredAndRecentViewOptionSelected = selectedViewOption === (0, $80ha2.ViewOptions).STARRED_AND_RECENT;
    // If the current project is not starred, display it under the Recent section.
    // Once navigated away from the current non-starred project, it should disappear from the sidebar,
    // along with the Recent section
    const currentRecentItem = recentItems.list.find((item)=>item.key && isSelectedPath((0, $jhS4y.ENTITY_ID).PROJECT(item.key)));
    const displayedRecentItems = isStarredViewOptionSelected ? {
        list: currentRecentItem ? [
            currentRecentItem
        ] : [],
        hasItems: Boolean(currentRecentItem)
    } : recentItems;
    const shouldShowStarredSection = isStarredAndRecentViewOptionSelected || isStarredViewOptionSelected;
    const shouldShowRecentSection = isStarredAndRecentViewOptionSelected || displayedRecentItems.hasItems;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, shouldShowStarredSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aeBua.RenderStarredSection), {
        favoriteItems: favoriteItems
    }), shouldShowRecentSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $di4cw.RenderRecentSection), {
        recentItems: displayedRecentItems
    }));
};

});
parcelRegister("ggBBt", function(module, exports) {

$parcel$export(module.exports, "default", () => $36220f58404b9cde$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<db313e78bd4577e1f34af3f48f590ec2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $36220f58404b9cde$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "entityAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ownerAri"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4ProjectsSectionsWithDisplaySettings",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "entityAri",
                    "variableName": "entityAri"
                },
                {
                    "kind": "Variable",
                    "name": "ownerAri",
                    "variableName": "ownerAri"
                }
            ],
            "concreteType": "SettingsNavigationCustomisation",
            "kind": "LinkedField",
            "name": "settings_navigationCustomisation",
            "plural": false,
            "selections": [
                {
                    "concreteType": "SettingsDisplayPropertyConnection",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SettingsDisplayProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$36220f58404b9cde$var$node.hash = "e6e0f204dff7282a7c0aeb808efb30c6";
var $36220f58404b9cde$export$2e2bcd8739ae039 = $36220f58404b9cde$var$node;

});




parcelRegister("a9bTe", function(module, exports) {

$parcel$export(module.exports, "useCreateProjectCheckPermissions", () => $a71a1b4c5fbb2614$export$1fb28f66ef08585d);

var $l3yn4 = parcelRequire("l3yn4");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $bSSG7 = parcelRequire("bSSG7");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $itmJb = parcelRequire("itmJb");

var $koeKL = parcelRequire("koeKL");
const $a71a1b4c5fbb2614$var$localStorageProvider = (0, $bSSG7.createLocalStorageProvider)('analytics-permission-check');
const $a71a1b4c5fbb2614$export$1fb28f66ef08585d = ()=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const cloudId = (0, $koeKL.useCloudId)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (!$a71a1b4c5fbb2614$var$localStorageProvider.get('complete') && (0, $4R6GH.fg)('groot-create-team-project-permission-check')) {
            (0, $8Uumt.fetchQuery)(environment, (0, $l3yn4.default), {
                cloudId: cloudId
            }).subscribe({
                next: (data)=>{
                    (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'createProject userPermissions', {
                        canCreateProject: !!data?.jira?.canCreateProject,
                        canCreateTeamManagedProject: !!data?.jira?.canCreateTeamManagedProject,
                        canCreateCompanyManagedProject: !!data?.jira?.canCreateCompanyManagedProject,
                        isAdmin: isAdmin
                    });
                }
            });
            $a71a1b4c5fbb2614$var$localStorageProvider.set('complete', true);
        }
    });
};

});
parcelRegister("l3yn4", function(module, exports) {

$parcel$export(module.exports, "default", () => $469e20a2166550ef$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c93e540d636d0b392cdbbee73a0755ce>>
 * @relayHash 62bedc769e6bd9abd36363472bc29495
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1b61f743a91e56bc00fd4727121e1381902c2c173f101c226049470d68a35783
const $469e20a2166550ef$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "alias": "canCreateProject",
                    "args": [
                        v1 /*: any*/ ,
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "CREATE_PROJECT"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "canPerform"
                },
                {
                    "alias": "canCreateTeamManagedProject",
                    "args": [
                        v1 /*: any*/ ,
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "CREATE_TEAM_MANAGED_PROJECT"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "canPerform"
                },
                {
                    "alias": "canCreateCompanyManagedProject",
                    "args": [
                        v1 /*: any*/ ,
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "CREATE_COMPANY_MANAGED_PROJECT"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "canPerform"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "analyticsPermissionCheckCreateProjectQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "analyticsPermissionCheckCreateProjectQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "id": "1b61f743a91e56bc00fd4727121e1381902c2c173f101c226049470d68a35783",
            "metadata": {},
            "name": "analyticsPermissionCheckCreateProjectQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$469e20a2166550ef$var$node.hash = "5895b8dfd4b6785a379d210f5d735279";
var $469e20a2166550ef$export$2e2bcd8739ae039 = $469e20a2166550ef$var$node;

});




parcelRegister("abrAF", function(module, exports) {

$parcel$export(module.exports, "Recent", () => $ca7c92fe8a3d50e4$export$1147d6e1036afec);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $l8ruj = parcelRequire("l8ruj");


var $paz61 = parcelRequire("paz61");
const $ca7c92fe8a3d50e4$export$1147d6e1036afec = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4-sidebar-recent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "flag",
        id: "recent",
        packageName: (0, $7ad55196d5c142dd$export$b8b9d90f9e5bd72b),
        teamName: (0, $7ad55196d5c142dd$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $paz61.RecentMenu), null)));

});
const $7ad55196d5c142dd$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Recent';
const $7ad55196d5c142dd$export$d57b6b390e78d90f = 'jira-cosmos';
const $7ad55196d5c142dd$export$56ff071570537731 = 15;
const $7ad55196d5c142dd$export$fe791c4fa892e400 = 'PROJECT';
const $7ad55196d5c142dd$export$c303e491e026ebc6 = 'PLAN';
const $7ad55196d5c142dd$export$c1c49903035a02df = 'FILTER';
const $7ad55196d5c142dd$export$4695c1a423ffe431 = 'DASHBOARD';
const $7ad55196d5c142dd$export$9b8283d5878d2491 = 'BOARD';
const $7ad55196d5c142dd$export$5828682c822c26e7 = 'QUEUE';
const $7ad55196d5c142dd$export$76a449e52fa0e1e8 = 'ISSUE';
const $7ad55196d5c142dd$export$fd6cd74eeb4b51a7 = 'searchRecentItems';
const $7ad55196d5c142dd$export$f91d73dc0ffb6584 = 'viewAllRecentItems';
const $7ad55196d5c142dd$export$ee6bbe0a973ca0e8 = 'today';
const $7ad55196d5c142dd$export$91c1c08ffbb5f1be = 'yesterday';
const $7ad55196d5c142dd$export$4bada75a9cb45bec = 'thisWeek';
const $7ad55196d5c142dd$export$1385d821597ee807 = 'thisMonth';
const $7ad55196d5c142dd$export$d64d14c448d5a065 = 'moreThanAMonth';

parcelRegister("paz61", function(module, exports) {

$parcel$export(module.exports, "RecentMenu", () => $041364aacc6e1a81$export$9051cd0d0927b696);

var $5uXOq = parcelRequire("5uXOq");

var $hyKRO = parcelRequire("hyKRO");

var $jUDIz = parcelRequire("jUDIz");
var $17aWz = parcelRequire("17aWz");
var $lBNLs = parcelRequire("lBNLs");

var $htawR = parcelRequire("htawR");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $4R6GH = parcelRequire("4R6GH");


var $jecJ3 = parcelRequire("jecJ3");

var $iszzG = parcelRequire("iszzG");

var $46Cti = parcelRequire("46Cti");

var $338xa = parcelRequire("338xa");

var $24a2m = parcelRequire("24a2m");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koeKL = parcelRequire("koeKL");


var $kIiWz = parcelRequire("kIiWz");

var $jh7Sz = parcelRequire("jh7Sz");
const $041364aacc6e1a81$var$EMPTY_OBJECT = {};
function $041364aacc6e1a81$export$9051cd0d0927b696() {
    const cloudId = (0, $koeKL.useCloudId)();
    const { formattedMessage: formattedMessage, icon: icon } = (0, $24a2m.useFormattedMessageAndIcon)((0, $kIiWz.default).recent, (0, (/*@__PURE__*/$parcel$interopDefault($hyKRO))));
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $jh7Sz.sidebarRecentMenuEntryPoint), (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            count: (0, $7ad55196d5c142dd$export$56ff071570537731)
        }), [
        cloudId
    ]) : {
        cloudId: cloudId,
        count: (0, $7ad55196d5c142dd$export$56ff071570537731)
    });
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    const { moreMenuIds: moreMenuIds } = (0, $5uXOq.useContext)((0, $iszzG.NavItemsContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onOpenChange = (0, $5uXOq.useCallback)((isMenuOpen)=>{
        if (isMenuOpen) {
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
            });
            const isInMore = moreMenuIds.includes((0, $46Cti.L1_MENU_ID).RECENT);
            (0, $8zOmE.fireUIAnalytics)(event, (0, $jecJ3.SECTION_ITEM_RECENT), {
                isInMore: isInMore
            });
        }
    }, [
        moreMenuIds,
        createAnalyticsEvent
    ]);
    return (0, $4R6GH.fg)('jira_global_recent_menu_item') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htawR.GlobalRecentMenuItem), {
        triggerRef: triggerRef,
        onOpenChange: onOpenChange
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jUDIz.FlyoutMenuItem), {
        onOpenChange: onOpenChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lBNLs.FlyoutMenuItemTrigger), {
        interactionName: "nav4-sidebar-recent",
        ref: triggerRef,
        elemBefore: icon
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $17aWz.FlyoutMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "nav4-sidebar-recent-default",
        packageName: (0, $7ad55196d5c142dd$export$b8b9d90f9e5bd72b),
        teamName: (0, $7ad55196d5c142dd$export$d57b6b390e78d90f),
        errorFallback: "flag",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), null),
        runtimeProps: (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? $041364aacc6e1a81$var$EMPTY_OBJECT : {}
    })));
}

});
parcelRegister("htawR", function(module, exports) {

$parcel$export(module.exports, "GlobalRecentMenuItem", () => $57b036c2634ba046$export$c58a64243715c6bf);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $hyKRO = parcelRequire("hyKRO");

var $jUDIz = parcelRequire("jUDIz");
var $17aWz = parcelRequire("17aWz");
var $lBNLs = parcelRequire("lBNLs");

var $kiLoo = parcelRequire("kiLoo");

var $4JtKA = parcelRequire("4JtKA");
const $57b036c2634ba046$export$1a14f8e769122bb2 = (Content)=>({ onOpenChange: onOpenChange, isDefaultOpen: isDefaultOpen, triggerRef: triggerRef })=>{
        const { formatMessage: formatMessage } = (0, $koVbs.default)();
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $jUDIz.FlyoutMenuItem), {
            onOpenChange: onOpenChange,
            isDefaultOpen: isDefaultOpen,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lBNLs.FlyoutMenuItemTrigger), {
                    ref: triggerRef,
                    elemBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hyKRO))), {
                        label: "",
                        color: "currentColor"
                    }),
                    children: formatMessage((0, $4JtKA.messages).flyoutMenuItemTriggerTitle)
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $17aWz.FlyoutMenuItemContent), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(Content, {})
                })
            ]
        });
    };
const $57b036c2634ba046$export$c58a64243715c6bf = $57b036c2634ba046$export$1a14f8e769122bb2((0, $kiLoo.GlobalRecentMenuContent));

});
parcelRegister("kiLoo", function(module, exports) {

$parcel$export(module.exports, "GlobalRecentMenuContent", () => $47989ae97937a74d$export$29802207e0d6c9fc);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $koVbs = parcelRequire("koVbs");

var $l1N8i = parcelRequire("l1N8i");

var $6L0PY = parcelRequire("6L0PY");

var $cJFfS = parcelRequire("cJFfS");

var $gSZmd = parcelRequire("gSZmd");

var $aAbfD = parcelRequire("aAbfD");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");

var $eeeRe = parcelRequire("eeeRe");

var $ekA4E = parcelRequire("ekA4E");

var $4JtKA = parcelRequire("4JtKA");
const $47989ae97937a74d$var$VIEW_ALL_LINK = 'https://home.atlassian.com/recents';

const $47989ae97937a74d$var$LazyGlobalRecentItems = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("21842")));
const $47989ae97937a74d$export$29802207e0d6c9fc = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                paddingInline: "space.075",
                paddingBlock: "space.100",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                    size: "xsmall",
                    children: formatMessage((0, $4JtKA.messages).flyoutMenuItemTriggerTitle)
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
                fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eeeRe.ErrorState), {}),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                    fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ekA4E.LoadingState), {}),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($47989ae97937a74d$var$LazyGlobalRecentItems, {})
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aAbfD.Divider), {}),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gSZmd.MenuList), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cJFfS.LinkMenuItem), {
                    elemBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6L0PY))), {
                        label: "",
                        spacing: "spacious",
                        color: "currentColor"
                    }),
                    href: $47989ae97937a74d$var$VIEW_ALL_LINK,
                    children: formatMessage((0, $4JtKA.messages).viewAllRecentItems)
                })
            })
        ]
    });
};
var $47989ae97937a74d$export$2e2bcd8739ae039 = $47989ae97937a74d$export$29802207e0d6c9fc;

});
parcelRegister("eeeRe", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $895870e33aa4e530$export$c1ed4f415b9e7023);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $4JtKA = parcelRequire("4JtKA");
const $895870e33aa4e530$export$c1ed4f415b9e7023 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        xcss: $895870e33aa4e530$var$styles,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
            alignInline: "center",
            space: "space.050",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                    size: "xsmall",
                    children: formatMessage((0, $4JtKA.messages).errorStateHeading)
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgL5K.default), {
                    size: "small",
                    align: "center",
                    color: "color.text.subtle",
                    children: formatMessage((0, $4JtKA.messages).errorStateDescription)
                })
            ]
        })
    });
};
const $895870e33aa4e530$var$styles = (0, $8CUq3.xcss)({
    paddingBlock: 'space.1000',
    paddingInline: 'space.100'
});

});
parcelRegister("4JtKA", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2d3bb08aab81d13d$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $2d3bb08aab81d13d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    flyoutMenuItemTriggerTitle: {
        id: 'navigation.global-recent.flyout-menu-item-trigger-title.non-final',
        description: 'Label of the control that triggers the flyout menu.',
        defaultMessage: 'Recent'
    },
    viewAllRecentItems: {
        id: 'navigation.global-recent.view-all-recent-items.non-final',
        description: 'Label of the control that links to a page with all of the recent items.',
        defaultMessage: 'View all recent items'
    },
    menuSectionHeadingToday: {
        id: 'navigation.global-recent.menu-section-heading-today.non-final',
        description: "Heading of the section rendering today's items.",
        defaultMessage: 'Today'
    },
    menuSectionHeadingYesterday: {
        id: 'navigation.global-recent.menu-section-heading-yesterday.non-final',
        description: "Heading of the section rendering yesterday's items.",
        defaultMessage: 'Yesterday'
    },
    menuSectionHeadingThisWeek: {
        id: 'navigation.global-recent.menu-section-heading-this-week.non-final',
        description: 'Heading of the section rendering items for the current week.',
        defaultMessage: 'This week'
    },
    menuSectionHeadingThisMonth: {
        id: 'navigation.global-recent.menu-section-heading-this-month.non-final',
        description: 'Heading of the section rendering items for the current month.',
        defaultMessage: 'This Month'
    },
    menuSectionHeadingMoreThanAMonthAgo: {
        id: 'navigation.global-recent.menu-section-heading-this-month.non-final',
        description: 'Heading of the section rendering items older than a month ago.',
        defaultMessage: 'More than a month ago'
    },
    errorStateHeading: {
        id: 'navigation.global-recent.error-state-heading.non-final',
        description: "Heading of the error state UI indicating we couldn't load the data.",
        defaultMessage: "Can't load items"
    },
    errorStateDescription: {
        id: 'navigation.global-recent.error-state-description.non-final',
        description: "Description of the error state UI indicating we couldn't load the data.",
        defaultMessage: "We're having trouble loading your data. Please try again later."
    },
    emptyStateHeading: {
        id: 'navigation.global-recent.empty-state-heading.non-final',
        description: "Heading of the empty state UI indicating there's no content available.",
        defaultMessage: 'Nothing to see here!'
    },
    emptyStateDescription: {
        id: 'navigation.global-recent.empty-state-description.non-final',
        description: "Description of the empty state UI indicating there's no content available.",
        defaultMessage: "Once you visit, edit, or create items, they'll show up here."
    },
    loadingStateVisuallyHiddenLabel: {
        id: 'navigation.global-recent.loading-state-visually-hidden-label.non-final',
        description: 'Label of the loading state UI only available to screen reader users.',
        defaultMessage: 'Loading recent content'
    },
    confluenceDraftDefaultTitle: {
        id: 'navigation.global-recent.confluence-item-draft-title.non-final',
        description: 'Default title for draft pages and blog posts in Confluence.',
        defaultMessage: 'Untitled'
    },
    confluenceDraftLabel: {
        id: 'navigation.global-recent.confluence-item-draft-label.non-final',
        description: 'Label of the lozenge indicating a Confluence item is a draft.',
        defaultMessage: 'Draft'
    }
});

});


parcelRegister("ekA4E", function(module, exports) {

$parcel$export(module.exports, "LoadingState", () => $48beae453ce3023e$export$62aa48085237e36f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $iwwXK = parcelRequire("iwwXK");

var $gSZmd = parcelRequire("gSZmd");

var $1qQhw = parcelRequire("1qQhw");

var $jldZL = parcelRequire("jldZL");

var $4JtKA = parcelRequire("4JtKA");
const $48beae453ce3023e$export$62aa48085237e36f = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const items = Array.from({
        length: 5
    }, (_, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1qQhw.MenuListItem), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwwXK.default), {
                isShimmering: true,
                width: "100%"
            })
        }, index));
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jldZL.default), {
                children: formatMessage((0, $4JtKA.messages).loadingStateVisuallyHiddenLabel)
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gSZmd.MenuList), {
                children: items
            })
        ]
    });
};

});

parcelRegister("21842", function(module, exports) {

let $1781ee233afeffac$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1781ee233afeffac$var$load("2Jj3u").then(()=>parcelRequire('iUmYx'));

});



parcelRegister("kIiWz", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa748d68241ef7a4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fa748d68241ef7a4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    recent: {
        "id": "navigation-apps-sidebar-nav4-recent.recent",
        "defaultMessage": "Recent"
    }
});

});

parcelRegister("jh7Sz", function(module, exports) {

$parcel$export(module.exports, "sidebarRecentMenuEntryPoint", () => $59b75f87881a1c54$export$52be5f9ca0100885);

var $6sGCE = parcelRequire("6sGCE");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $59b75f87881a1c54$export$52be5f9ca0100885 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("43AlB")), {
        moduleId: "1a0fa847",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, count: count })=>({
            queries: {
                recentMenuData: {
                    parameters: $6sGCE.default,
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    variables: {
                        cloudId: cloudId,
                        count: count,
                        keyword: ''
                    }
                }
            }
        })
});

});
parcelRegister("6sGCE", function(module, exports) {

$parcel$export(module.exports, "default", () => $de7f5d7554961488$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b419a047cdf1d84819532a8450f2373a>>
 * @relayHash 2bf261fc9e503f19a16072abc8ff3bb0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 855172207100d7942753caadb5bb595995ca2328e35845d9cb3c8f297f5e2ce4

var $eiowN = parcelRequire("eiowN");
const $de7f5d7554961488$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "count"
    }, v2 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "keyword"
    }, v3 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v4 = {
        "fields": [
            {
                "kind": "Variable",
                "name": "keyword",
                "variableName": "keyword"
            }
        ],
        "kind": "ObjectValue",
        "name": "filter"
    }, v5 = {
        "kind": "Literal",
        "name": "types",
        "value": [
            "PROJECT",
            "FILTER",
            "DASHBOARD",
            "BOARD",
            "QUEUE",
            "ISSUE",
            "PLAN"
        ]
    }, v6 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        },
        v5 /*: any*/ 
    ], v7 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "startCursor"
            }
        ]
    }, v8 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        },
        v5 /*: any*/ 
    ], v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = {
        "kind": "ScalarField",
        "name": "id"
    }, v11 = {
        "kind": "ScalarField",
        "name": "lastViewedTimestamp"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            v10 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v13 = [
        v10 /*: any*/ ,
        v11 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "alias": "filterName",
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "filterUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "filterId"
                }
            ],
            "type": "JiraFilter",
            "abstractKey": "__isJiraFilter"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "recentMenuQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "recent",
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v7 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.recent.pageInfo"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.recent"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "count",
                            "variableName": "count"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "recentMenu_navigationAppsSidebarNav4SidebarsContentRecent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "recentMenuQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "recent",
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "_recentItems",
                            "args": v8 /*: any*/ ,
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraSingleLineTextField",
                                                            "kind": "LinkedField",
                                                            "name": "summaryField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "text"
                                                                },
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "alias": "issueWebUrl",
                                                            "kind": "ScalarField",
                                                            "name": "webUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "issueId"
                                                        }
                                                    ],
                                                    "type": "JiraIssue"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "alias": "title",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "defaultNavigationItem",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ],
                                                                    "type": "JiraNavigationItem",
                                                                    "abstractKey": "__isJiraNavigationItem"
                                                                },
                                                                v12 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "large"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                        }
                                                    ],
                                                    "type": "JiraProject"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "planId"
                                                        },
                                                        {
                                                            "concreteType": "JiraScenario",
                                                            "kind": "LinkedField",
                                                            "name": "scenario",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "scenarioId"
                                                                },
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "alias": "planTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        }
                                                    ],
                                                    "type": "JiraPlan"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardId"
                                                        }
                                                    ],
                                                    "type": "JiraBoard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "alias": "dashboardTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardId"
                                                        }
                                                    ],
                                                    "type": "JiraDashboard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v13 /*: any*/ ,
                                                    "type": "JiraSystemFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v13 /*: any*/ ,
                                                    "type": "JiraCustomFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "alias": "queueTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueId"
                                                        }
                                                    ],
                                                    "type": "JiraServiceManagementQueue"
                                                },
                                                v12 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "_recentItems",
                            "args": v8 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "types",
                                "filter"
                            ],
                            "handle": "connection",
                            "key": "RecentMenuContent__recentItems",
                            "kind": "LinkedHandle",
                            "name": "recentItems"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "855172207100d7942753caadb5bb595995ca2328e35845d9cb3c8f297f5e2ce4",
            "metadata": {},
            "name": "recentMenuQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$de7f5d7554961488$var$node.hash = "b81d123360d86456f0af905baa34e827";
(0, $eiowN.PreloadableQueryRegistry).set($de7f5d7554961488$var$node.params.id, $de7f5d7554961488$var$node);
var $de7f5d7554961488$export$2e2bcd8739ae039 = $de7f5d7554961488$var$node;

});

parcelRegister("43AlB", function(module, exports) {

let $2f43a312730d6ad5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2f43a312730d6ad5$var$load("ldNZs").then(()=>parcelRequire('U4Few'));

});




parcelRegister("3J4Wg", function(module, exports) {

$parcel$export(module.exports, "Nav4Roadmaps", () => $3d2666959f2cadcc$export$257bbde911c73386);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $338xa = parcelRequire("338xa");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $3RJbG = parcelRequire("3RJbG");

var $9pfec = parcelRequire("9pfec");

var $lvWgl = parcelRequire("lvWgl");

var $kyQ0U = parcelRequire("kyQ0U");

const $3d2666959f2cadcc$var$LazySidebarContent = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("dHLn1")).then(({ Nav4RoadmapsContainer: Nav4RoadmapsContainer })=>Nav4RoadmapsContainer), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/content/roadmaps/src/ui/roadmaps/index.tsx"
});
const $3d2666959f2cadcc$export$257bbde911c73386 = /*#__PURE__*/ (0, $5uXOq.memo)(({ isExpanded: isExpanded })=>{
    const isCollectionSelected = (0, $kyQ0U.useIsCollectionSelected)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.roadmaps",
        packageName: (0, $3RJbG.PACKAGE_NAME),
        teamName: (0, $3RJbG.TEAM_NAME),
        ufoName: "nav4-sidebar-roadmaps"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4-sidebar-roadmaps",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9pfec.RoadmapsStatic), {
            isExpanded: isExpanded,
            actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lvWgl.ActionButtonsStatic), null)
        }, isCollectionSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), null))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3d2666959f2cadcc$var$LazySidebarContent, {
        isExpanded: isExpanded
    })));
});

});
parcelRegister("3RJbG", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $071bfededeb4df80$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $071bfededeb4df80$export$d57b6b390e78d90f);
$parcel$export(module.exports, "VIEW_ALL_ROADMAPS", () => $071bfededeb4df80$export$3fc15b6d7f7757ac);
$parcel$export(module.exports, "CREATE_ROADMAP", () => $071bfededeb4df80$export$862abc666c31a61a);
$parcel$export(module.exports, "MEATBALL_DROPDOWN", () => $071bfededeb4df80$export$f06dfcec5ff912e);
$parcel$export(module.exports, "PERMISSIONS_CACHE_TTL", () => $071bfededeb4df80$export$5448370085586a5f);
const $071bfededeb4df80$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Roadmaps';
const $071bfededeb4df80$export$d57b6b390e78d90f = 'jpd-horizon';
const $071bfededeb4df80$export$3fc15b6d7f7757ac = 'viewAllRoadmaps';
const $071bfededeb4df80$export$862abc666c31a61a = 'createRoadmaps';
const $071bfededeb4df80$export$f06dfcec5ff912e = 'meatballDropdown';
const $071bfededeb4df80$export$5448370085586a5f = 600000; // 10 minutes

});

parcelRegister("9pfec", function(module, exports) {

$parcel$export(module.exports, "RoadmapsStatic", () => $0df8f3e780fb12fe$export$4c4071eb62c5e1cf);

var $5uXOq = parcelRequire("5uXOq");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $lnznH = parcelRequire("lnznH");
var $cZa9B = parcelRequire("cZa9B");

var $jecJ3 = parcelRequire("jecJ3");

var $jhS4y = parcelRequire("jhS4y");

var $46Cti = parcelRequire("46Cti");

var $c16H2 = parcelRequire("c16H2");

var $dQbFB = parcelRequire("dQbFB");

var $eQV8d = parcelRequire("eQV8d");

var $dUyqZ = parcelRequire("dUyqZ");

var $d9ulS = parcelRequire("d9ulS");

var $fClqt = parcelRequire("fClqt");

var $aOD49 = parcelRequire("aOD49");

var $4R6GH = parcelRequire("4R6GH");

var $kyQ0U = parcelRequire("kyQ0U");

var $3BY0g = parcelRequire("3BY0g");

var $8tJaf = parcelRequire("8tJaf");
const $0df8f3e780fb12fe$export$4c4071eb62c5e1cf = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const { isExpanded: isExpanded, onExpansionToggle: onExpansionToggle, actionsOnHover: actionsOnHover, children: children } = props;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).ROADMAPS);
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    const isJpdProjectView = (0, $kyQ0U.useIsJpdProjectView)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: (0, $d9ulS.ROADMAP_INTRODUCTION_SPOTLIGHT)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: (0, $jhS4y.MENU_ID_ROADMAPS),
        onExpansionToggle: (hasExpanded)=>{
            onExpansionToggle?.(hasExpanded);
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $46Cti.L1_MENU_ID).ROADMAPS,
                sectionItem: (0, $jecJ3.SECTION_ITEM_ROADMAPS)
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZa9B.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-roadmaps-default",
        actionsOnHover: actionsOnHover,
        "aria-label": formattedMessage,
        elemBefore: icon,
        elemAfter: (0, $4R6GH.fg)('jpd_premium_lozenge') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3BY0g.PremiumLozenge), null),
        testId: (0, $dQbFB.getTestId)((0, $jhS4y.MENU_ID_ROADMAPS))
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnznH.ExpandableMenuItemContent), null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8tJaf.Footer), null))), isJpdProjectView && (0, $4R6GH.fg)('polaris_roadmaps_introduction_spotlight') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fClqt.RoadmapIntroductionSpotlight), {
        collectionsUrl: (0, $aOD49.getCollectionsPageUrl)(),
        placement: "right middle"
    }));
});

});
parcelRegister("d9ulS", function(module, exports) {

$parcel$export(module.exports, "GO_TO_PROJECT_SPOTLIGHT_DISMISSED", () => $033135e4463a547c$export$d4b65c1c7753dab5);
$parcel$export(module.exports, "GLOBAL_FIELDS_TOUR_DISMISSED", () => $033135e4463a547c$export$5ca3ca33630ba93c);
$parcel$export(module.exports, "EXPLORE_SECTION_MESSAGE_DISMISSED", () => $033135e4463a547c$export$a81698c00c65eb4a);
$parcel$export(module.exports, "SEEN_PULSATING_FIELDS_BUTTON", () => $033135e4463a547c$export$3085446206860099);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_DISMISSED", () => $033135e4463a547c$export$d32c1bbde6ae670d);
$parcel$export(module.exports, "PROJECT_FIELDS_PAGE_VIEWED", () => $033135e4463a547c$export$ca2e8a74c8b43637);
$parcel$export(module.exports, "TIMELINE_DATES_CONFIG_SECTION_MESSAGE_DISMISSED", () => $033135e4463a547c$export$c6877be73b5f3d5a);
$parcel$export(module.exports, "COLLECTIONS_TOUR_DISMISSED", () => $033135e4463a547c$export$9a1ee3e31621d60);
$parcel$export(module.exports, "PREMIUM_MODAL_DISMISSED", () => $033135e4463a547c$export$522f4dc72dc494f2);
$parcel$export(module.exports, "PREMIUM_LAST_VISIT", () => $033135e4463a547c$export$34f7000ddecc0e7f);
$parcel$export(module.exports, "CROSS_PROJECT_VIEW_TOUR_DISMISSED", () => $033135e4463a547c$export$1be797d9a57b42ac);
$parcel$export(module.exports, "CROSS_PROJECT_LIST_VIEW_FIELDS_DISMISSED_KEY", () => $033135e4463a547c$export$c176277d0ae24685);
$parcel$export(module.exports, "CROSS_PROJECT_TIMELINE_VIEW_FIELDS_DISMISSED_KEY", () => $033135e4463a547c$export$dc14a417cdf40a4e);
$parcel$export(module.exports, "CROSS_PROJECT_BOARD_VIEW_FIELDS_DISMISSED_KEY", () => $033135e4463a547c$export$76d94539e8fefb4a);
$parcel$export(module.exports, "CROSS_PROJECT_MATRIX_VIEW_FIELDS_DISMISSED_KEY", () => $033135e4463a547c$export$c98b8b1065f15440);
$parcel$export(module.exports, "INVITE_FROM_SHARE_DIALOG_SPOTLIGHT_DISMISSED", () => $033135e4463a547c$export$a7071dd1945a163a);
$parcel$export(module.exports, "USER_PROPERTY_BY_STATE_KEY", () => $033135e4463a547c$export$61a0683bfb4060d7);
$parcel$export(module.exports, "GLOBAL_FIELDS_TOUR_SPOTLIGHTS_STEP_1", () => $033135e4463a547c$export$34cb8e95f71c5026);
$parcel$export(module.exports, "GLOBAL_FIELDS_TOUR_SPOTLIGHTS_STEP_2", () => $033135e4463a547c$export$7f842ac8d21dd77c);
$parcel$export(module.exports, "GLOBAL_FIELDS_TOUR_SPOTLIGHTS_STEP_3", () => $033135e4463a547c$export$bd207a2522aeeba4);
$parcel$export(module.exports, "GLOBAL_FIELDS_TOUR_SPOTLIGHTS_STEP_4", () => $033135e4463a547c$export$204b6702ab1fae0e);
$parcel$export(module.exports, "GLOBAL_FIELDS_TOUR_SPOTLIGHTS_STEP_LAST", () => $033135e4463a547c$export$14b1ce7029803351);
$parcel$export(module.exports, "GLOBAL_FIELDS_GO_TO_PROJECT_SPOTLIGHT", () => $033135e4463a547c$export$4aa3d2e1dc759f3c);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_1", () => $033135e4463a547c$export$c1ff7f4df78bdbc4);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_2", () => $033135e4463a547c$export$465e1e9058d0a33e);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_3", () => $033135e4463a547c$export$22cb3b19b9a67a4);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_4", () => $033135e4463a547c$export$639255389f81ee25);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_5", () => $033135e4463a547c$export$5420b6f468b681cb);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_LAST", () => $033135e4463a547c$export$b51c0dd69192efcd);
$parcel$export(module.exports, "COLLECTIONS_CREATE_ROADMAP_SPOTLIGHT", () => $033135e4463a547c$export$1e3c409324b9e1c8);
$parcel$export(module.exports, "COLLECTIONS_CREATE_ROADMAP_SPOTLIGHT_DISMISSED", () => $033135e4463a547c$export$960902aa280e7c02);
$parcel$export(module.exports, "CROSS_PROJECT_VIEW_TOUR_SPOTLIGHTS_STEP_1", () => $033135e4463a547c$export$a2cbd84444b19ad9);
$parcel$export(module.exports, "CROSS_PROJECT_VIEW_TOUR_SPOTLIGHTS_STEP_LAST", () => $033135e4463a547c$export$1ecd157040cc790b);
$parcel$export(module.exports, "NAV_JPD_VIEWS_SPOTLIGHT_DISMISSED", () => $033135e4463a547c$export$6e3db205cdfcc126);
$parcel$export(module.exports, "PRIORITIZATION_VIEW_TOUR_DISMISSED", () => $033135e4463a547c$export$2c379250399a65);
$parcel$export(module.exports, "ROADMAP_VIEW_SPOTLIGHT_DISMISSED", () => $033135e4463a547c$export$6ec637a8d4b52e12);
$parcel$export(module.exports, "ROADMAP_COLUMN_CONFIG_SPOTLIGHT_DISMISSED", () => $033135e4463a547c$export$4c25160b46095f67);
$parcel$export(module.exports, "ROADMAP_INTRODUCTION_SPOTLIGHT", () => $033135e4463a547c$export$ec0f5ceae1abcc93);
$parcel$export(module.exports, "ROADMAP_INTRODUCTION_SPOTLIGHT_DISMISSED", () => $033135e4463a547c$export$4aa206dd068119fd);
$parcel$export(module.exports, "ROADMAP_INTRODUCTION_SPOTLIGHT_PREREQUISITE_DISMISSALS", () => $033135e4463a547c$export$84d5c6b713e2a436);
$parcel$export(module.exports, "PRODUCT_START_TIMESTAMP", () => $033135e4463a547c$export$810ba1749ac4ea65);
$parcel$export(module.exports, "VIEW_CREATOR_TOUR_SPOTLIGHTS", () => $033135e4463a547c$export$bc58a8e989fbe3bc);
$parcel$export(module.exports, "VIEW_CREATOR_TOUR_SPOTLIGHTS_STEP_1", () => $033135e4463a547c$export$414ec9dafc5e9628);
$parcel$export(module.exports, "VIEW_CREATOR_TOUR_SPOTLIGHTS_STEP_2", () => $033135e4463a547c$export$a546fb30dcbeb6b5);
$parcel$export(module.exports, "VIEW_CREATOR_TOUR_SPOTLIGHTS_STEP_3", () => $033135e4463a547c$export$dc3c81a11cac598);
$parcel$export(module.exports, "VIEW_CREATOR_TOUR_SPOTLIGHTS_STEP_4", () => $033135e4463a547c$export$620c0e8c369ed103);
$parcel$export(module.exports, "BLUEPRINTS_TOUR_SPOTLIGHTS", () => $033135e4463a547c$export$979841afe77608d2);
$parcel$export(module.exports, "BLUEPRINTS_TOUR_SPOTLIGHTS_STEP_1", () => $033135e4463a547c$export$54f2fcb05cde1625);
$parcel$export(module.exports, "BLUEPRINTS_TOUR_SPOTLIGHTS_STEP_2", () => $033135e4463a547c$export$61b8070a65644ed3);
// User property names
const $033135e4463a547c$export$d4b65c1c7753dab5 = 'polaris.global-fields.go-to-project-spotlight-dismissed';
const $033135e4463a547c$export$5ca3ca33630ba93c = 'polaris.global-fields.tour-dismissed';
const $033135e4463a547c$export$a81698c00c65eb4a = 'polaris.project-fields.explore-section-message-dismissed';
const $033135e4463a547c$export$3085446206860099 = 'polaris.project-fields.seen-pulsating-fields-button';
const $033135e4463a547c$export$d32c1bbde6ae670d = 'polaris.project-fields.tour-dismissed';
const $033135e4463a547c$export$ca2e8a74c8b43637 = 'polaris.project-fields.page-viewed';
const $033135e4463a547c$export$c6877be73b5f3d5a = 'polaris.timeline.dates-config-section-message-dismissed';
const $033135e4463a547c$export$9a1ee3e31621d60 = 'polaris.collections.tour-dismissed';
const $033135e4463a547c$export$522f4dc72dc494f2 = 'polaris.premium.modal-dismissed';
const $033135e4463a547c$export$34f7000ddecc0e7f = 'polaris.premium.last-visit';
const $033135e4463a547c$export$1be797d9a57b42ac = 'polaris.cross-project-view.tour-dismissed';
const $033135e4463a547c$var$CROSS_PROJECT_VIEW_LIST_FIELDS_DISMISSED = 'polaris.cross-project-view.list-fields-dismissed';
const $033135e4463a547c$var$CROSS_PROJECT_VIEW_TIMELINE_FIELDS_DISMISSED = 'polaris.cross-project-view.timeline-fields-dismissed';
const $033135e4463a547c$var$CROSS_PROJECT_VIEW_BOARD_FIELDS_DISMISSED = 'polaris.cross-project-view.board-fields-dismissed';
const $033135e4463a547c$var$CROSS_PROJECT_VIEW_MATRIX_FIELDS_DISMISSED = 'polaris.cross-project-view.matrix-fields-dismissed';
const $033135e4463a547c$export$c176277d0ae24685 = 'listViewfieldsDismissed';
const $033135e4463a547c$export$dc14a417cdf40a4e = 'timelineViewfieldsDismissed';
const $033135e4463a547c$export$76d94539e8fefb4a = 'boardViewfieldsDismissed';
const $033135e4463a547c$export$c98b8b1065f15440 = 'matrixViewfieldsDismissed';
const $033135e4463a547c$export$a7071dd1945a163a = 'polaris.share-dialog.invite.spotlight-dismissed';
const $033135e4463a547c$export$61a0683bfb4060d7 = {
    [$033135e4463a547c$export$c176277d0ae24685]: $033135e4463a547c$var$CROSS_PROJECT_VIEW_LIST_FIELDS_DISMISSED,
    [$033135e4463a547c$export$dc14a417cdf40a4e]: $033135e4463a547c$var$CROSS_PROJECT_VIEW_TIMELINE_FIELDS_DISMISSED,
    [$033135e4463a547c$export$76d94539e8fefb4a]: $033135e4463a547c$var$CROSS_PROJECT_VIEW_BOARD_FIELDS_DISMISSED,
    [$033135e4463a547c$export$c98b8b1065f15440]: $033135e4463a547c$var$CROSS_PROJECT_VIEW_MATRIX_FIELDS_DISMISSED
};
const $033135e4463a547c$export$34cb8e95f71c5026 = 'global-fields.tour.spotlights.step-1';
const $033135e4463a547c$export$7f842ac8d21dd77c = 'global-fields.tour.spotlights.step-2';
const $033135e4463a547c$export$bd207a2522aeeba4 = 'global-fields.tour.spotlights.step-3';
const $033135e4463a547c$export$204b6702ab1fae0e = 'global-fields.tour.spotlights.step-4';
const $033135e4463a547c$export$14b1ce7029803351 = 'global-fields.tour.spotlights.step-last';
const $033135e4463a547c$export$4aa3d2e1dc759f3c = 'global-fields.go-to-project.spotlight';
const $033135e4463a547c$export$c1ff7f4df78bdbc4 = 'project-fields.tour.spotlights.step-1';
const $033135e4463a547c$export$465e1e9058d0a33e = 'project-fields.tour.spotlights.step-2';
const $033135e4463a547c$export$22cb3b19b9a67a4 = 'project-fields.tour.spotlights.step-3';
const $033135e4463a547c$export$639255389f81ee25 = 'project-fields.tour.spotlights.step-4';
const $033135e4463a547c$export$5420b6f468b681cb = 'project-fields.tour.spotlights.step-5';
const $033135e4463a547c$export$b51c0dd69192efcd = 'project-fields.tour.spotlights.step-last';
const $033135e4463a547c$export$1e3c409324b9e1c8 = 'collections.create-roadmap.spotlight';
const $033135e4463a547c$export$960902aa280e7c02 = 'collections.create-roadmap.spotlight-dismissed';
const $033135e4463a547c$export$a2cbd84444b19ad9 = 'cross-project-view.tour.spotlights.step-1';
const $033135e4463a547c$export$1ecd157040cc790b = 'cross-project-view.tour.spotlights.step-last';
const $033135e4463a547c$export$f0a483c398048551 = 'jpd-nav-views.spotlight';
const $033135e4463a547c$export$6e3db205cdfcc126 = 'polaris.nav-jpd-views.spotlight-dismissed';
const $033135e4463a547c$export$6231ca46e95bc736 = 'prioritization-view.tour.spotlights.step-1';
const $033135e4463a547c$export$cd247efd7ec3525c = 'prioritization-view.tour.spotlights.step-last';
const $033135e4463a547c$export$2c379250399a65 = 'polaris.prioritization-view.tour-dismissed';
const $033135e4463a547c$export$3134ae340fb4ae39 = 'roadmap-view.spotlight';
const $033135e4463a547c$export$6ec637a8d4b52e12 = 'polaris.roadmap-view.spotlight-dismissed';
const $033135e4463a547c$export$10bda8c91e48ff2c = 'roadmap-view.column-config.spotlight';
const $033135e4463a547c$export$4c25160b46095f67 = 'polaris.roadmap-view.column-config-spotlight-dismissed';
const $033135e4463a547c$export$ec0f5ceae1abcc93 = 'roadmap.introduction.spotlight';
const $033135e4463a547c$export$4aa206dd068119fd = 'roadmap.introduction.spotlight.dismissed';
const $033135e4463a547c$export$ef2e4b0f650c3249 = 'roadmap-view.initial-prompt.spotlight';
const $033135e4463a547c$export$84d5c6b713e2a436 = [
    $033135e4463a547c$export$522f4dc72dc494f2,
    $033135e4463a547c$export$6e3db205cdfcc126
];
const $033135e4463a547c$export$810ba1749ac4ea65 = 'polaris.product-start-timestamp';
const $033135e4463a547c$export$bc58a8e989fbe3bc = 'polaris.view-creator.spotlight';
const $033135e4463a547c$export$414ec9dafc5e9628 = 'view-creator.tour.spotlights.step-1';
const $033135e4463a547c$export$a546fb30dcbeb6b5 = 'view-creator.tour.spotlights.step-2';
const $033135e4463a547c$export$dc3c81a11cac598 = 'view-creator.tour.spotlights.step-3';
const $033135e4463a547c$export$620c0e8c369ed103 = 'view-creator.tour.spotlights.step-4';
const $033135e4463a547c$export$979841afe77608d2 = 'polaris.blueprints.tour.spotlights';
const $033135e4463a547c$export$54f2fcb05cde1625 = `${$033135e4463a547c$export$979841afe77608d2}.step-1`;
const $033135e4463a547c$export$61b8070a65644ed3 = `${$033135e4463a547c$export$979841afe77608d2}.step-2`;

});

parcelRegister("fClqt", function(module, exports) {

$parcel$export(module.exports, "RoadmapIntroductionSpotlight", () => $4083f42e34bf2006$export$71e9b7b9d410b300);

var $5uXOq = parcelRequire("5uXOq");

var $1QiBP = parcelRequire("1QiBP");

var $fD6iO = parcelRequire("fD6iO");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ehdJY = parcelRequire("ehdJY");

var $daoB1 = parcelRequire("daoB1");

var $lVJAU = parcelRequire("lVJAU");

var $d9ulS = parcelRequire("d9ulS");

var $cAcWf = parcelRequire("cAcWf");

var $7qsHB = parcelRequire("7qsHB");

var $jhE94 = parcelRequire("jhE94");

var $9V003 = parcelRequire("9V003");

var $3aLoA = parcelRequire("3aLoA");
const $4083f42e34bf2006$export$8130629f6db139c2 = ()=>{
    const { hasProductDiscoveryAccess: hasProductDiscoveryAccess } = (0, $daoB1.useApplicationPermissions)() ?? {};
    return Boolean(hasProductDiscoveryAccess);
};
const $4083f42e34bf2006$export$71e9b7b9d410b300 = ({ collectionsUrl: collectionsUrl, placement: placement })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isLicensedUser = $4083f42e34bf2006$export$8130629f6db139c2();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const expandSideNav = (0, $fD6iO.useExpandSideNav)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const isAlreadyInRoadmaps = window?.location.href.includes('roadmap');
    const { loadRoadmapIntroductionDismissed: loadRoadmapIntroductionDismissed, loadRoadmapIntroductionPrerequisiteDismissalsMet: loadRoadmapIntroductionPrerequisiteDismissalsMet, loadProductUsageStartTimestamp: loadProductUsageStartTimestamp, setRoadmapIntroductionDismissed: setRoadmapIntroductionDismissed } = (0, $cAcWf.useOnboardingFlowsActions)();
    (0, $5uXOq.useEffect)(()=>{
        // we can prevent unnecessary calls in these cases
        if (isAlreadyInRoadmaps || !isLicensedUser) return;
        loadRoadmapIntroductionDismissed();
        loadRoadmapIntroductionPrerequisiteDismissalsMet();
        loadProductUsageStartTimestamp();
    }, [
        isAlreadyInRoadmaps,
        isLicensedUser,
        loadProductUsageStartTimestamp,
        loadRoadmapIntroductionDismissed,
        loadRoadmapIntroductionPrerequisiteDismissalsMet
    ]);
    const isIntroductionDismissed = (0, $7qsHB.useCollectionsIntroductionDismissed)();
    const arePrerequisiteDismissalsMet = (0, $7qsHB.useCollectionsIntroductionPrerequisiteDismissalsMet)();
    const productUsageStartTimestamp = (0, $jhE94.useProductUsageStartTimestamp)();
    if (isAlreadyInRoadmaps || !isLicensedUser || isIntroductionDismissed === undefined || isIntroductionDismissed || !arePrerequisiteDismissalsMet || !(0, $3aLoA.checkIfOlderThanNDays)(productUsageStartTimestamp)) return null;
    const dismiss = (analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'dismiss');
        setRoadmapIntroductionDismissed();
    };
    const openRoadmaps = (analyticsEvent)=>{
        if (analyticsEvent) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'openRoadmaps');
        else (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'openRoadmaps');
        setRoadmapIntroductionDismissed();
        push(collectionsUrl);
    };
    expandSideNav();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        actions: [
            {
                onClick: (_, analyticsEvent)=>dismiss(analyticsEvent),
                text: formatMessage((0, $9V003.messages).dismiss),
                testId: 'roadmap-introduction-spotlight-dismiss-button'
            },
            {
                onClick: (_, analyticsEvent)=>openRoadmaps(analyticsEvent),
                text: formatMessage((0, $9V003.messages).giveItATry)
            }
        ],
        dialogPlacement: placement,
        dialogWidth: 275,
        target: (0, $d9ulS.ROADMAP_INTRODUCTION_SPOTLIGHT),
        key: (0, $d9ulS.ROADMAP_INTRODUCTION_SPOTLIGHT),
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        targetOnClick: (_event)=>openRoadmaps(),
        messageId: "polaris-lib-onboarding-flows.ui.collections.tour.roadmap-introduction-spotlight.jira-spotlight",
        messageType: "engagement"
    }, formatMessage((0, $9V003.messages).message)));
};

});
parcelRegister("ehdJY", function(module, exports) {

$parcel$export(module.exports, "JiraSpotlight", () => $61a8dc1ff1116911$export$e209c6be9ab8c4f4);

var $5uXOq = parcelRequire("5uXOq");

var $7gs1W = parcelRequire("7gs1W");

var $10xFf = parcelRequire("10xFf");

var $5NHqU = parcelRequire("5NHqU");
const $61a8dc1ff1116911$export$e209c6be9ab8c4f4 = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5NHqU.ChoreographerSpotlight), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7gs1W.default), rest);
};

});
parcelRegister("5NHqU", function(module, exports) {

$parcel$export(module.exports, "ChoreographerSpotlight", () => $b7d2a49fe3b12822$export$e01943d134357d00);
// eslint-disable-next-line jira/import/no-restricted-import

var $7gs1W = parcelRequire("7gs1W");

var $cSWNW = parcelRequire("cSWNW");
const $b7d2a49fe3b12822$export$e01943d134357d00 = (0, $cSWNW.withChoreographedRender)((0, $7gs1W.default));

});


parcelRegister("cAcWf", function(module, exports) {

$parcel$export(module.exports, "useOnboardingFlowsActions", () => $7dbb55da8793fd57$export$e3d86ac85365138c);
$parcel$export(module.exports, "createHook", () => $7dbb55da8793fd57$export$e7f733c8fc2b8a24);
$parcel$export(module.exports, "OnboardingFlowsContainer", () => $7dbb55da8793fd57$export$214c4fcbf19b9a1d);

var $5uXOq = parcelRequire("5uXOq");

var $imZsD = parcelRequire("imZsD");

var $6ToME = parcelRequire("6ToME");

var $iXqE5 = parcelRequire("iXqE5");

var $flDq6 = parcelRequire("flDq6");

var $7D44j = parcelRequire("7D44j");
const $7dbb55da8793fd57$export$46c52354b8798e89 = (0, $iXqE5.createStore)({
    name: 'PolarisLibOnboardingFlowsStore',
    initialState: {
        containerProps: {
            accountId: undefined
        },
        productUsageStartTimestamp: undefined,
        globalFields: {
            goToProjectSpotlightDismissed: undefined,
            tourDismissed: undefined,
            tourSpotlightStep: null
        },
        projectFields: {
            exploreSectionMessageDismissed: undefined,
            seenPulsatingFieldsButton: undefined,
            tourDismissed: undefined,
            tourSpotlightStep: null,
            pageViewed: undefined
        },
        collections: {
            tourDismissed: undefined,
            tourSpotlightStep: null,
            introductionDismissed: undefined,
            introductionPrerequisiteDismissalsMet: undefined
        },
        crossProjectView: {
            tourDismissed: undefined,
            tourSpotlightStep: null
        },
        timeline: {
            sectionMessageDismissed: undefined
        },
        shareDialog: {
            inviteSpotlightDismissed: undefined
        },
        allViews: {
            spotlightDismissed: undefined
        },
        prioritizationView: {
            tourDismissed: undefined,
            tourSpotlightStep: null
        },
        roadmapView: {
            spotlightDismissed: undefined,
            columnConfigSpotlightDismissed: undefined
        },
        viewCreator: {
            tourDismissed: undefined,
            tourSpotlightStep: null
        },
        blueprints: {
            tourDismissed: undefined,
            tourSpotlightStep: null
        },
        premium: {
            modalDismissed: undefined,
            lastVisit: {
                isPremium: undefined,
                updated: undefined
            },
            promise: (0, $flDq6.createDeferredPromise)()
        }
    },
    actions: $7D44j.default
});
const { Container: $7dbb55da8793fd57$export$2e28a971a45925e3, useActions: $7dbb55da8793fd57$export$e3d86ac85365138c, createHook: $7dbb55da8793fd57$export$e7f733c8fc2b8a24, createHigherLevelHook: $7dbb55da8793fd57$export$757252247e722815 } = (0, $6ToME.createJpdContainer)($7dbb55da8793fd57$export$46c52354b8798e89);
const $7dbb55da8793fd57$export$214c4fcbf19b9a1d = ({ accountId: accountId, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7dbb55da8793fd57$export$2e28a971a45925e3, {
        isGlobal: true,
        accountId: accountId
    }, children));

});
parcelRegister("6ToME", function(module, exports) {

$parcel$export(module.exports, "createJpdContainer", () => $23346b108d18c150$export$7ed5db99dcc39128);

var $gJBT6 = parcelRequire("gJBT6");

var $jYn8S = parcelRequire("jYn8S");

var $3sQ5x = parcelRequire("3sQ5x");

var $5vOOL = parcelRequire("5vOOL");
const $23346b108d18c150$var$createSelectorHook = (store, selector)=>{
    const innerHook = (0, $3sQ5x.createHook)(store, {
        selector: (state)=>selector(state, state.containerProps)
    });
    return ()=>{
        const [val] = innerHook();
        return val;
    };
};
const $23346b108d18c150$export$757252247e722815 = (store, selectorCreator)=>{
    // TODO POL-2195 memoize one is not suitable for this task, as it will only memoize the last invocation. while this
    //               improves subsequent calls with the same argument set, it does not improve calls with different args
    //               this case should be solved with a generic memoization lib, e.g. reselect (4.1+) or moize
    //               discussion: https://hello.atlassian.net/wiki/spaces/TGR/pages/1416371989/Dependency+review+moize
    const memoizedSelectorCreator = (0, $jYn8S.cacheSelectorCreator)(selectorCreator);
    // TODO POL-2195 in the meantime, we can use lodash/memoize to at least solve the 1-ary case,
    //               which should be 99% of our selector creators anyway
    const monadicSelectorCreatorMemoized = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(selectorCreator);
    const rssHook = (0, $3sQ5x.createHook)(store, {
        selector: (state, args)=>{
            if (args.length <= 1) return monadicSelectorCreatorMemoized(...args)(state, state.containerProps);
            return memoizedSelectorCreator(...args)(state, state.containerProps);
        }
    });
    return (...args)=>{
        // @ts-expect-error - TS2345 - Argument of type 'SelectorCreatorArgs' is not assignable to parameter
        const [val] = rssHook(args);
        return val;
    };
};
const $23346b108d18c150$export$7ed5db99dcc39128 = (store, options)=>{
    const Container = (0, $5vOOL.createContainerWithContext)(store, options);
    const useEmptyState = (0, $3sQ5x.createHook)(store, {
        selector: null
    });
    const useActions = ()=>{
        const [, actions] = useEmptyState();
        return actions;
    };
    return {
        createHook: (selector)=>$23346b108d18c150$var$createSelectorHook(store, selector),
        createHigherLevelHook: (selectorCreator)=>$23346b108d18c150$export$757252247e722815(store, selectorCreator),
        useActions: useActions,
        Container: Container
    };
};

});
parcelRegister("jYn8S", function(module, exports) {

$parcel$export(module.exports, "cacheSelectorCreator", () => $904e561f620684de$export$413433974f0869c3);
$parcel$export(module.exports, "getCacheValue", () => $904e561f620684de$export$e15acfbd8ab989dd);
let $904e561f620684de$var$cache = new WeakMap();
let $904e561f620684de$var$jsonEqualityMap = new WeakMap();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $904e561f620684de$var$getValueFromJsonEqualityCache = (f, value, options)=>{
    if (options?.useJsonEquality !== true) return value;
    if (!$904e561f620684de$var$jsonEqualityMap.has(f)) $904e561f620684de$var$jsonEqualityMap.set(f, new Map());
    const storage = $904e561f620684de$var$jsonEqualityMap.get(f);
    try {
        const key = JSON.stringify(value);
        if (storage.has(key)) return storage.get(key);
        storage.set(key, value);
    } catch  {
    // do nothing
    }
    return value;
};
function $904e561f620684de$export$413433974f0869c3(f, options) {
    if (f.__isCachedSelectorCreator === true) return f;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cacheFunction = (...args)=>{
        if ($904e561f620684de$var$cache.has(f)) {
            let lastNode = $904e561f620684de$var$cache.get(f);
            for(let i = 0; i < args.length; i += 1){
                const value = $904e561f620684de$var$getValueFromJsonEqualityCache(f, args[i], options);
                if (!lastNode.args.has(value)) {
                    lastNode = null;
                    break;
                }
                lastNode = lastNode.args.get(value);
            }
            if (lastNode?.selector) return lastNode.selector;
        }
        const maybeSelector = f(...args);
        if (typeof maybeSelector?.resultFunc === 'function' || typeof maybeSelector === 'function') {
            if (!$904e561f620684de$var$cache.has(f)) $904e561f620684de$var$cache.set(f, {
                args: new Map(),
                selector: null
            });
            let lastNode = $904e561f620684de$var$cache.get(f);
            for(let i = 0; i < args.length; i += 1){
                const value = $904e561f620684de$var$getValueFromJsonEqualityCache(f, args[i], options);
                if (!lastNode.args.has(value)) lastNode.args.set(value, {
                    args: new Map(),
                    selector: null
                });
                lastNode = lastNode.args.get(value);
            }
            lastNode.selector = maybeSelector;
        }
        return maybeSelector;
    };
    cacheFunction.__isCachedSelectorCreator = true;
    cacheFunction.__origin = f;
    cacheFunction.displayName = f.name || f.displayName;
    return cacheFunction;
}
const $904e561f620684de$export$e2575ed62a2f107b = ()=>$904e561f620684de$var$cache;
const $904e561f620684de$export$e15acfbd8ab989dd = (key)=>$904e561f620684de$var$cache.get(key);
const $904e561f620684de$export$6e5dca841bdf93e3 = ()=>{
    $904e561f620684de$var$cache = new WeakMap();
    $904e561f620684de$var$jsonEqualityMap = new WeakMap();
};

});

parcelRegister("5vOOL", function(module, exports) {

$parcel$export(module.exports, "createContainerWithContext", () => $3e805df79a9b7626$export$ce6d80db779db7dc);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");

var $battw = parcelRequire("battw");
const $3e805df79a9b7626$export$ce6d80db779db7dc = (store, options)=>(0, $gg7kZ.createContainer)(store, {
        ...options,
        onInit: ()=>(api, containerProps)=>{
                (0, $battw.batchStateUpdates)(({ dispatch: dispatch, setState: setState }, props)=>{
                    // @ts-expect-error - TS2345 - Argument of type '{ containerProps: TContainerProps; }' is not assignable to parameter of type 'Partial<TState>'.
                    setState({
                        containerProps: props
                    });
                    options?.onInit && dispatch(options.onInit());
                })(api, containerProps);
            },
        onUpdate: ()=>(api, containerProps)=>{
                (0, $battw.batchStateUpdates)(({ dispatch: dispatch, setState: setState, getState: getState }, props)=>{
                    const prevContainerProps = getState().containerProps;
                    // @ts-expect-error - TS2345 - Argument of type '{ containerProps: TContainerProps; }' is not assignable to parameter of type 'Partial<TState>'.
                    setState({
                        containerProps: props,
                        prevContainerProps: prevContainerProps
                    });
                    options?.onUpdate && dispatch(options.onUpdate());
                })(api, containerProps);
            }
    });

});
parcelRegister("battw", function(module, exports) {

$parcel$export(module.exports, "batchStateUpdates", () => $cbff8929059d4af1$export$4f8b20404a906ca3);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $cbff8929059d4af1$export$4f8b20404a906ca3 = (cb)=>(api, containerProps)=>{
        let finalized = false;
        let localState = api.getState();
        const setState = (newState)=>{
            if (finalized) {
                api.setState(newState);
                return;
            }
            localState = {
                ...localState,
                ...newState
            };
        };
        const getState = ()=>finalized ? api.getState() : localState;
        const dispatch = (action)=>finalized ? action(api, containerProps) : action({
                dispatch: dispatch,
                setState: setState,
                getState: getState
            }, containerProps);
        const patchedApi = {
            setState: setState,
            getState: getState,
            dispatch: dispatch
        };
        cb(patchedApi, containerProps);
        finalized = true;
        api.setState({
            ...localState
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        localState = null;
    };

});



parcelRegister("flDq6", function(module, exports) {

$parcel$export(module.exports, "checkIfActivatedMoreThanFourDays", () => $4c6cd1f60d2b26de$export$562701f849a0aba7);
$parcel$export(module.exports, "normalizeError", () => $4c6cd1f60d2b26de$export$e7bd538fb0c5db1a);
$parcel$export(module.exports, "createDeferredPromise", () => $4c6cd1f60d2b26de$export$87a845ded7190bfc);
$parcel$export(module.exports, "checkPrerequisiteDismissals", () => $4c6cd1f60d2b26de$export$b20d00c7cb810f65);

var $5egm2 = parcelRequire("5egm2");

var $89SaW = parcelRequire("89SaW");
const $4c6cd1f60d2b26de$export$562701f849a0aba7 = (productUsageStartTimestamp)=>{
    const diffInDays = (0, $5egm2.default)(new Date(), new Date(productUsageStartTimestamp));
    return diffInDays >= 4;
};
const $4c6cd1f60d2b26de$export$e7bd538fb0c5db1a = (error)=>{
    if (error instanceof Error) return error;
    return new Error('Unknown error');
};
function $4c6cd1f60d2b26de$export$87a845ded7190bfc() {
    // These will be properly initialized in the Promise constructor
    let resolve;
    let reject;
    const promise = new Promise((res, rej)=>{
        resolve = res;
        reject = rej;
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}
const $4c6cd1f60d2b26de$export$b20d00c7cb810f65 = async (prerequisiteDismissals, accountId)=>{
    if (!accountId) return;
    const prerequisiteDismissalsPromises = prerequisiteDismissals.map((prerequisite)=>{
        return (0, $89SaW.getUserProperty)(accountId, prerequisite);
    });
    return Promise.all(prerequisiteDismissalsPromises);
};

});

parcelRegister("7D44j", function(module, exports) {

$parcel$export(module.exports, "default", () => $73ced0fde2678944$export$2e2bcd8739ae039);

var $hTGLO = parcelRequire("hTGLO");

var $3nX69 = parcelRequire("3nX69");

var $j7wFs = parcelRequire("j7wFs");

var $fw4kd = parcelRequire("fw4kd");

var $aLCt5 = parcelRequire("aLCt5");

var $ekdyp = parcelRequire("ekdyp");

var $9SWPx = parcelRequire("9SWPx");

var $7lHeU = parcelRequire("7lHeU");

var $7kErt = parcelRequire("7kErt");

var $8DEAI = parcelRequire("8DEAI");

var $jJ3r3 = parcelRequire("jJ3r3");

var $43cMo = parcelRequire("43cMo");

var $ehOuS = parcelRequire("ehOuS");

var $1bQtC = parcelRequire("1bQtC");

var $5lIPS = parcelRequire("5lIPS");

var $gSOEi = parcelRequire("gSOEi");

var $irhvp = parcelRequire("irhvp");

var $i1anS = parcelRequire("i1anS");

var $cXfUC = parcelRequire("cXfUC");

var $9nrm9 = parcelRequire("9nrm9");

var $fg3Qo = parcelRequire("fg3Qo");

var $a6Bob = parcelRequire("a6Bob");

var $dke7D = parcelRequire("dke7D");
const $73ced0fde2678944$var$actions = {
    loadProductUsageStartTimestamp: $dke7D.loadProductUsageStartTimestamp,
    loadGoToProjectSpotlightDismissed: $9SWPx.loadGoToProjectSpotlightDismissed,
    setGoToProjectSpotlightDismissed: $9SWPx.setGoToProjectSpotlightDismissed,
    setGlobalFieldsTourSpotlightStep: $7lHeU.setGlobalFieldsTourSpotlightStep,
    loadGlobalFieldsTourDismissed: $7kErt.loadGlobalFieldsTourDismissed,
    setGlobalFieldsTourDismissed: $7kErt.setGlobalFieldsTourDismissed,
    loadExploreSectionMessageDismissed: $8DEAI.loadExploreSectionMessageDismissed,
    setExploreSectionMessageDismissed: $8DEAI.setExploreSectionMessageDismissed,
    loadProjectFieldsPageViewed: $jJ3r3.loadProjectFieldsPageViewed,
    setProjectFieldsPageViewed: $jJ3r3.setProjectFieldsPageViewed,
    loadSeenPulsatingFieldsButton: $43cMo.loadSeenPulsatingFieldsButton,
    setSeenPulsatingFieldsButton: $43cMo.setSeenPulsatingFieldsButton,
    loadProjectFieldsTourDismissed: $1bQtC.loadProjectFieldsTourDismissed,
    setProjectFieldsTourDismissed: $1bQtC.setProjectFieldsTourDismissed,
    setProjectFieldsTourSpotlightStep: $ehOuS.setProjectFieldsTourSpotlightStep,
    loadCollectionsTourDismissed: $3nX69.loadCollectionsTourDismissed,
    loadRoadmapIntroductionPrerequisiteDismissalsMet: $ekdyp.loadRoadmapIntroductionPrerequisiteDismissalsMet,
    setCollectionsTourDismissed: $3nX69.setCollectionsTourDismissed,
    setCollectionsTourSpotlightStep: $hTGLO.setCollectionsTourSpotlightStep,
    loadRoadmapIntroductionDismissed: $ekdyp.loadRoadmapIntroductionDismissed,
    setRoadmapIntroductionDismissed: $ekdyp.setRoadmapIntroductionDismissed,
    loadCrossProjectViewTourDismissed: $aLCt5.loadCrossProjectViewTourDismissed,
    setCrossProjectViewTourDismissed: $aLCt5.setCrossProjectViewTourDismissed,
    setCrossProjectViewTourSpotlightStep: $fw4kd.setCrossProjectViewTourSpotlightStep,
    loadTimelineSectionMessageDismissed: $5lIPS.loadTimelineSectionMessageDismissed,
    setTimelineSectionMessageDismissed: $5lIPS.setTimelineSectionMessageDismissed,
    loadCrossProjectViewFieldsDismissed: $j7wFs.loadCrossProjectViewFieldsDismissed,
    setCrossProjectViewFieldsDismissed: $j7wFs.setCrossProjectViewFieldsDismissed,
    loadInviteFromShareDialogSpotlightDismissed: $gSOEi.loadInviteFromShareDialogSpotlightDismissed,
    setInviteFromShareDialogSpotlightDismissed: $gSOEi.setInviteFromShareDialogSpotlightDismissed,
    loadAllViewsSpotlightDismissed: $irhvp.loadAllViewsSpotlightDismissed,
    setAllViewsSpotlightDismissed: $irhvp.setAllViewsSpotlightDismissed,
    loadRoadmapViewSpotlightDismissed: $cXfUC.loadRoadmapViewSpotlightDismissed,
    setRoadmapViewSpotlightDismissed: $cXfUC.setRoadmapViewSpotlightDismissed,
    loadRoadmapColumnConfigSpotlightDismissed: $cXfUC.loadRoadmapColumnConfigSpotlightDismissed,
    setRoadmapColumnConfigSpotlightDismissed: $cXfUC.setRoadmapColumnConfigSpotlightDismissed,
    loadPrioritizationViewTourDismissed: $i1anS.loadPrioritizationViewTourDismissed,
    setPrioritizationViewTourDismissed: $i1anS.setPrioritizationViewTourDismissed,
    setPrioritizationViewTourSpotlightStep: $i1anS.setPrioritizationViewTourSpotlightStep,
    setViewCreatorSpotlightDismissed: $9nrm9.setViewCreatorSpotlightDismissed,
    setViewCreatorSpotlightTourStep: $9nrm9.setViewCreatorSpotlightTourStep,
    loadViewCreatorSpotlightState: $9nrm9.loadViewCreatorSpotlightState,
    setBlueprintsTourDismissed: $fg3Qo.setBlueprintsTourDismissed,
    setBlueprintsTourStep: $fg3Qo.setBlueprintsTourStep,
    loadBlueprintsState: $fg3Qo.loadBlueprintsState,
    loadPremiumLastVisit: $a6Bob.loadPremiumLastVisit,
    loadPremiumModalDismissed: $a6Bob.loadPremiumModalDismissed,
    setPremiumLastVisit: $a6Bob.setPremiumLastVisit,
    setPremiumModalDismissed: $a6Bob.setPremiumModalDismissed,
    unlockOnboardingFlow: $a6Bob.unlockOnboardingFlow
};
var $73ced0fde2678944$export$2e2bcd8739ae039 = $73ced0fde2678944$var$actions;

});
parcelRegister("hTGLO", function(module, exports) {

$parcel$export(module.exports, "setCollectionsTourSpotlightStep", () => $6d68522005faa178$export$501a98d23141dc4d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $6d68522005faa178$export$501a98d23141dc4d = (step)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            collections: {
                ...state.collections,
                tourSpotlightStep: step
            }
        });
    };

});

parcelRegister("3nX69", function(module, exports) {

$parcel$export(module.exports, "loadCollectionsTourDismissed", () => $f4b58b9aa01e4518$export$c7e2395278267e1d);
$parcel$export(module.exports, "setCollectionsTourDismissed", () => $f4b58b9aa01e4518$export$2a7240b702e8d617);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $f4b58b9aa01e4518$export$c7e2395278267e1d = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().collections.tourDismissed === 'boolean') return;
        try {
            const tourDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.COLLECTIONS_TOUR_DISMISSED));
            const state = getState();
            setState({
                ...state,
                collections: {
                    ...state.collections,
                    tourDismissed: tourDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    collections: {
                        ...state.collections,
                        tourDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.tour', `Failed to get user property with key: ${(0, $d9ulS.COLLECTIONS_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
        return getState().collections.tourDismissed;
    };
const $f4b58b9aa01e4518$export$2a7240b702e8d617 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            collections: {
                ...state.collections,
                tourDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.COLLECTIONS_TOUR_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.tour', `Failed to set user property with key: ${(0, $d9ulS.COLLECTIONS_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});
parcelRegister("8U9Op", function(module, exports) {

$parcel$export(module.exports, "logSafeErrorWithoutCustomerDataWrapper", () => $5cb445ae48fef3c4$export$ebd6466ba18b2f3a);

var $2YZCu = parcelRequire("2YZCu");

var $jJZqs = parcelRequire("jJZqs");




const $5cb445ae48fef3c4$export$ebd6466ba18b2f3a = async (location, message, event)=>{
    const modifiedEvent = event;
    if (modifiedEvent instanceof (0, $jJZqs.default) && modifiedEvent.originalResponse) {
        const originalResponseText = await modifiedEvent.originalResponse.text();
        modifiedEvent.message = `${modifiedEvent.message} - ${originalResponseText}`;
        delete modifiedEvent.originalResponse;
    }
    (0, $2YZCu.default).safeErrorWithoutCustomerData(location, message, modifiedEvent);
    // Returning the modified error so the original response text can be used in the error handler
    return modifiedEvent;
};

});

parcelRegister("6FNg9", function(module, exports) {

$parcel$export(module.exports, "maybeWaitForPremiumModal", () => $a42f0641756b90a5$export$b797d1ff3b371e8a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $a42f0641756b90a5$export$b797d1ff3b371e8a = async (getState)=>{
    // Await the resolution of the deferred promise associated with the premium modal.
    // This ensures that the premium modal has either never been displayed or has already been closed.
    // This mechanism allows for seamless orchestration of all spotlights within a single package,
    // ensuring they are postponed until the premium modal can be displayed and is dismissed.
    // Treat this similar to the `!accountId`, as every loading action
    // in the `onboarding-flow` package should incorporate this check.
    await getState().premium.promise.promise;
};

});


parcelRegister("j7wFs", function(module, exports) {

$parcel$export(module.exports, "loadCrossProjectViewFieldsDismissed", () => $bf11a724423fc392$export$e6e8b16aaeac983b);
$parcel$export(module.exports, "setCrossProjectViewFieldsDismissed", () => $bf11a724423fc392$export$2468c71857d0e133);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $bf11a724423fc392$export$e6e8b16aaeac983b = (viewKindStateKey)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().crossProjectView[viewKindStateKey] === 'boolean') return;
        const userProperty = (0, $d9ulS.USER_PROPERTY_BY_STATE_KEY)[viewKindStateKey];
        try {
            const viewfieldsDismissed = await (0, $89SaW.getUserProperty)(accountId, userProperty);
            const state = getState();
            setState({
                ...state,
                crossProjectView: {
                    ...state.crossProjectView,
                    [viewKindStateKey]: viewfieldsDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    crossProjectView: {
                        ...state.crossProjectView,
                        [viewKindStateKey]: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)(userProperty, `Failed to get user property with key: ${userProperty}`, error instanceof Error ? error : undefined);
        }
        return getState().crossProjectView[viewKindStateKey];
    };
const $bf11a724423fc392$export$2468c71857d0e133 = (viewKindStateKey)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            crossProjectView: {
                ...state.crossProjectView,
                [viewKindStateKey]: true
            }
        });
        const userProperty = (0, $d9ulS.USER_PROPERTY_BY_STATE_KEY)[viewKindStateKey];
        try {
            await (0, $89SaW.setUserProperties)(accountId, userProperty, 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)(userProperty, `Failed to set user property with key: ${userProperty}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("fw4kd", function(module, exports) {

$parcel$export(module.exports, "setCrossProjectViewTourSpotlightStep", () => $85bd86cefde8c272$export$7e29b1ed314f9b12);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $85bd86cefde8c272$export$7e29b1ed314f9b12 = (step)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            crossProjectView: {
                ...state.crossProjectView,
                tourSpotlightStep: step
            }
        });
    };

});

parcelRegister("aLCt5", function(module, exports) {

$parcel$export(module.exports, "loadCrossProjectViewTourDismissed", () => $27e7ac097dc825d8$export$24c1a2fce44090f2);
$parcel$export(module.exports, "setCrossProjectViewTourDismissed", () => $27e7ac097dc825d8$export$d25b2932701a97e6);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $27e7ac097dc825d8$export$24c1a2fce44090f2 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().crossProjectView.tourDismissed === 'boolean') return;
        try {
            const tourDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.CROSS_PROJECT_VIEW_TOUR_DISMISSED));
            const state = getState();
            setState({
                ...state,
                crossProjectView: {
                    ...state.crossProjectView,
                    tourDismissed: tourDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    crossProjectView: {
                        ...state.crossProjectView,
                        tourDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.tour', `Failed to get user property with key: ${(0, $d9ulS.CROSS_PROJECT_VIEW_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
        return getState().crossProjectView.tourDismissed;
    };
const $27e7ac097dc825d8$export$d25b2932701a97e6 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            crossProjectView: {
                ...state.crossProjectView,
                tourDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.CROSS_PROJECT_VIEW_TOUR_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.tour', `Failed to set user property with key: ${(0, $d9ulS.CROSS_PROJECT_VIEW_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("ekdyp", function(module, exports) {

$parcel$export(module.exports, "loadRoadmapIntroductionDismissed", () => $bb8292cba90e90b4$export$1a7b263d41622a5b);
$parcel$export(module.exports, "loadRoadmapIntroductionPrerequisiteDismissalsMet", () => $bb8292cba90e90b4$export$de983a99630cdc7d);
$parcel$export(module.exports, "setRoadmapIntroductionDismissed", () => $bb8292cba90e90b4$export$19c464c17f9739ab);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");

var $flDq6 = parcelRequire("flDq6");
const $bb8292cba90e90b4$export$1a7b263d41622a5b = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().collections.introductionDismissed === 'boolean') return;
        try {
            const introductionDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.ROADMAP_INTRODUCTION_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                collections: {
                    ...state.collections,
                    introductionDismissed: introductionDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    collections: {
                        ...state.collections,
                        introductionDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmaps.introduction.spotlight.dismissed', `Failed to get user property with key: ${(0, $d9ulS.ROADMAP_INTRODUCTION_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
        return getState().collections.introductionDismissed;
    };
const $bb8292cba90e90b4$export$de983a99630cdc7d = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        let dismissals = [];
        try {
            dismissals = await (0, $flDq6.checkPrerequisiteDismissals)((0, $d9ulS.ROADMAP_INTRODUCTION_SPOTLIGHT_PREREQUISITE_DISMISSALS), accountId);
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmaps.introduction.spotlight.prerequisites', 'Failed to get user properties for roadmap introduction spotlight prerequisites', error instanceof Error ? error : undefined);
        }
        const state = getState();
        setState({
            ...state,
            collections: {
                ...state.collections,
                introductionPrerequisiteDismissalsMet: dismissals?.every((dismissal)=>dismissal) ?? false
            }
        });
        return getState().collections.introductionPrerequisiteDismissalsMet;
    };
const $bb8292cba90e90b4$export$19c464c17f9739ab = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            collections: {
                ...state.collections,
                introductionDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.ROADMAP_INTRODUCTION_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmaps.introduction.spotlight.dismissed', `Failed to set user property with key: ${(0, $d9ulS.ROADMAP_INTRODUCTION_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("9SWPx", function(module, exports) {

$parcel$export(module.exports, "loadGoToProjectSpotlightDismissed", () => $068bea930b483a71$export$4c8d16771ecf8930);
$parcel$export(module.exports, "setGoToProjectSpotlightDismissed", () => $068bea930b483a71$export$3ea7a545c4faccd4);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $068bea930b483a71$export$4c8d16771ecf8930 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().globalFields.goToProjectSpotlightDismissed === 'boolean') return;
        try {
            const goToProjectSpotlightDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.GO_TO_PROJECT_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                globalFields: {
                    ...state.globalFields,
                    goToProjectSpotlightDismissed: goToProjectSpotlightDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    globalFields: {
                        ...state.globalFields,
                        goToProjectSpotlightDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.global-fields.go-to-project-spotlight', `Failed to get user property with key: ${(0, $d9ulS.GO_TO_PROJECT_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $068bea930b483a71$export$3ea7a545c4faccd4 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            globalFields: {
                ...state.globalFields,
                goToProjectSpotlightDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.GO_TO_PROJECT_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.global-fields.go-to-project-spotlight', `Failed to set user property with key: ${(0, $d9ulS.GO_TO_PROJECT_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("7lHeU", function(module, exports) {

$parcel$export(module.exports, "setGlobalFieldsTourSpotlightStep", () => $1b436c0378152500$export$71a13f0fff467880);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $1b436c0378152500$export$71a13f0fff467880 = (step)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            globalFields: {
                ...state.globalFields,
                tourSpotlightStep: step
            }
        });
    };

});

parcelRegister("7kErt", function(module, exports) {

$parcel$export(module.exports, "loadGlobalFieldsTourDismissed", () => $1bb555275befe735$export$6dbef36cf5394497);
$parcel$export(module.exports, "setGlobalFieldsTourDismissed", () => $1bb555275befe735$export$7ddbf8611b7a51e2);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $1bb555275befe735$export$6dbef36cf5394497 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().globalFields.tourDismissed === 'boolean') return;
        try {
            const tourDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.GLOBAL_FIELDS_TOUR_DISMISSED));
            const state = getState();
            setState({
                ...state,
                globalFields: {
                    ...state.globalFields,
                    tourDismissed: tourDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    globalFields: {
                        ...state.globalFields,
                        tourDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.global-fields.tour', `Failed to get user property with key: ${(0, $d9ulS.GLOBAL_FIELDS_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $1bb555275befe735$export$7ddbf8611b7a51e2 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            globalFields: {
                ...state.globalFields,
                tourDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.GLOBAL_FIELDS_TOUR_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.global-fields.tour', `Failed to set user property with key: ${(0, $d9ulS.GLOBAL_FIELDS_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("8DEAI", function(module, exports) {

$parcel$export(module.exports, "loadExploreSectionMessageDismissed", () => $c1db7be05492658f$export$178c75cc028231a2);
$parcel$export(module.exports, "setExploreSectionMessageDismissed", () => $c1db7be05492658f$export$994e754bbe4537c1);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $c1db7be05492658f$export$178c75cc028231a2 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().projectFields.exploreSectionMessageDismissed === 'boolean') return;
        try {
            const exploreSectionMessageDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.EXPLORE_SECTION_MESSAGE_DISMISSED));
            const state = getState();
            setState({
                ...state,
                projectFields: {
                    ...state.projectFields,
                    exploreSectionMessageDismissed: exploreSectionMessageDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    projectFields: {
                        ...state.projectFields,
                        exploreSectionMessageDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.explore-section-message', `Failed to get user property with key: ${(0, $d9ulS.EXPLORE_SECTION_MESSAGE_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $c1db7be05492658f$export$994e754bbe4537c1 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            projectFields: {
                ...state.projectFields,
                exploreSectionMessageDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.EXPLORE_SECTION_MESSAGE_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.explore-section-message', `Failed to set user property with key: ${(0, $d9ulS.EXPLORE_SECTION_MESSAGE_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("jJ3r3", function(module, exports) {

$parcel$export(module.exports, "loadProjectFieldsPageViewed", () => $15b014e1ee504e23$export$2932bbb803f6ab52);
$parcel$export(module.exports, "setProjectFieldsPageViewed", () => $15b014e1ee504e23$export$5425efd17972eca4);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $15b014e1ee504e23$export$2932bbb803f6ab52 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().projectFields.pageViewed === 'boolean') return;
        try {
            const pageViewed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.PROJECT_FIELDS_PAGE_VIEWED));
            const state = getState();
            setState({
                ...state,
                projectFields: {
                    ...state.projectFields,
                    pageViewed: pageViewed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    projectFields: {
                        ...state.projectFields,
                        pageViewed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.page-viewed', `Failed to get user property with key: ${(0, $d9ulS.PROJECT_FIELDS_PAGE_VIEWED)}`, error instanceof Error ? error : undefined);
        }
    };
const $15b014e1ee504e23$export$5425efd17972eca4 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            projectFields: {
                ...state.projectFields,
                pageViewed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.PROJECT_FIELDS_PAGE_VIEWED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.page-viewed', `Failed to set user property with key: ${(0, $d9ulS.PROJECT_FIELDS_PAGE_VIEWED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("43cMo", function(module, exports) {

$parcel$export(module.exports, "loadSeenPulsatingFieldsButton", () => $be3d4f9e88ab6d4d$export$4248149cb54f9a58);
$parcel$export(module.exports, "setSeenPulsatingFieldsButton", () => $be3d4f9e88ab6d4d$export$ef1450ffea0c5a63);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $be3d4f9e88ab6d4d$export$4248149cb54f9a58 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().projectFields.seenPulsatingFieldsButton === 'boolean') return;
        try {
            const seenPulsatingFieldsButton = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.SEEN_PULSATING_FIELDS_BUTTON));
            const state = getState();
            setState({
                ...state,
                projectFields: {
                    ...state.projectFields,
                    seenPulsatingFieldsButton: seenPulsatingFieldsButton
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    projectFields: {
                        ...state.projectFields,
                        seenPulsatingFieldsButton: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.pulsating-fields-button', `Failed to get user property with key: ${(0, $d9ulS.SEEN_PULSATING_FIELDS_BUTTON)}`, error instanceof Error ? error : undefined);
        }
    };
const $be3d4f9e88ab6d4d$export$ef1450ffea0c5a63 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            projectFields: {
                ...state.projectFields,
                seenPulsatingFieldsButton: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.SEEN_PULSATING_FIELDS_BUTTON), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.pulsating-fields-button', `Failed to set user property with key: ${(0, $d9ulS.SEEN_PULSATING_FIELDS_BUTTON)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("ehOuS", function(module, exports) {

$parcel$export(module.exports, "setProjectFieldsTourSpotlightStep", () => $69d9a94b5f8df0a0$export$a6b8eee670a4eb2f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $69d9a94b5f8df0a0$export$a6b8eee670a4eb2f = (step)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            projectFields: {
                ...state.projectFields,
                tourSpotlightStep: step
            }
        });
    };

});

parcelRegister("1bQtC", function(module, exports) {

$parcel$export(module.exports, "loadProjectFieldsTourDismissed", () => $5e852a2e701cb81c$export$9be5e6fba10e92ef);
$parcel$export(module.exports, "setProjectFieldsTourDismissed", () => $5e852a2e701cb81c$export$2ad2aec3cf81b681);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $5e852a2e701cb81c$export$9be5e6fba10e92ef = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().projectFields.tourDismissed === 'boolean') return;
        try {
            const tourDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.PROJECT_FIELDS_TOUR_DISMISSED));
            const state = getState();
            setState({
                ...state,
                projectFields: {
                    ...state.projectFields,
                    tourDismissed: tourDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    projectFields: {
                        ...state.projectFields,
                        tourDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.tour', `Failed to get user property with key: ${(0, $d9ulS.PROJECT_FIELDS_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $5e852a2e701cb81c$export$2ad2aec3cf81b681 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            projectFields: {
                ...state.projectFields,
                tourDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.PROJECT_FIELDS_TOUR_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.tour', `Failed to set user property with key: ${(0, $d9ulS.PROJECT_FIELDS_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("5lIPS", function(module, exports) {

$parcel$export(module.exports, "loadTimelineSectionMessageDismissed", () => $4c4013cb55e34c16$export$85213c72021b1243);
$parcel$export(module.exports, "setTimelineSectionMessageDismissed", () => $4c4013cb55e34c16$export$f5452ae8fa9e3836);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $4c4013cb55e34c16$export$85213c72021b1243 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().timeline.sectionMessageDismissed === 'boolean') return;
        try {
            const timelineSectionMessageDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.TIMELINE_DATES_CONFIG_SECTION_MESSAGE_DISMISSED));
            const state = getState();
            setState({
                ...state,
                timeline: {
                    sectionMessageDismissed: timelineSectionMessageDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    timeline: {
                        sectionMessageDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.timeline.spotlight', `Failed to get user property with key: ${(0, $d9ulS.TIMELINE_DATES_CONFIG_SECTION_MESSAGE_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $4c4013cb55e34c16$export$f5452ae8fa9e3836 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            timeline: {
                sectionMessageDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.TIMELINE_DATES_CONFIG_SECTION_MESSAGE_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.timeline.spotlight', `Failed to set user property with key: ${(0, $d9ulS.TIMELINE_DATES_CONFIG_SECTION_MESSAGE_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("gSOEi", function(module, exports) {

$parcel$export(module.exports, "loadInviteFromShareDialogSpotlightDismissed", () => $13bae66d7887fecd$export$8303e588f14a5f5);
$parcel$export(module.exports, "setInviteFromShareDialogSpotlightDismissed", () => $13bae66d7887fecd$export$57382f7f22e8cda0);

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $1As78 = parcelRequire("1As78");

var $aiePb = parcelRequire("aiePb");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $flDq6 = parcelRequire("flDq6");

var $6FNg9 = parcelRequire("6FNg9");
const $13bae66d7887fecd$export$8303e588f14a5f5 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().shareDialog.inviteSpotlightDismissed === 'boolean') return;
        try {
            const inviteFromShareDialogSpotlightDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.INVITE_FROM_SHARE_DIALOG_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                shareDialog: {
                    ...state.shareDialog,
                    inviteSpotlightDismissed: inviteFromShareDialogSpotlightDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && (0, $aiePb.isNotFoundError)(error)) {
                const state = getState();
                setState({
                    ...state,
                    shareDialog: {
                        ...state.shareDialog,
                        inviteSpotlightDismissed: false
                    }
                });
                return;
            }
            (0, $jcw0u.default)((0, $1As78.createErrorAnalytics)((0, $d9ulS.INVITE_FROM_SHARE_DIALOG_SPOTLIGHT_DISMISSED), (0, $flDq6.normalizeError)(error)));
        }
    };
const $13bae66d7887fecd$export$57382f7f22e8cda0 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            shareDialog: {
                ...state.shareDialog,
                inviteSpotlightDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.INVITE_FROM_SHARE_DIALOG_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            (0, $jcw0u.default)((0, $1As78.createErrorAnalytics)((0, $d9ulS.INVITE_FROM_SHARE_DIALOG_SPOTLIGHT_DISMISSED), (0, $flDq6.normalizeError)(error)));
        }
    };

});
parcelRegister("1As78", function(module, exports) {

$parcel$export(module.exports, "createErrorAnalytics", () => $7cf658edd2cdbf14$export$9841879b4fea885b);
$parcel$export(module.exports, "useErrorHandlers", () => $7cf658edd2cdbf14$export$e0b4869c7401cacb);
$parcel$export(module.exports, "useOnCyclicFormulaFieldError", () => $7cf658edd2cdbf14$export$4e01d30cacaf82b8);

var $5uXOq = parcelRequire("5uXOq");

var $dD7Zc = parcelRequire("dD7Zc");

var $aYAc3 = parcelRequire("aYAc3");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $eW55R = parcelRequire("eW55R");

var $lH8Ty = parcelRequire("lH8Ty");

var $l6caf = parcelRequire("l6caf");

var $aiePb = parcelRequire("aiePb");
const $7cf658edd2cdbf14$export$9841879b4fea885b = (id, error, options)=>({
        meta: {
            id: id
        },
        error: error,
        sendToPrivacyUnsafeSplunk: options?.sendToPrivacyUnsafeSplunk ?? true,
        skipSentry: options?.skipSentry ?? false
    });
const $7cf658edd2cdbf14$var$handleCallback = (errorObject, callback)=>{
    callback && callback((0, $aiePb.getMetadata)(errorObject));
};
const $7cf658edd2cdbf14$var$useGeneralDataLoadingFailedHandling = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { errorWithRefresh: errorWithRefresh } = (0, $eW55R.useNotifications)();
    return (0, $5uXOq.useCallback)((errorObject, callback)=>{
        $7cf658edd2cdbf14$var$handleCallback(errorObject, callback);
        errorWithRefresh({
            title: formatMessage((0, $l6caf.default).errorTitle),
            description: formatMessage((0, $l6caf.default).serverLoadFailedDescription)
        });
        (0, $jcw0u.default)($7cf658edd2cdbf14$export$9841879b4fea885b('polaris.error.generalDataLoadingFailed', errorObject));
    }, [
        errorWithRefresh,
        formatMessage
    ]);
};
const $7cf658edd2cdbf14$var$useGeneralDataUpdateFailedHandling = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { error: error, errorWithRefresh: errorWithRefresh, customFlag: customFlag } = (0, $eW55R.useNotifications)();
    return (0, $5uXOq.useCallback)((errorObject, callback)=>{
        $7cf658edd2cdbf14$var$handleCallback(errorObject, callback);
        (0, $jcw0u.default)($7cf658edd2cdbf14$export$9841879b4fea885b('polaris.error.generalDataUpdateFailed', errorObject));
        const entityLimitError = (0, $lH8Ty.getEntityLimitError)(errorObject);
        if (entityLimitError) {
            const errorMessage = (0, $lH8Ty.getErrorMessageDescriptor)(entityLimitError);
            return errorMessage ? customFlag({
                title: formatMessage((0, $l6caf.default).entityLimitErrorTitle),
                description: formatMessage(errorMessage, {
                    item: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), null, chunks)
                }),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
                    spacing: "spacious",
                    label: "Error",
                    color: "var(--ds-icon-danger, #C9372C)"
                })
            }) : null;
        }
        if ((0, $aiePb.isPermissionError)(errorObject)) return error({
            title: formatMessage((0, $l6caf.default).errorTitle),
            description: formatMessage((0, $l6caf.default).permissionErrorDescription)
        });
        if ((0, $aiePb.isConfigError)(errorObject)) return error({
            title: formatMessage((0, $l6caf.default).configErrorTitle),
            description: formatMessage((0, $l6caf.default).configErrorDescription)
        });
        errorWithRefresh({
            title: formatMessage((0, $l6caf.default).errorTitle),
            description: formatMessage((0, $l6caf.default).serverUpdateFailedDescription)
        });
    }, [
        customFlag,
        error,
        errorWithRefresh,
        formatMessage
    ]);
};
const $7cf658edd2cdbf14$var$useGeneralActionFailedHandling = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { errorWithRefresh: errorWithRefresh } = (0, $eW55R.useNotifications)();
    return (0, $5uXOq.useCallback)((errorObject, callback)=>{
        $7cf658edd2cdbf14$var$handleCallback(errorObject, callback);
        errorWithRefresh({
            title: formatMessage((0, $l6caf.default).errorTitle),
            description: formatMessage((0, $l6caf.default).errorDescription)
        });
        (0, $jcw0u.default)($7cf658edd2cdbf14$export$9841879b4fea885b('polaris.error.generalActionFailed', errorObject));
    }, [
        errorWithRefresh,
        formatMessage
    ]);
};
const $7cf658edd2cdbf14$var$usePossibleAccessLossError = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { errorWithRefresh: errorWithRefresh } = (0, $eW55R.useNotifications)();
    return (0, $5uXOq.useCallback)((errorObject, callback)=>{
        $7cf658edd2cdbf14$var$handleCallback(errorObject, callback);
        errorWithRefresh({
            title: formatMessage((0, $l6caf.default).errorTitle),
            description: formatMessage((0, $l6caf.default).errorPossibleAccessLoss)
        });
        (0, $jcw0u.default)($7cf658edd2cdbf14$export$9841879b4fea885b('polaris.error.generalActionFailed', errorObject));
    }, [
        errorWithRefresh,
        formatMessage
    ]);
};
const $7cf658edd2cdbf14$export$e0b4869c7401cacb = ()=>{
    const possibleAccessLossError = $7cf658edd2cdbf14$var$usePossibleAccessLossError();
    const generalActionFailedError = $7cf658edd2cdbf14$var$useGeneralActionFailedHandling();
    const generalDataUpdateFailedError = $7cf658edd2cdbf14$var$useGeneralDataUpdateFailedHandling();
    const generalDataLoadingFailedError = $7cf658edd2cdbf14$var$useGeneralDataLoadingFailedHandling();
    return (0, $5uXOq.useMemo)(()=>({
            possibleAccessLossError: possibleAccessLossError,
            generalActionFailedError: generalActionFailedError,
            generalDataUpdateFailedError: generalDataUpdateFailedError,
            generalDataLoadingFailedError: generalDataLoadingFailedError
        }), [
        possibleAccessLossError,
        generalActionFailedError,
        generalDataUpdateFailedError,
        generalDataLoadingFailedError
    ]);
};
const $7cf658edd2cdbf14$export$4e01d30cacaf82b8 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { error: error } = (0, $eW55R.useNotifications)();
    return (0, $5uXOq.useCallback)((fieldLabels)=>{
        error({
            title: formatMessage((0, $l6caf.default).errorTitle),
            description: formatMessage((0, $l6caf.default).cyclicFormulaFieldDescription, {
                fieldLabels: fieldLabels.join(', ')
            })
        });
        (0, $jcw0u.default)($7cf658edd2cdbf14$export$9841879b4fea885b('polaris.error.cyclicFormula', new Error('Cyclic formula field')));
    }, [
        error,
        formatMessage
    ]);
};

});
parcelRegister("eW55R", function(module, exports) {

$parcel$export(module.exports, "useNotifications", () => $3e7591c0992d0e62$export$53d5ca6c3f53e109);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $c2i4s = parcelRequire("c2i4s");

var $dD7Zc = parcelRequire("dD7Zc");

var $7R4eB = parcelRequire("7R4eB");
var $d4xRU = parcelRequire("d4xRU");
var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");
const $3e7591c0992d0e62$var$customFlagCommon = (notification, onDismiss, AkFlagComponent)=>{
    const id = (0, $7Jxgt.v4)();
    return {
        id: id,
        render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AkFlagComponent, {
                id: id,
                ...notification,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                onDismissed: (flagId)=>onDismiss(flagId),
                ...props,
                messageId: notification.messageId ?? `polaris-lib-notifications.controllers.ak-flag-component.${id}`,
                messageType: notification.messageType ?? 'transactional'
            })
    };
};
const $3e7591c0992d0e62$var$customFlag = (notification, onDismiss)=>$3e7591c0992d0e62$var$customFlagCommon(notification, onDismiss, (0, $d4xRU.default));
const $3e7591c0992d0e62$var$customAutoDismissFlag = (notification, onDismiss)=>$3e7591c0992d0e62$var$customFlagCommon(notification, onDismiss, (0, $7R4eB.default));
const $3e7591c0992d0e62$var$success = (notification, onDismiss)=>$3e7591c0992d0e62$var$customAutoDismissFlag({
        title: notification.title,
        description: notification.description,
        actions: notification.actions?.map((action, index)=>({
                ...action,
                testId: `polaris.nofitication.success.action.${action.testId !== undefined ? action.testId : `action-${index + 1}`}`
            })),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))), {
            spacing: "spacious",
            label: "Success icon",
            color: "var(--ds-icon-success, #22A06B)"
        }),
        appearance: 'normal',
        testId: 'polaris-lib-notifications.controllers.notification.success',
        messageId: notification.messageId ?? 'polaris-lib-notifications.controllers.customAutoDismissFlag.success',
        messageType: notification.messageType ?? 'transactional'
    }, onDismiss);
const $3e7591c0992d0e62$var$errorWithRefresh = (notification, onDismiss)=>$3e7591c0992d0e62$var$customAutoDismissFlag({
        title: notification.title,
        description: notification.description,
        actions: [
            ...notification.actions || [],
            {
                content: 'Refresh',
                testId: 'refresh',
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                onClick: ()=>window.location.reload()
            }
        ].map((action, index)=>({
                ...action,
                testId: `polaris.nofitication.error-refresh.action.${action.testId !== undefined ? action.testId : `action-${index + 1}`}`
            })),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
            spacing: "spacious",
            label: "Error",
            color: "var(--ds-icon-danger, #C9372C)"
        }),
        appearance: 'normal',
        testId: 'polaris-lib-notifications.controllers.notification.error-refresh',
        messageId: notification.messageId ?? 'polaris-lib-notifications.controllers.customAutoDismissFlag.errorWithRefresh',
        messageType: notification.messageType ?? 'transactional'
    }, onDismiss);
const $3e7591c0992d0e62$var$error = (notification, onDismiss)=>$3e7591c0992d0e62$var$customAutoDismissFlag({
        title: notification.title,
        description: notification.description,
        actions: notification.actions?.map((action, index)=>({
                ...action,
                testId: `polaris.nofitication.error.action.${action.testId !== undefined ? action.testId : `action-${index + 1}`}`
            })),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
            spacing: "spacious",
            label: "Error",
            color: "var(--ds-icon-danger, #C9372C)"
        }),
        appearance: 'normal',
        testId: 'polaris-lib-notifications.controllers.notification.error',
        messageId: notification.messageId ?? 'polaris-lib-notifications.controllers.customAutoDismissFlag.error',
        messageType: notification.messageType ?? 'transactional'
    }, onDismiss);
const $3e7591c0992d0e62$export$53d5ca6c3f53e109 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    return (0, $5uXOq.useMemo)(()=>({
            customFlag: (notification)=>{
                const flagId = showFlag($3e7591c0992d0e62$var$customFlag(notification, dismissFlag));
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            success: (notification)=>{
                const flagId = showFlag($3e7591c0992d0e62$var$success(notification, dismissFlag));
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            errorWithRefresh: (notification)=>{
                const flagId = showFlag($3e7591c0992d0e62$var$errorWithRefresh(notification, dismissFlag));
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            error: (notification)=>{
                const flagId = showFlag($3e7591c0992d0e62$var$error(notification, dismissFlag));
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            showFlag: (flag)=>{
                const id = flag.id !== undefined ? flag.id : (0, $7HGHK.toFlagId)((0, $7Jxgt.v4)());
                const flagId = showFlag({
                    ...flag,
                    id: id,
                    key: id,
                    messageId: flag.messageId ?? `polaris-lib-notifications.controllers.showFlag.${id}`,
                    messageType: flag.messageType ?? 'transactional'
                });
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            showCustomFlag: (flag)=>{
                const id = flag.id !== undefined ? flag.id : (0, $7HGHK.toFlagId)((0, $7Jxgt.v4)());
                const flagId = showFlag({
                    messageId: `polaris-lib-notifications.controllers.showCustomFlag.${id}`,
                    messageType: 'transactional',
                    ...flag,
                    id: id
                });
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            dismissFlag: dismissFlag
        }), [
        showFlag,
        dismissFlag
    ]);
};

});
parcelRegister("7R4eB", function(module, exports) {

$parcel$export(module.exports, "default", () => $435170f9f2349b2e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iNWLk = parcelRequire("iNWLk");

var $3KRpp = parcelRequire("3KRpp");
const $435170f9f2349b2e$var$AkAutoDismissFlag = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.CommonFlag), {
        isAutoDismiss: true,
        ...props,
        flagType: "info"
    }));
var $435170f9f2349b2e$export$2e2bcd8739ae039 = $435170f9f2349b2e$var$AkAutoDismissFlag;

});

parcelRegister("d4xRU", function(module, exports) {

$parcel$export(module.exports, "default", () => $61381db0e069bc03$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iNWLk = parcelRequire("iNWLk");

var $3KRpp = parcelRequire("3KRpp");
const $61381db0e069bc03$var$AkFlag = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.CommonFlag), {
        flagType: "info",
        ...props
    }));
var $61381db0e069bc03$export$2e2bcd8739ae039 = $61381db0e069bc03$var$AkFlag;

});


parcelRegister("lH8Ty", function(module, exports) {

$parcel$export(module.exports, "EntityLimitError", () => $bbaa521f44d79b10$export$c4e01b2c2ba95919);
$parcel$export(module.exports, "getEntityLimitError", () => $bbaa521f44d79b10$export$13f6f9a6b905ebbd);
$parcel$export(module.exports, "getErrorMessageDescriptor", () => $bbaa521f44d79b10$export$cf58cbb2768ea4f);

var $e3a3O = parcelRequire("e3a3O");

var $ht021 = parcelRequire("ht021");

var $j7a90 = parcelRequire("j7a90");

var $lTDxG = parcelRequire("lTDxG");
class $bbaa521f44d79b10$export$c4e01b2c2ba95919 extends (0, $ht021.default) {
    constructor(message, errors = [], statusCode = null, type){
        super(message, {
            cause: errors[0]
        }), this.name = 'EntityLimitError';
        this.errors = errors;
        this.statusCode = statusCode;
        this.type = type;
    }
}
const $bbaa521f44d79b10$export$13f6f9a6b905ebbd = (error)=>{
    // If already an EntityLimitError, return it
    if (error instanceof $bbaa521f44d79b10$export$c4e01b2c2ba95919) return error;
    // If not an ApolloError, return null as we can't handle it
    if (!(error instanceof (0, $e3a3O.ApolloError))) return null;
    // Get first entity limit error
    const entityLimitError = error.graphQLErrors?.filter((err)=>err.extensions?.limitType)[0];
    // If no entity limit error or no extensions, return null
    if (!entityLimitError?.extensions) return null;
    const { statusCode: statusCode, limitType: limitType } = entityLimitError.extensions;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const entityLimitErrorType = (0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE)[limitType];
    return new $bbaa521f44d79b10$export$c4e01b2c2ba95919(entityLimitError.message, [
        {
            error: entityLimitError.message
        }
    ], statusCode, entityLimitErrorType);
};
const $bbaa521f44d79b10$export$cf58cbb2768ea4f = (error)=>(0, $j7a90.default)[error.type] || null;

});
parcelRegister("j7a90", function(module, exports) {

$parcel$export(module.exports, "default", () => $6233b95581c40425$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");

var $lTDxG = parcelRequire("lTDxG");
var $6233b95581c40425$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    /* eslint-disable jira/i18n/id-named-by-package */ [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).COMMENTS_PER_VIEW]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.comments-per-view",
        "defaultMessage": "We couldn\u2019t create a new <item>comment</item> because this <item>view</item> has reached its limit for <item>comments</item>. Remove <item>comment</item> to create a new <item>comment</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).FIELDS_PER_VIEW]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.fields-per-view",
        "defaultMessage": "We couldn\u2019t create a new <item>field</item> because this <item>view</item> has reached its limit for <item>fields</item>. Remove <item>field</item> to create a new <item>field</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).FIELDS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.fields-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>field</item> because this <item>project</item> has reached its limit for <item>fields</item>. Remove <item>field</item> to create a new <item>field</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).INSIGHTS_PER_IDEA]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.insights-per-idea",
        "defaultMessage": "We couldn\u2019t create a new <item>insight</item> because this <item>idea</item> has reached its limit for <item>insights</item>. Remove <item>insight</item> to create a new <item>insight</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).INSIGHTS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.insights-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>insight</item> because this <item>project</item> has reached its limit for <item>insights</item>. Remove <item>insight</item> to create a new <item>insight</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).LABELS_PER_SNIPPET]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.labels-per-snippet",
        "defaultMessage": "We couldn\u2019t create a new <item>label</item> because this <item>snippet</item> has reached its limit for <item>labels</item>. Remove <item>label</item> to create a new <item>label</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).OPTIONS_PER_FIELD]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.options-per-field",
        "defaultMessage": "We couldn\u2019t create a new <item>option</item> because this <item>field</item> has reached its limit for <item>options</item>. Remove <item>option</item> to create a new <item>option</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).PLAY_CONTRIBUTIONS_PER_PLAY]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.play-contributions-per-play",
        "defaultMessage": "We couldn\u2019t create a new <item>vote contribution</item> because this <item>vote</item> has reached its limit for <item>vote contributions</item>. Remove <item>vote contribution</item> to create a new <item>vote contribution</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).PLAY_CONTRIBUTIONS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.play-contributions-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>vote contribution</item> because this <item>project</item> has reached its limit for <item>vote contributions</item>. Remove <item>vote contribution</item> to create a new <item>vote contribution</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).PLAYS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.plays-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>vote</item> because this <item>project</item> has reached its limit for <item>votes</item>. Remove <item>vote</item> to create a new <item>vote</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).SNIPPETS_PER_INSIGHT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.snippets-per-insight",
        "defaultMessage": "We couldn\u2019t create a new <item>snippet</item> because this <item>insight</item> has reached its limit for <item>snippets</item>. Remove <item>snippet</item> to create a new <item>snippet</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).VIEWS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.views-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>view</item> because this <item>project</item> has reached its limit for <item>views</item>. Remove <item>view</item> to create a new <item>view</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).VIEWSETS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.viewsets-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>section</item> because this <item>project</item> has reached its limit for <item>sections</item>. Remove <item>section</item> to create a new <item>section</item>"
    }
});

});
parcelRegister("lTDxG", function(module, exports) {

$parcel$export(module.exports, "ENTITY_LIMIT_ERROR_TYPE", () => $557259e823a7e117$export$a197d88688faa32c);
const $557259e823a7e117$export$a197d88688faa32c = {
    COMMENTS_PER_VIEW: 'commentsPerView',
    FIELDS_PER_VIEW: 'fieldsPerView',
    FIELDS_PER_PROJECT: 'fieldsPerProject',
    INSIGHTS_PER_IDEA: 'insightsPerIdea',
    INSIGHTS_PER_PROJECT: 'insightsPerProject',
    LABELS_PER_SNIPPET: 'labelsPerSnippet',
    OPTIONS_PER_FIELD: 'optionsPerField',
    PLAY_CONTRIBUTIONS_PER_PLAY: 'playContributionsPerPlay',
    PLAY_CONTRIBUTIONS_PER_PROJECT: 'playContributionsPerProject',
    PLAYS_PER_PROJECT: 'playsPerProject',
    SNIPPETS_PER_INSIGHT: 'snippetsPerInsight',
    VIEWS_PER_PROJECT: 'viewsPerProject',
    VIEWSETS_PER_PROJECT: 'viewsetsPerProject'
};

});



parcelRegister("l6caf", function(module, exports) {

$parcel$export(module.exports, "default", () => $891c8f37fb7de7f7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $891c8f37fb7de7f7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "polaris-lib-errors.controllers.error-title",
        "defaultMessage": "Something went wrong."
    },
    permissionErrorDescription: {
        "id": "polaris-lib-errors.controllers.permission-error-description",
        "defaultMessage": "You may not have the permissions required to perform this operation."
    },
    configErrorTitle: {
        "id": "polaris-lib-errors.controllers.config-error-title",
        "defaultMessage": "We couldn't save that."
    },
    configErrorDescription: {
        "id": "polaris-lib-errors.controllers.config-error-description",
        "defaultMessage": "This usually happens because the configuration data on this field is too big. Contact support for more details"
    },
    serverLoadFailedDescription: {
        "id": "polaris-lib-errors.controllers.server-load-failed-description",
        "defaultMessage": "We had difficulties to fetch some data from the server. Please refresh the page."
    },
    serverUpdateFailedDescription: {
        "id": "polaris-lib-errors.controllers.server-update-failed-description",
        "defaultMessage": "We had some difficulties to save some data to the server. Please try again or refresh the page."
    },
    errorDescription: {
        "id": "polaris-lib-errors.controllers.error-description",
        "defaultMessage": "We failed to execute your last operation. Our team has been notified. Please refresh the page to try again."
    },
    workflowLoadingFailedDescription: {
        "id": "polaris-lib-errors.controllers.workflow-loading-failed-description",
        "defaultMessage": "We had some difficulties to load some workflow data from the server. Please refresh the page."
    },
    errorPossibleAccessLoss: {
        "id": "polaris-lib-errors.controllers.error-possible-access-loss",
        "defaultMessage": "You may have lost access to the project or site. Please refresh the page."
    },
    cyclicFormulaFieldDescription: {
        "id": "polaris-lib-errors.controllers.cyclic-formula-field-description",
        "defaultMessage": "We cannot calculate the value of some fields because they contain a cyclic formula. Please edit the field configurations and refresh: {fieldLabels}"
    },
    entityLimitErrorTitle: {
        "id": "polaris-lib-errors.controllers.entity-limit-error-title",
        "defaultMessage": "You\u2019ve hit a limit"
    }
});

});

parcelRegister("aiePb", function(module, exports) {

$parcel$export(module.exports, "isPermissionError", () => $b7e19fcceac7c31b$export$e11674744930cd15);
$parcel$export(module.exports, "isRateLimitError", () => $b7e19fcceac7c31b$export$a8908c3867f6f20b);
$parcel$export(module.exports, "isAccessForbiddenError", () => $b7e19fcceac7c31b$export$443ae86cf12ba84);
$parcel$export(module.exports, "isNotFoundError", () => $b7e19fcceac7c31b$export$6ccdb59d3479f4f1);
$parcel$export(module.exports, "isClientClosedError", () => $b7e19fcceac7c31b$export$ce14333297f1d017);
$parcel$export(module.exports, "isBadRequest", () => $b7e19fcceac7c31b$export$9ec5d1f0bf2939c);
$parcel$export(module.exports, "isConflictError", () => $b7e19fcceac7c31b$export$b43c7b888ac6458);
$parcel$export(module.exports, "isConfigError", () => $b7e19fcceac7c31b$export$5e48c9e1c3c8f299);
$parcel$export(module.exports, "getMetadata", () => $b7e19fcceac7c31b$export$8548546c0aa631e6);

var $561FV = parcelRequire("561FV");

var $8LQ84 = parcelRequire("8LQ84");

var $icGZu = parcelRequire("icGZu");
const $b7e19fcceac7c31b$export$e11674744930cd15 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 401 || errorObject.statusCode === 403;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(errorObject, 'graphQLErrors') && (0, (/*@__PURE__*/$parcel$interopDefault($8LQ84)))(errorObject.graphQLErrors)) // graphql response error, check polaris-specific payload
    return (0, (/*@__PURE__*/$parcel$interopDefault($icGZu)))(errorObject.graphQLErrors, (error)=>{
        const safeMessage = error.message || '';
        return error.extensions?.statusCode === 403 || error.extensions?.statusCode === 401 || safeMessage.includes('JIRA_ACCESS_NOT_PERMITTED') || safeMessage.includes('RequestStatus: 401') || safeMessage.includes('RequestStatus: 403') || safeMessage.includes('status code 401') || // that's probably obsolete
        safeMessage.includes('status code 403') // that's probably obsolete
        ;
    });
    return false;
};
const $b7e19fcceac7c31b$var$checkRateLimitErrorMatch = (error)=>{
    const safeMessage = error?.message || '';
    return error && 'statusCode' in error && error?.statusCode === 429 || error && 'extensions' in error && error.extensions?.statusCode === 429 || safeMessage.includes('RequestStatus: 429') || safeMessage.includes('status code 429');
};
const $b7e19fcceac7c31b$export$a8908c3867f6f20b = (errorObject)=>{
    return $b7e19fcceac7c31b$var$checkRateLimitErrorMatch(errorObject) || errorObject.networkError && $b7e19fcceac7c31b$var$checkRateLimitErrorMatch(errorObject.networkError) || errorObject?.graphQLErrors?.some((error)=>$b7e19fcceac7c31b$var$checkRateLimitErrorMatch(error)) || false;
};
const $b7e19fcceac7c31b$export$443ae86cf12ba84 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 403;
    return false;
};
const $b7e19fcceac7c31b$export$6ccdb59d3479f4f1 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 404;
    return false;
};
const $b7e19fcceac7c31b$export$ce14333297f1d017 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 499;
    return false;
};
const $b7e19fcceac7c31b$export$9ec5d1f0bf2939c = (errorObject)=>{
    if (errorObject?.statusCode) // http response error, check status code
    return errorObject?.statusCode >= 400 && errorObject?.statusCode < 500;
    return false;
};
const $b7e19fcceac7c31b$export$b43c7b888ac6458 = (errorObject)=>errorObject.statusCode === 409;
const $b7e19fcceac7c31b$export$5e48c9e1c3c8f299 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(errorObject, 'statusCode') && (0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(errorObject, 'message')) return errorObject.statusCode === 500 && errorObject.message === 'Property is too long';
    return false;
};
const $b7e19fcceac7c31b$export$8548546c0aa631e6 = (errorObject)=>({
        metadata: {
            error: errorObject.message
        }
    });

});
parcelRegister("icGZu", function(module, exports) {

var $2k3l6 = parcelRequire("2k3l6");

var $bxDef = parcelRequire("bxDef");

var $6kYP8 = parcelRequire("6kYP8");

var $8LQ84 = parcelRequire("8LQ84");

var $4rDUz = parcelRequire("4rDUz");
/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $d40ab2104a331ebd$var$some(collection, predicate, guard) {
    var func = $8LQ84(collection) ? $2k3l6 : $6kYP8;
    if (guard && $4rDUz(collection, predicate, guard)) predicate = undefined;
    return func(collection, $bxDef(predicate, 3));
}
module.exports = $d40ab2104a331ebd$var$some;

});
parcelRegister("6kYP8", function(module, exports) {

var $e7pfQ = parcelRequire("e7pfQ");
/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $49d3cab0435826ab$var$baseSome(collection, predicate) {
    var result;
    $e7pfQ(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
module.exports = $49d3cab0435826ab$var$baseSome;

});





parcelRegister("irhvp", function(module, exports) {

$parcel$export(module.exports, "loadAllViewsSpotlightDismissed", () => $386a76adebfd5ad6$export$73f482a9822cc952);
$parcel$export(module.exports, "setAllViewsSpotlightDismissed", () => $386a76adebfd5ad6$export$84df3d965709961e);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $386a76adebfd5ad6$export$73f482a9822cc952 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().allViews.spotlightDismissed === 'boolean') return;
        try {
            const spotlightDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.NAV_JPD_VIEWS_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                allViews: {
                    ...state.allViews,
                    spotlightDismissed: spotlightDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    allViews: {
                        ...state.allViews,
                        spotlightDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.all-views-spotlight', `Failed to get user property with key: ${(0, $d9ulS.NAV_JPD_VIEWS_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : new Error(String(error)));
        }
    };
const $386a76adebfd5ad6$export$84df3d965709961e = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            allViews: {
                ...state.allViews,
                spotlightDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.NAV_JPD_VIEWS_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.all-views-spotlight', `Failed to set user property with key: ${(0, $d9ulS.NAV_JPD_VIEWS_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : new Error(String(error)));
        }
    };

});

parcelRegister("i1anS", function(module, exports) {

$parcel$export(module.exports, "loadPrioritizationViewTourDismissed", () => $21cf3ff4ec7ad773$export$f610fdf8823d3e34);
$parcel$export(module.exports, "setPrioritizationViewTourDismissed", () => $21cf3ff4ec7ad773$export$a72bdc987d4b2c7d);
$parcel$export(module.exports, "setPrioritizationViewTourSpotlightStep", () => $21cf3ff4ec7ad773$export$a76ccd1e602a886c);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $21cf3ff4ec7ad773$export$f610fdf8823d3e34 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().prioritizationView.tourDismissed === 'boolean') return;
        try {
            const tourDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.PRIORITIZATION_VIEW_TOUR_DISMISSED));
            const state = getState();
            setState({
                ...state,
                prioritizationView: {
                    ...state.prioritizationView,
                    tourDismissed: tourDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    prioritizationView: {
                        ...state.prioritizationView,
                        tourDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.prioritization-view.tour', `Failed to get user property with key: ${(0, $d9ulS.PRIORITIZATION_VIEW_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $21cf3ff4ec7ad773$export$a72bdc987d4b2c7d = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            prioritizationView: {
                ...state.prioritizationView,
                tourDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.PRIORITIZATION_VIEW_TOUR_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.prioritization-view.tour', `Failed to set user property with key: ${(0, $d9ulS.PRIORITIZATION_VIEW_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $21cf3ff4ec7ad773$export$a76ccd1e602a886c = (step)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            prioritizationView: {
                ...state.prioritizationView,
                tourSpotlightStep: step
            }
        });
    };

});

parcelRegister("cXfUC", function(module, exports) {

$parcel$export(module.exports, "loadRoadmapViewSpotlightDismissed", () => $2206505688e5db6e$export$7efa8325e0de15f);
$parcel$export(module.exports, "setRoadmapViewSpotlightDismissed", () => $2206505688e5db6e$export$b55083c189662aa5);
$parcel$export(module.exports, "loadRoadmapColumnConfigSpotlightDismissed", () => $2206505688e5db6e$export$9e6f136ba325b100);
$parcel$export(module.exports, "setRoadmapColumnConfigSpotlightDismissed", () => $2206505688e5db6e$export$866ee7083694a75f);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $2206505688e5db6e$export$7efa8325e0de15f = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().roadmapView.spotlightDismissed === 'boolean') return;
        try {
            const spotlightDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.ROADMAP_VIEW_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                roadmapView: {
                    ...state.roadmapView,
                    spotlightDismissed: spotlightDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    roadmapView: {
                        ...state.roadmapView,
                        spotlightDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmap-view-spotlight', `Failed to get user property with key: ${(0, $d9ulS.ROADMAP_VIEW_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $2206505688e5db6e$export$b55083c189662aa5 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            roadmapView: {
                ...state.roadmapView,
                spotlightDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.ROADMAP_VIEW_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmap-view-spotlight', `Failed to set user property with key: ${(0, $d9ulS.ROADMAP_VIEW_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $2206505688e5db6e$export$9e6f136ba325b100 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        // User property is already loaded
        if (typeof getState().roadmapView.columnConfigSpotlightDismissed === 'boolean') return;
        try {
            const columnConfigSpotlightDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.ROADMAP_COLUMN_CONFIG_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                roadmapView: {
                    ...state.roadmapView,
                    columnConfigSpotlightDismissed: columnConfigSpotlightDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    roadmapView: {
                        ...state.roadmapView,
                        columnConfigSpotlightDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.all-views-spotlight', `Failed to get user property with key: ${(0, $d9ulS.ROADMAP_COLUMN_CONFIG_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $2206505688e5db6e$export$866ee7083694a75f = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            roadmapView: {
                ...state.roadmapView,
                columnConfigSpotlightDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.ROADMAP_COLUMN_CONFIG_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmap-view-column-config-spotlight', `Failed to set user property with key: ${(0, $d9ulS.ROADMAP_COLUMN_CONFIG_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("9nrm9", function(module, exports) {

$parcel$export(module.exports, "loadViewCreatorSpotlightState", () => $99d368e0edf5cbc9$export$9a1628c8a6cce5a8);
$parcel$export(module.exports, "setViewCreatorSpotlightTourStep", () => $99d368e0edf5cbc9$export$55b6ef0c08b2c8bc);
$parcel$export(module.exports, "setViewCreatorSpotlightDismissed", () => $99d368e0edf5cbc9$export$b883437f952d9bab);

var $hJCUd = parcelRequire("hJCUd");

var $4R6GH = parcelRequire("4R6GH");

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $jcw0u = parcelRequire("jcw0u");

var $1As78 = parcelRequire("1As78");

var $6FNg9 = parcelRequire("6FNg9");

var $d9ulS = parcelRequire("d9ulS");

var $flDq6 = parcelRequire("flDq6");
const $99d368e0edf5cbc9$export$9a1628c8a6cce5a8 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().viewCreator.tourDismissed === 'boolean') return;
        try {
            const remoteState = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.VIEW_CREATOR_TOUR_SPOTLIGHTS));
            const state = getState();
            setState({
                ...state,
                viewCreator: {
                    ...state.viewCreator,
                    ...(0, (/*@__PURE__*/$parcel$interopDefault($hJCUd)))(remoteState, {
                        tourSpotlightStep: null,
                        tourDismissed: false
                    })
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    viewCreator: {
                        ...state.viewCreator,
                        tourDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.view-creator-spotlight', `Failed to get user property with key: ${(0, $d9ulS.VIEW_CREATOR_TOUR_SPOTLIGHTS)}`, error instanceof Error ? error : new Error(String(error)));
        }
    };
const $99d368e0edf5cbc9$export$55b6ef0c08b2c8bc = (step)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        const newViewCreatorState = {
            ...state.viewCreator,
            tourSpotlightStep: step
        };
        setState({
            ...state,
            viewCreator: newViewCreatorState
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.VIEW_CREATOR_TOUR_SPOTLIGHTS), JSON.stringify(newViewCreatorState));
        } catch (error) {
            (0, $jcw0u.default)((0, $1As78.createErrorAnalytics)('polaris.onboarding.view-creator-spotlight', (0, $flDq6.normalizeError)(error)));
        }
    };
const $99d368e0edf5cbc9$export$b883437f952d9bab = (tourDismissed = true)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        const newViewCreatorState = {
            ...state.viewCreator,
            tourDismissed: tourDismissed
        };
        setState({
            ...state,
            viewCreator: newViewCreatorState
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.VIEW_CREATOR_TOUR_SPOTLIGHTS), JSON.stringify(newViewCreatorState));
        } catch (error) {
            (0, $jcw0u.default)((0, $1As78.createErrorAnalytics)('polaris.onboarding.view-creator-spotlight', (0, $flDq6.normalizeError)(error)));
        }
    };

});
parcelRegister("hJCUd", function(module, exports) {

var $hlchF = parcelRequire("hlchF");

var $g7i7g = parcelRequire("g7i7g");

var $3KORh = parcelRequire("3KORh");

var $3dHKF = parcelRequire("3dHKF");
/**
 * This method is like `_.defaults` except that it recursively assigns
 * default properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaults
 * @example
 *
 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
 * // => { 'a': { 'b': 2, 'c': 3 } }
 */ var $ce94d17a4ae582d5$var$defaultsDeep = $g7i7g(function(args) {
    args.push(undefined, $3KORh);
    return $hlchF($3dHKF, undefined, args);
});
module.exports = $ce94d17a4ae582d5$var$defaultsDeep;

});
parcelRegister("3KORh", function(module, exports) {

var $1m1GH = parcelRequire("1m1GH");

var $k0qYG = parcelRequire("k0qYG");
/**
 * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
 * objects into destination objects that are passed thru.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to merge.
 * @param {Object} object The parent object of `objValue`.
 * @param {Object} source The parent object of `srcValue`.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 * @returns {*} Returns the value to assign.
 */ function $2bbd1e633373e9a1$var$customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
    if ($k0qYG(objValue) && $k0qYG(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        $1m1GH(objValue, srcValue, undefined, $2bbd1e633373e9a1$var$customDefaultsMerge, stack);
        stack['delete'](srcValue);
    }
    return objValue;
}
module.exports = $2bbd1e633373e9a1$var$customDefaultsMerge;

});

parcelRegister("3dHKF", function(module, exports) {

var $1m1GH = parcelRequire("1m1GH");

var $9MM2g = parcelRequire("9MM2g");
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var $2584862af7fb4983$var$mergeWith = $9MM2g(function(object, source, srcIndex, customizer) {
    $1m1GH(object, source, srcIndex, customizer);
});
module.exports = $2584862af7fb4983$var$mergeWith;

});



parcelRegister("fg3Qo", function(module, exports) {

$parcel$export(module.exports, "loadBlueprintsState", () => $f31731ee3059d607$export$104ee4f3e9ddc3c4);
$parcel$export(module.exports, "setBlueprintsTourStep", () => $f31731ee3059d607$export$1b9ba94b448264d2);
$parcel$export(module.exports, "setBlueprintsTourDismissed", () => $f31731ee3059d607$export$13d121276e063a92);

var $hJCUd = parcelRequire("hJCUd");

var $4R6GH = parcelRequire("4R6GH");

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $jcw0u = parcelRequire("jcw0u");

var $1As78 = parcelRequire("1As78");

var $6FNg9 = parcelRequire("6FNg9");

var $d9ulS = parcelRequire("d9ulS");

var $flDq6 = parcelRequire("flDq6");
const $f31731ee3059d607$export$104ee4f3e9ddc3c4 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().blueprints.tourDismissed === 'boolean') return;
        try {
            const remoteState = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.BLUEPRINTS_TOUR_SPOTLIGHTS));
            const state = getState();
            setState({
                ...state,
                blueprints: {
                    ...state.blueprints,
                    ...(0, (/*@__PURE__*/$parcel$interopDefault($hJCUd)))(remoteState, {
                        tourSpotlightStep: null,
                        tourDismissed: false
                    })
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    blueprints: {
                        ...state.blueprints,
                        tourDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.blueprints-spotlight', `Failed to get user property with key: ${(0, $d9ulS.BLUEPRINTS_TOUR_SPOTLIGHTS)}`, error instanceof Error ? error : new Error(String(error)));
        }
    };
const $f31731ee3059d607$export$1b9ba94b448264d2 = (step)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        const newBlueprintsState = {
            ...state.blueprints,
            tourSpotlightStep: step
        };
        setState({
            ...state,
            blueprints: newBlueprintsState
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.BLUEPRINTS_TOUR_SPOTLIGHTS), JSON.stringify(newBlueprintsState));
        } catch (error) {
            (0, $jcw0u.default)((0, $1As78.createErrorAnalytics)('polaris.onboarding.blueprints-spotlight', (0, $flDq6.normalizeError)(error)));
        }
    };
const $f31731ee3059d607$export$13d121276e063a92 = (tourDismissed)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        const newBlueprintsState = {
            ...state.blueprints,
            tourDismissed: tourDismissed
        };
        setState({
            ...state,
            blueprints: newBlueprintsState
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.BLUEPRINTS_TOUR_SPOTLIGHTS), JSON.stringify(newBlueprintsState));
        } catch (error) {
            (0, $jcw0u.default)((0, $1As78.createErrorAnalytics)('polaris.onboarding.blueprints-spotlight', (0, $flDq6.normalizeError)(error)));
        }
    };

});

parcelRegister("a6Bob", function(module, exports) {

$parcel$export(module.exports, "loadPremiumModalDismissed", () => $f7233d1c4eea5348$export$f4ca311cb4b4350f);
$parcel$export(module.exports, "setPremiumModalDismissed", () => $f7233d1c4eea5348$export$99d8813bb6724f28);
$parcel$export(module.exports, "loadPremiumLastVisit", () => $f7233d1c4eea5348$export$6825e78fd5bc05f5);
$parcel$export(module.exports, "setPremiumLastVisit", () => $f7233d1c4eea5348$export$c2d4fef533f3196c);
$parcel$export(module.exports, "unlockOnboardingFlow", () => $f7233d1c4eea5348$export$f92cc7ff16154919);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $d9ulS = parcelRequire("d9ulS");
const $f7233d1c4eea5348$export$f4ca311cb4b4350f = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        // User property is already loaded
        if (typeof getState().premium.modalDismissed === 'boolean') return;
        try {
            const modalDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.PREMIUM_MODAL_DISMISSED));
            const state = getState();
            setState({
                premium: {
                    ...state.premium,
                    modalDismissed: modalDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    premium: {
                        ...state.premium,
                        modalDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.premium.modal-dismissed', `Failed to get user property with key: ${(0, $d9ulS.PREMIUM_MODAL_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
        return getState().premium.modalDismissed;
    };
const $f7233d1c4eea5348$export$99d8813bb6724f28 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        // we need to pass isPremium to the lastVisit object to ensure that the modal is dismissed
        // when the user is on the premium edition and the last visit was on the free edition
        setState({
            premium: {
                ...state.premium,
                modalDismissed: true,
                lastVisit: {
                    ...state.premium.lastVisit,
                    isPremium: true
                }
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.PREMIUM_MODAL_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.premium.modal-dismissed', `Failed to set user property with key: ${(0, $d9ulS.PREMIUM_MODAL_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $f7233d1c4eea5348$export$6825e78fd5bc05f5 = (isPremiumEdition)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        // User property is already loaded
        if (typeof getState().premium.lastVisit.isPremium === 'boolean') return;
        try {
            const lastVisitOnPremium = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.PREMIUM_LAST_VISIT));
            const state = getState();
            setState({
                premium: {
                    ...state.premium,
                    lastVisit: {
                        ...state.premium.lastVisit,
                        isPremium: lastVisitOnPremium
                    }
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    premium: {
                        ...state.premium,
                        lastVisit: {
                            ...state.premium.lastVisit,
                            isPremium: isPremiumEdition
                        }
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.premium.last-visit', `Failed to get user property with key: ${(0, $d9ulS.PREMIUM_LAST_VISIT)}`, error instanceof Error ? error : undefined);
        }
        return getState().premium.modalDismissed;
    };
const $f7233d1c4eea5348$export$c2d4fef533f3196c = (isPremium)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if (getState().premium.lastVisit.updated) // If lastVisit has been updated already
        // then don't do it again
        return;
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.PREMIUM_LAST_VISIT), String(isPremium));
            const state = getState();
            setState({
                premium: {
                    ...state.premium,
                    lastVisit: {
                        ...state.premium.lastVisit,
                        updated: true
                    }
                }
            });
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.premium.last-visit', `Failed to set user property with key: ${(0, $d9ulS.PREMIUM_LAST_VISIT)}`, error instanceof Error ? error : undefined);
        }
    };
const $f7233d1c4eea5348$export$f92cc7ff16154919 = ()=>async ({ getState: getState })=>{
        getState().premium.promise.resolve();
    };

});

parcelRegister("dke7D", function(module, exports) {

$parcel$export(module.exports, "loadProductUsageStartTimestamp", () => $f2bc503204fd19f2$export$7cb2c6cd0d7c32c0);

var $89SaW = parcelRequire("89SaW");

var $8U9Op = parcelRequire("8U9Op");

var $fZneA = parcelRequire("fZneA");

var $jJZqs = parcelRequire("jJZqs");

var $d9ulS = parcelRequire("d9ulS");
const $f2bc503204fd19f2$export$7cb2c6cd0d7c32c0 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        // usage timestamp already loaded
        if (getState().productUsageStartTimestamp) return;
        try {
            const { isoDateString: productUsageStartTimestamp } = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.PRODUCT_START_TIMESTAMP));
            const state = getState();
            setState({
                ...state,
                productUsageStartTimestamp: productUsageStartTimestamp
            });
        } catch (error) {
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404 || (0, $fZneA.isClientFetchError)(error)) return;
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmaps.introduction.spotlight.dismissed', `Failed to get user property with key: ${(0, $d9ulS.PRODUCT_START_TIMESTAMP)}`, error instanceof Error ? error : undefined);
        }
        return getState().productUsageStartTimestamp;
    };

});



parcelRegister("7qsHB", function(module, exports) {

$parcel$export(module.exports, "useCollectionsTourDismissed", () => $de678aee09ba157d$export$17de768881ff6446);
$parcel$export(module.exports, "useTourSpotlightStep", () => $de678aee09ba157d$export$152b14ddbe17966d);
$parcel$export(module.exports, "useCollectionsIntroductionDismissed", () => $de678aee09ba157d$export$2c88e8fbdc79e33c);
$parcel$export(module.exports, "useCollectionsIntroductionPrerequisiteDismissalsMet", () => $de678aee09ba157d$export$45df47b92137b673);

var $cAcWf = parcelRequire("cAcWf");

var $3u3TI = parcelRequire("3u3TI");
const $de678aee09ba157d$export$17de768881ff6446 = (0, $cAcWf.createHook)((0, $3u3TI.getCollectionsTourDismissed));
const $de678aee09ba157d$export$152b14ddbe17966d = (0, $cAcWf.createHook)((0, $3u3TI.getTourSpotlightStep));
const $de678aee09ba157d$export$2c88e8fbdc79e33c = (0, $cAcWf.createHook)((0, $3u3TI.getCollectionsIntroductionDismissed));
const $de678aee09ba157d$export$45df47b92137b673 = (0, $cAcWf.createHook)((0, $3u3TI.getCollectionsIntroductionPrerequisiteDismissalsMet));

});
parcelRegister("3u3TI", function(module, exports) {

$parcel$export(module.exports, "getCollectionsTourDismissed", () => $dd2f618ed5b718df$export$2f4e8052c0c8cc36);
$parcel$export(module.exports, "getTourSpotlightStep", () => $dd2f618ed5b718df$export$c0777ba57d86bcd1);
$parcel$export(module.exports, "getCollectionsIntroductionDismissed", () => $dd2f618ed5b718df$export$df23a375f28a4c0f);
$parcel$export(module.exports, "getCollectionsIntroductionPrerequisiteDismissalsMet", () => $dd2f618ed5b718df$export$e6b937f1096fabf9);

var $dGvGJ = parcelRequire("dGvGJ");
const $dd2f618ed5b718df$export$9bc19dcd1978ec48 = (state)=>state.collections;
const $dd2f618ed5b718df$export$2f4e8052c0c8cc36 = (0, $dGvGJ.createSelector)($dd2f618ed5b718df$export$9bc19dcd1978ec48, (collections)=>collections.tourDismissed);
const $dd2f618ed5b718df$export$c0777ba57d86bcd1 = (0, $dGvGJ.createSelector)($dd2f618ed5b718df$export$9bc19dcd1978ec48, (collections)=>collections.tourSpotlightStep);
const $dd2f618ed5b718df$export$df23a375f28a4c0f = (0, $dGvGJ.createSelector)($dd2f618ed5b718df$export$9bc19dcd1978ec48, (collections)=>collections.introductionDismissed);
const $dd2f618ed5b718df$export$e6b937f1096fabf9 = (0, $dGvGJ.createSelector)($dd2f618ed5b718df$export$9bc19dcd1978ec48, (collections)=>collections.introductionPrerequisiteDismissalsMet);

});


parcelRegister("jhE94", function(module, exports) {

$parcel$export(module.exports, "useProductUsageStartTimestamp", () => $2346875d10b87fd5$export$935abb673611c138);

var $cAcWf = parcelRequire("cAcWf");

var $eyW9h = parcelRequire("eyW9h");
const $2346875d10b87fd5$export$935abb673611c138 = (0, $cAcWf.createHook)((0, $eyW9h.getProductUsageStartTimestamp));

});
parcelRegister("eyW9h", function(module, exports) {

$parcel$export(module.exports, "getProductUsageStartTimestamp", () => $4d3ab3242e339cb7$export$e96fba6f475323c2);
const $4d3ab3242e339cb7$export$e96fba6f475323c2 = (state)=>state.productUsageStartTimestamp;

});


parcelRegister("9V003", function(module, exports) {

$parcel$export(module.exports, "messages", () => $896b0ce39c051edc$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $896b0ce39c051edc$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    dismiss: {
        "id": "polaris-lib-onboarding-flows.collections.tour.introduction.dismiss",
        "defaultMessage": "Dismiss"
    },
    giveItATry: {
        "id": "polaris-lib-onboarding-flows.collections.tour.introduction.give-it-a-try",
        "defaultMessage": "Give it a try!"
    },
    message: {
        "id": "polaris-lib-onboarding-flows.collections.tour.introduction.message",
        "defaultMessage": "Create a roadmap tailored to the information your stakeholders care about the most by selecting which projects and ideas to include."
    }
});

});

parcelRegister("3aLoA", function(module, exports) {

$parcel$export(module.exports, "checkIfOlderThanNDays", () => $769a162525414dfb$export$cbcf9869d63af9cf);
const $769a162525414dfb$export$cbcf9869d63af9cf = (productStartTimestamp, days = 7)=>{
    if (!productStartTimestamp) return false;
    const daysInMs = days * 86400000;
    const currentDate = new Date();
    const productAge = currentDate.getTime() - new Date(productStartTimestamp).getTime();
    return productAge > daysInMs;
};

});


parcelRegister("aOD49", function(module, exports) {

$parcel$export(module.exports, "getCollectionDetailsPageUrl", () => $a92ae6c7b428c3ad$export$6d4e7a90e74e9b12);
$parcel$export(module.exports, "getCollectionViewPageUrl", () => $a92ae6c7b428c3ad$export$32ac8841347e1f79);
$parcel$export(module.exports, "getCollectionsPageUrl", () => $a92ae6c7b428c3ad$export$d15219b9c6a3e2f7);
$parcel$export(module.exports, "useCollectionIdeasCount", () => $a92ae6c7b428c3ad$export$28cc502c982e0868);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $dpYV0 = parcelRequire("dpYV0");

var $8EJ2P = parcelRequire("8EJ2P");
const $a92ae6c7b428c3ad$var$withQueryParams = (path, queryParams)=>{
    if (queryParams) {
        const searchParams = new URLSearchParams();
        Object.keys(queryParams).forEach((key)=>{
            if (queryParams[key]) searchParams.set(key, queryParams[key]);
        });
        if (searchParams.size > 0) return `${path}?${searchParams.toString()}`;
    }
    return path;
};
const $a92ae6c7b428c3ad$export$6d4e7a90e74e9b12 = (collectionUUID)=>`/jira/polaris/roadmaps/${collectionUUID}/view`;
const $a92ae6c7b428c3ad$export$32ac8841347e1f79 = (collectionUUID, viewUUID, queryParams)=>$a92ae6c7b428c3ad$var$withQueryParams(`/jira/polaris/roadmaps/${collectionUUID}/view/${viewUUID}`, queryParams);
const $a92ae6c7b428c3ad$export$d15219b9c6a3e2f7 = (queryParams)=>$a92ae6c7b428c3ad$var$withQueryParams('/jira/polaris/roadmaps', queryParams);
const $a92ae6c7b428c3ad$var$debouncedGetIdeasCountWithJQL = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((jql, setRequest, res, rej)=>{
    const request = (0, $8EJ2P.getIdeasCountForCollection)(jql);
    setRequest(request);
    request.then(res, rej).finally(()=>setRequest(undefined));
}, 500);
const $a92ae6c7b428c3ad$export$28cc502c982e0868 = (projectKeys, filtersJql)=>{
    const jql = (0, $dpYV0.getJQLForCollection)(projectKeys, filtersJql);
    const [ideasCount, setIdeasCount] = (0, $5uXOq.useState)(undefined);
    const [isLoading, setLoading] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [request, setRequest] = (0, $5uXOq.useState)(undefined);
    (0, $5uXOq.useEffect)(()=>{
        if (jql && projectKeys.length) {
            setLoading(true);
            $a92ae6c7b428c3ad$var$debouncedGetIdeasCountWithJQL(jql, setRequest, (newCount)=>{
                setIdeasCount(newCount);
                setLoading(false);
                setError(null);
            }, (err)=>{
                setIdeasCount(undefined);
                setLoading(false);
                setError(err);
            });
        } else setIdeasCount(undefined);
    }, [
        jql,
        projectKeys.length
    ]);
    return [
        ideasCount,
        isLoading,
        error,
        request
    ];
};

});
parcelRegister("dpYV0", function(module, exports) {

$parcel$export(module.exports, "getJQLForCollection", () => $982aeb25f1017157$export$8d4a8272ec8d3589);
$parcel$export(module.exports, "extractProjectKeysFromJql", () => $982aeb25f1017157$export$35840c54e03d7673);
$parcel$export(module.exports, "extractFiltersJqlFromJql", () => $982aeb25f1017157$export$bcd3615366d8d128);
$parcel$export(module.exports, "getFieldsFromJql", () => $982aeb25f1017157$export$54e99094db1a28af);

var $iEIQF = parcelRequire("iEIQF");
var $eK6AG = parcelRequire("eK6AG");
var $bzbto = parcelRequire("bzbto");
var $l0V05 = parcelRequire("l0V05");
const $982aeb25f1017157$var$quoteProjectKey = (projectKey)=>`"${projectKey}"`;
const $982aeb25f1017157$var$PROJECT_FIELD_KEY = 'project';
const $982aeb25f1017157$export$8d4a8272ec8d3589 = (projectsKeys = [], filtersJql = '')=>{
    const jast = new (0, $eK6AG.JastBuilder)().build(filtersJql);
    projectsKeys.length && jast.query?.appendClause((0, $iEIQF.default).terminalClause((0, $iEIQF.default).field($982aeb25f1017157$var$PROJECT_FIELD_KEY), (0, $iEIQF.default).operator((0, $bzbto.OPERATOR_IN)), (0, $iEIQF.default).listOperand(projectsKeys.map($982aeb25f1017157$var$quoteProjectKey).map((0, $iEIQF.default).byText.valueOperand))), (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97));
    if (jast.query?.orderBy) jast.query.removeOrderBy();
    return (0, $l0V05.print)(jast);
};
const $982aeb25f1017157$var$projectInRegex = /project\s+in\s+\((.*?)\)/;
const $982aeb25f1017157$var$projectKeyRegex = /"(.*?)"/g;
const $982aeb25f1017157$export$35840c54e03d7673 = (jql)=>{
    // Extract the part of the JQL related to `project in (...)`
    const projectInMatch = $982aeb25f1017157$var$projectInRegex.exec(jql);
    const projectKeys = [];
    if (projectInMatch) {
        const projectInClause = projectInMatch[1];
        let match;
        // Extract all project keys inside the quotes within the `project in (...)` clause
        // eslint-disable-next-line no-cond-assign
        while((match = $982aeb25f1017157$var$projectKeyRegex.exec(projectInClause)) !== null)projectKeys.push(match[1]);
    }
    return projectKeys;
};
const $982aeb25f1017157$export$bcd3615366d8d128 = (jql)=>{
    const jast = new (0, $eK6AG.JastBuilder)().build(jql);
    const { where: where } = jast.query ?? {};
    if (!where) return '';
    const clauses = where.clauseType === (0, $e9a0ef16a223cbc7$export$7a58b23488ea076b) ? where.clauses : [
        where
    ];
    const projectKeysClause = clauses.find((c)=>c.clauseType === (0, $e9a0ef16a223cbc7$export$ae56b4ef248a2b6a) && c.field.value === $982aeb25f1017157$var$PROJECT_FIELD_KEY);
    if (projectKeysClause) projectKeysClause.remove();
    return (0, $l0V05.print)(jast);
};
const $982aeb25f1017157$var$getFieldsFromClauses = ([clause, ...rest])=>{
    if (!clause) return [];
    if (clause.clauseType === (0, $e9a0ef16a223cbc7$export$ae56b4ef248a2b6a)) return [
        clause.field.value,
        ...$982aeb25f1017157$var$getFieldsFromClauses(rest)
    ];
    if (clause.clauseType === (0, $e9a0ef16a223cbc7$export$e356b89f8c8d2fcb)) return $982aeb25f1017157$var$getFieldsFromClauses([
        clause.clause,
        ...rest
    ]);
    return $982aeb25f1017157$var$getFieldsFromClauses([
        ...clause.clauses,
        ...rest
    ]);
};
const $982aeb25f1017157$var$getFieldKeyFromFieldName = (fieldKeys)=>(fieldName)=>fieldKeys[fieldName.replace(/\[.+\]$/, '').toLowerCase()];
const $982aeb25f1017157$export$54e99094db1a28af = (jql, fieldKeys)=>{
    const jast = new (0, $eK6AG.JastBuilder)().build(jql);
    const { where: where } = jast.query ?? {};
    if (!where) return [];
    const clauses = where.clauseType === (0, $e9a0ef16a223cbc7$export$7a58b23488ea076b) ? where.clauses : [
        where
    ];
    return $982aeb25f1017157$var$getFieldsFromClauses(clauses).map($982aeb25f1017157$var$getFieldKeyFromFieldName(fieldKeys)).filter((field)=>!!field);
};

});
const $e9a0ef16a223cbc7$export$7a58b23488ea076b = 'compound';
const $e9a0ef16a223cbc7$export$ae56b4ef248a2b6a = 'terminal';
const $e9a0ef16a223cbc7$export$e356b89f8c8d2fcb = 'not';

const $3cef51f82b2cbe1d$export$6d6d48d210d3ca97 = 'and';
const $3cef51f82b2cbe1d$export$7b8f0a728d79a753 = 'or';

parcelRegister("iEIQF", function(module, exports) {

$parcel$export(module.exports, "internalCreators", () => $76b4580b91797d8b$export$64d991963cfb5532);
$parcel$export(module.exports, "default", () => $76b4580b91797d8b$export$2e2bcd8739ae039);

var $gzGcl = parcelRequire("gzGcl");

var $awXvh = parcelRequire("awXvh");

var $3hoxA = parcelRequire("3hoxA");

var $2TUEL = parcelRequire("2TUEL");

var $9TMIk = parcelRequire("9TMIk");

var $23cr9 = parcelRequire("23cr9");

var $an0VC = parcelRequire("an0VC");

var $kO6UE = parcelRequire("kO6UE");

var $AZ9nU = parcelRequire("AZ9nU");

var $9HHq9 = parcelRequire("9HHq9");

var $6qN6D = parcelRequire("6qN6D");

var $3J4gf = parcelRequire("3J4gf");

var $her2D = parcelRequire("her2D");

var $j37YY = parcelRequire("j37YY");

var $doe2p = parcelRequire("doe2p");

var $k9DKN = parcelRequire("k9DKN");

var $jRA9z = parcelRequire("jRA9z");

var $bF1Nb = parcelRequire("bF1Nb");

var $bW5aY = parcelRequire("bW5aY");

var $dgZwd = parcelRequire("dgZwd");

var $1zQFd = parcelRequire("1zQFd");

var $eWV0u = parcelRequire("eWV0u");
const $76b4580b91797d8b$export$64d991963cfb5532 = {
    query: (0, $dgZwd.queryInternal),
    compoundClause: (0, $awXvh.compoundClauseInternal),
    compoundOperator: (0, $3hoxA.compoundOperatorInternal),
    terminalClause: (0, $1zQFd.terminalClauseInternal),
    notClause: (0, $9HHq9.notClauseInternal),
    notClauseOperator: (0, $6qN6D.notClauseOperatorInternal),
    predicate: (0, $jRA9z.predicateInternal),
    predicateOperator: (0, $bF1Nb.predicateOperatorInternal),
    field: (0, $2TUEL.fieldInternal),
    property: (0, $bW5aY.propertyInternal),
    operator: (0, $3J4gf.operatorInternal),
    valueOperand: (0, $eWV0u.valueOperandInternal),
    keywordOperand: (0, $kO6UE.keywordOperandInternal),
    functionOperand: (0, $9TMIk.functionOperandInternal),
    functionString: (0, $23cr9.functionStringInternal),
    argument: (0, $gzGcl.argumentInternal),
    listOperand: (0, $AZ9nU.listOperandInternal),
    orderBy: (0, $her2D.orderByInternal),
    orderByOperator: (0, $k9DKN.orderByOperatorInternal),
    orderByField: (0, $doe2p.orderByFieldInternal),
    orderByDirection: (0, $j37YY.orderByDirectionInternal)
};
var $76b4580b91797d8b$export$2e2bcd8739ae039 = {
    jast: $an0VC.jast,
    query: $dgZwd.query,
    compoundClause: $awXvh.compoundClause,
    compoundOperator: $3hoxA.compoundOperator,
    terminalClause: $1zQFd.terminalClause,
    notClause: $9HHq9.notClause,
    notClauseOperator: $6qN6D.notClauseOperator,
    predicate: $jRA9z.predicate,
    predicateOperator: $bF1Nb.predicateOperator,
    field: $2TUEL.field,
    property: $bW5aY.property,
    operator: $3J4gf.operator,
    valueOperand: $eWV0u.valueOperand,
    keywordOperand: $kO6UE.keywordOperand,
    functionOperand: $9TMIk.functionOperand,
    functionString: $23cr9.functionString,
    argument: $gzGcl.argument,
    listOperand: $AZ9nU.listOperand,
    orderBy: $her2D.orderBy,
    orderByOperator: $k9DKN.orderByOperator,
    orderByField: $doe2p.orderByField,
    orderByDirection: $j37YY.orderByDirection,
    byText: {
        argument: (0, $gzGcl.argumentByText),
        valueOperand: (0, $eWV0u.valueOperandByText)
    }
};

});
parcelRegister("gzGcl", function(module, exports) {

$parcel$export(module.exports, "argument", () => $1f5307df81a07b07$export$6ea29ee575e3f5ff);
$parcel$export(module.exports, "argumentInternal", () => $1f5307df81a07b07$export$5b341d50fa5bcdd5);
$parcel$export(module.exports, "argumentByText", () => $1f5307df81a07b07$export$84c43d23f51170cb);

var $gq4pj = parcelRequire("gq4pj");
var $2lgiK = parcelRequire("2lgiK");

var $WCvOq = parcelRequire("WCvOq");
function $1f5307df81a07b07$var$acceptArgument(visitor) {
    return visitor.visitArgument ? visitor.visitArgument(this) : visitor.visitChildren(this);
}
function $1f5307df81a07b07$var$enterNode(listener) {
    listener.enterArgument && listener.enterArgument(this);
}
function $1f5307df81a07b07$var$exitNode(listener) {
    listener.exitArgument && listener.exitArgument(this);
}
const $1f5307df81a07b07$export$6ea29ee575e3f5ff = (value)=>$1f5307df81a07b07$export$5b341d50fa5bcdd5(value, (0, $2lgiK.sanitiseJqlString)(value));
const $1f5307df81a07b07$export$84c43d23f51170cb = (text)=>$1f5307df81a07b07$export$5b341d50fa5bcdd5((0, $gq4pj.normaliseJqlString)(text), text);
const $1f5307df81a07b07$export$5b341d50fa5bcdd5 = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $1f5307df81a07b07$var$acceptArgument,
        enterNode: $1f5307df81a07b07$var$enterNode,
        exitNode: $1f5307df81a07b07$var$exitNode,
        getChildren: (0, $WCvOq.noChildren),
        parent: null
    });

});
parcelRegister("gq4pj", function(module, exports) {

$parcel$export(module.exports, "normaliseJqlString", () => $dd481207f70e9cdd$export$cecf78a779acc0ff);
const $dd481207f70e9cdd$export$7a0b99b892e0dda8 = (maybeQuotedString)=>{
    if (maybeQuotedString.length < 2) return false;
    return maybeQuotedString[0] === "'" && maybeQuotedString[maybeQuotedString.length - 1] === "'" && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
};
const $dd481207f70e9cdd$export$d5efd6512db694fd = (maybeQuotedString)=>{
    if (maybeQuotedString.length < 2) return false;
    return maybeQuotedString[0] === '"' && maybeQuotedString[maybeQuotedString.length - 1] === '"' && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
};
const $dd481207f70e9cdd$export$b86601123607fee5 = (maybeQuotedString)=>$dd481207f70e9cdd$export$7a0b99b892e0dda8(maybeQuotedString) || $dd481207f70e9cdd$export$d5efd6512db694fd(maybeQuotedString);
const $dd481207f70e9cdd$export$cecf78a779acc0ff = (maybeQuotedString)=>{
    if ($dd481207f70e9cdd$export$b86601123607fee5(maybeQuotedString)) return maybeQuotedString.slice(1, -1).replace(/(?:\\(.))/g, '$1');
    if (maybeQuotedString.startsWith('"') || maybeQuotedString.startsWith("'")) return maybeQuotedString.slice(1).replace(/(?:\\(.))/g, '$1');
    return maybeQuotedString;
};

});

parcelRegister("2lgiK", function(module, exports) {

$parcel$export(module.exports, "sanitiseJqlString", () => $6e52f9b4063b6286$export$3eb9033c48208278);

var $8QDwl = parcelRequire("8QDwl");
// Derived from JQLLexer#VALID_UNQUOTED_CHARS
const $6e52f9b4063b6286$var$CHARS_TO_QUOTE = new RegExp(`[\\s${(0, (/*@__PURE__*/$parcel$interopDefault($8QDwl)))(`"'=!<>()~,[]|&{}*/%+^$#@?;`)}]`);
const $6e52f9b4063b6286$export$3eb9033c48208278 = (jqlString)=>{
    if ($6e52f9b4063b6286$var$CHARS_TO_QUOTE.test(jqlString)) return `"${jqlString.replace(/"/g, '\\"')}"`;
    return jqlString;
};

});
parcelRegister("8QDwl", function(module, exports) {

var $jJVtR = parcelRequire("jJVtR");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $6711d60dd8e02df4$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g, $6711d60dd8e02df4$var$reHasRegExpChar = RegExp($6711d60dd8e02df4$var$reRegExpChar.source);
/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */ function $6711d60dd8e02df4$var$escapeRegExp(string) {
    string = $jJVtR(string);
    return string && $6711d60dd8e02df4$var$reHasRegExpChar.test(string) ? string.replace($6711d60dd8e02df4$var$reRegExpChar, '\\$&') : string;
}
module.exports = $6711d60dd8e02df4$var$escapeRegExp;

});


parcelRegister("WCvOq", function(module, exports) {

$parcel$export(module.exports, "noChildren", () => $90e2b276351fabc1$export$470bef71e654b804);
$parcel$export(module.exports, "assignParent", () => $90e2b276351fabc1$export$a4685923af2913a);
const $90e2b276351fabc1$export$470bef71e654b804 = ()=>[];
const $90e2b276351fabc1$export$a4685923af2913a = (node)=>{
    node.getChildren().forEach((child)=>{
        child.parent = node;
    });
};

});


parcelRegister("awXvh", function(module, exports) {

$parcel$export(module.exports, "compoundClause", () => $3e337dfb3ad8a3f8$export$ab714e56a32c25f2);
$parcel$export(module.exports, "compoundClauseInternal", () => $3e337dfb3ad8a3f8$export$cd65eed8c10b0911);


var $3AraL = parcelRequire("3AraL");

var $WCvOq = parcelRequire("WCvOq");
function $3e337dfb3ad8a3f8$var$acceptCompoundClause(visitor) {
    return visitor.visitCompoundClause ? visitor.visitCompoundClause(this) : visitor.visitChildren(this);
}
function $3e337dfb3ad8a3f8$var$enterNode(listener) {
    listener.enterCompoundClause && listener.enterCompoundClause(this);
}
function $3e337dfb3ad8a3f8$var$exitNode(listener) {
    listener.exitCompoundClause && listener.exitCompoundClause(this);
}
function $3e337dfb3ad8a3f8$var$getChildren() {
    return [
        this.operator,
        ...this.clauses
    ];
}
const $3e337dfb3ad8a3f8$export$ab714e56a32c25f2 = (operator, clauses)=>{
    return $3e337dfb3ad8a3f8$export$cd65eed8c10b0911(operator, clauses);
};
const $3e337dfb3ad8a3f8$export$cd65eed8c10b0911 = (operator, clauses, position = null)=>{
    const node = {
        type: (0, $c1dc40b7a30d95e8$export$2d205682cc545947),
        clauseType: (0, $e9a0ef16a223cbc7$export$7a58b23488ea076b),
        operator: operator,
        clauses: clauses,
        position: position,
        accept: $3e337dfb3ad8a3f8$var$acceptCompoundClause,
        enterNode: $3e337dfb3ad8a3f8$var$enterNode,
        exitNode: $3e337dfb3ad8a3f8$var$exitNode,
        getChildren: $3e337dfb3ad8a3f8$var$getChildren,
        parent: null,
        appendClause: $3AraL.appendClause,
        remove: $3AraL.remove,
        removeClause: $3AraL.removeClause,
        replace: $3AraL.replace,
        replaceClause: $3AraL.replaceClause
    };
    (0, $WCvOq.assignParent)(node);
    return node;
};

});
const $c1dc40b7a30d95e8$export$98dda21ec825792 = 'query';
const $c1dc40b7a30d95e8$export$2d205682cc545947 = 'clause';
const $c1dc40b7a30d95e8$export$d2f212d8ddbc8d1d = 'operand';
const $c1dc40b7a30d95e8$export$da0f73edded4a63d = 'order_by';

parcelRegister("3AraL", function(module, exports) {

$parcel$export(module.exports, "appendClause", () => appendClause);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceClause", () => replaceClause);


var $WCvOq = parcelRequire("WCvOq");
function appendClause(clause) {
    let clausesToAppend = [
        clause
    ];
    // If the clause to append is compound with a matching operator then we flatten it into the current clause
    if (clause.clauseType === (0, $e9a0ef16a223cbc7$export$7a58b23488ea076b) && clause.operator.value === this.operator.value) clausesToAppend = clause.clauses;
    this.clauses.push(...clausesToAppend);
    (0, $WCvOq.assignParent)(this);
}
function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function removeClause(clause) {
    this.clauses = this.clauses.filter((val)=>val !== clause);
    if (this.clauses.length === 1) this.replace(this.clauses[0]);
    else if (this.clauses.length === 0) this.remove();
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}
function replaceClause(clause, nextClause) {
    this.clauses = this.clauses.map((child)=>{
        return child === clause ? nextClause : child;
    });
    (0, $WCvOq.assignParent)(this);
}

});


parcelRegister("3hoxA", function(module, exports) {

$parcel$export(module.exports, "compoundOperator", () => $fe3f499b83b55a64$export$84bb3ebbba491aee);
$parcel$export(module.exports, "compoundOperatorInternal", () => $fe3f499b83b55a64$export$63c33bc3fe74fee6);

var $WCvOq = parcelRequire("WCvOq");
function $fe3f499b83b55a64$var$acceptCompoundOperator(visitor) {
    return visitor.visitCompoundOperator ? visitor.visitCompoundOperator(this) : visitor.visitChildren(this);
}
function $fe3f499b83b55a64$var$enterNode(listener) {
    listener.enterCompoundOperator && listener.enterCompoundOperator(this);
}
function $fe3f499b83b55a64$var$exitNode(listener) {
    listener.exitCompoundOperator && listener.exitCompoundOperator(this);
}
const $fe3f499b83b55a64$export$84bb3ebbba491aee = (value)=>$fe3f499b83b55a64$export$63c33bc3fe74fee6(value, []);
const $fe3f499b83b55a64$export$63c33bc3fe74fee6 = (value, operatorPositions)=>({
        value: value,
        positions: operatorPositions,
        position: null,
        accept: $fe3f499b83b55a64$var$acceptCompoundOperator,
        enterNode: $fe3f499b83b55a64$var$enterNode,
        exitNode: $fe3f499b83b55a64$var$exitNode,
        getChildren: (0, $WCvOq.noChildren),
        parent: null
    });

});

parcelRegister("2TUEL", function(module, exports) {

$parcel$export(module.exports, "field", () => $1c31156a69528c72$export$e0f35d825088c098);
$parcel$export(module.exports, "fieldInternal", () => $1c31156a69528c72$export$2193f8c541622b6);

var $2lgiK = parcelRequire("2lgiK");

var $WCvOq = parcelRequire("WCvOq");
function $1c31156a69528c72$var$acceptField(visitor) {
    return visitor.visitField ? visitor.visitField(this) : visitor.visitChildren(this);
}
function $1c31156a69528c72$var$enterNode(listener) {
    listener.enterField && listener.enterField(this);
}
function $1c31156a69528c72$var$exitNode(listener) {
    listener.exitField && listener.exitField(this);
}
function $1c31156a69528c72$var$getChildren() {
    return this.properties ? [
        ...this.properties
    ] : [];
}
const $1c31156a69528c72$export$e0f35d825088c098 = (value, properties)=>{
    return $1c31156a69528c72$export$2193f8c541622b6(value, (0, $2lgiK.sanitiseJqlString)(value), properties);
};
const $1c31156a69528c72$export$2193f8c541622b6 = (value, text, properties, position = null)=>{
    const node = {
        text: text,
        value: value,
        properties: properties,
        position: position,
        accept: $1c31156a69528c72$var$acceptField,
        enterNode: $1c31156a69528c72$var$enterNode,
        exitNode: $1c31156a69528c72$var$exitNode,
        getChildren: $1c31156a69528c72$var$getChildren,
        parent: null
    };
    (0, $WCvOq.assignParent)(node);
    return node;
};

});

parcelRegister("9TMIk", function(module, exports) {

$parcel$export(module.exports, "functionOperand", () => $413f1d947acf321b$export$4f981b0e83488ce);
$parcel$export(module.exports, "functionOperandInternal", () => $413f1d947acf321b$export$c1f2ce91dc05872a);


var $WCvOq = parcelRequire("WCvOq");
function $413f1d947acf321b$var$acceptFunctionOperand(visitor) {
    return visitor.visitFunctionOperand ? visitor.visitFunctionOperand(this) : visitor.visitChildren(this);
}
function $413f1d947acf321b$var$enterNode(listener) {
    listener.enterFunctionOperand && listener.enterFunctionOperand(this);
}
function $413f1d947acf321b$var$exitNode(listener) {
    listener.exitFunctionOperand && listener.exitFunctionOperand(this);
}
function $413f1d947acf321b$var$getChildren() {
    return [
        this.function,
        ...this.arguments
    ];
}
const $413f1d947acf321b$export$4f981b0e83488ce = (functionString, args = [])=>$413f1d947acf321b$export$c1f2ce91dc05872a(functionString, args);
const $413f1d947acf321b$export$c1f2ce91dc05872a = (functionString, args, position = null)=>{
    const node = {
        type: (0, $c1dc40b7a30d95e8$export$d2f212d8ddbc8d1d),
        operandType: (0, $49b29ef7baa2a152$export$19c7c729db381f9d),
        function: functionString,
        arguments: args,
        position: position,
        accept: $413f1d947acf321b$var$acceptFunctionOperand,
        enterNode: $413f1d947acf321b$var$enterNode,
        exitNode: $413f1d947acf321b$var$exitNode,
        getChildren: $413f1d947acf321b$var$getChildren,
        parent: null
    };
    (0, $WCvOq.assignParent)(node);
    return node;
};

});
const $49b29ef7baa2a152$export$38accfc5a5d1c113 = 'value';
const $49b29ef7baa2a152$export$f6049126fd97001f = 'keyword';
const $49b29ef7baa2a152$export$19c7c729db381f9d = 'function';
const $49b29ef7baa2a152$export$fabec4aebba3f4df = 'list';
const $49b29ef7baa2a152$export$1c46dca02aac24dd = 'empty';


parcelRegister("23cr9", function(module, exports) {

$parcel$export(module.exports, "functionString", () => $a67350f9199f98c5$export$4e1bb9a7ff8d0ef9);
$parcel$export(module.exports, "functionStringInternal", () => $a67350f9199f98c5$export$7aa9944588b7a69f);

var $2lgiK = parcelRequire("2lgiK");

var $WCvOq = parcelRequire("WCvOq");
function $a67350f9199f98c5$var$acceptFunctionString(visitor) {
    return visitor.visitFunction ? visitor.visitFunction(this) : visitor.visitChildren(this);
}
function $a67350f9199f98c5$var$enterNode(listener) {
    listener.enterFunction && listener.enterFunction(this);
}
function $a67350f9199f98c5$var$exitNode(listener) {
    listener.exitFunction && listener.exitFunction(this);
}
const $a67350f9199f98c5$export$4e1bb9a7ff8d0ef9 = (value)=>$a67350f9199f98c5$export$7aa9944588b7a69f(value, (0, $2lgiK.sanitiseJqlString)(value));
const $a67350f9199f98c5$export$7aa9944588b7a69f = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $a67350f9199f98c5$var$acceptFunctionString,
        enterNode: $a67350f9199f98c5$var$enterNode,
        exitNode: $a67350f9199f98c5$var$exitNode,
        getChildren: (0, $WCvOq.noChildren),
        parent: null
    });

});

parcelRegister("an0VC", function(module, exports) {

$parcel$export(module.exports, "jast", () => $99ec58cecea09c23$export$b9e70a00f479ff43);
const $99ec58cecea09c23$export$b9e70a00f479ff43 = (query, represents = '', errors = [])=>({
        query: query,
        represents: represents,
        errors: errors
    });

});

parcelRegister("kO6UE", function(module, exports) {

$parcel$export(module.exports, "keywordOperand", () => $374a6d53e0ec4f5c$export$2edd4971ed69f2ce);
$parcel$export(module.exports, "keywordOperandInternal", () => $374a6d53e0ec4f5c$export$7cc55480b054047b);


var $WCvOq = parcelRequire("WCvOq");
function $374a6d53e0ec4f5c$var$acceptKeywordOperand(visitor) {
    return visitor.visitKeywordOperand ? visitor.visitKeywordOperand(this) : visitor.visitChildren(this);
}
function $374a6d53e0ec4f5c$var$enterNode(listener) {
    listener.enterKeywordOperand && listener.enterKeywordOperand(this);
}
function $374a6d53e0ec4f5c$var$exitNode(listener) {
    listener.exitKeywordOperand && listener.exitKeywordOperand(this);
}
const $374a6d53e0ec4f5c$export$2edd4971ed69f2ce = ()=>$374a6d53e0ec4f5c$export$7cc55480b054047b((0, $49b29ef7baa2a152$export$1c46dca02aac24dd));
const $374a6d53e0ec4f5c$export$7cc55480b054047b = (value, position = null)=>({
        type: (0, $c1dc40b7a30d95e8$export$d2f212d8ddbc8d1d),
        operandType: (0, $49b29ef7baa2a152$export$f6049126fd97001f),
        value: value,
        position: position,
        accept: $374a6d53e0ec4f5c$var$acceptKeywordOperand,
        enterNode: $374a6d53e0ec4f5c$var$enterNode,
        exitNode: $374a6d53e0ec4f5c$var$exitNode,
        getChildren: (0, $WCvOq.noChildren),
        parent: null
    });

});

parcelRegister("AZ9nU", function(module, exports) {

$parcel$export(module.exports, "listOperand", () => $c52de47ddabd701d$export$769866c3e9d41d50);
$parcel$export(module.exports, "listOperandInternal", () => $c52de47ddabd701d$export$663c7831528c984b);


var $eDTUO = parcelRequire("eDTUO");

var $WCvOq = parcelRequire("WCvOq");
function $c52de47ddabd701d$var$acceptListOperand(visitor) {
    return visitor.visitListOperand ? visitor.visitListOperand(this) : visitor.visitChildren(this);
}
function $c52de47ddabd701d$var$enterNode(listener) {
    listener.enterListOperand && listener.enterListOperand(this);
}
function $c52de47ddabd701d$var$exitNode(listener) {
    listener.exitListOperand && listener.exitListOperand(this);
}
function $c52de47ddabd701d$var$getChildren() {
    return [
        ...this.values
    ];
}
const $c52de47ddabd701d$export$769866c3e9d41d50 = (values)=>$c52de47ddabd701d$export$663c7831528c984b(values);
const $c52de47ddabd701d$export$663c7831528c984b = (values, position = null)=>{
    const node = {
        type: (0, $c1dc40b7a30d95e8$export$d2f212d8ddbc8d1d),
        operandType: (0, $49b29ef7baa2a152$export$fabec4aebba3f4df),
        values: values,
        position: position,
        accept: $c52de47ddabd701d$var$acceptListOperand,
        enterNode: $c52de47ddabd701d$var$enterNode,
        exitNode: $c52de47ddabd701d$var$exitNode,
        getChildren: $c52de47ddabd701d$var$getChildren,
        parent: null,
        appendOperand: $eDTUO.appendOperand
    };
    (0, $WCvOq.assignParent)(node);
    return node;
};

});
parcelRegister("eDTUO", function(module, exports) {

$parcel$export(module.exports, "appendOperand", () => $9a86be0ad84d7cf1$export$d94c54f1aee177c4);


var $WCvOq = parcelRequire("WCvOq");
function $9a86be0ad84d7cf1$export$d94c54f1aee177c4(operand) {
    this.values.push(...operand.operandType === (0, $49b29ef7baa2a152$export$fabec4aebba3f4df) ? operand.values : [
        operand
    ]);
    (0, $WCvOq.assignParent)(this);
}

});


parcelRegister("9HHq9", function(module, exports) {

$parcel$export(module.exports, "notClause", () => $ed106cb5124eff4e$export$b4734a9fedb4d44e);
$parcel$export(module.exports, "notClauseInternal", () => $ed106cb5124eff4e$export$b25621824fea4548);


var $fjrwK = parcelRequire("fjrwK");

var $WCvOq = parcelRequire("WCvOq");

var $6qN6D = parcelRequire("6qN6D");
function $ed106cb5124eff4e$var$acceptNotClause(visitor) {
    return visitor.visitNotClause ? visitor.visitNotClause(this) : visitor.visitChildren(this);
}
function $ed106cb5124eff4e$var$enterNode(listener) {
    listener.enterNotClause && listener.enterNotClause(this);
}
function $ed106cb5124eff4e$var$exitNode(listener) {
    listener.exitNotClause && listener.exitNotClause(this);
}
function $ed106cb5124eff4e$var$getChildren() {
    return [
        this.operator,
        this.clause
    ];
}
const $ed106cb5124eff4e$export$b4734a9fedb4d44e = (clause)=>{
    return $ed106cb5124eff4e$export$b25621824fea4548(clause, (0, $6qN6D.notClauseOperator)());
};
const $ed106cb5124eff4e$export$b25621824fea4548 = (clause, operator, position = null)=>{
    const node = {
        type: (0, $c1dc40b7a30d95e8$export$2d205682cc545947),
        clauseType: (0, $e9a0ef16a223cbc7$export$e356b89f8c8d2fcb),
        clause: clause,
        operator: operator,
        position: position,
        accept: $ed106cb5124eff4e$var$acceptNotClause,
        enterNode: $ed106cb5124eff4e$var$enterNode,
        exitNode: $ed106cb5124eff4e$var$exitNode,
        getChildren: $ed106cb5124eff4e$var$getChildren,
        parent: null,
        remove: $fjrwK.remove,
        removeClause: $fjrwK.removeClause,
        replace: $fjrwK.replace,
        replaceClause: $fjrwK.replaceClause
    };
    (0, $WCvOq.assignParent)(node);
    return node;
};

});
parcelRegister("fjrwK", function(module, exports) {

$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceClause", () => replaceClause);

var $WCvOq = parcelRequire("WCvOq");
function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function removeClause(clause) {
    if (this.clause === clause) this.remove();
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}
function replaceClause(clause, nextClause) {
    if (this.clause === clause) {
        this.clause = nextClause;
        (0, $WCvOq.assignParent)(this);
    }
}

});

parcelRegister("6qN6D", function(module, exports) {

$parcel$export(module.exports, "notClauseOperator", () => $467f41c633037180$export$d2cd8239f99c13d3);
$parcel$export(module.exports, "notClauseOperatorInternal", () => $467f41c633037180$export$1b15a32bb57b9020);

var $bzbto = parcelRequire("bzbto");

var $WCvOq = parcelRequire("WCvOq");
function $467f41c633037180$var$acceptNotClauseOperator(visitor) {
    return visitor.visitNotClauseOperator ? visitor.visitNotClauseOperator(this) : visitor.visitChildren(this);
}
function $467f41c633037180$var$enterNode(listener) {
    listener.enterNotClauseOperator && listener.enterNotClauseOperator(this);
}
function $467f41c633037180$var$exitNode(listener) {
    listener.exitNotClauseOperator && listener.exitNotClauseOperator(this);
}
const $467f41c633037180$export$d2cd8239f99c13d3 = ()=>$467f41c633037180$export$1b15a32bb57b9020();
const $467f41c633037180$export$1b15a32bb57b9020 = (position = null)=>({
        value: (0, $bzbto.CLAUSE_OPERATOR_NOT),
        position: position,
        accept: $467f41c633037180$var$acceptNotClauseOperator,
        enterNode: $467f41c633037180$var$enterNode,
        exitNode: $467f41c633037180$var$exitNode,
        getChildren: (0, $WCvOq.noChildren),
        parent: null
    });

});
parcelRegister("bzbto", function(module, exports) {

$parcel$export(module.exports, "CLAUSE_OPERATOR_NOT", () => $bee8c61d429e7e04$export$c6c71ceedb15cda9);
$parcel$export(module.exports, "OPERATOR_EQUALS", () => $bee8c61d429e7e04$export$466517a888d00195);
$parcel$export(module.exports, "OPERATOR_NOT_EQUALS", () => $bee8c61d429e7e04$export$6d0d8810623974a5);
$parcel$export(module.exports, "OPERATOR_GT", () => $bee8c61d429e7e04$export$bcbb090ab3c498b3);
$parcel$export(module.exports, "OPERATOR_LT", () => $bee8c61d429e7e04$export$4bf1a4aa659c6ea4);
$parcel$export(module.exports, "OPERATOR_GT_EQUALS", () => $bee8c61d429e7e04$export$83ce674214a54b2a);
$parcel$export(module.exports, "OPERATOR_LT_EQUALS", () => $bee8c61d429e7e04$export$9629fd1727ef62ee);
$parcel$export(module.exports, "OPERATOR_IN", () => $bee8c61d429e7e04$export$c4e3fb55e320e979);
$parcel$export(module.exports, "OPERATOR_NOT_IN", () => $bee8c61d429e7e04$export$f9857532eaa24ddc);
$parcel$export(module.exports, "OPERATOR_LIKE", () => $bee8c61d429e7e04$export$221595834b8766ab);
$parcel$export(module.exports, "OPERATOR_NOT_LIKE", () => $bee8c61d429e7e04$export$fcefabf94a9bffbf);
$parcel$export(module.exports, "OPERATOR_IS", () => $bee8c61d429e7e04$export$4feeb3f4ff56bcef);
$parcel$export(module.exports, "OPERATOR_IS_NOT", () => $bee8c61d429e7e04$export$d08d969a0da27188);
$parcel$export(module.exports, "OPERATOR_WAS", () => $bee8c61d429e7e04$export$8f907e179985256d);
$parcel$export(module.exports, "OPERATOR_WAS_IN", () => $bee8c61d429e7e04$export$cc7b9d0b3ee23193);
$parcel$export(module.exports, "OPERATOR_WAS_NOT_IN", () => $bee8c61d429e7e04$export$585d3c004af078bb);
$parcel$export(module.exports, "OPERATOR_WAS_NOT", () => $bee8c61d429e7e04$export$123eaa9ccc2d9445);
$parcel$export(module.exports, "OPERATOR_CHANGED", () => $bee8c61d429e7e04$export$15f5b446ba8c941e);
$parcel$export(module.exports, "EQUALS_OPERATORS", () => $bee8c61d429e7e04$export$643c6101f3fc8547);
$parcel$export(module.exports, "LIKE_OPERATORS", () => $bee8c61d429e7e04$export$329664c9cf18cca6);
$parcel$export(module.exports, "COMPARISON_OPERATORS", () => $bee8c61d429e7e04$export$1b167a3705885a8b);
$parcel$export(module.exports, "IN_OPERATORS", () => $bee8c61d429e7e04$export$f25cf16c2270312f);
$parcel$export(module.exports, "IS_OPERATORS", () => $bee8c61d429e7e04$export$eb58cfffe4a6b805);
$parcel$export(module.exports, "WAS_OPERATORS", () => $bee8c61d429e7e04$export$c22a981f581de218);
$parcel$export(module.exports, "WAS_IN_OPERATORS", () => $bee8c61d429e7e04$export$6d08c4699bb75284);
$parcel$export(module.exports, "CHANGED_OPERATORS", () => $bee8c61d429e7e04$export$b7dc214eef214c1c);
$parcel$export(module.exports, "OPERATORS", () => $bee8c61d429e7e04$export$184799fc79ccac89);
$parcel$export(module.exports, "LIST_OPERATORS", () => $bee8c61d429e7e04$export$77c793736847e030);
const $bee8c61d429e7e04$export$c6c71ceedb15cda9 = 'not';
const $bee8c61d429e7e04$export$466517a888d00195 = '=';
const $bee8c61d429e7e04$export$6d0d8810623974a5 = '!=';
const $bee8c61d429e7e04$export$bcbb090ab3c498b3 = '>';
const $bee8c61d429e7e04$export$4bf1a4aa659c6ea4 = '<';
const $bee8c61d429e7e04$export$83ce674214a54b2a = '>=';
const $bee8c61d429e7e04$export$9629fd1727ef62ee = '<=';
const $bee8c61d429e7e04$export$c4e3fb55e320e979 = 'in';
const $bee8c61d429e7e04$export$f9857532eaa24ddc = 'not in';
const $bee8c61d429e7e04$export$221595834b8766ab = '~';
const $bee8c61d429e7e04$export$fcefabf94a9bffbf = '!~';
const $bee8c61d429e7e04$export$4feeb3f4ff56bcef = 'is';
const $bee8c61d429e7e04$export$d08d969a0da27188 = 'is not';
const $bee8c61d429e7e04$export$8f907e179985256d = 'was';
const $bee8c61d429e7e04$export$cc7b9d0b3ee23193 = 'was in';
const $bee8c61d429e7e04$export$585d3c004af078bb = 'was not in';
const $bee8c61d429e7e04$export$123eaa9ccc2d9445 = 'was not';
const $bee8c61d429e7e04$export$15f5b446ba8c941e = 'changed';
const $bee8c61d429e7e04$export$643c6101f3fc8547 = [
    $bee8c61d429e7e04$export$466517a888d00195,
    $bee8c61d429e7e04$export$6d0d8810623974a5
];
const $bee8c61d429e7e04$export$329664c9cf18cca6 = [
    $bee8c61d429e7e04$export$221595834b8766ab,
    $bee8c61d429e7e04$export$fcefabf94a9bffbf
];
const $bee8c61d429e7e04$export$1b167a3705885a8b = [
    $bee8c61d429e7e04$export$4bf1a4aa659c6ea4,
    $bee8c61d429e7e04$export$bcbb090ab3c498b3,
    $bee8c61d429e7e04$export$9629fd1727ef62ee,
    $bee8c61d429e7e04$export$83ce674214a54b2a
];
const $bee8c61d429e7e04$export$f25cf16c2270312f = [
    $bee8c61d429e7e04$export$c4e3fb55e320e979,
    $bee8c61d429e7e04$export$f9857532eaa24ddc
];
const $bee8c61d429e7e04$export$eb58cfffe4a6b805 = [
    $bee8c61d429e7e04$export$4feeb3f4ff56bcef,
    $bee8c61d429e7e04$export$d08d969a0da27188
];
const $bee8c61d429e7e04$export$c22a981f581de218 = [
    $bee8c61d429e7e04$export$8f907e179985256d,
    $bee8c61d429e7e04$export$123eaa9ccc2d9445
];
const $bee8c61d429e7e04$export$6d08c4699bb75284 = [
    $bee8c61d429e7e04$export$cc7b9d0b3ee23193,
    $bee8c61d429e7e04$export$585d3c004af078bb
];
const $bee8c61d429e7e04$export$b7dc214eef214c1c = [
    $bee8c61d429e7e04$export$15f5b446ba8c941e
];
const $bee8c61d429e7e04$export$184799fc79ccac89 = [
    ...$bee8c61d429e7e04$export$643c6101f3fc8547,
    ...$bee8c61d429e7e04$export$329664c9cf18cca6,
    ...$bee8c61d429e7e04$export$1b167a3705885a8b,
    ...$bee8c61d429e7e04$export$f25cf16c2270312f,
    ...$bee8c61d429e7e04$export$eb58cfffe4a6b805,
    ...$bee8c61d429e7e04$export$c22a981f581de218,
    ...$bee8c61d429e7e04$export$6d08c4699bb75284,
    ...$bee8c61d429e7e04$export$b7dc214eef214c1c
];
const $bee8c61d429e7e04$export$77c793736847e030 = [
    $bee8c61d429e7e04$export$c4e3fb55e320e979,
    $bee8c61d429e7e04$export$f9857532eaa24ddc,
    $bee8c61d429e7e04$export$cc7b9d0b3ee23193,
    $bee8c61d429e7e04$export$585d3c004af078bb
];

});



parcelRegister("3J4gf", function(module, exports) {

$parcel$export(module.exports, "operator", () => $6fd03a148f63af84$export$dbd72860f701d4f3);
$parcel$export(module.exports, "operatorInternal", () => $6fd03a148f63af84$export$649025bc60ab9c3b);

var $WCvOq = parcelRequire("WCvOq");
function $6fd03a148f63af84$var$acceptOperator(visitor) {
    return visitor.visitOperator ? visitor.visitOperator(this) : visitor.visitChildren(this);
}
function $6fd03a148f63af84$var$enterNode(listener) {
    listener.enterOperator && listener.enterOperator(this);
}
function $6fd03a148f63af84$var$exitNode(listener) {
    listener.exitOperator && listener.exitOperator(this);
}
const $6fd03a148f63af84$export$dbd72860f701d4f3 = (value)=>$6fd03a148f63af84$export$649025bc60ab9c3b(value, value);
const $6fd03a148f63af84$export$649025bc60ab9c3b = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $6fd03a148f63af84$var$acceptOperator,
        enterNode: $6fd03a148f63af84$var$enterNode,
        exitNode: $6fd03a148f63af84$var$exitNode,
        getChildren: (0, $WCvOq.noChildren),
        parent: null
    });

});

parcelRegister("her2D", function(module, exports) {

$parcel$export(module.exports, "orderBy", () => $37cf08d9a2045c25$export$f18af21d6f4dafd8);
$parcel$export(module.exports, "orderByInternal", () => $37cf08d9a2045c25$export$e4eb1fa6bc8465c1);


var $5HQt3 = parcelRequire("5HQt3");

var $WCvOq = parcelRequire("WCvOq");

var $k9DKN = parcelRequire("k9DKN");
function $37cf08d9a2045c25$var$acceptOrderBy(visitor) {
    return visitor.visitOrderBy ? visitor.visitOrderBy(this) : visitor.visitChildren(this);
}
function $37cf08d9a2045c25$var$enterNode(listener) {
    listener.enterOrderBy && listener.enterOrderBy(this);
}
function $37cf08d9a2045c25$var$exitNode(listener) {
    listener.exitOrderBy && listener.exitOrderBy(this);
}
function $37cf08d9a2045c25$var$getChildren() {
    return [
        this.operator,
        ...this.fields
    ];
}
const $37cf08d9a2045c25$export$f18af21d6f4dafd8 = (fields)=>{
    return $37cf08d9a2045c25$export$e4eb1fa6bc8465c1(fields, (0, $k9DKN.orderByOperator)());
};
const $37cf08d9a2045c25$export$e4eb1fa6bc8465c1 = (fields, operator, position = null)=>{
    const node = {
        type: (0, $c1dc40b7a30d95e8$export$da0f73edded4a63d),
        operator: operator,
        fields: fields,
        position: position,
        accept: $37cf08d9a2045c25$var$acceptOrderBy,
        enterNode: $37cf08d9a2045c25$var$enterNode,
        exitNode: $37cf08d9a2045c25$var$exitNode,
        getChildren: $37cf08d9a2045c25$var$getChildren,
        parent: null,
        prependOrderField: $5HQt3.prependOrderField,
        setOrderDirection: $5HQt3.setOrderDirection,
        replace: $5HQt3.replace,
        replaceOrderField: $5HQt3.replaceOrderField,
        remove: $5HQt3.remove,
        removeOrderField: $5HQt3.removeOrderField
    };
    (0, $WCvOq.assignParent)(node);
    return node;
};

});
parcelRegister("5HQt3", function(module, exports) {

$parcel$export(module.exports, "prependOrderField", () => prependOrderField);
$parcel$export(module.exports, "setOrderDirection", () => setOrderDirection);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceOrderField", () => replaceOrderField);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeOrderField", () => removeOrderField);

var $WCvOq = parcelRequire("WCvOq");
function prependOrderField(orderField) {
    this.fields.unshift(orderField);
    (0, $WCvOq.assignParent)(this);
}
function setOrderDirection(orderDirection) {
    if (this.fields.length > 0) this.fields[0].setOrderDirection(orderDirection);
}
function replace(nextOrderBy) {
    if (this.parent) this.parent.replaceOrderBy(nextOrderBy);
}
function replaceOrderField(orderByField, nextOrderByField) {
    this.fields = this.fields.map((child)=>{
        return child === orderByField ? nextOrderByField : child;
    });
    (0, $WCvOq.assignParent)(this);
}
function remove() {
    if (this.parent) this.parent.removeOrderBy();
}
function removeOrderField(orderByField) {
    this.fields = this.fields.filter((field)=>field !== orderByField);
    if (this.fields.length === 0) this.remove();
}

});

parcelRegister("k9DKN", function(module, exports) {

$parcel$export(module.exports, "orderByOperator", () => $0824f859de091a85$export$c7307b67924c61ea);
$parcel$export(module.exports, "orderByOperatorInternal", () => $0824f859de091a85$export$739e30af23a08da0);


var $WCvOq = parcelRequire("WCvOq");
function $0824f859de091a85$var$acceptOrderByOperator(visitor) {
    return visitor.visitOrderByOperator ? visitor.visitOrderByOperator(this) : visitor.visitChildren(this);
}
function $0824f859de091a85$var$enterNode(listener) {
    listener.enterOrderByOperator && listener.enterOrderByOperator(this);
}
function $0824f859de091a85$var$exitNode(listener) {
    listener.exitOrderByOperator && listener.exitOrderByOperator(this);
}
const $0824f859de091a85$export$c7307b67924c61ea = ()=>$0824f859de091a85$export$739e30af23a08da0();
const $0824f859de091a85$export$739e30af23a08da0 = (position = null)=>({
        value: (0, $9f1dbb2b39d4d9a2$export$ca51f5fd60a74517),
        position: position,
        accept: $0824f859de091a85$var$acceptOrderByOperator,
        enterNode: $0824f859de091a85$var$enterNode,
        exitNode: $0824f859de091a85$var$exitNode,
        getChildren: (0, $WCvOq.noChildren),
        parent: null
    });

});
const $9f1dbb2b39d4d9a2$export$ca51f5fd60a74517 = 'ORDER BY';
const $9f1dbb2b39d4d9a2$export$6d60017b9e092e73 = 'ASC';
const $9f1dbb2b39d4d9a2$export$2ea27ea5f2121899 = 'DESC';



parcelRegister("j37YY", function(module, exports) {

$parcel$export(module.exports, "orderByDirection", () => $c155c373ff42c873$export$864d934efed3ccaa);
$parcel$export(module.exports, "orderByDirectionInternal", () => $c155c373ff42c873$export$8c65cac1a7852d1f);

var $WCvOq = parcelRequire("WCvOq");
function $c155c373ff42c873$var$acceptOrderByDirection(visitor) {
    return visitor.visitOrderByDirection ? visitor.visitOrderByDirection(this) : visitor.visitChildren(this);
}
function $c155c373ff42c873$var$enterNode(listener) {
    listener.enterOrderByDirection && listener.enterOrderByDirection(this);
}
function $c155c373ff42c873$var$exitNode(listener) {
    listener.exitOrderByDirection && listener.exitOrderByDirection(this);
}
const $c155c373ff42c873$export$864d934efed3ccaa = (value)=>$c155c373ff42c873$export$8c65cac1a7852d1f(value);
const $c155c373ff42c873$export$8c65cac1a7852d1f = (value, position = null)=>({
        value: value,
        position: position,
        accept: $c155c373ff42c873$var$acceptOrderByDirection,
        enterNode: $c155c373ff42c873$var$enterNode,
        exitNode: $c155c373ff42c873$var$exitNode,
        getChildren: (0, $WCvOq.noChildren),
        parent: null
    });

});

parcelRegister("doe2p", function(module, exports) {

$parcel$export(module.exports, "orderByField", () => $b5422aff91034201$export$942df63e5e3d3899);
$parcel$export(module.exports, "orderByFieldInternal", () => $b5422aff91034201$export$661a7786e3d15926);

var $g2iOq = parcelRequire("g2iOq");

var $WCvOq = parcelRequire("WCvOq");
function $b5422aff91034201$var$acceptOrderByField(visitor) {
    return visitor.visitOrderByField ? visitor.visitOrderByField(this) : visitor.visitChildren(this);
}
function $b5422aff91034201$var$enterNode(listener) {
    listener.enterOrderByField && listener.enterOrderByField(this);
}
function $b5422aff91034201$var$exitNode(listener) {
    listener.exitOrderByField && listener.exitOrderByField(this);
}
function $b5422aff91034201$var$getChildren() {
    const children = [
        this.field
    ];
    if (this.direction) children.push(this.direction);
    return children;
}
const $b5422aff91034201$export$942df63e5e3d3899 = (field, direction)=>$b5422aff91034201$export$661a7786e3d15926(field, direction);
const $b5422aff91034201$export$661a7786e3d15926 = (field, direction, position = null)=>{
    const node = {
        field: field,
        direction: direction,
        position: position,
        accept: $b5422aff91034201$var$acceptOrderByField,
        enterNode: $b5422aff91034201$var$enterNode,
        exitNode: $b5422aff91034201$var$exitNode,
        getChildren: $b5422aff91034201$var$getChildren,
        parent: null,
        setOrderDirection: $g2iOq.setOrderDirection,
        replace: $g2iOq.replace,
        remove: $g2iOq.remove
    };
    (0, $WCvOq.assignParent)(node);
    return node;
};

});
parcelRegister("g2iOq", function(module, exports) {

$parcel$export(module.exports, "setOrderDirection", () => $27f36e283e6ff201$export$b596730931a09703);
$parcel$export(module.exports, "replace", () => $27f36e283e6ff201$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "remove", () => $27f36e283e6ff201$export$cd7f480d6b8286c3);

var $WCvOq = parcelRequire("WCvOq");
function $27f36e283e6ff201$export$b596730931a09703(orderDirection) {
    this.direction = orderDirection;
    (0, $WCvOq.assignParent)(this);
}
function $27f36e283e6ff201$export$77ad94ebf1c2b9ed(orderByField) {
    if (this.parent) this.parent.replaceOrderField(this, orderByField);
}
function $27f36e283e6ff201$export$cd7f480d6b8286c3() {
    if (this.parent) this.parent.removeOrderField(this);
}

});


parcelRegister("jRA9z", function(module, exports) {

$parcel$export(module.exports, "predicate", () => $ff1c73953498b7ec$export$5fc51e445ce24faf);
$parcel$export(module.exports, "predicateInternal", () => $ff1c73953498b7ec$export$a767a27ad05a38a2);

var $WCvOq = parcelRequire("WCvOq");
function $ff1c73953498b7ec$var$acceptPredicate(visitor) {
    return visitor.visitPredicate ? visitor.visitPredicate(this) : visitor.visitChildren(this);
}
function $ff1c73953498b7ec$var$enterNode(listener) {
    listener.enterPredicate && listener.enterPredicate(this);
}
function $ff1c73953498b7ec$var$exitNode(listener) {
    listener.exitPredicate && listener.exitPredicate(this);
}
function $ff1c73953498b7ec$var$getChildren() {
    const children = [
        this.operator
    ];
    if (this.operand) children.push(this.operand);
    return children;
}
const $ff1c73953498b7ec$export$5fc51e445ce24faf = (operator, operand)=>$ff1c73953498b7ec$export$a767a27ad05a38a2(operator, operand);
const $ff1c73953498b7ec$export$a767a27ad05a38a2 = (operator, operand, position = null)=>{
    const node = {
        operator: operator,
        operand: operand,
        position: position,
        accept: $ff1c73953498b7ec$var$acceptPredicate,
        enterNode: $ff1c73953498b7ec$var$enterNode,
        exitNode: $ff1c73953498b7ec$var$exitNode,
        getChildren: $ff1c73953498b7ec$var$getChildren,
        parent: null
    };
    (0, $WCvOq.assignParent)(node);
    return node;
};

});

parcelRegister("bF1Nb", function(module, exports) {

$parcel$export(module.exports, "predicateOperator", () => $fb65b796ae9eab4e$export$5419b7f16910ea62);
$parcel$export(module.exports, "predicateOperatorInternal", () => $fb65b796ae9eab4e$export$c69d893689716768);

var $WCvOq = parcelRequire("WCvOq");
function $fb65b796ae9eab4e$var$acceptPredicateOperator(visitor) {
    return visitor.visitPredicateOperator ? visitor.visitPredicateOperator(this) : visitor.visitChildren(this);
}
function $fb65b796ae9eab4e$var$enterNode(listener) {
    listener.enterPredicateOperator && listener.enterPredicateOperator(this);
}
function $fb65b796ae9eab4e$var$exitNode(listener) {
    listener.exitPredicateOperator && listener.exitPredicateOperator(this);
}
const $fb65b796ae9eab4e$export$5419b7f16910ea62 = (value)=>$fb65b796ae9eab4e$export$c69d893689716768(value, value);
const $fb65b796ae9eab4e$export$c69d893689716768 = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $fb65b796ae9eab4e$var$acceptPredicateOperator,
        enterNode: $fb65b796ae9eab4e$var$enterNode,
        exitNode: $fb65b796ae9eab4e$var$exitNode,
        getChildren: (0, $WCvOq.noChildren),
        parent: null
    });

});

parcelRegister("bW5aY", function(module, exports) {

$parcel$export(module.exports, "property", () => $1f1ea1ef09d97bb3$export$d541bacb2bda4494);
$parcel$export(module.exports, "propertyInternal", () => $1f1ea1ef09d97bb3$export$1cbd90994fef1fad);

var $WCvOq = parcelRequire("WCvOq");
function $1f1ea1ef09d97bb3$var$acceptProperty(visitor) {
    return visitor.visitProperty ? visitor.visitProperty(this) : visitor.visitChildren(this);
}
function $1f1ea1ef09d97bb3$var$enterNode(listener) {
    listener.enterProperty && listener.enterProperty(this);
}
function $1f1ea1ef09d97bb3$var$exitNode(listener) {
    listener.exitProperty && listener.exitProperty(this);
}
function $1f1ea1ef09d97bb3$var$getChildren() {
    const children = [];
    if (this.key) children.push(this.key);
    if (this.path) return children.concat(this.path);
    return children;
}
const $1f1ea1ef09d97bb3$export$d541bacb2bda4494 = (key, path = [])=>$1f1ea1ef09d97bb3$export$1cbd90994fef1fad(key, path);
const $1f1ea1ef09d97bb3$export$1cbd90994fef1fad = (key, path, position = null)=>{
    const node = {
        key: key,
        path: path,
        position: position,
        accept: $1f1ea1ef09d97bb3$var$acceptProperty,
        enterNode: $1f1ea1ef09d97bb3$var$enterNode,
        exitNode: $1f1ea1ef09d97bb3$var$exitNode,
        getChildren: $1f1ea1ef09d97bb3$var$getChildren,
        parent: null
    };
    (0, $WCvOq.assignParent)(node);
    return node;
};

});

parcelRegister("dgZwd", function(module, exports) {

$parcel$export(module.exports, "query", () => $3aa450a0eb1b166a$export$2fa187e846a241c4);
$parcel$export(module.exports, "queryInternal", () => $3aa450a0eb1b166a$export$bc2d6e2e1fd9014);


var $aqdKa = parcelRequire("aqdKa");

var $WCvOq = parcelRequire("WCvOq");
/**
 * AstNode accept functions. We define them outside of the creator function so the same function reference is returned
 * when a creator is invoked multiple times (which is helpful when testing for equality of AST objects).
 */ function $3aa450a0eb1b166a$var$acceptQuery(visitor) {
    return visitor.visitQuery ? visitor.visitQuery(this) : visitor.visitChildren(this);
}
function $3aa450a0eb1b166a$var$enterNode(listener) {
    listener.enterQuery && listener.enterQuery(this);
}
function $3aa450a0eb1b166a$var$exitNode(listener) {
    listener.exitQuery && listener.exitQuery(this);
}
function $3aa450a0eb1b166a$var$getChildren() {
    const children = [];
    if (this.where) children.push(this.where);
    if (this.orderBy) children.push(this.orderBy);
    return children;
}
const $3aa450a0eb1b166a$export$2fa187e846a241c4 = (where, orderBy)=>$3aa450a0eb1b166a$export$bc2d6e2e1fd9014(where, orderBy);
const $3aa450a0eb1b166a$export$bc2d6e2e1fd9014 = (where, orderBy, position = null)=>{
    const node = {
        type: (0, $c1dc40b7a30d95e8$export$98dda21ec825792),
        where: where,
        orderBy: orderBy,
        position: position,
        accept: $3aa450a0eb1b166a$var$acceptQuery,
        enterNode: $3aa450a0eb1b166a$var$enterNode,
        exitNode: $3aa450a0eb1b166a$var$exitNode,
        getChildren: $3aa450a0eb1b166a$var$getChildren,
        parent: null,
        appendClause: $aqdKa.appendClause,
        prependOrderField: $aqdKa.prependOrderField,
        setOrderDirection: $aqdKa.setOrderDirection,
        removeClause: $aqdKa.removeClause,
        replaceClause: $aqdKa.replaceClause,
        replaceOrderBy: $aqdKa.replaceOrderBy,
        removeOrderBy: $aqdKa.removeOrderBy
    };
    (0, $WCvOq.assignParent)(node);
    return node;
};

});
parcelRegister("aqdKa", function(module, exports) {

$parcel$export(module.exports, "appendClause", () => appendClause);
$parcel$export(module.exports, "prependOrderField", () => prependOrderField);
$parcel$export(module.exports, "setOrderDirection", () => setOrderDirection);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replaceOrderBy", () => replaceOrderBy);
$parcel$export(module.exports, "replaceClause", () => replaceClause);
$parcel$export(module.exports, "removeOrderBy", () => removeOrderBy);

var $iEIQF = parcelRequire("iEIQF");

var $WCvOq = parcelRequire("WCvOq");
function appendClause(clause, compoundOperatorValue) {
    if (!this.where) this.where = clause;
    else {
        const nextCompoundOperator = (0, $iEIQF.default).compoundOperator(compoundOperatorValue);
        const nextClause = (0, $iEIQF.default).compoundClause(nextCompoundOperator, []);
        // Append previous and new clause which will flatten compound clauses with matching operators.
        nextClause.appendClause(this.where);
        nextClause.appendClause(clause);
        this.where = nextClause;
    }
    (0, $WCvOq.assignParent)(this);
}
function prependOrderField(orderField) {
    if (!this.orderBy) {
        this.orderBy = (0, $iEIQF.default).orderBy([
            orderField
        ]);
        (0, $WCvOq.assignParent)(this);
    } else this.orderBy.prependOrderField(orderField);
}
function setOrderDirection(orderDirection) {
    if (this.orderBy) this.orderBy.setOrderDirection(orderDirection);
}
function removeClause(clause) {
    if (this.where === clause) this.where = undefined;
}
function replaceOrderBy(orderBy) {
    if (orderBy && orderBy.fields.length === 0) this.removeOrderBy();
    else {
        this.orderBy = orderBy;
        (0, $WCvOq.assignParent)(this);
    }
}
function replaceClause(clause, nextClause) {
    if (this.where === clause) {
        this.where = nextClause;
        (0, $WCvOq.assignParent)(this);
    }
}
function removeOrderBy() {
    this.orderBy = undefined;
}

});


parcelRegister("1zQFd", function(module, exports) {

$parcel$export(module.exports, "terminalClause", () => $ad22ef70da25a752$export$2627cbe08dd86b00);
$parcel$export(module.exports, "terminalClauseInternal", () => $ad22ef70da25a752$export$cc08e43598d091fc);


var $b6t5q = parcelRequire("b6t5q");

var $WCvOq = parcelRequire("WCvOq");
function $ad22ef70da25a752$var$acceptTerminalClause(visitor) {
    return visitor.visitTerminalClause ? visitor.visitTerminalClause(this) : visitor.visitChildren(this);
}
function $ad22ef70da25a752$var$enterNode(listener) {
    listener.enterTerminalClause && listener.enterTerminalClause(this);
}
function $ad22ef70da25a752$var$exitNode(listener) {
    listener.exitTerminalClause && listener.exitTerminalClause(this);
}
function $ad22ef70da25a752$var$getChildren() {
    const children = [
        this.field
    ];
    if (this.operator) children.push(this.operator);
    if (this.operand) children.push(this.operand);
    return children.concat(this.predicates);
}
const $ad22ef70da25a752$export$2627cbe08dd86b00 = (field, operator, operand, predicates = [])=>{
    return $ad22ef70da25a752$export$cc08e43598d091fc(field, operator, operand, predicates);
};
const $ad22ef70da25a752$export$cc08e43598d091fc = (field, operator, operand, predicates, position = null)=>{
    const node = {
        type: (0, $c1dc40b7a30d95e8$export$2d205682cc545947),
        clauseType: (0, $e9a0ef16a223cbc7$export$ae56b4ef248a2b6a),
        field: field,
        operator: operator,
        operand: operand,
        predicates: predicates,
        position: position,
        accept: $ad22ef70da25a752$var$acceptTerminalClause,
        enterNode: $ad22ef70da25a752$var$enterNode,
        exitNode: $ad22ef70da25a752$var$exitNode,
        getChildren: $ad22ef70da25a752$var$getChildren,
        parent: null,
        setOperator: $b6t5q.setOperator,
        setOperand: $b6t5q.setOperand,
        appendOperand: $b6t5q.appendOperand,
        remove: $b6t5q.remove,
        replace: $b6t5q.replace
    };
    (0, $WCvOq.assignParent)(node);
    return node;
};

});
parcelRegister("b6t5q", function(module, exports) {

$parcel$export(module.exports, "setOperator", () => setOperator);
$parcel$export(module.exports, "setOperand", () => setOperand);
$parcel$export(module.exports, "appendOperand", () => appendOperand);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "replace", () => replace);


var $iEIQF = parcelRequire("iEIQF");

var $WCvOq = parcelRequire("WCvOq");
function setOperator(operator) {
    this.operator = operator;
    (0, $WCvOq.assignParent)(this);
}
function setOperand(operand) {
    this.operand = operand;
    (0, $WCvOq.assignParent)(this);
}
function appendOperand(operand) {
    if (this.operand) {
        if (this.operand.operandType === (0, $49b29ef7baa2a152$export$fabec4aebba3f4df)) this.operand.appendOperand(operand);
        else this.setOperand((0, $iEIQF.default).listOperand([
            this.operand,
            ...operand.operandType === (0, $49b29ef7baa2a152$export$fabec4aebba3f4df) ? operand.values : [
                operand
            ]
        ]));
    } else this.setOperand(operand);
}
function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}

});


parcelRegister("eWV0u", function(module, exports) {

$parcel$export(module.exports, "valueOperand", () => $f1a80cb053576a13$export$2b6e4d2ed8d53bf3);
$parcel$export(module.exports, "valueOperandInternal", () => $f1a80cb053576a13$export$79c37d97caac8627);
$parcel$export(module.exports, "valueOperandByText", () => $f1a80cb053576a13$export$3ac9155bde56a45f);


var $gq4pj = parcelRequire("gq4pj");
var $2lgiK = parcelRequire("2lgiK");

var $WCvOq = parcelRequire("WCvOq");
function $f1a80cb053576a13$var$acceptValueOperand(visitor) {
    return visitor.visitValueOperand ? visitor.visitValueOperand(this) : visitor.visitChildren(this);
}
function $f1a80cb053576a13$var$enterNode(listener) {
    listener.enterValueOperand && listener.enterValueOperand(this);
}
function $f1a80cb053576a13$var$exitNode(listener) {
    listener.exitValueOperand && listener.exitValueOperand(this);
}
const $f1a80cb053576a13$export$2b6e4d2ed8d53bf3 = (value)=>$f1a80cb053576a13$export$79c37d97caac8627(value, (0, $2lgiK.sanitiseJqlString)(value));
const $f1a80cb053576a13$export$3ac9155bde56a45f = (text)=>$f1a80cb053576a13$export$79c37d97caac8627((0, $gq4pj.normaliseJqlString)(text), text);
const $f1a80cb053576a13$export$79c37d97caac8627 = (value, text, position = null)=>({
        type: (0, $c1dc40b7a30d95e8$export$d2f212d8ddbc8d1d),
        operandType: (0, $49b29ef7baa2a152$export$38accfc5a5d1c113),
        text: text,
        value: value,
        position: position,
        accept: $f1a80cb053576a13$var$acceptValueOperand,
        enterNode: $f1a80cb053576a13$var$enterNode,
        exitNode: $f1a80cb053576a13$var$exitNode,
        getChildren: (0, $WCvOq.noChildren),
        parent: null
    });

});


parcelRegister("eK6AG", function(module, exports) {

$parcel$export(module.exports, "JastBuilder", () => $ccc4ef92204502d2$export$99cae18a5a6ba8cf);

var $hCaMj = parcelRequire("hCaMj");

var $8QpSo = parcelRequire("8QpSo");

var $39War = parcelRequire("39War");
var $k9No4 = parcelRequire("k9No4");

var $iEIQF = parcelRequire("iEIQF");

var $lKjSa = parcelRequire("lKjSa");
var $k9iwN = parcelRequire("k9iwN");

var $bK3p2 = parcelRequire("bK3p2");
class $ccc4ef92204502d2$export$99cae18a5a6ba8cf {
    setErrorHandler(errorHandler) {
        this.errorHandler = errorHandler;
        return this;
    }
    setErrorListeners(errorListeners) {
        this.errorListeners = this.errorListeners.concat(errorListeners);
        return this;
    }
    build(value) {
        const tokens = this.getTokens(value);
        const parser = this.getParser(tokens);
        const astErrorListener = new (0, $lKjSa.JastBuilderErrorListener)();
        parser.removeErrorListeners();
        parser.addErrorListener(astErrorListener);
        this.errorListeners.forEach((errorListener)=>parser.addErrorListener(errorListener));
        if (this.errorHandler) {
            parser.errorHandler = this.errorHandler;
            this.errorHandler.reset(parser);
        }
        const visitor = new (0, $bK3p2.QueryVisitor)(tokens);
        try {
            const parseTree = parser.jqlQuery();
            const query = parseTree.accept(visitor);
            return (0, $iEIQF.default).jast(query, value, astErrorListener.errors);
        } catch (error) {
            return (0, $iEIQF.default).jast(undefined, value, [
                new (0, $k9iwN.JQLParseError)(error.message, error)
            ]);
        }
    }
    constructor(){
        this.errorListeners = [];
        this.errorHandler = undefined;
        this.getTokens = (0, $8QpSo.default)((value)=>{
            const chars = (0, $hCaMj.CharStreams).fromString(value);
            const lexer = new (0, $39War.JQLLexer)(chars);
            return new (0, $hCaMj.CommonTokenStream)(lexer);
        });
        this.getParser = (0, $8QpSo.default)((tokens)=>new (0, $k9No4.JQLParser)(tokens));
    }
}

});
parcelRegister("hCaMj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $cd2e58a1d1fa972f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cd2e58a1d1fa972f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $cd2e58a1d1fa972f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("fJ9SA")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("1lYFk")), module.exports);

// export * from "./ANTLRFileStream";
$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("g8XSE")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("b0kN8")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("1UkCC")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("QidO0")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("9NnFz")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("1Olk0")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("7ufNj")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("j53rr")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("gWaB3")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("a0nC0")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("e5mHr")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("4CCJj")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("4a3G0")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("5Poq6")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("ea0YW")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("iLUMi")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("5FrZ8")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("ceaEj")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("igNLf")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("gMbxO")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("fOEQQ")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("drCaH")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("hKCjP")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("jIG0W")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("2pQQd")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("dReoi")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("6bmaO")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("65iNZ")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("5xwgp")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("fLdDn")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("kBaAZ")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("c8jEe")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("77rdV")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("5IgvW")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("1ivK9")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("2DVsz")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("eftJA")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("9rAj4")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("5jPdD")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("dIykH")), module.exports);

// export * from "./UnbufferedCharStream";
// export * from "./UnbufferedTokenStream";
$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("1MVGg")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("3n2FE")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("6UcB4")), module.exports);

});
parcelRegister("fJ9SA", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("1lYFk", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("g8XSE", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ // ConvertTo-TS run at 2016-10-04T11:26:49.0828748-07:00
var $bc0bd7b6659a2632$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ANTLRInputStream = void 0;

var $bbHFU = parcelRequire("bbHFU");

var $d6D31 = parcelRequire("d6D31");

var $ceaEj = parcelRequire("ceaEj");
const $bc0bd7b6659a2632$var$READ_BUFFER_SIZE = 1024;
const $bc0bd7b6659a2632$var$INITIAL_BUFFER_SIZE = 1024;
/**
 * Vacuum all input from a {@link Reader}/{@link InputStream} and then treat it
 * like a `char[]` buffer. Can also pass in a {@link String} or
 * `char[]` to use.
 *
 * If you need encoding, pass in stream/reader with correct encoding.
 *
 * @deprecated as of 4.7, please use `CharStreams` interface.
 */ class $bc0bd7b6659a2632$var$ANTLRInputStream {
    /** Copy data in string to a local char array */ constructor(input){
        /** 0..n-1 index into string of next char */ this.p = 0;
        this.data = input;
        this.n = input.length;
    }
    /** Reset the stream so that it's in the same state it was
     *  when the object was created *except* the data array is not
     *  touched.
     */ reset() {
        this.p = 0;
    }
    consume() {
        if (this.p >= this.n) {
            $bbHFU(this.LA(1) === $ceaEj.IntStream.EOF);
            throw new Error("cannot consume EOF");
        }
        //System.out.println("prev p="+p+", c="+(char)data[p]);
        if (this.p < this.n) this.p++;
    }
    LA(i) {
        if (i === 0) return 0; // undefined
        if (i < 0) {
            i++; // e.g., translate LA(-1) to use offset i=0; then data[p+0-1]
            if (this.p + i - 1 < 0) return $ceaEj.IntStream.EOF; // invalid; no char before first char
        }
        if (this.p + i - 1 >= this.n) //System.out.println("char LA("+i+")=EOF; p="+p);
        return $ceaEj.IntStream.EOF;
        //System.out.println("char LA("+i+")="+(char)data[p+i-1]+"; p="+p);
        //System.out.println("LA("+i+"); p="+p+" n="+n+" data.length="+data.length);
        return this.data.charCodeAt(this.p + i - 1);
    }
    LT(i) {
        return this.LA(i);
    }
    /** Return the current input symbol index 0..n where n indicates the
     *  last symbol has been read.  The index is the index of char to
     *  be returned from LA(1).
     */ get index() {
        return this.p;
    }
    get size() {
        return this.n;
    }
    /** mark/release do nothing; we have entire buffer */ mark() {
        return -1;
    }
    release(marker) {
    // No default implementation since this stream buffers the entire input
    }
    /** consume() ahead until p==index; can't just set p=index as we must
     *  update line and charPositionInLine. If we seek backwards, just set p
     */ seek(index) {
        if (index <= this.p) {
            this.p = index; // just jump; don't update stream state (line, ...)
            return;
        }
        // seek forward, consume until p hits index or n (whichever comes first)
        index = Math.min(index, this.n);
        while(this.p < index)this.consume();
    }
    getText(interval) {
        let start = interval.a;
        let stop = interval.b;
        if (stop >= this.n) stop = this.n - 1;
        let count = stop - start + 1;
        if (start >= this.n) return "";
        // System.err.println("data: "+Arrays.toString(data)+", n="+n+
        // 				   ", start="+start+
        // 				   ", stop="+stop);
        return this.data.substr(start, count);
    }
    get sourceName() {
        if (!this.name) return $ceaEj.IntStream.UNKNOWN_SOURCE_NAME;
        return this.name;
    }
    toString() {
        return this.data;
    }
}
$bc0bd7b6659a2632$var$__decorate([
    $d6D31.Override
], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "consume", null);
$bc0bd7b6659a2632$var$__decorate([
    $d6D31.Override
], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "LA", null);
$bc0bd7b6659a2632$var$__decorate([
    $d6D31.Override
], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "index", null);
$bc0bd7b6659a2632$var$__decorate([
    $d6D31.Override
], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "size", null);
$bc0bd7b6659a2632$var$__decorate([
    $d6D31.Override
], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "mark", null);
$bc0bd7b6659a2632$var$__decorate([
    $d6D31.Override
], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "release", null);
$bc0bd7b6659a2632$var$__decorate([
    $d6D31.Override
], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "seek", null);
$bc0bd7b6659a2632$var$__decorate([
    $d6D31.Override
], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "getText", null);
$bc0bd7b6659a2632$var$__decorate([
    $d6D31.Override
], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "sourceName", null);
$bc0bd7b6659a2632$var$__decorate([
    $d6D31.Override
], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "toString", null);
module.exports.ANTLRInputStream = $bc0bd7b6659a2632$var$ANTLRInputStream;

});
parcelRegister("bbHFU", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $6cAn5 = parcelRequire("6cAn5");
'use strict';
function $825299b5d0c0a9a5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $825299b5d0c0a9a5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $825299b5d0c0a9a5$var$_typeof(o);
}
function $825299b5d0c0a9a5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $825299b5d0c0a9a5$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $825299b5d0c0a9a5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $825299b5d0c0a9a5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $825299b5d0c0a9a5$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $825299b5d0c0a9a5$var$_toPropertyKey(arg) {
    var key = $825299b5d0c0a9a5$var$_toPrimitive(arg, "string");
    return $825299b5d0c0a9a5$var$_typeof(key) === "symbol" ? key : String(key);
}
function $825299b5d0c0a9a5$var$_toPrimitive(input, hint) {
    if ($825299b5d0c0a9a5$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($825299b5d0c0a9a5$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $825299b5d0c0a9a5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $8JAro = parcelRequire("8JAro");
var $825299b5d0c0a9a5$var$_require$codes = $8JAro.codes, $825299b5d0c0a9a5$var$ERR_AMBIGUOUS_ARGUMENT = $825299b5d0c0a9a5$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE = $825299b5d0c0a9a5$var$_require$codes.ERR_INVALID_ARG_TYPE, $825299b5d0c0a9a5$var$ERR_INVALID_ARG_VALUE = $825299b5d0c0a9a5$var$_require$codes.ERR_INVALID_ARG_VALUE, $825299b5d0c0a9a5$var$ERR_INVALID_RETURN_VALUE = $825299b5d0c0a9a5$var$_require$codes.ERR_INVALID_RETURN_VALUE, $825299b5d0c0a9a5$var$ERR_MISSING_ARGS = $825299b5d0c0a9a5$var$_require$codes.ERR_MISSING_ARGS;

var $3ZLjA = parcelRequire("3ZLjA");

var $9kAQu = parcelRequire("9kAQu");
var $825299b5d0c0a9a5$var$inspect = $9kAQu.inspect;

var $9kAQu = parcelRequire("9kAQu");
var $825299b5d0c0a9a5$require$_require$types = $9kAQu.types;
var $825299b5d0c0a9a5$var$isPromise = $825299b5d0c0a9a5$require$_require$types.isPromise, $825299b5d0c0a9a5$var$isRegExp = $825299b5d0c0a9a5$require$_require$types.isRegExp;

var $825299b5d0c0a9a5$var$objectAssign = (parcelRequire("8s5ew"))();

var $825299b5d0c0a9a5$var$objectIs = (parcelRequire("eJazH"))();

var $825299b5d0c0a9a5$var$RegExpPrototypeTest = (parcelRequire("53KqO"))('RegExp.prototype.test');
var $825299b5d0c0a9a5$var$errorCache = new Map();
var $825299b5d0c0a9a5$var$isDeepEqual;
var $825299b5d0c0a9a5$var$isDeepStrictEqual;
var $825299b5d0c0a9a5$var$parseExpressionAt;
var $825299b5d0c0a9a5$var$findNodeAround;
var $825299b5d0c0a9a5$var$decoder;

function $825299b5d0c0a9a5$var$lazyLoadComparison() {
    var comparison = (parcelRequire("dztjv"));
    $825299b5d0c0a9a5$var$isDeepEqual = comparison.isDeepEqual;
    $825299b5d0c0a9a5$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
}
// Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $825299b5d0c0a9a5$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $825299b5d0c0a9a5$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    '\\b',
    '',
    '',
    "\\u000b",
    '\\f',
    '',
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $825299b5d0c0a9a5$var$escapeFn = function escapeFn(str) {
    return $825299b5d0c0a9a5$var$meta[str.charCodeAt(0)];
};
var $825299b5d0c0a9a5$var$warned = false;
// The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $825299b5d0c0a9a5$var$assert = module.exports = $825299b5d0c0a9a5$var$ok;
var $825299b5d0c0a9a5$var$NO_EXCEPTION_SENTINEL = {};
// All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $825299b5d0c0a9a5$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $3ZLjA(obj);
}
function $825299b5d0c0a9a5$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = 'Failed';
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($825299b5d0c0a9a5$var$warned === false) {
            $825299b5d0c0a9a5$var$warned = true;
            var warn = $6cAn5.emitWarning ? $6cAn5.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", 'DeprecationWarning', 'DEP0094');
        }
        if (argsLen === 2) operator = '!=';
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? 'fail' : operator,
        stackStartFn: stackStartFn || $825299b5d0c0a9a5$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $3ZLjA(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$825299b5d0c0a9a5$var$assert.fail = $825299b5d0c0a9a5$var$fail;
// The AssertionError is defined in internal/error.
$825299b5d0c0a9a5$var$assert.AssertionError = $3ZLjA;
function $825299b5d0c0a9a5$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = 'No value argument passed to `assert.ok()`';
        } else if (message instanceof Error) throw message;
        var err = new $3ZLjA({
            actual: value,
            expected: true,
            message: message,
            operator: '==',
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
// Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $825299b5d0c0a9a5$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $825299b5d0c0a9a5$var$innerOk.apply(void 0, [
        $825299b5d0c0a9a5$var$ok,
        args.length
    ].concat(args));
}
$825299b5d0c0a9a5$var$assert.ok = $825299b5d0c0a9a5$var$ok;
// The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $825299b5d0c0a9a5$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual != expected) $825299b5d0c0a9a5$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '==',
        stackStartFn: equal
    });
};
// The non-equality assertion tests for whether two objects are not
// equal with !=.
$825299b5d0c0a9a5$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual == expected) $825299b5d0c0a9a5$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '!=',
        stackStartFn: notEqual
    });
};
// The equivalence assertion tests a deep equality relation.
$825299b5d0c0a9a5$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($825299b5d0c0a9a5$var$isDeepEqual === undefined) $825299b5d0c0a9a5$var$lazyLoadComparison();
    if (!$825299b5d0c0a9a5$var$isDeepEqual(actual, expected)) $825299b5d0c0a9a5$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepEqual',
        stackStartFn: deepEqual
    });
};
// The non-equivalence assertion tests for any deep inequality.
$825299b5d0c0a9a5$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($825299b5d0c0a9a5$var$isDeepEqual === undefined) $825299b5d0c0a9a5$var$lazyLoadComparison();
    if ($825299b5d0c0a9a5$var$isDeepEqual(actual, expected)) $825299b5d0c0a9a5$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepEqual',
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $825299b5d0c0a9a5$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($825299b5d0c0a9a5$var$isDeepEqual === undefined) $825299b5d0c0a9a5$var$lazyLoadComparison();
    if (!$825299b5d0c0a9a5$var$isDeepStrictEqual(actual, expected)) $825299b5d0c0a9a5$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepStrictEqual',
        stackStartFn: deepStrictEqual
    });
};
$825299b5d0c0a9a5$var$assert.notDeepStrictEqual = $825299b5d0c0a9a5$var$notDeepStrictEqual;
function $825299b5d0c0a9a5$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($825299b5d0c0a9a5$var$isDeepEqual === undefined) $825299b5d0c0a9a5$var$lazyLoadComparison();
    if ($825299b5d0c0a9a5$var$isDeepStrictEqual(actual, expected)) $825299b5d0c0a9a5$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepStrictEqual',
        stackStartFn: $825299b5d0c0a9a5$var$notDeepStrictEqual
    });
}
$825299b5d0c0a9a5$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
    if (!$825299b5d0c0a9a5$var$objectIs(actual, expected)) $825299b5d0c0a9a5$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'strictEqual',
        stackStartFn: strictEqual
    });
};
$825299b5d0c0a9a5$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($825299b5d0c0a9a5$var$objectIs(actual, expected)) $825299b5d0c0a9a5$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notStrictEqual',
        stackStartFn: notStrictEqual
    });
};
var $825299b5d0c0a9a5$var$Comparison = /*#__PURE__*/ $825299b5d0c0a9a5$var$_createClass(function Comparison(obj, keys, actual) {
    var _this = this;
    $825299b5d0c0a9a5$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === 'string' && $825299b5d0c0a9a5$var$isRegExp(obj[key]) && $825299b5d0c0a9a5$var$RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
});
function $825299b5d0c0a9a5$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$825299b5d0c0a9a5$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $825299b5d0c0a9a5$var$Comparison(actual, keys);
            var b = new $825299b5d0c0a9a5$var$Comparison(expected, keys, actual);
            var err = new $3ZLjA({
                actual: a,
                expected: b,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $825299b5d0c0a9a5$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $825299b5d0c0a9a5$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== 'function') {
        if ($825299b5d0c0a9a5$var$isRegExp(expected)) return $825299b5d0c0a9a5$var$RegExpPrototypeTest(expected, actual);
        // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE('expected', [
            'Function',
            'RegExp'
        ], expected);
        // Handle primitives properly.
        if ($825299b5d0c0a9a5$var$_typeof(actual) !== 'object' || actual === null) {
            var err = new $3ZLjA({
                actual: actual,
                expected: expected,
                message: msg,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected);
        // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push('name', 'message');
        else if (keys.length === 0) throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
        if ($825299b5d0c0a9a5$var$isDeepEqual === undefined) $825299b5d0c0a9a5$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === 'string' && $825299b5d0c0a9a5$var$isRegExp(expected[key]) && $825299b5d0c0a9a5$var$RegExpPrototypeTest(expected[key], actual[key])) return;
            $825299b5d0c0a9a5$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    }
    // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $825299b5d0c0a9a5$var$getActual(fn) {
    if (typeof fn !== 'function') throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $825299b5d0c0a9a5$var$NO_EXCEPTION_SENTINEL;
}
function $825299b5d0c0a9a5$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $825299b5d0c0a9a5$var$isPromise(obj) || obj !== null && $825299b5d0c0a9a5$var$_typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
}
function $825299b5d0c0a9a5$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === 'function') {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn();
            // Fail in case no promise is returned.
            if (!$825299b5d0c0a9a5$var$checkIsPromise(resultPromise)) throw new $825299b5d0c0a9a5$var$ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
        } else if ($825299b5d0c0a9a5$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE('promiseFn', [
            'Function',
            'Promise'
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $825299b5d0c0a9a5$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $825299b5d0c0a9a5$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === 'string') {
        if (arguments.length === 4) throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE('error', [
            'Object',
            'Error',
            'Function',
            'RegExp'
        ], error);
        if ($825299b5d0c0a9a5$var$_typeof(actual) === 'object' && actual !== null) {
            if (actual.message === error) throw new $825299b5d0c0a9a5$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
        } else if (actual === error) throw new $825299b5d0c0a9a5$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
        message = error;
        error = undefined;
    } else if (error != null && $825299b5d0c0a9a5$var$_typeof(error) !== 'object' && typeof error !== 'function') throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE('error', [
        'Object',
        'Error',
        'Function',
        'RegExp'
    ], error);
    if (actual === $825299b5d0c0a9a5$var$NO_EXCEPTION_SENTINEL) {
        var details = '';
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
        $825299b5d0c0a9a5$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$825299b5d0c0a9a5$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $825299b5d0c0a9a5$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $825299b5d0c0a9a5$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === 'string') {
        message = error;
        error = undefined;
    }
    if (!error || $825299b5d0c0a9a5$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
        $825299b5d0c0a9a5$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$825299b5d0c0a9a5$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $825299b5d0c0a9a5$var$expectsError.apply(void 0, [
        throws,
        $825299b5d0c0a9a5$var$getActual(promiseFn)
    ].concat(args));
};
$825299b5d0c0a9a5$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $825299b5d0c0a9a5$var$waitForActual(promiseFn).then(function(result) {
        return $825299b5d0c0a9a5$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$825299b5d0c0a9a5$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $825299b5d0c0a9a5$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $825299b5d0c0a9a5$var$getActual(fn)
    ].concat(args));
};
$825299b5d0c0a9a5$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $825299b5d0c0a9a5$var$waitForActual(fn).then(function(result) {
        return $825299b5d0c0a9a5$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$825299b5d0c0a9a5$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = 'ifError got unwanted exception: ';
        if ($825299b5d0c0a9a5$var$_typeof(err) === 'object' && typeof err.message === 'string') {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $825299b5d0c0a9a5$var$inspect(err);
        var newErr = new $3ZLjA({
            actual: err,
            expected: null,
            operator: 'ifError',
            message: message,
            stackStartFn: ifError
        });
        // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === 'string') {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split('\n');
            tmp2.shift();
            // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split('\n');
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
        }
        throw newErr;
    }
};
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
function $825299b5d0c0a9a5$var$internalMatch(string, regexp, message, fn, fnName) {
    if (!$825299b5d0c0a9a5$var$isRegExp(regexp)) throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE('regexp', 'RegExp', regexp);
    var match = fnName === 'match';
    if (typeof string !== 'string' || $825299b5d0c0a9a5$var$RegExpPrototypeTest(regexp, string) !== match) {
        if (message instanceof Error) throw message;
        var generatedMessage = !message;
        // 'The input was expected to not match the regular expression ' +
        message = message || (typeof string !== 'string' ? 'The "string" argument must be of type string. Received type ' + "".concat($825299b5d0c0a9a5$var$_typeof(string), " (").concat($825299b5d0c0a9a5$var$inspect(string), ")") : (match ? 'The input did not match the regular expression ' : 'The input was expected to not match the regular expression ') + "".concat($825299b5d0c0a9a5$var$inspect(regexp), ". Input:\n\n").concat($825299b5d0c0a9a5$var$inspect(string), "\n"));
        var err = new $3ZLjA({
            actual: string,
            expected: regexp,
            message: message,
            operator: fnName,
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
$825299b5d0c0a9a5$var$assert.match = function match(string, regexp, message) {
    $825299b5d0c0a9a5$var$internalMatch(string, regexp, message, match, 'match');
};
$825299b5d0c0a9a5$var$assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
    $825299b5d0c0a9a5$var$internalMatch(string, regexp, message, doesNotMatch, 'doesNotMatch');
};
// Expose a strict only variant of assert
function $825299b5d0c0a9a5$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $825299b5d0c0a9a5$var$innerOk.apply(void 0, [
        $825299b5d0c0a9a5$var$strict,
        args.length
    ].concat(args));
}
$825299b5d0c0a9a5$var$assert.strict = $825299b5d0c0a9a5$var$objectAssign($825299b5d0c0a9a5$var$strict, $825299b5d0c0a9a5$var$assert, {
    equal: $825299b5d0c0a9a5$var$assert.strictEqual,
    deepEqual: $825299b5d0c0a9a5$var$assert.deepStrictEqual,
    notEqual: $825299b5d0c0a9a5$var$assert.notStrictEqual,
    notDeepEqual: $825299b5d0c0a9a5$var$assert.notDeepStrictEqual
});
$825299b5d0c0a9a5$var$assert.strict.strict = $825299b5d0c0a9a5$var$assert.strict;

});
parcelRegister("8JAro", function(module, exports) {

$parcel$export(module.exports, "codes", () => $65becb1820e5a079$export$e45cb6485273080e, (v) => $65becb1820e5a079$export$e45cb6485273080e = v);
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $65becb1820e5a079$export$e45cb6485273080e;
'use strict';
// The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $65becb1820e5a079$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $65becb1820e5a079$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $65becb1820e5a079$var$_typeof(o);
}
function $65becb1820e5a079$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $65becb1820e5a079$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $65becb1820e5a079$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $65becb1820e5a079$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $65becb1820e5a079$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $65becb1820e5a079$var$_toPropertyKey(arg) {
    var key = $65becb1820e5a079$var$_toPrimitive(arg, "string");
    return $65becb1820e5a079$var$_typeof(key) === "symbol" ? key : String(key);
}
function $65becb1820e5a079$var$_toPrimitive(input, hint) {
    if ($65becb1820e5a079$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($65becb1820e5a079$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $65becb1820e5a079$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $65becb1820e5a079$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $65becb1820e5a079$var$_setPrototypeOf(subClass, superClass);
}
function $65becb1820e5a079$var$_setPrototypeOf(o, p) {
    $65becb1820e5a079$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $65becb1820e5a079$var$_setPrototypeOf(o, p);
}
function $65becb1820e5a079$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $65becb1820e5a079$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $65becb1820e5a079$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $65becb1820e5a079$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $65becb1820e5a079$var$_possibleConstructorReturn(this, result);
    };
}
function $65becb1820e5a079$var$_possibleConstructorReturn(self, call) {
    if (call && ($65becb1820e5a079$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $65becb1820e5a079$var$_assertThisInitialized(self);
}
function $65becb1820e5a079$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $65becb1820e5a079$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $65becb1820e5a079$var$_getPrototypeOf(o) {
    $65becb1820e5a079$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $65becb1820e5a079$var$_getPrototypeOf(o);
}
var $65becb1820e5a079$var$codes = {};
// Lazy loaded
var $65becb1820e5a079$var$assert;
var $65becb1820e5a079$var$util;
function $65becb1820e5a079$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $65becb1820e5a079$var$_inherits(NodeError, _Base);
        var _super = $65becb1820e5a079$var$_createSuper(NodeError);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $65becb1820e5a079$var$_classCallCheck(this, NodeError);
            _this = _super.call(this, getMessage(arg1, arg2, arg3));
            _this.code = code;
            return _this;
        }
        return $65becb1820e5a079$var$_createClass(NodeError);
    }(Base);
    $65becb1820e5a079$var$codes[code] = NodeError;
}
// https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $65becb1820e5a079$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $65becb1820e5a079$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $65becb1820e5a079$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $65becb1820e5a079$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$65becb1820e5a079$var$createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);

$65becb1820e5a079$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    if ($65becb1820e5a079$var$assert === undefined) $65becb1820e5a079$var$assert = (parcelRequire("bbHFU"));
    $65becb1820e5a079$var$assert(typeof name === 'string', "'name' must be a string");
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $65becb1820e5a079$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($65becb1820e5a079$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($65becb1820e5a079$var$oneOf(expected, 'type'));
    else {
        var type = $65becb1820e5a079$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($65becb1820e5a079$var$oneOf(expected, 'type'));
    }
    // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($65becb1820e5a079$var$_typeof(actual));
    return msg;
}, TypeError);

$65becb1820e5a079$var$createErrorType('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
    if ($65becb1820e5a079$var$util === undefined) $65becb1820e5a079$var$util = (parcelRequire("9kAQu"));
    var inspected = $65becb1820e5a079$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$65becb1820e5a079$var$createErrorType('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($65becb1820e5a079$var$_typeof(value));
    return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
}, TypeError);

$65becb1820e5a079$var$createErrorType('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($65becb1820e5a079$var$assert === undefined) $65becb1820e5a079$var$assert = (parcelRequire("bbHFU"));
    $65becb1820e5a079$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg = 'The ';
    var len = args.length;
    args = args.map(function(a) {
        return "\"".concat(a, "\"");
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(', ');
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$65becb1820e5a079$export$e45cb6485273080e = $65becb1820e5a079$var$codes;

});
parcelRegister("9kAQu", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $6cAn5 = parcelRequire("6cAn5");
var $6cb29018fbdc8fcc$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $6cb29018fbdc8fcc$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$6cb29018fbdc8fcc$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($6cb29018fbdc8fcc$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($6cb29018fbdc8fcc$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($6cb29018fbdc8fcc$var$isNull(x) || !$6cb29018fbdc8fcc$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $6cb29018fbdc8fcc$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    if (typeof $6cAn5 !== 'undefined' && $6cAn5.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $6cAn5 === 'undefined') return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($6cAn5.throwDeprecation) throw new Error(msg);
            else if ($6cAn5.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $6cb29018fbdc8fcc$var$debugs = {};
var $6cb29018fbdc8fcc$var$debugEnvRegex = /^$/;
var $6cb29018fbdc8fcc$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$6cb29018fbdc8fcc$var$debugs[set]) {
        if ($6cb29018fbdc8fcc$var$debugEnvRegex.test(set)) {
            var pid = $6cAn5.pid;
            $6cb29018fbdc8fcc$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $6cb29018fbdc8fcc$var$debugs[set] = function() {};
    }
    return $6cb29018fbdc8fcc$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $6cb29018fbdc8fcc$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $6cb29018fbdc8fcc$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($6cb29018fbdc8fcc$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($6cb29018fbdc8fcc$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($6cb29018fbdc8fcc$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($6cb29018fbdc8fcc$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($6cb29018fbdc8fcc$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $6cb29018fbdc8fcc$var$stylizeWithColor;
    return $6cb29018fbdc8fcc$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $6cb29018fbdc8fcc$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$6cb29018fbdc8fcc$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$6cb29018fbdc8fcc$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $6cb29018fbdc8fcc$var$stylizeWithColor(str, styleType) {
    var style = $6cb29018fbdc8fcc$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $6cb29018fbdc8fcc$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $6cb29018fbdc8fcc$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $6cb29018fbdc8fcc$var$stylizeNoColor(str, styleType) {
    return str;
}
function $6cb29018fbdc8fcc$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $6cb29018fbdc8fcc$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $6cb29018fbdc8fcc$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$6cb29018fbdc8fcc$var$isString(ret)) ret = $6cb29018fbdc8fcc$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $6cb29018fbdc8fcc$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $6cb29018fbdc8fcc$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($6cb29018fbdc8fcc$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $6cb29018fbdc8fcc$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($6cb29018fbdc8fcc$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($6cb29018fbdc8fcc$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($6cb29018fbdc8fcc$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($6cb29018fbdc8fcc$var$isError(value)) return $6cb29018fbdc8fcc$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($6cb29018fbdc8fcc$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($6cb29018fbdc8fcc$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($6cb29018fbdc8fcc$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($6cb29018fbdc8fcc$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($6cb29018fbdc8fcc$var$isError(value)) base = ' ' + $6cb29018fbdc8fcc$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($6cb29018fbdc8fcc$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $6cb29018fbdc8fcc$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $6cb29018fbdc8fcc$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $6cb29018fbdc8fcc$var$reduceToSingleString(output, base, braces);
}
function $6cb29018fbdc8fcc$var$formatPrimitive(ctx, value) {
    if ($6cb29018fbdc8fcc$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($6cb29018fbdc8fcc$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($6cb29018fbdc8fcc$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($6cb29018fbdc8fcc$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($6cb29018fbdc8fcc$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $6cb29018fbdc8fcc$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $6cb29018fbdc8fcc$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($6cb29018fbdc8fcc$var$hasOwnProperty(value, String(i))) output.push($6cb29018fbdc8fcc$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($6cb29018fbdc8fcc$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $6cb29018fbdc8fcc$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$6cb29018fbdc8fcc$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($6cb29018fbdc8fcc$var$isNull(recurseTimes)) str = $6cb29018fbdc8fcc$var$formatValue(ctx, desc.value, null);
            else str = $6cb29018fbdc8fcc$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($6cb29018fbdc8fcc$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $6cb29018fbdc8fcc$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("jGyMi"));
function $6cb29018fbdc8fcc$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $6cb29018fbdc8fcc$var$isArray;
function $6cb29018fbdc8fcc$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $6cb29018fbdc8fcc$var$isBoolean;
function $6cb29018fbdc8fcc$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $6cb29018fbdc8fcc$var$isNull;
function $6cb29018fbdc8fcc$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $6cb29018fbdc8fcc$var$isNullOrUndefined;
function $6cb29018fbdc8fcc$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $6cb29018fbdc8fcc$var$isNumber;
function $6cb29018fbdc8fcc$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $6cb29018fbdc8fcc$var$isString;
function $6cb29018fbdc8fcc$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $6cb29018fbdc8fcc$var$isSymbol;
function $6cb29018fbdc8fcc$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $6cb29018fbdc8fcc$var$isUndefined;
function $6cb29018fbdc8fcc$var$isRegExp(re) {
    return $6cb29018fbdc8fcc$var$isObject(re) && $6cb29018fbdc8fcc$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $6cb29018fbdc8fcc$var$isRegExp;
module.exports.types.isRegExp = $6cb29018fbdc8fcc$var$isRegExp;
function $6cb29018fbdc8fcc$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $6cb29018fbdc8fcc$var$isObject;
function $6cb29018fbdc8fcc$var$isDate(d) {
    return $6cb29018fbdc8fcc$var$isObject(d) && $6cb29018fbdc8fcc$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $6cb29018fbdc8fcc$var$isDate;
module.exports.types.isDate = $6cb29018fbdc8fcc$var$isDate;
function $6cb29018fbdc8fcc$var$isError(e) {
    return $6cb29018fbdc8fcc$var$isObject(e) && ($6cb29018fbdc8fcc$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $6cb29018fbdc8fcc$var$isError;
module.exports.types.isNativeError = $6cb29018fbdc8fcc$var$isError;
function $6cb29018fbdc8fcc$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $6cb29018fbdc8fcc$var$isFunction;
function $6cb29018fbdc8fcc$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $6cb29018fbdc8fcc$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("kEU0N"));
function $6cb29018fbdc8fcc$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $6cb29018fbdc8fcc$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $6cb29018fbdc8fcc$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $6cb29018fbdc8fcc$var$timestamp() {
    var d = new Date();
    var time = [
        $6cb29018fbdc8fcc$var$pad(d.getHours()),
        $6cb29018fbdc8fcc$var$pad(d.getMinutes()),
        $6cb29018fbdc8fcc$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $6cb29018fbdc8fcc$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $6cb29018fbdc8fcc$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("v3bBu"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$6cb29018fbdc8fcc$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $6cb29018fbdc8fcc$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol && original[$6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol]) {
        var fn = original[$6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $6cb29018fbdc8fcc$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol;
function $6cb29018fbdc8fcc$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $6cb29018fbdc8fcc$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $6cAn5.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $6cAn5.nextTick($6cb29018fbdc8fcc$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $6cb29018fbdc8fcc$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $6cb29018fbdc8fcc$var$callbackify;

});
parcelRegister("jGyMi", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $eyPxb = parcelRequire("eyPxb");

var $kF7vh = parcelRequire("kF7vh");

var $hdl59 = parcelRequire("hdl59");

var $dFTgY = parcelRequire("dFTgY");
function $e54ceaba9c647d57$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $e54ceaba9c647d57$var$BigIntSupported = typeof BigInt !== 'undefined';
var $e54ceaba9c647d57$var$SymbolSupported = typeof Symbol !== 'undefined';
var $e54ceaba9c647d57$var$ObjectToString = $e54ceaba9c647d57$var$uncurryThis(Object.prototype.toString);
var $e54ceaba9c647d57$var$numberValue = $e54ceaba9c647d57$var$uncurryThis(Number.prototype.valueOf);
var $e54ceaba9c647d57$var$stringValue = $e54ceaba9c647d57$var$uncurryThis(String.prototype.valueOf);
var $e54ceaba9c647d57$var$booleanValue = $e54ceaba9c647d57$var$uncurryThis(Boolean.prototype.valueOf);
if ($e54ceaba9c647d57$var$BigIntSupported) var $e54ceaba9c647d57$var$bigIntValue = $e54ceaba9c647d57$var$uncurryThis(BigInt.prototype.valueOf);
if ($e54ceaba9c647d57$var$SymbolSupported) var $e54ceaba9c647d57$var$symbolValue = $e54ceaba9c647d57$var$uncurryThis(Symbol.prototype.valueOf);
function $e54ceaba9c647d57$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $eyPxb;
module.exports.isGeneratorFunction = $kF7vh;
module.exports.isTypedArray = $dFTgY;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $e54ceaba9c647d57$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $e54ceaba9c647d57$var$isPromise;
function $e54ceaba9c647d57$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $dFTgY(value) || $e54ceaba9c647d57$var$isDataView(value);
}
module.exports.isArrayBufferView = $e54ceaba9c647d57$var$isArrayBufferView;
function $e54ceaba9c647d57$var$isUint8Array(value) {
    return $hdl59(value) === 'Uint8Array';
}
module.exports.isUint8Array = $e54ceaba9c647d57$var$isUint8Array;
function $e54ceaba9c647d57$var$isUint8ClampedArray(value) {
    return $hdl59(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $e54ceaba9c647d57$var$isUint8ClampedArray;
function $e54ceaba9c647d57$var$isUint16Array(value) {
    return $hdl59(value) === 'Uint16Array';
}
module.exports.isUint16Array = $e54ceaba9c647d57$var$isUint16Array;
function $e54ceaba9c647d57$var$isUint32Array(value) {
    return $hdl59(value) === 'Uint32Array';
}
module.exports.isUint32Array = $e54ceaba9c647d57$var$isUint32Array;
function $e54ceaba9c647d57$var$isInt8Array(value) {
    return $hdl59(value) === 'Int8Array';
}
module.exports.isInt8Array = $e54ceaba9c647d57$var$isInt8Array;
function $e54ceaba9c647d57$var$isInt16Array(value) {
    return $hdl59(value) === 'Int16Array';
}
module.exports.isInt16Array = $e54ceaba9c647d57$var$isInt16Array;
function $e54ceaba9c647d57$var$isInt32Array(value) {
    return $hdl59(value) === 'Int32Array';
}
module.exports.isInt32Array = $e54ceaba9c647d57$var$isInt32Array;
function $e54ceaba9c647d57$var$isFloat32Array(value) {
    return $hdl59(value) === 'Float32Array';
}
module.exports.isFloat32Array = $e54ceaba9c647d57$var$isFloat32Array;
function $e54ceaba9c647d57$var$isFloat64Array(value) {
    return $hdl59(value) === 'Float64Array';
}
module.exports.isFloat64Array = $e54ceaba9c647d57$var$isFloat64Array;
function $e54ceaba9c647d57$var$isBigInt64Array(value) {
    return $hdl59(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $e54ceaba9c647d57$var$isBigInt64Array;
function $e54ceaba9c647d57$var$isBigUint64Array(value) {
    return $hdl59(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $e54ceaba9c647d57$var$isBigUint64Array;
function $e54ceaba9c647d57$var$isMapToString(value) {
    return $e54ceaba9c647d57$var$ObjectToString(value) === '[object Map]';
}
$e54ceaba9c647d57$var$isMapToString.working = typeof Map !== 'undefined' && $e54ceaba9c647d57$var$isMapToString(new Map());
function $e54ceaba9c647d57$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $e54ceaba9c647d57$var$isMapToString.working ? $e54ceaba9c647d57$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $e54ceaba9c647d57$var$isMap;
function $e54ceaba9c647d57$var$isSetToString(value) {
    return $e54ceaba9c647d57$var$ObjectToString(value) === '[object Set]';
}
$e54ceaba9c647d57$var$isSetToString.working = typeof Set !== 'undefined' && $e54ceaba9c647d57$var$isSetToString(new Set());
function $e54ceaba9c647d57$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $e54ceaba9c647d57$var$isSetToString.working ? $e54ceaba9c647d57$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $e54ceaba9c647d57$var$isSet;
function $e54ceaba9c647d57$var$isWeakMapToString(value) {
    return $e54ceaba9c647d57$var$ObjectToString(value) === '[object WeakMap]';
}
$e54ceaba9c647d57$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $e54ceaba9c647d57$var$isWeakMapToString(new WeakMap());
function $e54ceaba9c647d57$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $e54ceaba9c647d57$var$isWeakMapToString.working ? $e54ceaba9c647d57$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $e54ceaba9c647d57$var$isWeakMap;
function $e54ceaba9c647d57$var$isWeakSetToString(value) {
    return $e54ceaba9c647d57$var$ObjectToString(value) === '[object WeakSet]';
}
$e54ceaba9c647d57$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $e54ceaba9c647d57$var$isWeakSetToString(new WeakSet());
function $e54ceaba9c647d57$var$isWeakSet(value) {
    return $e54ceaba9c647d57$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $e54ceaba9c647d57$var$isWeakSet;
function $e54ceaba9c647d57$var$isArrayBufferToString(value) {
    return $e54ceaba9c647d57$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$e54ceaba9c647d57$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $e54ceaba9c647d57$var$isArrayBufferToString(new ArrayBuffer());
function $e54ceaba9c647d57$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $e54ceaba9c647d57$var$isArrayBufferToString.working ? $e54ceaba9c647d57$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $e54ceaba9c647d57$var$isArrayBuffer;
function $e54ceaba9c647d57$var$isDataViewToString(value) {
    return $e54ceaba9c647d57$var$ObjectToString(value) === '[object DataView]';
}
$e54ceaba9c647d57$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $e54ceaba9c647d57$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $e54ceaba9c647d57$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $e54ceaba9c647d57$var$isDataViewToString.working ? $e54ceaba9c647d57$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $e54ceaba9c647d57$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $e54ceaba9c647d57$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $e54ceaba9c647d57$var$isSharedArrayBufferToString(value) {
    return $e54ceaba9c647d57$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $e54ceaba9c647d57$var$isSharedArrayBuffer(value) {
    if (typeof $e54ceaba9c647d57$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $e54ceaba9c647d57$var$isSharedArrayBufferToString.working === 'undefined') $e54ceaba9c647d57$var$isSharedArrayBufferToString.working = $e54ceaba9c647d57$var$isSharedArrayBufferToString(new $e54ceaba9c647d57$var$SharedArrayBufferCopy());
    return $e54ceaba9c647d57$var$isSharedArrayBufferToString.working ? $e54ceaba9c647d57$var$isSharedArrayBufferToString(value) : value instanceof $e54ceaba9c647d57$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $e54ceaba9c647d57$var$isSharedArrayBuffer;
function $e54ceaba9c647d57$var$isAsyncFunction(value) {
    return $e54ceaba9c647d57$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $e54ceaba9c647d57$var$isAsyncFunction;
function $e54ceaba9c647d57$var$isMapIterator(value) {
    return $e54ceaba9c647d57$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $e54ceaba9c647d57$var$isMapIterator;
function $e54ceaba9c647d57$var$isSetIterator(value) {
    return $e54ceaba9c647d57$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $e54ceaba9c647d57$var$isSetIterator;
function $e54ceaba9c647d57$var$isGeneratorObject(value) {
    return $e54ceaba9c647d57$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $e54ceaba9c647d57$var$isGeneratorObject;
function $e54ceaba9c647d57$var$isWebAssemblyCompiledModule(value) {
    return $e54ceaba9c647d57$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $e54ceaba9c647d57$var$isWebAssemblyCompiledModule;
function $e54ceaba9c647d57$var$isNumberObject(value) {
    return $e54ceaba9c647d57$var$checkBoxedPrimitive(value, $e54ceaba9c647d57$var$numberValue);
}
module.exports.isNumberObject = $e54ceaba9c647d57$var$isNumberObject;
function $e54ceaba9c647d57$var$isStringObject(value) {
    return $e54ceaba9c647d57$var$checkBoxedPrimitive(value, $e54ceaba9c647d57$var$stringValue);
}
module.exports.isStringObject = $e54ceaba9c647d57$var$isStringObject;
function $e54ceaba9c647d57$var$isBooleanObject(value) {
    return $e54ceaba9c647d57$var$checkBoxedPrimitive(value, $e54ceaba9c647d57$var$booleanValue);
}
module.exports.isBooleanObject = $e54ceaba9c647d57$var$isBooleanObject;
function $e54ceaba9c647d57$var$isBigIntObject(value) {
    return $e54ceaba9c647d57$var$BigIntSupported && $e54ceaba9c647d57$var$checkBoxedPrimitive(value, $e54ceaba9c647d57$var$bigIntValue);
}
module.exports.isBigIntObject = $e54ceaba9c647d57$var$isBigIntObject;
function $e54ceaba9c647d57$var$isSymbolObject(value) {
    return $e54ceaba9c647d57$var$SymbolSupported && $e54ceaba9c647d57$var$checkBoxedPrimitive(value, $e54ceaba9c647d57$var$symbolValue);
}
module.exports.isSymbolObject = $e54ceaba9c647d57$var$isSymbolObject;
function $e54ceaba9c647d57$var$isBoxedPrimitive(value) {
    return $e54ceaba9c647d57$var$isNumberObject(value) || $e54ceaba9c647d57$var$isStringObject(value) || $e54ceaba9c647d57$var$isBooleanObject(value) || $e54ceaba9c647d57$var$isBigIntObject(value) || $e54ceaba9c647d57$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $e54ceaba9c647d57$var$isBoxedPrimitive;
function $e54ceaba9c647d57$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($e54ceaba9c647d57$var$isArrayBuffer(value) || $e54ceaba9c647d57$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $e54ceaba9c647d57$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("eyPxb", function(module, exports) {
'use strict';

var $a99c3747cd09063d$var$hasToStringTag = (parcelRequire("fmBzB"))();

var $53KqO = parcelRequire("53KqO");
var $a99c3747cd09063d$var$$toString = $53KqO('Object.prototype.toString');
var $a99c3747cd09063d$var$isStandardArguments = function isArguments(value) {
    if ($a99c3747cd09063d$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $a99c3747cd09063d$var$$toString(value) === '[object Arguments]';
};
var $a99c3747cd09063d$var$isLegacyArguments = function isArguments(value) {
    if ($a99c3747cd09063d$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $a99c3747cd09063d$var$$toString(value) !== '[object Array]' && $a99c3747cd09063d$var$$toString(value.callee) === '[object Function]';
};
var $a99c3747cd09063d$var$supportsStandardArguments = function() {
    return $a99c3747cd09063d$var$isStandardArguments(arguments);
}();
$a99c3747cd09063d$var$isStandardArguments.isLegacyArguments = $a99c3747cd09063d$var$isLegacyArguments; // for tests
module.exports = $a99c3747cd09063d$var$supportsStandardArguments ? $a99c3747cd09063d$var$isStandardArguments : $a99c3747cd09063d$var$isLegacyArguments;

});
parcelRegister("fmBzB", function(module, exports) {
'use strict';

var $9T9x9 = parcelRequire("9T9x9");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $9T9x9() && !!Symbol.toStringTag;
};

});

parcelRegister("53KqO", function(module, exports) {
'use strict';

var $iPtqy = parcelRequire("iPtqy");

var $h05ZS = parcelRequire("h05ZS");
var $3af13fe1c3fdd190$var$$indexOf = $h05ZS($iPtqy('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $iPtqy(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $3af13fe1c3fdd190$var$$indexOf(name, '.prototype.') > -1) return $h05ZS(intrinsic);
    return intrinsic;
};

});
parcelRegister("h05ZS", function(module, exports) {
'use strict';

var $6ElEw = parcelRequire("6ElEw");

var $7Th0d = parcelRequire("7Th0d");

var $h08zB = parcelRequire("h08zB");

var $ghZDY = parcelRequire("ghZDY");
module.exports = function callBind(originalFunction) {
    var func = $h08zB(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $6ElEw(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($7Th0d) $7Th0d(module.exports, 'apply', {
    value: $ghZDY
});
else module.exports.apply = $ghZDY;

});
parcelRegister("6ElEw", function(module, exports) {
'use strict';

var $iPtqy = parcelRequire("iPtqy");

var $le88V = parcelRequire("le88V");

var $4d77463b7ea9d419$var$hasDescriptors = (parcelRequire("9lmlE"))();

var $lBvcQ = parcelRequire("lBvcQ");

var $kQfBa = parcelRequire("kQfBa");
var $4d77463b7ea9d419$var$$floor = $iPtqy('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $kQfBa('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $4d77463b7ea9d419$var$$floor(length) !== length) throw new $kQfBa('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $lBvcQ) {
        var desc = $lBvcQ(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($4d77463b7ea9d419$var$hasDescriptors) $le88V(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $le88V(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("le88V", function(module, exports) {
'use strict';

var $7Th0d = parcelRequire("7Th0d");

var $6ZTEL = parcelRequire("6ZTEL");

var $kQfBa = parcelRequire("kQfBa");

var $lBvcQ = parcelRequire("lBvcQ");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $kQfBa('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $kQfBa('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $kQfBa('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $kQfBa('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $kQfBa('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $kQfBa('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$lBvcQ && $lBvcQ(obj, property);
    if ($7Th0d) $7Th0d(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $6ZTEL('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("9lmlE", function(module, exports) {
'use strict';

var $7Th0d = parcelRequire("7Th0d");
var $6cd7691e5358e89c$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$7Th0d;
};
$6cd7691e5358e89c$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$7Th0d) return null;
    try {
        return $7Th0d([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $6cd7691e5358e89c$var$hasPropertyDescriptors;

});


parcelRegister("ghZDY", function(module, exports) {
'use strict';

var $g2Z6Y = parcelRequire("g2Z6Y");

var $iJCdB = parcelRequire("iJCdB");

var $4XlJF = parcelRequire("4XlJF");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $4XlJF($g2Z6Y, $iJCdB, arguments);
};

});




parcelRegister("kF7vh", function(module, exports) {
'use strict';
var $f0ad750370f41c64$var$toStr = Object.prototype.toString;
var $f0ad750370f41c64$var$fnToStr = Function.prototype.toString;
var $f0ad750370f41c64$var$isFnRegex = /^\s*(?:function)?\*/;

var $f0ad750370f41c64$var$hasToStringTag = (parcelRequire("fmBzB"))();
var $f0ad750370f41c64$var$getProto = Object.getPrototypeOf;
var $f0ad750370f41c64$var$getGeneratorFunc = function() {
    if (!$f0ad750370f41c64$var$hasToStringTag) return false;
    try {
        return Function('return function*() {}')();
    } catch (e) {}
};
var $f0ad750370f41c64$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($f0ad750370f41c64$var$isFnRegex.test($f0ad750370f41c64$var$fnToStr.call(fn))) return true;
    if (!$f0ad750370f41c64$var$hasToStringTag) {
        var str = $f0ad750370f41c64$var$toStr.call(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$f0ad750370f41c64$var$getProto) return false;
    if (typeof $f0ad750370f41c64$var$GeneratorFunction === 'undefined') {
        var generatorFunc = $f0ad750370f41c64$var$getGeneratorFunc();
        $f0ad750370f41c64$var$GeneratorFunction = generatorFunc ? $f0ad750370f41c64$var$getProto(generatorFunc) : false;
    }
    return $f0ad750370f41c64$var$getProto(fn) === $f0ad750370f41c64$var$GeneratorFunction;
};

});

parcelRegister("hdl59", function(module, exports) {
'use strict';

var $258uT = parcelRequire("258uT");

var $9ME5O = parcelRequire("9ME5O");

var $h05ZS = parcelRequire("h05ZS");

var $3T2jo = parcelRequire("3T2jo");

var $lBvcQ = parcelRequire("lBvcQ");

var $863dK = parcelRequire("863dK");
var $c884010d01443113$var$$toString = $3T2jo('Object.prototype.toString');

var $c884010d01443113$var$hasToStringTag = (parcelRequire("fmBzB"))();
var $c884010d01443113$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $c884010d01443113$var$typedArrays = $9ME5O();
var $c884010d01443113$var$$slice = $3T2jo('String.prototype.slice');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $c884010d01443113$var$$indexOf = $3T2jo('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {import('./types').Getter} Getter */ /** @type {import('./types').Cache} */ var $c884010d01443113$var$cache = {
    __proto__: null
};
if ($c884010d01443113$var$hasToStringTag && $lBvcQ && $863dK) $258uT($c884010d01443113$var$typedArrays, function(typedArray) {
    var arr = new $c884010d01443113$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $863dK) {
        var proto = $863dK(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $lBvcQ(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $863dK(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $lBvcQ(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $c884010d01443113$var$cache['$' + typedArray] = $h05ZS(descriptor.get);
    }
});
else $258uT($c884010d01443113$var$typedArrays, function(typedArray) {
    var arr = new $c884010d01443113$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) $c884010d01443113$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ // @ts-expect-error TODO FIXME
    $h05ZS(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $c884010d01443113$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $258uT(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $c884010d01443113$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {import('.').TypedArrayName} */ $c884010d01443113$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $c884010d01443113$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $258uT(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $c884010d01443113$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {import('.').TypedArrayName} */ $c884010d01443113$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$c884010d01443113$var$hasToStringTag) {
        /** @type {string} */ var tag = $c884010d01443113$var$$slice($c884010d01443113$var$$toString(value), 8, -1);
        if ($c884010d01443113$var$$indexOf($c884010d01443113$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $c884010d01443113$var$trySlices(value);
    }
    if (!$lBvcQ) return null;
     // unknown engine
    return $c884010d01443113$var$tryTypedArrays(value);
};

});
parcelRegister("258uT", function(module, exports) {
'use strict';

var $f0Tdg = parcelRequire("f0Tdg");
var $1842a3cb7df292b5$var$toStr = Object.prototype.toString;
var $1842a3cb7df292b5$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $1842a3cb7df292b5$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($1842a3cb7df292b5$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $1842a3cb7df292b5$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $1842a3cb7df292b5$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($1842a3cb7df292b5$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $1842a3cb7df292b5$var$isArray(x) {
    return $1842a3cb7df292b5$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$f0Tdg(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($1842a3cb7df292b5$var$isArray(list)) $1842a3cb7df292b5$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $1842a3cb7df292b5$var$forEachString(list, iterator, receiver);
    else $1842a3cb7df292b5$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("f0Tdg", function(module, exports) {
'use strict';
var $02d21778b0eebae4$var$fnToStr = Function.prototype.toString;
var $02d21778b0eebae4$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $02d21778b0eebae4$var$badArrayLike;
var $02d21778b0eebae4$var$isCallableMarker;
if (typeof $02d21778b0eebae4$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $02d21778b0eebae4$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $02d21778b0eebae4$var$isCallableMarker;
        }
    });
    $02d21778b0eebae4$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $02d21778b0eebae4$var$reflectApply(function() {
        throw 42;
    }, null, $02d21778b0eebae4$var$badArrayLike);
} catch (_) {
    if (_ !== $02d21778b0eebae4$var$isCallableMarker) $02d21778b0eebae4$var$reflectApply = null;
}
else $02d21778b0eebae4$var$reflectApply = null;
var $02d21778b0eebae4$var$constructorRegex = /^\s*class\b/;
var $02d21778b0eebae4$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $02d21778b0eebae4$var$fnToStr.call(value);
        return $02d21778b0eebae4$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $02d21778b0eebae4$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($02d21778b0eebae4$var$isES6ClassFn(value)) return false;
        $02d21778b0eebae4$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $02d21778b0eebae4$var$toStr = Object.prototype.toString;
var $02d21778b0eebae4$var$objectClass = '[object Object]';
var $02d21778b0eebae4$var$fnClass = '[object Function]';
var $02d21778b0eebae4$var$genClass = '[object GeneratorFunction]';
var $02d21778b0eebae4$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $02d21778b0eebae4$var$ddaClass2 = '[object HTML document.all class]';
var $02d21778b0eebae4$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $02d21778b0eebae4$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $02d21778b0eebae4$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $02d21778b0eebae4$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $02d21778b0eebae4$var$all = document.all;
    if ($02d21778b0eebae4$var$toStr.call($02d21778b0eebae4$var$all) === $02d21778b0eebae4$var$toStr.call(document.all)) $02d21778b0eebae4$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($02d21778b0eebae4$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $02d21778b0eebae4$var$toStr.call(value);
            return (str === $02d21778b0eebae4$var$ddaClass || str === $02d21778b0eebae4$var$ddaClass2 || str === $02d21778b0eebae4$var$ddaClass3 // opera 12.16
             || str === $02d21778b0eebae4$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $02d21778b0eebae4$var$reflectApply ? function isCallable(value) {
    if ($02d21778b0eebae4$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $02d21778b0eebae4$var$reflectApply(value, null, $02d21778b0eebae4$var$badArrayLike);
    } catch (e) {
        if (e !== $02d21778b0eebae4$var$isCallableMarker) return false;
    }
    return !$02d21778b0eebae4$var$isES6ClassFn(value) && $02d21778b0eebae4$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($02d21778b0eebae4$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($02d21778b0eebae4$var$hasToStringTag) return $02d21778b0eebae4$var$tryFunctionObject(value);
    if ($02d21778b0eebae4$var$isES6ClassFn(value)) return false;
    var strClass = $02d21778b0eebae4$var$toStr.call(value);
    if (strClass !== $02d21778b0eebae4$var$fnClass && strClass !== $02d21778b0eebae4$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $02d21778b0eebae4$var$tryFunctionObject(value);
};

});


parcelRegister("9ME5O", function(module, exports) {
'use strict';

var $8a51N = parcelRequire("8a51N");
var $71f7b254c38edcde$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $8a51N.length; i++)if (typeof $71f7b254c38edcde$var$g[$8a51N[i]] === 'function') // @ts-expect-error
    out[out.length] = $8a51N[i];
    return out;
};

});
parcelRegister("8a51N", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});



parcelRegister("dFTgY", function(module, exports) {
'use strict';

var $hdl59 = parcelRequire("hdl59");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$hdl59(value);
};

});


parcelRegister("kEU0N", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});

parcelRegister("v3bBu", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});



parcelRegister("3ZLjA", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $6cAn5 = parcelRequire("6cAn5");
'use strict';
function $2e8bc5606025d797$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2e8bc5606025d797$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2e8bc5606025d797$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2e8bc5606025d797$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2e8bc5606025d797$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2e8bc5606025d797$var$_defineProperty(obj, key, value) {
    key = $2e8bc5606025d797$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2e8bc5606025d797$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2e8bc5606025d797$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $2e8bc5606025d797$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $2e8bc5606025d797$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2e8bc5606025d797$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2e8bc5606025d797$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $2e8bc5606025d797$var$_toPropertyKey(arg) {
    var key = $2e8bc5606025d797$var$_toPrimitive(arg, "string");
    return $2e8bc5606025d797$var$_typeof(key) === "symbol" ? key : String(key);
}
function $2e8bc5606025d797$var$_toPrimitive(input, hint) {
    if ($2e8bc5606025d797$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($2e8bc5606025d797$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $2e8bc5606025d797$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $2e8bc5606025d797$var$_setPrototypeOf(subClass, superClass);
}
function $2e8bc5606025d797$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $2e8bc5606025d797$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $2e8bc5606025d797$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $2e8bc5606025d797$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $2e8bc5606025d797$var$_possibleConstructorReturn(this, result);
    };
}
function $2e8bc5606025d797$var$_possibleConstructorReturn(self, call) {
    if (call && ($2e8bc5606025d797$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $2e8bc5606025d797$var$_assertThisInitialized(self);
}
function $2e8bc5606025d797$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $2e8bc5606025d797$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $2e8bc5606025d797$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$2e8bc5606025d797$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $2e8bc5606025d797$var$_construct(Class, arguments, $2e8bc5606025d797$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $2e8bc5606025d797$var$_setPrototypeOf(Wrapper, Class);
    };
    return $2e8bc5606025d797$var$_wrapNativeSuper(Class);
}
function $2e8bc5606025d797$var$_construct(Parent, args, Class) {
    if ($2e8bc5606025d797$var$_isNativeReflectConstruct()) $2e8bc5606025d797$var$_construct = Reflect.construct.bind();
    else $2e8bc5606025d797$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $2e8bc5606025d797$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $2e8bc5606025d797$var$_construct.apply(null, arguments);
}
function $2e8bc5606025d797$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $2e8bc5606025d797$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $2e8bc5606025d797$var$_setPrototypeOf(o, p) {
    $2e8bc5606025d797$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $2e8bc5606025d797$var$_setPrototypeOf(o, p);
}
function $2e8bc5606025d797$var$_getPrototypeOf(o) {
    $2e8bc5606025d797$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $2e8bc5606025d797$var$_getPrototypeOf(o);
}
function $2e8bc5606025d797$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2e8bc5606025d797$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2e8bc5606025d797$var$_typeof(o);
}

var $9kAQu = parcelRequire("9kAQu");
var $2e8bc5606025d797$var$inspect = $9kAQu.inspect;

var $8JAro = parcelRequire("8JAro");
var $2e8bc5606025d797$var$ERR_INVALID_ARG_TYPE = $8JAro.codes.ERR_INVALID_ARG_TYPE;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $2e8bc5606025d797$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $2e8bc5606025d797$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return '';
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $2e8bc5606025d797$var$blue = '';
var $2e8bc5606025d797$var$green = '';
var $2e8bc5606025d797$var$red = '';
var $2e8bc5606025d797$var$white = '';
var $2e8bc5606025d797$var$kReadableOperator = {
    deepStrictEqual: 'Expected values to be strictly deep-equal:',
    strictEqual: 'Expected values to be strictly equal:',
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: 'Expected values to be loosely deep-equal:',
    equal: 'Expected values to be loosely equal:',
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: 'Values identical but not reference-equal:'
};
// Comparing short primitives should just show === / !== instead of using the
// diff.
var $2e8bc5606025d797$var$kMaxShortLength = 10;
function $2e8bc5606025d797$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, 'message', {
        value: source.message
    });
    return target;
}
function $2e8bc5606025d797$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $2e8bc5606025d797$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $2e8bc5606025d797$var$createErrDiff(actual, expected, operator) {
    var other = '';
    var res = '';
    var lastPos = 0;
    var end = '';
    var skipped = false;
    var actualInspected = $2e8bc5606025d797$var$inspectValue(actual);
    var actualLines = actualInspected.split('\n');
    var expectedLines = $2e8bc5606025d797$var$inspectValue(expected).split('\n');
    var i = 0;
    var indicator = '';
    // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === 'strictEqual' && $2e8bc5606025d797$var$_typeof(actual) === 'object' && $2e8bc5606025d797$var$_typeof(expected) === 'object' && actual !== null && expected !== null) operator = 'strictEqualObject';
    // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length;
        // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $2e8bc5606025d797$var$kMaxShortLength) {
            if (($2e8bc5606025d797$var$_typeof(actual) !== 'object' || actual === null) && ($2e8bc5606025d797$var$_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($2e8bc5606025d797$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== 'strictEqualObject') {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $6cAn5.stderr && $6cAn5.stderr.isTTY ? $6cAn5.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($2e8bc5606025d797$var$repeat(' ', i), "^");
                    i = 0;
                }
            }
        }
    }
    // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length);
    // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split('\n');
        // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($2e8bc5606025d797$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
    }
    if (i > 3) {
        end = "\n".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white).concat(end);
        skipped = true;
    }
    if (other !== '') {
        end = "\n  ".concat(other).concat(end);
        other = '';
    }
    var printedLines = 0;
    var msg = $2e8bc5606025d797$var$kReadableOperator[operator] + "\n".concat($2e8bc5606025d797$var$green, "+ actual").concat($2e8bc5606025d797$var$white, " ").concat($2e8bc5606025d797$var$red, "- expected").concat($2e8bc5606025d797$var$white);
    var skippedMsg = " ".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the expected line to the cache.
            other += "\n".concat($2e8bc5606025d797$var$red, "-").concat($2e8bc5606025d797$var$white, " ").concat(expectedLines[i]);
            printedLines++;
        // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the actual line to the result.
            res += "\n".concat($2e8bc5606025d797$var$green, "+").concat($2e8bc5606025d797$var$white, " ").concat(actualLines[i]);
            printedLines++;
        // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i];
            // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$2e8bc5606025d797$var$endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine);
            // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $2e8bc5606025d797$var$endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ',';
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                // Mark the current line as the last diverging one.
                lastPos = i;
                // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($2e8bc5606025d797$var$green, "+").concat($2e8bc5606025d797$var$white, " ").concat(actualLine);
                other += "\n".concat($2e8bc5606025d797$var$red, "-").concat($2e8bc5606025d797$var$white, " ").concat(expectedLine);
                printedLines += 2;
            // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = '';
                // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        }
        // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white).concat(other, "\n") + "".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $2e8bc5606025d797$var$AssertionError = /*#__PURE__*/ function(_Error, _inspect$custom) {
    $2e8bc5606025d797$var$_inherits(AssertionError, _Error);
    var _super = $2e8bc5606025d797$var$_createSuper(AssertionError);
    function AssertionError(options) {
        var _this;
        $2e8bc5606025d797$var$_classCallCheck(this, AssertionError);
        if ($2e8bc5606025d797$var$_typeof(options) !== 'object' || options === null) throw new $2e8bc5606025d797$var$ERR_INVALID_ARG_TYPE('options', 'Object', options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = _super.call(this, String(message));
        else {
            if ($6cAn5.stderr && $6cAn5.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($6cAn5.stderr && $6cAn5.stderr.getColorDepth && $6cAn5.stderr.getColorDepth() !== 1) {
                    $2e8bc5606025d797$var$blue = "\x1B[34m";
                    $2e8bc5606025d797$var$green = "\x1B[32m";
                    $2e8bc5606025d797$var$white = "\x1B[39m";
                    $2e8bc5606025d797$var$red = "\x1B[31m";
                } else {
                    $2e8bc5606025d797$var$blue = '';
                    $2e8bc5606025d797$var$green = '';
                    $2e8bc5606025d797$var$white = '';
                    $2e8bc5606025d797$var$red = '';
                }
            }
            // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($2e8bc5606025d797$var$_typeof(actual) === 'object' && actual !== null && $2e8bc5606025d797$var$_typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
                actual = $2e8bc5606025d797$var$copyError(actual);
                expected = $2e8bc5606025d797$var$copyError(expected);
            }
            if (operator === 'deepStrictEqual' || operator === 'strictEqual') _this = _super.call(this, $2e8bc5606025d797$var$createErrDiff(actual, expected, operator));
            else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $2e8bc5606025d797$var$kReadableOperator[operator];
                var res = $2e8bc5606025d797$var$inspectValue(actual).split('\n');
                // In case "actual" is an object, it should not be reference equal.
                if (operator === 'notStrictEqual' && $2e8bc5606025d797$var$_typeof(actual) === 'object' && actual !== null) base = $2e8bc5606025d797$var$kReadableOperator.notStrictEqualObject;
                // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white);
                    while(res.length > 27)res.pop();
                }
                // Only print a single input.
                if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n"));
            } else {
                var _res = $2e8bc5606025d797$var$inspectValue(actual);
                var other = '';
                var knownOperators = $2e8bc5606025d797$var$kReadableOperator[operator];
                if (operator === 'notDeepEqual' || operator === 'notEqual') {
                    _res = "".concat($2e8bc5606025d797$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($2e8bc5606025d797$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === 'deepEqual' || operator === 'equal') _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = _super.call(this, "".concat(_res).concat(other));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($2e8bc5606025d797$var$_assertThisInitialized(_this), 'name', {
            value: 'AssertionError [ERR_ASSERTION]',
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = 'ERR_ASSERTION';
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($2e8bc5606025d797$var$_assertThisInitialized(_this), stackStartFn);
        // Create error message including the error code in the name.
        _this.stack;
        // Reset the name.
        _this.name = 'AssertionError';
        return $2e8bc5606025d797$var$_possibleConstructorReturn(_this);
    }
    $2e8bc5606025d797$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: _inspect$custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $2e8bc5606025d797$var$inspect(this, $2e8bc5606025d797$var$_objectSpread($2e8bc5606025d797$var$_objectSpread({}, ctx), {}, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}(/*#__PURE__*/ $2e8bc5606025d797$var$_wrapNativeSuper(Error), $2e8bc5606025d797$var$inspect.custom);
module.exports = $2e8bc5606025d797$var$AssertionError;

});

parcelRegister("8s5ew", function(module, exports) {
'use strict';

var $3WQC3 = parcelRequire("3WQC3");
var $0196883fce51d67b$var$lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = 'abcdefghijklmnopqrst';
    var letters = str.split('');
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = '';
    for(var k in obj)actual += k;
    return str !== actual;
};
var $0196883fce51d67b$var$assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, 'xy');
    } catch (e) {
        return thrower[1] === 'y';
    }
    return false;
};
module.exports = function getPolyfill() {
    if (!Object.assign) return $3WQC3;
    if ($0196883fce51d67b$var$lacksProperEnumerationOrder()) return $3WQC3;
    if ($0196883fce51d67b$var$assignHasPendingExceptions()) return $3WQC3;
    return Object.assign;
};

});
parcelRegister("3WQC3", function(module, exports) {
'use strict';

var $dZMWQ = parcelRequire("dZMWQ");

var $2dff99ad8985d37e$var$hasSymbols = (parcelRequire("9T9x9"))();

var $3T2jo = parcelRequire("3T2jo");

var $hVuCj = parcelRequire("hVuCj");
var $2dff99ad8985d37e$var$$push = $3T2jo('Array.prototype.push');
var $2dff99ad8985d37e$var$$propIsEnumerable = $3T2jo('Object.prototype.propertyIsEnumerable');
var $2dff99ad8985d37e$var$originalGetSymbols = $2dff99ad8985d37e$var$hasSymbols ? $hVuCj.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
    if (target == null) throw new TypeError('target must be an object');
    var to = $hVuCj(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = $hVuCj(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = $dZMWQ(from);
        var getSymbols = $2dff99ad8985d37e$var$hasSymbols && ($hVuCj.getOwnPropertySymbols || $2dff99ad8985d37e$var$originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($2dff99ad8985d37e$var$$propIsEnumerable(from, key)) $2dff99ad8985d37e$var$$push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($2dff99ad8985d37e$var$$propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};

});
parcelRegister("dZMWQ", function(module, exports) {
'use strict';
var $a306f0f1bb5f232a$var$slice = Array.prototype.slice;

var $1Houy = parcelRequire("1Houy");
var $a306f0f1bb5f232a$var$origKeys = Object.keys;

var $a306f0f1bb5f232a$var$keysShim = $a306f0f1bb5f232a$var$origKeys ? function keys(o) {
    return $a306f0f1bb5f232a$var$origKeys(o);
} : (parcelRequire("eQVXL"));
var $a306f0f1bb5f232a$var$originalKeys = Object.keys;
$a306f0f1bb5f232a$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($1Houy(object)) return $a306f0f1bb5f232a$var$originalKeys($a306f0f1bb5f232a$var$slice.call(object));
            return $a306f0f1bb5f232a$var$originalKeys(object);
        };
    } else Object.keys = $a306f0f1bb5f232a$var$keysShim;
    return Object.keys || $a306f0f1bb5f232a$var$keysShim;
};
module.exports = $a306f0f1bb5f232a$var$keysShim;

});
parcelRegister("1Houy", function(module, exports) {
'use strict';
var $13ccce2fa6936c75$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $13ccce2fa6936c75$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $13ccce2fa6936c75$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("eQVXL", function(module, exports) {
'use strict';
var $ad02e23a59d3730f$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $ad02e23a59d3730f$var$has = Object.prototype.hasOwnProperty;
    var $ad02e23a59d3730f$var$toStr = Object.prototype.toString;
    var $ad02e23a59d3730f$var$isArgs = (parcelRequire("1Houy")); // eslint-disable-line global-require
    var $ad02e23a59d3730f$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $ad02e23a59d3730f$var$hasDontEnumBug = !$ad02e23a59d3730f$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $ad02e23a59d3730f$var$hasProtoEnumBug = $ad02e23a59d3730f$var$isEnumerable.call(function() {}, 'prototype');
    var $ad02e23a59d3730f$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $ad02e23a59d3730f$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $ad02e23a59d3730f$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $ad02e23a59d3730f$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$ad02e23a59d3730f$var$excludedKeys['$' + k] && $ad02e23a59d3730f$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $ad02e23a59d3730f$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $ad02e23a59d3730f$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$ad02e23a59d3730f$var$hasAutomationEqualityBug) return $ad02e23a59d3730f$var$equalsConstructorPrototype(o);
        try {
            return $ad02e23a59d3730f$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $ad02e23a59d3730f$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $ad02e23a59d3730f$var$toStr.call(object) === '[object Function]';
        var isArguments = $ad02e23a59d3730f$var$isArgs(object);
        var isString = isObject && $ad02e23a59d3730f$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $ad02e23a59d3730f$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$ad02e23a59d3730f$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $ad02e23a59d3730f$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($ad02e23a59d3730f$var$hasDontEnumBug) {
            var skipConstructor = $ad02e23a59d3730f$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $ad02e23a59d3730f$var$dontEnums.length; ++k)if (!(skipConstructor && $ad02e23a59d3730f$var$dontEnums[k] === 'constructor') && $ad02e23a59d3730f$var$has.call(object, $ad02e23a59d3730f$var$dontEnums[k])) theKeys.push($ad02e23a59d3730f$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $ad02e23a59d3730f$var$keysShim;

});




parcelRegister("eJazH", function(module, exports) {
'use strict';

var $iwNFM = parcelRequire("iwNFM");
module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : $iwNFM;
};

});
parcelRegister("iwNFM", function(module, exports) {
'use strict';
var $d7d1bf25ec690182$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($d7d1bf25ec690182$var$numberIsNaN(a) && $d7d1bf25ec690182$var$numberIsNaN(b)) return true;
    return false;
};

});


parcelRegister("dztjv", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';
function $9e15485748de85e6$var$_slicedToArray(arr, i) {
    return $9e15485748de85e6$var$_arrayWithHoles(arr) || $9e15485748de85e6$var$_iterableToArrayLimit(arr, i) || $9e15485748de85e6$var$_unsupportedIterableToArray(arr, i) || $9e15485748de85e6$var$_nonIterableRest();
}
function $9e15485748de85e6$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9e15485748de85e6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9e15485748de85e6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9e15485748de85e6$var$_arrayLikeToArray(o, minLen);
}
function $9e15485748de85e6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9e15485748de85e6$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $9e15485748de85e6$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $9e15485748de85e6$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9e15485748de85e6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9e15485748de85e6$var$_typeof(o);
}
var $9e15485748de85e6$var$regexFlagsSupported = /a/g.flags !== undefined;
var $9e15485748de85e6$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $9e15485748de85e6$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $9e15485748de85e6$var$objectIs = Object.is ? Object.is : (parcelRequire("joK88"));
var $9e15485748de85e6$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $9e15485748de85e6$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("laO4W"));
function $9e15485748de85e6$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $9e15485748de85e6$var$hasOwnProperty = $9e15485748de85e6$var$uncurryThis(Object.prototype.hasOwnProperty);
var $9e15485748de85e6$var$propertyIsEnumerable = $9e15485748de85e6$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $9e15485748de85e6$var$objectToString = $9e15485748de85e6$var$uncurryThis(Object.prototype.toString);

var $9kAQu = parcelRequire("9kAQu");
var $9e15485748de85e6$require$_require$types = $9kAQu.types;
var $9e15485748de85e6$var$isAnyArrayBuffer = $9e15485748de85e6$require$_require$types.isAnyArrayBuffer, $9e15485748de85e6$var$isArrayBufferView = $9e15485748de85e6$require$_require$types.isArrayBufferView, $9e15485748de85e6$var$isDate = $9e15485748de85e6$require$_require$types.isDate, $9e15485748de85e6$var$isMap = $9e15485748de85e6$require$_require$types.isMap, $9e15485748de85e6$var$isRegExp = $9e15485748de85e6$require$_require$types.isRegExp, $9e15485748de85e6$var$isSet = $9e15485748de85e6$require$_require$types.isSet, $9e15485748de85e6$var$isNativeError = $9e15485748de85e6$require$_require$types.isNativeError, $9e15485748de85e6$var$isBoxedPrimitive = $9e15485748de85e6$require$_require$types.isBoxedPrimitive, $9e15485748de85e6$var$isNumberObject = $9e15485748de85e6$require$_require$types.isNumberObject, $9e15485748de85e6$var$isStringObject = $9e15485748de85e6$require$_require$types.isStringObject, $9e15485748de85e6$var$isBooleanObject = $9e15485748de85e6$require$_require$types.isBooleanObject, $9e15485748de85e6$var$isBigIntObject = $9e15485748de85e6$require$_require$types.isBigIntObject, $9e15485748de85e6$var$isSymbolObject = $9e15485748de85e6$require$_require$types.isSymbolObject, $9e15485748de85e6$var$isFloat32Array = $9e15485748de85e6$require$_require$types.isFloat32Array, $9e15485748de85e6$var$isFloat64Array = $9e15485748de85e6$require$_require$types.isFloat64Array;
function $9e15485748de85e6$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    }
    // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $9e15485748de85e6$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($9e15485748de85e6$var$isNonIndex).concat($9e15485748de85e6$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
}
// Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $9e15485748de85e6$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $9e15485748de85e6$var$ONLY_ENUMERABLE = undefined;
var $9e15485748de85e6$var$kStrict = true;
var $9e15485748de85e6$var$kLoose = false;
var $9e15485748de85e6$var$kNoIterator = 0;
var $9e15485748de85e6$var$kIsArray = 1;
var $9e15485748de85e6$var$kIsSet = 2;
var $9e15485748de85e6$var$kIsMap = 3;
// Check if they have the same source and flags
function $9e15485748de85e6$var$areSimilarRegExps(a, b) {
    return $9e15485748de85e6$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $9e15485748de85e6$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $9e15485748de85e6$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $9e15485748de85e6$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $9e15485748de85e6$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $9e15485748de85e6$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $9e15485748de85e6$var$isEqualBoxedPrimitive(val1, val2) {
    if ($9e15485748de85e6$var$isNumberObject(val1)) return $9e15485748de85e6$var$isNumberObject(val2) && $9e15485748de85e6$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($9e15485748de85e6$var$isStringObject(val1)) return $9e15485748de85e6$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($9e15485748de85e6$var$isBooleanObject(val1)) return $9e15485748de85e6$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($9e15485748de85e6$var$isBigIntObject(val1)) return $9e15485748de85e6$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $9e15485748de85e6$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
}
// Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $9e15485748de85e6$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $9e15485748de85e6$var$objectIs(val1, val2) : true;
    }
    // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($9e15485748de85e6$var$_typeof(val1) !== 'object') return typeof val1 === 'number' && $9e15485748de85e6$var$numberIsNaN(val1) && $9e15485748de85e6$var$numberIsNaN(val2);
        if ($9e15485748de85e6$var$_typeof(val2) !== 'object' || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $9e15485748de85e6$var$_typeof(val1) !== 'object') {
            if (val2 === null || $9e15485748de85e6$var$_typeof(val2) !== 'object') // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $9e15485748de85e6$var$_typeof(val2) !== 'object') return false;
    }
    var val1Tag = $9e15485748de85e6$var$objectToString(val1);
    var val2Tag = $9e15485748de85e6$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $9e15485748de85e6$var$getOwnNonIndexProperties(val1, $9e15485748de85e6$var$ONLY_ENUMERABLE);
        var keys2 = $9e15485748de85e6$var$getOwnNonIndexProperties(val2, $9e15485748de85e6$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $9e15485748de85e6$var$keyCheck(val1, val2, strict, memos, $9e15485748de85e6$var$kIsArray, keys1);
    }
    // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === '[object Object]') {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$9e15485748de85e6$var$isMap(val1) && $9e15485748de85e6$var$isMap(val2) || !$9e15485748de85e6$var$isSet(val1) && $9e15485748de85e6$var$isSet(val2)) return false;
    }
    if ($9e15485748de85e6$var$isDate(val1)) {
        if (!$9e15485748de85e6$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($9e15485748de85e6$var$isRegExp(val1)) {
        if (!$9e15485748de85e6$var$isRegExp(val2) || !$9e15485748de85e6$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($9e15485748de85e6$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($9e15485748de85e6$var$isArrayBufferView(val1)) {
        if (!strict && ($9e15485748de85e6$var$isFloat32Array(val1) || $9e15485748de85e6$var$isFloat64Array(val1))) {
            if (!$9e15485748de85e6$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$9e15485748de85e6$var$areSimilarTypedArrays(val1, val2)) return false;
        // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $9e15485748de85e6$var$getOwnNonIndexProperties(val1, $9e15485748de85e6$var$ONLY_ENUMERABLE);
        var _keys2 = $9e15485748de85e6$var$getOwnNonIndexProperties(val2, $9e15485748de85e6$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $9e15485748de85e6$var$keyCheck(val1, val2, strict, memos, $9e15485748de85e6$var$kNoIterator, _keys);
    } else if ($9e15485748de85e6$var$isSet(val1)) {
        if (!$9e15485748de85e6$var$isSet(val2) || val1.size !== val2.size) return false;
        return $9e15485748de85e6$var$keyCheck(val1, val2, strict, memos, $9e15485748de85e6$var$kIsSet);
    } else if ($9e15485748de85e6$var$isMap(val1)) {
        if (!$9e15485748de85e6$var$isMap(val2) || val1.size !== val2.size) return false;
        return $9e15485748de85e6$var$keyCheck(val1, val2, strict, memos, $9e15485748de85e6$var$kIsMap);
    } else if ($9e15485748de85e6$var$isAnyArrayBuffer(val1)) {
        if (!$9e15485748de85e6$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($9e15485748de85e6$var$isBoxedPrimitive(val1) && !$9e15485748de85e6$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $9e15485748de85e6$var$keyCheck(val1, val2, strict, memos, $9e15485748de85e6$var$kNoIterator);
}
function $9e15485748de85e6$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $9e15485748de85e6$var$propertyIsEnumerable(val, k);
    });
}
function $9e15485748de85e6$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2);
        // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    }
    // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$9e15485748de85e6$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $9e15485748de85e6$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($9e15485748de85e6$var$propertyIsEnumerable(val1, key)) {
                    if (!$9e15485748de85e6$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($9e15485748de85e6$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $9e15485748de85e6$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $9e15485748de85e6$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $9e15485748de85e6$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $9e15485748de85e6$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $9e15485748de85e6$var$kNoIterator || iterationType === $9e15485748de85e6$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
    // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $9e15485748de85e6$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $9e15485748de85e6$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $9e15485748de85e6$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($9e15485748de85e6$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
}
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $9e15485748de85e6$var$findLooseMatchingPrimitives(prim) {
    switch($9e15485748de85e6$var$_typeof(prim)){
        case 'undefined':
            return null;
        case 'object':
            // Only pass in null as object!
            return undefined;
        case 'symbol':
            return false;
        case 'string':
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case 'number':
            if ($9e15485748de85e6$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $9e15485748de85e6$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $9e15485748de85e6$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $9e15485748de85e6$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $9e15485748de85e6$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$9e15485748de85e6$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $9e15485748de85e6$var$innerDeepEqual(item, curB, false, memo);
}
function $9e15485748de85e6$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $9e15485748de85e6$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i];
        // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($9e15485748de85e6$var$_typeof(val) === 'object' && val !== null) {
            if (set === null) set = new Set();
            // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false;
            // Fast path to detect missing string, symbol, undefined and null values.
            if (!$9e15485748de85e6$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $9e15485748de85e6$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i];
            // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($9e15485748de85e6$var$_typeof(_val) === 'object' && _val !== null) {
                if (!$9e15485748de85e6$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$9e15485748de85e6$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $9e15485748de85e6$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $9e15485748de85e6$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($9e15485748de85e6$var$innerDeepEqual(key1, key2, strict, memo) && $9e15485748de85e6$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $9e15485748de85e6$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $9e15485748de85e6$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $9e15485748de85e6$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($9e15485748de85e6$var$_typeof(key) === 'object' && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$9e15485748de85e6$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false;
                // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$9e15485748de85e6$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $9e15485748de85e6$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $9e15485748de85e6$var$_slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($9e15485748de85e6$var$_typeof(_key) === 'object' && _key !== null) {
                if (!$9e15485748de85e6$var$mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(_key) || !$9e15485748de85e6$var$innerDeepEqual(a.get(_key), item, false, memo)) && !$9e15485748de85e6$var$mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $9e15485748de85e6$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $9e15485748de85e6$var$kIsSet) {
        if (!$9e15485748de85e6$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $9e15485748de85e6$var$kIsMap) {
        if (!$9e15485748de85e6$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $9e15485748de85e6$var$kIsArray) for(; i < a.length; i++){
        if ($9e15485748de85e6$var$hasOwnProperty(a, i)) {
            if (!$9e15485748de85e6$var$hasOwnProperty(b, i) || !$9e15485748de85e6$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($9e15485748de85e6$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$9e15485748de85e6$var$hasOwnProperty(b, key) || !$9e15485748de85e6$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
    // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key2 = keys[i];
        if (!$9e15485748de85e6$var$innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
    }
    return true;
}
function $9e15485748de85e6$var$isDeepEqual(val1, val2) {
    return $9e15485748de85e6$var$innerDeepEqual(val1, val2, $9e15485748de85e6$var$kLoose);
}
function $9e15485748de85e6$var$isDeepStrictEqual(val1, val2) {
    return $9e15485748de85e6$var$innerDeepEqual(val1, val2, $9e15485748de85e6$var$kStrict);
}
module.exports = {
    isDeepEqual: $9e15485748de85e6$var$isDeepEqual,
    isDeepStrictEqual: $9e15485748de85e6$var$isDeepStrictEqual
};

});
parcelRegister("joK88", function(module, exports) {
'use strict';

var $d94D2 = parcelRequire("d94D2");

var $h05ZS = parcelRequire("h05ZS");

var $iwNFM = parcelRequire("iwNFM");

var $eJazH = parcelRequire("eJazH");

var $90RaO = parcelRequire("90RaO");
var $e1f40ab7009ea590$var$polyfill = $h05ZS($eJazH(), Object);
$d94D2($e1f40ab7009ea590$var$polyfill, {
    getPolyfill: $eJazH,
    implementation: $iwNFM,
    shim: $90RaO
});
module.exports = $e1f40ab7009ea590$var$polyfill;

});
parcelRegister("d94D2", function(module, exports) {
'use strict';

var $dZMWQ = parcelRequire("dZMWQ");
var $991fb4ca00f3da54$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $991fb4ca00f3da54$var$toStr = Object.prototype.toString;
var $991fb4ca00f3da54$var$concat = Array.prototype.concat;

var $le88V = parcelRequire("le88V");
var $991fb4ca00f3da54$var$isFunction = function(fn) {
    return typeof fn === 'function' && $991fb4ca00f3da54$var$toStr.call(fn) === '[object Function]';
};

var $991fb4ca00f3da54$var$supportsDescriptors = (parcelRequire("9lmlE"))();
var $991fb4ca00f3da54$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$991fb4ca00f3da54$var$isFunction(predicate) || !predicate()) return;
    }
    if ($991fb4ca00f3da54$var$supportsDescriptors) $le88V(object, name, value, true);
    else $le88V(object, name, value);
};
var $991fb4ca00f3da54$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $dZMWQ(map);
    if ($991fb4ca00f3da54$var$hasSymbols) props = $991fb4ca00f3da54$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$991fb4ca00f3da54$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$991fb4ca00f3da54$var$defineProperties.supportsDescriptors = !!$991fb4ca00f3da54$var$supportsDescriptors;
module.exports = $991fb4ca00f3da54$var$defineProperties;

});

parcelRegister("90RaO", function(module, exports) {
'use strict';

var $eJazH = parcelRequire("eJazH");

var $d94D2 = parcelRequire("d94D2");
module.exports = function shimObjectIs() {
    var polyfill = $eJazH();
    $d94D2(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("laO4W", function(module, exports) {
'use strict';

var $h05ZS = parcelRequire("h05ZS");

var $d94D2 = parcelRequire("d94D2");

var $hdPWo = parcelRequire("hdPWo");

var $gmOnv = parcelRequire("gmOnv");

var $hXuHX = parcelRequire("hXuHX");
var $f6a160b687432d3b$var$polyfill = $h05ZS($gmOnv(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $d94D2($f6a160b687432d3b$var$polyfill, {
    getPolyfill: $gmOnv,
    implementation: $hdPWo,
    shim: $hXuHX
});
module.exports = $f6a160b687432d3b$var$polyfill;

});
parcelRegister("hdPWo", function(module, exports) {
'use strict';
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRegister("gmOnv", function(module, exports) {
'use strict';

var $hdPWo = parcelRequire("hdPWo");
module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) return Number.isNaN;
    return $hdPWo;
};

});

parcelRegister("hXuHX", function(module, exports) {
'use strict';

var $d94D2 = parcelRequire("d94D2");

var $gmOnv = parcelRequire("gmOnv");
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $gmOnv();
    $d94D2(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});




parcelRegister("d6D31", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SuppressWarnings = module.exports.Override = module.exports.Nullable = module.exports.NotNull = void 0;
function $98aa1ff32ce30be5$var$NotNull(target, propertyKey, propertyDescriptor) {
// intentionally empty
}
module.exports.NotNull = $98aa1ff32ce30be5$var$NotNull;
function $98aa1ff32ce30be5$var$Nullable(target, propertyKey, propertyDescriptor) {
// intentionally empty
}
module.exports.Nullable = $98aa1ff32ce30be5$var$Nullable;
function $98aa1ff32ce30be5$var$Override(target, propertyKey, propertyDescriptor) {
// do something with 'target' ...
}
module.exports.Override = $98aa1ff32ce30be5$var$Override;
function $98aa1ff32ce30be5$var$SuppressWarnings(options) {
    return (target, propertyKey, descriptor)=>{
    // intentionally empty
    };
}
module.exports.SuppressWarnings = $98aa1ff32ce30be5$var$SuppressWarnings;

});

parcelRegister("ceaEj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntStream = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:51.6934376-07:00
var $8e6f0d8930cd60b2$var$IntStream;
(function(IntStream) {
    /**
     * The value returned by {@link #LA LA()} when the end of the stream is
     * reached.
     */ IntStream.EOF = -1;
    /**
     * The value returned by {@link #getSourceName} when the actual name of the
     * underlying source is not known.
     */ IntStream.UNKNOWN_SOURCE_NAME = "<unknown>";
})($8e6f0d8930cd60b2$var$IntStream = module.exports.IntStream || (module.exports.IntStream = {}));

});


parcelRegister("b0kN8", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $802fd28fa76a2f4f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BailErrorStrategy = void 0;

var $4CCJj = parcelRequire("4CCJj");

var $iLUMi = parcelRequire("iLUMi");

var $d6D31 = parcelRequire("d6D31");

var $3kXUy = parcelRequire("3kXUy");
/**
 * This implementation of {@link ANTLRErrorStrategy} responds to syntax errors
 * by immediately canceling the parse operation with a
 * {@link ParseCancellationException}. The implementation ensures that the
 * {@link ParserRuleContext#exception} field is set for all parse tree nodes
 * that were not completed prior to encountering the error.
 *
 * This error strategy is useful in the following scenarios.
 *
 * * **Two-stage parsing:** This error strategy allows the first
 *   stage of two-stage parsing to immediately terminate if an error is
 *   encountered, and immediately fall back to the second stage. In addition to
 *   avoiding wasted work by attempting to recover from errors here, the empty
 *   implementation of {@link BailErrorStrategy#sync} improves the performance of
 *   the first stage.
 * * **Silent validation:** When syntax errors are not being
 *   reported or logged, and the parse result is simply ignored if errors occur,
 *   the {@link BailErrorStrategy} avoids wasting work on recovering from errors
 *   when the result will be ignored either way.
 *
 * ```
 * myparser.errorHandler = new BailErrorStrategy();
 * ```
 *
 * @see Parser.errorHandler
 */ class $802fd28fa76a2f4f$var$BailErrorStrategy extends $4CCJj.DefaultErrorStrategy {
    /** Instead of recovering from exception `e`, re-throw it wrapped
     *  in a {@link ParseCancellationException} so it is not caught by the
     *  rule function catches.  Use {@link Exception#getCause()} to get the
     *  original {@link RecognitionException}.
     */ recover(recognizer, e) {
        for(let context = recognizer.context; context; context = context.parent)context.exception = e;
        throw new $3kXUy.ParseCancellationException(e);
    }
    /** Make sure we don't attempt to recover inline; if the parser
     *  successfully recovers, it won't throw an exception.
     */ recoverInline(recognizer) {
        let e = new $iLUMi.InputMismatchException(recognizer);
        for(let context = recognizer.context; context; context = context.parent)context.exception = e;
        throw new $3kXUy.ParseCancellationException(e);
    }
    /** Make sure we don't attempt to recover from problems in subrules. */ sync(recognizer) {
    // intentionally empty
    }
}
$802fd28fa76a2f4f$var$__decorate([
    $d6D31.Override
], $802fd28fa76a2f4f$var$BailErrorStrategy.prototype, "recover", null);
$802fd28fa76a2f4f$var$__decorate([
    $d6D31.Override
], $802fd28fa76a2f4f$var$BailErrorStrategy.prototype, "recoverInline", null);
$802fd28fa76a2f4f$var$__decorate([
    $d6D31.Override
], $802fd28fa76a2f4f$var$BailErrorStrategy.prototype, "sync", null);
module.exports.BailErrorStrategy = $802fd28fa76a2f4f$var$BailErrorStrategy;

});
parcelRegister("4CCJj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $35d8c0fbab48edc4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $35d8c0fbab48edc4$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultErrorStrategy = void 0;

var $7j0Pc = parcelRequire("7j0Pc");

var $1bs3X = parcelRequire("1bs3X");

var $ea0YW = parcelRequire("ea0YW");

var $iLUMi = parcelRequire("iLUMi");

var $hGRod = parcelRequire("hGRod");

var $hKCjP = parcelRequire("hKCjP");

var $8DTT0 = parcelRequire("8DTT0");

var $2DVsz = parcelRequire("2DVsz");

var $d6D31 = parcelRequire("d6D31");
/**
 * This is the default implementation of {@link ANTLRErrorStrategy} used for
 * error reporting and recovery in ANTLR parsers.
 */ class $35d8c0fbab48edc4$var$DefaultErrorStrategy {
    constructor(){
        /**
         * Indicates whether the error strategy is currently "recovering from an
         * error". This is used to suppress reporting multiple error messages while
         * attempting to recover from a detected syntax error.
         *
         * @see #inErrorRecoveryMode
         */ this.errorRecoveryMode = false;
        /** The index into the input stream where the last error occurred.
         * 	This is used to prevent infinite loops where an error is found
         *  but no token is consumed during recovery...another error is found,
         *  ad nauseum.  This is a failsafe mechanism to guarantee that at least
         *  one token/tree node is consumed for two errors.
         */ this.lastErrorIndex = -1;
        /**
         * @see #nextTokensContext
         */ this.nextTokensState = $7j0Pc.ATNState.INVALID_STATE_NUMBER;
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation simply calls {@link #endErrorCondition} to
     * ensure that the handler is not in error recovery mode.
     */ reset(recognizer) {
        this.endErrorCondition(recognizer);
    }
    /**
     * This method is called to enter error recovery mode when a recognition
     * exception is reported.
     *
     * @param recognizer the parser instance
     */ beginErrorCondition(recognizer) {
        this.errorRecoveryMode = true;
    }
    /**
     * {@inheritDoc}
     */ inErrorRecoveryMode(recognizer) {
        return this.errorRecoveryMode;
    }
    /**
     * This method is called to leave error recovery mode after recovering from
     * a recognition exception.
     *
     * @param recognizer
     */ endErrorCondition(recognizer) {
        this.errorRecoveryMode = false;
        this.lastErrorStates = undefined;
        this.lastErrorIndex = -1;
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation simply calls {@link #endErrorCondition}.
     */ reportMatch(recognizer) {
        this.endErrorCondition(recognizer);
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation returns immediately if the handler is already
     * in error recovery mode. Otherwise, it calls {@link #beginErrorCondition}
     * and dispatches the reporting task based on the runtime type of `e`
     * according to the following table.
     *
     * * {@link NoViableAltException}: Dispatches the call to
     *   {@link #reportNoViableAlternative}
     * * {@link InputMismatchException}: Dispatches the call to
     *   {@link #reportInputMismatch}
     * * {@link FailedPredicateException}: Dispatches the call to
     *   {@link #reportFailedPredicate}
     * * All other types: calls {@link Parser#notifyErrorListeners} to report
     *   the exception
     */ reportError(recognizer, e) {
        // if we've already reported an error and have not matched a token
        // yet successfully, don't report any errors.
        if (this.inErrorRecoveryMode(recognizer)) //			System.err.print("[SPURIOUS] ");
        return; // don't report spurious errors
        this.beginErrorCondition(recognizer);
        if (e instanceof $hKCjP.NoViableAltException) this.reportNoViableAlternative(recognizer, e);
        else if (e instanceof $iLUMi.InputMismatchException) this.reportInputMismatch(recognizer, e);
        else if (e instanceof $ea0YW.FailedPredicateException) this.reportFailedPredicate(recognizer, e);
        else {
            console.error(`unknown recognition error type: ${e}`);
            this.notifyErrorListeners(recognizer, e.toString(), e);
        }
    }
    notifyErrorListeners(recognizer, message, e) {
        let offendingToken = e.getOffendingToken(recognizer);
        if (offendingToken === undefined) // Pass null to notifyErrorListeners so it in turn calls the error listeners with undefined as the offending
        // token. If we passed undefined, it would instead call the listeners with currentToken from the parser.
        offendingToken = null;
        recognizer.notifyErrorListeners(message, offendingToken, e);
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation resynchronizes the parser by consuming tokens
     * until we find one in the resynchronization set--loosely the set of tokens
     * that can follow the current rule.
     */ recover(recognizer, e) {
        //		System.out.println("recover in "+recognizer.getRuleInvocationStack()+
        //						   " index="+recognizer.inputStream.index+
        //						   ", lastErrorIndex="+
        //						   lastErrorIndex+
        //						   ", states="+lastErrorStates);
        if (this.lastErrorIndex === recognizer.inputStream.index && this.lastErrorStates && this.lastErrorStates.contains(recognizer.state)) // uh oh, another error at same token index and previously-visited
        // state in ATN; must be a case where LT(1) is in the recovery
        // token set so nothing got consumed. Consume a single token
        // at least to prevent an infinite loop; this is a failsafe.
        //			System.err.println("seen error condition before index="+
        //							   lastErrorIndex+", states="+lastErrorStates);
        //			System.err.println("FAILSAFE consumes "+recognizer.getTokenNames()[recognizer.inputStream.LA(1)]);
        recognizer.consume();
        this.lastErrorIndex = recognizer.inputStream.index;
        if (!this.lastErrorStates) this.lastErrorStates = new $hGRod.IntervalSet();
        this.lastErrorStates.add(recognizer.state);
        let followSet = this.getErrorRecoverySet(recognizer);
        this.consumeUntil(recognizer, followSet);
    }
    /**
     * The default implementation of {@link ANTLRErrorStrategy#sync} makes sure
     * that the current lookahead symbol is consistent with what were expecting
     * at this point in the ATN. You can call this anytime but ANTLR only
     * generates code to check before subrules/loops and each iteration.
     *
     * Implements Jim Idle's magic sync mechanism in closures and optional
     * subrules. E.g.,
     *
     * ```antlr
     * a : sync ( stuff sync )* ;
     * sync : {consume to what can follow sync} ;
     * ```
     *
     * At the start of a sub rule upon error, {@link #sync} performs single
     * token deletion, if possible. If it can't do that, it bails on the current
     * rule and uses the default error recovery, which consumes until the
     * resynchronization set of the current rule.
     *
     * If the sub rule is optional (`(...)?`, `(...)*`, or block
     * with an empty alternative), then the expected set includes what follows
     * the subrule.
     *
     * During loop iteration, it consumes until it sees a token that can start a
     * sub rule or what follows loop. Yes, that is pretty aggressive. We opt to
     * stay in the loop as long as possible.
     *
     * **ORIGINS**
     *
     * Previous versions of ANTLR did a poor job of their recovery within loops.
     * A single mismatch token or missing token would force the parser to bail
     * out of the entire rules surrounding the loop. So, for rule
     *
     * ```antlr
     * classDef : 'class' ID '{' member* '}'
     * ```
     *
     * input with an extra token between members would force the parser to
     * consume until it found the next class definition rather than the next
     * member definition of the current class.
     *
     * This functionality cost a little bit of effort because the parser has to
     * compare token set at the start of the loop and at each iteration. If for
     * some reason speed is suffering for you, you can turn off this
     * functionality by simply overriding this method as a blank { }.
     */ sync(recognizer) {
        let s = recognizer.interpreter.atn.states[recognizer.state];
        //		System.err.println("sync @ "+s.stateNumber+"="+s.getClass().getSimpleName());
        // If already recovering, don't try to sync
        if (this.inErrorRecoveryMode(recognizer)) return;
        let tokens = recognizer.inputStream;
        let la = tokens.LA(1);
        // try cheaper subset first; might get lucky. seems to shave a wee bit off
        let nextTokens = recognizer.atn.nextTokens(s);
        if (nextTokens.contains(la)) {
            // We are sure the token matches
            this.nextTokensContext = undefined;
            this.nextTokensState = $7j0Pc.ATNState.INVALID_STATE_NUMBER;
            return;
        }
        if (nextTokens.contains($2DVsz.Token.EPSILON)) {
            if (this.nextTokensContext === undefined) {
                // It's possible the next token won't match; information tracked
                // by sync is restricted for performance.
                this.nextTokensContext = recognizer.context;
                this.nextTokensState = recognizer.state;
            }
            return;
        }
        switch(s.stateType){
            case $1bs3X.ATNStateType.BLOCK_START:
            case $1bs3X.ATNStateType.STAR_BLOCK_START:
            case $1bs3X.ATNStateType.PLUS_BLOCK_START:
            case $1bs3X.ATNStateType.STAR_LOOP_ENTRY:
                // report error and recover if possible
                if (this.singleTokenDeletion(recognizer)) return;
                throw new $iLUMi.InputMismatchException(recognizer);
            case $1bs3X.ATNStateType.PLUS_LOOP_BACK:
            case $1bs3X.ATNStateType.STAR_LOOP_BACK:
                //			System.err.println("at loop back: "+s.getClass().getSimpleName());
                this.reportUnwantedToken(recognizer);
                let expecting = recognizer.getExpectedTokens();
                let whatFollowsLoopIterationOrRule = expecting.or(this.getErrorRecoverySet(recognizer));
                this.consumeUntil(recognizer, whatFollowsLoopIterationOrRule);
                break;
            default:
                break;
        }
    }
    /**
     * This is called by {@link #reportError} when the exception is a
     * {@link NoViableAltException}.
     *
     * @see #reportError
     *
     * @param recognizer the parser instance
     * @param e the recognition exception
     */ reportNoViableAlternative(recognizer, e) {
        let tokens = recognizer.inputStream;
        let input;
        if (tokens) {
            if (e.startToken.type === $2DVsz.Token.EOF) input = "<EOF>";
            else input = tokens.getTextFromRange(e.startToken, e.getOffendingToken());
        } else input = "<unknown input>";
        let msg = "no viable alternative at input " + this.escapeWSAndQuote(input);
        this.notifyErrorListeners(recognizer, msg, e);
    }
    /**
     * This is called by {@link #reportError} when the exception is an
     * {@link InputMismatchException}.
     *
     * @see #reportError
     *
     * @param recognizer the parser instance
     * @param e the recognition exception
     */ reportInputMismatch(recognizer, e) {
        let expected = e.expectedTokens;
        let expectedString = expected ? expected.toStringVocabulary(recognizer.vocabulary) : "";
        let msg = "mismatched input " + this.getTokenErrorDisplay(e.getOffendingToken(recognizer)) + " expecting " + expectedString;
        this.notifyErrorListeners(recognizer, msg, e);
    }
    /**
     * This is called by {@link #reportError} when the exception is a
     * {@link FailedPredicateException}.
     *
     * @see #reportError
     *
     * @param recognizer the parser instance
     * @param e the recognition exception
     */ reportFailedPredicate(recognizer, e) {
        let ruleName = recognizer.ruleNames[recognizer.context.ruleIndex];
        let msg = "rule " + ruleName + " " + e.message;
        this.notifyErrorListeners(recognizer, msg, e);
    }
    /**
     * This method is called to report a syntax error which requires the removal
     * of a token from the input stream. At the time this method is called, the
     * erroneous symbol is current `LT(1)` symbol and has not yet been
     * removed from the input stream. When this method returns,
     * `recognizer` is in error recovery mode.
     *
     * This method is called when {@link #singleTokenDeletion} identifies
     * single-token deletion as a viable recovery strategy for a mismatched
     * input error.
     *
     * The default implementation simply returns if the handler is already in
     * error recovery mode. Otherwise, it calls {@link #beginErrorCondition} to
     * enter error recovery mode, followed by calling
     * {@link Parser#notifyErrorListeners}.
     *
     * @param recognizer the parser instance
     */ reportUnwantedToken(recognizer) {
        if (this.inErrorRecoveryMode(recognizer)) return;
        this.beginErrorCondition(recognizer);
        let t = recognizer.currentToken;
        let tokenName = this.getTokenErrorDisplay(t);
        let expecting = this.getExpectedTokens(recognizer);
        let msg = "extraneous input " + tokenName + " expecting " + expecting.toStringVocabulary(recognizer.vocabulary);
        recognizer.notifyErrorListeners(msg, t, undefined);
    }
    /**
     * This method is called to report a syntax error which requires the
     * insertion of a missing token into the input stream. At the time this
     * method is called, the missing token has not yet been inserted. When this
     * method returns, `recognizer` is in error recovery mode.
     *
     * This method is called when {@link #singleTokenInsertion} identifies
     * single-token insertion as a viable recovery strategy for a mismatched
     * input error.
     *
     * The default implementation simply returns if the handler is already in
     * error recovery mode. Otherwise, it calls {@link #beginErrorCondition} to
     * enter error recovery mode, followed by calling
     * {@link Parser#notifyErrorListeners}.
     *
     * @param recognizer the parser instance
     */ reportMissingToken(recognizer) {
        if (this.inErrorRecoveryMode(recognizer)) return;
        this.beginErrorCondition(recognizer);
        let t = recognizer.currentToken;
        let expecting = this.getExpectedTokens(recognizer);
        let msg = "missing " + expecting.toStringVocabulary(recognizer.vocabulary) + " at " + this.getTokenErrorDisplay(t);
        recognizer.notifyErrorListeners(msg, t, undefined);
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation attempts to recover from the mismatched input
     * by using single token insertion and deletion as described below. If the
     * recovery attempt fails, this method
     * {@link InputMismatchException}.
     *
     * **EXTRA TOKEN** (single token deletion)
     *
     * `LA(1)` is not what we are looking for. If `LA(2)` has the
     * right token, however, then assume `LA(1)` is some extra spurious
     * token and delete it. Then consume and return the next token (which was
     * the `LA(2)` token) as the successful result of the match operation.
     *
     * This recovery strategy is implemented by {@link #singleTokenDeletion}.
     *
     * **MISSING TOKEN** (single token insertion)
     *
     * If current token (at `LA(1)`) is consistent with what could come
     * after the expected `LA(1)` token, then assume the token is missing
     * and use the parser's {@link TokenFactory} to create it on the fly. The
     * "insertion" is performed by returning the created token as the successful
     * result of the match operation.
     *
     * This recovery strategy is implemented by {@link #singleTokenInsertion}.
     *
     * **EXAMPLE**
     *
     * For example, Input `i=(3;` is clearly missing the `')'`. When
     * the parser returns from the nested call to `expr`, it will have
     * call chain:
     *
     * ```
     * stat → expr → atom
     * ```
     *
     * and it will be trying to match the `')'` at this point in the
     * derivation:
     *
     * ```
     * => ID '=' '(' INT ')' ('+' atom)* ';'
     *                    ^
     * ```
     *
     * The attempt to match `')'` will fail when it sees `';'` and
     * call {@link #recoverInline}. To recover, it sees that `LA(1)==';'`
     * is in the set of tokens that can follow the `')'` token reference
     * in rule `atom`. It can assume that you forgot the `')'`.
     */ recoverInline(recognizer) {
        // SINGLE TOKEN DELETION
        let matchedSymbol = this.singleTokenDeletion(recognizer);
        if (matchedSymbol) {
            // we have deleted the extra token.
            // now, move past ttype token as if all were ok
            recognizer.consume();
            return matchedSymbol;
        }
        // SINGLE TOKEN INSERTION
        if (this.singleTokenInsertion(recognizer)) return this.getMissingSymbol(recognizer);
        // even that didn't work; must throw the exception
        if (this.nextTokensContext === undefined) throw new $iLUMi.InputMismatchException(recognizer);
        else throw new $iLUMi.InputMismatchException(recognizer, this.nextTokensState, this.nextTokensContext);
    }
    /**
     * This method implements the single-token insertion inline error recovery
     * strategy. It is called by {@link #recoverInline} if the single-token
     * deletion strategy fails to recover from the mismatched input. If this
     * method returns `true`, `recognizer` will be in error recovery
     * mode.
     *
     * This method determines whether or not single-token insertion is viable by
     * checking if the `LA(1)` input symbol could be successfully matched
     * if it were instead the `LA(2)` symbol. If this method returns
     * `true`, the caller is responsible for creating and inserting a
     * token with the correct type to produce this behavior.
     *
     * @param recognizer the parser instance
     * @returns `true` if single-token insertion is a viable recovery
     * strategy for the current mismatched input, otherwise `false`
     */ singleTokenInsertion(recognizer) {
        let currentSymbolType = recognizer.inputStream.LA(1);
        // if current token is consistent with what could come after current
        // ATN state, then we know we're missing a token; error recovery
        // is free to conjure up and insert the missing token
        let currentState = recognizer.interpreter.atn.states[recognizer.state];
        let next = currentState.transition(0).target;
        let atn = recognizer.interpreter.atn;
        let expectingAtLL2 = atn.nextTokens(next, $8DTT0.PredictionContext.fromRuleContext(atn, recognizer.context));
        //		console.warn("LT(2) set="+expectingAtLL2.toString(recognizer.getTokenNames()));
        if (expectingAtLL2.contains(currentSymbolType)) {
            this.reportMissingToken(recognizer);
            return true;
        }
        return false;
    }
    /**
     * This method implements the single-token deletion inline error recovery
     * strategy. It is called by {@link #recoverInline} to attempt to recover
     * from mismatched input. If this method returns `undefined`, the parser and error
     * handler state will not have changed. If this method returns non-`undefined`,
     * `recognizer` will *not* be in error recovery mode since the
     * returned token was a successful match.
     *
     * If the single-token deletion is successful, this method calls
     * {@link #reportUnwantedToken} to report the error, followed by
     * {@link Parser#consume} to actually "delete" the extraneous token. Then,
     * before returning {@link #reportMatch} is called to signal a successful
     * match.
     *
     * @param recognizer the parser instance
     * @returns the successfully matched {@link Token} instance if single-token
     * deletion successfully recovers from the mismatched input, otherwise
     * `undefined`
     */ singleTokenDeletion(recognizer) {
        let nextTokenType = recognizer.inputStream.LA(2);
        let expecting = this.getExpectedTokens(recognizer);
        if (expecting.contains(nextTokenType)) {
            this.reportUnwantedToken(recognizer);
            /*
            System.err.println("recoverFromMismatchedToken deleting "+
                               ((TokenStream)recognizer.inputStream).LT(1)+
                               " since "+((TokenStream)recognizer.inputStream).LT(2)+
                               " is what we want");
            */ recognizer.consume(); // simply delete extra token
            // we want to return the token we're actually matching
            let matchedSymbol = recognizer.currentToken;
            this.reportMatch(recognizer); // we know current token is correct
            return matchedSymbol;
        }
        return undefined;
    }
    /** Conjure up a missing token during error recovery.
     *
     *  The recognizer attempts to recover from single missing
     *  symbols. But, actions might refer to that missing symbol.
     *  For example, x=ID {f($x);}. The action clearly assumes
     *  that there has been an identifier matched previously and that
     *  $x points at that token. If that token is missing, but
     *  the next token in the stream is what we want we assume that
     *  this token is missing and we keep going. Because we
     *  have to return some token to replace the missing token,
     *  we have to conjure one up. This method gives the user control
     *  over the tokens returned for missing tokens. Mostly,
     *  you will want to create something special for identifier
     *  tokens. For literals such as '{' and ',', the default
     *  action in the parser or tree parser works. It simply creates
     *  a CommonToken of the appropriate type. The text will be the token.
     *  If you change what tokens must be created by the lexer,
     *  override this method to create the appropriate tokens.
     */ getMissingSymbol(recognizer) {
        let currentSymbol = recognizer.currentToken;
        let expecting = this.getExpectedTokens(recognizer);
        let expectedTokenType = $2DVsz.Token.INVALID_TYPE;
        if (!expecting.isNil) // get any element
        expectedTokenType = expecting.minElement;
        let tokenText;
        if (expectedTokenType === $2DVsz.Token.EOF) tokenText = "<missing EOF>";
        else tokenText = "<missing " + recognizer.vocabulary.getDisplayName(expectedTokenType) + ">";
        let current = currentSymbol;
        let lookback = recognizer.inputStream.tryLT(-1);
        if (current.type === $2DVsz.Token.EOF && lookback != null) current = lookback;
        return this.constructToken(recognizer.inputStream.tokenSource, expectedTokenType, tokenText, current);
    }
    constructToken(tokenSource, expectedTokenType, tokenText, current) {
        let factory = tokenSource.tokenFactory;
        let x = current.tokenSource;
        let stream = x ? x.inputStream : undefined;
        return factory.create({
            source: tokenSource,
            stream: stream
        }, expectedTokenType, tokenText, $2DVsz.Token.DEFAULT_CHANNEL, -1, -1, current.line, current.charPositionInLine);
    }
    getExpectedTokens(recognizer) {
        return recognizer.getExpectedTokens();
    }
    /** How should a token be displayed in an error message? The default
     *  is to display just the text, but during development you might
     *  want to have a lot of information spit out.  Override in that case
     *  to use t.toString() (which, for CommonToken, dumps everything about
     *  the token). This is better than forcing you to override a method in
     *  your token objects because you don't have to go modify your lexer
     *  so that it creates a new Java type.
     */ getTokenErrorDisplay(t) {
        if (!t) return "<no token>";
        let s = this.getSymbolText(t);
        if (!s) {
            if (this.getSymbolType(t) === $2DVsz.Token.EOF) s = "<EOF>";
            else s = `<${this.getSymbolType(t)}>`;
        }
        return this.escapeWSAndQuote(s);
    }
    getSymbolText(symbol) {
        return symbol.text;
    }
    getSymbolType(symbol) {
        return symbol.type;
    }
    escapeWSAndQuote(s) {
        //		if ( s==null ) return s;
        s = s.replace("\n", "\\n");
        s = s.replace("\r", "\\r");
        s = s.replace("\t", "\\t");
        return "'" + s + "'";
    }
    /*  Compute the error recovery set for the current rule.  During
     *  rule invocation, the parser pushes the set of tokens that can
     *  follow that rule reference on the stack; this amounts to
     *  computing FIRST of what follows the rule reference in the
     *  enclosing rule. See LinearApproximator.FIRST().
     *  This local follow set only includes tokens
     *  from within the rule; i.e., the FIRST computation done by
     *  ANTLR stops at the end of a rule.
     *
     *  EXAMPLE
     *
     *  When you find a "no viable alt exception", the input is not
     *  consistent with any of the alternatives for rule r.  The best
     *  thing to do is to consume tokens until you see something that
     *  can legally follow a call to r *or* any rule that called r.
     *  You don't want the exact set of viable next tokens because the
     *  input might just be missing a token--you might consume the
     *  rest of the input looking for one of the missing tokens.
     *
     *  Consider grammar:
     *
     *  a : '[' b ']'
     *    | '(' b ')'
     *    ;
     *  b : c '^' INT ;
     *  c : ID
     *    | INT
     *    ;
     *
     *  At each rule invocation, the set of tokens that could follow
     *  that rule is pushed on a stack.  Here are the various
     *  context-sensitive follow sets:
     *
     *  FOLLOW(b1_in_a) = FIRST(']') = ']'
     *  FOLLOW(b2_in_a) = FIRST(')') = ')'
     *  FOLLOW(c_in_b) = FIRST('^') = '^'
     *
     *  Upon erroneous input "[]", the call chain is
     *
     *  a -> b -> c
     *
     *  and, hence, the follow context stack is:
     *
     *  depth     follow set       start of rule execution
     *    0         <EOF>                    a (from main())
     *    1          ']'                     b
     *    2          '^'                     c
     *
     *  Notice that ')' is not included, because b would have to have
     *  been called from a different context in rule a for ')' to be
     *  included.
     *
     *  For error recovery, we cannot consider FOLLOW(c)
     *  (context-sensitive or otherwise).  We need the combined set of
     *  all context-sensitive FOLLOW sets--the set of all tokens that
     *  could follow any reference in the call chain.  We need to
     *  resync to one of those tokens.  Note that FOLLOW(c)='^' and if
     *  we resync'd to that token, we'd consume until EOF.  We need to
     *  sync to context-sensitive FOLLOWs for a, b, and c: {']','^'}.
     *  In this case, for input "[]", LA(1) is ']' and in the set, so we would
     *  not consume anything. After printing an error, rule c would
     *  return normally.  Rule b would not find the required '^' though.
     *  At this point, it gets a mismatched token error and
     *  exception (since LA(1) is not in the viable following token
     *  set).  The rule exception handler tries to recover, but finds
     *  the same recovery set and doesn't consume anything.  Rule b
     *  exits normally returning to rule a.  Now it finds the ']' (and
     *  with the successful match exits errorRecovery mode).
     *
     *  So, you can see that the parser walks up the call chain looking
     *  for the token that was a member of the recovery set.
     *
     *  Errors are not generated in errorRecovery mode.
     *
     *  ANTLR's error recovery mechanism is based upon original ideas:
     *
     *  "Algorithms + Data Structures = Programs" by Niklaus Wirth
     *
     *  and
     *
     *  "A note on error recovery in recursive descent parsers":
     *  http://portal.acm.org/citation.cfm?id=947902.947905
     *
     *  Later, Josef Grosch had some good ideas:
     *
     *  "Efficient and Comfortable Error Recovery in Recursive Descent
     *  Parsers":
     *  ftp://www.cocolab.com/products/cocktail/doca4.ps/ell.ps.zip
     *
     *  Like Grosch I implement context-sensitive FOLLOW sets that are combined
     *  at run-time upon error to avoid overhead during parsing.
     */ getErrorRecoverySet(recognizer) {
        let atn = recognizer.interpreter.atn;
        let ctx = recognizer.context;
        let recoverSet = new $hGRod.IntervalSet();
        while(ctx && ctx.invokingState >= 0){
            // compute what follows who invoked us
            let invokingState = atn.states[ctx.invokingState];
            let rt = invokingState.transition(0);
            let follow = atn.nextTokens(rt.followState);
            recoverSet.addAll(follow);
            ctx = ctx._parent;
        }
        recoverSet.remove($2DVsz.Token.EPSILON);
        //		System.out.println("recover set "+recoverSet.toString(recognizer.getTokenNames()));
        return recoverSet;
    }
    /** Consume tokens until one matches the given token set. */ consumeUntil(recognizer, set) {
        //		System.err.println("consumeUntil("+set.toString(recognizer.getTokenNames())+")");
        let ttype = recognizer.inputStream.LA(1);
        while(ttype !== $2DVsz.Token.EOF && !set.contains(ttype)){
            //System.out.println("consume during recover LA(1)="+getTokenNames()[input.LA(1)]);
            //			recognizer.inputStream.consume();
            recognizer.consume();
            ttype = recognizer.inputStream.LA(1);
        }
    }
}
$35d8c0fbab48edc4$var$__decorate([
    $d6D31.Override
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reset", null);
$35d8c0fbab48edc4$var$__decorate([
    $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "beginErrorCondition", null);
$35d8c0fbab48edc4$var$__decorate([
    $d6D31.Override
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "inErrorRecoveryMode", null);
$35d8c0fbab48edc4$var$__decorate([
    $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "endErrorCondition", null);
$35d8c0fbab48edc4$var$__decorate([
    $d6D31.Override
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportMatch", null);
$35d8c0fbab48edc4$var$__decorate([
    $d6D31.Override
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportError", null);
$35d8c0fbab48edc4$var$__decorate([
    $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "notifyErrorListeners", null);
$35d8c0fbab48edc4$var$__decorate([
    $d6D31.Override
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "recover", null);
$35d8c0fbab48edc4$var$__decorate([
    $d6D31.Override
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "sync", null);
$35d8c0fbab48edc4$var$__decorate([
    $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull),
    $35d8c0fbab48edc4$var$__param(1, $d6D31.NotNull)
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportNoViableAlternative", null);
$35d8c0fbab48edc4$var$__decorate([
    $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull),
    $35d8c0fbab48edc4$var$__param(1, $d6D31.NotNull)
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportInputMismatch", null);
$35d8c0fbab48edc4$var$__decorate([
    $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull),
    $35d8c0fbab48edc4$var$__param(1, $d6D31.NotNull)
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportFailedPredicate", null);
$35d8c0fbab48edc4$var$__decorate([
    $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportUnwantedToken", null);
$35d8c0fbab48edc4$var$__decorate([
    $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportMissingToken", null);
$35d8c0fbab48edc4$var$__decorate([
    $d6D31.Override
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "recoverInline", null);
$35d8c0fbab48edc4$var$__decorate([
    $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "singleTokenInsertion", null);
$35d8c0fbab48edc4$var$__decorate([
    $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "singleTokenDeletion", null);
$35d8c0fbab48edc4$var$__decorate([
    $d6D31.NotNull,
    $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "getMissingSymbol", null);
$35d8c0fbab48edc4$var$__decorate([
    $d6D31.NotNull,
    $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "getExpectedTokens", null);
$35d8c0fbab48edc4$var$__decorate([
    $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "getSymbolText", null);
$35d8c0fbab48edc4$var$__decorate([
    $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "getSymbolType", null);
$35d8c0fbab48edc4$var$__decorate([
    $d6D31.NotNull,
    $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "escapeWSAndQuote", null);
$35d8c0fbab48edc4$var$__decorate([
    $d6D31.NotNull,
    $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "getErrorRecoverySet", null);
$35d8c0fbab48edc4$var$__decorate([
    $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull),
    $35d8c0fbab48edc4$var$__param(1, $d6D31.NotNull)
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "consumeUntil", null);
module.exports.DefaultErrorStrategy = $35d8c0fbab48edc4$var$DefaultErrorStrategy;

});
parcelRegister("7j0Pc", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $551af28bc8fe1b8c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNState = void 0;

var $d6D31 = parcelRequire("d6D31");
const $551af28bc8fe1b8c$var$INITIAL_NUM_TRANSITIONS = 4;
/**
 * The following images show the relation of states and
 * {@link ATNState#transitions} for various grammar constructs.
 *
 * * Solid edges marked with an &#0949; indicate a required
 *   {@link EpsilonTransition}.
 *
 * * Dashed edges indicate locations where any transition derived from
 *   {@link Transition} might appear.
 *
 * * Dashed nodes are place holders for either a sequence of linked
 *   {@link BasicState} states or the inclusion of a block representing a nested
 *   construct in one of the forms below.
 *
 * * Nodes showing multiple outgoing alternatives with a `...` support
 *   any number of alternatives (one or more). Nodes without the `...` only
 *   support the exact number of alternatives shown in the diagram.
 *
 * <h2>Basic Blocks</h2>
 *
 * <h3>Rule</h3>
 *
 * <embed src="images/Rule.svg" type="image/svg+xml"/>
 *
 * <h3>Block of 1 or more alternatives</h3>
 *
 * <embed src="images/Block.svg" type="image/svg+xml"/>
 *
 * <h2>Greedy Loops</h2>
 *
 * <h3>Greedy Closure: `(...)*`</h3>
 *
 * <embed src="images/ClosureGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Greedy Positive Closure: `(...)+`</h3>
 *
 * <embed src="images/PositiveClosureGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Greedy Optional: `(...)?`</h3>
 *
 * <embed src="images/OptionalGreedy.svg" type="image/svg+xml"/>
 *
 * <h2>Non-Greedy Loops</h2>
 *
 * <h3>Non-Greedy Closure: `(...)*?`</h3>
 *
 * <embed src="images/ClosureNonGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Non-Greedy Positive Closure: `(...)+?`</h3>
 *
 * <embed src="images/PositiveClosureNonGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Non-Greedy Optional: `(...)??`</h3>
 *
 * <embed src="images/OptionalNonGreedy.svg" type="image/svg+xml"/>
 */ class $551af28bc8fe1b8c$var$ATNState {
    constructor(){
        this.stateNumber = $551af28bc8fe1b8c$var$ATNState.INVALID_STATE_NUMBER;
        this.ruleIndex = 0; // at runtime, we don't have Rule objects
        this.epsilonOnlyTransitions = false;
        /** Track the transitions emanating from this ATN state. */ this.transitions = [];
        this.optimizedTransitions = this.transitions;
    }
    /**
     * Gets the state number.
     *
     * @returns the state number
     */ getStateNumber() {
        return this.stateNumber;
    }
    /**
     * For all states except {@link RuleStopState}, this returns the state
     * number. Returns -1 for stop states.
     *
     * @returns -1 for {@link RuleStopState}, otherwise the state number
     */ get nonStopStateNumber() {
        return this.getStateNumber();
    }
    hashCode() {
        return this.stateNumber;
    }
    equals(o) {
        // are these states same object?
        if (o instanceof $551af28bc8fe1b8c$var$ATNState) return this.stateNumber === o.stateNumber;
        return false;
    }
    get isNonGreedyExitState() {
        return false;
    }
    toString() {
        return String(this.stateNumber);
    }
    getTransitions() {
        return this.transitions.slice(0);
    }
    get numberOfTransitions() {
        return this.transitions.length;
    }
    addTransition(e, index) {
        if (this.transitions.length === 0) this.epsilonOnlyTransitions = e.isEpsilon;
        else if (this.epsilonOnlyTransitions !== e.isEpsilon) {
            this.epsilonOnlyTransitions = false;
            throw new Error("ATN state " + this.stateNumber + " has both epsilon and non-epsilon transitions.");
        }
        this.transitions.splice(index !== undefined ? index : this.transitions.length, 0, e);
    }
    transition(i) {
        return this.transitions[i];
    }
    setTransition(i, e) {
        this.transitions[i] = e;
    }
    removeTransition(index) {
        return this.transitions.splice(index, 1)[0];
    }
    get onlyHasEpsilonTransitions() {
        return this.epsilonOnlyTransitions;
    }
    setRuleIndex(ruleIndex) {
        this.ruleIndex = ruleIndex;
    }
    get isOptimized() {
        return this.optimizedTransitions !== this.transitions;
    }
    get numberOfOptimizedTransitions() {
        return this.optimizedTransitions.length;
    }
    getOptimizedTransition(i) {
        return this.optimizedTransitions[i];
    }
    addOptimizedTransition(e) {
        if (!this.isOptimized) this.optimizedTransitions = new Array();
        this.optimizedTransitions.push(e);
    }
    setOptimizedTransition(i, e) {
        if (!this.isOptimized) throw new Error("This ATNState is not optimized.");
        this.optimizedTransitions[i] = e;
    }
    removeOptimizedTransition(i) {
        if (!this.isOptimized) throw new Error("This ATNState is not optimized.");
        this.optimizedTransitions.splice(i, 1);
    }
}
$551af28bc8fe1b8c$var$__decorate([
    $d6D31.Override
], $551af28bc8fe1b8c$var$ATNState.prototype, "hashCode", null);
$551af28bc8fe1b8c$var$__decorate([
    $d6D31.Override
], $551af28bc8fe1b8c$var$ATNState.prototype, "equals", null);
$551af28bc8fe1b8c$var$__decorate([
    $d6D31.Override
], $551af28bc8fe1b8c$var$ATNState.prototype, "toString", null);
module.exports.ATNState = $551af28bc8fe1b8c$var$ATNState;
(function(ATNState) {
    ATNState.INVALID_STATE_NUMBER = -1;
})($551af28bc8fe1b8c$var$ATNState = module.exports.ATNState || (module.exports.ATNState = {}));

});

parcelRegister("1bs3X", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNStateType = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:27.4734328-07:00
var $0dcc96396a04e502$var$ATNStateType;
(function(ATNStateType) {
    ATNStateType[ATNStateType["INVALID_TYPE"] = 0] = "INVALID_TYPE";
    ATNStateType[ATNStateType["BASIC"] = 1] = "BASIC";
    ATNStateType[ATNStateType["RULE_START"] = 2] = "RULE_START";
    ATNStateType[ATNStateType["BLOCK_START"] = 3] = "BLOCK_START";
    ATNStateType[ATNStateType["PLUS_BLOCK_START"] = 4] = "PLUS_BLOCK_START";
    ATNStateType[ATNStateType["STAR_BLOCK_START"] = 5] = "STAR_BLOCK_START";
    ATNStateType[ATNStateType["TOKEN_START"] = 6] = "TOKEN_START";
    ATNStateType[ATNStateType["RULE_STOP"] = 7] = "RULE_STOP";
    ATNStateType[ATNStateType["BLOCK_END"] = 8] = "BLOCK_END";
    ATNStateType[ATNStateType["STAR_LOOP_BACK"] = 9] = "STAR_LOOP_BACK";
    ATNStateType[ATNStateType["STAR_LOOP_ENTRY"] = 10] = "STAR_LOOP_ENTRY";
    ATNStateType[ATNStateType["PLUS_LOOP_BACK"] = 11] = "PLUS_LOOP_BACK";
    ATNStateType[ATNStateType["LOOP_END"] = 12] = "LOOP_END";
})($0dcc96396a04e502$var$ATNStateType = module.exports.ATNStateType || (module.exports.ATNStateType = {}));

});

parcelRegister("ea0YW", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a4f2c2ded442ae18$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a4f2c2ded442ae18$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FailedPredicateException = void 0;

var $fLdDn = parcelRequire("fLdDn");

var $d6D31 = parcelRequire("d6D31");

var $hnaRv = parcelRequire("hnaRv");
/** A semantic predicate failed during validation.  Validation of predicates
 *  occurs when normally parsing the alternative just like matching a token.
 *  Disambiguating predicate evaluation occurs when we test a predicate during
 *  prediction.
 */ let $a4f2c2ded442ae18$var$FailedPredicateException = class FailedPredicateException extends $fLdDn.RecognitionException {
    constructor(recognizer, predicate, message){
        super(recognizer, recognizer.inputStream, recognizer.context, FailedPredicateException.formatMessage(predicate, message));
        let s = recognizer.interpreter.atn.states[recognizer.state];
        let trans = s.transition(0);
        if (trans instanceof $hnaRv.PredicateTransition) {
            this._ruleIndex = trans.ruleIndex;
            this._predicateIndex = trans.predIndex;
        } else {
            this._ruleIndex = 0;
            this._predicateIndex = 0;
        }
        this._predicate = predicate;
        super.setOffendingToken(recognizer, recognizer.currentToken);
    }
    get ruleIndex() {
        return this._ruleIndex;
    }
    get predicateIndex() {
        return this._predicateIndex;
    }
    get predicate() {
        return this._predicate;
    }
    static formatMessage(predicate, message) {
        if (message) return message;
        return `failed predicate: {${predicate}}?`;
    }
};
$a4f2c2ded442ae18$var$__decorate([
    $d6D31.NotNull
], $a4f2c2ded442ae18$var$FailedPredicateException, "formatMessage", null);
$a4f2c2ded442ae18$var$FailedPredicateException = $a4f2c2ded442ae18$var$__decorate([
    $a4f2c2ded442ae18$var$__param(0, $d6D31.NotNull)
], $a4f2c2ded442ae18$var$FailedPredicateException);
module.exports.FailedPredicateException = $a4f2c2ded442ae18$var$FailedPredicateException;

});
parcelRegister("fLdDn", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecognitionException = void 0;
/** The root of the ANTLR exception hierarchy. In general, ANTLR tracks just
 *  3 kinds of errors: prediction errors, failed predicate errors, and
 *  mismatched input errors. In each case, the parser knows where it is
 *  in the input, where it is in the ATN, the rule invocation stack,
 *  and what kind of problem occurred.
 */ class $b795d243382c1d9c$var$RecognitionException extends Error {
    constructor(recognizer, input, ctx, message){
        super(message);
        this._offendingState = -1;
        this._recognizer = recognizer;
        this.input = input;
        this.ctx = ctx;
        if (recognizer) this._offendingState = recognizer.state;
    }
    /**
     * Get the ATN state number the parser was in at the time the error
     * occurred. For {@link NoViableAltException} and
     * {@link LexerNoViableAltException} exceptions, this is the
     * {@link DecisionState} number. For others, it is the state whose outgoing
     * edge we couldn't match.
     *
     * If the state number is not known, this method returns -1.
     */ get offendingState() {
        return this._offendingState;
    }
    setOffendingState(offendingState) {
        this._offendingState = offendingState;
    }
    /**
     * Gets the set of input symbols which could potentially follow the
     * previously matched symbol at the time this exception was thrown.
     *
     * If the set of expected tokens is not known and could not be computed,
     * this method returns `undefined`.
     *
     * @returns The set of token types that could potentially follow the current
     * state in the ATN, or `undefined` if the information is not available.
     */ get expectedTokens() {
        if (this._recognizer) return this._recognizer.atn.getExpectedTokens(this._offendingState, this.ctx);
        return undefined;
    }
    /**
     * Gets the {@link RuleContext} at the time this exception was thrown.
     *
     * If the context is not available, this method returns `undefined`.
     *
     * @returns The {@link RuleContext} at the time this exception was thrown.
     * If the context is not available, this method returns `undefined`.
     */ get context() {
        return this.ctx;
    }
    /**
     * Gets the input stream which is the symbol source for the recognizer where
     * this exception was thrown.
     *
     * If the input stream is not available, this method returns `undefined`.
     *
     * @returns The input stream which is the symbol source for the recognizer
     * where this exception was thrown, or `undefined` if the stream is not
     * available.
     */ get inputStream() {
        return this.input;
    }
    getOffendingToken(recognizer) {
        if (recognizer && recognizer !== this._recognizer) return undefined;
        return this.offendingToken;
    }
    setOffendingToken(recognizer, offendingToken) {
        if (recognizer === this._recognizer) this.offendingToken = offendingToken;
    }
    /**
     * Gets the {@link Recognizer} where this exception occurred.
     *
     * If the recognizer is not available, this method returns `undefined`.
     *
     * @returns The recognizer where this exception occurred, or `undefined` if
     * the recognizer is not available.
     */ get recognizer() {
        return this._recognizer;
    }
}
module.exports.RecognitionException = $b795d243382c1d9c$var$RecognitionException;

});

parcelRegister("hnaRv", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ca5d02a3d9cef56c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $ca5d02a3d9cef56c$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredicateTransition = void 0;

var $fMVaR = parcelRequire("fMVaR");

var $d6D31 = parcelRequire("d6D31");

var $eHMgW = parcelRequire("eHMgW");
/** TODO: this is old comment:
 *  A tree of semantic predicates from the grammar AST if label==SEMPRED.
 *  In the ATN, labels will always be exactly one predicate, but the DFA
 *  may have to combine a bunch of them as it collects predicates from
 *  multiple ATN configurations into a single DFA state.
 */ let $ca5d02a3d9cef56c$var$PredicateTransition = class PredicateTransition extends $fMVaR.AbstractPredicateTransition {
    constructor(target, ruleIndex, predIndex, isCtxDependent){
        super(target);
        this.ruleIndex = ruleIndex;
        this.predIndex = predIndex;
        this.isCtxDependent = isCtxDependent;
    }
    get serializationType() {
        return 4 /* PREDICATE */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    get predicate() {
        return new $eHMgW.SemanticContext.Predicate(this.ruleIndex, this.predIndex, this.isCtxDependent);
    }
    toString() {
        return "pred_" + this.ruleIndex + ":" + this.predIndex;
    }
};
$ca5d02a3d9cef56c$var$__decorate([
    $d6D31.Override
], $ca5d02a3d9cef56c$var$PredicateTransition.prototype, "serializationType", null);
$ca5d02a3d9cef56c$var$__decorate([
    $d6D31.Override
], $ca5d02a3d9cef56c$var$PredicateTransition.prototype, "isEpsilon", null);
$ca5d02a3d9cef56c$var$__decorate([
    $d6D31.Override
], $ca5d02a3d9cef56c$var$PredicateTransition.prototype, "matches", null);
$ca5d02a3d9cef56c$var$__decorate([
    $d6D31.Override,
    $d6D31.NotNull
], $ca5d02a3d9cef56c$var$PredicateTransition.prototype, "toString", null);
$ca5d02a3d9cef56c$var$PredicateTransition = $ca5d02a3d9cef56c$var$__decorate([
    $ca5d02a3d9cef56c$var$__param(0, $d6D31.NotNull)
], $ca5d02a3d9cef56c$var$PredicateTransition);
module.exports.PredicateTransition = $ca5d02a3d9cef56c$var$PredicateTransition;

});
parcelRegister("fMVaR", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AbstractPredicateTransition = void 0;

var $5tcOQ = parcelRequire("5tcOQ");
/**
 *
 * @author Sam Harwell
 */ class $b7e7b04ea6d15f5c$var$AbstractPredicateTransition extends $5tcOQ.Transition {
    constructor(target){
        super(target);
    }
}
module.exports.AbstractPredicateTransition = $b7e7b04ea6d15f5c$var$AbstractPredicateTransition;

});
parcelRegister("5tcOQ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $3fb99acb0a3a1848$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $3fb99acb0a3a1848$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Transition = void 0;

var $d6D31 = parcelRequire("d6D31");
/** An ATN transition between any two ATN states.  Subclasses define
 *  atom, set, epsilon, action, predicate, rule transitions.
 *
 *  This is a one way link.  It emanates from a state (usually via a list of
 *  transitions) and has a target state.
 *
 *  Since we never have to change the ATN transitions once we construct it,
 *  we can fix these transitions as specific classes. The DFA transitions
 *  on the other hand need to update the labels as it adds transitions to
 *  the states. We'll use the term Edge for the DFA to distinguish them from
 *  ATN transitions.
 */ let $3fb99acb0a3a1848$var$Transition = class Transition {
    constructor(target){
        if (target == null) throw new Error("target cannot be null.");
        this.target = target;
    }
    /**
     * Determines if the transition is an "epsilon" transition.
     *
     * The default implementation returns `false`.
     *
     * @returns `true` if traversing this transition in the ATN does not
     * consume an input symbol; otherwise, `false` if traversing this
     * transition consumes (matches) an input symbol.
     */ get isEpsilon() {
        return false;
    }
    get label() {
        return undefined;
    }
};
$3fb99acb0a3a1848$var$Transition.serializationNames = [
    "INVALID",
    "EPSILON",
    "RANGE",
    "RULE",
    "PREDICATE",
    "ATOM",
    "ACTION",
    "SET",
    "NOT_SET",
    "WILDCARD",
    "PRECEDENCE"
];
$3fb99acb0a3a1848$var$__decorate([
    $d6D31.NotNull
], $3fb99acb0a3a1848$var$Transition.prototype, "target", void 0);
$3fb99acb0a3a1848$var$Transition = $3fb99acb0a3a1848$var$__decorate([
    $3fb99acb0a3a1848$var$__param(0, $d6D31.NotNull)
], $3fb99acb0a3a1848$var$Transition);
module.exports.Transition = $3fb99acb0a3a1848$var$Transition;

});


parcelRegister("eHMgW", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ab4a86b5def51fe2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $ab4a86b5def51fe2$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SemanticContext = void 0;

var $7Veax = parcelRequire("7Veax");

var $3sNxf = parcelRequire("3sNxf");

var $iXFjm = parcelRequire("iXFjm");

var $d6D31 = parcelRequire("d6D31");

var $a4Flx = parcelRequire("a4Flx");

var $2IEP9 = parcelRequire("2IEP9");
function $ab4a86b5def51fe2$var$max(items) {
    let result;
    for (let current of items){
        if (result === undefined) {
            result = current;
            continue;
        }
        let comparison = result.compareTo(current);
        if (comparison < 0) result = current;
    }
    return result;
}
function $ab4a86b5def51fe2$var$min(items) {
    let result;
    for (let current of items){
        if (result === undefined) {
            result = current;
            continue;
        }
        let comparison = result.compareTo(current);
        if (comparison > 0) result = current;
    }
    return result;
}
/** A tree structure used to record the semantic context in which
 *  an ATN configuration is valid.  It's either a single predicate,
 *  a conjunction `p1&&p2`, or a sum of products `p1||p2`.
 *
 *  I have scoped the {@link AND}, {@link OR}, and {@link Predicate} subclasses of
 *  {@link SemanticContext} within the scope of this outer class.
 */ class $ab4a86b5def51fe2$var$SemanticContext {
    /**
     * The default {@link SemanticContext}, which is semantically equivalent to
     * a predicate of the form `{true}?`.
     */ static get NONE() {
        if ($ab4a86b5def51fe2$var$SemanticContext._NONE === undefined) $ab4a86b5def51fe2$var$SemanticContext._NONE = new $ab4a86b5def51fe2$var$SemanticContext.Predicate();
        return $ab4a86b5def51fe2$var$SemanticContext._NONE;
    }
    /**
     * Evaluate the precedence predicates for the context and reduce the result.
     *
     * @param parser The parser instance.
     * @param parserCallStack
     * @returns The simplified semantic context after precedence predicates are
     * evaluated, which will be one of the following values.
     *
     * * {@link #NONE}: if the predicate simplifies to `true` after
     *   precedence predicates are evaluated.
     * * `undefined`: if the predicate simplifies to `false` after
     *   precedence predicates are evaluated.
     * * `this`: if the semantic context is not changed as a result of
     *   precedence predicate evaluation.
     * * A non-`undefined` {@link SemanticContext}: the new simplified
     *   semantic context after precedence predicates are evaluated.
     */ evalPrecedence(parser, parserCallStack) {
        return this;
    }
    static and(a, b) {
        if (!a || a === $ab4a86b5def51fe2$var$SemanticContext.NONE) return b;
        if (b === $ab4a86b5def51fe2$var$SemanticContext.NONE) return a;
        let result = new $ab4a86b5def51fe2$var$SemanticContext.AND(a, b);
        if (result.opnds.length === 1) return result.opnds[0];
        return result;
    }
    /**
     *
     *  @see ParserATNSimulator#getPredsForAmbigAlts
     */ static or(a, b) {
        if (!a) return b;
        if (a === $ab4a86b5def51fe2$var$SemanticContext.NONE || b === $ab4a86b5def51fe2$var$SemanticContext.NONE) return $ab4a86b5def51fe2$var$SemanticContext.NONE;
        let result = new $ab4a86b5def51fe2$var$SemanticContext.OR(a, b);
        if (result.opnds.length === 1) return result.opnds[0];
        return result;
    }
}
module.exports.SemanticContext = $ab4a86b5def51fe2$var$SemanticContext;
(function(SemanticContext) {
    /**
     * This random 30-bit prime represents the value of `AND.class.hashCode()`.
     */ const AND_HASHCODE = 40363613;
    /**
     * This random 30-bit prime represents the value of `OR.class.hashCode()`.
     */ const OR_HASHCODE = 486279973;
    function filterPrecedencePredicates(collection) {
        let result = [];
        for(let i = 0; i < collection.length; i++){
            let context = collection[i];
            if (context instanceof SemanticContext.PrecedencePredicate) {
                result.push(context);
                // Remove the item from 'collection' and move i back so we look at the same index again
                collection.splice(i, 1);
                i--;
            }
        }
        return result;
    }
    class Predicate extends SemanticContext {
        constructor(ruleIndex = -1, predIndex = -1, isCtxDependent = false){
            super();
            this.ruleIndex = ruleIndex;
            this.predIndex = predIndex;
            this.isCtxDependent = isCtxDependent;
        }
        eval(parser, parserCallStack) {
            let localctx = this.isCtxDependent ? parserCallStack : undefined;
            return parser.sempred(localctx, this.ruleIndex, this.predIndex);
        }
        hashCode() {
            let hashCode = $iXFjm.MurmurHash.initialize();
            hashCode = $iXFjm.MurmurHash.update(hashCode, this.ruleIndex);
            hashCode = $iXFjm.MurmurHash.update(hashCode, this.predIndex);
            hashCode = $iXFjm.MurmurHash.update(hashCode, this.isCtxDependent ? 1 : 0);
            hashCode = $iXFjm.MurmurHash.finish(hashCode, 3);
            return hashCode;
        }
        equals(obj) {
            if (!(obj instanceof Predicate)) return false;
            if (this === obj) return true;
            return this.ruleIndex === obj.ruleIndex && this.predIndex === obj.predIndex && this.isCtxDependent === obj.isCtxDependent;
        }
        toString() {
            return "{" + this.ruleIndex + ":" + this.predIndex + "}?";
        }
    }
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], Predicate.prototype, "eval", null);
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], Predicate.prototype, "hashCode", null);
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], Predicate.prototype, "equals", null);
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], Predicate.prototype, "toString", null);
    SemanticContext.Predicate = Predicate;
    class PrecedencePredicate extends SemanticContext {
        constructor(precedence){
            super();
            this.precedence = precedence;
        }
        eval(parser, parserCallStack) {
            return parser.precpred(parserCallStack, this.precedence);
        }
        evalPrecedence(parser, parserCallStack) {
            if (parser.precpred(parserCallStack, this.precedence)) return SemanticContext.NONE;
            else return undefined;
        }
        compareTo(o) {
            return this.precedence - o.precedence;
        }
        hashCode() {
            let hashCode = 1;
            hashCode = 31 * hashCode + this.precedence;
            return hashCode;
        }
        equals(obj) {
            if (!(obj instanceof PrecedencePredicate)) return false;
            if (this === obj) return true;
            return this.precedence === obj.precedence;
        }
        toString() {
            return "{" + this.precedence + ">=prec}?";
        }
    }
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], PrecedencePredicate.prototype, "eval", null);
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], PrecedencePredicate.prototype, "evalPrecedence", null);
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], PrecedencePredicate.prototype, "compareTo", null);
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], PrecedencePredicate.prototype, "hashCode", null);
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], PrecedencePredicate.prototype, "equals", null);
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], PrecedencePredicate.prototype, "toString", null);
    SemanticContext.PrecedencePredicate = PrecedencePredicate;
    /**
     * This is the base class for semantic context "operators", which operate on
     * a collection of semantic context "operands".
     *
     * @since 4.3
     */ class Operator extends SemanticContext {
    }
    SemanticContext.Operator = Operator;
    /**
     * A semantic context which is true whenever none of the contained contexts
     * is false.
     */ let AND = class AND extends Operator {
        constructor(a, b){
            super();
            let operands = new $7Veax.Array2DHashSet($a4Flx.ObjectEqualityComparator.INSTANCE);
            if (a instanceof AND) operands.addAll(a.opnds);
            else operands.add(a);
            if (b instanceof AND) operands.addAll(b.opnds);
            else operands.add(b);
            this.opnds = operands.toArray();
            let precedencePredicates = filterPrecedencePredicates(this.opnds);
            // interested in the transition with the lowest precedence
            let reduced = $ab4a86b5def51fe2$var$min(precedencePredicates);
            if (reduced) this.opnds.push(reduced);
        }
        get operands() {
            return this.opnds;
        }
        equals(obj) {
            if (this === obj) return true;
            if (!(obj instanceof AND)) return false;
            return $3sNxf.ArrayEqualityComparator.INSTANCE.equals(this.opnds, obj.opnds);
        }
        hashCode() {
            return $iXFjm.MurmurHash.hashCode(this.opnds, AND_HASHCODE);
        }
        /**
         * {@inheritDoc}
         *
         * The evaluation of predicates by this context is short-circuiting, but
         * unordered.
         */ eval(parser, parserCallStack) {
            for (let opnd of this.opnds){
                if (!opnd.eval(parser, parserCallStack)) return false;
            }
            return true;
        }
        evalPrecedence(parser, parserCallStack) {
            let differs = false;
            let operands = [];
            for (let context of this.opnds){
                let evaluated = context.evalPrecedence(parser, parserCallStack);
                differs = differs || evaluated !== context;
                if (evaluated == null) // The AND context is false if any element is false
                return undefined;
                else if (evaluated !== SemanticContext.NONE) // Reduce the result by skipping true elements
                operands.push(evaluated);
            }
            if (!differs) return this;
            if (operands.length === 0) // all elements were true, so the AND context is true
            return SemanticContext.NONE;
            let result = operands[0];
            for(let i = 1; i < operands.length; i++)result = SemanticContext.and(result, operands[i]);
            return result;
        }
        toString() {
            return $2IEP9.join(this.opnds, "&&");
        }
    };
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], AND.prototype, "operands", null);
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], AND.prototype, "equals", null);
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], AND.prototype, "hashCode", null);
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], AND.prototype, "eval", null);
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], AND.prototype, "evalPrecedence", null);
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], AND.prototype, "toString", null);
    AND = $ab4a86b5def51fe2$var$__decorate([
        $ab4a86b5def51fe2$var$__param(0, $d6D31.NotNull),
        $ab4a86b5def51fe2$var$__param(1, $d6D31.NotNull)
    ], AND);
    SemanticContext.AND = AND;
    /**
     * A semantic context which is true whenever at least one of the contained
     * contexts is true.
     */ let OR = class OR extends Operator {
        constructor(a, b){
            super();
            let operands = new $7Veax.Array2DHashSet($a4Flx.ObjectEqualityComparator.INSTANCE);
            if (a instanceof OR) operands.addAll(a.opnds);
            else operands.add(a);
            if (b instanceof OR) operands.addAll(b.opnds);
            else operands.add(b);
            this.opnds = operands.toArray();
            let precedencePredicates = filterPrecedencePredicates(this.opnds);
            // interested in the transition with the highest precedence
            let reduced = $ab4a86b5def51fe2$var$max(precedencePredicates);
            if (reduced) this.opnds.push(reduced);
        }
        get operands() {
            return this.opnds;
        }
        equals(obj) {
            if (this === obj) return true;
            if (!(obj instanceof OR)) return false;
            return $3sNxf.ArrayEqualityComparator.INSTANCE.equals(this.opnds, obj.opnds);
        }
        hashCode() {
            return $iXFjm.MurmurHash.hashCode(this.opnds, OR_HASHCODE);
        }
        /**
         * {@inheritDoc}
         *
         * The evaluation of predicates by this context is short-circuiting, but
         * unordered.
         */ eval(parser, parserCallStack) {
            for (let opnd of this.opnds){
                if (opnd.eval(parser, parserCallStack)) return true;
            }
            return false;
        }
        evalPrecedence(parser, parserCallStack) {
            let differs = false;
            let operands = [];
            for (let context of this.opnds){
                let evaluated = context.evalPrecedence(parser, parserCallStack);
                differs = differs || evaluated !== context;
                if (evaluated === SemanticContext.NONE) // The OR context is true if any element is true
                return SemanticContext.NONE;
                else if (evaluated) // Reduce the result by skipping false elements
                operands.push(evaluated);
            }
            if (!differs) return this;
            if (operands.length === 0) // all elements were false, so the OR context is false
            return undefined;
            let result = operands[0];
            for(let i = 1; i < operands.length; i++)result = SemanticContext.or(result, operands[i]);
            return result;
        }
        toString() {
            return $2IEP9.join(this.opnds, "||");
        }
    };
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], OR.prototype, "operands", null);
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], OR.prototype, "equals", null);
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], OR.prototype, "hashCode", null);
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], OR.prototype, "eval", null);
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], OR.prototype, "evalPrecedence", null);
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], OR.prototype, "toString", null);
    OR = $ab4a86b5def51fe2$var$__decorate([
        $ab4a86b5def51fe2$var$__param(0, $d6D31.NotNull),
        $ab4a86b5def51fe2$var$__param(1, $d6D31.NotNull)
    ], OR);
    SemanticContext.OR = OR;
})($ab4a86b5def51fe2$var$SemanticContext = module.exports.SemanticContext || (module.exports.SemanticContext = {}));

});
parcelRegister("7Veax", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $5c48d8f2b0160dc3$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $5c48d8f2b0160dc3$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Array2DHashSet = void 0;

var $bbHFU = parcelRequire("bbHFU");

var $1EUnG = parcelRequire("1EUnG");

var $d6D31 = parcelRequire("d6D31");

var $iXFjm = parcelRequire("iXFjm");
/** {@link Set} implementation with closed hashing (open addressing). */ // NOTE:  JavaScript's Set interface has on significant different diffrence from Java's:
// 		  e.g. the return type of add() differs!
//        For this reason I've commented tweaked the implements clause
const $5c48d8f2b0160dc3$var$INITAL_CAPACITY = 16; // must be power of 2
const $5c48d8f2b0160dc3$var$LOAD_FACTOR = 0.75;
class $5c48d8f2b0160dc3$var$Array2DHashSet {
    constructor(comparatorOrSet, initialCapacity = $5c48d8f2b0160dc3$var$INITAL_CAPACITY){
        /** How many elements in set */ this.n = 0;
        this.threshold = Math.floor($5c48d8f2b0160dc3$var$INITAL_CAPACITY * $5c48d8f2b0160dc3$var$LOAD_FACTOR); // when to expand
        if (comparatorOrSet instanceof $5c48d8f2b0160dc3$var$Array2DHashSet) {
            this.comparator = comparatorOrSet.comparator;
            this.buckets = comparatorOrSet.buckets.slice(0);
            for(let i = 0; i < this.buckets.length; i++){
                let bucket = this.buckets[i];
                if (bucket) this.buckets[i] = bucket.slice(0);
            }
            this.n = comparatorOrSet.n;
            this.threshold = comparatorOrSet.threshold;
        } else {
            this.comparator = comparatorOrSet || $1EUnG.DefaultEqualityComparator.INSTANCE;
            this.buckets = this.createBuckets(initialCapacity);
        }
    }
    /**
     * Add `o` to set if not there; return existing value if already
     * there. This method performs the same operation as {@link #add} aside from
     * the return value.
     */ getOrAdd(o) {
        if (this.n > this.threshold) this.expand();
        return this.getOrAddImpl(o);
    }
    getOrAddImpl(o) {
        let b = this.getBucket(o);
        let bucket = this.buckets[b];
        // NEW BUCKET
        if (!bucket) {
            bucket = [
                o
            ];
            this.buckets[b] = bucket;
            this.n++;
            return o;
        }
        // LOOK FOR IT IN BUCKET
        for (let existing of bucket){
            if (this.comparator.equals(existing, o)) return existing; // found existing, quit
        }
        // FULL BUCKET, expand and add to end
        bucket.push(o);
        this.n++;
        return o;
    }
    get(o) {
        if (o == null) return o;
        let b = this.getBucket(o);
        let bucket = this.buckets[b];
        if (!bucket) // no bucket
        return undefined;
        for (let e of bucket){
            if (this.comparator.equals(e, o)) return e;
        }
        return undefined;
    }
    getBucket(o) {
        let hash = this.comparator.hashCode(o);
        let b = hash & this.buckets.length - 1; // assumes len is power of 2
        return b;
    }
    hashCode() {
        let hash = $iXFjm.MurmurHash.initialize();
        for (let bucket of this.buckets){
            if (bucket == null) continue;
            for (let o of bucket){
                if (o == null) break;
                hash = $iXFjm.MurmurHash.update(hash, this.comparator.hashCode(o));
            }
        }
        hash = $iXFjm.MurmurHash.finish(hash, this.size);
        return hash;
    }
    equals(o) {
        if (o === this) return true;
        if (!(o instanceof $5c48d8f2b0160dc3$var$Array2DHashSet)) return false;
        if (o.size !== this.size) return false;
        let same = this.containsAll(o);
        return same;
    }
    expand() {
        let old = this.buckets;
        let newCapacity = this.buckets.length * 2;
        let newTable = this.createBuckets(newCapacity);
        this.buckets = newTable;
        this.threshold = Math.floor(newCapacity * $5c48d8f2b0160dc3$var$LOAD_FACTOR);
        //		System.out.println("new size="+newCapacity+", thres="+threshold);
        // rehash all existing entries
        let oldSize = this.size;
        for (let bucket of old){
            if (!bucket) continue;
            for (let o of bucket){
                let b = this.getBucket(o);
                let newBucket = this.buckets[b];
                if (!newBucket) {
                    newBucket = [];
                    this.buckets[b] = newBucket;
                }
                newBucket.push(o);
            }
        }
        $bbHFU(this.n === oldSize);
    }
    add(t) {
        let existing = this.getOrAdd(t);
        return existing === t;
    }
    get size() {
        return this.n;
    }
    get isEmpty() {
        return this.n === 0;
    }
    contains(o) {
        return this.containsFast(this.asElementType(o));
    }
    containsFast(obj) {
        if (obj == null) return false;
        return this.get(obj) != null;
    }
    *[Symbol.iterator]() {
        yield* this.toArray();
    }
    toArray() {
        const a = new Array(this.size);
        // Copy elements from the nested arrays into the destination array
        let i = 0; // Position within destination array
        for (let bucket of this.buckets){
            if (bucket == null) continue;
            for (let o of bucket){
                if (o == null) break;
                a[i++] = o;
            }
        }
        return a;
    }
    containsAll(collection) {
        if (collection instanceof $5c48d8f2b0160dc3$var$Array2DHashSet) {
            let s = collection;
            for (let bucket of s.buckets){
                if (bucket == null) continue;
                for (let o of bucket){
                    if (o == null) break;
                    if (!this.containsFast(this.asElementType(o))) return false;
                }
            }
        } else for (let o of collection){
            if (!this.containsFast(this.asElementType(o))) return false;
        }
        return true;
    }
    addAll(c) {
        let changed = false;
        for (let o of c){
            let existing = this.getOrAdd(o);
            if (existing !== o) changed = true;
        }
        return changed;
    }
    clear() {
        this.buckets = this.createBuckets($5c48d8f2b0160dc3$var$INITAL_CAPACITY);
        this.n = 0;
        this.threshold = Math.floor($5c48d8f2b0160dc3$var$INITAL_CAPACITY * $5c48d8f2b0160dc3$var$LOAD_FACTOR);
    }
    toString() {
        if (this.size === 0) return "{}";
        let buf = "{";
        let first = true;
        for (let bucket of this.buckets){
            if (bucket == null) continue;
            for (let o of bucket){
                if (o == null) break;
                if (first) first = false;
                else buf += ", ";
                buf += o.toString();
            }
        }
        buf += "}";
        return buf;
    }
    toTableString() {
        let buf = "";
        for (let bucket of this.buckets){
            if (bucket == null) {
                buf += "null\n";
                continue;
            }
            buf += "[";
            let first = true;
            for (let o of bucket){
                if (first) first = false;
                else buf += " ";
                if (o == null) buf += "_";
                else buf += o.toString();
            }
            buf += "]\n";
        }
        return buf;
    }
    /**
     * Return `o` as an instance of the element type `T`. If
     * `o` is non-undefined but known to not be an instance of `T`, this
     * method returns `undefined`. The base implementation does not perform any
     * type checks; override this method to provide strong type checks for the
     * {@link #contains} and {@link #remove} methods to ensure the arguments to
     * the {@link EqualityComparator} for the set always have the expected
     * types.
     *
     * @param o the object to try and cast to the element type of the set
     * @returns `o` if it could be an instance of `T`, otherwise
     * `undefined`.
     */ asElementType(o) {
        return o;
    }
    /**
     * Return an array of `T[]` with length `capacity`.
     *
     * @param capacity the length of the array to return
     * @returns the newly constructed array
     */ createBuckets(capacity) {
        return new Array(capacity);
    }
}
$5c48d8f2b0160dc3$var$__decorate([
    $d6D31.NotNull
], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "comparator", void 0);
$5c48d8f2b0160dc3$var$__decorate([
    $d6D31.Override
], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "hashCode", null);
$5c48d8f2b0160dc3$var$__decorate([
    $d6D31.Override
], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "equals", null);
$5c48d8f2b0160dc3$var$__decorate([
    $d6D31.Override
], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "add", null);
$5c48d8f2b0160dc3$var$__decorate([
    $d6D31.Override
], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "size", null);
$5c48d8f2b0160dc3$var$__decorate([
    $d6D31.Override
], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "isEmpty", null);
$5c48d8f2b0160dc3$var$__decorate([
    $d6D31.Override
], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "contains", null);
$5c48d8f2b0160dc3$var$__decorate([
    $5c48d8f2b0160dc3$var$__param(0, $d6D31.Nullable)
], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "containsFast", null);
$5c48d8f2b0160dc3$var$__decorate([
    $d6D31.Override
], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, Symbol.iterator, null);
$5c48d8f2b0160dc3$var$__decorate([
    $d6D31.Override
], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "toArray", null);
$5c48d8f2b0160dc3$var$__decorate([
    $d6D31.Override
], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "containsAll", null);
$5c48d8f2b0160dc3$var$__decorate([
    $d6D31.Override
], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "addAll", null);
$5c48d8f2b0160dc3$var$__decorate([
    $d6D31.Override
], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "clear", null);
$5c48d8f2b0160dc3$var$__decorate([
    $d6D31.Override
], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "toString", null);
$5c48d8f2b0160dc3$var$__decorate([
    $d6D31.SuppressWarnings("unchecked")
], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "asElementType", null);
$5c48d8f2b0160dc3$var$__decorate([
    $d6D31.SuppressWarnings("unchecked")
], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "createBuckets", null);
module.exports.Array2DHashSet = $5c48d8f2b0160dc3$var$Array2DHashSet;

});
parcelRegister("1EUnG", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $135542f8f0124ec7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultEqualityComparator = void 0;

var $d6D31 = parcelRequire("d6D31");

var $iXFjm = parcelRequire("iXFjm");

var $a4Flx = parcelRequire("a4Flx");
/**
 * This default implementation of {@link EqualityComparator} uses object equality
 * for comparisons by calling {@link Object#hashCode} and {@link Object#equals}.
 *
 * @author Sam Harwell
 */ class $135542f8f0124ec7$var$DefaultEqualityComparator {
    /**
     * {@inheritDoc}
     *
     * This implementation returns
     * `obj.`{@link Object#hashCode hashCode()}.
     */ hashCode(obj) {
        if (obj == null) return 0;
        else if (typeof obj === "string" || typeof obj === "number") return $iXFjm.MurmurHash.hashCode([
            obj
        ]);
        else return $a4Flx.ObjectEqualityComparator.INSTANCE.hashCode(obj);
    }
    /**
     * {@inheritDoc}
     *
     * This implementation relies on object equality. If both objects are
     * `undefined` or `null`, this method returns `true`. Otherwise if only
     * `a` is `undefined` or `null`, this method returns `false`. Otherwise,
     * this method returns the result of
     * `a.`{@link Object#equals equals}`(b)`.
     */ equals(a, b) {
        if (a == null) return b == null;
        else if (typeof a === "string" || typeof a === "number") return a === b;
        else return $a4Flx.ObjectEqualityComparator.INSTANCE.equals(a, b);
    }
}
$135542f8f0124ec7$var$DefaultEqualityComparator.INSTANCE = new $135542f8f0124ec7$var$DefaultEqualityComparator();
$135542f8f0124ec7$var$__decorate([
    $d6D31.Override
], $135542f8f0124ec7$var$DefaultEqualityComparator.prototype, "hashCode", null);
$135542f8f0124ec7$var$__decorate([
    $d6D31.Override
], $135542f8f0124ec7$var$DefaultEqualityComparator.prototype, "equals", null);
module.exports.DefaultEqualityComparator = $135542f8f0124ec7$var$DefaultEqualityComparator;

});
parcelRegister("iXFjm", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MurmurHash = void 0;
/**
 *
 * @author Sam Harwell
 */ var $dcddc83c17bb111f$var$MurmurHash;
(function(MurmurHash) {
    const DEFAULT_SEED = 0;
    /**
     * Initialize the hash using the specified `seed`.
     *
     * @param seed the seed (optional)
     * @returns the intermediate hash value
     */ function initialize(seed = DEFAULT_SEED) {
        return seed;
    }
    MurmurHash.initialize = initialize;
    /**
     * Update the intermediate hash value for the next input `value`.
     *
     * @param hash the intermediate hash value
     * @param value the value to add to the current hash
     * @returns the updated intermediate hash value
     */ function update(hash, value) {
        const c1 = 0xCC9E2D51;
        const c2 = 0x1B873593;
        const r1 = 15;
        const r2 = 13;
        const m = 5;
        const n = 0xE6546B64;
        if (value == null) value = 0;
        else if (typeof value === "string") value = hashString(value);
        else if (typeof value === "object") value = value.hashCode();
        let k = value;
        k = Math.imul(k, c1);
        k = k << r1 | k >>> 32 - r1;
        k = Math.imul(k, c2);
        hash = hash ^ k;
        hash = hash << r2 | hash >>> 32 - r2;
        hash = Math.imul(hash, m) + n;
        return hash & 0xFFFFFFFF;
    }
    MurmurHash.update = update;
    /**
     * Apply the final computation steps to the intermediate value `hash`
     * to form the final result of the MurmurHash 3 hash function.
     *
     * @param hash the intermediate hash value
     * @param numberOfWords the number of integer values added to the hash
     * @returns the final hash result
     */ function finish(hash, numberOfWords) {
        hash = hash ^ numberOfWords * 4;
        hash = hash ^ hash >>> 16;
        hash = Math.imul(hash, 0x85EBCA6B);
        hash = hash ^ hash >>> 13;
        hash = Math.imul(hash, 0xC2B2AE35);
        hash = hash ^ hash >>> 16;
        return hash;
    }
    MurmurHash.finish = finish;
    /**
     * Utility function to compute the hash code of an array using the
     * MurmurHash algorithm.
     *
     * @param <T> the array element type
     * @param data the array data
     * @param seed the seed for the MurmurHash algorithm
     * @returns the hash code of the data
     */ function hashCode(data, seed = DEFAULT_SEED) {
        let hash = initialize(seed);
        let length = 0;
        for (let value of data){
            hash = update(hash, value);
            length++;
        }
        hash = finish(hash, length);
        return hash;
    }
    MurmurHash.hashCode = hashCode;
    /**
     * Function to hash a string. Based on the implementation found here:
     * http://stackoverflow.com/a/7616484
     */ function hashString(str) {
        let len = str.length;
        if (len === 0) return 0;
        let hash = 0;
        for(let i = 0; i < len; i++){
            let c = str.charCodeAt(i);
            hash = (hash << 5 >>> 0) - hash + c;
            hash |= 0;
        }
        return hash;
    }
})($dcddc83c17bb111f$var$MurmurHash = module.exports.MurmurHash || (module.exports.MurmurHash = {}));

});

parcelRegister("a4Flx", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $755a59a5b7943f39$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ObjectEqualityComparator = void 0;

var $d6D31 = parcelRequire("d6D31");
/**
 * This default implementation of {@link EqualityComparator} uses object equality
 * for comparisons by calling {@link Object#hashCode} and {@link Object#equals}.
 *
 * @author Sam Harwell
 */ class $755a59a5b7943f39$var$ObjectEqualityComparator {
    /**
     * {@inheritDoc}
     *
     * This implementation returns
     * `obj.`{@link Object#hashCode hashCode()}.
     */ hashCode(obj) {
        if (obj == null) return 0;
        return obj.hashCode();
    }
    /**
     * {@inheritDoc}
     *
     * This implementation relies on object equality. If both objects are
     * `undefined` or `null`, this method returns `true`. Otherwise if only
     * `a` is `undefined` or `null`, this method returns `false`. Otherwise,
     * this method returns the result of
     * `a.`{@link Object#equals equals}`(b)`.
     */ equals(a, b) {
        if (a == null) return b == null;
        return a.equals(b);
    }
}
$755a59a5b7943f39$var$ObjectEqualityComparator.INSTANCE = new $755a59a5b7943f39$var$ObjectEqualityComparator();
$755a59a5b7943f39$var$__decorate([
    $d6D31.Override
], $755a59a5b7943f39$var$ObjectEqualityComparator.prototype, "hashCode", null);
$755a59a5b7943f39$var$__decorate([
    $d6D31.Override
], $755a59a5b7943f39$var$ObjectEqualityComparator.prototype, "equals", null);
module.exports.ObjectEqualityComparator = $755a59a5b7943f39$var$ObjectEqualityComparator;

});



parcelRegister("3sNxf", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $285a6946513e4d3e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ArrayEqualityComparator = void 0;

var $d6D31 = parcelRequire("d6D31");

var $iXFjm = parcelRequire("iXFjm");

var $a4Flx = parcelRequire("a4Flx");
/**
 * This default implementation of {@link EqualityComparator} uses object equality
 * for comparisons by calling {@link Object#hashCode} and {@link Object#equals}.
 *
 * @author Sam Harwell
 */ class $285a6946513e4d3e$var$ArrayEqualityComparator {
    /**
     * {@inheritDoc}
     *
     * This implementation returns
     * `obj.`{@link Object#hashCode hashCode()}.
     */ hashCode(obj) {
        if (obj == null) return 0;
        return $iXFjm.MurmurHash.hashCode(obj, 0);
    }
    /**
     * {@inheritDoc}
     *
     * This implementation relies on object equality. If both objects are
     * `undefined`, this method returns `true`. Otherwise if only
     * `a` is `undefined`, this method returns `false`. Otherwise,
     * this method returns the result of
     * `a.`{@link Object#equals equals}`(b)`.
     */ equals(a, b) {
        if (a == null) return b == null;
        else if (b == null) return false;
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (!$a4Flx.ObjectEqualityComparator.INSTANCE.equals(a[i], b[i])) return false;
        }
        return true;
    }
}
$285a6946513e4d3e$var$ArrayEqualityComparator.INSTANCE = new $285a6946513e4d3e$var$ArrayEqualityComparator();
$285a6946513e4d3e$var$__decorate([
    $d6D31.Override
], $285a6946513e4d3e$var$ArrayEqualityComparator.prototype, "hashCode", null);
$285a6946513e4d3e$var$__decorate([
    $d6D31.Override
], $285a6946513e4d3e$var$ArrayEqualityComparator.prototype, "equals", null);
module.exports.ArrayEqualityComparator = $285a6946513e4d3e$var$ArrayEqualityComparator;

});

parcelRegister("2IEP9", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toCharArray = module.exports.toMap = module.exports.equals = module.exports.join = module.exports.escapeWhitespace = void 0;
function $1faf5ba696168af5$var$escapeWhitespace(s, escapeSpaces) {
    return escapeSpaces ? s.replace(/ /, "\u00B7") : s.replace(/\t/, "\\t").replace(/\n/, "\\n").replace(/\r/, "\\r");
}
module.exports.escapeWhitespace = $1faf5ba696168af5$var$escapeWhitespace;
// Seriously: why isn't this built in to java? ugh!
function $1faf5ba696168af5$var$join(collection, separator) {
    let buf = "";
    let first = true;
    for (let current of collection){
        if (first) first = false;
        else buf += separator;
        buf += current;
    }
    return buf;
}
module.exports.join = $1faf5ba696168af5$var$join;
function $1faf5ba696168af5$var$equals(x, y) {
    if (x === y) return true;
    if (x === undefined || y === undefined) return false;
    return x.equals(y);
}
module.exports.equals = $1faf5ba696168af5$var$equals;
// export function numNonnull(data: any[]): number {
// 	let n: number =  0;
// 	if ( data == null ) return n;
// 	for (let o of data) {
// 		if ( o!=null ) n++;
// 	}
// 	return n;
// }
// export function removeAllElements<T>(data: Collection<T>, value: T): void {
// 	if ( data==null ) return;
// 	while ( data.contains(value) ) data.remove(value);
// }
// export function writeFile(@NotNull file: File, @NotNull content: Uint8Array): void {
// 	let fos: FileOutputStream = new FileOutputStream(file);
// 	try {
// 		fos.write(content);
// 	} finally {
// 		fos.close();
// 	}
// }
// export function writeFile(@NotNull fileName: string, @NotNull content: string): void {
// 	writeFile(fileName, content, null);
// }
// export function writeFile(@NotNull fileName: string, @NotNull content: string, @Nullable encoding: string): void {
// 	let f: File =  new File(fileName);
// 	let fos: FileOutputStream =  new FileOutputStream(f);
// 	let osw: OutputStreamWriter;
// 	if (encoding != null) {
// 		osw = new OutputStreamWriter(fos, encoding);
// 	}
// 	else {
// 		osw = new OutputStreamWriter(fos);
// 	}
// 	try {
// 		osw.write(content);
// 	}
// 	finally {
// 		osw.close();
// 	}
// }
// @NotNull
// export function readFile(@NotNull fileName: string): char[] {
// 	return readFile(fileName, null);
// }
// @NotNull
// export function readFile(@NotNull fileName: string, @Nullable encoding: string): char[] {
// 	let f: File =  new File(fileName);
// 	let size: number =  (int)f.length();
// 	let isr: InputStreamReader;
// 	let fis: FileInputStream =  new FileInputStream(fileName);
// 	if ( encoding!=null ) {
// 		isr = new InputStreamReader(fis, encoding);
// 	}
// 	else {
// 		isr = new InputStreamReader(fis);
// 	}
// 	let data: char[] =  null;
// 	try {
// 		data = new char[size];
// 		let n: number =  isr.read(data);
// 		if (n < data.length) {
// 			data = Arrays.copyOf(data, n);
// 		}
// 	}
// 	finally {
// 		isr.close();
// 	}
// 	return data;
// }
// export function removeAll<T>(@NotNull predicate: List<T> list,@NotNull Predicate<? super T>): void {
// 	let j: number =  0;
// 	for (let i = 0; i < list.size; i++) {
// 		let item: T =  list.get(i);
// 		if (!predicate.eval(item)) {
// 			if (j != i) {
// 				list.set(j, item);
// 			}
// 			j++;
// 		}
// 	}
// 	if (j < list.size) {
// 		list.subList(j, list.size).clear();
// 	}
// }
// export function removeAll<T>(@NotNull predicate: Iterable<T> iterable,@NotNull Predicate<? super T>): void {
// 	if (iterable instanceof List<?>) {
// 		removeAll((List<T>)iterable, predicate);
// 		return;
// 	}
// 	for (Iterator<T> iterator = iterable.iterator(); iterator.hasNext(); ) {
// 		let item: T =  iterator.next();
// 		if (predicate.eval(item)) {
// 			iterator.remove();
// 		}
// 	}
// }
/** Convert array of strings to string&rarr;index map. Useful for
 *  converting rulenames to name&rarr;ruleindex map.
 */ function $1faf5ba696168af5$var$toMap(keys) {
    let m = new Map();
    for(let i = 0; i < keys.length; i++)m.set(keys[i], i);
    return m;
}
module.exports.toMap = $1faf5ba696168af5$var$toMap;
function $1faf5ba696168af5$var$toCharArray(str) {
    if (typeof str === "string") {
        let result = new Uint16Array(str.length);
        for(let i = 0; i < str.length; i++)result[i] = str.charCodeAt(i);
        return result;
    } else return str.toCharArray();
}
module.exports.toCharArray = $1faf5ba696168af5$var$toCharArray; // /**
 // 	* @since 4.5
 // 	*/
 // @NotNull
 // export function toSet(@NotNull bits: BitSet): IntervalSet {
 // 	let s: IntervalSet =  new IntervalSet();
 // 	let i: number =  bits.nextSetBit(0);
 // 	while ( i >= 0 ) {
 // 		s.add(i);
 // 		i = bits.nextSetBit(i+1);
 // 	}
 // 	return s;
 // }

});




parcelRegister("iLUMi", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $daa8a8b6b270e309$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $daa8a8b6b270e309$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InputMismatchException = void 0;

var $fLdDn = parcelRequire("fLdDn");

var $d6D31 = parcelRequire("d6D31");
/** This signifies any kind of mismatched input exceptions such as
 *  when the current input does not match the expected token.
 */ let $daa8a8b6b270e309$var$InputMismatchException = class InputMismatchException extends $fLdDn.RecognitionException {
    constructor(recognizer, state, context){
        if (context === undefined) context = recognizer.context;
        super(recognizer, recognizer.inputStream, context);
        if (state !== undefined) this.setOffendingState(state);
        this.setOffendingToken(recognizer, recognizer.currentToken);
    }
};
$daa8a8b6b270e309$var$InputMismatchException = $daa8a8b6b270e309$var$__decorate([
    $daa8a8b6b270e309$var$__param(0, $d6D31.NotNull)
], $daa8a8b6b270e309$var$InputMismatchException);
module.exports.InputMismatchException = $daa8a8b6b270e309$var$InputMismatchException;

});

parcelRegister("hGRod", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ce0fc5f35b4fec79$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $ce0fc5f35b4fec79$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntervalSet = void 0;

var $3sNxf = parcelRequire("3sNxf");

var $37SGk = parcelRequire("37SGk");

var $gcfUE = parcelRequire("gcfUE");

var $igNLf = parcelRequire("igNLf");

var $iXFjm = parcelRequire("iXFjm");

var $d6D31 = parcelRequire("d6D31");

var $2DVsz = parcelRequire("2DVsz");
/**
 * This class implements the {@link IntSet} backed by a sorted array of
 * non-overlapping intervals. It is particularly efficient for representing
 * large collections of numbers, where the majority of elements appear as part
 * of a sequential range of numbers that are all part of the set. For example,
 * the set { 1, 2, 3, 4, 7, 8 } may be represented as { [1, 4], [7, 8] }.
 *
 * This class is able to represent sets containing any combination of values in
 * the range {@link Integer#MIN_VALUE} to {@link Integer#MAX_VALUE}
 * (inclusive).
 */ class $ce0fc5f35b4fec79$var$IntervalSet {
    constructor(intervals){
        this.readonly = false;
        if (intervals != null) this._intervals = intervals.slice(0);
        else this._intervals = [];
    }
    static get COMPLETE_CHAR_SET() {
        if ($ce0fc5f35b4fec79$var$IntervalSet._COMPLETE_CHAR_SET === undefined) {
            $ce0fc5f35b4fec79$var$IntervalSet._COMPLETE_CHAR_SET = $ce0fc5f35b4fec79$var$IntervalSet.of($igNLf.Lexer.MIN_CHAR_VALUE, $igNLf.Lexer.MAX_CHAR_VALUE);
            $ce0fc5f35b4fec79$var$IntervalSet._COMPLETE_CHAR_SET.setReadonly(true);
        }
        return $ce0fc5f35b4fec79$var$IntervalSet._COMPLETE_CHAR_SET;
    }
    static get EMPTY_SET() {
        if ($ce0fc5f35b4fec79$var$IntervalSet._EMPTY_SET == null) {
            $ce0fc5f35b4fec79$var$IntervalSet._EMPTY_SET = new $ce0fc5f35b4fec79$var$IntervalSet();
            $ce0fc5f35b4fec79$var$IntervalSet._EMPTY_SET.setReadonly(true);
        }
        return $ce0fc5f35b4fec79$var$IntervalSet._EMPTY_SET;
    }
    /**
     * Create a set with all ints within range [a..b] (inclusive). If b is omitted, the set contains the single element
     * a.
     */ static of(a, b = a) {
        let s = new $ce0fc5f35b4fec79$var$IntervalSet();
        s.add(a, b);
        return s;
    }
    clear() {
        if (this.readonly) throw new Error("can't alter readonly IntervalSet");
        this._intervals.length = 0;
    }
    /** Add interval; i.e., add all integers from a to b to set.
     *  If b&lt;a, do nothing.
     *  Keep list in sorted order (by left range value).
     *  If overlap, combine ranges.  For example,
     *  If this is {1..5, 10..20}, adding 6..7 yields
     *  {1..5, 6..7, 10..20}.  Adding 4..8 yields {1..8, 10..20}.
     */ add(a, b = a) {
        this.addRange($gcfUE.Interval.of(a, b));
    }
    // copy on write so we can cache a..a intervals and sets of that
    addRange(addition) {
        if (this.readonly) throw new Error("can't alter readonly IntervalSet");
        //System.out.println("add "+addition+" to "+intervals.toString());
        if (addition.b < addition.a) return;
        // find position in list
        // Use iterators as we modify list in place
        for(let i = 0; i < this._intervals.length; i++){
            let r = this._intervals[i];
            if (addition.equals(r)) return;
            if (addition.adjacent(r) || !addition.disjoint(r)) {
                // next to each other, make a single larger interval
                let bigger = addition.union(r);
                this._intervals[i] = bigger;
                // make sure we didn't just create an interval that
                // should be merged with next interval in list
                while(i < this._intervals.length - 1){
                    i++;
                    let next = this._intervals[i];
                    if (!bigger.adjacent(next) && bigger.disjoint(next)) break;
                    // if we bump up against or overlap next, merge
                    // remove this one
                    this._intervals.splice(i, 1);
                    i--;
                    // move backwards to what we just set
                    this._intervals[i] = bigger.union(next);
                // set to 3 merged ones
                }
                // first call to next after previous duplicates the result
                return;
            }
            if (addition.startsBeforeDisjoint(r)) {
                // insert before r
                this._intervals.splice(i, 0, addition);
                return;
            }
        // if disjoint and after r, a future iteration will handle it
        }
        // ok, must be after last interval (and disjoint from last interval)
        // just add it
        this._intervals.push(addition);
    }
    /** combine all sets in the array returned the or'd value */ static or(sets) {
        let r = new $ce0fc5f35b4fec79$var$IntervalSet();
        for (let s of sets)r.addAll(s);
        return r;
    }
    addAll(set) {
        if (set == null) return this;
        if (set instanceof $ce0fc5f35b4fec79$var$IntervalSet) {
            let other = set;
            // walk set and add each interval
            let n = other._intervals.length;
            for(let i = 0; i < n; i++){
                let I = other._intervals[i];
                this.add(I.a, I.b);
            }
        } else for (let value of set.toArray())this.add(value);
        return this;
    }
    complementRange(minElement, maxElement) {
        return this.complement($ce0fc5f35b4fec79$var$IntervalSet.of(minElement, maxElement));
    }
    /** {@inheritDoc} */ complement(vocabulary) {
        if (vocabulary.isNil) // nothing in common with null set
        return $ce0fc5f35b4fec79$var$IntervalSet.EMPTY_SET;
        let vocabularyIS;
        if (vocabulary instanceof $ce0fc5f35b4fec79$var$IntervalSet) vocabularyIS = vocabulary;
        else {
            vocabularyIS = new $ce0fc5f35b4fec79$var$IntervalSet();
            vocabularyIS.addAll(vocabulary);
        }
        return vocabularyIS.subtract(this);
    }
    subtract(a) {
        if (a == null || a.isNil) return new $ce0fc5f35b4fec79$var$IntervalSet(this._intervals);
        if (a instanceof $ce0fc5f35b4fec79$var$IntervalSet) return $ce0fc5f35b4fec79$var$IntervalSet.subtract(this, a);
        let other = new $ce0fc5f35b4fec79$var$IntervalSet();
        other.addAll(a);
        return $ce0fc5f35b4fec79$var$IntervalSet.subtract(this, other);
    }
    /**
     * Compute the set difference between two interval sets. The specific
     * operation is `left - right`.
     */ static subtract(left, right) {
        if (left.isNil) return new $ce0fc5f35b4fec79$var$IntervalSet();
        let result = new $ce0fc5f35b4fec79$var$IntervalSet(left._intervals);
        if (right.isNil) // right set has no elements; just return the copy of the current set
        return result;
        let resultI = 0;
        let rightI = 0;
        while(resultI < result._intervals.length && rightI < right._intervals.length){
            let resultInterval = result._intervals[resultI];
            let rightInterval = right._intervals[rightI];
            // operation: (resultInterval - rightInterval) and update indexes
            if (rightInterval.b < resultInterval.a) {
                rightI++;
                continue;
            }
            if (rightInterval.a > resultInterval.b) {
                resultI++;
                continue;
            }
            let beforeCurrent;
            let afterCurrent;
            if (rightInterval.a > resultInterval.a) beforeCurrent = new $gcfUE.Interval(resultInterval.a, rightInterval.a - 1);
            if (rightInterval.b < resultInterval.b) afterCurrent = new $gcfUE.Interval(rightInterval.b + 1, resultInterval.b);
            if (beforeCurrent) {
                if (afterCurrent) {
                    // split the current interval into two
                    result._intervals[resultI] = beforeCurrent;
                    result._intervals.splice(resultI + 1, 0, afterCurrent);
                    resultI++;
                    rightI++;
                    continue;
                } else {
                    // replace the current interval
                    result._intervals[resultI] = beforeCurrent;
                    resultI++;
                    continue;
                }
            } else if (afterCurrent) {
                // replace the current interval
                result._intervals[resultI] = afterCurrent;
                rightI++;
                continue;
            } else {
                // remove the current interval (thus no need to increment resultI)
                result._intervals.splice(resultI, 1);
                continue;
            }
        }
        // If rightI reached right.intervals.size, no more intervals to subtract from result.
        // If resultI reached result.intervals.size, we would be subtracting from an empty set.
        // Either way, we are done.
        return result;
    }
    or(a) {
        let o = new $ce0fc5f35b4fec79$var$IntervalSet();
        o.addAll(this);
        o.addAll(a);
        return o;
    }
    /** {@inheritDoc} */ and(other) {
        if (other.isNil) // nothing in common with null set
        return new $ce0fc5f35b4fec79$var$IntervalSet();
        let myIntervals = this._intervals;
        let theirIntervals = other._intervals;
        let intersection;
        let mySize = myIntervals.length;
        let theirSize = theirIntervals.length;
        let i = 0;
        let j = 0;
        // iterate down both interval lists looking for nondisjoint intervals
        while(i < mySize && j < theirSize){
            let mine = myIntervals[i];
            let theirs = theirIntervals[j];
            //System.out.println("mine="+mine+" and theirs="+theirs);
            if (mine.startsBeforeDisjoint(theirs)) // move this iterator looking for interval that might overlap
            i++;
            else if (theirs.startsBeforeDisjoint(mine)) // move other iterator looking for interval that might overlap
            j++;
            else if (mine.properlyContains(theirs)) {
                // overlap, add intersection, get next theirs
                if (!intersection) intersection = new $ce0fc5f35b4fec79$var$IntervalSet();
                intersection.addRange(mine.intersection(theirs));
                j++;
            } else if (theirs.properlyContains(mine)) {
                // overlap, add intersection, get next mine
                if (!intersection) intersection = new $ce0fc5f35b4fec79$var$IntervalSet();
                intersection.addRange(mine.intersection(theirs));
                i++;
            } else if (!mine.disjoint(theirs)) {
                // overlap, add intersection
                if (!intersection) intersection = new $ce0fc5f35b4fec79$var$IntervalSet();
                intersection.addRange(mine.intersection(theirs));
                // Move the iterator of lower range [a..b], but not
                // the upper range as it may contain elements that will collide
                // with the next iterator. So, if mine=[0..115] and
                // theirs=[115..200], then intersection is 115 and move mine
                // but not theirs as theirs may collide with the next range
                // in thisIter.
                // move both iterators to next ranges
                if (mine.startsAfterNonDisjoint(theirs)) j++;
                else if (theirs.startsAfterNonDisjoint(mine)) i++;
            }
        }
        if (!intersection) return new $ce0fc5f35b4fec79$var$IntervalSet();
        return intersection;
    }
    /** {@inheritDoc} */ contains(el) {
        let n = this._intervals.length;
        let l = 0;
        let r = n - 1;
        // Binary search for the element in the (sorted, disjoint) array of intervals.
        while(l <= r){
            let m = l + r >> 1;
            let I = this._intervals[m];
            let a = I.a;
            let b = I.b;
            if (b < el) l = m + 1;
            else if (a > el) r = m - 1;
            else // el >= a && el <= b
            return true;
        }
        return false;
    }
    /** {@inheritDoc} */ get isNil() {
        return this._intervals == null || this._intervals.length === 0;
    }
    /**
     * Returns the maximum value contained in the set if not isNil.
     *
     * @return the maximum value contained in the set.
     * @throws RangeError if set is empty
     */ get maxElement() {
        if (this.isNil) throw new RangeError("set is empty");
        let last = this._intervals[this._intervals.length - 1];
        return last.b;
    }
    /**
     * Returns the minimum value contained in the set if not isNil.
     *
     * @return the minimum value contained in the set.
     * @throws RangeError if set is empty
     */ get minElement() {
        if (this.isNil) throw new RangeError("set is empty");
        return this._intervals[0].a;
    }
    /** Return a list of Interval objects. */ get intervals() {
        return this._intervals;
    }
    hashCode() {
        let hash = $iXFjm.MurmurHash.initialize();
        for (let I of this._intervals){
            hash = $iXFjm.MurmurHash.update(hash, I.a);
            hash = $iXFjm.MurmurHash.update(hash, I.b);
        }
        hash = $iXFjm.MurmurHash.finish(hash, this._intervals.length * 2);
        return hash;
    }
    /** Are two IntervalSets equal?  Because all intervals are sorted
     *  and disjoint, equals is a simple linear walk over both lists
     *  to make sure they are the same.  Interval.equals() is used
     *  by the List.equals() method to check the ranges.
     */ equals(o) {
        if (o == null || !(o instanceof $ce0fc5f35b4fec79$var$IntervalSet)) return false;
        return $3sNxf.ArrayEqualityComparator.INSTANCE.equals(this._intervals, o._intervals);
    }
    toString(elemAreChar = false) {
        let buf = "";
        if (this._intervals == null || this._intervals.length === 0) return "{}";
        if (this.size > 1) buf += "{";
        let first = true;
        for (let I of this._intervals){
            if (first) first = false;
            else buf += ", ";
            let a = I.a;
            let b = I.b;
            if (a === b) {
                if (a === $2DVsz.Token.EOF) buf += "<EOF>";
                else if (elemAreChar) buf += "'" + String.fromCodePoint(a) + "'";
                else buf += a;
            } else if (elemAreChar) buf += "'" + String.fromCodePoint(a) + "'..'" + String.fromCodePoint(b) + "'";
            else buf += a + ".." + b;
        }
        if (this.size > 1) buf += "}";
        return buf;
    }
    toStringVocabulary(vocabulary) {
        if (this._intervals == null || this._intervals.length === 0) return "{}";
        let buf = "";
        if (this.size > 1) buf += "{";
        let first = true;
        for (let I of this._intervals){
            if (first) first = false;
            else buf += ", ";
            let a = I.a;
            let b = I.b;
            if (a === b) buf += this.elementName(vocabulary, a);
            else for(let i = a; i <= b; i++){
                if (i > a) buf += ", ";
                buf += this.elementName(vocabulary, i);
            }
        }
        if (this.size > 1) buf += "}";
        return buf;
    }
    elementName(vocabulary, a) {
        if (a === $2DVsz.Token.EOF) return "<EOF>";
        else if (a === $2DVsz.Token.EPSILON) return "<EPSILON>";
        else return vocabulary.getDisplayName(a);
    }
    get size() {
        let n = 0;
        let numIntervals = this._intervals.length;
        if (numIntervals === 1) {
            let firstInterval = this._intervals[0];
            return firstInterval.b - firstInterval.a + 1;
        }
        for(let i = 0; i < numIntervals; i++){
            let I = this._intervals[i];
            n += I.b - I.a + 1;
        }
        return n;
    }
    toIntegerList() {
        let values = new $37SGk.IntegerList(this.size);
        let n = this._intervals.length;
        for(let i = 0; i < n; i++){
            let I = this._intervals[i];
            let a = I.a;
            let b = I.b;
            for(let v = a; v <= b; v++)values.add(v);
        }
        return values;
    }
    toSet() {
        let s = new Set();
        for (let I of this._intervals){
            let a = I.a;
            let b = I.b;
            for(let v = a; v <= b; v++)s.add(v);
        }
        return s;
    }
    toArray() {
        let values = new Array();
        let n = this._intervals.length;
        for(let i = 0; i < n; i++){
            let I = this._intervals[i];
            let a = I.a;
            let b = I.b;
            for(let v = a; v <= b; v++)values.push(v);
        }
        return values;
    }
    remove(el) {
        if (this.readonly) throw new Error("can't alter readonly IntervalSet");
        let n = this._intervals.length;
        for(let i = 0; i < n; i++){
            let I = this._intervals[i];
            let a = I.a;
            let b = I.b;
            if (el < a) break; // list is sorted and el is before this interval; not here
            // if whole interval x..x, rm
            if (el === a && el === b) {
                this._intervals.splice(i, 1);
                break;
            }
            // if on left edge x..b, adjust left
            if (el === a) {
                this._intervals[i] = $gcfUE.Interval.of(I.a + 1, I.b);
                break;
            }
            // if on right edge a..x, adjust right
            if (el === b) {
                this._intervals[i] = $gcfUE.Interval.of(I.a, I.b - 1);
                break;
            }
            // if in middle a..x..b, split interval
            if (el > a && el < b) {
                let oldb = I.b;
                this._intervals[i] = $gcfUE.Interval.of(I.a, el - 1); // [a..x-1]
                this.add(el + 1, oldb); // add [x+1..b]
            }
        }
    }
    get isReadonly() {
        return this.readonly;
    }
    setReadonly(readonly) {
        if (this.readonly && !readonly) throw new Error("can't alter readonly IntervalSet");
        this.readonly = readonly;
    }
}
$ce0fc5f35b4fec79$var$__decorate([
    $d6D31.Override
], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "addAll", null);
$ce0fc5f35b4fec79$var$__decorate([
    $d6D31.Override
], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "complement", null);
$ce0fc5f35b4fec79$var$__decorate([
    $d6D31.Override
], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "subtract", null);
$ce0fc5f35b4fec79$var$__decorate([
    $d6D31.Override
], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "or", null);
$ce0fc5f35b4fec79$var$__decorate([
    $d6D31.Override
], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "and", null);
$ce0fc5f35b4fec79$var$__decorate([
    $d6D31.Override
], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "contains", null);
$ce0fc5f35b4fec79$var$__decorate([
    $d6D31.Override
], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "isNil", null);
$ce0fc5f35b4fec79$var$__decorate([
    $d6D31.Override
], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "hashCode", null);
$ce0fc5f35b4fec79$var$__decorate([
    $d6D31.Override
], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "equals", null);
$ce0fc5f35b4fec79$var$__decorate([
    $ce0fc5f35b4fec79$var$__param(0, $d6D31.NotNull)
], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "toStringVocabulary", null);
$ce0fc5f35b4fec79$var$__decorate([
    $d6D31.NotNull,
    $ce0fc5f35b4fec79$var$__param(0, $d6D31.NotNull)
], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "elementName", null);
$ce0fc5f35b4fec79$var$__decorate([
    $d6D31.Override
], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "size", null);
$ce0fc5f35b4fec79$var$__decorate([
    $d6D31.Override
], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "remove", null);
$ce0fc5f35b4fec79$var$__decorate([
    $d6D31.NotNull
], $ce0fc5f35b4fec79$var$IntervalSet, "of", null);
$ce0fc5f35b4fec79$var$__decorate([
    $d6D31.NotNull
], $ce0fc5f35b4fec79$var$IntervalSet, "subtract", null);
module.exports.IntervalSet = $ce0fc5f35b4fec79$var$IntervalSet;

});
parcelRegister("37SGk", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $246c712c5583aa9c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntegerList = void 0;

var $9yG1X = parcelRequire("9yG1X");

var $d6D31 = parcelRequire("d6D31");
const $246c712c5583aa9c$var$EMPTY_DATA = new Int32Array(0);
const $246c712c5583aa9c$var$INITIAL_SIZE = 4;
const $246c712c5583aa9c$var$MAX_ARRAY_SIZE = 2147483639;
/**
 *
 * @author Sam Harwell
 */ class $246c712c5583aa9c$var$IntegerList {
    constructor(arg){
        if (!arg) {
            this._data = $246c712c5583aa9c$var$EMPTY_DATA;
            this._size = 0;
        } else if (arg instanceof $246c712c5583aa9c$var$IntegerList) {
            this._data = arg._data.slice(0);
            this._size = arg._size;
        } else if (typeof arg === "number") {
            if (arg === 0) {
                this._data = $246c712c5583aa9c$var$EMPTY_DATA;
                this._size = 0;
            } else {
                this._data = new Int32Array(arg);
                this._size = 0;
            }
        } else {
            // arg is Iterable<number>
            this._data = $246c712c5583aa9c$var$EMPTY_DATA;
            this._size = 0;
            for (let value of arg)this.add(value);
        }
    }
    add(value) {
        if (this._data.length === this._size) this.ensureCapacity(this._size + 1);
        this._data[this._size] = value;
        this._size++;
    }
    addAll(list) {
        if (Array.isArray(list)) {
            this.ensureCapacity(this._size + list.length);
            this._data.subarray(this._size, this._size + list.length).set(list);
            this._size += list.length;
        } else if (list instanceof $246c712c5583aa9c$var$IntegerList) {
            this.ensureCapacity(this._size + list._size);
            this._data.subarray(this._size, this._size + list.size).set(list._data);
            this._size += list._size;
        } else {
            // list is JavaCollection<number>
            this.ensureCapacity(this._size + list.size);
            let current = 0;
            for (let xi of list){
                this._data[this._size + current] = xi;
                current++;
            }
            this._size += list.size;
        }
    }
    get(index) {
        if (index < 0 || index >= this._size) throw RangeError();
        return this._data[index];
    }
    contains(value) {
        for(let i = 0; i < this._size; i++){
            if (this._data[i] === value) return true;
        }
        return false;
    }
    set(index, value) {
        if (index < 0 || index >= this._size) throw RangeError();
        let previous = this._data[index];
        this._data[index] = value;
        return previous;
    }
    removeAt(index) {
        let value = this.get(index);
        this._data.copyWithin(index, index + 1, this._size);
        this._data[this._size - 1] = 0;
        this._size--;
        return value;
    }
    removeRange(fromIndex, toIndex) {
        if (fromIndex < 0 || toIndex < 0 || fromIndex > this._size || toIndex > this._size) throw RangeError();
        if (fromIndex > toIndex) throw RangeError();
        this._data.copyWithin(toIndex, fromIndex, this._size);
        this._data.fill(0, this._size - (toIndex - fromIndex), this._size);
        this._size -= toIndex - fromIndex;
    }
    get isEmpty() {
        return this._size === 0;
    }
    get size() {
        return this._size;
    }
    trimToSize() {
        if (this._data.length === this._size) return;
        this._data = this._data.slice(0, this._size);
    }
    clear() {
        this._data.fill(0, 0, this._size);
        this._size = 0;
    }
    toArray() {
        if (this._size === 0) return [];
        return Array.from(this._data.subarray(0, this._size));
    }
    sort() {
        this._data.subarray(0, this._size).sort();
    }
    /**
     * Compares the specified object with this list for equality.  Returns
     * `true` if and only if the specified object is also an {@link IntegerList},
     * both lists have the same size, and all corresponding pairs of elements in
     * the two lists are equal.  In other words, two lists are defined to be
     * equal if they contain the same elements in the same order.
     *
     * This implementation first checks if the specified object is this
     * list. If so, it returns `true`; if not, it checks if the
     * specified object is an {@link IntegerList}. If not, it returns `false`;
     * if so, it checks the size of both lists. If the lists are not the same size,
     * it returns `false`; otherwise it iterates over both lists, comparing
     * corresponding pairs of elements.  If any comparison returns `false`,
     * this method returns `false`.
     *
     * @param o the object to be compared for equality with this list
     * @returns `true` if the specified object is equal to this list
     */ equals(o) {
        if (o === this) return true;
        if (!(o instanceof $246c712c5583aa9c$var$IntegerList)) return false;
        if (this._size !== o._size) return false;
        for(let i = 0; i < this._size; i++){
            if (this._data[i] !== o._data[i]) return false;
        }
        return true;
    }
    /**
     * Returns the hash code value for this list.
     *
     * This implementation uses exactly the code that is used to define the
     * list hash function in the documentation for the {@link List#hashCode}
     * method.
     *
     * @returns the hash code value for this list
     */ hashCode() {
        let hashCode = 1;
        for(let i = 0; i < this._size; i++)hashCode = 31 * hashCode + this._data[i];
        return hashCode;
    }
    /**
     * Returns a string representation of this list.
     */ toString() {
        return this._data.toString();
    }
    binarySearch(key, fromIndex, toIndex) {
        if (fromIndex === undefined) fromIndex = 0;
        if (toIndex === undefined) toIndex = this._size;
        if (fromIndex < 0 || toIndex < 0 || fromIndex > this._size || toIndex > this._size) throw new RangeError();
        if (fromIndex > toIndex) throw new RangeError();
        return $9yG1X.Arrays.binarySearch(this._data, key, fromIndex, toIndex);
    }
    ensureCapacity(capacity) {
        if (capacity < 0 || capacity > $246c712c5583aa9c$var$MAX_ARRAY_SIZE) throw new RangeError();
        let newLength;
        if (this._data.length === 0) newLength = $246c712c5583aa9c$var$INITIAL_SIZE;
        else newLength = this._data.length;
        while(newLength < capacity){
            newLength = newLength * 2;
            if (newLength < 0 || newLength > $246c712c5583aa9c$var$MAX_ARRAY_SIZE) newLength = $246c712c5583aa9c$var$MAX_ARRAY_SIZE;
        }
        let tmp = new Int32Array(newLength);
        tmp.set(this._data);
        this._data = tmp;
    }
    /** Convert the list to a UTF-16 encoded char array. If all values are less
     *  than the 0xFFFF 16-bit code point limit then this is just a char array
     *  of 16-bit char as usual. For values in the supplementary range, encode
     * them as two UTF-16 code units.
     */ toCharArray() {
        // Optimize for the common case (all data values are < 0xFFFF) to avoid an extra scan
        let resultArray = new Uint16Array(this._size);
        let resultIdx = 0;
        let calculatedPreciseResultSize = false;
        for(let i = 0; i < this._size; i++){
            let codePoint = this._data[i];
            if (codePoint >= 0 && codePoint < 0x10000) {
                resultArray[resultIdx] = codePoint;
                resultIdx++;
                continue;
            }
            // Calculate the precise result size if we encounter a code point > 0xFFFF
            if (!calculatedPreciseResultSize) {
                let newResultArray = new Uint16Array(this.charArraySize());
                newResultArray.set(resultArray, 0);
                resultArray = newResultArray;
                calculatedPreciseResultSize = true;
            }
            // This will throw RangeError if the code point is not a valid Unicode code point
            let pair = String.fromCodePoint(codePoint);
            resultArray[resultIdx] = pair.charCodeAt(0);
            resultArray[resultIdx + 1] = pair.charCodeAt(1);
            resultIdx += 2;
        }
        return resultArray;
    }
    charArraySize() {
        let result = 0;
        for(let i = 0; i < this._size; i++)result += this._data[i] >= 0x10000 ? 2 : 1;
        return result;
    }
}
$246c712c5583aa9c$var$__decorate([
    $d6D31.NotNull
], $246c712c5583aa9c$var$IntegerList.prototype, "_data", void 0);
$246c712c5583aa9c$var$__decorate([
    $d6D31.Override
], $246c712c5583aa9c$var$IntegerList.prototype, "equals", null);
$246c712c5583aa9c$var$__decorate([
    $d6D31.Override
], $246c712c5583aa9c$var$IntegerList.prototype, "hashCode", null);
$246c712c5583aa9c$var$__decorate([
    $d6D31.Override
], $246c712c5583aa9c$var$IntegerList.prototype, "toString", null);
module.exports.IntegerList = $246c712c5583aa9c$var$IntegerList;

});
parcelRegister("9yG1X", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Arrays = void 0;
var $6f57e46e4dc9d39b$var$Arrays;
(function(Arrays) {
    /**
     * Searches the specified array of numbers for the specified value using the binary search algorithm. The array must
     * be sorted prior to making this call. If it is not sorted, the results are unspecified. If the array contains
     * multiple elements with the specified value, there is no guarantee which one will be found.
     *
     * @returns index of the search key, if it is contained in the array; otherwise, (-(insertion point) - 1). The
     * insertion point is defined as the point at which the key would be inserted into the array: the index of the first
     * element greater than the key, or array.length if all elements in the array are less than the specified key. Note
     * that this guarantees that the return value will be >= 0 if and only if the key is found.
     */ function binarySearch(array, key, fromIndex, toIndex) {
        return binarySearch0(array, fromIndex !== undefined ? fromIndex : 0, toIndex !== undefined ? toIndex : array.length, key);
    }
    Arrays.binarySearch = binarySearch;
    function binarySearch0(array, fromIndex, toIndex, key) {
        let low = fromIndex;
        let high = toIndex - 1;
        while(low <= high){
            let mid = low + high >>> 1;
            let midVal = array[mid];
            if (midVal < key) low = mid + 1;
            else if (midVal > key) high = mid - 1;
            else // key found
            return mid;
        }
        // key not found.
        return -(low + 1);
    }
    function toString(array) {
        let result = "[";
        let first = true;
        for (let element of array){
            if (first) first = false;
            else result += ", ";
            if (element === null) result += "null";
            else if (element === undefined) result += "undefined";
            else result += element;
        }
        result += "]";
        return result;
    }
    Arrays.toString = toString;
})($6f57e46e4dc9d39b$var$Arrays = module.exports.Arrays || (module.exports.Arrays = {}));

});


parcelRegister("gcfUE", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $bcaa1c4749d34439$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Interval = void 0;

var $d6D31 = parcelRequire("d6D31");
const $bcaa1c4749d34439$var$INTERVAL_POOL_MAX_VALUE = 1000;
/** An immutable inclusive interval a..b */ class $bcaa1c4749d34439$var$Interval {
    /**
     * @param a The start of the interval
     * @param b The end of the interval (inclusive)
     */ constructor(a, b){
        this.a = a;
        this.b = b;
    }
    static get INVALID() {
        return $bcaa1c4749d34439$var$Interval._INVALID;
    }
    /** Interval objects are used readonly so share all with the
     *  same single value a==b up to some max size.  Use an array as a perfect hash.
     *  Return shared object for 0..INTERVAL_POOL_MAX_VALUE or a new
     *  Interval object with a..a in it.  On Java.g4, 218623 IntervalSets
     *  have a..a (set with 1 element).
     */ static of(a, b) {
        // cache just a..a
        if (a !== b || a < 0 || a > $bcaa1c4749d34439$var$INTERVAL_POOL_MAX_VALUE) return new $bcaa1c4749d34439$var$Interval(a, b);
        if ($bcaa1c4749d34439$var$Interval.cache[a] == null) $bcaa1c4749d34439$var$Interval.cache[a] = new $bcaa1c4749d34439$var$Interval(a, a);
        return $bcaa1c4749d34439$var$Interval.cache[a];
    }
    /** return number of elements between a and b inclusively. x..x is length 1.
     *  if b &lt; a, then length is 0.  9..10 has length 2.
     */ get length() {
        if (this.b < this.a) return 0;
        return this.b - this.a + 1;
    }
    equals(o) {
        if (o === this) return true;
        else if (!(o instanceof $bcaa1c4749d34439$var$Interval)) return false;
        return this.a === o.a && this.b === o.b;
    }
    hashCode() {
        let hash = 23;
        hash = hash * 31 + this.a;
        hash = hash * 31 + this.b;
        return hash;
    }
    /** Does this start completely before other? Disjoint */ startsBeforeDisjoint(other) {
        return this.a < other.a && this.b < other.a;
    }
    /** Does this start at or before other? Nondisjoint */ startsBeforeNonDisjoint(other) {
        return this.a <= other.a && this.b >= other.a;
    }
    /** Does this.a start after other.b? May or may not be disjoint */ startsAfter(other) {
        return this.a > other.a;
    }
    /** Does this start completely after other? Disjoint */ startsAfterDisjoint(other) {
        return this.a > other.b;
    }
    /** Does this start after other? NonDisjoint */ startsAfterNonDisjoint(other) {
        return this.a > other.a && this.a <= other.b; // this.b>=other.b implied
    }
    /** Are both ranges disjoint? I.e., no overlap? */ disjoint(other) {
        return this.startsBeforeDisjoint(other) || this.startsAfterDisjoint(other);
    }
    /** Are two intervals adjacent such as 0..41 and 42..42? */ adjacent(other) {
        return this.a === other.b + 1 || this.b === other.a - 1;
    }
    properlyContains(other) {
        return other.a >= this.a && other.b <= this.b;
    }
    /** Return the interval computed from combining this and other */ union(other) {
        return $bcaa1c4749d34439$var$Interval.of(Math.min(this.a, other.a), Math.max(this.b, other.b));
    }
    /** Return the interval in common between this and o */ intersection(other) {
        return $bcaa1c4749d34439$var$Interval.of(Math.max(this.a, other.a), Math.min(this.b, other.b));
    }
    /** Return the interval with elements from `this` not in `other`;
     *  `other` must not be totally enclosed (properly contained)
     *  within `this`, which would result in two disjoint intervals
     *  instead of the single one returned by this method.
     */ differenceNotProperlyContained(other) {
        let diff;
        if (other.startsBeforeNonDisjoint(this)) // other.a to left of this.a (or same)
        diff = $bcaa1c4749d34439$var$Interval.of(Math.max(this.a, other.b + 1), this.b);
        else if (other.startsAfterNonDisjoint(this)) // other.a to right of this.a
        diff = $bcaa1c4749d34439$var$Interval.of(this.a, other.a - 1);
        return diff;
    }
    toString() {
        return this.a + ".." + this.b;
    }
}
$bcaa1c4749d34439$var$Interval._INVALID = new $bcaa1c4749d34439$var$Interval(-1, -2);
$bcaa1c4749d34439$var$Interval.cache = new Array($bcaa1c4749d34439$var$INTERVAL_POOL_MAX_VALUE + 1);
$bcaa1c4749d34439$var$__decorate([
    $d6D31.Override
], $bcaa1c4749d34439$var$Interval.prototype, "equals", null);
$bcaa1c4749d34439$var$__decorate([
    $d6D31.Override
], $bcaa1c4749d34439$var$Interval.prototype, "hashCode", null);
$bcaa1c4749d34439$var$__decorate([
    $d6D31.Override
], $bcaa1c4749d34439$var$Interval.prototype, "toString", null);
module.exports.Interval = $bcaa1c4749d34439$var$Interval;

});

parcelRegister("igNLf", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d4d0521f20d9c4ac$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Lexer = void 0;

var $gWaB3 = parcelRequire("gWaB3");

var $6Kebn = parcelRequire("6Kebn");

var $gcfUE = parcelRequire("gcfUE");

var $ceaEj = parcelRequire("ceaEj");

var $lQecE = parcelRequire("lQecE");

var $fOEQQ = parcelRequire("fOEQQ");

var $d6D31 = parcelRequire("d6D31");

var $kBaAZ = parcelRequire("kBaAZ");

var $2DVsz = parcelRequire("2DVsz");
/** A lexer is recognizer that draws input symbols from a character stream.
 *  lexer grammars result in a subclass of this object. A Lexer object
 *  uses simplified match() and error recovery mechanisms in the interest
 *  of speed.
 */ class $d4d0521f20d9c4ac$var$Lexer extends $kBaAZ.Recognizer {
    constructor(input){
        super();
        /** How to create token objects */ this._factory = $gWaB3.CommonTokenFactory.DEFAULT;
        /** What character index in the stream did the current token start at?
         *  Needed, for example, to get the text for current token.  Set at
         *  the start of nextToken.
         */ this._tokenStartCharIndex = -1;
        /** The line on which the first character of the token resides */ this._tokenStartLine = 0;
        /** The character position of first character within the line */ this._tokenStartCharPositionInLine = 0;
        /** Once we see EOF on char stream, next token will be EOF.
         *  If you have DONE : EOF ; then you see DONE EOF.
         */ this._hitEOF = false;
        /** The channel number for the current token */ this._channel = 0;
        /** The token type for the current token */ this._type = 0;
        this._modeStack = new $6Kebn.IntegerStack();
        this._mode = $d4d0521f20d9c4ac$var$Lexer.DEFAULT_MODE;
        this._input = input;
        this._tokenFactorySourcePair = {
            source: this,
            stream: input
        };
    }
    static get DEFAULT_TOKEN_CHANNEL() {
        return $2DVsz.Token.DEFAULT_CHANNEL;
    }
    static get HIDDEN() {
        return $2DVsz.Token.HIDDEN_CHANNEL;
    }
    reset(resetInput) {
        // wack Lexer state variables
        if (resetInput === undefined || resetInput) this._input.seek(0); // rewind the input
        this._token = undefined;
        this._type = $2DVsz.Token.INVALID_TYPE;
        this._channel = $2DVsz.Token.DEFAULT_CHANNEL;
        this._tokenStartCharIndex = -1;
        this._tokenStartCharPositionInLine = -1;
        this._tokenStartLine = -1;
        this._text = undefined;
        this._hitEOF = false;
        this._mode = $d4d0521f20d9c4ac$var$Lexer.DEFAULT_MODE;
        this._modeStack.clear();
        this.interpreter.reset();
    }
    /** Return a token from this source; i.e., match a token on the char
     *  stream.
     */ nextToken() {
        if (this._input == null) throw new Error("nextToken requires a non-null input stream.");
        // Mark start location in char stream so unbuffered streams are
        // guaranteed at least have text of current token
        let tokenStartMarker = this._input.mark();
        try {
            outer: while(true){
                if (this._hitEOF) return this.emitEOF();
                this._token = undefined;
                this._channel = $2DVsz.Token.DEFAULT_CHANNEL;
                this._tokenStartCharIndex = this._input.index;
                this._tokenStartCharPositionInLine = this.interpreter.charPositionInLine;
                this._tokenStartLine = this.interpreter.line;
                this._text = undefined;
                do {
                    this._type = $2DVsz.Token.INVALID_TYPE;
                    //				System.out.println("nextToken line "+tokenStartLine+" at "+((char)input.LA(1))+
                    //								   " in mode "+mode+
                    //								   " at index "+input.index);
                    let ttype;
                    try {
                        ttype = this.interpreter.match(this._input, this._mode);
                    } catch (e) {
                        if (e instanceof $fOEQQ.LexerNoViableAltException) {
                            this.notifyListeners(e); // report error
                            this.recover(e);
                            ttype = $d4d0521f20d9c4ac$var$Lexer.SKIP;
                        } else throw e;
                    }
                    if (this._input.LA(1) === $ceaEj.IntStream.EOF) this._hitEOF = true;
                    if (this._type === $2DVsz.Token.INVALID_TYPE) this._type = ttype;
                    if (this._type === $d4d0521f20d9c4ac$var$Lexer.SKIP) continue outer;
                }while (this._type === $d4d0521f20d9c4ac$var$Lexer.MORE);
                if (this._token == null) return this.emit();
                return this._token;
            }
        } finally{
            // make sure we release marker after match or
            // unbuffered char stream will keep buffering
            this._input.release(tokenStartMarker);
        }
    }
    /** Instruct the lexer to skip creating a token for current lexer rule
     *  and look for another token.  nextToken() knows to keep looking when
     *  a lexer rule finishes with token set to SKIP_TOKEN.  Recall that
     *  if token==undefined at end of any token rule, it creates one for you
     *  and emits it.
     */ skip() {
        this._type = $d4d0521f20d9c4ac$var$Lexer.SKIP;
    }
    more() {
        this._type = $d4d0521f20d9c4ac$var$Lexer.MORE;
    }
    mode(m) {
        this._mode = m;
    }
    pushMode(m) {
        if ($lQecE.LexerATNSimulator.debug) console.log("pushMode " + m);
        this._modeStack.push(this._mode);
        this.mode(m);
    }
    popMode() {
        if (this._modeStack.isEmpty) throw new Error("EmptyStackException");
        if ($lQecE.LexerATNSimulator.debug) console.log("popMode back to " + this._modeStack.peek());
        this.mode(this._modeStack.pop());
        return this._mode;
    }
    get tokenFactory() {
        return this._factory;
    }
    // @Override
    set tokenFactory(factory) {
        this._factory = factory;
    }
    get inputStream() {
        return this._input;
    }
    /** Set the char stream and reset the lexer */ set inputStream(input) {
        this.reset(false);
        this._input = input;
        this._tokenFactorySourcePair = {
            source: this,
            stream: this._input
        };
    }
    get sourceName() {
        return this._input.sourceName;
    }
    emit(token) {
        if (!token) token = this._factory.create(this._tokenFactorySourcePair, this._type, this._text, this._channel, this._tokenStartCharIndex, this.charIndex - 1, this._tokenStartLine, this._tokenStartCharPositionInLine);
        this._token = token;
        return token;
    }
    emitEOF() {
        let cpos = this.charPositionInLine;
        let line = this.line;
        let eof = this._factory.create(this._tokenFactorySourcePair, $2DVsz.Token.EOF, undefined, $2DVsz.Token.DEFAULT_CHANNEL, this._input.index, this._input.index - 1, line, cpos);
        this.emit(eof);
        return eof;
    }
    get line() {
        return this.interpreter.line;
    }
    set line(line) {
        this.interpreter.line = line;
    }
    get charPositionInLine() {
        return this.interpreter.charPositionInLine;
    }
    set charPositionInLine(charPositionInLine) {
        this.interpreter.charPositionInLine = charPositionInLine;
    }
    /** What is the index of the current character of lookahead? */ get charIndex() {
        return this._input.index;
    }
    /** Return the text matched so far for the current token or any
     *  text override.
     */ get text() {
        if (this._text != null) return this._text;
        return this.interpreter.getText(this._input);
    }
    /** Set the complete text of this token; it wipes any previous
     *  changes to the text.
     */ set text(text) {
        this._text = text;
    }
    /** Override if emitting multiple tokens. */ get token() {
        return this._token;
    }
    set token(_token) {
        this._token = _token;
    }
    set type(ttype) {
        this._type = ttype;
    }
    get type() {
        return this._type;
    }
    set channel(channel) {
        this._channel = channel;
    }
    get channel() {
        return this._channel;
    }
    /** Return a list of all Token objects in input char stream.
     *  Forces load of all tokens. Does not include EOF token.
     */ getAllTokens() {
        let tokens = [];
        let t = this.nextToken();
        while(t.type !== $2DVsz.Token.EOF){
            tokens.push(t);
            t = this.nextToken();
        }
        return tokens;
    }
    notifyListeners(e) {
        let text = this._input.getText($gcfUE.Interval.of(this._tokenStartCharIndex, this._input.index));
        let msg = "token recognition error at: '" + this.getErrorDisplay(text) + "'";
        let listener = this.getErrorListenerDispatch();
        if (listener.syntaxError) listener.syntaxError(this, undefined, this._tokenStartLine, this._tokenStartCharPositionInLine, msg, e);
    }
    getErrorDisplay(s) {
        if (typeof s === "number") {
            switch(s){
                case $2DVsz.Token.EOF:
                    return "<EOF>";
                case 0x0a:
                    return "\\n";
                case 0x09:
                    return "\\t";
                case 0x0d:
                    return "\\r";
            }
            return String.fromCharCode(s);
        }
        return s.replace(/\n/g, "\\n").replace(/\t/g, "\\t").replace(/\r/g, "\\r");
    }
    getCharErrorDisplay(c) {
        let s = this.getErrorDisplay(c);
        return "'" + s + "'";
    }
    recover(re) {
        if (re instanceof $fOEQQ.LexerNoViableAltException) {
            if (this._input.LA(1) !== $ceaEj.IntStream.EOF) // skip a char and try again
            this.interpreter.consume(this._input);
        } else //System.out.println("consuming char "+(char)input.LA(1)+" during recovery");
        //re.printStackTrace();
        // TODO: Do we lose character or line position information?
        this._input.consume();
    }
}
$d4d0521f20d9c4ac$var$Lexer.DEFAULT_MODE = 0;
$d4d0521f20d9c4ac$var$Lexer.MORE = -2;
$d4d0521f20d9c4ac$var$Lexer.SKIP = -3;
$d4d0521f20d9c4ac$var$Lexer.MIN_CHAR_VALUE = 0x0000;
$d4d0521f20d9c4ac$var$Lexer.MAX_CHAR_VALUE = 0x10FFFF;
$d4d0521f20d9c4ac$var$__decorate([
    $d6D31.Override
], $d4d0521f20d9c4ac$var$Lexer.prototype, "nextToken", null);
$d4d0521f20d9c4ac$var$__decorate([
    $d6D31.Override
], $d4d0521f20d9c4ac$var$Lexer.prototype, "tokenFactory", null);
$d4d0521f20d9c4ac$var$__decorate([
    $d6D31.Override
], $d4d0521f20d9c4ac$var$Lexer.prototype, "inputStream", null);
$d4d0521f20d9c4ac$var$__decorate([
    $d6D31.Override
], $d4d0521f20d9c4ac$var$Lexer.prototype, "sourceName", null);
$d4d0521f20d9c4ac$var$__decorate([
    $d6D31.Override
], $d4d0521f20d9c4ac$var$Lexer.prototype, "line", null);
$d4d0521f20d9c4ac$var$__decorate([
    $d6D31.Override
], $d4d0521f20d9c4ac$var$Lexer.prototype, "charPositionInLine", null);
module.exports.Lexer = $d4d0521f20d9c4ac$var$Lexer;

});
parcelRegister("gWaB3", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c54a4863b793dbc8$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommonTokenFactory = void 0;

var $j53rr = parcelRequire("j53rr");

var $gcfUE = parcelRequire("gcfUE");

var $d6D31 = parcelRequire("d6D31");
/**
 * This default implementation of {@link TokenFactory} creates
 * {@link CommonToken} objects.
 */ class $c54a4863b793dbc8$var$CommonTokenFactory {
    /**
     * Constructs a {@link CommonTokenFactory} with the specified value for
     * {@link #copyText}.
     *
     * When `copyText` is `false`, the {@link #DEFAULT} instance
     * should be used instead of constructing a new instance.
     *
     * @param copyText The value for {@link #copyText}.
     */ constructor(copyText = false){
        this.copyText = copyText;
    }
    create(source, type, text, channel, start, stop, line, charPositionInLine) {
        let t = new $j53rr.CommonToken(type, text, source, channel, start, stop);
        t.line = line;
        t.charPositionInLine = charPositionInLine;
        if (text == null && this.copyText && source.stream != null) t.text = source.stream.getText($gcfUE.Interval.of(start, stop));
        return t;
    }
    createSimple(type, text) {
        return new $j53rr.CommonToken(type, text);
    }
}
$c54a4863b793dbc8$var$__decorate([
    $d6D31.Override
], $c54a4863b793dbc8$var$CommonTokenFactory.prototype, "create", null);
$c54a4863b793dbc8$var$__decorate([
    $d6D31.Override
], $c54a4863b793dbc8$var$CommonTokenFactory.prototype, "createSimple", null);
module.exports.CommonTokenFactory = $c54a4863b793dbc8$var$CommonTokenFactory;
(function(CommonTokenFactory) {
    /**
     * The default {@link CommonTokenFactory} instance.
     *
     * This token factory does not explicitly copy token text when constructing
     * tokens.
     */ CommonTokenFactory.DEFAULT = new CommonTokenFactory();
})($c54a4863b793dbc8$var$CommonTokenFactory = module.exports.CommonTokenFactory || (module.exports.CommonTokenFactory = {}));

});
parcelRegister("j53rr", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $de41275c931ca469$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $de41275c931ca469$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommonToken = void 0;

var $gcfUE = parcelRequire("gcfUE");

var $d6D31 = parcelRequire("d6D31");

var $2DVsz = parcelRequire("2DVsz");
let $de41275c931ca469$var$CommonToken = class CommonToken {
    constructor(type, text, source = CommonToken.EMPTY_SOURCE, channel = $2DVsz.Token.DEFAULT_CHANNEL, start = 0, stop = 0){
        /**
         * This is the backing field for {@link #getLine} and {@link #setLine}.
         */ this._line = 0;
        /**
         * This is the backing field for {@link #getCharPositionInLine} and
         * {@link #setCharPositionInLine}.
         */ this._charPositionInLine = -1; // set to invalid position
        /**
         * This is the backing field for {@link #getChannel} and
         * {@link #setChannel}.
         */ this._channel = $2DVsz.Token.DEFAULT_CHANNEL;
        /**
         * This is the backing field for `tokenIndex`.
         */ this.index = -1;
        this._text = text;
        this._type = type;
        this.source = source;
        this._channel = channel;
        this.start = start;
        this.stop = stop;
        if (source.source != null) {
            this._line = source.source.line;
            this._charPositionInLine = source.source.charPositionInLine;
        }
    }
    /**
     * Constructs a new {@link CommonToken} as a copy of another {@link Token}.
     *
     * If `oldToken` is also a {@link CommonToken} instance, the newly
     * constructed token will share a reference to the {@link #text} field and
     * the {@link Tuple2} stored in {@link #source}. Otherwise, {@link #text} will
     * be assigned the result of calling {@link #getText}, and {@link #source}
     * will be constructed from the result of {@link Token#getTokenSource} and
     * {@link Token#getInputStream}.
     *
     * @param oldToken The token to copy.
     */ static fromToken(oldToken) {
        let result = new CommonToken(oldToken.type, undefined, CommonToken.EMPTY_SOURCE, oldToken.channel, oldToken.startIndex, oldToken.stopIndex);
        result._line = oldToken.line;
        result.index = oldToken.tokenIndex;
        result._charPositionInLine = oldToken.charPositionInLine;
        if (oldToken instanceof CommonToken) {
            result._text = oldToken._text;
            result.source = oldToken.source;
        } else {
            result._text = oldToken.text;
            result.source = {
                source: oldToken.tokenSource,
                stream: oldToken.inputStream
            };
        }
        return result;
    }
    get type() {
        return this._type;
    }
    // @Override
    set type(type) {
        this._type = type;
    }
    get line() {
        return this._line;
    }
    // @Override
    set line(line) {
        this._line = line;
    }
    get text() {
        if (this._text != null) return this._text;
        let input = this.inputStream;
        if (input == null) return undefined;
        let n = input.size;
        if (this.start < n && this.stop < n) return input.getText($gcfUE.Interval.of(this.start, this.stop));
        else return "<EOF>";
    }
    /**
     * Explicitly set the text for this token. If {code text} is not
     * `undefined`, then {@link #getText} will return this value rather than
     * extracting the text from the input.
     *
     * @param text The explicit text of the token, or `undefined` if the text
     * should be obtained from the input along with the start and stop indexes
     * of the token.
     */ // @Override
    set text(text) {
        this._text = text;
    }
    get charPositionInLine() {
        return this._charPositionInLine;
    }
    // @Override
    set charPositionInLine(charPositionInLine) {
        this._charPositionInLine = charPositionInLine;
    }
    get channel() {
        return this._channel;
    }
    // @Override
    set channel(channel) {
        this._channel = channel;
    }
    get startIndex() {
        return this.start;
    }
    set startIndex(start) {
        this.start = start;
    }
    get stopIndex() {
        return this.stop;
    }
    set stopIndex(stop) {
        this.stop = stop;
    }
    get tokenIndex() {
        return this.index;
    }
    // @Override
    set tokenIndex(index) {
        this.index = index;
    }
    get tokenSource() {
        return this.source.source;
    }
    get inputStream() {
        return this.source.stream;
    }
    toString(recognizer) {
        let channelStr = "";
        if (this._channel > 0) channelStr = ",channel=" + this._channel;
        let txt = this.text;
        if (txt != null) {
            txt = txt.replace(/\n/g, "\\n");
            txt = txt.replace(/\r/g, "\\r");
            txt = txt.replace(/\t/g, "\\t");
        } else txt = "<no text>";
        let typeString = String(this._type);
        if (recognizer) typeString = recognizer.vocabulary.getDisplayName(this._type);
        return "[@" + this.tokenIndex + "," + this.start + ":" + this.stop + "='" + txt + "',<" + typeString + ">" + channelStr + "," + this._line + ":" + this.charPositionInLine + "]";
    }
};
/**
 * An empty {@link Tuple2} which is used as the default value of
 * {@link #source} for tokens that do not have a source.
 */ $de41275c931ca469$var$CommonToken.EMPTY_SOURCE = {
    source: undefined,
    stream: undefined
};
$de41275c931ca469$var$__decorate([
    $d6D31.NotNull
], $de41275c931ca469$var$CommonToken.prototype, "source", void 0);
$de41275c931ca469$var$__decorate([
    $d6D31.Override
], $de41275c931ca469$var$CommonToken.prototype, "type", null);
$de41275c931ca469$var$__decorate([
    $d6D31.Override
], $de41275c931ca469$var$CommonToken.prototype, "line", null);
$de41275c931ca469$var$__decorate([
    $d6D31.Override
], $de41275c931ca469$var$CommonToken.prototype, "text", null);
$de41275c931ca469$var$__decorate([
    $d6D31.Override
], $de41275c931ca469$var$CommonToken.prototype, "charPositionInLine", null);
$de41275c931ca469$var$__decorate([
    $d6D31.Override
], $de41275c931ca469$var$CommonToken.prototype, "channel", null);
$de41275c931ca469$var$__decorate([
    $d6D31.Override
], $de41275c931ca469$var$CommonToken.prototype, "startIndex", null);
$de41275c931ca469$var$__decorate([
    $d6D31.Override
], $de41275c931ca469$var$CommonToken.prototype, "stopIndex", null);
$de41275c931ca469$var$__decorate([
    $d6D31.Override
], $de41275c931ca469$var$CommonToken.prototype, "tokenIndex", null);
$de41275c931ca469$var$__decorate([
    $d6D31.Override
], $de41275c931ca469$var$CommonToken.prototype, "tokenSource", null);
$de41275c931ca469$var$__decorate([
    $d6D31.Override
], $de41275c931ca469$var$CommonToken.prototype, "inputStream", null);
$de41275c931ca469$var$__decorate([
    $d6D31.Override
], $de41275c931ca469$var$CommonToken.prototype, "toString", null);
$de41275c931ca469$var$__decorate([
    $de41275c931ca469$var$__param(0, $d6D31.NotNull)
], $de41275c931ca469$var$CommonToken, "fromToken", null);
$de41275c931ca469$var$CommonToken = $de41275c931ca469$var$__decorate([
    $de41275c931ca469$var$__param(2, $d6D31.NotNull)
], $de41275c931ca469$var$CommonToken);
module.exports.CommonToken = $de41275c931ca469$var$CommonToken;

});
parcelRegister("2DVsz", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Token = void 0;

var $ceaEj = parcelRequire("ceaEj");
var $1ecbcb9fde4eac7e$var$Token;
(function(Token) {
    Token.INVALID_TYPE = 0;
    /** During lookahead operations, this "token" signifies we hit rule end ATN state
     *  and did not follow it despite needing to.
     */ Token.EPSILON = -2;
    Token.MIN_USER_TOKEN_TYPE = 1;
    Token.EOF = $ceaEj.IntStream.EOF;
    /** All tokens go to the parser (unless skip() is called in that rule)
     *  on a particular "channel".  The parser tunes to a particular channel
     *  so that whitespace etc... can go to the parser on a "hidden" channel.
     */ Token.DEFAULT_CHANNEL = 0;
    /** Anything on different channel than DEFAULT_CHANNEL is not parsed
     *  by parser.
     */ Token.HIDDEN_CHANNEL = 1;
    /**
     * This is the minimum constant value which can be assigned to a
     * user-defined token channel.
     *
     * The non-negative numbers less than {@link #MIN_USER_CHANNEL_VALUE} are
     * assigned to the predefined channels {@link #DEFAULT_CHANNEL} and
     * {@link #HIDDEN_CHANNEL}.
     *
     * @see `Token.channel`
     */ Token.MIN_USER_CHANNEL_VALUE = 2;
})($1ecbcb9fde4eac7e$var$Token = module.exports.Token || (module.exports.Token = {}));

});



parcelRegister("6Kebn", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntegerStack = void 0;

var $37SGk = parcelRequire("37SGk");
/**
 *
 * @author Sam Harwell
 */ class $4e920a4df7f4a425$var$IntegerStack extends $37SGk.IntegerList {
    constructor(arg){
        super(arg);
    }
    push(value) {
        this.add(value);
    }
    pop() {
        return this.removeAt(this.size - 1);
    }
    peek() {
        return this.get(this.size - 1);
    }
}
module.exports.IntegerStack = $4e920a4df7f4a425$var$IntegerStack;

});

parcelRegister("lQecE", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $fe6978bd928c111b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $fe6978bd928c111b$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerATNSimulator = void 0;

var $41NTU = parcelRequire("41NTU");

var $bcnvE = parcelRequire("bcnvE");

var $gcX0f = parcelRequire("gcX0f");

var $c1ClW = parcelRequire("c1ClW");

var $kr9A1 = parcelRequire("kr9A1");

var $2jevZ = parcelRequire("2jevZ");

var $gcfUE = parcelRequire("gcfUE");

var $ceaEj = parcelRequire("ceaEj");

var $igNLf = parcelRequire("igNLf");

var $3AYVu = parcelRequire("3AYVu");

var $fOEQQ = parcelRequire("fOEQQ");

var $d6D31 = parcelRequire("d6D31");

var $9tIYC = parcelRequire("9tIYC");

var $8DTT0 = parcelRequire("8DTT0");

var $4kGBm = parcelRequire("4kGBm");

var $2DVsz = parcelRequire("2DVsz");

var $bbHFU = parcelRequire("bbHFU");
/** "dup" of ParserInterpreter */ let $fe6978bd928c111b$var$LexerATNSimulator = class LexerATNSimulator extends $kr9A1.ATNSimulator {
    constructor(atn, recog){
        super(atn);
        this.optimize_tail_calls = true;
        /** The current token's starting index into the character stream.
         *  Shared across DFA to ATN simulation in case the ATN fails and the
         *  DFA did not have a previous accept state. In this case, we use the
         *  ATN-generated exception object.
         */ this.startIndex = -1;
        /** line number 1..n within the input */ this._line = 1;
        /** The index of the character relative to the beginning of the line 0..n-1 */ this._charPositionInLine = 0;
        this.mode = $igNLf.Lexer.DEFAULT_MODE;
        /** Used during DFA/ATN exec to record the most recent accept configuration info */ this.prevAccept = new LexerATNSimulator.SimState();
        this.recog = recog;
    }
    copyState(simulator) {
        this._charPositionInLine = simulator.charPositionInLine;
        this._line = simulator._line;
        this.mode = simulator.mode;
        this.startIndex = simulator.startIndex;
    }
    match(input, mode) {
        this.mode = mode;
        let mark = input.mark();
        try {
            this.startIndex = input.index;
            this.prevAccept.reset();
            let s0 = this.atn.modeToDFA[mode].s0;
            if (s0 == null) return this.matchATN(input);
            else return this.execATN(input, s0);
        } finally{
            input.release(mark);
        }
    }
    reset() {
        this.prevAccept.reset();
        this.startIndex = -1;
        this._line = 1;
        this._charPositionInLine = 0;
        this.mode = $igNLf.Lexer.DEFAULT_MODE;
    }
    matchATN(input) {
        let startState = this.atn.modeToStartState[this.mode];
        if (LexerATNSimulator.debug) console.log(`matchATN mode ${this.mode} start: ${startState}`);
        let old_mode = this.mode;
        let s0_closure = this.computeStartState(input, startState);
        let suppressEdge = s0_closure.hasSemanticContext;
        if (suppressEdge) s0_closure.hasSemanticContext = false;
        let next = this.addDFAState(s0_closure);
        if (!suppressEdge) {
            let dfa = this.atn.modeToDFA[this.mode];
            if (!dfa.s0) dfa.s0 = next;
            else next = dfa.s0;
        }
        let predict = this.execATN(input, next);
        if (LexerATNSimulator.debug) console.log(`DFA after matchATN: ${this.atn.modeToDFA[old_mode].toLexerString()}`);
        return predict;
    }
    execATN(input, ds0) {
        // console.log("enter exec index "+input.index+" from "+ds0.configs);
        if (LexerATNSimulator.debug) console.log(`start state closure=${ds0.configs}`);
        if (ds0.isAcceptState) // allow zero-length tokens
        this.captureSimState(this.prevAccept, input, ds0);
        let t = input.LA(1);
        // @NotNull
        let s = ds0; // s is current/from DFA state
        while(true){
            if (LexerATNSimulator.debug) console.log(`execATN loop starting closure: ${s.configs}`);
            // As we move src->trg, src->trg, we keep track of the previous trg to
            // avoid looking up the DFA state again, which is expensive.
            // If the previous target was already part of the DFA, we might
            // be able to avoid doing a reach operation upon t. If s!=null,
            // it means that semantic predicates didn't prevent us from
            // creating a DFA state. Once we know s!=null, we check to see if
            // the DFA state has an edge already for t. If so, we can just reuse
            // it's configuration set; there's no point in re-computing it.
            // This is kind of like doing DFA simulation within the ATN
            // simulation because DFA simulation is really just a way to avoid
            // computing reach/closure sets. Technically, once we know that
            // we have a previously added DFA state, we could jump over to
            // the DFA simulator. But, that would mean popping back and forth
            // a lot and making things more complicated algorithmically.
            // This optimization makes a lot of sense for loops within DFA.
            // A character will take us back to an existing DFA state
            // that already has lots of edges out of it. e.g., .* in comments.
            let target = this.getExistingTargetState(s, t);
            if (target == null) target = this.computeTargetState(input, s, t);
            if (target === $kr9A1.ATNSimulator.ERROR) break;
            // If this is a consumable input element, make sure to consume before
            // capturing the accept state so the input index, line, and char
            // position accurately reflect the state of the interpreter at the
            // end of the token.
            if (t !== $ceaEj.IntStream.EOF) this.consume(input);
            if (target.isAcceptState) {
                this.captureSimState(this.prevAccept, input, target);
                if (t === $ceaEj.IntStream.EOF) break;
            }
            t = input.LA(1);
            s = target; // flip; current DFA target becomes new src/from state
        }
        return this.failOrAccept(this.prevAccept, input, s.configs, t);
    }
    /**
     * Get an existing target state for an edge in the DFA. If the target state
     * for the edge has not yet been computed or is otherwise not available,
     * this method returns `undefined`.
     *
     * @param s The current DFA state
     * @param t The next input symbol
     * @returns The existing target DFA state for the given input symbol
     * `t`, or `undefined` if the target state for this edge is not
     * already cached
     */ getExistingTargetState(s, t) {
        let target = s.getTarget(t);
        if (LexerATNSimulator.debug && target != null) console.log("reuse state " + s.stateNumber + " edge to " + target.stateNumber);
        return target;
    }
    /**
     * Compute a target state for an edge in the DFA, and attempt to add the
     * computed state and corresponding edge to the DFA.
     *
     * @param input The input stream
     * @param s The current DFA state
     * @param t The next input symbol
     *
     * @returns The computed target DFA state for the given input symbol
     * `t`. If `t` does not lead to a valid DFA state, this method
     * returns {@link #ERROR}.
     */ computeTargetState(input, s, t) {
        let reach = new $9tIYC.OrderedATNConfigSet();
        // if we don't find an existing DFA state
        // Fill reach starting from closure, following t transitions
        this.getReachableConfigSet(input, s.configs, reach, t);
        if (reach.isEmpty) {
            if (!reach.hasSemanticContext) // we got nowhere on t, don't throw out this knowledge; it'd
            // cause a failover from DFA later.
            this.addDFAEdge(s, t, $kr9A1.ATNSimulator.ERROR);
            // stop when we can't match any more char
            return $kr9A1.ATNSimulator.ERROR;
        }
        // Add an edge from s to target DFA found/created for reach
        return this.addDFAEdge(s, t, reach);
    }
    failOrAccept(prevAccept, input, reach, t) {
        if (prevAccept.dfaState != null) {
            let lexerActionExecutor = prevAccept.dfaState.lexerActionExecutor;
            this.accept(input, lexerActionExecutor, this.startIndex, prevAccept.index, prevAccept.line, prevAccept.charPos);
            return prevAccept.dfaState.prediction;
        } else {
            // if no accept and EOF is first char, return EOF
            if (t === $ceaEj.IntStream.EOF && input.index === this.startIndex) return $2DVsz.Token.EOF;
            throw new $fOEQQ.LexerNoViableAltException(this.recog, input, this.startIndex, reach);
        }
    }
    /** Given a starting configuration set, figure out all ATN configurations
     *  we can reach upon input `t`. Parameter `reach` is a return
     *  parameter.
     */ getReachableConfigSet(input, closure, reach, t) {
        // this is used to skip processing for configs which have a lower priority
        // than a config that already reached an accept state for the same rule
        let skipAlt = $bcnvE.ATN.INVALID_ALT_NUMBER;
        for (let c of closure){
            let currentAltReachedAcceptState = c.alt === skipAlt;
            if (currentAltReachedAcceptState && c.hasPassedThroughNonGreedyDecision) continue;
            if (LexerATNSimulator.debug) console.log(`testing ${this.getTokenName(t)} at ${c.toString(this.recog, true)}`);
            let n = c.state.numberOfOptimizedTransitions;
            for(let ti = 0; ti < n; ti++){
                let trans = c.state.getOptimizedTransition(ti);
                let target = this.getReachableTarget(trans, t);
                if (target != null) {
                    let lexerActionExecutor = c.lexerActionExecutor;
                    let config;
                    if (lexerActionExecutor != null) {
                        lexerActionExecutor = lexerActionExecutor.fixOffsetBeforeMatch(input.index - this.startIndex);
                        config = c.transform(target, true, lexerActionExecutor);
                    } else {
                        $bbHFU(c.lexerActionExecutor == null);
                        config = c.transform(target, true);
                    }
                    let treatEofAsEpsilon = t === $ceaEj.IntStream.EOF;
                    if (this.closure(input, config, reach, currentAltReachedAcceptState, true, treatEofAsEpsilon)) {
                        // any remaining configs for this alt have a lower priority than
                        // the one that just reached an accept state.
                        skipAlt = c.alt;
                        break;
                    }
                }
            }
        }
    }
    accept(input, lexerActionExecutor, startIndex, index, line, charPos) {
        if (LexerATNSimulator.debug) console.log(`ACTION ${lexerActionExecutor}`);
        // seek to after last char in token
        input.seek(index);
        this._line = line;
        this._charPositionInLine = charPos;
        if (lexerActionExecutor != null && this.recog != null) lexerActionExecutor.execute(this.recog, input, startIndex);
    }
    getReachableTarget(trans, t) {
        if (trans.matches(t, $igNLf.Lexer.MIN_CHAR_VALUE, $igNLf.Lexer.MAX_CHAR_VALUE)) return trans.target;
        return undefined;
    }
    computeStartState(input, p) {
        let initialContext = $8DTT0.PredictionContext.EMPTY_FULL;
        let configs = new $9tIYC.OrderedATNConfigSet();
        for(let i = 0; i < p.numberOfTransitions; i++){
            let target = p.transition(i).target;
            let c = $gcX0f.ATNConfig.create(target, i + 1, initialContext);
            this.closure(input, c, configs, false, false, false);
        }
        return configs;
    }
    /**
     * Since the alternatives within any lexer decision are ordered by
     * preference, this method stops pursuing the closure as soon as an accept
     * state is reached. After the first accept state is reached by depth-first
     * search from `config`, all other (potentially reachable) states for
     * this rule would have a lower priority.
     *
     * @returns `true` if an accept state is reached, otherwise
     * `false`.
     */ closure(input, config, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon) {
        if (LexerATNSimulator.debug) console.log("closure(" + config.toString(this.recog, true) + ")");
        if (config.state instanceof $4kGBm.RuleStopState) {
            if (LexerATNSimulator.debug) {
                if (this.recog != null) console.log(`closure at ${this.recog.ruleNames[config.state.ruleIndex]} rule stop ${config}`);
                else console.log(`closure at rule stop ${config}`);
            }
            let context = config.context;
            if (context.isEmpty) {
                configs.add(config);
                return true;
            } else if (context.hasEmpty) {
                configs.add(config.transform(config.state, true, $8DTT0.PredictionContext.EMPTY_FULL));
                currentAltReachedAcceptState = true;
            }
            for(let i = 0; i < context.size; i++){
                let returnStateNumber = context.getReturnState(i);
                if (returnStateNumber === $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) continue;
                let newContext = context.getParent(i); // "pop" return state
                let returnState = this.atn.states[returnStateNumber];
                let c = config.transform(returnState, false, newContext);
                currentAltReachedAcceptState = this.closure(input, c, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon);
            }
            return currentAltReachedAcceptState;
        }
        // optimization
        if (!config.state.onlyHasEpsilonTransitions) {
            if (!currentAltReachedAcceptState || !config.hasPassedThroughNonGreedyDecision) configs.add(config);
        }
        let p = config.state;
        for(let i = 0; i < p.numberOfOptimizedTransitions; i++){
            let t = p.getOptimizedTransition(i);
            let c = this.getEpsilonTarget(input, config, t, configs, speculative, treatEofAsEpsilon);
            if (c != null) currentAltReachedAcceptState = this.closure(input, c, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon);
        }
        return currentAltReachedAcceptState;
    }
    // side-effect: can alter configs.hasSemanticContext
    getEpsilonTarget(input, config, t, configs, speculative, treatEofAsEpsilon) {
        let c;
        switch(t.serializationType){
            case 3 /* RULE */ :
                let ruleTransition = t;
                if (this.optimize_tail_calls && ruleTransition.optimizedTailCall && !config.context.hasEmpty) c = config.transform(t.target, true);
                else {
                    let newContext = config.context.getChild(ruleTransition.followState.stateNumber);
                    c = config.transform(t.target, true, newContext);
                }
                break;
            case 10 /* PRECEDENCE */ :
                throw new Error("Precedence predicates are not supported in lexers.");
            case 4 /* PREDICATE */ :
                /*  Track traversing semantic predicates. If we traverse,
                    we cannot add a DFA state for this "reach" computation
                    because the DFA would not test the predicate again in the
                    future. Rather than creating collections of semantic predicates
                    like v3 and testing them on prediction, v4 will test them on the
                    fly all the time using the ATN not the DFA. This is slower but
                    semantically it's not used that often. One of the key elements to
                    this predicate mechanism is not adding DFA states that see
                    predicates immediately afterwards in the ATN. For example,
    
                    a : ID {p1}? | ID {p2}? ;
    
                    should create the start state for rule 'a' (to save start state
                    competition), but should not create target of ID state. The
                    collection of ATN states the following ID references includes
                    states reached by traversing predicates. Since this is when we
                    test them, we cannot cash the DFA state target of ID.
                */ let pt = t;
                if (LexerATNSimulator.debug) console.log("EVAL rule " + pt.ruleIndex + ":" + pt.predIndex);
                configs.hasSemanticContext = true;
                if (this.evaluatePredicate(input, pt.ruleIndex, pt.predIndex, speculative)) c = config.transform(t.target, true);
                else c = undefined;
                break;
            case 6 /* ACTION */ :
                if (config.context.hasEmpty) {
                    // execute actions anywhere in the start rule for a token.
                    //
                    // TODO: if the entry rule is invoked recursively, some
                    // actions may be executed during the recursive call. The
                    // problem can appear when hasEmpty is true but
                    // isEmpty is false. In this case, the config needs to be
                    // split into two contexts - one with just the empty path
                    // and another with everything but the empty path.
                    // Unfortunately, the current algorithm does not allow
                    // getEpsilonTarget to return two configurations, so
                    // additional modifications are needed before we can support
                    // the split operation.
                    let lexerActionExecutor = $3AYVu.LexerActionExecutor.append(config.lexerActionExecutor, this.atn.lexerActions[t.actionIndex]);
                    c = config.transform(t.target, true, lexerActionExecutor);
                    break;
                } else {
                    // ignore actions in referenced rules
                    c = config.transform(t.target, true);
                    break;
                }
            case 1 /* EPSILON */ :
                c = config.transform(t.target, true);
                break;
            case 5 /* ATOM */ :
            case 2 /* RANGE */ :
            case 7 /* SET */ :
                if (treatEofAsEpsilon) {
                    if (t.matches($ceaEj.IntStream.EOF, $igNLf.Lexer.MIN_CHAR_VALUE, $igNLf.Lexer.MAX_CHAR_VALUE)) {
                        c = config.transform(t.target, false);
                        break;
                    }
                }
                c = undefined;
                break;
            default:
                c = undefined;
                break;
        }
        return c;
    }
    /**
     * Evaluate a predicate specified in the lexer.
     *
     * If `speculative` is `true`, this method was called before
     * {@link #consume} for the matched character. This method should call
     * {@link #consume} before evaluating the predicate to ensure position
     * sensitive values, including {@link Lexer#getText}, {@link Lexer#getLine},
     * and {@link Lexer#getCharPositionInLine}, properly reflect the current
     * lexer state. This method should restore `input` and the simulator
     * to the original state before returning (i.e. undo the actions made by the
     * call to {@link #consume}.
     *
     * @param input The input stream.
     * @param ruleIndex The rule containing the predicate.
     * @param predIndex The index of the predicate within the rule.
     * @param speculative `true` if the current index in `input` is
     * one character before the predicate's location.
     *
     * @returns `true` if the specified predicate evaluates to
     * `true`.
     */ evaluatePredicate(input, ruleIndex, predIndex, speculative) {
        // assume true if no recognizer was provided
        if (this.recog == null) return true;
        if (!speculative) return this.recog.sempred(undefined, ruleIndex, predIndex);
        let savedCharPositionInLine = this._charPositionInLine;
        let savedLine = this._line;
        let index = input.index;
        let marker = input.mark();
        try {
            this.consume(input);
            return this.recog.sempred(undefined, ruleIndex, predIndex);
        } finally{
            this._charPositionInLine = savedCharPositionInLine;
            this._line = savedLine;
            input.seek(index);
            input.release(marker);
        }
    }
    captureSimState(settings, input, dfaState) {
        settings.index = input.index;
        settings.line = this._line;
        settings.charPos = this._charPositionInLine;
        settings.dfaState = dfaState;
    }
    addDFAEdge(p, t, q) {
        if (q instanceof $c1ClW.ATNConfigSet) {
            /* leading to this call, ATNConfigSet.hasSemanticContext is used as a
            * marker indicating dynamic predicate evaluation makes this edge
            * dependent on the specific input sequence, so the static edge in the
            * DFA should be omitted. The target DFAState is still created since
            * execATN has the ability to resynchronize with the DFA state cache
            * following the predicate evaluation step.
            *
            * TJP notes: next time through the DFA, we see a pred again and eval.
            * If that gets us to a previously created (but dangling) DFA
            * state, we can continue in pure DFA mode from there.
            */ let suppressEdge = q.hasSemanticContext;
            if (suppressEdge) q.hasSemanticContext = false;
            // @NotNull
            let to = this.addDFAState(q);
            if (suppressEdge) return to;
            this.addDFAEdge(p, t, to);
            return to;
        } else {
            if (LexerATNSimulator.debug) console.log("EDGE " + p + " -> " + q + " upon " + String.fromCharCode(t));
            if (p != null) p.setTarget(t, q);
        }
    }
    /** Add a new DFA state if there isn't one with this set of
     * 	configurations already. This method also detects the first
     * 	configuration containing an ATN rule stop state. Later, when
     * 	traversing the DFA, we will know which rule to accept.
     */ addDFAState(configs) {
        /* the lexer evaluates predicates on-the-fly; by this point configs
         * should not contain any configurations with unevaluated predicates.
         */ $bbHFU(!configs.hasSemanticContext);
        let proposed = new $2jevZ.DFAState(configs);
        let existing = this.atn.modeToDFA[this.mode].states.get(proposed);
        if (existing != null) return existing;
        configs.optimizeConfigs(this);
        let newState = new $2jevZ.DFAState(configs.clone(true));
        let firstConfigWithRuleStopState;
        for (let c of configs)if (c.state instanceof $4kGBm.RuleStopState) {
            firstConfigWithRuleStopState = c;
            break;
        }
        if (firstConfigWithRuleStopState != null) {
            let prediction = this.atn.ruleToTokenType[firstConfigWithRuleStopState.state.ruleIndex];
            let lexerActionExecutor = firstConfigWithRuleStopState.lexerActionExecutor;
            newState.acceptStateInfo = new $41NTU.AcceptStateInfo(prediction, lexerActionExecutor);
        }
        return this.atn.modeToDFA[this.mode].addState(newState);
    }
    getDFA(mode) {
        return this.atn.modeToDFA[mode];
    }
    /** Get the text matched so far for the current token.
     */ getText(input) {
        // index is first lookahead char, don't include.
        return input.getText($gcfUE.Interval.of(this.startIndex, input.index - 1));
    }
    get line() {
        return this._line;
    }
    set line(line) {
        this._line = line;
    }
    get charPositionInLine() {
        return this._charPositionInLine;
    }
    set charPositionInLine(charPositionInLine) {
        this._charPositionInLine = charPositionInLine;
    }
    consume(input) {
        let curChar = input.LA(1);
        if (curChar === "\n".charCodeAt(0)) {
            this._line++;
            this._charPositionInLine = 0;
        } else this._charPositionInLine++;
        input.consume();
    }
    getTokenName(t) {
        if (t === -1) return "EOF";
        //if ( atn.g!=null ) return atn.g.getTokenDisplayName(t);
        return "'" + String.fromCharCode(t) + "'";
    }
};
$fe6978bd928c111b$var$__decorate([
    $d6D31.NotNull
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "prevAccept", void 0);
$fe6978bd928c111b$var$__decorate([
    $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "copyState", null);
$fe6978bd928c111b$var$__decorate([
    $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "match", null);
$fe6978bd928c111b$var$__decorate([
    $d6D31.Override
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "reset", null);
$fe6978bd928c111b$var$__decorate([
    $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "matchATN", null);
$fe6978bd928c111b$var$__decorate([
    $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
    $fe6978bd928c111b$var$__param(1, $d6D31.NotNull)
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "execATN", null);
$fe6978bd928c111b$var$__decorate([
    $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "getExistingTargetState", null);
$fe6978bd928c111b$var$__decorate([
    $d6D31.NotNull,
    $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
    $fe6978bd928c111b$var$__param(1, $d6D31.NotNull)
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "computeTargetState", null);
$fe6978bd928c111b$var$__decorate([
    $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
    $fe6978bd928c111b$var$__param(1, $d6D31.NotNull),
    $fe6978bd928c111b$var$__param(2, $d6D31.NotNull)
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "getReachableConfigSet", null);
$fe6978bd928c111b$var$__decorate([
    $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "accept", null);
$fe6978bd928c111b$var$__decorate([
    $d6D31.NotNull,
    $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
    $fe6978bd928c111b$var$__param(1, $d6D31.NotNull)
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "computeStartState", null);
$fe6978bd928c111b$var$__decorate([
    $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
    $fe6978bd928c111b$var$__param(1, $d6D31.NotNull),
    $fe6978bd928c111b$var$__param(2, $d6D31.NotNull)
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "closure", null);
$fe6978bd928c111b$var$__decorate([
    $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
    $fe6978bd928c111b$var$__param(1, $d6D31.NotNull),
    $fe6978bd928c111b$var$__param(2, $d6D31.NotNull),
    $fe6978bd928c111b$var$__param(3, $d6D31.NotNull)
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "getEpsilonTarget", null);
$fe6978bd928c111b$var$__decorate([
    $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "evaluatePredicate", null);
$fe6978bd928c111b$var$__decorate([
    $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
    $fe6978bd928c111b$var$__param(1, $d6D31.NotNull),
    $fe6978bd928c111b$var$__param(2, $d6D31.NotNull)
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "captureSimState", null);
$fe6978bd928c111b$var$__decorate([
    $d6D31.NotNull,
    $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "addDFAState", null);
$fe6978bd928c111b$var$__decorate([
    $d6D31.NotNull
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "getDFA", null);
$fe6978bd928c111b$var$__decorate([
    $d6D31.NotNull,
    $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "getText", null);
$fe6978bd928c111b$var$__decorate([
    $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "consume", null);
$fe6978bd928c111b$var$__decorate([
    $d6D31.NotNull
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "getTokenName", null);
$fe6978bd928c111b$var$LexerATNSimulator = $fe6978bd928c111b$var$__decorate([
    $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
], $fe6978bd928c111b$var$LexerATNSimulator);
module.exports.LexerATNSimulator = $fe6978bd928c111b$var$LexerATNSimulator;
(function(LexerATNSimulator) {
    LexerATNSimulator.debug = false;
    LexerATNSimulator.dfa_debug = false;
    /** When we hit an accept state in either the DFA or the ATN, we
     *  have to notify the character stream to start buffering characters
     *  via {@link IntStream#mark} and record the current state. The current sim state
     *  includes the current index into the input, the current line,
     *  and current character position in that line. Note that the Lexer is
     *  tracking the starting line and characterization of the token. These
     *  variables track the "state" of the simulator when it hits an accept state.
     *
     *  We track these variables separately for the DFA and ATN simulation
     *  because the DFA simulation often has to fail over to the ATN
     *  simulation. If the ATN simulation fails, we need the DFA to fall
     *  back to its previously accepted state, if any. If the ATN succeeds,
     *  then the ATN does the accept and the DFA simulator that invoked it
     *  can simply return the predicted token type.
     */ class SimState {
        constructor(){
            this.index = -1;
            this.line = 0;
            this.charPos = -1;
        }
        reset() {
            this.index = -1;
            this.line = 0;
            this.charPos = -1;
            this.dfaState = undefined;
        }
    }
    LexerATNSimulator.SimState = SimState;
})($fe6978bd928c111b$var$LexerATNSimulator = module.exports.LexerATNSimulator || (module.exports.LexerATNSimulator = {}));
module.exports.LexerATNSimulator = $fe6978bd928c111b$var$LexerATNSimulator;

});
parcelRegister("41NTU", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AcceptStateInfo = void 0;
/**
 * Stores information about a {@link DFAState} which is an accept state under
 * some condition. Certain settings, such as
 * {@link ParserATNSimulator#getPredictionMode()}, may be used in addition to
 * this information to determine whether or not a particular state is an accept
 * state.
 *
 * @author Sam Harwell
 */ class $2eedf6a56837c02c$var$AcceptStateInfo {
    constructor(prediction, lexerActionExecutor){
        this._prediction = prediction;
        this._lexerActionExecutor = lexerActionExecutor;
    }
    /**
     * Gets the prediction made by this accept state. Note that this value
     * assumes the predicates, if any, in the {@link DFAState} evaluate to
     * `true`. If predicate evaluation is enabled, the final prediction of
     * the accept state will be determined by the result of predicate
     * evaluation.
     */ get prediction() {
        return this._prediction;
    }
    /**
     * Gets the {@link LexerActionExecutor} which can be used to execute actions
     * and/or commands after the lexer matches a token.
     */ get lexerActionExecutor() {
        return this._lexerActionExecutor;
    }
}
module.exports.AcceptStateInfo = $2eedf6a56837c02c$var$AcceptStateInfo;

});

parcelRegister("bcnvE", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $82730d2c6766359c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $82730d2c6766359c$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATN = void 0;

var $fP17P = parcelRequire("fP17P");

var $jJRyp = parcelRequire("jJRyp");

var $hGRod = parcelRequire("hGRod");

var $l4Nh1 = parcelRequire("l4Nh1");

var $iiE1V = parcelRequire("iiE1V");

var $d6D31 = parcelRequire("d6D31");

var $a4Flx = parcelRequire("a4Flx");

var $8DTT0 = parcelRequire("8DTT0");

var $2DVsz = parcelRequire("2DVsz");

var $bbHFU = parcelRequire("bbHFU");
/** */ let $82730d2c6766359c$var$ATN = class ATN {
    /** Used for runtime deserialization of ATNs from strings */ constructor(grammarType, maxTokenType){
        this.states = [];
        /** Each subrule/rule is a decision point and we must track them so we
         *  can go back later and build DFA predictors for them.  This includes
         *  all the rules, subrules, optional blocks, ()+, ()* etc...
         */ this.decisionToState = [];
        this.modeNameToStartState = new Map();
        this.modeToStartState = [];
        this.contextCache = new $fP17P.Array2DHashMap($a4Flx.ObjectEqualityComparator.INSTANCE);
        this.decisionToDFA = [];
        this.modeToDFA = [];
        this.LL1Table = new Map();
        this.grammarType = grammarType;
        this.maxTokenType = maxTokenType;
    }
    clearDFA() {
        this.decisionToDFA = new Array(this.decisionToState.length);
        for(let i = 0; i < this.decisionToDFA.length; i++)this.decisionToDFA[i] = new $jJRyp.DFA(this.decisionToState[i], i);
        this.modeToDFA = new Array(this.modeToStartState.length);
        for(let i = 0; i < this.modeToDFA.length; i++)this.modeToDFA[i] = new $jJRyp.DFA(this.modeToStartState[i]);
        this.contextCache.clear();
        this.LL1Table.clear();
    }
    get contextCacheSize() {
        return this.contextCache.size;
    }
    getCachedContext(context) {
        return $8DTT0.PredictionContext.getCachedContext(context, this.contextCache, new $8DTT0.PredictionContext.IdentityHashMap());
    }
    getDecisionToDFA() {
        $bbHFU(this.decisionToDFA != null && this.decisionToDFA.length === this.decisionToState.length);
        return this.decisionToDFA;
    }
    nextTokens(s, ctx) {
        if (ctx) {
            let anal = new $iiE1V.LL1Analyzer(this);
            let next = anal.LOOK(s, ctx);
            return next;
        } else {
            if (s.nextTokenWithinRule) return s.nextTokenWithinRule;
            s.nextTokenWithinRule = this.nextTokens(s, $8DTT0.PredictionContext.EMPTY_LOCAL);
            s.nextTokenWithinRule.setReadonly(true);
            return s.nextTokenWithinRule;
        }
    }
    addState(state) {
        state.atn = this;
        state.stateNumber = this.states.length;
        this.states.push(state);
    }
    removeState(state) {
        // just replace the state, don't shift states in list
        let invalidState = new $l4Nh1.InvalidState();
        invalidState.atn = this;
        invalidState.stateNumber = state.stateNumber;
        this.states[state.stateNumber] = invalidState;
    }
    defineMode(name, s) {
        this.modeNameToStartState.set(name, s);
        this.modeToStartState.push(s);
        this.modeToDFA.push(new $jJRyp.DFA(s));
        this.defineDecisionState(s);
    }
    defineDecisionState(s) {
        this.decisionToState.push(s);
        s.decision = this.decisionToState.length - 1;
        this.decisionToDFA.push(new $jJRyp.DFA(s, s.decision));
        return s.decision;
    }
    getDecisionState(decision) {
        if (this.decisionToState.length > 0) return this.decisionToState[decision];
        return undefined;
    }
    get numberOfDecisions() {
        return this.decisionToState.length;
    }
    /**
     * Computes the set of input symbols which could follow ATN state number
     * `stateNumber` in the specified full `context`. This method
     * considers the complete parser context, but does not evaluate semantic
     * predicates (i.e. all predicates encountered during the calculation are
     * assumed true). If a path in the ATN exists from the starting state to the
     * {@link RuleStopState} of the outermost context without matching any
     * symbols, {@link Token#EOF} is added to the returned set.
     *
     * If `context` is `undefined`, it is treated as
     * {@link ParserRuleContext#EMPTY}.
     *
     * Note that this does NOT give you the set of all tokens that could
     * appear at a given token position in the input phrase.  In other words, it
     * does not answer:
     *
     * > Given a specific partial input phrase, return the set of all
     * > tokens that can follow the last token in the input phrase.
     *
     * The big difference is that with just the input, the parser could land
     * right in the middle of a lookahead decision. Getting all
     * *possible* tokens given a partial input stream is a separate
     * computation. See https://github.com/antlr/antlr4/issues/1428
     *
     * For this function, we are specifying an ATN state and call stack to
     * compute what token(s) can come next and specifically: outside of a
     * lookahead decision. That is what you want for error reporting and
     * recovery upon parse error.
     *
     * @param stateNumber the ATN state number
     * @param context the full parse context
     * @returns The set of potentially valid input symbols which could follow the
     * specified state in the specified context.
     * @ if the ATN does not contain a state with
     * number `stateNumber`
     */ getExpectedTokens(stateNumber, context) {
        if (stateNumber < 0 || stateNumber >= this.states.length) throw new RangeError("Invalid state number.");
        let ctx = context;
        let s = this.states[stateNumber];
        let following = this.nextTokens(s);
        if (!following.contains($2DVsz.Token.EPSILON)) return following;
        let expected = new $hGRod.IntervalSet();
        expected.addAll(following);
        expected.remove($2DVsz.Token.EPSILON);
        while(ctx != null && ctx.invokingState >= 0 && following.contains($2DVsz.Token.EPSILON)){
            let invokingState = this.states[ctx.invokingState];
            let rt = invokingState.transition(0);
            following = this.nextTokens(rt.followState);
            expected.addAll(following);
            expected.remove($2DVsz.Token.EPSILON);
            ctx = ctx._parent;
        }
        if (following.contains($2DVsz.Token.EPSILON)) expected.add($2DVsz.Token.EOF);
        return expected;
    }
};
$82730d2c6766359c$var$__decorate([
    $d6D31.NotNull
], $82730d2c6766359c$var$ATN.prototype, "states", void 0);
$82730d2c6766359c$var$__decorate([
    $d6D31.NotNull
], $82730d2c6766359c$var$ATN.prototype, "decisionToState", void 0);
$82730d2c6766359c$var$__decorate([
    $d6D31.NotNull
], $82730d2c6766359c$var$ATN.prototype, "modeNameToStartState", void 0);
$82730d2c6766359c$var$__decorate([
    $d6D31.NotNull
], $82730d2c6766359c$var$ATN.prototype, "modeToStartState", void 0);
$82730d2c6766359c$var$__decorate([
    $d6D31.NotNull
], $82730d2c6766359c$var$ATN.prototype, "decisionToDFA", void 0);
$82730d2c6766359c$var$__decorate([
    $d6D31.NotNull
], $82730d2c6766359c$var$ATN.prototype, "modeToDFA", void 0);
$82730d2c6766359c$var$__decorate([
    $d6D31.NotNull
], $82730d2c6766359c$var$ATN.prototype, "nextTokens", null);
$82730d2c6766359c$var$__decorate([
    $82730d2c6766359c$var$__param(0, $d6D31.NotNull)
], $82730d2c6766359c$var$ATN.prototype, "removeState", null);
$82730d2c6766359c$var$__decorate([
    $82730d2c6766359c$var$__param(0, $d6D31.NotNull),
    $82730d2c6766359c$var$__param(1, $d6D31.NotNull)
], $82730d2c6766359c$var$ATN.prototype, "defineMode", null);
$82730d2c6766359c$var$__decorate([
    $82730d2c6766359c$var$__param(0, $d6D31.NotNull)
], $82730d2c6766359c$var$ATN.prototype, "defineDecisionState", null);
$82730d2c6766359c$var$__decorate([
    $d6D31.NotNull
], $82730d2c6766359c$var$ATN.prototype, "getExpectedTokens", null);
$82730d2c6766359c$var$ATN = $82730d2c6766359c$var$__decorate([
    $82730d2c6766359c$var$__param(0, $d6D31.NotNull)
], $82730d2c6766359c$var$ATN);
module.exports.ATN = $82730d2c6766359c$var$ATN;
(function(ATN) {
    ATN.INVALID_ALT_NUMBER = 0;
})($82730d2c6766359c$var$ATN = module.exports.ATN || (module.exports.ATN = {}));
module.exports.ATN = $82730d2c6766359c$var$ATN;

});
parcelRegister("fP17P", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Array2DHashMap = void 0;

var $7Veax = parcelRequire("7Veax");
class $b84c7de35a10478c$var$MapKeyEqualityComparator {
    constructor(keyComparator){
        this.keyComparator = keyComparator;
    }
    hashCode(obj) {
        return this.keyComparator.hashCode(obj.key);
    }
    equals(a, b) {
        return this.keyComparator.equals(a.key, b.key);
    }
}
class $b84c7de35a10478c$var$Array2DHashMap {
    constructor(keyComparer){
        if (keyComparer instanceof $b84c7de35a10478c$var$Array2DHashMap) this.backingStore = new $7Veax.Array2DHashSet(keyComparer.backingStore);
        else this.backingStore = new $7Veax.Array2DHashSet(new $b84c7de35a10478c$var$MapKeyEqualityComparator(keyComparer));
    }
    clear() {
        this.backingStore.clear();
    }
    containsKey(key) {
        return this.backingStore.contains({
            key: key
        });
    }
    get(key) {
        let bucket = this.backingStore.get({
            key: key
        });
        if (!bucket) return undefined;
        return bucket.value;
    }
    get isEmpty() {
        return this.backingStore.isEmpty;
    }
    put(key, value) {
        let element = this.backingStore.get({
            key: key,
            value: value
        });
        let result;
        if (!element) this.backingStore.add({
            key: key,
            value: value
        });
        else {
            result = element.value;
            element.value = value;
        }
        return result;
    }
    putIfAbsent(key, value) {
        let element = this.backingStore.get({
            key: key,
            value: value
        });
        let result;
        if (!element) this.backingStore.add({
            key: key,
            value: value
        });
        else result = element.value;
        return result;
    }
    get size() {
        return this.backingStore.size;
    }
    hashCode() {
        return this.backingStore.hashCode();
    }
    equals(o) {
        if (!(o instanceof $b84c7de35a10478c$var$Array2DHashMap)) return false;
        return this.backingStore.equals(o.backingStore);
    }
}
module.exports.Array2DHashMap = $b84c7de35a10478c$var$Array2DHashMap;

});

parcelRegister("jJRyp", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e5ebc30517b3d229$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $e5ebc30517b3d229$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DFA = void 0;

var $7Veax = parcelRequire("7Veax");

var $c1ClW = parcelRequire("c1ClW");

var $yhTtv = parcelRequire("yhTtv");

var $2jevZ = parcelRequire("2jevZ");

var $aeRGo = parcelRequire("aeRGo");

var $d6D31 = parcelRequire("d6D31");

var $a4Flx = parcelRequire("a4Flx");

var $f9raX = parcelRequire("f9raX");

var $3n2FE = parcelRequire("3n2FE");
let $e5ebc30517b3d229$var$DFA = class DFA {
    constructor(atnStartState, decision = 0){
        /**
         * A set of all states in the `DFA`.
         *
         * Note that this collection of states holds the DFA states for both SLL and LL prediction. Only the start state
         * needs to be differentiated for these cases, which is tracked by the `s0` and `s0full` fields.
         */ this.states = new $7Veax.Array2DHashSet($a4Flx.ObjectEqualityComparator.INSTANCE);
        this.nextStateNumber = 0;
        if (!atnStartState.atn) throw new Error("The ATNState must be associated with an ATN");
        this.atnStartState = atnStartState;
        this.atn = atnStartState.atn;
        this.decision = decision;
        // Precedence DFAs are associated with the special precedence decision created for left-recursive rules which
        // evaluate their alternatives using a precedence hierarchy. When such a decision is encountered, we mark this
        // DFA instance as a precedence DFA and initialize the initial states s0 and s0full to special DFAState
        // instances which use outgoing edges to link to the actual start state used for each precedence level.
        let isPrecedenceDfa = false;
        if (atnStartState instanceof $f9raX.StarLoopEntryState) {
            if (atnStartState.precedenceRuleDecision) {
                isPrecedenceDfa = true;
                this.s0 = new $2jevZ.DFAState(new $c1ClW.ATNConfigSet());
                this.s0full = new $2jevZ.DFAState(new $c1ClW.ATNConfigSet());
            }
        }
        this.precedenceDfa = isPrecedenceDfa;
    }
    /**
     * Gets whether this DFA is a precedence DFA. Precedence DFAs use a special
     * start state {@link #s0} which is not stored in {@link #states}. The
     * {@link DFAState#edges} array for this start state contains outgoing edges
     * supplying individual start states corresponding to specific precedence
     * values.
     *
     * @returns `true` if this is a precedence DFA; otherwise,
     * `false`.
     * @see Parser.precedence
     */ get isPrecedenceDfa() {
        return this.precedenceDfa;
    }
    /**
     * Get the start state for a specific precedence value.
     *
     * @param precedence The current precedence.
     * @returns The start state corresponding to the specified precedence, or
     * `undefined` if no start state exists for the specified precedence.
     *
     * @ if this is not a precedence DFA.
     * @see `isPrecedenceDfa`
     */ getPrecedenceStartState(precedence, fullContext) {
        if (!this.isPrecedenceDfa) throw new Error("Only precedence DFAs may contain a precedence start state.");
        // s0 and s0full are never null for a precedence DFA
        if (fullContext) return this.s0full.getTarget(precedence);
        else return this.s0.getTarget(precedence);
    }
    /**
     * Set the start state for a specific precedence value.
     *
     * @param precedence The current precedence.
     * @param startState The start state corresponding to the specified
     * precedence.
     *
     * @ if this is not a precedence DFA.
     * @see `isPrecedenceDfa`
     */ setPrecedenceStartState(precedence, fullContext, startState) {
        if (!this.isPrecedenceDfa) throw new Error("Only precedence DFAs may contain a precedence start state.");
        if (precedence < 0) return;
        if (fullContext) // s0full is never null for a precedence DFA
        this.s0full.setTarget(precedence, startState);
        else // s0 is never null for a precedence DFA
        this.s0.setTarget(precedence, startState);
    }
    get isEmpty() {
        if (this.isPrecedenceDfa) // s0 and s0full are never null for a precedence DFA
        return this.s0.getEdgeMap().size === 0 && this.s0full.getEdgeMap().size === 0;
        return this.s0 == null && this.s0full == null;
    }
    get isContextSensitive() {
        if (this.isPrecedenceDfa) // s0full is never null for a precedence DFA
        return this.s0full.getEdgeMap().size > 0;
        return this.s0full != null;
    }
    addState(state) {
        state.stateNumber = this.nextStateNumber++;
        return this.states.getOrAdd(state);
    }
    toString(vocabulary, ruleNames) {
        if (!vocabulary) vocabulary = $3n2FE.VocabularyImpl.EMPTY_VOCABULARY;
        if (!this.s0) return "";
        let serializer;
        if (ruleNames) serializer = new $yhTtv.DFASerializer(this, vocabulary, ruleNames, this.atnStartState.atn);
        else serializer = new $yhTtv.DFASerializer(this, vocabulary);
        return serializer.toString();
    }
    toLexerString() {
        if (!this.s0) return "";
        let serializer = new $aeRGo.LexerDFASerializer(this);
        return serializer.toString();
    }
};
$e5ebc30517b3d229$var$__decorate([
    $d6D31.NotNull
], $e5ebc30517b3d229$var$DFA.prototype, "states", void 0);
$e5ebc30517b3d229$var$__decorate([
    $d6D31.NotNull
], $e5ebc30517b3d229$var$DFA.prototype, "atnStartState", void 0);
$e5ebc30517b3d229$var$__decorate([
    $d6D31.NotNull
], $e5ebc30517b3d229$var$DFA.prototype, "atn", void 0);
$e5ebc30517b3d229$var$DFA = $e5ebc30517b3d229$var$__decorate([
    $e5ebc30517b3d229$var$__param(0, $d6D31.NotNull)
], $e5ebc30517b3d229$var$DFA);
module.exports.DFA = $e5ebc30517b3d229$var$DFA;

});
parcelRegister("c1ClW", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $8c13542112ebfd78$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNConfigSet = void 0;

var $fP17P = parcelRequire("fP17P");

var $7Veax = parcelRequire("7Veax");

var $3sNxf = parcelRequire("3sNxf");

var $bcnvE = parcelRequire("bcnvE");

var $gcX0f = parcelRequire("gcX0f");

var $5BPMp = parcelRequire("5BPMp");

var $d6D31 = parcelRequire("d6D31");

var $a4Flx = parcelRequire("a4Flx");

var $8DTT0 = parcelRequire("8DTT0");

var $6vF7J = parcelRequire("6vF7J");

var $eHMgW = parcelRequire("eHMgW");

var $bbHFU = parcelRequire("bbHFU");

var $2IEP9 = parcelRequire("2IEP9");
class $8c13542112ebfd78$var$KeyTypeEqualityComparer {
    hashCode(key) {
        return key.state ^ key.alt;
    }
    equals(a, b) {
        return a.state === b.state && a.alt === b.alt;
    }
}
$8c13542112ebfd78$var$KeyTypeEqualityComparer.INSTANCE = new $8c13542112ebfd78$var$KeyTypeEqualityComparer();
function $8c13542112ebfd78$var$NewKeyedConfigMap(map) {
    if (map) return new $fP17P.Array2DHashMap(map);
    else return new $fP17P.Array2DHashMap($8c13542112ebfd78$var$KeyTypeEqualityComparer.INSTANCE);
}
/**
 * Represents a set of ATN configurations (see `ATNConfig`). As configurations are added to the set, they are merged
 * with other `ATNConfig` instances already in the set when possible using the graph-structured stack.
 *
 * An instance of this class represents the complete set of positions (with context) in an ATN which would be associated
 * with a single DFA state. Its internal representation is more complex than traditional state used for NFA to DFA
 * conversion due to performance requirements (both improving speed and reducing memory overhead) as well as supporting
 * features such as semantic predicates and non-greedy operators in a form to support ANTLR's prediction algorithm.
 *
 * @author Sam Harwell
 */ class $8c13542112ebfd78$var$ATNConfigSet {
    constructor(set, readonly){
        this._uniqueAlt = 0;
        // Used in parser and lexer. In lexer, it indicates we hit a pred
        // while computing a closure operation.  Don't make a DFA state from this.
        this._hasSemanticContext = false;
        this._dipsIntoOuterContext = false;
        /**
         * When `true`, this config set represents configurations where the entire
         * outer context has been consumed by the ATN interpreter. This prevents the
         * {@link ParserATNSimulator#closure} from pursuing the global FOLLOW when a
         * rule stop state is reached with an empty prediction context.
         *
         * Note: `outermostConfigSet` and {@link #dipsIntoOuterContext} should never
         * be true at the same time.
         */ this.outermostConfigSet = false;
        this.cachedHashCode = -1;
        if (!set) {
            this.mergedConfigs = $8c13542112ebfd78$var$NewKeyedConfigMap();
            this.unmerged = [];
            this.configs = [];
            this._uniqueAlt = $bcnvE.ATN.INVALID_ALT_NUMBER;
        } else {
            if (readonly) {
                this.mergedConfigs = undefined;
                this.unmerged = undefined;
            } else if (!set.isReadOnly) {
                this.mergedConfigs = $8c13542112ebfd78$var$NewKeyedConfigMap(set.mergedConfigs);
                this.unmerged = set.unmerged.slice(0);
            } else {
                this.mergedConfigs = $8c13542112ebfd78$var$NewKeyedConfigMap();
                this.unmerged = [];
            }
            this.configs = set.configs.slice(0);
            this._dipsIntoOuterContext = set._dipsIntoOuterContext;
            this._hasSemanticContext = set._hasSemanticContext;
            this.outermostConfigSet = set.outermostConfigSet;
            if (readonly || !set.isReadOnly) {
                this._uniqueAlt = set._uniqueAlt;
                this._conflictInfo = set._conflictInfo;
            }
        // if (!readonly && set.isReadOnly) -> addAll is called from clone()
        }
    }
    /**
     * Get the set of all alternatives represented by configurations in this
     * set.
     */ getRepresentedAlternatives() {
        if (this._conflictInfo != null) return this._conflictInfo.conflictedAlts.clone();
        let alts = new $5BPMp.BitSet();
        for (let config of this)alts.set(config.alt);
        return alts;
    }
    get isReadOnly() {
        return this.mergedConfigs == null;
    }
    get isOutermostConfigSet() {
        return this.outermostConfigSet;
    }
    set isOutermostConfigSet(outermostConfigSet) {
        if (this.outermostConfigSet && !outermostConfigSet) throw new Error("IllegalStateException");
        $bbHFU(!outermostConfigSet || !this._dipsIntoOuterContext);
        this.outermostConfigSet = outermostConfigSet;
    }
    getStates() {
        let states = new $7Veax.Array2DHashSet($a4Flx.ObjectEqualityComparator.INSTANCE);
        for (let c of this.configs)states.add(c.state);
        return states;
    }
    optimizeConfigs(interpreter) {
        if (this.configs.length === 0) return;
        for (let config of this.configs)config.context = interpreter.atn.getCachedContext(config.context);
    }
    clone(readonly) {
        let copy = new $8c13542112ebfd78$var$ATNConfigSet(this, readonly);
        if (!readonly && this.isReadOnly) copy.addAll(this.configs);
        return copy;
    }
    get size() {
        return this.configs.length;
    }
    get isEmpty() {
        return this.configs.length === 0;
    }
    contains(o) {
        if (!(o instanceof $gcX0f.ATNConfig)) return false;
        if (this.mergedConfigs && this.unmerged) {
            let config = o;
            let configKey = this.getKey(config);
            let mergedConfig = this.mergedConfigs.get(configKey);
            if (mergedConfig != null && this.canMerge(config, configKey, mergedConfig)) return mergedConfig.contains(config);
            for (let c of this.unmerged){
                if (c.contains(o)) return true;
            }
        } else for (let c of this.configs){
            if (c.contains(o)) return true;
        }
        return false;
    }
    *[Symbol.iterator]() {
        yield* this.configs;
    }
    toArray() {
        return this.configs;
    }
    add(e, contextCache) {
        this.ensureWritable();
        if (!this.mergedConfigs || !this.unmerged) throw new Error("Covered by ensureWritable but duplicated here for strict null check limitation");
        $bbHFU(!this.outermostConfigSet || !e.reachesIntoOuterContext);
        if (contextCache == null) contextCache = $6vF7J.PredictionContextCache.UNCACHED;
        let addKey;
        let key = this.getKey(e);
        let mergedConfig = this.mergedConfigs.get(key);
        addKey = mergedConfig == null;
        if (mergedConfig != null && this.canMerge(e, key, mergedConfig)) {
            mergedConfig.outerContextDepth = Math.max(mergedConfig.outerContextDepth, e.outerContextDepth);
            if (e.isPrecedenceFilterSuppressed) mergedConfig.isPrecedenceFilterSuppressed = true;
            let joined = $8DTT0.PredictionContext.join(mergedConfig.context, e.context, contextCache);
            this.updatePropertiesForMergedConfig(e);
            if (mergedConfig.context === joined) return false;
            mergedConfig.context = joined;
            return true;
        }
        for(let i = 0; i < this.unmerged.length; i++){
            let unmergedConfig = this.unmerged[i];
            if (this.canMerge(e, key, unmergedConfig)) {
                unmergedConfig.outerContextDepth = Math.max(unmergedConfig.outerContextDepth, e.outerContextDepth);
                if (e.isPrecedenceFilterSuppressed) unmergedConfig.isPrecedenceFilterSuppressed = true;
                let joined = $8DTT0.PredictionContext.join(unmergedConfig.context, e.context, contextCache);
                this.updatePropertiesForMergedConfig(e);
                if (unmergedConfig.context === joined) return false;
                unmergedConfig.context = joined;
                if (addKey) {
                    this.mergedConfigs.put(key, unmergedConfig);
                    this.unmerged.splice(i, 1);
                }
                return true;
            }
        }
        this.configs.push(e);
        if (addKey) this.mergedConfigs.put(key, e);
        else this.unmerged.push(e);
        this.updatePropertiesForAddedConfig(e);
        return true;
    }
    updatePropertiesForMergedConfig(config) {
        // merged configs can't change the alt or semantic context
        this._dipsIntoOuterContext = this._dipsIntoOuterContext || config.reachesIntoOuterContext;
        $bbHFU(!this.outermostConfigSet || !this._dipsIntoOuterContext);
    }
    updatePropertiesForAddedConfig(config) {
        if (this.configs.length === 1) this._uniqueAlt = config.alt;
        else if (this._uniqueAlt !== config.alt) this._uniqueAlt = $bcnvE.ATN.INVALID_ALT_NUMBER;
        this._hasSemanticContext = this._hasSemanticContext || !$eHMgW.SemanticContext.NONE.equals(config.semanticContext);
        this._dipsIntoOuterContext = this._dipsIntoOuterContext || config.reachesIntoOuterContext;
        $bbHFU(!this.outermostConfigSet || !this._dipsIntoOuterContext);
    }
    canMerge(left, leftKey, right) {
        if (left.state.stateNumber !== right.state.stateNumber) return false;
        if (leftKey.alt !== right.alt) return false;
        return left.semanticContext.equals(right.semanticContext);
    }
    getKey(e) {
        return {
            state: e.state.stateNumber,
            alt: e.alt
        };
    }
    containsAll(c) {
        for (let o of c){
            if (!(o instanceof $gcX0f.ATNConfig)) return false;
            if (!this.contains(o)) return false;
        }
        return true;
    }
    addAll(c, contextCache) {
        this.ensureWritable();
        let changed = false;
        for (let group of c)if (this.add(group, contextCache)) changed = true;
        return changed;
    }
    clear() {
        this.ensureWritable();
        if (!this.mergedConfigs || !this.unmerged) throw new Error("Covered by ensureWritable but duplicated here for strict null check limitation");
        this.mergedConfigs.clear();
        this.unmerged.length = 0;
        this.configs.length = 0;
        this._dipsIntoOuterContext = false;
        this._hasSemanticContext = false;
        this._uniqueAlt = $bcnvE.ATN.INVALID_ALT_NUMBER;
        this._conflictInfo = undefined;
    }
    equals(obj) {
        if (this === obj) return true;
        if (!(obj instanceof $8c13542112ebfd78$var$ATNConfigSet)) return false;
        return this.outermostConfigSet === obj.outermostConfigSet && $2IEP9.equals(this._conflictInfo, obj._conflictInfo) && $3sNxf.ArrayEqualityComparator.INSTANCE.equals(this.configs, obj.configs);
    }
    hashCode() {
        if (this.isReadOnly && this.cachedHashCode !== -1) return this.cachedHashCode;
        let hashCode = 1;
        hashCode = 5 * hashCode ^ (this.outermostConfigSet ? 1 : 0);
        hashCode = 5 * hashCode ^ $3sNxf.ArrayEqualityComparator.INSTANCE.hashCode(this.configs);
        if (this.isReadOnly) this.cachedHashCode = hashCode;
        return hashCode;
    }
    toString(showContext) {
        if (showContext == null) showContext = false;
        let buf = "";
        let sortedConfigs = this.configs.slice(0);
        sortedConfigs.sort((o1, o2)=>{
            if (o1.alt !== o2.alt) return o1.alt - o2.alt;
            else if (o1.state.stateNumber !== o2.state.stateNumber) return o1.state.stateNumber - o2.state.stateNumber;
            else return o1.semanticContext.toString().localeCompare(o2.semanticContext.toString());
        });
        buf += "[";
        for(let i = 0; i < sortedConfigs.length; i++){
            if (i > 0) buf += ", ";
            buf += sortedConfigs[i].toString(undefined, true, showContext);
        }
        buf += "]";
        if (this._hasSemanticContext) buf += ",hasSemanticContext=" + this._hasSemanticContext;
        if (this._uniqueAlt !== $bcnvE.ATN.INVALID_ALT_NUMBER) buf += ",uniqueAlt=" + this._uniqueAlt;
        if (this._conflictInfo != null) {
            buf += ",conflictingAlts=" + this._conflictInfo.conflictedAlts;
            if (!this._conflictInfo.isExact) buf += "*";
        }
        if (this._dipsIntoOuterContext) buf += ",dipsIntoOuterContext";
        return buf.toString();
    }
    get uniqueAlt() {
        return this._uniqueAlt;
    }
    get hasSemanticContext() {
        return this._hasSemanticContext;
    }
    set hasSemanticContext(value) {
        this.ensureWritable();
        this._hasSemanticContext = value;
    }
    get conflictInfo() {
        return this._conflictInfo;
    }
    set conflictInfo(conflictInfo) {
        this.ensureWritable();
        this._conflictInfo = conflictInfo;
    }
    get conflictingAlts() {
        if (this._conflictInfo == null) return undefined;
        return this._conflictInfo.conflictedAlts;
    }
    get isExactConflict() {
        if (this._conflictInfo == null) return false;
        return this._conflictInfo.isExact;
    }
    get dipsIntoOuterContext() {
        return this._dipsIntoOuterContext;
    }
    get(index) {
        return this.configs[index];
    }
    ensureWritable() {
        if (this.isReadOnly) throw new Error("This ATNConfigSet is read only.");
    }
}
$8c13542112ebfd78$var$__decorate([
    $d6D31.NotNull
], $8c13542112ebfd78$var$ATNConfigSet.prototype, "getRepresentedAlternatives", null);
$8c13542112ebfd78$var$__decorate([
    $d6D31.Override
], $8c13542112ebfd78$var$ATNConfigSet.prototype, "size", null);
$8c13542112ebfd78$var$__decorate([
    $d6D31.Override
], $8c13542112ebfd78$var$ATNConfigSet.prototype, "isEmpty", null);
$8c13542112ebfd78$var$__decorate([
    $d6D31.Override
], $8c13542112ebfd78$var$ATNConfigSet.prototype, "contains", null);
$8c13542112ebfd78$var$__decorate([
    $d6D31.Override
], $8c13542112ebfd78$var$ATNConfigSet.prototype, Symbol.iterator, null);
$8c13542112ebfd78$var$__decorate([
    $d6D31.Override
], $8c13542112ebfd78$var$ATNConfigSet.prototype, "toArray", null);
$8c13542112ebfd78$var$__decorate([
    $d6D31.Override
], $8c13542112ebfd78$var$ATNConfigSet.prototype, "containsAll", null);
$8c13542112ebfd78$var$__decorate([
    $d6D31.Override
], $8c13542112ebfd78$var$ATNConfigSet.prototype, "clear", null);
$8c13542112ebfd78$var$__decorate([
    $d6D31.Override
], $8c13542112ebfd78$var$ATNConfigSet.prototype, "equals", null);
$8c13542112ebfd78$var$__decorate([
    $d6D31.Override
], $8c13542112ebfd78$var$ATNConfigSet.prototype, "hashCode", null);
module.exports.ATNConfigSet = $8c13542112ebfd78$var$ATNConfigSet;

});
parcelRegister("gcX0f", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $bccb89124e8dfda2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $bccb89124e8dfda2$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNConfig = void 0;

var $fP17P = parcelRequire("fP17P");

var $dPYn6 = parcelRequire("dPYn6");

var $iXFjm = parcelRequire("iXFjm");

var $d6D31 = parcelRequire("d6D31");

var $a4Flx = parcelRequire("a4Flx");

var $8DTT0 = parcelRequire("8DTT0");

var $eHMgW = parcelRequire("eHMgW");

var $bbHFU = parcelRequire("bbHFU");
/**
 * This field stores the bit mask for implementing the
 * {@link #isPrecedenceFilterSuppressed} property as a bit within the
 * existing {@link #altAndOuterContextDepth} field.
 */ const $bccb89124e8dfda2$var$SUPPRESS_PRECEDENCE_FILTER = 0x80000000;
/**
 * Represents a location with context in an ATN. The location is identified by the following values:
 *
 * * The current ATN state
 * * The predicted alternative
 * * The semantic context which must be true for this configuration to be enabled
 * * The syntactic context, which is represented as a graph-structured stack whose path(s) lead to the root of the rule
 *   invocations leading to this state
 *
 * In addition to these values, `ATNConfig` stores several properties about paths taken to get to the location which
 * were added over time to help with performance, correctness, and/or debugging.
 *
 * * `reachesIntoOuterContext`:: Used to ensure semantic predicates are not evaluated in the wrong context.
 * * `hasPassedThroughNonGreedyDecision`: Used for enabling first-match-wins instead of longest-match-wins after
 *   crossing a non-greedy decision.
 * * `lexerActionExecutor`: Used for tracking the lexer action(s) to execute should this instance be selected during
 *   lexing.
 * * `isPrecedenceFilterSuppressed`: A state variable for one of the dynamic disambiguation strategies employed by
 *   `ParserATNSimulator.applyPrecedenceFilter`.
 *
 * Due to the use of a graph-structured stack, a single `ATNConfig` is capable of representing many individual ATN
 * configurations which reached the same location in an ATN by following different paths.
 *
 * PERF: To conserve memory, `ATNConfig` is split into several different concrete types. `ATNConfig` itself stores the
 * minimum amount of information typically used to define an `ATNConfig` instance. Various derived types provide
 * additional storage space for cases where a non-default value is used for some of the object properties. The
 * `ATNConfig.create` and `ATNConfig.transform` methods automatically select the smallest concrete type capable of
 * representing the unique information for any given `ATNConfig`.
 */ let $bccb89124e8dfda2$var$ATNConfig = class ATNConfig {
    constructor(state, altOrConfig, context){
        if (typeof altOrConfig === "number") {
            $bbHFU((altOrConfig & 0xFFFFFF) === altOrConfig);
            this._state = state;
            this.altAndOuterContextDepth = altOrConfig;
            this._context = context;
        } else {
            this._state = state;
            this.altAndOuterContextDepth = altOrConfig.altAndOuterContextDepth;
            this._context = context;
        }
    }
    static create(state, alt, context, semanticContext = $eHMgW.SemanticContext.NONE, lexerActionExecutor) {
        if (semanticContext !== $eHMgW.SemanticContext.NONE) {
            if (lexerActionExecutor != null) return new $bccb89124e8dfda2$var$ActionSemanticContextATNConfig(lexerActionExecutor, semanticContext, state, alt, context, false);
            else return new $bccb89124e8dfda2$var$SemanticContextATNConfig(semanticContext, state, alt, context);
        } else if (lexerActionExecutor != null) return new $bccb89124e8dfda2$var$ActionATNConfig(lexerActionExecutor, state, alt, context, false);
        else return new ATNConfig(state, alt, context);
    }
    /** Gets the ATN state associated with this configuration */ get state() {
        return this._state;
    }
    /** What alt (or lexer rule) is predicted by this configuration */ get alt() {
        return this.altAndOuterContextDepth & 0x00FFFFFF;
    }
    get context() {
        return this._context;
    }
    set context(context) {
        this._context = context;
    }
    get reachesIntoOuterContext() {
        return this.outerContextDepth !== 0;
    }
    /**
     * We cannot execute predicates dependent upon local context unless
     * we know for sure we are in the correct context. Because there is
     * no way to do this efficiently, we simply cannot evaluate
     * dependent predicates unless we are in the rule that initially
     * invokes the ATN simulator.
     *
     * closure() tracks the depth of how far we dip into the outer context:
     * depth &gt; 0.  Note that it may not be totally accurate depth since I
     * don't ever decrement. TODO: make it a boolean then
     */ get outerContextDepth() {
        return this.altAndOuterContextDepth >>> 24 & 0x7F;
    }
    set outerContextDepth(outerContextDepth) {
        $bbHFU(outerContextDepth >= 0);
        // saturate at 0x7F - everything but zero/positive is only used for debug information anyway
        outerContextDepth = Math.min(outerContextDepth, 0x7F);
        this.altAndOuterContextDepth = outerContextDepth << 24 | (this.altAndOuterContextDepth & -2130706433) >>> 0;
    }
    get lexerActionExecutor() {
        return undefined;
    }
    get semanticContext() {
        return $eHMgW.SemanticContext.NONE;
    }
    get hasPassedThroughNonGreedyDecision() {
        return false;
    }
    clone() {
        return this.transform(this.state, false);
    }
    transform(/*@NotNull*/ state, checkNonGreedy, arg2) {
        if (arg2 == null) return this.transformImpl(state, this._context, this.semanticContext, checkNonGreedy, this.lexerActionExecutor);
        else if (arg2 instanceof $8DTT0.PredictionContext) return this.transformImpl(state, arg2, this.semanticContext, checkNonGreedy, this.lexerActionExecutor);
        else if (arg2 instanceof $eHMgW.SemanticContext) return this.transformImpl(state, this._context, arg2, checkNonGreedy, this.lexerActionExecutor);
        else return this.transformImpl(state, this._context, this.semanticContext, checkNonGreedy, arg2);
    }
    transformImpl(state, context, semanticContext, checkNonGreedy, lexerActionExecutor) {
        let passedThroughNonGreedy = checkNonGreedy && ATNConfig.checkNonGreedyDecision(this, state);
        if (semanticContext !== $eHMgW.SemanticContext.NONE) {
            if (lexerActionExecutor != null || passedThroughNonGreedy) return new $bccb89124e8dfda2$var$ActionSemanticContextATNConfig(lexerActionExecutor, semanticContext, state, this, context, passedThroughNonGreedy);
            else return new $bccb89124e8dfda2$var$SemanticContextATNConfig(semanticContext, state, this, context);
        } else if (lexerActionExecutor != null || passedThroughNonGreedy) return new $bccb89124e8dfda2$var$ActionATNConfig(lexerActionExecutor, state, this, context, passedThroughNonGreedy);
        else return new ATNConfig(state, this, context);
    }
    static checkNonGreedyDecision(source, target) {
        return source.hasPassedThroughNonGreedyDecision || target instanceof $dPYn6.DecisionState && target.nonGreedy;
    }
    appendContext(context, contextCache) {
        if (typeof context === "number") {
            let appendedContext = this.context.appendSingleContext(context, contextCache);
            let result = this.transform(this.state, false, appendedContext);
            return result;
        } else {
            let appendedContext = this.context.appendContext(context, contextCache);
            let result = this.transform(this.state, false, appendedContext);
            return result;
        }
    }
    /**
     * Determines if this `ATNConfig` fully contains another `ATNConfig`.
     *
     * An ATN configuration represents a position (including context) in an ATN during parsing. Since `ATNConfig` stores
     * the context as a graph, a single `ATNConfig` instance is capable of representing many ATN configurations which
     * are all in the same "location" but have different contexts. These `ATNConfig` instances are again merged when
     * they are added to an `ATNConfigSet`. This method supports `ATNConfigSet.contains` by evaluating whether a
     * particular `ATNConfig` contains all of the ATN configurations represented by another `ATNConfig`.
     *
     * An `ATNConfig` _a_ contains another `ATNConfig` _b_ if all of the following conditions are met:
     *
     * * The configurations are in the same state (`state`)
     * * The configurations predict the same alternative (`alt`)
     * * The semantic context of _a_ implies the semantic context of _b_ (this method performs a weaker equality check)
     * * Joining the prediction contexts of _a_ and _b_ results in the prediction context of _a_
     *
     * This method implements a conservative approximation of containment. As a result, when this method returns `true`
     * it is known that parsing from `subconfig` can only recognize a subset of the inputs which can be recognized
     * starting at the current `ATNConfig`. However, due to the imprecise evaluation of implication for the semantic
     * contexts, no assumptions can be made about the relationship between the configurations when this method returns
     * `false`.
     *
     * @param subconfig The sub configuration.
     * @returns `true` if this configuration contains `subconfig`; otherwise, `false`.
     */ contains(subconfig) {
        if (this.state.stateNumber !== subconfig.state.stateNumber || this.alt !== subconfig.alt || !this.semanticContext.equals(subconfig.semanticContext)) return false;
        let leftWorkList = [];
        let rightWorkList = [];
        leftWorkList.push(this.context);
        rightWorkList.push(subconfig.context);
        while(true){
            let left = leftWorkList.pop();
            let right = rightWorkList.pop();
            if (!left || !right) break;
            if (left === right) return true;
            if (left.size < right.size) return false;
            if (right.isEmpty) return left.hasEmpty;
            else for(let i = 0; i < right.size; i++){
                let index = left.findReturnState(right.getReturnState(i));
                if (index < 0) // assumes invokingStates has no duplicate entries
                return false;
                leftWorkList.push(left.getParent(index));
                rightWorkList.push(right.getParent(i));
            }
        }
        return false;
    }
    get isPrecedenceFilterSuppressed() {
        return (this.altAndOuterContextDepth & $bccb89124e8dfda2$var$SUPPRESS_PRECEDENCE_FILTER) !== 0;
    }
    set isPrecedenceFilterSuppressed(value) {
        if (value) this.altAndOuterContextDepth |= $bccb89124e8dfda2$var$SUPPRESS_PRECEDENCE_FILTER;
        else this.altAndOuterContextDepth &= ~$bccb89124e8dfda2$var$SUPPRESS_PRECEDENCE_FILTER;
    }
    /** An ATN configuration is equal to another if both have
     *  the same state, they predict the same alternative, and
     *  syntactic/semantic contexts are the same.
     */ equals(o) {
        if (this === o) return true;
        else if (!(o instanceof ATNConfig)) return false;
        return this.state.stateNumber === o.state.stateNumber && this.alt === o.alt && this.reachesIntoOuterContext === o.reachesIntoOuterContext && this.context.equals(o.context) && this.semanticContext.equals(o.semanticContext) && this.isPrecedenceFilterSuppressed === o.isPrecedenceFilterSuppressed && this.hasPassedThroughNonGreedyDecision === o.hasPassedThroughNonGreedyDecision && $a4Flx.ObjectEqualityComparator.INSTANCE.equals(this.lexerActionExecutor, o.lexerActionExecutor);
    }
    hashCode() {
        let hashCode = $iXFjm.MurmurHash.initialize(7);
        hashCode = $iXFjm.MurmurHash.update(hashCode, this.state.stateNumber);
        hashCode = $iXFjm.MurmurHash.update(hashCode, this.alt);
        hashCode = $iXFjm.MurmurHash.update(hashCode, this.reachesIntoOuterContext ? 1 : 0);
        hashCode = $iXFjm.MurmurHash.update(hashCode, this.context);
        hashCode = $iXFjm.MurmurHash.update(hashCode, this.semanticContext);
        hashCode = $iXFjm.MurmurHash.update(hashCode, this.hasPassedThroughNonGreedyDecision ? 1 : 0);
        hashCode = $iXFjm.MurmurHash.update(hashCode, this.lexerActionExecutor);
        hashCode = $iXFjm.MurmurHash.finish(hashCode, 7);
        return hashCode;
    }
    /**
     * Returns a graphical representation of the current `ATNConfig` in Graphviz format. The graph can be stored to a
     * **.dot** file and then rendered to an image using Graphviz.
     *
     * @returns A Graphviz graph representing the current `ATNConfig`.
     *
     * @see http://www.graphviz.org/
     */ toDotString() {
        let builder = "";
        builder += "digraph G {\n";
        builder += "rankdir=LR;\n";
        let visited = new $fP17P.Array2DHashMap($8DTT0.PredictionContext.IdentityEqualityComparator.INSTANCE);
        let workList = [];
        function getOrAddContext(context) {
            let newNumber = visited.size;
            let result = visited.putIfAbsent(context, newNumber);
            if (result != null) // Already saw this context
            return result;
            workList.push(context);
            return newNumber;
        }
        workList.push(this.context);
        visited.put(this.context, 0);
        while(true){
            let current = workList.pop();
            if (!current) break;
            for(let i = 0; i < current.size; i++){
                builder += "  s" + getOrAddContext(current);
                builder += "->";
                builder += "s" + getOrAddContext(current.getParent(i));
                builder += "[label=\"" + current.getReturnState(i) + "\"];\n";
            }
        }
        builder += "}\n";
        return builder.toString();
    }
    toString(recog, showAlt, showContext) {
        // Must check showContext before showAlt to preserve original overload behavior
        if (showContext == null) showContext = showAlt != null;
        if (showAlt == null) showAlt = true;
        let buf = "";
        // if (this.state.ruleIndex >= 0) {
        // 	if (recog != null) {
        // 		buf += (recog.ruleNames[this.state.ruleIndex] + ":");
        // 	} else {
        // 		buf += (this.state.ruleIndex + ":");
        // 	}
        // }
        let contexts;
        if (showContext) contexts = this.context.toStrings(recog, this.state.stateNumber);
        else contexts = [
            "?"
        ];
        let first = true;
        for (let contextDesc of contexts){
            if (first) first = false;
            else buf += ", ";
            buf += "(";
            buf += this.state;
            if (showAlt) {
                buf += ",";
                buf += this.alt;
            }
            if (this.context) {
                buf += ",";
                buf += contextDesc;
            }
            if (this.semanticContext !== $eHMgW.SemanticContext.NONE) {
                buf += ",";
                buf += this.semanticContext;
            }
            if (this.reachesIntoOuterContext) buf += ",up=" + this.outerContextDepth;
            buf += ")";
        }
        return buf.toString();
    }
};
$bccb89124e8dfda2$var$__decorate([
    $d6D31.NotNull
], $bccb89124e8dfda2$var$ATNConfig.prototype, "_state", void 0);
$bccb89124e8dfda2$var$__decorate([
    $d6D31.NotNull
], $bccb89124e8dfda2$var$ATNConfig.prototype, "_context", void 0);
$bccb89124e8dfda2$var$__decorate([
    $d6D31.NotNull
], $bccb89124e8dfda2$var$ATNConfig.prototype, "state", null);
$bccb89124e8dfda2$var$__decorate([
    $d6D31.NotNull,
    $bccb89124e8dfda2$var$__param(0, $d6D31.NotNull)
], $bccb89124e8dfda2$var$ATNConfig.prototype, "context", null);
$bccb89124e8dfda2$var$__decorate([
    $d6D31.NotNull
], $bccb89124e8dfda2$var$ATNConfig.prototype, "semanticContext", null);
$bccb89124e8dfda2$var$__decorate([
    $d6D31.Override
], $bccb89124e8dfda2$var$ATNConfig.prototype, "clone", null);
$bccb89124e8dfda2$var$__decorate([
    $bccb89124e8dfda2$var$__param(0, $d6D31.NotNull),
    $bccb89124e8dfda2$var$__param(2, $d6D31.NotNull)
], $bccb89124e8dfda2$var$ATNConfig.prototype, "transformImpl", null);
$bccb89124e8dfda2$var$__decorate([
    $d6D31.Override
], $bccb89124e8dfda2$var$ATNConfig.prototype, "equals", null);
$bccb89124e8dfda2$var$__decorate([
    $d6D31.Override
], $bccb89124e8dfda2$var$ATNConfig.prototype, "hashCode", null);
$bccb89124e8dfda2$var$__decorate([
    $bccb89124e8dfda2$var$__param(0, $d6D31.NotNull),
    $bccb89124e8dfda2$var$__param(3, $d6D31.NotNull)
], $bccb89124e8dfda2$var$ATNConfig, "create", null);
$bccb89124e8dfda2$var$ATNConfig = $bccb89124e8dfda2$var$__decorate([
    $bccb89124e8dfda2$var$__param(0, $d6D31.NotNull),
    $bccb89124e8dfda2$var$__param(2, $d6D31.NotNull)
], $bccb89124e8dfda2$var$ATNConfig);
module.exports.ATNConfig = $bccb89124e8dfda2$var$ATNConfig;
/**
 * This class was derived from `ATNConfig` purely as a memory optimization. It allows for the creation of an `ATNConfig`
 * with a non-default semantic context.
 *
 * See the `ATNConfig` documentation for more information about conserving memory through the use of several concrete
 * types.
 */ let $bccb89124e8dfda2$var$SemanticContextATNConfig = class SemanticContextATNConfig extends $bccb89124e8dfda2$var$ATNConfig {
    constructor(semanticContext, state, altOrConfig, context){
        if (typeof altOrConfig === "number") super(state, altOrConfig, context);
        else super(state, altOrConfig, context);
        this._semanticContext = semanticContext;
    }
    get semanticContext() {
        return this._semanticContext;
    }
};
$bccb89124e8dfda2$var$__decorate([
    $d6D31.NotNull
], $bccb89124e8dfda2$var$SemanticContextATNConfig.prototype, "_semanticContext", void 0);
$bccb89124e8dfda2$var$__decorate([
    $d6D31.Override
], $bccb89124e8dfda2$var$SemanticContextATNConfig.prototype, "semanticContext", null);
$bccb89124e8dfda2$var$SemanticContextATNConfig = $bccb89124e8dfda2$var$__decorate([
    $bccb89124e8dfda2$var$__param(1, $d6D31.NotNull),
    $bccb89124e8dfda2$var$__param(2, $d6D31.NotNull)
], $bccb89124e8dfda2$var$SemanticContextATNConfig);
/**
 * This class was derived from `ATNConfig` purely as a memory optimization. It allows for the creation of an `ATNConfig`
 * with a lexer action.
 *
 * See the `ATNConfig` documentation for more information about conserving memory through the use of several concrete
 * types.
 */ let $bccb89124e8dfda2$var$ActionATNConfig = class ActionATNConfig extends $bccb89124e8dfda2$var$ATNConfig {
    constructor(lexerActionExecutor, state, altOrConfig, context, passedThroughNonGreedyDecision){
        if (typeof altOrConfig === "number") super(state, altOrConfig, context);
        else {
            super(state, altOrConfig, context);
            if (altOrConfig.semanticContext !== $eHMgW.SemanticContext.NONE) throw new Error("Not supported");
        }
        this._lexerActionExecutor = lexerActionExecutor;
        this.passedThroughNonGreedyDecision = passedThroughNonGreedyDecision;
    }
    get lexerActionExecutor() {
        return this._lexerActionExecutor;
    }
    get hasPassedThroughNonGreedyDecision() {
        return this.passedThroughNonGreedyDecision;
    }
};
$bccb89124e8dfda2$var$__decorate([
    $d6D31.Override
], $bccb89124e8dfda2$var$ActionATNConfig.prototype, "lexerActionExecutor", null);
$bccb89124e8dfda2$var$__decorate([
    $d6D31.Override
], $bccb89124e8dfda2$var$ActionATNConfig.prototype, "hasPassedThroughNonGreedyDecision", null);
$bccb89124e8dfda2$var$ActionATNConfig = $bccb89124e8dfda2$var$__decorate([
    $bccb89124e8dfda2$var$__param(1, $d6D31.NotNull),
    $bccb89124e8dfda2$var$__param(2, $d6D31.NotNull)
], $bccb89124e8dfda2$var$ActionATNConfig);
/**
 * This class was derived from `SemanticContextATNConfig` purely as a memory optimization. It allows for the creation of
 * an `ATNConfig` with both a lexer action and a non-default semantic context.
 *
 * See the `ATNConfig` documentation for more information about conserving memory through the use of several concrete
 * types.
 */ let $bccb89124e8dfda2$var$ActionSemanticContextATNConfig = class ActionSemanticContextATNConfig extends $bccb89124e8dfda2$var$SemanticContextATNConfig {
    constructor(lexerActionExecutor, semanticContext, state, altOrConfig, context, passedThroughNonGreedyDecision){
        if (typeof altOrConfig === "number") super(semanticContext, state, altOrConfig, context);
        else super(semanticContext, state, altOrConfig, context);
        this._lexerActionExecutor = lexerActionExecutor;
        this.passedThroughNonGreedyDecision = passedThroughNonGreedyDecision;
    }
    get lexerActionExecutor() {
        return this._lexerActionExecutor;
    }
    get hasPassedThroughNonGreedyDecision() {
        return this.passedThroughNonGreedyDecision;
    }
};
$bccb89124e8dfda2$var$__decorate([
    $d6D31.Override
], $bccb89124e8dfda2$var$ActionSemanticContextATNConfig.prototype, "lexerActionExecutor", null);
$bccb89124e8dfda2$var$__decorate([
    $d6D31.Override
], $bccb89124e8dfda2$var$ActionSemanticContextATNConfig.prototype, "hasPassedThroughNonGreedyDecision", null);
$bccb89124e8dfda2$var$ActionSemanticContextATNConfig = $bccb89124e8dfda2$var$__decorate([
    $bccb89124e8dfda2$var$__param(1, $d6D31.NotNull),
    $bccb89124e8dfda2$var$__param(2, $d6D31.NotNull)
], $bccb89124e8dfda2$var$ActionSemanticContextATNConfig);

});
parcelRegister("dPYn6", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DecisionState = void 0;

var $7j0Pc = parcelRequire("7j0Pc");
class $a12ede58b33ddcba$var$DecisionState extends $7j0Pc.ATNState {
    constructor(){
        super(...arguments);
        this.decision = -1;
        this.nonGreedy = false;
        this.sll = false;
    }
}
module.exports.DecisionState = $a12ede58b33ddcba$var$DecisionState;

});

parcelRegister("8DTT0", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $64ad510fde44ff92$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $64ad510fde44ff92$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SingletonPredictionContext = module.exports.PredictionContext = void 0;

var $fP17P = parcelRequire("fP17P");

var $7Veax = parcelRequire("7Veax");

var $9yG1X = parcelRequire("9yG1X");

var $iXFjm = parcelRequire("iXFjm");

var $d6D31 = parcelRequire("d6D31");

var $6vF7J = parcelRequire("6vF7J");

var $bbHFU = parcelRequire("bbHFU");
const $64ad510fde44ff92$var$INITIAL_HASH = 1;
class $64ad510fde44ff92$var$PredictionContext {
    constructor(cachedHashCode){
        this.cachedHashCode = cachedHashCode;
    }
    static calculateEmptyHashCode() {
        let hash = $iXFjm.MurmurHash.initialize($64ad510fde44ff92$var$INITIAL_HASH);
        hash = $iXFjm.MurmurHash.finish(hash, 0);
        return hash;
    }
    static calculateSingleHashCode(parent, returnState) {
        let hash = $iXFjm.MurmurHash.initialize($64ad510fde44ff92$var$INITIAL_HASH);
        hash = $iXFjm.MurmurHash.update(hash, parent);
        hash = $iXFjm.MurmurHash.update(hash, returnState);
        hash = $iXFjm.MurmurHash.finish(hash, 2);
        return hash;
    }
    static calculateHashCode(parents, returnStates) {
        let hash = $iXFjm.MurmurHash.initialize($64ad510fde44ff92$var$INITIAL_HASH);
        for (let parent of parents)hash = $iXFjm.MurmurHash.update(hash, parent);
        for (let returnState of returnStates)hash = $iXFjm.MurmurHash.update(hash, returnState);
        hash = $iXFjm.MurmurHash.finish(hash, 2 * parents.length);
        return hash;
    }
    static fromRuleContext(atn, outerContext, fullContext = true) {
        if (outerContext.isEmpty) return fullContext ? $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL : $64ad510fde44ff92$var$PredictionContext.EMPTY_LOCAL;
        let parent;
        if (outerContext._parent) parent = $64ad510fde44ff92$var$PredictionContext.fromRuleContext(atn, outerContext._parent, fullContext);
        else parent = fullContext ? $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL : $64ad510fde44ff92$var$PredictionContext.EMPTY_LOCAL;
        let state = atn.states[outerContext.invokingState];
        let transition = state.transition(0);
        return parent.getChild(transition.followState.stateNumber);
    }
    static addEmptyContext(context) {
        return context.addEmptyContext();
    }
    static removeEmptyContext(context) {
        return context.removeEmptyContext();
    }
    static join(context0, context1, contextCache = $6vF7J.PredictionContextCache.UNCACHED) {
        if (context0 === context1) return context0;
        if (context0.isEmpty) return $64ad510fde44ff92$var$PredictionContext.isEmptyLocal(context0) ? context0 : $64ad510fde44ff92$var$PredictionContext.addEmptyContext(context1);
        else if (context1.isEmpty) return $64ad510fde44ff92$var$PredictionContext.isEmptyLocal(context1) ? context1 : $64ad510fde44ff92$var$PredictionContext.addEmptyContext(context0);
        let context0size = context0.size;
        let context1size = context1.size;
        if (context0size === 1 && context1size === 1 && context0.getReturnState(0) === context1.getReturnState(0)) {
            let merged = contextCache.join(context0.getParent(0), context1.getParent(0));
            if (merged === context0.getParent(0)) return context0;
            else if (merged === context1.getParent(0)) return context1;
            else return merged.getChild(context0.getReturnState(0));
        }
        let count = 0;
        let parentsList = new Array(context0size + context1size);
        let returnStatesList = new Array(parentsList.length);
        let leftIndex = 0;
        let rightIndex = 0;
        let canReturnLeft = true;
        let canReturnRight = true;
        while(leftIndex < context0size && rightIndex < context1size){
            if (context0.getReturnState(leftIndex) === context1.getReturnState(rightIndex)) {
                parentsList[count] = contextCache.join(context0.getParent(leftIndex), context1.getParent(rightIndex));
                returnStatesList[count] = context0.getReturnState(leftIndex);
                canReturnLeft = canReturnLeft && parentsList[count] === context0.getParent(leftIndex);
                canReturnRight = canReturnRight && parentsList[count] === context1.getParent(rightIndex);
                leftIndex++;
                rightIndex++;
            } else if (context0.getReturnState(leftIndex) < context1.getReturnState(rightIndex)) {
                parentsList[count] = context0.getParent(leftIndex);
                returnStatesList[count] = context0.getReturnState(leftIndex);
                canReturnRight = false;
                leftIndex++;
            } else {
                $bbHFU(context1.getReturnState(rightIndex) < context0.getReturnState(leftIndex));
                parentsList[count] = context1.getParent(rightIndex);
                returnStatesList[count] = context1.getReturnState(rightIndex);
                canReturnLeft = false;
                rightIndex++;
            }
            count++;
        }
        while(leftIndex < context0size){
            parentsList[count] = context0.getParent(leftIndex);
            returnStatesList[count] = context0.getReturnState(leftIndex);
            leftIndex++;
            canReturnRight = false;
            count++;
        }
        while(rightIndex < context1size){
            parentsList[count] = context1.getParent(rightIndex);
            returnStatesList[count] = context1.getReturnState(rightIndex);
            rightIndex++;
            canReturnLeft = false;
            count++;
        }
        if (canReturnLeft) return context0;
        else if (canReturnRight) return context1;
        if (count < parentsList.length) {
            parentsList = parentsList.slice(0, count);
            returnStatesList = returnStatesList.slice(0, count);
        }
        if (parentsList.length === 0) // if one of them was EMPTY_LOCAL, it would be empty and handled at the beginning of the method
        return $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL;
        else if (parentsList.length === 1) return new $64ad510fde44ff92$var$SingletonPredictionContext(parentsList[0], returnStatesList[0]);
        else return new $64ad510fde44ff92$var$ArrayPredictionContext(parentsList, returnStatesList);
    }
    static isEmptyLocal(context) {
        return context === $64ad510fde44ff92$var$PredictionContext.EMPTY_LOCAL;
    }
    static getCachedContext(context, contextCache, visited) {
        if (context.isEmpty) return context;
        let existing = visited.get(context);
        if (existing) return existing;
        existing = contextCache.get(context);
        if (existing) {
            visited.put(context, existing);
            return existing;
        }
        let changed = false;
        let parents = new Array(context.size);
        for(let i = 0; i < parents.length; i++){
            let parent = $64ad510fde44ff92$var$PredictionContext.getCachedContext(context.getParent(i), contextCache, visited);
            if (changed || parent !== context.getParent(i)) {
                if (!changed) {
                    parents = new Array(context.size);
                    for(let j = 0; j < context.size; j++)parents[j] = context.getParent(j);
                    changed = true;
                }
                parents[i] = parent;
            }
        }
        if (!changed) {
            existing = contextCache.putIfAbsent(context, context);
            visited.put(context, existing != null ? existing : context);
            return context;
        }
        // We know parents.length>0 because context.isEmpty is checked at the beginning of the method.
        let updated;
        if (parents.length === 1) updated = new $64ad510fde44ff92$var$SingletonPredictionContext(parents[0], context.getReturnState(0));
        else {
            let returnStates = new Array(context.size);
            for(let i = 0; i < context.size; i++)returnStates[i] = context.getReturnState(i);
            updated = new $64ad510fde44ff92$var$ArrayPredictionContext(parents, returnStates, context.hashCode());
        }
        existing = contextCache.putIfAbsent(updated, updated);
        visited.put(updated, existing || updated);
        visited.put(context, existing || updated);
        return updated;
    }
    appendSingleContext(returnContext, contextCache) {
        return this.appendContext($64ad510fde44ff92$var$PredictionContext.EMPTY_FULL.getChild(returnContext), contextCache);
    }
    getChild(returnState) {
        return new $64ad510fde44ff92$var$SingletonPredictionContext(this, returnState);
    }
    hashCode() {
        return this.cachedHashCode;
    }
    toStrings(recognizer, currentState, stop = $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL) {
        let result = [];
        outer: for(let perm = 0;; perm++){
            let offset = 0;
            let last = true;
            let p = this;
            let stateNumber = currentState;
            let localBuffer = "";
            localBuffer += "[";
            while(!p.isEmpty && p !== stop){
                let index = 0;
                if (p.size > 0) {
                    let bits = 1;
                    while(1 << bits >>> 0 < p.size)bits++;
                    let mask = (1 << bits >>> 0) - 1;
                    index = perm >> offset & mask;
                    last = last && index >= p.size - 1;
                    if (index >= p.size) continue outer;
                    offset += bits;
                }
                if (recognizer) {
                    if (localBuffer.length > 1) // first char is '[', if more than that this isn't the first rule
                    localBuffer += " ";
                    let atn = recognizer.atn;
                    let s = atn.states[stateNumber];
                    let ruleName = recognizer.ruleNames[s.ruleIndex];
                    localBuffer += ruleName;
                } else if (p.getReturnState(index) !== $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL_STATE_KEY) {
                    if (!p.isEmpty) {
                        if (localBuffer.length > 1) // first char is '[', if more than that this isn't the first rule
                        localBuffer += " ";
                        localBuffer += p.getReturnState(index);
                    }
                }
                stateNumber = p.getReturnState(index);
                p = p.getParent(index);
            }
            localBuffer += "]";
            result.push(localBuffer);
            if (last) break;
        }
        return result;
    }
}
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$PredictionContext.prototype, "hashCode", null);
$64ad510fde44ff92$var$__decorate([
    $64ad510fde44ff92$var$__param(0, $d6D31.NotNull),
    $64ad510fde44ff92$var$__param(1, $d6D31.NotNull),
    $64ad510fde44ff92$var$__param(2, $d6D31.NotNull)
], $64ad510fde44ff92$var$PredictionContext, "join", null);
$64ad510fde44ff92$var$__decorate([
    $64ad510fde44ff92$var$__param(0, $d6D31.NotNull),
    $64ad510fde44ff92$var$__param(1, $d6D31.NotNull),
    $64ad510fde44ff92$var$__param(2, $d6D31.NotNull)
], $64ad510fde44ff92$var$PredictionContext, "getCachedContext", null);
module.exports.PredictionContext = $64ad510fde44ff92$var$PredictionContext;
class $64ad510fde44ff92$var$EmptyPredictionContext extends $64ad510fde44ff92$var$PredictionContext {
    constructor(fullContext){
        super($64ad510fde44ff92$var$PredictionContext.calculateEmptyHashCode());
        this.fullContext = fullContext;
    }
    get isFullContext() {
        return this.fullContext;
    }
    addEmptyContext() {
        return this;
    }
    removeEmptyContext() {
        throw new Error("Cannot remove the empty context from itself.");
    }
    getParent(index) {
        throw new Error("index out of bounds");
    }
    getReturnState(index) {
        throw new Error("index out of bounds");
    }
    findReturnState(returnState) {
        return -1;
    }
    get size() {
        return 0;
    }
    appendSingleContext(returnContext, contextCache) {
        return contextCache.getChild(this, returnContext);
    }
    appendContext(suffix, contextCache) {
        return suffix;
    }
    get isEmpty() {
        return true;
    }
    get hasEmpty() {
        return true;
    }
    equals(o) {
        return this === o;
    }
    toStrings(recognizer, currentState, stop) {
        return [
            "[]"
        ];
    }
}
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "addEmptyContext", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "removeEmptyContext", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "getParent", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "getReturnState", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "findReturnState", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "size", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "appendSingleContext", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "appendContext", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "isEmpty", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "hasEmpty", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "equals", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "toStrings", null);
let $64ad510fde44ff92$var$ArrayPredictionContext = class ArrayPredictionContext extends $64ad510fde44ff92$var$PredictionContext {
    constructor(parents, returnStates, hashCode){
        super(hashCode || $64ad510fde44ff92$var$PredictionContext.calculateHashCode(parents, returnStates));
        $bbHFU(parents.length === returnStates.length);
        $bbHFU(returnStates.length > 1 || returnStates[0] !== $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL_STATE_KEY, "Should be using PredictionContext.EMPTY instead.");
        this.parents = parents;
        this.returnStates = returnStates;
    }
    getParent(index) {
        return this.parents[index];
    }
    getReturnState(index) {
        return this.returnStates[index];
    }
    findReturnState(returnState) {
        return $9yG1X.Arrays.binarySearch(this.returnStates, returnState);
    }
    get size() {
        return this.returnStates.length;
    }
    get isEmpty() {
        return false;
    }
    get hasEmpty() {
        return this.returnStates[this.returnStates.length - 1] === $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL_STATE_KEY;
    }
    addEmptyContext() {
        if (this.hasEmpty) return this;
        let parents2 = this.parents.slice(0);
        let returnStates2 = this.returnStates.slice(0);
        parents2.push($64ad510fde44ff92$var$PredictionContext.EMPTY_FULL);
        returnStates2.push($64ad510fde44ff92$var$PredictionContext.EMPTY_FULL_STATE_KEY);
        return new ArrayPredictionContext(parents2, returnStates2);
    }
    removeEmptyContext() {
        if (!this.hasEmpty) return this;
        if (this.returnStates.length === 2) return new $64ad510fde44ff92$var$SingletonPredictionContext(this.parents[0], this.returnStates[0]);
        else {
            let parents2 = this.parents.slice(0, this.parents.length - 1);
            let returnStates2 = this.returnStates.slice(0, this.returnStates.length - 1);
            return new ArrayPredictionContext(parents2, returnStates2);
        }
    }
    appendContext(suffix, contextCache) {
        return ArrayPredictionContext.appendContextImpl(this, suffix, new $64ad510fde44ff92$var$PredictionContext.IdentityHashMap());
    }
    static appendContextImpl(context, suffix, visited) {
        if (suffix.isEmpty) {
            if ($64ad510fde44ff92$var$PredictionContext.isEmptyLocal(suffix)) {
                if (context.hasEmpty) return $64ad510fde44ff92$var$PredictionContext.EMPTY_LOCAL;
                throw new Error("what to do here?");
            }
            return context;
        }
        if (suffix.size !== 1) throw new Error("Appending a tree suffix is not yet supported.");
        let result = visited.get(context);
        if (!result) {
            if (context.isEmpty) result = suffix;
            else {
                let parentCount = context.size;
                if (context.hasEmpty) parentCount--;
                let updatedParents = new Array(parentCount);
                let updatedReturnStates = new Array(parentCount);
                for(let i = 0; i < parentCount; i++)updatedReturnStates[i] = context.getReturnState(i);
                for(let i = 0; i < parentCount; i++)updatedParents[i] = ArrayPredictionContext.appendContextImpl(context.getParent(i), suffix, visited);
                if (updatedParents.length === 1) result = new $64ad510fde44ff92$var$SingletonPredictionContext(updatedParents[0], updatedReturnStates[0]);
                else {
                    $bbHFU(updatedParents.length > 1);
                    result = new ArrayPredictionContext(updatedParents, updatedReturnStates);
                }
                if (context.hasEmpty) result = $64ad510fde44ff92$var$PredictionContext.join(result, suffix);
            }
            visited.put(context, result);
        }
        return result;
    }
    equals(o) {
        if (this === o) return true;
        else if (!(o instanceof ArrayPredictionContext)) return false;
        if (this.hashCode() !== o.hashCode()) // can't be same if hash is different
        return false;
        let other = o;
        return this.equalsImpl(other, new $7Veax.Array2DHashSet());
    }
    equalsImpl(other, visited) {
        let selfWorkList = [];
        let otherWorkList = [];
        selfWorkList.push(this);
        otherWorkList.push(other);
        while(true){
            let currentSelf = selfWorkList.pop();
            let currentOther = otherWorkList.pop();
            if (!currentSelf || !currentOther) break;
            let operands = new $6vF7J.PredictionContextCache.IdentityCommutativePredictionContextOperands(currentSelf, currentOther);
            if (!visited.add(operands)) continue;
            let selfSize = operands.x.size;
            if (selfSize === 0) {
                if (!operands.x.equals(operands.y)) return false;
                continue;
            }
            let otherSize = operands.y.size;
            if (selfSize !== otherSize) return false;
            for(let i = 0; i < selfSize; i++){
                if (operands.x.getReturnState(i) !== operands.y.getReturnState(i)) return false;
                let selfParent = operands.x.getParent(i);
                let otherParent = operands.y.getParent(i);
                if (selfParent.hashCode() !== otherParent.hashCode()) return false;
                if (selfParent !== otherParent) {
                    selfWorkList.push(selfParent);
                    otherWorkList.push(otherParent);
                }
            }
        }
        return true;
    }
};
$64ad510fde44ff92$var$__decorate([
    $d6D31.NotNull
], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "parents", void 0);
$64ad510fde44ff92$var$__decorate([
    $d6D31.NotNull
], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "returnStates", void 0);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "getParent", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "getReturnState", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "findReturnState", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "size", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "isEmpty", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "hasEmpty", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "addEmptyContext", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "removeEmptyContext", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "appendContext", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "equals", null);
$64ad510fde44ff92$var$ArrayPredictionContext = $64ad510fde44ff92$var$__decorate([
    $64ad510fde44ff92$var$__param(0, $d6D31.NotNull)
], $64ad510fde44ff92$var$ArrayPredictionContext);
let $64ad510fde44ff92$var$SingletonPredictionContext = class SingletonPredictionContext extends $64ad510fde44ff92$var$PredictionContext {
    constructor(parent, returnState){
        super($64ad510fde44ff92$var$PredictionContext.calculateSingleHashCode(parent, returnState));
        // assert(returnState != PredictionContext.EMPTY_FULL_STATE_KEY && returnState != PredictionContext.EMPTY_LOCAL_STATE_KEY);
        this.parent = parent;
        this.returnState = returnState;
    }
    getParent(index) {
        // assert(index == 0);
        return this.parent;
    }
    getReturnState(index) {
        // assert(index == 0);
        return this.returnState;
    }
    findReturnState(returnState) {
        return this.returnState === returnState ? 0 : -1;
    }
    get size() {
        return 1;
    }
    get isEmpty() {
        return false;
    }
    get hasEmpty() {
        return false;
    }
    appendContext(suffix, contextCache) {
        return contextCache.getChild(this.parent.appendContext(suffix, contextCache), this.returnState);
    }
    addEmptyContext() {
        let parents = [
            this.parent,
            $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL
        ];
        let returnStates = [
            this.returnState,
            $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL_STATE_KEY
        ];
        return new $64ad510fde44ff92$var$ArrayPredictionContext(parents, returnStates);
    }
    removeEmptyContext() {
        return this;
    }
    equals(o) {
        if (o === this) return true;
        else if (!(o instanceof SingletonPredictionContext)) return false;
        let other = o;
        if (this.hashCode() !== other.hashCode()) return false;
        return this.returnState === other.returnState && this.parent.equals(other.parent);
    }
};
$64ad510fde44ff92$var$__decorate([
    $d6D31.NotNull
], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "parent", void 0);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "getParent", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "getReturnState", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "findReturnState", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "size", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "isEmpty", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "hasEmpty", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "appendContext", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "addEmptyContext", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "removeEmptyContext", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "equals", null);
$64ad510fde44ff92$var$SingletonPredictionContext = $64ad510fde44ff92$var$__decorate([
    $64ad510fde44ff92$var$__param(0, $d6D31.NotNull)
], $64ad510fde44ff92$var$SingletonPredictionContext);
module.exports.SingletonPredictionContext = $64ad510fde44ff92$var$SingletonPredictionContext;
(function(PredictionContext) {
    PredictionContext.EMPTY_LOCAL = new $64ad510fde44ff92$var$EmptyPredictionContext(false);
    PredictionContext.EMPTY_FULL = new $64ad510fde44ff92$var$EmptyPredictionContext(true);
    PredictionContext.EMPTY_LOCAL_STATE_KEY = -2147483648;
    PredictionContext.EMPTY_FULL_STATE_KEY = 2147483647;
    class IdentityHashMap extends $fP17P.Array2DHashMap {
        constructor(){
            super(IdentityEqualityComparator.INSTANCE);
        }
    }
    PredictionContext.IdentityHashMap = IdentityHashMap;
    class IdentityEqualityComparator {
        IdentityEqualityComparator() {
        // intentionally empty
        }
        hashCode(obj) {
            return obj.hashCode();
        }
        equals(a, b) {
            return a === b;
        }
    }
    IdentityEqualityComparator.INSTANCE = new IdentityEqualityComparator();
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], IdentityEqualityComparator.prototype, "hashCode", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], IdentityEqualityComparator.prototype, "equals", null);
    PredictionContext.IdentityEqualityComparator = IdentityEqualityComparator;
})($64ad510fde44ff92$var$PredictionContext = module.exports.PredictionContext || (module.exports.PredictionContext = {}));

});
parcelRegister("6vF7J", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $4bd589a149816580$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredictionContextCache = void 0;

var $fP17P = parcelRequire("fP17P");

var $d6D31 = parcelRequire("d6D31");

var $a4Flx = parcelRequire("a4Flx");

var $8DTT0 = parcelRequire("8DTT0");

var $bbHFU = parcelRequire("bbHFU");
/** Used to cache {@link PredictionContext} objects. Its used for the shared
 *  context cash associated with contexts in DFA states. This cache
 *  can be used for both lexers and parsers.
 *
 * @author Sam Harwell
 */ class $4bd589a149816580$var$PredictionContextCache {
    constructor(enableCache = true){
        this.contexts = new $fP17P.Array2DHashMap($a4Flx.ObjectEqualityComparator.INSTANCE);
        this.childContexts = new $fP17P.Array2DHashMap($a4Flx.ObjectEqualityComparator.INSTANCE);
        this.joinContexts = new $fP17P.Array2DHashMap($a4Flx.ObjectEqualityComparator.INSTANCE);
        this.enableCache = enableCache;
    }
    getAsCached(context) {
        if (!this.enableCache) return context;
        let result = this.contexts.get(context);
        if (!result) {
            result = context;
            this.contexts.put(context, context);
        }
        return result;
    }
    getChild(context, invokingState) {
        if (!this.enableCache) return context.getChild(invokingState);
        let operands = new $4bd589a149816580$var$PredictionContextCache.PredictionContextAndInt(context, invokingState);
        let result = this.childContexts.get(operands);
        if (!result) {
            result = context.getChild(invokingState);
            result = this.getAsCached(result);
            this.childContexts.put(operands, result);
        }
        return result;
    }
    join(x, y) {
        if (!this.enableCache) return $8DTT0.PredictionContext.join(x, y, this);
        let operands = new $4bd589a149816580$var$PredictionContextCache.IdentityCommutativePredictionContextOperands(x, y);
        let result = this.joinContexts.get(operands);
        if (result) return result;
        result = $8DTT0.PredictionContext.join(x, y, this);
        result = this.getAsCached(result);
        this.joinContexts.put(operands, result);
        return result;
    }
}
module.exports.PredictionContextCache = $4bd589a149816580$var$PredictionContextCache;
$4bd589a149816580$var$PredictionContextCache.UNCACHED = new $4bd589a149816580$var$PredictionContextCache(false);
(function(PredictionContextCache) {
    class PredictionContextAndInt {
        constructor(obj, value){
            this.obj = obj;
            this.value = value;
        }
        equals(obj) {
            if (!(obj instanceof PredictionContextAndInt)) return false;
            else if (obj === this) return true;
            let other = obj;
            return this.value === other.value && (this.obj === other.obj || this.obj != null && this.obj.equals(other.obj));
        }
        hashCode() {
            let hashCode = 5;
            hashCode = 7 * hashCode + (this.obj != null ? this.obj.hashCode() : 0);
            hashCode = 7 * hashCode + this.value;
            return hashCode;
        }
    }
    $4bd589a149816580$var$__decorate([
        $d6D31.Override
    ], PredictionContextAndInt.prototype, "equals", null);
    $4bd589a149816580$var$__decorate([
        $d6D31.Override
    ], PredictionContextAndInt.prototype, "hashCode", null);
    PredictionContextCache.PredictionContextAndInt = PredictionContextAndInt;
    class IdentityCommutativePredictionContextOperands {
        constructor(x, y){
            $bbHFU(x != null);
            $bbHFU(y != null);
            this._x = x;
            this._y = y;
        }
        get x() {
            return this._x;
        }
        get y() {
            return this._y;
        }
        equals(o) {
            if (!(o instanceof IdentityCommutativePredictionContextOperands)) return false;
            else if (this === o) return true;
            let other = o;
            return this._x === other._x && this._y === other._y || this._x === other._y && this._y === other._x;
        }
        hashCode() {
            return this._x.hashCode() ^ this._y.hashCode();
        }
    }
    $4bd589a149816580$var$__decorate([
        $d6D31.Override
    ], IdentityCommutativePredictionContextOperands.prototype, "equals", null);
    $4bd589a149816580$var$__decorate([
        $d6D31.Override
    ], IdentityCommutativePredictionContextOperands.prototype, "hashCode", null);
    PredictionContextCache.IdentityCommutativePredictionContextOperands = IdentityCommutativePredictionContextOperands;
})($4bd589a149816580$var$PredictionContextCache = module.exports.PredictionContextCache || (module.exports.PredictionContextCache = {}));

});



parcelRegister("5BPMp", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BitSet = void 0;

var $9kAQu = parcelRequire("9kAQu");

var $iXFjm = parcelRequire("iXFjm");
/**
 * Private empty array used to construct empty BitSets
 */ const $415892d73e8925a4$var$EMPTY_DATA = new Uint16Array(0);
/**
 * Gets the word index of the `UInt16` element in `BitSet.data` containing the bit with the specified index.
 */ function $415892d73e8925a4$var$getIndex(bitNumber) {
    return bitNumber >>> 4;
}
/**
 * Convert a word index into the bit index of the LSB of that word
 */ function $415892d73e8925a4$var$unIndex(n) {
    return n * 16;
}
/**
 * Get's the bit number of the least signficant bit set LSB which is set in a word non-zero word;
 * Bit numbers run from LSB to MSB starting with 0.
 */ function $415892d73e8925a4$var$findLSBSet(word) {
    let bit = 1;
    for(let i = 0; i < 16; i++){
        if ((word & bit) !== 0) return i;
        bit = bit << 1 >>> 0;
    }
    throw new RangeError("No specified bit found");
}
function $415892d73e8925a4$var$findMSBSet(word) {
    let bit = 32768;
    for(let i = 15; i >= 0; i--){
        if ((word & bit) !== 0) return i;
        bit = bit >>> 1;
    }
    throw new RangeError("No specified bit found");
}
/**
 * Gets a 16-bit mask with bit numbers fromBit to toBit (inclusive) set.
 * Bit numbers run from LSB to MSB starting with 0.
 */ function $415892d73e8925a4$var$bitsFor(fromBit, toBit) {
    fromBit &= 0xF;
    toBit &= 0xF;
    if (fromBit === toBit) return 1 << fromBit >>> 0;
    return 0xFFFF >>> 15 - toBit ^ 0xFFFF >>> 16 - fromBit;
}
/**
 * A lookup table for number of set bits in a 16-bit integer.   This is used to quickly count the cardinality (number of unique elements) of a BitSet.
 */ const $415892d73e8925a4$var$POP_CNT = new Uint8Array(65536);
for(let i = 0; i < 16; i++){
    const stride = 1 << i >>> 0;
    let index = 0;
    while(index < $415892d73e8925a4$var$POP_CNT.length){
        // skip the numbers where the bit isn't set
        index += stride;
        // increment the ones where the bit is set
        for(let j = 0; j < stride; j++){
            $415892d73e8925a4$var$POP_CNT[index]++;
            index++;
        }
    }
}
class $415892d73e8925a4$var$BitSet {
    /*
    ** constructor implementation
    */ constructor(arg){
        if (!arg) // covering the case of unspecified and nbits===0
        this.data = $415892d73e8925a4$var$EMPTY_DATA;
        else if (typeof arg === "number") {
            if (arg < 0) throw new RangeError("nbits cannot be negative");
            else this.data = new Uint16Array($415892d73e8925a4$var$getIndex(arg - 1) + 1);
        } else if (arg instanceof $415892d73e8925a4$var$BitSet) this.data = arg.data.slice(0); // Clone the data
        else {
            let max = -1;
            for (let v of arg)if (max < v) max = v;
            this.data = new Uint16Array($415892d73e8925a4$var$getIndex(max - 1) + 1);
            for (let v of arg)this.set(v);
        }
    }
    /**
     * Performs a logical **AND** of this target bit set with the argument bit set. This bit set is modified so that
     * each bit in it has the value `true` if and only if it both initially had the value `true` and the corresponding
     * bit in the bit set argument also had the value `true`.
     */ and(set) {
        const data = this.data;
        const other = set.data;
        const words = Math.min(data.length, other.length);
        let lastWord = -1; // Keep track of index of last non-zero word
        for(let i = 0; i < words; i++){
            let value = data[i] &= other[i];
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $415892d73e8925a4$var$EMPTY_DATA;
        if (lastWord < data.length - 1) this.data = data.slice(0, lastWord + 1);
    }
    /**
     * Clears all of the bits in this `BitSet` whose corresponding bit is set in the specified `BitSet`.
     */ andNot(set) {
        const data = this.data;
        const other = set.data;
        const words = Math.min(data.length, other.length);
        let lastWord = -1; // Keep track of index of last non-zero word
        for(let i = 0; i < words; i++){
            let value = data[i] &= other[i] ^ 0xFFFF;
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $415892d73e8925a4$var$EMPTY_DATA;
        if (lastWord < data.length - 1) this.data = data.slice(0, lastWord + 1);
    }
    /**
     * Returns the number of bits set to `true` in this `BitSet`.
     */ cardinality() {
        if (this.isEmpty) return 0;
        const data = this.data;
        const length = data.length;
        let result = 0;
        for(let i = 0; i < length; i++)result += $415892d73e8925a4$var$POP_CNT[data[i]];
        return result;
    }
    clear(fromIndex, toIndex) {
        if (fromIndex == null) this.data.fill(0);
        else if (toIndex == null) this.set(fromIndex, false);
        else this.set(fromIndex, toIndex, false);
    }
    flip(fromIndex, toIndex) {
        if (toIndex == null) toIndex = fromIndex;
        if (fromIndex < 0 || toIndex < fromIndex) throw new RangeError();
        let word = $415892d73e8925a4$var$getIndex(fromIndex);
        const lastWord = $415892d73e8925a4$var$getIndex(toIndex);
        if (word === lastWord) this.data[word] ^= $415892d73e8925a4$var$bitsFor(fromIndex, toIndex);
        else {
            this.data[word++] ^= $415892d73e8925a4$var$bitsFor(fromIndex, 15);
            while(word < lastWord)this.data[word++] ^= 0xFFFF;
            this.data[word++] ^= $415892d73e8925a4$var$bitsFor(0, toIndex);
        }
    }
    get(fromIndex, toIndex) {
        if (toIndex === undefined) return !!(this.data[$415892d73e8925a4$var$getIndex(fromIndex)] & $415892d73e8925a4$var$bitsFor(fromIndex, fromIndex));
        else {
            // return a BitSet
            let result = new $415892d73e8925a4$var$BitSet(toIndex + 1);
            for(let i = fromIndex; i <= toIndex; i++)result.set(i, this.get(i));
            return result;
        }
    }
    /**
     * Returns true if the specified `BitSet` has any bits set to `true` that are also set to `true` in this `BitSet`.
     *
     * @param set `BitSet` to intersect with
     */ intersects(set) {
        let smallerLength = Math.min(this.length(), set.length());
        if (smallerLength === 0) return false;
        let bound = $415892d73e8925a4$var$getIndex(smallerLength - 1);
        for(let i = 0; i <= bound; i++){
            if ((this.data[i] & set.data[i]) !== 0) return true;
        }
        return false;
    }
    /**
     * Returns true if this `BitSet` contains no bits that are set to `true`.
     */ get isEmpty() {
        return this.length() === 0;
    }
    /**
     * Returns the "logical size" of this `BitSet`: the index of the highest set bit in the `BitSet` plus one. Returns
     * zero if the `BitSet` contains no set bits.
     */ length() {
        if (!this.data.length) return 0;
        return this.previousSetBit($415892d73e8925a4$var$unIndex(this.data.length) - 1) + 1;
    }
    /**
     * Returns the index of the first bit that is set to `false` that occurs on or after the specified starting index,
     * If no such bit exists then `-1` is returned.
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is negative
     */ nextClearBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $415892d73e8925a4$var$getIndex(fromIndex);
        if (word > length) return -1;
        let ignore = 0xFFFF ^ $415892d73e8925a4$var$bitsFor(fromIndex, 15);
        if ((data[word] | ignore) === 0xFFFF) {
            word++;
            ignore = 0;
            for(; word < length; word++){
                if (data[word] !== 0xFFFF) break;
            }
            if (word === length) // Hit the end
            return -1;
        }
        return $415892d73e8925a4$var$unIndex(word) + $415892d73e8925a4$var$findLSBSet((data[word] | ignore) ^ 0xFFFF);
    }
    /**
     * Returns the index of the first bit that is set to `true` that occurs on or after the specified starting index.
     * If no such bit exists then `-1` is returned.
     *
     * To iterate over the `true` bits in a `BitSet`, use the following loop:
     *
     * ```
     * for (let i = bs.nextSetBit(0); i >= 0; i = bs.nextSetBit(i + 1)) {
     *   // operate on index i here
     * }
     * ```
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is negative
     */ nextSetBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $415892d73e8925a4$var$getIndex(fromIndex);
        if (word > length) return -1;
        let mask = $415892d73e8925a4$var$bitsFor(fromIndex, 15);
        if ((data[word] & mask) === 0) {
            word++;
            mask = 0xFFFF;
            for(; word < length; word++){
                if (data[word] !== 0) break;
            }
            if (word >= length) return -1;
        }
        return $415892d73e8925a4$var$unIndex(word) + $415892d73e8925a4$var$findLSBSet(data[word] & mask);
    }
    /**
     * Performs a logical **OR** of this bit set with the bit set argument. This bit set is modified so that a bit in it
     * has the value `true` if and only if it either already had the value `true` or the corresponding bit in the bit
     * set argument has the value `true`.
     */ or(set) {
        const data = this.data;
        const other = set.data;
        const minWords = Math.min(data.length, other.length);
        const words = Math.max(data.length, other.length);
        const dest = data.length === words ? data : new Uint16Array(words);
        let lastWord = -1;
        // Or those words both sets have in common
        for(let i = 0; i < minWords; i++){
            let value = dest[i] = data[i] | other[i];
            if (value !== 0) lastWord = i;
        }
        // Copy words from larger set (if there is one)
        const longer = data.length > other.length ? data : other;
        for(let i = minWords; i < words; i++){
            let value = dest[i] = longer[i];
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $415892d73e8925a4$var$EMPTY_DATA;
        else if (dest.length === lastWord + 1) this.data = dest;
        else this.data = dest.slice(0, lastWord);
    }
    /**
     * Returns the index of the nearest bit that is set to `false` that occurs on or before the specified starting
     * index. If no such bit exists, or if `-1` is given as the starting index, then `-1` is returned.
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is less than `-1`
     */ previousClearBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $415892d73e8925a4$var$getIndex(fromIndex);
        if (word >= length) word = length - 1;
        let ignore = 0xFFFF ^ $415892d73e8925a4$var$bitsFor(0, fromIndex);
        if ((data[word] | ignore) === 0xFFFF) {
            ignore = 0;
            word--;
            for(; word >= 0; word--){
                if (data[word] !== 0xFFFF) break;
            }
            if (word < 0) // Hit the end
            return -1;
        }
        return $415892d73e8925a4$var$unIndex(word) + $415892d73e8925a4$var$findMSBSet((data[word] | ignore) ^ 0xFFFF);
    }
    /**
     * Returns the index of the nearest bit that is set to `true` that occurs on or before the specified starting index.
     * If no such bit exists, or if `-1` is given as the starting index, then `-1` is returned.
     *
     * To iterate over the `true` bits in a `BitSet`, use the following loop:
     *
     * ```
     * for (let i = bs.length(); (i = bs.previousSetBit(i-1)) >= 0; ) {
     *   // operate on index i here
     * }
     * ```
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is less than `-1`
     */ previousSetBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $415892d73e8925a4$var$getIndex(fromIndex);
        if (word >= length) word = length - 1;
        let mask = $415892d73e8925a4$var$bitsFor(0, fromIndex);
        if ((data[word] & mask) === 0) {
            word--;
            mask = 0xFFFF;
            for(; word >= 0; word--){
                if (data[word] !== 0) break;
            }
            if (word < 0) return -1;
        }
        return $415892d73e8925a4$var$unIndex(word) + $415892d73e8925a4$var$findMSBSet(data[word] & mask);
    }
    set(fromIndex, toIndex, value) {
        if (toIndex === undefined) {
            toIndex = fromIndex;
            value = true;
        } else if (typeof toIndex === "boolean") {
            value = toIndex;
            toIndex = fromIndex;
        }
        if (value === undefined) value = true;
        if (fromIndex < 0 || fromIndex > toIndex) throw new RangeError();
        let word = $415892d73e8925a4$var$getIndex(fromIndex);
        let lastWord = $415892d73e8925a4$var$getIndex(toIndex);
        if (value && lastWord >= this.data.length) {
            // Grow array "just enough" for bits we need to set
            let temp = new Uint16Array(lastWord + 1);
            this.data.forEach((value, index)=>temp[index] = value);
            this.data = temp;
        } else if (!value) {
            // But there is no need to grow array to clear bits.
            if (word >= this.data.length) // Early exit
            return;
            if (lastWord >= this.data.length) {
                // Adjust work to fit array
                lastWord = this.data.length - 1;
                toIndex = this.data.length * 16 - 1;
            }
        }
        if (word === lastWord) this._setBits(word, value, $415892d73e8925a4$var$bitsFor(fromIndex, toIndex));
        else {
            this._setBits(word++, value, $415892d73e8925a4$var$bitsFor(fromIndex, 15));
            while(word < lastWord)this.data[word++] = value ? 0xFFFF : 0;
            this._setBits(word, value, $415892d73e8925a4$var$bitsFor(0, toIndex));
        }
    }
    _setBits(word, value, mask) {
        if (value) this.data[word] |= mask;
        else this.data[word] &= 0xFFFF ^ mask;
    }
    /**
     * Returns the number of bits of space actually in use by this `BitSet` to represent bit values. The maximum element
     * in the set is the size - 1st element.
     */ get size() {
        return this.data.byteLength * 8;
    }
    /**
     * Returns a new byte array containing all the bits in this bit set.
     *
     * More precisely, if
     * `let bytes = s.toByteArray();`
     * then `bytes.length === (s.length()+7)/8` and `s.get(n) === ((bytes[n/8] & (1<<(n%8))) != 0)` for all
     * `n < 8 * bytes.length`.
     */ // toByteArray(): Int8Array {
    // 	throw new Error("NOT IMPLEMENTED");
    // }
    /**
     * Returns a new integer array containing all the bits in this bit set.
     *
     * More precisely, if
     * `let integers = s.toIntegerArray();`
     * then `integers.length === (s.length()+31)/32` and `s.get(n) === ((integers[n/32] & (1<<(n%32))) != 0)` for all
     * `n < 32 * integers.length`.
     */ // toIntegerArray(): Int32Array {
    // 	throw new Error("NOT IMPLEMENTED");
    // }
    hashCode() {
        return $iXFjm.MurmurHash.hashCode(this.data, 22);
    }
    /**
     * Compares this object against the specified object. The result is `true` if and only if the argument is not
     * `undefined` and is a `Bitset` object that has exactly the same set of bits set to `true` as this bit set. That
     * is, for every nonnegative index `k`,
     *
     * ```
     * ((BitSet)obj).get(k) == this.get(k)
     * ```
     *
     * must be true. The current sizes of the two bit sets are not compared.
     */ equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $415892d73e8925a4$var$BitSet)) return false;
        const len = this.length();
        if (len !== obj.length()) return false;
        if (len === 0) return true;
        let bound = $415892d73e8925a4$var$getIndex(len - 1);
        for(let i = 0; i <= bound; i++){
            if (this.data[i] !== obj.data[i]) return false;
        }
        return true;
    }
    /**
     * Returns a string representation of this bit set. For every index for which this `BitSet` contains a bit in the
     * set state, the decimal representation of that index is included in the result. Such indices are listed in order
     * from lowest to highest, separated by ", " (a comma and a space) and surrounded by braces, resulting in the usual
     * mathematical notation for a set of integers.
     *
     * Example:
     *
     *     BitSet drPepper = new BitSet();
     *
     * Now `drPepper.toString()` returns `"{}"`.
     *
     *     drPepper.set(2);
     *
     * Now `drPepper.toString()` returns `"{2}"`.
     *
     *     drPepper.set(4);
     *     drPepper.set(10);
     *
     * Now `drPepper.toString()` returns `"{2, 4, 10}"`.
     */ toString() {
        let result = "{";
        let first = true;
        for(let i = this.nextSetBit(0); i >= 0; i = this.nextSetBit(i + 1)){
            if (first) first = false;
            else result += ", ";
            result += i;
        }
        result += "}";
        return result;
    }
    // static valueOf(bytes: Int8Array): BitSet;
    // static valueOf(buffer: ArrayBuffer): BitSet;
    // static valueOf(integers: Int32Array): BitSet;
    // static valueOf(data: Int8Array | Int32Array | ArrayBuffer): BitSet {
    // 	throw new Error("NOT IMPLEMENTED");
    // }
    /**
     * Performs a logical **XOR** of this bit set with the bit set argument. This bit set is modified so that a bit in
     * it has the value `true` if and only if one of the following statements holds:
     *
     * * The bit initially has the value `true`, and the corresponding bit in the argument has the value `false`.
     * * The bit initially has the value `false`, and the corresponding bit in the argument has the value `true`.
     */ xor(set) {
        const data = this.data;
        const other = set.data;
        const minWords = Math.min(data.length, other.length);
        const words = Math.max(data.length, other.length);
        const dest = data.length === words ? data : new Uint16Array(words);
        let lastWord = -1;
        // Xor those words both sets have in common
        for(let i = 0; i < minWords; i++){
            let value = dest[i] = data[i] ^ other[i];
            if (value !== 0) lastWord = i;
        }
        // Copy words from larger set (if there is one)
        const longer = data.length > other.length ? data : other;
        for(let i = minWords; i < words; i++){
            let value = dest[i] = longer[i];
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $415892d73e8925a4$var$EMPTY_DATA;
        else if (dest.length === lastWord + 1) this.data = dest;
        else this.data = dest.slice(0, lastWord + 1);
    }
    clone() {
        return new $415892d73e8925a4$var$BitSet(this);
    }
    [Symbol.iterator]() {
        return new $415892d73e8925a4$var$BitSetIterator(this.data);
    }
    // Overrides formatting for nodejs assert etc.
    [$9kAQu.inspect.custom]() {
        return "BitSet " + this.toString();
    }
}
module.exports.BitSet = $415892d73e8925a4$var$BitSet;
class $415892d73e8925a4$var$BitSetIterator {
    constructor(data){
        this.data = data;
        this.index = 0;
        this.mask = 0xFFFF;
    }
    next() {
        while(this.index < this.data.length){
            const bits = this.data[this.index] & this.mask;
            if (bits !== 0) {
                const bitNumber = $415892d73e8925a4$var$unIndex(this.index) + $415892d73e8925a4$var$findLSBSet(bits);
                this.mask = $415892d73e8925a4$var$bitsFor(bitNumber + 1, 15);
                return {
                    done: false,
                    value: bitNumber
                };
            }
            this.index++;
            this.mask = 0xFFFF;
        }
        return {
            done: true,
            value: -1
        };
    }
    [Symbol.iterator]() {
        return this;
    }
}

});


parcelRegister("yhTtv", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $06710e6ae1da410a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DFASerializer = void 0;

var $kr9A1 = parcelRequire("kr9A1");

var $d6D31 = parcelRequire("d6D31");

var $8DTT0 = parcelRequire("8DTT0");

var $kBaAZ = parcelRequire("kBaAZ");

var $3n2FE = parcelRequire("3n2FE");
/** A DFA walker that knows how to dump them to serialized strings. */ class $06710e6ae1da410a$var$DFASerializer {
    constructor(dfa, vocabulary, ruleNames, atn){
        if (vocabulary instanceof $kBaAZ.Recognizer) {
            ruleNames = vocabulary.ruleNames;
            atn = vocabulary.atn;
            vocabulary = vocabulary.vocabulary;
        } else if (!vocabulary) vocabulary = $3n2FE.VocabularyImpl.EMPTY_VOCABULARY;
        this.dfa = dfa;
        this.vocabulary = vocabulary;
        this.ruleNames = ruleNames;
        this.atn = atn;
    }
    toString() {
        if (!this.dfa.s0) return "";
        let buf = "";
        if (this.dfa.states) {
            let states = new Array(...this.dfa.states.toArray());
            states.sort((o1, o2)=>o1.stateNumber - o2.stateNumber);
            for (let s of states){
                let edges = s.getEdgeMap();
                let edgeKeys = [
                    ...edges.keys()
                ].sort((a, b)=>a - b);
                let contextEdges = s.getContextEdgeMap();
                let contextEdgeKeys = [
                    ...contextEdges.keys()
                ].sort((a, b)=>a - b);
                for (let entry of edgeKeys){
                    let value = edges.get(entry);
                    if ((value == null || value === $kr9A1.ATNSimulator.ERROR) && !s.isContextSymbol(entry)) continue;
                    let contextSymbol = false;
                    buf += this.getStateString(s) + "-" + this.getEdgeLabel(entry) + "->";
                    if (s.isContextSymbol(entry)) {
                        buf += "!";
                        contextSymbol = true;
                    }
                    let t = value;
                    if (t && t.stateNumber !== $kr9A1.ATNSimulator.ERROR.stateNumber) buf += this.getStateString(t) + "\n";
                    else if (contextSymbol) buf += "ctx\n";
                }
                if (s.isContextSensitive) for (let entry of contextEdgeKeys)buf += this.getStateString(s) + "-" + this.getContextLabel(entry) + "->" + this.getStateString(contextEdges.get(entry)) + "\n";
            }
        }
        let output = buf;
        if (output.length === 0) return "";
        //return Utils.sortLinesInString(output);
        return output;
    }
    getContextLabel(i) {
        if (i === $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) return "ctx:EMPTY_FULL";
        else if (i === $8DTT0.PredictionContext.EMPTY_LOCAL_STATE_KEY) return "ctx:EMPTY_LOCAL";
        if (this.atn && i > 0 && i <= this.atn.states.length) {
            let state = this.atn.states[i];
            let ruleIndex = state.ruleIndex;
            if (this.ruleNames && ruleIndex >= 0 && ruleIndex < this.ruleNames.length) return "ctx:" + String(i) + "(" + this.ruleNames[ruleIndex] + ")";
        }
        return "ctx:" + String(i);
    }
    getEdgeLabel(i) {
        return this.vocabulary.getDisplayName(i);
    }
    getStateString(s) {
        if (s === $kr9A1.ATNSimulator.ERROR) return "ERROR";
        let n = s.stateNumber;
        let stateStr = "s" + n;
        if (s.isAcceptState) {
            if (s.predicates) stateStr = ":s" + n + "=>" + s.predicates;
            else stateStr = ":s" + n + "=>" + s.prediction;
        }
        if (s.isContextSensitive) {
            stateStr += "*";
            for (let config of s.configs)if (config.reachesIntoOuterContext) {
                stateStr += "*";
                break;
            }
        }
        return stateStr;
    }
}
$06710e6ae1da410a$var$__decorate([
    $d6D31.NotNull
], $06710e6ae1da410a$var$DFASerializer.prototype, "dfa", void 0);
$06710e6ae1da410a$var$__decorate([
    $d6D31.NotNull
], $06710e6ae1da410a$var$DFASerializer.prototype, "vocabulary", void 0);
$06710e6ae1da410a$var$__decorate([
    $d6D31.Override
], $06710e6ae1da410a$var$DFASerializer.prototype, "toString", null);
module.exports.DFASerializer = $06710e6ae1da410a$var$DFASerializer;

});
parcelRegister("kr9A1", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ee0dc2a763a7368a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $ee0dc2a763a7368a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNSimulator = void 0;

var $c1ClW = parcelRequire("c1ClW");

var $2jevZ = parcelRequire("2jevZ");

var $d6D31 = parcelRequire("d6D31");

var $8DTT0 = parcelRequire("8DTT0");
let $ee0dc2a763a7368a$var$ATNSimulator = class ATNSimulator {
    constructor(atn){
        this.atn = atn;
    }
    static get ERROR() {
        if (!ATNSimulator._ERROR) {
            ATNSimulator._ERROR = new $2jevZ.DFAState(new $c1ClW.ATNConfigSet());
            ATNSimulator._ERROR.stateNumber = $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY;
        }
        return ATNSimulator._ERROR;
    }
    /**
     * Clear the DFA cache used by the current instance. Since the DFA cache may
     * be shared by multiple ATN simulators, this method may affect the
     * performance (but not accuracy) of other parsers which are being used
     * concurrently.
     *
     * @ if the current instance does not
     * support clearing the DFA.
     *
     * @since 4.3
     */ clearDFA() {
        this.atn.clearDFA();
    }
};
$ee0dc2a763a7368a$var$__decorate([
    $d6D31.NotNull
], $ee0dc2a763a7368a$var$ATNSimulator.prototype, "atn", void 0);
$ee0dc2a763a7368a$var$__decorate([
    $d6D31.NotNull
], $ee0dc2a763a7368a$var$ATNSimulator, "ERROR", null);
$ee0dc2a763a7368a$var$ATNSimulator = $ee0dc2a763a7368a$var$__decorate([
    $ee0dc2a763a7368a$var$__param(0, $d6D31.NotNull)
], $ee0dc2a763a7368a$var$ATNSimulator);
module.exports.ATNSimulator = $ee0dc2a763a7368a$var$ATNSimulator;
(function(ATNSimulator) {
    const RULE_VARIANT_DELIMITER = "$";
    const RULE_LF_VARIANT_MARKER = "$lf$";
    const RULE_NOLF_VARIANT_MARKER = "$nolf$";
})($ee0dc2a763a7368a$var$ATNSimulator = module.exports.ATNSimulator || (module.exports.ATNSimulator = {}));
module.exports.ATNSimulator = $ee0dc2a763a7368a$var$ATNSimulator;

});
parcelRegister("2jevZ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $1ae89d7ac78d8bff$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $1ae89d7ac78d8bff$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DFAState = void 0;

var $bcnvE = parcelRequire("bcnvE");

var $5BPMp = parcelRequire("5BPMp");

var $iXFjm = parcelRequire("iXFjm");

var $d6D31 = parcelRequire("d6D31");

var $8DTT0 = parcelRequire("8DTT0");

var $bbHFU = parcelRequire("bbHFU");
/** A DFA state represents a set of possible ATN configurations.
 *  As Aho, Sethi, Ullman p. 117 says "The DFA uses its state
 *  to keep track of all possible states the ATN can be in after
 *  reading each input symbol.  That is to say, after reading
 *  input a1a2..an, the DFA is in a state that represents the
 *  subset T of the states of the ATN that are reachable from the
 *  ATN's start state along some path labeled a1a2..an."
 *  In conventional NFA&rarr;DFA conversion, therefore, the subset T
 *  would be a bitset representing the set of states the
 *  ATN could be in.  We need to track the alt predicted by each
 *  state as well, however.  More importantly, we need to maintain
 *  a stack of states, tracking the closure operations as they
 *  jump from rule to rule, emulating rule invocations (method calls).
 *  I have to add a stack to simulate the proper lookahead sequences for
 *  the underlying LL grammar from which the ATN was derived.
 *
 *  I use a set of ATNConfig objects not simple states.  An ATNConfig
 *  is both a state (ala normal conversion) and a RuleContext describing
 *  the chain of rules (if any) followed to arrive at that state.
 *
 *  A DFA state may have multiple references to a particular state,
 *  but with different ATN contexts (with same or different alts)
 *  meaning that state was reached via a different set of rule invocations.
 */ class $1ae89d7ac78d8bff$var$DFAState {
    /**
     * Constructs a new `DFAState`.
     *
     * @param configs The set of ATN configurations defining this state.
     */ constructor(configs){
        this.stateNumber = -1;
        this.configs = configs;
        this.edges = new Map();
        this.contextEdges = new Map();
    }
    get isContextSensitive() {
        return !!this.contextSymbols;
    }
    isContextSymbol(symbol) {
        if (!this.isContextSensitive) return false;
        return this.contextSymbols.get(symbol);
    }
    setContextSymbol(symbol) {
        $bbHFU(this.isContextSensitive);
        this.contextSymbols.set(symbol);
    }
    setContextSensitive(atn) {
        $bbHFU(!this.configs.isOutermostConfigSet);
        if (this.isContextSensitive) return;
        if (!this.contextSymbols) this.contextSymbols = new $5BPMp.BitSet();
    }
    get acceptStateInfo() {
        return this._acceptStateInfo;
    }
    set acceptStateInfo(acceptStateInfo) {
        this._acceptStateInfo = acceptStateInfo;
    }
    get isAcceptState() {
        return !!this._acceptStateInfo;
    }
    get prediction() {
        if (!this._acceptStateInfo) return $bcnvE.ATN.INVALID_ALT_NUMBER;
        return this._acceptStateInfo.prediction;
    }
    get lexerActionExecutor() {
        if (!this._acceptStateInfo) return undefined;
        return this._acceptStateInfo.lexerActionExecutor;
    }
    getTarget(symbol) {
        return this.edges.get(symbol);
    }
    setTarget(symbol, target) {
        this.edges.set(symbol, target);
    }
    getEdgeMap() {
        return this.edges;
    }
    getContextTarget(invokingState) {
        if (invokingState === $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) invokingState = -1;
        return this.contextEdges.get(invokingState);
    }
    setContextTarget(invokingState, target) {
        if (!this.isContextSensitive) throw new Error("The state is not context sensitive.");
        if (invokingState === $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) invokingState = -1;
        this.contextEdges.set(invokingState, target);
    }
    getContextEdgeMap() {
        let map = new Map(this.contextEdges);
        let existing = map.get(-1);
        if (existing !== undefined) {
            if (map.size === 1) {
                let result = new Map();
                result.set($8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY, existing);
                return result;
            } else {
                map.delete(-1);
                map.set($8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY, existing);
            }
        }
        return map;
    }
    hashCode() {
        let hash = $iXFjm.MurmurHash.initialize(7);
        hash = $iXFjm.MurmurHash.update(hash, this.configs.hashCode());
        hash = $iXFjm.MurmurHash.finish(hash, 1);
        return hash;
    }
    /**
     * Two {@link DFAState} instances are equal if their ATN configuration sets
     * are the same. This method is used to see if a state already exists.
     *
     * Because the number of alternatives and number of ATN configurations are
     * finite, there is a finite number of DFA states that can be processed.
     * This is necessary to show that the algorithm terminates.
     *
     * Cannot test the DFA state numbers here because in
     * {@link ParserATNSimulator#addDFAState} we need to know if any other state
     * exists that has this exact set of ATN configurations. The
     * {@link #stateNumber} is irrelevant.
     */ equals(o) {
        // compare set of ATN configurations in this set with other
        if (this === o) return true;
        if (!(o instanceof $1ae89d7ac78d8bff$var$DFAState)) return false;
        let other = o;
        let sameSet = this.configs.equals(other.configs);
        //		System.out.println("DFAState.equals: "+configs+(sameSet?"==":"!=")+other.configs);
        return sameSet;
    }
    toString() {
        let buf = "";
        buf += this.stateNumber + ":" + this.configs;
        if (this.isAcceptState) {
            buf += "=>";
            if (this.predicates) buf += this.predicates;
            else buf += this.prediction;
        }
        return buf.toString();
    }
}
$1ae89d7ac78d8bff$var$__decorate([
    $d6D31.NotNull
], $1ae89d7ac78d8bff$var$DFAState.prototype, "configs", void 0);
$1ae89d7ac78d8bff$var$__decorate([
    $d6D31.NotNull
], $1ae89d7ac78d8bff$var$DFAState.prototype, "edges", void 0);
$1ae89d7ac78d8bff$var$__decorate([
    $d6D31.NotNull
], $1ae89d7ac78d8bff$var$DFAState.prototype, "contextEdges", void 0);
$1ae89d7ac78d8bff$var$__decorate([
    $d6D31.Override
], $1ae89d7ac78d8bff$var$DFAState.prototype, "hashCode", null);
$1ae89d7ac78d8bff$var$__decorate([
    $d6D31.Override
], $1ae89d7ac78d8bff$var$DFAState.prototype, "equals", null);
$1ae89d7ac78d8bff$var$__decorate([
    $d6D31.Override
], $1ae89d7ac78d8bff$var$DFAState.prototype, "toString", null);
module.exports.DFAState = $1ae89d7ac78d8bff$var$DFAState;
(function(DFAState) {
    /** Map a predicate to a predicted alternative. */ let PredPrediction = class PredPrediction {
        constructor(pred, alt){
            this.alt = alt;
            this.pred = pred;
        }
        toString() {
            return "(" + this.pred + ", " + this.alt + ")";
        }
    };
    $1ae89d7ac78d8bff$var$__decorate([
        $d6D31.NotNull
    ], PredPrediction.prototype, "pred", void 0);
    $1ae89d7ac78d8bff$var$__decorate([
        $d6D31.Override
    ], PredPrediction.prototype, "toString", null);
    PredPrediction = $1ae89d7ac78d8bff$var$__decorate([
        $1ae89d7ac78d8bff$var$__param(0, $d6D31.NotNull)
    ], PredPrediction);
    DFAState.PredPrediction = PredPrediction;
})($1ae89d7ac78d8bff$var$DFAState = module.exports.DFAState || (module.exports.DFAState = {}));

});


parcelRegister("kBaAZ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $efef7b6bec20bc2a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $efef7b6bec20bc2a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Recognizer = void 0;

var $e5mHr = parcelRequire("e5mHr");

var $65iNZ = parcelRequire("65iNZ");

var $d6D31 = parcelRequire("d6D31");

var $2DVsz = parcelRequire("2DVsz");

var $2IEP9 = parcelRequire("2IEP9");
class $efef7b6bec20bc2a$var$Recognizer {
    constructor(){
        this._listeners = [
            $e5mHr.ConsoleErrorListener.INSTANCE
        ];
        this._stateNumber = -1;
    }
    /**
     * Get a map from token names to token types.
     *
     * Used for XPath and tree pattern compilation.
     */ getTokenTypeMap() {
        let vocabulary = this.vocabulary;
        let result = $efef7b6bec20bc2a$var$Recognizer.tokenTypeMapCache.get(vocabulary);
        if (result == null) {
            let intermediateResult = new Map();
            for(let i = 0; i <= this.atn.maxTokenType; i++){
                let literalName = vocabulary.getLiteralName(i);
                if (literalName != null) intermediateResult.set(literalName, i);
                let symbolicName = vocabulary.getSymbolicName(i);
                if (symbolicName != null) intermediateResult.set(symbolicName, i);
            }
            intermediateResult.set("EOF", $2DVsz.Token.EOF);
            result = intermediateResult;
            $efef7b6bec20bc2a$var$Recognizer.tokenTypeMapCache.set(vocabulary, result);
        }
        return result;
    }
    /**
     * Get a map from rule names to rule indexes.
     *
     * Used for XPath and tree pattern compilation.
     */ getRuleIndexMap() {
        let ruleNames = this.ruleNames;
        if (ruleNames == null) throw new Error("The current recognizer does not provide a list of rule names.");
        let result = $efef7b6bec20bc2a$var$Recognizer.ruleIndexMapCache.get(ruleNames);
        if (result == null) {
            result = $2IEP9.toMap(ruleNames);
            $efef7b6bec20bc2a$var$Recognizer.ruleIndexMapCache.set(ruleNames, result);
        }
        return result;
    }
    getTokenType(tokenName) {
        let ttype = this.getTokenTypeMap().get(tokenName);
        if (ttype != null) return ttype;
        return $2DVsz.Token.INVALID_TYPE;
    }
    /**
     * If this recognizer was generated, it will have a serialized ATN
     * representation of the grammar.
     *
     * For interpreters, we don't know their serialized ATN despite having
     * created the interpreter from it.
     */ get serializedATN() {
        throw new Error("there is no serialized ATN");
    }
    /**
     * Get the {@link ATN} used by the recognizer for prediction.
     *
     * @returns The {@link ATN} used by the recognizer for prediction.
     */ get atn() {
        return this._interp.atn;
    }
    /**
     * Get the ATN interpreter used by the recognizer for prediction.
     *
     * @returns The ATN interpreter used by the recognizer for prediction.
     */ get interpreter() {
        return this._interp;
    }
    /**
     * Set the ATN interpreter used by the recognizer for prediction.
     *
     * @param interpreter The ATN interpreter used by the recognizer for
     * prediction.
     */ set interpreter(interpreter) {
        this._interp = interpreter;
    }
    /** If profiling during the parse/lex, this will return DecisionInfo records
     *  for each decision in recognizer in a ParseInfo object.
     *
     * @since 4.3
     */ get parseInfo() {
        return Promise.resolve(undefined);
    }
    /** What is the error header, normally line/character position information? */ getErrorHeader(e) {
        let token = e.getOffendingToken();
        if (!token) return "";
        let line = token.line;
        let charPositionInLine = token.charPositionInLine;
        return "line " + line + ":" + charPositionInLine;
    }
    /**
     * @exception NullPointerException if `listener` is `undefined`.
     */ addErrorListener(listener) {
        if (!listener) throw new TypeError("listener must not be null");
        this._listeners.push(listener);
    }
    removeErrorListener(listener) {
        let position = this._listeners.indexOf(listener);
        if (position !== -1) this._listeners.splice(position, 1);
    }
    removeErrorListeners() {
        this._listeners.length = 0;
    }
    getErrorListeners() {
        return this._listeners.slice(0);
    }
    getErrorListenerDispatch() {
        return new $65iNZ.ProxyErrorListener(this.getErrorListeners());
    }
    // subclass needs to override these if there are sempreds or actions
    // that the ATN interp needs to execute
    sempred(_localctx, ruleIndex, actionIndex) {
        return true;
    }
    precpred(localctx, precedence) {
        return true;
    }
    action(_localctx, ruleIndex, actionIndex) {
    // intentionally empty
    }
    get state() {
        return this._stateNumber;
    }
    /** Indicate that the recognizer has changed internal state that is
     *  consistent with the ATN state passed in.  This way we always know
     *  where we are in the ATN as the parser goes along. The rule
     *  context objects form a stack that lets us see the stack of
     *  invoking rules. Combine this and we have complete ATN
     *  configuration information.
     */ set state(atnState) {
        //		System.err.println("setState "+atnState);
        this._stateNumber = atnState;
    //		if ( traceATNStates ) _ctx.trace(atnState);
    }
}
$efef7b6bec20bc2a$var$Recognizer.EOF = -1;
$efef7b6bec20bc2a$var$Recognizer.tokenTypeMapCache = new WeakMap();
$efef7b6bec20bc2a$var$Recognizer.ruleIndexMapCache = new WeakMap();
$efef7b6bec20bc2a$var$__decorate([
    $d6D31.SuppressWarnings("serial"),
    $d6D31.NotNull
], $efef7b6bec20bc2a$var$Recognizer.prototype, "_listeners", void 0);
$efef7b6bec20bc2a$var$__decorate([
    $d6D31.NotNull
], $efef7b6bec20bc2a$var$Recognizer.prototype, "getTokenTypeMap", null);
$efef7b6bec20bc2a$var$__decorate([
    $d6D31.NotNull
], $efef7b6bec20bc2a$var$Recognizer.prototype, "getRuleIndexMap", null);
$efef7b6bec20bc2a$var$__decorate([
    $d6D31.NotNull
], $efef7b6bec20bc2a$var$Recognizer.prototype, "serializedATN", null);
$efef7b6bec20bc2a$var$__decorate([
    $d6D31.NotNull
], $efef7b6bec20bc2a$var$Recognizer.prototype, "atn", null);
$efef7b6bec20bc2a$var$__decorate([
    $d6D31.NotNull,
    $efef7b6bec20bc2a$var$__param(0, $d6D31.NotNull)
], $efef7b6bec20bc2a$var$Recognizer.prototype, "interpreter", null);
$efef7b6bec20bc2a$var$__decorate([
    $d6D31.NotNull,
    $efef7b6bec20bc2a$var$__param(0, $d6D31.NotNull)
], $efef7b6bec20bc2a$var$Recognizer.prototype, "getErrorHeader", null);
$efef7b6bec20bc2a$var$__decorate([
    $efef7b6bec20bc2a$var$__param(0, $d6D31.NotNull)
], $efef7b6bec20bc2a$var$Recognizer.prototype, "addErrorListener", null);
$efef7b6bec20bc2a$var$__decorate([
    $efef7b6bec20bc2a$var$__param(0, $d6D31.NotNull)
], $efef7b6bec20bc2a$var$Recognizer.prototype, "removeErrorListener", null);
$efef7b6bec20bc2a$var$__decorate([
    $d6D31.NotNull
], $efef7b6bec20bc2a$var$Recognizer.prototype, "getErrorListeners", null);
module.exports.Recognizer = $efef7b6bec20bc2a$var$Recognizer;

});
parcelRegister("e5mHr", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConsoleErrorListener = void 0;
/**
 *
 * @author Sam Harwell
 */ class $a413240156cc2e50$var$ConsoleErrorListener {
    /**
     * {@inheritDoc}
     *
     * This implementation prints messages to {@link System#err} containing the
     * values of `line`, `charPositionInLine`, and `msg` using
     * the following format.
     *
     * <pre>
     * line *line*:*charPositionInLine* *msg*
     * </pre>
     */ syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e) {
        console.error(`line ${line}:${charPositionInLine} ${msg}`);
    }
}
module.exports.ConsoleErrorListener = $a413240156cc2e50$var$ConsoleErrorListener;
/**
 * Provides a default instance of {@link ConsoleErrorListener}.
 */ $a413240156cc2e50$var$ConsoleErrorListener.INSTANCE = new $a413240156cc2e50$var$ConsoleErrorListener();

});

parcelRegister("65iNZ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $46e1cc07c7f5b3d6$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $46e1cc07c7f5b3d6$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProxyErrorListener = void 0;

var $d6D31 = parcelRequire("d6D31");
/**
 * This implementation of {@link ANTLRErrorListener} dispatches all calls to a
 * collection of delegate listeners. This reduces the effort required to support multiple
 * listeners.
 *
 * @author Sam Harwell
 */ class $46e1cc07c7f5b3d6$var$ProxyErrorListener {
    constructor(delegates){
        this.delegates = delegates;
        if (!delegates) throw new Error("Invalid delegates");
    }
    getDelegates() {
        return this.delegates;
    }
    syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e) {
        this.delegates.forEach((listener)=>{
            if (listener.syntaxError) listener.syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e);
        });
    }
}
$46e1cc07c7f5b3d6$var$__decorate([
    $d6D31.Override,
    $46e1cc07c7f5b3d6$var$__param(0, $d6D31.NotNull),
    $46e1cc07c7f5b3d6$var$__param(4, $d6D31.NotNull)
], $46e1cc07c7f5b3d6$var$ProxyErrorListener.prototype, "syntaxError", null);
module.exports.ProxyErrorListener = $46e1cc07c7f5b3d6$var$ProxyErrorListener;

});


parcelRegister("3n2FE", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $27459777e7d4e735$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VocabularyImpl = void 0;

var $d6D31 = parcelRequire("d6D31");

var $2DVsz = parcelRequire("2DVsz");
/**
 * This class provides a default implementation of the {@link Vocabulary}
 * interface.
 *
 * @author Sam Harwell
 */ class $27459777e7d4e735$var$VocabularyImpl {
    /**
     * Constructs a new instance of {@link VocabularyImpl} from the specified
     * literal, symbolic, and display token names.
     *
     * @param literalNames The literal names assigned to tokens, or an empty array
     * if no literal names are assigned.
     * @param symbolicNames The symbolic names assigned to tokens, or
     * an empty array if no symbolic names are assigned.
     * @param displayNames The display names assigned to tokens, or an empty array
     * to use the values in `literalNames` and `symbolicNames` as
     * the source of display names, as described in
     * {@link #getDisplayName(int)}.
     *
     * @see #getLiteralName(int)
     * @see #getSymbolicName(int)
     * @see #getDisplayName(int)
     */ constructor(literalNames, symbolicNames, displayNames){
        this.literalNames = literalNames;
        this.symbolicNames = symbolicNames;
        this.displayNames = displayNames;
        // See note here on -1 part: https://github.com/antlr/antlr4/pull/1146
        this._maxTokenType = Math.max(this.displayNames.length, Math.max(this.literalNames.length, this.symbolicNames.length)) - 1;
    }
    get maxTokenType() {
        return this._maxTokenType;
    }
    getLiteralName(tokenType) {
        if (tokenType >= 0 && tokenType < this.literalNames.length) return this.literalNames[tokenType];
        return undefined;
    }
    getSymbolicName(tokenType) {
        if (tokenType >= 0 && tokenType < this.symbolicNames.length) return this.symbolicNames[tokenType];
        if (tokenType === $2DVsz.Token.EOF) return "EOF";
        return undefined;
    }
    getDisplayName(tokenType) {
        if (tokenType >= 0 && tokenType < this.displayNames.length) {
            let displayName = this.displayNames[tokenType];
            if (displayName) return displayName;
        }
        let literalName = this.getLiteralName(tokenType);
        if (literalName) return literalName;
        let symbolicName = this.getSymbolicName(tokenType);
        if (symbolicName) return symbolicName;
        return String(tokenType);
    }
}
/**
 * Gets an empty {@link Vocabulary} instance.
 *
 * No literal or symbol names are assigned to token types, so
 * {@link #getDisplayName(int)} returns the numeric value for all tokens
 * except {@link Token#EOF}.
 */ $27459777e7d4e735$var$VocabularyImpl.EMPTY_VOCABULARY = new $27459777e7d4e735$var$VocabularyImpl([], [], []);
$27459777e7d4e735$var$__decorate([
    $d6D31.NotNull
], $27459777e7d4e735$var$VocabularyImpl.prototype, "literalNames", void 0);
$27459777e7d4e735$var$__decorate([
    $d6D31.NotNull
], $27459777e7d4e735$var$VocabularyImpl.prototype, "symbolicNames", void 0);
$27459777e7d4e735$var$__decorate([
    $d6D31.NotNull
], $27459777e7d4e735$var$VocabularyImpl.prototype, "displayNames", void 0);
$27459777e7d4e735$var$__decorate([
    $d6D31.Override
], $27459777e7d4e735$var$VocabularyImpl.prototype, "maxTokenType", null);
$27459777e7d4e735$var$__decorate([
    $d6D31.Override
], $27459777e7d4e735$var$VocabularyImpl.prototype, "getLiteralName", null);
$27459777e7d4e735$var$__decorate([
    $d6D31.Override
], $27459777e7d4e735$var$VocabularyImpl.prototype, "getSymbolicName", null);
$27459777e7d4e735$var$__decorate([
    $d6D31.Override,
    $d6D31.NotNull
], $27459777e7d4e735$var$VocabularyImpl.prototype, "getDisplayName", null);
$27459777e7d4e735$var$__decorate([
    $d6D31.NotNull
], $27459777e7d4e735$var$VocabularyImpl, "EMPTY_VOCABULARY", void 0);
module.exports.VocabularyImpl = $27459777e7d4e735$var$VocabularyImpl;

});


parcelRegister("aeRGo", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7744da7bed4bb192$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $7744da7bed4bb192$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerDFASerializer = void 0;

var $yhTtv = parcelRequire("yhTtv");

var $d6D31 = parcelRequire("d6D31");

var $3n2FE = parcelRequire("3n2FE");
let $7744da7bed4bb192$var$LexerDFASerializer = class LexerDFASerializer extends $yhTtv.DFASerializer {
    constructor(dfa){
        super(dfa, $3n2FE.VocabularyImpl.EMPTY_VOCABULARY);
    }
    getEdgeLabel(i) {
        return "'" + String.fromCodePoint(i) + "'";
    }
};
$7744da7bed4bb192$var$__decorate([
    $d6D31.Override,
    $d6D31.NotNull
], $7744da7bed4bb192$var$LexerDFASerializer.prototype, "getEdgeLabel", null);
$7744da7bed4bb192$var$LexerDFASerializer = $7744da7bed4bb192$var$__decorate([
    $7744da7bed4bb192$var$__param(0, $d6D31.NotNull)
], $7744da7bed4bb192$var$LexerDFASerializer);
module.exports.LexerDFASerializer = $7744da7bed4bb192$var$LexerDFASerializer;

});

parcelRegister("f9raX", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $b07cc6cfd56668a7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarLoopEntryState = void 0;

var $1bs3X = parcelRequire("1bs3X");

var $5BPMp = parcelRequire("5BPMp");

var $dPYn6 = parcelRequire("dPYn6");

var $d6D31 = parcelRequire("d6D31");
class $b07cc6cfd56668a7$var$StarLoopEntryState extends $dPYn6.DecisionState {
    constructor(){
        super(...arguments);
        /**
         * Indicates whether this state can benefit from a precedence DFA during SLL
         * decision making.
         *
         * This is a computed property that is calculated during ATN deserialization
         * and stored for use in {@link ParserATNSimulator} and
         * {@link ParserInterpreter}.
         *
         * @see `DFA.isPrecedenceDfa`
         */ this.precedenceRuleDecision = false;
        /**
         * For precedence decisions, this set marks states *S* which have all
         * of the following characteristics:
         *
         * * One or more invocation sites of the current rule returns to
         *   *S*.
         * * The closure from *S* includes the current decision without
         *   passing through any rule invocations or stepping out of the current
         *   rule.
         *
         * This field is not used when {@link #precedenceRuleDecision} is
         * `false`.
         */ this.precedenceLoopbackStates = new $5BPMp.BitSet();
    }
    get stateType() {
        return $1bs3X.ATNStateType.STAR_LOOP_ENTRY;
    }
}
$b07cc6cfd56668a7$var$__decorate([
    $d6D31.Override
], $b07cc6cfd56668a7$var$StarLoopEntryState.prototype, "stateType", null);
module.exports.StarLoopEntryState = $b07cc6cfd56668a7$var$StarLoopEntryState;

});


parcelRegister("l4Nh1", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f580316b3d8851ef$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidState = void 0;

var $1bs3X = parcelRequire("1bs3X");

var $4yiuQ = parcelRequire("4yiuQ");

var $d6D31 = parcelRequire("d6D31");
/**
 *
 * @author Sam Harwell
 */ class $f580316b3d8851ef$var$InvalidState extends $4yiuQ.BasicState {
    get stateType() {
        return $1bs3X.ATNStateType.INVALID_TYPE;
    }
}
$f580316b3d8851ef$var$__decorate([
    $d6D31.Override
], $f580316b3d8851ef$var$InvalidState.prototype, "stateType", null);
module.exports.InvalidState = $f580316b3d8851ef$var$InvalidState;

});
parcelRegister("4yiuQ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $3508af691e74fe3f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BasicState = void 0;

var $7j0Pc = parcelRequire("7j0Pc");

var $1bs3X = parcelRequire("1bs3X");

var $d6D31 = parcelRequire("d6D31");
/**
 *
 * @author Sam Harwell
 */ class $3508af691e74fe3f$var$BasicState extends $7j0Pc.ATNState {
    get stateType() {
        return $1bs3X.ATNStateType.BASIC;
    }
}
$3508af691e74fe3f$var$__decorate([
    $d6D31.Override
], $3508af691e74fe3f$var$BasicState.prototype, "stateType", null);
module.exports.BasicState = $3508af691e74fe3f$var$BasicState;

});


parcelRegister("iiE1V", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d528f592a4fe7f4e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d528f592a4fe7f4e$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LL1Analyzer = void 0;

var $fMVaR = parcelRequire("fMVaR");

var $7Veax = parcelRequire("7Veax");

var $gcX0f = parcelRequire("gcX0f");

var $5BPMp = parcelRequire("5BPMp");

var $hGRod = parcelRequire("hGRod");

var $d6D31 = parcelRequire("d6D31");

var $FLEKS = parcelRequire("FLEKS");

var $a4Flx = parcelRequire("a4Flx");

var $8DTT0 = parcelRequire("8DTT0");

var $4kGBm = parcelRequire("4kGBm");

var $aybFP = parcelRequire("aybFP");

var $2DVsz = parcelRequire("2DVsz");

var $aPmi9 = parcelRequire("aPmi9");
let $d528f592a4fe7f4e$var$LL1Analyzer = class LL1Analyzer {
    constructor(atn){
        this.atn = atn;
    }
    /**
     * Calculates the SLL(1) expected lookahead set for each outgoing transition
     * of an {@link ATNState}. The returned array has one element for each
     * outgoing transition in `s`. If the closure from transition
     * *i* leads to a semantic predicate before matching a symbol, the
     * element at index *i* of the result will be `undefined`.
     *
     * @param s the ATN state
     * @returns the expected symbols for each outgoing transition of `s`.
     */ getDecisionLookahead(s) {
        //		System.out.println("LOOK("+s.stateNumber+")");
        if (s == null) return undefined;
        let look = new Array(s.numberOfTransitions);
        for(let alt = 0; alt < s.numberOfTransitions; alt++){
            let current = new $hGRod.IntervalSet();
            look[alt] = current;
            let lookBusy = new $7Veax.Array2DHashSet($a4Flx.ObjectEqualityComparator.INSTANCE);
            let seeThruPreds = false; // fail to get lookahead upon pred
            this._LOOK(s.transition(alt).target, undefined, $8DTT0.PredictionContext.EMPTY_LOCAL, current, lookBusy, new $5BPMp.BitSet(), seeThruPreds, false);
            // Wipe out lookahead for this alternative if we found nothing
            // or we had a predicate when we !seeThruPreds
            if (current.size === 0 || current.contains(LL1Analyzer.HIT_PRED)) {
                current = undefined;
                look[alt] = current;
            }
        }
        return look;
    }
    LOOK(s, ctx, stopState) {
        if (stopState === undefined) {
            if (s.atn == null) throw new Error("Illegal state");
            stopState = s.atn.ruleToStopState[s.ruleIndex];
        } else if (stopState === null) // This is an explicit request to pass undefined as the stopState to _LOOK. Used to distinguish an overload
        // from the method which simply omits the stopState parameter.
        stopState = undefined;
        let r = new $hGRod.IntervalSet();
        let seeThruPreds = true; // ignore preds; get all lookahead
        let addEOF = true;
        this._LOOK(s, stopState, ctx, r, new $7Veax.Array2DHashSet(), new $5BPMp.BitSet(), seeThruPreds, addEOF);
        return r;
    }
    /**
     * Compute set of tokens that can follow `s` in the ATN in the
     * specified `ctx`.
     * <p/>
     * If `ctx` is {@link PredictionContext#EMPTY_LOCAL} and
     * `stopState` or the end of the rule containing `s` is reached,
     * {@link Token#EPSILON} is added to the result set. If `ctx` is not
     * {@link PredictionContext#EMPTY_LOCAL} and `addEOF` is `true`
     * and `stopState` or the end of the outermost rule is reached,
     * {@link Token#EOF} is added to the result set.
     *
     * @param s the ATN state.
     * @param stopState the ATN state to stop at. This can be a
     * {@link BlockEndState} to detect epsilon paths through a closure.
     * @param ctx The outer context, or {@link PredictionContext#EMPTY_LOCAL} if
     * the outer context should not be used.
     * @param look The result lookahead set.
     * @param lookBusy A set used for preventing epsilon closures in the ATN
     * from causing a stack overflow. Outside code should pass
     * `new HashSet<ATNConfig>` for this argument.
     * @param calledRuleStack A set used for preventing left recursion in the
     * ATN from causing a stack overflow. Outside code should pass
     * `new BitSet()` for this argument.
     * @param seeThruPreds `true` to true semantic predicates as
     * implicitly `true` and "see through them", otherwise `false`
     * to treat semantic predicates as opaque and add {@link #HIT_PRED} to the
     * result if one is encountered.
     * @param addEOF Add {@link Token#EOF} to the result if the end of the
     * outermost context is reached. This parameter has no effect if `ctx`
     * is {@link PredictionContext#EMPTY_LOCAL}.
     */ _LOOK(s, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF) {
        //		System.out.println("_LOOK("+s.stateNumber+", ctx="+ctx);
        let c = $gcX0f.ATNConfig.create(s, 0, ctx);
        if (!lookBusy.add(c)) return;
        if (s === stopState) {
            if ($8DTT0.PredictionContext.isEmptyLocal(ctx)) {
                look.add($2DVsz.Token.EPSILON);
                return;
            } else if (ctx.isEmpty) {
                if (addEOF) look.add($2DVsz.Token.EOF);
                return;
            }
        }
        if (s instanceof $4kGBm.RuleStopState) {
            if (ctx.isEmpty && !$8DTT0.PredictionContext.isEmptyLocal(ctx)) {
                if (addEOF) look.add($2DVsz.Token.EOF);
                return;
            }
            let removed = calledRuleStack.get(s.ruleIndex);
            try {
                calledRuleStack.clear(s.ruleIndex);
                for(let i = 0; i < ctx.size; i++){
                    if (ctx.getReturnState(i) === $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) continue;
                    let returnState = this.atn.states[ctx.getReturnState(i)];
                    //					System.out.println("popping back to "+retState);
                    this._LOOK(returnState, stopState, ctx.getParent(i), look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                }
            } finally{
                if (removed) calledRuleStack.set(s.ruleIndex);
            }
        }
        let n = s.numberOfTransitions;
        for(let i = 0; i < n; i++){
            let t = s.transition(i);
            if (t instanceof $aybFP.RuleTransition) {
                if (calledRuleStack.get(t.ruleIndex)) continue;
                let newContext = ctx.getChild(t.followState.stateNumber);
                try {
                    calledRuleStack.set(t.ruleIndex);
                    this._LOOK(t.target, stopState, newContext, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                } finally{
                    calledRuleStack.clear(t.ruleIndex);
                }
            } else if (t instanceof $fMVaR.AbstractPredicateTransition) {
                if (seeThruPreds) this._LOOK(t.target, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                else look.add(LL1Analyzer.HIT_PRED);
            } else if (t.isEpsilon) this._LOOK(t.target, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
            else if (t instanceof $aPmi9.WildcardTransition) look.addAll($hGRod.IntervalSet.of($2DVsz.Token.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType));
            else {
                //				System.out.println("adding "+ t);
                let set = t.label;
                if (set != null) {
                    if (t instanceof $FLEKS.NotSetTransition) set = set.complement($hGRod.IntervalSet.of($2DVsz.Token.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType));
                    look.addAll(set);
                }
            }
        }
    }
};
/** Special value added to the lookahead sets to indicate that we hit
 *  a predicate during analysis if `seeThruPreds==false`.
 */ $d528f592a4fe7f4e$var$LL1Analyzer.HIT_PRED = $2DVsz.Token.INVALID_TYPE;
$d528f592a4fe7f4e$var$__decorate([
    $d6D31.NotNull
], $d528f592a4fe7f4e$var$LL1Analyzer.prototype, "atn", void 0);
$d528f592a4fe7f4e$var$__decorate([
    $d6D31.NotNull,
    $d528f592a4fe7f4e$var$__param(0, $d6D31.NotNull),
    $d528f592a4fe7f4e$var$__param(1, $d6D31.NotNull)
], $d528f592a4fe7f4e$var$LL1Analyzer.prototype, "LOOK", null);
$d528f592a4fe7f4e$var$__decorate([
    $d528f592a4fe7f4e$var$__param(0, $d6D31.NotNull),
    $d528f592a4fe7f4e$var$__param(2, $d6D31.NotNull),
    $d528f592a4fe7f4e$var$__param(3, $d6D31.NotNull),
    $d528f592a4fe7f4e$var$__param(4, $d6D31.NotNull),
    $d528f592a4fe7f4e$var$__param(5, $d6D31.NotNull)
], $d528f592a4fe7f4e$var$LL1Analyzer.prototype, "_LOOK", null);
$d528f592a4fe7f4e$var$LL1Analyzer = $d528f592a4fe7f4e$var$__decorate([
    $d528f592a4fe7f4e$var$__param(0, $d6D31.NotNull)
], $d528f592a4fe7f4e$var$LL1Analyzer);
module.exports.LL1Analyzer = $d528f592a4fe7f4e$var$LL1Analyzer;

});
parcelRegister("FLEKS", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $07d8cc01972b24a7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $07d8cc01972b24a7$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NotSetTransition = void 0;

var $d6D31 = parcelRequire("d6D31");

var $Np2R3 = parcelRequire("Np2R3");
let $07d8cc01972b24a7$var$NotSetTransition = class NotSetTransition extends $Np2R3.SetTransition {
    constructor(target, set){
        super(target, set);
    }
    get serializationType() {
        return 8 /* NOT_SET */ ;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return symbol >= minVocabSymbol && symbol <= maxVocabSymbol && !super.matches(symbol, minVocabSymbol, maxVocabSymbol);
    }
    toString() {
        return "~" + super.toString();
    }
};
$07d8cc01972b24a7$var$__decorate([
    $d6D31.Override
], $07d8cc01972b24a7$var$NotSetTransition.prototype, "serializationType", null);
$07d8cc01972b24a7$var$__decorate([
    $d6D31.Override
], $07d8cc01972b24a7$var$NotSetTransition.prototype, "matches", null);
$07d8cc01972b24a7$var$__decorate([
    $d6D31.Override
], $07d8cc01972b24a7$var$NotSetTransition.prototype, "toString", null);
$07d8cc01972b24a7$var$NotSetTransition = $07d8cc01972b24a7$var$__decorate([
    $07d8cc01972b24a7$var$__param(0, $d6D31.NotNull),
    $07d8cc01972b24a7$var$__param(1, $d6D31.Nullable)
], $07d8cc01972b24a7$var$NotSetTransition);
module.exports.NotSetTransition = $07d8cc01972b24a7$var$NotSetTransition;

});
parcelRegister("Np2R3", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $094801244c2d1a04$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $094801244c2d1a04$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SetTransition = void 0;

var $hGRod = parcelRequire("hGRod");

var $d6D31 = parcelRequire("d6D31");

var $2DVsz = parcelRequire("2DVsz");

var $5tcOQ = parcelRequire("5tcOQ");
/** A transition containing a set of values. */ let $094801244c2d1a04$var$SetTransition = class SetTransition extends $5tcOQ.Transition {
    // TODO (sam): should we really allow undefined here?
    constructor(target, set){
        super(target);
        if (set == null) set = $hGRod.IntervalSet.of($2DVsz.Token.INVALID_TYPE);
        this.set = set;
    }
    get serializationType() {
        return 7 /* SET */ ;
    }
    get label() {
        return this.set;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return this.set.contains(symbol);
    }
    toString() {
        return this.set.toString();
    }
};
$094801244c2d1a04$var$__decorate([
    $d6D31.NotNull
], $094801244c2d1a04$var$SetTransition.prototype, "set", void 0);
$094801244c2d1a04$var$__decorate([
    $d6D31.Override
], $094801244c2d1a04$var$SetTransition.prototype, "serializationType", null);
$094801244c2d1a04$var$__decorate([
    $d6D31.Override,
    $d6D31.NotNull
], $094801244c2d1a04$var$SetTransition.prototype, "label", null);
$094801244c2d1a04$var$__decorate([
    $d6D31.Override
], $094801244c2d1a04$var$SetTransition.prototype, "matches", null);
$094801244c2d1a04$var$__decorate([
    $d6D31.Override,
    $d6D31.NotNull
], $094801244c2d1a04$var$SetTransition.prototype, "toString", null);
$094801244c2d1a04$var$SetTransition = $094801244c2d1a04$var$__decorate([
    $094801244c2d1a04$var$__param(0, $d6D31.NotNull),
    $094801244c2d1a04$var$__param(1, $d6D31.Nullable)
], $094801244c2d1a04$var$SetTransition);
module.exports.SetTransition = $094801244c2d1a04$var$SetTransition;

});


parcelRegister("4kGBm", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $327a1377d5873c46$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleStopState = void 0;

var $7j0Pc = parcelRequire("7j0Pc");

var $1bs3X = parcelRequire("1bs3X");

var $d6D31 = parcelRequire("d6D31");
/** The last node in the ATN for a rule, unless that rule is the start symbol.
 *  In that case, there is one transition to EOF. Later, we might encode
 *  references to all calls to this rule to compute FOLLOW sets for
 *  error handling.
 */ class $327a1377d5873c46$var$RuleStopState extends $7j0Pc.ATNState {
    get nonStopStateNumber() {
        return -1;
    }
    get stateType() {
        return $1bs3X.ATNStateType.RULE_STOP;
    }
}
$327a1377d5873c46$var$__decorate([
    $d6D31.Override
], $327a1377d5873c46$var$RuleStopState.prototype, "nonStopStateNumber", null);
$327a1377d5873c46$var$__decorate([
    $d6D31.Override
], $327a1377d5873c46$var$RuleStopState.prototype, "stateType", null);
module.exports.RuleStopState = $327a1377d5873c46$var$RuleStopState;

});

parcelRegister("aybFP", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7ae622834621fa3c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $7ae622834621fa3c$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleTransition = void 0;

var $d6D31 = parcelRequire("d6D31");

var $5tcOQ = parcelRequire("5tcOQ");
/** */ let $7ae622834621fa3c$var$RuleTransition = class RuleTransition extends $5tcOQ.Transition {
    constructor(ruleStart, ruleIndex, precedence, followState){
        super(ruleStart);
        this.tailCall = false;
        this.optimizedTailCall = false;
        this.ruleIndex = ruleIndex;
        this.precedence = precedence;
        this.followState = followState;
    }
    get serializationType() {
        return 3 /* RULE */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
};
$7ae622834621fa3c$var$__decorate([
    $d6D31.NotNull
], $7ae622834621fa3c$var$RuleTransition.prototype, "followState", void 0);
$7ae622834621fa3c$var$__decorate([
    $d6D31.Override
], $7ae622834621fa3c$var$RuleTransition.prototype, "serializationType", null);
$7ae622834621fa3c$var$__decorate([
    $d6D31.Override
], $7ae622834621fa3c$var$RuleTransition.prototype, "isEpsilon", null);
$7ae622834621fa3c$var$__decorate([
    $d6D31.Override
], $7ae622834621fa3c$var$RuleTransition.prototype, "matches", null);
$7ae622834621fa3c$var$RuleTransition = $7ae622834621fa3c$var$__decorate([
    $7ae622834621fa3c$var$__param(0, $d6D31.NotNull),
    $7ae622834621fa3c$var$__param(3, $d6D31.NotNull)
], $7ae622834621fa3c$var$RuleTransition);
module.exports.RuleTransition = $7ae622834621fa3c$var$RuleTransition;

});

parcelRegister("aPmi9", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7e1ff581bbf7382f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $7e1ff581bbf7382f$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WildcardTransition = void 0;

var $d6D31 = parcelRequire("d6D31");

var $5tcOQ = parcelRequire("5tcOQ");
let $7e1ff581bbf7382f$var$WildcardTransition = class WildcardTransition extends $5tcOQ.Transition {
    constructor(target){
        super(target);
    }
    get serializationType() {
        return 9 /* WILDCARD */ ;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return symbol >= minVocabSymbol && symbol <= maxVocabSymbol;
    }
    toString() {
        return ".";
    }
};
$7e1ff581bbf7382f$var$__decorate([
    $d6D31.Override
], $7e1ff581bbf7382f$var$WildcardTransition.prototype, "serializationType", null);
$7e1ff581bbf7382f$var$__decorate([
    $d6D31.Override
], $7e1ff581bbf7382f$var$WildcardTransition.prototype, "matches", null);
$7e1ff581bbf7382f$var$__decorate([
    $d6D31.Override,
    $d6D31.NotNull
], $7e1ff581bbf7382f$var$WildcardTransition.prototype, "toString", null);
$7e1ff581bbf7382f$var$WildcardTransition = $7e1ff581bbf7382f$var$__decorate([
    $7e1ff581bbf7382f$var$__param(0, $d6D31.NotNull)
], $7e1ff581bbf7382f$var$WildcardTransition);
module.exports.WildcardTransition = $7e1ff581bbf7382f$var$WildcardTransition;

});



parcelRegister("3AYVu", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $29e3fe8db7459e78$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $29e3fe8db7459e78$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerActionExecutor = void 0;

var $3sNxf = parcelRequire("3sNxf");

var $4LVXs = parcelRequire("4LVXs");

var $iXFjm = parcelRequire("iXFjm");

var $d6D31 = parcelRequire("d6D31");
/**
 * Represents an executor for a sequence of lexer actions which traversed during
 * the matching operation of a lexer rule (token).
 *
 * The executor tracks position information for position-dependent lexer actions
 * efficiently, ensuring that actions appearing only at the end of the rule do
 * not cause bloating of the {@link DFA} created for the lexer.
 *
 * @author Sam Harwell
 * @since 4.2
 */ let $29e3fe8db7459e78$var$LexerActionExecutor = class LexerActionExecutor {
    /**
     * Constructs an executor for a sequence of {@link LexerAction} actions.
     * @param lexerActions The lexer actions to execute.
     */ constructor(lexerActions){
        this._lexerActions = lexerActions;
        let hash = $iXFjm.MurmurHash.initialize();
        for (let lexerAction of lexerActions)hash = $iXFjm.MurmurHash.update(hash, lexerAction);
        this.cachedHashCode = $iXFjm.MurmurHash.finish(hash, lexerActions.length);
    }
    /**
     * Creates a {@link LexerActionExecutor} which executes the actions for
     * the input `lexerActionExecutor` followed by a specified
     * `lexerAction`.
     *
     * @param lexerActionExecutor The executor for actions already traversed by
     * the lexer while matching a token within a particular
     * {@link ATNConfig}. If this is `undefined`, the method behaves as though
     * it were an empty executor.
     * @param lexerAction The lexer action to execute after the actions
     * specified in `lexerActionExecutor`.
     *
     * @returns A {@link LexerActionExecutor} for executing the combine actions
     * of `lexerActionExecutor` and `lexerAction`.
     */ static append(lexerActionExecutor, lexerAction) {
        if (!lexerActionExecutor) return new LexerActionExecutor([
            lexerAction
        ]);
        let lexerActions = lexerActionExecutor._lexerActions.slice(0);
        lexerActions.push(lexerAction);
        return new LexerActionExecutor(lexerActions);
    }
    /**
     * Creates a {@link LexerActionExecutor} which encodes the current offset
     * for position-dependent lexer actions.
     *
     * Normally, when the executor encounters lexer actions where
     * {@link LexerAction#isPositionDependent} returns `true`, it calls
     * {@link IntStream#seek} on the input {@link CharStream} to set the input
     * position to the *end* of the current token. This behavior provides
     * for efficient DFA representation of lexer actions which appear at the end
     * of a lexer rule, even when the lexer rule matches a variable number of
     * characters.
     *
     * Prior to traversing a match transition in the ATN, the current offset
     * from the token start index is assigned to all position-dependent lexer
     * actions which have not already been assigned a fixed offset. By storing
     * the offsets relative to the token start index, the DFA representation of
     * lexer actions which appear in the middle of tokens remains efficient due
     * to sharing among tokens of the same length, regardless of their absolute
     * position in the input stream.
     *
     * If the current executor already has offsets assigned to all
     * position-dependent lexer actions, the method returns `this`.
     *
     * @param offset The current offset to assign to all position-dependent
     * lexer actions which do not already have offsets assigned.
     *
     * @returns A {@link LexerActionExecutor} which stores input stream offsets
     * for all position-dependent lexer actions.
     */ fixOffsetBeforeMatch(offset) {
        let updatedLexerActions;
        for(let i = 0; i < this._lexerActions.length; i++)if (this._lexerActions[i].isPositionDependent && !(this._lexerActions[i] instanceof $4LVXs.LexerIndexedCustomAction)) {
            if (!updatedLexerActions) updatedLexerActions = this._lexerActions.slice(0);
            updatedLexerActions[i] = new $4LVXs.LexerIndexedCustomAction(offset, this._lexerActions[i]);
        }
        if (!updatedLexerActions) return this;
        return new LexerActionExecutor(updatedLexerActions);
    }
    /**
     * Gets the lexer actions to be executed by this executor.
     * @returns The lexer actions to be executed by this executor.
     */ get lexerActions() {
        return this._lexerActions;
    }
    /**
     * Execute the actions encapsulated by this executor within the context of a
     * particular {@link Lexer}.
     *
     * This method calls {@link IntStream#seek} to set the position of the
     * `input` {@link CharStream} prior to calling
     * {@link LexerAction#execute} on a position-dependent action. Before the
     * method returns, the input position will be restored to the same position
     * it was in when the method was invoked.
     *
     * @param lexer The lexer instance.
     * @param input The input stream which is the source for the current token.
     * When this method is called, the current {@link IntStream#index} for
     * `input` should be the start of the following token, i.e. 1
     * character past the end of the current token.
     * @param startIndex The token start index. This value may be passed to
     * {@link IntStream#seek} to set the `input` position to the beginning
     * of the token.
     */ execute(lexer, input, startIndex) {
        let requiresSeek = false;
        let stopIndex = input.index;
        try {
            for (let lexerAction of this._lexerActions){
                if (lexerAction instanceof $4LVXs.LexerIndexedCustomAction) {
                    let offset = lexerAction.offset;
                    input.seek(startIndex + offset);
                    lexerAction = lexerAction.action;
                    requiresSeek = startIndex + offset !== stopIndex;
                } else if (lexerAction.isPositionDependent) {
                    input.seek(stopIndex);
                    requiresSeek = false;
                }
                lexerAction.execute(lexer);
            }
        } finally{
            if (requiresSeek) input.seek(stopIndex);
        }
    }
    hashCode() {
        return this.cachedHashCode;
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof LexerActionExecutor)) return false;
        return this.cachedHashCode === obj.cachedHashCode && $3sNxf.ArrayEqualityComparator.INSTANCE.equals(this._lexerActions, obj._lexerActions);
    }
};
$29e3fe8db7459e78$var$__decorate([
    $d6D31.NotNull
], $29e3fe8db7459e78$var$LexerActionExecutor.prototype, "_lexerActions", void 0);
$29e3fe8db7459e78$var$__decorate([
    $d6D31.NotNull
], $29e3fe8db7459e78$var$LexerActionExecutor.prototype, "lexerActions", null);
$29e3fe8db7459e78$var$__decorate([
    $29e3fe8db7459e78$var$__param(0, $d6D31.NotNull)
], $29e3fe8db7459e78$var$LexerActionExecutor.prototype, "execute", null);
$29e3fe8db7459e78$var$__decorate([
    $d6D31.Override
], $29e3fe8db7459e78$var$LexerActionExecutor.prototype, "hashCode", null);
$29e3fe8db7459e78$var$__decorate([
    $d6D31.Override
], $29e3fe8db7459e78$var$LexerActionExecutor.prototype, "equals", null);
$29e3fe8db7459e78$var$__decorate([
    $d6D31.NotNull,
    $29e3fe8db7459e78$var$__param(1, $d6D31.NotNull)
], $29e3fe8db7459e78$var$LexerActionExecutor, "append", null);
$29e3fe8db7459e78$var$LexerActionExecutor = $29e3fe8db7459e78$var$__decorate([
    $29e3fe8db7459e78$var$__param(0, $d6D31.NotNull)
], $29e3fe8db7459e78$var$LexerActionExecutor);
module.exports.LexerActionExecutor = $29e3fe8db7459e78$var$LexerActionExecutor;

});
parcelRegister("4LVXs", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $3798827adeb28bf0$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $3798827adeb28bf0$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerIndexedCustomAction = void 0;

var $iXFjm = parcelRequire("iXFjm");

var $d6D31 = parcelRequire("d6D31");
/**
 * This implementation of {@link LexerAction} is used for tracking input offsets
 * for position-dependent actions within a {@link LexerActionExecutor}.
 *
 * This action is not serialized as part of the ATN, and is only required for
 * position-dependent lexer actions which appear at a location other than the
 * end of a rule. For more information about DFA optimizations employed for
 * lexer actions, see {@link LexerActionExecutor#append} and
 * {@link LexerActionExecutor#fixOffsetBeforeMatch}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ let $3798827adeb28bf0$var$LexerIndexedCustomAction = class LexerIndexedCustomAction {
    /**
     * Constructs a new indexed custom action by associating a character offset
     * with a {@link LexerAction}.
     *
     * Note: This class is only required for lexer actions for which
     * {@link LexerAction#isPositionDependent} returns `true`.
     *
     * @param offset The offset into the input {@link CharStream}, relative to
     * the token start index, at which the specified lexer action should be
     * executed.
     * @param action The lexer action to execute at a particular offset in the
     * input {@link CharStream}.
     */ constructor(offset, action){
        this._offset = offset;
        this._action = action;
    }
    /**
     * Gets the location in the input {@link CharStream} at which the lexer
     * action should be executed. The value is interpreted as an offset relative
     * to the token start index.
     *
     * @returns The location in the input {@link CharStream} at which the lexer
     * action should be executed.
     */ get offset() {
        return this._offset;
    }
    /**
     * Gets the lexer action to execute.
     *
     * @returns A {@link LexerAction} object which executes the lexer action.
     */ get action() {
        return this._action;
    }
    /**
     * {@inheritDoc}
     *
     * @returns This method returns the result of calling {@link #getActionType}
     * on the {@link LexerAction} returned by {@link #getAction}.
     */ get actionType() {
        return this._action.actionType;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `true`.
     */ get isPositionDependent() {
        return true;
    }
    /**
     * {@inheritDoc}
     *
     * This method calls {@link #execute} on the result of {@link #getAction}
     * using the provided `lexer`.
     */ execute(lexer) {
        // assume the input stream position was properly set by the calling code
        this._action.execute(lexer);
    }
    hashCode() {
        let hash = $iXFjm.MurmurHash.initialize();
        hash = $iXFjm.MurmurHash.update(hash, this._offset);
        hash = $iXFjm.MurmurHash.update(hash, this._action);
        return $iXFjm.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof LexerIndexedCustomAction)) return false;
        return this._offset === obj._offset && this._action.equals(obj._action);
    }
};
$3798827adeb28bf0$var$__decorate([
    $d6D31.NotNull
], $3798827adeb28bf0$var$LexerIndexedCustomAction.prototype, "action", null);
$3798827adeb28bf0$var$__decorate([
    $d6D31.Override
], $3798827adeb28bf0$var$LexerIndexedCustomAction.prototype, "actionType", null);
$3798827adeb28bf0$var$__decorate([
    $d6D31.Override
], $3798827adeb28bf0$var$LexerIndexedCustomAction.prototype, "isPositionDependent", null);
$3798827adeb28bf0$var$__decorate([
    $d6D31.Override
], $3798827adeb28bf0$var$LexerIndexedCustomAction.prototype, "execute", null);
$3798827adeb28bf0$var$__decorate([
    $d6D31.Override
], $3798827adeb28bf0$var$LexerIndexedCustomAction.prototype, "hashCode", null);
$3798827adeb28bf0$var$__decorate([
    $d6D31.Override
], $3798827adeb28bf0$var$LexerIndexedCustomAction.prototype, "equals", null);
$3798827adeb28bf0$var$LexerIndexedCustomAction = $3798827adeb28bf0$var$__decorate([
    $3798827adeb28bf0$var$__param(1, $d6D31.NotNull)
], $3798827adeb28bf0$var$LexerIndexedCustomAction);
module.exports.LexerIndexedCustomAction = $3798827adeb28bf0$var$LexerIndexedCustomAction;

});


parcelRegister("fOEQQ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $b83b36c534666cfd$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $b83b36c534666cfd$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerNoViableAltException = void 0;

var $fLdDn = parcelRequire("fLdDn");

var $d6D31 = parcelRequire("d6D31");

var $gcfUE = parcelRequire("gcfUE");

var $2IEP9 = parcelRequire("2IEP9");
let $b83b36c534666cfd$var$LexerNoViableAltException = class LexerNoViableAltException extends $fLdDn.RecognitionException {
    constructor(lexer, input, startIndex, deadEndConfigs){
        super(lexer, input);
        this._startIndex = startIndex;
        this._deadEndConfigs = deadEndConfigs;
    }
    get startIndex() {
        return this._startIndex;
    }
    get deadEndConfigs() {
        return this._deadEndConfigs;
    }
    get inputStream() {
        return super.inputStream;
    }
    toString() {
        let symbol = "";
        if (this._startIndex >= 0 && this._startIndex < this.inputStream.size) {
            symbol = this.inputStream.getText($gcfUE.Interval.of(this._startIndex, this._startIndex));
            symbol = $2IEP9.escapeWhitespace(symbol, false);
        }
        // return String.format(Locale.getDefault(), "%s('%s')", LexerNoViableAltException.class.getSimpleName(), symbol);
        return `LexerNoViableAltException('${symbol}')`;
    }
};
$b83b36c534666cfd$var$__decorate([
    $d6D31.Override
], $b83b36c534666cfd$var$LexerNoViableAltException.prototype, "inputStream", null);
$b83b36c534666cfd$var$__decorate([
    $d6D31.Override
], $b83b36c534666cfd$var$LexerNoViableAltException.prototype, "toString", null);
$b83b36c534666cfd$var$LexerNoViableAltException = $b83b36c534666cfd$var$__decorate([
    $b83b36c534666cfd$var$__param(1, $d6D31.NotNull)
], $b83b36c534666cfd$var$LexerNoViableAltException);
module.exports.LexerNoViableAltException = $b83b36c534666cfd$var$LexerNoViableAltException;

});

parcelRegister("9tIYC", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $6e69b5e962f238b8$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OrderedATNConfigSet = void 0;

var $c1ClW = parcelRequire("c1ClW");

var $d6D31 = parcelRequire("d6D31");
/**
 *
 * @author Sam Harwell
 */ class $6e69b5e962f238b8$var$OrderedATNConfigSet extends $c1ClW.ATNConfigSet {
    constructor(set, readonly){
        if (set != null && readonly != null) super(set, readonly);
        else super();
    }
    clone(readonly) {
        let copy = new $6e69b5e962f238b8$var$OrderedATNConfigSet(this, readonly);
        if (!readonly && this.isReadOnly) copy.addAll(this);
        return copy;
    }
    getKey(e) {
        // This is a specially crafted key to ensure configurations are only merged if they are equal
        return {
            state: 0,
            alt: e.hashCode()
        };
    }
    canMerge(left, leftKey, right) {
        return left.equals(right);
    }
}
$6e69b5e962f238b8$var$__decorate([
    $d6D31.Override
], $6e69b5e962f238b8$var$OrderedATNConfigSet.prototype, "clone", null);
$6e69b5e962f238b8$var$__decorate([
    $d6D31.Override
], $6e69b5e962f238b8$var$OrderedATNConfigSet.prototype, "getKey", null);
$6e69b5e962f238b8$var$__decorate([
    $d6D31.Override
], $6e69b5e962f238b8$var$OrderedATNConfigSet.prototype, "canMerge", null);
module.exports.OrderedATNConfigSet = $6e69b5e962f238b8$var$OrderedATNConfigSet;

});




parcelRegister("hKCjP", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $cec474d99a10f341$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NoViableAltException = void 0;

var $jIG0W = parcelRequire("jIG0W");

var $fLdDn = parcelRequire("fLdDn");

var $d6D31 = parcelRequire("d6D31");
/** Indicates that the parser could not decide which of two or more paths
 *  to take based upon the remaining input. It tracks the starting token
 *  of the offending input and also knows where the parser was
 *  in the various paths when the error. Reported by reportNoViableAlternative()
 */ class $cec474d99a10f341$var$NoViableAltException extends $fLdDn.RecognitionException {
    constructor(recognizer, input, startToken, offendingToken, deadEndConfigs, ctx){
        if (recognizer instanceof $jIG0W.Parser) {
            if (input === undefined) input = recognizer.inputStream;
            if (startToken === undefined) startToken = recognizer.currentToken;
            if (offendingToken === undefined) offendingToken = recognizer.currentToken;
            if (ctx === undefined) ctx = recognizer.context;
        }
        super(recognizer, input, ctx);
        this._deadEndConfigs = deadEndConfigs;
        this._startToken = startToken;
        this.setOffendingToken(recognizer, offendingToken);
    }
    get startToken() {
        return this._startToken;
    }
    get deadEndConfigs() {
        return this._deadEndConfigs;
    }
}
$cec474d99a10f341$var$__decorate([
    $d6D31.NotNull
], $cec474d99a10f341$var$NoViableAltException.prototype, "_startToken", void 0);
module.exports.NoViableAltException = $cec474d99a10f341$var$NoViableAltException;

});
parcelRegister("jIG0W", function(module, exports) {

var $6cAn5 = parcelRequire("6cAn5");
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e5b2b780657df507$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $e5b2b780657df507$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var $e5b2b780657df507$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Parser = void 0;

var $2IEP9 = parcelRequire("2IEP9");

var $2M2qJ = parcelRequire("2M2qJ");

var $dvgsl = parcelRequire("dvgsl");

var $4CCJj = parcelRequire("4CCJj");

var $cdCft = parcelRequire("cdCft");

var $6Kebn = parcelRequire("6Kebn");

var $igNLf = parcelRequire("igNLf");

var $d6D31 = parcelRequire("d6D31");

var $3iOjI = parcelRequire("3iOjI");

var $kzbnL = parcelRequire("kzbnL");

var $5xwgp = parcelRequire("5xwgp");

var $kBaAZ = parcelRequire("kBaAZ");

var $kYC92 = parcelRequire("kYC92");

var $2DVsz = parcelRequire("2DVsz");
class $e5b2b780657df507$var$TraceListener {
    constructor(ruleNames, tokenStream){
        this.ruleNames = ruleNames;
        this.tokenStream = tokenStream;
    }
    enterEveryRule(ctx) {
        console.log("enter   " + this.ruleNames[ctx.ruleIndex] + ", LT(1)=" + this.tokenStream.LT(1).text);
    }
    exitEveryRule(ctx) {
        console.log("exit    " + this.ruleNames[ctx.ruleIndex] + ", LT(1)=" + this.tokenStream.LT(1).text);
    }
    visitErrorNode(node) {
    // intentionally empty
    }
    visitTerminal(node) {
        let parent = node.parent.ruleContext;
        let token = node.symbol;
        console.log("consume " + token + " rule " + this.ruleNames[parent.ruleIndex]);
    }
}
$e5b2b780657df507$var$__decorate([
    $d6D31.Override
], $e5b2b780657df507$var$TraceListener.prototype, "enterEveryRule", null);
$e5b2b780657df507$var$__decorate([
    $d6D31.Override
], $e5b2b780657df507$var$TraceListener.prototype, "exitEveryRule", null);
$e5b2b780657df507$var$__decorate([
    $d6D31.Override
], $e5b2b780657df507$var$TraceListener.prototype, "visitErrorNode", null);
$e5b2b780657df507$var$__decorate([
    $d6D31.Override
], $e5b2b780657df507$var$TraceListener.prototype, "visitTerminal", null);



/** This is all the parsing support code essentially; most of it is error recovery stuff. */ class $e5b2b780657df507$var$Parser extends $kBaAZ.Recognizer {
    constructor(input){
        super();
        /**
         * The error handling strategy for the parser. The default value is a new
         * instance of {@link DefaultErrorStrategy}.
         *
         * @see #getErrorHandler
         * @see #setErrorHandler
         */ this._errHandler = new $4CCJj.DefaultErrorStrategy();
        this._precedenceStack = new $6Kebn.IntegerStack();
        /**
         * Specifies whether or not the parser should construct a parse tree during
         * the parsing process. The default value is `true`.
         *
         * @see `buildParseTree`
         */ this._buildParseTrees = true;
        /**
         * The list of {@link ParseTreeListener} listeners registered to receive
         * events during the parse.
         *
         * @see #addParseListener
         */ this._parseListeners = [];
        /**
         * The number of syntax errors reported during parsing. This value is
         * incremented each time {@link #notifyErrorListeners} is called.
         */ this._syntaxErrors = 0;
        /** Indicates parser has match()ed EOF token. See {@link #exitRule()}. */ this.matchedEOF = false;
        this._precedenceStack.push(0);
        this.inputStream = input;
    }
    reset(resetInput) {
        // Note: this method executes when not parsing, so _ctx can be undefined
        if (resetInput === undefined || resetInput) this.inputStream.seek(0);
        this._errHandler.reset(this);
        this._ctx = undefined;
        this._syntaxErrors = 0;
        this.matchedEOF = false;
        this.isTrace = false;
        this._precedenceStack.clear();
        this._precedenceStack.push(0);
        let interpreter = this.interpreter;
        if (interpreter != null) interpreter.reset();
    }
    /**
     * Match current input symbol against `ttype`. If the symbol type
     * matches, {@link ANTLRErrorStrategy#reportMatch} and {@link #consume} are
     * called to complete the match process.
     *
     * If the symbol type does not match,
     * {@link ANTLRErrorStrategy#recoverInline} is called on the current error
     * strategy to attempt recovery. If {@link #getBuildParseTree} is
     * `true` and the token index of the symbol returned by
     * {@link ANTLRErrorStrategy#recoverInline} is -1, the symbol is added to
     * the parse tree by calling {@link #createErrorNode(ParserRuleContext, Token)} then
     * {@link ParserRuleContext#addErrorNode(ErrorNode)}.
     *
     * @param ttype the token type to match
     * @returns the matched symbol
     * @ if the current input symbol did not match
     * `ttype` and the error strategy could not recover from the
     * mismatched symbol
     */ match(ttype) {
        let t = this.currentToken;
        if (t.type === ttype) {
            if (ttype === $2DVsz.Token.EOF) this.matchedEOF = true;
            this._errHandler.reportMatch(this);
            this.consume();
        } else {
            t = this._errHandler.recoverInline(this);
            if (this._buildParseTrees && t.tokenIndex === -1) // we must have conjured up a new token during single token insertion
            // if it's not the current symbol
            this._ctx.addErrorNode(this.createErrorNode(this._ctx, t));
        }
        return t;
    }
    /**
     * Match current input symbol as a wildcard. If the symbol type matches
     * (i.e. has a value greater than 0), {@link ANTLRErrorStrategy#reportMatch}
     * and {@link #consume} are called to complete the match process.
     *
     * If the symbol type does not match,
     * {@link ANTLRErrorStrategy#recoverInline} is called on the current error
     * strategy to attempt recovery. If {@link #getBuildParseTree} is
     * `true` and the token index of the symbol returned by
     * {@link ANTLRErrorStrategy#recoverInline} is -1, the symbol is added to
     * the parse tree by calling {@link Parser#createErrorNode(ParserRuleContext, Token)} then
     * {@link ParserRuleContext#addErrorNode(ErrorNode)}.
     *
     * @returns the matched symbol
     * @ if the current input symbol did not match
     * a wildcard and the error strategy could not recover from the mismatched
     * symbol
     */ matchWildcard() {
        let t = this.currentToken;
        if (t.type > 0) {
            this._errHandler.reportMatch(this);
            this.consume();
        } else {
            t = this._errHandler.recoverInline(this);
            if (this._buildParseTrees && t.tokenIndex === -1) // we must have conjured up a new token during single token insertion
            // if it's not the current symbol
            this._ctx.addErrorNode(this.createErrorNode(this._ctx, t));
        }
        return t;
    }
    /**
     * Track the {@link ParserRuleContext} objects during the parse and hook
     * them up using the {@link ParserRuleContext#children} list so that it
     * forms a parse tree. The {@link ParserRuleContext} returned from the start
     * rule represents the root of the parse tree.
     *
     * Note that if we are not building parse trees, rule contexts only point
     * upwards. When a rule exits, it returns the context but that gets garbage
     * collected if nobody holds a reference. It points upwards but nobody
     * points at it.
     *
     * When we build parse trees, we are adding all of these contexts to
     * {@link ParserRuleContext#children} list. Contexts are then not candidates
     * for garbage collection.
     */ set buildParseTree(buildParseTrees) {
        this._buildParseTrees = buildParseTrees;
    }
    /**
     * Gets whether or not a complete parse tree will be constructed while
     * parsing. This property is `true` for a newly constructed parser.
     *
     * @returns `true` if a complete parse tree will be constructed while
     * parsing, otherwise `false`
     */ get buildParseTree() {
        return this._buildParseTrees;
    }
    getParseListeners() {
        return this._parseListeners;
    }
    /**
     * Registers `listener` to receive events during the parsing process.
     *
     * To support output-preserving grammar transformations (including but not
     * limited to left-recursion removal, automated left-factoring, and
     * optimized code generation), calls to listener methods during the parse
     * may differ substantially from calls made by
     * {@link ParseTreeWalker#DEFAULT} used after the parse is complete. In
     * particular, rule entry and exit events may occur in a different order
     * during the parse than after the parser. In addition, calls to certain
     * rule entry methods may be omitted.
     *
     * With the following specific exceptions, calls to listener events are
     * *deterministic*, i.e. for identical input the calls to listener
     * methods will be the same.
     *
     * * Alterations to the grammar used to generate code may change the
     *   behavior of the listener calls.
     * * Alterations to the command line options passed to ANTLR 4 when
     *   generating the parser may change the behavior of the listener calls.
     * * Changing the version of the ANTLR Tool used to generate the parser
     *   may change the behavior of the listener calls.
     *
     * @param listener the listener to add
     *
     * @throws {@link TypeError} if `listener` is `undefined`
     */ addParseListener(listener) {
        if (listener == null) throw new TypeError("listener cannot be null");
        this._parseListeners.push(listener);
    }
    /**
     * Remove `listener` from the list of parse listeners.
     *
     * If `listener` is `undefined` or has not been added as a parse
     * listener, this method does nothing.
     *
     * @see #addParseListener
     *
     * @param listener the listener to remove
     */ removeParseListener(listener) {
        let index = this._parseListeners.findIndex((l)=>l === listener);
        if (index !== -1) this._parseListeners.splice(index, 1);
    }
    /**
     * Remove all parse listeners.
     *
     * @see #addParseListener
     */ removeParseListeners() {
        this._parseListeners.length = 0;
    }
    /**
     * Notify any parse listeners of an enter rule event.
     *
     * @see #addParseListener
     */ triggerEnterRuleEvent() {
        for (let listener of this._parseListeners){
            if (listener.enterEveryRule) listener.enterEveryRule(this._ctx);
            this._ctx.enterRule(listener);
        }
    }
    /**
     * Notify any parse listeners of an exit rule event.
     *
     * @see #addParseListener
     */ triggerExitRuleEvent() {
        // reverse order walk of listeners
        for(let i = this._parseListeners.length - 1; i >= 0; i--){
            let listener = this._parseListeners[i];
            this._ctx.exitRule(listener);
            if (listener.exitEveryRule) listener.exitEveryRule(this._ctx);
        }
    }
    /**
     * Gets the number of syntax errors reported during parsing. This value is
     * incremented each time {@link #notifyErrorListeners} is called.
     *
     * @see #notifyErrorListeners
     */ get numberOfSyntaxErrors() {
        return this._syntaxErrors;
    }
    get tokenFactory() {
        return this._input.tokenSource.tokenFactory;
    }
    /**
     * The ATN with bypass alternatives is expensive to create so we create it
     * lazily.
     *
     * @ if the current parser does not
     * implement the `serializedATN` property.
     */ getATNWithBypassAlts() {
        let serializedAtn = this.serializedATN;
        if (serializedAtn == null) throw new Error("The current parser does not support an ATN with bypass alternatives.");
        let result = $e5b2b780657df507$var$Parser.bypassAltsAtnCache.get(serializedAtn);
        if (result == null) {
            let deserializationOptions = new $2M2qJ.ATNDeserializationOptions();
            deserializationOptions.isGenerateRuleBypassTransitions = true;
            result = new $dvgsl.ATNDeserializer(deserializationOptions).deserialize($2IEP9.toCharArray(serializedAtn));
            $e5b2b780657df507$var$Parser.bypassAltsAtnCache.set(serializedAtn, result);
        }
        return result;
    }
    compileParseTreePattern(pattern, patternRuleIndex, lexer) {
        return $e5b2b780657df507$var$__awaiter(this, void 0, void 0, function*() {
            if (!lexer) {
                if (this.inputStream) {
                    let tokenSource = this.inputStream.tokenSource;
                    if (tokenSource instanceof $igNLf.Lexer) lexer = tokenSource;
                }
                if (!lexer) throw new Error("Parser can't discover a lexer to use");
            }
            let currentLexer = lexer;
            let m = yield Promise.resolve().then(()=>(parcelRequire("iC1eN")));
            let matcher = new m.ParseTreePatternMatcher(currentLexer, this);
            return matcher.compile(pattern, patternRuleIndex);
        });
    }
    get errorHandler() {
        return this._errHandler;
    }
    set errorHandler(handler) {
        this._errHandler = handler;
    }
    get inputStream() {
        return this._input;
    }
    /** Set the token stream and reset the parser. */ set inputStream(input) {
        this.reset(false);
        this._input = input;
    }
    /** Match needs to return the current input symbol, which gets put
     *  into the label for the associated token ref; e.g., x=ID.
     */ get currentToken() {
        return this._input.LT(1);
    }
    notifyErrorListeners(msg, offendingToken, e) {
        if (offendingToken === undefined) offendingToken = this.currentToken;
        else if (offendingToken === null) offendingToken = undefined;
        this._syntaxErrors++;
        let line = -1;
        let charPositionInLine = -1;
        if (offendingToken != null) {
            line = offendingToken.line;
            charPositionInLine = offendingToken.charPositionInLine;
        }
        let listener = this.getErrorListenerDispatch();
        if (listener.syntaxError) listener.syntaxError(this, offendingToken, line, charPositionInLine, msg, e);
    }
    /**
     * Consume and return the [current symbol](`currentToken`).
     *
     * E.g., given the following input with `A` being the current
     * lookahead symbol, this function moves the cursor to `B` and returns
     * `A`.
     *
     * ```
     * A B
     * ^
     * ```
     *
     * If the parser is not in error recovery mode, the consumed symbol is added
     * to the parse tree using {@link ParserRuleContext#addChild(TerminalNode)}, and
     * {@link ParseTreeListener#visitTerminal} is called on any parse listeners.
     * If the parser *is* in error recovery mode, the consumed symbol is
     * added to the parse tree using {@link #createErrorNode(ParserRuleContext, Token)} then
     * {@link ParserRuleContext#addErrorNode(ErrorNode)} and
     * {@link ParseTreeListener#visitErrorNode} is called on any parse
     * listeners.
     */ consume() {
        let o = this.currentToken;
        if (o.type !== $e5b2b780657df507$var$Parser.EOF) this.inputStream.consume();
        let hasListener = this._parseListeners.length !== 0;
        if (this._buildParseTrees || hasListener) {
            if (this._errHandler.inErrorRecoveryMode(this)) {
                let node = this._ctx.addErrorNode(this.createErrorNode(this._ctx, o));
                if (hasListener) {
                    for (let listener of this._parseListeners)if (listener.visitErrorNode) listener.visitErrorNode(node);
                }
            } else {
                let node = this.createTerminalNode(this._ctx, o);
                this._ctx.addChild(node);
                if (hasListener) {
                    for (let listener of this._parseListeners)if (listener.visitTerminal) listener.visitTerminal(node);
                }
            }
        }
        return o;
    }
    /**
     * How to create a token leaf node associated with a parent.
     * Typically, the terminal node to create is not a function of the parent.
     *
     * @since 4.7
     */ createTerminalNode(parent, t) {
        return new $kYC92.TerminalNode(t);
    }
    /**
     * How to create an error node, given a token, associated with a parent.
     * Typically, the error node to create is not a function of the parent.
     *
     * @since 4.7
     */ createErrorNode(parent, t) {
        return new $cdCft.ErrorNode(t);
    }
    addContextToParseTree() {
        let parent = this._ctx._parent;
        // add current context to parent if we have a parent
        if (parent != null) parent.addChild(this._ctx);
    }
    /**
     * Always called by generated parsers upon entry to a rule. Access field
     * {@link #_ctx} get the current context.
     */ enterRule(localctx, state, ruleIndex) {
        this.state = state;
        this._ctx = localctx;
        this._ctx._start = this._input.LT(1);
        if (this._buildParseTrees) this.addContextToParseTree();
        this.triggerEnterRuleEvent();
    }
    enterLeftFactoredRule(localctx, state, ruleIndex) {
        this.state = state;
        if (this._buildParseTrees) {
            let factoredContext = this._ctx.getChild(this._ctx.childCount - 1);
            this._ctx.removeLastChild();
            factoredContext._parent = localctx;
            localctx.addChild(factoredContext);
        }
        this._ctx = localctx;
        this._ctx._start = this._input.LT(1);
        if (this._buildParseTrees) this.addContextToParseTree();
        this.triggerEnterRuleEvent();
    }
    exitRule() {
        if (this.matchedEOF) // if we have matched EOF, it cannot consume past EOF so we use LT(1) here
        this._ctx._stop = this._input.LT(1); // LT(1) will be end of file
        else this._ctx._stop = this._input.tryLT(-1); // stop node is what we just matched
        // trigger event on _ctx, before it reverts to parent
        this.triggerExitRuleEvent();
        this.state = this._ctx.invokingState;
        this._ctx = this._ctx._parent;
    }
    enterOuterAlt(localctx, altNum) {
        localctx.altNumber = altNum;
        // if we have new localctx, make sure we replace existing ctx
        // that is previous child of parse tree
        if (this._buildParseTrees && this._ctx !== localctx) {
            let parent = this._ctx._parent;
            if (parent != null) {
                parent.removeLastChild();
                parent.addChild(localctx);
            }
        }
        this._ctx = localctx;
    }
    /**
     * Get the precedence level for the top-most precedence rule.
     *
     * @returns The precedence level for the top-most precedence rule, or -1 if
     * the parser context is not nested within a precedence rule.
     */ get precedence() {
        if (this._precedenceStack.isEmpty) return -1;
        return this._precedenceStack.peek();
    }
    enterRecursionRule(localctx, state, ruleIndex, precedence) {
        this.state = state;
        this._precedenceStack.push(precedence);
        this._ctx = localctx;
        this._ctx._start = this._input.LT(1);
        this.triggerEnterRuleEvent(); // simulates rule entry for left-recursive rules
    }
    /** Like {@link #enterRule} but for recursive rules.
     *  Make the current context the child of the incoming localctx.
     */ pushNewRecursionContext(localctx, state, ruleIndex) {
        let previous = this._ctx;
        previous._parent = localctx;
        previous.invokingState = state;
        previous._stop = this._input.tryLT(-1);
        this._ctx = localctx;
        this._ctx._start = previous._start;
        if (this._buildParseTrees) this._ctx.addChild(previous);
        this.triggerEnterRuleEvent(); // simulates rule entry for left-recursive rules
    }
    unrollRecursionContexts(_parentctx) {
        this._precedenceStack.pop();
        this._ctx._stop = this._input.tryLT(-1);
        let retctx = this._ctx; // save current ctx (return value)
        // unroll so _ctx is as it was before call to recursive method
        if (this._parseListeners.length > 0) while(this._ctx !== _parentctx){
            this.triggerExitRuleEvent();
            this._ctx = this._ctx._parent;
        }
        else this._ctx = _parentctx;
        // hook into tree
        retctx._parent = _parentctx;
        if (this._buildParseTrees && _parentctx != null) // add return ctx into invoking rule's tree
        _parentctx.addChild(retctx);
    }
    getInvokingContext(ruleIndex) {
        let p = this._ctx;
        while(p && p.ruleIndex !== ruleIndex)p = p._parent;
        return p;
    }
    get context() {
        return this._ctx;
    }
    set context(ctx) {
        this._ctx = ctx;
    }
    precpred(localctx, precedence) {
        return precedence >= this._precedenceStack.peek();
    }
    getErrorListenerDispatch() {
        return new $5xwgp.ProxyParserErrorListener(this.getErrorListeners());
    }
    inContext(context) {
        // TODO: useful in parser?
        return false;
    }
    /**
     * Checks whether or not `symbol` can follow the current state in the
     * ATN. The behavior of this method is equivalent to the following, but is
     * implemented such that the complete context-sensitive follow set does not
     * need to be explicitly constructed.
     *
     * ```
     * return getExpectedTokens().contains(symbol);
     * ```
     *
     * @param symbol the symbol type to check
     * @returns `true` if `symbol` can follow the current state in
     * the ATN, otherwise `false`.
     */ isExpectedToken(symbol) {
        //   		return interpreter.atn.nextTokens(_ctx);
        let atn = this.interpreter.atn;
        let ctx = this._ctx;
        let s = atn.states[this.state];
        let following = atn.nextTokens(s);
        if (following.contains(symbol)) return true;
        //        System.out.println("following "+s+"="+following);
        if (!following.contains($2DVsz.Token.EPSILON)) return false;
        while(ctx != null && ctx.invokingState >= 0 && following.contains($2DVsz.Token.EPSILON)){
            let invokingState = atn.states[ctx.invokingState];
            let rt = invokingState.transition(0);
            following = atn.nextTokens(rt.followState);
            if (following.contains(symbol)) return true;
            ctx = ctx._parent;
        }
        if (following.contains($2DVsz.Token.EPSILON) && symbol === $2DVsz.Token.EOF) return true;
        return false;
    }
    get isMatchedEOF() {
        return this.matchedEOF;
    }
    /**
     * Computes the set of input symbols which could follow the current parser
     * state and context, as given by {@link #getState} and {@link #getContext},
     * respectively.
     *
     * @see ATN#getExpectedTokens(int, RuleContext)
     */ getExpectedTokens() {
        return this.atn.getExpectedTokens(this.state, this.context);
    }
    getExpectedTokensWithinCurrentRule() {
        let atn = this.interpreter.atn;
        let s = atn.states[this.state];
        return atn.nextTokens(s);
    }
    /** Get a rule's index (i.e., `RULE_ruleName` field) or -1 if not found. */ getRuleIndex(ruleName) {
        let ruleIndex = this.getRuleIndexMap().get(ruleName);
        if (ruleIndex != null) return ruleIndex;
        return -1;
    }
    get ruleContext() {
        return this._ctx;
    }
    /** Return List&lt;String&gt; of the rule names in your parser instance
     *  leading up to a call to the current rule.  You could override if
     *  you want more details such as the file/line info of where
     *  in the ATN a rule is invoked.
     *
     *  This is very useful for error messages.
     */ getRuleInvocationStack(ctx = this._ctx) {
        let p = ctx; // Workaround for Microsoft/TypeScript#14487
        let ruleNames = this.ruleNames;
        let stack = [];
        while(p != null){
            // compute what follows who invoked us
            let ruleIndex = p.ruleIndex;
            if (ruleIndex < 0) stack.push("n/a");
            else stack.push(ruleNames[ruleIndex]);
            p = p._parent;
        }
        return stack;
    }
    /** For debugging and other purposes. */ getDFAStrings() {
        let s = [];
        for (let dfa of this._interp.atn.decisionToDFA)s.push(dfa.toString(this.vocabulary, this.ruleNames));
        return s;
    }
    /** For debugging and other purposes. */ dumpDFA() {
        let seenOne = false;
        for (let dfa of this._interp.atn.decisionToDFA)if (!dfa.isEmpty) {
            if (seenOne) console.log();
            console.log("Decision " + dfa.decision + ":");
            $6cAn5.stdout.write(dfa.toString(this.vocabulary, this.ruleNames));
            seenOne = true;
        }
    }
    get sourceName() {
        return this._input.sourceName;
    }
    get parseInfo() {
        return Promise.resolve().then(()=>(parcelRequire("5FqoK"))).then((m)=>{
            let interp = this.interpreter;
            if (interp instanceof m.ProfilingATNSimulator) return new $3iOjI.ParseInfo(interp);
            return undefined;
        });
    }
    /**
     * @since 4.3
     */ setProfile(profile) {
        return $e5b2b780657df507$var$__awaiter(this, void 0, void 0, function*() {
            let m = yield Promise.resolve().then(()=>(parcelRequire("5FqoK")));
            let interp = this.interpreter;
            if (profile) {
                if (!(interp instanceof m.ProfilingATNSimulator)) this.interpreter = new m.ProfilingATNSimulator(this);
            } else if (interp instanceof m.ProfilingATNSimulator) this.interpreter = new $kzbnL.ParserATNSimulator(this.atn, this);
            this.interpreter.setPredictionMode(interp.getPredictionMode());
        });
    }
    /** During a parse is sometimes useful to listen in on the rule entry and exit
     *  events as well as token matches. This is for quick and dirty debugging.
     */ set isTrace(trace) {
        if (!trace) {
            if (this._tracer) {
                this.removeParseListener(this._tracer);
                this._tracer = undefined;
            }
        } else {
            if (this._tracer) this.removeParseListener(this._tracer);
            else this._tracer = new $e5b2b780657df507$var$TraceListener(this.ruleNames, this._input);
            this.addParseListener(this._tracer);
        }
    }
    /**
     * Gets whether a {@link TraceListener} is registered as a parse listener
     * for the parser.
     */ get isTrace() {
        return this._tracer != null;
    }
}
/**
 * This field maps from the serialized ATN string to the deserialized {@link ATN} with
 * bypass alternatives.
 *
 * @see ATNDeserializationOptions.isGenerateRuleBypassTransitions
 */ $e5b2b780657df507$var$Parser.bypassAltsAtnCache = new Map();
$e5b2b780657df507$var$__decorate([
    $d6D31.NotNull
], $e5b2b780657df507$var$Parser.prototype, "_errHandler", void 0);
$e5b2b780657df507$var$__decorate([
    $d6D31.NotNull
], $e5b2b780657df507$var$Parser.prototype, "match", null);
$e5b2b780657df507$var$__decorate([
    $d6D31.NotNull
], $e5b2b780657df507$var$Parser.prototype, "matchWildcard", null);
$e5b2b780657df507$var$__decorate([
    $d6D31.NotNull
], $e5b2b780657df507$var$Parser.prototype, "getParseListeners", null);
$e5b2b780657df507$var$__decorate([
    $e5b2b780657df507$var$__param(0, $d6D31.NotNull)
], $e5b2b780657df507$var$Parser.prototype, "addParseListener", null);
$e5b2b780657df507$var$__decorate([
    $d6D31.NotNull
], $e5b2b780657df507$var$Parser.prototype, "getATNWithBypassAlts", null);
$e5b2b780657df507$var$__decorate([
    $d6D31.NotNull,
    $e5b2b780657df507$var$__param(0, $d6D31.NotNull)
], $e5b2b780657df507$var$Parser.prototype, "errorHandler", null);
$e5b2b780657df507$var$__decorate([
    $d6D31.Override
], $e5b2b780657df507$var$Parser.prototype, "inputStream", null);
$e5b2b780657df507$var$__decorate([
    $d6D31.NotNull
], $e5b2b780657df507$var$Parser.prototype, "currentToken", null);
$e5b2b780657df507$var$__decorate([
    $e5b2b780657df507$var$__param(0, $d6D31.NotNull)
], $e5b2b780657df507$var$Parser.prototype, "enterRule", null);
$e5b2b780657df507$var$__decorate([
    $d6D31.Override,
    $e5b2b780657df507$var$__param(0, $d6D31.Nullable)
], $e5b2b780657df507$var$Parser.prototype, "precpred", null);
$e5b2b780657df507$var$__decorate([
    $d6D31.Override
], $e5b2b780657df507$var$Parser.prototype, "getErrorListenerDispatch", null);
$e5b2b780657df507$var$__decorate([
    $d6D31.NotNull
], $e5b2b780657df507$var$Parser.prototype, "getExpectedTokens", null);
$e5b2b780657df507$var$__decorate([
    $d6D31.NotNull
], $e5b2b780657df507$var$Parser.prototype, "getExpectedTokensWithinCurrentRule", null);
$e5b2b780657df507$var$__decorate([
    $d6D31.Override
], $e5b2b780657df507$var$Parser.prototype, "parseInfo", null);
module.exports.Parser = $e5b2b780657df507$var$Parser;

});
parcelRegister("2M2qJ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $2051f30d0c577226$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNDeserializationOptions = void 0;

var $d6D31 = parcelRequire("d6D31");
/**
 *
 * @author Sam Harwell
 */ class $2051f30d0c577226$var$ATNDeserializationOptions {
    constructor(options){
        this.readOnly = false;
        if (options) {
            this.verifyATN = options.verifyATN;
            this.generateRuleBypassTransitions = options.generateRuleBypassTransitions;
            this.optimize = options.optimize;
        } else {
            this.verifyATN = true;
            this.generateRuleBypassTransitions = false;
            this.optimize = true;
        }
    }
    static get defaultOptions() {
        if ($2051f30d0c577226$var$ATNDeserializationOptions._defaultOptions == null) {
            $2051f30d0c577226$var$ATNDeserializationOptions._defaultOptions = new $2051f30d0c577226$var$ATNDeserializationOptions();
            $2051f30d0c577226$var$ATNDeserializationOptions._defaultOptions.makeReadOnly();
        }
        return $2051f30d0c577226$var$ATNDeserializationOptions._defaultOptions;
    }
    get isReadOnly() {
        return this.readOnly;
    }
    makeReadOnly() {
        this.readOnly = true;
    }
    get isVerifyATN() {
        return this.verifyATN;
    }
    set isVerifyATN(verifyATN) {
        this.throwIfReadOnly();
        this.verifyATN = verifyATN;
    }
    get isGenerateRuleBypassTransitions() {
        return this.generateRuleBypassTransitions;
    }
    set isGenerateRuleBypassTransitions(generateRuleBypassTransitions) {
        this.throwIfReadOnly();
        this.generateRuleBypassTransitions = generateRuleBypassTransitions;
    }
    get isOptimize() {
        return this.optimize;
    }
    set isOptimize(optimize) {
        this.throwIfReadOnly();
        this.optimize = optimize;
    }
    throwIfReadOnly() {
        if (this.isReadOnly) throw new Error("The object is read only.");
    }
}
$2051f30d0c577226$var$__decorate([
    $d6D31.NotNull
], $2051f30d0c577226$var$ATNDeserializationOptions, "defaultOptions", null);
module.exports.ATNDeserializationOptions = $2051f30d0c577226$var$ATNDeserializationOptions;

});

parcelRegister("dvgsl", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9d4aef733dce84f9$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9d4aef733dce84f9$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNDeserializer = void 0;

var $gxlfY = parcelRequire("gxlfY");

var $7Veax = parcelRequire("7Veax");

var $bcnvE = parcelRequire("bcnvE");

var $2M2qJ = parcelRequire("2M2qJ");

var $1bs3X = parcelRequire("1bs3X");

var $5r7n7 = parcelRequire("5r7n7");

var $gAm9p = parcelRequire("gAm9p");

var $4yiuQ = parcelRequire("4yiuQ");

var $5BPMp = parcelRequire("5BPMp");

var $loKp0 = parcelRequire("loKp0");

var $65vNG = parcelRequire("65vNG");

var $dPYn6 = parcelRequire("dPYn6");

var $jJRyp = parcelRequire("jJRyp");

var $bpnRH = parcelRequire("bpnRH");

var $hGRod = parcelRequire("hGRod");

var $l4Nh1 = parcelRequire("l4Nh1");

var $iw4Ko = parcelRequire("iw4Ko");

var $RgRAX = parcelRequire("RgRAX");

var $jgJtt = parcelRequire("jgJtt");

var $l606e = parcelRequire("l606e");

var $6hIs4 = parcelRequire("6hIs4");

var $a9nIX = parcelRequire("a9nIX");

var $2Gb96 = parcelRequire("2Gb96");

var $ayRdK = parcelRequire("ayRdK");

var $kfqEk = parcelRequire("kfqEk");

var $d6D31 = parcelRequire("d6D31");

var $FLEKS = parcelRequire("FLEKS");

var $kzbnL = parcelRequire("kzbnL");

var $d1V7w = parcelRequire("d1V7w");

var $7qlbM = parcelRequire("7qlbM");

var $7KGEQ = parcelRequire("7KGEQ");

var $hnaRv = parcelRequire("hnaRv");

var $aISkF = parcelRequire("aISkF");

var $j2zc8 = parcelRequire("j2zc8");

var $4kGBm = parcelRequire("4kGBm");

var $aybFP = parcelRequire("aybFP");

var $Np2R3 = parcelRequire("Np2R3");

var $jEsaF = parcelRequire("jEsaF");

var $bjwd1 = parcelRequire("bjwd1");

var $f9raX = parcelRequire("f9raX");

var $2DVsz = parcelRequire("2DVsz");

var $WS4d7 = parcelRequire("WS4d7");

var $kWxOc = parcelRequire("kWxOc");

var $aPmi9 = parcelRequire("aPmi9");
var $9d4aef733dce84f9$var$UnicodeDeserializingMode;
(function(UnicodeDeserializingMode) {
    UnicodeDeserializingMode[UnicodeDeserializingMode["UNICODE_BMP"] = 0] = "UNICODE_BMP";
    UnicodeDeserializingMode[UnicodeDeserializingMode["UNICODE_SMP"] = 1] = "UNICODE_SMP";
})($9d4aef733dce84f9$var$UnicodeDeserializingMode || ($9d4aef733dce84f9$var$UnicodeDeserializingMode = {}));
/**
 *
 * @author Sam Harwell
 */ class $9d4aef733dce84f9$var$ATNDeserializer {
    constructor(deserializationOptions){
        if (deserializationOptions === undefined) deserializationOptions = $2M2qJ.ATNDeserializationOptions.defaultOptions;
        this.deserializationOptions = deserializationOptions;
    }
    static get SERIALIZED_VERSION() {
        /* This value should never change. Updates following this version are
         * reflected as change in the unique ID SERIALIZED_UUID.
         */ return 3;
    }
    /**
     * Determines if a particular serialized representation of an ATN supports
     * a particular feature, identified by the {@link UUID} used for serializing
     * the ATN at the time the feature was first introduced.
     *
     * @param feature The {@link UUID} marking the first time the feature was
     * supported in the serialized ATN.
     * @param actualUuid The {@link UUID} of the actual serialized ATN which is
     * currently being deserialized.
     * @returns `true` if the `actualUuid` value represents a
     * serialized ATN at or after the feature identified by `feature` was
     * introduced; otherwise, `false`.
     */ static isFeatureSupported(feature, actualUuid) {
        let featureIndex = $9d4aef733dce84f9$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(feature));
        if (featureIndex < 0) return false;
        return $9d4aef733dce84f9$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(actualUuid)) >= featureIndex;
    }
    static getUnicodeDeserializer(mode) {
        if (mode === 0 /* UNICODE_BMP */ ) return {
            readUnicode: (data, p)=>{
                return $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p]);
            },
            size: 1
        };
        else return {
            readUnicode: (data, p)=>{
                return $9d4aef733dce84f9$var$ATNDeserializer.toInt32(data, p);
            },
            size: 2
        };
    }
    deserialize(data) {
        data = data.slice(0);
        // Each Uint16 value in data is shifted by +2 at the entry to this method. This is an encoding optimization
        // targeting the serialized values 0 and -1 (serialized to 0xFFFF), each of which are very common in the
        // serialized form of the ATN. In the modified UTF-8 that Java uses for compiled string literals, these two
        // character values have multi-byte forms. By shifting each value by +2, they become characters 2 and 1 prior to
        // writing the string, each of which have single-byte representations. Since the shift occurs in the tool during
        // ATN serialization, each target is responsible for adjusting the values during deserialization.
        //
        // As a special case, note that the first element of data is not adjusted because it contains the major version
        // number of the serialized ATN, which was fixed at 3 at the time the value shifting was implemented.
        for(let i = 1; i < data.length; i++)data[i] = data[i] - 2 & 0xFFFF;
        let p = 0;
        let version = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
        if (version !== $9d4aef733dce84f9$var$ATNDeserializer.SERIALIZED_VERSION) {
            let reason = `Could not deserialize ATN with version ${version} (expected ${$9d4aef733dce84f9$var$ATNDeserializer.SERIALIZED_VERSION}).`;
            throw new Error(reason);
        }
        let uuid = $9d4aef733dce84f9$var$ATNDeserializer.toUUID(data, p);
        p += 8;
        if ($9d4aef733dce84f9$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(uuid)) < 0) {
            let reason = `Could not deserialize ATN with UUID ${uuid} (expected ${$9d4aef733dce84f9$var$ATNDeserializer.SERIALIZED_UUID} or a legacy UUID).`;
            throw new Error(reason);
        }
        let supportsLexerActions = $9d4aef733dce84f9$var$ATNDeserializer.isFeatureSupported($9d4aef733dce84f9$var$ATNDeserializer.ADDED_LEXER_ACTIONS, uuid);
        let grammarType = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
        let maxTokenType = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
        let atn = new $bcnvE.ATN(grammarType, maxTokenType);
        //
        // STATES
        //
        let loopBackStateNumbers = [];
        let endStateNumbers = [];
        let nstates = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nstates; i++){
            let stype = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            // ignore bad type of states
            if (stype === $1bs3X.ATNStateType.INVALID_TYPE) {
                atn.addState(new $l4Nh1.InvalidState());
                continue;
            }
            let ruleIndex = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            if (ruleIndex === 0xFFFF) ruleIndex = -1;
            let s = this.stateFactory(stype, ruleIndex);
            if (stype === $1bs3X.ATNStateType.LOOP_END) {
                let loopBackStateNumber = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                loopBackStateNumbers.push([
                    s,
                    loopBackStateNumber
                ]);
            } else if (s instanceof $65vNG.BlockStartState) {
                let endStateNumber = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                endStateNumbers.push([
                    s,
                    endStateNumber
                ]);
            }
            atn.addState(s);
        }
        // delay the assignment of loop back and end states until we know all the state instances have been initialized
        for (let pair of loopBackStateNumbers)pair[0].loopBackState = atn.states[pair[1]];
        for (let pair of endStateNumbers)pair[0].endState = atn.states[pair[1]];
        let numNonGreedyStates = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < numNonGreedyStates; i++){
            let stateNumber = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            atn.states[stateNumber].nonGreedy = true;
        }
        let numSllDecisions = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < numSllDecisions; i++){
            let stateNumber = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            atn.states[stateNumber].sll = true;
        }
        let numPrecedenceStates = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < numPrecedenceStates; i++){
            let stateNumber = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            atn.states[stateNumber].isPrecedenceRule = true;
        }
        //
        // RULES
        //
        let nrules = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
        if (atn.grammarType === 0 /* LEXER */ ) atn.ruleToTokenType = new Int32Array(nrules);
        atn.ruleToStartState = new Array(nrules);
        for(let i = 0; i < nrules; i++){
            let s = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            let startState = atn.states[s];
            startState.leftFactored = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]) !== 0;
            atn.ruleToStartState[i] = startState;
            if (atn.grammarType === 0 /* LEXER */ ) {
                let tokenType = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                if (tokenType === 0xFFFF) tokenType = $2DVsz.Token.EOF;
                atn.ruleToTokenType[i] = tokenType;
                if (!$9d4aef733dce84f9$var$ATNDeserializer.isFeatureSupported($9d4aef733dce84f9$var$ATNDeserializer.ADDED_LEXER_ACTIONS, uuid)) {
                    // this piece of unused metadata was serialized prior to the
                    // addition of LexerAction
                    let actionIndexIgnored = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                    if (actionIndexIgnored === 0xFFFF) actionIndexIgnored = -1;
                }
            }
        }
        atn.ruleToStopState = new Array(nrules);
        for (let state of atn.states){
            if (!(state instanceof $4kGBm.RuleStopState)) continue;
            atn.ruleToStopState[state.ruleIndex] = state;
            atn.ruleToStartState[state.ruleIndex].stopState = state;
        }
        //
        // MODES
        //
        let nmodes = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nmodes; i++){
            let s = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            atn.modeToStartState.push(atn.states[s]);
        }
        atn.modeToDFA = new Array(nmodes);
        for(let i = 0; i < nmodes; i++)atn.modeToDFA[i] = new $jJRyp.DFA(atn.modeToStartState[i]);
        //
        // SETS
        //
        let sets = [];
        // First, read all sets with 16-bit Unicode code points <= U+FFFF.
        p = this.deserializeSets(data, p, sets, $9d4aef733dce84f9$var$ATNDeserializer.getUnicodeDeserializer(0 /* UNICODE_BMP */ ));
        // Next, if the ATN was serialized with the Unicode SMP feature,
        // deserialize sets with 32-bit arguments <= U+10FFFF.
        if ($9d4aef733dce84f9$var$ATNDeserializer.isFeatureSupported($9d4aef733dce84f9$var$ATNDeserializer.ADDED_UNICODE_SMP, uuid)) p = this.deserializeSets(data, p, sets, $9d4aef733dce84f9$var$ATNDeserializer.getUnicodeDeserializer(1 /* UNICODE_SMP */ ));
        //
        // EDGES
        //
        let nedges = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nedges; i++){
            let src = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p]);
            let trg = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p + 1]);
            let ttype = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p + 2]);
            let arg1 = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p + 3]);
            let arg2 = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p + 4]);
            let arg3 = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p + 5]);
            let trans = this.edgeFactory(atn, ttype, src, trg, arg1, arg2, arg3, sets);
            // console.log(`EDGE ${trans.constructor.name} ${src}->${trg} ${Transition.serializationNames[ttype]} ${arg1},${arg2},${arg3}`);
            let srcState = atn.states[src];
            srcState.addTransition(trans);
            p += 6;
        }
        let returnTransitionsSet = new $7Veax.Array2DHashSet({
            hashCode: (o)=>o.stopState ^ o.returnState ^ o.outermostPrecedenceReturn,
            equals: (a, b)=>{
                return a.stopState === b.stopState && a.returnState === b.returnState && a.outermostPrecedenceReturn === b.outermostPrecedenceReturn;
            }
        });
        let returnTransitions = [];
        for (let state of atn.states){
            let returningToLeftFactored = state.ruleIndex >= 0 && atn.ruleToStartState[state.ruleIndex].leftFactored;
            for(let i = 0; i < state.numberOfTransitions; i++){
                let t = state.transition(i);
                if (!(t instanceof $aybFP.RuleTransition)) continue;
                let ruleTransition = t;
                let returningFromLeftFactored = atn.ruleToStartState[ruleTransition.target.ruleIndex].leftFactored;
                if (!returningFromLeftFactored && returningToLeftFactored) continue;
                let outermostPrecedenceReturn = -1;
                if (atn.ruleToStartState[ruleTransition.target.ruleIndex].isPrecedenceRule) {
                    if (ruleTransition.precedence === 0) outermostPrecedenceReturn = ruleTransition.target.ruleIndex;
                }
                let current = {
                    stopState: ruleTransition.target.ruleIndex,
                    returnState: ruleTransition.followState.stateNumber,
                    outermostPrecedenceReturn: outermostPrecedenceReturn
                };
                if (returnTransitionsSet.add(current)) returnTransitions.push(current);
            }
        }
        // Add all elements from returnTransitions to the ATN
        for (let returnTransition of returnTransitions){
            let transition = new $bpnRH.EpsilonTransition(atn.states[returnTransition.returnState], returnTransition.outermostPrecedenceReturn);
            atn.ruleToStopState[returnTransition.stopState].addTransition(transition);
        }
        for (let state of atn.states){
            if (state instanceof $65vNG.BlockStartState) {
                // we need to know the end state to set its start state
                if (state.endState === undefined) throw new Error("IllegalStateException");
                // block end states can only be associated to a single block start state
                if (state.endState.startState !== undefined) throw new Error("IllegalStateException");
                state.endState.startState = state;
            }
            if (state instanceof $7qlbM.PlusLoopbackState) {
                let loopbackState = state;
                for(let i = 0; i < loopbackState.numberOfTransitions; i++){
                    let target = loopbackState.transition(i).target;
                    if (target instanceof $d1V7w.PlusBlockStartState) target.loopBackState = loopbackState;
                }
            } else if (state instanceof $bjwd1.StarLoopbackState) {
                let loopbackState = state;
                for(let i = 0; i < loopbackState.numberOfTransitions; i++){
                    let target = loopbackState.transition(i).target;
                    if (target instanceof $f9raX.StarLoopEntryState) target.loopBackState = loopbackState;
                }
            }
        }
        //
        // DECISIONS
        //
        let ndecisions = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 1; i <= ndecisions; i++){
            let s = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            let decState = atn.states[s];
            atn.decisionToState.push(decState);
            decState.decision = i - 1;
        }
        //
        // LEXER ACTIONS
        //
        if (atn.grammarType === 0 /* LEXER */ ) {
            if (supportsLexerActions) {
                atn.lexerActions = new Array($9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]));
                for(let i = 0; i < atn.lexerActions.length; i++){
                    let actionType = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                    let data1 = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                    if (data1 === 0xFFFF) data1 = -1;
                    let data2 = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                    if (data2 === 0xFFFF) data2 = -1;
                    let lexerAction = this.lexerActionFactory(actionType, data1, data2);
                    atn.lexerActions[i] = lexerAction;
                }
            } else {
                // for compatibility with older serialized ATNs, convert the old
                // serialized action index for action transitions to the new
                // form, which is the index of a LexerCustomAction
                let legacyLexerActions = [];
                for (let state of atn.states)for(let i = 0; i < state.numberOfTransitions; i++){
                    let transition = state.transition(i);
                    if (!(transition instanceof $gxlfY.ActionTransition)) continue;
                    let ruleIndex = transition.ruleIndex;
                    let actionIndex = transition.actionIndex;
                    let lexerAction = new $RgRAX.LexerCustomAction(ruleIndex, actionIndex);
                    state.setTransition(i, new $gxlfY.ActionTransition(transition.target, ruleIndex, legacyLexerActions.length, false));
                    legacyLexerActions.push(lexerAction);
                }
                atn.lexerActions = legacyLexerActions;
            }
        }
        this.markPrecedenceDecisions(atn);
        atn.decisionToDFA = new Array(ndecisions);
        for(let i = 0; i < ndecisions; i++)atn.decisionToDFA[i] = new $jJRyp.DFA(atn.decisionToState[i], i);
        if (this.deserializationOptions.isVerifyATN) this.verifyATN(atn);
        if (this.deserializationOptions.isGenerateRuleBypassTransitions && atn.grammarType === 1 /* PARSER */ ) {
            atn.ruleToTokenType = new Int32Array(atn.ruleToStartState.length);
            for(let i = 0; i < atn.ruleToStartState.length; i++)atn.ruleToTokenType[i] = atn.maxTokenType + i + 1;
            for(let i = 0; i < atn.ruleToStartState.length; i++){
                let bypassStart = new $gAm9p.BasicBlockStartState();
                bypassStart.ruleIndex = i;
                atn.addState(bypassStart);
                let bypassStop = new $loKp0.BlockEndState();
                bypassStop.ruleIndex = i;
                atn.addState(bypassStop);
                bypassStart.endState = bypassStop;
                atn.defineDecisionState(bypassStart);
                bypassStop.startState = bypassStart;
                let endState;
                let excludeTransition;
                if (atn.ruleToStartState[i].isPrecedenceRule) {
                    // wrap from the beginning of the rule to the StarLoopEntryState
                    endState = undefined;
                    for (let state of atn.states){
                        if (state.ruleIndex !== i) continue;
                        if (!(state instanceof $f9raX.StarLoopEntryState)) continue;
                        let maybeLoopEndState = state.transition(state.numberOfTransitions - 1).target;
                        if (!(maybeLoopEndState instanceof $kfqEk.LoopEndState)) continue;
                        if (maybeLoopEndState.epsilonOnlyTransitions && maybeLoopEndState.transition(0).target instanceof $4kGBm.RuleStopState) {
                            endState = state;
                            break;
                        }
                    }
                    if (!endState) throw new Error("Couldn't identify final state of the precedence rule prefix section.");
                    excludeTransition = endState.loopBackState.transition(0);
                } else endState = atn.ruleToStopState[i];
                // all non-excluded transitions that currently target end state need to target blockEnd instead
                for (let state of atn.states)for(let i = 0; i < state.numberOfTransitions; i++){
                    let transition = state.transition(i);
                    if (transition === excludeTransition) continue;
                    if (transition.target === endState) transition.target = bypassStop;
                }
                // all transitions leaving the rule start state need to leave blockStart instead
                while(atn.ruleToStartState[i].numberOfTransitions > 0){
                    let transition = atn.ruleToStartState[i].removeTransition(atn.ruleToStartState[i].numberOfTransitions - 1);
                    bypassStart.addTransition(transition);
                }
                // link the new states
                atn.ruleToStartState[i].addTransition(new $bpnRH.EpsilonTransition(bypassStart));
                bypassStop.addTransition(new $bpnRH.EpsilonTransition(endState));
                let matchState = new $4yiuQ.BasicState();
                atn.addState(matchState);
                matchState.addTransition(new $5r7n7.AtomTransition(bypassStop, atn.ruleToTokenType[i]));
                bypassStart.addTransition(new $bpnRH.EpsilonTransition(matchState));
            }
            if (this.deserializationOptions.isVerifyATN) // reverify after modification
            this.verifyATN(atn);
        }
        if (this.deserializationOptions.isOptimize) {
            while(true){
                let optimizationCount = 0;
                optimizationCount += $9d4aef733dce84f9$var$ATNDeserializer.inlineSetRules(atn);
                optimizationCount += $9d4aef733dce84f9$var$ATNDeserializer.combineChainedEpsilons(atn);
                let preserveOrder = atn.grammarType === 0 /* LEXER */ ;
                optimizationCount += $9d4aef733dce84f9$var$ATNDeserializer.optimizeSets(atn, preserveOrder);
                if (optimizationCount === 0) break;
            }
            if (this.deserializationOptions.isVerifyATN) // reverify after modification
            this.verifyATN(atn);
        }
        $9d4aef733dce84f9$var$ATNDeserializer.identifyTailCalls(atn);
        return atn;
    }
    deserializeSets(data, p, sets, unicodeDeserializer) {
        let nsets = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nsets; i++){
            let nintervals = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p]);
            p++;
            let set = new $hGRod.IntervalSet();
            sets.push(set);
            let containsEof = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]) !== 0;
            if (containsEof) set.add(-1);
            for(let j = 0; j < nintervals; j++){
                let a = unicodeDeserializer.readUnicode(data, p);
                p += unicodeDeserializer.size;
                let b = unicodeDeserializer.readUnicode(data, p);
                p += unicodeDeserializer.size;
                set.add(a, b);
            }
        }
        return p;
    }
    /**
     * Analyze the {@link StarLoopEntryState} states in the specified ATN to set
     * the {@link StarLoopEntryState#precedenceRuleDecision} field to the
     * correct value.
     *
     * @param atn The ATN.
     */ markPrecedenceDecisions(atn) {
        // Map rule index -> precedence decision for that rule
        let rulePrecedenceDecisions = new Map();
        for (let state of atn.states){
            if (!(state instanceof $f9raX.StarLoopEntryState)) continue;
            /* We analyze the ATN to determine if this ATN decision state is the
             * decision for the closure block that determines whether a
             * precedence rule should continue or complete.
             */ if (atn.ruleToStartState[state.ruleIndex].isPrecedenceRule) {
                let maybeLoopEndState = state.transition(state.numberOfTransitions - 1).target;
                if (maybeLoopEndState instanceof $kfqEk.LoopEndState) {
                    if (maybeLoopEndState.epsilonOnlyTransitions && maybeLoopEndState.transition(0).target instanceof $4kGBm.RuleStopState) {
                        rulePrecedenceDecisions.set(state.ruleIndex, state);
                        state.precedenceRuleDecision = true;
                        state.precedenceLoopbackStates = new $5BPMp.BitSet(atn.states.length);
                    }
                }
            }
        }
        // After marking precedence decisions, we go back through and fill in
        // StarLoopEntryState.precedenceLoopbackStates.
        for (let precedenceDecision of rulePrecedenceDecisions)for (let transition of atn.ruleToStopState[precedenceDecision[0]].getTransitions()){
            if (transition.serializationType !== 1 /* EPSILON */ ) continue;
            let epsilonTransition = transition;
            if (epsilonTransition.outermostPrecedenceReturn !== -1) continue;
            precedenceDecision[1].precedenceLoopbackStates.set(transition.target.stateNumber);
        }
    }
    verifyATN(atn) {
        // verify assumptions
        for (let state of atn.states){
            this.checkCondition(state !== undefined, "ATN states should not be undefined.");
            if (state.stateType === $1bs3X.ATNStateType.INVALID_TYPE) continue;
            this.checkCondition(state.onlyHasEpsilonTransitions || state.numberOfTransitions <= 1);
            if (state instanceof $d1V7w.PlusBlockStartState) this.checkCondition(state.loopBackState !== undefined);
            if (state instanceof $f9raX.StarLoopEntryState) {
                let starLoopEntryState = state;
                this.checkCondition(starLoopEntryState.loopBackState !== undefined);
                this.checkCondition(starLoopEntryState.numberOfTransitions === 2);
                if (starLoopEntryState.transition(0).target instanceof $jEsaF.StarBlockStartState) {
                    this.checkCondition(starLoopEntryState.transition(1).target instanceof $kfqEk.LoopEndState);
                    this.checkCondition(!starLoopEntryState.nonGreedy);
                } else if (starLoopEntryState.transition(0).target instanceof $kfqEk.LoopEndState) {
                    this.checkCondition(starLoopEntryState.transition(1).target instanceof $jEsaF.StarBlockStartState);
                    this.checkCondition(starLoopEntryState.nonGreedy);
                } else throw new Error("IllegalStateException");
            }
            if (state instanceof $bjwd1.StarLoopbackState) {
                this.checkCondition(state.numberOfTransitions === 1);
                this.checkCondition(state.transition(0).target instanceof $f9raX.StarLoopEntryState);
            }
            if (state instanceof $kfqEk.LoopEndState) this.checkCondition(state.loopBackState !== undefined);
            if (state instanceof $j2zc8.RuleStartState) this.checkCondition(state.stopState !== undefined);
            if (state instanceof $65vNG.BlockStartState) this.checkCondition(state.endState !== undefined);
            if (state instanceof $loKp0.BlockEndState) this.checkCondition(state.startState !== undefined);
            if (state instanceof $dPYn6.DecisionState) {
                let decisionState = state;
                this.checkCondition(decisionState.numberOfTransitions <= 1 || decisionState.decision >= 0);
            } else this.checkCondition(state.numberOfTransitions <= 1 || state instanceof $4kGBm.RuleStopState);
        }
    }
    checkCondition(condition, message) {
        if (!condition) throw new Error("IllegalStateException: " + message);
    }
    static inlineSetRules(atn) {
        let inlinedCalls = 0;
        let ruleToInlineTransition = new Array(atn.ruleToStartState.length);
        for(let i = 0; i < atn.ruleToStartState.length; i++){
            let startState = atn.ruleToStartState[i];
            let middleState = startState;
            while(middleState.onlyHasEpsilonTransitions && middleState.numberOfOptimizedTransitions === 1 && middleState.getOptimizedTransition(0).serializationType === 1 /* EPSILON */ )middleState = middleState.getOptimizedTransition(0).target;
            if (middleState.numberOfOptimizedTransitions !== 1) continue;
            let matchTransition = middleState.getOptimizedTransition(0);
            let matchTarget = matchTransition.target;
            if (matchTransition.isEpsilon || !matchTarget.onlyHasEpsilonTransitions || matchTarget.numberOfOptimizedTransitions !== 1 || !(matchTarget.getOptimizedTransition(0).target instanceof $4kGBm.RuleStopState)) continue;
            switch(matchTransition.serializationType){
                case 5 /* ATOM */ :
                case 2 /* RANGE */ :
                case 7 /* SET */ :
                    ruleToInlineTransition[i] = matchTransition;
                    break;
                case 8 /* NOT_SET */ :
                case 9 /* WILDCARD */ :
                    continue;
                default:
                    continue;
            }
        }
        for (let state of atn.states){
            if (state.ruleIndex < 0) continue;
            let optimizedTransitions;
            for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                let transition = state.getOptimizedTransition(i);
                if (!(transition instanceof $aybFP.RuleTransition)) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue;
                }
                let ruleTransition = transition;
                let effective = ruleToInlineTransition[ruleTransition.target.ruleIndex];
                if (effective === undefined) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue;
                }
                if (optimizedTransitions === undefined) {
                    optimizedTransitions = [];
                    for(let j = 0; j < i; j++)optimizedTransitions.push(state.getOptimizedTransition(i));
                }
                inlinedCalls++;
                let target = ruleTransition.followState;
                let intermediateState = new $4yiuQ.BasicState();
                intermediateState.setRuleIndex(target.ruleIndex);
                atn.addState(intermediateState);
                optimizedTransitions.push(new $bpnRH.EpsilonTransition(intermediateState));
                switch(effective.serializationType){
                    case 5 /* ATOM */ :
                        intermediateState.addTransition(new $5r7n7.AtomTransition(target, effective._label));
                        break;
                    case 2 /* RANGE */ :
                        intermediateState.addTransition(new $aISkF.RangeTransition(target, effective.from, effective.to));
                        break;
                    case 7 /* SET */ :
                        intermediateState.addTransition(new $Np2R3.SetTransition(target, effective.label));
                        break;
                    default:
                        throw new Error("UnsupportedOperationException");
                }
            }
            if (optimizedTransitions !== undefined) {
                if (state.isOptimized) while(state.numberOfOptimizedTransitions > 0)state.removeOptimizedTransition(state.numberOfOptimizedTransitions - 1);
                for (let transition of optimizedTransitions)state.addOptimizedTransition(transition);
            }
        }
        if ($kzbnL.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + inlinedCalls + " rule invocations by inlining sets.");
        return inlinedCalls;
    }
    static combineChainedEpsilons(atn) {
        let removedEdges = 0;
        for (let state of atn.states){
            if (!state.onlyHasEpsilonTransitions || state instanceof $4kGBm.RuleStopState) continue;
            let optimizedTransitions;
            nextTransition: for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                let transition = state.getOptimizedTransition(i);
                let intermediate = transition.target;
                if (transition.serializationType !== 1 /* EPSILON */  || transition.outermostPrecedenceReturn !== -1 || intermediate.stateType !== $1bs3X.ATNStateType.BASIC || !intermediate.onlyHasEpsilonTransitions) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue nextTransition;
                }
                for(let j = 0; j < intermediate.numberOfOptimizedTransitions; j++)if (intermediate.getOptimizedTransition(j).serializationType !== 1 /* EPSILON */  || intermediate.getOptimizedTransition(j).outermostPrecedenceReturn !== -1) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue nextTransition;
                }
                removedEdges++;
                if (optimizedTransitions === undefined) {
                    optimizedTransitions = [];
                    for(let j = 0; j < i; j++)optimizedTransitions.push(state.getOptimizedTransition(j));
                }
                for(let j = 0; j < intermediate.numberOfOptimizedTransitions; j++){
                    let target = intermediate.getOptimizedTransition(j).target;
                    optimizedTransitions.push(new $bpnRH.EpsilonTransition(target));
                }
            }
            if (optimizedTransitions !== undefined) {
                if (state.isOptimized) while(state.numberOfOptimizedTransitions > 0)state.removeOptimizedTransition(state.numberOfOptimizedTransitions - 1);
                for (let transition of optimizedTransitions)state.addOptimizedTransition(transition);
            }
        }
        if ($kzbnL.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + removedEdges + " transitions by combining chained epsilon transitions.");
        return removedEdges;
    }
    static optimizeSets(atn, preserveOrder) {
        if (preserveOrder) // this optimization currently doesn't preserve edge order.
        return 0;
        let removedPaths = 0;
        let decisions = atn.decisionToState;
        for (let decision of decisions){
            let setTransitions = new $hGRod.IntervalSet();
            for(let i = 0; i < decision.numberOfOptimizedTransitions; i++){
                let epsTransition = decision.getOptimizedTransition(i);
                if (!(epsTransition instanceof $bpnRH.EpsilonTransition)) continue;
                if (epsTransition.target.numberOfOptimizedTransitions !== 1) continue;
                let transition = epsTransition.target.getOptimizedTransition(0);
                if (!(transition.target instanceof $loKp0.BlockEndState)) continue;
                if (transition instanceof $FLEKS.NotSetTransition) continue;
                if (transition instanceof $5r7n7.AtomTransition || transition instanceof $aISkF.RangeTransition || transition instanceof $Np2R3.SetTransition) setTransitions.add(i);
            }
            if (setTransitions.size <= 1) continue;
            let optimizedTransitions = [];
            for(let i = 0; i < decision.numberOfOptimizedTransitions; i++)if (!setTransitions.contains(i)) optimizedTransitions.push(decision.getOptimizedTransition(i));
            let blockEndState = decision.getOptimizedTransition(setTransitions.minElement).target.getOptimizedTransition(0).target;
            let matchSet = new $hGRod.IntervalSet();
            for (let interval of setTransitions.intervals)for(let j = interval.a; j <= interval.b; j++){
                let matchTransition = decision.getOptimizedTransition(j).target.getOptimizedTransition(0);
                if (matchTransition instanceof $FLEKS.NotSetTransition) throw new Error("Not yet implemented.");
                else matchSet.addAll(matchTransition.label);
            }
            let newTransition;
            if (matchSet.intervals.length === 1) {
                if (matchSet.size === 1) newTransition = new $5r7n7.AtomTransition(blockEndState, matchSet.minElement);
                else {
                    let matchInterval = matchSet.intervals[0];
                    newTransition = new $aISkF.RangeTransition(blockEndState, matchInterval.a, matchInterval.b);
                }
            } else newTransition = new $Np2R3.SetTransition(blockEndState, matchSet);
            let setOptimizedState = new $4yiuQ.BasicState();
            setOptimizedState.setRuleIndex(decision.ruleIndex);
            atn.addState(setOptimizedState);
            setOptimizedState.addTransition(newTransition);
            optimizedTransitions.push(new $bpnRH.EpsilonTransition(setOptimizedState));
            removedPaths += decision.numberOfOptimizedTransitions - optimizedTransitions.length;
            if (decision.isOptimized) while(decision.numberOfOptimizedTransitions > 0)decision.removeOptimizedTransition(decision.numberOfOptimizedTransitions - 1);
            for (let transition of optimizedTransitions)decision.addOptimizedTransition(transition);
        }
        if ($kzbnL.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + removedPaths + " paths by collapsing sets.");
        return removedPaths;
    }
    static identifyTailCalls(atn) {
        for (let state of atn.states){
            for(let i = 0; i < state.numberOfTransitions; i++){
                let transition = state.transition(i);
                if (!(transition instanceof $aybFP.RuleTransition)) continue;
                transition.tailCall = this.testTailCall(atn, transition, false);
                transition.optimizedTailCall = this.testTailCall(atn, transition, true);
            }
            if (!state.isOptimized) continue;
            for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                let transition = state.getOptimizedTransition(i);
                if (!(transition instanceof $aybFP.RuleTransition)) continue;
                transition.tailCall = this.testTailCall(atn, transition, false);
                transition.optimizedTailCall = this.testTailCall(atn, transition, true);
            }
        }
    }
    static testTailCall(atn, transition, optimizedPath) {
        if (!optimizedPath && transition.tailCall) return true;
        if (optimizedPath && transition.optimizedTailCall) return true;
        let reachable = new $5BPMp.BitSet(atn.states.length);
        let worklist = [];
        worklist.push(transition.followState);
        while(true){
            let state = worklist.pop();
            if (!state) break;
            if (reachable.get(state.stateNumber)) continue;
            if (state instanceof $4kGBm.RuleStopState) continue;
            if (!state.onlyHasEpsilonTransitions) return false;
            let transitionCount = optimizedPath ? state.numberOfOptimizedTransitions : state.numberOfTransitions;
            for(let i = 0; i < transitionCount; i++){
                let t = optimizedPath ? state.getOptimizedTransition(i) : state.transition(i);
                if (t.serializationType !== 1 /* EPSILON */ ) return false;
                worklist.push(t.target);
            }
        }
        return true;
    }
    static toInt(c) {
        return c;
    }
    static toInt32(data, offset) {
        return (data[offset] | data[offset + 1] << 16) >>> 0;
    }
    static toUUID(data, offset) {
        let leastSigBits = $9d4aef733dce84f9$var$ATNDeserializer.toInt32(data, offset);
        let lessSigBits = $9d4aef733dce84f9$var$ATNDeserializer.toInt32(data, offset + 2);
        let moreSigBits = $9d4aef733dce84f9$var$ATNDeserializer.toInt32(data, offset + 4);
        let mostSigBits = $9d4aef733dce84f9$var$ATNDeserializer.toInt32(data, offset + 6);
        return new $kWxOc.UUID(mostSigBits, moreSigBits, lessSigBits, leastSigBits);
    }
    edgeFactory(atn, type, src, trg, arg1, arg2, arg3, sets) {
        let target = atn.states[trg];
        switch(type){
            case 1 /* EPSILON */ :
                return new $bpnRH.EpsilonTransition(target);
            case 2 /* RANGE */ :
                if (arg3 !== 0) return new $aISkF.RangeTransition(target, $2DVsz.Token.EOF, arg2);
                else return new $aISkF.RangeTransition(target, arg1, arg2);
            case 3 /* RULE */ :
                let rt = new $aybFP.RuleTransition(atn.states[arg1], arg2, arg3, target);
                return rt;
            case 4 /* PREDICATE */ :
                let pt = new $hnaRv.PredicateTransition(target, arg1, arg2, arg3 !== 0);
                return pt;
            case 10 /* PRECEDENCE */ :
                return new $7KGEQ.PrecedencePredicateTransition(target, arg1);
            case 5 /* ATOM */ :
                if (arg3 !== 0) return new $5r7n7.AtomTransition(target, $2DVsz.Token.EOF);
                else return new $5r7n7.AtomTransition(target, arg1);
            case 6 /* ACTION */ :
                let a = new $gxlfY.ActionTransition(target, arg1, arg2, arg3 !== 0);
                return a;
            case 7 /* SET */ :
                return new $Np2R3.SetTransition(target, sets[arg1]);
            case 8 /* NOT_SET */ :
                return new $FLEKS.NotSetTransition(target, sets[arg1]);
            case 9 /* WILDCARD */ :
                return new $aPmi9.WildcardTransition(target);
        }
        throw new Error("The specified transition type is not valid.");
    }
    stateFactory(type, ruleIndex) {
        let s;
        switch(type){
            case $1bs3X.ATNStateType.INVALID_TYPE:
                return new $l4Nh1.InvalidState();
            case $1bs3X.ATNStateType.BASIC:
                s = new $4yiuQ.BasicState();
                break;
            case $1bs3X.ATNStateType.RULE_START:
                s = new $j2zc8.RuleStartState();
                break;
            case $1bs3X.ATNStateType.BLOCK_START:
                s = new $gAm9p.BasicBlockStartState();
                break;
            case $1bs3X.ATNStateType.PLUS_BLOCK_START:
                s = new $d1V7w.PlusBlockStartState();
                break;
            case $1bs3X.ATNStateType.STAR_BLOCK_START:
                s = new $jEsaF.StarBlockStartState();
                break;
            case $1bs3X.ATNStateType.TOKEN_START:
                s = new $WS4d7.TokensStartState();
                break;
            case $1bs3X.ATNStateType.RULE_STOP:
                s = new $4kGBm.RuleStopState();
                break;
            case $1bs3X.ATNStateType.BLOCK_END:
                s = new $loKp0.BlockEndState();
                break;
            case $1bs3X.ATNStateType.STAR_LOOP_BACK:
                s = new $bjwd1.StarLoopbackState();
                break;
            case $1bs3X.ATNStateType.STAR_LOOP_ENTRY:
                s = new $f9raX.StarLoopEntryState();
                break;
            case $1bs3X.ATNStateType.PLUS_LOOP_BACK:
                s = new $7qlbM.PlusLoopbackState();
                break;
            case $1bs3X.ATNStateType.LOOP_END:
                s = new $kfqEk.LoopEndState();
                break;
            default:
                let message = `The specified state type ${type} is not valid.`;
                throw new Error(message);
        }
        s.ruleIndex = ruleIndex;
        return s;
    }
    lexerActionFactory(type, data1, data2) {
        switch(type){
            case 0 /* CHANNEL */ :
                return new $iw4Ko.LexerChannelAction(data1);
            case 1 /* CUSTOM */ :
                return new $RgRAX.LexerCustomAction(data1, data2);
            case 2 /* MODE */ :
                return new $jgJtt.LexerModeAction(data1);
            case 3 /* MORE */ :
                return $l606e.LexerMoreAction.INSTANCE;
            case 4 /* POP_MODE */ :
                return $6hIs4.LexerPopModeAction.INSTANCE;
            case 5 /* PUSH_MODE */ :
                return new $a9nIX.LexerPushModeAction(data1);
            case 6 /* SKIP */ :
                return $2Gb96.LexerSkipAction.INSTANCE;
            case 7 /* TYPE */ :
                return new $ayRdK.LexerTypeAction(data1);
            default:
                let message = `The specified lexer action type ${type} is not valid.`;
                throw new Error(message);
        }
    }
}
/* WARNING: DO NOT MERGE THESE LINES. If UUIDs differ during a merge,
 * resolve the conflict by generating a new ID!
 */ /**
 * This is the earliest supported serialized UUID.
 */ $9d4aef733dce84f9$var$ATNDeserializer.BASE_SERIALIZED_UUID = $kWxOc.UUID.fromString("E4178468-DF95-44D0-AD87-F22A5D5FB6D3");
/**
 * This UUID indicates an extension of {@link #ADDED_PRECEDENCE_TRANSITIONS}
 * for the addition of lexer actions encoded as a sequence of
 * {@link LexerAction} instances.
 */ $9d4aef733dce84f9$var$ATNDeserializer.ADDED_LEXER_ACTIONS = $kWxOc.UUID.fromString("AB35191A-1603-487E-B75A-479B831EAF6D");
/**
 * This UUID indicates the serialized ATN contains two sets of
 * IntervalSets, where the second set's values are encoded as
 * 32-bit integers to support the full Unicode SMP range up to U+10FFFF.
 */ $9d4aef733dce84f9$var$ATNDeserializer.ADDED_UNICODE_SMP = $kWxOc.UUID.fromString("C23FEA89-0605-4f51-AFB8-058BCAB8C91B");
/**
 * This list contains all of the currently supported UUIDs, ordered by when
 * the feature first appeared in this branch.
 */ $9d4aef733dce84f9$var$ATNDeserializer.SUPPORTED_UUIDS = [
    $9d4aef733dce84f9$var$ATNDeserializer.BASE_SERIALIZED_UUID,
    $9d4aef733dce84f9$var$ATNDeserializer.ADDED_LEXER_ACTIONS,
    $9d4aef733dce84f9$var$ATNDeserializer.ADDED_UNICODE_SMP
];
/**
 * This is the current serialized UUID.
 */ $9d4aef733dce84f9$var$ATNDeserializer.SERIALIZED_UUID = $9d4aef733dce84f9$var$ATNDeserializer.ADDED_UNICODE_SMP;
$9d4aef733dce84f9$var$__decorate([
    $d6D31.NotNull
], $9d4aef733dce84f9$var$ATNDeserializer.prototype, "deserializationOptions", void 0);
$9d4aef733dce84f9$var$__decorate([
    $9d4aef733dce84f9$var$__param(0, $d6D31.NotNull)
], $9d4aef733dce84f9$var$ATNDeserializer.prototype, "deserialize", null);
$9d4aef733dce84f9$var$__decorate([
    $9d4aef733dce84f9$var$__param(0, $d6D31.NotNull)
], $9d4aef733dce84f9$var$ATNDeserializer.prototype, "markPrecedenceDecisions", null);
$9d4aef733dce84f9$var$__decorate([
    $d6D31.NotNull,
    $9d4aef733dce84f9$var$__param(0, $d6D31.NotNull)
], $9d4aef733dce84f9$var$ATNDeserializer.prototype, "edgeFactory", null);
module.exports.ATNDeserializer = $9d4aef733dce84f9$var$ATNDeserializer;

});
parcelRegister("gxlfY", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c0a0378a1b984eee$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c0a0378a1b984eee$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActionTransition = void 0;

var $d6D31 = parcelRequire("d6D31");

var $5tcOQ = parcelRequire("5tcOQ");
let $c0a0378a1b984eee$var$ActionTransition = class ActionTransition extends $5tcOQ.Transition {
    constructor(target, ruleIndex, actionIndex = -1, isCtxDependent = false){
        super(target);
        this.ruleIndex = ruleIndex;
        this.actionIndex = actionIndex;
        this.isCtxDependent = isCtxDependent;
    }
    get serializationType() {
        return 6 /* ACTION */ ;
    }
    get isEpsilon() {
        return true; // we are to be ignored by analysis 'cept for predicates
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    toString() {
        return "action_" + this.ruleIndex + ":" + this.actionIndex;
    }
};
$c0a0378a1b984eee$var$__decorate([
    $d6D31.Override
], $c0a0378a1b984eee$var$ActionTransition.prototype, "serializationType", null);
$c0a0378a1b984eee$var$__decorate([
    $d6D31.Override
], $c0a0378a1b984eee$var$ActionTransition.prototype, "isEpsilon", null);
$c0a0378a1b984eee$var$__decorate([
    $d6D31.Override
], $c0a0378a1b984eee$var$ActionTransition.prototype, "matches", null);
$c0a0378a1b984eee$var$__decorate([
    $d6D31.Override
], $c0a0378a1b984eee$var$ActionTransition.prototype, "toString", null);
$c0a0378a1b984eee$var$ActionTransition = $c0a0378a1b984eee$var$__decorate([
    $c0a0378a1b984eee$var$__param(0, $d6D31.NotNull)
], $c0a0378a1b984eee$var$ActionTransition);
module.exports.ActionTransition = $c0a0378a1b984eee$var$ActionTransition;

});

parcelRegister("5r7n7", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $010580cb6b5878c3$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $010580cb6b5878c3$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AtomTransition = void 0;

var $hGRod = parcelRequire("hGRod");

var $d6D31 = parcelRequire("d6D31");

var $5tcOQ = parcelRequire("5tcOQ");
/** TODO: make all transitions sets? no, should remove set edges */ let $010580cb6b5878c3$var$AtomTransition = class AtomTransition extends $5tcOQ.Transition {
    constructor(target, label){
        super(target);
        this._label = label;
    }
    get serializationType() {
        return 5 /* ATOM */ ;
    }
    get label() {
        return $hGRod.IntervalSet.of(this._label);
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return this._label === symbol;
    }
    toString() {
        return String(this.label);
    }
};
$010580cb6b5878c3$var$__decorate([
    $d6D31.Override
], $010580cb6b5878c3$var$AtomTransition.prototype, "serializationType", null);
$010580cb6b5878c3$var$__decorate([
    $d6D31.Override,
    $d6D31.NotNull
], $010580cb6b5878c3$var$AtomTransition.prototype, "label", null);
$010580cb6b5878c3$var$__decorate([
    $d6D31.Override
], $010580cb6b5878c3$var$AtomTransition.prototype, "matches", null);
$010580cb6b5878c3$var$__decorate([
    $d6D31.Override,
    $d6D31.NotNull
], $010580cb6b5878c3$var$AtomTransition.prototype, "toString", null);
$010580cb6b5878c3$var$AtomTransition = $010580cb6b5878c3$var$__decorate([
    $010580cb6b5878c3$var$__param(0, $d6D31.NotNull)
], $010580cb6b5878c3$var$AtomTransition);
module.exports.AtomTransition = $010580cb6b5878c3$var$AtomTransition;

});

parcelRegister("gAm9p", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c13130ce46eb4f6a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BasicBlockStartState = void 0;

var $1bs3X = parcelRequire("1bs3X");

var $65vNG = parcelRequire("65vNG");

var $d6D31 = parcelRequire("d6D31");
/**
 *
 * @author Sam Harwell
 */ class $c13130ce46eb4f6a$var$BasicBlockStartState extends $65vNG.BlockStartState {
    get stateType() {
        return $1bs3X.ATNStateType.BLOCK_START;
    }
}
$c13130ce46eb4f6a$var$__decorate([
    $d6D31.Override
], $c13130ce46eb4f6a$var$BasicBlockStartState.prototype, "stateType", null);
module.exports.BasicBlockStartState = $c13130ce46eb4f6a$var$BasicBlockStartState;

});
parcelRegister("65vNG", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlockStartState = void 0;

var $dPYn6 = parcelRequire("dPYn6");
/**  The start of a regular `(...)` block. */ class $46ebe09d19265106$var$BlockStartState extends $dPYn6.DecisionState {
}
module.exports.BlockStartState = $46ebe09d19265106$var$BlockStartState;

});


parcelRegister("loKp0", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f93fd5601d243552$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlockEndState = void 0;

var $7j0Pc = parcelRequire("7j0Pc");

var $1bs3X = parcelRequire("1bs3X");

var $d6D31 = parcelRequire("d6D31");
/** Terminal node of a simple `(a|b|c)` block. */ class $f93fd5601d243552$var$BlockEndState extends $7j0Pc.ATNState {
    get stateType() {
        return $1bs3X.ATNStateType.BLOCK_END;
    }
}
$f93fd5601d243552$var$__decorate([
    $d6D31.Override
], $f93fd5601d243552$var$BlockEndState.prototype, "stateType", null);
module.exports.BlockEndState = $f93fd5601d243552$var$BlockEndState;

});

parcelRegister("bpnRH", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $84e48a9cb4812173$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $84e48a9cb4812173$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EpsilonTransition = void 0;

var $d6D31 = parcelRequire("d6D31");

var $5tcOQ = parcelRequire("5tcOQ");
let $84e48a9cb4812173$var$EpsilonTransition = class EpsilonTransition extends $5tcOQ.Transition {
    constructor(target, outermostPrecedenceReturn = -1){
        super(target);
        this._outermostPrecedenceReturn = outermostPrecedenceReturn;
    }
    /**
     * @returns the rule index of a precedence rule for which this transition is
     * returning from, where the precedence value is 0; otherwise, -1.
     *
     * @see ATNConfig.isPrecedenceFilterSuppressed
     * @see ParserATNSimulator#applyPrecedenceFilter(ATNConfigSet, ParserRuleContext, PredictionContextCache)
     * @since 4.4.1
     */ get outermostPrecedenceReturn() {
        return this._outermostPrecedenceReturn;
    }
    get serializationType() {
        return 1 /* EPSILON */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    toString() {
        return "epsilon";
    }
};
$84e48a9cb4812173$var$__decorate([
    $d6D31.Override
], $84e48a9cb4812173$var$EpsilonTransition.prototype, "serializationType", null);
$84e48a9cb4812173$var$__decorate([
    $d6D31.Override
], $84e48a9cb4812173$var$EpsilonTransition.prototype, "isEpsilon", null);
$84e48a9cb4812173$var$__decorate([
    $d6D31.Override
], $84e48a9cb4812173$var$EpsilonTransition.prototype, "matches", null);
$84e48a9cb4812173$var$__decorate([
    $d6D31.Override,
    $d6D31.NotNull
], $84e48a9cb4812173$var$EpsilonTransition.prototype, "toString", null);
$84e48a9cb4812173$var$EpsilonTransition = $84e48a9cb4812173$var$__decorate([
    $84e48a9cb4812173$var$__param(0, $d6D31.NotNull)
], $84e48a9cb4812173$var$EpsilonTransition);
module.exports.EpsilonTransition = $84e48a9cb4812173$var$EpsilonTransition;

});

parcelRegister("iw4Ko", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d7aee5df2113a2bc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d7aee5df2113a2bc$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerChannelAction = void 0;

var $iXFjm = parcelRequire("iXFjm");

var $d6D31 = parcelRequire("d6D31");
/**
 * Implements the `channel` lexer action by calling
 * {@link Lexer#setChannel} with the assigned channel.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $d7aee5df2113a2bc$var$LexerChannelAction {
    /**
     * Constructs a new `channel` action with the specified channel value.
     * @param channel The channel value to pass to {@link Lexer#setChannel}.
     */ constructor(channel){
        this._channel = channel;
    }
    /**
     * Gets the channel to use for the {@link Token} created by the lexer.
     *
     * @returns The channel to use for the {@link Token} created by the lexer.
     */ get channel() {
        return this._channel;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#CHANNEL}.
     */ get actionType() {
        return 0 /* CHANNEL */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#setChannel} with the
     * value provided by {@link #getChannel}.
     */ execute(lexer) {
        lexer.channel = this._channel;
    }
    hashCode() {
        let hash = $iXFjm.MurmurHash.initialize();
        hash = $iXFjm.MurmurHash.update(hash, this.actionType);
        hash = $iXFjm.MurmurHash.update(hash, this._channel);
        return $iXFjm.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $d7aee5df2113a2bc$var$LexerChannelAction)) return false;
        return this._channel === obj._channel;
    }
    toString() {
        return `channel(${this._channel})`;
    }
}
$d7aee5df2113a2bc$var$__decorate([
    $d6D31.Override
], $d7aee5df2113a2bc$var$LexerChannelAction.prototype, "actionType", null);
$d7aee5df2113a2bc$var$__decorate([
    $d6D31.Override
], $d7aee5df2113a2bc$var$LexerChannelAction.prototype, "isPositionDependent", null);
$d7aee5df2113a2bc$var$__decorate([
    $d6D31.Override,
    $d7aee5df2113a2bc$var$__param(0, $d6D31.NotNull)
], $d7aee5df2113a2bc$var$LexerChannelAction.prototype, "execute", null);
$d7aee5df2113a2bc$var$__decorate([
    $d6D31.Override
], $d7aee5df2113a2bc$var$LexerChannelAction.prototype, "hashCode", null);
$d7aee5df2113a2bc$var$__decorate([
    $d6D31.Override
], $d7aee5df2113a2bc$var$LexerChannelAction.prototype, "equals", null);
$d7aee5df2113a2bc$var$__decorate([
    $d6D31.Override
], $d7aee5df2113a2bc$var$LexerChannelAction.prototype, "toString", null);
module.exports.LexerChannelAction = $d7aee5df2113a2bc$var$LexerChannelAction;

});

parcelRegister("RgRAX", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $0a0208144418eb04$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $0a0208144418eb04$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerCustomAction = void 0;

var $iXFjm = parcelRequire("iXFjm");

var $d6D31 = parcelRequire("d6D31");
/**
 * Executes a custom lexer action by calling {@link Recognizer#action} with the
 * rule and action indexes assigned to the custom action. The implementation of
 * a custom action is added to the generated code for the lexer in an override
 * of {@link Recognizer#action} when the grammar is compiled.
 *
 * This class may represent embedded actions created with the `{...}`
 * syntax in ANTLR 4, as well as actions created for lexer commands where the
 * command argument could not be evaluated when the grammar was compiled.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $0a0208144418eb04$var$LexerCustomAction {
    /**
     * Constructs a custom lexer action with the specified rule and action
     * indexes.
     *
     * @param ruleIndex The rule index to use for calls to
     * {@link Recognizer#action}.
     * @param actionIndex The action index to use for calls to
     * {@link Recognizer#action}.
     */ constructor(ruleIndex, actionIndex){
        this._ruleIndex = ruleIndex;
        this._actionIndex = actionIndex;
    }
    /**
     * Gets the rule index to use for calls to {@link Recognizer#action}.
     *
     * @returns The rule index for the custom action.
     */ get ruleIndex() {
        return this._ruleIndex;
    }
    /**
     * Gets the action index to use for calls to {@link Recognizer#action}.
     *
     * @returns The action index for the custom action.
     */ get actionIndex() {
        return this._actionIndex;
    }
    /**
     * {@inheritDoc}
     *
     * @returns This method returns {@link LexerActionType#CUSTOM}.
     */ get actionType() {
        return 1 /* CUSTOM */ ;
    }
    /**
     * Gets whether the lexer action is position-dependent. Position-dependent
     * actions may have different semantics depending on the {@link CharStream}
     * index at the time the action is executed.
     *
     * Custom actions are position-dependent since they may represent a
     * user-defined embedded action which makes calls to methods like
     * {@link Lexer#getText}.
     *
     * @returns This method returns `true`.
     */ get isPositionDependent() {
        return true;
    }
    /**
     * {@inheritDoc}
     *
     * Custom actions are implemented by calling {@link Lexer#action} with the
     * appropriate rule and action indexes.
     */ execute(lexer) {
        lexer.action(undefined, this._ruleIndex, this._actionIndex);
    }
    hashCode() {
        let hash = $iXFjm.MurmurHash.initialize();
        hash = $iXFjm.MurmurHash.update(hash, this.actionType);
        hash = $iXFjm.MurmurHash.update(hash, this._ruleIndex);
        hash = $iXFjm.MurmurHash.update(hash, this._actionIndex);
        return $iXFjm.MurmurHash.finish(hash, 3);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $0a0208144418eb04$var$LexerCustomAction)) return false;
        return this._ruleIndex === obj._ruleIndex && this._actionIndex === obj._actionIndex;
    }
}
$0a0208144418eb04$var$__decorate([
    $d6D31.Override
], $0a0208144418eb04$var$LexerCustomAction.prototype, "actionType", null);
$0a0208144418eb04$var$__decorate([
    $d6D31.Override
], $0a0208144418eb04$var$LexerCustomAction.prototype, "isPositionDependent", null);
$0a0208144418eb04$var$__decorate([
    $d6D31.Override,
    $0a0208144418eb04$var$__param(0, $d6D31.NotNull)
], $0a0208144418eb04$var$LexerCustomAction.prototype, "execute", null);
$0a0208144418eb04$var$__decorate([
    $d6D31.Override
], $0a0208144418eb04$var$LexerCustomAction.prototype, "hashCode", null);
$0a0208144418eb04$var$__decorate([
    $d6D31.Override
], $0a0208144418eb04$var$LexerCustomAction.prototype, "equals", null);
module.exports.LexerCustomAction = $0a0208144418eb04$var$LexerCustomAction;

});

parcelRegister("jgJtt", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e072c93b157fdb6e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $e072c93b157fdb6e$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerModeAction = void 0;

var $iXFjm = parcelRequire("iXFjm");

var $d6D31 = parcelRequire("d6D31");
/**
 * Implements the `mode` lexer action by calling {@link Lexer#mode} with
 * the assigned mode.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $e072c93b157fdb6e$var$LexerModeAction {
    /**
     * Constructs a new `mode` action with the specified mode value.
     * @param mode The mode value to pass to {@link Lexer#mode}.
     */ constructor(mode){
        this._mode = mode;
    }
    /**
     * Get the lexer mode this action should transition the lexer to.
     *
     * @returns The lexer mode for this `mode` command.
     */ get mode() {
        return this._mode;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#MODE}.
     */ get actionType() {
        return 2 /* MODE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#mode} with the
     * value provided by {@link #getMode}.
     */ execute(lexer) {
        lexer.mode(this._mode);
    }
    hashCode() {
        let hash = $iXFjm.MurmurHash.initialize();
        hash = $iXFjm.MurmurHash.update(hash, this.actionType);
        hash = $iXFjm.MurmurHash.update(hash, this._mode);
        return $iXFjm.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $e072c93b157fdb6e$var$LexerModeAction)) return false;
        return this._mode === obj._mode;
    }
    toString() {
        return `mode(${this._mode})`;
    }
}
$e072c93b157fdb6e$var$__decorate([
    $d6D31.Override
], $e072c93b157fdb6e$var$LexerModeAction.prototype, "actionType", null);
$e072c93b157fdb6e$var$__decorate([
    $d6D31.Override
], $e072c93b157fdb6e$var$LexerModeAction.prototype, "isPositionDependent", null);
$e072c93b157fdb6e$var$__decorate([
    $d6D31.Override,
    $e072c93b157fdb6e$var$__param(0, $d6D31.NotNull)
], $e072c93b157fdb6e$var$LexerModeAction.prototype, "execute", null);
$e072c93b157fdb6e$var$__decorate([
    $d6D31.Override
], $e072c93b157fdb6e$var$LexerModeAction.prototype, "hashCode", null);
$e072c93b157fdb6e$var$__decorate([
    $d6D31.Override
], $e072c93b157fdb6e$var$LexerModeAction.prototype, "equals", null);
$e072c93b157fdb6e$var$__decorate([
    $d6D31.Override
], $e072c93b157fdb6e$var$LexerModeAction.prototype, "toString", null);
module.exports.LexerModeAction = $e072c93b157fdb6e$var$LexerModeAction;

});

parcelRegister("l606e", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f5ba3c4a18e49934$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f5ba3c4a18e49934$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerMoreAction = void 0;

var $iXFjm = parcelRequire("iXFjm");

var $d6D31 = parcelRequire("d6D31");
/**
 * Implements the `more` lexer action by calling {@link Lexer#more}.
 *
 * The `more` command does not have any parameters, so this action is
 * implemented as a singleton instance exposed by {@link #INSTANCE}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $f5ba3c4a18e49934$var$LexerMoreAction {
    /**
     * Constructs the singleton instance of the lexer `more` command.
     */ constructor(){
    // intentionally empty
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#MORE}.
     */ get actionType() {
        return 3 /* MORE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#more}.
     */ execute(lexer) {
        lexer.more();
    }
    hashCode() {
        let hash = $iXFjm.MurmurHash.initialize();
        hash = $iXFjm.MurmurHash.update(hash, this.actionType);
        return $iXFjm.MurmurHash.finish(hash, 1);
    }
    equals(obj) {
        return obj === this;
    }
    toString() {
        return "more";
    }
}
$f5ba3c4a18e49934$var$__decorate([
    $d6D31.Override
], $f5ba3c4a18e49934$var$LexerMoreAction.prototype, "actionType", null);
$f5ba3c4a18e49934$var$__decorate([
    $d6D31.Override
], $f5ba3c4a18e49934$var$LexerMoreAction.prototype, "isPositionDependent", null);
$f5ba3c4a18e49934$var$__decorate([
    $d6D31.Override,
    $f5ba3c4a18e49934$var$__param(0, $d6D31.NotNull)
], $f5ba3c4a18e49934$var$LexerMoreAction.prototype, "execute", null);
$f5ba3c4a18e49934$var$__decorate([
    $d6D31.Override
], $f5ba3c4a18e49934$var$LexerMoreAction.prototype, "hashCode", null);
$f5ba3c4a18e49934$var$__decorate([
    $d6D31.Override
], $f5ba3c4a18e49934$var$LexerMoreAction.prototype, "equals", null);
$f5ba3c4a18e49934$var$__decorate([
    $d6D31.Override
], $f5ba3c4a18e49934$var$LexerMoreAction.prototype, "toString", null);
module.exports.LexerMoreAction = $f5ba3c4a18e49934$var$LexerMoreAction;
(function(LexerMoreAction) {
    /**
     * Provides a singleton instance of this parameterless lexer action.
     */ LexerMoreAction.INSTANCE = new LexerMoreAction();
})($f5ba3c4a18e49934$var$LexerMoreAction = module.exports.LexerMoreAction || (module.exports.LexerMoreAction = {}));

});

parcelRegister("6hIs4", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $4936cfc70a1820aa$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $4936cfc70a1820aa$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerPopModeAction = void 0;

var $iXFjm = parcelRequire("iXFjm");

var $d6D31 = parcelRequire("d6D31");
/**
 * Implements the `popMode` lexer action by calling {@link Lexer#popMode}.
 *
 * The `popMode` command does not have any parameters, so this action is
 * implemented as a singleton instance exposed by {@link #INSTANCE}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $4936cfc70a1820aa$var$LexerPopModeAction {
    /**
     * Constructs the singleton instance of the lexer `popMode` command.
     */ constructor(){
    // intentionally empty
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#POP_MODE}.
     */ get actionType() {
        return 4 /* POP_MODE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#popMode}.
     */ execute(lexer) {
        lexer.popMode();
    }
    hashCode() {
        let hash = $iXFjm.MurmurHash.initialize();
        hash = $iXFjm.MurmurHash.update(hash, this.actionType);
        return $iXFjm.MurmurHash.finish(hash, 1);
    }
    equals(obj) {
        return obj === this;
    }
    toString() {
        return "popMode";
    }
}
$4936cfc70a1820aa$var$__decorate([
    $d6D31.Override
], $4936cfc70a1820aa$var$LexerPopModeAction.prototype, "actionType", null);
$4936cfc70a1820aa$var$__decorate([
    $d6D31.Override
], $4936cfc70a1820aa$var$LexerPopModeAction.prototype, "isPositionDependent", null);
$4936cfc70a1820aa$var$__decorate([
    $d6D31.Override,
    $4936cfc70a1820aa$var$__param(0, $d6D31.NotNull)
], $4936cfc70a1820aa$var$LexerPopModeAction.prototype, "execute", null);
$4936cfc70a1820aa$var$__decorate([
    $d6D31.Override
], $4936cfc70a1820aa$var$LexerPopModeAction.prototype, "hashCode", null);
$4936cfc70a1820aa$var$__decorate([
    $d6D31.Override
], $4936cfc70a1820aa$var$LexerPopModeAction.prototype, "equals", null);
$4936cfc70a1820aa$var$__decorate([
    $d6D31.Override
], $4936cfc70a1820aa$var$LexerPopModeAction.prototype, "toString", null);
module.exports.LexerPopModeAction = $4936cfc70a1820aa$var$LexerPopModeAction;
(function(LexerPopModeAction) {
    /**
     * Provides a singleton instance of this parameterless lexer action.
     */ LexerPopModeAction.INSTANCE = new LexerPopModeAction();
})($4936cfc70a1820aa$var$LexerPopModeAction = module.exports.LexerPopModeAction || (module.exports.LexerPopModeAction = {}));

});

parcelRegister("a9nIX", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $763d25c4cd7cf3b5$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $763d25c4cd7cf3b5$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerPushModeAction = void 0;

var $iXFjm = parcelRequire("iXFjm");

var $d6D31 = parcelRequire("d6D31");
/**
 * Implements the `pushMode` lexer action by calling
 * {@link Lexer#pushMode} with the assigned mode.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $763d25c4cd7cf3b5$var$LexerPushModeAction {
    /**
     * Constructs a new `pushMode` action with the specified mode value.
     * @param mode The mode value to pass to {@link Lexer#pushMode}.
     */ constructor(mode){
        this._mode = mode;
    }
    /**
     * Get the lexer mode this action should transition the lexer to.
     *
     * @returns The lexer mode for this `pushMode` command.
     */ get mode() {
        return this._mode;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#PUSH_MODE}.
     */ get actionType() {
        return 5 /* PUSH_MODE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#pushMode} with the
     * value provided by {@link #getMode}.
     */ execute(lexer) {
        lexer.pushMode(this._mode);
    }
    hashCode() {
        let hash = $iXFjm.MurmurHash.initialize();
        hash = $iXFjm.MurmurHash.update(hash, this.actionType);
        hash = $iXFjm.MurmurHash.update(hash, this._mode);
        return $iXFjm.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $763d25c4cd7cf3b5$var$LexerPushModeAction)) return false;
        return this._mode === obj._mode;
    }
    toString() {
        return `pushMode(${this._mode})`;
    }
}
$763d25c4cd7cf3b5$var$__decorate([
    $d6D31.Override
], $763d25c4cd7cf3b5$var$LexerPushModeAction.prototype, "actionType", null);
$763d25c4cd7cf3b5$var$__decorate([
    $d6D31.Override
], $763d25c4cd7cf3b5$var$LexerPushModeAction.prototype, "isPositionDependent", null);
$763d25c4cd7cf3b5$var$__decorate([
    $d6D31.Override,
    $763d25c4cd7cf3b5$var$__param(0, $d6D31.NotNull)
], $763d25c4cd7cf3b5$var$LexerPushModeAction.prototype, "execute", null);
$763d25c4cd7cf3b5$var$__decorate([
    $d6D31.Override
], $763d25c4cd7cf3b5$var$LexerPushModeAction.prototype, "hashCode", null);
$763d25c4cd7cf3b5$var$__decorate([
    $d6D31.Override
], $763d25c4cd7cf3b5$var$LexerPushModeAction.prototype, "equals", null);
$763d25c4cd7cf3b5$var$__decorate([
    $d6D31.Override
], $763d25c4cd7cf3b5$var$LexerPushModeAction.prototype, "toString", null);
module.exports.LexerPushModeAction = $763d25c4cd7cf3b5$var$LexerPushModeAction;

});

parcelRegister("2Gb96", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $1f3826579173f858$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $1f3826579173f858$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerSkipAction = void 0;

var $iXFjm = parcelRequire("iXFjm");

var $d6D31 = parcelRequire("d6D31");
/**
 * Implements the `skip` lexer action by calling {@link Lexer#skip}.
 *
 * The `skip` command does not have any parameters, so this action is
 * implemented as a singleton instance exposed by {@link #INSTANCE}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $1f3826579173f858$var$LexerSkipAction {
    /**
     * Constructs the singleton instance of the lexer `skip` command.
     */ constructor(){
    // intentionally empty
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#SKIP}.
     */ get actionType() {
        return 6 /* SKIP */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#skip}.
     */ execute(lexer) {
        lexer.skip();
    }
    hashCode() {
        let hash = $iXFjm.MurmurHash.initialize();
        hash = $iXFjm.MurmurHash.update(hash, this.actionType);
        return $iXFjm.MurmurHash.finish(hash, 1);
    }
    equals(obj) {
        return obj === this;
    }
    toString() {
        return "skip";
    }
}
$1f3826579173f858$var$__decorate([
    $d6D31.Override
], $1f3826579173f858$var$LexerSkipAction.prototype, "actionType", null);
$1f3826579173f858$var$__decorate([
    $d6D31.Override
], $1f3826579173f858$var$LexerSkipAction.prototype, "isPositionDependent", null);
$1f3826579173f858$var$__decorate([
    $d6D31.Override,
    $1f3826579173f858$var$__param(0, $d6D31.NotNull)
], $1f3826579173f858$var$LexerSkipAction.prototype, "execute", null);
$1f3826579173f858$var$__decorate([
    $d6D31.Override
], $1f3826579173f858$var$LexerSkipAction.prototype, "hashCode", null);
$1f3826579173f858$var$__decorate([
    $d6D31.Override
], $1f3826579173f858$var$LexerSkipAction.prototype, "equals", null);
$1f3826579173f858$var$__decorate([
    $d6D31.Override
], $1f3826579173f858$var$LexerSkipAction.prototype, "toString", null);
module.exports.LexerSkipAction = $1f3826579173f858$var$LexerSkipAction;
(function(LexerSkipAction) {
    /**
     * Provides a singleton instance of this parameterless lexer action.
     */ LexerSkipAction.INSTANCE = new LexerSkipAction();
})($1f3826579173f858$var$LexerSkipAction = module.exports.LexerSkipAction || (module.exports.LexerSkipAction = {}));

});

parcelRegister("ayRdK", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7b065cdfc5f207e7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $7b065cdfc5f207e7$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerTypeAction = void 0;

var $iXFjm = parcelRequire("iXFjm");

var $d6D31 = parcelRequire("d6D31");
/**
 * Implements the `type` lexer action by setting `Lexer.type`
 * with the assigned type.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $7b065cdfc5f207e7$var$LexerTypeAction {
    /**
     * Constructs a new `type` action with the specified token type value.
     * @param type The type to assign to the token using `Lexer.type`.
     */ constructor(type){
        this._type = type;
    }
    /**
     * Gets the type to assign to a token created by the lexer.
     * @returns The type to assign to a token created by the lexer.
     */ get type() {
        return this._type;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#TYPE}.
     */ get actionType() {
        return 7 /* TYPE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by setting `Lexer.type` with the
     * value provided by `type`.
     */ execute(lexer) {
        lexer.type = this._type;
    }
    hashCode() {
        let hash = $iXFjm.MurmurHash.initialize();
        hash = $iXFjm.MurmurHash.update(hash, this.actionType);
        hash = $iXFjm.MurmurHash.update(hash, this._type);
        return $iXFjm.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $7b065cdfc5f207e7$var$LexerTypeAction)) return false;
        return this._type === obj._type;
    }
    toString() {
        return `type(${this._type})`;
    }
}
$7b065cdfc5f207e7$var$__decorate([
    $d6D31.Override
], $7b065cdfc5f207e7$var$LexerTypeAction.prototype, "actionType", null);
$7b065cdfc5f207e7$var$__decorate([
    $d6D31.Override
], $7b065cdfc5f207e7$var$LexerTypeAction.prototype, "isPositionDependent", null);
$7b065cdfc5f207e7$var$__decorate([
    $d6D31.Override,
    $7b065cdfc5f207e7$var$__param(0, $d6D31.NotNull)
], $7b065cdfc5f207e7$var$LexerTypeAction.prototype, "execute", null);
$7b065cdfc5f207e7$var$__decorate([
    $d6D31.Override
], $7b065cdfc5f207e7$var$LexerTypeAction.prototype, "hashCode", null);
$7b065cdfc5f207e7$var$__decorate([
    $d6D31.Override
], $7b065cdfc5f207e7$var$LexerTypeAction.prototype, "equals", null);
$7b065cdfc5f207e7$var$__decorate([
    $d6D31.Override
], $7b065cdfc5f207e7$var$LexerTypeAction.prototype, "toString", null);
module.exports.LexerTypeAction = $7b065cdfc5f207e7$var$LexerTypeAction;

});

parcelRegister("kfqEk", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ebd9e16490628daf$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoopEndState = void 0;

var $7j0Pc = parcelRequire("7j0Pc");

var $1bs3X = parcelRequire("1bs3X");

var $d6D31 = parcelRequire("d6D31");
/** Mark the end of a * or + loop. */ class $ebd9e16490628daf$var$LoopEndState extends $7j0Pc.ATNState {
    get stateType() {
        return $1bs3X.ATNStateType.LOOP_END;
    }
}
$ebd9e16490628daf$var$__decorate([
    $d6D31.Override
], $ebd9e16490628daf$var$LoopEndState.prototype, "stateType", null);
module.exports.LoopEndState = $ebd9e16490628daf$var$LoopEndState;

});

parcelRegister("kzbnL", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ef8fe7d2bd819f1c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $ef8fe7d2bd819f1c$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParserATNSimulator = void 0;

var $41NTU = parcelRequire("41NTU");

var $gxlfY = parcelRequire("gxlfY");

var $7Veax = parcelRequire("7Veax");

var $9yG1X = parcelRequire("9yG1X");

var $bcnvE = parcelRequire("bcnvE");

var $gcX0f = parcelRequire("gcX0f");

var $c1ClW = parcelRequire("c1ClW");

var $kr9A1 = parcelRequire("kr9A1");

var $1bs3X = parcelRequire("1bs3X");

var $5r7n7 = parcelRequire("5r7n7");

var $5BPMp = parcelRequire("5BPMp");

var $gsRaX = parcelRequire("gsRaX");

var $dPYn6 = parcelRequire("dPYn6");

var $2jevZ = parcelRequire("2jevZ");

var $37SGk = parcelRequire("37SGk");

var $gcfUE = parcelRequire("gcfUE");

var $ceaEj = parcelRequire("ceaEj");

var $d6D31 = parcelRequire("d6D31");

var $FLEKS = parcelRequire("FLEKS");

var $hKCjP = parcelRequire("hKCjP");

var $a4Flx = parcelRequire("a4Flx");

var $6bmaO = parcelRequire("6bmaO");

var $8DTT0 = parcelRequire("8DTT0");

var $6vF7J = parcelRequire("6vF7J");

var $gDZVV = parcelRequire("gDZVV");

var $4kGBm = parcelRequire("4kGBm");

var $aybFP = parcelRequire("aybFP");

var $eHMgW = parcelRequire("eHMgW");

var $Np2R3 = parcelRequire("Np2R3");

var $g7SCF = parcelRequire("g7SCF");

var $2DVsz = parcelRequire("2DVsz");

var $3n2FE = parcelRequire("3n2FE");

var $bbHFU = parcelRequire("bbHFU");
const $ef8fe7d2bd819f1c$var$MAX_SHORT_VALUE = 0xFFFF;
const $ef8fe7d2bd819f1c$var$MIN_INTEGER_VALUE = -2147483648;
/**
 * The embodiment of the adaptive LL(*), ALL(*), parsing strategy.
 *
 * The basic complexity of the adaptive strategy makes it harder to understand.
 * We begin with ATN simulation to build paths in a DFA. Subsequent prediction
 * requests go through the DFA first. If they reach a state without an edge for
 * the current symbol, the algorithm fails over to the ATN simulation to
 * complete the DFA path for the current input (until it finds a conflict state
 * or uniquely predicting state).
 *
 * All of that is done without using the outer context because we want to create
 * a DFA that is not dependent upon the rule invocation stack when we do a
 * prediction. One DFA works in all contexts. We avoid using context not
 * necessarily because it's slower, although it can be, but because of the DFA
 * caching problem. The closure routine only considers the rule invocation stack
 * created during prediction beginning in the decision rule. For example, if
 * prediction occurs without invoking another rule's ATN, there are no context
 * stacks in the configurations. When lack of context leads to a conflict, we
 * don't know if it's an ambiguity or a weakness in the strong LL(*) parsing
 * strategy (versus full LL(*)).
 *
 * When SLL yields a configuration set with conflict, we rewind the input and
 * retry the ATN simulation, this time using full outer context without adding
 * to the DFA. Configuration context stacks will be the full invocation stacks
 * from the start rule. If we get a conflict using full context, then we can
 * definitively say we have a true ambiguity for that input sequence. If we
 * don't get a conflict, it implies that the decision is sensitive to the outer
 * context. (It is not context-sensitive in the sense of context-sensitive
 * grammars.)
 *
 * The next time we reach this DFA state with an SLL conflict, through DFA
 * simulation, we will again retry the ATN simulation using full context mode.
 * This is slow because we can't save the results and have to "interpret" the
 * ATN each time we get that input.
 *
 * **CACHING FULL CONTEXT PREDICTIONS**
 *
 * We could cache results from full context to predicted alternative easily and
 * that saves a lot of time but doesn't work in presence of predicates. The set
 * of visible predicates from the ATN start state changes depending on the
 * context, because closure can fall off the end of a rule. I tried to cache
 * tuples (stack context, semantic context, predicted alt) but it was slower
 * than interpreting and much more complicated. Also required a huge amount of
 * memory. The goal is not to create the world's fastest parser anyway. I'd like
 * to keep this algorithm simple. By launching multiple threads, we can improve
 * the speed of parsing across a large number of files.
 *
 * There is no strict ordering between the amount of input used by SLL vs LL,
 * which makes it really hard to build a cache for full context. Let's say that
 * we have input A B C that leads to an SLL conflict with full context X. That
 * implies that using X we might only use A B but we could also use A B C D to
 * resolve conflict. Input A B C D could predict alternative 1 in one position
 * in the input and A B C E could predict alternative 2 in another position in
 * input. The conflicting SLL configurations could still be non-unique in the
 * full context prediction, which would lead us to requiring more input than the
 * original A B C.	To make a	prediction cache work, we have to track	the exact
 * input	used during the previous prediction. That amounts to a cache that maps
 * X to a specific DFA for that context.
 *
 * Something should be done for left-recursive expression predictions. They are
 * likely LL(1) + pred eval. Easier to do the whole SLL unless error and retry
 * with full LL thing Sam does.
 *
 * **AVOIDING FULL CONTEXT PREDICTION**
 *
 * We avoid doing full context retry when the outer context is empty, we did not
 * dip into the outer context by falling off the end of the decision state rule,
 * or when we force SLL mode.
 *
 * As an example of the not dip into outer context case, consider as super
 * constructor calls versus function calls. One grammar might look like
 * this:
 *
 * ```antlr
 * ctorBody
 *   : '{' superCall? stat* '}'
 *   ;
 * ```
 *
 * Or, you might see something like
 *
 * ```antlr
 * stat
 *   : superCall ';'
 *   | expression ';'
 *   | ...
 *   ;
 * ```
 *
 * In both cases I believe that no closure operations will dip into the outer
 * context. In the first case ctorBody in the worst case will stop at the '}'.
 * In the 2nd case it should stop at the ';'. Both cases should stay within the
 * entry rule and not dip into the outer context.
 *
 * **PREDICATES**
 *
 * Predicates are always evaluated if present in either SLL or LL both. SLL and
 * LL simulation deals with predicates differently. SLL collects predicates as
 * it performs closure operations like ANTLR v3 did. It delays predicate
 * evaluation until it reaches and accept state. This allows us to cache the SLL
 * ATN simulation whereas, if we had evaluated predicates on-the-fly during
 * closure, the DFA state configuration sets would be different and we couldn't
 * build up a suitable DFA.
 *
 * When building a DFA accept state during ATN simulation, we evaluate any
 * predicates and return the sole semantically valid alternative. If there is
 * more than 1 alternative, we report an ambiguity. If there are 0 alternatives,
 * we throw an exception. Alternatives without predicates act like they have
 * true predicates. The simple way to think about it is to strip away all
 * alternatives with false predicates and choose the minimum alternative that
 * remains.
 *
 * When we start in the DFA and reach an accept state that's predicated, we test
 * those and return the minimum semantically viable alternative. If no
 * alternatives are viable, we throw an exception.
 *
 * During full LL ATN simulation, closure always evaluates predicates and
 * on-the-fly. This is crucial to reducing the configuration set size during
 * closure. It hits a landmine when parsing with the Java grammar, for example,
 * without this on-the-fly evaluation.
 *
 * **SHARING DFA**
 *
 * All instances of the same parser share the same decision DFAs through a
 * static field. Each instance gets its own ATN simulator but they share the
 * same {@link ATN#decisionToDFA} field. They also share a
 * {@link PredictionContextCache} object that makes sure that all
 * {@link PredictionContext} objects are shared among the DFA states. This makes
 * a big size difference.
 *
 * **THREAD SAFETY**
 *
 * The {@link ParserATNSimulator} locks on the {@link ATN#decisionToDFA} field when
 * it adds a new DFA object to that array. {@link #addDFAEdge}
 * locks on the DFA for the current decision when setting the
 * {@link DFAState#edges} field. {@link #addDFAState} locks on
 * the DFA for the current decision when looking up a DFA state to see if it
 * already exists. We must make sure that all requests to add DFA states that
 * are equivalent result in the same shared DFA object. This is because lots of
 * threads will be trying to update the DFA at once. The
 * {@link #addDFAState} method also locks inside the DFA lock
 * but this time on the shared context cache when it rebuilds the
 * configurations' {@link PredictionContext} objects using cached
 * subgraphs/nodes. No other locking occurs, even during DFA simulation. This is
 * safe as long as we can guarantee that all threads referencing
 * `s.edge[t]` get the same physical target {@link DFAState}, or
 * `undefined`. Once into the DFA, the DFA simulation does not reference the
 * {@link DFA#states} map. It follows the {@link DFAState#edges} field to new
 * targets. The DFA simulator will either find {@link DFAState#edges} to be
 * `undefined`, to be non-`undefined` and `dfa.edges[t]` undefined, or
 * `dfa.edges[t]` to be non-undefined. The
 * {@link #addDFAEdge} method could be racing to set the field
 * but in either case the DFA simulator works; if `undefined`, and requests ATN
 * simulation. It could also race trying to get `dfa.edges[t]`, but either
 * way it will work because it's not doing a test and set operation.
 *
 * **Starting with SLL then failing to combined SLL/LL (Two-Stage
 * Parsing)**
 *
 * Sam pointed out that if SLL does not give a syntax error, then there is no
 * point in doing full LL, which is slower. We only have to try LL if we get a
 * syntax error. For maximum speed, Sam starts the parser set to pure SLL
 * mode with the {@link BailErrorStrategy}:
 *
 * ```
 * parser.interpreter.{@link #setPredictionMode setPredictionMode}`(`{@link PredictionMode#SLL}`)`;
 * parser.{@link Parser#setErrorHandler setErrorHandler}(new {@link BailErrorStrategy}());
 * ```
 *
 * If it does not get a syntax error, then we're done. If it does get a syntax
 * error, we need to retry with the combined SLL/LL strategy.
 *
 * The reason this works is as follows. If there are no SLL conflicts, then the
 * grammar is SLL (at least for that input set). If there is an SLL conflict,
 * the full LL analysis must yield a set of viable alternatives which is a
 * subset of the alternatives reported by SLL. If the LL set is a singleton,
 * then the grammar is LL but not SLL. If the LL set is the same size as the SLL
 * set, the decision is SLL. If the LL set has size &gt; 1, then that decision
 * is truly ambiguous on the current input. If the LL set is smaller, then the
 * SLL conflict resolution might choose an alternative that the full LL would
 * rule out as a possibility based upon better context information. If that's
 * the case, then the SLL parse will definitely get an error because the full LL
 * analysis says it's not viable. If SLL conflict resolution chooses an
 * alternative within the LL set, them both SLL and LL would choose the same
 * alternative because they both choose the minimum of multiple conflicting
 * alternatives.
 *
 * Let's say we have a set of SLL conflicting alternatives `{1, 2, 3}` and
 * a smaller LL set called *s*. If *s* is `{2, 3}`, then SLL
 * parsing will get an error because SLL will pursue alternative 1. If
 * *s* is `{1, 2}` or `{1, 3}` then both SLL and LL will
 * choose the same alternative because alternative one is the minimum of either
 * set. If *s* is `{2}` or `{3}` then SLL will get a syntax
 * error. If *s* is `{1}` then SLL will succeed.
 *
 * Of course, if the input is invalid, then we will get an error for sure in
 * both SLL and LL parsing. Erroneous input will therefore require 2 passes over
 * the input.
 */ let $ef8fe7d2bd819f1c$var$ParserATNSimulator = class ParserATNSimulator extends $kr9A1.ATNSimulator {
    constructor(atn, parser){
        super(atn);
        this.predictionMode = $gDZVV.PredictionMode.LL;
        this.force_global_context = false;
        this.always_try_local_context = true;
        /**
         * Determines whether the DFA is used for full-context predictions. When
         * `true`, the DFA stores transition information for both full-context
         * and SLL parsing; otherwise, the DFA only stores SLL transition
         * information.
         *
         * For some grammars, enabling the full-context DFA can result in a
         * substantial performance improvement. However, this improvement typically
         * comes at the expense of memory used for storing the cached DFA states,
         * configuration sets, and prediction contexts.
         *
         * The default value is `false`.
         */ this.enable_global_context_dfa = false;
        this.optimize_unique_closure = true;
        this.optimize_ll1 = true;
        this.optimize_tail_calls = true;
        this.tail_call_preserves_sll = true;
        this.treat_sllk1_conflict_as_ambiguity = false;
        /**
         * When `true`, ambiguous alternatives are reported when they are
         * encountered within {@link #execATN}. When `false`, these messages
         * are suppressed. The default is `false`.
         *
         * When messages about ambiguous alternatives are not required, setting this
         * to `false` enables additional internal optimizations which may lose
         * this information.
         */ this.reportAmbiguities = false;
        /** By default we do full context-sensitive LL(*) parsing not
         *  Strong LL(*) parsing. If we fail with Strong LL(*) we
         *  try full LL(*). That means we rewind and use context information
         *  when closure operations fall off the end of the rule that
         *  holds the decision were evaluating.
         */ this.userWantsCtxSensitive = true;
        this._parser = parser;
    }
    getPredictionMode() {
        return this.predictionMode;
    }
    setPredictionMode(predictionMode) {
        this.predictionMode = predictionMode;
    }
    reset() {
    // intentionally empty
    }
    adaptivePredict(input, decision, outerContext, useContext) {
        if (useContext === undefined) useContext = false;
        let dfa = this.atn.decisionToDFA[decision];
        $bbHFU(dfa != null);
        if (this.optimize_ll1 && !dfa.isPrecedenceDfa && !dfa.isEmpty) {
            let ll_1 = input.LA(1);
            if (ll_1 >= 0 && ll_1 <= 0xFFFF) {
                let key = (decision << 16 >>> 0) + ll_1;
                let alt = this.atn.LL1Table.get(key);
                if (alt != null) return alt;
            }
        }
        this.dfa = dfa;
        if (this.force_global_context) useContext = true;
        else if (!this.always_try_local_context) useContext = useContext || dfa.isContextSensitive;
        this.userWantsCtxSensitive = useContext || this.predictionMode !== $gDZVV.PredictionMode.SLL && outerContext != null && !this.atn.decisionToState[decision].sll;
        if (outerContext == null) outerContext = $6bmaO.ParserRuleContext.emptyContext();
        let state;
        if (!dfa.isEmpty) state = this.getStartState(dfa, input, outerContext, useContext);
        if (state == null) {
            if (outerContext == null) outerContext = $6bmaO.ParserRuleContext.emptyContext();
            if (ParserATNSimulator.debug) console.log("ATN decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input) + ", outerContext=" + outerContext.toString(this._parser));
            state = this.computeStartState(dfa, outerContext, useContext);
        }
        let m = input.mark();
        let index = input.index;
        try {
            let alt = this.execDFA(dfa, input, index, state);
            if (ParserATNSimulator.debug) console.log("DFA after predictATN: " + dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
            return alt;
        } finally{
            this.dfa = undefined;
            input.seek(index);
            input.release(m);
        }
    }
    getStartState(dfa, input, outerContext, useContext) {
        if (!useContext) {
            if (dfa.isPrecedenceDfa) {
                // the start state for a precedence DFA depends on the current
                // parser precedence, and is provided by a DFA method.
                let state = dfa.getPrecedenceStartState(this._parser.precedence, false);
                if (state == null) return undefined;
                return new $g7SCF.SimulatorState(outerContext, state, false, outerContext);
            } else {
                if (dfa.s0 == null) return undefined;
                return new $g7SCF.SimulatorState(outerContext, dfa.s0, false, outerContext);
            }
        }
        if (!this.enable_global_context_dfa) return undefined;
        let remainingContext = outerContext;
        $bbHFU(outerContext != null);
        let s0;
        if (dfa.isPrecedenceDfa) s0 = dfa.getPrecedenceStartState(this._parser.precedence, true);
        else s0 = dfa.s0full;
        while(remainingContext != null && s0 != null && s0.isContextSensitive){
            remainingContext = this.skipTailCalls(remainingContext);
            s0 = s0.getContextTarget(this.getReturnState(remainingContext));
            if (remainingContext.isEmpty) $bbHFU(s0 == null || !s0.isContextSensitive);
            else remainingContext = remainingContext.parent;
        }
        if (s0 == null) return undefined;
        return new $g7SCF.SimulatorState(outerContext, s0, useContext, remainingContext);
    }
    execDFA(dfa, input, startIndex, state) {
        let outerContext = state.outerContext;
        if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input) + ", outerContext=" + outerContext.toString(this._parser));
        if (ParserATNSimulator.dfa_debug) console.log(dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
        let s = state.s0;
        let t = input.LA(1);
        let remainingOuterContext = state.remainingOuterContext;
        while(true){
            if (ParserATNSimulator.dfa_debug) console.log("DFA state " + s.stateNumber + " LA(1)==" + this.getLookaheadName(input));
            if (state.useContext) while(s.isContextSymbol(t)){
                let next;
                if (remainingOuterContext != null) {
                    remainingOuterContext = this.skipTailCalls(remainingOuterContext);
                    next = s.getContextTarget(this.getReturnState(remainingOuterContext));
                }
                if (next == null) {
                    // fail over to ATN
                    let initialState = new $g7SCF.SimulatorState(state.outerContext, s, state.useContext, remainingOuterContext);
                    return this.execATN(dfa, input, startIndex, initialState);
                }
                $bbHFU(remainingOuterContext != null);
                remainingOuterContext = remainingOuterContext.parent;
                s = next;
            }
            if (this.isAcceptState(s, state.useContext)) {
                if (s.predicates != null) {
                    if (ParserATNSimulator.dfa_debug) console.log("accept " + s);
                } else if (ParserATNSimulator.dfa_debug) console.log("accept; predict " + s.prediction + " in state " + s.stateNumber);
                break;
            }
            // t is not updated if one of these states is reached
            $bbHFU(!this.isAcceptState(s, state.useContext));
            // if no edge, pop over to ATN interpreter, update DFA and return
            let target = this.getExistingTargetState(s, t);
            if (target == null) {
                if (ParserATNSimulator.dfa_debug && t >= 0) console.log("no edge for " + this._parser.vocabulary.getDisplayName(t));
                let alt;
                if (ParserATNSimulator.dfa_debug) {
                    let interval = $gcfUE.Interval.of(startIndex, this._parser.inputStream.index);
                    console.log("ATN exec upon " + this._parser.inputStream.getText(interval) + " at DFA state " + s.stateNumber);
                }
                let initialState = new $g7SCF.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                alt = this.execATN(dfa, input, startIndex, initialState);
                if (ParserATNSimulator.dfa_debug) console.log("back from DFA update, alt=" + alt + ", dfa=\n" + dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
                // action already executed
                if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " predicts " + alt);
                return alt; // we've updated DFA, exec'd action, and have our deepest answer
            } else if (target === $kr9A1.ATNSimulator.ERROR) {
                let errorState = new $g7SCF.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                return this.handleNoViableAlt(input, startIndex, errorState);
            }
            s = target;
            if (!this.isAcceptState(s, state.useContext) && t !== $ceaEj.IntStream.EOF) {
                input.consume();
                t = input.LA(1);
            }
        }
        //		if ( acceptState==null ) {
        //			if ( debug ) System.out.println("!!! no viable alt in dfa");
        //			return -1;
        //		}
        if (!state.useContext && s.configs.conflictInfo != null) {
            if (dfa.atnStartState instanceof $dPYn6.DecisionState) {
                if (!this.userWantsCtxSensitive || !s.configs.dipsIntoOuterContext && s.configs.isExactConflict || this.treat_sllk1_conflict_as_ambiguity && input.index === startIndex) ;
                else {
                    $bbHFU(!state.useContext);
                    // Before attempting full context prediction, check to see if there are
                    // disambiguating or validating predicates to evaluate which allow an
                    // immediate decision
                    let conflictingAlts;
                    let predicates = s.predicates;
                    if (predicates != null) {
                        let conflictIndex = input.index;
                        if (conflictIndex !== startIndex) input.seek(startIndex);
                        conflictingAlts = this.evalSemanticContext(predicates, outerContext, true);
                        if (conflictingAlts.cardinality() === 1) return conflictingAlts.nextSetBit(0);
                        if (conflictIndex !== startIndex) // restore the index so reporting the fallback to full
                        // context occurs with the index at the correct spot
                        input.seek(conflictIndex);
                    }
                    if (this.reportAmbiguities) {
                        let conflictState = new $g7SCF.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                        this.reportAttemptingFullContext(dfa, conflictingAlts, conflictState, startIndex, input.index);
                    }
                    input.seek(startIndex);
                    return this.adaptivePredict(input, dfa.decision, outerContext, true);
                }
            }
        }
        // Before jumping to prediction, check to see if there are
        // disambiguating or validating predicates to evaluate
        let predicates = s.predicates;
        if (predicates != null) {
            let stopIndex = input.index;
            if (startIndex !== stopIndex) input.seek(startIndex);
            let alts = this.evalSemanticContext(predicates, outerContext, this.reportAmbiguities && this.predictionMode === $gDZVV.PredictionMode.LL_EXACT_AMBIG_DETECTION);
            switch(alts.cardinality()){
                case 0:
                    throw this.noViableAlt(input, outerContext, s.configs, startIndex);
                case 1:
                    return alts.nextSetBit(0);
                default:
                    // report ambiguity after predicate evaluation to make sure the correct
                    // set of ambig alts is reported.
                    if (startIndex !== stopIndex) input.seek(stopIndex);
                    this.reportAmbiguity(dfa, s, startIndex, stopIndex, s.configs.isExactConflict, alts, s.configs);
                    return alts.nextSetBit(0);
            }
        }
        if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " predicts " + s.prediction);
        return s.prediction;
    }
    /**
     * Determines if a particular DFA state should be treated as an accept state
     * for the current prediction mode. In addition to the `useContext`
     * parameter, the {@link #getPredictionMode()} method provides the
     * prediction mode controlling the prediction algorithm as a whole.
     *
     * The default implementation simply returns the value of
     * `DFAState.isAcceptState` except for conflict states when
     * `useContext` is `true` and {@link #getPredictionMode()} is
     * {@link PredictionMode#LL_EXACT_AMBIG_DETECTION}. In that case, only
     * conflict states where {@link ATNConfigSet#isExactConflict} is
     * `true` are considered accept states.
     *
     * @param state The DFA state to check.
     * @param useContext `true` if the prediction algorithm is currently
     * considering the full parser context; otherwise, `false` if the
     * algorithm is currently performing a local context prediction.
     *
     * @returns `true` if the specified `state` is an accept state;
     * otherwise, `false`.
     */ isAcceptState(state, useContext) {
        if (!state.isAcceptState) return false;
        if (state.configs.conflictingAlts == null) // unambiguous
        return true;
        // More picky when we need exact conflicts
        if (useContext && this.predictionMode === $gDZVV.PredictionMode.LL_EXACT_AMBIG_DETECTION) return state.configs.isExactConflict;
        return true;
    }
    /** Performs ATN simulation to compute a predicted alternative based
     *  upon the remaining input, but also updates the DFA cache to avoid
     *  having to traverse the ATN again for the same input sequence.
     *
     * There are some key conditions we're looking for after computing a new
     * set of ATN configs (proposed DFA state):
     *
     * * if the set is empty, there is no viable alternative for current symbol
     * * does the state uniquely predict an alternative?
     * * does the state have a conflict that would prevent us from
     *   putting it on the work list?
     * * if in non-greedy decision is there a config at a rule stop state?
     *
     * We also have some key operations to do:
     *
     * * add an edge from previous DFA state to potentially new DFA state, D,
     *   upon current symbol but only if adding to work list, which means in all
     *   cases except no viable alternative (and possibly non-greedy decisions?)
     * * collecting predicates and adding semantic context to DFA accept states
     * * adding rule context to context-sensitive DFA accept states
     * * consuming an input symbol
     * * reporting a conflict
     * * reporting an ambiguity
     * * reporting a context sensitivity
     * * reporting insufficient predicates
     *
     * We should isolate those operations, which are side-effecting, to the
     * main work loop. We can isolate lots of code into other functions, but
     * they should be side effect free. They can return package that
     * indicates whether we should report something, whether we need to add a
     * DFA edge, whether we need to augment accept state with semantic
     * context or rule invocation context. Actually, it seems like we always
     * add predicates if they exist, so that can simply be done in the main
     * loop for any accept state creation or modification request.
     *
     * cover these cases:
     *   dead end
     *   single alt
     *   single alt + preds
     *   conflict
     *   conflict + preds
     *
     * TODO: greedy + those
     */ execATN(dfa, input, startIndex, initialState) {
        if (ParserATNSimulator.debug) console.log("execATN decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input));
        let outerContext = initialState.outerContext;
        let useContext = initialState.useContext;
        let t = input.LA(1);
        let previous = initialState;
        let contextCache = new $6vF7J.PredictionContextCache();
        while(true){
            let nextState = this.computeReachSet(dfa, previous, t, contextCache);
            if (nextState == null) {
                this.setDFAEdge(previous.s0, input.LA(1), $kr9A1.ATNSimulator.ERROR);
                return this.handleNoViableAlt(input, startIndex, previous);
            }
            let D = nextState.s0;
            // predicted alt => accept state
            $bbHFU(D.isAcceptState || D.prediction === $bcnvE.ATN.INVALID_ALT_NUMBER);
            // conflicted => accept state
            $bbHFU(D.isAcceptState || D.configs.conflictInfo == null);
            if (this.isAcceptState(D, useContext)) {
                let conflictingAlts = D.configs.conflictingAlts;
                let predictedAlt = conflictingAlts == null ? D.prediction : $bcnvE.ATN.INVALID_ALT_NUMBER;
                if (predictedAlt !== $bcnvE.ATN.INVALID_ALT_NUMBER) {
                    if (this.optimize_ll1 && input.index === startIndex && !dfa.isPrecedenceDfa && nextState.outerContext === nextState.remainingOuterContext && dfa.decision >= 0 && !D.configs.hasSemanticContext) {
                        if (t >= 0 && t <= $ef8fe7d2bd819f1c$var$MAX_SHORT_VALUE) {
                            let key = (dfa.decision << 16 >>> 0) + t;
                            this.atn.LL1Table.set(key, predictedAlt);
                        }
                    }
                    if (useContext && this.always_try_local_context) this.reportContextSensitivity(dfa, predictedAlt, nextState, startIndex, input.index);
                }
                predictedAlt = D.prediction;
                //				int k = input.index - startIndex + 1; // how much input we used
                //				System.out.println("used k="+k);
                let attemptFullContext = conflictingAlts != null && this.userWantsCtxSensitive;
                if (attemptFullContext) // Only exact conflicts are known to be ambiguous when local
                // prediction does not step out of the decision rule.
                attemptFullContext = !useContext && (D.configs.dipsIntoOuterContext || !D.configs.isExactConflict) && (!this.treat_sllk1_conflict_as_ambiguity || input.index !== startIndex);
                if (D.configs.hasSemanticContext) {
                    let predPredictions = D.predicates;
                    if (predPredictions != null) {
                        let conflictIndex = input.index;
                        if (conflictIndex !== startIndex) input.seek(startIndex);
                        // use complete evaluation here if we'll want to retry with full context if still ambiguous
                        conflictingAlts = this.evalSemanticContext(predPredictions, outerContext, attemptFullContext || this.reportAmbiguities);
                        switch(conflictingAlts.cardinality()){
                            case 0:
                                throw this.noViableAlt(input, outerContext, D.configs, startIndex);
                            case 1:
                                return conflictingAlts.nextSetBit(0);
                            default:
                                break;
                        }
                        if (conflictIndex !== startIndex) // restore the index so reporting the fallback to full
                        // context occurs with the index at the correct spot
                        input.seek(conflictIndex);
                    }
                }
                if (!attemptFullContext) {
                    if (conflictingAlts != null) {
                        if (this.reportAmbiguities && conflictingAlts.cardinality() > 1) this.reportAmbiguity(dfa, D, startIndex, input.index, D.configs.isExactConflict, conflictingAlts, D.configs);
                        predictedAlt = conflictingAlts.nextSetBit(0);
                    }
                    return predictedAlt;
                } else {
                    $bbHFU(!useContext);
                    $bbHFU(this.isAcceptState(D, false));
                    if (ParserATNSimulator.debug) console.log("RETRY with outerContext=" + outerContext);
                    let fullContextState = this.computeStartState(dfa, outerContext, true);
                    if (this.reportAmbiguities) this.reportAttemptingFullContext(dfa, conflictingAlts, nextState, startIndex, input.index);
                    input.seek(startIndex);
                    return this.execATN(dfa, input, startIndex, fullContextState);
                }
            }
            previous = nextState;
            if (t !== $ceaEj.IntStream.EOF) {
                input.consume();
                t = input.LA(1);
            }
        }
    }
    /**
     * This method is used to improve the localization of error messages by
     * choosing an alternative rather than throwing a
     * {@link NoViableAltException} in particular prediction scenarios where the
     * {@link #ERROR} state was reached during ATN simulation.
     *
     * The default implementation of this method uses the following
     * algorithm to identify an ATN configuration which successfully parsed the
     * decision entry rule. Choosing such an alternative ensures that the
     * {@link ParserRuleContext} returned by the calling rule will be complete
     * and valid, and the syntax error will be reported later at a more
     * localized location.
     *
     * * If no configuration in `configs` reached the end of the
     *   decision rule, return {@link ATN#INVALID_ALT_NUMBER}.
     * * If all configurations in `configs` which reached the end of the
     *   decision rule predict the same alternative, return that alternative.
     * * If the configurations in `configs` which reached the end of the
     *   decision rule predict multiple alternatives (call this *S*),
     *   choose an alternative in the following order.
     *
     *     1. Filter the configurations in `configs` to only those
     *        configurations which remain viable after evaluating semantic predicates.
     *        If the set of these filtered configurations which also reached the end of
     *        the decision rule is not empty, return the minimum alternative
     *        represented in this set.
     *     1. Otherwise, choose the minimum alternative in *S*.
     *
     * In some scenarios, the algorithm described above could predict an
     * alternative which will result in a {@link FailedPredicateException} in
     * parser. Specifically, this could occur if the *only* configuration
     * capable of successfully parsing to the end of the decision rule is
     * blocked by a semantic predicate. By choosing this alternative within
     * {@link #adaptivePredict} instead of throwing a
     * {@link NoViableAltException}, the resulting
     * {@link FailedPredicateException} in the parser will identify the specific
     * predicate which is preventing the parser from successfully parsing the
     * decision rule, which helps developers identify and correct logic errors
     * in semantic predicates.
     *
     * @param input The input {@link TokenStream}
     * @param startIndex The start index for the current prediction, which is
     * the input index where any semantic context in `configs` should be
     * evaluated
     * @param previous The ATN simulation state immediately before the
     * {@link #ERROR} state was reached
     *
     * @returns The value to return from {@link #adaptivePredict}, or
     * {@link ATN#INVALID_ALT_NUMBER} if a suitable alternative was not
     * identified and {@link #adaptivePredict} should report an error instead.
     */ handleNoViableAlt(input, startIndex, previous) {
        if (previous.s0 != null) {
            let alts = new $5BPMp.BitSet();
            let maxAlt = 0;
            for (let config of previous.s0.configs)if (config.reachesIntoOuterContext || config.state instanceof $4kGBm.RuleStopState) {
                alts.set(config.alt);
                maxAlt = Math.max(maxAlt, config.alt);
            }
            switch(alts.cardinality()){
                case 0:
                    break;
                case 1:
                    return alts.nextSetBit(0);
                default:
                    if (!previous.s0.configs.hasSemanticContext) // configs doesn't contain any predicates, so the predicate
                    // filtering code below would be pointless
                    return alts.nextSetBit(0);
                    /*
                     * Try to find a configuration set that not only dipped into the outer
                     * context, but also isn't eliminated by a predicate.
                     */ let filteredConfigs = new $c1ClW.ATNConfigSet();
                    for (let config of previous.s0.configs)if (config.reachesIntoOuterContext || config.state instanceof $4kGBm.RuleStopState) filteredConfigs.add(config);
                    /* The following code blocks are adapted from predicateDFAState with
                     * the following key changes.
                     *
                     *  1. The code operates on an ATNConfigSet rather than a DFAState.
                     *  2. Predicates are collected for all alternatives represented in
                     *     filteredConfigs, rather than restricting the evaluation to
                     *     conflicting and/or unique configurations.
                     */ let altToPred = this.getPredsForAmbigAlts(alts, filteredConfigs, maxAlt);
                    if (altToPred != null) {
                        let predicates = this.getPredicatePredictions(alts, altToPred);
                        if (predicates != null) {
                            let stopIndex = input.index;
                            try {
                                input.seek(startIndex);
                                let filteredAlts = this.evalSemanticContext(predicates, previous.outerContext, false);
                                if (!filteredAlts.isEmpty) return filteredAlts.nextSetBit(0);
                            } finally{
                                input.seek(stopIndex);
                            }
                        }
                    }
                    return alts.nextSetBit(0);
            }
        }
        throw this.noViableAlt(input, previous.outerContext, previous.s0.configs, startIndex);
    }
    computeReachSet(dfa, previous, t, contextCache) {
        let useContext = previous.useContext;
        let remainingGlobalContext = previous.remainingOuterContext;
        let s = previous.s0;
        if (useContext) while(s.isContextSymbol(t)){
            let next;
            if (remainingGlobalContext != null) {
                remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                next = s.getContextTarget(this.getReturnState(remainingGlobalContext));
            }
            if (next == null) break;
            $bbHFU(remainingGlobalContext != null);
            remainingGlobalContext = remainingGlobalContext.parent;
            s = next;
        }
        $bbHFU(!this.isAcceptState(s, useContext));
        if (this.isAcceptState(s, useContext)) return new $g7SCF.SimulatorState(previous.outerContext, s, useContext, remainingGlobalContext);
        let s0 = s;
        let target = this.getExistingTargetState(s0, t);
        if (target == null) {
            let result = this.computeTargetState(dfa, s0, remainingGlobalContext, t, useContext, contextCache);
            target = result[0];
            remainingGlobalContext = result[1];
        }
        if (target === $kr9A1.ATNSimulator.ERROR) return undefined;
        $bbHFU(!useContext || !target.configs.dipsIntoOuterContext);
        return new $g7SCF.SimulatorState(previous.outerContext, target, useContext, remainingGlobalContext);
    }
    /**
     * Get an existing target state for an edge in the DFA. If the target state
     * for the edge has not yet been computed or is otherwise not available,
     * this method returns `undefined`.
     *
     * @param s The current DFA state
     * @param t The next input symbol
     * @returns The existing target DFA state for the given input symbol
     * `t`, or `undefined` if the target state for this edge is not
     * already cached
     */ getExistingTargetState(s, t) {
        return s.getTarget(t);
    }
    /**
     * Compute a target state for an edge in the DFA, and attempt to add the
     * computed state and corresponding edge to the DFA.
     *
     * @param dfa
     * @param s The current DFA state
     * @param remainingGlobalContext
     * @param t The next input symbol
     * @param useContext
     * @param contextCache
     *
     * @returns The computed target DFA state for the given input symbol
     * `t`. If `t` does not lead to a valid DFA state, this method
     * returns {@link #ERROR}.
     */ computeTargetState(dfa, s, remainingGlobalContext, t, useContext, contextCache) {
        let closureConfigs = s.configs.toArray();
        let contextElements;
        let reach = new $c1ClW.ATNConfigSet();
        let stepIntoGlobal;
        do {
            let hasMoreContext = !useContext || remainingGlobalContext != null;
            if (!hasMoreContext) reach.isOutermostConfigSet = true;
            let reachIntermediate = new $c1ClW.ATNConfigSet();
            /* Configurations already in a rule stop state indicate reaching the end
             * of the decision rule (local context) or end of the start rule (full
             * context). Once reached, these configurations are never updated by a
             * closure operation, so they are handled separately for the performance
             * advantage of having a smaller intermediate set when calling closure.
             *
             * For full-context reach operations, separate handling is required to
             * ensure that the alternative matching the longest overall sequence is
             * chosen when multiple such configurations can match the input.
             */ let skippedStopStates;
            for (let c of closureConfigs){
                if (ParserATNSimulator.debug) console.log("testing " + this.getTokenName(t) + " at " + c.toString());
                if (c.state instanceof $4kGBm.RuleStopState) {
                    $bbHFU(c.context.isEmpty);
                    if (useContext && !c.reachesIntoOuterContext || t === $ceaEj.IntStream.EOF) {
                        if (skippedStopStates == null) skippedStopStates = [];
                        skippedStopStates.push(c);
                    }
                    continue;
                }
                let n = c.state.numberOfOptimizedTransitions;
                for(let ti = 0; ti < n; ti++){
                    let trans = c.state.getOptimizedTransition(ti);
                    let target = this.getReachableTarget(c, trans, t);
                    if (target != null) reachIntermediate.add(c.transform(target, false), contextCache);
                }
            }
            /* This block optimizes the reach operation for intermediate sets which
             * trivially indicate a termination state for the overall
             * adaptivePredict operation.
             *
             * The conditions assume that intermediate
             * contains all configurations relevant to the reach set, but this
             * condition is not true when one or more configurations have been
             * withheld in skippedStopStates, or when the current symbol is EOF.
             */ if (this.optimize_unique_closure && skippedStopStates == null && t !== $2DVsz.Token.EOF && reachIntermediate.uniqueAlt !== $bcnvE.ATN.INVALID_ALT_NUMBER) {
                reachIntermediate.isOutermostConfigSet = reach.isOutermostConfigSet;
                reach = reachIntermediate;
                break;
            }
            /* If the reach set could not be trivially determined, perform a closure
             * operation on the intermediate set to compute its initial value.
             */ let collectPredicates = false;
            let treatEofAsEpsilon = t === $2DVsz.Token.EOF;
            this.closure(reachIntermediate, reach, collectPredicates, hasMoreContext, contextCache, treatEofAsEpsilon);
            stepIntoGlobal = reach.dipsIntoOuterContext;
            if (t === $ceaEj.IntStream.EOF) /* After consuming EOF no additional input is possible, so we are
                 * only interested in configurations which reached the end of the
                 * decision rule (local context) or end of the start rule (full
                 * context). Update reach to contain only these configurations. This
                 * handles both explicit EOF transitions in the grammar and implicit
                 * EOF transitions following the end of the decision or start rule.
                 *
                 * This is handled before the configurations in skippedStopStates,
                 * because any configurations potentially added from that list are
                 * already guaranteed to meet this condition whether or not it's
                 * required.
                 */ reach = this.removeAllConfigsNotInRuleStopState(reach, contextCache);
            /* If skippedStopStates is not undefined, then it contains at least one
             * configuration. For full-context reach operations, these
             * configurations reached the end of the start rule, in which case we
             * only add them back to reach if no configuration during the current
             * closure operation reached such a state. This ensures adaptivePredict
             * chooses an alternative matching the longest overall sequence when
             * multiple alternatives are viable.
             */ if (skippedStopStates != null && (!useContext || !$gDZVV.PredictionMode.hasConfigInRuleStopState(reach))) {
                $bbHFU(skippedStopStates.length > 0);
                for (let c of skippedStopStates)reach.add(c, contextCache);
            }
            if (useContext && stepIntoGlobal) {
                reach.clear();
                // We know remainingGlobalContext is not undefined at this point (why?)
                remainingGlobalContext;
                remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                let nextContextElement = this.getReturnState(remainingGlobalContext);
                if (contextElements == null) contextElements = new $37SGk.IntegerList();
                if (remainingGlobalContext.isEmpty) remainingGlobalContext = undefined;
                else remainingGlobalContext = remainingGlobalContext.parent;
                contextElements.add(nextContextElement);
                if (nextContextElement !== $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) for(let i = 0; i < closureConfigs.length; i++)closureConfigs[i] = closureConfigs[i].appendContext(nextContextElement, contextCache);
            }
        }while (useContext && stepIntoGlobal);
        if (reach.isEmpty) {
            this.setDFAEdge(s, t, $kr9A1.ATNSimulator.ERROR);
            return [
                $kr9A1.ATNSimulator.ERROR,
                remainingGlobalContext
            ];
        }
        let result = this.addDFAEdge(dfa, s, t, contextElements, reach, contextCache);
        return [
            result,
            remainingGlobalContext
        ];
    }
    /**
     * Return a configuration set containing only the configurations from
     * `configs` which are in a {@link RuleStopState}. If all
     * configurations in `configs` are already in a rule stop state, this
     * method simply returns `configs`.
     *
     * @param configs the configuration set to update
     * @param contextCache the {@link PredictionContext} cache
     *
     * @returns `configs` if all configurations in `configs` are in a
     * rule stop state, otherwise return a new configuration set containing only
     * the configurations from `configs` which are in a rule stop state
     */ removeAllConfigsNotInRuleStopState(configs, contextCache) {
        if ($gDZVV.PredictionMode.allConfigsInRuleStopStates(configs)) return configs;
        let result = new $c1ClW.ATNConfigSet();
        for (let config of configs){
            if (!(config.state instanceof $4kGBm.RuleStopState)) continue;
            result.add(config, contextCache);
        }
        return result;
    }
    computeStartState(dfa, globalContext, useContext) {
        let s0 = dfa.isPrecedenceDfa ? dfa.getPrecedenceStartState(this._parser.precedence, useContext) : useContext ? dfa.s0full : dfa.s0;
        if (s0 != null) {
            if (!useContext) return new $g7SCF.SimulatorState(globalContext, s0, useContext, globalContext);
            s0.setContextSensitive(this.atn);
        }
        let decision = dfa.decision;
        // @NotNull
        let p = dfa.atnStartState;
        let previousContext = 0;
        let remainingGlobalContext = globalContext;
        let initialContext = useContext ? $8DTT0.PredictionContext.EMPTY_FULL : $8DTT0.PredictionContext.EMPTY_LOCAL; // always at least the implicit call to start rule
        let contextCache = new $6vF7J.PredictionContextCache();
        if (useContext) {
            if (!this.enable_global_context_dfa) {
                while(remainingGlobalContext != null)if (remainingGlobalContext.isEmpty) {
                    previousContext = $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY;
                    remainingGlobalContext = undefined;
                } else {
                    previousContext = this.getReturnState(remainingGlobalContext);
                    initialContext = initialContext.appendSingleContext(previousContext, contextCache);
                    remainingGlobalContext = remainingGlobalContext.parent;
                }
            }
            while(s0 != null && s0.isContextSensitive && remainingGlobalContext != null){
                let next;
                remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                if (remainingGlobalContext.isEmpty) {
                    next = s0.getContextTarget($8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY);
                    previousContext = $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY;
                    remainingGlobalContext = undefined;
                } else {
                    previousContext = this.getReturnState(remainingGlobalContext);
                    next = s0.getContextTarget(previousContext);
                    initialContext = initialContext.appendSingleContext(previousContext, contextCache);
                    remainingGlobalContext = remainingGlobalContext.parent;
                }
                if (next == null) break;
                s0 = next;
            }
        }
        if (s0 != null && !s0.isContextSensitive) return new $g7SCF.SimulatorState(globalContext, s0, useContext, remainingGlobalContext);
        let configs = new $c1ClW.ATNConfigSet();
        while(true){
            let reachIntermediate = new $c1ClW.ATNConfigSet();
            let n = p.numberOfTransitions;
            for(let ti = 0; ti < n; ti++){
                // for each transition
                let target = p.transition(ti).target;
                reachIntermediate.add($gcX0f.ATNConfig.create(target, ti + 1, initialContext));
            }
            let hasMoreContext = remainingGlobalContext != null;
            if (!hasMoreContext) configs.isOutermostConfigSet = true;
            let collectPredicates = true;
            this.closure(reachIntermediate, configs, collectPredicates, hasMoreContext, contextCache, false);
            let stepIntoGlobal = configs.dipsIntoOuterContext;
            let next;
            if (useContext && !this.enable_global_context_dfa) {
                s0 = this.addDFAState(dfa, configs, contextCache);
                break;
            } else if (s0 == null) {
                if (!dfa.isPrecedenceDfa) {
                    next = this.addDFAState(dfa, configs, contextCache);
                    if (useContext) {
                        if (!dfa.s0full) dfa.s0full = next;
                        else next = dfa.s0full;
                    } else if (!dfa.s0) dfa.s0 = next;
                    else next = dfa.s0;
                } else {
                    /* If this is a precedence DFA, we use applyPrecedenceFilter
                     * to convert the computed start state to a precedence start
                     * state. We then use DFA.setPrecedenceStartState to set the
                     * appropriate start state for the precedence level rather
                     * than simply setting DFA.s0.
                     */ configs = this.applyPrecedenceFilter(configs, globalContext, contextCache);
                    next = this.addDFAState(dfa, configs, contextCache);
                    dfa.setPrecedenceStartState(this._parser.precedence, useContext, next);
                }
            } else {
                if (dfa.isPrecedenceDfa) configs = this.applyPrecedenceFilter(configs, globalContext, contextCache);
                next = this.addDFAState(dfa, configs, contextCache);
                s0.setContextTarget(previousContext, next);
            }
            s0 = next;
            if (!useContext || !stepIntoGlobal) break;
            // TODO: make sure it distinguishes empty stack states
            next.setContextSensitive(this.atn);
            // We know remainingGlobalContext is not undefined at this point (why?)
            remainingGlobalContext;
            configs.clear();
            remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
            let nextContextElement = this.getReturnState(remainingGlobalContext);
            if (remainingGlobalContext.isEmpty) remainingGlobalContext = undefined;
            else remainingGlobalContext = remainingGlobalContext.parent;
            if (nextContextElement !== $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) initialContext = initialContext.appendSingleContext(nextContextElement, contextCache);
            previousContext = nextContextElement;
        }
        return new $g7SCF.SimulatorState(globalContext, s0, useContext, remainingGlobalContext);
    }
    /**
     * This method transforms the start state computed by
     * {@link #computeStartState} to the special start state used by a
     * precedence DFA for a particular precedence value. The transformation
     * process applies the following changes to the start state's configuration
     * set.
     *
     * 1. Evaluate the precedence predicates for each configuration using
     *    {@link SemanticContext#evalPrecedence}.
     * 1. When {@link ATNConfig#isPrecedenceFilterSuppressed} is `false`,
     *    remove all configurations which predict an alternative greater than 1,
     *    for which another configuration that predicts alternative 1 is in the
     *    same ATN state with the same prediction context. This transformation is
     *    valid for the following reasons:
     *
     *     * The closure block cannot contain any epsilon transitions which bypass
     *       the body of the closure, so all states reachable via alternative 1 are
     *       part of the precedence alternatives of the transformed left-recursive
     *       rule.
     *     * The "primary" portion of a left recursive rule cannot contain an
     *       epsilon transition, so the only way an alternative other than 1 can exist
     *       in a state that is also reachable via alternative 1 is by nesting calls
     *       to the left-recursive rule, with the outer calls not being at the
     *       preferred precedence level. The
     *       {@link ATNConfig#isPrecedenceFilterSuppressed} property marks ATN
     *       configurations which do not meet this condition, and therefore are not
     *       eligible for elimination during the filtering process.
     *
     * The prediction context must be considered by this filter to address
     * situations like the following.
     *
     * ```antlr
     * grammar TA;
     * prog: statement* EOF;
     * statement: letterA | statement letterA 'b' ;
     * letterA: 'a';
     * ```
     *
     * If the above grammar, the ATN state immediately before the token
     * reference `'a'` in `letterA` is reachable from the left edge
     * of both the primary and closure blocks of the left-recursive rule
     * `statement`. The prediction context associated with each of these
     * configurations distinguishes between them, and prevents the alternative
     * which stepped out to `prog` (and then back in to `statement`
     * from being eliminated by the filter.
     *
     * @param configs The configuration set computed by
     * {@link #computeStartState} as the start state for the DFA.
     * @returns The transformed configuration set representing the start state
     * for a precedence DFA at a particular precedence level (determined by
     * calling {@link Parser#getPrecedence}).
     */ applyPrecedenceFilter(configs, globalContext, contextCache) {
        let statesFromAlt1 = new Map();
        let configSet = new $c1ClW.ATNConfigSet();
        for (let config of configs){
            // handle alt 1 first
            if (config.alt !== 1) continue;
            let updatedContext = config.semanticContext.evalPrecedence(this._parser, globalContext);
            if (updatedContext == null) continue;
            statesFromAlt1.set(config.state.stateNumber, config.context);
            if (updatedContext !== config.semanticContext) configSet.add(config.transform(config.state, false, updatedContext), contextCache);
            else configSet.add(config, contextCache);
        }
        for (let config of configs){
            if (config.alt === 1) continue;
            if (!config.isPrecedenceFilterSuppressed) {
                /* In the future, this elimination step could be updated to also
                 * filter the prediction context for alternatives predicting alt>1
                 * (basically a graph subtraction algorithm).
                 */ let context = statesFromAlt1.get(config.state.stateNumber);
                if (context != null && context.equals(config.context)) continue;
            }
            configSet.add(config, contextCache);
        }
        return configSet;
    }
    getReachableTarget(source, trans, ttype) {
        if (trans.matches(ttype, 0, this.atn.maxTokenType)) return trans.target;
        return undefined;
    }
    /** collect and set D's semantic context */ predicateDFAState(D, configs, nalts) {
        let conflictingAlts = this.getConflictingAltsFromConfigSet(configs);
        if (!conflictingAlts) throw new Error("This unhandled scenario is intended to be unreachable, but I'm currently not sure of why we know that's the case.");
        if (ParserATNSimulator.debug) console.log("predicateDFAState " + D);
        let altToPred = this.getPredsForAmbigAlts(conflictingAlts, configs, nalts);
        // altToPred[uniqueAlt] is now our validating predicate (if any)
        let predPredictions;
        if (altToPred != null) {
            // we have a validating predicate; test it
            // Update DFA so reach becomes accept state with predicate
            predPredictions = this.getPredicatePredictions(conflictingAlts, altToPred);
            D.predicates = predPredictions;
        }
        return predPredictions;
    }
    getPredsForAmbigAlts(ambigAlts, configs, nalts) {
        // REACH=[1|1|[]|0:0, 1|2|[]|0:1]
        /* altToPred starts as an array of all undefined contexts. The entry at index i
         * corresponds to alternative i. altToPred[i] may have one of three values:
         *   1. undefined: no ATNConfig c is found such that c.alt===i
         *   2. SemanticContext.NONE: At least one ATNConfig c exists such that
         *      c.alt===i and c.semanticContext===SemanticContext.NONE. In other words,
         *      alt i has at least one unpredicated config.
         *   3. Non-NONE Semantic Context: There exists at least one, and for all
         *      ATNConfig c such that c.alt===i, c.semanticContext!==SemanticContext.NONE.
         *
         * From this, it is clear that NONE||anything==NONE.
         */ let altToPred = new Array(nalts + 1);
        let n = altToPred.length;
        for (let c of configs)if (ambigAlts.get(c.alt)) altToPred[c.alt] = $eHMgW.SemanticContext.or(altToPred[c.alt], c.semanticContext);
        let nPredAlts = 0;
        for(let i = 0; i < n; i++){
            if (altToPred[i] == null) altToPred[i] = $eHMgW.SemanticContext.NONE;
            else if (altToPred[i] !== $eHMgW.SemanticContext.NONE) nPredAlts++;
        }
        // At this point we know `altToPred` doesn't contain any undefined entries
        let result = altToPred;
        // nonambig alts are undefined in result
        if (nPredAlts === 0) result = undefined;
        if (ParserATNSimulator.debug) console.log("getPredsForAmbigAlts result " + (result ? $9yG1X.Arrays.toString(result) : "undefined"));
        return result;
    }
    getPredicatePredictions(ambigAlts, altToPred) {
        let pairs = [];
        let containsPredicate = false;
        for(let i = 1; i < altToPred.length; i++){
            let pred = altToPred[i];
            // unpredicated is indicated by SemanticContext.NONE
            $bbHFU(pred != null);
            // find first unpredicated but ambig alternative, if any.
            // Only ambiguous alternatives will have SemanticContext.NONE.
            // Any unambig alts or ambig naked alts after first ambig naked are ignored
            // (undefined, i) means alt i is the default prediction
            // if no (undefined, i), then no default prediction.
            if (ambigAlts != null && ambigAlts.get(i) && pred === $eHMgW.SemanticContext.NONE) pairs.push(new $2jevZ.DFAState.PredPrediction(pred, i));
            else if (pred !== $eHMgW.SemanticContext.NONE) {
                containsPredicate = true;
                pairs.push(new $2jevZ.DFAState.PredPrediction(pred, i));
            }
        }
        if (!containsPredicate) return undefined;
        //		System.out.println(Arrays.toString(altToPred)+"->"+pairs);
        return pairs;
    }
    /** Look through a list of predicate/alt pairs, returning alts for the
     *  pairs that win. An `undefined` predicate indicates an alt containing an
     *  unpredicated config which behaves as "always true."
     */ evalSemanticContext(predPredictions, outerContext, complete) {
        let predictions = new $5BPMp.BitSet();
        for (let pair of predPredictions){
            if (pair.pred === $eHMgW.SemanticContext.NONE) {
                predictions.set(pair.alt);
                if (!complete) break;
                continue;
            }
            let evaluatedResult = this.evalSemanticContextImpl(pair.pred, outerContext, pair.alt);
            if (ParserATNSimulator.debug || ParserATNSimulator.dfa_debug) console.log("eval pred " + pair + "=" + evaluatedResult);
            if (evaluatedResult) {
                if (ParserATNSimulator.debug || ParserATNSimulator.dfa_debug) console.log("PREDICT " + pair.alt);
                predictions.set(pair.alt);
                if (!complete) break;
            }
        }
        return predictions;
    }
    /**
     * Evaluate a semantic context within a specific parser context.
     *
     * This method might not be called for every semantic context evaluated
     * during the prediction process. In particular, we currently do not
     * evaluate the following but it may change in the future:
     *
     * * Precedence predicates (represented by
     *   {@link SemanticContext.PrecedencePredicate}) are not currently evaluated
     *   through this method.
     * * Operator predicates (represented by {@link SemanticContext.AND} and
     *   {@link SemanticContext.OR}) are evaluated as a single semantic
     *   context, rather than evaluating the operands individually.
     *   Implementations which require evaluation results from individual
     *   predicates should override this method to explicitly handle evaluation of
     *   the operands within operator predicates.
     *
     * @param pred The semantic context to evaluate
     * @param parserCallStack The parser context in which to evaluate the
     * semantic context
     * @param alt The alternative which is guarded by `pred`
     *
     * @since 4.3
     */ evalSemanticContextImpl(pred, parserCallStack, alt) {
        return pred.eval(this._parser, parserCallStack);
    }
    /* TODO: If we are doing predicates, there is no point in pursuing
         closure operations if we reach a DFA state that uniquely predicts
         alternative. We will not be caching that DFA state and it is a
         waste to pursue the closure. Might have to advance when we do
         ambig detection thought :(
          */ closure(sourceConfigs, configs, collectPredicates, hasMoreContext, contextCache, treatEofAsEpsilon) {
        if (contextCache == null) contextCache = $6vF7J.PredictionContextCache.UNCACHED;
        let currentConfigs = sourceConfigs;
        let closureBusy = new $7Veax.Array2DHashSet($a4Flx.ObjectEqualityComparator.INSTANCE);
        while(currentConfigs.size > 0){
            let intermediate = new $c1ClW.ATNConfigSet();
            for (let config of currentConfigs)this.closureImpl(config, configs, intermediate, closureBusy, collectPredicates, hasMoreContext, contextCache, 0, treatEofAsEpsilon);
            currentConfigs = intermediate;
        }
    }
    closureImpl(config, configs, intermediate, closureBusy, collectPredicates, hasMoreContexts, contextCache, depth, treatEofAsEpsilon) {
        if (ParserATNSimulator.debug) console.log("closure(" + config.toString(this._parser, true) + ")");
        if (config.state instanceof $4kGBm.RuleStopState) {
            // We hit rule end. If we have context info, use it
            if (!config.context.isEmpty) {
                let hasEmpty = config.context.hasEmpty;
                let nonEmptySize = config.context.size - (hasEmpty ? 1 : 0);
                for(let i = 0; i < nonEmptySize; i++){
                    let newContext = config.context.getParent(i); // "pop" return state
                    let returnState = this.atn.states[config.context.getReturnState(i)];
                    let c = $gcX0f.ATNConfig.create(returnState, config.alt, newContext, config.semanticContext);
                    // While we have context to pop back from, we may have
                    // gotten that context AFTER having fallen off a rule.
                    // Make sure we track that we are now out of context.
                    c.outerContextDepth = config.outerContextDepth;
                    c.isPrecedenceFilterSuppressed = config.isPrecedenceFilterSuppressed;
                    $bbHFU(depth > $ef8fe7d2bd819f1c$var$MIN_INTEGER_VALUE);
                    this.closureImpl(c, configs, intermediate, closureBusy, collectPredicates, hasMoreContexts, contextCache, depth - 1, treatEofAsEpsilon);
                }
                if (!hasEmpty || !hasMoreContexts) return;
                config = config.transform(config.state, false, $8DTT0.PredictionContext.EMPTY_LOCAL);
            } else if (!hasMoreContexts) {
                configs.add(config, contextCache);
                return;
            } else {
                // else if we have no context info, just chase follow links (if greedy)
                if (ParserATNSimulator.debug) console.log("FALLING off rule " + this.getRuleName(config.state.ruleIndex));
                if (config.context === $8DTT0.PredictionContext.EMPTY_FULL) // no need to keep full context overhead when we step out
                config = config.transform(config.state, false, $8DTT0.PredictionContext.EMPTY_LOCAL);
                else if (!config.reachesIntoOuterContext && $8DTT0.PredictionContext.isEmptyLocal(config.context)) // add stop state when leaving decision rule for the first time
                configs.add(config, contextCache);
            }
        }
        let p = config.state;
        // optimization
        if (!p.onlyHasEpsilonTransitions) {
            configs.add(config, contextCache);
            // make sure to not return here, because EOF transitions can act as
            // both epsilon transitions and non-epsilon transitions.
            if (ParserATNSimulator.debug) console.log("added config " + configs);
        }
        for(let i = 0; i < p.numberOfOptimizedTransitions; i++){
            // This block implements first-edge elimination of ambiguous LR
            // alternatives as part of dynamic disambiguation during prediction.
            // See antlr/antlr4#1398.
            if (i === 0 && p.stateType === $1bs3X.ATNStateType.STAR_LOOP_ENTRY && p.precedenceRuleDecision && !config.context.hasEmpty) {
                let precedenceDecision = p;
                // When suppress is true, it means the outgoing edge i==0 is
                // ambiguous with the outgoing edge i==1, and thus the closure
                // operation can dynamically disambiguate by suppressing this
                // edge during the closure operation.
                let suppress = true;
                for(let j = 0; j < config.context.size; j++)if (!precedenceDecision.precedenceLoopbackStates.get(config.context.getReturnState(j))) {
                    suppress = false;
                    break;
                }
                if (suppress) continue;
            }
            let t = p.getOptimizedTransition(i);
            let continueCollecting = !(t instanceof $gxlfY.ActionTransition) && collectPredicates;
            let c = this.getEpsilonTarget(config, t, continueCollecting, depth === 0, contextCache, treatEofAsEpsilon);
            if (c != null) {
                if (t instanceof $aybFP.RuleTransition) {
                    if (intermediate != null && !collectPredicates) {
                        intermediate.add(c, contextCache);
                        continue;
                    }
                }
                let newDepth = depth;
                if (config.state instanceof $4kGBm.RuleStopState) {
                    // target fell off end of rule; mark resulting c as having dipped into outer context
                    // We can't get here if incoming config was rule stop and we had context
                    // track how far we dip into outer context.  Might
                    // come in handy and we avoid evaluating context dependent
                    // preds if this is > 0.
                    if (this.dfa != null && this.dfa.isPrecedenceDfa) {
                        let outermostPrecedenceReturn = t.outermostPrecedenceReturn;
                        if (outermostPrecedenceReturn === this.dfa.atnStartState.ruleIndex) c.isPrecedenceFilterSuppressed = true;
                    }
                    c.outerContextDepth = c.outerContextDepth + 1;
                    if (!closureBusy.add(c)) continue;
                    $bbHFU(newDepth > $ef8fe7d2bd819f1c$var$MIN_INTEGER_VALUE);
                    newDepth--;
                    if (ParserATNSimulator.debug) console.log("dips into outer ctx: " + c);
                } else if (t instanceof $aybFP.RuleTransition) {
                    if (this.optimize_tail_calls && t.optimizedTailCall && (!this.tail_call_preserves_sll || !$8DTT0.PredictionContext.isEmptyLocal(config.context))) {
                        $bbHFU(c.context === config.context);
                        if (newDepth === 0) {
                            // the pop/push of a tail call would keep the depth
                            // constant, except we latch if it goes negative
                            newDepth--;
                            if (!this.tail_call_preserves_sll && $8DTT0.PredictionContext.isEmptyLocal(config.context)) // make sure the SLL config "dips into the outer context" or prediction may not fall back to LL on conflict
                            c.outerContextDepth = c.outerContextDepth + 1;
                        }
                    } else // latch when newDepth goes negative - once we step out of the entry context we can't return
                    if (newDepth >= 0) newDepth++;
                } else {
                    if (!t.isEpsilon && !closureBusy.add(c)) continue;
                }
                this.closureImpl(c, configs, intermediate, closureBusy, continueCollecting, hasMoreContexts, contextCache, newDepth, treatEofAsEpsilon);
            }
        }
    }
    getRuleName(index) {
        if (this._parser != null && index >= 0) return this._parser.ruleNames[index];
        return "<rule " + index + ">";
    }
    getEpsilonTarget(config, t, collectPredicates, inContext, contextCache, treatEofAsEpsilon) {
        switch(t.serializationType){
            case 3 /* RULE */ :
                return this.ruleTransition(config, t, contextCache);
            case 10 /* PRECEDENCE */ :
                return this.precedenceTransition(config, t, collectPredicates, inContext);
            case 4 /* PREDICATE */ :
                return this.predTransition(config, t, collectPredicates, inContext);
            case 6 /* ACTION */ :
                return this.actionTransition(config, t);
            case 1 /* EPSILON */ :
                return config.transform(t.target, false);
            case 5 /* ATOM */ :
            case 2 /* RANGE */ :
            case 7 /* SET */ :
                // EOF transitions act like epsilon transitions after the first EOF
                // transition is traversed
                if (treatEofAsEpsilon) {
                    if (t.matches($2DVsz.Token.EOF, 0, 1)) return config.transform(t.target, false);
                }
                return undefined;
            default:
                return undefined;
        }
    }
    actionTransition(config, t) {
        if (ParserATNSimulator.debug) console.log("ACTION edge " + t.ruleIndex + ":" + t.actionIndex);
        return config.transform(t.target, false);
    }
    precedenceTransition(config, pt, collectPredicates, inContext) {
        if (ParserATNSimulator.debug) {
            console.log("PRED (collectPredicates=" + collectPredicates + ") " + pt.precedence + ">=_p" + ", ctx dependent=true");
            if (this._parser != null) console.log("context surrounding pred is " + this._parser.getRuleInvocationStack());
        }
        let c;
        if (collectPredicates && inContext) {
            let newSemCtx = $eHMgW.SemanticContext.and(config.semanticContext, pt.predicate);
            c = config.transform(pt.target, false, newSemCtx);
        } else c = config.transform(pt.target, false);
        if (ParserATNSimulator.debug) console.log("config from pred transition=" + c);
        return c;
    }
    predTransition(config, pt, collectPredicates, inContext) {
        if (ParserATNSimulator.debug) {
            console.log("PRED (collectPredicates=" + collectPredicates + ") " + pt.ruleIndex + ":" + pt.predIndex + ", ctx dependent=" + pt.isCtxDependent);
            if (this._parser != null) console.log("context surrounding pred is " + this._parser.getRuleInvocationStack());
        }
        let c;
        if (collectPredicates && (!pt.isCtxDependent || pt.isCtxDependent && inContext)) {
            let newSemCtx = $eHMgW.SemanticContext.and(config.semanticContext, pt.predicate);
            c = config.transform(pt.target, false, newSemCtx);
        } else c = config.transform(pt.target, false);
        if (ParserATNSimulator.debug) console.log("config from pred transition=" + c);
        return c;
    }
    ruleTransition(config, t, contextCache) {
        if (ParserATNSimulator.debug) console.log("CALL rule " + this.getRuleName(t.target.ruleIndex) + ", ctx=" + config.context);
        let returnState = t.followState;
        let newContext;
        if (this.optimize_tail_calls && t.optimizedTailCall && (!this.tail_call_preserves_sll || !$8DTT0.PredictionContext.isEmptyLocal(config.context))) newContext = config.context;
        else if (contextCache != null) newContext = contextCache.getChild(config.context, returnState.stateNumber);
        else newContext = config.context.getChild(returnState.stateNumber);
        return config.transform(t.target, false, newContext);
    }
    isConflicted(configset, contextCache) {
        if (configset.uniqueAlt !== $bcnvE.ATN.INVALID_ALT_NUMBER || configset.size <= 1) return undefined;
        let configs = configset.toArray();
        configs.sort(ParserATNSimulator.STATE_ALT_SORT_COMPARATOR);
        let exact = !configset.dipsIntoOuterContext;
        let alts = new $5BPMp.BitSet();
        let minAlt = configs[0].alt;
        alts.set(minAlt);
        /* Quick checks come first (single pass, no context joining):
         *  1. Make sure first config in the sorted list predicts the minimum
         *     represented alternative.
         *  2. Make sure every represented state has at least one configuration
         *     which predicts the minimum represented alternative.
         *  3. (exact only) make sure every represented state has at least one
         *     configuration which predicts each represented alternative.
         */ // quick check 1 & 2 => if we assume #1 holds and check #2 against the
        // minAlt from the first state, #2 will fail if the assumption was
        // incorrect
        let currentState = configs[0].state.nonStopStateNumber;
        for (let config of configs){
            let stateNumber = config.state.nonStopStateNumber;
            if (stateNumber !== currentState) {
                if (config.alt !== minAlt) return undefined;
                currentState = stateNumber;
            }
        }
        let representedAlts;
        if (exact) {
            currentState = configs[0].state.nonStopStateNumber;
            // get the represented alternatives of the first state
            representedAlts = new $5BPMp.BitSet();
            let maxAlt = minAlt;
            for (let config of configs){
                if (config.state.nonStopStateNumber !== currentState) break;
                let alt = config.alt;
                representedAlts.set(alt);
                maxAlt = alt;
            }
            // quick check #3:
            currentState = configs[0].state.nonStopStateNumber;
            let currentAlt = minAlt;
            for (let config of configs){
                let stateNumber = config.state.nonStopStateNumber;
                let alt = config.alt;
                if (stateNumber !== currentState) {
                    if (currentAlt !== maxAlt) {
                        exact = false;
                        break;
                    }
                    currentState = stateNumber;
                    currentAlt = minAlt;
                } else if (alt !== currentAlt) {
                    if (alt !== representedAlts.nextSetBit(currentAlt + 1)) {
                        exact = false;
                        break;
                    }
                    currentAlt = alt;
                }
            }
        }
        currentState = configs[0].state.nonStopStateNumber;
        let firstIndexCurrentState = 0;
        let lastIndexCurrentStateMinAlt = 0;
        let joinedCheckContext = configs[0].context;
        for(let i = 1; i < configs.length; i++){
            let config = configs[i];
            if (config.alt !== minAlt) break;
            if (config.state.nonStopStateNumber !== currentState) break;
            lastIndexCurrentStateMinAlt = i;
            joinedCheckContext = contextCache.join(joinedCheckContext, configs[i].context);
        }
        for(let i = lastIndexCurrentStateMinAlt + 1; i < configs.length; i++){
            let config = configs[i];
            let state = config.state;
            alts.set(config.alt);
            if (state.nonStopStateNumber !== currentState) {
                currentState = state.nonStopStateNumber;
                firstIndexCurrentState = i;
                lastIndexCurrentStateMinAlt = i;
                joinedCheckContext = config.context;
                for(let j = firstIndexCurrentState + 1; j < configs.length; j++){
                    let config2 = configs[j];
                    if (config2.alt !== minAlt) break;
                    if (config2.state.nonStopStateNumber !== currentState) break;
                    lastIndexCurrentStateMinAlt = j;
                    joinedCheckContext = contextCache.join(joinedCheckContext, config2.context);
                }
                i = lastIndexCurrentStateMinAlt;
                continue;
            }
            let joinedCheckContext2 = config.context;
            let currentAlt = config.alt;
            let lastIndexCurrentStateCurrentAlt = i;
            for(let j = lastIndexCurrentStateCurrentAlt + 1; j < configs.length; j++){
                let config2 = configs[j];
                if (config2.alt !== currentAlt) break;
                if (config2.state.nonStopStateNumber !== currentState) break;
                lastIndexCurrentStateCurrentAlt = j;
                joinedCheckContext2 = contextCache.join(joinedCheckContext2, config2.context);
            }
            i = lastIndexCurrentStateCurrentAlt;
            let check = contextCache.join(joinedCheckContext, joinedCheckContext2);
            if (!joinedCheckContext.equals(check)) return undefined;
            // update exact if necessary
            exact = exact && joinedCheckContext.equals(joinedCheckContext2);
        }
        return new $gsRaX.ConflictInfo(alts, exact);
    }
    getConflictingAltsFromConfigSet(configs) {
        let conflictingAlts = configs.conflictingAlts;
        if (conflictingAlts == null && configs.uniqueAlt !== $bcnvE.ATN.INVALID_ALT_NUMBER) {
            conflictingAlts = new $5BPMp.BitSet();
            conflictingAlts.set(configs.uniqueAlt);
        }
        return conflictingAlts;
    }
    getTokenName(t) {
        if (t === $2DVsz.Token.EOF) return "EOF";
        let vocabulary = this._parser != null ? this._parser.vocabulary : $3n2FE.VocabularyImpl.EMPTY_VOCABULARY;
        let displayName = vocabulary.getDisplayName(t);
        if (displayName === String(t)) return displayName;
        return displayName + "<" + t + ">";
    }
    getLookaheadName(input) {
        return this.getTokenName(input.LA(1));
    }
    dumpDeadEndConfigs(nvae) {
        console.log("dead end configs: ");
        let deadEndConfigs = nvae.deadEndConfigs;
        if (!deadEndConfigs) return;
        for (let c of deadEndConfigs){
            let trans = "no edges";
            if (c.state.numberOfOptimizedTransitions > 0) {
                let t = c.state.getOptimizedTransition(0);
                if (t instanceof $5r7n7.AtomTransition) trans = "Atom " + this.getTokenName(t._label);
                else if (t instanceof $Np2R3.SetTransition) {
                    let not = t instanceof $FLEKS.NotSetTransition;
                    trans = (not ? "~" : "") + "Set " + t.set.toString();
                }
            }
            console.log(c.toString(this._parser, true) + ":" + trans);
        }
    }
    noViableAlt(input, outerContext, configs, startIndex) {
        return new $hKCjP.NoViableAltException(this._parser, input, input.get(startIndex), input.LT(1), configs, outerContext);
    }
    getUniqueAlt(configs) {
        let alt = $bcnvE.ATN.INVALID_ALT_NUMBER;
        for (let c of configs){
            if (alt === $bcnvE.ATN.INVALID_ALT_NUMBER) alt = c.alt; // found first alt
            else if (c.alt !== alt) return $bcnvE.ATN.INVALID_ALT_NUMBER;
        }
        return alt;
    }
    configWithAltAtStopState(configs, alt) {
        for (let c of configs)if (c.alt === alt) {
            if (c.state instanceof $4kGBm.RuleStopState) return true;
        }
        return false;
    }
    addDFAEdge(dfa, fromState, t, contextTransitions, toConfigs, contextCache) {
        $bbHFU(contextTransitions == null || contextTransitions.isEmpty || dfa.isContextSensitive);
        let from = fromState;
        let to = this.addDFAState(dfa, toConfigs, contextCache);
        if (contextTransitions != null) for (let context of contextTransitions.toArray()){
            if (context === $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) {
                if (from.configs.isOutermostConfigSet) continue;
            }
            from.setContextSensitive(this.atn);
            from.setContextSymbol(t);
            let next = from.getContextTarget(context);
            if (next != null) {
                from = next;
                continue;
            }
            next = this.addDFAContextState(dfa, from.configs, context, contextCache);
            $bbHFU(context !== $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY || next.configs.isOutermostConfigSet);
            from.setContextTarget(context, next);
            from = next;
        }
        if (ParserATNSimulator.debug) console.log("EDGE " + from + " -> " + to + " upon " + this.getTokenName(t));
        this.setDFAEdge(from, t, to);
        if (ParserATNSimulator.debug) console.log("DFA=\n" + dfa.toString(this._parser != null ? this._parser.vocabulary : $3n2FE.VocabularyImpl.EMPTY_VOCABULARY, this._parser != null ? this._parser.ruleNames : undefined));
        return to;
    }
    setDFAEdge(p, t, q) {
        if (p != null) p.setTarget(t, q);
    }
    /** See comment on LexerInterpreter.addDFAState. */ addDFAContextState(dfa, configs, returnContext, contextCache) {
        if (returnContext !== $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) {
            let contextConfigs = new $c1ClW.ATNConfigSet();
            for (let config of configs)contextConfigs.add(config.appendContext(returnContext, contextCache));
            return this.addDFAState(dfa, contextConfigs, contextCache);
        } else {
            $bbHFU(!configs.isOutermostConfigSet, "Shouldn't be adding a duplicate edge.");
            configs = configs.clone(true);
            configs.isOutermostConfigSet = true;
            return this.addDFAState(dfa, configs, contextCache);
        }
    }
    /** See comment on LexerInterpreter.addDFAState. */ addDFAState(dfa, configs, contextCache) {
        let enableDfa = this.enable_global_context_dfa || !configs.isOutermostConfigSet;
        if (enableDfa) {
            if (!configs.isReadOnly) configs.optimizeConfigs(this);
            let proposed = this.createDFAState(dfa, configs);
            let existing = dfa.states.get(proposed);
            if (existing != null) return existing;
        }
        if (!configs.isReadOnly) {
            if (configs.conflictInfo == null) configs.conflictInfo = this.isConflicted(configs, contextCache);
        }
        let newState = this.createDFAState(dfa, configs.clone(true));
        // getDecisionState won't return undefined when we request a known valid decision
        let decisionState = this.atn.getDecisionState(dfa.decision);
        let predictedAlt = this.getUniqueAlt(configs);
        if (predictedAlt !== $bcnvE.ATN.INVALID_ALT_NUMBER) newState.acceptStateInfo = new $41NTU.AcceptStateInfo(predictedAlt);
        else if (configs.conflictingAlts != null) {
            let conflictingAlts = configs.conflictingAlts;
            if (conflictingAlts) newState.acceptStateInfo = new $41NTU.AcceptStateInfo(conflictingAlts.nextSetBit(0));
        }
        if (newState.isAcceptState && configs.hasSemanticContext) this.predicateDFAState(newState, configs, decisionState.numberOfTransitions);
        if (!enableDfa) return newState;
        let added = dfa.addState(newState);
        if (ParserATNSimulator.debug && added === newState) console.log("adding new DFA state: " + newState);
        return added;
    }
    createDFAState(dfa, configs) {
        return new $2jevZ.DFAState(configs);
    }
    reportAttemptingFullContext(dfa, conflictingAlts, conflictState, startIndex, stopIndex) {
        if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
            let interval = $gcfUE.Interval.of(startIndex, stopIndex);
            console.log("reportAttemptingFullContext decision=" + dfa.decision + ":" + conflictState.s0.configs + ", input=" + this._parser.inputStream.getText(interval));
        }
        if (this._parser != null) {
            let listener = this._parser.getErrorListenerDispatch();
            if (listener.reportAttemptingFullContext) listener.reportAttemptingFullContext(this._parser, dfa, startIndex, stopIndex, conflictingAlts, conflictState);
        }
    }
    reportContextSensitivity(dfa, prediction, acceptState, startIndex, stopIndex) {
        if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
            let interval = $gcfUE.Interval.of(startIndex, stopIndex);
            console.log("reportContextSensitivity decision=" + dfa.decision + ":" + acceptState.s0.configs + ", input=" + this._parser.inputStream.getText(interval));
        }
        if (this._parser != null) {
            let listener = this._parser.getErrorListenerDispatch();
            if (listener.reportContextSensitivity) listener.reportContextSensitivity(this._parser, dfa, startIndex, stopIndex, prediction, acceptState);
        }
    }
    /** If context sensitive parsing, we know it's ambiguity not conflict */ reportAmbiguity(dfa, D, startIndex, stopIndex, exact, ambigAlts, configs) {
        if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
            let interval = $gcfUE.Interval.of(startIndex, stopIndex);
            console.log("reportAmbiguity " + ambigAlts + ":" + configs + ", input=" + this._parser.inputStream.getText(interval));
        }
        if (this._parser != null) {
            let listener = this._parser.getErrorListenerDispatch();
            if (listener.reportAmbiguity) listener.reportAmbiguity(this._parser, dfa, startIndex, stopIndex, exact, ambigAlts, configs);
        }
    }
    getReturnState(context) {
        if (context.isEmpty) return $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY;
        let state = this.atn.states[context.invokingState];
        let transition = state.transition(0);
        return transition.followState.stateNumber;
    }
    skipTailCalls(context) {
        if (!this.optimize_tail_calls) return context;
        while(!context.isEmpty){
            let state = this.atn.states[context.invokingState];
            $bbHFU(state.numberOfTransitions === 1 && state.transition(0).serializationType === 3 /* RULE */ );
            let transition = state.transition(0);
            if (!transition.tailCall) break;
            // This method requires that the root ancestor of the ParserRuleContext be empty. If we make it to this
            // line, we know the current node is not empty, which means it does have a parent.
            context = context.parent;
        }
        return context;
    }
    /**
     * @since 4.3
     */ get parser() {
        return this._parser;
    }
};
$ef8fe7d2bd819f1c$var$ParserATNSimulator.debug = false;
$ef8fe7d2bd819f1c$var$ParserATNSimulator.dfa_debug = false;
$ef8fe7d2bd819f1c$var$ParserATNSimulator.retry_debug = false;
$ef8fe7d2bd819f1c$var$ParserATNSimulator.STATE_ALT_SORT_COMPARATOR = (o1, o2)=>{
    let diff = o1.state.nonStopStateNumber - o2.state.nonStopStateNumber;
    if (diff !== 0) return diff;
    diff = o1.alt - o2.alt;
    if (diff !== 0) return diff;
    return 0;
};
$ef8fe7d2bd819f1c$var$__decorate([
    $d6D31.NotNull
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "predictionMode", void 0);
$ef8fe7d2bd819f1c$var$__decorate([
    $d6D31.NotNull
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getPredictionMode", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "setPredictionMode", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $d6D31.Override
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "reset", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "adaptivePredict", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(2, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getStartState", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(3, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "execDFA", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(3, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "execATN", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(2, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "handleNoViableAlt", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getExistingTargetState", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $d6D31.NotNull,
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "computeTargetState", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $d6D31.NotNull,
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "removeAllConfigsNotInRuleStopState", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $d6D31.NotNull
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "computeStartState", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $d6D31.NotNull,
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "applyPrecedenceFilter", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getReachableTarget", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getPredsForAmbigAlts", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "evalSemanticContext", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "evalSemanticContextImpl", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(4, $d6D31.Nullable)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "closure", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(2, $d6D31.Nullable),
    $ef8fe7d2bd819f1c$var$__param(3, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(6, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "closureImpl", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $d6D31.NotNull
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getRuleName", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getEpsilonTarget", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $d6D31.NotNull,
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "actionTransition", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $d6D31.Nullable,
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "precedenceTransition", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $d6D31.Nullable,
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "predTransition", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $d6D31.NotNull,
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(2, $d6D31.Nullable)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "ruleTransition", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "isConflicted", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $d6D31.NotNull
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getTokenName", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "dumpDeadEndConfigs", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $d6D31.NotNull,
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(2, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "noViableAlt", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getUniqueAlt", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "configWithAltAtStopState", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $d6D31.NotNull,
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(4, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "addDFAEdge", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.Nullable),
    $ef8fe7d2bd819f1c$var$__param(2, $d6D31.Nullable)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "setDFAEdge", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $d6D31.NotNull,
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "addDFAContextState", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $d6D31.NotNull,
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "addDFAState", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $d6D31.NotNull,
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "createDFAState", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(2, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "reportAttemptingFullContext", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(2, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "reportContextSensitivity", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(5, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(6, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "reportAmbiguity", null);
$ef8fe7d2bd819f1c$var$ParserATNSimulator = $ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator);
module.exports.ParserATNSimulator = $ef8fe7d2bd819f1c$var$ParserATNSimulator;

});
parcelRegister("gsRaX", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $bfc8827830a146f2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConflictInfo = void 0;

var $d6D31 = parcelRequire("d6D31");

var $2IEP9 = parcelRequire("2IEP9");
/**
 * This class stores information about a configuration conflict.
 *
 * @author Sam Harwell
 */ class $bfc8827830a146f2$var$ConflictInfo {
    constructor(conflictedAlts, exact){
        this._conflictedAlts = conflictedAlts;
        this.exact = exact;
    }
    /**
     * Gets the set of conflicting alternatives for the configuration set.
     */ get conflictedAlts() {
        return this._conflictedAlts;
    }
    /**
     * Gets whether or not the configuration conflict is an exact conflict.
     * An exact conflict occurs when the prediction algorithm determines that
     * the represented alternatives for a particular configuration set cannot be
     * further reduced by consuming additional input. After reaching an exact
     * conflict during an SLL prediction, only switch to full-context prediction
     * could reduce the set of viable alternatives. In LL prediction, an exact
     * conflict indicates a true ambiguity in the input.
     *
     * For the {@link PredictionMode#LL_EXACT_AMBIG_DETECTION} prediction mode,
     * accept states are conflicting but not exact are treated as non-accept
     * states.
     */ get isExact() {
        return this.exact;
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $bfc8827830a146f2$var$ConflictInfo)) return false;
        return this.isExact === obj.isExact && $2IEP9.equals(this.conflictedAlts, obj.conflictedAlts);
    }
    hashCode() {
        return this.conflictedAlts.hashCode();
    }
}
$bfc8827830a146f2$var$__decorate([
    $d6D31.Override
], $bfc8827830a146f2$var$ConflictInfo.prototype, "equals", null);
$bfc8827830a146f2$var$__decorate([
    $d6D31.Override
], $bfc8827830a146f2$var$ConflictInfo.prototype, "hashCode", null);
module.exports.ConflictInfo = $bfc8827830a146f2$var$ConflictInfo;

});

parcelRegister("6bmaO", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $4804f857ecc73c01$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParserRuleContext = void 0;

var $cdCft = parcelRequire("cdCft");

var $gcfUE = parcelRequire("gcfUE");

var $d6D31 = parcelRequire("d6D31");

var $c8jEe = parcelRequire("c8jEe");

var $kYC92 = parcelRequire("kYC92");
/** A rule invocation record for parsing.
 *
 *  Contains all of the information about the current rule not stored in the
 *  RuleContext. It handles parse tree children list, Any ATN state
 *  tracing, and the default values available for rule invocations:
 *  start, stop, rule index, current alt number.
 *
 *  Subclasses made for each rule and grammar track the parameters,
 *  return values, locals, and labels specific to that rule. These
 *  are the objects that are returned from rules.
 *
 *  Note text is not an actual field of a rule return value; it is computed
 *  from start and stop using the input stream's toString() method.  I
 *  could add a ctor to this so that we can pass in and store the input
 *  stream, but I'm not sure we want to do that.  It would seem to be undefined
 *  to get the .text property anyway if the rule matches tokens from multiple
 *  input streams.
 *
 *  I do not use getters for fields of objects that are used simply to
 *  group values such as this aggregate.  The getters/setters are there to
 *  satisfy the superclass interface.
 */ class $4804f857ecc73c01$var$ParserRuleContext extends $c8jEe.RuleContext {
    constructor(parent, invokingStateNumber){
        if (invokingStateNumber == null) super();
        else super(parent, invokingStateNumber);
    }
    static emptyContext() {
        return $4804f857ecc73c01$var$ParserRuleContext.EMPTY;
    }
    /**
     * COPY a ctx (I'm deliberately not using copy constructor) to avoid
     * confusion with creating node with parent. Does not copy children
     * (except error leaves).
     *
     * This is used in the generated parser code to flip a generic XContext
     * node for rule X to a YContext for alt label Y. In that sense, it is not
     * really a generic copy function.
     *
     * If we do an error sync() at start of a rule, we might add error nodes
     * to the generic XContext so this function must copy those nodes to the
     * YContext as well else they are lost!
     */ copyFrom(ctx) {
        this._parent = ctx._parent;
        this.invokingState = ctx.invokingState;
        this._start = ctx._start;
        this._stop = ctx._stop;
        // copy any error nodes to alt label node
        if (ctx.children) {
            this.children = [];
            // reset parent pointer for any error nodes
            for (let child of ctx.children)if (child instanceof $cdCft.ErrorNode) this.addChild(child);
        }
    }
    // Double dispatch methods for listeners
    enterRule(listener) {
    // intentionally empty
    }
    exitRule(listener) {
    // intentionally empty
    }
    /** Add a parse tree node to this as a child.  Works for
     *  internal and leaf nodes. Does not set parent link;
     *  other add methods must do that. Other addChild methods
     *  call this.
     *
     *  We cannot set the parent pointer of the incoming node
     *  because the existing interfaces do not have a setParent()
     *  method and I don't want to break backward compatibility for this.
     *
     *  @since 4.7
     */ addAnyChild(t) {
        if (!this.children) this.children = [
            t
        ];
        else this.children.push(t);
        return t;
    }
    addChild(t) {
        let result;
        if (t instanceof $kYC92.TerminalNode) {
            t.setParent(this);
            this.addAnyChild(t);
            return;
        } else if (t instanceof $c8jEe.RuleContext) {
            // Does not set parent link
            this.addAnyChild(t);
            return;
        } else {
            // Deprecated code path
            t = new $kYC92.TerminalNode(t);
            this.addAnyChild(t);
            t.setParent(this);
            return t;
        }
    }
    addErrorNode(node) {
        if (node instanceof $cdCft.ErrorNode) {
            const errorNode = node;
            errorNode.setParent(this);
            return this.addAnyChild(errorNode);
        } else {
            // deprecated path
            const badToken = node;
            let t = new $cdCft.ErrorNode(badToken);
            this.addAnyChild(t);
            t.setParent(this);
            return t;
        }
    }
    //	public void trace(int s) {
    //		if ( states==null ) states = new ArrayList<Integer>();
    //		states.add(s);
    //	}
    /** Used by enterOuterAlt to toss out a RuleContext previously added as
     *  we entered a rule. If we have # label, we will need to remove
     *  generic ruleContext object.
     */ removeLastChild() {
        if (this.children) this.children.pop();
    }
    get parent() {
        let parent = super.parent;
        if (parent === undefined || parent instanceof $4804f857ecc73c01$var$ParserRuleContext) return parent;
        throw new TypeError("Invalid parent type for ParserRuleContext");
    }
    // Note: in TypeScript, order or arguments reversed
    getChild(i, ctxType) {
        if (!this.children || i < 0 || i >= this.children.length) throw new RangeError("index parameter must be between >= 0 and <= number of children.");
        if (ctxType == null) return this.children[i];
        let result = this.tryGetChild(i, ctxType);
        if (result === undefined) throw new Error("The specified node does not exist");
        return result;
    }
    tryGetChild(i, ctxType) {
        if (!this.children || i < 0 || i >= this.children.length) return undefined;
        let j = -1; // what node with ctxType have we found?
        for (let o of this.children)if (o instanceof ctxType) {
            j++;
            if (j === i) return o;
        }
        return undefined;
    }
    getToken(ttype, i) {
        let result = this.tryGetToken(ttype, i);
        if (result === undefined) throw new Error("The specified token does not exist");
        return result;
    }
    tryGetToken(ttype, i) {
        if (!this.children || i < 0 || i >= this.children.length) return undefined;
        let j = -1; // what token with ttype have we found?
        for (let o of this.children)if (o instanceof $kYC92.TerminalNode) {
            let symbol = o.symbol;
            if (symbol.type === ttype) {
                j++;
                if (j === i) return o;
            }
        }
        return undefined;
    }
    getTokens(ttype) {
        let tokens = [];
        if (!this.children) return tokens;
        for (let o of this.children)if (o instanceof $kYC92.TerminalNode) {
            let symbol = o.symbol;
            if (symbol.type === ttype) tokens.push(o);
        }
        return tokens;
    }
    get ruleContext() {
        return this;
    }
    // NOTE: argument order change from Java version
    getRuleContext(i, ctxType) {
        return this.getChild(i, ctxType);
    }
    tryGetRuleContext(i, ctxType) {
        return this.tryGetChild(i, ctxType);
    }
    getRuleContexts(ctxType) {
        let contexts = [];
        if (!this.children) return contexts;
        for (let o of this.children)if (o instanceof ctxType) contexts.push(o);
        return contexts;
    }
    get childCount() {
        return this.children ? this.children.length : 0;
    }
    get sourceInterval() {
        if (!this._start) return $gcfUE.Interval.INVALID;
        if (!this._stop || this._stop.tokenIndex < this._start.tokenIndex) return $gcfUE.Interval.of(this._start.tokenIndex, this._start.tokenIndex - 1); // empty
        return $gcfUE.Interval.of(this._start.tokenIndex, this._stop.tokenIndex);
    }
    /**
     * Get the initial token in this context.
     * Note that the range from start to stop is inclusive, so for rules that do not consume anything
     * (for example, zero length or error productions) this token may exceed stop.
     */ get start() {
        return this._start;
    }
    /**
     * Get the final token in this context.
     * Note that the range from start to stop is inclusive, so for rules that do not consume anything
     * (for example, zero length or error productions) this token may precede start.
     */ get stop() {
        return this._stop;
    }
    /** Used for rule context info debugging during parse-time, not so much for ATN debugging */ toInfoString(recognizer) {
        let rules = recognizer.getRuleInvocationStack(this).reverse();
        return "ParserRuleContext" + rules + "{" + "start=" + this._start + ", stop=" + this._stop + "}";
    }
}
$4804f857ecc73c01$var$ParserRuleContext.EMPTY = new $4804f857ecc73c01$var$ParserRuleContext();
$4804f857ecc73c01$var$__decorate([
    $d6D31.Override
], $4804f857ecc73c01$var$ParserRuleContext.prototype, "parent", null);
$4804f857ecc73c01$var$__decorate([
    $d6D31.Override
], $4804f857ecc73c01$var$ParserRuleContext.prototype, "childCount", null);
$4804f857ecc73c01$var$__decorate([
    $d6D31.Override
], $4804f857ecc73c01$var$ParserRuleContext.prototype, "sourceInterval", null);
module.exports.ParserRuleContext = $4804f857ecc73c01$var$ParserRuleContext;

});
parcelRegister("cdCft", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $8e545e4dd69efabc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorNode = void 0;

var $d6D31 = parcelRequire("d6D31");

var $kYC92 = parcelRequire("kYC92");
/** Represents a token that was consumed during resynchronization
 *  rather than during a valid match operation. For example,
 *  we will create this kind of a node during single token insertion
 *  and deletion as well as during "consume until error recovery set"
 *  upon no viable alternative exceptions.
 */ class $8e545e4dd69efabc$var$ErrorNode extends $kYC92.TerminalNode {
    constructor(token){
        super(token);
    }
    accept(visitor) {
        return visitor.visitErrorNode(this);
    }
}
$8e545e4dd69efabc$var$__decorate([
    $d6D31.Override
], $8e545e4dd69efabc$var$ErrorNode.prototype, "accept", null);
module.exports.ErrorNode = $8e545e4dd69efabc$var$ErrorNode;

});
parcelRegister("kYC92", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f4570001c9e8b34c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TerminalNode = void 0;

var $gcfUE = parcelRequire("gcfUE");

var $d6D31 = parcelRequire("d6D31");

var $2DVsz = parcelRequire("2DVsz");
class $f4570001c9e8b34c$var$TerminalNode {
    constructor(symbol){
        this._symbol = symbol;
    }
    getChild(i) {
        throw new RangeError("Terminal Node has no children.");
    }
    get symbol() {
        return this._symbol;
    }
    get parent() {
        return this._parent;
    }
    setParent(parent) {
        this._parent = parent;
    }
    get payload() {
        return this._symbol;
    }
    get sourceInterval() {
        let tokenIndex = this._symbol.tokenIndex;
        return new $gcfUE.Interval(tokenIndex, tokenIndex);
    }
    get childCount() {
        return 0;
    }
    accept(visitor) {
        return visitor.visitTerminal(this);
    }
    get text() {
        return this._symbol.text || "";
    }
    toStringTree(parser) {
        return this.toString();
    }
    toString() {
        if (this._symbol.type === $2DVsz.Token.EOF) return "<EOF>";
        return this._symbol.text || "";
    }
}
$f4570001c9e8b34c$var$__decorate([
    $d6D31.Override
], $f4570001c9e8b34c$var$TerminalNode.prototype, "getChild", null);
$f4570001c9e8b34c$var$__decorate([
    $d6D31.Override
], $f4570001c9e8b34c$var$TerminalNode.prototype, "parent", null);
$f4570001c9e8b34c$var$__decorate([
    $d6D31.Override
], $f4570001c9e8b34c$var$TerminalNode.prototype, "setParent", null);
$f4570001c9e8b34c$var$__decorate([
    $d6D31.Override
], $f4570001c9e8b34c$var$TerminalNode.prototype, "payload", null);
$f4570001c9e8b34c$var$__decorate([
    $d6D31.Override
], $f4570001c9e8b34c$var$TerminalNode.prototype, "sourceInterval", null);
$f4570001c9e8b34c$var$__decorate([
    $d6D31.Override
], $f4570001c9e8b34c$var$TerminalNode.prototype, "childCount", null);
$f4570001c9e8b34c$var$__decorate([
    $d6D31.Override
], $f4570001c9e8b34c$var$TerminalNode.prototype, "accept", null);
$f4570001c9e8b34c$var$__decorate([
    $d6D31.Override
], $f4570001c9e8b34c$var$TerminalNode.prototype, "text", null);
$f4570001c9e8b34c$var$__decorate([
    $d6D31.Override
], $f4570001c9e8b34c$var$TerminalNode.prototype, "toStringTree", null);
$f4570001c9e8b34c$var$__decorate([
    $d6D31.Override
], $f4570001c9e8b34c$var$TerminalNode.prototype, "toString", null);
module.exports.TerminalNode = $f4570001c9e8b34c$var$TerminalNode;

});


parcelRegister("c8jEe", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $8d557908ece2e6d0$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleContext = void 0;

var $bcnvE = parcelRequire("bcnvE");

var $kBaAZ = parcelRequire("kBaAZ");

var $2WQcE = parcelRequire("2WQcE");

var $gcfUE = parcelRequire("gcfUE");

var $d6D31 = parcelRequire("d6D31");

var $axprj = parcelRequire("axprj");

var $6bmaO = parcelRequire("6bmaO");
/** A rule context is a record of a single rule invocation.
 *
 *  We form a stack of these context objects using the parent
 *  pointer. A parent pointer of `undefined` indicates that the current
 *  context is the bottom of the stack. The ParserRuleContext subclass
 *  as a children list so that we can turn this data structure into a
 *  tree.
 *
 *  The root node always has a `undefined` pointer and invokingState of -1.
 *
 *  Upon entry to parsing, the first invoked rule function creates a
 *  context object (a subclass specialized for that rule such as
 *  SContext) and makes it the root of a parse tree, recorded by field
 *  Parser._ctx.
 *
 *  public final SContext s() throws RecognitionException {
 *      SContext _localctx = new SContext(_ctx, state); <-- create new node
 *      enterRule(_localctx, 0, RULE_s);                     <-- push it
 *      ...
 *      exitRule();                                          <-- pop back to _localctx
 *      return _localctx;
 *  }
 *
 *  A subsequent rule invocation of r from the start rule s pushes a
 *  new context object for r whose parent points at s and use invoking
 *  state is the state with r emanating as edge label.
 *
 *  The invokingState fields from a context object to the root
 *  together form a stack of rule indication states where the root
 *  (bottom of the stack) has a -1 sentinel value. If we invoke start
 *  symbol s then call r1, which calls r2, the  would look like
 *  this:
 *
 *     SContext[-1]   <- root node (bottom of the stack)
 *     R1Context[p]   <- p in rule s called r1
 *     R2Context[q]   <- q in rule r1 called r2
 *
 *  So the top of the stack, _ctx, represents a call to the current
 *  rule and it holds the return address from another rule that invoke
 *  to this rule. To invoke a rule, we must always have a current context.
 *
 *  The parent contexts are useful for computing lookahead sets and
 *  getting error information.
 *
 *  These objects are used during parsing and prediction.
 *  For the special case of parsers, we use the subclass
 *  ParserRuleContext.
 *
 *  @see ParserRuleContext
 */ class $8d557908ece2e6d0$var$RuleContext extends $2WQcE.RuleNode {
    constructor(parent, invokingState){
        super();
        this._parent = parent;
        this.invokingState = invokingState != null ? invokingState : -1;
    }
    static getChildContext(parent, invokingState) {
        return new $8d557908ece2e6d0$var$RuleContext(parent, invokingState);
    }
    depth() {
        let n = 0;
        let p = this;
        while(p){
            p = p._parent;
            n++;
        }
        return n;
    }
    /** A context is empty if there is no invoking state; meaning nobody called
     *  current context.
     */ get isEmpty() {
        return this.invokingState === -1;
    }
    // satisfy the ParseTree / SyntaxTree interface
    get sourceInterval() {
        return $gcfUE.Interval.INVALID;
    }
    get ruleContext() {
        return this;
    }
    get parent() {
        return this._parent;
    }
    /** @since 4.7. {@see ParseTree#setParent} comment */ setParent(parent) {
        this._parent = parent;
    }
    get payload() {
        return this;
    }
    /** Return the combined text of all child nodes. This method only considers
     *  tokens which have been added to the parse tree.
     *
     *  Since tokens on hidden channels (e.g. whitespace or comments) are not
     *  added to the parse trees, they will not appear in the output of this
     *  method.
     */ get text() {
        if (this.childCount === 0) return "";
        let builder = "";
        for(let i = 0; i < this.childCount; i++)builder += this.getChild(i).text;
        return builder.toString();
    }
    get ruleIndex() {
        return -1;
    }
    /** For rule associated with this parse tree internal node, return
     *  the outer alternative number used to match the input. Default
     *  implementation does not compute nor store this alt num. Create
     *  a subclass of ParserRuleContext with backing field and set
     *  option contextSuperClass.
     *  to set it.
     *
     *  @since 4.5.3
     */ get altNumber() {
        return $bcnvE.ATN.INVALID_ALT_NUMBER;
    }
    /** Set the outer alternative number for this context node. Default
     *  implementation does nothing to avoid backing field overhead for
     *  trees that don't need it.  Create
     *  a subclass of ParserRuleContext with backing field and set
     *  option contextSuperClass.
     *
     *  @since 4.5.3
     */ set altNumber(altNumber) {
    // intentionally ignored by the base implementation
    }
    getChild(i) {
        throw new RangeError("i must be greater than or equal to 0 and less than childCount");
    }
    get childCount() {
        return 0;
    }
    accept(visitor) {
        return visitor.visitChildren(this);
    }
    toStringTree(recog) {
        return $axprj.Trees.toStringTree(this, recog);
    }
    toString(arg1, stop) {
        const ruleNames = arg1 instanceof $kBaAZ.Recognizer ? arg1.ruleNames : arg1;
        stop = stop || $6bmaO.ParserRuleContext.emptyContext();
        let buf = "";
        let p = this;
        buf += "[";
        while(p && p !== stop){
            if (!ruleNames) {
                if (!p.isEmpty) buf += p.invokingState;
            } else {
                let ruleIndex = p.ruleIndex;
                let ruleName = ruleIndex >= 0 && ruleIndex < ruleNames.length ? ruleNames[ruleIndex] : ruleIndex.toString();
                buf += ruleName;
            }
            if (p._parent && (ruleNames || !p._parent.isEmpty)) buf += " ";
            p = p._parent;
        }
        buf += "]";
        return buf.toString();
    }
}
$8d557908ece2e6d0$var$__decorate([
    $d6D31.Override
], $8d557908ece2e6d0$var$RuleContext.prototype, "sourceInterval", null);
$8d557908ece2e6d0$var$__decorate([
    $d6D31.Override
], $8d557908ece2e6d0$var$RuleContext.prototype, "ruleContext", null);
$8d557908ece2e6d0$var$__decorate([
    $d6D31.Override
], $8d557908ece2e6d0$var$RuleContext.prototype, "parent", null);
$8d557908ece2e6d0$var$__decorate([
    $d6D31.Override
], $8d557908ece2e6d0$var$RuleContext.prototype, "setParent", null);
$8d557908ece2e6d0$var$__decorate([
    $d6D31.Override
], $8d557908ece2e6d0$var$RuleContext.prototype, "payload", null);
$8d557908ece2e6d0$var$__decorate([
    $d6D31.Override
], $8d557908ece2e6d0$var$RuleContext.prototype, "text", null);
$8d557908ece2e6d0$var$__decorate([
    $d6D31.Override
], $8d557908ece2e6d0$var$RuleContext.prototype, "getChild", null);
$8d557908ece2e6d0$var$__decorate([
    $d6D31.Override
], $8d557908ece2e6d0$var$RuleContext.prototype, "childCount", null);
$8d557908ece2e6d0$var$__decorate([
    $d6D31.Override
], $8d557908ece2e6d0$var$RuleContext.prototype, "accept", null);
$8d557908ece2e6d0$var$__decorate([
    $d6D31.Override
], $8d557908ece2e6d0$var$RuleContext.prototype, "toStringTree", null);
module.exports.RuleContext = $8d557908ece2e6d0$var$RuleContext;

});
parcelRegister("2WQcE", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleNode = void 0;
class $22597dffc9942eb7$var$RuleNode {
}
module.exports.RuleNode = $22597dffc9942eb7$var$RuleNode;

});

parcelRegister("axprj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7ac0b835c35ad12a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $7ac0b835c35ad12a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Trees = void 0;

var $bcnvE = parcelRequire("bcnvE");

var $j53rr = parcelRequire("j53rr");

var $cdCft = parcelRequire("cdCft");

var $d6D31 = parcelRequire("d6D31");

var $jIG0W = parcelRequire("jIG0W");

var $6bmaO = parcelRequire("6bmaO");

var $2WQcE = parcelRequire("2WQcE");

var $kYC92 = parcelRequire("kYC92");

var $2DVsz = parcelRequire("2DVsz");

var $2IEP9 = parcelRequire("2IEP9");
/** A set of utility routines useful for all kinds of ANTLR trees. */ class $7ac0b835c35ad12a$var$Trees {
    static toStringTree(t, arg2) {
        let ruleNames;
        if (arg2 instanceof $jIG0W.Parser) ruleNames = arg2.ruleNames;
        else ruleNames = arg2;
        let s = $2IEP9.escapeWhitespace(this.getNodeText(t, ruleNames), false);
        if (t.childCount === 0) return s;
        let buf = "";
        buf += "(";
        s = $2IEP9.escapeWhitespace(this.getNodeText(t, ruleNames), false);
        buf += s;
        buf += " ";
        for(let i = 0; i < t.childCount; i++){
            if (i > 0) buf += " ";
            buf += this.toStringTree(t.getChild(i), ruleNames);
        }
        buf += ")";
        return buf;
    }
    static getNodeText(t, arg2) {
        let ruleNames;
        if (arg2 instanceof $jIG0W.Parser) ruleNames = arg2.ruleNames;
        else if (arg2) ruleNames = arg2;
        else {
            // no recog or rule names
            let payload = t.payload;
            if (typeof payload.text === "string") return payload.text;
            return t.payload.toString();
        }
        if (t instanceof $2WQcE.RuleNode) {
            let ruleContext = t.ruleContext;
            let ruleIndex = ruleContext.ruleIndex;
            let ruleName = ruleNames[ruleIndex];
            let altNumber = ruleContext.altNumber;
            if (altNumber !== $bcnvE.ATN.INVALID_ALT_NUMBER) return ruleName + ":" + altNumber;
            return ruleName;
        } else if (t instanceof $cdCft.ErrorNode) return t.toString();
        else if (t instanceof $kYC92.TerminalNode) {
            let symbol = t.symbol;
            return symbol.text || "";
        }
        throw new TypeError("Unexpected node type");
    }
    static getChildren(t) {
        let kids = [];
        for(let i = 0; i < t.childCount; i++)kids.push(t.getChild(i));
        return kids;
    }
    static getAncestors(t) {
        let ancestors = [];
        let p = t.parent;
        while(p){
            ancestors.unshift(p); // insert at start
            p = p.parent;
        }
        return ancestors;
    }
    /** Return true if t is u's parent or a node on path to root from u.
     *  Use === not equals().
     *
     *  @since 4.5.1
     */ static isAncestorOf(t, u) {
        if (!t || !u || !t.parent) return false;
        let p = u.parent;
        while(p){
            if (t === p) return true;
            p = p.parent;
        }
        return false;
    }
    static findAllTokenNodes(t, ttype) {
        return $7ac0b835c35ad12a$var$Trees.findAllNodes(t, ttype, true);
    }
    static findAllRuleNodes(t, ruleIndex) {
        return $7ac0b835c35ad12a$var$Trees.findAllNodes(t, ruleIndex, false);
    }
    static findAllNodes(t, index, findTokens) {
        let nodes = [];
        $7ac0b835c35ad12a$var$Trees._findAllNodes(t, index, findTokens, nodes);
        return nodes;
    }
    static _findAllNodes(t, index, findTokens, nodes) {
        // check this node (the root) first
        if (findTokens && t instanceof $kYC92.TerminalNode) {
            if (t.symbol.type === index) nodes.push(t);
        } else if (!findTokens && t instanceof $6bmaO.ParserRuleContext) {
            if (t.ruleIndex === index) nodes.push(t);
        }
        // check children
        for(let i = 0; i < t.childCount; i++)$7ac0b835c35ad12a$var$Trees._findAllNodes(t.getChild(i), index, findTokens, nodes);
    }
    /** Get all descendents; includes t itself.
     *
     * @since 4.5.1
     */ static getDescendants(t) {
        let nodes = [];
        function recurse(e) {
            nodes.push(e);
            const n = e.childCount;
            for(let i = 0; i < n; i++)recurse(e.getChild(i));
        }
        recurse(t);
        return nodes;
    }
    /** Find smallest subtree of t enclosing range startTokenIndex..stopTokenIndex
     *  inclusively using postorder traversal.  Recursive depth-first-search.
     *
     *  @since 4.5
     */ static getRootOfSubtreeEnclosingRegion(t, startTokenIndex, stopTokenIndex) {
        let n = t.childCount;
        for(let i = 0; i < n; i++){
            let child = t.getChild(i);
            let r = $7ac0b835c35ad12a$var$Trees.getRootOfSubtreeEnclosingRegion(child, startTokenIndex, stopTokenIndex);
            if (r) return r;
        }
        if (t instanceof $6bmaO.ParserRuleContext) {
            let stopToken = t.stop;
            if (startTokenIndex >= t.start.tokenIndex && // is range fully contained in t?
            (stopToken == null || stopTokenIndex <= stopToken.tokenIndex)) // note: r.stop==null likely implies that we bailed out of parser and there's nothing to the right
            return t;
        }
        return undefined;
    }
    /** Replace any subtree siblings of root that are completely to left
     *  or right of lookahead range with a CommonToken(Token.INVALID_TYPE,"...")
     *  node. The source interval for t is not altered to suit smaller range!
     *
     *  WARNING: destructive to t.
     *
     *  @since 4.5.1
     */ static stripChildrenOutOfRange(t, root, startIndex, stopIndex) {
        if (!t) return;
        let count = t.childCount;
        for(let i = 0; i < count; i++){
            let child = t.getChild(i);
            let range = child.sourceInterval;
            if (child instanceof $6bmaO.ParserRuleContext && (range.b < startIndex || range.a > stopIndex)) {
                if ($7ac0b835c35ad12a$var$Trees.isAncestorOf(child, root)) {
                    let abbrev = new $j53rr.CommonToken($2DVsz.Token.INVALID_TYPE, "...");
                    t.children[i] = new $kYC92.TerminalNode(abbrev); // HACK access to private
                }
            }
        }
    }
    static findNodeSuchThat(t, pred) {
        // No type check needed as long as users only use one of the available overloads
        if (pred(t)) return t;
        let n = t.childCount;
        for(let i = 0; i < n; i++){
            let u = $7ac0b835c35ad12a$var$Trees.findNodeSuchThat(t.getChild(i), pred);
            if (u !== undefined) return u;
        }
        return undefined;
    }
}
$7ac0b835c35ad12a$var$__decorate([
    $7ac0b835c35ad12a$var$__param(0, $d6D31.NotNull)
], $7ac0b835c35ad12a$var$Trees, "toStringTree", null);
$7ac0b835c35ad12a$var$__decorate([
    $d6D31.NotNull,
    $7ac0b835c35ad12a$var$__param(0, $d6D31.NotNull)
], $7ac0b835c35ad12a$var$Trees, "getAncestors", null);
$7ac0b835c35ad12a$var$__decorate([
    $7ac0b835c35ad12a$var$__param(0, $d6D31.NotNull)
], $7ac0b835c35ad12a$var$Trees, "getRootOfSubtreeEnclosingRegion", null);
module.exports.Trees = $7ac0b835c35ad12a$var$Trees;

});



parcelRegister("gDZVV", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c1e05489d1cdbc78$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredictionMode = void 0;

var $fP17P = parcelRequire("fP17P");

var $iXFjm = parcelRequire("iXFjm");

var $d6D31 = parcelRequire("d6D31");

var $4kGBm = parcelRequire("4kGBm");
/**
 * This enumeration defines the prediction modes available in ANTLR 4 along with
 * utility methods for analyzing configuration sets for conflicts and/or
 * ambiguities.
 */ var $c1e05489d1cdbc78$var$PredictionMode;
(function(PredictionMode) {
    /**
     * The SLL(*) prediction mode. This prediction mode ignores the current
     * parser context when making predictions. This is the fastest prediction
     * mode, and provides correct results for many grammars. This prediction
     * mode is more powerful than the prediction mode provided by ANTLR 3, but
     * may result in syntax errors for grammar and input combinations which are
     * not SLL.
     *
     * When using this prediction mode, the parser will either return a correct
     * parse tree (i.e. the same parse tree that would be returned with the
     * {@link #LL} prediction mode), or it will report a syntax error. If a
     * syntax error is encountered when using the {@link #SLL} prediction mode,
     * it may be due to either an actual syntax error in the input or indicate
     * that the particular combination of grammar and input requires the more
     * powerful {@link #LL} prediction abilities to complete successfully.
     *
     * This prediction mode does not provide any guarantees for prediction
     * behavior for syntactically-incorrect inputs.
     */ PredictionMode[PredictionMode["SLL"] = 0] = "SLL";
    /**
     * The LL(*) prediction mode. This prediction mode allows the current parser
     * context to be used for resolving SLL conflicts that occur during
     * prediction. This is the fastest prediction mode that guarantees correct
     * parse results for all combinations of grammars with syntactically correct
     * inputs.
     *
     * When using this prediction mode, the parser will make correct decisions
     * for all syntactically-correct grammar and input combinations. However, in
     * cases where the grammar is truly ambiguous this prediction mode might not
     * report a precise answer for *exactly which* alternatives are
     * ambiguous.
     *
     * This prediction mode does not provide any guarantees for prediction
     * behavior for syntactically-incorrect inputs.
     */ PredictionMode[PredictionMode["LL"] = 1] = "LL";
    /**
     * The LL(*) prediction mode with exact ambiguity detection. In addition to
     * the correctness guarantees provided by the {@link #LL} prediction mode,
     * this prediction mode instructs the prediction algorithm to determine the
     * complete and exact set of ambiguous alternatives for every ambiguous
     * decision encountered while parsing.
     *
     * This prediction mode may be used for diagnosing ambiguities during
     * grammar development. Due to the performance overhead of calculating sets
     * of ambiguous alternatives, this prediction mode should be avoided when
     * the exact results are not necessary.
     *
     * This prediction mode does not provide any guarantees for prediction
     * behavior for syntactically-incorrect inputs.
     */ PredictionMode[PredictionMode["LL_EXACT_AMBIG_DETECTION"] = 2] = "LL_EXACT_AMBIG_DETECTION";
})($c1e05489d1cdbc78$var$PredictionMode = module.exports.PredictionMode || (module.exports.PredictionMode = {}));
(function(PredictionMode) {
    /** A Map that uses just the state and the stack context as the key. */ // NOTE: Base type used to be FlexibleHashMap<ATNConfig, BitSet>
    class AltAndContextMap extends $fP17P.Array2DHashMap {
        constructor(){
            super(AltAndContextConfigEqualityComparator.INSTANCE);
        }
    }
    class AltAndContextConfigEqualityComparator {
        AltAndContextConfigEqualityComparator() {
        // intentionally empty
        }
        /**
         * The hash code is only a function of the {@link ATNState#stateNumber}
         * and {@link ATNConfig#context}.
         */ hashCode(o) {
            let hashCode = $iXFjm.MurmurHash.initialize(7);
            hashCode = $iXFjm.MurmurHash.update(hashCode, o.state.stateNumber);
            hashCode = $iXFjm.MurmurHash.update(hashCode, o.context);
            hashCode = $iXFjm.MurmurHash.finish(hashCode, 2);
            return hashCode;
        }
        equals(a, b) {
            if (a === b) return true;
            if (a == null || b == null) return false;
            return a.state.stateNumber === b.state.stateNumber && a.context.equals(b.context);
        }
    }
    AltAndContextConfigEqualityComparator.INSTANCE = new AltAndContextConfigEqualityComparator();
    $c1e05489d1cdbc78$var$__decorate([
        $d6D31.Override
    ], AltAndContextConfigEqualityComparator.prototype, "hashCode", null);
    $c1e05489d1cdbc78$var$__decorate([
        $d6D31.Override
    ], AltAndContextConfigEqualityComparator.prototype, "equals", null);
    /**
     * Checks if any configuration in `configs` is in a
     * {@link RuleStopState}. Configurations meeting this condition have reached
     * the end of the decision rule (local context) or end of start rule (full
     * context).
     *
     * @param configs the configuration set to test
     * @returns `true` if any configuration in `configs` is in a
     * {@link RuleStopState}, otherwise `false`
     */ function hasConfigInRuleStopState(configs) {
        for (let c of configs){
            if (c.state instanceof $4kGBm.RuleStopState) return true;
        }
        return false;
    }
    PredictionMode.hasConfigInRuleStopState = hasConfigInRuleStopState;
    /**
     * Checks if all configurations in `configs` are in a
     * {@link RuleStopState}. Configurations meeting this condition have reached
     * the end of the decision rule (local context) or end of start rule (full
     * context).
     *
     * @param configs the configuration set to test
     * @returns `true` if all configurations in `configs` are in a
     * {@link RuleStopState}, otherwise `false`
     */ function allConfigsInRuleStopStates(/*@NotNull*/ configs) {
        for (let config of configs){
            if (!(config.state instanceof $4kGBm.RuleStopState)) return false;
        }
        return true;
    }
    PredictionMode.allConfigsInRuleStopStates = allConfigsInRuleStopStates;
})($c1e05489d1cdbc78$var$PredictionMode = module.exports.PredictionMode || (module.exports.PredictionMode = {}));

});

parcelRegister("g7SCF", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $bbd7abb561fe52b9$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $bbd7abb561fe52b9$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SimulatorState = void 0;

var $d6D31 = parcelRequire("d6D31");

var $6bmaO = parcelRequire("6bmaO");
/**
 *
 * @author Sam Harwell
 */ let $bbd7abb561fe52b9$var$SimulatorState = class SimulatorState {
    constructor(outerContext, s0, useContext, remainingOuterContext){
        this.outerContext = outerContext != null ? outerContext : $6bmaO.ParserRuleContext.emptyContext();
        this.s0 = s0;
        this.useContext = useContext;
        this.remainingOuterContext = remainingOuterContext;
    }
};
$bbd7abb561fe52b9$var$SimulatorState = $bbd7abb561fe52b9$var$__decorate([
    $bbd7abb561fe52b9$var$__param(1, $d6D31.NotNull)
], $bbd7abb561fe52b9$var$SimulatorState);
module.exports.SimulatorState = $bbd7abb561fe52b9$var$SimulatorState;

});


parcelRegister("d1V7w", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $97c7ad4039a43616$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PlusBlockStartState = void 0;

var $1bs3X = parcelRequire("1bs3X");

var $65vNG = parcelRequire("65vNG");

var $d6D31 = parcelRequire("d6D31");
/** Start of `(A|B|...)+` loop. Technically a decision state, but
 *  we don't use for code generation; somebody might need it, so I'm defining
 *  it for completeness. In reality, the {@link PlusLoopbackState} node is the
 *  real decision-making note for `A+`.
 */ class $97c7ad4039a43616$var$PlusBlockStartState extends $65vNG.BlockStartState {
    get stateType() {
        return $1bs3X.ATNStateType.PLUS_BLOCK_START;
    }
}
$97c7ad4039a43616$var$__decorate([
    $d6D31.Override
], $97c7ad4039a43616$var$PlusBlockStartState.prototype, "stateType", null);
module.exports.PlusBlockStartState = $97c7ad4039a43616$var$PlusBlockStartState;

});

parcelRegister("7qlbM", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $567b65d0d9bb1bcd$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PlusLoopbackState = void 0;

var $1bs3X = parcelRequire("1bs3X");

var $dPYn6 = parcelRequire("dPYn6");

var $d6D31 = parcelRequire("d6D31");
/** Decision state for `A+` and `(A|B)+`.  It has two transitions:
 *  one to the loop back to start of the block and one to exit.
 */ class $567b65d0d9bb1bcd$var$PlusLoopbackState extends $dPYn6.DecisionState {
    get stateType() {
        return $1bs3X.ATNStateType.PLUS_LOOP_BACK;
    }
}
$567b65d0d9bb1bcd$var$__decorate([
    $d6D31.Override
], $567b65d0d9bb1bcd$var$PlusLoopbackState.prototype, "stateType", null);
module.exports.PlusLoopbackState = $567b65d0d9bb1bcd$var$PlusLoopbackState;

});

parcelRegister("7KGEQ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $5a4deb3ba0fdbe62$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $5a4deb3ba0fdbe62$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrecedencePredicateTransition = void 0;

var $fMVaR = parcelRequire("fMVaR");

var $d6D31 = parcelRequire("d6D31");

var $eHMgW = parcelRequire("eHMgW");
/**
 *
 * @author Sam Harwell
 */ let $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition = class PrecedencePredicateTransition extends $fMVaR.AbstractPredicateTransition {
    constructor(target, precedence){
        super(target);
        this.precedence = precedence;
    }
    get serializationType() {
        return 10 /* PRECEDENCE */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    get predicate() {
        return new $eHMgW.SemanticContext.PrecedencePredicate(this.precedence);
    }
    toString() {
        return this.precedence + " >= _p";
    }
};
$5a4deb3ba0fdbe62$var$__decorate([
    $d6D31.Override
], $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition.prototype, "serializationType", null);
$5a4deb3ba0fdbe62$var$__decorate([
    $d6D31.Override
], $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition.prototype, "isEpsilon", null);
$5a4deb3ba0fdbe62$var$__decorate([
    $d6D31.Override
], $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition.prototype, "matches", null);
$5a4deb3ba0fdbe62$var$__decorate([
    $d6D31.Override
], $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition.prototype, "toString", null);
$5a4deb3ba0fdbe62$var$PrecedencePredicateTransition = $5a4deb3ba0fdbe62$var$__decorate([
    $5a4deb3ba0fdbe62$var$__param(0, $d6D31.NotNull)
], $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition);
module.exports.PrecedencePredicateTransition = $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition;

});

parcelRegister("aISkF", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7ce828b1bf424f49$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $7ce828b1bf424f49$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RangeTransition = void 0;

var $hGRod = parcelRequire("hGRod");

var $d6D31 = parcelRequire("d6D31");

var $5tcOQ = parcelRequire("5tcOQ");
let $7ce828b1bf424f49$var$RangeTransition = class RangeTransition extends $5tcOQ.Transition {
    constructor(target, from, to){
        super(target);
        this.from = from;
        this.to = to;
    }
    get serializationType() {
        return 2 /* RANGE */ ;
    }
    get label() {
        return $hGRod.IntervalSet.of(this.from, this.to);
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return symbol >= this.from && symbol <= this.to;
    }
    toString() {
        return "'" + String.fromCodePoint(this.from) + "'..'" + String.fromCodePoint(this.to) + "'";
    }
};
$7ce828b1bf424f49$var$__decorate([
    $d6D31.Override
], $7ce828b1bf424f49$var$RangeTransition.prototype, "serializationType", null);
$7ce828b1bf424f49$var$__decorate([
    $d6D31.Override,
    $d6D31.NotNull
], $7ce828b1bf424f49$var$RangeTransition.prototype, "label", null);
$7ce828b1bf424f49$var$__decorate([
    $d6D31.Override
], $7ce828b1bf424f49$var$RangeTransition.prototype, "matches", null);
$7ce828b1bf424f49$var$__decorate([
    $d6D31.Override,
    $d6D31.NotNull
], $7ce828b1bf424f49$var$RangeTransition.prototype, "toString", null);
$7ce828b1bf424f49$var$RangeTransition = $7ce828b1bf424f49$var$__decorate([
    $7ce828b1bf424f49$var$__param(0, $d6D31.NotNull)
], $7ce828b1bf424f49$var$RangeTransition);
module.exports.RangeTransition = $7ce828b1bf424f49$var$RangeTransition;

});

parcelRegister("j2zc8", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ddc981289e81a506$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleStartState = void 0;

var $7j0Pc = parcelRequire("7j0Pc");

var $1bs3X = parcelRequire("1bs3X");

var $d6D31 = parcelRequire("d6D31");
class $ddc981289e81a506$var$RuleStartState extends $7j0Pc.ATNState {
    constructor(){
        super(...arguments);
        this.isPrecedenceRule = false;
        this.leftFactored = false;
    }
    get stateType() {
        return $1bs3X.ATNStateType.RULE_START;
    }
}
$ddc981289e81a506$var$__decorate([
    $d6D31.Override
], $ddc981289e81a506$var$RuleStartState.prototype, "stateType", null);
module.exports.RuleStartState = $ddc981289e81a506$var$RuleStartState;

});

parcelRegister("jEsaF", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e4e79af439480b0e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarBlockStartState = void 0;

var $1bs3X = parcelRequire("1bs3X");

var $65vNG = parcelRequire("65vNG");

var $d6D31 = parcelRequire("d6D31");
/** The block that begins a closure loop. */ class $e4e79af439480b0e$var$StarBlockStartState extends $65vNG.BlockStartState {
    get stateType() {
        return $1bs3X.ATNStateType.STAR_BLOCK_START;
    }
}
$e4e79af439480b0e$var$__decorate([
    $d6D31.Override
], $e4e79af439480b0e$var$StarBlockStartState.prototype, "stateType", null);
module.exports.StarBlockStartState = $e4e79af439480b0e$var$StarBlockStartState;

});

parcelRegister("bjwd1", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $83ca741f127bc1b0$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarLoopbackState = void 0;

var $7j0Pc = parcelRequire("7j0Pc");

var $1bs3X = parcelRequire("1bs3X");

var $d6D31 = parcelRequire("d6D31");
class $83ca741f127bc1b0$var$StarLoopbackState extends $7j0Pc.ATNState {
    get loopEntryState() {
        return this.transition(0).target;
    }
    get stateType() {
        return $1bs3X.ATNStateType.STAR_LOOP_BACK;
    }
}
$83ca741f127bc1b0$var$__decorate([
    $d6D31.Override
], $83ca741f127bc1b0$var$StarLoopbackState.prototype, "stateType", null);
module.exports.StarLoopbackState = $83ca741f127bc1b0$var$StarLoopbackState;

});

parcelRegister("WS4d7", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $0b0f5b750847d473$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TokensStartState = void 0;

var $1bs3X = parcelRequire("1bs3X");

var $dPYn6 = parcelRequire("dPYn6");

var $d6D31 = parcelRequire("d6D31");
/** The Tokens rule start state linking to each lexer rule start state */ class $0b0f5b750847d473$var$TokensStartState extends $dPYn6.DecisionState {
    get stateType() {
        return $1bs3X.ATNStateType.TOKEN_START;
    }
}
$0b0f5b750847d473$var$__decorate([
    $d6D31.Override
], $0b0f5b750847d473$var$TokensStartState.prototype, "stateType", null);
module.exports.TokensStartState = $0b0f5b750847d473$var$TokensStartState;

});

parcelRegister("kWxOc", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UUID = void 0;

var $iXFjm = parcelRequire("iXFjm");
class $f3f3731a7838b7f9$var$UUID {
    constructor(mostSigBits, moreSigBits, lessSigBits, leastSigBits){
        this.data = new Uint32Array(4);
        this.data[0] = mostSigBits;
        this.data[1] = moreSigBits;
        this.data[2] = lessSigBits;
        this.data[3] = leastSigBits;
    }
    static fromString(data) {
        if (!/^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/.test(data)) throw new Error("Incorrectly formatted UUID");
        let segments = data.split("-");
        let mostSigBits = parseInt(segments[0], 16);
        let moreSigBits = (parseInt(segments[1], 16) << 16 >>> 0) + parseInt(segments[2], 16);
        let lessSigBits = (parseInt(segments[3], 16) << 16 >>> 0) + parseInt(segments[4].substr(0, 4), 16);
        let leastSigBits = parseInt(segments[4].substr(-8), 16);
        return new $f3f3731a7838b7f9$var$UUID(mostSigBits, moreSigBits, lessSigBits, leastSigBits);
    }
    hashCode() {
        return $iXFjm.MurmurHash.hashCode([
            this.data[0],
            this.data[1],
            this.data[2],
            this.data[3]
        ]);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $f3f3731a7838b7f9$var$UUID)) return false;
        return this.data[0] === obj.data[0] && this.data[1] === obj.data[1] && this.data[2] === obj.data[2] && this.data[3] === obj.data[3];
    }
    toString() {
        return ("00000000" + this.data[0].toString(16)).substr(-8) + "-" + ("0000" + (this.data[1] >>> 16).toString(16)).substr(-4) + "-" + ("0000" + this.data[1].toString(16)).substr(-4) + "-" + ("0000" + (this.data[2] >>> 16).toString(16)).substr(-4) + "-" + ("0000" + this.data[2].toString(16)).substr(-4) + ("00000000" + this.data[3].toString(16)).substr(-8);
    }
}
module.exports.UUID = $f3f3731a7838b7f9$var$UUID;

});


parcelRegister("3iOjI", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $267a15775466fb93$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $267a15775466fb93$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParseInfo = void 0;

var $d6D31 = parcelRequire("d6D31");
/**
 * This class provides access to specific and aggregate statistics gathered
 * during profiling of a parser.
 *
 * @since 4.3
 */ let $267a15775466fb93$var$ParseInfo = class ParseInfo {
    constructor(atnSimulator){
        this.atnSimulator = atnSimulator;
    }
    /**
     * Gets an array of {@link DecisionInfo} instances containing the profiling
     * information gathered for each decision in the ATN.
     *
     * @returns An array of {@link DecisionInfo} instances, indexed by decision
     * number.
     */ getDecisionInfo() {
        return this.atnSimulator.getDecisionInfo();
    }
    /**
     * Gets the decision numbers for decisions that required one or more
     * full-context predictions during parsing. These are decisions for which
     * {@link DecisionInfo#LL_Fallback} is non-zero.
     *
     * @returns A list of decision numbers which required one or more
     * full-context predictions during parsing.
     */ getLLDecisions() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let LL = [];
        for(let i = 0; i < decisions.length; i++){
            let fallBack = decisions[i].LL_Fallback;
            if (fallBack > 0) LL.push(i);
        }
        return LL;
    }
    /**
     * Gets the total time spent during prediction across all decisions made
     * during parsing. This value is the sum of
     * {@link DecisionInfo#timeInPrediction} for all decisions.
     */ getTotalTimeInPrediction() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let t = 0;
        for (let decision of decisions)t += decision.timeInPrediction;
        return t;
    }
    /**
     * Gets the total number of SLL lookahead operations across all decisions
     * made during parsing. This value is the sum of
     * {@link DecisionInfo#SLL_TotalLook} for all decisions.
     */ getTotalSLLLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.SLL_TotalLook;
        return k;
    }
    /**
     * Gets the total number of LL lookahead operations across all decisions
     * made during parsing. This value is the sum of
     * {@link DecisionInfo#LL_TotalLook} for all decisions.
     */ getTotalLLLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.LL_TotalLook;
        return k;
    }
    /**
     * Gets the total number of ATN lookahead operations for SLL prediction
     * across all decisions made during parsing.
     */ getTotalSLLATNLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.SLL_ATNTransitions;
        return k;
    }
    /**
     * Gets the total number of ATN lookahead operations for LL prediction
     * across all decisions made during parsing.
     */ getTotalLLATNLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.LL_ATNTransitions;
        return k;
    }
    /**
     * Gets the total number of ATN lookahead operations for SLL and LL
     * prediction across all decisions made during parsing.
     *
     * This value is the sum of {@link #getTotalSLLATNLookaheadOps} and
     * {@link #getTotalLLATNLookaheadOps}.
     */ getTotalATNLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions){
            k += decision.SLL_ATNTransitions;
            k += decision.LL_ATNTransitions;
        }
        return k;
    }
    getDFASize(decision) {
        if (decision) {
            let decisionToDFA = this.atnSimulator.atn.decisionToDFA[decision];
            return decisionToDFA.states.size;
        } else {
            let n = 0;
            let decisionToDFA = this.atnSimulator.atn.decisionToDFA;
            for(let i = 0; i < decisionToDFA.length; i++)n += this.getDFASize(i);
            return n;
        }
    }
};
$267a15775466fb93$var$__decorate([
    $d6D31.NotNull
], $267a15775466fb93$var$ParseInfo.prototype, "getDecisionInfo", null);
$267a15775466fb93$var$__decorate([
    $d6D31.NotNull
], $267a15775466fb93$var$ParseInfo.prototype, "getLLDecisions", null);
$267a15775466fb93$var$ParseInfo = $267a15775466fb93$var$__decorate([
    $267a15775466fb93$var$__param(0, $d6D31.NotNull)
], $267a15775466fb93$var$ParseInfo);
module.exports.ParseInfo = $267a15775466fb93$var$ParseInfo;

});

parcelRegister("5xwgp", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $40890fafca7801d5$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProxyParserErrorListener = void 0;

var $65iNZ = parcelRequire("65iNZ");

var $d6D31 = parcelRequire("d6D31");
/**
 * @author Sam Harwell
 */ class $40890fafca7801d5$var$ProxyParserErrorListener extends $65iNZ.ProxyErrorListener {
    constructor(delegates){
        super(delegates);
    }
    reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs) {
        this.getDelegates().forEach((listener)=>{
            if (listener.reportAmbiguity) listener.reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs);
        });
    }
    reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState) {
        this.getDelegates().forEach((listener)=>{
            if (listener.reportAttemptingFullContext) listener.reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState);
        });
    }
    reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState) {
        this.getDelegates().forEach((listener)=>{
            if (listener.reportContextSensitivity) listener.reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState);
        });
    }
}
$40890fafca7801d5$var$__decorate([
    $d6D31.Override
], $40890fafca7801d5$var$ProxyParserErrorListener.prototype, "reportAmbiguity", null);
$40890fafca7801d5$var$__decorate([
    $d6D31.Override
], $40890fafca7801d5$var$ProxyParserErrorListener.prototype, "reportAttemptingFullContext", null);
$40890fafca7801d5$var$__decorate([
    $d6D31.Override
], $40890fafca7801d5$var$ProxyParserErrorListener.prototype, "reportContextSensitivity", null);
module.exports.ProxyParserErrorListener = $40890fafca7801d5$var$ProxyParserErrorListener;

});

parcelRegister("iC1eN", function(module, exports) {

let $d8ccbc5caa411ff9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d8ccbc5caa411ff9$var$load("bn6Qq").then(()=>parcelRequire('gpWGO'));

});

parcelRegister("5FqoK", function(module, exports) {

let $42054231f05036bd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $42054231f05036bd$var$load("cIazg").then(()=>parcelRequire('cJzXV'));

});




parcelRegister("3kXUy", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParseCancellationException = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:42.5447085-07:00
/**
 * This exception is thrown to cancel a parsing operation. This exception does
 * not extend {@link RecognitionException}, allowing it to bypass the standard
 * error recovery mechanisms. {@link BailErrorStrategy} throws this exception in
 * response to a parse error.
 *
 * @author Sam Harwell
 */ class $26e1b6704997a3f4$var$ParseCancellationException extends Error {
    constructor(cause){
        super(cause.message);
        this.cause = cause;
        this.stack = cause.stack;
    }
    getCause() {
        return this.cause;
    }
}
module.exports.ParseCancellationException = $26e1b6704997a3f4$var$ParseCancellationException;

});


parcelRegister("1UkCC", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $163b0480402006d6$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $163b0480402006d6$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BufferedTokenStream = void 0;

var $bbHFU = parcelRequire("bbHFU");

var $j53rr = parcelRequire("j53rr");

var $gcfUE = parcelRequire("gcfUE");

var $igNLf = parcelRequire("igNLf");

var $d6D31 = parcelRequire("d6D31");

var $2DVsz = parcelRequire("2DVsz");
/**
 * This implementation of {@link TokenStream} loads tokens from a
 * {@link TokenSource} on-demand, and places the tokens in a buffer to provide
 * access to any previous token by index.
 *
 * This token stream ignores the value of {@link Token#getChannel}. If your
 * parser requires the token stream filter tokens to only those on a particular
 * channel, such as {@link Token#DEFAULT_CHANNEL} or
 * {@link Token#HIDDEN_CHANNEL}, use a filtering token stream such a
 * {@link CommonTokenStream}.
 */ let $163b0480402006d6$var$BufferedTokenStream = class BufferedTokenStream {
    constructor(tokenSource){
        /**
         * A collection of all tokens fetched from the token source. The list is
         * considered a complete view of the input once {@link #fetchedEOF} is set
         * to `true`.
         */ this.tokens = [];
        /**
         * The index into {@link #tokens} of the current token (next token to
         * {@link #consume}). {@link #tokens}`[`{@link #p}`]` should be
         * {@link #LT LT(1)}.
         *
         * This field is set to -1 when the stream is first constructed or when
         * {@link #setTokenSource} is called, indicating that the first token has
         * not yet been fetched from the token source. For additional information,
         * see the documentation of {@link IntStream} for a description of
         * Initializing Methods.
         */ this.p = -1;
        /**
         * Indicates whether the {@link Token#EOF} token has been fetched from
         * {@link #tokenSource} and added to {@link #tokens}. This field improves
         * performance for the following cases:
         *
         * * {@link #consume}: The lookahead check in {@link #consume} to prevent
         *   consuming the EOF symbol is optimized by checking the values of
         *   {@link #fetchedEOF} and {@link #p} instead of calling {@link #LA}.
         * * {@link #fetch}: The check to prevent adding multiple EOF symbols into
         *   {@link #tokens} is trivial with this field.
         */ this.fetchedEOF = false;
        if (tokenSource == null) throw new Error("tokenSource cannot be null");
        this._tokenSource = tokenSource;
    }
    get tokenSource() {
        return this._tokenSource;
    }
    /** Reset this token stream by setting its token source. */ set tokenSource(tokenSource) {
        this._tokenSource = tokenSource;
        this.tokens.length = 0;
        this.p = -1;
        this.fetchedEOF = false;
    }
    get index() {
        return this.p;
    }
    mark() {
        return 0;
    }
    release(marker) {
    // no resources to release
    }
    seek(index) {
        this.lazyInit();
        this.p = this.adjustSeekIndex(index);
    }
    get size() {
        return this.tokens.length;
    }
    consume() {
        let skipEofCheck;
        if (this.p >= 0) {
            if (this.fetchedEOF) // the last token in tokens is EOF. skip check if p indexes any
            // fetched token except the last.
            skipEofCheck = this.p < this.tokens.length - 1;
            else // no EOF token in tokens. skip check if p indexes a fetched token.
            skipEofCheck = this.p < this.tokens.length;
        } else // not yet initialized
        skipEofCheck = false;
        if (!skipEofCheck && this.LA(1) === $2DVsz.Token.EOF) throw new Error("cannot consume EOF");
        if (this.sync(this.p + 1)) this.p = this.adjustSeekIndex(this.p + 1);
    }
    /** Make sure index `i` in tokens has a token.
     *
     * @returns `true` if a token is located at index `i`, otherwise
     *    `false`.
     * @see #get(int i)
     */ sync(i) {
        $bbHFU(i >= 0);
        let n = i - this.tokens.length + 1; // how many more elements we need?
        //System.out.println("sync("+i+") needs "+n);
        if (n > 0) {
            let fetched = this.fetch(n);
            return fetched >= n;
        }
        return true;
    }
    /** Add `n` elements to buffer.
     *
     * @returns The actual number of elements added to the buffer.
     */ fetch(n) {
        if (this.fetchedEOF) return 0;
        for(let i = 0; i < n; i++){
            let t = this.tokenSource.nextToken();
            if (this.isWritableToken(t)) t.tokenIndex = this.tokens.length;
            this.tokens.push(t);
            if (t.type === $2DVsz.Token.EOF) {
                this.fetchedEOF = true;
                return i + 1;
            }
        }
        return n;
    }
    get(i) {
        if (i < 0 || i >= this.tokens.length) throw new RangeError("token index " + i + " out of range 0.." + (this.tokens.length - 1));
        return this.tokens[i];
    }
    /** Get all tokens from start..stop inclusively. */ getRange(start, stop) {
        if (start < 0 || stop < 0) return [];
        this.lazyInit();
        let subset = new Array();
        if (stop >= this.tokens.length) stop = this.tokens.length - 1;
        for(let i = start; i <= stop; i++){
            let t = this.tokens[i];
            if (t.type === $2DVsz.Token.EOF) break;
            subset.push(t);
        }
        return subset;
    }
    LA(i) {
        let token = this.LT(i);
        if (!token) return $2DVsz.Token.INVALID_TYPE;
        return token.type;
    }
    tryLB(k) {
        if (this.p - k < 0) return undefined;
        return this.tokens[this.p - k];
    }
    LT(k) {
        let result = this.tryLT(k);
        if (result === undefined) throw new RangeError("requested lookback index out of range");
        return result;
    }
    tryLT(k) {
        this.lazyInit();
        if (k === 0) throw new RangeError("0 is not a valid lookahead index");
        if (k < 0) return this.tryLB(-k);
        let i = this.p + k - 1;
        this.sync(i);
        if (i >= this.tokens.length) // return EOF token
        // EOF must be last token
        return this.tokens[this.tokens.length - 1];
        //		if ( i>range ) range = i;
        return this.tokens[i];
    }
    /**
     * Allowed derived classes to modify the behavior of operations which change
     * the current stream position by adjusting the target token index of a seek
     * operation. The default implementation simply returns `i`. If an
     * exception is thrown in this method, the current stream index should not be
     * changed.
     *
     * For example, {@link CommonTokenStream} overrides this method to ensure that
     * the seek target is always an on-channel token.
     *
     * @param i The target token index.
     * @returns The adjusted target token index.
     */ adjustSeekIndex(i) {
        return i;
    }
    lazyInit() {
        if (this.p === -1) this.setup();
    }
    setup() {
        this.sync(0);
        this.p = this.adjustSeekIndex(0);
    }
    /** Given a start and stop index, return a `List` of all tokens in
     *  the token type `BitSet`.  Return an empty array if no tokens were found.  This
     *  method looks at both on and off channel tokens.
     */ getTokens(start, stop, types) {
        this.lazyInit();
        if (start === undefined) {
            $bbHFU(stop === undefined && types === undefined);
            return this.tokens;
        } else if (stop === undefined) stop = this.tokens.length - 1;
        if (start < 0 || stop >= this.tokens.length || stop < 0 || start >= this.tokens.length) throw new RangeError("start " + start + " or stop " + stop + " not in 0.." + (this.tokens.length - 1));
        if (start > stop) return [];
        if (types === undefined) return this.tokens.slice(start, stop + 1);
        else if (typeof types === "number") types = new Set().add(types);
        let typesSet = types;
        // list = tokens[start:stop]:{T t, t.type in types}
        let filteredTokens = this.tokens.slice(start, stop + 1);
        filteredTokens = filteredTokens.filter((value)=>typesSet.has(value.type));
        return filteredTokens;
    }
    /**
     * Given a starting index, return the index of the next token on channel.
     * Return `i` if `tokens[i]` is on channel. Return the index of
     * the EOF token if there are no tokens on channel between `i` and
     * EOF.
     */ nextTokenOnChannel(i, channel) {
        this.sync(i);
        if (i >= this.size) return this.size - 1;
        let token = this.tokens[i];
        while(token.channel !== channel){
            if (token.type === $2DVsz.Token.EOF) return i;
            i++;
            this.sync(i);
            token = this.tokens[i];
        }
        return i;
    }
    /**
     * Given a starting index, return the index of the previous token on
     * channel. Return `i` if `tokens[i]` is on channel. Return -1
     * if there are no tokens on channel between `i` and 0.
     *
     * If `i` specifies an index at or after the EOF token, the EOF token
     * index is returned. This is due to the fact that the EOF token is treated
     * as though it were on every channel.
     */ previousTokenOnChannel(i, channel) {
        this.sync(i);
        if (i >= this.size) // the EOF token is on every channel
        return this.size - 1;
        while(i >= 0){
            let token = this.tokens[i];
            if (token.type === $2DVsz.Token.EOF || token.channel === channel) return i;
            i--;
        }
        return i;
    }
    /** Collect all tokens on specified channel to the right of
     *  the current token up until we see a token on {@link Lexer#DEFAULT_TOKEN_CHANNEL} or
     *  EOF. If `channel` is `-1`, find any non default channel token.
     */ getHiddenTokensToRight(tokenIndex, channel = -1) {
        this.lazyInit();
        if (tokenIndex < 0 || tokenIndex >= this.tokens.length) throw new RangeError(tokenIndex + " not in 0.." + (this.tokens.length - 1));
        let nextOnChannel = this.nextTokenOnChannel(tokenIndex + 1, $igNLf.Lexer.DEFAULT_TOKEN_CHANNEL);
        let to;
        let from = tokenIndex + 1;
        // if none onchannel to right, nextOnChannel=-1 so set to = last token
        if (nextOnChannel === -1) to = this.size - 1;
        else to = nextOnChannel;
        return this.filterForChannel(from, to, channel);
    }
    /** Collect all tokens on specified channel to the left of
     *  the current token up until we see a token on {@link Lexer#DEFAULT_TOKEN_CHANNEL}.
     *  If `channel` is `-1`, find any non default channel token.
     */ getHiddenTokensToLeft(tokenIndex, channel = -1) {
        this.lazyInit();
        if (tokenIndex < 0 || tokenIndex >= this.tokens.length) throw new RangeError(tokenIndex + " not in 0.." + (this.tokens.length - 1));
        if (tokenIndex === 0) // obviously no tokens can appear before the first token
        return [];
        let prevOnChannel = this.previousTokenOnChannel(tokenIndex - 1, $igNLf.Lexer.DEFAULT_TOKEN_CHANNEL);
        if (prevOnChannel === tokenIndex - 1) return [];
        // if none onchannel to left, prevOnChannel=-1 then from=0
        let from = prevOnChannel + 1;
        let to = tokenIndex - 1;
        return this.filterForChannel(from, to, channel);
    }
    filterForChannel(from, to, channel) {
        let hidden = new Array();
        for(let i = from; i <= to; i++){
            let t = this.tokens[i];
            if (channel === -1) {
                if (t.channel !== $igNLf.Lexer.DEFAULT_TOKEN_CHANNEL) hidden.push(t);
            } else if (t.channel === channel) hidden.push(t);
        }
        return hidden;
    }
    get sourceName() {
        return this.tokenSource.sourceName;
    }
    getText(interval) {
        if (interval === undefined) interval = $gcfUE.Interval.of(0, this.size - 1);
        else if (!(interval instanceof $gcfUE.Interval)) // Note: the more obvious check for 'instanceof RuleContext' results in a circular dependency problem
        interval = interval.sourceInterval;
        let start = interval.a;
        let stop = interval.b;
        if (start < 0 || stop < 0) return "";
        this.fill();
        if (stop >= this.tokens.length) stop = this.tokens.length - 1;
        let buf = "";
        for(let i = start; i <= stop; i++){
            let t = this.tokens[i];
            if (t.type === $2DVsz.Token.EOF) break;
            buf += t.text;
        }
        return buf.toString();
    }
    getTextFromRange(start, stop) {
        if (this.isToken(start) && this.isToken(stop)) return this.getText($gcfUE.Interval.of(start.tokenIndex, stop.tokenIndex));
        return "";
    }
    /** Get all tokens from lexer until EOF. */ fill() {
        this.lazyInit();
        const blockSize = 1000;
        while(true){
            let fetched = this.fetch(blockSize);
            if (fetched < blockSize) return;
        }
    }
    // TODO: Figure out a way to make this more flexible?
    isWritableToken(t) {
        return t instanceof $j53rr.CommonToken;
    }
    // TODO: Figure out a way to make this more flexible?
    isToken(t) {
        return t instanceof $j53rr.CommonToken;
    }
};
$163b0480402006d6$var$__decorate([
    $d6D31.NotNull
], $163b0480402006d6$var$BufferedTokenStream.prototype, "_tokenSource", void 0);
$163b0480402006d6$var$__decorate([
    $d6D31.Override
], $163b0480402006d6$var$BufferedTokenStream.prototype, "tokenSource", null);
$163b0480402006d6$var$__decorate([
    $d6D31.Override
], $163b0480402006d6$var$BufferedTokenStream.prototype, "index", null);
$163b0480402006d6$var$__decorate([
    $d6D31.Override
], $163b0480402006d6$var$BufferedTokenStream.prototype, "mark", null);
$163b0480402006d6$var$__decorate([
    $d6D31.Override
], $163b0480402006d6$var$BufferedTokenStream.prototype, "release", null);
$163b0480402006d6$var$__decorate([
    $d6D31.Override
], $163b0480402006d6$var$BufferedTokenStream.prototype, "seek", null);
$163b0480402006d6$var$__decorate([
    $d6D31.Override
], $163b0480402006d6$var$BufferedTokenStream.prototype, "size", null);
$163b0480402006d6$var$__decorate([
    $d6D31.Override
], $163b0480402006d6$var$BufferedTokenStream.prototype, "consume", null);
$163b0480402006d6$var$__decorate([
    $d6D31.Override
], $163b0480402006d6$var$BufferedTokenStream.prototype, "get", null);
$163b0480402006d6$var$__decorate([
    $d6D31.Override
], $163b0480402006d6$var$BufferedTokenStream.prototype, "LA", null);
$163b0480402006d6$var$__decorate([
    $d6D31.NotNull,
    $d6D31.Override
], $163b0480402006d6$var$BufferedTokenStream.prototype, "LT", null);
$163b0480402006d6$var$__decorate([
    $d6D31.Override
], $163b0480402006d6$var$BufferedTokenStream.prototype, "sourceName", null);
$163b0480402006d6$var$__decorate([
    $d6D31.NotNull,
    $d6D31.Override
], $163b0480402006d6$var$BufferedTokenStream.prototype, "getText", null);
$163b0480402006d6$var$__decorate([
    $d6D31.NotNull,
    $d6D31.Override
], $163b0480402006d6$var$BufferedTokenStream.prototype, "getTextFromRange", null);
$163b0480402006d6$var$BufferedTokenStream = $163b0480402006d6$var$__decorate([
    $163b0480402006d6$var$__param(0, $d6D31.NotNull)
], $163b0480402006d6$var$BufferedTokenStream);
module.exports.BufferedTokenStream = $163b0480402006d6$var$BufferedTokenStream;

});

parcelRegister("QidO0", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9NnFz", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CharStreams = void 0;

var $1Olk0 = parcelRequire("1Olk0");

var $7ufNj = parcelRequire("7ufNj");

var $ceaEj = parcelRequire("ceaEj");
// const DEFAULT_BUFFER_SIZE: number = 4096;
/** This class represents the primary interface for creating {@link CharStream}s
 *  from a variety of sources as of 4.7.  The motivation was to support
 *  Unicode code points > U+FFFF.  {@link ANTLRInputStream} and
 *  {@link ANTLRFileStream} are now deprecated in favor of the streams created
 *  by this interface.
 *
 *  DEPRECATED: {@code new ANTLRFileStream("myinputfile")}
 *  NEW:        {@code CharStreams.fromFileName("myinputfile")}
 *
 *  WARNING: If you use both the deprecated and the new streams, you will see
 *  a nontrivial performance degradation. This speed hit is because the
 *  {@link Lexer}'s internal code goes from a monomorphic to megamorphic
 *  dynamic dispatch to get characters from the input stream. Java's
 *  on-the-fly compiler (JIT) is unable to perform the same optimizations
 *  so stick with either the old or the new streams, if performance is
 *  a primary concern. See the extreme debugging and spelunking
 *  needed to identify this issue in our timing rig:
 *
 *      https://github.com/antlr/antlr4/pull/1781
 *
 *  The ANTLR character streams still buffer all the input when you create
 *  the stream, as they have done for ~20 years. If you need unbuffered
 *  access, please note that it becomes challenging to create
 *  parse trees. The parse tree has to point to tokens which will either
 *  point into a stale location in an unbuffered stream or you have to copy
 *  the characters out of the buffer into the token. That defeats the purpose
 *  of unbuffered input. Per the ANTLR book, unbuffered streams are primarily
 *  useful for processing infinite streams *during the parse.*
 *
 *  The new streams also use 8-bit buffers when possible so this new
 *  interface supports character streams that use half as much memory
 *  as the old {@link ANTLRFileStream}, which assumed 16-bit characters.
 *
 *  A big shout out to Ben Hamilton (github bhamiltoncx) for his superhuman
 *  efforts across all targets to get true Unicode 3.1 support for U+10FFFF.
 *
 *  @since 4.7
 */ var $721b0cebe5798117$var$CharStreams;
(function(CharStreams) {
    // /**
    //  * Creates a {@link CharStream} given a path to a UTF-8
    //  * encoded file on disk.
    //  *
    //  * Reads the entire contents of the file into the result before returning.
    //  */
    // export function fromFile(file: File): CharStream;
    // export function fromFile(file: File, charset: Charset): CharStream;
    // export function fromFile(file: File, charset?: Charset): CharStream {
    // 	if (charset === undefined) {
    // 		charset = Charset.forName("UTF-8");
    // 	}
    function fromString(s, sourceName) {
        if (sourceName === undefined || sourceName.length === 0) sourceName = $ceaEj.IntStream.UNKNOWN_SOURCE_NAME;
        // Initial guess assumes no code points > U+FFFF: one code
        // point for each code unit in the string
        let codePointBufferBuilder = $1Olk0.CodePointBuffer.builder(s.length);
        // TODO: CharBuffer.wrap(String) rightfully returns a read-only buffer
        // which doesn't expose its array, so we make a copy.
        let cb = new Uint16Array(s.length);
        for(let i = 0; i < s.length; i++)cb[i] = s.charCodeAt(i);
        codePointBufferBuilder.append(cb);
        return $7ufNj.CodePointCharStream.fromBuffer(codePointBufferBuilder.build(), sourceName);
    }
    CharStreams.fromString = fromString;
// export function bufferFromChannel(
// 	channel: ReadableByteChannel,
// 	charset: Charset,
// 	bufferSize: number,
// 	decodingErrorAction: CodingErrorAction,
// 	inputSize: number): CodePointBuffer {
// 	try {
// 		let utf8BytesIn: Uint8Array = new Uint8Array(bufferSize);
// 		let utf16CodeUnitsOut: Uint16Array = new Uint16Array(bufferSize);
// 		if (inputSize === -1) {
// 			inputSize = bufferSize;
// 		} else if (inputSize > Integer.MAX_VALUE) {
// 			// ByteBuffer et al don't support long sizes
// 			throw new RangeError(`inputSize ${inputSize} larger than max ${Integer.MAX_VALUE}`);
// 		}
// 		let codePointBufferBuilder: CodePointBuffer.Builder = CodePointBuffer.builder(inputSize);
// 		let decoder: CharsetDecoder = charset
// 				.newDecoder()
// 				.onMalformedInput(decodingErrorAction)
// 				.onUnmappableCharacter(decodingErrorAction);
// 		let endOfInput: boolean = false;
// 		while (!endOfInput) {
// 			let bytesRead: number = channel.read(utf8BytesIn);
// 			endOfInput = (bytesRead === -1);
// 			utf8BytesIn.flip();
// 			let result: CoderResult = decoder.decode(
// 				utf8BytesIn,
// 				utf16CodeUnitsOut,
// 				endOfInput);
// 			if (result.isError() && decodingErrorAction === CodingErrorAction.REPORT) {
// 				result.throwException();
// 			}
// 			utf16CodeUnitsOut.flip();
// 			codePointBufferBuilder.append(utf16CodeUnitsOut);
// 			utf8BytesIn.compact();
// 			utf16CodeUnitsOut.compact();
// 		}
// 		// Handle any bytes at the end of the file which need to
// 		// be represented as errors or substitution characters.
// 		let flushResult: CoderResult = decoder.flush(utf16CodeUnitsOut);
// 		if (flushResult.isError() && decodingErrorAction === CodingErrorAction.REPORT) {
// 			flushResult.throwException();
// 		}
// 		utf16CodeUnitsOut.flip();
// 		codePointBufferBuilder.append(utf16CodeUnitsOut);
// 		return codePointBufferBuilder.build();
// 	}
// 	finally {
// 		channel.close();
// 	}
// }
})($721b0cebe5798117$var$CharStreams = module.exports.CharStreams || (module.exports.CharStreams = {}));

});
parcelRegister("1Olk0", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CodePointBuffer = void 0;

var $bbHFU = parcelRequire("bbHFU");

var $gIRNa = parcelRequire("gIRNa");
/**
 * Wrapper for `Uint8Array` / `Uint16Array` / `Int32Array`.
 */ class $151b0001e5dcadf1$var$CodePointBuffer {
    constructor(buffer, size){
        this.buffer = buffer;
        this._position = 0;
        this._size = size;
    }
    static withArray(buffer) {
        return new $151b0001e5dcadf1$var$CodePointBuffer(buffer, buffer.length);
    }
    get position() {
        return this._position;
    }
    set position(newPosition) {
        if (newPosition < 0 || newPosition > this._size) throw new RangeError();
        this._position = newPosition;
    }
    get remaining() {
        return this._size - this.position;
    }
    get(offset) {
        return this.buffer[offset];
    }
    array() {
        return this.buffer.slice(0, this._size);
    }
    static builder(initialBufferSize) {
        return new $151b0001e5dcadf1$var$CodePointBuffer.Builder(initialBufferSize);
    }
}
module.exports.CodePointBuffer = $151b0001e5dcadf1$var$CodePointBuffer;
(function(CodePointBuffer) {
    let Type;
    (function(Type) {
        Type[Type["BYTE"] = 0] = "BYTE";
        Type[Type["CHAR"] = 1] = "CHAR";
        Type[Type["INT"] = 2] = "INT";
    })(Type || (Type = {}));
    class Builder {
        constructor(initialBufferSize){
            this.type = 0 /* BYTE */ ;
            this.buffer = new Uint8Array(initialBufferSize);
            this.prevHighSurrogate = -1;
            this.position = 0;
        }
        build() {
            return new CodePointBuffer(this.buffer, this.position);
        }
        static roundUpToNextPowerOfTwo(i) {
            let nextPowerOfTwo = 32 - Math.clz32(i - 1);
            return Math.pow(2, nextPowerOfTwo);
        }
        ensureRemaining(remainingNeeded) {
            switch(this.type){
                case 0 /* BYTE */ :
                    if (this.buffer.length - this.position < remainingNeeded) {
                        let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                        let newBuffer = new Uint8Array(newCapacity);
                        newBuffer.set(this.buffer.subarray(0, this.position), 0);
                        this.buffer = newBuffer;
                    }
                    break;
                case 1 /* CHAR */ :
                    if (this.buffer.length - this.position < remainingNeeded) {
                        let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                        let newBuffer = new Uint16Array(newCapacity);
                        newBuffer.set(this.buffer.subarray(0, this.position), 0);
                        this.buffer = newBuffer;
                    }
                    break;
                case 2 /* INT */ :
                    if (this.buffer.length - this.position < remainingNeeded) {
                        let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                        let newBuffer = new Int32Array(newCapacity);
                        newBuffer.set(this.buffer.subarray(0, this.position), 0);
                        this.buffer = newBuffer;
                    }
                    break;
            }
        }
        append(utf16In) {
            this.ensureRemaining(utf16In.length);
            this.appendArray(utf16In);
        }
        appendArray(utf16In) {
            switch(this.type){
                case 0 /* BYTE */ :
                    this.appendArrayByte(utf16In);
                    break;
                case 1 /* CHAR */ :
                    this.appendArrayChar(utf16In);
                    break;
                case 2 /* INT */ :
                    this.appendArrayInt(utf16In);
                    break;
            }
        }
        appendArrayByte(utf16In) {
            $bbHFU(this.prevHighSurrogate === -1);
            let input = utf16In;
            let inOffset = 0;
            let inLimit = utf16In.length;
            let outByte = this.buffer;
            let outOffset = this.position;
            while(inOffset < inLimit){
                let c = input[inOffset];
                if (c <= 0xFF) outByte[outOffset] = c;
                else {
                    utf16In = utf16In.subarray(inOffset, inLimit);
                    this.position = outOffset;
                    if (!$gIRNa.isHighSurrogate(c)) {
                        this.byteToCharBuffer(utf16In.length);
                        this.appendArrayChar(utf16In);
                        return;
                    } else {
                        this.byteToIntBuffer(utf16In.length);
                        this.appendArrayInt(utf16In);
                        return;
                    }
                }
                inOffset++;
                outOffset++;
            }
            this.position = outOffset;
        }
        appendArrayChar(utf16In) {
            $bbHFU(this.prevHighSurrogate === -1);
            let input = utf16In;
            let inOffset = 0;
            let inLimit = utf16In.length;
            let outChar = this.buffer;
            let outOffset = this.position;
            while(inOffset < inLimit){
                let c = input[inOffset];
                if (!$gIRNa.isHighSurrogate(c)) outChar[outOffset] = c;
                else {
                    utf16In = utf16In.subarray(inOffset, inLimit);
                    this.position = outOffset;
                    this.charToIntBuffer(utf16In.length);
                    this.appendArrayInt(utf16In);
                    return;
                }
                inOffset++;
                outOffset++;
            }
            this.position = outOffset;
        }
        appendArrayInt(utf16In) {
            let input = utf16In;
            let inOffset = 0;
            let inLimit = utf16In.length;
            let outInt = this.buffer;
            let outOffset = this.position;
            while(inOffset < inLimit){
                let c = input[inOffset];
                inOffset++;
                if (this.prevHighSurrogate !== -1) {
                    if ($gIRNa.isLowSurrogate(c)) {
                        outInt[outOffset] = String.fromCharCode(this.prevHighSurrogate, c).codePointAt(0);
                        outOffset++;
                        this.prevHighSurrogate = -1;
                    } else {
                        // Dangling high surrogate
                        outInt[outOffset] = this.prevHighSurrogate;
                        outOffset++;
                        if ($gIRNa.isHighSurrogate(c)) this.prevHighSurrogate = c;
                        else {
                            outInt[outOffset] = c;
                            outOffset++;
                            this.prevHighSurrogate = -1;
                        }
                    }
                } else if ($gIRNa.isHighSurrogate(c)) this.prevHighSurrogate = c;
                else {
                    outInt[outOffset] = c;
                    outOffset++;
                }
            }
            if (this.prevHighSurrogate !== -1) {
                // Dangling high surrogate
                outInt[outOffset] = this.prevHighSurrogate;
                outOffset++;
            }
            this.position = outOffset;
        }
        byteToCharBuffer(toAppend) {
            // CharBuffers hold twice as much per unit as ByteBuffers, so start with half the capacity.
            let newBuffer = new Uint16Array(Math.max(this.position + toAppend, this.buffer.length >> 1));
            newBuffer.set(this.buffer.subarray(0, this.position), 0);
            this.type = 1 /* CHAR */ ;
            this.buffer = newBuffer;
        }
        byteToIntBuffer(toAppend) {
            // IntBuffers hold four times as much per unit as ByteBuffers, so start with one quarter the capacity.
            let newBuffer = new Int32Array(Math.max(this.position + toAppend, this.buffer.length >> 2));
            newBuffer.set(this.buffer.subarray(0, this.position), 0);
            this.type = 2 /* INT */ ;
            this.buffer = newBuffer;
        }
        charToIntBuffer(toAppend) {
            // IntBuffers hold two times as much per unit as ByteBuffers, so start with one half the capacity.
            let newBuffer = new Int32Array(Math.max(this.position + toAppend, this.buffer.length >> 1));
            newBuffer.set(this.buffer.subarray(0, this.position), 0);
            this.type = 2 /* INT */ ;
            this.buffer = newBuffer;
        }
    }
    CodePointBuffer.Builder = Builder;
})($151b0001e5dcadf1$var$CodePointBuffer = module.exports.CodePointBuffer || (module.exports.CodePointBuffer = {}));

});
parcelRegister("gIRNa", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isSupplementaryCodePoint = module.exports.isLowSurrogate = module.exports.isHighSurrogate = void 0;
function $c2ca7b5ca2fc06e2$var$isHighSurrogate(ch) {
    return ch >= 0xD800 && ch <= 0xDBFF;
}
module.exports.isHighSurrogate = $c2ca7b5ca2fc06e2$var$isHighSurrogate;
function $c2ca7b5ca2fc06e2$var$isLowSurrogate(ch) {
    return ch >= 0xDC00 && ch <= 0xDFFF;
}
module.exports.isLowSurrogate = $c2ca7b5ca2fc06e2$var$isLowSurrogate;
function $c2ca7b5ca2fc06e2$var$isSupplementaryCodePoint(ch) {
    return ch >= 0x10000;
}
module.exports.isSupplementaryCodePoint = $c2ca7b5ca2fc06e2$var$isSupplementaryCodePoint;

});


parcelRegister("7ufNj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $57379632ac21bb89$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CodePointCharStream = void 0;

var $bbHFU = parcelRequire("bbHFU");

var $ceaEj = parcelRequire("ceaEj");

var $gcfUE = parcelRequire("gcfUE");

var $d6D31 = parcelRequire("d6D31");
/**
 * Alternative to {@link ANTLRInputStream} which treats the input
 * as a series of Unicode code points, instead of a series of UTF-16
 * code units.
 *
 * Use this if you need to parse input which potentially contains
 * Unicode values > U+FFFF.
 */ class $57379632ac21bb89$var$CodePointCharStream {
    // Use the factory method {@link #fromBuffer(CodePointBuffer)} to
    // construct instances of this type.
    constructor(array, position, remaining, name){
        // TODO
        $bbHFU(position === 0);
        this._array = array;
        this._size = remaining;
        this._name = name;
        this._position = 0;
    }
    get internalStorage() {
        return this._array;
    }
    static fromBuffer(codePointBuffer, name) {
        if (name === undefined || name.length === 0) name = $ceaEj.IntStream.UNKNOWN_SOURCE_NAME;
        // Java lacks generics on primitive types.
        //
        // To avoid lots of calls to virtual methods in the
        // very hot codepath of LA() below, we construct one
        // of three concrete subclasses.
        //
        // The concrete subclasses directly access the code
        // points stored in the underlying array (byte[],
        // char[], or int[]), so we can avoid lots of virtual
        // method calls to ByteBuffer.get(offset).
        return new $57379632ac21bb89$var$CodePointCharStream(codePointBuffer.array(), codePointBuffer.position, codePointBuffer.remaining, name);
    }
    consume() {
        if (this._size - this._position === 0) {
            $bbHFU(this.LA(1) === $ceaEj.IntStream.EOF);
            throw new RangeError("cannot consume EOF");
        }
        this._position++;
    }
    get index() {
        return this._position;
    }
    get size() {
        return this._size;
    }
    /** mark/release do nothing; we have entire buffer */ mark() {
        return -1;
    }
    release(marker) {
    // No default implementation since this stream buffers the entire input
    }
    seek(index) {
        this._position = index;
    }
    get sourceName() {
        return this._name;
    }
    toString() {
        return this.getText($gcfUE.Interval.of(0, this.size - 1));
    }
    LA(i) {
        let offset;
        switch(Math.sign(i)){
            case -1:
                offset = this.index + i;
                if (offset < 0) return $ceaEj.IntStream.EOF;
                return this._array[offset];
            case 0:
                // Undefined
                return 0;
            case 1:
                offset = this.index + i - 1;
                if (offset >= this.size) return $ceaEj.IntStream.EOF;
                return this._array[offset];
        }
        throw new RangeError("Not reached");
    }
    /** Return the UTF-16 encoded string for the given interval */ getText(interval) {
        const startIdx = Math.min(interval.a, this.size);
        const len = Math.min(interval.b - interval.a + 1, this.size - startIdx);
        if (this._array instanceof Int32Array) return String.fromCodePoint(...Array.from(this._array.subarray(startIdx, startIdx + len)));
        else return String.fromCharCode(...Array.from(this._array.subarray(startIdx, startIdx + len)));
    }
}
$57379632ac21bb89$var$__decorate([
    $d6D31.Override
], $57379632ac21bb89$var$CodePointCharStream.prototype, "consume", null);
$57379632ac21bb89$var$__decorate([
    $d6D31.Override
], $57379632ac21bb89$var$CodePointCharStream.prototype, "index", null);
$57379632ac21bb89$var$__decorate([
    $d6D31.Override
], $57379632ac21bb89$var$CodePointCharStream.prototype, "size", null);
$57379632ac21bb89$var$__decorate([
    $d6D31.Override
], $57379632ac21bb89$var$CodePointCharStream.prototype, "mark", null);
$57379632ac21bb89$var$__decorate([
    $d6D31.Override
], $57379632ac21bb89$var$CodePointCharStream.prototype, "release", null);
$57379632ac21bb89$var$__decorate([
    $d6D31.Override
], $57379632ac21bb89$var$CodePointCharStream.prototype, "seek", null);
$57379632ac21bb89$var$__decorate([
    $d6D31.Override
], $57379632ac21bb89$var$CodePointCharStream.prototype, "sourceName", null);
$57379632ac21bb89$var$__decorate([
    $d6D31.Override
], $57379632ac21bb89$var$CodePointCharStream.prototype, "toString", null);
$57379632ac21bb89$var$__decorate([
    $d6D31.Override
], $57379632ac21bb89$var$CodePointCharStream.prototype, "LA", null);
$57379632ac21bb89$var$__decorate([
    $d6D31.Override
], $57379632ac21bb89$var$CodePointCharStream.prototype, "getText", null);
module.exports.CodePointCharStream = $57379632ac21bb89$var$CodePointCharStream;

});


parcelRegister("a0nC0", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $748c38524e2afd86$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $748c38524e2afd86$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommonTokenStream = void 0;

var $1UkCC = parcelRequire("1UkCC");

var $d6D31 = parcelRequire("d6D31");

var $2DVsz = parcelRequire("2DVsz");
/**
 * This class extends {@link BufferedTokenStream} with functionality to filter
 * token streams to tokens on a particular channel (tokens where
 * {@link Token#getChannel} returns a particular value).
 *
 * This token stream provides access to all tokens by index or when calling
 * methods like {@link #getText}. The channel filtering is only used for code
 * accessing tokens via the lookahead methods {@link #LA}, {@link #LT}, and
 * {@link #LB}.
 *
 * By default, tokens are placed on the default channel
 * ({@link Token#DEFAULT_CHANNEL}), but may be reassigned by using the
 * `->channel(HIDDEN)` lexer command, or by using an embedded action to
 * call {@link Lexer#setChannel}.
 *
 * Note: lexer rules which use the `->skip` lexer command or call
 * {@link Lexer#skip} do not produce tokens at all, so input text matched by
 * such a rule will not be available as part of the token stream, regardless of
 * channel.
 */ let $748c38524e2afd86$var$CommonTokenStream = class CommonTokenStream extends $1UkCC.BufferedTokenStream {
    /**
     * Constructs a new {@link CommonTokenStream} using the specified token
     * source and filtering tokens to the specified channel. Only tokens whose
     * {@link Token#getChannel} matches `channel` or have the
     * `Token.type` equal to {@link Token#EOF} will be returned by the
     * token stream lookahead methods.
     *
     * @param tokenSource The token source.
     * @param channel The channel to use for filtering tokens.
     */ constructor(tokenSource, channel = $2DVsz.Token.DEFAULT_CHANNEL){
        super(tokenSource);
        this.channel = channel;
    }
    adjustSeekIndex(i) {
        return this.nextTokenOnChannel(i, this.channel);
    }
    tryLB(k) {
        if (this.p - k < 0) return undefined;
        let i = this.p;
        let n = 1;
        // find k good tokens looking backwards
        while(n <= k && i > 0){
            // skip off-channel tokens
            i = this.previousTokenOnChannel(i - 1, this.channel);
            n++;
        }
        if (i < 0) return undefined;
        return this.tokens[i];
    }
    tryLT(k) {
        //System.out.println("enter LT("+k+")");
        this.lazyInit();
        if (k === 0) throw new RangeError("0 is not a valid lookahead index");
        if (k < 0) return this.tryLB(-k);
        let i = this.p;
        let n = 1; // we know tokens[p] is a good one
        // find k good tokens
        while(n < k){
            // skip off-channel tokens, but make sure to not look past EOF
            if (this.sync(i + 1)) i = this.nextTokenOnChannel(i + 1, this.channel);
            n++;
        }
        //		if ( i>range ) range = i;
        return this.tokens[i];
    }
    /** Count EOF just once. */ getNumberOfOnChannelTokens() {
        let n = 0;
        this.fill();
        for (let t of this.tokens){
            if (t.channel === this.channel) n++;
            if (t.type === $2DVsz.Token.EOF) break;
        }
        return n;
    }
};
$748c38524e2afd86$var$__decorate([
    $d6D31.Override
], $748c38524e2afd86$var$CommonTokenStream.prototype, "adjustSeekIndex", null);
$748c38524e2afd86$var$__decorate([
    $d6D31.Override
], $748c38524e2afd86$var$CommonTokenStream.prototype, "tryLB", null);
$748c38524e2afd86$var$__decorate([
    $d6D31.Override
], $748c38524e2afd86$var$CommonTokenStream.prototype, "tryLT", null);
$748c38524e2afd86$var$CommonTokenStream = $748c38524e2afd86$var$__decorate([
    $748c38524e2afd86$var$__param(0, $d6D31.NotNull)
], $748c38524e2afd86$var$CommonTokenStream);
module.exports.CommonTokenStream = $748c38524e2afd86$var$CommonTokenStream;

});

parcelRegister("4a3G0", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Dependents = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:51.1349829-07:00
/**
 *
 * @author Sam Harwell
 */ var $307af2a6cd217eb5$var$Dependents;
(function(Dependents) {
    /**
     * The element is dependent upon the specified rule.
     */ Dependents[Dependents["SELF"] = 0] = "SELF";
    /**
     * The element is dependent upon the set of the specified rule's parents
     * (rules which directly reference it).
     */ Dependents[Dependents["PARENTS"] = 1] = "PARENTS";
    /**
     * The element is dependent upon the set of the specified rule's children
     * (rules which it directly references).
     */ Dependents[Dependents["CHILDREN"] = 2] = "CHILDREN";
    /**
     * The element is dependent upon the set of the specified rule's ancestors
     * (the transitive closure of `PARENTS` rules).
     */ Dependents[Dependents["ANCESTORS"] = 3] = "ANCESTORS";
    /**
     * The element is dependent upon the set of the specified rule's descendants
     * (the transitive closure of `CHILDREN` rules).
     */ Dependents[Dependents["DESCENDANTS"] = 4] = "DESCENDANTS";
    /**
     * The element is dependent upon the set of the specified rule's siblings
     * (the union of `CHILDREN` of its `PARENTS`).
     */ Dependents[Dependents["SIBLINGS"] = 5] = "SIBLINGS";
    /**
     * The element is dependent upon the set of the specified rule's preceeding
     * siblings (the union of `CHILDREN` of its `PARENTS` which
     * appear before a reference to the rule).
     */ Dependents[Dependents["PRECEEDING_SIBLINGS"] = 6] = "PRECEEDING_SIBLINGS";
    /**
     * The element is dependent upon the set of the specified rule's following
     * siblings (the union of `CHILDREN` of its `PARENTS` which
     * appear after a reference to the rule).
     */ Dependents[Dependents["FOLLOWING_SIBLINGS"] = 7] = "FOLLOWING_SIBLINGS";
    /**
     * The element is dependent upon the set of the specified rule's preceeding
     * elements (rules which might end before the start of the specified rule
     * while parsing). This is calculated by taking the
     * `PRECEEDING_SIBLINGS` of the rule and each of its
     * `ANCESTORS`, along with the `DESCENDANTS` of those
     * elements.
     */ Dependents[Dependents["PRECEEDING"] = 8] = "PRECEEDING";
    /**
     * The element is dependent upon the set of the specified rule's following
     * elements (rules which might start after the end of the specified rule
     * while parsing). This is calculated by taking the
     * `FOLLOWING_SIBLINGS` of the rule and each of its
     * `ANCESTORS`, along with the `DESCENDANTS` of those
     * elements.
     */ Dependents[Dependents["FOLLOWING"] = 9] = "FOLLOWING";
})($307af2a6cd217eb5$var$Dependents = module.exports.Dependents || (module.exports.Dependents = {}));

});

parcelRegister("5Poq6", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $43e4a87e035cc726$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $43e4a87e035cc726$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DiagnosticErrorListener = void 0;

var $5BPMp = parcelRequire("5BPMp");

var $d6D31 = parcelRequire("d6D31");

var $gcfUE = parcelRequire("gcfUE");
/**
 * This implementation of {@link ANTLRErrorListener} can be used to identify
 * certain potential correctness and performance problems in grammars. "Reports"
 * are made by calling {@link Parser#notifyErrorListeners} with the appropriate
 * message.
 *
 * * **Ambiguities**: These are cases where more than one path through the
 *   grammar can match the input.
 * * **Weak context sensitivity**: These are cases where full-context
 *   prediction resolved an SLL conflict to a unique alternative which equaled the
 *   minimum alternative of the SLL conflict.
 * * **Strong (forced) context sensitivity**: These are cases where the
 *   full-context prediction resolved an SLL conflict to a unique alternative,
 *   *and* the minimum alternative of the SLL conflict was found to not be
 *   a truly viable alternative. Two-stage parsing cannot be used for inputs where
 *   this situation occurs.
 *
 * @author Sam Harwell
 */ class $43e4a87e035cc726$var$DiagnosticErrorListener {
    /**
     * Initializes a new instance of {@link DiagnosticErrorListener}, specifying
     * whether all ambiguities or only exact ambiguities are reported.
     *
     * @param exactOnly `true` to report only exact ambiguities, otherwise
     * `false` to report all ambiguities.  Defaults to true.
     */ constructor(exactOnly = true){
        this.exactOnly = exactOnly;
        this.exactOnly = exactOnly;
    }
    syntaxError(/*@NotNull*/ recognizer, offendingSymbol, line, charPositionInLine, /*@NotNull*/ msg, e) {
    // intentionally empty
    }
    reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs) {
        if (this.exactOnly && !exact) return;
        let decision = this.getDecisionDescription(recognizer, dfa);
        let conflictingAlts = this.getConflictingAlts(ambigAlts, configs);
        let text = recognizer.inputStream.getText($gcfUE.Interval.of(startIndex, stopIndex));
        let message = `reportAmbiguity d=${decision}: ambigAlts=${conflictingAlts}, input='${text}'`;
        recognizer.notifyErrorListeners(message);
    }
    reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState) {
        let format = "reportAttemptingFullContext d=%s, input='%s'";
        let decision = this.getDecisionDescription(recognizer, dfa);
        let text = recognizer.inputStream.getText($gcfUE.Interval.of(startIndex, stopIndex));
        let message = `reportAttemptingFullContext d=${decision}, input='${text}'`;
        recognizer.notifyErrorListeners(message);
    }
    reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState) {
        let format = "reportContextSensitivity d=%s, input='%s'";
        let decision = this.getDecisionDescription(recognizer, dfa);
        let text = recognizer.inputStream.getText($gcfUE.Interval.of(startIndex, stopIndex));
        let message = `reportContextSensitivity d=${decision}, input='${text}'`;
        recognizer.notifyErrorListeners(message);
    }
    getDecisionDescription(recognizer, dfa) {
        let decision = dfa.decision;
        let ruleIndex = dfa.atnStartState.ruleIndex;
        let ruleNames = recognizer.ruleNames;
        if (ruleIndex < 0 || ruleIndex >= ruleNames.length) return decision.toString();
        let ruleName = ruleNames[ruleIndex];
        if (!ruleName) return decision.toString();
        return `${decision} (${ruleName})`;
    }
    /**
     * Computes the set of conflicting or ambiguous alternatives from a
     * configuration set, if that information was not already provided by the
     * parser.
     *
     * @param reportedAlts The set of conflicting or ambiguous alternatives, as
     * reported by the parser.
     * @param configs The conflicting or ambiguous configuration set.
     * @returns Returns `reportedAlts` if it is not `undefined`, otherwise
     * returns the set of alternatives represented in `configs`.
     */ getConflictingAlts(reportedAlts, configs) {
        if (reportedAlts != null) return reportedAlts;
        let result = new $5BPMp.BitSet();
        for (let config of configs)result.set(config.alt);
        return result;
    }
}
$43e4a87e035cc726$var$__decorate([
    $d6D31.Override
], $43e4a87e035cc726$var$DiagnosticErrorListener.prototype, "syntaxError", null);
$43e4a87e035cc726$var$__decorate([
    $d6D31.Override,
    $43e4a87e035cc726$var$__param(0, $d6D31.NotNull),
    $43e4a87e035cc726$var$__param(1, $d6D31.NotNull),
    $43e4a87e035cc726$var$__param(6, $d6D31.NotNull)
], $43e4a87e035cc726$var$DiagnosticErrorListener.prototype, "reportAmbiguity", null);
$43e4a87e035cc726$var$__decorate([
    $d6D31.Override,
    $43e4a87e035cc726$var$__param(0, $d6D31.NotNull),
    $43e4a87e035cc726$var$__param(1, $d6D31.NotNull),
    $43e4a87e035cc726$var$__param(5, $d6D31.NotNull)
], $43e4a87e035cc726$var$DiagnosticErrorListener.prototype, "reportAttemptingFullContext", null);
$43e4a87e035cc726$var$__decorate([
    $d6D31.Override,
    $43e4a87e035cc726$var$__param(0, $d6D31.NotNull),
    $43e4a87e035cc726$var$__param(1, $d6D31.NotNull),
    $43e4a87e035cc726$var$__param(5, $d6D31.NotNull)
], $43e4a87e035cc726$var$DiagnosticErrorListener.prototype, "reportContextSensitivity", null);
$43e4a87e035cc726$var$__decorate([
    $43e4a87e035cc726$var$__param(0, $d6D31.NotNull),
    $43e4a87e035cc726$var$__param(1, $d6D31.NotNull)
], $43e4a87e035cc726$var$DiagnosticErrorListener.prototype, "getDecisionDescription", null);
$43e4a87e035cc726$var$__decorate([
    $d6D31.NotNull,
    $43e4a87e035cc726$var$__param(1, $d6D31.NotNull)
], $43e4a87e035cc726$var$DiagnosticErrorListener.prototype, "getConflictingAlts", null);
module.exports.DiagnosticErrorListener = $43e4a87e035cc726$var$DiagnosticErrorListener;

});

parcelRegister("5FrZ8", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $42067d58e54221f4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InterpreterRuleContext = void 0;

var $d6D31 = parcelRequire("d6D31");

var $6bmaO = parcelRequire("6bmaO");
/**
 * This class extends {@link ParserRuleContext} by allowing the value of
 * {@link #getRuleIndex} to be explicitly set for the context.
 *
 * {@link ParserRuleContext} does not include field storage for the rule index
 * since the context classes created by the code generator override the
 * {@link #getRuleIndex} method to return the correct value for that context.
 * Since the parser interpreter does not use the context classes generated for a
 * parser, this class (with slightly more memory overhead per node) is used to
 * provide equivalent functionality.
 */ class $42067d58e54221f4$var$InterpreterRuleContext extends $6bmaO.ParserRuleContext {
    constructor(ruleIndex, parent, invokingStateNumber){
        if (invokingStateNumber !== undefined) super(parent, invokingStateNumber);
        else super();
        this._ruleIndex = ruleIndex;
    }
    get ruleIndex() {
        return this._ruleIndex;
    }
}
$42067d58e54221f4$var$__decorate([
    $d6D31.Override
], $42067d58e54221f4$var$InterpreterRuleContext.prototype, "ruleIndex", null);
module.exports.InterpreterRuleContext = $42067d58e54221f4$var$InterpreterRuleContext;

});

parcelRegister("gMbxO", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c36a1586c540a239$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c36a1586c540a239$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerInterpreter = void 0;

var $igNLf = parcelRequire("igNLf");

var $lQecE = parcelRequire("lQecE");

var $d6D31 = parcelRequire("d6D31");

var $d6D31 = parcelRequire("d6D31");
let $c36a1586c540a239$var$LexerInterpreter = class LexerInterpreter extends $igNLf.Lexer {
    constructor(grammarFileName, vocabulary, ruleNames, channelNames, modeNames, atn, input){
        super(input);
        if (atn.grammarType !== 0 /* LEXER */ ) throw new Error("IllegalArgumentException: The ATN must be a lexer ATN.");
        this._grammarFileName = grammarFileName;
        this._atn = atn;
        this._ruleNames = ruleNames.slice(0);
        this._channelNames = channelNames.slice(0);
        this._modeNames = modeNames.slice(0);
        this._vocabulary = vocabulary;
        this._interp = new $lQecE.LexerATNSimulator(atn, this);
    }
    get atn() {
        return this._atn;
    }
    get grammarFileName() {
        return this._grammarFileName;
    }
    get ruleNames() {
        return this._ruleNames;
    }
    get channelNames() {
        return this._channelNames;
    }
    get modeNames() {
        return this._modeNames;
    }
    get vocabulary() {
        return this._vocabulary;
    }
};
$c36a1586c540a239$var$__decorate([
    $d6D31.NotNull
], $c36a1586c540a239$var$LexerInterpreter.prototype, "_vocabulary", void 0);
$c36a1586c540a239$var$__decorate([
    $d6D31.Override
], $c36a1586c540a239$var$LexerInterpreter.prototype, "atn", null);
$c36a1586c540a239$var$__decorate([
    $d6D31.Override
], $c36a1586c540a239$var$LexerInterpreter.prototype, "grammarFileName", null);
$c36a1586c540a239$var$__decorate([
    $d6D31.Override
], $c36a1586c540a239$var$LexerInterpreter.prototype, "ruleNames", null);
$c36a1586c540a239$var$__decorate([
    $d6D31.Override
], $c36a1586c540a239$var$LexerInterpreter.prototype, "channelNames", null);
$c36a1586c540a239$var$__decorate([
    $d6D31.Override
], $c36a1586c540a239$var$LexerInterpreter.prototype, "modeNames", null);
$c36a1586c540a239$var$__decorate([
    $d6D31.Override
], $c36a1586c540a239$var$LexerInterpreter.prototype, "vocabulary", null);
$c36a1586c540a239$var$LexerInterpreter = $c36a1586c540a239$var$__decorate([
    $c36a1586c540a239$var$__param(1, $d6D31.NotNull)
], $c36a1586c540a239$var$LexerInterpreter);
module.exports.LexerInterpreter = $c36a1586c540a239$var$LexerInterpreter;

});

parcelRegister("drCaH", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9c9b68135c38f0cc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9c9b68135c38f0cc$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ListTokenSource = void 0;

var $gWaB3 = parcelRequire("gWaB3");

var $d6D31 = parcelRequire("d6D31");

var $2DVsz = parcelRequire("2DVsz");
/**
 * Provides an implementation of {@link TokenSource} as a wrapper around a list
 * of {@link Token} objects.
 *
 * If the final token in the list is an {@link Token#EOF} token, it will be used
 * as the EOF token for every call to {@link #nextToken} after the end of the
 * list is reached. Otherwise, an EOF token will be created.
 */ let $9c9b68135c38f0cc$var$ListTokenSource = class ListTokenSource {
    /**
     * Constructs a new {@link ListTokenSource} instance from the specified
     * collection of {@link Token} objects and source name.
     *
     * @param tokens The collection of {@link Token} objects to provide as a
     * {@link TokenSource}.
     * @param sourceName The name of the {@link TokenSource}. If this value is
     * `undefined`, {@link #getSourceName} will attempt to infer the name from
     * the next {@link Token} (or the previous token if the end of the input has
     * been reached).
     *
     * @exception NullPointerException if `tokens` is `undefined`
     */ constructor(tokens, sourceName){
        /**
         * The index into {@link #tokens} of token to return by the next call to
         * {@link #nextToken}. The end of the input is indicated by this value
         * being greater than or equal to the number of items in {@link #tokens}.
         */ this.i = 0;
        /**
         * This is the backing field for {@link #getTokenFactory} and
         * {@link setTokenFactory}.
         */ this._factory = $gWaB3.CommonTokenFactory.DEFAULT;
        if (tokens == null) throw new Error("tokens cannot be null");
        this.tokens = tokens;
        this._sourceName = sourceName;
    }
    /**
     * {@inheritDoc}
     */ get charPositionInLine() {
        if (this.i < this.tokens.length) return this.tokens[this.i].charPositionInLine;
        else if (this.eofToken != null) return this.eofToken.charPositionInLine;
        else if (this.tokens.length > 0) {
            // have to calculate the result from the line/column of the previous
            // token, along with the text of the token.
            let lastToken = this.tokens[this.tokens.length - 1];
            let tokenText = lastToken.text;
            if (tokenText != null) {
                let lastNewLine = tokenText.lastIndexOf("\n");
                if (lastNewLine >= 0) return tokenText.length - lastNewLine - 1;
            }
            return lastToken.charPositionInLine + lastToken.stopIndex - lastToken.startIndex + 1;
        }
        // only reach this if tokens is empty, meaning EOF occurs at the first
        // position in the input
        return 0;
    }
    /**
     * {@inheritDoc}
     */ nextToken() {
        if (this.i >= this.tokens.length) {
            if (this.eofToken == null) {
                let start = -1;
                if (this.tokens.length > 0) {
                    let previousStop = this.tokens[this.tokens.length - 1].stopIndex;
                    if (previousStop !== -1) start = previousStop + 1;
                }
                let stop = Math.max(-1, start - 1);
                this.eofToken = this._factory.create({
                    source: this,
                    stream: this.inputStream
                }, $2DVsz.Token.EOF, "EOF", $2DVsz.Token.DEFAULT_CHANNEL, start, stop, this.line, this.charPositionInLine);
            }
            return this.eofToken;
        }
        let t = this.tokens[this.i];
        if (this.i === this.tokens.length - 1 && t.type === $2DVsz.Token.EOF) this.eofToken = t;
        this.i++;
        return t;
    }
    /**
     * {@inheritDoc}
     */ get line() {
        if (this.i < this.tokens.length) return this.tokens[this.i].line;
        else if (this.eofToken != null) return this.eofToken.line;
        else if (this.tokens.length > 0) {
            // have to calculate the result from the line/column of the previous
            // token, along with the text of the token.
            let lastToken = this.tokens[this.tokens.length - 1];
            let line = lastToken.line;
            let tokenText = lastToken.text;
            if (tokenText != null) {
                for(let i = 0; i < tokenText.length; i++)if (tokenText.charAt(i) === "\n") line++;
            }
            // if no text is available, assume the token did not contain any newline characters.
            return line;
        }
        // only reach this if tokens is empty, meaning EOF occurs at the first
        // position in the input
        return 1;
    }
    /**
     * {@inheritDoc}
     */ get inputStream() {
        if (this.i < this.tokens.length) return this.tokens[this.i].inputStream;
        else if (this.eofToken != null) return this.eofToken.inputStream;
        else if (this.tokens.length > 0) return this.tokens[this.tokens.length - 1].inputStream;
        // no input stream information is available
        return undefined;
    }
    /**
     * {@inheritDoc}
     */ get sourceName() {
        if (this._sourceName) return this._sourceName;
        let inputStream = this.inputStream;
        if (inputStream != null) return inputStream.sourceName;
        return "List";
    }
    /**
     * {@inheritDoc}
     */ // @Override
    set tokenFactory(factory) {
        this._factory = factory;
    }
    /**
     * {@inheritDoc}
     */ get tokenFactory() {
        return this._factory;
    }
};
$9c9b68135c38f0cc$var$__decorate([
    $d6D31.Override
], $9c9b68135c38f0cc$var$ListTokenSource.prototype, "charPositionInLine", null);
$9c9b68135c38f0cc$var$__decorate([
    $d6D31.Override
], $9c9b68135c38f0cc$var$ListTokenSource.prototype, "nextToken", null);
$9c9b68135c38f0cc$var$__decorate([
    $d6D31.Override
], $9c9b68135c38f0cc$var$ListTokenSource.prototype, "line", null);
$9c9b68135c38f0cc$var$__decorate([
    $d6D31.Override
], $9c9b68135c38f0cc$var$ListTokenSource.prototype, "inputStream", null);
$9c9b68135c38f0cc$var$__decorate([
    $d6D31.Override
], $9c9b68135c38f0cc$var$ListTokenSource.prototype, "sourceName", null);
$9c9b68135c38f0cc$var$__decorate([
    $d6D31.Override,
    $d6D31.NotNull,
    $9c9b68135c38f0cc$var$__param(0, $d6D31.NotNull)
], $9c9b68135c38f0cc$var$ListTokenSource.prototype, "tokenFactory", null);
$9c9b68135c38f0cc$var$ListTokenSource = $9c9b68135c38f0cc$var$__decorate([
    $9c9b68135c38f0cc$var$__param(0, $d6D31.NotNull)
], $9c9b68135c38f0cc$var$ListTokenSource);
module.exports.ListTokenSource = $9c9b68135c38f0cc$var$ListTokenSource;

});

parcelRegister("2pQQd", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("dReoi", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a16b634f90dd81f4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a16b634f90dd81f4$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParserInterpreter = void 0;

var $7j0Pc = parcelRequire("7j0Pc");

var $1bs3X = parcelRequire("1bs3X");

var $5BPMp = parcelRequire("5BPMp");

var $ea0YW = parcelRequire("ea0YW");

var $iLUMi = parcelRequire("iLUMi");

var $5FrZ8 = parcelRequire("5FrZ8");

var $kfqEk = parcelRequire("kfqEk");

var $d6D31 = parcelRequire("d6D31");

var $d6D31 = parcelRequire("d6D31");

var $jIG0W = parcelRequire("jIG0W");

var $kzbnL = parcelRequire("kzbnL");

var $fLdDn = parcelRequire("fLdDn");

var $f9raX = parcelRequire("f9raX");

var $2DVsz = parcelRequire("2DVsz");
/** A parser simulator that mimics what ANTLR's generated
 *  parser code does. A ParserATNSimulator is used to make
 *  predictions via adaptivePredict but this class moves a pointer through the
 *  ATN to simulate parsing. ParserATNSimulator just
 *  makes us efficient rather than having to backtrack, for example.
 *
 *  This properly creates parse trees even for left recursive rules.
 *
 *  We rely on the left recursive rule invocation and special predicate
 *  transitions to make left recursive rules work.
 *
 *  See TestParserInterpreter for examples.
 */ let $a16b634f90dd81f4$var$ParserInterpreter = class ParserInterpreter extends $jIG0W.Parser {
    constructor(grammarFileName, vocabulary, ruleNames, atn, input){
        super(grammarFileName instanceof ParserInterpreter ? grammarFileName.inputStream : input);
        /** This stack corresponds to the _parentctx, _parentState pair of locals
         *  that would exist on call stack frames with a recursive descent parser;
         *  in the generated function for a left-recursive rule you'd see:
         *
         *  private EContext e(int _p) {
         *      ParserRuleContext _parentctx = _ctx;    // Pair.a
         *      int _parentState = state;          // Pair.b
         *      ...
         *  }
         *
         *  Those values are used to create new recursive rule invocation contexts
         *  associated with left operand of an alt like "expr '*' expr".
         */ this._parentContextStack = [];
        /** We need a map from (decision,inputIndex)->forced alt for computing ambiguous
         *  parse trees. For now, we allow exactly one override.
         */ this.overrideDecision = -1;
        this.overrideDecisionInputIndex = -1;
        this.overrideDecisionAlt = -1;
        this.overrideDecisionReached = false; // latch and only override once; error might trigger infinite loop
        /** What is the current context when we override a decisions?  This tells
         *  us what the root of the parse tree is when using override
         *  for an ambiguity/lookahead check.
         */ this._overrideDecisionRoot = undefined;
        if (grammarFileName instanceof ParserInterpreter) {
            let old = grammarFileName;
            this._grammarFileName = old._grammarFileName;
            this._atn = old._atn;
            this.pushRecursionContextStates = old.pushRecursionContextStates;
            this._ruleNames = old._ruleNames;
            this._vocabulary = old._vocabulary;
            this.interpreter = new $kzbnL.ParserATNSimulator(this._atn, this);
        } else {
            // The second constructor requires non-null arguments
            vocabulary;
            ruleNames;
            atn;
            this._grammarFileName = grammarFileName;
            this._atn = atn;
            this._ruleNames = ruleNames.slice(0);
            this._vocabulary = vocabulary;
            // identify the ATN states where pushNewRecursionContext() must be called
            this.pushRecursionContextStates = new $5BPMp.BitSet(atn.states.length);
            for (let state of atn.states){
                if (!(state instanceof $f9raX.StarLoopEntryState)) continue;
                if (state.precedenceRuleDecision) this.pushRecursionContextStates.set(state.stateNumber);
            }
            // get atn simulator that knows how to do predictions
            this.interpreter = new $kzbnL.ParserATNSimulator(atn, this);
        }
    }
    reset(resetInput) {
        if (resetInput === undefined) super.reset();
        else super.reset(resetInput);
        this.overrideDecisionReached = false;
        this._overrideDecisionRoot = undefined;
    }
    get atn() {
        return this._atn;
    }
    get vocabulary() {
        return this._vocabulary;
    }
    get ruleNames() {
        return this._ruleNames;
    }
    get grammarFileName() {
        return this._grammarFileName;
    }
    /** Begin parsing at startRuleIndex */ parse(startRuleIndex) {
        let startRuleStartState = this._atn.ruleToStartState[startRuleIndex];
        this._rootContext = this.createInterpreterRuleContext(undefined, $7j0Pc.ATNState.INVALID_STATE_NUMBER, startRuleIndex);
        if (startRuleStartState.isPrecedenceRule) this.enterRecursionRule(this._rootContext, startRuleStartState.stateNumber, startRuleIndex, 0);
        else this.enterRule(this._rootContext, startRuleStartState.stateNumber, startRuleIndex);
        while(true){
            let p = this.atnState;
            switch(p.stateType){
                case $1bs3X.ATNStateType.RULE_STOP:
                    // pop; return from rule
                    if (this._ctx.isEmpty) {
                        if (startRuleStartState.isPrecedenceRule) {
                            let result = this._ctx;
                            let parentContext = this._parentContextStack.pop();
                            this.unrollRecursionContexts(parentContext[0]);
                            return result;
                        } else {
                            this.exitRule();
                            return this._rootContext;
                        }
                    }
                    this.visitRuleStopState(p);
                    break;
                default:
                    try {
                        this.visitState(p);
                    } catch (e) {
                        if (e instanceof $fLdDn.RecognitionException) {
                            this.state = this._atn.ruleToStopState[p.ruleIndex].stateNumber;
                            this.context.exception = e;
                            this.errorHandler.reportError(this, e);
                            this.recover(e);
                        } else throw e;
                    }
                    break;
            }
        }
    }
    enterRecursionRule(localctx, state, ruleIndex, precedence) {
        this._parentContextStack.push([
            this._ctx,
            localctx.invokingState
        ]);
        super.enterRecursionRule(localctx, state, ruleIndex, precedence);
    }
    get atnState() {
        return this._atn.states[this.state];
    }
    visitState(p) {
        let predictedAlt = 1;
        if (p.numberOfTransitions > 1) predictedAlt = this.visitDecisionState(p);
        let transition = p.transition(predictedAlt - 1);
        switch(transition.serializationType){
            case 1 /* EPSILON */ :
                if (this.pushRecursionContextStates.get(p.stateNumber) && !(transition.target instanceof $kfqEk.LoopEndState)) {
                    // We are at the start of a left recursive rule's (...)* loop
                    // and we're not taking the exit branch of loop.
                    let parentContext = this._parentContextStack[this._parentContextStack.length - 1];
                    let localctx = this.createInterpreterRuleContext(parentContext[0], parentContext[1], this._ctx.ruleIndex);
                    this.pushNewRecursionContext(localctx, this._atn.ruleToStartState[p.ruleIndex].stateNumber, this._ctx.ruleIndex);
                }
                break;
            case 5 /* ATOM */ :
                this.match(transition._label);
                break;
            case 2 /* RANGE */ :
            case 7 /* SET */ :
            case 8 /* NOT_SET */ :
                if (!transition.matches(this._input.LA(1), $2DVsz.Token.MIN_USER_TOKEN_TYPE, 65535)) this.recoverInline();
                this.matchWildcard();
                break;
            case 9 /* WILDCARD */ :
                this.matchWildcard();
                break;
            case 3 /* RULE */ :
                let ruleStartState = transition.target;
                let ruleIndex = ruleStartState.ruleIndex;
                let newctx = this.createInterpreterRuleContext(this._ctx, p.stateNumber, ruleIndex);
                if (ruleStartState.isPrecedenceRule) this.enterRecursionRule(newctx, ruleStartState.stateNumber, ruleIndex, transition.precedence);
                else this.enterRule(newctx, transition.target.stateNumber, ruleIndex);
                break;
            case 4 /* PREDICATE */ :
                let predicateTransition = transition;
                if (!this.sempred(this._ctx, predicateTransition.ruleIndex, predicateTransition.predIndex)) throw new $ea0YW.FailedPredicateException(this);
                break;
            case 6 /* ACTION */ :
                let actionTransition = transition;
                this.action(this._ctx, actionTransition.ruleIndex, actionTransition.actionIndex);
                break;
            case 10 /* PRECEDENCE */ :
                if (!this.precpred(this._ctx, transition.precedence)) {
                    let precedence = transition.precedence;
                    throw new $ea0YW.FailedPredicateException(this, `precpred(_ctx, ${precedence})`);
                }
                break;
            default:
                throw new Error("UnsupportedOperationException: Unrecognized ATN transition type.");
        }
        this.state = transition.target.stateNumber;
    }
    /** Method visitDecisionState() is called when the interpreter reaches
     *  a decision state (instance of DecisionState). It gives an opportunity
     *  for subclasses to track interesting things.
     */ visitDecisionState(p) {
        let predictedAlt;
        this.errorHandler.sync(this);
        let decision = p.decision;
        if (decision === this.overrideDecision && this._input.index === this.overrideDecisionInputIndex && !this.overrideDecisionReached) {
            predictedAlt = this.overrideDecisionAlt;
            this.overrideDecisionReached = true;
        } else predictedAlt = this.interpreter.adaptivePredict(this._input, decision, this._ctx);
        return predictedAlt;
    }
    /** Provide simple "factory" for InterpreterRuleContext's.
     *  @since 4.5.1
     */ createInterpreterRuleContext(parent, invokingStateNumber, ruleIndex) {
        return new $5FrZ8.InterpreterRuleContext(ruleIndex, parent, invokingStateNumber);
    }
    visitRuleStopState(p) {
        let ruleStartState = this._atn.ruleToStartState[p.ruleIndex];
        if (ruleStartState.isPrecedenceRule) {
            let parentContext = this._parentContextStack.pop();
            this.unrollRecursionContexts(parentContext[0]);
            this.state = parentContext[1];
        } else this.exitRule();
        let ruleTransition = this._atn.states[this.state].transition(0);
        this.state = ruleTransition.followState.stateNumber;
    }
    /** Override this parser interpreters normal decision-making process
     *  at a particular decision and input token index. Instead of
     *  allowing the adaptive prediction mechanism to choose the
     *  first alternative within a block that leads to a successful parse,
     *  force it to take the alternative, 1..n for n alternatives.
     *
     *  As an implementation limitation right now, you can only specify one
     *  override. This is sufficient to allow construction of different
     *  parse trees for ambiguous input. It means re-parsing the entire input
     *  in general because you're never sure where an ambiguous sequence would
     *  live in the various parse trees. For example, in one interpretation,
     *  an ambiguous input sequence would be matched completely in expression
     *  but in another it could match all the way back to the root.
     *
     *  s : e '!'? ;
     *  e : ID
     *    | ID '!'
     *    ;
     *
     *  Here, x! can be matched as (s (e ID) !) or (s (e ID !)). In the first
     *  case, the ambiguous sequence is fully contained only by the root.
     *  In the second case, the ambiguous sequences fully contained within just
     *  e, as in: (e ID !).
     *
     *  Rather than trying to optimize this and make
     *  some intelligent decisions for optimization purposes, I settled on
     *  just re-parsing the whole input and then using
     *  {link Trees#getRootOfSubtreeEnclosingRegion} to find the minimal
     *  subtree that contains the ambiguous sequence. I originally tried to
     *  record the call stack at the point the parser detected and ambiguity but
     *  left recursive rules create a parse tree stack that does not reflect
     *  the actual call stack. That impedance mismatch was enough to make
     *  it it challenging to restart the parser at a deeply nested rule
     *  invocation.
     *
     *  Only parser interpreters can override decisions so as to avoid inserting
     *  override checking code in the critical ALL(*) prediction execution path.
     *
     *  @since 4.5
     */ addDecisionOverride(decision, tokenIndex, forcedAlt) {
        this.overrideDecision = decision;
        this.overrideDecisionInputIndex = tokenIndex;
        this.overrideDecisionAlt = forcedAlt;
    }
    get overrideDecisionRoot() {
        return this._overrideDecisionRoot;
    }
    /** Rely on the error handler for this parser but, if no tokens are consumed
     *  to recover, add an error node. Otherwise, nothing is seen in the parse
     *  tree.
     */ recover(e) {
        let i = this._input.index;
        this.errorHandler.recover(this, e);
        if (this._input.index === i) {
            // no input consumed, better add an error node
            let tok = e.getOffendingToken();
            if (!tok) throw new Error("Expected exception to have an offending token");
            let source = tok.tokenSource;
            let stream = source !== undefined ? source.inputStream : undefined;
            let sourcePair = {
                source: source,
                stream: stream
            };
            if (e instanceof $iLUMi.InputMismatchException) {
                let expectedTokens = e.expectedTokens;
                if (expectedTokens === undefined) throw new Error("Expected the exception to provide expected tokens");
                let expectedTokenType = $2DVsz.Token.INVALID_TYPE;
                if (!expectedTokens.isNil) // get any element
                expectedTokenType = expectedTokens.minElement;
                let errToken = this.tokenFactory.create(sourcePair, expectedTokenType, tok.text, $2DVsz.Token.DEFAULT_CHANNEL, -1, -1, tok.line, tok.charPositionInLine);
                this._ctx.addErrorNode(this.createErrorNode(this._ctx, errToken));
            } else {
                let source = tok.tokenSource;
                let errToken = this.tokenFactory.create(sourcePair, $2DVsz.Token.INVALID_TYPE, tok.text, $2DVsz.Token.DEFAULT_CHANNEL, -1, -1, tok.line, tok.charPositionInLine);
                this._ctx.addErrorNode(this.createErrorNode(this._ctx, errToken));
            }
        }
    }
    recoverInline() {
        return this._errHandler.recoverInline(this);
    }
    /** Return the root of the parse, which can be useful if the parser
     *  bails out. You still can access the top node. Note that,
     *  because of the way left recursive rules add children, it's possible
     *  that the root will not have any children if the start rule immediately
     *  called and left recursive rule that fails.
     *
     * @since 4.5.1
     */ get rootContext() {
        return this._rootContext;
    }
};
$a16b634f90dd81f4$var$__decorate([
    $d6D31.NotNull
], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "_vocabulary", void 0);
$a16b634f90dd81f4$var$__decorate([
    $d6D31.Override
], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "reset", null);
$a16b634f90dd81f4$var$__decorate([
    $d6D31.Override
], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "atn", null);
$a16b634f90dd81f4$var$__decorate([
    $d6D31.Override
], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "vocabulary", null);
$a16b634f90dd81f4$var$__decorate([
    $d6D31.Override
], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "ruleNames", null);
$a16b634f90dd81f4$var$__decorate([
    $d6D31.Override
], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "grammarFileName", null);
$a16b634f90dd81f4$var$__decorate([
    $d6D31.Override
], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "enterRecursionRule", null);
$a16b634f90dd81f4$var$ParserInterpreter = $a16b634f90dd81f4$var$__decorate([
    $a16b634f90dd81f4$var$__param(1, $d6D31.NotNull)
], $a16b634f90dd81f4$var$ParserInterpreter);
module.exports.ParserInterpreter = $a16b634f90dd81f4$var$ParserInterpreter;

});

parcelRegister("77rdV", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $52ee4de454858848$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleContextWithAltNum = void 0;

var $bcnvE = parcelRequire("bcnvE");

var $d6D31 = parcelRequire("d6D31");

var $6bmaO = parcelRequire("6bmaO");
/** A handy class for use with
 *
 *  options {contextSuperClass=org.antlr.v4.runtime.RuleContextWithAltNum;}
 *
 *  that provides a backing field / impl for the outer alternative number
 *  matched for an internal parse tree node.
 *
 *  I'm only putting into Java runtime as I'm certain I'm the only one that
 *  will really every use this.
 */ class $52ee4de454858848$var$RuleContextWithAltNum extends $6bmaO.ParserRuleContext {
    constructor(parent, invokingStateNumber){
        if (invokingStateNumber !== undefined) super(parent, invokingStateNumber);
        else super();
        this._altNumber = $bcnvE.ATN.INVALID_ALT_NUMBER;
    }
    get altNumber() {
        return this._altNumber;
    }
    // @Override
    set altNumber(altNum) {
        this._altNumber = altNum;
    }
}
$52ee4de454858848$var$__decorate([
    $d6D31.Override
], $52ee4de454858848$var$RuleContextWithAltNum.prototype, "altNumber", null);
module.exports.RuleContextWithAltNum = $52ee4de454858848$var$RuleContextWithAltNum;

});

parcelRegister("5IgvW", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleDependency = void 0;
/**
 * Declares a dependency upon a grammar rule, along with a set of zero or more dependent rules.
 *
 * Version numbers within a grammar should be assigned on a monotonically increasing basis to allow for accurate
 * tracking of dependent rules.
 *
 * @author Sam Harwell
 */ function $428ddf2e82bfc6fb$var$RuleDependency(dependency) {
    return (target, propertyKey, propertyDescriptor)=>{
    // intentionally empty
    };
}
module.exports.RuleDependency = $428ddf2e82bfc6fb$var$RuleDependency;

});

parcelRegister("1ivK9", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleVersion = void 0;
/**
 *
 * @author Sam Harwell
 */ function $0f201872a8ca959f$var$RuleVersion(version) {
    return (target, propertyKey, propertyDescriptor)=>{
    // intentionally empty
    };
}
module.exports.RuleVersion = $0f201872a8ca959f$var$RuleVersion;

});

parcelRegister("eftJA", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9rAj4", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("5jPdD", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("dIykH", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9fca043c2d5f0853$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RewriteOperation = module.exports.TokenStreamRewriter = void 0;

var $gcfUE = parcelRequire("gcfUE");

var $d6D31 = parcelRequire("d6D31");

var $2DVsz = parcelRequire("2DVsz");
/**
 * Useful for rewriting out a buffered input token stream after doing some
 * augmentation or other manipulations on it.
 *
 * You can insert stuff, replace, and delete chunks. Note that the operations
 * are done lazily--only if you convert the buffer to a {@link String} with
 * {@link TokenStream#getText()}. This is very efficient because you are not
 * moving data around all the time. As the buffer of tokens is converted to
 * strings, the {@link #getText()} method(s) scan the input token stream and
 * check to see if there is an operation at the current index. If so, the
 * operation is done and then normal {@link String} rendering continues on the
 * buffer. This is like having multiple Turing machine instruction streams
 * (programs) operating on a single input tape. :)
 *
 * This rewriter makes no modifications to the token stream. It does not ask the
 * stream to fill itself up nor does it advance the input cursor. The token
 * stream `TokenStream.index` will return the same value before and
 * after any {@link #getText()} call.
 *
 * The rewriter only works on tokens that you have in the buffer and ignores the
 * current input cursor. If you are buffering tokens on-demand, calling
 * {@link #getText()} halfway through the input will only do rewrites for those
 * tokens in the first half of the file.
 *
 * Since the operations are done lazily at {@link #getText}-time, operations do
 * not screw up the token index values. That is, an insert operation at token
 * index `i` does not change the index values for tokens
 * `i`+1..n-1.
 *
 * Because operations never actually alter the buffer, you may always get the
 * original token stream back without undoing anything. Since the instructions
 * are queued up, you can easily simulate transactions and roll back any changes
 * if there is an error just by removing instructions. For example,
 *
 * ```
 * CharStream input = new ANTLRFileStream("input");
 * TLexer lex = new TLexer(input);
 * CommonTokenStream tokens = new CommonTokenStream(lex);
 * T parser = new T(tokens);
 * TokenStreamRewriter rewriter = new TokenStreamRewriter(tokens);
 * parser.startRule();
 * ```
 *
 * Then in the rules, you can execute (assuming rewriter is visible):
 *
 * ```
 * Token t,u;
 * ...
 * rewriter.insertAfter(t, "text to put after t");}
 * rewriter.insertAfter(u, "text after u");}
 * System.out.println(rewriter.getText());
 * ```
 *
 * You can also have multiple "instruction streams" and get multiple rewrites
 * from a single pass over the input. Just name the instruction streams and use
 * that name again when printing the buffer. This could be useful for generating
 * a C file and also its header file--all from the same buffer:
 *
 * ```
 * rewriter.insertAfter("pass1", t, "text to put after t");}
 * rewriter.insertAfter("pass2", u, "text after u");}
 * System.out.println(rewriter.getText("pass1"));
 * System.out.println(rewriter.getText("pass2"));
 * ```
 *
 * If you don't use named rewrite streams, a "default" stream is used as the
 * first example shows.
 */ class $9fca043c2d5f0853$var$TokenStreamRewriter {
    constructor(tokens){
        this.tokens = tokens;
        this.programs = new Map();
        this.programs.set($9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME, []);
        this.lastRewriteTokenIndexes = new Map();
    }
    getTokenStream() {
        return this.tokens;
    }
    rollback(instructionIndex, programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let is = this.programs.get(programName);
        if (is != null) this.programs.set(programName, is.slice($9fca043c2d5f0853$var$TokenStreamRewriter.MIN_TOKEN_INDEX, instructionIndex));
    }
    deleteProgram(programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        this.rollback($9fca043c2d5f0853$var$TokenStreamRewriter.MIN_TOKEN_INDEX, programName);
    }
    insertAfter(tokenOrIndex, text, programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let index;
        if (typeof tokenOrIndex === "number") index = tokenOrIndex;
        else index = tokenOrIndex.tokenIndex;
        // to insert after, just insert before next index (even if past end)
        let rewrites = this.getProgram(programName);
        let op = new $9fca043c2d5f0853$var$InsertAfterOp(this.tokens, index, rewrites.length, text);
        rewrites.push(op);
    }
    insertBefore(tokenOrIndex, text, programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let index;
        if (typeof tokenOrIndex === "number") index = tokenOrIndex;
        else index = tokenOrIndex.tokenIndex;
        let rewrites = this.getProgram(programName);
        let op = new $9fca043c2d5f0853$var$InsertBeforeOp(this.tokens, index, rewrites.length, text);
        rewrites.push(op);
    }
    replaceSingle(index, text) {
        if (typeof index === "number") this.replace(index, index, text);
        else this.replace(index, index, text);
    }
    replace(from, to, text, programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        if (typeof from !== "number") from = from.tokenIndex;
        if (typeof to !== "number") to = to.tokenIndex;
        if (from > to || from < 0 || to < 0 || to >= this.tokens.size) throw new RangeError(`replace: range invalid: ${from}..${to}(size=${this.tokens.size})`);
        let rewrites = this.getProgram(programName);
        let op = new $9fca043c2d5f0853$var$ReplaceOp(this.tokens, from, to, rewrites.length, text);
        rewrites.push(op);
    }
    delete(from, to, programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        if (to === undefined) to = from;
        if (typeof from === "number") this.replace(from, to, "", programName);
        else this.replace(from, to, "", programName);
    }
    getLastRewriteTokenIndex(programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let I = this.lastRewriteTokenIndexes.get(programName);
        if (I == null) return -1;
        return I;
    }
    setLastRewriteTokenIndex(programName, i) {
        this.lastRewriteTokenIndexes.set(programName, i);
    }
    getProgram(name) {
        let is = this.programs.get(name);
        if (is == null) is = this.initializeProgram(name);
        return is;
    }
    initializeProgram(name) {
        let is = [];
        this.programs.set(name, is);
        return is;
    }
    getText(intervalOrProgram, programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let interval;
        if (intervalOrProgram instanceof $gcfUE.Interval) interval = intervalOrProgram;
        else interval = $gcfUE.Interval.of(0, this.tokens.size - 1);
        if (typeof intervalOrProgram === "string") programName = intervalOrProgram;
        let rewrites = this.programs.get(programName);
        let start = interval.a;
        let stop = interval.b;
        // ensure start/end are in range
        if (stop > this.tokens.size - 1) stop = this.tokens.size - 1;
        if (start < 0) start = 0;
        if (rewrites == null || rewrites.length === 0) return this.tokens.getText(interval); // no instructions to execute
        let buf = [];
        // First, optimize instruction stream
        let indexToOp = this.reduceToSingleOperationPerIndex(rewrites);
        // Walk buffer, executing instructions and emitting tokens
        let i = start;
        while(i <= stop && i < this.tokens.size){
            let op = indexToOp.get(i);
            indexToOp.delete(i); // remove so any left have index size-1
            let t = this.tokens.get(i);
            if (op == null) {
                // no operation at that index, just dump token
                if (t.type !== $2DVsz.Token.EOF) buf.push(String(t.text));
                i++; // move to next token
            } else i = op.execute(buf); // execute operation and skip
        }
        // include stuff after end if it's last index in buffer
        // So, if they did an insertAfter(lastValidIndex, "foo"), include
        // foo if end==lastValidIndex.
        if (stop === this.tokens.size - 1) {
            // Scan any remaining operations after last token
            // should be included (they will be inserts).
            for (let op of indexToOp.values())if (op.index >= this.tokens.size - 1) buf.push(op.text.toString());
        }
        return buf.join("");
    }
    /** We need to combine operations and report invalid operations (like
     *  overlapping replaces that are not completed nested). Inserts to
     *  same index need to be combined etc...  Here are the cases:
     *
     *  I.i.u I.j.v								leave alone, nonoverlapping
     *  I.i.u I.i.v								combine: Iivu
     *
     *  R.i-j.u R.x-y.v	| i-j in x-y			delete first R
     *  R.i-j.u R.i-j.v							delete first R
     *  R.i-j.u R.x-y.v	| x-y in i-j			ERROR
     *  R.i-j.u R.x-y.v	| boundaries overlap	ERROR
     *
     *  Delete special case of replace (text==undefined):
     *  D.i-j.u D.x-y.v	| boundaries overlap	combine to max(min)..max(right)
     *
     *  I.i.u R.x-y.v | i in (x+1)-y			delete I (since insert before
     * 											we're not deleting i)
     *  I.i.u R.x-y.v | i not in (x+1)-y		leave alone, nonoverlapping
     *  R.x-y.v I.i.u | i in x-y				ERROR
     *  R.x-y.v I.x.u 							R.x-y.uv (combine, delete I)
     *  R.x-y.v I.i.u | i not in x-y			leave alone, nonoverlapping
     *
     *  I.i.u = insert u before op @ index i
     *  R.x-y.u = replace x-y indexed tokens with u
     *
     *  First we need to examine replaces. For any replace op:
     *
     * 		1. wipe out any insertions before op within that range.
     * 		2. Drop any replace op before that is contained completely within
     * 	 that range.
     * 		3. Throw exception upon boundary overlap with any previous replace.
     *
     *  Then we can deal with inserts:
     *
     * 		1. for any inserts to same index, combine even if not adjacent.
     * 		2. for any prior replace with same left boundary, combine this
     * 	 insert with replace and delete this replace.
     * 		3. throw exception if index in same range as previous replace
     *
     *  Don't actually delete; make op undefined in list. Easier to walk list.
     *  Later we can throw as we add to index &rarr; op map.
     *
     *  Note that I.2 R.2-2 will wipe out I.2 even though, technically, the
     *  inserted stuff would be before the replace range. But, if you
     *  add tokens in front of a method body '{' and then delete the method
     *  body, I think the stuff before the '{' you added should disappear too.
     *
     *  Return a map from token index to operation.
     */ reduceToSingleOperationPerIndex(rewrites) {
        // console.log(`rewrites=[${Utils.join(rewrites, ", ")}]`);
        // WALK REPLACES
        for(let i = 0; i < rewrites.length; i++){
            let op = rewrites[i];
            if (op == null) continue;
            if (!(op instanceof $9fca043c2d5f0853$var$ReplaceOp)) continue;
            let rop = op;
            // Wipe prior inserts within range
            let inserts = this.getKindOfOps(rewrites, $9fca043c2d5f0853$var$InsertBeforeOp, i);
            for (let iop of inserts){
                if (iop.index === rop.index) {
                    // E.g., insert before 2, delete 2..2; update replace
                    // text to include insert before, kill insert
                    rewrites[iop.instructionIndex] = undefined;
                    rop.text = iop.text.toString() + (rop.text != null ? rop.text.toString() : "");
                } else if (iop.index > rop.index && iop.index <= rop.lastIndex) // delete insert as it's a no-op.
                rewrites[iop.instructionIndex] = undefined;
            }
            // Drop any prior replaces contained within
            let prevReplaces = this.getKindOfOps(rewrites, $9fca043c2d5f0853$var$ReplaceOp, i);
            for (let prevRop of prevReplaces){
                if (prevRop.index >= rop.index && prevRop.lastIndex <= rop.lastIndex) {
                    // delete replace as it's a no-op.
                    rewrites[prevRop.instructionIndex] = undefined;
                    continue;
                }
                // throw exception unless disjoint or identical
                let disjoint = prevRop.lastIndex < rop.index || prevRop.index > rop.lastIndex;
                // Delete special case of replace (text==null):
                // D.i-j.u D.x-y.v	| boundaries overlap	combine to max(min)..max(right)
                if (prevRop.text == null && rop.text == null && !disjoint) {
                    // console.log(`overlapping deletes: ${prevRop}, ${rop}`);
                    rewrites[prevRop.instructionIndex] = undefined; // kill first delete
                    rop.index = Math.min(prevRop.index, rop.index);
                    rop.lastIndex = Math.max(prevRop.lastIndex, rop.lastIndex);
                // console.log(`new rop ${rop}`);
                } else if (!disjoint) throw new Error(`replace op boundaries of ${rop} overlap with previous ${prevRop}`);
            }
        }
        // WALK INSERTS
        for(let i = 0; i < rewrites.length; i++){
            let op = rewrites[i];
            if (op == null) continue;
            if (!(op instanceof $9fca043c2d5f0853$var$InsertBeforeOp)) continue;
            let iop = op;
            // combine current insert with prior if any at same index
            let prevInserts = this.getKindOfOps(rewrites, $9fca043c2d5f0853$var$InsertBeforeOp, i);
            for (let prevIop of prevInserts)if (prevIop.index === iop.index) {
                if (prevIop instanceof $9fca043c2d5f0853$var$InsertAfterOp) {
                    iop.text = this.catOpText(prevIop.text, iop.text);
                    rewrites[prevIop.instructionIndex] = undefined;
                } else if (prevIop instanceof $9fca043c2d5f0853$var$InsertBeforeOp) {
                    // convert to strings...we're in process of toString'ing
                    // whole token buffer so no lazy eval issue with any templates
                    iop.text = this.catOpText(iop.text, prevIop.text);
                    // delete redundant prior insert
                    rewrites[prevIop.instructionIndex] = undefined;
                }
            }
            // look for replaces where iop.index is in range; error
            let prevReplaces = this.getKindOfOps(rewrites, $9fca043c2d5f0853$var$ReplaceOp, i);
            for (let rop of prevReplaces){
                if (iop.index === rop.index) {
                    rop.text = this.catOpText(iop.text, rop.text);
                    rewrites[i] = undefined; // delete current insert
                    continue;
                }
                if (iop.index >= rop.index && iop.index <= rop.lastIndex) throw new Error(`insert op ${iop} within boundaries of previous ${rop}`);
            }
        }
        // console.log(`rewrites after=[${Utils.join(rewrites, ", ")}]`);
        let m = new Map();
        for (let op of rewrites){
            if (op == null) continue;
            if (m.get(op.index) != null) throw new Error("should only be one op per index");
            m.set(op.index, op);
        }
        // console.log(`index to op: ${m}`);
        return m;
    }
    catOpText(a, b) {
        let x = "";
        let y = "";
        if (a != null) x = a.toString();
        if (b != null) y = b.toString();
        return x + y;
    }
    /** Get all operations before an index of a particular kind */ getKindOfOps(rewrites, kind, before) {
        let ops = [];
        for(let i = 0; i < before && i < rewrites.length; i++){
            let op = rewrites[i];
            if (op == null) continue;
            if (op instanceof kind) ops.push(op);
        }
        return ops;
    }
}
module.exports.TokenStreamRewriter = $9fca043c2d5f0853$var$TokenStreamRewriter;
$9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME = "default";
$9fca043c2d5f0853$var$TokenStreamRewriter.PROGRAM_INIT_SIZE = 100;
$9fca043c2d5f0853$var$TokenStreamRewriter.MIN_TOKEN_INDEX = 0;
// Define the rewrite operation hierarchy
class $9fca043c2d5f0853$var$RewriteOperation {
    constructor(tokens, index, instructionIndex, text){
        this.tokens = tokens;
        this.instructionIndex = instructionIndex;
        this.index = index;
        this.text = text === undefined ? "" : text;
    }
    /** Execute the rewrite operation by possibly adding to the buffer.
     *  Return the index of the next token to operate on.
     */ execute(buf) {
        return this.index;
    }
    toString() {
        let opName = this.constructor.name;
        let $index = opName.indexOf("$");
        opName = opName.substring($index + 1, opName.length);
        return "<" + opName + "@" + this.tokens.get(this.index) + ":\"" + this.text + "\">";
    }
}
$9fca043c2d5f0853$var$__decorate([
    $d6D31.Override
], $9fca043c2d5f0853$var$RewriteOperation.prototype, "toString", null);
module.exports.RewriteOperation = $9fca043c2d5f0853$var$RewriteOperation;
class $9fca043c2d5f0853$var$InsertBeforeOp extends $9fca043c2d5f0853$var$RewriteOperation {
    constructor(tokens, index, instructionIndex, text){
        super(tokens, index, instructionIndex, text);
    }
    execute(buf) {
        buf.push(this.text.toString());
        if (this.tokens.get(this.index).type !== $2DVsz.Token.EOF) buf.push(String(this.tokens.get(this.index).text));
        return this.index + 1;
    }
}
$9fca043c2d5f0853$var$__decorate([
    $d6D31.Override
], $9fca043c2d5f0853$var$InsertBeforeOp.prototype, "execute", null);
/** Distinguish between insert after/before to do the "insert afters"
 *  first and then the "insert befores" at same index. Implementation
 *  of "insert after" is "insert before index+1".
 */ class $9fca043c2d5f0853$var$InsertAfterOp extends $9fca043c2d5f0853$var$InsertBeforeOp {
    constructor(tokens, index, instructionIndex, text){
        super(tokens, index + 1, instructionIndex, text); // insert after is insert before index+1
    }
}
/** I'm going to try replacing range from x..y with (y-x)+1 ReplaceOp
 *  instructions.
 */ class $9fca043c2d5f0853$var$ReplaceOp extends $9fca043c2d5f0853$var$RewriteOperation {
    constructor(tokens, from, to, instructionIndex, text){
        super(tokens, from, instructionIndex, text);
        this.lastIndex = to;
    }
    execute(buf) {
        if (this.text != null) buf.push(this.text.toString());
        return this.lastIndex + 1;
    }
    toString() {
        if (this.text == null) return "<DeleteOp@" + this.tokens.get(this.index) + ".." + this.tokens.get(this.lastIndex) + ">";
        return "<ReplaceOp@" + this.tokens.get(this.index) + ".." + this.tokens.get(this.lastIndex) + ":\"" + this.text + "\">";
    }
}
$9fca043c2d5f0853$var$__decorate([
    $d6D31.Override
], $9fca043c2d5f0853$var$ReplaceOp.prototype, "execute", null);
$9fca043c2d5f0853$var$__decorate([
    $d6D31.Override
], $9fca043c2d5f0853$var$ReplaceOp.prototype, "toString", null);

});

parcelRegister("1MVGg", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6UcB4", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("39War", function(module, exports) {

$parcel$export(module.exports, "JQLLexer", () => $801b4612eb9312ce$export$375c79404cc64c7f);
/* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// Generated from JQLLexer.g4 by ANTLR 4.7.3-SNAPSHOT

var $dvgsl = parcelRequire("dvgsl");

var $igNLf = parcelRequire("igNLf");

var $lQecE = parcelRequire("lQecE");

var $3n2FE = parcelRequire("3n2FE");

var $2IEP9 = parcelRequire("2IEP9");
class $801b4612eb9312ce$export$375c79404cc64c7f extends (0, $igNLf.Lexer) {
    static{
        this.LPAREN = 1;
    }
    static{
        this.RPAREN = 2;
    }
    static{
        this.COMMA = 3;
    }
    static{
        this.LBRACKET = 4;
    }
    static{
        this.RBRACKET = 5;
    }
    static{
        this.BANG = 6;
    }
    static{
        this.LT = 7;
    }
    static{
        this.GT = 8;
    }
    static{
        this.GTEQ = 9;
    }
    static{
        this.LTEQ = 10;
    }
    static{
        this.EQUALS = 11;
    }
    static{
        this.NOT_EQUALS = 12;
    }
    static{
        this.LIKE = 13;
    }
    static{
        this.NOT_LIKE = 14;
    }
    static{
        this.IN = 15;
    }
    static{
        this.IS = 16;
    }
    static{
        this.AND = 17;
    }
    static{
        this.OR = 18;
    }
    static{
        this.NOT = 19;
    }
    static{
        this.EMPTY = 20;
    }
    static{
        this.WAS = 21;
    }
    static{
        this.CHANGED = 22;
    }
    static{
        this.BEFORE = 23;
    }
    static{
        this.AFTER = 24;
    }
    static{
        this.FROM = 25;
    }
    static{
        this.TO = 26;
    }
    static{
        this.ON = 27;
    }
    static{
        this.DURING = 28;
    }
    static{
        this.ORDER = 29;
    }
    static{
        this.BY = 30;
    }
    static{
        this.ASC = 31;
    }
    static{
        this.DESC = 32;
    }
    static{
        this.POSNUMBER = 33;
    }
    static{
        this.NEGNUMBER = 34;
    }
    static{
        this.CUSTOMFIELD = 35;
    }
    static{
        this.RESERVED_WORD = 36;
    }
    static{
        this.STRING = 37;
    }
    static{
        this.MATCHWS = 38;
    }
    static{
        this.ERROR_RESERVED = 39;
    }
    static{
        this.ERRORCHAR = 40;
    }
    static{
        this.QUOTE_STRING = 41;
    }
    static{
        this.UNCLOSED_QUOTE_STRING = 42;
    }
    static{
        this.INVALID_QUOTE_STRING = 43;
    }
    static{
        this.SQUOTE_STRING = 44;
    }
    static{
        this.UNCLOSED_SQUOTE_STRING = 45;
    }
    static{
        this.INVALID_SQUOTE_STRING = 46;
    }
    static{
        this.QUOTED_STR = 1;
    }
    static{
        this.SQUOTED_STR = 2;
    }
    static{
        // tslint:disable:no-trailing-whitespace
        this.channelNames = [
            'DEFAULT_TOKEN_CHANNEL',
            'HIDDEN'
        ];
    }
    static{
        // tslint:disable:no-trailing-whitespace
        this.modeNames = [
            'DEFAULT_MODE',
            'QUOTED_STR',
            'SQUOTED_STR'
        ];
    }
    static{
        this.ruleNames = [
            'LPAREN',
            'RPAREN',
            'COMMA',
            'LBRACKET',
            'RBRACKET',
            'LQUOTE',
            'LSQUOTE',
            'BANG',
            'LT',
            'GT',
            'GTEQ',
            'LTEQ',
            'EQUALS',
            'NOT_EQUALS',
            'LIKE',
            'NOT_LIKE',
            'IN',
            'IS',
            'AND',
            'OR',
            'NOT',
            'EMPTY',
            'WAS',
            'CHANGED',
            'BEFORE',
            'AFTER',
            'FROM',
            'TO',
            'ON',
            'DURING',
            'ORDER',
            'BY',
            'ASC',
            'DESC',
            'POSNUMBER',
            'NEGNUMBER',
            'CUSTOMFIELD',
            'RESERVED_WORD',
            'STRING',
            'MATCHWS',
            'ERROR_RESERVED',
            'ERRORCHAR',
            'QUOTE_STRING',
            'QUOTED_CONTENT',
            'UNCLOSED_QUOTE_STRING',
            'INVALID_QUOTE_STRING',
            'SQUOTE_STRING',
            'SQUOTED_CONTENT',
            'UNCLOSED_SQUOTE_STRING',
            'INVALID_SQUOTE_STRING',
            'VALID_UNQUOTED_CHARS',
            'VALID_QUOTED_CHARS',
            'VALID_SQUOTED_CHARS',
            'RESERVED_CHARS',
            'QUOTE',
            'SQUOTE',
            'BSLASH',
            'NL',
            'CR',
            'SPACE',
            'AMPER',
            'AMPER_AMPER',
            'PIPE',
            'PIPE_PIPE',
            'ESCAPE',
            'NEWLINE',
            'HEXDIGIT',
            'WS',
            'MINUS',
            'DIGIT',
            'A',
            'B',
            'C',
            'D',
            'E',
            'F',
            'G',
            'H',
            'I',
            'J',
            'K',
            'L',
            'M',
            'N',
            'O',
            'P',
            'Q',
            'R',
            'S',
            'T',
            'U',
            'V',
            'W',
            'X',
            'Y',
            'Z'
        ];
    }
    static{
        this._LITERAL_NAMES = [
            undefined,
            "'('",
            "')'",
            "','",
            "'['",
            "']'",
            "'!'",
            "'<'",
            "'>'",
            "'>='",
            "'<='",
            "'='",
            "'!='",
            "'~'",
            "'!~'"
        ];
    }
    static{
        this._SYMBOLIC_NAMES = [
            undefined,
            'LPAREN',
            'RPAREN',
            'COMMA',
            'LBRACKET',
            'RBRACKET',
            'BANG',
            'LT',
            'GT',
            'GTEQ',
            'LTEQ',
            'EQUALS',
            'NOT_EQUALS',
            'LIKE',
            'NOT_LIKE',
            'IN',
            'IS',
            'AND',
            'OR',
            'NOT',
            'EMPTY',
            'WAS',
            'CHANGED',
            'BEFORE',
            'AFTER',
            'FROM',
            'TO',
            'ON',
            'DURING',
            'ORDER',
            'BY',
            'ASC',
            'DESC',
            'POSNUMBER',
            'NEGNUMBER',
            'CUSTOMFIELD',
            'RESERVED_WORD',
            'STRING',
            'MATCHWS',
            'ERROR_RESERVED',
            'ERRORCHAR',
            'QUOTE_STRING',
            'UNCLOSED_QUOTE_STRING',
            'INVALID_QUOTE_STRING',
            'SQUOTE_STRING',
            'UNCLOSED_SQUOTE_STRING',
            'INVALID_SQUOTE_STRING'
        ];
    }
    static{
        this.VOCABULARY = new (0, $3n2FE.VocabularyImpl)($801b4612eb9312ce$export$375c79404cc64c7f._LITERAL_NAMES, $801b4612eb9312ce$export$375c79404cc64c7f._SYMBOLIC_NAMES, []);
    }
    // @Override
    // @NotNull
    get vocabulary() {
        return $801b4612eb9312ce$export$375c79404cc64c7f.VOCABULARY;
    }
    // tslint:enable:no-trailing-whitespace
    constructor(input){
        super(input);
        this._interp = new (0, $lQecE.LexerATNSimulator)($801b4612eb9312ce$export$375c79404cc64c7f._ATN, this);
    }
    // @Override
    get grammarFileName() {
        return 'JQLLexer.g4';
    }
    // @Override
    get ruleNames() {
        return $801b4612eb9312ce$export$375c79404cc64c7f.ruleNames;
    }
    // @Override
    get serializedATN() {
        return $801b4612eb9312ce$export$375c79404cc64c7f._serializedATN;
    }
    // @Override
    get channelNames() {
        return $801b4612eb9312ce$export$375c79404cc64c7f.channelNames;
    }
    // @Override
    get modeNames() {
        return $801b4612eb9312ce$export$375c79404cc64c7f.modeNames;
    }
    static{
        this._serializedATNSegments = 3;
    }
    static{
        this._serializedATNSegment0 = "\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x020\u062E\b\x01\b\x01\b\x01\x04\x02	\x02\x04\x03	\x03\x04\x04	\x04\x04\x05	\x05\x04\x06	\x06\x04\x07	\x07\x04\b	\b\x04			\x04\n	\n\x04\v	\v\x04\f	\f\x04\r	\r\x04\x0e	\x0e\x04\x0f	\x0f\x04\x10	\x10\x04\x11	\x11\x04\x12	\x12\x04\x13	\x13\x04\x14	\x14\x04\x15	\x15\x04\x16	\x16\x04\x17	\x17\x04\x18	\x18\x04\x19	\x19\x04\x1a	\x1a\x04\x1b	\x1b\x04\x1c	\x1c\x04\x1d	\x1d\x04\x1e	\x1e\x04\x1f	\x1f\x04 	 \x04!	!\x04\"	\"\x04#	#\x04$	$\x04%	%\x04&	&\x04'	'\x04(	(\x04)	)\x04*	*\x04+	+\x04,	,\x04-	-\x04.	.\x04/	/\x040	0\x041	1\x042	2\x043	3\x044	4\x045	5\x046	6\x047	7\x048	8\x049	9\x04:	:\x04;	;\x04<	<\x04=	=\x04>	>\x04?	?\x04@	@\x04A	A\x04B	B\x04C	C\x04D	D\x04E	E\x04F	F\x04G	G\x04H	H\x04I	I\x04J	J\x04K	K\x04L	L\x04M	M\x04N	N\x04O	O\x04P	P\x04Q	Q\x04R	R\x04S	S\x04T	T\x04U	U\x04V	V\x04W	W\x04X	X\x04Y	Y\x04Z	Z\x04[	[\x04\\	\\\x04]	]\x04^	^\x04_	_\x04`	`\x04a	a\x03\x02\x03\x02\x03\x03\x03\x03\x03\x04\x03\x04\x03\x05\x03\x05\x03\x06\x03\x06\x03\x07\x03\x07\x03\x07\x03\x07\x03\x07\x03\b\x03\b\x03\b\x03\b\x03\b\x03	\x03	\x03\n\x03\n\x03\v\x03\v\x03\f\x03\f\x03\f\x03\r\x03\r\x03\r\x03\x0e\x03\x0e\x03\x0f\x03\x0f\x03\x0f\x03\x10\x03\x10\x03\x11\x03\x11\x03\x11\x03\x12\x03\x12\x03\x12\x03\x13\x03\x13\x03\x13\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x05\x14\xfc\n\x14\x03\x15\x03\x15\x03\x15\x03\x15\x03\x15\x05\x15\u0103\n\x15\x03\x16\x03\x16\x03\x16\x03\x16\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x05\x17\u0114\n\x17\x03\x18\x03\x18\x03\x18\x03\x18\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1c\x03\x1c\x03\x1c\x03\x1c\x03\x1c\x03\x1d\x03\x1d\x03\x1d\x03\x1e\x03\x1e\x03\x1e\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03 \x03 \x03 \x03 \x03 \x03 \x03!\x03!\x03!\x03\"\x03\"\x03\"\x03\"\x03#\x03#\x03#\x03#\x03#\x03$\x06$\u0154\n$\r$\x0e$\u0155\x03%\x03%\x06%\u015A\n%\r%\x0e%\u015B\x03&\x03&\x03&\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x05'\u0582\n'\x03(\x03(\x06(\u0586\n(\r(\x0e(\u0587\x03)\x06)\u058B\n)\r)\x0e)\u058C\x03)\x03)\x03*\x03*\x03+\x03+\x03,\x03,\x03,\x03,\x03-\x03-\x05-\u059B\n-\x03-\x03-\x03.\x03.\x03.\x03.\x03/\x03/\x03/\x03/\x030\x030\x030\x030\x031\x031\x051\u05AD\n1\x031\x031\x032\x032\x032\x032\x033\x033\x033\x033\x034\x034\x035\x035\x036\x036\x037\x037\x038\x038\x039\x039\x03:\x03:\x03;\x03;\x03<\x03<\x03=\x03=\x03>\x03>\x03?\x03?\x03?\x03@\x03@\x03A\x03A\x03A\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x05B\u05E3\nB\x03C\x03C\x05C\u05E7\nC\x03D\x03D\x03D\x03D\x03D\x03D\x03D\x05D\u05F0\nD\x03E\x03E\x03E\x05E\u05F5\nE\x03F\x03F\x03G\x03G\x03H\x03H\x03I\x03I\x03J\x03J\x03K\x03K\x03L\x03L\x03M\x03M\x03N\x03N\x03O\x03O\x03P\x03P\x03Q\x03Q\x03R\x03R\x03S\x03S\x03T\x03T\x03U\x03U\x03V\x03V\x03W\x03W\x03X\x03X\x03Y\x03Y\x03Z\x03Z\x03[\x03[\x03\\\x03\\\x03]\x03]\x03^\x03^\x03_\x03_\x03`\x03`\x03a\x03a\x02\x02\x02b\x05\x02\x03\x07\x02\x04	\x02\x05\v\x02\x06\r\x02\x07\x0f\x02\x02\x11\x02\x02\x13\x02\b\x15\x02	\x17\x02\n\x19\x02\v\x1b\x02\f\x1d\x02\r\x1f\x02\x0e!\x02\x0f#\x02\x10%\x02\x11'\x02\x12)\x02\x13+\x02\x14-\x02\x15/\x02\x161\x02\x173\x02\x185\x02\x197\x02\x1a9\x02\x1b;\x02\x1c=\x02\x1d?\x02\x1eA\x02\x1fC\x02 E\x02!G\x02\"I\x02#K\x02$M\x02%O\x02&Q\x02'S\x02(U\x02)W\x02*Y\x02+[\x02\x02]\x02,_\x02-a\x02.c\x02\x02e\x02/g\x020i\x02\x02k\x02\x02m\x02\x02o\x02\x02q\x02\x02s\x02\x02u\x02\x02w\x02\x02y\x02\x02{\x02\x02}\x02\x02\x7f\x02\x02\x81\x02\x02\x83\x02\x02\x85\x02\x02\x87\x02\x02\x89\x02\x02\x8b\x02\x02\x8d\x02\x02\x8f\x02\x02\x91\x02\x02\x93\x02\x02\x95\x02\x02\x97\x02\x02\x99\x02\x02\x9b\x02\x02\x9d\x02\x02\x9f\x02\x02\xa1\x02\x02\xa3\x02\x02\xa5\x02\x02\xa7\x02\x02\xa9\x02\x02\xab\x02\x02\xad\x02\x02\xaf\x02\x02\xb1\x02\x02\xb3\x02\x02\xb5\x02\x02\xb7\x02\x02\xb9\x02\x02\xbb\x02\x02\xbd\x02\x02\xbf\x02\x02\xc1\x02\x02\xc3\x02\x02\x05\x02\x03\x04\"	\x02\x02.11=B]`}\xa1\uFDD2\uFDF1\0\x01\n\x02\x02\v\r\x0e\x10!$$^^\x81\xa1\uFDD2\uFDF1\0\x01\n\x02\x02\v\r\x0e\x10!))^^\x81\xa1\uFDD2\uFDF1\0\x01\n\x02%',-11==AB``}}\x7f\x7f\x05\x02ppttvv\x03\x022;\x04\x02CCcc\x04\x02DDdd\x04\x02EEee\x04\x02FFff\x04\x02GGgg\x04\x02HHhh\x04\x02IIii\x04\x02JJjj\x04\x02KKkk\x04\x02LLll\x04\x02MMmm\x04\x02NNnn\x04\x02OOoo\x04\x02PPpp\x04\x02QQqq\x04\x02RRrr\x04\x02SSss\x04\x02TTtt\x04\x02UUuu\x04\x02VVvv\x04\x02WWww\x04\x02XXxx\x04\x02YYyy\x04\x02ZZzz\x04\x02[[{{\x04\x02\\\\||\x02\u06B5\x02\x05\x03\x02\x02\x02\x02\x07\x03\x02\x02\x02\x02	\x03\x02\x02\x02\x02\v\x03\x02\x02\x02\x02\r\x03\x02\x02\x02\x02\x0f\x03\x02\x02\x02\x02\x11\x03\x02\x02\x02\x02\x13\x03\x02\x02\x02\x02\x15\x03\x02\x02\x02\x02\x17\x03\x02\x02\x02\x02\x19\x03\x02\x02\x02\x02\x1b\x03\x02\x02\x02\x02\x1d\x03\x02\x02\x02\x02\x1f\x03\x02\x02\x02\x02!\x03\x02\x02\x02\x02#\x03\x02\x02\x02\x02%\x03\x02\x02\x02\x02'\x03\x02\x02\x02\x02)\x03\x02\x02\x02\x02+\x03\x02\x02\x02\x02-\x03\x02\x02\x02\x02/\x03\x02\x02\x02\x021\x03\x02\x02\x02\x023\x03\x02\x02\x02\x025\x03\x02\x02\x02\x027\x03\x02\x02\x02\x029\x03\x02\x02\x02\x02;\x03\x02\x02\x02\x02=\x03\x02\x02\x02\x02?\x03\x02\x02\x02\x02A\x03\x02\x02\x02\x02C\x03\x02\x02\x02\x02E\x03\x02\x02\x02\x02G\x03\x02\x02\x02\x02I\x03\x02\x02\x02\x02K\x03\x02\x02\x02\x02M\x03\x02\x02\x02\x02O\x03\x02\x02\x02\x02Q\x03\x02\x02\x02\x02S\x03\x02\x02\x02\x02U\x03\x02\x02\x02\x02W\x03\x02\x02\x02\x03Y\x03\x02\x02\x02\x03[\x03\x02\x02\x02\x03]\x03\x02\x02\x02\x03_\x03\x02\x02\x02\x04a\x03\x02\x02\x02\x04c\x03\x02\x02\x02\x04e\x03\x02\x02\x02\x04g\x03\x02\x02\x02\x05\xc5\x03\x02\x02\x02\x07\xc7\x03\x02\x02\x02	\xc9\x03\x02\x02\x02\v\xcb\x03\x02\x02\x02\r\xcd\x03\x02\x02\x02\x0f\xcf\x03\x02\x02\x02\x11\xd4\x03\x02\x02\x02\x13\xd9\x03\x02\x02\x02\x15\xdb\x03\x02\x02\x02\x17\xdd\x03\x02\x02\x02\x19\xdf\x03\x02\x02\x02\x1b\xe2\x03\x02\x02\x02\x1d\xe5\x03\x02\x02\x02\x1f\xe7\x03\x02\x02\x02!\xea\x03\x02\x02\x02#\xec\x03\x02\x02\x02%\xef\x03\x02\x02\x02'\xf2\x03\x02\x02\x02)\xfb\x03\x02\x02\x02+\u0102\x03\x02\x02\x02-\u0104\x03\x02\x02\x02/\u0113\x03\x02\x02\x021\u0115\x03\x02\x02\x023\u0119\x03\x02\x02\x025\u0121\x03\x02\x02\x027\u0128\x03\x02\x02\x029\u012E\x03\x02\x02\x02;\u0133\x03\x02\x02\x02=\u0136\x03\x02\x02\x02?\u0139\x03\x02\x02\x02A\u0140\x03\x02\x02\x02C\u0146\x03\x02\x02\x02E\u0149\x03\x02\x02\x02G\u014D\x03\x02\x02\x02I\u0153\x03\x02\x02\x02K\u0157\x03\x02\x02\x02M\u015D\x03\x02\x02\x02O\u0581\x03\x02\x02\x02Q\u0585\x03\x02\x02\x02S\u058A\x03\x02\x02\x02U\u0590\x03\x02\x02\x02W\u0592\x03\x02\x02\x02Y\u0594\x03\x02\x02\x02[\u059A\x03\x02\x02\x02]\u059E\x03\x02\x02\x02_\u05A2\x03\x02\x02\x02a\u05A6\x03\x02\x02\x02c\u05AC\x03\x02\x02\x02e\u05B0\x03\x02\x02\x02g\u05B4\x03\x02\x02\x02i\u05B8\x03\x02\x02\x02k\u05BA\x03\x02\x02\x02m\u05BC\x03\x02\x02\x02o\u05BE\x03\x02\x02\x02q\u05C0\x03\x02\x02\x02s\u05C2\x03\x02\x02\x02u\u05C4\x03\x02\x02\x02w\u05C6\x03\x02\x02\x02y\u05C8\x03\x02\x02\x02{\u05CA\x03\x02\x02\x02}\u05CC\x03\x02\x02\x02\x7f\u05CE\x03\x02\x02\x02\x81\u05D1\x03\x02\x02\x02\x83\u05D3\x03\x02\x02\x02\x85\u05D6\x03\x02\x02\x02\x87\u05E6\x03\x02\x02\x02\x89\u05EF\x03\x02\x02\x02\x8b\u05F4\x03\x02\x02\x02\x8d\u05F6\x03\x02\x02\x02\x8f\u05F8\x03\x02\x02\x02\x91\u05FA\x03\x02\x02\x02\x93\u05FC\x03\x02\x02\x02\x95\u05FE\x03\x02\x02\x02\x97\u0600\x03\x02\x02\x02\x99\u0602\x03\x02\x02\x02\x9b\u0604\x03\x02\x02\x02\x9d\u0606\x03\x02\x02\x02\x9f\u0608\x03\x02\x02\x02\xa1\u060A\x03\x02\x02\x02\xa3\u060C\x03\x02\x02\x02\xa5\u060E\x03\x02\x02\x02\xa7\u0610\x03\x02\x02\x02\xa9\u0612\x03\x02\x02\x02\xab\u0614\x03\x02\x02\x02\xad\u0616\x03\x02\x02\x02\xaf\u0618\x03\x02\x02\x02\xb1\u061A\x03\x02\x02\x02\xb3\u061C\x03\x02\x02\x02\xb5\u061E\x03\x02\x02\x02\xb7\u0620\x03\x02\x02\x02\xb9\u0622\x03\x02\x02\x02\xbb\u0624\x03\x02\x02\x02\xbd\u0626\x03\x02\x02\x02\xbf\u0628\x03\x02\x02\x02\xc1\u062A\x03\x02\x02\x02\xc3\u062C\x03\x02\x02\x02\xc5\xc6\x07*\x02\x02\xc6\x06\x03\x02\x02\x02\xc7\xc8\x07+\x02\x02\xc8\b\x03\x02\x02\x02\xc9\xca\x07.\x02\x02\xca\n\x03\x02\x02\x02\xcb\xcc\x07]\x02\x02\xcc\f\x03\x02\x02\x02\xcd\xce\x07_\x02\x02\xce\x0e\x03\x02\x02\x02\xcf\xd0\x05q8\x02\xd0\xd1\x03\x02\x02\x02\xd1\xd2\b\x07\x02\x02\xd2\xd3\b\x07\x03\x02\xd3\x10\x03\x02\x02\x02\xd4\xd5\x05s9\x02\xd5\xd6\x03\x02\x02\x02\xd6\xd7\b\b\x02\x02\xd7\xd8\b\b\x04\x02\xd8\x12\x03\x02\x02\x02\xd9\xda\x07#\x02\x02\xda\x14\x03\x02\x02\x02\xdb\xdc\x07>\x02\x02\xdc\x16\x03\x02\x02\x02\xdd\xde\x07@\x02\x02\xde\x18\x03\x02\x02\x02\xdf\xe0\x07@\x02\x02\xe0\xe1\x07?\x02\x02\xe1\x1a\x03\x02\x02\x02\xe2\xe3\x07>\x02\x02\xe3\xe4\x07?\x02\x02\xe4\x1c\x03\x02\x02\x02\xe5\xe6\x07?\x02\x02\xe6\x1e\x03\x02\x02\x02\xe7\xe8\x07#\x02\x02\xe8\xe9\x07?\x02\x02\xe9 \x03\x02\x02\x02\xea\xeb\x07\x80\x02\x02\xeb\"\x03\x02\x02\x02\xec\xed\x07#\x02\x02\xed\xee\x07\x80\x02\x02\xee$\x03\x02\x02\x02\xef\xf0\x05\xa1P\x02\xf0\xf1\x05\xabU\x02\xf1&\x03\x02\x02\x02\xf2\xf3\x05\xa1P\x02\xf3\xf4\x05\xb5Z\x02\xf4(\x03\x02\x02\x02\xf5\xf6\x05\x91H\x02\xf6\xf7\x05\xabU\x02\xf7\xf8\x05\x97K\x02\xf8\xfc\x03\x02\x02\x02\xf9\xfc\x05}>\x02\xfa\xfc\x05\x7f?\x02\xfb\xf5\x03\x02\x02\x02\xfb\xf9\x03\x02\x02\x02\xfb\xfa\x03\x02\x02\x02\xfc*\x03\x02\x02\x02\xfd\xfe\x05\xadV\x02\xfe\xff\x05\xb3Y\x02\xff\u0103\x03\x02\x02\x02\u0100\u0103\x05\x81@\x02\u0101\u0103\x05\x83A\x02\u0102\xfd\x03\x02\x02\x02\u0102\u0100\x03\x02\x02\x02\u0102\u0101\x03\x02\x02\x02\u0103";
    }
    static{
        this._serializedATNSegment1 = ",\x03\x02\x02\x02\u0104\u0105\x05\xabU\x02\u0105\u0106\x05\xadV\x02\u0106\u0107\x05\xb7[\x02\u0107.\x03\x02\x02\x02\u0108\u0109\x05\x99L\x02\u0109\u010A\x05\xa9T\x02\u010A\u010B\x05\xafW\x02\u010B\u010C\x05\xb7[\x02\u010C\u010D\x05\xc1`\x02\u010D\u0114\x03\x02\x02\x02\u010E\u010F\x05\xabU\x02\u010F\u0110\x05\xb9\\\x02\u0110\u0111\x05\xa7S\x02\u0111\u0112\x05\xa7S\x02\u0112\u0114\x03\x02\x02\x02\u0113\u0108\x03\x02\x02\x02\u0113\u010E\x03\x02\x02\x02\u01140\x03\x02\x02\x02\u0115\u0116\x05\xbd^\x02\u0116\u0117\x05\x91H\x02\u0117\u0118\x05\xb5Z\x02\u01182\x03\x02\x02\x02\u0119\u011A\x05\x95J\x02\u011A\u011B\x05\x9fO\x02\u011B\u011C\x05\x91H\x02\u011C\u011D\x05\xabU\x02\u011D\u011E\x05\x9dN\x02\u011E\u011F\x05\x99L\x02\u011F\u0120\x05\x97K\x02\u01204\x03\x02\x02\x02\u0121\u0122\x05\x93I\x02\u0122\u0123\x05\x99L\x02\u0123\u0124\x05\x9bM\x02\u0124\u0125\x05\xadV\x02\u0125\u0126\x05\xb3Y\x02\u0126\u0127\x05\x99L\x02\u01276\x03\x02\x02\x02\u0128\u0129\x05\x91H\x02\u0129\u012A\x05\x9bM\x02\u012A\u012B\x05\xb7[\x02\u012B\u012C\x05\x99L\x02\u012C\u012D\x05\xb3Y\x02\u012D8\x03\x02\x02\x02\u012E\u012F\x05\x9bM\x02\u012F\u0130\x05\xb3Y\x02\u0130\u0131\x05\xadV\x02\u0131\u0132\x05\xa9T\x02\u0132:\x03\x02\x02\x02\u0133\u0134\x05\xb7[\x02\u0134\u0135\x05\xadV\x02\u0135<\x03\x02\x02\x02\u0136\u0137\x05\xadV\x02\u0137\u0138\x05\xabU\x02\u0138>\x03\x02\x02\x02\u0139\u013A\x05\x97K\x02\u013A\u013B\x05\xb9\\\x02\u013B\u013C\x05\xb3Y\x02\u013C\u013D\x05\xa1P\x02\u013D\u013E\x05\xabU\x02\u013E\u013F\x05\x9dN\x02\u013F@\x03\x02\x02\x02\u0140\u0141\x05\xadV\x02\u0141\u0142\x05\xb3Y\x02\u0142\u0143\x05\x97K\x02\u0143\u0144\x05\x99L\x02\u0144\u0145\x05\xb3Y\x02\u0145B\x03\x02\x02\x02\u0146\u0147\x05\x93I\x02\u0147\u0148\x05\xc1`\x02\u0148D\x03\x02\x02\x02\u0149\u014A\x05\x91H\x02\u014A\u014B\x05\xb5Z\x02\u014B\u014C\x05\x95J\x02\u014CF\x03\x02\x02\x02\u014D\u014E\x05\x97K\x02\u014E\u014F\x05\x99L\x02\u014F\u0150\x05\xb5Z\x02\u0150\u0151\x05\x95J\x02\u0151H\x03\x02\x02\x02\u0152\u0154\x05\x8fG\x02\u0153\u0152\x03\x02\x02\x02\u0154\u0155\x03\x02\x02\x02\u0155\u0153\x03\x02\x02\x02\u0155\u0156\x03\x02\x02\x02\u0156J\x03\x02\x02\x02\u0157\u0159\x05\x8dF\x02\u0158\u015A\x05\x8fG\x02\u0159\u0158\x03\x02\x02\x02\u015A\u015B\x03\x02\x02\x02\u015B\u0159\x03\x02\x02\x02\u015B\u015C\x03\x02\x02\x02\u015CL\x03\x02\x02\x02\u015D\u015E\x05\x95J\x02\u015E\u015F\x05\x9bM\x02\u015FN\x03\x02\x02\x02\u0160\u0161\x05\x91H\x02\u0161\u0162\x05\x93I\x02\u0162\u0163\x05\xadV\x02\u0163\u0164\x05\xb3Y\x02\u0164\u0165\x05\xb7[\x02\u0165\u0582\x03\x02\x02\x02\u0166\u0167\x05\x91H\x02\u0167\u0168\x05\x95J\x02\u0168\u0169\x05\x95J\x02\u0169\u016A\x05\x99L\x02\u016A\u016B\x05\xb5Z\x02\u016B\u016C\x05\xb5Z\x02\u016C\u0582\x03\x02\x02\x02\u016D\u016E\x05\x91H\x02\u016E\u016F\x05\x97K\x02\u016F\u0170\x05\x97K\x02\u0170\u0582\x03\x02\x02\x02\u0171\u0172\x05\x91H\x02\u0172\u0173\x05\xa7S\x02\u0173\u0174\x05\xa1P\x02\u0174\u0175\x05\x91H\x02\u0175\u0176\x05\xb5Z\x02\u0176\u0582\x03\x02\x02\x02\u0177\u0178\x05\x91H\x02\u0178\u0179\x05\xa7S\x02\u0179\u017A\x05\xb7[\x02\u017A\u017B\x05\x99L\x02\u017B\u017C\x05\xb3Y\x02\u017C\u0582\x03\x02\x02\x02\u017D\u017E\x05\x91H\x02\u017E\u017F\x05\xabU\x02\u017F\u0180\x05\xc1`\x02\u0180\u0582\x03\x02\x02\x02\u0181\u0182\x05\x91H\x02\u0182\u0183\x05\xb5Z\x02\u0183\u0582\x03\x02\x02\x02\u0184\u0185\x05\x91H\x02\u0185\u0186\x05\xb9\\\x02\u0186\u0187\x05\x97K\x02\u0187\u0188\x05\xa1P\x02\u0188\u0189\x05\xb7[\x02\u0189\u0582\x03\x02\x02\x02\u018A\u018B\x05\x91H\x02\u018B\u018C\x05\xbb]\x02\u018C\u018D\x05\x9dN\x02\u018D\u0582\x03\x02\x02\x02\u018E\u018F\x05\x93I\x02\u018F\u0190\x05\x99L\x02\u0190\u0191\x05\x9dN\x02\u0191\u0192\x05\xa1P\x02\u0192\u0193\x05\xabU\x02\u0193\u0582\x03\x02\x02\x02\u0194\u0195\x05\x93I\x02\u0195\u0196\x05\x99L\x02\u0196\u0197\x05\xb7[\x02\u0197\u0198\x05\xbd^\x02\u0198\u0199\x05\x99L\x02\u0199\u019A\x05\x99L\x02\u019A\u019B\x05\xabU\x02\u019B\u0582\x03\x02\x02\x02\u019C\u019D\x05\x93I\x02\u019D\u019E\x05\xadV\x02\u019E\u019F\x05\xadV\x02\u019F\u01A0\x05\xa7S\x02\u01A0\u01A1\x05\x99L\x02\u01A1\u01A2\x05\x91H\x02\u01A2\u01A3\x05\xabU\x02\u01A3\u0582\x03\x02\x02\x02\u01A4\u01A5\x05\x93I\x02\u01A5\u01A6\x05\xb3Y\x02\u01A6\u01A7\x05\x99L\x02\u01A7\u01A8\x05\x91H\x02\u01A8\u01A9\x05\xa5R\x02\u01A9\u0582\x03\x02\x02\x02\u01AA\u01AB\x05\x93I\x02\u01AB\u01AC\x05\xc1`\x02\u01AC\u01AD\x05\xb7[\x02\u01AD\u01AE\x05\x99L\x02\u01AE\u0582\x03\x02\x02\x02\u01AF\u01B0\x05\x95J\x02\u01B0\u01B1\x05\x91H\x02\u01B1\u01B2\x05\xb7[\x02\u01B2\u01B3\x05\x95J\x02\u01B3\u01B4\x05\x9fO\x02\u01B4\u0582\x03\x02\x02\x02\u01B5\u01B6\x05\x95J\x02\u01B6\u01B7\x05\x9fO\x02\u01B7\u01B8\x05\x91H\x02\u01B8\u01B9\x05\xb3Y\x02\u01B9\u0582\x03\x02\x02\x02\u01BA\u01BB\x05\x95J\x02\u01BB\u01BC\x05\x9fO\x02\u01BC\u01BD\x05\x91H\x02\u01BD\u01BE\x05\xb3Y\x02\u01BE\u01BF\x05\x91H\x02\u01BF\u01C0\x05\x95J\x02\u01C0\u01C1\x05\xb7[\x02\u01C1\u01C2\x05\x99L\x02\u01C2\u01C3\x05\xb3Y\x02\u01C3\u0582\x03\x02\x02\x02\u01C4\u01C5\x05\x95J\x02\u01C5\u01C6\x05\x9fO\x02\u01C6\u01C7\x05\x99L\x02\u01C7\u01C8\x05\x95J\x02\u01C8\u01C9\x05\xa5R\x02\u01C9\u0582\x03\x02\x02\x02\u01CA\u01CB\x05\x95J\x02\u01CB\u01CC\x05\x9fO\x02\u01CC\u01CD\x05\x99L\x02\u01CD\u01CE\x05\x95J\x02\u01CE\u01CF\x05\xa5R\x02\u01CF\u01D0\x05\xafW\x02\u01D0\u01D1\x05\xadV\x02\u01D1\u01D2\x05\xa1P\x02\u01D2\u01D3\x05\xabU\x02\u01D3\u01D4\x05\xb7[\x02\u01D4\u0582\x03\x02\x02\x02\u01D5\u01D6\x05\x95J\x02\u01D6\u01D7\x05\xadV\x02\u01D7\u01D8\x05\xa7S\x02\u01D8\u01D9\x05\xa7S\x02\u01D9\u01DA\x05\x91H\x02\u01DA\u01DB\x05\xb7[\x02\u01DB\u01DC\x05\x99L\x02\u01DC\u0582\x03\x02\x02\x02\u01DD\u01DE\x05\x95J\x02\u01DE\u01DF\x05\xadV\x02\u01DF\u01E0\x05\xa7S\x02\u01E0\u01E1\x05\xa7S\x02\u01E1\u01E2\x05\x91H\x02\u01E2\u01E3\x05\xb7[\x02\u01E3\u01E4\x05\xa1P\x02\u01E4\u01E5\x05\xadV\x02\u01E5\u01E6\x05\xabU\x02\u01E6\u0582\x03\x02\x02\x02\u01E7\u01E8\x05\x95J\x02\u01E8\u01E9\x05\xadV\x02\u01E9\u01EA\x05\xa7S\x02\u01EA\u01EB\x05\xb9\\\x02\u01EB\u01EC\x05\xa9T\x02\u01EC\u01ED\x05\xabU\x02\u01ED\u0582\x03\x02\x02\x02\u01EE\u01EF\x05\x95J\x02\u01EF\u01F0\x05\xadV\x02\u01F0\u01F1\x05\xa9T\x02\u01F1\u01F2\x05\xa9T\x02\u01F2\u01F3\x05\xa1P\x02\u01F3\u01F4\x05\xb7[\x02\u01F4\u0582\x03\x02\x02\x02\u01F5\u01F6\x05\x95J\x02\u01F6\u01F7\x05\xadV\x02\u01F7\u01F8\x05\xabU\x02\u01F8\u01F9\x05\xabU\x02\u01F9\u01FA\x05\x99L\x02\u01FA\u01FB\x05\x95J\x02\u01FB\u01FC\x05\xb7[\x02\u01FC\u0582\x03\x02\x02\x02\u01FD\u01FE\x05\x95J\x02\u01FE\u01FF\x05\xadV\x02\u01FF\u0200\x05\xabU\x02\u0200\u0201\x05\xb7[\x02\u0201\u0202\x05\xa1P\x02\u0202\u0203\x05\xabU\x02\u0203\u0204\x05\xb9\\\x02\u0204\u0205\x05\x99L\x02\u0205\u0582\x03\x02\x02\x02\u0206\u0207\x05\x95J\x02\u0207\u0208\x05\xadV\x02\u0208\u0209\x05\xb9\\\x02\u0209\u020A\x05\xabU\x02\u020A\u020B\x05\xb7[\x02\u020B\u0582\x03\x02\x02\x02\u020C\u020D\x05\x95J\x02\u020D\u020E\x05\xb3Y\x02\u020E\u020F\x05\x99L\x02\u020F\u0210\x05\x91H\x02\u0210\u0211\x05\xb7[\x02\u0211\u0212\x05\x99L\x02\u0212\u0582\x03\x02\x02\x02\u0213\u0214\x05\x95J\x02\u0214\u0215\x05\xb9\\\x02\u0215\u0216\x05\xb3Y\x02\u0216\u0217\x05\xb3Y\x02\u0217\u0218\x05\x99L\x02\u0218\u0219\x05\xabU\x02\u0219\u021A\x05\xb7[\x02\u021A\u0582\x03\x02\x02\x02\u021B\u021C\x05\x97K\x02\u021C\u021D\x05\x91H\x02\u021D\u021E\x05\xb7[\x02\u021E\u021F\x05\x99L\x02\u021F\u0582\x03\x02\x02\x02\u0220\u0221\x05\x97K\x02\u0221\u0222\x05\x99L\x02\u0222\u0223\x05\x95J\x02\u0223\u0224\x05\xa1P\x02\u0224\u0225\x05\xa9T\x02\u0225\u0226\x05\x91H\x02\u0226\u0227\x05\xa7S\x02\u0227\u0582\x03\x02\x02\x02\u0228\u0229\x05\x97K\x02\u0229\u022A\x05\x99L\x02\u022A\u022B\x05\x95J\x02\u022B\u022C\x05\xa7S\x02\u022C\u022D\x05\x91H\x02\u022D\u022E\x05\xb3Y\x02\u022E\u022F\x05\x99L\x02\u022F\u0582\x03\x02\x02\x02\u0230\u0231\x05\x97K\x02\u0231\u0232\x05\x99L\x02\u0232\u0233\x05\x95J\x02\u0233\u0234\x05\xb3Y\x02\u0234\u0235\x05\x99L\x02\u0235\u0236\x05\xa9T\x02\u0236\u0237\x05\x99L\x02\u0237\u0238\x05\xabU\x02\u0238\u0239\x05\xb7[\x02\u0239\u0582\x03\x02\x02\x02\u023A\u023B\x05\x97K\x02\u023B\u023C\x05\x99L\x02\u023C\u023D\x05\x9bM\x02\u023D\u023E\x05\x91H\x02\u023E\u023F\x05\xb9\\\x02\u023F\u0240\x05\xa7S\x02\u0240\u0241\x05\xb7[\x02\u0241\u0582\x03\x02\x02\x02\u0242\u0243\x05\x97K\x02\u0243\u0244\x05\x99L\x02\u0244\u0245\x05\x9bM\x02\u0245\u0246\x05\x91H\x02\u0246\u0247\x05\xb9\\\x02\u0247\u0248\x05\xa7S\x02\u0248\u0249\x05\xb7[\x02\u0249\u024A\x05\xb5Z\x02\u024A\u0582\x03\x02\x02\x02\u024B\u024C\x05\x97K\x02\u024C\u024D\x05\x99L\x02\u024D\u024E\x05\x9bM\x02\u024E\u024F\x05\xa1P\x02\u024F\u0250\x05\xabU\x02\u0250\u0251\x05\x99L\x02\u0251\u0582\x03\x02\x02\x02\u0252\u0253\x05\x97K\x02\u0253\u0254\x05\x99L\x02\u0254\u0255\x05\xa7S\x02\u0255\u0256\x05\x99L\x02\u0256\u0257\x05\xb7[\x02\u0257\u0258\x05\x99L\x02\u0258\u0582\x03\x02\x02\x02\u0259\u025A\x05\x97K\x02\u025A\u025B\x05\x99L\x02\u025B\u025C\x05\xa7S\x02\u025C\u025D\x05\xa1P\x02\u025D\u025E\x05\xa9T\x02\u025E\u025F\x05\xa1P\x02\u025F\u0260\x05\xb7[\x02\u0260\u0261\x05\x99L\x02\u0261\u0262\x05\xb3Y\x02\u0262\u0582\x03\x02\x02\x02\u0263\u0264\x05\x97K\x02\u0264\u0265\x05\xa1P\x02\u0265\u0266\x05\x9bM\x02\u0266\u0267\x05\x9bM\x02\u0267\u0268\x05\x99L\x02\u0268\u0269\x05\xb3Y\x02\u0269\u026A\x05\x99L\x02\u026A\u026B\x05\xabU\x02\u026B\u026C\x05\x95J\x02\u026C\u026D\x05\x99L\x02\u026D\u0582\x03\x02\x02\x02\u026E\u026F\x05\x97K\x02\u026F\u0270\x05\xa1P\x02\u0270\u0271\x05\xb5Z\x02\u0271\u0272\x05\xb7[\x02\u0272\u0273\x05\xa1P\x02\u0273\u0274\x05\xabU\x02\u0274\u0275\x05\x95J\x02\u0275\u0276\x05\xb7[\x02\u0276\u0582\x03\x02\x02\x02\u0277\u0278\x05\x97K\x02\u0278\u0279\x05\xa1P\x02\u0279\u027A\x05\xbb]\x02\u027A\u027B\x05\xa1P\x02\u027B\u027C\x05\x97K\x02\u027C\u027D\x05\x99L\x02\u027D\u0582\x03\x02\x02\x02\u027E\u027F\x05\x97K\x02\u027F\u0280\x05\xadV\x02\u0280\u0582\x03\x02\x02\x02\u0281\u0282\x05\x97K\x02\u0282\u0283\x05\xadV\x02\u0283\u0284\x05\xb9\\\x02\u0284\u0285\x05\x93I\x02\u0285\u0286\x05\xa7S\x02\u0286\u0287\x05\x99L\x02\u0287\u0582\x03\x02\x02\x02\u0288\u0289\x05\x97K\x02\u0289\u028A\x05\xb3Y\x02\u028A\u028B\x05\xadV\x02\u028B\u028C\x05\xafW\x02\u028C\u0582\x03\x02\x02\x02\u028D\u028E\x05\x99L\x02\u028E\u028F\x05\xa7S\x02\u028F\u0290\x05\xb5Z\x02\u0290\u0291\x05\x99L\x02\u0291\u0582\x03\x02\x02\x02\u0292\u0293\x05\x99L\x02\u0293\u0294\x05\xabU\x02\u0294\u0295\x05\x95J\x02\u0295\u0296\x05\xadV\x02\u0296\u0297\x05\x97K\x02\u0297\u0298\x05\xa1P\x02\u0298\u0299\x05\xabU\x02\u0299\u029A\x05\x9dN\x02\u029A\u0582\x03\x02\x02\x02\u029B\u029C\x05\x99L\x02\u029C\u029D\x05\xabU\x02\u029D\u029E\x05\x97K\x02\u029E\u0582\x03\x02\x02\x02\u029F\u02A0\x05\x99L\x02\u02A0\u02A1\x05\xb1X\x02\u02A1\u02A2\x05\xb9\\\x02\u02A2\u02A3\x05\x91H\x02\u02A3\u02A4\x05\xa7S\x02\u02A4\u02A5\x05\xb5Z\x02\u02A5\u0582\x03\x02\x02\x02\u02A6\u02A7\x05\x99L\x02\u02A7\u02A8\x05\xb5Z\x02\u02A8\u02A9\x05\x95J\x02\u02A9\u02AA\x05\x91H\x02\u02AA\u02AB\x05\xafW\x02\u02AB\u02AC\x05\x99L\x02\u02AC\u0582\x03\x02\x02\x02\u02AD\u02AE\x05\x99L\x02\u02AE\u02AF\x05\xbf_\x02\u02AF\u02B0\x05\x95J\x02\u02B0\u02B1\x05\xa7S\x02\u02B1\u02B2\x05\xb9\\\x02\u02B2\u02B3\x05\xb5Z\x02\u02B3\u02B4\x05\xa1P\x02\u02B4\u02B5\x05\xbb]\x02\u02B5\u02B6\x05\x99L\x02\u02B6\u0582\x03\x02\x02\x02\u02B7\u02B8\x05\x99L\x02\u02B8\u02B9\x05\xbf_\x02\u02B9\u02BA\x05\x99L\x02\u02BA\u02BB\x05\x95J\x02\u02BB\u0582\x03\x02\x02\x02\u02BC\u02BD\x05\x99L\x02\u02BD\u02BE\x05\xbf_\x02\u02BE\u02BF\x05\x99L\x02\u02BF\u02C0\x05\x95J\x02\u02C0\u02C1\x05\xb9\\\x02\u02C1\u02C2\x05\xb7[\x02\u02C2\u02C3\x05\x99L\x02\u02C3\u0582\x03\x02\x02\x02\u02C4\u02C5\x05\x99L\x02\u02C5\u02C6\x05\xbf_\x02\u02C6\u02C7\x05\xa1P\x02\u02C7\u02C8\x05\xb5Z\x02\u02C8\u02C9\x05\xb7[\x02\u02C9\u02CA\x05\xb5Z\x02\u02CA\u0582\x03\x02\x02\x02\u02CB\u02CC\x05\x99L\x02\u02CC\u02CD\x05\xbf_\x02\u02CD\u02CE\x05\xafW\x02\u02CE\u02CF\x05\xa7S\x02\u02CF\u02D0\x05\x91H\x02\u02D0\u02D1\x05\xa1P\x02\u02D1\u02D2\x05\xabU\x02\u02D2\u0582\x03\x02\x02\x02\u02D3\u02D4\x05\x9bM\x02\u02D4\u02D5\x05\x91H\x02\u02D5\u02D6\x05\xa7S\x02\u02D6\u02D7\x05\xb5Z\x02\u02D7\u02D8\x05\x99L\x02\u02D8\u0582\x03\x02\x02\x02\u02D9\u02DA\x05\x9bM\x02\u02DA\u02DB\x05\x99L\x02\u02DB\u02DC\x05\xb7[\x02\u02DC\u02DD\x05\x95J\x02\u02DD\u02DE\x05\x9fO\x02\u02DE\u0582\x03\x02\x02\x02\u02DF\u02E0\x05\x9bM\x02\u02E0\u02E1\x05\xa1P\x02\u02E1\u02E2\x05\xa7S\x02\u02E2\u02E3\x05\x99L\x02\u02E3\u0582\x03\x02\x02\x02\u02E4\u02E5\x05\x9bM\x02\u02E5\u02E6\x05\xa1P\x02\u02E6\u02E7\x05\x99L\x02\u02E7\u02E8\x05\xa7S\x02\u02E8\u02E9\x05\x97K\x02\u02E9\u0582\x03\x02\x02\x02\u02EA\u02EB\x05\x9bM\x02\u02EB\u02EC\x05\xa1P\x02\u02EC\u02ED\x05\xb3Y\x02\u02ED\u02EE\x05\xb5Z\x02\u02EE\u02EF\x05\xb7[\x02\u02EF\u0582\x03\x02\x02\x02\u02F0\u02F1\x05\x9bM\x02\u02F1\u02F2\x05\xa7S\x02\u02F2\u02F3\x05\xadV\x02\u02F3\u02F4\x05\x91H\x02\u02F4\u02F5\x05\xb7[\x02\u02F5\u0582\x03\x02\x02\x02\u02F6\u02F7\x05\x9bM\x02\u02F7\u02F8\x05\xadV\x02\u02F8\u02F9\x05\xb3Y\x02\u02F9\u0582\x03\x02\x02\x02\u02FA\u02FB\x05\x9bM\x02\u02FB\u02FC\x05\xb9\\\x02\u02FC\u02FD\x05\xabU\x02\u02FD\u02FE\x05\x95J\x02\u02FE\u02FF\x05\xb7[\x02\u02FF\u0300\x05\xa1P\x02\u0300\u0301\x05\xadV\x02\u0301\u0302\x05\xabU\x02\u0302\u0582\x03\x02\x02\x02\u0303\u0304\x05\x9dN\x02\u0304\u0305\x05\xadV\x02\u0305\u0582\x03\x02\x02\x02\u0306\u0307\x05\x9dN\x02\u0307\u0308\x05\xadV\x02\u0308\u0309\x05\xb7[\x02\u0309\u030A\x05\xadV\x02\u030A\u0582\x03\x02\x02\x02\u030B\u030C\x05\x9dN\x02\u030C\u030D\x05\xb3Y\x02\u030D\u030E\x05\x91H\x02\u030E\u030F\x05\xabU\x02\u030F\u0310\x05\xb7[\x02\u0310\u0582\x03\x02\x02\x02\u0311\u0312\x05\x9dN\x02\u0312\u0313\x05\xb3Y\x02\u0313\u0314\x05\x99L\x02\u0314\u0315\x05\x91H\x02\u0315\u0316\x05\xb7[\x02\u0316\u0317\x05\x99L\x02\u0317\u0318\x05\xb3Y\x02\u0318\u0582\x03\x02\x02\x02\u0319\u031A\x05\x9dN\x02\u031A\u031B\x05\xb3Y\x02\u031B\u031C\x05\xadV\x02\u031C\u031D\x05\xb9\\\x02\u031D\u031E\x05\xafW\x02\u031E\u0582\x03\x02\x02\x02\u031F\u0320\x05\x9fO\x02\u0320\u0321\x05\x91H\x02\u0321\u0322\x05\xbb]\x02\u0322\u0323\x05\xa1P\x02\u0323\u0324\x05\xabU\x02\u0324\u0325\x05\x9dN\x02\u0325\u0582\x03\x02\x02\x02\u0326\u0327\x05\xa1P\x02\u0327\u0328\x05\x97K\x02\u0328\u0329\x05\x99L\x02\u0329\u032A\x05\xabU\x02\u032A\u032B\x05\xb7[\x02\u032B\u032C\x05\xa1P\x02\u032C\u032D\x05\x9bM\x02\u032D\u032E\x05\xa1P\x02\u032E\u032F\x05\x99L\x02\u032F\u0330\x05\x97K\x02\u0330\u0582\x03\x02\x02\x02\u0331\u0332\x05\xa1P\x02\u0332\u0333\x05\x9bM\x02\u0333\u0582\x03\x02\x02\x02\u0334\u0335\x05\xa1P\x02\u0335\u0336\x05\xa9T\x02\u0336\u0337\x05\xa9T\x02\u0337\u0338\x05\x99L\x02\u0338\u0339\x05\x97K\x02\u0339\u033A\x05\xa1P\x02\u033A\u033B\x05\x91H\x02\u033B\u033C\x05\xb7[\x02\u033C\u033D\x05\x99L\x02\u033D\u0582\x03\x02\x02\x02\u033E\u033F\x05\xa1P\x02\u033F\u0340\x05\xabU\x02\u0340\u0341\x05\x95J\x02\u0341\u0342\x05\xb3Y\x02\u0342\u0343\x05\x99L\x02\u0343\u0344\x05\xa9T\x02\u0344\u0345\x05\x99L\x02\u0345\u0346\x05\xabU\x02\u0346\u0347\x05\xb7[\x02\u0347\u0582\x03\x02\x02\x02\u0348\u0349\x05\xa1P\x02\u0349\u034A\x05\xabU\x02\u034A\u034B\x05\x97K\x02\u034B\u034C\x05\x99L\x02\u034C\u034D\x05\xbf_\x02\u034D\u0582\x03\x02\x02\x02\u034E\u034F\x05\xa1P\x02\u034F\u0350\x05\xabU\x02\u0350\u0351\x05\xa1P\x02\u0351\u0352\x05\xb7[\x02\u0352\u0353\x05\xa1P\x02\u0353\u0354\x05\x91H\x02\u0354\u0355\x05\xa7S\x02\u0355\u0582\x03\x02\x02\x02\u0356\u0357\x05\xa1P\x02\u0357\u0358\x05\xabU\x02\u0358\u0359\x05\xabU\x02\u0359\u035A\x05\x99L\x02\u035A\u035B\x05\xb3Y\x02\u035B\u0582\x03\x02\x02\x02\u035C\u035D\x05\xa1P\x02\u035D\u035E\x05\xabU\x02\u035E\u035F\x05\xadV\x02\u035F\u0360\x05\xb9\\\x02\u0360\u0361\x05\xb7[\x02\u0361\u0582\x03\x02\x02\x02\u0362\u0363\x05\xa1P\x02\u0363\u0364\x05\xabU\x02\u0364\u0365\x05\xafW\x02\u0365\u0366\x05\xb9\\\x02\u0366\u0367\x05\xb7[\x02\u0367\u0582\x03\x02\x02\x02\u0368\u0369\x05\xa1P\x02\u0369\u036A\x05\xabU\x02\u036A\u036B\x05\xb5Z\x02\u036B\u036C\x05\x99L\x02\u036C\u036D\x05\xb3Y\x02\u036D\u036E\x05\xb7[\x02\u036E\u0582\x03\x02\x02\x02\u036F\u0370\x05\xa1P\x02\u0370\u0371\x05\xabU\x02\u0371\u0372\x05\xb7[\x02\u0372\u0582\x03\x02\x02\x02\u0373\u0374\x05\xa1P\x02\u0374\u0375\x05\xabU\x02\u0375\u0376\x05\xb7[\x02\u0376\u0377\x05\x99L\x02\u0377\u0378\x05\x9dN\x02\u0378\u0379\x05\x99L\x02\u0379\u037A\x05\xb3Y\x02\u037A\u0582\x03\x02\x02\x02\u037B\u037C\x05\xa1P\x02\u037C\u037D\x05\xabU\x02\u037D\u037E\x05\xb7[\x02\u037E\u037F\x05\x99L\x02\u037F\u0380\x05\xb3Y\x02\u0380\u0381\x05\xb5Z\x02\u0381\u0382\x05\x99L\x02\u0382\u0383\x05\x95J\x02\u0383\u0384\x05\xb7[\x02\u0384\u0582\x03\x02\x02\x02\u0385\u0386\x05\xa1P\x02\u0386\u0387\x05\xabU\x02\u0387\u0388\x05\xb7[\x02\u0388\u0389\x05\x99L\x02\u0389\u038A\x05\xb3Y\x02\u038A\u038B\x05\xb5Z\x02\u038B\u038C\x05\x99L\x02\u038C\u038D\x05\x95J\x02\u038D\u038E\x05\xb7[\x02\u038E\u038F\x05\xa1P\x02\u038F\u0390\x05\xadV\x02\u0390\u0391\x05\xabU\x02\u0391\u0582\x03\x02\x02\x02\u0392\u0393\x05\xa1P\x02\u0393\u0394\x05\xabU\x02\u0394\u0395\x05\xb7[\x02\u0395\u0396\x05\xadV\x02\u0396\u0582\x03\x02\x02\x02\u0397\u0398\x05\xa1P\x02\u0398\u0399\x05\xb5Z\x02\u0399\u039A\x05\x99L\x02\u039A\u039B\x05\xa9T\x02\u039B\u039C\x05\xafW\x02\u039C\u039D\x05\xb7[\x02\u039D\u039E\x05\xc1`\x02\u039E\u0582\x03\x02\x02\x02\u039F\u03A0\x05\xa1P\x02\u03A0\u03A1\x05\xb5Z\x02\u03A1\u03A2\x05\xabU\x02\u03A2\u03A3\x05\xb9\\\x02\u03A3\u03A4\x05\xa7S\x02\u03A4\u03A5\x05\xa7S\x02\u03A5\u0582\x03\x02\x02\x02\u03A6\u03A7\x05\xa3Q\x02\u03A7\u03A8\x05\xadV\x02\u03A8\u03A9\x05\xa1P\x02\u03A9\u03AA\x05\xabU\x02\u03AA\u0582\x03\x02\x02\x02\u03AB\u03AC\x05\xa7S\x02\u03AC\u03AD\x05\x91H\x02\u03AD\u03AE\x05\xb5Z\x02\u03AE\u03AF\x05\xb7[\x02\u03AF\u0582\x03\x02\x02\x02\u03B0\u03B1\x05\xa7S\x02\u03B1\u03B2\x05\x99L\x02\u03B2\u03B3\x05\x9bM\x02\u03B3\u03B4\x05\xb7[\x02\u03B4\u0582\x03\x02\x02\x02\u03B5\u03B6\x05\xa7S\x02\u03B6\u03B7\x05\x99L\x02\u03B7\u03B8\x05\xb5Z\x02\u03B8\u03B9\x05\xb5Z\x02\u03B9\u0582\x03\x02\x02\x02\u03BA\u03BB\x05\xa7S\x02\u03BB\u03BC\x05\xa1P\x02\u03BC\u03BD\x05\xa5R\x02\u03BD\u03BE\x05\x99L\x02\u03BE\u0582\x03\x02\x02\x02\u03BF\u03C0\x05\xa7S\x02\u03C0\u03C1\x05\xa1P\x02\u03C1\u03C2\x05\xa9T\x02\u03C2\u03C3\x05\xa1P\x02\u03C3\u03C4\x05\xb7[\x02\u03C4\u0582\x03\x02\x02\x02\u03C5\u03C6\x05\xa7S\x02\u03C6\u03C7\x05\xadV\x02\u03C7\u03C8\x05\x95J\x02\u03C8\u03C9\x05\xa5R\x02\u03C9\u0582\x03\x02\x02\x02\u03CA\u03CB\x05\xa7S\x02\u03CB\u03CC\x05\xadV\x02\u03CC\u03CD\x05\xabU\x02\u03CD\u03CE\x05\x9dN\x02\u03CE\u0582\x03\x02\x02\x02\u03CF\u03D0\x05\xa9T\x02\u03D0\u03D1\x05\x91H\x02\u03D1\u03D2\x05\xbf_\x02\u03D2\u0582\x03\x02\x02\x02\u03D3\u03D4\x05\xa9T\x02\u03D4\u03D5\x05\xa1P\x02\u03D5\u03D6\x05\xabU\x02\u03D6\u0582\x03\x02\x02\x02\u03D7\u03D8\x05\xa9T\x02\u03D8\u03D9\x05\xa1P\x02\u03D9\u03DA\x05\xabU\x02\u03DA\u03DB\x05\xb9\\\x02\u03DB\u03DC\x05\xb5Z\x02\u03DC\u0582\x03\x02\x02\x02\u03DD\u03DE\x05\xa9T\x02\u03DE\u03DF\x05\xadV\x02\u03DF\u03E0\x05\x97K\x02\u03E0\u03E1\x05\x99L\x02\u03E1\u0582\x03\x02\x02\x02\u03E2\u03E3\x05\xa9T\x02\u03E3\u03E4\x05\xadV\x02\u03E4\u03E5\x05\x97K\x02\u03E5\u03E6\x05\xa1P\x02\u03E6\u03E7\x05\x9bM\x02\u03E7\u03E8\x05\xc1`\x02\u03E8\u0582\x03\x02\x02\x02\u03E9\u03EA\x05\xa9T\x02\u03EA\u03EB\x05\xadV\x02\u03EB\u03EC\x05\x97K\x02\u03EC\u03ED\x05\xb9\\\x02\u03ED\u03EE\x05\xa7S\x02\u03EE\u03EF\x05\xadV\x02\u03EF\u0582\x03\x02\x02\x02\u03F0\u03F1\x05\xa9T\x02\u03F1\u03F2\x05\xadV\x02\u03F2\u03F3\x05\xb3Y\x02\u03F3\u03F4\x05\x99L\x02\u03F4\u0582\x03\x02\x02\x02\u03F5\u03F6\x05\xa9T\x02\u03F6\u03F7\x05\xb9\\\x02\u03F7\u03F8\x05\xa7S\x02\u03F8\u03F9\x05\xb7[\x02\u03F9\u03FA\x05\xa1P\x02\u03FA\u03FB\x05\xafW\x02\u03FB\u03FC\x05\xa7S\x02\u03FC\u03FD\x05\xc1`\x02\u03FD\u0582\x03\x02\x02\x02\u03FE\u03FF\x05\xabU\x02\u03FF\u0400\x05\x99L\x02\u0400\u0401\x05\xbf_\x02\u0401\u0402\x05\xb7[\x02\u0402\u0582\x03\x02\x02\x02\u0403\u0404\x05\xabU\x02\u0404\u0405\x05\xadV\x02\u0405\u0406\x05\x91H\x02\u0406\u0407\x05\xb9\\\x02\u0407\u0408\x05\x97K\x02\u0408\u0409\x05\xa1P\x02\u0409\u040A\x05\xb7[\x02\u040A\u0582\x03\x02\x02\x02\u040B\u040C\x05\xabU\x02\u040C\u040D\x05\xadV\x02\u040D\u040E\x05\xb7[\x02\u040E\u040F\x05\xa1P\x02\u040F\u0410\x05\xabU\x02\u0410\u0582\x03\x02\x02\x02\u0411\u0412\x05\xabU\x02\u0412\u0413\x05\xadV\x02\u0413\u0414\x05\xbd^\x02\u0414\u0415\x05\x91H\x02\u0415\u0416\x05\xa1P\x02\u0416\u0417\x05\xb7[\x02\u0417\u0582\x03\x02\x02\x02\u0418\u0419\x05\xabU\x02\u0419\u041A\x05\xb9\\\x02\u041A\u041B\x05\xa9T\x02\u041B\u041C\x05\x93I\x02\u041C\u041D\x05\x99L\x02\u041D\u041E\x05\xb3Y\x02\u041E\u0582\x03\x02\x02\x02\u041F\u0420\x05\xadV\x02\u0420\u0421\x05\x93I\x02\u0421\u0422\x05\xa3Q\x02\u0422\u0423\x05\x99L\x02\u0423\u0424\x05\x95J\x02\u0424\u0425\x05\xb7[\x02\u0425\u0582\x03\x02\x02\x02\u0426\u0427\x05\xadV\x02\u0427\u0428\x05\x9bM\x02\u0428\u0582\x03\x02\x02\x02\u0429\u042A\x05\xadV\x02\u042A\u042B\x05\xafW\x02\u042B\u042C\x05\xb7[\x02\u042C\u042D\x05\xa1P\x02\u042D\u042E\x05\xadV\x02\u042E\u042F\x05\xabU\x02\u042F\u0582\x03\x02\x02\x02\u0430\u0431\x05\xadV\x02\u0431\u0432\x05\xb9\\\x02\u0432\u0433\x05\xb7[\x02\u0433\u0434\x05\x99L\x02\u0434\u0435\x05\xb3Y\x02\u0435\u0582\x03\x02\x02\x02\u0436\u0437\x05\xadV\x02\u0437\u0438\x05\xb9\\\x02\u0438\u0439\x05\xb7[\x02\u0439\u043A\x05\xafW\x02\u043A\u043B\x05\xb9\\\x02\u043B\u043C\x05\xb7[\x02\u043C\u0582\x03\x02\x02\x02\u043D\u043E\x05\xafW\x02\u043E\u043F\x05\xadV\x02\u043F\u0440\x05\xbd^\x02\u0440\u0441\x05\x99L\x02\u0441\u0442\x05";
    }
    static{
        this._serializedATNSegment2 = '\xb3Y\x02\u0442\u0582\x03\x02\x02\x02\u0443\u0444\x05\xafW\x02\u0444\u0445\x05\xb3Y\x02\u0445\u0446\x05\x99L\x02\u0446\u0447\x05\xbb]\x02\u0447\u0448\x05\xa1P\x02\u0448\u0449\x05\xadV\x02\u0449\u044A\x05\xb9\\\x02\u044A\u044B\x05\xb5Z\x02\u044B\u0582\x03\x02\x02\x02\u044C\u044D\x05\xafW\x02\u044D\u044E\x05\xb3Y\x02\u044E\u044F\x05\xa1P\x02\u044F\u0450\x05\xadV\x02\u0450\u0451\x05\xb3Y\x02\u0451\u0582\x03\x02\x02\x02\u0452\u0453\x05\xafW\x02\u0453\u0454\x05\xb3Y\x02\u0454\u0455\x05\xa1P\x02\u0455\u0456\x05\xbb]\x02\u0456\u0457\x05\xa1P\x02\u0457\u0458\x05\xa7S\x02\u0458\u0459\x05\x99L\x02\u0459\u045A\x05\x9dN\x02\u045A\u045B\x05\x99L\x02\u045B\u045C\x05\xb5Z\x02\u045C\u0582\x03\x02\x02\x02\u045D\u045E\x05\xafW\x02\u045E\u045F\x05\xb9\\\x02\u045F\u0460\x05\x93I\x02\u0460\u0461\x05\xa7S\x02\u0461\u0462\x05\xa1P\x02\u0462\u0463\x05\x95J\x02\u0463\u0582\x03\x02\x02\x02\u0464\u0465\x05\xb3Y\x02\u0465\u0466\x05\x91H\x02\u0466\u0467\x05\xa1P\x02\u0467\u0468\x05\xb5Z\x02\u0468\u0469\x05\x99L\x02\u0469\u0582\x03\x02\x02\x02\u046A\u046B\x05\xb3Y\x02\u046B\u046C\x05\x91H\x02\u046C\u046D\x05\xbd^\x02\u046D\u0582\x03\x02\x02\x02\u046E\u046F\x05\xb3Y\x02\u046F\u0470\x05\x99L\x02\u0470\u0471\x05\xa9T\x02\u0471\u0472\x05\x91H\x02\u0472\u0473\x05\xa1P\x02\u0473\u0474\x05\xabU\x02\u0474\u0475\x05\x97K\x02\u0475\u0476\x05\x99L\x02\u0476\u0477\x05\xb3Y\x02\u0477\u0582\x03\x02\x02\x02\u0478\u0479\x05\xb3Y\x02\u0479\u047A\x05\x99L\x02\u047A\u047B\x05\xabU\x02\u047B\u047C\x05\x91H\x02\u047C\u047D\x05\xa9T\x02\u047D\u047E\x05\x99L\x02\u047E\u0582\x03\x02\x02\x02\u047F\u0480\x05\xb3Y\x02\u0480\u0481\x05\x99L\x02\u0481\u0482\x05\xb5Z\x02\u0482\u0483\x05\xadV\x02\u0483\u0484\x05\xb9\\\x02\u0484\u0485\x05\xb3Y\x02\u0485\u0486\x05\x95J\x02\u0486\u0487\x05\x99L\x02\u0487\u0582\x03\x02\x02\x02\u0488\u0489\x05\xb3Y\x02\u0489\u048A\x05\x99L\x02\u048A\u048B\x05\xb7[\x02\u048B\u048C\x05\xb9\\\x02\u048C\u048D\x05\xb3Y\x02\u048D\u048E\x05\xabU\x02\u048E\u0582\x03\x02\x02\x02\u048F\u0490\x05\xb3Y\x02\u0490\u0491\x05\x99L\x02\u0491\u0492\x05\xb7[\x02\u0492\u0493\x05\xb9\\\x02\u0493\u0494\x05\xb3Y\x02\u0494\u0495\x05\xabU\x02\u0495\u0496\x05\xb5Z\x02\u0496\u0582\x03\x02\x02\x02\u0497\u0498\x05\xb3Y\x02\u0498\u0499\x05\x99L\x02\u0499\u049A\x05\xbb]\x02\u049A\u049B\x05\xadV\x02\u049B\u049C\x05\xa5R\x02\u049C\u049D\x05\x99L\x02\u049D\u0582\x03\x02\x02\x02\u049E\u049F\x05\xb3Y\x02\u049F\u04A0\x05\xa1P\x02\u04A0\u04A1\x05\x9dN\x02\u04A1\u04A2\x05\x9fO\x02\u04A2\u04A3\x05\xb7[\x02\u04A3\u0582\x03\x02\x02\x02\u04A4\u04A5\x05\xb3Y\x02\u04A5\u04A6\x05\xadV\x02\u04A6\u04A7\x05\xbd^\x02\u04A7\u0582\x03\x02\x02\x02\u04A8\u04A9\x05\xb3Y\x02\u04A9\u04AA\x05\xadV\x02\u04AA\u04AB\x05\xbd^\x02\u04AB\u04AC\x05\xa1P\x02\u04AC\u04AD\x05\x97K\x02\u04AD\u0582\x03\x02\x02\x02\u04AE\u04AF\x05\xb3Y\x02\u04AF\u04B0\x05\xadV\x02\u04B0\u04B1\x05\xbd^\x02\u04B1\u04B2\x05\xabU\x02\u04B2\u04B3\x05\xb9\\\x02\u04B3\u04B4\x05\xa9T\x02\u04B4\u0582\x03\x02\x02\x02\u04B5\u04B6\x05\xb3Y\x02\u04B6\u04B7\x05\xadV\x02\u04B7\u04B8\x05\xbd^\x02\u04B8\u04B9\x05\xb5Z\x02\u04B9\u0582\x03\x02\x02\x02\u04BA\u04BB\x05\xb5Z\x02\u04BB\u04BC\x05\x99L\x02\u04BC\u04BD\x05\xa7S\x02\u04BD\u04BE\x05\x99L\x02\u04BE\u04BF\x05\x95J\x02\u04BF\u04C0\x05\xb7[\x02\u04C0\u0582\x03\x02\x02\x02\u04C1\u04C2\x05\xb5Z\x02\u04C2\u04C3\x05\x99L\x02\u04C3\u04C4\x05\xb5Z\x02\u04C4\u04C5\x05\xb5Z\x02\u04C5\u04C6\x05\xa1P\x02\u04C6\u04C7\x05\xadV\x02\u04C7\u04C8\x05\xabU\x02\u04C8\u0582\x03\x02\x02\x02\u04C9\u04CA\x05\xb5Z\x02\u04CA\u04CB\x05\x99L\x02\u04CB\u04CC\x05\xb7[\x02\u04CC\u0582\x03\x02\x02\x02\u04CD\u04CE\x05\xb5Z\x02\u04CE\u04CF\x05\x9fO\x02\u04CF\u04D0\x05\x91H\x02\u04D0\u04D1\x05\xb3Y\x02\u04D1\u04D2\x05\x99L\x02\u04D2\u0582\x03\x02\x02\x02\u04D3\u04D4\x05\xb5Z\x02\u04D4\u04D5\x05\xa1P\x02\u04D5\u04D6\x05\xc3a\x02\u04D6\u04D7\x05\x99L\x02\u04D7\u0582\x03\x02\x02\x02\u04D8\u04D9\x05\xb5Z\x02\u04D9\u04DA\x05\xb1X\x02\u04DA\u04DB\x05\xb3Y\x02\u04DB\u04DC\x05\xb7[\x02\u04DC\u0582\x03\x02\x02\x02\u04DD\u04DE\x05\xb5Z\x02\u04DE\u04DF\x05\xb7[\x02\u04DF\u04E0\x05\x91H\x02\u04E0\u04E1\x05\xb3Y\x02\u04E1\u04E2\x05\xb7[\x02\u04E2\u0582\x03\x02\x02\x02\u04E3\u04E4\x05\xb5Z\x02\u04E4\u04E5\x05\xb7[\x02\u04E5\u04E6\x05\xb3Y\x02\u04E6\u04E7\x05\xa1P\x02\u04E7\u04E8\x05\x95J\x02\u04E8\u04E9\x05\xb7[\x02\u04E9\u0582\x03\x02\x02\x02\u04EA\u04EB\x05\xb5Z\x02\u04EB\u04EC\x05\xb7[\x02\u04EC\u04ED\x05\xb3Y\x02\u04ED\u04EE\x05\xa1P\x02\u04EE\u04EF\x05\xabU\x02\u04EF\u04F0\x05\x9dN\x02\u04F0\u0582\x03\x02\x02\x02\u04F1\u04F2\x05\xb5Z\x02\u04F2\u04F3\x05\xb9\\\x02\u04F3\u04F4\x05\x93I\x02\u04F4\u04F5\x05\xb7[\x02\u04F5\u04F6\x05\xb3Y\x02\u04F6\u04F7\x05\x91H\x02\u04F7\u04F8\x05\x95J\x02\u04F8\u04F9\x05\xb7[\x02\u04F9\u0582\x03\x02\x02\x02\u04FA\u04FB\x05\xb5Z\x02\u04FB\u04FC\x05\xb9\\\x02\u04FC\u04FD\x05\xa9T\x02\u04FD\u0582\x03\x02\x02\x02\u04FE\u04FF\x05\xb5Z\x02\u04FF\u0500\x05\xc1`\x02\u0500\u0501\x05\xabU\x02\u0501\u0502\x05\xadV\x02\u0502\u0503\x05\xabU\x02\u0503\u0504\x05\xc1`\x02\u0504\u0505\x05\xa9T\x02\u0505\u0582\x03\x02\x02\x02\u0506\u0507\x05\xb7[\x02\u0507\u0508\x05\x91H\x02\u0508\u0509\x05\x93I\x02\u0509\u050A\x05\xa7S\x02\u050A\u050B\x05\x99L\x02\u050B\u0582\x03\x02\x02\x02\u050C\u050D\x05\xb7[\x02\u050D\u050E\x05\x9fO\x02\u050E\u050F\x05\x99L\x02\u050F\u0510\x05\xabU\x02\u0510\u0582\x03\x02\x02\x02\u0511\u0512\x05\xb7[\x02\u0512\u0513\x05\xb3Y\x02\u0513\u0514\x05\x91H\x02\u0514\u0515\x05\xabU\x02\u0515\u0516\x05\xb5Z\x02\u0516\u0582\x03\x02\x02\x02\u0517\u0518\x05\xb7[\x02\u0518\u0519\x05\xb3Y\x02\u0519\u051A\x05\x91H\x02\u051A\u051B\x05\xabU\x02\u051B\u051C\x05\xb5Z\x02\u051C\u051D\x05\x91H\x02\u051D\u051E\x05\x95J\x02\u051E\u051F\x05\xb7[\x02\u051F\u0520\x05\xa1P\x02\u0520\u0521\x05\xadV\x02\u0521\u0522\x05\xabU\x02\u0522\u0582\x03\x02\x02\x02\u0523\u0524\x05\xb7[\x02\u0524\u0525\x05\xb3Y\x02\u0525\u0526\x05\xa1P\x02\u0526\u0527\x05\x9dN\x02\u0527\u0528\x05\x9dN\x02\u0528\u0529\x05\x99L\x02\u0529\u052A\x05\xb3Y\x02\u052A\u0582\x03\x02\x02\x02\u052B\u052C\x05\xb7[\x02\u052C\u052D\x05\xb3Y\x02\u052D\u052E\x05\xb9\\\x02\u052E\u052F\x05\x99L\x02\u052F\u0582\x03\x02\x02\x02\u0530\u0531\x05\xb9\\\x02\u0531\u0532\x05\xa1P\x02\u0532\u0533\x05\x97K\x02\u0533\u0582\x03\x02\x02\x02\u0534\u0535\x05\xb9\\\x02\u0535\u0536\x05\xabU\x02\u0536\u0537\x05\xa1P\x02\u0537\u0538\x05\xadV\x02\u0538\u0539\x05\xabU\x02\u0539\u0582\x03\x02\x02\x02\u053A\u053B\x05\xb9\\\x02\u053B\u053C\x05\xabU\x02\u053C\u053D\x05\xa1P\x02\u053D\u053E\x05\xb1X\x02\u053E\u053F\x05\xb9\\\x02\u053F\u0540\x05\x99L\x02\u0540\u0582\x03\x02\x02\x02\u0541\u0542\x05\xb9\\\x02\u0542\u0543\x05\xafW\x02\u0543\u0544\x05\x97K\x02\u0544\u0545\x05\x91H\x02\u0545\u0546\x05\xb7[\x02\u0546\u0547\x05\x99L\x02\u0547\u0582\x03\x02\x02\x02\u0548\u0549\x05\xb9\\\x02\u0549\u054A\x05\xb5Z\x02\u054A\u054B\x05\x99L\x02\u054B\u054C\x05\xb3Y\x02\u054C\u0582\x03\x02\x02\x02\u054D\u054E\x05\xbb]\x02\u054E\u054F\x05\x91H\x02\u054F\u0550\x05\xa7S\x02\u0550\u0551\x05\xa1P\x02\u0551\u0552\x05\x97K\x02\u0552\u0553\x05\x91H\x02\u0553\u0554\x05\xb7[\x02\u0554\u0555\x05\x99L\x02\u0555\u0582\x03\x02\x02\x02\u0556\u0557\x05\xbb]\x02\u0557\u0558\x05\x91H\x02\u0558\u0559\x05\xa7S\x02\u0559\u055A\x05\xb9\\\x02\u055A\u055B\x05\x99L\x02\u055B\u055C\x05\xb5Z\x02\u055C\u0582\x03\x02\x02\x02\u055D\u055E\x05\xbb]\x02\u055E\u055F\x05\xa1P\x02\u055F\u0560\x05\x99L\x02\u0560\u0561\x05\xbd^\x02\u0561\u0582\x03\x02\x02\x02\u0562\u0563\x05\xbd^\x02\u0563\u0564\x05\x9fO\x02\u0564\u0565\x05\x99L\x02\u0565\u0566\x05\xabU\x02\u0566\u0582\x03\x02\x02\x02\u0567\u0568\x05\xbd^\x02\u0568\u0569\x05\x9fO\x02\u0569\u056A\x05\x99L\x02\u056A\u056B\x05\xabU\x02\u056B\u056C\x05\x99L\x02\u056C\u056D\x05\xbb]\x02\u056D\u056E\x05\x99L\x02\u056E\u056F\x05\xb3Y\x02\u056F\u0582\x03\x02\x02\x02\u0570\u0571\x05\xbd^\x02\u0571\u0572\x05\x9fO\x02\u0572\u0573\x05\x99L\x02\u0573\u0574\x05\xb3Y\x02\u0574\u0575\x05\x99L\x02\u0575\u0582\x03\x02\x02\x02\u0576\u0577\x05\xbd^\x02\u0577\u0578\x05\x9fO\x02\u0578\u0579\x05\xa1P\x02\u0579\u057A\x05\xa7S\x02\u057A\u057B\x05\x99L\x02\u057B\u0582\x03\x02\x02\x02\u057C\u057D\x05\xbd^\x02\u057D\u057E\x05\xa1P\x02\u057E\u057F\x05\xb7[\x02\u057F\u0580\x05\x9fO\x02\u0580\u0582\x03\x02\x02\x02\u0581\u0160\x03\x02\x02\x02\u0581\u0166\x03\x02\x02\x02\u0581\u016D\x03\x02\x02\x02\u0581\u0171\x03\x02\x02\x02\u0581\u0177\x03\x02\x02\x02\u0581\u017D\x03\x02\x02\x02\u0581\u0181\x03\x02\x02\x02\u0581\u0184\x03\x02\x02\x02\u0581\u018A\x03\x02\x02\x02\u0581\u018E\x03\x02\x02\x02\u0581\u0194\x03\x02\x02\x02\u0581\u019C\x03\x02\x02\x02\u0581\u01A4\x03\x02\x02\x02\u0581\u01AA\x03\x02\x02\x02\u0581\u01AF\x03\x02\x02\x02\u0581\u01B5\x03\x02\x02\x02\u0581\u01BA\x03\x02\x02\x02\u0581\u01C4\x03\x02\x02\x02\u0581\u01CA\x03\x02\x02\x02\u0581\u01D5\x03\x02\x02\x02\u0581\u01DD\x03\x02\x02\x02\u0581\u01E7\x03\x02\x02\x02\u0581\u01EE\x03\x02\x02\x02\u0581\u01F5\x03\x02\x02\x02\u0581\u01FD\x03\x02\x02\x02\u0581\u0206\x03\x02\x02\x02\u0581\u020C\x03\x02\x02\x02\u0581\u0213\x03\x02\x02\x02\u0581\u021B\x03\x02\x02\x02\u0581\u0220\x03\x02\x02\x02\u0581\u0228\x03\x02\x02\x02\u0581\u0230\x03\x02\x02\x02\u0581\u023A\x03\x02\x02\x02\u0581\u0242\x03\x02\x02\x02\u0581\u024B\x03\x02\x02\x02\u0581\u0252\x03\x02\x02\x02\u0581\u0259\x03\x02\x02\x02\u0581\u0263\x03\x02\x02\x02\u0581\u026E\x03\x02\x02\x02\u0581\u0277\x03\x02\x02\x02\u0581\u027E\x03\x02\x02\x02\u0581\u0281\x03\x02\x02\x02\u0581\u0288\x03\x02\x02\x02\u0581\u028D\x03\x02\x02\x02\u0581\u0292\x03\x02\x02\x02\u0581\u029B\x03\x02\x02\x02\u0581\u029F\x03\x02\x02\x02\u0581\u02A6\x03\x02\x02\x02\u0581\u02AD\x03\x02\x02\x02\u0581\u02B7\x03\x02\x02\x02\u0581\u02BC\x03\x02\x02\x02\u0581\u02C4\x03\x02\x02\x02\u0581\u02CB\x03\x02\x02\x02\u0581\u02D3\x03\x02\x02\x02\u0581\u02D9\x03\x02\x02\x02\u0581\u02DF\x03\x02\x02\x02\u0581\u02E4\x03\x02\x02\x02\u0581\u02EA\x03\x02\x02\x02\u0581\u02F0\x03\x02\x02\x02\u0581\u02F6\x03\x02\x02\x02\u0581\u02FA\x03\x02\x02\x02\u0581\u0303\x03\x02\x02\x02\u0581\u0306\x03\x02\x02\x02\u0581\u030B\x03\x02\x02\x02\u0581\u0311\x03\x02\x02\x02\u0581\u0319\x03\x02\x02\x02\u0581\u031F\x03\x02\x02\x02\u0581\u0326\x03\x02\x02\x02\u0581\u0331\x03\x02\x02\x02\u0581\u0334\x03\x02\x02\x02\u0581\u033E\x03\x02\x02\x02\u0581\u0348\x03\x02\x02\x02\u0581\u034E\x03\x02\x02\x02\u0581\u0356\x03\x02\x02\x02\u0581\u035C\x03\x02\x02\x02\u0581\u0362\x03\x02\x02\x02\u0581\u0368\x03\x02\x02\x02\u0581\u036F\x03\x02\x02\x02\u0581\u0373\x03\x02\x02\x02\u0581\u037B\x03\x02\x02\x02\u0581\u0385\x03\x02\x02\x02\u0581\u0392\x03\x02\x02\x02\u0581\u0397\x03\x02\x02\x02\u0581\u039F\x03\x02\x02\x02\u0581\u03A6\x03\x02\x02\x02\u0581\u03AB\x03\x02\x02\x02\u0581\u03B0\x03\x02\x02\x02\u0581\u03B5\x03\x02\x02\x02\u0581\u03BA\x03\x02\x02\x02\u0581\u03BF\x03\x02\x02\x02\u0581\u03C5\x03\x02\x02\x02\u0581\u03CA\x03\x02\x02\x02\u0581\u03CF\x03\x02\x02\x02\u0581\u03D3\x03\x02\x02\x02\u0581\u03D7\x03\x02\x02\x02\u0581\u03DD\x03\x02\x02\x02\u0581\u03E2\x03\x02\x02\x02\u0581\u03E9\x03\x02\x02\x02\u0581\u03F0\x03\x02\x02\x02\u0581\u03F5\x03\x02\x02\x02\u0581\u03FE\x03\x02\x02\x02\u0581\u0403\x03\x02\x02\x02\u0581\u040B\x03\x02\x02\x02\u0581\u0411\x03\x02\x02\x02\u0581\u0418\x03\x02\x02\x02\u0581\u041F\x03\x02\x02\x02\u0581\u0426\x03\x02\x02\x02\u0581\u0429\x03\x02\x02\x02\u0581\u0430\x03\x02\x02\x02\u0581\u0436\x03\x02\x02\x02\u0581\u043D\x03\x02\x02\x02\u0581\u0443\x03\x02\x02\x02\u0581\u044C\x03\x02\x02\x02\u0581\u0452\x03\x02\x02\x02\u0581\u045D\x03\x02\x02\x02\u0581\u0464\x03\x02\x02\x02\u0581\u046A\x03\x02\x02\x02\u0581\u046E\x03\x02\x02\x02\u0581\u0478\x03\x02\x02\x02\u0581\u047F\x03\x02\x02\x02\u0581\u0488\x03\x02\x02\x02\u0581\u048F\x03\x02\x02\x02\u0581\u0497\x03\x02\x02\x02\u0581\u049E\x03\x02\x02\x02\u0581\u04A4\x03\x02\x02\x02\u0581\u04A8\x03\x02\x02\x02\u0581\u04AE\x03\x02\x02\x02\u0581\u04B5\x03\x02\x02\x02\u0581\u04BA\x03\x02\x02\x02\u0581\u04C1\x03\x02\x02\x02\u0581\u04C9\x03\x02\x02\x02\u0581\u04CD\x03\x02\x02\x02\u0581\u04D3\x03\x02\x02\x02\u0581\u04D8\x03\x02\x02\x02\u0581\u04DD\x03\x02\x02\x02\u0581\u04E3\x03\x02\x02\x02\u0581\u04EA\x03\x02\x02\x02\u0581\u04F1\x03\x02\x02\x02\u0581\u04FA\x03\x02\x02\x02\u0581\u04FE\x03\x02\x02\x02\u0581\u0506\x03\x02\x02\x02\u0581\u050C\x03\x02\x02\x02\u0581\u0511\x03\x02\x02\x02\u0581\u0517\x03\x02\x02\x02\u0581\u0523\x03\x02\x02\x02\u0581\u052B\x03\x02\x02\x02\u0581\u0530\x03\x02\x02\x02\u0581\u0534\x03\x02\x02\x02\u0581\u053A\x03\x02\x02\x02\u0581\u0541\x03\x02\x02\x02\u0581\u0548\x03\x02\x02\x02\u0581\u054D\x03\x02\x02\x02\u0581\u0556\x03\x02\x02\x02\u0581\u055D\x03\x02\x02\x02\u0581\u0562\x03\x02\x02\x02\u0581\u0567\x03\x02\x02\x02\u0581\u0570\x03\x02\x02\x02\u0581\u0576\x03\x02\x02\x02\u0581\u057C\x03\x02\x02\x02\u0582P\x03\x02\x02\x02\u0583\u0586\x05\x85B\x02\u0584\u0586\x05i4\x02\u0585\u0583\x03\x02\x02\x02\u0585\u0584\x03\x02\x02\x02\u0586\u0587\x03\x02\x02\x02\u0587\u0585\x03\x02\x02\x02\u0587\u0588\x03\x02\x02\x02\u0588R\x03\x02\x02\x02\u0589\u058B\x05\x8bE\x02\u058A\u0589\x03\x02\x02\x02\u058B\u058C\x03\x02\x02\x02\u058C\u058A\x03\x02\x02\x02\u058C\u058D\x03\x02\x02\x02\u058D\u058E\x03\x02\x02\x02\u058E\u058F\b)\x05\x02\u058FT\x03\x02\x02\x02\u0590\u0591\x05o7\x02\u0591V\x03\x02\x02\x02\u0592\u0593\v\x02\x02\x02\u0593X\x03\x02\x02\x02\u0594\u0595\x05q8\x02\u0595\u0596\x03\x02\x02\x02\u0596\u0597\b,\x06\x02\u0597Z\x03\x02\x02\x02\u0598\u059B\x05\x85B\x02\u0599\u059B\x05k5\x02\u059A\u0598\x03\x02\x02\x02\u059A\u0599\x03\x02\x02\x02\u059B\u059C\x03\x02\x02\x02\u059C\u059D\b-\x02\x02\u059D\\\x03\x02\x02\x02\u059E\u059F\x07\x02\x02\x03\u059F\u05A0\x03\x02\x02\x02\u05A0\u05A1\b.\x06\x02\u05A1^\x03\x02\x02\x02\u05A2\u05A3\v\x02\x02\x02\u05A3\u05A4\x03\x02\x02\x02\u05A4\u05A5\b/\x06\x02\u05A5`\x03\x02\x02\x02\u05A6\u05A7\x05s9\x02\u05A7\u05A8\x03\x02\x02\x02\u05A8\u05A9\b0\x06\x02\u05A9b\x03\x02\x02\x02\u05AA\u05AD\x05\x85B\x02\u05AB\u05AD\x05m6\x02\u05AC\u05AA\x03\x02\x02\x02\u05AC\u05AB\x03\x02\x02\x02\u05AD\u05AE\x03\x02\x02\x02\u05AE\u05AF\b1\x02\x02\u05AFd\x03\x02\x02\x02\u05B0\u05B1\x07\x02\x02\x03\u05B1\u05B2\x03\x02\x02\x02\u05B2\u05B3\b2\x06\x02\u05B3f\x03\x02\x02\x02\u05B4\u05B5\v\x02\x02\x02\u05B5\u05B6\x03\x02\x02\x02\u05B6\u05B7\b3\x06\x02\u05B7h\x03\x02\x02\x02\u05B8\u05B9\n\x02\x02\x02\u05B9j\x03\x02\x02\x02\u05BA\u05BB\n\x03\x02\x02\u05BBl\x03\x02\x02\x02\u05BC\u05BD\n\x04\x02\x02\u05BDn\x03\x02\x02\x02\u05BE\u05BF	\x05\x02\x02\u05BFp\x03\x02\x02\x02\u05C0\u05C1\x07$\x02\x02\u05C1r\x03\x02\x02\x02\u05C2\u05C3\x07)\x02\x02\u05C3t\x03\x02\x02\x02\u05C4\u05C5\x07^\x02\x02\u05C5v\x03\x02\x02\x02\u05C6\u05C7\x07\x0f\x02\x02\u05C7x\x03\x02\x02\x02\u05C8\u05C9\x07\f\x02\x02\u05C9z\x03\x02\x02\x02\u05CA\u05CB\x07"\x02\x02\u05CB|\x03\x02\x02\x02\u05CC\u05CD\x07(\x02\x02\u05CD~\x03\x02\x02\x02\u05CE\u05CF\x07(\x02\x02\u05CF\u05D0\x07(\x02\x02\u05D0\x80\x03\x02\x02\x02\u05D1\u05D2\x07~\x02\x02\u05D2\x82\x03\x02\x02\x02\u05D3\u05D4\x07~\x02\x02\u05D4\u05D5\x07~\x02\x02\u05D5\x84\x03\x02\x02\x02\u05D6\u05E2\x05u:\x02\u05D7\u05E3	\x06\x02\x02\u05D8\u05E3\x05q8\x02\u05D9\u05E3\x05s9\x02\u05DA\u05E3\x05u:\x02\u05DB\u05E3\x05{=\x02\u05DC\u05DD\x07w\x02\x02\u05DD\u05DE\x05\x89D\x02\u05DE\u05DF\x05\x89D\x02\u05DF\u05E0\x05\x89D\x02\u05E0\u05E1\x05\x89D\x02\u05E1\u05E3\x03\x02\x02\x02\u05E2\u05D7\x03\x02\x02\x02\u05E2\u05D8\x03\x02\x02\x02\u05E2\u05D9\x03\x02\x02\x02\u05E2\u05DA\x03\x02\x02\x02\u05E2\u05DB\x03\x02\x02\x02\u05E2\u05DC\x03\x02\x02\x02\u05E3\x86\x03\x02\x02\x02\u05E4\u05E7\x05w;\x02\u05E5\u05E7\x05y<\x02\u05E6\u05E4\x03\x02\x02\x02\u05E6\u05E5\x03\x02\x02\x02\u05E7\x88\x03\x02\x02\x02\u05E8\u05F0\x05\x8fG\x02\u05E9\u05F0\x05\x91H\x02\u05EA\u05F0\x05\x93I\x02\u05EB\u05F0\x05\x95J\x02\u05EC\u05F0\x05\x97K\x02\u05ED\u05F0\x05\x99L\x02\u05EE\u05F0\x05\x9bM\x02\u05EF\u05E8\x03\x02\x02\x02\u05EF\u05E9\x03\x02\x02\x02\u05EF\u05EA\x03\x02\x02\x02\u05EF\u05EB\x03\x02\x02\x02\u05EF\u05EC\x03\x02\x02\x02\u05EF\u05ED\x03\x02\x02\x02\u05EF\u05EE\x03\x02\x02\x02\u05F0\x8a\x03\x02\x02\x02\u05F1\u05F5\x05{=\x02\u05F2\u05F5\x07\v\x02\x02\u05F3\u05F5\x05\x87C\x02\u05F4\u05F1\x03\x02\x02\x02\u05F4\u05F2\x03\x02\x02\x02\u05F4\u05F3\x03\x02\x02\x02\u05F5\x8c\x03\x02\x02\x02\u05F6\u05F7\x07/\x02\x02\u05F7\x8e\x03\x02\x02\x02\u05F8\u05F9	\x07\x02\x02\u05F9\x90\x03\x02\x02\x02\u05FA\u05FB	\b\x02\x02\u05FB\x92\x03\x02\x02\x02\u05FC\u05FD		\x02\x02\u05FD\x94\x03\x02\x02\x02\u05FE\u05FF	\n\x02\x02\u05FF\x96\x03\x02\x02\x02\u0600\u0601	\v\x02\x02\u0601\x98\x03\x02\x02\x02\u0602\u0603	\f\x02\x02\u0603\x9a\x03\x02\x02\x02\u0604\u0605	\r\x02\x02\u0605\x9c\x03\x02\x02\x02\u0606\u0607	\x0e\x02\x02\u0607\x9e\x03\x02\x02\x02\u0608\u0609	\x0f\x02\x02\u0609\xa0\x03\x02\x02\x02\u060A\u060B	\x10\x02\x02\u060B\xa2\x03\x02\x02\x02\u060C\u060D	\x11\x02\x02\u060D\xa4\x03\x02\x02\x02\u060E\u060F	\x12\x02\x02\u060F\xa6\x03\x02\x02\x02\u0610\u0611	\x13\x02\x02\u0611\xa8\x03\x02\x02\x02\u0612\u0613	\x14\x02\x02\u0613\xaa\x03\x02\x02\x02\u0614\u0615	\x15\x02\x02\u0615\xac\x03\x02\x02\x02\u0616\u0617	\x16\x02\x02\u0617\xae\x03\x02\x02\x02\u0618\u0619	\x17\x02\x02\u0619\xb0\x03\x02\x02\x02\u061A\u061B	\x18\x02\x02\u061B\xb2\x03\x02\x02\x02\u061C\u061D	\x19\x02\x02\u061D\xb4\x03\x02\x02\x02\u061E\u061F	\x1a\x02\x02\u061F\xb6\x03\x02\x02\x02\u0620\u0621	\x1b\x02\x02\u0621\xb8\x03\x02\x02\x02\u0622\u0623	\x1c\x02\x02\u0623\xba\x03\x02\x02\x02\u0624\u0625	\x1d\x02\x02\u0625\xbc\x03\x02\x02\x02\u0626\u0627	\x1e\x02\x02\u0627\xbe\x03\x02\x02\x02\u0628\u0629	\x1f\x02\x02\u0629\xc0\x03\x02\x02\x02\u062A\u062B	 \x02\x02\u062B\xc2\x03\x02\x02\x02\u062C\u062D	!\x02\x02\u062D\xc4\x03\x02\x02\x02\x14\x02\x03\x04\xfb\u0102\u0113\u0155\u015B\u0581\u0585\u0587\u058C\u059A\u05AC\u05E2\u05E6\u05EF\u05F4\x07\x05\x02\x02\x04\x03\x02\x04\x04\x02\x02\x03\x02\x04\x02\x02';
    }
    static{
        this._serializedATN = $2IEP9.join([
            $801b4612eb9312ce$export$375c79404cc64c7f._serializedATNSegment0,
            $801b4612eb9312ce$export$375c79404cc64c7f._serializedATNSegment1,
            $801b4612eb9312ce$export$375c79404cc64c7f._serializedATNSegment2
        ], '');
    }
    static get _ATN() {
        if (!$801b4612eb9312ce$export$375c79404cc64c7f.__ATN) $801b4612eb9312ce$export$375c79404cc64c7f.__ATN = new (0, $dvgsl.ATNDeserializer)().deserialize($2IEP9.toCharArray($801b4612eb9312ce$export$375c79404cc64c7f._serializedATN));
        return $801b4612eb9312ce$export$375c79404cc64c7f.__ATN;
    }
}

});

parcelRegister("k9No4", function(module, exports) {

$parcel$export(module.exports, "JQLParser", () => $371e898df891458a$export$9c4772e191bdb810);
/* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// Generated from JQLParser.g4 by ANTLR 4.7.3-SNAPSHOT

var $dvgsl = parcelRequire("dvgsl");

var $hKCjP = parcelRequire("hKCjP");

var $jIG0W = parcelRequire("jIG0W");

var $6bmaO = parcelRequire("6bmaO");

var $kzbnL = parcelRequire("kzbnL");

var $fLdDn = parcelRequire("fLdDn");

var $2DVsz = parcelRequire("2DVsz");

var $3n2FE = parcelRequire("3n2FE");

var $2IEP9 = parcelRequire("2IEP9");
class $371e898df891458a$export$9c4772e191bdb810 extends (0, $jIG0W.Parser) {
    static{
        this.LPAREN = 1;
    }
    static{
        this.RPAREN = 2;
    }
    static{
        this.COMMA = 3;
    }
    static{
        this.LBRACKET = 4;
    }
    static{
        this.RBRACKET = 5;
    }
    static{
        this.BANG = 6;
    }
    static{
        this.LT = 7;
    }
    static{
        this.GT = 8;
    }
    static{
        this.GTEQ = 9;
    }
    static{
        this.LTEQ = 10;
    }
    static{
        this.EQUALS = 11;
    }
    static{
        this.NOT_EQUALS = 12;
    }
    static{
        this.LIKE = 13;
    }
    static{
        this.NOT_LIKE = 14;
    }
    static{
        this.IN = 15;
    }
    static{
        this.IS = 16;
    }
    static{
        this.AND = 17;
    }
    static{
        this.OR = 18;
    }
    static{
        this.NOT = 19;
    }
    static{
        this.EMPTY = 20;
    }
    static{
        this.WAS = 21;
    }
    static{
        this.CHANGED = 22;
    }
    static{
        this.BEFORE = 23;
    }
    static{
        this.AFTER = 24;
    }
    static{
        this.FROM = 25;
    }
    static{
        this.TO = 26;
    }
    static{
        this.ON = 27;
    }
    static{
        this.DURING = 28;
    }
    static{
        this.ORDER = 29;
    }
    static{
        this.BY = 30;
    }
    static{
        this.ASC = 31;
    }
    static{
        this.DESC = 32;
    }
    static{
        this.POSNUMBER = 33;
    }
    static{
        this.NEGNUMBER = 34;
    }
    static{
        this.CUSTOMFIELD = 35;
    }
    static{
        this.RESERVED_WORD = 36;
    }
    static{
        this.STRING = 37;
    }
    static{
        this.MATCHWS = 38;
    }
    static{
        this.ERROR_RESERVED = 39;
    }
    static{
        this.ERRORCHAR = 40;
    }
    static{
        this.QUOTE_STRING = 41;
    }
    static{
        this.UNCLOSED_QUOTE_STRING = 42;
    }
    static{
        this.INVALID_QUOTE_STRING = 43;
    }
    static{
        this.SQUOTE_STRING = 44;
    }
    static{
        this.UNCLOSED_SQUOTE_STRING = 45;
    }
    static{
        this.INVALID_SQUOTE_STRING = 46;
    }
    static{
        this.RULE_jqlQuery = 0;
    }
    static{
        this.RULE_jqlWhere = 1;
    }
    static{
        this.RULE_jqlOrClause = 2;
    }
    static{
        this.RULE_jqlAndClause = 3;
    }
    static{
        this.RULE_jqlNotClause = 4;
    }
    static{
        this.RULE_jqlSubClause = 5;
    }
    static{
        this.RULE_jqlTerminalClause = 6;
    }
    static{
        this.RULE_jqlTerminalClauseRhs = 7;
    }
    static{
        this.RULE_jqlEqualsOperator = 8;
    }
    static{
        this.RULE_jqlLikeOperator = 9;
    }
    static{
        this.RULE_jqlComparisonOperator = 10;
    }
    static{
        this.RULE_jqlInOperator = 11;
    }
    static{
        this.RULE_jqlIsOperator = 12;
    }
    static{
        this.RULE_jqlWasOperator = 13;
    }
    static{
        this.RULE_jqlWasInOperator = 14;
    }
    static{
        this.RULE_jqlChangedOperator = 15;
    }
    static{
        this.RULE_jqlField = 16;
    }
    static{
        this.RULE_jqlFieldProperty = 17;
    }
    static{
        this.RULE_jqlCustomField = 18;
    }
    static{
        this.RULE_jqlString = 19;
    }
    static{
        this.RULE_jqlNumber = 20;
    }
    static{
        this.RULE_jqlOperand = 21;
    }
    static{
        this.RULE_jqlEmpty = 22;
    }
    static{
        this.RULE_jqlValue = 23;
    }
    static{
        this.RULE_jqlFunction = 24;
    }
    static{
        this.RULE_jqlFunctionName = 25;
    }
    static{
        this.RULE_jqlArgumentList = 26;
    }
    static{
        this.RULE_jqlList = 27;
    }
    static{
        this.RULE_jqlListStart = 28;
    }
    static{
        this.RULE_jqlListEnd = 29;
    }
    static{
        this.RULE_jqlPropertyArgument = 30;
    }
    static{
        this.RULE_jqlArgument = 31;
    }
    static{
        this.RULE_jqlWasPredicate = 32;
    }
    static{
        this.RULE_jqlChangedPredicate = 33;
    }
    static{
        this.RULE_jqlDatePredicateOperator = 34;
    }
    static{
        this.RULE_jqlDateRangePredicateOperator = 35;
    }
    static{
        this.RULE_jqlUserPredicateOperator = 36;
    }
    static{
        this.RULE_jqlValuePredicateOperator = 37;
    }
    static{
        this.RULE_jqlPredicateOperand = 38;
    }
    static{
        this.RULE_jqlOrderBy = 39;
    }
    static{
        this.RULE_jqlSearchSort = 40;
    }
    static{
        // tslint:disable:no-trailing-whitespace
        this.ruleNames = [
            'jqlQuery',
            'jqlWhere',
            'jqlOrClause',
            'jqlAndClause',
            'jqlNotClause',
            'jqlSubClause',
            'jqlTerminalClause',
            'jqlTerminalClauseRhs',
            'jqlEqualsOperator',
            'jqlLikeOperator',
            'jqlComparisonOperator',
            'jqlInOperator',
            'jqlIsOperator',
            'jqlWasOperator',
            'jqlWasInOperator',
            'jqlChangedOperator',
            'jqlField',
            'jqlFieldProperty',
            'jqlCustomField',
            'jqlString',
            'jqlNumber',
            'jqlOperand',
            'jqlEmpty',
            'jqlValue',
            'jqlFunction',
            'jqlFunctionName',
            'jqlArgumentList',
            'jqlList',
            'jqlListStart',
            'jqlListEnd',
            'jqlPropertyArgument',
            'jqlArgument',
            'jqlWasPredicate',
            'jqlChangedPredicate',
            'jqlDatePredicateOperator',
            'jqlDateRangePredicateOperator',
            'jqlUserPredicateOperator',
            'jqlValuePredicateOperator',
            'jqlPredicateOperand',
            'jqlOrderBy',
            'jqlSearchSort'
        ];
    }
    static{
        this._LITERAL_NAMES = [
            undefined,
            "'('",
            "')'",
            "','",
            "'['",
            "']'",
            "'!'",
            "'<'",
            "'>'",
            "'>='",
            "'<='",
            "'='",
            "'!='",
            "'~'",
            "'!~'"
        ];
    }
    static{
        this._SYMBOLIC_NAMES = [
            undefined,
            'LPAREN',
            'RPAREN',
            'COMMA',
            'LBRACKET',
            'RBRACKET',
            'BANG',
            'LT',
            'GT',
            'GTEQ',
            'LTEQ',
            'EQUALS',
            'NOT_EQUALS',
            'LIKE',
            'NOT_LIKE',
            'IN',
            'IS',
            'AND',
            'OR',
            'NOT',
            'EMPTY',
            'WAS',
            'CHANGED',
            'BEFORE',
            'AFTER',
            'FROM',
            'TO',
            'ON',
            'DURING',
            'ORDER',
            'BY',
            'ASC',
            'DESC',
            'POSNUMBER',
            'NEGNUMBER',
            'CUSTOMFIELD',
            'RESERVED_WORD',
            'STRING',
            'MATCHWS',
            'ERROR_RESERVED',
            'ERRORCHAR',
            'QUOTE_STRING',
            'UNCLOSED_QUOTE_STRING',
            'INVALID_QUOTE_STRING',
            'SQUOTE_STRING',
            'UNCLOSED_SQUOTE_STRING',
            'INVALID_SQUOTE_STRING'
        ];
    }
    static{
        this.VOCABULARY = new (0, $3n2FE.VocabularyImpl)($371e898df891458a$export$9c4772e191bdb810._LITERAL_NAMES, $371e898df891458a$export$9c4772e191bdb810._SYMBOLIC_NAMES, []);
    }
    // @Override
    // @NotNull
    get vocabulary() {
        return $371e898df891458a$export$9c4772e191bdb810.VOCABULARY;
    }
    // tslint:enable:no-trailing-whitespace
    // @Override
    get grammarFileName() {
        return 'JQLParser.g4';
    }
    // @Override
    get ruleNames() {
        return $371e898df891458a$export$9c4772e191bdb810.ruleNames;
    }
    // @Override
    get serializedATN() {
        return $371e898df891458a$export$9c4772e191bdb810._serializedATN;
    }
    constructor(input){
        super(input);
        this._interp = new (0, $kzbnL.ParserATNSimulator)($371e898df891458a$export$9c4772e191bdb810._ATN, this);
    }
    // @RuleVersion(0)
    jqlQuery() {
        let _localctx = new $371e898df891458a$export$ff413535b9575c8(this._ctx, this.state);
        this.enterRule(_localctx, 0, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlQuery);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 83;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if ((_la & -32) === 0 && (1 << _la & (1 << $371e898df891458a$export$9c4772e191bdb810.LPAREN | 1 << $371e898df891458a$export$9c4772e191bdb810.BANG | 1 << $371e898df891458a$export$9c4772e191bdb810.NOT)) !== 0 || (_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $371e898df891458a$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.CUSTOMFIELD - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.STRING - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0) {
                this.state = 82;
                this.jqlWhere();
            }
            this.state = 86;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if (_la === $371e898df891458a$export$9c4772e191bdb810.ORDER) {
                this.state = 85;
                this.jqlOrderBy();
            }
            this.state = 88;
            this.match($371e898df891458a$export$9c4772e191bdb810.EOF);
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWhere() {
        let _localctx = new $371e898df891458a$export$4148a879cab28017(this._ctx, this.state);
        this.enterRule(_localctx, 2, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlWhere);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 90;
            this.jqlOrClause();
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlOrClause() {
        let _localctx = new $371e898df891458a$export$d69831d387793480(this._ctx, this.state);
        this.enterRule(_localctx, 4, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlOrClause);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 92;
            this.jqlAndClause();
            this.state = 97;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $371e898df891458a$export$9c4772e191bdb810.OR){
                this.state = 93;
                this.match($371e898df891458a$export$9c4772e191bdb810.OR);
                this.state = 94;
                this.jqlAndClause();
                this.state = 99;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlAndClause() {
        let _localctx = new $371e898df891458a$export$f16819001158b9e(this._ctx, this.state);
        this.enterRule(_localctx, 6, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlAndClause);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 100;
            this.jqlNotClause();
            this.state = 105;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $371e898df891458a$export$9c4772e191bdb810.AND){
                this.state = 101;
                this.match($371e898df891458a$export$9c4772e191bdb810.AND);
                this.state = 102;
                this.jqlNotClause();
                this.state = 107;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlNotClause() {
        let _localctx = new $371e898df891458a$export$5e9146f8d5cf1330(this._ctx, this.state);
        this.enterRule(_localctx, 8, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlNotClause);
        let _la;
        try {
            this.state = 112;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $371e898df891458a$export$9c4772e191bdb810.BANG:
                case $371e898df891458a$export$9c4772e191bdb810.NOT:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 108;
                    _la = this._input.LA(1);
                    if (!(_la === $371e898df891458a$export$9c4772e191bdb810.BANG || _la === $371e898df891458a$export$9c4772e191bdb810.NOT)) this._errHandler.recoverInline(this);
                    else {
                        if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                        this._errHandler.reportMatch(this);
                        this.consume();
                    }
                    this.state = 109;
                    this.jqlNotClause();
                    break;
                case $371e898df891458a$export$9c4772e191bdb810.LPAREN:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 110;
                    this.jqlSubClause();
                    break;
                case $371e898df891458a$export$9c4772e191bdb810.POSNUMBER:
                case $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER:
                case $371e898df891458a$export$9c4772e191bdb810.CUSTOMFIELD:
                case $371e898df891458a$export$9c4772e191bdb810.STRING:
                case $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING:
                case $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 3);
                    this.state = 111;
                    this.jqlTerminalClause();
                    break;
                default:
                    throw new (0, $hKCjP.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlSubClause() {
        let _localctx = new $371e898df891458a$export$a136a0e9655bfb04(this._ctx, this.state);
        this.enterRule(_localctx, 10, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlSubClause);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 114;
            this.match($371e898df891458a$export$9c4772e191bdb810.LPAREN);
            this.state = 115;
            this.jqlOrClause();
            this.state = 116;
            this.match($371e898df891458a$export$9c4772e191bdb810.RPAREN);
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlTerminalClause() {
        let _localctx = new $371e898df891458a$export$23486a2f2ddd5bcd(this._ctx, this.state);
        this.enterRule(_localctx, 12, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlTerminalClause);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 118;
            this.jqlField();
            this.state = 119;
            this.jqlTerminalClauseRhs();
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlTerminalClauseRhs() {
        let _localctx = new $371e898df891458a$export$93924a205c12d32c(this._ctx, this.state);
        this.enterRule(_localctx, 14, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlTerminalClauseRhs);
        let _la;
        try {
            this.state = 176;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 14, this._ctx)){
                case 1:
                    _localctx = new $371e898df891458a$export$c428f709a58396e5(_localctx);
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 121;
                    this.jqlEqualsOperator();
                    this.state = 125;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 5, this._ctx)){
                        case 1:
                            this.state = 122;
                            this.jqlEmpty();
                            break;
                        case 2:
                            this.state = 123;
                            this.jqlValue();
                            break;
                        case 3:
                            this.state = 124;
                            this.jqlFunction();
                            break;
                    }
                    break;
                case 2:
                    _localctx = new $371e898df891458a$export$1b131204ef9fa33d(_localctx);
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 127;
                    this.jqlLikeOperator();
                    this.state = 131;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 6, this._ctx)){
                        case 1:
                            this.state = 128;
                            this.jqlEmpty();
                            break;
                        case 2:
                            this.state = 129;
                            this.jqlValue();
                            break;
                        case 3:
                            this.state = 130;
                            this.jqlFunction();
                            break;
                    }
                    break;
                case 3:
                    _localctx = new $371e898df891458a$export$d83706ee80a9852a(_localctx);
                    this.enterOuterAlt(_localctx, 3);
                    this.state = 133;
                    this.jqlComparisonOperator();
                    this.state = 136;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 7, this._ctx)){
                        case 1:
                            this.state = 134;
                            this.jqlValue();
                            break;
                        case 2:
                            this.state = 135;
                            this.jqlFunction();
                            break;
                    }
                    break;
                case 4:
                    _localctx = new $371e898df891458a$export$2934b8ff22fddd2d(_localctx);
                    this.enterOuterAlt(_localctx, 4);
                    this.state = 138;
                    this.jqlInOperator();
                    this.state = 141;
                    this._errHandler.sync(this);
                    switch(this._input.LA(1)){
                        case $371e898df891458a$export$9c4772e191bdb810.LPAREN:
                            this.state = 139;
                            this.jqlList();
                            break;
                        case $371e898df891458a$export$9c4772e191bdb810.POSNUMBER:
                        case $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER:
                        case $371e898df891458a$export$9c4772e191bdb810.STRING:
                        case $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING:
                        case $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING:
                            this.state = 140;
                            this.jqlFunction();
                            break;
                        default:
                            throw new (0, $hKCjP.NoViableAltException)(this);
                    }
                    break;
                case 5:
                    _localctx = new $371e898df891458a$export$8b84310182afcf93(_localctx);
                    this.enterOuterAlt(_localctx, 5);
                    this.state = 143;
                    this.jqlIsOperator();
                    this.state = 144;
                    this.jqlEmpty();
                    break;
                case 6:
                    _localctx = new $371e898df891458a$export$5df295dc7a2cac7c(_localctx);
                    this.enterOuterAlt(_localctx, 6);
                    this.state = 146;
                    this.jqlWasOperator();
                    this.state = 150;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 9, this._ctx)){
                        case 1:
                            this.state = 147;
                            this.jqlEmpty();
                            break;
                        case 2:
                            this.state = 148;
                            this.jqlValue();
                            break;
                        case 3:
                            this.state = 149;
                            this.jqlFunction();
                            break;
                    }
                    this.state = 155;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while((_la & -32) === 0 && (1 << _la & (1 << $371e898df891458a$export$9c4772e191bdb810.BEFORE | 1 << $371e898df891458a$export$9c4772e191bdb810.AFTER | 1 << $371e898df891458a$export$9c4772e191bdb810.ON | 1 << $371e898df891458a$export$9c4772e191bdb810.DURING | 1 << $371e898df891458a$export$9c4772e191bdb810.BY)) !== 0){
                        this.state = 152;
                        this.jqlWasPredicate();
                        this.state = 157;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
                case 7:
                    _localctx = new $371e898df891458a$export$9ac3367aee261b32(_localctx);
                    this.enterOuterAlt(_localctx, 7);
                    this.state = 158;
                    this.jqlWasInOperator();
                    this.state = 161;
                    this._errHandler.sync(this);
                    switch(this._input.LA(1)){
                        case $371e898df891458a$export$9c4772e191bdb810.LPAREN:
                            this.state = 159;
                            this.jqlList();
                            break;
                        case $371e898df891458a$export$9c4772e191bdb810.POSNUMBER:
                        case $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER:
                        case $371e898df891458a$export$9c4772e191bdb810.STRING:
                        case $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING:
                        case $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING:
                            this.state = 160;
                            this.jqlFunction();
                            break;
                        default:
                            throw new (0, $hKCjP.NoViableAltException)(this);
                    }
                    this.state = 166;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while((_la & -32) === 0 && (1 << _la & (1 << $371e898df891458a$export$9c4772e191bdb810.BEFORE | 1 << $371e898df891458a$export$9c4772e191bdb810.AFTER | 1 << $371e898df891458a$export$9c4772e191bdb810.ON | 1 << $371e898df891458a$export$9c4772e191bdb810.DURING | 1 << $371e898df891458a$export$9c4772e191bdb810.BY)) !== 0){
                        this.state = 163;
                        this.jqlWasPredicate();
                        this.state = 168;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
                case 8:
                    _localctx = new $371e898df891458a$export$7a7defca8628a13c(_localctx);
                    this.enterOuterAlt(_localctx, 8);
                    this.state = 169;
                    this.jqlChangedOperator();
                    this.state = 173;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while((_la & -32) === 0 && (1 << _la & (1 << $371e898df891458a$export$9c4772e191bdb810.BEFORE | 1 << $371e898df891458a$export$9c4772e191bdb810.AFTER | 1 << $371e898df891458a$export$9c4772e191bdb810.FROM | 1 << $371e898df891458a$export$9c4772e191bdb810.TO | 1 << $371e898df891458a$export$9c4772e191bdb810.ON | 1 << $371e898df891458a$export$9c4772e191bdb810.DURING | 1 << $371e898df891458a$export$9c4772e191bdb810.BY)) !== 0){
                        this.state = 170;
                        this.jqlChangedPredicate();
                        this.state = 175;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlEqualsOperator() {
        let _localctx = new $371e898df891458a$export$41e475fc1988e413(this._ctx, this.state);
        this.enterRule(_localctx, 16, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlEqualsOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 178;
            _la = this._input.LA(1);
            if (!(_la === $371e898df891458a$export$9c4772e191bdb810.EQUALS || _la === $371e898df891458a$export$9c4772e191bdb810.NOT_EQUALS)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlLikeOperator() {
        let _localctx = new $371e898df891458a$export$b76fe5387fdd7efd(this._ctx, this.state);
        this.enterRule(_localctx, 18, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlLikeOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 180;
            _la = this._input.LA(1);
            if (!(_la === $371e898df891458a$export$9c4772e191bdb810.LIKE || _la === $371e898df891458a$export$9c4772e191bdb810.NOT_LIKE)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlComparisonOperator() {
        let _localctx = new $371e898df891458a$export$d821da0716b3ec95(this._ctx, this.state);
        this.enterRule(_localctx, 20, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlComparisonOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 182;
            _la = this._input.LA(1);
            if (!((_la & -32) === 0 && (1 << _la & (1 << $371e898df891458a$export$9c4772e191bdb810.LT | 1 << $371e898df891458a$export$9c4772e191bdb810.GT | 1 << $371e898df891458a$export$9c4772e191bdb810.GTEQ | 1 << $371e898df891458a$export$9c4772e191bdb810.LTEQ)) !== 0)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlInOperator() {
        let _localctx = new $371e898df891458a$export$178478bfa8292f72(this._ctx, this.state);
        this.enterRule(_localctx, 22, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlInOperator);
        try {
            this.state = 187;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $371e898df891458a$export$9c4772e191bdb810.IN:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 184;
                    this.match($371e898df891458a$export$9c4772e191bdb810.IN);
                    break;
                case $371e898df891458a$export$9c4772e191bdb810.NOT:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 185;
                    this.match($371e898df891458a$export$9c4772e191bdb810.NOT);
                    this.state = 186;
                    this.match($371e898df891458a$export$9c4772e191bdb810.IN);
                    break;
                default:
                    throw new (0, $hKCjP.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlIsOperator() {
        let _localctx = new $371e898df891458a$export$e64c31d2830b66e4(this._ctx, this.state);
        this.enterRule(_localctx, 24, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlIsOperator);
        try {
            this.state = 192;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 16, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 189;
                    this.match($371e898df891458a$export$9c4772e191bdb810.IS);
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 190;
                    this.match($371e898df891458a$export$9c4772e191bdb810.IS);
                    this.state = 191;
                    this.match($371e898df891458a$export$9c4772e191bdb810.NOT);
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWasOperator() {
        let _localctx = new $371e898df891458a$export$7e283636700e4a6c(this._ctx, this.state);
        this.enterRule(_localctx, 26, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlWasOperator);
        try {
            this.state = 197;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 17, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 194;
                    this.match($371e898df891458a$export$9c4772e191bdb810.WAS);
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 195;
                    this.match($371e898df891458a$export$9c4772e191bdb810.WAS);
                    this.state = 196;
                    this.match($371e898df891458a$export$9c4772e191bdb810.NOT);
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWasInOperator() {
        let _localctx = new $371e898df891458a$export$b9118b1ed9a78d66(this._ctx, this.state);
        this.enterRule(_localctx, 28, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlWasInOperator);
        try {
            this.state = 204;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 18, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 199;
                    this.match($371e898df891458a$export$9c4772e191bdb810.WAS);
                    this.state = 200;
                    this.match($371e898df891458a$export$9c4772e191bdb810.IN);
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 201;
                    this.match($371e898df891458a$export$9c4772e191bdb810.WAS);
                    this.state = 202;
                    this.match($371e898df891458a$export$9c4772e191bdb810.NOT);
                    this.state = 203;
                    this.match($371e898df891458a$export$9c4772e191bdb810.IN);
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlChangedOperator() {
        let _localctx = new $371e898df891458a$export$493d626ed78ca66(this._ctx, this.state);
        this.enterRule(_localctx, 30, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlChangedOperator);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 206;
            this.match($371e898df891458a$export$9c4772e191bdb810.CHANGED);
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlField() {
        let _localctx = new $371e898df891458a$export$b33300c3d916229a(this._ctx, this.state);
        this.enterRule(_localctx, 32, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlField);
        let _la;
        try {
            this.state = 219;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $371e898df891458a$export$9c4772e191bdb810.POSNUMBER:
                case $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER:
                    _localctx = new $371e898df891458a$export$11fec15307d2e17b(_localctx);
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 208;
                    this.jqlNumber();
                    break;
                case $371e898df891458a$export$9c4772e191bdb810.CUSTOMFIELD:
                case $371e898df891458a$export$9c4772e191bdb810.STRING:
                case $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING:
                case $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING:
                    _localctx = new $371e898df891458a$export$b8b24f99f985ebb3(_localctx);
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 211;
                    this._errHandler.sync(this);
                    switch(this._input.LA(1)){
                        case $371e898df891458a$export$9c4772e191bdb810.STRING:
                        case $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING:
                        case $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING:
                            this.state = 209;
                            this.jqlString();
                            break;
                        case $371e898df891458a$export$9c4772e191bdb810.CUSTOMFIELD:
                            this.state = 210;
                            this.jqlCustomField();
                            break;
                        default:
                            throw new (0, $hKCjP.NoViableAltException)(this);
                    }
                    this.state = 216;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while(_la === $371e898df891458a$export$9c4772e191bdb810.LBRACKET){
                        this.state = 213;
                        this.jqlFieldProperty();
                        this.state = 218;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
                default:
                    throw new (0, $hKCjP.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlFieldProperty() {
        let _localctx = new $371e898df891458a$export$b02d0b6637ce0593(this._ctx, this.state);
        this.enterRule(_localctx, 34, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlFieldProperty);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 221;
            this.match($371e898df891458a$export$9c4772e191bdb810.LBRACKET);
            this.state = 222;
            this.jqlArgument();
            this.state = 223;
            this.match($371e898df891458a$export$9c4772e191bdb810.RBRACKET);
            this.state = 228;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while((_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $371e898df891458a$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.STRING - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0){
                this.state = 225;
                this.jqlPropertyArgument();
                this.state = 230;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlCustomField() {
        let _localctx = new $371e898df891458a$export$401a038855cc5b15(this._ctx, this.state);
        this.enterRule(_localctx, 36, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlCustomField);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 231;
            this.match($371e898df891458a$export$9c4772e191bdb810.CUSTOMFIELD);
            this.state = 232;
            this.match($371e898df891458a$export$9c4772e191bdb810.LBRACKET);
            this.state = 233;
            this.match($371e898df891458a$export$9c4772e191bdb810.POSNUMBER);
            this.state = 234;
            this.match($371e898df891458a$export$9c4772e191bdb810.RBRACKET);
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlString() {
        let _localctx = new $371e898df891458a$export$bde73d8ad7c8b71e(this._ctx, this.state);
        this.enterRule(_localctx, 38, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlString);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 236;
            _la = this._input.LA(1);
            if (!((_la - 37 & -32) === 0 && (1 << _la - 37 & (1 << $371e898df891458a$export$9c4772e191bdb810.STRING - 37 | 1 << $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING - 37 | 1 << $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING - 37)) !== 0)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlNumber() {
        let _localctx = new $371e898df891458a$export$8737d94a1880e8b3(this._ctx, this.state);
        this.enterRule(_localctx, 40, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlNumber);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 238;
            _localctx._jqlNum = this._input.LT(1);
            _la = this._input.LA(1);
            if (!(_la === $371e898df891458a$export$9c4772e191bdb810.POSNUMBER || _la === $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER)) _localctx._jqlNum = this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlOperand() {
        let _localctx = new $371e898df891458a$export$2eaac5a9828bf647(this._ctx, this.state);
        this.enterRule(_localctx, 42, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlOperand);
        try {
            this.state = 244;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 23, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 240;
                    this.jqlEmpty();
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 241;
                    this.jqlValue();
                    break;
                case 3:
                    this.enterOuterAlt(_localctx, 3);
                    this.state = 242;
                    this.jqlFunction();
                    break;
                case 4:
                    this.enterOuterAlt(_localctx, 4);
                    this.state = 243;
                    this.jqlList();
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlEmpty() {
        let _localctx = new $371e898df891458a$export$d85a062f90025e5c(this._ctx, this.state);
        this.enterRule(_localctx, 44, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlEmpty);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 246;
            this.match($371e898df891458a$export$9c4772e191bdb810.EMPTY);
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlValue() {
        let _localctx = new $371e898df891458a$export$2e17d457b0933bec(this._ctx, this.state);
        this.enterRule(_localctx, 46, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlValue);
        try {
            this.state = 250;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $371e898df891458a$export$9c4772e191bdb810.STRING:
                case $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING:
                case $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 248;
                    this.jqlString();
                    break;
                case $371e898df891458a$export$9c4772e191bdb810.POSNUMBER:
                case $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 249;
                    this.jqlNumber();
                    break;
                default:
                    throw new (0, $hKCjP.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlFunction() {
        let _localctx = new $371e898df891458a$export$ebf0cc785e9ee41a(this._ctx, this.state);
        this.enterRule(_localctx, 48, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlFunction);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 252;
            this.jqlFunctionName();
            this.state = 253;
            this.match($371e898df891458a$export$9c4772e191bdb810.LPAREN);
            this.state = 255;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if ((_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $371e898df891458a$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.STRING - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0) {
                this.state = 254;
                this.jqlArgumentList();
            }
            this.state = 257;
            this.match($371e898df891458a$export$9c4772e191bdb810.RPAREN);
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlFunctionName() {
        let _localctx = new $371e898df891458a$export$1f5f7ac816788f44(this._ctx, this.state);
        this.enterRule(_localctx, 50, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlFunctionName);
        try {
            this.state = 261;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $371e898df891458a$export$9c4772e191bdb810.STRING:
                case $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING:
                case $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 259;
                    this.jqlString();
                    break;
                case $371e898df891458a$export$9c4772e191bdb810.POSNUMBER:
                case $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 260;
                    this.jqlNumber();
                    break;
                default:
                    throw new (0, $hKCjP.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlArgumentList() {
        let _localctx = new $371e898df891458a$export$83d7c13849b931c3(this._ctx, this.state);
        this.enterRule(_localctx, 52, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlArgumentList);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 263;
            this.jqlArgument();
            this.state = 268;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $371e898df891458a$export$9c4772e191bdb810.COMMA){
                this.state = 264;
                this.match($371e898df891458a$export$9c4772e191bdb810.COMMA);
                this.state = 265;
                this.jqlArgument();
                this.state = 270;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlList() {
        let _localctx = new $371e898df891458a$export$9cb97a63f2be4864(this._ctx, this.state);
        this.enterRule(_localctx, 54, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlList);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 271;
            this.jqlListStart();
            this.state = 272;
            this.jqlOperand();
            this.state = 277;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $371e898df891458a$export$9c4772e191bdb810.COMMA){
                this.state = 273;
                this.match($371e898df891458a$export$9c4772e191bdb810.COMMA);
                this.state = 274;
                this.jqlOperand();
                this.state = 279;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
            this.state = 280;
            this.jqlListEnd();
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlListStart() {
        let _localctx = new $371e898df891458a$export$c419f717bfc46a5d(this._ctx, this.state);
        this.enterRule(_localctx, 56, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlListStart);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 282;
            this.match($371e898df891458a$export$9c4772e191bdb810.LPAREN);
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlListEnd() {
        let _localctx = new $371e898df891458a$export$f6cd3e372f5ab120(this._ctx, this.state);
        this.enterRule(_localctx, 58, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlListEnd);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 284;
            this.match($371e898df891458a$export$9c4772e191bdb810.RPAREN);
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlPropertyArgument() {
        let _localctx = new $371e898df891458a$export$e20ce4a2ed16372c(this._ctx, this.state);
        this.enterRule(_localctx, 60, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlPropertyArgument);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 286;
            this.jqlArgument();
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlArgument() {
        let _localctx = new $371e898df891458a$export$a95583953c237f88(this._ctx, this.state);
        this.enterRule(_localctx, 62, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlArgument);
        try {
            this.state = 290;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $371e898df891458a$export$9c4772e191bdb810.STRING:
                case $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING:
                case $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 288;
                    this.jqlString();
                    break;
                case $371e898df891458a$export$9c4772e191bdb810.POSNUMBER:
                case $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 289;
                    this.jqlNumber();
                    break;
                default:
                    throw new (0, $hKCjP.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWasPredicate() {
        let _localctx = new $371e898df891458a$export$9fa1e4d63f31b911(this._ctx, this.state);
        this.enterRule(_localctx, 64, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlWasPredicate);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 295;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $371e898df891458a$export$9c4772e191bdb810.BEFORE:
                case $371e898df891458a$export$9c4772e191bdb810.AFTER:
                case $371e898df891458a$export$9c4772e191bdb810.ON:
                    this.state = 292;
                    this.jqlDatePredicateOperator();
                    break;
                case $371e898df891458a$export$9c4772e191bdb810.DURING:
                    this.state = 293;
                    this.jqlDateRangePredicateOperator();
                    break;
                case $371e898df891458a$export$9c4772e191bdb810.BY:
                    this.state = 294;
                    this.jqlUserPredicateOperator();
                    break;
                default:
                    throw new (0, $hKCjP.NoViableAltException)(this);
            }
            this.state = 297;
            this.jqlPredicateOperand();
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlChangedPredicate() {
        let _localctx = new $371e898df891458a$export$e77e479a48133015(this._ctx, this.state);
        this.enterRule(_localctx, 66, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlChangedPredicate);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 303;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $371e898df891458a$export$9c4772e191bdb810.BEFORE:
                case $371e898df891458a$export$9c4772e191bdb810.AFTER:
                case $371e898df891458a$export$9c4772e191bdb810.ON:
                    this.state = 299;
                    this.jqlDatePredicateOperator();
                    break;
                case $371e898df891458a$export$9c4772e191bdb810.DURING:
                    this.state = 300;
                    this.jqlDateRangePredicateOperator();
                    break;
                case $371e898df891458a$export$9c4772e191bdb810.BY:
                    this.state = 301;
                    this.jqlUserPredicateOperator();
                    break;
                case $371e898df891458a$export$9c4772e191bdb810.FROM:
                case $371e898df891458a$export$9c4772e191bdb810.TO:
                    this.state = 302;
                    this.jqlValuePredicateOperator();
                    break;
                default:
                    throw new (0, $hKCjP.NoViableAltException)(this);
            }
            this.state = 305;
            this.jqlPredicateOperand();
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlDatePredicateOperator() {
        let _localctx = new $371e898df891458a$export$dc01290aee731418(this._ctx, this.state);
        this.enterRule(_localctx, 68, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlDatePredicateOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 307;
            _la = this._input.LA(1);
            if (!((_la & -32) === 0 && (1 << _la & (1 << $371e898df891458a$export$9c4772e191bdb810.BEFORE | 1 << $371e898df891458a$export$9c4772e191bdb810.AFTER | 1 << $371e898df891458a$export$9c4772e191bdb810.ON)) !== 0)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlDateRangePredicateOperator() {
        let _localctx = new $371e898df891458a$export$75412b8b6a6442e1(this._ctx, this.state);
        this.enterRule(_localctx, 70, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlDateRangePredicateOperator);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 309;
            this.match($371e898df891458a$export$9c4772e191bdb810.DURING);
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlUserPredicateOperator() {
        let _localctx = new $371e898df891458a$export$ad402332075c8656(this._ctx, this.state);
        this.enterRule(_localctx, 72, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlUserPredicateOperator);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 311;
            this.match($371e898df891458a$export$9c4772e191bdb810.BY);
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlValuePredicateOperator() {
        let _localctx = new $371e898df891458a$export$4239d7c0fbafd3f1(this._ctx, this.state);
        this.enterRule(_localctx, 74, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlValuePredicateOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 313;
            _la = this._input.LA(1);
            if (!(_la === $371e898df891458a$export$9c4772e191bdb810.FROM || _la === $371e898df891458a$export$9c4772e191bdb810.TO)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlPredicateOperand() {
        let _localctx = new $371e898df891458a$export$6b796c5a4b8c18e(this._ctx, this.state);
        this.enterRule(_localctx, 76, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlPredicateOperand);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 315;
            this.jqlOperand();
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlOrderBy() {
        let _localctx = new $371e898df891458a$export$534469b9c8f44139(this._ctx, this.state);
        this.enterRule(_localctx, 78, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlOrderBy);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 317;
            this.match($371e898df891458a$export$9c4772e191bdb810.ORDER);
            this.state = 318;
            this.match($371e898df891458a$export$9c4772e191bdb810.BY);
            this.state = 319;
            this.jqlSearchSort();
            this.state = 324;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $371e898df891458a$export$9c4772e191bdb810.COMMA){
                this.state = 320;
                this.match($371e898df891458a$export$9c4772e191bdb810.COMMA);
                this.state = 321;
                this.jqlSearchSort();
                this.state = 326;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlSearchSort() {
        let _localctx = new $371e898df891458a$export$c7d8f03f36952a46(this._ctx, this.state);
        this.enterRule(_localctx, 80, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlSearchSort);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 327;
            this.jqlField();
            this.state = 329;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if (_la === $371e898df891458a$export$9c4772e191bdb810.ASC || _la === $371e898df891458a$export$9c4772e191bdb810.DESC) {
                this.state = 328;
                _la = this._input.LA(1);
                if (!(_la === $371e898df891458a$export$9c4772e191bdb810.ASC || _la === $371e898df891458a$export$9c4772e191bdb810.DESC)) this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    static{
        this._serializedATN = '\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x030\u014E\x04\x02	\x02\x04\x03	\x03\x04\x04	\x04\x04\x05	\x05\x04\x06	\x06\x04\x07	\x07\x04\b	\b\x04			\x04\n	\n\x04\v	\v\x04\f	\f\x04\r	\r\x04\x0e	\x0e\x04\x0f	\x0f\x04\x10	\x10\x04\x11	\x11\x04\x12	\x12\x04\x13	\x13\x04\x14	\x14\x04\x15	\x15\x04\x16	\x16\x04\x17	\x17\x04\x18	\x18\x04\x19	\x19\x04\x1a	\x1a\x04\x1b	\x1b\x04\x1c	\x1c\x04\x1d	\x1d\x04\x1e	\x1e\x04\x1f	\x1f\x04 	 \x04!	!\x04"	"\x04#	#\x04$	$\x04%	%\x04&	&\x04\'	\'\x04(	(\x04)	)\x04*	*\x03\x02\x05\x02V\n\x02\x03\x02\x05\x02Y\n\x02\x03\x02\x03\x02\x03\x03\x03\x03\x03\x04\x03\x04\x03\x04\x07\x04b\n\x04\f\x04\x0e\x04e\v\x04\x03\x05\x03\x05\x03\x05\x07\x05j\n\x05\f\x05\x0e\x05m\v\x05\x03\x06\x03\x06\x03\x06\x03\x06\x05\x06s\n\x06\x03\x07\x03\x07\x03\x07\x03\x07\x03\b\x03\b\x03\b\x03	\x03	\x03	\x03	\x05	\x80\n	\x03	\x03	\x03	\x03	\x05	\x86\n	\x03	\x03	\x03	\x05	\x8b\n	\x03	\x03	\x03	\x05	\x90\n	\x03	\x03	\x03	\x03	\x03	\x03	\x03	\x05	\x99\n	\x03	\x07	\x9c\n	\f	\x0e	\x9f\v	\x03	\x03	\x03	\x05	\xa4\n	\x03	\x07	\xa7\n	\f	\x0e	\xaa\v	\x03	\x03	\x07	\xae\n	\f	\x0e	\xb1\v	\x05	\xb3\n	\x03\n\x03\n\x03\v\x03\v\x03\f\x03\f\x03\r\x03\r\x03\r\x05\r\xbe\n\r\x03\x0e\x03\x0e\x03\x0e\x05\x0e\xc3\n\x0e\x03\x0f\x03\x0f\x03\x0f\x05\x0f\xc8\n\x0f\x03\x10\x03\x10\x03\x10\x03\x10\x03\x10\x05\x10\xcf\n\x10\x03\x11\x03\x11\x03\x12\x03\x12\x03\x12\x05\x12\xd6\n\x12\x03\x12\x07\x12\xd9\n\x12\f\x12\x0e\x12\xdc\v\x12\x05\x12\xde\n\x12\x03\x13\x03\x13\x03\x13\x03\x13\x03\x13\x07\x13\xe5\n\x13\f\x13\x0e\x13\xe8\v\x13\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x03\x15\x03\x15\x03\x16\x03\x16\x03\x17\x03\x17\x03\x17\x03\x17\x05\x17\xf7\n\x17\x03\x18\x03\x18\x03\x19\x03\x19\x05\x19\xfd\n\x19\x03\x1a\x03\x1a\x03\x1a\x05\x1a\u0102\n\x1a\x03\x1a\x03\x1a\x03\x1b\x03\x1b\x05\x1b\u0108\n\x1b\x03\x1c\x03\x1c\x03\x1c\x07\x1c\u010D\n\x1c\f\x1c\x0e\x1c\u0110\v\x1c\x03\x1d\x03\x1d\x03\x1d\x03\x1d\x07\x1d\u0116\n\x1d\f\x1d\x0e\x1d\u0119\v\x1d\x03\x1d\x03\x1d\x03\x1e\x03\x1e\x03\x1f\x03\x1f\x03 \x03 \x03!\x03!\x05!\u0125\n!\x03"\x03"\x03"\x05"\u012A\n"\x03"\x03"\x03#\x03#\x03#\x03#\x05#\u0132\n#\x03#\x03#\x03$\x03$\x03%\x03%\x03&\x03&\x03\'\x03\'\x03(\x03(\x03)\x03)\x03)\x03)\x03)\x07)\u0145\n)\f)\x0e)\u0148\v)\x03*\x03*\x05*\u014C\n*\x03*\x02\x02\x02+\x02\x02\x04\x02\x06\x02\b\x02\n\x02\f\x02\x0e\x02\x10\x02\x12\x02\x14\x02\x16\x02\x18\x02\x1a\x02\x1c\x02\x1e\x02 \x02"\x02$\x02&\x02(\x02*\x02,\x02.\x020\x022\x024\x026\x028\x02:\x02<\x02>\x02@\x02B\x02D\x02F\x02H\x02J\x02L\x02N\x02P\x02R\x02\x02\v\x04\x02\b\b\x15\x15\x03\x02\r\x0e\x03\x02\x0f\x10\x03\x02	\f\x05\x02\'\'++..\x03\x02#$\x04\x02\x19\x1a\x1d\x1d\x03\x02\x1b\x1c\x03\x02!"\x02\u0155\x02U\x03\x02\x02\x02\x04\\\x03\x02\x02\x02\x06^\x03\x02\x02\x02\bf\x03\x02\x02\x02\nr\x03\x02\x02\x02\ft\x03\x02\x02\x02\x0ex\x03\x02\x02\x02\x10\xb2\x03\x02\x02\x02\x12\xb4\x03\x02\x02\x02\x14\xb6\x03\x02\x02\x02\x16\xb8\x03\x02\x02\x02\x18\xbd\x03\x02\x02\x02\x1a\xc2\x03\x02\x02\x02\x1c\xc7\x03\x02\x02\x02\x1e\xce\x03\x02\x02\x02 \xd0\x03\x02\x02\x02"\xdd\x03\x02\x02\x02$\xdf\x03\x02\x02\x02&\xe9\x03\x02\x02\x02(\xee\x03\x02\x02\x02*\xf0\x03\x02\x02\x02,\xf6\x03\x02\x02\x02.\xf8\x03\x02\x02\x020\xfc\x03\x02\x02\x022\xfe\x03\x02\x02\x024\u0107\x03\x02\x02\x026\u0109\x03\x02\x02\x028\u0111\x03\x02\x02\x02:\u011C\x03\x02\x02\x02<\u011E\x03\x02\x02\x02>\u0120\x03\x02\x02\x02@\u0124\x03\x02\x02\x02B\u0129\x03\x02\x02\x02D\u0131\x03\x02\x02\x02F\u0135\x03\x02\x02\x02H\u0137\x03\x02\x02\x02J\u0139\x03\x02\x02\x02L\u013B\x03\x02\x02\x02N\u013D\x03\x02\x02\x02P\u013F\x03\x02\x02\x02R\u0149\x03\x02\x02\x02TV\x05\x04\x03\x02UT\x03\x02\x02\x02UV\x03\x02\x02\x02VX\x03\x02\x02\x02WY\x05P)\x02XW\x03\x02\x02\x02XY\x03\x02\x02\x02YZ\x03\x02\x02\x02Z[\x07\x02\x02\x03[\x03\x03\x02\x02\x02\\]\x05\x06\x04\x02]\x05\x03\x02\x02\x02^c\x05\b\x05\x02_`\x07\x14\x02\x02`b\x05\b\x05\x02a_\x03\x02\x02\x02be\x03\x02\x02\x02ca\x03\x02\x02\x02cd\x03\x02\x02\x02d\x07\x03\x02\x02\x02ec\x03\x02\x02\x02fk\x05\n\x06\x02gh\x07\x13\x02\x02hj\x05\n\x06\x02ig\x03\x02\x02\x02jm\x03\x02\x02\x02ki\x03\x02\x02\x02kl\x03\x02\x02\x02l	\x03\x02\x02\x02mk\x03\x02\x02\x02no	\x02\x02\x02os\x05\n\x06\x02ps\x05\f\x07\x02qs\x05\x0e\b\x02rn\x03\x02\x02\x02rp\x03\x02\x02\x02rq\x03\x02\x02\x02s\v\x03\x02\x02\x02tu\x07\x03\x02\x02uv\x05\x06\x04\x02vw\x07\x04\x02\x02w\r\x03\x02\x02\x02xy\x05"\x12\x02yz\x05\x10	\x02z\x0f\x03\x02\x02\x02{\x7f\x05\x12\n\x02|\x80\x05.\x18\x02}\x80\x050\x19\x02~\x80\x052\x1a\x02\x7f|\x03\x02\x02\x02\x7f}\x03\x02\x02\x02\x7f~\x03\x02\x02\x02\x80\xb3\x03\x02\x02\x02\x81\x85\x05\x14\v\x02\x82\x86\x05.\x18\x02\x83\x86\x050\x19\x02\x84\x86\x052\x1a\x02\x85\x82\x03\x02\x02\x02\x85\x83\x03\x02\x02\x02\x85\x84\x03\x02\x02\x02\x86\xb3\x03\x02\x02\x02\x87\x8a\x05\x16\f\x02\x88\x8b\x050\x19\x02\x89\x8b\x052\x1a\x02\x8a\x88\x03\x02\x02\x02\x8a\x89\x03\x02\x02\x02\x8b\xb3\x03\x02\x02\x02\x8c\x8f\x05\x18\r\x02\x8d\x90\x058\x1d\x02\x8e\x90\x052\x1a\x02\x8f\x8d\x03\x02\x02\x02\x8f\x8e\x03\x02\x02\x02\x90\xb3\x03\x02\x02\x02\x91\x92\x05\x1a\x0e\x02\x92\x93\x05.\x18\x02\x93\xb3\x03\x02\x02\x02\x94\x98\x05\x1c\x0f\x02\x95\x99\x05.\x18\x02\x96\x99\x050\x19\x02\x97\x99\x052\x1a\x02\x98\x95\x03\x02\x02\x02\x98\x96\x03\x02\x02\x02\x98\x97\x03\x02\x02\x02\x99\x9d\x03\x02\x02\x02\x9a\x9c\x05B"\x02\x9b\x9a\x03\x02\x02\x02\x9c\x9f\x03\x02\x02\x02\x9d\x9b\x03\x02\x02\x02\x9d\x9e\x03\x02\x02\x02\x9e\xb3\x03\x02\x02\x02\x9f\x9d\x03\x02\x02\x02\xa0\xa3\x05\x1e\x10\x02\xa1\xa4\x058\x1d\x02\xa2\xa4\x052\x1a\x02\xa3\xa1\x03\x02\x02\x02\xa3\xa2\x03\x02\x02\x02\xa4\xa8\x03\x02\x02\x02\xa5\xa7\x05B"\x02\xa6\xa5\x03\x02\x02\x02\xa7\xaa\x03\x02\x02\x02\xa8\xa6\x03\x02\x02\x02\xa8\xa9\x03\x02\x02\x02\xa9\xb3\x03\x02\x02\x02\xaa\xa8\x03\x02\x02\x02\xab\xaf\x05 \x11\x02\xac\xae\x05D#\x02\xad\xac\x03\x02\x02\x02\xae\xb1\x03\x02\x02\x02\xaf\xad\x03\x02\x02\x02\xaf\xb0\x03\x02\x02\x02\xb0\xb3\x03\x02\x02\x02\xb1\xaf\x03\x02\x02\x02\xb2{\x03\x02\x02\x02\xb2\x81\x03\x02\x02\x02\xb2\x87\x03\x02\x02\x02\xb2\x8c\x03\x02\x02\x02\xb2\x91\x03\x02\x02\x02\xb2\x94\x03\x02\x02\x02\xb2\xa0\x03\x02\x02\x02\xb2\xab\x03\x02\x02\x02\xb3\x11\x03\x02\x02\x02\xb4\xb5	\x03\x02\x02\xb5\x13\x03\x02\x02\x02\xb6\xb7	\x04\x02\x02\xb7\x15\x03\x02\x02\x02\xb8\xb9	\x05\x02\x02\xb9\x17\x03\x02\x02\x02\xba\xbe\x07\x11\x02\x02\xbb\xbc\x07\x15\x02\x02\xbc\xbe\x07\x11\x02\x02\xbd\xba\x03\x02\x02\x02\xbd\xbb\x03\x02\x02\x02\xbe\x19\x03\x02\x02\x02\xbf\xc3\x07\x12\x02\x02\xc0\xc1\x07\x12\x02\x02\xc1\xc3\x07\x15\x02\x02\xc2\xbf\x03\x02\x02\x02\xc2\xc0\x03\x02\x02\x02\xc3\x1b\x03\x02\x02\x02\xc4\xc8\x07\x17\x02\x02\xc5\xc6\x07\x17\x02\x02\xc6\xc8\x07\x15\x02\x02\xc7\xc4\x03\x02\x02\x02\xc7\xc5\x03\x02\x02\x02\xc8\x1d\x03\x02\x02\x02\xc9\xca\x07\x17\x02\x02\xca\xcf\x07\x11\x02\x02\xcb\xcc\x07\x17\x02\x02\xcc\xcd\x07\x15\x02\x02\xcd\xcf\x07\x11\x02\x02\xce\xc9\x03\x02\x02\x02\xce\xcb\x03\x02\x02\x02\xcf\x1f\x03\x02\x02\x02\xd0\xd1\x07\x18\x02\x02\xd1!\x03\x02\x02\x02\xd2\xde\x05*\x16\x02\xd3\xd6\x05(\x15\x02\xd4\xd6\x05&\x14\x02\xd5\xd3\x03\x02\x02\x02\xd5\xd4\x03\x02\x02\x02\xd6\xda\x03\x02\x02\x02\xd7\xd9\x05$\x13\x02\xd8\xd7\x03\x02\x02\x02\xd9\xdc\x03\x02\x02\x02\xda\xd8\x03\x02\x02\x02\xda\xdb\x03\x02\x02\x02\xdb\xde\x03\x02\x02\x02\xdc\xda\x03\x02\x02\x02\xdd\xd2\x03\x02\x02\x02\xdd\xd5\x03\x02\x02\x02\xde#\x03\x02\x02\x02\xdf\xe0\x07\x06\x02\x02\xe0\xe1\x05@!\x02\xe1\xe2\x07\x07\x02\x02\xe2\xe6\x03\x02\x02\x02\xe3\xe5\x05> \x02\xe4\xe3\x03\x02\x02\x02\xe5\xe8\x03\x02\x02\x02\xe6\xe4\x03\x02\x02\x02\xe6\xe7\x03\x02\x02\x02\xe7%\x03\x02\x02\x02\xe8\xe6\x03\x02\x02\x02\xe9\xea\x07%\x02\x02\xea\xeb\x07\x06\x02\x02\xeb\xec\x07#\x02\x02\xec\xed\x07\x07\x02\x02\xed\'\x03\x02\x02\x02\xee\xef	\x06\x02\x02\xef)\x03\x02\x02\x02\xf0\xf1	\x07\x02\x02\xf1+\x03\x02\x02\x02\xf2\xf7\x05.\x18\x02\xf3\xf7\x050\x19\x02\xf4\xf7\x052\x1a\x02\xf5\xf7\x058\x1d\x02\xf6\xf2\x03\x02\x02\x02\xf6\xf3\x03\x02\x02\x02\xf6\xf4\x03\x02\x02\x02\xf6\xf5\x03\x02\x02\x02\xf7-\x03\x02\x02\x02\xf8\xf9\x07\x16\x02\x02\xf9/\x03\x02\x02\x02\xfa\xfd\x05(\x15\x02\xfb\xfd\x05*\x16\x02\xfc\xfa\x03\x02\x02\x02\xfc\xfb\x03\x02\x02\x02\xfd1\x03\x02\x02\x02\xfe\xff\x054\x1b\x02\xff\u0101\x07\x03\x02\x02\u0100\u0102\x056\x1c\x02\u0101\u0100\x03\x02\x02\x02\u0101\u0102\x03\x02\x02\x02\u0102\u0103\x03\x02\x02\x02\u0103\u0104\x07\x04\x02\x02\u01043\x03\x02\x02\x02\u0105\u0108\x05(\x15\x02\u0106\u0108\x05*\x16\x02\u0107\u0105\x03\x02\x02\x02\u0107\u0106\x03\x02\x02\x02\u01085\x03\x02\x02\x02\u0109\u010E\x05@!\x02\u010A\u010B\x07\x05\x02\x02\u010B\u010D\x05@!\x02\u010C\u010A\x03\x02\x02\x02\u010D\u0110\x03\x02\x02\x02\u010E\u010C\x03\x02\x02\x02\u010E\u010F\x03\x02\x02\x02\u010F7\x03\x02\x02\x02\u0110\u010E\x03\x02\x02\x02\u0111\u0112\x05:\x1e\x02\u0112\u0117\x05,\x17\x02\u0113\u0114\x07\x05\x02\x02\u0114\u0116\x05,\x17\x02\u0115\u0113\x03\x02\x02\x02\u0116\u0119\x03\x02\x02\x02\u0117\u0115\x03\x02\x02\x02\u0117\u0118\x03\x02\x02\x02\u0118\u011A\x03\x02\x02\x02\u0119\u0117\x03\x02\x02\x02\u011A\u011B\x05<\x1f\x02\u011B9\x03\x02\x02\x02\u011C\u011D\x07\x03\x02\x02\u011D;\x03\x02\x02\x02\u011E\u011F\x07\x04\x02\x02\u011F=\x03\x02\x02\x02\u0120\u0121\x05@!\x02\u0121?\x03\x02\x02\x02\u0122\u0125\x05(\x15\x02\u0123\u0125\x05*\x16\x02\u0124\u0122\x03\x02\x02\x02\u0124\u0123\x03\x02\x02\x02\u0125A\x03\x02\x02\x02\u0126\u012A\x05F$\x02\u0127\u012A\x05H%\x02\u0128\u012A\x05J&\x02\u0129\u0126\x03\x02\x02\x02\u0129\u0127\x03\x02\x02\x02\u0129\u0128\x03\x02\x02\x02\u012A\u012B\x03\x02\x02\x02\u012B\u012C\x05N(\x02\u012CC\x03\x02\x02\x02\u012D\u0132\x05F$\x02\u012E\u0132\x05H%\x02\u012F\u0132\x05J&\x02\u0130\u0132\x05L\'\x02\u0131\u012D\x03\x02\x02\x02\u0131\u012E\x03\x02\x02\x02\u0131\u012F\x03\x02\x02\x02\u0131\u0130\x03\x02\x02\x02\u0132\u0133\x03\x02\x02\x02\u0133\u0134\x05N(\x02\u0134E\x03\x02\x02\x02\u0135\u0136	\b\x02\x02\u0136G\x03\x02\x02\x02\u0137\u0138\x07\x1e\x02\x02\u0138I\x03\x02\x02\x02\u0139\u013A\x07 \x02\x02\u013AK\x03\x02\x02\x02\u013B\u013C		\x02\x02\u013CM\x03\x02\x02\x02\u013D\u013E\x05,\x17\x02\u013EO\x03\x02\x02\x02\u013F\u0140\x07\x1f\x02\x02\u0140\u0141\x07 \x02\x02\u0141\u0146\x05R*\x02\u0142\u0143\x07\x05\x02\x02\u0143\u0145\x05R*\x02\u0144\u0142\x03\x02\x02\x02\u0145\u0148\x03\x02\x02\x02\u0146\u0144\x03\x02\x02\x02\u0146\u0147\x03\x02\x02\x02\u0147Q\x03\x02\x02\x02\u0148\u0146\x03\x02\x02\x02\u0149\u014B\x05"\x12\x02\u014A\u014C	\n\x02\x02\u014B\u014A\x03\x02\x02\x02\u014B\u014C\x03\x02\x02\x02\u014CS\x03\x02\x02\x02$UXckr\x7f\x85\x8a\x8f\x98\x9d\xa3\xa8\xaf\xb2\xbd\xc2\xc7\xce\xd5\xda\xdd\xe6\xf6\xfc\u0101\u0107\u010E\u0117\u0124\u0129\u0131\u0146\u014B';
    }
    static get _ATN() {
        if (!$371e898df891458a$export$9c4772e191bdb810.__ATN) $371e898df891458a$export$9c4772e191bdb810.__ATN = new (0, $dvgsl.ATNDeserializer)().deserialize($2IEP9.toCharArray($371e898df891458a$export$9c4772e191bdb810._serializedATN));
        return $371e898df891458a$export$9c4772e191bdb810.__ATN;
    }
}
class $371e898df891458a$export$ff413535b9575c8 extends (0, $6bmaO.ParserRuleContext) {
    EOF() {
        return this.getToken($371e898df891458a$export$9c4772e191bdb810.EOF, 0);
    }
    jqlWhere() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$4148a879cab28017);
    }
    jqlOrderBy() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$534469b9c8f44139);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlQuery;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlQuery) listener.enterJqlQuery(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlQuery) listener.exitJqlQuery(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlQuery) return visitor.visitJqlQuery(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$4148a879cab28017 extends (0, $6bmaO.ParserRuleContext) {
    jqlOrClause() {
        return this.getRuleContext(0, $371e898df891458a$export$d69831d387793480);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlWhere;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWhere) listener.enterJqlWhere(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWhere) listener.exitJqlWhere(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWhere) return visitor.visitJqlWhere(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$d69831d387793480 extends (0, $6bmaO.ParserRuleContext) {
    jqlAndClause(i) {
        if (i === undefined) return this.getRuleContexts($371e898df891458a$export$f16819001158b9e);
        else return this.getRuleContext(i, $371e898df891458a$export$f16819001158b9e);
    }
    OR(i) {
        if (i === undefined) return this.getTokens($371e898df891458a$export$9c4772e191bdb810.OR);
        else return this.getToken($371e898df891458a$export$9c4772e191bdb810.OR, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlOrClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlOrClause) listener.enterJqlOrClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlOrClause) listener.exitJqlOrClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlOrClause) return visitor.visitJqlOrClause(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$f16819001158b9e extends (0, $6bmaO.ParserRuleContext) {
    jqlNotClause(i) {
        if (i === undefined) return this.getRuleContexts($371e898df891458a$export$5e9146f8d5cf1330);
        else return this.getRuleContext(i, $371e898df891458a$export$5e9146f8d5cf1330);
    }
    AND(i) {
        if (i === undefined) return this.getTokens($371e898df891458a$export$9c4772e191bdb810.AND);
        else return this.getToken($371e898df891458a$export$9c4772e191bdb810.AND, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlAndClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlAndClause) listener.enterJqlAndClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlAndClause) listener.exitJqlAndClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlAndClause) return visitor.visitJqlAndClause(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$5e9146f8d5cf1330 extends (0, $6bmaO.ParserRuleContext) {
    jqlNotClause() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$5e9146f8d5cf1330);
    }
    NOT() {
        return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.NOT, 0);
    }
    BANG() {
        return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.BANG, 0);
    }
    jqlSubClause() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$a136a0e9655bfb04);
    }
    jqlTerminalClause() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$23486a2f2ddd5bcd);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlNotClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNotClause) listener.enterJqlNotClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNotClause) listener.exitJqlNotClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNotClause) return visitor.visitJqlNotClause(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$a136a0e9655bfb04 extends (0, $6bmaO.ParserRuleContext) {
    LPAREN() {
        return this.getToken($371e898df891458a$export$9c4772e191bdb810.LPAREN, 0);
    }
    jqlOrClause() {
        return this.getRuleContext(0, $371e898df891458a$export$d69831d387793480);
    }
    RPAREN() {
        return this.getToken($371e898df891458a$export$9c4772e191bdb810.RPAREN, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlSubClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlSubClause) listener.enterJqlSubClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlSubClause) listener.exitJqlSubClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlSubClause) return visitor.visitJqlSubClause(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$23486a2f2ddd5bcd extends (0, $6bmaO.ParserRuleContext) {
    jqlField() {
        return this.getRuleContext(0, $371e898df891458a$export$b33300c3d916229a);
    }
    jqlTerminalClauseRhs() {
        return this.getRuleContext(0, $371e898df891458a$export$93924a205c12d32c);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlTerminalClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlTerminalClause) listener.enterJqlTerminalClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlTerminalClause) listener.exitJqlTerminalClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlTerminalClause) return visitor.visitJqlTerminalClause(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$93924a205c12d32c extends (0, $6bmaO.ParserRuleContext) {
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlTerminalClauseRhs;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
class $371e898df891458a$export$c428f709a58396e5 extends $371e898df891458a$export$93924a205c12d32c {
    jqlEqualsOperator() {
        return this.getRuleContext(0, $371e898df891458a$export$41e475fc1988e413);
    }
    jqlEmpty() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$ebf0cc785e9ee41a);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlEqualsClause) listener.enterJqlEqualsClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlEqualsClause) listener.exitJqlEqualsClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlEqualsClause) return visitor.visitJqlEqualsClause(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$1b131204ef9fa33d extends $371e898df891458a$export$93924a205c12d32c {
    jqlLikeOperator() {
        return this.getRuleContext(0, $371e898df891458a$export$b76fe5387fdd7efd);
    }
    jqlEmpty() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$ebf0cc785e9ee41a);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlLikeClause) listener.enterJqlLikeClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlLikeClause) listener.exitJqlLikeClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlLikeClause) return visitor.visitJqlLikeClause(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$d83706ee80a9852a extends $371e898df891458a$export$93924a205c12d32c {
    jqlComparisonOperator() {
        return this.getRuleContext(0, $371e898df891458a$export$d821da0716b3ec95);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$ebf0cc785e9ee41a);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlComparisonClause) listener.enterJqlComparisonClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlComparisonClause) listener.exitJqlComparisonClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlComparisonClause) return visitor.visitJqlComparisonClause(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$2934b8ff22fddd2d extends $371e898df891458a$export$93924a205c12d32c {
    jqlInOperator() {
        return this.getRuleContext(0, $371e898df891458a$export$178478bfa8292f72);
    }
    jqlList() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$9cb97a63f2be4864);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$ebf0cc785e9ee41a);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlInClause) listener.enterJqlInClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlInClause) listener.exitJqlInClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlInClause) return visitor.visitJqlInClause(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$8b84310182afcf93 extends $371e898df891458a$export$93924a205c12d32c {
    jqlIsOperator() {
        return this.getRuleContext(0, $371e898df891458a$export$e64c31d2830b66e4);
    }
    jqlEmpty() {
        return this.getRuleContext(0, $371e898df891458a$export$d85a062f90025e5c);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlIsClause) listener.enterJqlIsClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlIsClause) listener.exitJqlIsClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlIsClause) return visitor.visitJqlIsClause(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$5df295dc7a2cac7c extends $371e898df891458a$export$93924a205c12d32c {
    jqlWasOperator() {
        return this.getRuleContext(0, $371e898df891458a$export$7e283636700e4a6c);
    }
    jqlEmpty() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$ebf0cc785e9ee41a);
    }
    jqlWasPredicate(i) {
        if (i === undefined) return this.getRuleContexts($371e898df891458a$export$9fa1e4d63f31b911);
        else return this.getRuleContext(i, $371e898df891458a$export$9fa1e4d63f31b911);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasClause) listener.enterJqlWasClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasClause) listener.exitJqlWasClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasClause) return visitor.visitJqlWasClause(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$9ac3367aee261b32 extends $371e898df891458a$export$93924a205c12d32c {
    jqlWasInOperator() {
        return this.getRuleContext(0, $371e898df891458a$export$b9118b1ed9a78d66);
    }
    jqlList() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$9cb97a63f2be4864);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$ebf0cc785e9ee41a);
    }
    jqlWasPredicate(i) {
        if (i === undefined) return this.getRuleContexts($371e898df891458a$export$9fa1e4d63f31b911);
        else return this.getRuleContext(i, $371e898df891458a$export$9fa1e4d63f31b911);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasInClause) listener.enterJqlWasInClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasInClause) listener.exitJqlWasInClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasInClause) return visitor.visitJqlWasInClause(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$7a7defca8628a13c extends $371e898df891458a$export$93924a205c12d32c {
    jqlChangedOperator() {
        return this.getRuleContext(0, $371e898df891458a$export$493d626ed78ca66);
    }
    jqlChangedPredicate(i) {
        if (i === undefined) return this.getRuleContexts($371e898df891458a$export$e77e479a48133015);
        else return this.getRuleContext(i, $371e898df891458a$export$e77e479a48133015);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlChangedClause) listener.enterJqlChangedClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlChangedClause) listener.exitJqlChangedClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlChangedClause) return visitor.visitJqlChangedClause(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$41e475fc1988e413 extends (0, $6bmaO.ParserRuleContext) {
    EQUALS() {
        return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.EQUALS, 0);
    }
    NOT_EQUALS() {
        return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.NOT_EQUALS, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlEqualsOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlEqualsOperator) listener.enterJqlEqualsOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlEqualsOperator) listener.exitJqlEqualsOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlEqualsOperator) return visitor.visitJqlEqualsOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$b76fe5387fdd7efd extends (0, $6bmaO.ParserRuleContext) {
    LIKE() {
        return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.LIKE, 0);
    }
    NOT_LIKE() {
        return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.NOT_LIKE, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlLikeOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlLikeOperator) listener.enterJqlLikeOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlLikeOperator) listener.exitJqlLikeOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlLikeOperator) return visitor.visitJqlLikeOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$d821da0716b3ec95 extends (0, $6bmaO.ParserRuleContext) {
    LT() {
        return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.LT, 0);
    }
    GT() {
        return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.GT, 0);
    }
    LTEQ() {
        return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.LTEQ, 0);
    }
    GTEQ() {
        return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.GTEQ, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlComparisonOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlComparisonOperator) listener.enterJqlComparisonOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlComparisonOperator) listener.exitJqlComparisonOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlComparisonOperator) return visitor.visitJqlComparisonOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$178478bfa8292f72 extends (0, $6bmaO.ParserRuleContext) {
    IN() {
        return this.getToken($371e898df891458a$export$9c4772e191bdb810.IN, 0);
    }
    NOT() {
        return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.NOT, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlInOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlInOperator) listener.enterJqlInOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlInOperator) listener.exitJqlInOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlInOperator) return visitor.visitJqlInOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$e64c31d2830b66e4 extends (0, $6bmaO.ParserRuleContext) {
    IS() {
        return this.getToken($371e898df891458a$export$9c4772e191bdb810.IS, 0);
    }
    NOT() {
        return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.NOT, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlIsOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlIsOperator) listener.enterJqlIsOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlIsOperator) listener.exitJqlIsOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlIsOperator) return visitor.visitJqlIsOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$7e283636700e4a6c extends (0, $6bmaO.ParserRuleContext) {
    WAS() {
        return this.getToken($371e898df891458a$export$9c4772e191bdb810.WAS, 0);
    }
    NOT() {
        return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.NOT, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlWasOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasOperator) listener.enterJqlWasOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasOperator) listener.exitJqlWasOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasOperator) return visitor.visitJqlWasOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$b9118b1ed9a78d66 extends (0, $6bmaO.ParserRuleContext) {
    WAS() {
        return this.getToken($371e898df891458a$export$9c4772e191bdb810.WAS, 0);
    }
    IN() {
        return this.getToken($371e898df891458a$export$9c4772e191bdb810.IN, 0);
    }
    NOT() {
        return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.NOT, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlWasInOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasInOperator) listener.enterJqlWasInOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasInOperator) listener.exitJqlWasInOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasInOperator) return visitor.visitJqlWasInOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$493d626ed78ca66 extends (0, $6bmaO.ParserRuleContext) {
    CHANGED() {
        return this.getToken($371e898df891458a$export$9c4772e191bdb810.CHANGED, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlChangedOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlChangedOperator) listener.enterJqlChangedOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlChangedOperator) listener.exitJqlChangedOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlChangedOperator) return visitor.visitJqlChangedOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$b33300c3d916229a extends (0, $6bmaO.ParserRuleContext) {
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlField;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
class $371e898df891458a$export$11fec15307d2e17b extends $371e898df891458a$export$b33300c3d916229a {
    jqlNumber() {
        return this.getRuleContext(0, $371e898df891458a$export$8737d94a1880e8b3);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNumberField) listener.enterJqlNumberField(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNumberField) listener.exitJqlNumberField(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNumberField) return visitor.visitJqlNumberField(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$b8b24f99f985ebb3 extends $371e898df891458a$export$b33300c3d916229a {
    jqlString() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$bde73d8ad7c8b71e);
    }
    jqlCustomField() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$401a038855cc5b15);
    }
    jqlFieldProperty(i) {
        if (i === undefined) return this.getRuleContexts($371e898df891458a$export$b02d0b6637ce0593);
        else return this.getRuleContext(i, $371e898df891458a$export$b02d0b6637ce0593);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNonNumberField) listener.enterJqlNonNumberField(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNonNumberField) listener.exitJqlNonNumberField(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNonNumberField) return visitor.visitJqlNonNumberField(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$b02d0b6637ce0593 extends (0, $6bmaO.ParserRuleContext) {
    LBRACKET() {
        return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.LBRACKET, 0);
    }
    RBRACKET() {
        return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.RBRACKET, 0);
    }
    jqlPropertyArgument(i) {
        if (i === undefined) return this.getRuleContexts($371e898df891458a$export$e20ce4a2ed16372c);
        else return this.getRuleContext(i, $371e898df891458a$export$e20ce4a2ed16372c);
    }
    jqlArgument() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$a95583953c237f88);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlFieldProperty;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlFieldProperty) listener.enterJqlFieldProperty(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlFieldProperty) listener.exitJqlFieldProperty(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlFieldProperty) return visitor.visitJqlFieldProperty(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$401a038855cc5b15 extends (0, $6bmaO.ParserRuleContext) {
    CUSTOMFIELD() {
        return this.getToken($371e898df891458a$export$9c4772e191bdb810.CUSTOMFIELD, 0);
    }
    LBRACKET() {
        return this.getToken($371e898df891458a$export$9c4772e191bdb810.LBRACKET, 0);
    }
    POSNUMBER() {
        return this.getToken($371e898df891458a$export$9c4772e191bdb810.POSNUMBER, 0);
    }
    RBRACKET() {
        return this.getToken($371e898df891458a$export$9c4772e191bdb810.RBRACKET, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlCustomField;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlCustomField) listener.enterJqlCustomField(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlCustomField) listener.exitJqlCustomField(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlCustomField) return visitor.visitJqlCustomField(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$bde73d8ad7c8b71e extends (0, $6bmaO.ParserRuleContext) {
    STRING() {
        return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.STRING, 0);
    }
    QUOTE_STRING() {
        return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING, 0);
    }
    SQUOTE_STRING() {
        return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlString;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlString) listener.enterJqlString(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlString) listener.exitJqlString(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlString) return visitor.visitJqlString(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$8737d94a1880e8b3 extends (0, $6bmaO.ParserRuleContext) {
    POSNUMBER() {
        return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.POSNUMBER, 0);
    }
    NEGNUMBER() {
        return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.NEGNUMBER, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlNumber;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNumber) listener.enterJqlNumber(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNumber) listener.exitJqlNumber(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNumber) return visitor.visitJqlNumber(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$2eaac5a9828bf647 extends (0, $6bmaO.ParserRuleContext) {
    jqlEmpty() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$ebf0cc785e9ee41a);
    }
    jqlList() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$9cb97a63f2be4864);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlOperand;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlOperand) listener.enterJqlOperand(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlOperand) listener.exitJqlOperand(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlOperand) return visitor.visitJqlOperand(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$d85a062f90025e5c extends (0, $6bmaO.ParserRuleContext) {
    EMPTY() {
        return this.getToken($371e898df891458a$export$9c4772e191bdb810.EMPTY, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlEmpty;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlEmpty) listener.enterJqlEmpty(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlEmpty) listener.exitJqlEmpty(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlEmpty) return visitor.visitJqlEmpty(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$2e17d457b0933bec extends (0, $6bmaO.ParserRuleContext) {
    jqlString() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$bde73d8ad7c8b71e);
    }
    jqlNumber() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$8737d94a1880e8b3);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlValue;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlValue) listener.enterJqlValue(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlValue) listener.exitJqlValue(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlValue) return visitor.visitJqlValue(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$ebf0cc785e9ee41a extends (0, $6bmaO.ParserRuleContext) {
    jqlFunctionName() {
        return this.getRuleContext(0, $371e898df891458a$export$1f5f7ac816788f44);
    }
    LPAREN() {
        return this.getToken($371e898df891458a$export$9c4772e191bdb810.LPAREN, 0);
    }
    RPAREN() {
        return this.getToken($371e898df891458a$export$9c4772e191bdb810.RPAREN, 0);
    }
    jqlArgumentList() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$83d7c13849b931c3);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlFunction;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlFunction) listener.enterJqlFunction(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlFunction) listener.exitJqlFunction(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlFunction) return visitor.visitJqlFunction(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$1f5f7ac816788f44 extends (0, $6bmaO.ParserRuleContext) {
    jqlString() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$bde73d8ad7c8b71e);
    }
    jqlNumber() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$8737d94a1880e8b3);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlFunctionName;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlFunctionName) listener.enterJqlFunctionName(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlFunctionName) listener.exitJqlFunctionName(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlFunctionName) return visitor.visitJqlFunctionName(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$83d7c13849b931c3 extends (0, $6bmaO.ParserRuleContext) {
    jqlArgument(i) {
        if (i === undefined) return this.getRuleContexts($371e898df891458a$export$a95583953c237f88);
        else return this.getRuleContext(i, $371e898df891458a$export$a95583953c237f88);
    }
    COMMA(i) {
        if (i === undefined) return this.getTokens($371e898df891458a$export$9c4772e191bdb810.COMMA);
        else return this.getToken($371e898df891458a$export$9c4772e191bdb810.COMMA, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlArgumentList;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlArgumentList) listener.enterJqlArgumentList(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlArgumentList) listener.exitJqlArgumentList(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlArgumentList) return visitor.visitJqlArgumentList(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$9cb97a63f2be4864 extends (0, $6bmaO.ParserRuleContext) {
    jqlListStart() {
        return this.getRuleContext(0, $371e898df891458a$export$c419f717bfc46a5d);
    }
    jqlOperand(i) {
        if (i === undefined) return this.getRuleContexts($371e898df891458a$export$2eaac5a9828bf647);
        else return this.getRuleContext(i, $371e898df891458a$export$2eaac5a9828bf647);
    }
    jqlListEnd() {
        return this.getRuleContext(0, $371e898df891458a$export$f6cd3e372f5ab120);
    }
    COMMA(i) {
        if (i === undefined) return this.getTokens($371e898df891458a$export$9c4772e191bdb810.COMMA);
        else return this.getToken($371e898df891458a$export$9c4772e191bdb810.COMMA, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlList;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlList) listener.enterJqlList(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlList) listener.exitJqlList(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlList) return visitor.visitJqlList(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$c419f717bfc46a5d extends (0, $6bmaO.ParserRuleContext) {
    LPAREN() {
        return this.getToken($371e898df891458a$export$9c4772e191bdb810.LPAREN, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlListStart;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlListStart) listener.enterJqlListStart(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlListStart) listener.exitJqlListStart(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlListStart) return visitor.visitJqlListStart(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$f6cd3e372f5ab120 extends (0, $6bmaO.ParserRuleContext) {
    RPAREN() {
        return this.getToken($371e898df891458a$export$9c4772e191bdb810.RPAREN, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlListEnd;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlListEnd) listener.enterJqlListEnd(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlListEnd) listener.exitJqlListEnd(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlListEnd) return visitor.visitJqlListEnd(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$e20ce4a2ed16372c extends (0, $6bmaO.ParserRuleContext) {
    jqlArgument() {
        return this.getRuleContext(0, $371e898df891458a$export$a95583953c237f88);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlPropertyArgument;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlPropertyArgument) listener.enterJqlPropertyArgument(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlPropertyArgument) listener.exitJqlPropertyArgument(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlPropertyArgument) return visitor.visitJqlPropertyArgument(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$a95583953c237f88 extends (0, $6bmaO.ParserRuleContext) {
    jqlString() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$bde73d8ad7c8b71e);
    }
    jqlNumber() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$8737d94a1880e8b3);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlArgument;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlArgument) listener.enterJqlArgument(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlArgument) listener.exitJqlArgument(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlArgument) return visitor.visitJqlArgument(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$9fa1e4d63f31b911 extends (0, $6bmaO.ParserRuleContext) {
    jqlPredicateOperand() {
        return this.getRuleContext(0, $371e898df891458a$export$6b796c5a4b8c18e);
    }
    jqlDatePredicateOperator() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$dc01290aee731418);
    }
    jqlDateRangePredicateOperator() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$75412b8b6a6442e1);
    }
    jqlUserPredicateOperator() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$ad402332075c8656);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlWasPredicate;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasPredicate) listener.enterJqlWasPredicate(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasPredicate) listener.exitJqlWasPredicate(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasPredicate) return visitor.visitJqlWasPredicate(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$e77e479a48133015 extends (0, $6bmaO.ParserRuleContext) {
    jqlPredicateOperand() {
        return this.getRuleContext(0, $371e898df891458a$export$6b796c5a4b8c18e);
    }
    jqlDatePredicateOperator() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$dc01290aee731418);
    }
    jqlDateRangePredicateOperator() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$75412b8b6a6442e1);
    }
    jqlUserPredicateOperator() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$ad402332075c8656);
    }
    jqlValuePredicateOperator() {
        return this.tryGetRuleContext(0, $371e898df891458a$export$4239d7c0fbafd3f1);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlChangedPredicate;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlChangedPredicate) listener.enterJqlChangedPredicate(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlChangedPredicate) listener.exitJqlChangedPredicate(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlChangedPredicate) return visitor.visitJqlChangedPredicate(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$dc01290aee731418 extends (0, $6bmaO.ParserRuleContext) {
    AFTER() {
        return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.AFTER, 0);
    }
    BEFORE() {
        return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.BEFORE, 0);
    }
    ON() {
        return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.ON, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlDatePredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlDatePredicateOperator) listener.enterJqlDatePredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlDatePredicateOperator) listener.exitJqlDatePredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlDatePredicateOperator) return visitor.visitJqlDatePredicateOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$75412b8b6a6442e1 extends (0, $6bmaO.ParserRuleContext) {
    DURING() {
        return this.getToken($371e898df891458a$export$9c4772e191bdb810.DURING, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlDateRangePredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlDateRangePredicateOperator) listener.enterJqlDateRangePredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlDateRangePredicateOperator) listener.exitJqlDateRangePredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlDateRangePredicateOperator) return visitor.visitJqlDateRangePredicateOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$ad402332075c8656 extends (0, $6bmaO.ParserRuleContext) {
    BY() {
        return this.getToken($371e898df891458a$export$9c4772e191bdb810.BY, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlUserPredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlUserPredicateOperator) listener.enterJqlUserPredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlUserPredicateOperator) listener.exitJqlUserPredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlUserPredicateOperator) return visitor.visitJqlUserPredicateOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$4239d7c0fbafd3f1 extends (0, $6bmaO.ParserRuleContext) {
    FROM() {
        return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.FROM, 0);
    }
    TO() {
        return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.TO, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlValuePredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlValuePredicateOperator) listener.enterJqlValuePredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlValuePredicateOperator) listener.exitJqlValuePredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlValuePredicateOperator) return visitor.visitJqlValuePredicateOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$6b796c5a4b8c18e extends (0, $6bmaO.ParserRuleContext) {
    jqlOperand() {
        return this.getRuleContext(0, $371e898df891458a$export$2eaac5a9828bf647);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlPredicateOperand;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlPredicateOperand) listener.enterJqlPredicateOperand(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlPredicateOperand) listener.exitJqlPredicateOperand(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlPredicateOperand) return visitor.visitJqlPredicateOperand(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$534469b9c8f44139 extends (0, $6bmaO.ParserRuleContext) {
    ORDER() {
        return this.getToken($371e898df891458a$export$9c4772e191bdb810.ORDER, 0);
    }
    BY() {
        return this.getToken($371e898df891458a$export$9c4772e191bdb810.BY, 0);
    }
    jqlSearchSort(i) {
        if (i === undefined) return this.getRuleContexts($371e898df891458a$export$c7d8f03f36952a46);
        else return this.getRuleContext(i, $371e898df891458a$export$c7d8f03f36952a46);
    }
    COMMA(i) {
        if (i === undefined) return this.getTokens($371e898df891458a$export$9c4772e191bdb810.COMMA);
        else return this.getToken($371e898df891458a$export$9c4772e191bdb810.COMMA, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlOrderBy;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlOrderBy) listener.enterJqlOrderBy(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlOrderBy) listener.exitJqlOrderBy(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlOrderBy) return visitor.visitJqlOrderBy(this);
        else return visitor.visitChildren(this);
    }
}
class $371e898df891458a$export$c7d8f03f36952a46 extends (0, $6bmaO.ParserRuleContext) {
    jqlField() {
        return this.getRuleContext(0, $371e898df891458a$export$b33300c3d916229a);
    }
    DESC() {
        return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.DESC, 0);
    }
    ASC() {
        return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.ASC, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlSearchSort;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlSearchSort) listener.enterJqlSearchSort(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlSearchSort) listener.exitJqlSearchSort(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlSearchSort) return visitor.visitJqlSearchSort(this);
        else return visitor.visitChildren(this);
    }
}

});

parcelRegister("lKjSa", function(module, exports) {

$parcel$export(module.exports, "JastBuilderErrorListener", () => $6eeebc6d04d5cc03$export$d0857f60ff1f385);

var $k9iwN = parcelRequire("k9iwN");

var $gbJ9P = parcelRequire("gbJ9P");
class $6eeebc6d04d5cc03$export$d0857f60ff1f385 {
    constructor(){
        this.errors = [];
        this.syntaxError = (recognizer, offendingSymbol, line, charPositionInLine, msg)=>{
            if (offendingSymbol === undefined) this.errors.push(new (0, $k9iwN.JQLParseError)(msg));
            else this.errors.push(new (0, $gbJ9P.JQLSyntaxError)(msg, offendingSymbol.startIndex, offendingSymbol.stopIndex + 1, line, charPositionInLine));
        };
    }
}

});
parcelRegister("k9iwN", function(module, exports) {

$parcel$export(module.exports, "JQLParseError", () => $c014cc1dfc254ce5$export$e8cfe2b2c93fbd4b);
/**
 * Represents a error occurring when trying to parse JQL into a Jast.
 */ class $c014cc1dfc254ce5$export$e8cfe2b2c93fbd4b extends Error {
    constructor(message, cause){
        super(message);
        this.name = 'JQLParseError';
        this.cause = cause;
        this.description = message;
    }
}

});

parcelRegister("gbJ9P", function(module, exports) {

$parcel$export(module.exports, "JQLSyntaxError", () => $59495a4ee8e45f22$export$3276184116160c41);

var $k9iwN = parcelRequire("k9iwN");
class $59495a4ee8e45f22$export$3276184116160c41 extends (0, $k9iwN.JQLParseError) {
    constructor(message, start, stop, line, charPositionInLine){
        super(message);
        this.name = 'JQLSyntaxError';
        this.start = start;
        this.stop = stop;
        this.line = line;
        this.charPositionInLine = charPositionInLine;
    }
}

});


parcelRegister("bK3p2", function(module, exports) {

$parcel$export(module.exports, "QueryVisitor", () => $0cc7bd3e15dd4aeb$export$418003b930734805);

var $iEIQF = parcelRequire("iEIQF");

var $flxWO = parcelRequire("flxWO");

var $fcxPF = parcelRequire("fcxPF");

var $gW3lb = parcelRequire("gW3lb");
class $0cc7bd3e15dd4aeb$export$418003b930734805 extends (0, $flxWO.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.whereVisitor = new (0, $gW3lb.WhereVisitor)(this.tokens), this.orderByVisitor = new (0, $fcxPF.OrderByVisitor)(this.tokens), this.visitJqlQuery = (ctx)=>{
            const whereContext = ctx.jqlWhere();
            const orderByContext = ctx.jqlOrderBy();
            return (0, $iEIQF.internalCreators).query(whereContext && whereContext.accept(this.whereVisitor), orderByContext && orderByContext.accept(this.orderByVisitor), (0, $flxWO.getPositionFromContext)(ctx));
        };
    }
}

});
parcelRegister("flxWO", function(module, exports) {

$parcel$export(module.exports, "JastBuildingVisitor", () => $4f91741519176bb0$export$d3c14d7188b09387);
$parcel$export(module.exports, "getPositionFromToken", () => $4f91741519176bb0$export$85a4e6d858dbc6fb);
$parcel$export(module.exports, "getPositionFromContext", () => $4f91741519176bb0$export$264629d4cd3cad3f);
$parcel$export(module.exports, "getPositionsFromTerminalNodes", () => $4f91741519176bb0$export$30d51184879cbaa8);
$parcel$export(module.exports, "normalizeText", () => $4f91741519176bb0$export$7c2714a5250b9239);
class $4f91741519176bb0$export$d3c14d7188b09387 {
    constructor(tokens){
        this.tokens = tokens;
    }
    visit(tree) {
        throw new Error('Unsupported operation visit(ParseTree)');
    }
    visitChildren(node) {
        throw new Error('Unsupported operation visitChildren(RuleNode)');
    }
    visitErrorNode(node) {
        throw new Error('Unsupported operation visitErrorNode(ErrorNode)');
    }
    visitTerminal(node) {
        throw new Error('Unsupported operation visitTerminal(TerminalNode)');
    }
}
const $4f91741519176bb0$export$85a4e6d858dbc6fb = (startToken, stopToken)=>[
        startToken.startIndex,
        (stopToken || startToken).stopIndex + 1
    ];
const $4f91741519176bb0$export$264629d4cd3cad3f = (ctx)=>[
        ctx.start.startIndex,
        ctx.stop ? ctx.stop.stopIndex + 1 : ctx.start.stopIndex
    ];
const $4f91741519176bb0$export$30d51184879cbaa8 = (terminalNodes)=>terminalNodes.map((node)=>$4f91741519176bb0$export$85a4e6d858dbc6fb(node.payload));
const $4f91741519176bb0$export$7c2714a5250b9239 = (text)=>text.toLowerCase().replace(/\s+/g, ' ');

});

parcelRegister("fcxPF", function(module, exports) {

$parcel$export(module.exports, "OrderByVisitor", () => $10359fbb24d00401$export$2774b71b99734811);


var $iEIQF = parcelRequire("iEIQF");

var $kzRYu = parcelRequire("kzRYu");

var $flxWO = parcelRequire("flxWO");

var $8sbD2 = parcelRequire("8sbD2");
class $10359fbb24d00401$export$2774b71b99734811 extends (0, $flxWO.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.searchSortVisitor = new $10359fbb24d00401$var$SearchSortVisitor(this.tokens), this.visitJqlOrderBy = (ctx)=>{
            // If this rule returned due to an exception then the order by operator is incomplete so we should exit early,
            // e.g. 'order '.
            if (ctx.exception) return undefined;
            const operator = (0, $iEIQF.internalCreators).orderByOperator((0, $flxWO.getPositionFromToken)(ctx.ORDER().payload, ctx.BY().payload));
            const fields = ctx.jqlSearchSort().map((searchSortCtx)=>searchSortCtx.accept(this.searchSortVisitor)).filter((0, $kzRYu.notUndefined));
            return (0, $iEIQF.internalCreators).orderBy(fields, operator, (0, $flxWO.getPositionFromContext)(ctx));
        };
    }
}
class $10359fbb24d00401$var$SearchSortVisitor extends (0, $flxWO.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.fieldVisitor = new (0, $8sbD2.FieldVisitor)(this.tokens), this.visitJqlSearchSort = (ctx)=>{
            const fieldCtx = ctx.jqlField();
            // If the field rule is returned due to an exception then we should ignore this search search rule. This happens
            // when there are no fields following and order by clause, e.g. 'order by '
            if (fieldCtx.exception) return undefined;
            let direction;
            const desc = ctx.DESC();
            const asc = ctx.ASC();
            if (desc !== undefined) direction = (0, $iEIQF.internalCreators).orderByDirection((0, $9f1dbb2b39d4d9a2$export$2ea27ea5f2121899), (0, $flxWO.getPositionFromToken)(desc.payload));
            else if (asc !== undefined) direction = (0, $iEIQF.internalCreators).orderByDirection((0, $9f1dbb2b39d4d9a2$export$6d60017b9e092e73), (0, $flxWO.getPositionFromToken)(asc.payload));
            return (0, $iEIQF.internalCreators).orderByField(ctx.jqlField().accept(this.fieldVisitor), direction, (0, $flxWO.getPositionFromContext)(ctx));
        };
    }
}

});
parcelRegister("kzRYu", function(module, exports) {

$parcel$export(module.exports, "notUndefined", () => $7297aaf6104af1ea$export$9a1adf421b69c6a);
/**
 * Type predicate to assert an argument is not undefined.
 */ function $7297aaf6104af1ea$export$9a1adf421b69c6a(x) {
    return x !== undefined;
}

});

parcelRegister("8sbD2", function(module, exports) {

$parcel$export(module.exports, "FieldVisitor", () => $3b522eccd35764cb$export$c6a85c4c3bf2317d);

var $iEIQF = parcelRequire("iEIQF");

var $31uE9 = parcelRequire("31uE9");

var $flxWO = parcelRequire("flxWO");

var $gpYZF = parcelRequire("gpYZF");
class $3b522eccd35764cb$export$c6a85c4c3bf2317d extends (0, $flxWO.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.stringVisitor = new (0, $gpYZF.StringVisitor)(this.tokens), this.fieldPropertyVisitor = new $3b522eccd35764cb$var$FieldPropertyVisitor(this.tokens), this.visitJqlNumberField = (ctx)=>{
            const text = this.tokens.getText(ctx);
            return (0, $iEIQF.internalCreators).field(text, text, undefined, (0, $flxWO.getPositionFromContext)(ctx));
        }, this.visitJqlNonNumberField = (ctx)=>{
            const stringContext = ctx.jqlString();
            const properties = ctx.jqlFieldProperty().map((context)=>context.accept(this.fieldPropertyVisitor));
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $iEIQF.internalCreators).field(stringValue.value, stringValue.text, properties, (0, $flxWO.getPositionFromContext)(ctx));
            }
            const text = this.tokens.getText(ctx);
            return (0, $iEIQF.internalCreators).field(text, text, properties, (0, $flxWO.getPositionFromContext)(ctx));
        };
    }
}
class $3b522eccd35764cb$var$FieldPropertyVisitor extends (0, $flxWO.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.argumentVisitor = new (0, $31uE9.ArgumentVisitor)(this.tokens), this.propertyArgumentVisitor = new $3b522eccd35764cb$var$PropertyArgumentVisitor(this.tokens), this.visitJqlFieldProperty = (ctx)=>{
            const argumentContext = ctx.jqlArgument();
            const propertyArgumentContext = ctx.jqlPropertyArgument();
            const path = propertyArgumentContext.map((context)=>context.accept(this.propertyArgumentVisitor));
            return (0, $iEIQF.internalCreators).property(argumentContext && argumentContext.accept(this.argumentVisitor), path, (0, $flxWO.getPositionFromContext)(ctx));
        };
    }
}
class $3b522eccd35764cb$var$PropertyArgumentVisitor extends (0, $flxWO.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.argumentVisitor = new (0, $31uE9.ArgumentVisitor)(this.tokens), this.visitJqlPropertyArgument = (ctx)=>{
            return ctx.jqlArgument().accept(this.argumentVisitor);
        };
    }
}

});
parcelRegister("31uE9", function(module, exports) {

$parcel$export(module.exports, "ArgumentVisitor", () => $11f58529c551c5c5$export$46b5a1f6d962d533);

var $iEIQF = parcelRequire("iEIQF");

var $flxWO = parcelRequire("flxWO");

var $gpYZF = parcelRequire("gpYZF");
class $11f58529c551c5c5$export$46b5a1f6d962d533 extends (0, $flxWO.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.stringVisitor = new (0, $gpYZF.StringVisitor)(this.tokens), this.visitJqlArgument = (ctx)=>{
            const stringContext = ctx.jqlString();
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $iEIQF.internalCreators).argument(stringValue.value, stringValue.text, stringValue.position);
            } else {
                const text = this.tokens.getText(ctx);
                return (0, $iEIQF.internalCreators).argument(text, text, (0, $flxWO.getPositionFromContext)(ctx));
            }
        };
    }
}

});
parcelRegister("gpYZF", function(module, exports) {

$parcel$export(module.exports, "StringVisitor", () => $15b8c92276e87e16$export$617850cb96304515);

var $flxWO = parcelRequire("flxWO");
class $15b8c92276e87e16$export$617850cb96304515 extends (0, $flxWO.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.visitJqlString = (ctx)=>{
            const text = this.tokens.getText(ctx);
            const position = (0, $flxWO.getPositionFromContext)(ctx);
            let value;
            if (ctx.QUOTE_STRING()) value = text.replace(/^"|"$/g, '').replace(/(?:\\(.))/g, '$1');
            else if (ctx.SQUOTE_STRING()) value = text.replace(/^'|'$/g, '').replace(/(?:\\(.))/g, '$1');
            else // unquoted string
            value = text;
            return {
                text: text,
                value: value,
                position: position
            };
        };
    }
}

});




parcelRegister("gW3lb", function(module, exports) {

$parcel$export(module.exports, "WhereVisitor", () => $e8ab3cb2e5350018$export$c573472f1d20e15d);


var $iEIQF = parcelRequire("iEIQF");

var $kzRYu = parcelRequire("kzRYu");

var $flxWO = parcelRequire("flxWO");

var $aSD70 = parcelRequire("aSD70");
class $e8ab3cb2e5350018$export$c573472f1d20e15d extends (0, $flxWO.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.terminalClauseVisitor = new (0, $aSD70.TerminalClauseVisitor)(this.tokens), this.visitJqlWhere = (ctx)=>{
            return this.visitJqlOrClause(ctx.jqlOrClause());
        }, this.visitJqlOrClause = (ctx)=>{
            const clauses = ctx.jqlAndClause().map((andClauseContext)=>andClauseContext.accept(this)).filter((0, $kzRYu.notUndefined));
            if (clauses.length > 1) {
                const operator = (0, $iEIQF.internalCreators).compoundOperator((0, $3cef51f82b2cbe1d$export$7b8f0a728d79a753), (0, $flxWO.getPositionsFromTerminalNodes)(ctx.OR()));
                return (0, $iEIQF.internalCreators).compoundClause(operator, clauses, (0, $flxWO.getPositionFromContext)(ctx));
            }
            return clauses.length === 0 ? undefined : clauses[0];
        }, this.visitJqlAndClause = (ctx)=>{
            const clauses = ctx.jqlNotClause().map((notClauseContext)=>notClauseContext.accept(this)).filter((0, $kzRYu.notUndefined));
            if (clauses.length > 1) {
                const operator = (0, $iEIQF.internalCreators).compoundOperator((0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97), (0, $flxWO.getPositionsFromTerminalNodes)(ctx.AND()));
                return (0, $iEIQF.internalCreators).compoundClause(operator, clauses, (0, $flxWO.getPositionFromContext)(ctx));
            }
            return clauses.length === 0 ? undefined : clauses[0];
        }, this.visitJqlNotClause = (ctx)=>{
            const notClauseContext = ctx.jqlNotClause();
            const subClauseContext = ctx.jqlSubClause();
            const terminalClauseContext = ctx.jqlTerminalClause();
            let clause;
            if (notClauseContext !== undefined) clause = notClauseContext.accept(this) || undefined;
            else if (subClauseContext !== undefined) clause = subClauseContext.accept(this) || undefined;
            else if (terminalClauseContext !== undefined) clause = terminalClauseContext.accept(this.terminalClauseVisitor);
            // Our token can be either NOT or !
            let notToken = ctx.NOT();
            notToken = notToken === undefined ? ctx.BANG() : notToken;
            if (notToken && clause) return (0, $iEIQF.internalCreators).notClause(clause, (0, $iEIQF.internalCreators).notClauseOperator((0, $flxWO.getPositionFromToken)(notToken.payload)), (0, $flxWO.getPositionFromContext)(ctx));
            return clause;
        }, this.visitJqlSubClause = (ctx)=>{
            return this.visitJqlOrClause(ctx.jqlOrClause());
        };
    }
}

});
parcelRegister("aSD70", function(module, exports) {

$parcel$export(module.exports, "TerminalClauseVisitor", () => $059f8caffc466ad5$export$14576ae5bd1874a9);

var $iEIQF = parcelRequire("iEIQF");

var $kzRYu = parcelRequire("kzRYu");

var $flxWO = parcelRequire("flxWO");

var $8sbD2 = parcelRequire("8sbD2");

var $dE1pq = parcelRequire("dE1pq");

var $hUHF5 = parcelRequire("hUHF5");

var $3qoPC = parcelRequire("3qoPC");
class $059f8caffc466ad5$export$14576ae5bd1874a9 extends (0, $flxWO.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.fieldVisitor = new (0, $8sbD2.FieldVisitor)(this.tokens), this.terminalClauseRhsVisitor = new $059f8caffc466ad5$var$TerminalClauseRhsVisitor(this.tokens), this.visitJqlTerminalClause = (ctx)=>{
            const field = ctx.jqlField().accept(this.fieldVisitor);
            const { operator: operator, operand: operand, predicates: predicates } = ctx.jqlTerminalClauseRhs().accept(this.terminalClauseRhsVisitor);
            const position = (0, $flxWO.getPositionFromContext)(ctx);
            return (0, $iEIQF.internalCreators).terminalClause(field, operator, operand, predicates, position);
        };
    }
}
class $059f8caffc466ad5$var$TerminalClauseRhsVisitor extends (0, $flxWO.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.operatorVisitor = new (0, $hUHF5.OperatorVisitor)(this.tokens), this.terminalClauseOperandVisitor = new $059f8caffc466ad5$var$TerminalClauseOperandVisitor(this.tokens), this.predicateVisitor = new (0, $3qoPC.PredicateVisitor)(this.tokens), this.visitJqlEqualsClause = (ctx)=>{
            const operator = ctx.jqlEqualsOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        }, this.visitJqlLikeClause = (ctx)=>{
            const operator = ctx.jqlLikeOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        }, this.visitJqlComparisonClause = (ctx)=>{
            const operator = ctx.jqlComparisonOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        }, this.visitJqlInClause = (ctx)=>{
            const operator = ctx.jqlInOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        }, this.visitJqlIsClause = (ctx)=>{
            const operator = ctx.jqlIsOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        }, this.visitJqlWasClause = (ctx)=>{
            const operator = ctx.jqlWasOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            const predicates = ctx.jqlWasPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, $kzRYu.notUndefined));
            return {
                operator: operator,
                operand: operand,
                predicates: predicates
            };
        }, this.visitJqlWasInClause = (ctx)=>{
            const operator = ctx.jqlWasInOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            const predicates = ctx.jqlWasPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, $kzRYu.notUndefined));
            return {
                operator: operator,
                operand: operand,
                predicates: predicates
            };
        }, this.visitJqlChangedClause = (ctx)=>{
            const operator = ctx.jqlChangedOperator().accept(this.operatorVisitor);
            const predicates = ctx.jqlChangedPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, $kzRYu.notUndefined));
            return {
                operator: operator,
                operand: undefined,
                predicates: predicates
            };
        }, // Recover from clause type ambiguities, e.g. "issuetype was " (which can be a WAS or WAS IN clause)
        this.visitChildren = (node)=>{
            const operator = node.accept(this.operatorVisitor);
            return {
                operator: operator,
                operand: undefined,
                predicates: []
            };
        };
    }
}
class $059f8caffc466ad5$var$TerminalClauseOperandVisitor extends (0, $flxWO.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.operandVisitor = new (0, $dE1pq.OperandVisitor)(this.tokens), this.visitJqlEqualsClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        }, this.visitJqlLikeClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        }, this.visitJqlComparisonClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        }, this.visitJqlInClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlList(),
                ctx.jqlFunction()
            ]);
        }, this.visitJqlIsClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty()
            ]);
        }, this.visitJqlWasClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        }, this.visitJqlWasInClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlList(),
                ctx.jqlFunction()
            ]);
        }, this.getOperandForContexts = (contexts)=>{
            const operandContext = contexts.find((0, $kzRYu.notUndefined));
            return operandContext?.accept(this.operandVisitor);
        };
    }
}

});
parcelRegister("dE1pq", function(module, exports) {

$parcel$export(module.exports, "OperandVisitor", () => $f0dc0c50bebb9cb5$export$ef8ae1aa15d9c9af);


var $iEIQF = parcelRequire("iEIQF");

var $kzRYu = parcelRequire("kzRYu");

var $31uE9 = parcelRequire("31uE9");

var $flxWO = parcelRequire("flxWO");

var $h5KaL = parcelRequire("h5KaL");

var $gpYZF = parcelRequire("gpYZF");
class $f0dc0c50bebb9cb5$export$ef8ae1aa15d9c9af extends (0, $flxWO.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.stringVisitor = new (0, $gpYZF.StringVisitor)(this.tokens), this.numberVisitor = new (0, $h5KaL.NumberVisitor)(this.tokens), this.functionNameVisitor = new $f0dc0c50bebb9cb5$var$FunctionNameVisitor(this.tokens), this.argumentListVisitor = new $f0dc0c50bebb9cb5$var$ArgumentListVisitor(this.tokens), this.visitJqlOperand = (ctx)=>{
            const operandContext = [
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlList(),
                ctx.jqlFunction()
            ].find((0, $kzRYu.notUndefined));
            return operandContext?.accept(this);
        }, this.visitJqlEmpty = (ctx)=>{
            // ANTLR will optimistically create a jqlEmpty node in some situations where user input doesn't match the EMPTY
            // token, e.g. when using value operands in IS clauses ("field is value"), where EMPTY is the only valid operand.
            if (ctx.exception) return undefined;
            return (0, $iEIQF.internalCreators).keywordOperand((0, $49b29ef7baa2a152$export$1c46dca02aac24dd), (0, $flxWO.getPositionFromToken)(ctx.EMPTY().payload));
        }, this.visitJqlValue = (ctx)=>{
            const stringContext = ctx.jqlString();
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $iEIQF.internalCreators).valueOperand(stringValue.value, stringValue.text, stringValue.position);
            }
            const numberContext = ctx.jqlNumber();
            if (numberContext !== undefined) return numberContext.accept(this.numberVisitor);
        }, this.visitJqlList = (ctx)=>{
            const values = ctx.jqlOperand().map((operandCtx)=>operandCtx.accept(this)).filter((0, $kzRYu.notUndefined));
            return (0, $iEIQF.internalCreators).listOperand(values, (0, $flxWO.getPositionFromContext)(ctx));
        }, this.visitJqlFunction = (ctx)=>{
            const argumentListContext = ctx.jqlArgumentList();
            return (0, $iEIQF.internalCreators).functionOperand(ctx.jqlFunctionName().accept(this.functionNameVisitor), argumentListContext === undefined ? [] : argumentListContext.accept(this.argumentListVisitor), (0, $flxWO.getPositionFromContext)(ctx));
        };
    }
}
class $f0dc0c50bebb9cb5$var$FunctionNameVisitor extends (0, $flxWO.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.stringVisitor = new (0, $gpYZF.StringVisitor)(this.tokens), this.visitJqlFunctionName = (ctx)=>{
            const stringContext = ctx.jqlString();
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $iEIQF.internalCreators).functionString(stringValue.value, stringValue.text, stringValue.position);
            } else {
                const text = this.tokens.getText(ctx);
                return (0, $iEIQF.internalCreators).functionString(text, text, (0, $flxWO.getPositionFromContext)(ctx));
            }
        };
    }
}
class $f0dc0c50bebb9cb5$var$ArgumentListVisitor extends (0, $flxWO.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.argumentVisitor = new (0, $31uE9.ArgumentVisitor)(this.tokens), this.visitJqlArgumentList = (ctx)=>{
            return ctx.jqlArgument().map((argumentCtx)=>argumentCtx.accept(this.argumentVisitor));
        };
    }
}

});
parcelRegister("h5KaL", function(module, exports) {

$parcel$export(module.exports, "NumberVisitor", () => $949fba49fb4026f9$export$a55432f0884633e4);

var $iEIQF = parcelRequire("iEIQF");

var $flxWO = parcelRequire("flxWO");
class $949fba49fb4026f9$export$a55432f0884633e4 extends (0, $flxWO.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.visitJqlNumber = (ctx)=>{
            const text = this.tokens.getText(ctx);
            return (0, $iEIQF.internalCreators).valueOperand(text, text, (0, $flxWO.getPositionFromContext)(ctx));
        };
    }
}

});


parcelRegister("hUHF5", function(module, exports) {

$parcel$export(module.exports, "OperatorVisitor", () => $ce76282d2f3e5bd1$export$e56f89ba95b51d2a);

var $iEIQF = parcelRequire("iEIQF");

var $dI0u8 = parcelRequire("dI0u8");

var $flxWO = parcelRequire("flxWO");
class $ce76282d2f3e5bd1$export$e56f89ba95b51d2a extends (0, $flxWO.JastBuildingVisitor) {
    visitJqlEqualsOperator(ctx) {
        const text = this.tokens.getText(ctx);
        if (!(0, $dI0u8.isEqualsOperator)(text)) throw new Error(`'${text}' does not match any of the recognised equals operators`);
        return (0, $iEIQF.internalCreators).operator(text, text, (0, $flxWO.getPositionFromContext)(ctx));
    }
    visitJqlLikeOperator(ctx) {
        const text = this.tokens.getText(ctx);
        if (!(0, $dI0u8.isLikeOperator)(text)) throw new Error(`'${text}' does not match any of the recognised like operators`);
        return (0, $iEIQF.internalCreators).operator(text, text, (0, $flxWO.getPositionFromContext)(ctx));
    }
    visitJqlComparisonOperator(ctx) {
        const text = this.tokens.getText(ctx);
        if (!(0, $dI0u8.isComparisonOperator)(text)) throw new Error(`'${text}' does not match any of the recognised comparison operators`);
        return (0, $iEIQF.internalCreators).operator(text, text, (0, $flxWO.getPositionFromContext)(ctx));
    }
    visitJqlInOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $flxWO.normalizeText)(text);
        if (!(0, $dI0u8.isInOperator)(value)) // This can happen if an incomplete operator is used, e.g. `status not open`.
        return undefined;
        return (0, $iEIQF.internalCreators).operator(value, text, (0, $flxWO.getPositionFromContext)(ctx));
    }
    visitJqlIsOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $flxWO.normalizeText)(text);
        if (!(0, $dI0u8.isIsOperator)(value)) throw new Error(`'${text}' does not match any of the recognised is operators`);
        return (0, $iEIQF.internalCreators).operator(value, text, (0, $flxWO.getPositionFromContext)(ctx));
    }
    visitJqlWasOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $flxWO.normalizeText)(text);
        if (!(0, $dI0u8.isWasOperator)(value)) throw new Error(`'${text}' does not match any of the recognised was operators`);
        return (0, $iEIQF.internalCreators).operator(value, text, (0, $flxWO.getPositionFromContext)(ctx));
    }
    visitJqlWasInOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $flxWO.normalizeText)(text);
        if (!(0, $dI0u8.isWasInOperator)(value)) throw new Error(`'${text}' does not match any of the recognised was in operators`);
        return (0, $iEIQF.internalCreators).operator(value, text, (0, $flxWO.getPositionFromContext)(ctx));
    }
    visitJqlChangedOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $flxWO.normalizeText)(text);
        if (!(0, $dI0u8.isChangedOperator)(value)) throw new Error(`'${text}' does not match any of the recognised changed operators`);
        return (0, $iEIQF.internalCreators).operator(value, text, (0, $flxWO.getPositionFromContext)(ctx));
    }
    constructor(...args){
        super(...args), // Recover from clause type ambiguities, e.g. "issuetype was " (which can be a WAS or WAS IN clause)
        this.visitChildren = (node)=>{
            const { sourceInterval: sourceInterval } = node;
            const text = this.tokens.getText(sourceInterval);
            if (text) {
                const value = (0, $flxWO.normalizeText)(text);
                const { a: startIndex, b: stopIndex } = sourceInterval;
                const startToken = this.tokens.get(startIndex);
                const stopToken = this.tokens.get(stopIndex);
                const position = (0, $flxWO.getPositionFromToken)(startToken, stopToken);
                if ((0, $dI0u8.isOperator)(value)) return (0, $iEIQF.internalCreators).operator(value, text, position);
            }
        };
    }
}

});
parcelRegister("dI0u8", function(module, exports) {

$parcel$export(module.exports, "isOperator", () => $ced3977476a8d3df$export$4e40859592ee7ac2);
$parcel$export(module.exports, "isEqualsOperator", () => $ced3977476a8d3df$export$6d0fc196fa8a1673);
$parcel$export(module.exports, "isLikeOperator", () => $ced3977476a8d3df$export$ad91b6d6a89cb64e);
$parcel$export(module.exports, "isComparisonOperator", () => $ced3977476a8d3df$export$4477c442bd5c2a6d);
$parcel$export(module.exports, "isInOperator", () => $ced3977476a8d3df$export$c5e1cdef30e30bff);
$parcel$export(module.exports, "isIsOperator", () => $ced3977476a8d3df$export$ccc3334744e395c7);
$parcel$export(module.exports, "isWasOperator", () => $ced3977476a8d3df$export$2b1c5d7e7856f91d);
$parcel$export(module.exports, "isWasInOperator", () => $ced3977476a8d3df$export$55d8c9b20d99509f);
$parcel$export(module.exports, "isChangedOperator", () => $ced3977476a8d3df$export$b65d23d23ade534b);
$parcel$export(module.exports, "isListOperator", () => $ced3977476a8d3df$export$b09522e4061bbdd6);

var $bzbto = parcelRequire("bzbto");
const $ced3977476a8d3df$export$4e40859592ee7ac2 = (operator)=>(0, $bzbto.OPERATORS).includes(operator);
const $ced3977476a8d3df$export$6d0fc196fa8a1673 = (operator)=>(0, $bzbto.EQUALS_OPERATORS).includes(operator);
const $ced3977476a8d3df$export$ad91b6d6a89cb64e = (operator)=>(0, $bzbto.LIKE_OPERATORS).includes(operator);
const $ced3977476a8d3df$export$4477c442bd5c2a6d = (operator)=>(0, $bzbto.COMPARISON_OPERATORS).includes(operator);
const $ced3977476a8d3df$export$c5e1cdef30e30bff = (operator)=>(0, $bzbto.IN_OPERATORS).includes(operator);
const $ced3977476a8d3df$export$ccc3334744e395c7 = (operator)=>(0, $bzbto.IS_OPERATORS).includes(operator);
const $ced3977476a8d3df$export$2b1c5d7e7856f91d = (operator)=>(0, $bzbto.WAS_OPERATORS).includes(operator);
const $ced3977476a8d3df$export$55d8c9b20d99509f = (operator)=>(0, $bzbto.WAS_IN_OPERATORS).includes(operator);
const $ced3977476a8d3df$export$b65d23d23ade534b = (operator)=>(0, $bzbto.CHANGED_OPERATORS).includes(operator);
const $ced3977476a8d3df$export$b09522e4061bbdd6 = (operator)=>(0, $bzbto.LIST_OPERATORS).includes(operator);

});


parcelRegister("3qoPC", function(module, exports) {

$parcel$export(module.exports, "PredicateVisitor", () => $377f729dab70cce1$export$33bb52a35c693109);

var $iEIQF = parcelRequire("iEIQF");

var $k75oj = parcelRequire("k75oj");

var $kzRYu = parcelRequire("kzRYu");

var $flxWO = parcelRequire("flxWO");

var $dE1pq = parcelRequire("dE1pq");
class $377f729dab70cce1$export$33bb52a35c693109 extends (0, $flxWO.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.predicateOperatorVisitor = new $377f729dab70cce1$var$PredicateOperatorVisitor(this.tokens), this.predicateOperandVisitor = new $377f729dab70cce1$var$PredicateOperandVisitor(this.tokens), this.visitJqlWasPredicate = (ctx)=>{
            const operator = this.getOperatorForContexts([
                ctx.jqlDatePredicateOperator(),
                ctx.jqlDateRangePredicateOperator(),
                ctx.jqlUserPredicateOperator()
            ]);
            const operand = ctx.jqlPredicateOperand().accept(this.predicateOperandVisitor);
            const position = (0, $flxWO.getPositionFromContext)(ctx);
            return (0, $iEIQF.internalCreators).predicate(operator, operand, position);
        }, this.visitJqlChangedPredicate = (ctx)=>{
            const operator = this.getOperatorForContexts([
                ctx.jqlDatePredicateOperator(),
                ctx.jqlDateRangePredicateOperator(),
                ctx.jqlUserPredicateOperator(),
                ctx.jqlValuePredicateOperator()
            ]);
            const operand = ctx.jqlPredicateOperand().accept(this.predicateOperandVisitor);
            const position = (0, $flxWO.getPositionFromContext)(ctx);
            return (0, $iEIQF.internalCreators).predicate(operator, operand, position);
        }, this.getOperatorForContexts = (contexts)=>{
            const operatorContext = contexts.find((0, $kzRYu.notUndefined));
            if (operatorContext !== undefined) return operatorContext.accept(this.predicateOperatorVisitor);
            else throw new Error('Undefined predicate operator context');
        };
    }
}
class $377f729dab70cce1$var$PredicateOperatorVisitor extends (0, $flxWO.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.visitJqlDatePredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        }, this.visitJqlDateRangePredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        }, this.visitJqlUserPredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        }, this.visitJqlValuePredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        }, this.getPredicateOperator = (ctx)=>{
            const text = this.tokens.getText(ctx);
            // Replace consecutive whitespace chars with single space
            const value = text.toLowerCase().replace(/\s+/g, ' ');
            if (!(0, $k75oj.isPredicateOperator)(value)) throw new Error(`Found a history predicate operator which does not map to a changed time predicate operator in the ast: ${text}`);
            return (0, $iEIQF.internalCreators).predicateOperator(value, text, (0, $flxWO.getPositionFromContext)(ctx));
        };
    }
}
class $377f729dab70cce1$var$PredicateOperandVisitor extends (0, $flxWO.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.operandVisitor = new (0, $dE1pq.OperandVisitor)(this.tokens), this.visitJqlPredicateOperand = (ctx)=>{
            return ctx.jqlOperand().accept(this.operandVisitor);
        };
    }
}

});
parcelRegister("k75oj", function(module, exports) {

$parcel$export(module.exports, "isPredicateOperator", () => $d2e5ca8020522bfa$export$188978ad94919403);

var $2OsFJ = parcelRequire("2OsFJ");
const $d2e5ca8020522bfa$export$188978ad94919403 = (operator)=>(0, $2OsFJ.PREDICATE_OPERATORS).includes(operator);

});
parcelRegister("2OsFJ", function(module, exports) {

$parcel$export(module.exports, "PREDICATE_OPERATORS", () => $7ee5a5e33e4550f1$export$e200440af9f1d9f);
const $7ee5a5e33e4550f1$export$3d56e2ae1b4bbbf9 = 'after';
const $7ee5a5e33e4550f1$export$f0a816341603bb63 = 'before';
const $7ee5a5e33e4550f1$export$cdc81c84f768d513 = 'by';
const $7ee5a5e33e4550f1$export$8a5280c65e704c3d = 'during';
const $7ee5a5e33e4550f1$export$71f882dcac65f97a = 'from';
const $7ee5a5e33e4550f1$export$5685a35c6b0a7ee8 = 'on';
const $7ee5a5e33e4550f1$export$5a83c4789e531a = 'to';
const $7ee5a5e33e4550f1$export$e200440af9f1d9f = [
    $7ee5a5e33e4550f1$export$3d56e2ae1b4bbbf9,
    $7ee5a5e33e4550f1$export$f0a816341603bb63,
    $7ee5a5e33e4550f1$export$cdc81c84f768d513,
    $7ee5a5e33e4550f1$export$8a5280c65e704c3d,
    $7ee5a5e33e4550f1$export$71f882dcac65f97a,
    $7ee5a5e33e4550f1$export$5685a35c6b0a7ee8,
    $7ee5a5e33e4550f1$export$5a83c4789e531a
];

});







parcelRegister("l0V05", function(module, exports) {

$parcel$export(module.exports, "print", () => $2a6ee55a17f6829c$export$c2d084dc44961371);

var $3NMrl = parcelRequire("3NMrl");

var $jcm7E = parcelRequire("jcm7E");

var $4gL4M = parcelRequire("4gL4M");
const $2a6ee55a17f6829c$export$c2d084dc44961371 = (jast, options = {})=>{
    return (0, $4gL4M.printDocToString)((0, $jcm7E.printAstToDoc)(jast, (0, (/*@__PURE__*/$parcel$interopDefault($3NMrl)))(options, [
        'operatorCase'
    ])), (0, (/*@__PURE__*/$parcel$interopDefault($3NMrl)))(options, [
        'printWidth'
    ]));
};

});
parcelRegister("3NMrl", function(module, exports) {

var $i2e26 = parcelRequire("i2e26");

var $9SRAA = parcelRequire("9SRAA");
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $2c4b85df1af41471$var$pick = $9SRAA(function(object, paths) {
    return object == null ? {} : $i2e26(object, paths);
});
module.exports = $2c4b85df1af41471$var$pick;

});
parcelRegister("i2e26", function(module, exports) {

var $4gaCO = parcelRequire("4gaCO");

var $fh9gH = parcelRequire("fh9gH");
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $d2134c8f0f8064b1$var$basePick(object, paths) {
    return $4gaCO(object, paths, function(value, path) {
        return $fh9gH(object, path);
    });
}
module.exports = $d2134c8f0f8064b1$var$basePick;

});


parcelRegister("jcm7E", function(module, exports) {

$parcel$export(module.exports, "printAstToDoc", () => $7ac43980ca69512e$export$f0ef38932978952);


var $bv7J5 = parcelRequire("bv7J5");

var $d4xUO = parcelRequire("d4xUO");
const $7ac43980ca69512e$var$formatOperator = (operator, operatorCase)=>{
    switch(operatorCase){
        case 'lower':
            return operator.toLowerCase();
        case 'upper':
            return operator.toUpperCase();
        case 'preserve':
            return operator;
    }
};
class $7ac43980ca69512e$export$27a275559a5c8102 extends (0, $bv7J5.AbstractJastVisitor) {
    constructor({ operatorCase: operatorCase } = {}){
        super();
        this.operatorCase = operatorCase || 'preserve';
    }
    visitArgument(argument) {
        return argument.text;
    }
    /**
	 * Visit each of the provided nodes and form a new array with each `Doc` joined by the provided separator.
	 */ joinNodes(nodes, separator) {
        const docs = [];
        nodes.forEach((node)=>{
            if (separator !== undefined && docs.length > 0) docs.push(separator);
            docs.push(node.accept(this));
        });
        return docs;
    }
    visitCompoundClause(compoundClause) {
        const operatorDoc = compoundClause.operator.accept(this);
        const clauseDocs = [];
        compoundClause.clauses.forEach((clause)=>{
            if (clauseDocs.length > 0) clauseDocs.push((0, $d4xUO.ifBreak)((0, $d4xUO.newLine)(), ' '), operatorDoc, ' ');
            // Wrap nested compound clauses in parentheses
            if (clause.clauseType === (0, $e9a0ef16a223cbc7$export$7a58b23488ea076b)) clauseDocs.push('(', clause.accept(this), ')');
            else clauseDocs.push(clause.accept(this));
        });
        return (0, $d4xUO.group)(clauseDocs);
    }
    visitCompoundOperator(compoundOperator) {
        return $7ac43980ca69512e$var$formatOperator(compoundOperator.value, this.operatorCase);
    }
    visitField(field) {
        const propertyDocs = field.properties ? this.joinNodes(field.properties) : [];
        return (0, $d4xUO.group)([
            field.text,
            ...propertyDocs
        ]);
    }
    visitFunction(functionString) {
        return functionString.text;
    }
    visitFunctionOperand(functionOperand) {
        const argumentDocs = this.joinNodes(functionOperand.arguments, ', ');
        return (0, $d4xUO.group)([
            functionOperand.function.accept(this),
            '(',
            ...argumentDocs,
            ')'
        ]);
    }
    visitKeywordOperand(keywordOperand) {
        return keywordOperand.value;
    }
    visitListOperand(listOperand) {
        const operandDocs = this.joinNodes(listOperand.values, ', ');
        return (0, $d4xUO.group)([
            '(',
            ...operandDocs,
            ')'
        ]);
    }
    visitOperator(operator) {
        return $7ac43980ca69512e$var$formatOperator(operator.text, this.operatorCase);
    }
    visitOrderBy(orderBy) {
        const fieldDocs = this.joinNodes(orderBy.fields, ', ');
        return (0, $d4xUO.group)([
            orderBy.operator.accept(this),
            ' ',
            ...fieldDocs
        ]);
    }
    visitOrderByDirection(orderByDirection) {
        return orderByDirection.value;
    }
    visitOrderByField(orderByField) {
        const docs = [
            orderByField.field.accept(this)
        ];
        if (orderByField.direction) docs.push(' ', orderByField.direction.accept(this));
        return (0, $d4xUO.group)(docs);
    }
    visitOrderByOperator(orderByOperator) {
        return $7ac43980ca69512e$var$formatOperator(orderByOperator.value, this.operatorCase);
    }
    visitPredicate(predicate) {
        const docs = [
            predicate.operator.accept(this)
        ];
        if (predicate.operand) docs.push(' ', predicate.operand.accept(this));
        return (0, $d4xUO.group)(docs);
    }
    visitPredicateOperator(predicateOperator) {
        return $7ac43980ca69512e$var$formatOperator(predicateOperator.text, this.operatorCase);
    }
    visitProperty(property) {
        const docs = [];
        if (property.key) docs.push('[', property.key.accept(this), ']');
        if (property.path) {
            const pathDocs = this.joinNodes(property.path, ' ');
            docs.push(...pathDocs);
        }
        return (0, $d4xUO.group)(docs);
    }
    visitQuery(query) {
        if (query.where && query.orderBy) return (0, $d4xUO.group)([
            query.where.accept(this),
            (0, $d4xUO.ifBreak)((0, $d4xUO.newLine)(), ' '),
            query.orderBy.accept(this)
        ]);
        else if (query.where) return query.where.accept(this);
        else if (query.orderBy) return query.orderBy.accept(this);
        return '';
    }
    visitTerminalClause(terminalClause) {
        const docs = [
            terminalClause.field.accept(this)
        ];
        if (terminalClause.operator) docs.push(' ', terminalClause.operator.accept(this));
        if (terminalClause.operand) docs.push(' ', terminalClause.operand.accept(this));
        terminalClause.predicates.forEach((predicate)=>{
            docs.push(' ', predicate.accept(this));
        });
        return (0, $d4xUO.group)(docs);
    }
    visitValueOperand(valueOperand) {
        return valueOperand.text;
    }
    visitNotClause(notClause) {
        const clauseDocs = [];
        // Wrap nested compound clauses in parentheses
        if (notClause.clause.clauseType === (0, $e9a0ef16a223cbc7$export$7a58b23488ea076b)) clauseDocs.push('(', notClause.clause.accept(this), ')');
        else clauseDocs.push(notClause.clause.accept(this));
        return (0, $d4xUO.group)([
            notClause.operator.accept(this),
            ' ',
            ...clauseDocs
        ]);
    }
    visitNotClauseOperator(notClauseOperator) {
        return notClauseOperator.value;
    }
    visitChildren() {
        throw new Error('Required visit method not implemented for node');
    }
    defaultResult() {
        return '';
    }
}
const $7ac43980ca69512e$export$f0ef38932978952 = (jast, options)=>{
    const astToDocVisitor = new $7ac43980ca69512e$export$27a275559a5c8102(options);
    return jast.query ? jast.query.accept(astToDocVisitor) : '';
};

});
parcelRegister("bv7J5", function(module, exports) {

$parcel$export(module.exports, "AbstractJastVisitor", () => $564d8ceecff04d6a$export$51be62b46ee668fd);
class $564d8ceecff04d6a$export$51be62b46ee668fd {
    /**
	 * The default implementation calls AstNode#accept on the specified node.
	 * @param node
	 */ visit(node) {
        return node.accept(this);
    }
    /**
	 * The default implementation initializes the aggregate result to defaultResult(). Before visiting each child, it
	 * calls shouldVisitNextChild; if the result is false no more children are visited and the current aggregate result is
	 * returned. After visiting a child, the aggregate result is updated by calling aggregateResult with the previous
	 * aggregate result and the result of visiting the child.
	 */ visitChildren(node) {
        let result = this.defaultResult();
        const children = node.getChildren();
        for(let i = 0; i < children.length; i++){
            if (!this.shouldVisitNextChild(node, result)) break;
            const childResult = children[i].accept(this);
            result = this.aggregateResult(result, childResult);
        }
        return result;
    }
    /**
	 * Aggregates the results of visiting multiple children of a node.
	 *
	 * The default implementation returns `nextResult`, meaning
	 * {@link #visitChildren} will return the result of the last child visited
	 * (or return the initial value if the node has no children).
	 *
	 * @param aggregate The previous aggregate value. In the default
	 * implementation, the aggregate value is initialized to
	 * {@link #defaultResult}, which is passed as the `aggregate` argument
	 * to this method after the first child node is visited.
	 * @param nextResult The result of the immediately preceeding call to visit
	 * a child node.
	 *
	 * @returns The updated aggregate result.
	 */ aggregateResult(aggregate, nextResult) {
        return nextResult;
    }
    /**
	 * This method is called before visiting each child in
	 * {@link #visitChildren}. When the method is first called\ `currentResult`
	 * will be the initial value (in the default implementation, the initial value
	 * is returned by a call to {@link #defaultResult}).
	 *
	 * The default implementation always returns `true`, indicating that
	 * `visitChildren` should only return after all children are visited.
	 * One reason to override this method is to provide a "short circuit"
	 * evaluation option for situations where the result of visiting a single
	 * child has the potential to determine the result of the visit operation as
	 * a whole.
	 *
	 * @param node The {@link AstNode} whose children are currently being
	 * visited.
	 * @param currentResult The current aggregate result of the children visited
	 * to the current point.
	 *
	 * @returns `true` to continue visiting children. Otherwise return
	 * `false` to stop visiting children and immediately return the
	 * current aggregate result from {@link #visitChildren}.
	 */ shouldVisitNextChild(node, currentResult) {
        return true;
    }
}

});

parcelRegister("d4xUO", function(module, exports) {

$parcel$export(module.exports, "group", () => $9ef2b92937def9ad$export$e5e25fbcc1f7affe);
$parcel$export(module.exports, "ifBreak", () => $9ef2b92937def9ad$export$1db8e61901dcb0fa);
$parcel$export(module.exports, "newLine", () => $9ef2b92937def9ad$export$dc84f6841f96b7da);
const $9ef2b92937def9ad$export$e5e25fbcc1f7affe = (contents)=>{
    return {
        type: 'group',
        contents: contents
    };
};
const $9ef2b92937def9ad$export$1db8e61901dcb0fa = (breakContents, flatContents)=>{
    return {
        type: 'if-break',
        breakContents: breakContents,
        flatContents: flatContents
    };
};
const $9ef2b92937def9ad$export$dc84f6841f96b7da = ()=>{
    return {
        type: 'new-line'
    };
};

});


parcelRegister("4gL4M", function(module, exports) {

$parcel$export(module.exports, "printDocToString", () => $b6450d092f32aba3$export$316fc7e94b95b118);
const $b6450d092f32aba3$var$computeFlatWidth = (doc)=>{
    if (typeof doc === 'string') return doc.length;
    if (Array.isArray(doc)) return doc.reduce((result, innerDoc)=>result + $b6450d092f32aba3$var$computeFlatWidth(innerDoc), 0);
    switch(doc.type){
        case 'group':
            return $b6450d092f32aba3$var$computeFlatWidth(doc.contents);
        case 'if-break':
            return $b6450d092f32aba3$var$computeFlatWidth(doc.flatContents);
        case 'new-line':
            // TODO This probably represents a bug as we don't expect new lines in the flat path
            return 0;
        default:
            throw new Error('Unrecognised doc type.');
    }
};
const $b6450d092f32aba3$var$printDoc = (doc, context)=>{
    if (typeof doc === 'string') return {
        result: doc,
        endIndex: context.startIndex + doc.length
    };
    switch(doc.type){
        case 'group':
            return $b6450d092f32aba3$var$printGroup(doc, context);
        case 'if-break':
            return $b6450d092f32aba3$var$printIfBreak(doc, context);
        case 'new-line':
            return $b6450d092f32aba3$var$printNewLine();
        default:
            throw new Error('Unrecognised doc type.');
    }
};
const $b6450d092f32aba3$var$printGroup = (doc, context)=>{
    const docWidth = context.startIndex + $b6450d092f32aba3$var$computeFlatWidth(doc);
    const breakContents = context.printWidth !== null && docWidth > context.printWidth;
    return doc.contents.reduce((agg, innerDoc)=>{
        const innerContext = {
            ...context,
            startIndex: agg.endIndex,
            breakContents: breakContents
        };
        const output = $b6450d092f32aba3$var$printDoc(innerDoc, innerContext);
        return {
            result: agg.result + output.result,
            endIndex: output.endIndex
        };
    }, {
        result: '',
        endIndex: context.startIndex
    });
};
const $b6450d092f32aba3$var$printIfBreak = (doc, context)=>{
    if (context.breakContents) return $b6450d092f32aba3$var$printDoc(doc.breakContents, context);
    return $b6450d092f32aba3$var$printDoc(doc.flatContents, context);
};
const $b6450d092f32aba3$var$printNewLine = ()=>{
    return {
        result: '\n',
        // Reset our end index as a new line is being output.
        endIndex: 0
    };
};
// TODO Tweak this number with design
const $b6450d092f32aba3$var$defaultPrintWidth = 100;
const $b6450d092f32aba3$export$316fc7e94b95b118 = (doc, options = {})=>{
    const { printWidth: printWidth = $b6450d092f32aba3$var$defaultPrintWidth } = options;
    const output = $b6450d092f32aba3$var$printDoc(doc, {
        printWidth: printWidth,
        startIndex: 0,
        breakContents: false
    });
    return output.result;
};

});



parcelRegister("8EJ2P", function(module, exports) {

$parcel$export(module.exports, "createCollection", () => $18031dc7a5aa6b32$export$c74125a8e3af6bb2);
$parcel$export(module.exports, "fetchCollection", () => $18031dc7a5aa6b32$export$efeb96fc7f2aeaf9);
$parcel$export(module.exports, "fetchAllCollections", () => $18031dc7a5aa6b32$export$fb62ec897a9d1e05);
$parcel$export(module.exports, "deleteCollection", () => $18031dc7a5aa6b32$export$3d16e031f6551662);
$parcel$export(module.exports, "updateCollection", () => $18031dc7a5aa6b32$export$c0683150b517c317);
$parcel$export(module.exports, "fetchCollectionsViewsCounts", () => $18031dc7a5aa6b32$export$4ead91e2f6058f41);
$parcel$export(module.exports, "fetchCollectionDescription", () => $18031dc7a5aa6b32$export$8cd86b5346d1e786);
$parcel$export(module.exports, "cloneCollection", () => $18031dc7a5aa6b32$export$d753eba18153f51e);
$parcel$export(module.exports, "getIdeasCountForCollection", () => $18031dc7a5aa6b32$export$d355ccab36abee74);

var $7f4tk = parcelRequire("7f4tk");

var $eusud = parcelRequire("eusud");

var $b2npD = parcelRequire("b2npD");

var $jcw0u = parcelRequire("jcw0u");

var $1As78 = parcelRequire("1As78");

var $dpYV0 = parcelRequire("dpYV0");

var $cPshp = parcelRequire("cPshp");
const $18031dc7a5aa6b32$var$generateProjectKeys = (jql)=>{
    return (0, $dpYV0.extractProjectKeysFromJql)(jql);
};
const $18031dc7a5aa6b32$export$c74125a8e3af6bb2 = (collectionToCreate)=>(0, $eusud.performPostRequest)(`${(0, $b2npD.getJpdViewsServicePathPrefix)()}/v1/collections`, {
        body: JSON.stringify(collectionToCreate)
    }).then((response)=>({
            uuid: response.uuid,
            name: response.name,
            emoji: response.emoji,
            color: response.color,
            jql: response.jql,
            ownerId: response.owner,
            projectKeys: $18031dc7a5aa6b32$var$generateProjectKeys(response.jql),
            filtersJql: (0, $dpYV0.extractFiltersJqlFromJql)(response.jql)
        }));
const $18031dc7a5aa6b32$export$efeb96fc7f2aeaf9 = (collectionUUID, shouldIncludeViews = false)=>(0, $7f4tk.default)(`${(0, $b2npD.getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}${shouldIncludeViews ? '?expand=views' : ''}`).then((response)=>({
            uuid: response.uuid,
            name: response.name,
            emoji: response.emoji,
            color: response.color,
            jql: response.jql,
            ownerId: response.owner,
            views: response.views?.map((0, $cPshp.transformView)),
            projectKeys: $18031dc7a5aa6b32$var$generateProjectKeys(response.jql),
            filtersJql: (0, $dpYV0.extractFiltersJqlFromJql)(response.jql)
        }));
const $18031dc7a5aa6b32$export$fb62ec897a9d1e05 = ()=>(0, $7f4tk.default)(`${(0, $b2npD.getJpdViewsServicePathPrefix)()}/v1/collections`).then(({ collections: collections })=>collections.map((collection)=>({
                uuid: collection.uuid,
                name: collection.name,
                emoji: collection.emoji,
                color: collection.color,
                jql: collection.jql,
                ownerId: collection.owner,
                projectKeys: $18031dc7a5aa6b32$var$generateProjectKeys(collection.jql),
                filtersJql: (0, $dpYV0.extractFiltersJqlFromJql)(collection.jql)
            })));
const $18031dc7a5aa6b32$export$3d16e031f6551662 = async (collectionUUID)=>{
    await (0, $eusud.performDeleteRequest)(`${(0, $b2npD.getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}`);
};
const $18031dc7a5aa6b32$export$c0683150b517c317 = async (collectionUUID, collectionToUpdate)=>{
    await (0, $eusud.performPutRequest)(`${(0, $b2npD.getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}`, {
        body: JSON.stringify(collectionToUpdate)
    });
};
const $18031dc7a5aa6b32$export$4ead91e2f6058f41 = (collectionsUUIDs)=>(0, $eusud.performPostRequest)(`${(0, $b2npD.getJpdViewsServicePathPrefix)()}/v1/collections/views-count`, {
        body: JSON.stringify({
            uuids: collectionsUUIDs
        })
    });
const $18031dc7a5aa6b32$export$8cd86b5346d1e786 = (collectionUUID)=>(0, $7f4tk.default)(`${(0, $b2npD.getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}/description`);
const $18031dc7a5aa6b32$export$d753eba18153f51e = (collectionUUID, newCollectionName)=>(0, $eusud.performPostRequest)(`${(0, $b2npD.getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}/clone`, {
        body: JSON.stringify({
            name: newCollectionName
        })
    });
const $18031dc7a5aa6b32$export$d355ccab36abee74 = (jql)=>(0, $eusud.performPostRequest)('/rest/polaris/issues/searchCountForJql', {
        body: JSON.stringify({
            jql: jql,
            archived: 'ACTIVE_ONLY'
        })
    }).then((response)=>response.count).catch((error)=>{
        (0, $jcw0u.default)((0, $1As78.createErrorAnalytics)('polaris.error.getIdeasCountForCollectionFailed', error));
        throw error;
    });

});
parcelRegister("b2npD", function(module, exports) {

$parcel$export(module.exports, "getJpdViewsServicePathPrefix", () => $234049bfb6060538$export$1d2754f769c8a3c6);
const $234049bfb6060538$export$1d2754f769c8a3c6 = ()=>{
    return '/gateway/api/jpd';
};

});

parcelRegister("cPshp", function(module, exports) {

$parcel$export(module.exports, "transformView", () => $173999f9e481de31$export$601ea8be46c5c28c);
const $173999f9e481de31$export$601ea8be46c5c28c = (view)=>({
        uuid: view.uuid,
        ownerId: view.owner,
        kind: view.visualizationType,
        title: view.name,
        emoji: view.emoji,
        description: view.description,
        apiResponse: view
    });

});



parcelRegister("kyQ0U", function(module, exports) {

$parcel$export(module.exports, "useCollectionSelectedMatch", () => $1ac5450e6fdb6a66$export$f8678ffe77a81702);
$parcel$export(module.exports, "useIsCollectionsSelected", () => $1ac5450e6fdb6a66$export$bff956e91a23208e);
$parcel$export(module.exports, "useIsJpdProjectView", () => $1ac5450e6fdb6a66$export$dbf8a4da34593bdd);
$parcel$export(module.exports, "useIsCollectionSelected", () => $1ac5450e6fdb6a66$export$d1d2d8dc13ec1cf);
$parcel$export(module.exports, "getViewUrl", () => $1ac5450e6fdb6a66$export$bdccd6a672e4a607);

var $lODMY = parcelRequire("lODMY");

var $aOD49 = parcelRequire("aOD49");
const $1ac5450e6fdb6a66$export$f8678ffe77a81702 = (0, $lODMY.createRouterSelector)(({ route: route, match: match })=>{
    const viewUUID = match.params?.resource || undefined;
    const collectionUUID = match.params?.collectionUUID || undefined;
    const isCollectionSelected = route.name === 'polaris-collections' && collectionUUID !== undefined && viewUUID !== undefined;
    return isCollectionSelected ? {
        collectionUUID: collectionUUID,
        viewUUID: viewUUID
    } : undefined;
});
const $1ac5450e6fdb6a66$export$bff956e91a23208e = (0, $lODMY.createRouterSelector)(({ route: route, match: match })=>{
    const viewUUID = match.params?.resource || undefined;
    const collectionUUID = match.params?.collectionUUID || undefined;
    return route.name === 'polaris-collections' && viewUUID === undefined && collectionUUID === undefined;
});
const $1ac5450e6fdb6a66$export$dbf8a4da34593bdd = (0, $lODMY.createRouterSelector)(({ route: route, match: match })=>{
    const viewUUID = match.params?.resource || undefined;
    return route.name === 'polaris-ideas' && viewUUID !== undefined;
});
const $1ac5450e6fdb6a66$export$d1d2d8dc13ec1cf = (options)=>{
    const collectionMatched = $1ac5450e6fdb6a66$export$f8678ffe77a81702();
    if (options?.collectionUUID) return collectionMatched && collectionMatched.collectionUUID === options.collectionUUID;
    return Boolean(collectionMatched);
};
const $1ac5450e6fdb6a66$export$bdccd6a672e4a607 = ({ container: container, view: view })=>{
    // In collections we don't use `view.polarisId` like we do in jpd-project-menu
    // but instead we use `view.id` that contains UUID
    return (0, $aOD49.getCollectionViewPageUrl)(container.collectionUUID, view.id);
};

});

parcelRegister("3BY0g", function(module, exports) {

$parcel$export(module.exports, "PremiumLozenge", () => $41762d41640733d3$export$b37ef9640eaa3746);

var $5uXOq = parcelRequire("5uXOq");

var $9JG4b = parcelRequire("9JG4b");

var $l6jCW = parcelRequire("l6jCW");
const $41762d41640733d3$export$b37ef9640eaa3746 = ({ children: children })=>{
    const isVisible = (0, $l6jCW.useIsPremiumLozengeVisible)();
    return isVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9JG4b.PaidFeatureAwarenessPremiumLozenge), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};

});
parcelRegister("l6jCW", function(module, exports) {

$parcel$export(module.exports, "useIsPremiumLozengeVisible", () => $0ce28235057fcbaf$export$894065ae16e309f2);

var $5uXOq = parcelRequire("5uXOq");

var $dWQF5 = parcelRequire("dWQF5");

var $5oBMG = parcelRequire("5oBMG");

const $0ce28235057fcbaf$export$894065ae16e309f2 = ()=>{
    const isPremium = (0, $dWQF5.useIsPremiumEdition)();
    const productEntitlementDetails = (0, $5oBMG.useProductEntitlementDetails)();
    const trialEndDate = productEntitlementDetails?.[0, $3772f4e397c0a966$export$9062e724eddb8377]?.trialEndTime;
    return (0, $5uXOq.useMemo)(()=>{
        return isPremium && trialEndDate && trialEndDate - Date.now() > 0;
    }, [
        trialEndDate,
        isPremium
    ]);
};

});
parcelRegister("dWQF5", function(module, exports) {

$parcel$export(module.exports, "useIsPremiumEdition", () => $901349e77566565e$export$8aa8a7878fd61770);
$parcel$export(module.exports, "useIsViewPermissionsEnabled", () => $901349e77566565e$export$a94405ffcb20c356);
$parcel$export(module.exports, "useIsCrossProjectViewsEnabled", () => $901349e77566565e$export$34d097b1cd6f89c1);
$parcel$export(module.exports, "useIsConnectionsEnabled", () => $901349e77566565e$export$304793dd2c5f4db0);

var $4R6GH = parcelRequire("4R6GH");

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");
const $901349e77566565e$export$8aa8a7878fd61770 = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    if ((0, $4R6GH.fg)('polaris_force-premium')) return true;
    const jpdEdition = (0, $ldyPw.getEdition)((0, $efvDm.JIRA_PRODUCT_DISCOVERY), appEditions);
    // TODO: POL-10089 use entitlements instead of the edition when it will be available
    return jpdEdition === (0, $ldyPw.toEdition)((0, $ldyPw.PREMIUM_EDITION));
};
const $901349e77566565e$export$642bac71144485ad = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const jpdEdition = (0, $ldyPw.getEdition)((0, $efvDm.JIRA_PRODUCT_DISCOVERY), appEditions);
    return jpdEdition === (0, $ldyPw.toEdition)((0, $ldyPw.STANDARD_EDITION));
};
const $901349e77566565e$export$a94405ffcb20c356 = ()=>{
    const isPremium = $901349e77566565e$export$8aa8a7878fd61770();
    return isPremium;
};
const $901349e77566565e$export$34d097b1cd6f89c1 = ()=>{
    const isPremium = $901349e77566565e$export$8aa8a7878fd61770();
    return isPremium;
};
const $901349e77566565e$export$304793dd2c5f4db0 = ()=>{
    const isPremium = $901349e77566565e$export$8aa8a7878fd61770();
    const isStandard = $901349e77566565e$export$642bac71144485ad();
    if (isStandard && (0, $4R6GH.fg)('jpd_issues_relationships_eap_lighthouse_customer')) return true;
    return isPremium;
};

});

const $3772f4e397c0a966$export$9062e724eddb8377 = 'jira-product-discovery';



parcelRegister("8tJaf", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $cb38e1a17d55c084$export$a06f1c675e846f6f);

var $5uXOq = parcelRequire("5uXOq");

var $gSZmd = parcelRequire("gSZmd");
var $1qQhw = parcelRequire("1qQhw");
var $1FdfO = parcelRequire("1FdfO");

var $koVbs = parcelRequire("koVbs");

var $jhS4y = parcelRequire("jhS4y");

var $34PKs = parcelRequire("34PKs");

var $aOD49 = parcelRequire("aOD49");

var $6ZDS2 = parcelRequire("6ZDS2");

var $fZq5p = parcelRequire("fZq5p");
const $cb38e1a17d55c084$export$a06f1c675e846f6f = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { fireUIAnalyticForFixMenuItem: fireUIAnalyticForFixMenuItem } = (0, $5uXOq.useContext)((0, $6ZDS2.AnalyticContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1qQhw.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1FdfO.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gSZmd.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $34PKs.ViewAllEntityMenuItem), {
        href: (0, $aOD49.getCollectionsPageUrl)(),
        menuId: (0, $jhS4y.MENU_ID_ROADMAPS_VIEW_ALL),
        onClick: (e)=>{
            fireUIAnalyticForFixMenuItem();
            onClose?.(e);
        }
    }, formatMessage((0, $fZq5p.default).viewAllRoadmaps)))));
};

});
parcelRegister("6ZDS2", function(module, exports) {

$parcel$export(module.exports, "AnalyticContext", () => $c529cbf8cbd12a6e$export$da0556bf821b3494);
$parcel$export(module.exports, "AnalyticContextProvider", () => $c529cbf8cbd12a6e$export$aea8e3edcdec81e3);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");




var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $3RJbG = parcelRequire("3RJbG");
const $c529cbf8cbd12a6e$export$da0556bf821b3494 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    fireUIAnalyticForFixMenuItem: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    fireUIAnalyticForFixButton: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    fireUIAnalyticForFavouriteToggle: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    fireUIAnalyticForRoadmapsItems: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
});
const $c529cbf8cbd12a6e$export$aea8e3edcdec81e3 = ({ children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireUIAnalyticForFixMenuItem = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_ROADMAPS],
            attributes: {
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                itemId: (0, $3RJbG.VIEW_ALL_ROADMAPS)
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireUIAnalyticForFixButton = (0, $5uXOq.useCallback)(({ itemId: itemId })=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_ROADMAPS],
            attributes: {
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                itemId: itemId
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireUIAnalyticForFavouriteToggle = (0, $5uXOq.useCallback)(({ starType: starType, parentItemId: parentItemId })=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_ROADMAPS],
            attributes: {
                level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                componentType: (0, $1e554a683893bd46$export$74712b62056d422e),
                parentItemId: parentItemId,
                parentItemType: 'roadmap',
                itemId: starType
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireUIAnalyticForRoadmapsItems = (0, $5uXOq.useCallback)(({ itemId: itemId, section: section })=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_ROADMAPS],
            attributes: {
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                componentType: (0, $1e554a683893bd46$export$3ac911b122986477),
                itemType: (0, $632bd8725b437a12$export$bb8a37ab8d9ba82b).toLowerCase(),
                itemId: itemId,
                section: section
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const value = (0, $5uXOq.useMemo)(()=>({
            fireUIAnalyticForFixMenuItem: fireUIAnalyticForFixMenuItem,
            fireUIAnalyticForFixButton: fireUIAnalyticForFixButton,
            fireUIAnalyticForFavouriteToggle: fireUIAnalyticForFavouriteToggle,
            fireUIAnalyticForRoadmapsItems: fireUIAnalyticForRoadmapsItems
        }), [
        fireUIAnalyticForFavouriteToggle,
        fireUIAnalyticForFixButton,
        fireUIAnalyticForFixMenuItem,
        fireUIAnalyticForRoadmapsItems
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c529cbf8cbd12a6e$export$da0556bf821b3494.Provider, {
        value: value
    }, children);
};

});

parcelRegister("fZq5p", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e15b7e182815cf6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6e15b7e182815cf6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    viewAllRoadmaps: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-roadmaps.common.footer.view-all-roadmaps",
        "defaultMessage": "View all roadmaps"
    }
});

});



parcelRegister("lvWgl", function(module, exports) {

$parcel$export(module.exports, "ActionButtonsStatic", () => $98f2849f4093958c$export$d29fef02bcf1ee7);

var $5uXOq = parcelRequire("5uXOq");

var $dZbEw = parcelRequire("dZbEw");

var $eZUJu = parcelRequire("eZUJu");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $46Cti = parcelRequire("46Cti");

var $1xonH = parcelRequire("1xonH");

var $eaKdt = parcelRequire("eaKdt");

var $aCS3f = parcelRequire("aCS3f");

var $6ZDS2 = parcelRequire("6ZDS2");

var $3RJbG = parcelRequire("3RJbG");

var $j9kwa = parcelRequire("j9kwa");
const $98f2849f4093958c$export$d29fef02bcf1ee7 = /*#__PURE__*/ (0, $5uXOq.memo)(({ isReadOnly: isReadOnly, isCreadRoadmapLoading: isCreadRoadmapLoading, isCreateRoadmapDisabled: isCreateRoadmapDisabled, createRoadmapTooltipContent: createRoadmapTooltipContent, onCreateRoadmapClick: onCreateRoadmapClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { fireUIAnalyticForFixButton: fireUIAnalyticForFixButton } = (0, $5uXOq.useContext)((0, $6ZDS2.AnalyticContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !isReadOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: createRoadmapTooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1xonH.CommonNavMenuButton), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage((0, $j9kwa.messages).createRoadmap),
        isLoading: isCreadRoadmapLoading,
        isDisabled: isCreateRoadmapDisabled,
        onClick: onCreateRoadmapClick
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCS3f.MoreNavMenuButton), {
        onOpen: ()=>fireUIAnalyticForFixButton({
                itemId: (0, $3RJbG.MEATBALL_DROPDOWN)
            }),
        MenuItems: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaKdt.HideL1MenuItemSection), {
                menuId: (0, $46Cti.L1_MENU_ID).ROADMAPS,
                hasSeparator: false
            }))
    }));
});

});
parcelRegister("j9kwa", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5d207ce31c37069f$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $5d207ce31c37069f$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    createRoadmap: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-roadmaps.common.action-buttons-static.create-roadmap",
        "defaultMessage": "Create roadmap"
    }
});

});


parcelRegister("dHLn1", function(module, exports) {

let $9fa409479d1d9cc2$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9fa409479d1d9cc2$var$load("ffQaD"),
    $9fa409479d1d9cc2$var$load("kvRbA"),
    $9fa409479d1d9cc2$var$load("bYyRU")
]).then(()=>parcelRequire('goFx9'));

});


parcelRegister("cq1bX", function(module, exports) {

$parcel$export(module.exports, "Starred", () => $75f7926d6c4a87ae$export$8cd2a0520fb55072);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $l8ruj = parcelRequire("l8ruj");

var $2lF9G = parcelRequire("2lF9G");

var $xP1Je = parcelRequire("xP1Je");
const $75f7926d6c4a87ae$export$8cd2a0520fb55072 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4-sidebar-starred"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "flag",
        id: "starred",
        packageName: (0, $2lF9G.PACKAGE_NAME),
        teamName: (0, $2lF9G.TEAM_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $xP1Je.StarredFlyoutMenuItem), null)));

});
parcelRegister("2lF9G", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $ebc2aa74f4359e69$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $ebc2aa74f4359e69$export$d57b6b390e78d90f);
$parcel$export(module.exports, "FAVOURITE_QUERY_LIMIT", () => $ebc2aa74f4359e69$export$77881eca52f4f5a6);
$parcel$export(module.exports, "FAVORITE_TYPE_MAP", () => $ebc2aa74f4359e69$export$c2849e00cccc2078);
$parcel$export(module.exports, "FAVORITE_TYPE_FILTER_MAP", () => $ebc2aa74f4359e69$export$531e43cc63c1e036);
$parcel$export(module.exports, "VALID_FAVORITE_TYPES", () => $ebc2aa74f4359e69$export$336e25f77ad481a9);
$parcel$export(module.exports, "FAVORITE_TYPE_FILTER_MESSAGE", () => $ebc2aa74f4359e69$export$de9a288dad6f35f1);
$parcel$export(module.exports, "SEARCH_STARRED_ITEMS", () => $ebc2aa74f4359e69$export$6b181848cd9c8308);
$parcel$export(module.exports, "FILTER", () => $ebc2aa74f4359e69$export$c1c49903035a02df);

var $hWFET = parcelRequire("hWFET");
const $ebc2aa74f4359e69$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Starred';
const $ebc2aa74f4359e69$export$d57b6b390e78d90f = 'jira-cosmos';
const $ebc2aa74f4359e69$export$77881eca52f4f5a6 = 15;
const $ebc2aa74f4359e69$export$c2849e00cccc2078 = {
    PROJECT: 'PROJECT',
    FILTER: 'FILTER',
    DASHBOARD: 'DASHBOARD',
    PLAN: 'PLAN',
    BOARD: 'BOARD',
    QUEUE: 'QUEUE'
};
const $ebc2aa74f4359e69$export$531e43cc63c1e036 = {
    ...$ebc2aa74f4359e69$export$c2849e00cccc2078,
    ALL: 'ALL'
};
const $ebc2aa74f4359e69$export$336e25f77ad481a9 = Object.values($ebc2aa74f4359e69$export$c2849e00cccc2078);
const $ebc2aa74f4359e69$export$de9a288dad6f35f1 = {
    [$ebc2aa74f4359e69$export$531e43cc63c1e036.PROJECT]: (0, $hWFET.messages).projects,
    [$ebc2aa74f4359e69$export$531e43cc63c1e036.FILTER]: (0, $hWFET.messages).filters,
    [$ebc2aa74f4359e69$export$531e43cc63c1e036.DASHBOARD]: (0, $hWFET.messages).dashboards,
    [$ebc2aa74f4359e69$export$531e43cc63c1e036.PLAN]: (0, $hWFET.messages).plans,
    [$ebc2aa74f4359e69$export$531e43cc63c1e036.BOARD]: (0, $hWFET.messages).boards,
    [$ebc2aa74f4359e69$export$531e43cc63c1e036.QUEUE]: (0, $hWFET.messages).queues,
    [$ebc2aa74f4359e69$export$531e43cc63c1e036.ALL]: (0, $hWFET.messages).all
};
const $ebc2aa74f4359e69$export$6b181848cd9c8308 = 'searchStarredItems';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $ebc2aa74f4359e69$var$VIEW_ALL_STARRED_ITEMS = 'viewAllStarredItems';
const $ebc2aa74f4359e69$export$c1c49903035a02df = 'filter';

});
parcelRegister("hWFET", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ef19a8d714970feb$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $ef19a8d714970feb$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    projects: {
        "id": "navigation-apps-sidebar-nav4-starred.common.projects",
        "defaultMessage": "Projects"
    },
    filters: {
        "id": "navigation-apps-sidebar-nav4-starred.common.filters",
        "defaultMessage": "Filters"
    },
    dashboards: {
        "id": "navigation-apps-sidebar-nav4-starred.common.dashboards",
        "defaultMessage": "Dashboards"
    },
    plans: {
        "id": "navigation-apps-sidebar-nav4-starred.common.plans",
        "defaultMessage": "Plans"
    },
    boards: {
        "id": "navigation-apps-sidebar-nav4-starred.common.boards",
        "defaultMessage": "Boards"
    },
    queues: {
        "id": "navigation-apps-sidebar-nav4-starred.common.queues",
        "defaultMessage": "Queues"
    },
    all: {
        "id": "navigation-apps-sidebar-nav4-starred.common.all",
        "defaultMessage": "All"
    }
});

});


parcelRegister("xP1Je", function(module, exports) {

$parcel$export(module.exports, "StarredFlyoutMenuItem", () => $4533cea19a1bfb96$export$b5a36b539503145d);

var $5uXOq = parcelRequire("5uXOq");

var $dAf5R = parcelRequire("dAf5R");

var $jUDIz = parcelRequire("jUDIz");
var $17aWz = parcelRequire("17aWz");
var $lBNLs = parcelRequire("lBNLs");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");


var $jecJ3 = parcelRequire("jecJ3");

var $iszzG = parcelRequire("iszzG");

var $46Cti = parcelRequire("46Cti");

var $338xa = parcelRequire("338xa");

var $24a2m = parcelRequire("24a2m");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koeKL = parcelRequire("koeKL");

var $4R6GH = parcelRequire("4R6GH");

var $2lF9G = parcelRequire("2lF9G");

var $64Fry = parcelRequire("64Fry");

var $aOVaR = parcelRequire("aOVaR");
const $4533cea19a1bfb96$var$EMPTY_OBJECT = {};
function $4533cea19a1bfb96$export$b5a36b539503145d() {
    const cloudId = (0, $koeKL.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { moreMenuIds: moreMenuIds } = (0, $5uXOq.useContext)((0, $iszzG.NavItemsContext));
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $aOVaR.sidebarStarredMenuEntryPoint), (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            filter: {
                types: (0, $2lF9G.VALID_FAVORITE_TYPES),
                sort: {
                    order: 'DESC'
                }
            },
            count: (0, $2lF9G.FAVOURITE_QUERY_LIMIT)
        }), [
        cloudId
    ]) : {
        cloudId: cloudId,
        filter: {
            types: (0, $2lF9G.VALID_FAVORITE_TYPES),
            sort: {
                order: 'DESC'
            }
        },
        count: (0, $2lF9G.FAVOURITE_QUERY_LIMIT)
    });
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    const { formattedMessage: formattedMessage, icon: icon } = (0, $24a2m.useFormattedMessageAndIcon)((0, $64Fry.default).starred, (0, (/*@__PURE__*/$parcel$interopDefault($dAf5R))));
    const onOpenChangeHandler = (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useCallback)(async (isOpen)=>{
        if (isOpen) {
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
            });
            const isInMore = moreMenuIds.includes((0, $46Cti.L1_MENU_ID).STARRED);
            (0, $8zOmE.fireUIAnalytics)(event, (0, $jecJ3.SECTION_ITEM_STARRED), {
                isInMore: isInMore
            });
        }
    }, [
        createAnalyticsEvent,
        moreMenuIds
    ]) : async (isOpen)=>{
        if (isOpen) {
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
            });
            const isInMore = moreMenuIds.includes((0, $46Cti.L1_MENU_ID).STARRED);
            (0, $8zOmE.fireUIAnalytics)(event, (0, $jecJ3.SECTION_ITEM_STARRED), {
                isInMore: isInMore
            });
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jUDIz.FlyoutMenuItem), {
        onOpenChange: onOpenChangeHandler
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lBNLs.FlyoutMenuItemTrigger), {
        interactionName: "nav4-sidebar-starred",
        ref: triggerRef,
        elemBefore: icon
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $17aWz.FlyoutMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        // Data stream, will subscribe to load updates.
        entryPointReferenceSubject: entryPointReferenceSubject,
        // Required props for error JSErrorBoundary.
        id: "nav4-sidebar-starred-default",
        packageName: (0, $2lF9G.PACKAGE_NAME),
        teamName: (0, $2lF9G.TEAM_NAME),
        // Optional props for error JSErrorBoundary.
        errorFallback: "flag",
        // Fallback for `Suspense`.
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), null),
        // Props for the root component.
        runtimeProps: (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? $4533cea19a1bfb96$var$EMPTY_OBJECT : {}
    })));
}

});
parcelRegister("64Fry", function(module, exports) {

$parcel$export(module.exports, "default", () => $d29101a3b8ab7b9b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d29101a3b8ab7b9b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    starred: {
        "id": "navigation-apps-sidebar-nav4-starred.starred",
        "defaultMessage": "Starred"
    }
});

});

parcelRegister("aOVaR", function(module, exports) {

$parcel$export(module.exports, "sidebarStarredMenuEntryPoint", () => $ee124e0d33917030$export$72aec40208131d);

var $jFWWh = parcelRequire("jFWWh");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $ee124e0d33917030$export$72aec40208131d = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("bOjfZ")), {
        moduleId: "ab25fe7d",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, filter: filter, count: count })=>({
            queries: {
                starredMenuData: {
                    parameters: $jFWWh.default,
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    variables: {
                        cloudId: cloudId,
                        count: count,
                        filter: filter
                    }
                }
            }
        })
});

});
parcelRegister("jFWWh", function(module, exports) {

$parcel$export(module.exports, "default", () => $346d8a8aa569881a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7bb03542a269252c90a2aa73c01c6062>>
 * @relayHash f34979afb8cd27df9f4da6c1a31a9ee6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 31e047825e1403b4e5982d0a07da0a9f90eee8f2086996cd6caf739c1a5196dd

var $eiowN = parcelRequire("eiowN");
const $346d8a8aa569881a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "count"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v3 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v4 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v5 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        }
    ], v6 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "startCursor"
            }
        ]
    }, v7 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "name"
    }, v11 = {
        "kind": "InlineFragment",
        "selections": [
            v9 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v12 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isNode"
    }, v13 = [
        v9 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v10 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "filterUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "filterId"
                },
                v12 /*: any*/ 
            ],
            "type": "JiraFilter",
            "abstractKey": "__isJiraFilter"
        }
    ], v14 = {
        "kind": "ScalarField",
        "name": "title"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "starredMenuQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "alias": "allFavourites",
                                "args": v5 /*: any*/ ,
                                "concreteType": "JiraFavouriteConnection",
                                "kind": "LinkedField",
                                "name": "favourites",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": v6 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "jira.allFavourites.pageInfo"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "count",
                            "variableName": "count"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "starredMenu_navigationAppsSidebarNav4SidebarsContentStarred"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "starredMenuQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "allFavourites",
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "starredItems",
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "defaultNavigationItem",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ],
                                                                    "type": "JiraNavigationItem",
                                                                    "abstractKey": "__isJiraNavigationItem"
                                                                },
                                                                v11 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "large"
                                                                }
                                                            ]
                                                        },
                                                        v12 /*: any*/ 
                                                    ],
                                                    "type": "JiraProject"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v13 /*: any*/ ,
                                                    "type": "JiraSystemFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v13 /*: any*/ ,
                                                    "type": "JiraCustomFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardId"
                                                        },
                                                        v12 /*: any*/ 
                                                    ],
                                                    "type": "JiraDashboard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "planUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "planId"
                                                        },
                                                        v12 /*: any*/ 
                                                    ],
                                                    "type": "JiraPlan"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        {
                                                            "alias": "title",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardId"
                                                        },
                                                        v12 /*: any*/ 
                                                    ],
                                                    "type": "JiraBoard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueId"
                                                        },
                                                        v12 /*: any*/ 
                                                    ],
                                                    "type": "JiraServiceManagementQueue"
                                                },
                                                v11 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "starredItems",
                            "args": v7 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "filter"
                            ],
                            "handle": "connection",
                            "key": "StarredMenuListContent_starredItems",
                            "kind": "LinkedHandle",
                            "name": "favourites"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "31e047825e1403b4e5982d0a07da0a9f90eee8f2086996cd6caf739c1a5196dd",
            "metadata": {},
            "name": "starredMenuQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$346d8a8aa569881a$var$node.hash = "a986e516464a8c05df425dc6bf3d574d";
(0, $eiowN.PreloadableQueryRegistry).set($346d8a8aa569881a$var$node.params.id, $346d8a8aa569881a$var$node);
var $346d8a8aa569881a$export$2e2bcd8739ae039 = $346d8a8aa569881a$var$node;

});

parcelRegister("bOjfZ", function(module, exports) {

let $89934d424f30af2f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $89934d424f30af2f$var$load("lrF0k").then(()=>parcelRequire('1K2XC'));

});




parcelRegister("96poX", function(module, exports) {

$parcel$export(module.exports, "Teams", () => $b8d06ffc4011b778$export$b3a34d915d8dd11e);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $l8ruj = parcelRequire("l8ruj");


var $9SHwc = parcelRequire("9SHwc");

var $2F2eB = parcelRequire("2F2eB");
const $b8d06ffc4011b778$export$b3a34d915d8dd11e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4-sidebar-teams"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "flag",
        id: "teams",
        packageName: (0, $2cdcf2b7084757bc$export$b8b9d90f9e5bd72b),
        teamName: (0, $2cdcf2b7084757bc$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2F2eB.InvitePeopleModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9SHwc.TeamsMenu), null))));

});
const $2cdcf2b7084757bc$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Teams';
const $2cdcf2b7084757bc$export$d57b6b390e78d90f = 'People and Teams Collective';
const $2cdcf2b7084757bc$export$f17fc93a893ec45c = 'add';
const $2cdcf2b7084757bc$export$6ee8a54637c51e7d = 'createATeam';
const $2cdcf2b7084757bc$export$b3dcfa0224e0289c = 'invitePeople';
const $2cdcf2b7084757bc$export$f06dfcec5ff912e = 'meatballDropdown';
const $2cdcf2b7084757bc$export$1245c8aac7dab260 = '/jira/people/search';

parcelRegister("9SHwc", function(module, exports) {

$parcel$export(module.exports, "TeamsMenu", () => $00a1aa44690d74d1$export$deb84fb5c6bff4b0);

var $5uXOq = parcelRequire("5uXOq");

var $9dZ1c = parcelRequire("9dZ1c");

var $dZbEw = parcelRequire("dZbEw");

var $42CjB = parcelRequire("42CjB");

var $kJpBP = parcelRequire("kJpBP");
var $eZUJu = parcelRequire("eZUJu");

var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $cJFfS = parcelRequire("cJFfS");

var $jgJNO = parcelRequire("jgJNO");

var $koVbs = parcelRequire("koVbs");




var $jecJ3 = parcelRequire("jecJ3");

var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $46Cti = parcelRequire("46Cti");

var $eQV8d = parcelRequire("eQV8d");

var $dUyqZ = parcelRequire("dUyqZ");

var $eaKdt = parcelRequire("eaKdt");

var $aCS3f = parcelRequire("aCS3f");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $3TY9o = parcelRequire("3TY9o");


var $jOXuX = parcelRequire("jOXuX");

var $at1Nr = parcelRequire("at1Nr");

var $4R6GH = parcelRequire("4R6GH");

var $LmW5e = parcelRequire("LmW5e");


var $eXCTi = parcelRequire("eXCTi");

var $eA0nk = parcelRequire("eA0nk");

var $fxSv8 = parcelRequire("fxSv8");
const $00a1aa44690d74d1$var$PopupContent = ({ openTeamsPopup: openTeamsPopup, createTeamModalTrigger: createTeamModalTrigger })=>{
    const invitePeopleModalTrigger = (0, $fxSv8.useInvitePeopleModal)();
    const actionSubjectId = (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_TEAMS];
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onButtonClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: actionSubjectId,
            attributes: {
                level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                componentType: (0, $1e554a683893bd46$export$17bca95234dea43b),
                parentItemId: (0, $jecJ3.SECTION_ITEM_TEAMS),
                itemId: (0, $2cdcf2b7084757bc$export$b3dcfa0224e0289c)
            }
        });
        invitePeopleModalTrigger();
        openTeamsPopup(false);
    }, [
        createAnalyticsEvent,
        actionSubjectId,
        invitePeopleModalTrigger,
        openTeamsPopup
    ]);
    const onCreateTeamClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: actionSubjectId,
            attributes: {
                level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                componentType: (0, $1e554a683893bd46$export$17bca95234dea43b),
                parentItemId: (0, $jecJ3.SECTION_ITEM_TEAMS),
                itemId: (0, $2cdcf2b7084757bc$export$6ee8a54637c51e7d)
            }
        });
        createTeamModalTrigger();
        openTeamsPopup(false);
    }, [
        createAnalyticsEvent,
        actionSubjectId,
        createTeamModalTrigger,
        openTeamsPopup
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        xcss: $00a1aa44690d74d1$var$teamsMenuStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        onClick: onButtonClick
    }, formatMessage((0, $eXCTi.default).invitePeople)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        onClick: onCreateTeamClick
    }, formatMessage((0, $eXCTi.default).createTeam)));
};
const $00a1aa44690d74d1$var$MenuItems = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaKdt.HideL1MenuItemSection), {
        menuId: (0, $jhS4y.MENU_ID_TEAMS),
        hasSeparator: false
    }));
const $00a1aa44690d74d1$export$deb84fb5c6bff4b0 = (0, $LmW5e.memoWithCondition)(()=>(0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1'), ()=>{
    const [isOpenTeamsPopup, openTeamsPopup] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).TEAMS);
    const location = (0, $3TY9o.useLocation)();
    const path = location.pathname + location.search;
    const isSelected = path === (0, $2cdcf2b7084757bc$export$1245c8aac7dab260);
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const actionSubjectId = (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_TEAMS];
    const label = formatMessage((0, $eXCTi.default).addButton);
    const [createTeamModal, createTeamModalTrigger] = (0, $eA0nk.useCreateTeamModal)();
    const invitePeopleModalTrigger = (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? undefined : (0, $fxSv8.useInvitePeopleModal)();
    const onLinkClick = (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? (0, $5uXOq.useCallback)(()=>{
        sendSectionItemAnalyticsEvent({
            menuId: (0, $46Cti.L1_MENU_ID).TEAMS,
            sectionItem: (0, $jecJ3.SECTION_ITEM_TEAMS)
        });
    }, [
        sendSectionItemAnalyticsEvent
    ]) : ()=>{
        sendSectionItemAnalyticsEvent({
            menuId: (0, $46Cti.L1_MENU_ID).TEAMS,
            sectionItem: (0, $jecJ3.SECTION_ITEM_TEAMS)
        });
    };
    const onPlusButtonClick = (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: actionSubjectId,
            attributes: {
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                parentItemId: (0, $jecJ3.SECTION_ITEM_TEAMS),
                itemId: (0, $2cdcf2b7084757bc$export$f17fc93a893ec45c)
            }
        });
        openTeamsPopup(true);
    }, [
        createAnalyticsEvent,
        actionSubjectId
    ]) : ()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: actionSubjectId,
            attributes: {
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                parentItemId: (0, $jecJ3.SECTION_ITEM_TEAMS),
                itemId: (0, $2cdcf2b7084757bc$export$f17fc93a893ec45c)
            }
        });
        openTeamsPopup(true);
    };
    const isTailoredOnboarding = (0, $jOXuX.isTailoredOnboardingEnabled)();
    const peopleMenuWrapperRef = (0, $9dZ1c.useRegisterNudgeTarget)((0, $6784cbc7d62e5d7c$export$77bc79debbf5c069), isTailoredOnboarding || (0, $4R6GH.fg)('tailored_onboarding_m2p5_gate')).ref;
    const renderContent = (0, $5uXOq.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($00a1aa44690d74d1$var$PopupContent, {
            openTeamsPopup: openTeamsPopup,
            createTeamModalTrigger: createTeamModalTrigger
        });
    }, [
        createTeamModalTrigger,
        openTeamsPopup
    ]);
    const onMoreNavMenuButtonClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$b887e88d8d0739f6),
            actionSubjectId: actionSubjectId,
            attributes: {
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                itemId: (0, $2cdcf2b7084757bc$export$f06dfcec5ff912e)
            }
        });
    }, [
        actionSubjectId,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, createTeamModal, (isTailoredOnboarding || (0, $4R6GH.fg)('tailored_onboarding_m2p5_gate')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $at1Nr.InviteTeamNudgeAsync), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cJFfS.LinkMenuItem), {
        ref: isTailoredOnboarding || (0, $4R6GH.fg)('tailored_onboarding_m2p5_gate') ? peopleMenuWrapperRef : undefined,
        testId: "navigation-apps-sidebar-nav4-sidebars-content-teams.ui.sidenav-teams",
        href: (0, $2cdcf2b7084757bc$export$1245c8aac7dab260),
        isSelected: isSelected,
        elemBefore: icon,
        onClick: onLinkClick,
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
            shouldRenderToParent: true,
            placement: "bottom-start",
            messageId: "navigation-apps-sidebar-nav4-sidebars-content-teams.ui.popup",
            messageType: "transactional",
            onClose: (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? (0, $5uXOq.useCallback)(()=>openTeamsPopup(false), []) : ()=>openTeamsPopup(false),
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                    ...triggerProps,
                    icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
                            ...iconProps,
                            size: "small"
                        }),
                    appearance: "subtle",
                    spacing: "compact",
                    testId: "navigation-apps-sidebar-nav4-sidebars-content-teams.ui.sidenav-teams-popup-trigger",
                    isSelected: isOpenTeamsPopup,
                    label: label,
                    tooltip: {
                        content: label
                    },
                    isTooltipDisabled: false,
                    onClick: onPlusButtonClick
                }),
            isOpen: isOpenTeamsPopup,
            content: (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? renderContent : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
                    xcss: $00a1aa44690d74d1$var$teamsMenuStyle
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
                    onClick: ()=>{
                        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                            action: 'clicked',
                            actionSubject: 'dropdownItem',
                            actionSubjectId: actionSubjectId,
                            attributes: {
                                level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                                componentType: (0, $1e554a683893bd46$export$17bca95234dea43b),
                                parentItemId: (0, $jecJ3.SECTION_ITEM_TEAMS),
                                itemId: (0, $2cdcf2b7084757bc$export$b3dcfa0224e0289c)
                            }
                        });
                        invitePeopleModalTrigger?.();
                        openTeamsPopup(false);
                    }
                }, formatMessage((0, $eXCTi.default).invitePeople)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
                    onClick: ()=>{
                        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                            action: 'clicked',
                            actionSubject: 'dropdownItem',
                            actionSubjectId: actionSubjectId,
                            attributes: {
                                level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                                componentType: (0, $1e554a683893bd46$export$17bca95234dea43b),
                                parentItemId: (0, $jecJ3.SECTION_ITEM_TEAMS),
                                itemId: (0, $2cdcf2b7084757bc$export$6ee8a54637c51e7d)
                            }
                        });
                        createTeamModalTrigger();
                        openTeamsPopup(false);
                    }
                }, formatMessage((0, $eXCTi.default).createTeam)))
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCS3f.MoreNavMenuButton), {
            onOpen: (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? onMoreNavMenuButtonClick : ()=>{
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                    action: 'clicked',
                    actionSubject: (0, $ce8062101363feb9$export$b887e88d8d0739f6),
                    actionSubjectId: actionSubjectId,
                    attributes: {
                        level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                        componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                        itemId: (0, $2cdcf2b7084757bc$export$f06dfcec5ff912e)
                    }
                });
            },
            MenuItems: (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? $00a1aa44690d74d1$var$MenuItems : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaKdt.HideL1MenuItemSection), {
                    menuId: (0, $jhS4y.MENU_ID_TEAMS),
                    hasSeparator: false
                }))
        }))
    }, formattedMessage));
});
const $00a1aa44690d74d1$var$teamsMenuStyle = (0, $8CUq3.xcss)({
    minWidth: '260px',
    paddingBlock: 'space.100'
});

});
parcelRegister("9dZ1c", function(module, exports) {

$parcel$export(module.exports, "useNudgeController", () => $6a0467752d0c968a$export$9a533735412babca);
$parcel$export(module.exports, "useRegisterNudgeTarget", () => $6a0467752d0c968a$export$eb8a96124d659f2d);

var $5uXOq = parcelRequire("5uXOq");
/**
 * This class tracks nudge target HTML DOM elements by ID.
 * It also tracks subscribers to updates of these elements.
 *  See some of the history here https://hello.atlassian.net/wiki/spaces/~620663553/pages/2896059847/Shipit+57+-+Out+of+Tree+Nudges
 */ class $6a0467752d0c968a$var$NudgeController {
    static{
        /**
	 * Singleton instance of this class.
	 * Alternatively multiple instances would be created and passed through context.
	 */ this.instance = new $6a0467752d0c968a$var$NudgeController();
    }
    /**
	 * Register the HTML DOM node for an ID
	 */ registerNudgeTarget(id, ref) {
        this.nudgeTargetsMap.set(id, ref);
        this.notifySubscribers(id);
        // Return a cleanup function that will remove this ID from the map
        return ()=>{
            this.nudgeTargetsMap.delete(id);
        };
    }
    /**
	 * Subscribe to updates to a certain DOM node
	 */ subscribe(id, callback) {
        const subscribers = this.subscribers.get(id) ?? [];
        subscribers.push(callback);
        this.subscribers.set(id, subscribers);
        // Return a cleanup function that will remove this callback from the list of subscribers
        return ()=>{
            const subscribersOnCleanup = this.subscribers.get(id) ?? [];
            this.subscribers.set(id, subscribersOnCleanup.filter((cb)=>cb !== callback));
        };
    }
    /**
	 * Notify subscribers that the HTML DOM node for an ID has been updated.
	 */ notifySubscribers(id) {
        const subscribers = this.subscribers.get(id) ?? [];
        subscribers.forEach((subscriber)=>{
            subscriber();
        });
    }
    constructor(){
        this.nudgeTargetsMap = new Map();
        this.subscribers = new Map();
    }
}
const $6a0467752d0c968a$export$9a533735412babca = ()=>$6a0467752d0c968a$var$NudgeController.instance;
const $6a0467752d0c968a$export$eb8a96124d659f2d = (id, shouldRegister = true)=>{
    const controller = $6a0467752d0c968a$export$9a533735412babca();
    const ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (shouldRegister) {
            const unregister = controller.registerNudgeTarget(id, ref);
            return ()=>{
                unregister();
            };
        }
    }, [
        controller,
        id,
        shouldRegister
    ]);
    return {
        ref: ref
    };
};

});

parcelRegister("jOXuX", function(module, exports) {

$parcel$export(module.exports, "isTailoredOnboardingScrumAndSoftwareKanbanEnabled", () => $4b94b4e85c1e2fc8$export$5dd90adc2e8ee137);
$parcel$export(module.exports, "isTailoredOnboardingEnabled", () => $4b94b4e85c1e2fc8$export$8eec918bc6d2ab67);
$parcel$export(module.exports, "isEligibleForTailoredOnboardingM3", () => $4b94b4e85c1e2fc8$export$54c132e77bb6d105);
$parcel$export(module.exports, "isEligibleForTailoredOnboardingScrumAndSoftwareKanban", () => $4b94b4e85c1e2fc8$export$713219ba4b63fe78);
$parcel$export(module.exports, "useIsTailoredOnboardingEnabledAndEligible", () => $4b94b4e85c1e2fc8$export$46047e5fecf4cae5);
$parcel$export(module.exports, "isTailoredOnboardingEnabledWithExposure", () => $4b94b4e85c1e2fc8$export$142e2425d224298f);
$parcel$export(module.exports, "useIsTailoredOnboardingM2p5EligibleWithExposure", () => $4b94b4e85c1e2fc8$export$fd0589feb622f26b);
$parcel$export(module.exports, "useIsScrumProject", () => $4b94b4e85c1e2fc8$export$f9373c9ef51fa1f4);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $bNm1d = parcelRequire("bNm1d");

var $gQEFa = parcelRequire("gQEFa");

var $dAfqg = parcelRequire("dAfqg");

var $58GFP = parcelRequire("58GFP");


var $cNd4s = parcelRequire("cNd4s");

var $8zOmE = parcelRequire("8zOmE");

var $2NMNM = parcelRequire("2NMNM");

var $43qGj = parcelRequire("43qGj");
const $4b94b4e85c1e2fc8$export$7889b94f54c2d416 = ()=>{
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('tailored_onboarding_m3');
    return (0, $4R6GH.fg)('tailored_onboarding_m3_gate') && expConfig.get('isEnabled', false);
};
const $4b94b4e85c1e2fc8$export$5dd90adc2e8ee137 = ()=>{
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('tailored_onboarding_scrum_and_software_kanban');
    return expConfig.get('isEnabled', false);
};
const $4b94b4e85c1e2fc8$export$8eec918bc6d2ab67 = ()=>{
    return $4b94b4e85c1e2fc8$export$7889b94f54c2d416() || $4b94b4e85c1e2fc8$export$5dd90adc2e8ee137();
};
const $4b94b4e85c1e2fc8$export$54c132e77bb6d105 = ({ teamType: teamType, templateKey: templateKey, isSiteAdmin: isSiteAdmin })=>{
    if (!isSiteAdmin) return false;
    const isSoftwareTeamType = teamType === (0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b);
    const isKanbanTemplate = templateKey?.startsWith((0, $58GFP.KANBAN_TEAM_MANAGED_KEY));
    if (isKanbanTemplate && !isSoftwareTeamType && $4b94b4e85c1e2fc8$export$7889b94f54c2d416()) return true;
    return false;
};
const $4b94b4e85c1e2fc8$export$713219ba4b63fe78 = ({ teamType: teamType, templateKey: templateKey, isSiteAdmin: isSiteAdmin, fireExposure: fireExposure = false, analyticEvent: analyticEvent })=>{
    if (!isSiteAdmin) return false;
    const isSoftwareTeamType = teamType === (0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b);
    const isScrumTemplate = templateKey?.startsWith((0, $58GFP.SCRUM_TEAM_MANAGED_KEY));
    const isKanbanTemplate = templateKey?.startsWith((0, $58GFP.KANBAN_TEAM_MANAGED_KEY));
    // Software Kanban or Scrum all Team Types
    if (isKanbanTemplate && isSoftwareTeamType || isScrumTemplate) {
        // User is eligible for experiment. Fires exposure for those in control too here
        if (fireExposure) {
            analyticEvent && (0, $8zOmE.fireTrackAnalytics)(analyticEvent, 'tailoredOnboardingWithScrumAndSoftwareKanban personalised', {
                teamType: teamType,
                templateKey: templateKey,
                isEnabled: (0, $6s1PB.expVal)('tailored_onboarding_scrum_and_software_kanban', 'isEnabled', false)
            });
            return (0, $6s1PB.expVal)('tailored_onboarding_scrum_and_software_kanban', 'isEnabled', false);
        }
        if ($4b94b4e85c1e2fc8$export$5dd90adc2e8ee137()) return true;
    }
    return false;
};
const $4b94b4e85c1e2fc8$export$5188e1ffa34f6a91 = ({ teamType: teamType, templateKey: templateKey, isSiteAdmin: isSiteAdmin })=>{
    return $4b94b4e85c1e2fc8$export$54c132e77bb6d105({
        teamType: teamType,
        templateKey: templateKey,
        isSiteAdmin: isSiteAdmin
    }) || $4b94b4e85c1e2fc8$export$713219ba4b63fe78({
        teamType: teamType,
        templateKey: templateKey,
        isSiteAdmin: isSiteAdmin
    });
};
const $4b94b4e85c1e2fc8$export$46047e5fecf4cae5 = ()=>{
    const isEnabled = $4b94b4e85c1e2fc8$export$8eec918bc6d2ab67();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const { data: projectData } = (0, $dAfqg.useProjectContext)();
    const projectType = projectData?.projectType;
    const isSoftwareProject = projectType === 'software';
    const shouldFetch = isEnabled && isSiteAdmin && isSoftwareProject;
    const { isReady: teamTypeIsReady, teamType: teamType } = (0, $bNm1d.useTeamTypeShortHand)({
        shouldFetch: shouldFetch
    });
    const { loading: projectContextLoading, data: projectContext } = (0, $dAfqg.useProjectContext)();
    const { isReady: templateKeyIsReady, data: templateKey } = (0, $gQEFa.useFetchInitialProjectTemplateName)({
        shouldFetch: shouldFetch,
        projectId: projectContext?.projectId
    });
    if (!isEnabled) return {
        isReady: true,
        isTailoredOnboardingM3EnabledAndEligible: false,
        isTailoredOnboardingScrumAndSoftwareKanbanEnabled: false
    };
    const isTailoredOnboardingM3EnabledAndEligible = $4b94b4e85c1e2fc8$export$54c132e77bb6d105({
        teamType: teamType,
        templateKey: templateKey,
        isSiteAdmin: isSiteAdmin
    });
    const isTailoredOnboardingEnabledWithScrumAndSoftware = $4b94b4e85c1e2fc8$export$713219ba4b63fe78({
        teamType: teamType,
        templateKey: templateKey,
        isSiteAdmin: isSiteAdmin
    });
    return {
        isReady: teamTypeIsReady && templateKeyIsReady && !projectContextLoading,
        isTailoredOnboardingM3EnabledAndEligible: isEnabled && isTailoredOnboardingM3EnabledAndEligible,
        isTailoredOnboardingScrumAndSoftwareKanbanEnabled: isEnabled && isTailoredOnboardingEnabledWithScrumAndSoftware,
        teamType: teamType
    };
};
const $4b94b4e85c1e2fc8$export$142e2425d224298f = ({ isSiteAdmin: isSiteAdmin, analyticEvent: analyticEvent, teamType: teamType, templateKey: templateKey })=>{
    if ($4b94b4e85c1e2fc8$export$54c132e77bb6d105({
        teamType: teamType,
        templateKey: templateKey,
        isSiteAdmin: isSiteAdmin
    })) {
        (0, $8zOmE.fireTrackAnalytics)(analyticEvent, 'tailoredM3Redirect personalised', {
            teamType: teamType,
            templateKey: templateKey,
            isEnabled: (0, $6s1PB.expVal)('tailored_onboarding_m3', 'isEnabled', false)
        });
        return (0, $6s1PB.expVal)('tailored_onboarding_m3', 'isEnabled', false);
    }
    return $4b94b4e85c1e2fc8$export$713219ba4b63fe78({
        teamType: teamType,
        templateKey: templateKey,
        isSiteAdmin: isSiteAdmin,
        fireExposure: true,
        analyticEvent: analyticEvent
    });
};
const $4b94b4e85c1e2fc8$export$fd0589feb622f26b = ({ isBusinessProject: isBusinessProject, isTrelloCrossflow: isTrelloCrossflow, isOnboarding: isOnboarding })=>{
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isBasicEligible = isSiteAdmin && isBusinessProject && !isTrelloCrossflow;
    const { isReady: teamTypeIsReady, teamType: teamType } = (0, $bNm1d.useTeamTypeShortHand)({
        shouldFetch: isBasicEligible
    });
    const isTargettedTeamType = ![
        (0, $6784cbc7d62e5d7c$export$4f3cb0844009af52),
        (0, $6784cbc7d62e5d7c$export$e4824f74b9879164)
    ].includes(teamType ?? '');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireOnce = (0, $5uXOq.useRef)(false);
    if (!isBasicEligible) return {
        isEligible: false,
        isReady: true
    };
    if (!teamTypeIsReady) return {
        isEligible: undefined,
        isReady: false
    };
    if (isBusinessProject && isSiteAdmin && isTargettedTeamType) {
        if (!fireOnce.current) {
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'tailoredM2p5 exposed', {
                teamType: teamType,
                isOnboarding: isOnboarding,
                isEnabled: (0, $6s1PB.expVal)('tailored_onboarding_m2p5', 'isEnabled', false)
            });
            fireOnce.current = true;
        }
        return {
            isEligible: (0, $6s1PB.expVal)('tailored_onboarding_m2p5', 'isEnabled', false),
            isReady: true,
            teamType: teamType
        };
    }
    return {
        isEligible: false,
        isReady: true,
        teamType: teamType
    };
};
const $4b94b4e85c1e2fc8$export$f9373c9ef51fa1f4 = ()=>{
    if (!$4b94b4e85c1e2fc8$export$5dd90adc2e8ee137()) return false;
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data: data } = (0, $43qGj.useFeatures)();
    return (data?.hasSprint && data?.hasBacklog) ?? false;
};

});
parcelRegister("bNm1d", function(module, exports) {

$parcel$export(module.exports, "useUserEmailDomain", () => $e92819165abac823$export$f95c1c6f997ec47f);
$parcel$export(module.exports, "useAtlassianAccount", () => $e92819165abac823$export$19d38f479bd18098);
$parcel$export(module.exports, "useTeamTypeShortHand", () => $e92819165abac823$export$1a086dfae472ccfe);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $6dDSs = parcelRequire("6dDSs");
var $iXqE5 = parcelRequire("iXqE5");

var $9yQlD = parcelRequire("9yQlD");


var $asmQK = parcelRequire("asmQK");

var $2LmB4 = parcelRequire("2LmB4");
const $e92819165abac823$export$d4c72bab9d6cc13a = {
    isFetching: false,
    wasFetchedOnce: false,
    fetchError: null
};
const $e92819165abac823$var$Store = (0, $iXqE5.createStore)({
    initialState: $e92819165abac823$export$d4c72bab9d6cc13a,
    actions: $2LmB4.actions,
    name: 'atlassian-account'
});
const $e92819165abac823$var$loggedInEmailDomainSelector = (0, $6dDSs.createSelector)((state)=>state.data, (accountInfo)=>{
    if (!accountInfo) return null;
    const [, loggedInEmailDomain] = accountInfo.email?.split('@') ?? [];
    return loggedInEmailDomain;
});
const $e92819165abac823$export$2a9b22328f7b68fa = (0, $3sQ5x.createHook)($e92819165abac823$var$Store, {
    selector: $e92819165abac823$var$loggedInEmailDomainSelector
});
const $e92819165abac823$export$f95c1c6f997ec47f = (isEligibleToCall = true)=>{
    const [loggedInEmailDomain, { fetchAtlassianAccountData: fetchAtlassianAccountData }] = $e92819165abac823$export$2a9b22328f7b68fa();
    (0, $5uXOq.useEffect)(()=>{
        if (isEligibleToCall && !loggedInEmailDomain) fetchAtlassianAccountData();
    }, [
        fetchAtlassianAccountData,
        isEligibleToCall,
        loggedInEmailDomain
    ]);
    return {
        data: loggedInEmailDomain
    };
};
const $e92819165abac823$export$19d38f479bd18098 = (0, $3sQ5x.createHook)($e92819165abac823$var$Store);
const $e92819165abac823$export$1a086dfae472ccfe = ({ shouldFetch: shouldFetch })=>{
    const [{ data: atlassianAccountData, isFetching: isFetching, wasFetchedOnce: wasFetchedOnce }, { fetchAtlassianAccountData: fetchAtlassianAccountData }] = $e92819165abac823$export$19d38f479bd18098();
    const localStorageTeamTypeShorthand = (0, $9yQlD.localStorageProvider).get((0, $6784cbc7d62e5d7c$export$c06666264cd35603));
    (0, $5uXOq.useEffect)(()=>{
        if (shouldFetch && !localStorageTeamTypeShorthand && !isFetching && !wasFetchedOnce) fetchAtlassianAccountData({
            source: 'useTeamTypeShortHand'
        });
    }, [
        fetchAtlassianAccountData,
        isFetching,
        localStorageTeamTypeShorthand,
        shouldFetch,
        wasFetchedOnce
    ]);
    if (localStorageTeamTypeShorthand) return {
        isReady: true,
        teamType: localStorageTeamTypeShorthand
    };
    if (!shouldFetch) return {
        isReady: true,
        teamType: (0, $asmQK.mapUserSegmentationFullToShorthand)(atlassianAccountData?.extendedProfile.teamType)
    };
    if (atlassianAccountData?.extendedProfile.teamType && !localStorageTeamTypeShorthand) (0, $9yQlD.localStorageProvider).set((0, $6784cbc7d62e5d7c$export$c06666264cd35603), (0, $asmQK.mapUserSegmentationFullToShorthand)(atlassianAccountData.extendedProfile.teamType));
    return {
        isReady: !isFetching && wasFetchedOnce,
        teamType: (0, $asmQK.mapUserSegmentationFullToShorthand)(atlassianAccountData?.extendedProfile.teamType)
    };
};

});
parcelRegister("9yQlD", function(module, exports) {

$parcel$export(module.exports, "sessionStorage", () => $816fbeb16311dd64$export$f119d83aa936d634);
$parcel$export(module.exports, "sessionStorageProvider", () => $816fbeb16311dd64$export$5a24cb3021127ff7);
$parcel$export(module.exports, "localStorageProvider", () => $816fbeb16311dd64$export$aa821bfb3308a1f5);

var $bSSG7 = parcelRequire("bSSG7");

var $eNf8a = parcelRequire("eNf8a");




const $816fbeb16311dd64$export$f119d83aa936d634 = (0, $eNf8a.createSessionExpirableStorageProvider)('onboarding-core');
const $816fbeb16311dd64$export$5a24cb3021127ff7 = (0, $eNf8a.createSessionExpirableStorageProvider)('onboarding-core');
const $816fbeb16311dd64$export$c2ed3351cac403d1 = (0, $bSSG7.createLocalExpirableStorageProvider)('onboarding-core');
const $816fbeb16311dd64$export$aa821bfb3308a1f5 = (0, $bSSG7.createLocalExpirableStorageProvider)('onboarding-core');

});

parcelRegister("asmQK", function(module, exports) {

$parcel$export(module.exports, "mapUserSegmentationFullToShorthand", () => $2244820289929c87$export$8897f7082e20c8df);

const $2244820289929c87$export$8897f7082e20c8df = (teamTypeFromMe)=>{
    switch(teamTypeFromMe){
        case 0, $6784cbc7d62e5d7c$export$e07d1fa2da8ed874:
            return 0, $6784cbc7d62e5d7c$export$572242e58bd07594;
        case 0, $6784cbc7d62e5d7c$export$76dcec3f438d9e56:
            return 0, $6784cbc7d62e5d7c$export$d7de553940261eba;
        case 0, $6784cbc7d62e5d7c$export$9a574c301f67ba30:
            return 0, $6784cbc7d62e5d7c$export$4c29d0d04c15e55d;
        case 0, $6784cbc7d62e5d7c$export$363ec144a94029c8:
            return 0, $6784cbc7d62e5d7c$export$3950f7f841bf94b6;
        case 0, $6784cbc7d62e5d7c$export$df0fb32d68ae1e78:
            return 0, $6784cbc7d62e5d7c$export$881249b988b6030f;
        case 0, $6784cbc7d62e5d7c$export$d9c0e3e59442fb4:
            return 0, $6784cbc7d62e5d7c$export$e4824f74b9879164;
        case 0, $6784cbc7d62e5d7c$export$27dbc7d7ce66e6e3:
            return 0, $6784cbc7d62e5d7c$export$4f3cb0844009af52;
        case 0, $6784cbc7d62e5d7c$export$a5dce388adf922bd:
            return 0, $6784cbc7d62e5d7c$export$1a65d50c4a641bb4;
        case 0, $6784cbc7d62e5d7c$export$e1473b31a257caff:
            return 0, $6784cbc7d62e5d7c$export$9ee64e8fbd8b03a2;
        case 0, $6784cbc7d62e5d7c$export$699265ec8ad9a740:
            return 0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b;
        case 0, $6784cbc7d62e5d7c$export$85657457db93c2c2:
            return 0, $6784cbc7d62e5d7c$export$4f54a09a24fd1d74;
        case 0, $6784cbc7d62e5d7c$export$c0c2d1dfaeba89dd:
            return 0, $6784cbc7d62e5d7c$export$79685802e8ff1098;
        case 0, $6784cbc7d62e5d7c$export$2e6a7ad3ab9c82a3:
            return 0, $6784cbc7d62e5d7c$export$e5c438b7501b5a24;
        case 0, $6784cbc7d62e5d7c$export$7b60378c3b4372e9:
            return 0, $6784cbc7d62e5d7c$export$cbc0e551d91a692d;
        default:
            return teamTypeFromMe;
    }
};

});

parcelRegister("2LmB4", function(module, exports) {

$parcel$export(module.exports, "actions", () => $263b01c2e713c075$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $fBogR = parcelRequire("fBogR");
const $263b01c2e713c075$export$e324594224ef24da = {
    fetchAtlassianAccountData: ({ source: source } = {})=>async ({ setState: setState, getState: getState })=>{
            const { isFetching: isFetching, wasFetchedOnce: wasFetchedOnce } = getState();
            if (isFetching || wasFetchedOnce) return;
            setState({
                isFetching: true
            });
            try {
                const data = await (0, $fBogR.getAtlassianAccountWithRethrow)({
                    source: source
                });
                if (data !== null) setState({
                    data: data
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    fetchError: error
                });
            } finally{
                setState({
                    isFetching: false,
                    wasFetchedOnce: true
                });
            }
        }
};

});
parcelRegister("fBogR", function(module, exports) {

$parcel$export(module.exports, "getAtlassianAccountWithRethrow", () => $284b5d88f7e7a408$export$1f20b0741dc598bc);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

const $284b5d88f7e7a408$export$1f20b0741dc598bc = async ({ source: source } = {})=>{
    try {
        const { extended_profile: { job_title: jobTitle, team_type: teamType }, email: email, account_id: accountId } = await (0, $eusud.performGetRequestWithRetry)((0, $53b7c6a1de61c1d4$export$80945eb3738bcee8));
        return {
            extendedProfile: {
                jobTitle: jobTitle,
                teamType: teamType
            },
            email: email,
            accountId: accountId
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'getAtlassianAccountWithRethrow',
                packageName: 'jiraAtlassianAccount',
                teamName: 'jlove-makkuro'
            },
            attributes: {
                source: source
            },
            error: error
        });
        throw error;
    }
};

});
const $53b7c6a1de61c1d4$export$80945eb3738bcee8 = '/gateway/api/me';




parcelRegister("gQEFa", function(module, exports) {

$parcel$export(module.exports, "useFetchInitialProjectTemplateName", () => $be0087b09b981e14$export$b11629f839f2f12a);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $ggwAD = parcelRequire("ggwAD");
const $be0087b09b981e14$export$d4c72bab9d6cc13a = {};
const $be0087b09b981e14$var$store = (0, $iXqE5.createStore)({
    name: 'jira-initial-project-template-name',
    initialState: $be0087b09b981e14$export$d4c72bab9d6cc13a,
    actions: $ggwAD.actions
});
const $be0087b09b981e14$export$ee6e247e51917971 = (0, $3sQ5x.createHook)($be0087b09b981e14$var$store);
const $be0087b09b981e14$export$b11629f839f2f12a = ({ shouldFetch: shouldFetch, projectId: projectId })=>{
    const [state, { fetchInitialProjectTemplateName: fetchInitialProjectTemplateName }] = $be0087b09b981e14$export$ee6e247e51917971();
    (0, $5uXOq.useEffect)(()=>{
        if (shouldFetch && projectId) fetchInitialProjectTemplateName(`${projectId}`);
    }, [
        fetchInitialProjectTemplateName,
        projectId,
        shouldFetch
    ]);
    if (!projectId) return {
        data: undefined,
        isReady: true
    };
    if (!shouldFetch) return {
        // Still return the data if it's already fetched
        // leave it to consumer to decide what to do with it
        data: state[`${projectId}`]?.templateKey,
        isReady: true
    };
    return {
        data: state[`${projectId}`]?.templateKey,
        isReady: state[`${projectId}`]?.fetchStatus === 'fetched'
    };
};

});
parcelRegister("ggwAD", function(module, exports) {

$parcel$export(module.exports, "actions", () => $7361e67f73cde4dc$export$e324594224ef24da);

var $2y6my = parcelRequire("2y6my");
const $7361e67f73cde4dc$export$e324594224ef24da = {
    fetchInitialProjectTemplateName: (0, $2y6my.fetchInitialProjectTemplateNameWithRethrow)
};

});
parcelRegister("2y6my", function(module, exports) {

$parcel$export(module.exports, "fetchInitialProjectTemplateNameWithRethrow", () => $a69f9ed7a08e4d60$export$c837cab65def4654);

var $1sYcL = parcelRequire("1sYcL");

var $jcw0u = parcelRequire("jcw0u");

var $5fQRY = parcelRequire("5fQRY");
const $a69f9ed7a08e4d60$export$c837cab65def4654 = (projectId)=>async ({ getState: getState, setState: setState })=>{
        try {
            const currentState = getState();
            const currentStateForProjectId = currentState[projectId];
            if (currentStateForProjectId?.fetchStatus === 'fetched' || currentStateForProjectId?.fetchStatus === 'fetching') return;
            const localStorageInitialProjectTemplateName = (0, $5fQRY.getLocalStorageInitialProjectTemplateName)({
                projectId: projectId
            });
            if (localStorageInitialProjectTemplateName) {
                setState({
                    [projectId]: {
                        fetchStatus: 'fetched',
                        templateKey: localStorageInitialProjectTemplateName
                    }
                });
                return;
            }
            setState({
                [projectId]: {
                    ...currentStateForProjectId,
                    fetchStatus: 'fetching'
                }
            });
            const response = await (0, $1sYcL.get)({
                consumerMeta: {
                    id: 'fetchInitialProjectTemplateNameWithRethrow',
                    packageName: '@atlassian/jira-onboarding-core',
                    teamName: 'Jlove-Makkuro'
                },
                projectId: projectId,
                projectProperties: [
                    'initial.project.template.name'
                ]
            });
            const templateKey = response?.project?.['initial.project.template.name'];
            if (templateKey) {
                (0, $5fQRY.setLocalStorageInitialProjectTemplateName)({
                    projectId: projectId,
                    templateKey: templateKey
                });
                setState({
                    [projectId]: {
                        fetchStatus: 'fetched',
                        templateKey: templateKey
                    }
                });
            } else setState({
                [projectId]: {
                    fetchStatus: 'fetched',
                    templateKey: ''
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'fetchInitialProjectTemplateNameWithRethrow',
                    packageName: 'jiraOnboardingCore',
                    teamName: 'jlove-makkuro'
                }
            });
            setState({
                [projectId]: {
                    fetchStatus: 'fetched',
                    templateKey: ''
                }
            });
        }
    };

});
parcelRegister("5fQRY", function(module, exports) {

$parcel$export(module.exports, "getLocalStorageInitialProjectTemplateName", () => $fa50145683a10f14$export$82cce58d3eca5268);
$parcel$export(module.exports, "setLocalStorageInitialProjectTemplateName", () => $fa50145683a10f14$export$8767e71370b25cc2);

var $bSSG7 = parcelRequire("bSSG7");

var $jcw0u = parcelRequire("jcw0u");
const $fa50145683a10f14$var$localStorageProvider = (0, $bSSG7.createLocalStorageProvider)('jira-initial-project-template-name');
const $fa50145683a10f14$export$82cce58d3eca5268 = ({ projectId: projectId })=>{
    try {
        return $fa50145683a10f14$var$localStorageProvider.get(projectId);
    } catch (error) {
        const typeGuardedError = error instanceof Error ? error : new Error('getLocalStorageInitialProjectTemplateName');
        (0, $jcw0u.default)({
            error: typeGuardedError,
            meta: {
                id: 'getLocalStorageInitialProjectTemplateName',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            }
        });
        return undefined;
    }
};
const $fa50145683a10f14$export$8767e71370b25cc2 = ({ projectId: projectId, templateKey: templateKey })=>{
    try {
        $fa50145683a10f14$var$localStorageProvider.set(projectId, templateKey);
    } catch (error) {
        const typeGuardedError = error instanceof Error ? error : new Error('localStorageSetOnboardingPersonalisationResponse');
        (0, $jcw0u.default)({
            error: typeGuardedError,
            meta: {
                id: 'localStorageSetOnboardingPersonalisationResponse',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            }
        });
    }
};

});




parcelRegister("43qGj", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $64d4caaed133b77d$export$4a39035bacc4ed76);

var $5uXOq = parcelRequire("5uXOq");

var $1J3t1 = parcelRequire("1J3t1");

var $4bPSV = parcelRequire("4bPSV");

var $hDSPU = parcelRequire("hDSPU");

var $iHqA4 = parcelRequire("iHqA4");

var $j8sa8 = parcelRequire("j8sa8");
const $64d4caaed133b77d$export$4a39035bacc4ed76 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useJiraSoftwareProjectNavigation)();
    const isEligibleForFeatureToggle = (0, $j8sa8.useShouldApplyFeatureToggle)();
    const [sidebarFeatureToggled] = (0, $hDSPU.useSidebarFeatureToggled)();
    const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, $4bPSV.extractData)(data), [
        data
    ]);
    // merged feature status before navigation resource gets refreshed
    // if and only if there are features toggled and they are eligible for the feature
    const features = (0, $5uXOq.useMemo)(()=>{
        if (!extractedData || !isEligibleForFeatureToggle || !sidebarFeatureToggled) return extractedData;
        return {
            ...extractedData,
            ...sidebarFeatureToggled
        };
    }, [
        extractedData,
        isEligibleForFeatureToggle,
        sidebarFeatureToggled
    ]);
    (0, $iHqA4.useClearSidebarToggled)();
    return {
        data: features,
        loading: loading,
        error: error
    };
};

});
parcelRegister("4bPSV", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $4795c1c4367ea315$export$9df5fa0a366163d2);

var $6s1PB = parcelRequire("6s1PB");
const $4795c1c4367ea315$export$9df5fa0a366163d2 = (navData)=>{
    const { permissionInfo: permissionInfo, hasBacklog: hasBacklog, hasBoard: hasBoard, hasCode: hasCode, hasGoals: hasGoals, hasGetStarted: hasGetStarted, hasSecurity: hasSecurity, hasDeployments: hasDeployments, hasDevelopment: hasDevelopment, hasList: hasList, hasOpsgenieSchedule: hasOpsgenieSchedule, hasPages: hasPages, hasReleases: hasReleases, hasRoadmap: hasRoadmap, hasReports: hasReports, hasRequests: hasRequests, hasIssues: hasIssues, hasSprint: hasSprint, hasIncidents: hasIncidents, hasCalendar: hasCalendar, hasForms: hasForms, hasSummaryPage: hasSummaryPage, aiInfo: aiInfo, hasArchivedIssues: hasArchivedIssues = false } = navData;
    const isProjectOrJiraAdmin = permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS === true;
    return {
        hasArchivedIssues: hasArchivedIssues,
        hasBacklog: hasBacklog,
        hasBoard: hasBoard,
        hasRoadmap: hasRoadmap,
        hasCode: hasCode,
        hasGoals: hasGoals,
        hasGetStarted: isProjectOrJiraAdmin && hasGetStarted,
        hasSecurity: hasSecurity,
        hasDeployments: hasDeployments,
        hasDevelopment: hasDevelopment,
        hasList: (0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation') ? hasList : false,
        hasReleases: hasReleases,
        hasSIN: hasIssues,
        hasReports: hasReports,
        hasRequests: hasRequests,
        hasPages: hasPages,
        hasOpsgenie: hasOpsgenieSchedule,
        hasShortcutsAdd: isProjectOrJiraAdmin,
        hasSettings: isProjectOrJiraAdmin,
        hasSprint: hasSprint,
        hasIncidents: hasIncidents,
        hasCalendar: hasCalendar,
        hasForms: (0, $6s1PB.expValEquals)('forms_for_jsw_experiment', 'isEnabled', true) && hasForms,
        hasSummaryPage: hasSummaryPage,
        hasAIInNIN: hasIssues && aiInfo?.isEnabledInIssueNavigator === true
    };
};

});

parcelRegister("hDSPU", function(module, exports) {

$parcel$export(module.exports, "useFeature", () => $605ea180d8f833cc$export$fc97652867e5867e);
$parcel$export(module.exports, "useEnablingFeature", () => $605ea180d8f833cc$export$207b461610a7fca6);
$parcel$export(module.exports, "useSidebarFeatureToggled", () => $605ea180d8f833cc$export$9eef668f94562feb);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $6wyfe = parcelRequire("6wyfe");
const $605ea180d8f833cc$var$initialState = {
    features: [],
    isLoading: false,
    enablingFeatures: [],
    isFetchError: false,
    sidebarFeatureToggled: null
};
const $605ea180d8f833cc$var$store = (0, $iXqE5.createStore)({
    name: 'feature-toggle',
    initialState: $605ea180d8f833cc$var$initialState,
    actions: $6wyfe.actions
});
const $605ea180d8f833cc$export$fc97652867e5867e = (0, $3sQ5x.createHook)($605ea180d8f833cc$var$store);
const $605ea180d8f833cc$export$207b461610a7fca6 = (0, $3sQ5x.createHook)($605ea180d8f833cc$var$store, {
    selector: (state, { feature: feature })=>state.enablingFeatures.some((f)=>f === feature)
});
const $605ea180d8f833cc$export$e7699ed698eeb9ec = (0, $3sQ5x.createHook)($605ea180d8f833cc$var$store, {
    selector: (state, { feature: feature })=>state.features.find((f)=>f.feature === feature)?.state
});
const $605ea180d8f833cc$export$9eef668f94562feb = (0, $3sQ5x.createHook)($605ea180d8f833cc$var$store, {
    selector: (state)=>state.sidebarFeatureToggled
});

});
parcelRegister("6wyfe", function(module, exports) {

$parcel$export(module.exports, "actions", () => $158a47dbcbb0832b$export$e324594224ef24da);

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $8zOmE = parcelRequire("8zOmE");

var $3Jf4N = parcelRequire("3Jf4N");

var $czzsL = parcelRequire("czzsL");

var $iZZTd = parcelRequire("iZZTd");

var $ke207 = parcelRequire("ke207");
const $158a47dbcbb0832b$var$clearSiderbarFeatureToggled = ()=>({ setState: setState })=>{
        setState({
            sidebarFeatureToggled: null
        });
    };
const $158a47dbcbb0832b$var$fetchFeatures = (boardId)=>async ({ getState: getState, setState: setState })=>{
        const { features: features, isLoading: isLoading } = getState();
        if (isLoading) return;
        setState({
            isFetchError: false
        });
        try {
            if (features.length === 0) {
                setState({
                    isLoading: true
                });
                const data = await (0, $iZZTd.getBoardFeatures)(boardId);
                const filteredFeatures = (0, $czzsL.filterAndSort)(data);
                (0, $czzsL.fireErrorAnalyticsOnUnmatchFeatureKey)(filteredFeatures);
                setState({
                    isLoading: false,
                    features: filteredFeatures
                });
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                isFetchError: true,
                isLoading: false
            });
            (0, $jcw0u.default)({
                meta: {
                    ...(0, $3Jf4N.commonErrorAnalyticsMeta),
                    id: 'fetchFeatures'
                },
                error: error
            });
        }
    };
const $158a47dbcbb0832b$var$syncFeatures = (sidebarFeatureStatus)=>({ getState: getState, setState: setState })=>{
        const { features: features } = getState();
        const featureMap = (0, $3Jf4N.getFeatureMap)({
            isListViewEnabled: (0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation')
        });
        const synced = features.map((f)=>{
            const id = f.feature;
            if (featureMap[id]) {
                const { statusKey: statusKey } = featureMap[id];
                return {
                    ...f,
                    state: sidebarFeatureStatus[statusKey] ? 'ENABLED' : 'DISABLED'
                };
            }
            return f;
        });
        setState({
            features: synced
        });
    };
const $158a47dbcbb0832b$var$updateFeature = ({ boardId: boardId, feature: feature, dependentFeature: dependentFeature, analyticsEvent: analyticsEvent, onError: onError, onAfterUpdate: onAfterUpdate })=>async ({ getState: getState, setState: setState })=>{
        const { features: features, enablingFeatures: enablingFeatures, sidebarFeatureToggled: sidebarFeatureToggled } = getState();
        let featureMap = (0, $3Jf4N.getFeatureMap)();
        if ((0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation')) featureMap = {
            ...featureMap,
            ...(0, $3Jf4N.listFeature)
        };
        const currentStatus = features.find((f)=>f.feature === feature)?.state;
        const isEnabling = currentStatus === 'DISABLED';
        if (!boardId || feature.length === 0 || !currentStatus) return;
        try {
            // Optimistically update the toggle status before the API call finishes
            // and add feature to the enabling states
            setState({
                features: features.map((0, $czzsL.updateFeatureState)(feature, dependentFeature)),
                sidebarFeatureToggled: {
                    ...sidebarFeatureToggled ?? {},
                    [featureMap[feature].statusKey]: isEnabling,
                    ...dependentFeature && {
                        [featureMap[dependentFeature].statusKey]: isEnabling
                    }
                },
                ...isEnabling && {
                    enablingFeatures: [
                        ...enablingFeatures,
                        feature
                    ]
                }
            });
            await (0, $ke207.updateBoardFeature)({
                boardId: boardId,
                feature: feature,
                enabling: isEnabling
            });
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'featureStatus updated', {
                featureId: feature,
                newStatus: currentStatus
            });
            onAfterUpdate?.(feature, isEnabling);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            onError?.();
            setState({
                features: features,
                sidebarFeatureToggled: sidebarFeatureToggled
            });
            (0, $jcw0u.default)({
                meta: {
                    ...(0, $3Jf4N.commonErrorAnalyticsMeta),
                    id: 'updateFeature'
                },
                error: error
            });
        }
        if (isEnabling) setState({
            // feature has been enabled, remove from enabling state
            enablingFeatures: getState().enablingFeatures.filter((f)=>f !== feature)
        });
    };
const $158a47dbcbb0832b$export$e324594224ef24da = {
    fetchFeatures: $158a47dbcbb0832b$var$fetchFeatures,
    updateFeature: $158a47dbcbb0832b$var$updateFeature,
    syncFeatures: $158a47dbcbb0832b$var$syncFeatures,
    clearSiderbarFeatureToggled: $158a47dbcbb0832b$var$clearSiderbarFeatureToggled
};

});
parcelRegister("3Jf4N", function(module, exports) {

$parcel$export(module.exports, "commonErrorAnalyticsMeta", () => $d07f845012e39eac$export$47825241dc3c472c);
$parcel$export(module.exports, "MANAGE_FEATURE_MENU_ITEM_TEST_ID", () => $d07f845012e39eac$export$143e1d685830adbe);
$parcel$export(module.exports, "listFeature", () => $d07f845012e39eac$export$4ddfd7a9f5527982);
$parcel$export(module.exports, "getFeatureMap", () => $d07f845012e39eac$export$6ac50cf33852adb5);
$parcel$export(module.exports, "ERROR_FLAG_ID", () => $d07f845012e39eac$export$f5e4c120ac01b615);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $8QpSo = parcelRequire("8QpSo");

var $QasRB = parcelRequire("QasRB");

var $dME4E = parcelRequire("dME4E");

var $aZ5rg = parcelRequire("aZ5rg");

var $lfDf7 = parcelRequire("lfDf7");

var $eQfWH = parcelRequire("eQfWH");

var $k2Gga = parcelRequire("k2Gga");
const $d07f845012e39eac$export$47825241dc3c472c = {
    packageName: 'jiraTmpFeatureToggle',
    teamName: 'jlove-makkuro'
};
const $d07f845012e39eac$export$143e1d685830adbe = 'manage-feature-menu-item';
const $d07f845012e39eac$export$4ddfd7a9f5527982 = {
    'jsw.agility.list_view': {
        descriptionKey: 'listDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aZ5rg))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasList',
        order: 35,
        redirectOn: [
            'software-list'
        ]
    }
};
const $d07f845012e39eac$export$a712b1e96d47b856 = {
    'jsw.agility.simple-roadmap': {
        descriptionKey: 'timelineDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k2Gga))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasRoadmap',
        order: 10,
        redirectOn: [
            'software-timeline',
            'software-roadmap'
        ]
    },
    'jsw.agility.backlog': {
        descriptionKey: 'backlogDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($QasRB))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasBacklog',
        order: 20,
        redirectOn: [
            'software-backlog'
        ]
    },
    'jsw.agility.board': {
        descriptionKey: 'boardDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dME4E))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasBoard',
        order: 30
    },
    'jsw.agility.issue_navigator': {
        descriptionKey: 'issueNavigatorDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lfDf7))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasSIN',
        order: 40,
        redirectOn: [
            'software-issue-navigator',
            'issue'
        ]
    },
    'jsw.agility.sprints': {
        descriptionKey: 'releasesDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        statusKey: 'hasSprint',
        order: 50,
        isHidden: true
    }
}; // satisfies Partial<Record<ToggleableFeatureKey, FeatureProperties>>
const $d07f845012e39eac$export$6ac50cf33852adb5 = (0, $8QpSo.default)(({ isSimplifyNavExperimentEnabled: isSimplifyNavExperimentEnabled, isListViewEnabled: isListViewEnabled } = {})=>({
        'jsw.agility.simple-roadmap': {
            descriptionKey: 'timelineDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k2Gga))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasRoadmap',
            order: 10,
            redirectOn: [
                'software-timeline',
                'software-roadmap'
            ]
        },
        'jsw.agility.backlog': {
            descriptionKey: 'backlogDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($QasRB))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasBacklog',
            order: 20,
            redirectOn: [
                'software-backlog'
            ]
        },
        'jsw.agility.board': {
            descriptionKey: 'boardDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dME4E))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasBoard',
            order: 30
        },
        ...!isSimplifyNavExperimentEnabled && {
            'jsw.agility.issue_navigator': {
                descriptionKey: 'issueNavigatorDescription',
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lfDf7))), {
                    spacing: "spacious",
                    label: ""
                }),
                statusKey: 'hasSIN',
                order: 40,
                redirectOn: [
                    'software-issue-navigator',
                    'issue'
                ]
            }
        },
        'jsw.agility.sprints': {
            descriptionKey: 'releasesDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
            statusKey: 'hasSprint',
            order: 50,
            isHidden: true
        },
        'jsw.agility.pages': {
            descriptionKey: 'projectPagesDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eQfWH))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasPages',
            order: 60,
            redirectOn: [
                'project-pages'
            ]
        },
        ...isListViewEnabled && $d07f845012e39eac$export$4ddfd7a9f5527982
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))); // satisfies Partial<Record<ToggleableFeatureKey, FeatureProperties>>;
const $d07f845012e39eac$export$f5e4c120ac01b615 = 'feature-toggle-error-flag';

});

parcelRegister("czzsL", function(module, exports) {

$parcel$export(module.exports, "filterAndSort", () => $0a04151ee5a00965$export$d0e0de50c701304c);
$parcel$export(module.exports, "findDependentFeature", () => $0a04151ee5a00965$export$4c8205136225a4e2);
$parcel$export(module.exports, "updateFeatureState", () => $0a04151ee5a00965$export$2bdeae30201d513c);
$parcel$export(module.exports, "fireErrorAnalyticsOnUnmatchFeatureKey", () => $0a04151ee5a00965$export$5da1e8c5ba5c0dc2);

var $hqTkp = parcelRequire("hqTkp");

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $3Jf4N = parcelRequire("3Jf4N");
const $0a04151ee5a00965$export$b70265791d2079d4 = (hasFeature)=>hasFeature ? 'ENABLED' : 'DISABLED';
const $0a04151ee5a00965$export$d0e0de50c701304c = (features)=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_simplify_navigation_m2');
    const featureMap = (0, $3Jf4N.getFeatureMap)({
        isSimplifyNavExperimentEnabled: expConfig.get('isEnabled', false),
        isListViewEnabled: (0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation')
    });
    return features.filter((f)=>Object.keys(featureMap).includes(f.feature)).sort((a, b)=>featureMap[a.feature].order - featureMap[b.feature].order);
};
const $0a04151ee5a00965$export$4c8205136225a4e2 = (features, featureId)=>{
    const featureToDisable = features.find((f)=>f.feature === featureId);
    // Will only show the modal when the current status is enabled for both the feature to disable and the dependent feature
    if (featureToDisable?.state !== 'ENABLED') return undefined;
    // For the scope of the feature toggle, we assume there is only one dependency for now
    return features.find((f)=>f.prerequisites.includes(featureId) && f.state === 'ENABLED');
};
const $0a04151ee5a00965$export$2bdeae30201d513c = (featureId, dependentFeatureId)=>(feature)=>feature.feature === featureId || dependentFeatureId && feature.feature === dependentFeatureId ? {
            ...feature,
            state: feature.state === 'ENABLED' ? 'DISABLED' : 'ENABLED'
        } : feature;
const $0a04151ee5a00965$export$5da1e8c5ba5c0dc2 = (filteredFeatures)=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_simplify_navigation_m2');
    const featureMap = (0, $3Jf4N.getFeatureMap)({
        isSimplifyNavExperimentEnabled: expConfig.get('isEnabled', false),
        isListViewEnabled: (0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation')
    });
    if (filteredFeatures.length < Object.keys(featureMap).length) {
        const unmatchedFeatureKeys = (0, (/*@__PURE__*/$parcel$interopDefault($hqTkp)))(Object.keys(featureMap), ...filteredFeatures.map((f)=>f.feature));
        (0, $jcw0u.default)({
            error: new Error("Some feature keys don't match . Please check API response"),
            meta: {
                ...(0, $3Jf4N.commonErrorAnalyticsMeta),
                id: 'unmatchFeatureKey'
            },
            attributes: {
                unmatchedFeatureKeys: unmatchedFeatureKeys.toString()
            }
        });
    }
};

});

parcelRegister("iZZTd", function(module, exports) {

$parcel$export(module.exports, "getBoardFeatures", () => $140b4a0769fd2090$export$c20100b185d41ab0);

var $eusud = parcelRequire("eusud");

var $8djOx = parcelRequire("8djOx");
const $140b4a0769fd2090$export$c20100b185d41ab0 = async (boardId)=>{
    const data = await (0, $eusud.performGetRequest)((0, $8djOx.getBoardFeaturesUrl)(boardId));
    return data.features;
};

});
parcelRegister("8djOx", function(module, exports) {

$parcel$export(module.exports, "getBoardFeaturesUrl", () => $45a3789113fa4e8b$export$3f9939d302766b52);
const $45a3789113fa4e8b$export$3f9939d302766b52 = (boardId)=>`/rest/agile/latest/board/${boardId}/features`;

});


parcelRegister("ke207", function(module, exports) {

$parcel$export(module.exports, "updateBoardFeature", () => $1ce9149bd154bcf9$export$61f6bbb745b3a3);

var $eusud = parcelRequire("eusud");

var $8djOx = parcelRequire("8djOx");
const $1ce9149bd154bcf9$export$61f6bbb745b3a3 = async (request)=>{
    // it returns the board features array, but we don't use it for optimistic update
    // feature state is used instead to indicate if the updates successful or not
    const data = await (0, $eusud.performPutRequest)((0, $8djOx.getBoardFeaturesUrl)(request.boardId), {
        body: JSON.stringify(request)
    });
    const newState = data.features.find((f)=>f.feature === request.feature)?.state;
    return newState ?? (request.enabling ? 'ENABLED' : 'DISABLED');
};

});



parcelRegister("iHqA4", function(module, exports) {

$parcel$export(module.exports, "useClearSidebarToggled", () => $b80f211a69d994c6$export$2946f555c6f48127);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $1J3t1 = parcelRequire("1J3t1");

var $1XJ20 = parcelRequire("1XJ20");

var $hDSPU = parcelRequire("hDSPU");

var $j8sa8 = parcelRequire("j8sa8");
const $b80f211a69d994c6$export$2946f555c6f48127 = ()=>{
    const { data: data, refresh: refresh } = (0, $1J3t1.useJiraSoftwareProjectNavigation)();
    const [sidebarFeatureToggled, { clearSiderbarFeatureToggled: clearSiderbarFeatureToggled }] = (0, $hDSPU.useSidebarFeatureToggled)();
    const isEligibleForFeatureToggle = (0, $j8sa8.useShouldApplyFeatureToggle)();
    const sidebarHasChanged = (0, $5uXOq.useRef)(false);
    const previousData = (0, $1XJ20.usePreviousWithInitial)(data);
    // if resource data has changed since the last refresh then remove the sidebar toggled data.
    // i.e. whatever that has been toggled is reflected on the latest resource
    const shouldClear = (0, $5uXOq.useMemo)(()=>isEligibleForFeatureToggle && !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(previousData, data), [
        isEligibleForFeatureToggle,
        previousData,
        data
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (shouldClear) clearSiderbarFeatureToggled();
    }, [
        shouldClear,
        clearSiderbarFeatureToggled
    ]);
    (0, $5uXOq.useEffect)(()=>{
        sidebarHasChanged.current = isEligibleForFeatureToggle && !!sidebarFeatureToggled;
    }, [
        isEligibleForFeatureToggle,
        sidebarFeatureToggled
    ]);
    // refresh the navigation resource if sidebar has changed
    (0, $5uXOq.useEffect)(()=>()=>{
            if (sidebarHasChanged.current) refresh();
        }, [
        refresh
    ]);
};

});
parcelRegister("1XJ20", function(module, exports) {

$parcel$export(module.exports, "usePrevious", () => $011794d66b906d20$export$5cae361ad82dce8b);
$parcel$export(module.exports, "usePreviousPersistent", () => $011794d66b906d20$export$9c42f2690cfe6963);
$parcel$export(module.exports, "usePreviousWithInitial", () => $011794d66b906d20$export$23fbbb2e62c4a911);

var $5uXOq = parcelRequire("5uXOq");
const $011794d66b906d20$export$5cae361ad82dce8b = (value)=>{
    const ref = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $011794d66b906d20$export$9c42f2690cfe6963 = (value)=>{
    // initialise the ref with previous and current values
    const ref = (0, $5uXOq.useRef)({
        value: value,
        prev: undefined
    });
    const current = ref.current.value;
    // if the value passed into hook doesn't match what we store as "current"
    // move the "current" to the "previous"
    // and store the passed value as "current"
    if (value !== current) ref.current = {
        value: value,
        prev: current
    };
    // return the previous value only
    return ref.current.prev;
};
const $011794d66b906d20$export$23fbbb2e62c4a911 = (value)=>{
    const ref = (0, $5uXOq.useRef)(value);
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};

});

parcelRegister("j8sa8", function(module, exports) {

$parcel$export(module.exports, "useShouldApplyFeatureToggle", () => $d568e02a383436d9$export$7deca16ba2d9eb74);

var $2vSU6 = parcelRequire("2vSU6");

var $dAfqg = parcelRequire("dAfqg");

var $dkqym = parcelRequire("dkqym");
const $d568e02a383436d9$export$7deca16ba2d9eb74 = ()=>{
    const { data: project } = (0, $dAfqg.useProjectContext)();
    const firstActivationDateMs = (0, $dkqym.useFirstActivationDateMs)() || 0;
    const isJSW = project?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    const isTMP = !!project?.simplified;
    const isProjectAdmin = !!project?.isProjectAdmin;
    const isNewInstance = new Date(firstActivationDateMs) >= new Date('2023-09-25T15:00:00');
    return isJSW && isTMP && isProjectAdmin && isNewInstance;
};

});
parcelRegister("dkqym", function(module, exports) {

$parcel$export(module.exports, "useFirstActivationDateMs", () => $61794ef454831b86$export$9df3a539e50a284b);

var $9OXo1 = parcelRequire("9OXo1");
const $61794ef454831b86$export$9df3a539e50a284b = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.firstActivationDateMs != null ? tenantContext.firstActivationDateMs : null;
};

});





parcelRegister("at1Nr", function(module, exports) {

$parcel$export(module.exports, "InviteTeamNudgeAsync", () => $8b5bfc2ae277a997$export$a4b4061b22dbc897);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");


var $cE2Qr = parcelRequire("cE2Qr");


var $ahfXN = parcelRequire("ahfXN");
const $8b5bfc2ae277a997$var$runtimeProps = {};
const $8b5bfc2ae277a997$var$entryPointParams = {};
const $8b5bfc2ae277a997$export$a4b4061b22dbc897 = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $ahfXN.inviteTeamNudgeEntryPoint), $8b5bfc2ae277a997$var$entryPointParams);
    const [nudgeStep] = (0, $cE2Qr.useNudgeStep)();
    const [hasNudgeActive] = (0, $cE2Qr.useHasNudgeActive)();
    const firstLoadRef = (0, $5uXOq.useRef)(true);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (firstLoadRef.current && hasNudgeActive && nudgeStep === (0, $6784cbc7d62e5d7c$export$77bc79debbf5c069)) {
            entryPointActions.load();
            firstLoadRef.current = false;
        }
    }, [
        entryPointActions,
        hasNudgeActive,
        nudgeStep
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: (0, $dbbf68c32d8c4308$export$3bc551fe07069f89),
        packageName: "jiraInviteTeamOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        runtimeProps: $8b5bfc2ae277a997$var$runtimeProps
    });
};

});
const $dbbf68c32d8c4308$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $dbbf68c32d8c4308$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $dbbf68c32d8c4308$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $dbbf68c32d8c4308$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $dbbf68c32d8c4308$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $dbbf68c32d8c4308$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $dbbf68c32d8c4308$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $dbbf68c32d8c4308$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $dbbf68c32d8c4308$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $dbbf68c32d8c4308$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $dbbf68c32d8c4308$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $dbbf68c32d8c4308$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $dbbf68c32d8c4308$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $dbbf68c32d8c4308$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $dbbf68c32d8c4308$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $dbbf68c32d8c4308$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $dbbf68c32d8c4308$export$f8bf435a6066832c = 'button clicked';
const $dbbf68c32d8c4308$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $dbbf68c32d8c4308$export$d99767a37baddfc = 'sampleProjectDataNudge';
const $dbbf68c32d8c4308$export$2ef41782ca91324c = 'businessSampleDataNudge';
const $dbbf68c32d8c4308$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $dbbf68c32d8c4308$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $dbbf68c32d8c4308$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $dbbf68c32d8c4308$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $dbbf68c32d8c4308$export$5908fa8acd2c0739 = 'filterListNudge';
const $dbbf68c32d8c4308$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $dbbf68c32d8c4308$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $dbbf68c32d8c4308$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $dbbf68c32d8c4308$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $dbbf68c32d8c4308$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $dbbf68c32d8c4308$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $dbbf68c32d8c4308$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $dbbf68c32d8c4308$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $dbbf68c32d8c4308$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $dbbf68c32d8c4308$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $dbbf68c32d8c4308$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $dbbf68c32d8c4308$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $dbbf68c32d8c4308$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $dbbf68c32d8c4308$export$a1be34032ee24f78 = 'shareProjectNudge';
const $dbbf68c32d8c4308$export$29fe6611cc093756 = 'summaryTabNudge';
const $dbbf68c32d8c4308$export$f107c06c0830f09d = 'reportsTabNudge';
const $dbbf68c32d8c4308$export$9749a972a54ad7ba = 'boardContainerNudge';
const $dbbf68c32d8c4308$export$fb4f98ca3ff0420 = 'businessSampleDataNudge';
const $dbbf68c32d8c4308$export$b7fd448c62b5fb97 = 'listview';
const $dbbf68c32d8c4308$export$10c63dc5c09466d2 = 'boardview';
const $dbbf68c32d8c4308$export$75b8d65228d517e9 = 'sampleProjectScrumTourNudge';
const $dbbf68c32d8c4308$export$59a47f76d45b99 = 'sampleProjectScrumSprintNudge';
const $dbbf68c32d8c4308$export$513a9459cd6c3f96 = 'sampleProjectScrumBacklogNudge';
const $dbbf68c32d8c4308$export$657cdc4d7e8d9e5f = 'sampleProjectScrumBoardNudge';
const $dbbf68c32d8c4308$export$e16b25a220be9f3b = 'sampleProjectBoardNudge';
const $dbbf68c32d8c4308$export$c2f124710ac3a3ab = 'sampleProjectListNudge';
const $dbbf68c32d8c4308$export$b1c1e2ff4cbedbe = 'sampleProjectScrumSprintNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$b230ed22c9a186d5 = 'sampleProjectScrumBacklogNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$a321b777cf077071 = 'sampleProjectScrumBoardNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$b51b409cb5508624 = 'sampleProjectBoardNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$9757a1f68dc7a9b = 'sampleProjectListNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$63a886637b84800 = 'sampleProjectNavTourNudge';
const $dbbf68c32d8c4308$export$bb40993d16db4a4b = 'SampleProjectNavNudge';
const $dbbf68c32d8c4308$export$8c300ac9d8c53332 = 'SampleProjectNavNudgeErrorBoundary';

parcelRegister("ahfXN", function(module, exports) {

$parcel$export(module.exports, "inviteTeamNudgeEntryPoint", () => $140395164e9a1c0c$export$ff76bc343b4103b1);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $140395164e9a1c0c$export$ff76bc343b4103b1 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("6PgXT")), {
        moduleId: "4ca4d8af",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("6PgXT", function(module, exports) {

let $4f84aa61ae3792ec$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4f84aa61ae3792ec$var$load("keCTG").then(()=>parcelRequire('guBtq'));

});



parcelRegister("eXCTi", function(module, exports) {

$parcel$export(module.exports, "default", () => $93106a52315d7964$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $93106a52315d7964$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addButton: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-teams.common.action-buttons.add-button",
        "defaultMessage": "Create or invite"
    },
    createTeam: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-teams.common.action-buttons.create-team",
        "defaultMessage": "Create a team"
    },
    invitePeople: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-teams.common.action-buttons.invite-people",
        "defaultMessage": "Invite people"
    },
    inviteRecommendationsFromSlack: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-teams.invite-recommendations-from-slack",
        "defaultMessage": "{email} (Found in slack)"
    }
});

});

parcelRegister("eA0nk", function(module, exports) {

$parcel$export(module.exports, "useCreateTeamModal", () => $7ef2ce65db55ab3d$export$5458b68a653f4bfe);

var $5uXOq = parcelRequire("5uXOq");

var $euiLX = parcelRequire("euiLX");

var $pa9q9 = parcelRequire("pa9q9");

var $1wpPp = parcelRequire("1wpPp");

var $4ywcn = parcelRequire("4ywcn");

var $8igKv = parcelRequire("8igKv");

var $koVbs = parcelRequire("koVbs");

var $lfTZh = parcelRequire("lfTZh");

var $cYlk7 = parcelRequire("cYlk7");

var $14XJw = parcelRequire("14XJw");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");

var $0Wtmq = parcelRequire("0Wtmq");

var $kxZPA = parcelRequire("kxZPA");

var $lVJAU = parcelRequire("lVJAU");

// Relay entry point is not applicable here because this component does not live in jira frontend.
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7ef2ce65db55ab3d$var$LazyTeamCreateDialog = (0, $kxZPA.lazy)(()=>(parcelRequire("gQzjM")).then(({ TeamCreateDialog: TeamCreateDialog })=>TeamCreateDialog), {
    moduleId: "../platform/packages/people-and-teams/people-teams/src/index.ts"
});
const $7ef2ce65db55ab3d$export$5458b68a653f4bfe = ()=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { locale: locale } = (0, $koVbs.default)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const { data: { user: user } } = (0, $cYlk7.useCurrentUser)();
    const atlassianAccountId = (0, $90yGq.useAccountId)() || user.accountId;
    const pushRoute = (0, $5uXOq.useCallback)((url)=>push(url), [
        push
    ]);
    const addFlag = (0, $5uXOq.useCallback)(({ appearance: appearance, ...flagProps })=>{
        const Flag = $7ef2ce65db55ab3d$var$getFlagComponent(appearance);
        showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Flag, {
                ...flagProps,
                ...serviceProps,
                messageId: `navigation-apps-sidebar-nav4-sidebars-content-teams.ui.use-create-team-modal.flag.showFlag.${appearance}.${flagProps.id}`,
                messageType: "engagement"
            }));
    }, [
        showFlag
    ]);
    const callback = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(true);
    }, []);
    if (!atlassianAccountId) throw new Error('Missing current user id');
    return [
        isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "team-create-dialog"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0Wtmq.PeopleAndTeamsConfigurationProvider), {
            product: "jira",
            locale: (0, $euiLX.default)(locale)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7ef2ce65db55ab3d$var$LazyTeamCreateDialog, {
            pushRoute: pushRoute,
            cloudId: cloudId,
            orgId: orgId,
            product: "jira",
            principalId: atlassianAccountId,
            onClose: ()=>setIsOpen(false),
            enableMembershipSettingsChoice: true,
            currentUser: user.accountId ? {
                id: user.accountId,
                fullName: user.userFullname,
                // @ts-expect-error - TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
                email: user.emailAddress !== undefined ? user.emailAddress : '',
                // @ts-expect-error - TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
                avatarUrl: user.avatarUrls && user.avatarUrls['48x48'],
                nickname: user.userFullname
            } : undefined,
            addFlag: addFlag
        }))) : null,
        callback
    ];
};
const $7ef2ce65db55ab3d$var$getFlagComponent = (appearance)=>{
    switch(appearance){
        case 'warning':
            return 0, $8igKv.default;
        case 'error':
            return 0, $1wpPp.default;
        case 'success':
        case 'normal':
        default:
            return 0, $4ywcn.default;
    }
};

});

parcelRegister("fxSv8", function(module, exports) {

$parcel$export(module.exports, "useInvitePeopleModal", () => $bef8b2441fc0fca4$export$b9ec44715ae5ad99);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $1wpPp = parcelRequire("1wpPp");

var $4ywcn = parcelRequire("4ywcn");

var $8igKv = parcelRequire("8igKv");

var $d5puk = parcelRequire("d5puk");

var $1J3t1 = parcelRequire("1J3t1");

var $14XJw = parcelRequire("14XJw");

var $k9JTq = parcelRequire("k9JTq");

var $koeKL = parcelRequire("koeKL");

var $6s1PB = parcelRequire("6s1PB");

var $cYlk7 = parcelRequire("cYlk7");

var $vDAl4 = parcelRequire("vDAl4");

var $4R6GH = parcelRequire("4R6GH");

var $1naSs = parcelRequire("1naSs");

var $koVbs = parcelRequire("koVbs");

var $2F2eB = parcelRequire("2F2eB");

var $eXCTi = parcelRequire("eXCTi");
const $bef8b2441fc0fca4$var$isNthUserOnBoardingProjectRecommendationEnrolled = ()=>{
    const [config] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_nth_user_onboarding_proj_recommendation');
    // default value can't be a string to avoid type checking error
    return config.get('isEnabled', undefined) !== undefined;
};
const $bef8b2441fc0fca4$export$b9ec44715ae5ad99 = ()=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { data: projectSidebarNavigationData } = (0, $1J3t1.useProjectSidebarNavigation)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const { software: software } = (0, $k9JTq.useAppEditions)();
    const { data: currentUser } = (0, $cYlk7.useCurrentUser)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    let fetchInviteRecommendationsService = (0, $5uXOq.useCallback)((_)=>Promise.resolve([]), []);
    let mapToFeaturedUserService = (0, $5uXOq.useCallback)((_)=>[], []);
    if ((0, $4R6GH.fg)('tepi-3p-core-invites-slack-rec-ux')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        fetchInviteRecommendationsService = (0, $vDAl4.useService)((0, $1naSs.fetch3PInviteRecommendations));
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        mapToFeaturedUserService = (0, $vDAl4.useService)((0, $1naSs.mapToFeaturedUser));
    }
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    let continueUrl = window.location.href;
    if ($bef8b2441fc0fca4$var$isNthUserOnBoardingProjectRecommendationEnrolled() && currentUser?.user?.accountId) {
        const url = new URL(continueUrl);
        url.searchParams.append('inviterId', currentUser.user.accountId);
        continueUrl = url.toString();
    }
    const subProduct = (0, $d5puk.projectTypeToSubProduct)(projectSidebarNavigationData?.projectType);
    const fetchInviteRecommendations = (0, $5uXOq.useCallback)(async ()=>{
        if ((0, $4R6GH.fg)('tepi-3p-core-invites-slack-rec-ux')) {
            const inviteRecommendationsFromSlack = await fetchInviteRecommendationsService({
                limit: 10
            }).then((recommendations)=>{
                return mapToFeaturedUserService({
                    userInfo: recommendations,
                    tooltipRenderer: (user)=>formatMessage((0, $eXCTi.default).inviteRecommendationsFromSlack, {
                            email: user.email
                        })
                });
            });
            return inviteRecommendationsFromSlack;
        }
        return [];
    }, [
        fetchInviteRecommendationsService,
        mapToFeaturedUserService,
        formatMessage
    ]);
    const addFlag = (0, $5uXOq.useCallback)(({ appearance: appearance, ...flagProps })=>{
        const Flag = $bef8b2441fc0fca4$var$getFlagComponent(appearance);
        showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Flag, {
                ...flagProps,
                ...serviceProps,
                messageId: `navigation-apps-sidebar-nav4-sidebars-content-teams.ui.flag.showFlag.${appearance}.${flagProps.id}`,
                messageType: "transactional"
            }));
    }, [
        showFlag
    ]);
    const { openModal: invitePeopleModalTrigger } = (0, $2F2eB.useInvitePeopleModal)({
        continueUrl: continueUrl,
        enableThirdParty: true,
        displayInfiSpotlight: true,
        orgId: orgId,
        resourceAri: `ari:cloud:jira::site/${cloudId}`,
        showFlag: addFlag,
        source: 'peopleMenu',
        subProduct: subProduct,
        experimental_applicationEdition: software,
        navigation: {
            directoryContextEntryPoint: '/jira'
        },
        onSubmit: async (data)=>{
            await data.defaultOnSubmit();
        },
        experimental_featuredUsers: fetchInviteRecommendations
    });
    return invitePeopleModalTrigger;
};
const $bef8b2441fc0fca4$var$getFlagComponent = (appearance)=>{
    switch(appearance){
        case 'warning':
            return 0, $8igKv.default;
        case 'error':
            return 0, $1wpPp.default;
        case 'success':
        case 'normal':
        default:
            return 0, $4ywcn.default;
    }
};

});
parcelRegister("d5puk", function(module, exports) {

$parcel$export(module.exports, "stripUrlToIssueKey", () => $d13f96e7bcb31522$export$1f3c6284caef177b);
$parcel$export(module.exports, "useInvitePeopleFlags", () => $d13f96e7bcb31522$export$ab5fb7206b83c9ad);
$parcel$export(module.exports, "projectTypeToSubProduct", () => $d13f96e7bcb31522$export$3500077858760067);
$parcel$export(module.exports, "jiraProjectTypeToSubProduct", () => $d13f96e7bcb31522$export$9ce9c3ad0c2c5c71);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $1wpPp = parcelRequire("1wpPp");

var $g9eN3 = parcelRequire("g9eN3");

var $4ywcn = parcelRequire("4ywcn");

var $8igKv = parcelRequire("8igKv");
const $d13f96e7bcb31522$var$ISSUE_KEY_REGEXP = /(([A-Z][A-Z0-9]+)-([0-9]+))($|\?.*)/;
const $d13f96e7bcb31522$export$1f3c6284caef177b = (candidateUrl)=>{
    const match = candidateUrl.match($d13f96e7bcb31522$var$ISSUE_KEY_REGEXP);
    return match && match[1];
};
const $d13f96e7bcb31522$export$ab5fb7206b83c9ad = ()=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const addFlag = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7031 - Binding element 'appearance' implicitly has an 'any' type.
    ({ appearance: appearance, ...flagProps })=>{
        let FlagComponent = (0, $g9eN3.default);
        // eslint-disable-next-line default-case
        switch(appearance){
            case 'success':
            case 'normal':
                FlagComponent = (0, $4ywcn.default);
                break;
            case 'warning':
                FlagComponent = (0, $8igKv.default);
                break;
            case 'error':
                FlagComponent = (0, $1wpPp.default);
                break;
        }
        showFlag((serviceProps)=>{
            const props = {
                ...flagProps,
                ...serviceProps,
                messageId: `invite-people-drawer.ui.content.flag-component.${appearance}.${flagProps.id}`,
                messageType: 'transactional'
            };
            // @ts-expect-error Type error after Flag props have been fixed globally, to be fixed by owning team
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FlagComponent, props);
        });
    }, [
        showFlag
    ]);
    return {
        addFlag: addFlag
    };
};
const $d13f96e7bcb31522$export$3500077858760067 = (projectType)=>{
    switch(projectType){
        case 'jira_software':
            return 'software';
        case 'jira_service_management':
            return 'servicedesk';
        case 'jira_work_management':
            return 'core';
        case 'jira_product_discovery':
            return 'product-discovery';
        default:
            return undefined;
    }
};
const $d13f96e7bcb31522$export$9ce9c3ad0c2c5c71 = (projectType)=>{
    switch(projectType){
        case 'software':
            return 'software';
        case 'service_desk':
            return 'servicedesk';
        case 'business':
            return 'core';
        case 'product_discovery':
            return 'product-discovery';
        default:
            return undefined;
    }
};

});
parcelRegister("g9eN3", function(module, exports) {

$parcel$export(module.exports, "default", () => $100aabc6f0d895d9$export$2e2bcd8739ae039);

var $3KRpp = parcelRequire("3KRpp");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$100aabc6f0d895d9$export$2e2bcd8739ae039 = (0, $3KRpp.InfoFlag);

});


parcelRegister("vDAl4", function(module, exports) {

$parcel$export(module.exports, "useService", () => $9677bbf5335d2aff$export$6de4685a6c88b4e9);

var $5uXOq = parcelRequire("5uXOq");

var $koeKL = parcelRequire("koeKL");

var $90yGq = parcelRequire("90yGq");

var $2NMNM = parcelRequire("2NMNM");

var $5nEuA = parcelRequire("5nEuA");

var $jcw0u = parcelRequire("jcw0u");

var $9qRDo = parcelRequire("9qRDo");

var $go3id = parcelRequire("go3id");
const $9677bbf5335d2aff$var$useEnvironmentDeps = ()=>{
    // Use product's hooks to build a bag of dependencies
    // that the product environment will provide to the services.
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const cloudId = (0, $koeKL.useCloudId)();
    const product = (0, $go3id.useJiraCurrentProduct)();
    const atlassianAccountId = (0, $90yGq.useAccountId)();
    return (0, $5uXOq.useMemo)(()=>({
            createAnalyticsEvent: createAnalyticsEvent,
            fetchJSON: (0, $9qRDo.jiraFetchJson),
            getCurrentCloudId: ()=>cloudId,
            getCurrentProduct: ()=>product,
            getCurrentUserId: ()=>atlassianAccountId,
            fireErrorAnalytics: $jcw0u.default
        }), [
        createAnalyticsEvent,
        cloudId,
        product,
        atlassianAccountId
    ]);
};
const $9677bbf5335d2aff$export$6de4685a6c88b4e9 = (service, providedDeps)=>{
    const environmentDeps = $9677bbf5335d2aff$var$useEnvironmentDeps();
    const deps = (0, $5uXOq.useMemo)(()=>({
            ...environmentDeps,
            ...providedDeps
        }), [
        environmentDeps,
        providedDeps
    ]);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $5nEuA.useService)(service, deps);
};

});
parcelRegister("5nEuA", function(module, exports) {

$parcel$export(module.exports, "useService", () => $9684fe0f3cf53c6e$export$6de4685a6c88b4e9);

var $5uXOq = parcelRequire("5uXOq");

var $6Ctu6 = parcelRequire("6Ctu6");
const $9684fe0f3cf53c6e$export$6de4685a6c88b4e9 = (service, depsOverrides)=>{
    const memoizedRef = (0, $5uXOq.useRef)({
        service: undefined,
        depsOverrides: undefined,
        result: undefined
    });
    const memoized = memoizedRef.current;
    if (!memoized || memoized.service !== service || !$9684fe0f3cf53c6e$var$areObjectsEqualShallow(memoized.depsOverrides, depsOverrides)) {
        memoizedRef.current.result = (0, $6Ctu6.resolveService)(service, depsOverrides);
        memoizedRef.current.depsOverrides = depsOverrides;
        memoizedRef.current.service = service;
    }
    return memoizedRef.current.result;
};
const $9684fe0f3cf53c6e$var$DIFFERENT = false;
const $9684fe0f3cf53c6e$var$EQUAL = true;
const $9684fe0f3cf53c6e$var$areObjectsEqualShallow = (prevObject, nextObject)=>{
    if (nextObject === prevObject) return $9684fe0f3cf53c6e$var$EQUAL;
    if (!prevObject || !nextObject) return $9684fe0f3cf53c6e$var$DIFFERENT;
    else {
        const prevKeys = Object.keys(prevObject);
        const keys = Object.keys(nextObject);
        if (keys.length !== prevKeys.length) return $9684fe0f3cf53c6e$var$DIFFERENT;
        else for (let key of keys){
            if (nextObject[key] !== prevObject[key]) return $9684fe0f3cf53c6e$var$DIFFERENT;
        }
        return $9684fe0f3cf53c6e$var$EQUAL;
    }
};

});
parcelRegister("6Ctu6", function(module, exports) {

$parcel$export(module.exports, "resolveService", () => $8152fd9dbfdc89c7$export$388f24d19a29b0a2);

var $9oN5C = parcelRequire("9oN5C");
function $8152fd9dbfdc89c7$export$388f24d19a29b0a2(service, providedDeps) {
    if (typeof service === 'function' && (0, $9oN5C.isServiceWithDeps)(service)) return (input)=>{
        return service(input, $8152fd9dbfdc89c7$var$ResolvedServiceDependencyContext(service.dependencies, providedDeps ?? {}));
    };
    return service;
}
const $8152fd9dbfdc89c7$var$ResolvedServiceDependencyContext = (declaredDependencies, depsOverrides)=>{
    let resolvedDeps = undefined;
    return {
        dependencies () {
            if (resolvedDeps) return resolvedDeps;
            resolvedDeps = {};
            for (let [k, dependency] of Object.entries(declaredDependencies)){
                const key = k;
                resolvedDeps[key] = // TODO is this type-safe?
                // TODO resolve the override dep as well?
                key in depsOverrides ? depsOverrides[key] : $8152fd9dbfdc89c7$export$388f24d19a29b0a2(dependency, depsOverrides);
            }
            return resolvedDeps;
        }
    };
}; // TODO: support multiple services to be resolved with common deps
 // export function resolveServices<DeclaredServices extends DeclaredServicesBase>(
 // 	services: DeclaredServices,
 // 	deps: any /*TODO*/,
 // ) {
 // 	return services as ResolvedServices<DeclaredServices>;
 // }

});
parcelRegister("9oN5C", function(module, exports) {

$parcel$export(module.exports, "isServiceWithDeps", () => $040080a44356d901$export$4094c5185600bd73);
$parcel$export(module.exports, "unimplementedAbstractService", () => $040080a44356d901$export$6e9f7b680f09bab1);
const $040080a44356d901$export$4094c5185600bd73 = (maybeService)=>typeof maybeService === 'function' && 'dependencies' in maybeService;
const $040080a44356d901$export$6e9f7b680f09bab1 = (serviceName)=>Object.assign((_input)=>{
        throw TypeError(`Unimplemented abstract service: ${serviceName}`);
    }, {
        abstract: true
    });
const $040080a44356d901$export$cc3b967c039ed3e7 = (maybeError)=>{
    if (maybeError instanceof Error) return maybeError;
    return new TypeError('Service Error: ' + maybeError);
};

});



parcelRegister("9qRDo", function(module, exports) {

$parcel$export(module.exports, "jiraFetchJson", () => $23121174b063f460$export$a1dfe802bc656913);

var $7f4tk = parcelRequire("7f4tk");
const $23121174b063f460$export$a1dfe802bc656913 = (input)=>{
    const url = input.url;
    const options = input;
    return (0, $7f4tk.default)(url, options);
};

});

parcelRegister("go3id", function(module, exports) {

$parcel$export(module.exports, "useJiraCurrentProduct", () => $37d43f7c3c300c23$export$47a383c930365f5d);

var $kJP8l = parcelRequire("kJP8l");
const $37d43f7c3c300c23$export$47a383c930365f5d = ()=>{
    const productName = (0, $kJP8l.useProductName)();
    switch(productName){
        case 'core':
            return 'jira-core';
        case 'jira':
            return 'jira-software';
        case 'serviceDesk':
            return 'jira-servicedesk';
        case 'product-discovery':
            return 'jira-product-discovery';
        default:
            return 'jira-core';
    }
};

});
parcelRegister("kJP8l", function(module, exports) {

$parcel$export(module.exports, "useProductName", () => $fbc3e5a1ff3e1b43$export$dde400a84de238be);

var $daoB1 = parcelRequire("daoB1");

var $kLseK = parcelRequire("kLseK");
const $fbc3e5a1ff3e1b43$export$dde400a84de238be = ()=>{
    const appPermissions = (0, $daoB1.useApplicationPermissions)();
    return (0, $kLseK.getProductName)(appPermissions);
};

});
parcelRegister("kLseK", function(module, exports) {

$parcel$export(module.exports, "getProductName", () => $255564fdcf8ca770$export$aa3f36fe5dd1f237);

var $4R6GH = parcelRequire("4R6GH");
const $255564fdcf8ca770$export$aa3f36fe5dd1f237 = (permissions)=>{
    if ((0, $4R6GH.fg)('jcs_master_flag')) {
        const { hasSoftwareAccess: hasSoftwareAccess, hasServiceDeskAccess: hasServiceDeskAccess, hasCustomerServiceAccess: hasCustomerServiceAccess, hasCoreAccess: hasCoreAccess, hasProductDiscoveryAccess: hasProductDiscoveryAccess } = permissions;
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'ProductName'.
        return ([
            {
                condition: hasSoftwareAccess && !hasServiceDeskAccess && !hasProductDiscoveryAccess && !hasCustomerServiceAccess,
                value: 'software'
            },
            {
                condition: hasServiceDeskAccess && !hasSoftwareAccess && !hasProductDiscoveryAccess && !hasCustomerServiceAccess,
                value: 'serviceDesk'
            },
            {
                condition: hasCoreAccess && !hasSoftwareAccess && !hasServiceDeskAccess && !hasProductDiscoveryAccess && !hasCustomerServiceAccess,
                value: 'core'
            },
            {
                condition: hasProductDiscoveryAccess && !hasSoftwareAccess && !hasServiceDeskAccess && !hasCustomerServiceAccess,
                value: 'product-discovery'
            },
            {
                condition: hasCustomerServiceAccess && !hasProductDiscoveryAccess && !hasSoftwareAccess && !hasServiceDeskAccess,
                value: 'customer-service'
            }
        ].find((item)=>item.condition) || {
            value: 'jira'
        }).value;
    }
    const { hasSoftwareAccess: hasSoftwareAccess, hasServiceDeskAccess: hasServiceDeskAccess, hasCoreAccess: hasCoreAccess, hasProductDiscoveryAccess: hasProductDiscoveryAccess } = permissions;
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'ProductName'.
    return ([
        {
            condition: hasSoftwareAccess && !hasServiceDeskAccess && !hasProductDiscoveryAccess,
            value: 'software'
        },
        {
            condition: hasServiceDeskAccess && !hasSoftwareAccess && !hasProductDiscoveryAccess,
            value: 'serviceDesk'
        },
        {
            condition: hasCoreAccess && !hasSoftwareAccess && !hasServiceDeskAccess && !hasProductDiscoveryAccess,
            value: 'core'
        },
        {
            condition: hasProductDiscoveryAccess && !hasSoftwareAccess && !hasServiceDeskAccess,
            value: 'product-discovery'
        }
    ].find((item)=>item.condition) || {
        value: 'jira'
    }).value;
};

});




parcelRegister("1naSs", function(module, exports) {

$parcel$export(module.exports, "fetch3PInviteRecommendations", () => $f4ef3b6aec326481$export$fe357fea13f62bfe);
$parcel$export(module.exports, "mapToFeaturedUser", () => $f4ef3b6aec326481$export$44d2a44df9cb01bb);
/**
 * This file defines the recommendations3P() service.
 */ 
var $hVAD0 = parcelRequire("hVAD0");

var $7eo1O = parcelRequire("7eo1O");
const $f4ef3b6aec326481$var$dependencies = {
    fetchJSON: $7eo1O.fetchJSON,
    createAnalyticsEvent: $hVAD0.createAnalyticsEvent,
    fireErrorAnalytics: $hVAD0.fireErrorAnalytics,
    getCurrentCloudId: $hVAD0.getCurrentCloudId,
    getCurrentProduct: $hVAD0.getCurrentProduct
};
const $f4ef3b6aec326481$export$fe357fea13f62bfe = Object.assign($f4ef3b6aec326481$export$828ff91521f41431, {
    dependencies: $f4ef3b6aec326481$var$dependencies
});
async function $f4ef3b6aec326481$export$828ff91521f41431(input, context) {
    const deps = context.dependencies();
    const cloudId = input.targetCloudId ?? deps.getCurrentCloudId();
    const limit = input.limit;
    const product = input.targetProduct ?? deps.getCurrentProduct();
    try {
        const response = await deps.fetchJSON({
            url: `/gateway/api/pi-gateway/frontend/api/1/recommend/invite-users?limit=${limit}&targetCloudId=${cloudId}&targetProduct=${product}`,
            method: 'GET'
        });
        return response.recommendations;
    } catch (error) {
        deps.fireErrorAnalytics({
            meta: {
                id: 'fetchInviteRecommendations3P',
                packageName: 'expansion-services',
                teamName: 'Groot'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        return [];
    }
}
const $f4ef3b6aec326481$var$mapToFeaturedUserImpl = (input)=>{
    return input.userInfo.map((user, index)=>({
            email: user.email,
            name: user.displayName,
            avatarUrl: user.avatarUrl,
            source: user.source,
            tooltip: input.tooltipRenderer(user),
            id: user.atlassianAccountId ?? user.thirdPartyUserId
        }));
};
const $f4ef3b6aec326481$export$44d2a44df9cb01bb = Object.assign($f4ef3b6aec326481$var$mapToFeaturedUserImpl, {
    dependencies: {}
});

});
parcelRegister("hVAD0", function(module, exports) {

$parcel$export(module.exports, "getCurrentCloudId", () => $05577a28352bde83$export$ddb1688281a3443e);
$parcel$export(module.exports, "getCurrentProduct", () => $05577a28352bde83$export$d01408ed6f850a64);
$parcel$export(module.exports, "createAnalyticsEvent", () => $05577a28352bde83$export$a48841c0475a8073);
$parcel$export(module.exports, "fireErrorAnalytics", () => $05577a28352bde83$export$a27c21aa3ed8f0f1);
/**
 * This file contains declaration of smaller services,
 * commonly used as building blocks to create more specific
 * endpoint wrapping services
 */ 
var $9oN5C = parcelRequire("9oN5C");
const $05577a28352bde83$export$c7904a8284e43beb = (url)=>url;
const $05577a28352bde83$export$ddb1688281a3443e = (0, $9oN5C.unimplementedAbstractService)('getCurrentCloudId');
const $05577a28352bde83$export$5ebc6cb2748e1881 = (0, $9oN5C.unimplementedAbstractService)('getCurrentUserId');
const $05577a28352bde83$export$d01408ed6f850a64 = (0, $9oN5C.unimplementedAbstractService)('getCurrentProduct');
const $05577a28352bde83$export$a48841c0475a8073 = (0, $9oN5C.unimplementedAbstractService)('createAnalyticsEvent');
const $05577a28352bde83$export$a27c21aa3ed8f0f1 = (0, $9oN5C.unimplementedAbstractService)('fireErrorAnalytics');

});

parcelRegister("7eo1O", function(module, exports) {

$parcel$export(module.exports, "fetchJSON", () => $f9c1f44ac8aba1b1$export$81bec6e38e8b706b);

var $9oN5C = parcelRequire("9oN5C");
const $f9c1f44ac8aba1b1$export$81bec6e38e8b706b = // XXX: This is a generic function - careful with types!
// TypeScript has limitations when transforming generic functions.
// Here, the function signature will pass through our helper unimplementedAbstractService()
// untouched, which TypeScript can handle.
(0, $9oN5C.unimplementedAbstractService)('fetchJSON');

});


parcelRegister("2F2eB", function(module, exports) {

$parcel$export(module.exports, "useInvitePeopleModal", () => $bc0f5bcdf583ae5e$export$b9ec44715ae5ad99);
$parcel$export(module.exports, "InvitePeopleModalContextProvider", () => $bc0f5bcdf583ae5e$export$496e4f58036bb94d);

var $5uXOq = parcelRequire("5uXOq");

var $fElvF = parcelRequire("fElvF");
var $2JsdQ = parcelRequire("2JsdQ");

var $6s1PB = parcelRequire("6s1PB");

var $dNEo8 = parcelRequire("dNEo8");

var $e5wyW = parcelRequire("e5wyW");
/*
 * When we cleaning up experiment 'jira-invite-people-to-project-modal', this file should be removed.
 * Depending on the success / failure of the expirement we can replace the import of the modal context and hook
 * with the one from the invite-people package or keep using the one from jira-invite-people-modal-context.
 */ const $bc0f5bcdf583ae5e$var$isJiraInvitePeopleModalEnabled = ()=>{
    const [config] = (0, $6s1PB.UNSAFE_noExposureExp)('jira-invite-people-to-project-modal');
    return config.get('isEnabled', false);
};
// this ensures we only load one instance of the hook
const $bc0f5bcdf583ae5e$var$useConditionalInvitePeopleModal = (0, $e5wyW.functionWithCondition)(()=>$bc0f5bcdf583ae5e$var$isJiraInvitePeopleModalEnabled(), ({ resourceAri: resourceAri, onSubmit: onSubmit, ...props })=>(0, $dNEo8.useJiraInvitePeopleModalBound)(props), (0, $2JsdQ.useInvitePeopleModal));
const $bc0f5bcdf583ae5e$export$b9ec44715ae5ad99 = (props)=>{
    const [, fireExposure] = (0, $6s1PB.UNSAFE_noExposureExp)('jira-invite-people-to-project-modal');
    const { openModal: openModal } = $bc0f5bcdf583ae5e$var$useConditionalInvitePeopleModal(props);
    const openModalWithExposure = (0, $5uXOq.useCallback)(()=>{
        fireExposure();
        openModal();
    }, [
        openModal,
        fireExposure
    ]);
    return {
        openModal: openModalWithExposure
    };
};
const $bc0f5bcdf583ae5e$export$496e4f58036bb94d = ({ children: children })=>{
    if ($bc0f5bcdf583ae5e$var$isJiraInvitePeopleModalEnabled()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dNEo8.JiraInvitePeopleModalContextProvider), {
        renderedInProjectContext: false,
        shouldDisplaySuccessModal: false
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fElvF.InvitePeopleModalContextProvider), null, children);
};

});
parcelRegister("fElvF", function(module, exports) {

$parcel$export(module.exports, "InvitePeopleModalContext", () => $075d48b841fc8ac5$export$be58429061ae5194);
$parcel$export(module.exports, "InvitePeopleModalContextProvider", () => $075d48b841fc8ac5$export$496e4f58036bb94d);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

const $075d48b841fc8ac5$var$AKInvitePeopleModal = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("ecXMV")));

const $075d48b841fc8ac5$var$AKModalTransition = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("5LSAq")).then((module)=>({
            default: module.ModalTransition
        })));
const $075d48b841fc8ac5$export$be58429061ae5194 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isOpen: false,
    openModal: ()=>undefined,
    closeModal: ()=>undefined
});
const $075d48b841fc8ac5$export$496e4f58036bb94d = (invitePeopleModalContextProviderProps)=>{
    const { children: children } = invitePeopleModalContextProviderProps;
    const [invitePeopleState, setInvitePeopleState] = (0, $5uXOq.useState)({
        isOpen: false
    });
    const openModal = (invitePeopleProps, onClose)=>{
        setInvitePeopleState({
            isOpen: true,
            props: invitePeopleProps,
            onClose: onClose
        });
    };
    const closeModal = (0, $5uXOq.useCallback)((trigger)=>{
        if (!invitePeopleState.isOpen) return;
        invitePeopleState.onClose?.(trigger);
        setInvitePeopleState({
            previousProps: invitePeopleState.props,
            isOpen: false
        });
    }, [
        invitePeopleState
    ]);
    const reopenModal = (0, $5uXOq.useCallback)(()=>{
        // Reopen function can only reopen invite people if openModal has been called once with props
        setInvitePeopleState((prevState)=>!prevState.isOpen && prevState.previousProps ? {
                props: prevState.previousProps,
                isOpen: true
            } : prevState);
    }, []);
    const context = (0, $5uXOq.useMemo)(()=>({
            openModal: openModal,
            closeModal: closeModal,
            isOpen: invitePeopleState.isOpen
        }), [
        closeModal,
        invitePeopleState.isOpen
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)($075d48b841fc8ac5$export$be58429061ae5194.Provider, {
        value: context,
        children: [
            children,
            invitePeopleState.isOpen && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($075d48b841fc8ac5$var$AKModalTransition, {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($075d48b841fc8ac5$var$AKInvitePeopleModal, {
                        onCloseHandler: closeModal,
                        experimental_onReopenHandler: reopenModal,
                        ...invitePeopleState.props
                    })
                })
            })
        ]
    });
};

});
parcelRegister("ecXMV", function(module, exports) {

let $a580905fed4cc067$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $a580905fed4cc067$var$load("76n7a"),
    $a580905fed4cc067$var$load("l253H"),
    $a580905fed4cc067$var$load("kNFvF"),
    $a580905fed4cc067$var$load("3GGfo")
]).then(()=>parcelRequire('h8XS8'));

});

parcelRegister("5LSAq", function(module, exports) {

let $433baf47b06abf01$var$load = (parcelRequire("28QjX"))(4);
module.exports = $433baf47b06abf01$var$load("jELnc").then(()=>parcelRequire('3YJEd'));

});


parcelRegister("2JsdQ", function(module, exports) {

$parcel$export(module.exports, "useInvitePeopleModal", () => $e68e6d998c14d38d$export$b9ec44715ae5ad99);

var $5uXOq = parcelRequire("5uXOq");

var $fElvF = parcelRequire("fElvF");
const $e68e6d998c14d38d$export$b9ec44715ae5ad99 = (useInvitePeopleModalProps)=>{
    const { onClose: onClose, ...invitePeopleProps } = useInvitePeopleModalProps;
    const { openModal: openModal, closeModal: closeModal, isOpen: isOpen } = (0, $5uXOq.useContext)((0, $fElvF.InvitePeopleModalContext));
    return {
        // this is experimental only and should not be used without consulting !core-invtes in #groot-techops
        experimental_openModal: (propsOverride)=>openModal({
                ...invitePeopleProps,
                ...propsOverride
            }, onClose),
        openModal: ()=>openModal(invitePeopleProps, onClose),
        closeModal: closeModal,
        isOpen: isOpen
    };
};

});

parcelRegister("dNEo8", function(module, exports) {

$parcel$export(module.exports, "JiraInvitePeopleModalContextProvider", () => $dc5bcdd71ba92e9c$export$cdc03757c913ed0);
$parcel$export(module.exports, "useJiraInvitePeopleModalBound", () => $dc5bcdd71ba92e9c$export$569fef33efef0114);

var $5uXOq = parcelRequire("5uXOq");

var $gxYlr = parcelRequire("gxYlr");

var $k9JTq = parcelRequire("k9JTq");

var $cNd4s = parcelRequire("cNd4s");

var $koeKL = parcelRequire("koeKL");
const $dc5bcdd71ba92e9c$var$noop = ()=>null;
const $dc5bcdd71ba92e9c$var$JiraInvitePeopleModalContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isOpen: false,
    onOpen: $dc5bcdd71ba92e9c$var$noop,
    onClose: $dc5bcdd71ba92e9c$var$noop
});
const $dc5bcdd71ba92e9c$export$cdc03757c913ed0 = ({ children: children, ...props })=>{
    // new invite people modal requirements
    const cloudId = (0, $koeKL.useCloudId)();
    const appEditions = (0, $k9JTq.useAppEditions)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const [providerState, setProviderState] = (0, $5uXOq.useState)({
        props: {},
        isOpen: false
    });
    const onClose = (0, $5uXOq.useCallback)(()=>{
        setProviderState({
            props: {},
            isOpen: false
        });
    }, []);
    const onOpen = (0, $5uXOq.useCallback)((state)=>{
        setProviderState({
            props: state ?? {},
            isOpen: true
        });
    }, []);
    const value = (0, $5uXOq.useMemo)(()=>({
            isOpen: providerState.isOpen,
            onOpen: onOpen,
            onClose: onClose
        }), [
        providerState.isOpen,
        onOpen,
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dc5bcdd71ba92e9c$var$JiraInvitePeopleModalContext.Provider, {
        value: value
    }, providerState.isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gxYlr.default), {
        appEdition: appEditions.software,
        cloudId: cloudId,
        isOpen: providerState.isOpen,
        onClose: onClose,
        isSiteAdmin: isSiteAdmin,
        ...props,
        ...providerState.props
    }) : null, children);
};
const $dc5bcdd71ba92e9c$export$39f09976987c1e17 = ()=>(0, $5uXOq.useContext)($dc5bcdd71ba92e9c$var$JiraInvitePeopleModalContext);
const $dc5bcdd71ba92e9c$export$569fef33efef0114 = (props)=>{
    const { isOpen: isOpen, onOpen: onOpen, onClose: onClose } = (0, $5uXOq.useContext)($dc5bcdd71ba92e9c$var$JiraInvitePeopleModalContext);
    const openModal = (0, $5uXOq.useCallback)(()=>onOpen(props), [
        onOpen,
        props
    ]);
    return {
        isOpen: isOpen,
        openModal: openModal,
        closeModal: onClose
    };
};

});
parcelRegister("gxYlr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c808453409ea513$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0c808453409ea513$var$LazyComponent = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("bcZC9")), {
    ssr: false,
    moduleId: "./src/packages/project-settings/jira-invite-people-modal/src/ui/index.tsx"
});
const $0c808453409ea513$export$65d7b8c193fa4f41 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async-invite-people-modal",
        packageName: "jira-invite-people-modal",
        teamName: "groot-growth"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jira-invite-people-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0c808453409ea513$var$LazyComponent, props)));
var $0c808453409ea513$export$2e2bcd8739ae039 = $0c808453409ea513$export$65d7b8c193fa4f41;

});
parcelRegister("bcZC9", function(module, exports) {

let $82909c07f8da78c1$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $82909c07f8da78c1$var$load("ffQaD"),
    $82909c07f8da78c1$var$load("kvRbA"),
    $82909c07f8da78c1$var$load("76n7a"),
    $82909c07f8da78c1$var$load("l253H"),
    $82909c07f8da78c1$var$load("kNFvF"),
    $82909c07f8da78c1$var$load("e0u5J")
]).then(()=>parcelRequire('xET05'));

});







parcelRegister("3cFRo", function(module, exports) {

$parcel$export(module.exports, "Stub", () => $39abac17a0bf23b3$export$1ab0b9ce3cf276f8);

var $5uXOq = parcelRequire("5uXOq");

var $eZUJu = parcelRequire("eZUJu");

var $cJFfS = parcelRequire("cJFfS");




var $jecJ3 = parcelRequire("jecJ3");

var $ivGSs = parcelRequire("ivGSs");

var $46Cti = parcelRequire("46Cti");

var $eQV8d = parcelRequire("eQV8d");

var $dUyqZ = parcelRequire("dUyqZ");

var $eaKdt = parcelRequire("eaKdt");

var $aCS3f = parcelRequire("aCS3f");


var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $3TY9o = parcelRequire("3TY9o");
const $39abac17a0bf23b3$export$1ab0b9ce3cf276f8 = ({ menuId: menuId, href: href })=>{
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)(menuId);
    const location = (0, $3TY9o.useLocation)();
    const path = location.pathname + location.search;
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cJFfS.LinkMenuItem), {
        elemBefore: icon,
        href: href,
        isSelected: path === href,
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($39abac17a0bf23b3$var$ActionButtons, {
            menuId: menuId
        }),
        onClick: ()=>{
            if (menuId === (0, $46Cti.L1_MENU_ID).TEAMS) sendSectionItemAnalyticsEvent({
                menuId: (0, $46Cti.L1_MENU_ID).TEAMS,
                sectionItem: (0, $jecJ3.SECTION_ITEM_TEAMS)
            });
        }
    }, formattedMessage);
};
function $39abac17a0bf23b3$var$ActionButtons({ menuId: menuId }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCS3f.MoreNavMenuButton), {
        onOpen: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$b887e88d8d0739f6),
                actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[menuId],
                attributes: {
                    level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                    componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                    itemId: (0, $ddbe4b334e21c7a1$export$f06dfcec5ff912e)
                }
            });
        },
        MenuItems: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaKdt.HideL1MenuItemSection), {
                menuId: menuId,
                hasSeparator: false
            }))
    });
}

});


parcelRegister("cam2y", function(module, exports) {

$parcel$export(module.exports, "useFilterL1MenuItemsByEditionAndLicense", () => $7076df34d12ead42$export$bf04108d78a3abbe);

var $5uXOq = parcelRequire("5uXOq");

var $8J6rn = parcelRequire("8J6rn");

var $4R6GH = parcelRequire("4R6GH");

var $46Cti = parcelRequire("46Cti");

var $jYFkU = parcelRequire("jYFkU");

var $iKHgp = parcelRequire("iKHgp");

var $h9iZl = parcelRequire("h9iZl");

var $dWQF5 = parcelRequire("dWQF5");

var $a6FNA = parcelRequire("a6FNA");

var $crxHy = parcelRequire("crxHy");

var $eUfQ2 = parcelRequire("eUfQ2");

var $hwLGB = parcelRequire("hwLGB");
const $7076df34d12ead42$export$bf04108d78a3abbe = (navItems)=>{
    const showAssets = (0, $jYFkU.useShowAssets)();
    const { shouldUseJSM: shouldUseJSM } = (0, $8J6rn.useOgTenantInfo)();
    const shouldShowRoadmaps = (0, $dWQF5.useIsCrossProjectViewsEnabled)();
    const shouldRenderOverviews = (0, $iKHgp.useShouldRenderOverviews)();
    const [shouldRenderPlans] = (0, $h9iZl.useNavigationPlansVisibility)();
    const showCustomerService = (0, $a6FNA.useShowCustomerService)();
    const showCustomerServiceAnalytics = (0, $crxHy.useShowCustomerServiceAnalytics)();
    const { goals: goals, assets: assets, confluence: confluence, projects: projects, loom: loom, teams: teams, opsgenie: opsgenie } = (0, $eUfQ2.useGlobalApps)();
    const showCommunicationsMenu = (0, $hwLGB.useShowCommunicationsMenu)();
    return (0, $5uXOq.useMemo)(()=>navItems.filter(({ menuId: menuId })=>{
            if (menuId === (0, $46Cti.L1_MENU_ID).OPERATIONS) return shouldUseJSM;
            if (menuId === (0, $46Cti.L1_MENU_ID).ASSETS) /* remove this on
					 * blu-6313_sidebar_global_app_shortcuts cleanup &&
					 * assets_as_an_app_v2 cleanup &&
					 *
					 * Should hide the L1 Assets menu item when the asset shortcut is present
					 */ return showAssets && !assets;
            if (menuId === (0, $46Cti.L1_MENU_ID).ROADMAPS) return shouldShowRoadmaps;
            if (menuId === (0, $46Cti.L1_MENU_ID).OVERVIEWS) return (0, $4R6GH.fg)('blu-2858-sidebar-menu-overviews') && shouldRenderOverviews;
            if (menuId === (0, $46Cti.L1_MENU_ID).PLANS) return shouldRenderPlans;
            if (menuId === (0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS) return showCustomerServiceAnalytics;
            // See https://jplat.jira.atlassian.cloud/browse/BLU-3307
            // For the Dogfooding phase of Nav4 we are going to intentionally hide the Goals menu item.
            // This if block should be removed when we work on https://jplat.jira.atlassian.cloud/browse/BLU-3261
            // as we will know the correct URL for the Goals menu item at that point.
            if (menuId === (0, $46Cti.L1_MENU_ID).GOALS) return false;
            if (menuId === (0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE) return showCustomerService;
            if (menuId === (0, $46Cti.L1_MENU_ID).GLOBAL_APP_ASSETS) return assets;
            if (menuId === (0, $46Cti.L1_MENU_ID).GLOBAL_APP_GOALS) return goals;
            // App Shortcuts for Platform Component, feature gated in useGlobalApps
            if (menuId === (0, $46Cti.L1_MENU_ID).GLOBAL_APP_CONFLUENCE) return confluence;
            if (menuId === (0, $46Cti.L1_MENU_ID).GLOBAL_APP_PROJECTS) return projects;
            if (menuId === (0, $46Cti.L1_MENU_ID).GLOBAL_APP_LOOM) return loom;
            if (menuId === (0, $46Cti.L1_MENU_ID).GLOBAL_APP_TEAMS) return teams;
            if (menuId === (0, $46Cti.L1_MENU_ID).GLOBAL_APP_OPSGENIE) return opsgenie;
            if (menuId === (0, $46Cti.L1_MENU_ID).COMMUNICATION) return showCommunicationsMenu;
            return true;
        }), [
        navItems,
        shouldUseJSM,
        showAssets,
        shouldShowRoadmaps,
        shouldRenderOverviews,
        shouldRenderPlans,
        showCustomerService,
        showCustomerServiceAnalytics,
        goals,
        assets,
        confluence,
        projects,
        loom,
        teams,
        opsgenie,
        showCommunicationsMenu
    ]);
};

});
parcelRegister("jYFkU", function(module, exports) {

$parcel$export(module.exports, "useShowAssets", () => $e8ba161523dca261$export$6d1797fe1bb33b7a);

var $ktP1V = parcelRequire("ktP1V");

var $9OXo1 = parcelRequire("9OXo1");
function $e8ba161523dca261$export$6d1797fe1bb33b7a() {
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { appPermissions: appPermissions } = tenantContext;
    const isJSMUser = appPermissions.hasServiceDeskAccess;
    if ((0, $ktP1V.isCMDBEnabledInEnvironment)(tenantContext.cmdbDisabledInFedRAMP) && isJSMUser) return true;
    return false;
}

});

parcelRegister("a6FNA", function(module, exports) {

$parcel$export(module.exports, "useShowCustomerService", () => $022d7dbb7d3dace6$export$e760a809f2958bc7);

var $4R6GH = parcelRequire("4R6GH");

var $e5wyW = parcelRequire("e5wyW");

var $itmJb = parcelRequire("itmJb");

var $daoB1 = parcelRequire("daoB1");
const $022d7dbb7d3dace6$export$c4885f1dde7a76dc = ()=>{
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const { hasServiceDeskAccess: hasServiceDeskAccess } = (0, $daoB1.useApplicationPermissions)();
    return (0, $4R6GH.fg)('jcs_master_flag') && (isAdmin || hasServiceDeskAccess);
};
const $022d7dbb7d3dace6$export$888d99f9044122c4 = ()=>{
    const { hasCustomerServiceAccess: hasCustomerServiceAccess } = (0, $daoB1.useApplicationPermissions)();
    return (0, $4R6GH.fg)('jcs_master_flag') && hasCustomerServiceAccess;
};
const $022d7dbb7d3dace6$export$e760a809f2958bc7 = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('jcs_project_type_m3'), $022d7dbb7d3dace6$export$888d99f9044122c4, $022d7dbb7d3dace6$export$c4885f1dde7a76dc);

});

parcelRegister("crxHy", function(module, exports) {

$parcel$export(module.exports, "useShowCustomerServiceAnalytics", () => $aaa491f1440cfff7$export$4aaa66e80d627346);

var $4R6GH = parcelRequire("4R6GH");

var $itmJb = parcelRequire("itmJb");

var $daoB1 = parcelRequire("daoB1");
const $aaa491f1440cfff7$export$4aaa66e80d627346 = ()=>{
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const { hasServiceDeskAccess: hasServiceDeskAccess } = (0, $daoB1.useApplicationPermissions)();
    return (0, $4R6GH.fg)('jcs-analytics-page') && (isAdmin || hasServiceDeskAccess);
};

});

parcelRegister("hwLGB", function(module, exports) {

$parcel$export(module.exports, "useShowCommunicationsMenu", () => $7d10ce2fbda08f98$export$b98d497f7858571b);

var $ldyPw = parcelRequire("ldyPw");

var $4R6GH = parcelRequire("4R6GH");

var $k9JTq = parcelRequire("k9JTq");

var $itmJb = parcelRequire("itmJb");

var $cNd4s = parcelRequire("cNd4s");

var $eXrJi = parcelRequire("eXrJi");

var $9OXo1 = parcelRequire("9OXo1");
const $7d10ce2fbda08f98$export$b98d497f7858571b = ()=>{
    const { isOrgAdmin: isOrgAdmin } = (0, $eXrJi.useIsOrgAdmin)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const appEditions = (0, $k9JTq.useAppEditions)();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { appPermissions: appPermissions } = tenantContext;
    // Check if user has premium edition
    const isPremium = appEditions?.software === (0, $ldyPw.PREMIUM_EDITION);
    // Check if user has specific product license
    const isJSMUser = appPermissions.hasServiceDeskAccess;
    const isAdminUser = isOrgAdmin || isSiteAdmin || isAdmin;
    const showCommunicationsMenu = isAdminUser && isPremium && isJSMUser && (0, $4R6GH.fg)('communications_stakeholder_management_platform');
    return showCommunicationsMenu;
};

});
parcelRegister("eXrJi", function(module, exports) {

$parcel$export(module.exports, "useIsOrgAdmin", () => $1b04ea73291e11e0$export$8ed42372757d8b2a);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $14XJw = parcelRequire("14XJw");

var $90yGq = parcelRequire("90yGq");
const $1b04ea73291e11e0$var$getUserOrgPermissions = async ({ orgId: orgId, userId: userId })=>(0, $eusud.performPostRequest)('/gateway/api/permissions/permitted', {
        body: JSON.stringify({
            resourceId: `ari:cloud:platform::org/${orgId}`,
            principalId: `ari:cloud:identity::user/${userId}`,
            permissionId: 'manage-users'
        })
    }).then((resp)=>!!resp?.permitted);
const $1b04ea73291e11e0$export$8ed42372757d8b2a = ()=>{
    const userId = (0, $90yGq.useAccountId)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const checkUserIsOrgAdmin = (0, $5uXOq.useCallback)(async ()=>{
        if (!userId || !orgId) return false;
        return $1b04ea73291e11e0$var$getUserOrgPermissions({
            orgId: orgId,
            userId: userId
        });
    }, [
        orgId,
        userId
    ]);
    const { loading: loading, error: error, data: data, fetch: fetchIsOrgAdmin } = (0, $ld2hZ.useService)(checkUserIsOrgAdmin, {
        data: false
    });
    (0, $5uXOq.useEffect)(()=>{
        fetchIsOrgAdmin();
    }, [
        fetchIsOrgAdmin
    ]);
    (0, $5uXOq.useEffect)(()=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'checkUserIsOrgAdmin',
                packageName: 'jiraBusinessGoalPicker',
                teamName: 'jira-yurree'
            },
            sendToPrivacyUnsafeSplunk: true,
            error: error
        });
    }, [
        error
    ]);
    return {
        isOrgAdmin: !!data,
        loading: loading,
        hasErrorOccurred: !!error,
        retry: fetchIsOrgAdmin
    };
};

});



parcelRegister("jM4TX", function(module, exports) {

$parcel$export(module.exports, "useRefreshL1MenuItems", () => $c458e653f6eae5e5$export$6f30ce19c2e3e4c0);

var $5uXOq = parcelRequire("5uXOq");

var $k8IPx = parcelRequire("k8IPx");

var $1zjdl = parcelRequire("1zjdl");
const $c458e653f6eae5e5$export$6f30ce19c2e3e4c0 = (navItems = [])=>(0, $5uXOq.useMemo)(()=>{
        const missingMenuIds = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))((0, $1zjdl.USER_NAVIGATION_CONFIGURATION_DEFAULT_MENU_IDS), navItems.map(({ menuId: menuId })=>menuId));
        return [
            ...navItems,
            ...missingMenuIds.map((menuId)=>({
                    menuId: menuId,
                    isVisible: true
                }))
        ];
    }, [
        navItems
    ]);

});
parcelRegister("k8IPx", function(module, exports) {

var $55pzo = parcelRequire("55pzo");

var $ekcP3 = parcelRequire("ekcP3");

var $g7i7g = parcelRequire("g7i7g");

var $f3SOL = parcelRequire("f3SOL");
/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */ var $ea975459f1938a58$var$difference = $g7i7g(function(array, values) {
    return $f3SOL(array) ? $55pzo(array, $ekcP3(values, 1, $f3SOL, true)) : [];
});
module.exports = $ea975459f1938a58$var$difference;

});


parcelRegister("i98eP", function(module, exports) {

$parcel$export(module.exports, "MoreMenuIsOpenContextProvider", () => $b1de343b331e2d66$export$d11e004ed91611ce);

var $5uXOq = parcelRequire("5uXOq");

var $5xBN5 = parcelRequire("5xBN5");
const $b1de343b331e2d66$export$d11e004ed91611ce = ({ children: children })=>{
    const [moreMenuIsOpen, setMoreMenuIsOpen] = (0, $5uXOq.useState)(false);
    const moreMenuIsOpenContext = (0, $5uXOq.useMemo)(()=>({
            moreMenuIsOpen: moreMenuIsOpen,
            setMoreMenuIsOpen: setMoreMenuIsOpen
        }), [
        moreMenuIsOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5xBN5.MoreMenuIsOpenContext).Provider, {
        value: moreMenuIsOpenContext
    }, children);
};

});
parcelRegister("5xBN5", function(module, exports) {

$parcel$export(module.exports, "MoreMenuIsOpenContext", () => $5118c303d0e915f1$export$8888ac4b19e27f70);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");
const $5118c303d0e915f1$export$8888ac4b19e27f70 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    moreMenuIsOpen: false,
    setMoreMenuIsOpen: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
});

});


parcelRegister("1tKM7", function(module, exports) {

$parcel$export(module.exports, "SidebarCustomization", () => $93b4a8f63ccc708d$export$64f537f23c5bcad6);

var $5uXOq = parcelRequire("5uXOq");

var $kMSay = parcelRequire("kMSay");

var $jecJ3 = parcelRequire("jecJ3");

var $iszzG = parcelRequire("iszzG");

var $eQV8d = parcelRequire("eQV8d");

var $3SaXS = parcelRequire("3SaXS");

var $koVbs = parcelRequire("koVbs");

var $hFGs5 = parcelRequire("hFGs5");

var $9Qut3 = parcelRequire("9Qut3");

var $hBVbZ = parcelRequire("hBVbZ");

var $h3Slk = parcelRequire("h3Slk");
function $93b4a8f63ccc708d$export$64f537f23c5bcad6({ menuData: menuData, productItemsData: productItemsData, appItemsData: appItemsData, getAppShortcutURL: getAppShortcutURL }) {
    const { moreMenuIds: moreMenuIds } = (0, $5uXOq.useContext)((0, $iszzG.NavItemsContext));
    const { peekMenuId: peekMenuId } = (0, $5uXOq.useContext)((0, $iszzG.PeekMenuIdContext));
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    const pressTracing = (0, $kMSay.default)('nav4-sidebar-more');
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onClickMoreMenuTrigger = (0, $5uXOq.useCallback)(()=>{
        sendSectionItemAnalyticsEvent({
            sectionItem: (0, $jecJ3.SECTION_ITEM_MORE)
        });
        pressTracing();
    }, [
        pressTracing,
        sendSectionItemAnalyticsEvent
    ]);
    return moreMenuIds.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h3Slk.CustomizeSidebar), {
        productItemsData: productItemsData,
        appItemsData: appItemsData
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Qut3.PeekMenuItem), {
        menuData: menuData
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3SaXS.GlobalMoreMenu), {
        productItemsData: productItemsData,
        appItemsData: appItemsData,
        menuItemComponent: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hFGs5.MoreMenuItem), {
                ...props,
                getAppShortcutURL: getAppShortcutURL
            }),
        customizeSidebarMenuItem: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h3Slk.CustomizeSidebar), {
            productItemsData: productItemsData,
            appItemsData: appItemsData
        }),
        moreMenuItemLabel: formatMessage((0, $hBVbZ.default).more),
        peekingMenuIds: peekMenuId ? [
            peekMenuId
        ] : undefined,
        onClickMoreMenuTrigger: onClickMoreMenuTrigger
    }));
}

});
parcelRegister("3SaXS", function(module, exports) {

$parcel$export(module.exports, "GlobalMoreMenu", () => $2d953eb545f3c4ae$export$6741e824c68e9927);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7UziE = parcelRequire("7UziE");
function $2d953eb545f3c4ae$export$6741e824c68e9927({ productItemsData: productItemsData, appItemsData: appItemsData = [], menuItemComponent: menuItemComponent, customizeSidebarMenuItem: customizeSidebarMenuItem, moreMenuItemLabel: moreMenuItemLabel, peekingMenuIds: peekingMenuIds = [], onClickMoreMenuTrigger: onClickMoreMenuTrigger, testId: testId }) {
    const checkIsHiddenMenuItem = ({ menuId: menuId, visible: visible })=>!visible && !peekingMenuIds.includes(menuId);
    const hiddenProductItemsData = productItemsData.filter(checkIsHiddenMenuItem);
    const hiddenAppItemsData = appItemsData.filter(checkIsHiddenMenuItem);
    if (hiddenProductItemsData.length === 0 && hiddenAppItemsData.length === 0) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: customizeSidebarMenuItem
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7UziE.MoreMenuPopup), {
        productItemsData: hiddenProductItemsData,
        appItemsData: hiddenAppItemsData,
        moreMenuItemComponent: menuItemComponent,
        customizeSidebarMenuItem: customizeSidebarMenuItem,
        moreMenuItemLabel: moreMenuItemLabel,
        onClickMoreMenuTrigger: onClickMoreMenuTrigger,
        testId: testId
    });
}

});
parcelRegister("7UziE", function(module, exports) {

$parcel$export(module.exports, "MoreMenuPopup", () => $dfa0c8a1feea295b$export$b426d2e536b00785);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8U6zd = parcelRequire("8U6zd");

var $gSZmd = parcelRequire("gSZmd");

var $jpyeI = parcelRequire("jpyeI");

var $iUFLC = parcelRequire("iUFLC");

var $MHKc7 = parcelRequire("MHKc7");

var $a3vrD = parcelRequire("a3vrD");
const $dfa0c8a1feea295b$var$styles = {
    popupContentContainerStyles: "_195gr5cr _kqswh2mm",
    popupContentStyles: "_ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
};
function $dfa0c8a1feea295b$export$b426d2e536b00785({ productItemsData: productItemsData, appItemsData: appItemsData, moreMenuItemComponent: moreMenuItemComponent, customizeSidebarMenuItem: customizeSidebarMenuItem, moreMenuItemLabel: moreMenuItemLabel, onClickMoreMenuTrigger: onClickMoreMenuTrigger, testId: testId }) {
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const closeMenu = ()=>setIsOpen(false);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(true), onClickMoreMenuTrigger && onClickMoreMenuTrigger();
    }, [
        onClickMoreMenuTrigger
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $iUFLC.Popup), {
        isOpen: isOpen,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iUFLC.PopupTrigger), {
                children: (triggerProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $jpyeI.ButtonMenuItem), {
                        ...triggerProps,
                        elemBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))), {
                            label: "",
                            color: "currentColor",
                            spacing: "spacious"
                        }),
                        onClick: onClick,
                        testId: testId,
                        children: moreMenuItemLabel
                    })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: $dfa0c8a1feea295b$var$styles.popupContentContainerStyles,
                role: "listitem",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iUFLC.PopupContent), {
                    shouldFitContainer: true,
                    placement: "bottom-start",
                    // Offset the top margin of the menu section.
                    // This will keep an even spacing of menu items between those inside the dropdown and those above,
                    // and keep the icons aligned
                    offset: [
                        -4,
                        4
                    ],
                    onClose: ()=>setIsOpen(false),
                    shouldRenderToParent: true,
                    strategy: "absolute",
                    children: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            xcss: $dfa0c8a1feea295b$var$styles.popupContentStyles,
                            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gSZmd.MenuList), {
                                children: [
                                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a3vrD.MoreMenuSection), {
                                        itemsData: productItemsData,
                                        moreMenuItemComponent: moreMenuItemComponent,
                                        closeMenu: closeMenu
                                    }),
                                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a3vrD.MoreMenuSection), {
                                        itemsData: appItemsData,
                                        moreMenuItemComponent: moreMenuItemComponent,
                                        closeMenu: closeMenu
                                    }),
                                    customizeSidebarMenuItem
                                ]
                            })
                        })
                })
            })
        ]
    });
}

});
parcelRegister("a3vrD", function(module, exports) {

$parcel$export(module.exports, "MoreMenuSection", () => $82f4de3211210d1f$export$e69b6dd1756fb519);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gSZmd = parcelRequire("gSZmd");

var $aAbfD = parcelRequire("aAbfD");
var $1FdfO = parcelRequire("1FdfO");
function $82f4de3211210d1f$export$e69b6dd1756fb519({ itemsData: itemsData, moreMenuItemComponent: moreMenuItemComponent, closeMenu: closeMenu }) {
    if (itemsData.length === 0) return null;
    const MenuItemComponent = moreMenuItemComponent;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $1FdfO.MenuSection), {
        isMenuListItem: true,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gSZmd.MenuList), {
                children: itemsData.map(({ menuId: menuId })=>/*#__PURE__*/ (0, $2OMIu.jsx)(MenuItemComponent, {
                        menuId: menuId,
                        closeMenu: closeMenu
                    }, menuId))
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aAbfD.Divider), {})
        ]
    });
}

});



parcelRegister("hFGs5", function(module, exports) {

$parcel$export(module.exports, "MoreMenuItem", () => $020667c43ce85a92$export$e967513bbeba0537);

var $5uXOq = parcelRequire("5uXOq");

var $cJFfS = parcelRequire("cJFfS");

var $jpyeI = parcelRequire("jpyeI");

var $dUyqZ = parcelRequire("dUyqZ");

var $iszzG = parcelRequire("iszzG");

var $6kDpL = parcelRequire("6kDpL");

var $eQV8d = parcelRequire("eQV8d");

var $jecJ3 = parcelRequire("jecJ3");

var $eUfQ2 = parcelRequire("eUfQ2");

var $jhS4y = parcelRequire("jhS4y");

var $4R6GH = parcelRequire("4R6GH");

var $1zjdl = parcelRequire("1zjdl");
function $020667c43ce85a92$export$e967513bbeba0537({ menuId: menuId, closeMenu: closeMenu, key: key, getAppShortcutURL: getAppShortcutURL }) {
    const { setPeekMenuId: setPeekMenuId } = (0, $5uXOq.useContext)((0, $iszzG.PeekMenuIdContext));
    const configurableId = (0, $6kDpL.convertToConfigurableMenuId)(menuId);
    const isGlobalApp = (0, $eUfQ2.isGlobalAppMenuId)(menuId);
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)(configurableId);
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    const getProductUrl = (0, $5uXOq.useCallback)(()=>{
        if (!isGlobalApp || !getAppShortcutURL) return;
        if ((0, $jhS4y.GLOBAL_APP_MENU_ID_TO_APS_KEY)[menuId]) {
            const apsKey = (0, $jhS4y.GLOBAL_APP_MENU_ID_TO_APS_KEY)[menuId];
            return getAppShortcutURL(apsKey);
        }
    }, [
        isGlobalApp,
        getAppShortcutURL,
        menuId
    ]);
    // This is part of an intermediate state workaround where links are accounted for;
    // we don't expect links to be in the More menu at the end state,
    // at which point this and the MenuLinkItem below can be removed.
    const url = (0, $4R6GH.fg)('nav4_global_links_jira') ? getProductUrl() || (0, $1zjdl.USER_NAVIGATION_ITEM_LINKS)[menuId] : (0, $1zjdl.USER_NAVIGATION_ITEM_LINKS)[menuId];
    const onClick = (0, $5uXOq.useCallback)(()=>{
        closeMenu();
        if (!isGlobalApp) // Global apps open in a new tab onClick so they don't need to be a peek-item
        setPeekMenuId(configurableId);
        sendSectionItemAnalyticsEvent({
            menuId: configurableId,
            sectionItem: (0, $jecJ3.SECTION_ITEM_MAP)[configurableId]
        });
    }, [
        closeMenu,
        configurableId,
        isGlobalApp,
        sendSectionItemAnalyticsEvent,
        setPeekMenuId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cJFfS.LinkMenuItem), {
        elemBefore: icon,
        href: url,
        onClick: onClick,
        key: key,
        target: isGlobalApp ? '_blank' : undefined
    }, formattedMessage) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jpyeI.ButtonMenuItem), {
        elemBefore: icon,
        onClick: onClick,
        key: key
    }, formattedMessage));
}

});
parcelRegister("6kDpL", function(module, exports) {

$parcel$export(module.exports, "convertToConfigurableMenuId", () => $6a544b997005f6ad$export$c54090f9034b2d83);

var $jhS4y = parcelRequire("jhS4y");
const $6a544b997005f6ad$export$c54090f9034b2d83 = (menuId)=>{
    switch(menuId){
        case 'jira.sidebar.apps':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).APPS;
        case 'jira.sidebar.assets':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).ASSETS;
        case 'jira.sidebar.dashboards':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).DASHBOARDS;
        case 'jira.sidebar.filters':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).FILTERS;
        case 'jira.sidebar.goals':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).GOALS;
        case 'jira.sidebar.operations':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).OPERATIONS;
        case 'jira.sidebar.communication':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).COMMUNICATION;
        case 'jira.sidebar.overviews':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).OVERVIEWS;
        case 'jira.sidebar.plans':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).PLANS;
        case 'jira.sidebar.projects':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).PROJECTS;
        case 'jira.sidebar.recent':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).RECENT;
        case 'jira.sidebar.starred':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).STARRED;
        case 'jira.sidebar.teams':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).TEAMS;
        case 'jira.sidebar.roadmaps':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).ROADMAPS;
        case 'jira.sidebar.customerService':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).CUSTOMER_SERVICE;
        case 'jira.sidebar.customerHubs':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).CUSTOMER_HUBS;
        case 'jira.sidebar.customerServiceAnalytics':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).CUSTOMER_SERVICE_ANALYTICS;
        case 'jira.sidebar.globalApp.assets':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).GLOBAL_APP_ASSETS;
        case 'jira.sidebar.globalApp.goals':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).GLOBAL_APP_GOALS;
        case 'jira.sidebar.globalApp.confluence':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).GLOBAL_APP_CONFLUENCE;
        case 'jira.sidebar.globalApp.teams':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).GLOBAL_APP_TEAMS;
        case 'jira.sidebar.globalApp.projects':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).GLOBAL_APP_PROJECTS;
        case 'jira.sidebar.globalApp.loom':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).GLOBAL_APP_LOOM;
        case 'jira.sidebar.globalApp.opsgenie':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).GLOBAL_APP_OPSGENIE;
        default:
            throw new Error(`Invalid menuId: ${menuId}`);
    }
};

});


parcelRegister("9Qut3", function(module, exports) {

$parcel$export(module.exports, "PeekMenuItem", () => $53741d978b583623$export$4287f527b7969caa);

var $5uXOq = parcelRequire("5uXOq");

var $iszzG = parcelRequire("iszzG");

var $3muxY = parcelRequire("3muxY");
const $53741d978b583623$export$4287f527b7969caa = ({ menuData: menuData })=>{
    const { moreMenuIds: moreMenuIds } = (0, $5uXOq.useContext)((0, $iszzG.NavItemsContext));
    const { peekMenuId: peekMenuId } = (0, $5uXOq.useContext)((0, $iszzG.PeekMenuIdContext));
    return !!peekMenuId && moreMenuIds.includes(peekMenuId) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3muxY.ConfigurableMenuItem), {
        isDefaultOpen: true,
        menuData: menuData,
        menuId: peekMenuId
    });
};

});

parcelRegister("hBVbZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $972efabdcaff5f8b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $972efabdcaff5f8b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    more: {
        "id": "navigation-apps-sidebar-nav4-sidebar-content.configurable-menu-items.sidebar-customization.more",
        "defaultMessage": "More"
    }
});

});

parcelRegister("h3Slk", function(module, exports) {

$parcel$export(module.exports, "CustomizeSidebar", () => $476b63d94ba584a9$export$bfa967364825ce72);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2KAtx = parcelRequire("2KAtx");

var $6sQAR = parcelRequire("6sQAR");

var $7yQiQ = parcelRequire("7yQiQ");

var $k327m = parcelRequire("k327m");
function $476b63d94ba584a9$export$bfa967364825ce72({ productItemsData: productItemsData, appItemsData: appItemsData }) {
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            productItemsData: productItemsData,
            appItemsData: appItemsData
        }), [
        productItemsData,
        appItemsData
    ]);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $6sQAR.CustomisableSidebarModalEntrypoint),
        entryPointProps: entryPointParams,
        title: formatMessage((0, $k327m.default).customizeSidebar),
        useInternalModal: false
    }, ({ ref: ref })=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7yQiQ.CustomizeSidebarMenuItem), {
            ref: ref
        }));
}

});
parcelRegister("6sQAR", function(module, exports) {

$parcel$export(module.exports, "CustomisableSidebarModalEntrypoint", () => $70c42c9468d82fee$export$420f0b14c9bb574e);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $70c42c9468d82fee$export$420f0b14c9bb574e = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("gLLFz")).then(({ JiraCustomizationModal: JiraCustomizationModal })=>JiraCustomizationModal), {
        moduleId: "fd0bd96d",
        priority: "interaction"
    }),
    getPreloadProps: (props)=>({
            queries: {},
            props: props
        })
});

});
parcelRegister("gLLFz", function(module, exports) {

let $c3560346e51de875$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c3560346e51de875$var$load("j3vq9").then(()=>parcelRequire('9XBkh'));

});


parcelRegister("7yQiQ", function(module, exports) {

$parcel$export(module.exports, "CustomizeSidebarMenuItem", () => $3bf3d8658fdf9651$export$b7fa0daee00ba08b);

var $5uXOq = parcelRequire("5uXOq");

var $4QAwn = parcelRequire("4QAwn");

var $jpyeI = parcelRequire("jpyeI");

var $24a2m = parcelRequire("24a2m");

var $eQV8d = parcelRequire("eQV8d");

var $jecJ3 = parcelRequire("jecJ3");

var $k327m = parcelRequire("k327m");
const $3bf3d8658fdf9651$export$b7fa0daee00ba08b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onClick: onClick }, ref)=>{
    const { formattedMessage: formattedMessage, icon: icon } = (0, $24a2m.useFormattedMessageAndIcon)((0, $k327m.default).customizeSidebar, (0, (/*@__PURE__*/$parcel$interopDefault($4QAwn))));
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    const onClickHandler = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        sendSectionItemAnalyticsEvent({
            sectionItem: (0, $jecJ3.SECTION_ITEM_CUSTOMIZE_SIDEBAR)
        });
        onClick?.(event, analyticsEvent);
    }, [
        onClick,
        sendSectionItemAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jpyeI.ButtonMenuItem), {
        interactionName: "nav4-sidebar-customise-modal",
        elemBefore: icon,
        onClick: onClickHandler,
        ref: ref
    }, formattedMessage);
});

});
parcelRegister("4QAwn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8bb9804f9ea7eaa10f227008c94bcff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3878591d802e976a$var$_react = $3878591d802e976a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3878591d802e976a$var$_baseNew = $3878591d802e976a$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3878591d802e976a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Customize".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: customize sidebar, customize view, settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3878591d802e976a$var$CustomizeIcon = (props)=>/*#__PURE__*/ $3878591d802e976a$var$_react.default.createElement($3878591d802e976a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.375C3 1.615 3.616 1 4.375 1h1.75c.76 0 1.375.616 1.375 1.375v4.25C7.5 7.385 6.884 8 6.125 8h-1.75C3.615 8 3 7.384 3 6.625V5.25H0v-1.5h3zm1.5.125v4H6v-4zM16 5.25H8.5v-1.5H16zM8.5 9.375C8.5 8.615 9.116 8 9.875 8h1.75C12.385 8 13 8.616 13 9.375v1.375h3v1.5h-3v1.375c0 .76-.616 1.375-1.375 1.375h-1.75c-.76 0-1.375-.616-1.375-1.375zM10 9.5v4h1.5v-4zM0 12.25v-1.5h7.5v1.5z" clip-rule="evenodd"/>`
    }, props));
$3878591d802e976a$var$CustomizeIcon.displayName = 'CustomizeIcon';
var $3878591d802e976a$var$_default = module.exports.default = $3878591d802e976a$var$CustomizeIcon;

});

parcelRegister("k327m", function(module, exports) {

$parcel$export(module.exports, "default", () => $488968c72ecfab5f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $488968c72ecfab5f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    customizeSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebar-content.configurable-menu-items.sidebar-customization.customize-sidebar-menu-item.customize-sidebar",
        "defaultMessage": "Customize sidebar"
    }
});

});




parcelRegister("8FnIk", function(module, exports) {

$parcel$export(module.exports, "PeekMenuIdContextProvider", () => $e1d6abe2c6ea1ed4$export$b7d1a20f5a877f18);

var $5uXOq = parcelRequire("5uXOq");

var $jhS4y = parcelRequire("jhS4y");

var $c6x3L = parcelRequire("c6x3L");

var $lJ5jf = parcelRequire("lJ5jf");

var $iszzG = parcelRequire("iszzG");
// Eventually this will be all configurable menu ids and can be removed at that point.
// TODO: Adam, I think we've reached that point.
const $e1d6abe2c6ea1ed4$var$CONFIGURABLE_MENU_IDS_USING_SIDEBAR_CONTEXT = [
    (0, $jhS4y.CONFIGURABLE_MENU_ID).ASSETS,
    (0, $jhS4y.CONFIGURABLE_MENU_ID).APPS,
    (0, $jhS4y.CONFIGURABLE_MENU_ID).DASHBOARDS,
    (0, $jhS4y.CONFIGURABLE_MENU_ID).FILTERS,
    (0, $jhS4y.CONFIGURABLE_MENU_ID).OPERATIONS,
    (0, $jhS4y.CONFIGURABLE_MENU_ID).PLANS,
    (0, $jhS4y.CONFIGURABLE_MENU_ID).PROJECTS
];
const $e1d6abe2c6ea1ed4$export$b7d1a20f5a877f18 = ({ children: children })=>{
    const { isSelectedPath: isSelectedPath } = (0, $c6x3L.useSidebarNav4)();
    const { isControlledNav: isControlledNav, isControlledPath: isControlledPath } = (0, $lJ5jf.useSidebarNav4Controller)();
    const { moreMenuIds: moreMenuIds } = (0, $5uXOq.useContext)((0, $iszzG.NavItemsContext));
    const [peekMenuId, setPeekMenuId] = (0, $5uXOq.useState)(()=>$e1d6abe2c6ea1ed4$var$getAutoPeekMenuId(isSelectedPath, isControlledNav, isControlledPath, moreMenuIds));
    // This effect automatically overrides the manual value of peek menu id (set when clicking in the more menu item).
    // This effect is only triggered when controlled, selected, or more menu ids change.
    // Use layout effect so peek menu id is set before render.
    // An alternative to any effect would be to set peek menu id when setting selected path.
    // However, that may require elevating this context.
    (0, $5uXOq.useLayoutEffect)(()=>setPeekMenuId((currentPeekMenuId)=>$e1d6abe2c6ea1ed4$var$getAutoPeekMenuId(isSelectedPath, isControlledNav, isControlledPath, moreMenuIds, currentPeekMenuId)), [
        isControlledNav,
        isControlledPath,
        isSelectedPath,
        moreMenuIds
    ]);
    const peekMenuIdContext = (0, $5uXOq.useMemo)(()=>({
            peekMenuId: peekMenuId,
            setPeekMenuId: setPeekMenuId
        }), [
        peekMenuId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iszzG.PeekMenuIdContext).Provider, {
        value: peekMenuIdContext
    }, children);
};
const $e1d6abe2c6ea1ed4$var$getAutoPeekMenuId = (isSelectedPath, isControlledNav, isControlledPath, moreMenuIds, peekMenuId)=>{
    // When controlled...
    if (isControlledNav) return moreMenuIds.find(isControlledPath);
    // Otherwise selected...
    const autoPeekMenuId = moreMenuIds.find(isSelectedPath);
    // Once all configurable menu ids are using sidebar context we can just return `autoPeekMenuId`.
    if (autoPeekMenuId) return autoPeekMenuId;
    // Unpeek if peek menu id is no longer selected.
    // Only do this for menu ids using the sidebar context for now.
    // Legacy menu ids set peek menu id manually.
    if (peekMenuId && $e1d6abe2c6ea1ed4$var$CONFIGURABLE_MENU_IDS_USING_SIDEBAR_CONTEXT.includes(peekMenuId)) return undefined;
    // Otherwise unchanged.
    return peekMenuId;
};

});

parcelRegister("ef14J", function(module, exports) {

$parcel$export(module.exports, "GlobalShortcutsWithInvitePeopleProvider", () => $d56ea5e2a8fc5255$export$19459237290a4ec4);
$parcel$export(module.exports, "GlobalShortcuts", () => $d56ea5e2a8fc5255$export$bae2da217bf9db6);

var $5uXOq = parcelRequire("5uXOq");

var $koeKL = parcelRequire("koeKL");

var $3SCPg = parcelRequire("3SCPg");
var $aCYtG = parcelRequire("aCYtG");

var $auvFs = parcelRequire("auvFs");

var $dzg5P = parcelRequire("dzg5P");

var $5m3jG = parcelRequire("5m3jG");

var $2I6rM = parcelRequire("2I6rM");

var $3CClp = parcelRequire("3CClp");

var $b3Hic = parcelRequire("b3Hic");

var $46Cti = parcelRequire("46Cti");

var $14XJw = parcelRequire("14XJw");

var $7trqb = parcelRequire("7trqb");

var $2F2eB = parcelRequire("2F2eB");

var $jybPW = parcelRequire("jybPW");

var $4Pf62 = parcelRequire("4Pf62");

var $cL1cz = parcelRequire("cL1cz");

var $anvqT = parcelRequire("anvqT");
const $d56ea5e2a8fc5255$var$AssetsComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jybPW.GlobalAppShortcuts), {
        menuId: (0, $46Cti.L1_MENU_ID).GLOBAL_APP_ASSETS
    });
const $d56ea5e2a8fc5255$var$GlobalShortcutsComponent = ({ appItemsData: appItemsData, teamsAppConfig: teamsAppConfig, handleUpdateGetFilteredProductLinks: handleUpdateGetFilteredProductLinks })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const licenceStates = (0, $7trqb.useLicenseStates)();
    const products = (0, $4Pf62.getLicensedProducts)();
    const hasConfluence = products[(0, $4Pf62.LICENSED_PRODUCTS).CONFLUENCE];
    const hasLoom = products[(0, $4Pf62.LICENSED_PRODUCTS).LOOM];
    // Filter product shortcuts based on licence states
    const licenceFilterMap = (0, $5uXOq.useMemo)(()=>{
        // Map shortcut configs to menu identifiers
        const shortcutsMap = {
            [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: (0, $auvFs.default)(()=>''),
            [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_LOOM]: (0, $dzg5P.default)(()=>''),
            [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_GOALS]: (0, $5m3jG.default)(()=>'https://home.atlassian.com/goals'),
            [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_PROJECTS]: (0, $3CClp.default)(()=>'https://home.atlassian.com/projects'),
            ...teamsAppConfig ? {
                [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_TEAMS]: teamsAppConfig
            } : {},
            [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_ASSETS]: {
                ...(0, $b3Hic.default)(()=>'/jira/assets'),
                component: $d56ea5e2a8fc5255$var$AssetsComponent
            },
            [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: (0, $2I6rM.default)(()=>'')
        };
        if (licenceStates.core === 'ACTIVE') {
            if (licenceStates.serviceDesk === 'ACTIVE') return {
                ...hasConfluence ? {
                    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: (0, $auvFs.default)(()=>'')
                } : {},
                ...hasLoom ? {
                    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_LOOM]: (0, $dzg5P.default)(()=>'')
                } : {},
                [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_ASSETS]: shortcutsMap[(0, $46Cti.L1_MENU_ID).GLOBAL_APP_ASSETS],
                [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: shortcutsMap[(0, $46Cti.L1_MENU_ID).GLOBAL_APP_OPSGENIE],
                ...teamsAppConfig ? {
                    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_TEAMS]: teamsAppConfig
                } : {},
                [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_GOALS]: shortcutsMap[(0, $46Cti.L1_MENU_ID).GLOBAL_APP_GOALS]
            };
            if (licenceStates.productDiscovery === 'ACTIVE') return {
                ...hasConfluence ? {
                    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: (0, $auvFs.default)(()=>'')
                } : {},
                ...hasLoom ? {
                    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_LOOM]: (0, $dzg5P.default)(()=>'')
                } : {},
                ...teamsAppConfig ? {
                    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_TEAMS]: teamsAppConfig
                } : {},
                [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_GOALS]: shortcutsMap[(0, $46Cti.L1_MENU_ID).GLOBAL_APP_GOALS]
            };
        } else {
            if (licenceStates.serviceDesk === 'ACTIVE') return {
                [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_ASSETS]: shortcutsMap[(0, $46Cti.L1_MENU_ID).GLOBAL_APP_ASSETS],
                [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: shortcutsMap[(0, $46Cti.L1_MENU_ID).GLOBAL_APP_OPSGENIE],
                ...teamsAppConfig ? {
                    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_TEAMS]: teamsAppConfig
                } : {},
                [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_GOALS]: shortcutsMap[(0, $46Cti.L1_MENU_ID).GLOBAL_APP_GOALS]
            };
            if (licenceStates.productDiscovery === 'ACTIVE') return {
                ...teamsAppConfig ? {
                    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_TEAMS]: teamsAppConfig
                } : {},
                [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_GOALS]: shortcutsMap[(0, $46Cti.L1_MENU_ID).GLOBAL_APP_GOALS]
            };
        }
        return {
            ...hasConfluence ? {
                [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: (0, $auvFs.default)(()=>'')
            } : {},
            ...hasLoom ? {
                [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_LOOM]: (0, $dzg5P.default)(()=>'')
            } : {},
            ...teamsAppConfig ? {
                [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_TEAMS]: teamsAppConfig
            } : {},
            [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_GOALS]: shortcutsMap[(0, $46Cti.L1_MENU_ID).GLOBAL_APP_GOALS],
            [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_PROJECTS]: shortcutsMap[(0, $46Cti.L1_MENU_ID).GLOBAL_APP_PROJECTS]
        };
    }, [
        licenceStates,
        teamsAppConfig,
        hasConfluence,
        hasLoom
    ]);
    // sort filtered products based on order of appItemsData
    const orderedShortcuts = (0, $cL1cz.useOrderedAppShortcuts)(licenceFilterMap, appItemsData);
    // sync updated shortcut items across the other atomic components
    const onUpdateGetFilteredProductLinks = (getFilteredProductLinks)=>{
        if (onUpdateGetFilteredProductLinks && handleUpdateGetFilteredProductLinks) handleUpdateGetFilteredProductLinks(getFilteredProductLinks);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3SCPg.default), {
        cloudId: cloudId,
        orgId: orgId,
        promoteSite: true,
        shortcutItems: orderedShortcuts,
        product: "jira",
        productLinksFilter: cloudId ? (0, $aCYtG.productLinksWorkspaceCloudIdFilter)(cloudId) : undefined,
        onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks
    });
};
// Wrapper required to use teams app shortcut hook
const $d56ea5e2a8fc5255$var$GlobalShortcutsInvitePeopleWrapper = (props)=>{
    const { component: teamsAppComponent, config: teamsAppConfig } = (0, $anvqT.useTeamsAppShortcut)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, teamsAppComponent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d56ea5e2a8fc5255$var$GlobalShortcutsComponent, {
        ...props,
        teamsAppConfig: teamsAppConfig
    }));
};
const $d56ea5e2a8fc5255$export$19459237290a4ec4 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2F2eB.InvitePeopleModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d56ea5e2a8fc5255$var$GlobalShortcutsInvitePeopleWrapper, props));
};
const $d56ea5e2a8fc5255$export$bae2da217bf9db6 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d56ea5e2a8fc5255$var$GlobalShortcutsComponent, props);
};

});
parcelRegister("3SCPg", function(module, exports) {

$parcel$export(module.exports, "default", () => $008251b54b2b770b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");


var $1PVpv = parcelRequire("1PVpv");

var $2NMNM = parcelRequire("2NMNM");

var $gSZmd = parcelRequire("gSZmd");

var $414Wj = parcelRequire("414Wj");

var $8WHRG = parcelRequire("8WHRG");
var $6l5pC = parcelRequire("6l5pC");
var $ldxWh = parcelRequire("ldxWh");

var $eGlev = parcelRequire("eGlev");

var $1TwZd = parcelRequire("1TwZd");

var $cORqY = parcelRequire("cORqY");

var $aLl6R = parcelRequire("aLl6R");

var $6tqUo = parcelRequire("6tqUo");
function $008251b54b2b770b$var$Menu({ testId: testId, shortcutItems: shortcutItems = [], forceStatic: forceStatic, cloudId: cloudId, orgId: orgId, useSkeleton: useSkeleton, promoteSite: promoteSite, productLinksFilter: productLinksFilter, product: product, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks }) {
    // Update Ref
    const onUpdateGetFilteredProductLinksRef = (0, $5uXOq.useRef)(onUpdateGetFilteredProductLinks);
    onUpdateGetFilteredProductLinksRef.current = onUpdateGetFilteredProductLinks;
    // Filter Ref
    const productLinksFilterRef = (0, $5uXOq.useRef)(productLinksFilter);
    productLinksFilterRef.current = productLinksFilter;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { buildURLAndFetchData: buildURLAndFetchData, status: status, productLinks: productLinks } = (0, $ldxWh.useBFFDataProvider)({
        request: {},
        cloudId: cloudId,
        orgId: orgId,
        forceStatic: forceStatic
    });
    const getFilteredProductLinks = (0, $5uXOq.useCallback)((apsKey)=>{
        let filteredProductLinks = productLinks[apsKey] ?? [];
        if (productLinksFilterRef.current) filteredProductLinks = filteredProductLinks.filter(productLinksFilterRef.current);
        return {
            promotedLink: filteredProductLinks.find((item, _i, arr)=>arr.length === 1 || promoteSite && item.isCurrentSite),
            links: filteredProductLinks.filter((item, _i, arr)=>arr.length === 1 || !(promoteSite && item.isCurrentSite))
        };
    }, [
        productLinks,
        promoteSite
    ]);
    const mappedShortcutItems = (0, $5uXOq.useMemo)(()=>{
        return shortcutItems.map((item, index)=>{
            const key = item.apsKey || `shortcut-${index}`;
            // Render nested items if the dynamic data is available and we are not forcing static rendering
            if (!forceStatic && status?.toLowerCase() === (0, $8WHRG.RequestStatus).COMPLETE && item?.apsKey && productLinks?.[item.apsKey]) {
                const { links: filteredProductLinks, promotedLink: promotedLink } = getFilteredProductLinks(item.apsKey);
                const siteName = filteredProductLinks?.[0]?.displayName;
                // Determine whether shortcut is a single site and is current site and return link instead of flyout
                if (filteredProductLinks.length === 1 && !item.url) item.url = filteredProductLinks[0].url;
                return {
                    ...item,
                    siteName: siteName,
                    key: key,
                    promoted: promotedLink ? {
                        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cORqY.ImageFromUrl), {
                            src: promotedLink.avatar,
                            alt: "",
                            fallback: item.icon
                        }),
                        label: promotedLink.displayName,
                        url: promotedLink.url
                    } : undefined,
                    items: filteredProductLinks.map((link)=>({
                            icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cORqY.ImageFromUrl), {
                                src: link.avatar,
                                alt: "",
                                fallback: item.icon
                            }),
                            label: link.displayName,
                            displayName: link.displayName,
                            url: link.url
                        }))
                };
            }
            return {
                ...item,
                key: key
            };
        });
    }, [
        shortcutItems,
        productLinks,
        forceStatic,
        status,
        getFilteredProductLinks
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (onUpdateGetFilteredProductLinksRef.current) onUpdateGetFilteredProductLinksRef.current(getFilteredProductLinks);
    }, [
        getFilteredProductLinks
    ]);
    const apsKeys = (0, $5uXOq.useMemo)(()=>{
        return shortcutItems.map((item)=>item.apsKey || '').filter((item)=>!!item);
    }, [
        shortcutItems
    ]);
    const mountedRef = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (forceStatic || status?.toLowerCase() !== (0, $8WHRG.RequestStatus).COMPLETE || !Object.keys(productLinks).length || mountedRef.current === true) return;
        mountedRef.current = true;
        const missingShortcuts = shortcutItems.filter((item)=>{
            return !item.url && !item.fallbackUrl?.() && item.apsKey && !productLinks[item.apsKey];
        });
        const intended = shortcutItems.length;
        const rendered = intended - missingShortcuts.length;
        createAnalyticsEvent({
            eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
            action: 'cls',
            actionSubject: 'menu',
            actionSubjectId: 'globalNavigation',
            attributes: {
                name: product,
                intended: intended,
                rendered: rendered,
                missingAPSKeys: missingShortcuts.map((item)=>item.apsKey).filter(Boolean)
            }
        }).fire((0, $eGlev.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        shortcutItems,
        productLinks,
        product,
        forceStatic,
        status
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!forceStatic) buildURLAndFetchData(apsKeys);
    }, [
        apsKeys,
        buildURLAndFetchData,
        forceStatic
    ]);
    const createLinkItem = (0, $5uXOq.useCallback)((shortcut)=>{
        if (status?.toLowerCase() === (0, $8WHRG.RequestStatus).COMPLETE) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6tqUo.ShortcutMenuItem), {
            shortcut: shortcut,
            status: status,
            expandItems: shortcut.items && shortcut.items.length > 1 ? shortcut.items : undefined,
            promotedItem: shortcut.promoted,
            siteName: shortcut.siteName
        }, shortcut.key);
        // Show skeleton while BFF is loading
        if (useSkeleton && (status === (0, $8WHRG.RequestStatus).LOADING || status === (0, $8WHRG.RequestStatus).INIT)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aLl6R.MenuSkeletonItem), {}, shortcut.key);
        // We only want to allow static menu expand item if we are forcing static,
        // otherwise it should be showing the singular item as a disabled link until the
        // data is loaded.
        if (forceStatic && shortcut.items) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6tqUo.ShortcutMenuItem), {
            shortcut: shortcut,
            expandItems: shortcut.items,
            forceStatic: forceStatic
        }, shortcut.key);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6tqUo.ShortcutMenuItem), {
            shortcut: shortcut,
            status: status,
            forceStatic: forceStatic
        }, shortcut.key);
    }, [
        forceStatic,
        status,
        useSkeleton
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $414Wj.default), {
        testId: testId,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gSZmd.MenuList), {
            children: mappedShortcutItems?.map(createLinkItem)
        })
    });
}
function $008251b54b2b770b$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6l5pC.BFFProvider), {
        consumer: (0, $8WHRG.BFFConsumerEnum).GLOBAL_SHORTCUTS,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1TwZd.GlobalShortcutsWithIntlProvider), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1PVpv.NavigationAnalyticsContext), {
                data: {
                    product: props?.product
                },
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($008251b54b2b770b$var$Menu, {
                    ...props
                })
            })
        })
    });
}

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $676c5e519aa5ba55$export$a1562d08625f5d7e = 'ui';
const $676c5e519aa5ba55$export$947dac6c72b26f81 = 'track';
const $676c5e519aa5ba55$export$f1d537d508d2945a = 'screen';
const $676c5e519aa5ba55$export$12346a674644c156 = 'operational';
const $676c5e519aa5ba55$export$b055de0e665cb20c = 'unknown';

parcelRegister("8WHRG", function(module, exports) {

$parcel$export(module.exports, "BFFConsumerEnum", () => $4ecfd0ca2cefa9e0$export$9a146e025690327e);
$parcel$export(module.exports, "ASSETS_APP_KEY", () => $4ecfd0ca2cefa9e0$export$45e63649edff1e2a);
$parcel$export(module.exports, "MAX_ATTEMPTS_DEFAULT", () => $4ecfd0ca2cefa9e0$export$45c80c6b98d65f36);
$parcel$export(module.exports, "RETRY_INTERVAL_DEFAULT", () => $4ecfd0ca2cefa9e0$export$7b4183e5f0de390a);
$parcel$export(module.exports, "DAYS_AUTO_PROVISIONED_ITEM_CONSIDERED_NEW", () => $4ecfd0ca2cefa9e0$export$891dc7068a3d5e65);
$parcel$export(module.exports, "DAYS_END_USER_ACTIVE_PRODUCT_CONSIDERED_NEW", () => $4ecfd0ca2cefa9e0$export$6e594fe130dbe3b);
$parcel$export(module.exports, "RequestStatus", () => $4ecfd0ca2cefa9e0$export$600e7c1f9e0414e1);
$parcel$export(module.exports, "BFF_REQUEST_STATUS_KEY", () => $4ecfd0ca2cefa9e0$export$c889532d47d74e9c);
$parcel$export(module.exports, "FLIGHTDECK_REQUEST_STATUS_KEY", () => $4ecfd0ca2cefa9e0$export$123b1b8742c0ac6a);
var $4ecfd0ca2cefa9e0$export$9a146e025690327e = /*#__PURE__*/ function(BFFConsumerEnum) {
    BFFConsumerEnum["ATLASSIAN_SWITCHER"] = "ATLASSIAN_SWITCHER";
    BFFConsumerEnum["GLOBAL_SHORTCUTS"] = "GLOBAL_SHORTCUTS";
    BFFConsumerEnum["GLOBAL_SIDE_NAVIGATION"] = "GLOBAL_SIDE_NAVIGATION";
    BFFConsumerEnum["UNIVERSAL_CREATE"] = "UNIVERSAL_CREATE";
    return BFFConsumerEnum;
}({});
const $4ecfd0ca2cefa9e0$export$45e63649edff1e2a = 'ASSETS';
const $4ecfd0ca2cefa9e0$export$45c80c6b98d65f36 = 3;
const $4ecfd0ca2cefa9e0$export$7b4183e5f0de390a = 1000;
const $4ecfd0ca2cefa9e0$export$891dc7068a3d5e65 = 14;
const $4ecfd0ca2cefa9e0$export$6e594fe130dbe3b = 14;
var $4ecfd0ca2cefa9e0$export$600e7c1f9e0414e1 = /*#__PURE__*/ function(RequestStatus) {
    RequestStatus["INIT"] = "initializing";
    RequestStatus["LOADING"] = "loading";
    RequestStatus["COMPLETE"] = "complete";
    RequestStatus["ERROR"] = "error";
    return RequestStatus;
}({});
const $4ecfd0ca2cefa9e0$export$c889532d47d74e9c = 'bff';
const $4ecfd0ca2cefa9e0$export$123b1b8742c0ac6a = 'flightdeck';
const $4ecfd0ca2cefa9e0$export$95d80cce92acae9 = 'uc-suggestions';

});

parcelRegister("6l5pC", function(module, exports) {

$parcel$export(module.exports, "BFFContext", () => $43c7eb1a61e92f7c$export$873dcaf380a86d6b);
$parcel$export(module.exports, "BFFProvider", () => $43c7eb1a61e92f7c$export$71a938590b6955cc);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8WHRG = parcelRequire("8WHRG");
const $43c7eb1a61e92f7c$export$b2445cd6f2d7fd5 = {
    cache: {},
    cacheKey: '',
    status: null,
    consumer: null
};
const $43c7eb1a61e92f7c$export$873dcaf380a86d6b = /*#__PURE__*/ (0, $5uXOq.createContext)({
    value: $43c7eb1a61e92f7c$export$b2445cd6f2d7fd5,
    currentLoadingRequests: [],
    setValue: ()=>{},
    updateCurrentLoadingRequests: (name, status)=>{}
});
function $43c7eb1a61e92f7c$export$71a938590b6955cc({ consumer: consumer, children: children }) {
    const [value, setValue] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState({
        cache: {},
        cacheKey: consumer,
        consumer: consumer,
        status: (0, $8WHRG.RequestStatus).INIT
    });
    const [currentLoadingRequests, setCurrentLoadingRequests] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState([]);
    const updateCurrentLoadingRequests = (0, $5uXOq.useCallback)((name, status)=>{
        switch(status){
            case (0, $8WHRG.RequestStatus).LOADING:
                setCurrentLoadingRequests((prev)=>[
                        ...prev,
                        name
                    ]);
                break;
            case (0, $8WHRG.RequestStatus).COMPLETE:
                setCurrentLoadingRequests((prev)=>prev.filter((request)=>request !== name));
                break;
            case (0, $8WHRG.RequestStatus).ERROR:
                setCurrentLoadingRequests([]);
                break;
        }
    }, [
        setCurrentLoadingRequests
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($43c7eb1a61e92f7c$export$873dcaf380a86d6b.Provider, {
        value: {
            value: value,
            setValue: setValue,
            currentLoadingRequests: currentLoadingRequests,
            updateCurrentLoadingRequests: updateCurrentLoadingRequests
        },
        children: children
    });
}

});

parcelRegister("ldxWh", function(module, exports) {

$parcel$export(module.exports, "useBFFDataProvider", () => $7020588edfa1ab60$export$a00b492c9c3c66db);

var $5uXOq = parcelRequire("5uXOq");

var $8WHRG = parcelRequire("8WHRG");

var $5gEXK = parcelRequire("5gEXK");

var $9o6AH = parcelRequire("9o6AH");

var $lTU6F = parcelRequire("lTU6F");

var $3fhMO = parcelRequire("3fhMO");

var $c1MIo = parcelRequire("c1MIo");
async function $7020588edfa1ab60$var$wait(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
function $7020588edfa1ab60$export$a00b492c9c3c66db({ request: request, cloudId: cloudId, orgId: orgId, forceStatic: forceStatic }) {
    const { items: cachedItems, addItemsToCache: addItemsToCache, clearCache: clearCache, cacheKey: cacheKey, updateCacheKey: updateCacheKey } = (0, $9o6AH.useCache)();
    const { setStatus: setStatus, status: status } = (0, $3fhMO.useStatus)();
    const { productLinks: productLinks } = (0, $lTU6F.useProductLinks)({
        cloudId: cloudId,
        orgId: orgId,
        forceStatic: forceStatic
    });
    const { buildURL: buildURL } = (0, $c1MIo.useURLBuilder)({
        cloudId: cloudId
    });
    const currentRequest = (0, $5uXOq.useRef)(null);
    const fetchData = (0, $5uXOq.useCallback)(async (url, data, attemptCount = 1, successCheck)=>{
        if (url === '') throw new Error('URL is empty');
        setStatus((0, $8WHRG.RequestStatus).LOADING, (0, $8WHRG.BFF_REQUEST_STATUS_KEY));
        try {
            const response = await (0, $5gEXK.fetchJSON)(url, {});
            switch(response.status){
                case (0, $8WHRG.RequestStatus).ERROR:
                    throw response.error;
                case (0, $8WHRG.RequestStatus).COMPLETE:
                    if (!successCheck || successCheck(response.data)) {
                        setStatus((0, $8WHRG.RequestStatus).COMPLETE, (0, $8WHRG.BFF_REQUEST_STATUS_KEY));
                        currentRequest.current = null;
                        return response.data;
                    } else throw new Error('BFF success check failed');
            }
        } catch (e) {
            const maxAttempts = request?.maxAttempts ?? (0, $8WHRG.MAX_ATTEMPTS_DEFAULT);
            if (request?.shouldRetryOnException && attemptCount < maxAttempts) {
                // Introduce longer wait times for each retry attempt
                await $7020588edfa1ab60$var$wait((request?.attemptInterval ?? (0, $8WHRG.RETRY_INTERVAL_DEFAULT)) * attemptCount);
                return await fetchData(url, data, attemptCount + 1, successCheck);
            } else {
                currentRequest.current = null;
                setStatus((0, $8WHRG.RequestStatus).ERROR);
                throw new Error('Max attempts reached');
            }
        }
    }, [
        request?.attemptInterval,
        request?.maxAttempts,
        request?.shouldRetryOnException,
        setStatus
    ]);
    /**
	 * Helper function to build a URL and fetch data.
	 */ const buildURLAndFetchData = (0, $5uXOq.useCallback)(async (requestedAPSKeys)=>{
        // Wait for the current request to end before firing another
        if (currentRequest.current) return currentRequest.current;
        const builtUrl = buildURL({
            requestedAPSKeys: requestedAPSKeys
        });
        if (builtUrl !== '') {
            currentRequest.current = fetchData(builtUrl, undefined, undefined, (result)=>{
                return result.sites && result.sites.length > 0;
            });
            const fetchedData = await currentRequest.current;
            if (fetchedData.sites && fetchedData.sites.length) addItemsToCache(fetchedData.sites);
        }
    }, [
        addItemsToCache,
        buildURL,
        fetchData
    ]);
    return {
        status: status,
        cachedItems: cachedItems,
        cacheKey: cacheKey,
        updateCacheKey: updateCacheKey,
        addItemsToCache: addItemsToCache,
        clearCache: clearCache,
        buildURL: buildURL,
        fetchData: fetchData,
        buildURLAndFetchData: buildURLAndFetchData,
        productLinks: productLinks
    };
}

});
parcelRegister("5gEXK", function(module, exports) {

$parcel$export(module.exports, "isLocalHost", () => $3ab981076e0a5f18$export$f931afb2c5ecf7c7);
$parcel$export(module.exports, "fetchJSON", () => $3ab981076e0a5f18$export$81bec6e38e8b706b);

var $8WHRG = parcelRequire("8WHRG");

var $eCa3T = parcelRequire("eCa3T");
function $3ab981076e0a5f18$export$23da1d24a38b0bde() {
    const host = window.location.host;
    return host.includes('localhost') || host.includes('.stg.atlassian') || host.includes('jira-dev.com');
}
function $3ab981076e0a5f18$export$f931afb2c5ecf7c7() {
    const host = window.location.host;
    return host.includes('localhost') && host.includes(':');
}
async function $3ab981076e0a5f18$export$81bec6e38e8b706b(url, init) {
    try {
        const response = await fetch(url, {
            ...init,
            credentials: 'include',
            headers: {
                'Atl-BFF-Payload-Version': (0, $eCa3T.default).packageVersion,
                ...init?.headers
            }
        });
        const jsonResponse = await response.json();
        return {
            status: (0, $8WHRG.RequestStatus).COMPLETE,
            data: jsonResponse
        };
    } catch (e) {
        return {
            status: (0, $8WHRG.RequestStatus).ERROR,
            error: e,
            data: null
        };
    }
}

});
parcelRegister("eCa3T", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb112f182be1e25e$export$2e2bcd8739ae039);
const $cb112f182be1e25e$var$packageName = "platform-pkg";
const $cb112f182be1e25e$var$packageVersion = "0.0.0-use.local";
var $cb112f182be1e25e$export$2e2bcd8739ae039 = {
    packageName: $cb112f182be1e25e$var$packageName,
    packageVersion: $cb112f182be1e25e$var$packageVersion
};

});


parcelRegister("9o6AH", function(module, exports) {

$parcel$export(module.exports, "useCache", () => $45c82d874dea59bf$export$c6e89b6bb9436bc0);

var $5uXOq = parcelRequire("5uXOq");

var $6l5pC = parcelRequire("6l5pC");
function $45c82d874dea59bf$export$c6e89b6bb9436bc0() {
    const { value: { consumer: consumer, cache: cache, cacheKey: cacheKey }, setValue: setValue } = (0, $5uXOq.useContext)((0, $6l5pC.BFFContext));
    if (!consumer) throw new Error('BFFContext Consumer is not set');
    const items = (0, $5uXOq.useMemo)(()=>{
        return cache[cacheKey] ?? [];
    }, [
        cache,
        cacheKey
    ]);
    const updateCacheKey = (0, $5uXOq.useCallback)((updatedCacheKey)=>{
        setValue((prev)=>({
                ...prev,
                cacheKey: `${consumer}-${updatedCacheKey}`
            }));
    }, [
        setValue,
        consumer
    ]);
    const addItemsToCache = (0, $5uXOq.useCallback)((items, compareKey = 'cloudId')=>{
        setValue((prev)=>{
            const itemData = prev.cache[cacheKey] ?? [];
            // Overwrite values with matched key if a new value is present
            // This shouldn't be necessary, but it helps act as a safeguard
            // for duplication.
            for (let item of items){
                const replacedItemIndex = itemData.findIndex((i)=>i[compareKey] === item[compareKey]);
                if (replacedItemIndex !== -1) itemData[replacedItemIndex] = item;
                else itemData.push(item);
            }
            return {
                ...prev,
                cache: {
                    ...prev.cache,
                    [cacheKey]: itemData
                }
            };
        });
    }, [
        cacheKey,
        setValue
    ]);
    const clearCache = (0, $5uXOq.useCallback)(()=>{
        setValue((prev)=>({
                ...prev,
                cache: {
                    ...prev.cache,
                    [cacheKey]: []
                }
            }));
    }, [
        cacheKey,
        setValue
    ]);
    return {
        addItemsToCache: addItemsToCache,
        clearCache: clearCache,
        updateCacheKey: updateCacheKey,
        cacheKey: cacheKey,
        items: items
    };
}

});

parcelRegister("lTU6F", function(module, exports) {

$parcel$export(module.exports, "useProductLinks", () => $accf042594794cf8$export$79322ba781a26ce1);

var $5uXOq = parcelRequire("5uXOq");

var $6HV40 = parcelRequire("6HV40");

var $c04PQ = parcelRequire("c04PQ");

var $8WHRG = parcelRequire("8WHRG");

var $wFXKr = parcelRequire("wFXKr");

var $1hP2W = parcelRequire("1hP2W");

var $kJw5h = parcelRequire("kJw5h");

var $9o6AH = parcelRequire("9o6AH");

var $3fhMO = parcelRequire("3fhMO");
function $accf042594794cf8$var$checkIsRecentEndUserActivatedProduct(productType, endUserActivationDate) {
    const parsedEndUserActivationDate = Date.parse(endUserActivationDate || '');
    if (!endUserActivationDate || isNaN(parsedEndUserActivationDate) || ![
        'CONFLUENCE',
        'JIRA_SERVICE_DESK',
        'JIRA_PRODUCT_DISCOVERY'
    ].includes(productType)) return false;
    const days = (0, $wFXKr.daysBetween)(new Date(parsedEndUserActivationDate), new Date());
    return days >= 0 && days <= (0, $8WHRG.DAYS_END_USER_ACTIVE_PRODUCT_CONSIDERED_NEW);
}
function $accf042594794cf8$var$checkIsNewlyAutoProvisioned(autoProvisionDate) {
    let isConsideredNew = false;
    if (autoProvisionDate) {
        const days = (0, $wFXKr.daysBetween)(new Date(autoProvisionDate), new Date());
        isConsideredNew = days >= 0 && days <= (0, $8WHRG.DAYS_AUTO_PROVISIONED_ITEM_CONSIDERED_NEW);
    }
    return isConsideredNew;
}
function $accf042594794cf8$var$checkShouldRemoveJWM(productType) {
    return [
        'JIRA_SOFTWARE',
        'JIRA_PRODUCT_DISCOVERY',
        'JIRA_SERVICE_DESK'
    ].includes(productType);
}
const $accf042594794cf8$var$flightdeckClient = new (0, $6HV40.default)('atlassian-navigagtion-bff-data-provider');
function $accf042594794cf8$export$79322ba781a26ce1({ cloudId: cloudId, orgId: orgId, forceStatic: forceStatic }) {
    const { items: items } = (0, $9o6AH.useCache)();
    const { setStatus: setStatus } = (0, $3fhMO.useStatus)();
    const [fdResponse, setFdResponse] = (0, $5uXOq.useState)(null);
    const [productConfig, setProductConfig] = (0, $5uXOq.useState)(null);
    (0, $5uXOq.useEffect)(()=>{
        const getFlightdeckData = async ()=>{
            try {
                setStatus((0, $8WHRG.RequestStatus).LOADING, (0, $8WHRG.FLIGHTDECK_REQUEST_STATUS_KEY));
                const fdResponse = await $accf042594794cf8$var$flightdeckClient.fetchConfigFromFlightDeck({
                    // app-switcher-fe is currently the only valid name that is configured
                    // in Flightdeck
                    name: 'app-switcher-fe',
                    // This should get updated to be based on the supplied consumer
                    // name: `app-global-shortcuts-${consumer}-fe`,
                    dimensions: {
                        environmentType: 'prod',
                        perimeter: (0, $c04PQ.isFedRamp)() ? 'fedramp-moderate' : 'commercial'
                    }
                });
                setFdResponse(fdResponse);
                setStatus((0, $8WHRG.RequestStatus).COMPLETE, (0, $8WHRG.FLIGHTDECK_REQUEST_STATUS_KEY));
            } catch (e) {
                setStatus((0, $8WHRG.RequestStatus).ERROR, (0, $8WHRG.FLIGHTDECK_REQUEST_STATUS_KEY));
            }
        };
        if (!fdResponse && !forceStatic) getFlightdeckData();
    }, [
        fdResponse,
        setStatus,
        forceStatic
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!fdResponse) return;
        const config = {};
        for (const product of fdResponse.products){
            const { apsKey: apsKey, tcsProductKey: tcsProductKey, siteUrlSuffix: siteUrlSuffix, displayName: displayName, rebrandedDisplayName: rebrandedDisplayName, subtitle: subtitle, ordinal: ordinal, iconKey: iconKey, rebrandedIconKey: rebrandedIconKey } = product;
            config[apsKey] = {
                key: !!tcsProductKey ? tcsProductKey : apsKey.toLowerCase(),
                siteUrlSuffix: siteUrlSuffix,
                ordinal: ordinal,
                label: (0, $kJw5h.formatText)(displayName),
                rebrandedLabel: rebrandedDisplayName && (0, $kJw5h.formatText)(rebrandedDisplayName),
                description: (0, $kJw5h.formatText)(subtitle),
                iconKey: iconKey,
                rebrandedIconKey: rebrandedIconKey
            };
            // TODO: remove this once Asset app becomes standalone app
            if (apsKey === 'JIRA_SERVICE_DESK' && !config[0, $8WHRG.ASSETS_APP_KEY]) config[0, $8WHRG.ASSETS_APP_KEY] = {
                key: (0, $8WHRG.ASSETS_APP_KEY),
                siteUrlSuffix: '/jira/assets',
                ordinal: ordinal + 0.1,
                label: (0, $kJw5h.formatText)('Assets'),
                iconKey: 'assets'
            };
        }
        setProductConfig(config);
    }, [
        fdResponse
    ]);
    const getProductLinkForItem = (0, $5uXOq.useCallback)((productType, siteUrl, productUrl)=>{
        if (productUrl) return productUrl;
        const siteSuffix = productConfig?.[productType]?.siteUrlSuffix;
        return `${siteUrl}${siteSuffix}`;
    }, [
        productConfig
    ]);
    const productLinks = (0, $5uXOq.useMemo)(()=>{
        const products = {};
        const shouldRemoveJWM = items.some((item)=>{
            return (item.availableProducts || []).some(({ productType: productType })=>$accf042594794cf8$var$checkShouldRemoveJWM(productType));
        });
        items.forEach((item)=>{
            const { availableProducts: availableProducts = [], cloudId: cachedItemCloudId, avatar: avatar, url: siteUrl, displayName: displayName, org: org } = item;
            // only apply org level filtering if org data is available
            if (org && orgId && org.id !== orgId) return;
            availableProducts.forEach((product)=>{
                const { autoProvisionDate: autoProvisionDate, companyHubName: companyHubName, isCompanyHubPublishedAndPremium: isCompanyHubPublishedAndPremium, endUserActivationDate: endUserActivationDate, url: productUrl } = product;
                let { productType: productType } = product;
                const isExcludeJiraBusiness = productType === 'JIRA_BUSINESS' && !shouldRemoveJWM;
                // if a site has JWM only and no other Jiras, JWM needs to appear under "Jira"
                // to ensure that this happens, we set JSM's productType to 'JIRA_SOFTWARE'
                // this will ensure that JWM is not removed, even if another site has JSW/JPD/JSM
                if (isExcludeJiraBusiness) productType = 'JIRA_SOFTWARE';
                if (!products[productType]) products[productType] = [];
                if (!isExcludeJiraBusiness) products[productType].push({
                    product: product,
                    isCurrentSite: Boolean(cachedItemCloudId) && cloudId?.toLowerCase() === cachedItemCloudId?.toLowerCase(),
                    isCompanyHubPublishedAndPremium: isCompanyHubPublishedAndPremium,
                    companyHubName: companyHubName,
                    shouldShowNewLozenge: $accf042594794cf8$var$checkIsRecentEndUserActivatedProduct(productType, endUserActivationDate) || productType !== 'CONFLUENCE' && $accf042594794cf8$var$checkIsNewlyAutoProvisioned(autoProvisionDate),
                    shouldShowTryLozenge: productType === 'CONFLUENCE' && $accf042594794cf8$var$checkIsNewlyAutoProvisioned(autoProvisionDate),
                    autoProvisionDate: autoProvisionDate,
                    displayName: displayName,
                    url: getProductLinkForItem(productType, siteUrl, productUrl),
                    avatar: avatar,
                    cloudId: cachedItemCloudId
                });
            });
        });
        return (0, $1hP2W.sortArraysInObject)(products, (a, b)=>{
            return (0, $kJw5h.sortAlphabetically)('asc')(a.displayName, b.displayName);
        });
    }, [
        items,
        orgId,
        cloudId,
        getProductLinkForItem
    ]);
    return {
        productLinks: productLinks
    };
}

});
parcelRegister("wFXKr", function(module, exports) {

$parcel$export(module.exports, "daysBetween", () => $1d5ca493e8b4ae8a$export$416492d1a5f46c79);
const $1d5ca493e8b4ae8a$var$MILLISECONDS_IN_A_DAY = 86400000;
function $1d5ca493e8b4ae8a$export$416492d1a5f46c79(firstDate, secondDate) {
    if (!$1d5ca493e8b4ae8a$var$isValidDate(firstDate) || !$1d5ca493e8b4ae8a$var$isValidDate(secondDate)) return -1;
    const first = firstDate.getTime();
    const second = secondDate.getTime();
    const millisecondsBetween = Math.abs(second - first);
    return Math.round(millisecondsBetween / $1d5ca493e8b4ae8a$var$MILLISECONDS_IN_A_DAY);
}
// https://stackoverflow.com/questions/643782/how-to-check-whether-an-object-is-a-date/44198641#44198641
function $1d5ca493e8b4ae8a$var$isValidDate(date) {
    return date && Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date);
}

});

parcelRegister("1hP2W", function(module, exports) {

$parcel$export(module.exports, "sortArraysInObject", () => $79d3f22ad3936ca1$export$3e8bbf689f8e6cad);
function $79d3f22ad3936ca1$export$3e8bbf689f8e6cad(record, sortFunction) {
    for(const key in record)if (Array.isArray(record[key])) record[key].sort(sortFunction); // Sorts alphabetically or numerically by default
    return record;
}

});

parcelRegister("kJw5h", function(module, exports) {

$parcel$export(module.exports, "formatText", () => $0dd808480a1db97e$export$905fe28a7c283e1d);
$parcel$export(module.exports, "sortAlphabetically", () => $0dd808480a1db97e$export$60f5d4abb43a14b3);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
const $0dd808480a1db97e$export$905fe28a7c283e1d = (text)=>{
    return typeof text === 'string' ? text : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...text
    });
};
const $0dd808480a1db97e$export$60f5d4abb43a14b3 = (direction)=>(a, b)=>{
        const aLower = a.toLowerCase();
        const bLower = b.toLowerCase();
        if (direction === 'asc') return aLower.localeCompare(bLower);
        return bLower.localeCompare(aLower);
    };

});

parcelRegister("3fhMO", function(module, exports) {

$parcel$export(module.exports, "useStatus", () => $e3d7456c56445b47$export$53cc6abb6942ce72);

var $5uXOq = parcelRequire("5uXOq");

var $8WHRG = parcelRequire("8WHRG");

var $6l5pC = parcelRequire("6l5pC");
function $e3d7456c56445b47$export$53cc6abb6942ce72() {
    const { setValue: setValue, value: { status: status }, currentLoadingRequests: currentLoadingRequests, updateCurrentLoadingRequests: updateCurrentLoadingRequests } = (0, $5uXOq.useContext)((0, $6l5pC.BFFContext));
    const isInitializing = (0, $5uXOq.useMemo)(()=>status === (0, $8WHRG.RequestStatus).INIT, [
        status
    ]);
    const isComplete = (0, $5uXOq.useMemo)(()=>status === (0, $8WHRG.RequestStatus).COMPLETE, [
        status
    ]);
    const isError = (0, $5uXOq.useMemo)(()=>status === (0, $8WHRG.RequestStatus).ERROR, [
        status
    ]);
    const isLoading = (0, $5uXOq.useMemo)(()=>status === (0, $8WHRG.RequestStatus).LOADING, [
        status
    ]);
    const isLoaded = (0, $5uXOq.useMemo)(()=>status !== (0, $8WHRG.RequestStatus).LOADING, [
        status
    ]);
    // Globally update the status based on the request queue for the BFF
    (0, $5uXOq.useEffect)(()=>{
        if (!currentLoadingRequests.length && status === (0, $8WHRG.RequestStatus).LOADING) // Ensure that the error state remains if it was previously set
        setValue((prev)=>{
            if (prev.status === (0, $8WHRG.RequestStatus).ERROR) return prev;
            return {
                ...prev,
                status: (0, $8WHRG.RequestStatus).COMPLETE
            };
        });
    }, [
        currentLoadingRequests,
        setValue,
        status
    ]);
    // Globally manage the request queue of any calls to the BFF
    const setStatus = (0, $5uXOq.useCallback)((newStatus, integratingComponent)=>{
        if (newStatus === (0, $8WHRG.RequestStatus).LOADING && integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $8WHRG.RequestStatus).LOADING);
        if (newStatus === (0, $8WHRG.RequestStatus).COMPLETE) {
            if (integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $8WHRG.RequestStatus).COMPLETE);
        }
        if (newStatus === (0, $8WHRG.RequestStatus).ERROR) {
            if (integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $8WHRG.RequestStatus).ERROR);
        }
        // Don't allow the status to be marked as anything other than ERROR
        // if an error is pre-existing
        setValue((prev)=>{
            if (prev.status === (0, $8WHRG.RequestStatus).ERROR) return prev;
            return {
                ...prev,
                status: newStatus === (0, $8WHRG.RequestStatus).ERROR ? (0, $8WHRG.RequestStatus).ERROR : (0, $8WHRG.RequestStatus).LOADING
            };
        });
    }, [
        updateCurrentLoadingRequests,
        setValue
    ]);
    return {
        status: status,
        isInitializing: isInitializing,
        isComplete: isComplete,
        isError: isError,
        isLoading: isLoading,
        isLoaded: isLoaded,
        setStatus: setStatus
    };
}

});


parcelRegister("c1MIo", function(module, exports) {

$parcel$export(module.exports, "useURLBuilder", () => $dada798de50d4003$export$3748aab334e7d372);

var $5uXOq = parcelRequire("5uXOq");

var $8WHRG = parcelRequire("8WHRG");

var $5gEXK = parcelRequire("5gEXK");

var $9o6AH = parcelRequire("9o6AH");

var $aQaz7 = parcelRequire("aQaz7");
var $dada798de50d4003$var$BFFEndpointsEnum = /*#__PURE__*/ function(BFFEndpointsEnum) {
    BFFEndpointsEnum["AVAILABLE_PRODUCTS"] = "/gateway/api/app-switcher/api/available-products";
    BFFEndpointsEnum["SUGGESTIONS"] = "/gateway/api/app-switcher/api/universal-create/v1/suggestions";
    return BFFEndpointsEnum;
}($dada798de50d4003$var$BFFEndpointsEnum || {});
function $dada798de50d4003$export$3748aab334e7d372({ cloudId: cloudId }) {
    const { consumer: consumer } = (0, $aQaz7.useConsumer)();
    const { items: cachedItems } = (0, $9o6AH.useCache)();
    const buildUCRecommendationURL = (0, $5uXOq.useCallback)(({ product: product, orgId: orgId })=>{
        const baseUrl = "/gateway/api/app-switcher/api/universal-create/v1/suggestions";
        const url = new URL(`${getHomeUrl()}${baseUrl}`);
        const searchParams = new URLSearchParams();
        const queryParams = {
            tenantid: cloudId,
            product: product,
            orgid: orgId,
            source: consumer
        };
        Object.entries(queryParams).forEach(([key, value])=>{
            if (value) searchParams.append(key, value);
        });
        // Append search params to URL
        url.search = searchParams.toString();
        return url.toString();
    }, [
        consumer,
        cloudId
    ]);
    const buildProductShortcutURL = (0, $5uXOq.useCallback)(({ requestedAPSKeys: requestedAPSKeys, baseUrl: baseUrl })=>{
        baseUrl = baseUrl ?? "/gateway/api/app-switcher/api/available-products";
        const availableKVPairs = requestedAPSKeys.filter((itemKey)=>!cachedItems.some((cachedItem)=>cachedItem.availableProducts.some((cap)=>cap.productType === itemKey))).map((itemKey)=>[
                'products',
                itemKey
            ]);
        // No point in building a URL if there are no items to fetch and the cache is already populated
        if (!availableKVPairs.length && cachedItems.length > 0) return '';
        // Exclude items that have already been cached
        // and convert to URL query string
        // TODO: return it to the generated combinations:
        // const queryValues = new URLSearchParams(availableKVPairs);
        const queryValues = '';
        return `${getHomeUrl()}${baseUrl}?${queryValues}`;
    }, [
        cachedItems
    ]);
    const buildURL = (0, $5uXOq.useCallback)(({ requestedAPSKeys: requestedAPSKeys, baseUrl: baseUrl })=>{
        let url = '';
        if (baseUrl) url = `${getHomeUrl()}${baseUrl}`;
        // Consumer specific URL building implementations happen here
        switch(consumer){
            case (0, $8WHRG.BFFConsumerEnum).GLOBAL_SHORTCUTS:
                url = buildProductShortcutURL({
                    requestedAPSKeys: requestedAPSKeys
                });
                break;
            case (0, $8WHRG.BFFConsumerEnum).GLOBAL_SIDE_NAVIGATION:
                url = buildProductShortcutURL({
                    requestedAPSKeys: requestedAPSKeys
                });
                break;
        }
        if (!url) return url;
        // Append the consumer to the URL
        const formattedUrl = new URL(url);
        const updatedParams = new URLSearchParams(formattedUrl.search);
        if (consumer) updatedParams.append('source', consumer);
        if (cloudId) updatedParams.append('tenantid', cloudId);
        return `${formattedUrl.origin}${formattedUrl.pathname}?${updatedParams}`;
    }, [
        buildProductShortcutURL,
        consumer,
        cloudId
    ]);
    const getHomeUrl = ()=>{
        if ((0, $5gEXK.isLocalHost)()) return 'https://home.stg.atlassian.com';
        return new URL(window.location.href).origin;
    };
    return {
        buildURL: buildURL,
        buildProductShortcutURL: buildProductShortcutURL,
        buildUCRecommendationURL: buildUCRecommendationURL
    };
}

});
parcelRegister("aQaz7", function(module, exports) {

$parcel$export(module.exports, "useConsumer", () => $9283531d5c5d6dbd$export$33062d550933de6f);

var $5uXOq = parcelRequire("5uXOq");

var $6l5pC = parcelRequire("6l5pC");
function $9283531d5c5d6dbd$export$33062d550933de6f() {
    const { value: { consumer: consumer } } = (0, $5uXOq.useContext)((0, $6l5pC.BFFContext));
    return {
        consumer: consumer
    };
}

});



parcelRegister("eGlev", function(module, exports) {

$parcel$export(module.exports, "Products", () => $1c30622f22784719$export$92e44ea1079b9ec6);
$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $1c30622f22784719$export$85183a312807388d);
/**
 * Product keys as defined in flight-deck.
 * https://bitbucket.org/atlassian/flight-deck/src/master/packages/integrations/twp-switch-to-products/contrib/
 */ var $1c30622f22784719$export$92e44ea1079b9ec6 = /*#__PURE__*/ function(Products) {
    // ATLAS_* - Need to be standalone apps to sit in this space
    Products["ATLAS_HOME"] = "ATLAS_HOME";
    Products["ATLAS_GOALS"] = "GOALS";
    Products["ATLAS_TEAMS"] = "TEAMS";
    Products["ATLAS_HUB"] = "ATLAS_HUB";
    Products["ANALYTICS"] = "ANALYTICS";
    Products["ASSETS"] = "ASSETS";
    Products["BITBUCKET"] = "BITBUCKET";
    Products["COMPASS"] = "COMPASS";
    Products["FOCUS"] = "mercury";
    Products["STUDIO"] = "STUDIO";
    Products["OPSGENIE"] = "OPSGENIE";
    Products["JIRA_SERVICE_MANAGEMENT"] = "JIRA_SERVICE_DESK";
    Products["JIRA_PRODUCT_DISCOVERY"] = "JIRA_PRODUCT_DISCOVERY";
    Products["JIRA_SOFTWARE"] = "JIRA_SOFTWARE";
    Products["CONFLUENCE"] = "CONFLUENCE";
    Products["LOOM"] = "LOOM";
    Products["PROJECTS"] = "PROJECTS";
    Products["TALENT"] = "TALENT";
    Products["TRELLO"] = "TRELLO";
    return Products;
}({});
const $1c30622f22784719$export$85183a312807388d = 'navigation';

});

parcelRegister("1TwZd", function(module, exports) {

$parcel$export(module.exports, "GlobalShortcutsWithIntlProvider", () => $2851c8ecea16080e$export$6b89dea1a4334953);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $96nTn = parcelRequire("96nTn");

var $27oRf = parcelRequire("27oRf");

var $kgrHb = parcelRequire("kgrHb");
const $2851c8ecea16080e$var$fetchMessagesForLocale = async (locale)=>{
    try {
        // Fallback to the generic locale if specified one is not found
        const languageLocale = locale in (0, $kgrHb.asyncLanguages) ? locale : locale.split(/[-_]/)[0] || '';
        // Dynamic import of the locale file
        const localeMessages = await (0, $kgrHb.asyncLanguages)[languageLocale]?.();
        return localeMessages?.default ?? (0, $27oRf.default);
    } catch (e) {
    // ignore
    }
    return 0, $27oRf.default;
};
const $2851c8ecea16080e$export$6b89dea1a4334953 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $96nTn.default), {
        defaultMessages: (0, $27oRf.default),
        loaderFn: $2851c8ecea16080e$var$fetchMessagesForLocale,
        children: children
    });
};

});
parcelRegister("27oRf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4d7bf34ed1785553$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $4d7bf34ed1785553$export$2e2bcd8739ae039 = {
    'navigation.global-shortcuts.all-sites': 'All sites',
    'navigation.global-shortcuts.apps.align': 'Align',
    'navigation.global-shortcuts.apps.analytics': 'Analytics',
    'navigation.global-shortcuts.apps.assets': 'Assets',
    'navigation.global-shortcuts.apps.bitbucket': 'Bitbucket',
    'navigation.global-shortcuts.apps.company-hub': 'Company Hub',
    'navigation.global-shortcuts.apps.compass': 'Compass',
    'navigation.global-shortcuts.apps.confluence': 'Confluence',
    'navigation.global-shortcuts.apps.focus': 'Focus',
    'navigation.global-shortcuts.apps.goals': 'Goals',
    'navigation.global-shortcuts.apps.home': 'Home',
    'navigation.global-shortcuts.apps.jira': 'Jira',
    'navigation.global-shortcuts.apps.jira-product-discovery': 'Jira Product Discovery',
    'navigation.global-shortcuts.apps.jira-service-management': 'Jira Service Management',
    'navigation.global-shortcuts.apps.loom': 'Loom',
    'navigation.global-shortcuts.apps.opsgenie': 'Opsgenie',
    'navigation.global-shortcuts.apps.projects': 'Projects',
    'navigation.global-shortcuts.apps.studio': 'Studio',
    'navigation.global-shortcuts.apps.talent': 'Talent',
    'navigation.global-shortcuts.apps.teams': 'Teams',
    'navigation.global-shortcuts.apps.trello': 'Trello',
    'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': 'Close',
    'navigation.global-shortcuts.menu-expand-item.site-aria-label': '{name} site',
    'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': '(currently unavailable)',
    'navigation.global-shortcuts.menu-link-item.link-external-item-label': 'Open external link icon',
    'navigation.global-shortcuts.menu-link-item.loading-item-aria-label': '(loading)',
    'navigation.global-shortcuts.menu-loading-item.loading-item-aria-label': '(loading)',
    'navigation.global-shortcuts.shortcut-action.open-menu-label': 'open menu',
    'navigation.global-shortcuts.shortcut-link-item.aria-label': '{appName}{siteName}',
    'navigation.global-shortcuts.sites': '{productName} sites'
};

});

parcelRegister("kgrHb", function(module, exports) {

$parcel$export(module.exports, "asyncLanguages", () => $01e444fd08d864c4$export$3770c7a7737d463c);

























const $01e444fd08d864c4$export$3770c7a7737d463c = {
    cs: ()=>(parcelRequire("3weei")),
    da: ()=>(parcelRequire("8nnbC")),
    de: ()=>(parcelRequire("7vb14")),
    'en-GB': ()=>(parcelRequire("1VqcU")),
    'en-ZZ': ()=>(parcelRequire("eYXOt")),
    en: ()=>Promise.resolve((parcelRequire("27oRf"))),
    es: ()=>(parcelRequire("2Et2x")),
    fi: ()=>(parcelRequire("gg4cd")),
    fr: ()=>(parcelRequire("grfff")),
    hu: ()=>(parcelRequire("7CCpl")),
    it: ()=>(parcelRequire("lr8x3")),
    ja: ()=>(parcelRequire("7dcy5")),
    ko: ()=>(parcelRequire("91yB7")),
    nb: ()=>(parcelRequire("areAF")),
    nl: ()=>(parcelRequire("gBj19")),
    pl: ()=>(parcelRequire("4F8rb")),
    'pt-BR': ()=>(parcelRequire("faJo5")),
    ru: ()=>(parcelRequire("hJnP6")),
    sv: ()=>(parcelRequire("gRfzV")),
    th: ()=>(parcelRequire("dwCDT")),
    tr: ()=>(parcelRequire("cpMa0")),
    uk: ()=>(parcelRequire("gGDxy")),
    vi: ()=>(parcelRequire("7THZ9")),
    zh_TW: ()=>(parcelRequire("1ma7Z")),
    zh: ()=>(parcelRequire("5nqbt"))
};

});
parcelRegister("3weei", function(module, exports) {

let $28ff65f8795b34bc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $28ff65f8795b34bc$var$load("eH8We").then(()=>parcelRequire('kGwrf'));

});

parcelRegister("8nnbC", function(module, exports) {

let $61927510ee3e6e2f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $61927510ee3e6e2f$var$load("bRfRr").then(()=>parcelRequire('7Lseo'));

});

parcelRegister("7vb14", function(module, exports) {

let $5763f941bf28b94c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5763f941bf28b94c$var$load("ecPxb").then(()=>parcelRequire('aveJQ'));

});

parcelRegister("1VqcU", function(module, exports) {

let $166f7181092fb90b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $166f7181092fb90b$var$load("6aGQ5").then(()=>parcelRequire('9pfti'));

});

parcelRegister("eYXOt", function(module, exports) {

let $ae8510ed468975d1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ae8510ed468975d1$var$load("eMkc9").then(()=>parcelRequire('l1pXD'));

});

parcelRegister("2Et2x", function(module, exports) {

let $1ee5d7e8d45cb149$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1ee5d7e8d45cb149$var$load("45s1S").then(()=>parcelRequire('3zdsZ'));

});

parcelRegister("gg4cd", function(module, exports) {

let $bd61653bbaef318d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bd61653bbaef318d$var$load("7mrEX").then(()=>parcelRequire('dqJSQ'));

});

parcelRegister("grfff", function(module, exports) {

let $bf7afe474473842d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bf7afe474473842d$var$load("4mKxN").then(()=>parcelRequire('j2o0M'));

});

parcelRegister("7CCpl", function(module, exports) {

let $58c9e004ded1f20c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $58c9e004ded1f20c$var$load("iYkn7").then(()=>parcelRequire('37dLP'));

});

parcelRegister("lr8x3", function(module, exports) {

let $f9b2bce290c61458$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f9b2bce290c61458$var$load("drd60").then(()=>parcelRequire('9EsFy'));

});

parcelRegister("7dcy5", function(module, exports) {

let $54037b3ef0a5daa4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $54037b3ef0a5daa4$var$load("3Tt7n").then(()=>parcelRequire('1kvGh'));

});

parcelRegister("91yB7", function(module, exports) {

let $691f0b68f3417a9d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $691f0b68f3417a9d$var$load("iD9Hp").then(()=>parcelRequire('hN80u'));

});

parcelRegister("areAF", function(module, exports) {

let $7997be5cee0d5ba5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7997be5cee0d5ba5$var$load("e6MGH").then(()=>parcelRequire('e9JYy'));

});

parcelRegister("gBj19", function(module, exports) {

let $c15eda8426d90cfb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c15eda8426d90cfb$var$load("idiEK").then(()=>parcelRequire('268HQ'));

});

parcelRegister("4F8rb", function(module, exports) {

let $36518942a52b7aee$var$load = (parcelRequire("28QjX"))(4);
module.exports = $36518942a52b7aee$var$load("bye27").then(()=>parcelRequire('gwScc'));

});

parcelRegister("faJo5", function(module, exports) {

let $b0baff3596f9e1ff$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b0baff3596f9e1ff$var$load("aHNpO").then(()=>parcelRequire('lv3XG'));

});

parcelRegister("hJnP6", function(module, exports) {

let $ce891e71dcc54110$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ce891e71dcc54110$var$load("4Ig71").then(()=>parcelRequire('3Z1x3'));

});

parcelRegister("gRfzV", function(module, exports) {

let $c45dae1dc0283e3e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c45dae1dc0283e3e$var$load("1nfxc").then(()=>parcelRequire('9zt62'));

});

parcelRegister("dwCDT", function(module, exports) {

let $9d8c3d159e1ff7f9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9d8c3d159e1ff7f9$var$load("7yPxN").then(()=>parcelRequire('2wW2U'));

});

parcelRegister("cpMa0", function(module, exports) {

let $909d2d7fc28f90a8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $909d2d7fc28f90a8$var$load("dO74n").then(()=>parcelRequire('aVnDh'));

});

parcelRegister("gGDxy", function(module, exports) {

let $c25f3d768e260b03$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c25f3d768e260b03$var$load("k6Sks").then(()=>parcelRequire('jfBf2'));

});

parcelRegister("7THZ9", function(module, exports) {

let $5bffca0122226e12$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5bffca0122226e12$var$load("bub0Q").then(()=>parcelRequire('jNEcP'));

});

parcelRegister("1ma7Z", function(module, exports) {

let $0fcfb3b34a879ef0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0fcfb3b34a879ef0$var$load("jvpT9").then(()=>parcelRequire('3wdqM'));

});

parcelRegister("5nqbt", function(module, exports) {

let $3ea36951ff45c4a7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3ea36951ff45c4a7$var$load("2W0AX").then(()=>parcelRequire('fbvi5'));

});



parcelRegister("cORqY", function(module, exports) {

$parcel$export(module.exports, "ImageFromUrl", () => $8c6cf7633d1a1f77$export$8ce0ddc4c9a614d4);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5qRwM = parcelRequire("5qRwM");
const $8c6cf7633d1a1f77$export$8ce0ddc4c9a614d4 = ({ src: src, alt: alt, fallback: fallback, testId: testId })=>{
    const [hasError, setHasError] = (0, $5uXOq.useState)(false);
    if (!src || hasError) return fallback;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5qRwM.default), {
        src: src,
        alt: alt,
        onError: ()=>{
            setHasError(true);
        },
        testId: testId
    });
};

});

parcelRegister("aLl6R", function(module, exports) {

$parcel$export(module.exports, "MenuSkeletonItem", () => $4f31717a503523f6$export$cde35cc9e1359709);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $luBm6 = parcelRequire("luBm6");

var $1DVhQ = parcelRequire("1DVhQ");
const $4f31717a503523f6$var$DEFAULT_MENU_SKELETON_HEIGHT = 32;
const $4f31717a503523f6$var$DEFAULT_AVATAR_HEIGHT = 20;
const $4f31717a503523f6$var$DEFAULT_CONTENT_HEIGHT = 12;
const $4f31717a503523f6$var$DEFAULT_BORDER_RADIUS = 4;
const $4f31717a503523f6$var$styles = {
    root: "_4t3izwfg _1bsb1osq _ca0qze3t _n3tdze3t _19bv1b66 _u5f31b66",
    avatar: "_19bvv77o"
};
const $4f31717a503523f6$export$cde35cc9e1359709 = ({ avatarHeight: avatarHeight = $4f31717a503523f6$var$DEFAULT_AVATAR_HEIGHT, contentHeight: contentHeight = $4f31717a503523f6$var$DEFAULT_CONTENT_HEIGHT })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $luBm6.default), {
        xcss: (0, $3JT92.cx)($4f31717a503523f6$var$styles.root),
        alignBlock: "center",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $kgoHi.default), {
            alignItems: "center",
            gap: "space.050",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                    xcss: (0, $3JT92.cx)($4f31717a503523f6$var$styles.avatar),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1DVhQ.default), {
                        width: avatarHeight,
                        height: avatarHeight,
                        borderRadius: $4f31717a503523f6$var$DEFAULT_BORDER_RADIUS
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1DVhQ.default), {
                    width: "100%",
                    height: contentHeight,
                    borderRadius: "0"
                })
            ]
        })
    });
};

});

parcelRegister("6tqUo", function(module, exports) {

$parcel$export(module.exports, "ShortcutMenuItem", () => $92cca44ee7154eb1$export$af94fce1535255cc);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");


var $2NMNM = parcelRequire("2NMNM");

var $8WHRG = parcelRequire("8WHRG");

var $eGlev = parcelRequire("eGlev");

var $cytvH = parcelRequire("cytvH");

var $7sQLe = parcelRequire("7sQLe");

var $03lcS = parcelRequire("03lcS");

var $5WoEO = parcelRequire("5WoEO");
function $92cca44ee7154eb1$export$af94fce1535255cc({ shortcut: shortcut, status: status, expandItems: expandItems, forceStatic: forceStatic, promotedItem: promotedItem, siteName: siteName }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const analyticsName = (0, $5uXOq.useMemo)(()=>{
        if (typeof shortcut.label === 'string') return shortcut.label;
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(shortcut.label)) return (0, $cytvH.extractNameFromLabel)(shortcut.label);
    }, [
        shortcut.label
    ]);
    const siteNameAriaLabel = siteName ? ` (${siteName})` : '';
    /**
	 * If the data provider is being initialised or loading, we want to display a placeholder item with a spinner.
	 */ const loading = (0, $5uXOq.useMemo)(()=>!!(!forceStatic && status && (status === (0, $8WHRG.RequestStatus).INIT || status === (0, $8WHRG.RequestStatus).LOADING)), [
        status,
        forceStatic
    ]);
    /**
	 * Set disabled state based on what we know at this point
	 * from whether we are forcing static rendering and the status of the BFF request.
	 * If we have more conditions received from the BFF in the future (such as permissions), we can account for those here too.
	 */ const disabled = (0, $5uXOq.useMemo)(()=>{
        // If forceStatic is explicitly set to true, do not disable the item
        if (forceStatic) return false;
        // Do not explicitly disable links that have empty URLs, because we don't want to display them at all
        if (shortcut?.fallbackUrl && shortcut?.fallbackUrl() === '') return false;
        // Only show disabled state when the BFF request is complete and fails
        if (status === (0, $8WHRG.RequestStatus).ERROR) return true;
        if (forceStatic === undefined) return false;
        return !forceStatic;
    }, [
        forceStatic,
        shortcut,
        status
    ]);
    /**
	 * An event to pass down to the inner menu item component (MenuLinkItem or MenuExpandItem) to be called when the item is disabled.
	 * This allows the inner components to handle further disabling conditions within themselves if applicable,
	 * and optionally pass up a reason for the disabled state determined within itself.
	 * If no reason is passed, we check against what we know here from the data received from the BFF.
	 */ const onDisable = (0, $5uXOq.useCallback)((reason)=>{
        // Do not fire analytics event until loading is complete
        if (!status || status === (0, $8WHRG.RequestStatus).INIT || status === (0, $8WHRG.RequestStatus).LOADING) return;
        // This currently covers reasons like request errors.
        // If the BFF gives us more information in the future (such as permissions), that should be accounted for here too.
        const bffReason = status !== (0, $8WHRG.RequestStatus).COMPLETE ? status : undefined;
        createAnalyticsEvent({
            eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
            action: 'disabled',
            actionSubject: 'button',
            actionSubjectId: 'globalNavigation',
            attributes: {
                name: analyticsName,
                reason: reason ?? bffReason
            }
        }).fire((0, $eGlev.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        analyticsName,
        status
    ]);
    const Component = shortcut?.component;
    if (Component) return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        onClick: ()=>{
            (0, $03lcS.fireMenuLinkItemClickAnalyticsEvent)(createAnalyticsEvent, analyticsName);
        }
    });
    if (expandItems && expandItems?.length > 0) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7sQLe.MenuExpandItem), {
        analyticsName: analyticsName,
        icon: shortcut.icon,
        label: shortcut.label,
        items: expandItems,
        disabled: disabled,
        onDisable: onDisable,
        promotedItem: promotedItem,
        loading: loading
    }, shortcut.key);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $03lcS.MenuLinkItem), {
        analyticsName: analyticsName,
        disabled: disabled,
        apsKey: shortcut.apsKey,
        icon: shortcut.icon,
        url: shortcut.url || shortcut?.fallbackUrl?.(),
        label: shortcut.label,
        onDisable: onDisable,
        loading: loading,
        actions: shortcut.actions,
        ariaLabel: formatMessage((0, $5WoEO.messages).menuLinkItemAriaLabel, {
            appName: analyticsName,
            siteName: siteNameAriaLabel
        })
    }, shortcut.key);
}

});
parcelRegister("cytvH", function(module, exports) {

$parcel$export(module.exports, "extractNameFromLabel", () => $30671d85a31ee7f0$export$56d01f50df37ce79);

var $5uXOq = parcelRequire("5uXOq");
const $30671d85a31ee7f0$export$bc8c852df998b819 = (item)=>{
    return item.fallbackUrl !== undefined;
};
const $30671d85a31ee7f0$export$60f5d4abb43a14b3 = (direction)=>(a, b)=>{
        const aLower = a.toLowerCase();
        const bLower = b.toLowerCase();
        if (direction === 'asc') return aLower.localeCompare(bLower);
        return bLower.localeCompare(aLower);
    };
function $30671d85a31ee7f0$export$56d01f50df37ce79(label) {
    if (!label?.props?.children && !label?.props?.defaultMessage) return undefined;
    if (typeof label?.props?.children === 'string') return label?.props?.children;
    else if (typeof label?.props?.defaultMessage === 'string') return label?.props?.defaultMessage;
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(label.props.children)) return $30671d85a31ee7f0$export$56d01f50df37ce79(label.props.children);
}

});

parcelRegister("7sQLe", function(module, exports) {

$parcel$export(module.exports, "MenuExpandItem", () => $9061b208ff93ad74$export$3b6395e687b929ba);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");


var $2NMNM = parcelRequire("2NMNM");

var $eCeGD = parcelRequire("eCeGD");

var $3JT92 = parcelRequire("3JT92");

var $jpyeI = parcelRequire("jpyeI");

var $jUDIz = parcelRequire("jUDIz");
var $17aWz = parcelRequire("17aWz");
var $lBNLs = parcelRequire("lBNLs");

var $gSZmd = parcelRequire("gSZmd");

var $MHKc7 = parcelRequire("MHKc7");

var $eGlev = parcelRequire("eGlev");

var $cytvH = parcelRequire("cytvH");

var $5bKaN = parcelRequire("5bKaN");

var $03lcS = parcelRequire("03lcS");

var $eldgT = parcelRequire("eldgT");

var $16dhF = parcelRequire("16dhF");

var $8H3dR = parcelRequire("8H3dR");
const $9061b208ff93ad74$var$styles = {
    root: "_otyr1b66"
};
const $9061b208ff93ad74$export$3b6395e687b929ba = ({ icon: icon, label: label, analyticsName: analyticsName, items: items, disabled: disabled, onDisable: onDisable, promotedItem: promotedItem, loading: loading })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const closeFlyout = (0, $5uXOq.useCallback)(()=>setIsOpen(false), []);
    const toggleFlyout = (0, $5uXOq.useCallback)(()=>{
        createAnalyticsEvent({
            eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
            action: 'clicked',
            actionSubject: 'globalNavigation',
            actionSubjectId: 'navigationItem',
            attributes: {
                name: analyticsName,
                isExpanding: !isOpen
            }
        }).fire((0, $eGlev.ANALYTICS_CHANNEL));
        setIsOpen((prev)=>!prev);
    }, [
        createAnalyticsEvent,
        analyticsName,
        isOpen
    ]);
    const createLinkItem = (0, $5uXOq.useCallback)((shortcut, index)=>{
        return shortcut.items ? /*#__PURE__*/ (0, $2OMIu.jsx)($9061b208ff93ad74$export$3b6395e687b929ba, {
            icon: shortcut.icon,
            label: shortcut.label,
            items: shortcut.items,
            disabled: disabled,
            actions: shortcut.actions,
            analyticsName: analyticsName
        }, shortcut?.apsKey ?? `shortcut-${index}`) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $03lcS.MenuLinkItem), {
            apsKey: shortcut.apsKey,
            icon: shortcut.icon,
            url: shortcut.url || shortcut?.fallbackUrl?.(),
            label: shortcut.label,
            disabled: disabled,
            ariaLabel: formatMessage((0, $8H3dR.messages).siteAriaLabel, {
                name: (0, $cytvH.extractNameFromLabel)(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                    children: shortcut.label
                }))
            }),
            analyticsName: analyticsName
        }, shortcut?.apsKey ?? `shortcut-${index}`);
    }, [
        disabled,
        formatMessage,
        analyticsName
    ]);
    // If loading state then show loading placeholder
    if (loading === true) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eldgT.MenuLoadingItem), {
        icon: icon,
        label: label
    });
    if (disabled) {
        onDisable?.();
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jpyeI.ButtonMenuItem), {
            elemBefore: icon,
            isDisabled: true,
            children: label
        });
    }
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $jUDIz.FlyoutMenuItem), {
        isOpen: isOpen,
        onOpenChange: setIsOpen,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lBNLs.FlyoutMenuItemTrigger), {
                elemBefore: icon,
                onClick: toggleFlyout,
                children: label
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $17aWz.FlyoutMenuItemContent), {
                onClose: closeFlyout,
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5bKaN.MenuContent), {
                    heading: label,
                    children: [
                        promotedItem && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $16dhF.MenuSection), {
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gSZmd.MenuList), {
                                children: createLinkItem(promotedItem, 1)
                            }, "gas-promoted-sites")
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $16dhF.MenuSection), {
                            label: formatMessage((0, $8H3dR.messages).allSites),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gSZmd.MenuList), {
                                children: items?.map(createLinkItem)
                            }, "gas-all-sites")
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            xcss: (0, $3JT92.cx)($9061b208ff93ad74$var$styles.root),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                                shouldFitContainer: true,
                                appearance: "default",
                                onClick: closeFlyout,
                                children: formatMessage((0, $8H3dR.messages).closeButtonAriaLabel)
                            })
                        })
                    ]
                })
            })
        ]
    });
};

});
parcelRegister("5bKaN", function(module, exports) {

$parcel$export(module.exports, "MenuContent", () => $63e9d4542c99663c$export$479f0f2f71193efe);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $3JT92 = parcelRequire("3JT92");

var $l1N8i = parcelRequire("l1N8i");

var $c8oLN = parcelRequire("c8oLN");
var $dC5iT = parcelRequire("dC5iT");

var $hD4jy = parcelRequire("hD4jy");
const $63e9d4542c99663c$var$styles = {
    root: "_1e0c1txw _2lx21bp4 _c71l1x4w _18m91wug _19bvu2gc _u5f3u2gc",
    heading: "_1rjc12x7 _19bv12x7 _1e0c1txw _4cvr1h6o"
};
const $63e9d4542c99663c$export$479f0f2f71193efe = ({ children: children, heading: heading })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c8oLN.default), {
        xcss: (0, $3JT92.cx)($63e9d4542c99663c$var$styles.root),
        inline: "space.100",
        children: [
            heading && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                xcss: (0, $3JT92.cx)($63e9d4542c99663c$var$styles.heading),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                    size: "xsmall",
                    as: "h2",
                    children: formatMessage((0, $hD4jy.messages).sites, {
                        productName: heading
                    })
                })
            }),
            children
        ]
    });
};

});
parcelRegister("hD4jy", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2c6f769997b770c6$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $2c6f769997b770c6$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    sites: {
        id: 'navigation.global-shortcuts.sites',
        defaultMessage: '{productName} sites',
        description: 'The label that appends the product name in the expand menu'
    }
});

});


parcelRegister("03lcS", function(module, exports) {

$parcel$export(module.exports, "fireMenuLinkItemClickAnalyticsEvent", () => $95964c127205fd3a$export$18a13ecc162cd5c2);
$parcel$export(module.exports, "MenuLinkItem", () => $95964c127205fd3a$export$68ef190193a37bc2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");


var $2NMNM = parcelRequire("2NMNM");

var $3JT92 = parcelRequire("3JT92");

var $ggICg = parcelRequire("ggICg");

var $jpyeI = parcelRequire("jpyeI");

var $cJFfS = parcelRequire("cJFfS");

var $MHKc7 = parcelRequire("MHKc7");

var $eGlev = parcelRequire("eGlev");

var $eldgT = parcelRequire("eldgT");

var $4t7wo = parcelRequire("4t7wo");

var $2wBSU = parcelRequire("2wBSU");
const $95964c127205fd3a$export$18a13ecc162cd5c2 = (createAnalyticsEvent, analyticsName)=>{
    createAnalyticsEvent({
        eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'globalNavigation',
        attributes: {
            name: analyticsName
        }
    }).fire((0, $eGlev.ANALYTICS_CHANNEL));
};
const $95964c127205fd3a$var$styles = {
    iconsBlock: "_18zr12x7"
};
const $95964c127205fd3a$export$68ef190193a37bc2 = ({ analyticsName: analyticsName, url: url, label: label, icon: icon, disabled: disabled, onDisable: onDisable, ariaLabel: ariaLabel, loading: loading, actions: actions })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        $95964c127205fd3a$export$18a13ecc162cd5c2(createAnalyticsEvent, analyticsName);
    }, [
        createAnalyticsEvent,
        analyticsName
    ]);
    // If loading is true, we want to render a representation of the button
    if (loading === true) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eldgT.MenuLoadingItem), {
        icon: icon,
        label: label,
        showLinkIcon: true
    });
    // Don't render anything if url is undefined or empty, and disabled is not explicitly set to true
    if ((!url || url === '') && !disabled) return null;
    // Render disabled items if no url and/or disabled is true
    if (!url || disabled) {
        if (!url || url === '') onDisable?.('Invalid URL');
        else onDisable?.();
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $jpyeI.ButtonMenuItem), {
            elemBefore: icon,
            isDisabled: true,
            children: [
                label,
                /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    "aria-label": formatMessage((0, $2wBSU.messages).disabledItemAriaLabel)
                })
            ]
        });
    }
    // Only render link item if url is defined
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cJFfS.LinkMenuItem), {
        actionsOnHover: actions && actions.length && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4t7wo.ShortcutActionMenu), {
            actions: actions
        }),
        elemBefore: icon,
        elemAfter: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            xcss: (0, $3JT92.cx)($95964c127205fd3a$var$styles.iconsBlock),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ggICg))), {
                label: formatMessage((0, $2wBSU.messages).linkExternalIconLabel),
                size: "small"
            })
        }),
        href: url,
        target: "_blank",
        onClick: onClick,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            "aria-label": ariaLabel,
            children: label
        })
    });
};

});
parcelRegister("eldgT", function(module, exports) {

$parcel$export(module.exports, "MenuLoadingItem", () => $34014be683c4a5d6$export$6c62e509491f8f00);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $3JT92 = parcelRequire("3JT92");

var $ggICg = parcelRequire("ggICg");

var $jpyeI = parcelRequire("jpyeI");

var $MHKc7 = parcelRequire("MHKc7");

var $eZJjh = parcelRequire("eZJjh");

var $3kuNm = parcelRequire("3kuNm");
const $34014be683c4a5d6$var$styles = {
    iconsBlock: "_18zr12x7"
};
const $34014be683c4a5d6$export$6c62e509491f8f00 = ({ icon: icon, label: label, showLinkIcon: showLinkIcon })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $jpyeI.ButtonMenuItem), {
        elemBefore: icon,
        elemAfter: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            xcss: (0, $3JT92.cx)($34014be683c4a5d6$var$styles.iconsBlock),
            children: showLinkIcon ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ggICg))), {
                label: formatMessage((0, $3kuNm.messages).loadingItemAriaLabel),
                size: "small"
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
                size: "small"
            })
        }),
        testId: "menu-button-loading",
        children: [
            label,
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                "aria-label": formatMessage((0, $3kuNm.messages).loadingItemAriaLabel)
            })
        ]
    });
};

});
parcelRegister("3kuNm", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2aa4fa58e58d0790$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $2aa4fa58e58d0790$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    loadingItemAriaLabel: {
        id: 'navigation.global-shortcuts.menu-loading-item.loading-item-aria-label',
        description: 'Additional context after the label text for screen reader users when an item is loading',
        defaultMessage: '(loading)'
    }
});

});


parcelRegister("4t7wo", function(module, exports) {

$parcel$export(module.exports, "ShortcutActionMenu", () => $d559098dd405f031$export$7e648395389e18b0);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $42CjB = parcelRequire("42CjB");

var $dZbEw = parcelRequire("dZbEw");

var $kJpBP = parcelRequire("kJpBP");
var $eZUJu = parcelRequire("eZUJu");

var $1I7E8 = parcelRequire("1I7E8");

var $f6MsG = parcelRequire("f6MsG");
const $d559098dd405f031$export$7e648395389e18b0 = ({ actions: actions })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1I7E8.Popup), {
        shouldRenderToParent: true,
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZUJu.default), {
                children: actions.map((action, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kJpBP.default), {
                        onClick: (e)=>{
                            e.preventDefault();
                            action.onClick?.();
                            setIsOpen(false);
                        },
                        children: action.component
                    }, index))
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                ...triggerProps,
                appearance: "subtle",
                spacing: "compact",
                icon: (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
                        ...props,
                        size: "small"
                    }),
                label: formatMessage((0, $f6MsG.messages).shortcutActionOpenMenuLabel),
                onClick: ()=>setIsOpen(true)
            })
    });
};

});
parcelRegister("f6MsG", function(module, exports) {

$parcel$export(module.exports, "messages", () => $52e271a68d9e4545$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $52e271a68d9e4545$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    shortcutActionOpenMenuLabel: {
        id: 'navigation.global-shortcuts.shortcut-action.open-menu-label',
        description: 'Label for shortcut action items button',
        defaultMessage: 'open menu'
    }
});

});


parcelRegister("2wBSU", function(module, exports) {

$parcel$export(module.exports, "messages", () => $73d99afda22bd447$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $73d99afda22bd447$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    disabledItemAriaLabel: {
        id: 'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label',
        description: 'Additional context after the label text for screen reader users when an item is disabled',
        defaultMessage: '(currently unavailable)'
    },
    loadingItemAriaLabel: {
        id: 'navigation.global-shortcuts.menu-link-item.loading-item-aria-label',
        description: 'Additional context after the label text for screen reader users when an item is loading',
        defaultMessage: '(loading)'
    },
    linkExternalIconLabel: {
        id: 'navigation.global-shortcuts.menu-link-item.link-external-item-label',
        description: 'Label for the link external icon',
        defaultMessage: 'Open external link icon'
    }
});

});


parcelRegister("16dhF", function(module, exports) {

$parcel$export(module.exports, "MenuSection", () => $2e19cfc7cfe3fb78$export$4b1545b4f2016d26);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
const $2e19cfc7cfe3fb78$var$styles = {
    heading: "_11c82smr _1rjcu2gc _19bv12x7 _ca0qu2gc _n3tdu2gc _syaz1gjq _k48p1pd9 _1e0c1txw _4cvr1h6o"
};
const $2e19cfc7cfe3fb78$export$4b1545b4f2016d26 = ({ children: children, label: label })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $kgoHi.default), {
        direction: "column",
        children: [
            label && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                xcss: (0, $3JT92.cx)($2e19cfc7cfe3fb78$var$styles.heading),
                children: label
            }),
            children
        ]
    });
};

});

parcelRegister("8H3dR", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7ec8b39fd52efb7e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $7ec8b39fd52efb7e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    allSites: {
        id: 'navigation.global-shortcuts.all-sites',
        defaultMessage: 'All sites',
        description: 'The "all sites" menu label in expand menu'
    },
    closeButtonAriaLabel: {
        id: 'navigation.global-shortcuts.menu-expand-item.close-button-aria-label',
        description: 'Close button for menu expand item content',
        defaultMessage: 'Close'
    },
    siteAriaLabel: {
        id: 'navigation.global-shortcuts.menu-expand-item.site-aria-label',
        description: 'Aria label for sites',
        defaultMessage: '{name} site'
    }
});

});


parcelRegister("5WoEO", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e43c7d30300070b8$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $e43c7d30300070b8$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    menuLinkItemAriaLabel: {
        id: 'navigation.global-shortcuts.shortcut-link-item.aria-label',
        description: 'Aria label for menu link item',
        defaultMessage: '{appName}{siteName}'
    }
});

});



parcelRegister("aCYtG", function(module, exports) {

$parcel$export(module.exports, "productLinksWorkspaceCloudIdFilter", () => $3819382852b205fa$export$54a1da5292674ec8);
const $3819382852b205fa$export$54a1da5292674ec8 = (workspaceCloudId)=>(item, index, arr)=>{
        const matchedItem = arr.find((productLink)=>{
            return productLink.cloudId === workspaceCloudId;
        });
        // If an item exists in the parent array with the same cloudId,
        // we don't want to show a flyout and instead only want the list
        // of available product links to include the matching cloudId.
        if (matchedItem) return workspaceCloudId === item.cloudId;
        // If the filter gets here we want to only pass the first item
        return index === 0;
    };

});

parcelRegister("auvFs", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b90eac65f4cf92a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $1U4EY = parcelRequire("1U4EY");

var $eGlev = parcelRequire("eGlev");

var $ePcxf = parcelRequire("ePcxf");
function $8b90eac65f4cf92a$export$2e2bcd8739ae039(fallbackUrl) {
    return {
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1U4EY.ConfluenceIcon), {
            size: "20"
        }),
        label: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $ePcxf.messages).label
        }),
        apsKey: (0, $eGlev.Products).CONFLUENCE,
        fallbackUrl: fallbackUrl
    };
}

});
parcelRegister("ePcxf", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d8b4953ae3067ccd$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $d8b4953ae3067ccd$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    label: {
        id: 'navigation.global-shortcuts.apps.confluence',
        defaultMessage: 'Confluence',
        description: 'The link label for Confluence'
    }
});

});


parcelRegister("dzg5P", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4c0e4a204bc92a8$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $9bk6s = parcelRequire("9bk6s");

var $eGlev = parcelRequire("eGlev");

var $ai3CB = parcelRequire("ai3CB");
function $b4c0e4a204bc92a8$export$2e2bcd8739ae039(fallbackUrl) {
    return {
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9bk6s.LoomIcon), {
            size: "20"
        }),
        label: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $ai3CB.messages).label
        }),
        apsKey: (0, $eGlev.Products).LOOM,
        fallbackUrl: fallbackUrl
    };
}

});
parcelRegister("ai3CB", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f725c8b1830d0995$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f725c8b1830d0995$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    label: {
        id: 'navigation.global-shortcuts.apps.loom',
        defaultMessage: 'Loom',
        description: 'The link label for Loom'
    }
});

});


parcelRegister("5m3jG", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cb7a8a573cb9b75$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $8bDjo = parcelRequire("8bDjo");

var $eGlev = parcelRequire("eGlev");

var $gw84o = parcelRequire("gw84o");
function $7cb7a8a573cb9b75$export$2e2bcd8739ae039(fallbackUrl) {
    return {
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8bDjo.GoalsIcon), {
            size: "20"
        }),
        label: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $gw84o.messages).label
        }),
        apsKey: (0, $eGlev.Products).ATLAS_GOALS,
        fallbackUrl: fallbackUrl
    };
}

});
parcelRegister("gw84o", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b6480be3224fc9de$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $b6480be3224fc9de$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    label: {
        id: 'navigation.global-shortcuts.apps.goals',
        defaultMessage: 'Goals',
        description: 'The link label for Goals'
    }
});

});


parcelRegister("2I6rM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3170cad6cf360de3$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $lV2o9 = parcelRequire("lV2o9");

var $eGlev = parcelRequire("eGlev");

var $cV8Bd = parcelRequire("cV8Bd");
function $3170cad6cf360de3$export$2e2bcd8739ae039(fallbackUrl) {
    return {
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lV2o9.OpsgenieIcon), {
            size: "20"
        }),
        apsKey: (0, $eGlev.Products).OPSGENIE,
        label: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $cV8Bd.messages).label
        }),
        fallbackUrl: fallbackUrl
    };
}

});
parcelRegister("cV8Bd", function(module, exports) {

$parcel$export(module.exports, "messages", () => $af6cf9548fbc37f5$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $af6cf9548fbc37f5$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    label: {
        id: 'navigation.global-shortcuts.apps.opsgenie',
        defaultMessage: 'Opsgenie',
        description: 'The link label for Opsgenie'
    }
});

});


parcelRegister("3CClp", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc869fa38f5e8602$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $hT1xk = parcelRequire("hT1xk");

var $bpZfi = parcelRequire("bpZfi");
function $fc869fa38f5e8602$export$2e2bcd8739ae039(fallbackUrl) {
    return {
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hT1xk.ProjectsIcon), {
            size: "20"
        }),
        label: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $bpZfi.messages).label
        }),
        fallbackUrl: fallbackUrl
    };
}

});
parcelRegister("bpZfi", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f9a485d4e91ec13d$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f9a485d4e91ec13d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    label: {
        id: 'navigation.global-shortcuts.apps.projects',
        defaultMessage: 'Projects',
        description: 'The link label for Projects'
    }
});

});


parcelRegister("b3Hic", function(module, exports) {

$parcel$export(module.exports, "default", () => $84d6b78c514d67ca$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $bfgl4 = parcelRequire("bfgl4");

var $joIjC = parcelRequire("joIjC");
function $84d6b78c514d67ca$export$2e2bcd8739ae039(fallbackUrl) {
    return {
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bfgl4.AssetsIcon), {
            size: "20"
        }),
        label: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $joIjC.messages).label
        }),
        fallbackUrl: fallbackUrl
    };
}

});
parcelRegister("joIjC", function(module, exports) {

$parcel$export(module.exports, "messages", () => $482f9cad7ef4899b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $482f9cad7ef4899b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    label: {
        id: 'navigation.global-shortcuts.apps.assets',
        defaultMessage: 'Assets',
        description: 'The link label for Assets'
    }
});

});


parcelRegister("cL1cz", function(module, exports) {

$parcel$export(module.exports, "useOrderedAppShortcuts", () => $194336c61e9586ef$export$4bb4a114d280c175);

var $5uXOq = parcelRequire("5uXOq");
const $194336c61e9586ef$export$4bb4a114d280c175 = (shortcuts, appItemsData)=>{
    const orderedShortcuts = (0, $5uXOq.useMemo)(()=>{
        if (!appItemsData || appItemsData.length === 0) return Object.values(shortcuts);
        return appItemsData.reduce((acc, value)=>{
            const config = shortcuts[value.menuId];
            if (config && value.visible) acc.push(config);
            return acc;
        }, []);
    }, [
        appItemsData,
        shortcuts
    ]);
    return orderedShortcuts;
};

});

parcelRegister("anvqT", function(module, exports) {

$parcel$export(module.exports, "useTeamsAppShortcut", () => $a33b12e41492d305$export$68b2e4594fafcb97);

var $5uXOq = parcelRequire("5uXOq");

var $dS3PR = parcelRequire("dS3PR");

var $koVbs = parcelRequire("koVbs");

var $kHFed = parcelRequire("kHFed");

var $eA0nk = parcelRequire("eA0nk");

var $fxSv8 = parcelRequire("fxSv8");

var $eXCTi = parcelRequire("eXCTi");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");



var $jecJ3 = parcelRequire("jecJ3");

var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");
const $a33b12e41492d305$var$CREATE_A_TEAM = 'createATeam';
const $a33b12e41492d305$var$INVITE_PEOPLE = 'invitePeople';
const $a33b12e41492d305$export$68b2e4594fafcb97 = ()=>{
    const teamsConfig = (0, $kHFed.default)(()=>'/jira/people/search');
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const invitePeopleModalTrigger = (0, $fxSv8.useInvitePeopleModal)();
    const [createTeamModal, createTeamModalTrigger] = (0, $eA0nk.useCreateTeamModal)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const component = (0, $5uXOq.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, createTeamModal);
    }, [
        createTeamModal
    ]);
    const config = (0, $5uXOq.useMemo)(()=>{
        return {
            ...teamsConfig,
            actions: [
                {
                    onClick: ()=>{
                        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                            action: 'clicked',
                            actionSubject: 'dropdownItem',
                            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_TEAMS],
                            attributes: {
                                level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                                componentType: (0, $1e554a683893bd46$export$17bca95234dea43b),
                                parentItemId: (0, $jecJ3.GLOBAL_APP_SHORTCUT_TEAMS),
                                itemId: $a33b12e41492d305$var$INVITE_PEOPLE
                            }
                        });
                        invitePeopleModalTrigger();
                    },
                    component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), null, formatMessage((0, $eXCTi.default).invitePeople))
                },
                {
                    onClick: ()=>{
                        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                            action: 'clicked',
                            actionSubject: 'dropdownItem',
                            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_TEAMS],
                            attributes: {
                                level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                                componentType: (0, $1e554a683893bd46$export$17bca95234dea43b),
                                parentItemId: (0, $jecJ3.GLOBAL_APP_SHORTCUT_TEAMS),
                                itemId: $a33b12e41492d305$var$CREATE_A_TEAM
                            }
                        });
                        createTeamModalTrigger();
                    },
                    component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), null, formatMessage((0, $eXCTi.default).createTeam))
                }
            ]
        };
    }, [
        teamsConfig,
        createTeamModalTrigger,
        invitePeopleModalTrigger,
        formatMessage,
        createAnalyticsEvent
    ]);
    return {
        config: config,
        component: component
    };
};

});
parcelRegister("kHFed", function(module, exports) {

$parcel$export(module.exports, "default", () => $06037d498d325b41$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $by9zw = parcelRequire("by9zw");

var $eGlev = parcelRequire("eGlev");

var $1ukNZ = parcelRequire("1ukNZ");
function $06037d498d325b41$export$2e2bcd8739ae039(fallbackUrl) {
    return {
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $by9zw.TeamsIcon), {
            size: "20"
        }),
        label: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $1ukNZ.messages).label
        }),
        apsKey: (0, $eGlev.Products).ATLAS_TEAMS,
        fallbackUrl: fallbackUrl
    };
}

});
parcelRegister("1ukNZ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b11f4a5105e10671$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $b11f4a5105e10671$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    label: {
        id: 'navigation.global-shortcuts.apps.teams',
        defaultMessage: 'Teams',
        description: 'The link label for Teams'
    }
});

});










parcelRegister("e1cjg", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardEmbedRouteEntry", () => $eac56df495f9e28b$export$b5558b683e9c45a4);

var $c04PQ = parcelRequire("c04PQ");

var $4R6GH = parcelRequire("4R6GH");

var $fKmub = parcelRequire("fKmub");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $7NszV = parcelRequire("7NszV");

var $lfnsv = parcelRequire("lfnsv");

var $lJ1FP = parcelRequire("lJ1FP");

var $f5kpo = parcelRequire("f5kpo");

var $3RJkv = parcelRequire("3RJkv");

var $ipmBb = parcelRequire("ipmBb");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $2Ql51 = parcelRequire("2Ql51");

var $f7Y15 = parcelRequire("f7Y15");

var $gNStA = parcelRequire("gNStA");

var $fEr2a = parcelRequire("fEr2a");

var $16Z5s = parcelRequire("16Z5s");

var $aPfsS = parcelRequire("aPfsS");

var $5QYL3 = parcelRequire("5QYL3");
const $eac56df495f9e28b$export$b5558b683e9c45a4 = (0, $7NszV.createEntry)((0, $fEr2a.classicSoftwareBoardEmbedRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-board-embed',
        component: (0, $16Z5s.RapidBoardSpaPage),
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental-board'),
        layout: (0, $aPfsS.createLayout)({
            isChromeless: true
        }),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            (0, $gNStA.resourceWithCondition2)((0, $f5kpo.shouldLoadUIFBoardResources), (0, $f7Y15.uifBoardResource)),
            // Load the NBT resource if we opt-in UIF, not fedRamp is enabled
            (0, $gNStA.resourceWithCondition2)(()=>(0, $f5kpo.shouldLoadUIFBoardResources)() && !(0, $c04PQ.isFedRamp)(), (0, $ipmBb.nextBestTaskFeatureResource)),
            (0, $lJ1FP.getEditModelResource)(),
            (0, $lfnsv.getBoardDetailsResource)(),
            (0, $2Ql51.themePreferenceResource),
            (0, $5bkvv.forgeBoardModuleResource)
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $16Z5s.UIFBoardSpa)
        ],
        meta: {
            capability: (0, $5QYL3.classicBoardCapability)
        }
    }));

});
parcelRegister("ipmBb", function(module, exports) {

$parcel$export(module.exports, "nextBestTaskFeatureResource", () => $b97b42683de1c9b3$export$5d472f7d515300ca);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");

const $b97b42683de1c9b3$export$5d472f7d515300ca = (0, $2M1hQ.createResource)({
    type: (0, $167b031bfd6a6b6e$export$6f0555de4f60e84e),
    getKey: ()=>(0, $167b031bfd6a6b6e$export$7e7d7930e22ba39f),
    getData: async ()=>{
        try {
            return await (0, $eusud.performGetRequest)(`/rest/api/3/mypreferences?key=${(0, $167b031bfd6a6b6e$export$b94951a11282ae6a)}`);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const initialValueNeverSet = error.statusCode === 404;
            if (initialValueNeverSet) /**
				 * If the user has never set the preference, we auto enroll them and set the initial value to true.
				 */ return {
                hasUserOptedIn: true
            };
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: (0, $167b031bfd6a6b6e$export$7f111648ca05f056),
                    packageName: (0, $167b031bfd6a6b6e$export$b8b9d90f9e5bd72b)
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        /* on error return false,
		 * this ensures if user is in the experiment cohort but later opted out, they don't revert to having the feature enabled */ return {
            hasUserOptedIn: false
        };
    },
    maxAge: Number.MAX_VALUE
});

});
const $167b031bfd6a6b6e$export$6f0555de4f60e84e = 'RESOURCE_TYPE_NEXT_BEST_TASK_FEATURE';
const $167b031bfd6a6b6e$export$7e7d7930e22ba39f = 'nbt-opt-in-resource-key'; // value is global for user
const $167b031bfd6a6b6e$export$b94951a11282ae6a = 'next-best-task-feature';
const $167b031bfd6a6b6e$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesNextBestTask';
const $167b031bfd6a6b6e$export$7f111648ca05f056 = 'useResource.fetchNextBestTaskOptInPreference';


parcelRegister("fEr2a", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardEmbedRoute", () => $4d20da2caca0ff94$export$122afcef7dfd252);
const $4d20da2caca0ff94$export$122afcef7dfd252 = {
    name: 'rapidboard-board-embed',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/embed'
};

});

parcelRegister("5QYL3", function(module, exports) {

$parcel$export(module.exports, "classicBoardCapability", () => $72ffa11e3a10b500$export$a6d9a03b76d2193b);

const $72ffa11e3a10b500$export$a6d9a03b76d2193b = !false ? (0, $281cbd47ba46dd7d$export$664edf77d4c76110) : (0, $281cbd47ba46dd7d$export$fc5f182fc9019b1c);

});


parcelRegister("4t69d", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardRouteEntry", () => $d579a749ad862761$export$f2cd114cf8ab53aa);

var $c04PQ = parcelRequire("c04PQ");

var $ffza4 = parcelRequire("ffza4");

var $e2ctp = parcelRequire("e2ctp");

var $4R6GH = parcelRequire("4R6GH");

var $gyYxw = parcelRequire("gyYxw");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $lfnsv = parcelRequire("lfnsv");

var $lJ1FP = parcelRequire("lJ1FP");

var $f5kpo = parcelRequire("f5kpo");

var $3RJkv = parcelRequire("3RJkv");

var $ipmBb = parcelRequire("ipmBb");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $f7Y15 = parcelRequire("f7Y15");

var $gNStA = parcelRequire("gNStA");

var $lB6pS = parcelRequire("lB6pS");

var $16Z5s = parcelRequire("16Z5s");

var $edJtc = parcelRequire("edJtc");

var $dEJQ9 = parcelRequire("dEJQ9");

var $hWAe2 = parcelRequire("hWAe2");

var $5f2bR = parcelRequire("5f2bR");

var $9V5k0 = parcelRequire("9V5k0");

var $3HwlS = parcelRequire("3HwlS");

var $lmBAt = parcelRequire("lmBAt");

var $5QYL3 = parcelRequire("5QYL3");

var $aSO4t = parcelRequire("aSO4t");
/**
 * Ordinarily it would be inadvisable to evaluate something like this in
 * a static route, as this could lead to inconsistent behaviour between
 * the server and the browser.
 *
 * In this case it is necessary and safe because:
 * 1) There are two versions of the board that share the same route
 *    and we can only tell them apart at runtime. When the old version
 *    is eventually removed, this should be cleaned up.
 * 2) No requests for board data are made on the server, so even
 *    if the value is incorrect on the server it won't be utilised
 * */ const $d579a749ad862761$var$getLayout = ()=>{
    let viewMode = 'DEFAULT';
    if ((0, $dEJQ9.isLocalStorageAvailable)()) viewMode = (0, $edJtc.getViewModeFromLocalStorage)();
    return (0, $aPfsS.composeLayouts)((0, $gyYxw.genericProjectLayout), (0, $g5RGc.pageLoadIssuePreloadLayoutBuilder)([
        {
            query: [
                'selectedIssue'
            ]
        }
    ], viewMode));
};
/**
 * @deprecated delete when cleaning up blu-5799-jira-software-board-entrypoint-route
 */ const $d579a749ad862761$var$getHorizontalNavResources = ()=>(0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route') ? [] : [
        (0, $7uLIV.horizontalNavJiraResource)
    ];
const $d579a749ad862761$export$f2cd114cf8ab53aa = (0, $7NszV.createEntry)((0, $lB6pS.classicSoftwareBoardRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-board',
        component: (0, $16Z5s.RapidBoardSpaPage),
        skeleton: (0, $hWAe2.ClassicBoardSkeleton),
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental-board'),
        layout: $d579a749ad862761$var$getLayout(),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.ForPaintClassicSoftwareProjectSidebar),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true,
            sidebarId: (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route') ? (0, $lmyls.SIDEBAR_ID).CONTENT : undefined
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)({
                isUsingSidebarEntrypoint: // eslint-disable-next-line jira/ff/no-preconditioning
                ((0, $4R6GH.fg)('blu-7261-change-blu-5799-to-support-nav3') || (0, $3HwlS.getWillShowNav4)()) && (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route') && (0, $4R6GH.fg)('jfp-magma-fix-nav4-sidebar-client-api-call')
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // delete when cleaning up blu-5799-jira-software-board-entrypoint-route
            ...$d579a749ad862761$var$getHorizontalNavResources(),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            (0, $gNStA.resourceWithCondition2)((0, $f5kpo.shouldLoadUIFBoardResources), (0, $f7Y15.uifBoardResource)),
            // Load the NBT resource if we opt-in UIF, not fedRamp is enabled
            (0, $gNStA.resourceWithCondition2)(()=>(0, $f5kpo.shouldLoadUIFBoardResources)() && !(0, $c04PQ.isFedRamp)(), (0, $ipmBb.nextBestTaskFeatureResource)),
            (0, $lJ1FP.getEditModelResource)(),
            (0, $lfnsv.getBoardDetailsResource)(),
            (0, $5bkvv.forgeBoardModuleResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingEnabled)(), (0, $9V5k0.projectThemeResource))
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $16Z5s.UIFBoardSpa)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-cmp-board-early-entry'
            ]
        },
        meta: {
            capability: (0, $5QYL3.classicBoardCapability)
        },
        earlyAssets: (0, $e2ctp.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        bifrost: {
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-classic-board-entries/src/classicSoftwareBoardRouteEntry.tsx',
                whichExportToUse: 'classicSoftwareBoardRouteEntry'
            },
            enabled: true,
            manifestName: 'jira-spa-software-board.json'
        },
        entryPoint: ()=>((0, $4R6GH.fg)('blu-7261-change-blu-5799-to-support-nav3') || (0, $3HwlS.getWillShowNav4)()) && (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route') ? (0, $aSO4t.classicBoardPageEntryPoint) : undefined,
        supportsPreviewPanel: true
    }));

});
parcelRegister("lB6pS", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardRoute", () => $9dbec22457c8ec85$export$131d51ca54849e97);
const $9dbec22457c8ec85$export$131d51ca54849e97 = {
    name: 'rapidboard-board',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId'
};

});

parcelRegister("hWAe2", function(module, exports) {

$parcel$export(module.exports, "ClassicBoardSkeleton", () => $845fd4f51bb92262$export$631611c5fdf027d5);
/* ClassicBoardSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $i1CIU = parcelRequire("i1CIU");
const $845fd4f51bb92262$var$customCssStyles = null;
const $845fd4f51bb92262$export$631611c5fdf027d5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($i1CIU))),
        className: (0, $bwpsq.default)([
            "_2zz1idpf"
        ])
    });

});
parcelRegister("i1CIU", function(module, exports) {
module.exports = new URL("classic-board-app-skeleton.tpl.bf1c26f5.svg", import.meta.url).toString();

});


parcelRegister("aSO4t", function(module, exports) {

$parcel$export(module.exports, "classicBoardPageEntryPoint", () => $4fe96d7ad77574d7$export$b7ca8af848cd7993);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $7rNZV = parcelRequire("7rNZV");

var $dwZUI = parcelRequire("dwZUI");

var $fT58V = parcelRequire("fT58V");

var $krpZe = parcelRequire("krpZe");

var $fo6b8 = parcelRequire("fo6b8");
const $4fe96d7ad77574d7$export$b7ca8af848cd7993 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7rNZV.nextGenBoardEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $fT58V.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $krpZe.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $dwZUI.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("7rNZV", function(module, exports) {

$parcel$export(module.exports, "nextGenBoardEntryPoint", () => $c106d875c43f76b2$export$bb3c6f02a735f848);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $c106d875c43f76b2$export$bb3c6f02a735f848 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("3gYTm")), {
        moduleId: "5be6be56",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});



parcelRegister("hu1w9", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardSettingsInsightsRapidboardBacklogRouteEntry", () => $bfec0a4fc8785ec0$export$9bcdab5e8a786007);

var $g87MG = parcelRequire("g87MG");

var $ffza4 = parcelRequire("ffza4");


var $e2ctp = parcelRequire("e2ctp");

var $gyYxw = parcelRequire("gyYxw");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $lfnsv = parcelRequire("lfnsv");

var $f5kpo = parcelRequire("f5kpo");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $gwlQU = parcelRequire("gwlQU");

var $16Z5s = parcelRequire("16Z5s");

var $i8JTM = parcelRequire("i8JTM");

var $5f2bR = parcelRequire("5f2bR");

var $ltiRJ = parcelRequire("ltiRJ");
const $bfec0a4fc8785ec0$export$9bcdab5e8a786007 = (0, $7NszV.createEntry)((0, $gwlQU.classicSoftwareBoardSettingsInsightsRapidboardBacklogRoute), ()=>({
        group: 'classic-software',
        ufoName: 'rapidboard-backlog-insights',
        component: (0, $ltiRJ.InsightsSettingsRedirect),
        skeleton: (0, $i8JTM.NextGenBacklogSkeleton),
        layout: (0, $aPfsS.composeLayouts)((0, $gyYxw.genericProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue',
                    'view=planning'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            (0, $g87MG.issueHierarchyPageResource),
            (0, $lfnsv.getBoardDetailsResource)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $16Z5s.LazyRapidBoard),
            (0, $16Z5s.LazyRapidBoardApps),
            (0, $16Z5s.LazyRapidBoardDataApiResource),
            (0, $16Z5s.LazyRapidBoardConfigApiResource),
            (0, $16Z5s.LazyRapidBoardWrmBundleResource),
            (0, $16Z5s.LazyRapidBoardResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$93104dc4eba58ba4)
        },
        earlyAssets: (0, $e2ctp.AGGRESSIVE_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("g87MG", function(module, exports) {

$parcel$export(module.exports, "issueHierarchyPageResource", () => $6f06dee5876402c3$export$98d50a2e19509817);

var $ao2h1 = parcelRequire("ao2h1");

var $7a4aR = parcelRequire("7a4aR");
const $6f06dee5876402c3$export$98d50a2e19509817 = (0, $ao2h1.createRelayResource)({
    type: 'RESOURCE1',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $7a4aR.default),
            variables: {
                cloudId: tenantContext.cloudId
            }
        })
});

});
parcelRegister("7a4aR", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ea8bf05e90a48f8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8302ec971b0cf37e40bca801469af6c9>>
 * @relayHash 6acb7af1e94f5345e9b36a8cd44c4bee
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b990d47758e2cd9b24e5dbee104f873a7f1b2aead336e44568500c9564afe54b
const $0ea8bf05e90a48f8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "level"
    }, v4 = [
        {
            "concreteType": "JiraIssueTypeHierarchyLevel",
            "kind": "LinkedField",
            "name": "hierarchyLevel",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ]
        },
        {
            "concreteType": "JiraIssueTypeConnection",
            "kind": "LinkedField",
            "name": "cmpIssueTypes",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "issueTypeId"
                                },
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "concreteType": "JiraIssueTypeHierarchyLevel",
                                    "kind": "LinkedField",
                                    "name": "hierarchy",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "small"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ], v5 = {
        "concreteType": "JiraHierarchyConfigError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "code"
            },
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v6 = {
        "args": v1 /*: any*/ ,
        "concreteType": "JiraIssueHierarchyConfigurationQuery",
        "kind": "LinkedField",
        "name": "issueHierarchyConfig",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueHierarchyConfigData",
                "kind": "LinkedField",
                "name": "data",
                "plural": true,
                "selections": v4 /*: any*/ 
            },
            {
                "kind": "ScalarField",
                "name": "success"
            },
            v5 /*: any*/ 
        ]
    }, v7 = {
        "args": v1 /*: any*/ ,
        "concreteType": "JiraIssueHierarchyLimits",
        "kind": "LinkedField",
        "name": "issueHierarchyLimits",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "maxLevels"
            },
            {
                "kind": "ScalarField",
                "name": "nameLength"
            }
        ]
    }, v8 = {
        "args": v1 /*: any*/ ,
        "kind": "ScalarField",
        "name": "lockedIssueTypeIds"
    }, v9 = {
        "concreteType": "JiraIssueHierarchyConfigData",
        "kind": "LinkedField",
        "name": "issueHierarchyConfig",
        "plural": true,
        "selections": v4 /*: any*/ 
    }, v10 = {
        "concreteType": "JiraLongRunningTaskProgress",
        "kind": "LinkedField",
        "name": "taskProgress",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "status"
            },
            {
                "kind": "ScalarField",
                "name": "progress"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainIssueHierarchyQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraHierarchyConfigTask",
                            "kind": "LinkedField",
                            "name": "issueHierarchyConfigUpdateTask",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "kind": "FragmentSpread",
                                    "name": "saveButton_adminPagesIssueHierarchyDirectory"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "saveDialog_adminPagesIssueHierarchyDirectory"
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainIssueHierarchyQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraHierarchyConfigTask",
                            "kind": "LinkedField",
                            "name": "issueHierarchyConfigUpdateTask",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b990d47758e2cd9b24e5dbee104f873a7f1b2aead336e44568500c9564afe54b",
            "metadata": {},
            "name": "mainIssueHierarchyQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0ea8bf05e90a48f8$var$node.hash = "e780e64aedcd2278004df68a042f1343";
var $0ea8bf05e90a48f8$export$2e2bcd8739ae039 = $0ea8bf05e90a48f8$var$node;

});


parcelRegister("gwlQU", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardSettingsInsightsRapidboardBacklogRoute", () => $8b16a5460c1e898c$export$e43f33a0c1ae830c);
const $8b16a5460c1e898c$export$e43f33a0c1ae830c = {
    name: 'rapidboard-backlog',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog',
    query: [
        'config=insightsConfig'
    ]
};

});

parcelRegister("ltiRJ", function(module, exports) {

$parcel$export(module.exports, "InsightsSettingsRedirect", () => $018a8accd0bb9a64$export$f7bc2c5799e41684);

var $ibA3M = parcelRequire("ibA3M");

var $ieDtd = parcelRequire("ieDtd");
const $018a8accd0bb9a64$export$f7bc2c5799e41684 = ()=>{
    const { setSelectedConfigTab: setSelectedConfigTab } = (0, $ibA3M.useSelectedConfigTab)();
    const [, setConfigParam] = (0, $ieDtd.useQueryParam)('config');
    setSelectedConfigTab('filter');
    setConfigParam('filter');
    return null;
};

});
parcelRegister("ibA3M", function(module, exports) {

$parcel$export(module.exports, "useSelectedConfigTab", () => $a2554898b8aa72da$export$9b386f1a3e61b385);

var $bSSG7 = parcelRequire("bSSG7");

var $4R6GH = parcelRequire("4R6GH");
const $a2554898b8aa72da$export$9b386f1a3e61b385 = ()=>{
    const storageProvider = (0, $bSSG7.createLocalStorageProvider)('', false);
    const SELECTED_CONFIG_TAB_KEY = 'selectedConfigTab';
    const getSelectedConfigTab = ()=>{
        if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) return storageProvider.get(SELECTED_CONFIG_TAB_KEY) || '';
        return localStorage.getItem(SELECTED_CONFIG_TAB_KEY) || '';
    };
    const setSelectedConfigTab = (newConfigTab)=>{
        if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) storageProvider.set(SELECTED_CONFIG_TAB_KEY, `"${newConfigTab}"`);
        else localStorage.setItem(SELECTED_CONFIG_TAB_KEY, `"${newConfigTab}"`);
    };
    return {
        getSelectedConfigTab: getSelectedConfigTab,
        setSelectedConfigTab: setSelectedConfigTab
    };
};

});



parcelRegister("akFeA", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardSettingsInsightsRapidboardBoardRouteEntry", () => $f91dfbe36c62931f$export$d4cb7b5fe9faae5e);

var $g87MG = parcelRequire("g87MG");

var $ffza4 = parcelRequire("ffza4");


var $e2ctp = parcelRequire("e2ctp");

var $gyYxw = parcelRequire("gyYxw");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $lfnsv = parcelRequire("lfnsv");

var $f5kpo = parcelRequire("f5kpo");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $9Hi5X = parcelRequire("9Hi5X");

var $16Z5s = parcelRequire("16Z5s");

var $hWAe2 = parcelRequire("hWAe2");

var $5f2bR = parcelRequire("5f2bR");

var $ltiRJ = parcelRequire("ltiRJ");
const $f91dfbe36c62931f$export$d4cb7b5fe9faae5e = (0, $7NszV.createEntry)((0, $9Hi5X.classicSoftwareBoardSettingsInsightsRapidboardBoardRoute), ()=>({
        group: 'classic-software',
        ufoName: 'rapidboard-board-insights',
        component: (0, $ltiRJ.InsightsSettingsRedirect),
        skeleton: (0, $hWAe2.ClassicBoardSkeleton),
        layout: (0, $aPfsS.composeLayouts)((0, $gyYxw.genericProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue',
                    'view=detail'
                ]
            },
            {
                query: [
                    'selectedIssue',
                    'modal=detail'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            (0, $g87MG.issueHierarchyPageResource),
            (0, $lfnsv.getBoardDetailsResource)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $16Z5s.LazyRapidBoard),
            (0, $16Z5s.LazyRapidBoardApps),
            (0, $16Z5s.LazyRapidBoardDataApiResource),
            (0, $16Z5s.LazyRapidBoardConfigApiResource),
            (0, $16Z5s.LazyRapidBoardWrmBundleResource),
            (0, $16Z5s.LazyRapidBoardResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$fc5f182fc9019b1c)
        },
        earlyAssets: (0, $e2ctp.AGGRESSIVE_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("9Hi5X", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardSettingsInsightsRapidboardBoardRoute", () => $048f30bef65f82e7$export$8c2f936709b987ac);
const $048f30bef65f82e7$export$8c2f936709b987ac = {
    name: 'rapidboard-board',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId',
    query: [
        'config=insightsConfig'
    ]
};

});


parcelRegister("cjFCA", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardSettingsRouteEntry", () => $8a9bcce270c68b7d$export$4e7891e9bba3f679);

var $c04PQ = parcelRequire("c04PQ");

var $7NszV = parcelRequire("7NszV");

var $hWAe2 = parcelRequire("hWAe2");

var $i8Lv4 = parcelRequire("i8Lv4");

var $gyYxw = parcelRequire("gyYxw");

var $dxCvy = parcelRequire("dxCvy");

var $3RJkv = parcelRequire("3RJkv");

var $f5kpo = parcelRequire("f5kpo");

var $lfnsv = parcelRequire("lfnsv");

var $7GnDe = parcelRequire("7GnDe");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $lJ1FP = parcelRequire("lJ1FP");

var $gNStA = parcelRequire("gNStA");

var $f7Y15 = parcelRequire("f7Y15");

var $ipmBb = parcelRequire("ipmBb");


var $lmyls = parcelRequire("lmyls");

var $4R6GH = parcelRequire("4R6GH");

var $9s3j1 = parcelRequire("9s3j1");

var $e3Qmo = parcelRequire("e3Qmo");
const $8a9bcce270c68b7d$export$4e7891e9bba3f679 = (0, $7NszV.createEntry)((0, $i8Lv4.classicSoftwareBoardSettingsRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-board',
        skeleton: (0, $hWAe2.ClassicBoardSkeleton),
        entryPoint: ()=>(0, $e3Qmo.boardSettingsPageEntryPoint),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.ForPaintClassicSoftwareProjectSidebar),
            sidebarId: (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route') ? (0, $lmyls.SIDEBAR_ID).BOARD_SETTINGS : undefined
        },
        layout: (0, $gyYxw.genericProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            (0, $gNStA.resourceWithCondition2)((0, $f5kpo.shouldLoadUIFBoardResources), (0, $f7Y15.uifBoardResource)),
            // Load the NBT resource if we opt-in UIF, not fedRamp is enabled
            (0, $gNStA.resourceWithCondition2)(()=>(0, $f5kpo.shouldLoadUIFBoardResources)() && !(0, $c04PQ.isFedRamp)(), (0, $ipmBb.nextBestTaskFeatureResource)),
            (0, $lJ1FP.getEditModelResource)(),
            (0, $lfnsv.getBoardDetailsResource)(),
            (0, $5bkvv.forgeBoardModuleResource)
        ],
        meta: {
            // Inline this statement instead of creating a (circular) dependency by importing
            // { classicBoardCapability } from '@atlassian/jira-router-routes-software-classic-board-entries/src/common/constants.tsx';
            capability: !false ? (0, $281cbd47ba46dd7d$export$664edf77d4c76110) : (0, $281cbd47ba46dd7d$export$fc5f182fc9019b1c)
        }
    }));

});
parcelRegister("i8Lv4", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardSettingsRoute", () => $4143597146033f93$export$c055a8844d0d2f5e);
const $4143597146033f93$export$c055a8844d0d2f5e = {
    name: 'rapidboard-board-settings',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/settings/:config',
    query: [
        'from-backlog?'
    ]
};

});

parcelRegister("e3Qmo", function(module, exports) {

$parcel$export(module.exports, "boardSettingsPageEntryPoint", () => $385924313962f5aa$export$e92abb48a4e0c94d);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $eoZWh = parcelRequire("eoZWh");

var $edhw8 = parcelRequire("edhw8");
const $385924313962f5aa$export$e92abb48a4e0c94d = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $edhw8.classicBoardSettingsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $eoZWh.nav4SidebarSettingsBoardEntryPoint)
    }
});

});
parcelRegister("eoZWh", function(module, exports) {

$parcel$export(module.exports, "nav4SidebarSettingsBoardEntryPoint", () => $8560ff5804cb640b$export$f4cb88eb97cbdc30);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $8560ff5804cb640b$export$f4cb88eb97cbdc30 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("frghh")), {
        moduleId: "98fd14bc",
        priority: "userVisible"
    }),
    getPreloadProps () {
        return {};
    }
});

});
parcelRegister("frghh", function(module, exports) {

let $b3d6010dd8748286$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b3d6010dd8748286$var$load("4jRj5").then(()=>parcelRequire('gNcDN'));

});


parcelRegister("edhw8", function(module, exports) {

$parcel$export(module.exports, "classicBoardSettingsEntryPoint", () => $78b5eed4719a6123$export$fd11e3f2f113ef67);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $78b5eed4719a6123$export$fd11e3f2f113ef67 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("dnBeC")).then(({ BoardSettingsSwitcher: BoardSettingsSwitcher })=>BoardSettingsSwitcher), {
        moduleId: "59af2752",
        moduleName: "BoardSettingsSwitcher",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("dnBeC", function(module, exports) {

let $9bda4e697f98f3a5$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9bda4e697f98f3a5$var$load("ffQaD"),
    $9bda4e697f98f3a5$var$load("kvRbA"),
    $9bda4e697f98f3a5$var$load("eXKO6")
]).then(()=>parcelRequire('9tGl0'));

});




parcelRegister("8E1dI", function(module, exports) {

$parcel$export(module.exports, "cmpVelocityRouteEntry", () => $a27db4496b15726e$export$93315233fc25c1b4);

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $e7bC3 = parcelRequire("e7bC3");

var $jicqv = parcelRequire("jicqv");

var $fzG6k = parcelRequire("fzG6k");

var $yxwH0 = parcelRequire("yxwH0");
const $a27db4496b15726e$export$93315233fc25c1b4 = (0, $7NszV.createEntry)((0, $jicqv.cmpVelocityRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.velocity-report-cmp',
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $yxwH0.getTMPReportsCommonResource)()
        ],
        entryPoint: ()=>(0, $fzG6k.velocityReportPageEntrypoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("jicqv", function(module, exports) {

$parcel$export(module.exports, "cmpVelocityRoute", () => $a8cb7576e7ece3aa$export$1dfb0bd517ec7a8b);
const $a8cb7576e7ece3aa$export$1dfb0bd517ec7a8b = {
    name: 'software-reports-velocity-cmp',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/velocity'
};

});

parcelRegister("fzG6k", function(module, exports) {

$parcel$export(module.exports, "velocityReportPageEntrypoint", () => $29d7a4515738ef63$export$571ee01f62e186c8);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $kMjGT = parcelRequire("kMjGT");
const $29d7a4515738ef63$export$571ee01f62e186c8 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $kMjGT.velocityReportEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("kMjGT", function(module, exports) {

$parcel$export(module.exports, "velocityReportEntrypoint", () => $9e6b346357d67309$export$6f6bc731b8a9d27);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $9e6b346357d67309$export$6f6bc731b8a9d27 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("gFDgs")), {
        moduleId: "3ce1c0b2",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("gFDgs", function(module, exports) {

let $c22eeec209d0774a$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c22eeec209d0774a$var$load("ffQaD"),
    $c22eeec209d0774a$var$load("kvRbA"),
    $c22eeec209d0774a$var$load("eJHxk")
]).then(()=>parcelRequire('59dUe'));

});



parcelRegister("yxwH0", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $c75fcd785e66868e$export$8cb713295e6b7204);
$parcel$export(module.exports, "getTMPReportsCommonResource", () => $c75fcd785e66868e$export$f234446c23dc22a);

var $48Ij3 = parcelRequire("48Ij3");

var $gcI3W = parcelRequire("gcI3W");

var $4Bwc0 = parcelRequire("4Bwc0");
const $c75fcd785e66868e$export$8cb713295e6b7204 = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $c75fcd785e66868e$export$f234446c23dc22a = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $48Ij3.staticSidebarJSWReportsResource)
    ];

});
parcelRegister("48Ij3", function(module, exports) {

$parcel$export(module.exports, "staticSidebarJSWReportsResource", () => $d94d5098764be5f8$export$5910307042ab3f6f);

var $8YTna = parcelRequire("8YTna");

var $2M1hQ = parcelRequire("2M1hQ");

var $7xeIG = parcelRequire("7xeIG");
const $d94d5098764be5f8$export$5910307042ab3f6f = (0, $2M1hQ.createResource)({
    type: 'JIRA_SOFTWARE_REPORTS',
    getKey: ({ match: match, query: query })=>{
        const boardId = (0, $8YTna.getBoardId)(match, query);
        return boardId ? `board-${boardId}` : 'none';
    },
    getData: async ({ match: match, query: query })=>{
        const boardId = (0, $8YTna.getBoardId)(match, query);
        if (boardId == null) return null;
        const response = await (0, $7xeIG.fetchJSWReports)(boardId);
        return response?.reports;
    },
    maxAge: 300000
});

});
parcelRegister("7xeIG", function(module, exports) {

$parcel$export(module.exports, "fetchJSWReports", () => $61400f9195fc4c28$export$a93a577d6971da2c);

var $eusud = parcelRequire("eusud");
const $61400f9195fc4c28$export$a93a577d6971da2c = (boardId)=>{
    if (boardId == null) throw new Error('invalid boardId');
    return (0, $eusud.performGetRequest)(`/rest/agile/latest/board/${boardId}/reports`);
};

});


parcelRegister("4Bwc0", function(module, exports) {

$parcel$export(module.exports, "devOpsReportPreconditionResource", () => $5073d432665dfcf8$export$96cb0eae1b3413f4);
$parcel$export(module.exports, "useDevOpsReportPreconditionResource", () => $5073d432665dfcf8$export$e9adc6103e9ed514);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


const $5073d432665dfcf8$export$96cb0eae1b3413f4 = (0, $2M1hQ.createResource)({
    type: (0, $16165c7eb855363c$export$14c5ce449424c281),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("l1hQB")),
    maxAge: 60000
});
const $5073d432665dfcf8$export$e9adc6103e9ed514 = ()=>(0, $2YP9W.useResource)($5073d432665dfcf8$export$96cb0eae1b3413f4);

});
const $16165c7eb855363c$export$14c5ce449424c281 = 'SOFTWARE_CYCLE_TIME_REPORT_PRECONDITION';
const $16165c7eb855363c$export$28dc7a217425f1a9 = 'VIEW_DEV_TOOLS';
const $16165c7eb855363c$export$a03e1c9d464f9477 = 'VIEW_AGGREGATED_DATA';

parcelRegister("l1hQB", function(module, exports) {

let $f4d7891c32d51cd3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f4d7891c32d51cd3$var$load("dT7Bp").then(()=>parcelRequire('5aldt'));

});




parcelRegister("3GuHG", function(module, exports) {

$parcel$export(module.exports, "communicationsStakeholderGroupsRouteEntry", () => $dbb187174829db9f$export$f0dd910016653be3);

var $7NszV = parcelRequire("7NszV");

var $5U3St = parcelRequire("5U3St");

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $3RJkv = parcelRequire("3RJkv");

var $i831U = parcelRequire("i831U");
const $dbb187174829db9f$export$f0dd910016653be3 = (0, $7NszV.createEntry)((0, $5U3St.communicationsStakeholderGroupsRoute), ()=>({
        group: 'communications',
        navigation: {
            menuId: (0, $lmyls.MENU_ID).COMMUNICATIONS,
            sidebar: (0, $h0bZU.default)
        },
        entryPoint: ()=>{
            return (0, $4R6GH.fg)('communications_stakeholder_management_platform') ? (0, $i831U.stakeholderGroupsPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ]
    }));

});
parcelRegister("5U3St", function(module, exports) {

$parcel$export(module.exports, "communicationsStakeholderGroupsRoute", () => $4d0bd8ab67b79e5f$export$87043fcbf23f0119);
const $4d0bd8ab67b79e5f$export$87043fcbf23f0119 = {
    name: 'communications-stakeholder-groups',
    path: '/jira/communications/stakeholder-groups'
};

});

parcelRegister("i831U", function(module, exports) {

$parcel$export(module.exports, "stakeholderGroupsPageEntryPoint", () => $2935279ec52ff1e0$export$838bd3c623ceac0);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $b7Mlo = parcelRequire("b7Mlo");

var $dvt8F = parcelRequire("dvt8F");
const $2935279ec52ff1e0$export$838bd3c623ceac0 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $dvt8F.communicationsStakeholderGroupsEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).COMMUNICATIONS,
    horizontalNavigation: (0, $b7Mlo.communicationsHorizontalNavEntrypoint)
});

});
parcelRegister("b7Mlo", function(module, exports) {

$parcel$export(module.exports, "communicationsHorizontalNavEntrypoint", () => $958a24865685d839$export$6862ea61ceda83f3);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $958a24865685d839$export$6862ea61ceda83f3 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("fMQLh")).then((module)=>module.HorizontalCommunicationsNav), {
        moduleId: "a456392a",
        moduleName: "HorizontalCommunicationsNav",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("fMQLh", function(module, exports) {

let $b7e44411498c3d60$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b7e44411498c3d60$var$load("jGfUS").then(()=>parcelRequire('hGhnx'));

});


parcelRegister("dvt8F", function(module, exports) {

$parcel$export(module.exports, "communicationsStakeholderGroupsEntrypoint", () => $7b64302e0313e9f1$export$df18143715531ee1);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $7b64302e0313e9f1$export$df18143715531ee1 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("9EVc7")).then((module)=>module.StakeholderGroupsPage), {
        moduleId: "90ba51b1",
        moduleName: "StakeholderGroupsPage",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9EVc7", function(module, exports) {

let $70843720d7dec518$var$load = (parcelRequire("28QjX"))(4);
module.exports = $70843720d7dec518$var$load("6GplY").then(()=>parcelRequire('9J6zQ'));

});




parcelRegister("WsHyA", function(module, exports) {

$parcel$export(module.exports, "communicationsStakeholdersRouteEntry", () => $0c26f5691a26ccb6$export$c12bfa7616ac8400);

var $7NszV = parcelRequire("7NszV");

var $b1A6d = parcelRequire("b1A6d");

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $3RJkv = parcelRequire("3RJkv");

var $9Cm8h = parcelRequire("9Cm8h");
const $0c26f5691a26ccb6$export$c12bfa7616ac8400 = (0, $7NszV.createEntry)((0, $b1A6d.communicationsStakeholdersRoute), ()=>({
        group: 'communications',
        navigation: {
            menuId: (0, $lmyls.MENU_ID).COMMUNICATIONS,
            sidebar: (0, $h0bZU.default)
        },
        entryPoint: ()=>{
            return (0, $4R6GH.fg)('communications_stakeholder_management_platform') ? (0, $9Cm8h.stakeholdersPageEntrypoint) : undefined;
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ]
    }));

});
parcelRegister("b1A6d", function(module, exports) {

$parcel$export(module.exports, "communicationsStakeholdersRoute", () => $11c611984f2cf923$export$9933513623f14d7f);
const $11c611984f2cf923$export$9933513623f14d7f = {
    name: 'communications-stakeholders',
    path: '/jira/communications/stakeholders'
};

});

parcelRegister("9Cm8h", function(module, exports) {

$parcel$export(module.exports, "stakeholdersPageEntrypoint", () => $90fde8fc5b5b7285$export$24a5b3c3e5dd381e);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $b7Mlo = parcelRequire("b7Mlo");

var $1FKpj = parcelRequire("1FKpj");
const $90fde8fc5b5b7285$export$24a5b3c3e5dd381e = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1FKpj.communicationsStakeholdersEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).COMMUNICATIONS,
    horizontalNavigation: (0, $b7Mlo.communicationsHorizontalNavEntrypoint)
});

});
parcelRegister("1FKpj", function(module, exports) {

$parcel$export(module.exports, "communicationsStakeholdersEntrypoint", () => $12f1ec05d448ac20$export$2be0008a269b55af);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $aOzLh = parcelRequire("aOzLh");

const $12f1ec05d448ac20$export$2be0008a269b55af = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(0, $aOzLh.clientSideOnly)((parcelRequire("iSYTf")).then((module)=>module.StakeholdersPage)), {
        moduleId: "52ac92a7",
        moduleName: "StakeholdersPage",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("aOzLh", function(module, exports) {

$parcel$export(module.exports, "clientSideOnly", () => $eb01c57105fa1f36$export$7fda87e5e6d5a8d1);
const $eb01c57105fa1f36$export$7fda87e5e6d5a8d1 = (x)=>x;

});

parcelRegister("iSYTf", function(module, exports) {

let $dbfc80a8f86aa076$var$load = (parcelRequire("28QjX"))(4);
module.exports = $dbfc80a8f86aa076$var$load("65tRw").then(()=>parcelRequire('dqLEV'));

});




parcelRegister("6xRe5", function(module, exports) {

$parcel$export(module.exports, "compassProductSettingsRouteEntry", () => $8b91974ef292d61a$export$703b5090da478c9c);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $bTLzO = parcelRequire("bTLzO");

var $3RJkv = parcelRequire("3RJkv");

var $2g9Jq = parcelRequire("2g9Jq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $8b91974ef292d61a$var$LazyCompassProductSettingsPage = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("gQ7zj"))), {
    moduleId: "./src/packages/spa-apps/compass-product-settings/src/index.tsx"
});
const $8b91974ef292d61a$var$CompassProductSettingsComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8b91974ef292d61a$var$LazyCompassProductSettingsPage,
        pageId: "async-compass-product-settings",
        shouldShowSpinner: true
    });
const $8b91974ef292d61a$export$703b5090da478c9c = (0, $7NszV.createEntry)((0, $2g9Jq.compassProductSettingsRoute), ()=>({
        group: 'global-settings',
        component: $8b91974ef292d61a$var$CompassProductSettingsComponent,
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $bTLzO.compassProductSettingsResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $8b91974ef292d61a$var$LazyCompassProductSettingsPage
        ]
    }));

});
parcelRegister("bTLzO", function(module, exports) {

$parcel$export(module.exports, "compassProductSettingsResource", () => $cfea6057f91373db$export$d18ff068d6c25455);
$parcel$export(module.exports, "useCompassProductSettingsResource", () => $cfea6057f91373db$export$6cbcbd11d26ae36f);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

const $cfea6057f91373db$export$d18ff068d6c25455 = (0, $2M1hQ.createResource)({
    type: (0, $0e2163be65099f64$export$6f0555de4f60e84e),
    getKey: ()=>'state',
    getData: async ()=>{
        try {
            const isCompassEnabledForNewProjects = await (0, $eusud.performGetRequest)(`/rest/api/3/application-properties?key=${(0, $0e2163be65099f64$export$5685d70c20140008)}`).then(({ value: value })=>value.toLowerCase().trim() === 'true');
            return {
                isCompassEnabledForNewProjects: isCompassEnabledForNewProjects
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error?.statusCode === 404) return {
                isCompassEnabledForNewProjects: true
            };
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'compassProductSettingsResource',
                    packageName: 'jiraRouterResourcesCompassProductSettings',
                    teamName: 'compass-lodestone'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
});
const $cfea6057f91373db$export$6cbcbd11d26ae36f = ()=>(0, $2YP9W.useResource)($cfea6057f91373db$export$d18ff068d6c25455);

});
const $0e2163be65099f64$export$6f0555de4f60e84e = 'RESOURCE_TYPE_COMPASS_PRODUCT_SETTINGS';
const $0e2163be65099f64$export$5685d70c20140008 = 'jira.admin.compass.is-enabled-for-new-project';


parcelRegister("2g9Jq", function(module, exports) {

$parcel$export(module.exports, "compassProductSettingsRoute", () => $b5f6af89eb99da17$export$48d633ce1d0d2a0e);
const $b5f6af89eb99da17$export$48d633ce1d0d2a0e = {
    name: 'compass-product-settings',
    path: '/jira/settings/products/compass',
    exact: true
};

});

parcelRegister("gQ7zj", function(module, exports) {

let $c4275fa1fd7d56b9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c4275fa1fd7d56b9$var$load("4kBZR").then(()=>parcelRequire('lIMc4'));

});


parcelRegister("5eLaE", function(module, exports) {

$parcel$export(module.exports, "connectGeneralInvalidRouteEntry", () => $eea4a938c8d518ff$export$d8088cb4e7cc7efd);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $evs4R = parcelRequire("evs4R");

var $cYYI7 = parcelRequire("cYYI7");

var $3wwwB = parcelRequire("3wwwB");
const $eea4a938c8d518ff$export$d8088cb4e7cc7efd = (0, $7NszV.createEntry)((0, $evs4R.connectGeneralInvalidRoute), ()=>({
        group: 'connect',
        layout: (0, $aPfsS.createLayout)(),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).ADDONS,
            sidebar: (0, $hBv66.genericConnectSidebars)
        },
        component: (0, $3wwwB.default),
        resources: (0, $cYYI7.getGeneralConnectRouteResources)(),
        canTransitionIn: (current, next)=>{
            const { query: query } = next.match;
            // must be in sync with com.atlassian.jira.web.filters.frontend.ConnectGeneralPagesFrontendRoute::matchesRequest
            // block transitions to mobile version
            if (query.mobile === 'true' || query.includeWebResources === 'true' || query.classifier === 'json') return false;
            // block transitions to marketplace app as it requires specialised Connect API -
            const emceeKeyRegex = /com\.atlassian\.(jira|confluence)\.emcee($|\.local|\.staging|\.development\..*)/g;
            const addonKey = next.match.params.addonKey || '';
            if (emceeKeyRegex.test(addonKey)) return false;
            return true;
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3wwwB.LazyGeneralConnect)
        ],
        ufoName: 'jira-connect'
    }));

});
parcelRegister("evs4R", function(module, exports) {

$parcel$export(module.exports, "connectGeneralInvalidRoute", () => $178b17cd972d15af$export$486ffffd0a2797a5);

var $3Ra5L = parcelRequire("3Ra5L");
const $178b17cd972d15af$export$486ffffd0a2797a5 = {
    name: 'connect-general-invalid',
    path: '/plugins/servlet/ac/:addonKey//:moduleKey',
    query: (0, $3Ra5L.CONNECT_GENERAL_QUERY_PARAMS)
};

});
parcelRegister("3Ra5L", function(module, exports) {

$parcel$export(module.exports, "CONNECT_GENERAL_QUERY_PARAMS", () => $0bf6b9f3f002a423$export$2fdb05fdbf78d595);
// must be in sync with com.atlassian.jira.web.filters.frontend.ConnectGeneralPagesFrontendRoute::matchesRequest
const $0bf6b9f3f002a423$export$2fdb05fdbf78d595 = [
    'mobile?!=true',
    'includeWebResources?!=true',
    'classifier?!=json',
    'project.key?',
    'project.id?'
];

});


parcelRegister("cYYI7", function(module, exports) {

$parcel$export(module.exports, "getGeneralConnectRouteResources", () => $7a1fe7edd9b898b4$export$2c86c2f79b80cf77);
$parcel$export(module.exports, "getProjectConnectRouteDefaultResources", () => $7a1fe7edd9b898b4$export$4c06110e7d14ab3c);

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $lNicp = parcelRequire("lNicp");

var $hz6Yb = parcelRequire("hz6Yb");

var $9UABi = parcelRequire("9UABi");

var $bHhiy = parcelRequire("bHhiy");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");
const $7a1fe7edd9b898b4$export$2c86c2f79b80cf77 = ()=>[
        ...(0, $lNicp.getBusinessProjectResources)(),
        ...(0, $3RJkv.getNavigationResources)(),
        (0, $atU1t.navigationSidebarGlobalResource),
        ...(0, $5bkvv.getNavigationSidebarGlobalSettingsResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $7GnDe.incidentExperimentTraitResource),
        (0, $dxCvy.projectContextResource),
        (0, $5bkvv.forgeProjectModuleResource),
        (0, $iEUaw.staticSidebarShortcutsResource),
        (0, $ggg5j.staticProjectSidebarNavigationResource),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
        (0, $hz6Yb.connectGeneralResources),
        (0, $bHhiy.getConsolidationStateResource)()
    ];
const $7a1fe7edd9b898b4$export$4c06110e7d14ab3c = ()=>[
        ...(0, $lNicp.getBusinessProjectResources)(),
        ...(0, $3RJkv.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $7GnDe.incidentExperimentTraitResource),
        (0, $dxCvy.projectContextResource),
        (0, $5bkvv.forgeProjectModuleResource),
        (0, $iEUaw.staticSidebarShortcutsResource),
        (0, $ggg5j.staticProjectSidebarNavigationResource),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
        (0, $9UABi.connectProjectResources)
    ];

});
parcelRegister("hz6Yb", function(module, exports) {

$parcel$export(module.exports, "connectGeneralResources", () => $07e636c36bc19b52$export$f34ab0d904621847);
$parcel$export(module.exports, "useConnectGeneralResource", () => $07e636c36bc19b52$export$53479840ec6d4024);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


const $07e636c36bc19b52$export$f34ab0d904621847 = (0, $2M1hQ.createResource)({
    type: (0, $1130bd470474fe6f$export$d5eed449bb62d4c1),
    getKey: ({ match: { params: { addonKey: addonKey, moduleKey: moduleKey } } })=>{
        // spa-router/src/common/types.js:
        /** TODO we are supporting `undefined` here because we are currently using both
		 * this version of the `Match` type, and react-routers version (which allows for `undefined`)
		 * To fix this we should move `matchPath` to our own util so we can apply our own types, then
		 * decide if we want to support undefined types.
		 */ if (addonKey !== null && addonKey !== undefined && moduleKey !== null && moduleKey !== undefined) return `${addonKey}-${moduleKey}`;
        return 'state';
    },
    getDataLoader: ()=>(parcelRequire("c027M"))
});
const $07e636c36bc19b52$export$53479840ec6d4024 = ()=>(0, $2YP9W.useResource)($07e636c36bc19b52$export$f34ab0d904621847);

});
const $1130bd470474fe6f$export$d5eed449bb62d4c1 = 'CONNECT_GENERAL';

parcelRegister("c027M", function(module, exports) {

let $8bc721ff60773c51$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8bc721ff60773c51$var$load("amd3a").then(()=>parcelRequire('6LiLg'));

});


parcelRegister("9UABi", function(module, exports) {

$parcel$export(module.exports, "connectProjectResources", () => $fce046ce7cfaa8c3$export$7d2d082a4b91a6c7);
// eslint-disable-next-line jira/import-whitelist

var $8Vh1q = parcelRequire("8Vh1q");

var $ggg5j = parcelRequire("ggg5j");

var $2M1hQ = parcelRequire("2M1hQ");


const $fce046ce7cfaa8c3$export$7d2d082a4b91a6c7 = (0, $2M1hQ.createResource)({
    type: (0, $35b0c7feb103121f$export$da32d27651782c3),
    getKey: ({ query: query })=>{
        const { addonKey: addonKey, moduleKey: moduleKey } = (0, $8Vh1q.transformUrlToAddonAndModuleKeys)(query);
        if (addonKey !== '' && moduleKey !== '') return `${addonKey}-${moduleKey}`;
        return 'state';
    },
    depends: [
        (0, $ggg5j.staticProjectSidebarNavigationResource).type
    ],
    getDataLoader: ()=>(parcelRequire("6ahyC"))
});

});
parcelRegister("8Vh1q", function(module, exports) {

$parcel$export(module.exports, "transformResponse", () => $beff5be7f4728df2$export$3361e9be8093ddcc);
$parcel$export(module.exports, "extractContext", () => $beff5be7f4728df2$export$efdbd45f3e77a161);
$parcel$export(module.exports, "transformQueryParams", () => $beff5be7f4728df2$export$9e3c3f47fc3ab3d0);
$parcel$export(module.exports, "transformUrlToAddonAndModuleKeys", () => $beff5be7f4728df2$export$752ef5ab3d7ab15f);

var $2YZCu = parcelRequire("2YZCu");

var $6VnTH = parcelRequire("6VnTH");

var $3HwlS = parcelRequire("3HwlS");

var $bsuuc = parcelRequire("bsuuc");
const $beff5be7f4728df2$export$3361e9be8093ddcc = (response)=>{
    try {
        const productContext = response.productCtx ? JSON.parse(response.productCtx) : {};
        let structuredContext = response.structuredContext ? JSON.parse(response.structuredContext) : {};
        structuredContext = {
            ...structuredContext,
            jira: {
                ...structuredContext.jira,
                horizontalNavigation: (0, $3HwlS.getWillShowNav4)()
            }
        };
        const context = {
            productContext: productContext,
            structuredContext: structuredContext,
            productCtx: productContext
        };
        return {
            ...response,
            ...context,
            isFullPage: response.general === '1',
            user: {
                timeZone: response.timeZone,
                uid: response.uid || undefined,
                ukey: response.ukey || undefined,
                fullName: response.fullName || undefined
            },
            targets: {
                env: {
                    resize: 'both'
                }
            },
            history: {
                state: ''
            },
            autoresize: true,
            ns: response.uniqueKey,
            containerId: `embedded-${response.uniqueKey}`,
            contextPath: response.cp,
            width: response.w || response.width,
            height: response.h || response.height
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const location = 'connect-iframe.transformer';
        (0, $2YZCu.default).safeErrorWithoutCustomerData(location, 'Failed to transform response', error);
        return {
            autoresize: true,
            productCtx: undefined,
            structuredContext: undefined,
            isFullPage: true,
            history: {
                state: ''
            },
            targets: {
                env: {
                    resize: 'both'
                }
            }
        };
    }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $beff5be7f4728df2$var$checkValueAndMapToNewName = (object, oldName, newName)=>{
    const newValue = object !== null && object[oldName] ? String(object[oldName]) : null;
    return newValue !== null ? {
        [newName]: newValue
    } : null;
};
const $beff5be7f4728df2$export$1f8eea5a5a32169f = (contextData)=>{
    const scope = contextData && contextData.scope || null;
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    const project = contextData && contextData.project || null;
    const projectId = $beff5be7f4728df2$var$checkValueAndMapToNewName(project, 'id', 'project.id');
    const projectKey = $beff5be7f4728df2$var$checkValueAndMapToNewName(project, 'key', 'project.key');
    const boardType = $beff5be7f4728df2$var$checkValueAndMapToNewName(scope, 'type', 'board.type');
    const boardId = $beff5be7f4728df2$var$checkValueAndMapToNewName(scope, 'id', 'board.id');
    return {
        ...projectId,
        ...projectKey,
        ...boardType,
        ...boardId
    };
};
const $beff5be7f4728df2$export$efdbd45f3e77a161 = (projectSidebarNavInfo)=>{
    const project = projectSidebarNavInfo && (0, $bsuuc.extractData)(projectSidebarNavInfo) || null;
    const board = projectSidebarNavInfo?.jiraSoftwareNavData && (0, $6VnTH.extractData)(projectSidebarNavInfo.jiraSoftwareNavData) || null;
    const projectId = $beff5be7f4728df2$var$checkValueAndMapToNewName(project, 'id', 'project.id');
    const projectKey = $beff5be7f4728df2$var$checkValueAndMapToNewName(project, 'key', 'project.key');
    const boardType = $beff5be7f4728df2$var$checkValueAndMapToNewName(board, 'type', 'board.type');
    const boardId = $beff5be7f4728df2$var$checkValueAndMapToNewName(board, 'id', 'board.id');
    return {
        ...projectId,
        ...projectKey,
        ...boardType,
        ...boardId
    };
};
const $beff5be7f4728df2$export$9e3c3f47fc3ab3d0 = (contextData, query)=>{
    const context = $beff5be7f4728df2$export$1f8eea5a5a32169f(contextData);
    return {
        ...query,
        ...context
    };
};
const $beff5be7f4728df2$export$752ef5ab3d7ab15f = (query)=>{
    const { selectedItem: selectedItem } = query;
    let addonKey = '';
    let moduleKey = '';
    if (selectedItem) {
        const urlPattern = selectedItem.includes('%3A') ? 'com.atlassian.plugins.atlassian-connect-plugin%3A' : 'com.atlassian.plugins.atlassian-connect-plugin:';
        [addonKey, moduleKey] = selectedItem.replace(urlPattern, '').split('__');
    }
    return {
        addonKey: addonKey,
        moduleKey: moduleKey
    };
};

});
parcelRegister("6VnTH", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $4d73b10ca351bbb3$export$9df5fa0a366163d2);
$parcel$export(module.exports, "extractUserBoard", () => $4d73b10ca351bbb3$export$67db9e2d1b6ed865);
const $4d73b10ca351bbb3$export$9df5fa0a366163d2 = (jiraSoftwareNavData)=>{
    if (jiraSoftwareNavData.boardInfo == null) return null;
    const { boardInfo: { id: id, type: type = 'scrum', name: name } } = jiraSoftwareNavData;
    return {
        id: id,
        type: type,
        name: name,
        isProjectBoard: true
    };
};
const $4d73b10ca351bbb3$export$67db9e2d1b6ed865 = (userBoardNavData)=>{
    const { boardInfo: { id: id, type: type = 'scrum', name: name } } = userBoardNavData;
    return {
        id: id,
        type: type,
        name: name,
        isProjectBoard: false
    };
};

});


const $35b0c7feb103121f$export$da32d27651782c3 = 'CONNECT_PROJECT';

parcelRegister("6ahyC", function(module, exports) {

let $47d14bc51cf614ea$var$load = (parcelRequire("28QjX"))(4);
module.exports = $47d14bc51cf614ea$var$load("gnfQV").then(()=>parcelRequire('4ECv0'));

});



parcelRegister("3wwwB", function(module, exports) {

$parcel$export(module.exports, "LazyGeneralConnect", () => $49a774cbbfe614f4$export$c33275abe6c1e577);
$parcel$export(module.exports, "default", () => $49a774cbbfe614f4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $49a774cbbfe614f4$export$c33275abe6c1e577 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("kMM32"))), {
    moduleId: "./src/packages/spa-apps/jira-connect/general-pages/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$49a774cbbfe614f4$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $49a774cbbfe614f4$export$c33275abe6c1e577,
        pageId: "connect",
        shouldShowSpinner: true
    });

});
parcelRegister("kMM32", function(module, exports) {

let $f21d8fa781f8f20b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f21d8fa781f8f20b$var$load("hHprL").then(()=>parcelRequire('crFp4'));

});



parcelRegister("gnGkU", function(module, exports) {

$parcel$export(module.exports, "connectGeneralRouteEntry", () => $a1bee888763609f4$export$46273ee39bcd958b);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $luBXp = parcelRequire("luBXp");

var $cYYI7 = parcelRequire("cYYI7");

var $3wwwB = parcelRequire("3wwwB");
const $a1bee888763609f4$export$46273ee39bcd958b = (0, $7NszV.createEntry)((0, $luBXp.connectGeneralRoute), ()=>({
        group: 'connect',
        layout: (0, $aPfsS.createLayout)(),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).ADDONS,
            sidebar: (0, $hBv66.genericConnectSidebars)
        },
        component: (0, $3wwwB.default),
        resources: (0, $cYYI7.getGeneralConnectRouteResources)(),
        canTransitionIn: (current, next)=>{
            const { query: query } = next.match;
            // must be in sync with com.atlassian.jira.web.filters.frontend.ConnectGeneralPagesFrontendRoute::matchesRequest
            // block transitions to mobile version
            if (query.mobile === 'true' || query.includeWebResources === 'true' || query.classifier === 'json') return false;
            // block transitions to marketplace app as it requires specialised Connect API -
            const emceeKeyRegex = /com\.atlassian\.(jira|confluence)\.emcee($|\.local|\.staging|\.development\..*)/g;
            const addonKey = next.match.params.addonKey || '';
            if (emceeKeyRegex.test(addonKey)) return false;
            return true;
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3wwwB.LazyGeneralConnect)
        ],
        ufoName: 'jira-connect'
    }));

});
parcelRegister("luBXp", function(module, exports) {

$parcel$export(module.exports, "connectGeneralRoute", () => $1153a77cb71c1b79$export$1fda4850b6314ff0);

var $3Ra5L = parcelRequire("3Ra5L");
const $1153a77cb71c1b79$export$1fda4850b6314ff0 = {
    name: 'connect-general',
    path: '/plugins/servlet/ac/:addonKey/:moduleKey',
    query: (0, $3Ra5L.CONNECT_GENERAL_QUERY_PARAMS)
};

});


parcelRegister("c74Xp", function(module, exports) {

$parcel$export(module.exports, "connectGeneralServiceDeskProjectRouteEntry", () => $70d164d9674a0900$export$487a360459ad1bea);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $fpjJX = parcelRequire("fpjJX");

var $k7Q6G = parcelRequire("k7Q6G");

var $cYYI7 = parcelRequire("cYYI7");

var $3wwwB = parcelRequire("3wwwB");
const $70d164d9674a0900$export$487a360459ad1bea = (0, $7NszV.createEntry)((0, $k7Q6G.connectGeneralServiceDeskProjectRoute), ()=>({
        group: 'connect',
        layout: (0, $aPfsS.createLayout)(),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).ADDONS,
            sidebar: (0, $hBv66.genericConnectSidebars)
        },
        component: (0, $3wwwB.default),
        resources: [
            ...(0, $cYYI7.getGeneralConnectRouteResources)(),
            ...(0, $fpjJX.getServiceDeskNavigationSingleResources)()
        ],
        canTransitionIn: (current, next)=>{
            const { query: query } = next.match;
            // must be in sync with com.atlassian.jira.web.filters.frontend.ConnectGeneralPagesFrontendRoute::matchesRequest
            // block transitions to mobile version
            if (query.mobile === 'true' || query.includeWebResources === 'true' || query.classifier === 'json') return false;
            // block transitions to marketplace app as it requires specialised Connect API -
            const emceeKeyRegex = /com\.atlassian\.(jira|confluence)\.emcee($|\.local|\.staging|\.development\..*)/g;
            const addonKey = next.match.params.addonKey || '';
            if (emceeKeyRegex.test(addonKey)) return false;
            return true;
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3wwwB.LazyGeneralConnect)
        ],
        ufoName: 'jira-connect'
    }));

});
parcelRegister("k7Q6G", function(module, exports) {

$parcel$export(module.exports, "connectGeneralServiceDeskProjectRoute", () => $d699769fc97b2ccd$export$e8a58aee75961b55);
const $d699769fc97b2ccd$export$e8a58aee75961b55 = {
    name: 'connect-general-service-desk-project',
    path: '/plugins/servlet/ac/:addonKey/:moduleKey',
    query: [
        'mobile?!=true',
        'includeWebResources?!=true',
        'classifier?!=json',
        'project.key?',
        'project.id?',
        'project.key',
        'servicedesk.serviceDeskId'
    ]
};

});


parcelRegister("4Zw1h", function(module, exports) {

$parcel$export(module.exports, "connectProjectRouteEntry", () => $88ce8816647240e1$export$96bdc57a01f2ee48);

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $dx5ZK = parcelRequire("dx5ZK");

var $cYYI7 = parcelRequire("cYYI7");

var $iTDbG = parcelRequire("iTDbG");
const $88ce8816647240e1$export$96bdc57a01f2ee48 = (0, $7NszV.createEntry)((0, $dx5ZK.connectProjectRoute), ()=>({
        group: 'connect',
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        layout: (0, $gyYxw.genericProjectLayout),
        ufoName: 'jira-connect',
        // Match resources that are fetched for legacyConnectProjectRouteEntry
        // See src/packages/router-routes/legacy/connect-project/entries/src/index.tsx
        resources: [
            ...(0, $cYYI7.getProjectConnectRouteDefaultResources)(),
            ...(0, $fpjJX.getServiceDeskSharedNavigationSingleResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>(0, $iTDbG.connectProjectsPageEntrypoint)
    }));

});
parcelRegister("dx5ZK", function(module, exports) {

$parcel$export(module.exports, "connectProjectRoute", () => $e3a0435584f46760$export$27e7531864dfb704);

var $kUeZd = parcelRequire("kUeZd");
const $e3a0435584f46760$export$27e7531864dfb704 = {
    name: 'connect-project',
    path: '/projects/:projectKey',
    query: (0, $kUeZd.CONNECT_PROJECT_QUERY_PARAMS)
};

});
parcelRegister("kUeZd", function(module, exports) {

$parcel$export(module.exports, "CONNECT_PROJECT_QUERY_PARAMS", () => $e64562bb8c3fa371$export$9bb839aee83bf4d8);
const $e64562bb8c3fa371$export$9bb839aee83bf4d8 = [
    'selectedItem=(^com.atlassian.plugins.atlassian-connect-plugin.*)'
];

});


parcelRegister("iTDbG", function(module, exports) {

$parcel$export(module.exports, "connectProjectsPageEntrypoint", () => $c9a4402f23043c3c$export$d7105af2aa9527d0);
$parcel$export(module.exports, "connectProjectsWithoutHorizontalNavPageEntrypoint", () => $c9a4402f23043c3c$export$8df81c5e9c00a7b4);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $8vOSr = parcelRequire("8vOSr");

var $fo6b8 = parcelRequire("fo6b8");
const $c9a4402f23043c3c$export$d7105af2aa9527d0 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $8vOSr.connectProjectsEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $c9a4402f23043c3c$export$8df81c5e9c00a7b4 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $8vOSr.connectProjectsEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("8vOSr", function(module, exports) {

$parcel$export(module.exports, "connectProjectsEntrypoint", () => $b7bf9b62cbd74d5f$export$4ff832a017f5175c);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $b7bf9b62cbd74d5f$export$4ff832a017f5175c = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("TL3kb")), {
        moduleId: "2203c501",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context })=>({
            extraProps: {
                query: context.query
            }
        })
});

});
parcelRegister("TL3kb", function(module, exports) {

let $0a79a2d6e1ac8fa6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0a79a2d6e1ac8fa6$var$load("kmeN2").then(()=>parcelRequire('2GYK9'));

});




parcelRegister("dqjth", function(module, exports) {

$parcel$export(module.exports, "createProjectRouteEntry", () => $7e202110676952db$export$28887e2da22c839a);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $gyYxw = parcelRequire("gyYxw");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $R0AuF = parcelRequire("R0AuF");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $7e202110676952db$var$LazyCreateProject = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("f75gk")), {
    moduleId: "./src/packages/spa-apps/create-project/src/index.tsx"
});
const $7e202110676952db$var$CreateProject = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $7e202110676952db$var$LazyCreateProject,
        pageId: "spa-apps/create-project",
        shouldShowSpinner: true
    });
const $7e202110676952db$export$28887e2da22c839a = (0, $7NszV.createEntry)((0, $R0AuF.createProjectRoute), ()=>({
        group: 'components',
        component: $7e202110676952db$var$CreateProject,
        layout: (0, $gyYxw.genericProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $7e202110676952db$var$LazyCreateProject
        ]
    }));

});
parcelRegister("R0AuF", function(module, exports) {

$parcel$export(module.exports, "createProjectRoute", () => $e9869d33b741028e$export$5ce9108542315ac8);
const $e9869d33b741028e$export$5ce9108542315ac8 = {
    name: 'create-project',
    path: '/jira/create-project',
    exact: true
};

});

parcelRegister("f75gk", function(module, exports) {

let $b00b976f963e900e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b00b976f963e900e$var$load("5Vt5L").then(()=>parcelRequire('6cT2s'));

});


parcelRegister("aw22a", function(module, exports) {

$parcel$export(module.exports, "customerServiceEscalationsRouteEntry", () => $e27fdc04f14a6641$export$36a7c374f4474cc1);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $e4B7v = parcelRequire("e4B7v");

var $7fRd9 = parcelRequire("7fRd9");

var $ffa20 = parcelRequire("ffa20");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $e27fdc04f14a6641$var$LazyServicedeskCustomerServiceEscalations = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("l7FMY"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/customer-service-escalations/src/index.tsx"
});
const $e27fdc04f14a6641$var$ServicedeskCustomerServiceEscalations = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e27fdc04f14a6641$var$LazyServicedeskCustomerServiceEscalations,
        pageId: "spa-apps/servicedesk/customer-service-escalations",
        shouldShowSpinner: true
    });
const $e27fdc04f14a6641$export$36a7c374f4474cc1 = (0, $7NszV.createEntry)((0, $ffa20.customerServiceEscalationsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $e4B7v.componentFilterResource),
            (0, $7fRd9.priorityFilterResource)
        ],
        component: $e27fdc04f14a6641$var$ServicedeskCustomerServiceEscalations,
        perfMetricKey: 'jsm-customer-service-escalations-component-load',
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $e27fdc04f14a6641$var$LazyServicedeskCustomerServiceEscalations
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).CUSTOMER_SERVICE_ESCALATIONS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).CUSTOMER_SERVICE_ESCALATIONS),
                teamName: 'boysenberry'
            }
        }
    }));

});
parcelRegister("e4B7v", function(module, exports) {

$parcel$export(module.exports, "componentFilterResource", () => $ff0131666c555211$export$306e389909032632);
$parcel$export(module.exports, "useComponentFilterResource", () => $ff0131666c555211$export$e13868d6ab2288af);

var $dK8AG = parcelRequire("dK8AG");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

const $ff0131666c555211$var$getDataLoader = ()=>(parcelRequire("jW76F"));
const $ff0131666c555211$export$306e389909032632 = (0, $2M1hQ.createResource)({
    type: 'ESCALATIONS_COMPONENT_FILTER_RESOURCE',
    getKey: ({ match: match })=>(0, $dK8AG.getProjectKeyOrId)(match),
    getDataLoader: $ff0131666c555211$var$getDataLoader
});
const $ff0131666c555211$export$e13868d6ab2288af = ()=>(0, $2YP9W.useResource)($ff0131666c555211$export$306e389909032632);

});
parcelRegister("jW76F", function(module, exports) {

let $e838f24c0ec53c56$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e838f24c0ec53c56$var$load("hAfcl").then(()=>parcelRequire('hXg9m'));

});


parcelRegister("7fRd9", function(module, exports) {

$parcel$export(module.exports, "priorityFilterResource", () => $1ec7e880e057744a$export$ca03c5f9fc44703e);
$parcel$export(module.exports, "usePriorityFilterResource", () => $1ec7e880e057744a$export$3654f46b6bb12558);

var $4R6GH = parcelRequire("4R6GH");

var $dK8AG = parcelRequire("dK8AG");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

const $1ec7e880e057744a$var$getDataLoader = ()=>(parcelRequire("1ekaZ"));
const $1ec7e880e057744a$export$ca03c5f9fc44703e = (0, $2M1hQ.createResource)({
    type: 'ESCALATIONS_PRIORITY_FILTER_RESOURCE',
    getKey: ({ match: match })=>(0, $dK8AG.getProjectKeyOrId)(match),
    getDataLoader: $1ec7e880e057744a$var$getDataLoader
});
const $1ec7e880e057744a$export$3654f46b6bb12558 = ()=>(0, $2YP9W.useResource)((0, $4R6GH.fg)('jcs_master_flag') ? $1ec7e880e057744a$export$ca03c5f9fc44703e : (0, $2M1hQ.createResource)({
        type: 'ESCALATIONS_PRIORITY_FILTER_RESOURCE',
        getKey: ({ match: match })=>(0, $dK8AG.getProjectKeyOrId)(match),
        getDataLoader: $1ec7e880e057744a$var$getDataLoader
    }));

});
parcelRegister("1ekaZ", function(module, exports) {

let $0e56bfd88db62396$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0e56bfd88db62396$var$load("hybUM").then(()=>parcelRequire('ejgJG'));

});


parcelRegister("ffa20", function(module, exports) {

$parcel$export(module.exports, "customerServiceEscalationsRoute", () => $ee1b6a45151c9b49$export$51e84b36f828d9ff);
const $ee1b6a45151c9b49$export$51e84b36f828d9ff = {
    name: 'servicedesk-customer-service-escalations',
    path: '/jira/servicedesk/projects/:projectKey/escalations',
    exact: true
};

});

parcelRegister("l7FMY", function(module, exports) {

let $f60aaad1a3d9bd33$var$load = (parcelRequire("28QjX"))(4);

module.exports = Promise.all([
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $f60aaad1a3d9bd33$var$load("czifk")
        ]);
    }, function() {
        return Promise.all([
            $f60aaad1a3d9bd33$var$load("kcs34")
        ]);
    }),
    $f60aaad1a3d9bd33$var$load("ffQaD"),
    $f60aaad1a3d9bd33$var$load("kvRbA"),
    $f60aaad1a3d9bd33$var$load("76n7a"),
    $f60aaad1a3d9bd33$var$load("l253H"),
    $f60aaad1a3d9bd33$var$load("aDLsT")
]).then(()=>parcelRequire('81cgT'));

});


parcelRegister("yVbxa", function(module, exports) {

$parcel$export(module.exports, "customerServiceProductsRouteEntry", () => $d306aa8b938adbc6$export$8e015e39dbc90d0b);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $cEOhb = parcelRequire("cEOhb");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $7yABM = parcelRequire("7yABM");

var $fqFCk = parcelRequire("fqFCk");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $d306aa8b938adbc6$var$LazyServicedeskCustomerServiceProducts = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("52OW4"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/customer-service-products/src/index.tsx"
});
const $d306aa8b938adbc6$var$ServicedeskCustomerServiceProducts = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d306aa8b938adbc6$var$LazyServicedeskCustomerServiceProducts,
        pageId: "spa-apps/servicedesk/customer-service-products",
        shouldShowSpinner: true
    });
const $d306aa8b938adbc6$export$8e015e39dbc90d0b = (0, $7NszV.createEntry)((0, $fqFCk.customerServiceProductsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $cEOhb.AsyncDirectoryNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $7yABM.customerServiceProductsQueryResource)
        ],
        component: $d306aa8b938adbc6$var$ServicedeskCustomerServiceProducts,
        perfMetricKey: 'jsm-customer-service-products-component-load',
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $d306aa8b938adbc6$var$LazyServicedeskCustomerServiceProducts
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).CUSTOMER_SERVICE_PRODUCTS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).CUSTOMER_SERVICE_PRODUCTS),
                teamName: 'boysenberry'
            }
        }
    }));

});
parcelRegister("cEOhb", function(module, exports) {

$parcel$export(module.exports, "AsyncDirectoryNav", () => $c28aa1a42d481780$export$a237f415539577a5);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");


const $c28aa1a42d481780$var$LazyDirectoryNav = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("9imGM")).then(({ DirectoryHorizontalNav: DirectoryHorizontalNav })=>DirectoryHorizontalNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/directory/src/ui/index.tsx"
});
const $c28aa1a42d481780$export$a237f415539577a5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "horizontal-jsm-directory-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c28aa1a42d481780$var$LazyDirectoryNav, null));

});
parcelRegister("9imGM", function(module, exports) {

let $6c476509377e6757$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6c476509377e6757$var$load("cctvZ").then(()=>parcelRequire('emSF0'));

});


parcelRegister("7yABM", function(module, exports) {

$parcel$export(module.exports, "PRODUCTS_PAGE_SIZE", () => $cbdcceb1886ba86d$export$9e59a0b3e9d74a99);
$parcel$export(module.exports, "customerServiceProductsQueryResource", () => $cbdcceb1886ba86d$export$f9257217f5333b1a);

var $ao2h1 = parcelRequire("ao2h1");

var $aPLvO = parcelRequire("aPLvO");
const $cbdcceb1886ba86d$export$9e59a0b3e9d74a99 = 50;
const $cbdcceb1886ba86d$export$f9257217f5333b1a = (0, $ao2h1.createRelayResource)({
    type: 'CUSTOMER_SERVICE_PRODUCTS_QUERY',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $aPLvO.default),
            variables: {
                cloudId: tenantContext.cloudId,
                first: $cbdcceb1886ba86d$export$9e59a0b3e9d74a99
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("aPLvO", function(module, exports) {

$parcel$export(module.exports, "default", () => $06c174000e8c134e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4df781c51f5dfbc32b76735c59bb33af>>
 * @relayHash 081a2dfa9c4407c84bf8d024899e92b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bb8d4ae9602322e43ac61cf45c886f9ecad88afb1aaa237fd8615ea59abb7c16
const $06c174000e8c134e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v3 = [
        v2 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "srcCustomerServiceProductsQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "productsPage_servicedeskCustomerServiceProducts"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "srcCustomerServiceProductsQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ 
                    ],
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "CustomerServiceProductConnection",
                            "kind": "LinkedField",
                            "name": "productConnections",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CustomerServiceProductEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "CustomerServiceProduct",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "entitlementsCount"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__id"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v3 /*: any*/ ,
                            "handle": "connection",
                            "key": "customerServiceProducts_productConnections",
                            "kind": "LinkedHandle",
                            "name": "productConnections"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "bb8d4ae9602322e43ac61cf45c886f9ecad88afb1aaa237fd8615ea59abb7c16",
            "metadata": {},
            "name": "srcCustomerServiceProductsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$06c174000e8c134e$var$node.hash = "3c49696a6cdc337af280ec80f957ea89";
var $06c174000e8c134e$export$2e2bcd8739ae039 = $06c174000e8c134e$var$node;

});


parcelRegister("fqFCk", function(module, exports) {

$parcel$export(module.exports, "customerServiceProductsRoute", () => $ecb0fd0317e4b818$export$73e241aabf4c9c58);
const $ecb0fd0317e4b818$export$73e241aabf4c9c58 = {
    name: 'servicedesk-customer-service-products',
    path: '/jira/servicedesk/projects/:projectKey/products',
    exact: true
};

});

parcelRegister("52OW4", function(module, exports) {

let $3ac4a66e6600a746$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $3ac4a66e6600a746$var$load("ffQaD"),
    $3ac4a66e6600a746$var$load("kvRbA"),
    $3ac4a66e6600a746$var$load("76n7a"),
    $3ac4a66e6600a746$var$load("l253H"),
    $3ac4a66e6600a746$var$load("884YO")
]).then(()=>parcelRequire('fSKfx'));

});


parcelRegister("lYzgn", function(module, exports) {

$parcel$export(module.exports, "customIssueRouteEntry", () => $75b822e8abf02245$export$3813414450b75758);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $ayogX = parcelRequire("ayogX");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $aPfsS = parcelRequire("aPfsS");

var $jlOGG = parcelRequire("jlOGG");

var $bHhiy = parcelRequire("bHhiy");

var $lBKJK = parcelRequire("lBKJK");

var $4R6GH = parcelRequire("4R6GH");

var $fpjJX = parcelRequire("fpjJX");

var $aNLeB = parcelRequire("aNLeB");

var $6Z2mh = parcelRequire("6Z2mh");

var $lAGdd = parcelRequire("lAGdd");

var $faj7G = parcelRequire("faj7G");

var $gLKd7 = parcelRequire("gLKd7");
const $75b822e8abf02245$export$3813414450b75758 = (0, $7NszV.createEntry)((0, $ayogX.customIssueRoute), ()=>({
        layout: (0, $aPfsS.composeLayouts)((0, $6Z2mh.serviceProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                params: [
                    {
                        key: 'issueKey'
                    }
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            // Keep this consistent with the one in customQueueRouteEntry.tsx, so it won't rerender the queue agent view component
            // when navigating between queues and issues.
            // Rereder could cause problem:
            // 1. Issue view will lose issue navigator component
            // 2. When navigating back to queue, the queue will lose the scroll position.
            horizontal: (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $lBKJK.AsyncHorizontalNavQueue) : undefined
        },
        skeleton: (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $gLKd7.QueueLoadingSkeleton) : undefined,
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            ...(0, $fpjJX.getInsightResources)(),
            ...(0, $fpjJX.getIssueListSsrResource)(),
            (0, $jlOGG.newIssueViewLockInStatusResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $aNLeB.servicedeskIsItsmProjectResource),
            ...(0, $lAGdd.getAIContextPanelResources)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        group: 'servicedesk',
        // It is important to keep this component consistent across the two routes so
        // that React doesn't unmount it when switching between the routes and the
        // full state is kept so that scroll position and loaded data is kept when
        // going back from issue details to the queues page.
        component: (0, $faj7G.CustomQueueRouteComponent),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $faj7G.LazyServicedeskQueuesAgentAndIssueView)
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("ayogX", function(module, exports) {

$parcel$export(module.exports, "customIssueRoute", () => $2e7fd15e22956eb6$export$2c4bc3091ab58cd0);
const $2e7fd15e22956eb6$export$2c4bc3091ab58cd0 = {
    name: 'servicedesk-queues-custom-issue-detail',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/:issueKey',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});

parcelRegister("jlOGG", function(module, exports) {

$parcel$export(module.exports, "newIssueViewLockInStatusResource", () => $951713022fad9069$export$647de7516d081bd8);
$parcel$export(module.exports, "useNewIssueViewLockInStatus", () => $951713022fad9069$export$d8ba398930f2f5f);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $1odlY = parcelRequire("1odlY");

const $951713022fad9069$export$647de7516d081bd8 = (0, $2M1hQ.createResource)({
    type: (0, $1odlY.RESOURCE_TYPE_PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS),
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: ()=>(parcelRequire("aHjmk")),
    maxAge: Number.MAX_VALUE
});
const $951713022fad9069$export$d8ba398930f2f5f = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)($951713022fad9069$export$647de7516d081bd8);
    return {
        loading: loading,
        error: error,
        newIssueViewLockedIn: data && data.newIssueViewLockedIn
    };
};

});
parcelRegister("aHjmk", function(module, exports) {

let $7c9cefe0eb7d20fc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7c9cefe0eb7d20fc$var$load("bzwfz").then(()=>parcelRequire('7JV09'));

});


parcelRegister("lBKJK", function(module, exports) {

$parcel$export(module.exports, "AsyncHorizontalNavQueue", () => $08dafd9591b0689d$export$5f20c7610c638983);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $3HwlS = parcelRequire("3HwlS");

var $5NiYd = parcelRequire("5NiYd");

var $urQ6o = parcelRequire("urQ6o");

var $ayogX = parcelRequire("ayogX");

var $6jY6G = parcelRequire("6jY6G");

var $bmKPg = parcelRequire("bmKPg");

const $08dafd9591b0689d$var$LazyHorizontalNavQueue = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("6D49R")).then((HorizontalNavQueue)=>HorizontalNavQueue), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/queue/src/ui/HorizontalNavQueue.tsx"
});
const $08dafd9591b0689d$export$5f20c7610c638983 = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const [issueKey] = (0, $bmKPg.usePathParam)('issueKey');
    const isIssueView = route.name === (0, $ayogX.customIssueRoute).name || route.name === (0, $urQ6o.customPracticeQueueRoute).name && issueKey;
    const content = !isIssueView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "horizontal-nav-queue",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5NiYd.HorizontalNavSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08dafd9591b0689d$var$LazyHorizontalNavQueue, null));
    return (0, $3HwlS.getWillShowNav4)() ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $08dafd9591b0689d$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $08dafd9591b0689d$var$styles
    }, content));
};
const $08dafd9591b0689d$var$containerStyles = (0, $8CUq3.xcss)({
    position: 'relative'
});
const $08dafd9591b0689d$var$styles = (0, $8CUq3.xcss)({
    position: 'absolute',
    width: '100%'
});

});
parcelRegister("urQ6o", function(module, exports) {

$parcel$export(module.exports, "customPracticeQueueRoute", () => $41bd265d7c0f4884$export$59d0bd42aa07faad);
const $41bd265d7c0f4884$export$59d0bd42aa07faad = {
    name: 'servicedesk-practice-custom-and-issue',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/:issueKey?',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});

parcelRegister("6D49R", function(module, exports) {

let $4d399c466a75b2e7$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $4d399c466a75b2e7$var$load("ffQaD"),
    $4d399c466a75b2e7$var$load("kvRbA"),
    $4d399c466a75b2e7$var$load("7ODMs")
]).then(()=>parcelRequire('jjRnc'));

});


parcelRegister("faj7G", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesAgentAndIssueView", () => $a3b6d4fb9a4ea620$export$6f01bfb6fc18a06e);
$parcel$export(module.exports, "CustomQueueRouteComponent", () => $a3b6d4fb9a4ea620$export$59d555419fbaa611);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $4R6GH = parcelRequire("4R6GH");

var $7yO8g = parcelRequire("7yO8g");

const $a3b6d4fb9a4ea620$export$6f01bfb6fc18a06e = (0, $kxZPA.lazyForPaint)(()=>{
    return (0, $7yO8g.markAsProductBundleReady)((parcelRequire("8iiDO")));
}, {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-agent-and-issue-view/src/index.tsx"
});

const $a3b6d4fb9a4ea620$export$e34f6e9743063ca6 = (0, $kxZPA.lazyForPaint)(()=>{
    return (0, $7yO8g.markAsProductBundleReady)((parcelRequire("8iiDO")));
}, {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk/queues-agent-and-issue-view/src/index.tsx"
});
const $a3b6d4fb9a4ea620$export$59d555419fbaa611 = ({ match: match })=>{
    const queueId = match.params && match.params.queueId || '';
    const issueKey = match.params && match.params.issueKey || '';
    const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $4R6GH.fg)('disable_ssr_for_view_custom_queues') ? $a3b6d4fb9a4ea620$export$e34f6e9743063ca6 : $a3b6d4fb9a4ea620$export$6f01bfb6fc18a06e,
        pageId: `spa-apps/servicedesk/queues/${queueId}/${issueKey}/${oldIssueView}`,
        shouldShowSpinner: !(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag')
    });
};

});
parcelRegister("8iiDO", function(module, exports) {

let $609e76e7e92b91d1$var$load = (parcelRequire("28QjX"))(4);

module.exports = Promise.all([
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $609e76e7e92b91d1$var$load("czifk")
        ]);
    }, function() {
        return Promise.all([
            $609e76e7e92b91d1$var$load("kcs34")
        ]);
    }),
    $609e76e7e92b91d1$var$load("kNFvF"),
    $609e76e7e92b91d1$var$load("kVX56"),
    $609e76e7e92b91d1$var$load("76n7a"),
    $609e76e7e92b91d1$var$load("l253H"),
    $609e76e7e92b91d1$var$load("ffQaD"),
    $609e76e7e92b91d1$var$load("kvRbA"),
    $609e76e7e92b91d1$var$load("1tAfd")
]).then(()=>parcelRequire('6o1Xn'));

});


parcelRegister("gLKd7", function(module, exports) {

$parcel$export(module.exports, "QueueLoadingSkeleton", () => $1e5417896a058f9f$export$d20068523efc567f);

var $5uXOq = parcelRequire("5uXOq");

var $hoJVU = parcelRequire("hoJVU");

var $kb4zh = parcelRequire("kb4zh");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");
const $1e5417896a058f9f$export$d20068523efc567f = ()=>{
    return (0, $3HwlS.getWillShowNav4)() && !(0, $4R6GH.fg)('jsm_fix_queue_issue_view_navigate_back_state') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hoJVU.QueueNav3StylingPatchContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null));
};

});
parcelRegister("hoJVU", function(module, exports) {

$parcel$export(module.exports, "useStylingPatch", () => $a9c2b57f46f9d18e$export$ed35078f707ec860);
$parcel$export(module.exports, "QueueNav3StylingPatchContainer", () => $a9c2b57f46f9d18e$export$9cbbe53228ab978f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $3HwlS = parcelRequire("3HwlS");

var $4R6GH = parcelRequire("4R6GH");

var $6jY6G = parcelRequire("6jY6G");

var $bmKPg = parcelRequire("bmKPg");

var $7M8Tn = parcelRequire("7M8Tn");

var $urQ6o = parcelRequire("urQ6o");

var $1D031 = parcelRequire("1D031");

var $24BFc = parcelRequire("24BFc");

var $g0YQu = parcelRequire("g0YQu");

var $lVOJN = parcelRequire("lVOJN");

var $ayogX = parcelRequire("ayogX");
const $a9c2b57f46f9d18e$var$SEGMENT_KEY = 'queues-agent-view-top-layout-nav3';
const $a9c2b57f46f9d18e$export$ed35078f707ec860 = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const [issueKey] = (0, $bmKPg.usePathParam)('issueKey');
    if (!(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag')) return {
        shouldUseStylingPatch: false,
        isNav3QueueIssueViewRoute: false
    };
    const isNav3QueueRouteOld = !(0, $3HwlS.getWillShowNav4)() && (route.name === (0, $7M8Tn.customQueueRoute).name || route.name === (0, $urQ6o.customPracticeQueueRoute).name && !issueKey);
    const isNav3QueueRouteNew = !(0, $3HwlS.getWillShowNav4)() && (route.name === (0, $7M8Tn.customQueueRoute).name || route.name === (0, $urQ6o.customPracticeQueueRoute).name || // Only the Nav3 Queue content and Nav3 Category Queue content are wrapped with QueueNav3StylingPatchContainer.
    // The routes where we should doing this wrapping are queue route, category queue route and issue view route
    // The reason why we are also need to wrap the Queue content on issue view route is because we want to avoid re-rendering.
    // ----------------------------------------------------------------------------------------------------------
    // Inside the QueueNav3StylingPatchContainer (below), we will avoid putting the height on issue view route (because of this scroll problem).
    // This will not trigger the re-rendering because the DOM structure isn’t changed.
    route.name === (0, $ayogX.customIssueRoute).name);
    // customIssueRoute is issue view route for custom queue
    // while customPracticeQueueRoute contains route for both practice queue agent view and practice queue issue view, we need to check issueKey to determine if it's issue view route
    const isNav3QueueIssueViewRoute = !(0, $3HwlS.getWillShowNav4)() && (route.name === (0, $ayogX.customIssueRoute).name || route.name === (0, $urQ6o.customPracticeQueueRoute).name && !!issueKey);
    const isNav3QueueRoute = (0, $4R6GH.fg)('jsm_fix_queue_issue_view_navigate_back_state') ? isNav3QueueRouteNew : isNav3QueueRouteOld;
    const isNav3BoardRoute = !(0, $3HwlS.getWillShowNav4)() && (route.name === (0, $24BFc.customQueueBoardRoute).name || route.name === (0, $1D031.customPracticeQueueBoardRoute).name);
    const isNav3CalendarRoute = !(0, $3HwlS.getWillShowNav4)() && (route.name === (0, $g0YQu.customQueueCalendarRoute).name || route.name === (0, $lVOJN.customPracticeQueueCalendarRoute).name);
    return {
        shouldUseStylingPatch: isNav3QueueRoute || isNav3BoardRoute || isNav3CalendarRoute,
        isNav3QueueIssueViewRoute: isNav3QueueIssueViewRoute
    };
};
const $a9c2b57f46f9d18e$export$9cbbe53228ab978f = ({ children: children })=>{
    const { shouldUseStylingPatch: shouldUseStylingPatch, isNav3QueueIssueViewRoute: isNav3QueueIssueViewRoute } = $a9c2b57f46f9d18e$export$ed35078f707ec860();
    if (shouldUseStylingPatch || !(0, $4R6GH.fg)('jsm_fix_queue_issue_view_navigate_back_state')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-vc": (0, $4R6GH.fg)('further_improve_vc90_performence_of_queues_page') ? `${$a9c2b57f46f9d18e$var$SEGMENT_KEY}${false ? '-ssr' : ''}` : undefined,
        "data-ssr-placeholder": false && (0, $4R6GH.fg)('further_improve_vc90_performence_of_queues_page') ? $a9c2b57f46f9d18e$var$SEGMENT_KEY : undefined,
        "data-ssr-placeholder-replace": false || !(0, $4R6GH.fg)('further_improve_vc90_performence_of_queues_page') ? undefined : $a9c2b57f46f9d18e$var$SEGMENT_KEY,
        "data-testid": "horizontal-nav-queue.controllers.styling-patch.queue-nav-3-styling-patch-container",
        className: (0, $bwpsq.default)([
            !isNav3QueueIssueViewRoute && "_ca0q1h05 _vchhusvi _1e0c1txw _2lx21bp4 _4t3i1osq"
        ])
    }, children);
    return children;
};
const $a9c2b57f46f9d18e$var$nav3PaddingStyles = null;

});
parcelRegister("7M8Tn", function(module, exports) {

$parcel$export(module.exports, "customQueueRoute", () => $c0c93413dba087be$export$e1fac82ca0b0d637);
const $c0c93413dba087be$export$e1fac82ca0b0d637 = {
    name: 'servicedesk-queues-custom-view',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});

parcelRegister("1D031", function(module, exports) {

$parcel$export(module.exports, "customPracticeQueueBoardRoute", () => $63187d5cb553d47e$export$47ae519519dbd803);
const $63187d5cb553d47e$export$47ae519519dbd803 = {
    name: 'servicedesk-queues-practice-custom-board',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/board/:boardId',
    exact: true
};

});

parcelRegister("24BFc", function(module, exports) {

$parcel$export(module.exports, "customQueueBoardRoute", () => $3c41cbb682d42029$export$5407961894c40126);
const $3c41cbb682d42029$export$5407961894c40126 = {
    name: 'servicedesk-queues-custom-board',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/board/:boardId',
    exact: true
};

});

parcelRegister("g0YQu", function(module, exports) {

$parcel$export(module.exports, "customQueueCalendarRoute", () => $d63e361e6becb774$export$82a97d9fba2cfa9a);
const $d63e361e6becb774$export$82a97d9fba2cfa9a = {
    name: 'servicedesk-queues-custom-calendar',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/calendar/:boardId',
    exact: true
};

});

parcelRegister("lVOJN", function(module, exports) {

$parcel$export(module.exports, "customPracticeQueueCalendarRoute", () => $6fd1b54b722592ef$export$5a0e47b0abcf7c2f);
const $6fd1b54b722592ef$export$5a0e47b0abcf7c2f = {
    name: 'servicedesk-queues-practice-custom-calendar',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/calendar/:boardId',
    exact: true
};

});




parcelRegister("dAmDY", function(module, exports) {

$parcel$export(module.exports, "customPracticeQueueBoardRouteEntry", () => $0081c4c1a88ea88d$export$7b0b0691f8b766cf);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $5lsNZ = parcelRequire("5lsNZ");

var $1D031 = parcelRequire("1D031");

var $fpjJX = parcelRequire("fpjJX");

var $6Z2mh = parcelRequire("6Z2mh");

var $4R6GH = parcelRequire("4R6GH");

var $bHhiy = parcelRequire("bHhiy");

var $f5kpo = parcelRequire("f5kpo");

var $f7Y15 = parcelRequire("f7Y15");

var $gNStA = parcelRequire("gNStA");

var $iTSIT = parcelRequire("iTSIT");

var $3HwlS = parcelRequire("3HwlS");

var $lBKJK = parcelRequire("lBKJK");

var $dkQIn = parcelRequire("dkQIn");
const $0081c4c1a88ea88d$export$7b0b0691f8b766cf = (0, $7NszV.createEntry)((0, $1D031.customPracticeQueueBoardRoute), ()=>({
        group: 'servicedesk',
        component: (0, $5lsNZ.default),
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag')) return (0, $3HwlS.getWillShowNav4)() ? (0, $dkQIn.boardPageEntryPoint) : (0, $dkQIn.boardPageNav3EntryPoint);
            return undefined;
        },
        layout: (0, $6Z2mh.serviceProjectLayout),
        skeleton: (0, $dkQIn.BoardSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: // eslint-disable-next-line jira/ff/no-preconditioning
            (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') && !(0, $3HwlS.getWillShowNav4)() ? (0, $lBKJK.AsyncHorizontalNavQueue) : undefined
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>!false, (0, $f7Y15.uifBoardResource)),
            (0, $gNStA.resourceWithCondition2)(()=>!(0, $3HwlS.getWillShowNav4)(), (0, $iTSIT.horizontalNavQueueResource))
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("iTSIT", function(module, exports) {

$parcel$export(module.exports, "horizontalNavQueueResource", () => $0eded50aa7688d41$export$896712202052ca56);

var $ao2h1 = parcelRequire("ao2h1");

var $4Wr19 = parcelRequire("4Wr19");

var $9AmTW = parcelRequire("9AmTW");

var $1nb22 = parcelRequire("1nb22");

var $ktofH = parcelRequire("ktofH");

var $6YG83 = parcelRequire("6YG83");
const $0eded50aa7688d41$export$71eec30d9db46a56 = ({ match: match, query: query }, { tenantContext: { activationId: activationId, cloudId: cloudId } })=>{
    const queueId = match.params.queueId;
    let { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    projectKey = projectKey ?? '';
    projectId = projectId ?? '';
    const projectIdOrKey = projectId || projectKey;
    const queueAri = queueId ? (0, $9AmTW.JiraServicedeskQueueAri).create({
        siteId: cloudId,
        queueId: queueId || '',
        activationId: activationId
    }).toString() : '';
    const containerNavigationInput = queueAri ? {
        scopeId: queueAri
    } : {
        projectKeyQuery: {
            cloudId: cloudId,
            projectKey: projectKey
        }
    };
    return {
        options: {
            fetchPolicy: 'store-and-network'
        },
        parameters: $4Wr19.default,
        variables: {
            cloudId: cloudId,
            projectIdOrKey: projectIdOrKey,
            containerNavigationInput: containerNavigationInput,
            first: (0, $ktofH.NAVIGATION_ITEMS_PAGE_SIZE)
        }
    };
};
const $0eded50aa7688d41$export$896712202052ca56 = (0, $6YG83.withGiraAggAnonSsrFix)((0, $ao2h1.createRelayResource)({
    type: 'HORIZONTAL_NAVIGATION_QUEUE_QUERY',
    getQuery: $0eded50aa7688d41$export$71eec30d9db46a56
}));

});
parcelRegister("4Wr19", function(module, exports) {

$parcel$export(module.exports, "default", () => $e49ea8e372e3d9cf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6c8059f14a3201b31e0652bd91e511bc>>
 * @relayHash ad9b22c18ca56c0cec6bb77e087f1a60
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5a6395a2023b01b4b8728b98901f39635c74a467c84cd540ba5af518baccad2
const $e49ea8e372e3d9cf$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "b5a6395a2023b01b4b8728b98901f39635c74a467c84cd540ba5af518baccad2",
        "metadata": {},
        "name": "HorizontalNavQueueInnerQuery",
        "operationKind": "query",
        "text": null
    }
};
var $e49ea8e372e3d9cf$export$2e2bcd8739ae039 = $e49ea8e372e3d9cf$var$node;

});


parcelRegister("dkQIn", function(module, exports) {

$parcel$export(module.exports, "boardPageNav3EntryPoint", () => $d0693ec64fdd7e2b$export$ae25ae5278cbd6a1);
$parcel$export(module.exports, "boardPageEntryPoint", () => $d0693ec64fdd7e2b$export$552f44bed039f041);
$parcel$export(module.exports, "BoardSkeleton", () => $d0693ec64fdd7e2b$export$325f821722dfa572);

var $5uXOq = parcelRequire("5uXOq");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $4R6GH = parcelRequire("4R6GH");

var $4E7Hx = parcelRequire("4E7Hx");

var $2iSWJ = parcelRequire("2iSWJ");

var $hWAe2 = parcelRequire("hWAe2");

var $hoJVU = parcelRequire("hoJVU");

var $3HwlS = parcelRequire("3HwlS");
const $d0693ec64fdd7e2b$export$ae25ae5278cbd6a1 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $2iSWJ.boardEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $d0693ec64fdd7e2b$export$552f44bed039f041 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $2iSWJ.boardEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $4E7Hx.horizontalNavQueueEntrypoint)
});
const $d0693ec64fdd7e2b$export$325f821722dfa572 = ()=>(0, $3HwlS.getWillShowNav4)() && !(0, $4R6GH.fg)('jsm_fix_queue_issue_view_navigate_back_state') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hWAe2.ClassicBoardSkeleton), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hoJVU.QueueNav3StylingPatchContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hWAe2.ClassicBoardSkeleton), null));

});
parcelRegister("4E7Hx", function(module, exports) {

$parcel$export(module.exports, "horizontalNavQueueEntrypoint", () => $67dd0a42e98143fe$export$df9ea493099a3cc4);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $4Wr19 = parcelRequire("4Wr19");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $9AmTW = parcelRequire("9AmTW");

var $1nb22 = parcelRequire("1nb22");

var $ktofH = parcelRequire("ktofH");

const $67dd0a42e98143fe$export$df9ea493099a3cc4 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("7p7ap")), {
        moduleId: "664171c5",
        moduleName: "HorizontalNavQueueInner",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: { match: match, query: query }, tenantContext: { activationId: activationId, cloudId: cloudId } })=>{
        const queueId = match.params.queueId;
        let { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        projectKey = projectKey ?? '';
        projectId = projectId ?? '';
        const projectIdOrKey = projectId || projectKey;
        const queueAri = queueId ? (0, $9AmTW.JiraServicedeskQueueAri).create({
            siteId: cloudId,
            queueId: queueId || '',
            activationId: activationId
        }).toString() : '';
        const containerNavigationInput = queueAri ? {
            scopeId: queueAri
        } : {
            projectKeyQuery: {
                cloudId: cloudId,
                projectKey: projectKey
            }
        };
        return {
            queries: {
                horizontalNavQueueQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $4Wr19.default,
                    variables: {
                        cloudId: cloudId,
                        projectIdOrKey: projectIdOrKey,
                        containerNavigationInput: containerNavigationInput,
                        first: (0, $ktofH.NAVIGATION_ITEMS_PAGE_SIZE)
                    }
                }
            }
        };
    }
});

});
parcelRegister("7p7ap", function(module, exports) {

let $56406d63abcfcbf8$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $56406d63abcfcbf8$var$load("ffQaD"),
    $56406d63abcfcbf8$var$load("kvRbA"),
    $56406d63abcfcbf8$var$load("8lm5x")
]).then(()=>parcelRequire('ftqx5'));

});


parcelRegister("2iSWJ", function(module, exports) {

$parcel$export(module.exports, "boardEntryPoint", () => $d117236cb308f3eb$export$937ca5a4cdc1a12e);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $d117236cb308f3eb$export$937ca5a4cdc1a12e = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("8Kntq")), {
        moduleId: "286ebff8",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8Kntq", function(module, exports) {

let $65e4d3faf0204b68$var$load = (parcelRequire("28QjX"))(4);





module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $65e4d3faf0204b68$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $65e4d3faf0204b68$var$load("k6g9p")
        ]);
    }),
    (parcelRequire("avM1e"))('jirt-convert-class-to-functional-component', function() {
        return Promise.all([
            $65e4d3faf0204b68$var$load("1ls92")
        ]);
    }, function() {
        return Promise.all([
            $65e4d3faf0204b68$var$load("kLeYK")
        ]);
    }),
    $65e4d3faf0204b68$var$load("kNFvF"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("4lPfp"), 4)),
    $65e4d3faf0204b68$var$load("ffQaD"),
    $65e4d3faf0204b68$var$load("kvRbA"),
    $65e4d3faf0204b68$var$load("76n7a"),
    $65e4d3faf0204b68$var$load("l253H"),
    $65e4d3faf0204b68$var$load("dH1Ru")
]).then(()=>parcelRequire('fnC5S'));

});




parcelRegister("3MI0Z", function(module, exports) {

$parcel$export(module.exports, "customPracticeQueueCalendarRouteEntry", () => $ece609b32152a098$export$8e8d88d3af02e6f7);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $5lsNZ = parcelRequire("5lsNZ");

var $lVOJN = parcelRequire("lVOJN");

var $fpjJX = parcelRequire("fpjJX");

var $6Z2mh = parcelRequire("6Z2mh");

var $bHhiy = parcelRequire("bHhiy");

var $f7Y15 = parcelRequire("f7Y15");

var $jYeNO = parcelRequire("jYeNO");

var $iTSIT = parcelRequire("iTSIT");

var $4R6GH = parcelRequire("4R6GH");

var $gNStA = parcelRequire("gNStA");

var $3HwlS = parcelRequire("3HwlS");

var $lBKJK = parcelRequire("lBKJK");

var $dPV2J = parcelRequire("dPV2J");
const $ece609b32152a098$export$8e8d88d3af02e6f7 = (0, $7NszV.createEntry)((0, $lVOJN.customPracticeQueueCalendarRoute), ()=>({
        group: 'servicedesk',
        component: (0, $5lsNZ.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: // eslint-disable-next-line jira/ff/no-preconditioning
            (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') && !(0, $3HwlS.getWillShowNav4)() ? (0, $lBKJK.AsyncHorizontalNavQueue) : undefined
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ],
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag')) return (0, $3HwlS.getWillShowNav4)() ? (0, $dPV2J.calendarPageEntryPoint) : (0, $dPV2J.calendarPageNav3EntryPoint);
            return undefined;
        },
        skeleton: (0, $dPV2J.CalendarSkeleton),
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $jYeNO.getCalendarFilterFieldsResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>!(0, $3HwlS.getWillShowNav4)(), (0, $iTSIT.horizontalNavQueueResource)),
            (0, $gNStA.resourceWithCondition2)(()=>!false, (0, $f7Y15.uifBoardResource))
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("dPV2J", function(module, exports) {

$parcel$export(module.exports, "calendarPageNav3EntryPoint", () => $348976a96cbb6eb5$export$4dc8c8e2c977ed01);
$parcel$export(module.exports, "calendarPageEntryPoint", () => $348976a96cbb6eb5$export$eda0c2fb67f7d7e7);
$parcel$export(module.exports, "CalendarSkeleton", () => $348976a96cbb6eb5$export$ebc7c47cc535837e);

var $5uXOq = parcelRequire("5uXOq");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $4R6GH = parcelRequire("4R6GH");

var $faaUu = parcelRequire("faaUu");

var $4E7Hx = parcelRequire("4E7Hx");

var $hoJVU = parcelRequire("hoJVU");

var $6Y2I3 = parcelRequire("6Y2I3");

var $3HwlS = parcelRequire("3HwlS");
const $348976a96cbb6eb5$export$4dc8c8e2c977ed01 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $faaUu.calendarEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $348976a96cbb6eb5$export$eda0c2fb67f7d7e7 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $faaUu.calendarEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $4E7Hx.horizontalNavQueueEntrypoint)
});
const $348976a96cbb6eb5$export$ebc7c47cc535837e = ()=>(0, $3HwlS.getWillShowNav4)() && !(0, $4R6GH.fg)('jsm_fix_queue_issue_view_navigate_back_state') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Y2I3.ClassicCalendarSkeleton), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hoJVU.QueueNav3StylingPatchContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Y2I3.ClassicCalendarSkeleton), null));

});
parcelRegister("faaUu", function(module, exports) {

$parcel$export(module.exports, "calendarEntryPoint", () => $d491739a1b7483c1$export$19cf4b398f638dc6);

var $4R6GH = parcelRequire("4R6GH");

var $7JhZX = parcelRequire("7JhZX");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");
// This is the key used to store the calendar filters in the local storage
const $d491739a1b7483c1$var$ISSUE_SEARCH_INPUT_STORAGE_KEY = 'calendar-issue-search-input';
// This is the key used to store the calendar view settings in the local storage
const $d491739a1b7483c1$var$VIEW_SETTINGS_STORAGE_KEY = 'calendar-view-settings';
/**
 * Default Day Starts At Time in Calendar View Settings
 */ const $d491739a1b7483c1$var$DEFAULT_DAY_STARTS_AT = '09:00 AM';
function $d491739a1b7483c1$var$toBoardAri({ siteId: siteId, boardId: boardId }) {
    return `ari:cloud:jira-software:${siteId}:board/${boardId}`;
}
function $d491739a1b7483c1$var$toMidnightUTCString(date) {
    const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    return new Date(utcMilliseconds).toISOString();
}
function $d491739a1b7483c1$var$toDate(date) {
    if (!date) return new Date();
    try {
        const _date = new Date(date);
        return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
    } catch (e) {
        return new Date();
    }
}
function $d491739a1b7483c1$var$createScope({ context: context, tenantContext: tenantContext }, viewId) {
    const { cloudId: cloudId } = tenantContext;
    return {
        type: 'board',
        boardId: $d491739a1b7483c1$var$toBoardAri({
            siteId: cloudId,
            boardId: String(context.match.params.boardId)
        }),
        projectKeys: (0, $4R6GH.fg)('fix_jsm_calendar_scope_issue') ? [] : [
            String(context.match.params.projectKey)
        ],
        viewId: viewId
    };
}
function $d491739a1b7483c1$var$buildScopeInput({ tenantContext: tenantContext }, scope) {
    const { cloudId: cloudId } = tenantContext;
    return {
        ids: [
            scope.boardId
        ],
        projectKeys: {
            cloudId: cloudId,
            keys: scope.projectKeys
        }
    };
}
function $d491739a1b7483c1$var$toViewMode(mode) {
    switch(mode){
        case 'week':
            return 'WEEK';
        case 'day':
            return 'DAY';
        default:
            return 'MONTH';
    }
}
function $d491739a1b7483c1$var$toWeekStart(weekStart) {
    switch(weekStart){
        case 'monday':
            return 'MONDAY';
        case 'saturday':
            return 'SATURDAY';
        default:
            return 'SUNDAY';
    }
}
function $d491739a1b7483c1$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField, viewId: viewId }) {
    return {
        date: $d491739a1b7483c1$var$toMidnightUTCString(selectedDate),
        mode: $d491739a1b7483c1$var$toViewMode(viewRange),
        weekStart: $d491739a1b7483c1$var$toWeekStart(weekStartsOn),
        ...(0, $4R6GH.fg)('jira_calendar_load_more_pagination') ? {
            startDateField: startDateField,
            endDateField: endDateField
        } : {},
        viewId: viewId
    };
}
function $d491739a1b7483c1$var$buildStorageKey({ cloudId: cloudId, activationId: activationId, boardId: boardId, featureKey: featureKey }) {
    const viewId = $d491739a1b7483c1$var$buildViewId({
        cloudId: cloudId,
        activationId: activationId,
        boardId: boardId
    });
    const LOCALSTORAGE_KEY_PREFIX = 'persist:calendar';
    return `${LOCALSTORAGE_KEY_PREFIX}/view/${viewId}/${featureKey}`;
}
function $d491739a1b7483c1$var$getStorageValue(storageKey) {
    // window check is needed because this code is also executed on the SSR
    if (typeof window !== 'undefined') return localStorage?.getItem(storageKey) || '';
    return '';
}
function $d491739a1b7483c1$var$buildIssuesSearchInput(storageKey) {
    return {
        additionalFilterQuery: $d491739a1b7483c1$var$getStorageValue(storageKey) || ''
    };
}
function $d491739a1b7483c1$var$buildUnscheduledIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}
function $d491739a1b7483c1$var$buildVersionsSearchInput() {
    return {
        versionStatuses: [
            'RELEASED',
            'UNRELEASED'
        ]
    };
}
function $d491739a1b7483c1$var$buildSprintsSearchInput() {
    return {
        sprintStates: [
            'ACTIVE',
            'FUTURE',
            'CLOSED'
        ]
    };
}
function $d491739a1b7483c1$var$buildViewId({ cloudId: cloudId, activationId: activationId, boardId: boardId }) {
    // https://developer.atlassian.com/platform/atlassian-resource-identifier/resource-owners/registry/#ati%3Acloud%3Ajira%3Aview
    return `ari:cloud:jira:${cloudId}:view/activation/${activationId}/board/${boardId}`;
}

const $d491739a1b7483c1$export$19cf4b398f638dc6 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("7Tm3Z")), {
        moduleId: "7a55ad65",
        priority: "userVisible"
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
        const { cloudId: cloudId, activationId: activationId } = tenantContext;
        const { date: date } = context.query;
        const selectedDate = $d491739a1b7483c1$var$toDate(date);
        const { boardId: boardId, projectKey: projectKey } = context.match.params;
        if (!boardId || !projectKey) throw new Error('boardId and projectKey must be provided.');
        const viewId = $d491739a1b7483c1$var$buildViewId({
            cloudId: cloudId,
            activationId: activationId,
            boardId: boardId
        });
        const scope = $d491739a1b7483c1$var$createScope(entryPointRouteParams, viewId || '');
        const storageKeyForIssueSearchInput = $d491739a1b7483c1$var$buildStorageKey({
            cloudId: cloudId,
            activationId: activationId,
            boardId: boardId,
            featureKey: $d491739a1b7483c1$var$ISSUE_SEARCH_INPUT_STORAGE_KEY
        });
        const storageKeyForViewSettings = $d491739a1b7483c1$var$buildStorageKey({
            cloudId: cloudId,
            activationId: activationId,
            boardId: boardId,
            featureKey: $d491739a1b7483c1$var$VIEW_SETTINGS_STORAGE_KEY
        });
        const defaultViewRange = 'month';
        const storedConfig = $d491739a1b7483c1$var$getStorageValue(storageKeyForViewSettings);
        const viewSettingsConfig = storedConfig ? JSON.parse(storedConfig) : {
            viewRange: defaultViewRange,
            weekStartsOn: null,
            dayStartsAt: $d491739a1b7483c1$var$DEFAULT_DAY_STARTS_AT,
            showWeekends: false,
            showIssueKey: true,
            showIn24HourClock: false,
            colorBy: 'status'
        };
        const viewRange = (0, $4R6GH.fg)('jsd_shield_jsm_calendar_weekly_view') ? viewSettingsConfig.viewRange ?? 'month' : 'month';
        const weekStartsOn = viewSettingsConfig.weekStartsOn ?? 'sunday';
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const colorBy = viewSettingsConfig.colorBy ?? 'status';
        const startDateField = 'startdate';
        const endDateField = 'duedate';
        const issueEventFields = {
            startDateField: startDateField,
            endDateField: endDateField
        };
        const issuesSearchInput = $d491739a1b7483c1$var$buildIssuesSearchInput(storageKeyForIssueSearchInput);
        return {
            queries: {
                calendarData: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $7JhZX.default,
                    variables: {
                        cloudId: cloudId,
                        scopeInput: $d491739a1b7483c1$var$buildScopeInput(entryPointRouteParams, scope),
                        configurationInput: $d491739a1b7483c1$var$buildConfigurationInput({
                            selectedDate: selectedDate,
                            viewRange: viewRange,
                            weekStartsOn: weekStartsOn,
                            startDateField: startDateField,
                            endDateField: endDateField,
                            viewId: viewId
                        }),
                        issuesPageSize: (0, $4R6GH.fg)('jira_calendar_lazy_load') ? 200 : 50,
                        issuesSearchInput: issuesSearchInput,
                        unscheduledIssuesSearchInput: $d491739a1b7483c1$var$buildUnscheduledIssuesSearchInput(),
                        versionsSearchInput: $d491739a1b7483c1$var$buildVersionsSearchInput(),
                        sprintsSearchInput: $d491739a1b7483c1$var$buildSprintsSearchInput(),
                        skipSprintSearch: false,
                        viewId: viewId,
                        ...(0, $4R6GH.fg)('jsd_shield_jsm_calendar_weekly_view') && {
                            skipFieldConfig: false
                        },
                        schedulePermissionsEnabled: (0, $4R6GH.fg)('calendar_schedule_issue_permissions_check'),
                        pageLoadMoreEnabled: (0, $4R6GH.fg)('jira_calendar_load_more_pagination'),
                        skipVersionsV1Search: (0, $4R6GH.fg)('plan-calendar-versions-v2-adoption'),
                        skipVersionsV2Search: !(0, $4R6GH.fg)('plan-calendar-versions-v2-adoption'),
                        includeRecurrenceIndicator: false,
                        pageLoadMoreEnabledViewSettings: (0, $4R6GH.fg)('jira_calendar_load_more_pagination_view_settings')
                    }
                }
            },
            entryPoints: {},
            extraProps: {
                scope: scope,
                selectedDate: selectedDate,
                viewRange: viewRange,
                weekStartsOn: weekStartsOn,
                dayStartsAt: viewSettingsConfig.dayStartsAt,
                issueEventFields: issueEventFields,
                projectKey: projectKey,
                storageKeyForViewSettings: storageKeyForViewSettings,
                storageKeyForIssueSearchInput: storageKeyForIssueSearchInput,
                showWeekends: viewSettingsConfig.showWeekends,
                showIssueKey: viewSettingsConfig.showIssueKey,
                showIn24HourClock: viewSettingsConfig.showIn24HourClock,
                colorBy: colorBy
            }
        };
    }
});

});
parcelRegister("7Tm3Z", function(module, exports) {

let $5beec8cde0000d46$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $5beec8cde0000d46$var$load("ffQaD"),
    $5beec8cde0000d46$var$load("kvRbA"),
    $5beec8cde0000d46$var$load("76n7a"),
    $5beec8cde0000d46$var$load("l253H"),
    $5beec8cde0000d46$var$load("l4zsJ")
]).then(()=>parcelRequire('2hdB5'));

});


parcelRegister("6Y2I3", function(module, exports) {

$parcel$export(module.exports, "ClassicCalendarSkeleton", () => $69a8eba95a06a473$export$49d3670908a8d8fe);

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $rQ9b9 = parcelRequire("rQ9b9");
const $69a8eba95a06a473$export$49d3670908a8d8fe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($rQ9b9)))
    });

});
parcelRegister("rQ9b9", function(module, exports) {
module.exports = new URL("classic-calendar-skeleton.tpl.3dcfde16.svg", import.meta.url).toString();

});




parcelRegister("iYfXI", function(module, exports) {

$parcel$export(module.exports, "customPracticeQueueRouteEntry", () => $aa74409e2ad842d4$export$b43128c9b5db2a5e);

var $ffza4 = parcelRequire("ffza4");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $jlOGG = parcelRequire("jlOGG");

var $bHhiy = parcelRequire("bHhiy");

var $2pT4g = parcelRequire("2pT4g");

var $fpjJX = parcelRequire("fpjJX");

var $urQ6o = parcelRequire("urQ6o");

var $6Z2mh = parcelRequire("6Z2mh");

var $iTSIT = parcelRequire("iTSIT");

var $lBKJK = parcelRequire("lBKJK");

var $4R6GH = parcelRequire("4R6GH");

var $gNStA = parcelRequire("gNStA");

var $lAGdd = parcelRequire("lAGdd");

var $faj7G = parcelRequire("faj7G");

var $gLKd7 = parcelRequire("gLKd7");
const $aa74409e2ad842d4$export$b43128c9b5db2a5e = (0, $7NszV.createEntry)((0, $urQ6o.customPracticeQueueRoute), ()=>({
        group: 'servicedesk',
        component: (0, $faj7G.CustomQueueRouteComponent),
        layout: (0, $aPfsS.composeLayouts)((0, $6Z2mh.serviceProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                params: [
                    {
                        key: 'issueKey'
                    }
                ]
            }
        ])),
        skeleton: (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $gLKd7.QueueLoadingSkeleton) : undefined,
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $lBKJK.AsyncHorizontalNavQueue) : undefined
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            ...(0, $fpjJX.getKnowledgeBaseResources)(),
            ...(0, $fpjJX.getInsightResources)(),
            ...(0, $fpjJX.getIssueListSsrResource)(),
            (0, $jlOGG.newIssueViewLockInStatusResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $2pT4g.jsmRepackagingBannerResource),
            ...(0, $lAGdd.getAIContextPanelResources)(),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $iTSIT.horizontalNavQueueResource))
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $faj7G.LazyServicedeskQueuesAgentAndIssueView)
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("2pT4g", function(module, exports) {

$parcel$export(module.exports, "jsmRepackagingBannerResource", () => $f325ae4fdb8711ab$export$760ca885f96dacb6);
$parcel$export(module.exports, "useJsmRepackagingBannerResource", () => $f325ae4fdb8711ab$export$f1444ccc5653a5cb);

var $5uXOq = parcelRequire("5uXOq");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $daiqe = parcelRequire("daiqe");

const $f325ae4fdb8711ab$var$getDataLoader = ()=>(parcelRequire("eIMF3"));
const $f325ae4fdb8711ab$export$760ca885f96dacb6 = (0, $2M1hQ.createResource)({
    type: 'JSM_REPACKAGING_BANNER',
    getKey: ()=>'JSM_REPACKAGING_BANNER',
    getDataLoader: $f325ae4fdb8711ab$var$getDataLoader,
    maxAge: false ? 0 : Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});
const $f325ae4fdb8711ab$export$f1444ccc5653a5cb = (workCategory, accountId)=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)($f325ae4fdb8711ab$export$760ca885f96dacb6);
    (0, $5uXOq.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        refresh,
        error
    ]);
    return (0, $5uXOq.useMemo)(()=>{
        if (error || loading || !data || !accountId) return {
            show: false
        };
        const { bannerMeta: bannerMeta, bannerDismissState: bannerDismissState } = data;
        const workCategoryDismissState = bannerDismissState?.[workCategory];
        if (!bannerMeta.show || !(bannerMeta.type === 'info' || bannerMeta.type === 'warning')) return {
            show: false
        };
        if (!workCategoryDismissState) return {
            ...bannerDismissState,
            ...bannerMeta,
            refresh: refresh
        };
        if (workCategoryDismissState.packagingChangeDate !== bannerMeta.data.packagingChangeDate) {
            (0, $daiqe.deleteBannerDismissState)({
                accountId: accountId
            });
            return {
                ...bannerMeta,
                refresh: refresh
            };
        }
        if (workCategoryDismissState.bannerHiddenUntil > Date.now()) return {
            show: false
        };
        return {
            ...bannerMeta,
            ...bannerDismissState,
            refresh: refresh
        };
    }, [
        data,
        loading,
        error,
        workCategory,
        accountId,
        refresh
    ]);
};

});
parcelRegister("daiqe", function(module, exports) {

$parcel$export(module.exports, "deleteBannerDismissState", () => $00907b0f6d0c25ed$export$e21bb99d98e8c8b4);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
async function $00907b0f6d0c25ed$export$e21bb99d98e8c8b4({ accountId: accountId }) {
    try {
        await (0, $eusud.performDeleteRequest)(`/rest/api/3/user/properties/jsm-repackaging-banners-dismiss-state?accountId=${accountId}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // https://data-portal.internal.atlassian.com/analytics/registry/71209
        (0, $jcw0u.default)({
            meta: {
                id: 'deleteBannerDismissState',
                packageName: 'jiraRouterResourcesJsmRepackagingBanner',
                teamName: 'jenga'
            },
            error: error
        });
    }
}

});

parcelRegister("eIMF3", function(module, exports) {

let $ab7aebd15e8ab99b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ab7aebd15e8ab99b$var$load("eX1fm").then(()=>parcelRequire('iKQCz'));

});



parcelRegister("3kqBW", function(module, exports) {

$parcel$export(module.exports, "customQueueBoardRouteEntry", () => $5785385fb89d88cf$export$f94102e9d0a3b113);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $5lsNZ = parcelRequire("5lsNZ");

var $fpjJX = parcelRequire("fpjJX");

var $24BFc = parcelRequire("24BFc");

var $6Z2mh = parcelRequire("6Z2mh");

var $4R6GH = parcelRequire("4R6GH");

var $bHhiy = parcelRequire("bHhiy");

var $f5kpo = parcelRequire("f5kpo");

var $f7Y15 = parcelRequire("f7Y15");

var $gNStA = parcelRequire("gNStA");

var $iTSIT = parcelRequire("iTSIT");

var $3HwlS = parcelRequire("3HwlS");

var $lBKJK = parcelRequire("lBKJK");

var $dkQIn = parcelRequire("dkQIn");
const $5785385fb89d88cf$export$f94102e9d0a3b113 = (0, $7NszV.createEntry)((0, $24BFc.customQueueBoardRoute), ()=>({
        group: 'servicedesk',
        component: (0, $5lsNZ.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag')) return (0, $3HwlS.getWillShowNav4)() ? (0, $dkQIn.boardPageEntryPoint) : (0, $dkQIn.boardPageNav3EntryPoint);
            return undefined;
        },
        skeleton: (0, $dkQIn.BoardSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: // eslint-disable-next-line jira/ff/no-preconditioning
            (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') && !(0, $3HwlS.getWillShowNav4)() ? (0, $lBKJK.AsyncHorizontalNavQueue) : undefined
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ],
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>!false, (0, $f7Y15.uifBoardResource)),
            (0, $gNStA.resourceWithCondition2)(()=>!(0, $3HwlS.getWillShowNav4)(), (0, $iTSIT.horizontalNavQueueResource))
        ],
        supportsPreviewPanel: true
    }));

});

parcelRegister("79qCU", function(module, exports) {

$parcel$export(module.exports, "customQueueCalendarRouteEntry", () => $2a2221e4bb7d64f1$export$a6aaa9129c24f852);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $5lsNZ = parcelRequire("5lsNZ");

var $fpjJX = parcelRequire("fpjJX");

var $g0YQu = parcelRequire("g0YQu");

var $6Z2mh = parcelRequire("6Z2mh");

var $bHhiy = parcelRequire("bHhiy");

var $f7Y15 = parcelRequire("f7Y15");

var $jYeNO = parcelRequire("jYeNO");

var $4R6GH = parcelRequire("4R6GH");

var $gNStA = parcelRequire("gNStA");

var $iTSIT = parcelRequire("iTSIT");

var $3HwlS = parcelRequire("3HwlS");

var $lBKJK = parcelRequire("lBKJK");

var $dPV2J = parcelRequire("dPV2J");
const $2a2221e4bb7d64f1$export$a6aaa9129c24f852 = (0, $7NszV.createEntry)((0, $g0YQu.customQueueCalendarRoute), ()=>({
        group: 'servicedesk',
        component: (0, $5lsNZ.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: // eslint-disable-next-line jira/ff/no-preconditioning
            (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') && !(0, $3HwlS.getWillShowNav4)() ? (0, $lBKJK.AsyncHorizontalNavQueue) : undefined
        },
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag')) return (0, $3HwlS.getWillShowNav4)() ? (0, $dPV2J.calendarPageEntryPoint) : (0, $dPV2J.calendarPageNav3EntryPoint);
            return undefined;
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ],
        skeleton: (0, $dPV2J.CalendarSkeleton),
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $jYeNO.getCalendarFilterFieldsResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>!(0, $3HwlS.getWillShowNav4)(), (0, $iTSIT.horizontalNavQueueResource)),
            (0, $gNStA.resourceWithCondition2)(()=>!false, (0, $f7Y15.uifBoardResource))
        ],
        supportsPreviewPanel: true
    }));

});

parcelRegister("8brgy", function(module, exports) {

$parcel$export(module.exports, "customQueueRouteEntry", () => $9125770532ebae88$export$54a295e04e6cea33);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $7M8Tn = parcelRequire("7M8Tn");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $aPfsS = parcelRequire("aPfsS");

var $jlOGG = parcelRequire("jlOGG");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $iTSIT = parcelRequire("iTSIT");

var $lBKJK = parcelRequire("lBKJK");

var $4R6GH = parcelRequire("4R6GH");

var $gNStA = parcelRequire("gNStA");

var $aNLeB = parcelRequire("aNLeB");

var $6Z2mh = parcelRequire("6Z2mh");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $6lAw8 = parcelRequire("6lAw8");

var $faj7G = parcelRequire("faj7G");

var $gLKd7 = parcelRequire("gLKd7");
const $9125770532ebae88$export$54a295e04e6cea33 = (0, $7NszV.createEntry)((0, $7M8Tn.customQueueRoute), ()=>({
        layout: (0, $aPfsS.composeLayouts)((0, $6Z2mh.serviceProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                params: [
                    {
                        key: 'issueKey'
                    }
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $lBKJK.AsyncHorizontalNavQueue) : undefined
        },
        skeleton: (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $gLKd7.QueueLoadingSkeleton) : undefined,
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            ...(0, $fpjJX.getInsightResources)(),
            ...(0, $fpjJX.getIssueListSsrResource)(),
            (0, $jlOGG.newIssueViewLockInStatusResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $aNLeB.servicedeskIsItsmProjectResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $iTSIT.horizontalNavQueueResource))
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        group: 'servicedesk',
        // It is important to keep this component consistent across the two routes so
        // that React doesn't unmount it when switching between the routes and the
        // full state is kept so that scroll position and loaded data is kept when
        // going back from issue details to the queues page.
        component: (0, $faj7G.CustomQueueRouteComponent),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $faj7G.LazyServicedeskQueuesAgentAndIssueView),
            (0, $6lAw8.LazyForPaintServicedeskSidebar)
        ],
        supportsPreviewPanel: true
    }));

});

parcelRegister("2fNbh", function(module, exports) {

$parcel$export(module.exports, "dashboardEditRouteEntry", () => $ff9c4f8f4f936d52$export$9b0fdfd6a51a17de);

var $j6woB = parcelRequire("j6woB");


var $e2ctp = parcelRequire("e2ctp");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $gh1hi = parcelRequire("gh1hi");

var $3RJkv = parcelRequire("3RJkv");

var $gCJaT = parcelRequire("gCJaT");

var $h4rc7 = parcelRequire("h4rc7");

var $irlpm = parcelRequire("irlpm");

var $lkFvK = parcelRequire("lkFvK");

var $fT58V = parcelRequire("fT58V");

var $ernoj = parcelRequire("ernoj");
const $ff9c4f8f4f936d52$export$9b0fdfd6a51a17de = (0, $7NszV.createEntry)((0, $gCJaT.dashboardEditRoute), ()=>({
        group: 'dashboard',
        entryPoint: ()=>$ff9c4f8f4f936d52$var$pageEntryPoint,
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $j6woB.dashboardBackgroundScriptsLayout)),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).DASHBOARDS,
            sidebarId: (0, $lmyls.SIDEBAR_ID).CONTENT
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $ernoj.dashboardResources)(),
            (0, $gh1hi.gadgetDirectoryResource)
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$4695c1a423ffe431)
        },
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY)
    }));
// Page entrypoint, referred to above...
const $ff9c4f8f4f936d52$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $irlpm.dashboardEditEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).DASHBOARDS,
    leftSidebar: {
        sidebar: (0, $fT58V.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            dashboards: {
                entryPoint: (0, $h4rc7.nav4DashboardsContentEntryPoint)
            }
        }
    }
});

});
parcelRegister("j6woB", function(module, exports) {

$parcel$export(module.exports, "dashboardBackgroundScriptsLayout", () => $90a067693c09e346$export$f0a12e66953aa38a);

var $aPfsS = parcelRequire("aPfsS");

var $Xtn30 = parcelRequire("Xtn30");
const $90a067693c09e346$export$f0a12e66953aa38a = (0, $aPfsS.createLayout)({
    globalComponents: [
        (0, $Xtn30.DashboardBackgroundScripts)
    ]
});

});
parcelRegister("Xtn30", function(module, exports) {

$parcel$export(module.exports, "DashboardBackgroundScripts", () => $79510dabdd765f30$export$4095842bb2e8d712);

var $fZUl0 = parcelRequire("fZUl0");
const $79510dabdd765f30$export$4095842bb2e8d712 = (0, $fZUl0.LazyAfterPaintBackgroundScripts);
$79510dabdd765f30$export$4095842bb2e8d712.displayName = 'ConditionalDashboardBackgroundScripts';

});
parcelRegister("fZUl0", function(module, exports) {

$parcel$export(module.exports, "LazyAfterPaintBackgroundScripts", () => $f2fce09c535c3a19$export$d4768112536c9dc9);

var $kxZPA = parcelRequire("kxZPA");

const $f2fce09c535c3a19$export$d4768112536c9dc9 = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("heTtZ")), {
    ssr: false,
    moduleId: "./src/packages/global-pages/dashboard/background-scripts/src/ui/index.tsx"
});

});
parcelRegister("heTtZ", function(module, exports) {

let $c8cec82a098e213d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c8cec82a098e213d$var$load("jSyxJ").then(()=>parcelRequire('bjmK5'));

});




parcelRegister("gh1hi", function(module, exports) {

$parcel$export(module.exports, "dashboardConfigAndWRMResource", () => $ca62b878c99c7128$export$2853c0e656e89346);
$parcel$export(module.exports, "useDashboardResource", () => $ca62b878c99c7128$export$e5e5b3f462d6a4cb);
$parcel$export(module.exports, "useMultiDashboardsResource", () => $ca62b878c99c7128$export$6a46406b05d8d13c);
$parcel$export(module.exports, "dashboardAMDModulesResource", () => $ca62b878c99c7128$export$ef3fa55626812fa4);
$parcel$export(module.exports, "useDashboardAMDModulesResource", () => $ca62b878c99c7128$export$efe0eb9a44e08d38);
$parcel$export(module.exports, "dashboardReactGadgetsResource", () => $ca62b878c99c7128$export$39804ce8cc42cd04);
$parcel$export(module.exports, "useDashboardReactGadgetsResource", () => $ca62b878c99c7128$export$31b430e01a1caab5);
$parcel$export(module.exports, "dashboardForgeResource", () => $ca62b878c99c7128$export$4e0719e53da01e93);
$parcel$export(module.exports, "gadgetDirectoryResource", () => $ca62b878c99c7128$export$36c9632be21fbb06);
$parcel$export(module.exports, "useGadgetDirectoryResource", () => $ca62b878c99c7128$export$27f4c12e781b4572);
$parcel$export(module.exports, "useDashboardForgeResource", () => $ca62b878c99c7128$export$75ca1b431898fd09);

var $k2DRb = parcelRequire("k2DRb");

var $iVaKa = parcelRequire("iVaKa");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $3Yd87 = parcelRequire("3Yd87");

var $abozY = parcelRequire("abozY");


var $04Brv = parcelRequire("04Brv");

var $3cb5I = parcelRequire("3cb5I");

var $aVFmC = parcelRequire("aVFmC");

var $3Zhqx = parcelRequire("3Zhqx");

var $8oOn8 = parcelRequire("8oOn8");
const $ca62b878c99c7128$export$2853c0e656e89346 = (0, $2M1hQ.createResource)({
    type: (0, $e03099b7bef7f4cd$export$ca03ff6cc792cc16),
    getKey: $abozY.getKey,
    getData: (0, $3cb5I.default),
    maxAge: Infinity
});
// the type signature of promise and update is different on the useDashboardResource and useMultiDashboardsResource hook
const $ca62b878c99c7128$var$extractFirstPromise = (promise)=>promise ? promise.then((configs)=>configs && configs[0]) : null;
const $ca62b878c99c7128$export$e5e5b3f462d6a4cb = ()=>{
    // the response will have different signature on update, promise and clear etc
    const resourceResponse = $ca62b878c99c7128$export$6a46406b05d8d13c();
    const { loading: loading, error: error, data: data, promise: promiseOfMultiConfigs, ...rest } = resourceResponse;
    const extractFirstUpdate = (getNewData)=>resourceResponse.update(([a])=>[
                getNewData(a)
            ]);
    // RouteResourceResponseLoading type
    if (loading) return {
        ...rest,
        error: null,
        data: null,
        promise: $ca62b878c99c7128$var$extractFirstPromise(promiseOfMultiConfigs),
        loading: true,
        update: extractFirstUpdate
    };
    // RouteResourceResponseError type
    if (error) return {
        ...rest,
        error: error,
        data: null,
        promise: $ca62b878c99c7128$var$extractFirstPromise(promiseOfMultiConfigs),
        loading: false,
        update: extractFirstUpdate
    };
    // RouteResourceResponseLoaded type
    if (data && !error) return {
        ...rest,
        loading: false,
        update: extractFirstUpdate,
        data: data[0],
        error: null,
        promise: $ca62b878c99c7128$var$extractFirstPromise(promiseOfMultiConfigs)
    };
    // RouteResourceResponseInitial type
    return {
        ...rest,
        loading: false,
        error: error,
        data: null,
        promise: null,
        update: extractFirstUpdate
    };
};
const $ca62b878c99c7128$export$6a46406b05d8d13c = ()=>(0, $2YP9W.useResource)($ca62b878c99c7128$export$2853c0e656e89346);
const $ca62b878c99c7128$export$ef3fa55626812fa4 = (0, $3Yd87.createDependentResource)({
    type: (0, $e03099b7bef7f4cd$export$e239393fd4e2bc85),
    getKey: $abozY.getKey,
    depends: [
        (0, $e03099b7bef7f4cd$export$ca03ff6cc792cc16)
    ],
    mapToSharedValue: (0, $3Yd87.withEitherDataOrError)((data)=>{
        const { gadgets: gadgets, preloadedModuleNames: preloadedModuleNames } = data.reduce((prev, curr)=>({
                gadgets: prev.gadgets.concat(curr.gadgets),
                preloadedModuleNames: prev.preloadedModuleNames.concat(curr.preloadedModuleNames)
            }), {
            gadgets: [],
            preloadedModuleNames: []
        });
        const moduleNames = (0, $8oOn8.gadgetsToUniqueSortedAmdModules)(gadgets);
        const isPreloaded = moduleNames.every((name)=>preloadedModuleNames.includes(name));
        return {
            moduleNames: moduleNames,
            isPreloaded: isPreloaded
        };
    }, (x)=>x),
    shouldUpdate: ({ sharedValue: a, amdModules: amdModules }, b)=>(0, $3Yd87.withEitherDataOrError)((prev, next)=>next.moduleNames.length > prev.moduleNames.length || next.moduleNames.some((name)=>amdModules?.[name] == null), ()=>true)(a, b),
    getData: (0, $04Brv.default),
    maxAge: Infinity,
    isBrowserOnly: true
});
const $ca62b878c99c7128$export$efe0eb9a44e08d38 = ()=>(0, $2YP9W.useResource)($ca62b878c99c7128$export$ef3fa55626812fa4);
const $ca62b878c99c7128$export$39804ce8cc42cd04 = (0, $3Yd87.createDependentResource)({
    type: (0, $e03099b7bef7f4cd$export$9e5db01432b13b67),
    getKey: $abozY.getKey,
    depends: [
        (0, $e03099b7bef7f4cd$export$ca03ff6cc792cc16)
    ],
    mapToSharedValue: (0, $3Yd87.withEitherDataOrError)((data)=>{
        const gadgets = data.flatMap((dashboard)=>dashboard.gadgets);
        return {
            reactGadgets: (0, $8oOn8.gadgetsToSortedReactGadgets)(gadgets)
        };
    }, (x)=>x),
    shouldUpdate: ({ sharedValue: a, reactGadgetsState: reactGadgetsState }, b)=>(0, $3Yd87.withEitherDataOrError)((prev, next)=>JSON.stringify(next.reactGadgets) !== JSON.stringify(prev.reactGadgets) || reactGadgetsState != null && Object.values(reactGadgetsState).some((v)=>!v), ()=>true)(a, b),
    getData: (0, $3Zhqx.default),
    maxAge: Infinity,
    isBrowserOnly: true
});
const $ca62b878c99c7128$export$31b430e01a1caab5 = ()=>(0, $2YP9W.useResource)($ca62b878c99c7128$export$39804ce8cc42cd04);
const $ca62b878c99c7128$export$4e0719e53da01e93 = (0, $2M1hQ.createResource)({
    type: (0, $e03099b7bef7f4cd$export$bce41807cc929d0f),
    getKey: $abozY.getKey,
    getData: async (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
        const modules = await (0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.DASHBOARD_GADGET_MODULE),
                (0, $k2DRb.DASHBOARD_BACKGROUND_SCRIPT_MODULE)
            ],
            context: {},
            includeHidden: false,
            source: (0, $k2DRb.SOURCE_ROUTER)
        });
        return {
            gadgets: modules[0, $k2DRb.DASHBOARD_GADGET_MODULE],
            backgroundScripts: modules[0, $k2DRb.DASHBOARD_BACKGROUND_SCRIPT_MODULE]
        };
    },
    maxAge: Infinity
});
const $ca62b878c99c7128$export$36c9632be21fbb06 = (0, $2M1hQ.createResource)({
    type: (0, $e03099b7bef7f4cd$export$c07a25ebb6af1e84),
    getKey: ()=>'gadgetDirectoryItems',
    getData: (0, $aVFmC.default),
    maxAge: Infinity,
    isBrowserOnly: true
});
const $ca62b878c99c7128$export$27f4c12e781b4572 = ()=>(0, $2YP9W.useResource)($ca62b878c99c7128$export$36c9632be21fbb06);
const $ca62b878c99c7128$export$75ca1b431898fd09 = ()=>(0, $2YP9W.useResource)($ca62b878c99c7128$export$4e0719e53da01e93);

});
parcelRegister("3Yd87", function(module, exports) {

$parcel$export(module.exports, "withEitherDataOrError", () => $3e606a4e02c14aae$export$54e973088fdd59a1);
$parcel$export(module.exports, "createDependentResource", () => $3e606a4e02c14aae$export$7f8dd41bdfd85a47);
$parcel$export(module.exports, "SharedValueAggregateError", () => $3e606a4e02c14aae$export$36d5102d613df7c6);

var $2M1hQ = parcelRequire("2M1hQ");
var $htn2f = parcelRequire("htn2f");
const $3e606a4e02c14aae$export$54e973088fdd59a1 = (dataFn, errorFn)=>(...args)=>{
        const invalidArgs = args.filter((v)=>v == null || v instanceof Error);
        return invalidArgs.length ? errorFn(invalidArgs[0]) : dataFn(...args);
    };
const $3e606a4e02c14aae$export$fcdc85dfc621ec7a = (dependencies, type)=>{
    // the standard in react-resource-router is to fail getData() for dependency errors
    const { [type]: resourceSlice } = dependencies;
    if (!resourceSlice) throw new (0, $htn2f.ResourceDependencyError)(`Cannot decode dependency "${type}", it may be missing from resource depends field`);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return resourceSlice.data;
};
const $3e606a4e02c14aae$export$bee6a631bfb54474 = (dependencies, type)=>{
    // the standard in react-resource-router is to fail getData() for dependency errors
    const { [type]: resourceSlice } = dependencies;
    if (!resourceSlice) throw new Error(`Cannot decode dependency: "${type}" must be included in the resource depends field`);
    // prefer previous value rather than error
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { loading: loading, data: data, promise: promise, error: error } = resourceSlice;
    return loading && promise ? promise.then((v)=>v, (e)=>data ?? e) : data ?? error;
};
const $3e606a4e02c14aae$export$7f8dd41bdfd85a47 = ({ type: type, depends: depends, mapToSharedValue: mapToSharedValue, shouldUpdate: shouldUpdate, getData: getData, ...rest })=>(0, $2M1hQ.createResource)({
        ...rest,
        type: type,
        depends: [
            ...depends,
            type
        ],
        getData: (dataContext, storeContext)=>{
            const { dependencies: dependencies } = dataContext;
            const prevValue = $3e606a4e02c14aae$export$fcdc85dfc621ec7a(dependencies, type);
            const valuesOrPromises = depends.map((d)=>$3e606a4e02c14aae$export$bee6a631bfb54474(dependencies, d));
            const implementation = (depDataOrErrorOrNull)=>{
                const newShared = mapToSharedValue(...depDataOrErrorOrNull);
                return prevValue == null || prevValue instanceof Error || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                shouldUpdate(prevValue, newShared) ? getData(prevValue, newShared)(dataContext, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                storeContext) : prevValue;
            };
            return valuesOrPromises.some((v)=>v instanceof Promise) ? Promise.allSettled(valuesOrPromises).then((arr)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                arr.map((v)=>v.status === 'fulfilled' ? v.value : v.reason)).then(implementation) : implementation(valuesOrPromises);
        }
    });
class $3e606a4e02c14aae$export$36d5102d613df7c6 extends Error {
    constructor({ name: name, isPrefetch: isPrefetch, sharedValue: sharedValue }){
        super(`${name} is missing dependency, prefetch [${isPrefetch}] sharedValue [${sharedValue}]`);
        this.skipSentry = true;
    }
}

});

parcelRegister("abozY", function(module, exports) {

$parcel$export(module.exports, "getKey", () => $707c98c2b1b4b40d$export$a47fb462a08de82f);
// eslint-disable-next-line jira/import-whitelist

var $JIPqS = parcelRequire("JIPqS");
const $707c98c2b1b4b40d$export$a47fb462a08de82f = ({ route: route, query: query, match: { params: params } })=>{
    if (route.name === 'system-dashboard-edit') return 0, $JIPqS.SYSTEM_DASHBOARD_ID;
    if (route.name === 'dashboard-wallboard') // NOTE - Currently we will only load the first dashboard in the list
    return query.dashboardId?.split(',')[0];
    return params.dashboardId?.replace('last-visited', 'lastVisited') ?? query.selectPageId ?? 'lastVisited';
};

});
parcelRegister("JIPqS", function(module, exports) {

$parcel$export(module.exports, "GADGET_DISPLAY", () => $6c7fd970bbaee123$export$d7e1dfcefcde2410);
$parcel$export(module.exports, "MAXIMIZED_PARAM", () => $6c7fd970bbaee123$export$86eaa19ea940a4f5);
$parcel$export(module.exports, "CONNECT_ITEM_AMD_MODULE", () => $6c7fd970bbaee123$export$a1baea8b97610fd);
$parcel$export(module.exports, "WEB_RESOURCE_MAP", () => $6c7fd970bbaee123$export$c6d360a8456d120a);
$parcel$export(module.exports, "PRELOADED_GADGET_DATA_KEY", () => $6c7fd970bbaee123$export$30b970d16c2f5e0a);
$parcel$export(module.exports, "SYSTEM_DASHBOARD_ID", () => $6c7fd970bbaee123$export$50eac80bcbebc737);
$parcel$export(module.exports, "DASHBOARD_HEADER_HEIGHT", () => $6c7fd970bbaee123$export$e11ffd0409aa6522);
$parcel$export(module.exports, "FOOTER_MARGIN", () => $6c7fd970bbaee123$export$4d708f4c16ae3a73);
$parcel$export(module.exports, "STORAGE_PREFIX", () => $6c7fd970bbaee123$export$7cc65d02ca2e18ec);
$parcel$export(module.exports, "GADGET_LOCAL_STORAGE_NAME", () => $6c7fd970bbaee123$export$255117c9adec50a5);
$parcel$export(module.exports, "DASHBOARD_LOCAL_STORAGE_KEY_NAME", () => $6c7fd970bbaee123$export$e281465c09f561d4);
$parcel$export(module.exports, "GADGET_DEFAULT_HEIGHT", () => $6c7fd970bbaee123$export$46dd0168a7875b47);
$parcel$export(module.exports, "COLOR_MAP", () => $6c7fd970bbaee123$export$1468aefba37090f9);
$parcel$export(module.exports, "COLOR_NAME_MAP", () => $6c7fd970bbaee123$export$5d9e688e192a63ae);
$parcel$export(module.exports, "COLOR_CHECKMARK_MAP", () => $6c7fd970bbaee123$export$6906a4beef307ac4);
$parcel$export(module.exports, "MODAL_ID", () => $6c7fd970bbaee123$export$ebdd5a8e5b1c2de5);
$parcel$export(module.exports, "LAYOUTS", () => $6c7fd970bbaee123$export$87e50aced9c52ebb);
$parcel$export(module.exports, "GADGET_HEIGHT_UPDATE_WAIT_TIME", () => $6c7fd970bbaee123$export$b0234a47b1a4a515);
$parcel$export(module.exports, "GADGET_DRAG_CONTAINER_HEIGHT", () => $6c7fd970bbaee123$export$9674cd14c20d1c89);
$parcel$export(module.exports, "GADGET_METRICS_TYPE", () => $6c7fd970bbaee123$export$46b6c8eb53069613);
$parcel$export(module.exports, "PAGE_READY_METRIC_KEY", () => $6c7fd970bbaee123$export$464d2a6bcb398791);
$parcel$export(module.exports, "DELETE_DASHBOARD_EXPERIENCE", () => $6c7fd970bbaee123$export$4f74f1f13671c49d);
$parcel$export(module.exports, "COPY_DASHBOARD_EXPERIENCE", () => $6c7fd970bbaee123$export$3853fce65645c557);
$parcel$export(module.exports, "DASHBOARD_AUTOMATIC_REFRESH_EXPERIENCE", () => $6c7fd970bbaee123$export$c8c77659771c38b9);
$parcel$export(module.exports, "RENAME_OR_SHARE_DASHBOARD_EXPERIENCE", () => $6c7fd970bbaee123$export$707702c47e5b9648);
$parcel$export(module.exports, "CREATE_DASHBOARD_EXPERIENCE", () => $6c7fd970bbaee123$export$efbab4efa7252143);
$parcel$export(module.exports, "VIEW_DASHBOARD_EDITABLE_EXPERIENCE", () => $6c7fd970bbaee123$export$7b6f3ec1189de156);
$parcel$export(module.exports, "VIEW_DASHBOARD_READONLY_EXPERIENCE", () => $6c7fd970bbaee123$export$f0e105144716a420);
$parcel$export(module.exports, "VIEW_DASHBOARD_READONLY_EMBED_EXPERIENCE", () => $6c7fd970bbaee123$export$5ba84cd082269cd5);
$parcel$export(module.exports, "VIEW_DASHBOARD_WALLBOARD_READONLY_EXPERIENCE", () => $6c7fd970bbaee123$export$6c84c6099fed3c23);
$parcel$export(module.exports, "ADD_GADGET_EXPERIENCE", () => $6c7fd970bbaee123$export$3b17b4f7f722b1ae);
$parcel$export(module.exports, "SAVE_AMD_GADGET_CONFIG_PREFERENCES", () => $6c7fd970bbaee123$export$c8900d7e874d42ca);
$parcel$export(module.exports, "SAVE_FORGE_GADGET_CONFIG_PREFERENCES", () => $6c7fd970bbaee123$export$bac5a3e9d008da59);
$parcel$export(module.exports, "SAVE_CUSTOM_GADGET_TITLE_PREFERENCES", () => $6c7fd970bbaee123$export$18b54b2c53cf6acd);
$parcel$export(module.exports, "VIEW_WRM_GADGET_EXPERIENCE", () => $6c7fd970bbaee123$export$a3d5b76ea0c8f4ca);
$parcel$export(module.exports, "CHANGE_LAYOUT_EXPERIENCE", () => $6c7fd970bbaee123$export$7254246f25b4cbc8);
$parcel$export(module.exports, "DELETE_GADGET_EXPERIENCE", () => $6c7fd970bbaee123$export$40c4d345e57fce2d);
$parcel$export(module.exports, "VIEW_REACT_GADGET_EXPERIENCE", () => $6c7fd970bbaee123$export$43fb10a4d8374f1a);
$parcel$export(module.exports, "DASHBOARD_VIEW_SOURCENAME", () => $6c7fd970bbaee123$export$2f961c74af6d8735);
$parcel$export(module.exports, "DASHBOARD_VIEW_EMBED_SOURCENAME", () => $6c7fd970bbaee123$export$dab1096b356df1cc);
$parcel$export(module.exports, "DASHBOARD_EDIT_SOURCENAME", () => $6c7fd970bbaee123$export$32f0edca4eebb9c7);
$parcel$export(module.exports, "DASHBOARD_WALLBOARD_VIEW_SOURCENAME", () => $6c7fd970bbaee123$export$791f7067c41dc5b1);
$parcel$export(module.exports, "SYSTEM_DASHBOARD_EDIT_SOURCENAME", () => $6c7fd970bbaee123$export$eba1a497984af3ae);
$parcel$export(module.exports, "COPY_DASHBOARD", () => $6c7fd970bbaee123$export$3578044b625436f9);
$parcel$export(module.exports, "DASHBOARD_AUTOMATIC_REFRESH", () => $6c7fd970bbaee123$export$48bb59a846d62ea0);
$parcel$export(module.exports, "DELETE_DASHBOARD", () => $6c7fd970bbaee123$export$e7dfbcf33cf2b19a);
$parcel$export(module.exports, "DUPLICATE_GADGET_EXPERIENCE", () => $6c7fd970bbaee123$export$fabf79b25b44377f);
$parcel$export(module.exports, "RENAME_OR_SHARE_DASHBOARD", () => $6c7fd970bbaee123$export$abba919f32a1a776);
$parcel$export(module.exports, "GADGET_ERROR_TYPE", () => $6c7fd970bbaee123$export$768dad6811159849);
$parcel$export(module.exports, "DASHBOARD_REFRESH_LOAD_BUFFER_MS", () => $6c7fd970bbaee123$export$ada294d471e7dfc3);
$parcel$export(module.exports, "REFRESH_LABEL_UPDATE_INTERVAL", () => $6c7fd970bbaee123$export$f4280aaeba4d1d08);
$parcel$export(module.exports, "CONNECT_GADGET_REFRESH_REQUEST_EVENT", () => $6c7fd970bbaee123$export$685171fdf5112bc4);
$parcel$export(module.exports, "FORGE_JIRA_DASHBOARD_GADGET_REFRESH_EVENT", () => $6c7fd970bbaee123$export$4d8c12b9aaeac619);
$parcel$export(module.exports, "ISSUE_SEARCH_DEFAULT_COLUMNS", () => $6c7fd970bbaee123$export$f07dac7b8de3bda);


var $gwIPs = parcelRequire("gwIPs");

var $cKw8Y = parcelRequire("cKw8Y");
const $6c7fd970bbaee123$export$d7e1dfcefcde2410 = {
    MAXIMIZED: 'maximized',
    NORMAL: 'normal',
    HIDDEN: 'hidden'
};
const $6c7fd970bbaee123$export$86eaa19ea940a4f5 = 'maximized';
const $6c7fd970bbaee123$export$a1baea8b97610fd = 'atlassian-connect/connect-dashboard-item';
const $6c7fd970bbaee123$export$c6d360a8456d120a = {
    'jira-dashboard-items/assigned-to-me': 'com.atlassian.jira.gadgets:assigned-to-me-dashboard-item-resources',
    'jira-dashboard-items/filter-results': 'com.atlassian.jira.gadgets:filter-results-dashboard-item-resources',
    'jira-dashboard-items/createdvsresolved': 'com.atlassian.jira.gadgets:createdvsresolved-dashboard-item-resources',
    'jira-dashboard-items/favourite-filters': 'com.atlassian.jira.gadgets:favourite-filters-dashboard-item-resources',
    'jira-dashboard-items/in-progress': 'com.atlassian.jira.gadgets:in-progress-dashboard-item-resources',
    'jira-dashboard-items/stats': 'com.atlassian.jira.gadgets:stats-dashboard-item-resources',
    'jira-dashboard-items/watched': 'com.atlassian.jira.gadgets:watched-dashboard-item-resources',
    'jira-dashboard-items/labels': 'com.atlassian.jira.gadgets:labels-dashboard-item-resources',
    'jira-dashboard-items/bubble-chart-dashboard-item': 'com.atlassian.jira.gadgets:bubble-chart-dashboard-item-resources',
    'jira-dashboard-items/piechart': 'com.atlassian.jira.gadgets:piechart-dashboard-item-resources',
    'jira-dashboard-items/voted': 'com.atlassian.jira.gadgets:voted-dashboard-item-resources',
    'jira-dashboard-items/two-dimensional-stats': 'com.atlassian.jira.gadgets:two-dimensional-stats-dashboard-item-resources',
    'jira-dashboard-items/sprint-health': 'com.pyxis.greenhopper.jira:greenhopper-sprint-health-dashboard-item-resources',
    'jira-dashboard-items/sprint-days-remaining': 'com.pyxis.greenhopper.jira:greenhopper-days-remaining-dashboard-item-resources',
    'servicedesk/internal/dashboard-items/filter/filter-dashboard-item': 'com.atlassian.servicedesk.dashboard-items-plugin:spa-filter-dashboard-item-resources',
    'servicedesk/internal/reports/feature/custom-report-dashboard-item/custom-report-dashboard-item': 'com.atlassian.servicedesk.servicedesk-reports-plugin:custom-report-dashboard-item-resources-spa',
    'jira-dashboard-items/projects': 'com.atlassian.jira.gadgets:projects-dashboard-item-resources',
    'jira-dashboard-items/issuescalendar': 'com.atlassian.jira.ext.calendar:issues-calendar-dashboard-item-resources',
    'jira-dashboard-items/activitystream': 'com.atlassian.streams.streams-jira-plugin:activitystream-dashboard-item-resources',
    'jira-dashboard-items/recently-created': 'com.atlassian.jira.gadgets:recently-created-chart-dashboard-item-resources',
    'jira-dashboard-items/resolution-time': 'com.atlassian.jira.gadgets:resolution-time-dashboard-item-resources',
    'jira-dashboard-items/timesince': 'com.atlassian.jira.gadgets:timesince-dashboard-item-resources',
    'jira-dashboard-items/spacer': 'com.atlassian.jira.gadgets:spacer-dashboard-item-resources',
    'jira-dashboard-items/sprint-burndown': 'com.pyxis.greenhopper.jira:greenhopper-sprint-burndown-dashboard-item-resources',
    'jira-dashboard-items/workload-pie-chart': 'com.atlassian.jira.gadgets:workload-pie-chart-dashboard-item-resources',
    'jira-dashboard-items/roadmap': 'com.atlassian.jira.gadgets:roadmap-dashboard-item-resources',
    'jira-dashboard-items/average-age-chart': 'com.atlassian.jira.gadgets:average-age-chart-dashboard-item-resources',
    'jira-dashboard-items/average-time-in-status-chart': 'com.atlassian.jira.gadgets:average-time-in-status-chart-dashboard-item-resources',
    'jira-dashboard-items/average-number-of-times-in-status-chart': 'com.atlassian.jira.gadgets:average-number-of-times-in-status-chart-dashboard-item-resources',
    'jira-dashboard-items/heat-map': 'com.atlassian.jira.gadgets:heat-map-dashboard-item-resources',
    'jira-dashboard-items/time-to-first-response': 'com.atlassian.jira.gadgets:time-to-first-response-dashboard-item-resources',
    'jira-dashboard-items/rapid-view': 'com.pyxis.greenhopper.jira:greenhopper-rapid-view-dashboard-item-resources',
    'jira-dashboard-items/version-report': 'com.pyxis.greenhopper.jira:greenhopper-version-report-dashboard-item-resources'
};
const $6c7fd970bbaee123$export$30b970d16c2f5e0a = 'DASHBOARD_GADGET_PRELOADED_DATA';
const $6c7fd970bbaee123$export$50eac80bcbebc737 = '10000';
const $6c7fd970bbaee123$export$e11ffd0409aa6522 = (0, $gwIPs.gridSize) * 10;
const $6c7fd970bbaee123$export$4d708f4c16ae3a73 = (0, $gwIPs.gridSize) * 2;
const $6c7fd970bbaee123$export$7cc65d02ca2e18ec = 'dashboard';
const $6c7fd970bbaee123$export$255117c9adec50a5 = 'AG.congolmerate.cookie';
const $6c7fd970bbaee123$export$e281465c09f561d4 = 'dashboard-data';
const $6c7fd970bbaee123$export$46dd0168a7875b47 = 160;
const $6c7fd970bbaee123$var$COLOR_BLUE = '#2684ff';
const $6c7fd970bbaee123$var$COLOR_RED = '#ff5630';
const $6c7fd970bbaee123$var$COLOR_YELLOW = '#ffab00';
const $6c7fd970bbaee123$var$COLOR_GREEN = '#36b37e';
const $6c7fd970bbaee123$var$COLOR_TEAL = '#00b8d9';
const $6c7fd970bbaee123$var$COLOR_PURPLE = '#6554c0';
const $6c7fd970bbaee123$var$COLOR_GRAY = '#97a0af';
const $6c7fd970bbaee123$var$COLOR_WHITE = '#ffffff';
const $6c7fd970bbaee123$export$1468aefba37090f9 = {
    color1: $6c7fd970bbaee123$var$COLOR_BLUE,
    color2: $6c7fd970bbaee123$var$COLOR_RED,
    color3: $6c7fd970bbaee123$var$COLOR_YELLOW,
    color4: $6c7fd970bbaee123$var$COLOR_GREEN,
    color5: $6c7fd970bbaee123$var$COLOR_TEAL,
    color6: $6c7fd970bbaee123$var$COLOR_PURPLE,
    color7: $6c7fd970bbaee123$var$COLOR_GRAY,
    color8: $6c7fd970bbaee123$var$COLOR_WHITE
};
const $6c7fd970bbaee123$export$5d9e688e192a63ae = {
    [$6c7fd970bbaee123$var$COLOR_BLUE]: (0, $cKw8Y.default).blue,
    [$6c7fd970bbaee123$var$COLOR_RED]: (0, $cKw8Y.default).red,
    [$6c7fd970bbaee123$var$COLOR_YELLOW]: (0, $cKw8Y.default).yellow,
    [$6c7fd970bbaee123$var$COLOR_GREEN]: (0, $cKw8Y.default).green,
    [$6c7fd970bbaee123$var$COLOR_TEAL]: (0, $cKw8Y.default).teal,
    [$6c7fd970bbaee123$var$COLOR_PURPLE]: (0, $cKw8Y.default).purple,
    [$6c7fd970bbaee123$var$COLOR_GRAY]: (0, $cKw8Y.default).gray,
    [$6c7fd970bbaee123$var$COLOR_WHITE]: (0, $cKw8Y.default).white
};
const $6c7fd970bbaee123$export$6906a4beef307ac4 = {
    color1: (0, $829f609a65d26a98$exports).N10,
    color2: (0, $829f609a65d26a98$exports).N10,
    color3: (0, $829f609a65d26a98$exports).N500,
    color4: (0, $829f609a65d26a98$exports).N10,
    color5: (0, $829f609a65d26a98$exports).N500,
    color6: (0, $829f609a65d26a98$exports).N10,
    color7: (0, $829f609a65d26a98$exports).N10,
    color8: (0, $829f609a65d26a98$exports).N500
};
const $6c7fd970bbaee123$export$ebdd5a8e5b1c2de5 = {
    EDIT_LAYOUT: 'edit-layout',
    DASHBOARD_COPY: 'dashboard-copy',
    AUTOMATIC_REFRESH: 'dashboard-automatic-refresh',
    DASHBOARD_RENAME_OR_SHARE: 'dashboard-rename-or-share',
    DASHBOARD_DELETE: 'dashboard-delete',
    CONFIGURE_WALLBOARD: 'configure-wallboard',
    DASHBOARD_CREATE: 'dashboard-create-on-dashboard-page'
};
const $6c7fd970bbaee123$export$87e50aced9c52ebb = [
    'A',
    'AA',
    'AAA',
    'BA',
    'AB'
];
const $6c7fd970bbaee123$export$b0234a47b1a4a515 = 350;
const $6c7fd970bbaee123$export$9674cd14c20d1c89 = 250;
const $6c7fd970bbaee123$export$46b6c8eb53069613 = {
    REPORT: 'REPORT_GADGET_METRICS',
    TIMEOUT: 'TIMEOUT_GADGET_METRICS'
};
const $6c7fd970bbaee123$export$464d2a6bcb398791 = 'JIRA_SPA_PAGE_READY';
const $6c7fd970bbaee123$export$4f74f1f13671c49d = 'delete-dashboard';
const $6c7fd970bbaee123$export$3853fce65645c557 = 'copy-dashboard';
const $6c7fd970bbaee123$export$c8c77659771c38b9 = 'dashboard-automatic-refresh';
const $6c7fd970bbaee123$export$707702c47e5b9648 = 'rename-or-share-dashboard';
const $6c7fd970bbaee123$export$efbab4efa7252143 = 'create-dashboard';
const $6c7fd970bbaee123$export$7b6f3ec1189de156 = 'view-dashboard-editable';
const $6c7fd970bbaee123$export$f0e105144716a420 = 'view-dashboard-readonly';
const $6c7fd970bbaee123$export$5ba84cd082269cd5 = 'view-dashboard-readonly-embed';
const $6c7fd970bbaee123$export$6c84c6099fed3c23 = 'view-dashboard-wallboard-readonly';
const $6c7fd970bbaee123$export$3b17b4f7f722b1ae = 'add-gadget';
const $6c7fd970bbaee123$export$c8900d7e874d42ca = 'save-amd-gadget-config';
const $6c7fd970bbaee123$export$bac5a3e9d008da59 = 'save-forge-gadget-config';
const $6c7fd970bbaee123$export$18b54b2c53cf6acd = 'save-custom-gadget-title-config';
const $6c7fd970bbaee123$export$a3d5b76ea0c8f4ca = 'view-wrm-gadget';
const $6c7fd970bbaee123$export$7254246f25b4cbc8 = 'change-layout';
const $6c7fd970bbaee123$export$40c4d345e57fce2d = 'delete-gadget';
const $6c7fd970bbaee123$export$43fb10a4d8374f1a = 'view-react-gadget';
const $6c7fd970bbaee123$export$2f961c74af6d8735 = 'dashboardView';
const $6c7fd970bbaee123$export$dab1096b356df1cc = 'dashboardViewEmbed';
const $6c7fd970bbaee123$export$32f0edca4eebb9c7 = 'dashboardEdit';
const $6c7fd970bbaee123$export$791f7067c41dc5b1 = 'dashboardWallboardView';
const $6c7fd970bbaee123$export$eba1a497984af3ae = 'systemDashboardEdit';
const $6c7fd970bbaee123$export$3578044b625436f9 = 'copyDashboard';
const $6c7fd970bbaee123$export$48bb59a846d62ea0 = 'automaticRefresh';
const $6c7fd970bbaee123$export$e7dfbcf33cf2b19a = 'deleteDashboard';
const $6c7fd970bbaee123$export$fabf79b25b44377f = 'duplicateGadget';
const $6c7fd970bbaee123$export$abba919f32a1a776 = 'renameOrShareDashboard';
const $6c7fd970bbaee123$export$768dad6811159849 = {
    VIEW_ERROR: 'viewError',
    EDIT_ERROR: 'editError',
    CONFIG_ERROR: 'configError',
    NOT_SUPPORTED_ERROR: 'notSupportedError'
};
const $6c7fd970bbaee123$export$ada294d471e7dfc3 = 1000;
const $6c7fd970bbaee123$export$f4280aaeba4d1d08 = 30000;
const $6c7fd970bbaee123$export$685171fdf5112bc4 = 'jira_dashboard_item_refresh';
const $6c7fd970bbaee123$export$4d8c12b9aaeac619 = 'JIRA_DASHBOARD_GADGET_REFRESH';
const $6c7fd970bbaee123$export$f07dac7b8de3bda = [
    'issuetype',
    'issuekey',
    'summary',
    'priority'
];

});
parcelRegister("cKw8Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $81c05dd6e2dcad70$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $81c05dd6e2dcad70$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    blue: {
        "id": "dashboard-common.blue",
        "defaultMessage": "Blue"
    },
    red: {
        "id": "dashboard-common.red",
        "defaultMessage": "Red"
    },
    yellow: {
        "id": "dashboard-common.yellow",
        "defaultMessage": "Yellow"
    },
    green: {
        "id": "dashboard-common.green",
        "defaultMessage": "Green"
    },
    teal: {
        "id": "dashboard-common.teal",
        "defaultMessage": "Teal"
    },
    purple: {
        "id": "dashboard-common.purple",
        "defaultMessage": "Purple"
    },
    gray: {
        "id": "dashboard-common.gray",
        "defaultMessage": "Gray"
    },
    white: {
        "id": "dashboard-common.white",
        "defaultMessage": "White"
    }
});

});



const $e03099b7bef7f4cd$export$ca03ff6cc792cc16 = 'DASHBOARD_CONFIG_AND_WRM';
const $e03099b7bef7f4cd$export$e239393fd4e2bc85 = 'DASHBOARD_AMD_MODULES';
const $e03099b7bef7f4cd$export$9e5db01432b13b67 = 'DASHBOARD_REACT_GADGETS';
const $e03099b7bef7f4cd$export$bce41807cc929d0f = 'DASHBOARD_FORGE';
const $e03099b7bef7f4cd$export$c07a25ebb6af1e84 = 'DASHBOARD_GADGET_DIRECTORY';

parcelRegister("04Brv", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff7f8eda58c85578$export$2e2bcd8739ae039);

var $4su49 = parcelRequire("4su49");

var $3Yd87 = parcelRequire("3Yd87");

var $1IY2I = parcelRequire("1IY2I");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ff7f8eda58c85578$export$2e2bcd8739ae039 = (_maybePrevData, sharedValue)=>({ isPrefetch: isPrefetch })=>{
        if (!sharedValue || sharedValue instanceof Error) throw new (0, $3Yd87.SharedValueAggregateError)({
            sharedValue: sharedValue,
            isPrefetch: isPrefetch,
            name: 'AMD modules resource'
        });
        return (async ()=>{
            const { moduleNames: moduleNames, isPreloaded: isPreloaded } = sharedValue;
            const maybePromiseAmdModules = isPreloaded || await (0, $1IY2I.loadAmdModules)((0, $4su49.asyncWrmRequire), moduleNames) ? (0, $1IY2I.evalAmdModules)(moduleNames) : null;
            const amdModules = maybePromiseAmdModules instanceof Promise ? await maybePromiseAmdModules : maybePromiseAmdModules;
            return {
                sharedValue: sharedValue,
                amdModules: amdModules
            };
        })();
    };

});
parcelRegister("4su49", function(module, exports) {

$parcel$export(module.exports, "asyncWrmRequire", () => $ae90ef6541667ecb$export$1024fe099ca05f05);
$parcel$export(module.exports, "asyncWrmRequireWithPrefetch", () => $ae90ef6541667ecb$export$3ca0de203efa570e);
/* eslint-disable jira/wrm/no-load-bridge */ 
var $8JNtu = parcelRequire("8JNtu");
var $5Ik5Y = parcelRequire("5Ik5Y");
const $ae90ef6541667ecb$export$1024fe099ca05f05 = (resourcesToRequire)=>(0, $8JNtu.wrmRequire)(resourcesToRequire);
const $ae90ef6541667ecb$export$3ca0de203efa570e = (resourcesToRequire, batchUrl)=>(0, $5Ik5Y.wrmRequireWithPrefetch)(resourcesToRequire, batchUrl);

});

parcelRegister("1IY2I", function(module, exports) {

$parcel$export(module.exports, "loadAmdModules", () => $d6efeb87a1192ef7$export$2c79895bd69a8d54);
$parcel$export(module.exports, "evalAmdModules", () => $d6efeb87a1192ef7$export$d74eab33af9baaea);

var $2YZCu = parcelRequire("2YZCu");

var $JIPqS = parcelRequire("JIPqS");
/**
 * Dummy implementation for a Connect gadget, as rendering and editing are
 * managed externally.
 */ class $d6efeb87a1192ef7$var$ConnectDashboardItem {
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    render() {}
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    renderEdit() {}
}
const $d6efeb87a1192ef7$export$3bf37adbbdcafcc8 = (moduleName, retries = 5)=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (typeof window.require !== 'function') throw new TypeError('window.require is not a function');
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return window.require(moduleName);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // amd module could throw a non-Error
        if (error instanceof Error && /^No \S+$|^\S+ missing \S+$/.test(error.message)) {
            // some AMD modules have define() inside a require() block in which case the module is not immediately ready to be window.require()'d
            // this is due to the 4ms timeout in requirejs' require(), we need a retry logic here to make sure the module is loaded.
            // see the comment section for https://jdog.jira-dev.com/browse/WRM-71
            if (retries > 0) return new Promise((r)=>setTimeout(r, 100)).then(()=>$d6efeb87a1192ef7$export$3bf37adbbdcafcc8(moduleName, retries - 1));
        }
        throw error;
    }
};
const $d6efeb87a1192ef7$export$2c79895bd69a8d54 = async (wrmRequire, moduleNames)=>{
    if (moduleNames.length === 0) return false;
    const prefixedAmdResources = moduleNames.map((amdModule)=>(0, $JIPqS.WEB_RESOURCE_MAP)[amdModule]).map((resourceName)=>`wrc!${resourceName}`);
    try {
        // no result from the promise only the side effect of having loaded the AMD module via WRM
        await wrmRequire(prefixedAmdResources);
        return true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.resource', `Failed to load web resources [${prefixedAmdResources.join(',')}]`, error);
        return false;
    }
};
const $d6efeb87a1192ef7$var$getSortedModuleNamesFromTuples = (tuples)=>tuples.map(([moduleName])=>moduleName).sort((a, b)=>a.localeCompare(b)).join(',');
const $d6efeb87a1192ef7$export$d74eab33af9baaea = (amdModuleNames)=>{
    const tuplesOrPromises = amdModuleNames.map((amdModuleName)=>{
        try {
            const module = amdModuleName === (0, $JIPqS.CONNECT_ITEM_AMD_MODULE) ? $d6efeb87a1192ef7$var$ConnectDashboardItem : $d6efeb87a1192ef7$export$3bf37adbbdcafcc8(amdModuleName);
            return module instanceof Promise ? module.then((v)=>[
                    amdModuleName,
                    v
                ]) : [
                amdModuleName,
                module
            ];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            return Promise.reject(error);
        }
    });
    const hasPromise = tuplesOrPromises.some((entry)=>entry instanceof Promise);
    if (!hasPromise) {
        (0, $2YZCu.default).safeInfoWithoutCustomerData('spa-apps.dashboard.resource', 'Successful synchronous bulk eval AMD modules');
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Object.fromEntries(tuplesOrPromises);
    }
    return Promise.allSettled(tuplesOrPromises).then((results)=>{
        const tuples = results.map((result, i)=>{
            if (result.status === 'fulfilled') return result.value;
            const { reason: error } = result;
            const amdModuleName = amdModuleNames[i];
            const message = error instanceof Error ? error.message : String(error);
            (0, $2YZCu.default).safeErrorWithoutCustomerData('spa-apps.dashboard.resource', `Failed bulk eval AMD module [${amdModuleName}] with error [${message}]`, error);
            return [
                amdModuleName,
                null
            ];
        });
        const failedTuples = tuples.filter((module)=>module[1] === null);
        failedTuples.length > 0 ? (0, $2YZCu.default).safeErrorWithoutCustomerData('spa-apps.dashboard.resource', `Failed bulk eval AMD modules [${$d6efeb87a1192ef7$var$getSortedModuleNamesFromTuples(failedTuples)}]`) : (0, $2YZCu.default).safeInfoWithoutCustomerData('spa-apps.dashboard.resource', 'Successful asynchronous bulk eval AMD modules');
        return Object.fromEntries(tuples);
    });
};

});


parcelRegister("3cb5I", function(module, exports) {

$parcel$export(module.exports, "default", () => $f465c16c9ac91f45$export$2e2bcd8739ae039);

var $7RGnr = parcelRequire("7RGnr");

var $2YZCu = parcelRequire("2YZCu");

var $2j5ho = parcelRequire("2j5ho");

var $1LNzH = parcelRequire("1LNzH");

var $hoLk6 = parcelRequire("hoLk6");

var $6T8HZ = parcelRequire("6T8HZ");

var $abozY = parcelRequire("abozY");

var $8oOn8 = parcelRequire("8oOn8");
const $f465c16c9ac91f45$var$generateScriptTagAndPreloadedModuleNames = async (configs)=>{
    const gadgets = configs.flatMap((config)=>config.gadgets);
    const preloadedModuleNames = (0, $8oOn8.gadgetsToUniqueSortedAmdModules)(gadgets);
    const wrmBundleDescriptor = await (0, $1LNzH.default)(preloadedModuleNames);
    return configs.map((config)=>{
        const scriptTags = [
            wrmBundleDescriptor ? (0, $6T8HZ.default)(wrmBundleDescriptor) : null,
            (0, $hoLk6.default)(config)
        ].filter(Boolean).join('\n') || null;
        return {
            ...config,
            scriptTags: scriptTags,
            preloadedModuleNames: preloadedModuleNames
        };
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f465c16c9ac91f45$export$2e2bcd8739ae039 = async (context)=>{
    // this is either for single dashboard/wallboard or wallboard slide show with multiple dashboards
    try {
        const { route: route, query: query } = context;
        const originalConfigs = route.name === 'dashboard-wallboard' ? await (0, $2j5ho.getDashboardsConfig)(query.dashboardId) : [
            await (0, $2j5ho.default)((0, $abozY.getKey)(context))
        ];
        const configs = originalConfigs.map((config)=>({
                ...config,
                gadgets: (0, $7RGnr.mapToReactGadgets)(config.gadgets)
            }));
        if (!false) return configs.map((config)=>({
                ...config,
                preloadedModuleNames: []
            }));
        return $f465c16c9ac91f45$var$generateScriptTagAndPreloadedModuleNames(configs);
    } catch (error) {
        (0, $2YZCu.default).unsafeErrorWithCustomerData('spa-apps.dashboard.get-config-and-wrm-data', `Failed to get dashboard configuration and wrm data: route=[${context.route.name}], query=[${JSON.stringify(context.query)}]`, error instanceof Error ? error : undefined);
        throw error;
    }
};

});
parcelRegister("7RGnr", function(module, exports) {

$parcel$export(module.exports, "mapToReactGadgets", () => $119a071fe5fec8f8$export$c90615c5eb218d50);

var $4R6GH = parcelRequire("4R6GH");
const $119a071fe5fec8f8$export$c90615c5eb218d50 = (gadgets)=>{
    const gadgetMapping = {
        ...(0, $4R6GH.fg)('endeavour_nin_filter_results_gadget') ? {
            'jira-dashboard-items/filter-results': 'react/filter-results'
        } : {},
        'servicedesk/internal/reports/feature/custom-report-dashboard-item/custom-report-dashboard-item': 'react/custom-report',
        ...(0, $4R6GH.fg)('endeavour_nin_assigned_to_me_gadget') ? {
            'jira-dashboard-items/assigned-to-me': 'react/assigned-to-me'
        } : {},
        ...(0, $4R6GH.fg)('endeavour_nin_issues_in_progress_gadget') ? {
            'jira-dashboard-items/in-progress': 'react/issues-in-progress'
        } : {},
        ...(0, $4R6GH.fg)('endeavour_nin_voted_issues_gadget') ? {
            'jira-dashboard-items/voted': 'react/voted-issues'
        } : {},
        ...(0, $4R6GH.fg)('endeavour_nin_watched_issues_gadget') ? {
            'jira-dashboard-items/watched': 'react/watched-issues'
        } : {}
    }; // satisfies Record<string, ReactKey>; SSR image build Thread Loader doesn't understand 'satisfies'
    const isMapped = (module)=>module !== undefined && module in gadgetMapping;
    return gadgets.map((gadget)=>{
        if (isMapped(gadget.amdModule)) return {
            ...gadget,
            reactKey: gadgetMapping[gadget.amdModule],
            amdModule: undefined,
            configurable: false,
            inlineHtml: undefined
        };
        return gadget;
    });
};

});

parcelRegister("2j5ho", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ef874ace7c3cd69$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getDashboardsConfig", () => $3ef874ace7c3cd69$export$1264b6af3adf5084);

var $7f4tk = parcelRequire("7f4tk");

var $2YZCu = parcelRequire("2YZCu");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3ef874ace7c3cd69$export$2e2bcd8739ae039 = async (id)=>{
    try {
        return (0, $7f4tk.default)(`/rest/dashboards/1.0/${id}.json`);
    } catch (error) {
        (0, $2YZCu.default).unsafeErrorWithCustomerData('spa-apps.dashboard.fetch-dashboard-config', `Failed to get dashboard config json with id=[${id}]`, error instanceof Error ? error : undefined);
        throw error;
    }
};
const $3ef874ace7c3cd69$export$1264b6af3adf5084 = async (idsCsv)=>{
    try {
        return (0, $7f4tk.default)(`/rest/dashboards/1.0?dashboardId=${idsCsv}`);
    } catch (error) {
        (0, $2YZCu.default).unsafeErrorWithCustomerData('spa-apps.dashboard.fetch-dashboard-config', `Failed to get dashboard config with ids=[${idsCsv}]`, error instanceof Error ? error : undefined);
        throw error;
    }
};

});

parcelRegister("1LNzH", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e5794ac0c0d1780$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $JIPqS = parcelRequire("JIPqS");

var $7f4tk = parcelRequire("7f4tk");

var $2YZCu = parcelRequire("2YZCu");
const $1e5794ac0c0d1780$var$CRITICAL_DEPENDENCIES = [
    'jira.webresources:util',
    'jira.webresources:feature-flags',
    'com.atlassian.jira.jira-atlaskit-plugin:overrides-general'
];
const $1e5794ac0c0d1780$var$JIRA_HERITAGE_CRITICAL_BATCH = 'jira.heritage.critical';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1e5794ac0c0d1780$export$2e2bcd8739ae039 = async (moduleNames)=>{
    if (moduleNames.length === 0) return Promise.resolve(null);
    const contextsToRequire = moduleNames.map((amdModule)=>(0, $JIPqS.WEB_RESOURCE_MAP)[amdModule]);
    const payload = {
        r: [],
        c: [
            ...$1e5794ac0c0d1780$var$CRITICAL_DEPENDENCIES,
            ...contextsToRequire
        ],
        xc: [
            $1e5794ac0c0d1780$var$JIRA_HERITAGE_CRITICAL_BATCH
        ],
        xr: []
    };
    try {
        return (0, $7f4tk.default)('/rest/webResources/1.0/resources?operation=FetchWRMData', {
            method: 'POST',
            body: JSON.stringify(payload)
        });
    } catch (error) {
        (0, $2YZCu.default).unsafeErrorWithCustomerData('spa-apps.dashboard.wrm-bundle-descriptor', `Failed to fetch wrm bundle with contexts [${contextsToRequire.join(',')}]`, error instanceof Error ? error : undefined);
        throw error;
    }
};

});

parcelRegister("hoLk6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9b2d88076d11343$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $JIPqS = parcelRequire("JIPqS");

var $83oax = parcelRequire("83oax");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d9b2d88076d11343$export$2e2bcd8739ae039 = (dashboardConfig)=>{
    if (dashboardConfig.gadgets.length === 0) return null;
    const prefetches = (0, $83oax.getPrefetches)(dashboardConfig);
    const preloadLinks = prefetches.map((prefetch)=>`<link rel="preload" as="fetch" href="${prefetch.url}" crossorigin="anonymous" />`).join('\n') || null;
    const syncPrefetchUrls = prefetches.filter((prefetch)=>prefetch.isSyncLoadingSupported()).map((prefetch)=>prefetch.url);
    if (preloadLinks != null && syncPrefetchUrls.length > 0) {
        const fetchScript = `
            <script type="text/javascript" data-defer-skip>
                const preloadUrls = ${JSON.stringify(syncPrefetchUrls)};
                window['${(0, $JIPqS.PRELOADED_GADGET_DATA_KEY)}'] = {};

                preloadUrls.forEach((preloadUrl) => {
                    fetch(preloadUrl)
                        .then(res => res.json())
                        .then(data => {
                            window['${(0, $JIPqS.PRELOADED_GADGET_DATA_KEY)}'][preloadUrl] = data;
                        });
                });
            </script>
        `;
        return preloadLinks + fetchScript;
    }
    return preloadLinks;
};

});
parcelRegister("83oax", function(module, exports) {

$parcel$export(module.exports, "getPrefetches", () => $6e3ee08c53b7707c$export$3144db3718ad5e57);

var $bT0sh = parcelRequire("bT0sh");
const $6e3ee08c53b7707c$export$3144db3718ad5e57 = ({ gadgets: gadgets })=>{
    const lookup = (0, $bT0sh.getPrefetchDict)();
    return gadgets.flatMap((gadget)=>{
        const identifier = gadget.amdModule;
        const prefechProp = identifier != null ? lookup[identifier] : undefined;
        if (!prefechProp || !prefechProp.enabled) return [];
        const { func: func, priority: priority, isSyncLoadingSupported: isSyncLoadingSupported } = prefechProp;
        return func(gadget).map((url)=>({
                url: url,
                priority: priority,
                isSyncLoadingSupported: isSyncLoadingSupported
            }));
    });
};

});
parcelRegister("bT0sh", function(module, exports) {

$parcel$export(module.exports, "getPrefetchDict", () => $e3f3a590c57f26d7$export$244cea94cab19e07);

var $4R6GH = parcelRequire("4R6GH");

var $ltNbR = parcelRequire("ltNbR");

var $8lc67 = parcelRequire("8lc67");

var $cdUf4 = parcelRequire("cdUf4");
const $e3f3a590c57f26d7$export$244cea94cab19e07 = ()=>({
        'jira-dashboard-items/activitystream': {
            func: (0, $8lc67.getActivityStreamPrefetchLink),
            priority: (0, $ltNbR.LOADING_PRIORITY).HIGH,
            enabled: true,
            isSyncLoadingSupported: ()=>false
        },
        'jira-dashboard-items/filter-results': {
            func: (0, $cdUf4.getFilterResultsPrefetchLink),
            priority: (0, $ltNbR.LOADING_PRIORITY).LOW,
            enabled: !(0, $4R6GH.fg)('endeavour_nin_filter_results_gadget'),
            isSyncLoadingSupported: ()=>true
        }
    });

});
parcelRegister("ltNbR", function(module, exports) {

$parcel$export(module.exports, "LOADING_PRIORITY", () => $5a106311215627b2$export$cb9b1f2232733c1b);
const $5a106311215627b2$export$cb9b1f2232733c1b = {
    HIGH: 'preload',
    LOW: 'prefetch'
};

});

parcelRegister("8lc67", function(module, exports) {

$parcel$export(module.exports, "getActivityStreamPrefetchLink", () => $cadf517d0dd42b8b$export$360928f5bf059a9e);

var $ebyGx = parcelRequire("ebyGx");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $cadf517d0dd42b8b$var$replacer = (match, part1)=>String.fromCharCode(part1);
// IMPORTANT - The below code is copied from monolith streams plugin and modified to fit linting rules
// so any changes in here have to be synced with the monolith code as well.
// https://stash.atlassian.com/projects/jiracloud/repos/jira/browse/jira-components/jira-plugins/streams/streams-jira-plugin/src/main/resources/streams-jira-plugin/dashboarditem/activity-stream/js/activity-stream.js?at=64cdcf2e1660c3afeaf26d8795e8cb737286efe9#63-81
// @ts-expect-error - TS7006 - Parameter 'operatorLower' implicitly has an 'any' type.
const $cadf517d0dd42b8b$var$getDateValue = (dateValue, operatorLower)=>{
    // make sure we're dealing with a string so we can use indexOf and split without errors
    const dateStr = `${dateValue}`;
    const operator = operatorLower.toUpperCase();
    let dateArr;
    if (dateStr.indexOf(' ') !== -1) dateArr = dateStr.split(' ');
    else if (operator === 'BETWEEN') dateArr = [
        dateValue,
        dateValue
    ];
    else dateArr = [
        dateValue
    ];
    return dateArr.map((date, index)=>{
        // make sure we're adding numbers and not concatenating strings
        const dateInt = parseInt(date, 10);
        if (operator === 'AFTER' || operator === 'BETWEEN' && index === 1) return dateInt + 86400000 - 1; // Add 23 hours, 59 minutes, 59 seconds to get to end of day
        return dateInt;
    }).join(' ');
};
// IMPORTANT - The below code is copied from monolith streams plugin and modified to fit linting rules
// so any changes in here have to be synced with the monolith code as well.
// https://stash.atlassian.com/projects/jiracloud/repos/jira/browse/jira-components/jira-plugins/streams/streams-jira-plugin/src/main/resources/streams-jira-plugin/dashboarditem/activity-stream/js/activity-stream.js?at=64cdcf2e1660c3afeaf26d8795e8cb737286efe9#20
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $cadf517d0dd42b8b$var$handleSpecialCases = (rule)=>{
    let { value: value, operator: operator } = rule;
    const { type: type } = rule;
    if (Array.isArray(value)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const encodedValues = [];
        value.forEach((val)=>{
            // additional level of encoding for spaces because otherwise the spaces
            // will be mistaken for value delimiters (STRM-1857); escape space as "_"
            // and escape any existing "_" as "\_"
            encodedValues.push(val.replace(/_/g, '\\_').replace(/ /g, '_'));
        });
        value = encodedValues.join(' ');
    }
    if (type === 'date') {
        if (operator === 'is') // back end doesn't support "IS", we have to turn it into a between
        operator = 'between';
        value = $cadf517d0dd42b8b$var$getDateValue(value, operator);
        // We had some problems getting the date values
        // Return empty rule so it won't be included
        if (value.indexOf('NaN') !== -1) return {};
    } else if (type === 'list' || type === 'user') {
        // allow comma-separated values (in addition to space separated) for issue keys and usernames
        value = value.replace(/,/g, ' ');
        // escape underscores as "\_" (because "_" is used to escape spaces in lists)
        value = value.replace(/_/g, '\\_');
    }
    return {
        value: value,
        operator: operator
    };
};
// IMPORTANT - The below code is copied from monolith streams plugin and modified to fit linting rules
// so any changes in here have to be synced with the monolith code as well.
// https://stash.atlassian.com/projects/jiracloud/repos/jira/browse/jira-components/jira-plugins/streams/streams-jira-plugin/src/main/resources/streams-jira-plugin/dashboarditem/activity-stream/js/activity-stream.js?at=64cdcf2e1660c3afeaf26d8795e8cb737286efe9#651-683
const $cadf517d0dd42b8b$var$getParamsFromRules = (rules)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const params = {};
    const providers = JSON.parse(decodeURIComponent(rules.replace(/&#([0-9]+);/g, $cadf517d0dd42b8b$var$replacer)))?.providers || [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const enabledProviders = [];
    // @ts-expect-error - TS7006 - Parameter 'provider' implicitly has an 'any' type.
    providers.forEach((provider)=>{
        const providerKey = provider.provider;
        const { rules: providerRules } = provider;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const stringifiedRules = [];
        if (!provider.disabled) {
            if (providerKey !== 'streams') enabledProviders.push(providerKey);
            // @ts-expect-error - TS7006 - Parameter 'rule' implicitly has an 'any' type.
            providerRules.forEach((rule)=>{
                const modifiedRuleObj = $cadf517d0dd42b8b$var$handleSpecialCases(rule);
                const { operator: operator, value: value } = modifiedRuleObj;
                if (operator && value) stringifiedRules.push([
                    rule.rule,
                    operator.toUpperCase(),
                    value
                ].join(' '));
            });
            params[providerKey] = stringifiedRules;
        }
    });
    if (enabledProviders.length < providers.length - 1) params.providers = enabledProviders.join(' ');
    return params;
};
const $cadf517d0dd42b8b$export$3d7deb7cf8a9de04 = (gadget)=>{
    const prefs = Object.fromEntries(gadget.userPrefs?.fields.map((field)=>[
            field.name,
            field.value
        ]) ?? []);
    const params = {
        maxResults: prefs.numofentries ?? 25,
        relativeLinks: true,
        ...prefs.rules ? $cadf517d0dd42b8b$var$getParamsFromRules(prefs.rules) : {}
    };
    // Gadget encodes spaces as '+', rather than '%20'.  Need to replace here to match URL exactly.
    return (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(params).replace(/%20/g, '+');
};
const $cadf517d0dd42b8b$var$ACTIVITY_STREAM_REST_URL = 'plugins/servlet/streams';
const $cadf517d0dd42b8b$export$360928f5bf059a9e = (gadgetData)=>{
    const paramStr = $cadf517d0dd42b8b$export$3d7deb7cf8a9de04(gadgetData);
    return [
        `/${$cadf517d0dd42b8b$var$ACTIVITY_STREAM_REST_URL}?${paramStr}`
    ];
};

});

parcelRegister("cdUf4", function(module, exports) {

$parcel$export(module.exports, "getFilterResultsPrefetchLink", () => $7e69dbaeb4189994$export$947cd90004054337);

var $ebyGx = parcelRequire("ebyGx");
const $7e69dbaeb4189994$var$FILTER_RESULTS_REST_URL = 'rest/gadget/1.0/issueTable';
const $7e69dbaeb4189994$export$947cd90004054337 = (gadgetData)=>{
    const { properties: properties } = gadgetData.context.dashboardItem;
    const data = {
        num: properties.num,
        tableContext: 'jira.table.cols.dashboard',
        addDefault: false,
        columnNames: typeof properties.columnNames === 'string' ? properties.columnNames.split('|') : undefined,
        enableSorting: true,
        paging: true,
        showActions: true,
        filterId: undefined,
        jql: undefined,
        sortBy: String(properties.sortBy && properties.sortBy !== '' ? properties.sortBy : null),
        startIndex: properties.startIndex ? properties.startIndex : 0
    };
    let queryType = '';
    if (properties.filterId) {
        queryType = 'filter';
        Object.assign(data, {
            filterId: properties.filterId
        });
    } else if (properties.jql) {
        queryType = 'jql';
        Object.assign(data, {
            jql: properties.jql
        });
    }
    // IMPORTANT - type definitions are incorrect, sort is definitely an option
    // @see https://www.npmjs.com/package/query-string/v/5.1.0
    // @ts-expect-error - TS2345 - Argument of type '{ sort: boolean; }' is not assignable to parameter of type 'StringifyOptions'.
    const paramStr = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(data, {
        sort: false
    }).replace(/%20/g, '+');
    const preloadUrl = `/${$7e69dbaeb4189994$var$FILTER_RESULTS_REST_URL}/${queryType}?${paramStr}`;
    return [
        preloadUrl
    ];
};

});




parcelRegister("6T8HZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c547330881220e9$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8c547330881220e9$export$2e2bcd8739ae039 = (response)=>{
    let resourceHtml = `
        <script type="text/javascript" data-defer-skip>
            window.WRM=window.WRM||{};window.WRM._unparsedData=window.WRM._unparsedData||{};window.WRM._unparsedErrors=window.WRM._unparsedErrors||{};
            WRM._unparsedData = Object.assign({}, WRM._unparsedData, JSON.parse(${JSON.stringify(JSON.stringify(response.unparsedData))}));
            WRM._unparsedErrors = Object.assign({}, WRM._unparsedErrors, JSON.parse(${JSON.stringify(JSON.stringify(response.unparsedErrors))}));
            if(window.WRM._dataArrived)window.WRM._dataArrived();
        </script>
    `;
    response.resources.forEach((resource)=>{
        const { url: url, resourceType: resourceType, key: key } = resource;
        if (resourceType === 'CSS') {
            const cssResource = `<link
                href=${url}
                type="text/css"
                rel="stylesheet"
                media="all"
                data-wrm-key=${key}
                data-wrm-batch-type="context"
            />`;
            resourceHtml += cssResource;
        } else {
            const jsResource = `<div>
                <script
                    type="text/javascript"
                    data-initially-rendered
                    data-defer-skip
                    src=${url}
                    data-wrm-key=${key}
                    data-wrm-batch-type="context"
                ></script>
            </div>`;
            resourceHtml += jsResource;
        }
    });
    return resourceHtml;
};

});

parcelRegister("8oOn8", function(module, exports) {

$parcel$export(module.exports, "gadgetsToUniqueSortedAmdModules", () => $d83f51a78c4f458b$export$598e0ea2a7525181);
$parcel$export(module.exports, "gadgetsToSortedReactGadgets", () => $d83f51a78c4f458b$export$f98787198c197952);
// eslint-disable-next-line jira/import-whitelist

var $JIPqS = parcelRequire("JIPqS");

var $kspzT = parcelRequire("kspzT");
const $d83f51a78c4f458b$export$598e0ea2a7525181 = (gadgets)=>gadgets // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .map(({ amdModule: amdModule })=>amdModule) // validated below
    .filter(Boolean).filter((amdModule)=>amdModule in (0, $JIPqS.WEB_RESOURCE_MAP)).filter((v, i, a)=>a.indexOf(v) === i).sort() ?? [];
const $d83f51a78c4f458b$export$f98787198c197952 = (gadgets)=>gadgets.reduce((gadgetsAccumulator, gadget)=>{
        if (!(0, $kspzT.isReactKey)(gadget.reactKey)) return gadgetsAccumulator;
        gadgetsAccumulator.push({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            reactKey: gadget.reactKey,
            id: gadget.id,
            userPrefs: gadget.userPrefs
        });
        return gadgetsAccumulator;
    }, []).sort((a, b)=>a.id.localeCompare(b.id));

});
parcelRegister("kspzT", function(module, exports) {

$parcel$export(module.exports, "isReactKey", () => $7a81ea406ace6c08$export$6acd06c99f745b49);
$parcel$export(module.exports, "default", () => $7a81ea406ace6c08$export$2e2bcd8739ae039);

var $9zbBl = parcelRequire("9zbBl");

var $kvkwL = parcelRequire("kvkwL");

var $26UOd = parcelRequire("26UOd");
/** This is a gadgets definition file.  */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7a81ea406ace6c08$var$GADGETS_DEFINITION = {
    [(0, $26UOd.REACT_KEY).FILTER_RESULTS]: (0, $kvkwL.FILTER_RESULTS_DEFINITION),
    [(0, $26UOd.REACT_KEY).ASSIGNED_TO_ME]: (0, $kvkwL.ASSIGNED_TO_ME_DEFINITION),
    [(0, $26UOd.REACT_KEY).ISSUES_IN_PROGRESS]: (0, $kvkwL.ISSUES_IN_PROGRESS_DEFINITION),
    [(0, $26UOd.REACT_KEY).VOTED_ISSUES]: (0, $kvkwL.VOTED_ISSUES_DEFINITION),
    [(0, $26UOd.REACT_KEY).WATCHED_ISSUES]: (0, $kvkwL.WATCHED_ISSUES_DEFINITION),
    [(0, $26UOd.REACT_KEY).CUSTOM_REPORT]: (0, $9zbBl.default)
};
function $7a81ea406ace6c08$export$6acd06c99f745b49(key) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return !!(key && Object.values((0, $26UOd.REACT_KEY)).includes(key));
}
var $7a81ea406ace6c08$export$2e2bcd8739ae039 = $7a81ea406ace6c08$var$GADGETS_DEFINITION;

});
parcelRegister("9zbBl", function(module, exports) {

$parcel$export(module.exports, "default", () => $088534adc4ba7ffc$export$2e2bcd8739ae039);

var $cDOH2 = parcelRequire("cDOH2");

var $jUheV = parcelRequire("jUheV");

var $gM7kh = parcelRequire("gM7kh");
const $088534adc4ba7ffc$var$CUSTOM_REPORT_DEFINITION = {
    componentView: (0, $jUheV.LazyCustomReportGadgetView),
    componentEdit: (0, $cDOH2.LazyCustomReportGadgetEdit),
    getInitialState: $gM7kh.default,
    preload: $jUheV.preload
};
var $088534adc4ba7ffc$export$2e2bcd8739ae039 = $088534adc4ba7ffc$var$CUSTOM_REPORT_DEFINITION;

});
parcelRegister("cDOH2", function(module, exports) {

$parcel$export(module.exports, "LazyCustomReportGadgetEdit", () => $e8ab1a4d1d8a6eb4$export$475e4a6fb8f40116);

var $kxZPA = parcelRequire("kxZPA");

const $e8ab1a4d1d8a6eb4$export$475e4a6fb8f40116 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("g9rOr")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/custom-report-gadget/src/ui/edit/main.tsx"
});

});
parcelRegister("g9rOr", function(module, exports) {

let $bc230f973d976e94$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bc230f973d976e94$var$load("g1EA5").then(()=>parcelRequire('chhAm'));

});


parcelRegister("jUheV", function(module, exports) {

$parcel$export(module.exports, "LazyCustomReportGadgetView", () => $e43675722e4e42c6$export$27df795d4f3ff173);
$parcel$export(module.exports, "preload", () => $e43675722e4e42c6$export$513ccb98c53b8039);

var $kxZPA = parcelRequire("kxZPA");

const $e43675722e4e42c6$export$27df795d4f3ff173 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("5buDe")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/custom-report-gadget/src/ui/view/main.tsx"
});
const { preload: $e43675722e4e42c6$export$513ccb98c53b8039 } = $e43675722e4e42c6$export$27df795d4f3ff173;

});
parcelRegister("5buDe", function(module, exports) {

let $3c65bda4cdb9eab5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3c65bda4cdb9eab5$var$load("j2DU4").then(()=>parcelRequire('e2l8c'));

});


parcelRegister("gM7kh", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1132aa73a645b93$export$2e2bcd8739ae039);
const $d1132aa73a645b93$var$getInitialState = ()=>Promise.resolve({
        intervalValue: '1',
        isCustom: 'false',
        projectValue: '0',
        refresh: 'false',
        reportValue: '0',
        gadgetContentTitle: ''
    });
var $d1132aa73a645b93$export$2e2bcd8739ae039 = $d1132aa73a645b93$var$getInitialState;

});


parcelRegister("kvkwL", function(module, exports) {

$parcel$export(module.exports, "FILTER_RESULTS_DEFINITION", () => $676d00abfb59f2ab$export$3581891d04da6bb8);
$parcel$export(module.exports, "ASSIGNED_TO_ME_DEFINITION", () => $676d00abfb59f2ab$export$652d5a9cc2c18d2e);
$parcel$export(module.exports, "ISSUES_IN_PROGRESS_DEFINITION", () => $676d00abfb59f2ab$export$54b46348d1ed5d22);
$parcel$export(module.exports, "VOTED_ISSUES_DEFINITION", () => $676d00abfb59f2ab$export$ea96ce30d34ce354);
$parcel$export(module.exports, "WATCHED_ISSUES_DEFINITION", () => $676d00abfb59f2ab$export$5109728db227eae);

var $5uXOq = parcelRequire("5uXOq");

var $2egG3 = parcelRequire("2egG3");

var $eZ5lN = parcelRequire("eZ5lN");

var $kdIR9 = parcelRequire("kdIR9");

var $dzPNh = parcelRequire("dzPNh");

var $9KhHm = parcelRequire("9KhHm");

var $5ALJk = parcelRequire("5ALJk");

var $hfHPa = parcelRequire("hfHPa");
const $676d00abfb59f2ab$var$componentViewWithAdditionalState = (Component, additionalStateProps)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
            ...props,
            state: props.state ? {
                ...props.state,
                ...additionalStateProps
            } : null
        });
const $676d00abfb59f2ab$var$componentEditWithAdditionalState = (Component, additionalStateProps)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
            ...props,
            state: props.state ? {
                ...props.state,
                ...additionalStateProps
            } : null
        });
const $676d00abfb59f2ab$var$FILTER_RESULTS_CONFIG = {
    testId: 'react-issue-table-gadgets.filter-results.view'
};
const $676d00abfb59f2ab$export$3581891d04da6bb8 = {
    componentView: $676d00abfb59f2ab$var$componentViewWithAdditionalState((0, $dzPNh.IssueTableGadgetView), $676d00abfb59f2ab$var$FILTER_RESULTS_CONFIG),
    componentEdit: (0, $eZ5lN.FilterResultsGadgetEdit),
    getInitialState: (0, $hfHPa.default)($676d00abfb59f2ab$var$FILTER_RESULTS_CONFIG),
    preload: (0, $dzPNh.preload)
};
const $676d00abfb59f2ab$var$ASSIGNED_TO_ME_CONFIG = {
    predeterminedJql: 'assignee = currentUser() AND statusCategory != 3 ORDER BY priority DESC, created ASC',
    defaultSortPrefs: {
        field: 'priority',
        direction: 'DESC'
    },
    testId: 'react-issue-table-gadgets.assigned-to-me.view'
};
const $676d00abfb59f2ab$export$652d5a9cc2c18d2e = {
    componentView: $676d00abfb59f2ab$var$componentViewWithAdditionalState((0, $dzPNh.IssueTableGadgetView), $676d00abfb59f2ab$var$ASSIGNED_TO_ME_CONFIG),
    componentEdit: $676d00abfb59f2ab$var$componentEditWithAdditionalState((0, $2egG3.AssignedToMeGadgetEdit), $676d00abfb59f2ab$var$ASSIGNED_TO_ME_CONFIG),
    getInitialState: (0, $hfHPa.default)($676d00abfb59f2ab$var$ASSIGNED_TO_ME_CONFIG),
    preload: (0, $dzPNh.preload)
};
const $676d00abfb59f2ab$var$ISSUES_IN_PROGRESS_CONFIG = {
    predeterminedJql: 'status = "In Progress" AND statusCategory != Done AND assignee = currentUser() ORDER BY priority DESC, created ASC',
    defaultSortPrefs: {
        field: 'priority',
        direction: 'DESC'
    },
    testId: 'react-issue-table-gadgets.issues-in-progress.view'
};
const $676d00abfb59f2ab$export$54b46348d1ed5d22 = {
    componentView: $676d00abfb59f2ab$var$componentViewWithAdditionalState((0, $dzPNh.IssueTableGadgetView), $676d00abfb59f2ab$var$ISSUES_IN_PROGRESS_CONFIG),
    componentEdit: $676d00abfb59f2ab$var$componentEditWithAdditionalState((0, $kdIR9.IssuesInProgressGadgetEdit), $676d00abfb59f2ab$var$ISSUES_IN_PROGRESS_CONFIG),
    getInitialState: (0, $hfHPa.default)($676d00abfb59f2ab$var$ISSUES_IN_PROGRESS_CONFIG),
    preload: (0, $dzPNh.preload)
};
const $676d00abfb59f2ab$var$VOTED_ISSUES_CONFIG = {
    predeterminedJql: 'issue in votedIssues() AND statusCategory != Done ORDER BY votes DESC',
    predeterminedJqlIncludeResolved: 'issue in votedIssues() ORDER BY votes DESC',
    defaultSortPrefs: {
        field: 'votes',
        direction: 'DESC'
    },
    testId: 'react-issue-table-gadgets.voted-issues.view'
};
const $676d00abfb59f2ab$export$ea96ce30d34ce354 = {
    componentView: $676d00abfb59f2ab$var$componentViewWithAdditionalState((0, $dzPNh.IssueTableGadgetView), $676d00abfb59f2ab$var$VOTED_ISSUES_CONFIG),
    componentEdit: $676d00abfb59f2ab$var$componentEditWithAdditionalState((0, $9KhHm.VotedIssuesGadgetEdit), $676d00abfb59f2ab$var$VOTED_ISSUES_CONFIG),
    getInitialState: (0, $hfHPa.default)($676d00abfb59f2ab$var$VOTED_ISSUES_CONFIG),
    preload: (0, $dzPNh.preload)
};
const $676d00abfb59f2ab$var$WATCHED_ISSUES_CONFIG = {
    predeterminedJql: 'issue in watchedIssues() AND statusCategory != Done ORDER BY watchers DESC',
    predeterminedJqlIncludeResolved: 'issue in watchedIssues() ORDER BY watchers DESC',
    defaultSortPrefs: {
        field: 'watchers',
        direction: 'DESC'
    },
    testId: 'react-issue-table-gadgets.watched-issues.view'
};
const $676d00abfb59f2ab$export$5109728db227eae = {
    componentView: $676d00abfb59f2ab$var$componentViewWithAdditionalState((0, $dzPNh.IssueTableGadgetView), $676d00abfb59f2ab$var$WATCHED_ISSUES_CONFIG),
    componentEdit: $676d00abfb59f2ab$var$componentEditWithAdditionalState((0, $5ALJk.WatchedIssuesGadgetEdit), $676d00abfb59f2ab$var$WATCHED_ISSUES_CONFIG),
    getInitialState: (0, $hfHPa.default)($676d00abfb59f2ab$var$WATCHED_ISSUES_CONFIG),
    preload: (0, $dzPNh.preload)
};

});
parcelRegister("2egG3", function(module, exports) {

$parcel$export(module.exports, "AssignedToMeGadgetEdit", () => $91d75e80303bba8c$export$3ae3568d16dc8f35);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $834mM = parcelRequire("834mM");

var $kxZPA = parcelRequire("kxZPA");

const $91d75e80303bba8c$var$LazyAssignedToMeGadgetEdit = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("63llo")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/assigned-to-me/edit/main.tsx"
});
const $91d75e80303bba8c$export$3ae3568d16dc8f35 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "assigned-to-me-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $834mM.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91d75e80303bba8c$var$LazyAssignedToMeGadgetEdit, props));
const { preload: $91d75e80303bba8c$export$513ccb98c53b8039 } = $91d75e80303bba8c$var$LazyAssignedToMeGadgetEdit;

});
parcelRegister("834mM", function(module, exports) {

$parcel$export(module.exports, "FilterResultsEditSkeleton", () => $92b82de956011a8a$export$e10d91ce257e7374);
/* filter-results-edit.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $ewt3o = parcelRequire("ewt3o");
const $92b82de956011a8a$var$customCssStyles = null;
const $92b82de956011a8a$var$FILTER_RESULTS_EDIT_ESTIMATED_HEIGHT = '698px';
const $92b82de956011a8a$export$e10d91ce257e7374 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ewt3o))),
        containerStyles: {
            height: $92b82de956011a8a$var$FILTER_RESULTS_EDIT_ESTIMATED_HEIGHT
        },
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("ewt3o", function(module, exports) {
module.exports = new URL("filter-results-edit-skeleton.tpl.783fb7b7.svg", import.meta.url).toString();

});


parcelRegister("63llo", function(module, exports) {

let $4683945a7b6f2191$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $4683945a7b6f2191$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $4683945a7b6f2191$var$load("k6g9p")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $4683945a7b6f2191$var$load("czifk")
        ]);
    }, function() {
        return Promise.all([
            $4683945a7b6f2191$var$load("kcs34")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $4683945a7b6f2191$var$load("cTJTG"),
            $4683945a7b6f2191$var$load("l253H"),
            $4683945a7b6f2191$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $4683945a7b6f2191$var$load("4Qxp7")
        ]);
    }),
    $4683945a7b6f2191$var$load("ffQaD"),
    $4683945a7b6f2191$var$load("kvRbA"),
    $4683945a7b6f2191$var$load("fliVL"),
    $4683945a7b6f2191$var$load("g7OWt")
]).then(()=>parcelRequire('1SEAb'));

});


parcelRegister("eZ5lN", function(module, exports) {

$parcel$export(module.exports, "FilterResultsGadgetEdit", () => $fa7c1c640e166488$export$6dfceca003c43832);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $834mM = parcelRequire("834mM");

var $kxZPA = parcelRequire("kxZPA");

const $fa7c1c640e166488$var$LazyFilterResultsGadgetEdit = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("l8NRE")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/filter-results/edit/main.tsx"
});
const $fa7c1c640e166488$export$6dfceca003c43832 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "filter-results-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $834mM.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fa7c1c640e166488$var$LazyFilterResultsGadgetEdit, props));
const { preload: $fa7c1c640e166488$export$513ccb98c53b8039 } = $fa7c1c640e166488$var$LazyFilterResultsGadgetEdit;

});
parcelRegister("l8NRE", function(module, exports) {

let $f641065b61fe221b$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $f641065b61fe221b$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $f641065b61fe221b$var$load("k6g9p")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $f641065b61fe221b$var$load("czifk")
        ]);
    }, function() {
        return Promise.all([
            $f641065b61fe221b$var$load("kcs34")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $f641065b61fe221b$var$load("cTJTG"),
            $f641065b61fe221b$var$load("l253H"),
            $f641065b61fe221b$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $f641065b61fe221b$var$load("4Qxp7")
        ]);
    }),
    $f641065b61fe221b$var$load("ffQaD"),
    $f641065b61fe221b$var$load("kvRbA"),
    $f641065b61fe221b$var$load("fliVL"),
    $f641065b61fe221b$var$load("1kIEc")
]).then(()=>parcelRequire('eKgKX'));

});


parcelRegister("kdIR9", function(module, exports) {

$parcel$export(module.exports, "IssuesInProgressGadgetEdit", () => $04f85077310bce7f$export$199fec410a0f70a2);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $834mM = parcelRequire("834mM");

var $kxZPA = parcelRequire("kxZPA");

const $04f85077310bce7f$var$LazyIssuesInProgressGadgetEdit = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("inkVg")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/issues-in-progress/edit/main.tsx"
});
const $04f85077310bce7f$export$199fec410a0f70a2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issues-in-progress-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $834mM.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04f85077310bce7f$var$LazyIssuesInProgressGadgetEdit, props));
const { preload: $04f85077310bce7f$export$513ccb98c53b8039 } = $04f85077310bce7f$var$LazyIssuesInProgressGadgetEdit;

});
parcelRegister("inkVg", function(module, exports) {

let $d60a9ac0a9104560$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $d60a9ac0a9104560$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $d60a9ac0a9104560$var$load("k6g9p")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $d60a9ac0a9104560$var$load("czifk")
        ]);
    }, function() {
        return Promise.all([
            $d60a9ac0a9104560$var$load("kcs34")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $d60a9ac0a9104560$var$load("cTJTG"),
            $d60a9ac0a9104560$var$load("l253H"),
            $d60a9ac0a9104560$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $d60a9ac0a9104560$var$load("4Qxp7")
        ]);
    }),
    $d60a9ac0a9104560$var$load("ffQaD"),
    $d60a9ac0a9104560$var$load("kvRbA"),
    $d60a9ac0a9104560$var$load("fliVL"),
    $d60a9ac0a9104560$var$load("hgF8H")
]).then(()=>parcelRequire('dk51x'));

});


parcelRegister("dzPNh", function(module, exports) {

$parcel$export(module.exports, "IssueTableGadgetView", () => $0c0c24e495111ec5$export$da0765a3c10e16a3);
$parcel$export(module.exports, "preload", () => $0c0c24e495111ec5$export$513ccb98c53b8039);

var $5uXOq = parcelRequire("5uXOq");

var $JIPqS = parcelRequire("JIPqS");

var $lfTZh = parcelRequire("lfTZh");

var $dNZVN = parcelRequire("dNZVN");

var $kxZPA = parcelRequire("kxZPA");

const $0c0c24e495111ec5$var$LazyIssueTableGadgetView = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("dvqPQ")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/view/main.tsx"
});
const $0c0c24e495111ec5$export$da0765a3c10e16a3 = ({ customSkeletonHeightInPx: customSkeletonHeightInPx, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "filter-results-gadget-view",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dNZVN.FilterResultsIssueTableSkeleton), {
            height: `${customSkeletonHeightInPx ?? (0, $JIPqS.GADGET_DEFAULT_HEIGHT)}px`
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0c0c24e495111ec5$var$LazyIssueTableGadgetView, {
        customSkeletonHeightInPx: customSkeletonHeightInPx,
        ...props
    }));
const { preload: $0c0c24e495111ec5$export$513ccb98c53b8039 } = $0c0c24e495111ec5$var$LazyIssueTableGadgetView;

});
parcelRegister("dNZVN", function(module, exports) {

$parcel$export(module.exports, "FilterResultsIssueTableSkeleton", () => $a73c71eae267b518$export$35d754053deeac73);
/* filter-results-issue-table.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $iMQ64 = parcelRequire("iMQ64");
const $a73c71eae267b518$var$customCssStyles = null;
const $a73c71eae267b518$export$35d754053deeac73 = ({ height: height })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iMQ64))),
        containerStyles: {
            height: height
        },
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("iMQ64", function(module, exports) {
module.exports = new URL("filter-results-issue-table-skeleton.tpl.a502204a.svg", import.meta.url).toString();

});


parcelRegister("dvqPQ", function(module, exports) {

let $9d52fc89c635b792$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $9d52fc89c635b792$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $9d52fc89c635b792$var$load("k6g9p")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $9d52fc89c635b792$var$load("czifk")
        ]);
    }, function() {
        return Promise.all([
            $9d52fc89c635b792$var$load("kcs34")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $9d52fc89c635b792$var$load("cTJTG"),
            $9d52fc89c635b792$var$load("l253H"),
            $9d52fc89c635b792$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $9d52fc89c635b792$var$load("4Qxp7")
        ]);
    }),
    $9d52fc89c635b792$var$load("ffQaD"),
    $9d52fc89c635b792$var$load("kvRbA"),
    $9d52fc89c635b792$var$load("fliVL"),
    $9d52fc89c635b792$var$load("6rSuF")
]).then(()=>parcelRequire('dfMo9'));

});


parcelRegister("9KhHm", function(module, exports) {

$parcel$export(module.exports, "VotedIssuesGadgetEdit", () => $0ca7bf6a0d6f5346$export$7650b85a7a54914);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $834mM = parcelRequire("834mM");

var $kxZPA = parcelRequire("kxZPA");

const $0ca7bf6a0d6f5346$var$LazyVotedIssuesGadgetEdit = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("gRXie")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/voted-issues/edit/main.tsx"
});
const $0ca7bf6a0d6f5346$export$7650b85a7a54914 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "voted-issues-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $834mM.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ca7bf6a0d6f5346$var$LazyVotedIssuesGadgetEdit, props));
const { preload: $0ca7bf6a0d6f5346$export$513ccb98c53b8039 } = $0ca7bf6a0d6f5346$var$LazyVotedIssuesGadgetEdit;

});
parcelRegister("gRXie", function(module, exports) {

let $c47f96f5a8c40f50$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $c47f96f5a8c40f50$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $c47f96f5a8c40f50$var$load("k6g9p")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $c47f96f5a8c40f50$var$load("czifk")
        ]);
    }, function() {
        return Promise.all([
            $c47f96f5a8c40f50$var$load("kcs34")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $c47f96f5a8c40f50$var$load("cTJTG"),
            $c47f96f5a8c40f50$var$load("l253H"),
            $c47f96f5a8c40f50$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $c47f96f5a8c40f50$var$load("4Qxp7")
        ]);
    }),
    $c47f96f5a8c40f50$var$load("ffQaD"),
    $c47f96f5a8c40f50$var$load("kvRbA"),
    $c47f96f5a8c40f50$var$load("fliVL"),
    $c47f96f5a8c40f50$var$load("eDCzE")
]).then(()=>parcelRequire('irHWu'));

});


parcelRegister("5ALJk", function(module, exports) {

$parcel$export(module.exports, "WatchedIssuesGadgetEdit", () => $278dbe55a7acf378$export$a53864bd0bf8a85f);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $834mM = parcelRequire("834mM");

var $kxZPA = parcelRequire("kxZPA");

const $278dbe55a7acf378$var$LazyWatchedIssuesGadgetEdit = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("1dIy0")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/watched-issues/edit/main.tsx"
});
const $278dbe55a7acf378$export$a53864bd0bf8a85f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "watched-issues-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $834mM.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($278dbe55a7acf378$var$LazyWatchedIssuesGadgetEdit, props));
const { preload: $278dbe55a7acf378$export$513ccb98c53b8039 } = $278dbe55a7acf378$var$LazyWatchedIssuesGadgetEdit;

});
parcelRegister("1dIy0", function(module, exports) {

let $0e398f91480e19de$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $0e398f91480e19de$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $0e398f91480e19de$var$load("k6g9p")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $0e398f91480e19de$var$load("czifk")
        ]);
    }, function() {
        return Promise.all([
            $0e398f91480e19de$var$load("kcs34")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $0e398f91480e19de$var$load("cTJTG"),
            $0e398f91480e19de$var$load("l253H"),
            $0e398f91480e19de$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $0e398f91480e19de$var$load("4Qxp7")
        ]);
    }),
    $0e398f91480e19de$var$load("ffQaD"),
    $0e398f91480e19de$var$load("kvRbA"),
    $0e398f91480e19de$var$load("fliVL"),
    $0e398f91480e19de$var$load("6LqWP")
]).then(()=>parcelRequire('iLll9'));

});


parcelRegister("hfHPa", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f27ae6f4005fc53$export$2e2bcd8739ae039);

var $fJpBG = parcelRequire("fJpBG");

var $lgZ6q = parcelRequire("lgZ6q");

var $8rq2P = parcelRequire("8rq2P");

var $jyMtv = parcelRequire("jyMtv");
const $9f27ae6f4005fc53$var$createGetInitialState = ({ predeterminedJql: predeterminedJql, predeterminedJqlIncludeResolved: predeterminedJqlIncludeResolved, defaultSortPrefs: defaultSortPrefs, testId: testId })=>async (resourceContext, userPrefs)=>{
        if (resourceContext?.tenantContext == null) throw new Error('Tenant context is not available');
        const { cloudId: cloudId, activationId: activationId } = resourceContext.tenantContext;
        const validUserPrefs = (0, $jyMtv.transformToValidUserPrefs)((0, $fJpBG.decodeUserPreferences)(userPrefs));
        if (validUserPrefs.filterId === undefined && predeterminedJql === undefined && predeterminedJqlIncludeResolved === undefined) throw new Error('FilterId or JQL has to be available to be able to load the gadget initial state');
        const sortPrefs = (()=>{
            if (validUserPrefs.sortField) return {
                sortField: validUserPrefs.sortField,
                sortDirection: validUserPrefs.sortDirection
            };
            if (defaultSortPrefs) return {
                sortField: defaultSortPrefs.field,
                sortDirection: defaultSortPrefs.direction
            };
        })();
        const includeResolved = validUserPrefs.showResolved;
        const jql = includeResolved ? predeterminedJqlIncludeResolved : predeterminedJql;
        const queryReference = await (0, $8rq2P.loadQueryWithUserPrefs)({
            ...validUserPrefs,
            ...sortPrefs
        }, (0, $lgZ6q.default), cloudId, activationId, 'store-and-network', jql);
        return {
            queryReference: queryReference,
            predeterminedJql: predeterminedJql,
            defaultSortPrefs: defaultSortPrefs,
            testId: testId
        };
    };
var $9f27ae6f4005fc53$export$2e2bcd8739ae039 = $9f27ae6f4005fc53$var$createGetInitialState;

});
parcelRegister("fJpBG", function(module, exports) {

$parcel$export(module.exports, "getUserPreferences", () => $a6145919a3771254$export$ae3f5fa351e2f57a);
$parcel$export(module.exports, "decodeUserPreferences", () => $a6145919a3771254$export$ebdfc6c2778ef8e2);

var $7f4tk = parcelRequire("7f4tk");
const $a6145919a3771254$var$isBooleanString = (str)=>[
        'true',
        'false'
    ].includes(str.toLowerCase().trim());
const $a6145919a3771254$var$stringToBoolean = (str)=>str.toLowerCase().trim() === 'true';
const $a6145919a3771254$export$ae3f5fa351e2f57a = (action)=>(0, $7f4tk.default)(action);
const $a6145919a3771254$export$ebdfc6c2778ef8e2 = (userPreferences = [])=>userPreferences.reduce((output, { value: value, name: name })=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...output,
            [name]: $a6145919a3771254$var$isBooleanString(value) ? $a6145919a3771254$var$stringToBoolean(value) : value
        }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});

});

parcelRegister("lgZ6q", function(module, exports) {

$parcel$export(module.exports, "default", () => $328d775330990290$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f9d37c9f83b03ee098101c71c0c1f0cb>>
 * @relayHash b74b1e4a61970dacd09002c88be4d230
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5234c11c147186bc02da7b03a8d6b04a191accdffc6496f741bc7350f3d774b

var $fjldt = parcelRequire("fjldt");

var $gY76A = parcelRequire("gY76A");

var $5ykrX = parcelRequire("5ykrX");

var $ggSVP = parcelRequire("ggSVP");

var $knfEI = parcelRequire("knfEI");

var $5qm7M = parcelRequire("5qm7M");

var $l8ssf = parcelRequire("l8ssf");

var $dttgK = parcelRequire("dttgK");

var $adKYy = parcelRequire("adKYy");

var $iLxt4 = parcelRequire("iLxt4");

var $hBvdF = parcelRequire("hBvdF");
const $328d775330990290$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterAri"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isNotFilterFetch"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v8 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v9 = {
        "kind": "ScalarField",
        "name": "key"
    }, v10 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v11 = {
        "kind": "ScalarField",
        "name": "id"
    }, v12 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v13 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v14 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v15 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v14 /*: any*/ ,
            v11 /*: any*/ 
        ]
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            v13 /*: any*/ ,
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v15 /*: any*/ ,
                    v11 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v17 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "name"
    }, v19 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v20 = {
        "kind": "ScalarField",
        "name": "type"
    }, v21 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v22 = {
        "kind": "ScalarField",
        "name": "value"
    }, v23 = [
        v22 /*: any*/ ,
        v11 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v24 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v25 = {
        "kind": "ClientExtension",
        "selections": [
            v24 /*: any*/ 
        ]
    }, v26 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v27 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v28 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v29 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v30 = {
        "kind": "ScalarField",
        "name": "text"
    }, v31 = {
        "kind": "InlineFragment",
        "selections": [
            v30 /*: any*/ ,
            v18 /*: any*/ ,
            v25 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v32 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v33 = [
        v32 /*: any*/ 
    ], v34 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v11 /*: any*/ 
        ]
    }, v35 = [
        v34 /*: any*/ 
    ], v36 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v37 = {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            v22 /*: any*/ 
        ]
    }, v38 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v39 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v40 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v41 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v42 = [
        v11 /*: any*/ 
    ], v43 = {
        "kind": "ClientExtension",
        "selections": [
            v19 /*: any*/ 
        ]
    }, v44 = [
        v18 /*: any*/ ,
        v11 /*: any*/ 
    ], v45 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v46 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v47 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v30 /*: any*/ ,
            v11 /*: any*/ 
        ]
    }, v48 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v34 /*: any*/ ,
            v11 /*: any*/ 
        ]
    }, v49 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v50 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v49 /*: any*/ ,
                    v18 /*: any*/ ,
                    v11 /*: any*/ 
                ]
            },
            v11 /*: any*/ 
        ]
    }, v51 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v52 = {
        "kind": "ScalarField",
        "name": "number"
    }, v53 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraNumberFieldFormatConfig",
                "kind": "LinkedField",
                "name": "formatConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "formatStyle"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "formatUnit"
                    }
                ]
            }
        ]
    }, v54 = [
        v12 /*: any*/ ,
        v11 /*: any*/ 
    ], v55 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v56 = [
        {
            "kind": "ScalarField",
            "name": "cursor"
        },
        {
            "kind": "ScalarField",
            "name": "pageNumber"
        },
        {
            "kind": "ScalarField",
            "name": "isCurrent"
        }
    ], v57 = {
        "kind": "ScalarField",
        "name": "displayName"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueTableViewQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "issueTableView_reactIssueTableGadgets"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v7 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "issueTableViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "after",
                                    "variableName": "after"
                                },
                                v8 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "fieldSetsInput",
                                    "variableName": "fieldSetsInput"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "first",
                                    "variableName": "first"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "issueSearchInput",
                                    "variableName": "issueSearchInput"
                                }
                            ],
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearchStable",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isResolved"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "ids",
                                                            "value": [
                                                                "status"
                                                            ]
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueFieldConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldsById",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v12 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        v11 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldsById(ids:[\"status\"])"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canBeExported"
                                                },
                                                {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v17 /*: any*/ ,
                                                                v11 /*: any*/ 
                                                            ]
                                                        },
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v18 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isHighlightedIssueRow"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v12 /*: any*/ ,
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 500
                                                }
                                            ],
                                            "concreteType": "JiraIssueFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v20 /*: any*/ ,
                                                                v21 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fields",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v12 /*: any*/ ,
                                                                                        v13 /*: any*/ ,
                                                                                        v20 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "TypeDiscriminator",
                                                                                            "abstractKey": "__isJiraIssueField"
                                                                                        },
                                                                                        v11 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraAffectedServiceConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedAffectedServicesConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAffectedServiceEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAffectedService",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "serviceId"
                                                                                                                        },
                                                                                                                        v18 /*: any*/ ,
                                                                                                                        v11 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraAffectedServicesField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v18 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraCascadingOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "cascadingOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "parentOptionValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v23 /*: any*/ 
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "childOptionValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v23 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v25 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraCascadingSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v18 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v26 /*: any*/ ,
                                                                                                            "concreteType": "JiraComponentConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedComponentsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponent",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                v28 /*: any*/ ,
                                                                                                                                v11 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                        },
                                                                                                        v25 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraComponentsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v29 /*: any*/ ,
                                                                                                        v18 /*: any*/ ,
                                                                                                        v25 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraDateTimePickerField"
                                                                                                },
                                                                                                v31 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCommentSummary",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "commentSummary",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "canAddComment"
                                                                                                                },
                                                                                                                v32 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCommentSummaryField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v18 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "uri"
                                                                                                        },
                                                                                                        v25 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraUrlField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v18 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": v33 /*: any*/ 
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": v35 /*: any*/ 
                                                                                                                },
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": v35 /*: any*/ 
                                                                                                                },
                                                                                                                v11 /*: any*/ ,
                                                                                                                v36 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v25 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v18 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOption",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v11 /*: any*/ ,
                                                                                                                                v22 /*: any*/ ,
                                                                                                                                v36 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v25 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v18 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        v37 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v25 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraCheckboxesField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v18 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraUserConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedUsersConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraUserEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v12 /*: any*/ ,
                                                                                                                                v38 /*: any*/ ,
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                v39 /*: any*/ ,
                                                                                                                                v11 /*: any*/ ,
                                                                                                                                v40 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "email"
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "type": "AtlassianAccountUser"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v25 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectUserPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v18 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraTeamView",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedTeam",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "jiraSuppliedId"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "jiraSuppliedName"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v25 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraTeamViewField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "timeTrackingField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v11 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "concreteType": "JiraEstimate",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "originalEstimate",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "timeInSeconds"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraTimeTrackingSettings",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "timeTrackingSettings",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "workingHoursPerDay"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "workingDaysPerWeek"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "defaultFormat"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "defaultUnit"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v13 /*: any*/ ,
                                                                                                                        v18 /*: any*/ ,
                                                                                                                        v20 /*: any*/ ,
                                                                                                                        v25 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v11 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v18 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "alias": "label",
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "value"
                                                                                                                },
                                                                                                                v11 /*: any*/ ,
                                                                                                                v27 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v25 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraRadioSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v18 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v26 /*: any*/ ,
                                                                                                            "concreteType": "JiraVersionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedVersionsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraVersion",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v11 /*: any*/ ,
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                v28 /*: any*/ ,
                                                                                                                                v41 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                        },
                                                                                                        v25 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleVersionPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v18 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": v42 /*: any*/ 
                                                                                                        },
                                                                                                        {
                                                                                                            "args": v26 /*: any*/ ,
                                                                                                            "concreteType": "JiraGoalConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedGoals",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGoalEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraGoal",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v11 /*: any*/ ,
                                                                                                                                v9 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v43 /*: any*/ 
                                                                                                            ],
                                                                                                            "storageKey": "selectedGoals(first:1000)"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ClientExtension",
                                                                                                            "selections": [
                                                                                                                v19 /*: any*/ ,
                                                                                                                v24 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraGoalsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v18 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v26 /*: any*/ ,
                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "confluenceRemoteIssueLinks",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v11 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "href"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v32 /*: any*/ 
                                                                                                            ],
                                                                                                            "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                                        },
                                                                                                        v25 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraConfluenceRemoteIssueLinksField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCmdbObjectConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedCmdbObjectsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbObjectEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbObject",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "objectId"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "label"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraCmdbAvatar",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "avatar",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "mediaClientConfig",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "clientId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "fileId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "mediaBaseUrl"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "mediaJwtToken"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "url48"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "QueryError",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "errors",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "message"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraCMDBField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": "componentsOld",
                                                                                                            "concreteType": "JiraComponentConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedComponentsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponent",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v44 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraComponentsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v30 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "date"
                                                                                                },
                                                                                                v18 /*: any*/ ,
                                                                                                v45 /*: any*/ ,
                                                                                                v25 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDatePickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v29 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDateTimePickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraEpic",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "epic",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v9 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "summary"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "color"
                                                                                                        },
                                                                                                        v11 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraEpicLinkField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "renderedFieldHtml"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraFallbackField"
                                                                                        },
                                                                                        v31 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "statusCategory",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v18 /*: any*/ ,
                                                                                                        v14 /*: any*/ ,
                                                                                                        v11 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusCategoryField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatus",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "status",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v18 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "statusId"
                                                                                                        },
                                                                                                        v15 /*: any*/ ,
                                                                                                        v11 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": v26 /*: any*/ ,
                                                                                                    "concreteType": "JiraLabelConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedLabelsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraLabelEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraLabel",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v18 /*: any*/ ,
                                                                                                                        v34 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "labelId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v32 /*: any*/ 
                                                                                                    ],
                                                                                                    "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                                },
                                                                                                v18 /*: any*/ ,
                                                                                                v25 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraLabelsField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAvatar",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "avatar",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "small"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v18 /*: any*/ ,
                                                                                                        v11 /*: any*/ ,
                                                                                                        v46 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "parentIssue",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v9 /*: any*/ ,
                                                                                                        v47 /*: any*/ ,
                                                                                                        v11 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentIssue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v9 /*: any*/ ,
                                                                                                                v48 /*: any*/ ,
                                                                                                                v50 /*: any*/ ,
                                                                                                                v47 /*: any*/ ,
                                                                                                                v11 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentIssue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v9 /*: any*/ ,
                                                                                                                v48 /*: any*/ ,
                                                                                                                v50 /*: any*/ ,
                                                                                                                v47 /*: any*/ ,
                                                                                                                v11 /*: any*/ ,
                                                                                                                v10 /*: any*/ ,
                                                                                                                v51 /*: any*/ ,
                                                                                                                {
                                                                                                                    "args": [
                                                                                                                        {
                                                                                                                            "kind": "Literal",
                                                                                                                            "name": "ids",
                                                                                                                            "value": [
                                                                                                                                "summary",
                                                                                                                                "issuetype",
                                                                                                                                "status"
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fieldsById",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v12 /*: any*/ ,
                                                                                                                                        v11 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v13 /*: any*/ ,
                                                                                                                                                v30 /*: any*/ 
                                                                                                                                            ],
                                                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v13 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "issueType",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v46 /*: any*/ ,
                                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                                        v49 /*: any*/ ,
                                                                                                                                                        v17 /*: any*/ ,
                                                                                                                                                        v11 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "JiraIssueTypeField"
                                                                                                                                        },
                                                                                                                                        v16 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v18 /*: any*/ ,
                                                                                                        v25 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraParentIssueField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraPriority",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "priority",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v18 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "iconUrl"
                                                                                                        },
                                                                                                        v11 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "priorityId"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v18 /*: any*/ ,
                                                                                                v25 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraPriorityField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraProject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "project",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v18 /*: any*/ ,
                                                                                                        v9 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraAvatar",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "avatar",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "large"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v11 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "projectId"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraProjectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraResolution",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "resolution",
                                                                                                    "plural": false,
                                                                                                    "selections": v44 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraResolutionField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSprintConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedSprintsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSprintEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSprint",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v11 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "sprintId"
                                                                                                                        },
                                                                                                                        v18 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "state"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "endDate"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v18 /*: any*/ ,
                                                                                                v25 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSprintField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v12 /*: any*/ ,
                                                                                                        v38 /*: any*/ ,
                                                                                                        v39 /*: any*/ ,
                                                                                                        v18 /*: any*/ ,
                                                                                                        v11 /*: any*/ ,
                                                                                                        v40 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v18 /*: any*/ ,
                                                                                                v45 /*: any*/ ,
                                                                                                v25 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v26 /*: any*/ ,
                                                                                                    "concreteType": "JiraVersionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedVersionsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraVersionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v18 /*: any*/ ,
                                                                                                                        v11 /*: any*/ ,
                                                                                                                        v41 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraMultipleVersionPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraRichText",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "richText",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraADF",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "adfValue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "json"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraRichTextField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraServiceManagementRequestType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "requestType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v18 /*: any*/ ,
                                                                                                        v49 /*: any*/ ,
                                                                                                        v11 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraServiceManagementRequestTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Literal",
                                                                                                            "name": "first",
                                                                                                            "value": 1
                                                                                                        }
                                                                                                    ],
                                                                                                    "concreteType": "JiraIssueLinkConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueLinkConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v32 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueLinkEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLink",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issue",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v51 /*: any*/ ,
                                                                                                                                v9 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "args": [
                                                                                                                                        {
                                                                                                                                            "kind": "Literal",
                                                                                                                                            "name": "ids",
                                                                                                                                            "value": [
                                                                                                                                                "statusCategory"
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "fieldsById",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v12 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                            "selections": [
                                                                                                                                                                v15 /*: any*/ 
                                                                                                                                                            ],
                                                                                                                                                            "type": "JiraStatusCategoryField"
                                                                                                                                                        },
                                                                                                                                                        v11 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                                },
                                                                                                                                v11 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "relationName"
                                                                                                                        },
                                                                                                                        v11 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "issueLinkConnection(first:1)"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueLinkField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isStoryPointField"
                                                                                                },
                                                                                                v52 /*: any*/ ,
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": [
                                                                                                        v52 /*: any*/ ,
                                                                                                        v53 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        v52 /*: any*/ ,
                                                                                                        v18 /*: any*/ ,
                                                                                                        v53 /*: any*/ ,
                                                                                                        v25 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v25 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraNumberField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v18 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraGroupConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedGroupsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGroupEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraGroup",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v11 /*: any*/ ,
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "groupId"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v25 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleGroupPickerField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraFlag",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "flag",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isFlagged"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraFlagField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraWatch",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "watch",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "count"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isWatching"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraWatchesField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "components",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "componentId"
                                                                                                                        },
                                                                                                                        v11 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraComponentsField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraUserConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "users",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraUserEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v12 /*: any*/ ,
                                                                                                                        v38 /*: any*/ ,
                                                                                                                        v11 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraMultipleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraVersion",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "version",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v41 /*: any*/ ,
                                                                                                        v11 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraSingleVersionPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedValue",
                                                                                                    "plural": false,
                                                                                                    "selections": v54 /*: any*/ 
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fieldOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v36 /*: any*/ ,
                                                                                                        v11 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraSingleSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSelectableValueConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedValues",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSelectableValueEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v54 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraMultipleSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOption",
                                                                                                    "plural": false,
                                                                                                    "selections": v42 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraRadioSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOptions",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                v37 /*: any*/ ,
                                                                                                                v43 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraCheckboxesField"
                                                                                        },
                                                                                        v43 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v33 /*: any*/ 
                                                                        }
                                                                    ]
                                                                },
                                                                v43 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "fieldSets(first:500)"
                                        },
                                        v43 /*: any*/ 
                                    ]
                                },
                                v55 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "totalIssueSearchResultCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isCappingIssueSearchResult"
                                },
                                {
                                    "concreteType": "JiraIssueNavigatorPageInfo",
                                    "kind": "LinkedField",
                                    "name": "issueNavigatorPageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "firstIssuePosition"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "lastIssuePosition"
                                        }
                                    ]
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "maxCursors",
                                            "value": 7
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "pageSize",
                                            "variableName": "first"
                                        }
                                    ],
                                    "concreteType": "JiraPageCursors",
                                    "kind": "LinkedField",
                                    "name": "pageCursors",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "first",
                                            "plural": false,
                                            "selections": v56 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "around",
                                            "plural": true,
                                            "selections": v56 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "last",
                                            "plural": false,
                                            "selections": v56 /*: any*/ 
                                        }
                                    ]
                                },
                                v43 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "fieldSetIds",
                                    "variableName": "fieldSetIds"
                                }
                            ],
                            "concreteType": "JiraIssueSearchFieldSetConnection",
                            "kind": "LinkedField",
                            "name": "fieldSetsById",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueSearchFieldSet",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v21 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v57 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "jqlTerm"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isSortable"
                                                },
                                                {
                                                    "concreteType": "JiraFieldSetPreferences",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSetPreferences",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "width"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldMetadataConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldsMetadata",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldMetadataEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueSearchMetadataField",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "canBeConfigured"
                                                                                },
                                                                                v13 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isPlaceHolderField"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraFieldType",
                                                    "kind": "LinkedField",
                                                    "name": "fieldType",
                                                    "plural": false,
                                                    "selections": [
                                                        v57 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v32 /*: any*/ ,
                                v43 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "isNotFilterFetch",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "filterAri"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        v12 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v55 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b5234c11c147186bc02da7b03a8d6b04a191accdffc6496f741bc7350f3d774b",
            "metadata": {},
            "name": "issueTableViewQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $dttgK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $adKYy.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $fjldt.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $5qm7M.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": (0, $iLxt4.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $l8ssf.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": (0, $5ykrX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": (0, $ggSVP.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $knfEI.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $hBvdF.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $gY76A.default)
            }
        }
    };
}();
$328d775330990290$var$node.hash = "1f70c31f4e1c3b7345f8eebe7535773a";
var $328d775330990290$export$2e2bcd8739ae039 = $328d775330990290$var$node;

});

parcelRegister("8rq2P", function(module, exports) {

$parcel$export(module.exports, "loadQueryWithUserPrefs", () => $3de2b9db429d32f1$export$700e212b8b5c678f);

var $8Uumt = parcelRequire("8Uumt");

var $5yJb9 = parcelRequire("5yJb9");

var $kipqU = parcelRequire("kipqU");

var $2mSjU = parcelRequire("2mSjU");
async function $3de2b9db429d32f1$export$700e212b8b5c678f({ filterId: filterId, columnNames: columnNames, num: num, sortField: sortField, sortDirection: sortDirection }, query, cloudId, activationId, fetchPolicy = 'store-or-network', jql) {
    const { variables: variables } = await (0, $2mSjU.transformToVariables)({
        userPrefs: {
            filterId: filterId,
            columnNames: columnNames,
            num: num,
            sortField: sortField,
            sortDirection: sortDirection
        },
        cloudId: cloudId,
        activationId: activationId,
        jql: jql
    });
    const queryReference = (0, $8Uumt.loadQuery)((0, $5yJb9.default)(), query, variables, {
        fetchPolicy: fetchPolicy
    });
    if (false && queryReference.id != null) await (0, $kipqU.QueryPromisesMap).get(queryReference.id);
    return queryReference;
}

});
parcelRegister("2mSjU", function(module, exports) {

$parcel$export(module.exports, "transformToVariables", () => $1eea58ad38e5fdd1$export$a5cefa50115212b3);

var $6oLWS = parcelRequire("6oLWS");

var $czfFt = parcelRequire("czfFt");

var $t3Q07 = parcelRequire("t3Q07");

var $796ok = parcelRequire("796ok");



const $1eea58ad38e5fdd1$export$a5cefa50115212b3 = async ({ userPrefs: userPrefs, cloudId: cloudId, activationId: activationId, jql: jql, fetchIssueTableJqlFields: fetchIssueTableJqlFields })=>{
    const { filterId: filterId, columnNames: columnNames, num: num, sortField: sortField, sortDirection: sortDirection, showResolved: showResolved } = userPrefs;
    const filterAri = !jql && filterId ? (0, $6oLWS.JiraFilterAri).create({
        filterId: filterId,
        siteId: cloudId,
        activationId: activationId
    }).toString() : '';
    const variables = {
        cloudId: cloudId,
        issueSearchInput: {
            ...jql ? {
                jql: jql
            } : {
                filterId: filterId
            }
        },
        after: null,
        first: num,
        fieldSetIds: columnNames,
        amountOfColumns: (0, $czfFt.MAX_COLUMNS),
        shouldQueryFieldSetsById: true,
        fieldSetsInput: {
            fieldSetIds: columnNames
        },
        isNotFilterFetch: !filterAri,
        filterAri: filterAri
    };
    let fieldToJqlTermMap = new Map();
    if (!sortField || !sortDirection || ![
        'ASC',
        'DESC'
    ].includes(sortDirection)) return {
        variables: variables,
        fieldToJqlTermMap: fieldToJqlTermMap
    };
    let jqlToModify = jql;
    if (fetchIssueTableJqlFields && !jqlToModify && filterAri) {
        const result = await fetchIssueTableJqlFields(filterAri, variables.fieldSetIds, cloudId);
        fieldToJqlTermMap = result.fieldToJqlTermMap;
        jqlToModify = result.searchJql;
    }
    if (!jqlToModify) return {
        variables: variables,
        fieldToJqlTermMap: fieldToJqlTermMap
    };
    // This pulls in over 600KB of code, and if it's not deferred it's eagerly loaded as
    // part of the main jira-spa route map
    const [{ JqlUtils: JqlUtils }, { default: removeFieldClauseFromJql }, { default: findClauseInAst }] = await Promise.all([
        (parcelRequire("lEsjw")),
        (parcelRequire("60ZTe")),
        (parcelRequire("j4Vmz"))
    ]);
    const jqlUtils = new JqlUtils();
    const jqlTermForSortField = (0, $796ok.getJqlTermForField)(sortField, fieldToJqlTermMap);
    const modifiedJql = jqlUtils.jql(jqlToModify);
    const oldPrimarySortField = modifiedJql.getPrimarySortField();
    if (oldPrimarySortField) {
        // if the sort field in original filter jql is using alias, we need to pass all possible aliases in
        // so that jqlUtils knows to replace it instead of append it as a new field
        const aliases = (0, $t3Q07.getAliasesForField)(jqlTermForSortField, fieldToJqlTermMap);
        // Sometimes, oldPrimarySortField from the JQL has
        // quotations around it which we should include
        const inclusiveAliases = Array.from(new Set([
            ...aliases,
            oldPrimarySortField
        ]));
        modifiedJql.setPrimarySortField(jqlTermForSortField, sortDirection, inclusiveAliases);
    } else modifiedJql.setPrimarySortField(jqlTermForSortField, sortDirection, []);
    let finalJql = modifiedJql.jqlString;
    if (showResolved) {
        const jast = modifiedJql.jast;
        if (jast) {
            const statusClause = findClauseInAst(jast, 'statusCategory');
            if (statusClause) finalJql = removeFieldClauseFromJql(jast, statusClause);
        }
    }
    return {
        variables: {
            ...variables,
            issueSearchInput: {
                jql: finalJql
            }
        },
        fieldToJqlTermMap: fieldToJqlTermMap
    };
};

});
parcelRegister("czfFt", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $7f8ee02f08da8eac$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $7f8ee02f08da8eac$export$d57b6b390e78d90f);
$parcel$export(module.exports, "SORT_ASC", () => $7f8ee02f08da8eac$export$88956207daf9a17e);
$parcel$export(module.exports, "SORT_DESC", () => $7f8ee02f08da8eac$export$bc14f97913aaf2a);
$parcel$export(module.exports, "SORT_NONE", () => $7f8ee02f08da8eac$export$9c424bf3e8ffe64e);
$parcel$export(module.exports, "MODIFY_COLUMNS", () => $7f8ee02f08da8eac$export$1f921c78ce6d243c);
$parcel$export(module.exports, "REORDER_COLUMNS", () => $7f8ee02f08da8eac$export$83371d6c41a974aa);
$parcel$export(module.exports, "RESTORE_COLUMNS", () => $7f8ee02f08da8eac$export$3bfe53b79fc4f6ed);
$parcel$export(module.exports, "MOVE_COLUMN_FIRST", () => $7f8ee02f08da8eac$export$957d455bb65919d8);
$parcel$export(module.exports, "MOVE_COLUMN_LEFT", () => $7f8ee02f08da8eac$export$2082861c970802b0);
$parcel$export(module.exports, "MOVE_COLUMN_RIGHT", () => $7f8ee02f08da8eac$export$21847d308b0769ad);
$parcel$export(module.exports, "MOVE_COLUMN_LAST", () => $7f8ee02f08da8eac$export$c32913bc261af82d);
$parcel$export(module.exports, "BORDER_WIDTH", () => $7f8ee02f08da8eac$export$e2bd4c1faded7921);
$parcel$export(module.exports, "HEADER_HEIGHT", () => $7f8ee02f08da8eac$export$cdb7fd9d999c7168);
$parcel$export(module.exports, "ROW_HEIGHT", () => $7f8ee02f08da8eac$export$88e6c5bab2ff80e8);
$parcel$export(module.exports, "COLUMN_ID_MEATBALL_MENU", () => $7f8ee02f08da8eac$export$de4c02b525d877fa);
$parcel$export(module.exports, "COLUMN_ID_EXPAND_BUTTON", () => $7f8ee02f08da8eac$export$c3266da279aa6b84);
$parcel$export(module.exports, "COLUMN_ID_CHECKBOX", () => $7f8ee02f08da8eac$export$66b2a4a5f67468ac);
$parcel$export(module.exports, "COLUMN_ID_INTERNAL_COLUMN", () => $7f8ee02f08da8eac$export$b4e9105b7f5f1b0f);
$parcel$export(module.exports, "ACTION_COLUMNS", () => $7f8ee02f08da8eac$export$3dbdc5c16825be4d);
$parcel$export(module.exports, "EXPAND_BUTTON_WIDTH", () => $7f8ee02f08da8eac$export$a1c171a82c45d53f);
$parcel$export(module.exports, "CREATE_CHILD_BUTTON_WIDTH", () => $7f8ee02f08da8eac$export$43ff8c492b8a2e1b);
$parcel$export(module.exports, "EXPAND_CELL_PADDING", () => $7f8ee02f08da8eac$export$9c5dd6078b37aac2);
$parcel$export(module.exports, "DEPTH_WIDTH", () => $7f8ee02f08da8eac$export$a8273d7d48e89fce);
$parcel$export(module.exports, "MAX_COLUMNS", () => $7f8ee02f08da8eac$export$7ec4af037f372df4);
$parcel$export(module.exports, "CHILD_QUERY_PAGE_SIZE", () => $7f8ee02f08da8eac$export$d2372dfbd4e91a11);
$parcel$export(module.exports, "COLUMN_TYPE_PARENT_LINK", () => $7f8ee02f08da8eac$export$1adf7afff96bbf16);
$parcel$export(module.exports, "MINIMUM_COLUMN_WIDTH_COMPACT", () => $7f8ee02f08da8eac$export$10016003aa27fa67);
$parcel$export(module.exports, "MINIMUM_COLUMN_WIDTH", () => $7f8ee02f08da8eac$export$5575b9e0ed3ff59f);
$parcel$export(module.exports, "DEFAULT_COLUMN_WIDTH", () => $7f8ee02f08da8eac$export$7c3f559e2ca95fa);
$parcel$export(module.exports, "MAXIMUM_COLUMN_WIDTH", () => $7f8ee02f08da8eac$export$e1a42c2fefb5af25);
$parcel$export(module.exports, "SINGLE_LINE_ROW_HEIGHT_MINIMUM_COLUMN_WIDTH", () => $7f8ee02f08da8eac$export$54fb99171fb48426);
$parcel$export(module.exports, "COLUMN_WIDTH_TEXT_LONG", () => $7f8ee02f08da8eac$export$bfe09a9186b98f8f);
$parcel$export(module.exports, "COLUMN_WIDTH_TEXT_SHORT", () => $7f8ee02f08da8eac$export$f2540f34b796306d);
$parcel$export(module.exports, "COLUMN_WIDTH_TEXT_SUMMARY", () => $7f8ee02f08da8eac$export$954afb0fcf5a326);
$parcel$export(module.exports, "COLUMN_OPERATION_REORDER", () => $7f8ee02f08da8eac$export$93758649595b2d58);
$parcel$export(module.exports, "COLUMN_OPERATION_RESIZE", () => $7f8ee02f08da8eac$export$cad8c6a0b6e78898);
$parcel$export(module.exports, "INSERT_COLUMN_BUTTON_Y_OFFSET", () => $7f8ee02f08da8eac$export$5252387dc65db584);
$parcel$export(module.exports, "COLUMN_RESIZE_HANDLE_FULL_HEIGHT", () => $7f8ee02f08da8eac$export$754b76ac8fa63350);
$parcel$export(module.exports, "COLUMN_RESIZE_HANDLE_HEADER_ONLY", () => $7f8ee02f08da8eac$export$fa5c7dad7ee16383);
$parcel$export(module.exports, "ROW_OPERATION_REORDER", () => $7f8ee02f08da8eac$export$4e8abe16cd1126dd);
$parcel$export(module.exports, "DENSITY_COMPACT", () => $7f8ee02f08da8eac$export$6c0a5a77457ca62);
$parcel$export(module.exports, "DENSITY_FULL", () => $7f8ee02f08da8eac$export$119d8ab9a5bc4b2);
$parcel$export(module.exports, "LAZY_EDITABILITY_LOADER_CONTAINER_SCOPE", () => $7f8ee02f08da8eac$export$9ef77944c441ad07);
$parcel$export(module.exports, "LAZY_MEDIA_VIEW_CONTEXT_LOADER_CONTAINER_SCOPE", () => $7f8ee02f08da8eac$export$c1f680390b97c9e1);
$parcel$export(module.exports, "CHILD_ITEMS_EXPERIENCE", () => $7f8ee02f08da8eac$export$e03155205bf92428);
$parcel$export(module.exports, "CHILD_ITEMS_LOAD_MORE_EXPERIENCE", () => $7f8ee02f08da8eac$export$311c64c0d94dcdf3);
$parcel$export(module.exports, "GROUPED_ITEMS_EXPERIENCE", () => $7f8ee02f08da8eac$export$f5d215df3c6473e9);
$parcel$export(module.exports, "GROUPED_LOAD_MORE_EXPERIENCE", () => $7f8ee02f08da8eac$export$b4fd503bf7cccacd);
$parcel$export(module.exports, "INLINE_ISSUE_CREATE_EXPERIENCE", () => $7f8ee02f08da8eac$export$70f80a241e016093);
$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $7f8ee02f08da8eac$export$f7109619a5e9e0d6);
$parcel$export(module.exports, "MAKE_CHILD", () => $7f8ee02f08da8eac$export$5eb61e3ff74a4f58);
$parcel$export(module.exports, "REORDER_ABOVE", () => $7f8ee02f08da8eac$export$9213b5774112217f);
$parcel$export(module.exports, "REORDER_BELOW", () => $7f8ee02f08da8eac$export$118b06a03e2c672f);
$parcel$export(module.exports, "INSTRUCTION_BLOCKED", () => $7f8ee02f08da8eac$export$71b8539e20744dab);
$parcel$export(module.exports, "SUBTASK_HIERARCHY_LEVEL", () => $7f8ee02f08da8eac$export$5b388ccfa29be01);
$parcel$export(module.exports, "COLUMN_PICKER_CONFIGURATION_CONTAINER", () => $7f8ee02f08da8eac$export$f6d7582f33b86010);
$parcel$export(module.exports, "COLUMN_PICKER_ADD_COLUMN_CONTAINER", () => $7f8ee02f08da8eac$export$f92486d03c064eac);
$parcel$export(module.exports, "MAX_LINE_WRAP_OLD", () => $7f8ee02f08da8eac$export$139bffb2a576e8c0);
$parcel$export(module.exports, "MAX_LINE_WRAP_NEW", () => $7f8ee02f08da8eac$export$3b696b0ac06c2cc4);
$parcel$export(module.exports, "HIGHLIGHT_LINGER_DURATION_MS", () => $7f8ee02f08da8eac$export$6ba5aaedfd1b5319);
$parcel$export(module.exports, "SORT_A_TO_Z", () => $7f8ee02f08da8eac$export$1bc2edb2aa5e8282);
$parcel$export(module.exports, "SORT_Z_TO_A", () => $7f8ee02f08da8eac$export$c7b524b6c48f8273);
$parcel$export(module.exports, "SORT_LOWEST_TO_HIGHEST", () => $7f8ee02f08da8eac$export$9c60c93d5e95e80f);
$parcel$export(module.exports, "SORT_HIGHEST_TO_LOWEST", () => $7f8ee02f08da8eac$export$476f4bdd6eba4fb2);
$parcel$export(module.exports, "SORT_OLDEST_TO_NEWEST", () => $7f8ee02f08da8eac$export$fbcac9f513cf13f4);
$parcel$export(module.exports, "SORT_NEWEST_TO_OLDEST", () => $7f8ee02f08da8eac$export$d3c0241ce8ae9a73);
$parcel$export(module.exports, "DUPLICATE_FIELD_EDIT_WIDTH", () => $7f8ee02f08da8eac$export$de4b89eec2f02226);

var $65VLO = parcelRequire("65VLO");
const $7f8ee02f08da8eac$export$b8b9d90f9e5bd72b = 'jiraNativeIssueTable';
const $7f8ee02f08da8eac$export$d57b6b390e78d90f = 'empanada';
const $7f8ee02f08da8eac$export$88956207daf9a17e = 'ASC';
const $7f8ee02f08da8eac$export$bc14f97913aaf2a = 'DESC';
const $7f8ee02f08da8eac$export$9c424bf3e8ffe64e = 'NONE';
const $7f8ee02f08da8eac$export$1f921c78ce6d243c = 'MODIFY_COLUMNS';
const $7f8ee02f08da8eac$export$83371d6c41a974aa = 'REORDER_COLUMNS';
const $7f8ee02f08da8eac$export$3bfe53b79fc4f6ed = 'RESTORE_COLUMNS';
const $7f8ee02f08da8eac$export$957d455bb65919d8 = 'MOVE_COLUMN_FIRST';
const $7f8ee02f08da8eac$export$2082861c970802b0 = 'MOVE_COLUMN_LEFT';
const $7f8ee02f08da8eac$export$21847d308b0769ad = 'MOVE_COLUMN_RIGHT';
const $7f8ee02f08da8eac$export$c32913bc261af82d = 'MOVE_COLUMN_LAST';
const $7f8ee02f08da8eac$export$e2bd4c1faded7921 = '1px';
const $7f8ee02f08da8eac$export$cdb7fd9d999c7168 = 40;
const $7f8ee02f08da8eac$export$88e6c5bab2ff80e8 = 40;
const $7f8ee02f08da8eac$export$de4c02b525d877fa = '__issuetable_internal_meatball';
const $7f8ee02f08da8eac$export$c3266da279aa6b84 = '__issuetable_internal_expand_button';
const $7f8ee02f08da8eac$export$66b2a4a5f67468ac = '__issuetable_internal_checkbox';
const $7f8ee02f08da8eac$export$b4e9105b7f5f1b0f = '__issuetable_internal';
const $7f8ee02f08da8eac$export$3dbdc5c16825be4d = [
    $7f8ee02f08da8eac$export$c3266da279aa6b84,
    $7f8ee02f08da8eac$export$de4c02b525d877fa,
    $7f8ee02f08da8eac$export$66b2a4a5f67468ac,
    (0, $65VLO.COLUMN_ID_MERGED_COLUMN)
];
const $7f8ee02f08da8eac$export$a1c171a82c45d53f = 24;
const $7f8ee02f08da8eac$export$43ff8c492b8a2e1b = 24;
const $7f8ee02f08da8eac$export$9c5dd6078b37aac2 = 16;
const $7f8ee02f08da8eac$export$a8273d7d48e89fce = 24;
const $7f8ee02f08da8eac$export$7ec4af037f372df4 = 500;
const $7f8ee02f08da8eac$export$d2372dfbd4e91a11 = 50;
const $7f8ee02f08da8eac$export$ce9e2d7c178a9557 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $7f8ee02f08da8eac$export$1adf7afff96bbf16 = 'com.atlassian.jpo:jpo-custom-field-parent';
const $7f8ee02f08da8eac$export$c1d348661674e922 = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $7f8ee02f08da8eac$export$67082d449d5ec91 = 'com.atlassian.servicedesk:sd-request-feedback';
const $7f8ee02f08da8eac$export$145a4a20f394acf9 = 'com.atlassian.servicedesk.sentiment:sd-sentiment';
const $7f8ee02f08da8eac$export$55628b4c44d1522a = 'NATURAL_LANGUAGE_TO_JQL';
const $7f8ee02f08da8eac$export$10016003aa27fa67 = 40; // 2 x 8px cell padding + 24px icon size
const $7f8ee02f08da8eac$export$5575b9e0ed3ff59f = 69; // 2 x 8px cell padding + 2 x 24px icon size + 4px gap + 1px border
const $7f8ee02f08da8eac$export$7c3f559e2ca95fa = 170;
const $7f8ee02f08da8eac$export$e1a42c2fefb5af25 = 999;
const $7f8ee02f08da8eac$export$54fb99171fb48426 = 80;
const $7f8ee02f08da8eac$export$a194aa0e243a27f9 = 156;
const $7f8ee02f08da8eac$export$87a3548b97ce2540 = 136;
const $7f8ee02f08da8eac$export$d182a35496b19fb4 = 112;
const $7f8ee02f08da8eac$export$4fd6711c21931f5b = 116;
const $7f8ee02f08da8eac$export$9b72110b9a7c0a39 = 102;
const $7f8ee02f08da8eac$export$54c15048528650a8 = 84;
const $7f8ee02f08da8eac$export$7ed05c26fe24a805 = 200;
const $7f8ee02f08da8eac$export$bfe09a9186b98f8f = 400;
const $7f8ee02f08da8eac$export$f2540f34b796306d = 300;
const $7f8ee02f08da8eac$export$954afb0fcf5a326 = 450;
const $7f8ee02f08da8eac$export$93758649595b2d58 = 'reorder';
const $7f8ee02f08da8eac$export$cad8c6a0b6e78898 = 'resize';
const $7f8ee02f08da8eac$export$5252387dc65db584 = -16;
const $7f8ee02f08da8eac$export$754b76ac8fa63350 = 'FULL_HEIGHT';
const $7f8ee02f08da8eac$export$fa5c7dad7ee16383 = 'HEADER_ONLY';
const $7f8ee02f08da8eac$export$4e8abe16cd1126dd = 'rowReorder';
const $7f8ee02f08da8eac$export$6c0a5a77457ca62 = 'COMPACT';
const $7f8ee02f08da8eac$export$119d8ab9a5bc4b2 = 'FULL';
const $7f8ee02f08da8eac$export$9ef77944c441ad07 = 'LAZY_EDITABILITY_LOADER_CONTAINER_SCOPE';
const $7f8ee02f08da8eac$export$c1f680390b97c9e1 = 'LAZY_MEDIA_VIEW_CONTEXT_LOADER_CONTAINER_SCOPE';
const $7f8ee02f08da8eac$export$e03155205bf92428 = 'loadChildItems';
const $7f8ee02f08da8eac$export$311c64c0d94dcdf3 = 'loadMoreChildItems';
const $7f8ee02f08da8eac$export$f5d215df3c6473e9 = 'loadGroupChildren';
const $7f8ee02f08da8eac$export$b4fd503bf7cccacd = 'loadMoreGroupedItems';
const $7f8ee02f08da8eac$export$70f80a241e016093 = 'createIssue';
const $7f8ee02f08da8eac$export$f7109619a5e9e0d6 = 'jira-native-issue-table';
const $7f8ee02f08da8eac$export$5eb61e3ff74a4f58 = 'make-child';
const $7f8ee02f08da8eac$export$9213b5774112217f = 'reorder-above';
const $7f8ee02f08da8eac$export$118b06a03e2c672f = 'reorder-below';
const $7f8ee02f08da8eac$export$71b8539e20744dab = 'instruction-blocked';
const $7f8ee02f08da8eac$export$5b388ccfa29be01 = -1;
const $7f8ee02f08da8eac$export$f6d7582f33b86010 = 'COLUMN_PICKER_CONFIGURATION_CONTAINER';
const $7f8ee02f08da8eac$export$f92486d03c064eac = 'COLUMN_PICKER_ADD_COLUMN_CONTAINER';
const $7f8ee02f08da8eac$export$139bffb2a576e8c0 = 2;
const $7f8ee02f08da8eac$export$3b696b0ac06c2cc4 = 1;
const $7f8ee02f08da8eac$export$6ba5aaedfd1b5319 = 2000;
const $7f8ee02f08da8eac$export$1bc2edb2aa5e8282 = 'a_to_z';
const $7f8ee02f08da8eac$export$c7b524b6c48f8273 = 'z_to_a';
const $7f8ee02f08da8eac$export$9c60c93d5e95e80f = 'lowest_to_highest';
const $7f8ee02f08da8eac$export$476f4bdd6eba4fb2 = 'highest_to_lowest';
const $7f8ee02f08da8eac$export$fbcac9f513cf13f4 = 'oldest_to_newest';
const $7f8ee02f08da8eac$export$d3c0241ce8ae9a73 = 'newest_to_oldest';
const $7f8ee02f08da8eac$export$de4b89eec2f02226 = 270;

});
parcelRegister("65VLO", function(module, exports) {

$parcel$export(module.exports, "KNOWN_COLUMN_TYPES", () => $1fec13ea3747c865$export$bbc2e8c301f97f97);
$parcel$export(module.exports, "COLUMN_ID_EXPAND_BUTTON", () => $1fec13ea3747c865$export$c3266da279aa6b84);
$parcel$export(module.exports, "COLUMN_ID_CHECKBOX", () => $1fec13ea3747c865$export$66b2a4a5f67468ac);
$parcel$export(module.exports, "COLUMN_ID_MERGED_COLUMN", () => $1fec13ea3747c865$export$3237751348c4f1b);
$parcel$export(module.exports, "MERGED_COLUMN_IDS", () => $1fec13ea3747c865$export$70f30e260ec270f2);
$parcel$export(module.exports, "MERGED_COLUMN_DEFAULT_WIDTH", () => $1fec13ea3747c865$export$6aa1d347deb86ef3);
$parcel$export(module.exports, "NIN_PROJECT_OPERATION_SCOPE", () => $1fec13ea3747c865$export$fae6afe554014a45);
$parcel$export(module.exports, "NIN_GLOBAL_OPERATION_SCOPE", () => $1fec13ea3747c865$export$39ec48f092f3ea90);
const $1fec13ea3747c865$export$bbc2e8c301f97f97 = {
    ASSIGNEE: 'assignee',
    CHECKBOX: '__issuetable_internal_checkbox',
    CHECKBOX_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes',
    DESCRIPTION: 'description',
    ENVIRONMENT: 'environment',
    EXPAND_BUTTON: '__issuetable_internal_expand_button',
    ISSUE_KEY: 'issuekey',
    ISSUE_OPERATIONS: '__issuetable_internal_meatball',
    STATUS: 'status',
    SUMMARY: 'summary',
    ISSUE_TYPE: 'issuetype',
    RESOLUTION: 'resolution',
    PARENT: 'parent',
    LABELS: 'labels',
    COMPONENTS: 'components',
    FIX_VERSIONS: 'fixVersions',
    STATUS_CATEGORY: 'statusCategory',
    PROJECT: 'project',
    READ_ONLY: 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield',
    SPRINT: 'com.pyxis.greenhopper.jira:gh-sprint',
    TEXT: 'com.atlassian.jira.plugin.system.customfieldtypes:textfield',
    EPIC_LINK: 'com.pyxis.greenhopper.jira:gh-epic-link',
    CREATED: 'created',
    RESOLUTION_DATE: 'resolutiondate',
    TEXT_AREA: 'com.atlassian.jira.plugin.system.customfieldtypes:textarea',
    UPDATED: 'updated',
    DUE_DATE: 'duedate',
    REPORTER: 'reporter',
    CREATOR: 'creator',
    PRIORITY: 'priority',
    AFFECTS_VERSIONS: 'versions',
    REQUEST_TYPE: 'com.atlassian.servicedesk:vp-origin',
    NUMBER: 'com.atlassian.jira.plugin.system.customfieldtypes:float',
    STORY_POINT_ESTIMATE: 'com.pyxis.greenhopper.jira:jsw-story-points',
    USER_PICKER: 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker',
    CUSTOM_LABELS: 'com.atlassian.jira.plugin.system.customfieldtypes:labels',
    DATE_TIME: 'com.atlassian.jira.plugin.system.customfieldtypes:datetime',
    URL: 'com.atlassian.jira.plugin.system.customfieldtypes:url',
    SINGLE_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:select',
    MULTI_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect',
    MULTI_USER_PICKER: 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker',
    MERGED_COLUMN: '__issuetable_internal_merged_column',
    TEAM: 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team',
    ORIGINAL_ESTIMATE: 'timeoriginalestimate',
    GOALS: 'com.atlassian.jira.plugin.system.customfieldtypes:goals',
    CASCADING_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect',
    CONFLUENCE_PAGES: 'confluenceRemoteIssueLinks',
    PEOPLE: 'com.atlassian.jira.plugin.system.customfieldtypes:people',
    DATE_PICKER: 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker'
};
const $1fec13ea3747c865$export$de4c02b525d877fa = '__issuetable_internal_meatball';
const $1fec13ea3747c865$export$c3266da279aa6b84 = '__issuetable_internal_expand_button';
const $1fec13ea3747c865$export$66b2a4a5f67468ac = '__issuetable_internal_checkbox';
const $1fec13ea3747c865$export$3237751348c4f1b = '__issuetable_internal_merged_column';
const $1fec13ea3747c865$export$72f66561203b705c = [
    $1fec13ea3747c865$export$bbc2e8c301f97f97.ISSUE_TYPE,
    $1fec13ea3747c865$export$bbc2e8c301f97f97.ISSUE_KEY,
    $1fec13ea3747c865$export$bbc2e8c301f97f97.SUMMARY
];
const $1fec13ea3747c865$export$70f30e260ec270f2 = [
    'issuetype',
    'issuekey',
    'summary'
];
const $1fec13ea3747c865$export$6aa1d347deb86ef3 = 64; // 24 * 2 (two icons) + 8*2 (horizontal padding)
const $1fec13ea3747c865$export$fae6afe554014a45 = 'NIN_PROJECT';
const $1fec13ea3747c865$export$39ec48f092f3ea90 = 'NIN_GLOBAL';

});


parcelRegister("t3Q07", function(module, exports) {

$parcel$export(module.exports, "getAliasesForField", () => $a3816529ae558e1d$export$94d69942fbe58a01);
const $a3816529ae558e1d$export$94d69942fbe58a01 = (field, fieldToJqlTermMap)=>{
    // provided field could be a field id, name, an alias, or a jql term
    let term = fieldToJqlTermMap.get(field);
    if (term === undefined) {
        // it may be a jql term itself
        // filter is still an experiment feature in Iterator so we do old school looping
        for (const keyValuePair of fieldToJqlTermMap.entries())if (keyValuePair[1] === field) {
            term = keyValuePair[1];
            break;
        }
    }
    if (term === undefined) return [];
    // we do a reverse look-up to find any other keys of this jql term, they can all be used in a jql
    const set = new Set();
    set.add(term);
    for (const keyValuePair of fieldToJqlTermMap.entries())if (keyValuePair[1] === term) set.add(keyValuePair[0]);
    return Array.from(set);
};

});

parcelRegister("796ok", function(module, exports) {

$parcel$export(module.exports, "getJqlTermForField", () => $ad837b869bddcad8$export$ef4e8b2c9bc7bd4d);

var $bCU3R = parcelRequire("bCU3R");
const $ad837b869bddcad8$export$ef4e8b2c9bc7bd4d = (field, fieldToJqlTermMap)=>{
    const convertedField = (0, $bCU3R.convertFieldToJqlTerm)(field);
    const jqlTermForField = fieldToJqlTermMap.get(convertedField) ?? convertedField;
    return jqlTermForField;
};

});
parcelRegister("bCU3R", function(module, exports) {

$parcel$export(module.exports, "convertFieldToJqlTerm", () => $1e1011370a3a12e2$export$29f734dc2c61ea9d);
const $1e1011370a3a12e2$export$29f734dc2c61ea9d = (fieldName)=>{
    // custom fields are indexed by their ids and only work with JQL when referenced as such `cf[id]`.
    // fieldName match regex for customfield_<number> exactly
    // legacy gadget may have it stored as customfield_<number> in user prefs
    if (/^customfield_\d+$/.test(fieldName)) {
        const customFieldId = fieldName.split('customfield_')[1];
        return `cf[${customFieldId}]`;
    }
    return fieldName;
};

});


parcelRegister("lEsjw", function(module, exports) {

let $fc334bf5644f80c4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fc334bf5644f80c4$var$load("i8Zoh").then(()=>parcelRequire('aWG9Z'));

});

parcelRegister("60ZTe", function(module, exports) {

let $4612c03314737910$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4612c03314737910$var$load("4EmhV").then(()=>parcelRequire('eWn4R'));

});

parcelRegister("j4Vmz", function(module, exports) {

let $de3ae31f5334659f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $de3ae31f5334659f$var$load("fEFRC").then(()=>parcelRequire('ajrrh'));

});



parcelRegister("jyMtv", function(module, exports) {

$parcel$export(module.exports, "transformToValidUserPrefs", () => $8cfaebab7e294873$export$e9345b021afd3cc3);

var $hwva3 = parcelRequire("hwva3");

var $Z4X9T = parcelRequire("Z4X9T");

var $hCluT = parcelRequire("hCluT");
const $8cfaebab7e294873$export$e9345b021afd3cc3 = (rawUserPrefs)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const pageSize = parseInt(rawUserPrefs.num, 10);
    const fieldSetIds = (0, $hwva3.convertUserPrefsToColumnNames)(rawUserPrefs.columnNames);
    const stringifiedFilterId = `${rawUserPrefs.filterId}`;
    const { sortDirection: sortDirection, sortField: sortField } = (0, $Z4X9T.getSortFieldAndDirection)(rawUserPrefs.sortBy);
    const showResolved = !!rawUserPrefs.showResolved;
    return {
        filterId: (0, $hCluT.isFilterId)(stringifiedFilterId) ? stringifiedFilterId : undefined,
        columnNames: fieldSetIds,
        num: !Number.isNaN(pageSize) ? pageSize : 10,
        sortDirection: sortDirection,
        sortField: sortField,
        showResolved: showResolved
    };
};

});
parcelRegister("hwva3", function(module, exports) {

$parcel$export(module.exports, "convertUserPrefsToColumnNames", () => $ffa5f3be2fc11704$export$6e5cdc232ebb20cf);

var $JIPqS = parcelRequire("JIPqS");

const $ffa5f3be2fc11704$export$6e5cdc232ebb20cf = (columns)=>typeof columns === 'string' && columns !== '' && columns !== '--Default--' ? columns.split((0, $e997f85ca70fa8bf$export$a3d4af30107c4f4d)).map((col)=>col.replaceAll((0, $e997f85ca70fa8bf$export$952287cc7aef3a4c), (0, $e997f85ca70fa8bf$export$a3d4af30107c4f4d))) : (0, $JIPqS.ISSUE_SEARCH_DEFAULT_COLUMNS);

});
const $e997f85ca70fa8bf$export$dd03181e30c7d559 = 5;
const $e997f85ca70fa8bf$export$a3d4af30107c4f4d = '|';
const $e997f85ca70fa8bf$export$952287cc7aef3a4c = '%7C';


parcelRegister("Z4X9T", function(module, exports) {

$parcel$export(module.exports, "getSortFieldAndDirection", () => $834bd6f85e4a1e0d$export$e535bb2dfaa4d10b);
const $834bd6f85e4a1e0d$export$e535bb2dfaa4d10b = (sortByFromUserPrefs)=>{
    const [sortField, sortDirection] = typeof sortByFromUserPrefs === 'string' ? sortByFromUserPrefs.split(':') : [];
    if (!sortField || sortDirection !== 'ASC' && sortDirection !== 'DESC') return {};
    return {
        sortField: sortField,
        sortDirection: sortDirection
    };
};

});

parcelRegister("hCluT", function(module, exports) {

$parcel$export(module.exports, "isFilterId", () => $39fbd6b125bd3cbf$export$23be85030bd58047);
// this is copied from NIN https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/jira/src/packages/issue-navigator/actions/common/src/utils/filters/index.tsx?at=abdc1df97c8cee2475285ab25c47a938ce99d65a
const $39fbd6b125bd3cbf$export$23be85030bd58047 = (value)=>value !== undefined && /^-?\d+$/.test(value);

});




parcelRegister("26UOd", function(module, exports) {

$parcel$export(module.exports, "REACT_KEY", () => $c373d1a6bf5d7ef6$export$e0e89108956f58f6);
// React gadget keys
const $c373d1a6bf5d7ef6$export$c8ae0b83405368ed = 'react/filter-results';
const $c373d1a6bf5d7ef6$var$REACT_KEY_ASSIGNED_TO_ME = 'react/assigned-to-me';
const $c373d1a6bf5d7ef6$var$REACT_KEY_ISSUES_IN_PROGRESS = 'react/issues-in-progress';
const $c373d1a6bf5d7ef6$var$REACT_KEY_VOTED_ISSUES = 'react/voted-issues';
const $c373d1a6bf5d7ef6$var$REACT_KEY_WATCHED_ISSUES = 'react/watched-issues';
const $c373d1a6bf5d7ef6$var$REACT_KEY_CUSTOM_REPORT = 'react/custom-report';
const $c373d1a6bf5d7ef6$export$e0e89108956f58f6 = {
    FILTER_RESULTS: $c373d1a6bf5d7ef6$export$c8ae0b83405368ed,
    ASSIGNED_TO_ME: $c373d1a6bf5d7ef6$var$REACT_KEY_ASSIGNED_TO_ME,
    ISSUES_IN_PROGRESS: $c373d1a6bf5d7ef6$var$REACT_KEY_ISSUES_IN_PROGRESS,
    VOTED_ISSUES: $c373d1a6bf5d7ef6$var$REACT_KEY_VOTED_ISSUES,
    WATCHED_ISSUES: $c373d1a6bf5d7ef6$var$REACT_KEY_WATCHED_ISSUES,
    CUSTOM_REPORT: $c373d1a6bf5d7ef6$var$REACT_KEY_CUSTOM_REPORT
};

});




parcelRegister("aVFmC", function(module, exports) {

$parcel$export(module.exports, "default", () => $31463ce0406b73cb$export$2e2bcd8739ae039);

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$31463ce0406b73cb$export$2e2bcd8739ae039 = async ()=>(0, $eusud.performGetRequest)('/rest/config/1.0/directoryitems.json');

});

parcelRegister("3Zhqx", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1c788e303134293$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $5IKQ6 = parcelRequire("5IKQ6");

var $kspzT = parcelRequire("kspzT");

var $3Yd87 = parcelRequire("3Yd87");

var $kGR9w = parcelRequire("kGR9w");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b1c788e303134293$export$2e2bcd8739ae039 = (maybePrevData, sharedValue)=>({ isPrefetch: isPrefetch }, spaContext)=>{
        if (!sharedValue || sharedValue instanceof Error) throw new (0, $3Yd87.SharedValueAggregateError)({
            sharedValue: sharedValue,
            isPrefetch: isPrefetch,
            name: 'AMD modules resource'
        });
        return (async ()=>{
            const { reactGadgets: nextGadgets } = sharedValue;
            const prev = maybePrevData != null && !(maybePrevData instanceof Error) && maybePrevData.reactGadgetsState || {};
            const persistedGadgets = nextGadgets.filter(({ id: id })=>!!prev[id]);
            const gadgetsToLoad = nextGadgets.filter((gadget)=>{
                // componentEdit will be optional in the future, although currently types say that it's required
                const isConfigurable = !!(0, $kspzT.default)[gadget.reactKey].componentEdit;
                const isUnconfigured = isConfigurable && !(0, $5IKQ6.isGadgetConfigured)(gadget.userPrefs);
                return !prev[gadget.id] && !isUnconfigured;
            });
            const skippedGadgets = nextGadgets.filter((gadget)=>!prev[gadget.id] && !gadgetsToLoad.some(({ id: id })=>id === gadget.id));
            const reactGadgetsState = {
                ...Object.fromEntries(persistedGadgets.map(({ id: id })=>[
                        id,
                        prev[id]
                    ])),
                ...Object.fromEntries(skippedGadgets.map(({ id: id })=>[
                        id,
                        {}
                    ])),
                ...await (0, $kGR9w.loadReactGadgets)(gadgetsToLoad, spaContext)
            };
            return {
                sharedValue: sharedValue,
                reactGadgetsState: reactGadgetsState
            };
        })();
    };

});
parcelRegister("5IKQ6", function(module, exports) {

$parcel$export(module.exports, "isGadgetConfigured", () => $ce7e823be599a5b0$export$b625fae487818738);
const $ce7e823be599a5b0$export$b625fae487818738 = (userPrefs)=>userPrefs?.fields.some(({ name: name, value: value })=>name === 'isConfigured' && value === 'true') ?? false;

});

parcelRegister("kGR9w", function(module, exports) {

$parcel$export(module.exports, "loadReactGadgets", () => $ae0204181dcaff49$export$7e1a3455761184a2);
// eslint-disable-next-line jira/import-whitelist

var $kspzT = parcelRequire("kspzT");
const $ae0204181dcaff49$var$preloadGadgetBundles = (reactKeys)=>reactKeys.forEach((reactKey)=>{
        (0, $kspzT.default)[reactKey].preload();
    });
const $ae0204181dcaff49$export$7e1a3455761184a2 = async (gadgets, spaContext)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const distinctReactKeys = [
        ...new Set(gadgets.map((gadget)=>gadget.reactKey))
    ];
    $ae0204181dcaff49$var$preloadGadgetBundles(distinctReactKeys);
    return Object.fromEntries(await Promise.all(gadgets.map(({ id: id, reactKey: reactKey, userPrefs: userPrefs })=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $kspzT.default)[reactKey]?.getInitialState(spaContext, userPrefs?.fields || []).then((state)=>[
                id,
                state
            ], (error)=>[
                id,
                error
            ]))));
};

});



parcelRegister("gCJaT", function(module, exports) {

$parcel$export(module.exports, "dashboardEditRoute", () => $28f71741a95efd1f$export$b6e00d2cd7369fbd);
const $28f71741a95efd1f$export$b6e00d2cd7369fbd = {
    name: 'dashboard-edit',
    path: '/jira/dashboards/:dashboardId(\\d+)/edit',
    query: [
        'maximized?'
    ],
    exact: true
};

});

parcelRegister("irlpm", function(module, exports) {

$parcel$export(module.exports, "dashboardEditEntryPoint", () => $c73267a50536209c$export$eb39305ec6fcebf1);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $c73267a50536209c$export$eb39305ec6fcebf1 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("lKV68")), {
        moduleId: "4d5a5b34",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("lKV68", function(module, exports) {

let $fd6a2f5584ddebf2$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $fd6a2f5584ddebf2$var$load("ffQaD"),
    $fd6a2f5584ddebf2$var$load("kvRbA"),
    $fd6a2f5584ddebf2$var$load("5yNG7")
]).then(()=>parcelRequire('7AfLj'));

});


parcelRegister("ernoj", function(module, exports) {

$parcel$export(module.exports, "dashboardResources", () => $92d1f2722b27ff5d$export$50d95db618f58349);
$parcel$export(module.exports, "LazyDashboardView", () => $92d1f2722b27ff5d$export$c3bf98706b62de2b);
$parcel$export(module.exports, "LazyDashboardViewEmbed", () => $92d1f2722b27ff5d$export$94d85118d282a15);
$parcel$export(module.exports, "LazySystemDashboardEdit", () => $92d1f2722b27ff5d$export$c8d59d34c3e8f345);
$parcel$export(module.exports, "DashboardViewEmbedPage", () => $92d1f2722b27ff5d$export$86d9f777f9d4e312);
$parcel$export(module.exports, "SystemDashboardEditPage", () => $92d1f2722b27ff5d$export$dcd19a888f8c85c);

var $5uXOq = parcelRequire("5uXOq");

var $gh1hi = parcelRequire("gh1hi");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");
const $92d1f2722b27ff5d$export$50d95db618f58349 = ()=>[
        (0, $gh1hi.dashboardConfigAndWRMResource),
        (0, $gh1hi.dashboardAMDModulesResource),
        (0, $gh1hi.dashboardReactGadgetsResource),
        (0, $gh1hi.dashboardForgeResource)
    ];

const $92d1f2722b27ff5d$export$c3bf98706b62de2b = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("4C60q"))), {
    moduleId: "./src/packages/global-pages/dashboard/view/src/index.tsx"
});

const $92d1f2722b27ff5d$export$94d85118d282a15 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("4KQT7"))), {
    moduleId: "./src/packages/global-pages/dashboard/view-embed/src/index.tsx"
});

const $92d1f2722b27ff5d$export$c8d59d34c3e8f345 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("bBdB0"))), {
    moduleId: "./src/packages/spa-apps/dashboard/system-dashboard-edit/src/index.tsx"
});
const $92d1f2722b27ff5d$export$86d9f777f9d4e312 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $92d1f2722b27ff5d$export$94d85118d282a15,
        pageId: "dashboard",
        shouldShowSpinner: true
    });
const $92d1f2722b27ff5d$export$dcd19a888f8c85c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $92d1f2722b27ff5d$export$c8d59d34c3e8f345,
        pageId: "system-dashboard-edit",
        shouldShowSpinner: false
    });

});
parcelRegister("4C60q", function(module, exports) {

let $35bf5ea926444dc5$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $35bf5ea926444dc5$var$load("ffQaD"),
    $35bf5ea926444dc5$var$load("kvRbA"),
    $35bf5ea926444dc5$var$load("iv5Bz")
]).then(()=>parcelRequire('iqENN'));

});

parcelRegister("4KQT7", function(module, exports) {

let $37647bc60766f0a1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $37647bc60766f0a1$var$load("eCOxy").then(()=>parcelRequire('9aF4A'));

});

parcelRegister("bBdB0", function(module, exports) {

let $871db24493e19a8f$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $871db24493e19a8f$var$load("ffQaD"),
    $871db24493e19a8f$var$load("kvRbA"),
    $871db24493e19a8f$var$load("47Wf2")
]).then(()=>parcelRequire('3VYlm'));

});



parcelRegister("56moC", function(module, exports) {

$parcel$export(module.exports, "dashboardRouteEntry", () => $1603466baea9815f$export$9fbbaafb58999ac3);

var $ffza4 = parcelRequire("ffza4");


var $e2ctp = parcelRequire("e2ctp");

var $gmpjq = parcelRequire("gmpjq");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $fP8Ju = parcelRequire("fP8Ju");

var $4n0Oi = parcelRequire("4n0Oi");

var $ernoj = parcelRequire("ernoj");
const $1603466baea9815f$export$9fbbaafb58999ac3 = (0, $7NszV.createEntry)((0, $fP8Ju.dashboardRoute), ()=>({
        group: 'dashboard',
        component: (0, $4n0Oi.DashboardRedirect),
        layout: (0, $gmpjq.homepageLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $ernoj.dashboardResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ernoj.LazyDashboardView)
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$4695c1a423ffe431)
        },
        isRedirect: true,
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("gmpjq", function(module, exports) {

$parcel$export(module.exports, "homepageLayout", () => $226ab3e64821f6b2$export$5b7fb151d60504c);

var $iqZds = parcelRequire("iqZds");

var $2BrOV = parcelRequire("2BrOV");

var $aPfsS = parcelRequire("aPfsS");
const $226ab3e64821f6b2$export$5b7fb151d60504c = (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), {
    // both of the components are wrapped with componentWithCondition
    globalComponents: [
        (0, $iqZds.AsyncTransitionHomeRenderer),
        (0, $iqZds.AsyncWelcomeModalRenderer)
    ]
});

});
parcelRegister("iqZds", function(module, exports) {

$parcel$export(module.exports, "AsyncTransitionHomeRenderer", () => $d1122e3218429f7d$export$cb38f5a820347580);
$parcel$export(module.exports, "AsyncWelcomeModalRenderer", () => $d1122e3218429f7d$export$9cda67d6c86d7b98);
$parcel$export(module.exports, "eocChangeboardingLayout", () => $d1122e3218429f7d$export$b8fa7ac7019001bb);

var $aPfsS = parcelRequire("aPfsS");

var $kxZPA = parcelRequire("kxZPA");

var $cSD7y = parcelRequire("cSD7y");

const $d1122e3218429f7d$export$cb38f5a820347580 = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("hUE2l")).then((module)=>module.TransitionHomeRenderer), {
    ssr: false,
    moduleId: "./src/packages/eoc/changeboarding/src/ui/transition-home/main.tsx"
});
$d1122e3218429f7d$export$cb38f5a820347580.displayName = 'AsyncTransitionHomeRenderer';

const $d1122e3218429f7d$export$9cda67d6c86d7b98 = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("kyxXX")).then((module)=>module.WelcomeModalRenderer), {
    ssr: false,
    moduleId: "./src/packages/eoc/changeboarding/src/ui/wizard/main.tsx"
});
$d1122e3218429f7d$export$9cda67d6c86d7b98.displayName = 'AsyncWelcomeModalRenderer';

const $d1122e3218429f7d$export$913f5a2340406083 = (0, $cSD7y.componentWithFG)('operations-migration-hub-jira', // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("civVw")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/ops-settings-layout/src/ui/right-sidebars/index.tsx"
}), ()=>null);
$d1122e3218429f7d$export$913f5a2340406083.displayName = 'MigrationHubRightSidebar';

const $d1122e3218429f7d$export$6d7715b12d3ad17b = (0, $cSD7y.componentWithFG)('operations-migration-hub-jira', // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("dgrxE")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/ops-settings-layout/src/ui/onboarding/index.tsx"
}), ()=>null);
$d1122e3218429f7d$export$6d7715b12d3ad17b.displayName = 'MigrationHubOnboarding';
const $d1122e3218429f7d$export$b8fa7ac7019001bb = (0, $aPfsS.createLayout)({
    get globalComponents () {
        return [
            $d1122e3218429f7d$export$cb38f5a820347580,
            $d1122e3218429f7d$export$9cda67d6c86d7b98,
            $d1122e3218429f7d$export$6d7715b12d3ad17b
        ];
    },
    rightSidebars: [
        $d1122e3218429f7d$export$913f5a2340406083
    ]
});

});
parcelRegister("hUE2l", function(module, exports) {

let $d0a6b91d1557d0c5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d0a6b91d1557d0c5$var$load("blXNs").then(()=>parcelRequire('dsKht'));

});

parcelRegister("kyxXX", function(module, exports) {

let $ef715495206cdb29$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ef715495206cdb29$var$load("iCaFG").then(()=>parcelRequire('cKcai'));

});

parcelRegister("civVw", function(module, exports) {

let $8f3fee7c36a0f8c3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8f3fee7c36a0f8c3$var$load("1tohs").then(()=>parcelRequire('eb0cf'));

});

parcelRegister("dgrxE", function(module, exports) {

let $9a8222329de6024a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9a8222329de6024a$var$load("hZQ0p").then(()=>parcelRequire('kdZEd'));

});



parcelRegister("fP8Ju", function(module, exports) {

$parcel$export(module.exports, "dashboardRoute", () => $91c4527accb41ff2$export$3bf0ecb39349b6ef);
const $91c4527accb41ff2$export$3bf0ecb39349b6ef = {
    name: 'dashboard',
    path: '/secure/Dashboard.jspa'
};

});

parcelRegister("4n0Oi", function(module, exports) {

$parcel$export(module.exports, "DashboardRedirect", () => $55d04275d2bcfadf$export$da833ddcffcc38ba);

var $5uXOq = parcelRequire("5uXOq");

var $6jY6G = parcelRequire("6jY6G");

var $ds5qV = parcelRequire("ds5qV");

var $9VXkC = parcelRequire("9VXkC");
var $doZTA = parcelRequire("doZTA");
const $55d04275d2bcfadf$export$da833ddcffcc38ba = ()=>{
    const [{ query: query, location: { hash: hash } }] = (0, $doZTA.useRouter)();
    const { path: path } = (0, $6jY6G.useRouteByName)('dashboard-view') ?? {};
    if (path == null) throw new Error('Dashboard view route not found');
    const { selectPageId: id } = query;
    const idParam = /^\d+$/.test(id) ? id : 'last-visited';
    const generatedPath = (0, $9VXkC.generatePath)(path, {
        dashboardId: idParam
    });
    const maximizedId = hash.match(/.*\/(?<id>\d+)/)?.groups?.id ?? null;
    const pathWithQuery = maximizedId !== null ? `${generatedPath}?maximized=${maximizedId}` : generatedPath;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: pathWithQuery,
        persistSearchParams: false
    });
};

});


parcelRegister("aNsRz", function(module, exports) {

$parcel$export(module.exports, "dashboardsDirectoryRedirectRouteEntry", () => $3848740eee1bab7b$export$8dae8091f8e43b97);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $4yCf0 = parcelRequire("4yCf0");

var $3RJkv = parcelRequire("3RJkv");

var $2XHRw = parcelRequire("2XHRw");

var $ds5qV = parcelRequire("ds5qV");

var $cFtGt = parcelRequire("cFtGt");

var $aZoVa = parcelRequire("aZoVa");
const $3848740eee1bab7b$var$DashboardsDirectoryRedirect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: "/jira/dashboards"
    });
const $3848740eee1bab7b$export$8dae8091f8e43b97 = (0, $7NszV.createEntry)((0, $2XHRw.dashboardsDirectoryRedirectRoute), ()=>({
        group: 'directories',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $4yCf0.dashboardsDirectoryResource)
        ],
        component: !false ? $3848740eee1bab7b$var$DashboardsDirectoryRedirect : (0, $aZoVa.DashboardsDirectoryComponent),
        skeleton: (0, $cFtGt.DashboardsDirectorySkeleton),
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).DASHBOARDS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aZoVa.LazyDashboardsDirectory)
        ],
        isRedirect: true
    }));

});
parcelRegister("4yCf0", function(module, exports) {

$parcel$export(module.exports, "dashboardsDirectoryResource", () => $c9ec3cc3b6c0608d$export$1cf6c7815471c2a2);

var $kbVA4 = parcelRequire("kbVA4");

var $2M1hQ = parcelRequire("2M1hQ");
const $c9ec3cc3b6c0608d$var$RESOURCE_TYPE_DASHBOARDS_DIRECTORY = 'DASHBOARDS_DIRECTORY';

const $c9ec3cc3b6c0608d$export$1cf6c7815471c2a2 = (0, $2M1hQ.createResource)({
    type: $c9ec3cc3b6c0608d$var$RESOURCE_TYPE_DASHBOARDS_DIRECTORY,
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("1bD1s")),
    maxAge: (0, $kbVA4.MIN_MAX_AGE)
});

});
parcelRegister("1bD1s", function(module, exports) {

let $0dd51695df5cd3c5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0dd51695df5cd3c5$var$load("dxnac").then(()=>parcelRequire('ciD6c'));

});


parcelRegister("2XHRw", function(module, exports) {

$parcel$export(module.exports, "dashboardsDirectoryRedirectRoute", () => $55fec75e9850e3c3$export$b96f6fb3c35a6fe5);
const $55fec75e9850e3c3$export$b96f6fb3c35a6fe5 = {
    name: 'dashboards-directory-secure',
    path: '/secure/ConfigurePortalPages(!default.jspa|.jspa)'
};

});

parcelRegister("aZoVa", function(module, exports) {

$parcel$export(module.exports, "LazyDashboardsDirectory", () => $cd7e3d13d091ccad$export$f2f3fd22cd37e121);
$parcel$export(module.exports, "DashboardsDirectoryComponent", () => $cd7e3d13d091ccad$export$1cc6cc01050e1215);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $cd7e3d13d091ccad$export$f2f3fd22cd37e121 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("iB9lT"))), {
    moduleId: "./src/packages/spa-apps/directories/dashboards/src/index.tsx"
});
const $cd7e3d13d091ccad$export$1cc6cc01050e1215 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cd7e3d13d091ccad$export$f2f3fd22cd37e121,
        pageId: "dashboards-directory",
        shouldShowSpinner: false
    });

});
parcelRegister("iB9lT", function(module, exports) {

let $d8a2efd3b9af836d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d8a2efd3b9af836d$var$load("ffQaD"),
    $d8a2efd3b9af836d$var$load("kvRbA"),
    $d8a2efd3b9af836d$var$load("l4XNP")
]).then(()=>parcelRequire('76rrf'));

});



parcelRegister("cmvi5", function(module, exports) {

$parcel$export(module.exports, "dashboardsDirectoryRouteEntry", () => $bc6135fca4882261$export$748e329bd0c282a);

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $4yCf0 = parcelRequire("4yCf0");

var $3RJkv = parcelRequire("3RJkv");

var $dDmlh = parcelRequire("dDmlh");

var $cFtGt = parcelRequire("cFtGt");

var $lkFvK = parcelRequire("lkFvK");

var $fT58V = parcelRequire("fT58V");

var $h4rc7 = parcelRequire("h4rc7");

var $keYV7 = parcelRequire("keYV7");
const $bc6135fca4882261$export$748e329bd0c282a = (0, $7NszV.createEntry)((0, $dDmlh.dashboardsDirectoryRoute), ()=>({
        group: 'directories',
        entryPoint: ()=>$bc6135fca4882261$var$pageEntryPoint,
        skeleton: (0, $cFtGt.DashboardsDirectorySkeleton),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $4yCf0.dashboardsDirectoryResource)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).DASHBOARDS,
            sidebarId: (0, $lmyls.SIDEBAR_ID).CONTENT
        },
        supportsPreviewPanel: true
    }));
// Page entrypoint, referred to above...
const $bc6135fca4882261$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $keYV7.dashboardDirectoryEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).DASHBOARDS,
    leftSidebar: {
        sidebar: (0, $fT58V.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            dashboards: {
                entryPoint: (0, $h4rc7.nav4DashboardsContentEntryPoint)
            }
        }
    }
});

});
parcelRegister("keYV7", function(module, exports) {

$parcel$export(module.exports, "dashboardDirectoryEntryPoint", () => $483e18a450676181$export$3325d832741ebeb3);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $483e18a450676181$export$3325d832741ebeb3 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("iB9lT")), {
        moduleId: "933882c8",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});


parcelRegister("hfMX7", function(module, exports) {

$parcel$export(module.exports, "dashboardViewEmbedRouteEntry", () => $67a8397fa114200d$export$73a377380ff671af);

var $Xtn30 = parcelRequire("Xtn30");


var $e2ctp = parcelRequire("e2ctp");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $2Ql51 = parcelRequire("2Ql51");

var $joJjt = parcelRequire("joJjt");

var $ernoj = parcelRequire("ernoj");
const $67a8397fa114200d$export$73a377380ff671af = (0, $7NszV.createEntry)((0, $joJjt.dashboardViewEmbedRoute), ()=>({
        group: 'dashboard',
        component: (0, $ernoj.DashboardViewEmbedPage),
        layout: (0, $aPfsS.createLayout)({
            globalComponents: [
                (0, $Xtn30.DashboardBackgroundScripts)
            ],
            isChromeless: true
        }),
        resources: [
            (0, $2Ql51.themePreferenceResource),
            ...(0, $ernoj.dashboardResources)()
        ],
        forPaint: [
            (0, $ernoj.LazyDashboardViewEmbed)
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$4695c1a423ffe431)
        },
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("joJjt", function(module, exports) {

$parcel$export(module.exports, "dashboardViewEmbedRoute", () => $47f4f3f379b59c3e$export$258b5e3f294617d2);
const $47f4f3f379b59c3e$export$258b5e3f294617d2 = {
    name: 'dashboard-view-embed',
    path: '/jira/dashboards/:dashboardId(\\d+)/embed',
    query: [],
    exact: true
};

});


parcelRegister("1zhx7", function(module, exports) {

$parcel$export(module.exports, "dashboardViewRouteEntry", () => $c891244b3388b2f7$export$18226b6422149926);

var $j6woB = parcelRequire("j6woB");


var $e2ctp = parcelRequire("e2ctp");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $3RJkv = parcelRequire("3RJkv");

var $5gOBf = parcelRequire("5gOBf");

var $7NAzY = parcelRequire("7NAzY");

var $lkFvK = parcelRequire("lkFvK");

var $fT58V = parcelRequire("fT58V");

var $h4rc7 = parcelRequire("h4rc7");

var $ernoj = parcelRequire("ernoj");
const $c891244b3388b2f7$export$18226b6422149926 = (0, $7NszV.createEntry)((0, $5gOBf.dashboardViewRoute), ()=>({
        group: 'dashboard',
        entryPoint: ()=>$c891244b3388b2f7$var$pageEntryPoint,
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $j6woB.dashboardBackgroundScriptsLayout)),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).DASHBOARDS,
            sidebarId: (0, $lmyls.SIDEBAR_ID).CONTENT
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $ernoj.dashboardResources)()
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$4695c1a423ffe431)
        },
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY),
        ufoName: 'dashboard',
        supportsPreviewPanel: true
    }));
const $c891244b3388b2f7$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7NAzY.dashboardViewEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).DASHBOARDS,
    leftSidebar: {
        sidebar: (0, $fT58V.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            dashboards: {
                entryPoint: (0, $h4rc7.nav4DashboardsContentEntryPoint)
            }
        }
    }
});

});
parcelRegister("5gOBf", function(module, exports) {

$parcel$export(module.exports, "dashboardViewRoute", () => $1aac2fbaf8a5979b$export$24f1b2ff97b9d3e6);
const $1aac2fbaf8a5979b$export$24f1b2ff97b9d3e6 = {
    name: 'dashboard-view',
    path: '/jira/dashboards/:dashboardId(\\d+|last-visited)',
    query: [
        'maximized?'
    ],
    exact: true
};

});

parcelRegister("7NAzY", function(module, exports) {

$parcel$export(module.exports, "dashboardViewEntryPoint", () => $eb6de38ddcb43951$export$acd33fbfe610d0e6);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $eb6de38ddcb43951$export$acd33fbfe610d0e6 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("4C60q")), {
        moduleId: "2821e152",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});


parcelRegister("dxMNj", function(module, exports) {

$parcel$export(module.exports, "dashboardWallboardRouteEntry", () => $ae18a94b5423e69e$export$6009dd8e88f1a7de);

var $Xtn30 = parcelRequire("Xtn30");


var $e2ctp = parcelRequire("e2ctp");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $2Ql51 = parcelRequire("2Ql51");

var $TJQd9 = parcelRequire("TJQd9");

var $lkFvK = parcelRequire("lkFvK");

var $8RtQf = parcelRequire("8RtQf");

var $ernoj = parcelRequire("ernoj");
const $ae18a94b5423e69e$export$6009dd8e88f1a7de = (0, $7NszV.createEntry)((0, $TJQd9.dashboardWallboardRoute), ()=>({
        group: 'dashboard',
        entryPoint: ()=>$ae18a94b5423e69e$var$dashboardWallboardPageEntryPoint,
        layout: (0, $aPfsS.createLayout)({
            globalComponents: [
                (0, $Xtn30.DashboardBackgroundScripts)
            ],
            // we don't want nav bar and right panel etc to appear in wallboard, so we use chromeless mode
            isChromeless: true
        }),
        resources: [
            (0, $2Ql51.themePreferenceResource),
            ...(0, $ernoj.dashboardResources)()
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$4695c1a423ffe431)
        },
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY)
    }));
const $ae18a94b5423e69e$var$dashboardWallboardPageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $8RtQf.dashboardWallboardEntryPoint)
});

});
parcelRegister("TJQd9", function(module, exports) {

$parcel$export(module.exports, "dashboardWallboardRoute", () => $59e2472cc6b14119$export$eaa33c953ab9ca63);
const $59e2472cc6b14119$export$eaa33c953ab9ca63 = {
    name: 'dashboard-wallboard',
    path: '/jira/dashboards/wallboard',
    query: [
        'dashboardId',
        'cyclePeriod?',
        'transitionFx?',
        'random?'
    ],
    exact: true
};

});

parcelRegister("8RtQf", function(module, exports) {

$parcel$export(module.exports, "dashboardWallboardEntryPoint", () => $a0f9d35bbcc604c1$export$99f21964c00b61ef);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $a0f9d35bbcc604c1$export$99f21964c00b61ef = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("4K6Jh")), {
        moduleId: "b10917db",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("4K6Jh", function(module, exports) {

let $3740ada07419c85c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3740ada07419c85c$var$load("jrM9n").then(()=>parcelRequire('7ykDM'));

});



parcelRegister("hwgIz", function(module, exports) {

$parcel$export(module.exports, "devopsConnectedProjectRouteEntry", () => $b6b724158556afe3$export$ae258fb8ec2c1f86);

var $ffza4 = parcelRequire("ffza4");

var $6e4Kt = parcelRequire("6e4Kt");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $cK8ht = parcelRequire("cK8ht");

var $6IcGP = parcelRequire("6IcGP");
const $b6b724158556afe3$export$ae258fb8ec2c1f86 = (0, $7NszV.createEntry)((0, $cK8ht.devopsConnectedProjectRoute), ()=>({
        group: 'devops',
        ufoName: 'devops.connected-project',
        component: (0, $6IcGP.default),
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6IcGP.LazyDevopsConnectedProject)
        ]
    }));

});
parcelRegister("cK8ht", function(module, exports) {

$parcel$export(module.exports, "devopsConnectedProjectRoute", () => $52511ff99217f467$export$91257312631802bc);
const $52511ff99217f467$export$91257312631802bc = {
    name: 'devops-connected-project',
    path: '/jira/devops/connected-project'
};

});

parcelRegister("6IcGP", function(module, exports) {

$parcel$export(module.exports, "LazyDevopsConnectedProject", () => $31d281e7968db385$export$dcd3d20b0038b35c);
$parcel$export(module.exports, "default", () => $31d281e7968db385$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $31d281e7968db385$export$dcd3d20b0038b35c = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("1ezgG"))), {
    moduleId: "./src/packages/spa-apps/devops-connected-project/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$31d281e7968db385$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $31d281e7968db385$export$dcd3d20b0038b35c,
        pageId: "devops-connected-project",
        shouldShowSpinner: true
    });

});
parcelRegister("1ezgG", function(module, exports) {

let $0e6274c5f01ce0d0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0e6274c5f01ce0d0$var$load("cVZIB").then(()=>parcelRequire('kGKHk'));

});



parcelRegister("d4tTc", function(module, exports) {

$parcel$export(module.exports, "digestsNotificationsPersonalSettingsRouteEntry", () => $c698e0e2618894a9$export$6ff00ce079beb0ed);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $cRWZh = parcelRequire("cRWZh");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $b5ISR = parcelRequire("b5ISR");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $c698e0e2618894a9$var$LazyDigestsNotificationsPersonalSettings = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("6iV1I"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/personal-settings/digests-notifications/src/index.tsx"
});
const $c698e0e2618894a9$var$DigestsNotificationsPersonalSettingsComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $c698e0e2618894a9$var$LazyDigestsNotificationsPersonalSettings,
        pageId: "personal-settings-notifications",
        shouldShowSpinner: true
    });
const $c698e0e2618894a9$export$6ff00ce079beb0ed = (0, $7NszV.createEntry)((0, $b5ISR.digestsNotificationsPersonalSettingsRoute), ()=>({
        group: 'personal-settings',
        component: $c698e0e2618894a9$var$DigestsNotificationsPersonalSettingsComponent,
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PERSONAL_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PROFILE,
            sidebar: (0, $cRWZh.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $c698e0e2618894a9$var$LazyDigestsNotificationsPersonalSettings
        ]
    }));

});
parcelRegister("cRWZh", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fc6117fdc2ce1b9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

const $8fc6117fdc2ce1b9$var$LazyPersonalSettingsSidebar = (0, $kxZPA.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("kHYph")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/personal-settings/src/index.tsx"
});
const $8fc6117fdc2ce1b9$var$PersonalSettingsSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "personalSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8fc6117fdc2ce1b9$var$LazyPersonalSettingsSidebar, null));
var $8fc6117fdc2ce1b9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($8fc6117fdc2ce1b9$var$PersonalSettingsSidebar);

});
parcelRegister("kHYph", function(module, exports) {

let $f136ae4b96463a36$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f136ae4b96463a36$var$load("i4r9Y").then(()=>parcelRequire('6re9h'));

});


parcelRegister("b5ISR", function(module, exports) {

$parcel$export(module.exports, "digestsNotificationsPersonalSettingsRoute", () => $8043a136b458bb05$export$36b31d006b9456a1);
const $8043a136b458bb05$export$36b31d006b9456a1 = {
    name: 'personal-settings-digests',
    path: '/jira/settings/personal/digests'
};

});

parcelRegister("6iV1I", function(module, exports) {

let $4970a8d3588a7c4a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4970a8d3588a7c4a$var$load("hgbUB").then(()=>parcelRequire('erUXM'));

});


parcelRegister("Dkaoj", function(module, exports) {

$parcel$export(module.exports, "emailNotificationsLogAccessRouteEntry", () => $9945f9dd9a251453$export$4d57b993ce36e7b2);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $dmx0y = parcelRequire("dmx0y");

var $jsJ7J = parcelRequire("jsJ7J");

var $hBziA = parcelRequire("hBziA");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $5pSYQ = parcelRequire("5pSYQ");
const $9945f9dd9a251453$var$emailNotificationsLogEntryPointPage = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $hBziA.notificationLogsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).SETTINGS
});

const $9945f9dd9a251453$var$LazyNotificationLogsType = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("fGezR"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/notification-logs/src/index.tsx"
});
const $9945f9dd9a251453$var$NotificationLogs = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $9945f9dd9a251453$var$LazyNotificationLogsType,
        pageId: "Notification Logs",
        shouldShowSpinner: false
    });
const $9945f9dd9a251453$export$4d57b993ce36e7b2 = (0, $7NszV.createEntry)((0, $jsJ7J.emailNotificationsLogAccessRoute), ()=>({
        group: 'global-settings',
        component: $9945f9dd9a251453$var$NotificationLogs,
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $dmx0y.systemConfigurationGeneralResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $9945f9dd9a251453$var$LazyNotificationLogsType
        ],
        pageId: 'admin-settings-email-notifications-log',
        entryPoint () {
            return $9945f9dd9a251453$var$emailNotificationsLogEntryPointPage;
        }
    }));

});
parcelRegister("dmx0y", function(module, exports) {

$parcel$export(module.exports, "systemConfigurationGeneralResource", () => $3e822b05b84662f2$export$b622f7400bfafd0d);

var $2M1hQ = parcelRequire("2M1hQ");


const $3e822b05b84662f2$export$b622f7400bfafd0d = (0, $2M1hQ.createResource)({
    type: (0, $3d90c62269ed88a0$export$e780b172f774b673),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("6HjLU"))
});

});
const $3d90c62269ed88a0$export$e780b172f774b673 = 'RESOURCE_TYPE_SYSTEM_CONFIGURATION_GENERAL';

parcelRegister("6HjLU", function(module, exports) {

let $4e06187d5534f5d2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4e06187d5534f5d2$var$load("al8If").then(()=>parcelRequire('khTCh'));

});


parcelRegister("jsJ7J", function(module, exports) {

$parcel$export(module.exports, "emailNotificationsLogAccessRoute", () => $acdb6757893e541c$export$aed294a4a292b909);
const $acdb6757893e541c$export$aed294a4a292b909 = {
    name: 'global-admin-helper-email-notifications-log',
    path: '/jira/settings/system/notification-logs',
    exact: true
};

});

parcelRegister("hBziA", function(module, exports) {

$parcel$export(module.exports, "notificationLogsEntryPoint", () => $e96cd1acff95af13$export$818d841e00bb3749);

var $aGYm3 = parcelRequire("aGYm3");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $e96cd1acff95af13$export$818d841e00bb3749 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("fGezR")), {
        moduleId: "d533cc53",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                notificationLogs: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $aGYm3.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectIds: context?.query?.projectId,
                        notificationType: 'INTERNAL_NOTIFICATION',
                        notificationActionType: 'USER_INVITE',
                        recipientId: ''
                    }
                }
            },
            extraProps: {
                accountId: tenantContext.atlassianAccountId
            }
        })
});

});
parcelRegister("aGYm3", function(module, exports) {

$parcel$export(module.exports, "default", () => $25a34f05175c2102$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6106f34f1da05e19191cff41bffd4296>>
 * @relayHash 1d90cf309bc3da9c32297c3b1e952819
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 71e1f26fd67e2af410f2d8354171d8867b0efd6546709fc85bec1419f20e5b6d
const $25a34f05175c2102$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "71e1f26fd67e2af410f2d8354171d8867b0efd6546709fc85bec1419f20e5b6d",
        "metadata": {},
        "name": "uiNotificationLogsPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $25a34f05175c2102$export$2e2bcd8739ae039 = $25a34f05175c2102$var$node;

});

parcelRegister("fGezR", function(module, exports) {

let $b6a6160a5664c85f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b6a6160a5664c85f$var$load("jTCUX").then(()=>parcelRequire('ktpmL'));

});



parcelRegister("hs0Ni", function(module, exports) {

$parcel$export(module.exports, "eocAlertIssueSyncingCreateRouteEntry", () => $1afcecac57b51b7c$export$92f4b6644eb6cb88);

var $6YWw1 = parcelRequire("6YWw1");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $1GLKn = parcelRequire("1GLKn");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

var $jh1uq = parcelRequire("jh1uq");

var $3dgEU = parcelRequire("3dgEU");

var $a5NQf = parcelRequire("a5NQf");
const $1afcecac57b51b7c$var$getNavigationSpecifications = ()=>{
    return (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $1afcecac57b51b7c$export$92f4b6644eb6cb88 = (0, $7NszV.createEntry)((0, $1GLKn.eocAlertIssueSyncingCreateRoute), ()=>({
        group: 'eoc',
        component: (0, $jh1uq.AlertIssueSync),
        slot: (0, $3dgEU.AlertIssueSyncCreate),
        basePath: '/jira/settings/products/ops',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $6YWw1.resources).configuredSyncsResource,
            (0, $6YWw1.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$1afcecac57b51b7c$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a5NQf.LazyAlertIssueSync)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a5NQf.LazyAlertIssueSync)
        ]
    }));

});
parcelRegister("6YWw1", function(module, exports) {

$parcel$export(module.exports, "resources", () => $89b6fb9884e4755e$export$bc99aaabaf7b70a7);

var $7fV7n = parcelRequire("7fV7n");

var $1YfAT = parcelRequire("1YfAT");

var $7J53H = parcelRequire("7J53H");

var $eyLtQ = parcelRequire("eyLtQ");
const $89b6fb9884e4755e$export$bc99aaabaf7b70a7 = {
    configuredSyncsResource: $7fV7n.configuredSyncsResource,
    userAccessRightsResource: $eyLtQ.userAccessRightsResource,
    getTeamResource: $7J53H.getTeamResource,
    isCurrentSiteSyncEnabledResource: $1YfAT.isCurrentSiteSyncEnabledResource
};

});
parcelRegister("7fV7n", function(module, exports) {

$parcel$export(module.exports, "configuredSyncsResource", () => $780664dfd818f1ba$export$333c290f4a1ec41c);

var $2M1hQ = parcelRequire("2M1hQ");

var $l116g = parcelRequire("l116g");

var $fCcRT = parcelRequire("fCcRT");
const $780664dfd818f1ba$export$333c290f4a1ec41c = (0, $2M1hQ.createResource)({
    type: 'configuredSyncsResource',
    getKey: ({ query: query, match: match })=>{
        const teamId = match.params.teamId ?? query['teamId'];
        const keyword = query['keyword'];
        const type = query['type'];
        const page = query['page'] || '1';
        const status = query['status'];
        return (0, $l116g.UrlHelper)('configuredSyncsResource', {
            page: page,
            keyword: keyword,
            type: type,
            status: status,
            teamId: teamId
        });
    },
    getData: (routerContext)=>(0, $fCcRT.default).getSyncs(routerContext.query, routerContext.match.params.teamId),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("l116g", function(module, exports) {

$parcel$export(module.exports, "UrlHelper", () => $2539490b962657de$export$bacbc496e850c0a4);
const $2539490b962657de$export$bacbc496e850c0a4 = (path, params = {})=>{
    // https://github.com/microsoft/TypeScript/issues/16655
    const q = Object.entries(params).map(([k, v])=>v !== '' && !!v || v === false ? [
            k,
            v.toString()
        ] : undefined).filter((v)=>!!v);
    const qs = new URLSearchParams(q).toString();
    return `${path}${qs ? `?${qs}` : ''}`;
};

});

parcelRegister("fCcRT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4cc94b3364931bb$export$2e2bcd8739ae039);

var $j74qU = parcelRequire("j74qU");

var $l116g = parcelRequire("l116g");

const $a4cc94b3364931bb$var$getSyncs = async (query, pathParamTeamId)=>{
    const page = parseInt(query['page']) || 1;
    const offset = (page - 1) * (0, $85d01ad7b2541e2c$export$31ecae7225aecec6);
    const queryParams = query ? {
        teamId: pathParamTeamId ?? query.teamId,
        type: query.type,
        keyword: query.keyword,
        status: query.status
    } : {};
    return (0, $j74qU.eocFetch)((0, $l116g.UrlHelper)('/v1/entity-sync/unified', {
        ...queryParams,
        offset: offset.toString(),
        limit: (0, $85d01ad7b2541e2c$export$31ecae7225aecec6)
    })).then((response)=>({
            data: response.data.integrations,
            pageCount: Math.ceil(response.data.count / (0, $85d01ad7b2541e2c$export$31ecae7225aecec6)),
            itemCount: response.data.count
        }));
};
const $a4cc94b3364931bb$var$patchSync = async (syncId, syncType, body, teamId)=>(0, $j74qU.eocFetch)((0, $l116g.UrlHelper)(`/v1/entity-sync/unified/${syncId}`, {
        type: syncType,
        teamId: teamId
    }), {
        method: 'PATCH',
        body: body
    }).then((response)=>response.data);
const $a4cc94b3364931bb$var$deleteSync = async (syncId, syncType, teamId)=>(0, $j74qU.eocFetch)((0, $l116g.UrlHelper)(`/v1/entity-sync/unified/${syncId}`, {
        type: syncType,
        teamId: teamId
    }), {
        method: 'DELETE',
        responseType: 'headers'
    });
var $a4cc94b3364931bb$export$2e2bcd8739ae039 = {
    getSyncs: $a4cc94b3364931bb$var$getSyncs,
    patchSync: $a4cc94b3364931bb$var$patchSync,
    deleteSync: $a4cc94b3364931bb$var$deleteSync
};

});
const $85d01ad7b2541e2c$export$31ecae7225aecec6 = 20;



parcelRegister("1YfAT", function(module, exports) {

$parcel$export(module.exports, "isCurrentSiteSyncEnabledResource", () => $53dacb41f1b977c2$export$94465df791bf80);

var $2M1hQ = parcelRequire("2M1hQ");

var $9d6Ve = parcelRequire("9d6Ve");
const $53dacb41f1b977c2$export$94465df791bf80 = (0, $2M1hQ.createResource)({
    type: 'isCurrentSiteSyncEnabledResource',
    getKey: ()=>`isCurrentSiteSyncEnabledResource`,
    getData: (0, $9d6Ve.getIsCurrentSiteSyncEnabled),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("9d6Ve", function(module, exports) {

$parcel$export(module.exports, "getIsCurrentSiteSyncEnabled", () => $84b302591901e719$export$93fc09e39edf63d0);

var $j74qU = parcelRequire("j74qU");
const $84b302591901e719$export$93fc09e39edf63d0 = ()=>(0, $j74qU.eocFetch)(`/v1/entity-sync/is-current-site-enabled`).then((response)=>response.data.enabled);

});


parcelRegister("7J53H", function(module, exports) {

$parcel$export(module.exports, "getTeamResource", () => $3559e86ca19d1712$export$50271c9e7f21f10e);

var $2M1hQ = parcelRequire("2M1hQ");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $7n8Dv = parcelRequire("7n8Dv");
const $3559e86ca19d1712$export$50271c9e7f21f10e = (0, $2M1hQ.createResource)({
    type: 'getSyncTeamResource',
    getKey: (routerContext)=>`getSyncTeamResource#${routerContext.match.params?.teamId}`,
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $hmVmJ.assert)(!!teamId, new (0, $dH6Pi.AssertionError)('getTeamResource', 'teamId should be set to fetch the team'));
        const result = await (0, $7n8Dv.getTeam)(teamId);
        return result ?? null;
    },
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("7n8Dv", function(module, exports) {

$parcel$export(module.exports, "getTeam", () => $5f911005aed87c97$export$491fe77f22ab2b51);

var $j74qU = parcelRequire("j74qU");
const $5f911005aed87c97$export$491fe77f22ab2b51 = (teamId)=>(0, $j74qU.eocFetch)(`/v1/alerts/responders/names`, {
        method: 'POST',
        body: {
            responders: [
                {
                    id: teamId,
                    type: 'team'
                }
            ]
        }
    }).then((response)=>response.values.filter((responder)=>!responder.deleted).at(0));

});


parcelRegister("eyLtQ", function(module, exports) {

$parcel$export(module.exports, "userAccessRightsResource", () => $85ca4565e2692c52$export$69ddc7cc64ae9a02);

var $2M1hQ = parcelRequire("2M1hQ");

var $3mt67 = parcelRequire("3mt67");
const $85ca4565e2692c52$export$69ddc7cc64ae9a02 = (0, $2M1hQ.createResource)({
    type: 'userAccessRightsResource',
    getKey: ()=>'userAccessRightsResource',
    getData: (routerContext)=>(0, $3mt67.getUserRights)(routerContext.match.params.teamId),
    maxAge: 600000,
    isBrowserOnly: true
});

});
parcelRegister("3mt67", function(module, exports) {

$parcel$export(module.exports, "getUserRights", () => $565f7a833d907135$export$84e2ed279bc4e64e);

var $j74qU = parcelRequire("j74qU");

var $l116g = parcelRequire("l116g");
const $565f7a833d907135$export$84e2ed279bc4e64e = (teamId)=>{
    return (0, $j74qU.eocFetch)((0, $l116g.UrlHelper)(`/v1/entity-sync/unified/rights`, {
        teamId: teamId
    })).then((response)=>response.data.userAccessRights);
};

});



parcelRegister("1GLKn", function(module, exports) {

$parcel$export(module.exports, "eocAlertIssueSyncingCreateRoute", () => $cfb9010ddff8a27d$export$f271eef5f9ec6602);
const $cfb9010ddff8a27d$export$f271eef5f9ec6602 = {
    name: 'eoc-alert-issue-syncing-create',
    path: '/jira/settings/products/ops/syncs/create',
    exact: true
};

});

parcelRegister("hUyS9", function(module, exports) {

$parcel$export(module.exports, "LazyHorizontalOperationsConfigurationNav", () => $3b531790406897bf$export$aea682543f08e131);
$parcel$export(module.exports, "AsyncHorizontalOperationsConfigurationNav", () => $3b531790406897bf$export$1f7a0efe3746ea0d);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $3b531790406897bf$export$aea682543f08e131 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("hS33m")).then(({ HorizontalOperationsConfiguration: HorizontalOperationsConfiguration })=>HorizontalOperationsConfiguration), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/horizontal-nav-operations-configuration/src/ui/index.tsx"
});
const $3b531790406897bf$export$1f7a0efe3746ea0d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jira-operations-configurations-horizontal-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "asyncHorizontalOperationsConfigurationNav",
        packageName: "jiraOperationsConfigurationsHorizontalNav",
        fallback: "flag",
        teamName: "50cent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3b531790406897bf$export$aea682543f08e131, null)));

});
parcelRegister("hS33m", function(module, exports) {

let $d029d9177e9da62e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d029d9177e9da62e$var$load("9MqkJ").then(()=>parcelRequire('8WIBW'));

});


parcelRegister("7s8Fa", function(module, exports) {

$parcel$export(module.exports, "LazySidebarContent", () => $0ac1c74f5a7f2a66$export$5cb783b45e692ee9);
$parcel$export(module.exports, "default", () => $0ac1c74f5a7f2a66$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $cnlm7 = parcelRequire("cnlm7");

var $i8077 = parcelRequire("i8077");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $0ac1c74f5a7f2a66$export$5cb783b45e692ee9 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("k9PIF")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/operations/src/ui/main.tsx"
});
const $0ac1c74f5a7f2a66$var$AsyncSidebar = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.operations-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsOperationsSettings",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cnlm7.SidebarContent), {
        currentPageName: "operations",
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-operations.ui.sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.global-settings.operations-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8077.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ac1c74f5a7f2a66$export$5cb783b45e692ee9, null))));
};
var $0ac1c74f5a7f2a66$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($0ac1c74f5a7f2a66$var$AsyncSidebar);

});
parcelRegister("cnlm7", function(module, exports) {

$parcel$export(module.exports, "SidebarContent", () => $eb45bd1b3d8207f6$export$49e8f7b58a4df4ea);

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $gSZmd = parcelRequire("gSZmd");
var $3yxBH = parcelRequire("3yxBH");
var $6DDUb = parcelRequire("6DDUb");

var $koVbs = parcelRequire("koVbs");

var $iI75Y = parcelRequire("iI75Y");

var $9GB5z = parcelRequire("9GB5z");

var $jDuwy = parcelRequire("jDuwy");
const $eb45bd1b3d8207f6$export$49e8f7b58a4df4ea = ({ children: children, currentPageName: currentPageName, testId: testId = 'navigation-apps-sidebar-nav4-sidebars-settings-global-common.ui.sidebar-content' })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6DDUb.SideNavHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200",
        xcss: $eb45bd1b3d8207f6$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        grow: "hug",
        space: "space.100",
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-common.ui.sidebar-content.header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iI75Y.BackButton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "small",
        as: "h2"
    }, formatMessage((0, $jDuwy.default).heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9GB5z.AsyncPageSwitcher), {
        currentPageName: currentPageName
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3yxBH.SideNavContent), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gSZmd.MenuList), null, children)));
};
const $eb45bd1b3d8207f6$var$headingStyles = (0, $8CUq3.xcss)({
    // 4px of left padding is added to align the back icon with the side nav toggle button
    paddingInlineStart: 'space.050'
});

});
parcelRegister("6DDUb", function(module, exports) {

$parcel$export(module.exports, "SideNavHeader", () => $872964f12a4b72df$export$9d28ff3a0d89869c);
/* side-nav-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $872964f12a4b72df$var$styles = {
    root: "_18zrutpp _1q51utpp _85i51b66"
};
const $872964f12a4b72df$export$9d28ff3a0d89869c = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            $872964f12a4b72df$var$styles.root
        ]),
        children: children
    });
};

});

parcelRegister("iI75Y", function(module, exports) {

$parcel$export(module.exports, "BackButton", () => $8c6efbfad9d4699a$export$e0d897ee21382f67);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");
var $krXdA = parcelRequire("krXdA");

var $ctqwA = parcelRequire("ctqwA");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $cSD7y = parcelRequire("cSD7y");

var $jKa0E = parcelRequire("jKa0E");

var $dJXtD = parcelRequire("dJXtD");
const $8c6efbfad9d4699a$export$e0d897ee21382f67 = (0, $cSD7y.componentWithFG)('blu-5799-jira-software-board-entrypoint-route', $8c6efbfad9d4699a$var$BackButtonNew, $8c6efbfad9d4699a$var$BackButtonOld);
function $8c6efbfad9d4699a$var$BackButtonOld() {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { goBack: goBack } = (0, $jKa0E.useNavigateBack)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $dJXtD.default).tooltip),
        hideTooltipOnMouseDown: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ctqwA))),
        label: formatMessage((0, $dJXtD.default).label),
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'sidebarBackButton');
            goBack();
        }
    }));
}
function $8c6efbfad9d4699a$var$BackButtonNew() {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { previousUrl: previousUrl } = (0, $jKa0E.useNavigateBack)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $dJXtD.default).tooltip),
        hideTooltipOnMouseDown: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $krXdA.default), {
        href: previousUrl || '',
        appearance: "subtle",
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ctqwA))),
        label: formatMessage((0, $dJXtD.default).label),
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'sidebarBackButton');
        }
    }));
}

});
parcelRegister("jKa0E", function(module, exports) {

$parcel$export(module.exports, "useNavigateBack", () => $e131d9d1fc634955$export$7ce1f551d78f9130);
$parcel$export(module.exports, "NavigateBackProvider", () => $e131d9d1fc634955$export$e1e76f4ee7f8174d);

var $5uXOq = parcelRequire("5uXOq");

var $dIHnK = parcelRequire("dIHnK");

var $bmKPg = parcelRequire("bmKPg");
var $lVJAU = parcelRequire("lVJAU");

var $bOr6i = parcelRequire("bOr6i");
const $e131d9d1fc634955$var$STORAGE_KEY = 'back-button-url';
const $e131d9d1fc634955$var$NavigateBackContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $e131d9d1fc634955$export$7ce1f551d78f9130 = ()=>{
    const context = (0, $5uXOq.useContext)($e131d9d1fc634955$var$NavigateBackContext);
    if (!context) throw new Error('useNavigateBack must be used within a NavigateBackProvider');
    return context;
};
function $e131d9d1fc634955$export$e1e76f4ee7f8174d({ children: children }) {
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const [projectKey] = (0, $bmKPg.usePathParam)('projectKey');
    const defaultInitialUrl = projectKey ? `/projects/${projectKey}` : (0, $dIHnK.jiraHomeRoute).path;
    const [previousUrl, setPreviousUrl] = (0, $5uXOq.useState)(()=>(0, $bOr6i.storageProvider).get($e131d9d1fc634955$var$STORAGE_KEY) ?? defaultInitialUrl);
    const saveCurrentRoute = (0, $5uXOq.useCallback)((currentUrl)=>{
        setPreviousUrl(currentUrl);
        (0, $bOr6i.storageProvider).set($e131d9d1fc634955$var$STORAGE_KEY, currentUrl);
    }, []);
    // Remove this method when cleaning up blu-5799-jira-software-board-entrypoint-route
    const goBack = (0, $5uXOq.useCallback)(()=>push(previousUrl ?? defaultInitialUrl), [
        defaultInitialUrl,
        previousUrl,
        push
    ]);
    const value = (0, $5uXOq.useMemo)(()=>({
            saveCurrentRoute: saveCurrentRoute,
            goBack: goBack,
            previousUrl: previousUrl
        }), [
        saveCurrentRoute,
        goBack,
        previousUrl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e131d9d1fc634955$var$NavigateBackContext.Provider, {
        value: value
    }, children);
}

});
parcelRegister("bOr6i", function(module, exports) {

$parcel$export(module.exports, "storageProvider", () => $36fbcced1b17c587$export$ce7751641b93537d);

var $eNf8a = parcelRequire("eNf8a");
const $36fbcced1b17c587$export$ce7751641b93537d = (0, $eNf8a.createSessionStorageProvider)('sidebar-navigation');

});


parcelRegister("dJXtD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b400b92991a2960$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0b400b92991a2960$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltip: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-back-button.back-button.tooltip",
        "defaultMessage": "Go back"
    },
    label: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-back-button.back-button.label",
        "defaultMessage": "Navigate back to the previous page"
    }
});

});


parcelRegister("9GB5z", function(module, exports) {

$parcel$export(module.exports, "AsyncPageSwitcher", () => $8f72ed6ff9af1bd8$export$3130bd98029942c);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");
const $8f72ed6ff9af1bd8$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8f72ed6ff9af1bd8$var$headingSkeleton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8f72ed6ff9af1bd8$var$dropdownSkeleton
    }));

const $8f72ed6ff9af1bd8$var$LazyPageSwitcher = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("fGXvJ")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/common/src/common/ui/page-switcher/main.tsx"
});
const $8f72ed6ff9af1bd8$export$3130bd98029942c = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.global-settings.page-switcher",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8f72ed6ff9af1bd8$export$8f31e4c4a37b8e9c, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8f72ed6ff9af1bd8$var$LazyPageSwitcher, props));
const $8f72ed6ff9af1bd8$var$headingSkeleton = (0, $8CUq3.xcss)({
    backgroundColor: 'color.skeleton',
    width: '50%',
    height: "var(--ds-space-200, 16px)",
    borderRadius: 'border.radius.100'
});
const $8f72ed6ff9af1bd8$var$dropdownSkeleton = (0, $8CUq3.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});

});
parcelRegister("fGXvJ", function(module, exports) {

let $b6c8f0e389ff7faf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b6c8f0e389ff7faf$var$load("gpJf2").then(()=>parcelRequire('8dyHT'));

});


parcelRegister("jDuwy", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfdc401436033e3a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $dfdc401436033e3a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    heading: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-common.sidebar-content.heading",
        "defaultMessage": "Jira admin settings"
    }
});

});


parcelRegister("i8077", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $8a8cf6e18096ea33$export$8f31e4c4a37b8e9c);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");
const $8a8cf6e18096ea33$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8a8cf6e18096ea33$var$sectionHeading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8a8cf6e18096ea33$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8a8cf6e18096ea33$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8a8cf6e18096ea33$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8a8cf6e18096ea33$var$sectionHeading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8a8cf6e18096ea33$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8a8cf6e18096ea33$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8a8cf6e18096ea33$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8a8cf6e18096ea33$var$menuItem
    }));
const $8a8cf6e18096ea33$var$sectionHeading = (0, $8CUq3.xcss)({
    backgroundColor: 'color.skeleton',
    width: '50%',
    height: "var(--ds-space-200, 16px)",
    borderRadius: 'border.radius.100',
    marginTop: 'space.100'
});
const $8a8cf6e18096ea33$var$menuItem = (0, $8CUq3.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});

});

parcelRegister("k9PIF", function(module, exports) {

let $eaccc454a1ed4820$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eaccc454a1ed4820$var$load("8ybFV").then(()=>parcelRequire('8wx8h'));

});


parcelRegister("jh1uq", function(module, exports) {

$parcel$export(module.exports, "AlertIssueSync", () => $7deb342e59ce2af6$export$5a4922ba79d730f4);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $a5NQf = parcelRequire("a5NQf");
const $7deb342e59ce2af6$export$5a4922ba79d730f4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $a5NQf.LazyAlertIssueSync),
        pageId: "async-jira-eoc-alert-issue-syncing",
        shouldShowSpinner: true
    });

});
parcelRegister("a5NQf", function(module, exports) {

$parcel$export(module.exports, "LazyAlertIssueSync", () => $d2634f336818750c$export$dbbcce89c7be1e71);
$parcel$export(module.exports, "LazyAlertIssueSyncCreate", () => $d2634f336818750c$export$ff3e9ed7471eebce);
$parcel$export(module.exports, "LazyAlertIssueSyncDetail", () => $d2634f336818750c$export$75137a2a583918e2);

var $kxZPA = parcelRequire("kxZPA");

const $d2634f336818750c$export$dbbcce89c7be1e71 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("5Esgo")).then((module)=>module.AlertIssueSync), {
    moduleId: "./src/packages/eoc/eoc-alert-issue-syncing/src/index.tsx"
});

const $d2634f336818750c$export$ff3e9ed7471eebce = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("5Esgo")).then((module)=>module.AlertIssueSyncCreate), {
    moduleId: "./src/packages/eoc/eoc-alert-issue-syncing/src/index.tsx"
});

const $d2634f336818750c$export$75137a2a583918e2 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("5Esgo")).then((module)=>module.AlertIssueSyncDetail), {
    moduleId: "./src/packages/eoc/eoc-alert-issue-syncing/src/index.tsx"
});

});
parcelRegister("5Esgo", function(module, exports) {

let $41d69cb5765bc78b$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $41d69cb5765bc78b$var$load("ffQaD"),
    $41d69cb5765bc78b$var$load("kvRbA"),
    $41d69cb5765bc78b$var$load("9WAxB")
]).then(()=>parcelRequire('gAySz'));

});



parcelRegister("3dgEU", function(module, exports) {

$parcel$export(module.exports, "AlertIssueSyncCreate", () => $8b1bb3d27124393c$export$a26f24c49385cf3a);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $a5NQf = parcelRequire("a5NQf");
const $8b1bb3d27124393c$export$a26f24c49385cf3a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $a5NQf.LazyAlertIssueSyncCreate),
        pageId: "async-jira-eoc-alert-issue-syncing",
        shouldShowSpinner: true
    });

});


parcelRegister("8m0RN", function(module, exports) {

$parcel$export(module.exports, "eocAlertIssueSyncingDetailRouteEntry", () => $ea4b5ca423fc7b5e$export$7e604b22ae6e7c1e);

var $6YWw1 = parcelRequire("6YWw1");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $8cx1L = parcelRequire("8cx1L");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

var $jh1uq = parcelRequire("jh1uq");

var $fzxhM = parcelRequire("fzxhM");

var $a5NQf = parcelRequire("a5NQf");
const $ea4b5ca423fc7b5e$var$getNavigationSpecifications = ()=>{
    return (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $ea4b5ca423fc7b5e$export$7e604b22ae6e7c1e = (0, $7NszV.createEntry)((0, $8cx1L.eocAlertIssueSyncingDetailRoute), ()=>({
        group: 'eoc',
        component: (0, $jh1uq.AlertIssueSync),
        slot: (0, $fzxhM.AlertIssueSyncDetail),
        basePath: '/jira/settings/products/ops',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $6YWw1.resources).configuredSyncsResource,
            (0, $6YWw1.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$ea4b5ca423fc7b5e$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a5NQf.LazyAlertIssueSync)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a5NQf.LazyAlertIssueSync)
        ]
    }));

});
parcelRegister("8cx1L", function(module, exports) {

$parcel$export(module.exports, "eocAlertIssueSyncingDetailRoute", () => $2a3279be22ec7e63$export$f1b4093ef603b98d);
const $2a3279be22ec7e63$export$f1b4093ef603b98d = {
    name: 'eoc-alert-issue-syncing-detail',
    path: '/jira/settings/products/ops/syncs/:syncId',
    exact: true
};

});

parcelRegister("fzxhM", function(module, exports) {

$parcel$export(module.exports, "AlertIssueSyncDetail", () => $f855872703199c2e$export$c21f2a7e1aa801a7);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $a5NQf = parcelRequire("a5NQf");
const $f855872703199c2e$export$c21f2a7e1aa801a7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $a5NQf.LazyAlertIssueSyncDetail),
        pageId: "async-jira-eoc-alert-issue-syncing",
        shouldShowSpinner: true
    });

});


parcelRegister("dt3ZS", function(module, exports) {

$parcel$export(module.exports, "eocAlertIssueSyncingRouteEntry", () => $4abc338af93c95e0$export$c63d0942ec0f93c);

var $6YWw1 = parcelRequire("6YWw1");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $eZXFU = parcelRequire("eZXFU");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $hIYBE = parcelRequire("hIYBE");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

var $a5NQf = parcelRequire("a5NQf");

var $jh1uq = parcelRequire("jh1uq");
const $4abc338af93c95e0$var$getNavigationSpecifications = ()=>{
    return (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $4abc338af93c95e0$export$c63d0942ec0f93c = (0, $7NszV.createEntry)((0, $hIYBE.eocAlertIssueSyncingRoute), ()=>({
        group: 'eoc',
        component: (0, $jh1uq.AlertIssueSync),
        slot: null,
        basePath: '/jira/settings/products/ops',
        layout: (0, $eZXFU.opsSettingsLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $6YWw1.resources).configuredSyncsResource,
            (0, $6YWw1.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$4abc338af93c95e0$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a5NQf.LazyAlertIssueSync)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a5NQf.LazyAlertIssueSync)
        ]
    }));

});
parcelRegister("eZXFU", function(module, exports) {

$parcel$export(module.exports, "opsSettingsLayout", () => $bb0ecde8d2515afe$export$96d5e7da242cacf9);
$parcel$export(module.exports, "opsMigrationHubLayout", () => $bb0ecde8d2515afe$export$d4e92309ebd00b0f);
$parcel$export(module.exports, "opsNotificationsLayout", () => $bb0ecde8d2515afe$export$5714bc9520dbc6cf);

var $aPfsS = parcelRequire("aPfsS");

var $kxZPA = parcelRequire("kxZPA");

var $cSD7y = parcelRequire("cSD7y");

var $ibkIl = parcelRequire("ibkIl");

var $2BrOV = parcelRequire("2BrOV");

const $bb0ecde8d2515afe$export$f61c80ac3b95bc7d = (0, $cSD7y.componentWithFG)('operations-migration-hub-jira', // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("civVw")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/ops-settings-layout/src/ui/right-sidebars/index.tsx"
}), ()=>null);
$bb0ecde8d2515afe$export$f61c80ac3b95bc7d.displayName = 'RightSidebars';

const $bb0ecde8d2515afe$export$70238cd3868b67c9 = (0, $cSD7y.componentWithFG)('operations-migration-hub-jira', // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("dgrxE")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/ops-settings-layout/src/ui/onboarding/index.tsx"
}), ()=>null);
$bb0ecde8d2515afe$export$70238cd3868b67c9.displayName = 'Onboarding';
const $bb0ecde8d2515afe$export$96d5e7da242cacf9 = (0, $aPfsS.composeLayouts)((0, $ibkIl.globalSettingsLayout), {
    get globalComponents () {
        return [
            $bb0ecde8d2515afe$export$70238cd3868b67c9
        ];
    },
    rightSidebars: [
        $bb0ecde8d2515afe$export$f61c80ac3b95bc7d
    ]
});
const $bb0ecde8d2515afe$export$d4e92309ebd00b0f = (0, $aPfsS.createLayout)({
    get globalComponents () {
        return [
            $bb0ecde8d2515afe$export$70238cd3868b67c9
        ];
    },
    rightSidebars: [
        $bb0ecde8d2515afe$export$f61c80ac3b95bc7d
    ]
});
const $bb0ecde8d2515afe$export$5714bc9520dbc6cf = (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), {
    get globalComponents () {
        return [
            $bb0ecde8d2515afe$export$70238cd3868b67c9
        ];
    },
    rightSidebars: [
        $bb0ecde8d2515afe$export$f61c80ac3b95bc7d
    ]
});

});

parcelRegister("hIYBE", function(module, exports) {

$parcel$export(module.exports, "eocAlertIssueSyncingRoute", () => $8f63b88635f620d8$export$73d6a0dc298aae15);
const $8f63b88635f620d8$export$73d6a0dc298aae15 = {
    name: 'eoc-alert-issue-syncing',
    path: '/jira/settings/products/ops/syncs',
    exact: true
};

});


parcelRegister("GJOha", function(module, exports) {

$parcel$export(module.exports, "eocApiKeyManagementRouteEntry", () => $e19c93c774607b0f$export$e18a6be3d2ffad71);

var $2T8SP = parcelRequire("2T8SP");

var $ffza4 = parcelRequire("ffza4");

var $eZXFU = parcelRequire("eZXFU");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $eum5y = parcelRequire("eum5y");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");

var $7s8Fa = parcelRequire("7s8Fa");

var $gZxlv = parcelRequire("gZxlv");
const $e19c93c774607b0f$var$getNavigationSpecifications = ()=>{
    return (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $e19c93c774607b0f$export$e18a6be3d2ffad71 = (0, $7NszV.createEntry)((0, $eum5y.eocApiKeyManagementRoute), ()=>({
        group: 'eoc',
        component: (0, $gZxlv.default),
        layout: (0, $eZXFU.opsSettingsLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$e19c93c774607b0f$var$getNavigationSpecifications()
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $2T8SP.resources)()
        ],
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gZxlv.LazyApiKeyManagement)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gZxlv.LazyApiKeyManagement)
        ]
    }));

});
parcelRegister("2T8SP", function(module, exports) {

$parcel$export(module.exports, "apiKeysResource", () => $78235b6a5aa26e7e$export$a98d5421eda11f29);
$parcel$export(module.exports, "resources", () => $78235b6a5aa26e7e$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");
parcelRequire("jxRF2");
var $ldKOT = parcelRequire("ldKOT");

var $3do1I = parcelRequire("3do1I");
const $78235b6a5aa26e7e$export$a98d5421eda11f29 = (0, $2M1hQ.createResource)({
    type: 'api-key-management',
    getKey: ()=>'api-key-management',
    getData: async ({ dependencies: dependencies })=>{
        const data = await dependencies[(0, $ldKOT.eocUserResource).type]?.promise;
        return (0, $3do1I.fetchKeys)(data.accountId);
    },
    isBrowserOnly: true,
    maxCache: 0,
    maxAge: 0,
    depends: [
        (0, $ldKOT.eocUserResource).type
    ]
});
const $78235b6a5aa26e7e$export$bc99aaabaf7b70a7 = ()=>[
        (0, $ldKOT.eocUserResource),
        $78235b6a5aa26e7e$export$a98d5421eda11f29
    ];

});
parcelRegister("jxRF2", function(module, exports) {

$parcel$export(module.exports, "eocCommonResources", () => $9675469e92ce170a$export$8977bbbf2f7167d2);
$parcel$export(module.exports, "eocUserResource", () => (parcelRequire("ldKOT")).eocUserResource);

var $ldKOT = parcelRequire("ldKOT");
const $9675469e92ce170a$export$8977bbbf2f7167d2 = ()=>[
        (0, $ldKOT.eocUserResource)
    ];

});
parcelRegister("ldKOT", function(module, exports) {

$parcel$export(module.exports, "eocUserResource", () => $0e22e6fd8475b5e0$export$3a08a0bdeef86956);

var $2M1hQ = parcelRequire("2M1hQ");

var $jonVZ = parcelRequire("jonVZ");
const $0e22e6fd8475b5e0$export$3a08a0bdeef86956 = (0, $2M1hQ.createResource)({
    type: 'create-user-resource',
    getKey: ()=>'create-user-resource',
    getData: async ()=>(0, $jonVZ.fetchJsmUserInfo)(),
    maxAge: Infinity,
    isBrowserOnly: true
});

});
parcelRegister("jonVZ", function(module, exports) {

$parcel$export(module.exports, "fetchJsmUserInfo", () => $189024051479d227$export$7d750310098b5a7);

var $j74qU = parcelRequire("j74qU");
var $030R0 = parcelRequire("030R0");
const $189024051479d227$var$JSM_BASE_URL = '/rest/api/3/myself';
const $189024051479d227$export$7d750310098b5a7 = ()=>{
    return (0, $j74qU.eocFetch)($189024051479d227$var$JSM_BASE_URL, {
        exactUrl: true,
        errorTransformer: (0, $030R0.jsmErrorTransformer)
    });
};

});



parcelRegister("3do1I", function(module, exports) {

$parcel$export(module.exports, "fetchKeys", () => $064b2b209b19aeee$export$a0d93e1b78b8e70b);
$parcel$export(module.exports, "deleteApiKey", () => $064b2b209b19aeee$export$d2f8649a375a4113);

var $j74qU = parcelRequire("j74qU");
const $064b2b209b19aeee$export$a0d93e1b78b8e70b = async (accountId)=>{
    return (0, $j74qU.eocFetch)('/api-keys/web?accountId=' + accountId);
};
const $064b2b209b19aeee$export$d2f8649a375a4113 = async (key, accountId)=>{
    return (0, $j74qU.eocFetch)(`/api-keys/web?apiKey=${key}&accountId=${accountId}`, {
        method: 'DELETE'
    });
};

});


parcelRegister("eum5y", function(module, exports) {

$parcel$export(module.exports, "eocApiKeyManagementRoute", () => $3dba976dd77ba6a7$export$84985159d5695f4d);
const $3dba976dd77ba6a7$export$84985159d5695f4d = {
    name: 'eoc-api-key-management',
    path: '/jira/settings/products/ops/api-key-management',
    exact: true
};

});

parcelRegister("gZxlv", function(module, exports) {

$parcel$export(module.exports, "LazyApiKeyManagement", () => $eddc6a8c98318a70$export$6ae4b26c31b1b0d2);
$parcel$export(module.exports, "default", () => $eddc6a8c98318a70$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $eddc6a8c98318a70$export$6ae4b26c31b1b0d2 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("aA2bD")), {
    moduleId: "./src/packages/eoc/api-key-management/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$eddc6a8c98318a70$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $eddc6a8c98318a70$export$6ae4b26c31b1b0d2,
        pageId: "async-jira-eoc-api-key-management",
        shouldShowSpinner: false
    });

});
parcelRegister("aA2bD", function(module, exports) {

let $7b3ef66142419a7e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7b3ef66142419a7e$var$load("lueQq").then(()=>parcelRequire('95iLR'));

});



parcelRegister("hDU7Y", function(module, exports) {

$parcel$export(module.exports, "eocAssignCustomRolesRouteEntry", () => $34e2a1a3b5a525df$export$c51a4ee3e3f1b270);

var $jqlWU = parcelRequire("jqlWU");

var $ffza4 = parcelRequire("ffza4");

var $eZXFU = parcelRequire("eZXFU");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $2ClIR = parcelRequire("2ClIR");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

var $9Zb2K = parcelRequire("9Zb2K");
const $34e2a1a3b5a525df$var$getNavigationSpecifications = ()=>{
    return (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $34e2a1a3b5a525df$export$c51a4ee3e3f1b270 = (0, $7NszV.createEntry)((0, $2ClIR.eocAssignCustomRolesRoute), ()=>({
        group: 'eoc',
        component: (0, $9Zb2K.default),
        layout: (0, $eZXFU.opsSettingsLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$34e2a1a3b5a525df$var$getNavigationSpecifications()
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $jqlWU.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $9Zb2K.LazyAssignCustomRoles)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $9Zb2K.LazyAssignCustomRoles)
        ]
    }));

});
parcelRegister("jqlWU", function(module, exports) {

$parcel$export(module.exports, "rolesResource", () => $662177b4cdfd6303$export$52e29d5915d5f674);
$parcel$export(module.exports, "resources", () => $662177b4cdfd6303$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $c4XwU = parcelRequire("c4XwU");
const $662177b4cdfd6303$export$52e29d5915d5f674 = (0, $2M1hQ.createResource)({
    type: 'rolesResource',
    getKey: ()=>'rolesResource',
    getData: (0, $c4XwU.getRolesEndpoint),
    isBrowserOnly: true
});
const $662177b4cdfd6303$export$bc99aaabaf7b70a7 = ()=>[
        $662177b4cdfd6303$export$52e29d5915d5f674
    ];

});
parcelRegister("c4XwU", function(module, exports) {

$parcel$export(module.exports, "getUsersEndpoint", () => $3d7f15d2403fdf59$export$d372f7d69e481dba);
$parcel$export(module.exports, "getFilteredUsersEndpoint", () => $3d7f15d2403fdf59$export$d8f86d9603f031c0);
$parcel$export(module.exports, "getRolesEndpoint", () => $3d7f15d2403fdf59$export$7d0bc1a3c689fc74);
$parcel$export(module.exports, "updateRoleOfUserEndpoint", () => $3d7f15d2403fdf59$export$a0b296dc0259976f);

var $j74qU = parcelRequire("j74qU");

var $3m952 = parcelRequire("3m952");
const $3d7f15d2403fdf59$export$d372f7d69e481dba = ({ lastEvaluatedToken: lastEvaluatedToken, limit: limit, queryKey: queryKey })=>{
    const [_, query] = queryKey;
    let url = new (0, $3m952.URLBuilder)(`/v1/users/search`).withQueryParam('limit', limit).withQueryParam('query', query).withQueryParam('cursor', lastEvaluatedToken).build();
    return (0, $j74qU.eocFetch)(url);
};
const $3d7f15d2403fdf59$export$d8f86d9603f031c0 = ({ lastEvaluatedToken: lastEvaluatedToken, limit: limit, queryKey: queryKey })=>{
    const [_, ...filters] = queryKey;
    if (filters.length === 0) return Promise.resolve({
        lastEvaluatedToken: '',
        values: []
    });
    return (0, $j74qU.eocFetch)('/v1/users/roles/filter', {
        method: 'POST',
        body: {
            limit: limit,
            roles: filters,
            offset: lastEvaluatedToken || 0
        }
    });
};
const $3d7f15d2403fdf59$export$7d0bc1a3c689fc74 = ()=>{
    return (0, $j74qU.eocFetch)('/v1/users/roles');
};
const $3d7f15d2403fdf59$export$a0b296dc0259976f = ({ roleId: roleId, accountId: accountId })=>{
    return (0, $j74qU.eocFetch)(`/v1/users/roles/assign`, {
        method: 'PATCH',
        body: {
            accountId: accountId,
            roleId: roleId
        }
    });
};

});
parcelRegister("3m952", function(module, exports) {

$parcel$export(module.exports, "URLBuilder", () => $3c9748f3251c69d7$export$61d2e8db329a11f8);
class $3c9748f3251c69d7$export$61d2e8db329a11f8 {
    constructor(url){
        this.url = url;
        this.params = {};
    }
    withQueryParam(key, value) {
        this.params[key] = value;
        return this;
    }
    build() {
        const filteredParams = Object.entries(this.params).filter(([, value])=>value !== undefined && value !== null && value !== '').map(([key, value])=>[
                key,
                value && value.toString()
            ]);
        const queryInstance = new URLSearchParams(filteredParams);
        const queryParams = queryInstance.toString();
        if (queryParams === '') return `${this.url}`;
        if (queryParams) return `${this.url}?${queryParams}`;
        return this.url;
    }
}

});



parcelRegister("2ClIR", function(module, exports) {

$parcel$export(module.exports, "eocAssignCustomRolesRoute", () => $fee4692ea74fc971$export$79c37191a61ac94b);
const $fee4692ea74fc971$export$79c37191a61ac94b = {
    name: 'eoc-assign-custom-roles',
    path: '/jira/settings/products/ops/role-assignment',
    exact: true
};

});

parcelRegister("9Zb2K", function(module, exports) {

$parcel$export(module.exports, "LazyAssignCustomRoles", () => $cbc95c821be59e53$export$fb6bafef9453a357);
$parcel$export(module.exports, "default", () => $cbc95c821be59e53$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $cbc95c821be59e53$export$fb6bafef9453a357 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("iXql0")), {
    moduleId: "./src/packages/eoc/assign-custom-roles/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cbc95c821be59e53$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cbc95c821be59e53$export$fb6bafef9453a357,
        pageId: "async-eoc-assign-custom-roles",
        shouldShowSpinner: false
    });

});
parcelRegister("iXql0", function(module, exports) {

let $dcd22ad258b9a946$var$load = (parcelRequire("28QjX"))(4);
module.exports = $dcd22ad258b9a946$var$load("4gFRu").then(()=>parcelRequire('i3AK8'));

});



parcelRegister("dHqTd", function(module, exports) {

$parcel$export(module.exports, "eocAutomationsRouteEntry", () => $dd0ff3cccea414a4$export$6ff606556e19e12);

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $cIZ9i = parcelRequire("cIZ9i");

var $12Bno = parcelRequire("12Bno");
const $dd0ff3cccea414a4$export$6ff606556e19e12 = (0, $7NszV.createEntry)((0, $cIZ9i.eocAutomationsRoute), ()=>({
        group: 'eoc',
        component: (0, $12Bno.default),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $2r8fH.resources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $12Bno.LazyOpsTeamAutomation),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("cIZ9i", function(module, exports) {

$parcel$export(module.exports, "eocAutomationsRoute", () => $0aa16b205f7e3033$export$4a84eb4d8d37c9d4);
const $0aa16b205f7e3033$export$4a84eb4d8d37c9d4 = {
    name: 'eoc-automations',
    path: '/jira/ops/teams/:teamId/automations',
    exact: true
};

});

parcelRegister("12Bno", function(module, exports) {

$parcel$export(module.exports, "LazyOpsTeamAutomation", () => $1cf116b0539aa5be$export$903a0a44cc0933c5);
$parcel$export(module.exports, "default", () => $1cf116b0539aa5be$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $1cf116b0539aa5be$export$903a0a44cc0933c5 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("dYPlk")), {
    moduleId: "./src/packages/spa-apps/ops-team-scope-automation/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1cf116b0539aa5be$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $1cf116b0539aa5be$export$903a0a44cc0933c5,
        pageId: "ops-team-automation",
        shouldShowSpinner: true
    });

});
parcelRegister("dYPlk", function(module, exports) {

let $a2d8b49cc094aa76$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a2d8b49cc094aa76$var$load("as200").then(()=>parcelRequire('j6Qxa'));

});



parcelRegister("9KhdI", function(module, exports) {

$parcel$export(module.exports, "eocCustomRolesRouteEntry", () => $98b5efb8026932b2$export$9c9bab95d425eb6f);

var $7ygGB = parcelRequire("7ygGB");

var $ffza4 = parcelRequire("ffza4");

var $eZXFU = parcelRequire("eZXFU");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $7WUUX = parcelRequire("7WUUX");

var $4R6GH = parcelRequire("4R6GH");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

var $7vwGd = parcelRequire("7vwGd");
const $98b5efb8026932b2$var$getNavigationSpecifications = ()=>{
    return (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $98b5efb8026932b2$export$9c9bab95d425eb6f = (0, $7NszV.createEntry)((0, $7WUUX.eocCustomRolesRoute), ()=>({
        group: 'eoc',
        component: (0, $7vwGd.default),
        layout: (0, $eZXFU.opsSettingsLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$98b5efb8026932b2$var$getNavigationSpecifications()
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $7ygGB.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7vwGd.LazyCustomRoles)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7vwGd.LazyCustomRoles)
        ]
    }));

});
parcelRegister("7ygGB", function(module, exports) {

$parcel$export(module.exports, "customRolesResource", () => $010682625a4b0c54$export$7140716a1b1b8e7a);
$parcel$export(module.exports, "resources", () => $010682625a4b0c54$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $hnjQD = parcelRequire("hnjQD");
const $010682625a4b0c54$export$7140716a1b1b8e7a = (0, $2M1hQ.createResource)({
    type: 'rolesResource',
    getKey: ()=>'rolesResource',
    getData: (0, $hnjQD.getCustomRolesListEndpoint),
    isBrowserOnly: true
});
const $010682625a4b0c54$export$bc99aaabaf7b70a7 = ()=>[
        $010682625a4b0c54$export$7140716a1b1b8e7a
    ];

});
parcelRegister("hnjQD", function(module, exports) {

$parcel$export(module.exports, "getPermissionsEndpoint", () => $32ca3dc706b725ff$export$f97b589720c51ce1);
$parcel$export(module.exports, "createCustomRoleEndpoint", () => $32ca3dc706b725ff$export$5a7187e04c844900);
$parcel$export(module.exports, "editCustomRoleEndpoint", () => $32ca3dc706b725ff$export$304735a80b86192e);
$parcel$export(module.exports, "deleteCustomRoleEndpoint", () => $32ca3dc706b725ff$export$e12995ccad013f65);
$parcel$export(module.exports, "getCustomRolesListEndpoint", () => $32ca3dc706b725ff$export$3619edac53aa59fd);

var $j74qU = parcelRequire("j74qU");
const $32ca3dc706b725ff$export$f97b589720c51ce1 = ()=>(0, $j74qU.eocFetch)(`/v1/users/permissions`);
const $32ca3dc706b725ff$export$5a7187e04c844900 = (newCustomRole)=>(0, $j74qU.eocFetch)(`/v1/users/roles`, {
        method: 'POST',
        body: newCustomRole
    });
const $32ca3dc706b725ff$export$304735a80b86192e = (updatedCustomRole)=>{
    const { id: id } = updatedCustomRole;
    return (0, $j74qU.eocFetch)(`/v1/users/roles/${id}`, {
        method: 'PATCH',
        body: updatedCustomRole
    });
};
const $32ca3dc706b725ff$export$e12995ccad013f65 = (id)=>{
    return (0, $j74qU.eocFetch)(`/v1/users/roles/${id}`, {
        method: 'DELETE'
    });
};
const $32ca3dc706b725ff$export$3619edac53aa59fd = ()=>(0, $j74qU.eocFetch)(`/v1/users/roles`);

});


parcelRegister("7WUUX", function(module, exports) {

$parcel$export(module.exports, "eocCustomRolesRoute", () => $550a6202cdc3f9f3$export$3213a7325ca9911);
const $550a6202cdc3f9f3$export$3213a7325ca9911 = {
    name: 'eoc-custom-roles',
    path: '/jira/settings/products/ops/roles',
    exact: true
};

});

parcelRegister("7vwGd", function(module, exports) {

$parcel$export(module.exports, "LazyCustomRoles", () => $ae4b2d4dc59e70bc$export$78ed54710f55f948);
$parcel$export(module.exports, "default", () => $ae4b2d4dc59e70bc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $ae4b2d4dc59e70bc$export$78ed54710f55f948 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("HcDqV")), {
    moduleId: "./src/packages/eoc/custom-roles/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ae4b2d4dc59e70bc$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ae4b2d4dc59e70bc$export$78ed54710f55f948,
        pageId: "async-eoc-custom-roles",
        shouldShowSpinner: false
    });

});
parcelRegister("HcDqV", function(module, exports) {

let $081dd151b7d5390b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $081dd151b7d5390b$var$load("hxcwJ").then(()=>parcelRequire('WACar'));

});



parcelRegister("6q1hh", function(module, exports) {

$parcel$export(module.exports, "eocGlobalAlertListRedirectRouteEntry", () => $43b8d5dd0744ff60$export$4fc438c20edc8a6f);

var $8C32n = parcelRequire("8C32n");

var $ffza4 = parcelRequire("ffza4");

var $iqZds = parcelRequire("iqZds");

var $lmyls = parcelRequire("lmyls");

var $gLQQv = parcelRequire("gLQQv");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $gKpDb = parcelRequire("gKpDb");

var $lFFGs = parcelRequire("lFFGs");
const $43b8d5dd0744ff60$export$4fc438c20edc8a6f = (0, $7NszV.createEntry)((0, $gKpDb.eocGlobalAlertListRedirectRoute), ()=>({
        group: 'eoc',
        component: (0, $lFFGs.AlertListComponent),
        layout: (0, $iqZds.eocChangeboardingLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $8C32n.resources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).HOME,
            sidebar: (0, $gLQQv.AsyncSidebarEocGlobalAlerts)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $lFFGs.LazyAlertList),
            (0, $gLQQv.LazyGlobalAlertsSidebar)
        ]
    }));

});
parcelRegister("8C32n", function(module, exports) {

$parcel$export(module.exports, "resources", () => $400eb496bca9e6a6$export$bc99aaabaf7b70a7);

var $dsMLc = parcelRequire("dsMLc");

var $jxRF2 = parcelRequire("jxRF2");

var $gQ8M0 = parcelRequire("gQ8M0");

var $oacWJ = parcelRequire("oacWJ");

var $dqLIo = parcelRequire("dqLIo");
const $400eb496bca9e6a6$export$bc99aaabaf7b70a7 = ()=>[
        (0, $dqLIo.uiPreferencesResource),
        (0, $oacWJ.savedSearchesResource),
        (0, $gQ8M0.compressionRatioResource),
        (0, $dsMLc.alertGroupingStateResource),
        ...(0, $jxRF2.eocCommonResources)()
    ];

});
parcelRegister("dsMLc", function(module, exports) {

$parcel$export(module.exports, "alertGroupingStateResource", () => $8d54a3aea4bd3982$export$722cc8285202ce44);

var $2M1hQ = parcelRequire("2M1hQ");

var $chLms = parcelRequire("chLms");
const $8d54a3aea4bd3982$var$emptyAlertGroupingState = {
    isEnabled: false,
    reason: null
};
const $8d54a3aea4bd3982$export$722cc8285202ce44 = (0, $2M1hQ.createResource)({
    type: 'alertGroupingStateResource',
    getKey: ()=>'alertGroupingStateResource',
    getData: async ()=>{
        try {
            const response = await (0, $chLms.getGroupFeatureStatus)();
            return response;
        } catch (e) {
            // Exception handling and to return emptyState
            return $8d54a3aea4bd3982$var$emptyAlertGroupingState;
        }
    },
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("chLms", function(module, exports) {

$parcel$export(module.exports, "getGroupFeatureStatus", () => $b2722648a50141bc$export$48deee62d9dfb365);

var $R6fxx = parcelRequire("R6fxx");

var $1Dhlz = parcelRequire("1Dhlz");

var $j74qU = parcelRequire("j74qU");
const $b2722648a50141bc$export$48deee62d9dfb365 = ()=>{
    const url = new (0, $1Dhlz.URLBuilder)((0, $R6fxx.withAIOpsDomainPrefix)('/v1/aiops/feature-state')).withQueryParam('featureName', 'alert-grouping').build();
    return (0, $j74qU.eocFetch)(url, {
        exactUrl: true
    });
};

});
parcelRegister("R6fxx", function(module, exports) {

$parcel$export(module.exports, "withAIOpsDomainPrefix", () => $4f10eb10adc69486$export$81c70e0016508593);

var $030R0 = parcelRequire("030R0");
const $4f10eb10adc69486$export$81c70e0016508593 = (input)=>{
    const cloudId = (0, $030R0.getMeta)('ajs-cloud-id');
    if (cloudId) return `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input;
    return input;
};

});

parcelRegister("1Dhlz", function(module, exports) {

$parcel$export(module.exports, "URLBuilder", () => $3d24b3de45ba1bce$export$61d2e8db329a11f8);
class $3d24b3de45ba1bce$export$61d2e8db329a11f8 {
    constructor(url){
        this.url = url;
        this.params = {};
    }
    withQueryParam(key, value) {
        this.params[key] = value;
        return this;
    }
    build() {
        const filteredParams = Object.entries(this.params).filter(([, value])=>value !== undefined && value !== null && value !== '');
        const queryInstance = new URLSearchParams(filteredParams);
        const queryParams = queryInstance.toString();
        if (queryParams) return `${this.url}?${queryParams}`;
        return this.url;
    }
}

});



parcelRegister("gQ8M0", function(module, exports) {

$parcel$export(module.exports, "compressionRatioResource", () => $e8d6c20659375806$export$8c912e73f758af2);

var $2M1hQ = parcelRequire("2M1hQ");

var $5AHJS = parcelRequire("5AHJS");
const $e8d6c20659375806$var$emptyCompressionBanner = {
    compressionRatio: 0,
    uniqueGroupCount: 0,
    rollingWindow: 0
};
const $e8d6c20659375806$export$8c912e73f758af2 = (0, $2M1hQ.createResource)({
    type: 'compressionRatioResource',
    getKey: ()=>'compressionRatioResource',
    getData: async ()=>{
        try {
            const response = await (0, $5AHJS.getCompressionRatio)();
            return response;
        } catch (e) {
            return $e8d6c20659375806$var$emptyCompressionBanner;
        }
    },
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("5AHJS", function(module, exports) {

$parcel$export(module.exports, "getCompressionRatio", () => $c815f27666ee738a$export$4991457f359db4f7);

var $j74qU = parcelRequire("j74qU");

var $1Z10l = parcelRequire("1Z10l");
const $c815f27666ee738a$export$4991457f359db4f7 = ()=>{
    return (0, $j74qU.eocFetch)((0, $1Z10l.withAIOpsDomainPrefix)('/v1/alert-insights/compression-ratio'), {
        exactUrl: true
    });
};

});


parcelRegister("oacWJ", function(module, exports) {

$parcel$export(module.exports, "savedSearchesResource", () => $2aab5bfe07b93543$export$d915b849e6dd786b);

var $2M1hQ = parcelRequire("2M1hQ");

var $6IJKZ = parcelRequire("6IJKZ");
const $2aab5bfe07b93543$export$d915b849e6dd786b = (0, $2M1hQ.createResource)({
    type: 'savedSearchesResource',
    getKey: ()=>'savedSearchesResource',
    getData: ()=>(0, $6IJKZ.getSavedSearchesEndpoint)(),
    maxAge: 300000,
    isBrowserOnly: true
});

});

parcelRegister("dqLIo", function(module, exports) {

$parcel$export(module.exports, "uiPreferencesResource", () => $f86ed58750791981$export$4e143f0fe4b2e025);

var $2M1hQ = parcelRequire("2M1hQ");

var $fY9nC = parcelRequire("fY9nC");
const $f86ed58750791981$export$4e143f0fe4b2e025 = (0, $2M1hQ.createResource)({
    type: 'uiPreferencesResource',
    getKey: ()=>'uiPreferencesResource',
    getData: ()=>(0, $fY9nC.getUiPreferencesEndpoint)(),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("fY9nC", function(module, exports) {

$parcel$export(module.exports, "getUiPreferencesEndpoint", () => $838fb476cee34593$export$afa4854419ed2fc8);
$parcel$export(module.exports, "updateUiPreferencesEndpoint", () => $838fb476cee34593$export$4990793476d8f783);

var $j74qU = parcelRequire("j74qU");
const $838fb476cee34593$export$afa4854419ed2fc8 = ()=>{
    return (0, $j74qU.eocFetch)('/v1/alerts/ui-preferences');
};
const $838fb476cee34593$export$4990793476d8f783 = (data)=>{
    return (0, $j74qU.eocFetch)('/v1/alerts/ui-preferences', {
        method: 'PATCH',
        body: data
    });
};

});



parcelRegister("gLQQv", function(module, exports) {

$parcel$export(module.exports, "LazyGlobalAlertsSidebar", () => $423d186a1838bb07$export$674fd99c08c90491);
$parcel$export(module.exports, "AsyncSidebarEocGlobalAlerts", () => $423d186a1838bb07$export$a1c034c1031e8711);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $kxZPA = parcelRequire("kxZPA");

const $423d186a1838bb07$export$674fd99c08c90491 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("69BST")).then((bundle)=>bundle), {
    moduleId: "./src/packages/navigation-apps/sidebar/eoc-global-alerts/src/index.tsx"
});
const $423d186a1838bb07$export$a1c034c1031e8711 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "eocGlobalAlerts"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($423d186a1838bb07$export$674fd99c08c90491, null));

});
parcelRegister("69BST", function(module, exports) {

let $47b0f8600a6fc5f3$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $47b0f8600a6fc5f3$var$load("ffQaD"),
    $47b0f8600a6fc5f3$var$load("kvRbA"),
    $47b0f8600a6fc5f3$var$load("kWm96")
]).then(()=>parcelRequire('2kjD7'));

});


parcelRegister("gKpDb", function(module, exports) {

$parcel$export(module.exports, "eocGlobalAlertListRedirectRoute", () => $672bce5b0854416a$export$491d479dc37383e9);
const $672bce5b0854416a$export$491d479dc37383e9 = {
    name: 'eoc-global-alerts-redirect',
    path: '/jira/ops',
    exact: true
};

});

parcelRegister("lFFGs", function(module, exports) {

$parcel$export(module.exports, "LazyAlertList", () => $a8d77694d1ebf81f$export$f4aafff31d950b6c);
$parcel$export(module.exports, "AlertListComponent", () => $a8d77694d1ebf81f$export$9333bfa567c9c31);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $a8d77694d1ebf81f$export$f4aafff31d950b6c = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("9m0hg")), {
    moduleId: "./src/packages/eoc/alert-list/src/ui/index.tsx"
});
const $a8d77694d1ebf81f$export$9333bfa567c9c31 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $a8d77694d1ebf81f$export$f4aafff31d950b6c,
        pageId: "async-jira-eoc-alert-list",
        shouldShowSpinner: false
    });

});
parcelRegister("9m0hg", function(module, exports) {

let $6cf6623e4f48d5a7$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6cf6623e4f48d5a7$var$load("ffQaD"),
    $6cf6623e4f48d5a7$var$load("kvRbA"),
    $6cf6623e4f48d5a7$var$load("fliVL"),
    $6cf6623e4f48d5a7$var$load("76n7a"),
    $6cf6623e4f48d5a7$var$load("l253H"),
    $6cf6623e4f48d5a7$var$load("h31HI")
]).then(()=>parcelRequire('cHlJB'));

});



parcelRegister("7LUIt", function(module, exports) {

$parcel$export(module.exports, "eocGlobalAlertListRouteEntry", () => $0edb022327e9a2a9$export$851a659e50436cff);

var $8C32n = parcelRequire("8C32n");

var $ffza4 = parcelRequire("ffza4");

var $iqZds = parcelRequire("iqZds");

var $lmyls = parcelRequire("lmyls");

var $gLQQv = parcelRequire("gLQQv");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $lUaB2 = parcelRequire("lUaB2");

var $lFFGs = parcelRequire("lFFGs");
const $0edb022327e9a2a9$export$851a659e50436cff = (0, $7NszV.createEntry)((0, $lUaB2.eocGlobalAlertListRoute), ()=>({
        group: 'eoc',
        component: (0, $lFFGs.AlertListComponent),
        layout: (0, $iqZds.eocChangeboardingLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $8C32n.resources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).HOME,
            sidebar: (0, $gLQQv.AsyncSidebarEocGlobalAlerts)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $lFFGs.LazyAlertList),
            (0, $gLQQv.LazyGlobalAlertsSidebar)
        ]
    }));

});

parcelRegister("3EMmS", function(module, exports) {

$parcel$export(module.exports, "eocGlobalAlertsDetailRouteEntry", () => $ffa726838ac9512f$export$bcb93d8198d511b9);

var $en1L8 = parcelRequire("en1L8");

var $8C32n = parcelRequire("8C32n");

var $i5qMw = parcelRequire("i5qMw");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $gLQQv = parcelRequire("gLQQv");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $lOzKo = parcelRequire("lOzKo");

var $4R6GH = parcelRequire("4R6GH");

var $gNStA = parcelRequire("gNStA");

var $lFFGs = parcelRequire("lFFGs");
const $ffa726838ac9512f$export$bcb93d8198d511b9 = (0, $7NszV.createEntry)((0, $lOzKo.eocGlobalAlertsDetailRoute), ()=>({
        group: 'eoc',
        component: (0, $lFFGs.AlertListComponent),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $8C32n.resources)(),
            ...(0, $en1L8.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('automation_discoverability_in_jsm'), (0, $i5qMw.getAutomationDiscoveryDismissResource))
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).HOME,
            sidebar: (0, $gLQQv.AsyncSidebarEocGlobalAlerts)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $lFFGs.LazyAlertList),
            (0, $gLQQv.LazyGlobalAlertsSidebar)
        ]
    }));

});
parcelRegister("en1L8", function(module, exports) {

$parcel$export(module.exports, "alertDetailResource", () => $0fd209d54dcee973$export$f918335771807ac4);
$parcel$export(module.exports, "logTypesResource", () => $0fd209d54dcee973$export$f9c57ab4d5f63686);
$parcel$export(module.exports, "entityRelationTypesResource", () => $0fd209d54dcee973$export$a5515392cb45b9f8);
$parcel$export(module.exports, "responderStatesResource", () => $0fd209d54dcee973$export$c3b70747662e5932);
$parcel$export(module.exports, "resources", () => $0fd209d54dcee973$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $6CZ6k = parcelRequire("6CZ6k");

var $VSDnB = parcelRequire("VSDnB");

var $4EUyI = parcelRequire("4EUyI");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $jxRF2 = parcelRequire("jxRF2");

var $iCk5l = parcelRequire("iCk5l");

var $4sBoT = parcelRequire("4sBoT");
const $0fd209d54dcee973$var$ALERT_DETAIL_RESOURCE_TYPE = 'alertDetailResource';
const $0fd209d54dcee973$export$f918335771807ac4 = (0, $2M1hQ.createResource)({
    type: $0fd209d54dcee973$var$ALERT_DETAIL_RESOURCE_TYPE,
    getKey: (routerContext)=>`alertDetailResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const alertId = routerContext.match.params?.id;
        (0, $hmVmJ.assert)(!!alertId, new (0, $dH6Pi.AssertionError)('alertDetailResource', 'alertId should be set to fetch alert-detail'));
        return (0, $4sBoT.getAlertDetail)(alertId);
    },
    isBrowserOnly: true
});
const $0fd209d54dcee973$export$f9c57ab4d5f63686 = (0, $2M1hQ.createResource)({
    type: 'logTypesResource',
    getKey: (routerContext)=>`logTypesResource#${routerContext.match.params.id}`,
    getData: async ()=>{
        return (0, $4sBoT.getAlertLogTypesEndpoint)();
    },
    isBrowserOnly: true
});
const $0fd209d54dcee973$export$a5515392cb45b9f8 = (0, $2M1hQ.createResource)({
    type: 'entityRelationTypesResource',
    getKey: (routerContext)=>`entityRelationTypesResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const alertId = routerContext.match.params?.id;
        const dependencies = routerContext.dependencies;
        (0, $hmVmJ.assert)(!!alertId, new (0, $dH6Pi.AssertionError)('alertDetaentityRelationTypesResourceilResource', 'alertId should be set to fetch alert-detail'));
        // if id on the url is not a valid uuid and flag is on then wait for alertDetailResource to resolve for getting id of the alert instead of tinyId
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($6CZ6k)))(alertId) && (0, $VSDnB.fg)('alert_detail_convert_tiny_id_to_alert_id')) {
            const { id: id } = await (0, $iCk5l.consumeDependency)(dependencies, $0fd209d54dcee973$var$ALERT_DETAIL_RESOURCE_TYPE);
            return (0, $4sBoT.getEntityRelationTypesEndpoint)(id);
        }
        return (0, $4sBoT.getEntityRelationTypesEndpoint)(alertId);
    },
    depends: [
        $0fd209d54dcee973$var$ALERT_DETAIL_RESOURCE_TYPE
    ],
    isBrowserOnly: true
});
const $0fd209d54dcee973$export$c3b70747662e5932 = (0, $2M1hQ.createResource)({
    type: 'responderStatesResource',
    getKey: (routerContext)=>`responderStatesResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const alertId = routerContext.match.params?.id;
        const dependencies = routerContext.dependencies;
        (0, $hmVmJ.assert)(!!alertId, new (0, $dH6Pi.AssertionError)('alertDetaentityRelationTypesResourceilResource', 'alertId should be set to fetch alert-detail'));
        // if id on the url is not a valid uuid and flag is on then wait for alertDetailResource to resolve for getting id of the alert instead of tinyId
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($6CZ6k)))(alertId) && (0, $VSDnB.fg)('alert_detail_convert_tiny_id_to_alert_id')) {
            const { id: id } = await (0, $iCk5l.consumeDependency)(dependencies, $0fd209d54dcee973$var$ALERT_DETAIL_RESOURCE_TYPE);
            return (0, $4sBoT.getResponderStatesEndpoint)(id);
        }
        return (0, $4sBoT.getResponderStatesEndpoint)(alertId);
    },
    depends: [
        $0fd209d54dcee973$var$ALERT_DETAIL_RESOURCE_TYPE
    ],
    isBrowserOnly: true
});
const $0fd209d54dcee973$export$bc99aaabaf7b70a7 = ()=>[
        $0fd209d54dcee973$export$f918335771807ac4,
        $0fd209d54dcee973$export$f9c57ab4d5f63686,
        $0fd209d54dcee973$export$c3b70747662e5932,
        $0fd209d54dcee973$export$a5515392cb45b9f8,
        (0, $4EUyI.relatedAlertGroupResource),
        ...(0, $jxRF2.eocCommonResources)()
    ];

});
parcelRegister("6CZ6k", function(module, exports) {
// Regular expression used for basic parsing of the uuid.

var $5k7LC = parcelRequire("5k7LC");
var $4d35b0145f276bfe$require$Buffer = $5k7LC.Buffer;
var $4d35b0145f276bfe$var$pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/**
 * Unparses a UUID buffer to a string. From node-uuid:
 * https://github.com/defunctzombie/node-uuid/blob/master/uuid.js
 *
 * Copyright (c) 2010-2012 Robert Kieffer
 * MIT License - http://opensource.org/licenses/mit-license.php
 *
 * @param  {Buffer} buf
 * @param  {Number=0} offset
 * @return {String}
 */ var $4d35b0145f276bfe$var$_byteToHex = [];
for(var $4d35b0145f276bfe$var$i = 0; $4d35b0145f276bfe$var$i < 256; $4d35b0145f276bfe$var$i++)$4d35b0145f276bfe$var$_byteToHex[$4d35b0145f276bfe$var$i] = ($4d35b0145f276bfe$var$i + 0x100).toString(16).substr(1);
function $4d35b0145f276bfe$var$unparse(buf, offset) {
    var i = offset || 0, bth = $4d35b0145f276bfe$var$_byteToHex;
    return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
}
/**
 * Determines whether the uuid is valid, converting
 * it from a buffer if necessary.
 *
 * @param  {String|Buffer}  uuid
 * @param  {Number=}  version
 * @return {Boolean}
 */ module.exports = function(uuid, version) {
    var parsedUuid;
    // If the uuid is a biffer, parse it...
    if ($4d35b0145f276bfe$require$Buffer.isBuffer(uuid)) parsedUuid = $4d35b0145f276bfe$var$unparse(uuid);
    else if (Object.prototype.toString.call(uuid) === '[object String]') parsedUuid = uuid;
    else return false;
    parsedUuid = parsedUuid.toLowerCase();
    // All UUIDs fit a basic schema. Match that.
    if (!$4d35b0145f276bfe$var$pattern.test(parsedUuid)) return false;
    // Now extract the version...
    if (version === undefined) version = $4d35b0145f276bfe$var$extractVersion(parsedUuid);
    else if ($4d35b0145f276bfe$var$extractVersion(parsedUuid) !== version) return false;
    switch(version){
        // For certain versions, the checks we did up to this point are fine.
        case 1:
        case 2:
            return true;
        // For versions 3 and 4, they must specify a variant.
        case 3:
        case 4:
        case 5:
            return [
                '8',
                '9',
                'a',
                'b'
            ].indexOf(parsedUuid.charAt(19)) !== -1;
        default:
            // We should only be able to reach this if the consumer explicitly
            // provided an invalid version. Prior to extractVersion we check
            // that it's 1-4 in the regex.
            throw new Error('Invalid version provided.');
    }
};
/**
 * Extracts the version from the UUID, which is (by definition) the M in
 * xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx
 *
 * @param  {String} uuid
 * @return {Number}
 */ var $4d35b0145f276bfe$var$extractVersion = module.exports.version = function(uuid) {
    return uuid.charAt(14) | 0;
};

});

parcelRegister("4EUyI", function(module, exports) {

$parcel$export(module.exports, "relatedAlertGroupResource", () => $ba8a2335e3265c9e$export$35df14c9f0cfb113);

var $2M1hQ = parcelRequire("2M1hQ");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $3jET5 = parcelRequire("3jET5");
const $ba8a2335e3265c9e$export$35df14c9f0cfb113 = (0, $2M1hQ.createResource)({
    type: 'relatedAlertGroupResource',
    getKey: (routerContext)=>`relatedAlertGroupResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const alertId = routerContext.match.params?.id;
        (0, $hmVmJ.assert)(!!alertId, new (0, $dH6Pi.AssertionError)('relatedAlertGroupResource', 'alertId should be set to fetch related alert-groups'));
        return (0, $3jET5.getRelatedAlertGroup)(alertId);
    },
    isBrowserOnly: true
});

});
parcelRegister("3jET5", function(module, exports) {

$parcel$export(module.exports, "getRelatedAlertGroup", () => $0f60bd06765f80ba$export$665e34f20aad273a);

var $j74qU = parcelRequire("j74qU");

var $4ttsA = parcelRequire("4ttsA");
const $0f60bd06765f80ba$export$665e34f20aad273a = (alertId)=>(0, $j74qU.eocFetch)((0, $4ttsA.withAIOpsDomainPrefix)(`/v1/group-insights/get-group-of-alert?alertId=${alertId}`), {
        exactUrl: true
    });

});
parcelRegister("4ttsA", function(module, exports) {

$parcel$export(module.exports, "withAIOpsDomainPrefix", () => $8fd10dbbabf74295$export$81c70e0016508593);

var $030R0 = parcelRequire("030R0");
const $8fd10dbbabf74295$export$81c70e0016508593 = (input)=>{
    const cloudId = (0, $030R0.getMeta)('ajs-cloud-id');
    if (cloudId) return `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input;
    return input;
};

});



parcelRegister("iCk5l", function(module, exports) {

$parcel$export(module.exports, "consumeDependency", () => $05390e87704874e0$export$a973ef9e17a326f);
async function $05390e87704874e0$export$a973ef9e17a326f(dependencies, key) {
    // There is an inflight request, the response is source of truth
    if (dependencies[key]?.loading) return dependencies[key]?.promise;
    if (dependencies[key]?.error) // Our dependency errored out the last time it ran, we don't have the data
    throw dependencies[key]?.error;
    // Last response is what we want
    return dependencies[key]?.data;
}

});

parcelRegister("4sBoT", function(module, exports) {

$parcel$export(module.exports, "getAlertDetail", () => $440b6c9ebfdc99cb$export$436b6d88c1865c54);
$parcel$export(module.exports, "getAlertLogTypesEndpoint", () => $440b6c9ebfdc99cb$export$97200f7e7a7d1479);
$parcel$export(module.exports, "getResponderStatesEndpoint", () => $440b6c9ebfdc99cb$export$498d1a9ea659d430);
$parcel$export(module.exports, "getEntityRelationTypesEndpoint", () => $440b6c9ebfdc99cb$export$8f96130abdd7549d);

var $j74qU = parcelRequire("j74qU");
const $440b6c9ebfdc99cb$export$436b6d88c1865c54 = (alertId)=>(0, $j74qU.eocFetch)(`/v1/alerts/${alertId}`);
const $440b6c9ebfdc99cb$export$97200f7e7a7d1479 = ()=>(0, $j74qU.eocFetch)(`/v1/alerts/logs/types`);
const $440b6c9ebfdc99cb$export$498d1a9ea659d430 = (alertId)=>(0, $j74qU.eocFetch)(`/v1/alerts/${alertId}/responder-states`);
const $440b6c9ebfdc99cb$export$8f96130abdd7549d = (alertId)=>(0, $j74qU.eocFetch)(`/v1/alerts/${alertId}/entity-relations/relation-types`).then((res)=>({
            relationTypes: res.relationTypes.sort((a, b)=>a.label.localeCompare(b.label))
        }));

});


parcelRegister("i5qMw", function(module, exports) {

$parcel$export(module.exports, "getAutomationDiscoveryDismissResource", () => $e60dab4293b0384b$export$3e9b930ef3c80543);

var $2M1hQ = parcelRequire("2M1hQ");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

const $e60dab4293b0384b$var$PROPERTY_KEY = 'jira.user.issue.automation-discoverability.panel.state';
const $e60dab4293b0384b$export$3e9b930ef3c80543 = (0, $2M1hQ.createResource)({
    type: 'getAutomationDiscoveryDismiss',
    getKey: ()=>'getAutomationDiscoveryDismiss',
    getData: async ()=>{
        try {
            const res = await (0, $eusud.performGetRequest)(`/rest/api/3/mypreferences?key=${$e60dab4293b0384b$var$PROPERTY_KEY}`);
            return res;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef)) return null;
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'getDismissData',
                    teamName: 'ITOps Phantom',
                    packageName: 'jiraEocAutomationDiscovery'
                }
            });
            throw error;
        }
    },
    maxAge: 300000
});

});

parcelRegister("lOzKo", function(module, exports) {

$parcel$export(module.exports, "eocGlobalAlertsDetailRoute", () => $e176fbe640598c13$export$d87948ea641004e2);
const $e176fbe640598c13$export$d87948ea641004e2 = {
    name: 'eoc-global-alert-detail',
    path: '/jira/ops/alerts/:id',
    exact: true
};

});


parcelRegister("4Ykyz", function(module, exports) {

$parcel$export(module.exports, "eocGlobalGroupDetailRouteEntry", () => $08aebbbf84aea52e$export$66928ab349190059);

var $8C32n = parcelRequire("8C32n");

var $eYyoJ = parcelRequire("eYyoJ");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $gLQQv = parcelRequire("gLQQv");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $7eLbt = parcelRequire("7eLbt");

var $lgLgL = parcelRequire("lgLgL");
const $08aebbbf84aea52e$export$66928ab349190059 = (0, $7NszV.createEntry)((0, $7eLbt.eocGlobalGroupDetailRoute), ()=>({
        group: 'eoc',
        component: (0, $lgLgL.default),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $eYyoJ.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $8C32n.resources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).HOME,
            sidebar: (0, $gLQQv.AsyncSidebarEocGlobalAlerts)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $lgLgL.LazyGroupDetail),
            (0, $gLQQv.LazyGlobalAlertsSidebar)
        ]
    }));

});
parcelRegister("eYyoJ", function(module, exports) {

$parcel$export(module.exports, "groupHeaderResource", () => $3cd6727337445c45$export$e6ba56f6b67069c8);
$parcel$export(module.exports, "aiSuggestionsResource", () => $3cd6727337445c45$export$94675faef1d4568b);
$parcel$export(module.exports, "resources", () => $3cd6727337445c45$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $2LFOe = parcelRequire("2LFOe");
const $3cd6727337445c45$export$e6ba56f6b67069c8 = (0, $2M1hQ.createResource)({
    type: 'groupHeaderResource',
    getKey: (routerContext)=>`groupHeaderResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const groupId = routerContext.match.params?.id;
        (0, $hmVmJ.assert)(!!groupId, new (0, $dH6Pi.AssertionError)('groupHeaderResource', 'groupId should be set to fetch group-detail-header'));
        return (0, $2LFOe.getHeaderDetails)(groupId);
    },
    isBrowserOnly: true
});
const $3cd6727337445c45$export$94675faef1d4568b = (0, $2M1hQ.createResource)({
    type: 'aiSuggestionsResource',
    getKey: (routerContext)=>`aiSuggestionsResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const groupId = routerContext.match.params?.id;
        (0, $hmVmJ.assert)(!!groupId, new (0, $dH6Pi.AssertionError)('aiSuggestionsResource', 'groupId should be set to fetch ai-suggestions for any group'));
        return (0, $2LFOe.getAISuggestions)(groupId);
    },
    isBrowserOnly: true
});
const $3cd6727337445c45$export$bc99aaabaf7b70a7 = ()=>[
        $3cd6727337445c45$export$e6ba56f6b67069c8,
        $3cd6727337445c45$export$94675faef1d4568b
    ];

});
parcelRegister("2LFOe", function(module, exports) {

$parcel$export(module.exports, "getHeaderDetails", () => $1301a416506333ce$export$c0f2e4bfcbff05d1);
$parcel$export(module.exports, "getAISuggestions", () => $1301a416506333ce$export$34bb7a15a54039a5);
$parcel$export(module.exports, "addGroupAssignee", () => $1301a416506333ce$export$bd5bdebdb6d9abb);

var $j74qU = parcelRequire("j74qU");

var $iZjKh = parcelRequire("iZjKh");
const $1301a416506333ce$export$c0f2e4bfcbff05d1 = (groupId)=>(0, $j74qU.eocFetch)((0, $iZjKh.withAIOpsPrefix)(`/v1/group-insights/${groupId}`), {
        exactUrl: true
    });
const $1301a416506333ce$export$34bb7a15a54039a5 = (groupId)=>(0, $j74qU.eocFetch)((0, $iZjKh.withAIOpsPrefix)(`/v1/group-insights/getSimilar/${groupId}`), {
        exactUrl: true
    });
const $1301a416506333ce$export$bd5bdebdb6d9abb = (groupId, assigneeId)=>(0, $j74qU.eocFetch)((0, $iZjKh.withAIOpsPrefix)(`/v1/group-insights/${groupId}/add-assignee/${assigneeId}`), {
        method: 'PUT',
        exactUrl: true
    });

});
parcelRegister("iZjKh", function(module, exports) {

$parcel$export(module.exports, "withAIOpsPrefix", () => $1bb9bc334d3aa5dc$export$5ad74397753c99a2);
$parcel$export(module.exports, "formatTimezone", () => $1bb9bc334d3aa5dc$export$26da7aa151b6684c);

var $h3SpW = parcelRequire("h3SpW");

var $ecVqv = parcelRequire("ecVqv");

var $030R0 = parcelRequire("030R0");
const $1bb9bc334d3aa5dc$export$5ad74397753c99a2 = (input)=>{
    const cloudId = (0, $030R0.getMeta)('ajs-cloud-id');
    if (cloudId) return `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input;
    return input;
};
function $1bb9bc334d3aa5dc$export$9e555a50010549c1(timezone) {
    const splittedTz = timezone.split('/');
    // EST || EST5EDT
    if (splittedTz.length === 0) return splittedTz;
    // Europe/Amsterdam || Europe/Isle_of_Man || America/North_Dakota/New_Salem
    if (splittedTz.length > 0) {
        const areaName = splittedTz[splittedTz.length - 1];
        return areaName.replace(/_/g, ' ');
    }
    return timezone;
}
function $1bb9bc334d3aa5dc$export$26da7aa151b6684c(timezone) {
    const timeZone = timezone ?? (0, $ecVqv.guessUserTimeZone)();
    return (0, $h3SpW.default)(new Date(), timeZone, `z '${$1bb9bc334d3aa5dc$export$9e555a50010549c1(timeZone)}'`);
}

});
parcelRegister("h3SpW", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6bceda90e48606f$export$2e2bcd8739ae039);

var $fwbX5 = parcelRequire("fwbX5");

var $20Ydt = parcelRequire("20Ydt");

var $fUZDr = parcelRequire("fUZDr");
function $c6bceda90e48606f$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($fwbX5)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $20Ydt.default)((0, $fUZDr.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("20Ydt", function(module, exports) {

$parcel$export(module.exports, "default", () => $177a4a9326781e30$export$2e2bcd8739ae039);

var $aR9Qf = parcelRequire("aR9Qf");

var $7NnjV = parcelRequire("7NnjV");

var $65qJO = parcelRequire("65qJO");
var $177a4a9326781e30$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $177a4a9326781e30$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($177a4a9326781e30$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $65qJO.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $7NnjV.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($aR9Qf)))(dirtyDate, formatStr, options);
}

});
parcelRegister("7NnjV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5acf32f87aff2000$export$2e2bcd8739ae039);

var $gbKiI = parcelRequire("gbKiI");

var $atfNs = parcelRequire("atfNs");
var $5acf32f87aff2000$var$MILLISECONDS_IN_MINUTE = 60000;
var $5acf32f87aff2000$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $5acf32f87aff2000$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $5acf32f87aff2000$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $5acf32f87aff2000$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $5acf32f87aff2000$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $5acf32f87aff2000$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $5acf32f87aff2000$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $5acf32f87aff2000$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $5acf32f87aff2000$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $5acf32f87aff2000$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $5acf32f87aff2000$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $5acf32f87aff2000$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $gbKiI.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $gbKiI.default)('long', date, options);
        }
    }
};
function $5acf32f87aff2000$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $atfNs.default)(timeZone, originalDate, true) / $5acf32f87aff2000$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $5acf32f87aff2000$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $5acf32f87aff2000$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $5acf32f87aff2000$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $5acf32f87aff2000$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $5acf32f87aff2000$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $5acf32f87aff2000$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $5acf32f87aff2000$var$formatTimezone(offset, dirtyDelimeter);
}
function $5acf32f87aff2000$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $5acf32f87aff2000$var$addLeadingZeros(minutes, 2);
}
var $5acf32f87aff2000$export$2e2bcd8739ae039 = $5acf32f87aff2000$var$formatters;

});
parcelRegister("gbKiI", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc9196c8c3afb37a$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $bc9196c8c3afb37a$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $bc9196c8c3afb37a$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $bc9196c8c3afb37a$var$partsTimeZone(dtf, date) : $bc9196c8c3afb37a$var$hackyTimeZone(dtf, date);
}
function $bc9196c8c3afb37a$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $bc9196c8c3afb37a$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $bc9196c8c3afb37a$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("atfNs", function(module, exports) {

$parcel$export(module.exports, "default", () => $79f8ddb775209bef$export$2e2bcd8739ae039);

var $5ffLt = parcelRequire("5ffLt");

var $iVDyo = parcelRequire("iVDyo");
var $79f8ddb775209bef$var$MILLISECONDS_IN_HOUR = 3600000;
var $79f8ddb775209bef$var$MILLISECONDS_IN_MINUTE = 60000;
var $79f8ddb775209bef$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $79f8ddb775209bef$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $79f8ddb775209bef$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $79f8ddb775209bef$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$79f8ddb775209bef$var$validateTimezone(hours)) return NaN;
        return -(hours * $79f8ddb775209bef$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $79f8ddb775209bef$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$79f8ddb775209bef$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $79f8ddb775209bef$var$MILLISECONDS_IN_HOUR + minutes * $79f8ddb775209bef$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($79f8ddb775209bef$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $79f8ddb775209bef$var$toUtcDate(date);
        var offset = $79f8ddb775209bef$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $79f8ddb775209bef$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $79f8ddb775209bef$var$toUtcDate(date) {
    return (0, $iVDyo.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $79f8ddb775209bef$var$calcOffset(date, timezoneString) {
    var tokens = (0, $5ffLt.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $iVDyo.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $79f8ddb775209bef$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $79f8ddb775209bef$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $79f8ddb775209bef$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $79f8ddb775209bef$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $79f8ddb775209bef$var$validIANATimezoneCache = {};
function $79f8ddb775209bef$var$isValidTimezoneIANAString(timeZoneString) {
    if ($79f8ddb775209bef$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $79f8ddb775209bef$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("5ffLt", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d1a95017a15ed18$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $3d1a95017a15ed18$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $3d1a95017a15ed18$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $3d1a95017a15ed18$var$partsOffset(dtf, date) : $3d1a95017a15ed18$var$hackyOffset(dtf, date);
}
var $3d1a95017a15ed18$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $3d1a95017a15ed18$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $3d1a95017a15ed18$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $3d1a95017a15ed18$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $3d1a95017a15ed18$var$dtfCache = {};
function $3d1a95017a15ed18$var$getDateTimeFormat(timeZone) {
    if (!$3d1a95017a15ed18$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $3d1a95017a15ed18$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $3d1a95017a15ed18$var$dtfCache[timeZone];
}

});

parcelRegister("iVDyo", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc7c3b6f62152086$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $dc7c3b6f62152086$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("65qJO", function(module, exports) {

$parcel$export(module.exports, "default", () => $46e7f34b08b7ff56$export$2e2bcd8739ae039);

var $aSksP = parcelRequire("aSksP");

var $jGQTC = parcelRequire("jGQTC");

var $atfNs = parcelRequire("atfNs");

var $dB2sE = parcelRequire("dB2sE");
var $46e7f34b08b7ff56$var$MILLISECONDS_IN_HOUR = 3600000;
var $46e7f34b08b7ff56$var$MILLISECONDS_IN_MINUTE = 60000;
var $46e7f34b08b7ff56$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $46e7f34b08b7ff56$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $dB2sE.default)
};
function $46e7f34b08b7ff56$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $46e7f34b08b7ff56$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($aSksP)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $46e7f34b08b7ff56$var$splitDateString(argument);
    var parseYearResult = $46e7f34b08b7ff56$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $46e7f34b08b7ff56$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $46e7f34b08b7ff56$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $atfNs.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $46e7f34b08b7ff56$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $46e7f34b08b7ff56$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $46e7f34b08b7ff56$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $46e7f34b08b7ff56$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $46e7f34b08b7ff56$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $46e7f34b08b7ff56$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $46e7f34b08b7ff56$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $46e7f34b08b7ff56$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $46e7f34b08b7ff56$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $46e7f34b08b7ff56$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $46e7f34b08b7ff56$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$46e7f34b08b7ff56$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $46e7f34b08b7ff56$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$46e7f34b08b7ff56$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $46e7f34b08b7ff56$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$46e7f34b08b7ff56$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $46e7f34b08b7ff56$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$46e7f34b08b7ff56$var$validateWeekDate(year, week)) return new Date(NaN);
        return $46e7f34b08b7ff56$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $46e7f34b08b7ff56$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$46e7f34b08b7ff56$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $46e7f34b08b7ff56$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $46e7f34b08b7ff56$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $46e7f34b08b7ff56$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$46e7f34b08b7ff56$var$validateTime(hours)) return NaN;
        return hours % 24 * $46e7f34b08b7ff56$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $46e7f34b08b7ff56$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$46e7f34b08b7ff56$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $46e7f34b08b7ff56$var$MILLISECONDS_IN_HOUR + minutes * $46e7f34b08b7ff56$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $46e7f34b08b7ff56$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$46e7f34b08b7ff56$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $46e7f34b08b7ff56$var$MILLISECONDS_IN_HOUR + minutes * $46e7f34b08b7ff56$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $46e7f34b08b7ff56$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $46e7f34b08b7ff56$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $46e7f34b08b7ff56$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $46e7f34b08b7ff56$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $46e7f34b08b7ff56$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $46e7f34b08b7ff56$var$isLeapYearIndex(year);
        if (isLeapYear && date > $46e7f34b08b7ff56$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $46e7f34b08b7ff56$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $46e7f34b08b7ff56$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $46e7f34b08b7ff56$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $46e7f34b08b7ff56$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $46e7f34b08b7ff56$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("dB2sE", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e60a3c6941934b2$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $9e60a3c6941934b2$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $9e60a3c6941934b2$export$2e2bcd8739ae039 = $9e60a3c6941934b2$var$tzPattern;

});



parcelRegister("fUZDr", function(module, exports) {

$parcel$export(module.exports, "default", () => $b96be56ec1d1e59c$export$2e2bcd8739ae039);

var $atfNs = parcelRequire("atfNs");

var $65qJO = parcelRequire("65qJO");
function $b96be56ec1d1e59c$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $65qJO.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $atfNs.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});


parcelRegister("ecVqv", function(module, exports) {

$parcel$export(module.exports, "guessUserTimeZone", () => $2b4a394b314b1777$export$6fd096fe0456f5b);
$parcel$export(module.exports, "formatDate", () => $2b4a394b314b1777$export$3ae94a2503e890a1);
$parcel$export(module.exports, "getDefaultTimes", () => $2b4a394b314b1777$export$951e947e785c998d);

var $3r0F8 = parcelRequire("3r0F8");
function $2b4a394b314b1777$export$6fd096fe0456f5b() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
function $2b4a394b314b1777$export$3ae94a2503e890a1(date, timezone = $2b4a394b314b1777$export$6fd096fe0456f5b(), format = 'PP p') {
    return (0, $3r0F8.default)(new Date(date), timezone, format);
}
const $2b4a394b314b1777$export$951e947e785c998d = ()=>{
    return [
        ...Array(24).keys()
    ].map((time)=>{
        let newTime = time.toString();
        if (newTime.length === 1) newTime = `0${time}`;
        return [
            `${newTime}:00`,
            `${newTime}:30`
        ];
    }).flatMap((time)=>time);
};

});
parcelRegister("3r0F8", function(module, exports) {

$parcel$export(module.exports, "default", () => $2804684888b12a97$export$2e2bcd8739ae039);

var $fwbX5 = parcelRequire("fwbX5");

var $3Qy0g = parcelRequire("3Qy0g");

var $6AseU = parcelRequire("6AseU");
function $2804684888b12a97$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($fwbX5)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $3Qy0g.default)((0, $6AseU.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("3Qy0g", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cd09abfa6c4a431$export$2e2bcd8739ae039);

var $aR9Qf = parcelRequire("aR9Qf");

var $lSiV5 = parcelRequire("lSiV5");

var $fzXH2 = parcelRequire("fzXH2");
var $2cd09abfa6c4a431$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $2cd09abfa6c4a431$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($2cd09abfa6c4a431$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $fzXH2.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $lSiV5.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($aR9Qf)))(dirtyDate, formatStr, options);
}

});
parcelRegister("lSiV5", function(module, exports) {

$parcel$export(module.exports, "default", () => $fecd51332a1c1e9e$export$2e2bcd8739ae039);

var $3flYX = parcelRequire("3flYX");

var $fVXeF = parcelRequire("fVXeF");
var $fecd51332a1c1e9e$var$MILLISECONDS_IN_MINUTE = 60000;
var $fecd51332a1c1e9e$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $fecd51332a1c1e9e$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $fecd51332a1c1e9e$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $fecd51332a1c1e9e$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $fecd51332a1c1e9e$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $fecd51332a1c1e9e$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $fecd51332a1c1e9e$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $fecd51332a1c1e9e$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $fecd51332a1c1e9e$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $fecd51332a1c1e9e$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $fecd51332a1c1e9e$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $fecd51332a1c1e9e$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $3flYX.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $3flYX.default)('long', date, options);
        }
    }
};
function $fecd51332a1c1e9e$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $fVXeF.default)(timeZone, originalDate, true) / $fecd51332a1c1e9e$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $fecd51332a1c1e9e$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $fecd51332a1c1e9e$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $fecd51332a1c1e9e$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $fecd51332a1c1e9e$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $fecd51332a1c1e9e$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $fecd51332a1c1e9e$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $fecd51332a1c1e9e$var$formatTimezone(offset, dirtyDelimeter);
}
function $fecd51332a1c1e9e$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $fecd51332a1c1e9e$var$addLeadingZeros(minutes, 2);
}
var $fecd51332a1c1e9e$export$2e2bcd8739ae039 = $fecd51332a1c1e9e$var$formatters;

});
parcelRegister("3flYX", function(module, exports) {

$parcel$export(module.exports, "default", () => $25d3d3067975e358$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $25d3d3067975e358$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $25d3d3067975e358$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $25d3d3067975e358$var$partsTimeZone(dtf, date) : $25d3d3067975e358$var$hackyTimeZone(dtf, date);
}
function $25d3d3067975e358$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $25d3d3067975e358$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $25d3d3067975e358$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("fVXeF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b99a20d10e092648$export$2e2bcd8739ae039);

var $fiX0E = parcelRequire("fiX0E");

var $iNdur = parcelRequire("iNdur");
var $b99a20d10e092648$var$MILLISECONDS_IN_HOUR = 3600000;
var $b99a20d10e092648$var$MILLISECONDS_IN_MINUTE = 60000;
var $b99a20d10e092648$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $b99a20d10e092648$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $b99a20d10e092648$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $b99a20d10e092648$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$b99a20d10e092648$var$validateTimezone(hours)) return NaN;
        return -(hours * $b99a20d10e092648$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $b99a20d10e092648$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$b99a20d10e092648$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $b99a20d10e092648$var$MILLISECONDS_IN_HOUR + minutes * $b99a20d10e092648$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($b99a20d10e092648$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $b99a20d10e092648$var$toUtcDate(date);
        var offset = $b99a20d10e092648$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $b99a20d10e092648$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $b99a20d10e092648$var$toUtcDate(date) {
    return (0, $iNdur.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $b99a20d10e092648$var$calcOffset(date, timezoneString) {
    var tokens = (0, $fiX0E.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $iNdur.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $b99a20d10e092648$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $b99a20d10e092648$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $b99a20d10e092648$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $b99a20d10e092648$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $b99a20d10e092648$var$validIANATimezoneCache = {};
function $b99a20d10e092648$var$isValidTimezoneIANAString(timeZoneString) {
    if ($b99a20d10e092648$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $b99a20d10e092648$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("fiX0E", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2464f81a8ba230e$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $b2464f81a8ba230e$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $b2464f81a8ba230e$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $b2464f81a8ba230e$var$partsOffset(dtf, date) : $b2464f81a8ba230e$var$hackyOffset(dtf, date);
}
var $b2464f81a8ba230e$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $b2464f81a8ba230e$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $b2464f81a8ba230e$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $b2464f81a8ba230e$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $b2464f81a8ba230e$var$dtfCache = {};
function $b2464f81a8ba230e$var$getDateTimeFormat(timeZone) {
    if (!$b2464f81a8ba230e$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $b2464f81a8ba230e$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $b2464f81a8ba230e$var$dtfCache[timeZone];
}

});

parcelRegister("iNdur", function(module, exports) {

$parcel$export(module.exports, "default", () => $dae74471898019fc$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $dae74471898019fc$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("fzXH2", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5786db9ce2d798f$export$2e2bcd8739ae039);

var $aSksP = parcelRequire("aSksP");

var $jGQTC = parcelRequire("jGQTC");

var $fVXeF = parcelRequire("fVXeF");

var $ZIcI6 = parcelRequire("ZIcI6");
var $b5786db9ce2d798f$var$MILLISECONDS_IN_HOUR = 3600000;
var $b5786db9ce2d798f$var$MILLISECONDS_IN_MINUTE = 60000;
var $b5786db9ce2d798f$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $b5786db9ce2d798f$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $ZIcI6.default)
};
function $b5786db9ce2d798f$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $b5786db9ce2d798f$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($aSksP)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $b5786db9ce2d798f$var$splitDateString(argument);
    var parseYearResult = $b5786db9ce2d798f$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $b5786db9ce2d798f$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $b5786db9ce2d798f$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $fVXeF.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $b5786db9ce2d798f$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $b5786db9ce2d798f$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $b5786db9ce2d798f$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $b5786db9ce2d798f$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $b5786db9ce2d798f$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $b5786db9ce2d798f$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $b5786db9ce2d798f$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $b5786db9ce2d798f$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $b5786db9ce2d798f$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $b5786db9ce2d798f$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $b5786db9ce2d798f$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$b5786db9ce2d798f$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $b5786db9ce2d798f$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$b5786db9ce2d798f$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $b5786db9ce2d798f$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$b5786db9ce2d798f$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $b5786db9ce2d798f$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$b5786db9ce2d798f$var$validateWeekDate(year, week)) return new Date(NaN);
        return $b5786db9ce2d798f$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $b5786db9ce2d798f$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$b5786db9ce2d798f$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $b5786db9ce2d798f$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $b5786db9ce2d798f$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $b5786db9ce2d798f$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$b5786db9ce2d798f$var$validateTime(hours)) return NaN;
        return hours % 24 * $b5786db9ce2d798f$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $b5786db9ce2d798f$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$b5786db9ce2d798f$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $b5786db9ce2d798f$var$MILLISECONDS_IN_HOUR + minutes * $b5786db9ce2d798f$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $b5786db9ce2d798f$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$b5786db9ce2d798f$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $b5786db9ce2d798f$var$MILLISECONDS_IN_HOUR + minutes * $b5786db9ce2d798f$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $b5786db9ce2d798f$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $b5786db9ce2d798f$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $b5786db9ce2d798f$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $b5786db9ce2d798f$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $b5786db9ce2d798f$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $b5786db9ce2d798f$var$isLeapYearIndex(year);
        if (isLeapYear && date > $b5786db9ce2d798f$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $b5786db9ce2d798f$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $b5786db9ce2d798f$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $b5786db9ce2d798f$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $b5786db9ce2d798f$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $b5786db9ce2d798f$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("ZIcI6", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b97fc9d54a6e804$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $0b97fc9d54a6e804$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $0b97fc9d54a6e804$export$2e2bcd8739ae039 = $0b97fc9d54a6e804$var$tzPattern;

});



parcelRegister("6AseU", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cbc02a5e123715e$export$2e2bcd8739ae039);

var $fVXeF = parcelRequire("fVXeF");

var $fzXH2 = parcelRequire("fzXH2");
function $4cbc02a5e123715e$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $fzXH2.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $fVXeF.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});






parcelRegister("7eLbt", function(module, exports) {

$parcel$export(module.exports, "eocGlobalGroupDetailRoute", () => $c40ab0d9ba386fc6$export$e6569aff8dfd4c1d);
const $c40ab0d9ba386fc6$export$e6569aff8dfd4c1d = {
    name: 'eoc-global-group-detail',
    path: '/jira/ops/group-detail/:id',
    exact: true
};

});

parcelRegister("lgLgL", function(module, exports) {

$parcel$export(module.exports, "LazyGroupDetail", () => $009be0886fa71d74$export$8d4b3992eb19d436);
$parcel$export(module.exports, "default", () => $009be0886fa71d74$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $009be0886fa71d74$export$8d4b3992eb19d436 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("339DM")), {
    moduleId: "./src/packages/eoc/group-detail/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$009be0886fa71d74$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $009be0886fa71d74$export$8d4b3992eb19d436,
        pageId: "async-jira-eoc-group-detail",
        shouldShowSpinner: false
    });

});
parcelRegister("339DM", function(module, exports) {

let $2389215c621cd69c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $2389215c621cd69c$var$load("ffQaD"),
    $2389215c621cd69c$var$load("kvRbA"),
    $2389215c621cd69c$var$load("fliVL"),
    $2389215c621cd69c$var$load("76n7a"),
    $2389215c621cd69c$var$load("l253H"),
    $2389215c621cd69c$var$load("i4mUU")
]).then(()=>parcelRequire('9kpiP'));

});



parcelRegister("4Yh3B", function(module, exports) {

$parcel$export(module.exports, "eocGlobalHeartbeatsRouteEntry", () => $17d1dcee95d05254$export$2d7875aa465a7757);

var $90XDC = parcelRequire("90XDC");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $70VNh = parcelRequire("70VNh");

var $eZXFU = parcelRequire("eZXFU");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

var $jxkxr = parcelRequire("jxkxr");
const $17d1dcee95d05254$var$getNavigationSpecifications = ()=>{
    return (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $17d1dcee95d05254$export$2d7875aa465a7757 = (0, $7NszV.createEntry)((0, $70VNh.eocGlobalHeartbeatsRoute), ()=>({
        group: 'eoc',
        component: (0, $jxkxr.HeartbeatsComponent),
        layout: (0, $eZXFU.opsSettingsLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $90XDC.resources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$17d1dcee95d05254$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jxkxr.LazyHeartbeats)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jxkxr.LazyHeartbeats)
        ]
    }));

});
parcelRegister("90XDC", function(module, exports) {

$parcel$export(module.exports, "heartbeatsResource", () => $ba57cdfcb9409883$export$dd38e2aa5cfda9c9);
$parcel$export(module.exports, "heartbeatsUserRightsResource", () => $ba57cdfcb9409883$export$b5d9a0bcdfa848ce);
$parcel$export(module.exports, "resources", () => $ba57cdfcb9409883$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $6dFjI = parcelRequire("6dFjI");
const $ba57cdfcb9409883$export$dd38e2aa5cfda9c9 = (0, $2M1hQ.createResource)({
    type: 'heartbeatsResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `heartbeats/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return (0, $6dFjI.getHeartbeatsEndpoint)(teamId);
    },
    isBrowserOnly: true
});
const $ba57cdfcb9409883$export$b5d9a0bcdfa848ce = (0, $2M1hQ.createResource)({
    type: 'heartbeatsUserRightsResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `heartbeats-user-rights/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return (0, $6dFjI.getHeartbeatsUserRights)(teamId);
    },
    isBrowserOnly: true
});
const $ba57cdfcb9409883$export$bc99aaabaf7b70a7 = ()=>[
        $ba57cdfcb9409883$export$dd38e2aa5cfda9c9,
        $ba57cdfcb9409883$export$b5d9a0bcdfa848ce
    ];

});
parcelRegister("6dFjI", function(module, exports) {

$parcel$export(module.exports, "getHeartbeatsEndpoint", () => $9fd5e861ed04ddb5$export$c322dad372dcb08b);
$parcel$export(module.exports, "validateHeartbeatNameEndpoint", () => $9fd5e861ed04ddb5$export$676f6aee59f124b0);
$parcel$export(module.exports, "createHeartbeatEndpoint", () => $9fd5e861ed04ddb5$export$891ea85cc6973b32);
$parcel$export(module.exports, "updateHeartbeatEndpoint", () => $9fd5e861ed04ddb5$export$7311481b59e02e06);
$parcel$export(module.exports, "switchHeartbeatEndpoint", () => $9fd5e861ed04ddb5$export$5df993f1c74d7e8e);
$parcel$export(module.exports, "deleteHeartbeatEndpoint", () => $9fd5e861ed04ddb5$export$716e365975fc2cd1);
$parcel$export(module.exports, "getHeartbeatsUserRights", () => $9fd5e861ed04ddb5$export$26eaca11f3b4e506);
$parcel$export(module.exports, "updateAutoCreationEndpoint", () => $9fd5e861ed04ddb5$export$38097aade6a3b234);

var $j74qU = parcelRequire("j74qU");

var $5AXpX = parcelRequire("5AXpX");
const $9fd5e861ed04ddb5$export$c322dad372dcb08b = (teamId)=>(0, $j74qU.eocFetch)((0, $5AXpX.generateBaseUrl)(teamId), {
        method: 'GET'
    });
const $9fd5e861ed04ddb5$export$676f6aee59f124b0 = (heartbeatName, teamId)=>(0, $j74qU.eocFetch)(`${(0, $5AXpX.generateBaseUrl)(teamId)}/validateEmail?heartbeatName=${encodeURIComponent(heartbeatName)}`, {
        method: 'GET',
        responseType: 'headers'
    });
const $9fd5e861ed04ddb5$export$891ea85cc6973b32 = (heartbeat, teamId)=>(0, $j74qU.eocFetch)((0, $5AXpX.generateBaseUrl)(teamId), {
        method: 'POST',
        body: heartbeat
    });
const $9fd5e861ed04ddb5$export$7311481b59e02e06 = (heartbeat, teamId)=>(0, $j74qU.eocFetch)((0, $5AXpX.generateBaseUrl)(teamId), {
        method: 'PUT',
        body: heartbeat
    });
const $9fd5e861ed04ddb5$export$5df993f1c74d7e8e = (enable, name, teamId)=>(0, $j74qU.eocFetch)(`${(0, $5AXpX.generateBaseUrl)(teamId)}/enable?enabled=${enable}&name=${encodeURIComponent(name)}`, {
        method: 'PATCH'
    });
const $9fd5e861ed04ddb5$export$716e365975fc2cd1 = (name, teamId)=>(0, $j74qU.eocFetch)(`${(0, $5AXpX.generateBaseUrl)(teamId)}?name=${encodeURIComponent(name)}`, {
        method: 'DELETE',
        responseType: 'headers'
    });
const $9fd5e861ed04ddb5$export$26eaca11f3b4e506 = (teamId)=>{
    return (0, $j74qU.eocFetch)(`${(0, $5AXpX.generateBaseUrl)(teamId)}/rights`);
};
const $9fd5e861ed04ddb5$export$38097aade6a3b234 = (teamId, autoCreateEnabled)=>(0, $j74qU.eocFetch)(`${(0, $5AXpX.generateBaseUrl)(teamId)}/updateHeartbeatAutoCreation?autoCreateEnabled=${autoCreateEnabled}`, {
        method: 'POST',
        responseType: 'headers'
    });

});
parcelRegister("5AXpX", function(module, exports) {

$parcel$export(module.exports, "getMaxAvailableEpoch", () => $9de5e8fd83468bcc$export$1eaa8fc6df8a5dac);
$parcel$export(module.exports, "generateBaseUrl", () => $9de5e8fd83468bcc$export$25e86c63685d7e40);

var $awLan = parcelRequire("awLan");
const $9de5e8fd83468bcc$export$1eaa8fc6df8a5dac = ()=>{
    const today = new Date();
    const futureDate = new Date();
    futureDate.setFullYear(today.getFullYear() * (0, $awLan.MAX_INTERVAL_TIME_YEARS));
    const epochTime = futureDate.getTime();
    return epochTime;
};
const $9de5e8fd83468bcc$export$25e86c63685d7e40 = (teamId)=>{
    return teamId ? `/v1/teams/${teamId}/heartbeats` : '/v1/heartbeats';
};

});
parcelRegister("awLan", function(module, exports) {

$parcel$export(module.exports, "MAX_INTERVAL_TIME_YEARS", () => $a03a59daffb82f94$export$c3f9ae43b3ab397c);
$parcel$export(module.exports, "MIN_DATE_SHOWN_EPOCH", () => $a03a59daffb82f94$export$f081f690fcb957ce);
$parcel$export(module.exports, "SPOTLIGHT_NAMES", () => $a03a59daffb82f94$export$a7c923252528b255);
const $a03a59daffb82f94$export$c3f9ae43b3ab397c = 5;
const $a03a59daffb82f94$export$f081f690fcb957ce = 946677600;
const $a03a59daffb82f94$export$a7c923252528b255 = {
    actions: 'eoc-heartbeats_actions'
};

});




parcelRegister("70VNh", function(module, exports) {

$parcel$export(module.exports, "eocGlobalHeartbeatsRoute", () => $efe21b9fcd2adca8$export$48568054c59facbb);
const $efe21b9fcd2adca8$export$48568054c59facbb = {
    name: 'eoc-global-heartbeats',
    path: '/jira/settings/products/ops/heartbeats',
    exact: true
};

});

parcelRegister("jxkxr", function(module, exports) {

$parcel$export(module.exports, "LazyHeartbeats", () => $e4872049cbc66669$export$93c9586b023b5aa3);
$parcel$export(module.exports, "HeartbeatsComponent", () => $e4872049cbc66669$export$43c2d87bd51ba6ac);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $e4872049cbc66669$export$93c9586b023b5aa3 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("tKNMQ")), {
    moduleId: "./src/packages/eoc/heartbeats/src/index.tsx"
});
const $e4872049cbc66669$export$43c2d87bd51ba6ac = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e4872049cbc66669$export$93c9586b023b5aa3,
        pageId: "async-jira-eoc-heartbeats",
        shouldShowSpinner: false
    });

});
parcelRegister("tKNMQ", function(module, exports) {

let $05970373df817cd2$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $05970373df817cd2$var$load("ffQaD"),
    $05970373df817cd2$var$load("kvRbA"),
    $05970373df817cd2$var$load("bnWkb")
]).then(()=>parcelRequire('4uAlQ'));

});



parcelRegister("5H5Rm", function(module, exports) {

$parcel$export(module.exports, "eocGlobalMaintenanceRouteEntry", () => $e5934255c94fc385$export$ce2a5648c28a5b48);

var $iBsI0 = parcelRequire("iBsI0");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $eZXFU = parcelRequire("eZXFU");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $fGpPl = parcelRequire("fGpPl");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

var $bEKnP = parcelRequire("bEKnP");
const $e5934255c94fc385$var$getNavigationSpecifications = ()=>{
    return (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $e5934255c94fc385$export$ce2a5648c28a5b48 = (0, $7NszV.createEntry)((0, $fGpPl.eocGlobalMaintenanceRoute), ()=>({
        group: 'eoc',
        component: (0, $bEKnP.MaintenanceComponent),
        layout: (0, $eZXFU.opsSettingsLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $iBsI0.resources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$e5934255c94fc385$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bEKnP.LazyMaintenance)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bEKnP.LazyMaintenance)
        ]
    }));

});
parcelRegister("iBsI0", function(module, exports) {

$parcel$export(module.exports, "maintenanceResource", () => $b472cee8aa78ea18$export$5486c78261efb2c3);
$parcel$export(module.exports, "maintenanceUserRightsResource", () => $b472cee8aa78ea18$export$e4c92d8948e3625);
$parcel$export(module.exports, "resources", () => $b472cee8aa78ea18$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $jxRF2 = parcelRequire("jxRF2");

var $czDcW = parcelRequire("czDcW");
const $b472cee8aa78ea18$export$5486c78261efb2c3 = (0, $2M1hQ.createResource)({
    type: 'maintenanceResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `maintenance/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return (0, $czDcW.getMaintenance)(teamId);
    },
    isBrowserOnly: true
});
const $b472cee8aa78ea18$export$e4c92d8948e3625 = (0, $2M1hQ.createResource)({
    type: 'maintenanceUserRightsResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `maintenance-user-rights/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return (0, $czDcW.getMaintenanceUserRights)(teamId);
    },
    isBrowserOnly: true
});
const $b472cee8aa78ea18$export$bc99aaabaf7b70a7 = ()=>[
        ...(0, $jxRF2.eocCommonResources)(),
        $b472cee8aa78ea18$export$5486c78261efb2c3,
        $b472cee8aa78ea18$export$e4c92d8948e3625
    ];

});
parcelRegister("czDcW", function(module, exports) {

$parcel$export(module.exports, "getMaintenance", () => $b4a2c16b626eeb32$export$9cc878e1852c5ee1);
$parcel$export(module.exports, "deleteMaintenance", () => $b4a2c16b626eeb32$export$f64242288df38e86);
$parcel$export(module.exports, "cancelMaintenance", () => $b4a2c16b626eeb32$export$2d4a5362bda1b3c1);
$parcel$export(module.exports, "changeDateAndTime", () => $b4a2c16b626eeb32$export$2162fcbd04e23a3d);
$parcel$export(module.exports, "getMaintenanceUserRights", () => $b4a2c16b626eeb32$export$60048f3b7e7bf9b9);
$parcel$export(module.exports, "createMaintenance", () => $b4a2c16b626eeb32$export$602dd976bd963418);
$parcel$export(module.exports, "updateMaintenance", () => $b4a2c16b626eeb32$export$fa55cd063e1b15c2);

var $j74qU = parcelRequire("j74qU");
const $b4a2c16b626eeb32$export$9cc878e1852c5ee1 = (teamId)=>{
    return (0, $j74qU.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances`);
};
const $b4a2c16b626eeb32$export$f64242288df38e86 = (teamId, id)=>{
    return (0, $j74qU.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}`, {
        method: 'DELETE',
        responseType: 'headers'
    });
};
const $b4a2c16b626eeb32$export$2d4a5362bda1b3c1 = (teamId, id)=>{
    return (0, $j74qU.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}/cancel`, {
        method: 'PATCH'
    });
};
const $b4a2c16b626eeb32$export$2162fcbd04e23a3d = (teamId, id, endDate)=>{
    return (0, $j74qU.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}/updateEndDate`, {
        method: 'PATCH',
        body: {
            endDate: endDate
        }
    });
};
const $b4a2c16b626eeb32$export$60048f3b7e7bf9b9 = (teamId)=>{
    return (0, $j74qU.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/rights`);
};
const $b4a2c16b626eeb32$export$602dd976bd963418 = (payload, teamId)=>{
    const url = teamId ? `/v1/teams/${teamId}/maintenances` : '/v1/maintenances';
    return (0, $j74qU.eocFetch)(url, {
        method: 'POST',
        body: payload
    });
};
const $b4a2c16b626eeb32$export$fa55cd063e1b15c2 = (payload, id, teamId)=>{
    const url = teamId ? `/v1/teams/${teamId}/maintenances/${id}` : `/v1/maintenances/${id}`;
    return (0, $j74qU.eocFetch)(url, {
        method: 'PUT',
        body: payload
    });
};

});


parcelRegister("fGpPl", function(module, exports) {

$parcel$export(module.exports, "eocGlobalMaintenanceRoute", () => $665baa85f1a3583a$export$e0665f23a759e78f);
const $665baa85f1a3583a$export$e0665f23a759e78f = {
    name: 'eoc-global-maintenance',
    path: '/jira/settings/products/ops/maintenance',
    exact: true
};

});

parcelRegister("bEKnP", function(module, exports) {

$parcel$export(module.exports, "LazyMaintenance", () => $31bca194426a79fa$export$c5c7dc53d976edee);
$parcel$export(module.exports, "MaintenanceComponent", () => $31bca194426a79fa$export$76d7c25f72022339);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $31bca194426a79fa$export$c5c7dc53d976edee = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("jWWmq")), {
    moduleId: "./src/packages/eoc/maintenance/src/index.tsx"
});
const $31bca194426a79fa$export$76d7c25f72022339 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $31bca194426a79fa$export$c5c7dc53d976edee,
        pageId: "async-jira-eoc-maintenance",
        shouldShowSpinner: false
    });

});
parcelRegister("jWWmq", function(module, exports) {

let $e860b44bdacc397b$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e860b44bdacc397b$var$load("ffQaD"),
    $e860b44bdacc397b$var$load("kvRbA"),
    $e860b44bdacc397b$var$load("74MxY")
]).then(()=>parcelRequire('iqyJK'));

});



parcelRegister("dQtRM", function(module, exports) {

$parcel$export(module.exports, "eocGlobalReportsHomePageNav4RouteEntry", () => $d53f4be60f857b27$export$193586b163d4afae);

var $dY89w = parcelRequire("dY89w");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $70Icy = parcelRequire("70Icy");

var $eZXFU = parcelRequire("eZXFU");

var $5GbXG = parcelRequire("5GbXG");
const $d53f4be60f857b27$export$193586b163d4afae = (0, $7NszV.createEntry)((0, $70Icy.eocGlobalReportsHomePageNav4Route), ()=>({
        group: 'eoc',
        component: (0, $5GbXG.OpsReportsRedirect),
        layout: (0, $eZXFU.opsMigrationHubLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $dY89w.resources)(),
            (0, $dY89w.opsReportsPermissionResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default)
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5GbXG.LazyOpsReportsRedirect),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("dY89w", function(module, exports) {

$parcel$export(module.exports, "opsReportsResource", () => $adcf91cb99206588$export$8498311fc7a4ab48);
$parcel$export(module.exports, "opsReportsPermissionResource", () => $adcf91cb99206588$export$c432f280d76e2acf);
$parcel$export(module.exports, "resources", () => $adcf91cb99206588$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $5oSMF = parcelRequire("5oSMF");

var $QF2yk = parcelRequire("QF2yk");
const $adcf91cb99206588$export$8498311fc7a4ab48 = (0, $2M1hQ.createResource)({
    type: 'opsReportsResource',
    getKey: ()=>'opsReportsResource',
    getData: async ()=>{
        const settings = await (0, $QF2yk.getReportSettings)();
        const api = (0, $QF2yk.getDashboards);
        return {
            settings: settings,
            dashboards: settings.showReportingMaintenance ? null : await api()
        };
    },
    maxAge: Infinity,
    isBrowserOnly: true
});
const $adcf91cb99206588$export$c432f280d76e2acf = (0, $2M1hQ.createResource)({
    type: 'opsReportsPermissionResource',
    getKey: ({ match: match })=>{
        return `opsReportsPermissionResource-${match.params?.teamId}`;
    },
    getData: async (routerContext)=>{
        const isTeamDashboard = (0, $5oSMF.isTeamReportsUrl)(routerContext.match.url);
        const teamId = routerContext.match.params?.teamId;
        (0, $hmVmJ.assert)(!isTeamDashboard || !!teamId, new (0, $dH6Pi.AssertionError)('opsReportsPermissionResource', 'teamId should be set to fetch reports permissions on TeamDashboard page'));
        return (0, $QF2yk.getReportRights)(teamId);
    },
    isBrowserOnly: true,
    maxAge: Infinity
});
const $adcf91cb99206588$export$bc99aaabaf7b70a7 = ()=>[
        $adcf91cb99206588$export$8498311fc7a4ab48,
        $adcf91cb99206588$export$c432f280d76e2acf
    ];

});
parcelRegister("5oSMF", function(module, exports) {

$parcel$export(module.exports, "withReportingPrefix", () => $8aa539155af4c630$export$c0f073d636267c44);
$parcel$export(module.exports, "isTeamReportsUrl", () => $8aa539155af4c630$export$f923ac475871fcad);

var $030R0 = parcelRequire("030R0");
function $8aa539155af4c630$export$c0f073d636267c44(input) {
    // If current env is not opsgenie, we will add cloud id to base url of request.
    if (window.__OG__) return '/webapi' + input;
    const cloudId = (0, $030R0.getMeta)('ajs-cloud-id');
    if (cloudId) return `/gateway/api/jsm/ops/reporting/cloudId/${cloudId}/api` + input;
    return input;
}
const $8aa539155af4c630$export$f923ac475871fcad = (pathName)=>pathName.startsWith('/jira/ops/teams/');

});

parcelRegister("QF2yk", function(module, exports) {

$parcel$export(module.exports, "getDashboards", () => $de64900aae3821f4$export$8e4b6d6c4fec08f3);
$parcel$export(module.exports, "getReportSettings", () => $de64900aae3821f4$export$9114b8a872caf5d8);
$parcel$export(module.exports, "getSsoEmbedUrlEndpoint", () => $de64900aae3821f4$export$8384a95746267bd8);
$parcel$export(module.exports, "getReportRights", () => $de64900aae3821f4$export$f4a61c3c8c619f12);
$parcel$export(module.exports, "getAVPEmbedTokens", () => $de64900aae3821f4$export$fb46892f83504a42);

var $j74qU = parcelRequire("j74qU");

var $5oSMF = parcelRequire("5oSMF");

var $7IcT2 = parcelRequire("7IcT2");
const $de64900aae3821f4$export$8e4b6d6c4fec08f3 = ()=>(0, $j74qU.eocFetch)((0, $5oSMF.withReportingPrefix)('/v5/reports/dashboards'), {
        exactUrl: true,
        errorTransformer: $7IcT2.opsReportsErrorTransformer
    });
const $de64900aae3821f4$export$e69121e90ce0231b = ()=>(0, $j74qU.eocFetch)((0, $5oSMF.withReportingPrefix)('/v3/reports/dashboards'), {
        exactUrl: true,
        errorTransformer: $7IcT2.opsReportsErrorTransformer
    });
const $de64900aae3821f4$export$9114b8a872caf5d8 = ()=>(0, $j74qU.eocFetch)((0, $5oSMF.withReportingPrefix)('/v3/reports/index'), {
        exactUrl: true,
        errorTransformer: $7IcT2.opsReportsErrorTransformer
    });
const $de64900aae3821f4$export$8384a95746267bd8 = (isDarkMode, dashboardId, teamId)=>{
    const queryParam = teamId ? {
        theme: isDarkMode ? 'DarkMode' : '',
        dashboardId: dashboardId,
        teamId: teamId,
        // Adding time as queryParam to avoid browser caching
        // Should ideally be handled by "Cache-Control" header from server
        _: Date.now().toString()
    } : {
        theme: isDarkMode ? 'DarkMode' : '',
        dashboardId: dashboardId,
        _: Date.now().toString()
    };
    const url = `/v3/reports/dashboard?${new URLSearchParams(queryParam).toString()}`;
    return (0, $j74qU.eocFetch)((0, $5oSMF.withReportingPrefix)(url), {
        exactUrl: true,
        errorTransformer: $7IcT2.opsReportsErrorTransformer
    });
};
const $de64900aae3821f4$export$f4a61c3c8c619f12 = (teamId)=>{
    let url = '/v3/reports/rights';
    if (teamId) url += `?teamId=${teamId}`;
    return (0, $j74qU.eocFetch)((0, $5oSMF.withReportingPrefix)(url), {
        exactUrl: true,
        errorTransformer: $7IcT2.opsReportsErrorTransformer
    });
};
const $de64900aae3821f4$export$fb46892f83504a42 = (dashboardId, teamId)=>{
    let url = '/v3/reports/embed-token';
    return (0, $j74qU.eocFetch)((0, $5oSMF.withReportingPrefix)(url), {
        exactUrl: true,
        method: 'POST',
        body: {
            dashboardId: dashboardId,
            teamId: teamId
        },
        errorTransformer: $7IcT2.opsReportsErrorTransformer
    });
};

});
parcelRegister("7IcT2", function(module, exports) {

$parcel$export(module.exports, "opsReportsErrorTransformer", () => $726849c36404771c$export$b170750bd4489531);

var $aI12f = parcelRequire("aI12f");
const $726849c36404771c$var$mediaTypeRegex = /(^application\/json$)|(^application\/json([\s\t]?;.+?)*([\s\t]?;[\s\t]?charset=(("utf-8")|(utf-8)|("ISO-8859-1")|(ISO-8859-1))))/i;
const $726849c36404771c$export$b170750bd4489531 = (e)=>{
    if ((0, $aI12f.isHTTPError)(e)) {
        const contentType = e.response.headers.get('Content-Type');
        // The content type is application/json, and it is highly likely utf-8 encoded
        if (contentType && $726849c36404771c$var$mediaTypeRegex.test(contentType)) return e.response.json().then((data)=>new (0, $aI12f.StreamedHTTPError)(e, data, data.message));
        // For anything else, try to interpret it as utf8 text as best effort.
        return e.response.text().then((message)=>new (0, $aI12f.StreamedHTTPError)(e, message, message));
    }
    return e;
};

});



parcelRegister("70Icy", function(module, exports) {

$parcel$export(module.exports, "eocGlobalReportsHomePageNav4Route", () => $a80c4e46a4046a66$export$e7c62a288f7d3a11);
const $a80c4e46a4046a66$export$e7c62a288f7d3a11 = {
    name: 'eoc-global-reports',
    path: '/jira/ops/reports',
    exact: true
};

});

parcelRegister("5GbXG", function(module, exports) {

$parcel$export(module.exports, "LazyOpsReports", () => $cba1f7031d59cee6$export$2404f0e35deca592);
$parcel$export(module.exports, "LazyOpsReportsRedirect", () => $cba1f7031d59cee6$export$d33ea1a773b744e);
$parcel$export(module.exports, "LazyGlobalOpsReports", () => $cba1f7031d59cee6$export$66850ec5549adba6);
$parcel$export(module.exports, "LazyOpsReportsUnsubscribe", () => $cba1f7031d59cee6$export$5fd77c3bbfb22cbd);
$parcel$export(module.exports, "OpsReportsRedirect", () => $cba1f7031d59cee6$export$22253dbadb46d0cf);
$parcel$export(module.exports, "GlobalOpsReports", () => $cba1f7031d59cee6$export$648ddf2d1f8b1c3f);
$parcel$export(module.exports, "OpsReports", () => $cba1f7031d59cee6$export$87e6a54b4f5dc91e);
$parcel$export(module.exports, "OpsReportsUnsubscribe", () => $cba1f7031d59cee6$export$7f366d77015c286f);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $cba1f7031d59cee6$export$2404f0e35deca592 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("6ouKe")), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $cba1f7031d59cee6$export$d33ea1a773b744e = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("6ouKe")).then((exportedMembers)=>exportedMembers.OpsReportsRedirect), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $cba1f7031d59cee6$export$66850ec5549adba6 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("6ouKe")).then((exportedMembers)=>exportedMembers.GlobalOpsReports), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $cba1f7031d59cee6$export$5fd77c3bbfb22cbd = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("6ouKe")).then((exportedMembers)=>exportedMembers.OpsReportsUnsubscribe), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});
const $cba1f7031d59cee6$export$22253dbadb46d0cf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cba1f7031d59cee6$export$d33ea1a773b744e,
        pageId: "async-jira-eoc-ops-reports-redirect",
        shouldShowSpinner: false
    });
const $cba1f7031d59cee6$export$648ddf2d1f8b1c3f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cba1f7031d59cee6$export$66850ec5549adba6,
        pageId: "async-jira-eoc-global-ops-reports",
        shouldShowSpinner: false
    });
const $cba1f7031d59cee6$export$87e6a54b4f5dc91e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cba1f7031d59cee6$export$2404f0e35deca592,
        pageId: "async-jira-eoc-ops-reports",
        shouldShowSpinner: false
    });
const $cba1f7031d59cee6$export$7f366d77015c286f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cba1f7031d59cee6$export$5fd77c3bbfb22cbd,
        pageId: "async-jira-eoc-ops-reports-unsubscribe",
        shouldShowSpinner: false
    });

});
parcelRegister("6ouKe", function(module, exports) {

let $4a7cd532c67d24e2$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $4a7cd532c67d24e2$var$load("kNFvF"),
    $4a7cd532c67d24e2$var$load("ffQaD"),
    $4a7cd532c67d24e2$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("31Bp2"), 4)),
    $4a7cd532c67d24e2$var$load("76n7a"),
    $4a7cd532c67d24e2$var$load("l253H"),
    $4a7cd532c67d24e2$var$load("hMePY")
]).then(()=>parcelRequire('eHCOd'));

});



parcelRegister("iDxTp", function(module, exports) {

$parcel$export(module.exports, "eocGlobalReportsNav4RouteEntry", () => $1fb5a93b84172f00$export$90a73fe101848dd);

var $dY89w = parcelRequire("dY89w");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $7ABBf = parcelRequire("7ABBf");

var $5GbXG = parcelRequire("5GbXG");
const $1fb5a93b84172f00$export$90a73fe101848dd = (0, $7NszV.createEntry)((0, $7ABBf.eocGlobalReportsNav4Route), ()=>({
        group: 'eoc',
        component: (0, $5GbXG.GlobalOpsReports),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $dY89w.resources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).HOME
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5GbXG.LazyGlobalOpsReports)
        ]
    }));

});
parcelRegister("7ABBf", function(module, exports) {

$parcel$export(module.exports, "eocGlobalReportsNav4Route", () => $4c6718ca5b31c262$export$2344cc35fd2eff4e);
const $4c6718ca5b31c262$export$2344cc35fd2eff4e = {
    name: 'eoc-global-report-dashboard',
    path: '/jira/ops/reports/:dashboardId',
    exact: true
};

});


parcelRegister("75Ues", function(module, exports) {

$parcel$export(module.exports, "eocHeartbeatsRouteEntry", () => $b7a7f1ceb2ac2c2a$export$2c2d6115c4280a08);

var $90XDC = parcelRequire("90XDC");

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $6tmb0 = parcelRequire("6tmb0");

var $jxkxr = parcelRequire("jxkxr");
const $b7a7f1ceb2ac2c2a$export$2c2d6115c4280a08 = (0, $7NszV.createEntry)((0, $6tmb0.eocHeartbeatsRoute), ()=>({
        group: 'eoc',
        component: (0, $jxkxr.HeartbeatsComponent),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $90XDC.resources)(),
            ...(0, $2r8fH.resources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jxkxr.LazyHeartbeats),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("6tmb0", function(module, exports) {

$parcel$export(module.exports, "eocHeartbeatsRoute", () => $99f0aed6abda0a94$export$71bd833dcb7bd1e9);
const $99f0aed6abda0a94$export$71bd833dcb7bd1e9 = {
    name: 'eoc-heartbeats',
    path: '/jira/ops/teams/:teamId/heartbeats',
    exact: true
};

});


parcelRegister("jAB8i", function(module, exports) {

$parcel$export(module.exports, "eocMaintenanceRouteEntry", () => $e4663459434822fe$export$e9c59d0d6bfec8a3);

var $iBsI0 = parcelRequire("iBsI0");

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $9sQfT = parcelRequire("9sQfT");

var $bEKnP = parcelRequire("bEKnP");
const $e4663459434822fe$export$e9c59d0d6bfec8a3 = (0, $7NszV.createEntry)((0, $9sQfT.eocMaintenanceRoute), ()=>({
        group: 'eoc',
        component: (0, $bEKnP.MaintenanceComponent),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $iBsI0.resources)(),
            ...(0, $2r8fH.resources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bEKnP.LazyMaintenance),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("9sQfT", function(module, exports) {

$parcel$export(module.exports, "eocMaintenanceRoute", () => $e19afc32053c9ada$export$7523f600b27b1b54);
const $e19afc32053c9ada$export$7523f600b27b1b54 = {
    name: 'eoc-maintenance',
    path: '/jira/ops/teams/:teamId/maintenance',
    exact: true
};

});


parcelRegister("5KvQp", function(module, exports) {

$parcel$export(module.exports, "eocOnCallRedirectRouteEntry", () => $665cd44900aa1f78$export$c5c49f69c4fe1ea6);

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $fMGN8 = parcelRequire("fMGN8");

var $fLXNK = parcelRequire("fLXNK");
const $665cd44900aa1f78$export$c5c49f69c4fe1ea6 = (0, $7NszV.createEntry)((0, $fMGN8.eocOnCallRedirectRoute), ()=>({
        group: 'eoc',
        component: (0, $fLXNK.OnCallRedirect),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $2r8fH.resources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ],
        isRedirect: true
    }));

});
parcelRegister("fMGN8", function(module, exports) {

$parcel$export(module.exports, "eocOnCallRedirectRoute", () => $d0ffab051a4939b4$export$d725ece0e087d522);
const $d0ffab051a4939b4$export$d725ece0e087d522 = {
    name: 'eoc-on-call-redirect',
    path: '/jira/ops/teams/:teamId',
    exact: true
};

});

parcelRegister("fLXNK", function(module, exports) {

$parcel$export(module.exports, "OnCallRedirect", () => $da08681b2a2ed397$export$659b7ce11c160b32);
$parcel$export(module.exports, "LazyOnCall", () => $da08681b2a2ed397$export$772095aa22362f73);
$parcel$export(module.exports, "default", () => $da08681b2a2ed397$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $7tQej = parcelRequire("7tQej");
var $doZTA = parcelRequire("doZTA");
const $da08681b2a2ed397$export$659b7ce11c160b32 = ()=>{
    const [routeContext] = (0, $doZTA.useRouter)();
    const redirectionUrl = `${routeContext.location.pathname}/on-call`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: redirectionUrl
    });
};

const $da08681b2a2ed397$export$772095aa22362f73 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("eYDuU")), {
    moduleId: "./src/packages/eoc/on-call/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$da08681b2a2ed397$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $da08681b2a2ed397$export$772095aa22362f73,
        pageId: "async-jira-eoc-on-call",
        shouldShowSpinner: false
    });

});
parcelRegister("eYDuU", function(module, exports) {

let $ae754ea71b30ade3$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ae754ea71b30ade3$var$load("ffQaD"),
    $ae754ea71b30ade3$var$load("kvRbA"),
    $ae754ea71b30ade3$var$load("76n7a"),
    $ae754ea71b30ade3$var$load("l253H"),
    $ae754ea71b30ade3$var$load("fLvpH")
]).then(()=>parcelRequire('38rnw'));

});



parcelRegister("3Yng9", function(module, exports) {

$parcel$export(module.exports, "eocOnCallRouteEntry", () => $3f27e199fbc412b1$export$ac245212b12db871);

var $iufIe = parcelRequire("iufIe");

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $5ozXn = parcelRequire("5ozXn");

var $fLXNK = parcelRequire("fLXNK");
const $3f27e199fbc412b1$export$ac245212b12db871 = (0, $7NszV.createEntry)((0, $5ozXn.eocOnCallRoute), ()=>({
        group: 'eoc',
        component: (0, $fLXNK.default),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $2r8fH.resources)(),
            ...(0, $iufIe.resources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $fLXNK.LazyOnCall),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("iufIe", function(module, exports) {

$parcel$export(module.exports, "getTeamResource", () => $e31238735315794c$export$50271c9e7f21f10e);
$parcel$export(module.exports, "resources", () => $e31238735315794c$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $8SpRt = parcelRequire("8SpRt");

var $6RRyp = parcelRequire("6RRyp");

var $4Igwk = parcelRequire("4Igwk");
const $e31238735315794c$export$50271c9e7f21f10e = (0, $2M1hQ.createResource)({
    type: 'getTeamResource',
    getKey: ()=>'getTeamResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $hmVmJ.assert)(!!teamId, new (0, $dH6Pi.AssertionError)('getTeamResource', 'teamId should be set to fetch on-call'));
        return (0, $4Igwk.getTeam)(teamId);
    },
    isBrowserOnly: true
});
const $e31238735315794c$export$bc99aaabaf7b70a7 = ()=>[
        ...(0, $6RRyp.resources),
        (0, $8SpRt.routingRulesResource),
        $e31238735315794c$export$50271c9e7f21f10e
    ];

});
parcelRegister("8SpRt", function(module, exports) {

$parcel$export(module.exports, "routingRulesResource", () => $8308d404e93181e1$export$7f38c73dca88500e);

var $2M1hQ = parcelRequire("2M1hQ");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $eQugF = parcelRequire("eQugF");
const $8308d404e93181e1$export$7f38c73dca88500e = (0, $2M1hQ.createResource)({
    type: 'routingRulesResource',
    getKey: ()=>'routingRulesResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $hmVmJ.assert)(!!teamId, new (0, $dH6Pi.AssertionError)('routingRulesResource', 'teamId should be set to fetch routing-rules'));
        return (0, $eQugF.getRoutingRules)(teamId);
    },
    isBrowserOnly: true
});

});
parcelRegister("eQugF", function(module, exports) {

$parcel$export(module.exports, "getRoutingRules", () => $2cc350f95d05e13d$export$425c24c86196521);

var $j74qU = parcelRequire("j74qU");
const $2cc350f95d05e13d$export$425c24c86196521 = (teamId)=>(0, $j74qU.eocFetch)(`/v1/teams/${teamId}/routing-rules`);

});


parcelRegister("6RRyp", function(module, exports) {

$parcel$export(module.exports, "getSchedulesResource", () => $00ff222f7fbbe6c1$export$6b2b3e2a53cc13e2);
$parcel$export(module.exports, "getUiPreferencesResource", () => $00ff222f7fbbe6c1$export$5c6454d866055bdd);
$parcel$export(module.exports, "getScheduleRightsResource", () => $00ff222f7fbbe6c1$export$9d9ecb8586783931);
$parcel$export(module.exports, "getScheduleTimeTemplatesResource", () => $00ff222f7fbbe6c1$export$90251855f07c54b4);
$parcel$export(module.exports, "resources", () => $00ff222f7fbbe6c1$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $jxRF2 = parcelRequire("jxRF2");

var $dmLt8 = parcelRequire("dmLt8");

var $1IQ7I = parcelRequire("1IQ7I");

var $6CGrT = parcelRequire("6CGrT");

var $6bC8A = parcelRequire("6bC8A");

var $6FjDf = parcelRequire("6FjDf");

var $c0fyU = parcelRequire("c0fyU");
const $00ff222f7fbbe6c1$export$6b2b3e2a53cc13e2 = (0, $2M1hQ.createResource)({
    type: 'getSchedulesResource',
    getKey: ()=>'getSchedulesResource',
    isBrowserOnly: true,
    getData: async (routerExtendedContext)=>(0, $6bC8A.endpoints).getScheduleList((0, $1IQ7I.getTeamIdFromContext)(routerExtendedContext))
});
const $00ff222f7fbbe6c1$export$5c6454d866055bdd = (0, $2M1hQ.createResource)({
    type: 'getSchedulePreferencesResource',
    getKey: ()=>'getSchedulePreferencesResource',
    isBrowserOnly: true,
    getData: async (routerExtendedContext)=>(0, $6FjDf.endpoints).getUiPreferences((0, $1IQ7I.getTeamIdFromContext)(routerExtendedContext))
});
const $00ff222f7fbbe6c1$export$9d9ecb8586783931 = (0, $2M1hQ.createResource)({
    type: 'getScheduleRightsResource',
    getKey: ()=>'getScheduleRightsResource',
    isBrowserOnly: true,
    getData: async (routerExtendedContext)=>(0, $c0fyU.endpoints).getScheduleRights((0, $1IQ7I.getTeamIdFromContext)(routerExtendedContext))
});
const $00ff222f7fbbe6c1$export$90251855f07c54b4 = (0, $2M1hQ.createResource)({
    type: 'getScheduleTimeTemplatesResource',
    getKey: ()=>'getScheduleTimeTemplatesResourceurce',
    isBrowserOnly: true,
    getData: async ()=>(0, $6CGrT.endpoints).getScheduleTimeTemplates()
});
const $00ff222f7fbbe6c1$export$bc99aaabaf7b70a7 = [
    $00ff222f7fbbe6c1$export$6b2b3e2a53cc13e2,
    $00ff222f7fbbe6c1$export$5c6454d866055bdd,
    $00ff222f7fbbe6c1$export$9d9ecb8586783931,
    $00ff222f7fbbe6c1$export$90251855f07c54b4,
    ...(0, $dmLt8.resources),
    ...(0, $jxRF2.eocCommonResources)()
];

});
parcelRegister("dmLt8", function(module, exports) {

$parcel$export(module.exports, "getTimezonesResource", () => $6776e3cf1d2006c9$export$7524ea9fda8149c6);
$parcel$export(module.exports, "getTimeTemplatesResource", () => $6776e3cf1d2006c9$export$f045bbf39b81240d);
$parcel$export(module.exports, "resources", () => $6776e3cf1d2006c9$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $8EQhZ = parcelRequire("8EQhZ");
const $6776e3cf1d2006c9$export$7524ea9fda8149c6 = (0, $2M1hQ.createResource)({
    type: 'getEocTimezonesResource',
    getKey: ()=>'getEocTimezonesResource',
    isBrowserOnly: true,
    getData: async ()=>(0, $8EQhZ.endpoints).getTimezones()
});
const $6776e3cf1d2006c9$export$f045bbf39b81240d = (0, $2M1hQ.createResource)({
    type: 'getEocTimeTemplatesResource',
    getKey: ()=>'getEocTimeTemplatesResource',
    isBrowserOnly: true,
    getData: async ()=>(0, $8EQhZ.endpoints).getTimeTemplates()
});
const $6776e3cf1d2006c9$export$bc99aaabaf7b70a7 = [
    $6776e3cf1d2006c9$export$7524ea9fda8149c6
];

});
parcelRegister("8EQhZ", function(module, exports) {

$parcel$export(module.exports, "endpoints", () => $6f3fefc2f4704aa0$export$3a2536d80ecc00e7);

var $j74qU = parcelRequire("j74qU");

var $lVRaA = parcelRequire("lVRaA");
const $6f3fefc2f4704aa0$var$getTimezones = async ()=>{
    const response = await (0, $j74qU.eocFetch)((0, $lVRaA.urls).customers.timezones.url(), {
        method: 'GET'
    });
    const adjusted = response.timezones.map((timezone)=>({
            ...timezone,
            offset: timezone.offset * 60000,
            currentOffset: timezone.currentOffset * 60000
        }));
    return {
        ...response,
        timezones: adjusted
    };
};
const $6f3fefc2f4704aa0$var$getTimeTemplates = ()=>{
    return (0, $j74qU.eocFetch)((0, $lVRaA.urls).schedules.timeTemplates.rotation.url(), {
        method: 'GET'
    });
};
const $6f3fefc2f4704aa0$export$3a2536d80ecc00e7 = {
    getTimezones: $6f3fefc2f4704aa0$var$getTimezones,
    getTimeTemplates: $6f3fefc2f4704aa0$var$getTimeTemplates
};

});
parcelRegister("lVRaA", function(module, exports) {

$parcel$export(module.exports, "urls", () => $e7a5202f26785602$export$bcae9ba627f604b6);
const $e7a5202f26785602$export$bcae9ba627f604b6 = Object.freeze({
    alerts: {
        responders: {
            names: {
                url: ()=>'/v1/alerts/responders/names'
            },
            autoComplete: {
                url: ()=>'/v1/alerts/responders/auto-complete'
            },
            suggested: {
                url: ()=>'/v1/alerts/responders/suggested'
            }
        }
    },
    schedules: {
        url: ()=>`/v1/schedules`,
        scheduleId: {
            url: ({ scheduleId: scheduleId } = {
                scheduleId: ':scheduleId'
            })=>`/v1/schedules/${scheduleId}`,
            clone: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/clone`
            },
            name: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/name`
            },
            timezone: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/timezone`
            },
            enable: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/enable`
            },
            disable: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/disable`
            },
            webCalendarUrl: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/web-calendar-url`
            },
            timeline: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/timeline`
            },
            overrides: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/overrides`,
                alias: {
                    url: ({ scheduleId: scheduleId, alias: alias } = {
                        scheduleId: ':scheduleId',
                        alias: ':alias'
                    })=>`/v1/schedules/${scheduleId}/overrides/${alias}`
                },
                bulk: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/overrides/bulk`
                }
            },
            rotations: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/rotations`,
                rotationId: {
                    url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                        scheduleId: ':scheduleId',
                        rotationId: ':rotationId'
                    })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}`,
                    order: {
                        url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                            scheduleId: ':scheduleId',
                            rotationId: ':rotationId'
                        })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/order`
                    },
                    name: {
                        url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                            scheduleId: ':scheduleId',
                            rotationId: ':rotationId'
                        })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/name`
                    }
                }
            }
        },
        user: {
            webCalendarUrl: {
                url: ()=>`/v1/schedules/user/web-calendar-url`
            }
        },
        timeTemplates: {
            rotation: {
                url: ()=>'/v1/schedules/time-templates/rotation'
            }
        }
    },
    customers: {
        timezones: {
            url: ()=>'/v1/customers/timezones'
        }
    }
});

});



parcelRegister("1IQ7I", function(module, exports) {

$parcel$export(module.exports, "getTeamIdFromContext", () => $0269d115dae63a78$export$3ea727bebc3792bb);

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $lCzwW = parcelRequire("lCzwW");
const $0269d115dae63a78$export$3ea727bebc3792bb = (routerContext)=>{
    const teamId = (0, $lCzwW.getSafe)(()=>routerContext.match.params.teamId, null);
    (0, $hmVmJ.assert)(!(0, $lCzwW.isEmpty)(teamId), new (0, $dH6Pi.AssertionError)('eoc-schedule', 'teamId in routerContext is not defined'));
    return teamId;
};

});
parcelRegister("lCzwW", function(module, exports) {

$parcel$export(module.exports, "getSafe", () => $cb4f511f313ca560$export$fedb900c0ea4e699);
$parcel$export(module.exports, "isEmpty", () => $cb4f511f313ca560$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "isNullOrUndefined", () => $cb4f511f313ca560$export$bedb7023a7733221);
$parcel$export(module.exports, "noLeadingOrTrailingSpaces", () => $cb4f511f313ca560$export$5fc068d42db64a99);

var $jkGAf = parcelRequire("jkGAf");
const $cb4f511f313ca560$export$fedb900c0ea4e699 = (fn, defaultValue)=>{
    try {
        return fn();
    } catch  {
        return defaultValue;
    }
};
const $cb4f511f313ca560$export$dd1bc94b04021eeb = (input)=>{
    if (input !== 0 && input !== false && !input) return true;
    if (!(input instanceof Date) && typeof input === 'object' && Object.keys(input).length === 0) return true;
    return false;
};
const $cb4f511f313ca560$export$bedb7023a7733221 = (input)=>{
    return input === null || input === undefined;
};
const $cb4f511f313ca560$export$5fc068d42db64a99 = (message)=>({ formatMessage: formatMessage })=>(value)=>{
            if (typeof value === 'string' && (value.startsWith(' ') || value.endsWith(' '))) return message ?? formatMessage((0, $jkGAf.messages).nameSpaceValidationError);
        };

});
parcelRegister("jkGAf", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1ca05faf5e97d101$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $1ca05faf5e97d101$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    /*
   Misc common messages
  */ noOne: {
        id: 'eoc-schedule.common.no-one',
        defaultMessage: 'No one',
        description: 'Name of the user whose type is no-one.'
    },
    error: {
        id: 'eoc-schedule.common.error',
        defaultMessage: 'Error',
        description: 'Just simple error message.'
    },
    tryAgain: {
        id: 'eoc-schedule.common.try-again',
        defaultMessage: 'Try again',
        description: 'Try again message when an error occurs.'
    },
    cancel: {
        id: 'eoc-schedule.common.cancel',
        defaultMessage: 'Cancel',
        description: 'A cancel button.'
    },
    confirm: {
        id: 'eoc-schedule.common.confirm',
        defaultMessage: 'Confirm',
        description: 'A confirm button.'
    },
    addOverride: {
        id: 'eoc-schedule.common.add-override',
        defaultMessage: 'Add override',
        description: 'Adding override for a period item.'
    },
    overrideButton: {
        id: 'eoc-schedule.common.override',
        defaultMessage: 'Override',
        description: 'A override button.'
    },
    saveButton: {
        id: 'eoc-schedule.common.save',
        defaultMessage: 'Save',
        description: 'A save button.'
    },
    edit: {
        id: 'eoc-schedule.common.edit',
        defaultMessage: 'Edit',
        description: 'Button for editing schedule.'
    },
    turnOff: {
        id: 'eoc-schedule.common.turn-off',
        defaultMessage: 'Turn off',
        description: 'Button for turn-offing schedule.'
    },
    turnOn: {
        id: 'eoc-schedule.common.turn-on',
        defaultMessage: 'Turn on',
        description: 'Button for turn-on schedule.'
    },
    delete: {
        id: 'eoc-schedule.common.delete',
        defaultMessage: 'Delete',
        description: 'Button for deleting schedule or rotation.'
    },
    duplicate: {
        id: 'eoc-schedule.common.duplicate',
        defaultMessage: 'Duplicate',
        description: 'Button for duplicating schedule or rotation.'
    },
    remove: {
        id: 'eoc-schedule.common.remove',
        defaultMessage: 'Remove',
        description: 'Button for removing participant.'
    },
    start: {
        id: 'eoc-schedule.common.start',
        defaultMessage: 'Start',
        description: 'Label for start time and date.'
    },
    end: {
        id: 'eoc-schedule.common.end',
        defaultMessage: 'End',
        description: 'Label for end time and date.'
    },
    startTime: {
        id: 'eoc-schedule.common.start-time',
        defaultMessage: 'Start time',
        description: 'Label for start time and date.'
    },
    endTime: {
        id: 'eoc-schedule.common.end-time',
        defaultMessage: 'End time',
        description: 'Label for end time and date.'
    },
    startDate: {
        id: 'eoc-schedule.common.start-date',
        defaultMessage: 'Start date',
        description: 'Label for start time and date.'
    },
    endDate: {
        id: 'eoc-schedule.common.end-date',
        defaultMessage: 'End date',
        description: 'Label for end time and date.'
    },
    team: {
        id: 'eoc-schedule.common.team',
        defaultMessage: 'Team',
        description: 'Label that indicates responder is of type: Team'
    },
    escalation: {
        id: 'eoc-schedule.common.escalation',
        defaultMessage: 'Escalation',
        description: 'Label that indicates responder is of type: Escalation'
    },
    schedule: {
        id: 'eoc-schedule.common.schedule',
        defaultMessage: 'Schedule',
        description: 'Label that indicates responder is of type: Schedule'
    },
    selectionCount: {
        id: 'eoc-schedule.common.selection-count',
        defaultMessage: '{count} shifts selected',
        description: 'Indicates how many shifts are selected for override.'
    },
    quickOverrideTitle: {
        id: 'eoc-schedule.common.quick-override-title',
        defaultMessage: 'Override',
        description: 'Title for quick override card.'
    },
    search: {
        id: 'eoc-schedule.common.search',
        defaultMessage: 'Search',
        description: 'Label of search icon that shown inside search participant field'
    },
    replaceWith: {
        id: 'eoc-schedule.common.replace-with',
        defaultMessage: 'Replace with',
        description: 'A button for opening popup for replacing a participant.'
    },
    participants: {
        id: 'eoc-schedule.common.participants',
        defaultMessage: 'Participants',
        description: 'Label for participants.'
    },
    addParticipants: {
        id: 'eoc-schedule.common.add-participants',
        defaultMessage: 'Add people, teams, and escalation policies',
        description: 'Placeholder text for auto complete field for participants (responders).'
    },
    select: {
        id: 'eoc-schedule.common.select',
        defaultMessage: 'Select',
        description: 'Label that indicates selecting.'
    },
    teamDeleted: {
        id: 'eoc-schedule.common.team-deleted',
        defaultMessage: 'Team deleted',
        description: 'Fallback responder name that suggest team is deleted.'
    },
    deletedSchedule: {
        id: 'eoc-schedule.common.deleted-schedule',
        defaultMessage: 'Deleted schedule',
        description: 'Fallback responder name that suggest schedule is deleted.'
    },
    deletedEscalation: {
        id: 'eoc-schedule.common.deleted-escalation',
        defaultMessage: 'Deleted escalation',
        description: 'Fallback responder name that suggest escalation is deleted.'
    },
    formerUser: {
        id: 'eoc-schedule.common.former-user',
        defaultMessage: 'Former user',
        description: 'Fallback responder name that suggest user is deactivated or deleted.'
    },
    discard: {
        id: 'eoc-schedule.common.discard',
        defaultMessage: 'Discard',
        description: 'Button for discarding.'
    },
    confirmProceed: {
        id: 'eoc-schedule.common.confirm-proceed',
        defaultMessage: 'Are you sure to proceed?',
        description: 'A confirmation for proceeding.'
    },
    /*
   Common validation related messages
  */ required: {
        id: 'eoc-schedule.common.required',
        defaultMessage: 'This field is required.',
        description: 'A text that informs users that field should be filled.'
    },
    noSpaceAtEndOrStart: {
        id: 'eoc-schedule.common.no-space-at-end-or-start',
        defaultMessage: 'Field cannot contain spaces at start or end.',
        description: 'A text that informs users that field cannot start or end with spaces.'
    },
    maxLength: {
        id: 'eoc-schedule.common.max-length',
        defaultMessage: 'Field cannot be longer than {max} characters.',
        description: 'A text that informs users that field should be shorter than certain length.'
    },
    maxValue: {
        id: 'eoc-schedule.common.max-value',
        defaultMessage: 'Field should be less than {max}.',
        description: 'A text that informs users that field should be less than certain value.'
    },
    minValue: {
        id: 'eoc-schedule.common.min-value',
        defaultMessage: 'Enter digit 1 or more.',
        description: 'This sentence instructs the user to input a numeric value of at least 1 digit or greater.'
    },
    timePast: {
        id: 'eoc-schedule.common.time-past',
        defaultMessage: 'Time should be later than current time.',
        description: 'Validation error that indicates time values is in past.'
    },
    startLaterEnd: {
        id: 'eoc-schedule.common.start-later-end',
        defaultMessage: 'Start time should be earlier than the end time.',
        description: 'Validation error that indicates start time is later than the end time.'
    },
    endEarlierStart: {
        id: 'eoc-schedule.common.end-earlier-start',
        defaultMessage: 'End time should be later than the start time.',
        description: 'Validation error that indicates end time is earlier than the start time.'
    },
    startEndSame: {
        id: 'eoc-schedule.common.start-end-same',
        defaultMessage: 'Start and end time cannot be same.',
        description: 'Validation error that indicates start and end time should be different.'
    },
    thirtyMinuteInterval: {
        id: 'eoc-schedule.common.thirty-minute-intervals',
        defaultMessage: 'Time should be defined as 30 minute intervals.',
        description: 'Validation error that indicates time can be in 30 minutes intervals.'
    },
    nameSpaceValidationError: {
        id: 'eoc-schedule.common.name-space-validation-error',
        defaultMessage: 'The name cannot start or end with a space.',
        description: 'Error message for name validation when it starts or ends with a space'
    }
});

});



parcelRegister("6CGrT", function(module, exports) {

$parcel$export(module.exports, "endpoints", () => $fe0104c8713239aa$export$3a2536d80ecc00e7);

var $j74qU = parcelRequire("j74qU");

var $cB5Mt = parcelRequire("cB5Mt");
const $fe0104c8713239aa$var$orderRotation = ({ scheduleId: scheduleId, after: after, rotationId: rotationId })=>{
    return (0, $j74qU.eocFetch)((0, $cB5Mt.urls).schedules.scheduleId.rotations.rotationId.order.url({
        rotationId: rotationId,
        scheduleId: scheduleId
    }), {
        method: 'PATCH',
        body: {
            after: after
        }
    });
};
const $fe0104c8713239aa$var$getRotation = ({ scheduleId: scheduleId, rotationId: rotationId })=>{
    return (0, $j74qU.eocFetch)((0, $cB5Mt.urls).schedules.scheduleId.rotations.rotationId.url({
        scheduleId: scheduleId,
        rotationId: rotationId
    }), {
        method: 'GET'
    });
};
const $fe0104c8713239aa$var$deleteRotation = ({ scheduleId: scheduleId, rotationId: rotationId })=>{
    return (0, $j74qU.eocFetch)((0, $cB5Mt.urls).schedules.scheduleId.rotations.rotationId.url({
        scheduleId: scheduleId,
        rotationId: rotationId
    }), {
        method: 'DELETE'
    });
};
const $fe0104c8713239aa$var$addRotation = ({ name: name, responders: responders, restrictions: restrictions, rotationType: rotationType, hasEndTime: hasEndTime, rotationPeriod: rotationPeriod, scheduleId: scheduleId, timeTemplateId: timeTemplateId, timingType: timingType, startTimeRaw: startTimeRaw, endTimeRaw: endTimeRaw })=>{
    return (0, $j74qU.eocFetch)((0, $cB5Mt.urls).schedules.scheduleId.rotations.url({
        scheduleId: scheduleId
    }), {
        method: 'POST',
        body: {
            name: name,
            responders: responders,
            restrictions: restrictions,
            rotationType: rotationType,
            timeTemplateId: timeTemplateId,
            timingType: timingType,
            rotationPeriod: rotationPeriod,
            startTimeRaw: startTimeRaw,
            endTimeRaw: endTimeRaw,
            hasEndTime: hasEndTime
        }
    });
};
const $fe0104c8713239aa$var$editRotation = ({ id: id, name: name, responders: responders, restrictions: restrictions, rotationType: rotationType, rotationPeriod: rotationPeriod, hasEndTime: hasEndTime, timingType: timingType, scheduleId: scheduleId, timeTemplateId: timeTemplateId, startTimeRaw: startTimeRaw, endTimeRaw: endTimeRaw })=>{
    return (0, $j74qU.eocFetch)((0, $cB5Mt.urls).schedules.scheduleId.rotations.rotationId.url({
        scheduleId: scheduleId,
        rotationId: id
    }), {
        method: 'PUT',
        body: {
            id: id,
            name: name,
            responders: responders,
            restrictions: restrictions,
            rotationType: rotationType,
            rotationPeriod: rotationPeriod,
            timeTemplateId: timeTemplateId,
            timingType: timingType,
            startTimeRaw: startTimeRaw,
            endTimeRaw: endTimeRaw,
            hasEndTime: hasEndTime
        }
    });
};
const $fe0104c8713239aa$var$getScheduleTimeTemplates = ()=>{
    return (0, $j74qU.eocFetch)((0, $cB5Mt.urls).schedules.timeTemplates.rotation.url(), {
        method: 'GET'
    });
};
const $fe0104c8713239aa$export$3a2536d80ecc00e7 = {
    deleteRotation: $fe0104c8713239aa$var$deleteRotation,
    getRotation: $fe0104c8713239aa$var$getRotation,
    orderRotation: $fe0104c8713239aa$var$orderRotation,
    addRotation: $fe0104c8713239aa$var$addRotation,
    editRotation: $fe0104c8713239aa$var$editRotation,
    getScheduleTimeTemplates: $fe0104c8713239aa$var$getScheduleTimeTemplates
};

});
parcelRegister("cB5Mt", function(module, exports) {

$parcel$export(module.exports, "urls", () => $09cb24bcb900cd8c$export$bcae9ba627f604b6);
const $09cb24bcb900cd8c$export$bcae9ba627f604b6 = Object.freeze({
    alerts: {
        responders: {
            names: {
                url: ()=>'/v1/alerts/responders/names'
            },
            autoComplete: {
                url: ()=>'/v1/alerts/responders/auto-complete'
            }
        }
    },
    schedules: {
        url: ()=>`/v1/schedules`,
        teams: {
            teamId: {
                url: ({ teamId: teamId } = {
                    teamId: ':teamId'
                })=>`/v1/schedules/teams/${teamId}`,
                rights: {
                    url: ({ teamId: teamId } = {
                        teamId: ':teamId'
                    })=>`/v1/schedules/teams/${teamId}/rights`
                }
            }
        },
        scheduleId: {
            url: ({ scheduleId: scheduleId } = {
                scheduleId: ':scheduleId'
            })=>`/v1/schedules/${scheduleId}`,
            clone: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/clone`
            },
            name: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/name`
            },
            timezone: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/timezone`
            },
            enable: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/enable`
            },
            disable: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/disable`
            },
            webCalendarUrl: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/web-calendar-url`
            },
            timeline: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/timeline`
            },
            overrides: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/overrides`,
                alias: {
                    url: ({ scheduleId: scheduleId, alias: alias } = {
                        scheduleId: ':scheduleId',
                        alias: ':alias'
                    })=>`/v1/schedules/${scheduleId}/overrides/${alias}`
                },
                bulk: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/overrides/bulk`
                }
            },
            rotations: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/rotations`,
                rotationId: {
                    url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                        scheduleId: ':scheduleId',
                        rotationId: ':rotationId'
                    })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}`,
                    order: {
                        url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                            scheduleId: ':scheduleId',
                            rotationId: ':rotationId'
                        })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/order`
                    },
                    name: {
                        url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                            scheduleId: ':scheduleId',
                            rotationId: ':rotationId'
                        })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/name`
                    }
                }
            }
        },
        timeTemplates: {
            rotation: {
                url: ()=>'/v1/schedules/time-templates/rotation'
            }
        }
    },
    customers: {
        timezones: {
            url: ()=>'/v1/customers/timezones'
        }
    },
    uiPreference: {
        schedule: {
            team: {
                teamId: {
                    url: ({ teamId: teamId } = {
                        teamId: ':teamId'
                    })=>`/v1/users/ui-preference/schedule/team/${teamId}`
                }
            }
        }
    },
    onboarding: {
        completeTask: {
            url: ()=>'/v1/onboarding/complete-task'
        }
    }
});

});


parcelRegister("6bC8A", function(module, exports) {

$parcel$export(module.exports, "endpoints", () => $94e539ffc0ded8a5$export$3a2536d80ecc00e7);

var $j74qU = parcelRequire("j74qU");

var $cB5Mt = parcelRequire("cB5Mt");
const $94e539ffc0ded8a5$var$getScheduleList = (teamId)=>{
    return (0, $j74qU.eocFetch)((0, $cB5Mt.urls).schedules.teams.teamId.url({
        teamId: teamId
    }));
};
const $94e539ffc0ded8a5$var$updateSchedule = ({ scheduleId: scheduleId, description: description, name: name, enabled: enabled, timezone: timezone })=>{
    return (0, $j74qU.eocFetch)((0, $cB5Mt.urls).schedules.scheduleId.url({
        scheduleId: scheduleId
    }), {
        method: 'PATCH',
        body: {
            description: description,
            name: name,
            enabled: enabled,
            timezone: timezone
        }
    });
};
const $94e539ffc0ded8a5$var$deleteSchedule = ({ scheduleId: scheduleId })=>{
    return (0, $j74qU.eocFetch)((0, $cB5Mt.urls).schedules.scheduleId.url({
        scheduleId: scheduleId
    }), {
        method: 'DELETE'
    });
};
const $94e539ffc0ded8a5$export$3a2536d80ecc00e7 = {
    deleteSchedule: $94e539ffc0ded8a5$var$deleteSchedule,
    getScheduleList: $94e539ffc0ded8a5$var$getScheduleList,
    updateSchedule: $94e539ffc0ded8a5$var$updateSchedule
};

});

parcelRegister("6FjDf", function(module, exports) {

$parcel$export(module.exports, "endpoints", () => $4c5802ac60e7f752$export$3a2536d80ecc00e7);

var $j74qU = parcelRequire("j74qU");

var $cB5Mt = parcelRequire("cB5Mt");
const $4c5802ac60e7f752$var$getUiPreferences = (teamId)=>{
    return (0, $j74qU.eocFetch)((0, $cB5Mt.urls).uiPreference.schedule.team.teamId.url({
        teamId: teamId
    }));
};
const $4c5802ac60e7f752$var$updateUiPreferences = ({ teamId: teamId, key: key, value: value })=>{
    return (0, $j74qU.eocFetch)((0, $cB5Mt.urls).uiPreference.schedule.team.teamId.url({
        teamId: teamId
    }), {
        method: 'PATCH',
        body: {
            [key]: value
        }
    });
};
const $4c5802ac60e7f752$export$3a2536d80ecc00e7 = {
    getUiPreferences: $4c5802ac60e7f752$var$getUiPreferences,
    updateUiPreferences: $4c5802ac60e7f752$var$updateUiPreferences
};

});

parcelRegister("c0fyU", function(module, exports) {

$parcel$export(module.exports, "endpoints", () => $7066040345150142$export$3a2536d80ecc00e7);

var $j74qU = parcelRequire("j74qU");

var $cB5Mt = parcelRequire("cB5Mt");
const $7066040345150142$var$getScheduleRights = (teamId)=>{
    return (0, $j74qU.eocFetch)((0, $cB5Mt.urls).schedules.teams.teamId.rights.url({
        teamId: teamId
    }));
};
const $7066040345150142$var$createSchedule = ({ description: description, name: name, teamId: teamId, timezone: timezone })=>{
    return (0, $j74qU.eocFetch)((0, $cB5Mt.urls).schedules.url(), {
        method: 'POST',
        body: {
            description: description,
            name: name,
            teamId: teamId,
            timezone: timezone,
            // Created schedules are enabled by default
            enabled: true
        }
    });
};
const $7066040345150142$var$cloneSchedule = ({ description: description, name: name, enabled: enabled, timezone: timezone, teamId: teamId, scheduleId: scheduleId })=>{
    return (0, $j74qU.eocFetch)((0, $cB5Mt.urls).schedules.scheduleId.clone.url({
        scheduleId: scheduleId
    }), {
        method: 'POST',
        body: {
            description: description,
            name: name,
            enabled: enabled,
            timezone: timezone,
            teamId: teamId
        }
    });
};
const $7066040345150142$export$3a2536d80ecc00e7 = {
    createSchedule: $7066040345150142$var$createSchedule,
    getScheduleRights: $7066040345150142$var$getScheduleRights,
    cloneSchedule: $7066040345150142$var$cloneSchedule
};

});


parcelRegister("4Igwk", function(module, exports) {

$parcel$export(module.exports, "getTeam", () => $54c26d3a47aeeed9$export$491fe77f22ab2b51);

var $j74qU = parcelRequire("j74qU");
const $54c26d3a47aeeed9$export$491fe77f22ab2b51 = (teamId)=>(0, $j74qU.eocFetch)(`/v1/alerts/responders/names`, {
        method: 'POST',
        body: {
            responders: [
                {
                    id: teamId,
                    type: 'team'
                }
            ]
        }
    });

});


parcelRegister("5ozXn", function(module, exports) {

$parcel$export(module.exports, "eocOnCallRoute", () => $deb5dca00817980c$export$5eaa466ae8a4d7d3);
const $deb5dca00817980c$export$5eaa466ae8a4d7d3 = {
    name: 'eoc-on-call',
    path: '/jira/ops/teams/:teamId/on-call',
    exact: true
};

});


parcelRegister("2B61u", function(module, exports) {

$parcel$export(module.exports, "eocOverviewAllTeamsRouteEntry", () => $da84e8a7a2986788$export$842d7c81068bb64e);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $bh0Pj = parcelRequire("bh0Pj");

var $7NszV = parcelRequire("7NszV");

var $5OcAv = parcelRequire("5OcAv");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $6QP4T = parcelRequire("6QP4T");

var $jxRF2 = parcelRequire("jxRF2");

var $gNStA = parcelRequire("gNStA");

var $4R6GH = parcelRequire("4R6GH");

var $9FJ7w = parcelRequire("9FJ7w");
const $da84e8a7a2986788$export$842d7c81068bb64e = (0, $7NszV.createEntry)((0, $6QP4T.eocOverviewAllTeamsRoute), ()=>({
        group: 'eoc',
        component: (0, $9FJ7w.EocOverviewAllTeamsComponent),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $5OcAv.getTeamsResource),
            ...(0, $jxRF2.eocCommonResources)().map((resource)=>(0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('your_work_page_operation_widgets_changes'), resource))
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).HOME,
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsOverviewNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bh0Pj.LazyHorizontalOperationsOverviewNav),
            (0, $9FJ7w.LazyOverviewAllTeamsPage)
        ]
    }));

});
parcelRegister("5OcAv", function(module, exports) {

$parcel$export(module.exports, "getTeamsResource", () => $221e2d1c864e815a$export$27d854bd39923fc7);
// eslint-disable-next-line jira/import-whitelist

var $9qm0o = parcelRequire("9qm0o");
var $8NtOA = parcelRequire("8NtOA");

var $4R6GH = parcelRequire("4R6GH");

var $2M1hQ = parcelRequire("2M1hQ");

var $3H5ry = parcelRequire("3H5ry");

const $221e2d1c864e815a$export$27d854bd39923fc7 = (0, $2M1hQ.createResource)({
    type: (0, $8NtOA.getTeamsResource).type,
    getKey: (0, $8NtOA.getTeamsResource).getKey,
    getData: async ({ dependencies: dependencies }, { tenantContext: { atlassianAccountId: atlassianAccountId, isSiteAdmin: isSiteAdmin, isAdmin: isAdmin } })=>{
        if (!atlassianAccountId) return null;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const tenantInfo = await dependencies[0, $5a94e356f9d5e220$export$25ee35b01de9d734]?.promise;
        const isOpsAdmin = (0, $3H5ry.checkIsOpsAdmin)(tenantInfo);
        const shouldSeeAllTeams = (0, $4R6GH.fg)('operations-tenant-info-endpoint-update') ? isSiteAdmin || isAdmin || isOpsAdmin : isSiteAdmin || isAdmin;
        return (0, $9qm0o.getTeams)({
            queryParams: {
                accountId: !shouldSeeAllTeams ? atlassianAccountId : undefined,
                showAvatar: true,
                ...(0, $4R6GH.fg)('display_eoc_managed_teams_with_verified_marks') && {
                    includeTeamExternalDetails: true
                }
            }
        });
    },
    isBrowserOnly: true,
    maxAge: 0,
    depends: [
        (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
    ]
});

});
parcelRegister("9qm0o", function(module, exports) {

$parcel$export(module.exports, "getTeams", () => $66ba5008bb81f78a$export$5a622455e94bac3);

var $j74qU = parcelRequire("j74qU");
const $66ba5008bb81f78a$export$5a622455e94bac3 = ({ url: url, queryParams: queryParams })=>{
    const params = new URLSearchParams();
    if (queryParams.keyword) params.append('keyword', queryParams.keyword);
    if (queryParams.size) params.append('size', queryParams.size.toString());
    if (queryParams.offset) params.append('offset', queryParams.offset.toString());
    if (queryParams.accountId) params.append('memberId', queryParams.accountId);
    if (queryParams.showAvatar) params.append('showAvatar', String(queryParams.showAvatar));
    if (queryParams.includeTeamExternalDetails) params.append('includeTeamExternalDetails', String(queryParams.includeTeamExternalDetails));
    if (url) return (0, $j74qU.eocFetch)(`${url}${params.toString() ? `?${params.toString()}` : ''}`, {
        exactUrl: true
    });
    return (0, $j74qU.eocFetch)(`/v1/teams${params.toString() ? `?${params.toString()}` : ''}`);
};

});

parcelRegister("8NtOA", function(module, exports) {

$parcel$export(module.exports, "getTeamsResource", () => $61e1720e70cf825e$export$27d854bd39923fc7);

var $2M1hQ = parcelRequire("2M1hQ");

var $9qm0o = parcelRequire("9qm0o");
const $61e1720e70cf825e$export$27d854bd39923fc7 = (0, $2M1hQ.createResource)({
    type: 'getTeamsResource',
    getKey: ()=>'overview',
    getData: async ()=>{
        throw new Error('getData of getTeamsResource is not implemented in platform package, you should do it in your product');
    },
    isBrowserOnly: true
});

});


parcelRegister("6QP4T", function(module, exports) {

$parcel$export(module.exports, "eocOverviewAllTeamsRoute", () => $0f11196ea10bf082$export$dbe53627482b9f0f);
const $0f11196ea10bf082$export$dbe53627482b9f0f = {
    name: 'eoc-overview-all-teams',
    path: '/jira/ops/overview/teams',
    exact: true
};

});

parcelRegister("9FJ7w", function(module, exports) {

$parcel$export(module.exports, "LazyOverviewPage", () => $9dfc49c8c344cd92$export$c7c96cc8d6e9a8f1);
$parcel$export(module.exports, "LazyOverviewAllTeamsPage", () => $9dfc49c8c344cd92$export$9a22ecad8322834e);
$parcel$export(module.exports, "EocOverviewComponent", () => $9dfc49c8c344cd92$export$b22309f0ee469d5c);
$parcel$export(module.exports, "EocOverviewAllTeamsComponent", () => $9dfc49c8c344cd92$export$2713003ebbdbb975);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $9dfc49c8c344cd92$export$c7c96cc8d6e9a8f1 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("6C0jk")).then((m)=>m.OverviewPage), {
    moduleId: "./src/packages/eoc/overview/src/ui/overview-page/index.tsx"
});

const $9dfc49c8c344cd92$export$9a22ecad8322834e = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("2HwSR")).then((m)=>m.AllTeamsPage), {
    moduleId: "./src/packages/eoc/overview/src/ui/all-teams-page/index.tsx"
});
const $9dfc49c8c344cd92$export$b22309f0ee469d5c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $9dfc49c8c344cd92$export$c7c96cc8d6e9a8f1,
        pageId: "async-jira-eoc-overview",
        shouldShowSpinner: false
    });
const $9dfc49c8c344cd92$export$2713003ebbdbb975 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $9dfc49c8c344cd92$export$9a22ecad8322834e,
        pageId: "async-jira-eoc-overview-all-teams",
        shouldShowSpinner: false
    });

});
parcelRegister("6C0jk", function(module, exports) {

let $4d068860403e602a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4d068860403e602a$var$load("6ff4v").then(()=>parcelRequire('hTI3Y'));

});

parcelRegister("2HwSR", function(module, exports) {

let $1f791af300a0ec47$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $1f791af300a0ec47$var$load("ffQaD"),
    $1f791af300a0ec47$var$load("kvRbA"),
    $1f791af300a0ec47$var$load("bkLVV")
]).then(()=>parcelRequire('jMqXq'));

});



parcelRegister("e04XT", function(module, exports) {

$parcel$export(module.exports, "eocOverviewRouteEntry", () => $df54ba0aea7ee8de$export$f1a859c727c30be4);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $bh0Pj = parcelRequire("bh0Pj");

var $7NszV = parcelRequire("7NszV");

var $5OcAv = parcelRequire("5OcAv");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $bDEHF = parcelRequire("bDEHF");

var $eZXFU = parcelRequire("eZXFU");

var $jxRF2 = parcelRequire("jxRF2");

var $gNStA = parcelRequire("gNStA");

var $4R6GH = parcelRequire("4R6GH");

var $9FJ7w = parcelRequire("9FJ7w");
const $df54ba0aea7ee8de$export$f1a859c727c30be4 = (0, $7NszV.createEntry)((0, $bDEHF.eocOverviewRoute), ()=>({
        group: 'eoc',
        component: (0, $9FJ7w.EocOverviewComponent),
        layout: (0, $eZXFU.opsMigrationHubLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $5OcAv.getTeamsResource),
            ...(0, $jxRF2.eocCommonResources)().map((resource)=>(0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('your_work_page_operation_widgets_changes'), resource))
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).HOME,
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsOverviewNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bh0Pj.LazyHorizontalOperationsOverviewNav),
            (0, $9FJ7w.LazyOverviewPage)
        ]
    }));

});
parcelRegister("bDEHF", function(module, exports) {

$parcel$export(module.exports, "eocOverviewRoute", () => $82d2d783c671586e$export$cb929d46451a5c12);
const $82d2d783c671586e$export$cb929d46451a5c12 = {
    name: 'eoc-overview',
    path: '/jira/ops/overview',
    exact: true
};

});


parcelRegister("hGFnn", function(module, exports) {

$parcel$export(module.exports, "eocPermissionsRouteEntry", () => $b9f5341ba0d7de14$export$c2ced436a30c60dc);

var $j4Jjv = parcelRequire("j4Jjv");

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $1N8g8 = parcelRequire("1N8g8");

var $haBWo = parcelRequire("haBWo");
const $b9f5341ba0d7de14$export$c2ced436a30c60dc = (0, $7NszV.createEntry)((0, $1N8g8.eocPermissionsRoute), ()=>({
        group: 'eoc',
        component: (0, $haBWo.default),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // pageAccessResource should be defined before memberRolesResources since they depend on it
            (0, $j4Jjv.pageAccessResource),
            ...(0, $j4Jjv.resources)(),
            ...(0, $2r8fH.resources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $haBWo.LazyMemberRoles),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("j4Jjv", function(module, exports) {

$parcel$export(module.exports, "pageAccessResource", () => $0ef99385700ea410$export$b0d36f8262140e35);
$parcel$export(module.exports, "memberRolesResource", () => $0ef99385700ea410$export$5c4885c1f1a535b);
$parcel$export(module.exports, "getTeamResource", () => $0ef99385700ea410$export$50271c9e7f21f10e);
$parcel$export(module.exports, "customTeamRolesResource", () => $0ef99385700ea410$export$ed1eb48699cf7893);
$parcel$export(module.exports, "resources", () => $0ef99385700ea410$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $VSDnB = parcelRequire("VSDnB");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $cN8Qq = parcelRequire("cN8Qq");
const $0ef99385700ea410$var$mapStatus = (status, userAccessLevel)=>{
    if (userAccessLevel === 'INTERNAL_INACTIVE') return 'suspended';
    if (status === 'REQUEST_ACCESS' || status === 'DENIED_REQUEST_EXISTS' || status === 'FORBIDDEN' || status === 'DIRECT_ACCESS') return 'invite';
    if (status === 'ACCESS_EXISTS') return 'member';
    if (status === 'PENDING_REQUEST_EXISTS') return 'pending';
    if (status === '' || status === undefined) return 'member';
    return 'invite';
};
const $0ef99385700ea410$var$checkPageAccessRightsOnRouteDependency = async (dependencies)=>{
    let isAuthorizedToSeeMemberRolesPage = false;
    if (dependencies[$0ef99385700ea410$var$PAGE_ACCESS_RESOURCE_TYPE]) {
        const data = await dependencies[$0ef99385700ea410$var$PAGE_ACCESS_RESOURCE_TYPE].promise;
        isAuthorizedToSeeMemberRolesPage = data?.productOrTeamAdmin;
    }
    return isAuthorizedToSeeMemberRolesPage;
};
const $0ef99385700ea410$var$getMembersPaginated = async (teamId)=>{
    let hasNextPage = true;
    let endCursor = '';
    let members = [];
    while(hasNextPage && endCursor !== null){
        const gqlResponse = await (0, $cN8Qq.getMembers)(teamId, endCursor);
        endCursor = gqlResponse.data.team?.teamV2?.members.pageInfo.endCursor ?? '';
        hasNextPage = gqlResponse.data.team?.teamV2?.members.pageInfo.hasNextPage ?? false;
        const newMembers = gqlResponse.data.team?.teamV2?.members.edges.map((edge)=>edge.node.member);
        if (newMembers) members = [
            ...members,
            ...newMembers
        ];
    }
    return members;
};
const $0ef99385700ea410$var$PAGE_ACCESS_RESOURCE_TYPE = 'pageAccessResource';
const $0ef99385700ea410$export$b0d36f8262140e35 = (0, $2M1hQ.createResource)({
    type: $0ef99385700ea410$var$PAGE_ACCESS_RESOURCE_TYPE,
    getKey: ()=>'pageAccessResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $hmVmJ.assert)(!!teamId, new (0, $dH6Pi.AssertionError)('pageAccessResource', 'teamId should be set to fetch page access'));
        return (0, $cN8Qq.getMemberRolesPageAccess)(teamId);
    },
    isBrowserOnly: true
});
const $0ef99385700ea410$export$5c4885c1f1a535b = (0, $2M1hQ.createResource)({
    type: 'memberRolesResource',
    getKey: ()=>'memberRolesResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        const dependencies = routerContext.dependencies;
        (0, $hmVmJ.assert)(!!teamId, new (0, $dH6Pi.AssertionError)('memberRolesResource', 'teamId should be set to fetch member-roles'));
        const isAuthorizedToSeeMemberRolesPage = await $0ef99385700ea410$var$checkPageAccessRightsOnRouteDependency(dependencies);
        if (!isAuthorizedToSeeMemberRolesPage) return null;
        let members;
        if ((0, $VSDnB.fg)('member-roles-graphql-paginaton')) members = await $0ef99385700ea410$var$getMembersPaginated(teamId);
        else {
            const gqlResponse = await (0, $cN8Qq.getMembersOld)(teamId);
            members = gqlResponse?.data.team?.teamV2?.members.edges.map((edge)=>edge.node.member) || [];
        }
        const memberRoleResponse = await (0, $cN8Qq.getRoleAndJSMLicenseInfoEndpoint)({
            platformTeamId: teamId,
            accountIds: members.map((member)=>member.accountId)
        });
        const teamMembers = members.map((user)=>{
            const userWithRole = memberRoleResponse.teamMembers.find((userWithRole)=>userWithRole.accountId === user.accountId);
            return {
                ...user,
                role: userWithRole?.roleId || 'user',
                jsmLicense: userWithRole?.jsmLicense || false,
                jiraAdmin: userWithRole?.jiraAdmin || false,
                invitationStatus: 'member'
            };
        });
        const membersWithoutJSMLicense = teamMembers.filter((teamMembers)=>!teamMembers.jsmLicense);
        if (!membersWithoutJSMLicense.length) return teamMembers;
        const accountIds = membersWithoutJSMLicense.map((member)=>member.accountId).join(',');
        try {
            const { embeddedValue: embeddedValue } = await (0, $cN8Qq.getJSMInvitationStatusInfoEndpoint)({
                accountIds: accountIds
            });
            return teamMembers.map((user)=>{
                const userWithInvitationStatus = embeddedValue.find((userWithInvitationStatus)=>userWithInvitationStatus.accountId === user.accountId);
                return {
                    ...user,
                    invitationStatus: $0ef99385700ea410$var$mapStatus(userWithInvitationStatus?.accessMode, userWithInvitationStatus?.userAccessLevel)
                };
            });
        } catch  {
            return teamMembers;
        }
    },
    isBrowserOnly: true,
    depends: [
        $0ef99385700ea410$var$PAGE_ACCESS_RESOURCE_TYPE
    ]
});
const $0ef99385700ea410$export$50271c9e7f21f10e = (0, $2M1hQ.createResource)({
    type: 'getTeamResource',
    getKey: ()=>'getTeamResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $hmVmJ.assert)(!!teamId, new (0, $dH6Pi.AssertionError)('getTeamResource', 'teamId should be set to fetch team info on member roles'));
        return (0, $cN8Qq.getTeam)(teamId);
    },
    isBrowserOnly: true
});
const $0ef99385700ea410$export$ed1eb48699cf7893 = (0, $2M1hQ.createResource)({
    type: 'customTeamRolesResource',
    getKey: ()=>'customRolesResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        const dependencies = routerContext.dependencies;
        (0, $hmVmJ.assert)(!!teamId, new (0, $dH6Pi.AssertionError)('customTeamRolesResource', 'teamId should be set to fetch custom-team-roles'));
        const isAuthorizedToSeeMemberRolesPage = await $0ef99385700ea410$var$checkPageAccessRightsOnRouteDependency(dependencies);
        if (!isAuthorizedToSeeMemberRolesPage) return null;
        return (0, $cN8Qq.getCustomTeamRolesEndpoint)(teamId);
    },
    isBrowserOnly: true,
    depends: [
        $0ef99385700ea410$var$PAGE_ACCESS_RESOURCE_TYPE
    ]
});
const $0ef99385700ea410$export$bc99aaabaf7b70a7 = ()=>[
        $0ef99385700ea410$export$5c4885c1f1a535b,
        $0ef99385700ea410$export$50271c9e7f21f10e,
        $0ef99385700ea410$export$ed1eb48699cf7893
    ];

});
parcelRegister("cN8Qq", function(module, exports) {

$parcel$export(module.exports, "getMembersOld", () => $33127c313f2bb6a1$export$dc7a9fe3089fc26e);
$parcel$export(module.exports, "getMembers", () => $33127c313f2bb6a1$export$f4931e6f9feb30c5);
$parcel$export(module.exports, "getMemberRolesPageAccess", () => $33127c313f2bb6a1$export$95d4c4e762437fdd);
$parcel$export(module.exports, "getRoleAndJSMLicenseInfoEndpoint", () => $33127c313f2bb6a1$export$38ab389cb64a5000);
$parcel$export(module.exports, "getJSMInvitationStatusInfoEndpoint", () => $33127c313f2bb6a1$export$fd43007da8683026);
$parcel$export(module.exports, "getTeam", () => $33127c313f2bb6a1$export$491fe77f22ab2b51);
$parcel$export(module.exports, "getCustomTeamRolesEndpoint", () => $33127c313f2bb6a1$export$ebfa293eb1ef42f5);

var $VSDnB = parcelRequire("VSDnB");

var $j74qU = parcelRequire("j74qU");
var $030R0 = parcelRequire("030R0");
const $33127c313f2bb6a1$var$operationName = 'memberRolesTeamMembersQuery';
const $33127c313f2bb6a1$var$getMembersParams = (after)=>{
    const firstParam = (0, $VSDnB.fg)('platform_increase_limit_of_members_query') ? 'first: 300' : 'first: 100';
    const afterParam = after ? `, after: "${after}"` : '';
    return `(${firstParam}${afterParam})`;
};
const $33127c313f2bb6a1$export$dc7a9fe3089fc26e = (teamId)=>{
    const queryUrl = '/gateway/api/graphql';
    const teamAri = `ari:cloud:identity::team/${teamId}`;
    const siteId = (0, $030R0.getMeta)('ajs-cloud-id');
    const membersQueryV2 = `query memberRolesTeamMembersQuery($teamId: ID!, $siteId: String!) {
		team {
			teamV2 (id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
				id
				members ${(0, $VSDnB.fg)('platform_increase_limit_of_members_query') ? '(first: 300)' : ''}{
					edges {
						cursor
						node {
							member  {
								... on AtlassianAccountUser {
									email
								}
								name
								picture
								accountId
								accountStatus
							}
							state
							role
						}
					}
				}
			}
		}
	}
	`;
    return (0, $j74qU.eocFetch)(queryUrl, {
        method: 'POST',
        body: JSON.stringify({
            operationName: $33127c313f2bb6a1$var$operationName,
            query: membersQueryV2,
            variables: {
                teamId: teamAri,
                siteId: siteId
            }
        }),
        headers: {
            'Content-Type': 'application/json',
            'X-ExperimentalApi': 'teams-beta, team-members-beta'
        },
        exactUrl: true
    });
};
const $33127c313f2bb6a1$export$f4931e6f9feb30c5 = (teamId, after)=>{
    const queryUrl = '/gateway/api/graphql';
    const teamAri = `ari:cloud:identity::team/${teamId}`;
    const siteId = (0, $030R0.getMeta)('ajs-cloud-id');
    const membersQueryV2 = `query memberRolesTeamMembersQuery($teamId: ID!, $siteId: String!) {
		team {
			teamV2 (id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
				id
				members ${$33127c313f2bb6a1$var$getMembersParams(after)}{
					edges {
						cursor
						node {
							member  {
								... on AtlassianAccountUser {
									email
								}
								name
								picture
								accountId
								accountStatus
							}
							state
							role
						}
					}
					pageInfo {
						endCursor
						hasNextPage
					}
				}
			}
		}
	}
	`;
    return (0, $j74qU.eocFetch)(queryUrl, {
        method: 'POST',
        body: JSON.stringify({
            operationName: $33127c313f2bb6a1$var$operationName,
            query: membersQueryV2,
            variables: {
                teamId: teamAri,
                siteId: siteId
            }
        }),
        headers: {
            'Content-Type': 'application/json',
            'X-ExperimentalApi': 'teams-beta, team-members-beta'
        },
        exactUrl: true
    });
};
const $33127c313f2bb6a1$export$95d4c4e762437fdd = (teamId)=>(0, $j74qU.eocFetch)(`/v1/teams/members/member-roles-page-access?platformTeamId=${teamId}`);
const $33127c313f2bb6a1$export$38ab389cb64a5000 = ({ platformTeamId: platformTeamId, accountIds: accountIds })=>(0, $j74qU.eocFetch)(`/v1/teams/members`, {
        method: 'POST',
        body: {
            platformTeamId: platformTeamId,
            accountIds: accountIds
        }
    });
const $33127c313f2bb6a1$export$fd43007da8683026 = ({ accountIds: accountIds })=>(0, $j74qU.eocFetch)(`/v1/users/access-request-capabilities?accountIds=${accountIds}`, {
        method: 'GET'
    });
const $33127c313f2bb6a1$export$491fe77f22ab2b51 = (teamId)=>(0, $j74qU.eocFetch)(`/v1/alerts/responders/names`, {
        method: 'POST',
        body: {
            responders: [
                {
                    id: teamId,
                    type: 'team'
                }
            ]
        }
    });
const $33127c313f2bb6a1$export$ebfa293eb1ef42f5 = (platformTeamId)=>(0, $j74qU.eocFetch)(`/v1/teams/${platformTeamId}/roles`);

});


parcelRegister("1N8g8", function(module, exports) {

$parcel$export(module.exports, "eocPermissionsRoute", () => $a690bc071b9eec32$export$8e6afd724de3be6e);
const $a690bc071b9eec32$export$8e6afd724de3be6e = {
    name: 'eoc-permissions',
    path: '/jira/ops/teams/:teamId/settings',
    exact: true
};

});

parcelRegister("haBWo", function(module, exports) {

$parcel$export(module.exports, "LazyMemberRoles", () => $54e18f7965bed61c$export$27b4fb95241ab47);
$parcel$export(module.exports, "default", () => $54e18f7965bed61c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $54e18f7965bed61c$export$27b4fb95241ab47 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("bJDjw")), {
    moduleId: "./src/packages/eoc/member-roles/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$54e18f7965bed61c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $54e18f7965bed61c$export$27b4fb95241ab47,
        pageId: "async-jira-eoc-member-roles",
        shouldShowSpinner: false
    });

});
parcelRegister("bJDjw", function(module, exports) {

let $88b2649ac3677211$var$load = (parcelRequire("28QjX"))(4);
module.exports = $88b2649ac3677211$var$load("kBdWD").then(()=>parcelRequire('6Zxu7'));

});



parcelRegister("bAN0d", function(module, exports) {

$parcel$export(module.exports, "eocReportsTeamRedirectRouteEntry", () => $8d76deaec1999545$export$c5606e8eeca32c0f);

var $dY89w = parcelRequire("dY89w");

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $8mgka = parcelRequire("8mgka");

var $5GbXG = parcelRequire("5GbXG");
const $8d76deaec1999545$export$c5606e8eeca32c0f = (0, $7NszV.createEntry)((0, $8mgka.eocReportsTeamRedirectRoute), ()=>({
        group: 'eoc',
        component: (0, $5GbXG.OpsReportsRedirect),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $2r8fH.resources)(),
            ...(0, $dY89w.resources)(),
            (0, $dY89w.opsReportsPermissionResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5GbXG.LazyOpsReportsRedirect),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("8mgka", function(module, exports) {

$parcel$export(module.exports, "eocReportsTeamRedirectRoute", () => $4180c49ce19c4186$export$26b0a544e6502d55);
const $4180c49ce19c4186$export$26b0a544e6502d55 = {
    name: 'eoc-reports',
    path: '/jira/ops/teams/:teamId/reports',
    exact: true
};

});


parcelRegister("cLm5J", function(module, exports) {

$parcel$export(module.exports, "eocReportsTeamRouteEntry", () => $7f20eb6c54fad956$export$cd1c1a81e516fec5);

var $dY89w = parcelRequire("dY89w");

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $bSLd2 = parcelRequire("bSLd2");

var $5GbXG = parcelRequire("5GbXG");
const $7f20eb6c54fad956$export$cd1c1a81e516fec5 = (0, $7NszV.createEntry)((0, $bSLd2.eocReportsTeamRoute), ()=>({
        group: 'eoc',
        component: (0, $5GbXG.OpsReports),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $2r8fH.resources)(),
            ...(0, $dY89w.resources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5GbXG.LazyOpsReports),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("bSLd2", function(module, exports) {

$parcel$export(module.exports, "eocReportsTeamRoute", () => $ffd6c3cc5b5e020a$export$c9e0796615c034f3);
const $ffd6c3cc5b5e020a$export$c9e0796615c034f3 = {
    name: 'eoc-reports-team',
    path: '/jira/ops/teams/:teamId/reports/:dashboardId',
    exact: true
};

});


parcelRegister("dbAmH", function(module, exports) {

$parcel$export(module.exports, "eocReportsUnsubscribeRouteEntry", () => $a7106536ac902eff$export$6e8d112a548528b5);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $gEF2C = parcelRequire("gEF2C");

var $5GbXG = parcelRequire("5GbXG");
const $a7106536ac902eff$export$6e8d112a548528b5 = (0, $7NszV.createEntry)((0, $gEF2C.eocReportsUnsubscribeRoute), ()=>({
        group: 'eoc',
        component: (0, $5GbXG.OpsReportsUnsubscribe),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5GbXG.LazyOpsReportsUnsubscribe)
        ]
    }));

});
parcelRegister("gEF2C", function(module, exports) {

$parcel$export(module.exports, "eocReportsUnsubscribeRoute", () => $491397448b2426d8$export$72cde899ee974e6e);
const $491397448b2426d8$export$72cde899ee974e6e = {
    name: 'eoc-reports-unsubscribe',
    path: '/jira/ops/reports/unsubscribe/:templateId/:subscriptionId',
    exact: true
};

});


parcelRegister("jPcas", function(module, exports) {

$parcel$export(module.exports, "eocScheduleGlobalRouteEntry", () => $8a8ca7bd84166494$export$831e8756cdaae4ba);

var $5uXOq = parcelRequire("5uXOq");

var $9AeZq = parcelRequire("9AeZq");

var $ffza4 = parcelRequire("ffza4");

var $eZXFU = parcelRequire("eZXFU");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $4ft8f = parcelRequire("4ft8f");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8a8ca7bd84166494$var$LazyScheduleGlobalPage = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("k2zD9")).then((m)=>m.ScheduleGlobalPage), {
    moduleId: "./src/packages/eoc/schedule-global/src/ui/index.tsx"
});
const $8a8ca7bd84166494$var$EocScheduleGlobalComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8a8ca7bd84166494$var$LazyScheduleGlobalPage,
        pageId: "async-jira-eoc-schedule-global",
        shouldShowSpinner: false
    });
const $8a8ca7bd84166494$var$getNavigationSpecifications = ()=>{
    return (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $8a8ca7bd84166494$export$831e8756cdaae4ba = (0, $7NszV.createEntry)((0, $4ft8f.eocScheduleGlobalRoute), ()=>({
        group: 'eoc',
        component: $8a8ca7bd84166494$var$EocScheduleGlobalComponent,
        layout: (0, $eZXFU.opsSettingsLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $9AeZq.resources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$8a8ca7bd84166494$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            $8a8ca7bd84166494$var$LazyScheduleGlobalPage
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            $8a8ca7bd84166494$var$LazyScheduleGlobalPage
        ]
    }));

});
parcelRegister("9AeZq", function(module, exports) {

$parcel$export(module.exports, "resources", () => $3fd272a65e76c31a$export$bc99aaabaf7b70a7);

var $jxRF2 = parcelRequire("jxRF2");

var $dmLt8 = parcelRequire("dmLt8");
const $3fd272a65e76c31a$export$bc99aaabaf7b70a7 = ()=>[
        (0, $dmLt8.getTimezonesResource),
        (0, $dmLt8.getTimeTemplatesResource),
        ...(0, $jxRF2.eocCommonResources)()
    ];

});

parcelRegister("4ft8f", function(module, exports) {

$parcel$export(module.exports, "eocScheduleGlobalRoute", () => $9844eccd8c34fec5$export$10454dc485142eb6);
const $9844eccd8c34fec5$export$10454dc485142eb6 = {
    name: 'eoc-schedules',
    path: '/jira/settings/products/ops/schedules',
    exact: true
};

});

parcelRegister("k2zD9", function(module, exports) {

let $e96fa20a86511590$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e96fa20a86511590$var$load("ffQaD"),
    $e96fa20a86511590$var$load("kvRbA"),
    $e96fa20a86511590$var$load("lN09y")
]).then(()=>parcelRequire('94AYi'));

});


parcelRegister("k7VEf", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertDetailRouteEntry", () => $0f8c358fa6dbfa33$export$94aaa7006da9d63a);

var $en1L8 = parcelRequire("en1L8");

var $8C32n = parcelRequire("8C32n");

var $2r8fH = parcelRequire("2r8fH");

var $i5qMw = parcelRequire("i5qMw");

var $4R6GH = parcelRequire("4R6GH");

var $gNStA = parcelRequire("gNStA");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $fnZCh = parcelRequire("fnZCh");

var $cgOQ8 = parcelRequire("cgOQ8");
const $0f8c358fa6dbfa33$export$94aaa7006da9d63a = (0, $7NszV.createEntry)((0, $fnZCh.eocTeamAlertDetailRoute), ()=>({
        group: 'eoc',
        component: (0, $cgOQ8.default),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $2r8fH.resources)(),
            ...(0, $8C32n.resources)(),
            ...(0, $en1L8.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('automation_discoverability_in_jsm'), (0, $i5qMw.getAutomationDiscoveryDismissResource))
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cgOQ8.LazyAlertList),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("cgOQ8", function(module, exports) {

$parcel$export(module.exports, "LazyAlertList", () => $c4eca2f6e4b2f333$export$f4aafff31d950b6c);
$parcel$export(module.exports, "default", () => $c4eca2f6e4b2f333$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $c4eca2f6e4b2f333$export$f4aafff31d950b6c = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("9m0hg")), {
    moduleId: "./src/packages/eoc/alert-list/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c4eca2f6e4b2f333$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $c4eca2f6e4b2f333$export$f4aafff31d950b6c,
        pageId: "async-jira-eoc-alert-list",
        shouldShowSpinner: false
    });

});


parcelRegister("i27Sx", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertIssueSyncingCreateRouteEntry", () => $529c88752df4ac9c$export$8c07dc381591dc69);

var $6YWw1 = parcelRequire("6YWw1");

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $4rSQD = parcelRequire("4rSQD");

var $jh1uq = parcelRequire("jh1uq");

var $3dgEU = parcelRequire("3dgEU");

var $a5NQf = parcelRequire("a5NQf");
const $529c88752df4ac9c$export$8c07dc381591dc69 = (0, $7NszV.createEntry)((0, $4rSQD.eocTeamAlertIssueSyncingCreateRoute), ()=>({
        group: 'eoc',
        component: (0, $jh1uq.AlertIssueSync),
        layout: (0, $h3Ix2.opsTeamLayout),
        slot: (0, $3dgEU.AlertIssueSyncCreate),
        basePath: '/jira/ops/teams',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $2r8fH.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $6YWw1.resources).configuredSyncsResource,
            (0, $6YWw1.resources).userAccessRightsResource,
            (0, $6YWw1.resources).getTeamResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a5NQf.LazyAlertIssueSync),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("4rSQD", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertIssueSyncingCreateRoute", () => $daedb7d5520453e5$export$915ef1948fe4650a);
const $daedb7d5520453e5$export$915ef1948fe4650a = {
    name: 'eoc-team-alert-issue-syncing-create',
    path: '/jira/ops/teams/:teamId/syncs/create',
    exact: true
};

});


parcelRegister("qjJTn", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertIssueSyncingDetailRouteEntry", () => $a162d438dc34f2e2$export$6298ff494c460e75);

var $6YWw1 = parcelRequire("6YWw1");

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $6DLNJ = parcelRequire("6DLNJ");

var $fzxhM = parcelRequire("fzxhM");

var $jh1uq = parcelRequire("jh1uq");

var $a5NQf = parcelRequire("a5NQf");
const $a162d438dc34f2e2$export$6298ff494c460e75 = (0, $7NszV.createEntry)((0, $6DLNJ.eocTeamAlertIssueSyncingDetailRoute), ()=>({
        group: 'eoc',
        component: (0, $jh1uq.AlertIssueSync),
        layout: (0, $h3Ix2.opsTeamLayout),
        slot: (0, $fzxhM.AlertIssueSyncDetail),
        basePath: '/jira/ops/teams',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $2r8fH.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $6YWw1.resources).configuredSyncsResource,
            (0, $6YWw1.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a5NQf.LazyAlertIssueSync),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("6DLNJ", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertIssueSyncingDetailRoute", () => $19f7daafdc2ca993$export$e91535fc2137c3b);
const $19f7daafdc2ca993$export$e91535fc2137c3b = {
    name: 'eoc-team-alert-issue-syncing-detail',
    path: '/jira/ops/teams/:teamId/syncs/:syncId',
    exact: true
};

});


parcelRegister("5xt55", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertIssueSyncingRouteEntry", () => $4357b8f4ed10df63$export$be342a3401146aae);

var $6YWw1 = parcelRequire("6YWw1");

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $f8agQ = parcelRequire("f8agQ");

var $jh1uq = parcelRequire("jh1uq");

var $a5NQf = parcelRequire("a5NQf");
const $4357b8f4ed10df63$export$be342a3401146aae = (0, $7NszV.createEntry)((0, $f8agQ.eocTeamAlertIssueSyncingRoute), ()=>({
        group: 'eoc',
        component: (0, $jh1uq.AlertIssueSync),
        layout: (0, $h3Ix2.opsTeamLayout),
        slot: null,
        basePath: '/jira/ops/teams',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $2r8fH.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $6YWw1.resources).configuredSyncsResource,
            (0, $6YWw1.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a5NQf.LazyAlertIssueSync),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("f8agQ", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertIssueSyncingRoute", () => $4b9c202f143c618b$export$37ea7624561cbb89);
const $4b9c202f143c618b$export$37ea7624561cbb89 = {
    name: 'eoc-team-alert-issue-syncing',
    path: '/jira/ops/teams/:teamId/syncs',
    exact: true
};

});


parcelRegister("4yINJ", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertListRouteEntry", () => $f23486e21e430737$export$de37dab3b3ed8e5c);

var $8C32n = parcelRequire("8C32n");

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $fH1HX = parcelRequire("fH1HX");

var $cgOQ8 = parcelRequire("cgOQ8");
const $f23486e21e430737$export$de37dab3b3ed8e5c = (0, $7NszV.createEntry)((0, $fH1HX.eocTeamAlertListRoute), ()=>({
        group: 'eoc',
        component: (0, $cgOQ8.default),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $2r8fH.resources)(),
            ...(0, $8C32n.resources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cgOQ8.LazyAlertList),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("fH1HX", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertListRoute", () => $f402982842ecbfd0$export$94efd60f23d97aa5);
const $f402982842ecbfd0$export$94efd60f23d97aa5 = {
    name: 'eoc-team-alerts',
    path: '/jira/ops/teams/:teamId/alerts',
    exact: true
};

});


parcelRegister("bubms", function(module, exports) {

$parcel$export(module.exports, "eocTeamCustomerLogsDownloadRouteEntry", () => $aca15c3cadc5a7fe$export$d2ce6f09ef8aa840);

var $c4Buu = parcelRequire("c4Buu");

var $ibkIl = parcelRequire("ibkIl");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $6ZSdP = parcelRequire("6ZSdP");

var $8OJXJ = parcelRequire("8OJXJ");
const $aca15c3cadc5a7fe$export$d2ce6f09ef8aa840 = (0, $7NszV.createEntry)((0, $6ZSdP.eocTeamCustomerLogsDownloadRoute), ()=>({
        group: 'eoc',
        component: (0, $8OJXJ.CustomerLogsDownloadPage),
        layout: (0, $ibkIl.globalSettingsLayout),
        resources: [
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $c4Buu.downloadResources)()
        ],
        forPaint: [
            (0, $8OJXJ.LazyCustomerLogsDownLoad)
        ]
    }));

});
parcelRegister("c4Buu", function(module, exports) {

$parcel$export(module.exports, "resources", () => $6eed7288156ead59$export$bc99aaabaf7b70a7);
$parcel$export(module.exports, "downloadResources", () => $6eed7288156ead59$export$8571305c82629fe4);

var $jxRF2 = parcelRequire("jxRF2");

var $k5TFj = parcelRequire("k5TFj");

var $8qZNT = parcelRequire("8qZNT");

var $lCbSp = parcelRequire("lCbSp");
const $6eed7288156ead59$export$bc99aaabaf7b70a7 = ()=>[
        (0, $lCbSp.uiSettingsResource),
        (0, $8qZNT.logsResource),
        ...(0, $jxRF2.eocCommonResources)()
    ];
const $6eed7288156ead59$export$8571305c82629fe4 = ()=>[
        (0, $k5TFj.downloadAuditLogsResource),
        ...(0, $jxRF2.eocCommonResources)()
    ];

});
parcelRegister("k5TFj", function(module, exports) {

$parcel$export(module.exports, "downloadAuditLogsResource", () => $62049603e7f7b61b$export$304da75014b88b78);

var $2M1hQ = parcelRequire("2M1hQ");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $kg5A9 = parcelRequire("kg5A9");
const $62049603e7f7b61b$export$304da75014b88b78 = (0, $2M1hQ.createResource)({
    type: 'download-audit-logs-resource',
    getKey: ()=>'download-audit-logs-resource',
    getData: async (routerContext)=>{
        const uniqueKey = routerContext.match.params.exportUniqueKey;
        (0, $hmVmJ.assert)(!!uniqueKey, new (0, $dH6Pi.AssertionError)('downloadAuditLogs resource', 'uniqueKey must be defined'));
        return (0, $kg5A9.fetchDownloadLinkEndpoint)(uniqueKey);
    },
    maxAge: 0,
    isBrowserOnly: true
});

});
parcelRegister("kg5A9", function(module, exports) {

$parcel$export(module.exports, "fetchDownloadLinkEndpoint", () => $7bc9ff634e8ba041$export$c8df7e5942ba1d96);

var $j74qU = parcelRequire("j74qU");
const $7bc9ff634e8ba041$export$c8df7e5942ba1d96 = async (exportUniqueKey)=>{
    return (0, $j74qU.eocFetch)(`/v1/logs/export/${exportUniqueKey}/download`, {
        responseType: 'text'
    });
};

});


parcelRegister("8qZNT", function(module, exports) {

$parcel$export(module.exports, "logsResource", () => $37d900392ed354d4$export$fd88b4310d3f52ff);

var $2M1hQ = parcelRequire("2M1hQ");

var $kWKaa = parcelRequire("kWKaa");
const $37d900392ed354d4$export$fd88b4310d3f52ff = (0, $2M1hQ.createResource)({
    type: 'ui-get-logs',
    getKey: (routerContext)=>{
        const integrationId = routerContext.match.params.integrationId;
        const urlParam = new URLSearchParams();
        Object.entries(routerContext.query).forEach(([key, value])=>{
            if (value) urlParam.set(key, value);
        });
        return !!integrationId ? `integration-${integrationId}-logs#${urlParam.toString()}` : `ui-get-logs#${urlParam.toString()}`;
    },
    getData: async (routerContext)=>{
        return (0, $kWKaa.fetchLogs)({
            fromUnit: routerContext.query?.fromUnit,
            fromValue: routerContext.query?.fromValue,
            startTimestamp: routerContext.query?.startTimestamp,
            endTimestamp: routerContext.query?.endTimestamp,
            eventCategories: routerContext.query?.eventCategories,
            levels: routerContext.query?.levels,
            size: routerContext.query?.size ?? 30,
            insertedAt: routerContext.query?.insertedAt,
            searchString: routerContext.query?.searchString,
            pageDirection: routerContext.query?.pageDirection ?? 'NEXT',
            integrationId: routerContext.match.params.integrationId
        });
    },
    maxAge: 60000,
    isBrowserOnly: true
});

});
parcelRegister("kWKaa", function(module, exports) {

$parcel$export(module.exports, "fetchLogs", () => $ccc9d84c3a4ba264$export$b9fcc8145a518db4);

var $j74qU = parcelRequire("j74qU");

var $7sija = parcelRequire("7sija");
const $ccc9d84c3a4ba264$export$b9fcc8145a518db4 = async (params)=>{
    const urlParams = (0, $7sija.generateLogParams)(params);
    return (0, $j74qU.eocFetch)('/v1/logs/search?' + urlParams.toString()).then((response)=>(0, $7sija.postProcessLogsSearch)(urlParams, response));
};

});
parcelRegister("7sija", function(module, exports) {

$parcel$export(module.exports, "isValidTimePeriodFormat", () => $102956f839e5f725$export$2214112898027187);
$parcel$export(module.exports, "getBetweenErrorMessage", () => $102956f839e5f725$export$b29a6f1d6d345720);
$parcel$export(module.exports, "isValidBetweenInput", () => $102956f839e5f725$export$7b619dd534dac336);
$parcel$export(module.exports, "isInvalidDateValue", () => $102956f839e5f725$export$f18cd4bc58b99a27);
$parcel$export(module.exports, "checkQueryIncludesValue", () => $102956f839e5f725$export$792d5c0a6d15a15e);
$parcel$export(module.exports, "parseGroupOptionQuery", () => $102956f839e5f725$export$f344cca10df5ca13);
$parcel$export(module.exports, "parseOptionQuery", () => $102956f839e5f725$export$100c2d7fc380fbfa);
$parcel$export(module.exports, "collectQueryParamsFromOptions", () => $102956f839e5f725$export$4db9080fab1bce85);
$parcel$export(module.exports, "calculateTimeBetween", () => $102956f839e5f725$export$42dac873831f0e2);
$parcel$export(module.exports, "generateLogParams", () => $102956f839e5f725$export$85293a2f3995ddcc);
$parcel$export(module.exports, "fromUnitConverter", () => $102956f839e5f725$export$ae02811946c03a4b);
$parcel$export(module.exports, "createBaseQuery", () => $102956f839e5f725$export$9a8301702bf003c4);
$parcel$export(module.exports, "calculateNewStartAndEndTimestamp", () => $102956f839e5f725$export$b06db0f8b326b929);
$parcel$export(module.exports, "isDetailsSectionEmpty", () => $102956f839e5f725$export$74cb10c4b9924e49);
$parcel$export(module.exports, "generateParamsForOneMonthInterval", () => $102956f839e5f725$export$130612b33e678a37);
$parcel$export(module.exports, "calculateWidthAccordingToLevel", () => $102956f839e5f725$export$e083dc64e00e053b);
$parcel$export(module.exports, "getSourceStringFromUrl", () => $102956f839e5f725$export$c6631e198cf7c0f4);
$parcel$export(module.exports, "makeMarkup", () => $102956f839e5f725$export$59302306c6f78677);
$parcel$export(module.exports, "postProcessLogsSearch", () => $102956f839e5f725$export$9a858fe3837c0be0);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $grR0x = parcelRequire("grR0x");

var $jj52j = parcelRequire("jj52j");

var $jovBr = parcelRequire("jovBr");

var $eZDAP = parcelRequire("eZDAP");

var $gn1v9 = parcelRequire("gn1v9");

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");

var $dS3PR = parcelRequire("dS3PR");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $2VsTe = parcelRequire("2VsTe");

var $0yCO3 = parcelRequire("0yCO3");

var $hu2ZI = parcelRequire("hu2ZI");

var $9Pdtb = parcelRequire("9Pdtb");
// jira-frontend/src/packages/jql-builder-basic-datetime/src/ui/utils/time-functions.tsx
const $102956f839e5f725$var$isNumeric = (value)=>/^\d+$/.test(value);
const $102956f839e5f725$export$2214112898027187 = (timeDigits, timeUnit)=>{
    return timeDigits === '' || timeDigits !== undefined && $102956f839e5f725$var$isNumeric(timeDigits) && parseInt(timeDigits, 10) > -1 && (0, $0yCO3.RANGE_OPTIONS).includes(timeUnit);
};
const $102956f839e5f725$export$b29a6f1d6d345720 = (intl, value)=>{
    if (!value?.startDate && !value?.endDate) return intl.formatMessage((0, $9Pdtb.default).validationMessageAtLeastOneValue);
    if (value?.startDate && value?.endDate && new Date(value?.startDate) > new Date(value?.endDate)) return intl.formatMessage((0, $9Pdtb.default).validationMessageBeforeGreaterThanAfter);
    if (value && (value?.startDate !== '' && !(0, $jovBr.default)(new Date(value?.startDate)) || value?.endDate !== '' && !(0, $jovBr.default)(new Date(value?.endDate)))) return intl.formatMessage((0, $9Pdtb.default).validationMessageInvalidDateFormat);
    return undefined;
};
const $102956f839e5f725$export$7b619dd534dac336 = (value)=>{
    if (!value?.startDate && !value?.endDate) return false;
    if (value?.startDate && value?.endDate && new Date(value?.startDate) > new Date(value?.endDate)) return false;
    if (value && (value?.startDate !== '' && !(0, $jovBr.default)(new Date(value?.startDate)) || value?.endDate !== '' && !(0, $jovBr.default)(new Date(value?.endDate)))) return false;
    return true;
};
const $102956f839e5f725$export$f18cd4bc58b99a27 = (value)=>{
    return !(0, $jovBr.default)((0, $eZDAP.default)(value)) && value !== '';
};
const $102956f839e5f725$export$760bb1b75585fb94 = (value)=>{
    return value.map((event)=>event.value).join(',');
};
const $102956f839e5f725$export$792d5c0a6d15a15e = (query, value)=>{
    return query?.includes(value.toString()) ?? false;
};
const $102956f839e5f725$export$f344cca10df5ca13 = (query, options)=>{
    if (!query) return [];
    const labels = [];
    options.map((option)=>{
        option.options.map((item)=>labels.push(item));
    });
    return labels.filter(({ value: value })=>$102956f839e5f725$export$792d5c0a6d15a15e(query, value));
};
const $102956f839e5f725$export$100c2d7fc380fbfa = (query, options)=>{
    if (!query) return [];
    return options.filter((label)=>query.includes(label.value.toString()));
};
const $102956f839e5f725$export$422789958d8174dd = (unit)=>(0, $0yCO3.RANGE_OPTIONS).includes(unit);
const $102956f839e5f725$export$4db9080fab1bce85 = (options)=>{
    return options.map((option)=>option.value).join(',');
};
const $102956f839e5f725$var$isTimeQueryParamsValid = (params)=>{
    if (params.has('startTimestamp') && params.has('endTimestamp')) return true;
    else if (params.has('fromUnit') && params.has('fromValue')) return true;
    return false;
};
const $102956f839e5f725$export$42dac873831f0e2 = (params)=>{
    const now = new Date();
    if (!params.get('startTimestamp') && !params.get('endTimestamp') && params.get('fromUnit') && params.get('fromValue')) {
        const parsedFromValue = parseInt(params.get('fromValue') ?? '1');
        switch(params.get('fromUnit')){
            case 'HOUR':
                params.set('endTimestamp', (now.getTime() * (0, $hu2ZI.NANOSECONDS_IN_MILLISECOND)).toString());
                params.set('startTimestamp', ((0, $gn1v9.default)(now, {
                    hours: parsedFromValue
                }).getTime() * (0, $hu2ZI.NANOSECONDS_IN_MILLISECOND)).toString());
                break;
            case 'DAY':
                params.set('endTimestamp', (now.getTime() * (0, $hu2ZI.NANOSECONDS_IN_MILLISECOND)).toString());
                params.set('startTimestamp', ((0, $gn1v9.default)(now, {
                    days: parsedFromValue
                }).getTime() * (0, $hu2ZI.NANOSECONDS_IN_MILLISECOND)).toString());
                break;
            case 'WEEK':
                params.set('endTimestamp', (now.getTime() * (0, $hu2ZI.NANOSECONDS_IN_MILLISECOND)).toString());
                params.set('startTimestamp', ((0, $gn1v9.default)(now, {
                    weeks: parsedFromValue
                }).getTime() * (0, $hu2ZI.NANOSECONDS_IN_MILLISECOND)).toString());
                break;
            case 'MONTH':
                params.set('endTimestamp', (now.getTime() * (0, $hu2ZI.NANOSECONDS_IN_MILLISECOND)).toString());
                params.set('startTimestamp', ((0, $gn1v9.default)(now, {
                    months: parsedFromValue
                }).getTime() * (0, $hu2ZI.NANOSECONDS_IN_MILLISECOND)).toString());
                break;
        }
        params.delete('fromUnit');
        params.delete('fromValue');
    }
    return params;
};
const $102956f839e5f725$export$85293a2f3995ddcc = (params)=>{
    const urlParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value])=>{
        if (value) urlParams.append(key, decodeURI(value));
    });
    if (!$102956f839e5f725$var$isTimeQueryParamsValid(urlParams)) {
        // Remove time parameters if exists since they were not matched.
        urlParams.delete('fromUnit');
        urlParams.delete('fromValue');
        urlParams.delete('startTimestamp');
        urlParams.delete('endTimestamp');
        urlParams.append('fromUnit', 'DAY');
        urlParams.append('fromValue', '1');
    }
    return $102956f839e5f725$export$42dac873831f0e2(urlParams);
};
const $102956f839e5f725$var$calculateTimeDifference = (startDate, endDate)=>{
    const minutesDiff = (0, $grR0x.default)(endDate, startDate);
    if (minutesDiff < 60) return {
        hours: 1,
        days: 0,
        weeks: 0,
        months: 0,
        years: 0
    };
    const hoursDiff = minutesDiff / 60;
    const daysDiff = minutesDiff / 60 / 24;
    const weeksDiff = minutesDiff / 60 / 24 / 7;
    const monthsDiff = minutesDiff / 60 / 24 / 7 / 4;
    return {
        hours: hoursDiff > 0 ? Math.floor(hoursDiff) : 0,
        days: daysDiff > 0 ? Math.floor(daysDiff) : 0,
        weeks: weeksDiff > 0 ? Math.floor(weeksDiff) : 0,
        months: monthsDiff > 0 ? Math.floor(monthsDiff) : 0
    };
};
const $102956f839e5f725$export$ae02811946c03a4b = (startDate, endDate)=>{
    const parsedStartDate = (0, $eZDAP.default)(startDate);
    const parsedEndDate = (0, $eZDAP.default)(endDate);
    const timeDifference = $102956f839e5f725$var$calculateTimeDifference(parsedStartDate, parsedEndDate);
    if (timeDifference.months > 0) return {
        timeUnit: 'MONTH',
        timeDigits: timeDifference.months.toString()
    };
    else if (timeDifference.weeks > 0) return {
        timeUnit: 'WEEK',
        timeDigits: timeDifference.weeks.toString()
    };
    else if (timeDifference.days > 0) return {
        timeUnit: 'DAY',
        timeDigits: timeDifference.days.toString()
    };
    else return {
        timeUnit: 'HOUR',
        timeDigits: timeDifference.hours.toString()
    };
};
const $102956f839e5f725$export$9a8301702bf003c4 = (query)=>{
    let searchQuery = {};
    if (query.searchString) searchQuery = {
        ...searchQuery,
        searchString: query.searchString
    };
    if (query.startTimestamp && query.endTimestamp) searchQuery = {
        ...searchQuery,
        startTimestamp: query.startTimestamp,
        endTimestamp: query.endTimestamp
    };
    if (query.timeType) searchQuery = {
        ...searchQuery,
        timeType: query.timeType
    };
    if (query.eventCategories) searchQuery = {
        ...searchQuery,
        eventCategories: query.eventCategories
    };
    if (query.levels) searchQuery = {
        ...searchQuery,
        levels: query.levels
    };
    if (query.size) searchQuery = {
        ...searchQuery,
        size: query.size
    };
    return searchQuery;
};
function $102956f839e5f725$export$b06db0f8b326b929(startTimestamp, endTimestamp) {
    const startDateIntValue = parseInt(startTimestamp) / (0, $hu2ZI.NANOSECONDS_IN_MILLISECOND);
    const endDateIntValue = parseInt(endTimestamp) / (0, $hu2ZI.NANOSECONDS_IN_MILLISECOND);
    const { timeDigits: fromValue, timeUnit: fromUnit } = $102956f839e5f725$export$ae02811946c03a4b((0, $jj52j.default)(startDateIntValue), (0, $jj52j.default)(endDateIntValue));
    const params = $102956f839e5f725$export$42dac873831f0e2(new URLSearchParams({
        fromValue: fromValue,
        fromUnit: fromUnit
    }));
    const startTimestampParams = params.get('startTimestamp');
    const endTimestampParams = params.get('endTimestamp');
    (0, $hmVmJ.assert)(!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(startTimestampParams) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(endTimestampParams), new (0, $dH6Pi.AssertionError)('calculateNewStartAndEndTimestamp', 'startTimestamp and endTimestamp should not be null'));
    return {
        startTimestamp: startTimestampParams,
        endTimestamp: endTimestampParams
    };
}
const $102956f839e5f725$export$74cb10c4b9924e49 = (importantField, raw, isImportantFieldEmpty)=>{
    if (!importantField || !raw) return true;
    const parsedImportantField = JSON.parse(importantField);
    const parsedRaw = JSON.parse(raw);
    return ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(parsedImportantField) || isImportantFieldEmpty === true) && (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(parsedRaw);
};
const $102956f839e5f725$export$130612b33e678a37 = ()=>{
    const params = $102956f839e5f725$export$42dac873831f0e2(new URLSearchParams({
        fromUnit: 'MONTH',
        fromValue: '1'
    }));
    const startDate = params.get('startTimestamp');
    const endDate = params.get('endTimestamp');
    (0, $hmVmJ.assert)(!!startDate && !!endDate, new (0, $dH6Pi.AssertionError)('generateParamsForOneMonthInterval', 'startTimestamp and endDate should not be null'));
    return {
        dateTimeValue: {
            startDate: startDate,
            endDate: endDate
        },
        timeType: (0, $2VsTe.TimeRadioOptions).WITHIN_THE_LAST
    };
};
const $102956f839e5f725$export$e083dc64e00e053b = (level)=>{
    const BASE_OFFSET = 18;
    return `${(0, $hu2ZI.DETAIL_ITEM_BASE_WIDTH) - level * BASE_OFFSET}px`;
};
const $102956f839e5f725$export$c6631e198cf7c0f4 = (search)=>{
    const splittedSearch = search.split(/source=/i);
    if (splittedSearch.length > 1) return decodeURIComponent(splittedSearch[1]);
    return '';
};
function $102956f839e5f725$export$59302306c6f78677(fragment, key) {
    const { nodeName: nodeName, nodeType: nodeType, childNodes: childNodes, textContent: textContent } = fragment;
    if (nodeType === Node.TEXT_NODE) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: textContent
    }, key);
    const children = [];
    childNodes.forEach((childNode, i)=>{
        const markup = $102956f839e5f725$export$59302306c6f78677(childNode, String(i));
        if (markup) children.push(markup);
    });
    switch(nodeName){
        case 'B':
            return /*#__PURE__*/ (0, $2OMIu.jsx)("b", {
                children: children
            }, key);
        case 'I':
            return /*#__PURE__*/ (0, $2OMIu.jsx)("i", {
                children: children
            }, key);
        case 'STRONG':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                weight: "bold",
                children: children
            }, key);
        case 'EM':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                as: "em",
                children: children
            }, key);
        case 'CODE':
            // eslint-disable-next-line @atlaskit/design-system/no-html-code
            return /*#__PURE__*/ (0, $2OMIu.jsx)("code", {
                children: children
            }, key);
    }
    if (children.length === 1) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: children[0]
    }, key);
    if (children.length) return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        children: children
    }, key);
    return null;
}
const $102956f839e5f725$export$9a858fe3837c0be0 = (urlParams, response)=>{
    if (urlParams.get('startTimestamp') && urlParams.get('endTimestamp')) return {
        ...response,
        data: {
            ...response.data,
            pagination: {
                ...response.data.pagination,
                calcStartDate: urlParams.get('startTimestamp'),
                calcEndDate: urlParams.get('endTimestamp')
            }
        }
    };
    return response;
};

});
parcelRegister("2VsTe", function(module, exports) {

$parcel$export(module.exports, "TimeRadioOptions", () => $4e8f12ca8572dc61$export$ff1338756af30600);
var $4e8f12ca8572dc61$export$ff1338756af30600 = /*#__PURE__*/ function(TimeRadioOptions) {
    TimeRadioOptions["WITHIN_THE_LAST"] = "withinTheLast";
    TimeRadioOptions["BETWEEN"] = "between";
    return TimeRadioOptions;
}({});

});

parcelRegister("0yCO3", function(module, exports) {

$parcel$export(module.exports, "RANGE_OPTIONS", () => $928210b867587e62$export$a0f3448347834e6b);
const $928210b867587e62$export$a0f3448347834e6b = [
    'HOUR',
    'DAY',
    'WEEK',
    'MONTH'
];

});

parcelRegister("hu2ZI", function(module, exports) {

$parcel$export(module.exports, "PAGE_SIZE_QUERY_PARAM", () => $96911fb41d45d626$export$4b254bc84a71033a);
$parcel$export(module.exports, "NANOSECONDS_IN_MILLISECOND", () => $96911fb41d45d626$export$753f41e31eccb6d7);
$parcel$export(module.exports, "getHeaderWidths", () => $96911fb41d45d626$export$8aa6dbdb947f7df1);
$parcel$export(module.exports, "DETAIL_ITEM_BASE_WIDTH", () => $96911fb41d45d626$export$1220f90483bde21);
const $96911fb41d45d626$export$4b254bc84a71033a = 'size';
const $96911fb41d45d626$export$753f41e31eccb6d7 = 1000000;
const $96911fb41d45d626$export$8aa6dbdb947f7df1 = (params)=>{
    const { DATE_HEADER_WIDTH: DATE_HEADER_WIDTH, CATEGORY_HEADER_WIDTH: CATEGORY_HEADER_WIDTH, TYPE_HEADER_WIDTH: TYPE_HEADER_WIDTH } = params.showEventCategoryField ? {
        // Widths for audit logs page
        DATE_HEADER_WIDTH: 16,
        CATEGORY_HEADER_WIDTH: 16,
        TYPE_HEADER_WIDTH: 10
    } : {
        // Widths for integration-specific log page
        DATE_HEADER_WIDTH: 14,
        CATEGORY_HEADER_WIDTH: 0,
        TYPE_HEADER_WIDTH: 12
    };
    const columnsToShow = [
        DATE_HEADER_WIDTH,
        CATEGORY_HEADER_WIDTH,
        TYPE_HEADER_WIDTH
    ];
    let sum = 0;
    columnsToShow.forEach((width)=>{
        sum += width;
    });
    return {
        DATE_HEADER_WIDTH: `${DATE_HEADER_WIDTH}%`,
        CATEGORY_HEADER_WIDTH: `${CATEGORY_HEADER_WIDTH}%`,
        TYPE_HEADER_WIDTH: `${TYPE_HEADER_WIDTH}%`,
        CHANGE_SUMMARY_HEADER_WIDTH: `${100 - sum}%`
    };
};
const $96911fb41d45d626$export$1220f90483bde21 = 250;

});

parcelRegister("9Pdtb", function(module, exports) {

$parcel$export(module.exports, "default", () => $8183616acbf6d3e8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $8183616acbf6d3e8$var$messages = (0, $7VHMR.defineMessages)({
    validationMessageBeforeGreaterThanAfter: {
        id: `eoc.customer-logs.common.utils.validation-message-before-greater-than-after.no-translate`,
        defaultMessage: 'Specify a valid time range.',
        description: 'Message displayed to the user when the Before date used is greater than the after date while specifying dates'
    },
    validationMessageInvalidDateFormat: {
        id: `eoc.customer-logs.common.utils.validation-message-invalid-date-format.no-translate`,
        defaultMessage: 'Invalid date format.',
        description: 'Invalid date format.'
    },
    validationMessageAtLeastOneValue: {
        id: `eoc.customer-logs.common.utils.validation-message-at-least-one-value.no-translate`,
        defaultMessage: 'Select at least one value.',
        description: 'Message displayed to the user when there is no selected before and end date together'
    }
});
var $8183616acbf6d3e8$export$2e2bcd8739ae039 = $8183616acbf6d3e8$var$messages;

});




parcelRegister("lCbSp", function(module, exports) {

$parcel$export(module.exports, "uiSettingsResource", () => $efebb20f6ad5236b$export$f2b33518cf31cd40);

var $2M1hQ = parcelRequire("2M1hQ");

var $7xYVv = parcelRequire("7xYVv");
const $efebb20f6ad5236b$export$f2b33518cf31cd40 = (0, $2M1hQ.createResource)({
    type: 'ui-settings-resource',
    getKey: ()=>'ui-settings-resource',
    getData: async ()=>(0, $7xYVv.fetchUiSettingsEndpoint)(),
    maxAge: Infinity,
    isBrowserOnly: true
});

});
parcelRegister("7xYVv", function(module, exports) {

$parcel$export(module.exports, "fetchUiSettingsEndpoint", () => $7bc4e87c807af8e2$export$ea2f12bcbdce2020);

var $j74qU = parcelRequire("j74qU");
const $7bc4e87c807af8e2$export$ea2f12bcbdce2020 = async ()=>{
    return (0, $j74qU.eocFetch)('/v1/logs');
};

});



parcelRegister("6ZSdP", function(module, exports) {

$parcel$export(module.exports, "eocTeamCustomerLogsDownloadRoute", () => $e73c1ac5cb6acb9d$export$678856ccddc0bc05);
const $e73c1ac5cb6acb9d$export$678856ccddc0bc05 = {
    name: 'eoc-team-customer-logs-download',
    path: '/jira/settings/products/ops/jira-service-management-audit-logs/download/:exportUniqueKey',
    exact: true
};

});

parcelRegister("8OJXJ", function(module, exports) {

$parcel$export(module.exports, "LazyCustomerLogs", () => $ff16a0c6b99cd2b6$export$6e30e25faf4f6dce);
$parcel$export(module.exports, "LazyCustomerLogsDownLoad", () => $ff16a0c6b99cd2b6$export$898c7cb3b28a6104);
$parcel$export(module.exports, "default", () => $ff16a0c6b99cd2b6$export$2e2bcd8739ae039);
$parcel$export(module.exports, "CustomerLogsDownloadPage", () => $ff16a0c6b99cd2b6$export$a5786cf859b7b457);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $ff16a0c6b99cd2b6$export$6e30e25faf4f6dce = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("fFuGa")), {
    moduleId: "./src/packages/eoc/customer-logs/src/index.tsx"
});

const $ff16a0c6b99cd2b6$export$898c7cb3b28a6104 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("fFuGa")).then(({ CustomerLogsDownloadPage: CustomerLogsDownloadPage })=>CustomerLogsDownloadPage), {
    moduleId: "./src/packages/eoc/customer-logs/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ff16a0c6b99cd2b6$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ff16a0c6b99cd2b6$export$6e30e25faf4f6dce,
        pageId: "async-jira-eoc-customer-logs",
        shouldShowSpinner: false
    });
const $ff16a0c6b99cd2b6$export$a5786cf859b7b457 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ff16a0c6b99cd2b6$export$898c7cb3b28a6104,
        pageId: "async-jira-eoc-customer-logs-download",
        shouldShowSpinner: false
    });

});
parcelRegister("fFuGa", function(module, exports) {

let $b6827b92a9d2471b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b6827b92a9d2471b$var$load("8kKGn").then(()=>parcelRequire('ecO2s'));

});



parcelRegister("fOrUU", function(module, exports) {

$parcel$export(module.exports, "eocTeamCustomerLogsRouteEntry", () => $82450f458637cd82$export$42ca979ec2919b23);

var $c4Buu = parcelRequire("c4Buu");

var $ffza4 = parcelRequire("ffza4");

var $eZXFU = parcelRequire("eZXFU");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $3HwlS = parcelRequire("3HwlS");

var $dlUF2 = parcelRequire("dlUF2");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $8OJXJ = parcelRequire("8OJXJ");
const $82450f458637cd82$var$getNavigationSpecifications = ()=>{
    return (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $82450f458637cd82$export$42ca979ec2919b23 = (0, $7NszV.createEntry)((0, $dlUF2.eocTeamCustomerLogsRoute), ()=>({
        group: 'eoc',
        component: (0, $8OJXJ.default),
        layout: (0, $eZXFU.opsSettingsLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$82450f458637cd82$var$getNavigationSpecifications()
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $c4Buu.resources)()
        ],
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8OJXJ.LazyCustomerLogs)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8OJXJ.LazyCustomerLogs)
        ]
    }));

});
parcelRegister("dlUF2", function(module, exports) {

$parcel$export(module.exports, "eocTeamCustomerLogsRoute", () => $3689be50764be7f7$export$4b517044f5f7830d);
const $3689be50764be7f7$export$4b517044f5f7830d = {
    name: 'eoc-team-customer-logs',
    path: '/jira/settings/products/ops/jira-service-management-audit-logs',
    exact: true
};

});


parcelRegister("dYoht", function(module, exports) {

$parcel$export(module.exports, "eocTeamGroupDetailRouteEntry", () => $7742cad3c3e8631c$export$2b25520e20820251);

var $8C32n = parcelRequire("8C32n");

var $eYyoJ = parcelRequire("eYyoJ");

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $81IxY = parcelRequire("81IxY");

var $lgLgL = parcelRequire("lgLgL");
const $7742cad3c3e8631c$export$2b25520e20820251 = (0, $7NszV.createEntry)((0, $81IxY.eocTeamGroupDetailRoute), ()=>({
        group: 'eoc',
        component: (0, $lgLgL.default),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $2r8fH.resources)(),
            ...(0, $eYyoJ.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $8C32n.resources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $lgLgL.LazyGroupDetail),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("81IxY", function(module, exports) {

$parcel$export(module.exports, "eocTeamGroupDetailRoute", () => $c70e4aa8d21accf9$export$aa8cf61e94739f21);
const $c70e4aa8d21accf9$export$aa8cf61e94739f21 = {
    name: 'eoc-team-group-detail',
    path: '/jira/ops/teams/:teamId/group-detail/:id',
    exact: true
};

});


parcelRegister("9bLSq", function(module, exports) {

$parcel$export(module.exports, "eocUserNotificationsRouteEntry", () => $7f3a610ac409efab$export$15b42089d01e5917);

var $8ytTF = parcelRequire("8ytTF");

var $gk6PH = parcelRequire("gk6PH");

var $1Xcuw = parcelRequire("1Xcuw");

var $ffza4 = parcelRequire("ffza4");

var $eZXFU = parcelRequire("eZXFU");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $4o9PX = parcelRequire("4o9PX");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

var $bHVtu = parcelRequire("bHVtu");
const $7f3a610ac409efab$var$getNavigationSpecifications = ()=>{
    return (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $7f3a610ac409efab$export$15b42089d01e5917 = (0, $7NszV.createEntry)((0, $4o9PX.eocUserNotificationsRoute), ()=>({
        group: 'eoc',
        component: (0, $bHVtu.default),
        layout: (0, $eZXFU.opsSettingsLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$7f3a610ac409efab$var$getNavigationSpecifications()
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $8ytTF.createContactsResource)(),
            (0, $1Xcuw.createNotificationPreferencesResource)(),
            (0, $gk6PH.createMuteResource)(),
            (0, $gk6PH.createQuietHoursResource)(),
            (0, $1Xcuw.createForwardingRulesResource)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bHVtu.LazyUserNotifications)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bHVtu.LazyUserNotifications)
        ]
    }));

});
parcelRegister("8ytTF", function(module, exports) {

$parcel$export(module.exports, "createContactsResource", () => $3c33a8a96991f1a3$export$b9ca444b0be3df97);
$parcel$export(module.exports, "contactsResource", () => $3c33a8a96991f1a3$export$54a06d876c95357d);

var $2M1hQ = parcelRequire("2M1hQ");

var $VSDnB = parcelRequire("VSDnB");

var $4UHgN = parcelRequire("4UHgN");
const $3c33a8a96991f1a3$export$b9ca444b0be3df97 = (checkConsolidationOnRouteDependency, depends)=>(0, $2M1hQ.createResource)({
        type: 'contactsResource',
        getKey: ()=>'contactsResource',
        getData: async ({ dependencies: dependencies, match: match })=>{
            const targetAccountId = (0, $VSDnB.fg)('jsm_admin_access_user_notification_settings') ? match.params?.targetAccountId : undefined;
            const isConsolidated = checkConsolidationOnRouteDependency ? // This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
            checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            const data = await (0, $4UHgN.getContacts)(targetAccountId);
            return data.contacts;
        },
        isBrowserOnly: true,
        depends: depends
    });
const $3c33a8a96991f1a3$export$54a06d876c95357d = $3c33a8a96991f1a3$export$b9ca444b0be3df97();

});
parcelRegister("4UHgN", function(module, exports) {

$parcel$export(module.exports, "getContacts", () => $dee84df670092829$export$70ff9d70e43e8f10);
$parcel$export(module.exports, "addContactEndpoint", () => $dee84df670092829$export$bd596455bda1cd66);
$parcel$export(module.exports, "orderContactEndpoint", () => $dee84df670092829$export$77f16e7683ad08d6);
$parcel$export(module.exports, "updateContactStatusEndpoint", () => $dee84df670092829$export$d50cab05338f8080);
$parcel$export(module.exports, "deleteContactEndpoint", () => $dee84df670092829$export$59eb3ff38e4cd944);
$parcel$export(module.exports, "editContactEndpoint", () => $dee84df670092829$export$3f8035f77e3aeb9d);
$parcel$export(module.exports, "sendVerificationCodeEndpoint", () => $dee84df670092829$export$74e1bdc56dc32826);
$parcel$export(module.exports, "checkVerificationCodeEndpoint", () => $dee84df670092829$export$fbe80b8d857094de);

var $j74qU = parcelRequire("j74qU");

var $1qSGt = parcelRequire("1qSGt");
const $dee84df670092829$export$70ff9d70e43e8f10 = (targetAccountId)=>(0, $j74qU.eocFetch)(`/v1/users/contact${(0, $1qSGt.getTargetAccountIdSuffix)(targetAccountId)}`);
const $dee84df670092829$export$bd596455bda1cd66 = (newAddress, method, targetAccountId)=>{
    return (0, $j74qU.eocFetch)(`/v1/users/contact${(0, $1qSGt.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'POST',
        body: {
            address: newAddress,
            method: method.toLowerCase()
        }
    });
};
const $dee84df670092829$export$77f16e7683ad08d6 = (contactId, after, targetAccountId)=>{
    return (0, $j74qU.eocFetch)(`/v1/users/contact/order${(0, $1qSGt.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'PATCH',
        body: {
            contactId: contactId,
            after: after
        }
    });
};
const $dee84df670092829$export$d50cab05338f8080 = (status)=>{
    return status ? $dee84df670092829$var$enableContactEndpoint : $dee84df670092829$var$disableContactEndpoint;
};
const $dee84df670092829$var$enableContactEndpoint = (contactId, targetAccountId)=>{
    return (0, $j74qU.eocFetch)(`/v1/users/contact/state/enabled${(0, $1qSGt.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'PATCH',
        body: {
            contactId: contactId
        }
    });
};
const $dee84df670092829$var$disableContactEndpoint = (contactId, targetAccountId)=>{
    return (0, $j74qU.eocFetch)(`/v1/users/contact/state/disabled${(0, $1qSGt.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'PATCH',
        body: {
            contactId: contactId
        }
    });
};
const $dee84df670092829$export$59eb3ff38e4cd944 = (contactId, targetAccountId)=>{
    return (0, $j74qU.eocFetch)(`/v1/users/contact${(0, $1qSGt.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'DELETE',
        body: {
            contactId: contactId
        },
        responseType: 'headers'
    });
};
const $dee84df670092829$export$3f8035f77e3aeb9d = (contactId, newAddress, targetAccountId)=>{
    return (0, $j74qU.eocFetch)(`/v1/users/contact${(0, $1qSGt.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'PATCH',
        body: {
            contactId: contactId,
            address: newAddress
        }
    });
};
const $dee84df670092829$export$74e1bdc56dc32826 = (phoneNumber, method, targetAccountId)=>{
    return (0, $j74qU.eocFetch)(`/v1/users/contact/verification${(0, $1qSGt.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'POST',
        body: {
            phoneNumber: phoneNumber,
            method: method.toLowerCase()
        }
    });
};
const $dee84df670092829$export$fbe80b8d857094de = (phoneNumber, code, targetAccountId)=>{
    return (0, $j74qU.eocFetch)(`/v1/users/contact/verification/check${(0, $1qSGt.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'POST',
        body: {
            phoneNumber: phoneNumber,
            code: code
        },
        responseType: 'headers'
    });
};

});
parcelRegister("1qSGt", function(module, exports) {

$parcel$export(module.exports, "calculateRemainingMinutesAndSeconds", () => $69e2e00ba5affada$export$d3f650aeadf07bf8);
$parcel$export(module.exports, "getTargetAccountIdSuffix", () => $69e2e00ba5affada$export$f538d5c43127966b);

var $VSDnB = parcelRequire("VSDnB");
const $69e2e00ba5affada$export$d3f650aeadf07bf8 = (countDown)=>{
    const minutes = Math.floor(countDown % 3600000 / 60000);
    const seconds = Math.floor(countDown % 60000 / 1000);
    return [
        minutes < 0 ? 0 : minutes,
        seconds < 0 ? 0 : seconds
    ];
};
const $69e2e00ba5affada$export$f538d5c43127966b = (targetAccountId)=>{
    if ((0, $VSDnB.fg)('jsm_admin_access_user_notification_settings')) return targetAccountId ? `?targetAccountId=${targetAccountId}` : '';
    return '';
};

});



parcelRegister("gk6PH", function(module, exports) {

$parcel$export(module.exports, "createMuteResource", () => $63d22459d7da235f$export$c849cfac68bc6e80);
$parcel$export(module.exports, "createQuietHoursResource", () => $63d22459d7da235f$export$efc5e8690061f9cc);
$parcel$export(module.exports, "muteResource", () => $63d22459d7da235f$export$3c4c16a7c2620c29);
$parcel$export(module.exports, "quietHoursResource", () => $63d22459d7da235f$export$9b33012bd34cc225);

var $2M1hQ = parcelRequire("2M1hQ");

var $cSvuU = parcelRequire("cSvuU");
const $63d22459d7da235f$export$c849cfac68bc6e80 = (checkConsolidationOnRouteDependency, depends)=>(0, $2M1hQ.createResource)({
        type: 'muteResource',
        getKey: ()=>'muteResource',
        getData: ({ dependencies: dependencies, match: match })=>{
            const targetAccountId = match.params?.targetAccountId;
            const isConsolidated = checkConsolidationOnRouteDependency ? // This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
            checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $cSvuU.getMuteDetail)(targetAccountId);
        },
        isBrowserOnly: true,
        depends: depends
    });
const $63d22459d7da235f$export$efc5e8690061f9cc = (checkConsolidationOnRouteDependency, depends)=>(0, $2M1hQ.createResource)({
        type: 'quietHoursResource',
        getKey: ()=>'quietHoursResource',
        getData: ({ dependencies: dependencies, match: match })=>{
            const targetAccountId = match.params?.targetAccountId;
            const isConsolidated = checkConsolidationOnRouteDependency ? // This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
            checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $cSvuU.getQuietHoursDetail)(targetAccountId);
        },
        isBrowserOnly: true,
        depends: depends
    });
const $63d22459d7da235f$export$3c4c16a7c2620c29 = $63d22459d7da235f$export$c849cfac68bc6e80();
const $63d22459d7da235f$export$9b33012bd34cc225 = $63d22459d7da235f$export$efc5e8690061f9cc();

});
parcelRegister("cSvuU", function(module, exports) {

$parcel$export(module.exports, "getMuteDetail", () => $6e548a208bc1f9bf$export$80a4e62998a806a6);
$parcel$export(module.exports, "getQuietHoursDetail", () => $6e548a208bc1f9bf$export$44a94c74f358d02f);

var $j74qU = parcelRequire("j74qU");

var $j9fdm = parcelRequire("j9fdm");
const $6e548a208bc1f9bf$export$80a4e62998a806a6 = (targetAccountId)=>(0, $j74qU.eocFetch)(`/v1/users/notifications/mute${(0, $j9fdm.getTargetAccountIdSuffix)(targetAccountId)}`);
const $6e548a208bc1f9bf$export$44a94c74f358d02f = (targetAccountId)=>(0, $j74qU.eocFetch)(`/v1/users/quiet-hours/details${(0, $j9fdm.getTargetAccountIdSuffix)(targetAccountId)}`);

});
parcelRegister("j9fdm", function(module, exports) {

$parcel$export(module.exports, "getTargetAccountIdSuffix", () => $a80d378b5e253b9e$export$f538d5c43127966b);

var $VSDnB = parcelRequire("VSDnB");
const $a80d378b5e253b9e$export$f538d5c43127966b = (targetAccountId)=>{
    if ((0, $VSDnB.fg)('jsm_admin_access_user_notification_settings')) return targetAccountId ? `?targetAccountId=${targetAccountId}` : '';
    return '';
};

});



parcelRegister("1Xcuw", function(module, exports) {

$parcel$export(module.exports, "createNotificationPreferencesResource", () => $adb36d8860d29889$export$731980bd233a4797);
$parcel$export(module.exports, "createForwardingRulesResource", () => $adb36d8860d29889$export$5314dca65b4e5888);

var $2M1hQ = parcelRequire("2M1hQ");
parcelRequire("jxRF2");
var $ldKOT = parcelRequire("ldKOT");

var $4wOw1 = parcelRequire("4wOw1");
const $adb36d8860d29889$export$731980bd233a4797 = (checkConsolidationOnRouteDependency, depends)=>(0, $2M1hQ.createResource)({
        type: 'notificationPreferencesResource',
        getKey: ()=>'notificationPreferencesResource',
        getData: ({ dependencies: dependencies, match: match })=>{
            const targetAccountId = match.params?.targetAccountId;
            const isConsolidated = checkConsolidationOnRouteDependency ? // This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
            checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $4wOw1.getNotificationPreferences)(targetAccountId);
        },
        isBrowserOnly: true,
        depends: depends
    });
const $adb36d8860d29889$export$5314dca65b4e5888 = (checkConsolidationOnRouteDependency, depends)=>(0, $2M1hQ.createResource)({
        type: 'forwardingRulesResource',
        getKey: ()=>'forwardingRulesResource',
        getData: ({ dependencies: dependencies, match: match })=>{
            const targetAccountId = match.params?.targetAccountId;
            const isConsolidated = checkConsolidationOnRouteDependency ? // This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
            checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $4wOw1.getForwardingRules)(targetAccountId).then(({ values: values })=>values);
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("4wOw1", function(module, exports) {

$parcel$export(module.exports, "getNotificationPreferences", () => $05fff912cf0441ba$export$60e139c3026f21bc);
$parcel$export(module.exports, "getForwardingRules", () => $05fff912cf0441ba$export$2161af98e3d645a5);

var $j74qU = parcelRequire("j74qU");

var $1iPXg = parcelRequire("1iPXg");
const $05fff912cf0441ba$export$60e139c3026f21bc = (targetAccountId)=>(0, $j74qU.eocFetch)(`/v1/users/notification-preferences${(0, $1iPXg.getTargetAccountIdSuffix)(targetAccountId)}`);
const $05fff912cf0441ba$export$2161af98e3d645a5 = (targetAccountId)=>(0, $j74qU.eocFetch)(`/v1/alerts/notifications/forwarding-rules${(0, $1iPXg.getTargetAccountIdSuffix)(targetAccountId)}`);

});
parcelRegister("1iPXg", function(module, exports) {

$parcel$export(module.exports, "getOperationName", () => $b24aa276f68665dd$export$41bca9dc6871dd4e);
$parcel$export(module.exports, "getMatchType", () => $b24aa276f68665dd$export$a8ea0fb63186ef7e);
$parcel$export(module.exports, "formatRestriction", () => $b24aa276f68665dd$export$99bcc87a197977ea);
$parcel$export(module.exports, "getAvailableRuleTypeOptions", () => $b24aa276f68665dd$export$c5259662f509f23f);
$parcel$export(module.exports, "getDefaultTimeOptions", () => $b24aa276f68665dd$export$318d0e67e244d7ff);
$parcel$export(module.exports, "getTargetAccountIdSuffix", () => $b24aa276f68665dd$export$f538d5c43127966b);

var $gwejS = parcelRequire("gwejS");

var $k7m40 = parcelRequire("k7m40");

var $f2F4g = parcelRequire("f2F4g");

var $1GF3c = parcelRequire("1GF3c");

var $VSDnB = parcelRequire("VSDnB");

var $9U82y = parcelRequire("9U82y");

var $7K1zJ = parcelRequire("7K1zJ");

var $1zwqa = parcelRequire("1zwqa");
const $b24aa276f68665dd$export$41bca9dc6871dd4e = (id)=>{
    const operation = (0, $9U82y.OPERATIONS).find((operation)=>operation.id === id);
    return operation?.name;
};
const $b24aa276f68665dd$export$a8ea0fb63186ef7e = (conditionMatchType)=>{
    switch(conditionMatchType){
        case 1:
            return 'match-any-condition';
        case 2:
            return 'match-all-conditions';
        default:
            return 'match-all';
    }
};
const $b24aa276f68665dd$export$5f84d4e06c0693c4 = ()=>{
    const firstDOW = (0, $1GF3c.default)(new Date(), {
        weekStartsOn: 0
    });
    const weekDays = Array.from(Array(7)).map((e, i)=>({
            label: (0, $k7m40.default)((0, $gwejS.default)(firstDOW, i), 'EEEE'),
            value: i % 7 + 1
        }));
    return weekDays;
};
const $b24aa276f68665dd$export$99bcc87a197977ea = (timeInterval)=>{
    const days = $b24aa276f68665dd$export$5f84d4e06c0693c4();
    const startDay = days.find((day)=>day.value === timeInterval.startDay);
    const endDay = days.find((day)=>day.value === timeInterval.endDay);
    const startTime = (0, $k7m40.default)((0, $f2F4g.default)(new Date(), {
        hours: timeInterval.startHour,
        minutes: timeInterval.startMinute
    }), 'p');
    const endTime = (0, $k7m40.default)((0, $f2F4g.default)(new Date(), {
        hours: timeInterval.endHour,
        minutes: timeInterval.endMinute
    }), 'p');
    if (startDay && endDay) {
        const formattedTime = `${startDay.label} ${startTime} - ${endDay.label} ${endTime}`;
        return formattedTime;
    }
    const formattedTime = `${startTime} - ${endTime}`;
    return formattedTime;
};
const $b24aa276f68665dd$export$c5259662f509f23f = (formatMessage)=>{
    return Object.keys((0, $7K1zJ.AVAILABLE_RULE_TYPES)).filter((v)=>isNaN(Number(v))).map((key)=>({
            label: formatMessage((0, $1zwqa.default)[key]),
            value: key
        }));
};
const $b24aa276f68665dd$export$318d0e67e244d7ff = ()=>{
    return [
        ...Array(24).keys()
    ].map((time)=>{
        let newTime = time.toString();
        if (newTime.length === 1) newTime = `0${time}`;
        return [
            `${newTime}:00`,
            `${newTime}:30`
        ];
    }).flatMap((time)=>time);
};
const $b24aa276f68665dd$export$f538d5c43127966b = (targetAccountId)=>{
    if ((0, $VSDnB.fg)('jsm_admin_access_user_notification_settings')) return targetAccountId ? `?targetAccountId=${targetAccountId}` : '';
    return '';
};

});
parcelRegister("9U82y", function(module, exports) {

$parcel$export(module.exports, "DATE_FORMAT", () => $5c6a6e22fa30e50d$export$45c85543ba71221d);
$parcel$export(module.exports, "TIME_FORMAT", () => $5c6a6e22fa30e50d$export$c4e1e4e065ff5bd8);
$parcel$export(module.exports, "DATETIME_FORMAT", () => $5c6a6e22fa30e50d$export$ae1dc8cbcf481d8e);
$parcel$export(module.exports, "OPERATIONS", () => $5c6a6e22fa30e50d$export$98ff4de2f070152d);
$parcel$export(module.exports, "SPOTLIGHT_NAMES", () => $5c6a6e22fa30e50d$export$a7c923252528b255);
$parcel$export(module.exports, "defaultTimes", () => $5c6a6e22fa30e50d$export$b42ffb9f09b1861b);
$parcel$export(module.exports, "supportArticles", () => $5c6a6e22fa30e50d$export$f4b848c2437238f9);

var $7K1zJ = parcelRequire("7K1zJ");
const $5c6a6e22fa30e50d$export$45c85543ba71221d = 'dd/MM/yyyy';
const $5c6a6e22fa30e50d$export$c4e1e4e065ff5bd8 = 'h:mm aaa';
const $5c6a6e22fa30e50d$export$ae1dc8cbcf481d8e = `${$5c6a6e22fa30e50d$export$45c85543ba71221d}; ${$5c6a6e22fa30e50d$export$c4e1e4e065ff5bd8}`;
const $5c6a6e22fa30e50d$export$98ff4de2f070152d = [
    {
        order: 0,
        id: (0, $7K1zJ.OperationIds).Matches,
        name: (0, $7K1zJ.Operation).Matches
    },
    {
        order: 1,
        id: (0, $7K1zJ.OperationIds).Equals,
        name: (0, $7K1zJ.Operation).Equals
    },
    {
        order: 2,
        id: (0, $7K1zJ.OperationIds).Contains,
        name: (0, $7K1zJ.Operation).Contains
    },
    {
        order: 3,
        id: (0, $7K1zJ.OperationIds).StartsWith,
        name: (0, $7K1zJ.Operation).StartsWith
    },
    {
        order: 4,
        id: (0, $7K1zJ.OperationIds).EndsWith,
        name: (0, $7K1zJ.Operation).EndsWith
    },
    {
        order: 5,
        id: (0, $7K1zJ.OperationIds).ContainsKey,
        name: (0, $7K1zJ.Operation).ContainsKey
    },
    {
        order: 6,
        id: (0, $7K1zJ.OperationIds).ContainsValue,
        name: (0, $7K1zJ.Operation).ContainsValue
    },
    {
        order: 7,
        id: (0, $7K1zJ.OperationIds).GreaterThan,
        name: (0, $7K1zJ.Operation).GreaterThan
    },
    {
        order: 8,
        id: (0, $7K1zJ.OperationIds).LessThan,
        name: (0, $7K1zJ.Operation).LessThan
    },
    {
        order: 9,
        id: (0, $7K1zJ.OperationIds).IsEmpty,
        name: (0, $7K1zJ.Operation).IsEmpty
    },
    {
        order: 10,
        id: (0, $7K1zJ.OperationIds).EqualsIgnoreWhitespace,
        name: (0, $7K1zJ.Operation).EqualsIgnoreWhitespace
    }
];
const $5c6a6e22fa30e50d$export$a7c923252528b255 = {
    dndTitle: 'eoc-notifications_dnd_title',
    rulesTitle: 'eoc-notifications_rules_title',
    forwardingRulesTitle: 'eoc-notifications_forwarding_rules_title'
};
const $5c6a6e22fa30e50d$export$b42ffb9f09b1861b = [
    ...Array(24).keys()
].map((time)=>{
    let newTime = time.toString();
    if (newTime.length === 1) newTime = `0${time}`;
    return [
        `${newTime}:00`,
        `${newTime}:30`
    ];
}).flatMap((time)=>time);
const $5c6a6e22fa30e50d$export$f4b848c2437238f9 = {
    setUpRoleBasedNotifications: {
        jsm: 'https://support.atlassian.com/jira-service-management-cloud/docs/set-up-role-based-notifications/',
        compass: 'https://compass-ops-help.atlassian.net/wiki/spaces/OPERATIONS/pages/112066569/Set+up+role-based+notifications/'
    },
    setUpSmsAndVoice: {
        jsm: 'https://support.atlassian.com/jira-service-management-cloud/docs/set-up-sms-and-voice-notifications/#Contact-information',
        compass: 'https://compass-ops-help.atlassian.net/wiki/spaces/OPERATIONS/pages/11404235/Set+up+SMS+and+voice+notifications#Contact-information'
    },
    setUpNotificationPreferences: {
        jsm: 'https://support.atlassian.com/jira-service-management-cloud/docs/set-up-notification-preferences',
        compass: 'https://compass-ops-help.atlassian.net/wiki/spaces/OPERATIONS/pages/11469955/Set+up+notification+preferences'
    },
    notificationForwardingRules: {
        jsm: 'https://support.atlassian.com/jira-service-management-cloud/docs/add-notification-forwarding-rules',
        compass: 'https://compass-ops-help.atlassian.net/wiki/spaces/OPERATIONS/pages/11404196/Add+notification+forwarding+rules'
    }
};

});
parcelRegister("7K1zJ", function(module, exports) {

$parcel$export(module.exports, "AVAILABLE_RULE_TYPES", () => $22fbd560e3500848$export$a4958d8d5a6aee21);
$parcel$export(module.exports, "OperationIds", () => $22fbd560e3500848$export$9e369e35ea3634d7);
$parcel$export(module.exports, "ReverseOperations", () => $22fbd560e3500848$export$e722854e5571abe4);
$parcel$export(module.exports, "MatchConditionType", () => $22fbd560e3500848$export$dab128282aa7aeee);
$parcel$export(module.exports, "Operation", () => $22fbd560e3500848$export$ab5aad00225c5662);
var $22fbd560e3500848$export$a4958d8d5a6aee21 = /*#__PURE__*/ function(AVAILABLE_RULE_TYPES) {
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["New Alert"] = 0] = "New Alert";
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["Schedule Start"] = 3] = "Schedule Start";
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["Schedule End"] = 7] = "Schedule End";
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["Incoming Call Routing"] = 8] = "Incoming Call Routing";
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["Acknowledged Alert"] = 1] = "Acknowledged Alert";
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["Closed Alert"] = 2] = "Closed Alert";
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["Assigned Alert"] = 5] = "Assigned Alert";
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["Add Note"] = 6] = "Add Note";
    return AVAILABLE_RULE_TYPES;
}({});
var $22fbd560e3500848$export$9e369e35ea3634d7 = /*#__PURE__*/ function(OperationIds) {
    OperationIds[OperationIds["Matches"] = 0] = "Matches";
    OperationIds[OperationIds["Contains"] = 1] = "Contains";
    OperationIds[OperationIds["StartsWith"] = 3] = "StartsWith";
    OperationIds[OperationIds["EndsWith"] = 4] = "EndsWith";
    OperationIds[OperationIds["Equals"] = 5] = "Equals";
    OperationIds[OperationIds["ContainsKey"] = 6] = "ContainsKey";
    OperationIds[OperationIds["ContainsValue"] = 7] = "ContainsValue";
    OperationIds[OperationIds["GreaterThan"] = 8] = "GreaterThan";
    OperationIds[OperationIds["LessThan"] = 9] = "LessThan";
    OperationIds[OperationIds["IsEmpty"] = 10] = "IsEmpty";
    OperationIds[OperationIds["EqualsIgnoreWhitespace"] = 11] = "EqualsIgnoreWhitespace";
    return OperationIds;
}({});
var $22fbd560e3500848$export$e722854e5571abe4 = /*#__PURE__*/ function(ReverseOperations) {
    ReverseOperations[ReverseOperations["matches"] = 0] = "matches";
    ReverseOperations[ReverseOperations["contains"] = 1] = "contains";
    ReverseOperations[ReverseOperations["starts-with"] = 3] = "starts-with";
    ReverseOperations[ReverseOperations["ends-with"] = 4] = "ends-with";
    ReverseOperations[ReverseOperations["equals"] = 5] = "equals";
    ReverseOperations[ReverseOperations["contains-key"] = 6] = "contains-key";
    ReverseOperations[ReverseOperations["contains-value"] = 7] = "contains-value";
    ReverseOperations[ReverseOperations["greater-than"] = 8] = "greater-than";
    ReverseOperations[ReverseOperations["less-than"] = 9] = "less-than";
    ReverseOperations[ReverseOperations["is-empty"] = 10] = "is-empty";
    ReverseOperations[ReverseOperations["equals-ignore-whitespace"] = 11] = "equals-ignore-whitespace";
    return ReverseOperations;
}({});
var $22fbd560e3500848$export$dab128282aa7aeee = /*#__PURE__*/ function(MatchConditionType) {
    MatchConditionType[MatchConditionType["match-all"] = 0] = "match-all";
    MatchConditionType[MatchConditionType["match-any-condition"] = 1] = "match-any-condition";
    MatchConditionType[MatchConditionType["match-all-conditions"] = 2] = "match-all-conditions";
    return MatchConditionType;
}({});
var $22fbd560e3500848$export$ab5aad00225c5662 = /*#__PURE__*/ function(Operation) {
    Operation["Matches"] = "matches";
    Operation["Contains"] = "contains";
    Operation["StartsWith"] = "starts-with";
    Operation["EndsWith"] = "ends-with";
    Operation["Equals"] = "equals";
    Operation["ContainsKey"] = "contains-key";
    Operation["ContainsValue"] = "contains-value";
    Operation["GreaterThan"] = "greater-than";
    Operation["LessThan"] = "less-than";
    Operation["IsEmpty"] = "is-empty";
    Operation["EqualsIgnoreWhitespace"] = "equals-ignore-whitespace";
    return Operation;
}({});

});


parcelRegister("1zwqa", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6fe15d7c66ba072$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $b6fe15d7c66ba072$var$messages = (0, $7VHMR.defineMessages)({
    addIcon: {
        id: 'eoc.notifications.rules.add-icon.no-translate',
        defaultMessage: 'Add rule',
        description: 'Button label to indicate it is used for adding a new notification rule.'
    },
    'New Alert': {
        id: 'eoc.notifications.ui.notifications.new-alert.no-translate',
        defaultMessage: 'New alert',
        description: 'The title of new alert notifications'
    },
    'Schedule Start': {
        id: 'eoc.notifications.ui.notifications.schedule-start.no-translate',
        defaultMessage: 'Schedule start',
        description: 'The title of schedule start notifications'
    },
    'Schedule End': {
        id: 'eoc.notifications.ui.notifications.schedule-end.no-translate',
        defaultMessage: 'Schedule end',
        description: 'The title of schedule end notifications'
    },
    'Acknowledged Alert': {
        id: 'eoc.notifications.ui.notifications.acknowledged-alert.no-translate',
        defaultMessage: 'Acknowledged alert',
        description: 'The title of acknowledged alert notifications'
    },
    'Closed Alert': {
        id: 'eoc.notifications.ui.notifications.closed-alert.no-translate',
        defaultMessage: 'Closed alert',
        description: 'The title of closed alert notifications'
    },
    'Assigned Alert': {
        id: 'eoc.notifications.ui.notifications.assigned-alert.no-translate',
        defaultMessage: 'Assigned alert',
        description: 'The title of assigned alert notifications'
    },
    'Add Note': {
        id: 'eoc.notifications.ui.notifications.add-note.no-translate',
        defaultMessage: 'Add note',
        description: 'The title of add note notifications'
    },
    'Incoming Call Routing': {
        id: 'eoc.notifications.ui.notifications.incoming-call-routing.no-translate',
        defaultMessage: 'Incoming Call Routing',
        description: 'The title of incoming call rounting notifications'
    },
    addButtonTooltip: {
        id: 'eoc.notifications.common.ui.notification-section.add-button-tooltip.non-final',
        defaultMessage: "A role-based notification is in effect, so adding more rules isn\u2019t possible.",
        description: 'The message to be shown when user tries to add a rule but there is a role-based notification'
    }
});
var $b6fe15d7c66ba072$export$2e2bcd8739ae039 = $b6fe15d7c66ba072$var$messages;

});




parcelRegister("4o9PX", function(module, exports) {

$parcel$export(module.exports, "eocUserNotificationsRoute", () => $65aa2d34a770a788$export$f7a15352c90f8063);
const $65aa2d34a770a788$export$f7a15352c90f8063 = {
    name: 'eoc-user-notifications',
    path: '/jira/settings/products/ops/role-assignment/notifications/:targetAccountId',
    exact: true
};

});

parcelRegister("bHVtu", function(module, exports) {

$parcel$export(module.exports, "LazyUserNotifications", () => $9464b60ca4af723d$export$a510b3cfe09fad0d);
$parcel$export(module.exports, "default", () => $9464b60ca4af723d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $9464b60ca4af723d$export$a510b3cfe09fad0d = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("fnLBM")), {
    ssr: false,
    moduleId: "./src/packages/eoc/user-notifications/src/index.tsx"
});
const $9464b60ca4af723d$var$LazyUserNotificationsPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $9464b60ca4af723d$export$a510b3cfe09fad0d,
        pageId: "async-eoc-user-notifications",
        shouldShowSpinner: false
    });
var $9464b60ca4af723d$export$2e2bcd8739ae039 = $9464b60ca4af723d$var$LazyUserNotificationsPage;

});
parcelRegister("fnLBM", function(module, exports) {

let $b32def00c740af9b$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $b32def00c740af9b$var$load("ffQaD"),
    $b32def00c740af9b$var$load("kvRbA"),
    $b32def00c740af9b$var$load("76n7a"),
    $b32def00c740af9b$var$load("l253H"),
    $b32def00c740af9b$var$load("3HmhJ")
]).then(()=>parcelRequire('gqBoQ'));

});



parcelRegister("01Za6", function(module, exports) {

$parcel$export(module.exports, "errorsNotFoundRouteEntry", () => $083d2dc437d8c2ec$export$c4c012a49b465e94);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $5lsNZ = parcelRequire("5lsNZ");

var $7gROc = parcelRequire("7gROc");
const $083d2dc437d8c2ec$export$c4c012a49b465e94 = (0, $7NszV.createEntry)((0, $7gROc.errorsNotFoundRoute), ()=>({
        group: 'errors',
        component: (0, $5lsNZ.default),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5lsNZ.LazyNotFoundErrorPage)
        ]
    }));

});
parcelRegister("7gROc", function(module, exports) {

$parcel$export(module.exports, "errorsNotFoundRoute", () => $24256311e2794309$export$465fa01c0f3a0551);
const $24256311e2794309$export$465fa01c0f3a0551 = {
    name: 'errors-not-found',
    path: '/jira/:projectType(software|servicedesk|core)'
};

});


parcelRegister("fMVEG", function(module, exports) {

$parcel$export(module.exports, "externalImportRouteEntry", () => $88a6b2c74571ee4b$export$d55ce647d8216437);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $4j39S = parcelRequire("4j39S");

var $5pSYQ = parcelRequire("5pSYQ");

var $5ZnBW = parcelRequire("5ZnBW");
const $88a6b2c74571ee4b$export$d55ce647d8216437 = (0, $7NszV.createEntry)((0, $4j39S.externalImportRoute), ()=>({
        group: 'global-settings',
        component: (0, $5ZnBW.default),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("4j39S", function(module, exports) {

$parcel$export(module.exports, "externalImportRoute", () => $105ac7e3a2002ccc$export$17c79100fc4c65a1);
const $105ac7e3a2002ccc$export$17c79100fc4c65a1 = {
    name: 'external-import',
    path: '/jira/settings/system/external-import'
};

});

parcelRegister("5ZnBW", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b72a6c6c5d8947e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7b72a6c6c5d8947e$var$LazyExternalImport = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("1UROs")), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/admin-pages/external-import/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7b72a6c6c5d8947e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $7b72a6c6c5d8947e$var$LazyExternalImport,
        pageId: "external-import-general",
        shouldShowSpinner: false
    });

});
parcelRegister("1UROs", function(module, exports) {

let $1654c37d289b9485$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $1654c37d289b9485$var$load("kVX56"),
    $1654c37d289b9485$var$load("76n7a"),
    $1654c37d289b9485$var$load("l253H"),
    $1654c37d289b9485$var$load("3yAl4"),
    $1654c37d289b9485$var$load("ffQaD"),
    $1654c37d289b9485$var$load("kvRbA"),
    $1654c37d289b9485$var$load("8iRhF")
]).then(()=>parcelRequire('lBo8Z'));

});



parcelRegister("8fgeg", function(module, exports) {

$parcel$export(module.exports, "filtersDirectoryRedirectRouteEntry", () => $03e59a293d347a10$export$41fb3f2a3e68c7c3);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $dRl24 = parcelRequire("dRl24");

var $3RJkv = parcelRequire("3RJkv");

var $hCC3D = parcelRequire("hCC3D");

var $cFtGt = parcelRequire("cFtGt");

var $7RZwy = parcelRequire("7RZwy");
const $03e59a293d347a10$export$41fb3f2a3e68c7c3 = (0, $7NszV.createEntry)((0, $hCC3D.filtersDirectoryRedirectRoute), ()=>({
        group: 'directories',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $dRl24.filtersDirectoryResource)
        ],
        component: !false ? (0, $7RZwy.FiltersDirectoryRedirect) : (0, $7RZwy.FiltersDirectoryComponent),
        skeleton: (0, $cFtGt.FiltersDirectorySkeleton),
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).FILTERS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7RZwy.LazyFiltersDirectory)
        ],
        isRedirect: true
    }));

});
parcelRegister("dRl24", function(module, exports) {

$parcel$export(module.exports, "filtersDirectoryResource", () => $8b127055fac893b8$export$53f99086c62225b6);

var $kbVA4 = parcelRequire("kbVA4");

var $2M1hQ = parcelRequire("2M1hQ");


const $8b127055fac893b8$export$53f99086c62225b6 = (0, $2M1hQ.createResource)({
    type: (0, $6d3ffd6df613c846$export$79e191bf6cb15284),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("gwwXN")),
    maxAge: (0, $kbVA4.MIN_MAX_AGE)
});

});
const $6d3ffd6df613c846$export$79e191bf6cb15284 = 'FILTERS_DIRECTORY';

parcelRegister("gwwXN", function(module, exports) {

let $c0793457758a80b3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c0793457758a80b3$var$load("bg0Y0").then(()=>parcelRequire('cK9UE'));

});


parcelRegister("hCC3D", function(module, exports) {

$parcel$export(module.exports, "filtersDirectoryRedirectRoute", () => $2881371d3e73fb66$export$f4f86e1ddc30a625);
const $2881371d3e73fb66$export$f4f86e1ddc30a625 = {
    name: 'filters-directory-redirect',
    path: '/ManageFilters.jspa'
};

});

parcelRegister("7RZwy", function(module, exports) {

$parcel$export(module.exports, "FiltersDirectoryRedirect", () => $37b0d6d8034450f5$export$c56e739d3bb1fe19);
$parcel$export(module.exports, "LazyFiltersDirectory", () => $37b0d6d8034450f5$export$cc133cd5c6f1b69d);
$parcel$export(module.exports, "FiltersDirectoryComponent", () => $37b0d6d8034450f5$export$e5d735e83dacb7c7);

var $5uXOq = parcelRequire("5uXOq");

var $ds5qV = parcelRequire("ds5qV");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");
const $37b0d6d8034450f5$export$c56e739d3bb1fe19 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: "/jira/filters"
    });

const $37b0d6d8034450f5$export$cc133cd5c6f1b69d = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("1lQ3O"))), {
    moduleId: "./src/packages/spa-apps/directories/filters/src/index.tsx"
});
const $37b0d6d8034450f5$export$e5d735e83dacb7c7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $37b0d6d8034450f5$export$cc133cd5c6f1b69d,
        pageId: "filters-directory",
        shouldShowSpinner: false
    });

});
parcelRegister("1lQ3O", function(module, exports) {

let $0fc022bf18d9971f$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0fc022bf18d9971f$var$load("kNFvF"),
    $0fc022bf18d9971f$var$load("76n7a"),
    $0fc022bf18d9971f$var$load("l253H"),
    $0fc022bf18d9971f$var$load("ffQaD"),
    $0fc022bf18d9971f$var$load("kvRbA"),
    $0fc022bf18d9971f$var$load("a0X6H")
]).then(()=>parcelRequire('3Zqmb'));

});



parcelRegister("f7gaE", function(module, exports) {

$parcel$export(module.exports, "filtersDirectoryRouteEntry", () => $3947322b61fcc480$export$ca77bc660994f51f);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $dRl24 = parcelRequire("dRl24");

var $3RJkv = parcelRequire("3RJkv");

var $b6S3k = parcelRequire("b6S3k");

var $cFtGt = parcelRequire("cFtGt");

var $7RZwy = parcelRequire("7RZwy");
const $3947322b61fcc480$export$ca77bc660994f51f = (0, $7NszV.createEntry)((0, $b6S3k.filtersDirectoryRoute), ()=>({
        group: 'directories',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $dRl24.filtersDirectoryResource)
        ],
        component: (0, $7RZwy.FiltersDirectoryComponent),
        skeleton: (0, $cFtGt.FiltersDirectorySkeleton),
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).FILTERS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7RZwy.LazyFiltersDirectory)
        ],
        supportsPreviewPanel: true
    }));

});

parcelRegister("g5rwu", function(module, exports) {

$parcel$export(module.exports, "findAppsRouteEntry", () => $202f2f6ea16fcbde$export$422f564c9c56a4f8);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $iHiHz = parcelRequire("iHiHz");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $8Lquf = parcelRequire("8Lquf");

var $10giJ = parcelRequire("10giJ");
const $202f2f6ea16fcbde$export$422f564c9c56a4f8 = (0, $7NszV.createEntry)((0, $8Lquf.findAppsRoute), ()=>({
        group: 'marketplace',
        component: (0, $10giJ.MarketplaceComponent),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).ADDONS,
            sidebar: (0, $iHiHz.default)
        },
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $5bkvv.getNavigationSidebarGlobalSettingsResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $10giJ.LazyMarketplace)
        ],
        ufoName: 'embedded-marketplace'
    }));

});
parcelRegister("8Lquf", function(module, exports) {

$parcel$export(module.exports, "findAppsRoute", () => $a326557081fe34cb$export$e264ef643451c60a);
const $a326557081fe34cb$export$e264ef643451c60a = {
    name: 'marketplace-index',
    path: '/jira/marketplace'
};

});


parcelRegister("5fBQK", function(module, exports) {

$parcel$export(module.exports, "forgeAdminRouteEntry", () => $3cf9bea8e2a94905$export$9e57f00c65d37e11);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $iHiHz = parcelRequire("iHiHz");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $4PkbN = parcelRequire("4PkbN");

var $hIGzE = parcelRequire("hIGzE");
const $3cf9bea8e2a94905$export$9e57f00c65d37e11 = (0, $7NszV.createEntry)((0, $4PkbN.forgeAdminRoute), ()=>({
        component: (0, $hIGzE.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $iHiHz.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $5bkvv.getNavigationSidebarGlobalSettingsResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hIGzE.LazyForgeAdminPage)
        ]
    }));

});
parcelRegister("4PkbN", function(module, exports) {

$parcel$export(module.exports, "forgeAdminRoute", () => $cc2d93b85ec603e1$export$157f97e6454c2a9f);
const $cc2d93b85ec603e1$export$157f97e6454c2a9f = {
    name: 'forge-spa-admin',
    path: '/jira/settings/apps/:appId/:envId/:route?'
};

});

parcelRegister("hIGzE", function(module, exports) {

$parcel$export(module.exports, "LazyForgeAdminPage", () => $bef31a55bb1643fb$export$66ee65dcd4a6458d);
$parcel$export(module.exports, "default", () => $bef31a55bb1643fb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $bef31a55bb1643fb$export$66ee65dcd4a6458d = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("2xK19")), {
    moduleId: "./src/packages/spa-apps/forge/admin/src/index.tsx"
});
const $bef31a55bb1643fb$export$c9e5f500ef472147 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $bef31a55bb1643fb$export$66ee65dcd4a6458d,
        pageId: "forge-spa-admin",
        shouldShowSpinner: true
    });
var $bef31a55bb1643fb$export$2e2bcd8739ae039 = $bef31a55bb1643fb$export$c9e5f500ef472147;

});
parcelRegister("2xK19", function(module, exports) {

let $1da25bf3641c2f21$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1da25bf3641c2f21$var$load("aONsY").then(()=>parcelRequire('bqE5a'));

});



parcelRegister("hxYI0", function(module, exports) {

$parcel$export(module.exports, "forgeAdminSettingsRouteEntry", () => $10e343bd77fe2c43$export$ea8439aa1b4afbb2);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $iHiHz = parcelRequire("iHiHz");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $7OevD = parcelRequire("7OevD");

var $hIGzE = parcelRequire("hIGzE");
const $10e343bd77fe2c43$export$ea8439aa1b4afbb2 = (0, $7NszV.createEntry)((0, $7OevD.forgeAdminSettingsRoute), ()=>({
        component: (0, $hIGzE.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $iHiHz.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $5bkvv.getNavigationSidebarGlobalSettingsResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hIGzE.LazyForgeAdminPage)
        ]
    }));

});
parcelRegister("7OevD", function(module, exports) {

$parcel$export(module.exports, "forgeAdminSettingsRoute", () => $48618cc01d3d4f81$export$392534a80a0b9b11);
const $48618cc01d3d4f81$export$392534a80a0b9b11 = {
    name: 'forge-spa-admin-settings',
    path: '/jira/settings/apps/:settingsType(configure|get-started)/:appId/:envId/:route?'
};

});


parcelRegister("dzSy7", function(module, exports) {

$parcel$export(module.exports, "forgeFieldContextualConfigurationRouteEntry", () => $f15b9bbe688647f5$export$425186ecf36e93c);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $2YqLE = parcelRequire("2YqLE");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $92r5p = parcelRequire("92r5p");

var $6bHdH = parcelRequire("6bHdH");
const $f15b9bbe688647f5$export$425186ecf36e93c = (0, $7NszV.createEntry)((0, $92r5p.forgeFieldContextualConfigurationRoute), ()=>({
        component: (0, $6bHdH.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $5bkvv.forgeCustomFieldTypeResource),
            (0, $2YqLE.fieldContextConfigPageResource),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6bHdH.LazyForgeFieldContextConfigPage)
        ]
    }));

});
parcelRegister("78U7j", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f593a4193eb44f7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

const $4f593a4193eb44f7$var$LazyGlobalIssuesSettingsSidebar = (0, $kxZPA.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("5V3sW")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-issues/src/index.tsx"
});
const $4f593a4193eb44f7$var$GlobalIssuesSettingsSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "globalIssuesSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4f593a4193eb44f7$var$LazyGlobalIssuesSettingsSidebar, null)));
var $4f593a4193eb44f7$export$2e2bcd8739ae039 = $4f593a4193eb44f7$var$GlobalIssuesSettingsSidebar;

});
parcelRegister("5V3sW", function(module, exports) {

let $44f4f6de07080a55$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $44f4f6de07080a55$var$load("ffQaD"),
    $44f4f6de07080a55$var$load("kvRbA"),
    $44f4f6de07080a55$var$load("76n7a"),
    $44f4f6de07080a55$var$load("l253H"),
    $44f4f6de07080a55$var$load("59e6p")
]).then(()=>parcelRequire('dZptX'));

});


parcelRegister("2YqLE", function(module, exports) {

$parcel$export(module.exports, "fieldContextConfigPageResource", () => $2520f99c62492240$export$686a607053a18611);

var $2M1hQ = parcelRequire("2M1hQ");


const $2520f99c62492240$export$686a607053a18611 = (0, $2M1hQ.createResource)({
    type: (0, $714c31c1c770eaf3$export$4b80522d38222ad),
    getKey: ()=>'data',
    getDataLoader: ()=>(parcelRequire("8wzdC")),
    maxAge: 5000
});

});
const $714c31c1c770eaf3$export$4b80522d38222ad = 'FORGE_FIELD_CONTEXTUAL_CONFIG';

parcelRegister("8wzdC", function(module, exports) {

let $634ca19688bf6fd4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $634ca19688bf6fd4$var$load("ay5JG").then(()=>parcelRequire('ei6Pl'));

});


parcelRegister("92r5p", function(module, exports) {

$parcel$export(module.exports, "forgeFieldContextualConfigurationRoute", () => $5ea48a875d63d03b$export$2ee4468dd8e9636f);
const $5ea48a875d63d03b$export$2ee4468dd8e9636f = {
    name: 'forge-spa-field-context-config',
    path: '/jira/settings/issues/field/:fieldId/context/:contextId/configure/app'
};

});

parcelRegister("6bHdH", function(module, exports) {

$parcel$export(module.exports, "LazyForgeFieldContextConfigPage", () => $b96b1546635e7c38$export$c53e206c7fd6fb76);
$parcel$export(module.exports, "default", () => $b96b1546635e7c38$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $b96b1546635e7c38$export$c53e206c7fd6fb76 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("8tCqq")), {
    moduleId: "./src/packages/spa-apps/forge/field-contextual-config/src/index.tsx"
});
const $b96b1546635e7c38$export$50bd0baee0b2f946 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $b96b1546635e7c38$export$c53e206c7fd6fb76,
        pageId: "forge-spa-field-context-config",
        shouldShowSpinner: true
    });
var $b96b1546635e7c38$export$2e2bcd8739ae039 = $b96b1546635e7c38$export$50bd0baee0b2f946;

});
parcelRegister("8tCqq", function(module, exports) {

let $62bed69cd7704a2b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $62bed69cd7704a2b$var$load("ifDe8").then(()=>parcelRequire('jBnrF'));

});



parcelRegister("eKguf", function(module, exports) {

$parcel$export(module.exports, "forgeGlobalRouteEntry", () => $7633f07341519228$export$68b00eede5bc25e6);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $iFaFr = parcelRequire("iFaFr");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $3RJkv = parcelRequire("3RJkv");

var $ic1pa = parcelRequire("ic1pa");

var $aRZh7 = parcelRequire("aRZh7");
const $7633f07341519228$export$68b00eede5bc25e6 = (0, $7NszV.createEntry)((0, $ic1pa.forgeGlobalRoute), ()=>({
        component: (0, $aRZh7.default),
        layout: (0, $aPfsS.createLayout)(),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).ADDONS,
            sidebar: (0, $iFaFr.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $5bkvv.getNavigationForgeGlobalPageResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aRZh7.LazyForgeGlobalPage)
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("iFaFr", function(module, exports) {

$parcel$export(module.exports, "default", () => $b86720f4c83cfbb5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

const $b86720f4c83cfbb5$var$LazyForPaintForgeGlobalPageSidebar = (0, $kxZPA.lazyForPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("kWYIE")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/forge-global-page/src/index.tsx"
});
const $b86720f4c83cfbb5$var$ForgeGlobalPageSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "forgeGlobalPage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b86720f4c83cfbb5$var$LazyForPaintForgeGlobalPageSidebar, null)));
$b86720f4c83cfbb5$var$ForgeGlobalPageSidebar.displayName = 'ForgeGlobalPageSidebar';
var $b86720f4c83cfbb5$export$2e2bcd8739ae039 = $b86720f4c83cfbb5$var$ForgeGlobalPageSidebar;

});
parcelRegister("kWYIE", function(module, exports) {

let $03ef9e3de2c04c37$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $03ef9e3de2c04c37$var$load("ffQaD"),
    $03ef9e3de2c04c37$var$load("kvRbA"),
    $03ef9e3de2c04c37$var$load("d9tFv")
]).then(()=>parcelRequire('4opkK'));

});


parcelRegister("ic1pa", function(module, exports) {

$parcel$export(module.exports, "forgeGlobalRoute", () => $7d160aadc36293c5$export$4146dba061d1c72d);
const $7d160aadc36293c5$export$4146dba061d1c72d = {
    name: 'forge-spa-global',
    path: '/jira/apps/:appId/:envId/:route?'
};

});

parcelRegister("aRZh7", function(module, exports) {

$parcel$export(module.exports, "LazyForgeGlobalPage", () => $8f6029962fb4c5dc$export$332293feb5cffd72);
$parcel$export(module.exports, "default", () => $8f6029962fb4c5dc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $8f6029962fb4c5dc$export$332293feb5cffd72 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("7CuZc")), {
    moduleId: "./src/packages/spa-apps/forge/global/src/index.tsx"
});
const $8f6029962fb4c5dc$export$4c36a7b018e5e5cc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8f6029962fb4c5dc$export$332293feb5cffd72,
        pageId: "forge-spa-global",
        shouldShowSpinner: true
    });
var $8f6029962fb4c5dc$export$2e2bcd8739ae039 = $8f6029962fb4c5dc$export$4c36a7b018e5e5cc;

});
parcelRegister("7CuZc", function(module, exports) {

let $58c41e3992c24ee6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $58c41e3992c24ee6$var$load("8BF7S").then(()=>parcelRequire('eZUti'));

});



parcelRegister("7vXQn", function(module, exports) {

$parcel$export(module.exports, "forgePersonalSettingsRouteEntry", () => $20637ca5596c888a$export$bcf4a0e471a2493d);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $cRWZh = parcelRequire("cRWZh");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $jApsb = parcelRequire("jApsb");

var $jaNrZ = parcelRequire("jaNrZ");
const $20637ca5596c888a$export$bcf4a0e471a2493d = (0, $7NszV.createEntry)((0, $jApsb.forgePersonalSettingsRoute), ()=>({
        component: (0, $jaNrZ.default),
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PERSONAL_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PROFILE,
            sidebar: (0, $cRWZh.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $5bkvv.getNavigationForgePersonalSettingsPageResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jaNrZ.LazyForgePersonalSettingsPage)
        ]
    }));

});
parcelRegister("jApsb", function(module, exports) {

$parcel$export(module.exports, "forgePersonalSettingsRoute", () => $911d3aa14cf2fd85$export$8cf022892f01dc88);
const $911d3aa14cf2fd85$export$8cf022892f01dc88 = {
    name: 'forge-spa-personal-settings',
    path: '/jira/settings/personal/apps/:appId/:envId/:route?'
};

});

parcelRegister("jaNrZ", function(module, exports) {

$parcel$export(module.exports, "LazyForgePersonalSettingsPage", () => $407ba70330fa3fc8$export$984c6340ff981792);
$parcel$export(module.exports, "default", () => $407ba70330fa3fc8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $407ba70330fa3fc8$export$984c6340ff981792 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("dljoE")), {
    moduleId: "./src/packages/spa-apps/forge/personal-settings/src/index.tsx"
});
const $407ba70330fa3fc8$export$fb659fde7fa91075 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $407ba70330fa3fc8$export$984c6340ff981792,
        pageId: "forge-spa-personal-settings",
        shouldShowSpinner: true
    });
var $407ba70330fa3fc8$export$2e2bcd8739ae039 = $407ba70330fa3fc8$export$fb659fde7fa91075;

});
parcelRegister("dljoE", function(module, exports) {

let $9b6c484a70c5bb12$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9b6c484a70c5bb12$var$load("rlx05").then(()=>parcelRequire('arSLF'));

});



parcelRegister("kCn5T", function(module, exports) {

$parcel$export(module.exports, "forgeProjectRouteEntry", () => $284a2dce5bdef34f$export$1ed77617605af86d);

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $fpjJX = parcelRequire("fpjJX");

var $7GnDe = parcelRequire("7GnDe");

var $lgVu5 = parcelRequire("lgVu5");

var $ioJTL = parcelRequire("ioJTL");
const $284a2dce5bdef34f$export$1ed77617605af86d = (0, $7NszV.createEntry)((0, $lgVu5.forgeProjectRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            ...(0, $fpjJX.getServiceDeskSharedNavigationSingleResources)(),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $dxCvy.projectContextResourceWithCache),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>(0, $ioJTL.forgeProjectPageEntrypoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("lgVu5", function(module, exports) {

$parcel$export(module.exports, "forgeProjectRoute", () => $d3c18f0b3608cdac$export$998d01fc8f4c3224);
const $d3c18f0b3608cdac$export$998d01fc8f4c3224 = {
    name: 'forge-spa-project',
    path: '/jira/:projectType(software|software/c|core)/projects/:projectKey/apps/:appId/:envId/:route?'
};

});

parcelRegister("ioJTL", function(module, exports) {

$parcel$export(module.exports, "forgeProjectPageEntrypoint", () => $495262f31d81d9db$export$74e6ff15060a7efe);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $jVVdt = parcelRequire("jVVdt");

var $fo6b8 = parcelRequire("fo6b8");
const $495262f31d81d9db$export$74e6ff15060a7efe = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $jVVdt.forgeProjectEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("jVVdt", function(module, exports) {

$parcel$export(module.exports, "forgeProjectEntrypoint", () => $8e3be2a67cce3f64$export$109bb60f5ed960e9);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $8e3be2a67cce3f64$export$109bb60f5ed960e9 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("eNWYY")), {
        moduleId: "a42399f5",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context })=>({
            extraProps: {
                match: context.match
            }
        })
});

});
parcelRegister("eNWYY", function(module, exports) {

let $ac7364f8ec17c62b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ac7364f8ec17c62b$var$load("i5Vmg").then(()=>parcelRequire('kGkpN'));

});




parcelRegister("90Rrp", function(module, exports) {

$parcel$export(module.exports, "forgeProjectServicedeskRouteEntry", () => $4f02896c605dcb0b$export$6732bea56e68d0b4);

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $fpjJX = parcelRequire("fpjJX");

var $7GnDe = parcelRequire("7GnDe");

var $8RflP = parcelRequire("8RflP");

var $7IrJ6 = parcelRequire("7IrJ6");
const $4f02896c605dcb0b$export$6732bea56e68d0b4 = (0, $7NszV.createEntry)((0, $8RflP.forgeProjectServicedeskRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSharedNavigationSingleResources)(),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $dxCvy.projectContextResourceWithCache),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>(0, $7IrJ6.forgeProjectServicedeskPageEntrypoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("8RflP", function(module, exports) {

$parcel$export(module.exports, "forgeProjectServicedeskRoute", () => $e62a10d9c09b490c$export$8b83928f9f21e11);
const $e62a10d9c09b490c$export$8b83928f9f21e11 = {
    name: 'forge-spa-project-servicedesk',
    path: '/jira/:projectType(servicedesk)/projects/:projectKey/apps/:appId/:envId/:route?'
};

});

parcelRegister("7IrJ6", function(module, exports) {

$parcel$export(module.exports, "forgeProjectServicedeskPageEntrypoint", () => $c277f8b7f3958697$export$eae71fd9c3e0166a);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $jVVdt = parcelRequire("jVVdt");
const $c277f8b7f3958697$export$eae71fd9c3e0166a = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $jVVdt.forgeProjectEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});


parcelRegister("86qmt", function(module, exports) {

$parcel$export(module.exports, "forgeServicedeskQueueRouteEntry", () => $03b194d7d6d82e68$export$1486fc4f85c1237);

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $levwO = parcelRequire("levwO");

var $6Z2mh = parcelRequire("6Z2mh");

var $9mZwV = parcelRequire("9mZwV");
const $03b194d7d6d82e68$export$1486fc4f85c1237 = (0, $7NszV.createEntry)((0, $levwO.forgeServicedeskQueueRoute), ()=>({
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>(0, $9mZwV.forgeServiceDeskQueuePageEntrypoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("levwO", function(module, exports) {

$parcel$export(module.exports, "forgeServicedeskQueueRoute", () => $019035708a3fcd5d$export$b77275b989ab42a6);
const $019035708a3fcd5d$export$b77275b989ab42a6 = {
    name: 'forge-spa-servicedesk-queue',
    path: '/jira/servicedesk/projects/:projectKey/queues/apps/:appId/:envId/:route?'
};

});

parcelRegister("9mZwV", function(module, exports) {

$parcel$export(module.exports, "forgeServiceDeskQueuePageEntrypoint", () => $ebb310d709581894$export$e50db2ee9d53508e);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $5buAb = parcelRequire("5buAb");
const $ebb310d709581894$export$e50db2ee9d53508e = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $5buAb.forgeServiceDeskEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("5buAb", function(module, exports) {

$parcel$export(module.exports, "forgeServiceDeskEntrypoint", () => $599bf9ac9bda7f22$export$5f56161124a4cb21);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $599bf9ac9bda7f22$export$5f56161124a4cb21 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("hy8ml")), {
        moduleId: "70dc4c33",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("hy8ml", function(module, exports) {

let $cc6c18a358d94fa6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cc6c18a358d94fa6$var$load("g5aO0").then(()=>parcelRequire('6Ue2s'));

});




parcelRegister("fH16o", function(module, exports) {

$parcel$export(module.exports, "generalPersonalSettingsRouteEntry", () => $c84e53d16eb519d5$export$e8b7e9281fc3db35);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $cRWZh = parcelRequire("cRWZh");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $7ziML = parcelRequire("7ziML");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $4XFHO = parcelRequire("4XFHO");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $c84e53d16eb519d5$var$LazyGeneralPersonalSettings = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("6SrH0"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/personal-settings/general/src/index.tsx"
});
const $c84e53d16eb519d5$var$GeneralPersonalSettingsComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $c84e53d16eb519d5$var$LazyGeneralPersonalSettings,
        pageId: "personal-settings-general",
        shouldShowSpinner: true
    });
const $c84e53d16eb519d5$export$e8b7e9281fc3db35 = (0, $7NszV.createEntry)((0, $7ziML.generalPersonalSettingsRoute), ()=>({
        group: 'personal-settings',
        component: $c84e53d16eb519d5$var$GeneralPersonalSettingsComponent,
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PERSONAL_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PROFILE,
            sidebar: (0, $cRWZh.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $4XFHO.getLabsResources)(),
            ...(0, $5bkvv.getNavigationForgePersonalSettingsPageResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $c84e53d16eb519d5$var$LazyGeneralPersonalSettings
        ]
    }));

});
parcelRegister("7ziML", function(module, exports) {

$parcel$export(module.exports, "generalPersonalSettingsRoute", () => $bac161cf2450c76e$export$7a6c9715a86f906b);
const $bac161cf2450c76e$export$7a6c9715a86f906b = {
    name: 'personal-settings-general',
    path: '/jira/settings/personal/general'
};

});

parcelRegister("4XFHO", function(module, exports) {

$parcel$export(module.exports, "getLabsResources", () => $0f10f97c7a06e4e8$export$18345571aa12a367);

var $c04PQ = parcelRequire("c04PQ");

var $eOlBz = parcelRequire("eOlBz");

var $ipmBb = parcelRequire("ipmBb");

var $gNStA = parcelRequire("gNStA");
const $0f10f97c7a06e4e8$export$18345571aa12a367 = ()=>[
        (0, $eOlBz.newIssueViewTransitionLockInStatusResource),
        (0, $gNStA.resourceWithCondition2)(()=>!(0, $c04PQ.isFedRamp)(), (0, $ipmBb.nextBestTaskFeatureResource))
    ];

});

parcelRegister("6SrH0", function(module, exports) {

let $501d446920821a1a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $501d446920821a1a$var$load("jlJ8d").then(()=>parcelRequire('6keru'));

});


parcelRegister("q3duL", function(module, exports) {

$parcel$export(module.exports, "globalEscalationsRouteEntry", () => $ef2506bfe64688a1$export$adde4536d8e5f94c);

var $5uXOq = parcelRequire("5uXOq");

var $cM724 = parcelRequire("cM724");

var $ffza4 = parcelRequire("ffza4");

var $eZXFU = parcelRequire("eZXFU");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $6yAvP = parcelRequire("6yAvP");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ef2506bfe64688a1$var$LazyGlobalEscalations = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("btLVG")).then((module)=>module.GlobalEscalationsPage), {
    moduleId: "./src/packages/eoc/global-escalations/src/index.tsx"
});
const $ef2506bfe64688a1$var$GlobalEscalationsComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ef2506bfe64688a1$var$LazyGlobalEscalations,
        pageId: "async-jira-eoc-global-escalations",
        shouldShowSpinner: false
    });
const $ef2506bfe64688a1$var$getNavigationSpecifications = ()=>{
    return (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $ef2506bfe64688a1$export$adde4536d8e5f94c = (0, $7NszV.createEntry)((0, $6yAvP.globalEscalationsRoute), ()=>({
        group: 'eoc',
        component: $ef2506bfe64688a1$var$GlobalEscalationsComponent,
        layout: (0, $eZXFU.opsSettingsLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $cM724.globalEscalationsListInfoResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$ef2506bfe64688a1$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            $ef2506bfe64688a1$var$LazyGlobalEscalations
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            $ef2506bfe64688a1$var$LazyGlobalEscalations
        ]
    }));

});
parcelRegister("cM724", function(module, exports) {

$parcel$export(module.exports, "globalEscalationsListInfoResource", () => $a2d6726b104ac899$export$bffddc002dadaf3a);

var $2M1hQ = parcelRequire("2M1hQ");

var $2dbE7 = parcelRequire("2dbE7");
const $a2d6726b104ac899$export$bffddc002dadaf3a = (0, $2M1hQ.createResource)({
    type: 'globalEscalationsListInfoResource',
    getKey: ()=>'globalEscalationsListInfoResource',
    getData: (0, $2dbE7.getListInfo),
    isBrowserOnly: true
});

});
parcelRegister("2dbE7", function(module, exports) {

$parcel$export(module.exports, "getEscalations", () => $9fcebef6d9f6d876$export$300727380b60aeb4);
$parcel$export(module.exports, "getListInfo", () => $9fcebef6d9f6d876$export$bdc8fe7d9cd263b);

var $j74qU = parcelRequire("j74qU");
const $9fcebef6d9f6d876$export$300727380b60aeb4 = ({ lastEvaluatedToken: lastEvaluatedToken, queryKey: queryKey })=>{
    const [, filtersString] = queryKey;
    const filters = JSON.parse(filtersString);
    const params = new URLSearchParams({
        ...filters,
        lastEvaluatedToken: lastEvaluatedToken
    });
    return (0, $j74qU.eocFetch)(`/v1/escalations/search?${params.toString()}`);
};
const $9fcebef6d9f6d876$export$bdc8fe7d9cd263b = ()=>{
    return (0, $j74qU.eocFetch)('/v1/escalations/list-info');
};

});


parcelRegister("6yAvP", function(module, exports) {

$parcel$export(module.exports, "globalEscalationsRoute", () => $b256c068fa7916da$export$9ed12f6fa845edfb);
const $b256c068fa7916da$export$9ed12f6fa845edfb = {
    name: 'eoc-global-escalations',
    path: '/jira/settings/products/ops/escalation-policies',
    exact: true
};

});

parcelRegister("btLVG", function(module, exports) {

let $85b794e5096951ac$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $85b794e5096951ac$var$load("ffQaD"),
    $85b794e5096951ac$var$load("kvRbA"),
    $85b794e5096951ac$var$load("dMGRJ")
]).then(()=>parcelRequire('dLkuj'));

});


parcelRegister("4iFpq", function(module, exports) {

$parcel$export(module.exports, "globalIncomingCallDetailRouteEntry", () => $91ad9944e0af1355$export$39f40714591c98c0);

var $5uXOq = parcelRequire("5uXOq");

var $4C2Pb = parcelRequire("4C2Pb");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $1oUsV = parcelRequire("1oUsV");

var $5j7Th = parcelRequire("5j7Th");

var $hHoID = parcelRequire("hHoID");
const $91ad9944e0af1355$var$IncomingCallDetail = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $hHoID.LazyIncomingCallDetail),
        pageId: "async-jira-eoc-incoming-call-detail",
        shouldShowSpinner: false
    });
const $91ad9944e0af1355$export$39f40714591c98c0 = (0, $7NszV.createEntry)((0, $1oUsV.globalIncomingCallDetailRoute), ()=>({
        group: 'eoc',
        component: $91ad9944e0af1355$var$IncomingCallDetail,
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $4C2Pb.detailResources)()
        ],
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hHoID.LazyIncomingCall)
        ]
    }));

});
parcelRegister("4C2Pb", function(module, exports) {

$parcel$export(module.exports, "listResources", () => $e9a4d4d3026c87cf$export$c83d9fd41123ab31);
$parcel$export(module.exports, "detailResources", () => $e9a4d4d3026c87cf$export$63630293105c0f4e);

var $ffEPd = parcelRequire("ffEPd");

var $3zzQS = parcelRequire("3zzQS");
const $e9a4d4d3026c87cf$export$c83d9fd41123ab31 = ()=>[
        (0, $3zzQS.listResource)
    ];
const $e9a4d4d3026c87cf$export$63630293105c0f4e = ()=>[
        (0, $ffEPd.detailResource)
    ];

});
parcelRegister("ffEPd", function(module, exports) {

$parcel$export(module.exports, "detailResource", () => $d2ad11d314356b50$export$13d78d45f8054f1e);

var $2M1hQ = parcelRequire("2M1hQ");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $bKopM = parcelRequire("bKopM");
const $d2ad11d314356b50$export$13d78d45f8054f1e = (0, $2M1hQ.createResource)({
    type: 'getDetailResource',
    getKey: ()=>'getDetailResource',
    getData: async (routerContext)=>{
        const id = routerContext.match.params?.id;
        (0, $hmVmJ.assert)(!!id, new (0, $dH6Pi.AssertionError)('detailResource', 'id should be set to fetch incoming call detail'));
        return (0, $bKopM.getDetail)(id);
    },
    isBrowserOnly: true
});

});
parcelRegister("bKopM", function(module, exports) {

$parcel$export(module.exports, "getDetail", () => $3e9eec2aa2136224$export$d6c3faeb2ce9d297);

var $j74qU = parcelRequire("j74qU");

var $7PepW = parcelRequire("7PepW");
const $3e9eec2aa2136224$export$d6c3faeb2ce9d297 = (id)=>{
    const endpoint = `${(0, $7PepW.urls).incomingCall.detail.url(id)}`;
    return (0, $j74qU.eocFetch)(endpoint);
};

});
parcelRegister("7PepW", function(module, exports) {

$parcel$export(module.exports, "urls", () => $5edaa37a3b09374b$export$bcae9ba627f604b6);
const $5edaa37a3b09374b$export$bcae9ba627f604b6 = Object.freeze({
    incomingCall: {
        url: ()=>`/v1/incoming-call`,
        detail: {
            url: (incomingCallId = ':incomingCallId')=>`${$5edaa37a3b09374b$export$bcae9ba627f604b6.incomingCall.url()}/${incomingCallId}`
        }
    }
});

});



parcelRegister("3zzQS", function(module, exports) {

$parcel$export(module.exports, "listResource", () => $c316e599070576e5$export$5ee018e9baf9d633);

var $eURsm = parcelRequire("eURsm");

var $9FZzU = parcelRequire("9FZzU");
const $c316e599070576e5$export$5ee018e9baf9d633 = (0, $eURsm.createPaginatedResource)({
    type: 'getListResource',
    getKey: ()=>'getListResource',
    getData: ()=>(0, $9FZzU.getList),
    isBrowserOnly: true
});

});
parcelRegister("eURsm", function(module, exports) {

$parcel$export(module.exports, "createPaginatedResource", () => $9723334731b55493$export$561b032e4d26d1e8);

var $2M1hQ = parcelRequire("2M1hQ");
const $9723334731b55493$export$561b032e4d26d1e8 = ({ getData: getData, getKey: getKey, ...arg })=>{
    return (0, $2M1hQ.createResource)({
        ...arg,
        getKey: (routerContext, customContext)=>{
            const { query: query } = routerContext;
            const page = query['page'] || '1';
            const key = `${getKey(routerContext, customContext)}#${page}`;
            return key;
        },
        getData: (routerContext, customContext)=>{
            const { query: query } = routerContext;
            const page = parseInt(query['page']) || 1;
            return getData(routerContext, customContext)({
                page: page
            });
        }
    });
};

});

parcelRegister("9FZzU", function(module, exports) {

$parcel$export(module.exports, "getList", () => $3bbdbabf459bda32$export$73fffd6dda5144e);
$parcel$export(module.exports, "addIncomingCall", () => $3bbdbabf459bda32$export$cdae09ff00c893b2);

var $j74qU = parcelRequire("j74qU");

var $7PepW = parcelRequire("7PepW");
const $3bbdbabf459bda32$export$73fffd6dda5144e = ({ page: page })=>{
    const limit = 20;
    const offset = (page - 1) * limit;
    const params = new URLSearchParams({
        offset: `${offset}`,
        limit: `${limit}`,
        sortBy: 'name',
        sort: 'asc'
    });
    const endpoint = `${(0, $7PepW.urls).incomingCall.url()}?${params.toString()}`;
    return (0, $j74qU.eocFetch)(endpoint).then(({ data: data, count: count })=>{
        return {
            data: data,
            count: Math.ceil(count / limit)
        };
    });
};
const $3bbdbabf459bda32$export$cdae09ff00c893b2 = (params)=>{
    return (0, $j74qU.eocFetch)((0, $7PepW.urls).incomingCall.url(), {
        method: 'POST',
        body: params
    });
};

});



parcelRegister("1oUsV", function(module, exports) {

$parcel$export(module.exports, "globalIncomingCallDetailRoute", () => $f3c8c21142f35b35$export$10f19333da6ac52c);
const $f3c8c21142f35b35$export$10f19333da6ac52c = {
    name: 'eoc-incoming-call-detail',
    path: '/jira/settings/products/ops/incoming-call/:id',
    exact: true
};

});

parcelRegister("hHoID", function(module, exports) {

$parcel$export(module.exports, "LazyIncomingCall", () => $304419cc9d82ded9$export$d76e6607b7e88a7b);
$parcel$export(module.exports, "LazyIncomingCallDetail", () => $304419cc9d82ded9$export$1c56f2b1fdd5d724);

var $kxZPA = parcelRequire("kxZPA");

const $304419cc9d82ded9$export$d76e6607b7e88a7b = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("gYZW6")).then((module)=>module.IncomingCallPage), {
    moduleId: "./src/packages/eoc/incoming-call/src/index.tsx"
});

const $304419cc9d82ded9$export$1c56f2b1fdd5d724 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("gYZW6")).then((module)=>module.IncomingCallDetailPage), {
    moduleId: "./src/packages/eoc/incoming-call/src/index.tsx"
});

});
parcelRegister("gYZW6", function(module, exports) {

let $c5d24b26b83ea2c2$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c5d24b26b83ea2c2$var$load("ffQaD"),
    $c5d24b26b83ea2c2$var$load("kvRbA"),
    $c5d24b26b83ea2c2$var$load("5NUjK")
]).then(()=>parcelRequire('8oycJ'));

});



parcelRegister("kvJxs", function(module, exports) {

$parcel$export(module.exports, "globalIncomingCallRouteEntry", () => $06d17d7f82b9f72c$export$bf8ccc758901febd);

var $5uXOq = parcelRequire("5uXOq");

var $4C2Pb = parcelRequire("4C2Pb");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $eZXFU = parcelRequire("eZXFU");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $jWsFA = parcelRequire("jWsFA");

var $5j7Th = parcelRequire("5j7Th");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

var $hHoID = parcelRequire("hHoID");
const $06d17d7f82b9f72c$var$IncomingCall = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $hHoID.LazyIncomingCall),
        pageId: "async-jira-eoc-incoming-call",
        shouldShowSpinner: false
    });
const $06d17d7f82b9f72c$var$getNavigationSpecifications = ()=>{
    return (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $06d17d7f82b9f72c$export$bf8ccc758901febd = (0, $7NszV.createEntry)((0, $jWsFA.globalIncomingCallRoute), ()=>({
        group: 'eoc',
        component: $06d17d7f82b9f72c$var$IncomingCall,
        layout: (0, $eZXFU.opsSettingsLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $4C2Pb.listResources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$06d17d7f82b9f72c$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hHoID.LazyIncomingCall)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hHoID.LazyIncomingCall)
        ]
    }));

});
parcelRegister("jWsFA", function(module, exports) {

$parcel$export(module.exports, "globalIncomingCallRoute", () => $6e436edec71d75e1$export$8dd2e8adca05d8a3);
const $6e436edec71d75e1$export$8dd2e8adca05d8a3 = {
    name: 'eoc-incoming-call',
    path: '/jira/settings/products/ops/incoming-call',
    exact: true
};

});


parcelRegister("kxvlX", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationCreateRouteEntry", () => $675ac2c2cf4991e7$export$62eef9a2917f041f);

var $g9g6m = parcelRequire("g9g6m");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $iojZc = parcelRequire("iojZc");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

var $jNNfq = parcelRequire("jNNfq");

var $2PI2S = parcelRequire("2PI2S");

var $kEMby = parcelRequire("kEMby");
const $675ac2c2cf4991e7$var$getNavigationSpecifications = ()=>{
    return (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $675ac2c2cf4991e7$export$62eef9a2917f041f = (0, $7NszV.createEntry)((0, $iojZc.globalIntegrationCreateRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/settings/products/ops',
        component: (0, $jNNfq.IntegrationAutomation),
        slot: (0, $2PI2S.IntegrationCreate),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $g9g6m.resources).configuredIntegrationsResource,
            (0, $g9g6m.resources).integrationListResource,
            (0, $g9g6m.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$675ac2c2cf4991e7$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation)
        ]
    }));

});
parcelRegister("g9g6m", function(module, exports) {

$parcel$export(module.exports, "resources", () => $97e7bbf09fde8a26$export$bc99aaabaf7b70a7);

var $5WVG8 = parcelRequire("5WVG8");

var $hVeqx = parcelRequire("hVeqx");

var $h4DSB = parcelRequire("h4DSB");
const $97e7bbf09fde8a26$export$bc99aaabaf7b70a7 = {
    configuredIntegrationsResource: $5WVG8.configuredIntegrationsResource,
    integrationListResource: $hVeqx.integrationListResource,
    userAccessRightsResource: $h4DSB.userAccessRightsResource
};

});
parcelRegister("5WVG8", function(module, exports) {

$parcel$export(module.exports, "configuredIntegrationsResource", () => $83d54f0caf3b9996$export$4136019b80be5917);

var $2M1hQ = parcelRequire("2M1hQ");

var $6nRK2 = parcelRequire("6nRK2");

var $7suNB = parcelRequire("7suNB");

const $83d54f0caf3b9996$export$4136019b80be5917 = (0, $2M1hQ.createResource)({
    type: 'configuredIntegrationsResource',
    getKey: ({ query: query, match: match })=>{
        const teamId = match.params.teamId ?? query['teamId'];
        const group = query['group'];
        const keyword = query['keyword'];
        const status = query['status'];
        const page = query['page'] || '1';
        return (0, $6nRK2.UrlHelper)((0, $cf8709d20bdba1b1$export$bc7daa294a7c75e4), {
            [(0, $cf8709d20bdba1b1$export$d26137cf824a9e53)]: page,
            [(0, $cf8709d20bdba1b1$export$299579ccbdd63cbc)]: keyword,
            [(0, $cf8709d20bdba1b1$export$d7415cfdee4bffc8)]: group,
            [(0, $cf8709d20bdba1b1$export$ce2c93e90dda8613)]: status,
            [(0, $cf8709d20bdba1b1$export$4e0ddb4dc97eb573)]: teamId
        });
    },
    getData: (routerContext)=>(0, $7suNB.default).getIntegrations(routerContext.query, routerContext.match.params.teamId),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("6nRK2", function(module, exports) {

$parcel$export(module.exports, "UrlHelper", () => $15b449f9b21b0a2a$export$bacbc496e850c0a4);
const $15b449f9b21b0a2a$export$bacbc496e850c0a4 = (path, params = {})=>{
    // https://github.com/microsoft/TypeScript/issues/16655
    const q = Object.entries(params).map(([k, v])=>v !== '' && !!v || v === false ? [
            k,
            v.toString()
        ] : undefined).filter((v)=>!!v);
    // Using %2C in URLs causes bugs in AngularJS, so we need to replace it with comma
    const qs = new URLSearchParams(q).toString().replace(/%2C/g, ',');
    return `${path}${qs ? `?${qs}` : ''}`;
};

});

parcelRegister("7suNB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6c9b0fd99b09a25$export$2e2bcd8739ae039);

var $j74qU = parcelRequire("j74qU");

var $6nRK2 = parcelRequire("6nRK2");

const $f6c9b0fd99b09a25$var$getIntegrations = async (query, pathParamTeamId)=>{
    const page = parseInt(query['page']) || 1;
    const offset = (page - 1) * (0, $38fc251fc66fc98a$export$31ecae7225aecec6);
    const queryParams = query ? {
        teamId: pathParamTeamId ?? query.teamId,
        group: query.group,
        keyword: query.keyword,
        status: query.status
    } : {};
    return (0, $j74qU.eocFetch)((0, $6nRK2.UrlHelper)('/v3/integrations/unified', {
        ...queryParams,
        offset: offset.toString(),
        limit: (0, $38fc251fc66fc98a$export$31ecae7225aecec6)
    })).then((response)=>({
            data: response.data.integrations,
            pageCount: Math.ceil(response.data.count / (0, $38fc251fc66fc98a$export$31ecae7225aecec6)),
            itemCount: response.data.count,
            platformTeamId: response.data.platformTeamId
        }));
};
const $f6c9b0fd99b09a25$var$patchIntegration = async (integrationId, integrationType, body, teamId)=>(0, $j74qU.eocFetch)((0, $6nRK2.UrlHelper)(`/v3/integrations/unified/${integrationId}`, {
        type: integrationType,
        teamId: teamId
    }), {
        method: 'PATCH',
        body: body
    }).then((response)=>response.data);
const $f6c9b0fd99b09a25$var$deleteIntegration = async (integrationId, integrationType, teamId)=>(0, $j74qU.eocFetch)((0, $6nRK2.UrlHelper)(`/v3/integrations/unified/${integrationId}`, {
        type: integrationType,
        teamId: teamId
    }), {
        method: 'DELETE',
        responseType: 'headers'
    });
var $f6c9b0fd99b09a25$export$2e2bcd8739ae039 = {
    getIntegrations: $f6c9b0fd99b09a25$var$getIntegrations,
    patchIntegration: $f6c9b0fd99b09a25$var$patchIntegration,
    deleteIntegration: $f6c9b0fd99b09a25$var$deleteIntegration
};

});
const $38fc251fc66fc98a$export$31ecae7225aecec6 = 20;


const $cf8709d20bdba1b1$export$bc7daa294a7c75e4 = 'configuredIntegrationsResource';
const $cf8709d20bdba1b1$export$d26137cf824a9e53 = 'page';
const $cf8709d20bdba1b1$export$299579ccbdd63cbc = 'keyword';
const $cf8709d20bdba1b1$export$d7415cfdee4bffc8 = 'group';
const $cf8709d20bdba1b1$export$ce2c93e90dda8613 = 'status';
const $cf8709d20bdba1b1$export$4e0ddb4dc97eb573 = 'teamId';


parcelRegister("hVeqx", function(module, exports) {

$parcel$export(module.exports, "integrationListResource", () => $d497f8a5feefb0d5$export$f60a40a11a6e0ee4);

var $2M1hQ = parcelRequire("2M1hQ");

var $jYQAI = parcelRequire("jYQAI");
const $d497f8a5feefb0d5$export$f60a40a11a6e0ee4 = (0, $2M1hQ.createResource)({
    type: 'integrationListResource',
    getKey: ({ query: query })=>{
        const group = query['group'];
        const keyword = query['keyword'];
        return `integrationListResource?group=${group}&keyword=${keyword}`;
    },
    getData: async (routerContext)=>await (0, $jYQAI.default).getIntegrationList(routerContext.query, routerContext.match.params.teamId),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("jYQAI", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e286a884592e027$export$2e2bcd8739ae039);

var $j74qU = parcelRequire("j74qU");

var $6nRK2 = parcelRequire("6nRK2");
const $1e286a884592e027$var$getIntegrationList = (query, teamId)=>{
    const { keyword: keyword, group: group } = query ?? {};
    return (0, $j74qU.eocFetch)((0, $6nRK2.UrlHelper)(`/v3/integrations/unified/supported-integrations`, {
        keyword: keyword,
        group: group,
        teamId: teamId
    })).then((response)=>{
        const { labels: labels, availableGroups: availableGroups, allTypes: allTypes, platformTeamId: platformTeamId } = response.data;
        return {
            labels: labels,
            availableGroups: availableGroups,
            allTypes: allTypes,
            platformTeamId: platformTeamId
        };
    });
};
const $1e286a884592e027$var$getIntegrationTypes = (integrationType, teamId)=>(0, $j74qU.eocFetch)((0, $6nRK2.UrlHelper)(`/v3/integrations/unified/${integrationType}/types`, {
        teamId: teamId
    })).then((response)=>response.data.map((integrationType)=>({
                ...integrationType,
                value: integrationType.type,
                label: integrationType.displayName
            })));
var $1e286a884592e027$export$2e2bcd8739ae039 = {
    getIntegrationList: $1e286a884592e027$var$getIntegrationList,
    getIntegrationTypes: $1e286a884592e027$var$getIntegrationTypes
};

});


parcelRegister("h4DSB", function(module, exports) {

$parcel$export(module.exports, "userAccessRightsResource", () => $955f19580ff30efa$export$69ddc7cc64ae9a02);

var $2M1hQ = parcelRequire("2M1hQ");

var $ifvD2 = parcelRequire("ifvD2");
const $955f19580ff30efa$export$69ddc7cc64ae9a02 = (0, $2M1hQ.createResource)({
    type: 'userAccessRightsResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params.teamId;
        return `userAccessRightsResource#${!!teamId ? teamId : ''}`;
    },
    getData: (routerContext)=>(0, $ifvD2.getUserRights)(routerContext.match.params.teamId),
    maxAge: 3600000,
    isBrowserOnly: true
});

});
parcelRegister("ifvD2", function(module, exports) {

$parcel$export(module.exports, "getUserRights", () => $82efdac2c3d222dc$export$84e2ed279bc4e64e);

var $j74qU = parcelRequire("j74qU");

var $6nRK2 = parcelRequire("6nRK2");
const $82efdac2c3d222dc$export$84e2ed279bc4e64e = (teamId)=>{
    return (0, $j74qU.eocFetch)((0, $6nRK2.UrlHelper)(`/v3/integrations/unified/rights`, {
        teamId: teamId
    })).then((response)=>response.data);
};

});



parcelRegister("iojZc", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationCreateRoute", () => $9976afa23f08aee0$export$bb272d36e3c3b7c1);
const $9976afa23f08aee0$export$bb272d36e3c3b7c1 = {
    name: 'eoc-integration-create',
    path: '/jira/settings/products/ops/integrations/create/:type',
    exact: true
};

});

parcelRegister("jNNfq", function(module, exports) {

$parcel$export(module.exports, "IntegrationAutomation", () => $3543a714bb5eb15f$export$434c3e2269913ac0);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kEMby = parcelRequire("kEMby");
const $3543a714bb5eb15f$export$434c3e2269913ac0 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $kEMby.LazyIntegrationAutomation),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });

});
parcelRegister("kEMby", function(module, exports) {

$parcel$export(module.exports, "LazyIntegrationAutomation", () => $bd50af419902000e$export$68c40afda0287b61);
$parcel$export(module.exports, "LazyIntegrationDetail", () => $bd50af419902000e$export$fd7f60e3df94c902);
$parcel$export(module.exports, "LazyIntegrationCreate", () => $bd50af419902000e$export$aa9358ade7cb53ee);
$parcel$export(module.exports, "LazyIntegrationList", () => $bd50af419902000e$export$993132b847f26efa);
$parcel$export(module.exports, "LazyIntegrationLog", () => $bd50af419902000e$export$b02ef932401d95fc);

var $kxZPA = parcelRequire("kxZPA");

const $bd50af419902000e$export$68c40afda0287b61 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("2Lsjb")).then((module)=>module.IntegrationAutomation), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

const $bd50af419902000e$export$fd7f60e3df94c902 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("2Lsjb")).then((module)=>module.IntegrationDetail), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

const $bd50af419902000e$export$aa9358ade7cb53ee = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("2Lsjb")).then((module)=>module.IntegrationCreate), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

const $bd50af419902000e$export$993132b847f26efa = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("2Lsjb")).then((module)=>module.IntegrationList), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

const $bd50af419902000e$export$b02ef932401d95fc = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("2Lsjb")).then((module)=>module.IntegrationLog), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

});
parcelRegister("2Lsjb", function(module, exports) {

let $2035ee0662388660$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $2035ee0662388660$var$load("ffQaD"),
    $2035ee0662388660$var$load("kvRbA"),
    $2035ee0662388660$var$load("76n7a"),
    $2035ee0662388660$var$load("l253H"),
    $2035ee0662388660$var$load("4btFi")
]).then(()=>parcelRequire('5QWfc'));

});



parcelRegister("2PI2S", function(module, exports) {

$parcel$export(module.exports, "IntegrationCreate", () => $1b0aeecb6549cd04$export$5cb14595364f02c);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kEMby = parcelRequire("kEMby");
const $1b0aeecb6549cd04$export$5cb14595364f02c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $kEMby.LazyIntegrationCreate),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });

});


parcelRegister("0e4yJ", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationDetailRouteEntry", () => $127c0a8b66d1f657$export$b66abbccbf93e9ad);

var $g9g6m = parcelRequire("g9g6m");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $80hVz = parcelRequire("80hVz");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

var $jNNfq = parcelRequire("jNNfq");

var $7ifqF = parcelRequire("7ifqF");

var $kEMby = parcelRequire("kEMby");
const $127c0a8b66d1f657$var$getNavigationSpecifications = ()=>{
    return (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $127c0a8b66d1f657$export$b66abbccbf93e9ad = (0, $7NszV.createEntry)((0, $80hVz.globalIntegrationDetailRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/settings/products/ops',
        component: (0, $jNNfq.IntegrationAutomation),
        slot: (0, $7ifqF.IntegrationDetail),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $g9g6m.resources).configuredIntegrationsResource,
            (0, $g9g6m.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$127c0a8b66d1f657$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation)
        ]
    }));

});
parcelRegister("80hVz", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationDetailRoute", () => $5333a62eb0093759$export$f826f15073eda98);
const $5333a62eb0093759$export$f826f15073eda98 = {
    name: 'eoc-integration-detail',
    path: '/jira/settings/products/ops/integrations/:type/:integrationId',
    exact: true
};

});

parcelRegister("7ifqF", function(module, exports) {

$parcel$export(module.exports, "IntegrationDetail", () => $73ab5160c11e08af$export$8bb99f196e0be5b6);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kEMby = parcelRequire("kEMby");
const $73ab5160c11e08af$export$8bb99f196e0be5b6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $kEMby.LazyIntegrationDetail),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });

});


parcelRegister("4mhUQ", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationListRouteEntry", () => $ed52be46c53ae197$export$790602da39f8af00);

var $g9g6m = parcelRequire("g9g6m");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $hNbjv = parcelRequire("hNbjv");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

var $jNNfq = parcelRequire("jNNfq");

var $3cv8c = parcelRequire("3cv8c");

var $kEMby = parcelRequire("kEMby");
const $ed52be46c53ae197$var$getNavigationSpecifications = ()=>{
    return (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $ed52be46c53ae197$export$790602da39f8af00 = (0, $7NszV.createEntry)((0, $hNbjv.globalIntegrationListRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/settings/products/ops',
        component: (0, $jNNfq.IntegrationAutomation),
        slot: (0, $3cv8c.IntegrationList),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $g9g6m.resources).integrationListResource,
            (0, $g9g6m.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$ed52be46c53ae197$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation)
        ]
    }));

});
parcelRegister("hNbjv", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationListRoute", () => $acf744aa66a83413$export$270e16f240db883b);
const $acf744aa66a83413$export$270e16f240db883b = {
    name: 'eoc-integration-list',
    path: '/jira/settings/products/ops/integrations/list',
    exact: true
};

});

parcelRegister("3cv8c", function(module, exports) {

$parcel$export(module.exports, "IntegrationList", () => $e524b7820b9b172f$export$955768269b79c203);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kEMby = parcelRequire("kEMby");
const $e524b7820b9b172f$export$955768269b79c203 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $kEMby.LazyIntegrationList),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });

});


parcelRegister("lcAQi", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationLogRouteEntry", () => $6535404a8c018f23$export$d30f51d0f351bd8a);

var $c4Buu = parcelRequire("c4Buu");

var $g9g6m = parcelRequire("g9g6m");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $7GYMz = parcelRequire("7GYMz");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

var $jNNfq = parcelRequire("jNNfq");

var $5pZel = parcelRequire("5pZel");

var $kEMby = parcelRequire("kEMby");
const $6535404a8c018f23$var$getNavigationSpecifications = ()=>{
    return (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $6535404a8c018f23$export$d30f51d0f351bd8a = (0, $7NszV.createEntry)((0, $7GYMz.globalIntegrationLogRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/settings/products/ops',
        component: (0, $jNNfq.IntegrationAutomation),
        slot: (0, $5pZel.IntegrationLog),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $c4Buu.resources)(),
            (0, $g9g6m.resources).configuredIntegrationsResource,
            (0, $g9g6m.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$6535404a8c018f23$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation)
        ]
    }));

});
parcelRegister("7GYMz", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationLogRoute", () => $69ab4fb51e1e7924$export$71884dc820e415fc);
const $69ab4fb51e1e7924$export$71884dc820e415fc = {
    name: 'eoc-integration-log',
    path: '/jira/settings/products/ops/integrations/:type/:integrationId/logs',
    exact: true
};

});

parcelRegister("5pZel", function(module, exports) {

$parcel$export(module.exports, "IntegrationLog", () => $62766cc40b0fef68$export$b545b4a4c4cee016);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kEMby = parcelRequire("kEMby");
const $62766cc40b0fef68$export$b545b4a4c4cee016 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $kEMby.LazyIntegrationLog),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });

});


parcelRegister("68ycU", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationsRouteEntry", () => $42b9c62ef769e46b$export$6e5cd6656076550f);

var $g9g6m = parcelRequire("g9g6m");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $eZXFU = parcelRequire("eZXFU");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $aVb3A = parcelRequire("aVb3A");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

var $kEMby = parcelRequire("kEMby");

var $jNNfq = parcelRequire("jNNfq");
const $42b9c62ef769e46b$var$getNavigationSpecifications = ()=>{
    return (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $42b9c62ef769e46b$export$6e5cd6656076550f = (0, $7NszV.createEntry)((0, $aVb3A.globalIntegrationsRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/settings/products/ops',
        component: (0, $jNNfq.IntegrationAutomation),
        slot: null,
        layout: (0, $eZXFU.opsSettingsLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $g9g6m.resources).configuredIntegrationsResource,
            (0, $g9g6m.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$42b9c62ef769e46b$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation)
        ]
    }));

});
parcelRegister("aVb3A", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationsRoute", () => $0fed354e3cd747e8$export$e196ff2390a1ec56);
const $0fed354e3cd747e8$export$e196ff2390a1ec56 = {
    name: 'eoc-integrations',
    path: '/jira/settings/products/ops/integrations',
    exact: true
};

});


parcelRegister("6HuHg", function(module, exports) {

$parcel$export(module.exports, "globalIssueNavigatorBrowseIssueRedirectRouteEntry", () => $87a1c7411057f7f3$export$30f8c1a53605b10b);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $53W5y = parcelRequire("53W5y");

var $1gXMV = parcelRequire("1gXMV");


var $8irO5 = parcelRequire("8irO5");

var $96TVI = parcelRequire("96TVI");

var $3uU6P = parcelRequire("3uU6P");

var $gGOoR = parcelRequire("gGOoR");

var $b8f12 = parcelRequire("b8f12");
const $87a1c7411057f7f3$export$30f8c1a53605b10b = (0, $7NszV.createEntry)((0, $53W5y.globalIssueNavigatorBrowseIssueRedirectRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$d0ad1160bb95ce50),
            reporting: (0, $3uU6P.getRouteReporting)()
        },
        component: (0, $gGOoR.default),
        skeleton: (0, $1gXMV.GlobalIssueNavigatorSkeleton),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $b8f12.LazyGlobalIssueNavigator)
        ],
        ufoName: 'global-issue-navigator-jfe',
        navigation: (0, $8irO5.getCommonGlobalNavigation)(),
        resources: [
            ...(0, $96TVI.getCommonGlobalResources)()
        ],
        layout: (0, $2BrOV.globalLayout)
    }));

});
parcelRegister("53W5y", function(module, exports) {

$parcel$export(module.exports, "globalIssueNavigatorBrowseIssueRedirectRoute", () => $2ca0ba87b3cf3506$export$34695dccebecc6bc);
const $2ca0ba87b3cf3506$export$34695dccebecc6bc = {
    name: 'global-issue-navigator-browse-issue-redirect',
    path: '/browse/:issueKey?',
    query: [
        'jql|filter'
    ]
};

});

parcelRegister("1gXMV", function(module, exports) {

$parcel$export(module.exports, "GlobalIssueNavigatorSkeleton", () => $c87e28c0f4513050$export$51681996374b2585);
/* global-app.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $QBpyl = parcelRequire("QBpyl");
const $c87e28c0f4513050$var$customCssStyles = null;
const $c87e28c0f4513050$export$51681996374b2585 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($QBpyl))),
        className: (0, $bwpsq.default)([
            "_2zz1zwfg _slt8zwfg _1od57vkz"
        ])
    });

});
parcelRegister("QBpyl", function(module, exports) {
module.exports = new URL("global-issue-navigator-skeleton.tpl.b1bf4b99.svg", import.meta.url).toString();

});


parcelRegister("8irO5", function(module, exports) {

$parcel$export(module.exports, "getCommonGlobalNavigation", () => $bc5e7fba327b7679$export$2f31f4f387017d83);

var $cSD7y = parcelRequire("cSD7y");

var $lmyls = parcelRequire("lmyls");

var $8Wi6S = parcelRequire("8Wi6S");
const $bc5e7fba327b7679$export$2f31f4f387017d83 = ()=>({
        menuId: (0, $lmyls.MENU_ID).FILTERS,
        sidebar: (0, $cSD7y.componentWithFG)('make_nav3_sidebar_lazyforpaint', (0, $8Wi6S.AsyncForPaintSidebarFiltersGlobal), (0, $8Wi6S.AsyncSidebarFiltersGlobal))
    });

});
parcelRegister("8Wi6S", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c9fa7b304f828b3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "AsyncSidebarFiltersGlobal", () => $7c9fa7b304f828b3$export$1af88ebe65f50e73);
$parcel$export(module.exports, "AsyncForPaintSidebarFiltersGlobal", () => $7c9fa7b304f828b3$export$7655c90db6341aa6);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

// Legacy GIN Sidebar
const $7c9fa7b304f828b3$var$LazySidebarFiltersLegacy = (0, $kxZPA.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("3hMyV")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/filters/src/index.tsx"
});
const $7c9fa7b304f828b3$var$AsyncSidebarFiltersLegacy = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "filters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c9fa7b304f828b3$var$LazySidebarFiltersLegacy, null)));
var $7c9fa7b304f828b3$export$2e2bcd8739ae039 = $7c9fa7b304f828b3$var$AsyncSidebarFiltersLegacy;

// Global-scope NIN sidebar
const $7c9fa7b304f828b3$var$LazyAfterPaintSidebarFiltersGlobal = (0, $kxZPA.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    // using direct path instead of `index` because webpack will combine multiple chunks from same file
    return (parcelRequire("hzPjy")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle.SidebarFiltersGlobal;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/filters/src/ui/global-scope/index.tsx"
});

const $7c9fa7b304f828b3$var$LazyForPaintSidebarFiltersGlobal = (0, $kxZPA.lazyForPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    // using direct path instead of `index` because webpack will combine multiple chunks from same file
    // eslint-disable-next-line jira/import/webpack-magic-comment-entries
    return (parcelRequire("hzPjy")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle.SidebarFiltersGlobal;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/filters/src/ui/global-scope/index.tsx"
});
const $7c9fa7b304f828b3$export$1af88ebe65f50e73 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "filters-global"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c9fa7b304f828b3$var$LazyAfterPaintSidebarFiltersGlobal, null)));
const $7c9fa7b304f828b3$export$7655c90db6341aa6 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "filters-global"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c9fa7b304f828b3$var$LazyForPaintSidebarFiltersGlobal, null)));

});
parcelRegister("3hMyV", function(module, exports) {

let $2648a11bd10abe27$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $2648a11bd10abe27$var$load("ffQaD"),
    $2648a11bd10abe27$var$load("kvRbA"),
    $2648a11bd10abe27$var$load("f324T")
]).then(()=>parcelRequire('7T8w9'));

});

parcelRegister("hzPjy", function(module, exports) {

let $ccbd828b2651a9b2$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ccbd828b2651a9b2$var$load("ffQaD"),
    $ccbd828b2651a9b2$var$load("kvRbA"),
    $ccbd828b2651a9b2$var$load("1QDPs")
]).then(()=>parcelRequire('hcPI1'));

});



parcelRegister("96TVI", function(module, exports) {

$parcel$export(module.exports, "getCommonGlobalResources", () => $546bc7982ebbd30d$export$343e92405307cf8d);

var $4R6GH = parcelRequire("4R6GH");

var $96w9D = parcelRequire("96w9D");

var $8CVvd = parcelRequire("8CVvd");

var $bATyw = parcelRequire("bATyw");

var $89kiv = parcelRequire("89kiv");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $gNStA = parcelRequire("gNStA");

var $lAGdd = parcelRequire("lAGdd");
const $546bc7982ebbd30d$export$343e92405307cf8d = ()=>[
        (0, $89kiv.issueNavigatorRelayResource),
        (0, $89kiv.issueNavigatorFilterRelayResource),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('nin_request_hydrate_query_earlier') && !(0, $4R6GH.fg)('render_jql_builder_in_ssr'), (0, $89kiv.issueNavigatorHydrationRelayResourceBrowserOnly)),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('render_jql_builder_in_ssr'), (0, $89kiv.issueNavigatorHydrationRelayResource)),
        ...(0, $3RJkv.getNavigationResources)(),
        (0, $atU1t.navigationSidebarGlobalResource),
        (0, $bATyw.isNinGlobalScopeEnrolmentEnabledResource),
        (0, $gNStA.resourceWithCondition2)((0, $8CVvd.getWillShowNav3), (0, $96w9D.sidebarFiltersGlobalResource)),
        ...(0, $lAGdd.getAIContextPanelResources)()
    ];

});
parcelRegister("96w9D", function(module, exports) {

$parcel$export(module.exports, "sidebarFiltersGlobalResource", () => $4afb52221e3a3f09$export$7e0b804085f0470d);

var $ao2h1 = parcelRequire("ao2h1");

var $gBXKh = parcelRequire("gBXKh");

var $6YG83 = parcelRequire("6YG83");
const $4afb52221e3a3f09$export$7e0b804085f0470d = (0, $6YG83.withGiraAggAnonSsrFix)((0, $ao2h1.createRelayResource)({
    type: 'NAVIGATION_SIDEBAR_FILTERS_GLOBAL',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $gBXKh.default),
            variables: {
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
}));

});
parcelRegister("gBXKh", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0f1ab872360a786$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4654bfdfd3e20081cf96674156c0485e>>
 * @relayHash b167c3924c240111eb2c04f5138be112
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 488e4e7ceb05d5d63726635de6bb578e2d4b52a4643ab9ca4393d1579b8d07f0

var $7vXy9 = parcelRequire("7vXy9");
const $a0f1ab872360a786$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v6 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            }
        ],
        "type": "JiraCustomFilter"
    }, v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "menuNavigationAppsSidebarFiltersGlobalScopeQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "starredFiltersList_navigationAppsSidebarCommon"
                            },
                            {
                                "args": v2 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "systemFilters_navigationAppsSidebarFilters_SystemFiltersSection"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "menuNavigationAppsSidebarFiltersGlobalScopeQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "isFavourite",
                                    "value": false
                                }
                            ],
                            "concreteType": "JiraSystemFilterConnection",
                            "kind": "LinkedField",
                            "name": "systemFilters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSystemFilterEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSystemFilter",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ],
                                                    "type": "JiraFilter",
                                                    "abstractKey": "__isJiraFilter"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "favouriteFilters",
                                    "args": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": {
                                                    "order": "DESC"
                                                },
                                                "type": "FILTER"
                                            }
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 15
                                        }
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v8 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v4 /*: any*/ 
                                                            ],
                                                            "type": "Node",
                                                            "abstractKey": "__isNode"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "favouriteFiltersOld",
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraFilterConnection",
                                    "kind": "LinkedField",
                                    "name": "favouriteFilters",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFilterEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "TypeDiscriminator",
                                                            "abstractKey": "__isJiraFilter"
                                                        },
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "488e4e7ceb05d5d63726635de6bb578e2d4b52a4643ab9ca4393d1579b8d07f0",
            "metadata": {},
            "name": "menuNavigationAppsSidebarFiltersGlobalScopeQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider": (0, $7vXy9.default)
            }
        }
    };
}();
$a0f1ab872360a786$var$node.hash = "b5467e25277d67ce676aa25dd3a16377";
var $a0f1ab872360a786$export$2e2bcd8739ae039 = $a0f1ab872360a786$var$node;

});
parcelRegister("7vXy9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ac90445fe2bfbc0$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $3ac90445fe2bfbc0$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('add_limit_to_nav3_starred_filter_sidebar');
    }
};

});



parcelRegister("bATyw", function(module, exports) {

$parcel$export(module.exports, "isNinGlobalScopeEnrolmentEnabledResource", () => $a818348721ae6866$export$3f6390b4131d761b);

var $2M1hQ = parcelRequire("2M1hQ");

const $a818348721ae6866$var$getDataLoader = ()=>(parcelRequire("jyZ5j"));
const $a818348721ae6866$export$3f6390b4131d761b = (0, $2M1hQ.createResource)({
    type: 'NIN_GLOBAL_SCOPE_ENROLMENT_RESOURCE',
    getKey: ()=>'ninGlobalScopeEnrolment',
    getDataLoader: $a818348721ae6866$var$getDataLoader
});

});
parcelRegister("jyZ5j", function(module, exports) {

let $e3e0936d37a0ceb5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e3e0936d37a0ceb5$var$load("7etJl").then(()=>parcelRequire('dIecw'));

});


parcelRegister("89kiv", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorRelayResource", () => $93f22f98fd07bff0$export$b4096f516fb93159);
$parcel$export(module.exports, "issueNavigatorFilterRelayResource", () => $93f22f98fd07bff0$export$44ca3a0b25f38d83);
$parcel$export(module.exports, "issueNavigatorHydrationRelayResource", () => $93f22f98fd07bff0$export$967ef0cfbd1cc946);
$parcel$export(module.exports, "issueNavigatorHydrationRelayResourceBrowserOnly", () => $93f22f98fd07bff0$export$2c98f9cf5d4c493e);
/* eslint-disable jira/import-whitelist */ 
var $8Uumt = parcelRequire("8Uumt");

var $6oLWS = parcelRequire("6oLWS");

var $6s1PB = parcelRequire("6s1PB");

var $9Nvh7 = parcelRequire("9Nvh7");

var $6UAdF = parcelRequire("6UAdF");

var $eJ0Zs = parcelRequire("eJ0Zs");

var $j25AL = parcelRequire("j25AL");

var $dXq4S = parcelRequire("dXq4S");

var $5yJb9 = parcelRequire("5yJb9");

var $kipqU = parcelRequire("kipqU");

var $ao2h1 = parcelRequire("ao2h1");

var $16Yit = parcelRequire("16Yit");

var $kvekU = parcelRequire("kvekU");

var $hTvlq = parcelRequire("hTvlq");

var $2M1hQ = parcelRequire("2M1hQ");

var $4R6GH = parcelRequire("4R6GH");

var $5cSAN = parcelRequire("5cSAN");

var $5bSAg = parcelRequire("5bSAg");

var $aBKbA = parcelRequire("aBKbA");
const $93f22f98fd07bff0$export$b4096f516fb93159 = (0, $2M1hQ.createResource)({
    type: `${(0, $ao2h1.RELAY_RESOURCE_TYPE)}_${(0, $5bSAg.RESOURCE_TYPE_ISSUE_NAVIGATOR_RELAY)}`,
    getKey: ()=>'issue-navigator-relay',
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        const { projectKey: projectKey, issueKey: issueKey, jql: jqlParam, defaultJql: defaultJql, filter: filter } = (0, $aBKbA.getParams)(routerContext);
        const jqlOrFilterId = (0, $aBKbA.getJqlOrFilterId)(defaultJql, jqlParam, filter, projectKey);
        const maxIssuesPerPage = (0, $6UAdF.getMaxIssuesPerPage)();
        const chromelessRoute = (0, $aBKbA.isChromelessRoute)(routerContext) && (0, $4R6GH.fg)('jira_nin_smart_link');
        let viewId;
        let shouldQueryConditionalFormatting = Boolean(projectKey);
        const filterId = Boolean(filter) && (0, $9Nvh7.isCustomFilter)(filter) ? filter : null;
        if (chromelessRoute && (0, $4R6GH.fg)('jira_nin_smart_link')) {
            // Disable conditional formatting for chromeless (i.e. embed) routes
            shouldQueryConditionalFormatting = false;
            // Explicitly load list view for chromeless (i.e. embed) routes
            viewId = filterId ? (0, $eJ0Zs.convertFilterIdToIssueNavigatorId)(filterId) : 'list_default';
        }
        const viewConfigInput = projectKey !== undefined && projectKey !== null ? {
            viewInput: {
                namespace: (0, $6UAdF.ISSUE_SEARCH_NAMESPACE)
            }
        } : {
            staticViewInput: {
                isHierarchyEnabled: false,
                isGroupingEnabled: false,
                isHideDoneEnabled: false
            }
        };
        const staticViewInput = projectKey === undefined || projectKey === null ? {
            isHierarchyEnabled: false,
            isGroupingEnabled: false,
            isHideDoneEnabled: false
        } : undefined;
        let viewQueryInput;
        if ((0, $4R6GH.fg)('saved_list_view_technical_changes')) viewQueryInput = projectKey == null ? {
            viewAri: (0, $5cSAN.createViewAri)({
                activationId: tenantContext.activationId,
                cloudId: tenantContext.cloudId
            })
        } : {
            projectKeyAndItemIdQuery: {
                cloudId: tenantContext.cloudId,
                projectKey: projectKey,
                itemId: routerContext.match.params.itemId ?? ''
            }
        };
        let operationScope;
        if ((0, $6s1PB.expVal)('jira_inline_field_config', 'isInlineFieldConfigEnabled', false)) operationScope = (0, $j25AL.getOperationScope)(projectKey);
        else if (projectKey) operationScope = (0, $6UAdF.NIN_PROJECT_OPERATION_SCOPE);
        else operationScope = (0, $6UAdF.NIN_GLOBAL_OPERATION_SCOPE);
        const variables = {
            cloudId: tenantContext.cloudId,
            first: issueKey == null ? maxIssuesPerPage : null,
            issueSearchInput: jqlOrFilterId,
            namespace: (0, $6UAdF.ISSUE_SEARCH_NAMESPACE),
            fieldSetsInput: {
                viewInput: {
                    namespace: (0, $6UAdF.ISSUE_SEARCH_NAMESPACE),
                    filterId: filterId,
                    viewId: viewId
                }
            },
            after: null,
            options: {
                issueKey: issueKey
            },
            filterId: filterId,
            amountOfColumns: (0, $6UAdF.MAX_AMOUNT_OF_COLUMNS),
            shouldQueryHasChildren: projectKey !== null && projectKey !== undefined && (0, $6s1PB.expVal)('jsc_m2_hierarchy', 'isHierarchyEnabled', false),
            ...(0, $4R6GH.fg)('jsc_nin_operation_scope_fe') && {
                scope: {
                    operationScope: operationScope,
                    ...projectKey && (0, $6s1PB.expVal)('jira_inline_field_config', 'isInlineFieldConfigEnabled', false) ? {
                        projectKey: projectKey
                    } : {}
                }
            },
            ...(0, $6s1PB.expVal)('jsc_m2_hierarchy', 'isHierarchyEnabled', false) && {
                viewConfigInput: viewConfigInput
            },
            staticViewInput: staticViewInput,
            ...(0, $4R6GH.fg)('saved_list_view_technical_changes') && {
                viewQueryInput: viewQueryInput
            },
            atlassianIntelligenceProductFeature: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $6UAdF.NATURAL_LANGUAGE_TO_JQL),
            projectKey: projectKey ?? '',
            shouldQueryProject: Boolean(projectKey) && ((0, $6s1PB.expVal)('jira_list_realtime_updates_with_queue', 'isEnabled', false) || (0, $6s1PB.expVal)('jsc_m2_hierarchy', 'isHierarchyEnabled', false) || (0, $4R6GH.fg)('saved_list_view_technical_changes')),
            shouldQueryConditionalFormatting: shouldQueryConditionalFormatting && (0, $6s1PB.expVal)('conditional_formatting_in_new_list', 'isEnabled', false),
            groupBy: null,
            ...projectKey && (0, $6s1PB.expVal)('jira_inline_field_config', 'isInlineFieldConfigEnabled', false) && {
                fieldSetsScope: {
                    operationScope: operationScope,
                    projectKey: projectKey
                }
            },
            viewId: viewId
        };
        const queryReference = (0, $8Uumt.loadQuery)((0, $5yJb9.default)(), (0, $hTvlq.default), variables, {
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        });
        if (false && queryReference.id != null) await (0, $kipqU.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});
const $93f22f98fd07bff0$export$44ca3a0b25f38d83 = (0, $2M1hQ.createResource)({
    type: `${(0, $ao2h1.RELAY_RESOURCE_TYPE)}_${(0, $5bSAg.RESOURCE_TYPE_ISSUE_NAVIGATOR_FILTER_RELAY)}`,
    getKey: ()=>'issue-navigator-filter-relay',
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        const { filter: filter } = (0, $aBKbA.getParams)(routerContext);
        const includeFilter = Boolean(filter) && (0, $9Nvh7.isFilterId)(filter);
        const variables = {
            includeFilter: includeFilter,
            filterAri: includeFilter ? (0, $dXq4S.createAri)({
                resourceOwner: 'jira',
                cloudId: tenantContext.cloudId,
                resourceType: 'filter',
                resourceId: filter,
                activationId: tenantContext.activationId
            }) : ''
        };
        const options = {
            fetchPolicy: includeFilter ? 'network-only' : 'store-only'
        };
        const queryReference = (0, $8Uumt.loadQuery)((0, $5yJb9.default)(), (0, $kvekU.default), variables, options);
        if (false && queryReference.id != null) await (0, $kipqU.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});
const $93f22f98fd07bff0$export$967ef0cfbd1cc946 = (0, $2M1hQ.createResource)({
    type: `${(0, $ao2h1.RELAY_RESOURCE_TYPE)}_${(0, $5bSAg.RESOURCE_TYPE_ISSUE_NAVIGATOR_HYDRATION_RELAY)}`,
    getKey: ()=>'issue-navigator-hydration-relay',
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        const { projectKey: projectKey, jql: jqlParam, defaultJql: defaultJql, filter: filter } = (0, $aBKbA.getParams)(routerContext);
        const jqlOrFilterId = (0, $aBKbA.getJqlOrFilterId)(defaultJql, jqlParam, filter, projectKey);
        // eslint-disable-next-line jira/ff/inline-usage
        const variables = {
            accountId: tenantContext.atlassianAccountId ?? '',
            cloudId: tenantContext.cloudId,
            includeUser: true,
            includeJira: true,
            isFilter: 'filterId' in jqlOrFilterId,
            jql: 'jql' in jqlOrFilterId && jqlOrFilterId.jql || '',
            filterAri: 'filterId' in jqlOrFilterId && (0, $6oLWS.JiraFilterAri).create({
                siteId: tenantContext.cloudId,
                filterId: filter,
                activationId: tenantContext.activationId
            }).toString() || '',
            viewContext: null,
            isPlanReleaseFeatureToggleEnabled: (0, $4R6GH.fg)('simple-plans-m2-release-feature-toggle')
        };
        const queryReference = (0, $8Uumt.loadQuery)((0, $5yJb9.default)(), (0, $16Yit.default), variables, {
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        });
        if (false && queryReference.id != null) await (0, $kipqU.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});
const $93f22f98fd07bff0$export$2c98f9cf5d4c493e = (0, $2M1hQ.createResource)({
    type: `${(0, $ao2h1.RELAY_RESOURCE_TYPE)}_${(0, $5bSAg.RESOURCE_TYPE_ISSUE_NAVIGATOR_HYDRATION_RELAY)}_BROWSER_ONLY`,
    getKey: ()=>'issue-navigator-hydration-relay-browser-only',
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        const { projectKey: projectKey, jql: jqlParam, defaultJql: defaultJql, filter: filter } = (0, $aBKbA.getParams)(routerContext);
        const jqlOrFilterId = (0, $aBKbA.getJqlOrFilterId)(defaultJql, jqlParam, filter, projectKey);
        // eslint-disable-next-line jira/ff/inline-usage
        const variables = {
            accountId: tenantContext.atlassianAccountId ?? '',
            cloudId: tenantContext.cloudId,
            includeUser: true,
            includeJira: true,
            isFilter: 'filterId' in jqlOrFilterId,
            jql: 'jql' in jqlOrFilterId && jqlOrFilterId.jql || '',
            filterAri: 'filterId' in jqlOrFilterId && (0, $6oLWS.JiraFilterAri).create({
                siteId: tenantContext.cloudId,
                filterId: filter,
                activationId: tenantContext.activationId
            }).toString() || '',
            viewContext: null,
            isPlanReleaseFeatureToggleEnabled: (0, $4R6GH.fg)('simple-plans-m2-release-feature-toggle')
        };
        const queryReference = (0, $8Uumt.loadQuery)((0, $5yJb9.default)(), (0, $16Yit.default), variables, {
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        });
        if (false && queryReference.id != null) await (0, $kipqU.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0,
    isBrowserOnly: true
});

});
parcelRegister("9Nvh7", function(module, exports) {

$parcel$export(module.exports, "isCustomFilter", () => $08e78f523b28c02b$export$31180e7f1db565e5);
$parcel$export(module.exports, "isFilterId", () => $08e78f523b28c02b$export$23be85030bd58047);
const $08e78f523b28c02b$export$31180e7f1db565e5 = (filterId)=>/^\d+$/.test(filterId);
const $08e78f523b28c02b$export$887fa95a5a5cf197 = (filterId)=>/^-\d+$/.test(filterId);
const $08e78f523b28c02b$export$23be85030bd58047 = (value)=>value !== undefined && /^-?\d+$/.test(value);

});

parcelRegister("6UAdF", function(module, exports) {

$parcel$export(module.exports, "sortDirections", () => $8e65b6d66c73d810$export$73034536b9adc928);
$parcel$export(module.exports, "FilterTypes", () => $8e65b6d66c73d810$export$ad2e3f13451a5d44);
$parcel$export(module.exports, "SearchInputTypes", () => $8e65b6d66c73d810$export$75a31bc7c097ba4b);
$parcel$export(module.exports, "views", () => $8e65b6d66c73d810$export$d0079916fe6800ac);
$parcel$export(module.exports, "defaultOrderFields", () => $8e65b6d66c73d810$export$2bd49f8f262d7cbb);
$parcel$export(module.exports, "ISSUE_SEARCH_NAMESPACE", () => $8e65b6d66c73d810$export$de2495608df10495);
$parcel$export(module.exports, "DEFAULT_ORDER_FIELD", () => $8e65b6d66c73d810$export$393cb330f31d305c);
$parcel$export(module.exports, "DEFAULT_SORT_DIRECTION", () => $8e65b6d66c73d810$export$8ea18fa9e35fdf25);
$parcel$export(module.exports, "DEFAULT_VIEW_ID", () => $8e65b6d66c73d810$export$500b5c379b5c7f2e);
$parcel$export(module.exports, "MAX_ISSUES_PER_PAGE", () => $8e65b6d66c73d810$export$f88f58d1a4b2078b);
$parcel$export(module.exports, "getMaxIssuesPerPage", () => $8e65b6d66c73d810$export$8c67ad1f64ab5a9c);
$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $8e65b6d66c73d810$export$f7109619a5e9e0d6);
$parcel$export(module.exports, "PACKAGE_NAME", () => $8e65b6d66c73d810$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $8e65b6d66c73d810$export$d57b6b390e78d90f);
$parcel$export(module.exports, "EXPERIENCE_NAME", () => $8e65b6d66c73d810$export$52919046b94109dc);
$parcel$export(module.exports, "GROUPED_LIST_EXPERIENCE_ID", () => $8e65b6d66c73d810$export$88890124f795113d);
$parcel$export(module.exports, "ANALYTICS_LIST_VIEW_SOURCE_NAME", () => $8e65b6d66c73d810$export$81d9767bc5c1549e);
$parcel$export(module.exports, "ANALYTICS_DETAIL_VIEW_SOURCE_NAME", () => $8e65b6d66c73d810$export$524ae4278a57eea2);
$parcel$export(module.exports, "MAX_AMOUNT_OF_COLUMNS", () => $8e65b6d66c73d810$export$608eeb3a32afef02);
$parcel$export(module.exports, "COLUMN_TYPE_EPIC_LINK", () => $8e65b6d66c73d810$export$ce9e2d7c178a9557);
$parcel$export(module.exports, "COLUMN_TYPE_PARENT_LINK", () => $8e65b6d66c73d810$export$1adf7afff96bbf16);
$parcel$export(module.exports, "NATURAL_LANGUAGE_TO_JQL", () => $8e65b6d66c73d810$export$55628b4c44d1522a);
$parcel$export(module.exports, "NIN_PROJECT_OPERATION_SCOPE", () => $8e65b6d66c73d810$export$fae6afe554014a45);
$parcel$export(module.exports, "NIN_GLOBAL_OPERATION_SCOPE", () => $8e65b6d66c73d810$export$39ec48f092f3ea90);
$parcel$export(module.exports, "NIN_PROJECT_SHADOW_REQUEST_OPERATION_SCOPE", () => $8e65b6d66c73d810$export$2c213b805a8379cf);
$parcel$export(module.exports, "NIN_SIDEBAR_SCOPE", () => $8e65b6d66c73d810$export$adc96a79a4445d56);
$parcel$export(module.exports, "ISSUE_NAVIGATOR_SIDEBAR_ID", () => $8e65b6d66c73d810$export$6c35abbca3056365);
$parcel$export(module.exports, "ALL_COLUMNS_ID", () => $8e65b6d66c73d810$export$eb85a4c9b5d9ce7b);
$parcel$export(module.exports, "supportedOrderFields", () => $8e65b6d66c73d810$export$3630aa1c4c69277f);
$parcel$export(module.exports, "getSupportedFieldForAlias", () => $8e65b6d66c73d810$export$eaadab3243bf458);
$parcel$export(module.exports, "isJiraIssueSearchViewMetadata", () => $8e65b6d66c73d810$export$f40fffea1f8469ac);
$parcel$export(module.exports, "isJiraSpreadsheetView", () => $8e65b6d66c73d810$export$2627fa464eafde69);

var $czfFt = parcelRequire("czfFt");
const $8e65b6d66c73d810$export$73034536b9adc928 = {
    ASC: 'ASC',
    DESC: 'DESC',
    NONE: 'NONE'
};
const $8e65b6d66c73d810$export$ad2e3f13451a5d44 = {
    ID: 'filterId',
    JQL: 'filterJql'
};
const $8e65b6d66c73d810$export$75a31bc7c097ba4b = {
    JQL: 'jql',
    FILTER: 'filter',
    FILTER_AND_JQL: 'filterAndJql'
};
const $8e65b6d66c73d810$export$d0079916fe6800ac = {
    list: 'list-view',
    detail: 'split-view'
};
const $8e65b6d66c73d810$export$2bd49f8f262d7cbb = {
    created: 'created',
    lastviewed: 'lastviewed',
    updated: 'updated'
};
const $8e65b6d66c73d810$export$de2495608df10495 = 'ISSUE_NAVIGATOR';
const $8e65b6d66c73d810$export$393cb330f31d305c = $8e65b6d66c73d810$export$2bd49f8f262d7cbb.created;
const $8e65b6d66c73d810$export$8ea18fa9e35fdf25 = $8e65b6d66c73d810$export$73034536b9adc928.DESC;
const $8e65b6d66c73d810$export$500b5c379b5c7f2e = 'list_default';
const $8e65b6d66c73d810$export$f88f58d1a4b2078b = 50;
const $8e65b6d66c73d810$export$8c67ad1f64ab5a9c = ()=>$8e65b6d66c73d810$export$f88f58d1a4b2078b;
const $8e65b6d66c73d810$export$f7109619a5e9e0d6 = 'issue-navigator-next';
const $8e65b6d66c73d810$export$b8b9d90f9e5bd72b = 'jiraIssueNavigator';
const $8e65b6d66c73d810$export$d57b6b390e78d90f = 'empanada';
const $8e65b6d66c73d810$export$52919046b94109dc = 'showPinIssueList';
const $8e65b6d66c73d810$export$88890124f795113d = 'groupedList';
const $8e65b6d66c73d810$export$81d9767bc5c1549e = 'issueNavigatorListView';
const $8e65b6d66c73d810$export$524ae4278a57eea2 = 'issueNavigatorDetailView';
const $8e65b6d66c73d810$export$af225181779390f4 = 'list_default';
const $8e65b6d66c73d810$export$608eeb3a32afef02 = (0, $czfFt.MAX_COLUMNS);
const $8e65b6d66c73d810$export$ce9e2d7c178a9557 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $8e65b6d66c73d810$export$1adf7afff96bbf16 = 'com.atlassian.jpo:jpo-custom-field-parent';
const $8e65b6d66c73d810$export$55628b4c44d1522a = 'NATURAL_LANGUAGE_TO_JQL';
const $8e65b6d66c73d810$export$fae6afe554014a45 = 'NIN_PROJECT';
const $8e65b6d66c73d810$export$39ec48f092f3ea90 = 'NIN_GLOBAL';
const $8e65b6d66c73d810$export$2c213b805a8379cf = 'NIN_PROJECT_SHADOW_REQUEST';
const $8e65b6d66c73d810$export$adc96a79a4445d56 = 'NIN_SIDEBAR';
const $8e65b6d66c73d810$export$6c35abbca3056365 = 'IssueNavigator';
const $8e65b6d66c73d810$export$eb85a4c9b5d9ce7b = 'all-columns';
const $8e65b6d66c73d810$export$3630aa1c4c69277f = {
    created: {
        jqlTerm: 'created',
        fieldType: 'created',
        aliases: []
    },
    key: {
        jqlTerm: 'key',
        fieldType: 'issuekey',
        aliases: [
            'issuekey'
        ]
    },
    lastviewed: {
        jqlTerm: 'lastviewed',
        fieldType: 'lastviewed',
        aliases: []
    },
    priority: {
        jqlTerm: 'priority',
        fieldType: 'priority',
        aliases: []
    },
    resolved: {
        jqlTerm: 'resolved',
        fieldType: 'resolutiondate',
        aliases: []
    },
    status: {
        jqlTerm: 'status',
        fieldType: 'status',
        aliases: []
    },
    updated: {
        jqlTerm: 'updated',
        fieldType: 'updated',
        aliases: []
    },
    issuetype: {
        jqlTerm: 'issuetype',
        fieldType: 'issuetype',
        aliases: [
            'type'
        ]
    },
    assignee: {
        jqlTerm: 'assignee',
        fieldType: 'assignee',
        aliases: []
    },
    duedate: {
        jqlTerm: 'duedate',
        fieldType: 'duedate',
        aliases: []
    },
    reporter: {
        jqlTerm: 'reporter',
        fieldType: 'reporter',
        aliases: []
    },
    summary: {
        jqlTerm: 'summary',
        fieldType: 'summary',
        aliases: []
    }
};
const $8e65b6d66c73d810$export$eaadab3243bf458 = (alias)=>Object.keys($8e65b6d66c73d810$export$3630aa1c4c69277f).find((key)=>$8e65b6d66c73d810$export$3630aa1c4c69277f[key]?.aliases.includes(alias));
const $8e65b6d66c73d810$export$f40fffea1f8469ac = (data)=>[
        'JiraIssueSearchView',
        'JiraDetailedView',
        'JiraListView',
        'JiraGroupedListView'
    ].includes(data.__typename);
const $8e65b6d66c73d810$export$2627fa464eafde69 = (data)=>[
        'JiraListView',
        'JiraGroupedListView'
    ].includes(data.__typename);

});

parcelRegister("eJ0Zs", function(module, exports) {

$parcel$export(module.exports, "createRememoizeSelector", () => $945e9d040796364e$export$982d75deeca693ef);
$parcel$export(module.exports, "isNormalClick", () => $945e9d040796364e$export$729f3684d5c2b9b9);
$parcel$export(module.exports, "isNonNullish", () => $945e9d040796364e$export$70573498ee17fe1d);
$parcel$export(module.exports, "parseIssueNavigatorViewIdOrDefault", () => $945e9d040796364e$export$ad0c80ba9128e83a);
$parcel$export(module.exports, "isFilterViewId", () => $945e9d040796364e$export$194f1a1e890054c9);
$parcel$export(module.exports, "convertToIssueNavigatorId", () => $945e9d040796364e$export$6ce707b3eccb341d);
$parcel$export(module.exports, "convertToView", () => $945e9d040796364e$export$95ef66082092aa68);
$parcel$export(module.exports, "convertFilterIdToIssueNavigatorId", () => $945e9d040796364e$export$ec4f6e9ea23bb55d);
$parcel$export(module.exports, "exclusiveGroupResultsOrIssueResultsFragment", () => $945e9d040796364e$export$1dde85fc919cd8db);

var $dGvGJ = parcelRequire("dGvGJ");

var $6UAdF = parcelRequire("6UAdF");
const $945e9d040796364e$export$982d75deeca693ef = (0, $dGvGJ.createSelectorCreator)((0, $dGvGJ.defaultMemoize), // @ts-expect-error - TS2339 - Property '_rememoize' does not exist on type 'T'. | TS2339 - Property '_rememoize' does not exist on type 'T'.
(a, b)=>a._rememoize === b._rememoize);
const $945e9d040796364e$export$729f3684d5c2b9b9 = (e)=>!(e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
function $945e9d040796364e$var$isPossibleValueEntry(entry) {
    return typeof entry[1] === 'string' || typeof entry[1] === 'number' || Array.isArray(entry[1]) && entry[1].length > 0;
}
const $945e9d040796364e$export$20fba0bc14771b28 = (state)=>{
    const definedEntries = Object.entries(state).filter($945e9d040796364e$var$isPossibleValueEntry);
    return definedEntries.map((entry)=>({
            key: entry[0],
            value: Array.isArray(entry[1]) ? entry[1].map((values)=>values.value) : entry[1]
        }));
};
const $945e9d040796364e$export$6256478a5735e738 = (state)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(state).reduce((acc, key)=>{
        const value = state[key];
        if (key === 'search') {
            if (typeof value !== 'string') throw new Error('Unexpected non-string literal for search.');
            acc[key] = value;
        } else if (Array.isArray(value)) acc[key] = value.map((values)=>values.value);
        else if (typeof value === 'string' || typeof value === 'undefined') acc[key] = value || [];
        else acc[key] = value;
        return acc;
    }, {});
const $945e9d040796364e$export$28dade55d1b3964b = (viewId)=>viewId === 'detail' ? (0, $6UAdF.views).detail : (0, $6UAdF.views).list;
const $945e9d040796364e$export$587f73d78d2a7579 = (viewMode)=>viewMode === (0, $6UAdF.views).detail ? 'detail' : 'list_default';
const $945e9d040796364e$export$5786a571e562003d = (viewMode)=>viewMode === (0, $6UAdF.views).detail ? 'DETAIL' : 'LIST';
function $945e9d040796364e$export$70573498ee17fe1d(value) {
    return value != null;
}
const $945e9d040796364e$export$ad0c80ba9128e83a = (viewId, defaultValue = 'list_default')=>{
    if (!viewId) return defaultValue;
    switch(viewId){
        case 'list_default':
            return 'list_default';
        case 'list_system':
            return 'list_system';
        case 'detail':
            return 'detail';
        default:
            if ($945e9d040796364e$export$194f1a1e890054c9(viewId)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return viewId;
            return defaultValue;
    }
};
const $945e9d040796364e$export$194f1a1e890054c9 = (viewId)=>/^list_filter_\d+$/.test(viewId);
const $945e9d040796364e$export$6ce707b3eccb341d = (view)=>view === (0, $6UAdF.views).detail ? 'detail' : 'list_default';
const $945e9d040796364e$export$95ef66082092aa68 = (issueNavigatorViewId)=>issueNavigatorViewId === 'detail' ? (0, $6UAdF.views).detail : (0, $6UAdF.views).list;
const $945e9d040796364e$export$ec4f6e9ea23bb55d = (filterId)=>{
    if (typeof filterId === 'number') return `list_filter_${filterId}`;
    const filterIdInt = Number(filterId);
    if (Number.isNaN(filterIdInt)) throw new Error('filterId is invalid');
    return `list_filter_${filterIdInt}`;
};
function $945e9d040796364e$export$1dde85fc919cd8db({ groupResults: groupResults, issueResults: issueResults }) {
    if (issueResults) return {
        groupResults: null,
        issueResults: issueResults
    };
    if (groupResults) return {
        groupResults: groupResults,
        issueResults: null
    };
    return null;
}

});

parcelRegister("j25AL", function(module, exports) {

$parcel$export(module.exports, "getOperationScope", () => $d5ba595a67a7fccb$export$93ef6e0525bce59d);

var $65VLO = parcelRequire("65VLO");
const $d5ba595a67a7fccb$export$93ef6e0525bce59d = (projectKey)=>{
    let operationScope;
    if (projectKey != null) operationScope = (0, $65VLO.NIN_PROJECT_OPERATION_SCOPE);
    else operationScope = (0, $65VLO.NIN_GLOBAL_OPERATION_SCOPE);
    return operationScope;
};

});

parcelRegister("16Yit", function(module, exports) {

$parcel$export(module.exports, "default", () => $296a6f030570708c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<20dd45111f8c1ba187120575aa2cdcc0>>
 * @relayHash e8f98055e5741882d770ae3f9d601043
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6ce9d09660428bd26bc6bab008de01d9b128040aa45b6652f1bca1729f0d9064
const $296a6f030570708c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeJira"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeUser"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isFilter"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isPlanReleaseFeatureToggleEnabled"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewContext"
    }, v10 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v11 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
    }, v12 = {
        "kind": "Variable",
        "name": "viewContext",
        "variableName": "viewContext"
    }, v13 = [
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "jql"
        },
        v11 /*: any*/ ,
        v12 /*: any*/ 
    ], v14 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v15 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v16 = [
        v14 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v15 /*: any*/ 
            ],
            "type": "JiraJqlHydratedQuery"
        }
    ], v17 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "filterAri"
        },
        v11 /*: any*/ ,
        v12 /*: any*/ 
    ], v18 = {
        "kind": "ScalarField",
        "name": "id"
    }, v19 = [
        v14 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "picture"
        },
        v18 /*: any*/ 
    ], v20 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v21 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v22 = {
        "kind": "ScalarField",
        "name": "key"
    }, v23 = [
        {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "colorName"
                },
                v18 /*: any*/ 
            ]
        }
    ], v24 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v25 = [
        v14 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v15 /*: any*/ ,
                {
                    "kind": "LinkedField",
                    "name": "fields",
                    "plural": true,
                    "selections": [
                        v14 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v20 /*: any*/ ,
                                {
                                    "concreteType": "JiraJqlField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v21 /*: any*/ ,
                                        {
                                            "concreteType": "JiraJqlSearchTemplate",
                                            "kind": "LinkedField",
                                            "name": "searchTemplate",
                                            "plural": false,
                                            "selections": [
                                                v22 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "shouldShowInContext"
                                        },
                                        {
                                            "condition": "isPlanReleaseFeatureToggleEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": [
                                                        v11 /*: any*/ 
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "shouldExcludeInScope"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "description"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "operators"
                                        },
                                        {
                                            "concreteType": "JiraFieldType",
                                            "kind": "LinkedField",
                                            "name": "fieldType",
                                            "plural": false,
                                            "selections": [
                                                v21 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "values",
                                    "plural": true,
                                    "selections": [
                                        v14 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v20 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "values",
                                                    "plural": true,
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraProject",
                                                                    "kind": "LinkedField",
                                                                    "name": "project",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v22 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "small"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v18 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlProjectFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v23 /*: any*/ ,
                                                            "type": "JiraJqlStatusFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v23 /*: any*/ ,
                                                            "type": "JiraJqlStatusCategoryFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "xsmall"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v18 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueTypeFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": v19 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraJqlUserFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraPriority",
                                                                    "kind": "LinkedField",
                                                                    "name": "priority",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "iconUrl"
                                                                        },
                                                                        v18 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlPriorityFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "issue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v14 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "text"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                },
                                                                                                v18 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v18 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprint",
                                                                    "kind": "LinkedField",
                                                                    "name": "sprint",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "state"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "boardName"
                                                                        },
                                                                        v18 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlSprintFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v24 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraJqlCascadingOptionFieldValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentOption",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v21 /*: any*/ ,
                                                                        v20 /*: any*/ ,
                                                                        v24 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlCascadingOptionFieldValue"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlQueryHydratedValue"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v20 /*: any*/ ,
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "error",
                                                    "plural": false,
                                                    "selections": [
                                                        v14 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlQueryHydratedError"
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraJqlQueryHydratedField"
                        }
                    ]
                }
            ],
            "type": "JiraJqlHydratedQuery"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ],
            "type": "QueryError"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "hydrateJqlBuilderQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ui_jqlBuilder_JQLBuilderUI_hydrationQueryData"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "useHydratedValues"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "jqlEditor_jqlBuilderBasic_JQLEditorUI"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "useQuery"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "useHydratedValues_cascadeSelectPicker"
                },
                {
                    "condition": "includeJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "JiraJqlBuilder",
                                    "kind": "LinkedField",
                                    "name": "jqlBuilder",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "condition": "isFilter",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "args": v13 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "hydrateJqlQuery",
                                                    "plural": false,
                                                    "selections": v16 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isFilter",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": v17 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "hydrateJqlQueryForFilter",
                                                    "plural": false,
                                                    "selections": v16 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v7 /*: any*/ ,
                v9 /*: any*/ ,
                v8 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "hydrateJqlBuilderQuery",
            "selections": [
                {
                    "condition": "includeUser",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "accountId",
                                    "variableName": "accountId"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": v19 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "includeJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "JiraJqlBuilder",
                                    "kind": "LinkedField",
                                    "name": "jqlBuilder",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "condition": "isFilter",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "args": v13 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "hydrateJqlQuery",
                                                    "plural": false,
                                                    "selections": v25 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isFilter",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": v17 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "hydrateJqlQueryForFilter",
                                                    "plural": false,
                                                    "selections": v25 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6ce9d09660428bd26bc6bab008de01d9b128040aa45b6652f1bca1729f0d9064",
            "metadata": {},
            "name": "hydrateJqlBuilderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$296a6f030570708c$var$node.hash = "30fd8badf71c8e43e13c94db5bb98b42";
var $296a6f030570708c$export$2e2bcd8739ae039 = $296a6f030570708c$var$node;

});

parcelRegister("kvekU", function(module, exports) {

$parcel$export(module.exports, "default", () => $d76682723f87707c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1c0dc4a342f4ce5786fbe069292419e8>>
 * @relayHash 4722fbdc72716192181bb0830d738d17
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b9373e4d70177ba3d0d672c65e67a2165b4a0d774802f56dbef66239dd52c8e5
const $d76682723f87707c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeFilter"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "main_FilterQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigator_filterQuery"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "main_FilterQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "includeFilter",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "filterAri"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isJiraFilter"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEditable"
                                                }
                                            ],
                                            "type": "JiraCustomFilter"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "filterId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isFavourite"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b9373e4d70177ba3d0d672c65e67a2165b4a0d774802f56dbef66239dd52c8e5",
            "metadata": {},
            "name": "main_FilterQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d76682723f87707c$var$node.hash = "181bb07a6bafd05a2033750384a06766";
var $d76682723f87707c$export$2e2bcd8739ae039 = $d76682723f87707c$var$node;

});

parcelRegister("hTvlq", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff9dfb30fc1873c4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3b7160d789c9493f1bfb087ee5881aef>>
 * @relayHash b6742ef92027937cd2784e34a7a26555
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 153407de5ca4e1ced91ee9ec4084e2a660acb50a392391bbd13c261b0bedcd42

var $cNAof = parcelRequire("cNAof");

var $bqIzm = parcelRequire("bqIzm");

var $fjldt = parcelRequire("fjldt");

var $gY76A = parcelRequire("gY76A");

var $5ykrX = parcelRequire("5ykrX");

var $1xxk0 = parcelRequire("1xxk0");

var $c5npJ = parcelRequire("c5npJ");

var $ggSVP = parcelRequire("ggSVP");

var $5Bxi4 = parcelRequire("5Bxi4");

var $k3PJZ = parcelRequire("k3PJZ");

var $knfEI = parcelRequire("knfEI");

var $5qm7M = parcelRequire("5qm7M");

var $l8ssf = parcelRequire("l8ssf");

var $5wdbf = parcelRequire("5wdbf");

var $dttgK = parcelRequire("dttgK");

var $adKYy = parcelRequire("adKYy");

var $iLxt4 = parcelRequire("iLxt4");

var $hBvdF = parcelRequire("hBvdF");
const $ff9dfb30fc1873c4$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "atlassianIntelligenceProductFeature"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsScope"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterId"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "groupBy"
    }, v10 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isPaginating"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v17 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryConditionalFormatting"
    }, v18 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "shouldQueryHasChildren"
    }, v19 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryProject"
    }, v20 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "staticViewInput"
    }, v21 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewConfigInput"
    }, v22 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v23 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewQueryInput"
    }, v24 = {
        "kind": "Variable",
        "name": "projectKey",
        "variableName": "projectKey"
    }, v25 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v26 = [
        v25 /*: any*/ 
    ], v27 = [
        v25 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v28 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v29 = {
        "kind": "Variable",
        "name": "issueSearchInput",
        "variableName": "issueSearchInput"
    }, v30 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v31 = {
        "kind": "ScalarField",
        "name": "message"
    }, v32 = [
        {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                v30 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "statusCode"
                }
            ]
        },
        v31 /*: any*/ 
    ], v33 = {
        "kind": "ScalarField",
        "name": "id"
    }, v34 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "fieldSetsScope"
    }, v35 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "fieldSetSelectedState": "SELECTED"
            }
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "amountOfColumns"
        },
        v34 /*: any*/ 
    ], v36 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v37 = {
        "kind": "Variable",
        "name": "groupBy",
        "variableName": "groupBy"
    }, v38 = [
        v37 /*: any*/ ,
        v29 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "staticViewInput",
            "variableName": "staticViewInput"
        }
    ], v39 = {
        "kind": "ScalarField",
        "name": "isGroupingEnabled"
    }, v40 = {
        "kind": "ScalarField",
        "name": "canEnableGrouping"
    }, v41 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v42 = {
        "kind": "ScalarField",
        "name": "name"
    }, v43 = {
        "kind": "ScalarField",
        "name": "isHierarchyEnabled"
    }, v44 = {
        "kind": "ScalarField",
        "name": "hideDone"
    }, v45 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v46 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v47 = {
        "kind": "ScalarField",
        "name": "type"
    }, v48 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v49 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v50 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v51 = {
        "kind": "ClientExtension",
        "selections": [
            v50 /*: any*/ 
        ]
    }, v52 = {
        "kind": "ScalarField",
        "name": "canEnableHierarchy"
    }, v53 = [
        {
            "kind": "ScalarField",
            "name": "savedViewId"
        }
    ], v54 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v55 = {
        "kind": "Variable",
        "name": "before",
        "variableName": "before"
    }, v56 = {
        "kind": "Variable",
        "name": "fieldSetsInput",
        "variableName": "fieldSetsInput"
    }, v57 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v58 = {
        "kind": "Variable",
        "name": "last",
        "variableName": "last"
    }, v59 = {
        "kind": "Variable",
        "name": "options",
        "variableName": "options"
    }, v60 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
    }, v61 = [
        v54 /*: any*/ ,
        v55 /*: any*/ ,
        v56 /*: any*/ ,
        v57 /*: any*/ ,
        v29 /*: any*/ ,
        v58 /*: any*/ ,
        v59 /*: any*/ ,
        v60 /*: any*/ 
    ], v62 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v63 = {
        "kind": "ScalarField",
        "name": "key"
    }, v64 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v65 = {
        "kind": "ScalarField",
        "name": "isResolved"
    }, v66 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v67 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v66 /*: any*/ ,
            v33 /*: any*/ 
        ]
    }, v68 = {
        "kind": "InlineFragment",
        "selections": [
            v41 /*: any*/ ,
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v67 /*: any*/ ,
                    v33 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v69 = {
        "args": [
            {
                "kind": "Literal",
                "name": "ids",
                "value": [
                    "status"
                ]
            }
        ],
        "concreteType": "JiraIssueFieldConnection",
        "kind": "LinkedField",
        "name": "fieldsById",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueFieldEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v30 /*: any*/ ,
                            v68 /*: any*/ ,
                            v33 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "storageKey": "fieldsById(ids:[\"status\"])"
    }, v70 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v71 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v70 /*: any*/ ,
                    v33 /*: any*/ 
                ]
            },
            v33 /*: any*/ 
        ]
    }, v72 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraIssueTypeField",
                "kind": "LinkedField",
                "name": "issueTypeField",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueType",
                        "kind": "LinkedField",
                        "name": "issueType",
                        "plural": false,
                        "selections": [
                            v42 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v73 = {
        "kind": "ClientExtension",
        "selections": [
            v50 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "isHighlightedIssueRow"
            }
        ]
    }, v74 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v75 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v76 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v30 /*: any*/ ,
            v33 /*: any*/ ,
            v63 /*: any*/ ,
            v64 /*: any*/ ,
            v65 /*: any*/ ,
            v69 /*: any*/ ,
            v71 /*: any*/ ,
            v72 /*: any*/ ,
            v73 /*: any*/ ,
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v74 /*: any*/ ,
                    {
                        "concreteType": "JiraIssueTypeField",
                        "kind": "LinkedField",
                        "name": "issueTypeField",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueType",
                                "plural": false,
                                "selections": [
                                    v75 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v77 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v78 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isJiraIssueField"
    }, v79 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraAffectedServiceConnection",
                "kind": "LinkedField",
                "name": "selectedAffectedServicesConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraAffectedServiceEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraAffectedService",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "serviceId"
                                    },
                                    v42 /*: any*/ ,
                                    v33 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraAffectedServicesField"
    }, v80 = {
        "kind": "ScalarField",
        "name": "value"
    }, v81 = [
        v80 /*: any*/ ,
        v33 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v82 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v83 = {
        "kind": "ClientExtension",
        "selections": [
            v82 /*: any*/ 
        ]
    }, v84 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v85 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v86 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v87 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v88 = {
        "kind": "ScalarField",
        "name": "text"
    }, v89 = {
        "kind": "InlineFragment",
        "selections": [
            v88 /*: any*/ ,
            v42 /*: any*/ ,
            v83 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v90 = [
        v46 /*: any*/ 
    ], v91 = {
        "kind": "ScalarField",
        "name": "colorKey"
    }, v92 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            v91 /*: any*/ ,
            v33 /*: any*/ 
        ]
    }, v93 = [
        v92 /*: any*/ 
    ], v94 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v95 = {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v33 /*: any*/ ,
            v80 /*: any*/ 
        ]
    }, v96 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v97 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v98 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v99 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v100 = [
        v33 /*: any*/ 
    ], v101 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v42 /*: any*/ ,
                    {
                        "concreteType": "JiraCascadingOption",
                        "kind": "LinkedField",
                        "name": "cascadingOption",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "parentOptionValue",
                                "plural": false,
                                "selections": v81 /*: any*/ 
                            },
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "childOptionValue",
                                "plural": false,
                                "selections": v81 /*: any*/ 
                            }
                        ]
                    },
                    v83 /*: any*/ 
                ],
                "type": "JiraCascadingSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v42 /*: any*/ ,
                    {
                        "args": v84 /*: any*/ ,
                        "concreteType": "JiraComponentConnection",
                        "kind": "LinkedField",
                        "name": "selectedComponentsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraComponentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraComponent",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v85 /*: any*/ ,
                                            v86 /*: any*/ ,
                                            v33 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ],
                        "storageKey": "selectedComponentsConnection(first:1000)"
                    },
                    v83 /*: any*/ 
                ],
                "type": "JiraComponentsField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v87 /*: any*/ ,
                    v42 /*: any*/ ,
                    v83 /*: any*/ 
                ],
                "type": "JiraDateTimePickerField"
            },
            v89 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraCommentSummary",
                        "kind": "LinkedField",
                        "name": "commentSummary",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "canAddComment"
                            },
                            v46 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraCommentSummaryField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v42 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "uri"
                    },
                    v83 /*: any*/ 
                ],
                "type": "JiraUrlField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v42 /*: any*/ ,
                    {
                        "concreteType": "JiraOptionConnection",
                        "kind": "LinkedField",
                        "name": "fieldOptions",
                        "plural": false,
                        "selections": v90 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "fieldOption",
                        "plural": false,
                        "selections": [
                            v80 /*: any*/ ,
                            {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": v93 /*: any*/ 
                            },
                            {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": v93 /*: any*/ 
                            },
                            v33 /*: any*/ ,
                            v94 /*: any*/ 
                        ]
                    },
                    v83 /*: any*/ 
                ],
                "type": "JiraSingleSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v42 /*: any*/ ,
                    {
                        "concreteType": "JiraOptionConnection",
                        "kind": "LinkedField",
                        "name": "selectedOptions",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraOptionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraOption",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v33 /*: any*/ ,
                                            v80 /*: any*/ ,
                                            v94 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v83 /*: any*/ 
                ],
                "type": "JiraMultipleSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v42 /*: any*/ ,
                    {
                        "concreteType": "JiraOptionConnection",
                        "kind": "LinkedField",
                        "name": "selectedOptions",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraOptionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    v95 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    v83 /*: any*/ 
                ],
                "type": "JiraCheckboxesField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v42 /*: any*/ ,
                    {
                        "concreteType": "JiraUserConnection",
                        "kind": "LinkedField",
                        "name": "selectedUsersConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraUserEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v30 /*: any*/ ,
                                            v96 /*: any*/ ,
                                            v42 /*: any*/ ,
                                            v97 /*: any*/ ,
                                            v33 /*: any*/ ,
                                            v98 /*: any*/ ,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "email"
                                                    }
                                                ],
                                                "type": "AtlassianAccountUser"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v83 /*: any*/ 
                ],
                "type": "JiraMultipleSelectUserPickerField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v42 /*: any*/ ,
                    {
                        "concreteType": "JiraTeamView",
                        "kind": "LinkedField",
                        "name": "selectedTeam",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "jiraSuppliedId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "jiraSuppliedName"
                            }
                        ]
                    },
                    v83 /*: any*/ 
                ],
                "type": "JiraTeamViewField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "issue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraTimeTrackingField",
                                "kind": "LinkedField",
                                "name": "timeTrackingField",
                                "plural": false,
                                "selections": [
                                    v33 /*: any*/ ,
                                    {
                                        "concreteType": "JiraEstimate",
                                        "kind": "LinkedField",
                                        "name": "originalEstimate",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "timeInSeconds"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraTimeTrackingSettings",
                                        "kind": "LinkedField",
                                        "name": "timeTrackingSettings",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "workingHoursPerDay"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "workingDaysPerWeek"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "defaultFormat"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "defaultUnit"
                                            }
                                        ]
                                    },
                                    v41 /*: any*/ ,
                                    v42 /*: any*/ ,
                                    v47 /*: any*/ ,
                                    v83 /*: any*/ 
                                ]
                            },
                            v33 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraOriginalTimeEstimateField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v42 /*: any*/ ,
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "selectedOption",
                        "plural": false,
                        "selections": [
                            {
                                "alias": "label",
                                "kind": "ScalarField",
                                "name": "value"
                            },
                            v33 /*: any*/ ,
                            v85 /*: any*/ 
                        ]
                    },
                    v83 /*: any*/ 
                ],
                "type": "JiraRadioSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v42 /*: any*/ ,
                    {
                        "args": v84 /*: any*/ ,
                        "concreteType": "JiraVersionConnection",
                        "kind": "LinkedField",
                        "name": "selectedVersionsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraVersionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraVersion",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v33 /*: any*/ ,
                                            v42 /*: any*/ ,
                                            v85 /*: any*/ ,
                                            v86 /*: any*/ ,
                                            v99 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ],
                        "storageKey": "selectedVersionsConnection(first:1000)"
                    },
                    v83 /*: any*/ 
                ],
                "type": "JiraMultipleVersionPickerField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v42 /*: any*/ ,
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "issue",
                        "plural": false,
                        "selections": v100 /*: any*/ 
                    },
                    {
                        "args": v84 /*: any*/ ,
                        "concreteType": "JiraGoalConnection",
                        "kind": "LinkedField",
                        "name": "selectedGoals",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraGoalEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraGoal",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v33 /*: any*/ ,
                                            v63 /*: any*/ 
                                        ]
                                    }
                                ]
                            },
                            v51 /*: any*/ 
                        ],
                        "storageKey": "selectedGoals(first:1000)"
                    },
                    {
                        "kind": "ClientExtension",
                        "selections": [
                            v50 /*: any*/ ,
                            v82 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraGoalsField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v42 /*: any*/ ,
                    {
                        "args": v84 /*: any*/ ,
                        "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                        "kind": "LinkedField",
                        "name": "confluenceRemoteIssueLinks",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraConfluenceRemoteIssueLink",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v33 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "href"
                                            }
                                        ]
                                    }
                                ]
                            },
                            v46 /*: any*/ 
                        ],
                        "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                    },
                    v83 /*: any*/ 
                ],
                "type": "JiraConfluenceRemoteIssueLinksField"
            }
        ]
    }, v102 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCmdbObjectConnection",
                "kind": "LinkedField",
                "name": "selectedCmdbObjectsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraCmdbObjectEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraCmdbObject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "objectId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "label"
                                    },
                                    {
                                        "concreteType": "JiraCmdbAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraCmdbMediaClientConfig",
                                                "kind": "LinkedField",
                                                "name": "mediaClientConfig",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "clientId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "fileId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaBaseUrl"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaJwtToken"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "url48"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": [
                            v31 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "type": "JiraCMDBField"
    }, v103 = [
        v42 /*: any*/ ,
        v33 /*: any*/ 
    ], v104 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "componentsOld",
                        "concreteType": "JiraComponentConnection",
                        "kind": "LinkedField",
                        "name": "selectedComponentsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraComponentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraComponent",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": v103 /*: any*/ 
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "JiraComponentsField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v88 /*: any*/ 
                ],
                "type": "JiraSingleLineTextField"
            }
        ]
    }, v105 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v106 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "date"
            },
            v42 /*: any*/ ,
            v105 /*: any*/ ,
            v83 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v107 = {
        "kind": "InlineFragment",
        "selections": [
            v87 /*: any*/ 
        ],
        "type": "JiraDateTimePickerField"
    }, v108 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraEpic",
                "kind": "LinkedField",
                "name": "epic",
                "plural": false,
                "selections": [
                    v63 /*: any*/ ,
                    v74 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    },
                    v33 /*: any*/ 
                ]
            }
        ],
        "type": "JiraEpicLinkField"
    }, v109 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "renderedFieldHtml"
            }
        ],
        "type": "JiraFallbackField"
    }, v110 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatusCategory",
                "kind": "LinkedField",
                "name": "statusCategory",
                "plural": false,
                "selections": [
                    v42 /*: any*/ ,
                    v66 /*: any*/ ,
                    v33 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusCategoryField"
    }, v111 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v42 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "statusId"
                    },
                    v67 /*: any*/ ,
                    v33 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v112 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": v84 /*: any*/ ,
                "concreteType": "JiraLabelConnection",
                "kind": "LinkedField",
                "name": "selectedLabelsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraLabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v42 /*: any*/ ,
                                    v92 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "labelId"
                                    }
                                ]
                            }
                        ]
                    },
                    v46 /*: any*/ 
                ],
                "storageKey": "selectedLabelsConnection(first:1000)"
            },
            v42 /*: any*/ ,
            v83 /*: any*/ 
        ],
        "type": "JiraLabelsField"
    }, v113 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v114 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v75 /*: any*/ ,
                    v42 /*: any*/ ,
                    v33 /*: any*/ ,
                    v113 /*: any*/ 
                ]
            }
        ],
        "type": "JiraIssueTypeField"
    }, v115 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v88 /*: any*/ ,
            v33 /*: any*/ 
        ]
    }, v116 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v92 /*: any*/ ,
            v33 /*: any*/ 
        ]
    }, v117 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v118 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v117 /*: any*/ ,
                    v42 /*: any*/ ,
                    v33 /*: any*/ 
                ]
            },
            v33 /*: any*/ 
        ]
    }, v119 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v120 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                    v63 /*: any*/ ,
                    v115 /*: any*/ ,
                    v33 /*: any*/ 
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "parentIssue",
                        "plural": false,
                        "selections": [
                            v63 /*: any*/ ,
                            v116 /*: any*/ ,
                            v118 /*: any*/ ,
                            v115 /*: any*/ ,
                            v33 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "parentIssue",
                        "plural": false,
                        "selections": [
                            v63 /*: any*/ ,
                            v116 /*: any*/ ,
                            v118 /*: any*/ ,
                            v115 /*: any*/ ,
                            v33 /*: any*/ ,
                            v64 /*: any*/ ,
                            v119 /*: any*/ ,
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "ids",
                                        "value": [
                                            "summary",
                                            "issuetype",
                                            "status"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fieldsById",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v30 /*: any*/ ,
                                                    v33 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v41 /*: any*/ ,
                                                            v88 /*: any*/ 
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v41 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    v113 /*: any*/ ,
                                                                    v42 /*: any*/ ,
                                                                    v117 /*: any*/ ,
                                                                    v70 /*: any*/ ,
                                                                    v33 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    v68 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                            }
                        ]
                    },
                    v42 /*: any*/ ,
                    v83 /*: any*/ 
                ]
            }
        ],
        "type": "JiraParentIssueField"
    }, v121 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v122 = {
        "kind": "ScalarField",
        "name": "priorityId"
    }, v123 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    v42 /*: any*/ ,
                    v121 /*: any*/ ,
                    v33 /*: any*/ ,
                    v122 /*: any*/ 
                ]
            },
            v42 /*: any*/ ,
            v83 /*: any*/ 
        ],
        "type": "JiraPriorityField"
    }, v124 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v125 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    v42 /*: any*/ ,
                    v63 /*: any*/ ,
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "large"
                            }
                        ]
                    },
                    v33 /*: any*/ ,
                    v124 /*: any*/ 
                ]
            }
        ],
        "type": "JiraProjectField"
    }, v126 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraResolution",
                "kind": "LinkedField",
                "name": "resolution",
                "plural": false,
                "selections": v103 /*: any*/ 
            }
        ],
        "type": "JiraResolutionField"
    }, v127 = [
        v33 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "sprintId"
        },
        v42 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "state"
        },
        {
            "kind": "ScalarField",
            "name": "endDate"
        }
    ], v128 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraSprintConnection",
                "kind": "LinkedField",
                "name": "selectedSprintsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraSprintEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v127 /*: any*/ 
                            }
                        ]
                    }
                ]
            },
            v42 /*: any*/ ,
            v83 /*: any*/ 
        ],
        "type": "JiraSprintField"
    }, v129 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    v30 /*: any*/ ,
                    v96 /*: any*/ ,
                    v97 /*: any*/ ,
                    v42 /*: any*/ ,
                    v33 /*: any*/ ,
                    v98 /*: any*/ 
                ]
            },
            v42 /*: any*/ ,
            v105 /*: any*/ ,
            v83 /*: any*/ 
        ],
        "type": "JiraSingleSelectUserPickerField"
    }, v130 = {
        "kind": "InlineFragment",
        "selections": [
            v42 /*: any*/ ,
            {
                "args": v84 /*: any*/ ,
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "selectedVersionsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v42 /*: any*/ ,
                                    v33 /*: any*/ ,
                                    v99 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedVersionsConnection(first:1000)"
            }
        ],
        "type": "JiraMultipleVersionPickerField"
    }, v131 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraRichText",
                "kind": "LinkedField",
                "name": "richText",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraADF",
                        "kind": "LinkedField",
                        "name": "adfValue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraAdfToConvertedPlainText",
                                "kind": "LinkedField",
                                "name": "convertedPlainText",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "plainText"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraRichTextField"
    }, v132 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraServiceManagementRequestType",
                "kind": "LinkedField",
                "name": "requestType",
                "plural": false,
                "selections": [
                    v42 /*: any*/ ,
                    v117 /*: any*/ ,
                    v33 /*: any*/ 
                ]
            }
        ],
        "type": "JiraServiceManagementRequestTypeField"
    }, v133 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1
                    }
                ],
                "concreteType": "JiraIssueLinkConnection",
                "kind": "LinkedField",
                "name": "issueLinkConnection",
                "plural": false,
                "selections": [
                    v46 /*: any*/ ,
                    {
                        "concreteType": "JiraIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "issue",
                                        "plural": false,
                                        "selections": [
                                            v119 /*: any*/ ,
                                            v63 /*: any*/ ,
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "ids",
                                                        "value": [
                                                            "statusCategory"
                                                        ]
                                                    }
                                                ],
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldsById",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v30 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v67 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraStatusCategoryField"
                                                                    },
                                                                    v33 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                            },
                                            v33 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "relationName"
                                    },
                                    v33 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "issueLinkConnection(first:1)"
            }
        ],
        "type": "JiraIssueLinkField"
    }, v134 = {
        "kind": "ScalarField",
        "name": "number"
    }, v135 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraNumberFieldFormatConfig",
                "kind": "LinkedField",
                "name": "formatConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "formatStyle"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "formatUnit"
                    }
                ]
            }
        ]
    }, v136 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isStoryPointField"
            },
            v134 /*: any*/ ,
            v42 /*: any*/ ,
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    v134 /*: any*/ ,
                    v135 /*: any*/ 
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v134 /*: any*/ ,
                    v42 /*: any*/ ,
                    v135 /*: any*/ ,
                    v83 /*: any*/ 
                ]
            },
            v83 /*: any*/ 
        ],
        "type": "JiraNumberField"
    }, v137 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v42 /*: any*/ ,
                    {
                        "concreteType": "JiraGroupConnection",
                        "kind": "LinkedField",
                        "name": "selectedGroupsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraGroupEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraGroup",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v33 /*: any*/ ,
                                            v42 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "groupId"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v83 /*: any*/ 
                ],
                "type": "JiraMultipleGroupPickerField"
            }
        ]
    }, v138 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraFlag",
                        "kind": "LinkedField",
                        "name": "flag",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFlagged"
                            }
                        ]
                    }
                ],
                "type": "JiraFlagField"
            }
        ]
    }, v139 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraWatch",
                        "kind": "LinkedField",
                        "name": "watch",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "count"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "isWatching"
                            }
                        ]
                    }
                ],
                "type": "JiraWatchesField"
            }
        ]
    }, v140 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraComponentConnection",
                "kind": "LinkedField",
                "name": "components",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraComponent",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "componentId"
                                    },
                                    v33 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraComponentsField"
    }, v141 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraUserConnection",
                "kind": "LinkedField",
                "name": "users",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraUserEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v30 /*: any*/ ,
                                    v96 /*: any*/ ,
                                    v33 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraMultipleSelectUserPickerField"
    }, v142 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                    v99 /*: any*/ ,
                    v33 /*: any*/ 
                ]
            }
        ],
        "type": "JiraSingleVersionPickerField"
    }, v143 = [
        v30 /*: any*/ ,
        v33 /*: any*/ 
    ], v144 = {
        "kind": "LinkedField",
        "name": "selectedValue",
        "plural": false,
        "selections": v143 /*: any*/ 
    }, v145 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraSelectableValueConnection",
                "kind": "LinkedField",
                "name": "selectedValues",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraSelectableValueEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v143 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraMultipleSelectField"
    }, v146 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraOption",
                "kind": "LinkedField",
                "name": "selectedOption",
                "plural": false,
                "selections": v100 /*: any*/ 
            }
        ],
        "type": "JiraRadioSelectField"
    }, v147 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": v90 /*: any*/ 
    }, v148 = {
        "args": v77 /*: any*/ ,
        "concreteType": "JiraIssueFieldSetConnection",
        "kind": "LinkedField",
        "name": "fieldSets",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v47 /*: any*/ ,
                            v36 /*: any*/ ,
                            {
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v30 /*: any*/ ,
                                                    v41 /*: any*/ ,
                                                    v47 /*: any*/ ,
                                                    v78 /*: any*/ ,
                                                    v33 /*: any*/ ,
                                                    v79 /*: any*/ ,
                                                    v101 /*: any*/ ,
                                                    v102 /*: any*/ ,
                                                    v104 /*: any*/ ,
                                                    v106 /*: any*/ ,
                                                    v107 /*: any*/ ,
                                                    v108 /*: any*/ ,
                                                    v109 /*: any*/ ,
                                                    v89 /*: any*/ ,
                                                    v110 /*: any*/ ,
                                                    v111 /*: any*/ ,
                                                    v112 /*: any*/ ,
                                                    v114 /*: any*/ ,
                                                    v120 /*: any*/ ,
                                                    v123 /*: any*/ ,
                                                    v125 /*: any*/ ,
                                                    v126 /*: any*/ ,
                                                    v128 /*: any*/ ,
                                                    v129 /*: any*/ ,
                                                    v130 /*: any*/ ,
                                                    v131 /*: any*/ ,
                                                    v132 /*: any*/ ,
                                                    v133 /*: any*/ ,
                                                    v136 /*: any*/ ,
                                                    v137 /*: any*/ ,
                                                    v138 /*: any*/ ,
                                                    v139 /*: any*/ ,
                                                    v140 /*: any*/ ,
                                                    v141 /*: any*/ ,
                                                    v142 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v144 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraOption",
                                                                "kind": "LinkedField",
                                                                "name": "fieldOption",
                                                                "plural": false,
                                                                "selections": [
                                                                    v94 /*: any*/ ,
                                                                    v33 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraSingleSelectField"
                                                    },
                                                    v145 /*: any*/ ,
                                                    v146 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraOptionConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedOptions",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraOptionEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            v95 /*: any*/ ,
                                                                            v51 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraCheckboxesField"
                                                    },
                                                    v51 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    },
                                    v147 /*: any*/ 
                                ]
                            },
                            v51 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "storageKey": "fieldSets(first:500)"
    }, v149 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v150 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v151 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            v149 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "startCursor"
            },
            v150 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "hasPreviousPage"
            }
        ]
    }, v152 = {
        "concreteType": "JiraIssueNavigatorPageInfo",
        "kind": "LinkedField",
        "name": "issueNavigatorPageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "firstIssuePosition"
            },
            {
                "kind": "ScalarField",
                "name": "lastIssuePosition"
            }
        ]
    }, v153 = {
        "kind": "ScalarField",
        "name": "pageNumber"
    }, v154 = {
        "kind": "ScalarField",
        "name": "isCurrent"
    }, v155 = [
        v153 /*: any*/ ,
        v62 /*: any*/ ,
        v154 /*: any*/ 
    ], v156 = {
        "args": [
            {
                "kind": "Literal",
                "name": "maxCursors",
                "value": 7
            }
        ],
        "concreteType": "JiraPageCursors",
        "kind": "LinkedField",
        "name": "pageCursors",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraPageCursor",
                "kind": "LinkedField",
                "name": "around",
                "plural": true,
                "selections": v155 /*: any*/ 
            },
            {
                "concreteType": "JiraPageCursor",
                "kind": "LinkedField",
                "name": "last",
                "plural": false,
                "selections": v155 /*: any*/ 
            },
            {
                "concreteType": "JiraPageCursor",
                "kind": "LinkedField",
                "name": "first",
                "plural": false,
                "selections": [
                    v62 /*: any*/ ,
                    v153 /*: any*/ ,
                    v154 /*: any*/ 
                ]
            }
        ],
        "storageKey": "pageCursors(maxCursors:7)"
    }, v157 = {
        "kind": "ScalarField",
        "name": "totalIssueSearchResultCount"
    }, v158 = {
        "kind": "LinkedField",
        "name": "issueSearchError",
        "plural": false,
        "selections": [
            v30 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "messages"
                    }
                ],
                "type": "JiraInvalidJqlError"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v31 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "errorType"
                    }
                ],
                "type": "JiraInvalidSyntaxError"
            }
        ]
    }, v159 = {
        "kind": "ScalarField",
        "name": "isCappingIssueSearchResult"
    }, v160 = [
        "issueSearchInput"
    ], v161 = [
        v54 /*: any*/ ,
        v55 /*: any*/ ,
        v57 /*: any*/ ,
        v37 /*: any*/ ,
        v29 /*: any*/ ,
        v58 /*: any*/ ,
        v60 /*: any*/ 
    ], v162 = {
        "kind": "ScalarField",
        "name": "fieldType"
    }, v163 = {
        "kind": "LinkedField",
        "name": "fieldValue",
        "plural": false,
        "selections": [
            v30 /*: any*/ ,
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v49 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "label",
                                "plural": false,
                                "selections": [
                                    v42 /*: any*/ ,
                                    v92 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "JiraJqlLabelFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueTypes",
                                "plural": true,
                                "selections": v103 /*: any*/ 
                            }
                        ],
                        "type": "JiraJqlIssueTypeFieldValue"
                    }
                ]
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraPriority",
                        "kind": "LinkedField",
                        "name": "priority",
                        "plural": false,
                        "selections": [
                            v33 /*: any*/ ,
                            v122 /*: any*/ ,
                            v42 /*: any*/ ,
                            v121 /*: any*/ 
                        ]
                    },
                    v48 /*: any*/ 
                ],
                "type": "JiraJqlPriorityFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v30 /*: any*/ ,
                            v33 /*: any*/ ,
                            v96 /*: any*/ ,
                            v42 /*: any*/ ,
                            v97 /*: any*/ 
                        ]
                    },
                    v48 /*: any*/ 
                ],
                "type": "JiraJqlUserFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraStatus",
                        "kind": "LinkedField",
                        "name": "status",
                        "plural": false,
                        "selections": [
                            v33 /*: any*/ ,
                            v42 /*: any*/ ,
                            {
                                "concreteType": "JiraStatusCategory",
                                "kind": "LinkedField",
                                "name": "statusCategory",
                                "plural": false,
                                "selections": [
                                    v33 /*: any*/ ,
                                    v66 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    v48 /*: any*/ ,
                    v67 /*: any*/ 
                ],
                "type": "JiraJqlStatusFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v134 /*: any*/ 
                ],
                "type": "JiraJqlNumberFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "option",
                        "plural": false,
                        "selections": [
                            v33 /*: any*/ ,
                            v94 /*: any*/ ,
                            v80 /*: any*/ ,
                            v92 /*: any*/ 
                        ]
                    },
                    v48 /*: any*/ 
                ],
                "type": "JiraJqlOptionFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraSprint",
                        "kind": "LinkedField",
                        "name": "sprint",
                        "plural": false,
                        "selections": v127 /*: any*/ 
                    },
                    v48 /*: any*/ 
                ],
                "type": "JiraJqlSprintFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraGoal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                            v33 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "status"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "score"
                            }
                        ]
                    },
                    v48 /*: any*/ 
                ],
                "type": "JiraJqlGoalsFieldValue"
            }
        ]
    }, v164 = {
        "kind": "ScalarField",
        "name": "issueCount"
    }, v165 = [
        v56 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        },
        v34 /*: any*/ 
    ], v166 = [
        v54 /*: any*/ ,
        v55 /*: any*/ ,
        v56 /*: any*/ ,
        v57 /*: any*/ ,
        v29 /*: any*/ ,
        v58 /*: any*/ ,
        v59 /*: any*/ ,
        v60 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "viewConfigInput",
            "variableName": "viewConfigInput"
        }
    ], v167 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "feature",
                    "variableName": "atlassianIntelligenceProductFeature"
                }
            ],
            "kind": "ObjectValue",
            "name": "atlassianIntelligenceProductFeatureInput"
        },
        v25 /*: any*/ 
    ], v168 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "main_IssueNavigatorQuery",
            "selections": [
                {
                    "args": [
                        v24 /*: any*/ ,
                        {
                            "items": [
                                {
                                    "kind": "Variable",
                                    "name": "projectKeys.0",
                                    "variableName": "projectKey"
                                }
                            ],
                            "kind": "ListValue",
                            "name": "projectKeys"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigator_issueQuery"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v26 /*: any*/ ,
                            "concreteType": "JiraUserPreferences",
                            "kind": "LinkedField",
                            "name": "userPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "main_issueNavigator_IssueNavigator_userPreferences"
                                }
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_IssueNavigator_jira"
                        },
                        {
                            "condition": "shouldQueryProject",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v27 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "isConditionalFormattingEnabled",
                                                    "variableName": "shouldQueryConditionalFormatting"
                                                }
                                            ],
                                            "kind": "FragmentSpread",
                                            "name": "main_issueNavigator_IssueNavigatorUI_project"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "issueSearch_issueNavigatorProject"
                                        },
                                        {
                                            "condition": "shouldQueryConditionalFormatting",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": v28 /*: any*/ ,
                                                    "kind": "FragmentSpread",
                                                    "name": "container_issueNavigatorActionConditionalFormatting_ConditionalFormattingInner"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v11 /*: any*/ ,
                v8 /*: any*/ ,
                v12 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v13 /*: any*/ ,
                v22 /*: any*/ ,
                v14 /*: any*/ ,
                v5 /*: any*/ ,
                v7 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v15 /*: any*/ ,
                v19 /*: any*/ ,
                v17 /*: any*/ ,
                v10 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ ,
                v16 /*: any*/ ,
                v9 /*: any*/ ,
                v18 /*: any*/ ,
                v6 /*: any*/ ,
                v23 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistcheckissuecreatepermissionsrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "main_IssueNavigatorQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v25 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "filterId",
                                    "variableName": "filterId"
                                },
                                v29 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "namespace",
                                    "variableName": "namespace"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "viewConfigInput",
                                    "variableName": "staticViewInput"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "viewId",
                                    "variableName": "viewId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "viewQueryInput",
                                    "variableName": "viewQueryInput"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "jiraIssueSearchView",
                            "plural": false,
                            "selections": [
                                v30 /*: any*/ ,
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraView"
                                },
                                {
                                    "concreteType": "QueryError",
                                    "kind": "LinkedField",
                                    "name": "error",
                                    "plural": false,
                                    "selections": v32 /*: any*/ 
                                },
                                v33 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "viewId"
                                        },
                                        {
                                            "args": v35 /*: any*/ ,
                                            "concreteType": "JiraIssueSearchFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v36 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraIssueSearchViewMetadata",
                                    "abstractKey": "__isJiraIssueSearchViewMetadata"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v38 /*: any*/ ,
                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                            "kind": "LinkedField",
                                            "name": "viewSettings",
                                            "plural": false,
                                            "selections": [
                                                v39 /*: any*/ ,
                                                v40 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraSpreadsheetGroupByConfig",
                                                    "kind": "LinkedField",
                                                    "name": "groupByConfig",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraField",
                                                            "kind": "LinkedField",
                                                            "name": "groupByField",
                                                            "plural": false,
                                                            "selections": [
                                                                v41 /*: any*/ ,
                                                                v33 /*: any*/ ,
                                                                v42 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "typeKey"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v43 /*: any*/ ,
                                                v44 /*: any*/ 
                                            ]
                                        },
                                        v45 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "filterId"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasDefaultFieldSets"
                                                },
                                                {
                                                    "args": v35 /*: any*/ ,
                                                    "concreteType": "JiraIssueSearchFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        v46 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v47 /*: any*/ ,
                                                                        v48 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isSortable"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraFieldSetPreferences",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldSetPreferences",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "width"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraFieldType",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v48 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueSearchFieldMetadataConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldsMetadata",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueSearchFieldMetadataEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueSearchMetadataField",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "canBeConfigured"
                                                                                                        },
                                                                                                        v41 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ClientExtension",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isPlaceHolderField"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v51 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "args": v38 /*: any*/ ,
                                                                    "concreteType": "JiraIssueSearchViewConfigSettings",
                                                                    "kind": "LinkedField",
                                                                    "name": "viewSettings",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v43 /*: any*/ ,
                                                                        v52 /*: any*/ ,
                                                                        v39 /*: any*/ ,
                                                                        v40 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraSpreadsheetView",
                                                            "abstractKey": "__isJiraSpreadsheetView"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v38 /*: any*/ ,
                                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                                            "kind": "LinkedField",
                                                            "name": "viewSettings",
                                                            "plural": false,
                                                            "selections": [
                                                                v44 /*: any*/ ,
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        v39 /*: any*/ 
                                                                    ]
                                                                },
                                                                v52 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraSpreadsheetGroupByConfig",
                                                                    "kind": "LinkedField",
                                                                    "name": "groupByConfig",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraField",
                                                                            "kind": "LinkedField",
                                                                            "name": "groupByField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v41 /*: any*/ ,
                                                                                v33 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v43 /*: any*/ ,
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canEnableReranking"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraSpreadsheetView",
                                                    "abstractKey": "__isJiraSpreadsheetView"
                                                },
                                                v51 /*: any*/ 
                                            ],
                                            "type": "JiraIssueSearchViewMetadata",
                                            "abstractKey": "__isJiraIssueSearchViewMetadata"
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "args": v38 /*: any*/ ,
                                                                    "concreteType": "JiraIssueSearchViewConfigSettings",
                                                                    "kind": "LinkedField",
                                                                    "name": "viewSettings",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canPublishViewConfig"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isViewConfigModified"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraSpreadsheetView",
                                                            "abstractKey": "__isJiraSpreadsheetView"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v53 /*: any*/ ,
                                                            "type": "JiraDetailedView"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v53 /*: any*/ ,
                                                            "type": "JiraGroupedListView"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v53 /*: any*/ ,
                                                            "type": "JiraListView"
                                                        }
                                                    ],
                                                    "type": "JiraIssueSearchViewMetadata",
                                                    "abstractKey": "__isJiraIssueSearchViewMetadata"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraSpreadsheetView",
                                    "abstractKey": "__isJiraSpreadsheetView"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v61 /*: any*/ ,
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        v62 /*: any*/ ,
                                                        v76 /*: any*/ ,
                                                        v30 /*: any*/ ,
                                                        v148 /*: any*/ ,
                                                        v51 /*: any*/ 
                                                    ]
                                                },
                                                v151 /*: any*/ ,
                                                v152 /*: any*/ ,
                                                v156 /*: any*/ ,
                                                v157 /*: any*/ ,
                                                v158 /*: any*/ ,
                                                v45 /*: any*/ ,
                                                v159 /*: any*/ ,
                                                v51 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": v61 /*: any*/ ,
                                            "filters": v160 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "IssueNavigatorDetailedViewPagination__issues",
                                            "kind": "LinkedHandle",
                                            "name": "issues"
                                        }
                                    ],
                                    "type": "JiraDetailedView"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v161 /*: any*/ ,
                                            "concreteType": "JiraSpreadsheetGroupConnection",
                                            "kind": "LinkedField",
                                            "name": "groups",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSpreadsheetGroupEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        v62 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraSpreadsheetGroup",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v30 /*: any*/ ,
                                                                v33 /*: any*/ ,
                                                                v45 /*: any*/ ,
                                                                v41 /*: any*/ ,
                                                                v162 /*: any*/ ,
                                                                v163 /*: any*/ ,
                                                                v164 /*: any*/ 
                                                            ]
                                                        },
                                                        v30 /*: any*/ 
                                                    ]
                                                },
                                                v151 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "groupByField"
                                                },
                                                v45 /*: any*/ ,
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "errors",
                                                    "plural": true,
                                                    "selections": v32 /*: any*/ 
                                                },
                                                {
                                                    "condition": "isPaginating",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraSpreadsheetGroup",
                                                            "kind": "LinkedField",
                                                            "name": "firstGroup",
                                                            "plural": false,
                                                            "selections": [
                                                                v33 /*: any*/ ,
                                                                {
                                                                    "args": v165 /*: any*/ ,
                                                                    "concreteType": "JiraIssueConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "issues",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v30 /*: any*/ ,
                                                                                v62 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraIssue",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v30 /*: any*/ ,
                                                                                        v33 /*: any*/ ,
                                                                                        v63 /*: any*/ ,
                                                                                        v64 /*: any*/ ,
                                                                                        v65 /*: any*/ ,
                                                                                        v69 /*: any*/ ,
                                                                                        v71 /*: any*/ ,
                                                                                        v72 /*: any*/ ,
                                                                                        v73 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "args": v77 /*: any*/ ,
                                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldSets",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueFieldSet",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v47 /*: any*/ ,
                                                                                                        v36 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fields",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v30 /*: any*/ ,
                                                                                                                                v41 /*: any*/ ,
                                                                                                                                v47 /*: any*/ ,
                                                                                                                                v78 /*: any*/ ,
                                                                                                                                v33 /*: any*/ ,
                                                                                                                                v79 /*: any*/ ,
                                                                                                                                v101 /*: any*/ ,
                                                                                                                                v102 /*: any*/ ,
                                                                                                                                v104 /*: any*/ ,
                                                                                                                                v106 /*: any*/ ,
                                                                                                                                v107 /*: any*/ ,
                                                                                                                                v108 /*: any*/ ,
                                                                                                                                v109 /*: any*/ ,
                                                                                                                                v89 /*: any*/ ,
                                                                                                                                v110 /*: any*/ ,
                                                                                                                                v111 /*: any*/ ,
                                                                                                                                v112 /*: any*/ ,
                                                                                                                                v114 /*: any*/ ,
                                                                                                                                v120 /*: any*/ ,
                                                                                                                                v123 /*: any*/ ,
                                                                                                                                v125 /*: any*/ ,
                                                                                                                                v126 /*: any*/ ,
                                                                                                                                v128 /*: any*/ ,
                                                                                                                                v129 /*: any*/ ,
                                                                                                                                v130 /*: any*/ ,
                                                                                                                                v131 /*: any*/ ,
                                                                                                                                v132 /*: any*/ ,
                                                                                                                                v133 /*: any*/ ,
                                                                                                                                v136 /*: any*/ ,
                                                                                                                                v137 /*: any*/ ,
                                                                                                                                v138 /*: any*/ ,
                                                                                                                                v139 /*: any*/ ,
                                                                                                                                v140 /*: any*/ ,
                                                                                                                                v141 /*: any*/ ,
                                                                                                                                v142 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        v144 /*: any*/ 
                                                                                                                                    ],
                                                                                                                                    "type": "JiraSingleSelectField"
                                                                                                                                },
                                                                                                                                v145 /*: any*/ ,
                                                                                                                                v146 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v147 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": "fieldSets(first:500)"
                                                                                },
                                                                                v51 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "PageInfo",
                                                                            "kind": "LinkedField",
                                                                            "name": "pageInfo",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v149 /*: any*/ ,
                                                                                v150 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v157 /*: any*/ ,
                                                                        v159 /*: any*/ ,
                                                                        v51 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "args": v165 /*: any*/ ,
                                                                    "filters": [
                                                                        "fieldSetsInput",
                                                                        "scope"
                                                                    ],
                                                                    "handle": "connection",
                                                                    "key": "firstGroupSection_nativeIssueTable__issues",
                                                                    "kind": "LinkedHandle",
                                                                    "name": "issues"
                                                                },
                                                                v45 /*: any*/ ,
                                                                v41 /*: any*/ ,
                                                                v162 /*: any*/ ,
                                                                v163 /*: any*/ ,
                                                                v164 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v51 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": v161 /*: any*/ ,
                                            "filters": v160 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "IssueNavigatorGroupedListViewPagination__groups",
                                            "kind": "LinkedHandle",
                                            "name": "groups"
                                        }
                                    ],
                                    "type": "JiraGroupedListView"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v166 /*: any*/ ,
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        v62 /*: any*/ ,
                                                        v76 /*: any*/ ,
                                                        v30 /*: any*/ ,
                                                        v148 /*: any*/ ,
                                                        {
                                                            "condition": "shouldQueryHasChildren",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "items": [
                                                                                {
                                                                                    "kind": "Variable",
                                                                                    "name": "filterByProjectKeys.0",
                                                                                    "variableName": "projectKey"
                                                                                }
                                                                            ],
                                                                            "kind": "ListValue",
                                                                            "name": "filterByProjectKeys"
                                                                        }
                                                                    ],
                                                                    "kind": "ScalarField",
                                                                    "name": "hasChildren"
                                                                },
                                                                {
                                                                    "args": [
                                                                        v24 /*: any*/ 
                                                                    ],
                                                                    "kind": "ScalarField",
                                                                    "name": "canHaveChildIssues"
                                                                }
                                                            ]
                                                        },
                                                        v51 /*: any*/ 
                                                    ]
                                                },
                                                v151 /*: any*/ ,
                                                v152 /*: any*/ ,
                                                v156 /*: any*/ ,
                                                v157 /*: any*/ ,
                                                v158 /*: any*/ ,
                                                v45 /*: any*/ ,
                                                v159 /*: any*/ ,
                                                v51 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": v166 /*: any*/ ,
                                            "filters": v160 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "IssueNavigatorListViewPagination__issues",
                                            "kind": "LinkedHandle",
                                            "name": "issues"
                                        }
                                    ],
                                    "type": "JiraListView"
                                }
                            ]
                        },
                        {
                            "args": v26 /*: any*/ ,
                            "concreteType": "JiraUserPreferences",
                            "kind": "LinkedField",
                            "name": "userPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "jqlBuilderSearchMode"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isNaturalLanguageSpotlightTourEnabled"
                                },
                                v51 /*: any*/ 
                            ]
                        },
                        {
                            "args": v167 /*: any*/ ,
                            "kind": "ScalarField",
                            "name": "shouldShowAtlassianIntelligence"
                        },
                        {
                            "args": v167 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "atlassianIntelligenceAction",
                            "plural": false,
                            "selections": [
                                v30 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isAccessible"
                                        }
                                    ],
                                    "type": "JiraAccessAtlassianIntelligenceFeature"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "link"
                                        }
                                    ],
                                    "type": "JiraEnableAtlassianIntelligenceDeepLink"
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v26 /*: any*/ ,
                                    "concreteType": "JiraJqlFieldWithAliases",
                                    "kind": "LinkedField",
                                    "name": "rankField",
                                    "plural": false,
                                    "selections": [
                                        v41 /*: any*/ ,
                                        v49 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "shouldQueryProject",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v27 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        v63 /*: any*/ ,
                                        v124 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectType"
                                        },
                                        v33 /*: any*/ ,
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "alias": "editIssues",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "EDIT_ISSUES"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": v168 /*: any*/ ,
                                                    "storageKey": "action(type:\"EDIT_ISSUES\")"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistcheckissuecreatepermissionsrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "alias": "createIssues",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "CREATE_ISSUES"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": v168 /*: any*/ ,
                                                    "storageKey": "action(type:\"CREATE_ISSUES\")"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "shouldQueryConditionalFormatting",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": v28 /*: any*/ ,
                                                    "concreteType": "JiraFormattingRuleConnection",
                                                    "kind": "LinkedField",
                                                    "name": "conditionalFormattingRules",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraFormattingRuleEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraFormattingRule",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "expression",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v30 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v41 /*: any*/ ,
                                                                                        {
                                                                                            "alias": "singleValueOperator",
                                                                                            "kind": "ScalarField",
                                                                                            "name": "operator"
                                                                                        },
                                                                                        v80 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraFormattingSingleValueOperand"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v41 /*: any*/ ,
                                                                                        {
                                                                                            "alias": "twoValueOperator",
                                                                                            "kind": "ScalarField",
                                                                                            "name": "operator"
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraFormattingTwoValueOperand"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v41 /*: any*/ ,
                                                                                        {
                                                                                            "alias": "multipleValueOperator",
                                                                                            "kind": "ScalarField",
                                                                                            "name": "operator"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "values"
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraFormattingMultipleValueOperand"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v41 /*: any*/ ,
                                                                                        {
                                                                                            "alias": "noValueOperator",
                                                                                            "kind": "ScalarField",
                                                                                            "name": "operator"
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraFormattingNoValueOperand"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraColor",
                                                                            "kind": "LinkedField",
                                                                            "name": "formattingColor",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v33 /*: any*/ ,
                                                                                v91 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v33 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "formattingArea"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "conditionalFormattingRules(first:20)"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "153407de5ca4e1ced91ee9ec4084e2a660acb50a392391bbd13c261b0bedcd42",
            "metadata": {},
            "name": "main_IssueNavigatorQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider": (0, $1xxk0.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $dttgK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider": (0, $c5npJ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider": (0, $5wdbf.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $gY76A.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider": (0, $bqIzm.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": (0, $k3PJZ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $adKYy.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $fjldt.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $5qm7M.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": (0, $iLxt4.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $l8ssf.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": (0, $5ykrX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": (0, $ggSVP.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $knfEI.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $hBvdF.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider": (0, $cNAof.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistcheckissuecreatepermissionsrelayprovider": (0, $5Bxi4.default)
            }
        }
    };
}();
$ff9dfb30fc1873c4$var$node.hash = "cd2e7787a13530065b3d32c5fccc0f81";
var $ff9dfb30fc1873c4$export$2e2bcd8739ae039 = $ff9dfb30fc1873c4$var$node;

});
parcelRegister("cNAof", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5147da8196a86c3$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $a5147da8196a86c3$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('group_by_any_fields_technical');
    }
};

});

parcelRegister("bqIzm", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d9218d128e87a96$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");
const $9d9218d128e87a96$export$8777089b74f8b497 = {
    get () {
        return (0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false);
    }
};
var $9d9218d128e87a96$export$2e2bcd8739ae039 = $9d9218d128e87a96$export$8777089b74f8b497;

});

parcelRegister("1xxk0", function(module, exports) {

$parcel$export(module.exports, "default", () => $55ba50657e25f3ba$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");
var $55ba50657e25f3ba$export$2e2bcd8739ae039 = {
    get () {
        return (0, $6s1PB.expVal)('saved_list_view', 'isEnabled', false);
    }
};

});

parcelRegister("c5npJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a21ee23f5837435$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $2a21ee23f5837435$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('saved_list_view_technical_changes');
    }
};

});

parcelRegister("5Bxi4", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c80591faf091fb2$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $5c80591faf091fb2$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jira_list_check_issue_create_permissions');
    }
};

});

parcelRegister("k3PJZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3084fb4096ebf03f$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $3084fb4096ebf03f$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jsc_list_reparenting');
    }
};

});

parcelRegister("5wdbf", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cc50bf0ec4f935f$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
const $4cc50bf0ec4f935f$var$JscIssueRankingRelayProvider = {
    get () {
        return (0, $4R6GH.fg)('jsc_list_reranking_gate');
    }
};
var $4cc50bf0ec4f935f$export$2e2bcd8739ae039 = $4cc50bf0ec4f935f$var$JscIssueRankingRelayProvider;

});


parcelRegister("5cSAN", function(module, exports) {

$parcel$export(module.exports, "createViewAri", () => $ac366cc9f2edba1b$export$8e9e81ca81fb9409);
$parcel$export(module.exports, "useViewAri", () => $ac366cc9f2edba1b$export$b6b78fb187396ce9);

var $cGvzG = parcelRequire("cGvzG");

var $fY39E = parcelRequire("fY39E");

var $koeKL = parcelRequire("koeKL");

var $lODMY = parcelRequire("lODMY");
const $ac366cc9f2edba1b$var$useViewItemId = (0, $lODMY.createRouterSelector)((state)=>state.match?.params?.itemId);
const $ac366cc9f2edba1b$export$8e9e81ca81fb9409 = ({ activationId: activationId, cloudId: cloudId, layout: layout, projectId: projectId, viewItemId: viewItemId })=>{
    const layoutPart = layout ? `/layout/${layout}` : '';
    if (projectId) {
        const viewItemIdPart = viewItemId ? `/${viewItemId}` : '';
        return (0, $cGvzG.JiraViewAri).create({
            activationId: activationId,
            scopeId: `${projectId}/issues${viewItemIdPart}${layoutPart}`,
            scopeType: 'project',
            siteId: cloudId
        }).toString();
    }
    return (0, $cGvzG.JiraViewAri).create({
        activationId: activationId,
        scopeId: `issue-navigator${layoutPart}`,
        scopeType: 'global',
        siteId: cloudId
    }).toString();
};
const $ac366cc9f2edba1b$export$b6b78fb187396ce9 = ({ layout: layout, projectId: projectId })=>{
    const activationId = (0, $fY39E.useActivationId)();
    const cloudId = (0, $koeKL.useCloudId)();
    const viewItemId = $ac366cc9f2edba1b$var$useViewItemId();
    return $ac366cc9f2edba1b$export$8e9e81ca81fb9409({
        activationId: activationId,
        cloudId: cloudId,
        layout: layout,
        projectId: projectId,
        viewItemId: viewItemId
    });
};

});
parcelRegister("cGvzG", function(module, exports) {

$parcel$export(module.exports, "JiraViewAri", () => $93c1e64ca07778c1$export$259cce321cdbcc);

var $frfhC = parcelRequire("frfhC");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/view/manifest.ts
var $93c1e64ca07778c1$var$jiraViewAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $frfhC.JiraViewAriResourceOwner),
    resourceType: (0, $frfhC.JiraViewAriResourceType),
    resourceIdSlug: "activation/{activationId}/{scopeType}/{scopeId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        scopeType: /(global|project|board)/,
        // eslint-disable-line no-useless-escape
        scopeId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/view/index.ts
var $93c1e64ca07778c1$export$259cce321cdbcc = class _JiraViewAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._scopeType = opts.resourceIdSegmentValues.scopeType, this._scopeId = opts.resourceIdSegmentValues.scopeId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get scopeType() {
        return this._scopeType;
    }
    get scopeId() {
        return this._scopeId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $93c1e64ca07778c1$var$jiraViewAriStaticOpts.qualifier,
            platformQualifier: $93c1e64ca07778c1$var$jiraViewAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $93c1e64ca07778c1$var$jiraViewAriStaticOpts.resourceOwner,
            resourceType: $93c1e64ca07778c1$var$jiraViewAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.scopeType}/${opts.scopeId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                scopeType: opts.scopeType,
                scopeId: opts.scopeId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $93c1e64ca07778c1$var$jiraViewAriStaticOpts);
        return new _JiraViewAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $93c1e64ca07778c1$var$jiraViewAriStaticOpts);
        return new _JiraViewAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            scopeType: this.scopeType,
            scopeId: this.scopeId
        };
    }
};

});
parcelRegister("frfhC", function(module, exports) {

$parcel$export(module.exports, "JiraViewAriResourceOwner", () => $b3d53b90426675a7$export$c63cbf12e88f62b6);
$parcel$export(module.exports, "JiraViewAriResourceType", () => $b3d53b90426675a7$export$4b456bf9436bd47e);
// src/jira/view/types.ts
var $b3d53b90426675a7$export$c63cbf12e88f62b6 = "jira", $b3d53b90426675a7$export$4b456bf9436bd47e = "view";

});



parcelRegister("5bSAg", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_RELAY", () => $2134dee38b024167$export$c300d3b7f3dc697d);
$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_FILTER_RELAY", () => $2134dee38b024167$export$b99d8b4e19091835);
$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_HYDRATION_RELAY", () => $2134dee38b024167$export$1b65799bbeba8a33);
$parcel$export(module.exports, "defaultOrderFields", () => $2134dee38b024167$export$2bd49f8f262d7cbb);
$parcel$export(module.exports, "sortDirections", () => $2134dee38b024167$export$73034536b9adc928);
const $2134dee38b024167$export$c300d3b7f3dc697d = 'ISSUE_NAVIGATOR_RELAY';
const $2134dee38b024167$export$b99d8b4e19091835 = 'ISSUE_NAVIGATOR_FILTER_RELAY';
const $2134dee38b024167$export$1b65799bbeba8a33 = 'ISSUE_NAVIGATOR_HYDRATION_RELAY';
const $2134dee38b024167$export$2bd49f8f262d7cbb = {
    created: 'created',
    lastviewed: 'lastviewed',
    updated: 'updated'
};
const $2134dee38b024167$export$73034536b9adc928 = {
    ASC: 'ASC',
    DESC: 'DESC',
    NONE: 'NONE'
};

});

parcelRegister("aBKbA", function(module, exports) {

$parcel$export(module.exports, "getDefaultJqlGin", () => $b87185164056f069$export$8780b1523384f42d);
$parcel$export(module.exports, "getParams", () => $b87185164056f069$export$ec161d740909e39d);
$parcel$export(module.exports, "getJqlOrFilterId", () => $b87185164056f069$export$b968a035fc2aa57b);
$parcel$export(module.exports, "isChromelessRoute", () => $b87185164056f069$export$cc6019019381b4fd);
/* eslint-disable jira/import-whitelist */ 
var $9Nvh7 = parcelRequire("9Nvh7");

var $g5X3G = parcelRequire("g5X3G");

var $h2eGN = parcelRequire("h2eGN");

var $5bSAg = parcelRequire("5bSAg");
const $b87185164056f069$export$8780b1523384f42d = ()=>`ORDER BY ${(0, $5bSAg.defaultOrderFields).created} ${(0, $5bSAg.sortDirections).DESC}`;
const $b87185164056f069$export$ec161d740909e39d = ({ match: { params: params }, query: query })=>{
    const { projectKey: projectKey, issueKey: issueKey } = params;
    const { filter: filter, jql: jql } = query;
    // Default JQL when no relevant query parameter is set
    const defaultJql = projectKey !== null && projectKey !== undefined ? (0, $h2eGN.getDefaultJql)((0, $g5X3G.toProjectKey)(projectKey)) : $b87185164056f069$export$8780b1523384f42d();
    return {
        page: 1,
        jql: jql,
        issueKey: issueKey,
        projectKey: projectKey,
        filter: filter,
        defaultJql: defaultJql
    };
};
const $b87185164056f069$export$b968a035fc2aa57b = (defaultJql, jqlParam, filter, projectKey)=>{
    // If JQL param has been defined (even if it's empty) we should use it
    if (typeof jqlParam === 'string') return {
        jql: jqlParam
    };
    // If filter is non-empty then use the filter parameter
    if (typeof filter === 'string' && filter !== '') {
        if ((0, $9Nvh7.isFilterId)(filter)) return {
            filterId: filter
        };
        const filterJql = projectKey !== null && projectKey !== undefined ? (0, $h2eGN.mapFilterToJql)(projectKey, filter) : undefined;
        if (filterJql !== undefined) return {
            jql: filterJql
        };
    }
    // Fallback to the default JQL if neither JQL or valid filter parameters have been provided.
    return {
        jql: defaultJql
    };
};
const $b87185164056f069$export$cc6019019381b4fd = ({ route: route })=>{
    return route.layout?.isChromeless ?? false;
};

});
parcelRegister("h2eGN", function(module, exports) {

$parcel$export(module.exports, "isFilterKey", () => $0c6318e867c8ff1b$export$2cad587bb603edda);
$parcel$export(module.exports, "mapFilterToJql", () => $0c6318e867c8ff1b$export$1d71dda738f608f);
$parcel$export(module.exports, "getDefaultJql", () => $0c6318e867c8ff1b$export$346d50fe8350b1d0);
$parcel$export(module.exports, "getUrlPrefix", () => $0c6318e867c8ff1b$export$821d4141d135e0d0);

var $ebyGx = parcelRequire("ebyGx");

var $6UAdF = parcelRequire("6UAdF");

var $h2Dp1 = parcelRequire("h2Dp1");
const $0c6318e867c8ff1b$export$2cad587bb603edda = (filter)=>typeof filter === 'string' && filter in (0, $h2Dp1.Filters);
const $0c6318e867c8ff1b$export$1d71dda738f608f = (projectKey, filter)=>{
    if (!$0c6318e867c8ff1b$export$2cad587bb603edda(filter)) return undefined;
    const clauses = [
        `project = "${projectKey}"`
    ];
    let order = (0, $6UAdF.DEFAULT_ORDER_FIELD);
    const direction = (0, $6UAdF.DEFAULT_SORT_DIRECTION);
    switch((0, $h2Dp1.Filters)[filter]){
        case (0, $h2Dp1.Filters).myopenissues:
            clauses.push('assignee IN (currentUser())');
            clauses.push(`statusCategory IN (${(0, $h2Dp1.StatusCategoryValues).TO_DO}, ${(0, $h2Dp1.StatusCategoryValues).IN_PROGRESS})`);
            break;
        case (0, $h2Dp1.Filters).reportedbyme:
            clauses.push('reporter IN (currentUser())');
            break;
        case (0, $h2Dp1.Filters).allopenissues:
            clauses.push(`statusCategory IN (${(0, $h2Dp1.StatusCategoryValues).TO_DO}, ${(0, $h2Dp1.StatusCategoryValues).IN_PROGRESS})`);
            order = (0, $6UAdF.defaultOrderFields).updated;
            break;
        case (0, $h2Dp1.Filters).doneissues:
            clauses.push(`statusCategory = ${(0, $h2Dp1.StatusCategoryValues).DONE}`);
            break;
        case (0, $h2Dp1.Filters).recentlyviewed:
            order = (0, $6UAdF.defaultOrderFields).lastviewed;
            break;
        case (0, $h2Dp1.Filters).resolvedrecently:
            clauses.push('resolved >= -1w');
            order = (0, $6UAdF.defaultOrderFields).updated;
            break;
        case (0, $h2Dp1.Filters).updatedrecently:
            order = (0, $6UAdF.defaultOrderFields).updated;
            break;
        case (0, $h2Dp1.Filters).allissues:
            order = (0, $6UAdF.defaultOrderFields).created;
            break;
        default:
    }
    return `${clauses.join(' AND ')} ORDER BY ${order} ${direction}`.trim();
};
const $0c6318e867c8ff1b$export$346d50fe8350b1d0 = (projectKey)=>`project = "${projectKey}" ORDER BY ${0, $6UAdF.DEFAULT_ORDER_FIELD} ${0, $6UAdF.DEFAULT_SORT_DIRECTION}`;
const $0c6318e867c8ff1b$export$e5b4f9d05e643346 = (search, match)=>({
        ...(0, $ebyGx.parse)(search),
        ...match && match.params
    });
const $0c6318e867c8ff1b$export$821d4141d135e0d0 = (url)=>{
    const match = url.match(/^(.*)\/projects.*$/);
    return (match && match[1]) ?? '';
};

});
parcelRegister("h2Dp1", function(module, exports) {

$parcel$export(module.exports, "Filters", () => $cc363d6a082b1433$export$92a576f896a9bf72);
$parcel$export(module.exports, "StatusCategoryValues", () => $cc363d6a082b1433$export$72d6e2acce8f36fd);
const $cc363d6a082b1433$export$92a576f896a9bf72 = {
    myopenissues: Symbol('myopenissues'),
    reportedbyme: Symbol('reportedbyme'),
    allopenissues: Symbol('allopenissues'),
    doneissues: Symbol('doneissues'),
    recentlyviewed: Symbol('recentlyviewed'),
    resolvedrecently: Symbol('resolvedrecently'),
    updatedrecently: Symbol('updatedrecently'),
    allissues: Symbol('allissues')
};
const $cc363d6a082b1433$export$72d6e2acce8f36fd = {
    TO_DO: '"To Do"',
    DONE: '"Done"',
    IN_PROGRESS: '"In Progress"'
};

});





parcelRegister("3uU6P", function(module, exports) {

$parcel$export(module.exports, "getRouteReporting", () => $96adb79ea93c1c80$export$1300cb25a03c28fe);
const $96adb79ea93c1c80$export$1300cb25a03c28fe = ()=>({
        id: 'issue-navigator',
        packageName: 'issueNavigator',
        teamName: 'empanada'
    });

});

parcelRegister("gGOoR", function(module, exports) {

$parcel$export(module.exports, "default", () => $265d2c27687434ef$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ds5qV = parcelRequire("ds5qV");

var $doZTA = parcelRequire("doZTA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$265d2c27687434ef$export$2e2bcd8739ae039 = ()=>{
    const [{ match: match }] = (0, $doZTA.useRouter)();
    const issueKey = match.params.issueKey ?? '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: `/issues/${issueKey}`
    });
};

});

parcelRegister("b8f12", function(module, exports) {

$parcel$export(module.exports, "globalIssueNavigatorGinRedirectPageEntryPoint", () => $b7591135658477a3$export$f0e4197c4e8c99ac);
$parcel$export(module.exports, "issueNavigatorPageEntryPoint", () => $b7591135658477a3$export$b75ca1c5551bc52f);
$parcel$export(module.exports, "issueNavigatorWithoutHorizontalNavPageEntryPoint", () => $b7591135658477a3$export$ebe022658b1c5d7a);
$parcel$export(module.exports, "issueNavigatorPinRedirectPageEntryPoint", () => $b7591135658477a3$export$a90e8f2ed95763c3);
$parcel$export(module.exports, "issueNavigatorEmbedPageEntryPoint", () => $b7591135658477a3$export$650aa18210eea5a8);
$parcel$export(module.exports, "LazyGlobalIssueNavigator", () => $b7591135658477a3$export$8ff267588532c2ce);

var $kxZPA = parcelRequire("kxZPA");

var $3K3m0 = parcelRequire("3K3m0");

var $lmyls = parcelRequire("lmyls");

var $fo6b8 = parcelRequire("fo6b8");

var $lkFvK = parcelRequire("lkFvK");

var $5VqRy = parcelRequire("5VqRy");

var $mH8xj = parcelRequire("mH8xj");

var $4Exdo = parcelRequire("4Exdo");
const $b7591135658477a3$export$f0e4197c4e8c99ac = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $4Exdo.globalIssueNavigatorGinRedirectEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).FILTERS
});
const $b7591135658477a3$export$b75ca1c5551bc52f = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $3K3m0.issueNavigatorEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $b7591135658477a3$export$ebe022658b1c5d7a = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $3K3m0.issueNavigatorEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $b7591135658477a3$export$a90e8f2ed95763c3 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $mH8xj.issueNavigatorPinRedirectEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $b7591135658477a3$export$650aa18210eea5a8 = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $5VqRy.issueNavigatorEmbedEntrypoint)
});

const $b7591135658477a3$export$8ff267588532c2ce = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("7Kvfb")), {
    moduleId: "./src/packages/spa-apps/issue-navigator/global-issue-navigator/src/index.tsx"
});

});
parcelRegister("3K3m0", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorEntrypoint", () => $a876be73045a44c8$export$4ec136b0c737540b);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $5T6bY = parcelRequire("5T6bY");

var $4R6GH = parcelRequire("4R6GH");

const $a876be73045a44c8$export$4ec136b0c737540b = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("iD2vd")), {
        moduleId: "7afd1266",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (entryPointParams)=>{
        const issueKey = (0, $4R6GH.fg)('slv-4_migrate_nin_selected_issue_route') ? entryPointParams?.context?.match?.query?.selectedIssue : entryPointParams?.context?.match?.params?.issueKey;
        let preloadProps = {};
        // exclude nativeIssueTableEntryPoint from preloading on the issue route
        if (!issueKey) preloadProps = {
            entryPoints: {
                nativeIssueTableEntryPoint: {
                    entryPoint: (0, $5T6bY.nativeIssueTableEntryPoint),
                    entryPointParams: entryPointParams
                }
            }
        };
        return preloadProps;
    }
});

});
parcelRegister("5T6bY", function(module, exports) {

$parcel$export(module.exports, "nativeIssueTableEntryPoint", () => $b9fa91d89cda3ec1$export$df35b18d762f614);

var $fEDBv = parcelRequire("fEDBv");

var $2OZhN = parcelRequire("2OZhN");

const $b9fa91d89cda3ec1$export$df35b18d762f614 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("cXMTX")).then((module)=>module.NativeIssueTableEntryPoint), {
        moduleId: "b6718107",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("cXMTX", function(module, exports) {

let $9700ed8763600864$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $9700ed8763600864$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $9700ed8763600864$var$load("k6g9p")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $9700ed8763600864$var$load("czifk")
        ]);
    }, function() {
        return Promise.all([
            $9700ed8763600864$var$load("kcs34")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $9700ed8763600864$var$load("cTJTG"),
            $9700ed8763600864$var$load("l253H"),
            $9700ed8763600864$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $9700ed8763600864$var$load("4Qxp7")
        ]);
    }),
    $9700ed8763600864$var$load("ffQaD"),
    $9700ed8763600864$var$load("kvRbA"),
    $9700ed8763600864$var$load("fliVL"),
    $9700ed8763600864$var$load("kQN3l")
]).then(()=>parcelRequire('bPcgy'));

});


parcelRegister("iD2vd", function(module, exports) {

let $d8fdcf785688372d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d8fdcf785688372d$var$load("ffQaD"),
    $d8fdcf785688372d$var$load("kvRbA"),
    $d8fdcf785688372d$var$load("i5vpK")
]).then(()=>parcelRequire('f6FZF'));

});


parcelRegister("5VqRy", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorEmbedEntrypoint", () => $2c9d817c5420d6c2$export$407d940f927eac56);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $5T6bY = parcelRequire("5T6bY");

const $2c9d817c5420d6c2$export$407d940f927eac56 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("fJUQW")), {
        moduleId: "9aa91f84",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (entryPointParams)=>{
        return {
            entryPoints: {
                nativeIssueTableEntryPoint: {
                    entryPoint: (0, $5T6bY.nativeIssueTableEntryPoint),
                    entryPointParams: entryPointParams
                }
            }
        };
    }
});

});
parcelRegister("fJUQW", function(module, exports) {

let $b75728c45e5ab187$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $b75728c45e5ab187$var$load("ffQaD"),
    $b75728c45e5ab187$var$load("kvRbA"),
    $b75728c45e5ab187$var$load("lUgg5")
]).then(()=>parcelRequire('gDIMg'));

});


parcelRegister("mH8xj", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorPinRedirectEntrypoint", () => $5f84d963532ff7c4$export$cc17cd3f65b3828f);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $5f84d963532ff7c4$export$cc17cd3f65b3828f = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("8U0li")), {
        moduleId: "8d4a4d33",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8U0li", function(module, exports) {

let $67b3d1b6bdf864b1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $67b3d1b6bdf864b1$var$load("bdUIz").then(()=>parcelRequire('kF7iq'));

});


parcelRegister("4Exdo", function(module, exports) {

$parcel$export(module.exports, "globalIssueNavigatorGinRedirectEntrypoint", () => $45c50752d19052f1$export$3185a5139b079ec0);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $h9kbL = parcelRequire("h9kbL");

var $5T6bY = parcelRequire("5T6bY");

const $45c50752d19052f1$export$3185a5139b079ec0 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("cgz0a")), {
        moduleId: "e648b5f0",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (entryPointParams)=>{
        const issueKey = entryPointParams?.context?.match?.params?.issueKey;
        return {
            entryPoints: {
                globalIssueNavigatorEntryPoint: {
                    entryPoint: (0, $h9kbL.globalIssueNavigatorEntryPoint),
                    entryPointParams: entryPointParams
                },
                ...!issueKey ? {
                    nativeIssueTableEntryPoint: {
                        entryPoint: (0, $5T6bY.nativeIssueTableEntryPoint),
                        entryPointParams: entryPointParams
                    }
                } : {}
            }
        };
    }
});

});
parcelRegister("h9kbL", function(module, exports) {

$parcel$export(module.exports, "globalIssueNavigatorEntryPoint", () => $9cbef7a45f505720$export$79ac0647e40ae809);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $9cbef7a45f505720$export$79ac0647e40ae809 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("7Kvfb")).then((module)=>module.GlobalIssueNavigatorSPAEntryPoint), {
        moduleId: "c478d9ce",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("7Kvfb", function(module, exports) {

let $5a4510abac9857c6$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $5a4510abac9857c6$var$load("ffQaD"),
    $5a4510abac9857c6$var$load("kvRbA"),
    $5a4510abac9857c6$var$load("94Pxn")
]).then(()=>parcelRequire('68kUi'));

});


parcelRegister("cgz0a", function(module, exports) {

let $8ee2214921824dab$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8ee2214921824dab$var$load("hu7f4").then(()=>parcelRequire('5XrRK'));

});




parcelRegister("hxK6L", function(module, exports) {

$parcel$export(module.exports, "globalMailSettingsRouteEntry", () => $fc43fd37745c00e2$export$5e1236665a530df4);

var $ffza4 = parcelRequire("ffza4");

var $bwLf9 = parcelRequire("bwLf9");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $bzD24 = parcelRequire("bzD24");

var $euIkX = parcelRequire("euIkX");

var $21A4f = parcelRequire("21A4f");
const $fc43fd37745c00e2$export$5e1236665a530df4 = (0, $7NszV.createEntry)((0, $bzD24.globalMailSettingsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.global-mail-settings',
        component: (0, $bwLf9.default)(()=>true, (0, $21A4f.default), (0, $euIkX.default)),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $21A4f.LazyGlobalMailSettings)
        ]
    }));

});
parcelRegister("bzD24", function(module, exports) {

$parcel$export(module.exports, "globalMailSettingsRoute", () => $b88e0402aff618ba$export$e69b84daf70501b3);
const $b88e0402aff618ba$export$e69b84daf70501b3 = {
    name: 'global-mail-settings',
    path: '/secure/admin/global-mail-settings',
    exact: true
};

});

parcelRegister("euIkX", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a0afe23818eb6ed$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3mK2k = parcelRequire("3mK2k");
var /** This exists to be used as a route since the redirect as a route and redirect as a component
 * have different props, and flow complains. */ // @ts-expect-error - Type '{}' is missing the following properties from type 'Pick<Omit<Omit<RouteContext & { flagService: FlagService; createAnalyticsEvent: (arg1: { action: string; }) => UIAnalyticsEvent; }, keyof WithAnalyticsEventsProps> & RefAttributes<...>, "flagService">, keyof RouteContext | keyof RefAttributes<...>>': location, query, route, match, action
// eslint-disable-next-line jira/import/no-anonymous-default-export
$1a0afe23818eb6ed$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3mK2k.default), null);

});
parcelRegister("3mK2k", function(module, exports) {

$parcel$export(module.exports, "default", () => $1513009dd97e8af4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $cb25w = parcelRequire("cb25w");

var $dMnMc = parcelRequire("dMnMc");

var $2YZCu = parcelRequire("2YZCu");

var $34Vv8 = parcelRequire("34Vv8");

var $j8DrX = parcelRequire("j8DrX");

var $8zOmE = parcelRequire("8zOmE");

var $1bQGJ = parcelRequire("1bQGJ");

var $eNf8a = parcelRequire("eNf8a");

var $4R6GH = parcelRequire("4R6GH");

var $883db = parcelRequire("883db");
const $1513009dd97e8af4$var$THRESHOLD = 30000;
const $1513009dd97e8af4$var$getScopeType = (scope)=>{
    switch(scope.identifierType){
        case 'boardId':
            return 'board';
        case 'projectId':
        case 'projectKey':
            return scope.pageType === 'settings' ? 'projectSettings' : 'project';
        default:
            return '';
    }
};
const $1513009dd97e8af4$var$sessionStorageProvider = (0, $eNf8a.createSessionStorageProvider)('', false);
class $1513009dd97e8af4$export$836fe1ef2cfde075 extends (0, $5uXOq.Component) {
    componentDidMount() {
        // eslint-disable-next-line jira/react-magnetic-di/no-unneeded
        (0, $gKZoD.di)(sessionStorage, $1513009dd97e8af4$var$sessionStorageProvider, window);
        const { location: { pathname: pathname, search: search }, flagService: flagService, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        const redirectPathname = pathname.startsWith('//') ? pathname.substr(1) : pathname;
        const lastRedirectTime = (0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? Number($1513009dd97e8af4$var$sessionStorageProvider.get(redirectPathname)) : Number(sessionStorage.getItem(redirectPathname));
        if (!lastRedirectTime) (0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $1513009dd97e8af4$var$sessionStorageProvider.set(redirectPathname, Date.now().toString()) : sessionStorage.setItem(redirectPathname, Date.now().toString());
        else if (Date.now() - lastRedirectTime < $1513009dd97e8af4$var$THRESHOLD) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const scopeData = (0, $dMnMc.default)(window.location.href, (0, $j8DrX.default));
            const scope = $1513009dd97e8af4$var$getScopeType(scopeData);
            (0, $2YZCu.default).safeErrorWithoutCustomerData('redirect-loop.error', 'Redirect error caused by invalid url', {
                scope: scope
            });
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({
                action: 'entered'
            }), 'redirect-loop entered', 'endeavour.spa.redirect-loop', {
                scope: scope
            });
            flagService.showFlag((0, $883db.errorFlag)());
            (0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $1513009dd97e8af4$var$sessionStorageProvider.remove(redirectPathname) : sessionStorage.removeItem(redirectPathname);
            return;
        } else (0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $1513009dd97e8af4$var$sessionStorageProvider.remove(redirectPathname) : sessionStorage.removeItem(redirectPathname);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.assign(redirectPathname + search);
    }
    render() {
        return null;
    }
}
var // @ts-expect-error - TS2345 - Argument of type 'ForwardRefExoticComponent<Pick<WithAnalyticsEventsProps, never> & RefAttributes<any>>' is not assignable to parameter of type 'ComponentType<{ flagService: FlagService; }>'. | TS2345 - Argument of type 'typeof RedirectToLegacyRouting' is not assignable to parameter of type '(((props: WithAnalyticsEventsProps) => ReactElement<any, string | ((props: any) => ReactElement<any, any> | null) | (new (props: any) => Component<any, any, any>)> | null) & typeof RedirectToLegacyRouting) | ((new (props: WithAnalyticsEventsProps) => Component<...>) & typeof RedirectToLegacyRouting)'.
$1513009dd97e8af4$export$2e2bcd8739ae039 = (0, $1bQGJ.withRouter)((0, $34Vv8.default)((0, $cb25w.default)()($1513009dd97e8af4$export$836fe1ef2cfde075)));

});
parcelRegister("dMnMc", function(module, exports) {

$parcel$export(module.exports, "getBoardId", () => $fe24052863a91d57$export$557c2f222778cea6);
$parcel$export(module.exports, "default", () => $fe24052863a91d57$export$2e2bcd8739ae039);

var $aZsz6 = parcelRequire("aZsz6");

var $95bh0 = parcelRequire("95bh0");

var $556I0 = parcelRequire("556I0");

var $5PyNy = parcelRequire("5PyNy");

var $79s9E = parcelRequire("79s9E");
const $fe24052863a91d57$var$projectScopeDataMap = {
    routes: [
        // Query string
        /[&?]projectKey=(\w+)/i,
        // Service desk, business and some software
        /\/projects\/(\w+)/i,
        // Issue page (not root)
        /\/browse\/(\w+)-\d+\??((?!(filter=|jql=)).)*$/i,
        // Project settings
        /\/plugins\/servlet\/project-config\/(\w+)/i,
        // Service Desk project settings
        /\/servicedesk\/admin\/(\w+)/i,
        // Browse project
        /\/browse\/(\w+)\/?(\?.*)?$/i
    ],
    meta: [
        // Software
        'ghx-project-key',
        // Settings
        'projectKey',
        // Reports
        'ajs-project-key'
    ]
};
const $fe24052863a91d57$var$getProjectId = (url)=>{
    const projectIdRoutes = [
        // Query string - reports
        /[&?]selectedProjectId=(\w+)/i,
        // Query string - edit project, delete project
        /[&?]pid=(\w+)/i,
        // Query string - release notes
        /[&?]projectId=(\w+)/i,
        // Query string - connect items
        /[&?]project\.id=(\w+)/i
    ];
    return projectIdRoutes.reduce((foundId, route)=>{
        if (foundId) return foundId;
        const match = url.match(route);
        if (match != null) {
            const [, projectId] = match;
            if (projectId) return projectId;
        }
        return null;
    }, null);
};
/**
 * Extracts certain data out of the URL that is required by other data providers.
 */ const $fe24052863a91d57$var$getProjectKey = (url, getMeta)=>{
    let projectKey = null;
    $fe24052863a91d57$var$projectScopeDataMap.meta.forEach((tagName)=>{
        const value = getMeta(tagName);
        if (value && projectKey == null) projectKey = value;
    });
    $fe24052863a91d57$var$projectScopeDataMap.routes.forEach((route)=>{
        const match = url.match(route);
        if (match != null && projectKey == null) [, projectKey] = match;
    });
    return projectKey || undefined;
};
const $fe24052863a91d57$export$557c2f222778cea6 = (url)=>{
    try {
        const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($aZsz6)))(url, true);
        let boardId = parsed.query ? parsed.query.rapidView : null;
        if (boardId == null) {
            const match = url.match(/\/boards\/(\d+)/i);
            boardId = match ? match[1] : null;
        }
        return boardId;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        return null;
    }
};
const $fe24052863a91d57$var$isProjectSettingsConnectRoute = ({ getMeta: getMeta, url: url })=>getMeta('ajs-in-admin-mode') === 'true' && (0, $556I0.default).some((regex)=>regex.test(url)) || (0, $5PyNy.default).some((regex)=>regex.test(url));
const $fe24052863a91d57$var$isProjectPage = ({ getMeta: getMeta, projectId: projectId, projectKey: projectKey, url: url })=>{
    // Project routes that have a project id in the URL
    const isProject = ()=>{
        const routes = [
            /\/secure\/ConfigureReport(!default)?\.jspa.+selectedProjectId/i,
            /\/secure\/project\/(DeleteProject|EditProject)!default\.jspa.+pid/i,
            /\/secure\/ReleaseNote.jspa.+projectId/i,
            /\/secure\/ConfigureReleaseNote.jspa.+projectId/i
        ];
        return $fe24052863a91d57$var$isProjectSettingsConnectRoute({
            getMeta: getMeta,
            url: url
        }) || routes.some((regex)=>regex.test(url));
    };
    return projectKey || projectId && isProject();
};
const $fe24052863a91d57$var$isProjectSettingsPage = ({ getMeta: getMeta, url: url })=>(0, $79s9E.default).some((route)=>url.match(route)) || $fe24052863a91d57$var$isProjectSettingsConnectRoute({
        getMeta: getMeta,
        url: url
    });
const $fe24052863a91d57$var$getProjectPageType = (getMeta, url)=>{
    if ($fe24052863a91d57$var$isProjectSettingsPage({
        getMeta: getMeta,
        url: url
    })) return 'settings';
    const decorator = getMeta('decorator');
    const isSettings = getMeta('is-settings-page') === 'true';
    return decorator === 'admin' || decorator === 'atl.admin' || isSettings ? 'settings' : undefined;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fe24052863a91d57$export$2e2bcd8739ae039 = (url, getMeta)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const extractedData = {};
    const boardId = $fe24052863a91d57$export$557c2f222778cea6(url);
    if (boardId) extractedData.boardId = boardId;
    const projectKey = url.includes('/plugins/servlet/ac/') || url.includes('/settings/projects/') ? undefined : $fe24052863a91d57$var$getProjectKey(url, getMeta);
    if (projectKey) extractedData.projectKey = projectKey;
    const projectId = $fe24052863a91d57$var$getProjectId(url);
    if (projectId) extractedData.projectId = projectId;
    const isProject = $fe24052863a91d57$var$isProjectPage({
        getMeta: getMeta,
        projectId: projectId,
        projectKey: projectKey,
        url: url
    });
    extractedData.pageType = isProject ? $fe24052863a91d57$var$getProjectPageType(getMeta, url) : undefined;
    const identifier = (0, $95bh0.getScopeIdentifier)({
        boardId: boardId,
        projectKey: projectKey,
        projectId: isProject ? projectId : null
    });
    // This gets around a flow inexact type error
    return {
        ...extractedData,
        ...identifier
    };
};

});
parcelRegister("556I0", function(module, exports) {

$parcel$export(module.exports, "default", () => $2aff61bbf8b5a2cf$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $2aff61bbf8b5a2cf$export$2e2bcd8739ae039 = [
    // Regex groups: addonKey, pageKey
    /\/plugins\/servlet\/ac\/(.+)\/([^?\s]+)/i
];

});

parcelRegister("5PyNy", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d489e15712c5e17$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $5d489e15712c5e17$export$2e2bcd8739ae039 = [
    /\/plugins\/servlet\/ac\/com\.xpandit\.plugins\.jiraxporter\/jira-xporter-manage-project/i,
    /\/plugins\/servlet\/ac\/com\.xpandit\.plugins\.xray\/xray-project-settings-all/i
];

});

parcelRegister("79s9E", function(module, exports) {

$parcel$export(module.exports, "default", () => $efe7a2022eaf0f59$export$2e2bcd8739ae039);

var $5PyNy = parcelRequire("5PyNy");
const $efe7a2022eaf0f59$var$commonClassicProjectSettingsRoutes = [
    /\/plugins\/servlet\/project-config/i,
    /\/jira\/software\/c\/projects\/.+\/settings\/code/i,
    /\/jira\/software\/c\/projects\/.+\/settings\/deployments/i,
    /\/plugins\/servlet\/project-config\/.+\/administer-components/i,
    /\/plugins\/servlet\/project-config\/.+\/administer-versions/i,
    /\/plugins\/servlet\/project-config\/.+\/fields/i,
    /\/plugins\/servlet\/project-config\/.+\/issuesecurity/i,
    /\/plugins\/servlet\/project-config\/.+\/issuetypes/i,
    /\/plugins\/servlet\/project-config\/.+\/notifications/i,
    /\/plugins\/servlet\/project-config\/.+\/permissions/i,
    /\/plugins\/servlet\/project-config\/.+\/screens/i,
    /\/plugins\/servlet\/project-config\/.+\/workflows/i,
    /\/project\/DeleteProject!default\.jspa/i,
    /\/secure\/project\/EditProject!default\.jspa/i,
    // Collectors
    /\/secure\/AddCollector/i,
    /\/secure\/InsertCollectorHelp/i,
    /\/ViewCollector!default\.jspa\?projectKey=/i,
    /\/ViewCollectors!default\.jspa\?projectKey=/i,
    // Development tools
    /\/secure\/ConfigureDevStatus.jspa\?projectKey=/i,
    // Hipchat
    /\/InstallHipChat\.jspa\?projectKey=/i,
    /\/secure\/ConfigureHipChat\.jspa\?projectKey=(.+)/i,
    // Forge
    /\/jira\/software\/c\/projects\/.+\/settings\/apps\/([a-z0-9-]+)\/([a-z0-9-]+)(\/*)?/i
];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$efe7a2022eaf0f59$export$2e2bcd8739ae039 = [
    ...$efe7a2022eaf0f59$var$commonClassicProjectSettingsRoutes,
    /\/plugins\/servlet\/project-config\/.+\/issuelayout/i,
    ...(0, $5PyNy.default),
    // Service Desk project settings
    /\/servicedesk\/admin\/(\w+)/i,
    // SPA settings
    /\/projects\/\w+\/settings(\/\w+)*/i
];

});


parcelRegister("883db", function(module, exports) {

$parcel$export(module.exports, "errorFlag", () => $d8474afc40da2ee0$export$b9a7f1ebeaa76953);

var $dGrvr = parcelRequire("dGrvr");
const $d8474afc40da2ee0$export$b9a7f1ebeaa76953 = ()=>({
        type: 'error',
        title: (0, $dGrvr.messages).title,
        description: (0, $dGrvr.messages).description,
        messageId: 'spa-apps-common.redirect.legacy-routing.flags.flag.error.error-flag',
        messageType: 'transactional',
        actions: [
            {
                content: (0, $dGrvr.messages).goHome,
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                onClick: ()=>window.location.assign('/')
            }
        ]
    });

});
parcelRegister("dGrvr", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1d710f8117ed7a9a$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $1d710f8117ed7a9a$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        "id": "redirect.legacy-routing.flags.error.title",
        "defaultMessage": "We can't find the page you're looking for"
    },
    description: {
        "id": "redirect.legacy-routing.flags.error.description",
        "defaultMessage": "Check your spelling in the address bar. Or, try opening this site's home page to search or browse for the content."
    },
    goHome: {
        "id": "redirect.legacy-routing.flags.error.go-home",
        "defaultMessage": "Go to the homepage"
    }
});

});




parcelRegister("21A4f", function(module, exports) {

$parcel$export(module.exports, "LazyGlobalMailSettings", () => $cc4123579e370fa7$export$a133d90b2004a90e);
$parcel$export(module.exports, "default", () => $cc4123579e370fa7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $cc4123579e370fa7$export$a133d90b2004a90e = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("cCkD4"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/global-mail-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cc4123579e370fa7$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cc4123579e370fa7$export$a133d90b2004a90e,
        pageId: "global-mail-settings",
        shouldShowSpinner: false
    });

});
parcelRegister("cCkD4", function(module, exports) {

let $92f909288307c9ef$var$load = (parcelRequire("28QjX"))(4);
module.exports = $92f909288307c9ef$var$load("4QcTa").then(()=>parcelRequire('7ROZZ'));

});



parcelRegister("adI0E", function(module, exports) {

$parcel$export(module.exports, "globalPoliciesRouteEntry", () => $26e6da78b3e43e9c$export$2ee2f43d380cc210);

var $f4VN0 = parcelRequire("f4VN0");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $eZXFU = parcelRequire("eZXFU");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $1OKmH = parcelRequire("1OKmH");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

var $jyzx5 = parcelRequire("jyzx5");
const $26e6da78b3e43e9c$var$getNavigationSpecifications = ()=>{
    return (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $26e6da78b3e43e9c$export$2ee2f43d380cc210 = (0, $7NszV.createEntry)((0, $1OKmH.globalPoliciesRoute), ()=>({
        group: 'eoc',
        component: (0, $jyzx5.AlertPoliciesComponent),
        layout: (0, $eZXFU.opsSettingsLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $f4VN0.resources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$26e6da78b3e43e9c$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jyzx5.LazyAlertPolicies)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jyzx5.LazyAlertPolicies)
        ]
    }));

});
parcelRegister("1OKmH", function(module, exports) {

$parcel$export(module.exports, "globalPoliciesRoute", () => $a0dbfcfca37c6909$export$4eb24a8e860a3df7);
const $a0dbfcfca37c6909$export$4eb24a8e860a3df7 = {
    name: 'eoc-policies',
    path: '/jira/settings/products/ops/policies',
    exact: true
};

});


parcelRegister("aNke7", function(module, exports) {

$parcel$export(module.exports, "globalSettingsContactAdministratorRouteEntry", () => $2f78657934c6661f$export$d213125be8246eea);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $emDul = parcelRequire("emDul");

var $ksIuv = parcelRequire("ksIuv");
const $2f78657934c6661f$export$d213125be8246eea = (0, $7NszV.createEntry)((0, $emDul.globalSettingsContactAdministratorRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.contact-administrator',
        component: (0, $ksIuv.default),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ksIuv.LazyContactAdministratorPage)
        ]
    }));

});
parcelRegister("emDul", function(module, exports) {

$parcel$export(module.exports, "globalSettingsContactAdministratorRoute", () => $f70c16094aab0919$export$146910ddc36bf151);
const $f70c16094aab0919$export$146910ddc36bf151 = {
    name: 'global-settings-contact-administrator',
    path: '/jira/contact-administrator'
};

});

parcelRegister("ksIuv", function(module, exports) {

$parcel$export(module.exports, "LazyContactAdministratorPage", () => $817988e9accf1b9b$export$bf75747a931b9a2b);
$parcel$export(module.exports, "default", () => $817988e9accf1b9b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $817988e9accf1b9b$export$bf75747a931b9a2b = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("1kc0A"))), {
    moduleId: "./src/packages/admin-pages/contact-administrator/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$817988e9accf1b9b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $817988e9accf1b9b$export$bf75747a931b9a2b,
        pageId: "jira-admin-pages-contact-administrator",
        shouldShowSpinner: true
    });

});
parcelRegister("1kc0A", function(module, exports) {

let $0f70f94fa98dc7bf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0f70f94fa98dc7bf$var$load("6hbnn").then(()=>parcelRequire('dnrkU'));

});



parcelRegister("9jp5b", function(module, exports) {

$parcel$export(module.exports, "globalSettingsCustomFieldsRouteEntry", () => $8b3a43559c4bd90e$export$d83c2e469d070766);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $cpdjw = parcelRequire("cpdjw");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $hESSV = parcelRequire("hESSV");

var $5pSYQ = parcelRequire("5pSYQ");

var $eUwrd = parcelRequire("eUwrd");
const $8b3a43559c4bd90e$export$d83c2e469d070766 = (0, $7NszV.createEntry)((0, $hESSV.globalSettingsCustomFieldsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.custom-fields-directory',
        component: (0, $eUwrd.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $cpdjw.customFieldsDirectoryResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $eUwrd.LazyCustomFieldsDirectoryAdmin)
        ]
    }));

});
parcelRegister("cpdjw", function(module, exports) {

$parcel$export(module.exports, "customFieldsDirectoryResource", () => $dcd1379dc352c4e2$export$3d783f106e15b01a);

var $2M1hQ = parcelRequire("2M1hQ");


const $dcd1379dc352c4e2$export$3d783f106e15b01a = (0, $2M1hQ.createResource)({
    type: (0, $d558514bbbbc39cd$export$f237bae095c310e7),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("hLxGe"))
});

});
const $d558514bbbbc39cd$export$f237bae095c310e7 = 'CUSTOM_FIELDS_DIRECTORY';

parcelRegister("hLxGe", function(module, exports) {

let $cef0f3a07e538fdc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cef0f3a07e538fdc$var$load("hh76d").then(()=>parcelRequire('fFz2g'));

});


parcelRegister("hESSV", function(module, exports) {

$parcel$export(module.exports, "globalSettingsCustomFieldsRoute", () => $a19ed616896ad98a$export$45e7d93edcc9507f);
const $a19ed616896ad98a$export$45e7d93edcc9507f = {
    name: 'global-settings-issues-custom-fields-view',
    path: '/secure/admin/ViewCustomFields(!default)?.jspa'
};

});

parcelRegister("eUwrd", function(module, exports) {

$parcel$export(module.exports, "LazyCustomFieldsDirectoryAdmin", () => $0183f6c188d0635c$export$55a5c16f39a046af);
$parcel$export(module.exports, "default", () => $0183f6c188d0635c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $0183f6c188d0635c$export$55a5c16f39a046af = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("dq3cz"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/custom-fields-directory/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0183f6c188d0635c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $0183f6c188d0635c$export$55a5c16f39a046af,
        pageId: "admin-pages-custom-fields-directory",
        shouldShowSpinner: true
    });

});
parcelRegister("dq3cz", function(module, exports) {

let $9c502fdcfb880c92$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9c502fdcfb880c92$var$load("ffQaD"),
    $9c502fdcfb880c92$var$load("kvRbA"),
    $9c502fdcfb880c92$var$load("fliVL"),
    $9c502fdcfb880c92$var$load("cjvBE")
]).then(()=>parcelRequire('4ZT30'));

});



parcelRegister("1mByb", function(module, exports) {

$parcel$export(module.exports, "globalSettingsEditPermissionSchemesRouteEntry", () => $28d525b59d36751f$export$25dca167915e813c);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $1Sn7L = parcelRequire("1Sn7L");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $j15ln = parcelRequire("j15ln");

var $aVbhY = parcelRequire("aVbhY");
const $28d525b59d36751f$export$25dca167915e813c = (0, $7NszV.createEntry)((0, $j15ln.globalSettingsEditPermissionSchemesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.configure-permission-scheme',
        component: (0, $aVbhY.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $1Sn7L.editPermissionSchemePageResource)
        ],
        canTransitionIn: ()=>true,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aVbhY.LazyEditPermissionSchemePage)
        ],
        meta: {
            reporting: {
                id: 'EditPermissionScheme',
                packageName: 'jiraAdminPagesEditPermissionScheme',
                teamName: 'gordian'
            }
        }
    }));

});
parcelRegister("1Sn7L", function(module, exports) {

$parcel$export(module.exports, "editPermissionSchemePageResource", () => $c133ac01577799ff$export$2b6bb2f543863b53);

var $ao2h1 = parcelRequire("ao2h1");

var $eZzoq = parcelRequire("eZzoq");
const $c133ac01577799ff$var$RESOURCE_TYPE_EDIT_PERMISSION_SCHEME_PAGE = 'EDIT_PERMISSION_SCHEME_PAGE';
const $c133ac01577799ff$export$2b6bb2f543863b53 = (0, $ao2h1.createRelayResource)({
    type: $c133ac01577799ff$var$RESOURCE_TYPE_EDIT_PERMISSION_SCHEME_PAGE,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $eZzoq.default),
            variables: {
                // To Do: use ari-typescript library once it is approved
                // https://hello.atlassian.net/wiki/spaces/TGR/pages/1374189554/Dependency+review+atlassian+ari
                schemeId: `ari:cloud:jira:${tenantContext.cloudId}:permission-scheme/activation/${tenantContext.activationId}/${String(match.params.schemeId)}`,
                first: 50
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("eZzoq", function(module, exports) {

$parcel$export(module.exports, "default", () => $95d709337e778f61$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3e6d2609b22da674852d0d8a556caee0>>
 * @relayHash a8302edc7839549073bdffce737596f9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8c97cc5e281ea579c44e87ac7f80e5f399b27b3ac304b7267d4210b282a7a4b1
const $95d709337e778f61$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "schemeId"
    }, v2 = {
        "kind": "Variable",
        "name": "schemeId",
        "variableName": "schemeId"
    }, v3 = [
        v2 /*: any*/ 
    ], v4 = {
        "kind": "ScalarField",
        "name": "isEditable"
    }, v5 = {
        "concreteType": "JiraPermissionSchemeConfiguration",
        "kind": "LinkedField",
        "name": "configuration",
        "plural": false,
        "selections": [
            v4 /*: any*/ 
        ]
    }, v6 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v2 /*: any*/ 
    ], v7 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "key"
    }, v11 = {
        "kind": "ScalarField",
        "name": "description"
    }, v12 = {
        "kind": "ScalarField",
        "name": "text"
    }, v13 = {
        "kind": "ScalarField",
        "name": "id"
    }, v14 = [
        v8 /*: any*/ ,
        v9 /*: any*/ ,
        v13 /*: any*/ 
    ], v15 = [
        v9 /*: any*/ ,
        v13 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v3 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "viewPermissionScheme",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "PermissionCategories"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "header_editPermissionScheme"
                                            },
                                            v5 /*: any*/ 
                                        ],
                                        "type": "JiraPermissionSchemeView"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.viewPermissionScheme"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v6 /*: any*/ ,
                                "concreteType": "JiraProjectConnection",
                                "kind": "LinkedField",
                                "name": "getProjectsByPermissionScheme",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "JiraProject",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v7 /*: any*/ ,
                                                                "action": "LOG",
                                                                "path": "jira.getProjectsByPermissionScheme.edges.node.projectId"
                                                            }
                                                        ]
                                                    },
                                                    "action": "LOG",
                                                    "path": "jira.getProjectsByPermissionScheme.edges.node"
                                                }
                                            ]
                                        },
                                        "action": "LOG",
                                        "path": "jira.getProjectsByPermissionScheme.edges"
                                    }
                                ]
                            },
                            "action": "LOG",
                            "path": "jira.getProjectsByPermissionScheme"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "viewPermissionScheme",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraPermissionSchemeGrantGroup",
                                            "kind": "LinkedField",
                                            "name": "grantGroups",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProjectPermissionCategory",
                                                    "kind": "LinkedField",
                                                    "name": "category",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraPermissionGrantHolder",
                                                    "kind": "LinkedField",
                                                    "name": "grantHolders",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraProjectPermission",
                                                            "kind": "LinkedField",
                                                            "name": "permission",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                v11 /*: any*/ ,
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraPermissionConfiguration",
                                                            "kind": "LinkedField",
                                                            "name": "configuration",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "tag"
                                                                },
                                                                {
                                                                    "concreteType": "JiraPermissionMessageExtension",
                                                                    "kind": "LinkedField",
                                                                    "name": "message",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "type"
                                                                        },
                                                                        v12 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraPermissionDocumentationExtension",
                                                                    "kind": "LinkedField",
                                                                    "name": "documentation",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v12 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ]
                                                                },
                                                                v4 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraPermissionGrants",
                                                            "kind": "LinkedField",
                                                            "name": "grants",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraGrantTypeKey",
                                                                    "kind": "LinkedField",
                                                                    "name": "grantType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        v9 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraPermissionGrantValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "grantValues",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "value",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v9 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraDefaultGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "user",
                                                                                            "plural": false,
                                                                                            "selections": v14 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraUserGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraGroup",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "group",
                                                                                            "plural": false,
                                                                                            "selections": v15 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraGroupGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraRole",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "role",
                                                                                            "plural": false,
                                                                                            "selections": v15 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraProjectRoleGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "field",
                                                                                            "plural": false,
                                                                                            "selections": v14 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueFieldGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v13 /*: any*/ 
                                                                                    ],
                                                                                    "type": "Node",
                                                                                    "abstractKey": "__isNode"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v13 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "totalCount"
                                                                },
                                                                v8 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__id"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraPermissionScheme",
                                            "kind": "LinkedField",
                                            "name": "scheme",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v13 /*: any*/ 
                                            ]
                                        },
                                        v5 /*: any*/ 
                                    ],
                                    "type": "JiraPermissionSchemeView"
                                }
                            ]
                        },
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "getProjectsByPermissionScheme",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v13 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8c97cc5e281ea579c44e87ac7f80e5f399b27b3ac304b7267d4210b282a7a4b1",
            "metadata": {},
            "name": "mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$95d709337e778f61$var$node.hash = "9e1e7326d79aae057f4943753d3cd309";
var $95d709337e778f61$export$2e2bcd8739ae039 = $95d709337e778f61$var$node;

});


parcelRegister("j15ln", function(module, exports) {

$parcel$export(module.exports, "globalSettingsEditPermissionSchemesRoute", () => $b0eb7fc8ea8a5934$export$d57f448badd0561f);
const $b0eb7fc8ea8a5934$export$d57f448badd0561f = {
    name: 'global-settings-issues-edit-permissions-schemes',
    path: '/jira/settings/issues/permission-schemes/:schemeId'
};

});

parcelRegister("aVbhY", function(module, exports) {

$parcel$export(module.exports, "LazyEditPermissionSchemePage", () => $9fc866887d4bbe6b$export$4549705b02900c32);
$parcel$export(module.exports, "default", () => $9fc866887d4bbe6b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $9fc866887d4bbe6b$export$4549705b02900c32 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("lIELi"))), {
    moduleId: "./src/packages/permissions-administration/pages/edit-permission-scheme/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9fc866887d4bbe6b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $9fc866887d4bbe6b$export$4549705b02900c32,
        pageId: "jira-edit-permission-scheme",
        shouldShowSpinner: true
    });

});
parcelRegister("lIELi", function(module, exports) {

let $fcfd537bad6c9550$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fcfd537bad6c9550$var$load("68z6o").then(()=>parcelRequire('hZT3b'));

});



parcelRegister("izUuJ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsFormDataConnectionsRouteEntry", () => $3bc9e61b7154fc39$export$d975ee3e4df0b4d2);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $cL7r8 = parcelRequire("cL7r8");

var $dwY5M = parcelRequire("dwY5M");

var $lkFvK = parcelRequire("lkFvK");

var $6MVyv = parcelRequire("6MVyv");
const $3bc9e61b7154fc39$var$jiraAdminProformaDataConnectionsPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $dwY5M.default),
    topNavigationMenuId: (0, $lmyls.MENU_ID).SETTINGS
});
const $3bc9e61b7154fc39$export$d975ee3e4df0b4d2 = (0, $7NszV.createEntry)((0, $cL7r8.globalSettingsFormDataConnectionsRoute), ()=>({
        group: 'global-settings',
        component: (0, $6MVyv.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6MVyv.LazyProformaJiraDataConnectionsPage)
        ],
        entryPoint () {
            return $3bc9e61b7154fc39$var$jiraAdminProformaDataConnectionsPageEntryPoint;
        }
    }));

});
parcelRegister("cL7r8", function(module, exports) {

$parcel$export(module.exports, "globalSettingsFormDataConnectionsRoute", () => $e95abb1b467ec66d$export$6633247975d81f28);
const $e95abb1b467ec66d$export$6633247975d81f28 = {
    name: 'global-settings-issues-form-data-connections',
    path: '/jira/settings/forms/data-connections'
};

});

parcelRegister("dwY5M", function(module, exports) {

$parcel$export(module.exports, "default", () => $86888a626e8a4290$export$2e2bcd8739ae039);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $86888a626e8a4290$var$JiraAdminProformaDataConnectionsEntryPoint = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("5mTGn")), {
        moduleId: "606040fa",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});
var $86888a626e8a4290$export$2e2bcd8739ae039 = $86888a626e8a4290$var$JiraAdminProformaDataConnectionsEntryPoint;

});
parcelRegister("5mTGn", function(module, exports) {

let $3e8a333750974ea5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3e8a333750974ea5$var$load("imNNE").then(()=>parcelRequire('5syWw'));

});


parcelRegister("6MVyv", function(module, exports) {

$parcel$export(module.exports, "LazyProformaJiraDataConnectionsPage", () => $013d0419ad26989f$export$a81885366284dc75);
$parcel$export(module.exports, "default", () => $013d0419ad26989f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $013d0419ad26989f$export$a81885366284dc75 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("dI2ND"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/proforma/data-connections/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$013d0419ad26989f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $013d0419ad26989f$export$a81885366284dc75,
        pageId: "jira-admin-pages-forms-data-connections",
        shouldShowSpinner: true
    });

});
parcelRegister("dI2ND", function(module, exports) {

let $9fb18e5711d55c55$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9fb18e5711d55c55$var$load("5nxrg").then(()=>parcelRequire('jSKfU'));

});



parcelRegister("4BdYV", function(module, exports) {

$parcel$export(module.exports, "globalSettingsGlobalPermissionsRouteEntry", () => $29ac5183332fb76e$export$34203273711b537f);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $kiD5R = parcelRequire("kiD5R");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $1U35o = parcelRequire("1U35o");

var $5lsNZ = parcelRequire("5lsNZ");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $5pSYQ = parcelRequire("5pSYQ");

const $29ac5183332fb76e$var$LazyGlobalPermissions = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("jk5Cq"))), {
    moduleId: "./src/packages/permissions-administration/pages/global-permissions/src/index.tsx"
});
const $29ac5183332fb76e$var$LazyGlobalPermissionsPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $29ac5183332fb76e$var$LazyGlobalPermissions,
        pageId: "jira-global-permissions",
        shouldShowSpinner: true
    });
const $29ac5183332fb76e$export$34203273711b537f = (0, $7NszV.createEntry)((0, $1U35o.globalSettingsGlobalPermissionsRoute), ()=>({
        group: 'global-settings',
        component: (0, $cSD7y.componentWithFG)('olympus-global-permissions-fe-modernisation', $29ac5183332fb76e$var$LazyGlobalPermissionsPage, (0, $5lsNZ.default)),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $kiD5R.globalPermissionsResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        canTransitionIn: ()=>(0, $4R6GH.fg)('olympus-global-permissions-fe-modernisation'),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $29ac5183332fb76e$var$LazyGlobalPermissions
        ],
        meta: {
            reporting: {
                id: 'GlobalPermissions',
                packageName: 'jiraAdminPagesGlobalPermissions',
                teamName: 'gordian'
            }
        }
    }));

});
parcelRegister("kiD5R", function(module, exports) {

$parcel$export(module.exports, "globalPermissionsResource", () => $896d1d986bb0ea74$export$9a5d1bc1ff678482);

var $ao2h1 = parcelRequire("ao2h1");

var $5Uo2r = parcelRequire("5Uo2r");
const $896d1d986bb0ea74$var$RESOURCE_TYPE_GLOBAL_PERMISSIONS = 'GLOBAL_PERMISSIONS';
const $896d1d986bb0ea74$export$9a5d1bc1ff678482 = (0, $ao2h1.createRelayResource)({
    type: $896d1d986bb0ea74$var$RESOURCE_TYPE_GLOBAL_PERMISSIONS,
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $5Uo2r.default),
            variables: {
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("5Uo2r", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed1cca93794a5156$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5f014b4044459efb94c4edb99f926dd1>>
 * @relayHash 402a674bdd82767605c36953e2732f07
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5b2ad70438dbcc77ff45c7608ecd4e7382a18aa895a82fd26e83279a282b7ab6
const $ed1cca93794a5156$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "main_globalPermissionsAndGrantsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "globalPermissionsAndGrants",
                                    "args": v1 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "getGlobalPermissionsAndGrants",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "globalPermissionsTable_globalPermissions"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "grantPermissionDialog_globalPermissions"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.globalPermissionsAndGrants"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "main_globalPermissionsAndGrantsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "globalPermissionsAndGrants",
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "getGlobalPermissionsAndGrants",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraGlobalPermissionGrants",
                                            "kind": "LinkedField",
                                            "name": "globalPermissionGrants",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraGlobalPermission",
                                                    "kind": "LinkedField",
                                                    "name": "permission",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isManagedByJira"
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraGroup",
                                                    "kind": "LinkedField",
                                                    "name": "groups",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "groupId"
                                                        },
                                                        v2 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraGlobalPermissionGrantsList"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5b2ad70438dbcc77ff45c7608ecd4e7382a18aa895a82fd26e83279a282b7ab6",
            "metadata": {},
            "name": "main_globalPermissionsAndGrantsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ed1cca93794a5156$var$node.hash = "9f1b7eb98b606c41655e4fa1f200a351";
var $ed1cca93794a5156$export$2e2bcd8739ae039 = $ed1cca93794a5156$var$node;

});


parcelRegister("1U35o", function(module, exports) {

$parcel$export(module.exports, "globalSettingsGlobalPermissionsRoute", () => $efa019df4aa72b9f$export$236ce89eb737f752);
const $efa019df4aa72b9f$export$236ce89eb737f752 = {
    name: 'global-settings-global-permissions',
    path: '/secure/admin/global-permissions'
};

});

parcelRegister("jk5Cq", function(module, exports) {

let $e1143e525b0b7144$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e1143e525b0b7144$var$load("2F9b6").then(()=>parcelRequire('csGky'));

});


parcelRegister("69iY3", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueFieldConfigurationSchemesRouteEntry", () => $4d2835303e962147$export$46fc796086760207);

var $7NszV = parcelRequire("7NszV");

var $d4Sjz = parcelRequire("d4Sjz");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $4R6GH = parcelRequire("4R6GH");

var $3RJkv = parcelRequire("3RJkv");

var $atU1t = parcelRequire("atU1t");

var $5pSYQ = parcelRequire("5pSYQ");

var $lkFvK = parcelRequire("lkFvK");

var $hYZqE = parcelRequire("hYZqE");
const $4d2835303e962147$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $hYZqE.globalAdminFieldConfigurationSchemesEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).SETTINGS
});
const $4d2835303e962147$export$46fc796086760207 = (0, $7NszV.createEntry)((0, $d4Sjz.globalSettingsIssueFieldConfigurationSchemesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.field-configuration-schemes',
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        canTransitionIn: ()=>(0, $4R6GH.fg)('jira_efa_for_cmp_m2'),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>{
            if (!(0, $4R6GH.fg)('jira_efa_for_cmp_m2')) return undefined;
            return $4d2835303e962147$var$pageEntryPoint;
        },
        meta: {
            reporting: {
                packageName: 'jiraAdminPagesFieldConfigurationSchemes',
                id: 'globalSettingsIssueFieldConfigurationSchemes',
                teamName: 'Yamato'
            }
        }
    }));

});
parcelRegister("d4Sjz", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueFieldConfigurationSchemesRoute", () => $8375b3a32756f9f4$export$bbb23801a4589091);
const $8375b3a32756f9f4$export$bbb23801a4589091 = {
    name: 'global-settings-issues-field-configuration-schemes',
    path: '/jira/settings/issues/field-configuration-schemes',
    exact: true
};

});

parcelRegister("hYZqE", function(module, exports) {

$parcel$export(module.exports, "globalAdminFieldConfigurationSchemesEntryPoint", () => $950bddd33bf3b539$export$e6a385c0b09caa1f);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $ea5Bw = parcelRequire("ea5Bw");

const $950bddd33bf3b539$export$e6a385c0b09caa1f = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("jEZtL")), {
        moduleId: "d5c921f3",
        priority: "userVisible"
    }),
    getPreloadProps: ({ tenantContext: tenantContext })=>({
            queries: {
                pageQueryRef: {
                    parameters: (0, $ea5Bw.default),
                    variables: {
                        cloudId: tenantContext.cloudId
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        })
});

});
parcelRegister("ea5Bw", function(module, exports) {

$parcel$export(module.exports, "default", () => $af768739f7be23ae$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<54282f7b5aee88517f7d47a584b0941c>>
 * @relayHash 52309547e55b39b8ebca1abe76437e05
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9b511e08c69cd7827cb9cb410af68fa13d59c8373bcb7be3b8a5fd68f9304993

var $eiowN = parcelRequire("eiowN");
const $af768739f7be23ae$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "srcFieldConfigurationSchemesQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "ui_adminPagesFieldConfigurationSchemes_FieldConfigurationSchemesPage"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "srcFieldConfigurationSchemesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                }
                            ],
                            "concreteType": "JiraHomePage",
                            "kind": "LinkedField",
                            "name": "userHomePage",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "link"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9b511e08c69cd7827cb9cb410af68fa13d59c8373bcb7be3b8a5fd68f9304993",
            "metadata": {},
            "name": "srcFieldConfigurationSchemesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$af768739f7be23ae$var$node.hash = "789159df1c4fe4cca65de23212d77454";
(0, $eiowN.PreloadableQueryRegistry).set($af768739f7be23ae$var$node.params.id, $af768739f7be23ae$var$node);
var $af768739f7be23ae$export$2e2bcd8739ae039 = $af768739f7be23ae$var$node;

});

parcelRegister("jEZtL", function(module, exports) {

let $e501713450f03f71$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e501713450f03f71$var$load("ci0xn").then(()=>parcelRequire('1Cv5i'));

});



parcelRegister("ipR0U", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueFieldSchemesRouteEntry", () => $040da6ab68bb362d$export$d76b41f577aeeba5);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $g0QAg = parcelRequire("g0QAg");

var $5pSYQ = parcelRequire("5pSYQ");

var $MjvHI = parcelRequire("MjvHI");
const $040da6ab68bb362d$export$d76b41f577aeeba5 = (0, $7NszV.createEntry)((0, $g0QAg.globalSettingsIssueFieldSchemesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.screen-schemes',
        component: (0, $MjvHI.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $MjvHI.LazyScreenSchemesPage)
        ]
    }));

});
parcelRegister("g0QAg", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueFieldSchemesRoute", () => $f7a16e4417c90525$export$3c5a0cf6ecc1bdf1);
const $f7a16e4417c90525$export$3c5a0cf6ecc1bdf1 = {
    name: 'global-settings-issues-field-schemes-view',
    path: '/jira/settings/issues/screen-schemes'
};

});

parcelRegister("MjvHI", function(module, exports) {

$parcel$export(module.exports, "LazyScreenSchemesPage", () => $3b08a72bf07c6137$export$342ae41503f611f1);
$parcel$export(module.exports, "default", () => $3b08a72bf07c6137$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $3b08a72bf07c6137$export$342ae41503f611f1 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("ebWsC"))), {
    moduleId: "./src/packages/admin-pages/screens/screen-schemes-page/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3b08a72bf07c6137$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3b08a72bf07c6137$export$342ae41503f611f1,
        pageId: "jira-admin-pages-screen-schemes-page",
        shouldShowSpinner: true
    });

});
parcelRegister("ebWsC", function(module, exports) {

let $a54f70cd06d8e2c2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a54f70cd06d8e2c2$var$load("aIqr8").then(()=>parcelRequire('bwE6o'));

});



parcelRegister("jovMq", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueFieldScreensRouteEntry", () => $39823af69179fb5e$export$ea08b1064c32ddb2);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $eHWkH = parcelRequire("eHWkH");

var $5pSYQ = parcelRequire("5pSYQ");

var $P0dqS = parcelRequire("P0dqS");
const $39823af69179fb5e$export$ea08b1064c32ddb2 = (0, $7NszV.createEntry)((0, $eHWkH.globalSettingsIssueFieldScreensRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.screens',
        component: (0, $P0dqS.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $P0dqS.LazyScreensPage)
        ]
    }));

});
parcelRegister("eHWkH", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueFieldScreensRoute", () => $d6c79c93cf657eb0$export$197fd5d0ee709ca4);
const $d6c79c93cf657eb0$export$197fd5d0ee709ca4 = {
    name: 'global-settings-issues-field-screens',
    path: '/jira/settings/issues/screens'
};

});

parcelRegister("P0dqS", function(module, exports) {

$parcel$export(module.exports, "LazyScreensPage", () => $38a54f3b8a5e1e01$export$f4e6d546d7f2894c);
$parcel$export(module.exports, "default", () => $38a54f3b8a5e1e01$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $38a54f3b8a5e1e01$export$f4e6d546d7f2894c = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("cGWnL"))), {
    moduleId: "./src/packages/admin-pages/screens/screens-page/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$38a54f3b8a5e1e01$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $38a54f3b8a5e1e01$export$f4e6d546d7f2894c,
        pageId: "jira-admin-pages-screens-page",
        shouldShowSpinner: true
    });

});
parcelRegister("cGWnL", function(module, exports) {

let $93d6b1c6ecb14d29$var$load = (parcelRequire("28QjX"))(4);
module.exports = $93d6b1c6ecb14d29$var$load("1ev3J").then(()=>parcelRequire('lgmh3'));

});



parcelRegister("2UvYl", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueFieldsManagementRouteEntry", () => $f3cfe226a311fac7$export$b0811d27c1832ea1);

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $lKiq6 = parcelRequire("lKiq6");

var $eLOu4 = parcelRequire("eLOu4");

var $5lsNZ = parcelRequire("5lsNZ");

var $5pSYQ = parcelRequire("5pSYQ");

var $6s1PB = parcelRequire("6s1PB");
const $f3cfe226a311fac7$var$globalSettingsIssueFieldsManagementEntryPointPage = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $eLOu4.globalSettingsIssueFieldsManagementRouteEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).SETTINGS
});
const $f3cfe226a311fac7$export$b0811d27c1832ea1 = (0, $7NszV.createEntry)((0, $lKiq6.globalSettingsIssueFieldsManagementRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.fields',
        component: (0, $5lsNZ.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        canTransitionIn: ()=>(0, $6s1PB.expValEquals)('jira-admin-pages-centralised-fields-m1-experiment', 'isEnabled', true, false),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint () {
            if ((0, $6s1PB.expValEquals)('jira-admin-pages-centralised-fields-m1-experiment', 'isEnabled', true, false)) return $f3cfe226a311fac7$var$globalSettingsIssueFieldsManagementEntryPointPage;
        }
    }));

});
parcelRegister("lKiq6", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueFieldsManagementRoute", () => $4325708462413ccd$export$6e571c84819449f5);
const $4325708462413ccd$export$6e571c84819449f5 = {
    name: 'global-settings-issues-fields-management-view',
    path: '/jira/settings/issues/fields'
};

});

parcelRegister("eLOu4", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueFieldsManagementRouteEntryPoint", () => $8a6c936f0a349e84$export$b2a8ea978923a786);
// entrypoint.tsx

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $3EuEv = parcelRequire("3EuEv");
// Backwards compatibility with old URL params
const $8a6c936f0a349e84$var$CustomFieldStatus = {
    TRASHED: 'trashed',
    ACTIVE: 'active'
};

const $8a6c936f0a349e84$export$b2a8ea978923a786 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("7w1Wc")), {
        moduleId: "6660b54c",
        priority: "userVisible"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId }, context: { query: query } })=>{
        const initialTab = query.customFieldStatus?.toLowerCase() === $8a6c936f0a349e84$var$CustomFieldStatus.TRASHED ? 'deleted' : 'active';
        return {
            queries: {
                globalFields: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $3EuEv.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            },
            extraProps: {
                initialTab: initialTab
            }
        };
    }
});

});
parcelRegister("3EuEv", function(module, exports) {

$parcel$export(module.exports, "default", () => $06d1a8ee4ac7e20f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8d3081a94932b3ad83e6b679a3fab285>>
 * @relayHash 84e637e4ef0d68da7afb016e439ed3c5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 79ba897ff5566fb8cece4c2f8823fa80501ec1a372320f5611a4a2183e69e560
const $06d1a8ee4ac7e20f$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "79ba897ff5566fb8cece4c2f8823fa80501ec1a372320f5611a4a2183e69e560",
        "metadata": {},
        "name": "uiAdminPagesFieldsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $06d1a8ee4ac7e20f$export$2e2bcd8739ae039 = $06d1a8ee4ac7e20f$var$node;

});

parcelRegister("7w1Wc", function(module, exports) {

let $578d065bd28f60d8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $578d065bd28f60d8$var$load("hn8O3").then(()=>parcelRequire('1hPWF'));

});



parcelRegister("laDqO", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueHierarchyRedirectRouteEntry", () => $7b04b3e8e151f1c0$export$ce3302d254f9c0b4);

var $5uXOq = parcelRequire("5uXOq");

var $g87MG = parcelRequire("g87MG");

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $gTOS3 = parcelRequire("gTOS3");

var $ds5qV = parcelRequire("ds5qV");

var $dKJVX = parcelRequire("dKJVX");
const $7b04b3e8e151f1c0$export$ce3302d254f9c0b4 = (0, $7NszV.createEntry)((0, $gTOS3.globalSettingsIssueHierarchyRedirectRoute), ()=>({
        group: 'global-settings',
        component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
                to: "/jira/settings/issues/issue-hierarchy"
            }),
        isRedirect: true,
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $g87MG.issueHierarchyPageResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $dKJVX.LazyIssueHierarchyDirectory)
        ]
    }));

});
parcelRegister("gTOS3", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueHierarchyRedirectRoute", () => $68115cd41df3c3dd$export$6236a41e09bb858a);
const $68115cd41df3c3dd$export$6236a41e09bb858a = {
    name: 'global-settings-issues-hierarchy-redirect',
    path: '/secure/PortfolioHierarchy.jspa'
};

});

parcelRegister("dKJVX", function(module, exports) {

$parcel$export(module.exports, "LazyIssueHierarchyDirectory", () => $1c0ab549b6b1a06b$export$1ff7255ab4f7a2dd);
$parcel$export(module.exports, "default", () => $1c0ab549b6b1a06b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $1c0ab549b6b1a06b$export$1ff7255ab4f7a2dd = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("4X1AO"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/issue-types/issue-hierarchy-directory/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1c0ab549b6b1a06b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $1c0ab549b6b1a06b$export$1ff7255ab4f7a2dd,
        pageId: "jira-admin-pages-issue-hierarchy-directory",
        shouldShowSpinner: true
    });

});
parcelRegister("4X1AO", function(module, exports) {

let $39ade867fecf7809$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $39ade867fecf7809$var$load("ffQaD"),
    $39ade867fecf7809$var$load("kvRbA"),
    $39ade867fecf7809$var$load("W0knM")
]).then(()=>parcelRequire('7PW51'));

});



parcelRegister("2pvey", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueHierarchyRouteEntry", () => $7693e36a7d632143$export$119e5b48edcee4ff);

var $g87MG = parcelRequire("g87MG");

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $hrUKH = parcelRequire("hrUKH");

var $5pSYQ = parcelRequire("5pSYQ");

var $dKJVX = parcelRequire("dKJVX");
const $7693e36a7d632143$export$119e5b48edcee4ff = (0, $7NszV.createEntry)((0, $hrUKH.globalSettingsIssueHierarchyRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.issue-hierarchy-config',
        component: (0, $dKJVX.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $g87MG.issueHierarchyPageResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $dKJVX.LazyIssueHierarchyDirectory)
        ]
    }));

});
parcelRegister("hrUKH", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueHierarchyRoute", () => $b0028908d5aa290a$export$2c220ed11ae62e14);
const $b0028908d5aa290a$export$2c220ed11ae62e14 = {
    name: 'global-settings-issues-hierarchy-view',
    path: '/jira/settings/issues/issue-hierarchy'
};

});


parcelRegister("427L2", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesExplicitFieldAssociationRouteEntry", () => $654498d18bc8ccd3$export$5519b86c9ea602e1);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $gB79g = parcelRequire("gB79g");

var $aYyVm = parcelRequire("aYyVm");
const $654498d18bc8ccd3$export$5519b86c9ea602e1 = (0, $7NszV.createEntry)((0, $gB79g.globalSettingsIssuesExplicitFieldAssociationRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        component: (0, $aYyVm.LazyExplicitFieldsProjectListPage),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aYyVm.LazyExplicitFieldsProjectListPromise)
        ]
    }));

});
parcelRegister("gB79g", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesExplicitFieldAssociationRoute", () => $7a11591dcb8250ae$export$4f2c2d125c2b811a);
const $7a11591dcb8250ae$export$4f2c2d125c2b811a = {
    name: 'global-settings-issues-explicit-field-association-project-list',
    path: '/jira/settings/issues/explicit-field-association'
};

});

parcelRegister("aYyVm", function(module, exports) {

$parcel$export(module.exports, "LazyExplicitFieldsProjectListPromise", () => $95736e1c9d4aba6e$export$7b11685155ada84d);
$parcel$export(module.exports, "LazyExplicitFieldsProjectListPage", () => $95736e1c9d4aba6e$export$e81c180c4f4833e);

var $5uXOq = parcelRequire("5uXOq");

var $kxZPA = parcelRequire("kxZPA");

var $5j7Th = parcelRequire("5j7Th");

const $95736e1c9d4aba6e$export$7b11685155ada84d = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("khFxT")), {
    moduleId: "./src/packages/spa-apps/error-pages/not-found/src/index.tsx"
});
const $95736e1c9d4aba6e$export$e81c180c4f4833e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $95736e1c9d4aba6e$export$7b11685155ada84d,
        pageId: "errors-404",
        shouldShowSpinner: false
    });

});


parcelRegister("jWVY2", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNewIssueSearchRouteEntry", () => $d3d6f049267991fe$export$ecfeb067cb61f7f7);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $5AJNe = parcelRequire("5AJNe");

var $5pSYQ = parcelRequire("5pSYQ");

var $2FG9c = parcelRequire("2FG9c");
const $d3d6f049267991fe$export$ecfeb067cb61f7f7 = (0, $7NszV.createEntry)((0, $5AJNe.globalSettingsIssuesNewIssueSearchRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.new-issue-search-transition',
        component: (0, $2FG9c.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $2FG9c.LazyNewIssueSearchTransition)
        ],
        canTransitionIn: ()=>true
    }));

});
parcelRegister("5AJNe", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNewIssueSearchRoute", () => $2c4dc81da03ffb36$export$774dc60e785b8ae8);
const $2c4dc81da03ffb36$export$774dc60e785b8ae8 = {
    name: 'global-settings-issues-new-issue-search',
    path: '/jira/settings/issues/new-issue-search-transition'
};

});

parcelRegister("2FG9c", function(module, exports) {

$parcel$export(module.exports, "LazyNewIssueSearchTransition", () => $4f134f463ddf0416$export$aa5e318abd957ad);
$parcel$export(module.exports, "default", () => $4f134f463ddf0416$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $4f134f463ddf0416$export$aa5e318abd957ad = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("5Nkif"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/new-issue-search-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4f134f463ddf0416$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $4f134f463ddf0416$export$aa5e318abd957ad,
        pageId: "jira-admin-pages-new-issue-search-transition",
        shouldShowSpinner: true
    });

});
parcelRegister("5Nkif", function(module, exports) {

let $4381452d39908d94$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4381452d39908d94$var$load("blxz1").then(()=>parcelRequire('7sYTD'));

});



parcelRegister("gCfQs", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesRouteEntry", () => $90f1ccdb6a2bda75$export$63a56a096ab0d260);

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $72PKZ = parcelRequire("72PKZ");

var $5pSYQ = parcelRequire("5pSYQ");

var $jE90b = parcelRequire("jE90b");
const $90f1ccdb6a2bda75$export$63a56a096ab0d260 = (0, $7NszV.createEntry)((0, $72PKZ.globalSettingsIssuesPrioritiesRoute), ()=>({
        group: 'global-settings',
        component: (0, $jE90b.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $jE90b.LazyPrioritiesPage)
        ]
    }));

});
parcelRegister("72PKZ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesRoute", () => $20f25386b191950e$export$518516cdf6b7cd83);
const $20f25386b191950e$export$518516cdf6b7cd83 = {
    name: 'global-settings-issues-priorities',
    path: '/jira/settings/issues/priorities'
};

});

parcelRegister("jE90b", function(module, exports) {

$parcel$export(module.exports, "LazyPrioritiesPage", () => $bf15af7ed924092e$export$2b5843205130631c);
$parcel$export(module.exports, "default", () => $bf15af7ed924092e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $bf15af7ed924092e$export$2b5843205130631c = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("eBYAB"))), {
    moduleId: "./src/packages/admin-pages/priorities/src/index.tsx"
});
const $bf15af7ed924092e$var$PrioritiesPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $bf15af7ed924092e$export$2b5843205130631c,
        pageId: "jira-admin-pages-priorities",
        shouldShowSpinner: true
    });
var $bf15af7ed924092e$export$2e2bcd8739ae039 = $bf15af7ed924092e$var$PrioritiesPage;

});
parcelRegister("eBYAB", function(module, exports) {

let $aa33853364f8ec32$var$load = (parcelRequire("28QjX"))(4);
module.exports = $aa33853364f8ec32$var$load("avk8f").then(()=>parcelRequire('7oC7C'));

});



parcelRegister("81ZCL", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritySchemesRouteEntry", () => $e7cda76e463e35e5$export$a5ac2a64ed09e754);

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $fZEim = parcelRequire("fZEim");

var $5pSYQ = parcelRequire("5pSYQ");

var $3qE1A = parcelRequire("3qE1A");
const $e7cda76e463e35e5$export$a5ac2a64ed09e754 = (0, $7NszV.createEntry)((0, $fZEim.globalSettingsIssuesPrioritySchemesRoute), ()=>({
        group: 'global-settings',
        component: (0, $3qE1A.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $3qE1A.LazyPrioritySchemes)
        ]
    }));

});
parcelRegister("fZEim", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritySchemesRoute", () => $9dde78a6f0fc7878$export$185af30f53271c10);
const $9dde78a6f0fc7878$export$185af30f53271c10 = {
    name: 'global-settings-issues-priority-schemes',
    path: '/jira/settings/issues/priority-schemes'
};

});

parcelRegister("3qE1A", function(module, exports) {

$parcel$export(module.exports, "LazyPrioritySchemes", () => $a7002d7e57e81458$export$20bb8a3b40a3add4);
$parcel$export(module.exports, "default", () => $a7002d7e57e81458$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $a7002d7e57e81458$export$20bb8a3b40a3add4 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("2cjzo"))), {
    moduleId: "./src/packages/admin-pages/priority-schemes/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a7002d7e57e81458$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $a7002d7e57e81458$export$20bb8a3b40a3add4,
        pageId: "jira-admin-pages-priority-schemes",
        shouldShowSpinner: true
    });

});
parcelRegister("2cjzo", function(module, exports) {

let $199be1eef3a1e730$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $199be1eef3a1e730$var$load("ffQaD"),
    $199be1eef3a1e730$var$load("kvRbA"),
    $199be1eef3a1e730$var$load("l1o0A")
]).then(()=>parcelRequire('4bg9b'));

});



parcelRegister("lgfw1", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueTypesRouteEntry", () => $c4b1c133efa61697$export$680243b058188dc0);

var $hjmEZ = parcelRequire("hjmEZ");

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $doDFU = parcelRequire("doDFU");

var $5pSYQ = parcelRequire("5pSYQ");

var $d9kjz = parcelRequire("d9kjz");
const $c4b1c133efa61697$export$680243b058188dc0 = (0, $7NszV.createEntry)((0, $doDFU.globalSettingsIssueTypesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.issue-types',
        component: (0, $d9kjz.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $hjmEZ.issueTypesResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $d9kjz.LazyIssueTypesDirectory)
        ]
    }));

});
parcelRegister("hjmEZ", function(module, exports) {

$parcel$export(module.exports, "issueTypesResource", () => $0c72c798ed369d5b$export$614e9d897c1ef917);

var $ebyGx = parcelRequire("ebyGx");

var $2M1hQ = parcelRequire("2M1hQ");

var $kXy4X = parcelRequire("kXy4X");
const $0c72c798ed369d5b$export$614e9d897c1ef917 = (0, $2M1hQ.createResource)({
    type: 'GLOBAL_ADMIN_ISSUE_TYPES_DIRECTORY',
    getKey: ()=>'issue types',
    getData: async ({ query: query })=>(0, $kXy4X.getIssueTypes)((0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(query))
});

});
parcelRegister("kXy4X", function(module, exports) {

$parcel$export(module.exports, "getIssueTypes", () => $8b29c26e18cf4514$export$4cf4b24b88599615);

var $ebyGx = parcelRequire("ebyGx");

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");


var $6tPCs = parcelRequire("6tPCs");
const $8b29c26e18cf4514$export$4cf4b24b88599615 = async (qs)=>{
    const filter = (0, $6tPCs.fromUrlTransformer)((0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(qs));
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify((0, $6tPCs.toApiUrlTransformer)(filter));
    try {
        return await (0, $7f4tk.default)(`/rest/internal/3/issuetype/search?${query}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'getIssueTypesRequest',
                packageName: (0, $f4edca700b2e0273$export$4adfbb237b083187),
                teamName: 'morphinecake'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
const $f4edca700b2e0273$export$4adfbb237b083187 = 'jiraAdminPagesIssueTypesResources';

parcelRegister("6tPCs", function(module, exports) {

$parcel$export(module.exports, "toUrlTransformer", () => $ddf87573da5ca99a$export$5b9f8ed2c34be88a);
$parcel$export(module.exports, "fromUrlTransformer", () => $ddf87573da5ca99a$export$bec67ef860c0d0e1);
$parcel$export(module.exports, "toSearchFilterQsTransformer", () => $ddf87573da5ca99a$export$bcd1ab210547e2f5);
$parcel$export(module.exports, "toSortFieldFilterQsTransformer", () => $ddf87573da5ca99a$export$c114848fa733e5c4);
$parcel$export(module.exports, "toSortDirectionFilterQsTransformer", () => $ddf87573da5ca99a$export$c5d2609f8b4048d3);
$parcel$export(module.exports, "toApiUrlTransformer", () => $ddf87573da5ca99a$export$fb15afa686993f11);

var $dfl35 = parcelRequire("dfl35");

var $ebyGx = parcelRequire("ebyGx");



var $aud83 = parcelRequire("aud83");

var $eou7E = parcelRequire("eou7E");

var $iPfOK = parcelRequire("iPfOK");
const $ddf87573da5ca99a$var$sortDirectionMap = {
    [(0, $2a9e000a443b1a95$export$1dee026a19752d6b).toLowerCase()]: (0, $2a9e000a443b1a95$export$1dee026a19752d6b),
    [(0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65).toLowerCase()]: (0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65)
};
const $ddf87573da5ca99a$var$sortFieldMap = {
    [(0, $b140ee73c9ccd026$export$3c5e605ca7ade9f2).toLowerCase()]: (0, $b140ee73c9ccd026$export$3c5e605ca7ade9f2),
    [(0, $b140ee73c9ccd026$export$7673664bdc3ae979).toLowerCase()]: (0, $b140ee73c9ccd026$export$7673664bdc3ae979)
};
const $ddf87573da5ca99a$export$5b9f8ed2c34be88a = (filter)=>filter ? {
        page: filter.page !== undefined && filter.page >= 1 ? String(filter.page) : undefined,
        sortDirection: (0, $eou7E.fieldToParam)(filter.sortDirection),
        sortField: (0, $eou7E.fieldToParam)(filter.sortField),
        searchFilter: (0, $eou7E.trimSearchFilter)(filter.searchFilter)
    } : {};
const $ddf87573da5ca99a$export$bec67ef860c0d0e1 = (params)=>({
        page: Math.floor(Number((0, $aud83.number).parse(params.page))) || undefined,
        searchFilter: (0, $eou7E.trimSearchFilter)(params.searchFilter),
        sortDirection: (0, $eou7E.fieldFromParam)($ddf87573da5ca99a$var$sortDirectionMap, params.sortDirection),
        sortField: (0, $eou7E.fieldFromParam)($ddf87573da5ca99a$var$sortFieldMap, params.sortField)
    });
const $ddf87573da5ca99a$export$bcd1ab210547e2f5 = (qs)=>{
    const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(qs);
    return parsed.searchFilter ? parsed.searchFilter : '';
};
const $ddf87573da5ca99a$export$c114848fa733e5c4 = (qs)=>{
    const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(qs);
    return parsed.sortField && parsed.sortField === 'name' ? (0, $b140ee73c9ccd026$export$3c5e605ca7ade9f2) : (0, $b140ee73c9ccd026$export$7673664bdc3ae979);
};
const $ddf87573da5ca99a$export$c5d2609f8b4048d3 = (qs)=>{
    const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(qs);
    return parsed.sortDirection && parsed.sortDirection === 'asc' ? (0, $2a9e000a443b1a95$export$1dee026a19752d6b) : (0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65);
};
const $ddf87573da5ca99a$var$apiSortByMap = {
    [(0, $2a9e000a443b1a95$export$1dee026a19752d6b)]: '',
    [(0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65)]: '-'
};
const $ddf87573da5ca99a$export$fb15afa686993f11 = (filter)=>{
    const fullFilter = (0, (/*@__PURE__*/$parcel$interopDefault($dfl35)))({}, filter, (0, $iPfOK.DEFAULT_FILTER));
    // this additional mapping here is needed because the BE issue type search API already supports sorting by hierarchy level using the "type" parameter. It was decided to add mapping on frontend. More details here https://atlassian.slack.com/archives/C02HN05MC8K/p1680683395059279
    const sortFieldMapping = fullFilter.sortField === 'hierarchy-level' ? 'type' : fullFilter.sortField;
    return {
        maxResults: (0, $iPfOK.MAX_RESULTS),
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        startAt: (fullFilter.page - 1) * (0, $iPfOK.MAX_RESULTS),
        query: (0, $eou7E.trimSearchFilter)(fullFilter.searchFilter),
        // @ts-expect-error - TS2538 - Type 'undefined' cannot be used as an index type.
        orderBy: `${$ddf87573da5ca99a$var$apiSortByMap[fullFilter.sortDirection]}${sortFieldMapping}`
    };
};

});
parcelRegister("dfl35", function(module, exports) {

var $g7i7g = parcelRequire("g7i7g");

var $dGT4U = parcelRequire("dGT4U");

var $4rDUz = parcelRequire("4rDUz");

var $lbyKY = parcelRequire("lbyKY");
/** Used for built-in method references. */ var $9a4d00e997b9e158$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9a4d00e997b9e158$var$hasOwnProperty = $9a4d00e997b9e158$var$objectProto.hasOwnProperty;
/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */ var $9a4d00e997b9e158$var$defaults = $g7i7g(function(object, sources) {
    object = Object(object);
    var index = -1;
    var length = sources.length;
    var guard = length > 2 ? sources[2] : undefined;
    if (guard && $4rDUz(sources[0], sources[1], guard)) length = 1;
    while(++index < length){
        var source = sources[index];
        var props = $lbyKY(source);
        var propsIndex = -1;
        var propsLength = props.length;
        while(++propsIndex < propsLength){
            var key = props[propsIndex];
            var value = object[key];
            if (value === undefined || $dGT4U(value, $9a4d00e997b9e158$var$objectProto[key]) && !$9a4d00e997b9e158$var$hasOwnProperty.call(object, key)) object[key] = source[key];
        }
    }
    return object;
});
module.exports = $9a4d00e997b9e158$var$defaults;

});

// data field names
const $b140ee73c9ccd026$export$3c5e605ca7ade9f2 = 'name';
const $b140ee73c9ccd026$export$d44826c816b5619b = 'description';
const $b140ee73c9ccd026$export$b87f371cbc396fcf = 'type';
const $b140ee73c9ccd026$export$7673664bdc3ae979 = 'hierarchy-level';
const $b140ee73c9ccd026$export$68e97ee499f7c743 = 'related-schemes';
const $b140ee73c9ccd026$export$92a1a3b7554e9387 = 'actions';
const $b140ee73c9ccd026$export$23ba45d5f8d54fed = 'level-number';
const $b140ee73c9ccd026$export$1dc71bc9f1a3749a = 'arrow';
const $b140ee73c9ccd026$export$8be5a31a21d0c723 = 'level-name';
const $b140ee73c9ccd026$export$6ad51af4785d6548 = 'jira-issue-types';
const $b140ee73c9ccd026$export$20068afc6f8c1737 = 'label-space';

const $2a9e000a443b1a95$export$1dee026a19752d6b = 'ASC';
const $2a9e000a443b1a95$export$b6abcf7fa1d94f65 = 'DESC';

parcelRegister("aud83", function(module, exports) {

$parcel$export(module.exports, "string", () => $b7c0843f761cef5f$export$22b082955e083ec3);
$parcel$export(module.exports, "bool", () => $b7c0843f761cef5f$export$87b259aa03e3d267);
$parcel$export(module.exports, "array", () => $b7c0843f761cef5f$export$2f23118c22fb2630);
$parcel$export(module.exports, "multiple", () => $b7c0843f761cef5f$export$939ddaa3205df08e);
$parcel$export(module.exports, "number", () => $b7c0843f761cef5f$export$98e628dec113755e);

var $etyzk = parcelRequire("etyzk");
const $b7c0843f761cef5f$export$22b082955e083ec3 = {
    stringify: (0, (/*@__PURE__*/$parcel$interopDefault($etyzk))),
    parse: (0, (/*@__PURE__*/$parcel$interopDefault($etyzk)))
};
const $b7c0843f761cef5f$export$87b259aa03e3d267 = {
    stringify: (value)=>String(value),
    parse: (value)=>{
        if (value === 'true') return true;
        if (value === 'false') return false;
        return undefined;
    }
};
const $b7c0843f761cef5f$export$2f23118c22fb2630 = {
    stringify: (value)=>value && Array.isArray(value) ? value.join(',') : undefined,
    parse: (value)=>typeof value === 'string' ? value?.split(',') : undefined
};
const $b7c0843f761cef5f$export$939ddaa3205df08e = {
    stringify: (value)=>{
        if (!value || !Array.isArray(value)) return undefined;
        return value.length === 1 ? value[0] : value;
    },
    parse: (value)=>value && Array.isArray(value) ? value : [
            String(value)
        ]
};
const $b7c0843f761cef5f$export$98e628dec113755e = {
    stringify: (value)=>`${value}`,
    parse: (value)=>Number(value)
};

});

parcelRegister("eou7E", function(module, exports) {

$parcel$export(module.exports, "fieldToParam", () => $56517d5895d07b39$export$7341f299e7b93e87);
$parcel$export(module.exports, "fieldFromParam", () => $56517d5895d07b39$export$c876451e094c0060);
$parcel$export(module.exports, "trimSearchFilter", () => $56517d5895d07b39$export$ed1722f41c23aaaf);
const $56517d5895d07b39$export$7341f299e7b93e87 = (field)=>field !== undefined ? field.toLowerCase() : undefined;
const $56517d5895d07b39$export$c876451e094c0060 = (map, param)=>map[param] !== undefined ? map[param] : undefined;
const $56517d5895d07b39$export$ed1722f41c23aaaf = (searchFilter)=>{
    if (searchFilter === undefined) return undefined;
    return searchFilter.trim() || undefined;
};

});

parcelRegister("iPfOK", function(module, exports) {

$parcel$export(module.exports, "MAX_RESULTS", () => $68af332912f0171f$export$f6b2881bc1090cea);
$parcel$export(module.exports, "DEFAULT_FILTER", () => $68af332912f0171f$export$6deee0e4f2fb784e);


const $68af332912f0171f$export$f6b2881bc1090cea = 15;
const $68af332912f0171f$export$6deee0e4f2fb784e = {
    page: 1,
    sortDirection: (0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65),
    sortField: (0, $b140ee73c9ccd026$export$7673664bdc3ae979)
};

});




parcelRegister("doDFU", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueTypesRoute", () => $eae4c8452b1a9d87$export$7358263a3bbb38b1);
const $eae4c8452b1a9d87$export$7358263a3bbb38b1 = {
    name: 'global-settings-issues-types-view',
    path: '/jira/settings/issues/issue-types'
};

});

parcelRegister("d9kjz", function(module, exports) {

$parcel$export(module.exports, "LazyIssueTypesDirectory", () => $3e26a0063e6eb003$export$661e1bf38bb82270);
$parcel$export(module.exports, "default", () => $3e26a0063e6eb003$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $3e26a0063e6eb003$export$661e1bf38bb82270 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("goIHE"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/issue-types/issue-types-directory/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3e26a0063e6eb003$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3e26a0063e6eb003$export$661e1bf38bb82270,
        pageId: "jira-admin-pages-issue-types-directory",
        shouldShowSpinner: true
    });

});
parcelRegister("goIHE", function(module, exports) {

let $bf01905948d1a0df$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bf01905948d1a0df$var$load("2GJWD").then(()=>parcelRequire('g8Lpc'));

});



parcelRegister("4x45G", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueTypesSchemesRouteEntry", () => $50729a11180c681f$export$8f940be66a7e7324);

var $6oOqs = parcelRequire("6oOqs");

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $fZtiC = parcelRequire("fZtiC");

var $5pSYQ = parcelRequire("5pSYQ");

var $eISHy = parcelRequire("eISHy");
const $50729a11180c681f$export$8f940be66a7e7324 = (0, $7NszV.createEntry)((0, $fZtiC.globalSettingsIssueTypesSchemesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.view-issue-type-schemes',
        component: (0, $eISHy.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $6oOqs.default),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $eISHy.LazyIssueTypeSchemesDirectory)
        ]
    }));

});
parcelRegister("6oOqs", function(module, exports) {

$parcel$export(module.exports, "default", () => $b64e685bc951c633$export$2e2bcd8739ae039);

var $ebyGx = parcelRequire("ebyGx");

var $2M1hQ = parcelRequire("2M1hQ");

var $8yNp1 = parcelRequire("8yNp1");

const $b64e685bc951c633$var$issueTypeSchemeResource = (0, $2M1hQ.createResource)({
    type: (0, $e899d40884b470a8$export$1d678052bb5ae54d),
    getKey: ({ query: query })=>`${0, $e899d40884b470a8$export$41cf50ee50d5da20}-${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(query)}`,
    maxAge: 0,
    getData: async ({ query: query })=>(0, $8yNp1.getIssueTypeSchemes)((0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(query))
});
var $b64e685bc951c633$export$2e2bcd8739ae039 = $b64e685bc951c633$var$issueTypeSchemeResource;

});
parcelRegister("8yNp1", function(module, exports) {

$parcel$export(module.exports, "getIssueTypeSchemes", () => $b3d43746aaf616dc$export$2844cac611eecaa7);

var $ebyGx = parcelRequire("ebyGx");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $7vF3l = parcelRequire("7vF3l");

var $bLpq9 = parcelRequire("bLpq9");
const $b3d43746aaf616dc$export$2844cac611eecaa7 = async (qs)=>{
    const filter = (0, $bLpq9.fromUrlTransformer)((0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(qs));
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify((0, $bLpq9.toApiUrlTransformer)(filter));
    try {
        return await (0, $eusud.performGetRequest)(`/rest/api/3/issuetypescheme?${query}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'getIssueTypesRequest',
                packageName: (0, $7vF3l.PACKAGE_NAME),
                teamName: 'morphinecake'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
parcelRegister("7vF3l", function(module, exports) {

$parcel$export(module.exports, "SOURCE_NAME", () => $72a1bf464873d379$export$a3821bc63538b210);
$parcel$export(module.exports, "ISSUE_TYPE_SCHEMES_TABLE", () => $72a1bf464873d379$export$91570d508c93485d);
$parcel$export(module.exports, "ORDER", () => $72a1bf464873d379$export$11e75bce9f7ea886);
$parcel$export(module.exports, "MAX_RESULTS", () => $72a1bf464873d379$export$f6b2881bc1090cea);
$parcel$export(module.exports, "defaultIssueTypeSchemesFilter", () => $72a1bf464873d379$export$625de46796f967ae);
$parcel$export(module.exports, "EMPTY_PROJECTS_PAGE", () => $72a1bf464873d379$export$81a0343467d0e9a9);
$parcel$export(module.exports, "PACKAGE_NAME", () => $72a1bf464873d379$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "FILTER_CHANGE_ANALYTICS", () => $72a1bf464873d379$export$9ac56b2484c2d4e9);
// analytics constants

const $72a1bf464873d379$export$a3821bc63538b210 = 'issueTypeSchemeDirectory';
const $72a1bf464873d379$export$91570d508c93485d = 'issueTypeSchemesTable';
const $72a1bf464873d379$export$11e75bce9f7ea886 = Object.freeze({
    ASC: 'asc',
    DESC: 'desc'
});
const $72a1bf464873d379$export$f6b2881bc1090cea = 10;
const $72a1bf464873d379$export$625de46796f967ae = {
    pageNumber: 1,
    pageSize: $72a1bf464873d379$export$f6b2881bc1090cea,
    expand: [
        'projects',
        'issueTypes'
    ],
    orderBy: 'name',
    sortDirection: (0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65)
};
const $72a1bf464873d379$export$81a0343467d0e9a9 = {
    startAt: 0,
    maxResults: 10,
    values: [],
    total: 0,
    isLast: true
};
const $72a1bf464873d379$export$b8b9d90f9e5bd72b = 'jiraAdminPagesIssueTypeSchemesDirectory';
const $72a1bf464873d379$export$9ac56b2484c2d4e9 = Object.freeze({
    ACTION: 'changed',
    ACTION_SUBJECT: 'filterSearch'
});

});

parcelRegister("bLpq9", function(module, exports) {

$parcel$export(module.exports, "toUrlTransformer", () => $90d499beb7e9cb88$export$5b9f8ed2c34be88a);
$parcel$export(module.exports, "fromUrlTransformer", () => $90d499beb7e9cb88$export$bec67ef860c0d0e1);
$parcel$export(module.exports, "toApiUrlTransformer", () => $90d499beb7e9cb88$export$fb15afa686993f11);

var $dfl35 = parcelRequire("dfl35");

var $aud83 = parcelRequire("aud83");

var $7vF3l = parcelRequire("7vF3l");

var $lL6pH = parcelRequire("lL6pH");
const $90d499beb7e9cb88$export$5b9f8ed2c34be88a = (filter)=>{
    const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy } = filter || {};
    return {
        pageNumber: pageNumber,
        searchFilter: searchFilter,
        orderBy: orderBy
    };
};
const $90d499beb7e9cb88$export$bec67ef860c0d0e1 = (params)=>{
    const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy } = params;
    const parsedNumber = Number.isNaN((0, $aud83.number).parse(pageNumber)) ? (0, $7vF3l.defaultIssueTypeSchemesFilter).pageNumber : (0, $aud83.number).parse(pageNumber);
    const parsedOrderBy = orderBy === 'name' || orderBy === '-name' ? orderBy : undefined;
    return {
        ...(0, $7vF3l.defaultIssueTypeSchemesFilter),
        pageNumber: parsedNumber != null ? Number(parsedNumber) : undefined,
        searchFilter: searchFilter,
        orderBy: parsedOrderBy
    };
};
const $90d499beb7e9cb88$export$fb15afa686993f11 = (filter)=>{
    const fullFilter = (0, (/*@__PURE__*/$parcel$interopDefault($dfl35)))({}, filter, (0, $7vF3l.defaultIssueTypeSchemesFilter));
    let requestParams = {
        maxResults: (0, $7vF3l.MAX_RESULTS),
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        startAt: (fullFilter.pageNumber - 1) * (0, $7vF3l.MAX_RESULTS),
        orderBy: fullFilter.orderBy,
        queryString: (0, $lL6pH.trimSearchFilter)(fullFilter.searchFilter)
    };
    if (fullFilter.expand != null) // @ts-expect-error - TS2322 - Type '{ expand: string; maxResults: number; startAt: number; orderBy: IssueTypeOrderBy | undefined; queryString: string | undefined; }' is not assignable to type '{ maxResults: number; startAt: number; orderBy: IssueTypeOrderBy | undefined; queryString: string | undefined; }'.
    requestParams = {
        ...requestParams,
        expand: fullFilter.expand.join(',')
    };
    return requestParams;
};

});
parcelRegister("lL6pH", function(module, exports) {

$parcel$export(module.exports, "trimSearchFilter", () => $8bfdbd5ef20cefa5$export$ed1722f41c23aaaf);
const $8bfdbd5ef20cefa5$export$ed1722f41c23aaaf = (searchFilter)=>{
    if (searchFilter === undefined) return undefined;
    return searchFilter.trim() || undefined;
};

});



const $e899d40884b470a8$export$1d678052bb5ae54d = 'ISSUE_TYPE_SCHEME_TABLE';
const $e899d40884b470a8$export$41cf50ee50d5da20 = 'ISSUE_TYPE_SCHEME_TABLE_KEY';


parcelRegister("fZtiC", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueTypesSchemesRoute", () => $2bc2621ba9f684f5$export$2aba97aa663f43b3);
const $2bc2621ba9f684f5$export$2aba97aa663f43b3 = {
    name: 'global-settings-issues-types-schemes-manage',
    path: '/jira/settings/issues/issue-type-schemes'
};

});

parcelRegister("eISHy", function(module, exports) {

$parcel$export(module.exports, "LazyIssueTypeSchemesDirectory", () => $651db9488b9701c8$export$611728a54ba37830);
$parcel$export(module.exports, "default", () => $651db9488b9701c8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $651db9488b9701c8$export$611728a54ba37830 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("EaBXJ"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/issue-types/issue-type-schemes-directory/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$651db9488b9701c8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $651db9488b9701c8$export$611728a54ba37830,
        pageId: "jira-admin-pages-issue-type-schemes-directory",
        shouldShowSpinner: true
    });

});
parcelRegister("EaBXJ", function(module, exports) {

let $078bf7b95f75c715$var$load = (parcelRequire("28QjX"))(4);
module.exports = $078bf7b95f75c715$var$load("lblbO").then(()=>parcelRequire('1dsYb'));

});



parcelRegister("a4nP2", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueTypesScreenSchemesRouteEntry", () => $3911900520b0c6a8$export$e2c2c1569887e684);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $4gtHC = parcelRequire("4gtHC");

var $5pSYQ = parcelRequire("5pSYQ");

var $kMjOg = parcelRequire("kMjOg");
const $3911900520b0c6a8$export$e2c2c1569887e684 = (0, $7NszV.createEntry)((0, $4gtHC.globalSettingsIssueTypesScreenSchemesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.issue-type-screen-schemes',
        component: (0, $kMjOg.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kMjOg.LazyIssueTypeScreenSchemesPage)
        ]
    }));

});
parcelRegister("4gtHC", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueTypesScreenSchemesRoute", () => $2245c71c2bdfe600$export$df93a4addc359237);
const $2245c71c2bdfe600$export$df93a4addc359237 = {
    name: 'global-settings-issues-types-screen-schemes-view',
    path: '/jira/settings/issues/issue-type-screen-schemes'
};

});

parcelRegister("kMjOg", function(module, exports) {

$parcel$export(module.exports, "LazyIssueTypeScreenSchemesPage", () => $73b6b725092289e9$export$350edfb57b335a57);
$parcel$export(module.exports, "default", () => $73b6b725092289e9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $73b6b725092289e9$export$350edfb57b335a57 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("cTrCH"))), {
    moduleId: "./src/packages/admin-pages/screens/issue-type-screen-schemes-page/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$73b6b725092289e9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $73b6b725092289e9$export$350edfb57b335a57,
        pageId: "jira-admin-pages-issue-type-screen-schemes-page",
        shouldShowSpinner: true
    });

});
parcelRegister("cTrCH", function(module, exports) {

let $96300c77c31ba9db$var$load = (parcelRequire("28QjX"))(4);
module.exports = $96300c77c31ba9db$var$load("jvJLL").then(()=>parcelRequire('5K98P'));

});



parcelRegister("dtLGm", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueWorkflow1RouteEntry", () => $68897fd2bacb1927$export$55e4c1d21a9b75e6);

var $3aIZg = parcelRequire("3aIZg");

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $cPrje = parcelRequire("cPrje");

var $5pSYQ = parcelRequire("5pSYQ");

var $i6RvY = parcelRequire("i6RvY");
const $68897fd2bacb1927$export$55e4c1d21a9b75e6 = (0, $7NszV.createEntry)((0, $cPrje.globalSettingsIssueWorkflow1Route), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.view-workflows',
        component: (0, $i6RvY.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $3aIZg.default),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $i6RvY.LazyListWorkflows)
        ]
    }));

});
parcelRegister("3aIZg", function(module, exports) {

$parcel$export(module.exports, "default", () => $9146315a1662307e$export$2e2bcd8739ae039);

var $ebyGx = parcelRequire("ebyGx");

var $2M1hQ = parcelRequire("2M1hQ");

var $AdkCT = parcelRequire("AdkCT");

const $9146315a1662307e$var$workFlowsResource = (0, $2M1hQ.createResource)({
    type: (0, $5c95bdf76715894f$export$b11854972ecaecc7),
    getKey: ({ query: query })=>`${0, $5c95bdf76715894f$export$6602c5404301813f}-${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(query)}`,
    maxAge: 0,
    getData: async ({ query: query })=>(0, $AdkCT.getListWorkFlows)((0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(query))
});
var $9146315a1662307e$export$2e2bcd8739ae039 = $9146315a1662307e$var$workFlowsResource;

});
parcelRegister("AdkCT", function(module, exports) {

$parcel$export(module.exports, "getListWorkFlows", () => $bd8703d90d89a06c$export$952f5d693c3c0d4e);

var $ebyGx = parcelRequire("ebyGx");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $lNKJm = parcelRequire("lNKJm");

var $9KDge = parcelRequire("9KDge");
const $bd8703d90d89a06c$export$952f5d693c3c0d4e = async (qs)=>{
    const filter = (0, $9KDge.fromUrlTransformer)((0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(qs));
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify((0, $9KDge.toApiUrlTransformer)(filter));
    try {
        return await (0, $eusud.performGetRequest)(`/rest/api/3/workflow/search?${query}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'getWorkflowsSearchAPI',
                packageName: (0, $lNKJm.PACKAGE_NAME),
                teamName: 'helix'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
parcelRegister("lNKJm", function(module, exports) {

$parcel$export(module.exports, "SOURCE_NAME", () => $51adf94ab22e1863$export$a3821bc63538b210);
$parcel$export(module.exports, "WORKFLOW_NAME", () => $51adf94ab22e1863$export$a69699c3acbd94ca);
$parcel$export(module.exports, "PACKAGE_NAME", () => $51adf94ab22e1863$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "WORKFLOWS_ACTIONS", () => $51adf94ab22e1863$export$f3ab46ae5f3c01ad);
$parcel$export(module.exports, "WORKFLOWS_SCHEME", () => $51adf94ab22e1863$export$81c9aaf617cb2f01);
$parcel$export(module.exports, "SYSTEM_WORKFLOW_JIRA_NAME", () => $51adf94ab22e1863$export$615f1d8b29794ae);
$parcel$export(module.exports, "SYSTEM_WORKFLOW_BUILDS_WORKFLOWS_NAME", () => $51adf94ab22e1863$export$fccd4c1ce5f0896f);
$parcel$export(module.exports, "DEFAULT_PAGE_SIZE", () => $51adf94ab22e1863$export$5716e8bcb003888d);
$parcel$export(module.exports, "defaultListWorkFlowsFilter", () => $51adf94ab22e1863$export$dc5aae53031515c);
$parcel$export(module.exports, "ORDER", () => $51adf94ab22e1863$export$11e75bce9f7ea886);
$parcel$export(module.exports, "FILTER_CHANGE_ANALYTICS", () => $51adf94ab22e1863$export$9ac56b2484c2d4e9);
$parcel$export(module.exports, "PAGE_SIZE_CHANGE_ANALYTICS", () => $51adf94ab22e1863$export$e6613a3c77896936);
$parcel$export(module.exports, "API_PREFIX", () => $51adf94ab22e1863$export$a3f6840410eb0571);

const $51adf94ab22e1863$export$a3821bc63538b210 = 'listWorkflows';
const $51adf94ab22e1863$export$a69699c3acbd94ca = 'workflowName';
const $51adf94ab22e1863$export$b8b9d90f9e5bd72b = 'jira-admin-pages-list-workflows';
const $51adf94ab22e1863$export$f3ab46ae5f3c01ad = 'workflowsActions';
const $51adf94ab22e1863$export$81c9aaf617cb2f01 = 'workflowScheme';
const $51adf94ab22e1863$export$615f1d8b29794ae = 'jira';
const $51adf94ab22e1863$export$fccd4c1ce5f0896f = 'Builds Workflow';
const $51adf94ab22e1863$export$5716e8bcb003888d = 10;
const $51adf94ab22e1863$export$dc5aae53031515c = {
    pageNumber: 1,
    pageSize: $51adf94ab22e1863$export$5716e8bcb003888d,
    expand: [
        'default',
        'hasDraftWorkflow',
        'schemes',
        'operations',
        'projects'
    ],
    orderBy: 'name',
    sortDirection: (0, $2a9e000a443b1a95$export$1dee026a19752d6b),
    isActive: true
};
const $51adf94ab22e1863$export$11e75bce9f7ea886 = Object.freeze({
    ASC: 'asc',
    DESC: 'desc'
});
const $51adf94ab22e1863$export$9ac56b2484c2d4e9 = Object.freeze({
    ACTION: 'changed',
    ACTION_SUBJECT: 'filterSearch'
});
const $51adf94ab22e1863$export$e6613a3c77896936 = Object.freeze({
    ACTION: 'changed',
    ACTION_SUBJECT: 'pageSize'
});
const $51adf94ab22e1863$export$a3f6840410eb0571 = 'gateway/api/jira/project-configuration';

});

parcelRegister("9KDge", function(module, exports) {

$parcel$export(module.exports, "toUrlTransformer", () => $f0642d0f1e447d39$export$5b9f8ed2c34be88a);
$parcel$export(module.exports, "fromUrlTransformer", () => $f0642d0f1e447d39$export$bec67ef860c0d0e1);
$parcel$export(module.exports, "toApiUrlTransformer", () => $f0642d0f1e447d39$export$fb15afa686993f11);

var $aud83 = parcelRequire("aud83");

var $lNKJm = parcelRequire("lNKJm");

var $lgmUP = parcelRequire("lgmUP");
const $f0642d0f1e447d39$export$5b9f8ed2c34be88a = (filter)=>{
    const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy, isActive: isActive, pageSize: pageSize } = filter || {};
    return {
        pageNumber: pageNumber,
        searchFilter: searchFilter,
        orderBy: orderBy,
        isActive: isActive,
        pageSize: pageSize
    };
};
const $f0642d0f1e447d39$export$bec67ef860c0d0e1 = (params)=>{
    const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy, isActive: isActive, pageSize: pageSize } = params;
    const parsedNumber = Number.isNaN((0, $aud83.number).parse(pageNumber)) ? (0, $lNKJm.defaultListWorkFlowsFilter).pageNumber : (0, $aud83.number).parse(pageNumber);
    const parsedSize = Number.isNaN((0, $aud83.number).parse(pageSize)) ? (0, $lNKJm.defaultListWorkFlowsFilter).pageSize : (0, $aud83.number).parse(pageSize);
    const parsedOrderBy = orderBy === 'name' || orderBy === '-name' || orderBy === 'updated' || orderBy === '-updated' ? orderBy : undefined;
    const isActiveFinal = isActive != null ? isActive === 'true' : (0, $lNKJm.defaultListWorkFlowsFilter).isActive;
    return {
        ...(0, $lNKJm.defaultListWorkFlowsFilter),
        pageNumber: parsedNumber != null ? Number(parsedNumber) : undefined,
        pageSize: parsedSize != null ? Number(parsedSize) : undefined,
        searchFilter: searchFilter,
        orderBy: parsedOrderBy,
        isActive: isActiveFinal
    };
};
const $f0642d0f1e447d39$export$fb15afa686993f11 = (filter)=>{
    const fullFilter = {
        ...(0, $lNKJm.defaultListWorkFlowsFilter),
        ...filter
    };
    const { pageNumber: pageNumber = 1, pageSize: pageSize = (0, $lNKJm.DEFAULT_PAGE_SIZE) } = fullFilter;
    let requestParams = {
        maxResults: pageSize,
        startAt: (pageNumber - 1) * pageSize,
        orderBy: fullFilter.orderBy,
        queryString: (0, $lgmUP.trimSearchFilter)(fullFilter.searchFilter),
        isActive: fullFilter.isActive
    };
    if (fullFilter.expand != null) // @ts-expect-error - TS2322 - Type '{ expand: string; maxResults: number; startAt: number; orderBy: WorkflowOrderBy | undefined; queryString: string | undefined; isActive: boolean; }' is not assignable to type '{ maxResults: number; startAt: number; orderBy: WorkflowOrderBy | undefined; queryString: string | undefined; isActive: boolean; }'.
    requestParams = {
        ...requestParams,
        expand: fullFilter.expand.join(',')
    };
    return requestParams;
};

});
parcelRegister("lgmUP", function(module, exports) {

$parcel$export(module.exports, "trimSearchFilter", () => $d92ccc09aa62d68e$export$ed1722f41c23aaaf);
const $d92ccc09aa62d68e$export$7341f299e7b93e87 = (field)=>field !== undefined ? field.toLowerCase() : undefined;
const $d92ccc09aa62d68e$export$c876451e094c0060 = (map, param)=>map[param] !== undefined ? map[param] : undefined;
const $d92ccc09aa62d68e$export$ed1722f41c23aaaf = (searchFilter)=>{
    if (searchFilter === undefined) return undefined;
    return searchFilter.trim() || undefined;
};

});



const $5c95bdf76715894f$export$b11854972ecaecc7 = 'WORKFLOWS_TABLE';
const $5c95bdf76715894f$export$6602c5404301813f = 'WORKFLOWS_TABLE_KEY';


parcelRegister("cPrje", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueWorkflow1Route", () => $416b12e52ba65191$export$f8f2a617a2f4d53);
const $416b12e52ba65191$export$f8f2a617a2f4d53 = {
    name: 'global-settings-issues-workflows-pages',
    path: '/jira/settings/issues/workflows'
};

});

parcelRegister("i6RvY", function(module, exports) {

$parcel$export(module.exports, "LazyListWorkflows", () => $fe432a8ece476800$export$4c64b4f1ecf22fc8);
$parcel$export(module.exports, "default", () => $fe432a8ece476800$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $fe432a8ece476800$export$4c64b4f1ecf22fc8 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hrUJD"))), {
    moduleId: "./src/packages/admin-pages/workflows/list-workflows/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fe432a8ece476800$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $fe432a8ece476800$export$4c64b4f1ecf22fc8,
        pageId: "jira-admin-pages-list-workflows",
        shouldShowSpinner: true
    });

});
parcelRegister("hrUJD", function(module, exports) {

let $cb40f7b453330308$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cb40f7b453330308$var$load("5fPPA").then(()=>parcelRequire('b9R9h'));

});



parcelRegister("f6OBR", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueWorkflowEditRouteEntry", () => $e62e629a6fa746d6$export$d2b3121978e344e);

var $ffza4 = parcelRequire("ffza4");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $6e4Kt = parcelRequire("6e4Kt");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $3P1Nf = parcelRequire("3P1Nf");

var $5pSYQ = parcelRequire("5pSYQ");

var $jGXg7 = parcelRequire("jGXg7");

var $kb4zh = parcelRequire("kb4zh");

var $6s1PB = parcelRequire("6s1PB");

var $7x7cK = parcelRequire("7x7cK");

var $fuhVB = parcelRequire("fuhVB");

var $c7jVr = parcelRequire("c7jVr");
const $e62e629a6fa746d6$var$globalSettingsIssueWorkflowEditEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $jGXg7.editWorkflowEntryPoint)
});
const $e62e629a6fa746d6$export$d2b3121978e344e = (0, $7NszV.createEntry)((0, $3P1Nf.globalSettingsIssueWorkflowEditRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.edit-workflow',
        entryPoint: ()=>(0, $6s1PB.expValEquals)('hix-6586_wfe_no_nav_or_sidebar_route', 'isEnabled', true, false) ? $e62e629a6fa746d6$var$globalSettingsIssueWorkflowEditEntryPoint : undefined,
        skeleton: (0, $6s1PB.expValEquals)('hix-6586_wfe_no_nav_or_sidebar_route', 'isEnabled', true, false) ? (0, $kb4zh.default) : undefined,
        component: (0, $6s1PB.expValEquals)('hix-6586_wfe_no_nav_or_sidebar_route', 'isEnabled', true, false) ? undefined : (0, $c7jVr.default),
        layout: (0, $6s1PB.expValEquals)('hix-6586_wfe_no_nav_or_sidebar_route', 'isEnabled', true, false) ? (0, $6e4Kt.chromelessLayout) : (0, $ibkIl.globalSettingsLayout),
        navigation: (0, $6s1PB.expValEquals)('hix-6586_wfe_no_nav_or_sidebar_route', 'isEnabled', true, false) ? undefined : {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: (0, $6s1PB.expValEquals)('hix-6586_wfe_no_nav_or_sidebar_route', 'isEnabled', true, false) ? [
            (0, $7x7cK.workflowCapabilitiesResource),
            (0, $fuhVB.workflowDocumentResource)
        ] : [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: (0, $6s1PB.expValEquals)('hix-6586_wfe_no_nav_or_sidebar_route', 'isEnabled', true, false) ? undefined : [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $c7jVr.LazyEditWorkflow)
        ]
    }));

});
parcelRegister("3P1Nf", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueWorkflowEditRoute", () => $69ca7ef2aafafa96$export$9d533f08a4447cc);
const $69ca7ef2aafafa96$export$9d533f08a4447cc = {
    name: 'global-settings-issues-workflow-edit',
    path: '/jira/settings/issues/workflows/:workflowId'
};

});

parcelRegister("jGXg7", function(module, exports) {

$parcel$export(module.exports, "editWorkflowEntryPoint", () => $0e2ba8e8e8407a4c$export$8173c14a99f6a4bb);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $0e2ba8e8e8407a4c$export$8173c14a99f6a4bb = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("gXLyc")).then((module)=>module.EditWorkflow), {
        moduleId: "0b330143",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("gXLyc", function(module, exports) {

let $c5970a9a00da8091$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c5970a9a00da8091$var$load("76n7a"),
    $c5970a9a00da8091$var$load("l253H"),
    $c5970a9a00da8091$var$load("ffQaD"),
    $c5970a9a00da8091$var$load("kvRbA"),
    $c5970a9a00da8091$var$load("0s8QH")
]).then(()=>parcelRequire('c8ahc'));

});


parcelRegister("7x7cK", function(module, exports) {

$parcel$export(module.exports, "workflowCapabilitiesResource", () => $604ad387ddc13c8b$export$752f9619231646c7);
$parcel$export(module.exports, "useWorkflowCapabilities", () => $604ad387ddc13c8b$export$861a32391dc35e21);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $1m1Q6 = parcelRequire("1m1Q6");
const $604ad387ddc13c8b$export$e683a752d2185432 = 'ADMIN_WORKFLOW_CAPABILITIES';
const $604ad387ddc13c8b$export$752f9619231646c7 = (0, $2M1hQ.createResource)({
    type: $604ad387ddc13c8b$export$e683a752d2185432,
    getKey: (matchedRoute)=>{
        const { workflowId: workflowId } = matchedRoute.match.params;
        return `${$604ad387ddc13c8b$export$e683a752d2185432}_${workflowId}`;
    },
    getData: (0, $1m1Q6.fetchWorkflowCapabilities),
    maxAge: 1000,
    isBrowserOnly: true
});
const $604ad387ddc13c8b$export$861a32391dc35e21 = ()=>(0, $2YP9W.useResource)($604ad387ddc13c8b$export$752f9619231646c7);

});
parcelRegister("1m1Q6", function(module, exports) {

$parcel$export(module.exports, "fetchWorkflowCapabilities", () => $9f6507e136da2d5c$export$51e1638cbea98309);

var $x9xyg = parcelRequire("x9xyg");

var $8PRuf = parcelRequire("8PRuf");

var $iR3GG = parcelRequire("iR3GG");

var $6SOAq = parcelRequire("6SOAq");
const $9f6507e136da2d5c$export$51e1638cbea98309 = async ({ match: match }, { tenantContext: tenantContext })=>{
    const { isAnonymous: isAnonymous } = tenantContext;
    if (isAnonymous || !match.params.workflowId) {
        const message = !match.params.workflowId ? 'Workflow ID is not defined.' : "Workflows can't be edited in anonymous mode.";
        throw new Error(message);
    }
    try {
        // better way to monitor perf?
        (0, $x9xyg.setMark)((0, $8PRuf.prefetchApiStartMark));
        const workflowCapabilities = await (0, $6SOAq.getWorkflowCapabilities)(tenantContext.cloudId, {
            workflowId: match.params.workflowId
        });
        (0, $x9xyg.setMark)((0, $8PRuf.prefetchApiReadyMark));
        return workflowCapabilities;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $iR3GG.createResourceError)({
            component: 'spa.view.routes.admin-pages.workflows.workflow-capabilities.getData',
            message: 'An error was thrown while prefetching workflow capabilities data',
            name: 'ResourceError'
        }, error);
    }
};

});
parcelRegister("6SOAq", function(module, exports) {

$parcel$export(module.exports, "getWorkflowCapabilities", () => $147e0d57ef881867$export$334f82027882d665);

var $eTYOj = parcelRequire("eTYOj");

var $7f4tk = parcelRequire("7f4tk");

var $2YZCu = parcelRequire("2YZCu");
const $147e0d57ef881867$export$c1b7f62a96ae605b = ()=>'gateway/api/jira/project-configuration';
const $147e0d57ef881867$export$a5b7a8c3b1c6e775 = (cloudId, params)=>`/${$147e0d57ef881867$export$c1b7f62a96ae605b()}/query/${cloudId}/workflow/capabilities?${(0, $eTYOj.stringify)(params)}`;
const $147e0d57ef881867$export$334f82027882d665 = (cloudId, options)=>(0, $7f4tk.default)($147e0d57ef881867$export$a5b7a8c3b1c6e775(cloudId, options), {
        method: 'GET'
    }).catch((e)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('getWorkflowAvailableCapabilities', e);
        throw e;
    });

});
parcelRegister("eTYOj", function(module, exports) {

$parcel$export(module.exports, "decode", () => $ad955f71a780c006$export$2f872c0f2117be69, (v) => $ad955f71a780c006$export$2f872c0f2117be69 = v);
$parcel$export(module.exports, "parse", () => $ad955f71a780c006$export$98e6a39c04603d36, (v) => $ad955f71a780c006$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "encode", () => $ad955f71a780c006$export$c564cdbbe6da493, (v) => $ad955f71a780c006$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "stringify", () => $ad955f71a780c006$export$fac44ee5b035f737, (v) => $ad955f71a780c006$export$fac44ee5b035f737 = v);
var $ad955f71a780c006$export$2f872c0f2117be69;
var $ad955f71a780c006$export$98e6a39c04603d36;
var $ad955f71a780c006$export$c564cdbbe6da493;
var $ad955f71a780c006$export$fac44ee5b035f737;
'use strict';

$ad955f71a780c006$export$2f872c0f2117be69 = $ad955f71a780c006$export$98e6a39c04603d36 = (parcelRequire("1aASF"));

$ad955f71a780c006$export$c564cdbbe6da493 = $ad955f71a780c006$export$fac44ee5b035f737 = (parcelRequire("eDdlV"));

});
parcelRegister("1aASF", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function $0da35560ba4ecd4e$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = function(qs, sep, eq, options) {
    sep = sep || '&';
    eq = eq || '=';
    var obj = {};
    if (typeof qs !== 'string' || qs.length === 0) return obj;
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === 'number') maxKeys = options.maxKeys;
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
    for(var i = 0; i < len; ++i){
        var x = qs[i].replace(regexp, '%20'), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = '';
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!$0da35560ba4ecd4e$var$hasOwnProperty(obj, k)) obj[k] = v;
        else if ($0da35560ba4ecd4e$var$isArray(obj[k])) obj[k].push(v);
        else obj[k] = [
            obj[k],
            v
        ];
    }
    return obj;
};
var $0da35560ba4ecd4e$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};

});

parcelRegister("eDdlV", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $aa6f10c0e9e7da3c$var$stringifyPrimitive = function(v) {
    switch(typeof v){
        case 'string':
            return v;
        case 'boolean':
            return v ? 'true' : 'false';
        case 'number':
            return isFinite(v) ? v : '';
        default:
            return '';
    }
};
module.exports = function(obj, sep, eq, name) {
    sep = sep || '&';
    eq = eq || '=';
    if (obj === null) obj = undefined;
    if (typeof obj === 'object') return $aa6f10c0e9e7da3c$var$map($aa6f10c0e9e7da3c$var$objectKeys(obj), function(k) {
        var ks = encodeURIComponent($aa6f10c0e9e7da3c$var$stringifyPrimitive(k)) + eq;
        if ($aa6f10c0e9e7da3c$var$isArray(obj[k])) return $aa6f10c0e9e7da3c$var$map(obj[k], function(v) {
            return ks + encodeURIComponent($aa6f10c0e9e7da3c$var$stringifyPrimitive(v));
        }).join(sep);
        else return ks + encodeURIComponent($aa6f10c0e9e7da3c$var$stringifyPrimitive(obj[k]));
    }).join(sep);
    if (!name) return '';
    return encodeURIComponent($aa6f10c0e9e7da3c$var$stringifyPrimitive(name)) + eq + encodeURIComponent($aa6f10c0e9e7da3c$var$stringifyPrimitive(obj));
};
var $aa6f10c0e9e7da3c$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};
function $aa6f10c0e9e7da3c$var$map(xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
    return res;
}
var $aa6f10c0e9e7da3c$var$objectKeys = Object.keys || function(obj) {
    var res = [];
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
    return res;
};

});





parcelRegister("fuhVB", function(module, exports) {

$parcel$export(module.exports, "workflowDocumentResource", () => $5368a2ffa5bbe27c$export$b63b10ddc49fa54f);
$parcel$export(module.exports, "useWorkflowDocument", () => $5368a2ffa5bbe27c$export$1ed79b881a7cb8b1);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $fHwlu = parcelRequire("fHwlu");
const $5368a2ffa5bbe27c$export$e683a752d2185432 = 'ADMIN_WORKFLOW_DOCUMENT';
const $5368a2ffa5bbe27c$export$b63b10ddc49fa54f = (0, $2M1hQ.createResource)({
    type: $5368a2ffa5bbe27c$export$e683a752d2185432,
    getKey: (matchedRoute)=>{
        const { workflowId: workflowId } = matchedRoute.match.params;
        return `${$5368a2ffa5bbe27c$export$e683a752d2185432}_${workflowId}`;
    },
    getData: (0, $fHwlu.fetchWorkflowDocument),
    maxAge: 1000,
    isBrowserOnly: true
});
const $5368a2ffa5bbe27c$export$1ed79b881a7cb8b1 = ()=>(0, $2YP9W.useResource)($5368a2ffa5bbe27c$export$b63b10ddc49fa54f);

});
parcelRegister("fHwlu", function(module, exports) {

$parcel$export(module.exports, "fetchWorkflowDocument", () => $6c2174346e46ec13$export$f9f333ad2a8d394b);

var $x9xyg = parcelRequire("x9xyg");

var $8PRuf = parcelRequire("8PRuf");

var $iR3GG = parcelRequire("iR3GG");

var $b9Vx2 = parcelRequire("b9Vx2");
const $6c2174346e46ec13$export$f9f333ad2a8d394b = async ({ match: match }, { tenantContext: tenantContext })=>{
    const { isAnonymous: isAnonymous } = tenantContext;
    if (isAnonymous || !match.params.workflowId) {
        const message = !match.params.workflowId ? 'Workflow ID is not defined.' : "Workflows can't be edited in anonymous mode.";
        throw new Error(message);
    }
    try {
        (0, $x9xyg.setMark)((0, $8PRuf.prefetchApiStartMark));
        const workflowDocument = await (0, $b9Vx2.getWorkflow)(tenantContext.cloudId, {
            workflowId: match.params.workflowId
        });
        (0, $x9xyg.setMark)((0, $8PRuf.prefetchApiReadyMark));
        return workflowDocument;
    } catch (error) {
        throw (0, $iR3GG.createResourceError)({
            component: 'spa.view.routes.admin-pages.workflows.workflow-document.getData',
            message: 'An error was thrown while prefetching workflow document data',
            name: 'ResourceError'
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
        error);
    }
};

});
parcelRegister("b9Vx2", function(module, exports) {

$parcel$export(module.exports, "getWorkflow", () => $cc97485612cdb82f$export$f927248b35ee72a7);

var $hGgHi = parcelRequire("hGgHi");

var $eusud = parcelRequire("eusud");

var $4R6GH = parcelRequire("4R6GH");
const $cc97485612cdb82f$export$c1b7f62a96ae605b = ()=>'gateway/api/jira/project-configuration';
const $cc97485612cdb82f$export$a5b7a8c3b1c6e775 = (cloudId)=>`/${$cc97485612cdb82f$export$c1b7f62a96ae605b()}/query/${cloudId}/3/workflow`;
const $cc97485612cdb82f$export$f927248b35ee72a7 = (cloudId, workflowIdentifier, config)=>{
    const url = $cc97485612cdb82f$export$a5b7a8c3b1c6e775(cloudId);
    const { workflowId: workflowId, workflowName: workflowName, projectAndIssueType: projectAndIssueType } = workflowIdentifier;
    const payload = {
        skipUsageLookup: false
    };
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(workflowId)) payload.workflowIds = [
        workflowId
    ];
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(workflowName)) payload.workflowNames = [
        workflowName
    ];
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(projectAndIssueType)) payload.projectAndIssueTypes = [
        projectAndIssueType
    ];
    if (config?.checkForDrafts && (0, $4R6GH.fg)('hix-6846-discard-wfl-drafts-on-update')) payload.checkForDrafts = true;
    return (0, $eusud.performPostRequest)(url, {
        body: JSON.stringify(payload)
    });
};

});



parcelRegister("c7jVr", function(module, exports) {

$parcel$export(module.exports, "LazyEditWorkflow", () => $793ac7f9af5a2945$export$cb79ebb337a95317);
$parcel$export(module.exports, "default", () => $793ac7f9af5a2945$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $793ac7f9af5a2945$export$cb79ebb337a95317 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("gXLyc"))), {
    moduleId: "./src/packages/admin-pages/workflows/edit-workflow/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$793ac7f9af5a2945$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $793ac7f9af5a2945$export$cb79ebb337a95317,
        pageId: "jira-admin-pages-edit-workflow",
        shouldShowSpinner: true
    });

});


parcelRegister("dRexn", function(module, exports) {

$parcel$export(module.exports, "globalSettingsLegacyFieldLayoutRouteEntry", () => $f3a2596a31c9bceb$export$49998c6229ab8099);

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $5LAK1 = parcelRequire("5LAK1");

var $dqRj0 = parcelRequire("dqRj0");
const $f3a2596a31c9bceb$export$49998c6229ab8099 = (0, $7NszV.createEntry)((0, $5LAK1.globalSettingsLegacyFieldLayoutRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        component: (0, $dqRj0.LazyLegacyFieldLayoutPage),
        forPaint: [
            (0, $dqRj0.LazyLegacyFieldLayoutPromise)
        ]
    }));

});
parcelRegister("5LAK1", function(module, exports) {

$parcel$export(module.exports, "globalSettingsLegacyFieldLayoutRoute", () => $9095ae31098f1586$export$82fa992cdfa20fb5);
const $9095ae31098f1586$export$82fa992cdfa20fb5 = {
    name: 'global-settings-issues-legacy-field-layout',
    path: '/jira/settings/issues/field-configuration/:fieldLayoutId'
};

});

parcelRegister("dqRj0", function(module, exports) {

$parcel$export(module.exports, "LazyLegacyFieldLayoutPromise", () => $cbf369bc67d9494e$export$8b5ab888f8df499);
$parcel$export(module.exports, "LazyLegacyFieldLayoutPage", () => $cbf369bc67d9494e$export$676ecf497a280cfa);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $cbf369bc67d9494e$export$8b5ab888f8df499 = (0, $kxZPA.lazyForPaint)(()=>{
    return (0, $7yO8g.markAsProductBundleReady)((parcelRequire("5TIyC")).then((bundle)=>bundle.LegacyFieldLayoutApp));
}, {
    moduleId: "./src/packages/admin-pages/legacy-field-layout/src/index.tsx"
});
const $cbf369bc67d9494e$export$676ecf497a280cfa = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cbf369bc67d9494e$export$8b5ab888f8df499,
        pageId: "jira-admin-pages-legacy-field-layout",
        shouldShowSpinner: true
    });

});
parcelRegister("5TIyC", function(module, exports) {

let $44b4a6fa0796c7b4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $44b4a6fa0796c7b4$var$load("5sYR0").then(()=>parcelRequire('dENL7'));

});



parcelRegister("b952b", function(module, exports) {

$parcel$export(module.exports, "globalSettingsOptimizeFieldConfigurationSchemeRouteEntry", () => $f4756476c75bffa3$export$b98ced4649f55b1c);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $l8mjk = parcelRequire("l8mjk");

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $5lsNZ = parcelRequire("5lsNZ");

var $5pSYQ = parcelRequire("5pSYQ");

var $ehkRy = parcelRequire("ehkRy");
const $f4756476c75bffa3$export$b98ced4649f55b1c = (0, $7NszV.createEntry)((0, $l8mjk.globalSettingsOptimizeFieldConfigurationSchemeRoute), ()=>({
        group: 'global-settings',
        component: (0, $cSD7y.componentWithFG)('field_streamlining_ui', (0, $ehkRy.OptimizeFieldConfigurationSchemePage), (0, $5lsNZ.default)),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        canTransitionIn: ()=>(0, $4R6GH.fg)('field_streamlining_ui'),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ehkRy.LazyOptimizeFieldConfigurationSchemePagePage)
        ]
    }));

});
parcelRegister("l8mjk", function(module, exports) {

$parcel$export(module.exports, "globalSettingsOptimizeFieldConfigurationSchemeRoute", () => $1cad7dbb66344a48$export$3da73e59758744eb);
const $1cad7dbb66344a48$export$3da73e59758744eb = {
    name: 'global-settings-optimize-field-configuration-scheme-view',
    path: '/jira/settings/issues/field-configuration-schemes/:fieldConfigurationSchemeId/optimize'
};

});

parcelRegister("ehkRy", function(module, exports) {

$parcel$export(module.exports, "LazyOptimizeFieldConfigurationSchemePagePage", () => $38dfff5e6a0cdd15$export$bd8509501da10c3);
$parcel$export(module.exports, "OptimizeFieldConfigurationSchemePage", () => $38dfff5e6a0cdd15$export$7cd55863572c1f3a);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $38dfff5e6a0cdd15$export$bd8509501da10c3 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("5AwDH"))), {
    ssr: false,
    moduleId: "./src/packages/site-optimizer/optimize-field-configuration-scheme-page/src/index.tsx"
});
const $38dfff5e6a0cdd15$export$7cd55863572c1f3a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $38dfff5e6a0cdd15$export$bd8509501da10c3,
        pageId: "jira-admin-pages-optimize-field-configuration-scheme-page",
        shouldShowSpinner: true
    });

});
parcelRegister("5AwDH", function(module, exports) {

let $4119a20296b4f499$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4119a20296b4f499$var$load("5w8u2").then(()=>parcelRequire('hHp0Z'));

});



parcelRegister("aZXhs", function(module, exports) {

$parcel$export(module.exports, "globalSettingsOptimizeWorkTypeSchemeRouteEntry", () => $1f1412c4c9101f48$export$bae97ca0b9dd2ea2);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $hRCOF = parcelRequire("hRCOF");

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $5lsNZ = parcelRequire("5lsNZ");

var $5pSYQ = parcelRequire("5pSYQ");

var $kWXll = parcelRequire("kWXll");
const $1f1412c4c9101f48$export$bae97ca0b9dd2ea2 = (0, $7NszV.createEntry)((0, $hRCOF.globalSettingsOptimizeWorkTypeSchemeRoute), ()=>({
        group: 'global-settings',
        component: (0, $cSD7y.componentWithFG)('optimize_issue_type_scheme_page', (0, $kWXll.OptimizeWorkTypeSchemePage), (0, $5lsNZ.default)),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        canTransitionIn: ()=>(0, $4R6GH.fg)('optimize_issue_type_scheme_page'),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kWXll.LazyOptimizeWorkTypeSchemePagePage)
        ]
    }));

});
parcelRegister("hRCOF", function(module, exports) {

$parcel$export(module.exports, "globalSettingsOptimizeWorkTypeSchemeRoute", () => $7ac34df36e8a0c4b$export$c0e227e20c671f81);
const $7ac34df36e8a0c4b$export$c0e227e20c671f81 = {
    name: 'global-settings-optimize-work-type-scheme-view',
    path: '/jira/settings/issues/issue-type-schemes/:workTypeSchemeId/optimize'
};

});

parcelRegister("kWXll", function(module, exports) {

$parcel$export(module.exports, "LazyOptimizeWorkTypeSchemePagePage", () => $8e37869c3b270f55$export$267fd3967a05d273);
$parcel$export(module.exports, "OptimizeWorkTypeSchemePage", () => $8e37869c3b270f55$export$ba894e00aa169b3b);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $8e37869c3b270f55$export$267fd3967a05d273 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hNmmc"))), {
    ssr: false,
    moduleId: "./src/packages/site-optimizer/optimize-work-type-scheme-page/src/index.tsx"
});
const $8e37869c3b270f55$export$ba894e00aa169b3b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8e37869c3b270f55$export$267fd3967a05d273,
        pageId: "jira-admin-pages-optimize-work-type-scheme-page",
        shouldShowSpinner: true
    });

});
parcelRegister("hNmmc", function(module, exports) {

let $cf485aee5b8d7b8b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cf485aee5b8d7b8b$var$load("jZswI").then(()=>parcelRequire('gIjWg'));

});



parcelRegister("ktEDA", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceCustomFieldRouteEntry", () => $082dced0cf5c2e43$export$8cc68908e4ed5a16);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $b51sv = parcelRequire("b51sv");

var $6kCEi = parcelRequire("6kCEi");
const $082dced0cf5c2e43$export$8cc68908e4ed5a16 = (0, $7NszV.createEntry)((0, $b51sv.globalSettingsPerformanceCustomFieldRoute), ()=>({
        group: 'global-settings',
        component: (0, $6kCEi.CustomFieldMetricDetail),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6kCEi.LazyCustomFieldDetail)
        ]
    }));

});
parcelRegister("b51sv", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceCustomFieldRoute", () => $43a348db022c66e4$export$198b0dea5bcb104d);
const $43a348db022c66e4$export$198b0dea5bcb104d = {
    name: 'global-settings-performance-custom-field',
    path: '/jira/settings/system/performance/metrics/customfield'
};

});

parcelRegister("6kCEi", function(module, exports) {

$parcel$export(module.exports, "LazyCustomFieldDetail", () => $416b07e85e5902e2$export$d323aa888b5be0c2);
$parcel$export(module.exports, "CustomFieldMetricDetail", () => $416b07e85e5902e2$export$446bf9be075b3cb);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $416b07e85e5902e2$export$d323aa888b5be0c2 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("ipUdf"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-custom-field/src/index.tsx"
});
const $416b07e85e5902e2$export$446bf9be075b3cb = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $416b07e85e5902e2$export$d323aa888b5be0c2,
        pageId: "system-performance-metric-detail-custom-field",
        shouldShowSpinner: true
    });

});
parcelRegister("ipUdf", function(module, exports) {

let $d6862a761c67ec00$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d6862a761c67ec00$var$load("ffQaD"),
    $d6862a761c67ec00$var$load("kvRbA"),
    $d6862a761c67ec00$var$load("76n7a"),
    $d6862a761c67ec00$var$load("l253H"),
    $d6862a761c67ec00$var$load("fliVL"),
    $d6862a761c67ec00$var$load("dVhXY")
]).then(()=>parcelRequire('PZuxA'));

});



parcelRegister("caoz4", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceIssueArchivalRouteEntry", () => $bf0d17e8163c3686$export$6f8a930d1f2f4103);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $46SKm = parcelRequire("46SKm");

var $2vX6Y = parcelRequire("2vX6Y");
const $bf0d17e8163c3686$export$6f8a930d1f2f4103 = (0, $7NszV.createEntry)((0, $46SKm.globalSettingsPerformanceIssueArchivalRoute), ()=>({
        group: 'global-settings',
        component: (0, $2vX6Y.IssueMetricDetail),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $2vX6Y.LazyIssueDetail)
        ]
    }));

});
parcelRegister("46SKm", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceIssueArchivalRoute", () => $cad08cbdd7ac177a$export$a615b79ae9fb06e5);
const $cad08cbdd7ac177a$export$a615b79ae9fb06e5 = {
    name: 'global-settings-performance-issue',
    path: '/jira/settings/system/performance/metrics/issue'
};

});

parcelRegister("2vX6Y", function(module, exports) {

$parcel$export(module.exports, "LazyIssueDetail", () => $cc878f5a65037830$export$e44cbefb7c57e031);
$parcel$export(module.exports, "IssueMetricDetail", () => $cc878f5a65037830$export$30b22d5292fcd86f);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $cc878f5a65037830$export$e44cbefb7c57e031 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("9iDKV"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-issue/src/index.tsx"
});
const $cc878f5a65037830$export$30b22d5292fcd86f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cc878f5a65037830$export$e44cbefb7c57e031,
        pageId: "system-performance-metric-detail-issue",
        shouldShowSpinner: true
    });

});
parcelRegister("9iDKV", function(module, exports) {

let $6c54a232408bd9ca$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6c54a232408bd9ca$var$load("ffQaD"),
    $6c54a232408bd9ca$var$load("kvRbA"),
    $6c54a232408bd9ca$var$load("76n7a"),
    $6c54a232408bd9ca$var$load("l253H"),
    $6c54a232408bd9ca$var$load("fliVL"),
    $6c54a232408bd9ca$var$load("gMbKk")
]).then(()=>parcelRequire('9HctW'));

});



parcelRegister("5BlCA", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceMetricDetailRouteEntry", () => $233fa7d3de1e95a8$export$4b547a5bd165bd83);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $vq7VV = parcelRequire("vq7VV");

var $gq1Xn = parcelRequire("gq1Xn");
const $233fa7d3de1e95a8$export$4b547a5bd165bd83 = (0, $7NszV.createEntry)((0, $vq7VV.globalSettingsPerformanceMetricDetailRoute), ()=>({
        group: 'global-settings',
        component: (0, $gq1Xn.RedirectToExactMetricRoutes),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("vq7VV", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceMetricDetailRoute", () => $cd34eae2613f8100$export$d4f7a24791f8b506);
const $cd34eae2613f8100$export$d4f7a24791f8b506 = {
    name: 'global-settings-performance-metric-detail',
    path: '/jira/settings/system/performance/metric/:metricKey'
};

});

parcelRegister("gq1Xn", function(module, exports) {

$parcel$export(module.exports, "RedirectToExactMetricRoutes", () => $a9257ec476fbe8e1$export$dda90f06f8afe9ec);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $8zOmE = parcelRequire("8zOmE");

var $ds5qV = parcelRequire("ds5qV");

var $doZTA = parcelRequire("doZTA");
const $a9257ec476fbe8e1$export$dda90f06f8afe9ec = ()=>{
    const [{ match: match }] = (0, $doZTA.useRouter)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        // If we have a metric key in the URL, we know the user has accessed the old route
        // and we should fire an operational analytics event.
        // Once the frequency of this event is 0, we can consider removing the redirect.
        if (match?.params?.metricKey) (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'old-metric-detail-route visited', {
            metricKey: match.params.metricKey
        });
    }, [
        match?.params?.metricKey,
        createAnalyticsEvent
    ]);
    if (match == null || match.params == null || match.params.metricKey == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: "/jira/settings/system/performance/overview"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: `/jira/settings/system/performance/metrics/${match.params.metricKey}`
    });
};

});


parcelRegister("3Hflx", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceOverviewRouteEntry", () => $13d7b69aa99de9b5$export$6f957aade53e2c17);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $clE6J = parcelRequire("clE6J");

var $btX5r = parcelRequire("btX5r");

var $408O8 = parcelRequire("408O8");
const $13d7b69aa99de9b5$export$6f957aade53e2c17 = (0, $7NszV.createEntry)((0, $btX5r.globalSettingsPerformanceOverviewRoute), ()=>({
        group: 'global-settings',
        component: (0, $408O8.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $clE6J.metricsOverviewPageResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $408O8.LazyOverview)
        ]
    }));

});
parcelRegister("clE6J", function(module, exports) {

$parcel$export(module.exports, "metricsOverviewPageResource", () => $624fad9c7a7951b4$export$ac0b4ef4ec4987ae);

var $4R6GH = parcelRequire("4R6GH");

var $ao2h1 = parcelRequire("ao2h1");

var $hOOQr = parcelRequire("hOOQr");
const $624fad9c7a7951b4$export$ac0b4ef4ec4987ae = (0, $ao2h1.createRelayResource)({
    type: 'ADMIN_PAGES_PERFORMANCE_OVERVIEW',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $hOOQr.default),
            variables: {
                cloudId: tenantContext.cloudId,
                schemaMigrationEnabled: (0, $4R6GH.fg)('site_optimiser_schema_migration')
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("hOOQr", function(module, exports) {

$parcel$export(module.exports, "default", () => $69a9f121a9ac63a8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<669304670c931d09af8646f09ee71460>>
 * @relayHash 3b0412c013eb910bffa938b54599e765
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 589c5cc207a17b7fcd72acde1a46f074a3ac0a2e82da10793f61efb4fb0a786e
const $69a9f121a9ac63a8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "schemaMigrationEnabled"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "key"
    }, v3 = {
        "kind": "ScalarField",
        "name": "currentValue"
    }, v4 = {
        "kind": "ScalarField",
        "name": "warningValue"
    }, v5 = {
        "kind": "ScalarField",
        "name": "thresholdValue"
    }, v6 = {
        "kind": "ScalarField",
        "name": "cleanupValue"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "main_adminPagesPerformance_Overview_Query",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "condition": "schemaMigrationEnabled",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v1 /*: any*/ ,
                                            "concreteType": "JiraResourceUsageMetricConnection",
                                            "kind": "LinkedField",
                                            "name": "resourceUsageMetrics",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "main_adminPagesPerformance_OverviewPage"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.resourceUsageMetrics"
                                    }
                                ]
                            },
                            {
                                "condition": "schemaMigrationEnabled",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v1 /*: any*/ ,
                                            "concreteType": "JiraResourceUsageMetricConnectionV2",
                                            "kind": "LinkedField",
                                            "name": "resourceUsageMetricsV2",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "main_adminPagesPerformance_OverviewPageV2"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.resourceUsageMetricsV2"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "main_adminPagesPerformance_Overview_Query",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "schemaMigrationEnabled",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraResourceUsageMetricConnection",
                                    "kind": "LinkedField",
                                    "name": "resourceUsageMetrics",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraResourceUsageMetric",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "schemaMigrationEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraResourceUsageMetricConnectionV2",
                                    "kind": "LinkedField",
                                    "name": "resourceUsageMetricsV2",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "589c5cc207a17b7fcd72acde1a46f074a3ac0a2e82da10793f61efb4fb0a786e",
            "metadata": {},
            "name": "main_adminPagesPerformance_Overview_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$69a9f121a9ac63a8$var$node.hash = "f41d000bf8612aeb0ad7a3bfa4b9b2cb";
var $69a9f121a9ac63a8$export$2e2bcd8739ae039 = $69a9f121a9ac63a8$var$node;

});


parcelRegister("btX5r", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceOverviewRoute", () => $895fc96119706708$export$677fc3a2086479d2);
const $895fc96119706708$export$677fc3a2086479d2 = {
    name: 'global-settings-performance-overview',
    path: '/jira/settings/system/performance/overview'
};

});

parcelRegister("408O8", function(module, exports) {

$parcel$export(module.exports, "LazyOverview", () => $53afac4f83d10b4d$export$17b4d4eaede5f445);
$parcel$export(module.exports, "default", () => $53afac4f83d10b4d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $53afac4f83d10b4d$export$17b4d4eaede5f445 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("8uOVv"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/performance/overview/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$53afac4f83d10b4d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $53afac4f83d10b4d$export$17b4d4eaede5f445,
        pageId: "system-performance-overview",
        shouldShowSpinner: true
    });

});
parcelRegister("8uOVv", function(module, exports) {

let $62f8a10319be2fb2$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $62f8a10319be2fb2$var$load("ffQaD"),
    $62f8a10319be2fb2$var$load("kvRbA"),
    $62f8a10319be2fb2$var$load("9Xdwe")
]).then(()=>parcelRequire('aJlr3'));

});



parcelRegister("bUOZo", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceProjectCleanupRouteEntry", () => $5db1194ddce6c383$export$7048705fd224d040);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $66tAT = parcelRequire("66tAT");

var $kxXsG = parcelRequire("kxXsG");
const $5db1194ddce6c383$export$7048705fd224d040 = (0, $7NszV.createEntry)((0, $66tAT.globalSettingsPerformanceProjectCleanupRoute), ()=>({
        group: 'global-settings',
        component: (0, $kxXsG.ProjectCleanupMetricDetail),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kxXsG.LazyProjectCleanupDetail)
        ]
    }));

});
parcelRegister("66tAT", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceProjectCleanupRoute", () => $2cfd8d591a3d3df9$export$c0d3487a9dc79ff3);
const $2cfd8d591a3d3df9$export$c0d3487a9dc79ff3 = {
    name: 'global-settings-performance-project-cleanup',
    path: '/jira/settings/system/performance/metrics/projectCleanup'
};

});

parcelRegister("kxXsG", function(module, exports) {

$parcel$export(module.exports, "LazyProjectCleanupDetail", () => $a4333be24d8fdde0$export$a02cb3bfa11d0dc0);
$parcel$export(module.exports, "ProjectCleanupMetricDetail", () => $a4333be24d8fdde0$export$2adb5abd6651c182);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $a4333be24d8fdde0$export$a02cb3bfa11d0dc0 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("iWx5k"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-project-cleanup/src/index.tsx"
});
const $a4333be24d8fdde0$export$2adb5abd6651c182 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $a4333be24d8fdde0$export$a02cb3bfa11d0dc0,
        pageId: "system-performance-metric-detail-project-cleanup",
        shouldShowSpinner: true
    });

});
parcelRegister("iWx5k", function(module, exports) {

let $dca74ebb7f99dc18$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $dca74ebb7f99dc18$var$load("ffQaD"),
    $dca74ebb7f99dc18$var$load("kvRbA"),
    $dca74ebb7f99dc18$var$load("76n7a"),
    $dca74ebb7f99dc18$var$load("l253H"),
    $dca74ebb7f99dc18$var$load("fliVL"),
    $dca74ebb7f99dc18$var$load("eBa2B")
]).then(()=>parcelRequire('fJoHG'));

});



parcelRegister("bC98V", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceProjectRoleActorRouteEntry", () => $b0ecc0767e5528eb$export$a37cab737d8b474a);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $lG365 = parcelRequire("lG365");

var $7BrHr = parcelRequire("7BrHr");
const $b0ecc0767e5528eb$export$a37cab737d8b474a = (0, $7NszV.createEntry)((0, $lG365.globalSettingsPerformanceProjectRoleActorRoute), ()=>({
        group: 'global-settings',
        component: (0, $7BrHr.ProjectRoleActorMetricDetail),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7BrHr.LazyProjectRoleActorDetail)
        ]
    }));

});
parcelRegister("lG365", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceProjectRoleActorRoute", () => $a0135d88210046c6$export$c81695f590e65a42);
const $a0135d88210046c6$export$c81695f590e65a42 = {
    name: 'global-settings-performance-project-role-actor',
    path: '/jira/settings/system/performance/metrics/projectroleactor'
};

});

parcelRegister("7BrHr", function(module, exports) {

$parcel$export(module.exports, "LazyProjectRoleActorDetail", () => $e00517ee35b4ce44$export$41ecfa31d3d81e1c);
$parcel$export(module.exports, "ProjectRoleActorMetricDetail", () => $e00517ee35b4ce44$export$3c58376b89706313);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $e00517ee35b4ce44$export$41ecfa31d3d81e1c = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("90DZG"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-project-role-actor/src/index.tsx"
});
const $e00517ee35b4ce44$export$3c58376b89706313 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e00517ee35b4ce44$export$41ecfa31d3d81e1c,
        pageId: "system-performance-metric-detail-project-role-actor",
        shouldShowSpinner: true
    });

});
parcelRegister("90DZG", function(module, exports) {

let $01b157469d23daa3$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $01b157469d23daa3$var$load("ffQaD"),
    $01b157469d23daa3$var$load("kvRbA"),
    $01b157469d23daa3$var$load("76n7a"),
    $01b157469d23daa3$var$load("l253H"),
    $01b157469d23daa3$var$load("fliVL"),
    $01b157469d23daa3$var$load("6B7Dl")
]).then(()=>parcelRequire('eQgAh'));

});



parcelRegister("ew7DI", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPermissionSchemesRouteEntry", () => $1a723dff8ec4c1fb$export$85d07cd59d004b5b);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $bFrLw = parcelRequire("bFrLw");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $f7vTI = parcelRequire("f7vTI");

var $j8IEt = parcelRequire("j8IEt");
const $1a723dff8ec4c1fb$export$85d07cd59d004b5b = (0, $7NszV.createEntry)((0, $f7vTI.globalSettingsPermissionSchemesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.configure-permission-scheme',
        component: (0, $j8IEt.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $bFrLw.permissionSchemePageResource)
        ],
        canTransitionIn: ()=>true,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $j8IEt.LazyPermissionSchemePage)
        ],
        meta: {
            reporting: {
                id: 'PermissionScheme',
                packageName: 'jiraAdminPagesPermissionScheme',
                teamName: 'gordian'
            }
        }
    }));

});
parcelRegister("bFrLw", function(module, exports) {

$parcel$export(module.exports, "permissionSchemePageResource", () => $b39d37deff00f918$export$58d9013f694fc9d0);

var $ao2h1 = parcelRequire("ao2h1");

var $kf7Zr = parcelRequire("kf7Zr");
const $b39d37deff00f918$var$RESOURCE_TYPE_PERMISSION_SCHEME_PAGE = 'PERMISSION_SCHEME_PAGE';
const $b39d37deff00f918$export$58d9013f694fc9d0 = (0, $ao2h1.createRelayResource)({
    type: $b39d37deff00f918$var$RESOURCE_TYPE_PERMISSION_SCHEME_PAGE,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $kf7Zr.default),
            variables: {
                // To Do: use ari-typescript library once it is approved
                // https://hello.atlassian.net/wiki/spaces/TGR/pages/1374189554/Dependency+review+atlassian+ari
                schemeId: `ari:cloud:jira:${tenantContext.cloudId}:permission-scheme/activation/${tenantContext.activationId}/${String(match.params.schemeId)}`
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("kf7Zr", function(module, exports) {

$parcel$export(module.exports, "default", () => $667e2dd268ebb83a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bf59478679f84bf44b49fd41a2544ee4>>
 * @relayHash 0250f6408e8d8064d7cc97a77e2f5386
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5642572e212db64091380e916543cde0402cdfaa01db716befcdd494efd5feb
const $667e2dd268ebb83a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "schemeId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "schemeId",
            "variableName": "schemeId"
        }
    ], v2 = {
        "concreteType": "JiraPermissionSchemeConfiguration",
        "kind": "LinkedField",
        "name": "configuration",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            }
        ]
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "description"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "key"
    }, v8 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        v6 /*: any*/ 
    ], v9 = [
        v4 /*: any*/ ,
        v6 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v1 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "viewPermissionScheme",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "header_permissionScheme"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "PermissionsTable"
                                            },
                                            v2 /*: any*/ 
                                        ],
                                        "type": "JiraPermissionSchemeView"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.viewPermissionScheme"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "viewPermissionScheme",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraPermissionScheme",
                                            "kind": "LinkedField",
                                            "name": "scheme",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraPermissionSchemeGrantGroup",
                                            "kind": "LinkedField",
                                            "name": "grantGroups",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProjectPermissionCategory",
                                                    "kind": "LinkedField",
                                                    "name": "category",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraPermissionGrantHolder",
                                                    "kind": "LinkedField",
                                                    "name": "grantHolders",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraProjectPermission",
                                                            "kind": "LinkedField",
                                                            "name": "permission",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraPermissionGrants",
                                                            "kind": "LinkedField",
                                                            "name": "grants",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraGrantTypeKey",
                                                                    "kind": "LinkedField",
                                                                    "name": "grantType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        v4 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraPermissionGrantValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "grantValues",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "value",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v3 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        v4 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraDefaultGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "user",
                                                                                            "plural": false,
                                                                                            "selections": v8 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraUserGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraGroup",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "group",
                                                                                            "plural": false,
                                                                                            "selections": v9 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraGroupGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "field",
                                                                                            "plural": false,
                                                                                            "selections": v8 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueFieldGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraRole",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "role",
                                                                                            "plural": false,
                                                                                            "selections": v9 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraProjectRoleGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ 
                                                                                    ],
                                                                                    "type": "Node",
                                                                                    "abstractKey": "__isNode"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v6 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v2 /*: any*/ 
                                    ],
                                    "type": "JiraPermissionSchemeView"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b5642572e212db64091380e916543cde0402cdfaa01db716befcdd494efd5feb",
            "metadata": {},
            "name": "mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$667e2dd268ebb83a$var$node.hash = "41dd09a71a35c8ed416631b02fa73316";
var $667e2dd268ebb83a$export$2e2bcd8739ae039 = $667e2dd268ebb83a$var$node;

});


parcelRegister("f7vTI", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPermissionSchemesRoute", () => $1ed22cbad427b1e6$export$ceade8e040291782);
const $1ed22cbad427b1e6$export$ceade8e040291782 = {
    name: 'global-settings-permissions-schemes',
    path: '/jira/settings/issues/permission-schemes-new/:schemeId'
};

});

parcelRegister("j8IEt", function(module, exports) {

$parcel$export(module.exports, "LazyPermissionSchemePage", () => $d6d274858940e39c$export$f7fcf8304eb17dda);
$parcel$export(module.exports, "default", () => $d6d274858940e39c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $d6d274858940e39c$export$f7fcf8304eb17dda = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("eVLwI"))), {
    moduleId: "./src/packages/permissions-administration/pages/permission-scheme/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d6d274858940e39c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d6d274858940e39c$export$f7fcf8304eb17dda,
        pageId: "jira-permission-scheme",
        shouldShowSpinner: true
    });

});
parcelRegister("eVLwI", function(module, exports) {

let $adeb416205235858$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $adeb416205235858$var$load("ffQaD"),
    $adeb416205235858$var$load("kvRbA"),
    $adeb416205235858$var$load("gqVlZ")
]).then(()=>parcelRequire('cHxvv'));

});



parcelRegister("dTwSZ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemBulkMailRouteEntry", () => $afbfb00c133db3e2$export$f1e14d1857713e35);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $d8FBC = parcelRequire("d8FBC");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $gRmqY = parcelRequire("gRmqY");

var $5FGTk = parcelRequire("5FGTk");
const $afbfb00c133db3e2$export$f1e14d1857713e35 = (0, $7NszV.createEntry)((0, $gRmqY.globalSettingsSystemBulkMailRoute), ()=>({
        group: 'global-settings',
        component: (0, $5FGTk.default),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $d8FBC.SidebarGlobalSettingsSystem)
        },
        layout: (0, $ibkIl.globalSettingsLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5FGTk.LazyBulkEmail)
        ]
    }));

});
parcelRegister("d8FBC", function(module, exports) {

$parcel$export(module.exports, "SidebarGlobalSettingsSystem", () => $6ea6596802956a9d$export$52af3150b9f64726);

var $5uXOq = parcelRequire("5uXOq");

var $fobme = parcelRequire("fobme");

var $acDan = parcelRequire("acDan");

var $hcbSm = parcelRequire("hcbSm");
const $6ea6596802956a9d$export$52af3150b9f64726 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $acDan.SidebarRenderStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hcbSm.Menu), null), !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $acDan.SidebarReady), {
        id: (0, $fobme.SIDEBAR_ID).GLOBAL_SETTINGS_SYSTEM
    }));

});
parcelRegister("fobme", function(module, exports) {

$parcel$export(module.exports, "SIDEBAR_ID", () => $4b9be639c0c7f77b$export$adf978edbdfaf080);
const $4b9be639c0c7f77b$export$adf978edbdfaf080 = {
    CONNECT: 'CONNECT',
    CORE: 'CORE',
    FILTERS: 'FILTERS',
    FILTERS_GLOBAL: 'FILTERS_GLOBAL',
    FORGE_GLOBAL_PAGE: 'FORGE_GLOBAL_PAGE',
    GLOBAL_SETTINGS_APPS: 'GLOBAL_SETTINGS_APPS',
    GLOBAL_SETTINGS_ISSUES: 'GLOBAL_SETTINGS_ISSUES',
    GLOBAL_SETTINGS_PRODUCTS: 'GLOBAL_SETTINGS_PRODUCTS',
    GLOBAL_SETTINGS_PROJECTS: 'GLOBAL_SETTINGS_PROJECTS',
    GLOBAL_SETTINGS_SYSTEM: 'GLOBAL_SETTINGS_SYSTEM',
    JSM: 'JSM',
    JSW_CLASSIC: 'JSW_CLASSIC',
    JSW_NEXT_GEN: 'JSW_NEXT_GEN',
    PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
    EOC_OPERATIONS: 'EOC_OPERATIONS',
    POLARIS: 'POLARIS',
    USER: 'USER',
    HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS'
};

});

parcelRegister("hcbSm", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $e261d6c9e28d2ed4$export$d9b273488cd8ce6f);

var $5uXOq = parcelRequire("5uXOq");

var $g2EiV = parcelRequire("g2EiV");
var $9btdk = parcelRequire("9btdk");
var $gZEU1 = parcelRequire("gZEU1");
var $bWqXX = parcelRequire("bWqXX");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $3OGaE = parcelRequire("3OGaE");

var $juTur = parcelRequire("juTur");

var $17bH5 = parcelRequire("17bH5");

var $4OCke = parcelRequire("4OCke");

var $3tHFY = parcelRequire("3tHFY");

var $6jY6G = parcelRequire("6jY6G");

var $eaZ4X = parcelRequire("eaZ4X");

var $jMBA3 = parcelRequire("jMBA3");

var $aVTmi = parcelRequire("aVTmi");

var $cip1u = parcelRequire("cip1u");

var $8wyB3 = parcelRequire("8wyB3");

var $230Wm = parcelRequire("230Wm");

var $je2KE = parcelRequire("je2KE");

var $iAlf2 = parcelRequire("iAlf2");

var $fwlYA = parcelRequire("fwlYA");

var $9O5DC = parcelRequire("9O5DC");

var $1y2CG = parcelRequire("1y2CG");

var $71ORT = parcelRequire("71ORT");

var $3jrxv = parcelRequire("3jrxv");
const $e261d6c9e28d2ed4$var$calculateStack = (route)=>{
    const routeName = route && route.name;
    if ([
        'global-settings-performance-metric-detail',
        'global-settings-performance-overview',
        'global-settings-performance-project-cleanup',
        'global-settings-performance-project-role-actor',
        'global-settings-performance-custom-field',
        'global-settings-performance-issue'
    ].includes(routeName)) return [
        (0, $eaZ4X.SECTION_ID).PERFORMANCE_AND_SCALE
    ];
    return [];
};
const $e261d6c9e28d2ed4$export$d9b273488cd8ce6f = ()=>{
    const { data: features } = (0, $jMBA3.useFeatures)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const { data: connectItems } = (0, $jMBA3.useGlobalSettingsSystemConnectItems)();
    const [stack, setStack] = (0, $5uXOq.useState)($e261d6c9e28d2ed4$var$calculateStack(route));
    (0, $5uXOq.useEffect)(()=>{
        setStack($e261d6c9e28d2ed4$var$calculateStack(route));
    }, [
        route
    ]);
    const navigationPath = (0, $5uXOq.useMemo)(()=>(0, $17bH5.getSystemNavigationPaths)(), []);
    const generalConfigurationPath = navigationPath.generalConfiguration;
    if (features == null || connectItems == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    const navigationContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, features.hasGeneralConfiguration && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'general-configuration'
        },
        href: generalConfigurationPath,
        selectedOn: (0, $3jrxv.isGeneralConfigurationSelected)
    }, formatMessage((0, $iAlf2.default).generalConfiguration)), features.hasDarkFeatures && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'dark-features'
        },
        href: navigationPath.darkFeatures,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $iAlf2.default).darkFeatures)), features.hasTroubleshootingAndSupportSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1y2CG.TroubleshootingAndSupportSection), null), features.hasSecuritySection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fwlYA.SecuritySection), null), features.hasCollectors && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'collectors'
        },
        href: navigationPath.issueCollectors,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $iAlf2.default).issueCollectorsIssueTermRefresh : (0, $iAlf2.default).issueCollectors)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8wyB3.AutomationSection), null), features.hasUserInterfaceSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $71ORT.UserInterfaceSection), null), features.hasImportExportSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $230Wm.ImportExportSection), null), features.hasMailSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $je2KE.MailSection), null), features.hasAdminHelperSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aVTmi.AdminHelperSection), null), features.hasSharedSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9O5DC.SharedSection), null), features.hasAdvancedSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cip1u.AdvancedSection), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3tHFY.ConnectMenu), {
        items: connectItems,
        overrides: {
            BackMenuItem: {
                href: '/jira/settings/system/general-configuration',
                title: formatMessage((0, $iAlf2.default).systemGroup)
            }
        }
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juTur.ContextualAnalyticsData), {
        menuId: "global-settings/system",
        stack: stack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gZEU1.default), {
        label: formatMessage((0, $iAlf2.default).globalSettingsSystemSidebarLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g2EiV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OGaE.TitleHeader), null, formatMessage((0, $iAlf2.default).systemGroup))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9btdk.default), {
        stack: stack,
        onChange: setStack
    }, navigationContent)));
};

});
parcelRegister("g2EiV", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8d4c6f37fa43791$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
const $f8d4c6f37fa43791$var$styles = {
    navigationFooter: "_1e0c1ule _85i5u2gc _1q511ejb _y4tiu2gc _bozgu2gc"
};
/**
 * __Navigation header__
 *
 * Allows for customisation of the header.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $f8d4c6f37fa43791$var$NavigationHeader = (props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $f8d4c6f37fa43791$var$styles.navigationFooter,
        "data-navheader": true,
        children: children
    });
};
var $f8d4c6f37fa43791$export$2e2bcd8739ae039 = $f8d4c6f37fa43791$var$NavigationHeader;

});

parcelRegister("9btdk", function(module, exports) {

$parcel$export(module.exports, "ROOT_ID", () => $1598986e4d07c239$export$ec71a3379b43ae5c);
$parcel$export(module.exports, "default", () => $1598986e4d07c239$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $35XSW = parcelRequire("35XSW");

var $VSDnB = parcelRequire("VSDnB");

var $6XySk = parcelRequire("6XySk");

var $8UO8z = parcelRequire("8UO8z");

var $9zCCP = parcelRequire("9zCCP");

var $j9VTE = parcelRequire("j9VTE");

var $cfT4M = parcelRequire("cfT4M");
const $1598986e4d07c239$export$ec71a3379b43ae5c = 'ATLASKIT_NESTED_ROOT';
const $1598986e4d07c239$var$nestableNavigationContentStyles = null;
const $1598986e4d07c239$var$nestingRootStyles = null;
/**
 * __Nestable navigation content__
 *
 * The container for navigation items with nested views
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#nested-navigation)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $1598986e4d07c239$var$NestableNavigationContent = (props)=>{
    const containerRef = (0, $5uXOq.useRef)(null);
    const { children: children, testId: testId, overrides: overrides, initialStack: initialStack, onChange: onChange, onUnknownNest: onUnknownNest, stack: stack, showTopScrollIndicator: showTopScrollIndicator, isDefaultFocusControl: isDefaultFocusControl = true } = props;
    const goBackButtonRef = (0, $5uXOq.useRef)(null);
    const [committedStack, setCommittedStack] = (0, $5uXOq.useState)(stack || initialStack || []);
    const controlledStack = stack || undefined;
    const currentStackId = committedStack[committedStack.length - 1] || $1598986e4d07c239$export$ec71a3379b43ae5c;
    const [transition, setTransition] = (0, $5uXOq.useState)('nesting');
    const backTestId = testId && `${testId}--go-back-item`;
    const [activeParentId, setActiveParentId] = (0, $5uXOq.useState)('');
    const [focusGoBackButton, setFocusGoBackButton] = (0, $5uXOq.useState)(false);
    const shouldFocus = isDefaultFocusControl && (0, $VSDnB.fg)('platform-side-navigation-keyboard-focus');
    const renderGoBackItem = overrides && overrides.GoBackItem && overrides.GoBackItem.render ? overrides.GoBackItem.render : (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $6XySk.default), {
            ...props,
            children: "Go back"
        });
    const { childIdsRef: childIdsRef } = (0, $9zCCP.useChildIds)(currentStackId, committedStack, onUnknownNest);
    const onNestHandler = (0, $5uXOq.useCallback)((layerId)=>{
        onChange && onChange(committedStack.concat(layerId));
        setFocusGoBackButton(true);
        if (controlledStack) // We are in controlled mode - ignore the steps.
        return;
        // We need to split the state update into to parts.
        // First: Updating the direction of the motions.
        // Second: Actually updating the stack (which will cause elements to enter & leave).
        setTransition('nesting');
        requestAnimationFrame(()=>{
            setCommittedStack((prev)=>{
                const newStack = prev.concat(layerId);
                return newStack;
            });
        });
    }, [
        controlledStack,
        onChange,
        committedStack
    ]);
    const onUnNestHandler = (0, $5uXOq.useCallback)(()=>{
        onChange && onChange(committedStack.slice(0, committedStack.length - 1));
        setActiveParentId(currentStackId);
        setFocusGoBackButton(false);
        if (controlledStack) // We are in controlled mode - ignore the steps.
        return;
        // We need to split the state update into to parts.
        // First: Updating the direction of the motions.
        // Second: Actually updating the stack (which will cause elements to enter & leave).
        setTransition('unnesting');
        requestAnimationFrame(()=>{
            setCommittedStack((prev)=>{
                const newStack = prev.slice(0, prev.length - 1);
                return newStack;
            });
        });
    }, [
        controlledStack,
        onChange,
        committedStack,
        setActiveParentId,
        currentStackId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!controlledStack) // We aren't in controlled mode - bail out.
        return;
        if (JSON.stringify(committedStack) === JSON.stringify(controlledStack)) // stacks are equal - do nothing!
        return;
        // Controlled prop updated, let's figure out if we're nesting or unnesting.
        if (controlledStack.length < committedStack.length) // We are unnesting (removing from the stack)
        setTransition('unnesting');
        else // We are nesting (adding to the stack)
        setTransition('nesting');
        requestAnimationFrame(()=>{
            setCommittedStack(controlledStack);
        });
    }, [
        committedStack,
        controlledStack
    ]);
    const backButton = renderGoBackItem({
        onClick: onUnNestHandler,
        testId: backTestId,
        ref: shouldFocus ? goBackButtonRef : null
    });
    const context = (0, $5uXOq.useMemo)(()=>({
            currentStackId: currentStackId,
            backButton: backButton,
            stack: committedStack,
            onNest: onNestHandler,
            onUnNest: onUnNestHandler,
            parentId: $1598986e4d07c239$export$ec71a3379b43ae5c,
            childIds: childIdsRef,
            forceShowTopScrollIndicator: showTopScrollIndicator,
            activeParentId: activeParentId,
            goBackButtonRef: goBackButtonRef,
            isDefaultFocusControl: isDefaultFocusControl,
            focusGoBackButton: focusGoBackButton
        }), [
        currentStackId,
        backButton,
        committedStack,
        onNestHandler,
        onUnNestHandler,
        childIdsRef,
        showTopScrollIndicator,
        activeParentId,
        goBackButtonRef,
        isDefaultFocusControl,
        focusGoBackButton
    ]);
    const manageFocus = (event)=>{
        const triggeredByKeyboard = event.nativeEvent.detail === 0;
        if (triggeredByKeyboard) containerRef.current && containerRef.current.focus();
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-testid": testId,
            ref: containerRef,
            tabIndex: -1,
            onClick: manageFocus,
            className: (0, $bwpsq.default)([
                "_12ji1r31 _1qu2glyw _12y31o36 _4t3i1osq _kqswh2mm"
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $35XSW.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cfT4M.NestingMotion), {
                    enterFrom: transition === 'nesting' ? 'right' : 'left',
                    exitTo: transition === 'nesting' ? 'left' : 'right',
                    testId: testId && `${testId}-anim`,
                    children: (motion)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            ...motion,
                            className: (0, $bwpsq.default)([
                                "_1e0c1txw _1bsb1osq _4t3i1osq _kqswstnw _2lx21bp4",
                                motion.className
                            ]),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j9VTE.NestedContext).Provider, {
                                // This provider is inside the NestingMotion to ensure it keeps a stale
                                // reference to the previous value.
                                value: context,
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8UO8z.default), {
                                    title: "",
                                    id: $1598986e4d07c239$export$ec71a3379b43ae5c,
                                    children: children
                                })
                            })
                        })
                }, currentStackId)
            })
        })
    });
};
var $1598986e4d07c239$export$2e2bcd8739ae039 = $1598986e4d07c239$var$NestableNavigationContent;

});
parcelRegister("6XySk", function(module, exports) {

$parcel$export(module.exports, "default", () => $acf862f964b3fe45$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $d2gYe = parcelRequire("d2gYe");


var $ayWDM = parcelRequire("ayWDM");
/**
 * __Go back item__
 *
 * A go back item is used to provide a customized "go back" button in nested
 * navigations.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#go-back-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $acf862f964b3fe45$var$GoBackItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ className: className, iconBefore: iconBefore = /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d2gYe))), {
    color: "currentColor",
    LEGACY_secondaryColor: `var(--ds-surface, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
    label: ""
}), onClick: onClick, isSelected: isSelected, ...rest }, ref)=>{
    const [isInteracted, setIsInteracted] = (0, $5uXOq.useState)(false);
    const onClickHandler = (0, $5uXOq.useCallback)((e)=>{
        if (isInteracted) return;
        setIsInteracted(true);
        onClick && onClick(e);
    }, [
        onClick,
        isInteracted
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ayWDM.default), {
        isSelected: isSelected,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        iconBefore: iconBefore,
        onClick: onClickHandler,
        ref: ref,
        ...rest
    });
});
var $acf862f964b3fe45$export$2e2bcd8739ae039 = $acf862f964b3fe45$var$GoBackItem;

});
parcelRegister("d2gYe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::19a10e1149a5b84d93e6a05c6f1be0d9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $97d8a03a9ac2bd8e$var$_react = $97d8a03a9ac2bd8e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $97d8a03a9ac2bd8e$var$_arrowLeft = $97d8a03a9ac2bd8e$var$_interopRequireDefault((parcelRequire("ctqwA")));

var $97d8a03a9ac2bd8e$var$_arrowLeftCircle = $97d8a03a9ac2bd8e$var$_interopRequireDefault((parcelRequire("g9uZe")));
function $97d8a03a9ac2bd8e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowLeftIcon.
 * This component is ArrowLeftIcon, with `UNSAFE_fallbackIcon` set to "ArrowLeftCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $97d8a03a9ac2bd8e$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $97d8a03a9ac2bd8e$var$_react.default.createElement($97d8a03a9ac2bd8e$var$_arrowLeft.default, Object.assign({
        LEGACY_fallbackIcon: $97d8a03a9ac2bd8e$var$_arrowLeftCircle.default
    }, props));
$97d8a03a9ac2bd8e$var$ArrowLeftIcon.Name = 'ArrowLeftIconMigration';
var $97d8a03a9ac2bd8e$var$_default = module.exports.default = $97d8a03a9ac2bd8e$var$ArrowLeftIcon;

});
parcelRegister("g9uZe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bc2585eb44f99538$var$_react = $bc2585eb44f99538$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $bc2585eb44f99538$var$_arrowLeft = $bc2585eb44f99538$var$_interopRequireDefault((parcelRequire("ctqwA")));
function $bc2585eb44f99538$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bc2585eb44f99538$var$ArrowLeftCircleIcon = (props)=>/*#__PURE__*/ $bc2585eb44f99538$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M16 10.995h-5.586l1.272-1.279a1.01 1.01 0 0 0 0-1.421.996.996 0 0 0-1.415 0l-2.978 2.994a1.01 1.01 0 0 0 0 1.423l2.978 2.993a1 1 0 0 0 1.415 0 1.01 1.01 0 0 0 0-1.421l-1.272-1.279H16c.552 0 1-.45 1-1.005s-.448-1.005-1-1.005"/></svg>`
    }, props, {
        newIcon: $bc2585eb44f99538$var$_arrowLeft.default
    }));
$bc2585eb44f99538$var$ArrowLeftCircleIcon.displayName = 'ArrowLeftCircleIcon';
var $bc2585eb44f99538$var$_default = module.exports.default = $bc2585eb44f99538$var$ArrowLeftCircleIcon;

});


parcelRegister("ayWDM", function(module, exports) {

$parcel$export(module.exports, "default", () => $860cc941614c9e62$export$2e2bcd8739ae039);
/* button-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kJpBP = parcelRequire("kJpBP");

var $j9VTE = parcelRequire("j9VTE");
const $860cc941614c9e62$var$styles = {
    root: "_2rko1sit _1rjcu2gc _18zru2gc _bfhk1w7a _1a391k8s _racp1k8s _30l3jjyb _irr314ae _ppn2dud1 _183j1l7b",
    selectedStyles: "_bfhkbal5 _syaz1ldt _10531ldt _irr31gf2 _30l31pwi _1di61elt _9h8h1ldt"
};
/**
 * __Button item__
 *
 * A button item renders an item wrapped in a button tag, used primarily when an
 * action does something other than changing routes.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#button-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $860cc941614c9e62$var$ButtonItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(// Type needed on props to extract types with extract react types.
({ className: className, ...props }, ref)=>{
    const { shouldRender: shouldRender } = (0, $j9VTE.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kJpBP.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $860cc941614c9e62$var$styles.root,
            props.isSelected && $860cc941614c9e62$var$styles.selectedStyles,
            className
        ]),
        ...props
    });
});
var $860cc941614c9e62$export$2e2bcd8739ae039 = $860cc941614c9e62$var$ButtonItem;

});


parcelRegister("8UO8z", function(module, exports) {

$parcel$export(module.exports, "default", () => $0599b2a9b08db47e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $bh9nY = parcelRequire("bh9nY");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");


var $ayWDM = parcelRequire("ayWDM");
var $jSfqD = parcelRequire("jSfqD");
var $kzjuk = parcelRequire("kzjuk");

var $9btdk = parcelRequire("9btdk");

var $j9VTE = parcelRequire("j9VTE");

var $9zCCP = parcelRequire("9zCCP");
const $0599b2a9b08db47e$var$styles = {
    iconContainer: "_1e0c1nu9",
    nestingItem: "_udl3glyw _kqsfglyw _udrwglyw _13qvglyw _9mqr1kw7 _povs1kw7 _uv2d1kw7 _atks1kw7",
    nestingItemDisabled: "_1c06idpf _udl3glyw"
};
/**
 * NestingItem will render itself differently depending in what context it is rendered in.
 * When not open - it will render itself as an item.
 * When open - it will render its children.
 */ const $0599b2a9b08db47e$var$NestingItem = (props)=>{
    const { children: children, iconAfter: iconAfter, title: title, onClick: onClick, className: className, isDisabled: isDisabled, isSelected: isSelected, id: id, component: component, testId: testId, ...rest } = props;
    const { currentStackId: currentStackId, onNest: onNest, onUnNest: onUnNest, backButton: contextualBackButton, stack: stack, childIds: childIds, forceShowTopScrollIndicator: forceShowTopScrollIndicator, activeParentId: activeParentId, goBackButtonRef: goBackButtonRef, isDefaultFocusControl: isDefaultFocusControl, focusGoBackButton: focusGoBackButton } = (0, $j9VTE.useNestedContext)();
    const [isInteracted, setIsInteracted] = (0, $5uXOq.useState)(false);
    const parentItemRef = (0, $5uXOq.useRef)(null);
    // To avoid error we need to make sure that the component is wrapped in ForwardRef
    const isForwardRefCheck = (component)=>{
        if (component?.prototype?.isReactComponent) return false;
        return component?.$$typeof === Symbol.for('react.forward_ref');
    };
    const shouldFocus = isDefaultFocusControl && (0, $VSDnB.fg)('platform-side-navigation-keyboard-focus');
    const backButtonRef = shouldFocus ? goBackButtonRef : null;
    const activeParentRef = shouldFocus ? parentItemRef : null;
    (0, $5uXOq.useEffect)(()=>{
        if (shouldFocus) {
            if (activeParentId === id) parentItemRef?.current?.focus();
            if (focusGoBackButton) goBackButtonRef?.current?.focus();
        }
    }, [
        activeParentId,
        id,
        goBackButtonRef,
        focusGoBackButton,
        isDefaultFocusControl,
        shouldFocus
    ]);
    const backButton = props.overrides && props.overrides.GoBackItem && props.overrides.GoBackItem.render && props.overrides.GoBackItem.render({
        onClick: onUnNest,
        testId: testId && `${testId}--go-back-item`,
        ref: backButtonRef
    }) || contextualBackButton;
    const context = (0, $5uXOq.useMemo)(()=>({
            stack: stack,
            currentStackId: currentStackId,
            onNest: onNest,
            onUnNest: onUnNest,
            backButton: backButton,
            parentId: id,
            childIds: childIds,
            forceShowTopScrollIndicator: forceShowTopScrollIndicator,
            activeParentId: activeParentId,
            goBackButtonRef: goBackButtonRef,
            isDefaultFocusControl: isDefaultFocusControl,
            focusGoBackButton: focusGoBackButton
        }), [
        stack,
        currentStackId,
        onNest,
        onUnNest,
        backButton,
        id,
        childIds,
        forceShowTopScrollIndicator,
        activeParentId,
        goBackButtonRef,
        isDefaultFocusControl,
        focusGoBackButton
    ]);
    (0, $9zCCP.useChildIdsEffect)(childIds, id);
    const isNormalClick = (e)=>!(e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
    /**
   * We want both the on nest handler and the onclick handler to be called.
   * We create a wrapper function to call both.
   */ const onClickHandler = (0, $5uXOq.useCallback)((e)=>{
        if (isInteracted) // We return early if this has been interacted with because its assumed
        // this will be already exiting - so we don't want to double up the click.
        return;
        // Avoid a nesting transition if a modifier key is detected during click.
        // @ts-expect-error - Argument of type 'MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>' is not assignable to parameter of type 'MouseEvent'
        if (isNormalClick(e)) {
            setIsInteracted(true);
            onNest(id);
        }
        onClick && onClick(e);
    }, [
        isInteracted,
        onClick,
        onNest,
        id
    ]);
    if (currentStackId === id) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $j9VTE.NestedContext).Provider, {
        value: context,
        children: [
            stack.length >= 1 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                paddingBlock: "space.075",
                paddingInline: "space.100",
                children: backButton
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kzjuk.default), {
                testId: testId,
                showTopScrollIndicator: forceShowTopScrollIndicator || stack.length >= 1,
                children: children
            })
        ]
    });
    if ([
        (0, $9btdk.ROOT_ID),
        ...stack
    ].includes(id)) return children;
    const componentProps = {
        iconAfter: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
            children: [
                iconAfter ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    xcss: $0599b2a9b08db47e$var$styles.iconContainer,
                    "data-custom-icon": true,
                    as: "span",
                    children: iconAfter
                }) : null,
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    "data-right-arrow": true,
                    xcss: $0599b2a9b08db47e$var$styles.iconContainer,
                    as: "span",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bh9nY))), {
                        testId: testId && `${testId}--item--right-arrow`,
                        color: "currentColor",
                        LEGACY_secondaryColor: `var(--ds-surface, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
                        label: ""
                    })
                })
            ]
        }),
        onClick: onClickHandler,
        isSelected: isSelected,
        isDisabled: isDisabled,
        testId: testId && `${testId}--item`,
        ...rest,
        children: title
    };
    if (component) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jSfqD.default), {
        ref: isForwardRefCheck(component) ? parentItemRef : null,
        ...componentProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $0599b2a9b08db47e$var$styles.nestingItem,
            isDisabled && $0599b2a9b08db47e$var$styles.nestingItemDisabled,
            className
        ]),
        //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
        component: component
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ayWDM.default), {
        ref: activeParentRef,
        ...componentProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $0599b2a9b08db47e$var$styles.nestingItem,
            isDisabled && $0599b2a9b08db47e$var$styles.nestingItemDisabled,
            className
        ])
    });
};
var $0599b2a9b08db47e$export$2e2bcd8739ae039 = $0599b2a9b08db47e$var$NestingItem;

});
parcelRegister("bh9nY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dbc8100b1314a43ce0868b8331a89007>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $835890081946c47e$var$_react = $835890081946c47e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $835890081946c47e$var$_arrowRight = $835890081946c47e$var$_interopRequireDefault((parcelRequire("h1TKi")));

var $835890081946c47e$var$_arrowRightCircle = $835890081946c47e$var$_interopRequireDefault((parcelRequire("1zw66")));
function $835890081946c47e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowRightIcon.
 * This component is ArrowRightIcon, with `UNSAFE_fallbackIcon` set to "ArrowRightCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $835890081946c47e$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $835890081946c47e$var$_react.default.createElement($835890081946c47e$var$_arrowRight.default, Object.assign({
        LEGACY_fallbackIcon: $835890081946c47e$var$_arrowRightCircle.default
    }, props));
$835890081946c47e$var$ArrowRightIcon.Name = 'ArrowRightIconMigration';
var $835890081946c47e$var$_default = module.exports.default = $835890081946c47e$var$ArrowRightIcon;

});
parcelRegister("h1TKi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11b8e18b02050eefbe32dafc654ee453>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c65dc59efb96b35a$var$_react = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c65dc59efb96b35a$var$_baseNew = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $c65dc59efb96b35a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c65dc59efb96b35a$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $c65dc59efb96b35a$var$_react.default.createElement($c65dc59efb96b35a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$c65dc59efb96b35a$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $c65dc59efb96b35a$var$_default = module.exports.default = $c65dc59efb96b35a$var$ArrowRightIcon;

});

parcelRegister("1zw66", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1251f532550be707$var$_react = $1251f532550be707$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $1251f532550be707$var$_arrowRight = $1251f532550be707$var$_interopRequireDefault((parcelRequire("h1TKi")));
function $1251f532550be707$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1251f532550be707$var$ArrowRightCircleIcon = (props)=>/*#__PURE__*/ $1251f532550be707$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor" fill-rule="nonzero"/><path fill="inherit" d="M12.314 8.294a1.01 1.01 0 0 0 0 1.422l1.271 1.279H8c-.553 0-1.001.45-1.001 1.005S7.447 13.005 8 13.005h5.585l-1.271 1.279a1.01 1.01 0 0 0 0 1.422 1 1 0 0 0 1.415 0l2.978-2.995a1.01 1.01 0 0 0 0-1.422l-2.978-2.995a1 1 0 0 0-1.415 0"/></g></svg>`
    }, props, {
        newIcon: $1251f532550be707$var$_arrowRight.default
    }));
$1251f532550be707$var$ArrowRightCircleIcon.displayName = 'ArrowRightCircleIcon';
var $1251f532550be707$var$_default = module.exports.default = $1251f532550be707$var$ArrowRightCircleIcon;

});


parcelRegister("jSfqD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e63733262ea805c$export$2e2bcd8739ae039);
/* custom-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1aogK = parcelRequire("1aogK");

var $j9VTE = parcelRequire("j9VTE");
const $0e63733262ea805c$var$styles = {
    root: "_2rko1sit _1rjcu2gc _18zru2gc _bfhk1w7a _1a391k8s _racp1k8s _30l3jjyb _irr314ae _ppn2dud1 _183j1l7b",
    selectedStyles: "_bfhkbal5 _syaz1ldt _10531ldt _irr31gf2 _30l31pwi _1di61elt _9h8h1ldt"
};
/**
 * Used to support any custom items needed by products alongside the Header and Footer patterns.
 * Specific implementation of headers and footers are provided in the examples folder.
 */ const $0e63733262ea805c$var$CustomItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(// Type needed on props to extract types with extract react types.
({ className: className, ...props }, ref)=>{
    const { shouldRender: shouldRender } = (0, $j9VTE.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1aogK.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $0e63733262ea805c$var$styles.root,
            props.isSelected && $0e63733262ea805c$var$styles.selectedStyles,
            className
        ]),
        ...props
    });
});
var $0e63733262ea805c$export$2e2bcd8739ae039 = $0e63733262ea805c$var$CustomItem;

});

parcelRegister("kzjuk", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfdf97ddffeccb81$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cw1vL = parcelRequire("cw1vL");

var $j9VTE = parcelRequire("j9VTE");
const $dfdf97ddffeccb81$var$outerContainerCSS = null;
const $dfdf97ddffeccb81$var$innerContainerCSS = {
    basic: "_1reo1wug _18m91wug _1e0c1txw _vchhusvi _1bsb1osq _kqswh2mm _2lx21bp4 _14mjgqwt _1ywu1ule _1qdgyh40 _18poh2mm _1bqqcs5v _tua5idpf _1hfk1q2g _aetrb3bt _3mxo1wug",
    topScrollIndicator: "_rfx3gqwt _cfu11ule _kfgtyh40 _1cs8stnw _1g0vcs5v _1rus1q2g _1kt9b3bt _1enwidpf _z5wtidpf"
};
const $dfdf97ddffeccb81$var$containerCSS = {
    basic: "_kqswh2mm _12l2u2gc _ahbqu2gc _1pfhidpf _1p3h12x7 _1l6bpxbi _auo4rdoj _hp2110yn",
    marginBlockStart: "_1pfhv77o"
};
/**
 * __Navigation content__
 *
 * A navigation content is used as the container for navigation items.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#content)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $dfdf97ddffeccb81$var$NavigationContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { showTopScrollIndicator: showTopScrollIndicator, children: children, testId: testId } = props;
    const { shouldRender: shouldRender } = (0, $j9VTE.useShouldNestedElementRender)();
    const scrollbar = (0, $cw1vL.default)();
    if (!shouldRender) return children;
    const typedRef = ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: typedRef,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _4t3i1osq _kqswh2mm _rfx3gqwt _cfu11ule _kfgtyh40 _1cs8stnw _1g0vkb7n _1rus1p09 _1kt9b3bt _1enwftgi _z5wtu2gc _14mjgqwt _1ywu1ule _1qdgyh40 _18postnw _1bqqkb7n _tua5idpf _1hfk1p09 _aetrb3bt _1gufidpf _1czdftgi _g0nfu2gc"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            ref: scrollbar.ref,
            className: (0, $bwpsq.default)([
                $dfdf97ddffeccb81$var$innerContainerCSS.basic,
                !showTopScrollIndicator && $dfdf97ddffeccb81$var$innerContainerCSS.topScrollIndicator
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    $dfdf97ddffeccb81$var$containerCSS.basic,
                    showTopScrollIndicator && $dfdf97ddffeccb81$var$containerCSS.marginBlockStart
                ]),
                children: children
            })
        })
    });
});
var $dfdf97ddffeccb81$export$2e2bcd8739ae039 = $dfdf97ddffeccb81$var$NavigationContent;

});
parcelRegister("cw1vL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a03f8a420074f68d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $a03f8a420074f68d$export$2e2bcd8739ae039() {
    const [scrollbarWidth, setScrollbarWidth] = (0, $5uXOq.useState)(0);
    const elementRef = (0, $5uXOq.useRef)(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $5uXOq.useEffect)(()=>{
        if (!elementRef.current) return;
        const width = elementRef.current.offsetWidth - elementRef.current.scrollWidth;
        if (width === scrollbarWidth) return;
        setScrollbarWidth(width);
    });
    return {
        width: scrollbarWidth,
        ref: elementRef
    };
}

});


parcelRegister("9zCCP", function(module, exports) {

$parcel$export(module.exports, "useChildIds", () => $edc749a9b64f215e$export$61b3ef4f009a9474);
$parcel$export(module.exports, "useChildIdsEffect", () => $edc749a9b64f215e$export$ea18c2b5f0e24612);

var $5uXOq = parcelRequire("5uXOq");

var $9btdk = parcelRequire("9btdk");
const $edc749a9b64f215e$export$61b3ef4f009a9474 = (currentStackId, committedStack, onUnknownNest)=>{
    const childIdsRef = (0, $5uXOq.useRef)(new Set());
    (0, $5uXOq.useEffect)(()=>{
        // we are holding navigation item IDs in childIdsRef
        // check if the current displayed nav item (currentStackId) is in childIdsRef. if it's not, this means it's undefined
        if (currentStackId === (0, $9btdk.ROOT_ID) || !childIdsRef.current.size || childIdsRef.current.has(currentStackId) || !onUnknownNest) return;
        onUnknownNest(committedStack || [
            currentStackId
        ]);
    }, [
        currentStackId,
        committedStack,
        onUnknownNest
    ]);
    return {
        childIdsRef: childIdsRef
    };
};
const $edc749a9b64f215e$export$ea18c2b5f0e24612 = (childIds, id)=>{
    (0, $5uXOq.useEffect)(()=>{
        if (!childIds || !childIds.current) return;
        if (!childIds.current.has(id)) childIds.current.add(id);
        return ()=>{
            // eslint-disable-next-line react-hooks/exhaustive-deps
            childIds.current.delete(id);
        };
    // childIds shouldn't change as it's a ref
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        id
    ]);
};

});


parcelRegister("cfT4M", function(module, exports) {

$parcel$export(module.exports, "NestingMotion", () => $0051a7791f96d83a$export$9e743a8c2a6b450e);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8Sbj3 = parcelRequire("8Sbj3");
const $0051a7791f96d83a$export$9e743a8c2a6b450e = (props)=>{
    const { children: children, enterFrom: enterFrom, exitTo: exitTo, testId: testId } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Sbj3.default), {
        exitTo: exitTo,
        enterFrom: enterFrom,
        animationTimingFunction: "ease-out",
        children: (innerProps, direction)=>children({
                'data-enter-from': enterFrom,
                'data-exit-to': exitTo,
                'data-testid': testId && `${testId}-${direction}`,
                ...innerProps
            })
    });
};

});


parcelRegister("gZEU1", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb2dd47d2fa741f7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $j7LBE = parcelRequire("j7LBE");
const $eb2dd47d2fa741f7$var$sidebarMinWidth = '240px';
const $eb2dd47d2fa741f7$var$sideNavStyles = null;
/**
 * __Side navigation__
 *
 * A highly composable side navigation component that supports nested views.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 * - [Usage](https://atlassian.design/components/side-navigation/usage)
 */ const $eb2dd47d2fa741f7$var$SideNavigation = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, label: label, isServer: isServer = false, isSSRPlaceholderEnabled: isSSRPlaceholderEnabled = false } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("nav", {
        ref: ref,
        "data-testid": testId,
        "aria-label": label,
        "data-vc": `side-navigation${isServer ? '-ssr' : ''}`,
        ...isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder': 'side-navigation-placeholder'
        },
        ...!isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder-replace': 'side-navigation-placeholder'
        },
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _1bsb1osq _1ul9p3fh _4t3i1osq _kqswh2mm _2lx21bp4 _bfhkw70a _syazjjyb"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j7LBE.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "notch",
            children: children
        })
    });
});
var $eb2dd47d2fa741f7$export$2e2bcd8739ae039 = $eb2dd47d2fa741f7$var$SideNavigation;

});

parcelRegister("k0ZZ2", function(module, exports) {

$parcel$export(module.exports, "MenuItem", () => $5e6269ab5deb76fb$export$2ce376c2cc3355c8);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aZsz6 = parcelRequire("aZsz6");

var $jSfqD = parcelRequire("jSfqD");

var $hjSul = parcelRequire("hjSul");
var $doZTA = parcelRequire("doZTA");

var $fpoBX = parcelRequire("fpoBX");

var $jvqf4 = parcelRequire("jvqf4");
const $5e6269ab5deb76fb$var$cssVarPrefix = '--sidebar-menu-item';
const $5e6269ab5deb76fb$var$bgColorCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-bg-color`;
const $5e6269ab5deb76fb$var$bgColorHoverCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-bg-color-hover`;
const $5e6269ab5deb76fb$var$bgColorActiveCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-bg-color-active`;
const $5e6269ab5deb76fb$var$colorCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-color`;
const $5e6269ab5deb76fb$var$colorHoverCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-color-hover`;
const $5e6269ab5deb76fb$var$colorActiveCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-color-active`;
const $5e6269ab5deb76fb$var$boxShadowCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-box-shadow`;
const $5e6269ab5deb76fb$var$iconSecondaryColorHoverCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-icon-secondary-color-hover`;
const $5e6269ab5deb76fb$var$styles = {
    root: "_ow0718uv _vwjz18uv _el8t18uv _17rj1kw7 _1f981kw7 _12pi1kw7 _1iqunqa1 _6xf7nqa1 _1lwpnqa1 _144v1r31 _3m4d1r31 _epv21r31 _chl4glyw _1bblglyw _1xhsglyw _1txwidpf _fg45idpf _gmaiidpf _10fu1oxo _iozn1cd0 _1vzi1w2z _davf29yu _1lfucjiy _s3s5tlke _12pzh2mm",
    selected: "_1cmdaqb7",
    themeColorDefault: "_1w905hvc _zelm5hvc _1f1j5hvc _1cmd5hvc",
    themeColorHover: "_1fh1smn3",
    themeColorActive: "_1l5a14t4 _1gdc14t4 _g8mu14t4 _434t14t4",
    themeBgColorDefault: "_16hgrn9c",
    themeBgColorHover: "_u1mb58tq",
    themeBgColorActive: "_1lg618j6",
    themeIconSecondaryColorHover: "_1k5811db"
};
const $5e6269ab5deb76fb$var$WrapperComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, className: className, legacyClassName: legacyClassName, href: href, to: to, target: target, useButtonLink: // @ts-expect-error - TS2339 - Property 'useButtonLink' does not exist on type 'CustomItemComponentProps & AnchorHTMLAttributes<HTMLAnchorElement> & { children: ReactNode; ... 10 more ...; prefetch?: false | ... 2 more ... | undefined; } & { ...; }'.
useButtonLink, ...props }, ref)=>{
    const commonProps = {
        ...props,
        children: children,
        className: `${className ?? ''} ${legacyClassName ?? ''}`
    };
    return href != null || to != null ? /*#__PURE__*/ $5uXOq.createElement((0, $hjSul.Link), {
        ...commonProps,
        href: href,
        to: to,
        target: target,
        ref: ref,
        type: useButtonLink ? 'button' : 'a'
    }) : // @ts-expect-error Type 'HTMLAnchorElement | HTMLButtonElement | null' is not assignable to type 'HTMLButtonElement | null'
    /*#__PURE__*/ $5uXOq.createElement($5e6269ab5deb76fb$var$ButtonItem, {
        ...commonProps,
        type: "button",
        ref: ref
    });
});
const $5e6269ab5deb76fb$export$2ce376c2cc3355c8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ analytics: analytics, href: href, onClick: onClick, overrides: overrides, selectedOn: selectedOn, className: className, useButtonLink: useButtonLink = false, ...rest }, ref)=>{
    const onClickHandler = (0, $jvqf4.useOnClick)({
        onClick: onClick,
        analytics: analytics
    });
    const [{ route: route, query: query, location: location }] = (0, $doZTA.useRouter)();
    let isSelected;
    // Currently, because the CMP project settings are not part of the SPA, the whole sidebar reloads everytime a menu item
    // is clicked -> As part of the Lunar Project Settings improvements, we're scrolling selected items into view once the
    // page reloads.
    //
    // We're setting a timeout to wait for the event loop to complete prior to scrolling.
    (0, $5uXOq.useEffect)(()=>{
        // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
        if (isSelected && ref?.current != null) setTimeout(()=>{
            // using ref?.current doesn't seem to work specifically here
            // Flow complianed about this part here specifically :/
            ref && // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
            ref.current != null && // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
            ref.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        });
    }, [
        selectedOn,
        ref,
        // @ts-expect-error - Variable 'isSelected' is used before being assigned.
        isSelected
    ]);
    if (typeof selectedOn === 'function') isSelected = route != null && // @ts-expect-error - Property 'search' is missing in type 'URLParse' but required in type 'MatcherLocation'.
    selectedOn({
        ...location,
        query: query
    }, (0, (/*@__PURE__*/$parcel$interopDefault($aZsz6)))(href || '/', true));
    else isSelected = Boolean(selectedOn) && route != null && selectedOn != null && selectedOn.includes(route.name);
    const theme = (0, $fpoBX.useSidebarTheme)();
    const itemTheme = theme?.navigation?.item;
    const iconTheme = theme?.navigation?.icon;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const customProps = {
        ...rest,
        component: $5e6269ab5deb76fb$var$WrapperComponent,
        href: href,
        isSelected: isSelected,
        onClick: onClickHandler,
        overrides: overrides,
        ref: ref,
        useButtonLink: useButtonLink,
        'aria-current': isSelected ? 'page' : undefined,
        style: {
            [$5e6269ab5deb76fb$var$bgColorCssVar]: itemTheme?.background?.default ?? undefined,
            [$5e6269ab5deb76fb$var$bgColorHoverCssVar]: itemTheme?.background?.hover ?? undefined,
            [$5e6269ab5deb76fb$var$bgColorActiveCssVar]: itemTheme?.background?.active ?? undefined,
            [$5e6269ab5deb76fb$var$colorCssVar]: itemTheme?.color?.default ?? undefined,
            [$5e6269ab5deb76fb$var$colorHoverCssVar]: itemTheme?.color?.hover ?? undefined,
            [$5e6269ab5deb76fb$var$colorActiveCssVar]: itemTheme?.color?.active ?? undefined,
            [$5e6269ab5deb76fb$var$boxShadowCssVar]: itemTheme?.color?.active != null ? `${itemTheme?.color?.active} 0 0 0 2px inset` : `${"var(--ds-border-focused, #388BFF)"} 0 0 0 2px inset`,
            [$5e6269ab5deb76fb$var$iconSecondaryColorHoverCssVar]: iconTheme?.secondary?.color?.hover ?? undefined
        }
    };
    if (overrides?.CustomItem?.render) return overrides?.CustomItem?.render({
        ...customProps,
        className: (0, $bwpsq.default)([
            (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.root
            ]),
            isSelected && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.selected
            ]),
            itemTheme?.color?.default && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeColorDefault
            ]),
            itemTheme?.background?.default && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeBgColorDefault
            ]),
            itemTheme?.background?.hover && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeBgColorHover
            ]),
            itemTheme?.background?.active && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeBgColorActive
            ]),
            itemTheme?.color?.hover && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeColorHover
            ]),
            itemTheme?.color?.active && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeColorActive
            ]),
            iconTheme?.secondary?.color?.hover && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeIconSecondaryColorHover
            ]),
            className
        ])
    });
    return /*#__PURE__*/ $5uXOq.createElement((0, $jSfqD.default), {
        ...customProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $bwpsq.default)([
            $5e6269ab5deb76fb$var$styles.root,
            isSelected && $5e6269ab5deb76fb$var$styles.selected,
            itemTheme?.color?.default && $5e6269ab5deb76fb$var$styles.themeColorDefault,
            itemTheme?.background?.default && $5e6269ab5deb76fb$var$styles.themeBgColorDefault,
            itemTheme?.background?.hover && $5e6269ab5deb76fb$var$styles.themeBgColorHover,
            itemTheme?.background?.active && $5e6269ab5deb76fb$var$styles.themeBgColorActive,
            itemTheme?.color?.hover && $5e6269ab5deb76fb$var$styles.themeColorHover,
            itemTheme?.color?.active && $5e6269ab5deb76fb$var$styles.themeColorActive,
            iconTheme?.secondary?.color?.hover && $5e6269ab5deb76fb$var$styles.themeIconSecondaryColorHover,
            className
        ])
    });
});
// this should be same as ButtonItem in '@atlaskit/menu'
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5e6269ab5deb76fb$var$ButtonItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhk18uv _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fpoBX", function(module, exports) {

$parcel$export(module.exports, "SidebarThemeProvider", () => $c9116269ddc1accc$export$92cd68117b68bf5f);
$parcel$export(module.exports, "useSidebarTheme", () => $c9116269ddc1accc$export$b1a81b4626bc52c3);

var $5uXOq = parcelRequire("5uXOq");
const $c9116269ddc1accc$var$ThemeContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $c9116269ddc1accc$export$92cd68117b68bf5f = ({ theme: theme, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c9116269ddc1accc$var$ThemeContext.Provider, {
        value: theme
    }, children);
const $c9116269ddc1accc$export$b1a81b4626bc52c3 = ()=>(0, $5uXOq.useContext)($c9116269ddc1accc$var$ThemeContext);

});

parcelRegister("jvqf4", function(module, exports) {

$parcel$export(module.exports, "useOnClick", () => $568e03d72b926f2a$export$a81c45382e7253ac);

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $568e03d72b926f2a$export$a81c45382e7253ac = ({ analytics: analytics, onClick: onClick } = {})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        });
        if (analytics) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'sidebar', analytics);
        else (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'sidebar');
        onClick && onClick(event);
    };
};

});


parcelRegister("3OGaE", function(module, exports) {

$parcel$export(module.exports, "TitleHeader", () => $09f1bcc415909488$export$de3705f3d2162955);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $fJoTF = parcelRequire("fJoTF");
const $09f1bcc415909488$var$overrideStyles = null;
const $09f1bcc415909488$export$de3705f3d2162955 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fJoTF.CustomHeader), {
        testId: "navigation-apps-sidebar-common.common.ui.title-header",
        className: (0, $bwpsq.default)([
            "_dqi54jg8 _1lfu4jg8"
        ])
    }, children);
};

});
parcelRegister("fJoTF", function(module, exports) {

$parcel$export(module.exports, "CustomHeader", () => $d2408f7c0923c3e9$export$a231a61d189ef09a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jSfqD = parcelRequire("jSfqD");

var $fpoBX = parcelRequire("fpoBX");
const $d2408f7c0923c3e9$var$bgColorCssVar = '--header-bg-color';
const $d2408f7c0923c3e9$var$textColorCssVar = '--header-text-color';
const $d2408f7c0923c3e9$var$containerStyles = null;
const $d2408f7c0923c3e9$var$bgColorThemeStyles = null;
const $d2408f7c0923c3e9$var$colorThemeStyles = null;
const $d2408f7c0923c3e9$export$1e86fd0e1db89578 = ({ className: className, ...props })=>{
    const theme = (0, $fpoBX.useSidebarTheme)();
    const item = theme?.navigation?.item;
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_syaz1jnk _kqswh2mm _uizt1wug _vrjt140y _1cmdleuv _jl2n73ad _1v6j1fxt",
            item?.background?.default && "_bfhk1im0",
            item?.color?.default && "_syaz1jnk _i9a11jnk",
            className
        ]),
        // eslint-disable-next-line jira/react/no-style-attribute
        style: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {
            [$d2408f7c0923c3e9$var$bgColorCssVar]: item?.background?.default,
            [$d2408f7c0923c3e9$var$textColorCssVar]: item?.color?.default
        },
        ...props
    });
};
const $d2408f7c0923c3e9$export$a231a61d189ef09a = ({ iconBefore: iconBefore, iconAfter: iconAfter, children: children, ...rest })=>{
    return /*#__PURE__*/ $5uXOq.createElement((0, $jSfqD.default), {
        ...rest,
        component: $d2408f7c0923c3e9$export$1e86fd0e1db89578,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isTitleHeading: true
    }, children);
};

});


parcelRegister("juTur", function(module, exports) {

$parcel$export(module.exports, "ContextualAnalyticsData", () => $ffb2d49dc0e79e64$export$198470770171c65);
$parcel$export(module.exports, "IssuesContextualAnalyticsData", () => $ffb2d49dc0e79e64$export$bc7f6eebc16e6127);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $iXVV6 = parcelRequire("iXVV6");

var $lpwtK = parcelRequire("lpwtK");

var $3d1up = parcelRequire("3d1up");
const $ffb2d49dc0e79e64$export$198470770171c65 = ({ attributes: attributes, menuId: menuId, stack: stack = [], ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        ...rest,
        attributes: {
            // @deprecated cleanup this attribute on jira_nav4 FG / Nav3 cleanup. navState is used instead
            navVersion: '3',
            viewId: (0, $3d1up.generateViewId)(menuId, ...stack),
            navigationLayer: 'container',
            ...attributes
        }
    });
const $ffb2d49dc0e79e64$export$bc7f6eebc16e6127 = ({ attributes: attributes, navigatorScope: navigatorScope, useProject: // eslint-disable-next-line react-hooks/react-compiler
useProject = (0, $lpwtK.useProject), ...rest })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const { data: project } = useProject();
    const projectConfig = (project?.isSimplified ? (0, $2vSU6.ProjectStyle).NEXT_GEN : (0, $2vSU6.ProjectStyle).CLASSIC) || undefined;
    const projectType = project?.type || undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        ...rest,
        attributes: {
            ...attributes,
            projectConfig: projectConfig,
            projectType: projectType,
            navigatorScope: navigatorScope
        }
    });
};

});
parcelRegister("3d1up", function(module, exports) {

$parcel$export(module.exports, "generateViewId", () => $2f6f53381b1f04e0$export$5b5545ed894dc47a);
const $2f6f53381b1f04e0$export$5b5545ed894dc47a = (...ids)=>ids.join('/');

});


parcelRegister("17bH5", function(module, exports) {

$parcel$export(module.exports, "getSystemNavigationPaths", () => $0ac95c37050f315f$export$76c5f80c8d9bdb0e);
$parcel$export(module.exports, "isSystemNavPath", () => $0ac95c37050f315f$export$3e53a29d6e499ec4);

var $4R6GH = parcelRequire("4R6GH");
const $0ac95c37050f315f$export$76c5f80c8d9bdb0e = ()=>({
        generalConfiguration: '/jira/settings/system/general-configuration',
        darkFeatures: '/secure/admin/SiteDarkFeatures!default.jspa',
        issueCollectors: '/secure/admin/ViewGlobalCollectors!default.jspa',
        globalAutomation: '/jira/settings/automation',
        // troubleshooting
        troubleshootingAuditLog: '/auditing/view',
        troubleshootingPluginViewer: '/plugins/servlet/depview/plugins',
        troubleshootingModulesViewer: '/plugins/servlet/depview/modules',
        troubleshootingSystemInfo: '/secure/admin/ViewSystemInfo.jspa',
        troubleshootingIntegrityChecker: '/secure/admin/IntegrityChecker!default.jspa',
        troubleshootingLoggingProfiling: '/secure/admin/ViewLogging.jspa',
        troubleshootingSchedulerDetails: '/secure/admin/SchedulerAdmin.jspa',
        troubleshootingPerformanceAndScale: '/jira/settings/system/performance/overview',
        // security
        securityProjectRoles: '/secure/project/ViewProjectRoles.jspa',
        securityGlobalPermissions: (0, $4R6GH.fg)('olympus-global-permissions-fe-modernisation') ? '/secure/admin/global-permissions' : '/secure/admin/GlobalPermissions!default.jspa',
        // user interface
        userInterfacesUserDefaults: '/secure/admin/ViewUserDefaultSettings.jspa',
        userInterfacesEditDefaultDashboard: '/secure/admin/EditDefaultDashboard!default.jspa',
        userInterfacesLookAndFeel: '/secure/admin/LookAndFeel!default.jspa',
        userInterfacesPasAdmin: '/plugins/servlet/pas/admin',
        userInterfacesSiteAdmin: '/jira/settings/system/ui/announcement-banner',
        // import and export
        importSectionBackupManager: '/secure/admin/CloudExport.jspa',
        importSectionExternalImport: '/secure/admin/ExternalImport1.jspa',
        importSectionExternalImportNew: '/jira/settings/system/external-import',
        importSectionCloudImport: '/secure/admin/CloudImport!start.jspa?source=import_cloud',
        importSectionServerImport: '/secure/admin/CloudImport!start.jspa?source=import_server',
        // mail
        mailSectionGlobalMailSettings: '/secure/admin/GlobalMailSettings.jspa',
        mailSectionOutgoingMail: '/secure/admin/OutgoingMailServers.jspa',
        mailSectionIncomingMail: '/secure/admin/IncomingMailServers.jspa',
        mailSectionSendMail: '/secure/admin/SendBulkMail!default.jspa',
        // admin
        adminHelperPermissionHelper: '/secure/admin/PermissionHelperAdmin.jspa',
        adminHelperEmailNotificationsLogHelper: '/jira/settings/system/notification-logs',
        // shared
        sharedSectionManageFilters: '/secure/admin/filters/ViewSharedFilters.jspa',
        sharedManageDashboards: '/secure/admin/dashboards/ViewSharedDashboards.jspa',
        // advanced
        advancedSectionAttachments: '/secure/admin/ViewAttachmentSettings.jspa',
        advancedSectionEvents: '/secure/admin/ListEventTypes.jspa',
        advancedSectionWebHooks: '/plugins/servlet/webhooks',
        advancedSectionServices: '/secure/admin/ViewServices!default.jspa',
        advancedLexoRankManagement: '/secure/GHLexoRankManage.jspa?decorator=admin'
    });
const $0ac95c37050f315f$var$getSystemNavPaths = ()=>{
    return [
        '/jira/settings/system/general-configuration',
        '/secure/admin/SiteDarkFeatures',
        '/secure/admin/ViewGlobalCollectors',
        '/jira/settings/automation',
        '/auditing/view',
        '/secure/project/ViewProjectRoles',
        '/secure/admin/global-permissions',
        '/secure/admin/GlobalPermissions',
        '/secure/admin/ViewUserDefaultSettings',
        '/secure/admin/EditDefaultDashboard',
        '/secure/admin/LookAndFeel',
        '/jira/settings/system/ui/announcement-banner',
        '/secure/admin/CloudExport',
        '/jira/settings/system/external-import',
        '/secure/admin/CloudImport',
        '/secure/admin/GlobalMailSettings',
        '/secure/admin/global-mail-settings',
        '/secure/admin/OutgoingMailServers',
        '/secure/admin/IncomingMailServers',
        '/secure/admin/SendBulkMail',
        '/secure/admin/PermissionHelperAdmin',
        '/jira/settings/system/notification-logs',
        '/secure/admin/filters/ViewSharedFilters',
        '/secure/admin/dashboards/ViewSharedDashboards',
        '/secure/admin/ViewAttachmentSettings',
        '/secure/admin/ListEventTypes',
        '/plugins/servlet/webhooks',
        '/secure/GHLexoRankManage'
    ];
};
const $0ac95c37050f315f$export$3e53a29d6e499ec4 = (path)=>{
    const paths = $0ac95c37050f315f$var$getSystemNavPaths();
    return path && paths.some((p)=>path.includes(p));
};

});

parcelRegister("3tHFY", function(module, exports) {

$parcel$export(module.exports, "ConnectMenu", () => $1b0be5b9936240ae$export$19d0925d424b864a);

var $5uXOq = parcelRequire("5uXOq");

var $au6nA = parcelRequire("au6nA");

var $fh2pW = parcelRequire("fh2pW");
const $1b0be5b9936240ae$export$19d0925d424b864a = ({ items: items, overrides: overrides, showIcons: showIcons = false, shouldFilter: shouldFilter = true, submenuId: submenuId = '' })=>{
    const filteredItems = (0, $au6nA.useFilteredItems)(items || null, shouldFilter);
    if (filteredItems == null || !filteredItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, filteredItems.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fh2pW.ConnectItem), {
            item: item,
            key: item.id,
            index: index,
            overrides: overrides,
            showIcons: showIcons,
            submenuId: submenuId
        })));
};

});
parcelRegister("au6nA", function(module, exports) {

$parcel$export(module.exports, "useFilteredItems", () => $cb371d7d8e582719$export$79762159776e61da);

var $5uXOq = parcelRequire("5uXOq");

var $kvHKs = parcelRequire("kvHKs");
const $cb371d7d8e582719$export$79762159776e61da = (items, shouldFilter = true)=>(0, $5uXOq.useMemo)(()=>{
        if (!shouldFilter) return items || [];
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"services" | "collectors" | "attachments" | "eventtypes" | "webhooks-admin" | "greenhopper-lexorank-manage" | "admin-helper-admin-section" | "advanced_section" | "dark_features" | ... 74 more ... | "com.codebarrel.addons.automation__cb-automation" | "com.codebarrel.addons.automation.moderate__cb-automation"'.
        return items?.filter((item)=>!(0, $kvHKs.staticLegacyIds).includes(item.id)) || [];
    }, [
        items,
        shouldFilter
    ]);

});

parcelRegister("fh2pW", function(module, exports) {

$parcel$export(module.exports, "ConnectItem", () => $f2bd062d7c8c5e44$export$8bb4bcea44a3c9ea);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8vDvO = parcelRequire("8vDvO");

var $gjTBi = parcelRequire("gjTBi");

var $3TzYp = parcelRequire("3TzYp");

var $iUo88 = parcelRequire("iUo88");

var $jjUR3 = parcelRequire("jjUR3");

var $hrlU6 = parcelRequire("hrlU6");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $eYDk7 = parcelRequire("eYDk7");

var $3OGaE = parcelRequire("3OGaE");

var $kZj7F = parcelRequire("kZj7F");

var $4OCke = parcelRequire("4OCke");
const $f2bd062d7c8c5e44$export$8bb4bcea44a3c9ea = ({ index: index, item: item, overrides: overrides, showIcons: showIcons, submenuId: submenuId = '', isNested: isNested = false })=>{
    const { addNew: addNew } = (0, $jjUR3.useConnectItemClickHistory)();
    const isDialog = item.styleClass && (0, $hrlU6.isConnectDialogWebItem)(item.styleClass);
    const webItemRef = (0, $5uXOq.useRef)(null);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const BackMenuItem = {
        ...overrides.BackMenuItem,
        onClick: (ev)=>{
            // Due to CMP project settings not being part to the SPA, we have to set / get the state of the
            // Expandable menu items from cookies - this is because the page does a complete refresh upon clicking a menuitem link.
            // This is to satisfy a requirement for open expandable menus to remain open
            // when users return to the project settings menu
            if (submenuId != null) {
                const cookieData = (0, $3TzYp.getCookie)(`jira.navigation.expandableMenuStates.${submenuId}`);
                let parsedCookieData = null;
                try {
                    // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
                    parsedCookieData = JSON.parse(cookieData);
                } catch  {
                    // Rather than throw an error - just set the default state
                    parsedCookieData = {
                        submenuActive: false,
                        expanded: false
                    };
                }
                const newCookieData = {
                    ...parsedCookieData,
                    submenuActive: false
                };
                (0, $iUo88.setStrictlyNecessaryCookie)(`jira.navigation.expandableMenuStates.${submenuId}`, JSON.stringify(newCookieData));
            }
            // Setting navigateOnBackMenuItemClick to true will allow backToProject link to take user to the default project page
            if (overrides?.navigateOnBackMenuItemClick !== true) ev.preventDefault();
            overrides.BackMenuItem?.onClick?.(ev);
        }
    };
    const icon = (0, $5uXOq.useMemo)(()=>{
        if (showIcons !== true) return null;
        return item.iconUrl != null && item.iconUrl.trim().length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f2bd062d7c8c5e44$var$ConnectIcon, {
            src: item.iconUrl,
            alt: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8vDvO))), {
            spacing: "spacious",
            label: ""
        });
    }, [
        showIcons,
        item.iconUrl
    ]);
    const onItemClick = (0, $5uXOq.useCallback)((event)=>{
        // We need to check we're clicking an item inside a nested menu for a connect item.
        // if we are deep linking to a nested connect item -> we need to maintain the hiding of nav-modules
        // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        if (overrides?.ParentMenuItem?.onClick && isNested) // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        overrides.ParentMenuItem.onClick(event);
        if (isDialog) (0, $hrlU6.withConnectHost)((connectHost)=>{
            if (webItemRef.current && item.styleClass && item.url) connectHost.triggerWebItem(webItemRef.current, item.styleClass, item.url);
        });
        else item.url != null && addNew(item.url);
    }, [
        addNew,
        isDialog,
        isNested,
        item.styleClass,
        item.url,
        overrides
    ]);
    const onNestedMenuItemClick = (0, $5uXOq.useCallback)((event)=>{
        // Due to CMP project settings not being part to the SPA, we have to set / get the state of the
        // Expandable menu items from cookies - this is because the page does a complete refresh upon clicking a menuitem link.
        // This is to satisfy a requirement for open expandable menus to remain open
        // when users return to the project settings menu
        if (submenuId != null) {
            const cookieData = (0, $3TzYp.getCookie)(`jira.navigation.expandableMenuStates.${submenuId}`);
            if (cookieData != null) (0, $iUo88.setStrictlyNecessaryCookie)(`jira.navigation.expandableMenuStates.${submenuId}`, JSON.stringify({
                ...JSON.parse(cookieData),
                submenuActive: true
            }));
        }
        // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        if (overrides?.ParentMenuItem?.onClick) // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        overrides.ParentMenuItem.onClick(event);
        return ()=>null;
    }, [
        overrides,
        submenuId
    ]);
    if (item.section === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: item.name,
        hasSeparator: Boolean(index)
    }, (item.items || []).map((si, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f2bd062d7c8c5e44$export$8bb4bcea44a3c9ea, {
            key: si.id,
            item: si,
            overrides: {
                ...overrides,
                BackMenuItem: BackMenuItem
            },
            index: idx,
            isNested: isNested
        })));
    if (item.items) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZj7F.NestingMenuItem), {
        id: item.id,
        analytics: {
            itemId: item.id
        },
        iconBefore: icon,
        overrides: {
            ...overrides,
            BackMenuItem: BackMenuItem
        },
        title: item.name,
        onClick: onNestedMenuItemClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eYDk7.NavigationContentWrapper), {
        submenuActive: true,
        nestedMenuOpen: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OGaE.TitleHeader), null, item.name), (item.items || []).map((si, nestIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f2bd062d7c8c5e44$export$8bb4bcea44a3c9ea, {
            key: si.id,
            item: si,
            index: nestIndex,
            overrides: {
                ...overrides,
                BackMenuItem: {
                    href: item.url,
                    title: si.name,
                    onClick: (ev)=>ev.preventDefault()
                }
            },
            isNested: true
        })))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: item.id
        },
        selectedOn: (0, $4OCke.matchUrlExact)(),
        iconBefore: icon,
        href: isDialog ? undefined : item.url,
        onClick: onItemClick,
        ref: webItemRef
    }, item.name);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f2bd062d7c8c5e44$var$ConnectIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbgktf _4t3igktf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iUo88", function(module, exports) {

$parcel$export(module.exports, "setStrictlyNecessaryCookie", () => $89b5b8a4b358ad27$export$93509ff9a62ee022);

var $7RRGT = parcelRequire("7RRGT");
const $89b5b8a4b358ad27$export$93509ff9a62ee022 = (key, value, attributes)=>{
    (0, $7RRGT.setStrictlyNecessaryCookie)(key, value, attributes);
};

});

parcelRegister("eYDk7", function(module, exports) {

$parcel$export(module.exports, "NavigationHeaderWrapper", () => $eea5dc8ebf00d36e$export$bae9b35e967353d5);
$parcel$export(module.exports, "NavigationExpandableContentWrapper", () => $eea5dc8ebf00d36e$export$4e88508e6904469e);
$parcel$export(module.exports, "NavigationContentWrapper", () => $eea5dc8ebf00d36e$export$e7d691a5a9258e1b);
$parcel$export(module.exports, "NextGenIssueTypesWrapper", () => $eea5dc8ebf00d36e$export$f094f7aad76e4268);
$parcel$export(module.exports, "ExpandableProjectSettingsWrapper", () => $eea5dc8ebf00d36e$export$e38bb288d890ec2f);
$parcel$export(module.exports, "ShortCutsAndAppsWrapper", () => $eea5dc8ebf00d36e$export$337add4342ee7986);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $gwIPs = parcelRequire("gwIPs");
const $eea5dc8ebf00d36e$export$bae9b35e967353d5 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NavigationHeaderWrapperContainer, null, props.children);
const $eea5dc8ebf00d36e$export$4e88508e6904469e = (props)=>{
    const { nestedAppOpen: nestedAppOpen, submenuActive: submenuActive, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NavigationExpandableContentWrapperContainer, {
        nestedAppOpen: nestedAppOpen,
        submenuActive: submenuActive
    }, children);
};
const $eea5dc8ebf00d36e$export$e7d691a5a9258e1b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NavigationContentWrapperContainer, {
        submenuActive: props.submenuActive,
        nestedMenuOpen: props.nestedMenuOpen,
        "data-component-selector": "NavigationContentWrapperContainer"
    }, props.children);
const $eea5dc8ebf00d36e$export$f094f7aad76e4268 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NextGenIssueTypesWrapperContainer, null, props.children);
const $eea5dc8ebf00d36e$export$e38bb288d890ec2f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$ExpandableProjectContainer, null, props.children);
const $eea5dc8ebf00d36e$export$337add4342ee7986 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$ShortCutsAndAppsContainer, null, props.children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $eea5dc8ebf00d36e$var$NavigationHeaderWrapperContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0u2gc _1s541012 _1lfu1012",
            __cmplp.className
        ])
    });
});
const $eea5dc8ebf00d36e$var$NavigationExpandableContentWrapperContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { submenuActive: submenuActive, nestedAppOpen: nestedAppOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ykp9lh": (0, $lD23V.default)(__cmplp.nestedAppOpen ? 'auto' : '100%'),
            "--_1qrlsbv": (0, $lD23V.default)(Math.round((0, $gwIPs.borderRadius) * 1.333), "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0u2gc _1q1o54a6 _1dul54a6 _ofxb54a6 _179m54a6 _vnu9l52n _19iyl52n _t6kll52n _shi3l52n _15sk1v6z _178k1v6z _18pc1v6z _1bc71v6z _yugv5oil _83u65oil _1ern5oil _rjkj5oil",
            __cmplp.submenuActive && "_4t3i1qw7",
            __cmplp.submenuActive ? "_bq2uyjp0 _1n80yjp0 _di7gyjp0 _1lozyjp0" : "_bq2u1d7o _1n801d7o _di7g1d7o _1loz1d7o",
            __cmplp.className
        ])
    });
});
const $eea5dc8ebf00d36e$var$NavigationContentWrapperContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { submenuActive: submenuActive, nestedMenuOpen: nestedMenuOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_6w8gix": (0, $lD23V.default)(__cmplp.nestedMenuOpen ? 0 : 7.5 * (0, $gwIPs.gridSize), "px"),
            "--_1qrlsbv": (0, $lD23V.default)(Math.round((0, $gwIPs.borderRadius) * 1.333), "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_yugv5oil _83u65oil _1ern5oil _rjkj5oil",
            __cmplp.submenuActive ? "_4t3iu4z3" : "_4t3i1wug",
            __cmplp.submenuActive ? "_vnu91tcg _19iy1tcg _t6kl1tcg _shi31tcg" : "_vnu9l52n _19iyl52n _t6kll52n _shi3l52n",
            __cmplp.nestedMenuOpen && "_1reo1wug _18m91wug _14tk183y",
            __cmplp.className
        ])
    });
});
const $eea5dc8ebf00d36e$var$NextGenIssueTypesWrapperContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _vpnr1ejb _14tk72c6 _cb62utpp _1wtp1txs _l9o61txs _f6zi1txs",
            __cmplp.className
        ])
    });
});
const $eea5dc8ebf00d36e$var$ExpandableProjectContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _4t3i1osq _1wtppxbi _df5vpxbi",
            __cmplp.className
        ])
    });
});
const $eea5dc8ebf00d36e$var$ShortCutsAndAppsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _14tk72c6 _t3zc183y _1so41gjq _1thc1skh _a6avqslr _dnyv1skh",
            __cmplp.className
        ])
    });
});

});

parcelRegister("kZj7F", function(module, exports) {

$parcel$export(module.exports, "NestingMenuItem", () => $2fbfde7c900477f4$export$4c594f24f8e4128a);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $d2gYe = parcelRequire("d2gYe");

var $8UO8z = parcelRequire("8UO8z");

var $5Hj3V = parcelRequire("5Hj3V");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $fpoBX = parcelRequire("fpoBX");

var $kavsL = parcelRequire("kavsL");
const $2fbfde7c900477f4$var$iconSecondaryColorCssVar = '--nesting-menu-item-icon-secondary-color';
const $2fbfde7c900477f4$var$styles = {
    backButtonThemeOverrides: "_18ljulk5 _ksbyulk5",
    customItem: "_4t3i1ady _vl7qglyw _slhpglyw _7upw1txw _1nrm18uv _1a3b18uv _1ydc18uv _c2wa1kw7 _4fpr1kw7 _1x281kw7 _1iohnqa1 _5goinqa1 _1726nqa1 _1q5t1r31 _nt751r31 _9nxe1r31 _1ohyglyw _49pcglyw _tpgfglyw _1r9xidpf _1hvwidpf _12gridpf"
};
const $2fbfde7c900477f4$var$WrappingLinkComponent = (props)=>/*#__PURE__*/ $5uXOq.createElement("a", props, props.children);
const $2fbfde7c900477f4$export$4c594f24f8e4128a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, id: id, reloadOnNavigationToNesting: reloadOnNavigationToNesting, overrides: overrides = {}, title: title, ...rest }, ref)=>{
    const theme = (0, $fpoBX.useSidebarTheme)();
    const iconSecondaryColor = theme?.navigation?.icon?.secondary?.color?.default;
    const { BackMenuItem: BackMenuItem = {} } = overrides;
    const { title: backTitle = 'Back', wrapper: WrapperComponent = (0, $5uXOq.Fragment), ...backItemProps } = BackMenuItem; // eslint-disable-line @typescript-eslint/consistent-type-assertions
    const renderBackItem = (0, $5uXOq.useCallback)(({ onClick: onClick })=>/*#__PURE__*/ $5uXOq.createElement(WrapperComponent, null, /*#__PURE__*/ $5uXOq.createElement((0, $k0ZZ2.MenuItem), {
            ...backItemProps,
            analytics: {
                itemId: 'back'
            },
            iconBefore: /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($d2gYe))), {
                spacing: "spacious",
                label: ""
            }),
            onClick: (ev)=>{
                if ((0, $kavsL.isNormalClick)(ev)) {
                    onClick();
                    backItemProps.onClick?.(ev);
                }
            },
            // eslint-disable-next-line jira/react/no-style-attribute, @typescript-eslint/consistent-type-assertions
            style: {
                [$2fbfde7c900477f4$var$iconSecondaryColorCssVar]: iconSecondaryColor ?? undefined
            },
            className: (0, $bwpsq.default)([
                iconSecondaryColor && $2fbfde7c900477f4$var$styles.backButtonThemeOverrides
            ])
        }, backTitle)), [
        WrapperComponent,
        backItemProps,
        backTitle,
        iconSecondaryColor
    ]);
    const renderCustomItem = (0, $5uXOq.useCallback)(({ children: itemTitle, onClick: onClick, className: className, ...props })=>/*#__PURE__*/ $5uXOq.createElement((0, $8UO8z.default), {
            ...props,
            id: id,
            component: reloadOnNavigationToNesting ? $2fbfde7c900477f4$var$WrappingLinkComponent : props.component,
            onClick: (ev)=>{
                // if nesting item already selected do not trigger route change
                if (props.isSelected === true) ev.preventDefault();
                onClick && onClick(ev);
            },
            // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
            overrides: {
                GoBackItem: {
                    render: renderBackItem
                }
            },
            title: itemTitle,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
            className: (0, $bwpsq.default)([
                $2fbfde7c900477f4$var$styles.customItem,
                className
            ])
        }, /*#__PURE__*/ $5uXOq.createElement((0, $5Hj3V.SidebarErrorBoundary), {
            id: `${id}Nesting`,
            packageName: "jiraSpaAppsSidebarCommon"
        }, children)), [
        children,
        id,
        reloadOnNavigationToNesting,
        renderBackItem
    ]);
    return /*#__PURE__*/ $5uXOq.createElement((0, $k0ZZ2.MenuItem), {
        ...rest,
        ref: ref,
        overrides: {
            CustomItem: {
                render: renderCustomItem
            }
        }
    }, title);
});

});



parcelRegister("eaZ4X", function(module, exports) {

$parcel$export(module.exports, "SECTION_ID", () => $b36275c07d465a0e$export$501955bd67991a25);
const $b36275c07d465a0e$export$501955bd67991a25 = {
    MIGRATE_TO_CLOUD_SITE: 'migrate-to-cloud-site',
    PERFORMANCE_AND_SCALE: 'performance-and-scale'
};

});

parcelRegister("jMBA3", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $4023bf6b28a8dc58$export$4a39035bacc4ed76);
$parcel$export(module.exports, "useGlobalSettingsSystemConnectItems", () => $4023bf6b28a8dc58$export$f601efaceb0636f4);

var $5uXOq = parcelRequire("5uXOq");

var $aUDLa = parcelRequire("aUDLa");

var $7OqB4 = parcelRequire("7OqB4");

var $awp39 = parcelRequire("awp39");

var $9OXo1 = parcelRequire("9OXo1");

var $gJkov = parcelRequire("gJkov");
const $4023bf6b28a8dc58$export$4a39035bacc4ed76 = (0, $7OqB4.withThrowOnError)(()=>{
    const { data: data, loading: loading, error: error } = (0, $aUDLa.useNavigationGlobalResource)();
    const { isDevMode: isDevMode, isAdmin: isAdmin } = (0, $9OXo1.useTenantContext)();
    const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, $gJkov.extractData)(data, isDevMode, isAdmin), [
        data,
        isDevMode,
        isAdmin
    ]);
    return {
        data: extractedData,
        loading: loading,
        error: error
    };
});
const $4023bf6b28a8dc58$export$f601efaceb0636f4 = (0, $7OqB4.withThrowOnError)((0, $awp39.useGlobalSettingsSystemConnectItems));

});
parcelRegister("aUDLa", function(module, exports) {

$parcel$export(module.exports, "useNavigationGlobalResource", () => $dbad5a19b82e4911$export$1e1c317ed5b99faa);

var $5uXOq = parcelRequire("5uXOq");

var $atU1t = parcelRequire("atU1t");

var $2YP9W = parcelRequire("2YP9W");
const $dbad5a19b82e4911$export$1e1c317ed5b99faa = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)((0, $atU1t.navigationSidebarGlobalResource));
    const response = (0, $5uXOq.useMemo)(()=>data && data.response, [
        data
    ]);
    return {
        data: response,
        loading: loading,
        error: error
    };
};

});

parcelRegister("7OqB4", function(module, exports) {

$parcel$export(module.exports, "withThrowOnError", () => $f0eadb98e9fdd0d1$export$a018832f2ec4dc91);
/* eslint-disable jira/react-magnetic-di/no-unneeded */ 
var $gKZoD = parcelRequire("gKZoD");
const $f0eadb98e9fdd0d1$var$isDataEmpty = (data)=>data == null;
function $f0eadb98e9fdd0d1$export$a018832f2ec4dc91(theHook) {
    return (...args)=>{
        // tests like src/packages/navigation-apps/horizontal-nav/tabs/board-scoped-tab/src/test.tsx do not work without this line
        (0, $gKZoD.di)(theHook);
        const result = theHook(...args);
        // escalate .error if condition is met (by throwing a runtime exception from it; to be caught and logged by the nearest ErrorBoundary for example).
        if (!false && $f0eadb98e9fdd0d1$var$isDataEmpty(result.data) && !result.loading && result.error) throw result.error;
        return result;
    };
}

});

parcelRegister("awp39", function(module, exports) {

$parcel$export(module.exports, "useGlobalSettingsSystemConnectItems", () => $6ac80db07eab2a1e$export$f601efaceb0636f4);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $aUDLa = parcelRequire("aUDLa");

var $doZTA = parcelRequire("doZTA");

var $7tsV0 = parcelRequire("7tsV0");

var $4gymV = parcelRequire("4gymV");

var $5W6pd = parcelRequire("5W6pd");
// use memoised functions per hook to avoid re-computation between same hooks
const $6ac80db07eab2a1e$var$getItemsMemo = (0, $8QpSo.default)((d)=>(0, $4gymV.getLinks)(d, [
        'admin_system_menu'
    ], {
        skipFilter: true
    }).map((0, $5W6pd.transformLink)).filter(Boolean));
const $6ac80db07eab2a1e$var$findItemAndStackMemo = (0, $8QpSo.default)((0, $7tsV0.findItemAndStack));
const $6ac80db07eab2a1e$export$f601efaceb0636f4 = ()=>{
    const [{ route: route, location: location }] = (0, $doZTA.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $aUDLa.useNavigationGlobalResource)();
    const items = (0, $5uXOq.useMemo)(()=>data && $6ac80db07eab2a1e$var$getItemsMemo(data), [
        data
    ]);
    const found = (0, $5uXOq.useMemo)(()=>route && items && $6ac80db07eab2a1e$var$findItemAndStackMemo(items, route.name, location), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        loading: loading,
        error: error,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});
parcelRegister("7tsV0", function(module, exports) {

$parcel$export(module.exports, "findItemAndStack", () => $93fa8c16baad19b1$export$751e2e6237002565);

var $ajpes = parcelRequire("ajpes");

var $k0iPT = parcelRequire("k0iPT");
// JSPA-1062 remove qs items that might not always be there
const $93fa8c16baad19b1$var$splitRelevantQs = (s)=>s.replace('?', '').split('&').filter((v)=>v && !/^(ac\.|project|board|user|servicedesk)/.test(v));
// match query strings, but allow case where query param "s" is present in the menu item, but not the window url
const $93fa8c16baad19b1$var$isSameQuery = (locationQuery, itemQuery)=>(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(locationQuery, itemQuery) || !locationQuery.some((q)=>q.startsWith('s=')) && (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(itemQuery.filter((q)=>!q.startsWith('s=')), locationQuery);
const $93fa8c16baad19b1$export$751e2e6237002565 = (items, routeName, location, parentStack = [])=>{
    let found = null;
    if (!(0, $k0iPT.CONNECT_ROUTES_SET).has(routeName)) return found;
    const locationQuery = $93fa8c16baad19b1$var$splitRelevantQs(location.search);
    items.some((item)=>{
        const [itemPath, itemQs = ''] = (item.url || '').split('#')[0].split('?');
        const itemQuery = $93fa8c16baad19b1$var$splitRelevantQs(itemQs);
        const sameQuery = $93fa8c16baad19b1$var$isSameQuery(locationQuery, itemQuery);
        if (item.section !== true && itemPath === location.pathname && sameQuery) {
            found = {
                stack: parentStack,
                selected: item
            };
            return true;
        }
        if (item.items) {
            const stack = item.section === true ? parentStack : parentStack.concat(item.id);
            found = $93fa8c16baad19b1$export$751e2e6237002565(item.items, routeName, location, stack);
        }
        return Boolean(found);
    });
    return found;
};

});
parcelRegister("k0iPT", function(module, exports) {

$parcel$export(module.exports, "JWM_OVERVIEWS_ROUTE_SET", () => $c82776b15970ab04$export$a8aac2ba4dc1f57);
$parcel$export(module.exports, "CONNECT_ROUTES_SET", () => $c82776b15970ab04$export$c47bf667d3008c53);
$parcel$export(module.exports, "JSM_BOARD_ROUTES_SET", () => $c82776b15970ab04$export$50c2d6bcb0b94b74);
const $c82776b15970ab04$export$a8aac2ba4dc1f57 = new Set([
    'classic-business-overview-summary',
    'classic-business-overview-calendar',
    'classic-business-overview-timeline',
    'classic-business-overview-redirect'
]);
const $c82776b15970ab04$export$c47bf667d3008c53 = new Set([
    'connect-project',
    'connect-general',
    'connect-general-service-desk-project',
    'legacy-connect-project',
    'legacy-connect-general'
]);
const $c82776b15970ab04$export$50c2d6bcb0b94b74 = new Set([
    'servicedesk-boards',
    'servicedesk-queues-views-config',
    'servicedesk-practice-views-config'
]);

});


parcelRegister("4gymV", function(module, exports) {

$parcel$export(module.exports, "getLinks", () => $6dc7ee8ba2a1371f$export$8054dcb2b42da45c);

var $83mn0 = parcelRequire("83mn0");

var $7NH5Y = parcelRequire("7NH5Y");
const $6dc7ee8ba2a1371f$export$8054dcb2b42da45c = (sidebarConfig, locations, { skipFilter: skipFilter, omitSections: omitSections } = {})=>{
    const acc = [];
    locations.forEach((location)=>{
        const links = (0, $83mn0.getLinksFromSidebar)(sidebarConfig, location);
        if (omitSections === true) {
            // merge 2 arrays in good performance way
            Array.prototype.push.apply(acc, links.flatMap((item)=>item && item.section === true ? item.links || [] : item));
            return;
        }
        // merge 2 arrays in good performance way
        Array.prototype.push.apply(acc, links);
    });
    return acc.filter((item)=>{
        if (!item) return false;
        if (skipFilter === true) return true;
        const hasConnectPrefix = item.id && item.id.includes((0, $7NH5Y.connectPrefix));
        if (hasConnectPrefix) return true;
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"sd-reports-addons" | "sd-queues-addons" | "com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent"'.
        const isConnectSection = (0, $7NH5Y.connectSections).includes(item.id);
        if (isConnectSection) return true;
        const isJsdConnectSection = item.id && item.id.includes((0, $7NH5Y.jsdConnectPrefix));
        if (isJsdConnectSection) return true;
        return false;
    });
};

});
parcelRegister("83mn0", function(module, exports) {

$parcel$export(module.exports, "hasItemInSidebar", () => $90215f5482fce08d$export$57dd40eec4c64521);
$parcel$export(module.exports, "getLinksFromSidebar", () => $90215f5482fce08d$export$9b7e0e4dd8bfade8);
const $90215f5482fce08d$var$findLink = (arrayOfLinks, legacyId, partialMatch = false)=>{
    if (!Array.isArray(arrayOfLinks)) return undefined;
    for(let i = 0; i < arrayOfLinks.length; i += 1){
        const link = arrayOfLinks[i];
        if (partialMatch && link.id.indexOf(legacyId) === 0) return link;
        if (link.id === legacyId) return link;
        if (link.links) {
            const linkFound = $90215f5482fce08d$var$findLink(link.links, legacyId, partialMatch);
            if (linkFound) return linkFound;
        }
    }
    return undefined;
};
const $90215f5482fce08d$export$f62346e9b1894488 = (sidebarConfig, legacyId, partialMatch = false)=>sidebarConfig && sidebarConfig.product && $90215f5482fce08d$var$findLink(sidebarConfig.product.links, legacyId, partialMatch) || undefined;
const $90215f5482fce08d$export$57dd40eec4c64521 = (sidebarConfig, legacyId, partialMatch)=>Boolean($90215f5482fce08d$export$f62346e9b1894488(sidebarConfig, legacyId, partialMatch));
const $90215f5482fce08d$var$findChildLinks = (arrayOfLinks, legacyId)=>arrayOfLinks && arrayOfLinks.map((item)=>{
        if (item.id === legacyId) return item.links;
        return item.links && $90215f5482fce08d$var$findChildLinks(item.links, legacyId);
    }).find(Boolean);
const $90215f5482fce08d$export$9b7e0e4dd8bfade8 = (sidebarConfig, legacyId)=>{
    const links = legacyId != null ? $90215f5482fce08d$var$findChildLinks(sidebarConfig.product && sidebarConfig.product.links, legacyId) : sidebarConfig.product && sidebarConfig.product.links;
    return links || [];
};

});

parcelRegister("7NH5Y", function(module, exports) {

$parcel$export(module.exports, "connectPrefix", () => $a36a125359bfc961$export$196d83ebd873fb40);
$parcel$export(module.exports, "jsdConnectPrefix", () => $a36a125359bfc961$export$7fac8f726f52d70);
$parcel$export(module.exports, "connectSections", () => $a36a125359bfc961$export$b1c2c1fc5d10280);

var $kvHKs = parcelRequire("kvHKs");
const $a36a125359bfc961$export$196d83ebd873fb40 = 'com.atlassian.plugins.atlassian-connect-plugin:';
const $a36a125359bfc961$export$7fac8f726f52d70 = 'com.atlassian.servicedesk.connect';
const $a36a125359bfc961$var$legacyAddonPanelLinkId = 'com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent';
const $a36a125359bfc961$var$jsdQueuesConnectSection = 'sd-queues-addons';
const $a36a125359bfc961$export$b1c2c1fc5d10280 = [
    $a36a125359bfc961$var$legacyAddonPanelLinkId,
    (0, $kvHKs.REPORTS_IDS).REPORTS_ADDONS,
    $a36a125359bfc961$var$jsdQueuesConnectSection
];

});


parcelRegister("5W6pd", function(module, exports) {

$parcel$export(module.exports, "transformLink", () => $1efacbf40a7b73c8$export$5a32dc366b1d641f);
$parcel$export(module.exports, "transformLinkV4", () => $1efacbf40a7b73c8$export$27267b6b6650eaa5);
const $1efacbf40a7b73c8$export$5a32dc366b1d641f = (link)=>{
    const items = link.links && link.links.length ? link.links.map($1efacbf40a7b73c8$export$5a32dc366b1d641f).filter(Boolean) : undefined;
    // section item
    if (link.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(link.name)
        };
        return {
            id: link.id,
            name: String(link.name),
            section: !!link.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: link.id,
        name: String(link.name),
        url: link.url,
        iconUrl: link.iconUrl || '',
        styleClass: link.styleClass || '',
        items: items
    };
};
const $1efacbf40a7b73c8$export$27267b6b6650eaa5 = (data)=>{
    const items = data.links && data.links.length ? data.links.map($1efacbf40a7b73c8$export$27267b6b6650eaa5).filter(Boolean) : undefined;
    // section item
    if (data.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(data.name)
        };
        return {
            id: data.id,
            name: String(data.name),
            section: !!data.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: data.id,
        name: String(data.name),
        url: data.url,
        iconUrl: data.iconUrl || '',
        styleClass: data.styleClass || '',
        items: items
    };
};

});


parcelRegister("gJkov", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $63e1d07edc3ef769$export$9df5fa0a366163d2);

var $83mn0 = parcelRequire("83mn0");
const $63e1d07edc3ef769$export$9df5fa0a366163d2 = (data, isDevMode, isAdmin)=>({
        hasGeneralConfiguration: isAdmin,
        hasDarkFeatures: (0, $83mn0.hasItemInSidebar)(data, 'dark_features'),
        hasTroubleshootingAndSupportSection: isAdmin,
        hasViewAuditing: isAdmin,
        hasPluginViewer: isDevMode && isAdmin,
        hasModulesViewer: isDevMode && isAdmin,
        hasSystemInfo: (0, $83mn0.hasItemInSidebar)(data, 'system_info'),
        hasIntegrityChecker: (0, $83mn0.hasItemInSidebar)(data, 'integrity_checker'),
        hasLoggingProfiling: (0, $83mn0.hasItemInSidebar)(data, 'logging_profiling'),
        hasSchedulerDetails: (0, $83mn0.hasItemInSidebar)(data, 'scheduler_details'),
        hasSecuritySection: isAdmin,
        hasProjectRoles: isAdmin,
        hasGlobalPermissions: isAdmin,
        hasCollectors: isAdmin,
        hasUserInterfaceSection: isAdmin,
        hasUserDefaults: isAdmin,
        hasEditDefaultDashboard: isAdmin,
        hasLookAndFeel: isAdmin,
        hasPasAdmin: (0, $83mn0.hasItemInSidebar)(data, 'com.atlassian.pas:pas-admin-link-jira'),
        hasImportExportSection: isAdmin,
        hasBackupManager: isAdmin,
        hasExternalImport: isAdmin,
        hasRestoreSystem: (0, $83mn0.hasItemInSidebar)(data, 'vertigo_import'),
        hasCloudImport: (0, $83mn0.hasItemInSidebar)(data, 'vertigo_import_jira_cloud'),
        hasServerImport: (0, $83mn0.hasItemInSidebar)(data, 'vertigo_import_jira_server'),
        hasMailSection: isAdmin,
        hasGlobalMailSettings: isAdmin,
        hasOutgoingMail: isAdmin,
        hasIncomingMail: isAdmin,
        hasSendMail: isAdmin,
        hasAdminHelperSection: isAdmin,
        hasPermissionHelper: isAdmin,
        hasSharedSection: isAdmin,
        hasManageDashboards: isAdmin,
        hasManageFilters: isAdmin,
        // advanced
        hasAdvancedSection: isAdmin,
        hasAttachments: isAdmin,
        hasEvents: isAdmin,
        hasWebHooks: isAdmin,
        hasServices: isAdmin,
        hasLexoRankManagement: (0, $83mn0.hasItemInSidebar)(data, 'greenhopper-lexorank-manage')
    });

});


parcelRegister("aVTmi", function(module, exports) {

$parcel$export(module.exports, "AdminHelperSection", () => $f6a1ba8c0486741e$export$4855b2d78f0d666a);

var $5uXOq = parcelRequire("5uXOq");

var $jZ4fr = parcelRequire("jZ4fr");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gjTBi = parcelRequire("gjTBi");
var $bWqXX = parcelRequire("bWqXX");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $17bH5 = parcelRequire("17bH5");

var $4OCke = parcelRequire("4OCke");

var $jMBA3 = parcelRequire("jMBA3");

var $3B8mV = parcelRequire("3B8mV");
const $f6a1ba8c0486741e$var$BLOCKING_INVITATIONS_LOG_SPOTLIGHT_KEY = 'blocking-invitations-log-spotlight';
const $f6a1ba8c0486741e$export$4855b2d78f0d666a = ()=>{
    const { data: features } = (0, $jMBA3.useFeatures)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const navigationPath = (0, $5uXOq.useMemo)(()=>(0, $17bH5.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: formatMessage((0, $3B8mV.default).adminHelper)
    }, features.hasPermissionHelper && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'permission-helper'
        },
        href: navigationPath.adminHelperPermissionHelper,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $3B8mV.default).permissionHelper)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: $f6a1ba8c0486741e$var$BLOCKING_INVITATIONS_LOG_SPOTLIGHT_KEY
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'email-notifications-log'
        },
        href: navigationPath.adminHelperEmailNotificationsLogHelper,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $f6a1ba8c0486741e$var$emailNotificationsLogContainerStyles
    }, formatMessage((0, $3B8mV.default).adminEmailAuditNotificationsLog))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZ4fr.EngagementSpotlight), {
        engagementId: $f6a1ba8c0486741e$var$BLOCKING_INVITATIONS_LOG_SPOTLIGHT_KEY
    })));
};
const $f6a1ba8c0486741e$var$emailNotificationsLogContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    justifyContent: 'space-between'
});

});
parcelRegister("3B8mV", function(module, exports) {

$parcel$export(module.exports, "default", () => $82b0a510e0e13823$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $82b0a510e0e13823$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    adminHelper: {
        "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.admin-helper",
        "defaultMessage": "Admin helper"
    },
    permissionHelper: {
        "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.permission-helper",
        "defaultMessage": "Permission helper"
    },
    adminEmailAuditNotificationsLog: {
        "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.admin-email-audit-notifications-log",
        "defaultMessage": "Admin email audit"
    }
});

});


parcelRegister("cip1u", function(module, exports) {

$parcel$export(module.exports, "AdvancedSection", () => $55fa8f6cf375a533$export$32bea920eaad7efb);

var $5uXOq = parcelRequire("5uXOq");

var $gjTBi = parcelRequire("gjTBi");
var $bWqXX = parcelRequire("bWqXX");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $17bH5 = parcelRequire("17bH5");

var $4OCke = parcelRequire("4OCke");

var $jMBA3 = parcelRequire("jMBA3");

var $68MUk = parcelRequire("68MUk");
const $55fa8f6cf375a533$export$32bea920eaad7efb = ()=>{
    const { data: features } = (0, $jMBA3.useFeatures)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const navigationPath = (0, $5uXOq.useMemo)(()=>(0, $17bH5.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: formatMessage((0, $68MUk.default).advanced)
    }, features.hasAttachments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'attachments'
        },
        href: navigationPath.advancedSectionAttachments,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $68MUk.default).attachments)), features.hasEvents && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'events'
        },
        href: navigationPath.advancedSectionEvents,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $68MUk.default).events)), features.hasWebHooks && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'webhooks'
        },
        href: navigationPath.advancedSectionWebHooks,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $68MUk.default).webhooks)), features.hasLexoRankManagement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'lexorank-management'
        },
        href: navigationPath.advancedLexoRankManagement,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $68MUk.default).lexorankManagement)));
};

});
parcelRegister("68MUk", function(module, exports) {

$parcel$export(module.exports, "default", () => $24a7ac619834e463$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $24a7ac619834e463$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    advanced: {
        "id": "spa-apps-sidebar-global-settings-system.menu.advanced.advanced",
        "defaultMessage": "Advanced"
    },
    attachments: {
        "id": "spa-apps-sidebar-global-settings-system.menu.advanced.attachments",
        "defaultMessage": "Attachments"
    },
    events: {
        "id": "spa-apps-sidebar-global-settings-system.menu.advanced.events",
        "defaultMessage": "Events"
    },
    webhooks: {
        "id": "spa-apps-sidebar-global-settings-system.menu.advanced.webhooks",
        "defaultMessage": "WebHooks"
    },
    lexorankManagement: {
        "id": "spa-apps-sidebar-global-settings-system.menu.advanced.lexorank-management",
        "defaultMessage": "LexoRank management"
    }
});

});


parcelRegister("8wyB3", function(module, exports) {

$parcel$export(module.exports, "AutomationSection", () => $ae233f5e809ec072$export$5fa01e4d25d8e6ec);

var $5uXOq = parcelRequire("5uXOq");

var $gjTBi = parcelRequire("gjTBi");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $17bH5 = parcelRequire("17bH5");

var $6tKa8 = parcelRequire("6tKa8");
const $ae233f5e809ec072$export$5fa01e4d25d8e6ec = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const navigationPath = (0, $5uXOq.useMemo)(()=>(0, $17bH5.getSystemNavigationPaths)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: formatMessage((0, $6tKa8.default).automationGroup)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'automation'
        },
        href: navigationPath.globalAutomation,
        selectedOn: [
            'global-automation'
        ]
    }, formatMessage((0, $6tKa8.default).globalAutomation)));
};

});
parcelRegister("6tKa8", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1b0e49ecb7c48dd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b1b0e49ecb7c48dd$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    automationGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.automation.automation-group",
        "defaultMessage": "Automation"
    },
    globalAutomation: {
        "id": "spa-apps-sidebar-global-settings-system.menu.automation.global-automation",
        "defaultMessage": "Global automation"
    }
});

});


parcelRegister("230Wm", function(module, exports) {

$parcel$export(module.exports, "ImportExportSection", () => $45f1c30d97953942$export$2e4cb1dc5b398447);

var $5uXOq = parcelRequire("5uXOq");

var $gjTBi = parcelRequire("gjTBi");
var $bWqXX = parcelRequire("bWqXX");

var $2vSU6 = parcelRequire("2vSU6");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $17bH5 = parcelRequire("17bH5");

var $4OCke = parcelRequire("4OCke");

var $9OXo1 = parcelRequire("9OXo1");

var $jMBA3 = parcelRequire("jMBA3");

var $8136S = parcelRequire("8136S");
const $45f1c30d97953942$export$2e4cb1dc5b398447 = ()=>{
    const { data: features } = (0, $jMBA3.useFeatures)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { licensedProducts: licensedProducts } = (0, $9OXo1.useTenantContext)();
    const navigationPath = (0, $5uXOq.useMemo)(()=>(0, $17bH5.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    const hasSupportedLicense = licensedProducts[(0, $2vSU6.projectTypeToCanonicalId)((0, $2vSU6.SOFTWARE_PROJECT))] || licensedProducts[(0, $2vSU6.projectTypeToCanonicalId)((0, $2vSU6.CORE_PROJECT))];
    const showNewExternalImport = hasSupportedLicense;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: formatMessage((0, $8136S.default).importExportGroup)
    }, features.hasBackupManager && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'cloud-export'
        },
        href: navigationPath.importSectionBackupManager,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $8136S.default).backupManager)), features.hasExternalImport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'external-import'
        },
        href: showNewExternalImport ? navigationPath.importSectionExternalImportNew : navigationPath.importSectionExternalImport,
        selectedOn: (currentLocation, itemLocation)=>(0, $4OCke.matchUrlExact)()(currentLocation, itemLocation) || showNewExternalImport && currentLocation.pathname.includes(navigationPath.importSectionExternalImport)
    }, formatMessage((0, $8136S.default).externalImport)), features.hasCloudImport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'cloud-import'
        },
        href: navigationPath.importSectionCloudImport,
        selectedOn: (0, $4OCke.matchUrlExact)()
    }, formatMessage((0, $8136S.default).importJiraCloud)), features.hasServerImport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'server-import'
        },
        href: navigationPath.importSectionServerImport,
        selectedOn: (0, $4OCke.matchUrlExact)()
    }, formatMessage((0, $8136S.default).importJiraServer)));
};

});
parcelRegister("8136S", function(module, exports) {

$parcel$export(module.exports, "default", () => $e31be53e6f399aac$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e31be53e6f399aac$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    importExportGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.import-export-group",
        "defaultMessage": "Import and export"
    },
    backupManager: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.backup-manager",
        "defaultMessage": "Backup manager"
    },
    externalImport: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.external-import",
        "defaultMessage": "External System Import"
    },
    restoreSystem: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.restore-system",
        "defaultMessage": "Restore system"
    },
    importJiraCloud: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.import-jira-cloud",
        "defaultMessage": "Import Jira Cloud"
    },
    importJiraServer: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.import-jira-server",
        "defaultMessage": "Import Jira Server"
    }
});

});


parcelRegister("je2KE", function(module, exports) {

$parcel$export(module.exports, "MailSection", () => $6a76fa07c85a01a9$export$6e0cda39522c0aa7);

var $5uXOq = parcelRequire("5uXOq");

var $gjTBi = parcelRequire("gjTBi");
var $bWqXX = parcelRequire("bWqXX");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $17bH5 = parcelRequire("17bH5");

var $4OCke = parcelRequire("4OCke");

var $jMBA3 = parcelRequire("jMBA3");

var $1c6JR = parcelRequire("1c6JR");

var $gb7H7 = parcelRequire("gb7H7");
const $6a76fa07c85a01a9$export$6e0cda39522c0aa7 = ()=>{
    const { data: features } = (0, $jMBA3.useFeatures)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const navigationPath = (0, $5uXOq.useMemo)(()=>(0, $17bH5.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: formatMessage((0, $1c6JR.default).mailGroup)
    }, features.hasGlobalMailSettings && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'global-mail-settings'
        },
        href: navigationPath.mailSectionGlobalMailSettings,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $1c6JR.default).globalMailSettings)), features.hasOutgoingMail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'outgoing-mail'
        },
        href: navigationPath.mailSectionOutgoingMail,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $1c6JR.default).outgoingMail)), features.hasIncomingMail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'incoming-mail'
        },
        href: navigationPath.mailSectionIncomingMail,
        selectedOn: (0, $gb7H7.isIncomingMailSelected)
    }, formatMessage((0, $1c6JR.default).incomingMail)), features.hasSendMail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'send-email'
        },
        href: navigationPath.mailSectionSendMail,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $1c6JR.default).sendEmail)));
};

});
parcelRegister("1c6JR", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa5900167b5101d6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fa5900167b5101d6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    mailGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.mail.mail-group",
        "defaultMessage": "Mail"
    },
    globalMailSettings: {
        "id": "spa-apps-sidebar-global-settings-system.menu.mail.global-mail-settings",
        "defaultMessage": "Global Mail Settings"
    },
    outgoingMail: {
        "id": "spa-apps-sidebar-global-settings-system.menu.mail.outgoing-mail",
        "defaultMessage": "Outgoing Mail"
    },
    incomingMail: {
        "id": "spa-apps-sidebar-global-settings-system.menu.mail.incoming-mail",
        "defaultMessage": "Incoming Mail"
    },
    sendEmail: {
        "id": "spa-apps-sidebar-global-settings-system.menu.mail.send-email",
        "defaultMessage": "Send email"
    }
});

});

parcelRegister("gb7H7", function(module, exports) {

$parcel$export(module.exports, "isIncomingMailSelected", () => $d695081436bd6a1d$export$3f53f72603975cb0);

var $4OCke = parcelRequire("4OCke");
const $d695081436bd6a1d$var$INCOMING_MAIL_PATH_REGEXP = /\/admin\/(\w+)Pop(Mail)?Server/i;
const $d695081436bd6a1d$export$3f53f72603975cb0 = (currentLocation, itemLocation)=>(0, $4OCke.matchUrlExact)()(currentLocation, itemLocation) || $d695081436bd6a1d$var$INCOMING_MAIL_PATH_REGEXP.test(currentLocation.pathname);

});


parcelRegister("iAlf2", function(module, exports) {

$parcel$export(module.exports, "default", () => $979d16a4bf22949b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $979d16a4bf22949b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    systemGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.system-group",
        "defaultMessage": "System settings"
    },
    generalConfiguration: {
        "id": "spa-apps-sidebar-global-settings-system.menu.general-configuration",
        "defaultMessage": "General configuration"
    },
    darkFeatures: {
        "id": "spa-apps-sidebar-global-settings-system.menu.dark-features",
        "defaultMessage": "Dark features"
    },
    issueCollectors: {
        "id": "spa-apps-sidebar-global-settings-system.menu.issue-collectors",
        "defaultMessage": "Issue collectors"
    },
    globalSettingsSystemSidebarLabel: {
        "id": "spa-apps-sidebar-global-settings-system.menu.global-settings-system-sidebar-label",
        "defaultMessage": "Sidebar"
    },
    issueCollectorsIssueTermRefresh: {
        "id": "spa-apps-sidebar-global-settings-system.menu.issue-collectors-issue-term-refresh",
        "defaultMessage": "Work item collectors"
    }
});

});

parcelRegister("fwlYA", function(module, exports) {

$parcel$export(module.exports, "SecuritySection", () => $76b3d515542acad4$export$4f16aec1633bed7d);

var $5uXOq = parcelRequire("5uXOq");

var $gjTBi = parcelRequire("gjTBi");
var $bWqXX = parcelRequire("bWqXX");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $17bH5 = parcelRequire("17bH5");

var $4OCke = parcelRequire("4OCke");

var $jMBA3 = parcelRequire("jMBA3");

var $eTPZ8 = parcelRequire("eTPZ8");

var $icmgW = parcelRequire("icmgW");
const $76b3d515542acad4$export$4f16aec1633bed7d = ()=>{
    const { data: features } = (0, $jMBA3.useFeatures)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const navigationPath = (0, $5uXOq.useMemo)(()=>(0, $17bH5.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    const globalPermissionsPath = navigationPath.securityGlobalPermissions;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: formatMessage((0, $eTPZ8.default).securityGroup)
    }, features.hasProjectRoles && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'project-roles'
        },
        href: navigationPath.securityProjectRoles,
        selectedOn: (0, $icmgW.isProjectRolesSelected)
    }, formatMessage((0, $eTPZ8.default).projectRoles)), features.hasGlobalPermissions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'global-permissions'
        },
        href: globalPermissionsPath,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $eTPZ8.default).globalPermissions)));
};

});
parcelRegister("eTPZ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $db51b59205472bbf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $db51b59205472bbf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    securityGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.security.security-group",
        "defaultMessage": "Security"
    },
    projectRoles: {
        "id": "spa-apps-sidebar-global-settings-system.menu.security.project-roles",
        "defaultMessage": "Project roles"
    },
    globalPermissions: {
        "id": "spa-apps-sidebar-global-settings-system.menu.security.global-permissions",
        "defaultMessage": "Global permissions"
    }
});

});

parcelRegister("icmgW", function(module, exports) {

$parcel$export(module.exports, "isProjectRolesSelected", () => $f6a84fa88243c239$export$ca9501e7fedfce90);

var $4OCke = parcelRequire("4OCke");
const $f6a84fa88243c239$var$PROJECT_ROLES_PATH_REGEXP = /\/project\/(\w+)ProjectRole/i;
const $f6a84fa88243c239$export$ca9501e7fedfce90 = (currentLocation, itemLocation)=>(0, $4OCke.matchUrlExact)()(currentLocation, itemLocation) || $f6a84fa88243c239$var$PROJECT_ROLES_PATH_REGEXP.test(currentLocation.pathname);

});


parcelRegister("9O5DC", function(module, exports) {

$parcel$export(module.exports, "SharedSection", () => $440640fab2704f98$export$230e518497f06fdc);

var $5uXOq = parcelRequire("5uXOq");

var $gjTBi = parcelRequire("gjTBi");
var $bWqXX = parcelRequire("bWqXX");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $17bH5 = parcelRequire("17bH5");

var $4OCke = parcelRequire("4OCke");

var $jMBA3 = parcelRequire("jMBA3");

var $hw0ew = parcelRequire("hw0ew");
const $440640fab2704f98$export$230e518497f06fdc = ()=>{
    const { data: features } = (0, $jMBA3.useFeatures)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const navigationPath = (0, $5uXOq.useMemo)(()=>(0, $17bH5.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: formatMessage((0, $hw0ew.default).sharedItems)
    }, features.hasManageFilters && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'manage-filters'
        },
        href: navigationPath.sharedSectionManageFilters,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $hw0ew.default).filters)), features.hasManageDashboards && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'manage-dashboards'
        },
        href: navigationPath.sharedManageDashboards,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $hw0ew.default).dashboards)));
};

});
parcelRegister("hw0ew", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a51482729945d2e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4a51482729945d2e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    sharedItems: {
        "id": "spa-apps-sidebar-global-settings-system.menu.shared.shared-items",
        "defaultMessage": "Shared Items"
    },
    sharedFilters: {
        "id": "spa-apps-sidebar-global-settings-system.menu.shared.shared-filters",
        "defaultMessage": "Shared filters"
    },
    sharedDashboards: {
        "id": "spa-apps-sidebar-global-settings-system.menu.shared.shared-dashboards",
        "defaultMessage": "Shared dashboards"
    },
    filters: {
        "id": "spa-apps-sidebar-global-settings-system.menu.shared.filters",
        "defaultMessage": "Filters"
    },
    dashboards: {
        "id": "spa-apps-sidebar-global-settings-system.menu.shared.dashboards",
        "defaultMessage": "Dashboards"
    }
});

});


parcelRegister("1y2CG", function(module, exports) {

$parcel$export(module.exports, "TroubleshootingAndSupportSection", () => $5fd448f06aadda25$export$dad01649916e6a2d);

var $5uXOq = parcelRequire("5uXOq");

var $gjTBi = parcelRequire("gjTBi");
var $bWqXX = parcelRequire("bWqXX");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $fRwoF = parcelRequire("fRwoF");

var $17bH5 = parcelRequire("17bH5");

var $4OCke = parcelRequire("4OCke");

var $jMBA3 = parcelRequire("jMBA3");

var $4oL80 = parcelRequire("4oL80");

var $81Iv5 = parcelRequire("81Iv5");

var $ie4oV = parcelRequire("ie4oV");
const $5fd448f06aadda25$export$dad01649916e6a2d = ()=>{
    const { data: features } = (0, $jMBA3.useFeatures)();
    const { hasSiteOptimizerEntitlement: hasSiteOptimizerEntitlement } = (0, $fRwoF.useSiteOptimizerCheck)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const navigationPath = (0, $5uXOq.useMemo)(()=>(0, $17bH5.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: formatMessage((0, $4oL80.default).troubleshootingGroup)
    }, features.hasViewAuditing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'view-auditing'
        },
        href: navigationPath.troubleshootingAuditLog,
        selectedOn: (0, $ie4oV.isViewAuditingSelected)
    }, formatMessage((0, $4oL80.default).auditLog)), features.hasPluginViewer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'plugin-viewer'
        },
        href: navigationPath.troubleshootingPluginViewer,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $4oL80.default).pluginViewer)), features.hasModulesViewer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'modules-viewer'
        },
        href: navigationPath.troubleshootingModulesViewer,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $4oL80.default).modulesViewer)), features.hasSystemInfo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'system-info'
        },
        href: navigationPath.troubleshootingSystemInfo,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $4oL80.default).systemInfo)), features.hasIntegrityChecker && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'integrity-checker'
        },
        href: navigationPath.troubleshootingIntegrityChecker,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $4oL80.default).integrityChecker)), features.hasLoggingProfiling && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'logging-profiling'
        },
        href: navigationPath.troubleshootingLoggingProfiling,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $4oL80.default).loggingProfiling)), features.hasSchedulerDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'scheduler-details'
        },
        href: navigationPath.troubleshootingSchedulerDetails,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $4oL80.default).schedulerDetails)), hasSiteOptimizerEntitlement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $81Iv5.PerformanceMenuItem), null));
};

});
parcelRegister("fRwoF", function(module, exports) {

$parcel$export(module.exports, "useSiteOptimizerCheck", () => $31e8f2ad3b3f051f$export$7df80afc329cd61);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");
const $31e8f2ad3b3f051f$export$e9921a980669184 = ()=>(0, $eusud.performGetRequest)('/rest/internal/psi/latest/licence/check');
const $31e8f2ad3b3f051f$export$7df80afc329cd61 = ()=>{
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const [hasEntitlement, setHasEntitlement] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)();
    const fetch = async ()=>{
        try {
            setLoading(true);
            setError(undefined);
            if ((0, $4R6GH.fg)('override-enable-performance-and-scale-admin-menu')) setHasEntitlement(true);
            else {
                const data = await $31e8f2ad3b3f051f$export$e9921a980669184();
                setHasEntitlement(data?.isVisible ?? false);
            }
            setLoading(false);
        } catch (apiError) {
            setLoading(false);
            setError(apiError);
        }
    };
    (0, $5uXOq.useEffect)(()=>{
        fetch();
    }, []);
    return {
        loading: loading,
        hasSiteOptimizerEntitlement: hasEntitlement,
        error: error
    };
};

});

parcelRegister("4oL80", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ca98bc392d099f0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9ca98bc392d099f0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    troubleshootingGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.troubleshooting-group",
        "defaultMessage": "Troubleshooting and Support"
    },
    auditLog: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.audit-log",
        "defaultMessage": "Audit Log"
    },
    pluginViewer: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.plugin-viewer",
        "defaultMessage": "Plugin Viewer"
    },
    modulesViewer: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.modules-viewer",
        "defaultMessage": "Modules Viewer"
    },
    systemInfo: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.system-info",
        "defaultMessage": "System info"
    },
    integrityChecker: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.integrity-checker",
        "defaultMessage": "Integrity checker"
    },
    loggingProfiling: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.logging-profiling",
        "defaultMessage": "Logging profiling"
    },
    schedulerDetails: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.scheduler-details",
        "defaultMessage": "Scheduler details"
    }
});

});

parcelRegister("81Iv5", function(module, exports) {

$parcel$export(module.exports, "PerformanceMenuItem", () => $ca611bfc0be59ae0$export$b4e98631ff0b3fb5);

var $5uXOq = parcelRequire("5uXOq");

var $aYAc3 = parcelRequire("aYAc3");

var $imZsD = parcelRequire("imZsD");
var $5Fk4Z = parcelRequire("5Fk4Z");
var $1QiBP = parcelRequire("1QiBP");

var $MHKc7 = parcelRequire("MHKc7");
var $bUmQV = parcelRequire("bUmQV");

var $koVbs = parcelRequire("koVbs");

var $kZj7F = parcelRequire("kZj7F");

var $17bH5 = parcelRequire("17bH5");

var $8zOmE = parcelRequire("8zOmE");

var $ehdJY = parcelRequire("ehdJY");

var $90yGq = parcelRequire("90yGq");

var $eaZ4X = parcelRequire("eaZ4X");

var $1ssva = parcelRequire("1ssva");

var $iWjQg = parcelRequire("iWjQg");

var $fM231 = parcelRequire("fM231");
const $ca611bfc0be59ae0$export$b4e98631ff0b3fb5 = ()=>{
    const accountId = (0, $90yGq.useAccountId)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOptimiserSpotlightActive, setIsOptimiserSpotlightActive] = (0, $5uXOq.useState)(false);
    const navigationPath = (0, $5uXOq.useMemo)(()=>(0, $17bH5.getSystemNavigationPaths)(), []);
    const BackMenuItem = {
        href: '/jira/settings/system/general-configuration',
        title: formatMessage((0, $1ssva.default).itemBack)
    };
    const fetchSpotlightState = (0, $5uXOq.useCallback)(async ()=>{
        if (accountId != null) {
            const response = await (0, $fM231.hasSeenSiteOptimiserSpotlight)(accountId);
            setIsOptimiserSpotlightActive(!response);
        }
    }, [
        accountId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        fetchSpotlightState();
    }, [
        fetchSpotlightState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "site-optimiser-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZj7F.NestingMenuItem), {
        analytics: {
            itemId: 'performance-and-scale'
        },
        href: navigationPath.troubleshootingPerformanceAndScale,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
            gap: "space.050",
            justifyContent: "start",
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), null, formatMessage((0, $1ssva.default).performanceAndScale)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
            appearance: "new"
        }, formatMessage((0, $1ssva.default).beta))),
        overrides: {
            BackMenuItem: BackMenuItem
        },
        id: (0, $eaZ4X.SECTION_ID).PERFORMANCE_AND_SCALE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iWjQg.PerformanceAndScaleMenu), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, isOptimiserSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        actions: [
            {
                onClick: (_, analyticsEvent)=>{
                    setIsOptimiserSpotlightActive(false);
                    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'performanceMenuItemSpotlightComplete');
                },
                text: formatMessage((0, $1ssva.default).spotlightAction)
            }
        ],
        heading: formatMessage((0, $1ssva.default).spotlightHeading),
        target: "site-optimiser-spotlight",
        key: "site-optimiser-spotlight",
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        dialogPlacement: "right top",
        messageId: "navigation-apps-sidebar-global-settings-system.ui.menu.troubleshooting-and-support.performance-menu-item.jira-spotlight.site-optimiser-spotlight",
        messageType: "engagement"
    }, formatMessage((0, $1ssva.default).spotlightBody))));
};

});
parcelRegister("1ssva", function(module, exports) {

$parcel$export(module.exports, "default", () => $46da0b37092f9f6a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $46da0b37092f9f6a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    performanceAndScale: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale",
        "defaultMessage": "Site optimizer"
    },
    itemBack: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.item-back",
        "defaultMessage": "Back to system"
    },
    spotlightHeading: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.spotlight-heading",
        "defaultMessage": "Clean up your site"
    },
    spotlightBody: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.spotlight-body",
        "defaultMessage": "Remove old data that might be slowing down your site in a few clicks."
    },
    spotlightAction: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.spotlight-action",
        "defaultMessage": "Ok"
    },
    beta: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.beta",
        "defaultMessage": "Beta"
    }
});

});

parcelRegister("iWjQg", function(module, exports) {

$parcel$export(module.exports, "PerformanceAndScaleMenu", () => $4bb22b80a7726eba$export$442d4ccb0d25fc50);

var $5uXOq = parcelRequire("5uXOq");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $gjTBi = parcelRequire("gjTBi");

var $lzUDm = parcelRequire("lzUDm");

var $fgWYz = parcelRequire("fgWYz");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $3OGaE = parcelRequire("3OGaE");

var $4OCke = parcelRequire("4OCke");

var $etuUp = parcelRequire("etuUp");

var $jWIOc = parcelRequire("jWIOc");
const $4bb22b80a7726eba$export$442d4ccb0d25fc50 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const basePerformanceUrl = '/jira/settings/system/performance';
    const allVisibleMetrics = (0, $fgWYz.getAllVisibleMetrics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OGaE.TitleHeader), null, formatMessage((0, $etuUp.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'performance-overview'
        },
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        href: `${basePerformanceUrl}/overview`
    }, formatMessage((0, $etuUp.default).overview))), allVisibleMetrics.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: formatMessage((0, $etuUp.default).allReports)
    }, allVisibleMetrics.map((metric)=>{
        if (metric.key === (0, $lzUDm.PROJECT_CLEANUP_KEY)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
            key: "project-cleanup-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
            name: (0, $jWIOc.PROJECT_CLEANUP_SPOTLIGHT_NAME)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
            analytics: {
                itemId: `performance-metric-${metric.key}`
            },
            href: `${basePerformanceUrl}/metrics/${metric.key}`,
            selectedOn: (0, $4OCke.matchUrlPathname)(),
            key: metric.key
        }, formatMessage(metric.name))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jWIOc.ProjectCleanupSpotlight), null));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
            analytics: {
                itemId: `performance-metric-${metric.key}`
            },
            href: `${basePerformanceUrl}/metrics/${metric.key}`,
            selectedOn: (0, $4OCke.matchUrlPathname)(),
            key: metric.key
        }, formatMessage(metric.name));
    })));
};

});
parcelRegister("lzUDm", function(module, exports) {

$parcel$export(module.exports, "PROJECT_CLEANUP_KEY", () => $3bfe695ee69b7be4$export$4e9bf1d386c2f0c);
$parcel$export(module.exports, "PROJECT_CLEANUP", () => $3bfe695ee69b7be4$export$761acf34bef3a717);

var $iHO6d = parcelRequire("iHO6d");
const $3bfe695ee69b7be4$export$4e9bf1d386c2f0c = 'projectcleanup';
const $3bfe695ee69b7be4$export$761acf34bef3a717 = {
    key: $3bfe695ee69b7be4$export$4e9bf1d386c2f0c,
    visible: true,
    name: (0, $iHO6d.default).nameNonFinal,
    description: (0, $iHO6d.default).descriptionNonFinal,
    tabLabels: [
        (0, $iHO6d.default).analysisNonFinal,
        (0, $iHO6d.default).activityLogNonFinal
    ],
    warningMessage: (0, $iHO6d.default).warningNonFinal,
    exceededMessage: (0, $iHO6d.default).exceededNonFinal,
    risks: [],
    mitigations: [],
    currentValueLabel: (0, $iHO6d.default).currentValueLabel,
    cleanupValueLabel: (0, $iHO6d.default).cleanupValueLabel,
    graphHeader: (0, $iHO6d.default).graphHeader,
    recommendationUrl: 'https://support.atlassian.com/jira-cloud-administration/docs/optimize-the-number-of-projects-in-your-site/',
    recommendationUrlText: (0, $iHO6d.default).recommendationUrlText
};

});
parcelRegister("iHO6d", function(module, exports) {

$parcel$export(module.exports, "default", () => $622f291bdb5f6890$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
// The following are the description for the translators for the different text that we need translating.
// Unfortunately, this needs to copied to individual files because the i18n text extraction tool needs
// to be able to resolve variables statically. This duplication is OK.
const $622f291bdb5f6890$var$NAME_DESC = 'Name of the site optimizer metric that will be used as the title on the page and menu item.';
const $622f291bdb5f6890$var$DESCRIPTION_DESC = 'Description of the site optimizer metric.';
const $622f291bdb5f6890$var$WARNING_DESC = 'Warning message if metric are getting close to the threshold.';
const $622f291bdb5f6890$var$EXCEEDED_DESC = 'Message to show to the user if metric has exceeded the threshold.';
const $622f291bdb5f6890$var$CURRENT_VALUE_LABEL_DESC = 'Label to be shown next to the current value of the metric.';
const $622f291bdb5f6890$var$CLEANUP_VALUE_LABEL_DESC = 'Label to be shown next to the cleanup value of the metric.';
const $622f291bdb5f6890$var$RECOMMENDATION_URL_TEXT_DESC = 'Text to be shown on the hypertext link to additional documentation.';
const $622f291bdb5f6890$var$GRAPH_HEADER_DESC = 'Text to be shown on the header of the metric graph.';
var $622f291bdb5f6890$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    nameNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.name-non-final",
        "defaultMessage": "Projects"
    },
    descriptionNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.description-non-final",
        "defaultMessage": "Below, we\u2019ve identified company-managed and team-managed projects in your site that can be archived or trashed because they contain no issues. Removing these projects can improve site performance and stability."
    },
    recommendationUrlText: {
        "id": "admin-pages-performance.common.assets.project-cleanup.recommendation-url-text",
        "defaultMessage": "See how we identify these projects."
    },
    analysisNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.analysis-non-final",
        "defaultMessage": "Analysis"
    },
    activityLogNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.activity-log-non-final",
        "defaultMessage": "Activity log"
    },
    graphHeader: {
        "id": "admin-pages-performance.common.assets.project-role-actor.graph-header",
        "defaultMessage": "Projects over time"
    },
    // Since we don't have a threshold, these messages below will be unused - keeping them purely to satisfy the Metric type
    // We should make this type more flexible in the future
    warningNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.warning-non-final",
        "defaultMessage": "The number of projects is nearing our recommended threshold."
    },
    exceededNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.exceeded-non-final",
        "defaultMessage": "There are some project..."
    },
    currentValueLabel: {
        "id": "admin-pages-performance.common.assets.project-cleanup.current-value-label",
        "defaultMessage": "Projects in your site"
    },
    cleanupValueLabel: {
        "id": "admin-pages-performance.common.assets.project-cleanup.cleanup-value-label",
        "defaultMessage": "Recommended for cleanup"
    }
});

});


parcelRegister("fgWYz", function(module, exports) {

$parcel$export(module.exports, "getAllVisibleMetrics", () => $2cc6642f29a0adee$export$e6140fda06493d18);
$parcel$export(module.exports, "getMetric", () => $2cc6642f29a0adee$export$ed0dc1178a679c67);
$parcel$export(module.exports, "getAllVisibleMetricKeys", () => $2cc6642f29a0adee$export$1f2abf3e170d35d2);
$parcel$export(module.exports, "assertNever", () => $2cc6642f29a0adee$export$cbadc5a7223772a8);
$parcel$export(module.exports, "TooltipMap", () => $2cc6642f29a0adee$export$9bd9f2d76c500145);

var $a4FfD = parcelRequire("a4FfD");

var $8MHQY = parcelRequire("8MHQY");

var $cOrKR = parcelRequire("cOrKR");

var $lzUDm = parcelRequire("lzUDm");

var $3AEMX = parcelRequire("3AEMX");

var $gtb9f = parcelRequire("gtb9f");
class $2cc6642f29a0adee$export$9419457073a1750 {
    constructor(metrics){
        this.metrics = metrics;
    }
    getMetric(key) {
        return this.metrics.find((m)=>m.key === key);
    }
    getAllVisibleMetrics() {
        return this.metrics.filter((metric)=>metric.visible && $2cc6642f29a0adee$var$mitigationEnabled(metric.key));
    }
    getAllVisibleMetricsKeys() {
        return $2cc6642f29a0adee$export$e6140fda06493d18().map((m)=>m.key);
    }
}
/**
 * Metric registry singleton. We should not be creating another registry.
 */ const $2cc6642f29a0adee$var$REGISTRY = new $2cc6642f29a0adee$export$9419457073a1750((0, $gtb9f.METRICS));
const $2cc6642f29a0adee$export$ed0dc1178a679c67 = $2cc6642f29a0adee$var$REGISTRY.getMetric.bind($2cc6642f29a0adee$var$REGISTRY);
const $2cc6642f29a0adee$export$e6140fda06493d18 = $2cc6642f29a0adee$var$REGISTRY.getAllVisibleMetrics.bind($2cc6642f29a0adee$var$REGISTRY);
const $2cc6642f29a0adee$export$1f2abf3e170d35d2 = $2cc6642f29a0adee$var$REGISTRY.getAllVisibleMetricsKeys.bind($2cc6642f29a0adee$var$REGISTRY);
const $2cc6642f29a0adee$var$mitigationEnabled = (metricKey)=>{
    switch(metricKey){
        case 0, $lzUDm.PROJECT_CLEANUP_KEY:
        case 0, $3AEMX.PROJECT_ROLE_ACTOR_KEY:
        case 0, $8MHQY.CUSTOM_FIELDS_KEY:
        case 0, $cOrKR.ISSUE_KEY:
            return true;
        default:
            return false;
    }
};
const $2cc6642f29a0adee$export$cbadc5a7223772a8 = (_, message)=>{
    throw new Error(message);
};
const $2cc6642f29a0adee$export$9bd9f2d76c500145 = {
    [(0, $8MHQY.CUSTOM_FIELDS_KEY)]: (0, $a4FfD.CustomFieldsTooltip)
};

});
parcelRegister("a4FfD", function(module, exports) {

$parcel$export(module.exports, "CustomFieldsTooltip", () => $dcdb15fd0fe38e4b$export$9a2f1f96cf156e26);

var $l5IZ6 = parcelRequire("l5IZ6");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $3JT92 = parcelRequire("3JT92");

var $MHKc7 = parcelRequire("MHKc7");

var $3bDjY = parcelRequire("3bDjY");
var $btzsC = parcelRequire("btzsC");

var $koVbs = parcelRequire("koVbs");

var $9TSwz = parcelRequire("9TSwz");
const $dcdb15fd0fe38e4b$var$CustomTooltip = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, ...rest }, ref)=>{
    return /*#__PURE__*/ $5uXOq.createElement((0, $btzsC.default), {
        ...rest,
        ref: ref,
        className: (0, $bwpsq.default)([
            $dcdb15fd0fe38e4b$var$styles.tooltipStyles
        ])
    }, children);
});
const $dcdb15fd0fe38e4b$export$9a2f1f96cf156e26 = ({ children: children, dataRef: dataRef, metricState: metricState })=>{
    const { resourceUsageMetricV2: metricUsageData } = (0, $8Uumt.useFragment)((0, $l5IZ6.default), dataRef);
    if (metricUsageData === null || metricUsageData === undefined) return null;
    const customFieldsCount = {
        globalScopedCustomFieldsCount: metricUsageData.globalScopedCustomFieldsCount,
        projectScopedCustomFieldsCount: metricUsageData.projectScopedCustomFieldsCount
    };
    const customFieldsCountLabels = {
        globalScopedCustomFieldsCountLabel: (0, $9TSwz.default).globalScopedCustomFieldsCountLabel,
        projectScopedCustomFieldsCountLabel: (0, $9TSwz.default).projectScopedCustomFieldsCountLabel,
        globalScopedCustomFieldsCountAriaLabel: (0, $9TSwz.default).globalScopedCustomFieldsCountAriaLabel,
        projectScopedCustomFieldsCountArialLabel: (0, $9TSwz.default).projectScopedCustomFieldsCountAriaLabel
    };
    return /*#__PURE__*/ $5uXOq.createElement((0, $3bDjY.default), {
        content: /*#__PURE__*/ $5uXOq.createElement($dcdb15fd0fe38e4b$var$CustomFieldsTooltipContent, {
            customFieldsCount: customFieldsCount,
            customFieldsCountLabels: customFieldsCountLabels,
            metricState: metricState
        }),
        component: $dcdb15fd0fe38e4b$var$CustomTooltip
    }, children);
};
const $dcdb15fd0fe38e4b$var$CustomFieldsTooltipContent = ({ customFieldsCount: customFieldsCount, customFieldsCountLabels: customFieldsCountLabels, metricState: metricState })=>{
    const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, $koVbs.default)();
    const { globalScopedCustomFieldsCount: globalScopedCustomFieldsCount, projectScopedCustomFieldsCount: projectScopedCustomFieldsCount } = customFieldsCount;
    const { globalScopedCustomFieldsCountLabel: globalScopedCustomFieldsCountLabel, projectScopedCustomFieldsCountLabel: projectScopedCustomFieldsCountLabel, globalScopedCustomFieldsCountAriaLabel: globalScopedCustomFieldsCountAriaLabel, projectScopedCustomFieldsCountArialLabel: projectScopedCustomFieldsCountArialLabel } = customFieldsCountLabels;
    return /*#__PURE__*/ $5uXOq.createElement((0, $MHKc7.default), {
        xcss: $dcdb15fd0fe38e4b$var$styles.numbersContainer
    }, globalScopedCustomFieldsCount != null && globalScopedCustomFieldsCountLabel && /*#__PURE__*/ $5uXOq.createElement((0, $MHKc7.default), {
        xcss: $dcdb15fd0fe38e4b$var$styles.numberContainer,
        tabIndex: 0,
        "aria-label": globalScopedCustomFieldsCountAriaLabel ? formatMessage(globalScopedCustomFieldsCountAriaLabel, {
            number: formatNumber(globalScopedCustomFieldsCount)
        }) : undefined
    }, /*#__PURE__*/ $5uXOq.createElement((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)(metricState === 'none' && $dcdb15fd0fe38e4b$var$styles.successNumber, metricState === 'warning' && $dcdb15fd0fe38e4b$var$styles.warningNumber, metricState === 'exceeded' && $dcdb15fd0fe38e4b$var$styles.errorNumber, $dcdb15fd0fe38e4b$var$styles.fontWeightStyles),
        "aria-describedby": "global-scoped-custom-fields-count-desc"
    }, formatNumber(globalScopedCustomFieldsCount)), /*#__PURE__*/ $5uXOq.createElement((0, $MHKc7.default), {
        xcss: $dcdb15fd0fe38e4b$var$styles.textContainer
    }, /*#__PURE__*/ $5uXOq.createElement("small", {
        id: "global-scoped-custom-fields-count-desc"
    }, formatMessage(globalScopedCustomFieldsCountLabel)))), projectScopedCustomFieldsCount != null && projectScopedCustomFieldsCountLabel && /*#__PURE__*/ $5uXOq.createElement((0, $MHKc7.default), {
        xcss: $dcdb15fd0fe38e4b$var$styles.numberContainer,
        tabIndex: 0,
        "aria-label": projectScopedCustomFieldsCountArialLabel ? formatMessage(projectScopedCustomFieldsCountArialLabel, {
            number: formatNumber(projectScopedCustomFieldsCount)
        }) : undefined
    }, /*#__PURE__*/ $5uXOq.createElement((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)(metricState === 'none' && $dcdb15fd0fe38e4b$var$styles.successNumber, metricState === 'warning' && $dcdb15fd0fe38e4b$var$styles.warningNumber, metricState === 'exceeded' && $dcdb15fd0fe38e4b$var$styles.errorNumber, $dcdb15fd0fe38e4b$var$styles.fontWeightStyles),
        "aria-describedby": "project-scoped-custom-fields-count-desc"
    }, formatNumber(projectScopedCustomFieldsCount)), /*#__PURE__*/ $5uXOq.createElement((0, $MHKc7.default), {
        xcss: $dcdb15fd0fe38e4b$var$styles.textContainer
    }, /*#__PURE__*/ $5uXOq.createElement("small", {
        id: "project-scoped-custom-fields-count-desc"
    }, formatMessage(projectScopedCustomFieldsCountLabel)))));
};
const $dcdb15fd0fe38e4b$var$styles = {
    numbersContainer: "_1e0c1txw _y3gn1h6o _1bsb1mjv _1bah1yb4 _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o",
    numberContainer: "_16jlidpf _1o9zidpf _i0dl1wug",
    successNumber: "_11c8nf1z _syazaqb7",
    warningNumber: "_11c8nf1z _syaz1q28",
    errorNumber: "_11c8nf1z _syaz9lu1",
    fontWeightStyles: "_k48p1pd9",
    textContainer: "_p12f1lit",
    tooltipStyles: "_2rkoiti9 _bfhk1j9a _syaz15cr _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _16qszucj"
};

});
parcelRegister("l5IZ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $51f76bd051a38e39$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7720db90ecfa6c4681831e9e06d103aa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $51f76bd051a38e39$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "metricKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "tooltipEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "tooltip_adminPagesPerformance_CustomFieldsTooltip",
    "selections": [
        {
            "condition": "tooltipEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "metricKey",
                            "variableName": "metricKey"
                        }
                    ],
                    "kind": "LinkedField",
                    "name": "resourceUsageMetricV2",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "globalScopedCustomFieldsCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectScopedCustomFieldsCount"
                                }
                            ],
                            "type": "JiraCustomFieldUsageMetric"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraQuery"
};
$51f76bd051a38e39$var$node.hash = "e6113bc43303a707291b62cbe6c2b46f";
var $51f76bd051a38e39$export$2e2bcd8739ae039 = $51f76bd051a38e39$var$node;

});

parcelRegister("9TSwz", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb4cda92a9b67081$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
// The following are the description for the translators for the different text that we need translating.
// Unfortunately, this needs to copied to individual files because the i18n text extraction tool needs
// to be able to resolve variables statically. This duplication is OK.
const $eb4cda92a9b67081$var$NAME_DESC = 'Name of the site optimizer metric that will be used as the title on the page and menu item.';
const $eb4cda92a9b67081$var$DESCRIPTON_DESC = 'Description of the site optimizer metric.';
const $eb4cda92a9b67081$var$CHART_DESC = 'A tab label of Custom Field Tabs, to show custom fields chart';
const $eb4cda92a9b67081$var$REVIEW_AND_ANALYZE_DESC = 'A tab label of Custom Field Tabs, to show custom fields review and analyze';
const $eb4cda92a9b67081$var$WARNING_DESC = 'Warning message if metric are getting close to the threshold.';
const $eb4cda92a9b67081$var$EXCEEDED_DESC = 'Message to show to the user if metric has exceeded the threshold.';
const $eb4cda92a9b67081$var$RISK_DESC = 'One of the risks when this metric exceeded the threshold.';
const $eb4cda92a9b67081$var$MITIGATION_DESC = 'One of the mitigation options when this metric exceeded the threshold.';
const $eb4cda92a9b67081$var$CURRENT_VALUE_LABEL_DESC = 'Label to be shown next to the current value of the metric.';
const $eb4cda92a9b67081$var$THRESHOLD_VALUE_LABEL_DESC = 'Label to be shown next to the threshold value of the metric.';
const $eb4cda92a9b67081$var$RECOMMENDATION_URL_TEXT_DESC = 'Text to be shown on the hypertext link to additional documentation.';
const $eb4cda92a9b67081$var$GRAPH_HEADER_DESC = 'Text to be shown on the header of the metric graph.';
var $eb4cda92a9b67081$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    name: {
        "id": "admin-pages-performance.common.assets.custom-fields.name",
        "defaultMessage": "Custom fields"
    },
    description: {
        "id": "admin-pages-performance.common.assets.custom-fields.description",
        "defaultMessage": "Here are the custom fields in your site, including ones we think can be removed because they\u2019re not used. Removing unused fields could improve site performance and stability."
    },
    chart: {
        "id": "admin-pages-performance.common.assets.custom-fields.chart",
        "defaultMessage": "Overview"
    },
    reviewAndAnalyze: {
        "id": "admin-pages-performance.common.assets.custom-fields.review-and-analyze",
        "defaultMessage": "Analysis"
    },
    warning: {
        "id": "admin-pages-performance.common.assets.custom-fields.warning",
        "defaultMessage": "The number of custom fields is nearing our recommended threshold."
    },
    exceeded: {
        "id": "admin-pages-performance.common.assets.custom-fields.exceeded",
        "defaultMessage": "There are more custom fields than our recommended threshold."
    },
    risk1: {
        "id": "admin-pages-performance.common.assets.custom-fields.risk-1",
        "defaultMessage": "Custom fields can make searching for issues (JQL and boards) and creating issues slow."
    },
    mitigation1: {
        "id": "admin-pages-performance.common.assets.custom-fields.mitigation-1",
        "defaultMessage": "Edit the context for the custom field to make it visible only for specific projects."
    },
    mitigation2: {
        "id": "admin-pages-performance.common.assets.custom-fields.mitigation-2",
        "defaultMessage": "Limit the number of custom fields across all projects and use the same custom field in multiple projects."
    },
    currentValueLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.current-value-label",
        "defaultMessage": "Custom fields in your site"
    },
    thresholdValueLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.threshold-value-label",
        "defaultMessage": "Recommended maximum number of custom fields"
    },
    globalScopedCustomFieldsCountLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.global-scoped-custom-fields-count-label",
        "defaultMessage": "CMP custom fields count"
    },
    projectScopedCustomFieldsCountLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.project-scoped-custom-fields-count-label",
        "defaultMessage": "TMP custom fields count"
    },
    currentValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.current-value-aria-label",
        "defaultMessage": "{number} custom fields in your site"
    },
    thresholdValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.threshold-value-aria-label",
        "defaultMessage": "{number} recommended maximum number of custom fields"
    },
    globalScopedCustomFieldsCountAriaLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.global-scoped-custom-fields-count-aria-label",
        "defaultMessage": "{number} {number, plural, one {global scoped custom field} other {global scoped custom fields}}"
    },
    projectScopedCustomFieldsCountAriaLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.project-scoped-custom-fields-count-aria-label",
        "defaultMessage": "{number} {number, plural, one {project scoped custom field} other {global scoped custom fields}}"
    },
    recommendationUrlText: {
        "id": "admin-pages-performance.common.assets.custom-fields.recommendation-url-text",
        "defaultMessage": "See how we identify these fields."
    },
    graphHeader: {
        "id": "admin-pages-performance.common.assets.custom-fields.graph-header",
        "defaultMessage": "Custom fields over time"
    },
    risk1IssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.custom-fields.risk-1-issue-term-refresh",
        "defaultMessage": "Custom fields can make searching (JQL and boards) and creating work items slow."
    }
});

});


parcelRegister("8MHQY", function(module, exports) {

$parcel$export(module.exports, "CUSTOM_FIELDS_KEY", () => $1dd393ebccb36050$export$d214286a7039b004);
$parcel$export(module.exports, "CUSTOM_FIELDS", () => $1dd393ebccb36050$export$459112111ad5b136);

var $9TSwz = parcelRequire("9TSwz");
const $1dd393ebccb36050$export$d214286a7039b004 = 'customField';
const $1dd393ebccb36050$export$459112111ad5b136 = {
    key: $1dd393ebccb36050$export$d214286a7039b004,
    visible: true,
    name: (0, $9TSwz.default).name,
    description: (0, $9TSwz.default).description,
    tabLabels: [
        (0, $9TSwz.default).chart,
        (0, $9TSwz.default).reviewAndAnalyze
    ],
    warningMessage: (0, $9TSwz.default).warning,
    exceededMessage: (0, $9TSwz.default).exceeded,
    risks: [
        (0, $9TSwz.default).risk1
    ],
    mitigations: [],
    currentValueLabel: (0, $9TSwz.default).currentValueLabel,
    currentValueAriaLabel: (0, $9TSwz.default).currentValueAriaLabel,
    thresholdValueLabel: (0, $9TSwz.default).thresholdValueLabel,
    thresholdValueAriaLabel: (0, $9TSwz.default).thresholdValueAriaLabel,
    recommendationUrl: 'https://support.atlassian.com/jira-cloud-administration/docs/optimize-your-custom-fields/',
    recommendationUrlText: (0, $9TSwz.default).recommendationUrlText,
    graphHeader: (0, $9TSwz.default).graphHeader,
    showTooltip: true
};

});

parcelRegister("cOrKR", function(module, exports) {

$parcel$export(module.exports, "ISSUE_KEY", () => $a0748d951ae09b9b$export$5daa28d10e23592);
$parcel$export(module.exports, "ISSUE", () => $a0748d951ae09b9b$export$76a449e52fa0e1e8);

var $jWT6h = parcelRequire("jWT6h");
const $a0748d951ae09b9b$export$5daa28d10e23592 = 'issue';
const $a0748d951ae09b9b$export$76a449e52fa0e1e8 = {
    key: $a0748d951ae09b9b$export$5daa28d10e23592,
    visible: true,
    name: (0, $jWT6h.default).name,
    description: (0, $jWT6h.default).description,
    tabLabels: [
        (0, $jWT6h.default).reviewAndAnalyze,
        (0, $jWT6h.default).activityLog
    ],
    warningMessage: (0, $jWT6h.default).warning,
    exceededMessage: (0, $jWT6h.default).exceeded,
    risks: [
        (0, $jWT6h.default).risk1
    ],
    mitigations: [
        (0, $jWT6h.default).mitigation1,
        (0, $jWT6h.default).mitigation2,
        (0, $jWT6h.default).mitigation3
    ],
    currentValueLabel: (0, $jWT6h.default).currentValueLabel,
    currentValueAriaLabel: (0, $jWT6h.default).currentValueAriaLabel,
    thresholdValueLabel: (0, $jWT6h.default).thresholdValueLabel,
    thresholdValueAriaLabel: (0, $jWT6h.default).thresholdValueAriaLabel,
    graphHeader: (0, $jWT6h.default).graphHeader
};

});
parcelRegister("jWT6h", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5991724b8695ea5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
// The following are the description for the translators for the different text that we need translating.
// Unfortunately, this needs to copied to individual files because the i18n text extraction tool needs
// to be able to resolve variables statically. This duplication is OK.
const $a5991724b8695ea5$var$NAME_DESC = 'Name of the site optimizer metric that will be used as the title on the page and menu item.';
const $a5991724b8695ea5$var$DESCRIPTON_DESC = 'Description of the site optimizer metric.';
const $a5991724b8695ea5$var$CHART_DESC = 'A tab label of Issue Tabs, to show Issue chart';
const $a5991724b8695ea5$var$REVIEW_AND_ANALYZE_DESC = 'A tab label of Issue Tabs, to show issue review and analyze';
const $a5991724b8695ea5$var$WARNING_DESC = 'Warning message if metric are getting close to the threshold.';
const $a5991724b8695ea5$var$EXCEEDED_DESC = 'Message to show to the user if metric has exceeded the threshold.';
const $a5991724b8695ea5$var$RISK_DESC = 'One of the risks when this metric exceeded the threshold.';
const $a5991724b8695ea5$var$MITIGATION_DESC = 'One of the mitigation options when this metric exceeded the threshold.';
const $a5991724b8695ea5$var$CURRENT_VALUE_LABEL_DESC = 'Label to be shown next to the current value of the metric.';
const $a5991724b8695ea5$var$THRESHOLD_VALUE_LABEL_DESC = 'Label to be shown next to the threshold value of the metric.';
const $a5991724b8695ea5$var$ACTIVITY_LOG_DESC = 'A tab label of Activity Log Tabs, to show Issue Archival past operations';
const $a5991724b8695ea5$var$GRAPH_HEADER_DESC = 'Text to be shown on the header of the metric graph.';
var $a5991724b8695ea5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    name: {
        "id": "admin-pages-performance.common.assets.issue.name",
        "defaultMessage": "Issues"
    },
    description: {
        "id": "admin-pages-performance.common.assets.issue.description",
        "defaultMessage": "Here\u2019s a quick snapshot of the total number of issues in your site, including some that we think can be archived. Archiving unused issues can improve performance and stability of your site."
    },
    chart: {
        "id": "admin-pages-performance.common.assets.issue.chart",
        "defaultMessage": "Overview"
    },
    reviewAndAnalyze: {
        "id": "admin-pages-performance.common.assets.issue.review-and-analyze",
        "defaultMessage": "Analysis"
    },
    activityLog: {
        "id": "admin-pages-performance.common.assets.issue.activity-log",
        "defaultMessage": "Activity log"
    },
    warning: {
        "id": "admin-pages-performance.common.assets.issue.warning",
        "defaultMessage": "The number of issues in the system is nearing our recommended threshold."
    },
    exceeded: {
        "id": "admin-pages-performance.common.assets.issue.exceeded",
        "defaultMessage": "There are more issues in the system than our recommended threshold."
    },
    risk1: {
        "id": "admin-pages-performance.common.assets.issue.risk-1",
        "defaultMessage": "If you have too many issues you may find searches, automations, and workflow rules are slower than usual."
    },
    mitigation1: {
        "id": "admin-pages-performance.common.assets.issue.mitigation-1",
        "defaultMessage": "Delete any projects that are no longer required."
    },
    mitigation2: {
        "id": "admin-pages-performance.common.assets.issue.mitigation-2",
        "defaultMessage": "Disable Jira integrations that create issues you don't need."
    },
    mitigation3: {
        "id": "admin-pages-performance.common.assets.issue.mitigation-3",
        "defaultMessage": "Delete old issues that are no longer required. Use a JQL query to find issues older than a year (\u201Ccreated < -365d order by created DESC\u201C)."
    },
    currentValueLabel: {
        "id": "admin-pages-performance.common.assets.issue.current-value-label",
        "defaultMessage": "Total current issues in your site"
    },
    thresholdValueLabel: {
        "id": "admin-pages-performance.common.assets.issue.threshold-value-label",
        "defaultMessage": "Recommended maximum number of issues"
    },
    currentValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.issue.current-value-aria-label",
        "defaultMessage": "{number} total current issues in your site"
    },
    thresholdValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.issue.threshold-value-aria-label",
        "defaultMessage": "{number} recommended maximum number of issues"
    },
    graphHeader: {
        "id": "admin-pages-performance.common.assets.issue.graph-header",
        "defaultMessage": "Issues over time"
    },
    nameIssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.issue.name-issue-term-refresh",
        "defaultMessage": "Work items"
    },
    warningIssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.issue.warning-issue-term-refresh",
        "defaultMessage": "The number of work items in the system is nearing our recommended threshold."
    },
    exceededIssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.issue.exceeded-issue-term-refresh",
        "defaultMessage": "There are more work items in the system than our recommended threshold."
    },
    risk1IssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.issue.risk-1-issue-term-refresh",
        "defaultMessage": "If you have too many work items you may find searches, automations, and workflow rules are slower than usual."
    },
    mitigation2IssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.issue.mitigation-2-issue-term-refresh",
        "defaultMessage": "Disable Jira integrations that create work items you don't need"
    },
    mitigation3IssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.issue.mitigation-3-issue-term-refresh",
        "defaultMessage": "Delete old work items that are no longer required. Use a JQL query to find work items older than a year (\u201Ccreated < -365d order by created DESC\u201C)."
    },
    currentValueLabelIssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.issue.current-value-label-issue-term-refresh",
        "defaultMessage": "Total current work items in your site"
    },
    thresholdValueLabelIssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.issue.threshold-value-label-issue-term-refresh",
        "defaultMessage": "Recommended maximum number of work items"
    },
    currentValueAriaLabelIssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.issue.current-value-aria-label-issue-term-refresh",
        "defaultMessage": "{number} total current work items in your site"
    },
    thresholdValueAriaLabelIssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.issue.threshold-value-aria-label-issue-term-refresh",
        "defaultMessage": "{number} recommended maximum number of work items"
    },
    graphHeaderIssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.issue.graph-header-issue-term-refresh",
        "defaultMessage": "Work items over time"
    }
});

});


parcelRegister("3AEMX", function(module, exports) {

$parcel$export(module.exports, "PROJECT_ROLE_ACTOR_KEY", () => $c7627c0e6530f4b1$export$a570ca3f6cc5e280);
$parcel$export(module.exports, "PROJECT_ROLE_ACTOR", () => $c7627c0e6530f4b1$export$fc3d2ee6c3fb3908);

var $j0D55 = parcelRequire("j0D55");
const $c7627c0e6530f4b1$export$a570ca3f6cc5e280 = 'projectroleactor';
const $c7627c0e6530f4b1$export$fc3d2ee6c3fb3908 = {
    key: $c7627c0e6530f4b1$export$a570ca3f6cc5e280,
    visible: true,
    name: (0, $j0D55.default).name,
    description: (0, $j0D55.default).description,
    tabLabels: [
        (0, $j0D55.default).analysis,
        (0, $j0D55.default).activityLog
    ],
    warningMessage: (0, $j0D55.default).warning,
    exceededMessage: (0, $j0D55.default).exceeded,
    risks: [
        (0, $j0D55.default).risk1
    ],
    mitigations: [
        (0, $j0D55.default).mitigation1,
        (0, $j0D55.default).mitigation2,
        (0, $j0D55.default).mitigation3
    ],
    currentValueLabel: (0, $j0D55.default).currentValueLabel,
    currentValueAriaLabel: (0, $j0D55.default).currentValueAriaLabel,
    thresholdValueLabel: (0, $j0D55.default).thresholdValueLabel,
    thresholdValueAriaLabel: (0, $j0D55.default).thresholdValueAriaLabel,
    recommendationUrl: 'https://support.atlassian.com/jira-cloud-administration/docs/optimize-your-number-of-project-role-memberships/',
    recommendationUrlText: (0, $j0D55.default).recommendationUrlText,
    graphHeader: (0, $j0D55.default).graphHeader
};

});
parcelRegister("j0D55", function(module, exports) {

$parcel$export(module.exports, "default", () => $6549fa32a8352dcb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
// The following are the description for the translators for the different text that we need translating.
// Unfortunately, this needs to copied to individual files because the i18n text extraction tool needs
// to be able to resolve variables statically.
const $6549fa32a8352dcb$var$NAME_DESC = 'Name of the site optimizer metric that will be used as the title on the page and menu item.';
const $6549fa32a8352dcb$var$DESCRIPTON_DESC = 'Description of the site optimizer metric.';
const $6549fa32a8352dcb$var$WARNING_DESC = 'Warning message if metric are getting close to the threshold.';
const $6549fa32a8352dcb$var$EXCEEDED_DESC = 'Message to show to the user if metric has exceeded the threshold.';
const $6549fa32a8352dcb$var$RISK_DESC = 'One of the risks when this metric exceeded the threshold.';
const $6549fa32a8352dcb$var$MITIGATION_DESC = 'One of the mitigation options when this metric exceeded the threshold.';
const $6549fa32a8352dcb$var$CURRENT_VALUE_LABEL_DESC = 'Label to be shown next to the current value of the metric.';
const $6549fa32a8352dcb$var$THRESHOLD_VALUE_LABEL_DESC = 'Label to be shown next to the threshold value of the metric.';
const $6549fa32a8352dcb$var$RECOMMENDATION_URL_TEXT_DESC = 'Text to be shown on the hypertext link to additional documentation.';
const $6549fa32a8352dcb$var$GRAPH_HEADER_DESC = 'Text to be shown on the header of the metric graph.';
var $6549fa32a8352dcb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    name: {
        "id": "admin-pages-performance.common.assets.project-role-actor.name",
        "defaultMessage": "Project role permissions"
    },
    description: {
        "id": "admin-pages-performance.common.assets.project-role-actor.description",
        "defaultMessage": "Here's a quick snapshot of the total number of project role permissions across your site."
    },
    analysis: {
        "id": "admin-pages-performance.common.assets.project-role-actor.analysis",
        "defaultMessage": "Analysis"
    },
    activityLog: {
        "id": "admin-pages-performance.common.assets.project-role-actor.activity-log",
        "defaultMessage": "Activity log"
    },
    warning: {
        "id": "admin-pages-performance.common.assets.project-role-actor.warning",
        "defaultMessage": "Your number of project role memberships is nearing the recommended threshold."
    },
    exceeded: {
        "id": "admin-pages-performance.common.assets.project-role-actor.exceeded",
        "defaultMessage": "Your number of project role memberships is over the recommended threshold."
    },
    risk1: {
        "id": "admin-pages-performance.common.assets.project-role-actor.risk-1",
        "defaultMessage": "When the number of project role memberships (users or groups) increases, viewing, searching, and creating issues becomes slower."
    },
    mitigation1: {
        "id": "admin-pages-performance.common.assets.project-role-actor.mitigation-1",
        "defaultMessage": "Remove users who no longer need access to your site rather than only suspending them. Suspending users removes their permission but not their project role membership."
    },
    mitigation2: {
        "id": "admin-pages-performance.common.assets.project-role-actor.mitigation-2",
        "defaultMessage": "Give memberships to groups of users instead of individual users. Granting membership to a group of 50 users count as 1 membership whereas granting memberships to 50 single users counts as 50 memberships."
    },
    mitigation3: {
        "id": "admin-pages-performance.common.assets.project-role-actor.mitigation-3",
        "defaultMessage": "Use the default project role members in your permission scheme."
    },
    currentValueLabel: {
        "id": "admin-pages-performance.common.assets.project-role-actor.current-value-label",
        "defaultMessage": "Current project role permissions in your site"
    },
    thresholdValueLabel: {
        "id": "admin-pages-performance.common.assets.project-role-actor.threshold-value-label",
        "defaultMessage": "Recommended maximum number of permissions"
    },
    currentValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.project-role-actor.current-value-aria-label",
        "defaultMessage": "{number} current project role permissions in your site"
    },
    thresholdValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.project-role-actor.threshold-value-aria-label",
        "defaultMessage": "{number} recommended maximum number of permissions"
    },
    recommendationUrlText: {
        "id": "admin-pages-performance.common.assets.project-role-actor.recommendation-url-text",
        "defaultMessage": "Learn more about optimizing your project role memberships."
    },
    graphHeader: {
        "id": "admin-pages-performance.common.assets.project-role-actor.graph-header",
        "defaultMessage": "Project role permissions over time"
    }
});

});


parcelRegister("gtb9f", function(module, exports) {

$parcel$export(module.exports, "METRICS", () => $713364f722667f6e$export$3f0e99ae6e0ec541);
$parcel$export(module.exports, "RUN_ANALYSIS", () => $713364f722667f6e$export$769b1a9477352cf9);
$parcel$export(module.exports, "DELETE_RECOMMENDATIONS", () => $713364f722667f6e$export$e7e31b14c32e055a);
$parcel$export(module.exports, "DELETE_RECOMMENDATIONS_DROPDOWN", () => $713364f722667f6e$export$d96fe00ff2b38bae);
$parcel$export(module.exports, "DELETE_RECOMMENDATIONS_CONFIRM", () => $713364f722667f6e$export$3d4bb5f187c6844e);
$parcel$export(module.exports, "DELETE_RECOMMENDATIONS_CANCEL", () => $713364f722667f6e$export$5c1079e323f5d5bd);
$parcel$export(module.exports, "TAB_CLICKED", () => $713364f722667f6e$export$d358fc12daa9f606);
$parcel$export(module.exports, "RECOMMENDATIONS_LOADED", () => $713364f722667f6e$export$60cc0c61c99a5b81);
$parcel$export(module.exports, "METRIC_CARD_CLICKED", () => $713364f722667f6e$export$71794f4d197278dc);
$parcel$export(module.exports, "PROJECT_ROLE_ACTOR_FILTER_BY_PROJECT", () => $713364f722667f6e$export$9e34afbf86922b4a);
$parcel$export(module.exports, "projectRoleActorAttributes", () => $713364f722667f6e$export$d6761557c91eea50);
$parcel$export(module.exports, "ARCHIVE_ISSUES_CONFIRM", () => $713364f722667f6e$export$4e4b9391f7936ba2);
$parcel$export(module.exports, "RESTORE_ARCHIVE_ISSUES", () => $713364f722667f6e$export$70525d18051240f4);
$parcel$export(module.exports, "RESTORE_ARCHIVE_ISSUES_CANCEL", () => $713364f722667f6e$export$4951e0e034b50b9c);
$parcel$export(module.exports, "RESTORE_ARCHIVE_ISSUES_TRY_AGAIN", () => $713364f722667f6e$export$108288df7758f60c);
$parcel$export(module.exports, "VIEW_ISSUES", () => $713364f722667f6e$export$972d5a8da0d9f4c3);
$parcel$export(module.exports, "STOP_ISSUE_ARCHIVAL", () => $713364f722667f6e$export$b920363d50bcf753);
$parcel$export(module.exports, "ISSUE_UNARCHIVAL_COMPLETED", () => $713364f722667f6e$export$a84a5210fbad774);
$parcel$export(module.exports, "JQL_SEARCH", () => $713364f722667f6e$export$5c2df36fdd8476f7);
$parcel$export(module.exports, "DEFAULT_QUERY_SELECTED", () => $713364f722667f6e$export$77f23f1b921d5321);
$parcel$export(module.exports, "issueAnalyticsAttributes", () => $713364f722667f6e$export$c62a52f3f7d80ec3);
$parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_TRASH", () => $713364f722667f6e$export$8daffc99348bf555);
$parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_TRASH_CONFIRM", () => $713364f722667f6e$export$20f13a04bc3e5d74);
$parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_TRASH_CANCEL", () => $713364f722667f6e$export$ed285e0e924b673c);
$parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_SUCCEEDED", () => $713364f722667f6e$export$26f5d7eae10db511);
$parcel$export(module.exports, "customFieldAttributes", () => $713364f722667f6e$export$33989f74b6ba0674);
$parcel$export(module.exports, "METRICS_SPOTLIGHT_STARTED", () => $713364f722667f6e$export$d39b24a650c6c79d);
$parcel$export(module.exports, "METRICS_SPOTLIGHT_DISMISSED", () => $713364f722667f6e$export$eca4028936acf763);
$parcel$export(module.exports, "METRICS_SPOTLIGHT_COMPLETED", () => $713364f722667f6e$export$9ba0a5caedb0ff37);
$parcel$export(module.exports, "RESTORE_ACTIVITY_LOG", () => $713364f722667f6e$export$7b6bf63452d40db8);
$parcel$export(module.exports, "DOWNLOAD_CSV", () => $713364f722667f6e$export$efdb93c7210090d1);
$parcel$export(module.exports, "PROJECT_CLEANUP_FILTERS_CLEARED", () => $713364f722667f6e$export$6c650be5c2b4774f);
$parcel$export(module.exports, "PROJECT_CLEANUP_FILTER_BY_PROJECT", () => $713364f722667f6e$export$6493dd0e190d3f58);
$parcel$export(module.exports, "PROJECT_CLEANUP_FILTER_BY_STALE", () => $713364f722667f6e$export$422673ba1cec4aed);
$parcel$export(module.exports, "PROJECT_CLEAN_UP", () => $713364f722667f6e$export$3a7186fc63c9e188);
$parcel$export(module.exports, "PROJECT_CLEANUP_COMPLETED", () => $713364f722667f6e$export$8e0b8859a3cbd9e6);
$parcel$export(module.exports, "ACTION_TRASH", () => $713364f722667f6e$export$342d8b9804e407c7);
$parcel$export(module.exports, "ACTION_ARCHIVE", () => $713364f722667f6e$export$b685f2109baf2b4f);
$parcel$export(module.exports, "ACTION_UNARCHIVE", () => $713364f722667f6e$export$3ac60b381ed426ca);

var $8MHQY = parcelRequire("8MHQY");

var $cOrKR = parcelRequire("cOrKR");

var $lzUDm = parcelRequire("lzUDm");

var $3AEMX = parcelRequire("3AEMX");
const $713364f722667f6e$export$3f0e99ae6e0ec541 = [
    // Inclusion of issues in metrics is dependent on improving mitigation strategies for issues.
    // Inclusion of issue links in metrics is dependent on improving mitigation strategies for issue links.
    // ISSUE_LINKS,
    // CUSTOM_FIELD_OPTIONS,
    (0, $8MHQY.CUSTOM_FIELDS),
    (0, $cOrKR.ISSUE),
    (0, $3AEMX.PROJECT_ROLE_ACTOR),
    // Inclusion of file attachments in metrics is dependent on improving mitigation strategies for file attachments.
    // FILE_ATTACHMENTS,
    (0, $lzUDm.PROJECT_CLEANUP)
];
const $713364f722667f6e$export$769b1a9477352cf9 = 'runAnalysis';
const $713364f722667f6e$export$e7e31b14c32e055a = 'deleteRecommendations';
const $713364f722667f6e$export$d96fe00ff2b38bae = 'deleteRecommendationsDropdown';
const $713364f722667f6e$export$3d4bb5f187c6844e = 'deleteRecommendationsConfirm';
const $713364f722667f6e$export$5c1079e323f5d5bd = 'deleteRecommendationsCancel';
const $713364f722667f6e$export$d358fc12daa9f606 = 'psiTab';
const $713364f722667f6e$export$60cc0c61c99a5b81 = 'recommendations loaded';
const $713364f722667f6e$export$71794f4d197278dc = 'mitigationMetricCard';
const $713364f722667f6e$export$9e34afbf86922b4a = 'projectRoleActorFilterByProject';
const $713364f722667f6e$export$d6761557c91eea50 = {
    metric: (0, $3AEMX.PROJECT_ROLE_ACTOR_KEY)
};
const $713364f722667f6e$export$4e4b9391f7936ba2 = 'archiveIssuesConfirm';
const $713364f722667f6e$export$70525d18051240f4 = 'restoreIssueArchival';
const $713364f722667f6e$export$4951e0e034b50b9c = 'restoreIssueCancel';
const $713364f722667f6e$export$108288df7758f60c = 'restoreIssueTryAgain';
const $713364f722667f6e$export$972d5a8da0d9f4c3 = 'viewIssues';
const $713364f722667f6e$export$b920363d50bcf753 = 'stopIssueArchival';
const $713364f722667f6e$export$a84a5210fbad774 = 'restoreIssueArchival completed';
const $713364f722667f6e$export$5c2df36fdd8476f7 = 'jqlSearch';
const $713364f722667f6e$export$77f23f1b921d5321 = 'defaultQuerySelected';
const $713364f722667f6e$export$c62a52f3f7d80ec3 = {
    metric: (0, $cOrKR.ISSUE_KEY)
};
const $713364f722667f6e$export$8daffc99348bf555 = 'customFieldMoveToTrash';
const $713364f722667f6e$export$20f13a04bc3e5d74 = 'customFieldMoveToTrashConfirm';
const $713364f722667f6e$export$ed285e0e924b673c = 'customFieldMoveToTrashCancel';
const $713364f722667f6e$export$26f5d7eae10db511 = 'customFieldMoveToTrash succeeded';
const $713364f722667f6e$export$33989f74b6ba0674 = {
    metric: (0, $8MHQY.CUSTOM_FIELDS).key
};
const $713364f722667f6e$export$d39b24a650c6c79d = 'metricPerformanceSpotlight started';
const $713364f722667f6e$export$eca4028936acf763 = 'metricPerformanceSpotlightDismissed';
const $713364f722667f6e$export$9ba0a5caedb0ff37 = 'metricPerformanceSpotlight completed';
const $713364f722667f6e$export$7b6bf63452d40db8 = 'restoreActivityLog';
const $713364f722667f6e$export$efdb93c7210090d1 = 'downloadActivityLogCsv';
const $713364f722667f6e$export$6c650be5c2b4774f = 'projectCleanupFiltersCleared';
const $713364f722667f6e$export$6493dd0e190d3f58 = 'projectCleanupFilterByProjectState';
const $713364f722667f6e$export$422673ba1cec4aed = 'projectCleanupFilterByStale';
const $713364f722667f6e$export$3a7186fc63c9e188 = 'projectCleanUp';
const $713364f722667f6e$export$8e0b8859a3cbd9e6 = 'projectCleanup completed';
const $713364f722667f6e$export$342d8b9804e407c7 = 'TRASH';
const $713364f722667f6e$export$b685f2109baf2b4f = 'ARCHIVE';
const $713364f722667f6e$export$3ac60b381ed426ca = 'UNARCHIVE';

});


parcelRegister("etuUp", function(module, exports) {

$parcel$export(module.exports, "default", () => $df7d950b94f108ee$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $df7d950b94f108ee$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.title",
        "defaultMessage": "Site optimizer"
    },
    overview: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.overview",
        "defaultMessage": "Overview"
    },
    allReports: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.all-reports",
        "defaultMessage": "All reports"
    }
});

});

parcelRegister("jWIOc", function(module, exports) {

$parcel$export(module.exports, "PROJECT_CLEANUP_SPOTLIGHT_NAME", () => $fa0cf627da3f1f38$export$4150c6a7c9be0102);
$parcel$export(module.exports, "ProjectCleanupSpotlight", () => $fa0cf627da3f1f38$export$6dc8afd0c00f9525);

var $5uXOq = parcelRequire("5uXOq");

var $1QiBP = parcelRequire("1QiBP");

var $koVbs = parcelRequire("koVbs");

var $ehdJY = parcelRequire("ehdJY");

var $k43Y2 = parcelRequire("k43Y2");

var $8881D = parcelRequire("8881D");
const $fa0cf627da3f1f38$export$4150c6a7c9be0102 = 'site-optimiser-project-cleanup-spotlight-nav';
const $fa0cf627da3f1f38$export$6dc8afd0c00f9525 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isProjectCleanupSpotlightActive, setIsProjectCleanupSpotlightActive] = (0, $k43Y2.useProjectCleanupSpotlight)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, isProjectCleanupSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        actions: [
            {
                onClick: ()=>setIsProjectCleanupSpotlightActive(false),
                text: formatMessage((0, $8881D.default).spotlightAction)
            }
        ],
        heading: formatMessage((0, $8881D.default).spotlightHeading),
        target: $fa0cf627da3f1f38$export$4150c6a7c9be0102,
        key: $fa0cf627da3f1f38$export$4150c6a7c9be0102,
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        dialogPlacement: "right top",
        messageId: "navigation-apps-sidebar-global-settings-system.ui.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.jira-spotlight",
        messageType: "engagement"
    }, formatMessage((0, $8881D.default).spotlightDescription)));
});

});
parcelRegister("k43Y2", function(module, exports) {

$parcel$export(module.exports, "useProjectCleanupSpotlight", () => $249ebdaf0c0fc22c$export$780bcf6e3ebf2d12);

var $5uXOq = parcelRequire("5uXOq");

var $iyJxC = parcelRequire("iyJxC");

var $90yGq = parcelRequire("90yGq");
// Ensure this key matches the key in the old nav in navigation-apps/sidebar package
const $249ebdaf0c0fc22c$var$PROPERTY_KEY = 'jira.user.settings.system.project-cleanup-onboarding-spotlight';
const $249ebdaf0c0fc22c$export$780bcf6e3ebf2d12 = ()=>{
    const accountId = (0, $90yGq.useAccountId)();
    const [isProjectCleanupSpotlightActive, setIsProjectCleanupSpotlightActive] = (0, $5uXOq.useState)(false);
    const getHasSeenProjectCleanupSpotlight = async (id)=>{
        const response = await (0, $iyJxC.getUserProperty)({
            accountId: id,
            propertyKey: $249ebdaf0c0fc22c$var$PROPERTY_KEY,
            defaultValue: false
        });
        // If they have not seen the spotlight, return true and mark as shown
        if (!response.value) {
            await (0, $iyJxC.setUserProperty)({
                accountId: id,
                propertyKey: $249ebdaf0c0fc22c$var$PROPERTY_KEY,
                propertyValue: true
            });
            return false;
        }
        return true;
    };
    const fetchSpotlightState = (0, $5uXOq.useCallback)(async ()=>{
        if (accountId !== null) {
            const response = await getHasSeenProjectCleanupSpotlight(accountId);
            setIsProjectCleanupSpotlightActive(!response);
        }
    }, [
        accountId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        fetchSpotlightState();
    }, [
        fetchSpotlightState
    ]);
    return [
        isProjectCleanupSpotlightActive,
        setIsProjectCleanupSpotlightActive
    ];
};

});
parcelRegister("iyJxC", function(module, exports) {

$parcel$export(module.exports, "getUserProperty", () => $5455121d227e33bb$export$b3126db2ef6e34ed);
$parcel$export(module.exports, "setUserProperty", () => $5455121d227e33bb$export$ba821ce5e177c7ef);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $5455121d227e33bb$var$getUserUrl = (accountId, propertyKey)=>`/rest/api/3/user/properties/${propertyKey}?accountId=${accountId}`;
const $5455121d227e33bb$export$b3126db2ef6e34ed = async ({ accountId: accountId, propertyKey: propertyKey, defaultValue: defaultValue })=>{
    const url = $5455121d227e33bb$var$getUserUrl(accountId, propertyKey);
    try {
        const response = await fetch(url, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        // The API deliberately returns 404 if user property is not found - we will return default value
        if (response.status === 404) return {
            key: propertyKey,
            value: defaultValue
        };
        if (response.ok) return await response.json();
        throw new Error(`Fetching ${propertyKey} user property failed.`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'getUserProperty',
                packageName: 'jiraAdminPagesPerformance',
                teamName: 'cherenkov'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            key: propertyKey,
            value: defaultValue
        };
    }
};
const $5455121d227e33bb$export$ba821ce5e177c7ef = async ({ accountId: accountId, propertyKey: propertyKey, propertyValue: propertyValue })=>{
    const url = $5455121d227e33bb$var$getUserUrl(accountId, propertyKey);
    try {
        await (0, $eusud.performPutRequest)(url, {
            body: JSON.stringify(propertyValue)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'setUserProperty',
                packageName: 'jiraAdminPagesPerformance',
                teamName: 'cherenkov'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});


parcelRegister("8881D", function(module, exports) {

$parcel$export(module.exports, "default", () => $86d0877c08ff02be$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $86d0877c08ff02be$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    spotlightHeading: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.spotlight-heading",
        "defaultMessage": "Clean out unused projects"
    },
    spotlightDescription: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.spotlight-description",
        "defaultMessage": "Quickly remove inactive or empty projects to improve your site\u2019s performance. "
    },
    spotlightAction: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.spotlight-action",
        "defaultMessage": "Ok"
    }
});

});



parcelRegister("fM231", function(module, exports) {

$parcel$export(module.exports, "hasSeenSiteOptimiserSpotlight", () => $879944d685aae4de$export$3ed4e8541d8ba40);

var $iyJxC = parcelRequire("iyJxC");
const $879944d685aae4de$var$PROPERTY_KEY = 'jira.user.settings.system.site-optimizer-spotlight';
const $879944d685aae4de$export$3ed4e8541d8ba40 = async (accountId)=>{
    const response = await (0, $iyJxC.getUserProperty)({
        accountId: accountId,
        propertyKey: $879944d685aae4de$var$PROPERTY_KEY,
        defaultValue: false
    });
    // If they have not seen the spotlight, return true and mark as shown
    if (!response.value) {
        await (0, $iyJxC.setUserProperty)({
            accountId: accountId,
            propertyKey: $879944d685aae4de$var$PROPERTY_KEY,
            propertyValue: true
        });
        return false;
    }
    return true;
};

});


parcelRegister("ie4oV", function(module, exports) {

$parcel$export(module.exports, "isViewAuditingSelected", () => $84aa4044b145a05a$export$6da8ca04904513f9);

var $4OCke = parcelRequire("4OCke");
const $84aa4044b145a05a$var$VIEW_AUDITING_PATH_REGEXP = /\/auditing\/(\w+)/i;
const $84aa4044b145a05a$export$6da8ca04904513f9 = (currentLocation, itemLocation)=>(0, $4OCke.matchUrlExact)()(currentLocation, itemLocation) || $84aa4044b145a05a$var$VIEW_AUDITING_PATH_REGEXP.test(currentLocation.pathname);

});


parcelRegister("71ORT", function(module, exports) {

$parcel$export(module.exports, "UserInterfaceSection", () => $4dae17d9419cb38f$export$c4128359313d3f58);

var $5uXOq = parcelRequire("5uXOq");

var $gjTBi = parcelRequire("gjTBi");
var $bWqXX = parcelRequire("bWqXX");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $17bH5 = parcelRequire("17bH5");

var $4OCke = parcelRequire("4OCke");

var $itmJb = parcelRequire("itmJb");

var $jMBA3 = parcelRequire("jMBA3");

var $jDUf4 = parcelRequire("jDUf4");
const $4dae17d9419cb38f$export$c4128359313d3f58 = ()=>{
    const isJiraAdmin = (0, $itmJb.useIsAdmin)();
    const { data: features } = (0, $jMBA3.useFeatures)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const navigationPath = (0, $5uXOq.useMemo)(()=>(0, $17bH5.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: formatMessage((0, $jDUf4.default).userInterface)
    }, features.hasUserDefaults && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'user-defaults'
        },
        href: navigationPath.userInterfacesUserDefaults,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $jDUf4.default).userDefaults)), features.hasEditDefaultDashboard && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'edit-default-dashboard'
        },
        href: navigationPath.userInterfacesEditDefaultDashboard,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $jDUf4.default).systemDashboard)), features.hasLookAndFeel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'look-and-feel'
        },
        href: navigationPath.userInterfacesLookAndFeel,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $jDUf4.default).lookAndFeel)), features.hasPasAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'pas-admin-link-jira'
        },
        href: navigationPath.userInterfacesPasAdmin,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $jDUf4.default).pasAdmin)), isJiraAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'announcement-banner'
        },
        href: navigationPath.userInterfacesSiteAdmin,
        selectedOn: [
            'global-settings-system-ui-announcement-banner'
        ]
    }, formatMessage((0, $jDUf4.default).announcementBanner)));
};

});
parcelRegister("jDUf4", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f12d9a643fcf4ed$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6f12d9a643fcf4ed$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    userInterface: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.user-interface",
        "defaultMessage": "User Interface"
    },
    userDefaults: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.user-defaults",
        "defaultMessage": "Default user preferences"
    },
    systemDashboard: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.system-dashboard",
        "defaultMessage": "Default dashboard"
    },
    lookAndFeel: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.look-and-feel",
        "defaultMessage": "Look and feel"
    },
    pasAdmin: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.pas-admin",
        "defaultMessage": "Public Announcement Service"
    },
    announcementBanner: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.announcement-banner",
        "defaultMessage": "Announcement banner"
    }
});

});


parcelRegister("3jrxv", function(module, exports) {

$parcel$export(module.exports, "isGeneralConfigurationSelected", () => $e6139421bb00cae6$export$ba31cfa97c56eefd);

var $4OCke = parcelRequire("4OCke");
const $e6139421bb00cae6$var$APPLICATION_PROPERTIES_PATH_REGEXP = /\/admin\/(\w+)ApplicationProperties/i;
const $e6139421bb00cae6$export$ba31cfa97c56eefd = (currentLocation, itemLocation)=>(0, $4OCke.matchUrlExact)()(currentLocation, itemLocation) || $e6139421bb00cae6$var$APPLICATION_PROPERTIES_PATH_REGEXP.test(currentLocation.pathname);

});



parcelRegister("gRmqY", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemBulkMailRoute", () => $47674b1aa9d0fa81$export$2b269dcf51f5a4d3);
const $47674b1aa9d0fa81$export$2b269dcf51f5a4d3 = {
    name: 'global-settings-system-bulk-mail',
    path: '/jira/settings/system/send-email'
};

});

parcelRegister("5FGTk", function(module, exports) {

$parcel$export(module.exports, "LazyBulkEmail", () => $0240d4f2c2b35825$export$416f8039fbf50bea);
$parcel$export(module.exports, "default", () => $0240d4f2c2b35825$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $0240d4f2c2b35825$export$416f8039fbf50bea = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("iBdIG"))), {
    moduleId: "./src/packages/admin-pages/bulk-email/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0240d4f2c2b35825$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $0240d4f2c2b35825$export$416f8039fbf50bea,
        pageId: "jira-admin-pages-bulk-email",
        shouldShowSpinner: true
    });

});
parcelRegister("iBdIG", function(module, exports) {

let $d8a6532580e1bcb8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d8a6532580e1bcb8$var$load("8z6OY").then(()=>parcelRequire('8Z6uP'));

});



parcelRegister("hH7Cb", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemUiAnnouncementBannerRouteEntry", () => $375c8c577ca5ebf6$export$416d225883781012);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $49jFu = parcelRequire("49jFu");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $5pSYQ = parcelRequire("5pSYQ");

const $375c8c577ca5ebf6$var$LazyAnnouncementBanner = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("2Na7r"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/system/ui/announcement-banner/src/index.tsx"
});
const $375c8c577ca5ebf6$var$AnnouncementBanner = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $375c8c577ca5ebf6$var$LazyAnnouncementBanner,
        pageId: "admin-pages-system-ui-announcement-banner",
        shouldShowSpinner: true
    });
const $375c8c577ca5ebf6$export$416d225883781012 = (0, $7NszV.createEntry)((0, $49jFu.globalSettingsSystemUiAnnouncementBannerRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.system.ui.announcement-banner',
        component: $375c8c577ca5ebf6$var$AnnouncementBanner,
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $375c8c577ca5ebf6$var$LazyAnnouncementBanner
        ]
    }));

});
parcelRegister("49jFu", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemUiAnnouncementBannerRoute", () => $0f7678f7ab7e2ce6$export$20631ff3b13dafc0);
const $0f7678f7ab7e2ce6$export$20631ff3b13dafc0 = {
    name: 'global-settings-system-ui-announcement-banner',
    path: '/jira/settings/system/ui/announcement-banner'
};

});

parcelRegister("2Na7r", function(module, exports) {

let $208801cd8670537d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $208801cd8670537d$var$load("ffQaD"),
    $208801cd8670537d$var$load("kvRbA"),
    $208801cd8670537d$var$load("fliVL"),
    $208801cd8670537d$var$load("gydgg")
]).then(()=>parcelRequire('e7RG2'));

});


parcelRegister("2krv1", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioActionsRouteEntry", () => $3d7af2fe877a2988$export$47cbfd555c8570c0);

var $ffza4 = parcelRequire("ffza4");

var $e2ctp = parcelRequire("e2ctp");

var $5lsNZ = parcelRequire("5lsNZ");

var $fpjJX = parcelRequire("fpjJX");

var $7NszV = parcelRequire("7NszV");

var $6Z2mh = parcelRequire("6Z2mh");

var $gFEDq = parcelRequire("gFEDq");

var $cSD7y = parcelRequire("cSD7y");

var $6gWZ1 = parcelRequire("6gWZ1");

var $kgvfG = parcelRequire("kgvfG");
const $3d7af2fe877a2988$export$47cbfd555c8570c0 = (0, $7NszV.createEntry)((0, $gFEDq.helpCenterSettingsAgentStudioActionsRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.agent-studio-actions',
        component: (0, $cSD7y.componentWithFG)('csm-actions-framework-visibility', (0, $kgvfG.AgentStudioActionsComponent), (0, $5lsNZ.default)),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: (0, $6gWZ1.agentStudioNavigation),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kgvfG.LazyAgentStudioActionsPage)
        ],
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("gFEDq", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioActionsRoute", () => $f90b0e5d1a951de0$export$5cfc987a071755e7);
const $f90b0e5d1a951de0$export$5cfc987a071755e7 = {
    name: 'helpcenter-settings-agent-studio-actions',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/agent/actions',
    exact: true
};

});

parcelRegister("6gWZ1", function(module, exports) {

$parcel$export(module.exports, "navigation", () => $3831f5d0598d36f4$export$428e7c787d57587d);
$parcel$export(module.exports, "agentStudioNavigation", () => $3831f5d0598d36f4$export$c198b13d4a0b8cea);

var $lmyls = parcelRequire("lmyls");

var $65ItF = parcelRequire("65ItF");

var $fBTqh = parcelRequire("fBTqh");

var $cSD7y = parcelRequire("cSD7y");
const $3831f5d0598d36f4$export$428e7c787d57587d = {
    sidebarId: (0, $lmyls.SIDEBAR_ID).HELP_CENTER_SETTINGS,
    menuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS,
    sidebar: (0, $fBTqh.default)
};
const $3831f5d0598d36f4$export$c198b13d4a0b8cea = {
    sidebarId: (0, $lmyls.SIDEBAR_ID).HELP_CENTER_SETTINGS,
    menuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS,
    sidebar: (0, $fBTqh.default),
    horizontal: (0, $cSD7y.componentWithFG)('enable_support_center_agent_studio_page', (0, $65ItF.AsyncSupportCenterHorizontalNav), ()=>null)
};

});
parcelRegister("65ItF", function(module, exports) {

$parcel$export(module.exports, "AsyncSupportCenterHorizontalNav", () => $bc8ad4b74f43add3$export$123fcd6868b7ea3f);

var $5uXOq = parcelRequire("5uXOq");

var $hYRTO = parcelRequire("hYRTO");

var $kxZPA = parcelRequire("kxZPA");

const $bc8ad4b74f43add3$var$LazyHorizontalSupportCenterNav = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("cu6av")).then(({ HorizontalNav: HorizontalNav })=>HorizontalNav), {
    moduleId: "./src/packages/spa-apps/help-center-settings/agent-studio/src/ui/horizontal-nav/main.tsx"
});
const $bc8ad4b74f43add3$export$123fcd6868b7ea3f = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hYRTO.default), {
        name: "help-center-settings-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bc8ad4b74f43add3$var$LazyHorizontalSupportCenterNav, null));
};

});
parcelRegister("cu6av", function(module, exports) {

let $916d124dcfaec395$var$load = (parcelRequire("28QjX"))(4);
module.exports = $916d124dcfaec395$var$load("9G7s9").then(()=>parcelRequire('70kLi'));

});


parcelRegister("fBTqh", function(module, exports) {

$parcel$export(module.exports, "default", () => $43189553e9fc21a2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

const $43189553e9fc21a2$export$ea77f88c1b841127 = (0, $kxZPA.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("kmi2q")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/help-center-settings/src/index.tsx"
});
const $43189553e9fc21a2$var$HelpCenterSettingsSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "servicedeskProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($43189553e9fc21a2$export$ea77f88c1b841127, null)));
$43189553e9fc21a2$var$HelpCenterSettingsSidebar.displayName = 'HelpCenterSettingsSidebar';
var $43189553e9fc21a2$export$2e2bcd8739ae039 = $43189553e9fc21a2$var$HelpCenterSettingsSidebar;

});
parcelRegister("kmi2q", function(module, exports) {

let $ed23dab9fe014cab$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ed23dab9fe014cab$var$load("afUJz").then(()=>parcelRequire('5NHpB'));

});



parcelRegister("kgvfG", function(module, exports) {

$parcel$export(module.exports, "LazyAgentStudioOverviewPage", () => $90b72030babf7447$export$5fa375047554c75c);
$parcel$export(module.exports, "AgentStudioOverviewPage", () => $90b72030babf7447$export$3c32337b9e9c89e5);
$parcel$export(module.exports, "LazyAgentStudioConversationReviewPage", () => $90b72030babf7447$export$e5bd431cce56c023);
$parcel$export(module.exports, "AgentStudioConversationReview", () => $90b72030babf7447$export$ba343ba7cdb4cca4);
$parcel$export(module.exports, "LazyAgentStudioSimulatorPage", () => $90b72030babf7447$export$89ec1205a5fbfa5a);
$parcel$export(module.exports, "AgentStudioSimulatorComponent", () => $90b72030babf7447$export$974fe2862709837d);
$parcel$export(module.exports, "LazyAgentStudioActionsPage", () => $90b72030babf7447$export$f1d6621241cd5379);
$parcel$export(module.exports, "AgentStudioActionsComponent", () => $90b72030babf7447$export$27f9057c3758bdae);
$parcel$export(module.exports, "csmAgentOverviewPageEntryPoint", () => $90b72030babf7447$export$64672a53ea64d95b);
$parcel$export(module.exports, "agentStudioKnowledgePageEntryPoint", () => $90b72030babf7447$export$a9cf3691889e3b8);
$parcel$export(module.exports, "csmAgentHandoffPageEntryPoint", () => $90b72030babf7447$export$822a9de2df799668);
$parcel$export(module.exports, "csmAgentConversationReviewPageEntryPoint", () => $90b72030babf7447$export$14c5ab081cdbeb0d);
$parcel$export(module.exports, "csmAgentChatSimulatorPageEntryPoint", () => $90b72030babf7447$export$dc40d5702a9b03f3);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $lEnZH = parcelRequire("lEnZH");

var $7Di6X = parcelRequire("7Di6X");

var $96DTa = parcelRequire("96DTa");

var $9UI5x = parcelRequire("9UI5x");

var $9RDhp = parcelRequire("9RDhp");

const $90b72030babf7447$export$5fa375047554c75c = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("2HSON")).then((module)=>module.AgentOverview)), {
    moduleId: "./src/packages/spa-apps/help-center-settings/agent-studio/src/ui/overview/index.tsx"
});
const $90b72030babf7447$export$3c32337b9e9c89e5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $90b72030babf7447$export$5fa375047554c75c,
        pageId: "help-center-settings-agent-studio-overview",
        shouldShowSpinner: true
    });

const $90b72030babf7447$export$e5bd431cce56c023 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("cW76i"))), {
    moduleId: "./src/packages/spa-apps/help-center-settings/agent-studio/src/ui/conversation-review/index.tsx"
});
const $90b72030babf7447$export$ba343ba7cdb4cca4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $90b72030babf7447$export$e5bd431cce56c023,
        pageId: "help-center-settings-agent-studio-conversation-review",
        shouldShowSpinner: true
    });

const $90b72030babf7447$export$89ec1205a5fbfa5a = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("5EFdG"))), {
    moduleId: "./src/packages/spa-apps/help-center-settings/agent-studio/src/ui/chat-simulator/index.tsx"
});
const $90b72030babf7447$export$974fe2862709837d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $90b72030babf7447$export$89ec1205a5fbfa5a,
        pageId: "help-center-settings-agent-studio-chat-simulator",
        shouldShowSpinner: false
    });

const $90b72030babf7447$export$f1d6621241cd5379 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("4w0xo"))), {
    moduleId: "./src/packages/spa-apps/help-center-settings/agent-studio/src/ui/actions/index.tsx"
});
const $90b72030babf7447$export$27f9057c3758bdae = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $90b72030babf7447$export$f1d6621241cd5379,
        pageId: "help-center-settings-agent-studio-chat-actions",
        shouldShowSpinner: false
    });
const $90b72030babf7447$export$64672a53ea64d95b = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7Di6X.csmAgentOverviewEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});
const $90b72030babf7447$export$a9cf3691889e3b8 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $lEnZH.helpCenterSettingsAgentStudioKnowledgeAppEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});
const $90b72030babf7447$export$822a9de2df799668 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $9UI5x.helpCenterSettingsAgentStudioHandoffEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});
const $90b72030babf7447$export$14c5ab081cdbeb0d = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $9RDhp.csmAgentConversationReviewEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});
const $90b72030babf7447$export$dc40d5702a9b03f3 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $96DTa.csmAgentChatSimulatorEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("lEnZH", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioKnowledgeAppEntryPoint", () => $189f4d55daa7ac84$export$9436eec1eefc1701);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $8c96j = parcelRequire("8c96j");

const $189f4d55daa7ac84$export$9436eec1eefc1701 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("5IyQG")), {
        moduleId: "4b9cc39b",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $8c96j.default),
                    variables: {
                        helpCenterAri: `ari:cloud:help::help-center/${tenantContext.activationId}/${context.match.params.helpCenterId}`
                    }
                }
            }
        })
});

});
parcelRegister("8c96j", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cca371066bfa50a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7975a004da92a606996f012c39a7bd74>>
 * @relayHash 7517a65583faed70dbfad33ebebfb7fe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7062c3ecfa368283782ea4badae1efec4d13b76b7bd2fb2d781f242160bd2237
const $9cca371066bfa50a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "InlineFragment",
        "selections": [
            v2 /*: any*/ 
        ],
        "type": "CsmAiAgent"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "knowledgeConfig_agentIdentityQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "agent",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "CsmAiHub"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "knowledgeConfig_agentIdentityQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "agent",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v3 /*: any*/ 
                                    ]
                                },
                                v2 /*: any*/ 
                            ],
                            "type": "CsmAiHub"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7062c3ecfa368283782ea4badae1efec4d13b76b7bd2fb2d781f242160bd2237",
            "metadata": {},
            "name": "knowledgeConfig_agentIdentityQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9cca371066bfa50a$var$node.hash = "0b997c6ab7fcf5ad5b42793b2c9d9bc6";
var $9cca371066bfa50a$export$2e2bcd8739ae039 = $9cca371066bfa50a$var$node;

});

parcelRegister("5IyQG", function(module, exports) {

let $429c180796f49c72$var$load = (parcelRequire("28QjX"))(4);
module.exports = $429c180796f49c72$var$load("gMlYq").then(()=>parcelRequire('kYkWF'));

});


parcelRegister("7Di6X", function(module, exports) {

$parcel$export(module.exports, "csmAgentOverviewEntryPoint", () => $3280ffbb5b52c908$export$50a5fd926c9d7bb4);

var $36uSG = parcelRequire("36uSG");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $3280ffbb5b52c908$export$50a5fd926c9d7bb4 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("2HSON")).then((module)=>module.AgentOverview), {
        moduleId: "a5f961b3",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $36uSG.default),
                    variables: {
                        helpCenterAri: `ari:cloud:help::help-center/${tenantContext.activationId}/${context.match.params.helpCenterId}`
                    }
                }
            }
        })
});

});
parcelRegister("36uSG", function(module, exports) {

$parcel$export(module.exports, "default", () => $9aad833e24a70a01$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<95da339cb012f96ec20febdec96d2484>>
 * @relayHash b2c29c3713e9bb4a323b8c17631a839d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9159055d2982d57eb684f7a6fcf95942a5df5264ec27612680ad83db3bce0573
const $9aad833e24a70a01$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "overview_agentIdentityQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "agent",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "agentIdentity_AtlassianCsmAgentIdentity"
                                        }
                                    ]
                                }
                            ],
                            "type": "CsmAiHub"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "overview_agentIdentityQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "agent",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "companyName"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "companyDescription"
                                                },
                                                {
                                                    "concreteType": "CsmAiAgentTone",
                                                    "kind": "LinkedField",
                                                    "name": "tone",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "type"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "greetingMessage"
                                                }
                                            ],
                                            "type": "CsmAiAgent"
                                        }
                                    ]
                                },
                                v3 /*: any*/ 
                            ],
                            "type": "CsmAiHub"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9159055d2982d57eb684f7a6fcf95942a5df5264ec27612680ad83db3bce0573",
            "metadata": {},
            "name": "overview_agentIdentityQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9aad833e24a70a01$var$node.hash = "ad2118276853b2acba85a665b99d4060";
var $9aad833e24a70a01$export$2e2bcd8739ae039 = $9aad833e24a70a01$var$node;

});

parcelRegister("2HSON", function(module, exports) {

let $1f8a1eb2bd77646c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1f8a1eb2bd77646c$var$load("fFCZv").then(()=>parcelRequire('5SMTp'));

});


parcelRegister("96DTa", function(module, exports) {

$parcel$export(module.exports, "csmAgentChatSimulatorEntryPoint", () => $8d086789a796e4fd$export$e3fcb8d4e80081b0);

var $4737k = parcelRequire("4737k");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $8d086789a796e4fd$export$e3fcb8d4e80081b0 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("5EFdG")), {
        moduleId: "e930d9dc",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $4737k.default),
                    variables: {
                        helpCenterAri: `ari:cloud:help::help-center/${tenantContext.activationId}/${context.match.params.helpCenterId}`
                    }
                }
            }
        })
});

});
parcelRegister("4737k", function(module, exports) {

$parcel$export(module.exports, "default", () => $15ffe817581ead86$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fe98323d8ba25bee0cdc2d21b347b37c>>
 * @relayHash 6ec40e2940a58d5987f8d0d2565b653b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8b009d3de84f25c5f42694160edf048b5c7d1d61a085303179c1eec4658087cc
const $15ffe817581ead86$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "greetingMessage"
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "chatSimulator_agentIdentityQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "agent",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "concreteType": "CsmAiAgentConversationStarter",
                                                    "kind": "LinkedField",
                                                    "name": "conversationStarters",
                                                    "plural": true,
                                                    "selections": [
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "CsmAiAgent"
                                        }
                                    ]
                                }
                            ],
                            "type": "CsmAiHub"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "chatSimulator_agentIdentityQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "agent",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "concreteType": "CsmAiAgentConversationStarter",
                                                    "kind": "LinkedField",
                                                    "name": "conversationStarters",
                                                    "plural": true,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v2 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "CsmAiAgent"
                                        }
                                    ]
                                }
                            ],
                            "type": "CsmAiHub"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8b009d3de84f25c5f42694160edf048b5c7d1d61a085303179c1eec4658087cc",
            "metadata": {},
            "name": "chatSimulator_agentIdentityQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$15ffe817581ead86$var$node.hash = "db75ee797c497b47b6a05c1132ca4fc4";
var $15ffe817581ead86$export$2e2bcd8739ae039 = $15ffe817581ead86$var$node;

});

parcelRegister("5EFdG", function(module, exports) {

let $41e0a992d6efeee0$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $41e0a992d6efeee0$var$load("ffQaD"),
    $41e0a992d6efeee0$var$load("kvRbA"),
    $41e0a992d6efeee0$var$load("kNFvF"),
    $41e0a992d6efeee0$var$load("fliVL"),
    $41e0a992d6efeee0$var$load("lng2q")
]).then(()=>parcelRequire('e2jOc'));

});


parcelRegister("9UI5x", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioHandoffEntryPoint", () => $51bbfcf593383423$export$443ff355bdadb1d7);

var $exxeF = parcelRequire("exxeF");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $51bbfcf593383423$export$443ff355bdadb1d7 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("fyfLl")), {
        moduleId: "7048febb",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $exxeF.default),
                    variables: {
                        helpCenterAri: `ari:cloud:help::help-center/${tenantContext.activationId}/${context.match.params.helpCenterId}`
                    }
                }
            }
        })
});

});
parcelRegister("exxeF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3156665af3d70ae$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a5d2e2b0689326e4dd9c671c4ab20e2f>>
 * @relayHash e2d947e6ab2e11bdf54ebdd414d5c60b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5a982d3be4ddad4346819315406aee6db2741369f027cc154b1e6098bfad592b
const $b3156665af3d70ae$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "handoffConfig_csmAiHubQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "kind": "LinkedField",
                        "name": "csmAi_getAiHubByHelpCenterAri",
                        "plural": false,
                        "selections": [
                            v2 /*: any*/ ,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "configuration_AtlassianCsmHandoffConfig"
                                    }
                                ],
                                "type": "CsmAiHub"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "csmAi_getAiHubByHelpCenterAri"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "handoffConfig_csmAiHubQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "handoffConfigs",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "type"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "enabled"
                                                },
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "connectorConfiguration",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "message"
                                                                }
                                                            ],
                                                            "type": "CsmAiMessageHandoff"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "CsmAiHandoffConfig"
                                        }
                                    ]
                                },
                                v3 /*: any*/ 
                            ],
                            "type": "CsmAiHub"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5a982d3be4ddad4346819315406aee6db2741369f027cc154b1e6098bfad592b",
            "metadata": {},
            "name": "handoffConfig_csmAiHubQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b3156665af3d70ae$var$node.hash = "841642ca04c73dc56596f8461c555698";
var $b3156665af3d70ae$export$2e2bcd8739ae039 = $b3156665af3d70ae$var$node;

});

parcelRegister("fyfLl", function(module, exports) {

let $b526421f9fd337e0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b526421f9fd337e0$var$load("ZhH5c").then(()=>parcelRequire('lgJzj'));

});


parcelRegister("9RDhp", function(module, exports) {

$parcel$export(module.exports, "csmAgentConversationReviewEntryPoint", () => $cb7f36ce49502e4e$export$d1ea95606ab7ac2e);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $2SViv = parcelRequire("2SViv");

const $cb7f36ce49502e4e$export$d1ea95606ab7ac2e = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("cW76i")), {
        moduleId: "b29d9436",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $2SViv.default),
                    variables: {
                        helpCenterAri: `ari:cloud:help::help-center/${tenantContext.activationId}/${context.match.params.helpCenterId}`
                    }
                }
            }
        })
});

});
parcelRegister("2SViv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4c902db3cd67e1b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1d293c5fa575e282b09e51ccabc0fea4>>
 * @relayHash 5d73a886053db0c3167810d478cac2ef
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 95c94140fecba78cb87b8cfc0cf42eaf05d1a58960bd94f0b354baf1030acfc9
const $f4c902db3cd67e1b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v2 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            }
        ],
        "type": "CsmAiHub"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "conversationReview_agentIdentityQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "conversationReview_agentIdentityQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "95c94140fecba78cb87b8cfc0cf42eaf05d1a58960bd94f0b354baf1030acfc9",
            "metadata": {},
            "name": "conversationReview_agentIdentityQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f4c902db3cd67e1b$var$node.hash = "340a20f2d50cc5f77582b00676ed5abb";
var $f4c902db3cd67e1b$export$2e2bcd8739ae039 = $f4c902db3cd67e1b$var$node;

});

parcelRegister("cW76i", function(module, exports) {

let $96b068dae05f0139$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $96b068dae05f0139$var$load("fliVL"),
    $96b068dae05f0139$var$load("iCIYt")
]).then(()=>parcelRequire('iC69g'));

});


parcelRegister("4w0xo", function(module, exports) {

let $349a91583b463083$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $349a91583b463083$var$load("ffQaD"),
    $349a91583b463083$var$load("kvRbA"),
    $349a91583b463083$var$load("7BW98")
]).then(()=>parcelRequire('eJnmn'));

});



parcelRegister("8wIny", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioChatSimulatorRouteEntry", () => $ad87a7ca26339056$export$c4240053c0a5eb9c);

var $ffza4 = parcelRequire("ffza4");

var $e2ctp = parcelRequire("e2ctp");

var $5lsNZ = parcelRequire("5lsNZ");

var $fpjJX = parcelRequire("fpjJX");

var $7NszV = parcelRequire("7NszV");

var $6Z2mh = parcelRequire("6Z2mh");

var $9MsoF = parcelRequire("9MsoF");

var $cSD7y = parcelRequire("cSD7y");

var $jZ7nW = parcelRequire("jZ7nW");

var $4R6GH = parcelRequire("4R6GH");

var $6gWZ1 = parcelRequire("6gWZ1");

var $kgvfG = parcelRequire("kgvfG");
const $ad87a7ca26339056$export$c4240053c0a5eb9c = (0, $7NszV.createEntry)((0, $9MsoF.helpCenterSettingsAgentStudioChatSimulatorRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.agent-studio-chat-simulator',
        entryPoint () {
            if (!(0, $4R6GH.fg)('enable_support_center_agent_studio_page')) return undefined;
            return 0, $kgvfG.csmAgentChatSimulatorPageEntryPoint;
        },
        component: (0, $cSD7y.componentWithFG)('enable_support_center_agent_studio_page', (0, $kgvfG.AgentStudioSimulatorComponent), (0, $5lsNZ.default)),
        skeleton: (0, $jZ7nW.ChatSimulatorLoadingState),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: (0, $6gWZ1.agentStudioNavigation),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kgvfG.LazyAgentStudioSimulatorPage)
        ],
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("9MsoF", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioChatSimulatorRoute", () => $6d8e604aaf253ef7$export$426c3d828fdab50e);
const $6d8e604aaf253ef7$export$426c3d828fdab50e = {
    name: 'helpcenter-settings-agent-studio-chat-simulator',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/agent/simulator',
    exact: true
};

});

parcelRegister("jZ7nW", function(module, exports) {

$parcel$export(module.exports, "ChatSimulatorLoadingState", () => $27a7b26a19620204$export$3966fd37f06836dd);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $bgrar = parcelRequire("bgrar");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $1DVhQ = parcelRequire("1DVhQ");
const $27a7b26a19620204$var$gridStyles = (0, $8CUq3.xcss)({
    height: '920px'
});
const $27a7b26a19620204$var$leftSidebarStyles = (0, $8CUq3.xcss)({
    height: '100%',
    paddingBottom: 'space.0'
});
const $27a7b26a19620204$var$mainContentStyles = (0, $8CUq3.xcss)({
    height: '100%'
});
const $27a7b26a19620204$var$chatSectionStyles = (0, $8CUq3.xcss)({
    height: '100%',
    width: '100%',
    paddingTop: 'space.100',
    paddingBottom: 'space.0',
    paddingInline: 'space.200',
    overflow: 'auto',
    maxWidth: 'min(800px, 50vw)',
    marginInline: 'auto'
});
const $27a7b26a19620204$var$conversationListStyle = (0, $8CUq3.xcss)({
    padding: 'space.300'
});
const $27a7b26a19620204$export$3966fd37f06836dd = ()=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bgrar.default), {
        xcss: $27a7b26a19620204$var$gridStyles,
        rowGap: "space.200",
        columnGap: "space.0",
        templateColumns: "360px 1fr",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
                alignBlock: "start",
                xcss: $27a7b26a19620204$var$leftSidebarStyles,
                space: "space.200",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                        padding: "space.300",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1DVhQ.default), {
                            isShimmering: true,
                            width: "100%",
                            height: "32px",
                            borderRadius: 3
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
                        space: "space.100",
                        xcss: $27a7b26a19620204$var$conversationListStyle,
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1DVhQ.default), {
                                isShimmering: true,
                                width: "100%",
                                height: "36px",
                                borderRadius: 3
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1DVhQ.default), {
                                isShimmering: true,
                                width: "100%",
                                height: "36px",
                                borderRadius: 3
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1DVhQ.default), {
                                isShimmering: true,
                                width: "100%",
                                height: "36px",
                                borderRadius: 3
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1DVhQ.default), {
                                isShimmering: true,
                                width: "100%",
                                height: "36px",
                                borderRadius: 3
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
                xcss: $27a7b26a19620204$var$mainContentStyles,
                spread: "space-between",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                        padding: "space.300",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1DVhQ.default), {
                            isShimmering: true,
                            width: "50%",
                            height: "32px",
                            borderRadius: 0
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
                        xcss: $27a7b26a19620204$var$chatSectionStyles,
                        alignBlock: "end",
                        space: "space.200",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1DVhQ.default), {
                                isShimmering: true,
                                width: "440px",
                                height: "120px",
                                borderRadius: 2
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
                                space: "space.050",
                                alignInline: "end",
                                children: [
                                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1DVhQ.default), {
                                        isShimmering: true,
                                        width: "240px",
                                        height: "32px",
                                        borderRadius: 8
                                    }),
                                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1DVhQ.default), {
                                        isShimmering: true,
                                        width: "320px",
                                        height: "32px",
                                        borderRadius: 8
                                    }),
                                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1DVhQ.default), {
                                        isShimmering: true,
                                        width: "180px",
                                        height: "32px",
                                        borderRadius: 8
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
                                space: "space.100",
                                children: [
                                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1DVhQ.default), {
                                        isShimmering: true,
                                        width: "100%",
                                        height: "84px",
                                        borderRadius: 8
                                    }),
                                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1DVhQ.default), {
                                        isShimmering: true,
                                        width: "100%",
                                        height: "40px",
                                        borderRadius: 0
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });

});


parcelRegister("6pwY1", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioConversationReviewRouteEntry", () => $c952d5f6c83845ad$export$8fa9ba2d9a9de6f8);

var $ffza4 = parcelRequire("ffza4");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $e2ctp = parcelRequire("e2ctp");

var $7NszV = parcelRequire("7NszV");

var $6Z2mh = parcelRequire("6Z2mh");

var $iReeE = parcelRequire("iReeE");

var $lDcQw = parcelRequire("lDcQw");

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $kgvfG = parcelRequire("kgvfG");

var $6gWZ1 = parcelRequire("6gWZ1");
const $c952d5f6c83845ad$var$getConversationReviewResources = ()=>(0, $lDcQw.resources).conversationReview;
const $c952d5f6c83845ad$export$8fa9ba2d9a9de6f8 = (0, $7NszV.createEntry)((0, $iReeE.helpCenterSettingsAgentStudioConversationReviewRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.agent-studio.conversation-review',
        entryPoint () {
            if (!(0, $4R6GH.fg)('enable_support_center_agent_studio_page')) return undefined;
            return 0, $kgvfG.csmAgentConversationReviewPageEntryPoint;
        },
        component: (0, $cSD7y.componentWithFG)('enable_support_center_agent_studio_page', (0, $kgvfG.AgentStudioConversationReview), (0, $5lsNZ.default)),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: (0, $6gWZ1.agentStudioNavigation),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            ...$c952d5f6c83845ad$var$getConversationReviewResources()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kgvfG.LazyAgentStudioConversationReviewPage)
        ],
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("iReeE", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioConversationReviewRoute", () => $51d40744c6e2396f$export$6d3fd8c6a2cde9ea);
const $51d40744c6e2396f$export$6d3fd8c6a2cde9ea = {
    name: 'helpcenter-settings-agent-studio-conversation-review',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/agent/review/:conversationId?',
    exact: true
};

});

parcelRegister("lDcQw", function(module, exports) {

$parcel$export(module.exports, "resources", () => $fe134765bf28c322$export$bc99aaabaf7b70a7);

var $d1dY0 = parcelRequire("d1dY0");
// packages/ai-mate/csm-conversation-review/src/ui/index.tsx
const $fe134765bf28c322$var$conversationRouteNameAndPathFields = {
    name: 'conversationReview',
    path: '/:conversationId?'
};
const $fe134765bf28c322$export$bc99aaabaf7b70a7 = {
    conversationReview: [
        (0, $d1dY0.conversationsResource),
        (0, $d1dY0.messagesResource)
    ]
};

});
parcelRegister("d1dY0", function(module, exports) {

$parcel$export(module.exports, "conversationsResource", () => $4587c71a5878019f$export$666da16fe604f76a);
$parcel$export(module.exports, "messagesResource", () => $4587c71a5878019f$export$e5eacbe7ea3678fe);

var $2M1hQ = parcelRequire("2M1hQ");

var $3gU0O = parcelRequire("3gU0O");

var $614ON = parcelRequire("614ON");

var $8JLfK = parcelRequire("8JLfK");

var $g8NKZ = parcelRequire("g8NKZ");

var $VSDnB = parcelRequire("VSDnB");
const $4587c71a5878019f$export$666da16fe604f76a = (0, $2M1hQ.createResource)({
    type: 'CONVERSATIONS',
    getKey: (ctx)=>`conversations-${(0, $614ON.serialiseFiltersQueryToSearchParams)((0, $614ON.getFiltersQuery)(ctx.query)).toString()}-${ctx.query.csmAiHubId}`,
    getData: async (ctx)=>{
        const headers = (0, $3gU0O.createHeaders)();
        const queryString = (0, $614ON.serialiseFiltersQueryToSearchParams)((0, $614ON.getFiltersQuery)(ctx.query));
        const containerBasedApiEnabled = (0, $VSDnB.fg)('csm_ai_use_container_ari_for_conversations');
        const baseUrl = containerBasedApiEnabled ? `${0, $8JLfK.API_GATEWAY_BASE_URL}/assist/csm/v2/reporting/${ctx.query.csmAiHubId}/conversations` : `${0, $8JLfK.API_GATEWAY_BASE_URL}/assist/csm/v2/reporting/conversations`;
        return fetch(`${baseUrl}?${queryString}`, {
            method: 'GET',
            headers: headers
        }).then((response)=>response.json()).then((data)=>{
            const conversations = data.items.filter((0, $g8NKZ.isNotExcludedOwner));
            const error = 'errorMessage' in data ? data : undefined;
            return {
                conversations: conversations,
                hasNext: data.hasNext || false,
                // V2 only
                cursor: data.cursor,
                error: error
            };
        });
    },
    isBrowserOnly: true
});
const $4587c71a5878019f$export$e5eacbe7ea3678fe = (0, $2M1hQ.createResource)({
    type: 'CONVERSATION_MESSAGES',
    getKey: ({ match: match })=>`conversation-messages-${match.params.conversationId}`,
    getData: async ({ match: match })=>{
        const conversationId = match.params.conversationId;
        if (!conversationId) return {
            messages: [],
            error: {
                errorMessage: 'No conversationId provided',
                errors: [
                    'Missing conversationId'
                ],
                statusCode: 400
            }
        };
        const headers = (0, $3gU0O.createHeaders)();
        return fetch(`${(0, $8JLfK.API_GATEWAY_BASE_URL)}/assist/csm/v2/reporting/conversations/${match.params.conversationId}/messages`, {
            method: 'GET',
            headers: headers
        }).then((response)=>response.json()).then((data)=>{
            const conversation = data.conversation;
            const messages = data.messages;
            const error = 'errorMessage' in data ? data : undefined;
            return {
                conversation: conversation,
                messages: messages,
                error: error
            };
        });
    },
    isBrowserOnly: true
});

});
parcelRegister("3gU0O", function(module, exports) {

$parcel$export(module.exports, "CLOUD_ID_HEADER", () => $e3a1955c3fa05404$export$220635283667d336);
$parcel$export(module.exports, "createHeaders", () => $e3a1955c3fa05404$export$197579c449ddabf4);
$parcel$export(module.exports, "getRequestHeadersForAnnotation", () => $e3a1955c3fa05404$export$61dc7354b71f29a6);
const $e3a1955c3fa05404$var$PRODUCT_HEADER = 'x-product';
const $e3a1955c3fa05404$var$EXPERIENCE_ID_HEADER = 'x-experience-id';
const $e3a1955c3fa05404$export$220635283667d336 = 'x-cloudid';
const $e3a1955c3fa05404$var$JIRA_PRODUCT = 'jira';
const $e3a1955c3fa05404$var$CSM_AI_EXPERIENCE_ID = 'csm-ai';
function $e3a1955c3fa05404$export$197579c449ddabf4(init) {
    return new Headers({
        [$e3a1955c3fa05404$var$PRODUCT_HEADER]: $e3a1955c3fa05404$var$JIRA_PRODUCT,
        [$e3a1955c3fa05404$var$EXPERIENCE_ID_HEADER]: $e3a1955c3fa05404$var$CSM_AI_EXPERIENCE_ID,
        ...init || {}
    });
}
function $e3a1955c3fa05404$export$61dc7354b71f29a6(cloudId) {
    const headers = $e3a1955c3fa05404$export$197579c449ddabf4({
        ...cloudId ? {
            [$e3a1955c3fa05404$export$220635283667d336]: cloudId
        } : {},
        'Content-Type': 'application/json'
    });
    return headers;
}

});

parcelRegister("614ON", function(module, exports) {

$parcel$export(module.exports, "BUILT_IN_FILTERS_BY_PARAM", () => $5d8ecb3a54f2cf91$export$f0b7684dd99bf7f2);
$parcel$export(module.exports, "isValidDateQueryValue", () => $5d8ecb3a54f2cf91$export$5e471de6d5eefc41);
$parcel$export(module.exports, "isFilterField", () => $5d8ecb3a54f2cf91$export$d8a98f7533d78e24);
$parcel$export(module.exports, "serialiseFiltersQueryToSearchParams", () => $5d8ecb3a54f2cf91$export$4966dc62d022f1b7);
$parcel$export(module.exports, "getFiltersQuery", () => $5d8ecb3a54f2cf91$export$ada173b2ef64ad5d);

var $8QpSo = parcelRequire("8QpSo");

var $17krc = parcelRequire("17krc");
const $5d8ecb3a54f2cf91$var$SUPPORTED_FILTER_TYPES = [
    'string',
    'enum',
    'number',
    'boolean',
    'date'
];
const $5d8ecb3a54f2cf91$export$f0b7684dd99bf7f2 = {
    type: {
        label: 'Conversation type',
        param: 'type',
        type: 'enum',
        options: [
            {
                label: 'Test',
                value: 'test'
            },
            {
                label: 'Real',
                value: 'real'
            },
            {
                label: 'Imported',
                value: 'imported'
            }
        ]
    },
    reviewStatus: {
        label: 'Conversation',
        param: 'reviewStatus',
        type: 'enum',
        options: [
            {
                label: 'Good conversation',
                value: 'good'
            },
            {
                label: 'Bad conversation',
                value: 'bad'
            },
            {
                label: 'Not review',
                value: 'not-reviewed'
            }
        ]
    },
    messageReviewStatus: {
        label: 'Response',
        param: 'messageReviewStatus',
        type: 'enum',
        options: [
            {
                label: 'Reviewed',
                value: 'reviewed'
            },
            {
                label: 'Not reviewed',
                value: 'not-reviewed'
            }
        ]
    },
    lastUpdated: {
        label: 'Last updated',
        param: 'lastUpdated',
        type: 'date'
    },
    feedback: {
        label: 'Customer feedback',
        param: 'feedback',
        type: 'enum',
        options: [
            {
                label: 'Good response',
                value: 'good'
            },
            {
                label: 'Bad response',
                value: 'bad'
            }
        ]
    },
    tags: {
        label: 'Review tags',
        param: 'tags',
        type: 'enum',
        options: [
            (0, $17krc.accuracyTagsGroup),
            (0, $17krc.languageTagsGroup),
            (0, $17krc.problemTagsGroup)
        ]
    }
};
const $5d8ecb3a54f2cf91$export$3060295572f39fc0 = Object.values($5d8ecb3a54f2cf91$export$f0b7684dd99bf7f2);
const $5d8ecb3a54f2cf91$export$7be404e211e7c3aa = new Map($5d8ecb3a54f2cf91$export$3060295572f39fc0.map((filter)=>[
        filter.param,
        filter
    ]));
const $5d8ecb3a54f2cf91$export$5e471de6d5eefc41 = (value)=>{
    if (typeof value === 'string') return [
        'today',
        'yesterday',
        'past7Days',
        'past30Days'
    ].includes(value);
    if (typeof value === 'object' && value) {
        if ('to' in value && 'from' in value) return [
            'string',
            'undefined'
        ].includes(typeof value.to) && [
            'string',
            'undefined'
        ].includes(typeof value.from);
        if ('to' in value) return [
            'string',
            'undefined'
        ].includes(typeof value.to);
        if ('from' in value) return [
            'string',
            'undefined'
        ].includes(typeof value.from);
    }
    return false;
};
const $5d8ecb3a54f2cf91$var$BUILT_IN_FILTER_QUERY_PARAMS = $5d8ecb3a54f2cf91$export$3060295572f39fc0.map(({ param: param })=>param);
const $5d8ecb3a54f2cf91$export$53c0ae385683a670 = (param)=>{
    return $5d8ecb3a54f2cf91$var$BUILT_IN_FILTER_QUERY_PARAMS.some((x)=>x === param);
};
const $5d8ecb3a54f2cf91$export$d8a98f7533d78e24 = (param)=>{
    return $5d8ecb3a54f2cf91$export$53c0ae385683a670(param);
};
const $5d8ecb3a54f2cf91$var$QUERY_STRING_PARSERS = {
    string: (value)=>value,
    number: (value)=>isNaN(Number(value)) ? undefined : Number(value),
    boolean: (value)=>[
            'true',
            'false'
        ].some((v)=>v === value) ? value : undefined,
    enum: (value)=>value.split(','),
    date: (value)=>{
        const betweenMatch = value.match(/^between\.(\d{4}-\d{2}-\d{2}(?:T.*Z)?)?\.(\d{4}-\d{2}-\d{2}(?:T.*Z)?)?$/);
        if (betweenMatch) {
            const [, a, b] = betweenMatch ?? [];
            const from = Boolean(a) ? a : undefined;
            const to = Boolean(b) ? b : undefined;
            return {
                from: from,
                to: to
            };
        }
        const fromToMatch = value.match(/^(from|to)\.(\d{4}-\d{2}-\d{2}(?:T.*Z)?)$/);
        if (fromToMatch) {
            const [, operation, date] = fromToMatch ?? [];
            return operation === 'from' ? {
                from: date
            } : {
                to: date
            };
        }
        if ($5d8ecb3a54f2cf91$export$5e471de6d5eefc41(value)) return value;
    }
};
const $5d8ecb3a54f2cf91$var$startOfDate = (date)=>{
    const newDate = new Date(date);
    newDate.setHours(0, 0, 0, 0);
    return newDate;
};
const $5d8ecb3a54f2cf91$var$normaliseDateString = (date, endOfDate)=>{
    const isDateOnlyString = /^\d{4}-\d{2}-\d{2}$/.test(date);
    if (!isDateOnlyString) return new Date(date);
    const d = new Date(date);
    if (!endOfDate) d.setHours(0, 0, 0, 0);
    else d.setHours(23, 59, 59, 999);
    return d;
};
const $5d8ecb3a54f2cf91$export$2ca7fe1ffae7d4ec = {
    type: (value)=>[
            [
                'conversationType',
                String(value)
            ]
        ],
    lastUpdated: (value)=>{
        if (typeof value === 'string') switch(value){
            case 'today':
                return [
                    [
                        'updatedAfter',
                        $5d8ecb3a54f2cf91$var$startOfDate(new Date()).toISOString()
                    ]
                ];
            case 'yesterday':
                return [
                    [
                        'updatedAfter',
                        $5d8ecb3a54f2cf91$var$startOfDate(new Date(new Date().setDate(new Date().getDate() - 1))).toISOString()
                    ],
                    [
                        'updatedBefore',
                        $5d8ecb3a54f2cf91$var$startOfDate(new Date(new Date().setDate(new Date().getDate() - 0))).toISOString()
                    ]
                ];
            case 'past7Days':
                return [
                    [
                        'updatedAfter',
                        $5d8ecb3a54f2cf91$var$startOfDate(new Date(new Date().setDate(new Date().getDate() - 7))).toISOString()
                    ]
                ];
            case 'past30Days':
                return [
                    [
                        'updatedAfter',
                        $5d8ecb3a54f2cf91$var$startOfDate(new Date(new Date().setDate(new Date().getDate() - 30))).toISOString()
                    ]
                ];
        }
        if (typeof value === 'object') {
            if ('from' in value && 'to' in value && value.from && value.to) return [
                [
                    'updatedAfter',
                    $5d8ecb3a54f2cf91$var$normaliseDateString(value.from).toISOString()
                ],
                [
                    'updatedBefore',
                    $5d8ecb3a54f2cf91$var$normaliseDateString(value.to, true).toISOString()
                ]
            ];
            if ('from' in value && value.from) return [
                [
                    'updatedAfter',
                    $5d8ecb3a54f2cf91$var$normaliseDateString(value.from).toISOString()
                ]
            ];
            if ('to' in value && value.to) return [
                [
                    'updatedBefore',
                    $5d8ecb3a54f2cf91$var$normaliseDateString(value.to).toISOString()
                ]
            ];
        }
        return [];
    },
    feedback: (value)=>[
            [
                'customerFeedback',
                String(value)
            ]
        ],
    reviewStatus: (value)=>[
            [
                'conversationReviewStatus',
                String(value)
            ]
        ],
    messageReviewStatus: (value)=>[
            [
                'messageReviewStatus',
                String(value)
            ]
        ],
    tags: (value)=>[
            [
                'annotatedLabels',
                String(value)
            ]
        ]
};
const $5d8ecb3a54f2cf91$export$49da2961ae0c0fca = {
    ...$5d8ecb3a54f2cf91$export$2ca7fe1ffae7d4ec,
    lastUpdated: (value)=>{
        if (typeof value === 'string') switch(value){
            case 'today':
                return [
                    [
                        'lastMessageTimestampAfter',
                        $5d8ecb3a54f2cf91$var$startOfDate(new Date()).toISOString()
                    ]
                ];
            case 'yesterday':
                return [
                    [
                        'lastMessageTimestampAfter',
                        $5d8ecb3a54f2cf91$var$startOfDate(new Date(new Date().setDate(new Date().getDate() - 1))).toISOString()
                    ],
                    [
                        'lastMessageTimestampBefore',
                        $5d8ecb3a54f2cf91$var$startOfDate(new Date(new Date().setDate(new Date().getDate() - 0))).toISOString()
                    ]
                ];
            case 'past7Days':
                return [
                    [
                        'lastMessageTimestampAfter',
                        $5d8ecb3a54f2cf91$var$startOfDate(new Date(new Date().setDate(new Date().getDate() - 7))).toISOString()
                    ]
                ];
            case 'past30Days':
                return [
                    [
                        'lastMessageTimestampAfter',
                        $5d8ecb3a54f2cf91$var$startOfDate(new Date(new Date().setDate(new Date().getDate() - 30))).toISOString()
                    ]
                ];
        }
        if (typeof value === 'object') {
            if ('from' in value && 'to' in value && value.from && value.to) return [
                [
                    'lastMessageTimestampAfter',
                    $5d8ecb3a54f2cf91$var$normaliseDateString(value.from).toISOString()
                ],
                [
                    'lastMessageTimestampBefore',
                    $5d8ecb3a54f2cf91$var$normaliseDateString(value.to, true).toISOString()
                ]
            ];
            if ('from' in value && value.from) return [
                [
                    'lastMessageTimestampAfter',
                    $5d8ecb3a54f2cf91$var$normaliseDateString(value.from).toISOString()
                ]
            ];
            if ('to' in value && value.to) return [
                [
                    'lastMessageTimestampBefore',
                    $5d8ecb3a54f2cf91$var$normaliseDateString(value.to).toISOString()
                ]
            ];
        }
        return [];
    }
};
const $5d8ecb3a54f2cf91$export$4966dc62d022f1b7 = (0, $8QpSo.default)((query)=>{
    return Object.entries(query).reduce((searchParams, [param, value])=>{
        const filters = $5d8ecb3a54f2cf91$export$7be404e211e7c3aa;
        const filter = filters.get(param);
        if (!filter || typeof value === 'undefined') return searchParams;
        const serialisers = $5d8ecb3a54f2cf91$export$49da2961ae0c0fca;
        const serialiser = serialisers[filter.param];
        if (filter.param in serialisers) {
            const params = serialiser(value);
            params.forEach(([key, value])=>{
                searchParams.append(key, value);
            });
            return searchParams;
        }
        return searchParams;
    }, new URLSearchParams());
});
const $5d8ecb3a54f2cf91$export$ada173b2ef64ad5d = (0, $8QpSo.default)((query)=>{
    const filters = $5d8ecb3a54f2cf91$export$7be404e211e7c3aa;
    return Object.entries(query).reduce((acc, [param, value])=>{
        if (!$5d8ecb3a54f2cf91$export$d8a98f7533d78e24(param)) return acc;
        const filter = filters.get(param);
        if (!filter) return acc;
        try {
            const parsedValue = $5d8ecb3a54f2cf91$var$QUERY_STRING_PARSERS[filter.type](value);
            return {
                ...acc,
                [param]: parsedValue
            };
        } catch (err) {
            return acc;
        }
    }, {});
});

});
parcelRegister("17krc", function(module, exports) {

$parcel$export(module.exports, "accuracyTagsGroup", () => $1c6e3e443781646c$export$f592d323cd45fe0b);
$parcel$export(module.exports, "languageTagsGroup", () => $1c6e3e443781646c$export$bd57e646b9ca4d6);
$parcel$export(module.exports, "problemTagsGroup", () => $1c6e3e443781646c$export$f12ac532d5145c52);
const $1c6e3e443781646c$export$40b86a6296d7a6cc = [
    {
        label: 'Accurate',
        value: 'accurate'
    },
    {
        label: 'Not accurate',
        value: 'not-accurate'
    }
];
const $1c6e3e443781646c$export$f592d323cd45fe0b = {
    label: 'Accuracy',
    options: $1c6e3e443781646c$export$40b86a6296d7a6cc
};
const $1c6e3e443781646c$export$f1009b3c58b25589 = [
    {
        label: 'Easy to understand',
        value: 'easy-to-understand'
    },
    {
        label: 'Hard to understand',
        value: 'hard-to-understand'
    },
    {
        label: 'Concise',
        value: 'concise'
    },
    {
        label: 'Verbose',
        value: 'verbose'
    },
    {
        label: 'Grammatical errors',
        value: 'grammatical-errors'
    },
    {
        label: 'Formatting errors',
        value: 'formatting-errors'
    },
    {
        label: 'Incorrect tone',
        value: 'incorrect-tone'
    }
];
const $1c6e3e443781646c$export$bd57e646b9ca4d6 = {
    label: 'Language',
    options: $1c6e3e443781646c$export$f1009b3c58b25589
};
const $1c6e3e443781646c$export$ea5f6f7f4df4b955 = [
    {
        label: 'Vague question',
        value: 'vaque-question'
    },
    {
        label: 'Irrelevant answer',
        value: 'irrelevant-answer'
    },
    {
        label: 'Human required',
        value: 'human-required'
    },
    {
        label: 'Content not retrieved',
        value: 'content-not-retrieved'
    },
    {
        label: 'Missing links',
        value: 'missing-links'
    },
    {
        label: 'Incorrect source',
        value: 'incorrect-source'
    }
];
const $1c6e3e443781646c$export$f12ac532d5145c52 = {
    label: 'Problems',
    options: $1c6e3e443781646c$export$ea5f6f7f4df4b955
};

});


parcelRegister("8JLfK", function(module, exports) {

$parcel$export(module.exports, "API_GATEWAY_BASE_URL", () => $b6313a29e003fab0$export$d9629d145ee9933b);
const $b6313a29e003fab0$export$d9629d145ee9933b = '/gateway/api';
function $b6313a29e003fab0$export$23da1d24a38b0bde() {
    const hostname = window.location.hostname;
    return hostname.includes('localhost') || hostname.includes('.stg.internal.atlassian') || hostname.includes('.stg.atlassian');
}

});

parcelRegister("g8NKZ", function(module, exports) {

$parcel$export(module.exports, "isNotExcludedOwner", () => $566d186f00e19b13$export$f4707ebc2561f73d);
// Users who's conversations should be excluded from the list
const $566d186f00e19b13$export$9112ec7e6c72159b = [
    // Staging test bot
    'ari:cloud:identity::user/61c2c7a390cfd2007154ede7',
    // Prod test bot - 'cst-e2e-test-bot
    'ari:cloud:identity::user/61bc6c272f24e70068bf462a'
];
const $566d186f00e19b13$export$f4707ebc2561f73d = (c)=>{
    return !$566d186f00e19b13$export$9112ec7e6c72159b.includes(c.owner);
};

});




parcelRegister("gQABM", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioHandoffRouteEntry", () => $0537c5be2e29ef16$export$df69744b9adaa993);

var $4R6GH = parcelRequire("4R6GH");

var $e2ctp = parcelRequire("e2ctp");

var $5lsNZ = parcelRequire("5lsNZ");

var $fpjJX = parcelRequire("fpjJX");

var $7NszV = parcelRequire("7NszV");

var $6Z2mh = parcelRequire("6Z2mh");

var $58uk4 = parcelRequire("58uk4");

var $6gWZ1 = parcelRequire("6gWZ1");

var $kgvfG = parcelRequire("kgvfG");
const $0537c5be2e29ef16$export$df69744b9adaa993 = (0, $7NszV.createEntry)((0, $58uk4.helpCenterSettingsAgentStudioHandoffRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.agent-studio-handoff',
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('csm_ai_agent_builder_handoff') ? (0, $kgvfG.csmAgentHandoffPageEntryPoint) : undefined;
        },
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: (0, $6gWZ1.agentStudioNavigation),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ],
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("58uk4", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioHandoffRoute", () => $0fed46fe26c2e78b$export$d23d0e34831b4de5);
const $0fed46fe26c2e78b$export$d23d0e34831b4de5 = {
    name: 'helpcenter-settings-agent-studio-handoff',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/agent/handoff',
    exact: true
};

});


parcelRegister("9sgxL", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioKnowledgeRouteEntry", () => $34dc2eb2639959d6$export$6d22d206a282d6a9);

var $4R6GH = parcelRequire("4R6GH");

var $e2ctp = parcelRequire("e2ctp");

var $5lsNZ = parcelRequire("5lsNZ");

var $fpjJX = parcelRequire("fpjJX");

var $7NszV = parcelRequire("7NszV");

var $6Z2mh = parcelRequire("6Z2mh");

var $fCFMo = parcelRequire("fCFMo");

var $gLUA7 = parcelRequire("gLUA7");

var $6gWZ1 = parcelRequire("6gWZ1");

var $kgvfG = parcelRequire("kgvfG");
const $34dc2eb2639959d6$export$6d22d206a282d6a9 = (0, $7NszV.createEntry)((0, $gLUA7.helpCenterSettingsAgentStudioKnowledgeRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.agent-studio-knowledge',
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('enable_support_center_agent_studio_page') ? (0, $kgvfG.agentStudioKnowledgePageEntryPoint) : undefined;
        },
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: (0, $6gWZ1.agentStudioNavigation),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $fCFMo.knowledgeSourcesResource)
        ],
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("fCFMo", function(module, exports) {

$parcel$export(module.exports, "knowledgeSourcesResource", () => $d492004289a23794$export$98ae61e83ea268b1);

var $2M1hQ = parcelRequire("2M1hQ");
const $d492004289a23794$var$TWENTY_FOUR_HOURS_IN_MS = 86400000;

const $d492004289a23794$export$98ae61e83ea268b1 = (0, $2M1hQ.createResource)({
    type: 'CSM_AGENT_CONFIGURATION_KNOWLEDGE_SOURCES',
    getKey: (routerContext)=>`knowledge-sources-${routerContext.query.agentId}`,
    getData: (routerContext)=>(parcelRequire("3v17H")).then((module)=>module.default(routerContext.query.agentId)),
    maxAge: $d492004289a23794$var$TWENTY_FOUR_HOURS_IN_MS,
    isBrowserOnly: true
});

});
parcelRegister("3v17H", function(module, exports) {

let $28c523662ab125a0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $28c523662ab125a0$var$load("lzESI").then(()=>parcelRequire('hScnq'));

});


parcelRegister("gLUA7", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioKnowledgeRoute", () => $d0a24339f6e35337$export$f1df26b41169b43);
const $d0a24339f6e35337$export$f1df26b41169b43 = {
    name: 'helpcenter-settings-agent-studio-knowledge',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/agent/knowledge',
    exact: true
};

});


parcelRegister("alZMU", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioRouteEntry", () => $331ec935012c0277$export$5328c10e46075e4d);

var $4R6GH = parcelRequire("4R6GH");

var $ffza4 = parcelRequire("ffza4");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $6Z2mh = parcelRequire("6Z2mh");

var $e2ctp = parcelRequire("e2ctp");

var $7NszV = parcelRequire("7NszV");

var $k2Bg0 = parcelRequire("k2Bg0");

var $cSD7y = parcelRequire("cSD7y");

var $kgvfG = parcelRequire("kgvfG");

var $6gWZ1 = parcelRequire("6gWZ1");
const $331ec935012c0277$export$5328c10e46075e4d = (0, $7NszV.createEntry)((0, $k2Bg0.helpCenterSettingsAgentStudioRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.agent-studio',
        // For either return undefined scenario, it will fallback to the component config below
        entryPoint () {
            if (!(0, $4R6GH.fg)('enable_support_center_agent_studio_page')) return undefined;
            return 0, $kgvfG.csmAgentOverviewPageEntryPoint;
        },
        component: (0, $cSD7y.componentWithFG)('enable_support_center_agent_studio_page', (0, $kgvfG.AgentStudioOverviewPage), (0, $5lsNZ.default)),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: (0, $6gWZ1.agentStudioNavigation),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kgvfG.LazyAgentStudioOverviewPage)
        ],
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("k2Bg0", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioRoute", () => $22c785b6be90cb91$export$b8b0efb16984db50);
const $22c785b6be90cb91$export$b8b0efb16984db50 = {
    name: 'helpcenter-settings-agent-studio',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/agent',
    exact: true
};

});


parcelRegister("lVyEk", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAnalyticsRouteEntry", () => $ea9995db41d502d1$export$13d5cfdc3231d970);

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $5lsNZ = parcelRequire("5lsNZ");

var $6LApU = parcelRequire("6LApU");

var $6HgQO = parcelRequire("6HgQO");
const $ea9995db41d502d1$export$13d5cfdc3231d970 = (0, $7NszV.createEntry)((0, $6LApU.helpCenterSettingsAnalyticsRoute), ()=>({
        group: 'customer-service',
        perfMetricKey: 'customer-service.analytics',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
        },
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('jcs-analytics-page') ? (0, $6HgQO.helpCenterSettingsAnalyticsRoutePageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ]
    }));

});
parcelRegister("6LApU", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAnalyticsRoute", () => $02d8dbaff147f01e$export$1487d4661960397f);
const $02d8dbaff147f01e$export$1487d4661960397f = {
    exact: true,
    name: 'customer-service-helpcenter-analytics',
    path: '/jira/helpcenter/analytics'
};

});

parcelRegister("6HgQO", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAnalyticsRoutePageEntryPoint", () => $44f12967ed405696$export$cb0b3a882806ef6e);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $6aw3i = parcelRequire("6aw3i");
const $44f12967ed405696$export$cb0b3a882806ef6e = (0, $lkFvK.createPageEntryPoint)({
    main: $6aw3i.helpCenterSettingsAnalyticsAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("6aw3i", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAnalyticsAppEntryPoint", () => $0e5696f7f2194583$export$fa405dadb950b4a6);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $0e5696f7f2194583$export$fa405dadb950b4a6 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("6gqoz")), {
        moduleId: "19032ae8",
        priority: "interaction"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("6gqoz", function(module, exports) {

let $48f8b6421016c939$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $48f8b6421016c939$var$load("kNFvF"),
    $48f8b6421016c939$var$load("ffQaD"),
    $48f8b6421016c939$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("1Fg4H"), 4)),
    $48f8b6421016c939$var$load("fliVL"),
    $48f8b6421016c939$var$load("76n7a"),
    $48f8b6421016c939$var$load("l253H"),
    $48f8b6421016c939$var$load("8xMJk")
]).then(()=>parcelRequire('h1w7n'));

});




parcelRegister("6u3qv", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsArticlesRouteEntry", () => $32bcb1fc70286108$export$dcf98310ab461eb0);

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $9kAH1 = parcelRequire("9kAH1");

var $6Z2mh = parcelRequire("6Z2mh");

var $6gWZ1 = parcelRequire("6gWZ1");

var $8N6gO = parcelRequire("8N6gO");
const $32bcb1fc70286108$export$dcf98310ab461eb0 = (0, $7NszV.createEntry)((0, $9kAH1.helpCenterSettingsArticlesRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.articles',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: $6gWZ1.navigation,
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('enable_articles_page_csm') ? (0, $8N6gO.helpCenterSettingArticlesAppPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ]
    }));

});
parcelRegister("9kAH1", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsArticlesRoute", () => $412bb66633bbef70$export$6445613754b0db30);
const $412bb66633bbef70$export$6445613754b0db30 = {
    name: 'helpcenter-settings-articles',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/articles',
    exact: true
};

});

parcelRegister("8N6gO", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingArticlesAppPageEntryPoint", () => $9b45af5968e8d332$export$5f683051fd990adb);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $630bL = parcelRequire("630bL");
const $9b45af5968e8d332$export$5f683051fd990adb = (0, $lkFvK.createPageEntryPoint)({
    main: $630bL.HelpCenterSettingsArticlesAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("630bL", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsArticlesAppEntryPoint", () => $ba27834c1284a762$export$ba888b162abf6368);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $ba27834c1284a762$export$ba888b162abf6368 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("329Po")), {
        moduleId: "8c0e0839",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("329Po", function(module, exports) {

let $23592ea20e3d5c82$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $23592ea20e3d5c82$var$load("ffQaD"),
    $23592ea20e3d5c82$var$load("kvRbA"),
    $23592ea20e3d5c82$var$load("bpRYe")
]).then(()=>parcelRequire('eFox7'));

});




parcelRegister("j2SDi", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsArticlesViewArticleRouteEntry", () => $88e0a8f5dda84f20$export$d14f4c2b666bbb54);

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $6zrpv = parcelRequire("6zrpv");

var $6Z2mh = parcelRequire("6Z2mh");

var $6gWZ1 = parcelRequire("6gWZ1");

var $3Ap7x = parcelRequire("3Ap7x");
const $88e0a8f5dda84f20$export$d14f4c2b666bbb54 = (0, $7NszV.createEntry)((0, $6zrpv.helpCenterSettingsArticlesViewArticleRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.articles-view-article',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: $6gWZ1.navigation,
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('enable_articles_page_csm') ? (0, $3Ap7x.helpCenterSettingViewArticleAppPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ]
    }));

});
parcelRegister("6zrpv", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsArticlesViewArticleRoute", () => $2f69465d47479faa$export$c5c6fbcb1f26b87b);
const $2f69465d47479faa$export$c5c6fbcb1f26b87b = {
    name: 'helpcenter-settings-articles-view-article',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/articles/:articleId',
    exact: true
};

});

parcelRegister("3Ap7x", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingViewArticleAppPageEntryPoint", () => $aeb454237a95509d$export$7f08ea9d5c2912ad);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $ji0Vr = parcelRequire("ji0Vr");
const $aeb454237a95509d$export$7f08ea9d5c2912ad = (0, $lkFvK.createPageEntryPoint)({
    main: $ji0Vr.HelpCenterSettingsArticlesViewArticleAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("ji0Vr", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsArticlesViewArticleAppEntryPoint", () => $96a8b60127af2d58$export$31df33b35c5b2ee);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $96a8b60127af2d58$export$31df33b35c5b2ee = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("BRbGT")), {
        moduleId: "6cb514e3",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("BRbGT", function(module, exports) {

let $071cb6c1f6814196$var$load = (parcelRequire("28QjX"))(4);
module.exports = $071cb6c1f6814196$var$load("98lbG").then(()=>parcelRequire('1yKGc'));

});




parcelRegister("e48vl", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsCreateArticleRouteEntry", () => $57dff6ea3b7a57a0$export$882f07b6a7d364c7);

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $1huwb = parcelRequire("1huwb");

var $6Z2mh = parcelRequire("6Z2mh");

var $6gWZ1 = parcelRequire("6gWZ1");

var $flVeW = parcelRequire("flVeW");
const $57dff6ea3b7a57a0$export$882f07b6a7d364c7 = (0, $7NszV.createEntry)((0, $1huwb.helpCenterSettingsCreateArticleRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.create-article',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: $6gWZ1.navigation,
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('enable_articles_page_csm') ? (0, $flVeW.helpCenterSettingCreateArticleAppPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ]
    }));

});
parcelRegister("1huwb", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsCreateArticleRoute", () => $7549b70b1a3f48a6$export$6f4350070b3391d2);
const $7549b70b1a3f48a6$export$6f4350070b3391d2 = {
    name: 'helpcenter-settings-create-article',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/articles/:articleId/space/:spaceKey/edit',
    query: [
        'draftShareId?',
        'topicId?'
    ]
};

});

parcelRegister("flVeW", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingCreateArticleAppPageEntryPoint", () => $e1fa58280d3204d3$export$2dedebb94d500afa);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $ljlmd = parcelRequire("ljlmd");
const $e1fa58280d3204d3$export$2dedebb94d500afa = (0, $lkFvK.createPageEntryPoint)({
    main: $ljlmd.HelpCenterSettingsCreateArticleAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("ljlmd", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsCreateArticleAppEntryPoint", () => $fd79767a8e638019$export$dd82613d258b9120);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $fd79767a8e638019$export$dd82613d258b9120 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("9VL1r")), {
        moduleId: "d6a89104",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("9VL1r", function(module, exports) {

let $73ade9902fe061b1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $73ade9902fe061b1$var$load("16C5P").then(()=>parcelRequire('iDGEe'));

});




parcelRegister("jSJ1v", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsCustomerAccessRouteEntry", () => $1e207cd846476f87$export$5cfeb28cf3c43d24);

var $ffza4 = parcelRequire("ffza4");

var $cSD7y = parcelRequire("cSD7y");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $hyajn = parcelRequire("hyajn");

var $6Z2mh = parcelRequire("6Z2mh");

var $6gWZ1 = parcelRequire("6gWZ1");

var $7aOCJ = parcelRequire("7aOCJ");
const $1e207cd846476f87$export$5cfeb28cf3c43d24 = (0, $7NszV.createEntry)((0, $hyajn.helpCenterSettingsCustomerAccessRoute), ()=>({
        perfMetricKey: 'help-center-settings.customer-access',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: $6gWZ1.navigation,
        component: (0, $cSD7y.componentWithFG)('jcs_master_flag', (0, $7aOCJ.HelpCenterSettingsCustomerAccess), (0, $5lsNZ.default)),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7aOCJ.LazyHelpCenterSettingsCustomerAccess)
        ],
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ]
    }));

});
parcelRegister("hyajn", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsCustomerAccessRoute", () => $956ef53bef7f74b8$export$5adf9b8f07e4dd7b);
const $956ef53bef7f74b8$export$5adf9b8f07e4dd7b = {
    name: 'helpcenter-settings-customer-access',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/customer-access'
};

});

parcelRegister("7aOCJ", function(module, exports) {

$parcel$export(module.exports, "LazyHelpCenterSettingsCustomerAccess", () => $c2a27ef145addce1$export$2c331ddbdb6fb4ef);
$parcel$export(module.exports, "HelpCenterSettingsCustomerAccess", () => $c2a27ef145addce1$export$ab643bb246877df);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $c2a27ef145addce1$export$2c331ddbdb6fb4ef = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("912hJ"))), {
    moduleId: "./src/packages/spa-apps/help-center-settings/customer-access/src/index.tsx"
});
const $c2a27ef145addce1$export$ab643bb246877df = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $c2a27ef145addce1$export$2c331ddbdb6fb4ef,
        pageId: "help-center-settings-customer-access",
        shouldShowSpinner: true
    });

});
parcelRegister("912hJ", function(module, exports) {

let $6905faccb26fbfa3$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6905faccb26fbfa3$var$load("76n7a"),
    $6905faccb26fbfa3$var$load("l253H"),
    $6905faccb26fbfa3$var$load("bfO34")
]).then(()=>parcelRequire('lQS7P'));

});



parcelRegister("fdHNd", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsCustomerNotificationsRouteEntry", () => $7e976989bafafd81$export$4e4f38417d267cf6);

var $ffza4 = parcelRequire("ffza4");

var $cSD7y = parcelRequire("cSD7y");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $6cuak = parcelRequire("6cuak");

var $6Z2mh = parcelRequire("6Z2mh");

var $6gWZ1 = parcelRequire("6gWZ1");

var $jp5Vz = parcelRequire("jp5Vz");
const $7e976989bafafd81$export$4e4f38417d267cf6 = (0, $7NszV.createEntry)((0, $6cuak.helpCenterSettingsCustomerNotificationsRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.customer-notifications',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: $6gWZ1.navigation,
        component: (0, $cSD7y.componentWithFG)('jcs_master_flag', (0, $jp5Vz.HelpCenterSettingsCustomerNotifications), (0, $5lsNZ.default)),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jp5Vz.LazyHelpCenterSettingsCustomerNotifications)
        ],
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ]
    }));

});
parcelRegister("6cuak", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsCustomerNotificationsRoute", () => $e11b5b1fd2c66498$export$88fcb9acf40a0827);
const $e11b5b1fd2c66498$export$88fcb9acf40a0827 = {
    name: 'helpcenter-settings-customer-notifications',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/customer-notifications'
};

});

parcelRegister("jp5Vz", function(module, exports) {

$parcel$export(module.exports, "LazyHelpCenterSettingsCustomerNotifications", () => $ce252471da0db8c1$export$b2b6550dec008a98);
$parcel$export(module.exports, "HelpCenterSettingsCustomerNotifications", () => $ce252471da0db8c1$export$2f2f18f57014444a);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $ce252471da0db8c1$export$b2b6550dec008a98 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("lQYjh"))), {
    moduleId: "./src/packages/spa-apps/help-center-settings/customer-notifications/src/index.tsx"
});
const $ce252471da0db8c1$export$2f2f18f57014444a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ce252471da0db8c1$export$b2b6550dec008a98,
        pageId: "help-center-settings-customer-notifications",
        shouldShowSpinner: true
    });

});
parcelRegister("lQYjh", function(module, exports) {

let $041b0d5d42d050e9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $041b0d5d42d050e9$var$load("fopkd").then(()=>parcelRequire('7QYfj'));

});



parcelRegister("guURi", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsDetailsRouteEntry", () => $0315c5537179bf15$export$a9c03c3c37251dd3);

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $hTsNV = parcelRequire("hTsNV");

var $6Z2mh = parcelRequire("6Z2mh");

var $6gWZ1 = parcelRequire("6gWZ1");

var $gD7KY = parcelRequire("gD7KY");
const $0315c5537179bf15$export$a9c03c3c37251dd3 = (0, $7NszV.createEntry)((0, $hTsNV.helpCenterSettingsDetailsRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.details',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: $6gWZ1.navigation,
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('jcs_master_flag') ? (0, $gD7KY.helpCenterSettingDetailsAppPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ]
    }));

});
parcelRegister("hTsNV", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsDetailsRoute", () => $c84b441b3d2b2a1a$export$f54c1546ddea019b);
const $c84b441b3d2b2a1a$export$f54c1546ddea019b = {
    name: 'helpcenter-settings-details',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/details',
    exact: true
};

});

parcelRegister("gD7KY", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingDetailsAppPageEntryPoint", () => $145a2f3e4b766427$export$c52cb026d0dc8ed7);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $16x51 = parcelRequire("16x51");
const $145a2f3e4b766427$export$c52cb026d0dc8ed7 = (0, $lkFvK.createPageEntryPoint)({
    main: $16x51.helpCenterSettingDetailsAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("16x51", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingDetailsAppEntryPoint", () => $f508c84d71030ec3$export$519ec4ef3722cb47);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $26seq = parcelRequire("26seq");

const $f508c84d71030ec3$export$519ec4ef3722cb47 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("drPd0")), {
        moduleId: "e9a696a2",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>({
            queries: {
                serviceHubDetailsQuery: {
                    parameters: $26seq.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("26seq", function(module, exports) {

$parcel$export(module.exports, "default", () => $5995ee8670b27cd9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<067fa7fbcebd00e597b347ca915f6034>>
 * @relayHash fd0d1d5dce03064b407037920fb2720b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e73190d907fbed87beb0dcedf5843143674119a51c7aba6c42a0159b955a42d1
const $5995ee8670b27cd9$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "e73190d907fbed87beb0dcedf5843143674119a51c7aba6c42a0159b955a42d1",
        "metadata": {},
        "name": "uiServiceHubDetailsPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $5995ee8670b27cd9$export$2e2bcd8739ae039 = $5995ee8670b27cd9$var$node;

});

parcelRegister("drPd0", function(module, exports) {

let $9ca584fbfa6d9ae5$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9ca584fbfa6d9ae5$var$load("76n7a"),
    $9ca584fbfa6d9ae5$var$load("l253H"),
    $9ca584fbfa6d9ae5$var$load("hKY0Y")
]).then(()=>parcelRequire('kGNbu'));

});




parcelRegister("6RCDC", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsEmailRouteEntry", () => $a5ff5d25549b46ce$export$f95717dac47e4db3);

var $ffza4 = parcelRequire("ffza4");

var $cSD7y = parcelRequire("cSD7y");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $9wcYQ = parcelRequire("9wcYQ");

var $6Z2mh = parcelRequire("6Z2mh");

var $6gWZ1 = parcelRequire("6gWZ1");

var $lUb7T = parcelRequire("lUb7T");
const $a5ff5d25549b46ce$export$f95717dac47e4db3 = (0, $7NszV.createEntry)((0, $9wcYQ.helpCenterSettingsEmailRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.email',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: $6gWZ1.navigation,
        component: (0, $cSD7y.componentWithFG)('jcs_master_flag', (0, $lUb7T.HelpCenterSettingsEmail), (0, $5lsNZ.default)),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $lUb7T.LazyHelpCenterSettingsEmail)
        ],
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ]
    }));

});
parcelRegister("9wcYQ", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsEmailRoute", () => $1e498e8ebd1ddcd1$export$4515288a48c62087);
const $1e498e8ebd1ddcd1$export$4515288a48c62087 = {
    name: 'helpcenter-settings-email',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/email',
    exact: true
};

});

parcelRegister("lUb7T", function(module, exports) {

$parcel$export(module.exports, "LazyHelpCenterSettingsEmail", () => $6353b69d503ce9ba$export$e090cd3a62343249);
$parcel$export(module.exports, "HelpCenterSettingsEmail", () => $6353b69d503ce9ba$export$962f20e752738967);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $6353b69d503ce9ba$export$e090cd3a62343249 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("dn1HB")), {
    moduleId: "./src/packages/spa-apps/help-center-settings/email/src/index.tsx"
});
const $6353b69d503ce9ba$export$962f20e752738967 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $6353b69d503ce9ba$export$e090cd3a62343249,
        pageId: "help-center-settings-email",
        shouldShowSpinner: true
    });

});
parcelRegister("dn1HB", function(module, exports) {

let $9bbebe60fd3c317e$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9bbebe60fd3c317e$var$load("ffQaD"),
    $9bbebe60fd3c317e$var$load("kvRbA"),
    $9bbebe60fd3c317e$var$load("d036g")
]).then(()=>parcelRequire('7r8zn'));

});



parcelRegister("9aEQn", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsFormEditRouteEntry", () => $dca661aacd919783$export$1750cfcab794a07d);

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $fCXWg = parcelRequire("fCXWg");

var $5lsNZ = parcelRequire("5lsNZ");

var $fmqJw = parcelRequire("fmqJw");

var $6Z2mh = parcelRequire("6Z2mh");

var $6gWZ1 = parcelRequire("6gWZ1");

var $7VD4g = parcelRequire("7VD4g");
const $dca661aacd919783$export$1750cfcab794a07d = (0, $7NszV.createEntry)((0, $fmqJw.helpCenterSettingsFormEditRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.form-edit',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: $6gWZ1.navigation,
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('jcs_master_flag') ? (0, $7VD4g.helpCenterSettingFormEditAppPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $fCXWg.formEditJirafieldsResource)
        ]
    }));

});
parcelRegister("fCXWg", function(module, exports) {

$parcel$export(module.exports, "formEditJirafieldsResource", () => $0b2fb9f25d526504$export$ca58e1498fd1ff3e);
$parcel$export(module.exports, "useFormEditJirafields", () => $0b2fb9f25d526504$export$8a76fadb956ce203);

var $dK8AG = parcelRequire("dK8AG");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

const $0b2fb9f25d526504$var$getDataLoader = ()=>(parcelRequire("2P1yL"));
const $0b2fb9f25d526504$export$ca58e1498fd1ff3e = (0, $2M1hQ.createResource)({
    type: 'HELP_CENTER_FORM_EDIT_JIRAFIELDS_RESOURCE',
    getKey: ({ match: match })=>(0, $dK8AG.getProjectKeyOrId)(match),
    getDataLoader: $0b2fb9f25d526504$var$getDataLoader,
    isBrowserOnly: true
});
const $0b2fb9f25d526504$export$8a76fadb956ce203 = ()=>(0, $2YP9W.useResource)($0b2fb9f25d526504$export$ca58e1498fd1ff3e);

});
parcelRegister("2P1yL", function(module, exports) {

let $20e18de93309751e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $20e18de93309751e$var$load("lELr1").then(()=>parcelRequire('5Kre9'));

});


parcelRegister("fmqJw", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsFormEditRoute", () => $76127e6b6297617e$export$31bd3e10c42460dc);
const $76127e6b6297617e$export$31bd3e10c42460dc = {
    exact: true,
    name: 'helpcenter-settings-form-edit',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/forms/:formId'
};

});

parcelRegister("7VD4g", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingFormEditAppPageEntryPoint", () => $73a7c9331a7a621d$export$2792cba2387cbc5c);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $aXX0d = parcelRequire("aXX0d");
const $73a7c9331a7a621d$export$2792cba2387cbc5c = (0, $lkFvK.createPageEntryPoint)({
    main: $aXX0d.helpCenterSettingFormEditAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("aXX0d", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingFormEditAppEntryPoint", () => $dcaafae9dc3cdb4f$export$262512d610e494f8);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $jVPFz = parcelRequire("jVPFz");

const $dcaafae9dc3cdb4f$export$262512d610e494f8 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("hNYOp")), {
        moduleId: "d82eb4d8",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId, formId: formId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>({
            queries: {
                uiFormEditRoutingQuery: {
                    parameters: $jVPFz.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
                        templateFormAri: `ari:cloud:jira-customer-service::template-form/activation/${activationId}/${formId}`
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("jVPFz", function(module, exports) {

$parcel$export(module.exports, "default", () => $05a055aee7ffa295$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e08557ab552bf44df293cd7626377d57>>
 * @relayHash 25cf59f5b03aae972cf632dae9685f3c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7dd46115cf70ad94d508dc1c7421a44d4cff3f62c44724b51e2c900cb6cfe9d3
const $05a055aee7ffa295$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "7dd46115cf70ad94d508dc1c7421a44d4cff3f62c44724b51e2c900cb6cfe9d3",
        "metadata": {},
        "name": "uiFormEditRoutingQuery",
        "operationKind": "query",
        "text": null
    }
};
var $05a055aee7ffa295$export$2e2bcd8739ae039 = $05a055aee7ffa295$var$node;

});

parcelRegister("hNYOp", function(module, exports) {

let $cf662f446745e979$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cf662f446745e979$var$load("8NSzi").then(()=>parcelRequire('3XNgZ'));

});




parcelRegister("gZQLD", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsFormsRouteEntry", () => $752d7b6fe60c2c67$export$9a67aaae787c9f40);

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $Z9uTe = parcelRequire("Z9uTe");

var $6Z2mh = parcelRequire("6Z2mh");

var $6gWZ1 = parcelRequire("6gWZ1");

var $uu31h = parcelRequire("uu31h");
const $752d7b6fe60c2c67$export$9a67aaae787c9f40 = (0, $7NszV.createEntry)((0, $Z9uTe.helpCenterSettingsFormsRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.forms',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: $6gWZ1.navigation,
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('jcs_master_flag') ? (0, $uu31h.helpCenterSettingFormsAppPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ]
    }));

});
parcelRegister("Z9uTe", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsFormsRoute", () => $a0406c9ab9debc78$export$45b14c3ed47b2b3a);
const $a0406c9ab9debc78$export$45b14c3ed47b2b3a = {
    exact: true,
    name: 'helpcenter-settings-forms',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/forms'
};

});

parcelRegister("uu31h", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingFormsAppPageEntryPoint", () => $cf39360ee106b7b5$export$b50d944f3be2457f);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $UvMAc = parcelRequire("UvMAc");
const $cf39360ee106b7b5$export$b50d944f3be2457f = (0, $lkFvK.createPageEntryPoint)({
    main: $UvMAc.helpCenterSettingFormsAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("UvMAc", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingFormsAppEntryPoint", () => $dbea87a49a7edd6e$export$ce8253ab16579f12);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $gqaus = parcelRequire("gqaus");

const $dbea87a49a7edd6e$export$ce8253ab16579f12 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("c3cNm")), {
        moduleId: "c7a4dbb9",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>({
            queries: {
                uiFormsQuery: {
                    parameters: $gqaus.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("gqaus", function(module, exports) {

$parcel$export(module.exports, "default", () => $22259d546684fabe$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<84b049be8f3a777ce173b3c8cca04631>>
 * @relayHash 0a68a91abafc7c22614c8b72a0a3f13b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0ae63b4dd317fe8ffc05de4c48bb50926299366f1b898d6a5e04aae8b233cac4
const $22259d546684fabe$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "0ae63b4dd317fe8ffc05de4c48bb50926299366f1b898d6a5e04aae8b233cac4",
        "metadata": {},
        "name": "uiFormsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $22259d546684fabe$export$2e2bcd8739ae039 = $22259d546684fabe$var$node;

});

parcelRegister("c3cNm", function(module, exports) {

let $8c5fb0b0a5e7b0e1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8c5fb0b0a5e7b0e1$var$load("jJS8Y").then(()=>parcelRequire('a6kDH'));

});




parcelRegister("kzcqd", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsKbRouteEntry", () => $55fac3162ba94854$export$caf568619a621961);

var $ffza4 = parcelRequire("ffza4");

var $cSD7y = parcelRequire("cSD7y");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $dZu6u = parcelRequire("dZu6u");

var $6Z2mh = parcelRequire("6Z2mh");

var $6gWZ1 = parcelRequire("6gWZ1");

var $81LME = parcelRequire("81LME");
const $55fac3162ba94854$export$caf568619a621961 = (0, $7NszV.createEntry)((0, $dZu6u.helpCenterSettingsKbRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.kb',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: $6gWZ1.navigation,
        component: (0, $cSD7y.componentWithFG)('jcs_master_flag', (0, $81LME.HelpCenterSettingsKnowledgeBase), (0, $5lsNZ.default)),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $81LME.LazyHelpCenterSettingsKnowledgeBase)
        ],
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            // TODO: https://jplat.jira.atlassian.cloud/browse/BERRY-2884
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ]
    }));

});
parcelRegister("dZu6u", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsKbRoute", () => $643da700cdb365a5$export$8a784299dc7faaff);
const $643da700cdb365a5$export$8a784299dc7faaff = {
    name: 'helpcenter-settings-kb',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/kb',
    exact: true
};

});

parcelRegister("81LME", function(module, exports) {

$parcel$export(module.exports, "LazyHelpCenterSettingsKnowledgeBase", () => $d84b744908886ed8$export$92983043c677b1b1);
$parcel$export(module.exports, "HelpCenterSettingsKnowledgeBase", () => $d84b744908886ed8$export$c1d58cf9dc0a2ed3);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $d84b744908886ed8$export$92983043c677b1b1 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("jzAOh"))), {
    moduleId: "./src/packages/spa-apps/help-center-settings/knowledge-settings/src/index.tsx"
});
const $d84b744908886ed8$export$c1d58cf9dc0a2ed3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d84b744908886ed8$export$92983043c677b1b1,
        pageId: "help-center-settings-knowledge-base",
        shouldShowSpinner: true
    });

});
parcelRegister("jzAOh", function(module, exports) {

let $e3fdd6e7116660c3$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e3fdd6e7116660c3$var$load("ffQaD"),
    $e3fdd6e7116660c3$var$load("kvRbA"),
    $e3fdd6e7116660c3$var$load("bVssC")
]).then(()=>parcelRequire('5bGBK'));

});



parcelRegister("duVOn", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsNotFoundRouteEntry", () => $16b9b96eb3704d99$export$2dced3f6d0a4894);

var $7NszV = parcelRequire("7NszV");

var $65gi0 = parcelRequire("65gi0");

var $6NkHq = parcelRequire("6NkHq");
const $16b9b96eb3704d99$export$2dced3f6d0a4894 = (0, $7NszV.createEntry)((0, $65gi0.helpCenterSettingsNotFoundRoute), ()=>({
        group: 'customer-service',
        component: (0, $6NkHq.NotFound)
    }));

});
parcelRegister("65gi0", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsNotFoundRoute", () => $a438def0ee4651b3$export$b6bc9dd96e9608e7);
const $a438def0ee4651b3$export$b6bc9dd96e9608e7 = {
    exact: false,
    name: 'customer-service-not-found',
    path: '/jira/helpcenter/:any'
};

});

parcelRegister("6NkHq", function(module, exports) {

$parcel$export(module.exports, "NotFound", () => $7f8c6894e16771dc$export$271f9f08425019c7);

var $5uXOq = parcelRequire("5uXOq");

var $beRD7 = parcelRequire("beRD7");

var $lODMY = parcelRequire("lODMY");

var $jcw0u = parcelRequire("jcw0u");
const $7f8c6894e16771dc$var$useLocation = (0, $lODMY.createRouterSelector)(({ location: location })=>location.pathname);
const $7f8c6894e16771dc$export$271f9f08425019c7 = ()=>{
    const pathname = $7f8c6894e16771dc$var$useLocation();
    (0, $5uXOq.useEffect)(()=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'serviceHubPageNotFound',
                packageName: 'jiraServicedeskCustomerServiceServiceHubs',
                teamName: 'boysenberry'
            },
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                pathname: pathname
            }
        });
    }, [
        pathname
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $beRD7.NotFoundErrorPageAsync), null);
};

});


parcelRegister("lDuCa", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsServiceHubsRouteEntry", () => $17f669f9f746c53b$export$4afd756ea4d2cf7e);

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $5lsNZ = parcelRequire("5lsNZ");

var $3Y5jq = parcelRequire("3Y5jq");

var $85NOq = parcelRequire("85NOq");
const $17f669f9f746c53b$export$4afd756ea4d2cf7e = (0, $7NszV.createEntry)((0, $3Y5jq.helpCenterSettingsServiceHubsRoute), ()=>({
        group: 'customer-service',
        perfMetricKey: 'customer-service.service-hubs',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
        },
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('jcs_master_flag') ? (0, $85NOq.helpCenterSettingsServiceHubsRoutePageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ]
    }));

});
parcelRegister("3Y5jq", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsServiceHubsRoute", () => $ce6844775f881a62$export$16970f28ba5bfb66);
const $ce6844775f881a62$export$16970f28ba5bfb66 = {
    exact: true,
    name: 'customer-service-helpcenter',
    path: '/jira/helpcenter'
};

});

parcelRegister("85NOq", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsServiceHubsRoutePageEntryPoint", () => $ba28558a5bb4c0c7$export$3c1cef4845013f95);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $1yeSy = parcelRequire("1yeSy");
const $ba28558a5bb4c0c7$export$3c1cef4845013f95 = (0, $lkFvK.createPageEntryPoint)({
    main: $1yeSy.helpCenterSettingsServiceHubsAppEntryPoint,
    // TODO update to right menu id
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("1yeSy", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsServiceHubsAppEntryPoint", () => $0978151941bc8303$export$68ab0caf884fe346);

var $enqBA = parcelRequire("enqBA");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $4R6GH = parcelRequire("4R6GH");
const $0978151941bc8303$var$NUMBER_OF_HELP_CENTERS_INITIAL_FETCH = 20;
const $0978151941bc8303$var$SORT_ORDER = 'CREATED_DATE_DESCENDING';

const $0978151941bc8303$export$68ab0caf884fe346 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("edxWT")).then((module)=>(0, $4R6GH.fg)('jcs_customer_hubs_access_license_check') ? module.HelpCenterSettingServiceHubsAppWithJCSLicenseCheck : module.HelpCenterSettingServiceHubsApp), {
        moduleId: "c447b568",
        priority: "userVisible"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        return {
            queries: {
                serviceHubsQuery: {
                    parameters: $enqBA.default,
                    variables: {
                        cloudId: cloudId,
                        workspaceAri: `ari:cloud:jira:${cloudId}:workspace/${activationId}`,
                        SORT_ORDER: $0978151941bc8303$var$SORT_ORDER,
                        NUMBER_OF_HELP_CENTERS_INITIAL_FETCH: $0978151941bc8303$var$NUMBER_OF_HELP_CENTERS_INITIAL_FETCH
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("enqBA", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3b56a15c10c4b45$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2bfa82f2d0823efdab8d51258393ace5>>
 * @relayHash 3e3a69d2c99a9c3c9ec567802fc52640
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3e0356e42e96d3adde2f74f099ff3e06573fc979ecc8bc591691d4221d6efc41
const $e3b56a15c10c4b45$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "3e0356e42e96d3adde2f74f099ff3e06573fc979ecc8bc591691d4221d6efc41",
        "metadata": {},
        "name": "srcCustomerServiceServiceHubsPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $e3b56a15c10c4b45$export$2e2bcd8739ae039 = $e3b56a15c10c4b45$var$node;

});

parcelRegister("edxWT", function(module, exports) {

let $a59c9d21500cfe92$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $a59c9d21500cfe92$var$load("76n7a"),
    $a59c9d21500cfe92$var$load("l253H"),
    $a59c9d21500cfe92$var$load("dDk2I")
]).then(()=>parcelRequire('c7EOd'));

});




parcelRegister("f7vKZ", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsSupportWebsiteOverviewRouteEntry", () => $032e280ea85bb67e$export$eb728930eecb0b42);

var $4R6GH = parcelRequire("4R6GH");

var $6Z2mh = parcelRequire("6Z2mh");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $69WMA = parcelRequire("69WMA");

var $fBTqh = parcelRequire("fBTqh");

var $lmyls = parcelRequire("lmyls");

var $hVOfU = parcelRequire("hVOfU");

var $cfV2M = parcelRequire("cfV2M");
const $032e280ea85bb67e$export$eb728930eecb0b42 = (0, $7NszV.createEntry)((0, $69WMA.helpCenterSettingsSupportWebsiteOverviewRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'customer-service.support-website.overview',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).HELP_CENTER_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS,
            sidebar: (0, $fBTqh.default),
            horizontal: (0, $4R6GH.fg)('csm_contact_us_rte') ? undefined : (0, $hVOfU.AsyncSupportWebsiteNav)
        },
        component: (0, $5lsNZ.default),
        entryPoint: ()=>{
            if (!(0, $4R6GH.fg)('enable_support_site_details_csm')) return undefined;
            return (0, $4R6GH.fg)('csm_contact_us_rte') ? (0, $cfV2M.HelpCenterSettingsSupportWebsiteOverviewAppEntryPointWithHorizontalNavigation) : (0, $cfV2M.HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint);
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)()
        ]
    }));

});
parcelRegister("69WMA", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsSupportWebsiteOverviewRoute", () => $8aa73486df339929$export$64e95782b19caeac);
const $8aa73486df339929$export$64e95782b19caeac = {
    name: 'helpcenter-settings-support-website-details-overview',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/support-website/overview',
    exact: true
};

});

parcelRegister("hVOfU", function(module, exports) {

$parcel$export(module.exports, "AsyncSupportWebsiteNav", () => $fe8481e5cfa634b6$export$8887f9c4b5829b78);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $fe8481e5cfa634b6$var$LazySupportWebsiteNav = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("jQPWD")).then(({ SupportWebsiteNavOld: SupportWebsiteNavOld })=>SupportWebsiteNavOld), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-csm/support-website/src/ui/index.tsx"
});
const $fe8481e5cfa634b6$export$8887f9c4b5829b78 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "horizontal-csm-support-site-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fe8481e5cfa634b6$var$LazySupportWebsiteNav, null));

});
parcelRegister("jQPWD", function(module, exports) {

let $e73b2ac9594cc767$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e73b2ac9594cc767$var$load("9aARs").then(()=>parcelRequire('9fzxT'));

});


parcelRegister("cfV2M", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint", () => $5c12c4d46de7a315$export$780fd78388c1f1d1);
$parcel$export(module.exports, "HelpCenterSettingsSupportWebsiteOverviewAppEntryPointWithHorizontalNavigation", () => $5c12c4d46de7a315$export$23f7867fc61415d6);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $5Xswi = parcelRequire("5Xswi");

var $k4AVk = parcelRequire("k4AVk");
const $5c12c4d46de7a315$export$780fd78388c1f1d1 = (0, $lkFvK.createPageEntryPoint)({
    main: $5Xswi.HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});
const $5c12c4d46de7a315$export$23f7867fc61415d6 = (0, $lkFvK.createPageEntryPoint)({
    main: $5Xswi.HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS,
    horizontalNavigation: (0, $k4AVk.horizontalNavigationCsmSupportWebsiteEntryPoint)
});

});
parcelRegister("5Xswi", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint", () => $71148ffb5b8df6c9$export$780fd78388c1f1d1);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $65dSj = parcelRequire("65dSj");

const $71148ffb5b8df6c9$export$780fd78388c1f1d1 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("1ivka")), {
        moduleId: "d27a8c99",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>({
            queries: {
                serviceHubDetailsQuery: {
                    parameters: $65dSj.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("65dSj", function(module, exports) {

$parcel$export(module.exports, "default", () => $739483af15ac3c69$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<086fc8a80466dbab70300b14e65169cd>>
 * @relayHash 97f7e29b9656db740fc7b8aa0a23f4d6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 00edac7f68a877717beb0b54982122a8afa0dbc0016892d64c3d13228d7c8fb7
const $739483af15ac3c69$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "00edac7f68a877717beb0b54982122a8afa0dbc0016892d64c3d13228d7c8fb7",
        "metadata": {},
        "name": "uiSupportWebsiteOverviewServiceHubPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $739483af15ac3c69$export$2e2bcd8739ae039 = $739483af15ac3c69$var$node;

});

parcelRegister("1ivka", function(module, exports) {

let $0f1fc53760638aa8$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0f1fc53760638aa8$var$load("76n7a"),
    $0f1fc53760638aa8$var$load("l253H"),
    $0f1fc53760638aa8$var$load("cBrt7")
]).then(()=>parcelRequire('kqMbh'));

});


parcelRegister("k4AVk", function(module, exports) {

$parcel$export(module.exports, "horizontalNavigationCsmSupportWebsiteEntryPoint", () => $25afd3bee76e68c6$export$2ba426f18e0d22f5);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $6M0GP = parcelRequire("6M0GP");

const $25afd3bee76e68c6$export$2ba426f18e0d22f5 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("l15Wx")), {
        moduleId: "b4f1b5e4",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        return {
            queries: {
                mainHorizontalNavCsmSupportWebsiteQuery: {
                    parameters: $6M0GP.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("6M0GP", function(module, exports) {

$parcel$export(module.exports, "default", () => $eec8ee5685901ecf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<254d867d38ac2047e1b355de64e44419>>
 * @relayHash 74a6ed725a3c21301a8a9e20260043d1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e56b17fc47959b40a696bb4d93e1ad9907e79c351376c9594868dd91b2bd2a9d
const $eec8ee5685901ecf$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "e56b17fc47959b40a696bb4d93e1ad9907e79c351376c9594868dd91b2bd2a9d",
        "metadata": {},
        "name": "mainHorizontalNavCsmSupportWebsiteQuery",
        "operationKind": "query",
        "text": null
    }
};
var $eec8ee5685901ecf$export$2e2bcd8739ae039 = $eec8ee5685901ecf$var$node;

});

parcelRegister("l15Wx", function(module, exports) {

let $f4ce4d2b906c23c1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f4ce4d2b906c23c1$var$load("jo9Ab").then(()=>parcelRequire('hc56P'));

});




parcelRegister("k826a", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsSupportWebsitePagesRouteEntry", () => $9bc8c8ad2937179a$export$5077ff1d96b93d83);

var $6Z2mh = parcelRequire("6Z2mh");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $h8xmH = parcelRequire("h8xmH");

var $fBTqh = parcelRequire("fBTqh");

var $lmyls = parcelRequire("lmyls");

var $hVOfU = parcelRequire("hVOfU");

var $4R6GH = parcelRequire("4R6GH");

var $fwLOb = parcelRequire("fwLOb");
const $9bc8c8ad2937179a$export$5077ff1d96b93d83 = (0, $7NszV.createEntry)((0, $h8xmH.helpCenterSettingsSupportWebsitePagesRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'customer-service.support-website.pages',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).HELP_CENTER_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS,
            sidebar: (0, $fBTqh.default),
            horizontal: (0, $4R6GH.fg)('csm_contact_us_rte') ? undefined : (0, $hVOfU.AsyncSupportWebsiteNav)
        },
        component: (0, $5lsNZ.default),
        entryPoint: ()=>{
            if (!(0, $4R6GH.fg)('jcs_master_flag')) return undefined;
            return (0, $4R6GH.fg)('csm_contact_us_rte') ? (0, $fwLOb.HelpCenterSettingsSupportWebsitePagesAppEntryPointWithHorizontalNavigation) : (0, $fwLOb.HelpCenterSettingsSupportWebsitePagesAppEntryPoint);
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)()
        ]
    }));

});
parcelRegister("h8xmH", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsSupportWebsitePagesRoute", () => $4b2f69811d8f88b2$export$a6eefe359f3d3ade);
const $4b2f69811d8f88b2$export$a6eefe359f3d3ade = {
    name: 'helpcenter-settings-support-website-details-pages',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/support-website/pages',
    exact: true
};

});

parcelRegister("fwLOb", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsSupportWebsitePagesAppEntryPoint", () => $ba2e92bb63ab8578$export$7d51b2b14ae8000f);
$parcel$export(module.exports, "HelpCenterSettingsSupportWebsitePagesAppEntryPointWithHorizontalNavigation", () => $ba2e92bb63ab8578$export$e27663b14f44038e);

var $lkFvK = parcelRequire("lkFvK");

var $k4AVk = parcelRequire("k4AVk");

var $lmyls = parcelRequire("lmyls");

var $ezcM4 = parcelRequire("ezcM4");
const $ba2e92bb63ab8578$export$7d51b2b14ae8000f = (0, $lkFvK.createPageEntryPoint)({
    main: $ezcM4.HelpCenterSettingsSupportWebsitePagesAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});
const $ba2e92bb63ab8578$export$e27663b14f44038e = (0, $lkFvK.createPageEntryPoint)({
    main: $ezcM4.HelpCenterSettingsSupportWebsitePagesAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS,
    horizontalNavigation: (0, $k4AVk.horizontalNavigationCsmSupportWebsiteEntryPoint)
});

});
parcelRegister("ezcM4", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsSupportWebsitePagesAppEntryPoint", () => $fa9b1e599393909a$export$7d51b2b14ae8000f);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $kHuGF = parcelRequire("kHuGF");

const $fa9b1e599393909a$export$7d51b2b14ae8000f = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("5LPHo")), {
        moduleId: "c9581695",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>({
            queries: {
                customPagesQuery: {
                    parameters: $kHuGF.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterARI: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
                        NUMBER_OF_PAGES_INITIAL_FETCH: 300
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("kHuGF", function(module, exports) {

$parcel$export(module.exports, "default", () => $82b3287921674b82$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<255b47cc0babd2dc6c2822562386643c>>
 * @relayHash 4cef641aeddb35300aa8d4846416dd5c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 15c35c8f3c86832753921d0da0dad55d8b9e763158ce0f0a3976cf1897ea1a8b
const $82b3287921674b82$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "15c35c8f3c86832753921d0da0dad55d8b9e763158ce0f0a3976cf1897ea1a8b",
        "metadata": {
            "connection": [
                {
                    "count": "NUMBER_OF_PAGES_INITIAL_FETCH",
                    "cursor": null,
                    "direction": "forward",
                    "path": [
                        "helpCenter",
                        "helpCenterPages"
                    ]
                }
            ]
        },
        "name": "uiSupportWebsiteCustomPagesQuery",
        "operationKind": "query",
        "text": null
    }
};
var $82b3287921674b82$export$2e2bcd8739ae039 = $82b3287921674b82$var$node;

});

parcelRegister("5LPHo", function(module, exports) {

let $433971d9306a7800$var$load = (parcelRequire("28QjX"))(4);
module.exports = $433971d9306a7800$var$load("3sPkw").then(()=>parcelRequire('lDMA6'));

});




parcelRegister("avQ9D", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsSupportWebsiteRouteEntry", () => $bdc73697774975eb$export$59cfd0dfcd1b4311);

var $6Z2mh = parcelRequire("6Z2mh");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $aQelL = parcelRequire("aQelL");

var $lmyls = parcelRequire("lmyls");

var $fBTqh = parcelRequire("fBTqh");

var $hVOfU = parcelRequire("hVOfU");

var $4R6GH = parcelRequire("4R6GH");

var $6gj7h = parcelRequire("6gj7h");
const $bdc73697774975eb$export$59cfd0dfcd1b4311 = (0, $7NszV.createEntry)((0, $aQelL.helpCenterSettingsSupportWebsiteRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'customer-service.support-website',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).HELP_CENTER_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS,
            sidebar: (0, $fBTqh.default),
            horizontal: (0, $4R6GH.fg)('csm_contact_us_rte') ? undefined : (0, $hVOfU.AsyncSupportWebsiteNav)
        },
        component: (0, $5lsNZ.default),
        entryPoint: ()=>{
            if (!(0, $4R6GH.fg)('enable_support_site_details_csm')) return undefined;
            return (0, $4R6GH.fg)('csm_contact_us_rte') ? (0, $6gj7h.HelpCenterSettingsSupportWebsiteEntryPointWithHorizontalNavigation) : (0, $6gj7h.HelpCenterSettingsSupportWebsiteEntryPoint);
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)()
        ]
    }));

});
parcelRegister("aQelL", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsSupportWebsiteRoute", () => $fc3d051dfa242c89$export$c59ea9b870a0e809);
const $fc3d051dfa242c89$export$c59ea9b870a0e809 = {
    name: 'helpcenter-settings-support-website-details',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/support-website',
    exact: true
};

});

parcelRegister("6gj7h", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsSupportWebsiteEntryPoint", () => $a1985909a25e76e4$export$91f75c485220b109);
$parcel$export(module.exports, "HelpCenterSettingsSupportWebsiteEntryPointWithHorizontalNavigation", () => $a1985909a25e76e4$export$4811316770750d89);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $eiTxd = parcelRequire("eiTxd");

var $k4AVk = parcelRequire("k4AVk");
const $a1985909a25e76e4$export$91f75c485220b109 = (0, $lkFvK.createPageEntryPoint)({
    main: $eiTxd.HelpCenterSettingsSupportWebsiteAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});
const $a1985909a25e76e4$export$4811316770750d89 = (0, $lkFvK.createPageEntryPoint)({
    main: $eiTxd.HelpCenterSettingsSupportWebsiteAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS,
    horizontalNavigation: (0, $k4AVk.horizontalNavigationCsmSupportWebsiteEntryPoint)
});

});
parcelRegister("eiTxd", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsSupportWebsiteAppEntryPoint", () => $fccdb49574d19a8f$export$43c72a7c514122ed);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $fccdb49574d19a8f$export$43c72a7c514122ed = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("ixqp3")), {
        moduleId: "6e5d67aa",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("ixqp3", function(module, exports) {

let $d7efca2b2bb68971$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d7efca2b2bb68971$var$load("1NYHB").then(()=>parcelRequire('hPBOL'));

});




parcelRegister("7xmCI", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsWidgetConfigurationRouteEntry", () => $04025a82140be736$export$c31c9a710ba499e8);

var $6Z2mh = parcelRequire("6Z2mh");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $eA7JC = parcelRequire("eA7JC");

var $4R6GH = parcelRequire("4R6GH");

var $5boY7 = parcelRequire("5boY7");

var $6gWZ1 = parcelRequire("6gWZ1");
const $04025a82140be736$export$c31c9a710ba499e8 = (0, $7NszV.createEntry)((0, $eA7JC.helpCenterSettingsWidgetConfigurationRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'customer-service.widget-configuration',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: $6gWZ1.navigation,
        component: (0, $5lsNZ.default),
        entryPoint: ()=>{
            if (!(0, $4R6GH.fg)('csm-agent-config-widget-branding-configuration')) return undefined;
            return 0, $5boY7.HelpCenterSettingsWidgetConfigurationEntryPoint;
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)()
        ]
    }));

});
parcelRegister("eA7JC", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsWidgetConfigurationRoute", () => $bbc9f170f1e87168$export$5383ecd0996d74ed);
const $bbc9f170f1e87168$export$5383ecd0996d74ed = {
    name: 'helpcenter-settings-widget-configuration',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/widget-configuration',
    exact: true
};

});

parcelRegister("5boY7", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsWidgetConfigurationEntryPoint", () => $787cf000090b3dca$export$8b1b69a280b85325);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $lfjfW = parcelRequire("lfjfW");
const $787cf000090b3dca$export$8b1b69a280b85325 = (0, $lkFvK.createPageEntryPoint)({
    main: $lfjfW.HelpCenterSettingsWidgetConfigurationAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("lfjfW", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsWidgetConfigurationAppEntryPoint", () => $ad07218277da56e6$export$5b62ed117b99ac21);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $ad07218277da56e6$export$5b62ed117b99ac21 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("hu5KQ")), {
        moduleId: "3b1d944d",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("hu5KQ", function(module, exports) {

let $cba9b3c151ab5090$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cba9b3c151ab5090$var$load("j0czf").then(()=>parcelRequire('6bs8O'));

});




parcelRegister("h82Z7", function(module, exports) {

$parcel$export(module.exports, "homeOnboardingRedirectRouteEntry", () => $5e597886ba168534$export$2740cfaa979353b9);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $cHNCn = parcelRequire("cHNCn");

var $dzpo2 = parcelRequire("dzpo2");
const $5e597886ba168534$export$2740cfaa979353b9 = (0, $7NszV.createEntry)((0, $cHNCn.homeOnboardingRedirectRoute), ()=>({
        group: 'home',
        component: (0, $dzpo2.default),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        isRedirect: true,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("cHNCn", function(module, exports) {

$parcel$export(module.exports, "homeOnboardingRedirectRoute", () => $fc7d4480067c689f$export$2eaffde3ad991b33);
const $fc7d4480067c689f$export$2eaffde3ad991b33 = {
    name: 'home-onboarding-redirect',
    path: '/jira/your-work-onboarding',
    exact: true
};

});

parcelRegister("dzpo2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff7a191a114ce3ba$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5oFIy = parcelRequire("5oFIy");

var $lVJAU = parcelRequire("lVJAU");
/**
 * This component will cause an SPA transition (and overwrite of current history) to Your work or the Projects directory
 * depending on whether nav-v3, Your work's deep dive cards, and the JSW onboarding flows in Your work are enabled.
 */ const $ff7a191a114ce3ba$var$JiraHomeOnboardingRedirect = ()=>{
    const { replace: replace } = (0, $lVJAU.useRouterActions)();
    replace('/jira/your-work');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
        eventName: "JiraHomeOnboardingRedirect loaded",
        componentName: "JiraHomeOnboardingRedirect",
        attributes: {
            isRedirectionEnabled: true
        }
    });
};
var $ff7a191a114ce3ba$export$2e2bcd8739ae039 = $ff7a191a114ce3ba$var$JiraHomeOnboardingRedirect;

});


parcelRegister("9qXuz", function(module, exports) {

$parcel$export(module.exports, "homeRedirectRouteEntry", () => $f8b2ddb194f05043$export$5379c026da4201e6);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $7R6xY = parcelRequire("7R6xY");

var $crx5O = parcelRequire("crx5O");
const $f8b2ddb194f05043$export$5379c026da4201e6 = (0, $7NszV.createEntry)((0, $7R6xY.homeRedirectRoute), ()=>({
        group: 'home',
        component: (0, $crx5O.default),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        isRedirect: true,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("7R6xY", function(module, exports) {

$parcel$export(module.exports, "homeRedirectRoute", () => $d39d4562915d89ec$export$f7a252c9d61f8f94);
const $d39d4562915d89ec$export$f7a252c9d61f8f94 = {
    name: 'home-redirect',
    path: '/jira',
    exact: true
};

});

parcelRegister("crx5O", function(module, exports) {

$parcel$export(module.exports, "default", () => $92d7d72ca8393409$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dXRYE = parcelRequire("dXRYE");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$92d7d72ca8393409$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dXRYE.default), null);

});
parcelRegister("dXRYE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5a49877dbf7e167$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $2YZCu = parcelRequire("2YZCu");

var $9vlEn = parcelRequire("9vlEn");

var $7tQej = parcelRequire("7tQej");
var $2YP9W = parcelRequire("2YP9W");

const $e5a49877dbf7e167$var$JiraBaseRedirectWrapper = ()=>{
    (0, $gKZoD.di)(window);
    const { data: data, loading: loading } = (0, $2YP9W.useResource)((0, $9vlEn.userHomepageResource));
    (0, $5uXOq.useEffect)(()=>{
        if (!loading && data == null) (0, $2YZCu.default).safeInfoWithoutCustomerData((0, $2791311ae97b7f0a$export$25a759e49d5049db), 'userHomepage data is null');
    }, [
        loading,
        data
    ]);
    if (loading) return null;
    // redirect to monolith to handle "/jira" route if homepageData is null (should not happen)
    if (data == null) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.replace('/jira');
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: data.homepagePreference
    });
};
var $e5a49877dbf7e167$export$2e2bcd8739ae039 = $e5a49877dbf7e167$var$JiraBaseRedirectWrapper;

});
const $2791311ae97b7f0a$export$25a759e49d5049db = 'spa-apps.common.redirect.jira-base-routing';




parcelRegister("3HGg1", function(module, exports) {

$parcel$export(module.exports, "issueCreateEmbedRouteEntry", () => $f0855c0baf74da48$export$abd0bbe95839baf7);

var $5uXOq = parcelRequire("5uXOq");

var $6e4Kt = parcelRequire("6e4Kt");

var $7NszV = parcelRequire("7NszV");

var $2Ql51 = parcelRequire("2Ql51");

var $ell37 = parcelRequire("ell37");

var $9NiTW = parcelRequire("9NiTW");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");
const $f0855c0baf74da48$var$handleEmbedLinkClick = (e)=>{
    const eventTarget = e.target;
    // this is used for handling all the button clicks inside the iframe to open the new link in a new tab
    // as this view is mainly used an embed view inside an iframe.
    if (eventTarget && eventTarget instanceof HTMLAnchorElement && eventTarget.target !== '_blank') // link
    eventTarget.target = '_blank';
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f0855c0baf74da48$var$LazyIssueCreateEmbed = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("hnK2a")), {
    ssr: false,
    moduleId: "./src/packages/issue-create/issue-create-embed/src/index.tsx"
});
const $f0855c0baf74da48$var$IssueCreateEmbedLazy = ()=>{
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('click', $f0855c0baf74da48$var$handleEmbedLinkClick, true);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('click', $f0855c0baf74da48$var$handleEmbedLinkClick);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9NiTW.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f0855c0baf74da48$var$LazyIssueCreateEmbed,
        pageId: "spa-apps/issue-create-embed",
        shouldShowSpinner: true
    }));
};
const $f0855c0baf74da48$export$abd0bbe95839baf7 = (0, $7NszV.createEntry)((0, $ell37.issueCreateEmbedRoute), ()=>({
        group: 'issue',
        component: $f0855c0baf74da48$var$IssueCreateEmbedLazy,
        resources: [
            (0, $2Ql51.themePreferenceResource)
        ],
        layout: (0, $6e4Kt.chromelessLayout),
        forPaint: [
            $f0855c0baf74da48$var$LazyIssueCreateEmbed
        ]
    }));

});
parcelRegister("ell37", function(module, exports) {

$parcel$export(module.exports, "issueCreateEmbedRoute", () => $fcce99f65e838928$export$c155f4de16b62110);
const $fcce99f65e838928$export$c155f4de16b62110 = {
    name: 'issue-create-embed',
    path: '/jira/issues/create/embed'
};

});

parcelRegister("hnK2a", function(module, exports) {

let $ca784b039715179c$var$load = (parcelRequire("28QjX"))(4);

module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $ca784b039715179c$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $ca784b039715179c$var$load("k6g9p")
        ]);
    }),
    $ca784b039715179c$var$load("3yAl4"),
    $ca784b039715179c$var$load("kNFvF"),
    $ca784b039715179c$var$load("ffQaD"),
    $ca784b039715179c$var$load("kvRbA"),
    $ca784b039715179c$var$load("fliVL"),
    $ca784b039715179c$var$load("76n7a"),
    $ca784b039715179c$var$load("l253H"),
    $ca784b039715179c$var$load("6PtIC")
]).then(()=>parcelRequire('5tdjr'));

});


parcelRegister("4nXyN", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorGlobalJiraRouteEntry", () => $a09e1f9770441a11$export$8925c79a030fdfe8);

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $fwSmZ = parcelRequire("fwSmZ");

var $1gXMV = parcelRequire("1gXMV");


var $8irO5 = parcelRequire("8irO5");

var $96TVI = parcelRequire("96TVI");

var $3uU6P = parcelRequire("3uU6P");

var $b8f12 = parcelRequire("b8f12");
const $a09e1f9770441a11$export$8925c79a030fdfe8 = (0, $7NszV.createEntry)((0, $fwSmZ.issueNavigatorGlobalJiraRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$d0ad1160bb95ce50),
            reporting: (0, $3uU6P.getRouteReporting)()
        },
        skeleton: (0, $1gXMV.GlobalIssueNavigatorSkeleton),
        ufoName: 'global-issue-navigator-jfe',
        navigation: (0, $8irO5.getCommonGlobalNavigation)(),
        resources: [
            ...(0, $96TVI.getCommonGlobalResources)()
        ],
        layout: (0, $2BrOV.globalLayout),
        // We want to opt out of concurrent mode for all NIN routes https://hello.atlassian.net/wiki/x/wTRfDAE
        // But allow for users with empanada-concurrent-incremental gate enabled to continue testing it
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental') && !(0, $4R6GH.fg)('empanada-concurrent-incremental'),
        entryPoint: ()=>(0, $b8f12.globalIssueNavigatorGinRedirectPageEntryPoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("fwSmZ", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorGlobalJiraRoute", () => $f141385b640afc92$export$286b1d26dcbbce9e);
const $f141385b640afc92$export$286b1d26dcbbce9e = {
    name: 'global-issue-navigator',
    path: '/jira/issues/:issueKey?'
};

});


parcelRegister("jrl3R", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorGlobalRouteEntry", () => $25e6f63d1902d36e$export$3e58fe44312b4093);

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $ddy4Q = parcelRequire("ddy4Q");

var $1gXMV = parcelRequire("1gXMV");


var $8irO5 = parcelRequire("8irO5");

var $96TVI = parcelRequire("96TVI");

var $3uU6P = parcelRequire("3uU6P");

var $b8f12 = parcelRequire("b8f12");
const $25e6f63d1902d36e$export$3e58fe44312b4093 = (0, $7NszV.createEntry)((0, $ddy4Q.issueNavigatorGlobalRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$d0ad1160bb95ce50),
            reporting: (0, $3uU6P.getRouteReporting)()
        },
        skeleton: (0, $1gXMV.GlobalIssueNavigatorSkeleton),
        ufoName: 'global-issue-navigator-jfe',
        navigation: (0, $8irO5.getCommonGlobalNavigation)(),
        resources: [
            ...(0, $96TVI.getCommonGlobalResources)()
        ],
        layout: (0, $2BrOV.globalLayout),
        // We want to opt out of concurrent mode for all NIN routes https://hello.atlassian.net/wiki/x/wTRfDAE
        // But allow for users with empanada-concurrent-incremental gate enabled to continue testing it
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental') && !(0, $4R6GH.fg)('empanada-concurrent-incremental'),
        isHydrateRootEnabled: (0, $4R6GH.fg)('nin-full-page-hydrate-root'),
        bifrost: {
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-navigator-entries/src/issueNavigatorGlobalRouteEntry.tsx',
                whichExportToUse: 'issueNavigatorGlobalRouteEntry'
            },
            enabled: true,
            manifestName: 'jira-spa-issue-navigator.json',
            // An increase from 1.2s default to 1.5s will comfortably cater for P95 of issue search requests
            // For more insights into this decision, see https://jplat.atlassian.net/browse/EM-9249
            fetchTimeout: (0, $4R6GH.fg)('increase_server_fetch_timeouts_for_nin_bifrost') ? 1500 : undefined
        },
        entryPoint: ()=>(0, $b8f12.globalIssueNavigatorGinRedirectPageEntryPoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("ddy4Q", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorGlobalRoute", () => $5ec8272afbf68925$export$928d3577bbe9e124);
const $5ec8272afbf68925$export$928d3577bbe9e124 = {
    name: 'global-issue-navigator',
    // Remove the issueKey path param when cleaning up slv-4_migrate_nin_selected_issue_route
    path: '/issues/:issueKey?',
    query: [
        'selectedIssue?'
    ]
};

});


parcelRegister("bvhAI", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectBusinessEmbedRouteEntry", () => $25993f18ac5a79c6$export$2b29f9b6033583e1);

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $bG4N3 = parcelRequire("bG4N3");


var $8SwBk = parcelRequire("8SwBk");

var $6e4Kt = parcelRequire("6e4Kt");

var $6LsQE = parcelRequire("6LsQE");

var $arJNO = parcelRequire("arJNO");

var $3uU6P = parcelRequire("3uU6P");

var $b8f12 = parcelRequire("b8f12");
const $25993f18ac5a79c6$export$2b29f9b6033583e1 = (0, $7NszV.createEntry)((0, $bG4N3.issueNavigatorProjectBusinessEmbedRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$d0ad1160bb95ce50),
            reporting: (0, $3uU6P.getRouteReporting)()
        },
        skeleton: (0, $8SwBk.EmbedIssueNavigatorSkeleton),
        resources: [
            ...(0, $arJNO.getCommonProjectResources)()
        ],
        layout: (0, $6e4Kt.chromelessLayout),
        // We want to opt out of concurrent mode for all NIN routes https://hello.atlassian.net/wiki/x/wTRfDAE
        // But allow for users with empanada-concurrent-incremental gate enabled to continue testing it
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental') && !(0, $4R6GH.fg)('empanada-concurrent-incremental'),
        entryPoint: ()=>(0, $4R6GH.fg)('jira_nin_smart_link') ? (0, $b8f12.issueNavigatorEmbedPageEntryPoint) : (0, $6LsQE.notFoundPageEntrypoint)
    }));

});
parcelRegister("bG4N3", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectBusinessEmbedRoute", () => $c6cd917aee22ec45$export$a59f4bdf8be89f93);
const $c6cd917aee22ec45$export$a59f4bdf8be89f93 = {
    name: 'issue-navigator-core-embed',
    path: '/jira/core/projects/:projectKey/issues/embed'
};

});

parcelRegister("8SwBk", function(module, exports) {

$parcel$export(module.exports, "EmbedIssueNavigatorSkeleton", () => $9d3d268015ae6173$export$1b1eaa2e48fda507);
/* embed-app.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $7TslS = parcelRequire("7TslS");
const $9d3d268015ae6173$var$customCssStyles = null;
const $9d3d268015ae6173$export$1b1eaa2e48fda507 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7TslS))),
        className: (0, $bwpsq.default)([
            "_2zz1zwfg _slt8zwfg _1od57vkz"
        ])
    });

});
parcelRegister("7TslS", function(module, exports) {
module.exports = new URL("embed-issue-navigator-skeleton.tpl.616c25ab.svg", import.meta.url).toString();

});


parcelRegister("arJNO", function(module, exports) {

$parcel$export(module.exports, "getCommonProjectResources", () => $bb08e11d903a04ff$export$6236a7417086ea8d);

var $4R6GH = parcelRequire("4R6GH");

var $5bkvv = parcelRequire("5bkvv");

var $1b36n = parcelRequire("1b36n");

var $a3OKn = parcelRequire("a3OKn");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $lNicp = parcelRequire("lNicp");

var $bATyw = parcelRequire("bATyw");

var $89kiv = parcelRequire("89kiv");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $gNStA = parcelRequire("gNStA");

var $lAGdd = parcelRequire("lAGdd");
const $bb08e11d903a04ff$export$6236a7417086ea8d = ()=>[
        (0, $89kiv.issueNavigatorRelayResource),
        (0, $89kiv.issueNavigatorFilterRelayResource),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('nin_request_hydrate_query_earlier') && !(0, $4R6GH.fg)('render_jql_builder_in_ssr'), (0, $89kiv.issueNavigatorHydrationRelayResourceBrowserOnly)),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('render_jql_builder_in_ssr'), (0, $89kiv.issueNavigatorHydrationRelayResource)),
        ...(0, $3RJkv.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $7GnDe.incidentExperimentTraitResource),
        (0, $dxCvy.projectContextResource),
        (0, $5bkvv.forgeProjectModuleResource),
        (0, $iEUaw.staticSidebarShortcutsResource),
        (0, $ggg5j.staticProjectSidebarNavigationResource),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...(0, $lNicp.getBusinessProjectResources)(),
        (0, $a3OKn.sidebarProjectIssuesResource),
        (0, $bATyw.isNinGlobalScopeEnrolmentEnabledResource),
        // this resource is also used by the nav4 sidebar for JSM project's 'issues and filters'
        // src/packages/navigation-apps/sidebar-nav4/jsm-project-menu/src/ui/project-menu/issues-and-filters/default-filters/index.tsx
        (0, $1b36n.staticSidebarDefaultPINFiltersResource),
        ...(0, $lAGdd.getAIContextPanelResources)()
    ];

});
parcelRegister("1b36n", function(module, exports) {

$parcel$export(module.exports, "staticSidebarDefaultPINFiltersResource", () => $f0c33588b62c7651$export$d3efe54a881807bf);

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");

var $elyZV = parcelRequire("elyZV");
const $f0c33588b62c7651$export$d3efe54a881807bf = (0, $2M1hQ.createResource)({
    type: 'JIRA_PROJECT_DEFAULT_PIN_FILTERS_NAV_DATA',
    getKey: ({ match: match, query: query })=>{
        const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(match, query);
        return projectKey || 'none';
    },
    getData: async ({ match: match, query: query })=>{
        const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(match, query);
        if (projectKey == null) return null;
        return (0, $elyZV.fetchDefaultPINFiltersNavData)(projectKey);
    },
    maxAge: 300000
});

});
parcelRegister("elyZV", function(module, exports) {

$parcel$export(module.exports, "fetchDefaultPINFiltersNavData", () => $88433d457c0f5220$export$268c1bcb44a0ddd3);

var $eusud = parcelRequire("eusud");
const $88433d457c0f5220$var$extractNavIds = (result)=>new Set((result['com.atlassian.jira.jira-projects-issue-navigator:generic-filters'] || []).map((filterNavItem)=>filterNavItem.id));
const $88433d457c0f5220$export$268c1bcb44a0ddd3 = async (projectKey)=>{
    if (projectKey == null) throw new Error('invalid project id or key');
    const result = await (0, $eusud.performGetRequest)(`/rest/filters/1.0/filters?projectKey=${projectKey}`);
    const filterNavIds = $88433d457c0f5220$var$extractNavIds(result);
    return {
        hasMyOpenIssues: filterNavIds.has('myopenissues'),
        hasReportedByMe: filterNavIds.has('reportedbyme'),
        hasAllIssues: filterNavIds.has('allissues'),
        hasAllOpenIssues: filterNavIds.has('allopenissues'),
        hasDoneIssues: filterNavIds.has('doneissues'),
        hasViewedRecently: filterNavIds.has('recentlyviewed'),
        hasCreatedRecently: filterNavIds.has('addedrecently'),
        hasResolvedRecently: filterNavIds.has('resolvedrecently'),
        hasUpdatedRecently: filterNavIds.has('updatedrecently')
    };
};

});


parcelRegister("a3OKn", function(module, exports) {

$parcel$export(module.exports, "sidebarProjectIssuesResource", () => $b491cf2963738bcf$export$be31dd7adcfd2297);

var $ao2h1 = parcelRequire("ao2h1");

var $59JDz = parcelRequire("59JDz");

var $6YG83 = parcelRequire("6YG83");
const $b491cf2963738bcf$export$be31dd7adcfd2297 = (0, $6YG83.withGiraAggAnonSsrFix)((0, $ao2h1.createRelayResource)({
    type: 'NAVIGATION_SIDEBAR_STARRED_FILTERS',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $59JDz.default),
            variables: {
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
}));

});
parcelRegister("59JDz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bc7247f574fad09$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<02638f2e8727b45498d5facc19a78e14>>
 * @relayHash 976837d13abb9b9131601925549fb05e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f420a549079d5a65e8a18d3584aa82b524d2287758061372f8331701919dd3f9

var $7vXy9 = parcelRequire("7vXy9");
const $6bc7247f574fad09$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v6 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            }
        ],
        "type": "JiraCustomFilter"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "starredFiltersList_navigationAppsSidebarCommon"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "favouriteFilters",
                                    "args": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": {
                                                    "order": "DESC"
                                                },
                                                "type": "FILTER"
                                            }
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 15
                                        }
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v8 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v9 /*: any*/ 
                                                            ],
                                                            "type": "Node",
                                                            "abstractKey": "__isNode"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "favouriteFiltersOld",
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraFilterConnection",
                                    "kind": "LinkedField",
                                    "name": "favouriteFilters",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFilterEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "TypeDiscriminator",
                                                            "abstractKey": "__isJiraFilter"
                                                        },
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f420a549079d5a65e8a18d3584aa82b524d2287758061372f8331701919dd3f9",
            "metadata": {},
            "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider": (0, $7vXy9.default)
            }
        }
    };
}();
$6bc7247f574fad09$var$node.hash = "86a313b9769c9a6a731e02bed044f4d2";
var $6bc7247f574fad09$export$2e2bcd8739ae039 = $6bc7247f574fad09$var$node;

});




parcelRegister("3B53X", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectBusinessRouteEntry", () => $99398975b82221bf$export$ce258b07e4b7eb8c);

var $5f2bR = parcelRequire("5f2bR");

var $4R6GH = parcelRequire("4R6GH");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $eGOUS = parcelRequire("eGOUS");

var $lHYIV = parcelRequire("lHYIV");


var $arJNO = parcelRequire("arJNO");

var $3uU6P = parcelRequire("3uU6P");

var $b8f12 = parcelRequire("b8f12");
const $99398975b82221bf$export$ce258b07e4b7eb8c = (0, $7NszV.createEntry)((0, $eGOUS.issueNavigatorProjectBusinessRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$d0ad1160bb95ce50),
            reporting: (0, $3uU6P.getRouteReporting)()
        },
        skeleton: (0, $lHYIV.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $arJNO.getCommonProjectResources)()
        ],
        layout: (0, $aPfsS.createLayout)((0, $gyYxw.genericProjectLayout)),
        // We want to opt out of concurrent mode for all NIN routes https://hello.atlassian.net/wiki/x/wTRfDAE
        // But allow for users with empanada-concurrent-incremental gate enabled to continue testing it
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental') && !(0, $4R6GH.fg)('empanada-concurrent-incremental'),
        entryPoint: ()=>(0, $b8f12.issueNavigatorPageEntryPoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("eGOUS", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectBusinessRoute", () => $dd2aac8c1b4464da$export$3219766aa1a42d18);
const $dd2aac8c1b4464da$export$3219766aa1a42d18 = {
    name: 'issue-navigator-core',
    // Remove the issueKey path param when cleaning up slv-4_migrate_nin_selected_issue_route
    path: '/jira/core/projects/:projectKey/issues/:issueKey?',
    query: [
        'selectedIssue?'
    ]
};

});

parcelRegister("lHYIV", function(module, exports) {

$parcel$export(module.exports, "ProjectIssueNavigatorSkeleton", () => $8afa09f5da2bc6b1$export$112138f5f732a994);
/* project-app.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $3HwlS = parcelRequire("3HwlS");

var $hCy6k = parcelRequire("hCy6k");

var $fqNKR = parcelRequire("fqNKR");

var $l06VQ = parcelRequire("l06VQ");
const $8afa09f5da2bc6b1$var$customCssStyles = null;
const $8afa09f5da2bc6b1$export$112138f5f732a994 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, $3HwlS.getWillShowNav4)() ? (0, (/*@__PURE__*/$parcel$interopDefault($fqNKR))) : (0, (/*@__PURE__*/$parcel$interopDefault($l06VQ))),
        className: (0, $bwpsq.default)([
            "_2zz1zwfg _slt8zwfg _1od57vkz"
        ])
    });

});
parcelRegister("fqNKR", function(module, exports) {
module.exports = new URL("project-issue-navigator-nav4-skeleton.tpl.0c4c4250.svg", import.meta.url).toString();

});

parcelRegister("l06VQ", function(module, exports) {
module.exports = new URL("project-issue-navigator-skeleton.tpl.2a1718d8.svg", import.meta.url).toString();

});



parcelRegister("anGpc", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectClassicEmbedRouteEntry", () => $e5189f36edabee3f$export$e77148aa19091842);

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $8nAP5 = parcelRequire("8nAP5");

var $8SwBk = parcelRequire("8SwBk");

var $6e4Kt = parcelRequire("6e4Kt");


var $6LsQE = parcelRequire("6LsQE");

var $arJNO = parcelRequire("arJNO");

var $b8f12 = parcelRequire("b8f12");

var $3uU6P = parcelRequire("3uU6P");
const $e5189f36edabee3f$export$e77148aa19091842 = (0, $7NszV.createEntry)((0, $8nAP5.issueNavigatorProjectClassicEmbedRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$d0ad1160bb95ce50),
            reporting: (0, $3uU6P.getRouteReporting)()
        },
        skeleton: (0, $8SwBk.EmbedIssueNavigatorSkeleton),
        resources: [
            ...(0, $arJNO.getCommonProjectResources)()
        ],
        layout: (0, $6e4Kt.chromelessLayout),
        // We want to opt out of concurrent mode for all NIN routes https://hello.atlassian.net/wiki/x/wTRfDAE
        // But allow for users with empanada-concurrent-incremental gate enabled to continue testing it
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental') && !(0, $4R6GH.fg)('empanada-concurrent-incremental'),
        isHydrateRootEnabled: (0, $4R6GH.fg)('nin-full-page-hydrate-root'),
        entryPoint: ()=>(0, $4R6GH.fg)('jira_nin_smart_link') ? (0, $b8f12.issueNavigatorEmbedPageEntryPoint) : (0, $6LsQE.notFoundPageEntrypoint)
    }));

});
parcelRegister("8nAP5", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectClassicEmbedRoute", () => $1e630657526162a5$export$1062bd8aa98d7bd1);
const $1e630657526162a5$export$1062bd8aa98d7bd1 = {
    name: 'issue-navigator-classic-embed',
    path: '/jira/software/c/projects/:projectKey/issues/embed'
};

});


parcelRegister("glkO2", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectClassicRouteEntry", () => $41789f7b84696902$export$88d5f4117ce3d0fb);

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $eL7Ve = parcelRequire("eL7Ve");

var $lHYIV = parcelRequire("lHYIV");

var $5f2bR = parcelRequire("5f2bR");


var $arJNO = parcelRequire("arJNO");

var $3uU6P = parcelRequire("3uU6P");

var $b8f12 = parcelRequire("b8f12");
const $41789f7b84696902$export$88d5f4117ce3d0fb = (0, $7NszV.createEntry)((0, $eL7Ve.issueNavigatorProjectClassicRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$d0ad1160bb95ce50),
            reporting: (0, $3uU6P.getRouteReporting)()
        },
        skeleton: (0, $lHYIV.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $cSD7y.componentWithFG)('make_nav3_sidebar_lazyforpaint', (0, $9s3j1.ForPaintClassicSoftwareProjectSidebar), (0, $9s3j1.default)),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $arJNO.getCommonProjectResources)()
        ],
        layout: (0, $aPfsS.createLayout)((0, $gyYxw.genericProjectLayout)),
        // We want to opt out of concurrent mode for all NIN routes https://hello.atlassian.net/wiki/x/wTRfDAE
        // But allow for users with empanada-concurrent-incremental gate enabled to continue testing it
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental') && !(0, $4R6GH.fg)('empanada-concurrent-incremental'),
        isHydrateRootEnabled: (0, $4R6GH.fg)('nin-full-page-hydrate-root'),
        bifrost: {
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-navigator-entries/src/issueNavigatorProjectClassicRouteEntry.tsx',
                whichExportToUse: 'issueNavigatorProjectClassicRouteEntry'
            },
            enabled: true,
            manifestName: 'jira-spa-issue-navigator.json',
            // An increase from 1.2s default to 1.5s will comfortably cater for P95 of issue search requests
            // For more insights into this decision, see https://jplat.atlassian.net/browse/EM-9249
            fetchTimeout: (0, $4R6GH.fg)('increase_server_fetch_timeouts_for_nin_bifrost') ? 1500 : undefined
        },
        entryPoint: ()=>(0, $b8f12.issueNavigatorPageEntryPoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("eL7Ve", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectClassicRoute", () => $97f612a83fdbbb6d$export$8e7b74b6169d59ca);
const $97f612a83fdbbb6d$export$8e7b74b6169d59ca = {
    name: 'issue-navigator-classic',
    // Remove the issueKey path param when cleaning up slv-4_migrate_nin_selected_issue_route
    path: '/jira/software/c/projects/:projectKey/issues/:issueKey?',
    query: [
        'selectedIssue?'
    ]
};

});


parcelRegister("04Vlk", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectServicedeskRouteEntry", () => $20147c9440522c21$export$b779296ccb8ca1a8);

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $1WlLE = parcelRequire("1WlLE");

var $imKA4 = parcelRequire("imKA4");

var $6Z2mh = parcelRequire("6Z2mh");

var $lHYIV = parcelRequire("lHYIV");


var $arJNO = parcelRequire("arJNO");

var $3uU6P = parcelRequire("3uU6P");

var $b8f12 = parcelRequire("b8f12");
const $20147c9440522c21$export$b779296ccb8ca1a8 = (0, $7NszV.createEntry)((0, $imKA4.issueNavigatorProjectServicedeskRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$d0ad1160bb95ce50),
            reporting: (0, $3uU6P.getRouteReporting)()
        },
        skeleton: (0, $lHYIV.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $cSD7y.componentWithFG)('make_nav3_sidebar_lazyforpaint', (0, $h0bZU.ForPaintServicedeskSidebar), (0, $h0bZU.default))
        },
        resources: [
            ...(0, $arJNO.getCommonProjectResources)(),
            (0, $1WlLE.queuesNavigationItems),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        layout: (0, $6Z2mh.serviceProjectLayout),
        // We want to opt out of concurrent mode for all NIN routes https://hello.atlassian.net/wiki/x/wTRfDAE
        // But allow for users with empanada-concurrent-incremental gate enabled to continue testing it
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental') && !(0, $4R6GH.fg)('empanada-concurrent-incremental'),
        entryPoint: ()=>(0, $b8f12.issueNavigatorWithoutHorizontalNavPageEntryPoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("imKA4", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectServicedeskRoute", () => $708b2863e92ba0fb$export$e3495d64f36ba27c);
const $708b2863e92ba0fb$export$e3495d64f36ba27c = {
    name: 'servicedesk-issues',
    // Remove the issueKey path param when cleaning up slv-4_migrate_nin_selected_issue_route
    path: '/jira/servicedesk/projects/:projectKey/issues/:issueKey?',
    query: [
        'selectedIssue?'
    ]
};

});


parcelRegister("aI01j", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectSoftwareEmbedRouteEntry", () => $8c2cd4169c434551$export$e87ead168f851b66);

var $7NszV = parcelRequire("7NszV");

var $aw4Mv = parcelRequire("aw4Mv");

var $6e4Kt = parcelRequire("6e4Kt");

var $bHhiy = parcelRequire("bHhiy");

var $8SwBk = parcelRequire("8SwBk");


var $4R6GH = parcelRequire("4R6GH");

var $6LsQE = parcelRequire("6LsQE");

var $arJNO = parcelRequire("arJNO");

var $b8f12 = parcelRequire("b8f12");

var $3uU6P = parcelRequire("3uU6P");
const $8c2cd4169c434551$export$e87ead168f851b66 = (0, $7NszV.createEntry)((0, $aw4Mv.issueNavigatorProjectSoftwareEmbedRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$d0ad1160bb95ce50),
            reporting: (0, $3uU6P.getRouteReporting)()
        },
        skeleton: (0, $8SwBk.EmbedIssueNavigatorSkeleton),
        resources: [
            ...(0, $arJNO.getCommonProjectResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        layout: (0, $6e4Kt.chromelessLayout),
        entryPoint: ()=>(0, $4R6GH.fg)('jira_nin_smart_link') ? (0, $b8f12.issueNavigatorEmbedPageEntryPoint) : (0, $6LsQE.notFoundPageEntrypoint)
    }));

});
parcelRegister("aw4Mv", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectSoftwareEmbedRoute", () => $46a13e12b1e055fa$export$ab4385f7ae539901);
const $46a13e12b1e055fa$export$ab4385f7ae539901 = {
    name: 'software-issue-navigator-embed',
    path: '/jira/software/projects/:projectKey/issues/embed'
};

});


parcelRegister("flsjf", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectSoftwareRouteEntry", () => $a82ae7782e05cd6a$export$2a50f64378877c9d);

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $5vzYC = parcelRequire("5vzYC");

var $lHYIV = parcelRequire("lHYIV");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");


var $arJNO = parcelRequire("arJNO");

var $3uU6P = parcelRequire("3uU6P");

var $b8f12 = parcelRequire("b8f12");
const $a82ae7782e05cd6a$export$2a50f64378877c9d = (0, $7NszV.createEntry)((0, $5vzYC.issueNavigatorProjectSoftwareRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$d0ad1160bb95ce50),
            reporting: (0, $3uU6P.getRouteReporting)()
        },
        skeleton: (0, $lHYIV.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $cSD7y.componentWithFG)('make_nav3_sidebar_lazyforpaint', (0, $koWFd.ForPaintSoftwareProjectSidebar), (0, $koWFd.default)),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $arJNO.getCommonProjectResources)()
        ],
        layout: (0, $aPfsS.createLayout)((0, $e7bC3.softwareProjectLayoutNoOnboarding)),
        // We want to opt out of concurrent mode for all NIN routes https://hello.atlassian.net/wiki/x/wTRfDAE
        // But allow for users with empanada-concurrent-incremental gate enabled to continue testing it
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental') && !(0, $4R6GH.fg)('empanada-concurrent-incremental'),
        entryPoint: ()=>(0, $b8f12.issueNavigatorPageEntryPoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("5vzYC", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectSoftwareRoute", () => $4a5b2c25740c19d3$export$b8bd410115307d80);
const $4a5b2c25740c19d3$export$b8bd410115307d80 = {
    name: 'software-issue-navigator',
    // Remove the issueKey path param when cleaning up slv-4_migrate_nin_selected_issue_route
    path: '/jira/software/projects/:projectKey/issues/:issueKey?',
    query: [
        'selectedIssue?'
    ]
};

});


parcelRegister("gm7fA", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessAttachmentsRouteEntry", () => $dfc0a30c9444e0ae$export$62c45d8ff658b6c2);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $bokkA = parcelRequire("bokkA");

var $6DXrm = parcelRequire("6DXrm");

var $lkFvK = parcelRequire("lkFvK");

var $fo6b8 = parcelRequire("fo6b8");
const $dfc0a30c9444e0ae$var$attachmentsPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $6DXrm.attachmentsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $dfc0a30c9444e0ae$export$62c45d8ff658b6c2 = (0, $7NszV.createEntry)((0, $bokkA.jiraBusinessAttachmentsRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.attachments-view',
        layout: (0, $lRPBw.businessProjectLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        entryPoint: ()=>$dfc0a30c9444e0ae$var$attachmentsPageEntryPoint,
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: (0, $lNicp.getProjectViewResources)(),
        supportsPreviewPanel: true
    }));

});
parcelRegister("bokkA", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessAttachmentsRoute", () => $8ee02e904721e8ab$export$81237c0b791e592e);
const $8ee02e904721e8ab$export$81237c0b791e592e = {
    name: 'classic-business-attachments',
    path: '/jira/core/projects/:projectKey/attachments'
};

});

parcelRegister("6DXrm", function(module, exports) {

$parcel$export(module.exports, "attachmentsEntryPoint", () => $5488b7c894698968$export$d94bafd9d893ec98);

var $e31y9 = parcelRequire("e31y9");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $5488b7c894698968$export$d94bafd9d893ec98 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("fIEnV")), {
        moduleId: "26a1d436",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        // This entry point should only load in this route
        // once overview is supported by backend, we should have a different entry point for it
        const { projectKey: projectKey } = context.match.params;
        if (!projectKey) throw new Error('projectKey is required');
        return {
            queries: {
                jwmAttachmentsQuery: {
                    parameters: $e31y9.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: projectKey,
                        projectKeys: [
                            projectKey
                        ],
                        filters: {
                            fileName: '',
                            authorIds: [],
                            mimeTypes: [],
                            dateRange: {
                                before: undefined,
                                after: undefined
                            }
                        },
                        durationInSeconds: 900,
                        maxTokenLength: 65534,
                        attachmentCount: 100
                    },
                    options: {
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        fetchPolicy: 'network-only'
                    }
                }
            },
            entryPoints: {},
            extraProps: {}
        };
    }
});

});
parcelRegister("e31y9", function(module, exports) {

$parcel$export(module.exports, "default", () => $6955691f2f41efa8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<27cf8d4c8476b55ad0214615c4321597>>
 * @relayHash c6e9983b2d202d37d436585f73068bb1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9c2e6d7f1e46fae7f20940e5f2d25270db884f9c4ffb727bc5ca1be7cef02546
const $6955691f2f41efa8$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "9c2e6d7f1e46fae7f20940e5f2d25270db884f9c4ffb727bc5ca1be7cef02546",
        "metadata": {},
        "name": "src_jiraBusinessAttachmentsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $6955691f2f41efa8$export$2e2bcd8739ae039 = $6955691f2f41efa8$var$node;

});

parcelRegister("fIEnV", function(module, exports) {

let $b71a4aabd8d5e093$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $b71a4aabd8d5e093$var$load("ffQaD"),
    $b71a4aabd8d5e093$var$load("kvRbA"),
    $b71a4aabd8d5e093$var$load("3m9rR")
]).then(()=>parcelRequire('hLT0c'));

});



parcelRegister("8gEiV", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessBoardCustomEmbedRouteEntry", () => $8fc4c7c9ffb4bf6a$export$4622ad4c7294f3a7);

var $6e4Kt = parcelRequire("6e4Kt");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $d8VYe = parcelRequire("d8VYe");

var $lNicp = parcelRequire("lNicp");

var $5JXXx = parcelRequire("5JXXx");

var $93hm0 = parcelRequire("93hm0");
const $8fc4c7c9ffb4bf6a$export$4622ad4c7294f3a7 = (0, $7NszV.createEntry)((0, $5JXXx.jiraBusinessBoardCustomEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.jwm-board-embed',
        layout: (0, $6e4Kt.chromelessLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        resources: [
            ...(0, $lNicp.getProjectViewResources)(),
            (0, $d8VYe.workflowIssuesResource)
        ],
        entryPoint: ()=>(0, $93hm0.boardEmbedPageEntryPoint)
    }));

});
parcelRegister("d8VYe", function(module, exports) {

$parcel$export(module.exports, "workflowIssuesResource", () => $6a9e21653771d63a$export$49027035af709702);
$parcel$export(module.exports, "useWorkflowIssues", () => $6a9e21653771d63a$export$86b7de71bf71360d);

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $9YrR3 = parcelRequire("9YrR3");
const $6a9e21653771d63a$var$RESOURCE_TYPE_KEY = 'BUSINESS_WORKFLOW_ISSUES';

const $6a9e21653771d63a$export$49027035af709702 = (0, $2M1hQ.createResource)({
    type: $6a9e21653771d63a$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        return `${$6a9e21653771d63a$var$RESOURCE_TYPE_KEY}_${projectKey}_${matchedRoute.match?.params?.itemId ?? 'default'}`;
    },
    getDataLoader: ()=>Promise.resolve((parcelRequire("9YrR3"))),
    getData: (0, $9YrR3.default),
    maxAge: 1000,
    isBrowserOnly: true
});
const $6a9e21653771d63a$export$86b7de71bf71360d = ()=>// forcing the return type due to react-resource-router's weird error types
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $2YP9W.useResource)($6a9e21653771d63a$export$49027035af709702);

});
parcelRegister("9YrR3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $465154b480a996b2$export$2e2bcd8739ae039);

var $7juH2 = parcelRequire("7juH2");

var $x9xyg = parcelRequire("x9xyg");

var $jJZqs = parcelRequire("jJZqs");

var $8PRuf = parcelRequire("8PRuf");

var $iR3GG = parcelRequire("iR3GG");
const $465154b480a996b2$var$EMPTY_DATA = {
    workflows: [],
    lastChangedTime: null
};
function $465154b480a996b2$var$getEarlyPreload() {
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__JIRA_BUSINESS_BOARD_WORKFLOWS_DATA_PROMISE__) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const earlyPreloadPromise = window.__JIRA_BUSINESS_BOARD_WORKFLOWS_DATA_PROMISE__;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__JIRA_BUSINESS_BOARD_WORKFLOWS_DATA_PROMISE__ = null;
        return earlyPreloadPromise.then((response)=>{
            if (!response.success) {
                if (response.error.status === 304) throw new (0, $7juH2.Unchanged)('Workflow issues have not changed since the last request');
                throw new (0, $jJZqs.default)(response.error.status);
            }
            return {
                workflows: response.workflows,
                lastChangedTime: null
            };
        });
    }
    return null;
}
function $465154b480a996b2$var$fetchData({ projectKey: projectKey, itemId: itemId }) {
    const earlyPreload = $465154b480a996b2$var$getEarlyPreload();
    if (earlyPreload !== null) return earlyPreload;
    return (0, $7juH2.fetchWorkflowIssues)({
        projectKey: projectKey,
        itemId: itemId
    });
}
async function $465154b480a996b2$export$2e2bcd8739ae039({ match: match }, { tenantContext: tenantContext }) {
    const { isAnonymous: isAnonymous } = tenantContext;
    if (isAnonymous) return $465154b480a996b2$var$EMPTY_DATA;
    try {
        (0, $x9xyg.setMark)((0, $8PRuf.prefetchApiStartMark));
        const workflows = await $465154b480a996b2$var$fetchData({
            projectKey: match.params.projectKey ?? '',
            itemId: match.params.itemId ?? undefined
        });
        (0, $x9xyg.setMark)((0, $8PRuf.prefetchApiReadyMark));
        return workflows;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $iR3GG.createResourceError)({
            component: 'spa.view.routes.business.board-workflows.getData',
            message: 'An error was thrown while prefetching board data',
            name: 'ResourceError'
        }, error);
    }
}

});
parcelRegister("7juH2", function(module, exports) {

$parcel$export(module.exports, "Unchanged", () => $16e71a1b1f979cb0$export$eccd6db33b8f6a89);
$parcel$export(module.exports, "fetchWorkflowIssues", () => $16e71a1b1f979cb0$export$17e2e8212d93f58d);

var $gKZoD = parcelRequire("gKZoD");


var $gN11a = parcelRequire("gN11a");

var $jJZqs = parcelRequire("jJZqs");

var $5HnTq = parcelRequire("5HnTq");
class $16e71a1b1f979cb0$export$eccd6db33b8f6a89 extends Error {
}
const $16e71a1b1f979cb0$export$17e2e8212d93f58d = async ({ projectKey: projectKey, itemId: itemId, ifChangedSince: ifChangedSince })=>{
    (0, $gKZoD.di)(fetch);
    try {
        (0, $gN11a.markViewMetric)('jwm-board', (0, $a286480ec63fa4c8$export$23e322eb7c526958));
        let url = `/rest/board-api/1/board/${projectKey}/workflows?excludeLabels=true`;
        if (itemId) url += `&viewItemId=${itemId}`;
        const defaultOptions = (0, $5HnTq.getDefaultOptions)(url);
        const response = await fetch(url, {
            ...defaultOptions,
            headers: {
                ...defaultOptions.headers,
                ...ifChangedSince ? {
                    'x-aif-changed-since': ifChangedSince
                } : undefined
            }
        });
        if (!response.ok) {
            if (response.status === 304) throw new $16e71a1b1f979cb0$export$eccd6db33b8f6a89('Workflow issues have not changed since the last request');
            throw new (0, $jJZqs.default)(response.status);
        }
        const lastChangedTime = response.headers.get('x-alast-changed-time');
        const workflows = await response.json();
        return {
            workflows: workflows.data,
            lastChangedTime: lastChangedTime
        };
    } finally{
        (0, $gN11a.markViewMetric)('jwm-board', (0, $a286480ec63fa4c8$export$83ca21a50372ea3b));
    }
};

});
const $a286480ec63fa4c8$export$747aad128920134d = 3000;
const $a286480ec63fa4c8$export$e4f8d353742c04ac = 4000;
const $a286480ec63fa4c8$export$540ffd289e5e0562 = 'timeWaitingForBackendData';
const $a286480ec63fa4c8$export$23e322eb7c526958 = 'REQUEST_START';
const $a286480ec63fa4c8$export$83ca21a50372ea3b = 'REQUEST_END';
const $a286480ec63fa4c8$export$821ca6ff41f300ec = 'jwm-availableFieldsQuery';
const $a286480ec63fa4c8$export$7b887ee35f2b465e = 'AVAILABLE_FIELDS_QUERY_START';
const $a286480ec63fa4c8$export$ac953882305d6102 = 'AVAILABLE_FIELDS_QUERY_END';
const $a286480ec63fa4c8$export$7f7f60b5526c5ee3 = 'jwm-ui-render-time';
const $a286480ec63fa4c8$export$b78f0bbf209e5f4 = 'UI_RENDER_START';
const $a286480ec63fa4c8$export$88ea1e280513690f = 'UI_RENDER_END';

parcelRegister("gN11a", function(module, exports) {

$parcel$export(module.exports, "pageLoadMetrics", () => $f9c6206c3cbbca63$export$2878bf482e539059);
$parcel$export(module.exports, "markViewMetric", () => $f9c6206c3cbbca63$export$8d15b4fb25f90514);

var $dGrdR = parcelRequire("dGrdR");

const $f9c6206c3cbbca63$var$slo = {
    fmp: {
        initial: {
            threshold: (0, $a286480ec63fa4c8$export$747aad128920134d)
        },
        transition: {
            threshold: (0, $a286480ec63fa4c8$export$747aad128920134d)
        }
    },
    tti: {
        initial: {
            threshold: (0, $a286480ec63fa4c8$export$e4f8d353742c04ac)
        },
        transition: {
            threshold: (0, $a286480ec63fa4c8$export$e4f8d353742c04ac)
        }
    }
};
const $f9c6206c3cbbca63$var$timings = [
    {
        key: (0, $a286480ec63fa4c8$export$540ffd289e5e0562),
        startMark: (0, $a286480ec63fa4c8$export$23e322eb7c526958),
        endMark: (0, $a286480ec63fa4c8$export$83ca21a50372ea3b)
    },
    {
        key: (0, $a286480ec63fa4c8$export$821ca6ff41f300ec),
        startMark: (0, $a286480ec63fa4c8$export$7b887ee35f2b465e),
        endMark: (0, $a286480ec63fa4c8$export$ac953882305d6102)
    },
    {
        key: (0, $a286480ec63fa4c8$export$7f7f60b5526c5ee3),
        startMark: (0, $a286480ec63fa4c8$export$b78f0bbf209e5f4),
        endMark: (0, $a286480ec63fa4c8$export$88ea1e280513690f)
    }
];
const $f9c6206c3cbbca63$export$2878bf482e539059 = {
    'approvals-view': (0, $dGrdR.metrics).pageLoad({
        key: 'jwm.approvals-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    summary: (0, $dGrdR.metrics).pageLoad({
        key: 'jwm.summary-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'summary-embed': (0, $dGrdR.metrics).pageLoad({
        key: 'jwm.summary-view-embed',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    list: (0, $dGrdR.metrics).pageLoad({
        key: 'jwm.list-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'list-embed': (0, $dGrdR.metrics).pageLoad({
        key: 'jwm.list-embed-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'software-form-submit-embed': (0, $dGrdR.metrics).pageLoad({
        key: 'jsw.form-submit-embed',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'software-list': (0, $dGrdR.metrics).pageLoad({
        key: 'jsw.list-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'software-list-embed': (0, $dGrdR.metrics).pageLoad({
        key: 'jsw.list-view-embed',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    timeline: (0, $dGrdR.metrics).pageLoad({
        key: 'jwm.timeline-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'timeline-embed': (0, $dGrdR.metrics).pageLoad({
        key: 'jwm.timeline-embed-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    calendar: (0, $dGrdR.metrics).pageLoad({
        key: 'jwm.calendar-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'calendar-embed': (0, $dGrdR.metrics).pageLoad({
        key: 'jwm.calendar-embed-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    form: (0, $dGrdR.metrics).pageLoad({
        key: 'jwm.form-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'form-submit': (0, $dGrdR.metrics).pageLoad({
        key: 'jwm.form-submit-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'form-submit-embed': (0, $dGrdR.metrics).pageLoad({
        key: 'jwm.form-submit-embed-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'form-submit-public': (0, $dGrdR.metrics).pageLoad({
        key: 'jwm.form-submit-public-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'form-directory': (0, $dGrdR.metrics).pageLoad({
        key: 'jwm.form-directory-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    board: (0, $dGrdR.metrics).pageLoad({
        key: 'jwm.board-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'jwm-board': (0, $dGrdR.metrics).pageLoad({
        key: 'jwm.jwm-board',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'jwm-board-embed': (0, $dGrdR.metrics).pageLoad({
        key: 'jwm.jwm-board-embed',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'jwm-pages': (0, $dGrdR.metrics).pageLoad({
        key: 'jwm.jwm-pages',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    // TODO: will be removed with sploverview-decouple-calendar-perf-metrics
    'software-plan-calendar': (0, $dGrdR.metrics).pageLoad({
        key: 'jsw.plan-calendar-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    })
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f9c6206c3cbbca63$var$startedMarks = {};
const $f9c6206c3cbbca63$export$8d15b4fb25f90514 = (view, mark)=>{
    const markKey = `${view}-${mark}`;
    // prevent overriding marks when markViewMetric() is called many times with the same param
    if ($f9c6206c3cbbca63$var$startedMarks[markKey]) return;
    $f9c6206c3cbbca63$var$startedMarks[markKey] = true;
    const metric = $f9c6206c3cbbca63$export$2878bf482e539059[view];
    metric?.mark(mark);
};

});




parcelRegister("5JXXx", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessBoardCustomEmbedRoute", () => $609d5e332788d2ad$export$7d977a74e9d9d32b);
const $609d5e332788d2ad$export$7d977a74e9d9d32b = {
    name: 'classic-business-board-custom-embed',
    path: '/jira/core/projects/:projectKey/board/:itemId/embed',
    exact: true
};

});

parcelRegister("93hm0", function(module, exports) {

$parcel$export(module.exports, "boardEmbedPageEntryPoint", () => $b8780d447378502c$export$5046daadb8899791);

var $lkFvK = parcelRequire("lkFvK");

var $9715X = parcelRequire("9715X");
const $b8780d447378502c$export$5046daadb8899791 = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $9715X.boardEmbedEntryPoint)
});

});
parcelRegister("9715X", function(module, exports) {

$parcel$export(module.exports, "boardEmbedEntryPoint", () => $302c841aa900e4ab$export$416ba69e2e054935);

var $kCyK0 = parcelRequire("kCyK0");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $302c841aa900e4ab$export$416ba69e2e054935 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("3xH9w")), {
        moduleId: "c853cc44",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        const itemId = context.match.params.itemId ?? '';
        let filterJql = context.query?.filter;
        let groupBy = context.query?.groupBy;
        // if in a client environment, check whether the router url matches the current window pathname
        // if it does, use the filter and groupBy from the current window location instead of the router query
        // this avoids reloading the query without the overrides when a user hovers over prefetching links that don't include them
        if (typeof window !== 'undefined' && window.location.pathname === context.match.url) {
            const searchParams = new URLSearchParams(window.location.search);
            filterJql = searchParams.get('filter') ?? undefined;
            groupBy = searchParams.get('groupBy') ?? undefined;
        }
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                boardEmbedQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $kCyK0.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey,
                        viewInput: {
                            jiraBoardViewQueryInput: {
                                projectKeyAndItemIdQuery: {
                                    cloudId: cloudId,
                                    projectKey: projectKey,
                                    itemId: itemId
                                }
                            },
                            settings: {
                                filterJql: filterJql,
                                groupBy: groupBy
                            }
                        }
                    }
                }
            }
        };
    }
});

});
parcelRegister("kCyK0", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc9b07a0cf3a6615$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6ea30a83ac060a9221d6b5a68fd65577>>
 * @relayHash 2857d7a63c00b432f8bcdcf77a7b98b3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b257013a105e897ea6bf87125f47d4cee1951c5d2e40b694afff240092da93e2

var $3K6QB = parcelRequire("3K6QB");

var $apYuT = parcelRequire("apYuT");
const $cc9b07a0cf3a6615$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "b257013a105e897ea6bf87125f47d4cee1951c5d2e40b694afff240092da93e2",
        "metadata": {},
        "name": "src_jiraBusinessBoardEmbedQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcallowstatusmappingonbusinessboardrelayprovider": (0, $3K6QB.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider": (0, $apYuT.default)
        }
    }
};
var $cc9b07a0cf3a6615$export$2e2bcd8739ae039 = $cc9b07a0cf3a6615$var$node;

});
parcelRegister("3K6QB", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a116c0c5e30cca9$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $4a116c0c5e30cca9$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('mbw-43-allow-status-mapping-on-business-board');
    }
};

});

parcelRegister("apYuT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4118540cc4c9ddd7$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");
const $4118540cc4c9ddd7$var$MergeBoardWorkflowsRelayProvider = {
    get () {
        return (0, $6s1PB.expVal)('merge_board_workflows', 'enabled', false);
    }
};
var $4118540cc4c9ddd7$export$2e2bcd8739ae039 = $4118540cc4c9ddd7$var$MergeBoardWorkflowsRelayProvider;

});


parcelRegister("3xH9w", function(module, exports) {

let $2945ed6316c4aa28$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $2945ed6316c4aa28$var$load("ffQaD"),
    $2945ed6316c4aa28$var$load("kvRbA"),
    $2945ed6316c4aa28$var$load("fliVL"),
    $2945ed6316c4aa28$var$load("7TaZM")
]).then(()=>parcelRequire('azXNC'));

});




parcelRegister("gbj7F", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessBoardEmbedRouteEntry", () => $0142438b20a4e9a9$export$7a97e5e258f37b2a);

var $6e4Kt = parcelRequire("6e4Kt");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $d8VYe = parcelRequire("d8VYe");

var $lNicp = parcelRequire("lNicp");

var $0sAwf = parcelRequire("0sAwf");

var $93hm0 = parcelRequire("93hm0");
const $0142438b20a4e9a9$export$7a97e5e258f37b2a = (0, $7NszV.createEntry)((0, $0sAwf.jiraBusinessBoardEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.jwm-board-embed',
        layout: (0, $6e4Kt.chromelessLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        resources: [
            ...(0, $lNicp.getProjectViewResources)(),
            (0, $d8VYe.workflowIssuesResource)
        ],
        entryPoint: ()=>(0, $93hm0.boardEmbedPageEntryPoint)
    }));

});
parcelRegister("0sAwf", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessBoardEmbedRoute", () => $143b8615692fbb7d$export$bd75a810572fe27d);
const $143b8615692fbb7d$export$bd75a810572fe27d = {
    name: 'classic-business-board-embed',
    path: '/jira/core/projects/:projectKey/board/embed',
    exact: true
};

});


parcelRegister("dhiyM", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessBoardRouteEntry", () => $0eb25cb247c76465$export$c7fe0dd4417407a0);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $g5RGc = parcelRequire("g5RGc");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $d8VYe = parcelRequire("d8VYe");

var $lNicp = parcelRequire("lNicp");

var $g8BTw = parcelRequire("g8BTw");

var $gkbjZ = parcelRequire("gkbjZ");
const $0eb25cb247c76465$export$c7fe0dd4417407a0 = (0, $7NszV.createEntry)((0, $g8BTw.jiraBusinessBoardRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.jwm-board',
        layout: (0, $aPfsS.composeLayouts)((0, $lRPBw.businessProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $lNicp.getProjectViewResources)(),
            (0, $d8VYe.workflowIssuesResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'business-board-early-entry'
            ]
        },
        entryPoint: ()=>(0, $gkbjZ.boardPageEntryPoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("g8BTw", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessBoardRoute", () => $66846ddeea123664$export$14a5cbbd7e1e2dc2);
const $66846ddeea123664$export$14a5cbbd7e1e2dc2 = {
    name: 'classic-business-board',
    exact: true,
    path: '/jira/core/projects/:projectKey/board/:itemId?'
};

});

parcelRegister("gkbjZ", function(module, exports) {

$parcel$export(module.exports, "boardPageEntryPoint", () => $39c257a891cf9743$export$552f44bed039f041);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $7AGbN = parcelRequire("7AGbN");

var $fo6b8 = parcelRequire("fo6b8");
const $39c257a891cf9743$export$552f44bed039f041 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7AGbN.boardEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("7AGbN", function(module, exports) {

$parcel$export(module.exports, "boardEntryPoint", () => $a4aaf8c5264c4217$export$937ca5a4cdc1a12e);

var $lzufP = parcelRequire("lzufP");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $a4aaf8c5264c4217$export$937ca5a4cdc1a12e = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("c0LIk")), {
        moduleId: "8dcbcc62",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        const itemId = context.match.params.itemId ?? '';
        let filterJql = context.query?.filter;
        let groupBy = context.query?.groupBy;
        // if in a client environment, check whether the router url matches the current window pathname
        // if it does, use the filter and groupBy from the current window location instead of the router query
        // this avoids reloading the query without the overrides when a user hovers over prefetching links that don't include them
        if (typeof window !== 'undefined' && window.location.pathname === context.match.url) {
            const searchParams = new URLSearchParams(window.location.search);
            filterJql = searchParams.get('filter') ?? undefined;
            groupBy = searchParams.get('groupBy') ?? undefined;
        }
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                boardQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $lzufP.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey,
                        viewInput: {
                            jiraBoardViewQueryInput: {
                                projectKeyAndItemIdQuery: {
                                    cloudId: cloudId,
                                    projectKey: projectKey,
                                    itemId: itemId
                                }
                            },
                            settings: {
                                filterJql: filterJql,
                                groupBy: groupBy
                            }
                        }
                    }
                }
            }
        };
    }
});

});
parcelRegister("lzufP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e141afb773c5347$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fdd5f2faba9f3b11a68a52fc75809d2f>>
 * @relayHash 66470b7cddbae81c8d8d9b3d877eaebe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 316c8fbd62b804d89d8a55da9aa1042f281d1943b652a8bc66ca2ecce1629e7a

var $3K6QB = parcelRequire("3K6QB");

var $apYuT = parcelRequire("apYuT");
const $5e141afb773c5347$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "316c8fbd62b804d89d8a55da9aa1042f281d1943b652a8bc66ca2ecce1629e7a",
        "metadata": {},
        "name": "src_jiraBusinessBoardQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcallowstatusmappingonbusinessboardrelayprovider": (0, $3K6QB.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider": (0, $apYuT.default)
        }
    }
};
var $5e141afb773c5347$export$2e2bcd8739ae039 = $5e141afb773c5347$var$node;

});

parcelRegister("c0LIk", function(module, exports) {

let $8bea7f1e501feaf4$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $8bea7f1e501feaf4$var$load("ffQaD"),
    $8bea7f1e501feaf4$var$load("kvRbA"),
    $8bea7f1e501feaf4$var$load("fliVL"),
    $8bea7f1e501feaf4$var$load("4jU2d")
]).then(()=>parcelRequire('ac4Ca'));

});




parcelRegister("21AP4", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessCalendarEmbedRouteEntry", () => $600d33daee8526e1$export$d75a7b48d8838f92);

var $6e4Kt = parcelRequire("6e4Kt");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $d5vH1 = parcelRequire("d5vH1");

var $lkFvK = parcelRequire("lkFvK");

var $4wa6C = parcelRequire("4wa6C");
const $600d33daee8526e1$var$calendarEmbedPageEntrypoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $4wa6C.calendarEntryPoint)
});
const $600d33daee8526e1$export$d75a7b48d8838f92 = (0, $7NszV.createEntry)((0, $d5vH1.jiraBusinessCalendarEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.calendar-embed-view',
        entryPoint () {
            return $600d33daee8526e1$var$calendarEmbedPageEntrypoint;
        },
        layout: (0, $6e4Kt.chromelessLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        resources: (0, $lNicp.getProjectViewResources)()
    }));

});
parcelRegister("d5vH1", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessCalendarEmbedRoute", () => $085faca8e3760e1d$export$71a801c267234959);
const $085faca8e3760e1d$export$71a801c267234959 = {
    name: 'classic-business-calendar-embed',
    path: '/jira/core/projects/:projectKey/calendar/embed',
    exact: true
};

});

parcelRegister("4wa6C", function(module, exports) {

$parcel$export(module.exports, "calendarEntryPoint", () => $38193f9d05bd632a$export$19cf4b398f638dc6);

var $4R6GH = parcelRequire("4R6GH");

var $8s8gU = parcelRequire("8s8gU");

var $7JhZX = parcelRequire("7JhZX");

var $6s1PB = parcelRequire("6s1PB");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");
const $38193f9d05bd632a$var$SETTINGS_STORAGE_KEY = 'calendar:settings:business';
function $38193f9d05bd632a$var$getViewSettings(key) {
    try {
        const serializedValue = globalThis.localStorage?.getItem(key);
        return serializedValue !== null ? JSON.parse(serializedValue) : undefined;
    } catch  {
        return undefined;
    }
}
const $38193f9d05bd632a$var$and = (clauses)=>{
    return clauses.map((clause)=>clause.trim()).filter((clause)=>clause.length > 0).join(' AND ');
};
function $38193f9d05bd632a$var$toMidnightUTCString(date) {
    const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    return new Date(utcMilliseconds).toISOString();
}
function $38193f9d05bd632a$var$toDate(date) {
    if (!date) return new Date();
    try {
        const _date = new Date(date);
        return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
    } catch (e) {
        return new Date();
    }
}
function $38193f9d05bd632a$var$createScope({ context: context }) {
    return {
        type: 'project',
        projectKeys: [
            String(context.match.params.projectKey)
        ]
    };
}
function $38193f9d05bd632a$var$buildScopeInput({ tenantContext: tenantContext }, scope) {
    const { cloudId: cloudId } = tenantContext;
    return {
        projectKeys: {
            cloudId: cloudId,
            keys: scope.projectKeys
        }
    };
}
function $38193f9d05bd632a$var$toViewMode(mode) {
    switch(mode){
        case 'week':
            return 'WEEK';
        case 'day':
            return 'DAY';
        default:
            return 'MONTH';
    }
}
function $38193f9d05bd632a$var$toWeekStart(weekStart) {
    switch(weekStart){
        case 'monday':
            return 'MONDAY';
        case 'saturday':
            return 'SATURDAY';
        default:
            return 'SUNDAY';
    }
}
function $38193f9d05bd632a$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField }) {
    return {
        date: $38193f9d05bd632a$var$toMidnightUTCString(selectedDate),
        mode: $38193f9d05bd632a$var$toViewMode(viewRange),
        weekStart: $38193f9d05bd632a$var$toWeekStart(weekStartsOn),
        startDateField: startDateField,
        endDateField: endDateField,
        viewId: null
    };
}
/** Extracted from business/shared/simpleSearch */ function $38193f9d05bd632a$var$jqlSearchText(text) {
    if (text === undefined || text.trim() === '') return '';
    const sanitize = (value)=>value.replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/\t/g, ' ');
    const ISSUEKEY_REGEX = '([A-Z][A-Z0-9_]+-\\d+)';
    const issueKeyRegex = new RegExp(`^${ISSUEKEY_REGEX}$`);
    const japaneseAndChineseRegex = /[\p{Script_Extensions=Hiragana}\p{Script_Extensions=Katakana}\p{Script_Extensions=Han}]/u;
    let search = sanitize(text);
    if (issueKeyRegex.test(text)) return `(summary ~ '${search}*' OR description ~ '${search}*' OR key = '${search}')`;
    // if the text does not contain Chinese or Japanese characters (which are not tokenized),
    // and does not end with a space character
    // make it a wildcard search
    if (!japaneseAndChineseRegex.test(text) && !text.endsWith(' ')) search = `${search}*`;
    return `(summary ~ '${search}' OR description ~ '${search}')`;
}
function $38193f9d05bd632a$var$buildIssuesSearchInput(filter = '', text = '', hideDoneItems) {
    if (!(0, $4R6GH.fg)('jira_calendar_load_more_pagination')) return {
        additionalFilterQuery: ''
    };
    const hideDoneItemsQuery = "StatusCategory != 'Complete'";
    const search = $38193f9d05bd632a$var$jqlSearchText(text);
    return {
        additionalFilterQuery: $38193f9d05bd632a$var$and([
            search,
            filter,
            ...hideDoneItems ? [
                hideDoneItemsQuery
            ] : []
        ])
    };
}
function $38193f9d05bd632a$var$buildUnscheduledIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}

const $38193f9d05bd632a$export$19cf4b398f638dc6 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("Qsp1w")), {
        moduleId: "70b39bf1",
        priority: "userVisible"
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
        const { cloudId: cloudId } = tenantContext;
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        const scope = $38193f9d05bd632a$var$createScope(entryPointRouteParams);
        const { date: date, filter: filter, hideDone: hideDone, text: text } = context.query;
        const selectedDate = $38193f9d05bd632a$var$toDate(date);
        const settings = (0, $4R6GH.fg)('jira_calendar_load_more_pagination') ? $38193f9d05bd632a$var$getViewSettings($38193f9d05bd632a$var$SETTINGS_STORAGE_KEY) : undefined;
        const viewRange = 'month';
        const hideDoneItems = hideDone && (0, $4R6GH.fg)('calendar-hide-done-query-param') ? true : settings?.hideDoneItems ?? false;
        const weekStartsOn = (0, $4R6GH.fg)('jira_calendar_load_more_pagination') ? settings?.weekStartsOn ?? 'sunday' : 'sunday';
        const startDateField = 'startdate';
        const endDateField = 'duedate';
        const issueEventFields = {
            startDateField: startDateField,
            endDateField: endDateField
        };
        return {
            queries: {
                calendarQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $8s8gU.default),
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                calendarData: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $7JhZX.default),
                    variables: {
                        cloudId: cloudId,
                        scopeInput: $38193f9d05bd632a$var$buildScopeInput(entryPointRouteParams, scope),
                        configurationInput: $38193f9d05bd632a$var$buildConfigurationInput({
                            selectedDate: selectedDate,
                            viewRange: viewRange,
                            weekStartsOn: weekStartsOn,
                            startDateField: startDateField,
                            endDateField: endDateField
                        }),
                        issuesPageSize: (0, $4R6GH.fg)('jira_calendar_lazy_load') ? 200 : 50,
                        issuesSearchInput: $38193f9d05bd632a$var$buildIssuesSearchInput(filter, text, hideDoneItems),
                        unscheduledIssuesSearchInput: $38193f9d05bd632a$var$buildUnscheduledIssuesSearchInput(),
                        versionsSearchInput: {
                            versionStatuses: [
                                'RELEASED',
                                'UNRELEASED'
                            ],
                            includeSharedReleases: true
                        },
                        sprintsSearchInput: null,
                        skipSprintSearch: true,
                        viewId: null,
                        schedulePermissionsEnabled: (0, $4R6GH.fg)('calendar_schedule_issue_permissions_check'),
                        pageLoadMoreEnabled: (0, $4R6GH.fg)('jira_calendar_load_more_pagination'),
                        skipVersionsV1Search: (0, $4R6GH.fg)('plan-calendar-versions-v2-adoption'),
                        skipVersionsV2Search: !(0, $4R6GH.fg)('plan-calendar-versions-v2-adoption'),
                        includeRecurrenceIndicator: (0, $6s1PB.expValEquals)('jira-recur-single-work-item-on-schedule', 'isRecurrenceCalendarViewEnabled', true),
                        pageLoadMoreEnabledViewSettings: (0, $4R6GH.fg)('jira_calendar_load_more_pagination_view_settings')
                    }
                }
            },
            entryPoints: {},
            extraProps: {
                scope: scope,
                selectedDate: selectedDate,
                viewRange: viewRange,
                weekStartsOn: weekStartsOn,
                issueEventFields: issueEventFields,
                hasRecurrenceItemIndicator: (0, $6s1PB.expValEquals)('jira-recur-single-work-item-on-schedule', 'isRecurrenceCalendarViewEnabled', true)
            }
        };
    }
});

});
parcelRegister("8s8gU", function(module, exports) {

$parcel$export(module.exports, "default", () => $04b6b433e450264c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<620394e61554de6b4de7fc13153ce658>>
 * @relayHash e7f526a757abd5ec137c62e6d5d37fb3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 23ff8ebcf7d113448b039ee2b0b9d7d1d70d6a6af70115838ee65796d163a423
const $04b6b433e450264c$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "23ff8ebcf7d113448b039ee2b0b9d7d1d70d6a6af70115838ee65796d163a423",
        "metadata": {},
        "name": "src_jiraBusinessSharedCalendarQuery",
        "operationKind": "query",
        "text": null
    }
};
var $04b6b433e450264c$export$2e2bcd8739ae039 = $04b6b433e450264c$var$node;

});

parcelRegister("Qsp1w", function(module, exports) {

let $09dae39c06e24b27$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $09dae39c06e24b27$var$load("ffQaD"),
    $09dae39c06e24b27$var$load("kvRbA"),
    $09dae39c06e24b27$var$load("76n7a"),
    $09dae39c06e24b27$var$load("l253H"),
    $09dae39c06e24b27$var$load("9BiZd")
]).then(()=>parcelRequire('jJF0P'));

});



parcelRegister("infHq", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessCalendarRouteEntry", () => $2bf1458ced078f1f$export$b8f4785659c5349e);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $aMqk7 = parcelRequire("aMqk7");

var $lkFvK = parcelRequire("lkFvK");

var $4wa6C = parcelRequire("4wa6C");

var $fo6b8 = parcelRequire("fo6b8");
const $2bf1458ced078f1f$var$calendarPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $4wa6C.calendarEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $2bf1458ced078f1f$export$b8f4785659c5349e = (0, $7NszV.createEntry)((0, $aMqk7.jiraBusinessCalendarRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.calendar-view',
        entryPoint () {
            return $2bf1458ced078f1f$var$calendarPageEntrypoint;
        },
        layout: (0, $lRPBw.businessProjectLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: (0, $lNicp.getProjectViewResources)(),
        supportsPreviewPanel: true
    }));

});
parcelRegister("aMqk7", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessCalendarRoute", () => $4cb3bab25d5027cf$export$3f1924073260dde6);
const $4cb3bab25d5027cf$export$3f1924073260dde6 = {
    name: 'classic-business-calendar',
    path: '/jira/core/projects/:projectKey/calendar',
    exact: true
};

});


parcelRegister("9yqzH", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessListEmbedRouteEntry", () => $965e54647b28fbce$export$a6737d9a8c0f9d4f);

var $6e4Kt = parcelRequire("6e4Kt");

var $lkFvK = parcelRequire("lkFvK");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $jwVzG = parcelRequire("jwVzG");

var $dfTsw = parcelRequire("dfTsw");
const $965e54647b28fbce$var$listEmbedPageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $dfTsw.listEmbedEntryPoint)
});
const $965e54647b28fbce$export$a6737d9a8c0f9d4f = (0, $7NszV.createEntry)((0, $jwVzG.jiraBusinessListEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.list-embed-view',
        layout: (0, $6e4Kt.chromelessLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        entryPoint: ()=>$965e54647b28fbce$var$listEmbedPageEntryPoint,
        resources: (0, $lNicp.getProjectViewResources)()
    }));

});
parcelRegister("jwVzG", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessListEmbedRoute", () => $9db7312602117a3c$export$40306068630dfc2);
const $9db7312602117a3c$export$40306068630dfc2 = {
    name: 'classic-business-list-embed',
    path: '/jira/core/projects/:projectKey/list/embed',
    exact: true
};

});

parcelRegister("dfTsw", function(module, exports) {

$parcel$export(module.exports, "listEmbedEntryPoint", () => $4eb9b872b8483ed3$export$519bb55e1612f243);

var $EVQo4 = parcelRequire("EVQo4");

var $iptXe = parcelRequire("iptXe");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");
const $4eb9b872b8483ed3$var$FORMAT_RULES_FIRST = 20;

const $4eb9b872b8483ed3$export$519bb55e1612f243 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("hkEPp")), {
        moduleId: "543152bd",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                listEmbedQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $iptXe.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                formattingRulesQuery: {
                    parameters: (0, $EVQo4.default),
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId,
                        first: $4eb9b872b8483ed3$var$FORMAT_RULES_FIRST
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        };
    }
});

});
parcelRegister("EVQo4", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fc143a99d34d8f4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b813023754a9b145ce165f16a407c601>>
 * @relayHash 59527960279493483dc426741a94e942
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 27842af21d3c4a1c89e9cf81f5d797dbb89b3da4ac6cc54f90271e8a38b37e39
const $6fc143a99d34d8f4$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "27842af21d3c4a1c89e9cf81f5d797dbb89b3da4ac6cc54f90271e8a38b37e39",
        "metadata": {},
        "name": "formatRulesQuery",
        "operationKind": "query",
        "text": null
    }
};
var $6fc143a99d34d8f4$export$2e2bcd8739ae039 = $6fc143a99d34d8f4$var$node;

});

parcelRegister("iptXe", function(module, exports) {

$parcel$export(module.exports, "default", () => $286e0bf23cd75683$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3fbad09b7a5f56fa90258f09408fcab9>>
 * @relayHash 09e2853d076a3827094f0b2a31a60cad
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e0425937923f1cfadd146be550944e5e36b0ec94fb0732af23a465a8c1c70cf5
const $286e0bf23cd75683$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "e0425937923f1cfadd146be550944e5e36b0ec94fb0732af23a465a8c1c70cf5",
        "metadata": {},
        "name": "src_jiraBusinessListEmbedQuery",
        "operationKind": "query",
        "text": null
    }
};
var $286e0bf23cd75683$export$2e2bcd8739ae039 = $286e0bf23cd75683$var$node;

});

parcelRegister("hkEPp", function(module, exports) {

let $c9e3f98c76158d23$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $c9e3f98c76158d23$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $c9e3f98c76158d23$var$load("k6g9p")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $c9e3f98c76158d23$var$load("cTJTG"),
            $c9e3f98c76158d23$var$load("l253H"),
            $c9e3f98c76158d23$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $c9e3f98c76158d23$var$load("4Qxp7")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $c9e3f98c76158d23$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $c9e3f98c76158d23$var$load("7B2gt")
        ]);
    }),
    $c9e3f98c76158d23$var$load("ffQaD"),
    $c9e3f98c76158d23$var$load("kvRbA"),
    $c9e3f98c76158d23$var$load("kHsBv")
]).then(()=>parcelRequire('ik71Z'));

});



parcelRegister("gxVJf", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessListRouteEntry", () => $ea798fc0f4203cc1$export$9ef24aa950399eaf);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $hCAN5 = parcelRequire("hCAN5");

var $2C7sQ = parcelRequire("2C7sQ");

var $fo6b8 = parcelRequire("fo6b8");
const $ea798fc0f4203cc1$var$listPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $2C7sQ.listEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $ea798fc0f4203cc1$export$9ef24aa950399eaf = (0, $7NszV.createEntry)((0, $hCAN5.jiraBusinessListRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.list-view',
        layout: (0, $lRPBw.businessProjectLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        entryPoint: ()=>$ea798fc0f4203cc1$var$listPageEntryPoint,
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: (0, $lNicp.getProjectViewResources)(),
        supportsPreviewPanel: true
    }));

});
parcelRegister("hCAN5", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessListRoute", () => $257b3e3c032338e6$export$ea171f7670960cff);
const $257b3e3c032338e6$export$ea171f7670960cff = {
    name: 'classic-business-list',
    path: '/jira/core/projects/:projectKey/list',
    exact: true
};

});

parcelRegister("2C7sQ", function(module, exports) {

$parcel$export(module.exports, "listEntryPoint", () => $7b34153964734d60$export$6be4f10150ff6073);

var $EVQo4 = parcelRequire("EVQo4");

var $91hzp = parcelRequire("91hzp");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");
const $7b34153964734d60$var$FORMAT_RULES_FIRST = 20;

const $7b34153964734d60$export$6be4f10150ff6073 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("cdBwP")), {
        moduleId: "b03343a1",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                listQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $91hzp.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                formattingRulesQuery: {
                    parameters: (0, $EVQo4.default),
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId,
                        first: $7b34153964734d60$var$FORMAT_RULES_FIRST
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        };
    }
});

});
parcelRegister("91hzp", function(module, exports) {

$parcel$export(module.exports, "default", () => $169ed3aa08e6bba7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9516f6b957580a1dd0913ff88ae3e10d>>
 * @relayHash 8ab96395b697c5b81fab0afb4eebcfef
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e0cc007557fb53672f36f25ae9fd169cd95e4b69654d21b1f471f604abc11db8
const $169ed3aa08e6bba7$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "e0cc007557fb53672f36f25ae9fd169cd95e4b69654d21b1f471f604abc11db8",
        "metadata": {},
        "name": "src_jiraBusinessListQuery",
        "operationKind": "query",
        "text": null
    }
};
var $169ed3aa08e6bba7$export$2e2bcd8739ae039 = $169ed3aa08e6bba7$var$node;

});

parcelRegister("cdBwP", function(module, exports) {

let $8e53cf4ed89a813e$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $8e53cf4ed89a813e$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $8e53cf4ed89a813e$var$load("k6g9p")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $8e53cf4ed89a813e$var$load("cTJTG"),
            $8e53cf4ed89a813e$var$load("l253H"),
            $8e53cf4ed89a813e$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $8e53cf4ed89a813e$var$load("4Qxp7")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $8e53cf4ed89a813e$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $8e53cf4ed89a813e$var$load("7B2gt")
        ]);
    }),
    $8e53cf4ed89a813e$var$load("ffQaD"),
    $8e53cf4ed89a813e$var$load("kvRbA"),
    $8e53cf4ed89a813e$var$load("keT0w")
]).then(()=>parcelRequire('zU4ax'));

});



parcelRegister("c1v6Y", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessOverviewRedirectRouteEntry", () => $653443b3f7416d46$export$3aa9116f715693e1);

var $ffza4 = parcelRequire("ffza4");

var $l71WK = parcelRequire("l71WK");

var $lRPBw = parcelRequire("lRPBw");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $bG2it = parcelRequire("bG2it");

var $6475a = parcelRequire("6475a");
const $653443b3f7416d46$export$3aa9116f715693e1 = (0, $7NszV.createEntry)((0, $bG2it.jiraBusinessOverviewRedirectRoute), ()=>({
        group: 'classic-business',
        isRedirect: true,
        component: (0, $6475a.default),
        layout: (0, $lRPBw.businessProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $l71WK.AsyncHorizontalOverviewNav)
        },
        resources: (0, $lNicp.getOverviewViewResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("bG2it", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessOverviewRedirectRoute", () => $2d98eac94414a73a$export$5ab0e07528c31349);
const $2d98eac94414a73a$export$5ab0e07528c31349 = {
    name: 'classic-business-overview-redirect',
    path: '/jira/core/overviews/:overviewId',
    exact: true
};

});

parcelRegister("6475a", function(module, exports) {

$parcel$export(module.exports, "default", () => $31755126abaef7af$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ds5qV = parcelRequire("ds5qV");

var $bmKPg = parcelRequire("bmKPg");
const $31755126abaef7af$var$OverviewRedirect = ()=>{
    const [overviewId] = (0, $bmKPg.usePathParam)('overviewId');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: `/jira/core/overviews/${overviewId}/summary`
    });
};
var $31755126abaef7af$export$2e2bcd8739ae039 = $31755126abaef7af$var$OverviewRedirect;

});


parcelRegister("bZEI9", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessProjectRedirectRouteEntry", () => $8fd82d52927aa17f$export$766e305da4c78de5);

var $ffza4 = parcelRequire("ffza4");

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $hqguB = parcelRequire("hqguB");

var $7MCPm = parcelRequire("7MCPm");
const $8fd82d52927aa17f$export$766e305da4c78de5 = (0, $7NszV.createEntry)((0, $hqguB.jiraBusinessProjectRedirectRoute), ()=>({
        group: 'classic-business',
        isRedirect: true,
        component: (0, $7MCPm.RedirectToLastVisitedProjectPage),
        layout: (0, $lRPBw.businessProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: (0, $lNicp.getProjectViewResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("hqguB", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessProjectRedirectRoute", () => $abd9824736763ae8$export$73b60789ceb8e1eb);
const $abd9824736763ae8$export$73b60789ceb8e1eb = {
    name: 'classic-business-redirect',
    path: '/jira/core/projects/:projectKey',
    exact: true
};

});


parcelRegister("ilKWG", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessReportsOverviewRouteEntry", () => $c06ed3cb1d5f7aff$export$2cde310731fa9055);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $6e5qs = parcelRequire("6e5qs");

var $lkFvK = parcelRequire("lkFvK");

var $fo6b8 = parcelRequire("fo6b8");

var $fh5Sl = parcelRequire("fh5Sl");
const $c06ed3cb1d5f7aff$var$reportsOverviewPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $fh5Sl.reportsOverviewPageEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $c06ed3cb1d5f7aff$export$2cde310731fa9055 = (0, $7NszV.createEntry)((0, $6e5qs.jiraBusinessReportsOverviewRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.reports-overview',
        entryPoint () {
            return $c06ed3cb1d5f7aff$var$reportsOverviewPageEntryPoint;
        },
        layout: (0, $lRPBw.businessProjectLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: (0, $lNicp.getProjectViewResources)()
    }));

});
parcelRegister("6e5qs", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessReportsOverviewRoute", () => $4545a709b63712be$export$5881ca008f82b9d8);
const $4545a709b63712be$export$5881ca008f82b9d8 = {
    name: 'classic-business-reports-overview',
    path: '/jira/core/projects/:projectKey/reports',
    exact: true
};

});

parcelRegister("fh5Sl", function(module, exports) {

$parcel$export(module.exports, "reportsOverviewPageEntryPoint", () => $cb9d07f6a92b0ec7$export$9dfa968d9e20b359);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $6hHfS = parcelRequire("6hHfS");

const $cb9d07f6a92b0ec7$export$9dfa968d9e20b359 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("gbxdX")).then((mod)=>mod.ReportsOverviewPage), {
        moduleId: "b8514977",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const boardId = context.match.params.boardId ? String(context.match.params.boardId) : null;
        const projectKey = context.match.params.projectKey ? String(context.match.params.projectKey) : null;
        const isBoardContext = !!boardId;
        const isProjectContext = !!projectKey;
        const cloudId = tenantContext.cloudId;
        return {
            queries: {
                reportsOverviewPage: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $6hHfS.default,
                    variables: {
                        boardId: isBoardContext ? `ari:cloud:jira-software:${cloudId}:board/${boardId}` : '',
                        projectKey: !isBoardContext && isProjectContext ? projectKey : '',
                        cloudId: cloudId,
                        isBoardContext: isBoardContext
                    }
                }
            }
        };
    }
});

});
parcelRegister("6hHfS", function(module, exports) {

$parcel$export(module.exports, "default", () => $868a790b54436928$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d07eb7632c7c8519e83224e9ac018576>>
 * @relayHash 497df43b1252a8dc0b4f0ec9cd482e92
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fa621fa4bb6543d468797211342e1086ef2a6b35d10869637d74ad38c4e9685b
const $868a790b54436928$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isBoardContext"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "idOrKey",
            "variableName": "projectKey"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "concreteType": "JiraReportCategoryConnection",
        "kind": "LinkedField",
        "name": "reportCategories",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraReportCategoryEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraReportCategoryNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v6 /*: any*/ ,
                            {
                                "concreteType": "JiraReportConnection",
                                "kind": "LinkedField",
                                "name": "reports",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraReportConnectionEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraReport",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v7 /*: any*/ ,
                                                    v6 /*: any*/ ,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "key"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "imageUrl"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "description"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "url"
                                                    },
                                                    v8 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            v8 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "srcReportsOverviewPageQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "reportCategories_reportsOverviewPage"
                },
                {
                    "condition": "isBoardContext",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v4 /*: any*/ ,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jira_projectByIdOrKey",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": v5 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "jira_projectByIdOrKey.projectType"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira_projectByIdOrKey"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "srcReportsOverviewPageQuery",
            "selections": [
                {
                    "condition": "isBoardContext",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jira_projectByIdOrKey",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v8 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "condition": "isBoardContext",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "boardId"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "jiraBoard",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v9 /*: any*/ 
                                            ],
                                            "type": "JiraBoard"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v8 /*: any*/ 
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fa621fa4bb6543d468797211342e1086ef2a6b35d10869637d74ad38c4e9685b",
            "metadata": {},
            "name": "srcReportsOverviewPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$868a790b54436928$var$node.hash = "48e488c0e3939efa5d53df92fe5fb373";
var $868a790b54436928$export$2e2bcd8739ae039 = $868a790b54436928$var$node;

});

parcelRegister("gbxdX", function(module, exports) {

let $bc8772047788bbd7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bc8772047788bbd7$var$load("3VKXz").then(()=>parcelRequire('b8Z4e'));

});



parcelRegister("1EihZ", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessSummaryEmbedRouteEntry", () => $f7c860425219110c$export$2c37f93832ff9919);

var $6e4Kt = parcelRequire("6e4Kt");

var $lkFvK = parcelRequire("lkFvK");

var $6s1PB = parcelRequire("6s1PB");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $kqhaB = parcelRequire("kqhaB");

var $3zj3N = parcelRequire("3zj3N");

var $f1r4M = parcelRequire("f1r4M");

var $eASai = parcelRequire("eASai");

var $7yKXN = parcelRequire("7yKXN");

var $4R6GH = parcelRequire("4R6GH");
/**
 * @deprecated delete this entrypoint when cleaning up jwm-summary-page-migration experiment flag
 */ const $f7c860425219110c$var$summaryEmbedPageEntrypoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $eASai.summaryEmbedEntrypoint)
});
const $f7c860425219110c$var$summaryEmbedBusimessPageEntrypoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $7yKXN.summaryBusinessEmbedEntrypoint)
});
const $f7c860425219110c$var$getSummaryPageResource = ()=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jwm-summary-page-migration');
    const jwmSummaryPageMigrationEnabled = expConfig.get('isEnabled', false);
    return [
        ...jwmSummaryPageMigrationEnabled && (0, $4R6GH.fg)('helios_biz_project_remove_rrr') ? [] : [
            (0, $3zj3N.summaryDataResource)
        ],
        ...jwmSummaryPageMigrationEnabled && (0, $4R6GH.fg)('helios_biz_project_fast_activity_feed') ? [] : [
            (0, $kqhaB.activityFeedResource)
        ]
    ];
};
const $f7c860425219110c$export$2c37f93832ff9919 = (0, $7NszV.createEntry)((0, $f1r4M.jiraBusinessSummaryEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.summary-view-embed',
        layout: (0, $6e4Kt.chromelessLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        resources: [
            ...(0, $lNicp.getProjectViewResources)(),
            ...$f7c860425219110c$var$getSummaryPageResource()
        ],
        entryPoint: ()=>{
            if ((0, $6s1PB.expVal)('jwm-summary-page-migration', 'isEnabled', false)) return $f7c860425219110c$var$summaryEmbedBusimessPageEntrypoint;
            return $f7c860425219110c$var$summaryEmbedPageEntrypoint;
        }
    }));

});
parcelRegister("kqhaB", function(module, exports) {

$parcel$export(module.exports, "activityFeedResource", () => $1609d8a65ae37e85$export$928ea152e5c5de54);
$parcel$export(module.exports, "useActivityFeed", () => $1609d8a65ae37e85$export$ee1fe267047f502f);

var $4NbWL = parcelRequire("4NbWL");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");
const $1609d8a65ae37e85$var$RESOURCE_TYPE_KEY = 'BUSINESS_ACTIVITY_FEED';
const $1609d8a65ae37e85$var$EMPTY_DATA = {
    data: [],
    pageInfo: {
        hasNextPage: false,
        endCursor: ''
    }
};
const $1609d8a65ae37e85$export$928ea152e5c5de54 = (0, $2M1hQ.createResource)({
    type: $1609d8a65ae37e85$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        return `${$1609d8a65ae37e85$var$RESOURCE_TYPE_KEY}_${projectKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { isAnonymous: isAnonymous } })=>{
        // do not fetch the resource for anonymous access
        if (isAnonymous) return $1609d8a65ae37e85$var$EMPTY_DATA;
        const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(match, query);
        return (0, $4NbWL.fetchActivityFeed)(null, projectKey);
    },
    maxAge: 5000,
    isBrowserOnly: true
});
const $1609d8a65ae37e85$export$ee1fe267047f502f = ()=>// forcing the return type due to react-resource-router's weird error types
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $2YP9W.useResource)($1609d8a65ae37e85$export$928ea152e5c5de54);

});
parcelRegister("4NbWL", function(module, exports) {

$parcel$export(module.exports, "fetchActivityFeed", () => $72e600639fed107e$export$967c92ed76f908b6);

var $gKZoD = parcelRequire("gKZoD");

var $jJZqs = parcelRequire("jJZqs");

var $a8I18 = parcelRequire("a8I18");
const $72e600639fed107e$var$PAGE_SIZE = 10;
const $72e600639fed107e$var$CONTENT_TYPE = 'application/atom+xml; charset=UTF-8';
const $72e600639fed107e$var$STREAM_PROVIDERS = 'thirdparty issues';
const $72e600639fed107e$export$967c92ed76f908b6 = (after, projectKey)=>{
    (0, $gKZoD.di)(fetch);
    const firstIndex = after != null ? Number(after) : 0;
    const maxResults = firstIndex + $72e600639fed107e$var$PAGE_SIZE;
    return fetch(// @ts-expect-error - TS2345: Types of property 'maxResults' are incompatible. Type 'number' is not assignable to type 'string'.
    `/plugins/servlet/streams?${new URLSearchParams({
        maxResults: maxResults,
        relativeLinks: true,
        streams: `key IS ${projectKey}`,
        providers: $72e600639fed107e$var$STREAM_PROVIDERS
    }).toString()}`, {
        headers: {
            'content-type': $72e600639fed107e$var$CONTENT_TYPE
        }
    }).then((response)=>{
        if (!response.ok) throw new (0, $jJZqs.default)(response.status, `Error server response: ${response.status}`);
        return response.text();
    }).then((rawResponse)=>{
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(rawResponse, 'application/xml');
        const entries = (0, $a8I18.transformData)(xmlDoc);
        return {
            data: entries,
            pageInfo: {
                hasNextPage: entries.length >= maxResults,
                endCursor: String(entries.length)
            }
        };
    });
};

});
parcelRegister("a8I18", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $26b06333cc6e5e1f$export$3ceb62baab058c6b);
const $26b06333cc6e5e1f$export$3ceb62baab058c6b = (xmlDoc)=>{
    // @ts-expect-error - TS2304 - Cannot find name 'ActivityFeedItem'.
    const result = [];
    // Typecheck with project references identifies this as error but existing typecheck is not so doesnt allow ts-expect-error, so used ts-ignore
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - Type 'NodeListOf<Element>' must have a '[Symbol.iterator]()' method that returns an iterator.
    for (const entry of xmlDoc.querySelectorAll('entry')){
        const id = entry.querySelector('id')?.textContent ?? '';
        const published = entry.querySelector('published')?.textContent ?? '';
        const name = entry.querySelector('author > name')?.textContent ?? '';
        const title = entry.querySelector('title')?.textContent ?? '';
        const iconUrl = entry.querySelector('[rel="http://streams.atlassian.com/syndication/icon"]')?.getAttribute('href') ?? '';
        const content = entry.querySelector('content')?.textContent;
        const feedItem = {
            id: id,
            author: {
                name: name,
                avatarUrl: ''
            },
            published: published,
            title: title,
            iconUrl: iconUrl,
            content: content
        };
        entry.querySelectorAll('author > link[rel=photo]').forEach((link)=>{
            if (link.getAttribute('media:height') === '48') feedItem.author.avatarUrl = link.getAttribute('href') ?? '';
        });
        result.push(feedItem);
    }
    return result;
};

});



parcelRegister("3zj3N", function(module, exports) {

$parcel$export(module.exports, "summaryDataResource", () => $acdbc5801b5f9bec$export$cdfee963587c1ea4);
$parcel$export(module.exports, "useSummaryData", () => $acdbc5801b5f9bec$export$c82acf736eaa253c);

var $aR4Ot = parcelRequire("aR4Ot");

var $iR3GG = parcelRequire("iR3GG");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");
const $acdbc5801b5f9bec$var$RESOURCE_TYPE_KEY = 'BUSINESS_SUMMARY_DATA';
const $acdbc5801b5f9bec$var$EMPTY_DATA = {
    overviewItems: null,
    issuesByStatus: null,
    issuesByPriority: null,
    issuesByAssignee: null,
    issuesByType: null,
    workflowsCount: null
};
const $acdbc5801b5f9bec$export$cdfee963587c1ea4 = (0, $2M1hQ.createResource)({
    type: $acdbc5801b5f9bec$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        return `${$acdbc5801b5f9bec$var$RESOURCE_TYPE_KEY}_${projectKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
        // do not fetch the resource for anonymous access
        if (isAnonymous) return $acdbc5801b5f9bec$var$EMPTY_DATA;
        const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(match, query);
        const jqlContext = `project = "${projectKey}"`;
        try {
            return await (0, $aR4Ot.fetchSummaryPageData)({
                cloudId: cloudId,
                jqlContext: jqlContext,
                projectKey: projectKey
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
            throw (0, $iR3GG.createResourceError)({
                component: 'spa.view.routes.business.summary-data.getData',
                message: `An error was thrown while prefetching the summary data. Status code: ${error?.statusCode}. Message: ${error?.message}`,
                name: 'ResourceError',
                skipSentry: isClientError
            });
        }
    },
    maxAge: 5000,
    isBrowserOnly: true
});
const $acdbc5801b5f9bec$export$c82acf736eaa253c = ()=>// forcing the return type due to react-resource-router's weird error types
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $2YP9W.useResource)($acdbc5801b5f9bec$export$cdfee963587c1ea4);

});
parcelRegister("aR4Ot", function(module, exports) {

$parcel$export(module.exports, "fetchSummaryPageData", () => $86d3799d8fb43b74$export$a3fa5b61d6f8cf86);

var $jlq4V = parcelRequire("jlq4V");

var $6s1PB = parcelRequire("6s1PB");

var $eusud = parcelRequire("eusud");


var $6FqTo = parcelRequire("6FqTo");

var $7P4vu = parcelRequire("7P4vu");
const $86d3799d8fb43b74$var$QUERY_NAME = 'SummaryPageData';
const $86d3799d8fb43b74$export$a3fa5b61d6f8cf86 = async ({ cloudId: cloudId, jqlContext: jqlContext, projectKey: projectKey })=>{
    const response = await (0, $eusud.performPostRequest)(`/rest/gira/1/?operation=${$86d3799d8fb43b74$var$QUERY_NAME}`, {
        body: JSON.stringify({
            query: (0, $6s1PB.expVal)('jwm-summary-page-migration', 'isEnabled', false) ? (0, $6FqTo.SUMMARY_PAGE_DATA_QUERY) : (0, $6FqTo.SUMMARY_PAGE_DATA_QUERY_OLD),
            variables: {
                cloudId: cloudId,
                jqlContext: jqlContext,
                // unused variable for the new GQL query
                projectKey: (0, $6s1PB.expVal)('jwm-summary-page-migration', 'isEnabled', false) ? undefined : projectKey,
                doneThisWeekJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$d5aac1de7fafa2b0)}`,
                updatedThisWeekJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$b10a33c38cc20983)}`,
                createdThisWeekJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$48eb4b4c930c6378)}`,
                dueThisWeekJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$2573f5b8014b4068)}`,
                issuesByStatusJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$8cca17e1017ba894)}`,
                issuesByPriorityJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$c49e48bfa75ab23c)}`,
                issuesByAssigneeJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$c49e48bfa75ab23c)}`,
                issuesByTypeJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$c49e48bfa75ab23c)}`,
                pagedDataPageSize: (0, $cd053842fd66588d$export$c0ecd9bd08a86184),
                // unused variable for the new GQL query
                isWorkflowsCountEnabled: (0, $6s1PB.expVal)('jwm-summary-page-migration', 'isEnabled', false) ? undefined : true
            }
        })
    });
    if (response.errors != null) throw new (0, $jlq4V.GraphQLErrors)(response.errors);
    if (response.data == null) throw new Error('GraphQL response has no data');
    return (0, $7P4vu.transformData)(response.data);
};

});
const $cd053842fd66588d$export$d5aac1de7fafa2b0 = 'statusCategory = Done AND statusCategoryChangedDate >= -1w';
const $cd053842fd66588d$export$b10a33c38cc20983 = 'updatedDate >= -1w';
const $cd053842fd66588d$export$48eb4b4c930c6378 = 'createdDate >= -1w';
const $cd053842fd66588d$export$2573f5b8014b4068 = 'statusCategory != Done AND (duedate >= 0d AND duedate < 1w)';
const $cd053842fd66588d$export$8cca17e1017ba894 = '(statusCategory != Done OR (statusCategory = Done AND statusCategoryChangedDate >= -2w))';
const $cd053842fd66588d$export$c49e48bfa75ab23c = 'statusCategory != Done';
const $cd053842fd66588d$export$c0ecd9bd08a86184 = 8;
const $cd053842fd66588d$export$27f4fb65edc908d0 = `
  fragment IssuesByAssigneeFragment on JWMItemGroupConnection {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      field {
        ... on UserField {
          userValue {
            accountId,
            avatarUrl,
            displayName
          }
        }
      }
      id,
      totalCount
    }
  }
`;
const $cd053842fd66588d$export$5b2a5373659a0414 = `
  fragment IssuesByTypeFragment on JWMItemGroupConnection {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      field {
        ... on IssueTypeField {
              id
              name
              iconUrl
        }
      }
      id,
      totalCount
    }
  }
`;

parcelRegister("6FqTo", function(module, exports) {

$parcel$export(module.exports, "SUMMARY_PAGE_DATA_QUERY_OLD", () => $7511339abc68f96a$export$d825244d8ba23e54);
$parcel$export(module.exports, "SUMMARY_PAGE_DATA_QUERY", () => $7511339abc68f96a$export$7ea8f81ff5bf6361);

const $7511339abc68f96a$export$d825244d8ba23e54 = `
  query JiraBusinessSummaryPageData($cloudId: ID!, $jqlContext: String!, $doneThisWeekJql: String!, $updatedThisWeekJql: String!, $createdThisWeekJql: String!, $dueThisWeekJql: String!, $issuesByStatusJql: String!, $issuesByPriorityJql: String!, $issuesByAssigneeJql: String!, $issuesByTypeJql: String!, $pagedDataPageSize: Int!, $projectKey: String!, $isWorkflowsCountEnabled: Boolean!) {
    jira {
      jqlBuilder(cloudId: $cloudId) {
        status: fieldValues(
          jqlTerm: "status"
          jqlContext: $jqlContext
          viewContext: JWM
        ) {
          edges {
            node {
              jqlTerm
              displayName
            }
          }
        }
      }
      doneThisWeek: jwmViewItems(cloudId: $cloudId, jql: $doneThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      updatedThisWeek: jwmViewItems(cloudId: $cloudId, jql: $updatedThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      createdThisWeek: jwmViewItems(cloudId: $cloudId, jql: $createdThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      dueThisWeek: jwmViewItems(cloudId: $cloudId, jql: $dueThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      totalUnresolvedIssues: jwmViewItems(cloudId: $cloudId, jql: $issuesByAssigneeJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
    }
    issuesByStatus: jwmItemGroups(jql: $issuesByStatusJql, groupByFieldId: "status", fieldIds: [], first: 50) {
      nodes {
        id
        field {
          ...on StatusField {
              name
							statusId
              category {
                key
              }
          }
        }
        totalCount
      }
    }
    issuesByPriority: jwmItemGroups(jql: $issuesByPriorityJql, groupByFieldId: "priority", fieldIds: [], first: 50) {
      nodes {
        id
        field {
          ...on PriorityField {
            iconUrl
            name
          }
        }
        totalCount
      }
    }
    issuesByAssignee: jwmItemGroups(jql: $issuesByAssigneeJql, first: $pagedDataPageSize, fieldIds: [], groupByFieldId: "assignee", sortBy: {field: GROUP_COUNT, direction: DESC}) {
      ...IssuesByAssigneeFragment
    }
    issuesByType: jwmItemGroups(jql: $issuesByTypeJql, first: $pagedDataPageSize, fieldIds: [], groupByFieldId: "issuetype", sortBy: {field: GROUP_COUNT, direction: DESC}) {
      ...IssuesByTypeFragment
    }
    workflowsCount: jwmWorkflowWithIssueTypes(projectIdOrKey: $projectKey) @include(if: $isWorkflowsCountEnabled) {
      totalCount
    }
  }

  ${(0, $cd053842fd66588d$export$27f4fb65edc908d0)}
  ${(0, $cd053842fd66588d$export$5b2a5373659a0414)}
`;
const $7511339abc68f96a$export$7ea8f81ff5bf6361 = `
  query JiraBusinessSummaryPageData($cloudId: ID!, $jqlContext: String!, $doneThisWeekJql: String!, $updatedThisWeekJql: String!, $createdThisWeekJql: String!, $dueThisWeekJql: String!, $issuesByStatusJql: String!, $issuesByPriorityJql: String!, $issuesByAssigneeJql: String!, $issuesByTypeJql: String!, $pagedDataPageSize: Int!) {
    jira {
      jqlBuilder(cloudId: $cloudId) {
        status: fieldValues(
          jqlTerm: "status"
          jqlContext: $jqlContext
          viewContext: JWM
        ) {
          edges {
            node {
              jqlTerm
              displayName
            }
          }
        }
        priority: fieldValues(
          jqlTerm: "priority"
          jqlContext: $jqlContext
          viewContext: JWM
        ) {
          edges {
            node {
              jqlTerm
              displayName
            }
          }
        }
      }
      doneThisWeek: jwmViewItems(cloudId: $cloudId, jql: $doneThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      updatedThisWeek: jwmViewItems(cloudId: $cloudId, jql: $updatedThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      createdThisWeek: jwmViewItems(cloudId: $cloudId, jql: $createdThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      dueThisWeek: jwmViewItems(cloudId: $cloudId, jql: $dueThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      totalUnresolvedIssues: jwmViewItems(cloudId: $cloudId, jql: $issuesByAssigneeJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
    }
    issuesByStatus: jwmItemGroups(jql: $issuesByStatusJql, groupByFieldId: "status", fieldIds: [], first: 50) {
      nodes {
        id
        field {
          ...on StatusField {
              name
							statusId
              category {
                key
              }
          }
        }
        totalCount
      }
    }
    issuesByPriority: jwmItemGroups(jql: $issuesByPriorityJql, groupByFieldId: "priority", fieldIds: [], first: 50) {
      nodes {
        id
        field {
          ...on PriorityField {
            iconUrl
            name
          }
        }
        totalCount
      }
    }
    issuesByAssignee: jwmItemGroups(jql: $issuesByAssigneeJql, first: $pagedDataPageSize, fieldIds: [], groupByFieldId: "assignee", sortBy: {field: GROUP_COUNT, direction: DESC}) {
      ...IssuesByAssigneeFragment
    }
    issuesByType: jwmItemGroups(jql: $issuesByTypeJql, first: $pagedDataPageSize, fieldIds: [], groupByFieldId: "issuetype", sortBy: {field: GROUP_COUNT, direction: DESC}) {
      ...IssuesByTypeFragment
    }
  }

  ${(0, $cd053842fd66588d$export$27f4fb65edc908d0)}
  ${(0, $cd053842fd66588d$export$5b2a5373659a0414)}
`;

});

parcelRegister("7P4vu", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $583dacb5a6b553e9$export$3ceb62baab058c6b);

var $6s1PB = parcelRequire("6s1PB");

var $egekd = parcelRequire("egekd");
const $583dacb5a6b553e9$export$3ceb62baab058c6b = (data)=>{
    return {
        overviewItems: {
            doneThisWeek: data.jira.doneThisWeek?.totalCount ?? 0,
            updatedThisWeek: data.jira.updatedThisWeek?.totalCount ?? 0,
            createdThisWeek: data.jira.createdThisWeek?.totalCount ?? 0,
            dueThisWeek: data.jira.dueThisWeek?.totalCount ?? 0
        },
        issuesByStatus: // eslint-disable-next-line @typescript-eslint/no-explicit-any
        data.issuesByStatus?.nodes.map((node)=>({
                id: node.id,
                count: node.totalCount,
                status: {
                    name: node.field.name,
                    statusId: node.field.statusId,
                    jqlTerm: data.jira.jqlBuilder?.status.edges.find((status)=>status.node.displayName === node.field.name)?.node.jqlTerm,
                    category: {
                        key: node.field.category.key
                    }
                }
            })) ?? null,
        issuesByPriority: // eslint-disable-next-line @typescript-eslint/no-explicit-any
        data.issuesByPriority?.nodes.map((node)=>{
            const priorityJqlTerm = data.jira.jqlBuilder?.priority?.edges.find((priority)=>priority.node?.displayName === node.field.name)?.node?.jqlTerm;
            return {
                id: node.id,
                count: node.totalCount,
                priority: {
                    name: node.field.name,
                    iconUrl: node.field.iconUrl,
                    jqlTerm: priorityJqlTerm
                }
            };
        }) ?? null,
        issuesByAssignee: data.issuesByAssignee ? {
            ...(0, $egekd.transformIssuesByAssigneeData)(data.issuesByAssignee),
            totalUnresolvedIssues: data.jira.totalUnresolvedIssues?.totalCount ?? 0
        } : null,
        issuesByType: data.issuesByType ? {
            ...(0, $egekd.transformIssuesByTypeData)(data.issuesByType),
            totalUnresolvedIssues: data.jira.totalUnresolvedIssues?.totalCount ?? 0
        } : null,
        workflowsCount: (0, $6s1PB.expVal)('jwm-summary-page-migration', 'isEnabled', false) ? undefined : data?.workflowsCount?.totalCount ?? null
    };
};

});
parcelRegister("egekd", function(module, exports) {

$parcel$export(module.exports, "transformIssuesByAssigneeData", () => $0d59c4e7b34bf6f1$export$cef1c6c4edf3287b);
$parcel$export(module.exports, "transformIssuesByTypeData", () => $0d59c4e7b34bf6f1$export$bc7f7d59cba70a26);
const $0d59c4e7b34bf6f1$export$cef1c6c4edf3287b = (data)=>({
        pageInfo: {
            hasNextPage: data.pageInfo.hasNextPage,
            endCursor: data.pageInfo.endCursor
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        data: data.nodes.map((node)=>({
                id: node.id,
                user: node.field.userValue ? {
                    avatarUrl: node.field.userValue.avatarUrl ?? '',
                    displayName: node.field.userValue.displayName,
                    accountId: node.field.userValue.accountId
                } : null,
                count: node.totalCount
            }))
    });
const $0d59c4e7b34bf6f1$export$bc7f7d59cba70a26 = (data)=>({
        pageInfo: {
            hasNextPage: data.pageInfo.hasNextPage,
            endCursor: data.pageInfo.endCursor
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        data: data.nodes.map((node)=>({
                id: node.id,
                issueType: node.field ? {
                    iconUrl: node.field.iconUrl,
                    name: node.field.name,
                    id: node.field.id
                } : null,
                count: node.totalCount
            }))
    });

});




parcelRegister("f1r4M", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessSummaryEmbedRoute", () => $75bf41a31996f0a6$export$d4aa7e677d381961);
const $75bf41a31996f0a6$export$d4aa7e677d381961 = {
    name: 'classic-business-summary-embed',
    path: '/jira/core/projects/:projectKey/summary/embed',
    exact: true
};

});

parcelRegister("eASai", function(module, exports) {

$parcel$export(module.exports, "summaryEmbedEntrypoint", () => $99cc4adc5066587d$export$5a118ab60ce38554);

var $gIFn8 = parcelRequire("gIFn8");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $99cc4adc5066587d$export$5a118ab60ce38554 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("3eVaH")), {
        moduleId: "936313f5",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                summaryEmbedQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $gIFn8.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("gIFn8", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a7b94e3ffb3bd2f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1a20b087016d45df0229b06077572278>>
 * @relayHash 3820c91496cd6ed2417544137170dd18
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9c794c308a61b48d1203cad5842636c8f860239cf229202638ed7468403107c2
const $6a7b94e3ffb3bd2f$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "9c794c308a61b48d1203cad5842636c8f860239cf229202638ed7468403107c2",
        "metadata": {},
        "name": "src_jiraBusinessSummaryEmbedQuery",
        "operationKind": "query",
        "text": null
    }
};
var $6a7b94e3ffb3bd2f$export$2e2bcd8739ae039 = $6a7b94e3ffb3bd2f$var$node;

});

parcelRegister("3eVaH", function(module, exports) {

let $25bf06ff15a4cf4c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $25bf06ff15a4cf4c$var$load("ffQaD"),
    $25bf06ff15a4cf4c$var$load("kvRbA"),
    $25bf06ff15a4cf4c$var$load("75kUW")
]).then(()=>parcelRequire('kB5po'));

});


parcelRegister("7yKXN", function(module, exports) {

$parcel$export(module.exports, "summaryBusinessEmbedEntrypoint", () => $2cd94e1a653bd86e$export$a027511631595373);

var $3N2oG = parcelRequire("3N2oG");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $2cd94e1a653bd86e$export$a027511631595373 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("1I7wW")), {
        moduleId: "bfeee3c2",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                summaryQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $3N2oG.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("3N2oG", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dea5c0730559df4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2161716a6a9ddd596df65d397a277cb5>>
 * @relayHash 4f557a85d513d521d9088e7217fed3ad
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 15dd5fffb84db9cd2e32bf1439d87098cf295ac5f7e1bcaae80f031fdad2d763
const $9dea5c0730559df4$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "15dd5fffb84db9cd2e32bf1439d87098cf295ac5f7e1bcaae80f031fdad2d763",
        "metadata": {},
        "name": "src_jiraSummaryBusinessEmbedQuery",
        "operationKind": "query",
        "text": null
    }
};
var $9dea5c0730559df4$export$2e2bcd8739ae039 = $9dea5c0730559df4$var$node;

});

parcelRegister("1I7wW", function(module, exports) {

let $13efbddf23902134$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $13efbddf23902134$var$load("ffQaD"),
    $13efbddf23902134$var$load("kvRbA"),
    $13efbddf23902134$var$load("fliVL"),
    $13efbddf23902134$var$load("67ZGv")
]).then(()=>parcelRequire('7biA2'));

});



parcelRegister("2IdR0", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessSummaryRouteEntry", () => $388a84b6edfc3b2f$export$66365c0c5e8430d2);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lkFvK = parcelRequire("lkFvK");

var $6s1PB = parcelRequire("6s1PB");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $kqhaB = parcelRequire("kqhaB");

var $3zj3N = parcelRequire("3zj3N");

var $3x7be = parcelRequire("3x7be");

var $7QgtY = parcelRequire("7QgtY");

var $3RnWB = parcelRequire("3RnWB");

var $fo6b8 = parcelRequire("fo6b8");

var $4R6GH = parcelRequire("4R6GH");
/**
 * @deprecated delete this entrypoint when cleaning up jwm-summary-page-migration experiment flag
 */ const $388a84b6edfc3b2f$var$summaryPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7QgtY.summaryEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $388a84b6edfc3b2f$var$summaryBusinessPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $3RnWB.summaryBusinessEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $388a84b6edfc3b2f$var$getSummaryPageResource = ()=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jwm-summary-page-migration');
    const jwmSummaryPageMigrationEnabled = expConfig.get('isEnabled', false);
    return [
        ...jwmSummaryPageMigrationEnabled && (0, $4R6GH.fg)('helios_biz_project_remove_rrr') ? [] : [
            (0, $3zj3N.summaryDataResource)
        ],
        ...jwmSummaryPageMigrationEnabled && (0, $4R6GH.fg)('helios_biz_project_fast_activity_feed') ? [] : [
            (0, $kqhaB.activityFeedResource)
        ]
    ];
};
const $388a84b6edfc3b2f$export$66365c0c5e8430d2 = (0, $7NszV.createEntry)((0, $3x7be.jiraBusinessSummaryRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.summary-view',
        layout: (0, $lRPBw.businessProjectLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $lNicp.getProjectViewResources)(),
            ...$388a84b6edfc3b2f$var$getSummaryPageResource()
        ],
        entryPoint: ()=>{
            if ((0, $6s1PB.expVal)('jwm-summary-page-migration', 'isEnabled', false)) return $388a84b6edfc3b2f$var$summaryBusinessPageEntrypoint;
            return $388a84b6edfc3b2f$var$summaryPageEntrypoint;
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("3x7be", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessSummaryRoute", () => $da1a77dee609f26a$export$ad0ce411d14c71d7);
const $da1a77dee609f26a$export$ad0ce411d14c71d7 = {
    name: 'classic-business-summary',
    path: '/jira/core/projects/:projectKey/summary',
    exact: true
};

});

parcelRegister("7QgtY", function(module, exports) {

$parcel$export(module.exports, "summaryEntrypoint", () => $e408b66321f42c9a$export$3d50a9cba1287544);

var $5o8fa = parcelRequire("5o8fa");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $e408b66321f42c9a$export$3d50a9cba1287544 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("cELt9")), {
        moduleId: "75fba772",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                summaryQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $5o8fa.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("5o8fa", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e3b5ebe8bc3ce2b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b98870a9a14cc3127b27958d6372112f>>
 * @relayHash c3f96584d95baf5fcb618835c22e3826
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2313ad2fdb6e791eef71a3a51657d606a68b9c66e72b580fa0b63e9475ba0787
const $8e3b5ebe8bc3ce2b$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "2313ad2fdb6e791eef71a3a51657d606a68b9c66e72b580fa0b63e9475ba0787",
        "metadata": {},
        "name": "src_jiraBusinessSummaryQuery",
        "operationKind": "query",
        "text": null
    }
};
var $8e3b5ebe8bc3ce2b$export$2e2bcd8739ae039 = $8e3b5ebe8bc3ce2b$var$node;

});

parcelRegister("cELt9", function(module, exports) {

let $936e0ad8578baa23$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $936e0ad8578baa23$var$load("ffQaD"),
    $936e0ad8578baa23$var$load("kvRbA"),
    $936e0ad8578baa23$var$load("abwKD")
]).then(()=>parcelRequire('j5uWP'));

});


parcelRegister("3RnWB", function(module, exports) {

$parcel$export(module.exports, "summaryBusinessEntrypoint", () => $52c89b30c31bd0d6$export$1655de4ea7d4bb73);

var $ixLIQ = parcelRequire("ixLIQ");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $52c89b30c31bd0d6$export$1655de4ea7d4bb73 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("1npA7")), {
        moduleId: "e788cf2e",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                summaryQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $ixLIQ.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("ixLIQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $27bcdcea8e0fdaf7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e999f38de92db02cb900ff3e39b1c9b5>>
 * @relayHash e1db5ab6de3c01b21716a8934a36cc9b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0b047866626fc08071e5717fa8caf4a6c7867aefae410e0168cbc01019589055
const $27bcdcea8e0fdaf7$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "0b047866626fc08071e5717fa8caf4a6c7867aefae410e0168cbc01019589055",
        "metadata": {},
        "name": "src_jiraSummaryBusinessQuery",
        "operationKind": "query",
        "text": null
    }
};
var $27bcdcea8e0fdaf7$export$2e2bcd8739ae039 = $27bcdcea8e0fdaf7$var$node;

});

parcelRegister("1npA7", function(module, exports) {

let $100bc862c692a980$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $100bc862c692a980$var$load("ffQaD"),
    $100bc862c692a980$var$load("kvRbA"),
    $100bc862c692a980$var$load("fliVL"),
    $100bc862c692a980$var$load("8MzXB")
]).then(()=>parcelRequire('eGmqi'));

});



parcelRegister("cZPPs", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessTimelineEmbedRouteEntry", () => $1c46fc585f965612$export$ef65a62ced1a9df1);

var $6e4Kt = parcelRequire("6e4Kt");

var $lkFvK = parcelRequire("lkFvK");

var $6s1PB = parcelRequire("6s1PB");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $1kHS4 = parcelRequire("1kHS4");

var $2vlnX = parcelRequire("2vlnX");

var $1FhoW = parcelRequire("1FhoW");
const $1c46fc585f965612$var$timelineEmbedPageEntrypoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $1FhoW.timelineEntrypoint)
});
const $1c46fc585f965612$var$legacyimelineEmbedPageEntrypoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $2vlnX.timelineEmbedEntrypoint)
});
const $1c46fc585f965612$export$ef65a62ced1a9df1 = (0, $7NszV.createEntry)((0, $1kHS4.jiraBusinessTimelineEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.timeline-embed-view',
        layout: (0, $6e4Kt.chromelessLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        resources: (0, $lNicp.getProjectViewResources)(),
        entryPoint: ()=>(0, $6s1PB.expValEquals)('jira_timeline_harmonisation_m1', 'isEnabled', true) ? $1c46fc585f965612$var$timelineEmbedPageEntrypoint : $1c46fc585f965612$var$legacyimelineEmbedPageEntrypoint
    }));

});
parcelRegister("1kHS4", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessTimelineEmbedRoute", () => $12b838a84c0952a0$export$d85fbccfa0ba559a);
const $12b838a84c0952a0$export$d85fbccfa0ba559a = {
    name: 'classic-business-timeline-embed',
    path: '/jira/core/projects/:projectKey/timeline/embed',
    exact: true
};

});

parcelRegister("2vlnX", function(module, exports) {

$parcel$export(module.exports, "timelineEmbedEntrypoint", () => $94157aa0ce3558d4$export$12a9d017aa53985f);

var $6orcY = parcelRequire("6orcY");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $94157aa0ce3558d4$export$12a9d017aa53985f = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("6LJkC")), {
        moduleId: "88bc99ab",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                timelineEmbedQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $6orcY.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("6orcY", function(module, exports) {

$parcel$export(module.exports, "default", () => $c96eaccedf3004ad$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c25e21ec05fd2b676e0b39f50f317308>>
 * @relayHash aaa779177ef49e606102f9e257279c2f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 52e90730f9edc63b8e9c272f467903f50d287b068a5e9571a6fd34719bb2539c
const $c96eaccedf3004ad$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "52e90730f9edc63b8e9c272f467903f50d287b068a5e9571a6fd34719bb2539c",
        "metadata": {},
        "name": "src_jiraBusinessTimelineEmbedQuery",
        "operationKind": "query",
        "text": null
    }
};
var $c96eaccedf3004ad$export$2e2bcd8739ae039 = $c96eaccedf3004ad$var$node;

});

parcelRegister("6LJkC", function(module, exports) {

let $4eda4bc353bb27bd$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $4eda4bc353bb27bd$var$load("ffQaD"),
    $4eda4bc353bb27bd$var$load("kvRbA"),
    $4eda4bc353bb27bd$var$load("egDkZ")
]).then(()=>parcelRequire('fm6i9'));

});


parcelRegister("1FhoW", function(module, exports) {

$parcel$export(module.exports, "timelineEntrypoint", () => $081fe9ef67594c5f$export$7586afa83216512a);

var $4R6GH = parcelRequire("4R6GH");

var $b8ALi = parcelRequire("b8ALi");

var $esiIm = parcelRequire("esiIm");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");
const $081fe9ef67594c5f$var$and = (clauses)=>{
    return clauses.map((clause)=>clause.trim()).filter((clause)=>clause.length > 0).join(' AND ');
};
const $081fe9ef67594c5f$var$getProjectJql = (projectKey)=>projectKey.length > 0 ? `project = '${projectKey}'` : '';
const $081fe9ef67594c5f$var$getSearchTextJql = (text)=>{
    if (text === undefined || text.trim() === '') return '';
    const sanitize = (value)=>value.replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/\t/g, ' ');
    const issueKeyRegex = new RegExp('^([A-Z][A-Z0-9_]+-\\d+)$');
    const japaneseAndChineseRegex = /[\p{Script_Extensions=Hiragana}\p{Script_Extensions=Katakana}\p{Script_Extensions=Han}]/u;
    let search = sanitize(text);
    if (issueKeyRegex.test(text)) return `(summary ~ '${search}*' OR description ~ '${search}*' OR key = '${search}')`;
    // if the text does not contain Chinese or Japanese characters (which are not tokenized),
    // and does not end with a space character
    // make it a wildcard search
    if (!japaneseAndChineseRegex.test(text) && !text.endsWith(' ')) search = `${search}*`;
    return `(summary ~ '${search}' OR description ~ '${search}')`;
};
const $081fe9ef67594c5f$var$buildIssuesSearchInput = (filter = '', text = '', projectKey = '')=>{
    const search = $081fe9ef67594c5f$var$getSearchTextJql(text);
    const project = $081fe9ef67594c5f$var$getProjectJql(projectKey);
    return {
        jql: $081fe9ef67594c5f$var$and([
            search,
            filter,
            project
        ])
    };
};
// should be equivalent to the getToday function in jira/src/packages/software/roadmap/utils/src/utils/dates.tsx
const $081fe9ef67594c5f$var$getToday = ()=>{
    const now = new Date();
    const date = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0));
    return date.valueOf();
};

const $081fe9ef67594c5f$export$7586afa83216512a = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("i7r9k")), {
        moduleId: "ea9f2eb3",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const namespace = (0, $4R6GH.fg)('add_timeline_namespace_in_issue_search') ? 'TIMELINE' : 'ISSUE_NAVIGATOR';
        const projectKey = context.match.params.projectKey;
        const { filter: filter, text: text } = context.query;
        if (projectKey == null) throw new Error('Project key missing');
        const fieldSetIds = [
            'issuetype',
            'issuekey',
            'summary',
            'Start date[Date]',
            'duedate'
        ];
        return {
            extraProps: {
                today: $081fe9ef67594c5f$var$getToday()
            },
            queries: {
                businessTimelineQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $b8ALi.default),
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                timelineQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $esiIm.default),
                    variables: {
                        amountOfColumns: 500,
                        cloudId: cloudId,
                        fieldSetIds: fieldSetIds,
                        fieldSetsInput: {
                            fieldSetIds: fieldSetIds
                        },
                        filterId: null,
                        first: 50,
                        issueSearchInput: $081fe9ef67594c5f$var$buildIssuesSearchInput(filter, text, projectKey),
                        namespace: namespace,
                        projectKey: projectKey,
                        shouldQueryFieldSetsById: false,
                        shouldQueryHasChildren: true,
                        staticViewInput: {
                            isGroupingEnabled: false
                        },
                        viewConfigInput: {
                            viewInput: {
                                namespace: namespace
                            }
                        },
                        viewId: 'list_default'
                    }
                }
            }
        };
    }
});

});
parcelRegister("b8ALi", function(module, exports) {

$parcel$export(module.exports, "default", () => $9449fe427e3fdb1b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b44f9761057ed7ea0b277fcdeb998d61>>
 * @relayHash 91af7345571ae29b0bcaa8c35ba4c2fe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 937f60fcad28d0549884b2d0d71ae578315c0f9d27f22e844f8d3bf73d6dcd99
const $9449fe427e3fdb1b$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "937f60fcad28d0549884b2d0d71ae578315c0f9d27f22e844f8d3bf73d6dcd99",
        "metadata": {},
        "name": "src_jiraHarmonisedBusinessTimelineQuery",
        "operationKind": "query",
        "text": null
    }
};
var $9449fe427e3fdb1b$export$2e2bcd8739ae039 = $9449fe427e3fdb1b$var$node;

});

parcelRegister("esiIm", function(module, exports) {

$parcel$export(module.exports, "default", () => $29bb48365820fb9e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<aed89e6140a9e3b94bf42d86466de501>>
 * @relayHash cac05a86673a7e980d5ab693016c7430
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 84b40347a3dd96cb42d1aaec4817cbd30fe221b8312bbc6e3b17e5ca2b698bbc

var $fjldt = parcelRequire("fjldt");

var $gY76A = parcelRequire("gY76A");

var $5ykrX = parcelRequire("5ykrX");

var $c5npJ = parcelRequire("c5npJ");

var $ggSVP = parcelRequire("ggSVP");

var $5Bxi4 = parcelRequire("5Bxi4");

var $k3PJZ = parcelRequire("k3PJZ");

var $knfEI = parcelRequire("knfEI");

var $5qm7M = parcelRequire("5qm7M");

var $l8ssf = parcelRequire("l8ssf");

var $dttgK = parcelRequire("dttgK");

var $adKYy = parcelRequire("adKYy");

var $iLxt4 = parcelRequire("iLxt4");

var $hBvdF = parcelRequire("hBvdF");
const $29bb48365820fb9e$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "84b40347a3dd96cb42d1aaec4817cbd30fe221b8312bbc6e3b17e5ca2b698bbc",
        "metadata": {},
        "name": "src_timelineQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $gY76A.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": (0, $k3PJZ.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistcheckissuecreatepermissionsrelayprovider": (0, $5Bxi4.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider": (0, $c5npJ.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $dttgK.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $adKYy.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $fjldt.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $5qm7M.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": (0, $iLxt4.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $l8ssf.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": (0, $5ykrX.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": (0, $ggSVP.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $knfEI.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $hBvdF.default)
        }
    }
};
var $29bb48365820fb9e$export$2e2bcd8739ae039 = $29bb48365820fb9e$var$node;

});

parcelRegister("i7r9k", function(module, exports) {

let $d30df0bd6e5216e9$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $d30df0bd6e5216e9$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $d30df0bd6e5216e9$var$load("k6g9p")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $d30df0bd6e5216e9$var$load("czifk")
        ]);
    }, function() {
        return Promise.all([
            $d30df0bd6e5216e9$var$load("kcs34")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $d30df0bd6e5216e9$var$load("cTJTG"),
            $d30df0bd6e5216e9$var$load("l253H"),
            $d30df0bd6e5216e9$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $d30df0bd6e5216e9$var$load("4Qxp7")
        ]);
    }),
    $d30df0bd6e5216e9$var$load("ffQaD"),
    $d30df0bd6e5216e9$var$load("kvRbA"),
    $d30df0bd6e5216e9$var$load("fliVL"),
    $d30df0bd6e5216e9$var$load("9F52l")
]).then(()=>parcelRequire('izPvq'));

});



parcelRegister("frUin", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessTimelineRouteEntry", () => $a1408a3d6b1a5eeb$export$5725375da49b5772);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lkFvK = parcelRequire("lkFvK");

var $6s1PB = parcelRequire("6s1PB");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $54kZi = parcelRequire("54kZi");

var $bOakJ = parcelRequire("bOakJ");

var $1FhoW = parcelRequire("1FhoW");

var $fo6b8 = parcelRequire("fo6b8");
const $a1408a3d6b1a5eeb$var$timelinePageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1FhoW.timelineEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $a1408a3d6b1a5eeb$var$legacyTimelinePageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $bOakJ.timelineEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $a1408a3d6b1a5eeb$export$5725375da49b5772 = (0, $7NszV.createEntry)((0, $54kZi.jiraBusinessTimelineRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.timeline-view',
        layout: (0, $lRPBw.businessProjectLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: (0, $lNicp.getProjectViewResources)(),
        entryPoint: ()=>(0, $6s1PB.expValEquals)('jira_timeline_harmonisation_m1', 'isEnabled', true) ? $a1408a3d6b1a5eeb$var$timelinePageEntrypoint : $a1408a3d6b1a5eeb$var$legacyTimelinePageEntrypoint,
        supportsPreviewPanel: true
    }));

});
parcelRegister("54kZi", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessTimelineRoute", () => $d72294ad8bab4281$export$4c71cfbf61bf0bf3);
const $d72294ad8bab4281$export$4c71cfbf61bf0bf3 = {
    name: 'classic-business-timeline',
    path: '/jira/core/projects/:projectKey/timeline',
    exact: true
};

});

parcelRegister("bOakJ", function(module, exports) {

$parcel$export(module.exports, "timelineEntrypoint", () => $49d4c306324fda15$export$7586afa83216512a);

var $6T238 = parcelRequire("6T238");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $49d4c306324fda15$export$7586afa83216512a = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("jA2oL")), {
        moduleId: "cac371d1",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                timelineQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $6T238.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("6T238", function(module, exports) {

$parcel$export(module.exports, "default", () => $5232f385be868c01$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ec0d5db49437667573ca835bd84e9756>>
 * @relayHash 841436c7487840af84c959f83e5a4493
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4443dbc3773e515f952da0ae8f171c483657c4548c4768b6b9c144da0822a4f1
const $5232f385be868c01$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "4443dbc3773e515f952da0ae8f171c483657c4548c4768b6b9c144da0822a4f1",
        "metadata": {},
        "name": "src_jiraBusinessTimelineQuery",
        "operationKind": "query",
        "text": null
    }
};
var $5232f385be868c01$export$2e2bcd8739ae039 = $5232f385be868c01$var$node;

});

parcelRegister("jA2oL", function(module, exports) {

let $e4133d5fd3df4359$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e4133d5fd3df4359$var$load("ffQaD"),
    $e4133d5fd3df4359$var$load("kvRbA"),
    $e4133d5fd3df4359$var$load("aZ962")
]).then(()=>parcelRequire('2sFVY'));

});



parcelRegister("1hbMK", function(module, exports) {

$parcel$export(module.exports, "jiraHomeRouteEntry", () => $056174761f438866$export$578dcb61ac3cb57a);

var $5uXOq = parcelRequire("5uXOq");

var $vla3y = parcelRequire("vla3y");

var $biCWj = parcelRequire("biCWj");

var $ffza4 = parcelRequire("ffza4");

var $3H5ry = parcelRequire("3H5ry");

var $4R6GH = parcelRequire("4R6GH");

var $l9RBL = parcelRequire("l9RBL");

var $gmpjq = parcelRequire("gmpjq");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");


var $bHhiy = parcelRequire("bHhiy");

var $aILzD = parcelRequire("aILzD");

var $gSttA = parcelRequire("gSttA");

var $3RJkv = parcelRequire("3RJkv");

var $dIHnK = parcelRequire("dIHnK");

var $5pSYQ = parcelRequire("5pSYQ");

var $gNStA = parcelRequire("gNStA");

var $7mjY3 = parcelRequire("7mjY3");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $6s1PB = parcelRequire("6s1PB");
const $056174761f438866$var$conditionalPostOfficeJiraYourWorkResource = (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('post_office_ssr_jira_your_work_enabled'), (0, $5pSYQ.postOfficeJiraYourWorkResource));
const $056174761f438866$var$conditionalJiraHomeWorkSuggestionsIsDeveloperResource = (0, $gNStA.resourceWithCondition2)(()=>(0, $6s1PB.expVal)('jira-your-work-work-suggestions-tab-experiment', 'isEnabled', false), (0, $gSttA.jiraHomeWorkSuggestionsIsDeveloperResource));

const $056174761f438866$var$LazyJiraHomePage = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("jG6YQ"))), {
    moduleId: "./src/packages/spa-apps/jira-home/src/index.tsx"
});
const $056174761f438866$var$checkConsolidationOnRouteDependency = async (dependencies)=>{
    const data = await dependencies[0, $5a94e356f9d5e220$export$25ee35b01de9d734].promise;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $3H5ry.checkShouldUseJSM)(data);
};
const $056174761f438866$var$JiraHomeComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $056174761f438866$var$LazyJiraHomePage,
        pageId: "jira-home",
        shouldShowSpinner: false
    });
const $056174761f438866$export$578dcb61ac3cb57a = (0, $7NszV.createEntry)((0, $dIHnK.jiraHomeRoute), ()=>({
        group: 'home',
        ufoName: 'jira-home',
        component: $056174761f438866$var$JiraHomeComponent,
        skeleton: (0, $7mjY3.YourWorkSkeleton),
        layout: (0, $gmpjq.homepageLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).HOME
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $aILzD.jiraHomeResourceWithCache),
            (0, $l9RBL.jiraHomePageRightSidePanelResource),
            $056174761f438866$var$conditionalPostOfficeJiraYourWorkResource,
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $vla3y.widgetResources).map((resourceCreator)=>resourceCreator($056174761f438866$var$checkConsolidationOnRouteDependency, [
                    (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
                ])),
            ...(0, $biCWj.widgetResources).map((resourceCreator)=>(0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('your_work_page_operation_widgets_changes'), resourceCreator($056174761f438866$var$checkConsolidationOnRouteDependency, [
                    (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
                ]))),
            $056174761f438866$var$conditionalJiraHomeWorkSuggestionsIsDeveloperResource
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $056174761f438866$var$LazyJiraHomePage
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("vla3y", function(module, exports) {

$parcel$export(module.exports, "myTeamsResource", () => $21f951fdce1763c0$export$602f373f7fdaccc1);
$parcel$export(module.exports, "statusResource", () => $21f951fdce1763c0$export$8f57164cc67fb360);
$parcel$export(module.exports, "userTimelineResource", () => $21f951fdce1763c0$export$35b906dc2329cdc6);
$parcel$export(module.exports, "schedulesResource", () => $21f951fdce1763c0$export$f9574b51fbc36dc3);
$parcel$export(module.exports, "resources", () => $21f951fdce1763c0$export$bc99aaabaf7b70a7);
$parcel$export(module.exports, "widgetResources", () => $21f951fdce1763c0$export$bce3244764eac6e6);
$parcel$export(module.exports, "createMyTeamsResource", () => (parcelRequire("kCVY8")).createMyTeamsResource);
$parcel$export(module.exports, "createStatusResource", () => (parcelRequire("5IZS8")).createStatusResource);
$parcel$export(module.exports, "createUserTimelineResource", () => (parcelRequire("izTEw")).createUserTimelineResource);
$parcel$export(module.exports, "createSchedulesResource", () => (parcelRequire("dlTDC")).createSchedulesResource);
parcelRequire("jxRF2");
var $ldKOT = parcelRequire("ldKOT");

var $kCVY8 = parcelRequire("kCVY8");

var $jfpRV = parcelRequire("jfpRV");

var $dlTDC = parcelRequire("dlTDC");

var $5IZS8 = parcelRequire("5IZS8");

var $izTEw = parcelRequire("izTEw");
const $21f951fdce1763c0$export$602f373f7fdaccc1 = (0, $kCVY8.createMyTeamsResource)();
const $21f951fdce1763c0$export$f363fac02afee7a4 = (0, $jfpRV.createOpsTeamsResource)();
const $21f951fdce1763c0$export$8f57164cc67fb360 = (0, $5IZS8.createStatusResource)();
const $21f951fdce1763c0$export$35b906dc2329cdc6 = (0, $izTEw.createUserTimelineResource)();
const $21f951fdce1763c0$export$f9574b51fbc36dc3 = (0, $dlTDC.createSchedulesResource)();
const $21f951fdce1763c0$export$bc99aaabaf7b70a7 = [
    (0, $ldKOT.eocUserResource),
    (0, $kCVY8.createMyTeamsResource)(),
    (0, $5IZS8.createStatusResource)(),
    (0, $jfpRV.createOpsTeamsResource)()
];
const $21f951fdce1763c0$export$bce3244764eac6e6 = [
    ()=>(0, $ldKOT.eocUserResource),
    (callback, depends)=>(0, $kCVY8.createMyTeamsResource)(callback, depends),
    (callback, depends)=>(0, $5IZS8.createStatusResource)(callback, depends),
    (callback, depends)=>(0, $izTEw.createUserTimelineResource)(callback, depends),
    (callback, depends)=>(0, $dlTDC.createSchedulesResource)(callback, depends)
];

});
parcelRegister("kCVY8", function(module, exports) {

$parcel$export(module.exports, "createMyTeamsResource", () => $cad624fc2ff7cfd6$export$bf86fb90d0661bcb);

var $2M1hQ = parcelRequire("2M1hQ");

var $6OdRW = parcelRequire("6OdRW");
const $cad624fc2ff7cfd6$export$bf86fb90d0661bcb = (checkConsolidationOnRouteDependency, depends)=>(0, $2M1hQ.createResource)({
        type: 'myTeamsResource',
        getKey: ()=>'myTeamsResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $6OdRW.getMyTeamsEndpoint)();
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("6OdRW", function(module, exports) {

$parcel$export(module.exports, "getMyTeamsEndpoint", () => $8d7771bc195a7eba$export$abe46da7d1f191a7);

var $j74qU = parcelRequire("j74qU");
const $8d7771bc195a7eba$export$abe46da7d1f191a7 = ()=>{
    return (0, $j74qU.eocFetch)(`/v1/alerts/responders/suggested`);
};

});


parcelRegister("jfpRV", function(module, exports) {

$parcel$export(module.exports, "createOpsTeamsResource", () => $8fdf339b714e66ed$export$99505a9d792f516c);

var $2M1hQ = parcelRequire("2M1hQ");

var $6LUYW = parcelRequire("6LUYW");
const $8fdf339b714e66ed$export$99505a9d792f516c = (checkConsolidationOnRouteDependency, depends)=>(0, $2M1hQ.createResource)({
        type: 'opsTeamsResource',
        getKey: ()=>'opsTeamsResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $6LUYW.getOpsTeamsEndpoint)().then((response)=>{
                return response.values;
            });
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("6LUYW", function(module, exports) {

$parcel$export(module.exports, "getOpsTeamsEndpoint", () => $da0ecde7fda1bab3$export$7498ba30158c16cd);

var $j74qU = parcelRequire("j74qU");

var $68pYM = parcelRequire("68pYM");
const $da0ecde7fda1bab3$export$7498ba30158c16cd = ()=>{
    return (0, $j74qU.eocFetch)((0, $68pYM.urls).teams.url());
};

});
parcelRegister("68pYM", function(module, exports) {

$parcel$export(module.exports, "urls", () => $d4c8bf52c3691263$export$bcae9ba627f604b6);
$parcel$export(module.exports, "SPOTLIGHT_NAMES", () => $d4c8bf52c3691263$export$a7c923252528b255);
$parcel$export(module.exports, "SPOTLIGHT_TOURS", () => $d4c8bf52c3691263$export$38c46ed7a5bc80a0);
$parcel$export(module.exports, "WhoIsOnCallHandler", () => $d4c8bf52c3691263$export$1e7191618d5d4548);
$parcel$export(module.exports, "WhoIsOnCallWidgetHandler", () => $d4c8bf52c3691263$export$d05bbb1ada0e07c4);
const $d4c8bf52c3691263$export$bcae9ba627f604b6 = Object.freeze({
    schedules: {
        url: ()=>`/v1/schedules`,
        user: {
            url: ()=>`${$d4c8bf52c3691263$export$bcae9ba627f604b6.schedules.url()}/user`,
            timeline: {
                url: ()=>`${$d4c8bf52c3691263$export$bcae9ba627f604b6.schedules.user.url()}/timeline`,
                export: {
                    url: ()=>`${$d4c8bf52c3691263$export$bcae9ba627f604b6.schedules.user.timeline.url()}/export`
                }
            },
            userId: {
                url: ({ userId: userId } = {
                    userId: ':userId'
                })=>`${$d4c8bf52c3691263$export$bcae9ba627f604b6.schedules.user.url()}/${userId}`
            }
        },
        onCalls: {
            url: ()=>`${$d4c8bf52c3691263$export$bcae9ba627f604b6.schedules.url()}/on-calls`
        },
        scheduleId: {
            url: ({ scheduleId: scheduleId } = {
                scheduleId: ':scheduleId'
            })=>`${$d4c8bf52c3691263$export$bcae9ba627f604b6.schedules.url()}/${scheduleId}`,
            timeline: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`${$d4c8bf52c3691263$export$bcae9ba627f604b6.schedules.scheduleId.url({
                        scheduleId: scheduleId
                    })}/timeline`
            }
        }
    },
    wioc: {
        status: {
            url: ()=>`${$d4c8bf52c3691263$export$bcae9ba627f604b6.schedules.url()}/user/on-calls`
        }
    },
    teams: {
        url: ()=>`/v1/teams`
    }
});
const $d4c8bf52c3691263$export$a7c923252528b255 = {
    firstOverlappingPeriod: 'eoc-who-is-on-call_first_overlapping_period'
};
const $d4c8bf52c3691263$export$38c46ed7a5bc80a0 = {
    overlappingPeriod: 'eoc-who-is-on-call-overlapping-period'
};
class $d4c8bf52c3691263$export$1e7191618d5d4548 {
    handler(message, context) {
        throw new Error('Not implemented');
    }
}
class $d4c8bf52c3691263$export$d05bbb1ada0e07c4 {
    handler(message, context) {
        throw new Error('Not implemented');
    }
}

});



parcelRegister("dlTDC", function(module, exports) {

$parcel$export(module.exports, "createSchedulesResource", () => $10cde28570610d7a$export$b5e65ca3f82b01c5);

var $2M1hQ = parcelRequire("2M1hQ");

var $ajrLe = parcelRequire("ajrLe");
const $10cde28570610d7a$export$b5e65ca3f82b01c5 = (checkConsolidationOnRouteDependency, depends)=>(0, $2M1hQ.createResource)({
        type: 'schedulesResource',
        getKey: ()=>'schedulesResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $ajrLe.getSchedulesEndpoint)();
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("ajrLe", function(module, exports) {

$parcel$export(module.exports, "getSchedulesEndpoint", () => $1a931852d60ab07d$export$e8e940098db1b988);

var $j74qU = parcelRequire("j74qU");

var $68pYM = parcelRequire("68pYM");
const $1a931852d60ab07d$export$e8e940098db1b988 = ()=>{
    return (0, $j74qU.eocFetch)(`${(0, $68pYM.urls).schedules.onCalls.url()}`);
};

});


parcelRegister("5IZS8", function(module, exports) {

$parcel$export(module.exports, "createStatusResource", () => $c6e09a482698443b$export$3d1c353e2693418c);

var $2M1hQ = parcelRequire("2M1hQ");

var $iyzC0 = parcelRequire("iyzC0");

var $41Gqg = parcelRequire("41Gqg");
const $c6e09a482698443b$export$3d1c353e2693418c = (checkConsolidationOnRouteDependency, depends)=>(0, $2M1hQ.createResource)({
        type: 'statusResource',
        getKey: ()=>'statusResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $iyzC0.getStatus)().then((0, $41Gqg.transformStatusResponse));
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("iyzC0", function(module, exports) {

$parcel$export(module.exports, "getStatus", () => $d83203ae0be7e9b4$export$b70265791d2079d4);

var $j74qU = parcelRequire("j74qU");

var $68pYM = parcelRequire("68pYM");
const $d83203ae0be7e9b4$export$b70265791d2079d4 = ()=>{
    return (0, $j74qU.eocFetch)((0, $68pYM.urls).wioc.status.url(), {
        method: 'GET'
    });
};

});

parcelRegister("41Gqg", function(module, exports) {

$parcel$export(module.exports, "transformStatusResponse", () => $8a21b756a892d7eb$export$44a749c89534e42c);
const $8a21b756a892d7eb$export$44a749c89534e42c = ({ currentTimeUtcMillis: currentTimeUtcMillis, onCallUntilUtcMillis: onCallUntilUtcMillis, onCallUntilOffsetMillis: onCallUntilOffsetMillis, isCurrentOnCall: isCurrentOnCall, isParticipantOfAnyRotation: isParticipantOfAnyRotation, nextOnCallEndUtcMillis: nextOnCallEndUtcMillis, nextOnCallEndOffsetMillis: nextOnCallEndOffsetMillis, nextOnCallStartUtcMillis: nextOnCallStartUtcMillis, nextOnCallStartOffsetMillis: nextOnCallStartOffsetMillis })=>{
    return {
        currentDate: currentTimeUtcMillis,
        currentShiftEnd: onCallUntilUtcMillis,
        currentShiftEndOffset: onCallUntilOffsetMillis,
        isOnCall: isCurrentOnCall,
        isParticipantOfAnyRotation: isParticipantOfAnyRotation,
        nextEndDate: nextOnCallEndUtcMillis,
        nextEndOffset: nextOnCallEndOffsetMillis,
        nextStartDate: nextOnCallStartUtcMillis,
        nextStartOffset: nextOnCallStartOffsetMillis
    };
};

});


parcelRegister("izTEw", function(module, exports) {

$parcel$export(module.exports, "createUserTimelineResource", () => $3f4c51b6b015af14$export$a479dcc35c33def1);

var $2M1hQ = parcelRequire("2M1hQ");
parcelRequire("jxRF2");
var $ldKOT = parcelRequire("ldKOT");

var $5rGi1 = parcelRequire("5rGi1");
const $3f4c51b6b015af14$export$a479dcc35c33def1 = (checkConsolidationOnRouteDependency, depends)=>(0, $2M1hQ.createResource)({
        type: 'userTimelineResource',
        getKey: ()=>'userTimelineResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            const data = await dependencies[(0, $ldKOT.eocUserResource).type]?.promise;
            // Since depends API types are not exported it's impossible to infer types,
            // thus we have to use casting
            const accountId = data?.accountId;
            const timezone = data?.timeZone;
            if (!accountId || !timezone) return null;
            return (0, $5rGi1.getWidgetTimeline)(accountId);
        },
        isBrowserOnly: true,
        depends: [
            ...depends ? depends : [],
            (0, $ldKOT.eocUserResource).type
        ]
    });

});
parcelRegister("5rGi1", function(module, exports) {

$parcel$export(module.exports, "getWidgetTimeline", () => $2c4955dde7aaf4da$export$bd80cae08a85b1f0);

var $eYLkf = parcelRequire("eYLkf");

var $j74qU = parcelRequire("j74qU");

var $68pYM = parcelRequire("68pYM");

var $8PqA1 = parcelRequire("8PqA1");
const $2c4955dde7aaf4da$export$bd80cae08a85b1f0 = (accountId)=>{
    const formattedCurrent = (0, $eYLkf.default)(new Date(), 'UTC', "yyyy-MM-dd'T'HH:mm:ss.SSSXX");
    const urlParams = new URLSearchParams({
        currentDate: formattedCurrent,
        accountId: accountId,
        mode: 'timeline',
        timelineType: '6'
    });
    return (0, $j74qU.eocFetch)(`${(0, $68pYM.urls).schedules.user.timeline.url()}?${urlParams.toString()}`, {
        method: 'GET'
    }).then((0, $8PqA1.transformUserTimelineResponse));
};

});
parcelRegister("eYLkf", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae7b6125506491b3$export$2e2bcd8739ae039);

var $fwbX5 = parcelRequire("fwbX5");

var $iwG2X = parcelRequire("iwG2X");

var $jAT0D = parcelRequire("jAT0D");
function $ae7b6125506491b3$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($fwbX5)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $iwG2X.default)((0, $jAT0D.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("iwG2X", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7cbd4ba80af9369$export$2e2bcd8739ae039);

var $aR9Qf = parcelRequire("aR9Qf");

var $dBimx = parcelRequire("dBimx");

var $gUUmE = parcelRequire("gUUmE");
var $d7cbd4ba80af9369$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $d7cbd4ba80af9369$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($d7cbd4ba80af9369$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $gUUmE.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $dBimx.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($aR9Qf)))(dirtyDate, formatStr, options);
}

});
parcelRegister("dBimx", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e6cf97ea11d4595$export$2e2bcd8739ae039);

var $kbEJb = parcelRequire("kbEJb");

var $i6fIb = parcelRequire("i6fIb");
var $9e6cf97ea11d4595$var$MILLISECONDS_IN_MINUTE = 60000;
var $9e6cf97ea11d4595$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $9e6cf97ea11d4595$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $9e6cf97ea11d4595$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $9e6cf97ea11d4595$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $9e6cf97ea11d4595$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $9e6cf97ea11d4595$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $9e6cf97ea11d4595$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $9e6cf97ea11d4595$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $9e6cf97ea11d4595$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $9e6cf97ea11d4595$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $9e6cf97ea11d4595$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $9e6cf97ea11d4595$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $kbEJb.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $kbEJb.default)('long', date, options);
        }
    }
};
function $9e6cf97ea11d4595$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $i6fIb.default)(timeZone, originalDate, true) / $9e6cf97ea11d4595$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $9e6cf97ea11d4595$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $9e6cf97ea11d4595$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $9e6cf97ea11d4595$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $9e6cf97ea11d4595$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $9e6cf97ea11d4595$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $9e6cf97ea11d4595$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $9e6cf97ea11d4595$var$formatTimezone(offset, dirtyDelimeter);
}
function $9e6cf97ea11d4595$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $9e6cf97ea11d4595$var$addLeadingZeros(minutes, 2);
}
var $9e6cf97ea11d4595$export$2e2bcd8739ae039 = $9e6cf97ea11d4595$var$formatters;

});
parcelRegister("kbEJb", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb246d6cdcaaeca4$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $eb246d6cdcaaeca4$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $eb246d6cdcaaeca4$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $eb246d6cdcaaeca4$var$partsTimeZone(dtf, date) : $eb246d6cdcaaeca4$var$hackyTimeZone(dtf, date);
}
function $eb246d6cdcaaeca4$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $eb246d6cdcaaeca4$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $eb246d6cdcaaeca4$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("i6fIb", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2d4f98f2ab6c303$export$2e2bcd8739ae039);

var $hb3mZ = parcelRequire("hb3mZ");

var $e86X7 = parcelRequire("e86X7");
var $d2d4f98f2ab6c303$var$MILLISECONDS_IN_HOUR = 3600000;
var $d2d4f98f2ab6c303$var$MILLISECONDS_IN_MINUTE = 60000;
var $d2d4f98f2ab6c303$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $d2d4f98f2ab6c303$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $d2d4f98f2ab6c303$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $d2d4f98f2ab6c303$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$d2d4f98f2ab6c303$var$validateTimezone(hours)) return NaN;
        return -(hours * $d2d4f98f2ab6c303$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $d2d4f98f2ab6c303$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$d2d4f98f2ab6c303$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $d2d4f98f2ab6c303$var$MILLISECONDS_IN_HOUR + minutes * $d2d4f98f2ab6c303$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($d2d4f98f2ab6c303$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $d2d4f98f2ab6c303$var$toUtcDate(date);
        var offset = $d2d4f98f2ab6c303$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $d2d4f98f2ab6c303$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $d2d4f98f2ab6c303$var$toUtcDate(date) {
    return (0, $e86X7.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $d2d4f98f2ab6c303$var$calcOffset(date, timezoneString) {
    var tokens = (0, $hb3mZ.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $e86X7.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $d2d4f98f2ab6c303$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $d2d4f98f2ab6c303$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $d2d4f98f2ab6c303$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $d2d4f98f2ab6c303$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $d2d4f98f2ab6c303$var$validIANATimezoneCache = {};
function $d2d4f98f2ab6c303$var$isValidTimezoneIANAString(timeZoneString) {
    if ($d2d4f98f2ab6c303$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $d2d4f98f2ab6c303$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("hb3mZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c81613eb8d87ac5c$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $c81613eb8d87ac5c$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $c81613eb8d87ac5c$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $c81613eb8d87ac5c$var$partsOffset(dtf, date) : $c81613eb8d87ac5c$var$hackyOffset(dtf, date);
}
var $c81613eb8d87ac5c$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $c81613eb8d87ac5c$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $c81613eb8d87ac5c$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $c81613eb8d87ac5c$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $c81613eb8d87ac5c$var$dtfCache = {};
function $c81613eb8d87ac5c$var$getDateTimeFormat(timeZone) {
    if (!$c81613eb8d87ac5c$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $c81613eb8d87ac5c$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $c81613eb8d87ac5c$var$dtfCache[timeZone];
}

});

parcelRegister("e86X7", function(module, exports) {

$parcel$export(module.exports, "default", () => $a49734b25d97733d$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $a49734b25d97733d$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("gUUmE", function(module, exports) {

$parcel$export(module.exports, "default", () => $c50d991cbda2c596$export$2e2bcd8739ae039);

var $aSksP = parcelRequire("aSksP");

var $jGQTC = parcelRequire("jGQTC");

var $i6fIb = parcelRequire("i6fIb");

var $crHgC = parcelRequire("crHgC");
var $c50d991cbda2c596$var$MILLISECONDS_IN_HOUR = 3600000;
var $c50d991cbda2c596$var$MILLISECONDS_IN_MINUTE = 60000;
var $c50d991cbda2c596$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $c50d991cbda2c596$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $crHgC.default)
};
function $c50d991cbda2c596$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $c50d991cbda2c596$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($aSksP)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $c50d991cbda2c596$var$splitDateString(argument);
    var parseYearResult = $c50d991cbda2c596$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $c50d991cbda2c596$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $c50d991cbda2c596$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $i6fIb.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $c50d991cbda2c596$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $c50d991cbda2c596$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $c50d991cbda2c596$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $c50d991cbda2c596$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $c50d991cbda2c596$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $c50d991cbda2c596$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $c50d991cbda2c596$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $c50d991cbda2c596$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $c50d991cbda2c596$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $c50d991cbda2c596$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $c50d991cbda2c596$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$c50d991cbda2c596$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $c50d991cbda2c596$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$c50d991cbda2c596$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $c50d991cbda2c596$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$c50d991cbda2c596$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $c50d991cbda2c596$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$c50d991cbda2c596$var$validateWeekDate(year, week)) return new Date(NaN);
        return $c50d991cbda2c596$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $c50d991cbda2c596$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$c50d991cbda2c596$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $c50d991cbda2c596$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $c50d991cbda2c596$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $c50d991cbda2c596$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$c50d991cbda2c596$var$validateTime(hours)) return NaN;
        return hours % 24 * $c50d991cbda2c596$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $c50d991cbda2c596$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$c50d991cbda2c596$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $c50d991cbda2c596$var$MILLISECONDS_IN_HOUR + minutes * $c50d991cbda2c596$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $c50d991cbda2c596$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$c50d991cbda2c596$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $c50d991cbda2c596$var$MILLISECONDS_IN_HOUR + minutes * $c50d991cbda2c596$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $c50d991cbda2c596$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $c50d991cbda2c596$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $c50d991cbda2c596$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $c50d991cbda2c596$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $c50d991cbda2c596$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $c50d991cbda2c596$var$isLeapYearIndex(year);
        if (isLeapYear && date > $c50d991cbda2c596$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $c50d991cbda2c596$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $c50d991cbda2c596$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $c50d991cbda2c596$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $c50d991cbda2c596$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $c50d991cbda2c596$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("crHgC", function(module, exports) {

$parcel$export(module.exports, "default", () => $90f991911d90bed8$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $90f991911d90bed8$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $90f991911d90bed8$export$2e2bcd8739ae039 = $90f991911d90bed8$var$tzPattern;

});



parcelRegister("jAT0D", function(module, exports) {

$parcel$export(module.exports, "default", () => $e43c0cd241603813$export$2e2bcd8739ae039);

var $i6fIb = parcelRequire("i6fIb");

var $gUUmE = parcelRequire("gUUmE");
function $e43c0cd241603813$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $gUUmE.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $i6fIb.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});


parcelRegister("8PqA1", function(module, exports) {

$parcel$export(module.exports, "transformUserTimelineResponse", () => $8a23480b7911491d$export$78049913b79774a2);

var $hz3Fg = parcelRequire("hz3Fg");
const $8a23480b7911491d$export$78049913b79774a2 = ({ startTimeUtcMillis: startTimeUtcMillis, endTimeUtcMillis: endTimeUtcMillis, startOffsetMillis: startOffsetMillis, endOffsetMillis: endOffsetMillis, utcTimeOffsetMillis: utcTimeOffsetMillis, currentTime: currentTime, periods: periods, ...data })=>{
    return {
        startEpoch: startTimeUtcMillis,
        endEpoch: endTimeUtcMillis,
        nowEpoch: currentTime,
        startOffset: startOffsetMillis,
        endOffset: endOffsetMillis,
        nowOffset: utcTimeOffsetMillis,
        data: {
            ...data,
            periods: periods.map((0, $hz3Fg.fromMergedPeriodResponseToClusterPeriod))
        }
    };
};

});
parcelRegister("hz3Fg", function(module, exports) {

$parcel$export(module.exports, "fromMergedPeriodResponseToClusterPeriod", () => $0fe8fc9a353d2f1e$export$9b0bac75f135bd57);
const $0fe8fc9a353d2f1e$export$9b0bac75f135bd57 = (mergedPeriodResponse)=>{
    const { startTimeUtcMillis: startTimeUtcMillis, endTimeUtcMillis: endTimeUtcMillis, isTrueStartTime: isTrueStartTime, isTrueEndTime: isTrueEndTime, periodStartOffsetMillis: periodStartOffsetMillis, periodEndOffsetMillis: periodEndOffsetMillis, overlappingPeriods: overlappingPeriods } = mergedPeriodResponse;
    const clusterPeriod = {
        id: `${startTimeUtcMillis}-${endTimeUtcMillis}`,
        startEpoch: startTimeUtcMillis,
        endEpoch: endTimeUtcMillis,
        isTrueStartTime: isTrueStartTime,
        isTrueEndTime: isTrueEndTime,
        startOffset: periodStartOffsetMillis,
        endOffset: periodEndOffsetMillis,
        overlaps: overlappingPeriods.map($0fe8fc9a353d2f1e$var$fromOverlappingPeriodResponseToOverlappingPeriod)
    };
    return clusterPeriod;
};
const $0fe8fc9a353d2f1e$var$fromOverlappingPeriodResponseToOverlappingPeriod = (overlappingPeriodResponse)=>{
    const { startTimeUtcMillis: startTimeUtcMillis, endTimeUtcMillis: endTimeUtcMillis, periodStartOffsetMillis: periodStartOffsetMillis, periodEndOffsetMillis: periodEndOffsetMillis, overlappingRotations: overlappingRotations, isTrueStartTime: isTrueStartTime, isTrueEndTime: isTrueEndTime } = overlappingPeriodResponse;
    const overlappingPeriod = {
        id: `${startTimeUtcMillis}-${endTimeUtcMillis}`,
        startEpoch: startTimeUtcMillis,
        endEpoch: endTimeUtcMillis,
        startOffset: periodStartOffsetMillis,
        endOffset: periodEndOffsetMillis,
        overlaps: overlappingRotations,
        isTrueStartTime: isTrueStartTime,
        isTrueEndTime: isTrueEndTime
    };
    return overlappingPeriod;
};

});





parcelRegister("biCWj", function(module, exports) {

$parcel$export(module.exports, "openAlertsResource", () => $a9a9236debbf4a7e$export$fb6d91a24bfaa074);
$parcel$export(module.exports, "ackedAlertsResource", () => $a9a9236debbf4a7e$export$3917a9639b1be557);
$parcel$export(module.exports, "snoozedAlertsResource", () => $a9a9236debbf4a7e$export$f62d237df457042d);
$parcel$export(module.exports, "widgetResources", () => $a9a9236debbf4a7e$export$bce3244764eac6e6);

var $2M1hQ = parcelRequire("2M1hQ");

var $4wMKp = parcelRequire("4wMKp");

var $ddwld = parcelRequire("ddwld");
const $a9a9236debbf4a7e$export$e5eb8aade1d4272a = (checkConsolidationOnRouteDependency, depends)=>(0, $2M1hQ.createResource)({
        type: 'openAlertsResource',
        getKey: ()=>'openAlertsResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $ddwld.fetchAlerts)({
                searchParams: {
                    query: (0, $4wMKp.PredefinedQueries).MY_OPEN_ALERTS,
                    limit: 3
                }
            });
        },
        isBrowserOnly: true,
        depends: depends
    });
const $a9a9236debbf4a7e$export$66760ff81022525f = (checkConsolidationOnRouteDependency, depends)=>(0, $2M1hQ.createResource)({
        type: 'ackedAlertsResource',
        getKey: ()=>'ackedAlertsResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $ddwld.fetchAlerts)({
                searchParams: {
                    query: (0, $4wMKp.PredefinedQueries).MY_ACKED_ALERTS,
                    limit: 3
                }
            });
        },
        isBrowserOnly: true,
        depends: depends
    });
const $a9a9236debbf4a7e$export$73c7fe1d8124595f = (checkConsolidationOnRouteDependency, depends)=>(0, $2M1hQ.createResource)({
        type: 'snoozedAlertsResource',
        getKey: ()=>'snoozedAlertsResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $ddwld.fetchAlerts)({
                searchParams: {
                    query: (0, $4wMKp.PredefinedQueries).MY_SNOOZED_ALERTS,
                    limit: 3
                }
            });
        },
        isBrowserOnly: true,
        depends: depends
    });
const $a9a9236debbf4a7e$export$fb6d91a24bfaa074 = $a9a9236debbf4a7e$export$e5eb8aade1d4272a();
const $a9a9236debbf4a7e$export$3917a9639b1be557 = $a9a9236debbf4a7e$export$66760ff81022525f();
const $a9a9236debbf4a7e$export$f62d237df457042d = $a9a9236debbf4a7e$export$73c7fe1d8124595f();
const $a9a9236debbf4a7e$export$bce3244764eac6e6 = [
    (callback, depends)=>$a9a9236debbf4a7e$export$e5eb8aade1d4272a(callback, depends),
    (callback, depends)=>$a9a9236debbf4a7e$export$66760ff81022525f(callback, depends),
    (callback, depends)=>$a9a9236debbf4a7e$export$73c7fe1d8124595f(callback, depends)
];

});
parcelRegister("4wMKp", function(module, exports) {

$parcel$export(module.exports, "ALERTS_STORE_NAME", () => $53bef7e86dc9eace$export$6793992c0b67d9c9);
$parcel$export(module.exports, "PredefinedQueries", () => $53bef7e86dc9eace$export$ed6721f2880ce367);
$parcel$export(module.exports, "initialState", () => $53bef7e86dc9eace$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "baseState", () => $53bef7e86dc9eace$export$a2290b0841306a43);
$parcel$export(module.exports, "GLOBAL_ALERTS_ROUTE_NAME", () => $53bef7e86dc9eace$export$ba93b3de87c980dc);
$parcel$export(module.exports, "GLOBAL_ALERT_DETAIL_ROUTE_NAME", () => $53bef7e86dc9eace$export$1881423041ad1b5c);
const $53bef7e86dc9eace$export$6793992c0b67d9c9 = 'navigation-alerts-store';
const $53bef7e86dc9eace$var$ONLY_MY_SELECTOR_QUERY = '(acknowledgedBy: me OR owner: me OR responders: me)';
const $53bef7e86dc9eace$export$ed6721f2880ce367 = {
    MY_OPEN_ALERTS: `status: open AND acknowledged: false AND snoozed: false AND ${$53bef7e86dc9eace$var$ONLY_MY_SELECTOR_QUERY}`,
    MY_ACKED_ALERTS: `status: open AND acknowledged: true AND ${$53bef7e86dc9eace$var$ONLY_MY_SELECTOR_QUERY}`,
    MY_SNOOZED_ALERTS: `status: open AND acknowledged: false AND snoozed: true AND ${$53bef7e86dc9eace$var$ONLY_MY_SELECTOR_QUERY}`
};
const $53bef7e86dc9eace$export$d4c72bab9d6cc13a = {};
const $53bef7e86dc9eace$export$a2290b0841306a43 = {
    items: null,
    isFetching: false,
    fetchError: null,
    hasFetchedOnce: false,
    hasSuccessOnce: false,
    totalCount: 0
};
const $53bef7e86dc9eace$export$ba93b3de87c980dc = 'eoc-global-alerts';
const $53bef7e86dc9eace$export$1881423041ad1b5c = 'eoc-global-alert-detail';

});

parcelRegister("ddwld", function(module, exports) {

$parcel$export(module.exports, "fetchAlerts", () => $dc9d47a55900ee18$export$f7b1e2075b3da718);

var $j74qU = parcelRequire("j74qU");
const $dc9d47a55900ee18$export$f7b1e2075b3da718 = async ({ searchParams: searchParams })=>{
    const params = new URLSearchParams(searchParams ?? {});
    return (0, $j74qU.eocFetch)(`/v1/alerts/?${params.toString()}`);
};

});


parcelRegister("l9RBL", function(module, exports) {

$parcel$export(module.exports, "jiraHomePageRightSidePanelResource", () => $eed57b2562d325e4$export$9cba342d9ec5384d);

var $ao2h1 = parcelRequire("ao2h1");

var $a4BhB = parcelRequire("a4BhB");

var $jKXj9 = parcelRequire("jKXj9");
const $eed57b2562d325e4$var$isBroadcastWidgetEnabled = ()=>false;
const $eed57b2562d325e4$export$9cba342d9ec5384d = (0, $ao2h1.createRelayResource)({
    type: (0, $jKXj9.JIRA_HOME_PAGE_RIGHT_SIDE_PANEL),
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $a4BhB.default),
            variables: {
                cloudId: tenantContext.cloudId,
                broadcastWidgetEnabled: $eed57b2562d325e4$var$isBroadcastWidgetEnabled()
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("a4BhB", function(module, exports) {

$parcel$export(module.exports, "default", () => $616ef8e6ff77d43c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3d73a7099a9295c02951eb57579b7d93>>
 * @relayHash a7e48eaea1f1087c0622f1648327271d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d1e74aae483d14f57577f9505f3c4efaab555f7aa6ddfb379804496ec3f405f1
const $616ef8e6ff77d43c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "broadcastWidgetEnabled"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "main_rightSidePanel_RootQuery",
            "selections": [
                {
                    "condition": "broadcastWidgetEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "main_homeBroadcastWidget_Widget"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "main_rightSidePanel_RootQuery",
            "selections": [
                {
                    "condition": "broadcastWidgetEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudId",
                                            "variableName": "cloudId"
                                        }
                                    ],
                                    "concreteType": "JiraUserBroadcastMessageConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraUserBroadcastMessages",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraUserBroadcastMessageEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraUserBroadcastMessage",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "shouldDisplay"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d1e74aae483d14f57577f9505f3c4efaab555f7aa6ddfb379804496ec3f405f1",
            "metadata": {},
            "name": "main_rightSidePanel_RootQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$616ef8e6ff77d43c$var$node.hash = "174d1e9e3edb60b5684e0806b3d7342e";
var $616ef8e6ff77d43c$export$2e2bcd8739ae039 = $616ef8e6ff77d43c$var$node;

});

parcelRegister("jKXj9", function(module, exports) {

$parcel$export(module.exports, "RIGHT_PANEL_WIDTH", () => $64d3bec226f7ff92$export$750459958906793);
$parcel$export(module.exports, "RIGHT_SIDE_PANEL_EXPERIENCE", () => $64d3bec226f7ff92$export$2eb41e47cfa429b7);
$parcel$export(module.exports, "JIRA_HOME_PAGE_RIGHT_SIDE_PANEL", () => $64d3bec226f7ff92$export$6c783d91630ece21);

var $gwIPs = parcelRequire("gwIPs");
const $64d3bec226f7ff92$export$750459958906793 = (0, $gwIPs.gridSize) * 49;
const $64d3bec226f7ff92$export$2eb41e47cfa429b7 = {
    experience: 'jiraHomeRightSidePanel',
    experienceId: undefined,
    analyticsSource: 'jira-home'
};
const $64d3bec226f7ff92$export$6c783d91630ece21 = 'JIRA_HOME_PAGE_RIGHT_SIDE_PANEL';

});


parcelRegister("aILzD", function(module, exports) {

$parcel$export(module.exports, "jiraHomeResourceWithCache", () => $9f71890db935ba06$export$1da15dc2d924240c);

var $2M1hQ = parcelRequire("2M1hQ");


const $9f71890db935ba06$export$1da15dc2d924240c = (0, $2M1hQ.createResource)({
    type: (0, $dac9c443ac5dd9ad$export$e79da7e0d9d1c1f2),
    getKey: ()=>'jira-home',
    getDataLoader: ()=>(parcelRequire("2oLex")),
    maxAge: Infinity
});

});
const $dac9c443ac5dd9ad$export$e79da7e0d9d1c1f2 = 'JIRA_HOME';

parcelRegister("2oLex", function(module, exports) {

let $1bf2763e367ce5ff$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1bf2763e367ce5ff$var$load("xbbNO").then(()=>parcelRequire('fvAUD'));

});


parcelRegister("gSttA", function(module, exports) {

$parcel$export(module.exports, "jiraHomeWorkSuggestionsIsDeveloperResource", () => $bbd3e0c5dee753c9$export$420b5969a526b86f);

var $ao2h1 = parcelRequire("ao2h1");

var $i7jMq = parcelRequire("i7jMq");

var $ef5Xn = parcelRequire("ef5Xn");

var $4Pf62 = parcelRequire("4Pf62");
const $bbd3e0c5dee753c9$export$420b5969a526b86f = (0, $ao2h1.createRelayResource)({
    type: 'JIRA_HOME_WORK_SUGGESTIONS_IS_DEVELOPER',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $i7jMq.default),
            variables: {
                cloudId: tenantContext.cloudId,
                isSoftwareLicensed: tenantContext.licensedProducts[(0, $4Pf62.LICENSED_PRODUCTS).JIRA_SOFTWARE] && tenantContext.licenseStates?.software === (0, $ef5Xn.LICENSE_STATE_ACTIVE)
            }
        })
});

});
parcelRegister("i7jMq", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1a456774fd54599$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9af3482c29caafe3c266b9a94e6bf614>>
 * @relayHash 33a398085fffc1c8c240023b01b17ecb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6531092ed29d33046fe36572f33533c333d5d1c7642ce67bd8f17687b4e69ba1
const $a1a456774fd54599$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isSoftwareLicensed"
        }
    ], v1 = [
        {
            "condition": "isSoftwareLicensed",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "concreteType": "WorkSuggestions",
                    "kind": "LinkedField",
                    "name": "workSuggestions",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                }
                            ],
                            "concreteType": "WorkSuggestionsUserProfile",
                            "kind": "LinkedField",
                            "name": "userProfileByCloudId",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "persona"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "JiraHomeWithWorkSuggestionsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "JiraHomeWithWorkSuggestionsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "6531092ed29d33046fe36572f33533c333d5d1c7642ce67bd8f17687b4e69ba1",
            "metadata": {},
            "name": "JiraHomeWithWorkSuggestionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a1a456774fd54599$var$node.hash = "2ffc84c440c4cba253c916b64a96af89";
var $a1a456774fd54599$export$2e2bcd8739ae039 = $a1a456774fd54599$var$node;

});


parcelRegister("7mjY3", function(module, exports) {

$parcel$export(module.exports, "YourWorkSkeleton", () => $305c0c711ea600ba$export$62cf62fa23284b71);
$parcel$export(module.exports, "YourWorkItemListSkeleton", () => $305c0c711ea600ba$export$31cebe1052db844);

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $l3Kuc = parcelRequire("l3Kuc");

var $dnZyp = parcelRequire("dnZyp");
const $305c0c711ea600ba$export$62cf62fa23284b71 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($l3Kuc)))
    });
const $305c0c711ea600ba$export$31cebe1052db844 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dnZyp))),
        containerStyles: {
            maxHeight: '30em'
        }
    });

});
parcelRegister("l3Kuc", function(module, exports) {
module.exports = new URL("your-work-app-skeleton.tpl.14d150b5.svg", import.meta.url).toString();

});

parcelRegister("dnZyp", function(module, exports) {
module.exports = new URL("your-work-itemlist-skeleton.tpl.e9027f83.svg", import.meta.url).toString();

});


parcelRegister("jG6YQ", function(module, exports) {

let $e5375ab984a078ba$var$load = (parcelRequire("28QjX"))(4);

module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $e5375ab984a078ba$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $e5375ab984a078ba$var$load("k6g9p")
        ]);
    }),
    $e5375ab984a078ba$var$load("ffQaD"),
    $e5375ab984a078ba$var$load("kvRbA"),
    $e5375ab984a078ba$var$load("bEf6f")
]).then(()=>parcelRequire('jyj7M'));

});


parcelRegister("c2KPY", function(module, exports) {

$parcel$export(module.exports, "jiraSearchRouteEntry", () => $06085f80d69fe841$export$76b74d5744e69817);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $cg1lV = parcelRequire("cg1lV");

var $7kiuE = parcelRequire("7kiuE");

var $5ZrME = parcelRequire("5ZrME");
const $06085f80d69fe841$export$76b74d5744e69817 = (0, $7NszV.createEntry)((0, $cg1lV.jiraSearchRoute), ()=>({
        group: 'redirects',
        component: (0, $7kiuE.JiraSearchRedirect),
        isRedirect: true,
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $5ZrME.jiraSearchResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("cg1lV", function(module, exports) {

$parcel$export(module.exports, "jiraSearchRoute", () => $e3d75d351326e47a$export$a3a93dcf611b611a);
const $e3d75d351326e47a$export$a3a93dcf611b611a = {
    name: 'jira-search',
    path: '/jira/search',
    exact: true
};

});

parcelRegister("7kiuE", function(module, exports) {

$parcel$export(module.exports, "JiraSearchRedirect", () => $c1df58920245e964$export$ee180957879b33ac);

var $5uXOq = parcelRequire("5uXOq");

var $lb0Dk = parcelRequire("lb0Dk");

var $7tQej = parcelRequire("7tQej");
var $2YP9W = parcelRequire("2YP9W");

var $lFlWg = parcelRequire("lFlWg");

var $5ZrME = parcelRequire("5ZrME");
const $c1df58920245e964$export$ee180957879b33ac = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)((0, $5ZrME.jiraSearchResource));
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lb0Dk.IssueViewSkeleton), null);
    if (error || !data?.url) // handle api error state
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lFlWg.QuickSearchToGlobalIssueNavigatorRedirect), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: data.url,
        push: false
    });
};

});
parcelRegister("lFlWg", function(module, exports) {

$parcel$export(module.exports, "QuickSearchToGlobalIssueNavigatorRedirect", () => $2bd6861b4d276506$export$968c2900ae111000);

var $5uXOq = parcelRequire("5uXOq");

var $6jY6G = parcelRequire("6jY6G");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $bATyw = parcelRequire("bATyw");

var $7tQej = parcelRequire("7tQej");
var $ieDtd = parcelRequire("ieDtd");
var $2YP9W = parcelRequire("2YP9W");
const $2bd6861b4d276506$export$968c2900ae111000 = ({ Redirect: Redirect = (0, $7tQej.Redirect), fireScreenAnalytics: fireScreenAnalytics = (0, $8zOmE.fireScreenAnalytics), useAnalyticsEvents: useAnalyticsEvents = (0, $2NMNM.useAnalyticsEvents), useCurrentRoute: useCurrentRoute = (0, $6jY6G.useCurrentRoute), useQueryParam: useQueryParam = (0, $ieDtd.useQueryParam) })=>{
    const route = useCurrentRoute();
    const [searchString] = useQueryParam('searchString');
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const { data: isNinEnabled } = (0, $2YP9W.useResource)((0, $bATyw.isNinGlobalScopeEnrolmentEnabledResource));
    (0, $5uXOq.useEffect)(()=>{
        if (!route) return;
        const screenEvent = createAnalyticsEvent({
            screenName: 'quickSearchRedirect',
            attributes: {
                type: route.name
            }
        });
        fireScreenAnalytics(screenEvent);
    }, [
        createAnalyticsEvent,
        fireScreenAnalytics,
        route
    ]);
    let jql;
    if (isNinEnabled) jql = searchString != null ? `textfields ~ "${searchString}"` : 'ORDER BY created DESC';
    else jql = searchString != null ? `text ~ "${searchString}"` : 'order by created DESC';
    const redirectUrl = `/issues/?jql=${encodeURIComponent(jql)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Redirect, {
        to: redirectUrl
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2bd6861b4d276506$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2bd6861b4d276506$export$968c2900ae111000, null);

});

parcelRegister("5ZrME", function(module, exports) {

$parcel$export(module.exports, "jiraSearchResource", () => $c763bb61845622fe$export$d23832be0ebf8a93);

var $ebyGx = parcelRequire("ebyGx");

var $7f4tk = parcelRequire("7f4tk");

var $2M1hQ = parcelRequire("2M1hQ");
const $c763bb61845622fe$export$486bd66a4d919be7 = 'RESOURCE_TYPE_JIRA_SEARCH';
const $c763bb61845622fe$export$d23832be0ebf8a93 = (0, $2M1hQ.createResource)({
    type: $c763bb61845622fe$export$486bd66a4d919be7,
    getKey: ()=>'search',
    getData: ({ query: query }, { tenantContext: tenantContext })=>{
        const { atlassianAccountId: atlassianAccountId } = tenantContext;
        if (!atlassianAccountId || !query?.searchString) return null;
        const queryStr = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
            searchString: query.searchString
        });
        return (0, $7f4tk.default)(`/rest/navigation/4/quicksearch?${queryStr}`);
    },
    isBrowserOnly: true
});

});



parcelRegister("6mo9H", function(module, exports) {

$parcel$export(module.exports, "jsmBoardRouteEntry", () => $bbc84ec66ce4b2fd$export$44cb11fe4ca053f8);

var $ffza4 = parcelRequire("ffza4");

var $6hJYB = parcelRequire("6hJYB");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $f5kpo = parcelRequire("f5kpo");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $fpjJX = parcelRequire("fpjJX");

var $f7Y15 = parcelRequire("f7Y15");

var $gNStA = parcelRequire("gNStA");

var $kk6FJ = parcelRequire("kk6FJ");

var $6Z2mh = parcelRequire("6Z2mh");

var $hWAe2 = parcelRequire("hWAe2");

var $lfnsv = parcelRequire("lfnsv");

var $lJ1FP = parcelRequire("lJ1FP");

var $4R6GH = parcelRequire("4R6GH");

var $dCThw = parcelRequire("dCThw");
const $bbc84ec66ce4b2fd$export$44cb11fe4ca053f8 = (0, $7NszV.createEntry)((0, $kk6FJ.jsmBoardRoute), ()=>({
        group: 'servicedesk',
        component: (0, $dCThw.ServicedeskBoard),
        layout: (0, $6Z2mh.serviceProjectLayout),
        skeleton: (0, $hWAe2.ClassicBoardSkeleton),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $dCThw.LazyServicedeskBoard),
            (0, $dCThw.LazyServicedeskLegacyBoardSettings),
            (0, $dCThw.LazyBoardSettings)
        ],
        perfMetricKey: 'servicedesk-boards-load',
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $6hJYB.AsyncViewsNav)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>!false, (0, $f7Y15.uifBoardResource)),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_views_configuration_migration'), (0, $lJ1FP.getEditModelResource)()),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_views_configuration_migration'), (0, $lfnsv.getBoardDetailsResource)()),
            (0, $dxCvy.projectContextResource)
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("6hJYB", function(module, exports) {

$parcel$export(module.exports, "AsyncViewsNav", () => $7a169ab056601f38$export$b43adc74b6a33bde);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $7a169ab056601f38$var$LazyViewsNav = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("hmeBm")).then(({ ViewsBaseNav: ViewsBaseNav })=>ViewsBaseNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/views/src/ui/index.tsx"
});
const $7a169ab056601f38$export$b43adc74b6a33bde = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "horizontal-jsm-views-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7a169ab056601f38$var$LazyViewsNav, null));

});
parcelRegister("hmeBm", function(module, exports) {

let $ca2fd14e0c4b2e8e$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ca2fd14e0c4b2e8e$var$load("ffQaD"),
    $ca2fd14e0c4b2e8e$var$load("kvRbA"),
    $ca2fd14e0c4b2e8e$var$load("cygJy")
]).then(()=>parcelRequire('l1Z7j'));

});


parcelRegister("kk6FJ", function(module, exports) {

$parcel$export(module.exports, "jsmBoardRoute", () => $f1ec4cbb5ae8c6af$export$a192088aab559fa1);
const $f1ec4cbb5ae8c6af$export$a192088aab559fa1 = {
    path: '/jira/servicedesk/projects/:projectKey/boards/:boardId',
    name: 'servicedesk-boards',
    exact: true
};

});

parcelRegister("dCThw", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskBoard", () => $2b6a3552fb449509$export$bb5ed4e7838cf30c);
$parcel$export(module.exports, "LazyBoardSettings", () => $2b6a3552fb449509$export$45bb2963a11a5163);
$parcel$export(module.exports, "LazyServicedeskLegacyBoardSettings", () => $2b6a3552fb449509$export$6828c4b2d0ff0d5d);
$parcel$export(module.exports, "ServicedeskBoard", () => $2b6a3552fb449509$export$f058c0d1561d67f3);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $7tQej = parcelRequire("7tQej");

var $4R6GH = parcelRequire("4R6GH");

const $2b6a3552fb449509$export$bb5ed4e7838cf30c = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("8Kntq"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/board/src/index.tsx"
});

const $2b6a3552fb449509$export$45bb2963a11a5163 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("53HHW")).then((module)=>module.ServicedeskBoardSettingsAppLayout)), {
    moduleId: "./src/packages/spa-apps/servicedesk/board-settings/src/ui/index.tsx"
});

const $2b6a3552fb449509$export$6828c4b2d0ff0d5d = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("1DU5s"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/legacy-board-settings/src/index.tsx"
});
const $2b6a3552fb449509$export$f058c0d1561d67f3 = (props)=>{
    const { route: route, query: query } = props;
    if (route.name !== 'servicedesk-boards') return null;
    const allowedConfigurations = [
        'columns',
        'filter',
        'quickFilters',
        'swimlanes',
        'cardColors',
        'cardLayout',
        'dateFields'
    ];
    if (query.config && !allowedConfigurations.includes(query.config) && !(0, $4R6GH.fg)('jsm_views_configuration_migration')) {
        const { config: config, ...restQuery } = query;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: {
                pathname: props.location.pathname,
                hash: '',
                search: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
                    ...restQuery,
                    config: 'columns'
                })
            }
        });
    }
    return query.config ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $4R6GH.fg)('jsm_views_configuration_migration') ? $2b6a3552fb449509$export$45bb2963a11a5163 : $2b6a3552fb449509$export$6828c4b2d0ff0d5d,
        pageId: (0, $4R6GH.fg)('jsm_views_configuration_migration') ? 'spa-apps/servicedesk/boards/board-settings' : 'spa-apps/servicedesk/boards/legacy-board-settings',
        shouldShowSpinner: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2b6a3552fb449509$export$bb5ed4e7838cf30c,
        pageId: "spa-apps/servicedesk/boards/board",
        shouldShowSpinner: true
    });
};

});
parcelRegister("53HHW", function(module, exports) {

let $3aef22fbbcee9dc2$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $3aef22fbbcee9dc2$var$load("ffQaD"),
    $3aef22fbbcee9dc2$var$load("kvRbA"),
    $3aef22fbbcee9dc2$var$load("45MRb")
]).then(()=>parcelRequire('as6Z6'));

});

parcelRegister("1DU5s", function(module, exports) {

let $1324f0b2e2f8d66a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1324f0b2e2f8d66a$var$load("2CgvA").then(()=>parcelRequire('lWiJj'));

});



parcelRegister("eoIQt", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubAllArticlesRouteEntry", () => $a340d83cd9968ce2$export$5b55251966102ec);

var $ffza4 = parcelRequire("ffza4");

var $jIAHH = parcelRequire("jIAHH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $2qMD5 = parcelRequire("2qMD5");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $fThMI = parcelRequire("fThMI");

var $bbBli = parcelRequire("bbBli");
const $a340d83cd9968ce2$export$5b55251966102ec = (0, $7NszV.createEntry)((0, $2qMD5.knowledgeHubAllArticlesRoute), ()=>({
        group: 'servicedesk',
        component: (0, $bbBli.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $jIAHH.AsyncKbNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bbBli.LazyServicedeskKnowledgeHubBrowseAllArticles)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).KB_BROWSE_ARTICLES,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).KB_BROWSE_ARTICLES),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("jIAHH", function(module, exports) {

$parcel$export(module.exports, "AsyncKbNav", () => $22359123c06ce2f3$export$223f755b7799fe02);

var $5uXOq = parcelRequire("5uXOq");

var $hYRTO = parcelRequire("hYRTO");

var $b71gk = parcelRequire("b71gk");

var $kxZPA = parcelRequire("kxZPA");

const $22359123c06ce2f3$var$LazyKbNav = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("cPLH9")).then(({ KnowledgeBaseNav: KnowledgeBaseNav })=>KnowledgeBaseNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/knowledge-base/src/ui/index.tsx"
});
const $22359123c06ce2f3$export$223f755b7799fe02 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "horizontal-jsm-kb-nav",
        packageName: "jira-horizontal-nav-jsm-knowledge-base"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hYRTO.default), {
        name: "horizontal-jsm-kb-nav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($22359123c06ce2f3$var$LazyKbNav, null)));
};

});
parcelRegister("cPLH9", function(module, exports) {

let $957f3eac6085a22a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $957f3eac6085a22a$var$load("1uDyI").then(()=>parcelRequire('gaKUF'));

});


parcelRegister("2qMD5", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubAllArticlesRoute", () => $0168703d3ad589b1$export$20e57a83f181da7b);
const $0168703d3ad589b1$export$20e57a83f181da7b = {
    name: 'knowledge-hub-all-articles',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/browse/page/:pageId'
};

});

parcelRegister("fThMI", function(module, exports) {

$parcel$export(module.exports, "getKnowledgeHubResources", () => $885fe963549c17bc$export$5421e48e728c449f);

var $bjZiV = parcelRequire("bjZiV");

var $fpjJX = parcelRequire("fpjJX");
const $885fe963549c17bc$export$5421e48e728c449f = ()=>[
        ...(0, $fpjJX.getServicedeskPageContextResources)(),
        (0, $bjZiV.kbConfluenceContextResource)
    ];

});

parcelRegister("bbBli", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskKnowledgeHubBrowseAllArticles", () => $7877fae2c22be3a0$export$c73ba7e80a805fb2);
$parcel$export(module.exports, "default", () => $7877fae2c22be3a0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $7877fae2c22be3a0$export$c73ba7e80a805fb2 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("3nAwU"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-browse-all-articles/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7877fae2c22be3a0$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $7877fae2c22be3a0$export$c73ba7e80a805fb2,
        pageId: "spa-apps/servicedesk/knowledge-hub/browse-all-articles",
        shouldShowSpinner: true
    });

});
parcelRegister("3nAwU", function(module, exports) {

let $275fdb286b88be0d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $275fdb286b88be0d$var$load("ffQaD"),
    $275fdb286b88be0d$var$load("kvRbA"),
    $275fdb286b88be0d$var$load("fliVL"),
    $275fdb286b88be0d$var$load("blv8l")
]).then(()=>parcelRequire('4uyp4'));

});



parcelRegister("kTgg2", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubArticleEmbedEditorRouteEntry", () => $a9203ca39324e16d$export$513e093ef937dc06);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $lBeuR = parcelRequire("lBeuR");

var $6Z2mh = parcelRequire("6Z2mh");

var $fThMI = parcelRequire("fThMI");

var $aNjVS = parcelRequire("aNjVS");
const $a9203ca39324e16d$export$513e093ef937dc06 = (0, $7NszV.createEntry)((0, $lBeuR.knowledgeHubArticleEmbedEditorRoute), ()=>({
        group: 'servicedesk',
        component: (0, $aNjVS.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aNjVS.LazyServiceDeskKnowledgeArticleEmbedEditor)
        ],
        perfMetricKey: 'service-management.knowledge.ep-editor'
    }));

});
parcelRegister("lBeuR", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubArticleEmbedEditorRoute", () => $e0250c214f5345c0$export$bd512c426b095693);
const $e0250c214f5345c0$export$bd512c426b095693 = {
    name: 'kb-article-embed-editor',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/space/:spaceKey/articles/:articleId/edit',
    query: [
        'draftShareId?',
        'topicId?'
    ]
};

});

parcelRegister("aNjVS", function(module, exports) {

$parcel$export(module.exports, "LazyServiceDeskKnowledgeArticleEmbedEditor", () => $398a28a595927246$export$35c6d2a033ef4c42);
$parcel$export(module.exports, "default", () => $398a28a595927246$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $398a28a595927246$export$35c6d2a033ef4c42 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("4o4Nf"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-article-embed-editor/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$398a28a595927246$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $398a28a595927246$export$35c6d2a033ef4c42,
        pageId: "knowledge-article-embed-editor",
        shouldShowSpinner: true
    });

});
parcelRegister("4o4Nf", function(module, exports) {

let $331d1f3196a75a77$var$load = (parcelRequire("28QjX"))(4);
module.exports = $331d1f3196a75a77$var$load("5D8Fc").then(()=>parcelRequire('l54tv'));

});



parcelRegister("agsO7", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubArticleInCategoryRouteEntry", () => $def4faef06d1a61c$export$a67199ebb12b0f7f);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $4BJB2 = parcelRequire("4BJB2");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $fThMI = parcelRequire("fThMI");

var $809cs = parcelRequire("809cs");
const $def4faef06d1a61c$export$a67199ebb12b0f7f = (0, $7NszV.createEntry)((0, $4BJB2.knowledgeHubArticleInCategoryRoute), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.knowledge.article',
        component: (0, $809cs.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $809cs.LazyServicedeskKnowledgeHubViewArticle)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).KB_VIEW_ARTICLE,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).KB_VIEW_ARTICLE),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("4BJB2", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubArticleInCategoryRoute", () => $cafdb26099846497$export$3afe8482ce820835);
const $cafdb26099846497$export$3afe8482ce820835 = {
    name: 'knowledge-hub-article-in-category',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId/articles/:articleId'
};

});

parcelRegister("809cs", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskKnowledgeHubViewArticle", () => $8c5dbaffda117c43$export$efd0ec49853aa81);
$parcel$export(module.exports, "default", () => $8c5dbaffda117c43$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $8c5dbaffda117c43$export$efd0ec49853aa81 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("8D4Zf"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-view-article/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8c5dbaffda117c43$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8c5dbaffda117c43$export$efd0ec49853aa81,
        pageId: "spa-apps/servicedesk/knowledge-hub/view-article",
        shouldShowSpinner: true
    });

});
parcelRegister("8D4Zf", function(module, exports) {

let $6485d5848d0fa743$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6485d5848d0fa743$var$load("75vrF").then(()=>parcelRequire('MNfxH'));

});



parcelRegister("9y8sW", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubBrowseAllArticlesRouteEntry", () => $4c224bc59177653b$export$de40c949b963d9e);

var $ffza4 = parcelRequire("ffza4");

var $jIAHH = parcelRequire("jIAHH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $coVHe = parcelRequire("coVHe");

var $gNStA = parcelRequire("gNStA");

var $9D0RM = parcelRequire("9D0RM");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $c04PQ = parcelRequire("c04PQ");

var $fThMI = parcelRequire("fThMI");

var $bbBli = parcelRequire("bbBli");
const $4c224bc59177653b$export$de40c949b963d9e = (0, $7NszV.createEntry)((0, $9D0RM.knowledgeHubBrowseAllArticlesRoute), ()=>({
        group: 'servicedesk',
        component: (0, $bbBli.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $jIAHH.AsyncKbNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>!(0, $c04PQ.isFedRamp)(), (0, $coVHe.virtualAgentKnowledgebaseTouchpointResource))
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bbBli.LazyServicedeskKnowledgeHubBrowseAllArticles)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).KB_BROWSE_ARTICLES,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).KB_BROWSE_ARTICLES),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("coVHe", function(module, exports) {

$parcel$export(module.exports, "virtualAgentKnowledgebaseTouchpointResource", () => $b5eb4da6bb86684f$export$1b798e6122168cca);

var $4R6GH = parcelRequire("4R6GH");

var $ao2h1 = parcelRequire("ao2h1");

var $eCMpj = parcelRequire("eCMpj");
const $b5eb4da6bb86684f$export$1b798e6122168cca = (0, $ao2h1.createRelayResource)({
    type: 'SERVICEDESK_VIRTUAL_AGENT_KNOWLEDGE_BASE_TOUCHPOINT',
    isBrowserOnly: true,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $eCMpj.default),
            variables: {
                cloudId: tenantContext.cloudId,
                key: match.params.projectKey || '',
                checkForAiEnabledFF: (0, $4R6GH.fg)('require_ai_enabled_for_jsm_virtual_agent')
            }
        })
});

});
parcelRegister("eCMpj", function(module, exports) {

$parcel$export(module.exports, "default", () => $0111b96d105a115c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d286ede3f2edeee466a0bd65055c253b>>
 * @relayHash 7555a82a51148c607a64f1ab7402dfed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a066b2d28ec980806bb63d852e0abfc11a1a1a5c90904f798db2d9030dc7252b
const $0111b96d105a115c$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a066b2d28ec980806bb63d852e0abfc11a1a1a5c90904f798db2d9030dc7252b",
        "metadata": {},
        "name": "mainVirtualServiceAgentCtaCardQuery",
        "operationKind": "query",
        "text": null
    }
};
var $0111b96d105a115c$export$2e2bcd8739ae039 = $0111b96d105a115c$var$node;

});


parcelRegister("9D0RM", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubBrowseAllArticlesRoute", () => $ef3c5487d473c383$export$c8e99e3434791c0e);
const $ef3c5487d473c383$export$c8e99e3434791c0e = {
    name: 'knowledge-hub-browse-all-articles',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/articles',
    exact: true
};

});


parcelRegister("825dq", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubBrowseAllCategoriesRouteEntry", () => $578b57d26acf701a$export$dd6c99863524ee59);

var $ffza4 = parcelRequire("ffza4");

var $jIAHH = parcelRequire("jIAHH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $90PHJ = parcelRequire("90PHJ");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $fThMI = parcelRequire("fThMI");

var $fDsbI = parcelRequire("fDsbI");
const $578b57d26acf701a$export$dd6c99863524ee59 = (0, $7NszV.createEntry)((0, $90PHJ.knowledgeHubBrowseAllCategoriesRoute), ()=>({
        group: 'servicedesk',
        component: (0, $fDsbI.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $jIAHH.AsyncKbNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $fDsbI.LazyServicedeskKnowledgeHubBrowseAllCategories)
        ],
        perfMetricKey: 'service-management.kb-categories',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).KB_BROWSE_CATEGORIES,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).KB_BROWSE_CATEGORIES),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("90PHJ", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubBrowseAllCategoriesRoute", () => $74299e4842369ef4$export$256f841794b3f077);
const $74299e4842369ef4$export$256f841794b3f077 = {
    name: 'knowledge-hub-browse-all-categories',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/categories',
    exact: true
};

});

parcelRegister("fDsbI", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskKnowledgeHubBrowseAllCategories", () => $0ed31e41bd08d12a$export$a488cba75f18ade8);
$parcel$export(module.exports, "default", () => $0ed31e41bd08d12a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $0ed31e41bd08d12a$export$a488cba75f18ade8 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("5Nh1B"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-browse-all-categories/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0ed31e41bd08d12a$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $0ed31e41bd08d12a$export$a488cba75f18ade8,
        pageId: "spa-apps/servicedesk/knowledge-hub/browse-all-categories",
        shouldShowSpinner: true
    });

});
parcelRegister("5Nh1B", function(module, exports) {

let $437ebc236310cfdb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $437ebc236310cfdb$var$load("7HMQe").then(()=>parcelRequire('dseQM'));

});



parcelRegister("h8swE", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubBrowseViewArticleRouteEntry", () => $4bb5aab980a1ec0f$export$abb9cdffbf5c943b);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $8p1m6 = parcelRequire("8p1m6");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $fThMI = parcelRequire("fThMI");

var $809cs = parcelRequire("809cs");
const $4bb5aab980a1ec0f$export$abb9cdffbf5c943b = (0, $7NszV.createEntry)((0, $8p1m6.knowledgeHubBrowseViewArticleRoute), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.knowledge.article',
        component: (0, $809cs.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $809cs.LazyServicedeskKnowledgeHubViewArticle)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).KB_VIEW_ARTICLE,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).KB_VIEW_ARTICLE),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("8p1m6", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubBrowseViewArticleRoute", () => $43d5800a4cfdec2f$export$ef8a9ec2979d1b10);
const $43d5800a4cfdec2f$export$ef8a9ec2979d1b10 = {
    name: 'knowledge-hub-browse-view-article',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/articles/:articleId'
};

});


parcelRegister("gGQIR", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubCategoryPageRouteEntry", () => $298d9707a87dc987$export$464b24032c2aeb02);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $8WB8S = parcelRequire("8WB8S");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $fThMI = parcelRequire("fThMI");

var $7EGTo = parcelRequire("7EGTo");
const $298d9707a87dc987$export$464b24032c2aeb02 = (0, $7NszV.createEntry)((0, $8WB8S.knowledgeHubCategoryPageRoute), ()=>({
        group: 'servicedesk',
        component: (0, $7EGTo.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7EGTo.LazyServicedeskKnowledgeHubCategory)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).KB_CATEGORY,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).KB_CATEGORY),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("8WB8S", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubCategoryPageRoute", () => $4f0b06054e994db5$export$79fb48a07e43639a);
const $4f0b06054e994db5$export$79fb48a07e43639a = {
    name: 'knowledge-hub-category-page',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId/browse/page/:pageId'
};

});

parcelRegister("7EGTo", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskKnowledgeHubCategory", () => $cbedf43cff0d751d$export$c01a896b8d33aa9c);
$parcel$export(module.exports, "default", () => $cbedf43cff0d751d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $cbedf43cff0d751d$export$c01a896b8d33aa9c = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("d5eX1"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-category/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cbedf43cff0d751d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cbedf43cff0d751d$export$c01a896b8d33aa9c,
        pageId: "spa-apps/servicedesk/knowledge-hub/category",
        shouldShowSpinner: true
    });

});
parcelRegister("d5eX1", function(module, exports) {

let $986756eebe73f0f7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $986756eebe73f0f7$var$load("4oq8D").then(()=>parcelRequire('lE3ki'));

});



parcelRegister("01hnS", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubCategoryRouteEntry", () => $2e1862f21e7b949b$export$416d7b87b4f3205e);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $k4nQf = parcelRequire("k4nQf");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $fThMI = parcelRequire("fThMI");

var $7EGTo = parcelRequire("7EGTo");
const $2e1862f21e7b949b$export$416d7b87b4f3205e = (0, $7NszV.createEntry)((0, $k4nQf.knowledgeHubCategoryRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.knowledge.category',
        component: (0, $7EGTo.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7EGTo.LazyServicedeskKnowledgeHubCategory)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).KB_CATEGORY,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).KB_CATEGORY),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("k4nQf", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubCategoryRoute", () => $874cf8128fc31da0$export$69ed5b0214ea6ee5);
const $874cf8128fc31da0$export$69ed5b0214ea6ee5 = {
    name: 'knowledge-hub-category',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId'
};

});


parcelRegister("8jDeK", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubDraftsRouteEntry", () => $9ba3413d02e7079e$export$4da743c0d13c2cfc);

var $ffza4 = parcelRequire("ffza4");

var $jIAHH = parcelRequire("jIAHH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $bltfg = parcelRequire("bltfg");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $fThMI = parcelRequire("fThMI");

var $2KDj2 = parcelRequire("2KDj2");
const $9ba3413d02e7079e$export$4da743c0d13c2cfc = (0, $7NszV.createEntry)((0, $bltfg.knowledgeHubDraftsRoute), ()=>({
        group: 'servicedesk',
        component: (0, $2KDj2.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $jIAHH.AsyncKbNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $2KDj2.LazyServicedeskKnowledgeHubDrafts)
        ],
        perfMetricKey: 'service-management.kb-drafts',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).KB_DRAFTS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).KB_DRAFTS),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("bltfg", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubDraftsRoute", () => $9a661013d8f5290f$export$670f3b59aa55b7ae);
const $9a661013d8f5290f$export$670f3b59aa55b7ae = {
    name: 'knowledge-hub-drafts',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/drafts',
    exact: true
};

});

parcelRegister("2KDj2", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskKnowledgeHubDrafts", () => $e2e95eba21898c94$export$53decb9d1eb60aed);
$parcel$export(module.exports, "default", () => $e2e95eba21898c94$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $e2e95eba21898c94$export$53decb9d1eb60aed = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("cxABR"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-drafts/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e2e95eba21898c94$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e2e95eba21898c94$export$53decb9d1eb60aed,
        pageId: "spa-apps/servicedesk/knowledge-hub/drafts",
        shouldShowSpinner: true
    });

});
parcelRegister("cxABR", function(module, exports) {

let $9214f70393226531$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9214f70393226531$var$load("fliVL"),
    $9214f70393226531$var$load("2BkWv")
]).then(()=>parcelRequire('kl4T5'));

});



parcelRegister("64Uyh", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubLandingRouteEntry", () => $cd1258ca8f7bcdbf$export$671687d85e096e5b);

var $ffza4 = parcelRequire("ffza4");

var $jIAHH = parcelRequire("jIAHH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $bMJcR = parcelRequire("bMJcR");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $fThMI = parcelRequire("fThMI");

var $fWD3P = parcelRequire("fWD3P");
const $cd1258ca8f7bcdbf$export$671687d85e096e5b = (0, $7NszV.createEntry)((0, $bMJcR.knowledgeHubLandingRoute), ()=>({
        group: 'servicedesk',
        component: (0, $fWD3P.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $jIAHH.AsyncKbNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $fWD3P.LazyServicedeskKnowledgeHubLanding)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).KB_LANDING,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).KB_LANDING),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("bMJcR", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubLandingRoute", () => $5a3037062b8f539c$export$239eaf6a202e0f54);
const $5a3037062b8f539c$export$239eaf6a202e0f54 = {
    name: 'knowledge-hub-landing',
    path: '/jira/servicedesk/projects/:projectKey/knowledge',
    exact: true
};

});

parcelRegister("fWD3P", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskKnowledgeHubLanding", () => $f59132c22330e6a8$export$f1266a588cfc310b);
$parcel$export(module.exports, "default", () => $f59132c22330e6a8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $f59132c22330e6a8$export$f1266a588cfc310b = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("1Zkwy")), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-landing/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f59132c22330e6a8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f59132c22330e6a8$export$f1266a588cfc310b,
        pageId: "spa-apps/servicedesk/knowledge-hub/landing-page",
        shouldShowSpinner: true
    });

});
parcelRegister("1Zkwy", function(module, exports) {

let $172b689f35489cc1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $172b689f35489cc1$var$load("fg7LP").then(()=>parcelRequire('baJ3W'));

});



parcelRegister("1T4J3", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubSearchRouteEntry", () => $1f2e00b6e54dbec2$export$49337a3cc2431ae5);

var $ffza4 = parcelRequire("ffza4");

var $jIAHH = parcelRequire("jIAHH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $5PTSS = parcelRequire("5PTSS");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $fThMI = parcelRequire("fThMI");

var $809cs = parcelRequire("809cs");
const $1f2e00b6e54dbec2$export$49337a3cc2431ae5 = (0, $7NszV.createEntry)((0, $5PTSS.knowledgeHubSearchRoute), ()=>({
        group: 'servicedesk',
        component: (0, $809cs.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $jIAHH.AsyncKbNav),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $809cs.LazyServicedeskKnowledgeHubViewArticle)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).KB_VIEW_ARTICLE,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).KB_VIEW_ARTICLE),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("5PTSS", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubSearchRoute", () => $27dc0fd67ac82331$export$a47c36fb081b544d);
const $27dc0fd67ac82331$export$a47c36fb081b544d = {
    name: 'knowledge-hub-search',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/search/articles/:articleId'
};

});


parcelRegister("8hATp", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubSetupRouteEntry", () => $fa00eaf494d4bfab$export$b220f8194ee7c231);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $5jG9Z = parcelRequire("5jG9Z");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $fThMI = parcelRequire("fThMI");

var $1iNof = parcelRequire("1iNof");
const $fa00eaf494d4bfab$export$b220f8194ee7c231 = (0, $7NszV.createEntry)((0, $5jG9Z.knowledgeHubSetupRoute), ()=>({
        group: 'servicedesk',
        component: (0, $1iNof.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $1iNof.LazyServicedeskKnowledgeHubSetup)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).KB_SETUP,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).KB_SETUP),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("5jG9Z", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubSetupRoute", () => $598bde1f568a466c$export$f20770545704547d);
const $598bde1f568a466c$export$f20770545704547d = {
    name: 'knowledge-hub-setup',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/setup'
};

});

parcelRegister("1iNof", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskKnowledgeHubSetup", () => $4cd10b3eae0d5ed2$export$6c08040d2dc71e43);
$parcel$export(module.exports, "default", () => $4cd10b3eae0d5ed2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $4cd10b3eae0d5ed2$export$6c08040d2dc71e43 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("3KWG5")), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-setup/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4cd10b3eae0d5ed2$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $4cd10b3eae0d5ed2$export$6c08040d2dc71e43,
        pageId: "spa-apps/servicedesk/knowledge-hub/setup",
        shouldShowSpinner: true
    });

});
parcelRegister("3KWG5", function(module, exports) {

let $2bc32f300c741c0f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2bc32f300c741c0f$var$load("4raVQ").then(()=>parcelRequire('gBJGI'));

});



parcelRegister("lrPAp", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubSuggestedArticlesRouteEntry", () => $0632a084fe67a48e$export$6a7974939bde7d37);

var $ffza4 = parcelRequire("ffza4");

var $jIAHH = parcelRequire("jIAHH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $kO4Z1 = parcelRequire("kO4Z1");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $fThMI = parcelRequire("fThMI");

var $hnJOJ = parcelRequire("hnJOJ");
const $0632a084fe67a48e$export$6a7974939bde7d37 = (0, $7NszV.createEntry)((0, $kO4Z1.knowledgeHubSuggestedArticlesRoute), ()=>({
        group: 'servicedesk',
        component: (0, $hnJOJ.ServiceDeskKnowledgeHubSuggestedArticles),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $jIAHH.AsyncKbNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hnJOJ.LazyServicedeskKnowledgeHubSuggestedArticles)
        ],
        perfMetricKey: 'service-management.kb-suggested-articles',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).KB_SUGGESTED_ARTICLES,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).KB_SUGGESTED_ARTICLES),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("kO4Z1", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubSuggestedArticlesRoute", () => $8f32a5b26dce9533$export$54edf5cef1c6b21b);
const $8f32a5b26dce9533$export$54edf5cef1c6b21b = {
    name: 'knowledge-hub-suggested-topics',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/suggested-topics',
    exact: true
};

});

parcelRegister("hnJOJ", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskKnowledgeHubSuggestedArticles", () => $70c4d3c688caba8c$export$aee7d96c2ee4c388);
$parcel$export(module.exports, "ServiceDeskKnowledgeHubSuggestedArticles", () => $70c4d3c688caba8c$export$ee4623542ebd573e);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $2WqFA = parcelRequire("2WqFA");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $70c4d3c688caba8c$export$aee7d96c2ee4c388 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("5lY7i"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-suggested-articles/src/index.tsx"
});
const $70c4d3c688caba8c$export$ee4623542ebd573e = ()=>{
    const { data: isAdminHubAIEnabled, loading: loading, error: error, fetchAIEnablement: fetchAIEnablement } = (0, $2WqFA.default)('jira-servicedesk');
    const showSuggestedTopics = !loading && !error && isAdminHubAIEnabled && (0, $4R6GH.fg)('jsm-suggested-articles-in-kb');
    (0, $5uXOq.useEffect)(()=>{
        (0, $4R6GH.fg)('jsm-suggested-articles-in-kb') && fetchAIEnablement();
    }, [
        fetchAIEnablement
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, showSuggestedTopics && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $70c4d3c688caba8c$export$aee7d96c2ee4c388,
        pageId: "spa-apps/servicedesk/knowledge-hub/suggested-articles",
        shouldShowSpinner: true
    }));
};

});
parcelRegister("2WqFA", function(module, exports) {

$parcel$export(module.exports, "default", () => $18bf020f3f366501$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $29jfS = parcelRequire("29jfS");
const $18bf020f3f366501$var$useIsAdminHubAIEnabled = (jiraProduct, version)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isAdminHubAiToggleEnabled, setIsAdminHubAiToggleEnabled] = (0, $5uXOq.useState)(null);
    const [loading, setLoading] = (0, $5uXOq.useState)(true);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const fetchData = (0, $5uXOq.useCallback)(async ()=>{
        setLoading(true);
        setError(null);
        try {
            const response = await (0, $29jfS.fetchAiEnablement)(jiraProduct, version);
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchAiEnablementStatus succeeded');
            setIsAdminHubAiToggleEnabled(response.isEnabled);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setError(err);
            (0, $jcw0u.default)({
                error: err,
                meta: {
                    id: 'fetchAiEnablementStatus failed'
                }
            });
        } finally{
            setLoading(false);
        }
    }, [
        createAnalyticsEvent,
        jiraProduct,
        version
    ]);
    return {
        data: isAdminHubAiToggleEnabled,
        loading: loading,
        error: error,
        fetchAIEnablement: fetchData
    };
};
var $18bf020f3f366501$export$2e2bcd8739ae039 = $18bf020f3f366501$var$useIsAdminHubAIEnabled;

});
parcelRegister("29jfS", function(module, exports) {

$parcel$export(module.exports, "fetchAiEnablement", () => $f8e2a461a4c2e420$export$ad4105850d0ce824);

var $7f4tk = parcelRequire("7f4tk");
const $f8e2a461a4c2e420$export$2171a423b572256a = (jiraProduct, version = '1')=>`/rest/api/${version}/aiconfig/ai-enabled/${jiraProduct}`;
const $f8e2a461a4c2e420$export$ad4105850d0ce824 = (jiraProduct, version = '1')=>{
    const url = $f8e2a461a4c2e420$export$2171a423b572256a(jiraProduct, version);
    return (0, $7f4tk.default)(url, {
        method: 'GET'
    });
};

});


parcelRegister("5lY7i", function(module, exports) {

let $3e5d8bd6ae283e17$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3e5d8bd6ae283e17$var$load("hNNyi").then(()=>parcelRequire('hY7nq'));

});



parcelRegister("ceMKm", function(module, exports) {

$parcel$export(module.exports, "landingPageRouteEntry", () => $6f350a9dc34d5147$export$8ccc5b384e778bac);

var $c04PQ = parcelRequire("c04PQ");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $iXFkh = parcelRequire("iXFkh");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $7pflU = parcelRequire("7pflU");

var $lkFvK = parcelRequire("lkFvK");

var $8cTxW = parcelRequire("8cTxW");

var $k6R7C = parcelRequire("k6R7C");
const $6f350a9dc34d5147$var$landingPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $8cTxW.landingEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $6f350a9dc34d5147$export$8ccc5b384e778bac = (0, $7NszV.createEntry)((0, $iXFkh.landingPageRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $c04PQ.isFedRamp)()) return undefined;
            return $6f350a9dc34d5147$var$landingPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $k6R7C.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $7pflU.VirtualAgentLandingSkeleton),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_SETTINGS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_SETTINGS),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }));

});
parcelRegister("7pflU", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentLandingSkeleton", () => $450c0f05e134cd5f$export$f4b71d7b732df8a7);
/* VirtualAgentLandingSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $azvva = parcelRequire("azvva");
const $450c0f05e134cd5f$var$customStyles = null;
const $450c0f05e134cd5f$export$f4b71d7b732df8a7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($azvva))),
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("azvva", function(module, exports) {
module.exports = new URL("virtual-agent-landing-app-skeleton.tpl.e8a7897b.svg", import.meta.url).toString();

});


parcelRegister("8cTxW", function(module, exports) {

$parcel$export(module.exports, "landingEntryPoint", () => $0f9dae747ed8bf8a$export$ad927ca7512a3a01);

var $9uqwu = parcelRequire("9uqwu");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");
const $0f9dae747ed8bf8a$var$DEFAULT_TIME_RANGE_MS = 604800000; // 7 days
const $0f9dae747ed8bf8a$var$formatFetchDate = (date)=>date.toISOString().substring(0, 10); // has to be truncated for proper caching in SSR

const $0f9dae747ed8bf8a$export$ad927ca7512a3a01 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("ar6kv")), {
        moduleId: "06d84010",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $9uqwu.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        startDate: $0f9dae747ed8bf8a$var$formatFetchDate(new Date(Date.now() - $0f9dae747ed8bf8a$var$DEFAULT_TIME_RANGE_MS)),
                        endDate: $0f9dae747ed8bf8a$var$formatFetchDate(new Date())
                    }
                }
            }
        })
});

});
parcelRegister("9uqwu", function(module, exports) {

$parcel$export(module.exports, "default", () => $588c29ffd4ee84e7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0a78bf4eb73312f253425641b6e6edd1>>
 * @relayHash 48cac63f50e3e62073c3fa83bcb82928
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 74dc4e4e81ad0cb8dd6227a0472c8046ac651d7f53b2154358897ce22af9ad1f

var $7oHmH = parcelRequire("7oHmH");

var $fzDI5 = parcelRequire("fzDI5");

var $gnNIl = parcelRequire("gnNIl");
const $588c29ffd4ee84e7$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "74dc4e4e81ad0cb8dd6227a0472c8046ac651d7f53b2154358897ce22af9ad1f",
        "metadata": {},
        "name": "srcVirtualAgentLandingQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvastatusheaderrelayprovider": (0, $gnNIl.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvanextstepsrelayprovider": (0, $fzDI5.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $7oHmH.default)
        }
    }
};
var $588c29ffd4ee84e7$export$2e2bcd8739ae039 = $588c29ffd4ee84e7$var$node;

});
parcelRegister("fzDI5", function(module, exports) {

$parcel$export(module.exports, "default", () => $485bf838f346a5c9$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $485bf838f346a5c9$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('show-next-steps-on-vsa-performance-page');
    }
};

});

parcelRegister("gnNIl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1a08e53932eeb60$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $f1a08e53932eeb60$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jsm_va_status_header');
    }
};

});


parcelRegister("ar6kv", function(module, exports) {

let $799155f580cf3354$var$load = (parcelRequire("28QjX"))(4);
module.exports = $799155f580cf3354$var$load("9eM0F").then(()=>parcelRequire('52WYW'));

});



parcelRegister("43Rln", function(module, exports) {

$parcel$export(module.exports, "legacyPlanPageRedirectRouteEntry", () => $10eae15c25a3521c$export$e9cfdb950d40e917);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $4e0eu = parcelRequire("4e0eu");

var $3ibi7 = parcelRequire("3ibi7");

var $g6wgl = parcelRequire("g6wgl");
const $10eae15c25a3521c$export$e9cfdb950d40e917 = (0, $7NszV.createEntry)((0, $4e0eu.legacyPlanPageRedirectRoute), ()=>({
        group: 'software',
        component: (0, $3ibi7.RedirectLegacyPlanPage),
        isRedirect: true,
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $c3WQb.advancedRoadmapsScenarioIdResource)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $g6wgl.LazyPlanTimeline)
        ]
    }));

});
parcelRegister("4e0eu", function(module, exports) {

$parcel$export(module.exports, "legacyPlanPageRedirectRoute", () => $72e984bd321d5543$export$1e324bd9675918a8);
const $72e984bd321d5543$export$1e324bd9675918a8 = {
    name: 'software-advanced-roadmaps-redirect',
    path: '/secure/PortfolioPlanView.jspa'
};

});

parcelRegister("3ibi7", function(module, exports) {

$parcel$export(module.exports, "RedirectLegacyPlanPage", () => $3e6624904a2f18eb$export$c3e4fda2290a52bf);
$parcel$export(module.exports, "RedirectPlanPageWithoutScenarioId", () => $3e6624904a2f18eb$export$ff420400c9900835);
$parcel$export(module.exports, "RedirectPlanPageWithoutScenarioIdLoadQuery", () => $3e6624904a2f18eb$export$e57364775e9e9634);

var $697YZ = parcelRequire("697YZ");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $kb4zh = parcelRequire("kb4zh");

var $c3WQb = parcelRequire("c3WQb");

var $ds5qV = parcelRequire("ds5qV");

var $5W2CW = parcelRequire("5W2CW");

var $2YP9W = parcelRequire("2YP9W");
var $doZTA = parcelRequire("doZTA");

var $697YZ = parcelRequire("697YZ");

var $9OXo1 = parcelRequire("9OXo1");
const $3e6624904a2f18eb$var$PERSIST_SEARCH_PARAMS = [
    'search'
];
const $3e6624904a2f18eb$var$RedirectLegacyPlanPageWithoutScenarioId = ()=>{
    const [{ query: query }] = (0, $doZTA.useRouter)();
    const { data: data, loading: loading } = (0, $2YP9W.useResource)((0, $c3WQb.advancedRoadmapsScenarioIdResource));
    if (loading || data === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: `/jira/plans/${query.id}/scenarios/${data.scenarioId}`,
        persistSearchParams: $3e6624904a2f18eb$var$PERSIST_SEARCH_PARAMS
    });
};
const $3e6624904a2f18eb$export$c3e4fda2290a52bf = ()=>{
    const [{ query: query }] = (0, $doZTA.useRouter)();
    const { id: id, sid: sid } = query;
    if (Number.isNaN(Number.parseFloat(sid))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3e6624904a2f18eb$var$RedirectLegacyPlanPageWithoutScenarioId, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: `/jira/plans/${id}/scenarios/${sid}`,
        persistSearchParams: $3e6624904a2f18eb$var$PERSIST_SEARCH_PARAMS
    });
};
const $3e6624904a2f18eb$export$ff420400c9900835 = ()=>{
    const [{ match: match }] = (0, $doZTA.useRouter)();
    const { planId: planId } = match.params;
    if (planId === null || planId === undefined || Number.isNaN(Number.parseFloat(planId))) throw new Error('Plan cannot be loaded without planId');
    const { data: data, loading: loading } = (0, $2YP9W.useResource)((0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource));
    if (loading || data === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null);
    if (!data.success) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5W2CW.ErrorScreen), {
        errorMessage: data.errorMessage
    });
    if (data.scenarioId === null || data.scenarioId === undefined || typeof data.scenarioId === 'string' && Number.isNaN(Number.parseFloat(data.scenarioId))) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: `/jira/plans/${planId}/scenarios/${data.scenarioId}`,
        persistSearchParams: $3e6624904a2f18eb$var$PERSIST_SEARCH_PARAMS
    });
};
const $3e6624904a2f18eb$export$b2194d886d9f3b64 = ({ queryRef: queryRef, planId: planId })=>{
    const gqlData = (0, $8Uumt.usePreloadedQuery)((0, $697YZ.default), queryRef);
    const { data: data, loading: loading } = (0, $2YP9W.useResource)((0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource));
    const defaultTabUrl = gqlData?.jira?.planById?.defaultNavigationItem?.url;
    if (defaultTabUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: defaultTabUrl,
        persistSearchParams: $3e6624904a2f18eb$var$PERSIST_SEARCH_PARAMS
    });
    // Fallback if can not get defaultTabUrl
    if (loading || data === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null);
    if (!data.success) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5W2CW.ErrorScreen), {
        errorMessage: data.errorMessage
    });
    if (data.scenarioId === null || data.scenarioId === undefined || typeof data.scenarioId === 'string' && Number.isNaN(Number.parseFloat(data.scenarioId))) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: `/jira/plans/${planId}/scenarios/${data.scenarioId}`,
        persistSearchParams: $3e6624904a2f18eb$var$PERSIST_SEARCH_PARAMS
    });
};
const $3e6624904a2f18eb$export$e57364775e9e9634 = ()=>{
    const [{ match: match }] = (0, $doZTA.useRouter)();
    const { planId: planId } = match.params;
    if (planId === null || planId === undefined || Number.isNaN(Number.parseFloat(planId))) throw new Error('Plan cannot be loaded without planId');
    const { cloudId: cloudId, activationId: activationId } = (0, $9OXo1.useTenantContext)();
    const [queryRef, loadQuery, disposeQuery] = (0, $8Uumt.useQueryLoader)((0, $697YZ.default));
    (0, $5uXOq.useEffect)(()=>{
        loadQuery({
            planId: `ari:cloud:jira:${cloudId}:plan/activation/${activationId}/${planId}`
        }, {
            fetchPolicy: 'store-or-network'
        });
        return disposeQuery;
    }, [
        loadQuery,
        disposeQuery,
        cloudId,
        activationId,
        planId
    ]);
    return queryRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3e6624904a2f18eb$export$b2194d886d9f3b64, {
        queryRef: queryRef,
        planId: planId
    }) : null;
};

});
parcelRegister("697YZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $da05f469fe76f276$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<513d91abcf431d67cd831934eb3cdd81>>
 * @relayHash c7ba33b8e7695997c7bbf9e29b42c7ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7b22213e57ba6874b345876f3c35d0dda118f459e6007f6c559d80ba94b6d1fe
const $da05f469fe76f276$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "planId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "planId"
        }
    ], v2 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "JiraNavigationItem",
        "abstractKey": "__isJiraNavigationItem"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "planNoScenarioQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraPlan",
                            "kind": "LinkedField",
                            "name": "planById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "LinkedField",
                                        "name": "defaultNavigationItem",
                                        "plural": false,
                                        "selections": [
                                            v2 /*: any*/ 
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.planById.defaultNavigationItem"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "planNoScenarioQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraPlan",
                            "kind": "LinkedField",
                            "name": "planById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "defaultNavigationItem",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ 
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7b22213e57ba6874b345876f3c35d0dda118f459e6007f6c559d80ba94b6d1fe",
            "metadata": {},
            "name": "planNoScenarioQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$da05f469fe76f276$var$node.hash = "7791279196ac8025a83cda3fc2b29b08";
var $da05f469fe76f276$export$2e2bcd8739ae039 = $da05f469fe76f276$var$node;

});

parcelRegister("5W2CW", function(module, exports) {

$parcel$export(module.exports, "ErrorScreen", () => $50454f3b2d1014d6$export$42f84e610f279c31);

var $5uXOq = parcelRequire("5uXOq");

var $38Y30 = parcelRequire("38Y30");


var $6AaZy = parcelRequire("6AaZy");

var $1v2QX = parcelRequire("1v2QX");

var $jMY1T = parcelRequire("jMY1T");

var $5Bu9u = parcelRequire("5Bu9u");
const $50454f3b2d1014d6$export$42f84e610f279c31 = ({ errorMessage: errorMessage, isEmbedded: isEmbedded = false, planId: planId })=>{
    /**
	 * Clearing the early-preload promises here otherwise they get carried on to the following plan loads.
	 *
	 * The SPA app renders the ErrorScreen instead of the PlanApp when the validation fails,
	 * hence the early-preload promises did not get cleaned up.
	 */ // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage, react-hooks/react-compiler
    delete window.__ARJ_BACKLOG_PROMISE__;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    delete window.__ARJ_INFO_METADATA_PROMISE__;
    switch(errorMessage){
        case 0, $b31dd89598859846$export$aa64437890e7b596:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38Y30.RedirectToLoginPage), null);
        case 0, $b31dd89598859846$export$3fe2400c9d24940d:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6AaZy.AsyncLicenseViolationErrorPage), {
                isEmbedded: isEmbedded
            });
        case 0, $b31dd89598859846$export$4589763db20bfd7f:
        case 0, $b31dd89598859846$export$7e6358a0c21dff8c:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jMY1T.AsyncNotFoundErrorPage), {
                entity: (0, $b31dd89598859846$export$c303e491e026ebc6),
                isEmbedded: isEmbedded
            });
        case 0, $b31dd89598859846$export$6519152a5f0e081:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jMY1T.AsyncNotFoundErrorPage), {
                entity: (0, $b31dd89598859846$export$9b928fc5e710e864),
                isEmbedded: isEmbedded,
                planId: planId
            });
        case 0, $b31dd89598859846$export$6128dc888243fa0a:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1v2QX.AsyncNoPlanPermissionErrorPage), {
                isEmbedded: isEmbedded
            });
        case 0, $b31dd89598859846$export$1f988ace3cbe8975:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Bu9u.AsyncLazyGenericErrorPage), null);
        default:
            return null;
    }
};

});
const $b31dd89598859846$export$aa64437890e7b596 = 'permission-violation';
const $b31dd89598859846$export$3fe2400c9d24940d = 'license-violation';
const $b31dd89598859846$export$4589763db20bfd7f = 'plan-not-found';
const $b31dd89598859846$export$6519152a5f0e081 = 'scenario-not-found';
const $b31dd89598859846$export$7e6358a0c21dff8c = 'report-not-found';
const $b31dd89598859846$export$6128dc888243fa0a = 'no-plan-permission';
const $b31dd89598859846$export$1f988ace3cbe8975 = 'GENERIC';
const $b31dd89598859846$export$c303e491e026ebc6 = 'PLAN';
const $b31dd89598859846$export$9b928fc5e710e864 = 'SCENARIO';

parcelRegister("6AaZy", function(module, exports) {

$parcel$export(module.exports, "AsyncLicenseViolationErrorPage", () => $05d56fdddce8137e$export$f5d9764f07badc4d);

var $5uXOq = parcelRequire("5uXOq");

var $kb4zh = parcelRequire("kb4zh");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $05d56fdddce8137e$var$LazyLicenseViolationErrorPage = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("9aruW")), {
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/error-screens/license-violation/index.tsx"
});
const $05d56fdddce8137e$export$f5d9764f07badc4d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "arj-license-violation-page",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($05d56fdddce8137e$var$LazyLicenseViolationErrorPage, props));

});
parcelRegister("9aruW", function(module, exports) {

let $6aca60c16208ee3b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6aca60c16208ee3b$var$load("dk1NB").then(()=>parcelRequire('cGdIS'));

});


parcelRegister("1v2QX", function(module, exports) {

$parcel$export(module.exports, "AsyncNoPlanPermissionErrorPage", () => $d08fb773ac6c1816$export$e595d2c5dfcb1d5a);

var $5uXOq = parcelRequire("5uXOq");

var $kb4zh = parcelRequire("kb4zh");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $d08fb773ac6c1816$var$LazyNoPlanPermissionErrorPage = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("PK1Hc")), {
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/error-screens/no-plan-permission/index.tsx"
});
const $d08fb773ac6c1816$export$e595d2c5dfcb1d5a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "arj-no-plan-permission",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d08fb773ac6c1816$var$LazyNoPlanPermissionErrorPage, props));

});
parcelRegister("PK1Hc", function(module, exports) {

let $09b87768e2a44421$var$load = (parcelRequire("28QjX"))(4);
module.exports = $09b87768e2a44421$var$load("gqZrF").then(()=>parcelRequire('dycHB'));

});


parcelRegister("jMY1T", function(module, exports) {

$parcel$export(module.exports, "AsyncNotFoundErrorPage", () => $900bf2ccc30cc7be$export$8f6c907860218fdc);

var $5uXOq = parcelRequire("5uXOq");

var $kb4zh = parcelRequire("kb4zh");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $900bf2ccc30cc7be$var$LazyNotFoundErrorPage = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("cddga")), {
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/error-screens/not-found/index.tsx"
});
const $900bf2ccc30cc7be$export$8f6c907860218fdc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "arj-not-found-page",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($900bf2ccc30cc7be$var$LazyNotFoundErrorPage, props));

});
parcelRegister("cddga", function(module, exports) {

let $8e40fc0c9dd886fa$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8e40fc0c9dd886fa$var$load("2kKFX").then(()=>parcelRequire('3jte6'));

});


parcelRegister("5Bu9u", function(module, exports) {

$parcel$export(module.exports, "AsyncLazyGenericErrorPage", () => $66b4ac8b1535587d$export$8e4963c137216f8f);

var $5uXOq = parcelRequire("5uXOq");

var $kb4zh = parcelRequire("kb4zh");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $66b4ac8b1535587d$var$LazyGenericErrorPage = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("5vAo0")), {
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/error-screens/generic/index.tsx"
});
const $66b4ac8b1535587d$export$8e4963c137216f8f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-arj-generic-error-page",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($66b4ac8b1535587d$var$LazyGenericErrorPage, null));

});
parcelRegister("5vAo0", function(module, exports) {

let $402c128bcd3717d5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $402c128bcd3717d5$var$load("h4ijC").then(()=>parcelRequire('lBDrF'));

});




parcelRegister("g6wgl", function(module, exports) {

$parcel$export(module.exports, "LazyPlanTimeline", () => $c8bd5810f2180a4a$export$bf48e5f1529ddaeb);
$parcel$export(module.exports, "default", () => $c8bd5810f2180a4a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $c8bd5810f2180a4a$export$bf48e5f1529ddaeb = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("jEWT5"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-timeline/index-old.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c8bd5810f2180a4a$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $c8bd5810f2180a4a$export$bf48e5f1529ddaeb,
        pageId: "plan-timeline",
        shouldShowSpinner: true
    });

});


parcelRegister("6Z4jF", function(module, exports) {

$parcel$export(module.exports, "legacyPlanReportPageRedirectRouteEntry", () => $be1254c729965d54$export$c2a4c5c6576a704c);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $j5aum = parcelRequire("j5aum");

var $5WheG = parcelRequire("5WheG");

var $g6wgl = parcelRequire("g6wgl");
const $be1254c729965d54$export$c2a4c5c6576a704c = (0, $7NszV.createEntry)((0, $j5aum.legacyPlanReportPageRedirectRoute), ()=>({
        group: 'software',
        component: (0, $5WheG.default),
        isRedirect: true,
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $g6wgl.LazyPlanTimeline)
        ]
    }));

});
parcelRegister("j5aum", function(module, exports) {

$parcel$export(module.exports, "legacyPlanReportPageRedirectRoute", () => $c3430a8e44cc7ca2$export$7747547e845a016c);
const $c3430a8e44cc7ca2$export$7747547e845a016c = {
    name: 'software-advanced-roadmaps-redirect',
    path: '/secure/PortfolioReportView.jspa'
};

});

parcelRegister("5WheG", function(module, exports) {

$parcel$export(module.exports, "default", () => $135d7141d14abe41$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ds5qV = parcelRequire("ds5qV");

var $doZTA = parcelRequire("doZTA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$135d7141d14abe41$export$2e2bcd8739ae039 = ()=>{
    const [{ query: query }] = (0, $doZTA.useRouter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: `/jira/plans/reports/${query.r}`,
        persistSearchParams: false
    });
};

});


parcelRegister("d2uL5", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesNoteConfigRouteEntry", () => $212dfb46ac85d619$export$836428e7b33b6c6c);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $j3hwR = parcelRequire("j3hwR");

var $e7bC3 = parcelRequire("e7bC3");

var $9PHNK = parcelRequire("9PHNK");
const $212dfb46ac85d619$export$836428e7b33b6c6c = (0, $7NszV.createEntry)((0, $j3hwR.legacyProjectReleasesNoteConfigRoute), ()=>({
        group: 'project-settings-software',
        resources: [
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        component: (0, $9PHNK.LegacyFrontendReleaseNoteRedirect),
        layout: (0, $e7bC3.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("j3hwR", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesNoteConfigRoute", () => $1e459e992a50ef9a$export$a9509017cabb1e30);
const $1e459e992a50ef9a$export$a9509017cabb1e30 = {
    name: 'legacy-project-releases-note-config',
    path: '/secure/ConfigureReleaseNote.jspa',
    query: [
        'projectId',
        'version'
    ]
};

});

parcelRegister("9PHNK", function(module, exports) {

$parcel$export(module.exports, "BoardSettingsRedirectToCSM", () => $3fda9f3e07781c4c$export$ccce5315da25c53e);
$parcel$export(module.exports, "RoadmapSettingsRedirectToTimelineSettings", () => $3fda9f3e07781c4c$export$eaa324972a212c18);
$parcel$export(module.exports, "SpaReleaseNoteRedirectToVersionDetails", () => $3fda9f3e07781c4c$export$52fa4fd8ca9baab5);
$parcel$export(module.exports, "LegacyFrontendReleaseNoteRedirect", () => $3fda9f3e07781c4c$export$dee47264404d89a0);
$parcel$export(module.exports, "getUFOName", () => $3fda9f3e07781c4c$export$759ec9adbd19c936);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $b5AbL = parcelRequire("b5AbL");

var $7tQej = parcelRequire("7tQej");
const $3fda9f3e07781c4c$export$ccce5315da25c53e = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/jira/software/projects/${String(match.params.projectKey)}/settings/boards/${String(match.params.boardId)}/columns`,
        push: false
    });
const $3fda9f3e07781c4c$export$eaa324972a212c18 = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/jira/software/projects/${String(match.params.projectKey)}/settings/boards/${String(match.params.boardId)}/timeline`,
        push: false
    });
const $3fda9f3e07781c4c$export$52fa4fd8ca9baab5 = ({ query: query })=>{
    const { version: versionId } = query;
    const { loading: loading, error: error, projectKey: projectKey } = (0, $b5AbL.useProjectKeyByProjectResource)();
    if (loading === false && error) return null;
    if (loading) return null;
    if (!versionId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: {
            pathname: `/projects/${projectKey}?selectedItem=com.atlassian.jira.jira-projects-plugin%3Arelease-page`,
            hash: '',
            search: ''
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: {
            pathname: `/projects/${projectKey}/versions/${versionId}/tab/release-report-all-issues`,
            hash: '',
            search: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
                isReleaseNoteModalOpen: true
            })
        }
    });
};
const $3fda9f3e07781c4c$export$dee47264404d89a0 = ({ query: query })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: {
            pathname: '/secure/ReleaseNote.jspa',
            hash: '',
            search: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
                ...query,
                isRedirectedFromLegacy: true
            })
        }
    });
const $3fda9f3e07781c4c$var$ufoNamesMap = {
    'project-settings-software-issuetypes': 'project-settings.issue-type.jsw-tmp',
    'project-settings-servicedesk-issuetypes': 'project-settings.issue-type.jsm-tmp'
};
const $3fda9f3e07781c4c$export$759ec9adbd19c936 = (name)=>$3fda9f3e07781c4c$var$ufoNamesMap[name] || name;

});
parcelRegister("b5AbL", function(module, exports) {

$parcel$export(module.exports, "useProjectKeyByProjectResource", () => $347c2a822ae60413$export$899fd1c46031ece8);

var $jcw0u = parcelRequire("jcw0u");

var $2YP9W = parcelRequire("2YP9W");

var $dxCvy = parcelRequire("dxCvy");
const $347c2a822ae60413$export$899fd1c46031ece8 = (teamName)=>{
    const { data: data, error: resourceError, loading: loading } = (0, $2YP9W.useResource)((0, $dxCvy.projectContextResource));
    if (resourceError && data == null) {
        const isErrorErrorType = resourceError instanceof Error;
        const error = isErrorErrorType ? resourceError : new Error(`projectContextResource returned error resourceError: ${JSON.stringify(resourceError)}, loading: ${loading}, data: null`);
        (0, $jcw0u.default)({
            meta: {
                id: 'useResourceProjectContext',
                packageName: 'jiraRouterResourcesProjectContext',
                teamName: teamName ?? 'magma'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            loading: false,
            error: error,
            projectKey: null
        };
    }
    if (loading) return {
        loading: true,
        error: null,
        projectKey: null
    };
    // This case never happens by type definition, which you can't even mock test data for this case due to type definition. But if you don't check this, TS is not happy
    if (data == null) return {
        loading: false,
        error: new Error('projectContextResource returned data=null when loading false'),
        projectKey: null
    };
    return {
        loading: false,
        projectKey: data.projectKey,
        error: null
    };
};

});



parcelRegister("2ubrr", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesNoteRouteEntry", () => $a8cc91e8c082e291$export$781dd53d465d270d);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $9xZTT = parcelRequire("9xZTT");

var $e7bC3 = parcelRequire("e7bC3");

var $9PHNK = parcelRequire("9PHNK");
const $a8cc91e8c082e291$export$781dd53d465d270d = (0, $7NszV.createEntry)((0, $9xZTT.legacyProjectReleasesNoteRoute), ()=>({
        group: 'project-settings-software',
        resources: [
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        component: (0, $9PHNK.LegacyFrontendReleaseNoteRedirect),
        layout: (0, $e7bC3.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("9xZTT", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesNoteRoute", () => $6ea4b44e61fd0227$export$6ef734887b6da0c8);
const $6ea4b44e61fd0227$export$6ef734887b6da0c8 = {
    name: 'legacy-project-releases-note',
    path: '/jira/secure/ReleaseNote.jspa',
    query: [
        'projectId',
        'version'
    ]
};

});


parcelRegister("iz3gR", function(module, exports) {

$parcel$export(module.exports, "legacyRapidBoardRouteEntry", () => $bc93178a086d6ff3$export$4a5b9e48e40676ad);

var $ffza4 = parcelRequire("ffza4");


var $e2ctp = parcelRequire("e2ctp");

var $gyYxw = parcelRequire("gyYxw");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $f5kpo = parcelRequire("f5kpo");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $kNWOS = parcelRequire("kNWOS");

var $16Z5s = parcelRequire("16Z5s");

var $hWAe2 = parcelRequire("hWAe2");

var $5f2bR = parcelRequire("5f2bR");
const $bc93178a086d6ff3$export$4a5b9e48e40676ad = (0, $7NszV.createEntry)((0, $kNWOS.legacyRapidBoardRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-board',
        component: (0, $16Z5s.RapidBoardSpaPage),
        skeleton: (0, $hWAe2.ClassicBoardSkeleton),
        layout: (0, $aPfsS.composeLayouts)((0, $gyYxw.genericProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue',
                    'view=detail'
                ]
            },
            {
                query: [
                    'selectedIssue',
                    'modal=detail'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            ...(0, $3RJkv.getUserBoardNavigationResources)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $16Z5s.LazyRapidBoard),
            (0, $16Z5s.LazyRapidBoardApps)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$fc5f182fc9019b1c)
        },
        earlyAssets: (0, $e2ctp.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        supportsPreviewPanel: true
    }));

});
parcelRegister("kNWOS", function(module, exports) {

$parcel$export(module.exports, "legacyRapidBoardRoute", () => $454db19224248ed1$export$2bc0c59cefa2bd5e);
const $454db19224248ed1$export$2bc0c59cefa2bd5e = {
    name: 'rapidboard-board',
    path: '/secure/RapidBoard.jspa',
    query: [
        'rapidView'
    ],
    __unsafeOrder: -1
};

});


parcelRegister("ghGCX", function(module, exports) {

$parcel$export(module.exports, "legacyRedirectRouteEntry", () => $c46fefae40525649$export$27f123cb9320355);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $7v7WP = parcelRequire("7v7WP");

var $3mK2k = parcelRequire("3mK2k");
// @ts-expect-error - Type '{}' is missing the following properties from type 'Pick<Omit<Omit<RouteContext & { flagService: FlagService; createAnalyticsEvent: (arg1: { action: string; }) => UIAnalyticsEvent; }, keyof WithAnalyticsEventsProps> & RefAttributes<...>, "flagService">, keyof RouteContext | keyof RefAttributes<...>>': query, location, route, match, action
const $c46fefae40525649$var$RedirectComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3mK2k.default), null);
const $c46fefae40525649$export$27f123cb9320355 = (0, $7NszV.createEntry)((0, $7v7WP.legacyRedirectRoute), ()=>({
        component: $c46fefae40525649$var$RedirectComponent,
        layout: (0, $2BrOV.globalLayout),
        resources: [],
        isRedirect: true,
        canTransitionIn: ()=>false,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("7v7WP", function(module, exports) {

$parcel$export(module.exports, "legacyRedirectRoute", () => $5ce80937ea4d4231$export$176ff76c3ba7c4ce);
const $5ce80937ea4d4231$export$176ff76c3ba7c4ce = {
    path: '',
    name: 'legacy-redirect',
    exact: false
};

});


parcelRegister("7MpwB", function(module, exports) {

$parcel$export(module.exports, "loginEmbedRouteEntry", () => $cd382e3a47206865$export$faa46f8c5e1f06d3);

var $5uXOq = parcelRequire("5uXOq");

var $6e4Kt = parcelRequire("6e4Kt");

var $7NszV = parcelRequire("7NszV");

var $hA0Yo = parcelRequire("hA0Yo");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $cd382e3a47206865$var$LazyLoginEmbed = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("87y4U")), {
    moduleId: "./src/packages/spa-apps/login-embed/src/index.tsx"
});
const $cd382e3a47206865$var$LoginEmbed = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cd382e3a47206865$var$LazyLoginEmbed,
        pageId: "spa-apps/login-embed",
        shouldShowSpinner: true
    });
const $cd382e3a47206865$export$faa46f8c5e1f06d3 = (0, $7NszV.createEntry)((0, $hA0Yo.loginEmbedRoute), ()=>({
        group: 'errors',
        component: $cd382e3a47206865$var$LoginEmbed,
        layout: (0, $6e4Kt.chromelessLayout)
    }));

});
parcelRegister("hA0Yo", function(module, exports) {

$parcel$export(module.exports, "loginEmbedRoute", () => $288f4f9c77816594$export$9efae7a8e8e69866);
const $288f4f9c77816594$export$9efae7a8e8e69866 = {
    name: 'login-embed',
    path: '/jira-login/embed'
};

});

parcelRegister("87y4U", function(module, exports) {

let $5e99696055545d45$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5e99696055545d45$var$load("96g6X").then(()=>parcelRequire('8LbPV'));

});


parcelRegister("pRrpu", function(module, exports) {

$parcel$export(module.exports, "manageProjectsDirectoryRouteEntry", () => $e28e6d3f170e3052$export$d5b1a46987369ee4);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $4jMkc = parcelRequire("4jMkc");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $fsqMg = parcelRequire("fsqMg");

var $cFtGt = parcelRequire("cFtGt");

var $5j7Th = parcelRequire("5j7Th");

var $fbnvY = parcelRequire("fbnvY");

var $fhRbA = parcelRequire("fhRbA");

var $jL5x9 = parcelRequire("jL5x9");
const $e28e6d3f170e3052$var$LazyAdminProjectsDirectory = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fhRbA.LazyProjectsDirectory), {
        isAdminProjectDirectoryRoute: true
    });
const $e28e6d3f170e3052$var$ProjectsDirectoryManageComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e28e6d3f170e3052$var$LazyAdminProjectsDirectory,
        pageId: "projects-directory-manage-v3",
        shouldShowSpinner: false
    });
const $e28e6d3f170e3052$export$d5b1a46987369ee4 = (0, $7NszV.createEntry)((0, $fsqMg.manageProjectsDirectoryRoute), ()=>({
        group: 'directories',
        component: $e28e6d3f170e3052$var$ProjectsDirectoryManageComponent,
        skeleton: (0, $cFtGt.ProjectsDirectorySkeleton),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
            sidebar: (0, $4jMkc.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $fbnvY.adminProjectDirectoryResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $fhRbA.LazyProjectsDirectory)
        ],
        ufoName: 'projects-directory-v3-manage',
        entryPoint () {
            return 0, $jL5x9.ProjectsDirectoryPageEntryPoint;
        }
    }));

});
parcelRegister("fsqMg", function(module, exports) {

$parcel$export(module.exports, "manageProjectsDirectoryRoute", () => $3dd7670289805d41$export$281a4490a0f8fb4c);
const $3dd7670289805d41$export$281a4490a0f8fb4c = {
    name: 'projects-directory-manage',
    path: '/jira/settings/projects/manage'
};

});

parcelRegister("fbnvY", function(module, exports) {

$parcel$export(module.exports, "adminProjectDirectoryResources", () => $9521a93df7bbe3a1$export$1b29db6307155621);

var $atU1t = parcelRequire("atU1t");

var $hW253 = parcelRequire("hW253");
const $9521a93df7bbe3a1$export$1b29db6307155621 = ()=>[
        (0, $atU1t.navigationSidebarGlobalResource),
        (0, $hW253.projectsDirectoryPageResource)
    ];

});
parcelRegister("hW253", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryPageResource", () => $4c805bc331263d5b$export$aabb201a7f7100c5);
/* eslint-disable jira/import-whitelist */ 
var $8Uumt = parcelRequire("8Uumt");

var $gkT9B = parcelRequire("gkT9B");

var $8pIiT = parcelRequire("8pIiT");

var $5yJb9 = parcelRequire("5yJb9");

var $kipqU = parcelRequire("kipqU");

var $ao2h1 = parcelRequire("ao2h1");

var $lVQ0r = parcelRequire("lVQ0r");

var $2M1hQ = parcelRequire("2M1hQ");

const $4c805bc331263d5b$export$aabb201a7f7100c5 = (0, $2M1hQ.createResource)({
    type: `${(0, $ao2h1.RELAY_RESOURCE_TYPE)}_${(0, $ce818d5819645fe8$export$2150caade62dc875)}`,
    getKey: ()=>'projects-directory-relay',
    // @ts-expect-error - might return null
    getData: async ({ query: query, route: route }, { tenantContext: tenantContext })=>{
        const { cloudId: cloudId, isAnonymous: isAnonymous } = tenantContext;
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should temporally disable anonymous SSR until
        // the underlying auth issues have been fixed. Duplo team will push the real fix later.
        if (false && isAnonymous) return null;
        const queryReference = (0, $8Uumt.loadQuery)((0, $5yJb9.default)(), (0, $lVQ0r.default), {
            cloudId: tenantContext.cloudId,
            filter: (0, $8pIiT.mapQueryToFilter)((0, $gkT9B.filterInitialState), {
                cloudId: cloudId,
                query: (0, $8pIiT.sanitizeLegacyQuery)(query),
                aliases: (0, $gkT9B.filterAliasMap)
            }),
            first: query?.page ? (0, $gkT9B.DEFAULT_LIMIT) * (parseInt(query.page, 10) || 1) : (0, $gkT9B.DEFAULT_LIMIT),
            last: (0, $gkT9B.DEFAULT_LIMIT),
            isAdminSettingsContext: route.name === 'projects-directory-manage',
            isAnonymous: isAnonymous
        }, {
            fetchPolicy: 'network-only'
        });
        if (false && queryReference.id != null) await (0, $kipqU.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    }
});

});
parcelRegister("gkT9B", function(module, exports) {

$parcel$export(module.exports, "TableColumns", () => $4e4ac97bc1b1894b$export$b0e68791ad9c52df);
$parcel$export(module.exports, "SortableColumns", () => $4e4ac97bc1b1894b$export$f9e740ef44a4c43a);
$parcel$export(module.exports, "FilterFields", () => $4e4ac97bc1b1894b$export$e38c2fbdcbc20613);
$parcel$export(module.exports, "filterAliasMap", () => $4e4ac97bc1b1894b$export$5bc0ad9873e5cd89);
$parcel$export(module.exports, "filterInitialState", () => $4e4ac97bc1b1894b$export$fcb7b3e474e67781);
$parcel$export(module.exports, "DEFAULT_LIMIT", () => $4e4ac97bc1b1894b$export$ebc5ec3267fbcf57);
$parcel$export(module.exports, "PROJECTS_DIRECTORY_EXPERIENCE", () => $4e4ac97bc1b1894b$export$7c1bd7128901e2c4);
$parcel$export(module.exports, "MANAGE_PROJECTS_DIRECTORY_EXPERIENCE", () => $4e4ac97bc1b1894b$export$72fb94bf1b8ec849);
// eslint-disable-next-line jira/import-whitelist

var $7OwSg = parcelRequire("7OwSg");
const $4e4ac97bc1b1894b$export$b0e68791ad9c52df = {
    Favourites: 'favourite',
    Key: 'key',
    Name: 'name',
    Type: 'type',
    Lead: 'lead',
    Category: 'category',
    LastIssueUpdate: 'last_issue_updated_time',
    Url: 'url',
    Action: 'actions'
};
const $4e4ac97bc1b1894b$export$f9e740ef44a4c43a = [
    $4e4ac97bc1b1894b$export$b0e68791ad9c52df.Favourites,
    $4e4ac97bc1b1894b$export$b0e68791ad9c52df.Key,
    $4e4ac97bc1b1894b$export$b0e68791ad9c52df.Name,
    $4e4ac97bc1b1894b$export$b0e68791ad9c52df.Lead,
    $4e4ac97bc1b1894b$export$b0e68791ad9c52df.Category,
    $4e4ac97bc1b1894b$export$b0e68791ad9c52df.LastIssueUpdate
];
const $4e4ac97bc1b1894b$export$e38c2fbdcbc20613 = {
    Keyword: 'keyword',
    ProjectType: 'types',
    ProjectTypeLabel: 'ProjectTypeLabel',
    ProjectCategoryId: 'projectCategoryId',
    ProjectCategoryLabel: 'projectCategoryLabel',
    ...(0, $7OwSg.DefaultFilterFields)
};
const $4e4ac97bc1b1894b$export$5bc0ad9873e5cd89 = {
    contains: $4e4ac97bc1b1894b$export$e38c2fbdcbc20613.Keyword,
    selectedProjectType: $4e4ac97bc1b1894b$export$e38c2fbdcbc20613.ProjectType,
    selectedCategory: $4e4ac97bc1b1894b$export$e38c2fbdcbc20613.ProjectCategoryId
};
const $4e4ac97bc1b1894b$export$fcb7b3e474e67781 = {
    [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.Keyword]: '',
    [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.ProjectType]: '',
    [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.ProjectTypeLabel]: '',
    [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.ProjectCategoryId]: '',
    [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.ProjectCategoryLabel]: '',
    [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.SortOrder]: 'ASC',
    [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.SortKey]: $4e4ac97bc1b1894b$export$b0e68791ad9c52df.Name,
    [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.Page]: '1'
};
const $4e4ac97bc1b1894b$export$ebc5ec3267fbcf57 = 25;
const $4e4ac97bc1b1894b$export$7c1bd7128901e2c4 = 'viewProjectsDirectoryV3';
const $4e4ac97bc1b1894b$export$72fb94bf1b8ec849 = 'viewManageProjectsDirectoryV3';

});
parcelRegister("7OwSg", function(module, exports) {

$parcel$export(module.exports, "DefaultFilterFields", () => $30cd11272c627f6b$export$7ecdd4b6ae40e139);
$parcel$export(module.exports, "createUseFilter", () => $30cd11272c627f6b$export$ef79d9c1dcb09f8f);

var $ebyGx = parcelRequire("ebyGx");

var $jcw0u = parcelRequire("jcw0u");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $30cd11272c627f6b$export$7ecdd4b6ae40e139 = {
    // sorting
    SortOrder: 'sortOrder',
    SortKey: 'sortKey',
    // pagination
    Page: 'page'
};
const $30cd11272c627f6b$export$ef79d9c1dcb09f8f = (storeName, { getInitialState: getInitialState })=>{
    const actions = {
        updateFilter: (nameOrFilter, value)=>({ setState: setState, getState: getState }, { onUpdate: onUpdate })=>{
                const newFilter = typeof nameOrFilter === 'object' ? nameOrFilter : {
                    [nameOrFilter]: value
                };
                setState({
                    ...getState(),
                    [$30cd11272c627f6b$export$7ecdd4b6ae40e139.Page]: 1,
                    ...newFilter
                });
                onUpdate(getState());
            },
        forceUpdate: ()=>({ getState: getState }, { onUpdate: onUpdate })=>onUpdate(getState())
    };
    const Store = (0, $iXqE5.createStore)({
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        initialState: {},
        actions: actions,
        name: storeName
    });
    const useFilter = (0, $3sQ5x.createHook)(Store);
    const useScopedFilter = (0, $3sQ5x.createHook)(Store, {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        selector: (state, name)=>state[name]
    });
    const FilterContainer = (0, $gg7kZ.createContainer)(Store, {
        onInit: ()=>({ setState: setState })=>{
                try {
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    const routeQuery = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(window.location.search);
                    setState(getInitialState({
                        routeQuery: routeQuery
                    }));
                } catch (error) {
                    (0, $jcw0u.default)({
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        error: error,
                        meta: {
                            id: 'createUseFilter',
                            packageName: 'jiraDirectoryBaseV3',
                            teamName: 'jira-cosmos'
                        }
                    });
                }
            },
        // reset initial state on unmount
        onCleanup: ()=>({ setState: setState })=>setState(getInitialState({
                    routeQuery: {}
                }))
    });
    return {
        useFilter: useFilter,
        useScopedFilter: useScopedFilter,
        FilterContainer: FilterContainer
    };
};

});


parcelRegister("8pIiT", function(module, exports) {

$parcel$export(module.exports, "sanitizeLegacyQuery", () => $ddc7efe5cefc2e09$export$b6d5141c3209bd35);
$parcel$export(module.exports, "mapQueryToFilter", () => $ddc7efe5cefc2e09$export$2274cd5f35844a96);

var $4R6GH = parcelRequire("4R6GH");

var $h29WZ = parcelRequire("h29WZ");

var $7a3e8 = parcelRequire("7a3e8");

var $2vSU6 = parcelRequire("2vSU6");

var $dZhZb = parcelRequire("dZhZb");

var $dXq4S = parcelRequire("dXq4S");

var $gkT9B = parcelRequire("gkT9B");
const $ddc7efe5cefc2e09$var$LEGACY_ALL_VALUE = 'all';
const $ddc7efe5cefc2e09$export$b6d5141c3209bd35 = (query)=>({
        ...query,
        selectedProjectType: query.selectedProjectType === $ddc7efe5cefc2e09$var$LEGACY_ALL_VALUE ? (0, $gkT9B.filterInitialState)[(0, $gkT9B.FilterFields).ProjectType] : query.selectedProjectType,
        selectedCategory: query.selectedCategory === $ddc7efe5cefc2e09$var$LEGACY_ALL_VALUE ? (0, $gkT9B.filterInitialState)[(0, $gkT9B.FilterFields).ProjectCategoryId] : query.selectedCategory
    });
const $ddc7efe5cefc2e09$export$2274cd5f35844a96 = (filter, { cloudId: cloudId, query: query, aliases: aliases })=>{
    const variables = {};
    const { [(0, $gkT9B.FilterFields).Keyword]: keyword, [(0, $gkT9B.FilterFields).ProjectCategoryId]: projectCategoryId, [(0, $gkT9B.FilterFields).ProjectType]: types, [(0, $gkT9B.FilterFields).SortOrder]: sortOrder, [(0, $gkT9B.FilterFields).SortKey]: sortKey } = aliases && query ? (0, $dZhZb.matchAliases)(filter, query, aliases) : filter; // eslint-disable-line @typescript-eslint/consistent-type-assertions
    if (keyword) variables.keyword = keyword;
    if (projectCategoryId) {
        const isAlreadyAri = (0, $4R6GH.fg)('camptasks-1102-enable-atlassian-ari-projects') ? (0, $h29WZ.AnyAri).check(projectCategoryId) : (0, $dXq4S.isAri)(projectCategoryId);
        if (isAlreadyAri) variables.projectCategoryId = projectCategoryId;
        else variables.projectCategoryId = (0, $4R6GH.fg)('camptasks-1102-enable-atlassian-ari-projects') ? (0, $7a3e8.JiraProjectCategoryAri).create({
            projectCategoryId: projectCategoryId,
            siteId: cloudId
        }).toString() : (0, $dXq4S.createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'project-category',
            resourceId: projectCategoryId
        });
    }
    if (sortKey || sortOrder) {
        const sortByValue = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        sortKey && (0, $gkT9B.SortableColumns).includes(sortKey) ? sortKey : (0, $gkT9B.filterInitialState)[(0, $gkT9B.FilterFields).SortKey];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        variables.sortBy = {
            order: [
                'ASC',
                'DESC'
            ].includes(sortOrder) ? sortOrder : (0, $gkT9B.filterInitialState)[(0, $gkT9B.FilterFields).SortOrder],
            sortBy: sortByValue.toUpperCase()
        };
    }
    if (types && typeof types === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    variables.types = types.split(',') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .filter((type)=>(0, $2vSU6.PROJECT_TYPES).includes(type)).map((type)=>type.toUpperCase());
    return variables;
};

});
parcelRegister("7a3e8", function(module, exports) {

$parcel$export(module.exports, "JiraProjectCategoryAri", () => $536bf865a32ac7bf$export$da484aad24207e3d);

var $g0RIi = parcelRequire("g0RIi");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/project-category/manifest.ts
var $536bf865a32ac7bf$var$jiraProjectCategoryAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $g0RIi.JiraProjectCategoryAriResourceOwner),
    resourceType: (0, $g0RIi.JiraProjectCategoryAriResourceType),
    resourceIdSlug: "{projectCategoryId}",
    resourceIdSegmentFormats: {
        projectCategoryId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/project-category/index.ts
var $536bf865a32ac7bf$export$da484aad24207e3d = class _JiraProjectCategoryAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._projectCategoryId = opts.resourceIdSegmentValues.projectCategoryId;
    }
    get siteId() {
        return this._siteId;
    }
    get projectCategoryId() {
        return this._projectCategoryId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $536bf865a32ac7bf$var$jiraProjectCategoryAriStaticOpts.qualifier,
            platformQualifier: $536bf865a32ac7bf$var$jiraProjectCategoryAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $536bf865a32ac7bf$var$jiraProjectCategoryAriStaticOpts.resourceOwner,
            resourceType: $536bf865a32ac7bf$var$jiraProjectCategoryAriStaticOpts.resourceType,
            resourceId: `${opts.projectCategoryId}`,
            resourceIdSegmentValues: {
                projectCategoryId: opts.projectCategoryId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $536bf865a32ac7bf$var$jiraProjectCategoryAriStaticOpts);
        return new _JiraProjectCategoryAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $536bf865a32ac7bf$var$jiraProjectCategoryAriStaticOpts);
        return new _JiraProjectCategoryAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectCategoryId: this.projectCategoryId
        };
    }
};

});
parcelRegister("g0RIi", function(module, exports) {

$parcel$export(module.exports, "JiraProjectCategoryAriResourceOwner", () => $ba864fca2e893f55$export$b4df372413a623f1);
$parcel$export(module.exports, "JiraProjectCategoryAriResourceType", () => $ba864fca2e893f55$export$51b6f2a645c9e23a);
// src/jira/project-category/types.ts
var $ba864fca2e893f55$export$b4df372413a623f1 = "jira", $ba864fca2e893f55$export$51b6f2a645c9e23a = "project-category";

});


parcelRegister("dZhZb", function(module, exports) {

$parcel$export(module.exports, "matchAliases", () => $e41b5d91b7cfd8ce$export$55f686d7a3507dbe);
$parcel$export(module.exports, "serializeSelectOptions", () => $e41b5d91b7cfd8ce$export$74a705e0bee1565b);
$parcel$export(module.exports, "serializeSelectOptionsLabel", () => $e41b5d91b7cfd8ce$export$eed751fcc55ddadd);
$parcel$export(module.exports, "matchValueToSelectOptions", () => $e41b5d91b7cfd8ce$export$17e142fa55464467);

var $ggSx2 = parcelRequire("ggSx2");

var $cuHs1 = parcelRequire("cuHs1");
const $e41b5d91b7cfd8ce$export$55f686d7a3507dbe = (filterState, query, aliases)=>Object.keys(query).reduce((filter, key)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const alias = aliases[key];
        const queryValue = query[key];
        const hasInitialValue = filter[key] !== undefined;
        // override default filter value with query params
        if (hasInitialValue && queryValue) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
            filter[key] = queryValue;
            return filter;
        }
        // if there's no alias and no query param for it return default filter
        if (!alias || !queryValue) return filter;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
        filter[alias] = queryValue;
        return filter;
    }, {
        ...filterState
    });
const $e41b5d91b7cfd8ce$export$40bf1812f0f07002 = (data, aliases)=>{
    const invertedAliases = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))(aliases);
    return (0, (/*@__PURE__*/$parcel$interopDefault($cuHs1)))(data, (_, key)=>invertedAliases[key] || key);
};
const $e41b5d91b7cfd8ce$export$74a705e0bee1565b = (options)=>options.map((v)=>v.value).join(',');
const $e41b5d91b7cfd8ce$export$eed751fcc55ddadd = (options)=>options.map((v)=>v.label).join(',');
const $e41b5d91b7cfd8ce$export$17e142fa55464467 = (value, options)=>value ? value.split(',').map((val)=>options.find((option)=>option.value === val)).filter(Boolean) : [];

});
parcelRegister("ggSx2", function(module, exports) {

var $cxSdl = parcelRequire("cxSdl");

var $fxKlj = parcelRequire("fxKlj");

var $etyzk = parcelRequire("etyzk");
/** Used for built-in method references. */ var $bd8870e21c3833a0$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $bd8870e21c3833a0$var$nativeObjectToString = $bd8870e21c3833a0$var$objectProto.toString;
/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */ var $bd8870e21c3833a0$var$invert = $fxKlj(function(result, value, key) {
    if (value != null && typeof value.toString != 'function') value = $bd8870e21c3833a0$var$nativeObjectToString.call(value);
    result[value] = key;
}, $cxSdl($etyzk));
module.exports = $bd8870e21c3833a0$var$invert;

});
parcelRegister("fxKlj", function(module, exports) {

var $d1nCg = parcelRequire("d1nCg");
/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */ function $b50de2cb57eb155c$var$createInverter(setter, toIteratee) {
    return function(object, iteratee) {
        return $d1nCg(object, setter, toIteratee(iteratee), {});
    };
}
module.exports = $b50de2cb57eb155c$var$createInverter;

});
parcelRegister("d1nCg", function(module, exports) {

var $hDnyx = parcelRequire("hDnyx");
/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */ function $97adb007e27dc709$var$baseInverter(object, setter, iteratee, accumulator) {
    $hDnyx(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
    });
    return accumulator;
}
module.exports = $97adb007e27dc709$var$baseInverter;

});



parcelRegister("cuHs1", function(module, exports) {

var $1m3dq = parcelRequire("1m3dq");

var $hDnyx = parcelRequire("hDnyx");

var $bxDef = parcelRequire("bxDef");
/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */ function $0258ef72e36fbfcb$var$mapKeys(object, iteratee) {
    var result = {};
    iteratee = $bxDef(iteratee, 3);
    $hDnyx(object, function(value, key, object) {
        $1m3dq(result, iteratee(value, key, object), value);
    });
    return result;
}
module.exports = $0258ef72e36fbfcb$var$mapKeys;

});



parcelRegister("lVQ0r", function(module, exports) {

$parcel$export(module.exports, "default", () => $0264f0fee7e7a1be$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4f241df3a6ea0e25359d8080940f5802>>
 * @relayHash 9748961340a0877dad06569907936559
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID da04654402c040cfb1a5731e6742c8a699abdddac45bfc2bc9c768547f13bcf3

var $eiowN = parcelRequire("eiowN");
const $0264f0fee7e7a1be$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isAdminSettingsContext"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isAnonymous"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "isAnonymous",
            "variableName": "isAnonymous"
        }
    ], v7 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v8 = {
        "alias": "canBrowseProjects",
        "args": [
            v7 /*: any*/ ,
            {
                "kind": "Literal",
                "name": "type",
                "value": "BROWSE_PROJECTS"
            }
        ],
        "concreteType": "JiraPermission",
        "kind": "LinkedField",
        "name": "permission",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasPermission"
            }
        ]
    }, v9 = [
        v7 /*: any*/ 
    ], v10 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ], v11 = {
        "kind": "ScalarField",
        "name": "id"
    }, v12 = {
        "kind": "ScalarField",
        "name": "name"
    }, v13 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v14 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "key"
    }, v16 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v17 = {
        "kind": "ScalarField",
        "name": "totalCount"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "pageLayout_projectsDirectoryLayout_RootQuery",
            "selections": [
                {
                    "args": v6 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "header_projectsDirectoryV3"
                },
                {
                    "args": v6 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "refinementBar_projectsDirectoryV3_Filters"
                },
                {
                    "args": v6 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "projectsList_projectsDirectoryV3_rootQueryRef"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isAdminSettingsContext",
                            "variableName": "isAdminSettingsContext"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "pageLayout_projectsDirectoryV3_ProjectDirectoryLayout"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "emptyView_projectsDirectoryV3"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "noPermissionViews_projectsDirectoryV3"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "pageLayout_projectsDirectoryLayout_RootQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "canCreateProject",
                            "args": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "CREATE_PROJECT"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "canPerform"
                        },
                        {
                            "args": v9 /*: any*/ ,
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        },
                        {
                            "args": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "filter",
                                    "variableName": "filter"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "first",
                                    "variableName": "first"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "last",
                                    "variableName": "last"
                                }
                            ],
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": "canViewIssue",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "VIEW_ISSUES"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": v10 /*: any*/ ,
                                                    "storageKey": "action(type:\"VIEW_ISSUES\")"
                                                },
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraFavouriteValue",
                                                    "kind": "LinkedField",
                                                    "name": "favouriteValue",
                                                    "plural": false,
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                v15 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraAvatar",
                                                    "kind": "LinkedField",
                                                    "name": "avatar",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "medium"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectStyle"
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "navigationMetadata",
                                                    "plural": false,
                                                    "selections": [
                                                        v16 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "boardId"
                                                                },
                                                                v11 /*: any*/ 
                                                            ],
                                                            "type": "JiraSoftwareProjectNavigationMetadata"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "queueId"
                                                                }
                                                            ],
                                                            "type": "JiraServiceManagementProjectNavigationMetadata"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectType"
                                                },
                                                {
                                                    "concreteType": "JiraProjectCategory",
                                                    "kind": "LinkedField",
                                                    "name": "category",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "lead",
                                                    "plural": false,
                                                    "selections": [
                                                        v16 /*: any*/ ,
                                                        {
                                                            "kind": "TypeDiscriminator",
                                                            "abstractKey": "__isUser"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "accountId"
                                                        },
                                                        v12 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "picture"
                                                        },
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "condition": "isAdminSettingsContext",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "alias": "lastUpdatedToolTipDate",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "format",
                                                                    "value": "COMPLETE_DATETIME_FORMAT"
                                                                }
                                                            ],
                                                            "kind": "ScalarField",
                                                            "name": "lastUpdatedFormatted",
                                                            "storageKey": "lastUpdatedFormatted(format:\"COMPLETE_DATETIME_FORMAT\")"
                                                        },
                                                        {
                                                            "alias": "lastUpdatedDisplayDate",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "format",
                                                                    "value": "RELATIVE"
                                                                }
                                                            ],
                                                            "kind": "ScalarField",
                                                            "name": "lastUpdatedFormatted",
                                                            "storageKey": "lastUpdatedFormatted(format:\"RELATIVE\")"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectUrl"
                                                },
                                                {
                                                    "alias": "canViewProjectConfig",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "VIEW_PROJECT_CONFIG"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": v10 /*: any*/ ,
                                                    "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
                                                },
                                                {
                                                    "alias": "jiraProjectType",
                                                    "kind": "ScalarField",
                                                    "name": "projectType"
                                                },
                                                {
                                                    "alias": "jiraProjectName",
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v17 /*: any*/ ,
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isHasTotal"
                                }
                            ]
                        },
                        {
                            "alias": "canContactAdmin",
                            "args": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": "jira.show.contact.administrators.form"
                                }
                            ],
                            "concreteType": "JiraApplicationProperty",
                            "kind": "LinkedField",
                            "name": "applicationPropertiesByKey",
                            "plural": true,
                            "selections": [
                                v15 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                },
                                v11 /*: any*/ 
                            ]
                        },
                        v8 /*: any*/ ,
                        {
                            "condition": "isAnonymous",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": v9 /*: any*/ ,
                                    "concreteType": "JiraUserPreferences",
                                    "kind": "LinkedField",
                                    "name": "userPreferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectListRightPanelState"
                                        },
                                        v14 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "sidebarExperimentTemplates",
                                    "args": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "experimentKey",
                                            "value": "sidebarExperiment"
                                        }
                                    ],
                                    "concreteType": "JiraProjectListViewTemplateConnection",
                                    "kind": "LinkedField",
                                    "name": "projectListViewTemplates",
                                    "plural": false,
                                    "selections": [
                                        v17 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v9 /*: any*/ ,
                                    "concreteType": "JiraProjectCategoryConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjectCategories",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectCategoryEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v16 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isAnonymous",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": v9 /*: any*/ ,
                                    "concreteType": "JiraProjectCategoryConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjectCategories",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectCategoryEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraProjectCategory",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        v12 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v9 /*: any*/ ,
                            "concreteType": "JiraProjectTypeDetailsConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjectTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectTypeDetailsEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectTypeDetails",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                v11 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "da04654402c040cfb1a5731e6742c8a699abdddac45bfc2bc9c768547f13bcf3",
            "metadata": {},
            "name": "pageLayout_projectsDirectoryLayout_RootQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0264f0fee7e7a1be$var$node.hash = "0383d6b00b0ae0222d704297e4fe4e64";
(0, $eiowN.PreloadableQueryRegistry).set($0264f0fee7e7a1be$var$node.params.id, $0264f0fee7e7a1be$var$node);
var $0264f0fee7e7a1be$export$2e2bcd8739ae039 = $0264f0fee7e7a1be$var$node;

});

const $ce818d5819645fe8$export$2150caade62dc875 = 'PROJECTS_DIRECTORY_RELAY';



parcelRegister("fhRbA", function(module, exports) {

$parcel$export(module.exports, "LazyProjectsDirectory", () => $a4d64259d3b4962d$export$f9ee24127b8e4a7f);

var $7yO8g = parcelRequire("7yO8g");

var $kxZPA = parcelRequire("kxZPA");

const $a4d64259d3b4962d$export$f9ee24127b8e4a7f = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("7u2Nb"))), {
    moduleId: "./src/packages/spa-apps/directories/projects-v3/src/index.tsx"
});

});
parcelRegister("7u2Nb", function(module, exports) {

let $572d803cd92ab725$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $572d803cd92ab725$var$load("ffQaD"),
    $572d803cd92ab725$var$load("kvRbA"),
    $572d803cd92ab725$var$load("9HCEh")
]).then(()=>parcelRequire('eBOH6'));

});


parcelRegister("jL5x9", function(module, exports) {

$parcel$export(module.exports, "ProjectsDirectoryPageEntryPoint", () => $46b7b7dce12367bc$export$f4985310f86f98fc);

var $lkFvK = parcelRequire("lkFvK");

var $3obFW = parcelRequire("3obFW");

var $lmyls = parcelRequire("lmyls");

var $7wpGh = parcelRequire("7wpGh");

var $6raju = parcelRequire("6raju");
const $46b7b7dce12367bc$export$f4985310f86f98fc = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7wpGh.projectsDirectoryEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    rightSidebar: (0, $3obFW.RecommendationsInProjectListEntryPoint),
    rightSidebarFallback: (0, $6raju.ProjectListSidebarSkeleton)
});

});
parcelRegister("3obFW", function(module, exports) {

$parcel$export(module.exports, "RecommendationsInProjectListEntryPoint", () => $64f90d2bc5407ac6$export$8baad7954c0e6b8c);

var $5uP7K = parcelRequire("5uP7K");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $64f90d2bc5407ac6$export$8baad7954c0e6b8c = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("d6b47")), {
        moduleId: "3a12ca77",
        priority: "userVisible"
    }),
    getPreloadProps: (extraProps)=>({
            extraProps: extraProps,
            queries: {
                templatesQueryRef: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $5uP7K.default,
                    variables: {
                        cloudId: extraProps.tenantContext.cloudId,
                        isAnonymous: extraProps.tenantContext.isAnonymous
                    }
                }
            }
        })
});

});
parcelRegister("5uP7K", function(module, exports) {

$parcel$export(module.exports, "default", () => $73a724a7681d68cc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2096812634ac4db7102f111552f3cac0>>
 * @relayHash 33d5cb864464856bfba034ce11494a6a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a8abf8f0db8118c80c104d263cb9b57c8ed6264d060a8d429ffbcaa08ff96694
const $73a724a7681d68cc$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a8abf8f0db8118c80c104d263cb9b57c8ed6264d060a8d429ffbcaa08ff96694",
        "metadata": {},
        "name": "src_projectsDirectoryTemplatesSidebar_RecommendationsInProjectListQuery",
        "operationKind": "query",
        "text": null
    }
};
var $73a724a7681d68cc$export$2e2bcd8739ae039 = $73a724a7681d68cc$var$node;

});

parcelRegister("d6b47", function(module, exports) {

let $98946b3d8cf00690$var$load = (parcelRequire("28QjX"))(4);
module.exports = $98946b3d8cf00690$var$load("fiVNq").then(()=>parcelRequire('hT4Zj'));

});


parcelRegister("7wpGh", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryEntryPoint", () => $94d9041756c0d8ee$export$80225215a10b2688);

var $4R6GH = parcelRequire("4R6GH");

var $h29WZ = parcelRequire("h29WZ");

var $7a3e8 = parcelRequire("7a3e8");

var $dXq4S = parcelRequire("dXq4S");

var $9M2wg = parcelRequire("9M2wg");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");
const $94d9041756c0d8ee$var$DEFAULT_LIMIT = 25;
const $94d9041756c0d8ee$var$PROJECTS_DIRECTORY_MANAGE = 'projects-directory-manage';
const $94d9041756c0d8ee$var$DefaultFilterFields = {
    // sorting
    SortOrder: 'sortOrder',
    SortKey: 'sortKey',
    // pagination
    Page: 'page'
};
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $94d9041756c0d8ee$var$TableColumns = /*#__PURE__*/ function(TableColumns) {
    TableColumns["Favourites"] = "favourites";
    TableColumns["Key"] = "key";
    TableColumns["Name"] = "name";
    TableColumns["Type"] = "type";
    TableColumns["Lead"] = "lead";
    TableColumns["Category"] = "category";
    TableColumns["LastIssueUpdate"] = "last_issue_updated_time";
    TableColumns["Url"] = "url";
    TableColumns["Action"] = "actions";
    return TableColumns;
}($94d9041756c0d8ee$var$TableColumns || {});
const $94d9041756c0d8ee$var$SortableColumns = [
    "key",
    "name",
    "lead",
    "category",
    "last_issue_updated_time"
];
const $94d9041756c0d8ee$var$FilterFields = {
    Keyword: 'keyword',
    ProjectType: 'types',
    ProjectCategoryId: 'projectCategoryId',
    ...$94d9041756c0d8ee$var$DefaultFilterFields
};
const $94d9041756c0d8ee$var$filterAliasMap = {
    contains: $94d9041756c0d8ee$var$FilterFields.Keyword,
    selectedProjectType: $94d9041756c0d8ee$var$FilterFields.ProjectType,
    selectedCategory: $94d9041756c0d8ee$var$FilterFields.ProjectCategoryId
};
const $94d9041756c0d8ee$var$filterInitialState = {
    [$94d9041756c0d8ee$var$FilterFields.Keyword]: '',
    [$94d9041756c0d8ee$var$FilterFields.ProjectType]: '',
    [$94d9041756c0d8ee$var$FilterFields.ProjectCategoryId]: '',
    [$94d9041756c0d8ee$var$FilterFields.SortOrder]: 'ASC',
    [$94d9041756c0d8ee$var$FilterFields.SortKey]: "name",
    [$94d9041756c0d8ee$var$FilterFields.Page]: '1'
};
const $94d9041756c0d8ee$var$LEGACY_ALL_VALUE = 'all';
const $94d9041756c0d8ee$var$sanitizeLegacyQuery = (query = {})=>({
        ...query,
        selectedProjectType: query.selectedProjectType === $94d9041756c0d8ee$var$LEGACY_ALL_VALUE ? $94d9041756c0d8ee$var$filterInitialState[$94d9041756c0d8ee$var$FilterFields.ProjectType] : query.selectedProjectType,
        selectedCategory: query.selectedCategory === $94d9041756c0d8ee$var$LEGACY_ALL_VALUE ? $94d9041756c0d8ee$var$filterInitialState[$94d9041756c0d8ee$var$FilterFields.ProjectCategoryId] : query.selectedCategory
    });
const $94d9041756c0d8ee$var$matchAliases = (filterState, query, aliases)=>Object.keys(query).reduce((filter, key)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const alias = aliases[key];
        const queryValue = query[key];
        const hasInitialValue = filter[key] !== undefined;
        // override default filter value with query params
        if (hasInitialValue && queryValue) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
            filter[key] = queryValue;
            return filter;
        }
        // if there's no alias and no query param for it return default filter
        if (!alias || !queryValue) return filter;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
        filter[alias] = queryValue;
        return filter;
    }, {
        ...filterState
    });
const $94d9041756c0d8ee$var$CORE_PROJECT = 'business';
const $94d9041756c0d8ee$var$SOFTWARE_PROJECT = 'software';
const $94d9041756c0d8ee$var$SERVICE_DESK_PROJECT = 'service_desk';
const $94d9041756c0d8ee$var$PRODUCT_DISCOVERY_PROJECT = 'product_discovery';
const $94d9041756c0d8ee$var$PROJECT_TYPES = [
    $94d9041756c0d8ee$var$CORE_PROJECT,
    $94d9041756c0d8ee$var$SOFTWARE_PROJECT,
    $94d9041756c0d8ee$var$SERVICE_DESK_PROJECT,
    $94d9041756c0d8ee$var$PRODUCT_DISCOVERY_PROJECT
];
const $94d9041756c0d8ee$var$mapQueryToFilter = (filter, { cloudId: cloudId, query: query, aliases: aliases })=>{
    const variables = {};
    const { [$94d9041756c0d8ee$var$FilterFields.Keyword]: keyword, [$94d9041756c0d8ee$var$FilterFields.ProjectCategoryId]: projectCategoryId, [$94d9041756c0d8ee$var$FilterFields.ProjectType]: types, [$94d9041756c0d8ee$var$FilterFields.SortOrder]: sortOrder, [$94d9041756c0d8ee$var$FilterFields.SortKey]: sortKey } = aliases && query ? $94d9041756c0d8ee$var$matchAliases(filter, query, aliases) : filter;
    if (keyword) variables.keyword = keyword;
    if (projectCategoryId) {
        const isAlreadyAri = (0, $4R6GH.fg)('camptasks-1102-enable-atlassian-ari-projects') ? (0, $h29WZ.AnyAri).check(projectCategoryId) : (0, $dXq4S.isAri)(projectCategoryId);
        if (isAlreadyAri) variables.projectCategoryId = projectCategoryId;
        else variables.projectCategoryId = (0, $4R6GH.fg)('camptasks-1102-enable-atlassian-ari-projects') ? (0, $7a3e8.JiraProjectCategoryAri).create({
            projectCategoryId: projectCategoryId,
            siteId: cloudId
        }).toString() : (0, $dXq4S.createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'project-category',
            resourceId: projectCategoryId
        });
    }
    if (sortKey || sortOrder) {
        const sortByValue = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        sortKey && $94d9041756c0d8ee$var$SortableColumns.includes(sortKey) ? sortKey : $94d9041756c0d8ee$var$filterInitialState[$94d9041756c0d8ee$var$FilterFields.SortKey];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        variables.sortBy = {
            order: [
                'ASC',
                'DESC'
            ].includes(sortOrder) ? sortOrder : $94d9041756c0d8ee$var$filterInitialState[$94d9041756c0d8ee$var$FilterFields.SortOrder],
            sortBy: sortByValue.toUpperCase()
        };
    }
    if (types && typeof types === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    variables.types = types.split(',') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .filter((type)=>$94d9041756c0d8ee$var$PROJECT_TYPES.includes(type)).map((type)=>type.toUpperCase());
    return variables;
};

const $94d9041756c0d8ee$export$80225215a10b2688 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("grweM")), {
        moduleId: "b77224b3",
        priority: "userVisible"
    }),
    getPreloadProps ({ context: { query: query, route: route }, tenantContext: tenantContext }) {
        const { cloudId: cloudId, isAnonymous: isAnonymous } = tenantContext;
        const extraProps = {
            isAdminProjectDirectoryRoute: route.name === $94d9041756c0d8ee$var$PROJECTS_DIRECTORY_MANAGE
        };
        if (false && isAnonymous) return {
            extraProps: extraProps
        };
        return {
            queries: {
                projectsDirectoryPage: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: (0, $9M2wg.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        filter: $94d9041756c0d8ee$var$mapQueryToFilter($94d9041756c0d8ee$var$filterInitialState, {
                            cloudId: cloudId,
                            query: $94d9041756c0d8ee$var$sanitizeLegacyQuery(query),
                            aliases: $94d9041756c0d8ee$var$filterAliasMap
                        }),
                        first: query?.page ? $94d9041756c0d8ee$var$DEFAULT_LIMIT * (parseInt(query.page, 10) || 1) : $94d9041756c0d8ee$var$DEFAULT_LIMIT,
                        last: $94d9041756c0d8ee$var$DEFAULT_LIMIT,
                        isAdminSettingsContext: route.name === $94d9041756c0d8ee$var$PROJECTS_DIRECTORY_MANAGE,
                        isAnonymous: isAnonymous
                    }
                }
            },
            extraProps: extraProps
        };
    }
});

});
parcelRegister("9M2wg", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2863fb0305ba6a4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<23a6e9e3efd53029f1bd2f15dafcc83f>>
 * @relayHash 9748961340a0877dad06569907936559
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID da04654402c040cfb1a5731e6742c8a699abdddac45bfc2bc9c768547f13bcf3
const $a2863fb0305ba6a4$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "da04654402c040cfb1a5731e6742c8a699abdddac45bfc2bc9c768547f13bcf3",
        "metadata": {},
        "name": "pageLayout_projectsDirectoryLayout_RootQuery",
        "operationKind": "query",
        "text": null
    }
};
var $a2863fb0305ba6a4$export$2e2bcd8739ae039 = $a2863fb0305ba6a4$var$node;

});

parcelRegister("grweM", function(module, exports) {

let $bf882ca2f5801382$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $bf882ca2f5801382$var$load("ffQaD"),
    $bf882ca2f5801382$var$load("kvRbA"),
    $bf882ca2f5801382$var$load("jj5e4")
]).then(()=>parcelRequire('j3Lmi'));

});


parcelRegister("6raju", function(module, exports) {

$parcel$export(module.exports, "ProjectListSidebarSkeleton", () => $be14de1be79b27e3$export$808c25bcc6102427);
/* ProjectListSidebarSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $6bUD4 = parcelRequire("6bUD4");
const $be14de1be79b27e3$var$customCssStyles = null;
const $be14de1be79b27e3$var$sidebarCssStyles = null;
const $be14de1be79b27e3$export$808c25bcc6102427 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_4t3i1osq _1bsb1gwv _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _t6vdt94y _1p3lnqa1 _5wramuej _bfhkvuon _vchhusvi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6bUD4))),
        className: (0, $bwpsq.default)([
            "_t6vdidpf _hr4jidpf"
        ])
    }));

});
parcelRegister("6bUD4", function(module, exports) {
module.exports = new URL("project-list-sidebar-app-skeleton.tpl.35da4e26.svg", import.meta.url).toString();

});




parcelRegister("ZVu1m", function(module, exports) {

$parcel$export(module.exports, "notificationLogsRouteEntry", () => $8c16ad2f5cbcb35f$export$20ab3a955246df95);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $joRT8 = parcelRequire("joRT8");

var $6Z2mh = parcelRequire("6Z2mh");

var $1RPRU = parcelRequire("1RPRU");
const $8c16ad2f5cbcb35f$export$20ab3a955246df95 = (0, $7NszV.createEntry)((0, $joRT8.notificationLogsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        component: (0, $1RPRU.NotificationLogs),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $1RPRU.LazyNotificationLogs)
        ],
        perfMetricKey: 'jsm-notification-logs-component-load'
    }));

});
parcelRegister("joRT8", function(module, exports) {

$parcel$export(module.exports, "notificationLogsRoute", () => $7c61830ec505ffc9$export$c947c80f138bc137);
const $7c61830ec505ffc9$export$c947c80f138bc137 = {
    name: 'notification-logs',
    path: '/jira/servicedesk/projects/:projectKey/notification-logs',
    exact: true
};

});

parcelRegister("1RPRU", function(module, exports) {

$parcel$export(module.exports, "LazyNotificationLogs", () => $ce165317fbb6ef87$export$69cba5247233f8bc);
$parcel$export(module.exports, "NotificationLogs", () => $ce165317fbb6ef87$export$1139895a5af7252e);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $ce165317fbb6ef87$export$69cba5247233f8bc = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("iGIpL"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/notification-logs/src/index.tsx"
});
const $ce165317fbb6ef87$export$1139895a5af7252e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ce165317fbb6ef87$export$69cba5247233f8bc,
        pageId: "spa-apps/servicedesk/notification-logs",
        shouldShowSpinner: true
    });

});
parcelRegister("iGIpL", function(module, exports) {

let $d9ae9a059e4be563$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d9ae9a059e4be563$var$load("g0ZxT").then(()=>parcelRequire('9feT0'));

});



parcelRegister("5YggO", function(module, exports) {

$parcel$export(module.exports, "notificationsPersonalSettingsRouteEntry", () => $6f6984c8da820d1e$export$640c1b3b96c9032e);

var $5uXOq = parcelRequire("5uXOq");

var $lkFvK = parcelRequire("lkFvK");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $cRWZh = parcelRequire("cRWZh");

var $1C2yb = parcelRequire("1C2yb");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $d1xZH = parcelRequire("d1xZH");

var $ds5qV = parcelRequire("ds5qV");

var $a94gn = parcelRequire("a94gn");

var $h1H2H = parcelRequire("h1H2H");
const $6f6984c8da820d1e$var$personalSettingsNotificationsEntryPointPage = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $h1H2H.personalSettingsNotificationsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).NOTIFICATIONS
});
const $6f6984c8da820d1e$export$640c1b3b96c9032e = (0, $7NszV.createEntry)((0, $d1xZH.notificationsPersonalSettingsRoute), ()=>({
        group: 'personal-settings',
        skeleton: (0, $a94gn.PersonalSettingsNotificationsAppSkeleton),
        component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
                to: (0, $1C2yb.getNotificationsPersonalSettingsPath)()
            }),
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PERSONAL_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PROFILE,
            sidebar: (0, $cRWZh.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $5bkvv.getNavigationForgePersonalSettingsPageResources)()
        ],
        pageId: 'personal-settings-notifications',
        entryPoint () {
            return $6f6984c8da820d1e$var$personalSettingsNotificationsEntryPointPage;
        }
    }));

});
parcelRegister("1C2yb", function(module, exports) {

$parcel$export(module.exports, "GENERAL_PERSONAL_SETTINGS_PATH", () => $63706130a90445cd$export$693b70d1bcef8627);
$parcel$export(module.exports, "NOTIFICATIONS_PERSONAL_SETTINGS_PATH", () => $63706130a90445cd$export$21946ea4c58fd4c9);
$parcel$export(module.exports, "DIGEST_NOTIFICATIONS_PERSONAL_SETTINGS_PATH", () => $63706130a90445cd$export$cff16c3a6aa7a3a9);
$parcel$export(module.exports, "OPS_NOTIFICATIONS_PERSONAL_SETTINGS_PATH", () => $63706130a90445cd$export$2321c59d517801c8);
$parcel$export(module.exports, "getGeneralPersonalSettingsPath", () => $63706130a90445cd$export$db9e3ccc1e5e3317);
$parcel$export(module.exports, "getNotificationsPersonalSettingsPath", () => $63706130a90445cd$export$64a672523a583594);
$parcel$export(module.exports, "getAppsPersonalSettingsPath", () => $63706130a90445cd$export$1a7321c4210a3049);
const $63706130a90445cd$export$b468ccdb67523656 = '/secure/ViewPersonalSettings.jspa';
const $63706130a90445cd$export$a974f4af282a75ba = '/jira/settings/personal';
const $63706130a90445cd$export$693b70d1bcef8627 = `${$63706130a90445cd$export$a974f4af282a75ba}/general`;
const $63706130a90445cd$export$21946ea4c58fd4c9 = `${$63706130a90445cd$export$a974f4af282a75ba}/notifications`;
const $63706130a90445cd$export$cff16c3a6aa7a3a9 = `${$63706130a90445cd$export$a974f4af282a75ba}/digests`;
const $63706130a90445cd$export$1fffbb6055aa320a = `${$63706130a90445cd$export$a974f4af282a75ba}/apps`;
const $63706130a90445cd$export$2321c59d517801c8 = `${$63706130a90445cd$export$a974f4af282a75ba}/alert-notifications`;
function $63706130a90445cd$export$db9e3ccc1e5e3317() {
    return $63706130a90445cd$export$693b70d1bcef8627;
}
function $63706130a90445cd$export$88a45ae8c4b1c664() {
    return $63706130a90445cd$export$2321c59d517801c8;
}
function $63706130a90445cd$export$64a672523a583594() {
    return $63706130a90445cd$export$21946ea4c58fd4c9;
}
function $63706130a90445cd$export$1a7321c4210a3049() {
    return $63706130a90445cd$export$1fffbb6055aa320a;
}

});

parcelRegister("d1xZH", function(module, exports) {

$parcel$export(module.exports, "notificationsPersonalSettingsRoute", () => $de84b22e790c56d0$export$55ab09b9d6beb8be);
const $de84b22e790c56d0$export$55ab09b9d6beb8be = {
    name: 'personal-settings-notifications',
    path: '/jira/settings/personal/notifications'
};

});

parcelRegister("a94gn", function(module, exports) {

$parcel$export(module.exports, "PersonalSettingsNotificationsAppSkeleton", () => $e165273754ebea11$export$b542eb2d3193b983);
$parcel$export(module.exports, "PersonalSettingsNotificationsGlobalTableSkeleton", () => $e165273754ebea11$export$d58f6bbbc1838cb2);
$parcel$export(module.exports, "ProjectNotificationAccordionSkeleton", () => $e165273754ebea11$export$8cb773cb6fc17338);
/* PersonalSettingsNotificationsAppSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hCy6k = parcelRequire("hCy6k");

var $8JjKV = parcelRequire("8JjKV");

var $6kNmt = parcelRequire("6kNmt");

var $lBT69 = parcelRequire("lBT69");

var $7Vzvx = parcelRequire("7Vzvx");
const $e165273754ebea11$var$maxWidthCssStyles = null;
const $e165273754ebea11$var$customCssStyles = null;
const $e165273754ebea11$export$b542eb2d3193b983 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lBT69))),
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f8stt"
        ])
    });
const $e165273754ebea11$export$d58f6bbbc1838cb2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e165273754ebea11$var$SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8JjKV))),
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    }));
const $e165273754ebea11$export$46fc11a564484c9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e165273754ebea11$var$SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6kNmt))),
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    }));
const $e165273754ebea11$export$8cb773cb6fc17338 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e165273754ebea11$var$SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7Vzvx))),
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e165273754ebea11$var$SkeletonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_c71ldgin _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8JjKV", function(module, exports) {
module.exports = new URL("global-table-skeleton-with-projects.tpl.5a5d24b9.svg", import.meta.url).toString();

});

parcelRegister("6kNmt", function(module, exports) {
module.exports = new URL("mimetype-skeleton.tpl.8b750352.svg", import.meta.url).toString();

});

parcelRegister("lBT69", function(module, exports) {
module.exports = new URL("personal-settings-notifications-app-skeleton-with-projects.tpl.d18b3c58.svg", import.meta.url).toString();

});

parcelRegister("7Vzvx", function(module, exports) {
module.exports = new URL("project-accordion-skeleton.tpl.cee2df62.svg", import.meta.url).toString();

});


parcelRegister("h1H2H", function(module, exports) {

$parcel$export(module.exports, "personalSettingsNotificationsEntryPoint", () => $0e73b796ef7555dc$export$44d710abd316d1f1);

var $7P45F = parcelRequire("7P45F");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $0e73b796ef7555dc$export$44d710abd316d1f1 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("lKoxX")), {
        moduleId: "fe0c927e",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            // Queries your async component uses
            queries: {
                pageAndProject: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $7P45F.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectIds: context.query?.projectIds ? context.query.projectIds.split(',') : []
                    }
                }
            },
            // Optional - Anything extra you wish to pass to your component
            // Something from `EntryPointParams` for example
            extraProps: {
                accountId: tenantContext.atlassianAccountId
            }
        })
});

});
parcelRegister("7P45F", function(module, exports) {

$parcel$export(module.exports, "default", () => $49af4b582b9c7470$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<65f7487bbf2166c21de5aefdce342ece>>
 * @relayHash 0ace672294c09b398fb8d4f0e7526c83
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b7fd514c01c704c310af24b4bec2490f86683eb6f578c5e61833c2151685f3ba

var $jA1kf = parcelRequire("jA1kf");
const $49af4b582b9c7470$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = [
        v1 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        v4 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "xsmall"
                }
            ]
        }
    ], v6 = [
        {
            "kind": "ScalarField",
            "name": "channel"
        },
        {
            "kind": "ScalarField",
            "name": "isEnabled"
        },
        {
            "kind": "ScalarField",
            "name": "isEditable"
        }
    ], v7 = [
        v4 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "concreteType": "JiraNotificationChannel",
            "kind": "LinkedField",
            "name": "emailChannel",
            "plural": false,
            "selections": v6 /*: any*/ 
        },
        {
            "concreteType": "JiraNotificationChannel",
            "kind": "LinkedField",
            "name": "inProductChannel",
            "plural": false,
            "selections": v6 /*: any*/ 
        },
        {
            "kind": "ScalarField",
            "name": "category"
        }
    ], v8 = {
        "concreteType": "JiraNotificationPreferences",
        "kind": "LinkedField",
        "name": "preferences",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueAssigned",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueUpdated",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueDeleted",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "commentCreated",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "commentEdited",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "commentDeleted",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueCreated",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueMoved",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "mentionsCombined",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "worklogCombined",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "miscellaneousIssueEventCombined",
                "plural": false,
                "selections": v7 /*: any*/ 
            }
        ]
    }, v9 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ui_NotificationsPageAndProjectQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "projectNotificationsConfig_personalSettingsNotificationsConfigTable_projects"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraNotificationGlobalPreference",
                                    "kind": "LinkedField",
                                    "name": "notificationGlobalPreference",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "globalNotificationsConfigTable_personalSettingsNotificationsConfigTable_GlobalNotificationConfigTableNew"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraNotificationOptions",
                                                "kind": "LinkedField",
                                                "name": "options",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "notificationPreferencesOptionsWrapper_personalSettingsPreferenceFields_NotificationPreferencesOptions"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.notificationGlobalPreference.options"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.notificationGlobalPreference"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "ui_NotificationsPageAndProjectQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraNotificationProjectPreferenceConnection",
                            "kind": "LinkedField",
                            "name": "allNotificationProjectPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectNotificationPreferenceEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNotificationProjectPreferences",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": v5 /*: any*/ 
                                                },
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "totalCount"
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                v9 /*: any*/ 
                            ]
                        },
                        {
                            "args": v3 /*: any*/ ,
                            "filters": [
                                "cloudId"
                            ],
                            "handle": "connection",
                            "key": "projects_allNotificationProjectPreferences",
                            "kind": "LinkedHandle",
                            "name": "allNotificationProjectPreferences"
                        },
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraNotificationGlobalPreference",
                            "kind": "LinkedField",
                            "name": "notificationGlobalPreference",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraNotificationOptions",
                                    "kind": "LinkedField",
                                    "name": "options",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEmailNotificationEnabled"
                                        },
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "notifyWhenRoleAssigneeEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "notifyWhenRoleReporterEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "notifyOwnChangesEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "batchWindow"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "dailyBatchLocalTime"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "emailMimeType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEmailMimeTypeEditable"
                                        }
                                    ]
                                },
                                v8 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "allJiraProjectsForModal",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "notificationConfigurationState": "DEFAULT",
                                        "sortBy": {
                                            "sortBy": "NAME"
                                        }
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 5
                                }
                            ],
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b7fd514c01c704c310af24b4bec2490f86683eb6f578c5e61833c2151685f3ba",
            "metadata": {},
            "name": "ui_NotificationsPageAndProjectQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider": (0, $jA1kf.default)
            }
        }
    };
}();
$49af4b582b9c7470$var$node.hash = "b001322577b49b90b0c0e44082f4b2b8";
var $49af4b582b9c7470$export$2e2bcd8739ae039 = $49af4b582b9c7470$var$node;

});
parcelRegister("jA1kf", function(module, exports) {

$parcel$export(module.exports, "default", () => $349f2b9cab96c314$export$2e2bcd8739ae039);
var $349f2b9cab96c314$export$2e2bcd8739ae039 = {
    get () {
        return true;
    }
};

});


parcelRegister("lKoxX", function(module, exports) {

let $fd50ef569156e377$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fd50ef569156e377$var$load("17nZz").then(()=>parcelRequire('4DJNq'));

});



parcelRegister("6p9ik", function(module, exports) {

$parcel$export(module.exports, "opsgenieScheduleRedirectRouteEntry", () => $330664ff34aced93$export$75f0bcae97d54ba0);

var $ffza4 = parcelRequire("ffza4");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $gr6ab = parcelRequire("gr6ab");

var $fyMYi = parcelRequire("fyMYi");
const $330664ff34aced93$export$75f0bcae97d54ba0 = (0, $7NszV.createEntry)((0, $gr6ab.opsgenieScheduleRedirectRoute), ()=>({
        group: 'components',
        component: !false ? (0, $fyMYi.OpsgenieScheduleRedirect) : (0, $fyMYi.default),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $fyMYi.LazyOpsGenieSchedule)
        ],
        isRedirect: true
    }));

});
parcelRegister("gr6ab", function(module, exports) {

$parcel$export(module.exports, "opsgenieScheduleRedirectRoute", () => $65ae7cc3298d4e34$export$5d29dbb36868dff4);
const $65ae7cc3298d4e34$export$5d29dbb36868dff4 = {
    name: 'opsgenie-schedule-redirect',
    path: '/projects/:projectKey',
    query: [
        'selectedItem=com.atlassian.jira.jira-projects-plugin:opsgenie-schedule-page'
    ]
};

});

parcelRegister("fyMYi", function(module, exports) {

$parcel$export(module.exports, "LazyOpsGenieSchedule", () => $aa55fbc557add2b7$export$3a9c3ff70731bdd6);
$parcel$export(module.exports, "OpsgenieScheduleRedirect", () => $aa55fbc557add2b7$export$6ffd640c3062d976);
$parcel$export(module.exports, "default", () => $aa55fbc557add2b7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $dRTnK = parcelRequire("dRTnK");

const $aa55fbc557add2b7$export$3a9c3ff70731bdd6 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("clgde"))), {
    moduleId: "./src/packages/spa-apps/project/opsgenie-schedule/src/index.tsx"
});
const $aa55fbc557add2b7$export$6ffd640c3062d976 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dRTnK.RedirectToProjectType), {
        page: "/on-call-schedule"
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$aa55fbc557add2b7$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $aa55fbc557add2b7$export$3a9c3ff70731bdd6,
        pageId: "opsgenie-schedule",
        shouldShowSpinner: true
    });

});
parcelRegister("dRTnK", function(module, exports) {

$parcel$export(module.exports, "RedirectToProjectType", () => $f4de23917d090f8e$export$8a3df560509448b8);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dxCvy = parcelRequire("dxCvy");

var $bVDE5 = parcelRequire("bVDE5");

var $7tQej = parcelRequire("7tQej");
var $2YP9W = parcelRequire("2YP9W");
var $doZTA = parcelRequire("doZTA");
const $f4de23917d090f8e$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $7tQej.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $8zOmE.fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, $2NMNM.useAnalyticsEvents), useResource: useResource = (0, $2YP9W.useResource), useRouter: useRouter = (0, $doZTA.useRouter), useSpaStateTransition: useSpaStateTransition = (0, $bVDE5.useSpaStateTransition) })=>{
    const [{ match: match, query: query, route: route }] = useRouter();
    const { data: data } = useResource((0, $dxCvy.projectContextResource));
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
    (0, $5uXOq.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $2vSU6.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $2vSU6.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};

});

parcelRegister("clgde", function(module, exports) {

let $8fc405a4f222cb9b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8fc405a4f222cb9b$var$load("km7JB").then(()=>parcelRequire('dz9Sq'));

});



parcelRegister("SvIen", function(module, exports) {

$parcel$export(module.exports, "opsgenieScheduleRouteEntry", () => $54b4aa3079c12c39$export$f128c1c4a1f0d631);

var $e4eHl = parcelRequire("e4eHl");

var $ffza4 = parcelRequire("ffza4");

var $7XYc4 = parcelRequire("7XYc4");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $5lsNZ = parcelRequire("5lsNZ");

var $lco6K = parcelRequire("lco6K");

var $kfztd = parcelRequire("kfztd");

var $5f2bR = parcelRequire("5f2bR");

var $fyMYi = parcelRequire("fyMYi");
const $54b4aa3079c12c39$export$f128c1c4a1f0d631 = (0, $7NszV.createEntry)((0, $lco6K.opsgenieScheduleRoute), ()=>({
        group: 'components',
        ufoName: 'project-opsgenie-schedule',
        component: (0, $7XYc4.componentWithCondition)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $fyMYi.default)),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: [
                (0, $koWFd.default),
                (0, $9s3j1.default)
            ],
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $fyMYi.LazyOpsGenieSchedule)
        ],
        meta: {
            reporting: {
                id: 'opsgenie-schedule',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('opsgenie-schedule'),
                teamName: 'fusion-solaris'
            }
        }
    }));

});
parcelRegister("lco6K", function(module, exports) {

$parcel$export(module.exports, "opsgenieScheduleRoute", () => $3d5ce45adc18efc0$export$534a7ac096cb1da2);
const $3d5ce45adc18efc0$export$534a7ac096cb1da2 = {
    name: 'opsgenie-schedule',
    path: '/jira/:projectType(software|software/c)/projects/:projectKey/on-call-schedule'
};

});


parcelRegister("g3kqr", function(module, exports) {

$parcel$export(module.exports, "opsNotificationsPersonalSettingsRouteEntry", () => $cb843413a571a269$export$407513e3bdb49efe);

var $5uXOq = parcelRequire("5uXOq");

var $8ytTF = parcelRequire("8ytTF");

var $gk6PH = parcelRequire("gk6PH");

var $1Xcuw = parcelRequire("1Xcuw");parcelRequire("jxRF2");
var $ldKOT = parcelRequire("ldKOT");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $cRWZh = parcelRequire("cRWZh");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $8tZGz = parcelRequire("8tZGz");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $eZXFU = parcelRequire("eZXFU");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $cb843413a571a269$var$LazyOpsNotificationsPersonalSettings = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("1cOkR"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/personal-settings/ops-notifications/src/index.tsx"
});
const $cb843413a571a269$var$OpsNotificationsPersonalSettingsComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cb843413a571a269$var$LazyOpsNotificationsPersonalSettings,
        pageId: "personal-settings-notifications",
        shouldShowSpinner: true
    });
const $cb843413a571a269$export$407513e3bdb49efe = (0, $7NszV.createEntry)((0, $8tZGz.opsNotificationsPersonalSettingsRoute), ()=>({
        group: 'personal-settings',
        component: $cb843413a571a269$var$OpsNotificationsPersonalSettingsComponent,
        layout: (0, $eZXFU.opsNotificationsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PERSONAL_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PROFILE,
            sidebar: (0, $cRWZh.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $8ytTF.createContactsResource)(),
            (0, $1Xcuw.createNotificationPreferencesResource)(),
            (0, $ldKOT.eocUserResource),
            (0, $gk6PH.createMuteResource)(),
            (0, $gk6PH.createQuietHoursResource)(),
            (0, $1Xcuw.createForwardingRulesResource)(),
            ...(0, $5bkvv.getNavigationForgePersonalSettingsPageResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $cb843413a571a269$var$LazyOpsNotificationsPersonalSettings
        ]
    }));

});
parcelRegister("8tZGz", function(module, exports) {

$parcel$export(module.exports, "opsNotificationsPersonalSettingsRoute", () => $84075aa9af41e0be$export$68ebdd4eccb7b383);
const $84075aa9af41e0be$export$68ebdd4eccb7b383 = {
    name: 'personal-settings-ops-notifications',
    path: '/jira/settings/personal/alert-notifications'
};

});

parcelRegister("1cOkR", function(module, exports) {

let $0e0df507dd5a0fbe$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0e0df507dd5a0fbe$var$load("ffQaD"),
    $0e0df507dd5a0fbe$var$load("kvRbA"),
    $0e0df507dd5a0fbe$var$load("76n7a"),
    $0e0df507dd5a0fbe$var$load("l253H"),
    $0e0df507dd5a0fbe$var$load("8svwN")
]).then(()=>parcelRequire('aV66n'));

});


parcelRegister("frn0U", function(module, exports) {

$parcel$export(module.exports, "peopleProfilesRouteEntry", () => $ec3623cf53188008$export$219b6cc00b2f91a0);

var $6s1PB = parcelRequire("6s1PB");

var $2BrOV = parcelRequire("2BrOV");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $5UHoB = parcelRequire("5UHoB");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $fDWVs = parcelRequire("fDWVs");

var $6Z2mh = parcelRequire("6Z2mh");

var $7HAuv = parcelRequire("7HAuv");
const $ec3623cf53188008$var$peopleProfilesPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7HAuv.peopleProfilesEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PEOPLE
});
const $ec3623cf53188008$export$219b6cc00b2f91a0 = (0, $7NszV.createEntry)((0, $fDWVs.peopleProfilesRoute), ()=>({
        group: 'people-profiles',
        layout: (0, $5UHoB.layoutWithCondition)(()=>(0, $6s1PB.expValEquals)('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation'), (0, $6Z2mh.rightSidebarsLayout), (0, $2BrOV.globalLayout)),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        ufoName: 'people-profiles',
        entryPoint: ()=>$ec3623cf53188008$var$peopleProfilesPageEntrypoint,
        supportsPreviewPanel: true
    }));

});
parcelRegister("5UHoB", function(module, exports) {

$parcel$export(module.exports, "layoutWithCondition", () => $201222bac9c3aac5$export$c5db53e93ba35c0f);
const $201222bac9c3aac5$export$c5db53e93ba35c0f = (conditionGetter, itemTrue, itemFalse)=>({
        get isChromeless () {
            return conditionGetter() ? itemTrue.isChromeless : itemFalse.isChromeless;
        },
        get globalComponents () {
            return conditionGetter() ? itemTrue.globalComponents : itemFalse.globalComponents;
        },
        get rightSidebars () {
            return conditionGetter() ? itemTrue.rightSidebars : itemFalse.rightSidebars;
        }
    });

});

parcelRegister("fDWVs", function(module, exports) {

$parcel$export(module.exports, "peopleProfilesRoute", () => $44b234ae71647fd2$export$1338132568be849);
const $44b234ae71647fd2$export$1338132568be849 = {
    name: 'people-index',
    path: '/jira/people/:subPath?'
};

});

parcelRegister("7HAuv", function(module, exports) {

$parcel$export(module.exports, "peopleProfilesEntrypoint", () => $4e67e105bb4b4bfb$export$26daeb77c71acf79);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $4e67e105bb4b4bfb$export$26daeb77c71acf79 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("aPDfm")), {
        moduleId: "871dfc54",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("aPDfm", function(module, exports) {

let $7e2d1c5e141e1b33$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $7e2d1c5e141e1b33$var$load("ffQaD"),
    $7e2d1c5e141e1b33$var$load("kvRbA"),
    $7e2d1c5e141e1b33$var$load("kVX56"),
    $7e2d1c5e141e1b33$var$load("7mIf9"),
    $7e2d1c5e141e1b33$var$load("jXweD"),
    $7e2d1c5e141e1b33$var$load("fliVL"),
    $7e2d1c5e141e1b33$var$load("ieefZ")
]).then(()=>parcelRequire('3sora'));

});



parcelRegister("gjuAo", function(module, exports) {

$parcel$export(module.exports, "performanceRouteEntry", () => $8e362f7bda5bcefa$export$3f75a1735cbe5a04);

var $c04PQ = parcelRequire("c04PQ");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $eIj3W = parcelRequire("eIj3W");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $lkFvK = parcelRequire("lkFvK");

var $9aT1E = parcelRequire("9aT1E");

var $k6R7C = parcelRequire("k6R7C");
const $8e362f7bda5bcefa$var$performancePageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $9aT1E.performanceEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $8e362f7bda5bcefa$export$3f75a1735cbe5a04 = (0, $7NszV.createEntry)((0, $eIj3W.performanceRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $c04PQ.isFedRamp)()) return undefined;
            return $8e362f7bda5bcefa$var$performancePageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $k6R7C.FedRAMPFallbackRedirectToProjectSettings),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_PERFORMANCE,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_PERFORMANCE),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }));

});
parcelRegister("eIj3W", function(module, exports) {

$parcel$export(module.exports, "performanceRoute", () => $a08dee66d983407c$export$d867623f05adedb3);
const $a08dee66d983407c$export$d867623f05adedb3 = {
    name: 'project-settings-servicedesk-virtualagent-performance',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/performance'
};

});

parcelRegister("9aT1E", function(module, exports) {

$parcel$export(module.exports, "performanceEntryPoint", () => $94968a7dbb3de852$export$52b48527e9315b46);

var $jvgzC = parcelRequire("jvgzC");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");
const $94968a7dbb3de852$var$DEFAULT_TIME_RANGE_MS = 604800000; // 7 days
const $94968a7dbb3de852$var$formatFetchDate = (date)=>date.toISOString().substring(0, 10); // has to be truncated for proper caching in SSR

const $94968a7dbb3de852$export$52b48527e9315b46 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("jp4pR")), {
        moduleId: "25efd1aa",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $jvgzC.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey?.toUpperCase() ?? '',
                        startDate: $94968a7dbb3de852$var$formatFetchDate(new Date(Date.now() - $94968a7dbb3de852$var$DEFAULT_TIME_RANGE_MS)),
                        endDate: $94968a7dbb3de852$var$formatFetchDate(new Date())
                    }
                }
            }
        })
});

});
parcelRegister("jvgzC", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c3ef32003964182$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<861165471f6f0a3ccb4f0e5d452abe29>>
 * @relayHash 21e9d7bc6c1d6159d3cb21287ece8c13
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cf0299fe94a9a8a861ab1195460e48c47ec0b6bbbeb73751ebaf9968c7a8b54d

var $7oHmH = parcelRequire("7oHmH");

var $fzDI5 = parcelRequire("fzDI5");

var $gnNIl = parcelRequire("gnNIl");
const $7c3ef32003964182$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "cf0299fe94a9a8a861ab1195460e48c47ec0b6bbbeb73751ebaf9968c7a8b54d",
        "metadata": {},
        "name": "srcVirtualAgentPerformanceQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvastatusheaderrelayprovider": (0, $gnNIl.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvanextstepsrelayprovider": (0, $fzDI5.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $7oHmH.default)
        }
    }
};
var $7c3ef32003964182$export$2e2bcd8739ae039 = $7c3ef32003964182$var$node;

});

parcelRegister("jp4pR", function(module, exports) {

let $e203c717226b2324$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e203c717226b2324$var$load("3X7oq").then(()=>parcelRequire('6G1GD'));

});



parcelRegister("lPLcB", function(module, exports) {

$parcel$export(module.exports, "personalSettingsRouteEntry", () => $4a98174db89ed9a9$export$89646e32fa7698db);

var $5uXOq = parcelRequire("5uXOq");

var $8ytTF = parcelRequire("8ytTF");

var $gk6PH = parcelRequire("gk6PH");

var $1Xcuw = parcelRequire("1Xcuw");parcelRequire("jxRF2");
var $ldKOT = parcelRequire("ldKOT");

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $1C2yb = parcelRequire("1C2yb");

var $7NszV = parcelRequire("7NszV");


var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $bCvq0 = parcelRequire("bCvq0");

var $ds5qV = parcelRequire("ds5qV");

var $7yO8g = parcelRequire("7yO8g");

var $kxZPA = parcelRequire("kxZPA");

var $9wNN8 = parcelRequire("9wNN8");

var $4XFHO = parcelRequire("4XFHO");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $4a98174db89ed9a9$var$LazyLegacyPersonalSettings = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hXqvZ"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/personal-settings-legacy/src/index.tsx"
});
const $4a98174db89ed9a9$export$89646e32fa7698db = (0, $7NszV.createEntry)((0, $bCvq0.personalSettingsRoute), ()=>({
        group: 'personal-settings',
        component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
                to: (0, $1C2yb.GENERAL_PERSONAL_SETTINGS_PATH)
            }),
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PERSONAL_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PROFILE
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $8ytTF.createContactsResource)((0, $9wNN8.checkConsolidationOnRouteDependency), [
                (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
            ]),
            (0, $1Xcuw.createNotificationPreferencesResource)((0, $9wNN8.checkConsolidationOnRouteDependency), [
                (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
            ]),
            (0, $ldKOT.eocUserResource),
            (0, $gk6PH.createMuteResource)((0, $9wNN8.checkConsolidationOnRouteDependency), [
                (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
            ]),
            (0, $gk6PH.createQuietHoursResource)((0, $9wNN8.checkConsolidationOnRouteDependency), [
                (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
            ]),
            (0, $1Xcuw.createForwardingRulesResource)((0, $9wNN8.checkConsolidationOnRouteDependency), [
                (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
            ]),
            ...(0, $5bkvv.getNavigationForgePersonalSettingsPageResources)(),
            ...(0, $4XFHO.getLabsResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $4a98174db89ed9a9$var$LazyLegacyPersonalSettings
        ]
    }));

});
parcelRegister("bCvq0", function(module, exports) {

$parcel$export(module.exports, "personalSettingsRoute", () => $03113dbc73778b4c$export$176d0935b95c75e8);
const $03113dbc73778b4c$export$176d0935b95c75e8 = {
    name: 'personal-settings',
    path: '/secure/ViewPersonalSettings.jspa'
};

});

parcelRegister("9wNN8", function(module, exports) {

$parcel$export(module.exports, "checkConsolidationOnRouteDependency", () => $d103219a16ecaa90$export$ac86a769188afd33);

var $3H5ry = parcelRequire("3H5ry");

const $d103219a16ecaa90$export$ac86a769188afd33 = (dependencies)=>{
    const { data: data } = dependencies[0, $5a94e356f9d5e220$export$25ee35b01de9d734];
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $3H5ry.checkShouldUseJSM)(data);
};

});

parcelRegister("hXqvZ", function(module, exports) {

let $d12c83a70732e3f9$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d12c83a70732e3f9$var$load("kVX56"),
    $d12c83a70732e3f9$var$load("4lvCC")
]).then(()=>parcelRequire('3hooO'));

});


parcelRegister("eyDhF", function(module, exports) {

$parcel$export(module.exports, "piCreateIssueEmbedRouteEntry", () => $9f70c0379ebea475$export$7f9ffa2e2d102ba);

var $5uXOq = parcelRequire("5uXOq");

var $7NszV = parcelRequire("7NszV");

var $9NiTW = parcelRequire("9NiTW");

var $5j7Th = parcelRequire("5j7Th");

var $6e4Kt = parcelRequire("6e4Kt");

var $2Ql51 = parcelRequire("2Ql51");

var $4tkZW = parcelRequire("4tkZW");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9f70c0379ebea475$var$LazyPICreateIssueEmbed = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("1zu3V")).then((module)=>module.CreateIssueEmbed), {
    ssr: false,
    moduleId: "./src/packages/growth/gmail-embed/src/ui/create-issue/index.tsx"
});
const $9f70c0379ebea475$var$PIIssueCreateEmbedLazy = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9NiTW.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $9f70c0379ebea475$var$LazyPICreateIssueEmbed,
        pageId: "spa-apps/pi-issue-create-embed",
        shouldShowSpinner: true
    }));
};
const $9f70c0379ebea475$export$7f9ffa2e2d102ba = (0, $7NszV.createEntry)((0, $4tkZW.piCreateIssueEmbedRoute), ()=>({
        group: 'issue',
        component: $9f70c0379ebea475$var$PIIssueCreateEmbedLazy,
        resources: [
            (0, $2Ql51.themePreferenceResource)
        ],
        layout: (0, $6e4Kt.chromelessLayout),
        forPaint: [
            $9f70c0379ebea475$var$LazyPICreateIssueEmbed
        ]
    }));

});
parcelRegister("4tkZW", function(module, exports) {

$parcel$export(module.exports, "piCreateIssueEmbedRoute", () => $194e64041acf2c20$export$e38c7e6f5c65691b);
const $194e64041acf2c20$export$e38c7e6f5c65691b = {
    name: 'pi-issue-create-embed',
    path: '/jira/issues/create/pi/embed'
};

});

parcelRegister("1zu3V", function(module, exports) {

let $1250611323aac497$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1250611323aac497$var$load("6p1JY").then(()=>parcelRequire('1iOv0'));

});


parcelRegister("bFlFq", function(module, exports) {

$parcel$export(module.exports, "piEditIssueEmbedRouteEntry", () => $68977f9133eef8e0$export$54fd859765926fb);

var $5uXOq = parcelRequire("5uXOq");

var $7NszV = parcelRequire("7NszV");

var $gFxdE = parcelRequire("gFxdE");

var $9NiTW = parcelRequire("9NiTW");

var $5j7Th = parcelRequire("5j7Th");

var $6e4Kt = parcelRequire("6e4Kt");

var $2Ql51 = parcelRequire("2Ql51");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $68977f9133eef8e0$var$LazyPIEditIssueEmbed = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("4XLTG")).then((module)=>module.EditIssueEmbed), {
    ssr: false,
    moduleId: "./src/packages/growth/gmail-embed/src/ui/edit-issue/index.tsx"
});
const $68977f9133eef8e0$var$PIIssueEditEmbedLazy = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9NiTW.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $68977f9133eef8e0$var$LazyPIEditIssueEmbed,
        pageId: "spa-apps/pi-issue-edit-embed",
        shouldShowSpinner: true
    }));
};
const $68977f9133eef8e0$export$54fd859765926fb = (0, $7NszV.createEntry)((0, $gFxdE.piEditIssueEmbedRoute), ()=>({
        group: 'issue',
        component: $68977f9133eef8e0$var$PIIssueEditEmbedLazy,
        resources: [
            (0, $2Ql51.themePreferenceResource)
        ],
        layout: (0, $6e4Kt.chromelessLayout),
        forPaint: [
            $68977f9133eef8e0$var$LazyPIEditIssueEmbed
        ]
    }));

});
parcelRegister("gFxdE", function(module, exports) {

$parcel$export(module.exports, "piEditIssueEmbedRoute", () => $4be1968bc1e8e50c$export$963ebe9ee36e7e80);
const $4be1968bc1e8e50c$export$963ebe9ee36e7e80 = {
    name: 'pi-issue-edit-embed',
    path: '/jira/issues/edit/pi/embed'
};

});

parcelRegister("4XLTG", function(module, exports) {

let $39d1d37fde99e60b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $39d1d37fde99e60b$var$load("aZPed").then(()=>parcelRequire('cINTo'));

});


parcelRegister("eLT92", function(module, exports) {

$parcel$export(module.exports, "planExportPageRouteEntry", () => $e17ef7a70aea4a64$export$d751e3552b21c604);

var $5uXOq = parcelRequire("5uXOq");

var $7NszV = parcelRequire("7NszV");

var $c3WQb = parcelRequire("c3WQb");

var $dht4a = parcelRequire("dht4a");

var $5j7Th = parcelRequire("5j7Th");

var $hGLha = parcelRequire("hGLha");

var $g6wgl = parcelRequire("g6wgl");
/**
 * Export Page
 */ const $e17ef7a70aea4a64$var$ExportPageComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hGLha.LazyAdvancedRoadmapsPlanExport), null);
const $e17ef7a70aea4a64$var$ExportPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e17ef7a70aea4a64$var$ExportPageComponent,
        pageId: "advanced-roadmap",
        shouldShowSpinner: true
    });
const $e17ef7a70aea4a64$export$d751e3552b21c604 = (0, $7NszV.createEntry)((0, $dht4a.planExportPageRoute), ()=>({
        group: 'software',
        ufoName: 'software-advanced-roadmaps-scenario-export',
        component: $e17ef7a70aea4a64$var$ExportPage,
        layout: {
            isChromeless: true,
            globalComponents: [],
            rightSidebars: []
        },
        resources: [
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource)
        ],
        forPaint: [
            (0, $g6wgl.LazyPlanTimeline)
        ]
    }));

});
parcelRegister("dht4a", function(module, exports) {

$parcel$export(module.exports, "planExportPageRoute", () => $76c19eff2b41ddc4$export$2ca5fe6f9ab466c1);
const $76c19eff2b41ddc4$export$2ca5fe6f9ab466c1 = {
    name: 'software-advanced-roadmaps',
    path: '/jira/plans/:planId/scenarios/:scenarioId/export'
};

});

parcelRegister("hGLha", function(module, exports) {

$parcel$export(module.exports, "LazyAdvancedRoadmapsPlanExport", () => $b6ed3ac1658c948e$export$890fb5003e472449);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $b6ed3ac1658c948e$export$890fb5003e472449 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("eG68m"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b6ed3ac1658c948e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $b6ed3ac1658c948e$export$890fb5003e472449,
        pageId: "advanced-roadmaps-plan",
        shouldShowSpinner: true
    });

});
parcelRegister("eG68m", function(module, exports) {

let $aaf9bef978292fa7$var$load = (parcelRequire("28QjX"))(4);





module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $aaf9bef978292fa7$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $aaf9bef978292fa7$var$load("k6g9p")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $aaf9bef978292fa7$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $aaf9bef978292fa7$var$load("7B2gt")
        ]);
    }),
    $aaf9bef978292fa7$var$load("ffQaD"),
    $aaf9bef978292fa7$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("fqYxj"), 4)),
    $aaf9bef978292fa7$var$load("76n7a"),
    $aaf9bef978292fa7$var$load("l253H"),
    $aaf9bef978292fa7$var$load("fliVL"),
    $aaf9bef978292fa7$var$load("jdjwS")
]).then(()=>parcelRequire('ecw8s'));

});



parcelRegister("5nA0V", function(module, exports) {

$parcel$export(module.exports, "planIncrementRouteEntry", () => $13d9e6b7582fbfc8$export$a26fa5cabff8bc7c);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $8iyFV = parcelRequire("8iyFV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $czMjG = parcelRequire("czMjG");

var $4R6GH = parcelRequire("4R6GH");

var $eCdAs = parcelRequire("eCdAs");

var $8iKh5 = parcelRequire("8iKh5");
const $13d9e6b7582fbfc8$export$a26fa5cabff8bc7c = (0, $7NszV.createEntry)((0, $czMjG.planIncrementRoute), ()=>({
        group: 'software',
        entryPoint: ()=>// eslint-disable-next-line no-nested-ternary
            (0, $4R6GH.fg)('migrate_plans_to_entrypoints') ? (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? (0, $eCdAs.planIncrementPageEntryPoint) : (0, $eCdAs.planIncrementPageEntryPointWithoutHorizontalNavigation) : undefined,
        component: (0, $8iKh5.PlanIncrement),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default),
            horizontal: (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? undefined : (0, $8iyFV.AsyncHorizontalNavPlans),
            onlyShowHorizontalOnNav4: true
        },
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8iKh5.LazyPlanIncrement)
        ]
    }));

});
parcelRegister("8iyFV", function(module, exports) {

$parcel$export(module.exports, "AsyncHorizontalNavPlans", () => $ee88d7a7192b9e04$export$84e1a5f003939496);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $ee88d7a7192b9e04$var$LazyHorizontalPlansNav = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("3mzvo")).then(({ HorizontalPlansNav: HorizontalPlansNav })=>HorizontalPlansNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-plans/src/ui/index.tsx"
});
const $ee88d7a7192b9e04$export$84e1a5f003939496 = ({ store: store })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "horizontal-software-plans-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ee88d7a7192b9e04$var$LazyHorizontalPlansNav, {
        store: store
    }));

});
parcelRegister("3mzvo", function(module, exports) {

let $272ef7c827ed0c69$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("a2cPc"), 4)),
    $272ef7c827ed0c69$var$load("fliVL"),
    $272ef7c827ed0c69$var$load("kNFvF"),
    $272ef7c827ed0c69$var$load("ffQaD"),
    $272ef7c827ed0c69$var$load("kvRbA"),
    $272ef7c827ed0c69$var$load("kVX56"),
    $272ef7c827ed0c69$var$load("76n7a"),
    $272ef7c827ed0c69$var$load("l253H"),
    $272ef7c827ed0c69$var$load("l1q6n")
]).then(()=>parcelRequire('fYibJ'));

});


parcelRegister("937TY", function(module, exports) {

$parcel$export(module.exports, "default", () => $375ae1bde651f684$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

const $375ae1bde651f684$var$LazyPlanSidebar = (0, $kxZPA.lazyForPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("cWlA9")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/plan/src/index.tsx"
});
const $375ae1bde651f684$var$PlanSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "Plan"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($375ae1bde651f684$var$LazyPlanSidebar, null)));
$375ae1bde651f684$var$PlanSidebar.displayName = 'PlanSidebar';
var $375ae1bde651f684$export$2e2bcd8739ae039 = $375ae1bde651f684$var$PlanSidebar;

});
parcelRegister("cWlA9", function(module, exports) {

let $96bba496c3753cd4$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $96bba496c3753cd4$var$load("ffQaD"),
    $96bba496c3753cd4$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("27441"), 4)),
    $96bba496c3753cd4$var$load("2X7cR")
]).then(()=>parcelRequire('5q8CD'));

});


parcelRegister("451ix", function(module, exports) {

$parcel$export(module.exports, "planLayout", () => $fa12faadb00e7e4f$export$94e1d79bf65579e2);

var $aPfsS = parcelRequire("aPfsS");

var $kxZPA = parcelRequire("kxZPA");

const $fa12faadb00e7e4f$export$b6292b5f7e5b5fad = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("j7JIq")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx"
});
const $fa12faadb00e7e4f$export$94e1d79bf65579e2 = (0, $aPfsS.createLayout)({
    globalComponents: [
        $fa12faadb00e7e4f$export$b6292b5f7e5b5fad
    ]
});

});
parcelRegister("j7JIq", function(module, exports) {

let $dec221ec5c09d66c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $dec221ec5c09d66c$var$load("a9fOo").then(()=>parcelRequire('ikoZN'));

});


parcelRegister("czMjG", function(module, exports) {

$parcel$export(module.exports, "planIncrementRoute", () => $1f9e3780cba4a3e0$export$ef33a75556fde209);
const $1f9e3780cba4a3e0$export$ef33a75556fde209 = {
    name: 'software-plan-increment',
    path: '/jira/plans/:planId/scenarios/:scenarioId/program/:incrementId',
    exact: true
};

});

parcelRegister("eCdAs", function(module, exports) {

$parcel$export(module.exports, "planIncrementPageEntryPoint", () => $fd8b21deba1fc1a8$export$a87dd3f7b0d2f7c2);
$parcel$export(module.exports, "planIncrementPageEntryPointWithoutHorizontalNavigation", () => $fd8b21deba1fc1a8$export$1d20f43e7336cbe6);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $8tlKP = parcelRequire("8tlKP");

var $57oLc = parcelRequire("57oLc");
const $fd8b21deba1fc1a8$export$a87dd3f7b0d2f7c2 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $8tlKP.planIncrementEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS,
    horizontalNavigation: (0, $57oLc.plansHorizontalNavigationEntryPoint)
});
const $fd8b21deba1fc1a8$export$1d20f43e7336cbe6 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $8tlKP.planIncrementEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS
});

});
parcelRegister("57oLc", function(module, exports) {

$parcel$export(module.exports, "plansHorizontalNavigationEntryPoint", () => $9252b8e5bbb4c32e$export$172a11f0d118de01);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $fEDBv = parcelRequire("fEDBv");

var $2OZhN = parcelRequire("2OZhN");

var $6LB8G = parcelRequire("6LB8G");

var $ktofH = parcelRequire("ktofH");
function $9252b8e5bbb4c32e$var$toPlanScenarioAri({ siteId: siteId, activationId: activationId, planId: planId, scenarioId: scenarioId }) {
    return `ari:cloud:jira:${siteId}:plan-scenario/activation/${activationId}/${planId}/scenario/${scenarioId}`;
}

const $9252b8e5bbb4c32e$export$172a11f0d118de01 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("6ganA")), {
        moduleId: "8c821489",
        moduleName: "HorizontalNavPlans",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: { match: match }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        const planId = match.params.planId;
        const scenarioId = match.params.scenarioId;
        if (!planId) throw new Error('Plan Id is missing');
        if (!scenarioId) throw new Error('Scenario Id is missing');
        const planScenarioAri = $9252b8e5bbb4c32e$var$toPlanScenarioAri({
            siteId: cloudId,
            activationId: activationId,
            planId: planId,
            scenarioId: scenarioId
        });
        return {
            queries: {
                horizontalNavPlansQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $6LB8G.default,
                    variables: {
                        first: (0, $ktofH.NAVIGATION_ITEMS_PAGE_SIZE),
                        cloudId: cloudId,
                        containerNavigationInput: {
                            scopeId: planScenarioAri
                        }
                    }
                }
            }
        };
    }
});

});
parcelRegister("6LB8G", function(module, exports) {

$parcel$export(module.exports, "default", () => $de2da6d338535497$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<579d50b31430815e25d91a9a65380319>>
 * @relayHash 164c48c3824ef2f0755f6d70fb373e5c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5ae63d79ee56070a78fcd0f81b3991516463430dbed3ae6bcd427e7e0f13d71c
const $de2da6d338535497$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "5ae63d79ee56070a78fcd0f81b3991516463430dbed3ae6bcd427e7e0f13d71c",
        "metadata": {},
        "name": "HorizontalNavPlansQuery",
        "operationKind": "query",
        "text": null
    }
};
var $de2da6d338535497$export$2e2bcd8739ae039 = $de2da6d338535497$var$node;

});

parcelRegister("6ganA", function(module, exports) {

let $48ec49db7bb4f064$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $48ec49db7bb4f064$var$load("ffQaD"),
    $48ec49db7bb4f064$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("deI1u"), 4)),
    $48ec49db7bb4f064$var$load("fliVL"),
    $48ec49db7bb4f064$var$load("gNkmV")
]).then(()=>parcelRequire('2NXnj'));

});



parcelRegister("8iKh5", function(module, exports) {

$parcel$export(module.exports, "LazyPlanIncrement", () => $e45281955bb769d7$export$e7b9f83d442bac51);
$parcel$export(module.exports, "PlanIncrement", () => $e45281955bb769d7$export$5e1035d0876d64db);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $e45281955bb769d7$export$e7b9f83d442bac51 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("1WeVM"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-increment/index-old.tsx"
});
const $e45281955bb769d7$export$5e1035d0876d64db = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e45281955bb769d7$export$e7b9f83d442bac51,
        pageId: "plan-increment",
        shouldShowSpinner: true
    });

});


parcelRegister("bQ0RK", function(module, exports) {

$parcel$export(module.exports, "planIncrementsRouteEntry", () => $38c9ffd9e7c2e0a9$export$f7abc47036ff7dd9);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $8iyFV = parcelRequire("8iyFV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $f3F6W = parcelRequire("f3F6W");

var $4R6GH = parcelRequire("4R6GH");

var $iHuPr = parcelRequire("iHuPr");

var $fw6rG = parcelRequire("fw6rG");
const $38c9ffd9e7c2e0a9$export$f7abc47036ff7dd9 = (0, $7NszV.createEntry)((0, $f3F6W.planIncrementsRoute), ()=>({
        group: 'software',
        entryPoint: ()=>// eslint-disable-next-line no-nested-ternary
            (0, $4R6GH.fg)('migrate_plans_to_entrypoints') ? (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? (0, $fw6rG.planProgramPageEntryPoint) : (0, $fw6rG.planProgramPageEntryPointWithoutHorizontalNavigation) : undefined,
        component: (0, $iHuPr.PlanProgram),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default),
            horizontal: (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? undefined : (0, $8iyFV.AsyncHorizontalNavPlans),
            onlyShowHorizontalOnNav4: true
        },
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource),
            (0, $c3WQb.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $iHuPr.LazyPlanProgram)
        ]
    }));

});
parcelRegister("f3F6W", function(module, exports) {

$parcel$export(module.exports, "planIncrementsRoute", () => $1fae537885c9da25$export$d0986e4bd9568b30);
const $1fae537885c9da25$export$d0986e4bd9568b30 = {
    name: 'software-plan-increments',
    path: '/jira/plans/:planId/scenarios/:scenarioId/program',
    exact: true
};

});

parcelRegister("iHuPr", function(module, exports) {

$parcel$export(module.exports, "LazyPlanProgram", () => $ad7f54b0993adadc$export$9da4d4d5c4d7f749);
$parcel$export(module.exports, "PlanProgram", () => $ad7f54b0993adadc$export$fb30c2b19a4f5d59);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $ad7f54b0993adadc$export$9da4d4d5c4d7f749 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("7tZ8j"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-program/index-old.tsx"
});
const $ad7f54b0993adadc$export$fb30c2b19a4f5d59 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ad7f54b0993adadc$export$9da4d4d5c4d7f749,
        pageId: "plan-program",
        shouldShowSpinner: true
    });

});
parcelRegister("7tZ8j", function(module, exports) {

let $572aa99a7b7a4523$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("fRF2W"), 4)),
    $572aa99a7b7a4523$var$load("foI4g")
]).then(()=>parcelRequire('hWHTd'));

});


parcelRegister("fw6rG", function(module, exports) {

$parcel$export(module.exports, "planProgramPageEntryPoint", () => $d0d482e714f6dec6$export$cb6ac90e8faddaeb);
$parcel$export(module.exports, "planProgramPageEntryPointWithoutHorizontalNavigation", () => $d0d482e714f6dec6$export$4d1acef570d425d5);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $avgZu = parcelRequire("avgZu");

var $57oLc = parcelRequire("57oLc");
const $d0d482e714f6dec6$export$cb6ac90e8faddaeb = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $avgZu.planProgramEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS,
    horizontalNavigation: (0, $57oLc.plansHorizontalNavigationEntryPoint)
});
const $d0d482e714f6dec6$export$4d1acef570d425d5 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $avgZu.planProgramEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS
});

});
parcelRegister("avgZu", function(module, exports) {

$parcel$export(module.exports, "planProgramEntryPoint", () => $9e8c359432edc7ee$export$da91c765d9841bae);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $9e8c359432edc7ee$export$da91c765d9841bae = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("5HXqS")), {
        moduleId: "1b761aac",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("5HXqS", function(module, exports) {

let $427f11f3aa36e392$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("6uYTH"), 4)),
    $427f11f3aa36e392$var$load("lPt5E")
]).then(()=>parcelRequire('laRNy'));

});




parcelRegister("cgOe5", function(module, exports) {

$parcel$export(module.exports, "planPageRouteEntry", () => $877bd5b2a7f04d5c$export$f85a75f1604118ff);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $eG65S = parcelRequire("eG65S");

var $aPfsS = parcelRequire("aPfsS");

var $451ix = parcelRequire("451ix");

var $g6wgl = parcelRequire("g6wgl");

var $caKhF = parcelRequire("caKhF");
// This redirect is required to support legacy routes, it should never be deleted
const $877bd5b2a7f04d5c$var$planPageRedirect = (0, $caKhF.withRedirection)((0, $g6wgl.default), {
    to: '/timeline',
    redirectCondition: ()=>true
});
const $877bd5b2a7f04d5c$export$f85a75f1604118ff = (0, $7NszV.createEntry)((0, $eG65S.planPageRoute), ()=>({
        group: 'software',
        ufoName: 'software-advanced-roadmaps-scenario',
        component: $877bd5b2a7f04d5c$var$planPageRedirect,
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource),
            (0, $c3WQb.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $g6wgl.LazyPlanTimeline)
        ]
    }));

});
parcelRegister("eG65S", function(module, exports) {

$parcel$export(module.exports, "planPageRoute", () => $39ce5190353a5838$export$26495e043d80cccc);
const $39ce5190353a5838$export$26495e043d80cccc = {
    name: 'software-advanced-roadmaps',
    path: '/jira/plans/:planId/scenarios/:scenarioId'
};

});

parcelRegister("caKhF", function(module, exports) {

$parcel$export(module.exports, "withRedirection", () => $25bed75d5ee084fd$export$2c9e4550ef8bdea9);

var $5uXOq = parcelRequire("5uXOq");

var $ds5qV = parcelRequire("ds5qV");

var $doZTA = parcelRequire("doZTA");
function $25bed75d5ee084fd$export$2c9e4550ef8bdea9(Component, { to: to, redirectCondition: redirectCondition }) {
    return ()=>{
        const [{ match: match }] = (0, $doZTA.useRouter)();
        if (match == null || match.params == null || match.params.planId == null || match.params.scenarioId == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
            to: "/jira/plans"
        });
        if (!redirectCondition()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
            to: `/jira/plans/${match.params.planId}/scenarios/${match.params.scenarioId}${to}`
        });
    };
}

});


parcelRegister("2d9QY", function(module, exports) {

$parcel$export(module.exports, "planPageWithoutScenarioIdRouteEntry", () => $c926071780746d94$export$9cbef73b51558ef);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $4qTS7 = parcelRequire("4qTS7");

var $3HwlS = parcelRequire("3HwlS");

var $3ibi7 = parcelRequire("3ibi7");

var $g6wgl = parcelRequire("g6wgl");
const $c926071780746d94$export$9cbef73b51558ef = (0, $7NszV.createEntry)((0, $4qTS7.planPageWithoutScenarioIdRoute), ()=>({
        group: 'software',
        ufoName: 'software-advanced-roadmaps-plan',
        component: (0, $3HwlS.getWillShowNav4)() ? (0, $3ibi7.RedirectPlanPageWithoutScenarioIdLoadQuery) : (0, $3ibi7.RedirectPlanPageWithoutScenarioId),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $g6wgl.LazyPlanTimeline)
        ]
    }));

});
parcelRegister("4qTS7", function(module, exports) {

$parcel$export(module.exports, "planPageWithoutScenarioIdRoute", () => $d753ed11fe1ac80a$export$610e14c9c89d0afb);
const $d753ed11fe1ac80a$export$610e14c9c89d0afb = {
    name: 'software-advanced-roadmaps',
    path: '/jira/plans/:planId(\\d+)'
};

});


parcelRegister("jj70V", function(module, exports) {

$parcel$export(module.exports, "planReportPageRouteEntry", () => $7a323ef2c1a2c74a$export$e71031acce6d7e47);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $aZkeA = parcelRequire("aZkeA");

var $3bZgP = parcelRequire("3bZgP");
const $7a323ef2c1a2c74a$export$e71031acce6d7e47 = (0, $7NszV.createEntry)((0, $aZkeA.planReportPageRoute), ()=>({
        group: 'software',
        ufoName: 'software-advanced-roadmaps-report',
        component: (0, $3bZgP.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $c3WQb.advancedRoadmapsPlanReportPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource),
            (0, $c3WQb.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3bZgP.LazyPlanReport)
        ]
    }));

});
parcelRegister("aZkeA", function(module, exports) {

$parcel$export(module.exports, "planReportPageRoute", () => $082ad5157a706ae9$export$7c8c0761b1ba57bb);
const $082ad5157a706ae9$export$7c8c0761b1ba57bb = {
    name: 'software-advanced-roadmaps',
    path: '/jira/plans/reports/:reportId'
};

});

parcelRegister("3bZgP", function(module, exports) {

$parcel$export(module.exports, "LazyPlanReport", () => $620253f0b511b587$export$fe1fc08f511671db);
$parcel$export(module.exports, "default", () => $620253f0b511b587$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $620253f0b511b587$export$fe1fc08f511671db = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("cAnCG"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-report/index.tsx"
});
const $620253f0b511b587$var$PlanReport = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $620253f0b511b587$export$fe1fc08f511671db,
        pageId: "plan-report",
        shouldShowSpinner: true
    });
var $620253f0b511b587$export$2e2bcd8739ae039 = $620253f0b511b587$var$PlanReport;

});
parcelRegister("cAnCG", function(module, exports) {

let $929b2bd84c9b1637$var$load = (parcelRequire("28QjX"))(4);





module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $929b2bd84c9b1637$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $929b2bd84c9b1637$var$load("k6g9p")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $929b2bd84c9b1637$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $929b2bd84c9b1637$var$load("7B2gt")
        ]);
    }),
    $929b2bd84c9b1637$var$load("ffQaD"),
    $929b2bd84c9b1637$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("kRzLE"), 4)),
    $929b2bd84c9b1637$var$load("76n7a"),
    $929b2bd84c9b1637$var$load("l253H"),
    $929b2bd84c9b1637$var$load("fliVL"),
    $929b2bd84c9b1637$var$load("l8YRe")
]).then(()=>parcelRequire('9UXSF'));

});



parcelRegister("cmIyb", function(module, exports) {

$parcel$export(module.exports, "plansDirectoryRouteEntry", () => $d1aaabcb7e27c9a6$export$4f9df77811fbdc1f);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $8jQu6 = parcelRequire("8jQu6");

var $cFtGt = parcelRequire("cFtGt");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $d1aaabcb7e27c9a6$var$LazyPlansDirectory = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("f4PsM"))), {
    moduleId: "./src/packages/spa-apps/directories/plans/src/index.tsx"
});
const $d1aaabcb7e27c9a6$var$PlansDirectoryComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d1aaabcb7e27c9a6$var$LazyPlansDirectory,
        pageId: "plans-directory",
        shouldShowSpinner: false
    });
const $d1aaabcb7e27c9a6$export$4f9df77811fbdc1f = (0, $7NszV.createEntry)((0, $8jQu6.plansDirectoryRoute), ()=>({
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental'),
        group: 'directories',
        component: $d1aaabcb7e27c9a6$var$PlansDirectoryComponent,
        skeleton: (0, $cFtGt.PlansDirectorySkeleton),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $d1aaabcb7e27c9a6$var$LazyPlansDirectory
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("f4PsM", function(module, exports) {

let $02d525c72e1a1521$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $02d525c72e1a1521$var$load("ffQaD"),
    $02d525c72e1a1521$var$load("kvRbA"),
    $02d525c72e1a1521$var$load("czLNO")
]).then(()=>parcelRequire('flZBd'));

});


parcelRegister("4AqA1", function(module, exports) {

$parcel$export(module.exports, "planSetupPageRouteEntry", () => $3d84c56e2a698202$export$2a24acea4e628148);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $2wBti = parcelRequire("2wBti");

var $2RtMw = parcelRequire("2RtMw");
const $3d84c56e2a698202$export$2a24acea4e628148 = (0, $7NszV.createEntry)((0, $2wBti.planSetupPageRoute), ()=>({
        group: 'software',
        component: (0, $2RtMw.default),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $2RtMw.LazyAdvancedRoadmapsSetup)
        ]
    }));

});
parcelRegister("2wBti", function(module, exports) {

$parcel$export(module.exports, "planSetupPageRoute", () => $08361bcde105abef$export$4815756bb523904e);
const $08361bcde105abef$export$4815756bb523904e = {
    name: 'software-advanced-roadmaps-setup',
    path: '/jira/plans/:planId/setup'
};

});

parcelRegister("2RtMw", function(module, exports) {

$parcel$export(module.exports, "LazyAdvancedRoadmapsSetup", () => $360fed07fa6fa9e9$export$46bb3a1779d7815b);
$parcel$export(module.exports, "default", () => $360fed07fa6fa9e9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $360fed07fa6fa9e9$export$46bb3a1779d7815b = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("iN8tI"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/setup/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$360fed07fa6fa9e9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $360fed07fa6fa9e9$export$46bb3a1779d7815b,
        pageId: "advanced-roadmaps-setup",
        shouldShowSpinner: true
    });

});
parcelRegister("iN8tI", function(module, exports) {

let $dae3613548c045cc$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $dae3613548c045cc$var$load("ffQaD"),
    $dae3613548c045cc$var$load("kvRbA"),
    $dae3613548c045cc$var$load("gtmRO")
]).then(()=>parcelRequire('bF4NR'));

});



parcelRegister("5qx9W", function(module, exports) {

$parcel$export(module.exports, "planUpsellRouteEntry", () => $7ff38098f11bff34$export$363894d991872cbf);

var $7NszV = parcelRequire("7NszV");

var $eCT4E = parcelRequire("eCT4E");

var $lmyls = parcelRequire("lmyls");

var $2BrOV = parcelRequire("2BrOV");

var $3RJkv = parcelRequire("3RJkv");

var $eeeSt = parcelRequire("eeeSt");
const $7ff38098f11bff34$export$363894d991872cbf = (0, $7NszV.createEntry)((0, $eCT4E.planUpsellRoute), ()=>({
        group: 'software',
        entryPoint () {
            return 0, $eeeSt.planUpsellPageEntryPoint;
        },
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS
        }
    }));

});
parcelRegister("eeeSt", function(module, exports) {

$parcel$export(module.exports, "planUpsellPageEntryPoint", () => $8fee77540cc4840f$export$7551fe27e3c0a4bf);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $fzr0K = parcelRequire("fzr0K");
const $8fee77540cc4840f$export$7551fe27e3c0a4bf = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $fzr0K.planUpsellEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS
});

});


parcelRegister("5dqn2", function(module, exports) {

$parcel$export(module.exports, "planViewNotFoundRouteEntry", () => $e166e971b74a927b$export$19c7bb0eeda48c06);

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $NONdU = parcelRequire("NONdU");

var $aPfsS = parcelRequire("aPfsS");

var $2BrOV = parcelRequire("2BrOV");

var $451ix = parcelRequire("451ix");

var $937TY = parcelRequire("937TY");

var $lEqGO = parcelRequire("lEqGO");
const $e166e971b74a927b$export$19c7bb0eeda48c06 = (0, $7NszV.createEntry)((0, $NONdU.planViewNotFoundRoute), ()=>({
        group: 'software',
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default),
            horizontal: undefined,
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)()
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        entryPoint: ()=>(0, $lEqGO.planViewNotFoundPageEntrypoint)
    }));

});
parcelRegister("NONdU", function(module, exports) {

$parcel$export(module.exports, "planViewNotFoundRoute", () => $81b3aac8927596c6$export$f2531e319f8b4274);
const $81b3aac8927596c6$export$f2531e319f8b4274 = {
    name: 'plan-view-not-found',
    path: '/jira/plans/:planId/scenarios/:scenarioId/not-found'
};

});

parcelRegister("lEqGO", function(module, exports) {

$parcel$export(module.exports, "planViewNotFoundPageEntrypoint", () => $5fbb9e47837eed67$export$18e8a0d930f394a2);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $1RGLt = parcelRequire("1RGLt");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $57oLc = parcelRequire("57oLc");

const $5fbb9e47837eed67$var$main = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("7RUUm")), {
        moduleId: "f2ea0209",
        moduleName: "PlanViewNotFound",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: { match: match }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        const planId = match.params.planId;
        if (!planId) throw new Error('Plan Id is missing');
        return {
            queries: {
                mainQuery: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $1RGLt.default,
                    variables: {
                        planId: `ari:cloud:jira:${cloudId}:plan/activation/${activationId}/${planId}`
                    }
                }
            }
        };
    }
});
const $5fbb9e47837eed67$export$18e8a0d930f394a2 = (0, $lkFvK.createPageEntryPoint)({
    main: $5fbb9e47837eed67$var$main,
    horizontalNavigation: (0, $57oLc.plansHorizontalNavigationEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS
});

});
parcelRegister("1RGLt", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e981f11ecdd6cbe$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f97e78ab59091e8012bd8a05696ce789>>
 * @relayHash c51281360f2d7bd5387e9bb058f11f6d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 29dd5915a4af58bbd22d79842971790506a1f3ab87507ab96eca150acfd91229
const $5e981f11ecdd6cbe$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "29dd5915a4af58bbd22d79842971790506a1f3ab87507ab96eca150acfd91229",
        "metadata": {},
        "name": "PlanViewNotFoundQuery",
        "operationKind": "query",
        "text": null
    }
};
var $5e981f11ecdd6cbe$export$2e2bcd8739ae039 = $5e981f11ecdd6cbe$var$node;

});

parcelRegister("7RUUm", function(module, exports) {

let $5ba9a0650a3e27d5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5ba9a0650a3e27d5$var$load("1vYQA").then(()=>parcelRequire('eIJQP'));

});



parcelRegister("3L1EU", function(module, exports) {

$parcel$export(module.exports, "polarisCollectionsRouteEntry", () => $4aedad13e1b8926d$export$a034dc25c21d1029);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $1bDWO = parcelRequire("1bDWO");

var $iI3aS = parcelRequire("iI3aS");
const $4aedad13e1b8926d$export$a034dc25c21d1029 = (0, $7NszV.createEntry)((0, $1bDWO.polarisCollectionsRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'polaris',
        ufoName: 'jpd.collections',
        component: (0, $iI3aS.default),
        layout: (0, $2BrOV.globalLayout),
        canTransitionIn: ()=>{
            // default is no-refresh
            return true;
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $iI3aS.LazyCollectionsPage)
        ]
    }));

});
parcelRegister("1bDWO", function(module, exports) {

$parcel$export(module.exports, "polarisCollectionsRoute", () => $31434a8eaec0208e$export$d415b74f78a5f159);
const $31434a8eaec0208e$export$d415b74f78a5f159 = {
    name: 'polaris-collections',
    path: '/jira/polaris/roadmaps/:collectionUUID?/:section?/:resource?',
    query: [
        'projects?',
        'owners?'
    ],
    exact: true
};

});

parcelRegister("iI3aS", function(module, exports) {

$parcel$export(module.exports, "LazyCollectionsPage", () => $1bfc7c5d195e4066$export$f7960e7dbd7e5265);
$parcel$export(module.exports, "default", () => $1bfc7c5d195e4066$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dWQF5 = parcelRequire("dWQF5");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $9OXo1 = parcelRequire("9OXo1");

var $kxZPA = parcelRequire("kxZPA");

var $7tQej = parcelRequire("7tQej");

const $1bfc7c5d195e4066$export$f7960e7dbd7e5265 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("kNCUR"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/polaris/collections/src/index.tsx"
});
const $1bfc7c5d195e4066$var$useJpdLicensed = ()=>{
    const context = (0, $9OXo1.useTenantContext)();
    return context.licensedProducts['jira-product-discovery'];
};
const $1bfc7c5d195e4066$export$3bba33442c4150b1 = ()=>{
    const jpdLicensed = $1bfc7c5d195e4066$var$useJpdLicensed();
    const crossProjectViewsEnabled = (0, $dWQF5.useIsCrossProjectViewsEnabled)();
    if (!jpdLicensed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: "/jira/polaris/unlicensed"
    });
    if (!crossProjectViewsEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: "/jira"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $1bfc7c5d195e4066$export$f7960e7dbd7e5265,
        pageId: "async-polaris-collections",
        shouldShowSpinner: false
    });
};
var $1bfc7c5d195e4066$export$2e2bcd8739ae039 = $1bfc7c5d195e4066$export$3bba33442c4150b1;

});
parcelRegister("kNCUR", function(module, exports) {

let $f24692343689530b$var$load = (parcelRequire("28QjX"))(4);


module.exports = Promise.all([
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $f24692343689530b$var$load("cTJTG"),
            $f24692343689530b$var$load("l253H"),
            $f24692343689530b$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $f24692343689530b$var$load("4Qxp7")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $f24692343689530b$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $f24692343689530b$var$load("7B2gt")
        ]);
    }),
    $f24692343689530b$var$load("ffQaD"),
    $f24692343689530b$var$load("kvRbA"),
    $f24692343689530b$var$load("76n7a"),
    $f24692343689530b$var$load("l253H"),
    $f24692343689530b$var$load("fliVL"),
    $f24692343689530b$var$load("lOpCK")
]).then(()=>parcelRequire('jaSwr'));

});



parcelRegister("g5olQ", function(module, exports) {

$parcel$export(module.exports, "polarisIdeasRouteEntry", () => $a75ffafad7078936$export$26631f98f007b2d2);

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $eviST = parcelRequire("eviST");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $1Yu63 = parcelRequire("1Yu63");

var $hO84v = parcelRequire("hO84v");
const $a75ffafad7078936$export$26631f98f007b2d2 = (0, $7NszV.createEntry)((0, $1Yu63.polarisIdeasRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'polaris',
        ufoName: 'jpd.project',
        layout: (0, $eviST.polarisProjectLayout),
        canTransitionIn: ()=>true,
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint () {
            return 0, $hO84v.ideasPageEntryPoint;
        },
        preloadOptions: {
            earlyChunks: [
                'jpd-ideas-early-entry'
            ]
        }
    }));

});
parcelRegister("eviST", function(module, exports) {

$parcel$export(module.exports, "polarisProjectLayout", () => $501e6cef37d28e94$export$d5273c1a2e2fe212);

var $1Du13 = parcelRequire("1Du13");

var $aPfsS = parcelRequire("aPfsS");
const $501e6cef37d28e94$export$d5273c1a2e2fe212 = (0, $aPfsS.composeLayouts)((0, $1Du13.projectLayout));

});

parcelRegister("1Yu63", function(module, exports) {

$parcel$export(module.exports, "polarisIdeasRoute", () => $3378a983c17fef3f$export$54c333cd4ed2d70e);
const $3378a983c17fef3f$export$54c333cd4ed2d70e = {
    name: 'polaris-ideas',
    path: '/jira/polaris/projects/:projectKey/ideas/:section?/:resource?',
    query: [
        'selectedIssue?',
        'issueViewLayout?'
    ],
    exact: true
};

});

parcelRegister("hO84v", function(module, exports) {

$parcel$export(module.exports, "ideasPageEntryPoint", () => $9c1678c5da04bd73$export$aa9a00411f9c3e39);

var $lmyls = parcelRequire("lmyls");

var $lkFvK = parcelRequire("lkFvK");

var $jVaQG = parcelRequire("jVaQG");
const $9c1678c5da04bd73$export$aa9a00411f9c3e39 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $jVaQG.ideasEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("jVaQG", function(module, exports) {

$parcel$export(module.exports, "ideasEntryPoint", () => $5c23c7623190e5b0$export$ffc470fa0659ba16);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $5c23c7623190e5b0$export$ffc470fa0659ba16 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("jayZv")), {
        moduleId: "3b89e133",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("jayZv", function(module, exports) {

let $df4a17fe07e81060$var$load = (parcelRequire("28QjX"))(4);


module.exports = Promise.all([
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $df4a17fe07e81060$var$load("cTJTG"),
            $df4a17fe07e81060$var$load("l253H"),
            $df4a17fe07e81060$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $df4a17fe07e81060$var$load("4Qxp7")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $df4a17fe07e81060$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $df4a17fe07e81060$var$load("7B2gt")
        ]);
    }),
    $df4a17fe07e81060$var$load("ffQaD"),
    $df4a17fe07e81060$var$load("kvRbA"),
    $df4a17fe07e81060$var$load("76n7a"),
    $df4a17fe07e81060$var$load("l253H"),
    $df4a17fe07e81060$var$load("fliVL"),
    $df4a17fe07e81060$var$load("biBC0")
]).then(()=>parcelRequire('glCkY'));

});




parcelRegister("ecUH3", function(module, exports) {

$parcel$export(module.exports, "polarisOnboardingRouteEntry", () => $9a1e9d5292b9a0dc$export$a297a71cb150e2af);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $aFVvc = parcelRequire("aFVvc");

var $brgR1 = parcelRequire("brgR1");

var $dQc5Q = parcelRequire("dQc5Q");
const $9a1e9d5292b9a0dc$export$a297a71cb150e2af = (0, $7NszV.createEntry)((0, $brgR1.polarisOnboardingRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'polaris',
        component: (0, $dQc5Q.default),
        layout: (0, $2BrOV.globalLayout),
        canTransitionIn: ()=>true,
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $aFVvc.projectCreatePermissionsResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $dQc5Q.LazyOnboardingPage)
        ]
    }));

});
parcelRegister("brgR1", function(module, exports) {

$parcel$export(module.exports, "polarisOnboardingRoute", () => $d7e18a0721187b3f$export$6696e9deb45fe980);
const $d7e18a0721187b3f$export$6696e9deb45fe980 = {
    name: 'polaris-onboarding',
    path: '/welcome/discovery',
    exact: true
};

});

parcelRegister("dQc5Q", function(module, exports) {

$parcel$export(module.exports, "LazyOnboardingPage", () => $ff87f692d7c58a17$export$13889cc3ce0d5a93);
$parcel$export(module.exports, "default", () => $ff87f692d7c58a17$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $ff87f692d7c58a17$export$13889cc3ce0d5a93 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("j3mJn"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/polaris/onboarding/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ff87f692d7c58a17$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ff87f692d7c58a17$export$13889cc3ce0d5a93,
        pageId: "async-polaris-onboarding",
        shouldShowSpinner: false
    });

});
parcelRegister("j3mJn", function(module, exports) {

let $ddefedff4c6cb88e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ddefedff4c6cb88e$var$load("giy0q").then(()=>parcelRequire('2PQGe'));

});



parcelRegister("6okEU", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsAccessRouteEntry", () => $23f05070dbae84f0$export$9c0f51630c25c3d);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $jUKSc = parcelRequire("jUKSc");

var $4csue = parcelRequire("4csue");
const $23f05070dbae84f0$export$9c0f51630c25c3d = (0, $7NszV.createEntry)((0, $jUKSc.polarisSettingsAccessRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'global-settings',
        component: (0, $4csue.AccessSettingsPage),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4csue.LazyAccessSettingsPage)
        ]
    }));

});
parcelRegister("jUKSc", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsAccessRoute", () => $5cb169f7c1c57d8b$export$bfdcdf76e802d67d);
const $5cb169f7c1c57d8b$export$bfdcdf76e802d67d = {
    name: 'polaris-settings-access',
    path: '/jira/settings/products/jira-product-discovery/access',
    exact: true
};

});

parcelRegister("4csue", function(module, exports) {

$parcel$export(module.exports, "LazyAccessSettingsPage", () => $ff4634525ed299f8$export$b66ea0dcd38af7f0);
$parcel$export(module.exports, "AccessSettingsPage", () => $ff4634525ed299f8$export$d46497fe68b0853c);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $ff4634525ed299f8$export$b66ea0dcd38af7f0 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("c7uoK"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/polaris/settings-access/src/index.tsx"
});
const $ff4634525ed299f8$export$d46497fe68b0853c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ff4634525ed299f8$export$b66ea0dcd38af7f0,
        pageId: "async-polaris-settings-access",
        shouldShowSpinner: false
    });

});
parcelRegister("c7uoK", function(module, exports) {

let $8d2db7e78fb03a36$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8d2db7e78fb03a36$var$load("25TW9").then(()=>parcelRequire('ab4oe'));

});



parcelRegister("9vMJ0", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsDatesRouteEntry", () => $497ad9cfc7139300$export$df39bbcec5c3d8fb);

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $gD7VO = parcelRequire("gD7VO");

var $eUjyB = parcelRequire("eUjyB");
const $497ad9cfc7139300$export$df39bbcec5c3d8fb = (0, $7NszV.createEntry)((0, $gD7VO.polarisSettingsDatesRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'global-settings',
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)()
        ],
        entryPoint () {
            return 0, $eUjyB.polarisProductFinancialYearSettingsPageEntryPoint;
        }
    }));

});
parcelRegister("gD7VO", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsDatesRoute", () => $9fe2451188657c9d$export$41bd51b740ebfe25);
const $9fe2451188657c9d$export$41bd51b740ebfe25 = {
    name: 'polaris-settings-financial-year',
    path: '/jira/settings/products/jira-product-discovery/dates',
    exact: true
};

});

parcelRegister("eUjyB", function(module, exports) {

$parcel$export(module.exports, "polarisProductFinancialYearSettingsPageEntryPoint", () => $54953d335cd55907$export$b1c132cd756e9b86);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $4vOBH = parcelRequire("4vOBH");
const $54953d335cd55907$export$b1c132cd756e9b86 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $4vOBH.polarisProductFinancialYearSettingsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).SETTINGS
});

});
parcelRegister("4vOBH", function(module, exports) {

$parcel$export(module.exports, "polarisProductFinancialYearSettingsEntryPoint", () => $b962cb3dff43d6f8$export$2e0ef763d6b208ea);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $b962cb3dff43d6f8$export$2e0ef763d6b208ea = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("6UnRY")), {
        moduleId: "47bc544f",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("6UnRY", function(module, exports) {

let $507a7d07925f38dc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $507a7d07925f38dc$var$load("aeyGa").then(()=>parcelRequire('cqP15'));

});




parcelRegister("gAq9g", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsEarlyAccessFeaturesRouteEntry", () => $bf181a7631938891$export$986710683a071056);

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $6HnX2 = parcelRequire("6HnX2");

var $9EMQz = parcelRequire("9EMQz");
const $bf181a7631938891$export$986710683a071056 = (0, $7NszV.createEntry)((0, $6HnX2.polarisSettingsEarlyAccessFeaturesRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'global-settings',
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)()
        ],
        entryPoint () {
            return 0, $9EMQz.polarisProductEAPSettingsPageEntryPoint;
        }
    }));

});
parcelRegister("6HnX2", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsEarlyAccessFeaturesRoute", () => $33928478759c7483$export$19bd38107b2ac64b);
const $33928478759c7483$export$19bd38107b2ac64b = {
    name: 'polaris-settings-early-access-features',
    path: '/jira/settings/products/jira-product-discovery/early-access-features',
    exact: true
};

});

parcelRegister("9EMQz", function(module, exports) {

$parcel$export(module.exports, "polarisProductEAPSettingsPageEntryPoint", () => $b121880695e6f137$export$1bd9d2b1f32dc9ee);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $7fx7L = parcelRequire("7fx7L");
const $b121880695e6f137$export$1bd9d2b1f32dc9ee = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7fx7L.polarisProductEAPSettingsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).SETTINGS
});

});
parcelRegister("7fx7L", function(module, exports) {

$parcel$export(module.exports, "polarisProductEAPSettingsEntryPoint", () => $cd1239aae9aba238$export$92df711874ab564a);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $cd1239aae9aba238$export$92df711874ab564a = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("163GN")), {
        moduleId: "e4e16138",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("163GN", function(module, exports) {

let $0cc93697834eba9b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0cc93697834eba9b$var$load("kNl59").then(()=>parcelRequire('exNFO'));

});




parcelRegister("9YDUs", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsGlobalFieldsRouteEntry", () => $8b674ae9037c6c90$export$e29465c661741392);

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $ieDqa = parcelRequire("ieDqa");

var $6gpmn = parcelRequire("6gpmn");
const $8b674ae9037c6c90$export$e29465c661741392 = (0, $7NszV.createEntry)((0, $ieDqa.polarisSettingsGlobalFieldsRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'global-settings',
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)()
        ],
        entryPoint () {
            return 0, $6gpmn.polarisProductGlobalFieldsSettingsPageEntryPoint;
        }
    }));

});
parcelRegister("ieDqa", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsGlobalFieldsRoute", () => $1d178fd38105ca54$export$d1d77b6a84982ab8);
const $1d178fd38105ca54$export$d1d77b6a84982ab8 = {
    name: 'polaris-settings-global-fields',
    path: '/jira/settings/products/jira-product-discovery/global-fields',
    exact: true
};

});

parcelRegister("6gpmn", function(module, exports) {

$parcel$export(module.exports, "polarisProductGlobalFieldsSettingsPageEntryPoint", () => $dd5db072b96b7a9a$export$c682ebcd2290352f);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $gZZ5s = parcelRequire("gZZ5s");
const $dd5db072b96b7a9a$export$c682ebcd2290352f = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $gZZ5s.polarisProductGlobalFieldsSettingsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).SETTINGS
});

});
parcelRegister("gZZ5s", function(module, exports) {

$parcel$export(module.exports, "polarisProductGlobalFieldsSettingsEntryPoint", () => $7946c690dff6c696$export$f2f24531058bc251);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $7946c690dff6c696$export$f2f24531058bc251 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("cPs1V")), {
        moduleId: "fead11bc",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("cPs1V", function(module, exports) {

let $956ffda688b494f2$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $956ffda688b494f2$var$load("ffQaD"),
    $956ffda688b494f2$var$load("kvRbA"),
    $956ffda688b494f2$var$load("dYILR")
]).then(()=>parcelRequire('b26tT'));

});




parcelRegister("6ElYx", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsViewBlueprintsRouteEntry", () => $e66c079ef35da565$export$3a434d3b47ab1779);

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $4R6GH = parcelRequire("4R6GH");

var $5lsNZ = parcelRequire("5lsNZ");

var $3RJkv = parcelRequire("3RJkv");

var $cn2EV = parcelRequire("cn2EV");

var $g1n0t = parcelRequire("g1n0t");
const $e66c079ef35da565$export$3a434d3b47ab1779 = (0, $7NszV.createEntry)((0, $cn2EV.polarisSettingsViewBlueprintsRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'global-settings',
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        component: (0, $5lsNZ.default),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)()
        ],
        entryPoint () {
            return (0, $4R6GH.fg)('jpd-view-templates-sample-project') ? (0, $g1n0t.polarisProductViewBlueprintsSettingsPageEntryPoint) : undefined;
        }
    }));

});
parcelRegister("cn2EV", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsViewBlueprintsRoute", () => $edb522df64f463be$export$8a86f742c99c33c);
const $edb522df64f463be$export$8a86f742c99c33c = {
    name: 'polaris-settings-view-blueprints',
    path: '/jira/settings/products/jira-product-discovery/view-blueprints',
    exact: true
};

});

parcelRegister("g1n0t", function(module, exports) {

$parcel$export(module.exports, "polarisProductViewBlueprintsSettingsPageEntryPoint", () => $dab74faa23cd301e$export$b38d612b8eddc59a);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $a8Qvh = parcelRequire("a8Qvh");
const $dab74faa23cd301e$export$b38d612b8eddc59a = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $a8Qvh.polarisProductViewBlueprintsSettingsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).SETTINGS
});

});
parcelRegister("a8Qvh", function(module, exports) {

$parcel$export(module.exports, "polarisProductViewBlueprintsSettingsEntryPoint", () => $423dbee6f0d25e86$export$39c56d81a6a3e673);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $423dbee6f0d25e86$export$39c56d81a6a3e673 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("eXAgS")), {
        moduleId: "a9a1a8f1",
        moduleName: "PolarisViewBlueprintsSettingsPage",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("eXAgS", function(module, exports) {

let $ae42b61112ce48db$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ae42b61112ce48db$var$load("df3Va").then(()=>parcelRequire('lWvfd'));

});




parcelRegister("h3JFI", function(module, exports) {

$parcel$export(module.exports, "polarisUnlicensedRouteEntry", () => $ed78a6ddbb53401e$export$f975154b9b0ce777);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $aFVvc = parcelRequire("aFVvc");

var $aBsar = parcelRequire("aBsar");

var $5gkML = parcelRequire("5gkML");
const $ed78a6ddbb53401e$export$f975154b9b0ce777 = (0, $7NszV.createEntry)((0, $aBsar.polarisUnlicensedRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'polaris',
        component: (0, $5gkML.default),
        layout: (0, $2BrOV.globalLayout),
        canTransitionIn: ()=>true,
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $aFVvc.projectCreatePermissionsResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5gkML.LazyUnlicensedPage)
        ]
    }));

});
parcelRegister("aBsar", function(module, exports) {

$parcel$export(module.exports, "polarisUnlicensedRoute", () => $451d03603cca57ae$export$32b1bc71501d2751);
const $451d03603cca57ae$export$32b1bc71501d2751 = {
    name: 'polaris-unlicensed',
    path: '/jira/polaris/unlicensed',
    exact: true
};

});

parcelRegister("5gkML", function(module, exports) {

$parcel$export(module.exports, "LazyUnlicensedPage", () => $14579de685a40428$export$394984ca86b38b8f);
$parcel$export(module.exports, "default", () => $14579de685a40428$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $14579de685a40428$export$394984ca86b38b8f = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("gPXeU"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/polaris/unlicensed/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$14579de685a40428$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $14579de685a40428$export$394984ca86b38b8f,
        pageId: "async-polaris-unlicensed",
        shouldShowSpinner: false
    });

});
parcelRegister("gPXeU", function(module, exports) {

let $c41f5c821fd0788b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c41f5c821fd0788b$var$load("jiGTm").then(()=>parcelRequire('5KpQH'));

});



parcelRegister("5uMDF", function(module, exports) {

$parcel$export(module.exports, "productsJcsCustomerAccessRouteEntry", () => $896a9842aa03470c$export$487fd1bbb9f3684e);

var $4R6GH = parcelRequire("4R6GH");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $jGT6h = parcelRequire("jGT6h");

var $8xIbV = parcelRequire("8xIbV");

var $5lsNZ = parcelRequire("5lsNZ");

var $6IgbX = parcelRequire("6IgbX");

var $cuwqc = parcelRequire("cuwqc");
const $896a9842aa03470c$var$productsJcsCustomerAccessEntryPointPage = (0, $lkFvK.createPageEntryPoint)({
    main: $8xIbV.productsJcsCustomerAccessEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).SETTINGS
});
const $896a9842aa03470c$export$487fd1bbb9f3684e = (0, $7NszV.createEntry)((0, $jGT6h.productsJcsCustomerAccessRoute), ()=>({
        group: 'global-settings',
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('jcs_master_flag') ? $896a9842aa03470c$var$productsJcsCustomerAccessEntryPointPage : undefined;
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $cuwqc.jsmGlobalCustomerAccessSettingsResource),
            (0, $6IgbX.jsmGlobalCustomerAccessAffectedProjectsResource)
        ]
    }));

});
parcelRegister("jGT6h", function(module, exports) {

$parcel$export(module.exports, "productsJcsCustomerAccessRoute", () => $810d264c2a8581fd$export$db5278559525ffee);
const $810d264c2a8581fd$export$db5278559525ffee = {
    name: 'products-jcs-customer-access',
    path: '/jira/settings/products/customerservice/customer-access',
    exact: true
};

});

parcelRegister("8xIbV", function(module, exports) {

$parcel$export(module.exports, "productsJcsCustomerAccessEntryPoint", () => $2f553626bc230951$export$a10305920ea7bd7);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $2f553626bc230951$export$a10305920ea7bd7 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("6nuR6")), {
        moduleId: "d1f6773e",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("6nuR6", function(module, exports) {

let $4a4cd34ff38c3020$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4a4cd34ff38c3020$var$load("462n9").then(()=>parcelRequire('8f4JT'));

});


parcelRegister("6IgbX", function(module, exports) {

$parcel$export(module.exports, "jsmGlobalCustomerAccessAffectedProjectsResource", () => $da9f8bab48dab68f$export$f27acbd4701f5dfe);

var $2M1hQ = parcelRequire("2M1hQ");

const $da9f8bab48dab68f$var$ONE_DAY_IN_MILLIS = 86400000;

const $da9f8bab48dab68f$export$f27acbd4701f5dfe = (0, $2M1hQ.createResource)({
    type: (0, $700dba149c7972be$export$341f26dde034af5b),
    getKey: ()=>'affected-projects',
    getDataLoader: ()=>(parcelRequire("2hpwE")),
    maxAge: $da9f8bab48dab68f$var$ONE_DAY_IN_MILLIS
});

});
const $700dba149c7972be$export$341f26dde034af5b = 'JSM_CUSTOMER_ACCESS_AFFECTED_PROJECTS';
const $700dba149c7972be$export$eb7818fb178a80b4 = 'JSM_GLOBAL_CUSTOMER_ACCESS_SETTINGS';

parcelRegister("2hpwE", function(module, exports) {

let $1a90f822bfab362c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1a90f822bfab362c$var$load("aRUIJ").then(()=>parcelRequire('8QdIc'));

});


parcelRegister("cuwqc", function(module, exports) {

$parcel$export(module.exports, "jsmGlobalCustomerAccessSettingsResource", () => $ab848c99e9d2daf7$export$b1a50ad717b4ca61);

var $2M1hQ = parcelRequire("2M1hQ");

const $ab848c99e9d2daf7$var$ONE_DAY_IN_MILLIS = 86400000;

const $ab848c99e9d2daf7$export$b1a50ad717b4ca61 = (0, $2M1hQ.createResource)({
    type: (0, $700dba149c7972be$export$eb7818fb178a80b4),
    getKey: ()=>'settings',
    getDataLoader: ()=>(parcelRequire("fmDBD")),
    maxAge: $ab848c99e9d2daf7$var$ONE_DAY_IN_MILLIS
});

});
parcelRegister("fmDBD", function(module, exports) {

let $b2f7a1fe5c3e4783$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b2f7a1fe5c3e4783$var$load("6RmSY").then(()=>parcelRequire('4pG8m'));

});



parcelRegister("3RvJ0", function(module, exports) {

$parcel$export(module.exports, "productsJcsFormFieldsRouteEntry", () => $5e479a4488e4cc4e$export$ce43ae01ccf4d9b6);

var $4R6GH = parcelRequire("4R6GH");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $3niDA = parcelRequire("3niDA");

var $ftS5c = parcelRequire("ftS5c");

var $5lsNZ = parcelRequire("5lsNZ");

var $4oU7e = parcelRequire("4oU7e");
const $5e479a4488e4cc4e$var$productsJcsFormFieldsEntryPointPage = (0, $lkFvK.createPageEntryPoint)({
    main: $ftS5c.productsJcsFormFieldsEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).SETTINGS
});
const $5e479a4488e4cc4e$export$ce43ae01ccf4d9b6 = (0, $7NszV.createEntry)((0, $3niDA.productsJcsFormFieldsRoute), ()=>({
        group: 'global-settings',
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('jcs_forms_resiliency_fast_follows') ? $5e479a4488e4cc4e$var$productsJcsFormFieldsEntryPointPage : undefined;
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $4oU7e.formFieldsResource)
        ]
    }));

});
parcelRegister("3niDA", function(module, exports) {

$parcel$export(module.exports, "productsJcsFormFieldsRoute", () => $29928e55102e185a$export$ace810399baa80ca);
const $29928e55102e185a$export$ace810399baa80ca = {
    name: 'products-jcs-form-fields',
    path: '/jira/settings/products/customerservice/form-fields',
    exact: true
};

});

parcelRegister("ftS5c", function(module, exports) {

$parcel$export(module.exports, "productsJcsFormFieldsEntryPoint", () => $18c73624925e2d30$export$4afec7b2100b3396);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $18c73624925e2d30$export$4afec7b2100b3396 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("jMzD4")), {
        moduleId: "b263f162",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("jMzD4", function(module, exports) {

let $e66e23346554f4fa$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e66e23346554f4fa$var$load("kkDPU").then(()=>parcelRequire('kL0fx'));

});


parcelRegister("4oU7e", function(module, exports) {

$parcel$export(module.exports, "setSearchFieldsFormQuery", () => $5806ca2e66378d57$export$52917d9e09f11230);
$parcel$export(module.exports, "formFieldsResource", () => $5806ca2e66378d57$export$cf387af041de8a73);

var $2M1hQ = parcelRequire("2M1hQ");

var $7f4tk = parcelRequire("7f4tk");

var $1m4nn = parcelRequire("1m4nn");
const $5806ca2e66378d57$export$2345ec6675b232f1 = {};
const $5806ca2e66378d57$export$52917d9e09f11230 = (query)=>{
    $5806ca2e66378d57$export$2345ec6675b232f1.query = query;
};
const $5806ca2e66378d57$export$cf387af041de8a73 = (0, $2M1hQ.createResource)({
    type: 'FORM_FIELDS_RESOURCE',
    // The query.page in getData() is cached, and only changes if getKey() returns a new value
    getKey: ({ query: query })=>`form-fields${query?.page || 1}`,
    getData: async ({ query: query })=>(0, $7f4tk.default)((0, $1m4nn.getUrl)(query?.page, $5806ca2e66378d57$export$2345ec6675b232f1.query)),
    maxAge: 0
});

});
parcelRegister("1m4nn", function(module, exports) {

$parcel$export(module.exports, "PAGE_SIZE", () => $1f5621e396d56d5b$export$8ec3d08588d2eeda);
$parcel$export(module.exports, "getUrl", () => $1f5621e396d56d5b$export$94df0e59ebebf4a7);
const $1f5621e396d56d5b$export$8ec3d08588d2eeda = 50;
const $1f5621e396d56d5b$var$getStartAt = (page)=>{
    const pageNum = Number(page);
    if (!page || Number.isNaN(pageNum)) return 0;
    return (pageNum - 1) * $1f5621e396d56d5b$export$8ec3d08588d2eeda;
};
const $1f5621e396d56d5b$export$94df0e59ebebf4a7 = (page, query)=>`/rest/jcs/admin/v1/request-intake/global-fields?startAt=${$1f5621e396d56d5b$var$getStartAt(page)}${query ? `&query=${query}` : ''}`;

});



parcelRegister("3rBGh", function(module, exports) {

$parcel$export(module.exports, "productsJsmAuthenticationSettingsRouteEntry", () => $9cff46e3a47cb509$export$de5cc5a334946074);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $jKASa = parcelRequire("jKASa");

var $3RJkv = parcelRequire("3RJkv");

var $5ANfe = parcelRequire("5ANfe");

var $1xsZo = parcelRequire("1xsZo");
const $9cff46e3a47cb509$export$de5cc5a334946074 = (0, $7NszV.createEntry)((0, $5ANfe.productsJsmAuthenticationSettingsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-authentication-settings',
        component: (0, $1xsZo.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $jKASa.jsmCustomerAuthenticationSettingsResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $1xsZo.LazyAuthenticationSettings)
        ]
    }));

});
parcelRegister("jKASa", function(module, exports) {

$parcel$export(module.exports, "jsmCustomerAuthenticationSettingsResource", () => $3f20045f00d71d00$export$73134c05a3c27bd);

var $2M1hQ = parcelRequire("2M1hQ");

var $8Pbm3 = parcelRequire("8Pbm3");

const $3f20045f00d71d00$export$73134c05a3c27bd = (0, $2M1hQ.createResource)({
    type: (0, $8Pbm3.RESOURCE_TYPE_JSM_CUSTOMER_AUTHENTICATION_SETTINGS),
    getKey: ()=>'settings',
    getDataLoader: ()=>(parcelRequire("k8U7S")),
    maxAge: (0, $8Pbm3.ONE_DAY_IN_MILLIS)
});

});
parcelRegister("8Pbm3", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_JSM_CUSTOMER_AUTHENTICATION_SETTINGS", () => $bbe3b013803e2d85$export$6a2799d78d98b915);
$parcel$export(module.exports, "ONE_DAY_IN_MILLIS", () => $bbe3b013803e2d85$export$5a00268156ea5027);
const $bbe3b013803e2d85$export$6a2799d78d98b915 = 'JSM_CUSTOMER_AUTHENTICATION_SETTINGS';
const $bbe3b013803e2d85$export$5a00268156ea5027 = 86400000;

});

parcelRegister("k8U7S", function(module, exports) {

let $eaa0177cc709c1d9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eaa0177cc709c1d9$var$load("lSS91").then(()=>parcelRequire('7xEnC'));

});


parcelRegister("5ANfe", function(module, exports) {

$parcel$export(module.exports, "productsJsmAuthenticationSettingsRoute", () => $a5162dfcc59db4dc$export$6395086ce7e72e37);
const $a5162dfcc59db4dc$export$6395086ce7e72e37 = {
    name: 'products-jsm-authentication-settings',
    path: '/jira/settings/products/servicedesk/authentication',
    exact: true
};

});

parcelRegister("1xsZo", function(module, exports) {

$parcel$export(module.exports, "LazyAuthenticationSettings", () => $a330db909964048e$export$6cd59b0135f3fe86);
$parcel$export(module.exports, "default", () => $a330db909964048e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $a330db909964048e$export$6cd59b0135f3fe86 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("9M0Zf"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/product-jsm-authentication-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a330db909964048e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $a330db909964048e$export$6cd59b0135f3fe86,
        pageId: "spa-apps/admin-pages/jsm-authentication-settings",
        shouldShowSpinner: false
    });

});
parcelRegister("9M0Zf", function(module, exports) {

let $71d95cb8467af4c8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $71d95cb8467af4c8$var$load("bo2dV").then(()=>parcelRequire('8YmLU'));

});



parcelRegister("tdrXl", function(module, exports) {

$parcel$export(module.exports, "productsJsmChatopsAndVideosToolsRouteEntry", () => $4e0ccc70ab88c05a$export$8b55e723205ec5f3);

var $c04PQ = parcelRequire("c04PQ");
var $cwX5o = parcelRequire("cwX5o");

var $ffza4 = parcelRequire("ffza4");

var $7XYc4 = parcelRequire("7XYc4");

var $eZXFU = parcelRequire("eZXFU");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $5lsNZ = parcelRequire("5lsNZ");

var $1pjne = parcelRequire("1pjne");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

var $j78rb = parcelRequire("j78rb");
const $4e0ccc70ab88c05a$var$getNavigationSpecifications = ()=>{
    return (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $4e0ccc70ab88c05a$export$8b55e723205ec5f3 = (0, $7NszV.createEntry)((0, $1pjne.productsJsmChatopsAndVideosToolsRoute), ()=>({
        group: 'global-settings',
        component: (0, $7XYc4.componentWithCondition)((0, $c04PQ.isFedRamp) || (0, $cwX5o.isIsolatedCloud)() && (0, $4R6GH.fg)('hide_chatops_component_in_isolated_cloud'), (0, $5lsNZ.default), (0, $j78rb.default)),
        layout: (0, $eZXFU.opsSettingsLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$4e0ccc70ab88c05a$var$getNavigationSpecifications()
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $j78rb.LazyProductsJsmChatopsAndVideoTools)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $j78rb.LazyProductsJsmChatopsAndVideoTools)
        ]
    }));

});
parcelRegister("1pjne", function(module, exports) {

$parcel$export(module.exports, "productsJsmChatopsAndVideosToolsRoute", () => $233b8dbf88e7279c$export$7c663ddc097df1e8);
const $233b8dbf88e7279c$export$7c663ddc097df1e8 = {
    name: 'products-jsm-chatops-and-videos-tools',
    path: '/jira/settings/products/ops/jira-service-management-chatops-and-video-tools',
    exact: true
};

});

parcelRegister("j78rb", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJsmChatopsAndVideoTools", () => $2b1085a0fa643a34$export$1b7f55251df02fe9);
$parcel$export(module.exports, "default", () => $2b1085a0fa643a34$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $2b1085a0fa643a34$export$1b7f55251df02fe9 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("2R1L8"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-chatops-and-video-tools/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2b1085a0fa643a34$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2b1085a0fa643a34$export$1b7f55251df02fe9,
        pageId: "products-jsm-chatops-and-video-tools",
        shouldShowSpinner: false
    });

});
parcelRegister("2R1L8", function(module, exports) {

let $2141e55d8b3f38b9$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $2141e55d8b3f38b9$var$load("ffQaD"),
    $2141e55d8b3f38b9$var$load("kvRbA"),
    $2141e55d8b3f38b9$var$load("3r0o4")
]).then(()=>parcelRequire('1H43T'));

});



parcelRegister("5EloX", function(module, exports) {

$parcel$export(module.exports, "productsJsmComplianceRouteEntry", () => $a7108b06ea361a14$export$9cc9423a3967333b);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $fRFcK = parcelRequire("fRFcK");

var $9WIUh = parcelRequire("9WIUh");
const $a7108b06ea361a14$export$9cc9423a3967333b = (0, $7NszV.createEntry)((0, $fRFcK.productsJsmComplianceRoute), ()=>({
        group: 'global-settings',
        component: (0, $9WIUh.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $9WIUh.LazyProductsJsmCompliance)
        ],
        ufoName: 'admin.jsm-compliance'
    }));

});
parcelRegister("fRFcK", function(module, exports) {

$parcel$export(module.exports, "productsJsmComplianceRoute", () => $7de4aa1c0a8e9753$export$6196bf08f64419da);
const $7de4aa1c0a8e9753$export$6196bf08f64419da = {
    name: 'products-jsm-compliance',
    path: '/jira/settings/products/jira-service-management-compliance',
    exact: true
};

});

parcelRegister("9WIUh", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJsmCompliance", () => $62ef4b19010ca280$export$159d8c0e1862cd2b);
$parcel$export(module.exports, "default", () => $62ef4b19010ca280$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $62ef4b19010ca280$export$159d8c0e1862cd2b = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("9nrbj"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-compliance/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$62ef4b19010ca280$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $62ef4b19010ca280$export$159d8c0e1862cd2b,
        pageId: "products-jsm-compliance",
        shouldShowSpinner: false
    });

});
parcelRegister("9nrbj", function(module, exports) {

let $6d3b58b5db244739$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6d3b58b5db244739$var$load("l8CKv").then(()=>parcelRequire('dxuco'));

});



parcelRegister("7p4oW", function(module, exports) {

$parcel$export(module.exports, "productsJsmConfigurationRouteEntry", () => $7c5012e44416fb27$export$461f2b06a7a914db);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $eMdJp = parcelRequire("eMdJp");

var $eKojW = parcelRequire("eKojW");
const $7c5012e44416fb27$export$461f2b06a7a914db = (0, $7NszV.createEntry)((0, $eMdJp.productsJsmConfigurationRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-configuration',
        component: (0, $eKojW.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $eKojW.LazyProductsJsmConfiguration)
        ]
    }));

});
parcelRegister("eMdJp", function(module, exports) {

$parcel$export(module.exports, "productsJsmConfigurationRoute", () => $7d2ff473ef6296e1$export$2ad48fbde4743a97);
const $7d2ff473ef6296e1$export$2ad48fbde4743a97 = {
    name: 'products-jsm-configuration',
    path: '/jira/settings/products/jira-service-management-configuration',
    exact: true
};

});

parcelRegister("eKojW", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJsmConfiguration", () => $2e07bdac6faf88fe$export$aa3f3d5ca376f305);
$parcel$export(module.exports, "default", () => $2e07bdac6faf88fe$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $2e07bdac6faf88fe$export$aa3f3d5ca376f305 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("jUHjS"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-configuration/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2e07bdac6faf88fe$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2e07bdac6faf88fe$export$aa3f3d5ca376f305,
        pageId: "products-jsm-configuration",
        shouldShowSpinner: false
    });

});
parcelRegister("jUHjS", function(module, exports) {

let $e7f4d9ac9e1ca305$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e7f4d9ac9e1ca305$var$load("6G6wt").then(()=>parcelRequire('14xmF'));

});



parcelRegister("4PsEV", function(module, exports) {

$parcel$export(module.exports, "productsJsmCustomerAccessRouteEntry", () => $1b073120d1b5fb73$export$d014f5ba2dec6c16);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $6IgbX = parcelRequire("6IgbX");

var $cuwqc = parcelRequire("cuwqc");

var $3RJkv = parcelRequire("3RJkv");

var $kMtnK = parcelRequire("kMtnK");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $1b073120d1b5fb73$var$LazyCustomerAccess = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("7zpPj"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/customer-access/src/index.tsx"
});
const $1b073120d1b5fb73$var$ServiceDeskCustomerAccess = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $1b073120d1b5fb73$var$LazyCustomerAccess,
        pageId: "spa-apps/admin-pages/customer-access",
        shouldShowSpinner: false
    });
const $1b073120d1b5fb73$export$d014f5ba2dec6c16 = (0, $7NszV.createEntry)((0, $kMtnK.productsJsmCustomerAccessRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-customer-access',
        component: $1b073120d1b5fb73$var$ServiceDeskCustomerAccess,
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $cuwqc.jsmGlobalCustomerAccessSettingsResource),
            (0, $6IgbX.jsmGlobalCustomerAccessAffectedProjectsResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $1b073120d1b5fb73$var$LazyCustomerAccess
        ]
    }));

});
parcelRegister("kMtnK", function(module, exports) {

$parcel$export(module.exports, "productsJsmCustomerAccessRoute", () => $3ca187dfdc0607c8$export$b97e3b6231be8149);
const $3ca187dfdc0607c8$export$b97e3b6231be8149 = {
    name: 'products-jsm-customer-access',
    path: '/jira/settings/products/servicedesk/customer-access',
    exact: true
};

});

parcelRegister("7zpPj", function(module, exports) {

let $582fd5e624987f0f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $582fd5e624987f0f$var$load("gOcFK").then(()=>parcelRequire('faXQs'));

});


parcelRegister("GIsnE", function(module, exports) {

$parcel$export(module.exports, "productsJsmEmailRequestsRouteEntry", () => $4b72522d0ef4aab5$export$3f8d7424a47f4dd);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $3jDL8 = parcelRequire("3jDL8");

var $HR4Qz = parcelRequire("HR4Qz");
const $4b72522d0ef4aab5$export$3f8d7424a47f4dd = (0, $7NszV.createEntry)((0, $3jDL8.productsJsmEmailRequestsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-email-requests',
        component: (0, $HR4Qz.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $HR4Qz.LazyProductsJsmEmailRequests)
        ]
    }));

});
parcelRegister("3jDL8", function(module, exports) {

$parcel$export(module.exports, "productsJsmEmailRequestsRoute", () => $7687bd61dacb24e9$export$6288bb6ea42acf0c);
const $7687bd61dacb24e9$export$6288bb6ea42acf0c = {
    name: 'products-jsm-email-requests',
    path: '/jira/settings/products/jira-service-management-email-requests',
    exact: true
};

});

parcelRegister("HR4Qz", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJsmEmailRequests", () => $f8c99b7a302373fc$export$4c9d90d0caf04d67);
$parcel$export(module.exports, "default", () => $f8c99b7a302373fc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $f8c99b7a302373fc$export$4c9d90d0caf04d67 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("lyfqo"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/product-jsm-email-requests/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f8c99b7a302373fc$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f8c99b7a302373fc$export$4c9d90d0caf04d67,
        pageId: "products-jsm-email-requests",
        shouldShowSpinner: false
    });

});
parcelRegister("lyfqo", function(module, exports) {

let $040c872d652cbc18$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $040c872d652cbc18$var$load("ffQaD"),
    $040c872d652cbc18$var$load("kvRbA"),
    $040c872d652cbc18$var$load("gbPTO")
]).then(()=>parcelRequire('c81zX'));

});



parcelRegister("MSc9t", function(module, exports) {

$parcel$export(module.exports, "productsJsmFeatureUsageRouteEntry", () => $fc79a196d6d127dc$export$80a3e4dda2dcd1a4);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $lkQ6W = parcelRequire("lkQ6W");

var $gRzZD = parcelRequire("gRzZD");

var $3FCb0 = parcelRequire("3FCb0");
const $fc79a196d6d127dc$export$80a3e4dda2dcd1a4 = (0, $7NszV.createEntry)((0, $lkQ6W.productsJsmFeatureUsageRoute), ()=>({
        group: 'global-settings',
        component: (0, $3FCb0.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $gRzZD.workspaceResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3FCb0.LazyProductsJsmFeatureUsage)
        ]
    }));

});
parcelRegister("lkQ6W", function(module, exports) {

$parcel$export(module.exports, "productsJsmFeatureUsageRoute", () => $dcb61f2507bdacb1$export$f98dec539fffaa15);
const $dcb61f2507bdacb1$export$f98dec539fffaa15 = {
    name: 'products-jsm-feature-usage',
    path: '/jira/settings/products/servicedesk/feature-usage',
    exact: true
};

});

parcelRegister("3FCb0", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJsmFeatureUsage", () => $48028ef535c008c9$export$5ad1c1e822bd5d34);
$parcel$export(module.exports, "default", () => $48028ef535c008c9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $48028ef535c008c9$export$5ad1c1e822bd5d34 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("iSAKy"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-feature-usage/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$48028ef535c008c9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $48028ef535c008c9$export$5ad1c1e822bd5d34,
        pageId: "products-jsm-feature-usage",
        shouldShowSpinner: false
    });

});
parcelRegister("iSAKy", function(module, exports) {

let $dbe9c6e03093f114$var$load = (parcelRequire("28QjX"))(4);
module.exports = $dbe9c6e03093f114$var$load("96INv").then(()=>parcelRequire('g4KKw'));

});



parcelRegister("bpbCg", function(module, exports) {

$parcel$export(module.exports, "productsJsmGlobalOpsReportsRedirectRouteEntry", () => $5f3f997c6af1c603$export$289cc03f2eacd57a);

var $dY89w = parcelRequire("dY89w");

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $adTVI = parcelRequire("adTVI");

var $4HfNx = parcelRequire("4HfNx");
const $5f3f997c6af1c603$export$289cc03f2eacd57a = (0, $7NszV.createEntry)((0, $adTVI.productsJsmGlobalOpsReportsRedirectRoute), ()=>({
        group: 'global-settings',
        component: (0, $4HfNx.OpsReportsRedirect),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $dY89w.resources)(),
            (0, $dY89w.opsReportsPermissionResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4HfNx.LazyGlobalOpsReports)
        ]
    }));

});
parcelRegister("adTVI", function(module, exports) {

$parcel$export(module.exports, "productsJsmGlobalOpsReportsRedirectRoute", () => $3e538dded475ec91$export$c6d42e4b4a63248d);
const $3e538dded475ec91$export$c6d42e4b4a63248d = {
    name: 'products-jsm-global-ops-reports',
    path: '/jira/settings/products/ops/reports',
    exact: true
};

});

parcelRegister("4HfNx", function(module, exports) {

$parcel$export(module.exports, "LazyOpsReportsRedirect", () => $59dec6d88aab4fac$export$d33ea1a773b744e);
$parcel$export(module.exports, "LazyGlobalOpsReports", () => $59dec6d88aab4fac$export$66850ec5549adba6);
$parcel$export(module.exports, "OpsReportsRedirect", () => $59dec6d88aab4fac$export$22253dbadb46d0cf);
$parcel$export(module.exports, "GlobalOpsReports", () => $59dec6d88aab4fac$export$648ddf2d1f8b1c3f);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $59dec6d88aab4fac$export$2404f0e35deca592 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("6ouKe")), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $59dec6d88aab4fac$export$d33ea1a773b744e = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("6ouKe")).then((exportedMembers)=>exportedMembers.OpsReportsRedirect), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $59dec6d88aab4fac$export$66850ec5549adba6 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("6ouKe")).then((exportedMembers)=>exportedMembers.GlobalOpsReports), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});
const $59dec6d88aab4fac$export$22253dbadb46d0cf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $59dec6d88aab4fac$export$d33ea1a773b744e,
        pageId: "async-jira-eoc-ops-reports-redirect",
        shouldShowSpinner: false
    });
const $59dec6d88aab4fac$export$648ddf2d1f8b1c3f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $59dec6d88aab4fac$export$66850ec5549adba6,
        pageId: "async-jira-eoc-global-ops-reports",
        shouldShowSpinner: false
    });
const $59dec6d88aab4fac$export$87e6a54b4f5dc91e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $59dec6d88aab4fac$export$2404f0e35deca592,
        pageId: "async-jira-eoc-ops-reports",
        shouldShowSpinner: false
    });

});


parcelRegister("5X0aC", function(module, exports) {

$parcel$export(module.exports, "productsJsmGlobalOpsReportsRouteEntry", () => $61761389ad3b32bd$export$6a7fc41fb2523290);

var $dY89w = parcelRequire("dY89w");

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dDcek = parcelRequire("dDcek");

var $4HfNx = parcelRequire("4HfNx");
const $61761389ad3b32bd$export$6a7fc41fb2523290 = (0, $7NszV.createEntry)((0, $dDcek.productsJsmGlobalOpsReportsRoute), ()=>({
        group: 'global-settings',
        component: (0, $4HfNx.GlobalOpsReports),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $dY89w.resources)(),
            (0, $dY89w.opsReportsPermissionResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4HfNx.LazyOpsReportsRedirect)
        ]
    }));

});
parcelRegister("dDcek", function(module, exports) {

$parcel$export(module.exports, "productsJsmGlobalOpsReportsRoute", () => $126ddc8c4a59a59a$export$d92d66762943b115);
const $126ddc8c4a59a59a$export$d92d66762943b115 = {
    name: 'products-jsm-global-ops-reports',
    path: '/jira/settings/products/ops/reports/:dashboardId',
    exact: true
};

});


parcelRegister("fkWQj", function(module, exports) {

$parcel$export(module.exports, "productsJsmIncidentManagementToolsRouteEntry", () => $954e97d3acac763c$export$773f8e3318be1dd5);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $8PUrK = parcelRequire("8PUrK");

var $6MP9S = parcelRequire("6MP9S");
const $954e97d3acac763c$export$773f8e3318be1dd5 = (0, $7NszV.createEntry)((0, $8PUrK.productsJsmIncidentManagementToolsRoute), ()=>({
        group: 'global-settings',
        component: (0, $6MP9S.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6MP9S.LazyProductsJsmIncidentManagementTools)
        ]
    }));

});
parcelRegister("8PUrK", function(module, exports) {

$parcel$export(module.exports, "productsJsmIncidentManagementToolsRoute", () => $1d5dbffa04bebbb5$export$da6d538ddabade32);
const $1d5dbffa04bebbb5$export$da6d538ddabade32 = {
    name: 'products-jsm-incident-management-tools',
    path: '/jira/settings/products/jira-service-management-incident-management-tools',
    exact: true
};

});

parcelRegister("6MP9S", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJsmIncidentManagementTools", () => $63d70171d6cec69e$export$f541eb9b8f00bfaf);
$parcel$export(module.exports, "default", () => $63d70171d6cec69e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $63d70171d6cec69e$export$f541eb9b8f00bfaf = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("5kREt"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-incident-management-tools/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$63d70171d6cec69e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $63d70171d6cec69e$export$f541eb9b8f00bfaf,
        pageId: "products-jsm-incident-management-tools",
        shouldShowSpinner: false
    });

});
parcelRegister("5kREt", function(module, exports) {

let $3e2870243a225055$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $3e2870243a225055$var$load("ffQaD"),
    $3e2870243a225055$var$load("kvRbA"),
    $3e2870243a225055$var$load("4sTC2")
]).then(()=>parcelRequire('joBQW'));

});



parcelRegister("7NO6v", function(module, exports) {

$parcel$export(module.exports, "productsJsmKbPermissionsRouteEntry", () => $b6759abef36b3efc$export$717e134eb971b450);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $2EpSF = parcelRequire("2EpSF");

var $knyuK = parcelRequire("knyuK");
const $b6759abef36b3efc$export$717e134eb971b450 = (0, $7NszV.createEntry)((0, $2EpSF.productsJsmKbPermissionsRoute), ()=>({
        group: 'global-settings',
        component: (0, $knyuK.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $knyuK.LazyProductsJsmKbPermissions)
        ]
    }));

});
parcelRegister("2EpSF", function(module, exports) {

$parcel$export(module.exports, "productsJsmKbPermissionsRoute", () => $a35de718c16ba9da$export$339486410c7a783f);
const $a35de718c16ba9da$export$339486410c7a783f = {
    name: 'products-jsm-kb-permissions',
    path: '/jira/settings/products/jira-service-management-knowledge-base-permissions',
    exact: true
};

});

parcelRegister("knyuK", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJsmKbPermissions", () => $724367026054fd0c$export$a3e7bdc5dbf2d47e);
$parcel$export(module.exports, "default", () => $724367026054fd0c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $724367026054fd0c$export$a3e7bdc5dbf2d47e = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("lXBBw"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/product-jsm-kb-permissions/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$724367026054fd0c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $724367026054fd0c$export$a3e7bdc5dbf2d47e,
        pageId: "products-jsm-kb-permissions",
        shouldShowSpinner: false
    });

});
parcelRegister("lXBBw", function(module, exports) {

let $ffcc4714b4e68449$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ffcc4714b4e68449$var$load("1CHnf").then(()=>parcelRequire('glk23'));

});



parcelRegister("gtJvE", function(module, exports) {

$parcel$export(module.exports, "productsJsmOrganizationsDetailsRouteEntry", () => $d5f0f03722be4af7$export$f7b6cda88404733e);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $38BXB = parcelRequire("38BXB");

var $7CBZS = parcelRequire("7CBZS");

var $6nu63 = parcelRequire("6nu63");

var $esddG = parcelRequire("esddG");

var $3RJkv = parcelRequire("3RJkv");

var $zsl89 = parcelRequire("zsl89");

var $5JNlT = parcelRequire("5JNlT");
const $d5f0f03722be4af7$export$f7b6cda88404733e = (0, $7NszV.createEntry)((0, $zsl89.productsJsmOrganizationsDetailsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-organization-page-list',
        isRedirect: false,
        component: (0, $5JNlT.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $7CBZS.productsJsmOrganizationDetailsResource),
            (0, $6nu63.productsJsmOrganizationMembersResource),
            (0, $esddG.productsJsmOrganizationListResource),
            (0, $38BXB.jsmEmailDomainsListResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5JNlT.LazyProductsJsmOrganizationDetails)
        ]
    }));

});
parcelRegister("38BXB", function(module, exports) {

$parcel$export(module.exports, "jsmEmailDomainsListResource", () => $02fee81a891a3dc1$export$8e956348e5d47a3c);

var $2M1hQ = parcelRequire("2M1hQ");


const $02fee81a891a3dc1$export$8e956348e5d47a3c = (0, $2M1hQ.createResource)({
    type: (0, $fb7ceb315fdf5327$export$2bde433b962efbdd),
    getKey: ()=>'email-domains-list',
    isBrowserOnly: true,
    getDataLoader: ()=>(parcelRequire("j5LfK"))
});

});
const $fb7ceb315fdf5327$export$2bde433b962efbdd = 'JSM_EMAIL_DOMAINS_LIST';

parcelRegister("j5LfK", function(module, exports) {

let $de63236826e70e65$var$load = (parcelRequire("28QjX"))(4);
module.exports = $de63236826e70e65$var$load("lgmw4").then(()=>parcelRequire('bHzRo'));

});


parcelRegister("7CBZS", function(module, exports) {

$parcel$export(module.exports, "productsJsmOrganizationDetailsResource", () => $d8ebe0a210bfc926$export$ccda79811a15bf5);

var $2M1hQ = parcelRequire("2M1hQ");


const $d8ebe0a210bfc926$export$ccda79811a15bf5 = (0, $2M1hQ.createResource)({
    type: (0, $1b34d67fee3735c4$export$52408f1a0f23569a),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("k2P4E"))
});

});
const $1b34d67fee3735c4$export$52408f1a0f23569a = 'RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_DETAILS';

parcelRegister("k2P4E", function(module, exports) {

let $e97b9cc8281cbe40$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e97b9cc8281cbe40$var$load("hgZNC").then(()=>parcelRequire('dXKCD'));

});


parcelRegister("6nu63", function(module, exports) {

$parcel$export(module.exports, "productsJsmOrganizationMembersResource", () => $36d00fa173b898da$export$65c7941bd3e14d00);

var $2M1hQ = parcelRequire("2M1hQ");

const $36d00fa173b898da$var$TEN_SECONDS_IN_MILLIS = 10000;

const $36d00fa173b898da$export$65c7941bd3e14d00 = (0, $2M1hQ.createResource)({
    type: (0, $b3f9f4e37cbce264$export$d3eec3e4b4eac6ac),
    getKey: (routerContext)=>`OrganizationMembers-${routerContext.match.params.organizationId}-${routerContext.query.page}-${routerContext.query.query}`,
    getDataLoader: ()=>(parcelRequire("8hc5o")),
    maxAge: $36d00fa173b898da$var$TEN_SECONDS_IN_MILLIS
});

});
const $b3f9f4e37cbce264$export$d3eec3e4b4eac6ac = 'PRODUCT_JSM_ORGANIZATION_MEMBERS';

parcelRegister("8hc5o", function(module, exports) {

let $6069494a2248820b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6069494a2248820b$var$load("kl1ZQ").then(()=>parcelRequire('kx7O4'));

});


parcelRegister("esddG", function(module, exports) {

$parcel$export(module.exports, "productsJsmOrganizationListResource", () => $ad899c035903db82$export$3e38a27ad406d7f7);

var $2M1hQ = parcelRequire("2M1hQ");

const $ad899c035903db82$var$TEN_SECONDS_IN_MILLIS = 10000;

const $ad899c035903db82$export$3e38a27ad406d7f7 = (0, $2M1hQ.createResource)({
    type: (0, $5073c414a8292ea0$export$50de2841b08b875f),
    getKey: (routerContext)=>routerContext.query.page,
    getDataLoader: ()=>(parcelRequire("75Ymv")),
    maxAge: $ad899c035903db82$var$TEN_SECONDS_IN_MILLIS
});

});
const $5073c414a8292ea0$export$50de2841b08b875f = 'RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_LIST';

parcelRegister("75Ymv", function(module, exports) {

let $52a7d2a883c6cb65$var$load = (parcelRequire("28QjX"))(4);
module.exports = $52a7d2a883c6cb65$var$load("3nXj2").then(()=>parcelRequire('v9BTs'));

});


parcelRegister("zsl89", function(module, exports) {

$parcel$export(module.exports, "productsJsmOrganizationsDetailsRoute", () => $a0ada8abfade1bcc$export$bc61991d01535831);
const $a0ada8abfade1bcc$export$bc61991d01535831 = {
    name: 'products-jsm-organizations',
    path: '/jira/settings/products/servicedesk/organizations/:organizationId',
    exact: true
};

});

parcelRegister("5JNlT", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJsmOrganizationDetails", () => $2542e7a566ffd224$export$ff149ceefa65ab70);
$parcel$export(module.exports, "default", () => $2542e7a566ffd224$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $2542e7a566ffd224$export$ff149ceefa65ab70 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("6pF2p"))), {
    moduleId: "./src/packages/admin-pages/products-jsm-organization-details/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2542e7a566ffd224$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2542e7a566ffd224$export$ff149ceefa65ab70,
        pageId: "products-jsm-organization-details",
        shouldShowSpinner: true
    });

});
parcelRegister("6pF2p", function(module, exports) {

let $4ab4e925131487f0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4ab4e925131487f0$var$load("ePo15").then(()=>parcelRequire('dgpeW'));

});



parcelRegister("hMqu9", function(module, exports) {

$parcel$export(module.exports, "productsJsmOrganizationsRouteEntry", () => $5dc17715cd6fddea$export$34d843946d3894aa);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $esddG = parcelRequire("esddG");

var $3RJkv = parcelRequire("3RJkv");

var $d6Cjb = parcelRequire("d6Cjb");

var $ckuB6 = parcelRequire("ckuB6");
const $5dc17715cd6fddea$export$34d843946d3894aa = (0, $7NszV.createEntry)((0, $d6Cjb.productsJsmOrganizationsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-organization-page-list',
        isRedirect: false,
        component: (0, $ckuB6.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $esddG.productsJsmOrganizationListResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ckuB6.LazyProductsJsmOrganizations)
        ]
    }));

});
parcelRegister("d6Cjb", function(module, exports) {

$parcel$export(module.exports, "productsJsmOrganizationsRoute", () => $aff64887f4e5e03c$export$512fa30726e0049d);
const $aff64887f4e5e03c$export$512fa30726e0049d = {
    name: 'products-jsm-organizations',
    path: '/jira/settings/products/servicedesk/organizations',
    exact: true
};

});

parcelRegister("ckuB6", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJsmOrganizations", () => $34fecedc618348fb$export$410bec6e06fd4723);
$parcel$export(module.exports, "default", () => $34fecedc618348fb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $34fecedc618348fb$export$410bec6e06fd4723 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("679xe"))), {
    moduleId: "./src/packages/admin-pages/products-jsm-organizations-list/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$34fecedc618348fb$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $34fecedc618348fb$export$410bec6e06fd4723,
        pageId: "products-jsm-organizations-list",
        shouldShowSpinner: true
    });

});
parcelRegister("679xe", function(module, exports) {

let $473acaf8e5582b0c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $473acaf8e5582b0c$var$load("aUS8e").then(()=>parcelRequire('hfcIv'));

});



parcelRegister("7YRoH", function(module, exports) {

$parcel$export(module.exports, "productsJswConfigurationRouteEntry", () => $1733bfec88a8a7ea$export$2f65b1ec4ed05f91);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $hwXlc = parcelRequire("hwXlc");

var $8dDE8 = parcelRequire("8dDE8");

var $esWmF = parcelRequire("esWmF");
const $1733bfec88a8a7ea$export$2f65b1ec4ed05f91 = (0, $7NszV.createEntry)((0, $8dDE8.productsJswConfigurationRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsw-configuration',
        component: (0, $esWmF.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $hwXlc.productsJswConfigurationResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $esWmF.LazyProductsJswConfiguration)
        ]
    }));

});
parcelRegister("hwXlc", function(module, exports) {

$parcel$export(module.exports, "productsJswConfigurationResource", () => $3248841597f2b624$export$b6a5741c2b47fb17);

var $2M1hQ = parcelRequire("2M1hQ");


const $3248841597f2b624$export$b6a5741c2b47fb17 = (0, $2M1hQ.createResource)({
    type: (0, $8b1aa0975152cf4f$export$73be8e1edd21e2d),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("7k2tt"))
});

});
const $8b1aa0975152cf4f$export$73be8e1edd21e2d = 'RESOURCE_TYPE_PRODUCT_JSW_CONFIGURATION';

parcelRegister("7k2tt", function(module, exports) {

let $554c51ff613acde0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $554c51ff613acde0$var$load("2oxTp").then(()=>parcelRequire('bX4Lv'));

});


parcelRegister("8dDE8", function(module, exports) {

$parcel$export(module.exports, "productsJswConfigurationRoute", () => $ac36f76001e1c678$export$decdad53ba9b97af);
const $ac36f76001e1c678$export$decdad53ba9b97af = {
    name: 'products-jsw-configuration',
    path: '/jira/settings/products/jira-software-configuration',
    exact: true
};

});

parcelRegister("esWmF", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJswConfiguration", () => $90ae9e1263695143$export$f9a32397033f9ced);
$parcel$export(module.exports, "default", () => $90ae9e1263695143$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $90ae9e1263695143$export$f9a32397033f9ced = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("gb28O"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsw-configuration/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$90ae9e1263695143$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $90ae9e1263695143$export$f9a32397033f9ced,
        pageId: "products-jsw-configuration",
        shouldShowSpinner: false
    });

});
parcelRegister("gb28O", function(module, exports) {

let $bc6f55996da8f3c1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bc6f55996da8f3c1$var$load("3KjvI").then(()=>parcelRequire('1eYnA'));

});



parcelRegister("i0b8q", function(module, exports) {

$parcel$export(module.exports, "productsJswStorageManagementRouteEntry", () => $ebdca188f3705262$export$c62ca2d3fcc552a5);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $1vQWT = parcelRequire("1vQWT");

var $ab5pe = parcelRequire("ab5pe");

var $bARgN = parcelRequire("bARgN");
const $ebdca188f3705262$export$c62ca2d3fcc552a5 = (0, $7NszV.createEntry)((0, $ab5pe.productsJswStorageManagementRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsw-configuration.storage-management',
        component: (0, $bARgN.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $1vQWT.productsJswStorageManagementResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bARgN.LazyProductsJswStorageManagement)
        ]
    }));

});
parcelRegister("1vQWT", function(module, exports) {

$parcel$export(module.exports, "productsJswStorageManagementResource", () => $20cc0f4a1ad53cba$export$2cd668845b3478bd);

var $2M1hQ = parcelRequire("2M1hQ");


const $20cc0f4a1ad53cba$export$2cd668845b3478bd = (0, $2M1hQ.createResource)({
    type: (0, $593b84e85768ae60$export$1ac222647be3baf8),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("8LYAU"))
});

});
const $593b84e85768ae60$export$1ac222647be3baf8 = 'RESOURCE_TYPE_PRODUCT_JSW_STORAGE_MANAGEMENT';

parcelRegister("8LYAU", function(module, exports) {

let $6631b74bfab4a972$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6631b74bfab4a972$var$load("axIcs").then(()=>parcelRequire('a5z0r'));

});


parcelRegister("ab5pe", function(module, exports) {

$parcel$export(module.exports, "productsJswStorageManagementRoute", () => $7e2088c789cd548c$export$18f0044f00cc3996);
const $7e2088c789cd548c$export$18f0044f00cc3996 = {
    name: 'products-jsw-storage-management',
    path: '/jira/settings/products/jira-software-configuration/storage-management',
    exact: true
};

});

parcelRegister("bARgN", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJswStorageManagement", () => $bad793b8f28a1de3$export$a4f5e12ce817cbb8);
$parcel$export(module.exports, "default", () => $bad793b8f28a1de3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $bad793b8f28a1de3$export$a4f5e12ce817cbb8 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("c04D9"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsw-storage-management/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bad793b8f28a1de3$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $bad793b8f28a1de3$export$a4f5e12ce817cbb8,
        pageId: "products-jsw-storage-management",
        shouldShowSpinner: true
    });

});
parcelRegister("c04D9", function(module, exports) {

let $8bc913a5930976c3$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $8bc913a5930976c3$var$load("fliVL"),
    $8bc913a5930976c3$var$load("181PN")
]).then(()=>parcelRequire('2i4Yq'));

});



parcelRegister("734Wz", function(module, exports) {

$parcel$export(module.exports, "productsOnboardingHubRouteEntry", () => $5a685cdbfad9fada$export$114fd427e3931043);

var $7NszV = parcelRequire("7NszV");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $ibkIl = parcelRequire("ibkIl");

var $7Vazp = parcelRequire("7Vazp");

var $4R6GH = parcelRequire("4R6GH");

var $gFyNY = parcelRequire("gFyNY");

var $3RJkv = parcelRequire("3RJkv");
const $5a685cdbfad9fada$var$productsOnboardingHubEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7Vazp.onboardingHubEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).SETTINGS
});
const $5a685cdbfad9fada$export$114fd427e3931043 = (0, $7NszV.createEntry)((0, $gFyNY.productsOnboardingHubRoute), ()=>({
        group: 'global-settings',
        entryPoint () {
            return (0, $4R6GH.fg)('jira-onboarding-hub-gate') ? $5a685cdbfad9fada$var$productsOnboardingHubEntryPoint : undefined;
        },
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)()
        ]
    }));

});
parcelRegister("7Vazp", function(module, exports) {

$parcel$export(module.exports, "onboardingHubEntryPoint", () => $46a5e3e23f370ef8$export$fbab93125af0feae);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $46a5e3e23f370ef8$export$fbab93125af0feae = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("943K6")).then((module)=>module.OnboardingHubPage), {
        moduleId: "4a678f18",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("943K6", function(module, exports) {

let $699763faab9cf871$var$load = (parcelRequire("28QjX"))(4);
module.exports = $699763faab9cf871$var$load("aksCE").then(()=>parcelRequire('8eArQ'));

});


parcelRegister("gFyNY", function(module, exports) {

$parcel$export(module.exports, "productsOnboardingHubRoute", () => $46c877b8c621eeec$export$6a9e8ece249577cc);
const $46c877b8c621eeec$export$6a9e8ece249577cc = {
    name: 'products-onboarding-hub',
    path: '/jira/settings/products/onboarding'
};

});


parcelRegister("jKCJe", function(module, exports) {

$parcel$export(module.exports, "proformaExportRouteEntry", () => $6ada90d55b94e879$export$27be010fc1b30f6c);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $gXbcB = parcelRequire("gXbcB");

var $6dVUC = parcelRequire("6dVUC");
const $6ada90d55b94e879$export$27be010fc1b30f6c = (0, $7NszV.createEntry)((0, $gXbcB.proformaExportRoute), ()=>({
        group: 'proforma',
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        component: (0, $6dVUC.default),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6dVUC.LazyProformaExport)
        ]
    }));

});
parcelRegister("gXbcB", function(module, exports) {

$parcel$export(module.exports, "proformaExportRoute", () => $e9663b2cd0ceb8c1$export$5130d152b1cda229);
const $e9663b2cd0ceb8c1$export$5130d152b1cda229 = {
    name: 'proforma-export',
    path: '/jira/forms/export',
    exact: true
};

});

parcelRegister("6dVUC", function(module, exports) {

$parcel$export(module.exports, "LazyProformaExport", () => $f012061ea42d3cc1$export$5e0d802a5d865352);
$parcel$export(module.exports, "default", () => $f012061ea42d3cc1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $f012061ea42d3cc1$export$5e0d802a5d865352 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("22cFk")), {
    moduleId: "./src/packages/spa-apps/proforma-export/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f012061ea42d3cc1$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f012061ea42d3cc1$export$5e0d802a5d865352,
        pageId: "proforma-export",
        shouldShowSpinner: true
    });

});
parcelRegister("22cFk", function(module, exports) {

let $17b597cdea5f1540$var$load = (parcelRequire("28QjX"))(4);
module.exports = $17b597cdea5f1540$var$load("9eOiG").then(()=>parcelRequire('dtDoN'));

});



parcelRegister("iJIU8", function(module, exports) {

$parcel$export(module.exports, "proformaIssueFormsGeneralRouteEntry", () => $8d5b2002b38c1828$export$90d7a2fe9ba3bc11);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $jErk8 = parcelRequire("jErk8");

var $5cTgp = parcelRequire("5cTgp");
const $8d5b2002b38c1828$export$90d7a2fe9ba3bc11 = (0, $7NszV.createEntry)((0, $jErk8.proformaIssueFormsGeneralRoute), ()=>({
        group: 'proforma',
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        component: (0, $5cTgp.default),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5cTgp.LazyProformaIssueFormsGeneral)
        ],
        perfMetricKey: 'issue-forms-general'
    }));

});
parcelRegister("jErk8", function(module, exports) {

$parcel$export(module.exports, "proformaIssueFormsGeneralRoute", () => $6484903254af07fd$export$5e0c19066a4c3806);
const $6484903254af07fd$export$5e0c19066a4c3806 = {
    name: 'proforma-issue-forms-general',
    path: '/jira/forms/create',
    exact: true
};

});

parcelRegister("5cTgp", function(module, exports) {

$parcel$export(module.exports, "LazyProformaIssueFormsGeneral", () => $06427390ad9a129c$export$7c16b09eb95f1c5d);
$parcel$export(module.exports, "default", () => $06427390ad9a129c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $06427390ad9a129c$export$7c16b09eb95f1c5d = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("5xdPl")), {
    moduleId: "./src/packages/spa-apps/proforma-issue-forms-general/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$06427390ad9a129c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $06427390ad9a129c$export$7c16b09eb95f1c5d,
        pageId: "proforma-issue-forms-general",
        shouldShowSpinner: true
    });

});
parcelRegister("5xdPl", function(module, exports) {

let $407ac299691e5d96$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $407ac299691e5d96$var$load("76n7a"),
    $407ac299691e5d96$var$load("l253H"),
    $407ac299691e5d96$var$load("58s7b")
]).then(()=>parcelRequire('28Pju'));

});



parcelRegister("64qpc", function(module, exports) {

$parcel$export(module.exports, "projectComponentsRedirectRouteEntry", () => $4b7fc303ce7a2a17$export$b498607b4440c4ef);

var $ffza4 = parcelRequire("ffza4");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $xNRJ9 = parcelRequire("xNRJ9");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $9Qrwv = parcelRequire("9Qrwv");

var $holgx = parcelRequire("holgx");
const $4b7fc303ce7a2a17$export$b498607b4440c4ef = (0, $7NszV.createEntry)((0, $9Qrwv.projectComponentsRedirectRoute), ()=>({
        group: 'components',
        component: !false ? (0, $holgx.ComponentsRedirect) : undefined,
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource),
            (0, $xNRJ9.projectsComponentsResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ],
        isRedirect: true
    }));

});
parcelRegister("xNRJ9", function(module, exports) {

$parcel$export(module.exports, "projectsComponentsResource", () => $e6f1f6e8951a4819$export$557cc3eff8939b3);

var $kbVA4 = parcelRequire("kbVA4");

var $2M1hQ = parcelRequire("2M1hQ");


const $e6f1f6e8951a4819$export$557cc3eff8939b3 = (0, $2M1hQ.createResource)({
    type: (0, $7f7620b307267b7d$export$ae1b86a8daeb387d),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("iPV1q")),
    maxAge: (0, $kbVA4.MIN_MAX_AGE)
});

});
const $7f7620b307267b7d$export$ae1b86a8daeb387d = 'PROJECTS_COMPONENTS';

parcelRegister("iPV1q", function(module, exports) {

let $db6938cd551a96f9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $db6938cd551a96f9$var$load("76u5F").then(()=>parcelRequire('77Eyd'));

});


parcelRegister("9Qrwv", function(module, exports) {

$parcel$export(module.exports, "projectComponentsRedirectRoute", () => $ca17ca5646521c59$export$d370abe25253fa1b);

var $jhtWp = parcelRequire("jhtWp");
const $ca17ca5646521c59$export$d370abe25253fa1b = {
    name: 'project-components-redirect',
    path: '/projects/:projectKey',
    query: (0, $jhtWp.PROJECTS_COMPONENTS_QUERY_PARAMS)
};

});
parcelRegister("jhtWp", function(module, exports) {

$parcel$export(module.exports, "PROJECTS_COMPONENTS_QUERY_PARAMS", () => $650eb9307abab3e5$export$1d7a0c194c3e83f2);
const $650eb9307abab3e5$export$1d7a0c194c3e83f2 = [
    'selectedItem=com.atlassian.jira.jira-projects-plugin:components-page'
];

});


parcelRegister("holgx", function(module, exports) {

$parcel$export(module.exports, "ComponentsRedirect", () => $15d396b2dbadf93f$export$9cf9ae84482ff18e);

var $5uXOq = parcelRequire("5uXOq");

var $aZsz6 = parcelRequire("aZsz6");

var $6XreI = parcelRequire("6XreI");
const $15d396b2dbadf93f$export$9cf9ae84482ff18e = ()=>{
    const page = (_, { selectedItem: selectedItem, ...rest })=>{
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
        const querystring = (0, $aZsz6.qs).stringify(rest, true);
        return `/components${querystring}`;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6XreI.RedirectToProjectType), {
        page: page
    });
};

});
parcelRegister("6XreI", function(module, exports) {

$parcel$export(module.exports, "RedirectToProjectType", () => $d19b3848ac7d27f0$export$8a3df560509448b8);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dxCvy = parcelRequire("dxCvy");

var $bVDE5 = parcelRequire("bVDE5");

var $7tQej = parcelRequire("7tQej");
var $2YP9W = parcelRequire("2YP9W");
var $doZTA = parcelRequire("doZTA");
const $d19b3848ac7d27f0$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $7tQej.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $8zOmE.fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, $2NMNM.useAnalyticsEvents), useResource: useResource = (0, $2YP9W.useResource), useRouter: useRouter = (0, $doZTA.useRouter), useSpaStateTransition: useSpaStateTransition = (0, $bVDE5.useSpaStateTransition) })=>{
    const [{ match: match, query: query, route: route }] = useRouter();
    const { data: data } = useResource((0, $dxCvy.projectContextResource));
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
    (0, $5uXOq.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $2vSU6.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $2vSU6.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};

});



parcelRegister("87aC7", function(module, exports) {

$parcel$export(module.exports, "projectComponentsRouteEntry", () => $97d73743db912d34$export$e60f53ff5ae626cd);

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $xNRJ9 = parcelRequire("xNRJ9");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $59Kn5 = parcelRequire("59Kn5");

var $lkFvK = parcelRequire("lkFvK");

var $fo6b8 = parcelRequire("fo6b8");

var $7JEuc = parcelRequire("7JEuc");

var $4R6GH = parcelRequire("4R6GH");

var $gNStA = parcelRequire("gNStA");

var $7bHMy = parcelRequire("7bHMy");
const $97d73743db912d34$var$projectComponentsPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7JEuc.projectComponentsEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $97d73743db912d34$export$e60f53ff5ae626cd = (0, $7NszV.createEntry)((0, $59Kn5.projectComponentsRoute), ()=>({
        group: 'components',
        ufoName: 'project-components-view',
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource),
            (0, $xNRJ9.projectsComponentsResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jira-project-isglobalcomponent-route-resource'), (0, $7bHMy.projectGlobalComponentsResource))
        ],
        entryPoint: ()=>$97d73743db912d34$var$projectComponentsPageEntryPoint,
        supportsPreviewPanel: true
    }));

});
parcelRegister("59Kn5", function(module, exports) {

$parcel$export(module.exports, "projectComponentsRoute", () => $c0c0fb35b16dfdd1$export$f76189bea494b0b8);
const $c0c0fb35b16dfdd1$export$f76189bea494b0b8 = {
    name: 'project-components',
    path: '/jira/:projectType(software|software/c|servicedesk|core)/projects/:projectKey/components'
};

});

parcelRegister("7JEuc", function(module, exports) {

$parcel$export(module.exports, "projectComponentsEntrypoint", () => $ba5b4d8c4394f047$export$d90db228c6acd520);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $ba5b4d8c4394f047$export$d90db228c6acd520 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("eRz9R")), {
        moduleId: "f6db472c",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("eRz9R", function(module, exports) {

let $ad214999af906df1$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ad214999af906df1$var$load("ffQaD"),
    $ad214999af906df1$var$load("kvRbA"),
    $ad214999af906df1$var$load("fliVL"),
    $ad214999af906df1$var$load("b2kYj")
]).then(()=>parcelRequire('2NjcZ'));

});



parcelRegister("aAF0I", function(module, exports) {

$parcel$export(module.exports, "projectDirectoryRedirectRouteEntry", () => $a32e24e3142418a0$export$f1f04e35fd5f4283);

var $5uXOq = parcelRequire("5uXOq");

var $7NszV = parcelRequire("7NszV");

var $lmyls = parcelRequire("lmyls");

var $3RJkv = parcelRequire("3RJkv");

var $ffza4 = parcelRequire("ffza4");

var $3JE1m = parcelRequire("3JE1m");

var $ds5qV = parcelRequire("ds5qV");

var $2BrOV = parcelRequire("2BrOV");
const $a32e24e3142418a0$var$ProjectsDirectoryRedirect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: "/jira/projects"
    });
const $a32e24e3142418a0$export$f1f04e35fd5f4283 = (0, $7NszV.createEntry)((0, $3JE1m.projectDirectoryRedirectRoute), ()=>({
        group: 'classic-software',
        component: $a32e24e3142418a0$var$ProjectsDirectoryRedirect,
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        isRedirect: true,
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("3JE1m", function(module, exports) {

$parcel$export(module.exports, "projectDirectoryRedirectRoute", () => $0939314fcba99a8c$export$3913c8bee519225c);
const $0939314fcba99a8c$export$3913c8bee519225c = {
    name: 'project-directory-redirect',
    path: '/secure/RapidBoard.jspa'
};

});


parcelRegister("4Aamz", function(module, exports) {

$parcel$export(module.exports, "projectIssueNavigatorRouteEntry", () => $1d391d147db0115e$export$d6b778af15db7d3);

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $bHhiy = parcelRequire("bHhiy");

var $f9Gea = parcelRequire("f9Gea");

var $lHYIV = parcelRequire("lHYIV");


var $arJNO = parcelRequire("arJNO");

var $3uU6P = parcelRequire("3uU6P");

var $b8f12 = parcelRequire("b8f12");
const $1d391d147db0115e$export$d6b778af15db7d3 = (0, $7NszV.createEntry)((0, $f9Gea.projectIssueNavigatorRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$d0ad1160bb95ce50),
            reporting: (0, $3uU6P.getRouteReporting)()
        },
        skeleton: (0, $lHYIV.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $arJNO.getCommonProjectResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        layout: (0, $aPfsS.createLayout)((0, $gyYxw.genericProjectLayout)),
        entryPoint: ()=>(0, $b8f12.issueNavigatorPinRedirectPageEntryPoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("f9Gea", function(module, exports) {

$parcel$export(module.exports, "projectIssueNavigatorRoute", () => $2de97b1bab3baedd$export$126b16ec65343bf);
const $2de97b1bab3baedd$export$126b16ec65343bf = {
    name: 'issue-navigator',
    path: '/projects/:projectKey/issues/:issueKey?'
};

});


parcelRegister("hPrN5", function(module, exports) {

$parcel$export(module.exports, "projectNotFoundRouteEntry", () => $292badf40134cb3e$export$beae48175e3016b8);

var $lkFvK = parcelRequire("lkFvK");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $frKbc = parcelRequire("frKbc");

var $T9TsM = parcelRequire("T9TsM");
const $292badf40134cb3e$var$projectNotFoundPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $T9TsM.projectNotFoundEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $292badf40134cb3e$export$beae48175e3016b8 = (0, $7NszV.createEntry)((0, $frKbc.projectNotFoundRoute), ()=>({
        group: 'errors',
        entryPoint () {
            return $292badf40134cb3e$var$projectNotFoundPageEntryPoint;
        },
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        pageId: 'project-not-found-page-id'
    }));

});
parcelRegister("frKbc", function(module, exports) {

$parcel$export(module.exports, "projectNotFoundRoute", () => $5f4b2f1efa38e84e$export$ad23ddca45852d02);
const $5f4b2f1efa38e84e$export$ad23ddca45852d02 = {
    name: 'project-not-found',
    path: '/jira/:projectType(software|servicedesk|core|polaris)/projects/not-found',
    exact: true
};

});

parcelRegister("T9TsM", function(module, exports) {

$parcel$export(module.exports, "projectNotFoundEntryPoint", () => $ad3635ddd4e67df5$export$6ffa2f426ba3b25a);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $ad3635ddd4e67df5$export$6ffa2f426ba3b25a = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("03Taw")), {
        moduleId: "51ed29c5",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("03Taw", function(module, exports) {

let $00bb134f62f91f02$var$load = (parcelRequire("28QjX"))(4);
module.exports = $00bb134f62f91f02$var$load("ifylz").then(()=>parcelRequire('L9JRT'));

});



parcelRegister("kKEWZ", function(module, exports) {

$parcel$export(module.exports, "projectPagesLegacyRouteEntry", () => $5b3bb769f5acfa20$export$5788c5f8c4e440b1);

var $ffza4 = parcelRequire("ffza4");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $4U4Td = parcelRequire("4U4Td");

var $9V7O8 = parcelRequire("9V7O8");
const $5b3bb769f5acfa20$export$5788c5f8c4e440b1 = (0, $7NszV.createEntry)((0, $4U4Td.projectPagesLegacyRoute), ()=>({
        group: 'components',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        component: !false ? (0, $9V7O8.PagesRedirect) : (0, $9V7O8.default),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $9V7O8.LazyProjectPages)
        ],
        isRedirect: true
    }));

});
parcelRegister("4U4Td", function(module, exports) {

$parcel$export(module.exports, "projectPagesLegacyRoute", () => $25092ed805d69948$export$a82cbb9b9c689c40);
const $25092ed805d69948$export$a82cbb9b9c689c40 = {
    name: 'project-pages-legacy',
    path: '/projects/:projectKey',
    query: [
        'selectedItem=com.atlassian.jira.jira-projects-plugin:project-pages-page'
    ]
};

});

parcelRegister("9V7O8", function(module, exports) {

$parcel$export(module.exports, "LazyProjectPages", () => $4be66c9d92628f7f$export$c2115a649411f570);
$parcel$export(module.exports, "PagesRedirect", () => $4be66c9d92628f7f$export$7c3b1828ada63555);
$parcel$export(module.exports, "default", () => $4be66c9d92628f7f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $3jbwx = parcelRequire("3jbwx");

const $4be66c9d92628f7f$export$c2115a649411f570 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("gnvTd"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/project/pages/src/index.tsx"
});
const $4be66c9d92628f7f$export$7c3b1828ada63555 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3jbwx.RedirectToProjectType), {
        page: "/pages"
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4be66c9d92628f7f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $4be66c9d92628f7f$export$c2115a649411f570,
        pageId: "project-pages",
        shouldShowSpinner: false
    });

});
parcelRegister("3jbwx", function(module, exports) {

$parcel$export(module.exports, "RedirectToProjectType", () => $b1c3ef54235a025d$export$8a3df560509448b8);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dxCvy = parcelRequire("dxCvy");

var $bVDE5 = parcelRequire("bVDE5");

var $7tQej = parcelRequire("7tQej");
var $2YP9W = parcelRequire("2YP9W");
var $doZTA = parcelRequire("doZTA");
const $b1c3ef54235a025d$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $7tQej.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $8zOmE.fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, $2NMNM.useAnalyticsEvents), useResource: useResource = (0, $2YP9W.useResource), useRouter: useRouter = (0, $doZTA.useRouter), useSpaStateTransition: useSpaStateTransition = (0, $bVDE5.useSpaStateTransition) })=>{
    const [{ match: match, query: query, route: route }] = useRouter();
    const { data: data } = useResource((0, $dxCvy.projectContextResource));
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
    (0, $5uXOq.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $2vSU6.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $2vSU6.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};

});

parcelRegister("gnvTd", function(module, exports) {

let $bec787f016102870$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $bec787f016102870$var$load("76n7a"),
    $bec787f016102870$var$load("l253H"),
    $bec787f016102870$var$load("eXPra")
]).then(()=>parcelRequire('8nMC7'));

});



parcelRegister("ljItG", function(module, exports) {

$parcel$export(module.exports, "projectPagesRouteEntry", () => $ec177ab479977ba2$export$babf32528ef518e9);

var $ffza4 = parcelRequire("ffza4");

var $7XYc4 = parcelRequire("7XYc4");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $5lsNZ = parcelRequire("5lsNZ");

var $gTBUm = parcelRequire("gTBUm");

var $kfztd = parcelRequire("kfztd");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");

var $6s1PB = parcelRequire("6s1PB");

var $9V7O8 = parcelRequire("9V7O8");
const $ec177ab479977ba2$export$babf32528ef518e9 = (0, $7NszV.createEntry)((0, $gTBUm.projectPagesRoute), ()=>({
        group: 'components',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingEnabled)() && (0, $6s1PB.expVal)('performance_improvement_in_use_project_theme', 'isEnabled', false) || (0, $lmBAt.getIsSoftwareThemingM2Enabled)(), (0, $9V5k0.projectThemeResource))
        ],
        component: (0, $7XYc4.componentWithCondition)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $9V7O8.default)),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $9V7O8.LazyProjectPages)
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("gTBUm", function(module, exports) {

$parcel$export(module.exports, "projectPagesRoute", () => $b32f9068985446b1$export$54a218ca6d1c056a);
const $b32f9068985446b1$export$54a218ca6d1c056a = {
    name: 'project-pages',
    path: '/jira/:projectType(software|software/c|servicedesk)/projects/:projectKey/pages'
};

});


parcelRegister("fQyGL", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryLegacyPathRedirectRouteEntry", () => $8f20c76692c396ce$export$78ff5b5f42b9de4);

var $ffza4 = parcelRequire("ffza4");

var $gmpjq = parcelRequire("gmpjq");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $hW253 = parcelRequire("hW253");

var $gUy1M = parcelRequire("gUy1M");

var $cFtGt = parcelRequire("cFtGt");

var $1ryl1 = parcelRequire("1ryl1");

var $fhRbA = parcelRequire("fhRbA");
const $8f20c76692c396ce$export$78ff5b5f42b9de4 = (0, $7NszV.createEntry)((0, $gUy1M.projectsDirectoryLegacyPathRedirectRoute), ()=>({
        group: 'directories',
        component: (0, $1ryl1.ProjectsDirectoryRedirect),
        skeleton: (0, $cFtGt.ProjectsDirectorySkeleton),
        isRedirect: true,
        layout: (0, $gmpjq.homepageLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $hW253.projectsDirectoryPageResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $fhRbA.LazyProjectsDirectory)
        ]
    }));

});
parcelRegister("gUy1M", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryLegacyPathRedirectRoute", () => $6002c1f8d9c23c57$export$c713f57300a82898);
const $6002c1f8d9c23c57$export$c713f57300a82898 = {
    name: 'projects-directory-legacy-path-spa-redirect',
    path: '/secure/BrowseProjects.jspa'
};

});

parcelRegister("1ryl1", function(module, exports) {

$parcel$export(module.exports, "ProjectsDirectoryRedirect", () => $3ba92fb58534b205$export$b68dd6112a931c10);

var $5uXOq = parcelRequire("5uXOq");

var $ds5qV = parcelRequire("ds5qV");
const $3ba92fb58534b205$export$b68dd6112a931c10 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: "/jira/projects"
    });

});


parcelRegister("ifEj3", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryManageRedirectRouteEntry", () => $b468f39f7a3e39f4$export$c3c347e60b82f074);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $4jMkc = parcelRequire("4jMkc");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $jQdhH = parcelRequire("jQdhH");

var $cFtGt = parcelRequire("cFtGt");

var $k3MnQ = parcelRequire("k3MnQ");

var $fbnvY = parcelRequire("fbnvY");

var $fhRbA = parcelRequire("fhRbA");
const $b468f39f7a3e39f4$export$c3c347e60b82f074 = (0, $7NszV.createEntry)((0, $jQdhH.projectsDirectoryManageRedirectRoute), ()=>({
        component: (0, $k3MnQ.ProjectsDirectoryManageRedirect),
        skeleton: (0, $cFtGt.ProjectsDirectorySkeleton),
        isRedirect: true,
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebar: (0, $4jMkc.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $fbnvY.adminProjectDirectoryResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $fhRbA.LazyProjectsDirectory)
        ]
    }));

});
parcelRegister("jQdhH", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryManageRedirectRoute", () => $9ef5b86eaaaceda7$export$dbd3b6c012e8b6dc);
const $9ef5b86eaaaceda7$export$dbd3b6c012e8b6dc = {
    name: 'projects-directory-manage-redirect',
    path: '/secure/project/ViewProjects.jspa'
};

});

parcelRegister("k3MnQ", function(module, exports) {

$parcel$export(module.exports, "ProjectsDirectoryManageRedirect", () => $0582a6018d790f50$export$74316a0a4963952b);

var $5uXOq = parcelRequire("5uXOq");

var $ds5qV = parcelRequire("ds5qV");
const $0582a6018d790f50$export$74316a0a4963952b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: "/jira/settings/projects/manage"
    });

});


parcelRegister("4CGuj", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryManageRootRedirectRouteEntry", () => $e677bebc1d8715eb$export$3f6ec3224d4c9da);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $4jMkc = parcelRequire("4jMkc");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $g8syc = parcelRequire("g8syc");

var $cFtGt = parcelRequire("cFtGt");

var $k3MnQ = parcelRequire("k3MnQ");

var $fbnvY = parcelRequire("fbnvY");

var $fhRbA = parcelRequire("fhRbA");
const $e677bebc1d8715eb$export$3f6ec3224d4c9da = (0, $7NszV.createEntry)((0, $g8syc.projectsDirectoryManageRootRedirectRoute), ()=>({
        component: (0, $k3MnQ.ProjectsDirectoryManageRedirect),
        skeleton: (0, $cFtGt.ProjectsDirectorySkeleton),
        isRedirect: true,
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebar: (0, $4jMkc.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $fbnvY.adminProjectDirectoryResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $fhRbA.LazyProjectsDirectory)
        ]
    }));

});
parcelRegister("g8syc", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryManageRootRedirectRoute", () => $45b46e5e0a379e06$export$4531e3b2e25fad23);
const $45b46e5e0a379e06$export$4531e3b2e25fad23 = {
    name: 'projects-directory-manage-root-redirect',
    path: '/jira/settings/projects',
    exact: true
};

});


parcelRegister("6VvYi", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryRedirectRouteEntry", () => $66b2e7de35cd3e39$export$8d9d65bb59f2354e);

var $ffza4 = parcelRequire("ffza4");

var $gmpjq = parcelRequire("gmpjq");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $hW253 = parcelRequire("hW253");

var $1k12N = parcelRequire("1k12N");

var $cFtGt = parcelRequire("cFtGt");

var $1ryl1 = parcelRequire("1ryl1");

var $fhRbA = parcelRequire("fhRbA");
const $66b2e7de35cd3e39$export$8d9d65bb59f2354e = (0, $7NszV.createEntry)((0, $1k12N.projectsDirectoryRedirectRoute), ()=>({
        group: 'directories',
        component: (0, $1ryl1.ProjectsDirectoryRedirect),
        skeleton: (0, $cFtGt.ProjectsDirectorySkeleton),
        isRedirect: true,
        layout: (0, $gmpjq.homepageLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $hW253.projectsDirectoryPageResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $fhRbA.LazyProjectsDirectory)
        ]
    }));

});
parcelRegister("1k12N", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryRedirectRoute", () => $529d55d6a6980bfb$export$d44f1be3782f0fde);
const $529d55d6a6980bfb$export$d44f1be3782f0fde = {
    name: 'projects-directory-redirect',
    path: '/projects',
    exact: true
};

});


parcelRegister("dSrOC", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryRouteEntry", () => $00e4719282b1ae8b$export$79292a834772288c);

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $foR3E = parcelRequire("foR3E");

var $cFtGt = parcelRequire("cFtGt");

var $jL5x9 = parcelRequire("jL5x9");
const $00e4719282b1ae8b$export$79292a834772288c = (0, $7NszV.createEntry)((0, $foR3E.projectsDirectoryRoute), ()=>({
        group: 'directories',
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental-projects'),
        entryPoint () {
            return 0, $jL5x9.ProjectsDirectoryPageEntryPoint;
        },
        skeleton: (0, $cFtGt.ProjectsDirectorySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        ufoName: 'projects-directory-v3',
        supportsPreviewPanel: true
    }));

});

parcelRegister("j0BAb", function(module, exports) {

$parcel$export(module.exports, "projectServiceDeskRouteEntry", () => $3053f9214c133ac3$export$8810bfd4f6a0eb22);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $7MCPm = parcelRequire("7MCPm");

var $ludxj = parcelRequire("ludxj");

var $6Z2mh = parcelRequire("6Z2mh");
const $3053f9214c133ac3$export$8810bfd4f6a0eb22 = (0, $7NszV.createEntry)((0, $ludxj.projectServiceDeskRoute), ()=>({
        group: 'servicedesk',
        isRedirect: true,
        component: (0, $7MCPm.RedirectToLastVisitedProjectPage),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("ludxj", function(module, exports) {

$parcel$export(module.exports, "projectServiceDeskRoute", () => $be54e9dad71bd630$export$1cfc858068dd8718);
const $be54e9dad71bd630$export$1cfc858068dd8718 = {
    name: 'servicedesk-redirect',
    path: '/jira/servicedesk/projects/:projectKey',
    exact: true
};

});


parcelRegister("d7mi1", function(module, exports) {

$parcel$export(module.exports, "projectSettingsAutomationCRouteEntry", () => $93ddc77854479226$export$8a6c5a399335fa16);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $jTltG = parcelRequire("jTltG");

var $e7bC3 = parcelRequire("e7bC3");

var $kdqX9 = parcelRequire("kdqX9");
const $93ddc77854479226$export$8a6c5a399335fa16 = (0, $7NszV.createEntry)((0, $jTltG.projectSettingsAutomationCRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings-automation-c',
        component: (0, $kdqX9.default),
        layout: (0, $e7bC3.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $dxCvy.projectContextResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kdqX9.LazyProjectSettingsJiraAutomation)
        ]
    }));

});
parcelRegister("jTltG", function(module, exports) {

$parcel$export(module.exports, "projectSettingsAutomationCRoute", () => $c472df0c8cbe0617$export$5337cc16f271a9cf);
const $c472df0c8cbe0617$export$5337cc16f271a9cf = {
    name: 'project-settings-automation',
    path: '/jira/software/c/projects/:projectKey/settings/automate'
};

});

parcelRegister("kdqX9", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsJiraAutomation", () => $4700cd79d99e02ea$export$dea5ad7e8eac12ae);
$parcel$export(module.exports, "default", () => $4700cd79d99e02ea$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $4700cd79d99e02ea$export$dea5ad7e8eac12ae = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("3Dp46")), {
    moduleId: "./src/packages/spa-apps/project-settings/jira-automation/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4700cd79d99e02ea$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $4700cd79d99e02ea$export$dea5ad7e8eac12ae,
        pageId: "project-settings-jira-automation",
        shouldShowSpinner: true
    });

});
parcelRegister("3Dp46", function(module, exports) {

let $2a58750af25485f1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2a58750af25485f1$var$load("4KSkX").then(()=>parcelRequire('ieTY5'));

});



parcelRegister("5HfC7", function(module, exports) {

$parcel$export(module.exports, "projectSettingsAutomationRouteEntry", () => $4db68a59886d705c$export$a34f85c5b69f2c2f);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $33SkB = parcelRequire("33SkB");

var $e7bC3 = parcelRequire("e7bC3");

var $kdqX9 = parcelRequire("kdqX9");

var $1XdKx = parcelRequire("1XdKx");
const $4db68a59886d705c$export$a34f85c5b69f2c2f = (0, $7NszV.createEntry)((0, $33SkB.projectSettingsAutomationRoute), ()=>({
        group: 'project-settings-software',
        ufoName: `project-settings-automation-${0, $1XdKx.SOFTWARE_PRODUCT}`,
        component: (0, $kdqX9.default),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kdqX9.LazyProjectSettingsJiraAutomation)
        ]
    }));

});
parcelRegister("33SkB", function(module, exports) {

$parcel$export(module.exports, "projectSettingsAutomationRoute", () => $ccabe492276f268a$export$7809aa084868deea);
const $ccabe492276f268a$export$7809aa084868deea = {
    name: 'project-settings-automation',
    path: '/jira/software/projects/:projectKey/settings/automate'
};

});


parcelRegister("6JQwt", function(module, exports) {

$parcel$export(module.exports, "projectSettingsComponentsRouteEntry", () => $ad71816b701c4a98$export$72497f4e39dd0df4);

var $ffza4 = parcelRequire("ffza4");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $xNRJ9 = parcelRequire("xNRJ9");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $cQsSp = parcelRequire("cQsSp");

var $cSUZZ = parcelRequire("cSUZZ");

var $4R6GH = parcelRequire("4R6GH");

var $gNStA = parcelRequire("gNStA");

var $7bHMy = parcelRequire("7bHMy");

var $d83t6 = parcelRequire("d83t6");
const $ad71816b701c4a98$export$72497f4e39dd0df4 = (0, $7NszV.createEntry)((0, $cQsSp.projectSettingsComponentsRoute), ()=>({
        group: 'components',
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $dxCvy.projectContextResource),
            (0, $xNRJ9.projectsComponentsResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jira-project-isglobalcomponent-route-resource'), (0, $7bHMy.projectGlobalComponentsResource))
        ],
        component: (0, $d83t6.default),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $d83t6.LazyProjectComponentsSettings)
        ]
    }));

});
parcelRegister("cQsSp", function(module, exports) {

$parcel$export(module.exports, "projectSettingsComponentsRoute", () => $d6034f5b9e9794c0$export$79cbce13eeecd53);
const $d6034f5b9e9794c0$export$79cbce13eeecd53 = {
    name: 'project-settings-components',
    path: '/plugins/servlet/project-config/:projectKey/administer-components'
};

});

parcelRegister("d83t6", function(module, exports) {

$parcel$export(module.exports, "LazyProjectComponentsSettings", () => $2794979f407c5b17$export$bb69d8c36391123);
$parcel$export(module.exports, "default", () => $2794979f407c5b17$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $aZsz6 = parcelRequire("aZsz6");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $a25Ol = parcelRequire("a25Ol");

const $2794979f407c5b17$export$bb69d8c36391123 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("eRz9R"))), {
    moduleId: "./src/packages/spa-apps/project/components/src/index.tsx"
});
const $2794979f407c5b17$export$60cfbcd781a48d01 = ()=>{
    const page = (_, { selectedItem: selectedItem, ...rest })=>{
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
        const querystring = (0, $aZsz6.qs).stringify(rest, true);
        return `/settings/components${querystring}`;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a25Ol.RedirectToProjectType), {
        page: page
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2794979f407c5b17$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2794979f407c5b17$export$bb69d8c36391123,
        pageId: "project-settings-components",
        shouldShowSpinner: true
    });

});
parcelRegister("a25Ol", function(module, exports) {

$parcel$export(module.exports, "RedirectToProjectType", () => $55786e10b01ad2e7$export$8a3df560509448b8);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dxCvy = parcelRequire("dxCvy");

var $bVDE5 = parcelRequire("bVDE5");

var $7tQej = parcelRequire("7tQej");
var $2YP9W = parcelRequire("2YP9W");
var $doZTA = parcelRequire("doZTA");
const $55786e10b01ad2e7$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $7tQej.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $8zOmE.fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, $2NMNM.useAnalyticsEvents), useResource: useResource = (0, $2YP9W.useResource), useRouter: useRouter = (0, $doZTA.useRouter), useSpaStateTransition: useSpaStateTransition = (0, $bVDE5.useSpaStateTransition) })=>{
    const [{ match: match, query: query, route: route }] = useRouter();
    const { data: data } = useResource((0, $dxCvy.projectContextResource));
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
    (0, $5uXOq.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $2vSU6.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $2vSU6.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};

});



parcelRegister("icwb1", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAccessRedirectRouteEntry", () => $b190785db05a7599$export$36e1851c22975fc0);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $jtZ32 = parcelRequire("jtZ32");

var $7tQej = parcelRequire("7tQej");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

var $8sFwL = parcelRequire("8sFwL");
const $b190785db05a7599$export$36e1851c22975fc0 = (0, $7NszV.createEntry)((0, $jtZ32.projectSettingsCoreAccessRedirectRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
                to: `/jira/core/projects/${String(match.params.projectKey)}/settings/access`,
                push: false
            }),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8sFwL.LazyPeopleSettings)
        ]
    }));

});
parcelRegister("jtZ32", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAccessRedirectRoute", () => $cb26bde1d38666aa$export$59e3323ba0cc224a);
const $cb26bde1d38666aa$export$59e3323ba0cc224a = {
    name: 'project-settings-core-access-redirect',
    path: '/jira/core/projects/:projectKey/settings/people',
    exact: true
};

});

parcelRegister("gTwsg", function(module, exports) {

$parcel$export(module.exports, "getNavigationSidebarProjectSettingsResource", () => $0cec9bd54a67f5ed$export$808691f5a412afa3);

var $5bkvv = parcelRequire("5bkvv");

var $loy04 = parcelRequire("loy04");

var $kJQXA = parcelRequire("kJQXA");

var $eOlBz = parcelRequire("eOlBz");

var $dxCvy = parcelRequire("dxCvy");
const $0cec9bd54a67f5ed$export$808691f5a412afa3 = ()=>[
        (0, $eOlBz.newIssueViewTransitionLockInStatusResource),
        (0, $kJQXA.navigationSidebarAutomationLegacyEnabledResource),
        (0, $dxCvy.projectContextResourceWithCache),
        (0, $5bkvv.forgeProjectSettingsModuleResource),
        (0, $loy04.staticProjectSettingsSidebarConnectAddonsNavigationResource)
    ];

});

parcelRegister("8sFwL", function(module, exports) {

$parcel$export(module.exports, "LazyPeopleSettings", () => $8dc1ced653e243b7$export$7eee4f97b7a1273);

var $7yO8g = parcelRequire("7yO8g");

var $kxZPA = parcelRequire("kxZPA");

const $8dc1ced653e243b7$export$7eee4f97b7a1273 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("8pwbR"))), {
    moduleId: "./src/packages/spa-apps/project-settings/people/src/index.tsx"
});

});
parcelRegister("8pwbR", function(module, exports) {

let $61f9a0e0c3257818$var$load = (parcelRequire("28QjX"))(4);
module.exports = $61f9a0e0c3257818$var$load("g4hzh").then(()=>parcelRequire('7N8D9'));

});



parcelRegister("egxSq", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAccessRouteEntry", () => $c0cf9eb9a1189c3e$export$8188648c76953df0);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $l2Ko4 = parcelRequire("l2Ko4");

var $jaAyo = parcelRequire("jaAyo");

var $5j7Th = parcelRequire("5j7Th");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

var $8sFwL = parcelRequire("8sFwL");
const $c0cf9eb9a1189c3e$var$Access = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $8sFwL.LazyPeopleSettings),
        pageId: "project-settings-people",
        shouldShowSpinner: false
    });
const $c0cf9eb9a1189c3e$export$8188648c76953df0 = (0, $7NszV.createEntry)((0, $l2Ko4.projectSettingsCoreAccessRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $c0cf9eb9a1189c3e$var$Access,
        skeleton: (0, $jaAyo.ProjectSettingsAccessSkeleton),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8sFwL.LazyPeopleSettings)
        ],
        ufoName: 'project-settings.access'
    }));

});
parcelRegister("l2Ko4", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAccessRoute", () => $213a8c0a4e177f13$export$fe93051d5b7385a1);
const $213a8c0a4e177f13$export$fe93051d5b7385a1 = {
    name: 'project-settings-core-access',
    path: '/jira/core/projects/:projectKey/settings/access',
    exact: true
};

});


parcelRegister("lhZGg", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreApprovalsRouteEntry", () => $391f453756ba70b6$export$728033a86ab68014);

var $18N1t = parcelRequire("18N1t");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $hIjSj = parcelRequire("hIjSj");

var $ljyNx = parcelRequire("ljyNx");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");
const $391f453756ba70b6$var$approvalsProjectSettingsPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $ljyNx.approvalsProjectSettingsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $391f453756ba70b6$export$728033a86ab68014 = (0, $7NszV.createEntry)((0, $hIjSj.projectSettingsCoreApprovalsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        entryPoint () {
            return $391f453756ba70b6$var$approvalsProjectSettingsPageEntryPoint;
        },
        ufoName: 'project-settings-approvals-core'
    }));

});
parcelRegister("hIjSj", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreApprovalsRoute", () => $2c78c142a4e64bf0$export$ba11c8f378a2c121);
const $2c78c142a4e64bf0$export$ba11c8f378a2c121 = {
    name: 'project-settings-core-approvals',
    path: '/jira/core/projects/:projectKey/settings/approvals',
    exact: true
};

});

parcelRegister("ljyNx", function(module, exports) {

$parcel$export(module.exports, "approvalsProjectSettingsEntryPoint", () => $d1b68aa40690ad89$export$1389a6ddf34f642e);

var $bDrsD = parcelRequire("bDrsD");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $d1b68aa40690ad89$export$1389a6ddf34f642e = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("fGoju")), {
        moduleId: "83e2f2c2",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                approvalsSettingsQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $bDrsD.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("bDrsD", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ed220cf4f93fbf5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d871f3ede49d545d142f76fc4cdb7b72>>
 * @relayHash c1a8c3336b76570b82a8688f17264c3b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 270763b3ff0773a74aedea0d0dc622ebea8eee56eab0c89b0657cf49632cc53f
const $9ed220cf4f93fbf5$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "270763b3ff0773a74aedea0d0dc622ebea8eee56eab0c89b0657cf49632cc53f",
        "metadata": {},
        "name": "src_jiraBusinessApprovalsSettingsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $9ed220cf4f93fbf5$export$2e2bcd8739ae039 = $9ed220cf4f93fbf5$var$node;

});

parcelRegister("fGoju", function(module, exports) {

let $b6ada35dd488d0c8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b6ada35dd488d0c8$var$load("irD3p").then(()=>parcelRequire('8gPdF'));

});



parcelRegister("jr5gb", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAppsFieldsRouteEntry", () => $6edc0d1d8bb5be4d$export$7870a0b1630a504e);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $9qIcj = parcelRequire("9qIcj");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

const $6edc0d1d8bb5be4d$var$LazyConnectAppControlsSettings = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("1j8hG"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-app-controls/src/index.tsx"
});
const $6edc0d1d8bb5be4d$var$ConnectAppControlsPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $6edc0d1d8bb5be4d$var$LazyConnectAppControlsSettings,
        pageId: "project-settings-connect-app-controls",
        shouldShowSpinner: false
    });
const $6edc0d1d8bb5be4d$export$7870a0b1630a504e = (0, $7NszV.createEntry)((0, $9qIcj.projectSettingsCoreAppsFieldsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $6edc0d1d8bb5be4d$var$ConnectAppControlsPage,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $6edc0d1d8bb5be4d$var$LazyConnectAppControlsSettings
        ]
    }));

});
parcelRegister("9qIcj", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAppsFieldsRoute", () => $68a47d7164ebf1d3$export$1c7e75ffaa491922);
const $68a47d7164ebf1d3$export$1c7e75ffaa491922 = {
    name: 'project-settings-core-apps-fields',
    path: '/jira/core/projects/:projectKey/settings/apps/app-fields',
    exact: true
};

});

parcelRegister("1j8hG", function(module, exports) {

let $0f3dfdda988fa97f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0f3dfdda988fa97f$var$load("hXzjm").then(()=>parcelRequire('kO3mB'));

});


parcelRegister("7lZOe", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAppsRouteEntry", () => $af106c0091889a1f$export$c038a2892f34f1a9);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $hZjdc = parcelRequire("hZjdc");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

const $af106c0091889a1f$var$LazyConnectAppsSettings = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("flIAq"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-apps/src/index.tsx"
});
const $af106c0091889a1f$var$ConnectAppsPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $af106c0091889a1f$var$LazyConnectAppsSettings,
        pageId: "project-settings-connect-apps",
        shouldShowSpinner: false
    });
const $af106c0091889a1f$export$c038a2892f34f1a9 = (0, $7NszV.createEntry)((0, $hZjdc.projectSettingsCoreAppsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $af106c0091889a1f$var$ConnectAppsPage,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $af106c0091889a1f$var$LazyConnectAppsSettings
        ]
    }));

});
parcelRegister("hZjdc", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAppsRoute", () => $7add52f5911a831e$export$c7ac65fb0bbe767f);
const $7add52f5911a831e$export$c7ac65fb0bbe767f = {
    name: 'project-settings-core-apps',
    path: '/jira/core/projects/:projectKey/settings/apps/:appId?',
    exact: true
};

});

parcelRegister("flIAq", function(module, exports) {

let $b2cb671febd63ce2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b2cb671febd63ce2$var$load("eJV9X").then(()=>parcelRequire('79qwo'));

});


parcelRegister("9rVvQ", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAutomationRouteEntry", () => $1becf8cdf357266c$export$a244870e56f5c9a3);

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $bCPFV = parcelRequire("bCPFV");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

var $eBc8i = parcelRequire("eBc8i");
const $1becf8cdf357266c$export$a244870e56f5c9a3 = (0, $7NszV.createEntry)((0, $bCPFV.projectSettingsCoreAutomationRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: (0, $eBc8i.AutomationLazyPage),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $eBc8i.LazyProjectSettingsJiraAutomation)
        ],
        ufoName: 'project-settings-automation-core'
    }));

});
parcelRegister("bCPFV", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAutomationRoute", () => $7024005c59ef8f32$export$65a4d727336c49f4);
const $7024005c59ef8f32$export$65a4d727336c49f4 = {
    name: 'project-settings-core-automation',
    path: '/jira/core/projects/:projectKey/settings/automation'
};

});

parcelRegister("eBc8i", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsJiraAutomation", () => $d9e4cec5af9ce718$export$dea5ad7e8eac12ae);
$parcel$export(module.exports, "AutomationLazyPage", () => $d9e4cec5af9ce718$export$88eebe21cecb82db);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $d9e4cec5af9ce718$export$dea5ad7e8eac12ae = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("3Dp46")), {
    moduleId: "./src/packages/spa-apps/project-settings/jira-automation/src/index.tsx"
});
const $d9e4cec5af9ce718$export$88eebe21cecb82db = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d9e4cec5af9ce718$export$dea5ad7e8eac12ae,
        pageId: "project-settings-jira-automation",
        shouldShowSpinner: true
    });

});


parcelRegister("au6vg", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAutomationV2RouteEntry", () => $d7c59ae6b2241667$export$a2c8a6767edeeaed);

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $dJG0f = parcelRequire("dJG0f");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

var $eBc8i = parcelRequire("eBc8i");
const $d7c59ae6b2241667$export$a2c8a6767edeeaed = (0, $7NszV.createEntry)((0, $dJG0f.projectSettingsCoreAutomationV2Route), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: (0, $eBc8i.AutomationLazyPage),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $eBc8i.LazyProjectSettingsJiraAutomation)
        ]
    }));

});
parcelRegister("dJG0f", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAutomationV2Route", () => $e31b6bde721f5bf5$export$5437af2650f645e0);
const $e31b6bde721f5bf5$export$5437af2650f645e0 = {
    name: 'project-settings-core-automation',
    path: '/jira/core/projects/:projectKey/settings/automate'
};

});


parcelRegister("cLamq", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreDataClassificationsRouteEntry", () => $60f4334670e39dba$export$cf5194c476e8bcdb);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $brYsn = parcelRequire("brYsn");

var $jaAyo = parcelRequire("jaAyo");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

const $60f4334670e39dba$var$LazyDataClassificationsSettings = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("foQoc"))), {
    moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
});
const $60f4334670e39dba$var$DataClassifications = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $60f4334670e39dba$var$LazyDataClassificationsSettings,
        pageId: "project-settings-data-classifications",
        shouldShowSpinner: false
    });
const $60f4334670e39dba$export$cf5194c476e8bcdb = (0, $7NszV.createEntry)((0, $brYsn.projectSettingsCoreDataClassificationsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $60f4334670e39dba$var$DataClassifications,
        skeleton: (0, $jaAyo.ProjectSettingsDetailsSkeleton),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("brYsn", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreDataClassificationsRoute", () => $46bd61981cdecbb8$export$7aae1006c82a79c0);
const $46bd61981cdecbb8$export$7aae1006c82a79c0 = {
    name: 'project-settings-core-data-classifications',
    path: '/jira/core/projects/:projectKey/settings/data-classifications',
    exact: true
};

});


parcelRegister("2vHPs", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreDefaultRedirectRouteEntry", () => $72042ad67933f70e$export$df1c02c3f28b7a95);

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $1IH8G = parcelRequire("1IH8G");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

var $7dO7c = parcelRequire("7dO7c");
const $72042ad67933f70e$export$df1c02c3f28b7a95 = (0, $7NszV.createEntry)((0, $1IH8G.projectSettingsCoreDefaultRedirectRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: (0, $7dO7c.ProjectSettingsRedirect),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("1IH8G", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreDefaultRedirectRoute", () => $5a27ba0a68240f95$export$322fe16ec991f12);
const $5a27ba0a68240f95$export$322fe16ec991f12 = {
    name: 'project-settings-core-redirect',
    path: '/jira/core/projects/:projectKey/settings'
};

});

parcelRegister("7dO7c", function(module, exports) {

$parcel$export(module.exports, "ProjectSettingsRedirect", () => $646d86edb6dba940$export$72130cf40a3c3778);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $1J3t1 = parcelRequire("1J3t1");

var $7tQej = parcelRequire("7tQej");
const $646d86edb6dba940$export$72130cf40a3c3778 = ({ match: match })=>{
    const { data: data } = (0, $1J3t1.useJiraWorkmanagementProjectNavigation)();
    const { projectKey: projectKey } = match.params;
    if (data?.permissionInfo?.isAdmin || data?.permissionInfo?.isSiteAdmin || data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/jira/core/projects/${String(projectKey)}/settings/details`
    });
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_WORKFLOW === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/workflows`
    });
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_ISSUE_LAYOUT === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/issuelayout`
    });
    if ((0, $4R6GH.fg)('vmc-11-manage-versions-permission')) {
        if (data?.permissionInfo?.projectPermissionsQueried?.MANAGE_VERSIONS === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: `/plugins/servlet/project-config/${String(projectKey)}/administer-versions`
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/jira/core/projects/${String(match.params.projectKey)}/settings/details`
    });
};

});


parcelRegister("hztdR", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreDetailsRouteEntry", () => $f65156aa09643d37$export$438a330ccc1e7a91);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $3yAjF = parcelRequire("3yAjF");

var $jaAyo = parcelRequire("jaAyo");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

const $f65156aa09643d37$var$LazyDetailsSettings = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("eC5lK"))), {
    moduleId: "./src/packages/spa-apps/project-settings/details/src/index.tsx"
});
const $f65156aa09643d37$var$Details = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f65156aa09643d37$var$LazyDetailsSettings,
        pageId: "project-settings-details",
        shouldShowSpinner: false
    });
const $f65156aa09643d37$export$438a330ccc1e7a91 = (0, $7NszV.createEntry)((0, $3yAjF.projectSettingsCoreDetailsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $f65156aa09643d37$var$Details,
        skeleton: (0, $jaAyo.ProjectSettingsDetailsSkeleton),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $f65156aa09643d37$var$LazyDetailsSettings
        ]
    }));

});
parcelRegister("3yAjF", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreDetailsRoute", () => $5d63f1af39ccfc34$export$14535b40530c8690);
const $5d63f1af39ccfc34$export$14535b40530c8690 = {
    name: 'project-settings-core-details',
    path: '/jira/core/projects/:projectKey/settings/details',
    exact: true
};

});


parcelRegister("6cSNh", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreFieldsRouteEntry", () => $3dfc1ebecbfe533b$export$8d8dff75124dcebc);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $7XYc4 = parcelRequire("7XYc4");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $e7C7O = parcelRequire("e7C7O");

var $5lsNZ = parcelRequire("5lsNZ");

var $9BCCu = parcelRequire("9BCCu");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $cSUZZ = parcelRequire("cSUZZ");

var $6s1PB = parcelRequire("6s1PB");

var $gTwsg = parcelRequire("gTwsg");
const $3dfc1ebecbfe533b$var$isEfaExperimentExposed = ()=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('efa_and_project_fields_page_for_tmp');
    return expConfig.get('isEnabled', false);
};

const $3dfc1ebecbfe533b$var$LazyFieldsSettings = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("cqfV9"))), {
    moduleId: "./src/packages/spa-apps/project-settings/fields/src/index.tsx"
});
const $3dfc1ebecbfe533b$var$FieldsPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3dfc1ebecbfe533b$var$LazyFieldsSettings,
        pageId: "project-settings-fields",
        shouldShowSpinner: true
    });
const $3dfc1ebecbfe533b$export$8d8dff75124dcebc = (0, $7NszV.createEntry)((0, $9BCCu.projectSettingsCoreFieldsRoute), ()=>({
        group: 'project-settings-core',
        ufoName: 'project-settings.fields.jwm-tmp',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            (0, $e7C7O.fieldSettingsRelayResource)
        ],
        component: (0, $7XYc4.componentWithCondition)($3dfc1ebecbfe533b$var$isEfaExperimentExposed, $3dfc1ebecbfe533b$var$FieldsPage, (0, $5lsNZ.default)),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $3dfc1ebecbfe533b$var$LazyFieldsSettings
        ]
    }));

});
parcelRegister("e7C7O", function(module, exports) {

$parcel$export(module.exports, "fieldSettingsRelayResource", () => $424e18beff0a1aec$export$68b4e700e00bad7a);

var $ao2h1 = parcelRequire("ao2h1");

var $gF6UW = parcelRequire("gF6UW");

var $1nb22 = parcelRequire("1nb22");
const $424e18beff0a1aec$var$RESOURCE_TYPE_PROJECT_SETTINGS_FIELDS = 'PROJECT_SETTINGS_FIELDS';
const $424e18beff0a1aec$export$68b4e700e00bad7a = (0, $ao2h1.createRelayResource)({
    type: $424e18beff0a1aec$var$RESOURCE_TYPE_PROJECT_SETTINGS_FIELDS,
    getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(match, query);
        return {
            parameters: (0, $gF6UW.default),
            variables: {
                projectKey: projectKey ?? '',
                cloudId: tenantContext.cloudId ?? ''
            },
            options: {
                fetchPolicy: 'network-only'
            }
        };
    }
});

});
parcelRegister("gF6UW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e41b4fca86430f4d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ee28b66a642cc1004aa55dc30a2345a5>>
 * @relayHash 688b6c95c0ea52161faae19bee1dd1b8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 168b1f0f840442f9fbe701ad7fbb88fc92d9062192e9881d6ac0dc7c01a053df

var $3iWRf = parcelRequire("3iWRf");

var $fqBML = parcelRequire("fqBML");

var $eiowN = parcelRequire("eiowN");
const $e41b4fca86430f4d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v2 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v3 = [
        v2 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "isExplicitFieldAssociationsEnabled"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "ScalarField",
        "name": "key"
    }, v10 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 30
        }
    ], v11 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "uiFieldsPageQuery",
            "selections": [
                {
                    "args": [
                        v2 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "projectKey",
                            "variableName": "projectKey"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "fieldsTable_projectFields"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "FragmentSpread",
                                    "name": "pageHeader_projectFields_Header"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationuienabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolourfulsingleselectfieldsexperimentrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "uiFieldsPageQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                },
                                {
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v9 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "optionsPerFieldLimit"
                                },
                                {
                                    "concreteType": "JiraFieldTypeGroupConnection",
                                    "kind": "LinkedField",
                                    "name": "projectFieldTypeGroups",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFieldTypeGroupEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFieldTypeGroup",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "displayName"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectScopedFieldsPerProjectLimit"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectScopedFieldsCount"
                                },
                                v8 /*: any*/ ,
                                {
                                    "concreteType": "JiraProjectWithIssueTypeIds",
                                    "kind": "LinkedField",
                                    "name": "projectWithVisibleIssueTypeIds",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v10 /*: any*/ ,
                                            "concreteType": "JiraFieldAssociationWithIssueTypesConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldAssociationWithIssueTypes",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFieldAssociationWithIssueTypesEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraFieldAssociationWithIssueTypes",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraField",
                                                                    "kind": "LinkedField",
                                                                    "name": "field",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "fieldId"
                                                                        },
                                                                        v8 /*: any*/ ,
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "scope"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "typeName"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "description"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "typeKey"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "hasMissingConfiguration"
                                                                },
                                                                {
                                                                    "concreteType": "JiraIssueTypeConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypes",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueTypeEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v5 /*: any*/ ,
                                                                                        v6 /*: any*/ ,
                                                                                        v8 /*: any*/ ,
                                                                                        v7 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraFieldOperation",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldOperation",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canRemove"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canDelete"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canAssociateInSettings"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canEdit"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canModifyOptions"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraFieldOptionConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldOptions",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraFieldOptionEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraFieldOption",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "optionId"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "parentOptionId"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "value"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolourfulsingleselectfieldsexperimentrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraColor",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "color",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "colorKey"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationuienabledrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldFormatConfig",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v11 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "formatStyle"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "formatUnit"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "formatDecimals"
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraNumberFieldFormatConfig"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isFieldLocked"
                                                                },
                                                                v11 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "fieldAssociationWithIssueTypes(first:30)"
                                        },
                                        {
                                            "args": v10 /*: any*/ ,
                                            "filters": [
                                                "input"
                                            ],
                                            "handle": "connection",
                                            "key": "fieldsTable_fieldAssociationWithIssueTypes",
                                            "kind": "LinkedHandle",
                                            "name": "fieldAssociationWithIssueTypes"
                                        }
                                    ]
                                },
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "168b1f0f840442f9fbe701ad7fbb88fc92d9062192e9881d6ac0dc7c01a053df",
            "metadata": {},
            "name": "uiFieldsPageQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationuienabledrelayprovider": (0, $3iWRf.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolourfulsingleselectfieldsexperimentrelayprovider": (0, $fqBML.default)
            }
        }
    };
}();
$e41b4fca86430f4d$var$node.hash = "b0872e3059548632993c06522c7f5584";
(0, $eiowN.PreloadableQueryRegistry).set($e41b4fca86430f4d$var$node.params.id, $e41b4fca86430f4d$var$node);
var $e41b4fca86430f4d$export$2e2bcd8739ae039 = $e41b4fca86430f4d$var$node;

});
parcelRegister("3iWRf", function(module, exports) {

$parcel$export(module.exports, "default", () => $b077dd0bcb571945$export$2e2bcd8739ae039);

var $6nAWD = parcelRequire("6nAWD");
var $b077dd0bcb571945$export$2e2bcd8739ae039 = {
    get () {
        return (0, $6nAWD.isSidebarFormatConfigEnabled)();
    }
};

});
parcelRegister("6nAWD", function(module, exports) {

$parcel$export(module.exports, "formatNumberField", () => $9b0426e4b7a06da2$export$d390e3b8d1c21e01);
$parcel$export(module.exports, "isSidebarFormatConfigEnabled", () => $9b0426e4b7a06da2$export$3c854a930069a447);

var $4R6GH = parcelRequire("4R6GH");

/**
 * This is due to Jira commonly using the POSIX format (using '_' for defining locales),
 * such as in jira/src/packages/platform/utils/constants/src/supported-locales.tsx,
 * whereas the Intl Javascript API requires locales to be in the IETF BCP 47 format.
 */ const $9b0426e4b7a06da2$var$coerceBCPLocaleFormat = (locale)=>{
    return locale.replace('_', '-');
};
// Converts strings to lower case while also preventing string literal types from being converted
// into the more general `string` type as the String.prototype.toLowerCase() method always returns
// a `string` type, even if the string is a string literal. For example:
// const string = 'CONSTANT'; // type is `'CONSTANT'`;
// string.toLowerCase() // returned type is `string`;
// toLowerCase(string) // returned type is `'constant'`;
const $9b0426e4b7a06da2$var$toLowerCase = (inputString)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return inputString.toLocaleLowerCase();
};
const $9b0426e4b7a06da2$var$isSupportedCurrencyCode = (currencyCode)=>{
    // Check if the currency code is supported
    return Intl.supportedValuesOf($9b0426e4b7a06da2$var$toLowerCase((0, $ef69814f8c2ef982$export$a82896da99871ba4))).includes(currencyCode);
};
const $9b0426e4b7a06da2$var$isSupportedUnit = (unit)=>{
    // Check if the unit is supported
    return Intl.supportedValuesOf($9b0426e4b7a06da2$var$toLowerCase((0, $ef69814f8c2ef982$export$83551de9ca24925e))).includes(unit);
};
const $9b0426e4b7a06da2$export$3dc27271f5d5c629 = (amount, config = {})=>{
    const { currencyCode: currencyCode = (0, $ef69814f8c2ef982$export$c852e1f5bb177898), locale: locale, currencyDisplay: currencyDisplay = (0, $ef69814f8c2ef982$export$b9e50a64e0ca3437), ...rest } = config;
    // Check if the currency code is supported. fall back to decimal format if not.
    const formatOptions = $9b0426e4b7a06da2$var$isSupportedCurrencyCode(currencyCode) ? {
        style: (0, $ef69814f8c2ef982$export$a82896da99871ba4).toLocaleLowerCase(),
        currency: currencyCode,
        currencyDisplay: currencyDisplay,
        maximumFractionDigits: Number.isInteger(amount) ? 0 : undefined,
        ...rest
    } : {
        style: (0, $ef69814f8c2ef982$export$768e3e8e60d01cea).toLocaleLowerCase(),
        ...rest
    };
    const formatter = new Intl.NumberFormat(locale && $9b0426e4b7a06da2$var$coerceBCPLocaleFormat(locale), formatOptions);
    return formatter.format(amount ?? 0);
};
const $9b0426e4b7a06da2$export$32e6b1ae352e94d6 = (amount, config = {})=>{
    const { locale: locale, ...rest } = config;
    return new Intl.NumberFormat(locale && $9b0426e4b7a06da2$var$coerceBCPLocaleFormat(locale), {
        ...rest,
        style: (0, $ef69814f8c2ef982$export$83551de9ca24925e).toLocaleLowerCase(),
        unit: (0, $ef69814f8c2ef982$export$97f1ae291e87b4b2)
    }).format(amount ?? 0);
};
const $9b0426e4b7a06da2$export$bd39b96f71da1885 = (number, config = {})=>{
    const { unit: unit, locale: locale, ...rest } = config;
    // Check if the unit code is supported. fall back to decimal format if not.
    const formatOptions = unit && $9b0426e4b7a06da2$var$isSupportedUnit(unit) ? {
        style: (0, $ef69814f8c2ef982$export$83551de9ca24925e).toLocaleLowerCase(),
        unit: unit,
        ...rest
    } : {
        style: (0, $ef69814f8c2ef982$export$768e3e8e60d01cea).toLocaleLowerCase(),
        ...rest
    };
    const formatter = new Intl.NumberFormat(locale && $9b0426e4b7a06da2$var$coerceBCPLocaleFormat(locale), formatOptions);
    return formatter.format(number ?? 0);
};
const $9b0426e4b7a06da2$export$845857f28dc08744 = (number, config = {})=>{
    const formatter = new Intl.NumberFormat(config.locale && $9b0426e4b7a06da2$var$coerceBCPLocaleFormat(config.locale), {
        style: (0, $ef69814f8c2ef982$export$768e3e8e60d01cea).toLocaleLowerCase(),
        ...config
    });
    return formatter.format(number ?? 0);
};
const $9b0426e4b7a06da2$export$d390e3b8d1c21e01 = (number, config = {
    formatStyle: (0, $ef69814f8c2ef982$export$768e3e8e60d01cea)
})=>{
    const { formatStyle: formatStyle, formatUnit: formatUnit, locale: locale } = config;
    switch(formatStyle){
        case 0, $ef69814f8c2ef982$export$a82896da99871ba4:
            return formatUnit ? $9b0426e4b7a06da2$export$3dc27271f5d5c629(number, {
                locale: locale,
                currencyCode: formatUnit
            }) : $9b0426e4b7a06da2$export$845857f28dc08744(number, {
                locale: locale
            });
        case 0, $ef69814f8c2ef982$export$e50c15d5408652a9:
            return $9b0426e4b7a06da2$export$32e6b1ae352e94d6(number, {
                locale: locale
            });
        case 0, $ef69814f8c2ef982$export$83551de9ca24925e:
            return formatUnit ? $9b0426e4b7a06da2$export$bd39b96f71da1885(number, {
                locale: locale,
                unit: formatUnit
            }) : $9b0426e4b7a06da2$export$845857f28dc08744(number, {
                locale: locale
            });
        default:
            return $9b0426e4b7a06da2$export$845857f28dc08744(number);
    }
};
const $9b0426e4b7a06da2$export$3c854a930069a447 = ()=>// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4R6GH.fg)('frontier-currency-field-d1') && (0, $4R6GH.fg)('fields-settings-currency-field-display');

});
const $ef69814f8c2ef982$export$c852e1f5bb177898 = 'USD';
const $ef69814f8c2ef982$export$b9e50a64e0ca3437 = 'narrowSymbol';
const $ef69814f8c2ef982$export$768e3e8e60d01cea = 'DECIMAL';
const $ef69814f8c2ef982$export$a82896da99871ba4 = 'CURRENCY';
const $ef69814f8c2ef982$export$e50c15d5408652a9 = 'PERCENT';
const $ef69814f8c2ef982$export$83551de9ca24925e = 'UNIT';
const $ef69814f8c2ef982$export$e0f41b79f8d902b5 = 'liter';
const $ef69814f8c2ef982$export$83a33c313ebf2c4a = 'meter';
const $ef69814f8c2ef982$export$32fca264df3a7957 = 'kilogram';
const $ef69814f8c2ef982$export$97f1ae291e87b4b2 = 'percent';



parcelRegister("fqBML", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c0d9a50b10efb8d$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");
var $0c0d9a50b10efb8d$export$2e2bcd8739ae039 = {
    get () {
        return (0, $6s1PB.expVal)('thor_colourful_single_select_milestone2_experiment', 'isColorfulSingleSelectEnabled', false) && (0, $6s1PB.expVal)('thor_colourful_single_select_fields_experiment', 'isColorfulSingleSelectEnabled', false);
    }
};

});



parcelRegister("9BCCu", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreFieldsRoute", () => $03614f84baa4becb$export$7c4ee74641923239);
const $03614f84baa4becb$export$7c4ee74641923239 = {
    name: 'project-settings-core-fields',
    path: '/jira/core/projects/:projectKey/settings/fields',
    exact: true
};

});

parcelRegister("cqfV9", function(module, exports) {

let $90b4434558a8f4ff$var$load = (parcelRequire("28QjX"))(4);
module.exports = $90b4434558a8f4ff$var$load("4eTRc").then(()=>parcelRequire('aRrWI'));

});


parcelRegister("lIPtt", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreForgeAppsRouteEntry", () => $81842dc02c80a297$export$1006fd9f5f02b1c2);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $kXEQj = parcelRequire("kXEQj");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

const $81842dc02c80a297$var$LazyForgeProjectSettingsPage = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("bZbyt")), {
    moduleId: "./src/packages/spa-apps/forge/project-settings/src/index.tsx"
});
const $81842dc02c80a297$var$ForgeProjectSettingsPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $81842dc02c80a297$var$LazyForgeProjectSettingsPage,
        pageId: "forge-spa-project-settings",
        shouldShowSpinner: true
    });
const $81842dc02c80a297$export$1006fd9f5f02b1c2 = (0, $7NszV.createEntry)((0, $kXEQj.projectSettingsCoreForgeAppsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $81842dc02c80a297$var$ForgeProjectSettingsPage,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $81842dc02c80a297$var$LazyForgeProjectSettingsPage
        ]
    }));

});
parcelRegister("kXEQj", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreForgeAppsRoute", () => $ffe7ed90d4a26759$export$b34160f55b6104e9);
const $ffe7ed90d4a26759$export$b34160f55b6104e9 = {
    name: 'project-settings-core-forge-apps',
    path: '/jira/core/projects/:projectKey/settings/apps/:appId/:envId/:route?'
};

});

parcelRegister("bZbyt", function(module, exports) {

let $8b9e5aca48265423$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8b9e5aca48265423$var$load("bfSAg").then(()=>parcelRequire('ln9R3'));

});


parcelRegister("cWKD0", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreIssueTypesRouteEntry", () => $dfd719394f285715$export$95ecbacf0120fcfd);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $cXAV1 = parcelRequire("cXAV1");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

const $dfd719394f285715$var$LazyIssueTypeSettings = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("7a4qW"))), {
    moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
});
const $dfd719394f285715$var$IssueTypePage = ({ match: match })=>{
    const { issueTypeId: issueTypeId } = match.params;
    // unique pageId need to be set so that ApdexProvider would properly reset all the performance marks when switching between issue types
    const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $dfd719394f285715$var$LazyIssueTypeSettings,
        pageId: pageId,
        shouldShowSpinner: false
    });
};
const $dfd719394f285715$export$95ecbacf0120fcfd = (0, $7NszV.createEntry)((0, $cXAV1.projectSettingsCoreIssueTypesRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $dfd719394f285715$var$IssueTypePage,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $dfd719394f285715$var$LazyIssueTypeSettings
        ]
    }));

});
parcelRegister("cXAV1", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreIssueTypesRoute", () => $9890a5b2bae88b9c$export$c3a32433c580b9ff);
const $9890a5b2bae88b9c$export$c3a32433c580b9ff = {
    name: 'project-settings-core-issuetypes',
    path: '/jira/core/projects/:projectKey/settings/issuetypes/:issueTypeId?',
    exact: true
};

});


parcelRegister("d0eOH", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreIssueTypesWorkflowRouteEntry", () => $73a52ccb6b02557a$export$1dfd4811b9065dd6);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $Tp0iK = parcelRequire("Tp0iK");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

const $73a52ccb6b02557a$var$LazyWorkflowNavigationSettings = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("gEQDq"))), {
    moduleId: "./src/packages/spa-apps/project-settings/workflow-navigation/src/index.tsx"
});
const $73a52ccb6b02557a$var$WorkflowNavigationPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $73a52ccb6b02557a$var$LazyWorkflowNavigationSettings,
        pageId: "project-settings-workflow-navigation",
        shouldShowSpinner: false
    });
const $73a52ccb6b02557a$export$1dfd4811b9065dd6 = (0, $7NszV.createEntry)((0, $Tp0iK.projectSettingsCoreIssueTypesWorkflowRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $73a52ccb6b02557a$var$WorkflowNavigationPage,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $73a52ccb6b02557a$var$LazyWorkflowNavigationSettings
        ]
    }));

});
parcelRegister("Tp0iK", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreIssueTypesWorkflowRoute", () => $5c1b1d7296dcb1b9$export$9e79ee307216071b);
const $5c1b1d7296dcb1b9$export$9e79ee307216071b = {
    name: 'project-settings-core-issuetypes-workflow',
    path: '/jira/core/projects/:projectKey/settings/issuetypes/:issueTypeId/:initialSection(workflow)',
    exact: true
};

});

parcelRegister("gEQDq", function(module, exports) {

let $c20935fcbb16708d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c20935fcbb16708d$var$load("76n7a"),
    $c20935fcbb16708d$var$load("l253H"),
    $c20935fcbb16708d$var$load("ffQaD"),
    $c20935fcbb16708d$var$load("kvRbA"),
    $c20935fcbb16708d$var$load("JZq07")
]).then(()=>parcelRequire('fEx2J'));

});


parcelRegister("bxg3m", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreNotificationsEmailRouteEntry", () => $c698ffcb86d9bd83$export$da36a1671d868927);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $6IsiM = parcelRequire("6IsiM");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

const $c698ffcb86d9bd83$var$LazyProjectSettingsNotificationEmail = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hLnUL"))), {
    moduleId: "./src/packages/spa-apps/project-settings/notification-email/src/index.tsx"
});
const $c698ffcb86d9bd83$var$EmailNotifications = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $c698ffcb86d9bd83$var$LazyProjectSettingsNotificationEmail,
        pageId: "project-settings-email-notifications",
        shouldShowSpinner: true
    });
const $c698ffcb86d9bd83$export$da36a1671d868927 = (0, $7NszV.createEntry)((0, $6IsiM.projectSettingsCoreNotificationsEmailRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $c698ffcb86d9bd83$var$EmailNotifications,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $c698ffcb86d9bd83$var$LazyProjectSettingsNotificationEmail
        ]
    }));

});
parcelRegister("6IsiM", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreNotificationsEmailRoute", () => $91d0b5fe7c793948$export$b546589f1b048dc);
const $91d0b5fe7c793948$export$b546589f1b048dc = {
    name: 'project-settings-core-notifications-notification-email',
    path: '/jira/core/projects/:projectKey/settings/notifications/notification-email',
    exact: true
};

});

parcelRegister("hLnUL", function(module, exports) {

let $cee9606302ec1388$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cee9606302ec1388$var$load("OBAxr").then(()=>parcelRequire('d6iMp'));

});


parcelRegister("e6Vbw", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreNotificationsIssueLogsRouteEntry", () => $4c1c7acc90dd4d09$export$e562140c482cb0c);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $cpVGO = parcelRequire("cpVGO");

var $femMW = parcelRequire("femMW");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");
const $4c1c7acc90dd4d09$var$emailNotificationsLogEntryPointPage = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $femMW.notificationsIssueLogsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

const $4c1c7acc90dd4d09$var$LazyNotificationsIssueLogs = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("5Q8bv"))), {
    moduleId: "./src/packages/spa-apps/project-settings/software-notifications-issue-logs/src/index.tsx"
});
const $4c1c7acc90dd4d09$var$NotificationsIssueLogs = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $4c1c7acc90dd4d09$var$LazyNotificationsIssueLogs,
        pageId: "project-settings-software-notifications-issue-logs",
        shouldShowSpinner: false
    });
const $4c1c7acc90dd4d09$export$e562140c482cb0c = (0, $7NszV.createEntry)((0, $cpVGO.projectSettingsCoreNotificationsIssueLogsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $4c1c7acc90dd4d09$var$NotificationsIssueLogs,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $4c1c7acc90dd4d09$var$LazyNotificationsIssueLogs
        ],
        entryPoint () {
            return $4c1c7acc90dd4d09$var$emailNotificationsLogEntryPointPage;
        }
    }));

});
parcelRegister("cpVGO", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreNotificationsIssueLogsRoute", () => $1ebe41c3d3a19553$export$56a8a0b88329b044);
const $1ebe41c3d3a19553$export$56a8a0b88329b044 = {
    name: 'project-settings-core-notifications-issue-logs',
    path: '/jira/core/projects/:projectKey/settings/notifications/issue-logs',
    exact: true
};

});


parcelRegister("7LwJB", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreNotificationsRouteEntry", () => $221f77694f7c3501$export$ed481b03aa858542);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $oHytR = parcelRequire("oHytR");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

const $221f77694f7c3501$var$LazyNotificationsSettings = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("fhvdd"))), {
    moduleId: "./src/packages/spa-apps/project-settings/software-notifications/src/index.tsx"
});
const $221f77694f7c3501$var$Notifications = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $221f77694f7c3501$var$LazyNotificationsSettings,
        pageId: "project-settings-software-notifications",
        shouldShowSpinner: false
    });
const $221f77694f7c3501$export$ed481b03aa858542 = (0, $7NszV.createEntry)((0, $oHytR.projectSettingsCoreNotificationsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $221f77694f7c3501$var$Notifications,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $221f77694f7c3501$var$LazyNotificationsSettings
        ]
    }));

});
parcelRegister("oHytR", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreNotificationsRoute", () => $3cc89fad893f0f33$export$a1ee80066685b98d);
const $3cc89fad893f0f33$export$a1ee80066685b98d = {
    name: 'project-settings-core-notifications',
    path: '/jira/core/projects/:projectKey/settings/notifications',
    exact: true
};

});

parcelRegister("fhvdd", function(module, exports) {

let $b200a7a119c4bd46$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b200a7a119c4bd46$var$load("cmtly").then(()=>parcelRequire('giI7i'));

});


parcelRegister("66HfJ", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreProformaJiraFormBuilderRouteEntry", () => $58b256108db01248$export$46d6b55ebf21ccc);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $1y7ot = parcelRequire("1y7ot");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

const $58b256108db01248$var$LazyProjectSettingsProformaJiraFormBuilder = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("7R9RB")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-jira-form-builder/src/index.tsx"
});
const $58b256108db01248$var$ProformaJiraFormBuilder = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $58b256108db01248$var$LazyProjectSettingsProformaJiraFormBuilder,
        pageId: "project-settings-proforma-jira-form-builder",
        shouldShowSpinner: true
    });
const $58b256108db01248$export$46d6b55ebf21ccc = (0, $7NszV.createEntry)((0, $1y7ot.projectSettingsCoreProformaJiraFormBuilderRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $58b256108db01248$var$ProformaJiraFormBuilder,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $58b256108db01248$var$LazyProjectSettingsProformaJiraFormBuilder
        ],
        perfMetricKey: 'form-builder'
    }));

});
parcelRegister("1y7ot", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreProformaJiraFormBuilderRoute", () => $bffeb81c48a88921$export$4e7ce7e6ced0f291);
const $bffeb81c48a88921$export$4e7ce7e6ced0f291 = {
    name: 'project-settings-core-proforma-jira-form-builder',
    path: '/jira/core/projects/:projectKey/settings/forms/form/:templateFormId/edit',
    exact: true
};

});


parcelRegister("aDZxG", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreProformaProjectFormsRouteEntry", () => $76ec485f5ce6229b$export$5e9e27f116094fdf);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $dcOuP = parcelRequire("dcOuP");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

const $76ec485f5ce6229b$var$LazyProjectSettingsProformaProjectForms = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("cShK4")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-project-forms/src/index.tsx"
});
const $76ec485f5ce6229b$var$ProformaProjectForms = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $76ec485f5ce6229b$var$LazyProjectSettingsProformaProjectForms,
        pageId: "project-settings-proforma-project-forms",
        shouldShowSpinner: true
    });
const $76ec485f5ce6229b$export$5e9e27f116094fdf = (0, $7NszV.createEntry)((0, $dcOuP.projectSettingsCoreProformaProjectFormsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $76ec485f5ce6229b$var$ProformaProjectForms,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $76ec485f5ce6229b$var$LazyProjectSettingsProformaProjectForms
        ],
        perfMetricKey: 'forms-settings'
    }));

});
parcelRegister("dcOuP", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreProformaProjectFormsRoute", () => $ca16757f7d5a6f92$export$57fe8c5107a9c0de);
const $ca16757f7d5a6f92$export$57fe8c5107a9c0de = {
    name: 'project-settings-core-proforma-project-forms',
    path: '/jira/core/projects/:projectKey/settings/forms',
    exact: true
};

});


parcelRegister("lkwO5", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCustomerServiceFeaturesRouteEntry", () => $a15bf8b76e7abde8$export$e17f02db5d9c0485);

var $9MntO = parcelRequire("9MntO");

var $4R6GH = parcelRequire("4R6GH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6sNnq = parcelRequire("6sNnq");

var $5lsNZ = parcelRequire("5lsNZ");

var $6Z2mh = parcelRequire("6Z2mh");

var $cnvpg = parcelRequire("cnvpg");
const $a15bf8b76e7abde8$export$e17f02db5d9c0485 = (0, $7NszV.createEntry)((0, $9MntO.projectSettingsCustomerServiceFeaturesRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'jcs-project-settings.features',
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('berry-5039-jcs-features-page') ? (0, $cnvpg.projectSettingFeaturesAppPageEntryPoint) : undefined;
        },
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $6sNnq.featuresResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ],
        perfMetricKey: 'jcs-project-settings.features'
    }));

});
parcelRegister("9MntO", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCustomerServiceFeaturesRoute", () => $ad71d4ac3cd19ffa$export$5498201d2eacd40d);
const $ad71d4ac3cd19ffa$export$5498201d2eacd40d = {
    name: 'project-settings-customer-service-features',
    path: '/jira/servicedesk/projects/:projectKey/settings/features',
    exact: true
};

});

parcelRegister("cnvpg", function(module, exports) {

$parcel$export(module.exports, "projectSettingFeaturesAppPageEntryPoint", () => $6330397aa7ca9f96$export$f5b640657f5a50a3);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $c5TMF = parcelRequire("c5TMF");
const $6330397aa7ca9f96$export$f5b640657f5a50a3 = (0, $lkFvK.createPageEntryPoint)({
    main: $c5TMF.projectSettingFeaturesAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("c5TMF", function(module, exports) {

$parcel$export(module.exports, "projectSettingFeaturesAppEntryPoint", () => $60cea261eed7da95$export$83a2217e7eee641e);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $60cea261eed7da95$export$83a2217e7eee641e = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("kUYn8")), {
        moduleId: "92e8308d",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("kUYn8", function(module, exports) {

let $f3a7de42328eec2c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f3a7de42328eec2c$var$load("ly14Q").then(()=>parcelRequire('bMF5U'));

});




parcelRegister("7QAza", function(module, exports) {

$parcel$export(module.exports, "projectSettingsForgeAppsNextgenRouteEntry", () => $0239e22c8f9a631b$export$872a0285d27dfa47);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $kvHR2 = parcelRequire("kvHR2");

var $e7bC3 = parcelRequire("e7bC3");

var $dBDdA = parcelRequire("dBDdA");

var $1XdKx = parcelRequire("1XdKx");
const $0239e22c8f9a631b$export$872a0285d27dfa47 = (0, $7NszV.createEntry)((0, $kvHR2.projectSettingsForgeAppsNextgenRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $dBDdA.default),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)(),
            ...(0, $dBDdA.forgeProjectSettingsPageResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $dBDdA.LazyForgeProjectSettingsPage)
        ]
    }));

});
parcelRegister("kvHR2", function(module, exports) {

$parcel$export(module.exports, "projectSettingsForgeAppsNextgenRoute", () => $c8db0ba1a5916a92$export$8559c4a0b692890e);
const $c8db0ba1a5916a92$export$8559c4a0b692890e = {
    name: 'project-settings-software-apps-forge',
    path: '/jira/software/projects/:projectKey/settings/apps/:appId/:envId/:route?'
};

});

parcelRegister("dBDdA", function(module, exports) {

$parcel$export(module.exports, "LazyForgeProjectSettingsPage", () => $fa6a5556191902b5$export$ef66d3f49a9953d8);
$parcel$export(module.exports, "forgeProjectSettingsPageResources", () => $fa6a5556191902b5$export$33d85a1b2211b38);
$parcel$export(module.exports, "default", () => $fa6a5556191902b5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5bkvv = parcelRequire("5bkvv");

var $dxCvy = parcelRequire("dxCvy");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $fa6a5556191902b5$export$ef66d3f49a9953d8 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("bZbyt")), {
    moduleId: "./src/packages/spa-apps/forge/project-settings/src/index.tsx"
});
const $fa6a5556191902b5$export$33d85a1b2211b38 = ()=>[
        (0, $dxCvy.projectContextResourceWithCache),
        (0, $5bkvv.forgeProjectSettingsModuleResource)
    ];
const $fa6a5556191902b5$export$b943f48844c671a5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $fa6a5556191902b5$export$ef66d3f49a9953d8,
        pageId: "forge-spa-project-settings",
        shouldShowSpinner: true
    });
var $fa6a5556191902b5$export$2e2bcd8739ae039 = $fa6a5556191902b5$export$b943f48844c671a5;

});


parcelRegister("5MiVl", function(module, exports) {

$parcel$export(module.exports, "projectSettingsForgeAppsRouteEntry", () => $9bf506152004886d$export$54d0d8466c8b40dc);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $iSJL6 = parcelRequire("iSJL6");

var $e7bC3 = parcelRequire("e7bC3");

var $dBDdA = parcelRequire("dBDdA");
const $9bf506152004886d$export$54d0d8466c8b40dc = (0, $7NszV.createEntry)((0, $iSJL6.projectSettingsForgeAppsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $dBDdA.default),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $dBDdA.forgeProjectSettingsPageResources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $dBDdA.LazyForgeProjectSettingsPage)
        ]
    }));

});
parcelRegister("iSJL6", function(module, exports) {

$parcel$export(module.exports, "projectSettingsForgeAppsRoute", () => $dbb37015acdc19c0$export$f74a0b1be9d5b9f6);
const $dbb37015acdc19c0$export$f74a0b1be9d5b9f6 = {
    name: 'project-settings-software-forge-apps',
    path: '/jira/software/c/projects/:projectKey/settings/apps/:appId/:envId/:route?'
};

});


parcelRegister("ee5pi", function(module, exports) {

$parcel$export(module.exports, "projectSettingsOpsgenieRouteEntry", () => $d6930e98cb7e7363$export$4b4bfb4318f5a98e);

var $ffza4 = parcelRequire("ffza4");

var $bwLf9 = parcelRequire("bwLf9");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $5lsNZ = parcelRequire("5lsNZ");

var $a8P7Z = parcelRequire("a8P7Z");

var $kfztd = parcelRequire("kfztd");

var $e7bC3 = parcelRequire("e7bC3");

var $1KQBW = parcelRequire("1KQBW");

var $1XdKx = parcelRequire("1XdKx");
const $d6930e98cb7e7363$export$4b4bfb4318f5a98e = (0, $7NszV.createEntry)((0, $a8P7Z.projectSettingsOpsgenieRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $bwLf9.default)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $1KQBW.default)),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $1KQBW.LazyLinkOpsgeniePage)
        ],
        ufoName: 'project-settings.link-opsgenie'
    }));

});
parcelRegister("a8P7Z", function(module, exports) {

$parcel$export(module.exports, "projectSettingsOpsgenieRoute", () => $6ef9ba56e8ee2329$export$c7039de5a4b78802);
const $6ef9ba56e8ee2329$export$c7039de5a4b78802 = {
    name: 'project-settings-software-link-opsgenie',
    path: '/jira/software/projects/:projectKey/settings/opsgenie',
    exact: true
};

});


parcelRegister("hWZAC", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAccessRedirectRouteEntry", () => $fe3c44b562f5a007$export$7a0e75d9ac8038aa);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $kDaRO = parcelRequire("kDaRO");

var $6Z2mh = parcelRequire("6Z2mh");

var $p09kb = parcelRequire("p09kb");

var $01LdL = parcelRequire("01LdL");
const $fe3c44b562f5a007$export$7a0e75d9ac8038aa = (0, $7NszV.createEntry)((0, $kDaRO.projectSettingsServicedeskAccessRedirectRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $p09kb.peopleAccessRedirect)(`/jira/${(0, $01LdL.SERVICE_DESK_PRODUCT)}`),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $p09kb.LazyPeopleSettings)
        ]
    }));

});
parcelRegister("kDaRO", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAccessRedirectRoute", () => $8669efd5b368806c$export$115667ee60b1ec74);
const $8669efd5b368806c$export$115667ee60b1ec74 = {
    name: 'project-settings-servicedesk-access-redirect',
    path: '/jira/servicedesk/projects/:projectKey/settings/people',
    exact: true
};

});

parcelRegister("p09kb", function(module, exports) {

$parcel$export(module.exports, "LazyPeopleSettings", () => $3a1472a535e1ea00$export$7eee4f97b7a1273);
$parcel$export(module.exports, "peopleAccessRedirect", () => $3a1472a535e1ea00$export$45346ed2aa24e3f3);
$parcel$export(module.exports, "default", () => $3a1472a535e1ea00$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $7tQej = parcelRequire("7tQej");

const $3a1472a535e1ea00$export$7eee4f97b7a1273 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("8pwbR"))), {
    moduleId: "./src/packages/spa-apps/project-settings/people/src/index.tsx"
});
const $3a1472a535e1ea00$var$PeopleAccessRedirectInner = ({ match: match, basePath: basePath })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `${basePath}/projects/${String(match.params.projectKey)}/settings/access`,
        push: false
    });
const $3a1472a535e1ea00$export$45346ed2aa24e3f3 = (basePath)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3a1472a535e1ea00$var$PeopleAccessRedirectInner, {
            match: match,
            basePath: basePath
        });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3a1472a535e1ea00$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3a1472a535e1ea00$export$7eee4f97b7a1273,
        pageId: "project-settings-people",
        shouldShowSpinner: false
    });

});

parcelRegister("01LdL", function(module, exports) {

$parcel$export(module.exports, "SERVICE_DESK_PRODUCT", () => $a51e57eb3887507b$export$5575497f0592ee94);
$parcel$export(module.exports, "defaultRedirectForSettings", () => $a51e57eb3887507b$export$c9b0516439c55d7a);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
const $a51e57eb3887507b$export$5575497f0592ee94 = 'servicedesk';
const $a51e57eb3887507b$export$c9b0516439c55d7a = (product)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: `/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`
        });

});


parcelRegister("2kXpo", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAccessRouteEntry", () => $87f6949fc1184ba3$export$f7b56f6d0437146d);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $cAtSX = parcelRequire("cAtSX");

var $6Z2mh = parcelRequire("6Z2mh");

var $jaAyo = parcelRequire("jaAyo");

var $p09kb = parcelRequire("p09kb");
const $87f6949fc1184ba3$export$f7b56f6d0437146d = (0, $7NszV.createEntry)((0, $cAtSX.projectSettingsServicedeskAccessRoute), ()=>({
        group: 'project-settings-servicedesk',
        skeleton: (0, $jaAyo.ProjectSettingsAccessSkeleton),
        component: (0, $p09kb.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $p09kb.LazyPeopleSettings)
        ],
        ufoName: 'project-settings.access'
    }));

});

parcelRegister("fhlje", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAppsFieldsRouteEntry", () => $82144ad3cdad7a53$export$12f064da36fbd279);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $g49yz = parcelRequire("g49yz");

var $6Z2mh = parcelRequire("6Z2mh");

var $j9RuP = parcelRequire("j9RuP");
const $82144ad3cdad7a53$export$12f064da36fbd279 = (0, $7NszV.createEntry)((0, $g49yz.projectSettingsServicedeskAppsFieldsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $j9RuP.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $j9RuP.LazyConnectAppControlsSettings)
        ]
    }));

});
parcelRegister("j9RuP", function(module, exports) {

$parcel$export(module.exports, "LazyConnectAppControlsSettings", () => $3f52008d1cdfa258$export$246ec9cdadd2a163);
$parcel$export(module.exports, "ConnectAppsRedirect", () => $3f52008d1cdfa258$export$cc3414a2d9daf70d);
$parcel$export(module.exports, "default", () => $3f52008d1cdfa258$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $dAfqg = parcelRequire("dAfqg");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $7tQej = parcelRequire("7tQej");

var $hKH9R = parcelRequire("hKH9R");

const $3f52008d1cdfa258$export$246ec9cdadd2a163 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("1j8hG"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-app-controls/src/index.tsx"
});
const $3f52008d1cdfa258$var$ConnectAppsRedirectInner = ({ match: match, basePath: basePath })=>{
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const shouldRedirect = projectContext != null && projectContext.simplified && projectContext.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);
    return shouldRedirect ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `${basePath}/projects/${String(match.params.projectKey)}/settings/apps/app-fields`,
        push: false
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKH9R.default), null);
};
const $3f52008d1cdfa258$export$cc3414a2d9daf70d = (basePath)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3f52008d1cdfa258$var$ConnectAppsRedirectInner, {
            match: match,
            basePath: basePath
        });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3f52008d1cdfa258$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3f52008d1cdfa258$export$246ec9cdadd2a163,
        pageId: "project-settings-connect-app-controls",
        shouldShowSpinner: false
    });

});
parcelRegister("hKH9R", function(module, exports) {

$parcel$export(module.exports, "LazyAppDiscoverySettings", () => $d7e52a3e5f45b58f$export$fa3bc297af95f169);
$parcel$export(module.exports, "default", () => $d7e52a3e5f45b58f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $d7e52a3e5f45b58f$export$fa3bc297af95f169 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("3cuPS"))), {
    moduleId: "./src/packages/spa-apps/project-settings/app-discovery-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d7e52a3e5f45b58f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d7e52a3e5f45b58f$export$fa3bc297af95f169,
        pageId: "project-settings-app-discovery-settings",
        shouldShowSpinner: false
    });

});
parcelRegister("3cuPS", function(module, exports) {

let $254a696a14cd40fc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $254a696a14cd40fc$var$load("koyH0").then(()=>parcelRequire('jgXd4'));

});




parcelRegister("8to5X", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAppsRouteEntry", () => $0879ee567efffa41$export$d637c59982b0d896);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $fRJeY = parcelRequire("fRJeY");

var $6Z2mh = parcelRequire("6Z2mh");

var $cp0du = parcelRequire("cp0du");
const $0879ee567efffa41$export$d637c59982b0d896 = (0, $7NszV.createEntry)((0, $fRJeY.projectSettingsServicedeskAppsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $cp0du.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cp0du.LazyConnectAppsSettings)
        ]
    }));

});
parcelRegister("fRJeY", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAppsRoute", () => $d868c77dc879347a$export$ccc91c475c403d1a);
const $d868c77dc879347a$export$ccc91c475c403d1a = {
    name: 'project-settings-servicedesk-apps',
    path: '/jira/servicedesk/projects/:projectKey/settings/apps/:appId?',
    exact: true
};

});

parcelRegister("cp0du", function(module, exports) {

$parcel$export(module.exports, "LazyConnectAppsSettings", () => $841a04425f045e7e$export$3633e017e520a1c2);
$parcel$export(module.exports, "default", () => $841a04425f045e7e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $841a04425f045e7e$export$3633e017e520a1c2 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("flIAq"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-apps/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$841a04425f045e7e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $841a04425f045e7e$export$3633e017e520a1c2,
        pageId: "project-settings-connect-apps",
        shouldShowSpinner: false
    });

});


parcelRegister("9eiXm", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationCopyRuleRouteEntry", () => $051ebb61cb8e5385$export$1cfe280529d4ebf8);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $86FuT = parcelRequire("86FuT");

var $6Z2mh = parcelRequire("6Z2mh");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $9zLHs = parcelRequire("9zLHs");
const $051ebb61cb8e5385$export$1cfe280529d4ebf8 = (0, $7NszV.createEntry)((0, $86FuT.projectSettingsServicedeskAutomationCopyRuleRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        ufoName: 'service-management.automation.copy-rule',
        component: (0, $9zLHs.default),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $9zLHs.LazyProjectSettingsServiceDeskAutomationCopyRule)
        ]
    }));

});
parcelRegister("86FuT", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationCopyRuleRoute", () => $01244213b237aa9a$export$9aa8ef0c982cee2f);
const $01244213b237aa9a$export$9aa8ef0c982cee2f = {
    name: 'project-settings-servicedesk-automation-copy-rule',
    path: '/jira/servicedesk/projects/:projectKey/settings/automation/copy/:ruleId'
};

});

parcelRegister("9zLHs", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskAutomationCopyRule", () => $10ca54f4f21ea64a$export$4a3b5f6370555dbc);
$parcel$export(module.exports, "default", () => $10ca54f4f21ea64a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $10ca54f4f21ea64a$export$4a3b5f6370555dbc = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("1335S")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-copy-rule/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$10ca54f4f21ea64a$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $10ca54f4f21ea64a$export$4a3b5f6370555dbc,
        pageId: "project-settings-automation-copy-rule",
        shouldShowSpinner: true
    });

});
parcelRegister("1335S", function(module, exports) {

let $0c38789e27e47d14$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0c38789e27e47d14$var$load("107sG").then(()=>parcelRequire('9Qg7T'));

});



parcelRegister("D5QBq", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationCreateRouteEntry", () => $89415bba0f887370$export$f1e32463088d9246);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $ivLNh = parcelRequire("ivLNh");

var $6Z2mh = parcelRequire("6Z2mh");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $cNpXW = parcelRequire("cNpXW");
const $89415bba0f887370$export$f1e32463088d9246 = (0, $7NszV.createEntry)((0, $ivLNh.projectSettingsServicedeskAutomationCreateRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        ufoName: 'service-management.automation.create-rule',
        component: (0, $cNpXW.default),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cNpXW.LazyProjectSettingsServiceDeskAutomationCreateRule)
        ]
    }));

});
parcelRegister("ivLNh", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationCreateRoute", () => $50f5a58676cb66d1$export$6f20ce2991881c20);
const $50f5a58676cb66d1$export$6f20ce2991881c20 = {
    name: 'project-settings-servicedesk-automation-create',
    path: '/jira/servicedesk/projects/:projectKey/settings/automation/blueprint/:blueprintKey'
};

});

parcelRegister("cNpXW", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskAutomationCreateRule", () => $2a5fc816810cf307$export$5b197b51eb5ad982);
$parcel$export(module.exports, "default", () => $2a5fc816810cf307$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $2a5fc816810cf307$export$5b197b51eb5ad982 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("2zzKJ")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-create-rule/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2a5fc816810cf307$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2a5fc816810cf307$export$5b197b51eb5ad982,
        pageId: "project-settings-automation-create-rule",
        shouldShowSpinner: true
    });

});
parcelRegister("2zzKJ", function(module, exports) {

let $1dfa956995b4b83d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1dfa956995b4b83d$var$load("9F4Mz").then(()=>parcelRequire('7uVkM'));

});



parcelRegister("hRMW9", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationEditRuleRouteEntry", () => $e2d087af8b87ec7f$export$568d8653c06c756e);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $7qLRc = parcelRequire("7qLRc");

var $6Z2mh = parcelRequire("6Z2mh");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $2sKYo = parcelRequire("2sKYo");
const $e2d087af8b87ec7f$export$568d8653c06c756e = (0, $7NszV.createEntry)((0, $7qLRc.projectSettingsServicedeskAutomationEditRuleRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        ufoName: 'service-management.automation.edit-rule',
        component: (0, $2sKYo.default),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $2sKYo.LazyProjectSettingsServiceDeskAutomationEditRule)
        ]
    }));

});
parcelRegister("7qLRc", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationEditRuleRoute", () => $eafa82ab5994f857$export$9f1e5391e2d6f95);
const $eafa82ab5994f857$export$9f1e5391e2d6f95 = {
    name: 'project-settings-servicedesk-automation-edit-rule',
    path: '/jira/servicedesk/projects/:projectKey/settings/automation/ruleset/:ruleId'
};

});

parcelRegister("2sKYo", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskAutomationEditRule", () => $0645e13982e9c11f$export$c1c9a68738a9ab36);
$parcel$export(module.exports, "default", () => $0645e13982e9c11f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $0645e13982e9c11f$export$c1c9a68738a9ab36 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("k03nb")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-edit-rule/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0645e13982e9c11f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $0645e13982e9c11f$export$c1c9a68738a9ab36,
        pageId: "project-settings-automation-edit-rule",
        shouldShowSpinner: true
    });

});
parcelRegister("k03nb", function(module, exports) {

let $e8f66c8b4bac468d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e8f66c8b4bac468d$var$load("gYGtb").then(()=>parcelRequire('44UJy'));

});



parcelRegister("7B6VF", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationRouteEntry", () => $033d001835d92f56$export$7a0b8ca27efc7201);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $7HDop = parcelRequire("7HDop");

var $6Z2mh = parcelRequire("6Z2mh");

var $01Poo = parcelRequire("01Poo");

var $01LdL = parcelRequire("01LdL");
const $033d001835d92f56$export$7a0b8ca27efc7201 = (0, $7NszV.createEntry)((0, $7HDop.projectSettingsServicedeskAutomationRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: `project-settings-automation-${0, $01LdL.SERVICE_DESK_PRODUCT}`,
        component: (0, $01Poo.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $01Poo.LazyProjectSettingsJiraAutomation)
        ]
    }));

});
parcelRegister("01Poo", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsJiraAutomation", () => $f62e804ec9c6d7ed$export$dea5ad7e8eac12ae);
$parcel$export(module.exports, "default", () => $f62e804ec9c6d7ed$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $f62e804ec9c6d7ed$export$dea5ad7e8eac12ae = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("3Dp46")), {
    moduleId: "./src/packages/spa-apps/project-settings/jira-automation/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f62e804ec9c6d7ed$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f62e804ec9c6d7ed$export$dea5ad7e8eac12ae,
        pageId: "project-settings-jira-automation",
        shouldShowSpinner: true
    });

});


parcelRegister("5W0wg", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationSummaryRouteEntry", () => $54707b820bd59983$export$4d6e0242b09fef3b);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $jowOt = parcelRequire("jowOt");

var $6Z2mh = parcelRequire("6Z2mh");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $5G6Zw = parcelRequire("5G6Zw");
const $54707b820bd59983$export$4d6e0242b09fef3b = (0, $7NszV.createEntry)((0, $jowOt.projectSettingsServicedeskAutomationSummaryRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        ufoName: 'service-management.automation.summary',
        component: (0, $5G6Zw.default),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5G6Zw.LazyProjectSettingsServiceDeskAutomationSummary)
        ]
    }));

});
parcelRegister("jowOt", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationSummaryRoute", () => $634728c55a499ff5$export$165d82a2618e4d99);
const $634728c55a499ff5$export$165d82a2618e4d99 = {
    name: 'project-settings-servicedesk-automation-summary',
    path: '/jira/servicedesk/projects/:projectKey/settings/automation'
};

});

parcelRegister("5G6Zw", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskAutomationSummary", () => $8a03171b9122a104$export$2fc8c3fcbb365b89);
$parcel$export(module.exports, "default", () => $8a03171b9122a104$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $8a03171b9122a104$export$2fc8c3fcbb365b89 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("lHXN9")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-summary/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8a03171b9122a104$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8a03171b9122a104$export$2fc8c3fcbb365b89,
        pageId: "project-settings-automation-summary",
        shouldShowSpinner: true
    });

});
parcelRegister("lHXN9", function(module, exports) {

let $fcdbfe847ce1afc4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fcdbfe847ce1afc4$var$load("e3XdD").then(()=>parcelRequire('6kXBX'));

});



parcelRegister("4eKYR", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationViewLogRouteEntry", () => $6d458a597bcccee8$export$ddc45b708634b66);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $edDQg = parcelRequire("edDQg");

var $6Z2mh = parcelRequire("6Z2mh");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $i7FI3 = parcelRequire("i7FI3");
const $6d458a597bcccee8$export$ddc45b708634b66 = (0, $7NszV.createEntry)((0, $edDQg.projectSettingsServicedeskAutomationViewLogRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        ufoName: 'service-management.automation.log',
        component: (0, $i7FI3.default),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $i7FI3.LazyProjectSettingsServiceDeskAutomationViewLog)
        ]
    }));

});
parcelRegister("edDQg", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationViewLogRoute", () => $3068172667b89342$export$ea3acd3ad4eb7d38);
const $3068172667b89342$export$ea3acd3ad4eb7d38 = {
    name: 'project-settings-servicedesk-automation-view-log',
    path: '/jira/servicedesk/projects/:projectKey/settings/automation/log/:ruleId'
};

});

parcelRegister("i7FI3", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskAutomationViewLog", () => $6f8757b068912193$export$db6c5cdbc65b2b4a);
$parcel$export(module.exports, "default", () => $6f8757b068912193$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $6f8757b068912193$export$db6c5cdbc65b2b4a = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("6TZ72")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-view-log/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6f8757b068912193$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $6f8757b068912193$export$db6c5cdbc65b2b4a,
        pageId: "project-settings-automation-view-log",
        shouldShowSpinner: true
    });

});
parcelRegister("6TZ72", function(module, exports) {

let $506748cc098237ca$var$load = (parcelRequire("28QjX"))(4);
module.exports = $506748cc098237ca$var$load("1vnBX").then(()=>parcelRequire('5jbPW'));

});



parcelRegister("1aB8Z", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChangeManagementRouteEntry", () => $518452e4098d607c$export$a8eaf3cca1d5d936);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $gmE3I = parcelRequire("gmE3I");

var $2pT4g = parcelRequire("2pT4g");

var $fpjJX = parcelRequire("fpjJX");

var $cAofY = parcelRequire("cAofY");

var $6sNnq = parcelRequire("6sNnq");

var $aBfqj = parcelRequire("aBfqj");

var $6Z2mh = parcelRequire("6Z2mh");

var $ejiWA = parcelRequire("ejiWA");

var $eHnlx = parcelRequire("eHnlx");
const $518452e4098d607c$export$a8eaf3cca1d5d936 = (0, $7NszV.createEntry)((0, $aBfqj.projectSettingsServicedeskChangeManagementRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.change-management-settings',
        component: (0, $eHnlx.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $cAofY.serviceDeskContextResource),
            (0, $ejiWA.changeManagementSettingsProjectConfigurationResource),
            (0, $gmE3I.jsmChangeManagementSettingsGitLabGatingResource),
            (0, $6sNnq.featuresResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $2pT4g.jsmRepackagingBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $eHnlx.LazyProjectSettingsServiceDeskChangeManagement)
        ]
    }));

});
parcelRegister("gmE3I", function(module, exports) {

$parcel$export(module.exports, "jsmChangeManagementSettingsGitLabGatingResource", () => $ff8ead4f49d1e745$export$315b6278d34861b4);
$parcel$export(module.exports, "useGitLabGatingResource", () => $ff8ead4f49d1e745$export$dd3715dce02ee460);

var $5uXOq = parcelRequire("5uXOq");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

const $ff8ead4f49d1e745$var$getDataLoader = ()=>(parcelRequire("doiMC"));
const $ff8ead4f49d1e745$export$315b6278d34861b4 = (0, $2M1hQ.createResource)({
    type: 'JSM_CHANGE_MANAGEMENT_SETTINGS_GITLAB_GATING_RESOURCE',
    getKey: ()=>'JSM_CHANGE_MANAGEMENT_SETTINGS_GITLAB_GATING_RESOURCE',
    getDataLoader: $ff8ead4f49d1e745$var$getDataLoader,
    maxAge: false ? 0 : Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});
const $ff8ead4f49d1e745$export$dd3715dce02ee460 = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)($ff8ead4f49d1e745$export$315b6278d34861b4);
    (0, $5uXOq.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        error,
        refresh
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            data: data?.data,
            pending: loading,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: data?.error || error
        }), [
        data,
        loading,
        error
    ]);
};

});
parcelRegister("doiMC", function(module, exports) {

let $9bfc163791b99137$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9bfc163791b99137$var$load("5O1mG").then(()=>parcelRequire('4y3Yq'));

});


parcelRegister("ejiWA", function(module, exports) {

$parcel$export(module.exports, "changeManagementSettingsProjectConfigurationResource", () => $53ebb72294d46a1c$export$2413ba18ec38282d);
// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router

var $2M1hQ = parcelRequire("2M1hQ");
const $53ebb72294d46a1c$export$c0636b6062501e0b = 'CHANGE_MANAGEMENT_SETTINGS_PROJECT_CONFIG';

const $53ebb72294d46a1c$var$getDataLoader = ()=>(parcelRequire("kcL6g"));
const $53ebb72294d46a1c$var$getKey = ({ match: match })=>typeof match.params.projectKey === 'string' ? match.params.projectKey : '';
const $53ebb72294d46a1c$export$2413ba18ec38282d = (0, $2M1hQ.createResource)({
    type: $53ebb72294d46a1c$export$c0636b6062501e0b,
    getKey: $53ebb72294d46a1c$var$getKey,
    getDataLoader: $53ebb72294d46a1c$var$getDataLoader,
    maxAge: Infinity
});

});
parcelRegister("kcL6g", function(module, exports) {

let $eb5976b3f3b83ea1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eb5976b3f3b83ea1$var$load("cI1fz").then(()=>parcelRequire('k9qTQ'));

});


parcelRegister("eHnlx", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskChangeManagement", () => $8fbb06494113daae$export$e674d93688e620b3);
$parcel$export(module.exports, "default", () => $8fbb06494113daae$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $8fbb06494113daae$export$e674d93688e620b3 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("72Bld"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-change-management-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8fbb06494113daae$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8fbb06494113daae$export$e674d93688e620b3,
        pageId: "project-settings-change-management",
        shouldShowSpinner: true
    });

});
parcelRegister("72Bld", function(module, exports) {

let $5205af8025952c50$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5205af8025952c50$var$load("fBBnQ").then(()=>parcelRequire('eh7Vf'));

});



parcelRegister("a2PeW", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsChatRouteEntry", () => $7d42d939b28a59ca$export$aa27d235fc2eedf6);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $9wUes = parcelRequire("9wUes");

var $6Z2mh = parcelRequire("6Z2mh");

var $6ybDD = parcelRequire("6ybDD");

var $5qwUl = parcelRequire("5qwUl");
const $7d42d939b28a59ca$export$aa27d235fc2eedf6 = (0, $7NszV.createEntry)((0, $9wUes.projectSettingsServicedeskChannelsChatRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $6ybDD.serviceDeskChatNextGenRedirect),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5qwUl.LazyProjectSettingsServiceDeskChatSettings)
        ]
    }));

});
parcelRegister("6ybDD", function(module, exports) {

$parcel$export(module.exports, "serviceDeskChatNextGenRedirect", () => $7c240e4106c097e5$export$22c86ddb04b1359a);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
const $7c240e4106c097e5$export$22c86ddb04b1359a = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/chat`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: url
    });
};

});

parcelRegister("5qwUl", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskChatSettings", () => $955f7623ed5daf83$export$971347f9ac02f862);
$parcel$export(module.exports, "default", () => $955f7623ed5daf83$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $955f7623ed5daf83$export$971347f9ac02f862 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("6sGNP")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-chat-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$955f7623ed5daf83$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $955f7623ed5daf83$export$971347f9ac02f862,
        pageId: "project-settings-widget-settings",
        shouldShowSpinner: true
    });

});
parcelRegister("6sGNP", function(module, exports) {

let $4b468f56fb4ec068$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4b468f56fb4ec068$var$load("8FOl8").then(()=>parcelRequire('k9vj7'));

});



parcelRegister("gsEXA", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsEmailNextGenRouteEntry", () => $61a4779d190eed13$export$b4590bec09451e4c);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $hOElL = parcelRequire("hOElL");

var $6Z2mh = parcelRequire("6Z2mh");

var $vzOOJ = parcelRequire("vzOOJ");

var $3VKX1 = parcelRequire("3VKX1");
const $61a4779d190eed13$export$b4590bec09451e4c = (0, $7NszV.createEntry)((0, $hOElL.projectSettingsServicedeskChannelsEmailNextGenRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $vzOOJ.serviceDeskEmailNextGenRedirect),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3VKX1.LazyProjectSettingsServiceDeskEmail)
        ]
    }));

});
parcelRegister("hOElL", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsEmailNextGenRoute", () => $a6fdffc3a6348da0$export$89c7bf2bac1464c2);
const $a6fdffc3a6348da0$export$89c7bf2bac1464c2 = {
    name: 'project-settings-servicedesk-channels-email-next-gen',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/email',
    exact: true
};

});

parcelRegister("vzOOJ", function(module, exports) {

$parcel$export(module.exports, "serviceDeskEmailNextGenRedirect", () => $f10a7d047f1802a3$export$86c8da903fb97c4f);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
const $f10a7d047f1802a3$export$86c8da903fb97c4f = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/email`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: url
    });
};

});

parcelRegister("3VKX1", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskEmail", () => $881ebeec1a2867ea$export$66d0c668045080de);
$parcel$export(module.exports, "default", () => $881ebeec1a2867ea$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kKHTt = parcelRequire("kKHTt");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $881ebeec1a2867ea$export$66d0c668045080de = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("dmwiF")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-email/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$881ebeec1a2867ea$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kKHTt.HelpCenterSettingsRedirect), {
        page: "email"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $881ebeec1a2867ea$export$66d0c668045080de,
        pageId: "project-settings-email",
        shouldShowSpinner: true
    }));

});
parcelRegister("kKHTt", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsRedirect", () => $ebd0dfae741c0d7b$export$a24ec33acfeae48d);

var $k9rcv = parcelRequire("k9rcv");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ds5qV = parcelRequire("ds5qV");

var $lODMY = parcelRequire("lODMY");

var $dAfqg = parcelRequire("dAfqg");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $fY39E = parcelRequire("fY39E");

var $koeKL = parcelRequire("koeKL");

var $7XYc4 = parcelRequire("7XYc4");

var $ahChO = parcelRequire("ahChO");

var $4R6GH = parcelRequire("4R6GH");

var $2vSU6 = parcelRequire("2vSU6");

var $aTz47 = parcelRequire("aTz47");

var $jEJ7g = parcelRequire("jEJ7g");

var $8WSu7 = parcelRequire("8WSu7");

var $jagxb = parcelRequire("jagxb");
const $ebd0dfae741c0d7b$export$c224e724e933fbea = (page, pathname)=>{
    if (page === 'customer-notifications') {
        const customerNotificationsPage = pathname.split('/settings/customer-notifications')[1];
        if (customerNotificationsPage === '/template') return 'customer-notifications-template';
        if (customerNotificationsPage === '/account-notification/invite-customer') return 'customer-notifications-invite-customer';
        if (/rule\/\d+/.test(customerNotificationsPage)) return 'customer-notifications-rule';
    }
    return page;
};
const $ebd0dfae741c0d7b$export$2d1034e371a567c6 = (page, pathname, helpCenterId)=>{
    switch(page){
        case 'kb':
            return (0, $8WSu7.getSettingsPath)(pathname.replace('/confluence-kb', '/kb'), true, helpCenterId);
        default:
            return (0, $8WSu7.getSettingsPath)(pathname, true, helpCenterId);
    }
};
const $ebd0dfae741c0d7b$var$useLocation = (0, $lODMY.createRouterSelector)((state)=>state.location);
const $ebd0dfae741c0d7b$export$b90b599f4b180ba = ({ page: page, children: children })=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const useLocationOld = (0, $lODMY.createRouterSelector)((state)=>state.location);
    // eslint-disable-next-line react-hooks/react-compiler
    const location = useLocationOld();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const isJCS = (0, $jEJ7g.useIsJCSProjectType)(projectContext?.projectType);
    (0, $5uXOq.useEffect)(()=>{
        if (isJCS && !(0, $aTz47.isHelpCenterSettingsPath)()) {
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectSettingsToHelpCenterSettings redirected', {
                page: $ebd0dfae741c0d7b$export$c224e724e933fbea(page, location.pathname)
            });
            showFlag({
                messageId: 'servicedesk-customer-service-common.ui.help-center-settings-redirect.show-flag.error',
                messageType: 'transactional',
                type: 'error',
                title: formatMessage((0, $jagxb.default).errorTitle),
                description: formatMessage((0, $4R6GH.fg)('jcs_project_type_m3') ? (0, $jagxb.default).description : (0, $jagxb.default).errorDescription),
                isAutoDismiss: true
            });
        }
    }, [
        createAnalyticsEvent,
        formatMessage,
        isJCS,
        location.pathname,
        page,
        showFlag
    ]);
    if (isJCS && !(0, $aTz47.isHelpCenterSettingsPath)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: "/jira/helpcenter"
    });
    return children;
};
const $ebd0dfae741c0d7b$export$4e0587d8c8738b4d = ({ page: page, children: children })=>{
    const location = $ebd0dfae741c0d7b$var$useLocation();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const isJCS = projectContext?.projectType === (0, $2vSU6.CUSTOMER_SERVICE_PROJECT);
    (0, $5uXOq.useEffect)(()=>{
        if (isJCS && !(0, $aTz47.isHelpCenterSettingsPath)()) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectSettingsToHelpCenterSettings redirected', {
            page: $ebd0dfae741c0d7b$export$c224e724e933fbea(page, location.pathname)
        });
    }, [
        createAnalyticsEvent,
        isJCS,
        location.pathname,
        page
    ]);
    if (isJCS && !(0, $aTz47.isHelpCenterSettingsPath)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ebd0dfae741c0d7b$export$b65700afa6ae3ae9, {
        page: page,
        pathname: location.pathname,
        projectId: projectContext.projectId
    });
    return children;
};
const $ebd0dfae741c0d7b$export$b65700afa6ae3ae9 = ({ page: page, pathname: pathname, projectId: projectId })=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const activationId = (0, $fY39E.useActivationId)();
    const cloudId = (0, $koeKL.useCloudId)();
    const jiraProjectAri = `ari:cloud:jira:${cloudId}:project/${projectId}`;
    const jiraWorkspaceAri = `ari:cloud:jira:${cloudId}:workspace/${activationId}`;
    const { helpCenter: { helpCenterByHoistedProjectIdRouted: helpCenter } } = (0, $8Uumt.useLazyLoadQuery)((0, $k9rcv.default), {
        cloudId: cloudId,
        jiraProjectAri: jiraProjectAri,
        jiraWorkspaceAri: jiraWorkspaceAri
    });
    if (helpCenter.__typename !== 'HelpCenter') {
        showFlag({
            messageId: 'servicedesk-customer-service-common.ui.help-center-settings-redirect.show-flag.error.1',
            messageType: 'transactional',
            type: 'error',
            title: formatMessage((0, $jagxb.default).errorTitle),
            description: formatMessage((0, $jagxb.default).errorDescription),
            isAutoDismiss: true
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
            to: "/jira/helpcenter"
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: $ebd0dfae741c0d7b$export$2d1034e371a567c6(page, pathname, (0, $ahChO.HelpHelpCenterAri).parse(helpCenter.id).helpCenterId),
        persistSearchParams: true
    });
};
const $ebd0dfae741c0d7b$export$a24ec33acfeae48d = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jcs_project_type_m3'), $ebd0dfae741c0d7b$export$4e0587d8c8738b4d, $ebd0dfae741c0d7b$export$b90b599f4b180ba);

});
parcelRegister("k9rcv", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3d97065ff4628c3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5a71e1d1b1dbf7cb82e4e714dfd62b93>>
 * @relayHash e13196a4072c1e05f1d5cb92fe604cee
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d94a9943ce2554eb8cf7db62a3d014b0ef4ffb159df3aec135c71cb712c22610
const $e3d97065ff4628c3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jiraProjectAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jiraWorkspaceAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "projectAri",
            "variableName": "jiraProjectAri"
        },
        {
            "kind": "Variable",
            "name": "workspaceAri",
            "variableName": "jiraWorkspaceAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "kind": "ScalarField",
            "name": "id"
        }
    ], v5 = {
        "kind": "InlineFragment",
        "selections": v4 /*: any*/ ,
        "type": "HelpCenter"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "helpCenterSettingsRedirectQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "HelpCenterQueryApi",
                        "kind": "LinkedField",
                        "name": "helpCenter",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "helpCenterByHoistedProjectIdRouted",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                },
                                "action": "THROW",
                                "path": "helpCenter.helpCenterByHoistedProjectIdRouted"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "helpCenter"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "helpCenterSettingsRedirectQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterByHoistedProjectIdRouted",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": v4 /*: any*/ ,
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d94a9943ce2554eb8cf7db62a3d014b0ef4ffb159df3aec135c71cb712c22610",
            "metadata": {},
            "name": "helpCenterSettingsRedirectQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e3d97065ff4628c3$var$node.hash = "87969f8d9448b730bb329d59f60087f6";
var $e3d97065ff4628c3$export$2e2bcd8739ae039 = $e3d97065ff4628c3$var$node;

});

parcelRegister("ahChO", function(module, exports) {

$parcel$export(module.exports, "HelpHelpCenterAri", () => $77c930c30f742077$export$a75f3c98d930b258);

var $2DmWN = parcelRequire("2DmWN");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/help/help-center/manifest.ts
var $77c930c30f742077$var$helpHelpCenterAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $2DmWN.HelpHelpCenterAriResourceOwner),
    resourceType: (0, $2DmWN.HelpHelpCenterAriResourceType),
    resourceIdSlug: "{activationId}/{helpCenterId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        helpCenterId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/help/help-center/index.ts
var $77c930c30f742077$export$a75f3c98d930b258 = class _HelpHelpCenterAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._activationId = opts.resourceIdSegmentValues.activationId, this._helpCenterId = opts.resourceIdSegmentValues.helpCenterId;
    }
    get activationId() {
        return this._activationId;
    }
    get helpCenterId() {
        return this._helpCenterId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $77c930c30f742077$var$helpHelpCenterAriStaticOpts.qualifier,
            platformQualifier: $77c930c30f742077$var$helpHelpCenterAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $77c930c30f742077$var$helpHelpCenterAriStaticOpts.resourceOwner,
            resourceType: $77c930c30f742077$var$helpHelpCenterAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}/${opts.helpCenterId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                helpCenterId: opts.helpCenterId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $77c930c30f742077$var$helpHelpCenterAriStaticOpts);
        return new _HelpHelpCenterAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $77c930c30f742077$var$helpHelpCenterAriStaticOpts);
        return new _HelpHelpCenterAri(opts);
    }
    getVariables() {
        return {
            activationId: this.activationId,
            helpCenterId: this.helpCenterId
        };
    }
};

});
parcelRegister("2DmWN", function(module, exports) {

$parcel$export(module.exports, "HelpHelpCenterAriResourceOwner", () => $1eb1062b37145e8a$export$a4af98a27b4568ee);
$parcel$export(module.exports, "HelpHelpCenterAriResourceType", () => $1eb1062b37145e8a$export$f6271ed6947e9084);
// src/help/help-center/types.ts
var $1eb1062b37145e8a$export$a4af98a27b4568ee = "help", $1eb1062b37145e8a$export$f6271ed6947e9084 = "help-center";

});


parcelRegister("aTz47", function(module, exports) {

$parcel$export(module.exports, "isHelpCenterSettingsPath", () => $1e0d45f36b27f85a$export$bf8b98b87d485657);
$parcel$export(module.exports, "getHelpCenterUUIDFromPath", () => $1e0d45f36b27f85a$export$73a9fbfd9155f593);

var $gKZoD = parcelRequire("gKZoD");

var $4R6GH = parcelRequire("4R6GH");
const $1e0d45f36b27f85a$export$bf8b98b87d485657 = ()=>{
    (0, $gKZoD.di)(window);
    if (!(0, $4R6GH.fg)('jcs_master_flag')) return false;
    if (!false) return window.location.pathname.includes('jira/helpcenter/');
    return false;
};
const $1e0d45f36b27f85a$export$73a9fbfd9155f593 = ()=>{
    (0, $gKZoD.di)(window);
    if (!$1e0d45f36b27f85a$export$bf8b98b87d485657()) return '';
    if (!false) return window.location.pathname.match(/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}/)?.[0];
    return '';
};

});

parcelRegister("jEJ7g", function(module, exports) {

$parcel$export(module.exports, "useAsyncIsJCS", () => $db67bf04078e8532$export$3894a8f24b665478);
$parcel$export(module.exports, "isJCSProjectType", () => $db67bf04078e8532$export$25e1541dd4631818);
$parcel$export(module.exports, "useIsJCSProjectType", () => $db67bf04078e8532$export$b78b0f34fdacd97a);
$parcel$export(module.exports, "isJCSTemplate", () => $db67bf04078e8532$export$afee907b7a66ef2b);

var $e5wyW = parcelRequire("e5wyW");

var $4R6GH = parcelRequire("4R6GH");

var $O4MMs = parcelRequire("O4MMs");

var $2vSU6 = parcelRequire("2vSU6");
const $db67bf04078e8532$var$useIsJCSProjectTypeFallback = (projectType, isAsync)=>{
    const isJCS = $db67bf04078e8532$export$3894a8f24b665478();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return isAsync ? isJCS : Boolean(isJCS);
};
const $db67bf04078e8532$export$25e1541dd4631818 = (projectType)=>projectType === (0, $2vSU6.CUSTOMER_SERVICE_PROJECT) && (0, $4R6GH.fg)('jcs_project_type_m3');
const $db67bf04078e8532$export$4b74a6f22da4a0d2 = (projectType)=>projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) || $db67bf04078e8532$export$25e1541dd4631818(projectType);
const $db67bf04078e8532$export$b78b0f34fdacd97a = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('jcs_project_type_m3'), $db67bf04078e8532$export$25e1541dd4631818, $db67bf04078e8532$var$useIsJCSProjectTypeFallback);
//
//  M2 helpers, deprecated
// ---------------------
const $db67bf04078e8532$var$useIsJCSUnderFF = ()=>{
    const { 'initial.project.template.name': initialProjectTemplate } = (0, $O4MMs.useProjectProperties)([
        'initial.project.template.name'
    ]);
    return initialProjectTemplate === 'com.atlassian.jcs:customer-service-management';
};
const $db67bf04078e8532$export$927b5354181b3adf = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('jcs_master_flag'), $db67bf04078e8532$var$useIsJCSUnderFF, ()=>false);
// Undefined can be used to check if project properties has been resolved or not
const $db67bf04078e8532$var$useAsyncIsJCSUnderFF = ()=>{
    const { 'initial.project.template.name': initialProjectTemplate } = (0, $O4MMs.useProjectProperties)([
        'initial.project.template.name'
    ]);
    return initialProjectTemplate ? initialProjectTemplate === 'com.atlassian.jcs:customer-service-management' : undefined;
};
const $db67bf04078e8532$export$3894a8f24b665478 = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('jcs_master_flag'), $db67bf04078e8532$var$useAsyncIsJCSUnderFF, ()=>false);
const $db67bf04078e8532$var$isJCSTemplateUnderFF = (template)=>template === 'com.atlassian.jcs:customer-service-management';
const $db67bf04078e8532$var$isJCSTemplateFallback = (template)=>false;
const $db67bf04078e8532$export$afee907b7a66ef2b = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('jcs_master_flag'), $db67bf04078e8532$var$isJCSTemplateUnderFF, $db67bf04078e8532$var$isJCSTemplateFallback);

});
parcelRegister("O4MMs", function(module, exports) {

$parcel$export(module.exports, "useProjectProperties", () => $eccdf8f1b49d4032$export$58be98885c2d686a);

var $5uXOq = parcelRequire("5uXOq");

var $74ySO = parcelRequire("74ySO");

var $ajpes = parcelRequire("ajpes");

var $4f8Oj = parcelRequire("4f8Oj");

var $lpwtK = parcelRequire("lpwtK");

var $1XJ20 = parcelRequire("1XJ20");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $dYZ0w = parcelRequire("dYZ0w");
const $eccdf8f1b49d4032$export$d4c72bab9d6cc13a = {};
const $eccdf8f1b49d4032$var$Store = (0, $iXqE5.createStore)({
    name: 'project-properties',
    initialState: $eccdf8f1b49d4032$export$d4c72bab9d6cc13a,
    actions: $dYZ0w.actions
});
const $eccdf8f1b49d4032$export$eebf791068e870dd = (0, $3sQ5x.createHook)($eccdf8f1b49d4032$var$Store);
const $eccdf8f1b49d4032$export$58be98885c2d686a = (propertyKeys, projectIdOverride)=>{
    const { data: data } = (0, $lpwtK.useProject)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const projectId = projectIdOverride !== undefined ? projectIdOverride : data?.id && `${data.id}`;
    const [state, { get: get }] = $eccdf8f1b49d4032$export$eebf791068e870dd();
    const prevPropertyKeys = (0, $1XJ20.usePrevious)(propertyKeys);
    (0, $5uXOq.useEffect)(()=>{
        if (projectId === undefined) (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jiraProjectPropertiesServices undefinedProjectId');
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(propertyKeys, prevPropertyKeys) && !projectIdOverride) return;
        if (projectId) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        get(projectId, propertyKeys);
    }, [
        projectId,
        propertyKeys,
        prevPropertyKeys,
        get,
        createAnalyticsEvent,
        projectIdOverride
    ]);
    return projectId !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($4f8Oj)))(state[projectId], (_, key)=>(0, (/*@__PURE__*/$parcel$interopDefault($74ySO)))(propertyKeys, key)) : {};
};

});
parcelRegister("74ySO", function(module, exports) {

var $2wwA6 = parcelRequire("2wwA6");

var $hTJwX = parcelRequire("hTJwX");

var $agVdz = parcelRequire("agVdz");

var $kPZpS = parcelRequire("kPZpS");

var $dMEgP = parcelRequire("dMEgP");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5263f72d78aeaf9c$var$nativeMax = Math.max;
/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */ function $5263f72d78aeaf9c$var$includes(collection, value, fromIndex, guard) {
    collection = $hTJwX(collection) ? collection : $dMEgP(collection);
    fromIndex = fromIndex && !guard ? $kPZpS(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) fromIndex = $5263f72d78aeaf9c$var$nativeMax(length + fromIndex, 0);
    return $agVdz(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && $2wwA6(collection, value, fromIndex) > -1;
}
module.exports = $5263f72d78aeaf9c$var$includes;

});
parcelRegister("agVdz", function(module, exports) {

var $beQoo = parcelRequire("beQoo");

var $8LQ84 = parcelRequire("8LQ84");

var $fC1Kz = parcelRequire("fC1Kz");
/** `Object#toString` result references. */ var $77a7c84c5ee0b808$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $77a7c84c5ee0b808$var$isString(value) {
    return typeof value == 'string' || !$8LQ84(value) && $fC1Kz(value) && $beQoo(value) == $77a7c84c5ee0b808$var$stringTag;
}
module.exports = $77a7c84c5ee0b808$var$isString;

});


parcelRegister("dYZ0w", function(module, exports) {

$parcel$export(module.exports, "actions", () => $d36e01b4b5883936$export$e324594224ef24da);

var $9Tr6m = parcelRequire("9Tr6m");
const $d36e01b4b5883936$export$e324594224ef24da = {
    get: $9Tr6m.get
};

});
parcelRegister("9Tr6m", function(module, exports) {

$parcel$export(module.exports, "get", () => $52dc90cc0afc52f4$export$3988ae62b71be9a3);

var $k8IPx = parcelRequire("k8IPx");

var $cjFoH = parcelRequire("cjFoH");

var $66FNL = parcelRequire("66FNL");

var $fUPWG = parcelRequire("fUPWG");
const $52dc90cc0afc52f4$export$3988ae62b71be9a3 = (projectId, properties)=>({ getState: getState, setState: setState })=>{
        const currentProperties = getState()[projectId] || {};
        const missingProperties = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(properties, (0, (/*@__PURE__*/$parcel$interopDefault($66FNL)))(currentProperties));
        missingProperties.length && (0, $fUPWG.default)({
            projectId: projectId,
            properties: missingProperties
        }).then((fetchedProperties)=>{
            const latestProperties = getState()[projectId] || {};
            setState({
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [projectId]: {
                    ...latestProperties,
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    ...missingProperties.reduce((result, name)=>{
                        const reducedResult = result;
                        const fetchedProperty = fetchedProperties[name];
                        // `undefined` inside state means that property was never requested.
                        // If value returned for the property is `undefined`, we will set it to `null`,
                        // to differentiate it from the unrequested state. Otherwise, returned value will be set.
                        reducedResult[name] = (0, (/*@__PURE__*/$parcel$interopDefault($cjFoH)))(fetchedProperty) ? null : fetchedProperty;
                        return reducedResult;
                    }, {})
                }
            });
        });
    };

});
parcelRegister("fUPWG", function(module, exports) {

$parcel$export(module.exports, "default", () => $573d8b462e0e2ec6$export$2e2bcd8739ae039);

var $1sYcL = parcelRequire("1sYcL");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$573d8b462e0e2ec6$export$2e2bcd8739ae039 = async ({ projectId: projectId, properties: properties })=>{
    const { project: project } = await (0, $1sYcL.get)({
        projectId: projectId,
        projectProperties: properties,
        consumerMeta: {
            id: 'remoteGet',
            packageName: 'jiraProjectPropertiesServices',
            teamName: 'jsd-shield'
        }
    });
    return project;
};

});





parcelRegister("8WSu7", function(module, exports) {

$parcel$export(module.exports, "getSettingsPath", () => $b4b4e7a1fd793539$export$67417cd3aaee582d);
const $b4b4e7a1fd793539$export$67417cd3aaee582d = (path, isJCS, helpCenterId)=>{
    if (!helpCenterId) return isJCS ? path.replace('/jira/servicedesk/', '/jira/helpcenter/') : path;
    return path.replace('/jira/servicedesk/', '/jira/helpcenter/').replace('/settings', `/settings/${helpCenterId}`);
};

});

parcelRegister("jagxb", function(module, exports) {

$parcel$export(module.exports, "default", () => $a36eb1fdbec95bf4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a36eb1fdbec95bf4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "servicedesk-customer-service-common.help-center-settings-redirect.error-title",
        "defaultMessage": "This page has been moved"
    },
    errorDescription: {
        "id": "servicedesk-customer-service-common.help-center-settings-redirect.error-description",
        "defaultMessage": "You can find the page you\u2019re looking for in a service hub."
    },
    description: {
        "id": "servicedesk-customer-service-common.help-center-settings-redirect.description",
        "defaultMessage": "You can find the page you\u2019re looking for in a customer hub."
    }
});

});


parcelRegister("dmwiF", function(module, exports) {

let $9ba66294ef3d2e3a$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9ba66294ef3d2e3a$var$load("ffQaD"),
    $9ba66294ef3d2e3a$var$load("kvRbA"),
    $9ba66294ef3d2e3a$var$load("e6ONP")
]).then(()=>parcelRequire('gu2ky'));

});



parcelRegister("cONlw", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsPermissionsNextGenRouteEntry", () => $4964340980955d47$export$65a2b00cdeff4516);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $fpjJX = parcelRequire("fpjJX");

var $10cgn = parcelRequire("10cgn");

var $8pE1n = parcelRequire("8pE1n");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $tQ1zW = parcelRequire("tQ1zW");

var $aZDos = parcelRequire("aZDos");
const $4964340980955d47$export$65a2b00cdeff4516 = (0, $7NszV.createEntry)((0, $8pE1n.projectSettingsServicedeskChannelsPermissionsNextGenRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $tQ1zW.customerPermissionsRedirect),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $dxCvy.projectContextResource),
            (0, $10cgn.customerPermissionsPageDataResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aZDos.LazyProjectSettingsServiceDeskCustomerPermissions)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).CUSTOMER_PERMISSIONS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).CUSTOMER_PERMISSIONS),
                teamName: 'jsd-flux-capacitors'
            }
        },
        perfMetricKey: 'jsm-customer-permissions'
    }));

});
parcelRegister("10cgn", function(module, exports) {

$parcel$export(module.exports, "customerPermissionsPageDataResource", () => $35508436fc3abfb3$export$ae3446385906310c);

var $2M1hQ = parcelRequire("2M1hQ");


const $35508436fc3abfb3$export$ae3446385906310c = (0, $2M1hQ.createResource)({
    type: (0, $9cf87aec7862b8b9$export$34a89f9aaa677bb5),
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: ()=>(parcelRequire("hzRiC")),
    maxAge: Infinity
});

});
const $9cf87aec7862b8b9$export$34a89f9aaa677bb5 = 'CUSTOMER_PERMISSIONS';

parcelRegister("hzRiC", function(module, exports) {

let $ccbf0cb0b6a46451$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ccbf0cb0b6a46451$var$load("heNxp").then(()=>parcelRequire('i9zBn'));

});


parcelRegister("tQ1zW", function(module, exports) {

$parcel$export(module.exports, "customerPermissionsRedirect", () => $467404e10c7e501f$export$59eedcca37dbbafd);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
const $467404e10c7e501f$export$59eedcca37dbbafd = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/customer-permissions`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: url
    });
};

});

parcelRegister("aZDos", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskCustomerPermissions", () => $8d9798e9d24a9632$export$5367e40a24f0bd54);
$parcel$export(module.exports, "default", () => $8d9798e9d24a9632$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $8d9798e9d24a9632$export$5367e40a24f0bd54 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("be2DK"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-customer-permissions/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8d9798e9d24a9632$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8d9798e9d24a9632$export$5367e40a24f0bd54,
        pageId: "project-settings-customer-permissions",
        shouldShowSpinner: true
    });

});
parcelRegister("be2DK", function(module, exports) {

let $82c30cc87147dc95$var$load = (parcelRequire("28QjX"))(4);
module.exports = $82c30cc87147dc95$var$load("iAFWW").then(()=>parcelRequire('3eQYY'));

});



parcelRegister("627LR", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsPortalRouteEntry", () => $631bf1a02812ef78$export$7b7294b50c70e50c);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $fpjJX = parcelRequire("fpjJX");

var $8CwPO = parcelRequire("8CwPO");

var $cfj3a = parcelRequire("cfj3a");

var $6Z2mh = parcelRequire("6Z2mh");

var $c0aPe = parcelRequire("c0aPe");
const $631bf1a02812ef78$export$7b7294b50c70e50c = (0, $7NszV.createEntry)((0, $cfj3a.projectSettingsServicedeskChannelsPortalRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $c0aPe.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $dxCvy.projectContextResource),
            (0, $8CwPO.portalSettingsContextResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $c0aPe.LazyProjectSettingsServiceDeskPortalSettings)
        ]
    }));

});
parcelRegister("8CwPO", function(module, exports) {

$parcel$export(module.exports, "portalSettingsContextResource", () => $9dfc351c3ebf85b6$export$4a3e29f235f3320c);

var $2M1hQ = parcelRequire("2M1hQ");
const $9dfc351c3ebf85b6$var$RESOURCE_TYPE_PORTAL_SETTINGS_CONTEXT = 'PORTAL_SETTINGS_CONTEXT';

const $9dfc351c3ebf85b6$export$4a3e29f235f3320c = (0, $2M1hQ.createResource)({
    type: $9dfc351c3ebf85b6$var$RESOURCE_TYPE_PORTAL_SETTINGS_CONTEXT,
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("90J7n"))
});

});
parcelRegister("90J7n", function(module, exports) {

let $68f71ca28af557ef$var$load = (parcelRequire("28QjX"))(4);
module.exports = $68f71ca28af557ef$var$load("kpoiF").then(()=>parcelRequire('7wy1U'));

});


parcelRegister("c0aPe", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskPortalSettings", () => $9da321ff59a70829$export$fdbd4b1e5ae0e422);
$parcel$export(module.exports, "default", () => $9da321ff59a70829$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $9da321ff59a70829$export$fdbd4b1e5ae0e422 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("c9Bia")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-portal-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9da321ff59a70829$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $9da321ff59a70829$export$fdbd4b1e5ae0e422,
        pageId: "project-settings-portal-settings",
        shouldShowSpinner: true
    });

});
parcelRegister("c9Bia", function(module, exports) {

let $8d9340b8ccdabff9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8d9340b8ccdabff9$var$load("iBebQ").then(()=>parcelRequire('jQFbr'));

});



parcelRegister("amBHA", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsRouteEntry", () => $e62176a0302c26c4$export$2d20001d3350adbc);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $2a84P = parcelRequire("2a84P");

var $6Z2mh = parcelRequire("6Z2mh");

var $3egqP = parcelRequire("3egqP");
const $e62176a0302c26c4$export$2d20001d3350adbc = (0, $7NszV.createEntry)((0, $2a84P.projectSettingsServicedeskChannelsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $3egqP.channelsRedirect)('customer-permissions'),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("2a84P", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsRoute", () => $a400bd3af4bd9318$export$36e4210554830c2f);
const $a400bd3af4bd9318$export$36e4210554830c2f = {
    name: 'project-settings-servicedesk-channels',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels',
    exact: true
};

});

parcelRegister("3egqP", function(module, exports) {

$parcel$export(module.exports, "channelsRedirect", () => $73d598aaa606ce09$export$c7e6c0ac0abe2336);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $02Psx = parcelRequire("02Psx");

var $7tQej = parcelRequire("7tQej");
const $73d598aaa606ce09$export$c7e6c0ac0abe2336 = (pageUrlFragment)=>({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        const url = `${(0, $02Psx.getNextgenSettingsUrl)((0, $2vSU6.SERVICE_DESK_PROJECT), String(projectKey))}/channels/${pageUrlFragment}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: url,
            push: false
        });
    };

});
parcelRegister("02Psx", function(module, exports) {

$parcel$export(module.exports, "getNextgenSettingsUrl", () => $a59737cd16881573$export$26432406821aa7bf);
$parcel$export(module.exports, "getNextgenSettingsIssueTypesUrl", () => $a59737cd16881573$export$defee92e506aa306);
$parcel$export(module.exports, "getNextgenSettingsWorkflowUrl", () => $a59737cd16881573$export$9133e09a98a043dc);
$parcel$export(module.exports, "getNextgenSettingsJSDAutomationUrl", () => $a59737cd16881573$export$b0d20d18e0230e83);
$parcel$export(module.exports, "getClassicJSWSettingsUrl", () => $a59737cd16881573$export$ff0a17aa36a000df);
$parcel$export(module.exports, "getProjectSettingsDetailsUrl", () => $a59737cd16881573$export$16d52b9357bb73ab);
$parcel$export(module.exports, "getClassicIssueLayoutSettingsUrl", () => $a59737cd16881573$export$d531a9788343348f);
$parcel$export(module.exports, "getClassicRequestTypeLayoutSettingsUrl", () => $a59737cd16881573$export$dad567762dae162e);

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $2X0eJ = parcelRequire("2X0eJ");

var $3XO6n = parcelRequire("3XO6n");

var $gl0PU = parcelRequire("gl0PU");

var $1RLjE = parcelRequire("1RLjE");
const $a59737cd16881573$export$26432406821aa7bf = (projectType, projectKey)=>{
    const products = {
        [(0, $2vSU6.CORE_PROJECT)]: 'core',
        [(0, $2vSU6.SERVICE_DESK_PROJECT)]: 'servicedesk',
        [(0, $2vSU6.CUSTOMER_SERVICE_PROJECT)]: (0, $4R6GH.fg)('jcs_project_type_m3') ? 'servicedesk' : 'customerservice',
        [(0, $2vSU6.SOFTWARE_PROJECT)]: 'software',
        [(0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)]: 'polaris'
    };
    const product = products[projectType];
    if (!product) {
        (0, $1RLjE.logError)((0, $3XO6n.PACKAGE_NAME), (0, $gl0PU.toErrorId)('urls'), (0, $gl0PU.toErrorMessage)(`Can't build default project settings url for project type: ${projectType}`), new Error(`Unexpected project type: ${projectType}`));
        // let's return classic url in that case
        return `/projects/${projectKey}/settings`;
    }
    if (projectType === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)) return `/jira/${product}/projects/${projectKey}/ideas/settings`;
    return `/jira/${product}/projects/${projectKey}/settings`;
};
const $a59737cd16881573$export$defee92e506aa306 = (projectType, projectKey, issueTypeId, backLink)=>{
    if (projectType === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)) return `${$a59737cd16881573$export$26432406821aa7bf(projectType, projectKey)}`;
    return `${$a59737cd16881573$export$26432406821aa7bf(projectType, projectKey)}/issuetypes${issueTypeId ? `/${issueTypeId}` : ''}${(0, $2X0eJ.serializeBackLink)(backLink)}`;
};
const $a59737cd16881573$export$9133e09a98a043dc = (projectType, projectKey, issueTypeId)=>{
    if (projectType === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)) return `${$a59737cd16881573$export$26432406821aa7bf(projectType, projectKey)}/workflow`;
    return `${$a59737cd16881573$export$26432406821aa7bf(projectType, projectKey)}/issuetypes/${issueTypeId}/workflow`;
};
const $a59737cd16881573$export$b0d20d18e0230e83 = (projectKey)=>`${$a59737cd16881573$export$26432406821aa7bf((0, $2vSU6.SERVICE_DESK_PROJECT), projectKey)}/automation`;
const $a59737cd16881573$export$ff0a17aa36a000df = (projectKey)=>`/jira/software/c/projects/${projectKey}/settings`;
const $a59737cd16881573$export$16d52b9357bb73ab = (projectType, projectKey, isSimplified)=>{
    const urlBase = projectType === (0, $2vSU6.SOFTWARE_PROJECT) && !isSimplified ? $a59737cd16881573$export$ff0a17aa36a000df(projectKey) : $a59737cd16881573$export$26432406821aa7bf(projectType, projectKey);
    return `${urlBase}/details`;
};
const $a59737cd16881573$export$d531a9788343348f = ({ projectKey: projectKey, viewScreenId: viewScreenId, backLink: backLink })=>`/plugins/servlet/project-config/${projectKey}/issuelayout?screenId=${viewScreenId}${(0, $2X0eJ.serializeBackLink)(backLink)}`;
const $a59737cd16881573$export$dad567762dae162e = ({ projectKey: projectKey, requestTypeId: requestTypeId, backLink: backLink })=>`/jira/servicedesk/projects/${projectKey}/settings/request-types/request-type/${requestTypeId}${(0, $2X0eJ.serializeBackLink)(backLink)}`;

});
parcelRegister("2X0eJ", function(module, exports) {

$parcel$export(module.exports, "serializeBackLink", () => $b75ea0cca9bceab1$export$abebef1e474c32c5);
$parcel$export(module.exports, "getHrefWithBackLink", () => $b75ea0cca9bceab1$export$6d7b0d2d046b7fdd);
/**
 * When users complete task in SWIFT settings page, a UI flag shows and says "Go back to X"
 * This object configures the URL and _translated_ link text of the UI flag.
 *
 * If this backlink is not configured then SWIFT uses some default text ("Go to project") or similar.
 * Each project type has its own defaults: configured in Product features
 *
 * See https://hello.atlassian.net/wiki/spaces/JPCE/pages/700125807/SWIFT+backlinks
 */ const $b75ea0cca9bceab1$export$abebef1e474c32c5 = (backLink)=>{
    if (backLink == null) return '';
    const { url: url, title: title } = backLink;
    return `#backLinkUrl=${encodeURIComponent(url)}&backLinkTitle=${encodeURIComponent(title)}`;
};
const $b75ea0cca9bceab1$export$6d7b0d2d046b7fdd = (href, title)=>{
    if (!href || !href.length) return null;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { pathname: pathname, search: search } = window.location;
    const backlinkData = {
        // url and title are not using encodeURIComponent here because it will be serialized later.
        url: `${pathname}${search}`,
        title: title
    };
    const backlink = $b75ea0cca9bceab1$export$abebef1e474c32c5(backlinkData);
    return `${href}${backlink}`;
};

});

parcelRegister("3XO6n", function(module, exports) {

$parcel$export(module.exports, "TASK", () => $594ec5369f29a734$export$9355e489ad16f98e);
$parcel$export(module.exports, "BUG", () => $594ec5369f29a734$export$bcf558c186108044);
$parcel$export(module.exports, "STORY", () => $594ec5369f29a734$export$1ea39a3ae330045);
$parcel$export(module.exports, "EPIC", () => $594ec5369f29a734$export$3cb4a99a332e4186);
$parcel$export(module.exports, "SUB_TASK", () => $594ec5369f29a734$export$a06f889861f6537d);
$parcel$export(module.exports, "CUSTOM", () => $594ec5369f29a734$export$952581bc40160893);
$parcel$export(module.exports, "TEMPLATES_WHITELIST", () => $594ec5369f29a734$export$dff1da4a9bab6d3e);
$parcel$export(module.exports, "TEXT_AREA_CF_TYPE", () => $594ec5369f29a734$export$39cd48613b53ce2f);
$parcel$export(module.exports, "DESCRIPTION_FIELD_TYPE", () => $594ec5369f29a734$export$56eae1056efd4899);
$parcel$export(module.exports, "ENVIRONMENT_FIELD_TYPE", () => $594ec5369f29a734$export$ca61f05d869b2ea3);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_NAME", () => $594ec5369f29a734$export$2ec42920a0df6b9a);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_ANALYTIC_TYPE", () => $594ec5369f29a734$export$40c10ba35ceb5c6b);
$parcel$export(module.exports, "JIRA_SERVICE_MANAGEMENT_APP_NAME", () => $594ec5369f29a734$export$a11dccbf88784c62);
$parcel$export(module.exports, "JIRA_PRODUCT_DISCOVERY_APP_NAME", () => $594ec5369f29a734$export$f35dc2e6deb1692e);
$parcel$export(module.exports, "JIRA_CUSTOMER_SERVICE_APP_NAME", () => $594ec5369f29a734$export$b36025abb367eace);
$parcel$export(module.exports, "JIRA_APP_NAME", () => $594ec5369f29a734$export$ec5d0e43836cb3c7);
$parcel$export(module.exports, "toPackageName", () => $594ec5369f29a734$export$f31a652635bd75fe);
$parcel$export(module.exports, "PACKAGE_NAME", () => $594ec5369f29a734$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "NEW_FIELD_OPTION_PREFIX", () => $594ec5369f29a734$export$a2231d79966e0ccc);
$parcel$export(module.exports, "RADIO_FIELD_TYPE", () => $594ec5369f29a734$export$28a4bdf7d9b6f9);
$parcel$export(module.exports, "USERPICKER_FIELD_TYPE", () => $594ec5369f29a734$export$9d758b3e8c6e0ed1);
$parcel$export(module.exports, "MULTIUSERPICKER_FIELD_TYPE", () => $594ec5369f29a734$export$b0e37d421e006913);
$parcel$export(module.exports, "SELECT_FIELD_TYPE", () => $594ec5369f29a734$export$d77765147749db6b);
$parcel$export(module.exports, "CASCADINGSELECT_FIELD_TYPE", () => $594ec5369f29a734$export$42ef68d6bd555a8d);
$parcel$export(module.exports, "MULTISELECT_FIELD_TYPE", () => $594ec5369f29a734$export$4db6eb15b3c529cf);
$parcel$export(module.exports, "CHECKBOX_FIELD_TYPE", () => $594ec5369f29a734$export$ee975373b7797e8a);
$parcel$export(module.exports, "TEXT_FIELD_TYPE", () => $594ec5369f29a734$export$aa99342cc6a8ced5);
$parcel$export(module.exports, "NUMBER_FIELD_TYPE", () => $594ec5369f29a734$export$6f327bf99e20320);
$parcel$export(module.exports, "DATETIME_FIELD_TYPE", () => $594ec5369f29a734$export$dc64bdfdf9660a05);
$parcel$export(module.exports, "PROJECTPICKER_FIELD_TYPE", () => $594ec5369f29a734$export$e6d73ed745b9a04);
$parcel$export(module.exports, "DATE_FIELD_TYPE", () => $594ec5369f29a734$export$d8b50f59220c7580);
$parcel$export(module.exports, "ASSETSPICKER_FIELD_TYPE", () => $594ec5369f29a734$export$3a6f0a44478f1d2);
$parcel$export(module.exports, "LABELPICKER_FIELD_TYPE", () => $594ec5369f29a734$export$68b76ef93df5a880);
$parcel$export(module.exports, "GROUPPICKER_FIELD_TYPE", () => $594ec5369f29a734$export$e7773fccbeec45e6);
$parcel$export(module.exports, "MULTIGROUPPICKER_FIELD_TYPE", () => $594ec5369f29a734$export$b45487b145c52a37);
$parcel$export(module.exports, "VERSION_FIELD_TYPE", () => $594ec5369f29a734$export$48548129a6d117f5);
$parcel$export(module.exports, "MULTIVERSION_FIELD_TYPE", () => $594ec5369f29a734$export$722c271a9e11cb94);
$parcel$export(module.exports, "TEXTAREA_FIELD_TYPE", () => $594ec5369f29a734$export$33dbe2a903610aa1);
$parcel$export(module.exports, "emptyTenantContext", () => $594ec5369f29a734$export$ac655f5b3ff7b929);
// Issue Type Templates

var $lzeFL = parcelRequire("lzeFL");

var $5fc53 = parcelRequire("5fc53");

var $ldyPw = parcelRequire("ldyPw");

var $g5X3G = parcelRequire("g5X3G");

var $ef5Xn = parcelRequire("ef5Xn");

var $7qPn9 = parcelRequire("7qPn9");

var $5fc53 = parcelRequire("5fc53");
const $594ec5369f29a734$export$9355e489ad16f98e = 'task';
const $594ec5369f29a734$export$bcf558c186108044 = 'bug';
const $594ec5369f29a734$export$1ea39a3ae330045 = 'story';
const $594ec5369f29a734$export$3cb4a99a332e4186 = 'epic';
const $594ec5369f29a734$export$a06f889861f6537d = 'subtask';
const $594ec5369f29a734$export$952581bc40160893 = 'custom';
const $594ec5369f29a734$export$dff1da4a9bab6d3e = [
    $594ec5369f29a734$export$9355e489ad16f98e,
    $594ec5369f29a734$export$bcf558c186108044,
    $594ec5369f29a734$export$1ea39a3ae330045,
    $594ec5369f29a734$export$3cb4a99a332e4186
];
const $594ec5369f29a734$export$39cd48613b53ce2f = (0, $5fc53.TEXT_AREA_CF_TYPE);
const $594ec5369f29a734$export$56eae1056efd4899 = (0, $5fc53.DESCRIPTION_TYPE);
const $594ec5369f29a734$export$ca61f05d869b2ea3 = (0, $5fc53.ENVIRONMENT_TYPE);
const $594ec5369f29a734$export$2ec42920a0df6b9a = 'Story point estimate';
const $594ec5369f29a734$export$40c10ba35ceb5c6b = 'storyPointEstimate';
const $594ec5369f29a734$export$a4d3702d4c7481d6 = 44;
const $594ec5369f29a734$export$8a6a961f6caf7a8b = [
    $594ec5369f29a734$export$56eae1056efd4899,
    $594ec5369f29a734$export$39cd48613b53ce2f,
    $594ec5369f29a734$export$ca61f05d869b2ea3
];
const $594ec5369f29a734$export$e27914436cc13e3c = 'Jira Software';
const $594ec5369f29a734$export$a11dccbf88784c62 = 'Jira Service Management';
const $594ec5369f29a734$export$9f4aa232cbb6be46 = 'Jira Work Management';
const $594ec5369f29a734$export$b3c4739240716eb6 = 'Jira Ops';
const $594ec5369f29a734$export$f35dc2e6deb1692e = 'Jira Product Discovery';
const $594ec5369f29a734$export$b36025abb367eace = 'Jira Customer Service';
const $594ec5369f29a734$export$ec5d0e43836cb3c7 = 'Jira';
const $594ec5369f29a734$export$f31a652635bd75fe = (packageName)=>packageName;
const $594ec5369f29a734$export$b8b9d90f9e5bd72b = $594ec5369f29a734$export$f31a652635bd75fe('jiraProjectSettingsAppsCommon');
const $594ec5369f29a734$export$a2231d79966e0ccc = 'NEW_';
const $594ec5369f29a734$export$13dc44d2a9a248a4 = 'swift_openAddIssueTypeModal';
const $594ec5369f29a734$export$28a4bdf7d9b6f9 = 'radio';
const $594ec5369f29a734$export$9d758b3e8c6e0ed1 = 'userpicker';
const $594ec5369f29a734$export$b0e37d421e006913 = 'multiuserpicker';
const $594ec5369f29a734$export$d77765147749db6b = 'select';
const $594ec5369f29a734$export$42ef68d6bd555a8d = 'cascadingselect';
const $594ec5369f29a734$export$4db6eb15b3c529cf = 'multiselect';
const $594ec5369f29a734$export$ee975373b7797e8a = 'checkbox';
const $594ec5369f29a734$export$aa99342cc6a8ced5 = 'text';
const $594ec5369f29a734$export$6f327bf99e20320 = 'number';
const $594ec5369f29a734$export$dc64bdfdf9660a05 = 'datetime';
const $594ec5369f29a734$export$e6d73ed745b9a04 = 'projectpicker';
const $594ec5369f29a734$export$d8b50f59220c7580 = 'date';
const $594ec5369f29a734$export$3a6f0a44478f1d2 = 'assetspicker';
const $594ec5369f29a734$export$68b76ef93df5a880 = 'labelpicker';
const $594ec5369f29a734$export$e7773fccbeec45e6 = 'grouppicker';
const $594ec5369f29a734$export$b45487b145c52a37 = 'multigrouppicker';
const $594ec5369f29a734$export$48548129a6d117f5 = 'version';
const $594ec5369f29a734$export$722c271a9e11cb94 = 'multiversion';
const $594ec5369f29a734$export$33dbe2a903610aa1 = 'textarea';
const $594ec5369f29a734$export$ac655f5b3ff7b929 = ()=>({
        appEditions: (0, $ldyPw.populateApplicationEditions)(),
        appPermissions: (0, $7qPn9.populateApplicationPermissions)(),
        applicationKey: null,
        areProductSuggestionsEnabled: false,
        appUpdatesAvailable: null,
        atlassianAccountId: null,
        baseUrl: (0, $g5X3G.toBaseUrl)(''),
        cloudId: (0, $g5X3G.toCloudId)(''),
        activationId: (0, $g5X3G.toActivationId)(''),
        cloudName: (0, $g5X3G.toCloudName)(''),
        devopsProjectSignupSource: (0, $g5X3G.toDevopsProjectSignupSource)(''),
        environment: null,
        fabricActivityUrl: null,
        fabricNotificationLogUrl: null,
        fabricPfDirUrl: null,
        firstActivationDateMs: null,
        isAdmin: false,
        isAnonymous: false,
        isDevMode: false,
        isDevopsProjectCreationScenario: false,
        isMarketingOptOut: false,
        isSiteAdmin: false,
        languageTag: null,
        licenseStates: (0, $ef5Xn.populateApplicationLicenseStates)(),
        licensedProducts: {},
        locale: (0, $lzeFL.defaultLocale),
        loggedInUser: null,
        productCrossSellConfig: 'unknown',
        productEntitlementDetails: null,
        productPermissionGated: {
            core: false,
            software: false,
            serviceDesk: false,
            productDiscovery: false,
            customerService: false
        },
        siteAdminStatus: 'unknown',
        userFullname: null,
        xsrfToken: null,
        hasDlpEnabled: false,
        avpWorkspaceId: null,
        cmdbDisabledInFedRAMP: null
    });

});
parcelRegister("5fc53", function(module, exports) {

$parcel$export(module.exports, "ISSUE_LINK_SEARCH", () => $81f079589240b9b7$export$b144116dae474c88);
$parcel$export(module.exports, "ISSUE_FIELD_NUMBER_CF_TYPE", () => $81f079589240b9b7$export$bc917bc699b25f75);
$parcel$export(module.exports, "ISSUE_FIELD_STRING_CF_TYPE", () => $81f079589240b9b7$export$5f26ca419fdffbe7);
$parcel$export(module.exports, "ISSUE_FIELD_DATETIME_CF_TYPE", () => $81f079589240b9b7$export$ce9bfd823c7e1a6d);
$parcel$export(module.exports, "ISSUE_FIELD_DATE_CF_TYPE", () => $81f079589240b9b7$export$346b72b1f7cd6d5a);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_SELECT_CF_TYPE", () => $81f079589240b9b7$export$b20fbcacd7942c2a);
$parcel$export(module.exports, "ISSUE_FIELD_ANY_CF_TYPE", () => $81f079589240b9b7$export$a2e8554bffc61ece);
$parcel$export(module.exports, "ISSUE_FIELD_MULTI_SELECT_CF_TYPE", () => $81f079589240b9b7$export$f25cd4907cbb25b9);
$parcel$export(module.exports, "ISSUE_FIELD_USER_CF_TYPE", () => $81f079589240b9b7$export$5600354b43577e17);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_GROUP_CF_TYPE", () => $81f079589240b9b7$export$5dbc9917f72d0d2a);
$parcel$export(module.exports, "ISSUE_FIELD_OBJECT_CF_TYPE", () => $81f079589240b9b7$export$253649f07fb55948);
$parcel$export(module.exports, "ISSUE_FIELD_GROUPS_CF_TYPE", () => $81f079589240b9b7$export$eb39592ba5247ee7);
$parcel$export(module.exports, "ISSUE_FIELD_STRINGS_CF_TYPE", () => $81f079589240b9b7$export$f48a9be226105736);
$parcel$export(module.exports, "ISSUE_FIELD_VERSION_CF_TYPE", () => $81f079589240b9b7$export$42e2e93fc721df5d);
$parcel$export(module.exports, "APPROVALS_PANEL_TYPE", () => $81f079589240b9b7$export$7773375e72c953ed);
$parcel$export(module.exports, "ISSUE_FIELD_PROJECT_CF_TYPE", () => $81f079589240b9b7$export$80ad0037098f3919);
$parcel$export(module.exports, "AFFECTED_SERVICES_GQL_FIELD", () => $81f079589240b9b7$export$6875c7efa3a5e380);
$parcel$export(module.exports, "ASSIGNEE_GQL_FIELD", () => $81f079589240b9b7$export$7c1a5c7d37b8f968);
$parcel$export(module.exports, "ATLASSIAN_TEAM_GQL_FIELD", () => $81f079589240b9b7$export$c5931a5d7dbfb40b);
$parcel$export(module.exports, "BOOLEAN_GQL_FIELD", () => $81f079589240b9b7$export$c979d9c548c05133);
$parcel$export(module.exports, "CASCADING_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$ff25e7412c4ae9c7);
$parcel$export(module.exports, "CHECKBOX_GQL_FIELD", () => $81f079589240b9b7$export$16dbdf57e34e8d63);
$parcel$export(module.exports, "CHILDREN_EXCEEDING_LIMIT_GQL_FIELD", () => $81f079589240b9b7$export$1bf8bec92e6e84df);
$parcel$export(module.exports, "CHILDREN_WITHIN_LIMIT_GQL_FIELD", () => $81f079589240b9b7$export$c32f5d822fe5ea95);
$parcel$export(module.exports, "CMDB_GQL_FIELD", () => $81f079589240b9b7$export$b0deb225eed90fbd);
$parcel$export(module.exports, "COLOR_GQL_FIELD", () => $81f079589240b9b7$export$add3775cfea8fde3);
$parcel$export(module.exports, "COMPONENTS_GQL_FIELD", () => $81f079589240b9b7$export$9631d4098abab3eb);
$parcel$export(module.exports, "CONNECT_DATE_TIME_GQL_FIELD", () => $81f079589240b9b7$export$ee42bc16c09ee564);
$parcel$export(module.exports, "CONNECT_NUMBER_GQL_FIELD", () => $81f079589240b9b7$export$fbcebbdce821f712);
$parcel$export(module.exports, "CONNECT_MULTI_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$41dd2eb1f33d3042);
$parcel$export(module.exports, "CONNECT_RICH_TEXT_GQL_FIELD", () => $81f079589240b9b7$export$f4e3e72a3be84e5b);
$parcel$export(module.exports, "CONNECT_SINGLE_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$d6738c8a6d1a735d);
$parcel$export(module.exports, "CONNECT_TEXT_GQL_FIELD", () => $81f079589240b9b7$export$79a75502a3f0c4c4);
$parcel$export(module.exports, "DATE_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$ed2eabcf0931df31);
$parcel$export(module.exports, "DATE_TIME_GQL_FIELD", () => $81f079589240b9b7$export$1f17904e959f2f0b);
$parcel$export(module.exports, "EPIC_LINK_GQL_FIELD", () => $81f079589240b9b7$export$6d8da4497234455);
$parcel$export(module.exports, "FLAG_GQL_FIELD", () => $81f079589240b9b7$export$9bcfac568e4fa59c);
$parcel$export(module.exports, "ISSUE_RESTRICTION_GQL_FIELD", () => $81f079589240b9b7$export$dd84cd6c957c6f5e);
$parcel$export(module.exports, "ISSUE_TYPE_GQL_FIELD", () => $81f079589240b9b7$export$5cc7c39d7d1cf6d5);
$parcel$export(module.exports, "LABEL_GQL_FIELD", () => $81f079589240b9b7$export$810709f0c5c2e9db);
$parcel$export(module.exports, "MULTI_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$82cb6735134c23a2);
$parcel$export(module.exports, "MULTI_USER_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$85e04e9a3a81ee1);
$parcel$export(module.exports, "MULTI_VERSION_GQL_FIELD", () => $81f079589240b9b7$export$24c916a8a33ed20c);
$parcel$export(module.exports, "MULTI_GROUP_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$c049920d930c3b8a);
$parcel$export(module.exports, "NUMBER_GQL_FIELD", () => $81f079589240b9b7$export$3b6d7fc1833bf7da);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE_GQL_FIELD", () => $81f079589240b9b7$export$bd3e2fe853319c13);
$parcel$export(module.exports, "PARENT_GQL_FIELD", () => $81f079589240b9b7$export$6dfd3fc78bc751a0);
$parcel$export(module.exports, "PEOPLE_GQL_FIELD", () => $81f079589240b9b7$export$31aea7548807c6b5);
$parcel$export(module.exports, "PRIORITY_GQL_FIELD", () => $81f079589240b9b7$export$e89fbbf3983c0219);
$parcel$export(module.exports, "PROFORMA_FORMS_GQL_FIELD", () => $81f079589240b9b7$export$f5e2fb1022ff7912);
$parcel$export(module.exports, "PROJECT_GQL_FIELD", () => $81f079589240b9b7$export$12f54499c6252188);
$parcel$export(module.exports, "RADIO_GQL_FIELD", () => $81f079589240b9b7$export$8e4293d806f435e0);
$parcel$export(module.exports, "REPORTER_GQL_FIELD", () => $81f079589240b9b7$export$c69486dd643dfb69);
$parcel$export(module.exports, "RESOLUTION_GQL_FIELD", () => $81f079589240b9b7$export$1e4faa0d6dc58a81);
$parcel$export(module.exports, "RICH_TEXT_GQL_FIELD", () => $81f079589240b9b7$export$37f4daaa7b409554);
$parcel$export(module.exports, "SECURITY_GQL_FIELD", () => $81f079589240b9b7$export$ca57cccd6d7bf97c);
$parcel$export(module.exports, "SINGLE_GROUP_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$bea889616fd5bdab);
$parcel$export(module.exports, "SINGLE_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$ab5cecc580898d1c);
$parcel$export(module.exports, "SPRINT_GQL_FIELD", () => $81f079589240b9b7$export$bb63813d13e8eaf7);
$parcel$export(module.exports, "STATUS_GQL_FIELD", () => $81f079589240b9b7$export$e40f819979b3881d);
$parcel$export(module.exports, "TEAM_GQL_FIELD", () => $81f079589240b9b7$export$6c243704a22baffe);
$parcel$export(module.exports, "TEAM_VIEW_GQL_FIELD", () => $81f079589240b9b7$export$6c32429bac235203);
$parcel$export(module.exports, "TEXT_GQL_FIELD", () => $81f079589240b9b7$export$61b514b470cbbf07);
$parcel$export(module.exports, "TIME_TRACKING_GQL_FIELD", () => $81f079589240b9b7$export$e4bcb1729da5683);
$parcel$export(module.exports, "URL_GQL_FIELD", () => $81f079589240b9b7$export$37ccd11f08a93ccb);
$parcel$export(module.exports, "USER_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$abf1bf8c1106ba7d);
$parcel$export(module.exports, "VERSION_GQL_FIELD", () => $81f079589240b9b7$export$b55604041ae7179e);
$parcel$export(module.exports, "VOTES_GQL_FIELD", () => $81f079589240b9b7$export$c8bf66d62e74cdd2);
$parcel$export(module.exports, "WATCHES_GQL_FIELD", () => $81f079589240b9b7$export$aa815aaa741ae18);
$parcel$export(module.exports, "JSM_ASSETS_GQL_FIELD", () => $81f079589240b9b7$export$e805f89b15d2abf4);
$parcel$export(module.exports, "JSM_PEOPLE_GQL_FIELD", () => $81f079589240b9b7$export$5bfd36acd96f04c2);
$parcel$export(module.exports, "JSM_ORGANIZATION_GQL_FIELD", () => $81f079589240b9b7$export$695423a2bc8a9ac4);
$parcel$export(module.exports, "FORGE_STRING_GQL_FIELD", () => $81f079589240b9b7$export$d29b0ba0d80bc129);
$parcel$export(module.exports, "FORGE_STRINGS_GQL_FIELD", () => $81f079589240b9b7$export$ac6c7b30703608d6);
$parcel$export(module.exports, "FORGE_NUMBER_GQL_FIELD", () => $81f079589240b9b7$export$478b546dccd33e1e);
$parcel$export(module.exports, "FORGE_DATETIME_GQL_FIELD", () => $81f079589240b9b7$export$f90c042e9eb983e7);
$parcel$export(module.exports, "FORGE_DATE_GQL_FIELD", () => $81f079589240b9b7$export$753ca4fb34ff3f2b);
$parcel$export(module.exports, "FORGE_OBJECT_GQL_FIELD", () => $81f079589240b9b7$export$b7aed9efb4a9154b);
$parcel$export(module.exports, "FORGE_GROUP_GQL_FIELD", () => $81f079589240b9b7$export$1763713d718f7ef0);
$parcel$export(module.exports, "FORGE_USER_GQL_FIELD", () => $81f079589240b9b7$export$ebb0caa2a98dcf9e);
$parcel$export(module.exports, "FORGE_GROUPS_GQL_FIELD", () => $81f079589240b9b7$export$671131ba12d94144);
$parcel$export(module.exports, "FORGE_USERS_GQL_FIELD", () => $81f079589240b9b7$export$c48132adab502d6b);
$parcel$export(module.exports, "JSM_APPROVAL_GQL_FIELD", () => $81f079589240b9b7$export$6cd83226f31c7072);
$parcel$export(module.exports, "JSM_USER_APPROVER_PRINCIPAL_FIELD", () => $81f079589240b9b7$export$7de726bd6d97a9a7);
$parcel$export(module.exports, "JSM_GROUP_APPROVER_PRINCIPAL_FIELD", () => $81f079589240b9b7$export$8e4b538f77340a05);
$parcel$export(module.exports, "JSM_REQUEST_FEEDBACK_GQL_FIELD", () => $81f079589240b9b7$export$10ba8c0d74470907);
$parcel$export(module.exports, "JSM_REQUEST_LANGUAGE_GQL_FIELD", () => $81f079589240b9b7$export$1756bb4eff1cc3c6);
$parcel$export(module.exports, "JSM_REQUEST_TYPE_GQL_FIELD", () => $81f079589240b9b7$export$5876b4be3c4407b);
$parcel$export(module.exports, "JSM_RESPONDERS_GQL_FIELD", () => $81f079589240b9b7$export$e7fe49e6f36c7154);
$parcel$export(module.exports, "JSM_USER_RESPONDER_GQL_FIELD", () => $81f079589240b9b7$export$aeed3395a6bca18b);
$parcel$export(module.exports, "JSM_ENTITLEMENTS_GQL_FIELD", () => $81f079589240b9b7$export$9b725a1eafd02e4f);
$parcel$export(module.exports, "JSM_SENTIMENT_GQL_FIELD", () => $81f079589240b9b7$export$699805cbca2c41d);
$parcel$export(module.exports, "JSM_TEAM_RESPONDER_FIELD", () => $81f079589240b9b7$export$f658d5c0f0b5dbc2);
$parcel$export(module.exports, "JSM_MAJOR_INCIDENT_FIELD", () => $81f079589240b9b7$export$e469bcb2060000af);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $81f079589240b9b7$export$f10e53e8928b61bd);
$parcel$export(module.exports, "GOALS_GQL_FIELD", () => $81f079589240b9b7$export$bfcb1a91094f113a);
$parcel$export(module.exports, "DURATION_GQL_FIELD", () => $81f079589240b9b7$export$db0bd6c04eb7d04a);
$parcel$export(module.exports, "JCS_ORGANIZATION_GQL_FIELD", () => $81f079589240b9b7$export$7fe9e7bac5a59952);
$parcel$export(module.exports, "FORGE_CUSTOM_FIELD_TYPE", () => $81f079589240b9b7$export$798d2f5814884447);
$parcel$export(module.exports, "FORGE_STRING_TYPE", () => $81f079589240b9b7$export$1e188101081be3f8);
$parcel$export(module.exports, "FORGE_STRING_LIST_TYPE", () => $81f079589240b9b7$export$caf3b3f20c0589b9);
$parcel$export(module.exports, "FORGE_NUMBER_TYPE", () => $81f079589240b9b7$export$9bdf08a1276e866c);
$parcel$export(module.exports, "FORGE_DATE_TYPE", () => $81f079589240b9b7$export$996c3d3eb2880229);
$parcel$export(module.exports, "FORGE_DATETIME_TYPE", () => $81f079589240b9b7$export$578c5856bf684e2a);
$parcel$export(module.exports, "FORGE_USER_TYPE", () => $81f079589240b9b7$export$38791c0fdd0bcce);
$parcel$export(module.exports, "FORGE_USER_LIST_TYPE", () => $81f079589240b9b7$export$5c209e1debd6c274);
$parcel$export(module.exports, "FORGE_GROUP_TYPE", () => $81f079589240b9b7$export$8646fecba9a8be61);
$parcel$export(module.exports, "FORGE_GROUP_LIST_TYPE", () => $81f079589240b9b7$export$68b91cd2f2e6b810);
$parcel$export(module.exports, "TEAMS_PLATFORM_CF_TYPE", () => $81f079589240b9b7$export$269d70c1b1c9fb80);
$parcel$export(module.exports, "APPROVALS_CF_TYPE", () => $81f079589240b9b7$export$f0f17ef462331df4);
$parcel$export(module.exports, "CATEGORY_TYPE", () => $81f079589240b9b7$export$3c7d8923295a5199);
$parcel$export(module.exports, "PEOPLE_CF_TYPE", () => $81f079589240b9b7$export$fb431e758c9252df);
$parcel$export(module.exports, "NUMBER_CF_TYPE", () => $81f079589240b9b7$export$c7faa96db185cfc6);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_TYPE", () => $81f079589240b9b7$export$492b0fa4fe201a22);
$parcel$export(module.exports, "URL_CF_TYPE", () => $81f079589240b9b7$export$60f0bd6e4b582fe6);
$parcel$export(module.exports, "TEXT_CF_TYPE", () => $81f079589240b9b7$export$68c7e01d5460d298);
$parcel$export(module.exports, "TEXT_AREA_CF_TYPE", () => $81f079589240b9b7$export$39cd48613b53ce2f);
$parcel$export(module.exports, "TEXT_READONLY_CF_TYPE", () => $81f079589240b9b7$export$977db5973ce73e44);
$parcel$export(module.exports, "LABELS_CF_TYPE", () => $81f079589240b9b7$export$ad4eb83f78528e13);
$parcel$export(module.exports, "DATE_CF_TYPE", () => $81f079589240b9b7$export$ff745f432984005d);
$parcel$export(module.exports, "DATETIME_CF_TYPE", () => $81f079589240b9b7$export$42d097f7b1622ef1);
$parcel$export(module.exports, "RADIO_BUTTONS_CF_TYPE", () => $81f079589240b9b7$export$65524be5675e57e6);
$parcel$export(module.exports, "MULTI_CHECKBOXES_CF_TYPE", () => $81f079589240b9b7$export$5280e5501a801dc0);
$parcel$export(module.exports, "MULTI_SELECT_CF_TYPE", () => $81f079589240b9b7$export$c5d13ea26562d57a);
$parcel$export(module.exports, "SELECT_CF_TYPE", () => $81f079589240b9b7$export$22ac48a51c014e4b);
$parcel$export(module.exports, "EPIC_STATUS_TYPE", () => $81f079589240b9b7$export$6769c2c97b828e11);
$parcel$export(module.exports, "MULTI_VERSION_CF_TYPE", () => $81f079589240b9b7$export$39866626496bbfc8);
$parcel$export(module.exports, "VERSION_CF_TYPE", () => $81f079589240b9b7$export$24382b4e8c58336b);
$parcel$export(module.exports, "GROUP_CF_TYPE", () => $81f079589240b9b7$export$b075907882e80160);
$parcel$export(module.exports, "MULTI_GROUP_CF_TYPE", () => $81f079589240b9b7$export$b600addfa3355c57);
$parcel$export(module.exports, "USER_CF_TYPE", () => $81f079589240b9b7$export$c491a4b98394028e);
$parcel$export(module.exports, "MULTI_USER_CF_TYPE", () => $81f079589240b9b7$export$5365f2d3fac5261a);
$parcel$export(module.exports, "PARTICIPANTS_CF_TYPE", () => $81f079589240b9b7$export$cc8ffff49170b0f4);
$parcel$export(module.exports, "FLAGGED_CF_TYPE", () => $81f079589240b9b7$export$b7178f601d7373f9);
$parcel$export(module.exports, "TEAM_CF_TYPE", () => $81f079589240b9b7$export$eb1f1dca13a0f02d);
$parcel$export(module.exports, "PARENT_CF_TYPE", () => $81f079589240b9b7$export$3e71e11f80203acb);
$parcel$export(module.exports, "BASELINE_START_CF_TYPE", () => $81f079589240b9b7$export$d10d66823a65e688);
$parcel$export(module.exports, "BASELINE_END_CF_TYPE", () => $81f079589240b9b7$export$dfc6da4a9963d5dc);
$parcel$export(module.exports, "COLOR_CF_TYPE", () => $81f079589240b9b7$export$b4a1fbc1cf0059cf);
$parcel$export(module.exports, "EPIC_COLOR_TYPE", () => $81f079589240b9b7$export$4838a8a8d62a64fd);
$parcel$export(module.exports, "ASSETS_CF_TYPE", () => $81f079589240b9b7$export$ed2de20ab8b7ad3d);
$parcel$export(module.exports, "SERVICE_ENTITY_CF_TYPE", () => $81f079589240b9b7$export$b755e97dbfa92610);
$parcel$export(module.exports, "REQUEST_PARTICIPANTS_CF_TYPE", () => $81f079589240b9b7$export$1be1ecd4dfc06fab);
$parcel$export(module.exports, "ORGANIZATIONS_CF_TYPE", () => $81f079589240b9b7$export$34317c2d84a93553);
$parcel$export(module.exports, "ORGANIZATION_CF_TYPE", () => $81f079589240b9b7$export$c1e26582406f77ec);
$parcel$export(module.exports, "REQUEST_LANGUAGE_CF_TYPE", () => $81f079589240b9b7$export$555b4f35f98a3210);
$parcel$export(module.exports, "REQUEST_FEEDBACK_CF_TYPE", () => $81f079589240b9b7$export$1f2859a3ef701a14);
$parcel$export(module.exports, "REQUEST_FEEDBACK_DATE_CF_TYPE", () => $81f079589240b9b7$export$68f62eb762e4157f);
$parcel$export(module.exports, "REQUEST_TYPE_CF_TYPE", () => $81f079589240b9b7$export$6da975fce1fbd38e);
$parcel$export(module.exports, "APPROVERS_LIST_CF_TYPE", () => $81f079589240b9b7$export$c6dd874aae21e51f);
$parcel$export(module.exports, "CASCADING_SELECT_CF_TYPE", () => $81f079589240b9b7$export$c3c9f8a8a8dc0b30);
$parcel$export(module.exports, "RANK_CF_TYPE", () => $81f079589240b9b7$export$af89c0396aaf23e3);
$parcel$export(module.exports, "CMDB_OBJECT_CF_TYPE", () => $81f079589240b9b7$export$3b5a62bb34372404);
$parcel$export(module.exports, "READ_ONLY_CF_TYPE", () => $81f079589240b9b7$export$247829aef464243f);
$parcel$export(module.exports, "PROJECT_PICKER_CF_TYPE", () => $81f079589240b9b7$export$65a6076c0927d413);
$parcel$export(module.exports, "RESPONDERS_CF_TYPE", () => $81f079589240b9b7$export$bcf83e1d934501c9);
$parcel$export(module.exports, "MAJOR_INCIDENT_CF_TYPE", () => $81f079589240b9b7$export$ae0eeec12e90a01e);
$parcel$export(module.exports, "ENTITLEMENT_CF_TYPE", () => $81f079589240b9b7$export$c23f6b40da18371a);
$parcel$export(module.exports, "SENTIMENT_CF_TYPE", () => $81f079589240b9b7$export$c23cfbdf83daa90d);
$parcel$export(module.exports, "MESSAGE_VIEW_CF_TYPE", () => $81f079589240b9b7$export$21dda64db57e4883);
$parcel$export(module.exports, "MESSAGE_EDIT_CF_TYPE", () => $81f079589240b9b7$export$45700f3bf92a003a);
$parcel$export(module.exports, "LAST_UPDATER_OR_COMMENTER_CF_TYPE", () => $81f079589240b9b7$export$2d75b47d12efc812);
$parcel$export(module.exports, "USER_PROPERTY_CF_TYPE", () => $81f079589240b9b7$export$7b79405842547ccb);
$parcel$export(module.exports, "TIME_IN_STATUS_CF_TYPE", () => $81f079589240b9b7$export$96201d0ae03ca323);
$parcel$export(module.exports, "FIRST_RESPONSE_DATE_CF_TYPE", () => $81f079589240b9b7$export$fc276d6ccf118a14);
$parcel$export(module.exports, "DEV_SUMMARY_CF_TYPE", () => $81f079589240b9b7$export$8b0718167d092603);
$parcel$export(module.exports, "CHILDREN_ISSUES_CF_TYPE", () => $81f079589240b9b7$export$904b40dd2afd17a2);
$parcel$export(module.exports, "GOALS_CF_TYPE", () => $81f079589240b9b7$export$2bbb7f69c97ea279);
$parcel$export(module.exports, "ASSIGNEE_TYPE", () => $81f079589240b9b7$export$fba8634fd401ba8b);
$parcel$export(module.exports, "REPORTER_TYPE", () => $81f079589240b9b7$export$a91aea2438afcce8);
$parcel$export(module.exports, "DUE_DATE_TYPE", () => $81f079589240b9b7$export$b159f8b8f27aae4c);
$parcel$export(module.exports, "PRIORITY_TYPE", () => $81f079589240b9b7$export$34740f8d07d23ac0);
$parcel$export(module.exports, "LABELS_TYPE", () => $81f079589240b9b7$export$43b6e33ec70f2272);
$parcel$export(module.exports, "CREATED", () => $81f079589240b9b7$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $81f079589240b9b7$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "RESOLUTION_DATE", () => $81f079589240b9b7$export$6a052efb0b4ec5d2);
$parcel$export(module.exports, "COMPONENTS_TYPE", () => $81f079589240b9b7$export$37abf56f13f61ec5);
$parcel$export(module.exports, "SERVICEDESK_APPROVAL_TYPE", () => $81f079589240b9b7$export$aef0c22aecd16996);
$parcel$export(module.exports, "SERVICEDESK_PRACTICES_TYPE", () => $81f079589240b9b7$export$cff5b6d1e7135679);
$parcel$export(module.exports, "SERVICEDESK_INCIDENT_MANAGEMENT_TYPE", () => $81f079589240b9b7$export$791007408faf42f4);
$parcel$export(module.exports, "DEV_SUMMARY_TYPE", () => $81f079589240b9b7$export$827a1c600bac12a3);
$parcel$export(module.exports, "RELEASES_TYPE", () => $81f079589240b9b7$export$e9ba671d077969f8);
$parcel$export(module.exports, "SPRINT_TYPE", () => $81f079589240b9b7$export$3d37701ba6fb68ec);
$parcel$export(module.exports, "STORY_POINTS_TYPE", () => $81f079589240b9b7$export$36fd22f47020f37b);
$parcel$export(module.exports, "EPIC_TYPE", () => $81f079589240b9b7$export$9f2fedcd916d2a79);
$parcel$export(module.exports, "EPIC_NAME_TYPE", () => $81f079589240b9b7$export$dfc63737b8c0150d);
$parcel$export(module.exports, "FIX_VERSIONS_TYPE", () => $81f079589240b9b7$export$a5c9f63aadcb220);
$parcel$export(module.exports, "AFFECTS_VERSIONS_TYPE", () => $81f079589240b9b7$export$94009605902e4fe5);
$parcel$export(module.exports, "DESCRIPTION_TYPE", () => $81f079589240b9b7$export$5e7324042f1d6b31);
$parcel$export(module.exports, "ENVIRONMENT_TYPE", () => $81f079589240b9b7$export$113281d03e6830ef);
$parcel$export(module.exports, "WATCHES_TYPE", () => $81f079589240b9b7$export$5ff798870a3dffbf);
$parcel$export(module.exports, "SUMMARY_TYPE", () => $81f079589240b9b7$export$907219511d14ba3d);
$parcel$export(module.exports, "PROFORMA_FORMS", () => $81f079589240b9b7$export$d09aa6a4f3538063);
$parcel$export(module.exports, "RESOLUTION_TYPE", () => $81f079589240b9b7$export$3aca8c91b58a42e2);
$parcel$export(module.exports, "TIME_TRACKING_TYPE", () => $81f079589240b9b7$export$ccb5ffefbf8b987c);
$parcel$export(module.exports, "TIME_ESTIMATE_TYPE", () => $81f079589240b9b7$export$c8bedad98a5e7f5f);
$parcel$export(module.exports, "STATUS_TYPE", () => $81f079589240b9b7$export$358267065be1e);
$parcel$export(module.exports, "STATUS_CATEGORY_TYPE", () => $81f079589240b9b7$export$dcaa788c7ada56de);
$parcel$export(module.exports, "ISSUE_TYPE", () => $81f079589240b9b7$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_KEY_TYPE", () => $81f079589240b9b7$export$5e91047fe9955d0e);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $81f079589240b9b7$export$3b3d0889022c85b3);
$parcel$export(module.exports, "HIERARCHY_LEVEL_BELOW", () => $81f079589240b9b7$export$335851d83a79891);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_BELOW", () => $81f079589240b9b7$export$7b76bbcb87d41695);
$parcel$export(module.exports, "HIERARCHY_LEVEL_ABOVE", () => $81f079589240b9b7$export$297b67ac63f09f72);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_ABOVE", () => $81f079589240b9b7$export$ae87161126086be);
$parcel$export(module.exports, "HIERARCHY_LEVEL_SAME_LEVEL", () => $81f079589240b9b7$export$6a88420fc2f6901d);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_SAME_LEVEL", () => $81f079589240b9b7$export$ef1a0421bd42c0e4);
$parcel$export(module.exports, "CUSTOMER_CONTEXT_TYPE", () => $81f079589240b9b7$export$dd695c8c5ab62f9d);
$parcel$export(module.exports, "SLA_PANEL_TYPE", () => $81f079589240b9b7$export$7b3d247435a784fa);
$parcel$export(module.exports, "LINKED_ALERTS_TYPE", () => $81f079589240b9b7$export$17b7080ed1fe8cfd);
$parcel$export(module.exports, "CHAT_CHANNEL_TYPE", () => $81f079589240b9b7$export$29fe745131dad7ba);
$parcel$export(module.exports, "MSTEAMS_CHANNEL_TYPE", () => $81f079589240b9b7$export$9c245100c3091ec3);
$parcel$export(module.exports, "ZOOM_MEETING_TYPE", () => $81f079589240b9b7$export$51eb15cea47a37ba);
$parcel$export(module.exports, "MANAGE_STAKEHOLDERS_TYPE", () => $81f079589240b9b7$export$c7ae0622b0bd5d56);
$parcel$export(module.exports, "KNOWLEDGE_BASE_TYPE", () => $81f079589240b9b7$export$b5358afda8ff335e);
$parcel$export(module.exports, "JOURNEY_PANEL_TYPE", () => $81f079589240b9b7$export$d2a475ff30e5bf97);
$parcel$export(module.exports, "ASSET_ONBOARDING_TYPE", () => $81f079589240b9b7$export$63cf6f392da16c25);
$parcel$export(module.exports, "SIMILAR_ISSUES_TYPE", () => $81f079589240b9b7$export$22f61ccc2730431f);
$parcel$export(module.exports, "SUBTASKS_TYPE", () => $81f079589240b9b7$export$8bbb446f57294715);
$parcel$export(module.exports, "VOTES_TYPE", () => $81f079589240b9b7$export$34fcd7cb291a1e4d);
$parcel$export(module.exports, "PARENT_TYPE", () => $81f079589240b9b7$export$5e93f2a57cc4ca3a);
$parcel$export(module.exports, "PROJECT_TYPE", () => $81f079589240b9b7$export$91a9dba2d38d9a6f);
$parcel$export(module.exports, "WORKLOG", () => $81f079589240b9b7$export$df36fc05622c402);
$parcel$export(module.exports, "TIME_SPENT_TYPE", () => $81f079589240b9b7$export$ede0a4c20124ec85);
$parcel$export(module.exports, "DATA_CLASSIFICATION_TYPE", () => $81f079589240b9b7$export$3eeb79d48fb5f667);
$parcel$export(module.exports, "SENTIMENT_TYPE", () => $81f079589240b9b7$export$45e72c9a63ab61ab);
$parcel$export(module.exports, "DETAILS_PANEL_IN_EDIT_MODE", () => $81f079589240b9b7$export$f4909db381566ce3);
$parcel$export(module.exports, "ARE_FIELDS_REORDERED", () => $81f079589240b9b7$export$6159d4eb69c78696);
$parcel$export(module.exports, "HIDE_EMPTY_FIELDS", () => $81f079589240b9b7$export$962c5b8782b7a233);
$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $81f079589240b9b7$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $81f079589240b9b7$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $81f079589240b9b7$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "ISSUE_RESTRICTION_TYPE", () => $81f079589240b9b7$export$84e5674890d55030);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE", () => $81f079589240b9b7$export$326a5522a485e43d);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE_OVERRIDE", () => $81f079589240b9b7$export$c9f3f01e2c535302);
$parcel$export(module.exports, "TEAM_TYPE", () => $81f079589240b9b7$export$66519f3bbff1796a);
$parcel$export(module.exports, "ESTIMATE_TYPE", () => $81f079589240b9b7$export$a4ee0bca77cc8463);
$parcel$export(module.exports, "DUE_DATE_PORTFOLIO_TYPE", () => $81f079589240b9b7$export$fed53408e89e0497);
$parcel$export(module.exports, "TARGET_START_TYPE", () => $81f079589240b9b7$export$d53c26f9ce31f56b);
$parcel$export(module.exports, "TARGET_END_TYPE", () => $81f079589240b9b7$export$48f82d653f85e459);
$parcel$export(module.exports, "START_DATE_TYPE", () => $81f079589240b9b7$export$ea5a888f39f722c7);
$parcel$export(module.exports, "COLOR_TYPE", () => $81f079589240b9b7$export$f245bbec12cc0e40);
$parcel$export(module.exports, "ATTACHMENT_TYPE", () => $81f079589240b9b7$export$aed630b4b7114a59);
$parcel$export(module.exports, "ISSUE_LINKS_TYPE", () => $81f079589240b9b7$export$b50c1a8fef07104);
$parcel$export(module.exports, "TIME_ESTIMATE_CONFIG_TYPE", () => $81f079589240b9b7$export$ea3d72f4bb7738ba);
$parcel$export(module.exports, "COMMENT_TYPE", () => $81f079589240b9b7$export$a4cab0124760d860);
$parcel$export(module.exports, "WORK_LOG_TYPE", () => $81f079589240b9b7$export$734929aef118d7e2);
$parcel$export(module.exports, "PARENT_FIELD_TYPE", () => $81f079589240b9b7$export$ffbacacb07c1d46d);
$parcel$export(module.exports, "AGGREGATE_TIME_ORIGINAL_ESTIMATE", () => $81f079589240b9b7$export$871661506c0a91ea);
$parcel$export(module.exports, "AGGREGATE_TIME_ESTIMATE", () => $81f079589240b9b7$export$4a7ecfe931ab6c07);
$parcel$export(module.exports, "PROGRESS", () => $81f079589240b9b7$export$fbc5ebe2e580bf8b);
$parcel$export(module.exports, "AGGREGATE_PROGRESS", () => $81f079589240b9b7$export$aa3b37e271efd578);
$parcel$export(module.exports, "WORKRATIO", () => $81f079589240b9b7$export$444bffe6526fb5f2);
$parcel$export(module.exports, "getLayoutFieldTypes", () => $81f079589240b9b7$export$3c3e26aadbfa2c32);

var $8QpSo = parcelRequire("8QpSo");

var $4R6GH = parcelRequire("4R6GH");
const $81f079589240b9b7$export$b144116dae474c88 = 'issue-link-search';
const $81f079589240b9b7$export$bc917bc699b25f75 = 'number';
const $81f079589240b9b7$export$5f26ca419fdffbe7 = 'string';
const $81f079589240b9b7$export$ce9bfd823c7e1a6d = 'datetime';
const $81f079589240b9b7$export$346b72b1f7cd6d5a = 'date';
const $81f079589240b9b7$export$b20fbcacd7942c2a = 'option2';
const $81f079589240b9b7$export$20737ab0ca5fa93f = 'option'; // graphql currently returns this type
const $81f079589240b9b7$export$a2e8554bffc61ece = 'any';
const $81f079589240b9b7$export$f25cd4907cbb25b9 = 'array';
const $81f079589240b9b7$export$5600354b43577e17 = 'user';
const $81f079589240b9b7$export$5dbc9917f72d0d2a = 'group';
const $81f079589240b9b7$export$253649f07fb55948 = 'object';
const $81f079589240b9b7$export$eb39592ba5247ee7 = 'group-list';
const $81f079589240b9b7$export$f48a9be226105736 = 'array-string';
const $81f079589240b9b7$export$42e2e93fc721df5d = 'version';
const $81f079589240b9b7$export$a603eef6fee2a5f0 = 'parent-issues'; // Remove on FD-30157 clean-up
const $81f079589240b9b7$export$7773375e72c953ed = 'approval-panel';
const $81f079589240b9b7$export$80ad0037098f3919 = 'project';
const $81f079589240b9b7$export$82db8a26de491dd2 = 'array';
const $81f079589240b9b7$export$6875c7efa3a5e380 = 'JiraAffectedServicesField';
const $81f079589240b9b7$export$7c1a5c7d37b8f968 = 'JiraAssigneeField';
const $81f079589240b9b7$export$d74e2f14098ef8f6 = 'JiraAttachmentsField';
const $81f079589240b9b7$export$c5931a5d7dbfb40b = 'JiraAtlassianTeamField';
const $81f079589240b9b7$export$c979d9c548c05133 = 'JiraBooleanField';
const $81f079589240b9b7$export$ff25e7412c4ae9c7 = 'JiraCascadingSelectField';
const $81f079589240b9b7$export$16dbdf57e34e8d63 = 'JiraCheckboxesField';
const $81f079589240b9b7$export$1bf8bec92e6e84df = 'JiraChildIssuesExceedingLimit';
const $81f079589240b9b7$export$c32f5d822fe5ea95 = 'JiraChildIssuesWithinLimit';
const $81f079589240b9b7$export$b0deb225eed90fbd = 'JiraCMDBField';
const $81f079589240b9b7$export$add3775cfea8fde3 = 'JiraColorField';
const $81f079589240b9b7$export$9631d4098abab3eb = 'JiraComponentsField';
const $81f079589240b9b7$export$ee42bc16c09ee564 = 'JiraConnectDateTimeField';
const $81f079589240b9b7$export$fbcebbdce821f712 = 'JiraConnectNumberField';
const $81f079589240b9b7$export$41dd2eb1f33d3042 = 'JiraConnectMultipleSelectField';
const $81f079589240b9b7$export$f4e3e72a3be84e5b = 'JiraConnectRichTextField';
const $81f079589240b9b7$export$d6738c8a6d1a735d = 'JiraConnectSingleSelectField';
const $81f079589240b9b7$export$79a75502a3f0c4c4 = 'JiraConnectTextField';
const $81f079589240b9b7$export$ed2eabcf0931df31 = 'JiraDatePickerField';
const $81f079589240b9b7$export$1f17904e959f2f0b = 'JiraDateTimePickerField';
const $81f079589240b9b7$export$6d8da4497234455 = 'JiraEpicLinkField';
const $81f079589240b9b7$export$9bcfac568e4fa59c = 'JiraFlagField';
const $81f079589240b9b7$export$ff2e58d499eebe1d = 'JiraIssueLinkField';
const $81f079589240b9b7$export$dd84cd6c957c6f5e = 'JiraIssueRestrictionField';
const $81f079589240b9b7$export$5cc7c39d7d1cf6d5 = 'JiraIssueTypeField';
const $81f079589240b9b7$export$810709f0c5c2e9db = 'JiraLabelsField';
const $81f079589240b9b7$export$82cb6735134c23a2 = 'JiraMultipleSelectField';
const $81f079589240b9b7$export$85e04e9a3a81ee1 = 'JiraMultipleSelectUserPickerField';
const $81f079589240b9b7$export$24c916a8a33ed20c = 'JiraMultipleVersionPickerField';
const $81f079589240b9b7$export$c049920d930c3b8a = 'JiraMultipleGroupPickerField';
const $81f079589240b9b7$export$3b6d7fc1833bf7da = 'JiraNumberField';
const $81f079589240b9b7$export$bd3e2fe853319c13 = 'JiraOriginalTimeEstimateField';
const $81f079589240b9b7$export$6dfd3fc78bc751a0 = 'JiraParentIssueField';
const $81f079589240b9b7$export$31aea7548807c6b5 = 'JiraPeopleField';
const $81f079589240b9b7$export$e89fbbf3983c0219 = 'JiraPriorityField';
const $81f079589240b9b7$export$f5e2fb1022ff7912 = 'JiraProformaFormsField';
const $81f079589240b9b7$export$12f54499c6252188 = 'JiraProjectField';
const $81f079589240b9b7$export$8e4293d806f435e0 = 'JiraRadioSelectField';
const $81f079589240b9b7$export$c69486dd643dfb69 = 'JiraReporterField';
const $81f079589240b9b7$export$1e18a858257aca2f = 'JiraRequestTypeField';
const $81f079589240b9b7$export$1e4faa0d6dc58a81 = 'JiraResolutionField';
const $81f079589240b9b7$export$37f4daaa7b409554 = 'JiraRichTextField';
const $81f079589240b9b7$export$ca57cccd6d7bf97c = 'JiraSecurityLevelField';
const $81f079589240b9b7$export$bea889616fd5bdab = 'JiraSingleGroupPickerField';
const $81f079589240b9b7$export$ab5cecc580898d1c = 'JiraSingleSelectField';
const $81f079589240b9b7$export$bb63813d13e8eaf7 = 'JiraSprintField';
const $81f079589240b9b7$export$e40f819979b3881d = 'JiraStatusField';
const $81f079589240b9b7$export$6c243704a22baffe = 'JiraTeamField';
const $81f079589240b9b7$export$6c32429bac235203 = 'JiraTeamViewField';
const $81f079589240b9b7$export$61b514b470cbbf07 = 'JiraSingleLineTextField';
const $81f079589240b9b7$export$e4bcb1729da5683 = 'JiraTimeTrackingField';
const $81f079589240b9b7$export$37ccd11f08a93ccb = 'JiraUrlField';
const $81f079589240b9b7$export$abf1bf8c1106ba7d = 'JiraSingleSelectUserPickerField';
const $81f079589240b9b7$export$b55604041ae7179e = 'JiraSingleVersionPickerField';
const $81f079589240b9b7$export$c8bf66d62e74cdd2 = 'JiraVotesField';
const $81f079589240b9b7$export$aa815aaa741ae18 = 'JiraWatchesField';
const $81f079589240b9b7$export$e805f89b15d2abf4 = 'JiraAssetField';
const $81f079589240b9b7$export$5bfd36acd96f04c2 = 'JiraServiceManagementPeopleField';
const $81f079589240b9b7$export$695423a2bc8a9ac4 = 'JiraServiceManagementOrganizationField';
const $81f079589240b9b7$export$d29b0ba0d80bc129 = 'JiraForgeStringField';
const $81f079589240b9b7$export$ac6c7b30703608d6 = 'JiraForgeStringsField';
const $81f079589240b9b7$export$478b546dccd33e1e = 'JiraForgeNumberField';
const $81f079589240b9b7$export$f90c042e9eb983e7 = 'JiraForgeDatetimeField';
const $81f079589240b9b7$export$753ca4fb34ff3f2b = 'JiraForgeDateField';
const $81f079589240b9b7$export$b7aed9efb4a9154b = 'JiraForgeObjectField';
const $81f079589240b9b7$export$1763713d718f7ef0 = 'JiraForgeGroupField';
const $81f079589240b9b7$export$ebb0caa2a98dcf9e = 'JiraForgeUserField';
const $81f079589240b9b7$export$671131ba12d94144 = 'JiraForgeGroupsField';
const $81f079589240b9b7$export$c48132adab502d6b = 'JiraForgeUsersField';
const $81f079589240b9b7$export$6cd83226f31c7072 = 'JiraServiceManagementApprovalField';
const $81f079589240b9b7$export$7de726bd6d97a9a7 = 'JiraServiceManagementUserApproverPrincipal';
const $81f079589240b9b7$export$8e4b538f77340a05 = 'JiraServiceManagementGroupApproverPrincipal';
const $81f079589240b9b7$export$10ba8c0d74470907 = 'JiraServiceManagementRequestFeedbackField';
const $81f079589240b9b7$export$1756bb4eff1cc3c6 = 'JiraServiceManagementRequestLanguageField';
const $81f079589240b9b7$export$5876b4be3c4407b = 'JiraServiceManagementRequestTypeField';
const $81f079589240b9b7$export$e7fe49e6f36c7154 = 'JiraServiceManagementRespondersField';
const $81f079589240b9b7$export$aeed3395a6bca18b = 'JiraServiceManagementUserResponder';
const $81f079589240b9b7$export$9b725a1eafd02e4f = 'JiraServiceManagementEntitlementField';
const $81f079589240b9b7$export$699805cbca2c41d = 'JiraServiceManagementSentimentField';
const $81f079589240b9b7$export$f658d5c0f0b5dbc2 = 'JiraServiceManagementTeamResponder';
const $81f079589240b9b7$export$e469bcb2060000af = 'JiraServiceManagementMajorIncidentField';
const $81f079589240b9b7$export$f10e53e8928b61bd = 'JiraDataClassificationField';
const $81f079589240b9b7$export$bfcb1a91094f113a = 'JiraGoalsField';
const $81f079589240b9b7$export$db0bd6c04eb7d04a = 'JiraDurationField';
const $81f079589240b9b7$export$7fe9e7bac5a59952 = 'JiraCustomerServiceOrganizationField';
const $81f079589240b9b7$export$798d2f5814884447 = 'forgeCustomField';
const $81f079589240b9b7$export$1e188101081be3f8 = 'forge/string';
const $81f079589240b9b7$export$caf3b3f20c0589b9 = 'forge/string-list';
const $81f079589240b9b7$export$9bdf08a1276e866c = 'forge/number';
const $81f079589240b9b7$export$996c3d3eb2880229 = 'forge/date';
const $81f079589240b9b7$export$578c5856bf684e2a = 'forge/datetime';
const $81f079589240b9b7$export$38791c0fdd0bcce = 'forge/user';
const $81f079589240b9b7$export$5c209e1debd6c274 = 'forge/user-list';
const $81f079589240b9b7$export$8646fecba9a8be61 = 'forge/group';
const $81f079589240b9b7$export$68b91cd2f2e6b810 = 'forge/group-list';
const $81f079589240b9b7$export$269d70c1b1c9fb80 = 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team';
const $81f079589240b9b7$export$f0f17ef462331df4 = 'com.atlassian.servicedesk.approvals-plugin:sd-approvals';
const $81f079589240b9b7$export$3c7d8923295a5199 = 'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category';
const $81f079589240b9b7$export$fb431e758c9252df = 'com.atlassian.jira.plugin.system.customfieldtypes:people';
const $81f079589240b9b7$export$c7faa96db185cfc6 = 'com.atlassian.jira.plugin.system.customfieldtypes:float';
const $81f079589240b9b7$export$492b0fa4fe201a22 = 'com.pyxis.greenhopper.jira:jsw-story-points';
const $81f079589240b9b7$export$60f0bd6e4b582fe6 = 'com.atlassian.jira.plugin.system.customfieldtypes:url';
const $81f079589240b9b7$export$68c7e01d5460d298 = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
const $81f079589240b9b7$export$39cd48613b53ce2f = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
const $81f079589240b9b7$export$977db5973ce73e44 = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $81f079589240b9b7$export$ad4eb83f78528e13 = 'com.atlassian.jira.plugin.system.customfieldtypes:labels';
const $81f079589240b9b7$export$ff745f432984005d = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $81f079589240b9b7$export$42d097f7b1622ef1 = 'com.atlassian.jira.plugin.system.customfieldtypes:datetime';
const $81f079589240b9b7$export$65524be5675e57e6 = 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons';
const $81f079589240b9b7$export$5280e5501a801dc0 = 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
const $81f079589240b9b7$export$c5d13ea26562d57a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
const $81f079589240b9b7$export$22ac48a51c014e4b = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $81f079589240b9b7$export$6769c2c97b828e11 = 'com.pyxis.greenhopper.jira:gh-epic-status';
const $81f079589240b9b7$export$39866626496bbfc8 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiversion';
const $81f079589240b9b7$export$24382b4e8c58336b = 'com.atlassian.jira.plugin.system.customfieldtypes:version';
const $81f079589240b9b7$export$b075907882e80160 = 'com.atlassian.jira.plugin.system.customfieldtypes:grouppicker';
const $81f079589240b9b7$export$b600addfa3355c57 = 'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker';
const $81f079589240b9b7$export$c491a4b98394028e = 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker';
const $81f079589240b9b7$export$5365f2d3fac5261a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker';
const $81f079589240b9b7$export$cc8ffff49170b0f4 = 'com.atlassian.jira.toolkit:participants';
const $81f079589240b9b7$export$b7178f601d7373f9 = 'com.atlassian.jira.plugin.system.customfieldtypes:flagged';
const $81f079589240b9b7$export$eb1f1dca13a0f02d = 'com.atlassian.teams:rm-teams-custom-field-team';
const $81f079589240b9b7$export$3e71e11f80203acb = 'com.atlassian.jpo:jpo-custom-field-parent';
const $81f079589240b9b7$export$9f47a86016048ac3 = 'com.atlassian.graphql:parent-issues';
const $81f079589240b9b7$export$d10d66823a65e688 = 'com.atlassian.jpo:jpo-custom-field-baseline-start';
const $81f079589240b9b7$export$dfc6da4a9963d5dc = 'com.atlassian.jpo:jpo-custom-field-baseline-end';
const $81f079589240b9b7$export$b4a1fbc1cf0059cf = 'com.pyxis.greenhopper.jira:jsw-issue-color';
const $81f079589240b9b7$export$4838a8a8d62a64fd = 'com.pyxis.greenhopper.jira:gh-epic-color';
const $81f079589240b9b7$export$ed2de20ab8b7ad3d = 'com.atlassian.servicedesk.assets-plugin:assetfield';
const $81f079589240b9b7$export$b755e97dbfa92610 = 'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype';
const $81f079589240b9b7$export$1be1ecd4dfc06fab = 'com.atlassian.servicedesk:sd-request-participants';
const $81f079589240b9b7$export$34317c2d84a93553 = 'com.atlassian.servicedesk:sd-customer-organizations';
const $81f079589240b9b7$export$c1e26582406f77ec = 'com.atlassian.servicedesk.customer-context:sd-csm-organization';
const $81f079589240b9b7$export$555b4f35f98a3210 = 'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-request-language';
const $81f079589240b9b7$export$1f2859a3ef701a14 = 'com.atlassian.servicedesk:sd-request-feedback';
const $81f079589240b9b7$export$68f62eb762e4157f = 'com.atlassian.servicedesk:sd-request-feedback-date';
const $81f079589240b9b7$export$6da975fce1fbd38e = 'com.atlassian.servicedesk:vp-origin';
const $81f079589240b9b7$export$c6dd874aae21e51f = 'com.atlassian.jira.plugin.system.customfieldtypes:servicedesk-approvers-list';
const $81f079589240b9b7$export$c3c9f8a8a8dc0b30 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
const $81f079589240b9b7$export$af89c0396aaf23e3 = 'com.pyxis.greenhopper.jira:gh-lexo-rank';
const $81f079589240b9b7$export$3b5a62bb34372404 = 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype';
const $81f079589240b9b7$export$247829aef464243f = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $81f079589240b9b7$export$65a6076c0927d413 = 'com.atlassian.jira.plugin.system.customfieldtypes:project';
const $81f079589240b9b7$export$bcf83e1d934501c9 = 'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype';
const $81f079589240b9b7$export$ae0eeec12e90a01e = 'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype';
const $81f079589240b9b7$export$f94696506ee781f9 = 'com.atlassian.jira.plugins.jim-plugin:bug-importid';
const $81f079589240b9b7$export$8ba6ed64df1ce64a = 'com.atlassian.jira.plugin.system.customfieldtypes:importid';
const $81f079589240b9b7$export$e90ce947f06b085d = 'com.atlassian.jconnect.jconnect-plugin:uuid';
const $81f079589240b9b7$export$c23f6b40da18371a = 'com.atlassian.servicedesk.customer-context:sd-csm-entitlement';
const $81f079589240b9b7$export$c23cfbdf83daa90d = 'com.atlassian.servicedesk.sentiment:sd-sentiment';
const $81f079589240b9b7$export$21dda64db57e4883 = 'com.atlassian.jira.toolkit:viewmessage';
const $81f079589240b9b7$export$45700f3bf92a003a = 'com.atlassian.jira.toolkit:message';
const $81f079589240b9b7$export$2d75b47d12efc812 = 'com.atlassian.jira.toolkit:lastupdaterorcommenter';
const $81f079589240b9b7$export$36500b2821f7114f = 'com.atlassian.jira.toolkit:attachments';
const $81f079589240b9b7$export$37dc91333ba7a96 = 'com.atlassian.jira.toolkit:LastCommentDate';
const $81f079589240b9b7$export$7b79405842547ccb = 'com.atlassian.jira.toolkit:userproperty';
const $81f079589240b9b7$export$ac9f7d2dfc7c6826 = 'com.atlassian.jira.toolkit:assigneedomain';
const $81f079589240b9b7$export$a3d9c149d737aa78 = 'com.atlassian.jira.toolkit:reporterdomain';
const $81f079589240b9b7$export$4745e551386233a5 = 'com.atlassian.jira.toolkit:comments';
const $81f079589240b9b7$export$5ee213d6fd4c9b2b = 'com.atlassian.jira.toolkit:dayslastcommented';
const $81f079589240b9b7$export$fb0b6a2e098e1fe2 = 'com.atlassian.jira.toolkit:lastusercommented';
const $81f079589240b9b7$export$fe1291c40f590f35 = 'com.atlassian.servicedesk:sd-sla-field';
const $81f079589240b9b7$export$e9c81bef34f2c86c = 'sd-servicelevelagreement';
const $81f079589240b9b7$export$96201d0ae03ca323 = 'com.atlassian.jira.ext.charting:timeinstatus';
const $81f079589240b9b7$export$fc276d6ccf118a14 = 'com.atlassian.jira.ext.charting:firstresponsedate';
const $81f079589240b9b7$export$8b0718167d092603 = 'com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf';
const $81f079589240b9b7$export$904b40dd2afd17a2 = 'com.atlassian.graphql:children-issues';
const $81f079589240b9b7$export$4063d93c74c89472 = 'com.atlassian.graphql:epic-issues';
const $81f079589240b9b7$export$f0eeb5dcfbc42177 = 'com.atlassian.graphql:portfolio-child-issues';
const $81f079589240b9b7$export$2bbb7f69c97ea279 = 'com.atlassian.jira.plugin.system.customfieldtypes:goals';
const $81f079589240b9b7$export$fba8634fd401ba8b = 'assignee';
const $81f079589240b9b7$export$a91aea2438afcce8 = 'reporter';
const $81f079589240b9b7$export$b159f8b8f27aae4c = 'duedate';
const $81f079589240b9b7$export$34740f8d07d23ac0 = 'priority';
const $81f079589240b9b7$export$43b6e33ec70f2272 = 'labels';
const $81f079589240b9b7$export$ff39ebd4bb12b718 = 'created';
const $81f079589240b9b7$export$cd8e68094cb5c3cb = 'updated';
const $81f079589240b9b7$export$6a052efb0b4ec5d2 = 'resolutiondate';
const $81f079589240b9b7$export$37abf56f13f61ec5 = 'components';
const $81f079589240b9b7$export$aef0c22aecd16996 = 'servicedesk-approvals';
const $81f079589240b9b7$export$cff5b6d1e7135679 = 'servicedesk-practices';
const $81f079589240b9b7$export$d925edcf818f4885 = 'servicedesk-incident-linking';
const $81f079589240b9b7$export$e7c590d96ed1c7fa = 'servicedesk-incident-escalate';
const $81f079589240b9b7$export$791007408faf42f4 = 'servicedesk-incident-management';
const $81f079589240b9b7$export$827a1c600bac12a3 = 'devSummary';
const $81f079589240b9b7$export$e9ba671d077969f8 = 'releases';
const $81f079589240b9b7$export$3d37701ba6fb68ec = 'com.pyxis.greenhopper.jira:gh-sprint';
const $81f079589240b9b7$export$36fd22f47020f37b = 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint';
const $81f079589240b9b7$export$9f2fedcd916d2a79 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $81f079589240b9b7$export$dfc63737b8c0150d = 'com.pyxis.greenhopper.jira:gh-epic-label';
const $81f079589240b9b7$export$a5c9f63aadcb220 = 'fixVersions';
const $81f079589240b9b7$export$94009605902e4fe5 = 'versions';
const $81f079589240b9b7$export$5e7324042f1d6b31 = 'description';
const $81f079589240b9b7$export$113281d03e6830ef = 'environment';
const $81f079589240b9b7$export$5ff798870a3dffbf = 'watches';
const $81f079589240b9b7$export$907219511d14ba3d = 'summary';
const $81f079589240b9b7$export$d09aa6a4f3538063 = 'proforma-forms';
const $81f079589240b9b7$export$3aca8c91b58a42e2 = 'resolution';
const $81f079589240b9b7$export$ccb5ffefbf8b987c = 'timetracking';
const $81f079589240b9b7$export$c8bedad98a5e7f5f = 'timeoriginalestimate';
const $81f079589240b9b7$export$358267065be1e = 'status';
const $81f079589240b9b7$export$dcaa788c7ada56de = 'statusCategory';
const $81f079589240b9b7$export$ebb48b08205007c5 = 'issuetype';
const $81f079589240b9b7$export$5e91047fe9955d0e = 'issuekey';
const $81f079589240b9b7$export$3b3d0889022c85b3 = 'children-issues';
const $81f079589240b9b7$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $81f079589240b9b7$export$8fe3d5be8cb17459 = 'epic-issues';
const $81f079589240b9b7$export$335851d83a79891 = 'hierarchy-level-below';
const $81f079589240b9b7$export$7b76bbcb87d41695 = 'com.atlassian.graphql:hierarchy-level-below';
const $81f079589240b9b7$export$297b67ac63f09f72 = 'hierarchy-level-above';
const $81f079589240b9b7$export$ae87161126086be = 'com.atlassian.graphql:hierarchy-level-above';
const $81f079589240b9b7$export$6a88420fc2f6901d = 'hierarchy-level-same-level';
const $81f079589240b9b7$export$ef1a0421bd42c0e4 = 'com.atlassian.graphql:hierarchy-level-same-level';
const $81f079589240b9b7$export$dd695c8c5ab62f9d = 'CUSTOMER_CONTEXT';
const $81f079589240b9b7$export$7b3d247435a784fa = 'SLA_PANEL';
const $81f079589240b9b7$export$17b7080ed1fe8cfd = 'LINKED_ALERTS';
const $81f079589240b9b7$export$29fe745131dad7ba = 'CHAT_CHANNEL';
const $81f079589240b9b7$export$9c245100c3091ec3 = 'MSTEAMS_CHANNEL';
const $81f079589240b9b7$export$51eb15cea47a37ba = 'ZOOM_MEETING';
const $81f079589240b9b7$export$c7ae0622b0bd5d56 = 'MANAGE_STAKEHOLDERS';
const $81f079589240b9b7$export$b5358afda8ff335e = 'KNOWLEDGE_BASE';
const $81f079589240b9b7$export$d2a475ff30e5bf97 = 'JOURNEY_PANEL';
const $81f079589240b9b7$export$63cf6f392da16c25 = 'ASSET_ONBOARDING';
const $81f079589240b9b7$export$22f61ccc2730431f = 'similar-issues';
const $81f079589240b9b7$export$8bbb446f57294715 = 'subtasks';
const $81f079589240b9b7$export$34fcd7cb291a1e4d = 'votes';
const $81f079589240b9b7$export$5e93f2a57cc4ca3a = 'parent';
const $81f079589240b9b7$export$be3891c8b47ab821 = 'parent-issue'; // Remove on FD-30157 clean-up
const $81f079589240b9b7$export$91a9dba2d38d9a6f = 'project';
const $81f079589240b9b7$export$df36fc05622c402 = 'worklog';
const $81f079589240b9b7$export$ede0a4c20124ec85 = 'timespent';
const $81f079589240b9b7$export$3eeb79d48fb5f667 = 'dataclassification';
const $81f079589240b9b7$export$45e72c9a63ab61ab = 'SENTIMENT';
const $81f079589240b9b7$export$f4909db381566ce3 = 'DETAILS_PANEL_IN_EDIT_MODE';
const $81f079589240b9b7$export$6159d4eb69c78696 = 'ARE_FIELDS_REORDERED';
const $81f079589240b9b7$export$962c5b8782b7a233 = 'HIDE_EMPTY_FIELDS';
const $81f079589240b9b7$export$99ad62164189f781 = 'ecosystemGlance';
const $81f079589240b9b7$export$7719ef6e9283671 = 'forgeGlance';
const $81f079589240b9b7$export$bfebea5ce2e1887a = 'ecosystemContext';
const $81f079589240b9b7$export$be8e68fb1aed253e = 'forgeContext';
const $81f079589240b9b7$export$84e5674890d55030 = 'issuerestriction';
const $81f079589240b9b7$export$326a5522a485e43d = 'security';
const $81f079589240b9b7$export$c9f3f01e2c535302 = 'securitylevel';
const $81f079589240b9b7$export$35e5652f764785bd = 'creator';
const $81f079589240b9b7$export$66519f3bbff1796a = 'team';
const $81f079589240b9b7$export$a4ee0bca77cc8463 = 'estimate';
const $81f079589240b9b7$export$fed53408e89e0497 = 'dueDate';
const $81f079589240b9b7$export$d53c26f9ce31f56b = 'targetStart';
const $81f079589240b9b7$export$48f82d653f85e459 = 'targetEnd';
const $81f079589240b9b7$export$ea5a888f39f722c7 = 'startDate';
const $81f079589240b9b7$export$f245bbec12cc0e40 = 'color';
const $81f079589240b9b7$export$aed630b4b7114a59 = 'attachment';
const $81f079589240b9b7$export$b50c1a8fef07104 = 'issuelinks';
const $81f079589240b9b7$export$ea3d72f4bb7738ba = 'timeestimate';
const $81f079589240b9b7$export$a4cab0124760d860 = 'comment';
const $81f079589240b9b7$export$734929aef118d7e2 = 'worklog';
const $81f079589240b9b7$export$ffbacacb07c1d46d = 'parent';
const $81f079589240b9b7$export$871661506c0a91ea = 'aggregatetimeoriginalestimate';
const $81f079589240b9b7$export$278c072e2f9176ab = 'aggregatetimespent';
const $81f079589240b9b7$export$4a7ecfe931ab6c07 = 'aggregatetimeestimate';
const $81f079589240b9b7$export$fbc5ebe2e580bf8b = 'progress';
const $81f079589240b9b7$export$aa3b37e271efd578 = 'aggregateprogress';
const $81f079589240b9b7$export$444bffe6526fb5f2 = 'workratio';
/**
 * Fields shown in the issue layout
 *
 * Cannot declare as simple object - in case there is a FF in getLayoutItemMap() (which happens when we add a new field), because we cannot get FF value in SSR.
 * Memoization is needed not to rerender too many times.
 */ const $81f079589240b9b7$var$getLayoutFieldTypesNonMemoized = ()=>{
    const types = {
        ASSIGNEE_TYPE: $81f079589240b9b7$export$fba8634fd401ba8b,
        DUE_DATE_TYPE: $81f079589240b9b7$export$b159f8b8f27aae4c,
        PRIORITY_TYPE: $81f079589240b9b7$export$34740f8d07d23ac0,
        REPORTER_TYPE: $81f079589240b9b7$export$a91aea2438afcce8,
        DESCRIPTION_TYPE: $81f079589240b9b7$export$5e7324042f1d6b31,
        LABELS_TYPE: $81f079589240b9b7$export$43b6e33ec70f2272,
        COMPONENTS_TYPE: $81f079589240b9b7$export$37abf56f13f61ec5,
        SPRINT_TYPE: $81f079589240b9b7$export$3d37701ba6fb68ec,
        STORY_POINTS_TYPE: $81f079589240b9b7$export$36fd22f47020f37b,
        TEAMS_PLATFORM_CF_TYPE: $81f079589240b9b7$export$269d70c1b1c9fb80,
        FIX_VERSIONS_TYPE: $81f079589240b9b7$export$a5c9f63aadcb220,
        AFFECTS_VERSIONS_TYPE: $81f079589240b9b7$export$94009605902e4fe5,
        TIME_ESTIMATE_TYPE: $81f079589240b9b7$export$c8bedad98a5e7f5f,
        TIME_TRACKING_TYPE: $81f079589240b9b7$export$ccb5ffefbf8b987c,
        ENVIRONMENT_TYPE: $81f079589240b9b7$export$113281d03e6830ef,
        DEV_SUMMARY_TYPE: $81f079589240b9b7$export$827a1c600bac12a3,
        APPROVALS_PANEL_TYPE: $81f079589240b9b7$export$7773375e72c953ed,
        KNOWLEDGE_BASE_TYPE: $81f079589240b9b7$export$b5358afda8ff335e,
        SLA_PANEL_TYPE: $81f079589240b9b7$export$7b3d247435a784fa,
        LINKED_ALERTS_TYPE: $81f079589240b9b7$export$17b7080ed1fe8cfd,
        CHAT_CHANNEL_TYPE: $81f079589240b9b7$export$29fe745131dad7ba,
        MSTEAMS_CHANNEL_TYPE: $81f079589240b9b7$export$9c245100c3091ec3,
        ZOOM_MEETING_TYPE: $81f079589240b9b7$export$51eb15cea47a37ba,
        MANAGE_STAKEHOLDERS_TYPE: $81f079589240b9b7$export$c7ae0622b0bd5d56,
        ASSETS_CF_TYPE: $81f079589240b9b7$export$ed2de20ab8b7ad3d,
        RESPONDERS_CF_TYPE: $81f079589240b9b7$export$bcf83e1d934501c9,
        MAJOR_INCIDENT_CF_TYPE: $81f079589240b9b7$export$ae0eeec12e90a01e,
        COLOR_CF_TYPE: $81f079589240b9b7$export$b4a1fbc1cf0059cf,
        EPIC_COLOR_TYPE: $81f079589240b9b7$export$4838a8a8d62a64fd,
        RELEASES_TYPE: $81f079589240b9b7$export$e9ba671d077969f8,
        BASELINE_START_CF_TYPE: $81f079589240b9b7$export$d10d66823a65e688,
        BASELINE_END_CF_TYPE: $81f079589240b9b7$export$dfc6da4a9963d5dc,
        LABELS_CF_TYPE: $81f079589240b9b7$export$ad4eb83f78528e13,
        TEXT_CF_TYPE: $81f079589240b9b7$export$68c7e01d5460d298,
        MULTI_USER_CF_TYPE: $81f079589240b9b7$export$5365f2d3fac5261a,
        PARTICIPANTS_CF_TYPE: $81f079589240b9b7$export$cc8ffff49170b0f4,
        URL_CF_TYPE: $81f079589240b9b7$export$60f0bd6e4b582fe6,
        NUMBER_CF_TYPE: $81f079589240b9b7$export$c7faa96db185cfc6,
        STORY_POINT_ESTIMATE_CF_TYPE: $81f079589240b9b7$export$492b0fa4fe201a22,
        SELECT_CF_TYPE: $81f079589240b9b7$export$22ac48a51c014e4b,
        EPIC_STATUS_TYPE: $81f079589240b9b7$export$6769c2c97b828e11,
        MULTI_SELECT_CF_TYPE: $81f079589240b9b7$export$c5d13ea26562d57a,
        ECOSYSTEM_GLANCE_TYPE: $81f079589240b9b7$export$99ad62164189f781,
        FORGE_CUSTOM_FIELD_TYPE: $81f079589240b9b7$export$798d2f5814884447,
        ISSUE_FIELD_USER_CF_TYPE: $81f079589240b9b7$export$5600354b43577e17,
        ISSUE_FIELD_GROUPS_CF_TYPE: $81f079589240b9b7$export$eb39592ba5247ee7,
        ISSUE_FIELD_STRINGS_CF_TYPE: $81f079589240b9b7$export$f48a9be226105736,
        FORGE_GLANCE_TYPE: $81f079589240b9b7$export$7719ef6e9283671,
        TEXT_AREA_CF_TYPE: $81f079589240b9b7$export$39cd48613b53ce2f,
        MULTI_VERSION_CF_TYPE: $81f079589240b9b7$export$39866626496bbfc8,
        VERSION_CF_TYPE: $81f079589240b9b7$export$24382b4e8c58336b,
        DATE_CF_TYPE: $81f079589240b9b7$export$ff745f432984005d,
        GROUP_CF_TYPE: $81f079589240b9b7$export$b075907882e80160,
        MULTI_GROUP_CF_TYPE: $81f079589240b9b7$export$b600addfa3355c57,
        USER_CF_TYPE: $81f079589240b9b7$export$c491a4b98394028e,
        DATETIME_CF_TYPE: $81f079589240b9b7$export$42d097f7b1622ef1,
        MULTI_CHECKBOXES_CF_TYPE: $81f079589240b9b7$export$5280e5501a801dc0,
        RADIO_BUTTONS_CF_TYPE: $81f079589240b9b7$export$65524be5675e57e6,
        TEAM_CF_TYPE: $81f079589240b9b7$export$eb1f1dca13a0f02d,
        ISSUE_FIELD_NUMBER_CF_TYPE: $81f079589240b9b7$export$bc917bc699b25f75,
        ISSUE_FIELD_DATETIME_CF_TYPE: $81f079589240b9b7$export$ce9bfd823c7e1a6d,
        ISSUE_FIELD_STRING_CF_TYPE: $81f079589240b9b7$export$5f26ca419fdffbe7,
        ISSUE_FIELD_SINGLE_SELECT_CF_TYPE: $81f079589240b9b7$export$b20fbcacd7942c2a,
        ISSUE_FIELD_MULTI_SELECT_CF_TYPE: $81f079589240b9b7$export$f25cd4907cbb25b9,
        REQUEST_TYPE_CF_TYPE: $81f079589240b9b7$export$6da975fce1fbd38e,
        SERVICE_ENTITY_CF_TYPE: $81f079589240b9b7$export$b755e97dbfa92610,
        REQUEST_PARTICIPANTS_CF_TYPE: $81f079589240b9b7$export$1be1ecd4dfc06fab,
        ORGANIZATIONS_CF_TYPE: $81f079589240b9b7$export$34317c2d84a93553,
        REQUEST_FEEDBACK_CF_TYPE: $81f079589240b9b7$export$1f2859a3ef701a14,
        PEOPLE_CF_TYPE: $81f079589240b9b7$export$fb431e758c9252df,
        REQUEST_LANGUAGE_CF_TYPE: $81f079589240b9b7$export$555b4f35f98a3210,
        ASSET_ONBOARDING_TYPE: $81f079589240b9b7$export$63cf6f392da16c25,
        APPROVERS_LIST_CF_TYPE: $81f079589240b9b7$export$c6dd874aae21e51f,
        CASCADING_SELECT_CF_TYPE: $81f079589240b9b7$export$c3c9f8a8a8dc0b30,
        PROJECT_PICKER_CF_TYPE: $81f079589240b9b7$export$65a6076c0927d413,
        CMDB_OBJECT_CF_TYPE: $81f079589240b9b7$export$3b5a62bb34372404,
        READ_ONLY_CF_TYPE: $81f079589240b9b7$export$247829aef464243f,
        MESSAGE_VIEW_CF_TYPE: $81f079589240b9b7$export$21dda64db57e4883,
        MESSAGE_EDIT_CF_TYPE: $81f079589240b9b7$export$45700f3bf92a003a,
        EPIC_NAME_TYPE: $81f079589240b9b7$export$dfc63737b8c0150d,
        ECOSYSTEM_CONTEXT_TYPE: $81f079589240b9b7$export$bfebea5ce2e1887a,
        CATEGORY_TYPE: $81f079589240b9b7$export$3c7d8923295a5199,
        ENTITLEMENT_CF_TYPE: $81f079589240b9b7$export$c23f6b40da18371a,
        GOALS_CF_TYPE: $81f079589240b9b7$export$2bbb7f69c97ea279,
        PARENT_TYPE: $81f079589240b9b7$export$5e93f2a57cc4ca3a,
        FORGE_CONTEXT_TYPE: $81f079589240b9b7$export$be8e68fb1aed253e,
        SENTIMENT_CF_TYPE: $81f079589240b9b7$export$c23cfbdf83daa90d
    };
    Object.assign(types, {
        SENTIMENT_TYPE: $81f079589240b9b7$export$45e72c9a63ab61ab
    });
    if ((0, $4R6GH.fg)('jsm-journey-builder-in-issue-view')) Object.assign(types, {
        JOURNEY_PANEL_TYPE: $81f079589240b9b7$export$d2a475ff30e5bf97
    });
    return types;
};
const $81f079589240b9b7$export$3c3e26aadbfa2c32 = (0, $8QpSo.default)($81f079589240b9b7$var$getLayoutFieldTypesNonMemoized);

});


parcelRegister("gl0PU", function(module, exports) {

$parcel$export(module.exports, "toErrorId", () => $b5e194c6e2cc34cd$export$706bbe4209d93dfe);
$parcel$export(module.exports, "toErrorMessage", () => $b5e194c6e2cc34cd$export$95506c204c060a3);
// Package name to be used in famaCatchAndLogFetchError and logError utils
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

const $b5e194c6e2cc34cd$export$706bbe4209d93dfe = (id)=>id;
const $b5e194c6e2cc34cd$export$95506c204c060a3 = (message)=>message;

});

parcelRegister("1RLjE", function(module, exports) {

$parcel$export(module.exports, "logError", () => $b0fc9ceb76f86c8e$export$58da9968c3170cb1);

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");
const $b0fc9ceb76f86c8e$export$58da9968c3170cb1 = (packageName, errorId, message, error, attributes)=>{
    // Send error log to analytics pipeline (i.e. SFX) and Sentry
    (0, $jcw0u.default)({
        meta: {
            packageName: packageName,
            id: errorId,
            teamName: 'morphinecake'
        },
        attributes: {
            ...attributes,
            message: message
        },
        error: error
    });
    // Send error log to Splunk
    // We use this instead of `sendToPrivacyUnsafeSplunk` to preserve error message and custom properties
    const location = `${packageName}.${errorId}`;
    (0, $2YZCu.default).unsafeErrorWithCustomerData(location, message, error);
};

});




parcelRegister("1XqXD", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsWidgetRouteEntry", () => $a95971dddf0af763$export$dcfc82c90a86b038);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $d9ukL = parcelRequire("d9ukL");

var $6Z2mh = parcelRequire("6Z2mh");

var $b0cvA = parcelRequire("b0cvA");

var $b2cnG = parcelRequire("b2cnG");
const $a95971dddf0af763$export$dcfc82c90a86b038 = (0, $7NszV.createEntry)((0, $d9ukL.projectSettingsServicedeskChannelsWidgetRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $b0cvA.widgetsNextGenRedirect),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $b2cnG.LazyProjectSettingsServiceDeskWidgetSettings)
        ]
    }));

});
parcelRegister("b0cvA", function(module, exports) {

$parcel$export(module.exports, "widgetsNextGenRedirect", () => $1ae3adbbf5c00734$export$8ba256148f9b998f);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
const $1ae3adbbf5c00734$export$8ba256148f9b998f = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/widget`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: url
    });
};

});

parcelRegister("b2cnG", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskWidgetSettings", () => $bf4d9e5ccdf213aa$export$216a049c4d917b0);
$parcel$export(module.exports, "default", () => $bf4d9e5ccdf213aa$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $bf4d9e5ccdf213aa$export$216a049c4d917b0 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("2EBYc")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-widget-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bf4d9e5ccdf213aa$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $bf4d9e5ccdf213aa$export$216a049c4d917b0,
        pageId: "project-settings-widget-settings",
        shouldShowSpinner: true
    });

});
parcelRegister("2EBYc", function(module, exports) {

let $1eecc537e4997e50$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1eecc537e4997e50$var$load("67JWT").then(()=>parcelRequire('dO6p9'));

});



parcelRegister("gXApH", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChatRouteEntry", () => $30ca084fd423718b$export$f030ac1baa84c682);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $2I1zE = parcelRequire("2I1zE");

var $6Z2mh = parcelRequire("6Z2mh");

var $5qwUl = parcelRequire("5qwUl");
const $30ca084fd423718b$export$f030ac1baa84c682 = (0, $7NszV.createEntry)((0, $2I1zE.projectSettingsServicedeskChatRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $5qwUl.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5qwUl.LazyProjectSettingsServiceDeskChatSettings)
        ]
    }));

});

parcelRegister("jjqkz", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskClassicAppsRouteEntry", () => $626e75f8ec29a06e$export$aba71c4218b643ad);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $4P4Lq = parcelRequire("4P4Lq");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $hKH9R = parcelRequire("hKH9R");

var $j9RuP = parcelRequire("j9RuP");

var $01LdL = parcelRequire("01LdL");
const $626e75f8ec29a06e$export$aba71c4218b643ad = (0, $7NszV.createEntry)((0, $4P4Lq.projectSettingsServicedeskClassicAppsRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.app-discovery',
        component: (0, $j9RuP.ConnectAppsRedirect)(`/jira/${(0, $01LdL.SERVICE_DESK_PRODUCT)}`),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        isRedirect: true,
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hKH9R.LazyAppDiscoverySettings)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).APP_DISCOVERY,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).APP_DISCOVERY),
                teamName: 'it-solutions-hermes'
            }
        }
    }));

});

parcelRegister("h4Pr8", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskCustomerNotificationsRouteEntry", () => $90cce0d970ed183f$export$5a4abc64d2a82698);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $1XuFh = parcelRequire("1XuFh");

var $6Z2mh = parcelRequire("6Z2mh");

var $hASB6 = parcelRequire("hASB6");
const $90cce0d970ed183f$export$5a4abc64d2a82698 = (0, $7NszV.createEntry)((0, $1XuFh.projectSettingsServicedeskCustomerNotificationsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $hASB6.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hASB6.LazyProjectSettingsServiceDeskCustomerNotifications)
        ]
    }));

});
parcelRegister("hASB6", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskCustomerNotifications", () => $6081b8204512e323$export$c763ea321ade5f68);
$parcel$export(module.exports, "default", () => $6081b8204512e323$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kKHTt = parcelRequire("kKHTt");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $6081b8204512e323$export$c763ea321ade5f68 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("7rpJm")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-customer-notifications/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6081b8204512e323$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kKHTt.HelpCenterSettingsRedirect), {
        page: "customer-notifications"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $6081b8204512e323$export$c763ea321ade5f68,
        pageId: "project-settings-customer-notifications",
        shouldShowSpinner: true
    }));

});
parcelRegister("7rpJm", function(module, exports) {

let $56af039c638807c6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $56af039c638807c6$var$load("denwG").then(()=>parcelRequire('jp5Rx'));

});



parcelRegister("28AFT", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskCustomerPermissionsRouteEntry", () => $35c7869995fcce58$export$ed034e5245184767);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $fpjJX = parcelRequire("fpjJX");

var $10cgn = parcelRequire("10cgn");

var $fdCkK = parcelRequire("fdCkK");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $aZDos = parcelRequire("aZDos");
const $35c7869995fcce58$export$ed034e5245184767 = (0, $7NszV.createEntry)((0, $fdCkK.projectSettingsServicedeskCustomerPermissionsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $aZDos.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $dxCvy.projectContextResource),
            (0, $10cgn.customerPermissionsPageDataResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aZDos.LazyProjectSettingsServiceDeskCustomerPermissions)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).CUSTOMER_PERMISSIONS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).CUSTOMER_PERMISSIONS),
                teamName: 'jsd-flux-capacitors'
            }
        },
        perfMetricKey: 'jsm-customer-permissions'
    }));

});

parcelRegister("dyGLN", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskDataClassificationsRouteEntry", () => $245c81b9a56de56f$export$5cea2172fd288382);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $jqtuR = parcelRequire("jqtuR");

var $6Z2mh = parcelRequire("6Z2mh");

var $jaAyo = parcelRequire("jaAyo");

var $6h9hV = parcelRequire("6h9hV");
const $245c81b9a56de56f$export$5cea2172fd288382 = (0, $7NszV.createEntry)((0, $jqtuR.projectSettingsServicedeskDataClassificationsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $6h9hV.default),
        skeleton: (0, $jaAyo.ProjectSettingsDetailsSkeleton),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6h9hV.LazyDataClassificationsSettings)
        ]
    }));

});
parcelRegister("jqtuR", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskDataClassificationsRoute", () => $42b53ec38758c5f7$export$ec4d4f6583272cd);
const $42b53ec38758c5f7$export$ec4d4f6583272cd = {
    name: 'project-settings-servicedesk-data-classifications',
    path: '/jira/servicedesk/projects/:projectKey/settings/data-classifications',
    exact: true
};

});

parcelRegister("6h9hV", function(module, exports) {

$parcel$export(module.exports, "LazyDataClassificationsSettings", () => $953aed1c2ae3d2f5$export$b8abcf8aa8f4df56);
$parcel$export(module.exports, "default", () => $953aed1c2ae3d2f5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $953aed1c2ae3d2f5$export$b8abcf8aa8f4df56 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("foQoc"))), {
    moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$953aed1c2ae3d2f5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $953aed1c2ae3d2f5$export$b8abcf8aa8f4df56,
        pageId: "project-settings-data-classifications",
        shouldShowSpinner: false
    });

});


parcelRegister("7xqQs", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskDetailsRouteEntry", () => $ec64aa09583181df$export$6b37ff6fd616f383);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $7T78N = parcelRequire("7T78N");

var $6Z2mh = parcelRequire("6Z2mh");

var $jaAyo = parcelRequire("jaAyo");

var $bYT90 = parcelRequire("bYT90");
const $ec64aa09583181df$export$6b37ff6fd616f383 = (0, $7NszV.createEntry)((0, $7T78N.projectSettingsServicedeskDetailsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $bYT90.default),
        skeleton: (0, $jaAyo.ProjectSettingsDetailsSkeleton),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bYT90.LazyDetailsSettings)
        ]
    }));

});
parcelRegister("7T78N", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskDetailsRoute", () => $68e7499c720861f2$export$23583c23687c31c7);
const $68e7499c720861f2$export$23583c23687c31c7 = {
    name: 'project-settings-servicedesk-details',
    // /settings/details
    path: '/jira/servicedesk/projects/:projectKey/settings/details',
    exact: true
};

});

parcelRegister("bYT90", function(module, exports) {

$parcel$export(module.exports, "LazyDetailsSettings", () => $3746e6592757d8dd$export$6f16b5efddd5c646);
$parcel$export(module.exports, "default", () => $3746e6592757d8dd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $3746e6592757d8dd$export$6f16b5efddd5c646 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("eC5lK"))), {
    moduleId: "./src/packages/spa-apps/project-settings/details/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3746e6592757d8dd$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3746e6592757d8dd$export$6f16b5efddd5c646,
        pageId: "project-settings-details",
        shouldShowSpinner: false
    });

});


parcelRegister("g3Gvc", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskEmailRouteEntry", () => $0634a6ceff42062d$export$676e8af036d3e9c1);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $i62iX = parcelRequire("i62iX");

var $6Z2mh = parcelRequire("6Z2mh");

var $3VKX1 = parcelRequire("3VKX1");
const $0634a6ceff42062d$export$676e8af036d3e9c1 = (0, $7NszV.createEntry)((0, $i62iX.projectSettingsServicedeskEmailRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.settings.email-channels',
        component: (0, $3VKX1.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3VKX1.LazyProjectSettingsServiceDeskEmail)
        ]
    }));

});

parcelRegister("3wbIE", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskExternalLinksRouteEntry", () => $95680d22988b2454$export$ca80e1d474f774d4);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $fpjJX = parcelRequire("fpjJX");

var $6sNnq = parcelRequire("6sNnq");

var $eObGp = parcelRequire("eObGp");

var $6Z2mh = parcelRequire("6Z2mh");

var $aV9OB = parcelRequire("aV9OB");
const $95680d22988b2454$export$ca80e1d474f774d4 = (0, $7NszV.createEntry)((0, $eObGp.projectSettingsServicedeskExternalLinksRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $aV9OB.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $dxCvy.projectContextResource),
            (0, $6sNnq.featuresResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aV9OB.LazyProjectSettingsServiceDeskExternalLinks)
        ],
        perfMetricKey: 'jsm-external-resources'
    }));

});
parcelRegister("aV9OB", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskExternalLinks", () => $15bcce9a01d18cfd$export$28482a53859ec466);
$parcel$export(module.exports, "default", () => $15bcce9a01d18cfd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $15bcce9a01d18cfd$export$28482a53859ec466 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("fMLOq"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-external-links/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$15bcce9a01d18cfd$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $15bcce9a01d18cfd$export$28482a53859ec466,
        pageId: "project-settings-external-links",
        shouldShowSpinner: true
    });

});
parcelRegister("fMLOq", function(module, exports) {

let $b7e06d383c642301$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b7e06d383c642301$var$load("cdxh0").then(()=>parcelRequire('7iBoV'));

});



parcelRegister("7fwfr", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskFeedbackRouteEntry", () => $e67580ab8b50900d$export$5c0731470c0dc065);

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6z8e6 = parcelRequire("6z8e6");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $7Txnp = parcelRequire("7Txnp");

var $7zcmB = parcelRequire("7zcmB");
const $e67580ab8b50900d$export$5c0731470c0dc065 = (0, $7NszV.createEntry)((0, $6z8e6.projectSettingsServicedeskFeedbackRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $7zcmB.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $7zcmB.LazyProjectSettingsServiceDeskFeedbackSettings),
            (0, $7Txnp.LazyCsatSettingsPage)
        ],
        perfMetricKey: 'jsm-feedback-settings',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).CSAT_CONFIG,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).CSAT_CONFIG),
                teamName: 'jsm-request-intake'
            }
        }
    }));

});
parcelRegister("7Txnp", function(module, exports) {

$parcel$export(module.exports, "LoadingComponent", () => $42f73bbf4237dc1b$export$7db30d367db7d20a);
$parcel$export(module.exports, "LazyCsatSettingsPage", () => $42f73bbf4237dc1b$export$32eb62914bae0e84);
/* async.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");

var $kxZPA = parcelRequire("kxZPA");
const $42f73bbf4237dc1b$export$7db30d367db7d20a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($42f73bbf4237dc1b$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "large"
    }));

const $42f73bbf4237dc1b$export$32eb62914bae0e84 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("91zvd")), {
    moduleId: "./src/packages/servicedesk/csat/src/index.tsx"
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $42f73bbf4237dc1b$var$SpinnerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i68cl",
            __cmplp.className
        ])
    });
});

});
parcelRegister("91zvd", function(module, exports) {

let $691fbf17fd30d01e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $691fbf17fd30d01e$var$load("8bdOt").then(()=>parcelRequire('hX8BJ'));

});


parcelRegister("7zcmB", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskFeedbackSettings", () => $4b8db06fa1ed7bd1$export$ff54bec6c7cb7d47);
$parcel$export(module.exports, "default", () => $4b8db06fa1ed7bd1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");
const $4b8db06fa1ed7bd1$export$3fac45fa34d00981 = 'project/service-desk/settings/index';
const $4b8db06fa1ed7bd1$export$1aa47348ef6dbdda = 'project/service-desk/settings';

const $4b8db06fa1ed7bd1$export$ff54bec6c7cb7d47 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("90tUm")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-feedback-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4b8db06fa1ed7bd1$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $4b8db06fa1ed7bd1$export$ff54bec6c7cb7d47,
        pageId: "project-settings-feedback-settings",
        shouldShowSpinner: true
    });

});
parcelRegister("90tUm", function(module, exports) {

let $68eb5040a1e7ed9e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $68eb5040a1e7ed9e$var$load("1ierf").then(()=>parcelRequire('d3uR0'));

});



parcelRegister("peO7W", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskFieldsRouteEntry", () => $3c9b84b0d48a58a6$export$8a5eabbb292c5b39);

var $ffza4 = parcelRequire("ffza4");

var $7XYc4 = parcelRequire("7XYc4");

var $lmyls = parcelRequire("lmyls");


var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $e7C7O = parcelRequire("e7C7O");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $coidL = parcelRequire("coidL");

var $6Z2mh = parcelRequire("6Z2mh");

var $6s1PB = parcelRequire("6s1PB");

var $3sOmz = parcelRequire("3sOmz");
const $3c9b84b0d48a58a6$var$isEfaExperimentExposed = ()=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('efa_and_project_fields_page_for_tmp');
    return expConfig.get('isEnabled', false);
};
const $3c9b84b0d48a58a6$export$8a5eabbb292c5b39 = (0, $7NszV.createEntry)((0, $coidL.projectSettingsServicedeskFieldsRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'project-settings.fields.jsm-tmp',
        component: (0, $7XYc4.componentWithCondition)($3c9b84b0d48a58a6$var$isEfaExperimentExposed, (0, $3sOmz.default), (0, $5lsNZ.default)),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $e7C7O.fieldSettingsRelayResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3sOmz.LazyFieldsSettings)
        ]
    }));

});
parcelRegister("3sOmz", function(module, exports) {

$parcel$export(module.exports, "LazyFieldsSettings", () => $c77ac9be273e47d5$export$e309780f520d125a);
$parcel$export(module.exports, "default", () => $c77ac9be273e47d5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $c77ac9be273e47d5$export$e309780f520d125a = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("cqfV9"))), {
    moduleId: "./src/packages/spa-apps/project-settings/fields/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c77ac9be273e47d5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $c77ac9be273e47d5$export$e309780f520d125a,
        pageId: "project-settings-fields",
        shouldShowSpinner: true
    });

});


parcelRegister("gUdrp", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskForgeAppsRouteEntry", () => $b86b6dad0a03dbe6$export$58e3b68d22b7a42b);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $8L6oT = parcelRequire("8L6oT");

var $6Z2mh = parcelRequire("6Z2mh");

var $5bkvv = parcelRequire("5bkvv");

var $dxCvy = parcelRequire("dxCvy");

var $bUhjF = parcelRequire("bUhjF");
const $b86b6dad0a03dbe6$export$58e3b68d22b7a42b = (0, $7NszV.createEntry)((0, $8L6oT.projectSettingsServicedeskForgeAppsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $bUhjF.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $dxCvy.projectContextResourceWithCache),
            (0, $5bkvv.forgeProjectSettingsModuleResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bUhjF.LazyForgeProjectSettingsPage)
        ]
    }));

});
parcelRegister("8L6oT", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskForgeAppsRoute", () => $b9987e58af4bd5dd$export$10bafd1256118bb8);
const $b9987e58af4bd5dd$export$10bafd1256118bb8 = {
    name: 'project-settings-servicedesk-forge-apps',
    path: '/jira/servicedesk/projects/:projectKey/settings/apps/:appId/:envId/:route?'
};

});

parcelRegister("bUhjF", function(module, exports) {

$parcel$export(module.exports, "LazyForgeProjectSettingsPage", () => $d4e28d950e086fee$export$ef66d3f49a9953d8);
$parcel$export(module.exports, "default", () => $d4e28d950e086fee$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $d4e28d950e086fee$export$ef66d3f49a9953d8 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("bZbyt")), {
    moduleId: "./src/packages/spa-apps/forge/project-settings/src/index.tsx"
});
const $d4e28d950e086fee$export$b943f48844c671a5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d4e28d950e086fee$export$ef66d3f49a9953d8,
        pageId: "forge-spa-project-settings",
        shouldShowSpinner: true
    });
var $d4e28d950e086fee$export$2e2bcd8739ae039 = $d4e28d950e086fee$export$b943f48844c671a5;

});


parcelRegister("3M4hq", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskIncidentManagementRouteEntry", () => $959537c21f89ae37$export$95a73b5db67dd70a);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $cAofY = parcelRequire("cAofY");

var $jHXos = parcelRequire("jHXos");

var $6Z2mh = parcelRequire("6Z2mh");

var $3uo46 = parcelRequire("3uo46");
const $959537c21f89ae37$export$95a73b5db67dd70a = (0, $7NszV.createEntry)((0, $jHXos.projectSettingsServicedeskIncidentManagementRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $3uo46.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $cAofY.serviceDeskContextResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3uo46.LazyProjectSettingsServiceDeskIncidentManagement)
        ]
    }));

});
parcelRegister("3uo46", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskIncidentManagement", () => $74652d26314b4bbc$export$7796b6d080b8c187);
$parcel$export(module.exports, "default", () => $74652d26314b4bbc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $74652d26314b4bbc$export$7796b6d080b8c187 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("83npX"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-incident-management-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$74652d26314b4bbc$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $74652d26314b4bbc$export$7796b6d080b8c187,
        pageId: "project-settings-incident-management",
        shouldShowSpinner: true
    });

});
parcelRegister("83npX", function(module, exports) {

let $5dd0c4ce28f934ad$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $5dd0c4ce28f934ad$var$load("ffQaD"),
    $5dd0c4ce28f934ad$var$load("kvRbA"),
    $5dd0c4ce28f934ad$var$load("fliVL"),
    $5dd0c4ce28f934ad$var$load("ijYee")
]).then(()=>parcelRequire('gZiIg'));

});



parcelRegister("drVWM", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskInternalNotificationsNextGenRouteEntry", () => $a5004afda5310874$export$dfcd097af0ecd961);

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $h6YNW = parcelRequire("h6YNW");

var $6Z2mh = parcelRequire("6Z2mh");

var $f8FqB = parcelRequire("f8FqB");

var $jNJyR = parcelRequire("jNJyR");
const $a5004afda5310874$export$dfcd097af0ecd961 = (0, $7NszV.createEntry)((0, $h6YNW.projectSettingsServicedeskInternalNotificationsNextGenRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.internal-notifications',
        component: (0, $jNJyR.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jNJyR.LazyProjectSettingsServiceDeskInternalNotifications),
            (0, $f8FqB.LazyInternalNotificationSettingsPage)
        ]
    }));

});
parcelRegister("f8FqB", function(module, exports) {

$parcel$export(module.exports, "LazyInternalNotificationSettingsPage", () => $c99d86239fe70688$export$501979bd6d492c43);

var $kxZPA = parcelRequire("kxZPA");

const $c99d86239fe70688$export$501979bd6d492c43 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("1R31W")), {
    moduleId: "./src/packages/servicedesk/notification-internal/src/ui/index.tsx"
});

});
parcelRegister("1R31W", function(module, exports) {

let $159d17766285f7f8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $159d17766285f7f8$var$load("2oZWs").then(()=>parcelRequire('ZHF20'));

});


parcelRegister("jNJyR", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskInternalNotifications", () => $1956b65a2446b925$export$9c9d293dc6de29d0);
$parcel$export(module.exports, "default", () => $1956b65a2446b925$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $1956b65a2446b925$export$9c9d293dc6de29d0 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("4izHY"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-internal-notifications/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1956b65a2446b925$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $1956b65a2446b925$export$9c9d293dc6de29d0,
        pageId: "project-settings-internal-notifications",
        shouldShowSpinner: true
    });

});
parcelRegister("4izHY", function(module, exports) {

let $32148ac1c0860cb0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $32148ac1c0860cb0$var$load("bJipY").then(()=>parcelRequire('apjAt'));

});



parcelRegister("f1JiD", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskIssuetypesRouteEntry", () => $0936f5888a81e879$export$cf4a5eaa3cb7522f);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6EgCy = parcelRequire("6EgCy");

var $6Z2mh = parcelRequire("6Z2mh");

var $5EbkJ = parcelRequire("5EbkJ");

var $cDJku = parcelRequire("cDJku");
const $0936f5888a81e879$export$cf4a5eaa3cb7522f = (0, $7NszV.createEntry)((0, $6EgCy.projectSettingsServicedeskIssuetypesRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: (0, $cDJku.getUFOName)('project-settings-servicedesk-issuetypes'),
        component: (0, $5EbkJ.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5EbkJ.LazyIssueTypeSettings)
        ]
    }));

});
parcelRegister("5EbkJ", function(module, exports) {

$parcel$export(module.exports, "LazyIssueTypeSettings", () => $9d365377dbe2cbf1$export$36dcfb52d47cb93a);
$parcel$export(module.exports, "default", () => $9d365377dbe2cbf1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $9d365377dbe2cbf1$export$36dcfb52d47cb93a = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("7a4qW"))), {
    moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9d365377dbe2cbf1$export$2e2bcd8739ae039 = ({ match: match })=>{
    const { issueTypeId: issueTypeId } = match.params;
    // unique pageId need to be set so that ApdexProvider would properly reset all the performance marks when switching between issue types
    const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $9d365377dbe2cbf1$export$36dcfb52d47cb93a,
        pageId: pageId,
        shouldShowSpinner: false
    });
};

});

parcelRegister("cDJku", function(module, exports) {

$parcel$export(module.exports, "getUFOName", () => $3eab64ae9fcc418e$export$759ec9adbd19c936);
const $3eab64ae9fcc418e$var$ufoNamesMap = {
    'project-settings-software-issuetypes': 'project-settings.issue-type.jsw-tmp',
    'project-settings-servicedesk-issuetypes': 'project-settings.issue-type.jsm-tmp'
};
const $3eab64ae9fcc418e$export$759ec9adbd19c936 = (name)=>$3eab64ae9fcc418e$var$ufoNamesMap[name] || name;

});


parcelRegister("138gn", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskIssuetypesWorkflowRouteEntry", () => $f2cb7e5eb7db4222$export$a6c573e3904e9dbd);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $63HTu = parcelRequire("63HTu");

var $6Z2mh = parcelRequire("6Z2mh");

var $5EbkJ = parcelRequire("5EbkJ");

var $3i9aq = parcelRequire("3i9aq");
const $f2cb7e5eb7db4222$export$a6c573e3904e9dbd = (0, $7NszV.createEntry)((0, $63HTu.projectSettingsServicedeskIssuetypesWorkflowRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $3i9aq.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5EbkJ.LazyIssueTypeSettings)
        ]
    }));

});
parcelRegister("63HTu", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskIssuetypesWorkflowRoute", () => $c901967b54883cb1$export$959cd36cc49d3b76);
const $c901967b54883cb1$export$959cd36cc49d3b76 = {
    name: 'project-settings-servicedesk-issuetypes-workflow',
    path: '/jira/servicedesk/projects/:projectKey/settings/issuetypes/:issueTypeId/:initialSection(workflow)',
    exact: true
};

});

parcelRegister("3i9aq", function(module, exports) {

$parcel$export(module.exports, "default", () => $55da4849dbdf5d52$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $55da4849dbdf5d52$export$cb608e3696682e76 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("gEQDq"))), {
    moduleId: "./src/packages/spa-apps/project-settings/workflow-navigation/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$55da4849dbdf5d52$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $55da4849dbdf5d52$export$cb608e3696682e76,
        pageId: "project-settings-workflow-navigation",
        shouldShowSpinner: false
    });

});


parcelRegister("gwCoT", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskItsmFeaturesRouteEntry", () => $8c26b195513d6c20$export$40ca23d1e05da300);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6sNnq = parcelRequire("6sNnq");

var $jP54v = parcelRequire("jP54v");

var $6Z2mh = parcelRequire("6Z2mh");

var $bz1sy = parcelRequire("bz1sy");
const $8c26b195513d6c20$export$40ca23d1e05da300 = (0, $7NszV.createEntry)((0, $jP54v.projectSettingsServicedeskItsmFeaturesRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'jsm-features-settings',
        component: (0, $bz1sy.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $6sNnq.featuresResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bz1sy.LazyProjectSettingsServiceDeskItsmFeatures)
        ],
        perfMetricKey: 'jsm-features-settings'
    }));

});
parcelRegister("jP54v", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskItsmFeaturesRoute", () => $444365caa1de116d$export$e60ffa2990540464);
const $444365caa1de116d$export$e60ffa2990540464 = {
    name: 'project-settings-servicedesk-itsm-features',
    path: '/jira/servicedesk/projects/:projectKey/settings/itsm-features',
    exact: true
};

});

parcelRegister("bz1sy", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskItsmFeatures", () => $402e11ff5e131d95$export$562be1021beb9882);
$parcel$export(module.exports, "default", () => $402e11ff5e131d95$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $402e11ff5e131d95$export$562be1021beb9882 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("k759J"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-itsm-features/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$402e11ff5e131d95$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $402e11ff5e131d95$export$562be1021beb9882,
        pageId: "project-settings-itsm-features",
        shouldShowSpinner: true
    });

});
parcelRegister("k759J", function(module, exports) {

let $ea4875f0b72a5716$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ea4875f0b72a5716$var$load("3aFI2").then(()=>parcelRequire('dWAhE'));

});



parcelRegister("kkXdG", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskItsmTicketTypeFieldsRouteEntry", () => $2aef83b11784cadf$export$49692fb0973d60ca);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $eUvlM = parcelRequire("eUvlM");

var $gfgJe = parcelRequire("gfgJe");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $bO6K2 = parcelRequire("bO6K2");
const $2aef83b11784cadf$export$49692fb0973d60ca = (0, $7NszV.createEntry)((0, $gfgJe.projectSettingsServicedeskItsmTicketTypeFieldsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $bO6K2.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $eUvlM.servicedeskPracticesResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bO6K2.LazyProjectSettingsServiceDeskTicketTypeFields)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).REQUEST_TYPE_FIELDS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).REQUEST_TYPE_FIELDS),
                teamName: 'jsd-shield'
            }
        },
        ufoName: 'project-settings-servicedesk-ticket-type-fields'
    }));

});
parcelRegister("gfgJe", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskItsmTicketTypeFieldsRoute", () => $e91beb008e9026ec$export$1af0541fcb95547b);
const $e91beb008e9026ec$export$1af0541fcb95547b = {
    exact: true,
    name: 'project-settings-servicedesk-itsm-ticket-type-fields',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types/category/:practice/request-type/:requestTypeId/:tabKey?'
};

});

parcelRegister("bO6K2", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskTicketTypeFields", () => $e9f2572a89172526$export$471040ce01e559fc);
$parcel$export(module.exports, "default", () => $e9f2572a89172526$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kKHTt = parcelRequire("kKHTt");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $e9f2572a89172526$export$471040ce01e559fc = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("bfWUt")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-ticket-type-fields/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e9f2572a89172526$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kKHTt.HelpCenterSettingsRedirect), {
        page: "ticket-type-fields"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e9f2572a89172526$export$471040ce01e559fc,
        pageId: "project-settings-ticket-type-fields",
        shouldShowSpinner: true
    }));

});
parcelRegister("bfWUt", function(module, exports) {

let $831ecaaf536bca50$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $831ecaaf536bca50$var$load("ffQaD"),
    $831ecaaf536bca50$var$load("kvRbA"),
    $831ecaaf536bca50$var$load("blL1z")
]).then(()=>parcelRequire('73hU9'));

});



parcelRegister("bl8cB", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskItsmTicketTypesConfigRouteEntry", () => $1761f8f0b85b3339$export$9f40815b933b51ba);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $2pT4g = parcelRequire("2pT4g");

var $dxCvy = parcelRequire("dxCvy");

var $fpjJX = parcelRequire("fpjJX");

var $k8jl5 = parcelRequire("k8jl5");

var $1cpsA = parcelRequire("1cpsA");

var $eUvlM = parcelRequire("eUvlM");

var $6sNnq = parcelRequire("6sNnq");

var $j9HCv = parcelRequire("j9HCv");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $dEPxR = parcelRequire("dEPxR");

var $lkFvK = parcelRequire("lkFvK");

var $4stgq = parcelRequire("4stgq");
const $1761f8f0b85b3339$var$projectSettingsServicedeskItsmTicketTypesConfigPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $dEPxR.TicketTypesConfigEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $1761f8f0b85b3339$export$9f40815b933b51ba = (0, $7NszV.createEntry)((0, $j9HCv.projectSettingsServicedeskItsmTicketTypesConfigRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $4stgq.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            return $1761f8f0b85b3339$var$projectSettingsServicedeskItsmTicketTypesConfigPageEntrypoint;
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $dxCvy.projectContextResource),
            (0, $eUvlM.servicedeskPracticesResource),
            (0, $k8jl5.servicedeskIssueTypesResource),
            (0, $1cpsA.servicedeskPortalGroupsResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $2pT4g.jsmRepackagingBannerResource),
            (0, $6sNnq.featuresResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4stgq.LazyProjectSettingsServiceDeskTicketTypesConfig)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).REQUEST_TYPES_CONFIG,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).REQUEST_TYPES_CONFIG),
                teamName: 'jsd-shield'
            }
        },
        perfMetricKey: 'jsm-request-types-configuration',
        ufoName: 'jsm-request-types-configuration'
    }));

});
parcelRegister("k8jl5", function(module, exports) {

$parcel$export(module.exports, "servicedeskIssueTypesResource", () => $8b723afc89fdf36c$export$191ce50629f40dbe);

var $2M1hQ = parcelRequire("2M1hQ");


const $8b723afc89fdf36c$var$getDataLoader = ()=>(parcelRequire("8Yxr9"));
const $8b723afc89fdf36c$export$191ce50629f40dbe = (0, $2M1hQ.createResource)({
    type: (0, $30e9f90f7be7696a$export$1ed713fe52212251),
    getKey: ({ match: { params: params } })=>params.projectKey || '',
    getDataLoader: $8b723afc89fdf36c$var$getDataLoader
});

});
const $30e9f90f7be7696a$export$1ed713fe52212251 = 'SERVICEDESK_ISSUE_TYPES';

parcelRegister("8Yxr9", function(module, exports) {

let $688ddd2e977b64e1$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $688ddd2e977b64e1$var$load("kVX56"),
    $688ddd2e977b64e1$var$load("bSrZ5")
]).then(()=>parcelRequire('lWPKX'));

});


parcelRegister("1cpsA", function(module, exports) {

$parcel$export(module.exports, "servicedeskPortalGroupsResource", () => $2ddee7630453f9bc$export$c7fb28234b909b2f);

var $2M1hQ = parcelRequire("2M1hQ");


const $2ddee7630453f9bc$var$getDataLoader = ()=>(parcelRequire("646f9"));
const $2ddee7630453f9bc$var$ONE_DAY_IN_MILLIS = 86400000;
const $2ddee7630453f9bc$export$c7fb28234b909b2f = (0, $2M1hQ.createResource)({
    type: (0, $1e9c4adda1725c92$export$4160f2c498fcd32e),
    getKey: ({ match: { params: params } })=>params.projectKey || '',
    getDataLoader: $2ddee7630453f9bc$var$getDataLoader,
    maxAge: $2ddee7630453f9bc$var$ONE_DAY_IN_MILLIS
});

});
const $1e9c4adda1725c92$export$4160f2c498fcd32e = 'SERVICEDESK_PORTAL_GROUPS';

parcelRegister("646f9", function(module, exports) {

let $46a7f59c7223f675$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $46a7f59c7223f675$var$load("kVX56"),
    $46a7f59c7223f675$var$load("9IaT8")
]).then(()=>parcelRequire('7sMSo'));

});


parcelRegister("j9HCv", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskItsmTicketTypesConfigRoute", () => $6ecc0aee1a9cf675$export$52596d9b432829c);
const $6ecc0aee1a9cf675$export$52596d9b432829c = {
    exact: true,
    name: 'project-settings-servicedesk-itsm-ticket-types-config',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types/category/:practice'
};

});

parcelRegister("dEPxR", function(module, exports) {

$parcel$export(module.exports, "TicketTypesConfigEntrypoint", () => $67e2a135ba1dfc6c$export$85bc484c6bab022d);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $jfTHL = parcelRequire("jfTHL");

const $67e2a135ba1dfc6c$export$85bc484c6bab022d = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("3X95c")), {
        moduleId: "d08c0344",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const cloudId = tenantContext.cloudId;
        const projectKey = context.match.params.projectKey;
        if (!projectKey) throw new Error('Project key is required');
        return {
            entryPoints: {
                requestTypeTableEntrypoint: {
                    entryPoint: (0, $jfTHL.requestTypeTableEntrypoint),
                    entryPointParams: {
                        projectKey: projectKey,
                        cloudId: cloudId
                    }
                }
            }
        };
    }
});

});
parcelRegister("jfTHL", function(module, exports) {

$parcel$export(module.exports, "requestTypeTableEntrypoint", () => $c5ac394482ac63fe$export$ecbf0c880decd2ac);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $2K2rC = parcelRequire("2K2rC");

const $c5ac394482ac63fe$export$ecbf0c880decd2ac = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("lntVi")).then((module)=>module.RequestTypesTable), {
        moduleId: "44a9b8a6",
        priority: "userVisible"
    }),
    getPreloadProps: ({ projectKey: projectKey, cloudId: cloudId })=>{
        return {
            queries: {
                tableSettings: {
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    },
                    parameters: $2K2rC.default,
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("2K2rC", function(module, exports) {

$parcel$export(module.exports, "default", () => $32bd8aa55825b96f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ce045fc0dd46722872f41c70f570f768>>
 * @relayHash 989e1263c7e39eb54ef3504b593961dc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bc2fb1d6504af1e571c063410348f23ce17651af7eb3f1921b9b1483b8d48cc8
const $32bd8aa55825b96f$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "bc2fb1d6504af1e571c063410348f23ce17651af7eb3f1921b9b1483b8d48cc8",
        "metadata": {},
        "name": "table_RequestTypesTableQuery",
        "operationKind": "query",
        "text": null
    }
};
var $32bd8aa55825b96f$export$2e2bcd8739ae039 = $32bd8aa55825b96f$var$node;

});

parcelRegister("lntVi", function(module, exports) {

let $f902f50dc9cd0caa$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f902f50dc9cd0caa$var$load("h8elz").then(()=>parcelRequire('hBNKS'));

});


parcelRegister("3X95c", function(module, exports) {

let $2e0ded7395bfdfd4$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $2e0ded7395bfdfd4$var$load("ffQaD"),
    $2e0ded7395bfdfd4$var$load("kvRbA"),
    $2e0ded7395bfdfd4$var$load("5uHcO")
]).then(()=>parcelRequire('aFE6U'));

});


parcelRegister("4stgq", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskTicketTypesConfig", () => $d4145a6e3aeb3bbb$export$c26e63f8b7d3b52c);
$parcel$export(module.exports, "default", () => $d4145a6e3aeb3bbb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kKHTt = parcelRequire("kKHTt");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $d4145a6e3aeb3bbb$export$c26e63f8b7d3b52c = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("eu1S5")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-ticket-types-config/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d4145a6e3aeb3bbb$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kKHTt.HelpCenterSettingsRedirect), {
        page: "ticket-types-config"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d4145a6e3aeb3bbb$export$c26e63f8b7d3b52c,
        pageId: "project-settings-ticket-types-config",
        shouldShowSpinner: true
    }));

});
parcelRegister("eu1S5", function(module, exports) {

let $a8b551a15d0aa522$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $a8b551a15d0aa522$var$load("ffQaD"),
    $a8b551a15d0aa522$var$load("kvRbA"),
    $a8b551a15d0aa522$var$load("6mGQj")
]).then(()=>parcelRequire('7wKb0'));

});



parcelRegister("i8buc", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskJourneyConfigurationEditRouteEntry", () => $c37fb91c4e26e536$export$5cbb0a0098e65c64);

var $e4eHl = parcelRequire("e4eHl");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $2ki4m = parcelRequire("2ki4m");

var $6Z2mh = parcelRequire("6Z2mh");

var $4R6GH = parcelRequire("4R6GH");

var $2pLla = parcelRequire("2pLla");
const $c37fb91c4e26e536$export$5cbb0a0098e65c64 = (0, $7NszV.createEntry)((0, $2ki4m.projectSettingsServicedeskJourneyConfigurationEditRoute), ()=>({
        group: 'project-settings-servicedesk',
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        meta: {
            reporting: {
                id: 'jsm.journey-builder.journey-config',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('journey-config'),
                teamName: 'JSM Getting Started'
            }
        },
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ],
        perfMetricKey: 'jsm-journey-configuration-edit',
        entryPoint: ()=>(0, $4R6GH.fg)('journey_builder_support_versioning') ? (0, $2pLla.journeyConfigEditPageEntryPoint) : undefined
    }));

});
parcelRegister("2ki4m", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskJourneyConfigurationEditRoute", () => $5908f0de6ed8a95e$export$f80f582ef54900c6);
const $5908f0de6ed8a95e$export$f80f582ef54900c6 = {
    name: 'project-settings-servicedesk-journey-configuration-edit',
    path: '/jira/servicedesk/projects/:projectKey/settings/journeys/:journeyId/edit',
    exact: true
};

});

parcelRegister("2pLla", function(module, exports) {

$parcel$export(module.exports, "journeyConfigEditPageEntryPoint", () => $fdfad37cd3d1b2d6$export$7388ef888b9170a7);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $3HGnZ = parcelRequire("3HGnZ");
const $fdfad37cd3d1b2d6$export$7388ef888b9170a7 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $3HGnZ.journeyConfigEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("3HGnZ", function(module, exports) {

$parcel$export(module.exports, "journeyConfigEntryPoint", () => $1dfcd84f3f61c84b$export$26f82de7820f0c3);

var $lyoHt = parcelRequire("lyoHt");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $1dfcd84f3f61c84b$export$26f82de7820f0c3 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("kVsKg")), {
        moduleId: "6bffb775",
        moduleName: "JourneyConfigurationPage",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        return {
            queries: {
                jiraJourneyConfiguration: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $lyoHt.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey || '',
                        journeyId: context.match.params.journeyId ?? '',
                        isEditing: context.match.path?.includes('journeys/:journeyId/edit')
                    }
                }
            },
            entryPoints: {},
            extraProps: {}
        };
    }
});

});
parcelRegister("lyoHt", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c24657e8d4ddd13$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f994f30dd97be3822eaade95df9378b5>>
 * @relayHash 08619cb4687448195662e27bf198a9e4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 596a9d67d6f570fde4886f4bd23bd6d470c0ddc8e71e1037b4bbbb7280f26b7f

var $7vH2K = parcelRequire("7vH2K");
const $5c24657e8d4ddd13$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "596a9d67d6f570fde4886f4bd23bd6d470c0ddc8e71e1037b4bbbb7280f26b7f",
        "metadata": {},
        "name": "JourneyConfigurationPageQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjirajourneybuilderimprovevalidationrelayprovider": (0, $7vH2K.default)
        }
    }
};
var $5c24657e8d4ddd13$export$2e2bcd8739ae039 = $5c24657e8d4ddd13$var$node;

});
parcelRegister("7vH2K", function(module, exports) {

$parcel$export(module.exports, "default", () => $7331b15cf1e62060$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $7331b15cf1e62060$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('journey_builder_validation_errors');
    }
};

});


parcelRegister("kVsKg", function(module, exports) {

let $f3bf6dbb28656de2$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f3bf6dbb28656de2$var$load("ffQaD"),
    $f3bf6dbb28656de2$var$load("kvRbA"),
    $f3bf6dbb28656de2$var$load("9gF6b")
]).then(()=>parcelRequire('aG5pa'));

});




parcelRegister("gpVZm", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskJourneyConfigurationRouteEntry", () => $d346a4266360b0ae$export$7475316a4561dd76);

var $e4eHl = parcelRequire("e4eHl");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $gyJ1H = parcelRequire("gyJ1H");

var $6Z2mh = parcelRequire("6Z2mh");

var $4R6GH = parcelRequire("4R6GH");

var $8LFLY = parcelRequire("8LFLY");
const $d346a4266360b0ae$export$7475316a4561dd76 = (0, $7NszV.createEntry)((0, $gyJ1H.projectSettingsServicedeskJourneyConfigurationRoute), ()=>({
        group: 'project-settings-servicedesk',
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        meta: {
            reporting: {
                id: 'jsm.journey-builder.journey-config',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('journey-config'),
                teamName: 'JSM Getting Started'
            }
        },
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ],
        perfMetricKey: 'jsm-journey-configuration',
        entryPoint: ()=>(0, $4R6GH.fg)('jsm-journey-builder') ? (0, $8LFLY.journeyConfigPageEntryPoint) : undefined
    }));

});
parcelRegister("gyJ1H", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskJourneyConfigurationRoute", () => $9a0c0a603e702cf3$export$9013e78604bfadb0);
const $9a0c0a603e702cf3$export$9013e78604bfadb0 = {
    name: 'project-settings-servicedesk-journey-configuration',
    path: '/jira/servicedesk/projects/:projectKey/settings/journeys/:journeyId',
    exact: true
};

});

parcelRegister("8LFLY", function(module, exports) {

$parcel$export(module.exports, "journeyConfigPageEntryPoint", () => $e2e16678033c3122$export$35537410b0bf07ea);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $3HGnZ = parcelRequire("3HGnZ");
const $e2e16678033c3122$export$35537410b0bf07ea = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $3HGnZ.journeyConfigEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});


parcelRegister("1ods3", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskJourneysRouteEntry", () => $b1d24e5a00ab7abb$export$6c014a8c741bf222);

var $e4eHl = parcelRequire("e4eHl");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $2j3DA = parcelRequire("2j3DA");

var $6Z2mh = parcelRequire("6Z2mh");

var $4R6GH = parcelRequire("4R6GH");

var $g2OFQ = parcelRequire("g2OFQ");
const $b1d24e5a00ab7abb$export$6c014a8c741bf222 = (0, $7NszV.createEntry)((0, $2j3DA.projectSettingsServicedeskJourneysRoute), ()=>({
        group: 'project-settings-servicedesk',
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        meta: {
            reporting: {
                id: 'jsm.journey-builder.journeys-list',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('journeys-list'),
                teamName: 'JSM Getting Started'
            }
        },
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ],
        perfMetricKey: 'jsm-journeys',
        entryPoint: ()=>(0, $4R6GH.fg)('jsm-journey-builder') ? (0, $g2OFQ.journeysPageEntryPoint) : undefined
    }));

});
parcelRegister("2j3DA", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskJourneysRoute", () => $705088c1cf32c92a$export$627d71a1dd7a9593);
const $705088c1cf32c92a$export$627d71a1dd7a9593 = {
    name: 'project-settings-servicedesk-journeys',
    path: '/jira/servicedesk/projects/:projectKey/settings/journeys',
    exact: true
};

});

parcelRegister("g2OFQ", function(module, exports) {

$parcel$export(module.exports, "journeysPageEntryPoint", () => $afecb2c38eb0ad75$export$3b90f0eb27bdd52f);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $bbmu4 = parcelRequire("bbmu4");
const $afecb2c38eb0ad75$export$3b90f0eb27bdd52f = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $bbmu4.journeysEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("bbmu4", function(module, exports) {

$parcel$export(module.exports, "journeysEntryPoint", () => $1cbf56bd5b792bd0$export$4ded7f93dbe6eb63);

var $8FYy8 = parcelRequire("8FYy8");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $4R6GH = parcelRequire("4R6GH");

const $1cbf56bd5b792bd0$export$4ded7f93dbe6eb63 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("v9NCl")), {
        moduleId: "ab11e2ef",
        moduleName: "JourneysPage",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                journeysPageQueryRef: {
                    parameters: $8FYy8.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey || '',
                        isFGEnabled: (0, $4R6GH.fg)('journey_builder_support_versioning')
                    },
                    options: {
                        fetchPolicy: 'store-and-network'
                    }
                }
            },
            entryPoints: {},
            extraProps: {}
        })
});

});
parcelRegister("8FYy8", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dab8bc029613fb5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<83a2d8b891919354b4a371e0d3b595de>>
 * @relayHash 3354cc4202d42c6c5ace34b7d2c7f774
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0c55cb735663043e184d5adef47ee8599cdf2febd8c3e6ce1d01460696ef3aa4
const $0dab8bc029613fb5$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "0c55cb735663043e184d5adef47ee8599cdf2febd8c3e6ce1d01460696ef3aa4",
        "metadata": {},
        "name": "JourneysPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $0dab8bc029613fb5$export$2e2bcd8739ae039 = $0dab8bc029613fb5$var$node;

});

parcelRegister("v9NCl", function(module, exports) {

let $05da7f4c56a24140$var$load = (parcelRequire("28QjX"))(4);
module.exports = $05da7f4c56a24140$var$load("17vDF").then(()=>parcelRequire('iSwlg'));

});




parcelRegister("hqIff", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskKbRouteEntry", () => $f4ec187fc157720c$export$d43e914d37d059b8);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $2m3cT = parcelRequire("2m3cT");

var $6Z2mh = parcelRequire("6Z2mh");

var $gw09t = parcelRequire("gw09t");
const $f4ec187fc157720c$export$d43e914d37d059b8 = (0, $7NszV.createEntry)((0, $2m3cT.projectSettingsServicedeskKbRoute), ()=>({
        group: 'project-settings-servicedesk',
        perfMetricKey: 'service-management.kb-settings',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        component: (0, $gw09t.ServiceDeskKnowledgeBaseV2),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gw09t.LazyProjectSettingsServiceDeskKnowledgeBaseV2)
        ],
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ]
    }));

});
parcelRegister("gw09t", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskKnowledgeBaseV2", () => $0bf88a8d63415148$export$7c7186fdd8c56428);
$parcel$export(module.exports, "ServiceDeskKnowledgeBaseV2", () => $0bf88a8d63415148$export$6d92735e249274bb);

var $5uXOq = parcelRequire("5uXOq");

var $kKHTt = parcelRequire("kKHTt");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");
const $0bf88a8d63415148$export$3fac45fa34d00981 = 'project/service-desk/settings/index';
const $0bf88a8d63415148$export$1aa47348ef6dbdda = 'project/service-desk/settings';

const $0bf88a8d63415148$export$583a442626bd3345 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("8h2hP")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-knowledge-base/src/index.tsx"
});

const $0bf88a8d63415148$export$7c7186fdd8c56428 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("iR667"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-settings/src/index.tsx"
});
const $0bf88a8d63415148$export$6d92735e249274bb = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kKHTt.HelpCenterSettingsRedirect), {
        page: "kb"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $0bf88a8d63415148$export$7c7186fdd8c56428,
        pageId: "project-settings-knowledge-base",
        shouldShowSpinner: true
    }));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0bf88a8d63415148$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $0bf88a8d63415148$export$583a442626bd3345,
        pageId: "project-settings-knowledge-base",
        shouldShowSpinner: true
    });

});
parcelRegister("8h2hP", function(module, exports) {

let $6061af51954aa4ba$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6061af51954aa4ba$var$load("3uUSO").then(()=>parcelRequire('2fak7'));

});

parcelRegister("iR667", function(module, exports) {

let $dba1e81c3a2f2f23$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $dba1e81c3a2f2f23$var$load("ffQaD"),
    $dba1e81c3a2f2f23$var$load("kvRbA"),
    $dba1e81c3a2f2f23$var$load("iDhNV")
]).then(()=>parcelRequire('gCbsh'));

});



parcelRegister("ljDIh", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLanguageKeyRouteEntry", () => $2ca289138c55c124$export$db3a99044f906462);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $e4oBS = parcelRequire("e4oBS");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $k7tsS = parcelRequire("k7tsS");

var $lAfKa = parcelRequire("lAfKa");
const $2ca289138c55c124$export$db3a99044f906462 = (0, $7NszV.createEntry)((0, $e4oBS.projectSettingsServicedeskLanguageKeyRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.translations',
        component: (0, $lAfKa.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $k7tsS.languageTranslationsResource),
            (0, $k7tsS.outgoingEmailStateModelResource)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).LANGUAGE_SETTINGS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).LANGUAGE_SETTINGS),
                teamName: 'jsm-banana'
            }
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $lAfKa.LazyProjectSettingsServiceDeskLanguageTranslations)
        ],
        perfMetricKey: 'jsm-language-translations'
    }));

});
parcelRegister("e4oBS", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLanguageKeyRoute", () => $8a798ea346394d71$export$194a3f27b07aafec);
const $8a798ea346394d71$export$194a3f27b07aafec = {
    name: 'project-settings-servicedesk-language-key',
    path: '/jira/servicedesk/projects/:projectKey/settings/language/:languageKey/:sidebarItemKey?'
};

});

parcelRegister("k7tsS", function(module, exports) {

$parcel$export(module.exports, "languageTranslationsResource", () => $ffad7a39054feef3$export$f51887e33895eab9);
$parcel$export(module.exports, "outgoingEmailStateModelResource", () => $ffad7a39054feef3$export$c460156a7e6b85b2);

var $2M1hQ = parcelRequire("2M1hQ");
const $ffad7a39054feef3$export$9f529be3aeae01ea = 'JSM Language Translations';
const $ffad7a39054feef3$export$ecd381e388e8c56f = "Language Support Customer Notification's Outgoing Email State";

const $ffad7a39054feef3$export$f51887e33895eab9 = (0, $2M1hQ.createResource)({
    type: 'Language Translations',
    getKey: ({ match: { params: { projectKey: projectKey, languageKey: languageKey } } })=>`${$ffad7a39054feef3$export$9f529be3aeae01ea}-${projectKey}-${languageKey}`,
    getDataLoader: ()=>(parcelRequire("knz5P")),
    maxAge: Infinity
});

const $ffad7a39054feef3$export$c460156a7e6b85b2 = (0, $2M1hQ.createResource)({
    type: 'Outgoing Email State Model',
    getKey: ()=>`${$ffad7a39054feef3$export$ecd381e388e8c56f}`,
    getDataLoader: ()=>(parcelRequire("3VjNS")),
    maxAge: Infinity
});

});
parcelRegister("knz5P", function(module, exports) {

let $ed612d6393858c1f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ed612d6393858c1f$var$load("5fBDT").then(()=>parcelRequire('3m5cp'));

});

parcelRegister("3VjNS", function(module, exports) {

let $2db60e7fc388debe$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2db60e7fc388debe$var$load("l1iwu").then(()=>parcelRequire('49aS0'));

});


parcelRegister("lAfKa", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskLanguageTranslations", () => $818bcbaaddc8bfd3$export$c029d3f514c7b3e0);
$parcel$export(module.exports, "default", () => $818bcbaaddc8bfd3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $818bcbaaddc8bfd3$export$c029d3f514c7b3e0 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("c2QNW")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-language-translations/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$818bcbaaddc8bfd3$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $818bcbaaddc8bfd3$export$c029d3f514c7b3e0,
        pageId: "project-settings-language-translations",
        shouldShowSpinner: true
    });

});
parcelRegister("c2QNW", function(module, exports) {

let $8c4ea1ca82de4f8e$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $8c4ea1ca82de4f8e$var$load("ffQaD"),
    $8c4ea1ca82de4f8e$var$load("kvRbA"),
    $8c4ea1ca82de4f8e$var$load("fliVL"),
    $8c4ea1ca82de4f8e$var$load("bu4VX")
]).then(()=>parcelRequire('kG5x5'));

});



parcelRegister("lAnjX", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLanguageRouteEntry", () => $bffa1bbc0966d026$export$576b048795cbefad);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $jZ1W8 = parcelRequire("jZ1W8");

var $6Z2mh = parcelRequire("6Z2mh");

var $6xGbx = parcelRequire("6xGbx");

var $lAfKa = parcelRequire("lAfKa");
const $bffa1bbc0966d026$export$576b048795cbefad = (0, $7NszV.createEntry)((0, $jZ1W8.projectSettingsServicedeskLanguageRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.languages',
        component: (0, $6xGbx.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $lAfKa.LazyProjectSettingsServiceDeskLanguageTranslations)
        ]
    }));

});
parcelRegister("jZ1W8", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLanguageRoute", () => $171e592762201788$export$99b0bbae92462ac2);
const $171e592762201788$export$99b0bbae92462ac2 = {
    name: 'project-settings-servicedesk-language',
    path: '/jira/servicedesk/projects/:projectKey/settings/language',
    exact: true
};

});

parcelRegister("6xGbx", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c45ee4ab52677ce$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $4c45ee4ab52677ce$export$213b8279037c9d98 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("23tIB"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-language-support/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4c45ee4ab52677ce$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $4c45ee4ab52677ce$export$213b8279037c9d98,
        pageId: "project-settings-language-support",
        shouldShowSpinner: true
    });

});
parcelRegister("23tIB", function(module, exports) {

let $17f2ea03d8409eca$var$load = (parcelRequire("28QjX"))(4);
module.exports = $17f2ea03d8409eca$var$load("chbbZ").then(()=>parcelRequire('4yiYq'));

});



parcelRegister("bCnWj", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectCopyRouteEntry", () => $9834f5e7c0df5412$export$dd52be928c274980);

var $7NszV = parcelRequire("7NszV");

var $bM51X = parcelRequire("bM51X");

var $6Z2mh = parcelRequire("6Z2mh");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6g6uF = parcelRequire("6g6uF");
const $9834f5e7c0df5412$export$dd52be928c274980 = (0, $7NszV.createEntry)((0, $bM51X.projectSettingsServicedeskLegacyAutomationRedirectCopyRoute), ()=>({
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [],
        component: (0, $6g6uF.automationRedirect)('copy')
    }));

});
parcelRegister("bM51X", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectCopyRoute", () => $60a67b19cd763b2f$export$869afe63d0e077be);
const $60a67b19cd763b2f$export$869afe63d0e077be = {
    name: 'project-settings-servicedesk-automation-redirect-copy',
    path: '/projects/:projectKey/settings/automation/copy/:ruleId'
};

});

parcelRegister("6g6uF", function(module, exports) {

$parcel$export(module.exports, "automationRedirect", () => $69d1eaf61634b750$export$d6674bfa636b8090);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $02Psx = parcelRequire("02Psx");

var $g5X3G = parcelRequire("g5X3G");

var $7tQej = parcelRequire("7tQej");
const $69d1eaf61634b750$var$newAutomationUrl = (baseUrl, { match: match }, pageType)=>{
    const { projectKey: projectKey } = match.params;
    if (pageType === 'edit') {
        const { ruleId: ruleId } = match.params;
        return `${(0, $02Psx.getNextgenSettingsUrl)((0, $2vSU6.SERVICE_DESK_PROJECT), String(projectKey))}/automation/ruleset/${ruleId || ''}`;
    }
    if (pageType === 'copy') {
        const { ruleId: ruleId } = match.params;
        return `${(0, $02Psx.getNextgenSettingsUrl)((0, $2vSU6.SERVICE_DESK_PROJECT), String(projectKey))}/automation/copy/${ruleId || ''}`;
    }
    if (pageType === 'viewlog') {
        const { ruleId: ruleId } = match.params;
        return `${(0, $02Psx.getNextgenSettingsUrl)((0, $2vSU6.SERVICE_DESK_PROJECT), String(projectKey))}/automation/log/${ruleId || ''}`;
    }
    if (pageType === 'create') {
        const { blueprintKey: blueprintKey } = match.params;
        return `${(0, $02Psx.getNextgenSettingsUrl)((0, $2vSU6.SERVICE_DESK_PROJECT), String(projectKey))}/automation/blueprint/${blueprintKey || ''}`;
    }
    return `${(0, $02Psx.getNextgenSettingsUrl)((0, $2vSU6.SERVICE_DESK_PROJECT), String(projectKey))}/automation`;
};
const $69d1eaf61634b750$export$d6674bfa636b8090 = (pageType)=>(routeContext)=>{
        // use empty string instead of actual baseUrl as router redirect handles it internally
        const emptyBaseUrl = (0, $g5X3G.toBaseUrl)('');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: $69d1eaf61634b750$var$newAutomationUrl(emptyBaseUrl, routeContext, pageType),
            push: false
        });
    };

});


parcelRegister("aQ85T", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectCreateRouteEntry", () => $4e9c4987ebea2357$export$fc7d1f3302418153);

var $7NszV = parcelRequire("7NszV");

var $gzxoX = parcelRequire("gzxoX");

var $6Z2mh = parcelRequire("6Z2mh");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6g6uF = parcelRequire("6g6uF");
const $4e9c4987ebea2357$export$fc7d1f3302418153 = (0, $7NszV.createEntry)((0, $gzxoX.projectSettingsServicedeskLegacyAutomationRedirectCreateRoute), ()=>({
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [],
        component: (0, $6g6uF.automationRedirect)('create')
    }));

});
parcelRegister("gzxoX", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectCreateRoute", () => $180ffea8026c8f05$export$c2a59dbe6d23efd4);
const $180ffea8026c8f05$export$c2a59dbe6d23efd4 = {
    name: 'project-settings-servicedesk-automation-redirect-create',
    path: '/projects/:projectKey/settings/automation/blueprint/:blueprintKey'
};

});


parcelRegister("6kvQ5", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectEditRouteEntry", () => $d4b71d1e99902d1e$export$cf95450a3eafe8ff);

var $7NszV = parcelRequire("7NszV");

var $zrLzB = parcelRequire("zrLzB");

var $6Z2mh = parcelRequire("6Z2mh");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6g6uF = parcelRequire("6g6uF");
const $d4b71d1e99902d1e$export$cf95450a3eafe8ff = (0, $7NszV.createEntry)((0, $zrLzB.projectSettingsServicedeskLegacyAutomationRedirectEditRoute), ()=>({
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [],
        component: (0, $6g6uF.automationRedirect)('edit')
    }));

});
parcelRegister("zrLzB", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectEditRoute", () => $7a29d6d898ef792a$export$f61e79c14e9bc0a1);
const $7a29d6d898ef792a$export$f61e79c14e9bc0a1 = {
    name: 'project-settings-servicedesk-automation-redirect-edit',
    path: '/projects/:projectKey/settings/automation/ruleset/:ruleId'
};

});


parcelRegister("9Dd5o", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectSummaryRouteEntry", () => $c179245528a3d6e0$export$d6873ef17e5a0ea5);

var $7NszV = parcelRequire("7NszV");

var $1N14b = parcelRequire("1N14b");

var $6Z2mh = parcelRequire("6Z2mh");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6g6uF = parcelRequire("6g6uF");
const $c179245528a3d6e0$export$d6873ef17e5a0ea5 = (0, $7NszV.createEntry)((0, $1N14b.projectSettingsServicedeskLegacyAutomationRedirectSummaryRoute), ()=>({
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [],
        component: (0, $6g6uF.automationRedirect)('summary')
    }));

});
parcelRegister("1N14b", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectSummaryRoute", () => $4fd4ba182f3de844$export$fdd432d4e600f9);
const $4fd4ba182f3de844$export$fdd432d4e600f9 = {
    name: 'project-settings-servicedesk-automation-redirect-summary',
    path: '/projects/:projectKey/settings/automation/'
};

});


parcelRegister("kci7Q", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectViewLogRouteEntry", () => $d28565c3ab2c87a7$export$f0eaafcdee9dfa31);

var $7NszV = parcelRequire("7NszV");

var $7wX2j = parcelRequire("7wX2j");

var $lmyls = parcelRequire("lmyls");

var $6Z2mh = parcelRequire("6Z2mh");

var $h0bZU = parcelRequire("h0bZU");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6g6uF = parcelRequire("6g6uF");
const $d28565c3ab2c87a7$export$f0eaafcdee9dfa31 = (0, $7NszV.createEntry)((0, $7wX2j.projectSettingsServicedeskLegacyAutomationRedirectViewLogRoute), ()=>({
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [],
        component: (0, $6g6uF.automationRedirect)('viewlog')
    }));

});
parcelRegister("7wX2j", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectViewLogRoute", () => $5e0bbde66fde5bf7$export$e6e772830a33ba0b);
const $5e0bbde66fde5bf7$export$e6e772830a33ba0b = {
    name: 'project-settings-servicedesk-automation-redirect-viewlog',
    path: '/projects/:projectKey/settings/automation/log/:ruleId'
};

});


parcelRegister("5XbrB", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsCustomerNotificationsRouteEntry", () => $d08875f655bb322d$export$b4d122e49516c10d);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $3BQ4q = parcelRequire("3BQ4q");

var $6Z2mh = parcelRequire("6Z2mh");

var $kFrbC = parcelRequire("kFrbC");

var $hASB6 = parcelRequire("hASB6");
const $d08875f655bb322d$export$b4d122e49516c10d = (0, $7NszV.createEntry)((0, $3BQ4q.projectSettingsServicedeskNotificationsCustomerNotificationsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $kFrbC.ServiceDeskCustomerNotificationsNextGenRedirect),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hASB6.LazyProjectSettingsServiceDeskCustomerNotifications)
        ]
    }));

});
parcelRegister("kFrbC", function(module, exports) {

$parcel$export(module.exports, "ServiceDeskCustomerNotificationsNextGenRedirect", () => $aa137e884608085b$export$8249a46a710af6da);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
const $aa137e884608085b$export$8249a46a710af6da = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/customer-notifications`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: url
    });
};

});


parcelRegister("72XXS", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsEmailRouteEntry", () => $fd4b138cf89ddc30$export$ec0ead95e321b800);

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $9ujoJ = parcelRequire("9ujoJ");

var $6Z2mh = parcelRequire("6Z2mh");

var $6T6BC = parcelRequire("6T6BC");
const $fd4b138cf89ddc30$export$ec0ead95e321b800 = (0, $7NszV.createEntry)((0, $9ujoJ.projectSettingsServicedeskNotificationsEmailRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $6T6BC.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $6T6BC.LazyProjectSettingsNotificationEmail)
        ]
    }));

});
parcelRegister("6T6BC", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsNotificationEmail", () => $6229d9dc67e508de$export$ea7d73c94d9369f4);
$parcel$export(module.exports, "default", () => $6229d9dc67e508de$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $6229d9dc67e508de$export$ea7d73c94d9369f4 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hLnUL"))), {
    moduleId: "./src/packages/spa-apps/project-settings/notification-email/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6229d9dc67e508de$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $6229d9dc67e508de$export$ea7d73c94d9369f4,
        pageId: "project-settings-email-notifications",
        shouldShowSpinner: true
    });

});


parcelRegister("bbdey", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsInternalNotificationsRouteEntry", () => $d5bc60012ecbb2c8$export$4a15f2c244cd196c);

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $2CYtL = parcelRequire("2CYtL");

var $6Z2mh = parcelRequire("6Z2mh");

var $f8FqB = parcelRequire("f8FqB");

var $e8N9g = parcelRequire("e8N9g");

var $jNJyR = parcelRequire("jNJyR");
const $d5bc60012ecbb2c8$export$4a15f2c244cd196c = (0, $7NszV.createEntry)((0, $2CYtL.projectSettingsServicedeskNotificationsInternalNotificationsRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.internal-notifications',
        component: (0, $e8N9g.serviceDeskInternalNotificationsNextGenRedirect),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jNJyR.LazyProjectSettingsServiceDeskInternalNotifications),
            (0, $f8FqB.LazyInternalNotificationSettingsPage)
        ]
    }));

});
parcelRegister("e8N9g", function(module, exports) {

$parcel$export(module.exports, "serviceDeskInternalNotificationsNextGenRedirect", () => $68a880eb92a707c3$export$49625f83fe7ecc69);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
const $68a880eb92a707c3$export$49625f83fe7ecc69 = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/internal-notifications`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: url
    });
};

});


parcelRegister("t2WaR", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsNotificationEmailRouteEntry", () => $fc3eddb4351c27ae$export$cc1164e0e5db595);

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $buwAo = parcelRequire("buwAo");

var $6Z2mh = parcelRequire("6Z2mh");

var $6T6BC = parcelRequire("6T6BC");

var $k1jvb = parcelRequire("k1jvb");
const $fc3eddb4351c27ae$export$cc1164e0e5db595 = (0, $7NszV.createEntry)((0, $buwAo.projectSettingsServicedeskNotificationsNotificationEmailRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $k1jvb.ServiceDeskNotificationEmailNextGenRedirect),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $6T6BC.LazyProjectSettingsNotificationEmail)
        ]
    }));

});
parcelRegister("k1jvb", function(module, exports) {

$parcel$export(module.exports, "ServiceDeskNotificationEmailNextGenRedirect", () => $060e0b1586db8e82$export$735e58642f560ddc);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
const $060e0b1586db8e82$export$735e58642f560ddc = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/notification-email`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: url
    });
};

});


parcelRegister("yVmHw", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsRouteEntry", () => $a804e86b2cf06d23$export$20923f853e06d781);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $9D90J = parcelRequire("9D90J");

var $6Z2mh = parcelRequire("6Z2mh");

var $hJD3V = parcelRequire("hJD3V");
const $a804e86b2cf06d23$export$20923f853e06d781 = (0, $7NszV.createEntry)((0, $9D90J.projectSettingsServicedeskNotificationsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $hJD3V.notificationsRedirect)('customer-notifications'),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("9D90J", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsRoute", () => $f83be005a8f713dd$export$dbc53740e1d7ff79);
const $f83be005a8f713dd$export$dbc53740e1d7ff79 = {
    name: 'project-settings-servicedesk-notifications',
    path: '/jira/servicedesk/projects/:projectKey/settings/notifications',
    exact: true
};

});

parcelRegister("hJD3V", function(module, exports) {

$parcel$export(module.exports, "notificationsRedirect", () => $d3615143cfedd2aa$export$59144dd4441639fa);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $02Psx = parcelRequire("02Psx");

var $7tQej = parcelRequire("7tQej");
const $d3615143cfedd2aa$export$59144dd4441639fa = (pageUrlFragment)=>({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        const url = projectKey !== null && projectKey !== undefined ? `${(0, $02Psx.getNextgenSettingsUrl)((0, $2vSU6.SERVICE_DESK_PROJECT), projectKey)}/notifications/${pageUrlFragment}` : `/projects/${String(projectKey)}/settings/notifications/${pageUrlFragment}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: url,
            push: false
        });
    };

});


parcelRegister("26BGc", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskOverviewRouteEntry", () => $574f0a122beb6abc$export$1f0cb137e600941a);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $8q8ki = parcelRequire("8q8ki");

var $6Z2mh = parcelRequire("6Z2mh");

var $gC5Yv = parcelRequire("gC5Yv");
const $574f0a122beb6abc$export$1f0cb137e600941a = (0, $7NszV.createEntry)((0, $8q8ki.projectSettingsServicedeskOverviewRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $gC5Yv.AsyncOverviewSetting),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gC5Yv.LazyOverviewSettings)
        ]
    }));

});
parcelRegister("8q8ki", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskOverviewRoute", () => $f9e896d4d174d698$export$b4043f1a1b914130);
const $f9e896d4d174d698$export$b4043f1a1b914130 = {
    name: 'project-settings-servicedesk-overview',
    // /settings/overview
    path: '/jira/servicedesk/projects/:projectKey/settings/overview',
    exact: true
};

});

parcelRegister("gC5Yv", function(module, exports) {

$parcel$export(module.exports, "LazyOverviewSettings", () => $6294d9bbdecd1714$export$ce469ceb4c68a932);
$parcel$export(module.exports, "AsyncOverviewSetting", () => $6294d9bbdecd1714$export$92888ae2bbb25072);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $6294d9bbdecd1714$export$ce469ceb4c68a932 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("6crUx"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-overview/src/ui/index.tsx"
});
const $6294d9bbdecd1714$export$92888ae2bbb25072 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $6294d9bbdecd1714$export$ce469ceb4c68a932,
        pageId: "project-settings-overview",
        shouldShowSpinner: false
    });

});
parcelRegister("6crUx", function(module, exports) {

let $48398391760346c7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $48398391760346c7$var$load("fCic7").then(()=>parcelRequire('5F05h'));

});



parcelRegister("dseRA", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskPortalSettingsRouteEntry", () => $68ffccdafeca70f6$export$2f07a0943f4553c4);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $bveQD = parcelRequire("bveQD");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $34BDN = parcelRequire("34BDN");
const $68ffccdafeca70f6$export$2f07a0943f4553c4 = (0, $7NszV.createEntry)((0, $bveQD.projectSettingsServicedeskPortalSettingsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $34BDN.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $34BDN.LazyProjectSettingsServiceDeskClassicPortalSettings)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).PORTAL_SETTINGS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).PORTAL_SETTINGS),
                teamName: 'jsd-shield'
            }
        }
    }));

});
parcelRegister("34BDN", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskClassicPortalSettings", () => $2f67c1468e19aedd$export$eb662b618d6247be);
$parcel$export(module.exports, "default", () => $2f67c1468e19aedd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $2f67c1468e19aedd$export$eb662b618d6247be = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("9H24X"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-classic-portal-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2f67c1468e19aedd$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2f67c1468e19aedd$export$eb662b618d6247be,
        pageId: "project-settings-classic-portal-settings",
        shouldShowSpinner: true
    });

});
parcelRegister("9H24X", function(module, exports) {

let $70e9be059c49d1cc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $70e9be059c49d1cc$var$load("3gaLt").then(()=>parcelRequire('giHe4'));

});



parcelRegister("fCX78", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskProformaJiraFormBuilderRouteEntry", () => $ce34267499de75f9$export$f7bbe7fb3eeb9258);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $CiTFA = parcelRequire("CiTFA");

var $6Z2mh = parcelRequire("6Z2mh");

var $aPBt5 = parcelRequire("aPBt5");
const $ce34267499de75f9$export$f7bbe7fb3eeb9258 = (0, $7NszV.createEntry)((0, $CiTFA.projectSettingsServicedeskProformaJiraFormBuilderRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $aPBt5.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aPBt5.LazyProjectSettingsProformaJiraFormBuilder)
        ],
        perfMetricKey: 'form-builder'
    }));

});
parcelRegister("CiTFA", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskProformaJiraFormBuilderRoute", () => $1fa17d3fd833408f$export$f2a7862c8cde472d);
const $1fa17d3fd833408f$export$f2a7862c8cde472d = {
    name: 'project-settings-servicedesk-proforma-jira-form-builder',
    path: '/jira/servicedesk/projects/:projectKey/settings/forms/form/:templateFormId/edit',
    exact: true
};

});

parcelRegister("aPBt5", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsProformaJiraFormBuilder", () => $5cc0224f486155a9$export$a7d63246a10aedd);
$parcel$export(module.exports, "default", () => $5cc0224f486155a9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $5cc0224f486155a9$export$a7d63246a10aedd = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("7R9RB")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-jira-form-builder/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5cc0224f486155a9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $5cc0224f486155a9$export$a7d63246a10aedd,
        pageId: "project-settings-proforma-jira-form-builder",
        shouldShowSpinner: true
    });

});


parcelRegister("6NqDk", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskProformaProjectFormsRouteEntry", () => $83fcac200820df4d$export$f0d9fbaec8a9f2a);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $59iBR = parcelRequire("59iBR");

var $6Z2mh = parcelRequire("6Z2mh");

var $6RowE = parcelRequire("6RowE");
const $83fcac200820df4d$export$f0d9fbaec8a9f2a = (0, $7NszV.createEntry)((0, $59iBR.projectSettingsServicedeskProformaProjectFormsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $6RowE.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6RowE.LazyProjectSettingsProformaProjectForms)
        ],
        perfMetricKey: 'forms-settings'
    }));

});
parcelRegister("6RowE", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsProformaProjectForms", () => $7c82c5f708d0cd7e$export$38414b624a749cec);
$parcel$export(module.exports, "default", () => $7c82c5f708d0cd7e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $7c82c5f708d0cd7e$export$38414b624a749cec = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("cShK4")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-project-forms/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7c82c5f708d0cd7e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $7c82c5f708d0cd7e$export$38414b624a749cec,
        pageId: "project-settings-proforma-project-forms",
        shouldShowSpinner: true
    });

});


parcelRegister("bERWs", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskRedirectRouteEntry", () => $1c4a2f62f943cd86$export$a0279fafdeb78607);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $bYwAR = parcelRequire("bYwAR");

var $6Z2mh = parcelRequire("6Z2mh");

var $01LdL = parcelRequire("01LdL");
const $1c4a2f62f943cd86$export$a0279fafdeb78607 = (0, $7NszV.createEntry)((0, $bYwAR.projectSettingsServicedeskRedirectRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $01LdL.defaultRedirectForSettings)((0, $01LdL.SERVICE_DESK_PRODUCT)),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("bYwAR", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskRedirectRoute", () => $dd2a76b3e525b3b0$export$3fbe0a89e4d1e816);
const $dd2a76b3e525b3b0$export$3fbe0a89e4d1e816 = {
    name: 'project-settings-servicedesk-redirect',
    path: '/jira/servicedesk/projects/:projectKey/settings'
};

});


parcelRegister("gPxpf", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskTicketTypeFieldsRouteEntry", () => $4fa5116a5c8fa3c1$export$30951c6038a30ec4);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $eUvlM = parcelRequire("eUvlM");

var $7mt6L = parcelRequire("7mt6L");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $bO6K2 = parcelRequire("bO6K2");
const $4fa5116a5c8fa3c1$export$30951c6038a30ec4 = (0, $7NszV.createEntry)((0, $7mt6L.projectSettingsServicedeskTicketTypeFieldsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $bO6K2.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $eUvlM.servicedeskPracticesResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bO6K2.LazyProjectSettingsServiceDeskTicketTypeFields)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).REQUEST_TYPE_FIELDS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).REQUEST_TYPE_FIELDS),
                teamName: 'jsd-shield'
            }
        },
        ufoName: 'project-settings-servicedesk-ticket-type-fields'
    }));

});
parcelRegister("7mt6L", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskTicketTypeFieldsRoute", () => $28fb213ff0720fc3$export$6c99c477ef7583ba);
const $28fb213ff0720fc3$export$6c99c477ef7583ba = {
    exact: true,
    name: 'project-settings-servicedesk-ticket-type-fields',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types/request-type/:requestTypeId/:tabKey?'
};

});


parcelRegister("fLbia", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskTicketTypesConfigRouteEntry", () => $0acca3ff344e5eeb$export$bcc0bb7cf7f75a0f);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $2pT4g = parcelRequire("2pT4g");

var $dxCvy = parcelRequire("dxCvy");

var $fpjJX = parcelRequire("fpjJX");

var $k8jl5 = parcelRequire("k8jl5");

var $1cpsA = parcelRequire("1cpsA");

var $eUvlM = parcelRequire("eUvlM");

var $6sNnq = parcelRequire("6sNnq");

var $cmEH1 = parcelRequire("cmEH1");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $dEPxR = parcelRequire("dEPxR");

var $lkFvK = parcelRequire("lkFvK");

var $4stgq = parcelRequire("4stgq");
const $0acca3ff344e5eeb$var$projectSettingsServicedeskTicketTypesConfigPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $dEPxR.TicketTypesConfigEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $0acca3ff344e5eeb$export$bcc0bb7cf7f75a0f = (0, $7NszV.createEntry)((0, $cmEH1.projectSettingsServicedeskTicketTypesConfigRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $4stgq.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $dxCvy.projectContextResource),
            (0, $eUvlM.servicedeskPracticesResource),
            (0, $k8jl5.servicedeskIssueTypesResource),
            (0, $1cpsA.servicedeskPortalGroupsResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $2pT4g.jsmRepackagingBannerResource),
            (0, $6sNnq.featuresResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4stgq.LazyProjectSettingsServiceDeskTicketTypesConfig)
        ],
        entryPoint () {
            return $0acca3ff344e5eeb$var$projectSettingsServicedeskTicketTypesConfigPageEntrypoint;
        },
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).REQUEST_TYPES_CONFIG,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).REQUEST_TYPES_CONFIG),
                teamName: 'jsd-shield'
            }
        },
        perfMetricKey: 'jsm-request-types-configuration',
        ufoName: 'jsm-request-types-configuration'
    }));

});

parcelRegister("1Y5eu", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskUnassignedTicketTypeFieldsRouteEntry", () => $d537ae27f4e9ad4c$export$515ee5ae44539ca4);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $eUvlM = parcelRequire("eUvlM");

var $iWVTz = parcelRequire("iWVTz");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $bO6K2 = parcelRequire("bO6K2");
const $d537ae27f4e9ad4c$export$515ee5ae44539ca4 = (0, $7NszV.createEntry)((0, $iWVTz.projectSettingsServicedeskUnassignedTicketTypeFieldsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $bO6K2.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $eUvlM.servicedeskPracticesResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bO6K2.LazyProjectSettingsServiceDeskTicketTypeFields)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).REQUEST_TYPE_FIELDS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).REQUEST_TYPE_FIELDS),
                teamName: 'jsd-shield'
            }
        },
        ufoName: 'project-settings-servicedesk-ticket-type-fields'
    }));

});
parcelRegister("iWVTz", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskUnassignedTicketTypeFieldsRoute", () => $0ce9ec8fbf444bc7$export$f7a986e844a111a6);
const $0ce9ec8fbf444bc7$export$f7a986e844a111a6 = {
    exact: true,
    name: 'project-settings-servicedesk-unassigned-ticket-type-fields',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types/unassigned/request-type/:requestTypeId/:tabKey?'
};

});


parcelRegister("3FG4O", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskUnassignedTicketTypesConfigRouteEntry", () => $13309764c6efb114$export$6ba31a548ab77c4);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $2pT4g = parcelRequire("2pT4g");

var $dxCvy = parcelRequire("dxCvy");

var $fpjJX = parcelRequire("fpjJX");

var $k8jl5 = parcelRequire("k8jl5");

var $1cpsA = parcelRequire("1cpsA");

var $eUvlM = parcelRequire("eUvlM");

var $6sNnq = parcelRequire("6sNnq");

var $9xhY2 = parcelRequire("9xhY2");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $dEPxR = parcelRequire("dEPxR");

var $lkFvK = parcelRequire("lkFvK");

var $4stgq = parcelRequire("4stgq");
const $13309764c6efb114$var$projectSettingsServicedeskUnassignedTicketTypesConfigPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $dEPxR.TicketTypesConfigEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $13309764c6efb114$export$6ba31a548ab77c4 = (0, $7NszV.createEntry)((0, $9xhY2.projectSettingsServicedeskUnassignedTicketTypesConfigRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $4stgq.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $dxCvy.projectContextResource),
            (0, $eUvlM.servicedeskPracticesResource),
            (0, $k8jl5.servicedeskIssueTypesResource),
            (0, $1cpsA.servicedeskPortalGroupsResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $2pT4g.jsmRepackagingBannerResource),
            (0, $6sNnq.featuresResource)
        ],
        entryPoint () {
            return $13309764c6efb114$var$projectSettingsServicedeskUnassignedTicketTypesConfigPageEntrypoint;
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4stgq.LazyProjectSettingsServiceDeskTicketTypesConfig)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).REQUEST_TYPES_CONFIG,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).REQUEST_TYPES_CONFIG),
                teamName: 'jsd-shield'
            }
        },
        perfMetricKey: 'jsm-request-types-configuration',
        ufoName: 'jsm-request-types-configuration'
    }));

});

parcelRegister("dDzIU", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskWidgetRouteEntry", () => $a1253eff07e9815b$export$d86db47c21552ca);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $8qmAq = parcelRequire("8qmAq");

var $6Z2mh = parcelRequire("6Z2mh");

var $b2cnG = parcelRequire("b2cnG");
const $a1253eff07e9815b$export$d86db47c21552ca = (0, $7NszV.createEntry)((0, $8qmAq.projectSettingsServicedeskWidgetRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $b2cnG.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $b2cnG.LazyProjectSettingsServiceDeskWidgetSettings)
        ]
    }));

});

parcelRegister("3SReJ", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAccessRedirectRouteEntry", () => $ba86f21f622e78fc$export$99415df4033272f);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $9X7Hu = parcelRequire("9X7Hu");

var $e7bC3 = parcelRequire("e7bC3");

var $8ODWq = parcelRequire("8ODWq");

var $1XdKx = parcelRequire("1XdKx");
const $ba86f21f622e78fc$export$99415df4033272f = (0, $7NszV.createEntry)((0, $9X7Hu.projectSettingsSoftwareAccessRedirectRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $8ODWq.peopleAccessRedirect)(`/jira/${(0, $1XdKx.SOFTWARE_PRODUCT)}`),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8ODWq.LazyPeopleSettings)
        ]
    }));

});
parcelRegister("9X7Hu", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAccessRedirectRoute", () => $82c1f2665cb2cc20$export$55335c81a2be4654);
const $82c1f2665cb2cc20$export$55335c81a2be4654 = {
    name: 'project-settings-software-access-redirect',
    path: '/jira/software/projects/:projectKey/settings/people',
    exact: true
};

});

parcelRegister("8ODWq", function(module, exports) {

$parcel$export(module.exports, "LazyPeopleSettings", () => $3671536b80f548b9$export$7eee4f97b7a1273);
$parcel$export(module.exports, "peopleAccessRedirect", () => $3671536b80f548b9$export$45346ed2aa24e3f3);
$parcel$export(module.exports, "default", () => $3671536b80f548b9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $7tQej = parcelRequire("7tQej");

const $3671536b80f548b9$export$7eee4f97b7a1273 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("8pwbR"))), {
    moduleId: "./src/packages/spa-apps/project-settings/people/src/index.tsx"
});
const $3671536b80f548b9$var$PeopleAccessRedirectInner = ({ match: match, basePath: basePath })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `${basePath}/projects/${String(match.params.projectKey)}/settings/access`,
        push: false
    });
const $3671536b80f548b9$export$45346ed2aa24e3f3 = (basePath)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3671536b80f548b9$var$PeopleAccessRedirectInner, {
            match: match,
            basePath: basePath
        });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3671536b80f548b9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3671536b80f548b9$export$7eee4f97b7a1273,
        pageId: "project-settings-people",
        shouldShowSpinner: false
    });

});


parcelRegister("aLuho", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAccessRouteEntry", () => $298f52c63e8d86c3$export$a5ead9d0de14b14b);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $lJe4p = parcelRequire("lJe4p");

var $jaAyo = parcelRequire("jaAyo");

var $e7bC3 = parcelRequire("e7bC3");

var $8ODWq = parcelRequire("8ODWq");

var $1XdKx = parcelRequire("1XdKx");
const $298f52c63e8d86c3$export$a5ead9d0de14b14b = (0, $7NszV.createEntry)((0, $lJe4p.projectSettingsSoftwareAccessRoute), ()=>({
        group: 'project-settings-software',
        skeleton: (0, $jaAyo.ProjectSettingsAccessSkeleton),
        component: (0, $8ODWq.default),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8ODWq.LazyPeopleSettings)
        ],
        ufoName: 'project-settings.access'
    }));

});
parcelRegister("lJe4p", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAccessRoute", () => $b825fa291dbed4f2$export$db689602f90567d8);
const $b825fa291dbed4f2$export$db689602f90567d8 = {
    name: 'project-settings-software-access',
    path: '/jira/software/projects/:projectKey/settings/access',
    exact: true
};

});


parcelRegister("3YX4q", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAppsFieldsRouteEntry", () => $0c75b4b7b48f7f91$export$78d9c4be1503dd23);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $d6jlO = parcelRequire("d6jlO");

var $e7bC3 = parcelRequire("e7bC3");

var $5GDQc = parcelRequire("5GDQc");

var $1XdKx = parcelRequire("1XdKx");
const $0c75b4b7b48f7f91$export$78d9c4be1503dd23 = (0, $7NszV.createEntry)((0, $d6jlO.projectSettingsSoftwareAppsFieldsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $5GDQc.default),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5GDQc.LazyConnectAppControlsSettings)
        ]
    }));

});
parcelRegister("d6jlO", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAppsFieldsRoute", () => $d1b04e5d85adc782$export$333c94a9ec1a1535);
const $d1b04e5d85adc782$export$333c94a9ec1a1535 = {
    name: 'project-settings-software-apps-fields',
    path: '/jira/software/projects/:projectKey/settings/apps/app-fields',
    exact: true
};

});

parcelRegister("5GDQc", function(module, exports) {

$parcel$export(module.exports, "LazyConnectAppControlsSettings", () => $c49a5a5e07aed0ac$export$246ec9cdadd2a163);
$parcel$export(module.exports, "default", () => $c49a5a5e07aed0ac$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $dAfqg = parcelRequire("dAfqg");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $7tQej = parcelRequire("7tQej");

var $looJs = parcelRequire("looJs");

const $c49a5a5e07aed0ac$export$246ec9cdadd2a163 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("1j8hG"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-app-controls/src/index.tsx"
});
const $c49a5a5e07aed0ac$var$ConnectAppsRedirectInner = ({ match: match, basePath: basePath })=>{
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const shouldRedirect = projectContext != null && projectContext.simplified && projectContext.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);
    return shouldRedirect ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `${basePath}/projects/${String(match.params.projectKey)}/settings/apps/app-fields`,
        push: false
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $looJs.default), null);
};
const $c49a5a5e07aed0ac$export$cc3414a2d9daf70d = (basePath)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c49a5a5e07aed0ac$var$ConnectAppsRedirectInner, {
            match: match,
            basePath: basePath
        });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c49a5a5e07aed0ac$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $c49a5a5e07aed0ac$export$246ec9cdadd2a163,
        pageId: "project-settings-connect-app-controls",
        shouldShowSpinner: false
    });

});
parcelRegister("looJs", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab1da42a9104ecee$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $ab1da42a9104ecee$export$fa3bc297af95f169 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("3cuPS"))), {
    moduleId: "./src/packages/spa-apps/project-settings/app-discovery-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ab1da42a9104ecee$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ab1da42a9104ecee$export$fa3bc297af95f169,
        pageId: "project-settings-app-discovery-settings",
        shouldShowSpinner: false
    });

});



parcelRegister("kEFGH", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAppsRouteEntry", () => $0ed53dac2f0a0ceb$export$290fcdffa80c48ce);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $g44Z8 = parcelRequire("g44Z8");

var $e7bC3 = parcelRequire("e7bC3");

var $jwbRB = parcelRequire("jwbRB");

var $1XdKx = parcelRequire("1XdKx");
const $0ed53dac2f0a0ceb$export$290fcdffa80c48ce = (0, $7NszV.createEntry)((0, $g44Z8.projectSettingsSoftwareAppsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $jwbRB.default),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jwbRB.LazyConnectAppsSettings)
        ]
    }));

});
parcelRegister("g44Z8", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAppsRoute", () => $2fe06dc3c4459510$export$aece357f5f434121);
const $2fe06dc3c4459510$export$aece357f5f434121 = {
    name: 'project-settings-software-apps',
    path: '/jira/software/projects/:projectKey/settings/apps/:appId?',
    exact: true
};

});

parcelRegister("jwbRB", function(module, exports) {

$parcel$export(module.exports, "LazyConnectAppsSettings", () => $0d3ebe2f9030fc49$export$3633e017e520a1c2);
$parcel$export(module.exports, "default", () => $0d3ebe2f9030fc49$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $0d3ebe2f9030fc49$export$3633e017e520a1c2 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("flIAq"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-apps/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0d3ebe2f9030fc49$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $0d3ebe2f9030fc49$export$3633e017e520a1c2,
        pageId: "project-settings-connect-apps",
        shouldShowSpinner: false
    });

});


parcelRegister("kwWQ0", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAutomationRouteEntry", () => $5d7bd87a7c840c7a$export$fb1f0477184046c5);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $lecb5 = parcelRequire("lecb5");

var $e7bC3 = parcelRequire("e7bC3");

var $kdqX9 = parcelRequire("kdqX9");

var $1XdKx = parcelRequire("1XdKx");
const $5d7bd87a7c840c7a$export$fb1f0477184046c5 = (0, $7NszV.createEntry)((0, $lecb5.projectSettingsSoftwareAutomationRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $kdqX9.default),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kdqX9.LazyProjectSettingsJiraAutomation)
        ]
    }));

});
parcelRegister("lecb5", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAutomationRoute", () => $fc9d7be9739092f6$export$4d430aeb28b702f8);
const $fc9d7be9739092f6$export$4d430aeb28b702f8 = {
    name: 'project-settings-software-automation',
    path: '/jira/software/projects/:projectKey/settings/automation',
    exact: true
};

});


parcelRegister("7F7I9", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsCardRouteEntry", () => $f60e688753874fc2$export$ca616a5516b2e16d);

var $ffza4 = parcelRequire("ffza4");

var $1xZqw = parcelRequire("1xZqw");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $63xkH = parcelRequire("63xkH");

var $e7bC3 = parcelRequire("e7bC3");

var $1XdKx = parcelRequire("1XdKx");

var $lN3Iw = parcelRequire("lN3Iw");
const $f60e688753874fc2$export$ca616a5516b2e16d = (0, $7NszV.createEntry)((0, $63xkH.projectSettingsSoftwareBoardsCardRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'board-settings-apps.card-cover-settings-page.page.load',
        component: (0, $lN3Iw.default),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)(),
            (0, $1xZqw.cardCoverImageResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $lN3Iw.LazyCard)
        ]
    }));

});
parcelRegister("1xZqw", function(module, exports) {

$parcel$export(module.exports, "cardCoverImageResource", () => $0fcabd2255a2311c$export$f37f52e28126ce75);

var $dXq4S = parcelRequire("dXq4S");

var $ao2h1 = parcelRequire("ao2h1");

var $eQDse = parcelRequire("eQDse");

const $0fcabd2255a2311c$export$f37f52e28126ce75 = (0, $ao2h1.createRelayResource)({
    type: (0, $b9b0da783aed9042$export$d9d248919fbd0611),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $eQDse.default),
            variables: {
                boardId: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("eQDse", function(module, exports) {

$parcel$export(module.exports, "default", () => $19be575ffa3b6370$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<18030b1362ffffdd2f24b83852b88efd>>
 * @relayHash b790d69589aa0ef2a06a10dc57fc6bfc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4216a4fc24eb7ed0390f1effcdb5558af09a70f95660a0c572ae4b531ddc98fc
const $19be575ffa3b6370$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "cardCoverSettingsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "SoftwareBoard",
                                    "kind": "LinkedField",
                                    "name": "board",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "toggle_boardSettingsCard_CardCoverToggle"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "cardPreview_boardSettingsCard"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.board"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "boardScope"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "cardCoverSettingsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SoftwareBoard",
                            "kind": "LinkedField",
                            "name": "board",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CardMediaConfig",
                                    "kind": "LinkedField",
                                    "name": "cardMedia",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "enabled"
                                        }
                                    ]
                                },
                                v2 /*: any*/ 
                            ]
                        },
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "4216a4fc24eb7ed0390f1effcdb5558af09a70f95660a0c572ae4b531ddc98fc",
            "metadata": {},
            "name": "cardCoverSettingsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$19be575ffa3b6370$var$node.hash = "eb3068eeffbe9ec2fb99186c54005ea6";
var $19be575ffa3b6370$export$2e2bcd8739ae039 = $19be575ffa3b6370$var$node;

});

const $b9b0da783aed9042$export$d9d248919fbd0611 = 'BOARD_CONTEXT_CARD_COVER_SETTINGS';


parcelRegister("63xkH", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsCardRoute", () => $fd58dce0fef4a2da$export$d3f185a361401db7);
const $fd58dce0fef4a2da$export$d3f185a361401db7 = {
    name: 'project-settings-software-boards-card',
    path: '/jira/software/projects/:projectKey/settings/boards/:boardId/card',
    exact: true
};

});

parcelRegister("lN3Iw", function(module, exports) {

$parcel$export(module.exports, "LazyCard", () => $4bec2fc264f66dc5$export$40ff283c032abbc4);
$parcel$export(module.exports, "default", () => $4bec2fc264f66dc5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $4bec2fc264f66dc5$export$40ff283c032abbc4 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("3YP1H")), {
    moduleId: "./src/packages/spa-apps/project-settings/board-settings/card/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4bec2fc264f66dc5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $4bec2fc264f66dc5$export$40ff283c032abbc4,
        pageId: "board-settings-card",
        shouldShowSpinner: false
    });

});
parcelRegister("3YP1H", function(module, exports) {

let $2e5e8e7a6b33af0b$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("1u6BA"), 4)),
    $2e5e8e7a6b33af0b$var$load("jP6Yz")
]).then(()=>parcelRequire('dgQTq'));

});



parcelRegister("2OQWG", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsCsmRouteEntry", () => $5614131c72bf5418$export$7a31e42733ba05a0);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $g6Dtv = parcelRequire("g6Dtv");

var $e7bC3 = parcelRequire("e7bC3");

var $dtjqc = parcelRequire("dtjqc");

var $1XdKx = parcelRequire("1XdKx");
const $5614131c72bf5418$export$7a31e42733ba05a0 = (0, $7NszV.createEntry)((0, $g6Dtv.projectSettingsSoftwareBoardsCsmRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'software.next-gen.boards.column-status-mapping.page.load',
        component: (0, $dtjqc.default),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $dtjqc.LazyCsmSettings)
        ]
    }));

});
parcelRegister("g6Dtv", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsCsmRoute", () => $e2028f4601d0a4d1$export$88e68eb447e3db49);
const $e2028f4601d0a4d1$export$88e68eb447e3db49 = {
    name: 'project-settings-software-boards-csm',
    path: '/jira/software/projects/:projectKey/settings/boards/:boardId/columns',
    exact: true
};

});

parcelRegister("dtjqc", function(module, exports) {

$parcel$export(module.exports, "LazyCsmSettings", () => $f25068ef108ee62d$export$de293ea44d0410ca);
$parcel$export(module.exports, "default", () => $f25068ef108ee62d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $f25068ef108ee62d$export$de293ea44d0410ca = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("kaHVp"))), {
    moduleId: "./src/packages/spa-apps/project-settings/csm/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f25068ef108ee62d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f25068ef108ee62d$export$de293ea44d0410ca,
        pageId: "project-settings-csm",
        shouldShowSpinner: false
    });

});
parcelRegister("kaHVp", function(module, exports) {

let $eaf6d061f5a770d6$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("8OpWG"), 4)),
    $eaf6d061f5a770d6$var$load("ffQaD"),
    $eaf6d061f5a770d6$var$load("kvRbA"),
    $eaf6d061f5a770d6$var$load("4YWoA")
]).then(()=>parcelRequire('jFUmz'));

});



parcelRegister("4eRSO", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsCustomFiltersRouteEntry", () => $e8af9bf5c835f1d8$export$6332ad3e1d8d721);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $cD3jo = parcelRequire("cD3jo");

var $7NszV = parcelRequire("7NszV");

var $VF0KL = parcelRequire("VF0KL");

var $e7bC3 = parcelRequire("e7bC3");

var $gqIYW = parcelRequire("gqIYW");

var $1XdKx = parcelRequire("1XdKx");
const $e8af9bf5c835f1d8$export$6332ad3e1d8d721 = (0, $7NszV.createEntry)((0, $VF0KL.projectSettingsSoftwareBoardsCustomFiltersRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.custom-filters',
        component: (0, $gqIYW.default),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)(),
            (0, $cD3jo.customFiltersResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gqIYW.LazyCustomFiltersSettings)
        ]
    }));

});
parcelRegister("cD3jo", function(module, exports) {

$parcel$export(module.exports, "customFiltersResource", () => $ca950ad823e84673$export$3e390340716755de);

var $dXq4S = parcelRequire("dXq4S");

var $ao2h1 = parcelRequire("ao2h1");

var $WcCM5 = parcelRequire("WcCM5");

const $ca950ad823e84673$export$3e390340716755de = (0, $ao2h1.createRelayResource)({
    type: (0, $ad903674eb868bde$export$5917fd27c14066cd),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $WcCM5.default),
            variables: {
                boardId: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("WcCM5", function(module, exports) {

$parcel$export(module.exports, "default", () => $5edc411e6b038299$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6c655bf5d42bc04990088e48dc6b757f>>
 * @relayHash 82ae1b9c2b4e7b31e211094a4e3f4f3f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c990befb5021511de9b1550aa7300067f8d87644e0d370c3754283355de50686
const $5edc411e6b038299$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "customFiltersQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "CustomFilter",
                                    "kind": "LinkedField",
                                    "name": "customFilters",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "card_projectSettingsCustomFilters_customFilterFragmentRef"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.customFilters"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "card_projectSettingsCustomFilters_boardScopeFragmentRef"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "expandedCard_projectSettingsCustomFilters_boardScopeFragmentRef"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "boardScope"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "customFiltersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "CustomFilter",
                            "kind": "LinkedField",
                            "name": "customFilters",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "concreteType": "FilterQuery",
                                    "kind": "LinkedField",
                                    "name": "filterQuery",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "sanitisedJql"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "errors"
                                        }
                                    ]
                                },
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        },
                        v3 /*: any*/ ,
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "c990befb5021511de9b1550aa7300067f8d87644e0d370c3754283355de50686",
            "metadata": {},
            "name": "customFiltersQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5edc411e6b038299$var$node.hash = "2c5c0d030a87f3820766a2a896d71275";
var $5edc411e6b038299$export$2e2bcd8739ae039 = $5edc411e6b038299$var$node;

});

const $ad903674eb868bde$export$5917fd27c14066cd = 'NEXTGEN_PROJECT_SETTINGS_CUSTOM_FILTERS';


parcelRegister("VF0KL", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsCustomFiltersRoute", () => $0d2b719554e610ba$export$9bc9b345958a301c);
const $0d2b719554e610ba$export$9bc9b345958a301c = {
    name: 'project-settings-software-boards-custom-filters',
    path: '/jira/software/projects/:projectKey/settings/boards/:boardId/custom-filters',
    exact: true
};

});

parcelRegister("gqIYW", function(module, exports) {

$parcel$export(module.exports, "LazyCustomFiltersSettings", () => $26928850e3bfb37f$export$7e21d36a9d4548e6);
$parcel$export(module.exports, "default", () => $26928850e3bfb37f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $26928850e3bfb37f$export$7e21d36a9d4548e6 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("FptVO")), {
    moduleId: "./src/packages/spa-apps/project-settings/custom-filters/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$26928850e3bfb37f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $26928850e3bfb37f$export$7e21d36a9d4548e6,
        pageId: "project-settings-custom-filters",
        shouldShowSpinner: true
    });

});
parcelRegister("FptVO", function(module, exports) {

let $07c798990cc1bed3$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $07c798990cc1bed3$var$load("ffQaD"),
    $07c798990cc1bed3$var$load("kvRbA"),
    $07c798990cc1bed3$var$load("1QfoG")
]).then(()=>parcelRequire('keIpy'));

});



parcelRegister("b9Dpn", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsRedirectRouteEntry", () => $966af26f7fec7c46$export$cb6169207ddfd1b2);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $dieXh = parcelRequire("dieXh");

var $e7bC3 = parcelRequire("e7bC3");

var $9PHNK = parcelRequire("9PHNK");

var $1XdKx = parcelRequire("1XdKx");
const $966af26f7fec7c46$export$cb6169207ddfd1b2 = (0, $7NszV.createEntry)((0, $dieXh.projectSettingsSoftwareBoardsRedirectRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $9PHNK.BoardSettingsRedirectToCSM),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        isRedirect: true,
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("dieXh", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsRedirectRoute", () => $31cf97a1a4a84207$export$989ca67485551616);
const $31cf97a1a4a84207$export$989ca67485551616 = {
    name: 'project-settings-software-boards-redirect',
    path: '/jira/software/projects/:projectKey/settings/boards/:boardId',
    exact: true
};

});


parcelRegister("eitw0", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsRoadmapRouteEntry", () => $6d01f44cfcf07c9a$export$6d5eadd440c430f5);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $2FXLN = parcelRequire("2FXLN");

var $1V8vh = parcelRequire("1V8vh");

var $e7bC3 = parcelRequire("e7bC3");

var $9PHNK = parcelRequire("9PHNK");

var $1XdKx = parcelRequire("1XdKx");

var $aXcNG = parcelRequire("aXcNG");
const $6d01f44cfcf07c9a$export$6d5eadd440c430f5 = (0, $7NszV.createEntry)((0, $1V8vh.projectSettingsSoftwareBoardsRoadmapRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $9PHNK.RoadmapSettingsRedirectToTimelineSettings),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)(),
            (0, $2FXLN.roadmapSettingsResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aXcNG.LazyRoadmap)
        ]
    }));

});
parcelRegister("2FXLN", function(module, exports) {

$parcel$export(module.exports, "roadmapSettingsResource", () => $265fc06fbb6443a3$export$7901a008bd73bf46);

var $dXq4S = parcelRequire("dXq4S");

var $ao2h1 = parcelRequire("ao2h1");

var $6VnEZ = parcelRequire("6VnEZ");

const $265fc06fbb6443a3$export$7901a008bd73bf46 = (0, $ao2h1.createRelayResource)({
    type: (0, $87d7efe6336d8b83$export$e905b9170ecbb599),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>{
        const { cloudId: cloudId } = tenantContext;
        return {
            parameters: (0, $6VnEZ.default),
            variables: {
                sourceAri: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                }),
                locationAri: undefined
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    }
});

});
parcelRegister("6VnEZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a28994bc59c1b6c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<549802b43e67112dd5fba3309099c2de>>
 * @relayHash 19ad9a547bce255c35adc444386a03af
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6603bfc1272bd596fb67b3022210270e42d5bfb54ab2cf66470e7e5a8934ba80
const $4a28994bc59c1b6c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locationAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sourceAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "locationARI",
            "variableName": "locationAri"
        },
        {
            "kind": "Variable",
            "name": "sourceARI",
            "variableName": "sourceAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "isSprintsFeatureEnabled"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "roadmapSettingsQuery",
            "selections": [
                {
                    "concreteType": "RoadmapsQuery",
                    "kind": "LinkedField",
                    "name": "roadmaps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "RoadmapDetails",
                            "kind": "LinkedField",
                            "name": "roadmapForSource",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "RoadmapConfiguration",
                                        "kind": "LinkedField",
                                        "name": "roadmapConfiguration",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "RoadmapBoardConfiguration",
                                                    "kind": "LinkedField",
                                                    "name": "boardConfiguration",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "childIssuesSchedulingToggle_boardSettingsRoadmap"
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "childIssuesSchedulingPreview_boardSettingsRoadmap"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "roadmaps.roadmapForSource.roadmapConfiguration.boardConfiguration"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "roadmaps.roadmapForSource.roadmapConfiguration"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "roadmapSettingsQuery",
            "selections": [
                {
                    "concreteType": "RoadmapsQuery",
                    "kind": "LinkedField",
                    "name": "roadmaps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "RoadmapDetails",
                            "kind": "LinkedField",
                            "name": "roadmapForSource",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "RoadmapConfiguration",
                                    "kind": "LinkedField",
                                    "name": "roadmapConfiguration",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "RoadmapBoardConfiguration",
                                            "kind": "LinkedField",
                                            "name": "boardConfiguration",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isChildIssuePlanningEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "childIssuePlanningMode"
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6603bfc1272bd596fb67b3022210270e42d5bfb54ab2cf66470e7e5a8934ba80",
            "metadata": {},
            "name": "roadmapSettingsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4a28994bc59c1b6c$var$node.hash = "31c20159daaa03716587a1ccbe27ab14";
var $4a28994bc59c1b6c$export$2e2bcd8739ae039 = $4a28994bc59c1b6c$var$node;

});

const $87d7efe6336d8b83$export$75dfa03544a19422 = 'ROADMAP';
const $87d7efe6336d8b83$export$e3b1cd17bd82de3d = 'CLASSIC_ROADMAP';
const $87d7efe6336d8b83$export$e905b9170ecbb599 = 'BOARD_CONTEXT_ROADMAP_SETTINGS';


parcelRegister("1V8vh", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsRoadmapRoute", () => $a1437557f2047801$export$17ccdaa366ec26b8);
const $a1437557f2047801$export$17ccdaa366ec26b8 = {
    name: 'project-settings-software-boards-roadmap',
    path: '/jira/software/projects/:projectKey/settings/boards/:boardId/roadmap',
    exact: true
};

});

parcelRegister("aXcNG", function(module, exports) {

$parcel$export(module.exports, "LazyRoadmap", () => $50cd29d3245ccefc$export$8eca5454e72ee961);
$parcel$export(module.exports, "default", () => $50cd29d3245ccefc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $4R6GH = parcelRequire("4R6GH");

var $j8DrX = parcelRequire("j8DrX");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $50cd29d3245ccefc$export$8eca5454e72ee961 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("JMguM")), {
    moduleId: "./src/packages/spa-apps/project-settings/board-settings/roadmap/src/index.tsx"
});
const $50cd29d3245ccefc$var$AsyncProjectSettingsRoadmap = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "project-settings.roadmap",
        teamName: "chronos",
        attributes: {
            isSynthetic: (0, $4R6GH.fg)('is_synthetic_tenant') || (0, $j8DrX.default)('ajs-is-synthetic') === 'true'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $50cd29d3245ccefc$export$8eca5454e72ee961,
        pageId: "board-settings-roadmap",
        shouldShowSpinner: false
    }));
var $50cd29d3245ccefc$export$2e2bcd8739ae039 = $50cd29d3245ccefc$var$AsyncProjectSettingsRoadmap;

});
parcelRegister("JMguM", function(module, exports) {

let $0899a484be15b455$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0899a484be15b455$var$load("aEr6V").then(()=>parcelRequire('5d39M'));

});



parcelRegister("14ooS", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsTimelineRouteEntry", () => $aeb3431f883d58ca$export$cc224b8b7595975b);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $2FXLN = parcelRequire("2FXLN");

var $at8lb = parcelRequire("at8lb");

var $e7bC3 = parcelRequire("e7bC3");

var $1XdKx = parcelRequire("1XdKx");

var $aXcNG = parcelRequire("aXcNG");
const $aeb3431f883d58ca$export$cc224b8b7595975b = (0, $7NszV.createEntry)((0, $at8lb.projectSettingsSoftwareBoardsTimelineRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'board-settings-apps.roadmap-settings-page.page.load',
        component: (0, $aXcNG.default),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)(),
            (0, $2FXLN.roadmapSettingsResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aXcNG.LazyRoadmap)
        ]
    }));

});
parcelRegister("at8lb", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsTimelineRoute", () => $cc4b8dfb5f37c2a0$export$e116d6b2a5f71426);
const $cc4b8dfb5f37c2a0$export$e116d6b2a5f71426 = {
    name: 'project-settings-software-boards-timeline',
    path: '/jira/software/projects/:projectKey/settings/boards/:boardId/timeline',
    exact: true
};

});


parcelRegister("lWR9T", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareDataClassificationsRouteEntry", () => $fb225e359b3a3445$export$cc932462de184b27);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $flo0i = parcelRequire("flo0i");

var $jaAyo = parcelRequire("jaAyo");

var $e7bC3 = parcelRequire("e7bC3");

var $ejqjx = parcelRequire("ejqjx");

var $1XdKx = parcelRequire("1XdKx");
const $fb225e359b3a3445$export$cc932462de184b27 = (0, $7NszV.createEntry)((0, $flo0i.projectSettingsSoftwareDataClassificationsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $ejqjx.default),
        skeleton: (0, $jaAyo.ProjectSettingsDetailsSkeleton),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ejqjx.LazyDataClassificationsSettings)
        ]
    })); /**
 * Contains all software settings routes using the new url format `jira/:product/projects/:projectKey/settings`.
 */ 

});
parcelRegister("flo0i", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareDataClassificationsRoute", () => $09578e3175fbd546$export$af525a8f93b72cc7);
const $09578e3175fbd546$export$af525a8f93b72cc7 = {
    name: 'project-settings-software-data-classifications',
    path: '/jira/software/projects/:projectKey/settings/data-classifications',
    exact: true
};

});

parcelRegister("ejqjx", function(module, exports) {

$parcel$export(module.exports, "LazyDataClassificationsSettings", () => $81cf21747f4c944d$export$b8abcf8aa8f4df56);
$parcel$export(module.exports, "default", () => $81cf21747f4c944d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $81cf21747f4c944d$export$b8abcf8aa8f4df56 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("foQoc"))), {
    moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$81cf21747f4c944d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $81cf21747f4c944d$export$b8abcf8aa8f4df56,
        pageId: "project-settings-data-classifications",
        shouldShowSpinner: false
    });

});


parcelRegister("6DlqX", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareDetailsRouteEntry", () => $a903695c1ce96a1b$export$8440d3384846d9b8);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $a1v1W = parcelRequire("a1v1W");

var $jaAyo = parcelRequire("jaAyo");

var $e7bC3 = parcelRequire("e7bC3");

var $cYgMq = parcelRequire("cYgMq");

var $1XdKx = parcelRequire("1XdKx");
const $a903695c1ce96a1b$export$8440d3384846d9b8 = (0, $7NszV.createEntry)((0, $a1v1W.projectSettingsSoftwareDetailsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $cYgMq.default),
        skeleton: (0, $jaAyo.ProjectSettingsDetailsSkeleton),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cYgMq.LazyDetailsSettings)
        ]
    }));

});
parcelRegister("a1v1W", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareDetailsRoute", () => $6754d8275b08745c$export$8760347e2b0955eb);
const $6754d8275b08745c$export$8760347e2b0955eb = {
    name: 'project-settings-software-details',
    path: '/jira/software/projects/:projectKey/settings/details',
    exact: true
};

});


parcelRegister("jCfr4", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareFieldsRouteEntry", () => $2b9364818ff70bc7$export$e6b200b5a1ce3063);

var $ffza4 = parcelRequire("ffza4");

var $7XYc4 = parcelRequire("7XYc4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $e7C7O = parcelRequire("e7C7O");

var $5lsNZ = parcelRequire("5lsNZ");

var $eUAWy = parcelRequire("eUAWy");

var $e7bC3 = parcelRequire("e7bC3");

var $6s1PB = parcelRequire("6s1PB");

var $kwZwx = parcelRequire("kwZwx");

var $1XdKx = parcelRequire("1XdKx");
const $2b9364818ff70bc7$var$isEfaExperimentExposed = ()=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('efa_and_project_fields_page_for_tmp');
    return expConfig.get('isEnabled', false);
};
const $2b9364818ff70bc7$export$e6b200b5a1ce3063 = (0, $7NszV.createEntry)((0, $eUAWy.projectSettingsSoftwareFieldsRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.fields.jsw-tmp',
        component: (0, $7XYc4.componentWithCondition)($2b9364818ff70bc7$var$isEfaExperimentExposed, (0, $kwZwx.default), (0, $5lsNZ.default)),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)(),
            (0, $e7C7O.fieldSettingsRelayResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kwZwx.LazyFieldsSettings)
        ]
    }));

});
parcelRegister("eUAWy", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareFieldsRoute", () => $507c3ff044231698$export$1ab9d3299fbc789b);
const $507c3ff044231698$export$1ab9d3299fbc789b = {
    name: 'project-settings-software-fields',
    path: '/jira/software/projects/:projectKey/settings/fields',
    exact: true
};

});

parcelRegister("kwZwx", function(module, exports) {

$parcel$export(module.exports, "LazyFieldsSettings", () => $628b742891e4f718$export$e309780f520d125a);
$parcel$export(module.exports, "default", () => $628b742891e4f718$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $628b742891e4f718$export$e309780f520d125a = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("cqfV9"))), {
    moduleId: "./src/packages/spa-apps/project-settings/fields/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$628b742891e4f718$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $628b742891e4f718$export$e309780f520d125a,
        pageId: "project-settings-fields",
        shouldShowSpinner: true
    });

});


parcelRegister("kRn5i", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareIssuetypesRouteEntry", () => $a62547b317f1890b$export$84a9a2dce32d93aa);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $7Uj8H = parcelRequire("7Uj8H");

var $e7bC3 = parcelRequire("e7bC3");

var $9PHNK = parcelRequire("9PHNK");

var $6UFDl = parcelRequire("6UFDl");

var $1XdKx = parcelRequire("1XdKx");
const $a62547b317f1890b$export$84a9a2dce32d93aa = (0, $7NszV.createEntry)((0, $7Uj8H.projectSettingsSoftwareIssuetypesRoute), ()=>({
        group: 'project-settings-software',
        ufoName: (0, $9PHNK.getUFOName)('project-settings-software-issuetypes'),
        component: (0, $6UFDl.default),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6UFDl.LazyIssueTypeSettings)
        ]
    }));

});
parcelRegister("7Uj8H", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareIssuetypesRoute", () => $1344929ef12856ff$export$7f26edefe51efc38);
const $1344929ef12856ff$export$7f26edefe51efc38 = {
    name: 'project-settings-software-issuetypes',
    path: '/jira/software/projects/:projectKey/settings/issuetypes/:issueTypeId?',
    exact: true
};

});

parcelRegister("6UFDl", function(module, exports) {

$parcel$export(module.exports, "LazyIssueTypeSettings", () => $8f1b2ea450c47b3b$export$36dcfb52d47cb93a);
$parcel$export(module.exports, "default", () => $8f1b2ea450c47b3b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $8f1b2ea450c47b3b$export$36dcfb52d47cb93a = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("7a4qW"))), {
    moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8f1b2ea450c47b3b$export$2e2bcd8739ae039 = ({ match: match })=>{
    const { issueTypeId: issueTypeId } = match.params;
    // unique pageId need to be set so that ApdexProvider would properly reset all the performance marks when switching between issue types
    const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8f1b2ea450c47b3b$export$36dcfb52d47cb93a,
        pageId: pageId,
        shouldShowSpinner: false
    });
};

});


parcelRegister("3NIY8", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareIssuetypesWorkflowRouteEntry", () => $991168ab4a6e6879$export$58ca33ed538911cb);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $9QOPa = parcelRequire("9QOPa");

var $e7bC3 = parcelRequire("e7bC3");

var $6UFDl = parcelRequire("6UFDl");

var $1XdKx = parcelRequire("1XdKx");

var $cNuJO = parcelRequire("cNuJO");
const $991168ab4a6e6879$export$58ca33ed538911cb = (0, $7NszV.createEntry)((0, $9QOPa.projectSettingsSoftwareIssuetypesWorkflowRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $cNuJO.default),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6UFDl.LazyIssueTypeSettings)
        ]
    }));

});
parcelRegister("9QOPa", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareIssuetypesWorkflowRoute", () => $2d01183c61a2983c$export$de010d824a551ec);
const $2d01183c61a2983c$export$de010d824a551ec = {
    name: 'project-settings-software-issuetypes-workflow',
    path: '/jira/software/projects/:projectKey/settings/issuetypes/:issueTypeId/:initialSection(workflow)',
    exact: true
};

});

parcelRegister("cNuJO", function(module, exports) {

$parcel$export(module.exports, "default", () => $48f5bfd32d483aba$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $48f5bfd32d483aba$export$cb608e3696682e76 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("gEQDq"))), {
    moduleId: "./src/packages/spa-apps/project-settings/workflow-navigation/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$48f5bfd32d483aba$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $48f5bfd32d483aba$export$cb608e3696682e76,
        pageId: "project-settings-workflow-navigation",
        shouldShowSpinner: false
    });

});


parcelRegister("fjYA2", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNextGenFeaturesRouteEntry", () => $71f1d776dd1bcb90$export$81067f5196099c81);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $hJYLH = parcelRequire("hJYLH");

var $jaAyo = parcelRequire("jaAyo");

var $e7bC3 = parcelRequire("e7bC3");

var $eNw6s = parcelRequire("eNw6s");

var $1XdKx = parcelRequire("1XdKx");
const $71f1d776dd1bcb90$export$81067f5196099c81 = (0, $7NszV.createEntry)((0, $hJYLH.projectSettingsSoftwareNextGenFeaturesRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.next-gen-features',
        component: (0, $eNw6s.default),
        skeleton: (0, $jaAyo.ProjectSettingsFeaturesSkeleton),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $eNw6s.LazyFeaturesSettings)
        ]
    }));

});
parcelRegister("hJYLH", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNextGenFeaturesRoute", () => $78ec600058c356ce$export$12c7a1737b594a28);
const $78ec600058c356ce$export$12c7a1737b594a28 = {
    name: 'project-settings-software-next-gen-features',
    path: '/jira/software/projects/:projectKey/settings/features',
    exact: true
};

});

parcelRegister("eNw6s", function(module, exports) {

$parcel$export(module.exports, "LazyFeaturesSettings", () => $4e545f86ddd60f53$export$da4d608b99858bfc);
$parcel$export(module.exports, "default", () => $4e545f86ddd60f53$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $4e545f86ddd60f53$export$da4d608b99858bfc = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("jgiOL"))), {
    moduleId: "./src/packages/spa-apps/project-settings/next-gen-features/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4e545f86ddd60f53$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $4e545f86ddd60f53$export$da4d608b99858bfc,
        pageId: "project-settings-next-gen-features",
        shouldShowSpinner: false
    });

});
parcelRegister("jgiOL", function(module, exports) {

let $e05e1bc168e3a744$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e05e1bc168e3a744$var$load("zWsTk").then(()=>parcelRequire('2MwfB'));

});



parcelRegister("qdq3O", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNotificationEmailCRouteEntry", () => $70f72ce01753856b$export$9bb08b8e1b39d15f);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $iqUDj = parcelRequire("iqUDj");

var $jaAyo = parcelRequire("jaAyo");

var $e7bC3 = parcelRequire("e7bC3");

var $9T2qH = parcelRequire("9T2qH");

var $4glor = parcelRequire("4glor");
const $70f72ce01753856b$export$9bb08b8e1b39d15f = (0, $7NszV.createEntry)((0, $iqUDj.projectSettingsSoftwareNotificationEmailCRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $9T2qH.default),
        skeleton: (0, $jaAyo.ProjectSettingsFeaturesSkeleton),
        layout: (0, $e7bC3.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $dxCvy.projectContextResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4glor.LazySoftwareClassicFeatures),
            (0, $9T2qH.LazyProjectSettingsNotificationEmail)
        ]
    }));

});
parcelRegister("iqUDj", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNotificationEmailCRoute", () => $660f0733dcb91b32$export$dda91725b6c4a039);
const $660f0733dcb91b32$export$dda91725b6c4a039 = {
    name: 'project-settings-software-notifications-notification-email',
    path: '/jira/software/c/projects/:projectKey/settings/notifications/notification-email',
    exact: true
};

});

parcelRegister("9T2qH", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsNotificationEmail", () => $6e8f6f53c599ad60$export$ea7d73c94d9369f4);
$parcel$export(module.exports, "default", () => $6e8f6f53c599ad60$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $6e8f6f53c599ad60$export$ea7d73c94d9369f4 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hLnUL"))), {
    moduleId: "./src/packages/spa-apps/project-settings/notification-email/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6e8f6f53c599ad60$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $6e8f6f53c599ad60$export$ea7d73c94d9369f4,
        pageId: "project-settings-email-notifications",
        shouldShowSpinner: true
    });

});


parcelRegister("aY70k", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNotificationEmailRouteEntry", () => $96e097b23221938d$export$8a17783c300fca11);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $dXGLS = parcelRequire("dXGLS");

var $jaAyo = parcelRequire("jaAyo");

var $e7bC3 = parcelRequire("e7bC3");

var $1XdKx = parcelRequire("1XdKx");
const $96e097b23221938d$export$8a17783c300fca11 = (0, $7NszV.createEntry)((0, $dXGLS.projectSettingsSoftwareNotificationEmailRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $1XdKx.RedirectForSettings),
        skeleton: (0, $jaAyo.ProjectSettingsFeaturesSkeleton),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("dXGLS", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNotificationEmailRoute", () => $427d02b02ceb584b$export$d4ed083331cb6e00);
const $427d02b02ceb584b$export$d4ed083331cb6e00 = {
    name: 'project-settings-software-notifications-notification-email',
    path: '/jira/software/projects/:projectKey/settings/notifications/notification-email',
    exact: true
};

});


parcelRegister("2wF9u", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNotificationsIssueLogsRouteEntry", () => $c50f7899cb2834ba$export$9c37d834dfe46ebf);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $be8d4 = parcelRequire("be8d4");

var $e7bC3 = parcelRequire("e7bC3");

var $1XdKx = parcelRequire("1XdKx");

var $14B4q = parcelRequire("14B4q");
const $c50f7899cb2834ba$export$9c37d834dfe46ebf = (0, $7NszV.createEntry)((0, $be8d4.projectSettingsSoftwareNotificationsIssueLogsRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.software.notifications.issue-logs',
        component: (0, $14B4q.SoftwareNotificationsIssueLogs),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $14B4q.LazySoftwareNotificationsIssueLogs)
        ],
        entryPoint () {
            return 0, $14B4q.emailNotificationsLogEntryPointPage;
        }
    }));

});
parcelRegister("be8d4", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNotificationsIssueLogsRoute", () => $2685d8d8e87c6306$export$ff4977f79c273b29);
const $2685d8d8e87c6306$export$ff4977f79c273b29 = {
    name: 'project-settings-software-notifications-issue-logs',
    path: '/jira/software/projects/:projectKey/settings/notifications/issue-logs',
    exact: true
};

});


parcelRegister("feDOq", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNotificationsRouteEntry", () => $d6aa89f0f35f02a8$export$1c340fa0c9022252);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $567rt = parcelRequire("567rt");

var $e7bC3 = parcelRequire("e7bC3");

var $1XdKx = parcelRequire("1XdKx");

var $8Z6ZD = parcelRequire("8Z6ZD");
const $d6aa89f0f35f02a8$export$1c340fa0c9022252 = (0, $7NszV.createEntry)((0, $567rt.projectSettingsSoftwareNotificationsRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.software.notifications',
        component: (0, $8Z6ZD.default),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8Z6ZD.LazySoftwareNotificationsSettings)
        ]
    }));

});
parcelRegister("567rt", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNotificationsRoute", () => $93d386ac6f219e91$export$c1d1892d6c07135a);
const $93d386ac6f219e91$export$c1d1892d6c07135a = {
    name: 'project-settings-software-notifications',
    path: '/jira/software/projects/:projectKey/settings/notifications',
    exact: true
};

});

parcelRegister("8Z6ZD", function(module, exports) {

$parcel$export(module.exports, "LazySoftwareNotificationsSettings", () => $576f902bdb908a77$export$69a64a29d67ca160);
$parcel$export(module.exports, "default", () => $576f902bdb908a77$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $576f902bdb908a77$export$69a64a29d67ca160 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("fhvdd"))), {
    moduleId: "./src/packages/spa-apps/project-settings/software-notifications/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$576f902bdb908a77$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $576f902bdb908a77$export$69a64a29d67ca160,
        pageId: "project-settings-software-notifications",
        shouldShowSpinner: false
    });

});


parcelRegister("cqk4B", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareProformaJiraFormBuilderRouteEntry", () => $219ec4fb78eddcea$export$5606059eca31e30);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $hDUMP = parcelRequire("hDUMP");

var $e7bC3 = parcelRequire("e7bC3");

var $1XdKx = parcelRequire("1XdKx");

var $8JnjW = parcelRequire("8JnjW");
const $219ec4fb78eddcea$export$5606059eca31e30 = (0, $7NszV.createEntry)((0, $hDUMP.projectSettingsSoftwareProformaJiraFormBuilderRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $8JnjW.default),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8JnjW.LazyProjectSettingsProformaJiraFormBuilder)
        ],
        perfMetricKey: 'form-builder'
    }));

});
parcelRegister("hDUMP", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareProformaJiraFormBuilderRoute", () => $b09cc9a715d5f75a$export$cf33294d9d90a855);
const $b09cc9a715d5f75a$export$cf33294d9d90a855 = {
    name: 'project-settings-software-proforma-jira-form-builder',
    path: '/jira/software/projects/:projectKey/settings/forms/form/:templateFormId/edit',
    exact: true
};

});


parcelRegister("d66ag", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareProformaProjectFormsRouteEntry", () => $1f2ddc69ff9bd153$export$ea77a3e974b26072);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $f5WPG = parcelRequire("f5WPG");

var $e7bC3 = parcelRequire("e7bC3");

var $1XdKx = parcelRequire("1XdKx");

var $gyEpf = parcelRequire("gyEpf");
const $1f2ddc69ff9bd153$export$ea77a3e974b26072 = (0, $7NszV.createEntry)((0, $f5WPG.projectSettingsSoftwareProformaProjectFormsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $gyEpf.default),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gyEpf.LazyProjectSettingsProformaProjectForms)
        ],
        perfMetricKey: 'forms-settings'
    }));

});
parcelRegister("f5WPG", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareProformaProjectFormsRoute", () => $f94052f77c0e6bf4$export$750dec948cc98062);
const $f94052f77c0e6bf4$export$750dec948cc98062 = {
    name: 'project-settings-software-proforma-project-forms',
    path: '/jira/software/projects/:projectKey/settings/forms',
    exact: true
};

});


parcelRegister("84EwA", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareRedirectRouteEntry", () => $156cde955bd90b23$export$e5caf0892d6025c9);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $c8fK3 = parcelRequire("c8fK3");

var $e7bC3 = parcelRequire("e7bC3");

var $1XdKx = parcelRequire("1XdKx");
const $156cde955bd90b23$export$e5caf0892d6025c9 = (0, $7NszV.createEntry)((0, $c8fK3.projectSettingsSoftwareRedirectRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $1XdKx.RedirectForSettings),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("c8fK3", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareRedirectRoute", () => $4fd256cbd670956d$export$168cc8ed4398c230);
const $4fd256cbd670956d$export$168cc8ed4398c230 = {
    // the following route should be non-exact, it will handle "index" and "404" cases
    name: 'project-settings-software-redirect',
    path: '/jira/software/projects/:projectKey/settings'
};

});


parcelRegister("7dYbE", function(module, exports) {

$parcel$export(module.exports, "projectSettingsToolchainRouteEntry", () => $eb246e0ef2b2c1c3$export$dd97d29f96b25d09);

var $ffza4 = parcelRequire("ffza4");

var $bwLf9 = parcelRequire("bwLf9");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $35Wvp = parcelRequire("35Wvp");

var $5lsNZ = parcelRequire("5lsNZ");

var $6eLkt = parcelRequire("6eLkt");

var $kfztd = parcelRequire("kfztd");

var $e7bC3 = parcelRequire("e7bC3");

var $aA5DA = parcelRequire("aA5DA");

var $1XdKx = parcelRequire("1XdKx");
const $eb246e0ef2b2c1c3$export$dd97d29f96b25d09 = (0, $7NszV.createEntry)((0, $6eLkt.projectSettingsToolchainRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $bwLf9.default)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $aA5DA.default)),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)(),
            (0, $35Wvp.projectSettingsToolchainResource)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aA5DA.LazyDevOpsConnectionsSettings)
        ],
        ufoName: 'project-settings.devops-connections'
    }));

});
parcelRegister("6eLkt", function(module, exports) {

$parcel$export(module.exports, "projectSettingsToolchainRoute", () => $f16500562a276728$export$e3e3877ec9c5e840);
const $f16500562a276728$export$e3e3877ec9c5e840 = {
    name: 'project-settings-software-toolchain-team-managed',
    path: '/jira/software/projects/:projectKey/settings/toolchain',
    exact: true
};

});


parcelRegister("dRm2C", function(module, exports) {

$parcel$export(module.exports, "projectSettingsVersionsRouteEntry", () => $1aa15c245eff2860$export$4791201b4877aa5d);

var $ffza4 = parcelRequire("ffza4");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $bC7QJ = parcelRequire("bC7QJ");

var $7GnDe = parcelRequire("7GnDe");

var $cXVqt = parcelRequire("cXVqt");

var $cSUZZ = parcelRequire("cSUZZ");

var $af7CK = parcelRequire("af7CK");
const $1aa15c245eff2860$export$4791201b4877aa5d = (0, $7NszV.createEntry)((0, $cXVqt.projectSettingsVersionsRoute), ()=>({
        group: 'components',
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $dxCvy.projectContextResource),
            (0, $bC7QJ.projectVersionsRelayResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        component: (0, $af7CK.RelayVersions),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $af7CK.LazyRelayProjectVersions)
        ]
    }));

});
parcelRegister("bC7QJ", function(module, exports) {

$parcel$export(module.exports, "projectVersionsRelayResource", () => $d194483d3a062e97$export$7e8aa1360f86345c);
/* eslint-disable jira/import-whitelist */ 
var $8Uumt = parcelRequire("8Uumt");


var $e8T8A = parcelRequire("e8T8A");

var $5yJb9 = parcelRequire("5yJb9");

var $kipqU = parcelRequire("kipqU");

var $ao2h1 = parcelRequire("ao2h1");

var $lqMPx = parcelRequire("lqMPx");

var $2M1hQ = parcelRequire("2M1hQ");

var $4R6GH = parcelRequire("4R6GH");

const $d194483d3a062e97$export$7e8aa1360f86345c = (0, $2M1hQ.createResource)({
    type: `${(0, $ao2h1.RELAY_RESOURCE_TYPE)}_${(0, $92b865e141ed2a4f$export$59aa73792ad9507a)}`,
    getKey: ({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        return `project-version-query-relay-${projectKey}`;
    },
    // @ts-expect-error - might return null
    getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const queryReference = (0, $8Uumt.loadQuery)((0, $5yJb9.default)(), (0, $lqMPx.default), {
            initialLoadCount: 20,
            cloudId: tenantContext.cloudId,
            projectKey: match.params.projectKey,
            filter: (0, $e8T8A.transformStatusFromParam)(query[0, $6868fc0fce0c2912$export$3e8168848b996f7]),
            searchString: query[0, $6868fc0fce0c2912$export$a181206198b7f50c] || '',
            sortBy: {
                sortByField: (0, $e8T8A.transformSortFieldFromParam)(query[0, $6868fc0fce0c2912$export$a3482d3a8df0e725]),
                order: (0, $e8T8A.transformSortOrderFromParam)(query[0, $6868fc0fce0c2912$export$71089821f361e881])
            },
            isManageVersionsPermissionEnabled: (0, $4R6GH.fg)('vmc-11-manage-versions-permission')
        }, {
            fetchPolicy: 'store-or-network'
        });
        if (false && queryReference.id != null) await (0, $kipqU.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});

});
const $6868fc0fce0c2912$export$a181206198b7f50c = 'contains';
const $6868fc0fce0c2912$export$3e8168848b996f7 = 'status';
const $6868fc0fce0c2912$export$71089821f361e881 = 'orderDirection';
const $6868fc0fce0c2912$export$a3482d3a8df0e725 = 'orderField';
const $6868fc0fce0c2912$export$3c5e605ca7ade9f2 = 'NAME';
const $6868fc0fce0c2912$export$50241fe906e4f94e = 'RELEASE_DATE';
const $6868fc0fce0c2912$export$99a467bcc22b8df9 = 'START_DATE';
const $6868fc0fce0c2912$export$d44826c816b5619b = 'DESCRIPTION';
const $6868fc0fce0c2912$export$34694f8d8b23ee2a = 'SEQUENCE';
const $6868fc0fce0c2912$export$cb638d1fae624fbf = 20;
const $6868fc0fce0c2912$export$bbcbc202f2dfa28c = 3;
const $6868fc0fce0c2912$export$b983f2cb1f658a55 = 'RELEASED';
const $6868fc0fce0c2912$export$cb459d726a8530a5 = 'UNRELEASED';
const $6868fc0fce0c2912$export$c936349447a77fe0 = 'ARCHIVED';
const $6868fc0fce0c2912$export$c5ed97509d0e2aaf = 'projectVersions';

parcelRegister("e8T8A", function(module, exports) {

$parcel$export(module.exports, "transformStatusFromParam", () => $b959dd84148d7436$export$5760f9690301cdb);
$parcel$export(module.exports, "transformStatusToParam", () => $b959dd84148d7436$export$46595832dd863016);
$parcel$export(module.exports, "transformSortOrderFromParam", () => $b959dd84148d7436$export$1945e6d2f31e09e6);
$parcel$export(module.exports, "transformSortFieldFromParam", () => $b959dd84148d7436$export$f842a0d1846d319d);
$parcel$export(module.exports, "transformStatusToDropdownSelection", () => $b959dd84148d7436$export$7dad705635760cfe);
$parcel$export(module.exports, "getUpdatedDisplayedStatuses", () => $b959dd84148d7436$export$ce4c948ba1d53df4);
$parcel$export(module.exports, "getFormattedVersionDate", () => $b959dd84148d7436$export$5a6eeb16be7dd21d);


var $1O7Kb = parcelRequire("1O7Kb");

var $brjCS = parcelRequire("brjCS");

const $b959dd84148d7436$export$5760f9690301cdb = (input)=>{
    switch(input){
        case 'no-filter':
            return [
                (0, $brjCS.RELEASED),
                (0, $brjCS.UNRELEASED),
                (0, $brjCS.ARCHIVED)
            ];
        case 'all':
            return [
                (0, $brjCS.RELEASED),
                (0, $brjCS.UNRELEASED),
                (0, $brjCS.ARCHIVED)
            ];
        default:
            {
                const params = (input || '').split('-');
                const result = [
                    ...params.includes('released') ? [
                        (0, $brjCS.RELEASED)
                    ] : [],
                    ...params.includes('unreleased') ? [
                        (0, $brjCS.UNRELEASED)
                    ] : [],
                    ...params.includes('archived') ? [
                        (0, $brjCS.ARCHIVED)
                    ] : []
                ];
                return result.length ? result : [
                    (0, $brjCS.UNRELEASED)
                ];
            }
    }
};
const $b959dd84148d7436$export$46595832dd863016 = (input)=>{
    if (input) {
        if (input.length === 0) return 'no-filter';
        if (input.length > 2) return 'all';
        return [
            input.includes((0, $brjCS.RELEASED)) && [
                'released'
            ],
            input.includes((0, $brjCS.UNRELEASED)) && [
                'unreleased'
            ],
            input.includes((0, $brjCS.ARCHIVED)) && [
                'archived'
            ]
        ].filter(Boolean).join('-');
    }
    return undefined;
};
const $b959dd84148d7436$export$1945e6d2f31e09e6 = (input)=>{
    switch(input){
        case 'ASC':
            return 0, $2a9e000a443b1a95$export$1dee026a19752d6b;
        case 'DESC':
            return 0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65;
        default:
            return 0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65;
    }
};
const $b959dd84148d7436$export$f842a0d1846d319d = (input)=>{
    switch(input){
        case 'NAME':
            return 0, $6868fc0fce0c2912$export$3c5e605ca7ade9f2;
        case 'RELEASEDATE':
            return 0, $6868fc0fce0c2912$export$50241fe906e4f94e;
        case 'STARTDATE':
            return 0, $6868fc0fce0c2912$export$99a467bcc22b8df9;
        case 'DESCRIPTION':
            return 0, $6868fc0fce0c2912$export$d44826c816b5619b;
        case 'SEQUENCE':
            return 0, $6868fc0fce0c2912$export$34694f8d8b23ee2a;
        default:
            return 0, $6868fc0fce0c2912$export$34694f8d8b23ee2a;
    }
};
const $b959dd84148d7436$export$7dad705635760cfe = (input)=>{
    switch(input){
        case 'no-filter':
            return [];
        case 'all':
            return [
                (0, $brjCS.RELEASED),
                (0, $brjCS.UNRELEASED),
                (0, $brjCS.ARCHIVED)
            ];
        default:
            {
                const params = (input || '').split('-');
                const result = [
                    ...params.includes('released') ? [
                        (0, $brjCS.RELEASED)
                    ] : [],
                    ...params.includes('unreleased') ? [
                        (0, $brjCS.UNRELEASED)
                    ] : [],
                    ...params.includes('archived') ? [
                        (0, $brjCS.ARCHIVED)
                    ] : []
                ];
                return result.length ? result : [
                    (0, $brjCS.UNRELEASED)
                ];
            }
    }
};
const $b959dd84148d7436$export$ce4c948ba1d53df4 = (displayedStatuses, selectedStatuses, newStatus)=>{
    // Handle the case when a status is selected after deselection of all in dropdown where versions in all statuses are displayed despite empty selection & deselecting a status from a full selection.
    if (displayedStatuses.length === (0, $6868fc0fce0c2912$export$bbcbc202f2dfa28c)) {
        if (!selectedStatuses.length) return [
            newStatus
        ];
        return displayedStatuses.filter((status)=>status !== newStatus);
    }
    return displayedStatuses.includes(newStatus) ? displayedStatuses.filter((item)=>item !== newStatus) : [
        ...displayedStatuses,
        newStatus
    ];
};
const $b959dd84148d7436$export$5a6eeb16be7dd21d = (versionDate, formatDate)=>versionDate != null ? formatDate(new Date(versionDate), {
        timeZone: (0, $1O7Kb.VERSION_DATE_FORMAT_OPTION).timeZone,
        dateStyle: 'long'
    }) : '';

});
parcelRegister("1O7Kb", function(module, exports) {

$parcel$export(module.exports, "VERSION_DATE_FORMAT_OPTION", () => $db4b27c65287280e$export$d54c0d576c2caef5);
// Used to format date string from the server to display version start date and release date
// Server only stores date without any time information such as 2023-12-31
// Use this WHENEVER displaying version start date and release date.
// If you respect local timezone without this constant, there will be a bug that will display one day early date in negative timezones.
// https://jira.atlassian.com/browse/JSWCLOUD-22316
const $db4b27c65287280e$export$d54c0d576c2caef5 = {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC'
};

});

parcelRegister("brjCS", function(module, exports) {

$parcel$export(module.exports, "RELEASED", () => $96a1491cb0f9d4eb$export$b983f2cb1f658a55);
$parcel$export(module.exports, "UNRELEASED", () => $96a1491cb0f9d4eb$export$cb459d726a8530a5);
$parcel$export(module.exports, "ARCHIVED", () => $96a1491cb0f9d4eb$export$c936349447a77fe0);
const $96a1491cb0f9d4eb$export$b983f2cb1f658a55 = 'RELEASED';
const $96a1491cb0f9d4eb$export$cb459d726a8530a5 = 'UNRELEASED';
const $96a1491cb0f9d4eb$export$c936349447a77fe0 = 'ARCHIVED';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$96a1491cb0f9d4eb$export$2e2bcd8739ae039 = [
    $96a1491cb0f9d4eb$export$b983f2cb1f658a55,
    $96a1491cb0f9d4eb$export$cb459d726a8530a5,
    $96a1491cb0f9d4eb$export$c936349447a77fe0
];

});


parcelRegister("lqMPx", function(module, exports) {

$parcel$export(module.exports, "default", () => $08cc25b93689af36$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<be6ae44fd11772903154fa2ff10aa6ce>>
 * @relayHash f6deebf30059f6281cb9bf02e6322b7d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a175b6c61bf13924cb07158ed38861f8913923419e12aad6abdd2052a17b0395
const $08cc25b93689af36$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "initialLoadCount"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isManageVersionsPermissionEnabled"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchString"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortBy"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "key"
    }, v11 = {
        "alias": "jiraProjectType",
        "kind": "ScalarField",
        "name": "projectType"
    }, v12 = [
        {
            "kind": "Literal",
            "name": "type",
            "value": "MANAGE_VERSIONS"
        }
    ], v13 = {
        "kind": "ScalarField",
        "name": "canPerform"
    }, v14 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v15 = {
        "kind": "Variable",
        "name": "searchString",
        "variableName": "searchString"
    }, v16 = {
        "kind": "Variable",
        "name": "sortBy",
        "variableName": "sortBy"
    }, v17 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v18 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v19 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v20 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v21 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v22 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "initialLoadCount"
    }, v23 = [
        v14 /*: any*/ ,
        v22 /*: any*/ ,
        v15 /*: any*/ ,
        v16 /*: any*/ 
    ], v24 = {
        "kind": "ScalarField",
        "name": "id"
    }, v25 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v26 = [
        v25 /*: any*/ 
    ], v27 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": "DONE"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "uiProjectVersionsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v8 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.projectId"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v9 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.name"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v10 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.key"
                                        },
                                        v11 /*: any*/ ,
                                        {
                                            "condition": "isManageVersionsPermissionEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "alias": "canEditVersions",
                                                    "args": v12 /*: any*/ ,
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v13 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "jira.jiraProjectByKey.canEditVersions.canPerform"
                                                        }
                                                    ],
                                                    "storageKey": "action(type:\"MANAGE_VERSIONS\")"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "alias": "versions",
                                                "args": [
                                                    v14 /*: any*/ ,
                                                    v15 /*: any*/ ,
                                                    v16 /*: any*/ 
                                                ],
                                                "concreteType": "JiraVersionConnection",
                                                "kind": "LinkedField",
                                                "name": "__uiProject__versions_connection",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraVersionEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            v17 /*: any*/ ,
                                                            v18 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraVersion",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v17 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "QueryError",
                                                        "kind": "LinkedField",
                                                        "name": "errors",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "extensions",
                                                                "plural": true,
                                                                "selections": [
                                                                    v19 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    v20 /*: any*/ ,
                                                    v21 /*: any*/ 
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.versions"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "args": [
                        v14 /*: any*/ ,
                        v22 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "isManageVersionsPermissionEnabled",
                            "variableName": "isManageVersionsPermissionEnabled"
                        },
                        v15 /*: any*/ ,
                        v16 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "table_projectVersions"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "uiProjectVersionsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                {
                                    "condition": "isManageVersionsPermissionEnabled",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "canEditVersions",
                                            "args": v12 /*: any*/ ,
                                            "concreteType": "JiraProjectAction",
                                            "kind": "LinkedField",
                                            "name": "action",
                                            "plural": false,
                                            "selections": [
                                                v13 /*: any*/ 
                                            ],
                                            "storageKey": "action(type:\"MANAGE_VERSIONS\")"
                                        }
                                    ]
                                },
                                {
                                    "args": v23 /*: any*/ ,
                                    "concreteType": "JiraVersionConnection",
                                    "kind": "LinkedField",
                                    "name": "versions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraVersionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraVersion",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v24 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "status"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "startDate"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "releaseDate"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "overdue"
                                                        },
                                                        {
                                                            "alias": "allIssues",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "filter",
                                                                    "value": "ALL"
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v26 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"ALL\")"
                                                        },
                                                        {
                                                            "alias": "doneIssues",
                                                            "args": v27 /*: any*/ ,
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v26 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"DONE\")"
                                                        },
                                                        {
                                                            "alias": "done",
                                                            "args": v27 /*: any*/ ,
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v26 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"DONE\")"
                                                        },
                                                        {
                                                            "alias": "inProgress",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "filter",
                                                                    "value": "IN_PROGRESS"
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v26 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"IN_PROGRESS\")"
                                                        },
                                                        {
                                                            "alias": "toDo",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "filter",
                                                                    "value": "TODO"
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v26 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"TODO\")"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "versionId"
                                                        },
                                                        v9 /*: any*/ ,
                                                        v21 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "QueryError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v19 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        v25 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v23 /*: any*/ ,
                                    "filters": [
                                        "filter",
                                        "searchString",
                                        "sortBy"
                                    ],
                                    "handle": "connection",
                                    "key": "uiProject__versions",
                                    "kind": "LinkedHandle",
                                    "name": "versions"
                                },
                                v24 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a175b6c61bf13924cb07158ed38861f8913923419e12aad6abdd2052a17b0395",
            "metadata": {
                "connection": [
                    {
                        "count": "initialLoadCount",
                        "cursor": null,
                        "direction": "forward",
                        "path": [
                            "jira",
                            "jiraProjectByKey",
                            "versions"
                        ]
                    }
                ]
            },
            "name": "uiProjectVersionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$08cc25b93689af36$var$node.hash = "d200347d20dfa0c568d719d21b96cc62";
var $08cc25b93689af36$export$2e2bcd8739ae039 = $08cc25b93689af36$var$node;

});

const $92b865e141ed2a4f$export$59aa73792ad9507a = 'PROJECT_VERSIONS';


parcelRegister("cXVqt", function(module, exports) {

$parcel$export(module.exports, "projectSettingsVersionsRoute", () => $b9ce459589c7232c$export$cc9450e5d7579b99);
const $b9ce459589c7232c$export$cc9450e5d7579b99 = {
    name: 'project-settings-versions',
    path: '/plugins/servlet/project-config/:projectKey/administer-versions'
};

});

parcelRegister("af7CK", function(module, exports) {

$parcel$export(module.exports, "LazyRelayProjectVersions", () => $4b5729de9815f9dc$export$9036da4fa9f7a66f);
$parcel$export(module.exports, "RelayVersions", () => $4b5729de9815f9dc$export$9aff7dab80671d9);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $4b5729de9815f9dc$export$9036da4fa9f7a66f = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("9HXr2"))), {
    moduleId: "./src/packages/spa-apps/project/relay-versions/src/index.tsx"
});
const $4b5729de9815f9dc$export$9aff7dab80671d9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $4b5729de9815f9dc$export$9036da4fa9f7a66f,
        pageId: "relay-project-versions",
        shouldShowSpinner: false
    });

});
parcelRegister("9HXr2", function(module, exports) {

let $71163bc214002fdb$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $71163bc214002fdb$var$load("ffQaD"),
    $71163bc214002fdb$var$load("kvRbA"),
    $71163bc214002fdb$var$load("gq5gC")
]).then(()=>parcelRequire('5E2pR'));

});



parcelRegister("1Ps9S", function(module, exports) {

$parcel$export(module.exports, "projectsRedirectRouteEntry", () => $c72266bbdc090734$export$56f9921db324f30);

var $ffza4 = parcelRequire("ffza4");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $7MCPm = parcelRequire("7MCPm");

var $2iuKi = parcelRequire("2iuKi");
const $c72266bbdc090734$export$56f9921db324f30 = (0, $7NszV.createEntry)((0, $2iuKi.projectsRedirectRoute), ()=>({
        group: 'redirects',
        isRedirect: true,
        component: (0, $7MCPm.RedirectToLastVisitedProjectPage),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("2iuKi", function(module, exports) {

$parcel$export(module.exports, "projectsRedirectRoute", () => $3aa0370b36d3207d$export$e6bc3ea427ddafb8);
const $3aa0370b36d3207d$export$e6bc3ea427ddafb8 = {
    name: 'projects-redirect',
    path: '/projects/:projectKey',
    query: [
        'selectedItem!=(.+)'
    ],
    exact: true
};

});


parcelRegister("bRRmd", function(module, exports) {

$parcel$export(module.exports, "projectVersionsRouteEntry", () => $3890e3ec7715d603$export$982bc443ef89cc3f);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $bC7QJ = parcelRequire("bC7QJ");

var $7GnDe = parcelRequire("7GnDe");

var $1G6pd = parcelRequire("1G6pd");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $3890e3ec7715d603$var$LazyRelayProjectVersions = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("9HXr2"))), {
    moduleId: "./src/packages/spa-apps/project/relay-versions/src/index.tsx"
});
const $3890e3ec7715d603$var$RelayVersions = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3890e3ec7715d603$var$LazyRelayProjectVersions,
        pageId: "relay-project-versions",
        shouldShowSpinner: false
    });
const $3890e3ec7715d603$export$982bc443ef89cc3f = (0, $7NszV.createEntry)((0, $1G6pd.projectVersionsRoute), ()=>({
        group: 'components',
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $bC7QJ.projectVersionsRelayResource)
        ],
        component: $3890e3ec7715d603$var$RelayVersions,
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $3890e3ec7715d603$var$LazyRelayProjectVersions
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("1G6pd", function(module, exports) {

$parcel$export(module.exports, "projectVersionsRoute", () => $4cfeade459489896$export$fb5516756c3eba40);

var $kMGqE = parcelRequire("kMGqE");
const $4cfeade459489896$export$fb5516756c3eba40 = {
    name: 'project-versions',
    path: '/projects/:projectKey',
    query: (0, $kMGqE.PROJECTS_VERSIONS_QUERY_PARAMS)
};

});
parcelRegister("kMGqE", function(module, exports) {

$parcel$export(module.exports, "PROJECTS_VERSIONS_QUERY_PARAMS", () => $91224398be5e0171$export$ad46185437bb571a);
const $91224398be5e0171$export$ad46185437bb571a = [
    'selectedItem=com.atlassian.jira.jira-projects-plugin:release-page'
];

});



parcelRegister("1XAMa", function(module, exports) {

$parcel$export(module.exports, "promotionsRouteEntry", () => $2e7db6c4b913404f$export$875d88a44b1ff74c);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $iHiHz = parcelRequire("iHiHz");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $jcvAd = parcelRequire("jcvAd");

var $10giJ = parcelRequire("10giJ");
const $2e7db6c4b913404f$export$875d88a44b1ff74c = (0, $7NszV.createEntry)((0, $jcvAd.promotionsRoute), ()=>({
        group: 'marketplace',
        component: (0, $10giJ.MarketplaceComponent),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).ADDONS,
            sidebar: (0, $iHiHz.default)
        },
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $5bkvv.getNavigationSidebarGlobalSettingsResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $10giJ.LazyMarketplace)
        ],
        ufoName: 'embedded-marketplace'
    }));

});
parcelRegister("jcvAd", function(module, exports) {

$parcel$export(module.exports, "promotionsRoute", () => $bc8d892f5d9c1f9e$export$45df65bfacbf9a2a);
const $bc8d892f5d9c1f9e$export$45df65bfacbf9a2a = {
    name: 'marketplace-promotions',
    path: '/jira/marketplace/manage/promotions'
};

});


parcelRegister("aA0rC", function(module, exports) {

$parcel$export(module.exports, "rapidboardBacklog1RouteEntry", () => $1bf0295d0982658a$export$ee2385c1acba53f2);

var $7NszV = parcelRequire("7NszV");

var $16Z5s = parcelRequire("16Z5s");

var $f5kpo = parcelRequire("f5kpo");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $fKmub = parcelRequire("fKmub");

var $e2ctp = parcelRequire("e2ctp");

var $i8JTM = parcelRequire("i8JTM");

var $aPfsS = parcelRequire("aPfsS");

var $gyYxw = parcelRequire("gyYxw");

var $g5RGc = parcelRequire("g5RGc");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $5f2bR = parcelRequire("5f2bR");

var $3RJkv = parcelRequire("3RJkv");

var $7uLIV = parcelRequire("7uLIV");

var $ffza4 = parcelRequire("ffza4");

var $3Lsjg = parcelRequire("3Lsjg");

const $1bf0295d0982658a$export$ee2385c1acba53f2 = (0, $7NszV.createEntry)((0, $3Lsjg.rapidboardBacklog1Route), ()=>({
        group: 'classic-software',
        ufoName: 'classic-backlog',
        component: (0, $16Z5s.RapidBoardSpaPage),
        skeleton: (0, $i8JTM.NextGenBacklogSkeleton),
        layout: (0, $aPfsS.composeLayouts)((0, $gyYxw.genericProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue',
                    'view=planning'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            ...(0, $3RJkv.getUserBoardNavigationResources)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $16Z5s.LazyRapidBoard),
            (0, $16Z5s.LazyRapidBoardApps)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$93104dc4eba58ba4)
        },
        earlyAssets: (0, $e2ctp.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        supportsPreviewPanel: true
    }));

});
parcelRegister("3Lsjg", function(module, exports) {

$parcel$export(module.exports, "rapidboardBacklog1Route", () => $af1c8b7df470b6b1$export$ff874528b0b33a61);
const $af1c8b7df470b6b1$export$ff874528b0b33a61 = {
    name: 'rapidboard-backlog',
    path: '/secure/RapidBoard.jspa',
    query: [
        'rapidView',
        'view=(planning|planning.nodetail)'
    ]
};

});


parcelRegister("hjVS0", function(module, exports) {

$parcel$export(module.exports, "rapidboardLastVisitedProjectRedirectRouteEntry", () => $09ab131c9331c58d$export$420f86cfd239da4d);

var $7NszV = parcelRequire("7NszV");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $5f2bR = parcelRequire("5f2bR");

var $3RJkv = parcelRequire("3RJkv");

var $ffza4 = parcelRequire("ffza4");

var $Th6Kd = parcelRequire("Th6Kd");

var $7MCPm = parcelRequire("7MCPm");
const $09ab131c9331c58d$export$420f86cfd239da4d = (0, $7NszV.createEntry)((0, $Th6Kd.rapidboardLastVisitedProjectRedirectRoute), ()=>({
        group: 'classic-software',
        component: (0, $7MCPm.RedirectToLastVisitedProjectPage),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        isRedirect: true,
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("Th6Kd", function(module, exports) {

$parcel$export(module.exports, "rapidboardLastVisitedProjectRedirectRoute", () => $848732acccd8706d$export$991b1be164057e91);
const $848732acccd8706d$export$991b1be164057e91 = {
    name: 'rapidboard-last-visited-project-redirect',
    path: '/secure/RapidBoard.jspa',
    query: [
        'projectKey'
    ],
    __unsafeOrder: 1
};

});


parcelRegister("jss6V", function(module, exports) {

$parcel$export(module.exports, "rapidboardReport1RouteEntry", () => $231e2e3fd736b80c$export$7e8c0a9f6d68837);

var $7NszV = parcelRequire("7NszV");

var $16Z5s = parcelRequire("16Z5s");

var $f5kpo = parcelRequire("f5kpo");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $fKmub = parcelRequire("fKmub");

var $e2ctp = parcelRequire("e2ctp");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $3RJkv = parcelRequire("3RJkv");

var $7uLIV = parcelRequire("7uLIV");

var $ffza4 = parcelRequire("ffza4");

var $fIEje = parcelRequire("fIEje");

var $7o1kb = parcelRequire("7o1kb");

var $yxwH0 = parcelRequire("yxwH0");
const $231e2e3fd736b80c$export$7e8c0a9f6d68837 = (0, $7NszV.createEntry)((0, $fIEje.rapidboardReport1Route), ()=>({
        group: 'classic-software',
        component: (0, $16Z5s.RapidBoardSpaPage),
        skeleton: (0, $7o1kb.ClassicReportSkeleton),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getRapidboardResources)(),
            ...(0, $yxwH0.getReportsCommonResource)(),
            ...(0, $3RJkv.getUserBoardNavigationResources)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $16Z5s.LazyRapidBoard),
            (0, $16Z5s.LazyRapidBoardApps)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        earlyAssets: (0, $e2ctp.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        ufoName: 'classic-report',
        supportsPreviewPanel: true
    }));

});
parcelRegister("fIEje", function(module, exports) {

$parcel$export(module.exports, "rapidboardReport1Route", () => $0732a35485277820$export$d27f9ad2fc277ff9);
const $0732a35485277820$export$d27f9ad2fc277ff9 = {
    name: 'rapidboard-report',
    path: '/secure/RapidBoard.jspa',
    query: [
        'rapidView',
        'view=reporting',
        'chart'
    ]
};

});

parcelRegister("7o1kb", function(module, exports) {

$parcel$export(module.exports, "ClassicReportSkeleton", () => $61f1e37e5e1946ad$export$d7667341f4db3b8d);

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $g5liH = parcelRequire("g5liH");
const $61f1e37e5e1946ad$export$d7667341f4db3b8d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($g5liH)))
    });

});
parcelRegister("g5liH", function(module, exports) {
module.exports = new URL("classic-report-app-skeleton.tpl.1daae66d.svg", import.meta.url).toString();

});



parcelRegister("1iYkP", function(module, exports) {

$parcel$export(module.exports, "rapidboardReportRouteEntry", () => $6946c90a7efbc538$export$745f1d5a2458a2d9);

var $7NszV = parcelRequire("7NszV");

var $hwrCN = parcelRequire("hwrCN");

var $16Z5s = parcelRequire("16Z5s");

var $7o1kb = parcelRequire("7o1kb");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $f5kpo = parcelRequire("f5kpo");

var $fKmub = parcelRequire("fKmub");

var $ffza4 = parcelRequire("ffza4");

var $e2ctp = parcelRequire("e2ctp");

var $yxwH0 = parcelRequire("yxwH0");

var $kJSiQ = parcelRequire("kJSiQ");
const $6946c90a7efbc538$export$745f1d5a2458a2d9 = (0, $7NszV.createEntry)((0, $hwrCN.rapidboardReportRoute), ()=>({
        group: 'classic-software',
        component: (0, $16Z5s.RapidBoardSpaPage),
        skeleton: (0, $7o1kb.ClassicReportSkeleton),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getRapidboardResources)(),
            ...(0, $yxwH0.getReportsCommonResource)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $16Z5s.LazyRapidBoard),
            (0, $16Z5s.LazyRapidBoardApps)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        earlyAssets: (0, $e2ctp.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        ufoName: 'classic-report',
        entryPoint: ()=>(0, $kJSiQ.reportPageEntrypoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("hwrCN", function(module, exports) {

$parcel$export(module.exports, "rapidboardReportRoute", () => $090be05d28e65948$export$d37f637b09fb9fda);
const $090be05d28e65948$export$d37f637b09fb9fda = {
    name: 'rapidboard-report',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/:chartView'
};

});

parcelRegister("kJSiQ", function(module, exports) {

$parcel$export(module.exports, "reportPageEntrypoint", () => $d52c4fa019e81654$export$73cecf7395943edd);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $3MyKR = parcelRequire("3MyKR");
const $d52c4fa019e81654$export$73cecf7395943edd = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $3MyKR.rapidBoardEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("3MyKR", function(module, exports) {

$parcel$export(module.exports, "rapidBoardEntryPoint", () => $366384de5193f3a2$export$15991360ec37fcaf);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $366384de5193f3a2$export$15991360ec37fcaf = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("kb1Oq")), {
        moduleId: "4d7ce9a3",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("kb1Oq", function(module, exports) {

let $eb063d987cfe43b1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eb063d987cfe43b1$var$load("ecERA").then(()=>parcelRequire('Gk4RP'));

});




parcelRegister("4XUsE", function(module, exports) {

$parcel$export(module.exports, "rapidboardUserBacklogRouteEntry", () => $5ef9e40cccee388d$export$ccde3c1d7a857b27);

var $7NszV = parcelRequire("7NszV");

var $f5kpo = parcelRequire("f5kpo");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $lJ1FP = parcelRequire("lJ1FP");

var $lfnsv = parcelRequire("lfnsv");

var $fKmub = parcelRequire("fKmub");

var $e2ctp = parcelRequire("e2ctp");

var $csqnl = parcelRequire("csqnl");

var $i8JTM = parcelRequire("i8JTM");

var $aPfsS = parcelRequire("aPfsS");

var $gyYxw = parcelRequire("gyYxw");

var $g5RGc = parcelRequire("g5RGc");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $5f2bR = parcelRequire("5f2bR");

var $3RJkv = parcelRequire("3RJkv");

var $7qieH = parcelRequire("7qieH");

var $2h7lp = parcelRequire("2h7lp");
const $5ef9e40cccee388d$export$ccde3c1d7a857b27 = (0, $7NszV.createEntry)((0, $csqnl.rapidboardUserBacklogRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $i8JTM.NextGenBacklogSkeleton),
        layout: (0, $aPfsS.composeLayouts)((0, $gyYxw.genericProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getUIFBacklogDataResource)(),
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            ...(0, $3RJkv.getUserBoardNavigationResources)(),
            (0, $lJ1FP.getEditModelResource)(),
            (0, $lfnsv.getBoardDetailsResource)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        entryPoint: ()=>(0, $2h7lp.backlogPageEntrypoint),
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            capability: (0, $7qieH.classicBacklogCapability)
        },
        earlyAssets: (0, $e2ctp.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        supportsPreviewPanel: true
    }));

});
parcelRegister("csqnl", function(module, exports) {

$parcel$export(module.exports, "rapidboardUserBacklogRoute", () => $710a0fc51c857594$export$79c2d9718e914f91);
const $710a0fc51c857594$export$79c2d9718e914f91 = {
    name: 'rapidboard-user-backlog',
    path: '/jira/people/:accountId/boards/:boardId/backlog'
};

});

parcelRegister("7qieH", function(module, exports) {

$parcel$export(module.exports, "classicBacklogCapability", () => $8c35ce65b592afc5$export$10a7bb102137d92b);

const $8c35ce65b592afc5$export$10a7bb102137d92b = !false ? (0, $281cbd47ba46dd7d$export$571692eec8a399e1) : (0, $281cbd47ba46dd7d$export$93104dc4eba58ba4);

});

parcelRegister("2h7lp", function(module, exports) {

$parcel$export(module.exports, "backlogPageEntrypoint", () => $89c165261f1ffe48$export$1ccf08591607897d);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $fo6b8 = parcelRequire("fo6b8");

var $6avBT = parcelRequire("6avBT");
const $89c165261f1ffe48$export$1ccf08591607897d = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $6avBT.nextGenBacklogEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});


parcelRegister("bbDvZ", function(module, exports) {

$parcel$export(module.exports, "rapidboardUserReportRouteEntry", () => $aba9ebd89ef67057$export$374d78dc1cde7b56);

var $7NszV = parcelRequire("7NszV");

var $f5kpo = parcelRequire("f5kpo");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $fKmub = parcelRequire("fKmub");

var $e2ctp = parcelRequire("e2ctp");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $3RJkv = parcelRequire("3RJkv");

var $jMZEA = parcelRequire("jMZEA");

var $7o1kb = parcelRequire("7o1kb");

var $yxwH0 = parcelRequire("yxwH0");

var $kJSiQ = parcelRequire("kJSiQ");
const $aba9ebd89ef67057$export$374d78dc1cde7b56 = (0, $7NszV.createEntry)((0, $jMZEA.rapidboardUserReportRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $7o1kb.ClassicReportSkeleton),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getRapidboardResources)(),
            ...(0, $yxwH0.getReportsCommonResource)(),
            ...(0, $3RJkv.getUserBoardNavigationResources)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        entryPoint: ()=>(0, $kJSiQ.reportPageEntrypoint),
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        earlyAssets: (0, $e2ctp.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        supportsPreviewPanel: true
    }));

});
parcelRegister("jMZEA", function(module, exports) {

$parcel$export(module.exports, "rapidboardUserReportRoute", () => $2f9ddde12b93dadf$export$7b85bca17717def6);
const $2f9ddde12b93dadf$export$7b85bca17717def6 = {
    name: 'rapidboard-user-report',
    path: '/jira/people/:accountId/boards/:boardId/reports/:chartView'
};

});


parcelRegister("e7GI8", function(module, exports) {

$parcel$export(module.exports, "rapidboardUserReportsOverviewRouteEntry", () => $2b4f7b178bf7d762$export$721c38d3152f9625);

var $7NszV = parcelRequire("7NszV");

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");

var $8OTYY = parcelRequire("8OTYY");

var $gyYxw = parcelRequire("gyYxw");

var $5f2bR = parcelRequire("5f2bR");

var $lkFvK = parcelRequire("lkFvK");

var $hBv66 = parcelRequire("hBv66");

var $f5kpo = parcelRequire("f5kpo");

var $fo6b8 = parcelRequire("fo6b8");

var $7GnDe = parcelRequire("7GnDe");

var $3RJkv = parcelRequire("3RJkv");

var $fh5Sl = parcelRequire("fh5Sl");
const $2b4f7b178bf7d762$var$reportsOverviewPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $fh5Sl.reportsOverviewPageEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $2b4f7b178bf7d762$export$721c38d3152f9625 = (0, $7NszV.createEntry)((0, $8OTYY.rapidboardUserReportsOverviewRoute), ()=>({
        group: 'classic-software',
        entryPoint () {
            return (0, $4R6GH.fg)('reports-overview-page-migration') ? $2b4f7b178bf7d762$var$reportsOverviewPageEntryPoint : undefined;
        },
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            ...(0, $3RJkv.getUserBoardNavigationResources)(),
            ...(0, $f5kpo.getRapidboardResources)()
        ],
        ufoName: 'reports-overview',
        supportsPreviewPanel: true
    }));

});
parcelRegister("8OTYY", function(module, exports) {

$parcel$export(module.exports, "rapidboardUserReportsOverviewRoute", () => $bd6a1ad5f3384924$export$6101ec4dca41c740);
const $bd6a1ad5f3384924$export$6101ec4dca41c740 = {
    name: 'rapidboard-user-reports-overview',
    path: '/jira/people/:accountId/boards/:boardId/reports'
};

});


parcelRegister("4Xzif", function(module, exports) {

$parcel$export(module.exports, "roleBasedNotificationDetailRouteEntry", () => $29aaea7e1c593cdc$export$565325825b04cec6);

var $hZVks = parcelRequire("hZVks");

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $8CqQS = parcelRequire("8CqQS");

var $7OghT = parcelRequire("7OghT");

var $k3GMp = parcelRequire("k3GMp");
const $29aaea7e1c593cdc$export$565325825b04cec6 = (0, $7NszV.createEntry)((0, $8CqQS.roleBasedNotificationDetailRoute), ()=>({
        group: 'eoc',
        component: (0, $7OghT.RoleBasedNotificationsComponent),
        layout: (0, $ibkIl.globalSettingsLayout),
        slot: (0, $k3GMp.RoleBasedNotificationDetail),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $hZVks.resources)[0],
            (0, $hZVks.resources)[1],
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        forPaint: [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7OghT.LazyRoleBasedNotifications)
        ]
    }));

});
parcelRegister("hZVks", function(module, exports) {

$parcel$export(module.exports, "roleBasedNotificationsResource", () => $a9efe5455286a2a7$export$9a716bf20d804ec3);
$parcel$export(module.exports, "notificationDetailResource", () => $a9efe5455286a2a7$export$8ad8a0a20fd0ed5a);
$parcel$export(module.exports, "resources", () => $a9efe5455286a2a7$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $5V1Ip = parcelRequire("5V1Ip");
const $a9efe5455286a2a7$export$9a716bf20d804ec3 = (0, $2M1hQ.createResource)({
    type: 'roleBasedNotificationsResource',
    getKey: ()=>'roleBasedNotificationsResource',
    getData: (0, $5V1Ip.getRoleBasedNotificationsEndpoint),
    isBrowserOnly: true,
    maxAge: 300000
});
const $a9efe5455286a2a7$export$8ad8a0a20fd0ed5a = (0, $2M1hQ.createResource)({
    type: 'notificationDetailResource',
    getKey: ({ match: match })=>{
        const settingId = match.params['id'];
        return `notificationDetailResource-id=${settingId}`;
    },
    getData: ({ match: match })=>{
        const settingId = match.params['id'];
        (0, $hmVmJ.assert)(!!settingId, new (0, $dH6Pi.AssertionError)('notificationDetailResource', 'settingId is required'));
        return (0, $5V1Ip.getRoleBasedNotificationDetailEndpoint)(settingId);
    },
    isBrowserOnly: true
});
const $a9efe5455286a2a7$export$bc99aaabaf7b70a7 = [
    $a9efe5455286a2a7$export$9a716bf20d804ec3,
    $a9efe5455286a2a7$export$8ad8a0a20fd0ed5a
];

});
parcelRegister("5V1Ip", function(module, exports) {

$parcel$export(module.exports, "getRoleBasedNotificationsEndpoint", () => $c1906554d85d7a30$export$db67dfe9fe98cd49);
$parcel$export(module.exports, "getRoleBasedNotificationDetailEndpoint", () => $c1906554d85d7a30$export$5522446e6d3ee73);

var $j74qU = parcelRequire("j74qU");
const $c1906554d85d7a30$export$db67dfe9fe98cd49 = ()=>(0, $j74qU.eocFetch)(`/v1/role-based-notifications`);
const $c1906554d85d7a30$export$5522446e6d3ee73 = (settingId)=>(0, $j74qU.eocFetch)(`/v1/role-based-notifications/${settingId}`);

});


parcelRegister("8CqQS", function(module, exports) {

$parcel$export(module.exports, "roleBasedNotificationDetailRoute", () => $8ff922c499db0d93$export$10ec812f053317c9);
const $8ff922c499db0d93$export$10ec812f053317c9 = {
    name: 'eoc-role-based-notifications-detail',
    path: '/jira/settings/products/ops/role-based-notifications/:id',
    exact: true
};

});

parcelRegister("7OghT", function(module, exports) {

$parcel$export(module.exports, "LazyRoleBasedNotifications", () => $1190c1dcb9a75d0f$export$15a244aba8f3b406);
$parcel$export(module.exports, "RoleBasedNotificationsComponent", () => $1190c1dcb9a75d0f$export$8994be6f8ad6a04a);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $1190c1dcb9a75d0f$export$15a244aba8f3b406 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("ksHZF")).then((module)=>module.RoleBasedNotificationsPage), {
    moduleId: "./src/packages/eoc/role-based-notifications/src/index.tsx"
});
const $1190c1dcb9a75d0f$export$8994be6f8ad6a04a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $1190c1dcb9a75d0f$export$15a244aba8f3b406,
        pageId: "async-jira-eoc-role-based-notifications",
        shouldShowSpinner: false
    });

});
parcelRegister("ksHZF", function(module, exports) {

let $ee588c5de5ed242d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ee588c5de5ed242d$var$load("ffQaD"),
    $ee588c5de5ed242d$var$load("kvRbA"),
    $ee588c5de5ed242d$var$load("kNFvF"),
    $ee588c5de5ed242d$var$load("kToIa")
]).then(()=>parcelRequire('2ddPE'));

});


parcelRegister("k3GMp", function(module, exports) {

$parcel$export(module.exports, "RoleBasedNotificationDetail", () => $89e521226d6aac78$export$445112c3a1089cc5);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $89e521226d6aac78$export$5211e5a7ed694f98 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("ksHZF")).then((module)=>module.RoleBasedNotificationDetail), {
    moduleId: "./src/packages/eoc/role-based-notifications/src/index.tsx"
});
const $89e521226d6aac78$export$445112c3a1089cc5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $89e521226d6aac78$export$5211e5a7ed694f98,
        pageId: "async-jira-eoc-role-based-notifications",
        shouldShowSpinner: false
    });

});


parcelRegister("7mf3n", function(module, exports) {

$parcel$export(module.exports, "roleBasedNotificationsRouteEntry", () => $fec308ab1c0618bc$export$60de9875bb8ef1d6);

var $hZVks = parcelRequire("hZVks");

var $ffza4 = parcelRequire("ffza4");

var $eZXFU = parcelRequire("eZXFU");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $2bQB3 = parcelRequire("2bQB3");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

var $7OghT = parcelRequire("7OghT");
const $fec308ab1c0618bc$var$getNavigationSpecifications = ()=>{
    return (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $fec308ab1c0618bc$export$60de9875bb8ef1d6 = (0, $7NszV.createEntry)((0, $2bQB3.roleBasedNotificationsRoute), ()=>({
        group: 'eoc',
        component: (0, $7OghT.RoleBasedNotificationsComponent),
        layout: (0, $eZXFU.opsSettingsLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $hZVks.resources)[0],
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$fec308ab1c0618bc$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7OghT.LazyRoleBasedNotifications)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7OghT.LazyRoleBasedNotifications)
        ]
    }));

});
parcelRegister("2bQB3", function(module, exports) {

$parcel$export(module.exports, "roleBasedNotificationsRoute", () => $2188ae80315aaff9$export$5a10092825ee32e4);
const $2188ae80315aaff9$export$5a10092825ee32e4 = {
    name: 'eoc-role-based-notifications',
    path: '/jira/settings/products/ops/role-based-notifications',
    exact: true
};

});


parcelRegister("4VMm4", function(module, exports) {

$parcel$export(module.exports, "rovoSearchRouteEntry", () => $e32aede527302f76$export$64c44018a429a3ed);

var $5uXOq = parcelRequire("5uXOq");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $5cBfM = parcelRequire("5cBfM");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e32aede527302f76$var$LazyRovoSearchPage = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("jDSk9"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/rovo-search/src/index.tsx"
});
const $e32aede527302f76$var$RovoSearchPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e32aede527302f76$var$LazyRovoSearchPage,
        pageId: "rovo-search",
        shouldShowSpinner: false
    });
const $e32aede527302f76$export$64c44018a429a3ed = (0, $7NszV.createEntry)((0, $5cBfM.rovoSearchRoute), ()=>({
        group: 'search',
        component: $e32aede527302f76$var$RovoSearchPage,
        isRedirect: false,
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        forPaint: [
            $e32aede527302f76$var$LazyRovoSearchPage
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("5cBfM", function(module, exports) {

$parcel$export(module.exports, "rovoSearchRoute", () => $361c5d3a5eacaef4$export$c45b7c601eb1ba93);
const $361c5d3a5eacaef4$export$c45b7c601eb1ba93 = {
    name: 'jira-rovo-search',
    path: '/jira/cross-product-search',
    exact: true
};

});

parcelRegister("jDSk9", function(module, exports) {

let $e4cbcc79e86ff9ff$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e4cbcc79e86ff9ff$var$load("ffQaD"),
    $e4cbcc79e86ff9ff$var$load("kvRbA"),
    $e4cbcc79e86ff9ff$var$load("kVX56"),
    $e4cbcc79e86ff9ff$var$load("7mIf9"),
    $e4cbcc79e86ff9ff$var$load("jXweD"),
    $e4cbcc79e86ff9ff$var$load("fliVL"),
    $e4cbcc79e86ff9ff$var$load("kSSEk")
]).then(()=>parcelRequire('4CIoa'));

});


parcelRegister("gMkpP", function(module, exports) {

$parcel$export(module.exports, "sandboxBundlerBifrostEntrypointsRouteEntry", () => $b93ec6a6f2bfa33b$export$95bd68c4f26980ed);

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $lkFvK = parcelRequire("lkFvK");

var $3RJkv = parcelRequire("3RJkv");

var $4R6GH = parcelRequire("4R6GH");

var $6LsQE = parcelRequire("6LsQE");

var $c6VcK = parcelRequire("c6VcK");

var $lmyls = parcelRequire("lmyls");

var $1a10w = parcelRequire("1a10w");
const $b93ec6a6f2bfa33b$var$sandboxBundlerBifrostPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1a10w.sandboxBundlerBifrostEntryPoint),
    // using PROJECTS as a placeholder
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $b93ec6a6f2bfa33b$export$95bd68c4f26980ed = (0, $7NszV.createEntry)((0, $c6VcK.sandboxBundlerBifrostEntrypointsRoute), ()=>({
        group: 'sandbox',
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        ufoName: 'sandbox-bundler',
        entryPoint: ()=>(0, $4R6GH.fg)('conditional_import_sandbox_bifrost') ? $b93ec6a6f2bfa33b$var$sandboxBundlerBifrostPageEntryPoint : (0, $6LsQE.notFoundPageEntrypoint),
        bifrost: {
            bundling: {
                packageName: '@atlassian/jira-router-routes-sandbox-entries/src/sandboxBundlerBifrostEntrypointsRouteEntry.tsx',
                whichExportToUse: 'sandboxBundlerBifrostEntrypointsRouteEntry'
            },
            enabled: false
        }
    }));

});
parcelRegister("c6VcK", function(module, exports) {

$parcel$export(module.exports, "sandboxBundlerBifrostEntrypointsRoute", () => $7e324bc9b2d883b2$export$1e4fe7eb44ddb2fd);
const $7e324bc9b2d883b2$export$1e4fe7eb44ddb2fd = {
    name: 'sandbox-bundler-bifrost-entrypoints',
    path: '/jira/software/sandbox/bundler-bifrost/entrypoints',
    exact: true
};

});

parcelRegister("1a10w", function(module, exports) {

$parcel$export(module.exports, "sandboxBundlerBifrostEntryPoint", () => $a22d3ee72805761a$export$e6bb5cf1b802d157);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $a22d3ee72805761a$export$e6bb5cf1b802d157 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("6v9Qq")), {
        moduleId: "ce1b1bd6",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("6v9Qq", function(module, exports) {

let $4bbd4645ad5b0baf$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("avM1e"))('test_conditional_imports', function() {
        return Promise.all([
            (parcelRequire("avM1e"))('some_feature_gate_that_doesnt_exist', function() {
                return Promise.all([
                    $4bbd4645ad5b0baf$var$load("diclD")
                ]);
            }, function() {
                return Promise.all([
                    $4bbd4645ad5b0baf$var$load("jx2kw")
                ]);
            }),
            $4bbd4645ad5b0baf$var$load("dLcOq")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("avM1e"))('some_feature_gate_that_doesnt_exist', function() {
                return Promise.all([
                    $4bbd4645ad5b0baf$var$load("diclD")
                ]);
            }, function() {
                return Promise.all([
                    $4bbd4645ad5b0baf$var$load("jx2kw")
                ]);
            }),
            $4bbd4645ad5b0baf$var$load("fhdtB")
        ]);
    }),
    $4bbd4645ad5b0baf$var$load("ipbtI")
]).then(()=>parcelRequire('jsr3R'));

});



parcelRegister("gtcNN", function(module, exports) {

$parcel$export(module.exports, "sandboxBundlerBifrostRLLRouteEntry", () => $37a8de44636c635e$export$e0dd38ef6ff677e7);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $cSD7y = parcelRequire("cSD7y");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $5lsNZ = parcelRequire("5lsNZ");

var $8v2Rt = parcelRequire("8v2Rt");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $37a8de44636c635e$var$LazySandboxBundlerPage = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("6v9Qq"))), {
    moduleId: "./src/packages/spa-apps/sandbox/bundler/src/index.tsx"
});
const $37a8de44636c635e$var$SandboxBundler = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $37a8de44636c635e$var$LazySandboxBundlerPage,
        pageId: "sandbox-bundler-bifrost",
        shouldShowSpinner: true
    });
const $37a8de44636c635e$export$e0dd38ef6ff677e7 = (0, $7NszV.createEntry)((0, $8v2Rt.sandboxBundlerBifrostRLLRoute), ()=>({
        group: 'sandbox',
        component: (0, $cSD7y.componentWithFG)('conditional_import_sandbox_bifrost', $37a8de44636c635e$var$SandboxBundler, (0, $5lsNZ.default)),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $37a8de44636c635e$var$LazySandboxBundlerPage
        ],
        ufoName: 'sandbox-bundler',
        bifrost: {
            bundling: {
                packageName: '@atlassian/jira-router-routes-sandbox-entries/src/sandboxBundlerBifrostRLLRouteEntry.tsx',
                whichExportToUse: 'sandboxBundlerBifrostRLLRouteEntry'
            },
            enabled: false
        }
    }));

});
parcelRegister("8v2Rt", function(module, exports) {

$parcel$export(module.exports, "sandboxBundlerBifrostRLLRoute", () => $d64f6dbc3099be3d$export$c21fd836e6493cee);
const $d64f6dbc3099be3d$export$c21fd836e6493cee = {
    name: 'sandbox-bundler-bifrost-rll',
    path: '/jira/software/sandbox/bundler-bifrost/rll',
    exact: true
};

});


parcelRegister("jr7ke", function(module, exports) {

$parcel$export(module.exports, "sandboxBundlerRouteEntry", () => $4ca2e5796b93a363$export$71497b88db8291d0);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $cSD7y = parcelRequire("cSD7y");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $5lsNZ = parcelRequire("5lsNZ");

var $3LHrF = parcelRequire("3LHrF");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $4ca2e5796b93a363$var$LazySandboxBundlerPage = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("6v9Qq"))), {
    moduleId: "./src/packages/spa-apps/sandbox/bundler/src/index.tsx"
});
const $4ca2e5796b93a363$var$SandboxBundler = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $4ca2e5796b93a363$var$LazySandboxBundlerPage,
        pageId: "sandbox-bundler",
        shouldShowSpinner: true
    });
const $4ca2e5796b93a363$export$71497b88db8291d0 = (0, $7NszV.createEntry)((0, $3LHrF.sandboxBundlerRoute), ()=>({
        group: 'sandbox',
        component: (0, $cSD7y.componentWithFG)('conditional_import_sandbox', $4ca2e5796b93a363$var$SandboxBundler, (0, $5lsNZ.default)),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $4ca2e5796b93a363$var$LazySandboxBundlerPage
        ],
        ufoName: 'sandbox-bundler'
    }));

});
parcelRegister("3LHrF", function(module, exports) {

$parcel$export(module.exports, "sandboxBundlerRoute", () => $2919d66f60e8ebb6$export$3891624aac454ec2);
const $2919d66f60e8ebb6$export$3891624aac454ec2 = {
    name: 'sandbox-bundler',
    path: '/jira/software/sandbox/bundler',
    exact: true
};

});


parcelRegister("hhRES", function(module, exports) {

$parcel$export(module.exports, "sandboxRelayEchoPageUsingEntryPointRouteEntry", () => $23ef7703ae4d22af$export$38fc3637f21e26b2);

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $jra4q = parcelRequire("jra4q");

var $9CSXQ = parcelRequire("9CSXQ");

var $6LsQE = parcelRequire("6LsQE");

var $4R6GH = parcelRequire("4R6GH");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");
const $23ef7703ae4d22af$var$sandboxRelayEchoPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $9CSXQ.sandboxEchoPageEntryPoint),
    // using PROJECTS as a placeholder
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $23ef7703ae4d22af$export$38fc3637f21e26b2 = (0, $7NszV.createEntry)((0, $jra4q.sandboxRelayEchoPageUsingEntryPointRoute), ()=>({
        group: 'sandbox',
        entryPoint: ()=>(0, $4R6GH.fg)('jfp-magma-support-defer') ? $23ef7703ae4d22af$var$sandboxRelayEchoPageEntryPoint : (0, $6LsQE.notFoundPageEntrypoint),
        layout: (0, $2BrOV.globalLayout),
        resources: [],
        ufoName: 'sandbox-relay-echo',
        bifrost: {
            bundling: {
                packageName: '@atlassian/jira-router-routes-sandbox-entries/src/sandboxRelayEchoPageUsingEntryPointRouteEntry.tsx',
                whichExportToUse: 'sandboxRelayEchoPageUsingEntryPointRouteEntry'
            },
            // WARNING: setting this to `true` will cause us to build & deploy the route to bifrost+tesseract instances worldwide, which is quite expensive!
            // enabled: true,
            manifestName: 'jira-spa-sandboxdemo.json'
        }
    }));

});
parcelRegister("jra4q", function(module, exports) {

$parcel$export(module.exports, "sandboxRelayEchoPageUsingEntryPointRoute", () => $d9c9711d719842a6$export$eaecd670f9df9fd6);
const $d9c9711d719842a6$export$eaecd670f9df9fd6 = {
    name: 'sandbox-relay-defer-echo',
    path: '/jira/software/sandbox/relay/echo',
    exact: true
};

});

parcelRegister("9CSXQ", function(module, exports) {

$parcel$export(module.exports, "sandboxEchoPageEntryPoint", () => $dcf81025a7e62257$export$d3ff1e280a8985f3);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $7k9VK = parcelRequire("7k9VK");

const $dcf81025a7e62257$export$d3ff1e280a8985f3 = (0, $fEDBv.createEntryPoint)({
    // eslint-disable-next-line jira/jira-ssr/wrong-entrypoint-usage
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("8Zcgn")), {
        moduleId: "73542e71",
        moduleName: "SandboxEchoPage",
        priority: "userVisible"
    }),
    getPreloadProps: ({ tenantContext: tenantContext, context: routerContext })=>{
        return {
            queries: {
                pageQueryRef: {
                    parameters: (0, $7k9VK.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        enableDefer: Boolean('defer' in routerContext.query ? routerContext.query.defer === 'true' : true),
                        skipLongQuery: Boolean('skipLong' in routerContext.query ? routerContext.query.skipLong === 'true' : true)
                    },
                    options: {
                        fetchPolicy: 'store-and-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("7k9VK", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c6e216d80813cf2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f43786c95d21554e6525e62ba3fbbd95>>
 * @relayHash 34217eab0f370d5568f7c0ae333e556f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1b22a744e4afb7fe2f6980e1e86b1c0648005cad43d16555b8e2f7003e74dec9
const $1c6e216d80813cf2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "enableDefer"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skipLongQuery"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "alias": "criticalMessage",
        "args": v2 /*: any*/ ,
        "kind": "ScalarField",
        "name": "echo"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SandboxEchoPageQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            v3 /*: any*/ ,
                            {
                                "kind": "Defer",
                                "selections": [
                                    {
                                        "args": v2 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "SandboxEchoDefer1"
                                    }
                                ]
                            },
                            {
                                "kind": "Defer",
                                "selections": [
                                    {
                                        "args": v2 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "SandboxEchoDefer2"
                                    }
                                ]
                            },
                            {
                                "kind": "Defer",
                                "selections": [
                                    {
                                        "args": [
                                            v1 /*: any*/ ,
                                            {
                                                "kind": "Variable",
                                                "name": "enableDefer",
                                                "variableName": "enableDefer"
                                            }
                                        ],
                                        "kind": "FragmentSpread",
                                        "name": "SandboxEchoDefer3"
                                    }
                                ]
                            },
                            {
                                "condition": "skipLongQuery",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "kind": "Defer",
                                        "selections": [
                                            {
                                                "args": v2 /*: any*/ ,
                                                "kind": "FragmentSpread",
                                                "name": "SandboxEchoVeryLongQuery"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SandboxEchoPageQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "if": "enableDefer",
                            "kind": "Defer",
                            "label": "SandboxEchoPageQuery$defer$SandboxEchoDefer1_PVNZy",
                            "selections": [
                                {
                                    "alias": "defer1",
                                    "args": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "where",
                                            "value": {
                                                "delayMs": 500
                                            }
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "echo"
                                }
                            ]
                        },
                        {
                            "if": "enableDefer",
                            "kind": "Defer",
                            "label": "SandboxEchoPageQuery$defer$SandboxEchoDefer2_PVNZy",
                            "selections": [
                                {
                                    "alias": "defer2",
                                    "args": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "where",
                                            "value": {
                                                "delayMs": 700
                                            }
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "echo"
                                }
                            ]
                        },
                        {
                            "if": "enableDefer",
                            "kind": "Defer",
                            "label": "SandboxEchoPageQuery$defer$SandboxEchoDefer3_1jcU60",
                            "selections": [
                                {
                                    "alias": "defer3",
                                    "args": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "where",
                                            "value": {
                                                "delayMs": 900
                                            }
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "echo"
                                },
                                {
                                    "if": "enableDefer",
                                    "kind": "Defer",
                                    "label": "SandboxEchoDefer3$defer$SandboxEchoNestedDefer_PVNZy",
                                    "selections": [
                                        {
                                            "alias": "nestedImmediate",
                                            "args": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "where",
                                                    "value": {
                                                        "delayMs": 1
                                                    }
                                                }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "echo"
                                        },
                                        {
                                            "alias": "nestedDefer1",
                                            "args": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "where",
                                                    "value": {
                                                        "delayMs": 600
                                                    }
                                                }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "echo"
                                        },
                                        {
                                            "alias": "nestedDefer2",
                                            "args": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "where",
                                                    "value": {
                                                        "delayMs": 1600
                                                    }
                                                }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "echo"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "skipLongQuery",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "if": "enableDefer",
                                    "kind": "Defer",
                                    "label": "SandboxEchoPageQuery$defer$SandboxEchoVeryLongQuery_PVNZy",
                                    "selections": [
                                        {
                                            "alias": "wasItWorthTheWait",
                                            "args": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "where",
                                                    "value": {
                                                        "delayMs": 5000
                                                    }
                                                }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "echo"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1b22a744e4afb7fe2f6980e1e86b1c0648005cad43d16555b8e2f7003e74dec9",
            "metadata": {},
            "name": "SandboxEchoPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1c6e216d80813cf2$var$node.hash = "6c4aa6e81890a1b652ce97e525a243a3";
var $1c6e216d80813cf2$export$2e2bcd8739ae039 = $1c6e216d80813cf2$var$node;

});

parcelRegister("8Zcgn", function(module, exports) {

let $68ad887692b4acfe$var$load = (parcelRequire("28QjX"))(4);
module.exports = $68ad887692b4acfe$var$load("8Dzgf").then(()=>parcelRequire('7K1UW'));

});



parcelRegister("8VY8F", function(module, exports) {

$parcel$export(module.exports, "sandboxRelayEchoPageUsingRLLRouteEntry", () => $665d41b0efb6bf2c$export$3981404cc747e85);

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $eGfyu = parcelRequire("eGfyu");

var $9ALh1 = parcelRequire("9ALh1");

var $lmyls = parcelRequire("lmyls");

var $5f2bR = parcelRequire("5f2bR");

var $5wazW = parcelRequire("5wazW");

var $3o2V7 = parcelRequire("3o2V7");
const $665d41b0efb6bf2c$export$3981404cc747e85 = (0, $7NszV.createEntry)((0, $eGfyu.sandboxRelayEchoPageUsingRLLRoute), ()=>({
        group: 'sandbox',
        layout: (0, $2BrOV.globalLayout),
        skeleton: (0, $3o2V7.Skeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        component: (0, $9ALh1.AsyncSandboxEchoPage),
        lazyForPaint: [
            (0, $9ALh1.AsyncSandboxEchoPage)
        ],
        resources: [
            (0, $5wazW.sandboxEchoPageRelayResource)
        ],
        ufoName: 'sandbox-relay-echo',
        bifrost: {
            bundling: {
                packageName: '@atlassian/jira-router-routes-sandbox-entries/src/sandboxRelayEchoPageUsingRLLRouteEntry.tsx',
                whichExportToUse: 'sandboxRelayEchoPageUsingRLLRouteEntry'
            },
            // WARNING: setting this to `true` will cause us to build & deploy the route to bifrost+tesseract instances worldwide, which is quite expensive!
            // enabled: true,
            manifestName: 'jira-spa-sandboxdemo.json'
        }
    }));

});
parcelRegister("eGfyu", function(module, exports) {

$parcel$export(module.exports, "sandboxRelayEchoPageUsingRLLRoute", () => $60296d8f40ca6e26$export$382892be07e8f9fc);
const $60296d8f40ca6e26$export$382892be07e8f9fc = {
    name: 'sandbox-relay-defer-echo',
    path: '/jira/software/sandbox/relay/echo',
    exact: true
};

});

parcelRegister("9ALh1", function(module, exports) {

$parcel$export(module.exports, "AsyncSandboxEchoPage", () => $3807a6a16c88bb0d$export$3e76bcb04553d279);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $kxZPA = parcelRequire("kxZPA");

var $ao2h1 = parcelRequire("ao2h1");

var $7yO8g = parcelRequire("7yO8g");

var $7k9VK = parcelRequire("7k9VK");

var $lfTZh = parcelRequire("lfTZh");

var $5wazW = parcelRequire("5wazW");

const $3807a6a16c88bb0d$export$cc4c54c1ebe3736c = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("8Zcgn"))), {
    moduleId: "./src/packages/spa-apps/sandbox/relay/src/ui/SandboxEchoPage.tsx"
});
const $3807a6a16c88bb0d$export$131119b9314343c7 = ()=>{
    const [queryReference, loadQuery] = (0, $8Uumt.useQueryLoader)((0, $7k9VK.default));
    if (queryReference == null) {
        loadQuery({
            cloudId: '7088b486-bbf4-4e1f-9195-412bfac4be28',
            enableDefer: true,
            skipLongQuery: true
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("small", null, "Triggering query...");
    }
    const props = {
        queries: {
            pageQueryRef: queryReference
        },
        props: {},
        extraProps: {},
        entryPoints: {}
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("small", null, "Self-starting sandbox echo page"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "self-starting-sandbox-echo-page",
        fallback: "Loading echo page..."
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3807a6a16c88bb0d$export$cc4c54c1ebe3736c, props)));
};
const $3807a6a16c88bb0d$export$3e76bcb04553d279 = ()=>{
    const { queryReference: queryReference } = (0, $ao2h1.useRelayResource)((0, $5wazW.sandboxEchoPageRelayResource));
    const props = queryReference ? {
        queries: {
            pageQueryRef: queryReference
        },
        props: {},
        extraProps: {},
        entryPoints: {}
    } : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("small", null, "Async sandbox echo page"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-sandbox-echo-page",
        fallback: "Loading echo page..."
    }, props && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3807a6a16c88bb0d$export$cc4c54c1ebe3736c, props)));
};

});
parcelRegister("5wazW", function(module, exports) {

$parcel$export(module.exports, "sandboxEchoPageRelayResource", () => $82d02f97ad4a2283$export$1d94b7b81d2cfb0c);
/* eslint-disable jira/import-whitelist */ 
var $8Uumt = parcelRequire("8Uumt");

var $2M1hQ = parcelRequire("2M1hQ");

var $7k9VK = parcelRequire("7k9VK");

var $5yJb9 = parcelRequire("5yJb9");

var $kipqU = parcelRequire("kipqU");

var $ao2h1 = parcelRequire("ao2h1");
const $82d02f97ad4a2283$export$1d94b7b81d2cfb0c = (0, $2M1hQ.createResource)({
    type: `${(0, $ao2h1.RELAY_RESOURCE_TYPE)}_SANDBOX_RELAY_DEFER_ECHO`,
    getKey: ()=>'sandbox-relay-defer-echo',
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        // Bail if the request opted out of SSR rendering
        if (false && 'ssr' in routerContext.query && routerContext.query.ssr === 'false') return null;
        const variables = {
            cloudId: tenantContext.cloudId,
            enableDefer: Boolean('defer' in routerContext.query ? routerContext.query.defer === 'true' : true),
            skipLongQuery: Boolean('skipLong' in routerContext.query ? routerContext.query.skipLong === 'true' : true)
        };
        const options = {
            fetchPolicy: 'store-and-network'
        };
        const queryReference = (0, $8Uumt.loadQuery)((0, $5yJb9.default)(), (0, $7k9VK.default), variables, options);
        if (false && queryReference.id != null) await (0, $kipqU.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});

});


parcelRegister("3o2V7", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $2b395e940acc9b2a$export$8f31e4c4a37b8e9c);

var $5uXOq = parcelRequire("5uXOq");
const $2b395e940acc9b2a$export$8f31e4c4a37b8e9c = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, "Loading the sandbox page...");
};

});


parcelRegister("aApqk", function(module, exports) {

$parcel$export(module.exports, "sandboxRelayJiraPageRouteEntry", () => $7d2751a4782f2f1e$export$c19004b7e7b87ab0);

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $e7ZQf = parcelRequire("e7ZQf");

var $fNyQe = parcelRequire("fNyQe");

var $6LsQE = parcelRequire("6LsQE");

var $4R6GH = parcelRequire("4R6GH");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");
const $7d2751a4782f2f1e$var$sandboxRelayJiraPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $fNyQe.sandboxJiraPageEntryPoint),
    // using PROJECTS as a placeholder
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $7d2751a4782f2f1e$export$c19004b7e7b87ab0 = (0, $7NszV.createEntry)((0, $e7ZQf.sandboxRelayJiraPageRoute), ()=>({
        group: 'sandbox',
        entryPoint: ()=>(0, $4R6GH.fg)('jfp-magma-support-defer') ? $7d2751a4782f2f1e$var$sandboxRelayJiraPageEntryPoint : (0, $6LsQE.notFoundPageEntrypoint),
        layout: (0, $2BrOV.globalLayout),
        resources: [],
        ufoName: 'sandbox-relay-jirasearch',
        bifrost: {
            bundling: {
                packageName: '@atlassian/jira-router-routes-sandbox-entries/src/sandboxRelayJiraPageRouteEntry.tsx',
                whichExportToUse: 'sandboxRelayJiraPageRouteEntry'
            },
            // WARNING: setting this to `true` will cause us to build & deploy the route to bifrost+tesseract instances worldwide, which is quite expensive!
            // enabled: true,
            manifestName: 'jira-spa-sandboxdemo.json'
        }
    }));

});
parcelRegister("e7ZQf", function(module, exports) {

$parcel$export(module.exports, "sandboxRelayJiraPageRoute", () => $1aba9d02c092354f$export$71a894fccabfdcfa);
const $1aba9d02c092354f$export$71a894fccabfdcfa = {
    name: 'sandbox-relay-defer-jira',
    path: '/jira/software/sandbox/relay/jirasearch',
    exact: true
};

});

parcelRegister("fNyQe", function(module, exports) {

$parcel$export(module.exports, "sandboxJiraPageEntryPoint", () => $4ca571dfa319a590$export$d56ccd62431eaba5);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $gE4Gq = parcelRequire("gE4Gq");

const $4ca571dfa319a590$export$d56ccd62431eaba5 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("juM28")), {
        moduleId: "ea0eea54",
        moduleName: "SandboxJiraPage",
        priority: "userVisible"
    }),
    getPreloadProps: ({ tenantContext: tenantContext, context: context })=>{
        return {
            queries: {
                pageQueryRef: {
                    parameters: (0, $gE4Gq.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        enableDefer: Boolean('defer' in context.query ? context.query.defer === 'true' : true)
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        };
    }
});

});
parcelRegister("gE4Gq", function(module, exports) {

$parcel$export(module.exports, "default", () => $441fd2aafa7117c0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<79cda9a8a207ac397a141bd7897c3537>>
 * @relayHash 3037c8cb08fdd5bd0f2bb8885e4a147b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0191f3cabe6c9edb534f4c87d64645dbe943dea580fe1d42d0e0f5e9710d4ff4
const $441fd2aafa7117c0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "enableDefer"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SandboxJiraPageQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "SandboxJiraCriticalData"
                            },
                            {
                                "kind": "Defer",
                                "selections": [
                                    {
                                        "args": v2 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "SandboxJiraUserPreferences"
                                    }
                                ]
                            },
                            {
                                "kind": "Defer",
                                "selections": [
                                    {
                                        "args": v2 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "SandboxJiraAiStuff"
                                    }
                                ]
                            },
                            {
                                "kind": "Defer",
                                "selections": [
                                    {
                                        "args": [
                                            v1 /*: any*/ ,
                                            {
                                                "kind": "Variable",
                                                "name": "enableDefer",
                                                "variableName": "enableDefer"
                                            }
                                        ],
                                        "kind": "FragmentSpread",
                                        "name": "SandboxJiraIssueSearch"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SandboxJiraPageQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "ScalarField",
                            "name": "childIssuesLimit"
                        },
                        {
                            "if": "enableDefer",
                            "kind": "Defer",
                            "label": "SandboxJiraPageQuery$defer$SandboxJiraUserPreferences_PVNZy",
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraUserPreferences",
                                    "kind": "LinkedField",
                                    "name": "userPreferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isIssueViewCrossFlowBannerDismissed"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isCustomNavBarThemeFlagDismissed"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "if": "enableDefer",
                            "kind": "Defer",
                            "label": "SandboxJiraPageQuery$defer$SandboxJiraAiStuff_PVNZy",
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "atlassianIntelligenceProductFeatureInput",
                                            "value": {
                                                "product": "JIRA_SOFTWARE"
                                            }
                                        },
                                        v1 /*: any*/ 
                                    ],
                                    "kind": "ScalarField",
                                    "name": "shouldShowAtlassianIntelligence"
                                },
                                {
                                    "args": v2 /*: any*/ ,
                                    "kind": "ScalarField",
                                    "name": "isRovoEnabled"
                                }
                            ]
                        },
                        {
                            "if": "enableDefer",
                            "kind": "Defer",
                            "label": "SandboxJiraPageQuery$defer$SandboxJiraIssueSearch_1jcU60",
                            "selections": [
                                {
                                    "args": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 10
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "issueSearchInput",
                                            "value": {
                                                "jql": "ORDER BY created DESC"
                                            }
                                        }
                                    ],
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issueSearch",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                },
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        {
                                                            "concreteType": "JiraSingleLineTextField",
                                                            "kind": "LinkedField",
                                                            "name": "summaryField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "text"
                                                                },
                                                                v3 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "idsOrAliases",
                                                                    "value": [
                                                                        "assignee",
                                                                        "reporter",
                                                                        "status"
                                                                    ]
                                                                }
                                                            ],
                                                            "kind": "LinkedField",
                                                            "name": "fieldsByIdOrAlias",
                                                            "plural": true,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                v3 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "if": "enableDefer",
                                                                    "kind": "Defer",
                                                                    "label": "SandboxJiraIssueWithDeferCard$defer$SandboxJiraIssueFieldEditability",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "TypeDiscriminator",
                                                                            "abstractKey": "__isJiraIssueField"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isEditableInIssueView"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "user",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v4 /*: any*/ ,
                                                                                v3 /*: any*/ ,
                                                                                v5 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraStatus",
                                                                            "kind": "LinkedField",
                                                                            "name": "status",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v3 /*: any*/ ,
                                                                                v5 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JiraStatusField"
                                                                }
                                                            ],
                                                            "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"assignee\",\"reporter\",\"status\"])"
                                                        },
                                                        v3 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "startCursor"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0191f3cabe6c9edb534f4c87d64645dbe943dea580fe1d42d0e0f5e9710d4ff4",
            "metadata": {},
            "name": "SandboxJiraPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$441fd2aafa7117c0$var$node.hash = "1a8ba1e200e80a9f80ac57367382ae4b";
var $441fd2aafa7117c0$export$2e2bcd8739ae039 = $441fd2aafa7117c0$var$node;

});

parcelRegister("juM28", function(module, exports) {

let $e316141e7d14ac53$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e316141e7d14ac53$var$load("5FdsD").then(()=>parcelRequire('fVUS8'));

});



parcelRegister("dTkCg", function(module, exports) {

$parcel$export(module.exports, "secureFiltersDirectoryRedirectRouteEntry", () => $d55bc420bfc42a32$export$c2ec350ee9e78717);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $dRl24 = parcelRequire("dRl24");

var $3RJkv = parcelRequire("3RJkv");

var $ba16k = parcelRequire("ba16k");

var $cFtGt = parcelRequire("cFtGt");

var $7RZwy = parcelRequire("7RZwy");
const $d55bc420bfc42a32$export$c2ec350ee9e78717 = (0, $7NszV.createEntry)((0, $ba16k.secureFiltersDirectoryRedirectRoute), ()=>({
        group: 'directories',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $dRl24.filtersDirectoryResource)
        ],
        component: !false ? (0, $7RZwy.FiltersDirectoryRedirect) : (0, $7RZwy.FiltersDirectoryComponent),
        skeleton: (0, $cFtGt.FiltersDirectorySkeleton),
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).FILTERS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7RZwy.LazyFiltersDirectory)
        ],
        isRedirect: true
    }));

});
parcelRegister("ba16k", function(module, exports) {

$parcel$export(module.exports, "secureFiltersDirectoryRedirectRoute", () => $6cb8f0f1ec2e6905$export$50796f2aecd63181);
const $6cb8f0f1ec2e6905$export$50796f2aecd63181 = {
    name: 'filters-directory-secure-redirect',
    path: '/secure/ManageFilters.jspa'
};

});


parcelRegister("eTL4x", function(module, exports) {

$parcel$export(module.exports, "selectedDashboardRouteEntry", () => $4fedf6a5f46c9101$export$ac09a8d3ecbafc5);

var $ffza4 = parcelRequire("ffza4");


var $e2ctp = parcelRequire("e2ctp");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $a1i1S = parcelRequire("a1i1S");

var $4n0Oi = parcelRequire("4n0Oi");

var $ernoj = parcelRequire("ernoj");
const $4fedf6a5f46c9101$export$ac09a8d3ecbafc5 = (0, $7NszV.createEntry)((0, $a1i1S.selectedDashboardRoute), ()=>({
        group: 'dashboard',
        component: (0, $4n0Oi.DashboardRedirect),
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).DASHBOARDS
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $ernoj.dashboardResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ernoj.LazyDashboardView)
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$4695c1a423ffe431)
        },
        isRedirect: true,
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("a1i1S", function(module, exports) {

$parcel$export(module.exports, "selectedDashboardRoute", () => $f6e234b8f82fcbbd$export$b32070ee9554c3fb);
const $f6e234b8f82fcbbd$export$b32070ee9554c3fb = {
    name: 'dashboard-selected',
    path: '/secure/Dashboard.jspa',
    query: [
        'selectPageId'
    ]
};

});


parcelRegister("lzLcy", function(module, exports) {

$parcel$export(module.exports, "servicedeskAtlassianAnalyticsRouteEntry", () => $f87b1ab4700345c2$export$94d6674b63b9d647);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $hejqw = parcelRequire("hejqw");

var $fpjJX = parcelRequire("fpjJX");

var $cb8ep = parcelRequire("cb8ep");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $cm4j2 = parcelRequire("cm4j2");
const $f87b1ab4700345c2$export$94d6674b63b9d647 = (0, $7NszV.createEntry)((0, $cb8ep.servicedeskAtlassianAnalyticsRoute), ()=>({
        group: 'servicedesk',
        component: (0, $cm4j2.AtlassianAnalytics),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $hejqw.servicedeskAtlassianAnalyticsResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cm4j2.LazyAtlassianAnalytics)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).ATLASSIAN_ANALYTICS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).ATLASSIAN_ANALYTICS),
                teamName: 'ITSM Saga'
            }
        }
    }));

});
parcelRegister("hejqw", function(module, exports) {

$parcel$export(module.exports, "servicedeskAtlassianAnalyticsResource", () => $ccd9a1a485573887$export$eb2deca89cf3fb61);

var $2M1hQ = parcelRequire("2M1hQ");


const $ccd9a1a485573887$var$getDataLoader = ()=>(parcelRequire("hnsP6"));
const $ccd9a1a485573887$export$eb2deca89cf3fb61 = (0, $2M1hQ.createResource)({
    type: (0, $125270e59037c004$export$73cf43fb073ce577),
    getKey: ()=>'atlassian analytics',
    getDataLoader: $ccd9a1a485573887$var$getDataLoader,
    isBrowserOnly: true
});

});
const $125270e59037c004$export$73cf43fb073ce577 = 'SERVICEDESK_ATLASSIAN_ANALYTICS';

parcelRegister("hnsP6", function(module, exports) {

let $ca6af156226db1a1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ca6af156226db1a1$var$load("l4osd").then(()=>parcelRequire('ghpmF'));

});


parcelRegister("cb8ep", function(module, exports) {

$parcel$export(module.exports, "servicedeskAtlassianAnalyticsRoute", () => $9a654d65b63de676$export$399ef3a2d4288bba);
const $9a654d65b63de676$export$399ef3a2d4288bba = {
    name: 'servicedesk-atlassian-analytics',
    path: '/jira/servicedesk/projects/:projectKey/reports/atlassian-analytics',
    exact: true
};

});

parcelRegister("cm4j2", function(module, exports) {

$parcel$export(module.exports, "LazyAtlassianAnalytics", () => $8afe4cbad132cc61$export$78ffe2f6530d45d1);
$parcel$export(module.exports, "AtlassianAnalytics", () => $8afe4cbad132cc61$export$6d23a188bb96b7ab);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $8afe4cbad132cc61$export$78ffe2f6530d45d1 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("5E9AQ"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/atlassian-analytics/src/index.tsx"
});
const $8afe4cbad132cc61$export$6d23a188bb96b7ab = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8afe4cbad132cc61$export$78ffe2f6530d45d1,
        pageId: "spa-apps/servicedesk/atlassian-analytics",
        shouldShowSpinner: true
    });

});
parcelRegister("5E9AQ", function(module, exports) {

let $41c82132d94ec2ec$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $41c82132d94ec2ec$var$load("ffQaD"),
    $41c82132d94ec2ec$var$load("kvRbA"),
    $41c82132d94ec2ec$var$load("9j2sf")
]).then(()=>parcelRequire('hUapH'));

});



parcelRegister("cJoBA", function(module, exports) {

$parcel$export(module.exports, "servicedeskCalendarRouteEntry", () => $3ce1b2936d5b40e0$export$301bfcedbd0983b7);

var $4R6GH = parcelRequire("4R6GH");

var $6hJYB = parcelRequire("6hJYB");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $jYeNO = parcelRequire("jYeNO");

var $f7Y15 = parcelRequire("f7Y15");

var $gNStA = parcelRequire("gNStA");

var $4pwUQ = parcelRequire("4pwUQ");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $6Y2I3 = parcelRequire("6Y2I3");

var $f1mpQ = parcelRequire("f1mpQ");
const $3ce1b2936d5b40e0$export$301bfcedbd0983b7 = (0, $7NszV.createEntry)((0, $4pwUQ.servicedeskCalendarRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'jsm-calendar',
        component: ()=>null,
        skeleton: (0, $6Y2I3.ClassicCalendarSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $6hJYB.AsyncViewsNav)
        },
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $jYeNO.getCalendarFilterFieldsResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsd_shield_weekly_view_fast_follow') && !false, (0, $f7Y15.uifBoardResource))
        ],
        entryPoint: ()=>(0, $f1mpQ.calendarPageEntryPoint),
        meta: {
            reporting: {
                id: 'calendar',
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).CALENDAR),
                teamName: 'jsd-shield'
            }
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("4pwUQ", function(module, exports) {

$parcel$export(module.exports, "servicedeskCalendarRoute", () => $72d318e197b1c24c$export$28a386a00670c893);
const $72d318e197b1c24c$export$28a386a00670c893 = {
    name: 'servicedesk-calendar',
    path: '/jira/servicedesk/projects/:projectKey/boards/:boardId/calendar',
    exact: true
};

});

parcelRegister("f1mpQ", function(module, exports) {

$parcel$export(module.exports, "calendarPageEntryPoint", () => $c3ff53bf28ecf1c9$export$eda0c2fb67f7d7e7);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $faaUu = parcelRequire("faaUu");
const $c3ff53bf28ecf1c9$export$eda0c2fb67f7d7e7 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $faaUu.calendarEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});


parcelRegister("SBgrM", function(module, exports) {

$parcel$export(module.exports, "servicedeskChangeCalendarRouteEntry", () => $76cc3b1301a661ae$export$de5b915e23c7ce7d);

var $ffza4 = parcelRequire("ffza4");

var $1cxvE = parcelRequire("1cxvE");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $2pT4g = parcelRequire("2pT4g");

var $fpjJX = parcelRequire("fpjJX");

var $J5M3r = parcelRequire("J5M3r");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $VGh1b = parcelRequire("VGh1b");

var $cOMjN = parcelRequire("cOMjN");
const $76cc3b1301a661ae$export$de5b915e23c7ce7d = (0, $7NszV.createEntry)((0, $J5M3r.servicedeskChangeCalendarRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.change-calendar',
        component: (0, $cOMjN.default),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $1cxvE.AsyncJSMOperationsHorizontalNav),
            onlyShowHorizontalOnNav4: true
        },
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $2pT4g.jsmRepackagingBannerResource),
            (0, $VGh1b.changeCalendarViewSettingsResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cOMjN.LazyChangeCalendar),
            (0, $1cxvE.LazyJSMOperationsHorizontalNav)
        ],
        meta: {
            reporting: {
                id: 'changeCalendar',
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).CHANGE_CALENDAR),
                teamName: 'jenga'
            }
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("1cxvE", function(module, exports) {

$parcel$export(module.exports, "LazyJSMOperationsHorizontalNav", () => $f4b0e9313c9342f0$export$d9802671a2b1aa20);
$parcel$export(module.exports, "AsyncJSMOperationsHorizontalNav", () => $f4b0e9313c9342f0$export$d4493569f106c71);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $f4b0e9313c9342f0$export$d9802671a2b1aa20 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("b3C4T")).then(({ JSMOperationsHorizontalNav: JSMOperationsHorizontalNav })=>JSMOperationsHorizontalNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/operations/src/ui/index.tsx"
});
const $f4b0e9313c9342f0$export$d4493569f106c71 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "horizontal-operations-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "asyncHorizontalOperationsNav",
        packageName: "jiraHorizontalNavJsmOperations",
        fallback: "flag",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f4b0e9313c9342f0$export$d9802671a2b1aa20, null)));

});
parcelRegister("b3C4T", function(module, exports) {

let $80cd8306d305c2e2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $80cd8306d305c2e2$var$load("dFn17").then(()=>parcelRequire('6vvjk'));

});


parcelRegister("J5M3r", function(module, exports) {

$parcel$export(module.exports, "servicedeskChangeCalendarRoute", () => $927ba64566bdbc92$export$3dbc16ae422c469);
const $927ba64566bdbc92$export$3dbc16ae422c469 = {
    name: 'servicedesk-change-calendar',
    path: '/jira/servicedesk/projects/:projectKey/change-calendar',
    exact: true
};

});

parcelRegister("VGh1b", function(module, exports) {

$parcel$export(module.exports, "changeCalendarViewSettingsResource", () => $28120858fd0aa9ba$export$30950a4228efde07);

var $2M1hQ = parcelRequire("2M1hQ");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $28120858fd0aa9ba$var$getData = async (routerContext, { tenantContext: tenantContext })=>{
    if (!routerContext.match.params.projectKey) return;
    const { cloudId: cloudId } = tenantContext;
    const { projectKey: projectKey } = routerContext.match.params;
    try {
        const response = await (0, $eusud.performGetRequest)(`/gateway/api/jsm/change-management/view/api/v1/cloudId/${cloudId}/settings/project/${projectKey}`);
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'getChangeCalendarViewSettings',
                packageName: 'jiraRouterResourcesJsmChangeCalendar',
                teamName: 'jenga'
            },
            error: error
        });
        throw error;
    }
};
const $28120858fd0aa9ba$export$30950a4228efde07 = (0, $2M1hQ.createResource)({
    getData: $28120858fd0aa9ba$var$getData,
    isBrowserOnly: true,
    type: 'CHANGE_CALENDAR_VIEW_SETTINGS_RESOURCE',
    maxAge: false ? 0 : Number.MAX_SAFE_INTEGER,
    getKey: ()=>'CHANGE_CALENDAR_VIEW_SETTINGS_RESOURCE'
});

});

parcelRegister("cOMjN", function(module, exports) {

$parcel$export(module.exports, "LazyChangeCalendar", () => $f705f6e0ca7ffaf5$export$a6cec2d1c2e631eb);
$parcel$export(module.exports, "default", () => $f705f6e0ca7ffaf5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $f705f6e0ca7ffaf5$export$a6cec2d1c2e631eb = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("j3mFh"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/change-calendar/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f705f6e0ca7ffaf5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f705f6e0ca7ffaf5$export$a6cec2d1c2e631eb,
        pageId: "spa-apps/servicedesk/change-calendar",
        shouldShowSpinner: true
    });

});
parcelRegister("j3mFh", function(module, exports) {

let $ddefe0eaf7db7c25$var$load = (parcelRequire("28QjX"))(4);

module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $ddefe0eaf7db7c25$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $ddefe0eaf7db7c25$var$load("k6g9p")
        ]);
    }),
    $ddefe0eaf7db7c25$var$load("ffQaD"),
    $ddefe0eaf7db7c25$var$load("kvRbA"),
    $ddefe0eaf7db7c25$var$load("kSNuI")
]).then(()=>parcelRequire('4cmmO'));

});



parcelRegister("cVgRQ", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsGlobalConfigurationRouteEntry", () => $faac49f10a71388a$export$6755c90e62150ca0);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $92pmL = parcelRequire("92pmL");

var $e9YVH = parcelRequire("e9YVH");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $gXGYk = parcelRequire("gXGYk");

var $aP5Tt = parcelRequire("aP5Tt");
const $faac49f10a71388a$export$6755c90e62150ca0 = (0, $7NszV.createEntry)((0, $92pmL.servicedeskCmdbAssetsGlobalConfigurationRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        ufoName: 'servicedesk-cmdb-assets-configure',
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $gXGYk.default),
        resources: (0, $55ZOZ.getCmdbResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gXGYk.LazyServicedeskCmdbGlobalConfigure)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-global-config-page',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION),
                teamName: 'aurum'
            }
        }
    }));

});
parcelRegister("92pmL", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsGlobalConfigurationRoute", () => $d7e386cd256d5aa1$export$b28679181cd68abd);
const $d7e386cd256d5aa1$export$b28679181cd68abd = {
    name: 'servicedesk-cmdb-configure',
    path: '/jira/servicedesk/assets/configure/global'
};

});

parcelRegister("gXGYk", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskCmdbGlobalConfigure", () => $faa956883f49da96$export$b80bd807bad3fd0a);
$parcel$export(module.exports, "default", () => $faa956883f49da96$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $faa956883f49da96$export$b80bd807bad3fd0a = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("lTD03")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-configure-v2/src/index.tsx"
});
const $faa956883f49da96$var$GlobalConfigure = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $faa956883f49da96$export$b80bd807bad3fd0a,
        pageId: "spa-apps/servicedesk/insight/cmdb-configure",
        shouldShowSpinner: true
    });
var $faa956883f49da96$export$2e2bcd8739ae039 = $faa956883f49da96$var$GlobalConfigure;

});

parcelRegister("aP5Tt", function(module, exports) {

$parcel$export(module.exports, "AssetsAppRedirect", () => $8bbdf2dde395c922$export$5d5d166a9477289f);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $7tQej = parcelRequire("7tQej");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $blEB6 = parcelRequire("blEB6");
const $8bbdf2dde395c922$export$5d5d166a9477289f = ({ match: match, query: query })=>{
    const pattern = /\/jira\/servicedesk\/(assets|insight)/;
    let redirectionUrl = match.url.replace(pattern, (0, $blEB6.ASSETS_APP_ROUTE_PREFIX));
    if (Object.keys(query).length > 0) redirectionUrl += `?${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(query)}`;
    const analyticsAttributes = {
        matchedRoute: match.path
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "assetsAppRedirect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: redirectionUrl,
        push: false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: analyticsAttributes
    }));
};

});


parcelRegister("8XfJX", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsObjectRouteEntry", () => $3695f420dde24db1$export$ed571153b6c25586);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $8naTI = parcelRequire("8naTI");

var $gyaGI = parcelRequire("gyaGI");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $8lolW = parcelRequire("8lolW");

var $aP5Tt = parcelRequire("aP5Tt");
const $3695f420dde24db1$export$ed571153b6c25586 = (0, $7NszV.createEntry)((0, $gyaGI.servicedeskCmdbAssetsObjectRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $8lolW.InsightCmdbObjectViewV2),
        resources: [
            ...(0, $55ZOZ.getCmdbResources)(),
            (0, $8naTI.insightObjectResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8lolW.LazyServicedeskCmdbObjectV2)
        ],
        perfMetricKey: 'service-management.insight-cmdb.object-view-page-load',
        ufoName: 'service-management.insight-cmdb.object-view-page-load'
    }));

});
parcelRegister("gyaGI", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsObjectRoute", () => $2c9190d0f388a73b$export$bf02944216c526ff);
const $2c9190d0f388a73b$export$bf02944216c526ff = {
    name: 'servicedesk-cmdb-object',
    path: '/jira/servicedesk/assets/object/:objectId'
};

});

parcelRegister("8lolW", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskCmdbObjectV2", () => $3afd4c2d86bdef54$export$411c1981ced22249);
$parcel$export(module.exports, "InsightCmdbObjectViewV2", () => $3afd4c2d86bdef54$export$3c208f927c6178ee);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $3afd4c2d86bdef54$export$411c1981ced22249 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("jJT8T")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-object-v2/src/index.tsx"
});
const $3afd4c2d86bdef54$export$3c208f927c6178ee = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3afd4c2d86bdef54$export$411c1981ced22249,
        pageId: "spa-apps/servicedesk/insight/cmdb-object-v2",
        shouldShowSpinner: true
    });
var $3afd4c2d86bdef54$export$2e2bcd8739ae039 = $3afd4c2d86bdef54$export$3c208f927c6178ee;

});


parcelRegister("5o5UE", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsObjectSchemaConfigurationRouteEntry", () => $1bf397a941deb833$export$ce7f2af5016c6aa9);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $6j0IA = parcelRequire("6j0IA");

var $9kM4D = parcelRequire("9kM4D");

var $e9YVH = parcelRequire("e9YVH");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $2vrwM = parcelRequire("2vrwM");

var $aP5Tt = parcelRequire("aP5Tt");
const $1bf397a941deb833$export$ce7f2af5016c6aa9 = (0, $7NszV.createEntry)((0, $9kM4D.servicedeskCmdbAssetsObjectSchemaConfigurationRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $2vrwM.default),
        resources: [
            ...(0, $55ZOZ.getCmdbResources)(),
            (0, $6j0IA.serviceDeskAssetsImportTypeForgeDataResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $2vrwM.LazyServicedeskCmdbObjectSchemaConfiguration)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-object-schema-config',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
                teamName: 'krispy-krew'
            }
        }
    }));

});
parcelRegister("9kM4D", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsObjectSchemaConfigurationRoute", () => $3076563cb1feeec0$export$b4a150d67181752);
const $3076563cb1feeec0$export$b4a150d67181752 = {
    name: 'servicedesk-cmdb-object-schema-configuration',
    path: '/jira/servicedesk/assets/configure/object-schema/:objectSchemaId'
};

});

parcelRegister("2vrwM", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskCmdbObjectSchemaConfiguration", () => $af13a504c251f159$export$8305a1bc1c5bee45);
$parcel$export(module.exports, "default", () => $af13a504c251f159$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $af13a504c251f159$export$8305a1bc1c5bee45 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("byrcV")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-object-schema-configuration/src/index.tsx"
});
const $af13a504c251f159$var$ObjectSchemaConfiguration = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $af13a504c251f159$export$8305a1bc1c5bee45,
        pageId: "spa-apps/servicedesk/insight/cmdb-object-schema-configuration",
        shouldShowSpinner: true
    });
var $af13a504c251f159$export$2e2bcd8739ae039 = $af13a504c251f159$var$ObjectSchemaConfiguration;

});


parcelRegister("2OBp2", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsObjectSchemaRouteEntry", () => $8d7a97c0aebbdbdc$export$d9dc7083d0a34d11);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $3W4zD = parcelRequire("3W4zD");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $2iVq4 = parcelRequire("2iVq4");

var $aP5Tt = parcelRequire("aP5Tt");
const $8d7a97c0aebbdbdc$export$d9dc7083d0a34d11 = (0, $7NszV.createEntry)((0, $3W4zD.servicedeskCmdbAssetsObjectSchemaRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $2iVq4.ObjectSchemaV2),
        resources: (0, $55ZOZ.getCmdbResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $2iVq4.LazyServicedeskCmdbObjectSchemaV2)
        ],
        perfMetricKey: 'service-management.insight-cmdb.load-schema-page'
    }));

});
parcelRegister("3W4zD", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsObjectSchemaRoute", () => $7cc0a4e0da040e16$export$6f86804eb594cd29);
const $7cc0a4e0da040e16$export$6f86804eb594cd29 = {
    name: 'servicedesk-cmdb-object-schema',
    path: '/jira/servicedesk/assets/object-schema/:objectSchemaId'
};

});


parcelRegister("29XA4", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsObjectTypeConfigurationRouteEntry", () => $271b67f72308a1a9$export$d45b927987c92c0e);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $VSMJU = parcelRequire("VSMJU");

var $e9YVH = parcelRequire("e9YVH");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $b93Zs = parcelRequire("b93Zs");

var $aP5Tt = parcelRequire("aP5Tt");
const $271b67f72308a1a9$export$d45b927987c92c0e = (0, $7NszV.createEntry)((0, $VSMJU.servicedeskCmdbAssetsObjectTypeConfigurationRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $b93Zs.default),
        resources: (0, $55ZOZ.getCmdbResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $b93Zs.LazyServicedeskCmdbConfigureObjectType)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION),
                teamName: 'aurum'
            }
        },
        ufoName: 'service-management.insight-cmdb-object-type-configuration'
    }));

});
parcelRegister("VSMJU", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsObjectTypeConfigurationRoute", () => $f41e677a77064268$export$73b901e16d5e5a02);
const $f41e677a77064268$export$73b901e16d5e5a02 = {
    name: 'servicedesk-cmdb-object-type-configuration',
    path: '/jira/servicedesk/assets/configure/object-type/:objectTypeId'
};

});

parcelRegister("b93Zs", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskCmdbConfigureObjectType", () => $14de2d11a3985015$export$926956539e1f72ba);
$parcel$export(module.exports, "default", () => $14de2d11a3985015$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $14de2d11a3985015$export$926956539e1f72ba = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("dbln9")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-configure-object-type/src/index.tsx"
});
const $14de2d11a3985015$var$InsightConfigureObjectType = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $14de2d11a3985015$export$926956539e1f72ba,
        pageId: "spa-apps/servicedesk/insight/cmdb-configure-object-type",
        shouldShowSpinner: true
    });
var $14de2d11a3985015$export$2e2bcd8739ae039 = $14de2d11a3985015$var$InsightConfigureObjectType;

});


parcelRegister("aNc7A", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsReportsRouteEntry", () => $b2f990f1e1876908$export$2621677b40f03d6c);

var $ffza4 = parcelRequire("ffza4");

var $7XYc4 = parcelRequire("7XYc4");

var $3HwlS = parcelRequire("3HwlS");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $fpjJX = parcelRequire("fpjJX");

var $zCmTp = parcelRequire("zCmTp");

var $e9YVH = parcelRequire("e9YVH");

var $gRzZD = parcelRequire("gRzZD");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $ceEFi = parcelRequire("ceEFi");

var $aP5Tt = parcelRequire("aP5Tt");
const $b2f990f1e1876908$export$2621677b40f03d6c = (0, $7NszV.createEntry)((0, $zCmTp.servicedeskCmdbAssetsReportsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), (0, $ceEFi.AssetsReportsNav4HomePage), (0, $ceEFi.AssetsReportingDefaultRedirect)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $gRzZD.workspaceResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ceEFi.LazyServicedeskCmdbDefaultReportsRedirect),
            (0, $ceEFi.LazyServicedeskCmdbAssetsReportsNav4HomePage)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT),
                teamName: 'ITSM SAGA'
            }
        }
    }));

});
parcelRegister("zCmTp", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsReportsRoute", () => $5c3155ab36693f37$export$a075d8b7c4c55c41);
const $5c3155ab36693f37$export$a075d8b7c4c55c41 = {
    name: 'servicedesk-cmdb-assets-reports-default-redirect',
    path: '/jira/servicedesk/assets/reports',
    exact: true
};

});


parcelRegister("4e4nJ", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsReportsTemplateRouteEntry", () => $8f1e557acbc4fa67$export$51d27be4bd1db6ce);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $72NwO = parcelRequire("72NwO");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $fpjJX = parcelRequire("fpjJX");

var $3b83Z = parcelRequire("3b83Z");

var $e9YVH = parcelRequire("e9YVH");

var $gRzZD = parcelRequire("gRzZD");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $ceEFi = parcelRequire("ceEFi");

var $aP5Tt = parcelRequire("aP5Tt");
const $8f1e557acbc4fa67$export$51d27be4bd1db6ce = (0, $7NszV.createEntry)((0, $3b83Z.servicedeskCmdbAssetsReportsTemplateRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $ceEFi.AssetsReports),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $gRzZD.workspaceResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ceEFi.LazyServicedeskCmdbAssetsReports)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $72NwO.default)
        },
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_ASSETS_REPORTS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_ASSETS_REPORTS),
                teamName: 'ITSM SAGA'
            }
        },
        perfMetricKey: 'service-management.insight-cmdb.load-assets-reports-template'
    }));

});
parcelRegister("3b83Z", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsReportsTemplateRoute", () => $a647cdc489d0614a$export$9482cb7f11a7730);
const $a647cdc489d0614a$export$9482cb7f11a7730 = {
    name: 'servicedesk-cmdb-assets-reports',
    path: '/jira/servicedesk/assets/reports/:templateId',
    exact: true
};

});


parcelRegister("5nU8P", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsReportsUnsubscribeRouteEntry", () => $3f95abeddff727cc$export$5842852f274cd739);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $fpjJX = parcelRequire("fpjJX");

var $nQffI = parcelRequire("nQffI");

var $e9YVH = parcelRequire("e9YVH");

var $gRzZD = parcelRequire("gRzZD");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $ceEFi = parcelRequire("ceEFi");

var $aP5Tt = parcelRequire("aP5Tt");
const $3f95abeddff727cc$export$5842852f274cd739 = (0, $7NszV.createEntry)((0, $nQffI.servicedeskCmdbAssetsReportsUnsubscribeRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $ceEFi.AssetsReportsUnsubscribe),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $gRzZD.workspaceResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ceEFi.LazyServicedeskCmdbAssetsReportsUnsubscribe)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE),
                teamName: 'ITSM SAGA'
            }
        }
    }));

});
parcelRegister("nQffI", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsReportsUnsubscribeRoute", () => $8ce2bb095b9742dc$export$66ab60d374e8e458);
const $8ce2bb095b9742dc$export$66ab60d374e8e458 = {
    name: 'servicedesk-cmdb-assets-reports-unsubscribe',
    path: '/jira/servicedesk/assets/reports/unsubscribe/:templateId/:subscriptionId',
    exact: true
};

});


parcelRegister("kHVIE", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsSchemasRouteEntry", () => $bd164bb7c160f180$export$70a75f8d403c935a);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $6t4Wv = parcelRequire("6t4Wv");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $ia3qM = parcelRequire("ia3qM");

var $aP5Tt = parcelRequire("aP5Tt");
const $bd164bb7c160f180$export$70a75f8d403c935a = (0, $7NszV.createEntry)((0, $6t4Wv.servicedeskCmdbAssetsSchemasRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $ia3qM.default),
        resources: (0, $55ZOZ.getCmdbResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ia3qM.LazyServicedeskCmdbLandingPage)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-landing-page'
    }));

});
parcelRegister("6t4Wv", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsSchemasRoute", () => $1096c786552e99d7$export$118f7c2ddb756e80);
const $1096c786552e99d7$export$118f7c2ddb756e80 = {
    name: 'servicedesk-cmdb-assets',
    path: '/jira/servicedesk/assets',
    exact: true
};

});

parcelRegister("ia3qM", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskCmdbLandingPage", () => $3371db153f9530b2$export$f6c79e6ff37913ee);
$parcel$export(module.exports, "default", () => $3371db153f9530b2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $3371db153f9530b2$export$f6c79e6ff37913ee = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("8W8bB")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-landing-page/src/index.tsx"
});
const $3371db153f9530b2$var$LandingPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3371db153f9530b2$export$f6c79e6ff37913ee,
        pageId: "spa-apps/servicedesk/insight/cmdb-landing-page",
        shouldShowSpinner: true
    });
var $3371db153f9530b2$export$2e2bcd8739ae039 = $3371db153f9530b2$var$LandingPage;

});


parcelRegister("eHeAh", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightConfigureGlobalRouteEntry", () => $c572a1f6d205e72b$export$69b479583cd0d13f);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $h8gJx = parcelRequire("h8gJx");

var $e9YVH = parcelRequire("e9YVH");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $gXGYk = parcelRequire("gXGYk");

var $aP5Tt = parcelRequire("aP5Tt");
const $c572a1f6d205e72b$export$69b479583cd0d13f = (0, $7NszV.createEntry)((0, $h8gJx.servicedeskCmdbInsightConfigureGlobalRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        ufoName: 'servicedesk-cmdb-insight-configure-global',
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $gXGYk.default),
        resources: (0, $55ZOZ.getCmdbResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gXGYk.LazyServicedeskCmdbGlobalConfigure)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-global-config-page',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION),
                teamName: 'aurum'
            }
        }
    }));

});
parcelRegister("h8gJx", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightConfigureGlobalRoute", () => $ba065f4b091a02af$export$96e5da52356f214c);
const $ba065f4b091a02af$export$96e5da52356f214c = {
    name: 'servicedesk-cmdb-configure',
    path: '/jira/servicedesk/insight/configure/global'
};

});


parcelRegister("9R3is", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightConfigureRouteEntry", () => $495bba4b83c4abb8$export$277a55a31c82cf0e);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $8xYq7 = parcelRequire("8xYq7");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $ac6Qh = parcelRequire("ac6Qh");

var $aP5Tt = parcelRequire("aP5Tt");
const $495bba4b83c4abb8$export$277a55a31c82cf0e = (0, $7NszV.createEntry)((0, $8xYq7.servicedeskCmdbInsightConfigureRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        ufoName: 'servicedesk-cmdb-insight-configure',
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $ac6Qh.default),
        resources: (0, $55ZOZ.getCmdbResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ac6Qh.LazyServicedeskCmdbConfigure)
        ]
    }));

});
parcelRegister("8xYq7", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightConfigureRoute", () => $b3ba64550401680b$export$e960ab4fcd3e80b6);
const $b3ba64550401680b$export$e960ab4fcd3e80b6 = {
    name: 'servicedesk-cmdb-configure',
    path: '/jira/servicedesk/insight/configure'
};

});

parcelRegister("ac6Qh", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskCmdbConfigure", () => $9872d73b74d97014$export$8075d4042713bf6d);
$parcel$export(module.exports, "default", () => $9872d73b74d97014$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $9872d73b74d97014$export$8075d4042713bf6d = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("f8jjU")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-configure/src/index.tsx"
});
const $9872d73b74d97014$var$InsightConfigure = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $9872d73b74d97014$export$8075d4042713bf6d,
        pageId: "spa-apps/servicedesk/insight/cmdb-configure",
        shouldShowSpinner: true
    });
var $9872d73b74d97014$export$2e2bcd8739ae039 = $9872d73b74d97014$var$InsightConfigure;

});
parcelRegister("f8jjU", function(module, exports) {

let $b04696f2c542b95e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b04696f2c542b95e$var$load("kmeQV").then(()=>parcelRequire('cKWhs'));

});



parcelRegister("lKkaY", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightObject4RouteEntry", () => $20b7f48df08d140e$export$95574c3333e559d3);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $8naTI = parcelRequire("8naTI");

var $dODCf = parcelRequire("dODCf");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $8lolW = parcelRequire("8lolW");

var $aP5Tt = parcelRequire("aP5Tt");
const $20b7f48df08d140e$export$95574c3333e559d3 = (0, $7NszV.createEntry)((0, $dODCf.servicedeskCmdbInsightObject4Route), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $8lolW.InsightCmdbObjectViewV2),
        resources: [
            ...(0, $55ZOZ.getCmdbResources)(),
            (0, $8naTI.insightObjectResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8lolW.LazyServicedeskCmdbObjectV2)
        ],
        perfMetricKey: 'service-management.insight-cmdb.object-view-page-load',
        ufoName: 'service-management.insight-cmdb.object-view-page-load'
    }));

});
parcelRegister("dODCf", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightObject4Route", () => $fa024efc61833843$export$223f5bacfd3d39fd);
const $fa024efc61833843$export$223f5bacfd3d39fd = {
    name: 'servicedesk-cmdb-object',
    path: '/jira/servicedesk/insight/assets/:objectId'
};

});


parcelRegister("brWuf", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightObjectSchemaConfigurationRouteEntry", () => $dc805604e47f30ff$export$261e9b5115dfbb0a);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $6tshd = parcelRequire("6tshd");

var $e9YVH = parcelRequire("e9YVH");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $2vrwM = parcelRequire("2vrwM");

var $aP5Tt = parcelRequire("aP5Tt");
const $dc805604e47f30ff$export$261e9b5115dfbb0a = (0, $7NszV.createEntry)((0, $6tshd.servicedeskCmdbInsightObjectSchemaConfigurationRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $2vrwM.default),
        resources: (0, $55ZOZ.getCmdbResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $2vrwM.LazyServicedeskCmdbObjectSchemaConfiguration)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-object-schema-config',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
                teamName: 'krispy-krew'
            }
        }
    }));

});
parcelRegister("6tshd", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightObjectSchemaConfigurationRoute", () => $0be30b09ce65a175$export$f6b688a8729943b3);
const $0be30b09ce65a175$export$f6b688a8729943b3 = {
    name: 'servicedesk-cmdb-object-schema-configuration',
    path: '/jira/servicedesk/insight/configure/object-schema/:objectSchemaId'
};

});


parcelRegister("iXsus", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightObjectSchemaRouteEntry", () => $390b0c9138642138$export$192b200c13b0b76a);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $S3PTJ = parcelRequire("S3PTJ");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $2iVq4 = parcelRequire("2iVq4");

var $aP5Tt = parcelRequire("aP5Tt");
const $390b0c9138642138$export$192b200c13b0b76a = (0, $7NszV.createEntry)((0, $S3PTJ.servicedeskCmdbInsightObjectSchemaRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $2iVq4.ObjectSchemaV2),
        resources: (0, $55ZOZ.getCmdbResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $2iVq4.LazyServicedeskCmdbObjectSchemaV2)
        ],
        perfMetricKey: 'service-management.insight-cmdb.load-schema-page'
    }));

});
parcelRegister("S3PTJ", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightObjectSchemaRoute", () => $0050a642a1c533ba$export$fcde60ded71d4ae6);
const $0050a642a1c533ba$export$fcde60ded71d4ae6 = {
    name: 'servicedesk-cmdb-object-schema',
    path: '/jira/servicedesk/insight/object-schemas/:objectSchemaId'
};

});


parcelRegister("xwXfC", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightObjectTypeConfigurationRouteEntry", () => $0a9518d238b0ac1f$export$de4ab140a5dbd984);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $kA9Q5 = parcelRequire("kA9Q5");

var $e9YVH = parcelRequire("e9YVH");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $b93Zs = parcelRequire("b93Zs");

var $aP5Tt = parcelRequire("aP5Tt");
const $0a9518d238b0ac1f$export$de4ab140a5dbd984 = (0, $7NszV.createEntry)((0, $kA9Q5.servicedeskCmdbInsightObjectTypeConfigurationRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $b93Zs.default),
        resources: (0, $55ZOZ.getCmdbResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $b93Zs.LazyServicedeskCmdbConfigureObjectType)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION),
                teamName: 'aurum'
            }
        }
    }));

});
parcelRegister("kA9Q5", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightObjectTypeConfigurationRoute", () => $de5e134e813298dc$export$12e89d5d79d59785);
const $de5e134e813298dc$export$12e89d5d79d59785 = {
    name: 'servicedesk-cmdb-object-type-configuration',
    path: '/jira/servicedesk/insight/configure/object-type/:objectTypeId'
};

});


parcelRegister("3lpLH", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightRouteEntry", () => $a395bb20c6d1e9c8$export$3befca4eb012b818);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $cx6sj = parcelRequire("cx6sj");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $ia3qM = parcelRequire("ia3qM");

var $aP5Tt = parcelRequire("aP5Tt");
const $a395bb20c6d1e9c8$export$3befca4eb012b818 = (0, $7NszV.createEntry)((0, $cx6sj.servicedeskCmdbInsightRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $ia3qM.default),
        resources: (0, $55ZOZ.getCmdbResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ia3qM.LazyServicedeskCmdbLandingPage)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-landing-page'
    }));

});
parcelRegister("cx6sj", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightRoute", () => $638ad863a15aceaf$export$1efada07b7203f2d);
const $638ad863a15aceaf$export$1efada07b7203f2d = {
    name: 'servicedesk-cmdb-insight',
    path: '/jira/servicedesk/insight',
    exact: true
};

});


parcelRegister("iLmKH", function(module, exports) {

$parcel$export(module.exports, "servicedeskConnectProjectRouteEntry", () => $ec6bba63502dd6b2$export$72138a83eeba68eb);

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $4IAAz = parcelRequire("4IAAz");

var $6Z2mh = parcelRequire("6Z2mh");

var $cYYI7 = parcelRequire("cYYI7");

var $iTDbG = parcelRequire("iTDbG");
const $ec6bba63502dd6b2$export$72138a83eeba68eb = (0, $7NszV.createEntry)((0, $4IAAz.servicedeskConnectProjectRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $cYYI7.getProjectConnectRouteDefaultResources)(),
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        ufoName: 'jira-connect',
        entryPoint: ()=>(0, $iTDbG.connectProjectsWithoutHorizontalNavPageEntrypoint)
    }));

});
parcelRegister("4IAAz", function(module, exports) {

$parcel$export(module.exports, "servicedeskConnectProjectRoute", () => $03d8cdc4dcb18bd2$export$148fcbe26061b2c9);

var $kUeZd = parcelRequire("kUeZd");
const $03d8cdc4dcb18bd2$export$148fcbe26061b2c9 = {
    name: 'servicedesk-connect-project',
    path: '/jira/servicedesk/projects/:projectKey',
    query: (0, $kUeZd.CONNECT_PROJECT_QUERY_PARAMS),
    exact: true
};

});


parcelRegister("kNZj9", function(module, exports) {

$parcel$export(module.exports, "servicedeskCreateProjectRouteEntry", () => $3e592ff21679cec3$export$ac25abe07ac3f570);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $h2JLJ = parcelRequire("h2JLJ");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $3e592ff21679cec3$var$LazyServiceDeskCreateProject = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("eKFEL")), {
    moduleId: "./src/packages/spa-apps/servicedesk/create-project/src/index.tsx"
});
const $3e592ff21679cec3$var$ServiceDeskCreateProject = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3e592ff21679cec3$var$LazyServiceDeskCreateProject,
        pageId: "spa-apps/servicedesk/create-project",
        shouldShowSpinner: true
    });
const $3e592ff21679cec3$export$ac25abe07ac3f570 = (0, $7NszV.createEntry)((0, $h2JLJ.servicedeskCreateProjectRoute), ()=>({
        group: 'servicedesk',
        isRedirect: true,
        component: $3e592ff21679cec3$var$ServiceDeskCreateProject,
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $3e592ff21679cec3$var$LazyServiceDeskCreateProject
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).CREATE_PROJECT,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).CREATE_PROJECT),
                teamName: 'Sequoia'
            }
        }
    }));

});
parcelRegister("h2JLJ", function(module, exports) {

$parcel$export(module.exports, "servicedeskCreateProjectRoute", () => $834f9b43560f1ccb$export$1f409a894343952a);
const $834f9b43560f1ccb$export$1f409a894343952a = {
    name: 'servicedesk-create-project',
    path: '/jira/servicedesk/create-project',
    exact: true
};

});

parcelRegister("eKFEL", function(module, exports) {

let $abd5acb09c5cc1e8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $abd5acb09c5cc1e8$var$load("9CSBV").then(()=>parcelRequire('3hX8x'));

});


parcelRegister("dCGUp", function(module, exports) {

$parcel$export(module.exports, "servicedeskCustomerDetailsRouteEntry", () => $742f9da2fde448d1$export$97ee6e9bb7f7bd31);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $fcMlY = parcelRequire("fcMlY");

var $4lqmX = parcelRequire("4lqmX");

var $9BHIm = parcelRequire("9BHIm");

var $e9YVH = parcelRequire("e9YVH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6Z2mh = parcelRequire("6Z2mh");

var $ctGuD = parcelRequire("ctGuD");
const $742f9da2fde448d1$export$97ee6e9bb7f7bd31 = (0, $7NszV.createEntry)((0, $9BHIm.servicedeskCustomerDetailsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        component: (0, $ctGuD.ServicedeskCustomerDetails),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ctGuD.LazyServicedeskCustomerDetails)
        ],
        perfMetricKey: 'jsm-customer-details-component-load',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).CUSTOMER_DETAILS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).CUSTOMER_DETAILS),
                teamName: 'boysenberry'
            }
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $fcMlY.entitlementsCustomerQueryResource),
            (0, $4lqmX.uiCustomerDetailsPageQueryResource)
        ]
    }));

});
parcelRegister("fcMlY", function(module, exports) {

$parcel$export(module.exports, "entitlementsCustomerQueryResource", () => $b3b86d13796012d4$export$78737979422d6907);

var $ao2h1 = parcelRequire("ao2h1");

var $3KdBC = parcelRequire("3KdBC");
const $b3b86d13796012d4$export$78737979422d6907 = (0, $ao2h1.createRelayResource)({
    type: 'ENTITLEMENTS_CUSTOMER_QUERY',
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $3KdBC.default),
            variables: {
                accountId: String(match.params.customerId),
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("3KdBC", function(module, exports) {

$parcel$export(module.exports, "default", () => $234ef4e6f5c8b134$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2d711ace41d650be975013cf5a90d182>>
 * @relayHash 2d56ae07e9224712e6cbeb1d40c0d517
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b6e68492e4403956991e93b2bec1552e11424884520f6d91d362bfb3f950af38
const $234ef4e6f5c8b134$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "accountId"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v9 = [
        v7 /*: any*/ ,
        v6 /*: any*/ 
    ], v10 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "entitlementsCustomerQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v2 /*: any*/ ,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "CustomerServiceProductConnection",
                                    "kind": "LinkedField",
                                    "name": "productConnections",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CustomerServiceProductEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "CustomerServiceProduct",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v4 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "customerService.productConnections.edges"
                                        }
                                    ],
                                    "storageKey": "productConnections(first:1)"
                                },
                                "action": "THROW",
                                "path": "customerService.productConnections"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v5 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "individualByAccountId",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v7 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "customerService.individualByAccountId.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "CustomerServiceEntitlement",
                                                        "kind": "LinkedField",
                                                        "name": "entitlementList",
                                                        "plural": true,
                                                        "selections": [
                                                            v7 /*: any*/ ,
                                                            {
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "includeEntityTypeName",
                                                                        "value": true
                                                                    }
                                                                ],
                                                                "kind": "FragmentSpread",
                                                                "name": "entitlement_servicedeskCustomerServiceEntitlementsCard"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "customerService.individualByAccountId.entitlementList"
                                                },
                                                v8 /*: any*/ 
                                            ],
                                            "type": "CustomerServiceIndividual"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "throwOnQueryError_servicedeskCustomerServiceCommon"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "customerService.individualByAccountId"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "customerService"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "entitlementsCustomerQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "CustomerServiceProductConnection",
                            "kind": "LinkedField",
                            "name": "productConnections",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CustomerServiceProductEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "CustomerServiceProduct",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "productConnections(first:1)"
                        },
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "individualByAccountId",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "concreteType": "CustomerServiceEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlementList",
                                            "plural": true,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "concreteType": "CustomerServiceProduct",
                                                    "kind": "LinkedField",
                                                    "name": "product",
                                                    "plural": false,
                                                    "selections": v9 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "entity",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v9 /*: any*/ ,
                                                            "type": "CustomerServiceOrganization"
                                                        },
                                                        v10 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ],
                                    "type": "CustomerServiceIndividual"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "identifier"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "errorType"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                v10 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b6e68492e4403956991e93b2bec1552e11424884520f6d91d362bfb3f950af38",
            "metadata": {},
            "name": "entitlementsCustomerQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$234ef4e6f5c8b134$var$node.hash = "52b18fa6e520ef1142f20ddded30f5ba";
var $234ef4e6f5c8b134$export$2e2bcd8739ae039 = $234ef4e6f5c8b134$var$node;

});


parcelRegister("4lqmX", function(module, exports) {

$parcel$export(module.exports, "uiCustomerDetailsPageQueryResource", () => $bb7f2c1b84275683$export$d766b4bd7ad23814);

var $ao2h1 = parcelRequire("ao2h1");

var $bvCOc = parcelRequire("bvCOc");
const $bb7f2c1b84275683$export$d766b4bd7ad23814 = (0, $ao2h1.createRelayResource)({
    type: 'UI_CUSTOMER_DETAILS_PAGE_QUERY',
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $bvCOc.default),
            variables: {
                accountId: String(match.params.customerId),
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("bvCOc", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb866aea27d5a9be$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<feb4ddb92be08c0d717024aa5a8194a8>>
 * @relayHash 368df621eebbab5cb9e1cf9ceded10d2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4c922c068178abaa255d12a88a8254e5b236724d396e47df3f3461e152127536
const $eb866aea27d5a9be$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "4c922c068178abaa255d12a88a8254e5b236724d396e47df3f3461e152127536",
        "metadata": {},
        "name": "uiCustomerDetailsPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $eb866aea27d5a9be$export$2e2bcd8739ae039 = $eb866aea27d5a9be$var$node;

});


parcelRegister("9BHIm", function(module, exports) {

$parcel$export(module.exports, "servicedeskCustomerDetailsRoute", () => $42ea45afdbe6f2e0$export$42c0f04d04ecd1f8);
const $42ea45afdbe6f2e0$export$42c0f04d04ecd1f8 = {
    name: 'servicedesk-customer-details',
    path: '/jira/servicedesk/projects/:projectKey/customers/:customerId',
    exact: true
};

});

parcelRegister("ctGuD", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskCustomersV2", () => $11e345ce4933debe$export$864b519a4059ac6b);
$parcel$export(module.exports, "LazyServicedeskCustomerDetails", () => $11e345ce4933debe$export$6c5749ec31de847d);
$parcel$export(module.exports, "ServicedeskCustomerDetails", () => $11e345ce4933debe$export$2412523c0e3657cc);
$parcel$export(module.exports, "ServiceDeskCustomersV2", () => $11e345ce4933debe$export$ac54d7814cf71dd);
$parcel$export(module.exports, "ServiceDeskContacts", () => $11e345ce4933debe$export$db9de32a8b149a29);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $11e345ce4933debe$export$864b519a4059ac6b = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("DJ6C2"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/customers-v2/src/index.tsx"
});

const $11e345ce4933debe$export$55118fe902ecc07a = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("cLmWW")), {
    moduleId: "./src/packages/spa-apps/servicedesk/contacts/src/index.tsx"
});

const $11e345ce4933debe$export$6c5749ec31de847d = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hNzkQ"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/customer-details/src/index.tsx"
});
const $11e345ce4933debe$export$2412523c0e3657cc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $11e345ce4933debe$export$6c5749ec31de847d,
        pageId: "spa-apps/servicedesk/customer-details",
        shouldShowSpinner: true
    });
const $11e345ce4933debe$export$ac54d7814cf71dd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $11e345ce4933debe$export$864b519a4059ac6b,
        pageId: "spa-apps/servicedesk/customers-v2",
        shouldShowSpinner: true
    });
const $11e345ce4933debe$export$db9de32a8b149a29 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $11e345ce4933debe$export$55118fe902ecc07a,
        pageId: "spa-apps/servicedesk/contacts",
        shouldShowSpinner: true
    });

});
parcelRegister("DJ6C2", function(module, exports) {

let $0776a1ad0ffde430$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0776a1ad0ffde430$var$load("ffQaD"),
    $0776a1ad0ffde430$var$load("kvRbA"),
    $0776a1ad0ffde430$var$load("e2nBc")
]).then(()=>parcelRequire('dKNUD'));

});

parcelRegister("cLmWW", function(module, exports) {

let $94abad250520b856$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $94abad250520b856$var$load("ffQaD"),
    $94abad250520b856$var$load("kvRbA"),
    $94abad250520b856$var$load("76n7a"),
    $94abad250520b856$var$load("l253H"),
    $94abad250520b856$var$load("uP0oQ")
]).then(()=>parcelRequire('2XE2f'));

});

parcelRegister("hNzkQ", function(module, exports) {

let $cf526c1faabd291a$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $cf526c1faabd291a$var$load("ffQaD"),
    $cf526c1faabd291a$var$load("kvRbA"),
    $cf526c1faabd291a$var$load("76n7a"),
    $cf526c1faabd291a$var$load("l253H"),
    $cf526c1faabd291a$var$load("b4axw")
]).then(()=>parcelRequire('eRp4S'));

});



parcelRegister("4KLVz", function(module, exports) {

$parcel$export(module.exports, "servicedeskCustomersV2RouteEntry", () => $499fff83668d7b3b$export$e1fa279356610d18);

var $ffza4 = parcelRequire("ffza4");

var $cEOhb = parcelRequire("cEOhb");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $eAdnc = parcelRequire("eAdnc");

var $cSD7y = parcelRequire("cSD7y");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6Z2mh = parcelRequire("6Z2mh");

var $ctGuD = parcelRequire("ctGuD");
const $499fff83668d7b3b$export$e1fa279356610d18 = (0, $7NszV.createEntry)((0, $eAdnc.servicedeskCustomersV2Route), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        component: (0, $cSD7y.componentWithFG)('jsm_customers_directory_page_for_all', (0, $ctGuD.ServiceDeskContacts), (0, $ctGuD.ServiceDeskCustomersV2)),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ctGuD.LazyServicedeskCustomersV2)
        ],
        perfMetricKey: 'jsm-customers-component-load',
        ufoName: 'jsm-customers-component-load',
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $cEOhb.AsyncDirectoryNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        }
    }));

});
parcelRegister("eAdnc", function(module, exports) {

$parcel$export(module.exports, "servicedeskCustomersV2Route", () => $3bc65f8e809f9f4e$export$89e9e350610ee31e);
const $3bc65f8e809f9f4e$export$89e9e350610ee31e = {
    name: 'servicedesk-customers-v2',
    path: '/jira/servicedesk/projects/:projectKey/customers',
    exact: true
};

});


parcelRegister("lYrmE", function(module, exports) {

$parcel$export(module.exports, "servicedeskGettingStartedRouteEntry", () => $1512d8f7329a67e2$export$e4e0491275df7c2d);

var $lkFvK = parcelRequire("lkFvK");

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");

var $ggg5j = parcelRequire("ggg5j");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $k8jl5 = parcelRequire("k8jl5");

var $5lsNZ = parcelRequire("5lsNZ");

var $5nEM1 = parcelRequire("5nEM1");

var $6Z2mh = parcelRequire("6Z2mh");

var $jm3iE = parcelRequire("jm3iE");

var $d1gXy = parcelRequire("d1gXy");
const $1512d8f7329a67e2$var$gettingStartedPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $d1gXy.gettingStartedEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $1512d8f7329a67e2$export$e4e0491275df7c2d = (0, $7NszV.createEntry)((0, $5nEM1.servicedeskGettingStartedRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        perfMetricKey: 'servicedesk-getting-started-page-load',
        skeleton: (0, $jm3iE.GettingStartedPageSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $k8jl5.servicedeskIssueTypesResource)
        ],
        entryPoint () {
            return (0, $4R6GH.fg)('gsp_production_rollout') ? $1512d8f7329a67e2$var$gettingStartedPageEntryPoint : undefined;
        },
        component: (0, $5lsNZ.default)
    }));

});
parcelRegister("5nEM1", function(module, exports) {

$parcel$export(module.exports, "servicedeskGettingStartedRoute", () => $eed17dbc1c65d2ba$export$165249c1c8f2e713);
const $eed17dbc1c65d2ba$export$165249c1c8f2e713 = {
    name: 'servicedesk-getting-started-page',
    path: '/jira/servicedesk/projects/:projectKey/getting-started',
    exact: true
};

});

parcelRegister("jm3iE", function(module, exports) {

$parcel$export(module.exports, "GettingStartedPageSkeleton", () => $562ac3cd506226fa$export$525669daa9599ec);
/* GettingStartedPageSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $eGwD4 = parcelRequire("eGwD4");
const $562ac3cd506226fa$var$customCssStyles = null;
const $562ac3cd506226fa$export$525669daa9599ec = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eGwD4))),
        className: (0, $bwpsq.default)([
            "_rcuj1wug _o81c1wug _1l6u1wug _149m1wug _701wukw8 _9qarbrur"
        ])
    });

});
parcelRegister("eGwD4", function(module, exports) {
module.exports = new URL("getting-started-page-app-skeleton.tpl.b9c0d034.svg", import.meta.url).toString();

});


parcelRegister("d1gXy", function(module, exports) {

$parcel$export(module.exports, "gettingStartedEntryPoint", () => $7b51534336e501eb$export$a91a58d8bb93ad8e);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $7b51534336e501eb$export$a91a58d8bb93ad8e = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("gDRgW")), {
        moduleId: "99c912b0",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("gDRgW", function(module, exports) {

let $c1d99c9d462a1d65$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c1d99c9d462a1d65$var$load("fliVL"),
    $c1d99c9d462a1d65$var$load("3o8b3")
]).then(()=>parcelRequire('8Xvm1'));

});



parcelRegister("6YHWn", function(module, exports) {

$parcel$export(module.exports, "servicedeskIssueRouteEntry", () => $d0c44cd76c7c1b24$export$a4bd7206a6659ad3);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $hwnr9 = parcelRequire("hwnr9");

var $6Z2mh = parcelRequire("6Z2mh");

var $lAGdd = parcelRequire("lAGdd");

var $eyZxr = parcelRequire("eyZxr");
const $d0c44cd76c7c1b24$export$a4bd7206a6659ad3 = (0, $7NszV.createEntry)((0, $hwnr9.servicedeskIssueRoute), ()=>({
        group: 'servicedesk',
        component: (0, $eyZxr.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            ...(0, $fpjJX.getKnowledgeBaseResources)(),
            ...(0, $fpjJX.getInsightResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $lAGdd.getAIContextPanelResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $eyZxr.LazyServicedeskQueuesIssueViewRedirect)
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("hwnr9", function(module, exports) {

$parcel$export(module.exports, "servicedeskIssueRoute", () => $1bb6cc8a72a7dc88$export$e146d4ae5415aa9);
const $1bb6cc8a72a7dc88$export$e146d4ae5415aa9 = {
    name: 'servicedesk-issue',
    path: '/jira/servicedesk/projects/:projectKey/issue/:issueKey',
    exact: true
};

});

parcelRegister("eyZxr", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesIssueViewRedirect", () => $3e1702b77575d903$export$52593b5917c5e179);
$parcel$export(module.exports, "default", () => $3e1702b77575d903$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $3e1702b77575d903$export$52593b5917c5e179 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("hMRL4")), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-issue-view-redirect/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3e1702b77575d903$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3e1702b77575d903$export$52593b5917c5e179,
        pageId: "spa-apps/servicedesk/queues/issue-view-redirect",
        shouldShowSpinner: true
    });

});
parcelRegister("hMRL4", function(module, exports) {

let $cf309ea21c0191ca$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cf309ea21c0191ca$var$load("2l5lq").then(()=>parcelRequire('blyWx'));

});



parcelRegister("awOZa", function(module, exports) {

$parcel$export(module.exports, "servicedeskItsmSampleSpaceRouteEntry", () => $e773d085694b29f0$export$61ad481262acd4e6);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $kEEAb = parcelRequire("kEEAb");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $e773d085694b29f0$var$LazyItsmSampleSpace = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("5sy8Z")), {
    moduleId: "./src/packages/spa-apps/servicedesk/itsm-sample-space/src/index.tsx"
});
const $e773d085694b29f0$var$ItsmSampleSpace = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e773d085694b29f0$var$LazyItsmSampleSpace,
        pageId: "spa-apps/servicedesk/itsm-sample-space",
        shouldShowSpinner: true
    });
const $e773d085694b29f0$export$61ad481262acd4e6 = (0, $7NszV.createEntry)((0, $kEEAb.servicedeskItsmSampleSpaceRoute), ()=>({
        group: 'servicedesk',
        isRedirect: true,
        component: $e773d085694b29f0$var$ItsmSampleSpace,
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $e773d085694b29f0$var$LazyItsmSampleSpace
        ],
        perfMetricKey: 'jsm-sample-space-landing-page',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).ITSM_SAMPLE_SPACE,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).ITSM_SAMPLE_SPACE),
                teamName: 'Sequoia'
            }
        }
    }));

});
parcelRegister("kEEAb", function(module, exports) {

$parcel$export(module.exports, "servicedeskItsmSampleSpaceRoute", () => $d8477253737ee5ba$export$5bc288fedb880892);
const $d8477253737ee5ba$export$5bc288fedb880892 = {
    name: 'servicedesk-itsm-sample-space',
    path: '/jira/servicedesk/itsm-sample-space',
    exact: true
};

});

parcelRegister("5sy8Z", function(module, exports) {

let $3f9a0d8c19c06851$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3f9a0d8c19c06851$var$load("2sbnI").then(()=>parcelRequire('5eXru'));

});


parcelRegister("kZgpC", function(module, exports) {

$parcel$export(module.exports, "servicedeskKbRequestsReports2RouteEntry", () => $aba9a99d9cdea566$export$c4c0806ea684088);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $3ZP7Q = parcelRequire("3ZP7Q");

var $6Z2mh = parcelRequire("6Z2mh");

var $cVTuT = parcelRequire("cVTuT");
const $aba9a99d9cdea566$export$c4c0806ea684088 = (0, $7NszV.createEntry)((0, $3ZP7Q.servicedeskKbRequestsReports2Route), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.reports.kb-requests',
        component: (0, $cVTuT.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cVTuT.LazyServicedeskKbRequestsReports)
        ]
    }));

});
parcelRegister("3ZP7Q", function(module, exports) {

$parcel$export(module.exports, "servicedeskKbRequestsReports2Route", () => $abd055c66022393b$export$276e2ed89304d21c);
const $abd055c66022393b$export$276e2ed89304d21c = {
    name: 'servicedesk-kb-requests-reports',
    path: '/jira/servicedesk/projects/:projectKey/reports/:reportId(kb-requests-resolved|kb-requests-deflected)'
};

});

parcelRegister("cVTuT", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskKbRequestsReports", () => $12e91a60aa9991e2$export$f86e12b111395ad);
$parcel$export(module.exports, "default", () => $12e91a60aa9991e2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $12e91a60aa9991e2$export$f86e12b111395ad = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("cHieW"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/kb-requests-reports/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$12e91a60aa9991e2$export$2e2bcd8739ae039 = ({ match: match })=>{
    const reportType = match.params.reportType || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $12e91a60aa9991e2$export$f86e12b111395ad,
        pageId: `spa-apps/servicedesk/reports/${reportType}`,
        shouldShowSpinner: true
    });
};

});
parcelRegister("cHieW", function(module, exports) {

let $93e7a6408ec26dea$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $93e7a6408ec26dea$var$load("ffQaD"),
    $93e7a6408ec26dea$var$load("kvRbA"),
    $93e7a6408ec26dea$var$load("94NOo")
]).then(()=>parcelRequire('exkzN'));

});



parcelRegister("auP5Z", function(module, exports) {

$parcel$export(module.exports, "servicedeskKbRequestsReportsIssueRouteEntry", () => $7f9fdb3f5341d83e$export$280a79a8f002dd58);

var $ffza4 = parcelRequire("ffza4");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $jlOGG = parcelRequire("jlOGG");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $8O7zJ = parcelRequire("8O7zJ");

var $6Z2mh = parcelRequire("6Z2mh");

var $lAGdd = parcelRequire("lAGdd");

var $1hJVy = parcelRequire("1hJVy");
const $7f9fdb3f5341d83e$export$280a79a8f002dd58 = (0, $7NszV.createEntry)((0, $8O7zJ.servicedeskKbRequestsReportsIssueRoute), ()=>({
        group: 'servicedesk',
        component: (0, $1hJVy.default),
        layout: (0, $aPfsS.composeLayouts)((0, $6Z2mh.serviceProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)()),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $jlOGG.newIssueViewLockInStatusResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $lAGdd.getAIContextPanelResources)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $1hJVy.LazyServicedeskReportsIssueView)
        ],
        ufoName: 'service-management.reports.issue'
    }));

});
parcelRegister("8O7zJ", function(module, exports) {

$parcel$export(module.exports, "servicedeskKbRequestsReportsIssueRoute", () => $8f89a0ced56a7cae$export$296aa46068d40f43);
const $8f89a0ced56a7cae$export$296aa46068d40f43 = {
    name: 'servicedesk-kb-requests-reports-time-scale-issue',
    path: '/jira/servicedesk/projects/:projectKey/reports/:reportId(kb-requests-resolved|kb-requests-deflected)/timescale/:timescaleId/:issueKey',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});

parcelRegister("1hJVy", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskReportsIssueView", () => $7281c34e15a34d51$export$c2f0d3c59c9d3bf3);
$parcel$export(module.exports, "default", () => $7281c34e15a34d51$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $7281c34e15a34d51$export$c2f0d3c59c9d3bf3 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("lxYCP")), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-issue-view/src/index.tsx"
});
var /**
 * Dynamically constructs and renders a lazy-loaded page tailored to specific Servicedesk report views. By leveraging URL parameters such as issue key and timescale ID, it enhances user navigation within the Servicedesk environment by directly accommodating varied user inquiries and historical data perspectives.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$7281c34e15a34d51$export$2e2bcd8739ae039 = ({ match: match })=>{
    const issueKey = `/${match.params && match.params.issueKey || ''}`;
    const timescaleId = `/${match.params && match.params.timescaleId || ''}`;
    const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $7281c34e15a34d51$export$c2f0d3c59c9d3bf3,
        pageId: `spa-apps/servicedesk/reports/issue${issueKey}${timescaleId}${oldIssueView}`,
        shouldShowSpinner: true
    });
};

});
parcelRegister("lxYCP", function(module, exports) {

let $fafbb4f0ed50f21f$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $fafbb4f0ed50f21f$var$load("kNFvF"),
    $fafbb4f0ed50f21f$var$load("kVX56"),
    $fafbb4f0ed50f21f$var$load("76n7a"),
    $fafbb4f0ed50f21f$var$load("l253H"),
    $fafbb4f0ed50f21f$var$load("lUXnl")
]).then(()=>parcelRequire('kXHaM'));

});



parcelRegister("6un8I", function(module, exports) {

$parcel$export(module.exports, "servicedeskKbRequestsReportsTimeScaleRouteEntry", () => $bb1d631cc0a3bc8b$export$1c6b1e308d58ca8b);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $cKqlJ = parcelRequire("cKqlJ");

var $6Z2mh = parcelRequire("6Z2mh");

var $cVTuT = parcelRequire("cVTuT");
const $bb1d631cc0a3bc8b$export$1c6b1e308d58ca8b = (0, $7NszV.createEntry)((0, $cKqlJ.servicedeskKbRequestsReportsTimeScaleRoute), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.reports.kb-requests',
        component: (0, $cVTuT.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cVTuT.LazyServicedeskKbRequestsReports)
        ]
    }));

});
parcelRegister("cKqlJ", function(module, exports) {

$parcel$export(module.exports, "servicedeskKbRequestsReportsTimeScaleRoute", () => $7032eddc67e65c51$export$1585b6f8f1838e19);
const $7032eddc67e65c51$export$1585b6f8f1838e19 = {
    name: 'servicedesk-kb-requests-reports-time-scale',
    path: '/jira/servicedesk/projects/:projectKey/reports/:reportId(kb-requests-resolved|kb-requests-deflected)/timescale/:timescaleId'
};

});


parcelRegister("l1PfI", function(module, exports) {

$parcel$export(module.exports, "servicedeskOncallScheduleRouteEntry", () => $010b24cf318456cc$export$36994f6fd22da90e);

var $ffza4 = parcelRequire("ffza4");

var $1cxvE = parcelRequire("1cxvE");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $9kQCa = parcelRequire("9kQCa");

var $6Z2mh = parcelRequire("6Z2mh");

var $cysbi = parcelRequire("cysbi");
const $010b24cf318456cc$export$36994f6fd22da90e = (0, $7NszV.createEntry)((0, $9kQCa.servicedeskOncallScheduleRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.on-call-schedule',
        component: (0, $cysbi.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $1cxvE.AsyncJSMOperationsHorizontalNav),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cysbi.LazyServicedeskOpsgenieSchedule),
            (0, $1cxvE.LazyJSMOperationsHorizontalNav)
        ]
    }));

});
parcelRegister("9kQCa", function(module, exports) {

$parcel$export(module.exports, "servicedeskOncallScheduleRoute", () => $993b636c10d5f63c$export$740e6e5e982b48a9);
const $993b636c10d5f63c$export$740e6e5e982b48a9 = {
    name: 'servicedesk-oncall-schedule',
    path: '/jira/servicedesk/projects/:projectKey/on-call-schedule',
    exact: true
};

});

parcelRegister("cysbi", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskOpsgenieSchedule", () => $816d970487a82139$export$e8392650fdcd92d5);
$parcel$export(module.exports, "default", () => $816d970487a82139$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $816d970487a82139$export$e8392650fdcd92d5 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("f2nGu")), {
    moduleId: "./src/packages/spa-apps/servicedesk/opsgenie-schedule/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$816d970487a82139$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $816d970487a82139$export$e8392650fdcd92d5,
        pageId: "spa-apps/servicedesk/opsgenie-schedule",
        shouldShowSpinner: true
    });

});
parcelRegister("f2nGu", function(module, exports) {

let $af296a271e0eedf7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $af296a271e0eedf7$var$load("9yISX").then(()=>parcelRequire('gjKCT'));

});



parcelRegister("cvYE5", function(module, exports) {

$parcel$export(module.exports, "servicedeskOrganizationDetailsRouteEntry", () => $a8b4c58f96e42722$export$a9452a74fdc4d74f);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $38BXB = parcelRequire("38BXB");

var $7CBZS = parcelRequire("7CBZS");

var $8XgXN = parcelRequire("8XgXN");

var $iTeMQ = parcelRequire("iTeMQ");

var $5tVaj = parcelRequire("5tVaj");

var $e9YVH = parcelRequire("e9YVH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6Z2mh = parcelRequire("6Z2mh");

var $rKFLU = parcelRequire("rKFLU");
const $a8b4c58f96e42722$export$a9452a74fdc4d74f = (0, $7NszV.createEntry)((0, $5tVaj.servicedeskOrganizationDetailsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        component: (0, $rKFLU.ServicedeskOrganizationDetails),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $rKFLU.LazyServicedeskOrganizationDetails)
        ],
        perfMetricKey: 'jsm-organization-details-component-load',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).ORGANIZATION_DETAILS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).ORGANIZATION_DETAILS),
                teamName: 'boysenberry'
            }
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $8XgXN.entitlementsOrganizationQueryResource),
            (0, $iTeMQ.uiOrganizationDetailsPageQueryResource),
            (0, $7CBZS.productsJsmOrganizationDetailsResource),
            (0, $38BXB.jsmEmailDomainsListResource)
        ]
    }));

});
parcelRegister("8XgXN", function(module, exports) {

$parcel$export(module.exports, "entitlementsOrganizationQueryResource", () => $275795ce1e7f33fe$export$fead08d66d56688e);

var $4R6GH = parcelRequire("4R6GH");

var $ao2h1 = parcelRequire("ao2h1");

var $9NGHY = parcelRequire("9NGHY");
const $275795ce1e7f33fe$var$getCustomerServiceOrganizationAri = (organizationId, activationId)=>{
    return `ari:cloud:jira-servicedesk::organization/activation/${activationId}/${organizationId}`;
};
const $275795ce1e7f33fe$export$fead08d66d56688e = (0, $ao2h1.createRelayResource)({
    type: 'ENTITLEMENTS_ORGANIZATION_QUERY',
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $9NGHY.default),
            variables: {
                organizationId: (0, $4R6GH.fg)('jcs_twg_organization_id_to_ari') ? $275795ce1e7f33fe$var$getCustomerServiceOrganizationAri(String(match.params.organizationId), tenantContext.activationId) : String(match.params.organizationId),
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("9NGHY", function(module, exports) {

$parcel$export(module.exports, "default", () => $42e659babe89c8d5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5505d7bd1e485943d52683e3e287125b>>
 * @relayHash 4fd7c02cf85ce43ff1f3b2c2885428f1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 01a04225033d1c240e60c2831c34cc958b17cd0c6be52ce6b65c5484adb41a6f
const $42e659babe89c8d5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "organizationId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "organizationId",
            "variableName": "organizationId"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entitlementsOrganizationQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "CustomerServiceProductConnection",
                                    "kind": "LinkedField",
                                    "name": "productConnections",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CustomerServiceProductEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "CustomerServiceProduct",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v3 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "customerService.productConnections.edges"
                                        }
                                    ],
                                    "storageKey": "productConnections(first:1)"
                                },
                                "action": "THROW",
                                "path": "customerService.productConnections"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v4 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "organizationByOrganizationId",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v6 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "customerService.organizationByOrganizationId.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "CustomerServiceEntitlement",
                                                        "kind": "LinkedField",
                                                        "name": "entitlementList",
                                                        "plural": true,
                                                        "selections": [
                                                            v6 /*: any*/ ,
                                                            {
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "includeEntityTypeName",
                                                                        "value": false
                                                                    }
                                                                ],
                                                                "kind": "FragmentSpread",
                                                                "name": "entitlement_servicedeskCustomerServiceEntitlementsCard"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "customerService.organizationByOrganizationId.entitlementList"
                                                },
                                                v7 /*: any*/ 
                                            ],
                                            "type": "CustomerServiceOrganization"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "throwOnQueryError_servicedeskCustomerServiceCommon"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "customerService.organizationByOrganizationId"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "customerService"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entitlementsOrganizationQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "CustomerServiceProductConnection",
                            "kind": "LinkedField",
                            "name": "productConnections",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CustomerServiceProductEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "CustomerServiceProduct",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "productConnections(first:1)"
                        },
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "organizationByOrganizationId",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "concreteType": "CustomerServiceEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlementList",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "CustomerServiceProduct",
                                                    "kind": "LinkedField",
                                                    "name": "product",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v7 /*: any*/ 
                                    ],
                                    "type": "CustomerServiceOrganization"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "identifier"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "errorType"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "01a04225033d1c240e60c2831c34cc958b17cd0c6be52ce6b65c5484adb41a6f",
            "metadata": {},
            "name": "entitlementsOrganizationQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$42e659babe89c8d5$var$node.hash = "c2dbf2a99cb38657b66de75f23707712";
var $42e659babe89c8d5$export$2e2bcd8739ae039 = $42e659babe89c8d5$var$node;

});


parcelRegister("iTeMQ", function(module, exports) {

$parcel$export(module.exports, "uiOrganizationDetailsPageQueryResource", () => $6f42d74340bbf820$export$ab65064827d1831d);

var $ao2h1 = parcelRequire("ao2h1");

var $hpIsM = parcelRequire("hpIsM");

var $4R6GH = parcelRequire("4R6GH");
const $6f42d74340bbf820$var$getCustomerServiceOrganizationAri = (organizationId, activationId)=>{
    return `ari:cloud:jira-servicedesk::organization/activation/${activationId}/${organizationId}`;
};
const $6f42d74340bbf820$export$ab65064827d1831d = (0, $ao2h1.createRelayResource)({
    type: 'UI_ORGANIZATION_DETAILS_PAGE_QUERY',
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $hpIsM.default),
            variables: {
                organizationId: (0, $4R6GH.fg)('jcs_twg_organization_id_to_ari') ? $6f42d74340bbf820$var$getCustomerServiceOrganizationAri(String(match.params.organizationId), tenantContext.activationId) : String(match.params.organizationId),
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("hpIsM", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc8caf12ab702db6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<08164275d7c73aca9297baa3da2d3967>>
 * @relayHash 572d7a60b6cd2c2d7190bee47f74e0e0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8425025856dcdb524ab8c9068e976910d1b94e9aab4d880ce4e0939990c08edf
const $bc8caf12ab702db6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "organizationId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "organizationId",
            "variableName": "organizationId"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "identifier"
    }, v8 = {
        "kind": "ScalarField",
        "name": "message"
    }, v9 = {
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            v3 /*: any*/ ,
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "errorType"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "uiOrganizationDetailsPageQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "organizationByOrganizationId",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "details",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "customDetailsSidebar_servicedeskCustomerServiceCustomDetailsSidebar_Inner"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "CustomerServiceOrganization"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "throwOnQueryError_servicedeskCustomerServiceCommon"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "customerService.organizationByOrganizationId"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "customerService"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "uiOrganizationDetailsPageQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "organizationByOrganizationId",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "details",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isCustomerServiceCustomDetailValuesQueryResult"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "CustomerServiceCustomDetailValue",
                                                            "kind": "LinkedField",
                                                            "name": "results",
                                                            "plural": true,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canEdit"
                                                                },
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "values"
                                                                },
                                                                {
                                                                    "concreteType": "CustomerServiceCustomDetailType",
                                                                    "kind": "LinkedField",
                                                                    "name": "type",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "options"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "CustomerServiceCustomDetailConfigMetadata",
                                                                    "kind": "LinkedField",
                                                                    "name": "config",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "CustomerServiceCustomAttributeStyleConfiguration",
                                                                            "kind": "LinkedField",
                                                                            "name": "styleConfiguration",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "CustomerServiceCustomAttributeOptionsStyleConfiguration",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "options",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "optionValue"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "CustomerServiceCustomAttributeOptionStyle",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "style",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "backgroundColour"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "CustomerServiceCustomDetailValues"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ],
                                                    "type": "QueryError"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "CustomerServiceOrganization"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8425025856dcdb524ab8c9068e976910d1b94e9aab4d880ce4e0939990c08edf",
            "metadata": {},
            "name": "uiOrganizationDetailsPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$bc8caf12ab702db6$var$node.hash = "8781f4b4eca174196d95ee737ccdc3aa";
var $bc8caf12ab702db6$export$2e2bcd8739ae039 = $bc8caf12ab702db6$var$node;

});


parcelRegister("5tVaj", function(module, exports) {

$parcel$export(module.exports, "servicedeskOrganizationDetailsRoute", () => $beffe8b6a9e6d0f2$export$eacc4723293cbc36);
const $beffe8b6a9e6d0f2$export$eacc4723293cbc36 = {
    name: 'servicedesk-organization-details',
    path: '/jira/servicedesk/projects/:projectKey/organizations/:organizationId',
    exact: true
};

});

parcelRegister("rKFLU", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskOrganizations", () => $b9e14ed4e63c050e$export$b40b4bfa472057b9);
$parcel$export(module.exports, "ServiceDeskOrganizations", () => $b9e14ed4e63c050e$export$4abec67d7b34dda2);
$parcel$export(module.exports, "LazyServicedeskOrganizationDetails", () => $b9e14ed4e63c050e$export$4a01866152e4a375);
$parcel$export(module.exports, "ServicedeskOrganizationDetails", () => $b9e14ed4e63c050e$export$709be875ca0a7ead);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $b9e14ed4e63c050e$export$b40b4bfa472057b9 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("gnciN"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/organizations/src/index.tsx"
});
const $b9e14ed4e63c050e$export$4abec67d7b34dda2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $b9e14ed4e63c050e$export$b40b4bfa472057b9,
        pageId: "spa-apps/servicedesk/organizations",
        shouldShowSpinner: true
    });

const $b9e14ed4e63c050e$export$4a01866152e4a375 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("9OwFC"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/organization-details/src/index.tsx"
});
const $b9e14ed4e63c050e$export$709be875ca0a7ead = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $b9e14ed4e63c050e$export$4a01866152e4a375,
        pageId: "spa-apps/servicedesk/organization-details",
        shouldShowSpinner: true
    });

});
parcelRegister("gnciN", function(module, exports) {

let $beb8564198e1bf2a$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $beb8564198e1bf2a$var$load("ffQaD"),
    $beb8564198e1bf2a$var$load("kvRbA"),
    $beb8564198e1bf2a$var$load("76n7a"),
    $beb8564198e1bf2a$var$load("l253H"),
    $beb8564198e1bf2a$var$load("6j8cP")
]).then(()=>parcelRequire('e2tYQ'));

});

parcelRegister("9OwFC", function(module, exports) {

let $72522033f5741814$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $72522033f5741814$var$load("ffQaD"),
    $72522033f5741814$var$load("kvRbA"),
    $72522033f5741814$var$load("76n7a"),
    $72522033f5741814$var$load("l253H"),
    $72522033f5741814$var$load("iz2YA")
]).then(()=>parcelRequire('9LQpe'));

});



parcelRegister("2cpS3", function(module, exports) {

$parcel$export(module.exports, "servicedeskOrganizationsRouteEntry", () => $51233e7b4d73b144$export$cf20fe731144ca3b);

var $ffza4 = parcelRequire("ffza4");

var $cEOhb = parcelRequire("cEOhb");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bkElt = parcelRequire("bkElt");

var $e9YVH = parcelRequire("e9YVH");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6Z2mh = parcelRequire("6Z2mh");

var $rKFLU = parcelRequire("rKFLU");
const $51233e7b4d73b144$export$cf20fe731144ca3b = (0, $7NszV.createEntry)((0, $bkElt.servicedeskOrganizationsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        component: (0, $rKFLU.ServiceDeskOrganizations),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $rKFLU.LazyServicedeskOrganizations)
        ],
        perfMetricKey: 'jsm-organizations-component-load',
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $cEOhb.AsyncDirectoryNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).ORGANIZATIONS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).ORGANIZATIONS),
                teamName: 'boysenberry'
            }
        }
    }));

});
parcelRegister("bkElt", function(module, exports) {

$parcel$export(module.exports, "servicedeskOrganizationsRoute", () => $3df03e0958f7e9c7$export$d4a712c5bc3c3434);
const $3df03e0958f7e9c7$export$d4a712c5bc3c3434 = {
    name: 'servicedesk-organizations',
    path: '/jira/servicedesk/projects/:projectKey/organizations',
    exact: true
};

});


parcelRegister("iuWOh", function(module, exports) {

$parcel$export(module.exports, "servicedeskOrganizationV2RouteEntry", () => $5928d6539d724a6d$export$1b6ea96c35c2472c);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $38BXB = parcelRequire("38BXB");

var $7CBZS = parcelRequire("7CBZS");

var $fpjJX = parcelRequire("fpjJX");

var $6x0wo = parcelRequire("6x0wo");

var $hlsv9 = parcelRequire("hlsv9");

var $6Z2mh = parcelRequire("6Z2mh");

var $6gtea = parcelRequire("6gtea");
const $5928d6539d724a6d$export$1b6ea96c35c2472c = (0, $7NszV.createEntry)((0, $hlsv9.servicedeskOrganizationV2Route), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $6x0wo.serviceDeskOrganizationPanelForgeDataResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $7CBZS.productsJsmOrganizationDetailsResource),
            (0, $38BXB.jsmEmailDomainsListResource)
        ],
        component: (0, $6gtea.ServiceDeskOrganizationV2),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6gtea.LazyServicedeskOrganizationV2)
        ],
        perfMetricKey: 'jsm-organizations-component-load'
    }));

});
parcelRegister("6x0wo", function(module, exports) {

$parcel$export(module.exports, "serviceDeskOrganizationPanelForgeDataResource", () => $8bc812ed070bb2a3$export$f3c46a19f3594363);

var $2M1hQ = parcelRequire("2M1hQ");


const $8bc812ed070bb2a3$var$getDataLoader = ()=>(parcelRequire("626yv"));
const $8bc812ed070bb2a3$export$f3c46a19f3594363 = (0, $2M1hQ.createResource)({
    type: (0, $b6a87c89b0762905$export$66d6e1e05866ee2f),
    getKey: ({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        return `extension-${projectKey}`;
    },
    getDataLoader: $8bc812ed070bb2a3$var$getDataLoader,
    maxAge: Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});

});
const $b6a87c89b0762905$export$66d6e1e05866ee2f = 'ORGANIZATION_PANEL_FORGE_DATA';

parcelRegister("626yv", function(module, exports) {

let $464803ca0825c621$var$load = (parcelRequire("28QjX"))(4);
module.exports = $464803ca0825c621$var$load("2OoNF").then(()=>parcelRequire('emXcY'));

});


parcelRegister("hlsv9", function(module, exports) {

$parcel$export(module.exports, "servicedeskOrganizationV2Route", () => $0e8ebef5d5d75a55$export$7f878f9aeac61f1e);
const $0e8ebef5d5d75a55$export$7f878f9aeac61f1e = {
    name: 'servicedesk-organization_v2',
    path: '/jira/servicedesk/projects/:projectKey/organization/:organizationId',
    exact: true
};

});

parcelRegister("6gtea", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskOrganizationV2", () => $f3c20d8fbb399193$export$1c7fcdb58f42db03);
$parcel$export(module.exports, "ServiceDeskOrganizationV2", () => $f3c20d8fbb399193$export$5f69663d85db303d);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $f3c20d8fbb399193$export$1c7fcdb58f42db03 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("anLDQ"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/organization-v2/src/index.tsx"
});
const $f3c20d8fbb399193$export$5f69663d85db303d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f3c20d8fbb399193$export$1c7fcdb58f42db03,
        pageId: "spa-apps/servicedesk/organization-v2",
        shouldShowSpinner: true
    });

});
parcelRegister("anLDQ", function(module, exports) {

let $78f101fd532a8011$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $78f101fd532a8011$var$load("ffQaD"),
    $78f101fd532a8011$var$load("kvRbA"),
    $78f101fd532a8011$var$load("15ucL")
]).then(()=>parcelRequire('3BhTj'));

});



parcelRegister("2r2Gu", function(module, exports) {

$parcel$export(module.exports, "servicedeskPlaybooksEditRouteEntry", () => $bdbdec3ce8186cd4$export$abfa8cd64fabd80e);

var $e4eHl = parcelRequire("e4eHl");

var $c04PQ = parcelRequire("c04PQ");

var $h0bZU = parcelRequire("h0bZU");

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $7GkYX = parcelRequire("7GkYX");

var $6Z2mh = parcelRequire("6Z2mh");

var $lmyls = parcelRequire("lmyls");

var $lusKj = parcelRequire("lusKj");

var $lkFvK = parcelRequire("lkFvK");

var $f6cRY = parcelRequire("f6cRY");

var $6LsQE = parcelRequire("6LsQE");
const $bdbdec3ce8186cd4$var$editEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $lusKj.default),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $bdbdec3ce8186cd4$export$abfa8cd64fabd80e = (0, $7NszV.createEntry)((0, $7GkYX.servicedeskPlaybooksEditRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $4R6GH.fg)('playbooks-in-jsm')) {
                if ((0, $c04PQ.isFedRamp)() && (0, $4R6GH.fg)('playbooks_disable_for_fedramp')) return 0, $6LsQE.notFoundPageEntrypoint;
                return $bdbdec3ce8186cd4$var$editEntryPoint;
            }
            return undefined;
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: 'project-settings.playbooks.admin-edit-view',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('project-settings-playbooks-edit'),
                teamName: 'ITOps Phantom'
            }
        },
        component: (0, $5lsNZ.default),
        ufoName: 'playbook-edit',
        skeleton: (0, $f6cRY.PlaybookEditSkeleton)
    }));

});
parcelRegister("7GkYX", function(module, exports) {

$parcel$export(module.exports, "servicedeskPlaybooksEditRoute", () => $f6a9df88dc0097bb$export$5920ce3a2ccf6e2b);
const $f6a9df88dc0097bb$export$5920ce3a2ccf6e2b = {
    name: 'project-settings-playbooks-edit',
    path: '/jira/servicedesk/projects/:projectKey/settings/playbooks/:playbookId',
    exact: true
};

});

parcelRegister("lusKj", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c46caae51932151$export$2e2bcd8739ae039);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $l5Wv9 = parcelRequire("l5Wv9");

var $4R6GH = parcelRequire("4R6GH");

/**
 * NOTE - Please update src/packages/playbooks/edit-screen/src/entrypoint.tsx
 * as that is used in integration test and ideally both should be same except queries
 */ const $7c46caae51932151$var$playbookEditViewEntryPoint = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("fPf2x")), {
        moduleId: "15e5be42",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const { projectKey: projectKey, playbookId: playbookId = '' } = context.match.params;
        const { fromPlaybookId: fromPlaybookId = '' } = context.query;
        if (!projectKey) throw new Error('projectKey is required');
        const { cloudId: cloudId, activationId: activationId } = tenantContext;
        const isNewPlaybook = !!playbookId?.includes($7c46caae51932151$var$NEW_PLAYBOOK_IDENTIFIER);
        const callablePlaybookId = $7c46caae51932151$var$getPlaybookId(playbookId, fromPlaybookId);
        const playbookAri = $7c46caae51932151$var$toPlaybookAri({
            siteId: cloudId,
            activationId: activationId,
            playbookId: callablePlaybookId
        });
        const isNewPlaybookCheck = (0, $4R6GH.fg)('playbook_duplicate_feature') ? isNewPlaybook && !fromPlaybookId : isNewPlaybook;
        if (isNewPlaybookCheck) // This is complete new playbook creation
        return {
            extraProps: {
                playbookAri: playbookAri,
                isNew: true,
                variant: 'new'
            }
        };
        return {
            queries: {
                PlaybookDetailQuery: {
                    parameters: (0, $l5Wv9.default),
                    variables: {
                        playbookAri: playbookAri,
                        jqlFilterSupportEnabled: (0, $4R6GH.fg)('bif-2073-jql-filter-support-playbook')
                    }
                }
            },
            extraProps: {
                playbookAri: playbookAri,
                isNew: false,
                variant: isNewPlaybook && !!fromPlaybookId ? 'copy' : 'edit'
            }
        };
    }
});
var $7c46caae51932151$export$2e2bcd8739ae039 = $7c46caae51932151$var$playbookEditViewEntryPoint;
function $7c46caae51932151$var$toPlaybookAri({ siteId: siteId, activationId: activationId, playbookId: playbookId }) {
    return `ari:cloud:jira:${siteId}:playbook/activation/${activationId}/${playbookId}`;
}
const $7c46caae51932151$var$getPlaybookId = (playbookId, fromPlaybookId)=>{
    if ((0, $4R6GH.fg)('playbook_duplicate_feature')) {
        if (fromPlaybookId) return fromPlaybookId;
        return playbookId || '';
    }
    return playbookId || '';
};
const $7c46caae51932151$var$NEW_PLAYBOOK_IDENTIFIER = '_new_';

});
parcelRegister("l5Wv9", function(module, exports) {

$parcel$export(module.exports, "default", () => $1650a5e016addfe6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<62fd2d24521bf1b720b287d66f16c390>>
 * @relayHash e9c7e6b4898ee3fc37292a281d66d56b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e46b239ecba29033c61fed267ed511d448fb890bb4309170ec2b9627fe77264f
const $1650a5e016addfe6$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "e46b239ecba29033c61fed267ed511d448fb890bb4309170ec2b9627fe77264f",
        "metadata": {},
        "name": "PlaybookDetailQuery",
        "operationKind": "query",
        "text": null
    }
};
var $1650a5e016addfe6$export$2e2bcd8739ae039 = $1650a5e016addfe6$var$node;

});

parcelRegister("fPf2x", function(module, exports) {

let $b857490d1b9f4970$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $b857490d1b9f4970$var$load("ffQaD"),
    $b857490d1b9f4970$var$load("kvRbA"),
    $b857490d1b9f4970$var$load("fliVL"),
    $b857490d1b9f4970$var$load("4qmB9")
]).then(()=>parcelRequire('79e1o'));

});


parcelRegister("f6cRY", function(module, exports) {

$parcel$export(module.exports, "PlaybookEditSkeleton", () => $da382d4ceac0982f$export$8e181e27312cd7a4);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $1GGwS = parcelRequire("1GGwS");

var $1DVhQ = parcelRequire("1DVhQ");

var $cS37j = parcelRequire("cS37j");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $7Kysn = parcelRequire("7Kysn");
const $da382d4ceac0982f$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    returnToList: {
        "id": "playbooks-edit-screen.playbook-item.skeleton.return-to-list",
        "defaultMessage": "Return to list"
    }
});
const $da382d4ceac0982f$export$8e181e27312cd7a4 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [playbookListLink] = (0, $7Kysn.useReturnToListUrl)();
    const actions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.100",
        direction: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1GGwS.default), {
        appearance: "subtle",
        href: playbookListLink
    }, formatMessage($da382d4ceac0982f$export$defe85febe8b728c.returnToList)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        xcss: $da382d4ceac0982f$var$containerStyle,
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), {
        actions: actions,
        disableTitleStyles: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.300",
        direction: "row",
        justifyContent: "space-between",
        xcss: $da382d4ceac0982f$var$contentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        xcss: $da382d4ceac0982f$var$stepCards,
        alignBlock: "start",
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        height: "52px",
        width: "100%",
        isShimmering: true,
        borderRadius: "8px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        height: "52px",
        width: "100%",
        isShimmering: true,
        borderRadius: "8px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $da382d4ceac0982f$var$addButton,
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        height: "40px",
        width: "40px",
        isShimmering: true,
        borderRadius: "40px"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $da382d4ceac0982f$var$detailStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        height: "520px",
        width: "100%",
        isShimmering: true,
        borderRadius: "8px"
    }))));
};
const $da382d4ceac0982f$var$containerStyle = (0, $8CUq3.xcss)({
    backgroundColor: 'elevation.surface.sunken',
    paddingLeft: 'space.300',
    paddingRight: 'space.500',
    height: '100vh'
});
const $da382d4ceac0982f$var$detailStyle = (0, $8CUq3.xcss)({
    maxWidth: '800px',
    minWidth: '440px',
    width: '45%'
});
const $da382d4ceac0982f$var$contentStyles = (0, $8CUq3.xcss)({
    width: '100%',
    paddingTop: 'space.400'
});
const $da382d4ceac0982f$var$stepCards = (0, $8CUq3.xcss)({
    flexGrow: 0,
    flexShrink: 1,
    flexBasis: '30%',
    maxWidth: '600px'
});
const $da382d4ceac0982f$var$addButton = (0, $8CUq3.xcss)({
    height: '52px'
});

});
parcelRegister("cS37j", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a15efb09f101ecb$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $57MwZ = parcelRequire("57MwZ");
const $2a15efb09f101ecb$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $57MwZ.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2a15efb09f101ecb$var$ActionsWrapper, null, actions) : null
    });
var $2a15efb09f101ecb$export$2e2bcd8739ae039 = $2a15efb09f101ecb$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a15efb09f101ecb$var$ActionsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("57MwZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9694e728fd1ea060$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eeGIy = parcelRequire("eeGIy");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $9694e728fd1ea060$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false, testId: testId })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eeGIy.OuterWrapper), {
        children: [
            breadcrumbs,
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eeGIy.TitleWrapper), {
                truncateTitle: truncateTitle,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eeGIy.TitleContainer), {
                        truncateTitle: truncateTitle,
                        children: disableTitleStyles ? children : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eeGIy.StyledTitleWrapper), {
                            ref: innerRef,
                            truncateTitle: truncateTitle,
                            id: id,
                            testId: testId,
                            children: children
                        })
                    }),
                    actions && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eeGIy.ActionsWrapper), {
                        children: actions
                    })
                ]
            }),
            bottomBar && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eeGIy.BottomBarWrapper), {
                children: [
                    " ",
                    bottomBar,
                    " "
                ]
            })
        ]
    });
};
var $9694e728fd1ea060$export$2e2bcd8739ae039 = $9694e728fd1ea060$var$PageHeader;

});
parcelRegister("eeGIy", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $0c196d37a4e8266c$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $0c196d37a4e8266c$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $0c196d37a4e8266c$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $0c196d37a4e8266c$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $0c196d37a4e8266c$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $0c196d37a4e8266c$export$6330225854c30dc);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
const $0c196d37a4e8266c$var$styles = {
    bottomBar: "_1pfhpxbi"
};
const $0c196d37a4e8266c$var$truncateStyles = null;
const $0c196d37a4e8266c$var$outerStyles = null;
const $0c196d37a4e8266c$var$titleStyles = null;
const $0c196d37a4e8266c$var$titleWrapperStyles = null;
const $0c196d37a4e8266c$var$titleWrapperTruncateStyles = null;
const $0c196d37a4e8266c$var$titleContainerStyles = null;
const $0c196d37a4e8266c$var$actionStyles = null;
const $0c196d37a4e8266c$var$titleContainerTruncateStyles = null;
const $0c196d37a4e8266c$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_6rthpxbi _1pfh1ejb _12l2idpf _ahbqidpf"
        ]),
        children: children
    });
};
const $0c196d37a4e8266c$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("h1", {
        ref: ref,
        tabIndex: -1,
        id: id,
        "data-testid": testId && `${testId}--title`,
        className: (0, $bwpsq.default)([
            "_11c8nf1z _12ji1r31 _1qu2glyw _12y31o36 _syaz1fxt _1dyz4jg8 _1pfhidpf",
            truncateTitle && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
        ]),
        children: children
    });
});
const $0c196d37a4e8266c$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1y6m _1n261g80",
            truncateTitle && "_1n261q9c"
        ]),
        children: children
    });
};
const $0c196d37a4e8266c$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zidpf _i0dl1wug _1ul9idpf _p12f1osq _6rthu2gc",
            truncateTitle && "_1o9zkb7n"
        ]),
        children: children
    });
};
const $0c196d37a4e8266c$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _p12f1osq _6rthu2gc _ahbq1wug _bozgxy5q _o5721q9c"
        ]),
        children: children
    });
};
const $0c196d37a4e8266c$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $0c196d37a4e8266c$var$styles.bottomBar,
        children: children
    });
};

});



parcelRegister("7Kysn", function(module, exports) {

$parcel$export(module.exports, "getStepData", () => $d5ec6522606d2f57$export$f1427121561aecf8);
$parcel$export(module.exports, "isStep", () => $d5ec6522606d2f57$export$21684750287da054);
$parcel$export(module.exports, "useIsNewPlaybook", () => $d5ec6522606d2f57$export$d761c1032826f7f);
$parcel$export(module.exports, "getJiraPlaybookIdFromARI", () => $d5ec6522606d2f57$export$191a8b6475837449);
$parcel$export(module.exports, "useReturnToListUrl", () => $d5ec6522606d2f57$export$565f39f00aacdb73);
$parcel$export(module.exports, "getIsDescriptionEmpty", () => $d5ec6522606d2f57$export$f11d072d2cef989a);
$parcel$export(module.exports, "getStepsOrder", () => $d5ec6522606d2f57$export$812421dcb7983dd1);
$parcel$export(module.exports, "getStepsDetail", () => $d5ec6522606d2f57$export$aa46de8dc426f402);

var $kz2lw = parcelRequire("kz2lw");

var $gB22t = parcelRequire("gB22t");

var $bmKPg = parcelRequire("bmKPg");

var $6c7e8 = parcelRequire("6c7e8");

var $iMvey = parcelRequire("iMvey");
const $d5ec6522606d2f57$export$f1427121561aecf8 = (id, name, type, index)=>{
    return {
        stepId: id,
        name: name,
        index: index,
        type: type
    };
};
const $d5ec6522606d2f57$export$21684750287da054 = (data)=>{
    if (data) {
        const { type: type } = data;
        return type === 'INSTRUCTIONAL_RULE' || type === 'AUTOMATION_RULE';
    }
    return false;
};
const $d5ec6522606d2f57$export$cf6e5a5e05d437ad = (cloudId, activationId, playbookId)=>{
    return (0, $gB22t.JiraPlaybookAri).create({
        siteId: cloudId,
        activationId: activationId,
        playbookId: playbookId
    }).toString();
};
const $d5ec6522606d2f57$export$d761c1032826f7f = ()=>{
    const [playbookId = ''] = (0, $bmKPg.usePathParam)('playbookId');
    return playbookId.includes((0, $iMvey.NEW_PLAYBOOK_IDENTIFIER));
};
const $d5ec6522606d2f57$export$191a8b6475837449 = (playbookAri)=>{
    return (0, $gB22t.JiraPlaybookAri).parse(playbookAri).playbookId;
};
const $d5ec6522606d2f57$export$565f39f00aacdb73 = ()=>{
    const [projectKey = ''] = (0, $bmKPg.usePathParam)('projectKey');
    const playbookListLink = (0, $6c7e8.getProjectSettingsPageUrl)(projectKey, 'playbooks');
    return [
        playbookListLink
    ];
};
const $d5ec6522606d2f57$export$f11d072d2cef989a = (description)=>{
    if (description && Object.keys(description).length > 0) return JSON.stringify(description) === JSON.stringify((0, $kz2lw.getEmptyADF)());
    return true;
};
const $d5ec6522606d2f57$export$812421dcb7983dd1 = (data)=>{
    return data.map((step)=>step.stepId);
};
const $d5ec6522606d2f57$export$aa46de8dc426f402 = (data)=>{
    const acc = {};
    data.forEach((step)=>{
        acc[step.stepId] = step;
    });
    return acc;
};

});
parcelRegister("kz2lw", function(module, exports) {

$parcel$export(module.exports, "getEmptyADF", () => $06167b6274ea84aa$export$d109ab46c9575565);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $ebjue = parcelRequire("ebjue");
const $06167b6274ea84aa$export$d109ab46c9575565 = ()=>({
        type: 'doc',
        version: 1,
        content: []
    });

});
parcelRegister("ebjue", function(module, exports) {

$parcel$export(module.exports, "isEmpty", () => $9e55b7d6fded4629$export$dd1bc94b04021eeb);
const $9e55b7d6fded4629$export$dd1bc94b04021eeb = (node)=>!node?.content?.length;

});


parcelRegister("gB22t", function(module, exports) {

$parcel$export(module.exports, "JiraPlaybookAri", () => $c151aeecb99aa7ff$export$2b27259a6ef92c74);

var $cyZcy = parcelRequire("cyZcy");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/playbook/manifest.ts
var $c151aeecb99aa7ff$var$jiraPlaybookAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $cyZcy.JiraPlaybookAriResourceOwner),
    resourceType: (0, $cyZcy.JiraPlaybookAriResourceType),
    resourceIdSlug: "activation/{activationId}/{playbookId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        playbookId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/jira/playbook/index.ts
var $c151aeecb99aa7ff$export$2b27259a6ef92c74 = class _JiraPlaybookAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._playbookId = opts.resourceIdSegmentValues.playbookId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get playbookId() {
        return this._playbookId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $c151aeecb99aa7ff$var$jiraPlaybookAriStaticOpts.qualifier,
            platformQualifier: $c151aeecb99aa7ff$var$jiraPlaybookAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $c151aeecb99aa7ff$var$jiraPlaybookAriStaticOpts.resourceOwner,
            resourceType: $c151aeecb99aa7ff$var$jiraPlaybookAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.playbookId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                playbookId: opts.playbookId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $c151aeecb99aa7ff$var$jiraPlaybookAriStaticOpts);
        return new _JiraPlaybookAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $c151aeecb99aa7ff$var$jiraPlaybookAriStaticOpts);
        return new _JiraPlaybookAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            playbookId: this.playbookId
        };
    }
};

});
parcelRegister("cyZcy", function(module, exports) {

$parcel$export(module.exports, "JiraPlaybookAriResourceOwner", () => $9258225fc0ac187a$export$91235105b4a9ebd9);
$parcel$export(module.exports, "JiraPlaybookAriResourceType", () => $9258225fc0ac187a$export$5af5bf4e6f11326f);
// src/jira/playbook/types.ts
var $9258225fc0ac187a$export$91235105b4a9ebd9 = "jira", $9258225fc0ac187a$export$5af5bf4e6f11326f = "playbook";

});


parcelRegister("6c7e8", function(module, exports) {

$parcel$export(module.exports, "getProjectUrl", () => $19354c1d34ccf1a2$export$951b86b8e730b952);
$parcel$export(module.exports, "getRequestTypesUrl", () => $19354c1d34ccf1a2$export$9d7c743b509e267);
$parcel$export(module.exports, "getChangeRequestTypesUrl", () => $19354c1d34ccf1a2$export$6096ac65eb900914);
$parcel$export(module.exports, "getProjectSettingsPageUrl", () => $19354c1d34ccf1a2$export$75ee62cffcd82d96);
$parcel$export(module.exports, "getProjectSettingsUrl", () => $19354c1d34ccf1a2$export$a497c8f8c3782075);
$parcel$export(module.exports, "getWorkflowSettingsUrl", () => $19354c1d34ccf1a2$export$c2a8139910ee6c);
$parcel$export(module.exports, "getJsmChangeEditionUrl", () => $19354c1d34ccf1a2$export$b87292f363462760);
$parcel$export(module.exports, "getUserManagementUrl", () => $19354c1d34ccf1a2$export$13f39b40814e5f3e);

var $2vSU6 = parcelRequire("2vSU6");

var $02Psx = parcelRequire("02Psx");

var $l3Iek = parcelRequire("l3Iek");

var $cmEH1 = parcelRequire("cmEH1");

var $2iuKi = parcelRequire("2iuKi");

var $9VXkC = parcelRequire("9VXkC");
const $19354c1d34ccf1a2$export$951b86b8e730b952 = (projectKey)=>(0, $9VXkC.generatePath)((0, $2iuKi.projectsRedirectRoute).path, {
        projectKey: projectKey
    });
const $19354c1d34ccf1a2$var$getNextgenIssueTypesUrl = (projectKey, issueTypeId)=>(0, $02Psx.getNextgenSettingsIssueTypesUrl)((0, $2vSU6.SERVICE_DESK_PROJECT), projectKey, issueTypeId);
const $19354c1d34ccf1a2$export$9d7c743b509e267 = (projectKey, isSimplified = false)=>isSimplified ? $19354c1d34ccf1a2$var$getNextgenIssueTypesUrl(projectKey) : (0, $9VXkC.generatePath)((0, $cmEH1.projectSettingsServicedeskTicketTypesConfigRoute).path, {
        projectKey: projectKey
    });
const $19354c1d34ccf1a2$export$6096ac65eb900914 = (projectKey, isSimplified = false)=>isSimplified ? $19354c1d34ccf1a2$var$getNextgenIssueTypesUrl(projectKey) : `${$19354c1d34ccf1a2$export$9d7c743b509e267(projectKey, isSimplified)}/category/changes`;
const $19354c1d34ccf1a2$export$75ee62cffcd82d96 = (projectKey, relativeUrl)=>`/jira/servicedesk/projects/${projectKey}/settings/${relativeUrl}`;
const $19354c1d34ccf1a2$export$a497c8f8c3782075 = (projectKey, isSimplified = false)=>{
    const classicSettingsUrl = `/plugins/servlet/project-config/${projectKey}`;
    return isSimplified ? $19354c1d34ccf1a2$var$getNextgenIssueTypesUrl(projectKey) : classicSettingsUrl;
};
const $19354c1d34ccf1a2$export$c2a8139910ee6c = (projectKey, issueTypeId, isSimplified = false)=>{
    if (!issueTypeId) return isSimplified ? $19354c1d34ccf1a2$var$getNextgenIssueTypesUrl(projectKey) : (0, $9VXkC.generatePath)((0, $l3Iek.legacyProjectSettingsWorkflowsRoute).path, {
        projectKey: projectKey
    });
    return isSimplified ? $19354c1d34ccf1a2$var$getNextgenIssueTypesUrl(projectKey, issueTypeId) : `/plugins/servlet/project-config/${projectKey}/issuetypes/${issueTypeId}/workflow`;
};
const $19354c1d34ccf1a2$export$b87292f363462760 = ()=>'/admin/billing/applications/change-edition/jira-servicedesk.ondemand';
const $19354c1d34ccf1a2$export$13f39b40814e5f3e = ()=>'/admin/users?referrerName=JIRA';

});
parcelRegister("l3Iek", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsWorkflowsRoute", () => $31816b9f42bcb36a$export$b03606cedffdadf6);
const $31816b9f42bcb36a$export$b03606cedffdadf6 = {
    name: 'legacy-project-settings-workflows',
    path: '/plugins/servlet/project-config/:projectKey/workflows'
};

});


parcelRegister("iMvey", function(module, exports) {

$parcel$export(module.exports, "DragState", () => $a810461a6c4da09f$export$4e38e1908f8d60cc);
$parcel$export(module.exports, "DETAILS_QUERY_PARAM_VALUE", () => $a810461a6c4da09f$export$4ff6caac8d343661);
$parcel$export(module.exports, "STEP_QUERY_PARAM", () => $a810461a6c4da09f$export$10d60ba8ee33b6cd);
$parcel$export(module.exports, "NEW_PLAYBOOK_IDENTIFIER", () => $a810461a6c4da09f$export$ddc22677c31f7347);
$parcel$export(module.exports, "NEW_STEP_IDENTIFIER", () => $a810461a6c4da09f$export$a1049a464ef7c857);
const $a810461a6c4da09f$export$4e38e1908f8d60cc = {
    IDLE: 'idle',
    PREVIEW: 'preview',
    DRAGGING: 'dragging'
};
const $a810461a6c4da09f$export$4ff6caac8d343661 = 'details';
const $a810461a6c4da09f$export$10d60ba8ee33b6cd = 'step';
const $a810461a6c4da09f$export$ddc22677c31f7347 = '_new_';
const $a810461a6c4da09f$export$a1049a464ef7c857 = '_new_';

});




parcelRegister("80PF8", function(module, exports) {

$parcel$export(module.exports, "servicedeskPlaybooksListRouteEntry", () => $ccdff8c69ba43bde$export$19177b8fa44e5e4d);

var $e4eHl = parcelRequire("e4eHl");

var $4R6GH = parcelRequire("4R6GH");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $8YZBz = parcelRequire("8YZBz");

var $6Z2mh = parcelRequire("6Z2mh");

var $lmyls = parcelRequire("lmyls");

var $lk01G = parcelRequire("lk01G");

var $lkFvK = parcelRequire("lkFvK");

var $jom1z = parcelRequire("jom1z");

var $6LsQE = parcelRequire("6LsQE");

var $c04PQ = parcelRequire("c04PQ");
const $ccdff8c69ba43bde$var$listEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $lk01G.default),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $ccdff8c69ba43bde$export$19177b8fa44e5e4d = (0, $7NszV.createEntry)((0, $8YZBz.servicedeskPlaybooksListRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $4R6GH.fg)('playbooks-in-jsm')) {
                if ((0, $c04PQ.isFedRamp)() && (0, $4R6GH.fg)('playbooks_disable_for_fedramp')) return 0, $6LsQE.notFoundPageEntrypoint;
                return $ccdff8c69ba43bde$var$listEntryPoint;
            }
            return undefined;
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $jom1z.playbooksListRequestTypesResource)
        ],
        meta: {
            reporting: {
                id: 'project-settings.playbooks.admin-list-view',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('project-settings-playbooks-list'),
                teamName: 'ITOps Phantom'
            }
        },
        component: (0, $5lsNZ.default),
        ufoName: 'playbook-list'
    }));

});
parcelRegister("8YZBz", function(module, exports) {

$parcel$export(module.exports, "servicedeskPlaybooksListRoute", () => $39cfce4bc27a2e92$export$cbed08b5b0671f5f);
const $39cfce4bc27a2e92$export$cbed08b5b0671f5f = {
    name: 'project-settings-playbooks-list',
    path: '/jira/servicedesk/projects/:projectKey/settings/playbooks',
    exact: true
};

});

parcelRegister("lk01G", function(module, exports) {

$parcel$export(module.exports, "default", () => $787278c10397c75e$export$2e2bcd8739ae039);

var $8fDOc = parcelRequire("8fDOc");

var $6YEEX = parcelRequire("6YEEX");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore Argument of type '{ root: ...; getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => any; }' is not assignable to parameter of type 'never'
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $787278c10397c75e$var$playbookListViewEntryPoint = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("kKaI7")), {
        moduleId: "a498670b",
        priority: "interaction"
    }),
    // This has been causing build errors in unrelated code. Broadening type to fix build.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const { projectKey: projectKey } = context.match.params;
        const { tab: tab = 'list', name: name = '' } = context.query;
        if (!projectKey) throw new Error('projectKey is required');
        // In case where tab is logs, we need to load the logs entry point
        // For other cases, fallback to the list entry point. This matches the current logic in the UI component.
        const entryPoints = tab === 'logs' ? {
            preloadedPlaybookLogsEntryPoint: {
                entryPoint: (0, $6YEEX.playbookLogsEntryPoint),
                entryPointParams: {
                    cloudId: tenantContext.cloudId,
                    projectKey: projectKey,
                    first: 20,
                    filter: name ? {
                        name: name
                    } : null
                }
            }
        } : {
            preloadedPlaybookListEntryPoint: {
                entryPoint: (0, $8fDOc.playbookListEntryPoint),
                entryPointParams: {
                    cloudId: tenantContext.cloudId,
                    projectKey: projectKey,
                    first: 20,
                    filter: name ? {
                        name: name
                    } : null
                }
            }
        };
        return {
            extraProps: {
                accountId: tenantContext.atlassianAccountId,
                cloudId: tenantContext.cloudId,
                projectId: context.query.projectId,
                projectKey: context.match.params.projectKey
            },
            entryPoints: entryPoints
        };
    }
});
var $787278c10397c75e$export$2e2bcd8739ae039 = $787278c10397c75e$var$playbookListViewEntryPoint;

});
parcelRegister("8fDOc", function(module, exports) {

$parcel$export(module.exports, "playbookListEntryPoint", () => $d77fb854f7f8e8b8$export$d7be5d3b24f1d526);

var $k1Mbn = parcelRequire("k1Mbn");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $d77fb854f7f8e8b8$export$d7be5d3b24f1d526 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("4xpNC")).then((module)=>module.PlaybookList), {
        moduleId: "3f3b7cb0",
        moduleName: "PlaybookList",
        priority: "userVisible"
    }),
    getPreloadProps: (variables)=>{
        return {
            queries: {
                PlaybookListQuery: {
                    parameters: (0, $k1Mbn.default),
                    variables: variables
                }
            }
        };
    }
});

});
parcelRegister("k1Mbn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0a57d88af1f6396$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b88c7d8959d92c99cd3826a502e76334>>
 * @relayHash b47669aaa2d26c840c41f7ffe677fdee
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 77aaea5c8216b45b296be33aff153112c51d2e91c98685f982b9ea3d4088d4e6
const $a0a57d88af1f6396$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "77aaea5c8216b45b296be33aff153112c51d2e91c98685f982b9ea3d4088d4e6",
        "metadata": {},
        "name": "PlaybookListQuery",
        "operationKind": "query",
        "text": null
    }
};
var $a0a57d88af1f6396$export$2e2bcd8739ae039 = $a0a57d88af1f6396$var$node;

});

parcelRegister("4xpNC", function(module, exports) {

let $34de41ac7ad35f10$var$load = (parcelRequire("28QjX"))(4);
module.exports = $34de41ac7ad35f10$var$load("9gFtJ").then(()=>parcelRequire('hM1vX'));

});


parcelRegister("6YEEX", function(module, exports) {

$parcel$export(module.exports, "playbookLogsEntryPoint", () => $60633bec6dffe3a8$export$7ebe0f850472ea07);

var $2OZhN = parcelRequire("2OZhN");

var $YWlMy = parcelRequire("YWlMy");

var $fEDBv = parcelRequire("fEDBv");

const $60633bec6dffe3a8$export$7ebe0f850472ea07 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("5mg8u")), {
        moduleId: "c3ca80f1",
        moduleName: "PlaybookLogs",
        priority: "userVisible"
    }),
    getPreloadProps: (variables)=>({
            queries: {
                PlaybookLogsQuery: {
                    parameters: (0, $YWlMy.default),
                    variables: variables
                }
            }
        })
});

});
parcelRegister("YWlMy", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcd4a200ecef7c9e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<eac6514e594c2e6e8979a745c7d9215c>>
 * @relayHash c40005688009ad578d2262abe92dfdd6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 42292b23d4d61a2a7e987006bd56b1edc64641483aaf6e59202fb8e13a1830da
const $fcd4a200ecef7c9e$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "42292b23d4d61a2a7e987006bd56b1edc64641483aaf6e59202fb8e13a1830da",
        "metadata": {},
        "name": "PlaybookLogsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $fcd4a200ecef7c9e$export$2e2bcd8739ae039 = $fcd4a200ecef7c9e$var$node;

});

parcelRegister("5mg8u", function(module, exports) {

let $3e6b860fc8b7aed4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3e6b860fc8b7aed4$var$load("diW3e").then(()=>parcelRequire('baehV'));

});


parcelRegister("kKaI7", function(module, exports) {

let $f1a0696bff22865f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f1a0696bff22865f$var$load("dAVQn").then(()=>parcelRequire('6o22p'));

});


parcelRegister("jom1z", function(module, exports) {

$parcel$export(module.exports, "playbooksListRequestTypesResource", () => $4640323ec09a801b$export$43f774aa05fabd18);

var $2M1hQ = parcelRequire("2M1hQ");


var $jthxb = parcelRequire("jthxb");

var $eusud = parcelRequire("eusud");
const $4640323ec09a801b$export$43f774aa05fabd18 = (0, $2M1hQ.createResource)({
    type: 'PLAYBOOKS-LIST-REQUEST-TYPES-RESOURCE-TYPE',
    getKey: ({ match: match })=>{
        const projectKey = match.params.projectKey;
        return `playbooksListRequestTypesResource-${projectKey}`;
    },
    getData: async ({ dependencies: dependencies })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { projectId: projectId } = await (0, $jthxb.consumeDependency)(dependencies, (0, $0f463a88567f1621$export$80a60a092d9ab81));
        return (0, $eusud.performGetRequest)($4640323ec09a801b$var$getRequestTypesUrl(projectId)).then((response)=>response.ticketTypes);
    },
    maxAge: 300000,
    depends: [
        (0, $0f463a88567f1621$export$80a60a092d9ab81)
    ]
});
const $4640323ec09a801b$var$getRequestTypesUrl = (projectId)=>`/rest/servicedesk/1/servicedesk/${projectId}/request-types`;

});


parcelRegister("aAIWh", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeEditRouteEntry", () => $b2af11fd25aabf4a$export$5d9efd0f838d30a1);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $aDAYL = parcelRequire("aDAYL");

var $6Z2mh = parcelRequire("6Z2mh");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $4kils = parcelRequire("4kils");

var $a3285 = parcelRequire("a3285");

var $iRITI = parcelRequire("iRITI");
const $b2af11fd25aabf4a$export$5d9efd0f838d30a1 = (0, $7NszV.createEntry)((0, $aDAYL.servicedeskPracticeEditRoute), ()=>({
        group: 'servicedesk',
        component: (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $a3285.ServicedeskQueuesConfig), (0, $4kils.default)),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            ...(0, $fpjJX.getIssueListSsrResource)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $fpjJX.getQueueConfigResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $a3285.LazyServicedeskQueuesConfig) : (0, $4kils.LazyServicedeskQueuesEditView)
        ],
        pageId: ({ query: query, match: match })=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? `spa-apps/servicedesk/queues/views-config/${query.config}` : `spa-apps/servicedesk/queues/edit/${match.params && match.params.queueId || ''}`,
        entryPoint () {
            return (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $iRITI.serviceDeskQueuesConfigPageEntryPoint) : undefined;
        }
    }));

});
parcelRegister("aDAYL", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeEditRoute", () => $c23ca6ea0acd72bb$export$dfaa99f66db1aa2);
const $c23ca6ea0acd72bb$export$dfaa99f66db1aa2 = {
    name: 'servicedesk-practice-edit',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/edit',
    exact: true,
    query: [
        'config?'
    ]
};

});

parcelRegister("4kils", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesEditView", () => $deaadf08ad128234$export$5bb02347e0261e6a);
$parcel$export(module.exports, "default", () => $deaadf08ad128234$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $deaadf08ad128234$export$5bb02347e0261e6a = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("h871I"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-edit-view/src/index.tsx"
});
var /**
 * @deprecated Remove this when fsm_views_inside_queues_-_main_flag is cleaned up
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$deaadf08ad128234$export$2e2bcd8739ae039 = ({ match: match })=>{
    const queueId = match.params && match.params.queueId || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $deaadf08ad128234$export$5bb02347e0261e6a,
        pageId: `spa-apps/servicedesk/queues/edit/${queueId}`,
        shouldShowSpinner: true
    });
};

});
parcelRegister("h871I", function(module, exports) {

let $c788a260225084ad$var$load = (parcelRequire("28QjX"))(4);

module.exports = Promise.all([
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $c788a260225084ad$var$load("czifk")
        ]);
    }, function() {
        return Promise.all([
            $c788a260225084ad$var$load("kcs34")
        ]);
    }),
    $c788a260225084ad$var$load("ffQaD"),
    $c788a260225084ad$var$load("kvRbA"),
    $c788a260225084ad$var$load("8IAs5")
]).then(()=>parcelRequire('3r23L'));

});


parcelRegister("a3285", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesConfig", () => $262e81f2d9d70ac4$export$8bc01f18d5db1178);
$parcel$export(module.exports, "ServicedeskQueuesConfig", () => $262e81f2d9d70ac4$export$ac10b7696844d33);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $7tQej = parcelRequire("7tQej");

const $262e81f2d9d70ac4$export$8bc01f18d5db1178 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("3MPbT")), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-config/src/index.tsx"
});
const $262e81f2d9d70ac4$export$ac10b7696844d33 = (props)=>{
    const { query: query } = props;
    // If URL is from edit queue, then redirect to the new URL with config query param
    if (!query.config) {
        const { config: config, ...restQuery } = query;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: {
                pathname: `${props.location.pathname}`,
                hash: '',
                search: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
                    ...restQuery,
                    config: 'queueConfig'
                })
            }
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $262e81f2d9d70ac4$export$8bc01f18d5db1178,
        pageId: `spa-apps/servicedesk/queues/config/${query.config}`,
        shouldShowSpinner: true
    });
};

});
parcelRegister("3MPbT", function(module, exports) {

let $2c1d90385a30e022$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $2c1d90385a30e022$var$load("ffQaD"),
    $2c1d90385a30e022$var$load("kvRbA"),
    $2c1d90385a30e022$var$load("fZ3Mx")
]).then(()=>parcelRequire('bgMER'));

});


parcelRegister("iRITI", function(module, exports) {

$parcel$export(module.exports, "serviceDeskQueuesConfigPageEntryPoint", () => $34887bb49cd0d1b5$export$2a7296eb9b68414);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $cZYKf = parcelRequire("cZYKf");
const $34887bb49cd0d1b5$export$2a7296eb9b68414 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $cZYKf.queuesConfigEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("cZYKf", function(module, exports) {

$parcel$export(module.exports, "queuesConfigEntrypoint", () => $4ca55b3219138116$export$bc016338e2032123);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $9AmTW = parcelRequire("9AmTW");

var $1nb22 = parcelRequire("1nb22");

var $ktofH = parcelRequire("ktofH");

var $cmFS1 = parcelRequire("cmFS1");

const $4ca55b3219138116$export$bc016338e2032123 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>{
        return (parcelRequire("3MPbT"));
    }, {
        moduleId: "2bb3c6f1",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: { match: match, query: query, route: route }, tenantContext: { activationId: activationId, cloudId: cloudId } })=>{
        const queueId = match.params.queueId;
        let { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(match, query);
        projectKey = projectKey ?? '';
        const queueAri = queueId ? (0, $9AmTW.JiraServicedeskQueueAri).create({
            siteId: cloudId,
            queueId: queueId || '',
            activationId: activationId
        }).toString() : '';
        const input = queueAri ? {
            scopeId: queueAri
        } : {
            projectKeyQuery: {
                cloudId: cloudId,
                projectKey: projectKey
            }
        };
        return {
            queries: {
                mainSettingsNavigationQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $cmFS1.default),
                    variables: {
                        input: input,
                        first: (0, $ktofH.NAVIGATION_ITEMS_PAGE_SIZE)
                    }
                }
            },
            extraProps: {
                query: query,
                match: match,
                route: route
            }
        };
    }
});

});
parcelRegister("cmFS1", function(module, exports) {

$parcel$export(module.exports, "default", () => $30f039e31305dc75$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<46e2694401dd0296d6732a14558ad98c>>
 * @relayHash dfd06866fddd95df7034205febe8eb4e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9b239a41299b531cf29a09d8abbeb2cf530d1715b2ea22ad115bc7f31e5f68f9
const $30f039e31305dc75$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "typeKey"
    }, v6 = {
        "kind": "ScalarField",
        "name": "message"
    }, v7 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v8 = {
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            v7 /*: any*/ 
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = [
        v6 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                v3 /*: any*/ ,
                v7 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainSettingsNavigationQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "containerNavigation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "args": v4 /*: any*/ ,
                                                    "concreteType": "JiraNavigationItemConnection",
                                                    "kind": "LinkedField",
                                                    "name": "navigationItems",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "JiraNavigationItemEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v5 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        "action": "THROW",
                                                                        "path": "jira.containerNavigation.navigationItems.edges.node"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "THROW",
                                                            "path": "jira.containerNavigation.navigationItems.edges"
                                                        },
                                                        {
                                                            "concreteType": "QueryError",
                                                            "kind": "LinkedField",
                                                            "name": "errors",
                                                            "plural": true,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                v8 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraContainerNavigation"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.containerNavigation"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainSettingsNavigationQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "containerNavigation",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v4 /*: any*/ ,
                                            "concreteType": "JiraNavigationItemConnection",
                                            "kind": "LinkedField",
                                            "name": "navigationItems",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraNavigationItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                v9 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "errors",
                                                    "plural": true,
                                                    "selections": v10 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraContainerNavigation"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": v10 /*: any*/ ,
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9b239a41299b531cf29a09d8abbeb2cf530d1715b2ea22ad115bc7f31e5f68f9",
            "metadata": {},
            "name": "mainSettingsNavigationQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$30f039e31305dc75$var$node.hash = "a86c2910ccbf2af4328e8f1d666e319c";
var $30f039e31305dc75$export$2e2bcd8739ae039 = $30f039e31305dc75$var$node;

});




parcelRegister("5fOtJ", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeIssueRouteEntry", () => $c4ae805410394011$export$ff51f5ad948cb987);

var $ffza4 = parcelRequire("ffza4");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $jlOGG = parcelRequire("jlOGG");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6yPAx = parcelRequire("6yPAx");

var $6Z2mh = parcelRequire("6Z2mh");

var $lAGdd = parcelRequire("lAGdd");

var $i1TcK = parcelRequire("i1TcK");
const $c4ae805410394011$export$ff51f5ad948cb987 = (0, $7NszV.createEntry)((0, $6yPAx.servicedeskPracticeIssueRoute), ()=>({
        group: 'servicedesk',
        component: (0, $i1TcK.default),
        layout: (0, $aPfsS.composeLayouts)((0, $6Z2mh.serviceProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)()),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            ...(0, $fpjJX.getKnowledgeBaseResources)(),
            ...(0, $fpjJX.getInsightResources)(),
            (0, $jlOGG.newIssueViewLockInStatusResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $lAGdd.getAIContextPanelResources)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $i1TcK.LazyServicedeskQueuesIssueView)
        ]
    }));

});
parcelRegister("6yPAx", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeIssueRoute", () => $b7f41b661071cdd5$export$38a6ee0f22e74bf3);
const $b7f41b661071cdd5$export$38a6ee0f22e74bf3 = {
    name: 'servicedesk-practice-issue',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/issue/:issueKey',
    exact: true
};

});

parcelRegister("i1TcK", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesIssueView", () => $e8099257b5d2aca0$export$164f2dfdd8dc056b);
$parcel$export(module.exports, "default", () => $e8099257b5d2aca0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $e8099257b5d2aca0$export$164f2dfdd8dc056b = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("c7Zmd")), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk/queues-issue-view/src/index.tsx"
});
var /**
 * Constructs a URL path for navigating to a specific issue view within a service desk queue, incorporating optional parameters for issue identification and view customization.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$e8099257b5d2aca0$export$2e2bcd8739ae039 = ({ match: match })=>{
    const issueKey = `/${match.params && match.params.issueKey || ''}`;
    const queueId = `/${match.params && match.params.queueId || ''}`;
    const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e8099257b5d2aca0$export$164f2dfdd8dc056b,
        pageId: `spa-apps/servicedesk/queues/issue${queueId}${issueKey}${oldIssueView}`,
        shouldShowSpinner: true
    });
};

});
parcelRegister("c7Zmd", function(module, exports) {

let $8d45bbc35f4d8b78$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $8d45bbc35f4d8b78$var$load("kNFvF"),
    $8d45bbc35f4d8b78$var$load("kVX56"),
    $8d45bbc35f4d8b78$var$load("76n7a"),
    $8d45bbc35f4d8b78$var$load("l253H"),
    $8d45bbc35f4d8b78$var$load("3EDTs")
]).then(()=>parcelRequire('6qBzG'));

});



parcelRegister("gfz2f", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeLandingRouteEntry", () => $8be1362ae286a3b1$export$881d545af6c177f1);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $gclwh = parcelRequire("gclwh");

var $6Z2mh = parcelRequire("6Z2mh");

var $erVva = parcelRequire("erVva");
const $8be1362ae286a3b1$export$881d545af6c177f1 = (0, $7NszV.createEntry)((0, $gclwh.servicedeskPracticeLandingRoute), ()=>({
        group: 'servicedesk',
        isRedirect: true,
        component: (0, $erVva.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $erVva.LazyServicedeskQueuesLanding)
        ]
    }));

});
parcelRegister("gclwh", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeLandingRoute", () => $3ecb8d0a4bfa59d9$export$3c859c71be33b36c);
const $3ecb8d0a4bfa59d9$export$3c859c71be33b36c = {
    name: 'servicedesk-practice-landing',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/(custom)?',
    exact: true
};

});

parcelRegister("erVva", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesLanding", () => $33ab495a6069d0db$export$bdf522692228bb6f);
$parcel$export(module.exports, "default", () => $33ab495a6069d0db$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $33ab495a6069d0db$export$bdf522692228bb6f = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("3Kiw4")), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-landing/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$33ab495a6069d0db$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $33ab495a6069d0db$export$bdf522692228bb6f,
        pageId: "spa-apps/servicedesk/queues/landing",
        shouldShowSpinner: true
    });

});
parcelRegister("3Kiw4", function(module, exports) {

let $2ba407ee76c83606$var$load = (parcelRequire("28QjX"))(4);

module.exports = Promise.all([
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $2ba407ee76c83606$var$load("czifk")
        ]);
    }, function() {
        return Promise.all([
            $2ba407ee76c83606$var$load("kcs34")
        ]);
    }),
    $2ba407ee76c83606$var$load("ffQaD"),
    $2ba407ee76c83606$var$load("kvRbA"),
    $2ba407ee76c83606$var$load("slTJc")
]).then(()=>parcelRequire('5ou2F'));

});



parcelRegister("gfW60", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeManageViewRouteEntry", () => $1a1c1c43e66f85e4$export$4e1b0df2a8fcae78);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $kxe3F = parcelRequire("kxe3F");

var $6Z2mh = parcelRequire("6Z2mh");

var $57W6j = parcelRequire("57W6j");
const $1a1c1c43e66f85e4$export$4e1b0df2a8fcae78 = (0, $7NszV.createEntry)((0, $kxe3F.servicedeskPracticeManageViewRoute), ()=>({
        group: 'servicedesk',
        component: (0, $57W6j.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: (0, $fpjJX.getQueuesResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $57W6j.LazyServicedeskQueuesManageView)
        ]
    }));

});
parcelRegister("kxe3F", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeManageViewRoute", () => $bf1a5a194b52ef2d$export$125e0ab662806584);
const $bf1a5a194b52ef2d$export$125e0ab662806584 = {
    name: 'servicedesk-practice-manage-view',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/queue-settings',
    exact: true
};

});

parcelRegister("57W6j", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesManageView", () => $ad9d634f0cdcf391$export$9f1e189198f08c4a);
$parcel$export(module.exports, "default", () => $ad9d634f0cdcf391$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $ad9d634f0cdcf391$export$9f1e189198f08c4a = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("kJOSZ"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-manage-view/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ad9d634f0cdcf391$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ad9d634f0cdcf391$export$9f1e189198f08c4a,
        pageId: "spa-apps/servicedesk/queues/manage",
        shouldShowSpinner: true
    });

});
parcelRegister("kJOSZ", function(module, exports) {

let $f18f7b82fe2d0e32$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f18f7b82fe2d0e32$var$load("dutL0").then(()=>parcelRequire('htw0K'));

});



parcelRegister("h51Kg", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeNewRouteEntry", () => $149e7521aa5247f3$export$50a04ec00cb8039);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $UrzEQ = parcelRequire("UrzEQ");

var $6Z2mh = parcelRequire("6Z2mh");

var $hw6fm = parcelRequire("hw6fm");
const $149e7521aa5247f3$export$50a04ec00cb8039 = (0, $7NszV.createEntry)((0, $UrzEQ.servicedeskPracticeNewRoute), ()=>({
        group: 'servicedesk',
        component: (0, $hw6fm.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hw6fm.LazyServicedeskQueuesCreateView)
        ]
    }));

});
parcelRegister("UrzEQ", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeNewRoute", () => $e5aa77a45094c512$export$8595a5452f93a1fd);
const $e5aa77a45094c512$export$8595a5452f93a1fd = {
    name: 'servicedesk-practice-new',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/new',
    query: [
        'parentId?'
    ],
    exact: true
};

});

parcelRegister("hw6fm", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesCreateView", () => $093d629913ef6b8e$export$c050b699bf9e3e40);
$parcel$export(module.exports, "default", () => $093d629913ef6b8e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $093d629913ef6b8e$export$c050b699bf9e3e40 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("aDpUA"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-create-view/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$093d629913ef6b8e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $093d629913ef6b8e$export$c050b699bf9e3e40,
        pageId: "spa-apps/servicedesk/queues/create",
        shouldShowSpinner: true
    });

});
parcelRegister("aDpUA", function(module, exports) {

let $7be1a568ddee856e$var$load = (parcelRequire("28QjX"))(4);

module.exports = Promise.all([
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $7be1a568ddee856e$var$load("czifk")
        ]);
    }, function() {
        return Promise.all([
            $7be1a568ddee856e$var$load("kcs34")
        ]);
    }),
    $7be1a568ddee856e$var$load("ffQaD"),
    $7be1a568ddee856e$var$load("kvRbA"),
    $7be1a568ddee856e$var$load("9QDg8")
]).then(()=>parcelRequire('aQuyJ'));

});



parcelRegister("fEAJ2", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeViewsConfigRouteEntry", () => $f8d8209f3e843316$export$101c882abd4d051);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $SqPVy = parcelRequire("SqPVy");

var $6Z2mh = parcelRequire("6Z2mh");

var $dxCvy = parcelRequire("dxCvy");

var $4R6GH = parcelRequire("4R6GH");

var $5lsNZ = parcelRequire("5lsNZ");

var $7XYc4 = parcelRequire("7XYc4");

var $iRITI = parcelRequire("iRITI");

var $e3Tce = parcelRequire("e3Tce");
const $f8d8209f3e843316$export$101c882abd4d051 = (0, $7NszV.createEntry)((0, $SqPVy.servicedeskPracticeViewsConfigRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            ...(0, $fpjJX.getQueueViewConfigResource)(),
            (0, $dxCvy.projectContextResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $e3Tce.LazyServicedeskQueuesViewsConfig)
        ],
        ufoName: 'service-management.views.config',
        component: (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $e3Tce.ServicedeskQueuesViewsConfig), (0, $5lsNZ.default)),
        pageId: ({ query: query, match: match })=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? `spa-apps/servicedesk/queues/views-config/${query.config}` : `spa-apps/servicedesk/queues/edit/${match.params && match.params.queueId || ''}`,
        entryPoint () {
            return (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $iRITI.serviceDeskQueuesConfigPageEntryPoint) : undefined;
        }
    }));

});
parcelRegister("SqPVy", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeViewsConfigRoute", () => $7e4dd55084659e58$export$e8e807e90d20fe7b);
const $7e4dd55084659e58$export$e8e807e90d20fe7b = {
    name: 'servicedesk-practice-views-config',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/edit/:boardId',
    query: [
        'config'
    ],
    exact: true
};

});

parcelRegister("e3Tce", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesViewsConfig", () => $6daef49d48ee6ffb$export$12b9e920fc614605);
$parcel$export(module.exports, "ServicedeskQueuesViewsConfig", () => $6daef49d48ee6ffb$export$666845896df029ad);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $6daef49d48ee6ffb$export$12b9e920fc614605 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("3MPbT")), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-config/src/index.tsx"
});
const $6daef49d48ee6ffb$export$666845896df029ad = (props)=>{
    const { query: query } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $6daef49d48ee6ffb$export$12b9e920fc614605,
        pageId: `spa-apps/servicedesk/queues/views-config/${query.config}`,
        shouldShowSpinner: true
    });
};

});


parcelRegister("1rMUU", function(module, exports) {

$parcel$export(module.exports, "servicedeskProformaIssueFormsDirectEmbedRouteEntry", () => $240624c6c03e7472$export$2792607788ca81db);

var $6e4Kt = parcelRequire("6e4Kt");

var $7NszV = parcelRequire("7NszV");

var $dxCvy = parcelRequire("dxCvy");

var $chOdK = parcelRequire("chOdK");

var $edJLT = parcelRequire("edJLT");
const $240624c6c03e7472$export$2792607788ca81db = (0, $7NszV.createEntry)((0, $chOdK.servicedeskProformaIssueFormsDirectEmbedRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            (0, $dxCvy.projectContextResource)
        ],
        component: (0, $edJLT.default),
        forPaint: [
            (0, $edJLT.LazyProformaIssueFormsDirectEmbed)
        ],
        perfMetricKey: 'issue-forms-direct-embed'
    }));

});
parcelRegister("chOdK", function(module, exports) {

$parcel$export(module.exports, "servicedeskProformaIssueFormsDirectEmbedRoute", () => $920134fe3a6eefea$export$bf24763c9fc04bde);
const $920134fe3a6eefea$export$bf24763c9fc04bde = {
    name: 'servicedesk-proforma-issue-forms-direct-embed',
    path: '/jira/servicedesk/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?/embed',
    exact: true
};

});


parcelRegister("36qRE", function(module, exports) {

$parcel$export(module.exports, "servicedeskProformaIssueFormsDirectRouteEntry", () => $6c7c317c40c5c36f$export$f249c6e19ad4181e);

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $dxCvy = parcelRequire("dxCvy");

var $lPvHo = parcelRequire("lPvHo");

var $6Z2mh = parcelRequire("6Z2mh");

var $6VQ64 = parcelRequire("6VQ64");
const $6c7c317c40c5c36f$export$f249c6e19ad4181e = (0, $7NszV.createEntry)((0, $lPvHo.servicedeskProformaIssueFormsDirectRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            (0, $dxCvy.projectContextResource)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        entryPoint: ()=>(0, $6VQ64.proformaIssueFormsDirectPageEntryPoint),
        perfMetricKey: 'issue-forms-direct'
    }));

});
parcelRegister("lPvHo", function(module, exports) {

$parcel$export(module.exports, "servicedeskProformaIssueFormsDirectRoute", () => $2c9a39a116b2202b$export$9b51b0994bb4b8f0);
const $2c9a39a116b2202b$export$9b51b0994bb4b8f0 = {
    name: 'servicedesk-proforma-issue-forms-direct',
    path: '/jira/servicedesk/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?',
    exact: true
};

});


parcelRegister("2QFEo", function(module, exports) {

$parcel$export(module.exports, "servicedeskProjectDashboardsEditableRouteEntry", () => $651a80faa0a84c4e$export$a74c7ae68710fdc7);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $51sGd = parcelRequire("51sGd");

var $6Z2mh = parcelRequire("6Z2mh");

var $3TQ0n = parcelRequire("3TQ0n");
const $651a80faa0a84c4e$export$a74c7ae68710fdc7 = (0, $7NszV.createEntry)((0, $51sGd.servicedeskProjectDashboardsEditableRoute), ()=>({
        group: 'servicedesk',
        component: (0, $3TQ0n.ProjectDashboardsEditable),
        perfMetricKey: 'service-management.project-dashboards.dashboard-list',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3TQ0n.LazyServicedeskProjectDashboardsEditable)
        ]
    }));

});
parcelRegister("51sGd", function(module, exports) {

$parcel$export(module.exports, "servicedeskProjectDashboardsEditableRoute", () => $4c3f3699e4765514$export$e1b9572169ced05e);
const $4c3f3699e4765514$export$e1b9572169ced05e = {
    name: 'servicedesk-avp-project-dashboards-editable',
    path: '/jira/servicedesk/projects/:projectKey/dashboards/:dashboardId'
};

});

parcelRegister("3TQ0n", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskProjectDashboardsEditable", () => $d02f8caddd39bb63$export$cab0bd21e2c67be7);
$parcel$export(module.exports, "ProjectDashboardsEditable", () => $d02f8caddd39bb63$export$65f0b3d2f1a55263);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $d02f8caddd39bb63$export$cab0bd21e2c67be7 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("8lpR1")).then((module)=>module.DashboardEditableSpaWrapper)), {
    moduleId: "./src/packages/spa-apps/servicedesk/project-dashboards/src/index.tsx"
});
const $d02f8caddd39bb63$export$65f0b3d2f1a55263 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d02f8caddd39bb63$export$cab0bd21e2c67be7,
        pageId: "spa-apps/servicedesk-project-dashboards-editable",
        shouldShowSpinner: true
    });

});
parcelRegister("8lpR1", function(module, exports) {

let $613456ff113daaa6$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $613456ff113daaa6$var$load("kNFvF"),
    $613456ff113daaa6$var$load("ffQaD"),
    $613456ff113daaa6$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("3IplF"), 4)),
    $613456ff113daaa6$var$load("fliVL"),
    $613456ff113daaa6$var$load("76n7a"),
    $613456ff113daaa6$var$load("l253H"),
    $613456ff113daaa6$var$load("2E73w")
]).then(()=>parcelRequire('7DwpA'));

});



parcelRegister("fQGIH", function(module, exports) {

$parcel$export(module.exports, "servicedeskProjectDashboardsListRouteEntry", () => $512bbe577042e05b$export$eaf3433859cfed23);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $k3FW1 = parcelRequire("k3FW1");

var $6Z2mh = parcelRequire("6Z2mh");

var $fnnP2 = parcelRequire("fnnP2");
const $512bbe577042e05b$export$eaf3433859cfed23 = (0, $7NszV.createEntry)((0, $k3FW1.servicedeskProjectDashboardsListRoute), ()=>({
        group: 'servicedesk',
        component: (0, $fnnP2.ProjectDashboardsList),
        perfMetricKey: 'service-management.project-dashboards.dashboard-list',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $fnnP2.LazyServicedeskProjectDashboardsList)
        ]
    }));

});
parcelRegister("k3FW1", function(module, exports) {

$parcel$export(module.exports, "servicedeskProjectDashboardsListRoute", () => $bf2da1572ff2c45e$export$ff671f43f5c6b309);
const $bf2da1572ff2c45e$export$ff671f43f5c6b309 = {
    name: 'servicedesk-avp-project-dashboards-list',
    path: '/jira/servicedesk/projects/:projectKey/dashboards'
};

});

parcelRegister("fnnP2", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskProjectDashboardsList", () => $e0169e5fe1e4431f$export$fea8ad531d3abdc3);
$parcel$export(module.exports, "ProjectDashboardsList", () => $e0169e5fe1e4431f$export$86ab4708fa0d87fa);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $e0169e5fe1e4431f$export$fea8ad531d3abdc3 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("8lpR1")).then((module)=>module.DashboardList)), {
    moduleId: "./src/packages/spa-apps/servicedesk/project-dashboards/src/index.tsx"
});
const $e0169e5fe1e4431f$export$86ab4708fa0d87fa = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e0169e5fe1e4431f$export$fea8ad531d3abdc3,
        pageId: "spa-apps/servicedesk-project-dashboards-list",
        shouldShowSpinner: true
    });

});


parcelRegister("c0JOH", function(module, exports) {

$parcel$export(module.exports, "servicedeskProjectSummaryRouteEntry", () => $2c8ef8f8c8b8bea4$export$a24d68fcf82b16bb);

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $5wuQF = parcelRequire("5wuQF");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $5xviT = parcelRequire("5xviT");

var $dWyPA = parcelRequire("dWyPA");

var $iZ8qR = parcelRequire("iZ8qR");
const $2c8ef8f8c8b8bea4$export$a24d68fcf82b16bb = (0, $7NszV.createEntry)((0, $5wuQF.servicedeskProjectSummaryRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'jsm.project-summary',
        component: (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jsm-project-summary'), ()=>null, (0, $5lsNZ.default)),
        skeleton: (0, $5xviT.ProjectSummarySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $dWyPA.getProjectSummaryFilterFieldsResource)()
        ],
        entryPoint: ()=>(0, $4R6GH.fg)('jsm-project-summary') ? (0, $iZ8qR.projectSummaryPageEntryPoint) : undefined,
        meta: {
            reporting: {
                id: 'project-summary',
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).PROJECT_SUMMARY),
                teamName: 'jsd-shield'
            }
        }
    }));

});
parcelRegister("5wuQF", function(module, exports) {

$parcel$export(module.exports, "servicedeskProjectSummaryRoute", () => $4ba559112e9c0332$export$a23b752ff24027ae);
const $4ba559112e9c0332$export$a23b752ff24027ae = {
    path: '/jira/servicedesk/projects/:projectKey/summary',
    name: 'servicedesk-project-summary'
};

});

parcelRegister("5xviT", function(module, exports) {

$parcel$export(module.exports, "ProjectSummarySkeleton", () => $d1cb7759e14ba32c$export$93a223cf4712c63d);

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $atIlz = parcelRequire("atIlz");
const $d1cb7759e14ba32c$export$93a223cf4712c63d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($atIlz)))
    });

});
parcelRegister("atIlz", function(module, exports) {
module.exports = new URL("project-summary-skeleton.tpl.f2232e71.svg", import.meta.url).toString();

});


parcelRegister("dWyPA", function(module, exports) {

$parcel$export(module.exports, "getProjectSummaryFilterFieldsResource", () => $742db2d29900c944$export$efafab65f8d3c3b6);
$parcel$export(module.exports, "useGetProjectSummaryFilterFields", () => $742db2d29900c944$export$e6baafb2e3d74187);
$parcel$export(module.exports, "useRequestTypeJqlTerm", () => $742db2d29900c944$export$1bb1552d41afd41f);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $fZneA = parcelRequire("fZneA");

var $eusud = parcelRequire("eusud");

var $4R6GH = parcelRequire("4R6GH");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


const $742db2d29900c944$var$RESOURCE_NAME = 'projectSummaryFilterFieldResource';
const $742db2d29900c944$export$6f0555de4f60e84e = 'RESOURCE_TYPE_JSM_PROJECT_SUMMARY_FILTERS';
const $742db2d29900c944$var$REQUEST_TYPE_FILTER_TYPE = 'com.atlassian.servicedesk:vp-origin';
const $742db2d29900c944$var$REQUEST_TYPE_FILTER_SEARCH_TEMPLATE = 'com.atlassian.servicedesk:vp-origin-searcher';
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $742db2d29900c944$var$createdField = {
    displayName: 'Created',
    fieldType: 'created',
    jqlTerm: 'created',
    operators: [
        'LESS_THAN_OR_EQUAL',
        'GREATER_THAN_OR_EQUAL',
        'NOT_IN',
        'IS_NOT',
        'LESS_THAN',
        'GREATER_THAN',
        'EQUALS',
        'IS',
        'IN',
        'NOT_EQUALS'
    ],
    searchTemplate: 'created',
    type: 'created'
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $742db2d29900c944$var$priorityField = {
    displayName: 'Priority',
    fieldType: 'priority',
    jqlTerm: 'priority',
    operators: [
        'GREATER_THAN_OR_EQUAL',
        'LESS_THAN',
        'GREATER_THAN',
        'WAS_NOT',
        'IS',
        'IN',
        'CHANGED',
        'LESS_THAN_OR_EQUAL',
        'NOT_IN',
        'IS_NOT',
        'WAS_NOT_IN',
        'EQUALS',
        'WAS_IN',
        'WAS',
        'NOT_EQUALS'
    ],
    searchTemplate: 'priority',
    type: 'priority'
};
const $742db2d29900c944$var$reportError = ({ error: error, id: id })=>(0, $jcw0u.default)({
        error: error,
        sendToPrivacyUnsafeSplunk: true,
        meta: {
            id: id ? `${$742db2d29900c944$var$RESOURCE_NAME}.${id}` : $742db2d29900c944$var$RESOURCE_NAME,
            packageName: (0, $1067b0e29a05cd94$export$b8b9d90f9e5bd72b),
            teamName: (0, $1067b0e29a05cd94$export$d57b6b390e78d90f)
        }
    });
const $742db2d29900c944$var$fetchFilterFieldsOld = async (cloudId, jqlContext)=>{
    try {
        const response = await (0, $eusud.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $9f7e041fbe104d81$export$546e90157aa718d4),
                variables: {
                    cloudId: cloudId,
                    contextFieldsFilter: (0, $4R6GH.fg)('corecap_3780_fix_rt_fetching_issue') ? {
                        jqlTerms: [
                            (0, $1067b0e29a05cd94$export$2c388650eabddf5e),
                            (0, $1067b0e29a05cd94$export$2fcf90614ee15858),
                            (0, $1067b0e29a05cd94$export$43482ff574598f59)
                        ]
                    } : {
                        searchString: 'request type'
                    },
                    jqlContext: jqlContext
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'JiraJqlBuilder'
            }
        });
        const tryGetField = ({ data: data, type: type, searchTemplate: searchTemplate, displayName: displayName })=>{
            const edges = data?.jira?.jqlBuilder?.fields?.edges;
            const field = edges?.find((edge)=>edge?.node?.type === type && edge?.node?.searchTemplate?.key === searchTemplate)?.node;
            return field ? {
                ...field,
                searchTemplate: field.searchTemplate.key,
                fieldType: field.type,
                displayName: displayName ?? field.displayName
            } : undefined;
        };
        return {
            requestTypeField: tryGetField({
                data: response.data,
                type: $742db2d29900c944$var$REQUEST_TYPE_FILTER_TYPE,
                searchTemplate: $742db2d29900c944$var$REQUEST_TYPE_FILTER_SEARCH_TEMPLATE
            })
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!(0, $fZneA.isHttpClientErrorResponse)(error)) $742db2d29900c944$var$reportError({
            error: error,
            id: 'fetchFields'
        });
        return {
            requestTypeField: undefined
        };
    }
};
const $742db2d29900c944$var$fetchFilterFields = async (cloudId)=>{
    try {
        const requestTypeFieldResponse = await (0, $eusud.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $9f7e041fbe104d81$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        const requestTypeField = requestTypeFieldResponse.data?.jira?.requestTypeField;
        if (!requestTypeField) return {
            requestTypeField: undefined
        };
        return {
            requestTypeField: {
                ...requestTypeField,
                searchTemplate: requestTypeField.searchTemplate?.key,
                fieldType: requestTypeField.type,
                displayName: requestTypeField.displayName
            }
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!(0, $fZneA.isHttpClientErrorResponse)(error)) $742db2d29900c944$var$reportError({
            error: error,
            id: 'fetchFields'
        });
        return {
            requestTypeField: undefined
        };
    }
};
const $742db2d29900c944$var$getProjectKeyOrId = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $742db2d29900c944$var$filterFieldsResource = (0, $2M1hQ.createResource)({
    type: $742db2d29900c944$export$6f0555de4f60e84e,
    getKey: ({ match: match, query: query })=>$742db2d29900c944$export$6f0555de4f60e84e + $742db2d29900c944$var$getProjectKeyOrId(match, query),
    getData: ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
        const jqlContext = `project = '${$742db2d29900c944$var$getProjectKeyOrId(match, query)}'`;
        return (0, $4R6GH.fg)('move_jsm_views_rt_filter_to_new_query') ? $742db2d29900c944$var$fetchFilterFields(cloudId) : $742db2d29900c944$var$fetchFilterFieldsOld(cloudId, jqlContext);
    },
    maxAge: Infinity
});
const $742db2d29900c944$export$efafab65f8d3c3b6 = ()=>$742db2d29900c944$var$filterFieldsResource;
const $742db2d29900c944$export$e6baafb2e3d74187 = ()=>{
    const { data: filterResource } = (0, $2YP9W.useResource)($742db2d29900c944$var$filterFieldsResource);
    const useFilterFields = (0, $5uXOq.useMemo)(()=>({ requestTypeField: requestTypeField = filterResource?.requestTypeField, requestTypeDisplayName: requestTypeDisplayName, priorityDisplayName: priorityDisplayName, createdDisplayName: createdDisplayName })=>{
            return [
                ...requestTypeField ? [
                    {
                        ...requestTypeField,
                        ...requestTypeDisplayName && {
                            displayName: requestTypeDisplayName
                        }
                    }
                ] : [],
                'status',
                'assignee',
                {
                    ...$742db2d29900c944$var$priorityField,
                    ...priorityDisplayName && {
                        displayName: priorityDisplayName
                    }
                },
                {
                    ...$742db2d29900c944$var$createdField,
                    ...createdDisplayName && {
                        displayName: createdDisplayName
                    }
                }
            ];
        }, [
        filterResource
    ]);
    return useFilterFields;
};
const $742db2d29900c944$export$1bb1552d41afd41f = ({ jqlTerm: jqlTerm })=>{
    const { data: filterResource, loading: loading } = (0, $2YP9W.useResource)($742db2d29900c944$var$filterFieldsResource);
    const term = jqlTerm ?? filterResource?.requestTypeField?.jqlTerm;
    const hasError = !loading && !term;
    (0, $5uXOq.useEffect)(()=>{
        if (hasError) $742db2d29900c944$var$reportError({
            error: new Error('Error while getting request type jql term.'),
            id: 'rtJqlTerm'
        });
    }, [
        hasError
    ]);
    return term;
};

});
const $1067b0e29a05cd94$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesServicedeskProjectSummary';
const $1067b0e29a05cd94$export$d57b6b390e78d90f = 'jsd-shield';
const $1067b0e29a05cd94$export$2c388650eabddf5e = 'request type';
const $1067b0e29a05cd94$export$2fcf90614ee15858 = 'service desk origin';
const $1067b0e29a05cd94$export$43482ff574598f59 = 'cf[10010]';

const $9f7e041fbe104d81$export$546e90157aa718d4 = `
query findFieldQuery($cloudId: ID!, $contextFieldsFilter: JiraJQLContextFieldsFilter!, $jqlContext: String!) {
  jira {
    jqlBuilder(cloudId: $cloudId) {
        fields(jqlContextFieldsFilter: $contextFieldsFilter, jqlContext: $jqlContext) {
          ... on JiraJqlFieldConnection {
            __typename
            edges {
              node {
                jqlTerm
                displayName
                type
                searchTemplate {
                  key
                }
                operators
              }
            }
          }
          ... on QueryError {
            __typename
          }
        }
      }
  }
}
`;
const $9f7e041fbe104d81$export$2b91517d6d5b4365 = `
query requestTypeFieldQuery($cloudId: ID!) {
  jira {
    requestTypeField(cloudId: $cloudId) {
      displayName
      jqlTerm
      operators
      searchTemplate {
        key
      }
      type
    }
  }
}
`;


parcelRegister("iZ8qR", function(module, exports) {

$parcel$export(module.exports, "projectSummaryPageEntryPoint", () => $cfa42f0318b6392e$export$ae7c241893e7dab9);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $fmaTw = parcelRequire("fmaTw");
const $cfa42f0318b6392e$export$ae7c241893e7dab9 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $fmaTw.projectSummaryEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("fmaTw", function(module, exports) {

$parcel$export(module.exports, "projectSummaryEntryPoint", () => $15ffffad92965566$export$95a2fe4e495efca5);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $15ffffad92965566$export$95a2fe4e495efca5 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("dpbCV")), {
        moduleId: "ac794fd1",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("dpbCV", function(module, exports) {

let $9c26a0fd0a316f52$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9c26a0fd0a316f52$var$load("ffQaD"),
    $9c26a0fd0a316f52$var$load("kvRbA"),
    $9c26a0fd0a316f52$var$load("lBgV9")
]).then(()=>parcelRequire('i6ZtS'));

});




parcelRegister("rsO8k", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesAddonRouteEntry", () => $59596f7c053ae5d7$export$23a16f20b48235b3);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $95l0v = parcelRequire("95l0v");

var $6Z2mh = parcelRequire("6Z2mh");

var $laAgE = parcelRequire("laAgE");
const $59596f7c053ae5d7$export$23a16f20b48235b3 = (0, $7NszV.createEntry)((0, $95l0v.servicedeskQueuesAddonRoute), ()=>({
        group: 'servicedesk',
        component: (0, $laAgE.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $laAgE.LazyServicedeskQueuesAddonView)
        ]
    }));

});
parcelRegister("95l0v", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesAddonRoute", () => $4884cbac3a1d9cc0$export$1465f05b88a63f13);
const $4884cbac3a1d9cc0$export$1465f05b88a63f13 = {
    name: 'servicedesk-queues-addon',
    path: '/jira/servicedesk/projects/:projectKey/queues/addon/:addonKey',
    exact: true
};

});

parcelRegister("laAgE", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesAddonView", () => $6cc059f7849819d9$export$451a7cce84b6b1e6);
$parcel$export(module.exports, "default", () => $6cc059f7849819d9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $6cc059f7849819d9$export$451a7cce84b6b1e6 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("2N6MT")), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-addon-view/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6cc059f7849819d9$export$2e2bcd8739ae039 = ({ match: match })=>{
    const addonKey = match.params && match.params.addonKey || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $6cc059f7849819d9$export$451a7cce84b6b1e6,
        pageId: `spa-apps/servicedesk/queues/addon/${addonKey}`,
        shouldShowSpinner: true
    });
};

});
parcelRegister("2N6MT", function(module, exports) {

let $20856c461c6807b2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $20856c461c6807b2$var$load("cQS1H").then(()=>parcelRequire('jFMLI'));

});



parcelRegister("5JkxV", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesEditRouteEntry", () => $ce3daf0233f73856$export$ae7b71ac953d95bf);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $7n6p5 = parcelRequire("7n6p5");

var $6Z2mh = parcelRequire("6Z2mh");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $4kils = parcelRequire("4kils");

var $a3285 = parcelRequire("a3285");

var $iRITI = parcelRequire("iRITI");
const $ce3daf0233f73856$export$ae7b71ac953d95bf = (0, $7NszV.createEntry)((0, $7n6p5.servicedeskQueuesEditRoute), ()=>({
        group: 'servicedesk',
        component: (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $a3285.ServicedeskQueuesConfig), (0, $4kils.default)),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $fpjJX.getIssueListSsrResource)(),
            ...(0, $fpjJX.getQueueConfigResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $a3285.LazyServicedeskQueuesConfig) : (0, $4kils.LazyServicedeskQueuesEditView)
        ],
        ufoName: 'service-management.queues.edit',
        pageId: ({ query: query, match: match })=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? `spa-apps/servicedesk/queues/views-config/${query.config}` : `spa-apps/servicedesk/queues/edit/${match.params && match.params.queueId || ''}`,
        entryPoint () {
            return (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $iRITI.serviceDeskQueuesConfigPageEntryPoint) : undefined;
        }
    }));

});
parcelRegister("7n6p5", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesEditRoute", () => $f9047204629cbf40$export$f8fd3a1f8c33aff8);
const $f9047204629cbf40$export$f8fd3a1f8c33aff8 = {
    name: 'servicedesk-queues-edit',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/edit',
    exact: true,
    query: [
        'config?'
    ]
};

});


parcelRegister("jIBei", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesIssueRouteEntry", () => $af2173f32f306a68$export$2e4931acac9270fc);

var $ffza4 = parcelRequire("ffza4");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $jlOGG = parcelRequire("jlOGG");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $3lD6Q = parcelRequire("3lD6Q");

var $6Z2mh = parcelRequire("6Z2mh");

var $lAGdd = parcelRequire("lAGdd");

var $i1TcK = parcelRequire("i1TcK");
const $af2173f32f306a68$export$2e4931acac9270fc = (0, $7NszV.createEntry)((0, $3lD6Q.servicedeskQueuesIssueRoute), ()=>({
        group: 'servicedesk',
        component: (0, $i1TcK.default),
        layout: (0, $aPfsS.composeLayouts)((0, $6Z2mh.serviceProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                params: [
                    {
                        key: 'issueKey'
                    }
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            ...(0, $fpjJX.getKnowledgeBaseResources)(),
            ...(0, $fpjJX.getInsightResources)(),
            (0, $jlOGG.newIssueViewLockInStatusResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $lAGdd.getAIContextPanelResources)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $i1TcK.LazyServicedeskQueuesIssueView)
        ]
    }));

});
parcelRegister("3lD6Q", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesIssueRoute", () => $e8668889c15b3639$export$52a24b9cf42d208b);
const $e8668889c15b3639$export$52a24b9cf42d208b = {
    name: 'servicedesk-queues-issue',
    path: '/jira/servicedesk/projects/:projectKey/queues/issue/:issueKey',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});


parcelRegister("3oSi6", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesLandingRouteEntry", () => $725a0b4233bb029f$export$4242a81237c45c7d);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $jlOGG = parcelRequire("jlOGG");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $50cHa = parcelRequire("50cHa");

var $6Z2mh = parcelRequire("6Z2mh");

var $erVva = parcelRequire("erVva");
const $725a0b4233bb029f$export$4242a81237c45c7d = (0, $7NszV.createEntry)((0, $50cHa.servicedeskQueuesLandingRoute), ()=>({
        group: 'servicedesk',
        isRedirect: true,
        component: (0, $erVva.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            (0, $jlOGG.newIssueViewLockInStatusResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $erVva.LazyServicedeskQueuesLanding)
        ]
    }));

});
parcelRegister("50cHa", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesLandingRoute", () => $c48a2414491b1ed8$export$52b4c044e4929ebc);
const $c48a2414491b1ed8$export$52b4c044e4929ebc = {
    name: 'servicedesk-queues-landing',
    // Supporting optional /default for legacy backwards compatability
    path: '/jira/servicedesk/projects/:projectKey/queues/(default|custom)?',
    exact: true
};

});


parcelRegister("96BnX", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesManageViewRouteEntry", () => $4edb93f2b23424ca$export$7e9e2984a94a07b0);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $68aAJ = parcelRequire("68aAJ");

var $6Z2mh = parcelRequire("6Z2mh");

var $57W6j = parcelRequire("57W6j");
const $4edb93f2b23424ca$export$7e9e2984a94a07b0 = (0, $7NszV.createEntry)((0, $68aAJ.servicedeskQueuesManageViewRoute), ()=>({
        group: 'servicedesk',
        component: (0, $57W6j.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: (0, $fpjJX.getQueuesResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $57W6j.LazyServicedeskQueuesManageView)
        ]
    }));

});
parcelRegister("68aAJ", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesManageViewRoute", () => $d770d83963ac1c36$export$7f30d40b906894c5);
const $d770d83963ac1c36$export$7f30d40b906894c5 = {
    name: 'servicedesk-queues-manage-view',
    path: '/jira/servicedesk/projects/:projectKey/queues/queue-settings',
    exact: true
};

});


parcelRegister("fP1EY", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesNewRouteEntry", () => $43b55289272bfd02$export$9f7cc3294b3141b1);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6x8s4 = parcelRequire("6x8s4");

var $6Z2mh = parcelRequire("6Z2mh");

var $hw6fm = parcelRequire("hw6fm");
const $43b55289272bfd02$export$9f7cc3294b3141b1 = (0, $7NszV.createEntry)((0, $6x8s4.servicedeskQueuesNewRoute), ()=>({
        group: 'servicedesk',
        component: (0, $hw6fm.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hw6fm.LazyServicedeskQueuesCreateView)
        ],
        ufoName: 'service-management.queues.new'
    }));

});
parcelRegister("6x8s4", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesNewRoute", () => $52cd0fc2ec934503$export$c1908994722d1e73);
const $52cd0fc2ec934503$export$c1908994722d1e73 = {
    name: 'servicedesk-queues-new',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/new',
    query: [
        'parentId?'
    ],
    exact: true
};

});


parcelRegister("2yO8h", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesViewsConfigRouteEntry", () => $3766b33f9d299552$export$a5000d326f347afb);

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $bfOrv = parcelRequire("bfOrv");

var $6Z2mh = parcelRequire("6Z2mh");

var $dxCvy = parcelRequire("dxCvy");

var $4R6GH = parcelRequire("4R6GH");

var $5lsNZ = parcelRequire("5lsNZ");

var $ffza4 = parcelRequire("ffza4");

var $7XYc4 = parcelRequire("7XYc4");

var $lJ1FP = parcelRequire("lJ1FP");

var $iRITI = parcelRequire("iRITI");

var $e3Tce = parcelRequire("e3Tce");
const $3766b33f9d299552$export$a5000d326f347afb = (0, $7NszV.createEntry)((0, $bfOrv.servicedeskQueuesViewsConfigRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            ...(0, $fpjJX.getQueueViewConfigResource)(),
            (0, $lJ1FP.getEditModelResource)(),
            (0, $dxCvy.projectContextResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $e3Tce.LazyServicedeskQueuesViewsConfig)
        ],
        ufoName: 'service-management.views.config',
        component: (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $e3Tce.ServicedeskQueuesViewsConfig), (0, $5lsNZ.default)),
        pageId: ({ query: query, match: match })=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? `spa-apps/servicedesk/queues/views-config/${query.config}` : `spa-apps/servicedesk/queues/edit/${match.params && match.params.queueId || ''}`,
        entryPoint () {
            return (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $iRITI.serviceDeskQueuesConfigPageEntryPoint) : undefined;
        }
    }));

});
parcelRegister("bfOrv", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesViewsConfigRoute", () => $a336f3ec9a74ea1c$export$eea17b09d67a7980);
const $a336f3ec9a74ea1c$export$eea17b09d67a7980 = {
    name: 'servicedesk-queues-views-config',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/edit/:boardId',
    query: [
        'config?'
    ],
    exact: true
};

});


parcelRegister("c97hk", function(module, exports) {

$parcel$export(module.exports, "servicedeskReports1RouteEntry", () => $28c558427771b7f4$export$8055c8b2162cf5bd);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $7XYc4 = parcelRequire("7XYc4");

var $lmyls = parcelRequire("lmyls");

var $3HwlS = parcelRequire("3HwlS");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $cJTRV = parcelRequire("cJTRV");

var $6Z2mh = parcelRequire("6Z2mh");

var $7tQej = parcelRequire("7tQej");


var $IT9I6 = parcelRequire("IT9I6");

var $4QhHa = parcelRequire("4QhHa");
const $28c558427771b7f4$var$DefaultReportsRedirect = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/jira/servicedesk/projects/${String(match.params.projectKey)}${(0, $d37b1fd9e7afc201$export$ddc580d759168f88)}`
    });
const $28c558427771b7f4$export$8055c8b2162cf5bd = (0, $7NszV.createEntry)((0, $cJTRV.servicedeskReports1Route), ()=>({
        group: 'servicedesk',
        component: (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), (0, $4QhHa.default), $28c558427771b7f4$var$DefaultReportsRedirect),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $IT9I6.getReportsWithKbResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4QhHa.LazyServicedeskReportsHomePage)
        ]
    }));

});
parcelRegister("cJTRV", function(module, exports) {

$parcel$export(module.exports, "servicedeskReports1Route", () => $ddba74d9a05765e5$export$f5adfd681a4e85ad);
const $ddba74d9a05765e5$export$f5adfd681a4e85ad = {
    name: 'servicedesk-reports',
    path: '/jira/servicedesk/projects/:projectKey/reports',
    exact: true
};

});

const $d37b1fd9e7afc201$export$e4c007d05145b8c2 = '/reports/all-rating';
const $d37b1fd9e7afc201$export$ddc580d759168f88 = '/reports/workload';
const $d37b1fd9e7afc201$export$13bdc187fca9c33e = '/reports';

parcelRegister("IT9I6", function(module, exports) {

$parcel$export(module.exports, "getReportsWithKbResources", () => $fbd9e6ca0682c0bc$export$1a63e9cdf8268e40);

var $bjZiV = parcelRequire("bjZiV");

var $fpjJX = parcelRequire("fpjJX");
const $fbd9e6ca0682c0bc$export$1a63e9cdf8268e40 = ()=>[
        ...(0, $fpjJX.getServicedeskPageContextResources)(),
        (0, $bjZiV.kbConfluenceContextResource)
    ];

});

parcelRegister("4QhHa", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskReportsHomePage", () => $2636e09e0764ad56$export$121b9cfb2b001a53);
$parcel$export(module.exports, "default", () => $2636e09e0764ad56$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");


const $2636e09e0764ad56$export$121b9cfb2b001a53 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("iPowq"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-home-page/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2636e09e0764ad56$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2636e09e0764ad56$export$121b9cfb2b001a53,
        pageId: `spa-apps/servicedesk${(0, $d37b1fd9e7afc201$export$13bdc187fca9c33e)}}`,
        shouldShowSpinner: true
    });

});
parcelRegister("iPowq", function(module, exports) {

let $db5002f63be16b11$var$load = (parcelRequire("28QjX"))(4);
module.exports = $db5002f63be16b11$var$load("lP9Ot").then(()=>parcelRequire('i1BaA'));

});



parcelRegister("7sSEm", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustom4RouteEntry", () => $bc9f120c03f314db$export$5ef62fad7280cd08);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $2cp29 = parcelRequire("2cp29");

var $6Z2mh = parcelRequire("6Z2mh");

var $3FrpL = parcelRequire("3FrpL");
const $bc9f120c03f314db$export$5ef62fad7280cd08 = (0, $7NszV.createEntry)((0, $2cp29.servicedeskReportsCustom4Route), ()=>({
        group: 'servicedesk',
        component: (0, $3FrpL.default),
        perfMetricKey: 'service-management.reports.custom',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3FrpL.LazyServicedeskReportsCustom)
        ],
        ufoName: 'service-management-custom-reports'
    }));

});
parcelRegister("2cp29", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustom4Route", () => $47b22144a185fe3a$export$39325072940fb58c);
const $47b22144a185fe3a$export$39325072940fb58c = {
    name: 'servicedesk-reports-custom',
    path: '/jira/servicedesk/projects/:projectKey/reports/custom/:reportId'
};

});

parcelRegister("3FrpL", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskReportsCustom", () => $940ea7d208fcfce4$export$3ec5c3d7729889b9);
$parcel$export(module.exports, "default", () => $940ea7d208fcfce4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $940ea7d208fcfce4$export$3ec5c3d7729889b9 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("dIOmK"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-custom/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$940ea7d208fcfce4$export$2e2bcd8739ae039 = ({ match: match })=>{
    const reportType = match.params.reportType || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $940ea7d208fcfce4$export$3ec5c3d7729889b9,
        pageId: `spa-apps/servicedesk/reports/${reportType}`,
        shouldShowSpinner: true
    });
};

});
parcelRegister("dIOmK", function(module, exports) {

let $9fd6740cb20cd1f5$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9fd6740cb20cd1f5$var$load("ffQaD"),
    $9fd6740cb20cd1f5$var$load("kvRbA"),
    $9fd6740cb20cd1f5$var$load("hLTt5")
]).then(()=>parcelRequire('gIY6j'));

});



parcelRegister("eaXgt", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustomCreateRouteEntry", () => $2cf0babd3b9237c1$export$b806d1abc9172b6d);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $17wjD = parcelRequire("17wjD");

var $6Z2mh = parcelRequire("6Z2mh");

var $3I9YI = parcelRequire("3I9YI");
const $2cf0babd3b9237c1$export$b806d1abc9172b6d = (0, $7NszV.createEntry)((0, $17wjD.servicedeskReportsCustomCreateRoute), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.reports.custom-create',
        component: (0, $3I9YI.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3I9YI.LazyServicedeskReportsCustomCreate)
        ]
    }));

});
parcelRegister("17wjD", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustomCreateRoute", () => $c5c6b7b61be9d580$export$333e623d5eb41af0);
const $c5c6b7b61be9d580$export$333e623d5eb41af0 = {
    name: 'servicedesk-reports-custom-create',
    path: '/jira/servicedesk/projects/:projectKey/reports/custom/new'
};

});

parcelRegister("3I9YI", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskReportsCustomCreate", () => $0aaa6fdfa8d01159$export$821b8201b24f8b7d);
$parcel$export(module.exports, "default", () => $0aaa6fdfa8d01159$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $0aaa6fdfa8d01159$export$821b8201b24f8b7d = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("3oiDL"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-custom-create/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0aaa6fdfa8d01159$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $0aaa6fdfa8d01159$export$821b8201b24f8b7d,
        pageId: "spa-apps/servicedesk/reports/custom/create",
        shouldShowSpinner: true
    });

});
parcelRegister("3oiDL", function(module, exports) {

let $278212941c954458$var$load = (parcelRequire("28QjX"))(4);
module.exports = $278212941c954458$var$load("jIVQO").then(()=>parcelRequire('bYkUJ'));

});



parcelRegister("moUwl", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustomEditRouteEntry", () => $79d751c5c6540b74$export$c4c3dcf824e7036e);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $b3EQX = parcelRequire("b3EQX");

var $6Z2mh = parcelRequire("6Z2mh");

var $gnyZS = parcelRequire("gnyZS");
const $79d751c5c6540b74$export$c4c3dcf824e7036e = (0, $7NszV.createEntry)((0, $b3EQX.servicedeskReportsCustomEditRoute), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.reports.custom-edit-view',
        component: (0, $gnyZS.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gnyZS.LazyServicedeskReportsCustomEdit)
        ]
    }));

});
parcelRegister("b3EQX", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustomEditRoute", () => $175ba21e4ba52ddb$export$3b6b3105a9ef9b83);
const $175ba21e4ba52ddb$export$3b6b3105a9ef9b83 = {
    name: 'servicedesk-reports-custom-edit',
    path: '/jira/servicedesk/projects/:projectKey/reports/custom/:reportId/edit'
};

});

parcelRegister("gnyZS", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskReportsCustomEdit", () => $db3dd114755c3f65$export$53def03ace9a6c5b);
$parcel$export(module.exports, "default", () => $db3dd114755c3f65$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $db3dd114755c3f65$export$53def03ace9a6c5b = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("1oIgh"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-custom-edit/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$db3dd114755c3f65$export$2e2bcd8739ae039 = ({ match: match })=>{
    const { reportId: reportId } = match.params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $db3dd114755c3f65$export$53def03ace9a6c5b,
        pageId: `spa-apps/servicedesk/reports/custom/${reportId || ''}`,
        shouldShowSpinner: true
    });
};

});
parcelRegister("1oIgh", function(module, exports) {

let $104a5dc6eb4d6b0b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $104a5dc6eb4d6b0b$var$load("4ynxu").then(()=>parcelRequire('cOaoL'));

});



parcelRegister("7D3Yv", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustomIssueRouteEntry", () => $db3c4c23d5eb6125$export$222c6398b69dbc6d);

var $ffza4 = parcelRequire("ffza4");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $jlOGG = parcelRequire("jlOGG");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $7QuMl = parcelRequire("7QuMl");

var $6Z2mh = parcelRequire("6Z2mh");

var $lAGdd = parcelRequire("lAGdd");

var $1hJVy = parcelRequire("1hJVy");
const $db3c4c23d5eb6125$export$222c6398b69dbc6d = (0, $7NszV.createEntry)((0, $7QuMl.servicedeskReportsCustomIssueRoute), ()=>({
        group: 'servicedesk',
        component: (0, $1hJVy.default),
        layout: (0, $aPfsS.composeLayouts)((0, $6Z2mh.serviceProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)()),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $jlOGG.newIssueViewLockInStatusResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $lAGdd.getAIContextPanelResources)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $1hJVy.LazyServicedeskReportsIssueView)
        ],
        ufoName: 'service-management.reports.issue'
    }));

});
parcelRegister("7QuMl", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustomIssueRoute", () => $3e79cb7a6fb28a4d$export$1cfe539c854438e8);
const $3e79cb7a6fb28a4d$export$1cfe539c854438e8 = {
    name: 'servicedesk-reports-custom-time-scale-issue',
    path: '/jira/servicedesk/projects/:projectKey/reports/custom/:reportId/timescale/:timescaleId/:issueKey',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});


parcelRegister("dgneZ", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustomTimeScaleRouteEntry", () => $422e88992a614b49$export$508d5e1a59322a54);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $jBB4F = parcelRequire("jBB4F");

var $6Z2mh = parcelRequire("6Z2mh");

var $3FrpL = parcelRequire("3FrpL");
const $422e88992a614b49$export$508d5e1a59322a54 = (0, $7NszV.createEntry)((0, $jBB4F.servicedeskReportsCustomTimeScaleRoute), ()=>({
        group: 'servicedesk',
        component: (0, $3FrpL.default),
        perfMetricKey: 'service-management.reports.custom',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3FrpL.LazyServicedeskReportsCustom)
        ],
        ufoName: 'service-management-custom-reports'
    }));

});
parcelRegister("jBB4F", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustomTimeScaleRoute", () => $3a492ac932fcb1b3$export$eae9a65fe3f035ef);
const $3a492ac932fcb1b3$export$eae9a65fe3f035ef = {
    name: 'servicedesk-reports-custom-time-scale',
    path: '/jira/servicedesk/projects/:projectKey/reports/custom/:reportId/timescale/:timescaleId'
};

});


parcelRegister("hRN7l", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsSatisfaction2RouteEntry", () => $eebc12aca0cec40e$export$d6fb66bfd4a40ef);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $bsSH9 = parcelRequire("bsSH9");

var $6Z2mh = parcelRequire("6Z2mh");

var $8Xwpi = parcelRequire("8Xwpi");
const $eebc12aca0cec40e$export$d6fb66bfd4a40ef = (0, $7NszV.createEntry)((0, $bsSH9.servicedeskReportsSatisfaction2Route), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.reports.satisfaction',
        component: (0, $8Xwpi.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8Xwpi.LazyServicedeskReportsSatisfaction)
        ]
    }));

});
parcelRegister("bsSH9", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsSatisfaction2Route", () => $15dedc31928a1123$export$22fd25b495033fdf);
const $15dedc31928a1123$export$22fd25b495033fdf = {
    name: 'servicedesk-reports-satisfaction',
    path: '/jira/servicedesk/projects/:projectKey/reports/all-rating'
};

});

parcelRegister("8Xwpi", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskReportsSatisfaction", () => $66f1c14673116eb8$export$8edc7b9d922cd22f);
$parcel$export(module.exports, "default", () => $66f1c14673116eb8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");


const $66f1c14673116eb8$export$8edc7b9d922cd22f = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("kCuJl"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-satisfaction/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$66f1c14673116eb8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $66f1c14673116eb8$export$8edc7b9d922cd22f,
        pageId: `spa-apps/servicedesk${(0, $d37b1fd9e7afc201$export$e4c007d05145b8c2)}}`,
        shouldShowSpinner: true
    });

});
parcelRegister("kCuJl", function(module, exports) {

let $f02f31a67700b899$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f02f31a67700b899$var$load("ffQaD"),
    $f02f31a67700b899$var$load("kvRbA"),
    $f02f31a67700b899$var$load("1lERf")
]).then(()=>parcelRequire('hLsyG'));

});



parcelRegister("cU5zd", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsSatisfactionIssueRouteEntry", () => $28e15c46fa77f0cb$export$6b98300c0f2ab048);

var $ffza4 = parcelRequire("ffza4");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $jlOGG = parcelRequire("jlOGG");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $i69aA = parcelRequire("i69aA");

var $6Z2mh = parcelRequire("6Z2mh");

var $lAGdd = parcelRequire("lAGdd");

var $1hJVy = parcelRequire("1hJVy");
const $28e15c46fa77f0cb$export$6b98300c0f2ab048 = (0, $7NszV.createEntry)((0, $i69aA.servicedeskReportsSatisfactionIssueRoute), ()=>({
        group: 'servicedesk',
        component: (0, $1hJVy.default),
        layout: (0, $aPfsS.composeLayouts)((0, $6Z2mh.serviceProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)()),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $jlOGG.newIssueViewLockInStatusResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $lAGdd.getAIContextPanelResources)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $1hJVy.LazyServicedeskReportsIssueView)
        ],
        ufoName: 'service-management.reports.issue'
    }));

});
parcelRegister("i69aA", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsSatisfactionIssueRoute", () => $c513c6729e01b870$export$da606765550c7e7);
const $c513c6729e01b870$export$da606765550c7e7 = {
    name: 'servicedesk-reports-satisfaction-time-scale-issue',
    path: '/jira/servicedesk/projects/:projectKey/reports/all-rating/timescale/:timescaleId/:issueKey',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});


parcelRegister("fSktp", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsSatisfactionTimeScaleRouteEntry", () => $460b54aef192ce9f$export$8d7026b8c74a8be8);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $lH1vR = parcelRequire("lH1vR");

var $6Z2mh = parcelRequire("6Z2mh");

var $8Xwpi = parcelRequire("8Xwpi");
const $460b54aef192ce9f$export$8d7026b8c74a8be8 = (0, $7NszV.createEntry)((0, $lH1vR.servicedeskReportsSatisfactionTimeScaleRoute), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.reports.satisfaction',
        component: (0, $8Xwpi.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8Xwpi.LazyServicedeskReportsSatisfaction)
        ]
    }));

});
parcelRegister("lH1vR", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsSatisfactionTimeScaleRoute", () => $51118689f933b851$export$64ae70b2d6b34c4e);
const $51118689f933b851$export$64ae70b2d6b34c4e = {
    name: 'servicedesk-reports-satisfaction-time-scale',
    path: '/jira/servicedesk/projects/:projectKey/reports/all-rating/timescale/:timescaleId'
};

});


parcelRegister("5TKdO", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsTypeRouteEntry", () => $2e5063c16517b80e$export$bc47b2df6d39fd3f);

var $ffza4 = parcelRequire("ffza4");

var $g5RGc = parcelRequire("g5RGc");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $jlOGG = parcelRequire("jlOGG");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $iYmop = parcelRequire("iYmop");

var $6Z2mh = parcelRequire("6Z2mh");

var $lAGdd = parcelRequire("lAGdd");

var $IT9I6 = parcelRequire("IT9I6");

var $6Hx2y = parcelRequire("6Hx2y");
const $2e5063c16517b80e$export$bc47b2df6d39fd3f = (0, $7NszV.createEntry)((0, $iYmop.servicedeskReportsTypeRoute), ()=>({
        group: 'servicedesk',
        component: (0, $6Hx2y.default),
        layout: (0, $aPfsS.composeLayouts)((0, $6Z2mh.serviceProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                params: [
                    {
                        key: 'issueKey'
                    }
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $IT9I6.getReportsWithKbResources)(),
            (0, $jlOGG.newIssueViewLockInStatusResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $lAGdd.getAIContextPanelResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6Hx2y.LazyServicedeskReports)
        ]
    }));

});
parcelRegister("iYmop", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsTypeRoute", () => $48dd2701ffbb9a85$export$b955ac7f09c5dbb);
const $48dd2701ffbb9a85$export$b955ac7f09c5dbb = {
    name: 'servicedesk-reports-type',
    path: '/jira/servicedesk/projects/:projectKey/reports/:reportType/:reportId?/:reportsAction?/:timescaleId?/:issueKey?',
    query: [
        'oldIssueView?'
    ]
};

});

parcelRegister("6Hx2y", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskReports", () => $7131a1cafe24fb0a$export$75e043cf7a4e3661);
$parcel$export(module.exports, "default", () => $7131a1cafe24fb0a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $7131a1cafe24fb0a$export$75e043cf7a4e3661 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("7ndIc")), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports/src/index.tsx"
});
var /**
 * Dynamically loads the ServicedeskReports component, enhancing user experience by using deferred loading with a visual feedback.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$7131a1cafe24fb0a$export$2e2bcd8739ae039 = ({ match: match })=>{
    const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $7131a1cafe24fb0a$export$75e043cf7a4e3661,
        pageId: `spa-apps/servicedesk/reports/${match ? match.url : ''}${oldIssueView}`,
        shouldShowSpinner: true
    });
};

});
parcelRegister("7ndIc", function(module, exports) {

let $55e5514740be4e4d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $55e5514740be4e4d$var$load("3hBpW").then(()=>parcelRequire('dp6PR'));

});



parcelRegister("4zSYf", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsWorkloadRouteEntry", () => $6d0123422454b447$export$793ba749f18b4dd4);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $f55k4 = parcelRequire("f55k4");

var $6Z2mh = parcelRequire("6Z2mh");

var $iYH8s = parcelRequire("iYH8s");
const $6d0123422454b447$export$793ba749f18b4dd4 = (0, $7NszV.createEntry)((0, $f55k4.servicedeskReportsWorkloadRoute), ()=>({
        group: 'servicedesk',
        component: (0, $iYH8s.default),
        perfMetricKey: 'service-management.reports.workload',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $iYH8s.LazyServicedeskReportsWorkload)
        ]
    }));

});
parcelRegister("f55k4", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsWorkloadRoute", () => $339f526b78d38fe7$export$ce9b409ccf53e93c);
const $339f526b78d38fe7$export$ce9b409ccf53e93c = {
    name: 'servicedesk-reports-workload',
    path: '/jira/servicedesk/projects/:projectKey/reports/workload',
    exact: true
};

});

parcelRegister("iYH8s", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskReportsWorkload", () => $d985dd949edfaeac$export$e805fb47fdcd991);
$parcel$export(module.exports, "default", () => $d985dd949edfaeac$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");


const $d985dd949edfaeac$export$e805fb47fdcd991 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("lMSlP"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-workload/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d985dd949edfaeac$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d985dd949edfaeac$export$e805fb47fdcd991,
        pageId: `spa-apps/servicedesk${(0, $d37b1fd9e7afc201$export$ddc580d759168f88)}}`,
        shouldShowSpinner: true
    });

});
parcelRegister("lMSlP", function(module, exports) {

let $fdc83da7c215a866$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fdc83da7c215a866$var$load("ifHTD").then(()=>parcelRequire('bQ0Tt'));

});



parcelRegister("j175z", function(module, exports) {

$parcel$export(module.exports, "servicedeskServiceDetailsRouteEntry", () => $9ea7b1d46a5382bf$export$48af7c0b8f21929b);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $fPesd = parcelRequire("fPesd");

var $6Z2mh = parcelRequire("6Z2mh");

var $eGEo2 = parcelRequire("eGEo2");
const $9ea7b1d46a5382bf$export$48af7c0b8f21929b = (0, $7NszV.createEntry)((0, $fPesd.servicedeskServiceDetailsRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.service-details',
        component: (0, $eGEo2.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $eGEo2.LazyServicedeskServiceDetailsWithProjectContext)
        ]
    }));

});
parcelRegister("fPesd", function(module, exports) {

$parcel$export(module.exports, "servicedeskServiceDetailsRoute", () => $338c1e6694a650ce$export$fe5fe00b6d5eab87);
const $338c1e6694a650ce$export$fe5fe00b6d5eab87 = {
    name: 'servicedesk-service-details',
    path: '/jira/servicedesk/projects/:projectKey/services/:serviceAri'
};

});

parcelRegister("eGEo2", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskServiceDetailsWithProjectContext", () => $b6f27b3727e127d8$export$b154597f29589502);
$parcel$export(module.exports, "default", () => $b6f27b3727e127d8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $b6f27b3727e127d8$export$b154597f29589502 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hIKgA"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/service-details-with-project-context/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b6f27b3727e127d8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $b6f27b3727e127d8$export$b154597f29589502,
        pageId: "spa-apps/servicedesk/service-details",
        shouldShowSpinner: true
    });

});
parcelRegister("hIKgA", function(module, exports) {

let $ce6a6f4ad85d6a1d$var$load = (parcelRequire("28QjX"))(4);

module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $ce6a6f4ad85d6a1d$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $ce6a6f4ad85d6a1d$var$load("k6g9p")
        ]);
    }),
    $ce6a6f4ad85d6a1d$var$load("ffQaD"),
    $ce6a6f4ad85d6a1d$var$load("kvRbA"),
    $ce6a6f4ad85d6a1d$var$load("fliVL"),
    $ce6a6f4ad85d6a1d$var$load("jNxcv")
]).then(()=>parcelRequire('cIaZn'));

});



parcelRegister("gQWOR", function(module, exports) {

$parcel$export(module.exports, "serviceDeskServiceDetailsWithoutProjectRouteEntry", () => $90fd21cadf51bf65$export$de2e645f69483ce);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $kew7L = parcelRequire("kew7L");

var $3jBnk = parcelRequire("3jBnk");
const $90fd21cadf51bf65$export$de2e645f69483ce = (0, $7NszV.createEntry)((0, $kew7L.serviceDeskServiceDetailsWithoutProjectRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.service-details-without-project',
        component: (0, $3jBnk.default),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3jBnk.LazyServicedeskServiceDetailsWithoutProjectContext)
        ],
        meta: {
            reporting: {
                id: 'servicedesk-service-details-without-project',
                packageName: 'jiraSpaAppsServicedeskServiceDetailsWithoutProjectContext"',
                teamName: 'Falcons'
            }
        }
    }));

});
parcelRegister("kew7L", function(module, exports) {

$parcel$export(module.exports, "serviceDeskServiceDetailsWithoutProjectRoute", () => $35fa5222e37aa796$export$25e1d58db18a7c8b);
const $35fa5222e37aa796$export$25e1d58db18a7c8b = {
    name: 'servicedesk-service-details-without-project',
    path: '/jira/servicedesk/services/:serviceAri'
};

});

parcelRegister("3jBnk", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskServiceDetailsWithoutProjectContext", () => $0bd916f0e88ab362$export$ba1931edde0ce20c);
$parcel$export(module.exports, "default", () => $0bd916f0e88ab362$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $0bd916f0e88ab362$export$ba1931edde0ce20c = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("fi088"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/service-details-without-project-context/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0bd916f0e88ab362$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $0bd916f0e88ab362$export$ba1931edde0ce20c,
        pageId: "spa-apps/servicedesk/service-details",
        shouldShowSpinner: true
    });

});
parcelRegister("fi088", function(module, exports) {

let $b218a35594ccaf07$var$load = (parcelRequire("28QjX"))(4);

module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $b218a35594ccaf07$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $b218a35594ccaf07$var$load("k6g9p")
        ]);
    }),
    $b218a35594ccaf07$var$load("ffQaD"),
    $b218a35594ccaf07$var$load("kvRbA"),
    $b218a35594ccaf07$var$load("fliVL"),
    $b218a35594ccaf07$var$load("jDV3A")
]).then(()=>parcelRequire('bWPI8'));

});



parcelRegister("zaQdk", function(module, exports) {

$parcel$export(module.exports, "servicedeskServiceModalEditRouteEntry", () => $92695f6b0e89b9c4$export$5698449b623d4af);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $hxTrJ = parcelRequire("hxTrJ");

var $6Z2mh = parcelRequire("6Z2mh");

var $3URFK = parcelRequire("3URFK");
const $92695f6b0e89b9c4$export$5698449b623d4af = (0, $7NszV.createEntry)((0, $hxTrJ.servicedeskServiceModalEditRoute), ()=>({
        group: 'servicedesk',
        component: (0, $3URFK.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3URFK.LazyServiceUpdateModalWithProjectContext)
        ]
    }));

});
parcelRegister("hxTrJ", function(module, exports) {

$parcel$export(module.exports, "servicedeskServiceModalEditRoute", () => $6a799f5afeb5f72a$export$319fbbab5eb49cbf);
const $6a799f5afeb5f72a$export$319fbbab5eb49cbf = {
    name: 'servicedesk-service-modal-edit',
    path: '/jira/servicedesk/service-modal/:serviceAri'
};

});

parcelRegister("3URFK", function(module, exports) {

$parcel$export(module.exports, "LazyServiceUpdateModalWithProjectContext", () => $ca64a28173fa79b9$export$8984aadca7e15d1);
$parcel$export(module.exports, "default", () => $ca64a28173fa79b9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $ca64a28173fa79b9$export$8984aadca7e15d1 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("c3P55")), {
    moduleId: "./src/packages/spa-apps/servicedesk/service-update-modal-without-project-context/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ca64a28173fa79b9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ca64a28173fa79b9$export$8984aadca7e15d1,
        pageId: "spa-apps/servicedesk/service-update-modal",
        shouldShowSpinner: true
    });

});
parcelRegister("c3P55", function(module, exports) {

let $8c7d637e2cd3fd73$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8c7d637e2cd3fd73$var$load("e222C").then(()=>parcelRequire('9LJAj'));

});



parcelRegister("4UU5H", function(module, exports) {

$parcel$export(module.exports, "servicedeskServiceModalNewRouteEntry", () => $42345241d55d66da$export$75c24699abe8e616);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $ch9Xu = parcelRequire("ch9Xu");

var $6Z2mh = parcelRequire("6Z2mh");

var $cUmrA = parcelRequire("cUmrA");
const $42345241d55d66da$export$75c24699abe8e616 = (0, $7NszV.createEntry)((0, $ch9Xu.servicedeskServiceModalNewRoute), ()=>({
        group: 'servicedesk',
        component: (0, $cUmrA.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cUmrA.LazyServiceCreateModalWithProjectContext)
        ]
    }));

});
parcelRegister("ch9Xu", function(module, exports) {

$parcel$export(module.exports, "servicedeskServiceModalNewRoute", () => $feeac99aa6e6a420$export$5b5ea97286af2784);
const $feeac99aa6e6a420$export$5b5ea97286af2784 = {
    name: 'servicedesk-service-modal-new',
    path: '/jira/servicedesk/service-modal',
    exact: true
};

});

parcelRegister("cUmrA", function(module, exports) {

$parcel$export(module.exports, "LazyServiceCreateModalWithProjectContext", () => $cd397b20b9604e50$export$7f4092c8e7b7d3ec);
$parcel$export(module.exports, "default", () => $cd397b20b9604e50$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $cd397b20b9604e50$export$7f4092c8e7b7d3ec = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("g4Ihb")), {
    moduleId: "./src/packages/spa-apps/servicedesk/service-create-modal-without-project-context/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cd397b20b9604e50$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cd397b20b9604e50$export$7f4092c8e7b7d3ec,
        pageId: "spa-apps/servicedesk/service-create-modal",
        shouldShowSpinner: true
    });

});
parcelRegister("g4Ihb", function(module, exports) {

let $bb3f5d66fa136562$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bb3f5d66fa136562$var$load("jPaud").then(()=>parcelRequire('jBLt3'));

});



parcelRegister("izdjx", function(module, exports) {

$parcel$export(module.exports, "servicedeskServicesRouteEntry", () => $2498bd7e181dd343$export$5df203501090bc7f);

var $ffza4 = parcelRequire("ffza4");

var $1cxvE = parcelRequire("1cxvE");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $dePjO = parcelRequire("dePjO");

var $6Z2mh = parcelRequire("6Z2mh");

var $gLrf3 = parcelRequire("gLrf3");
const $2498bd7e181dd343$export$5df203501090bc7f = (0, $7NszV.createEntry)((0, $dePjO.servicedeskServicesRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.services',
        component: (0, $gLrf3.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $1cxvE.AsyncJSMOperationsHorizontalNav),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $1cxvE.LazyJSMOperationsHorizontalNav),
            (0, $gLrf3.LazyServicedeskServicesWithProjectContext)
        ]
    }));

});
parcelRegister("dePjO", function(module, exports) {

$parcel$export(module.exports, "servicedeskServicesRoute", () => $93e32423b61f9abd$export$4a800381bda6d53c);
const $93e32423b61f9abd$export$4a800381bda6d53c = {
    name: 'servicedesk-services',
    path: '/jira/servicedesk/projects/:projectKey/services',
    exact: true
};

});

parcelRegister("gLrf3", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskServicesWithProjectContext", () => $6f003aeaf484cf06$export$4aa60213b3477cf6);
$parcel$export(module.exports, "default", () => $6f003aeaf484cf06$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $6f003aeaf484cf06$export$4aa60213b3477cf6 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("ajRNX")), {
    moduleId: "./src/packages/spa-apps/servicedesk/services-with-project-context/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6f003aeaf484cf06$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $6f003aeaf484cf06$export$4aa60213b3477cf6,
        pageId: "spa-apps/servicedesk/services",
        shouldShowSpinner: true
    });

});
parcelRegister("ajRNX", function(module, exports) {

let $78356a38b1a12cb0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $78356a38b1a12cb0$var$load("d6j4K").then(()=>parcelRequire('6MNnt'));

});



parcelRegister("eWSeK", function(module, exports) {

$parcel$export(module.exports, "serviceDeskServicesWithoutProjectRouteEntry", () => $48a572bbef08816c$export$7031f96c25be5e14);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $ddcmX = parcelRequire("ddcmX");

var $7zD3e = parcelRequire("7zD3e");
const $48a572bbef08816c$export$7031f96c25be5e14 = (0, $7NszV.createEntry)((0, $ddcmX.serviceDeskServicesWithoutProjectRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.services-without-project',
        component: (0, $7zD3e.default),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7zD3e.LazyServicedeskServicesWithoutProjectContext)
        ],
        meta: {
            reporting: {
                id: 'servicedesk-services-without-project',
                packageName: 'jiraSpaAppsServicedeskServicesWithoutProjectContext"',
                teamName: 'Falcons'
            }
        }
    }));

});
parcelRegister("ddcmX", function(module, exports) {

$parcel$export(module.exports, "serviceDeskServicesWithoutProjectRoute", () => $1c8a671593efdd17$export$3210e7c54c21be97);
const $1c8a671593efdd17$export$3210e7c54c21be97 = {
    name: 'servicedesk-services-without-project',
    path: '/jira/servicedesk/services',
    exact: true
};

});

parcelRegister("7zD3e", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskServicesWithoutProjectContext", () => $be661d3f8fec3b0f$export$fc385e1392a8e28);
$parcel$export(module.exports, "default", () => $be661d3f8fec3b0f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $be661d3f8fec3b0f$export$fc385e1392a8e28 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("dXUPN")), {
    moduleId: "./src/packages/spa-apps/servicedesk/services-without-project-context/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$be661d3f8fec3b0f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $be661d3f8fec3b0f$export$fc385e1392a8e28,
        pageId: "spa-apps/servicedesk/services",
        shouldShowSpinner: true
    });

});
parcelRegister("dXUPN", function(module, exports) {

let $a2acdf30f3724a8b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a2acdf30f3724a8b$var$load("2WlWD").then(()=>parcelRequire('1QgiZ'));

});



parcelRegister("6agOS", function(module, exports) {

$parcel$export(module.exports, "servicedeskSlaSettingsRouteEntry", () => $4a495883d616d596$export$472949ed4e9ddfb0);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $fpjJX = parcelRequire("fpjJX");

var $4wBwP = parcelRequire("4wBwP");

var $hewRX = parcelRequire("hewRX");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $1CEnL = parcelRequire("1CEnL");
const $4a495883d616d596$export$472949ed4e9ddfb0 = (0, $7NszV.createEntry)((0, $hewRX.servicedeskSlaSettingsRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).SLA_SETTINGS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).SLA_SETTINGS),
                teamName: 'bumblebee'
            }
        },
        perfMetricKey: 'jsm-sla-settings',
        component: (0, $1CEnL.ServiceDeskSlaSettings),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $dxCvy.projectContextResource),
            (0, $4wBwP.slaMetricsDataResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $1CEnL.LazyProjectSettingsServiceDeskSlaSettings)
        ]
    }));

});
parcelRegister("4wBwP", function(module, exports) {

$parcel$export(module.exports, "slaMetricsDataResource", () => $5bd842d236781a2e$export$6cdfca3e816e9661);

var $2M1hQ = parcelRequire("2M1hQ");
const $5bd842d236781a2e$export$c5fa03c9ad8df0e2 = 'SLA_METRICS';

const $5bd842d236781a2e$export$6cdfca3e816e9661 = (0, $2M1hQ.createResource)({
    type: $5bd842d236781a2e$export$c5fa03c9ad8df0e2,
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: ()=>(parcelRequire("gvBbS")),
    maxAge: Infinity
});

});
parcelRegister("gvBbS", function(module, exports) {

let $c04c63e219cbeaca$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c04c63e219cbeaca$var$load("liBrI").then(()=>parcelRequire('dxWU3'));

});


parcelRegister("1CEnL", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskSlaSettings", () => $45b508c287c9b763$export$a6694c07cb5be8c1);
$parcel$export(module.exports, "ServiceDeskSlaSettings", () => $45b508c287c9b763$export$c56fde3803c5a1a3);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $l8ruj = parcelRequire("l8ruj");

var $kxZPA = parcelRequire("kxZPA");

const $45b508c287c9b763$export$a6694c07cb5be8c1 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("i4OMZ"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-sla-settings/src/index.tsx"
});
const $45b508c287c9b763$export$c56fde3803c5a1a3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "project-settings-service-desk-sla-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $45b508c287c9b763$export$a6694c07cb5be8c1,
        pageId: "project-settings-service-desk-sla-settings",
        shouldShowSpinner: true
    }));

});
parcelRegister("i4OMZ", function(module, exports) {

let $d28fff60291b027c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d28fff60291b027c$var$load("ffQaD"),
    $d28fff60291b027c$var$load("kvRbA"),
    $d28fff60291b027c$var$load("39wLT")
]).then(()=>parcelRequire('1rjw0'));

});



parcelRegister("2ytxj", function(module, exports) {

$parcel$export(module.exports, "servicedeskWorkflowConfigRouteEntry", () => $37624069b0a267c0$export$212f7f79630d5adc);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $dxCvy = parcelRequire("dxCvy");

var $fpjJX = parcelRequire("fpjJX");

var $043ka = parcelRequire("043ka");

var $6Z2mh = parcelRequire("6Z2mh");

var $j3pH1 = parcelRequire("j3pH1");
const $37624069b0a267c0$var$workflowSchemeConfigPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $j3pH1.workflowSchemeConfigEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $37624069b0a267c0$export$212f7f79630d5adc = (0, $7NszV.createEntry)((0, $043ka.servicedeskWorkflowConfigRoute), ()=>({
        group: 'project-settings-servicedesk',
        entryPoint () {
            return $37624069b0a267c0$var$workflowSchemeConfigPageEntrypoint;
        },
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $dxCvy.projectContextResource)
        ],
        meta: {
            reporting: {
                id: 'project-settings.workflow-scheme-config',
                packageName: 'projectSettingsWorkflowSchemeConfig',
                teamName: 'jsd-shield'
            }
        },
        ufoName: 'project-settings-workflow-scheme-config'
    }));

});
parcelRegister("j3pH1", function(module, exports) {

$parcel$export(module.exports, "workflowSchemeConfigEntrypoint", () => $5e46ff6da5ce3455$export$12ccdf1d30de8ac);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $5e46ff6da5ce3455$export$12ccdf1d30de8ac = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("gvqVA")), {
        moduleId: "6be3e66b",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("gvqVA", function(module, exports) {

let $c0446de3009672ee$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c0446de3009672ee$var$load("8Zr88").then(()=>parcelRequire('3STzC'));

});



parcelRegister("16Svt", function(module, exports) {

$parcel$export(module.exports, "settingsAutomationRouteEntry", () => $2c9e65dfb42014f0$export$4df9f9dcaf8565c9);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $ii08q = parcelRequire("ii08q");

var $5pSYQ = parcelRequire("5pSYQ");

var $fMK33 = parcelRequire("fMK33");
const $2c9e65dfb42014f0$export$4df9f9dcaf8565c9 = (0, $7NszV.createEntry)((0, $ii08q.settingsAutomationRoute), ()=>({
        group: 'global-settings',
        component: (0, $fMK33.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $fMK33.LazyGlobalAutomation)
        ]
    }));

});
parcelRegister("ii08q", function(module, exports) {

$parcel$export(module.exports, "settingsAutomationRoute", () => $21b53826ac35bfbd$export$b314ab31b2da625b);
const $21b53826ac35bfbd$export$b314ab31b2da625b = {
    name: 'global-automation',
    path: '/jira/settings/automation',
    exact: true
};

});

parcelRegister("fMK33", function(module, exports) {

$parcel$export(module.exports, "LazyGlobalAutomation", () => $e4cf560ebe587071$export$4189991a2992b828);
$parcel$export(module.exports, "default", () => $e4cf560ebe587071$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $aZsz6 = parcelRequire("aZsz6");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $i9k4m = parcelRequire("i9k4m");

const $e4cf560ebe587071$export$4189991a2992b828 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("fF6eq"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/automation/src/index.tsx"
});
const $e4cf560ebe587071$export$7c85ddcd4f0a813f = ()=>{
    const page = (_, { selectedItem: selectedItem, ...rest })=>{
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
        const querystring = (0, $aZsz6.qs).stringify(rest, true);
        return `/automation${querystring}`;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i9k4m.RedirectToProjectType), {
        page: page
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e4cf560ebe587071$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e4cf560ebe587071$export$4189991a2992b828,
        pageId: "global-automation",
        shouldShowSpinner: false
    });

});
parcelRegister("i9k4m", function(module, exports) {

$parcel$export(module.exports, "RedirectToProjectType", () => $5f4113c49e08a927$export$8a3df560509448b8);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dxCvy = parcelRequire("dxCvy");

var $bVDE5 = parcelRequire("bVDE5");

var $7tQej = parcelRequire("7tQej");
var $2YP9W = parcelRequire("2YP9W");
var $doZTA = parcelRequire("doZTA");
const $5f4113c49e08a927$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $7tQej.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $8zOmE.fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, $2NMNM.useAnalyticsEvents), useResource: useResource = (0, $2YP9W.useResource), useRouter: useRouter = (0, $doZTA.useRouter), useSpaStateTransition: useSpaStateTransition = (0, $bVDE5.useSpaStateTransition) })=>{
    const [{ match: match, query: query, route: route }] = useRouter();
    const { data: data } = useResource((0, $dxCvy.projectContextResource));
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
    (0, $5uXOq.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $2vSU6.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $2vSU6.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};

});

parcelRegister("fF6eq", function(module, exports) {

let $b66f84dae9f17679$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b66f84dae9f17679$var$load("dyp0t").then(()=>parcelRequire('b0ztm'));

});



parcelRegister("7m5aN", function(module, exports) {

$parcel$export(module.exports, "settingsCmdbFieldConfigRouteEntry", () => $89fe0e9a025a7c8e$export$c68a412f25295511);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $kAymX = parcelRequire("kAymX");

var $gRzZD = parcelRequire("gRzZD");

var $5Td0i = parcelRequire("5Td0i");
const $89fe0e9a025a7c8e$export$c68a412f25295511 = (0, $7NszV.createEntry)((0, $kAymX.settingsCmdbFieldConfigRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.cmdb-field-config',
        component: (0, $5Td0i.AsyncCmdbFieldConfigPage),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $gRzZD.workspaceResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5Td0i.LazyCMDBFieldConfigAdmin)
        ]
    }));

});
parcelRegister("kAymX", function(module, exports) {

$parcel$export(module.exports, "settingsCmdbFieldConfigRoute", () => $db5ba62dbec4de6f$export$5097bfaa68f86ca6);
const $db5ba62dbec4de6f$export$5097bfaa68f86ca6 = {
    name: 'global-settings-issues-cmdb-field-config',
    path: '/secure/admin/CmdbObjectFieldConfiguration'
};

});

parcelRegister("5Td0i", function(module, exports) {

$parcel$export(module.exports, "LazyCMDBFieldConfigAdmin", () => $03d0290def261ead$export$ccc6da5137e23637);
$parcel$export(module.exports, "AsyncCmdbFieldConfigPage", () => $03d0290def261ead$export$8dfbe255f554ebab);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $03d0290def261ead$export$ccc6da5137e23637 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hYKAo"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/cmdb-field-config/src/index.tsx"
});
const $03d0290def261ead$export$8dfbe255f554ebab = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $03d0290def261ead$export$ccc6da5137e23637,
        pageId: "admin-pages-cmdb-field-config",
        shouldShowSpinner: true
    });

});
parcelRegister("hYKAo", function(module, exports) {

let $d16c2d48b4643d57$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d16c2d48b4643d57$var$load("23hZk").then(()=>parcelRequire('gXCe1'));

});



parcelRegister("kDimk", function(module, exports) {

$parcel$export(module.exports, "settingsOauthCredentialsRouteEntry", () => $360b9bb3a5e4b35a$export$d1c67ceb7c5e2d6a);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $iHiHz = parcelRequire("iHiHz");

var $7NszV = parcelRequire("7NszV");

var $ldGiq = parcelRequire("ldGiq");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $9Z37w = parcelRequire("9Z37w");

var $jTwes = parcelRequire("jTwes");
const $360b9bb3a5e4b35a$export$d1c67ceb7c5e2d6a = (0, $7NszV.createEntry)((0, $9Z37w.settingsOauthCredentialsRoute), ()=>({
        group: 'global-settings',
        component: (0, $jTwes.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $iHiHz.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $5bkvv.getNavigationSidebarGlobalSettingsResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $ldGiq.adminOauthCredentialsResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jTwes.LazyOAuthCredentialsAdmin)
        ],
        ufoName: 'admin.oauth-credentials'
    }));

});
parcelRegister("ldGiq", function(module, exports) {

$parcel$export(module.exports, "adminOauthCredentialsResource", () => $b7e65fd0b40325af$export$870d7919c1ca4482);

var $2M1hQ = parcelRequire("2M1hQ");
const $b7e65fd0b40325af$var$RESOURCE_TYPE_ADMIN_OAUTH_CREDENTIALS = 'ADMIN_OAUTH_CREDENTIALS';

const $b7e65fd0b40325af$export$870d7919c1ca4482 = (0, $2M1hQ.createResource)({
    type: $b7e65fd0b40325af$var$RESOURCE_TYPE_ADMIN_OAUTH_CREDENTIALS,
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("9ztLD"))
});

});
parcelRegister("9ztLD", function(module, exports) {

let $6f7e79204086cfdc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6f7e79204086cfdc$var$load("2MJAU").then(()=>parcelRequire('8EYbC'));

});


parcelRegister("9Z37w", function(module, exports) {

$parcel$export(module.exports, "settingsOauthCredentialsRoute", () => $79dbadc9937eefab$export$c0ee28def7ef8783);
const $79dbadc9937eefab$export$c0ee28def7ef8783 = {
    name: 'admin-oauth-credentials',
    path: '/secure/admin/oauth-credentials'
};

});

parcelRegister("jTwes", function(module, exports) {

$parcel$export(module.exports, "LazyOAuthCredentialsAdmin", () => $a25b27e0ebd790aa$export$101baa25055633e8);
$parcel$export(module.exports, "default", () => $a25b27e0ebd790aa$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $a25b27e0ebd790aa$export$101baa25055633e8 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("egIgg"))), {
    moduleId: "./src/packages/spa-apps/admin-oauth-credentials/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a25b27e0ebd790aa$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $a25b27e0ebd790aa$export$101baa25055633e8,
        pageId: "admin-oauth-credentials",
        shouldShowSpinner: true
    });

});
parcelRegister("egIgg", function(module, exports) {

let $a634e4af552502c1$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $a634e4af552502c1$var$load("ffQaD"),
    $a634e4af552502c1$var$load("kvRbA"),
    $a634e4af552502c1$var$load("jkFsZ")
]).then(()=>parcelRequire('imW3j'));

});



parcelRegister("9z1Wd", function(module, exports) {

$parcel$export(module.exports, "settingsRouteEntry", () => $1a59cf2a3db44036$export$1d28e19560927106);

var $c04PQ = parcelRequire("c04PQ");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $H5kLJ = parcelRequire("H5kLJ");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $7g2py = parcelRequire("7g2py");

var $lkFvK = parcelRequire("lkFvK");

var $7j28R = parcelRequire("7j28R");

var $k6R7C = parcelRequire("k6R7C");
const $1a59cf2a3db44036$var$settingsPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7j28R.settingsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $1a59cf2a3db44036$export$1d28e19560927106 = (0, $7NszV.createEntry)((0, $H5kLJ.settingsRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $c04PQ.isFedRamp)()) return undefined;
            return $1a59cf2a3db44036$var$settingsPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $k6R7C.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $7g2py.VirtualAgentSettingsSkeleton),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_SETTINGS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_SETTINGS),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }));

});
parcelRegister("H5kLJ", function(module, exports) {

$parcel$export(module.exports, "settingsRoute", () => $b642a35d67793caf$export$847a7c378c11c645);
const $b642a35d67793caf$export$847a7c378c11c645 = {
    name: 'project-settings-servicedesk-virtualagent-settings',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/settings/:tab(basic|channels)?'
};

});

parcelRegister("7g2py", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentSettingsSkeleton", () => $d88dc21ec5f90208$export$429c43ddcb09c14c);
/* VirtualAgentSettingsSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $6mG7P = parcelRequire("6mG7P");
const $d88dc21ec5f90208$var$customCssStyles = null;
const $d88dc21ec5f90208$export$429c43ddcb09c14c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6mG7P))),
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("6mG7P", function(module, exports) {
module.exports = new URL("virtual-agent-settings-app-skeleton.tpl.1a9c03fe.svg", import.meta.url).toString();

});


parcelRegister("7j28R", function(module, exports) {

$parcel$export(module.exports, "settingsEntryPoint", () => $a9827913d0401124$export$d34e7816b7ac181a);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $1I4lD = parcelRequire("1I4lD");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $aOzLh = parcelRequire("aOzLh");

const $a9827913d0401124$export$d34e7816b7ac181a = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(0, $aOzLh.clientSideOnly)((parcelRequire("e5yLU"))), {
        moduleId: "ed4de71b",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $1I4lD.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey?.toUpperCase() ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("1I4lD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a14dfc5f3ce71c58$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6a8b54dff6bd67d9f566bb4eac1d257a>>
 * @relayHash 7189bee0c97cc09b10f8e1589368c2de
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 392629a596a95c19575393c3c0047883914bb7cb4d8de01d923e7684c2f31d13

var $y2RTb = parcelRequire("y2RTb");

var $7oHmH = parcelRequire("7oHmH");

var $gnNIl = parcelRequire("gnNIl");
const $a14dfc5f3ce71c58$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "392629a596a95c19575393c3c0047883914bb7cb4d8de01d923e7684c2f31d13",
        "metadata": {},
        "name": "srcVirtualAgentSettingsQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaenableaianswerspagerelayprovider": (0, $y2RTb.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvastatusheaderrelayprovider": (0, $gnNIl.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $7oHmH.default)
        }
    }
};
var $a14dfc5f3ce71c58$export$2e2bcd8739ae039 = $a14dfc5f3ce71c58$var$node;

});
parcelRegister("y2RTb", function(module, exports) {

$parcel$export(module.exports, "default", () => $610656e9d6041bd2$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $610656e9d6041bd2$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jsm_va_enable_ai_answers_page');
    }
};

});


parcelRegister("e5yLU", function(module, exports) {

let $a41c8144c3124c57$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a41c8144c3124c57$var$load("atgSj").then(()=>parcelRequire('byLJY'));

});



parcelRegister("2FVZu", function(module, exports) {

$parcel$export(module.exports, "softwareAdvancedRoadmapsGettingStartedRedirectRouteEntry", () => $c59b8ec61d58752b$export$4652a26319dca4d0);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $cSxBV = parcelRequire("cSxBV");

var $ds5qV = parcelRequire("ds5qV");

var $g6wgl = parcelRequire("g6wgl");
const $c59b8ec61d58752b$export$4652a26319dca4d0 = (0, $7NszV.createEntry)((0, $cSxBV.softwareAdvancedRoadmapsGettingStartedRedirectRoute), ()=>({
        group: 'software',
        component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
                to: "/jira/plans?create-sample-plan=true"
            }),
        isRedirect: true,
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $g6wgl.LazyPlanTimeline)
        ]
    }));

});
parcelRegister("cSxBV", function(module, exports) {

$parcel$export(module.exports, "softwareAdvancedRoadmapsGettingStartedRedirectRoute", () => $c9008f0cd6cfcbbf$export$38c76ea9ddc85b3);
const $c9008f0cd6cfcbbf$export$38c76ea9ddc85b3 = {
    name: 'software-advanced-roadmaps-getting-started-redirect',
    path: '/secure/PortfolioGettingStarted.jspa'
};

});


parcelRegister("fQCGk", function(module, exports) {

$parcel$export(module.exports, "softwareBacklogEmbedRouteEntry", () => $bec4451dd2be6ad0$export$7cd14dee22609378);


var $4R6GH = parcelRequire("4R6GH");

var $fKmub = parcelRequire("fKmub");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $3RJkv = parcelRequire("3RJkv");

var $bAB30 = parcelRequire("bAB30");

var $9SRRO = parcelRequire("9SRRO");

var $6DTBr = parcelRequire("6DTBr");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $2Ql51 = parcelRequire("2Ql51");

var $78yv1 = parcelRequire("78yv1");

var $1jxD5 = parcelRequire("1jxD5");

var $gNStA = parcelRequire("gNStA");

var $hKGEW = parcelRequire("hKGEW");
const $bec4451dd2be6ad0$export$7cd14dee22609378 = (0, $7NszV.createEntry)((0, $78yv1.softwareBacklogEmbedRoute), ()=>({
        group: 'software',
        component: (0, $hKGEW.BacklogPage),
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental-backlog'),
        layout: (0, $aPfsS.createLayout)({
            isChromeless: true
        }),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $bAB30.backlogResource),
            (0, $9SRRO.customFiltersResource),
            (0, $6DTBr.backlogFilterRefinementResource),
            (0, $5bkvv.forgeBacklogModuleResource),
            (0, $5bkvv.forgeSprintModuleResource),
            (0, $2Ql51.themePreferenceResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('crocs-load_ai_enablement_in_backlog_router'), (0, $1jxD5.aiEntitlementResource))
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $hKGEW.LazyBacklogPage)
        ],
        ufoName: 'next-gen-backlog-embed',
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$c17f34c425972af1)
        }
    }));

});
parcelRegister("bAB30", function(module, exports) {

$parcel$export(module.exports, "backlogResource", () => $d3029439c7d3b0b0$export$31d171ba71468137);

var $2M1hQ = parcelRequire("2M1hQ");


const $d3029439c7d3b0b0$export$31d171ba71468137 = (0, $2M1hQ.createResource)({
    type: (0, $fe839261f35d1611$export$a0ef589381533a7c),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>(parcelRequire("7osjY")),
    // SSR doesn't care about this and we can't check FFs here because its not in the render path
    maxAge: 3600000,
    isBrowserOnly: true
});

});
const $fe839261f35d1611$export$faa68b3df5415bcb = 'NEXTGEN_BACKLOG_CUSTOM_FILTERS';
const $fe839261f35d1611$export$214238a9ff4636a = 'NEXTGEN_BACKLOG_FILTER_REFINEMENT';
const $fe839261f35d1611$export$a0ef589381533a7c = 'NEXTGEN_BACKLOG';

parcelRegister("7osjY", function(module, exports) {

let $5620be4b0c5ec4eb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5620be4b0c5ec4eb$var$load("dHucG").then(()=>parcelRequire('lq5RB'));

});


parcelRegister("9SRRO", function(module, exports) {

$parcel$export(module.exports, "customFiltersResource", () => $87093d7252240507$export$3e390340716755de);

var $dXq4S = parcelRequire("dXq4S");

var $ao2h1 = parcelRequire("ao2h1");

var $aYacW = parcelRequire("aYacW");

const $87093d7252240507$export$3e390340716755de = (0, $ao2h1.createRelayResource)({
    type: (0, $fe839261f35d1611$export$faa68b3df5415bcb),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $aYacW.default),
            variables: {
                boardId: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    captureErrors: true,
    isBrowserOnly: true
});

});
parcelRegister("aYacW", function(module, exports) {

$parcel$export(module.exports, "default", () => $16318ecaa49178e6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<066895e3c0e872466470887b4350609b>>
 * @relayHash 8bb4d5e3e502ca70e90f4e1bb2f1614f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 494a9992c544e6be8f44d8b97ba70f29edc0d248b0153079b00cda817f4f7082
const $16318ecaa49178e6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "viewBacklogCustomFiltersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "customFilter_softwareFilters_CustomFilterRelay"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "viewBacklogCustomFiltersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "CustomFilter",
                            "kind": "LinkedField",
                            "name": "customFilters",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        },
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "494a9992c544e6be8f44d8b97ba70f29edc0d248b0153079b00cda817f4f7082",
            "metadata": {},
            "name": "viewBacklogCustomFiltersQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$16318ecaa49178e6$var$node.hash = "071c255f9696fe84a9c3982d42cfa5c0";
var $16318ecaa49178e6$export$2e2bcd8739ae039 = $16318ecaa49178e6$var$node;

});


parcelRegister("6DTBr", function(module, exports) {

$parcel$export(module.exports, "backlogFilterRefinementResource", () => $da5207290785304f$export$f9d71cb27b4dd1d8);

var $gNStA = parcelRequire("gNStA");

var $ao2h1 = parcelRequire("ao2h1");

var $6s1PB = parcelRequire("6s1PB");

var $dXq4S = parcelRequire("dXq4S");

var $5T5EE = parcelRequire("5T5EE");

const $da5207290785304f$export$f9d71cb27b4dd1d8 = (0, $gNStA.resourceWithCondition2)(()=>(0, $6s1PB.expVal)('filter_refinement_in_tmp_backlog', 'isEnabled', false), (0, $ao2h1.createRelayResource)({
    type: (0, $fe839261f35d1611$export$214238a9ff4636a),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $5T5EE.default),
            variables: {
                cloudId: tenantContext.cloudId,
                boardId: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                }),
                filterRefinementScope: {
                    board: {
                        boardId: Number(match.params.boardId)
                    }
                }
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    isBrowserOnly: true
}));

});
parcelRegister("5T5EE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2d4cd0ca7ffbade$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f792f8e7dc037abcb427c6104481635b>>
 * @relayHash 1380d721b18915720bbca11b40e27b39
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fff74428c768ff9ead961fcc85650bd1e66c4e039411390b08d38d160e9ec27d
const $e2d4cd0ca7ffbade$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "fff74428c768ff9ead961fcc85650bd1e66c4e039411390b08d38d160e9ec27d",
        "metadata": {},
        "name": "backlogFilterRefinementQuery",
        "operationKind": "query",
        "text": null
    }
};
var $e2d4cd0ca7ffbade$export$2e2bcd8739ae039 = $e2d4cd0ca7ffbade$var$node;

});


parcelRegister("78yv1", function(module, exports) {

$parcel$export(module.exports, "softwareBacklogEmbedRoute", () => $58a7d1c6d58c26bf$export$bc022a39c42aba2f);
const $58a7d1c6d58c26bf$export$bc022a39c42aba2f = {
    name: 'software-backlog-embed',
    path: '/jira/software/projects/:projectKey/boards/:boardId/backlog/embed',
    exact: true
};

});

parcelRegister("hKGEW", function(module, exports) {

$parcel$export(module.exports, "LazyBacklogPage", () => $6275b1ced1324b76$export$edb4b8cf67d7d767);
$parcel$export(module.exports, "BacklogPage", () => $6275b1ced1324b76$export$471ffbe87b75af04);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $d3645 = parcelRequire("d3645");

const $6275b1ced1324b76$export$edb4b8cf67d7d767 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hiNeG"))), {
    moduleId: "./src/packages/spa-apps/next-gen-backlog/src/index.tsx"
});
const $6275b1ced1324b76$export$471ffbe87b75af04 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $6275b1ced1324b76$export$edb4b8cf67d7d767,
        pageId: `next-gen-backlog-${(0, $d3645.getBoardId)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });

});
parcelRegister("d3645", function(module, exports) {

$parcel$export(module.exports, "getBoardId", () => $8f60ec15db3f7d28$export$557c2f222778cea6);

var $ebyGx = parcelRequire("ebyGx");
const $8f60ec15db3f7d28$export$557c2f222778cea6 = ({ location: location, match: match })=>{
    if (match && match.params.boardId) return match.params.boardId;
    const { rapidView: rapidView } = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(location.search);
    return rapidView;
};

});



parcelRegister("1EVpW", function(module, exports) {

$parcel$export(module.exports, "softwareBacklogRouteEntry", () => $73cbd5374edd4b4f$export$a5f8ba02d2755510);


var $4R6GH = parcelRequire("4R6GH");

var $5f2bR = parcelRequire("5f2bR");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $3RJkv = parcelRequire("3RJkv");

var $bAB30 = parcelRequire("bAB30");

var $9SRRO = parcelRequire("9SRRO");

var $6DTBr = parcelRequire("6DTBr");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $fTg4y = parcelRequire("fTg4y");

var $i8JTM = parcelRequire("i8JTM");

var $e7bC3 = parcelRequire("e7bC3");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");

var $1jxD5 = parcelRequire("1jxD5");

var $6ypBw = parcelRequire("6ypBw");
const $73cbd5374edd4b4f$export$a5f8ba02d2755510 = (0, $7NszV.createEntry)((0, $fTg4y.softwareBacklogRoute), ()=>({
        group: 'software',
        skeleton: (0, $i8JTM.NextGenBacklogSkeleton),
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental-backlog'),
        layout: (0, $aPfsS.composeLayouts)((0, $e7bC3.softwareProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true,
            sidebarId: (0, $4R6GH.fg)('jfp-magma-fix-nav4-sidebar-client-api-call') ? (0, $lmyls.SIDEBAR_ID).CONTENT : undefined
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)({
                isUsingSidebarEntrypoint: (0, $4R6GH.fg)('jfp-magma-fix-nav4-sidebar-client-api-call')
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3Only),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResourceOnNav3Only),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $bAB30.backlogResource),
            (0, $9SRRO.customFiltersResource),
            (0, $6DTBr.backlogFilterRefinementResource),
            (0, $5bkvv.forgeBacklogModuleResource),
            (0, $5bkvv.forgeSprintModuleResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingEnabled)(), (0, $9V5k0.projectThemeResource)),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('crocs-load_ai_enablement_in_backlog_router'), (0, $1jxD5.aiEntitlementResource))
        ],
        preloadOptions: {
            earlyChunks: [
                'software-backlog-early-entry'
            ]
        },
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        ufoName: 'next-gen-backlog',
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$c17f34c425972af1)
        },
        entryPoint: ()=>(0, $6ypBw.backlogPageEntrypoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("fTg4y", function(module, exports) {

$parcel$export(module.exports, "softwareBacklogRoute", () => $bb895b75440d1fb3$export$fb454ec14936c0ab);
const $bb895b75440d1fb3$export$fb454ec14936c0ab = {
    name: 'software-backlog',
    path: '/jira/software/projects/:projectKey/boards/:boardId/backlog'
};

});

parcelRegister("6ypBw", function(module, exports) {

$parcel$export(module.exports, "backlogPageEntrypoint", () => $095a4b5c220745ce$export$1ccf08591607897d);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $fo6b8 = parcelRequire("fo6b8");

var $fT58V = parcelRequire("fT58V");

var $krpZe = parcelRequire("krpZe");

var $6avBT = parcelRequire("6avBT");
const $095a4b5c220745ce$export$1ccf08591607897d = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $6avBT.nextGenBacklogEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $fT58V.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $krpZe.nav4ProjectsContentEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});


parcelRegister("azyVo", function(module, exports) {

$parcel$export(module.exports, "softwareBoardEmbedRouteEntry", () => $8db4a1001ea28148$export$ff8632c8a0f5d984);


var $4R6GH = parcelRequire("4R6GH");

var $fKmub = parcelRequire("fKmub");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $5qQ9I = parcelRequire("5qQ9I");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $2Ql51 = parcelRequire("2Ql51");

var $eeXsz = parcelRequire("eeXsz");

var $4IqZT = parcelRequire("4IqZT");

var $aRjc0 = parcelRequire("aRjc0");

var $2QA6X = parcelRequire("2QA6X");

var $itbWq = parcelRequire("itbWq");

var $kirSA = parcelRequire("kirSA");
const $8db4a1001ea28148$export$ff8632c8a0f5d984 = (0, $7NszV.createEntry)((0, $eeXsz.softwareBoardEmbedRoute), ()=>({
        group: 'software',
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental-board'),
        layout: (0, $aPfsS.createLayout)({
            isChromeless: true
        }),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $4IqZT.conditionalBoardNBTOptInResource),
            (0, $2QA6X.conditionalBoardResource),
            (0, $aRjc0.conditionalBoardRelayResource),
            (0, $5qQ9I.boardFilterRefinementResource),
            (0, $itbWq.conditionalCustomFiltersResource),
            (0, $2Ql51.themePreferenceResource),
            (0, $5bkvv.forgeBoardModuleResource)
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        entryPoint: ()=>(0, $kirSA.softwareBoardPageEntrypoint),
        ufoName: 'next-gen-board-embed',
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$f364828958cffad0)
        }
    }));

});
parcelRegister("5qQ9I", function(module, exports) {

$parcel$export(module.exports, "boardResource", () => $21d99b29ea940c83$export$286b76e0f2661cfb);
$parcel$export(module.exports, "customFiltersResource", () => $21d99b29ea940c83$export$3e390340716755de);
$parcel$export(module.exports, "boardFilterRefinementResource", () => $21d99b29ea940c83$export$283d16e3e02421f0);
$parcel$export(module.exports, "boardRelayResource", () => $21d99b29ea940c83$export$81ac23db76b1f935);
// eslint-disable-next-line jira/import-whitelist -- Unclear how to change the config whilst we transition to flat config

var $6s1PB = parcelRequire("6s1PB");

var $dXq4S = parcelRequire("dXq4S");

var $ao2h1 = parcelRequire("ao2h1");

var $6mTNg = parcelRequire("6mTNg");

var $9fgCw = parcelRequire("9fgCw");

var $ke2kk = parcelRequire("ke2kk");

var $gNStA = parcelRequire("gNStA");

var $2M1hQ = parcelRequire("2M1hQ");


const $21d99b29ea940c83$export$286b76e0f2661cfb = (0, $2M1hQ.createResource)({
    type: (0, $a00fc8fb83f2948a$export$a38ac7339e3f31db),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>(parcelRequire("dhimE")),
    // SSR doesn't care about this and we can't check FFs here because its not in the render path
    maxAge: 3600000,
    isBrowserOnly: true
});
const $21d99b29ea940c83$export$3e390340716755de = (0, $ao2h1.createRelayResource)({
    type: (0, $a00fc8fb83f2948a$export$b48bcc76a0105016),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $9fgCw.default),
            variables: {
                boardId: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    isBrowserOnly: true
});
const $21d99b29ea940c83$export$283d16e3e02421f0 = (0, $gNStA.resourceWithCondition2)(()=>(0, $6s1PB.expVal)('filter_refinement_in_tmp_board', 'isEnabled', false), (0, $ao2h1.createRelayResource)({
    type: (0, $a00fc8fb83f2948a$export$339da8fd7fc0a8e9),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $ke2kk.default),
            variables: {
                cloudId: tenantContext.cloudId,
                boardId: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                }),
                filterRefinementScope: {
                    board: {
                        boardId: Number(match.params.boardId)
                    }
                }
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    isBrowserOnly: true
}));
const $21d99b29ea940c83$export$81ac23db76b1f935 = (0, $ao2h1.createRelayResource)({
    type: (0, $a00fc8fb83f2948a$export$5cef388780439aec),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $6mTNg.default),
            variables: {
                boardId: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    isBrowserOnly: true
});

});
parcelRegister("6mTNg", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddc6b6eeb5cc2255$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<916f92cb49153da25a6abe2a4d651185>>
 * @relayHash 1b45667561f9430ea4e961757485983b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ab366f74068bb048193650cda464a839daec6f71dd9d1e7ee8874e9f9959ba67
const $ddc6b6eeb5cc2255$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "ab366f74068bb048193650cda464a839daec6f71dd9d1e7ee8874e9f9959ba67",
        "metadata": {},
        "name": "boardWithRouterRelayQuery",
        "operationKind": "query",
        "text": null
    }
};
var $ddc6b6eeb5cc2255$export$2e2bcd8739ae039 = $ddc6b6eeb5cc2255$var$node;

});

parcelRegister("9fgCw", function(module, exports) {

$parcel$export(module.exports, "default", () => $59a4f75157ae0306$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3e40c06e874adef0395c5788a7d119a9>>
 * @relayHash fa277d121f8f09e75035802d7ede6889
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a079984b25df71d288de249187cdd59463b205124f1a0a13756db6b3207ef56b
const $59a4f75157ae0306$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a079984b25df71d288de249187cdd59463b205124f1a0a13756db6b3207ef56b",
        "metadata": {},
        "name": "viewBoardCustomFiltersQuery",
        "operationKind": "query",
        "text": null
    }
};
var $59a4f75157ae0306$export$2e2bcd8739ae039 = $59a4f75157ae0306$var$node;

});

parcelRegister("ke2kk", function(module, exports) {

$parcel$export(module.exports, "default", () => $32c6ecabe578696e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b2791ce93d3a0a0e17fee486ad965601>>
 * @relayHash 5c749d389bf268ee9226560ad568adcf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9283dbd6d43bd23893ba0d1fb905c533d07635b370710c93db0ea67cb8b41e06
const $32c6ecabe578696e$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "9283dbd6d43bd23893ba0d1fb905c533d07635b370710c93db0ea67cb8b41e06",
        "metadata": {},
        "name": "boardFilterRefinementQuery",
        "operationKind": "query",
        "text": null
    }
};
var $32c6ecabe578696e$export$2e2bcd8739ae039 = $32c6ecabe578696e$var$node;

});

const $a00fc8fb83f2948a$export$a38ac7339e3f31db = 'NEXTGEN_BOARD';
const $a00fc8fb83f2948a$export$b48bcc76a0105016 = 'NEXTGEN_BOARD_CUSTOM_FILTERS';
const $a00fc8fb83f2948a$export$5cef388780439aec = 'NEXTGEN_BOARD_RELAY';
const $a00fc8fb83f2948a$export$339da8fd7fc0a8e9 = 'NEXTGEN_BOARD_FILTER_REFINEMENT';

parcelRegister("dhimE", function(module, exports) {

let $9aab1baa202b1068$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9aab1baa202b1068$var$load("kVX56"),
    $9aab1baa202b1068$var$load("j6VPG")
]).then(()=>parcelRequire('11pNz'));

});


parcelRegister("eeXsz", function(module, exports) {

$parcel$export(module.exports, "softwareBoardEmbedRoute", () => $f06c20d996c477e6$export$f55626b64e3fcb4f);
const $f06c20d996c477e6$export$f55626b64e3fcb4f = {
    name: 'software-boards-embed',
    exact: true,
    path: '/jira/software/projects/:projectKey/boards/:boardId/embed'
};

});

parcelRegister("4IqZT", function(module, exports) {

$parcel$export(module.exports, "conditionalBoardNBTOptInResource", () => $e8f5fec2c725aeaf$export$3cdaa13b878c3c59);

var $c04PQ = parcelRequire("c04PQ");

var $ipmBb = parcelRequire("ipmBb");

var $gNStA = parcelRequire("gNStA");
const $e8f5fec2c725aeaf$export$3cdaa13b878c3c59 = (0, $gNStA.resourceWithCondition2)(()=>!(0, $c04PQ.isFedRamp)(), (0, $ipmBb.nextBestTaskFeatureResource));

});

parcelRegister("aRjc0", function(module, exports) {

$parcel$export(module.exports, "conditionalBoardRelayResource", () => $170e9c5fe0076e7e$export$ce009bf1a33fb264);

var $4R6GH = parcelRequire("4R6GH");

var $5qQ9I = parcelRequire("5qQ9I");

var $gNStA = parcelRequire("gNStA");
const $170e9c5fe0076e7e$export$ce009bf1a33fb264 = (0, $gNStA.resourceWithCondition)(()=>(0, $4R6GH.fg)('critical_board_query_with_relay'), (0, $5qQ9I.boardRelayResource));

});

parcelRegister("2QA6X", function(module, exports) {

$parcel$export(module.exports, "conditionalBoardResource", () => $ea9cac4f36af465b$export$2ba7dfd4089a1a57);

var $4R6GH = parcelRequire("4R6GH");

var $5qQ9I = parcelRequire("5qQ9I");

var $gNStA = parcelRequire("gNStA");
const $ea9cac4f36af465b$export$2ba7dfd4089a1a57 = (0, $gNStA.resourceWithCondition)(()=>!(0, $4R6GH.fg)('critical_board_query_with_relay'), (0, $5qQ9I.boardResource));

});

parcelRegister("itbWq", function(module, exports) {

$parcel$export(module.exports, "conditionalCustomFiltersResource", () => $1121c6a3d058cc47$export$ad9ac1bd5f72148c);

var $6s1PB = parcelRequire("6s1PB");

var $5qQ9I = parcelRequire("5qQ9I");

var $gNStA = parcelRequire("gNStA");
const $1121c6a3d058cc47$export$ad9ac1bd5f72148c = (0, $gNStA.resourceWithCondition2)(()=>!(0, $6s1PB.expVal)('filter_refinement_in_tmp_board', 'isEnabled', false), (0, $5qQ9I.customFiltersResource));

});

parcelRegister("kirSA", function(module, exports) {

$parcel$export(module.exports, "softwareBoardPageEntrypoint", () => $371682d9ceaef2cd$export$89009c28cae628ae);

var $lkFvK = parcelRequire("lkFvK");

var $fo6b8 = parcelRequire("fo6b8");

var $7rNZV = parcelRequire("7rNZV");

var $lmyls = parcelRequire("lmyls");
const $371682d9ceaef2cd$export$89009c28cae628ae = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7rNZV.nextGenBoardEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});


parcelRegister("7wXr4", function(module, exports) {

$parcel$export(module.exports, "softwareBoardRouteEntry", () => $bc83504262104385$export$2964ea1cdd5afa39);


var $4R6GH = parcelRequire("4R6GH");

var $5f2bR = parcelRequire("5f2bR");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $5qQ9I = parcelRequire("5qQ9I");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $7wTzh = parcelRequire("7wTzh");

var $11dfA = parcelRequire("11dfA");

var $gNStA = parcelRequire("gNStA");

var $e7bC3 = parcelRequire("e7bC3");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");

var $4IqZT = parcelRequire("4IqZT");

var $aRjc0 = parcelRequire("aRjc0");

var $2QA6X = parcelRequire("2QA6X");

var $itbWq = parcelRequire("itbWq");

var $kirSA = parcelRequire("kirSA");
const $bc83504262104385$export$2964ea1cdd5afa39 = (0, $7NszV.createEntry)((0, $7wTzh.softwareBoardRoute), ()=>({
        group: 'software',
        skeleton: (0, $11dfA.NextGenBoardSkeleton),
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental-board'),
        layout: (0, $aPfsS.composeLayouts)((0, $e7bC3.softwareProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3Only),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResourceOnNav3Only),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $2QA6X.conditionalBoardResource),
            (0, $itbWq.conditionalCustomFiltersResource),
            (0, $5qQ9I.boardFilterRefinementResource),
            (0, $aRjc0.conditionalBoardRelayResource),
            (0, $4IqZT.conditionalBoardNBTOptInResource),
            (0, $5bkvv.forgeBoardModuleResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingEnabled)(), (0, $9V5k0.projectThemeResource))
        ],
        preloadOptions: {
            earlyChunks: [
                'software-board-early-entry'
            ]
        },
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        entryPoint: ()=>(0, $kirSA.softwareBoardPageEntrypoint),
        ufoName: 'next-gen-board',
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$f364828958cffad0)
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("7wTzh", function(module, exports) {

$parcel$export(module.exports, "softwareBoardRoute", () => $4f781bb234c1132b$export$9ae2c0a566d4e0f6);
const $4f781bb234c1132b$export$9ae2c0a566d4e0f6 = {
    name: 'software-boards',
    exact: true,
    path: '/jira/software/projects/:projectKey/boards/:boardId'
};

});

parcelRegister("11dfA", function(module, exports) {

$parcel$export(module.exports, "NextGenBoardSkeleton", () => $b1638a290dc4da1e$export$25a9d0fbcb127c90);
/* NextGenBoardSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $kNTTx = parcelRequire("kNTTx");
const $b1638a290dc4da1e$var$customCssStyles = null;
const $b1638a290dc4da1e$export$25a9d0fbcb127c90 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kNTTx))),
        className: (0, $bwpsq.default)([
            "_2zz1idpf"
        ])
    });

});
parcelRegister("kNTTx", function(module, exports) {
module.exports = new URL("next-gen-board-app-skeleton.tpl.d10f8ca5.svg", import.meta.url).toString();

});



parcelRegister("wwgc5", function(module, exports) {

$parcel$export(module.exports, "softwareBoardViewNotFoundClassicRouteEntry", () => $58fb43be4cabcab8$export$bdd0e204be6866cd);

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $4mEI2 = parcelRequire("4mEI2");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $hhqrL = parcelRequire("hhqrL");
const $58fb43be4cabcab8$export$bdd0e204be6866cd = (0, $7NszV.createEntry)((0, $4mEI2.softwareBoardViewNotFoundClassicRoute), ()=>({
        group: 'software',
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $hhqrL.boardViewNotFoundPageEntrypoint)
    }));

});
parcelRegister("4mEI2", function(module, exports) {

$parcel$export(module.exports, "softwareBoardViewNotFoundClassicRoute", () => $09300f0330e984d8$export$b31cf885abe93fbf);
const $09300f0330e984d8$export$b31cf885abe93fbf = {
    name: 'software-board-view-not-found-classic',
    exact: true,
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/not-found'
};

});

parcelRegister("hhqrL", function(module, exports) {

$parcel$export(module.exports, "boardViewNotFoundPageEntrypoint", () => $c49d7c07685117d8$export$7f51979492148d53);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $8cOrT = parcelRequire("8cOrT");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $fo6b8 = parcelRequire("fo6b8");

const $c49d7c07685117d8$var$main = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("j6L5g")), {
        moduleId: "83a02129",
        moduleName: "BoardViewNotFound",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const boardId = context.match.params.boardId;
        if (boardId == null) throw new Error('Board id missing');
        return {
            queries: {
                mainQuery: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $8cOrT.default,
                    variables: {
                        boardId: `ari:cloud:jira-software:${cloudId}:board/${boardId}`
                    }
                }
            }
        };
    }
});
const $c49d7c07685117d8$export$7f51979492148d53 = (0, $lkFvK.createPageEntryPoint)({
    main: $c49d7c07685117d8$var$main,
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("8cOrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9e82953f4eddfcb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<39b4c2382e9edb79ca18ee82cc3dcb5e>>
 * @relayHash c015acb85644d3bee5c8b2cb145b1d66
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 082161233dbd381be9ed014242444b47bd21443811aada3c5cc8c3c2e46e7c51
const $a9e82953f4eddfcb$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "082161233dbd381be9ed014242444b47bd21443811aada3c5cc8c3c2e46e7c51",
        "metadata": {},
        "name": "BoardViewNotFoundQuery",
        "operationKind": "query",
        "text": null
    }
};
var $a9e82953f4eddfcb$export$2e2bcd8739ae039 = $a9e82953f4eddfcb$var$node;

});

parcelRegister("j6L5g", function(module, exports) {

let $de9319c29aedad61$var$load = (parcelRequire("28QjX"))(4);
module.exports = $de9319c29aedad61$var$load("gM5js").then(()=>parcelRequire('bICXK'));

});



parcelRegister("eAw5v", function(module, exports) {

$parcel$export(module.exports, "softwareBoardViewNotFoundRouteEntry", () => $ed8d1bfb27dbc181$export$70fda0ba037c81ca);

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $aqDWp = parcelRequire("aqDWp");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $hhqrL = parcelRequire("hhqrL");
const $ed8d1bfb27dbc181$export$70fda0ba037c81ca = (0, $7NszV.createEntry)((0, $aqDWp.softwareBoardViewNotFoundRoute), ()=>({
        group: 'software',
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $hhqrL.boardViewNotFoundPageEntrypoint)
    }));

});
parcelRegister("aqDWp", function(module, exports) {

$parcel$export(module.exports, "softwareBoardViewNotFoundRoute", () => $d9228dcc50b0d701$export$4c5eaffb9e70d071);
const $d9228dcc50b0d701$export$4c5eaffb9e70d071 = {
    name: 'software-board-view-not-found',
    exact: true,
    path: '/jira/software/projects/:projectKey/boards/:boardId/not-found'
};

});


parcelRegister("djlm6", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarClassicEmbedRouteEntry", () => $dcd6d1616221fb9c$export$6a544072729c1964);

var $7NszV = parcelRequire("7NszV");

var $apHIk = parcelRequire("apHIk");

var $kZOse = parcelRequire("kZOse");

var $6e4Kt = parcelRequire("6e4Kt");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $2Ql51 = parcelRequire("2Ql51");

var $4R6GH = parcelRequire("4R6GH");

var $eQnNj = parcelRequire("eQnNj");
const $dcd6d1616221fb9c$export$6a544072729c1964 = (0, $7NszV.createEntry)((0, $apHIk.softwareCalendarClassicEmbedRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $kZOse.CalendarEmbedSkeleton),
        component: (0, $kZOse.CalendarEmbedSkeleton),
        entryPoint () {
            if (false) return undefined;
            return 0, $eQnNj.softwareCalendarRouteEntry;
        },
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $2Ql51.themePreferenceResource)
        ],
        ufoName: 'classic-calendar-embed',
        EXPERIMENTAL__shouldReload: (0, $4R6GH.fg)('jira_fix_calendar_suspending_when_switching_months') ? ({ context: context, prevContext: prevContext })=>{
            return context.match.url !== prevContext.match.url;
        } : undefined
    }));

});
parcelRegister("apHIk", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarClassicEmbedRoute", () => $4565df2ae20b6eec$export$ced2612fe5124ff8);
const $4565df2ae20b6eec$export$ced2612fe5124ff8 = {
    name: 'software-calendar-classic-embed',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/calendar/embed',
    query: [
        'date?'
    ]
};

});

parcelRegister("eQnNj", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarRouteEntry", () => $24d3258934ab0fe5$export$83b1b9036cc7961a);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $dQ4vn = parcelRequire("dQ4vn");

var $fo6b8 = parcelRequire("fo6b8");
const $24d3258934ab0fe5$export$83b1b9036cc7961a = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $dQ4vn.calendarEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("dQ4vn", function(module, exports) {

$parcel$export(module.exports, "calendarEntryPoint", () => $d8251bf369abb7ad$export$19cf4b398f638dc6);

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $7JhZX = parcelRequire("7JhZX");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");
const $d8251bf369abb7ad$var$SETTINGS_STORAGE_KEY = 'calendar:settings:software';
function $d8251bf369abb7ad$var$getViewSettings(key) {
    try {
        const serializedValue = globalThis.localStorage?.getItem(key);
        return serializedValue !== null ? JSON.parse(serializedValue) : undefined;
    } catch  {
        return undefined;
    }
}
function $d8251bf369abb7ad$var$toBoardAri({ siteId: siteId, boardId: boardId }) {
    return `ari:cloud:jira-software:${siteId}:board/${boardId}`;
}
function $d8251bf369abb7ad$var$toMidnightUTCString(date) {
    const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    return new Date(utcMilliseconds).toISOString();
}
function $d8251bf369abb7ad$var$toDate(date) {
    if (!date) return new Date();
    try {
        const _date = new Date(date);
        return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
    } catch (e) {
        return new Date();
    }
}
/* Given the current constraints that prevent importing route name constants into the entrypoint,
we are re-defining these constants here in order to perform a route name check.
Consider breaking this entrypoint per route to avoid these types of checks and dependencies. */ const $d8251bf369abb7ad$var$SOFTWARE_CALENDAR = 'software-calendar';
const $d8251bf369abb7ad$var$SOFTWARE_CALENDAR_EMBED = 'software-calendar-embed';
const $d8251bf369abb7ad$var$TEAM_MANAGED_CALENDAR_ROUTES = [
    $d8251bf369abb7ad$var$SOFTWARE_CALENDAR,
    $d8251bf369abb7ad$var$SOFTWARE_CALENDAR_EMBED
];
function $d8251bf369abb7ad$var$createScope({ context: context, tenantContext: tenantContext }) {
    const { cloudId: cloudId } = tenantContext;
    const isTMP = $d8251bf369abb7ad$var$TEAM_MANAGED_CALENDAR_ROUTES.includes(context.route.name);
    return {
        type: 'board',
        boardId: $d8251bf369abb7ad$var$toBoardAri({
            siteId: cloudId,
            boardId: String(context.match.params.boardId)
        }),
        projectKeys: isTMP ? [
            String(context.match.params.projectKey)
        ] : []
    };
}
function $d8251bf369abb7ad$var$buildScopeInput({ tenantContext: tenantContext }, scope) {
    const { cloudId: cloudId } = tenantContext;
    const scopeInput = {
        ids: [
            scope.boardId
        ]
    };
    if ((0, $4R6GH.fg)('jira_calendar_load_more_pagination') || scope.projectKeys && scope.projectKeys.length > 0) return {
        ...scopeInput,
        projectKeys: {
            cloudId: cloudId,
            keys: scope.projectKeys
        }
    };
    return scopeInput;
}
function $d8251bf369abb7ad$var$toViewMode(mode) {
    switch(mode){
        case 'week':
            return 'WEEK';
        case 'day':
            return 'DAY';
        default:
            return 'MONTH';
    }
}
function $d8251bf369abb7ad$var$toWeekStart(weekStart) {
    switch(weekStart){
        case 'monday':
            return 'MONDAY';
        case 'saturday':
            return 'SATURDAY';
        default:
            return 'SUNDAY';
    }
}
function $d8251bf369abb7ad$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField }) {
    return {
        date: $d8251bf369abb7ad$var$toMidnightUTCString(selectedDate),
        mode: $d8251bf369abb7ad$var$toViewMode(viewRange),
        weekStart: $d8251bf369abb7ad$var$toWeekStart(weekStartsOn),
        startDateField: startDateField,
        endDateField: endDateField,
        viewId: null
    };
}
function $d8251bf369abb7ad$var$buildIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}
function $d8251bf369abb7ad$var$buildUnscheduledIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}
function $d8251bf369abb7ad$var$buildVersionsSearchInput() {
    return {
        versionStatuses: [
            'RELEASED',
            'UNRELEASED'
        ]
    };
}
function $d8251bf369abb7ad$var$buildSprintsSearchInput() {
    return {
        sprintStates: [
            'ACTIVE',
            'FUTURE',
            'CLOSED'
        ]
    };
}

const $d8251bf369abb7ad$export$19cf4b398f638dc6 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("hLauq")), {
        moduleId: "57ee20a5",
        priority: "userVisible"
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
        const { cloudId: cloudId } = tenantContext;
        const scope = $d8251bf369abb7ad$var$createScope(entryPointRouteParams);
        const { date: date } = context.query;
        const selectedDate = $d8251bf369abb7ad$var$toDate(date);
        const boardId = String(context.match.params.boardId);
        const settings = (0, $4R6GH.fg)('jira_calendar_load_more_pagination') ? $d8251bf369abb7ad$var$getViewSettings($d8251bf369abb7ad$var$SETTINGS_STORAGE_KEY) : undefined;
        const viewRange = 'month';
        const weekStartsOn = (0, $4R6GH.fg)('jira_calendar_load_more_pagination') ? settings?.weekStartsOn ?? 'sunday' : 'sunday';
        const startDateField = 'startdate';
        const endDateField = 'duedate';
        const issueEventFields = {
            startDateField: startDateField,
            endDateField: endDateField
        };
        return {
            queries: {
                calendarData: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $7JhZX.default,
                    variables: {
                        cloudId: cloudId,
                        scopeInput: $d8251bf369abb7ad$var$buildScopeInput(entryPointRouteParams, scope),
                        configurationInput: $d8251bf369abb7ad$var$buildConfigurationInput({
                            selectedDate: selectedDate,
                            viewRange: viewRange,
                            weekStartsOn: weekStartsOn,
                            startDateField: startDateField,
                            endDateField: endDateField
                        }),
                        issuesPageSize: (0, $4R6GH.fg)('jira_calendar_lazy_load') ? 200 : 50,
                        issuesSearchInput: $d8251bf369abb7ad$var$buildIssuesSearchInput(),
                        unscheduledIssuesSearchInput: $d8251bf369abb7ad$var$buildUnscheduledIssuesSearchInput(),
                        versionsSearchInput: $d8251bf369abb7ad$var$buildVersionsSearchInput(),
                        sprintsSearchInput: $d8251bf369abb7ad$var$buildSprintsSearchInput(),
                        includeRecurrenceIndicator: (0, $6s1PB.expValEquals)('jira-recur-single-work-item-on-schedule', 'isRecurrenceCalendarViewEnabled', true),
                        skipSprintSearch: false,
                        viewId: null,
                        schedulePermissionsEnabled: (0, $4R6GH.fg)('calendar_schedule_issue_permissions_check'),
                        pageLoadMoreEnabled: (0, $4R6GH.fg)('jira_calendar_load_more_pagination'),
                        skipVersionsV1Search: (0, $4R6GH.fg)('plan-calendar-versions-v2-adoption'),
                        skipVersionsV2Search: !(0, $4R6GH.fg)('plan-calendar-versions-v2-adoption'),
                        pageLoadMoreEnabledViewSettings: (0, $4R6GH.fg)('jira_calendar_load_more_pagination_view_settings')
                    }
                }
            },
            entryPoints: {},
            extraProps: {
                scope: scope,
                selectedDate: selectedDate,
                viewRange: viewRange,
                weekStartsOn: weekStartsOn,
                issueEventFields: issueEventFields,
                boardId: boardId,
                hasRecurrenceItemIndicator: (0, $6s1PB.expValEquals)('jira-recur-single-work-item-on-schedule', 'isRecurrenceCalendarViewEnabled', true)
            }
        };
    }
});

});
parcelRegister("hLauq", function(module, exports) {

let $cedef683fe3d6740$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $cedef683fe3d6740$var$load("ffQaD"),
    $cedef683fe3d6740$var$load("kvRbA"),
    $cedef683fe3d6740$var$load("76n7a"),
    $cedef683fe3d6740$var$load("l253H"),
    $cedef683fe3d6740$var$load("f4bCw")
]).then(()=>parcelRequire('71XRW'));

});




parcelRegister("3J8Cl", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarClassicRouteEntry", () => $784ebb96624ec7cf$export$17ea82bdc641d5ce);

var $7NszV = parcelRequire("7NszV");

var $4R6GH = parcelRequire("4R6GH");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $501Vn = parcelRequire("501Vn");

var $kZOse = parcelRequire("kZOse");

var $aPfsS = parcelRequire("aPfsS");

var $e7bC3 = parcelRequire("e7bC3");

var $g5RGc = parcelRequire("g5RGc");

var $lmyls = parcelRequire("lmyls");

var $9s3j1 = parcelRequire("9s3j1");

var $5f2bR = parcelRequire("5f2bR");

var $3RJkv = parcelRequire("3RJkv");

var $fKmub = parcelRequire("fKmub");

var $ffza4 = parcelRequire("ffza4");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");

var $eQnNj = parcelRequire("eQnNj");
const $784ebb96624ec7cf$export$17ea82bdc641d5ce = (0, $7NszV.createEntry)((0, $501Vn.softwareCalendarClassicRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $kZOse.CalendarSkeleton),
        component: (0, $kZOse.CalendarSkeleton),
        entryPoint () {
            if (false) return undefined;
            return 0, $eQnNj.softwareCalendarRouteEntry;
        },
        layout: (0, $aPfsS.composeLayouts)((0, $e7bC3.classicSoftwareProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingEnabled)(), (0, $9V5k0.projectThemeResource))
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ],
        ufoName: 'classic-calendar',
        EXPERIMENTAL__shouldReload: (0, $4R6GH.fg)('jira_fix_calendar_suspending_when_switching_months') ? ({ context: context, prevContext: prevContext })=>{
            return context.match.url !== prevContext.match.url;
        } : undefined,
        supportsPreviewPanel: true
    }));

});
parcelRegister("501Vn", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarClassicRoute", () => $ad58dc33708a3879$export$f2c3b99639d54eb8);
const $ad58dc33708a3879$export$f2c3b99639d54eb8 = {
    name: 'software-calendar-classic',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/calendar',
    query: [
        'date?'
    ]
};

});


parcelRegister("kutfD", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarEmbedRouteEntry", () => $99cba918a9dd41cf$export$24fc07c22f0d06);

var $6e4Kt = parcelRequire("6e4Kt");

var $4R6GH = parcelRequire("4R6GH");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $7NszV = parcelRequire("7NszV");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $2Ql51 = parcelRequire("2Ql51");

var $1oC4O = parcelRequire("1oC4O");

var $kZOse = parcelRequire("kZOse");

var $4p1Sa = parcelRequire("4p1Sa");
const $99cba918a9dd41cf$export$24fc07c22f0d06 = (0, $7NszV.createEntry)((0, $1oC4O.softwareCalendarEmbedRoute), ()=>({
        group: 'software',
        skeleton: (0, $kZOse.CalendarEmbedSkeleton),
        component: (0, $kZOse.CalendarEmbedSkeleton),
        entryPoint () {
            if (false) return undefined;
            return 0, $4p1Sa.calendarRouteEntry;
        },
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $2Ql51.themePreferenceResource)
        ],
        ufoName: 'next-gen-calendar-embed',
        EXPERIMENTAL__shouldReload: (0, $4R6GH.fg)('jira_fix_calendar_suspending_when_switching_months') ? ({ context: context, prevContext: prevContext })=>{
            return context.match.url !== prevContext.match.url;
        } : undefined
    }));

});
parcelRegister("1oC4O", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarEmbedRoute", () => $e9efd1396eb47ddd$export$b55c4d4efb097c1c);
const $e9efd1396eb47ddd$export$b55c4d4efb097c1c = {
    name: 'software-calendar-embed',
    path: '/jira/software/projects/:projectKey/boards/:boardId/calendar/embed',
    query: [
        'date?'
    ]
};

});

parcelRegister("4p1Sa", function(module, exports) {

$parcel$export(module.exports, "calendarRouteEntry", () => $a85dcaa61158a1a3$export$d154630e8966be91);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $dQ4vn = parcelRequire("dQ4vn");

var $fo6b8 = parcelRequire("fo6b8");
const $a85dcaa61158a1a3$export$d154630e8966be91 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $dQ4vn.calendarEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});


parcelRegister("2z6Z2", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarRouteEntry", () => $31f17a935a7b6ad5$export$83b1b9036cc7961a);

var $ffza4 = parcelRequire("ffza4");

var $4R6GH = parcelRequire("4R6GH");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $582IH = parcelRequire("582IH");

var $kZOse = parcelRequire("kZOse");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");

var $4p1Sa = parcelRequire("4p1Sa");
const $31f17a935a7b6ad5$export$83b1b9036cc7961a = (0, $7NszV.createEntry)((0, $582IH.softwareCalendarRoute), ()=>({
        group: 'software',
        skeleton: (0, $kZOse.CalendarSkeleton),
        component: (0, $kZOse.CalendarSkeleton),
        entryPoint () {
            if (false) return undefined;
            return 0, $4p1Sa.calendarRouteEntry;
        },
        layout: (0, $aPfsS.composeLayouts)((0, $e7bC3.softwareProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingEnabled)(), (0, $9V5k0.projectThemeResource))
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ],
        ufoName: 'next-gen-calendar',
        EXPERIMENTAL__shouldReload: (0, $4R6GH.fg)('jira_fix_calendar_suspending_when_switching_months') ? ({ context: context, prevContext: prevContext })=>{
            return context.match.url !== prevContext.match.url;
        } : undefined,
        supportsPreviewPanel: true
    }));

});
parcelRegister("582IH", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarRoute", () => $8d2c5695d9358265$export$d6730f103a4ad844);
const $8d2c5695d9358265$export$d6730f103a4ad844 = {
    name: 'software-calendar',
    path: '/jira/software/projects/:projectKey/boards/:boardId/calendar',
    query: [
        'date?'
    ]
};

});


parcelRegister("knZRG", function(module, exports) {

$parcel$export(module.exports, "softwareClassicProformaIssueFormsDirectEmbedRouteEntry", () => $e9a0be7e929de3ec$export$fdc2679a6c96e9fa);

var $7NszV = parcelRequire("7NszV");

var $dxCvy = parcelRequire("dxCvy");

var $kHaoU = parcelRequire("kHaoU");

var $6e4Kt = parcelRequire("6e4Kt");

var $33P3A = parcelRequire("33P3A");
const $e9a0be7e929de3ec$export$fdc2679a6c96e9fa = (0, $7NszV.createEntry)((0, $kHaoU.softwareClassicProformaIssueFormsDirectEmbedRoute), ()=>({
        group: 'classic-software',
        component: (0, $33P3A.default),
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            (0, $dxCvy.projectContextResource)
        ],
        forPaint: [
            (0, $33P3A.LazyProformaIssueFormsDirectEmbed)
        ],
        perfMetricKey: 'issue-forms-direct-embed'
    }));

});
parcelRegister("kHaoU", function(module, exports) {

$parcel$export(module.exports, "softwareClassicProformaIssueFormsDirectEmbedRoute", () => $e5452599d7d96b18$export$16987cdd084cceba);
const $e5452599d7d96b18$export$16987cdd084cceba = {
    name: 'classic-software-proforma-issue-forms-direct-embed',
    path: '/jira/software/c/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?/embed',
    exact: true
};

});

parcelRegister("33P3A", function(module, exports) {

$parcel$export(module.exports, "LazyProformaIssueFormsDirectEmbed", () => $a96f990777917c84$export$22681210aaeb910f);
$parcel$export(module.exports, "default", () => $a96f990777917c84$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $a96f990777917c84$export$22681210aaeb910f = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("8yRRM")), {
    moduleId: "./src/packages/spa-apps/proforma-issue-forms-direct-embed/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a96f990777917c84$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $a96f990777917c84$export$22681210aaeb910f,
        pageId: "proforma-issue-forms-direct-embed",
        shouldShowSpinner: true
    });

});


parcelRegister("hUUCw", function(module, exports) {

$parcel$export(module.exports, "softwareClassicProformaIssueFormsDirectRouteEntry", () => $d4fc432d647b5f41$export$8fd8b0cbd2b8730d);

var $7NszV = parcelRequire("7NszV");

var $lmyls = parcelRequire("lmyls");

var $bQgMC = parcelRequire("bQgMC");

var $e7bC3 = parcelRequire("e7bC3");

var $dxCvy = parcelRequire("dxCvy");

var $13pw2 = parcelRequire("13pw2");
const $d4fc432d647b5f41$export$8fd8b0cbd2b8730d = (0, $7NszV.createEntry)((0, $bQgMC.softwareClassicProformaIssueFormsDirectRoute), ()=>({
        group: 'classic-software',
        layout: (0, $e7bC3.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        resources: [
            (0, $dxCvy.projectContextResource)
        ],
        entryPoint: ()=>(0, $13pw2.proformaIssueFormsDirectPageEntryPoint),
        perfMetricKey: 'issue-forms-direct'
    }));

});
parcelRegister("bQgMC", function(module, exports) {

$parcel$export(module.exports, "softwareClassicProformaIssueFormsDirectRoute", () => $a29107263e83fc90$export$92f34907c6bf7007);
const $a29107263e83fc90$export$92f34907c6bf7007 = {
    name: 'classic-software-proforma-issue-forms-direct',
    path: '/jira/software/c/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?',
    exact: true
};

});

parcelRegister("13pw2", function(module, exports) {

$parcel$export(module.exports, "proformaIssueFormsDirectPageEntryPoint", () => $480a54898b863a19$export$dc0bb5719ae7aab4);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $1aJjB = parcelRequire("1aJjB");
const $480a54898b863a19$export$dc0bb5719ae7aab4 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1aJjB.proformaIssueFormsDirectEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});


parcelRegister("6B4GJ", function(module, exports) {

$parcel$export(module.exports, "softwareCodeClassicRouteEntry", () => $7aa05f37015fe3d2$export$6acfada96c85cfaa);

var $7NszV = parcelRequire("7NszV");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $lmyls = parcelRequire("lmyls");

var $5f2bR = parcelRequire("5f2bR");

var $3RJkv = parcelRequire("3RJkv");

var $7uLIV = parcelRequire("7uLIV");

var $ffza4 = parcelRequire("ffza4");

var $cu9WL = parcelRequire("cu9WL");

var $iZ82x = parcelRequire("iZ82x");

var $7XYc4 = parcelRequire("7XYc4");

var $kfztd = parcelRequire("kfztd");

var $5lsNZ = parcelRequire("5lsNZ");

var $e7bC3 = parcelRequire("e7bC3");

var $9s3j1 = parcelRequire("9s3j1");

var $4R6GH = parcelRequire("4R6GH");

var $6LsQE = parcelRequire("6LsQE");

var $brJ9B = parcelRequire("brJ9B");

var $6Kmkr = parcelRequire("6Kmkr");
const $7aa05f37015fe3d2$var$getHorizontalNavResource = ()=>(0, $4R6GH.fg)('entrypoint_migration_for_software_code') ? [] : [
        (0, $7uLIV.horizontalNavJiraResource)
    ];
const $7aa05f37015fe3d2$export$6acfada96c85cfaa = (0, $7NszV.createEntry)((0, $cu9WL.softwareCodeClassicRoute), ()=>({
        group: 'classic-software',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            ...$7aa05f37015fe3d2$var$getHorizontalNavResource(),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $iZ82x.codePageResource)
        ],
        component: (0, $7XYc4.componentWithCondition)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $6Kmkr.CodePageClassic)),
        layout: (0, $e7bC3.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6Kmkr.LazyCode)
        ],
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('entrypoint_migration_for_software_code')) return (0, $kfztd.isDevopsFeatureDisabledInFedRamp)() ? (0, $6LsQE.notFoundPageEntrypoint) : (0, $brJ9B.softwareCodeClassicPageEntrypoint);
            return undefined;
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("cu9WL", function(module, exports) {

$parcel$export(module.exports, "softwareCodeClassicRoute", () => $7462b5ebecb54ef7$export$d92cd77785d00ff);
const $7462b5ebecb54ef7$export$d92cd77785d00ff = {
    name: 'software-code-classic',
    path: '/jira/software/c/projects/:projectKey/code'
};

});

parcelRegister("iZ82x", function(module, exports) {

$parcel$export(module.exports, "codePageResource", () => $06e9ff5230710b90$export$642ce64cf3689406);

var $ao2h1 = parcelRequire("ao2h1");

var $euUUL = parcelRequire("euUUL");

var $6mT2K = parcelRequire("6mT2K");

let $06e9ff5230710b90$var$numPullRequestsToFetch = 0;
const $06e9ff5230710b90$export$642ce64cf3689406 = (0, $ao2h1.createRelayResource)({
    type: (0, $96625f88cf395132$export$94a43d2ac55ac375),
    getQuery ({ match: { params: params }, query: query, route: { name: name } }, { tenantContext: { cloudId: cloudId } }) {
        const isCodeRoute = name === 'software-code' || name === 'software-code-classic';
        // Set numPullRequestsToFetch on initial call only and not on every query param change
        if (!$06e9ff5230710b90$var$numPullRequestsToFetch && isCodeRoute) $06e9ff5230710b90$var$numPullRequestsToFetch = (0, $6mT2K.getNumPullRequestsToFetch)(query);
        // Reset numPullRequestsToFetch when navigating away from the code page
        if (!isCodeRoute) $06e9ff5230710b90$var$numPullRequestsToFetch = 0;
        return {
            parameters: (0, $euUUL.default),
            options: {
                fetchPolicy: 'store-and-network'
            },
            variables: {
                cloudId: cloudId,
                projectKey: params.projectKey ?? '',
                pullRequestsUpdatedFrom: (0, $6mT2K.getPullRequestsUpdatedFromDate)(),
                numPullRequestsToFetch: $06e9ff5230710b90$var$numPullRequestsToFetch,
                siteAri: `ari:cloud:jira::site/${cloudId}`
            }
        };
    }
});

});
parcelRegister("euUUL", function(module, exports) {

$parcel$export(module.exports, "default", () => $1914e75096664626$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9e4d6b6379280bbf391f7e2d315a8c2a>>
 * @relayHash 389fdeea048c66525e3cec717b045093
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 065a174c5747d32e4ac04da08516b772ae16f6995b07756d19cd3af74fa4c4bb
const $1914e75096664626$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "numPullRequestsToFetch"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pullRequestsUpdatedFrom"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "siteAri"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "siteAri"
        },
        {
            "kind": "Literal",
            "name": "providerTypes",
            "value": [
                "DEV_INFO"
            ]
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v9 = [
        v8 /*: any*/ 
    ], v10 = {
        "kind": "ScalarField",
        "name": "status"
    }, v11 = {
        "concreteType": "JiraConfigStateConnection",
        "kind": "LinkedField",
        "name": "config",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraConfigState",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "appId"
                    },
                    v10 /*: any*/ 
                ]
            }
        ]
    }, v12 = [
        v11 /*: any*/ 
    ], v13 = [
        v7 /*: any*/ 
    ], v14 = [
        {
            "kind": "Literal",
            "name": "appId",
            "value": "bitbucket"
        },
        v8 /*: any*/ 
    ], v15 = [
        v8 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v16 = [
        {
            "kind": "Literal",
            "name": "sort",
            "value": {
                "lastModified": {
                    "direction": "DESC",
                    "priority": 1
                }
            }
        }
    ], v17 = {
        "kind": "ScalarField",
        "name": "id"
    }, v18 = [
        v11 /*: any*/ ,
        v17 /*: any*/ 
    ], v19 = {
        "kind": "ScalarField",
        "name": "lastUpdated"
    }, v20 = {
        "kind": "ScalarField",
        "name": "url"
    }, v21 = [
        v17 /*: any*/ 
    ], v22 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v23 = [
        v7 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "accountId"
        },
        v6 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "picture"
        },
        v17 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainCodeInJiraUpdatedQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "DevOps",
                        "kind": "LinkedField",
                        "name": "devOps",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "DevOpsProviders",
                                    "kind": "LinkedField",
                                    "name": "providers",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "DevOpsDevInfoProvider",
                                            "kind": "LinkedField",
                                            "name": "devInfoProviders",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                {
                                                    "args": v9 /*: any*/ ,
                                                    "concreteType": "JiraAppConfigState",
                                                    "kind": "LinkedField",
                                                    "name": "configState",
                                                    "plural": false,
                                                    "selections": v12 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "devOps.providers"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "devOps"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v9 /*: any*/ ,
                        "concreteType": "CodeInJira",
                        "kind": "LinkedField",
                        "name": "codeInJira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "CodeInJiraUserConfiguration",
                                    "kind": "LinkedField",
                                    "name": "userConfiguration",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CodeInJiraBitbucketWorkspace",
                                                "kind": "LinkedField",
                                                "name": "ownedBitbucketWorkspaces",
                                                "plural": true,
                                                "selections": v13 /*: any*/ 
                                            },
                                            "action": "THROW",
                                            "path": "codeInJira.userConfiguration.ownedBitbucketWorkspaces"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "codeInJira.userConfiguration"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "codeInJira"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraDevOpsQuery",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v14 /*: any*/ ,
                                    "concreteType": "JiraAppConfigState",
                                    "kind": "LinkedField",
                                    "name": "configState",
                                    "plural": false,
                                    "selections": v12 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "args": v15 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v16 /*: any*/ ,
                                    "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoConnection",
                                    "kind": "LinkedField",
                                    "name": "repositories",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v13 /*: any*/ 
                                        }
                                    ],
                                    "storageKey": "repositories(sort:{\"lastModified\":{\"direction\":\"DESC\",\"priority\":1}})"
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "FragmentSpread",
                    "name": "main_softwareCodePage_MainPage"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "main_softwareCodePage_Header"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "main_softwareCodePage_ConnectionPage"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainCodeInJiraUpdatedQuery",
            "selections": [
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "DevOpsProviders",
                            "kind": "LinkedField",
                            "name": "providers",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "DevOpsDevInfoProvider",
                                    "kind": "LinkedField",
                                    "name": "devInfoProviders",
                                    "plural": true,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "args": v9 /*: any*/ ,
                                            "concreteType": "JiraAppConfigState",
                                            "kind": "LinkedField",
                                            "name": "configState",
                                            "plural": false,
                                            "selections": v18 /*: any*/ 
                                        },
                                        v17 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "homeUrl"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "namespace"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "CodeInJira",
                    "kind": "LinkedField",
                    "name": "codeInJira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "CodeInJiraUserConfiguration",
                            "kind": "LinkedField",
                            "name": "userConfiguration",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CodeInJiraBitbucketWorkspace",
                                    "kind": "LinkedField",
                                    "name": "ownedBitbucketWorkspaces",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "uuid"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "slug"
                                        },
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraDevOpsQuery",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v14 /*: any*/ ,
                                    "concreteType": "JiraAppConfigState",
                                    "kind": "LinkedField",
                                    "name": "configState",
                                    "plural": false,
                                    "selections": v18 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "args": v15 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v16 /*: any*/ ,
                                    "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoConnection",
                                    "kind": "LinkedField",
                                    "name": "repositories",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v17 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "providerId"
                                                                },
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "avatarUrl"
                                                                },
                                                                v20 /*: any*/ 
                                                            ],
                                                            "type": "DevOpsRepository"
                                                        },
                                                        v22 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "repositories(sort:{\"lastModified\":{\"direction\":\"DESC\",\"priority\":1}})"
                                },
                                v17 /*: any*/ ,
                                {
                                    "args": [
                                        {
                                            "fields": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "updatedFrom",
                                                    "variableName": "pullRequestsUpdatedFrom"
                                                }
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "filter"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "first",
                                            "variableName": "numPullRequestsToFetch"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "sort",
                                            "value": {
                                                "lastUpdatedSortDirection": "DESC"
                                            }
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "project-associated-pr"
                                        }
                                    ],
                                    "concreteType": "AriGraphRelationshipConnection",
                                    "kind": "LinkedField",
                                    "name": "devOpsEntityRelationships",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "AriGraphRelationshipEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationship",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AriGraphRelationshipNode",
                                                            "kind": "LinkedField",
                                                            "name": "to",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v10 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "repositoryName"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "repositoryId"
                                                                                },
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "author",
                                                                                    "plural": false,
                                                                                    "selections": v23 /*: any*/ 
                                                                                },
                                                                                {
                                                                                    "concreteType": "DevOpsReviewer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "reviewers",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "user",
                                                                                            "plural": false,
                                                                                            "selections": v23 /*: any*/ 
                                                                                        },
                                                                                        v7 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "approvalStatus"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "userId"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "title"
                                                                                },
                                                                                v17 /*: any*/ ,
                                                                                v19 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "commentCount"
                                                                                },
                                                                                v20 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "DevOpsBranchInfo",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "destinationBranch",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        v20 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "pullRequestInternalId"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "repositoryUrl"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "authorId"
                                                                                }
                                                                            ],
                                                                            "type": "DevOpsPullRequestDetails"
                                                                        },
                                                                        v22 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "DevOpsFeatureFlag"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "DevOpsOperationsComponentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "DevOpsOperationsIncidentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "DevOpsOperationsPostIncidentReviewDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "DevOpsRepository"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "DevOpsSecurityVulnerabilityDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "JiraAutodevJob"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "JiraConfluenceRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "JiraCustomRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "JiraIssueRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "JiraWebRemoteIssueLink"
                                                                        }
                                                                    ]
                                                                },
                                                                v17 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "065a174c5747d32e4ac04da08516b772ae16f6995b07756d19cd3af74fa4c4bb",
            "metadata": {},
            "name": "mainCodeInJiraUpdatedQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1914e75096664626$var$node.hash = "e7b0f6a6904c8a1f0dcd2b6cc16ebe99";
var $1914e75096664626$export$2e2bcd8739ae039 = $1914e75096664626$var$node;

});

parcelRegister("6mT2K", function(module, exports) {

$parcel$export(module.exports, "isBitbucketProvider", () => $e46b745b21c77b2f$export$1f508885be28c4e);
$parcel$export(module.exports, "codeErrorBoundaryAttributes", () => $e46b745b21c77b2f$export$ea10bb8bdf2072e5);
$parcel$export(module.exports, "toSanitizedUrl", () => $e46b745b21c77b2f$export$36fdccbdcd093523);
$parcel$export(module.exports, "useIsOverflowWidth", () => $e46b745b21c77b2f$export$2dcd60313c8d761b);
$parcel$export(module.exports, "getPullRequestsUpdatedFromDate", () => $e46b745b21c77b2f$export$3784bdf6b4807521);
$parcel$export(module.exports, "getNumPullRequestsToFetch", () => $e46b745b21c77b2f$export$a837c7c9c7670570);

var $5uXOq = parcelRequire("5uXOq");

var $5kchp = parcelRequire("5kchp");

var $it1wb = parcelRequire("it1wb");
var $gn1v9 = parcelRequire("gn1v9");

var $eY2eW = parcelRequire("eY2eW");

var $1tSBh = parcelRequire("1tSBh");
const $e46b745b21c77b2f$export$36ebc9cd52c6b517 = (repository)=>repository === (0, $1tSBh.RepositoryTypes).REPO_BITBUCKET;
const $e46b745b21c77b2f$export$1f508885be28c4e = (providerId)=>providerId === (0, $eY2eW.VcsProviderIds).BITBUCKET || providerId === (0, $eY2eW.DataDepotProviderIds).BITBUCKET_PROD || providerId === (0, $eY2eW.DataDepotProviderIds).BITBUCKET_STG;
const $e46b745b21c77b2f$var$shouldCountToReliability = (error)=>{
    const okayErrors = [
        ...(0, $eY2eW.nonCriticalGqlErrors),
        ...(0, $eY2eW.nonReliabilityCriticalErrors)
    ];
    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"HTTP status [403] while retrieving Bitbucket repository." | "HTTP status [404] while retrieving Bitbucket repository." | "Failed to retrieve Bitbucket repository because the user wasn't authorized." | "HTTP status [429] while retrieving Bitbucket repository." | "The user does not have 'View Development Tools' permi...'.
    return !okayErrors.includes(error.message);
};
const $e46b745b21c77b2f$export$ea10bb8bdf2072e5 = (error)=>{
    if (error instanceof Error) return {
        countToReliability: $e46b745b21c77b2f$var$shouldCountToReliability(error)
    };
    return {
        countToReliability: true
    };
};
const $e46b745b21c77b2f$export$36fdccbdcd093523 = (url)=>(0, $5kchp.sanitizeUrl)(url);
const $e46b745b21c77b2f$export$2dcd60313c8d761b = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
ref, callback)=>{
    const [isOverflow, setIsOverflow] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useLayoutEffect)(()=>{
        const { current: current } = ref;
        const trigger = ()=>{
            const hasOverflow = current.scrollWidth > current.clientWidth;
            setIsOverflow(hasOverflow);
            if (callback) callback(hasOverflow);
        };
        if (current) {
            if ('ResizeObserver' in window) new ResizeObserver(trigger).observe(current);
            trigger();
        }
    }, [
        callback,
        ref
    ]);
    return isOverflow;
};
const $e46b745b21c77b2f$export$3784bdf6b4807521 = ()=>(0, $it1wb.default)((0, $gn1v9.default)(new Date(), {
        days: (0, $eY2eW.PULL_REQUESTS_UPDATED_FROM_NUMBER_OF_DAYS)
    })).toISOString();
const $e46b745b21c77b2f$export$a837c7c9c7670570 = (queryParams)=>{
    const hasFilterOrSortQueryParam = Object.entries(queryParams).some(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ([key, value])=>(0, $eY2eW.queryParamsToWatch).includes(key) && value !== '');
    return hasFilterOrSortQueryParam ? (0, $eY2eW.MAX_NUMBER_OF_PULL_REQUESTS_TO_QUERY) : (0, $eY2eW.PULL_REQUESTS_TABLE_PAGE_SIZE);
};

});
parcelRegister("5kchp", function(module, exports) {
'use strict';
var $3e0858899f98084b$var$invalidPrototcolRegex = /^(%20|\s)*(javascript|data)/im;
var $3e0858899f98084b$var$ctrlCharactersRegex = /[^\x20-\x7E]/gmi;
var $3e0858899f98084b$var$urlSchemeRegex = /^([^:]+):/gm;
var $3e0858899f98084b$var$relativeFirstCharacters = [
    '.',
    '/'
];
function $3e0858899f98084b$var$isRelativeUrl(url) {
    return $3e0858899f98084b$var$relativeFirstCharacters.indexOf(url[0]) > -1;
}
function $3e0858899f98084b$var$sanitizeUrl(url) {
    if (!url) return 'about:blank';
    var urlScheme, urlSchemeParseResults;
    var sanitizedUrl = url.replace($3e0858899f98084b$var$ctrlCharactersRegex, '');
    if ($3e0858899f98084b$var$isRelativeUrl(sanitizedUrl)) return sanitizedUrl;
    urlSchemeParseResults = sanitizedUrl.match($3e0858899f98084b$var$urlSchemeRegex);
    if (!urlSchemeParseResults) return 'about:blank';
    urlScheme = urlSchemeParseResults[0];
    if ($3e0858899f98084b$var$invalidPrototcolRegex.test(urlScheme)) return 'about:blank';
    return sanitizedUrl;
}
module.exports = {
    sanitizeUrl: $3e0858899f98084b$var$sanitizeUrl
};

});

parcelRegister("eY2eW", function(module, exports) {

$parcel$export(module.exports, "nonCriticalGqlErrors", () => $a2f3556545768e94$export$4b1abe4db5ed7515);
$parcel$export(module.exports, "nonReliabilityCriticalErrors", () => $a2f3556545768e94$export$687544614e0812da);
$parcel$export(module.exports, "MAX_NUMBER_OF_PULL_REQUESTS_TO_QUERY", () => $a2f3556545768e94$export$f84c6b6609a3dd30);
$parcel$export(module.exports, "PULL_REQUESTS_TABLE_PAGE_SIZE", () => $a2f3556545768e94$export$ea15b38f3901f518);
$parcel$export(module.exports, "PULL_REQUESTS_UPDATED_FROM_NUMBER_OF_DAYS", () => $a2f3556545768e94$export$2b8b0a4489f9147b);
$parcel$export(module.exports, "COLLAPSIBLE_REGION_ID", () => $a2f3556545768e94$export$3b8f88133d28aaa6);
$parcel$export(module.exports, "REPOSITORIES_HEADER_ID", () => $a2f3556545768e94$export$256a9f141103f328);
$parcel$export(module.exports, "COLLAPSIBLE_REGION_DESCRIPTION_ID", () => $a2f3556545768e94$export$b0d4e90e40369b80);
$parcel$export(module.exports, "featureIdToHelpMap", () => $a2f3556545768e94$export$1de4eaccc23a8747);
$parcel$export(module.exports, "FILTER_CONTAINER_TEST_ID", () => $a2f3556545768e94$export$5c00a6bedc2037c8);
$parcel$export(module.exports, "NO_RESULTS_CLEAR_FILTERS_BUTTON_TEST_ID", () => $a2f3556545768e94$export$f70ce14ba902adcb);
$parcel$export(module.exports, "PULL_REQUESTS_TABLE_TEST_ID", () => $a2f3556545768e94$export$19381ed4387aa05b);
$parcel$export(module.exports, "PULL_REQUESTS_DYNAMIC_TABLE_TEST_ID", () => $a2f3556545768e94$export$f3e116f999d4c5c1);
$parcel$export(module.exports, "PULL_REQUESTS_EMPTY_STATE_TEST_ID", () => $a2f3556545768e94$export$c28f1cd40ae0394c);
$parcel$export(module.exports, "SUMMARY_CELL_TEST_ID", () => $a2f3556545768e94$export$f69d7aa9c5e17d55);
$parcel$export(module.exports, "SUMMARY_CELL_TITLE_LINK_TEST_ID", () => $a2f3556545768e94$export$4ed9a8a7faf641f);
$parcel$export(module.exports, "SUMMARY_CELL_TARGET_BRANCH_LINK_TEST_ID", () => $a2f3556545768e94$export$c5322e755fd1028d);
$parcel$export(module.exports, "SUMMARY_CELL_REPOSITORY_LINK_TEST_ID", () => $a2f3556545768e94$export$72fcd104fde041d6);
$parcel$export(module.exports, "REVIEWERS_CELL_TEST_ID", () => $a2f3556545768e94$export$d8f600a480a9c2d4);
$parcel$export(module.exports, "STATUS_CELL_TEST_ID", () => $a2f3556545768e94$export$9d9ab707c4e446cc);
$parcel$export(module.exports, "COMMENTS_CELL_TEST_ID", () => $a2f3556545768e94$export$4da3056fdbfaf111);
$parcel$export(module.exports, "LAST_UPDATED_CELL_TEST_ID", () => $a2f3556545768e94$export$e1134688b6a1032);
$parcel$export(module.exports, "PULL_REQUESTS_ERROR_STATE_TEST_ID", () => $a2f3556545768e94$export$143249aa50321d51);
$parcel$export(module.exports, "REPOSITORIES_ERROR_STATE_TEST_ID", () => $a2f3556545768e94$export$a46febdd3fe90de0);
$parcel$export(module.exports, "IMPROVED_SCM_CONFIG_SCREEN_ERROR_TEST_ID", () => $a2f3556545768e94$export$333db4cac7ee017);
$parcel$export(module.exports, "IMPROVE_READY_TO_CONNECT_EMPTY_STATE_TEST_ID", () => $a2f3556545768e94$export$5cbae081959768bd);
$parcel$export(module.exports, "REPOSITORIES_FILTER_BUTTON_TEST_ID", () => $a2f3556545768e94$export$4939c117ba49bc9e);
$parcel$export(module.exports, "AUTHOR_FILTER_BUTTON_TEST_ID", () => $a2f3556545768e94$export$5a92d7579dac6294);
$parcel$export(module.exports, "REVIEWERS_FILTER_BUTTON_TEST_ID", () => $a2f3556545768e94$export$a77ea162c15f0290);
$parcel$export(module.exports, "STATUS_FILTER_BUTTON_TEST_ID", () => $a2f3556545768e94$export$b7477204cae64b46);
$parcel$export(module.exports, "QUERY_PARAM_SUMMARY", () => $a2f3556545768e94$export$39983b6fb040a5eb);
$parcel$export(module.exports, "QUERY_PARAM_AUTHORS", () => $a2f3556545768e94$export$3d96f5f9ccd35be6);
$parcel$export(module.exports, "QUERY_PARAM_REVIEWERS", () => $a2f3556545768e94$export$8a8927c29ab32b10);
$parcel$export(module.exports, "QUERY_PARAM_STATUS", () => $a2f3556545768e94$export$3e8168848b996f7);
$parcel$export(module.exports, "QUERY_PARAM_REPOSITORIES", () => $a2f3556545768e94$export$4adc519ba40b72a6);
$parcel$export(module.exports, "QUERY_PARAM_SORT_KEY", () => $a2f3556545768e94$export$6da773286c35ef41);
$parcel$export(module.exports, "QUERY_PARAM_SORT_ORDER", () => $a2f3556545768e94$export$810a1f7ed2facfcb);
$parcel$export(module.exports, "queryParamsToWatch", () => $a2f3556545768e94$export$ba75fb5089c0eb0b);
$parcel$export(module.exports, "VcsProviderIds", () => $a2f3556545768e94$export$7d5c3d28df5f438a);
$parcel$export(module.exports, "DataDepotProviderIds", () => $a2f3556545768e94$export$7912a169c18abe9d);
$parcel$export(module.exports, "FEEDBACK_COLLECTOR_LOCATION", () => $a2f3556545768e94$export$74189cec821240a6);
$parcel$export(module.exports, "eligibleForConfigurationScreenStatuses", () => $a2f3556545768e94$export$3f3fc252f5066c72);
$parcel$export(module.exports, "notEligibleForConfigurationScreenStatuses", () => $a2f3556545768e94$export$9ce5b1bba5f17875);
$parcel$export(module.exports, "CODE_TAB_NAMESPACE", () => $a2f3556545768e94$export$f3873cacb48e85d4);
$parcel$export(module.exports, "LOCAL_STORAGE_GO_TO_DEVELOPMENT_KEY", () => $a2f3556545768e94$export$e9ce282f5e635322);
$parcel$export(module.exports, "CODE_TAB_MIGRATION_ANALYTICS", () => $a2f3556545768e94$export$49902d80a065c2d5);
const $a2f3556545768e94$export$4b1abe4db5ed7515 = [
    'HTTP status [403] while retrieving Bitbucket repository.',
    'HTTP status [404] while retrieving Bitbucket repository.',
    "Failed to retrieve Bitbucket repository because the user wasn't authorized."
];
const $a2f3556545768e94$export$687544614e0812da = [
    'HTTP status [429] while retrieving Bitbucket repository.',
    "The user does not have 'View Development Tools' permission for the Jira project or the project does not exist",
    'The user does not have admin permission for the site, Jira, project or the project does not exist.',
    'Unable to get providers when contacting Jira due to 401 Unauthorized'
];
const $a2f3556545768e94$export$7527a73da794030d = "var(--ds-shadow-overflow, 0px 0px 8px #091E4228, 0px 0px 1px #091E421e)";
const $a2f3556545768e94$export$2ecfdc24b216c295 = "var(--ds-shadow-overflow, 0px 0px 8px #091E4228, 0px 0px 1px #091E421e)"; // we use  in package.json file, so box-shadow here must be a value, cannot use elevation
const $a2f3556545768e94$export$f84c6b6609a3dd30 = 1000;
const $a2f3556545768e94$export$ea15b38f3901f518 = 12;
const $a2f3556545768e94$export$2b8b0a4489f9147b = 30;
const $a2f3556545768e94$export$3b8f88133d28aaa6 = 'collapsible-repository-list';
const $a2f3556545768e94$export$256a9f141103f328 = 'repository-list-header';
const $a2f3556545768e94$export$b0d4e90e40369b80 = 'repository-list-description';
const $a2f3556545768e94$export$1de4eaccc23a8747 = {
    'repository-list.pull-requests.empty-state': {
        helpArticleId: '5WUm7jlQnN9aiw9KOp1Ks1',
        href: 'https://support.atlassian.com/jira-software-cloud/docs/view-development-information-for-an-issue/'
    },
    'repository-list.pull-requests.description': {
        helpArticleId: '5WUm7jlQnN9aiw9KOp1Ks1',
        href: 'https://support.atlassian.com/jira-software-cloud/docs/view-development-information-for-an-issue/'
    }
};
const $a2f3556545768e94$export$5c00a6bedc2037c8 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.filter-container';
const $a2f3556545768e94$export$f70ce14ba902adcb = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filtered-table.pull-request-table.no-results.clearfiltersbutton';
const $a2f3556545768e94$export$19381ed4387aa05b = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.pull-requests-table';
const $a2f3556545768e94$export$f3e116f999d4c5c1 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.pull-requests-table.dynamic-table';
const $a2f3556545768e94$export$c28f1cd40ae0394c = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.pull-requests-empty-state';
const $a2f3556545768e94$export$f69d7aa9c5e17d55 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filtered-table.pull-request-table.summary-cell';
const $a2f3556545768e94$export$4ed9a8a7faf641f = `${$a2f3556545768e94$export$f69d7aa9c5e17d55}.title-link`;
const $a2f3556545768e94$export$c5322e755fd1028d = `${$a2f3556545768e94$export$f69d7aa9c5e17d55}.target-branch-link`;
const $a2f3556545768e94$export$72fcd104fde041d6 = `${$a2f3556545768e94$export$f69d7aa9c5e17d55}.repository-link`;
const $a2f3556545768e94$export$d8f600a480a9c2d4 = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.reviewers-cell';
const $a2f3556545768e94$export$9d9ab707c4e446cc = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.status-cell';
const $a2f3556545768e94$export$4da3056fdbfaf111 = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.comments-cell';
const $a2f3556545768e94$export$e1134688b6a1032 = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.last-updated-cell';
const $a2f3556545768e94$export$143249aa50321d51 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-error-state';
const $a2f3556545768e94$export$a46febdd3fe90de0 = 'software-code-page.ui.pages.main-page.repositories.repository-error-state';
const $a2f3556545768e94$export$333db4cac7ee017 = 'software-code-page.ui.pages.improved-configure-step-error-state';
const $a2f3556545768e94$export$5cbae081959768bd = 'software-code-page.ui.pages.ready-to-connect-empty-state-error-state';
const $a2f3556545768e94$export$4939c117ba49bc9e = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.repository-filter.filter-button';
const $a2f3556545768e94$export$5a92d7579dac6294 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.author-filter.filter-button';
const $a2f3556545768e94$export$a77ea162c15f0290 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.reviewers-filter.filter-button';
const $a2f3556545768e94$export$b7477204cae64b46 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.status-filter.filter-button';
const $a2f3556545768e94$export$39983b6fb040a5eb = 'summaryFilter';
const $a2f3556545768e94$export$3d96f5f9ccd35be6 = 'authorsFilter';
const $a2f3556545768e94$export$8a8927c29ab32b10 = 'reviewersFilter';
const $a2f3556545768e94$export$3e8168848b996f7 = 'statusFilter';
const $a2f3556545768e94$export$4adc519ba40b72a6 = 'repositoriesFilter';
const $a2f3556545768e94$export$6da773286c35ef41 = 'sortKey';
const $a2f3556545768e94$export$810a1f7ed2facfcb = 'sortOrder';
const $a2f3556545768e94$export$ba75fb5089c0eb0b = [
    $a2f3556545768e94$export$39983b6fb040a5eb,
    $a2f3556545768e94$export$3d96f5f9ccd35be6,
    $a2f3556545768e94$export$8a8927c29ab32b10,
    $a2f3556545768e94$export$3e8168848b996f7,
    $a2f3556545768e94$export$4adc519ba40b72a6,
    $a2f3556545768e94$export$6da773286c35ef41,
    $a2f3556545768e94$export$810a1f7ed2facfcb
];
const $a2f3556545768e94$export$7d5c3d28df5f438a = {
    BITBUCKET: 'bitbucket'
};
const $a2f3556545768e94$export$7912a169c18abe9d = {
    BITBUCKET_PROD: 'kRiZ7boFApjBINFF1L7wPrCa4iF8O6R9',
    BITBUCKET_STG: 'cOwtZiBfejjJAryJH0WPb1otsa4HrI1N',
    GITHUB_PROD: 'com.github.integration.production',
    GITHUB_STG: 'com.github.integration.staging'
};
const $a2f3556545768e94$export$74189cec821240a6 = 'jsw.code.page.header';
const $a2f3556545768e94$export$3f3fc252f5066c72 = [
    'NOT_CONFIGURED',
    'NOT_SET',
    'PARTIALLY_CONFIGURED'
];
const $a2f3556545768e94$export$9ce5b1bba5f17875 = [
    'CONFIGURED',
    'PROVIDER_ACTION_CONFIGURED',
    'PROVIDER_ACTION_NOT_CONFIGURED'
];
const $a2f3556545768e94$export$f3873cacb48e85d4 = 'jira-software-code-tab';
const $a2f3556545768e94$export$e9ce282f5e635322 = 'clickedGoToDevelopment';
const $a2f3556545768e94$export$49902d80a065c2d5 = 'jiraCodePageMigrationModal';

});

parcelRegister("1tSBh", function(module, exports) {

$parcel$export(module.exports, "numberToTimestamp", () => $dbe340acf3f0dbdc$export$9a7be8324d19a048);
$parcel$export(module.exports, "toProjectAri", () => $dbe340acf3f0dbdc$export$9429718a5f74f761);
$parcel$export(module.exports, "RepositoryTypes", () => $dbe340acf3f0dbdc$export$b5ab924fb433d9ea);
/**
 * Opaque types
 */ const $dbe340acf3f0dbdc$export$9a7be8324d19a048 = (time)=>{
    if (time < 0) throw new Error(`Trying to case invalid number(${time}) to Timestamp opaque type`);
    return time;
};
const $dbe340acf3f0dbdc$export$9429718a5f74f761 = (cloudId, projectId)=>`ari:cloud:jira:${cloudId}:project/${projectId}`;
const $dbe340acf3f0dbdc$export$b5ab924fb433d9ea = {
    REPO_BITBUCKET: 'REPO_BITBUCKET',
    REPO_GITHUB: 'REPO_GITHUB',
    REPO_GITLAB: 'REPO_GITLAB'
};
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $dbe340acf3f0dbdc$var$VcsProviderNamespaces = {
    CLASSIC: 'classic',
    OAUTH: 'oauth',
    BITBUCKET: 'bitbucket'
};

});


const $96625f88cf395132$export$94a43d2ac55ac375 = 'SOFTWARE_CODE';


parcelRegister("brJ9B", function(module, exports) {

$parcel$export(module.exports, "softwareCodeClassicPageEntrypoint", () => $6049b4a08957accb$export$10463031c8017b);

var $5mvmF = parcelRequire("5mvmF");

var $lmyls = parcelRequire("lmyls");

var $fo6b8 = parcelRequire("fo6b8");

var $lkFvK = parcelRequire("lkFvK");
const $6049b4a08957accb$export$10463031c8017b = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $5mvmF.softwareCodeEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("5mvmF", function(module, exports) {

$parcel$export(module.exports, "softwareCodeEntrypoint", () => $91f5d21e8db2487a$export$7dbaba2b508f1f10);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $91f5d21e8db2487a$export$7dbaba2b508f1f10 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("3GkOe")), {
        moduleId: "ba9a9980",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3GkOe", function(module, exports) {

let $2ae56f994f708324$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2ae56f994f708324$var$load("eXTT6").then(()=>parcelRequire('2kLjA'));

});



parcelRegister("6Kmkr", function(module, exports) {

$parcel$export(module.exports, "LazyCode", () => $bd64eb30d91f5f71$export$4beafd9dbad29bff);
$parcel$export(module.exports, "CodePageClassic", () => $bd64eb30d91f5f71$export$95e2389b7ca7ccf2);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $iS0yP = parcelRequire("iS0yP");

const $bd64eb30d91f5f71$export$4beafd9dbad29bff = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("jG7sy"))), {
    moduleId: "./src/packages/spa-apps/code/src/ui/index-old.tsx"
});
const $bd64eb30d91f5f71$export$95e2389b7ca7ccf2 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $bd64eb30d91f5f71$export$4beafd9dbad29bff,
        pageId: `classic-code-${(0, $iS0yP.getBoardId)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });

});
parcelRegister("iS0yP", function(module, exports) {

$parcel$export(module.exports, "getBoardId", () => $12fea879e07c880e$export$557c2f222778cea6);

var $ebyGx = parcelRequire("ebyGx");
const $12fea879e07c880e$export$557c2f222778cea6 = ({ location: location, match: match })=>{
    if (match && match.params.boardId) return match.params.boardId;
    const { rapidView: rapidView } = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(location.search);
    return rapidView;
};

});

parcelRegister("jG7sy", function(module, exports) {

let $e537b9df6b85c9f4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e537b9df6b85c9f4$var$load("ioZNk").then(()=>parcelRequire('fd2lp'));

});



parcelRegister("1kSIj", function(module, exports) {

$parcel$export(module.exports, "softwareCodeRouteEntry", () => $0271d7bff18c22c8$export$eac18b7aea4cb524);

var $ffza4 = parcelRequire("ffza4");

var $7XYc4 = parcelRequire("7XYc4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $iZ82x = parcelRequire("iZ82x");

var $7GnDe = parcelRequire("7GnDe");

var $5lsNZ = parcelRequire("5lsNZ");

var $lzTbm = parcelRequire("lzTbm");

var $kfztd = parcelRequire("kfztd");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $4R6GH = parcelRequire("4R6GH");

var $6LsQE = parcelRequire("6LsQE");

var $dOE01 = parcelRequire("dOE01");

var $cD5C5 = parcelRequire("cD5C5");
const $0271d7bff18c22c8$var$getHorizontalNavResource = ()=>(0, $4R6GH.fg)('entrypoint_migration_for_software_code') ? [] : [
        (0, $7uLIV.horizontalNavJiraResource)
    ];
const $0271d7bff18c22c8$export$eac18b7aea4cb524 = (0, $7NszV.createEntry)((0, $lzTbm.softwareCodeRoute), ()=>({
        group: 'software',
        component: (0, $7XYc4.componentWithCondition)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $dOE01.CodePageNextGen)),
        layout: (0, $e7bC3.softwareProjectLayoutCode),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            ...$0271d7bff18c22c8$var$getHorizontalNavResource(),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $iZ82x.codePageResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $dOE01.LazyCode)
        ],
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('entrypoint_migration_for_software_code')) return (0, $kfztd.isDevopsFeatureDisabledInFedRamp)() ? (0, $6LsQE.notFoundPageEntrypoint) : (0, $cD5C5.softwareCodeNextGenPageEntrypoint);
            return undefined;
        },
        ufoName: 'next-gen-code',
        supportsPreviewPanel: true
    }));

});
parcelRegister("lzTbm", function(module, exports) {

$parcel$export(module.exports, "softwareCodeRoute", () => $29efee39c2e259e2$export$9d24fc75b0f1d9a0);
const $29efee39c2e259e2$export$9d24fc75b0f1d9a0 = {
    name: 'software-code',
    path: '/jira/software/projects/:projectKey/code'
};

});

parcelRegister("dOE01", function(module, exports) {

$parcel$export(module.exports, "LazyCode", () => $1829bbce77409b44$export$4beafd9dbad29bff);
$parcel$export(module.exports, "CodePageNextGen", () => $1829bbce77409b44$export$d9e8184332f86b53);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $bzM7d = parcelRequire("bzM7d");

const $1829bbce77409b44$export$4beafd9dbad29bff = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("jG7sy"))), {
    moduleId: "./src/packages/spa-apps/code/src/ui/index-old.tsx"
});
const $1829bbce77409b44$export$d9e8184332f86b53 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $1829bbce77409b44$export$4beafd9dbad29bff,
        pageId: `next-gen-code-${(0, $bzM7d.getBoardId)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });

});
parcelRegister("bzM7d", function(module, exports) {

$parcel$export(module.exports, "getBoardId", () => $8d5a6727ab17b6ba$export$557c2f222778cea6);

var $ebyGx = parcelRequire("ebyGx");
const $8d5a6727ab17b6ba$export$557c2f222778cea6 = ({ location: location, match: match })=>{
    if (match && match.params.boardId) return match.params.boardId;
    const { rapidView: rapidView } = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(location.search);
    return rapidView;
};

});


parcelRegister("cD5C5", function(module, exports) {

$parcel$export(module.exports, "softwareCodeNextGenPageEntrypoint", () => $e02d9e74ba3f4d5c$export$bba7318d4079a95);

var $5mvmF = parcelRequire("5mvmF");

var $lmyls = parcelRequire("lmyls");

var $fo6b8 = parcelRequire("fo6b8");

var $lkFvK = parcelRequire("lkFvK");
const $e02d9e74ba3f4d5c$export$bba7318d4079a95 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $5mvmF.softwareCodeEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});


parcelRegister("bi9fZ", function(module, exports) {

$parcel$export(module.exports, "softwareDeploymentsClassicRouteEntry", () => $3da78177932dfa66$export$dcf1f9ba660dedf6);

var $e4eHl = parcelRequire("e4eHl");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $b4koY = parcelRequire("b4koY");

var $7GnDe = parcelRequire("7GnDe");

var $lKmRI = parcelRequire("lKmRI");

var $kfztd = parcelRequire("kfztd");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $6LsQE = parcelRequire("6LsQE");

var $jBfl2 = parcelRequire("jBfl2");
const $3da78177932dfa66$export$dcf1f9ba660dedf6 = (0, $7NszV.createEntry)((0, $lKmRI.softwareDeploymentsClassicRoute), ()=>({
        group: 'classic-software',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $b4koY.deploymentPreconditionRelayResource),
            (0, $dxCvy.projectContextResource)
        ],
        layout: (0, $e7bC3.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        entryPoint: ()=>(0, $kfztd.isDevopsFeatureDisabledInFedRamp)() ? (0, $6LsQE.notFoundPageEntrypoint) : (0, $jBfl2.softwareDeploymentsPageEntrypoint),
        meta: {
            reporting: {
                id: 'software-deployments-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-deployments-classic'),
                teamName: 'fusion-solaris'
            }
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("b4koY", function(module, exports) {

$parcel$export(module.exports, "deploymentPreconditionRelayResource", () => $b79457e490ba4467$export$50e4eedb9e6127c8);

var $ao2h1 = parcelRequire("ao2h1");

var $ajgeO = parcelRequire("ajgeO");

var $2M1hQ = parcelRequire("2M1hQ");


const $b79457e490ba4467$export$a1c09d7f7318f85c = (0, $2M1hQ.createResource)({
    type: (0, $c47c39dbdbc02648$export$2171160371fac588),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("kpWNE")),
    maxAge: 60000
});
const $b79457e490ba4467$export$50e4eedb9e6127c8 = (0, $ao2h1.createRelayResource)({
    type: (0, $c47c39dbdbc02648$export$a969d0487e348031),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $ajgeO.default),
            variables: {
                cloudId: tenantContext.cloudId,
                projectKey: String(match.params.projectKey)
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("ajgeO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0f41d4aeb9b6b93$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<946bfee09c64f3e6ddd3c9cbab07a461>>
 * @relayHash ea273678a5c985c0053babf0f185662a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0b497951b118068d82bb77e253f1fcb758c4dde1aa7f8eb01bf559f5961522f2
const $e0f41d4aeb9b6b93$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }
    ], v1 = {
        "args": [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "projectKey",
                "variableName": "projectKey"
            }
        ],
        "kind": "ScalarField",
        "name": "deploymentsFeaturePreconditionByProjectKey"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "uiDeploymentsFeaturePreconditionQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v1 /*: any*/ ,
                                "action": "THROW",
                                "path": "jira.deploymentsFeaturePreconditionByProjectKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "uiDeploymentsFeaturePreconditionQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "0b497951b118068d82bb77e253f1fcb758c4dde1aa7f8eb01bf559f5961522f2",
            "metadata": {},
            "name": "uiDeploymentsFeaturePreconditionQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e0f41d4aeb9b6b93$var$node.hash = "3337e3d6b76da02b643c63aacd15b239";
var $e0f41d4aeb9b6b93$export$2e2bcd8739ae039 = $e0f41d4aeb9b6b93$var$node;

});

const $c47c39dbdbc02648$export$2171160371fac588 = 'SOFTWARE_DEPLOYMENTS_PRECONDITION';
const $c47c39dbdbc02648$export$a969d0487e348031 = 'SOFTWARE_DEPLOYMENTS_PRECONDITION_RELAY';

parcelRegister("kpWNE", function(module, exports) {

let $edd3c0dba462d599$var$load = (parcelRequire("28QjX"))(4);
module.exports = $edd3c0dba462d599$var$load("l3NOh").then(()=>parcelRequire('96xO4'));

});


parcelRegister("lKmRI", function(module, exports) {

$parcel$export(module.exports, "softwareDeploymentsClassicRoute", () => $d186f38c5f1ffe01$export$485e4a7b82f29d70);
const $d186f38c5f1ffe01$export$485e4a7b82f29d70 = {
    name: 'software-deployments-classic',
    path: '/jira/software/c/projects/:projectKey/deployments'
};

});

parcelRegister("jBfl2", function(module, exports) {

$parcel$export(module.exports, "softwareDeploymentsPageEntrypoint", () => $ced3b63436800171$export$44d7744645dea53c);

var $lkFvK = parcelRequire("lkFvK");

var $fo6b8 = parcelRequire("fo6b8");

var $lmyls = parcelRequire("lmyls");

var $4f7Zu = parcelRequire("4f7Zu");
const $ced3b63436800171$export$44d7744645dea53c = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $4f7Zu.softwareDeploymentsEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("4f7Zu", function(module, exports) {

$parcel$export(module.exports, "softwareDeploymentsEntrypoint", () => $1d95bd1b138a4f0c$export$c51c7780e55a0186);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $1d95bd1b138a4f0c$export$c51c7780e55a0186 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("4Djls")), {
        moduleId: "12d277d5",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4Djls", function(module, exports) {

let $35f9cf74ea5ba4c9$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $35f9cf74ea5ba4c9$var$load("76n7a"),
    $35f9cf74ea5ba4c9$var$load("l253H"),
    $35f9cf74ea5ba4c9$var$load("ffQaD"),
    $35f9cf74ea5ba4c9$var$load("kvRbA"),
    $35f9cf74ea5ba4c9$var$load("4cCGA")
]).then(()=>parcelRequire('5EQGR'));

});




parcelRegister("jvZP3", function(module, exports) {

$parcel$export(module.exports, "softwareDeploymentsNextGenRouteEntry", () => $fae05ab45ce767cc$export$7e5ccb20ad8e1612);

var $e4eHl = parcelRequire("e4eHl");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $b4koY = parcelRequire("b4koY");

var $7GnDe = parcelRequire("7GnDe");

var $3V85G = parcelRequire("3V85G");

var $kfztd = parcelRequire("kfztd");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $6LsQE = parcelRequire("6LsQE");

var $jBfl2 = parcelRequire("jBfl2");
const $fae05ab45ce767cc$export$7e5ccb20ad8e1612 = (0, $7NszV.createEntry)((0, $3V85G.softwareDeploymentsNextGenRoute), ()=>({
        group: 'software',
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $b4koY.deploymentPreconditionRelayResource),
            (0, $dxCvy.projectContextResource)
        ],
        entryPoint: ()=>(0, $kfztd.isDevopsFeatureDisabledInFedRamp)() ? (0, $6LsQE.notFoundPageEntrypoint) : (0, $jBfl2.softwareDeploymentsPageEntrypoint),
        meta: {
            reporting: {
                id: 'software-deployments',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-deployments'),
                teamName: 'fusion-solaris'
            }
        }
    }));

});
parcelRegister("3V85G", function(module, exports) {

$parcel$export(module.exports, "softwareDeploymentsNextGenRoute", () => $80f4392aa55fd172$export$4b0939825a323ea5);
const $80f4392aa55fd172$export$4b0939825a323ea5 = {
    name: 'software-deployments',
    path: '/jira/software/projects/:projectKey/deployments'
};

});


parcelRegister("711QI", function(module, exports) {

$parcel$export(module.exports, "softwareFormBuilderClassicRouteEntry", () => $b4fa37ff3bdeb6f7$export$96aa488380334044);

var $7NszV = parcelRequire("7NszV");

var $7XYc4 = parcelRequire("7XYc4");

var $lmyls = parcelRequire("lmyls");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $3OSHM = parcelRequire("3OSHM");

var $6s1PB = parcelRequire("6s1PB");

var $evEd2 = parcelRequire("evEd2");

var $fo6b8 = parcelRequire("fo6b8");

var $e7bC3 = parcelRequire("e7bC3");

var $9s3j1 = parcelRequire("9s3j1");

var $lkFvK = parcelRequire("lkFvK");

var $3HwlS = parcelRequire("3HwlS");

var $6LsQE = parcelRequire("6LsQE");

var $5f2bR = parcelRequire("5f2bR");

var $l2N2a = parcelRequire("l2N2a");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");
const $b4fa37ff3bdeb6f7$var$formBuilderPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $evEd2.formBuilderEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $b4fa37ff3bdeb6f7$export$96aa488380334044 = (0, $7NszV.createEntry)((0, $3OSHM.softwareFormBuilderClassicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-form-builder',
        layout: (0, $e7bC3.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), (0, $5f2bR.AsyncHorizontalNavJira), ()=>null)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line camelcase
            (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingM2Enabled)(), (0, $9V5k0.projectThemeResource))
        ],
        entryPoint: ()=>{
            return (0, $6s1PB.expVal)('forms_for_jsw_experiment', 'isEnabled', false) ? $b4fa37ff3bdeb6f7$var$formBuilderPageEntrypoint : (0, $6LsQE.notFoundPageEntrypoint);
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("3OSHM", function(module, exports) {

$parcel$export(module.exports, "softwareFormBuilderClassicRoute", () => $9ede72c8b3eb717b$export$f6cfee0232aa1e);
const $9ede72c8b3eb717b$export$f6cfee0232aa1e = {
    name: 'software-form-builder-classic',
    path: '/jira/software/c/projects/:projectKey/form/:formId/builder',
    exact: true
};

});

parcelRegister("evEd2", function(module, exports) {

$parcel$export(module.exports, "formBuilderEntrypoint", () => $169d3b5f1d6377cd$export$6d3c9fa7232f412c);

var $kTta5 = parcelRequire("kTta5");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $169d3b5f1d6377cd$export$6d3c9fa7232f412c = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("6bH7n")), {
        moduleId: "a7e5ed4a",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                formBuilderQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $kTta5.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("kTta5", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e840d497ba3b73a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cd13e4f001483f4b52003ed8bc472792>>
 * @relayHash e8f0191fa153f065f7266afab384a46c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 165f5de6118450a4d0cf4ac24900ba8099a89412eebcbf8f5dee46032eb83e21
const $0e840d497ba3b73a$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "165f5de6118450a4d0cf4ac24900ba8099a89412eebcbf8f5dee46032eb83e21",
        "metadata": {},
        "name": "src_jiraSoftwareFormBuilderQuery",
        "operationKind": "query",
        "text": null
    }
};
var $0e840d497ba3b73a$export$2e2bcd8739ae039 = $0e840d497ba3b73a$var$node;

});

parcelRegister("6bH7n", function(module, exports) {

let $481537788a492b60$var$load = (parcelRequire("28QjX"))(4);

module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $481537788a492b60$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $481537788a492b60$var$load("k6g9p")
        ]);
    }),
    $481537788a492b60$var$load("ffQaD"),
    $481537788a492b60$var$load("kvRbA"),
    $481537788a492b60$var$load("76n7a"),
    $481537788a492b60$var$load("l253H"),
    $481537788a492b60$var$load("72F6c")
]).then(()=>parcelRequire('jM2sL'));

});



parcelRegister("03taV", function(module, exports) {

$parcel$export(module.exports, "softwareFormBuilderRouteEntry", () => $21f43a00ab4a505f$export$e8dede7671fad23d);

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $3HwlS = parcelRequire("3HwlS");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $l2N2a = parcelRequire("l2N2a");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $6LsQE = parcelRequire("6LsQE");

var $hGNg4 = parcelRequire("hGNg4");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $evEd2 = parcelRequire("evEd2");

var $fo6b8 = parcelRequire("fo6b8");

var $lkFvK = parcelRequire("lkFvK");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");
const $21f43a00ab4a505f$var$formBuilderPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $evEd2.formBuilderEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $21f43a00ab4a505f$export$e8dede7671fad23d = (0, $7NszV.createEntry)((0, $hGNg4.softwareFormBuilderRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-form-builder',
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), (0, $5f2bR.AsyncHorizontalNavJira), ()=>null)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line camelcase
            (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingM2Enabled)(), (0, $9V5k0.projectThemeResource))
        ],
        entryPoint: ()=>{
            return (0, $6s1PB.expVal)('forms_for_jsw_experiment', 'isEnabled', false) ? $21f43a00ab4a505f$var$formBuilderPageEntrypoint : (0, $6LsQE.notFoundPageEntrypoint);
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("hGNg4", function(module, exports) {

$parcel$export(module.exports, "softwareFormBuilderRoute", () => $2ce33b6906a0aad5$export$c5589046ee2a390d);
const $2ce33b6906a0aad5$export$c5589046ee2a390d = {
    name: 'software-form-builder',
    path: '/jira/software/projects/:projectKey/form/:formId/builder',
    exact: true
};

});


parcelRegister("kQjkp", function(module, exports) {

$parcel$export(module.exports, "softwareFormClassicRouteEntry", () => $d20dbf7f22bf9ac8$export$4bb0f20ad6471148);

var $7NszV = parcelRequire("7NszV");

var $7XYc4 = parcelRequire("7XYc4");

var $lmyls = parcelRequire("lmyls");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $fo6b8 = parcelRequire("fo6b8");

var $6s1PB = parcelRequire("6s1PB");

var $l2N2a = parcelRequire("l2N2a");

var $iwW4Z = parcelRequire("iwW4Z");

var $6LsQE = parcelRequire("6LsQE");

var $eeYjL = parcelRequire("eeYjL");

var $lkFvK = parcelRequire("lkFvK");

var $e7bC3 = parcelRequire("e7bC3");

var $9s3j1 = parcelRequire("9s3j1");

var $3HwlS = parcelRequire("3HwlS");

var $5f2bR = parcelRequire("5f2bR");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");
const $d20dbf7f22bf9ac8$var$formPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $eeYjL.formEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $d20dbf7f22bf9ac8$export$4bb0f20ad6471148 = (0, $7NszV.createEntry)((0, $iwW4Z.softwareFormClassicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-form',
        layout: (0, $e7bC3.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), (0, $5f2bR.AsyncHorizontalNavJira), ()=>null)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line camelcase
            (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingM2Enabled)(), (0, $9V5k0.projectThemeResource))
        ],
        entryPoint: ()=>{
            return (0, $6s1PB.expVal)('forms_for_jsw_experiment', 'isEnabled', false) ? $d20dbf7f22bf9ac8$var$formPageEntrypoint : (0, $6LsQE.notFoundPageEntrypoint);
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("iwW4Z", function(module, exports) {

$parcel$export(module.exports, "softwareFormClassicRoute", () => $3b49c520878b4671$export$ae560ee5b676193d);
const $3b49c520878b4671$export$ae560ee5b676193d = {
    name: 'software-form-classic',
    path: '/jira/software/c/projects/:projectKey/form',
    exact: true
};

});

parcelRegister("eeYjL", function(module, exports) {

$parcel$export(module.exports, "formEntrypoint", () => $2a299b0a5731b934$export$b931eb60522f687a);

var $czWfL = parcelRequire("czWfL");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $2a299b0a5731b934$export$b931eb60522f687a = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("93DVW")), {
        moduleId: "34421974",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                formQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $czWfL.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("czWfL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4080ec7d5d2fb7c3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3232935a5b9879fc4ee86b3cbc2c9c83>>
 * @relayHash 499a6633134d808842c9e8cd05fbcda0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 10cd467b6a17d91893094678f3292542a4270c9ce4e2a820600612d50bb642b5
const $4080ec7d5d2fb7c3$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "10cd467b6a17d91893094678f3292542a4270c9ce4e2a820600612d50bb642b5",
        "metadata": {},
        "name": "src_jiraSoftwareFormQuery",
        "operationKind": "query",
        "text": null
    }
};
var $4080ec7d5d2fb7c3$export$2e2bcd8739ae039 = $4080ec7d5d2fb7c3$var$node;

});

parcelRegister("93DVW", function(module, exports) {

let $69835ed2a93bafc1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $69835ed2a93bafc1$var$load("2eoES").then(()=>parcelRequire('jqjLM'));

});



parcelRegister("6KvsG", function(module, exports) {

$parcel$export(module.exports, "softwareFormRouteEntry", () => $eae74982fc8ba226$export$563e3b39911993a0);

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $3HwlS = parcelRequire("3HwlS");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $l2N2a = parcelRequire("l2N2a");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $6LsQE = parcelRequire("6LsQE");

var $4kqDP = parcelRequire("4kqDP");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $eeYjL = parcelRequire("eeYjL");

var $fo6b8 = parcelRequire("fo6b8");

var $lkFvK = parcelRequire("lkFvK");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");
const $eae74982fc8ba226$var$formPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $eeYjL.formEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $eae74982fc8ba226$export$563e3b39911993a0 = (0, $7NszV.createEntry)((0, $4kqDP.softwareFormRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-form',
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), (0, $5f2bR.AsyncHorizontalNavJira), ()=>null),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line camelcase
            (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingM2Enabled)(), (0, $9V5k0.projectThemeResource))
        ],
        entryPoint: ()=>{
            return (0, $6s1PB.expVal)('forms_for_jsw_experiment', 'isEnabled', false) ? $eae74982fc8ba226$var$formPageEntrypoint : (0, $6LsQE.notFoundPageEntrypoint);
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("4kqDP", function(module, exports) {

$parcel$export(module.exports, "softwareFormRoute", () => $fca3b9cc3ce6bbb8$export$a46217d369231a5);
const $fca3b9cc3ce6bbb8$export$a46217d369231a5 = {
    name: 'software-form',
    path: '/jira/software/projects/:projectKey/form',
    exact: true
};

});


parcelRegister("efYyQ", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitClassicPublicRouteEntry", () => $0622f0c75a643879$export$df7e146d38db5cc0);

var $7NszV = parcelRequire("7NszV");

var $6LsQE = parcelRequire("6LsQE");

var $6s1PB = parcelRequire("6s1PB");

var $1AQOY = parcelRequire("1AQOY");

var $2Ql51 = parcelRequire("2Ql51");

var $6e4Kt = parcelRequire("6e4Kt");

var $eRU3k = parcelRequire("eRU3k");
const $0622f0c75a643879$export$df7e146d38db5cc0 = (0, $7NszV.createEntry)((0, $1AQOY.softwareFormSubmitClassicPublicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-form-submit-public',
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            (0, $2Ql51.themePreferenceResource)
        ],
        entryPoint: ()=>(0, $6s1PB.expVal)('jira_forms_public_access_experiment', 'isEnabled', 'false') ? (0, $eRU3k.formSubmitPageEntrypoint) : (0, $6LsQE.notFoundPageEntrypoint)
    }));

});
parcelRegister("1AQOY", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitClassicPublicRoute", () => $3e5868f8d7166868$export$c66ba06e288dec3f);
const $3e5868f8d7166868$export$c66ba06e288dec3f = {
    name: 'software-form-submit-classic-public',
    path: '/jira/software/c/form/:formUuid',
    exact: true
};

});


parcelRegister("gcVUu", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitClassicRouteEntry", () => $331e128c3f179847$export$a7c8812838762453);

var $7NszV = parcelRequire("7NszV");

var $lmyls = parcelRequire("lmyls");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $6LsQE = parcelRequire("6LsQE");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $6FnT3 = parcelRequire("6FnT3");

var $lkFvK = parcelRequire("lkFvK");

var $6s1PB = parcelRequire("6s1PB");

var $l2N2a = parcelRequire("l2N2a");

var $1Fd2h = parcelRequire("1Fd2h");

var $6e4Kt = parcelRequire("6e4Kt");
const $331e128c3f179847$var$formSubmitPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $6FnT3.formSubmitEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $331e128c3f179847$export$a7c8812838762453 = (0, $7NszV.createEntry)((0, $1Fd2h.softwareFormSubmitClassicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-form-submit',
        layout: (0, $6e4Kt.chromelessLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line camelcase
            (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource)
        ],
        entryPoint: ()=>{
            return (0, $6s1PB.expVal)('forms_for_jsw_experiment', 'isEnabled', false) ? $331e128c3f179847$var$formSubmitPageEntrypoint : (0, $6LsQE.notFoundPageEntrypoint);
        }
    }));

});
parcelRegister("6FnT3", function(module, exports) {

$parcel$export(module.exports, "formSubmitEntrypoint", () => $385f1a5bd4b1bf72$export$d33b8db02e0a0cb5);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $385f1a5bd4b1bf72$export$d33b8db02e0a0cb5 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("d1BIx")), {
        moduleId: "3c821c06",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("d1BIx", function(module, exports) {

let $97b8a03f156fab74$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $97b8a03f156fab74$var$load("ffQaD"),
    $97b8a03f156fab74$var$load("kvRbA"),
    $97b8a03f156fab74$var$load("76n7a"),
    $97b8a03f156fab74$var$load("l253H"),
    $97b8a03f156fab74$var$load("fInOz")
]).then(()=>parcelRequire('6SZAm'));

});


parcelRegister("1Fd2h", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitClassicRoute", () => $dcbb2b95e9b9bd2e$export$91d6851bf27349);
const $dcbb2b95e9b9bd2e$export$91d6851bf27349 = {
    name: 'software-form-submit-classic',
    path: '/jira/software/c/projects/:projectKey/form/:formId',
    exact: true
};

});


parcelRegister("dG6DF", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitEmbedClassicRouteEntry", () => $cca7fa509b94a5ef$export$ffc85d68201bbe35);

var $7NszV = parcelRequire("7NszV");

var $lmyls = parcelRequire("lmyls");

var $l2N2a = parcelRequire("l2N2a");

var $6e4Kt = parcelRequire("6e4Kt");

var $cQaX2 = parcelRequire("cQaX2");

var $a1Eek = parcelRequire("a1Eek");

var $lkFvK = parcelRequire("lkFvK");
const $cca7fa509b94a5ef$var$formSubmitEmbedPageEntrypoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $a1Eek.formSubmitEmbedEntrypoint)
});
const $cca7fa509b94a5ef$export$ffc85d68201bbe35 = (0, $7NszV.createEntry)((0, $cQaX2.softwareFormSubmitEmbedClassicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-form-submit-embed',
        layout: (0, $6e4Kt.chromelessLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        // eslint-disable-next-line camelcase
        resources: [
            (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource)
        ],
        entryPoint: ()=>{
            return $cca7fa509b94a5ef$var$formSubmitEmbedPageEntrypoint;
        }
    }));

});
parcelRegister("cQaX2", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitEmbedClassicRoute", () => $7149a36cf3eab9d7$export$812703a022333f7c);
const $7149a36cf3eab9d7$export$812703a022333f7c = {
    name: 'software-form-submit-classic-embed',
    path: '/jira/software/c/projects/:projectKey/form/:formId/embed',
    exact: true
};

});

parcelRegister("a1Eek", function(module, exports) {

$parcel$export(module.exports, "formSubmitEmbedEntrypoint", () => $8db17a4483c62517$export$4c748d8ca82fc24);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $8db17a4483c62517$export$4c748d8ca82fc24 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("eW2YV")), {
        moduleId: "d6417f2e",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("eW2YV", function(module, exports) {

let $adf8cb96088dcee9$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $adf8cb96088dcee9$var$load("ffQaD"),
    $adf8cb96088dcee9$var$load("kvRbA"),
    $adf8cb96088dcee9$var$load("76n7a"),
    $adf8cb96088dcee9$var$load("l253H"),
    $adf8cb96088dcee9$var$load("7Gdm3")
]).then(()=>parcelRequire('91Ac2'));

});



parcelRegister("kg7GL", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitEmbedRouteEntry", () => $82aac62e73960caa$export$ac2e374edf86801f);

var $6e4Kt = parcelRequire("6e4Kt");

var $7NszV = parcelRequire("7NszV");

var $l2N2a = parcelRequire("l2N2a");

var $7G821 = parcelRequire("7G821");

var $a1Eek = parcelRequire("a1Eek");

var $lkFvK = parcelRequire("lkFvK");
const $82aac62e73960caa$var$formSubmitEmbedPageEntrypoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $a1Eek.formSubmitEmbedEntrypoint)
});
const $82aac62e73960caa$export$ac2e374edf86801f = (0, $7NszV.createEntry)((0, $7G821.softwareFormSubmitEmbedRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-form-submit-embed',
        layout: (0, $6e4Kt.chromelessLayout),
        // eslint-disable-next-line camelcase
        resources: [
            (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource)
        ],
        entryPoint: ()=>{
            return $82aac62e73960caa$var$formSubmitEmbedPageEntrypoint;
        }
    }));

});
parcelRegister("7G821", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitEmbedRoute", () => $fae57e01e4ce41f8$export$2bee26f083dc2946);
const $fae57e01e4ce41f8$export$2bee26f083dc2946 = {
    name: 'software-form-submit-embed',
    path: '/jira/software/projects/:projectKey/form/:formId/embed',
    exact: true
};

});


parcelRegister("aviVh", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitPublicRouteEntry", () => $640c017209c8df68$export$70893a47a5c041fd);

var $7NszV = parcelRequire("7NszV");

var $6LsQE = parcelRequire("6LsQE");

var $6s1PB = parcelRequire("6s1PB");

var $8SevG = parcelRequire("8SevG");

var $6e4Kt = parcelRequire("6e4Kt");

var $eRU3k = parcelRequire("eRU3k");

var $2Ql51 = parcelRequire("2Ql51");
const $640c017209c8df68$export$70893a47a5c041fd = (0, $7NszV.createEntry)((0, $8SevG.softwareFormSubmitPublicRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-form-submit-public',
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            (0, $2Ql51.themePreferenceResource)
        ],
        entryPoint: ()=>{
            return (0, $6s1PB.expVal)('jira_forms_public_access_experiment', 'isEnabled', 'false') ? (0, $eRU3k.formSubmitPageEntrypoint) : (0, $6LsQE.notFoundPageEntrypoint);
        }
    }));

});
parcelRegister("8SevG", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitPublicRoute", () => $796526da1cff6a97$export$d238522bd96fb720);
const $796526da1cff6a97$export$d238522bd96fb720 = {
    name: 'software-form-submit-public',
    path: '/jira/software/form/:formUuid',
    exact: true
};

});


parcelRegister("i0tax", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitRouteEntry", () => $b1634ae98fc90f0b$export$752724866670c36);

var $6e4Kt = parcelRequire("6e4Kt");

var $6s1PB = parcelRequire("6s1PB");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $7NszV = parcelRequire("7NszV");

var $l2N2a = parcelRequire("l2N2a");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $6LsQE = parcelRequire("6LsQE");

var $lHSmT = parcelRequire("lHSmT");

var $6FnT3 = parcelRequire("6FnT3");

var $lkFvK = parcelRequire("lkFvK");
const $b1634ae98fc90f0b$var$formSubmitPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $6FnT3.formSubmitEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $b1634ae98fc90f0b$export$752724866670c36 = (0, $7NszV.createEntry)((0, $lHSmT.softwareFormSubmitRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-form-submit',
        layout: (0, $6e4Kt.chromelessLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line camelcase
            (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource)
        ],
        entryPoint: ()=>{
            return (0, $6s1PB.expVal)('forms_for_jsw_experiment', 'isEnabled', false) ? $b1634ae98fc90f0b$var$formSubmitPageEntrypoint : (0, $6LsQE.notFoundPageEntrypoint);
        }
    }));

});
parcelRegister("lHSmT", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitRoute", () => $a6eb0d1c3eac1f7e$export$75b28ee1c7f02f00);
const $a6eb0d1c3eac1f7e$export$75b28ee1c7f02f00 = {
    name: 'software-form-submit',
    path: '/jira/software/projects/:projectKey/form/:formId',
    exact: true
};

});


parcelRegister("1IhKQ", function(module, exports) {

$parcel$export(module.exports, "softwareGoalsClassicRouteEntry", () => $1b0cb05431f8ca29$export$58d10390fc181fcf);

var $7NszV = parcelRequire("7NszV");

var $lmyls = parcelRequire("lmyls");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $9s3j1 = parcelRequire("9s3j1");

var $5f2bR = parcelRequire("5f2bR");

var $e1lSQ = parcelRequire("e1lSQ");

var $6XlJT = parcelRequire("6XlJT");
const $1b0cb05431f8ca29$export$58d10390fc181fcf = (0, $7NszV.createEntry)((0, $e1lSQ.softwareGoalsClassicRoute), ()=>({
        group: 'classic-software',
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $6XlJT.softwareGoalsClassicPageEntrypoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("e1lSQ", function(module, exports) {

$parcel$export(module.exports, "softwareGoalsClassicRoute", () => $9ec0c22df6343cfe$export$d12f3924cf53b545);
const $9ec0c22df6343cfe$export$d12f3924cf53b545 = {
    name: 'software-goals-classic',
    path: '/jira/software/c/projects/:projectKey/goals'
};

});

parcelRegister("6XlJT", function(module, exports) {

$parcel$export(module.exports, "softwareGoalsClassicPageEntrypoint", () => $4a23aaa7a1201d94$export$6c6f7e606a16292);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $fo6b8 = parcelRequire("fo6b8");

var $gz6uQ = parcelRequire("gz6uQ");
const $4a23aaa7a1201d94$export$6c6f7e606a16292 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $gz6uQ.softwareGoalsEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("gz6uQ", function(module, exports) {

$parcel$export(module.exports, "softwareGoalsEntrypoint", () => $6005f5d27d54b399$export$a75f86449cc34a72);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $6005f5d27d54b399$export$a75f86449cc34a72 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("bsowf")), {
        moduleId: "a5f3007b",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("bsowf", function(module, exports) {

let $85755438750c9306$var$load = (parcelRequire("28QjX"))(4);
module.exports = $85755438750c9306$var$load("lCGb1").then(()=>parcelRequire('lrWy4'));

});




parcelRegister("dl9zj", function(module, exports) {

$parcel$export(module.exports, "softwareGoalsRouteEntry", () => $db50753f4b92496b$export$d3fcc412edfa2068);

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $9ltJc = parcelRequire("9ltJc");

var $5f2bR = parcelRequire("5f2bR");

var $x6sAR = parcelRequire("x6sAR");
const $db50753f4b92496b$export$d3fcc412edfa2068 = (0, $7NszV.createEntry)((0, $9ltJc.softwareGoalsRoute), ()=>({
        group: 'software',
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $x6sAR.softwareGoalsPageEntrypoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("9ltJc", function(module, exports) {

$parcel$export(module.exports, "softwareGoalsRoute", () => $7d61fd42ce40e603$export$2328fed7ebee3cce);
const $7d61fd42ce40e603$export$2328fed7ebee3cce = {
    name: 'software-goals',
    exact: true,
    path: '/jira/software/projects/:projectKey/goals'
};

});

parcelRegister("x6sAR", function(module, exports) {

$parcel$export(module.exports, "softwareGoalsPageEntrypoint", () => $f4f250cf13a0bcf2$export$6c63903b420029c0);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $fo6b8 = parcelRequire("fo6b8");

var $gz6uQ = parcelRequire("gz6uQ");
const $f4f250cf13a0bcf2$export$6c63903b420029c0 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $gz6uQ.softwareGoalsEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});


parcelRegister("iQsfj", function(module, exports) {

$parcel$export(module.exports, "softwareInboxClassicRouteEntry", () => $f05204c4b21c61d2$export$ca6aeb36a7b6211d);

var $e4eHl = parcelRequire("e4eHl");

var $c309A = parcelRequire("c309A");

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $15eSh = parcelRequire("15eSh");

var $5f2bR = parcelRequire("5f2bR");

var $6LsQE = parcelRequire("6LsQE");

var $arJNO = parcelRequire("arJNO");

var $8RACJ = parcelRequire("8RACJ");
const $f05204c4b21c61d2$export$ca6aeb36a7b6211d = (0, $7NszV.createEntry)((0, $c309A.softwareInboxClassicRoute), ()=>({
        group: 'classic-software',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            reporting: {
                id: 'software-inbox-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-inbox-classic'),
                teamName: 'boysenberry'
            }
        },
        skeleton: (0, $15eSh.InboxViewTableSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $cSD7y.componentWithFG)('make_nav3_sidebar_lazyforpaint', (0, $9s3j1.ForPaintClassicSoftwareProjectSidebar), (0, $9s3j1.default)),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $arJNO.getCommonProjectResources)()
        ],
        layout: (0, $aPfsS.createLayout)((0, $gyYxw.genericProjectLayout)),
        // We want to opt out of concurrent mode for all NIN routes https://hello.atlassian.net/wiki/x/wTRfDAE
        // But allow for users with empanada-concurrent-incremental gate enabled to continue testing it
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental') && !(0, $4R6GH.fg)('empanada-concurrent-incremental'),
        entryPoint: ()=>(0, $4R6GH.fg)('jcs_developer_escalations') ? (0, $8RACJ.inboxPageEntryPoint) : (0, $6LsQE.notFoundPageEntrypoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("c309A", function(module, exports) {

$parcel$export(module.exports, "softwareInboxClassicRoute", () => $a0a29968a08b5849$export$a3612f128eff4e3c);
const $a0a29968a08b5849$export$a3612f128eff4e3c = {
    name: 'inbox-classic',
    path: '/jira/software/c/projects/:projectKey/inbox/:issueKey?'
};

});

parcelRegister("15eSh", function(module, exports) {

$parcel$export(module.exports, "InboxViewTableSkeleton", () => $3523ca2f02bd8f32$export$24aae43683500596);
/* InboxViewTableSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $5kmCE = parcelRequire("5kmCE");
const $3523ca2f02bd8f32$var$customCssStyles = null;
const $3523ca2f02bd8f32$var$containerStyles = {
    height: '448px'
};
const $3523ca2f02bd8f32$export$24aae43683500596 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5kmCE))),
        containerStyles: $3523ca2f02bd8f32$var$containerStyles,
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("5kmCE", function(module, exports) {
module.exports = new URL("inbox-view-table-skeleton.tpl.3e3d3620.svg", import.meta.url).toString();

});


parcelRegister("8RACJ", function(module, exports) {

$parcel$export(module.exports, "inboxPageEntryPoint", () => $3d431b841140962e$export$6da9e4ae87b73009);

var $lmyls = parcelRequire("lmyls");

var $fo6b8 = parcelRequire("fo6b8");

var $lkFvK = parcelRequire("lkFvK");

var $c0j7k = parcelRequire("c0j7k");
const $3d431b841140962e$export$6da9e4ae87b73009 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $c0j7k.customerServiceInboxPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("c0j7k", function(module, exports) {

$parcel$export(module.exports, "customerServiceInboxPageEntrypoint", () => $30c38ea6fc569c0d$export$bf72eb0f567836ce);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $30c38ea6fc569c0d$export$bf72eb0f567836ce = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("6DN6j")), {
        moduleId: "9cc840e3",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("6DN6j", function(module, exports) {

let $4d5c78f95b74c06e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4d5c78f95b74c06e$var$load("dcueU").then(()=>parcelRequire('fLjxR'));

});




parcelRegister("3gU47", function(module, exports) {

$parcel$export(module.exports, "softwareInboxNextGenRouteEntry", () => $d466539a61f9c01e$export$22d61f7936797fc0);

var $e4eHl = parcelRequire("e4eHl");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $cSD7y = parcelRequire("cSD7y");

var $cwQst = parcelRequire("cwQst");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $15eSh = parcelRequire("15eSh");

var $6LsQE = parcelRequire("6LsQE");

var $arJNO = parcelRequire("arJNO");

var $8RACJ = parcelRequire("8RACJ");
const $d466539a61f9c01e$export$22d61f7936797fc0 = (0, $7NszV.createEntry)((0, $cwQst.softwareInboxNextGenRoute), ()=>({
        group: 'software',
        meta: {
            reporting: {
                id: 'software-inbox-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-inbox-classic'),
                teamName: 'boysenberry'
            }
        },
        skeleton: (0, $15eSh.InboxViewTableSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $cSD7y.componentWithFG)('make_nav3_sidebar_lazyforpaint', (0, $koWFd.ForPaintSoftwareProjectSidebar), (0, $koWFd.default)),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $arJNO.getCommonProjectResources)()
        ],
        layout: (0, $aPfsS.createLayout)((0, $e7bC3.softwareProjectLayoutNoOnboarding)),
        // We want to opt out of concurrent mode for all NIN routes https://hello.atlassian.net/wiki/x/wTRfDAE
        // But allow for users with empanada-concurrent-incremental gate enabled to continue testing it
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental') && !(0, $4R6GH.fg)('empanada-concurrent-incremental'),
        entryPoint: ()=>(0, $4R6GH.fg)('jcs_developer_escalations') ? (0, $8RACJ.inboxPageEntryPoint) : (0, $6LsQE.notFoundPageEntrypoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("cwQst", function(module, exports) {

$parcel$export(module.exports, "softwareInboxNextGenRoute", () => $cd2c848c671bcda5$export$e44454ed868d0941);
const $cd2c848c671bcda5$export$e44454ed868d0941 = {
    name: 'inbox',
    path: '/jira/software/projects/:projectKey/inbox/:issueKey?'
};

});


parcelRegister("4Mj46", function(module, exports) {

$parcel$export(module.exports, "softwareIncidentsClassicRouteEntry", () => $dedf0d7500ec9709$export$c7d98bfe75274932);

var $e4eHl = parcelRequire("e4eHl");

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $eIvCa = parcelRequire("eIvCa");

var $9LHPC = parcelRequire("9LHPC");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $hb1PV = parcelRequire("hb1PV");

var $BrpCW = parcelRequire("BrpCW");
const $dedf0d7500ec9709$export$c7d98bfe75274932 = (0, $7NszV.createEntry)((0, $eIvCa.softwareIncidentsClassicRoute), ()=>({
        group: 'classic-software',
        entryPoint () {
            return (0, $4R6GH.fg)('corex_operandi_incidents_page_in_jira') ? (0, $hb1PV.entryPoint) : (0, $BrpCW.entryPointDeprecated);
        },
        layout: (0, $e7bC3.classicSoftwareProjectLayout),
        skeleton: (0, $9LHPC.IncidentsPageSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource),
            (0, $7GnDe.incidentsInitialPageChecksResource),
            (0, $7GnDe.incidentsCustomFieldIdResource)
        ],
        meta: {
            reporting: {
                id: 'software-incidents-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-incidents-classic'),
                teamName: 'operandi'
            }
        },
        ufoName: 'software-incidents',
        supportsPreviewPanel: true
    }));

});
parcelRegister("eIvCa", function(module, exports) {

$parcel$export(module.exports, "softwareIncidentsClassicRoute", () => $a586f286b7619cb0$export$3356a7870a2717f4);
const $a586f286b7619cb0$export$3356a7870a2717f4 = {
    name: 'software-incidents-classic',
    path: '/jira/software/c/projects/:projectKey/incidents'
};

});

parcelRegister("9LHPC", function(module, exports) {

$parcel$export(module.exports, "IncidentsPageSkeleton", () => $cc84120449e592c1$export$3105d59d9ca899bd);
$parcel$export(module.exports, "IncidentsTableSkeleton", () => $cc84120449e592c1$export$7092b8ea63ebf9be);
/* IncidentsPageSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $c5GCJ = parcelRequire("c5GCJ");

var $6Hwnc = parcelRequire("6Hwnc");
const $cc84120449e592c1$var$incidentsPageSkeletonStyles = null;
const $cc84120449e592c1$var$incidentsTableSkeletonStyles = null;
const $cc84120449e592c1$export$3105d59d9ca899bd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "skeletons.ui.incidents-page.app-skeleton-image-incidents-page",
        className: (0, $bwpsq.default)([
            "_1bsb1x27 _4t3i1osq _ca0q1ejb _19bv1jfw _u5f31jfw _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c5GCJ)))
    }));
const $cc84120449e592c1$export$7092b8ea63ebf9be = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "skeletons.ui.incidents-page.app-skeleton-image-incidents-table",
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6Hwnc)))
    }));

});
parcelRegister("c5GCJ", function(module, exports) {
module.exports = new URL("incidents-page-app-skeleton.tpl.5b656159.svg", import.meta.url).toString();

});

parcelRegister("6Hwnc", function(module, exports) {
module.exports = new URL("incidents-page-table-skeleton.tpl.e8f337f1.svg", import.meta.url).toString();

});


parcelRegister("hb1PV", function(module, exports) {

$parcel$export(module.exports, "entryPoint", () => $3b4ebee292145bb5$export$6333901e831d7af0);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $5En1O = parcelRequire("5En1O");

var $fo6b8 = parcelRequire("fo6b8");
const $3b4ebee292145bb5$export$6333901e831d7af0 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $5En1O.incidentsPageEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("5En1O", function(module, exports) {

$parcel$export(module.exports, "incidentsPageEntryPoint", () => $b9fe885d02827a63$export$a59477eea6e8cd7f);

var $2T5vx = parcelRequire("2T5vx");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");
const $b9fe885d02827a63$var$AriGraphSortOrderInput = {
    ASC: 'ASC',
    DESC: 'DESC'
};
const $b9fe885d02827a63$var$QUERY_PARAM_SEARCH = 'search';
const $b9fe885d02827a63$var$QUERY_PARAM_PRIORITY = 'priority';
const $b9fe885d02827a63$var$QUERY_PARAM_AFFECTED_SERVICE = 'affected-service';
const $b9fe885d02827a63$var$QUERY_PARAM_STATUS = 'status';
const $b9fe885d02827a63$var$QUERY_PARAM_SORT_BY = 'sortBy';
const $b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER = 'sortOrder';
const $b9fe885d02827a63$var$STATUS_SORT_KEY = 'status';
const $b9fe885d02827a63$var$CREATED_SORT_KEY = 'created';
const $b9fe885d02827a63$var$PRIORITY_SORT_KEY = 'priority';
const $b9fe885d02827a63$var$SUMMARY_SORT_KEY = 'key';
const $b9fe885d02827a63$var$ASC_SORT_KEY = 'ASC';
const $b9fe885d02827a63$var$DESC_SORT_KEY = 'DESC';
function $b9fe885d02827a63$var$notEmpty(value) {
    return Boolean(value);
}
const $b9fe885d02827a63$var$isPriority = $b9fe885d02827a63$var$notEmpty;
const $b9fe885d02827a63$var$isStatus = (val)=>val === 'resolved' || val === 'open';
const $b9fe885d02827a63$var$isSortBy = (val)=>val === $b9fe885d02827a63$var$STATUS_SORT_KEY || val === $b9fe885d02827a63$var$CREATED_SORT_KEY || val === $b9fe885d02827a63$var$PRIORITY_SORT_KEY || val === $b9fe885d02827a63$var$SUMMARY_SORT_KEY;
const $b9fe885d02827a63$var$isSortOrder = (val)=>val === $b9fe885d02827a63$var$ASC_SORT_KEY || val === $b9fe885d02827a63$var$DESC_SORT_KEY;
const $b9fe885d02827a63$var$isAffectedService = $b9fe885d02827a63$var$notEmpty;
function $b9fe885d02827a63$var$parseParameter(parameter, parameterValidationFn) {
    return parameter == null ? undefined : parameter.split(',').map((str)=>str.trim()).filter(parameterValidationFn);
}
const $b9fe885d02827a63$var$parseQueryParams = (paramsRaw)=>{
    const result = {
        [$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY]: paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY] && $b9fe885d02827a63$var$isSortBy(paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY]) ? paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY] : $b9fe885d02827a63$var$CREATED_SORT_KEY,
        [$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER]: paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER] && $b9fe885d02827a63$var$isSortOrder(paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER]) ? paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER] : $b9fe885d02827a63$var$DESC_SORT_KEY
    };
    result[$b9fe885d02827a63$var$QUERY_PARAM_AFFECTED_SERVICE] = $b9fe885d02827a63$var$parseParameter(paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_AFFECTED_SERVICE], $b9fe885d02827a63$var$isAffectedService);
    result[$b9fe885d02827a63$var$QUERY_PARAM_STATUS] = $b9fe885d02827a63$var$parseParameter(paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_STATUS], $b9fe885d02827a63$var$isStatus);
    result[$b9fe885d02827a63$var$QUERY_PARAM_SEARCH] = paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SEARCH] ?? undefined;
    result[$b9fe885d02827a63$var$QUERY_PARAM_PRIORITY] = $b9fe885d02827a63$var$parseParameter(paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_PRIORITY], $b9fe885d02827a63$var$isPriority);
    return result;
};
const $b9fe885d02827a63$var$getFilterValue = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
values)=>({
        ...values.length > 0 ? {
            is: values
        } : {}
    });
const $b9fe885d02827a63$var$parseStatusToFilterValues = (status)=>status.flatMap((stat)=>{
        switch(stat){
            case 'open':
                return [
                    'NEW',
                    'INDETERMINATE'
                ];
            case 'resolved':
                return [
                    'DONE'
                ];
            default:
                return [
                    'UNDEFINED'
                ];
        }
    });
const $b9fe885d02827a63$var$getGqlFiltersFromQueryParams = (parsedQueryParams)=>({
        and: [
            {
                to_status: $b9fe885d02827a63$var$getFilterValue($b9fe885d02827a63$var$parseStatusToFilterValues(parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_STATUS] ?? [])),
                to_priority: $b9fe885d02827a63$var$getFilterValue(parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_PRIORITY] ?? []),
                to_affectedServiceAris: $b9fe885d02827a63$var$getFilterValue(parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_AFFECTED_SERVICE] ?? [])
            }
        ]
    });
const $b9fe885d02827a63$var$parseSortDirection = (maybeDirection, defaultValue)=>{
    switch(maybeDirection?.toUpperCase()){
        case $b9fe885d02827a63$var$AriGraphSortOrderInput.ASC.toUpperCase():
            return $b9fe885d02827a63$var$AriGraphSortOrderInput.ASC;
        case $b9fe885d02827a63$var$AriGraphSortOrderInput.DESC.toUpperCase():
            return $b9fe885d02827a63$var$AriGraphSortOrderInput.DESC;
        default:
            return defaultValue;
    }
};
const $b9fe885d02827a63$var$getSortValue = (sortOrder)=>({
        priority: 2,
        direction: $b9fe885d02827a63$var$parseSortDirection(sortOrder, $b9fe885d02827a63$var$AriGraphSortOrderInput.DESC)
    });
// Added Inverse sort fn as data in AGS is indexed in reverse order for priority
const $b9fe885d02827a63$var$parseInverseSortDirection = (maybeDirection, defaultValue)=>{
    switch(maybeDirection?.toUpperCase()){
        case $b9fe885d02827a63$var$AriGraphSortOrderInput.ASC.toUpperCase():
            return $b9fe885d02827a63$var$AriGraphSortOrderInput.DESC;
        case $b9fe885d02827a63$var$AriGraphSortOrderInput.DESC.toUpperCase():
            return $b9fe885d02827a63$var$AriGraphSortOrderInput.ASC;
        default:
            return defaultValue;
    }
};
const $b9fe885d02827a63$var$getInverseSortValue = (sortOrder)=>({
        priority: 2,
        direction: $b9fe885d02827a63$var$parseInverseSortDirection(sortOrder, $b9fe885d02827a63$var$AriGraphSortOrderInput.ASC)
    });
const $b9fe885d02827a63$var$getGraphStoreSortFromQueryParams = (parsedQueryParams)=>({
        lastModified: {
            priority: 1,
            direction: $b9fe885d02827a63$var$AriGraphSortOrderInput.DESC
        },
        ...$b9fe885d02827a63$var$STATUS_SORT_KEY === parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY] ? {
            to_status: $b9fe885d02827a63$var$getSortValue(parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER])
        } : {},
        ...$b9fe885d02827a63$var$PRIORITY_SORT_KEY === parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY] ? {
            to_priority: $b9fe885d02827a63$var$getInverseSortValue(parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER])
        } : {},
        ...$b9fe885d02827a63$var$CREATED_SORT_KEY === parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY] ? {
            createdAt: $b9fe885d02827a63$var$getSortValue(parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER])
        } : {}
    });

const $b9fe885d02827a63$export$a59477eea6e8cd7f = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("lMrpD")).then((mod)=>mod.IncidentsPageWrapper), {
        moduleId: "5b8b4ff7",
        priority: "userVisible"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId }, context: context })=>({
            queries: {
                incidentPageData: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $2T5vx.default,
                    variables: {
                        incidentPageSize: 30,
                        servicePageSize: 30,
                        cloudId: cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        filter: $b9fe885d02827a63$var$getGqlFiltersFromQueryParams($b9fe885d02827a63$var$parseQueryParams(context.query)),
                        sort: $b9fe885d02827a63$var$getGraphStoreSortFromQueryParams($b9fe885d02827a63$var$parseQueryParams(context.query)),
                        siteAri: `ari:cloud:jira::site/${cloudId}`
                    }
                }
            }
        })
});

});
parcelRegister("2T5vx", function(module, exports) {

$parcel$export(module.exports, "default", () => $58f54a3a0d651497$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<535af53561736a2d836fc81ae5b4bf2f>>
 * @relayHash ab315f9ffdcbe8bd8ba7b5de061e5649
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 46b09365c92c616fad0f3bc4329e6d2421389f9a3a81cc6bcfaa80c14a330137
const $58f54a3a0d651497$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "46b09365c92c616fad0f3bc4329e6d2421389f9a3a81cc6bcfaa80c14a330137",
        "metadata": {
            "connection": [
                {
                    "count": "servicePageSize",
                    "cursor": "after",
                    "direction": "forward",
                    "path": [
                        "jira",
                        "jiraProjectByKey",
                        "linkedOperationsComponentsByProject"
                    ]
                }
            ]
        },
        "name": "srcIncidentsPageInternalQuery",
        "operationKind": "query",
        "text": null
    }
};
var $58f54a3a0d651497$export$2e2bcd8739ae039 = $58f54a3a0d651497$var$node;

});

parcelRegister("lMrpD", function(module, exports) {

let $fdb358306daa83eb$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $fdb358306daa83eb$var$load("ffQaD"),
    $fdb358306daa83eb$var$load("kvRbA"),
    $fdb358306daa83eb$var$load("fCQQy")
]).then(()=>parcelRequire('cwNeR'));

});



parcelRegister("BrpCW", function(module, exports) {

$parcel$export(module.exports, "entryPointDeprecated", () => $b39c17e33fa0794a$export$821fec5ea5acc81d);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $eXpsd = parcelRequire("eXpsd");

var $fo6b8 = parcelRequire("fo6b8");
const $b39c17e33fa0794a$export$821fec5ea5acc81d = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $eXpsd.incidentsPageEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("eXpsd", function(module, exports) {

$parcel$export(module.exports, "incidentsPageEntryPoint", () => $b93c8ec26a3d236d$export$a59477eea6e8cd7f);

var $d23s9 = parcelRequire("d23s9");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $b93c8ec26a3d236d$export$a59477eea6e8cd7f = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("01s5Y")).then((mod)=>mod.IncidentsPageLinkedServicesWrapper), {
        moduleId: "d6132459",
        priority: "userVisible"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId }, context: context })=>({
            queries: {
                incidentPageData: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $d23s9.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: context.match.params.projectKey ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("d23s9", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2978738121ef6b5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7699704d0995bbdc63133dc84290d5de>>
 * @relayHash bf929c95e6738104436e6a3b1e6f48cd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8822ca061f1e1e9e11103925231d8d61251ca06c569e9da069f1b3faa1183aaf
const $d2978738121ef6b5$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "8822ca061f1e1e9e11103925231d8d61251ca06c569e9da069f1b3faa1183aaf",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "after",
                    "direction": "forward",
                    "path": [
                        "jira",
                        "jiraProjectByKey",
                        "associatedComponents"
                    ]
                }
            ]
        },
        "name": "srcIncidentsLinkedServicesQuery",
        "operationKind": "query",
        "text": null
    }
};
var $d2978738121ef6b5$export$2e2bcd8739ae039 = $d2978738121ef6b5$var$node;

});

parcelRegister("01s5Y", function(module, exports) {

let $0045e33e605c1197$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0045e33e605c1197$var$load("ffQaD"),
    $0045e33e605c1197$var$load("kvRbA"),
    $0045e33e605c1197$var$load("7xTyk")
]).then(()=>parcelRequire('8c2Ir'));

});




parcelRegister("9MSQj", function(module, exports) {

$parcel$export(module.exports, "softwareIncidentsNextGenRouteEntry", () => $1e3d0627cbc31b1a$export$fd29243dbe4103);

var $e4eHl = parcelRequire("e4eHl");

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $jAXrH = parcelRequire("jAXrH");

var $9LHPC = parcelRequire("9LHPC");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $hb1PV = parcelRequire("hb1PV");

var $BrpCW = parcelRequire("BrpCW");
const $1e3d0627cbc31b1a$export$fd29243dbe4103 = (0, $7NszV.createEntry)((0, $jAXrH.softwareIncidentsNextGenRoute), ()=>({
        group: 'software',
        entryPoint () {
            return (0, $4R6GH.fg)('corex_operandi_incidents_page_in_jira') ? (0, $hb1PV.entryPoint) : (0, $BrpCW.entryPointDeprecated);
        },
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        skeleton: (0, $9LHPC.IncidentsPageSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource),
            (0, $7GnDe.incidentsInitialPageChecksResource),
            (0, $7GnDe.incidentsCustomFieldIdResource)
        ],
        meta: {
            reporting: {
                id: 'software-incidents',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-incidents'),
                teamName: 'operandi'
            }
        },
        ufoName: 'software-incidents',
        supportsPreviewPanel: true
    }));

});
parcelRegister("jAXrH", function(module, exports) {

$parcel$export(module.exports, "softwareIncidentsNextGenRoute", () => $cf2d0aff779a466b$export$12e1ca6c7cfdfd49);
const $cf2d0aff779a466b$export$12e1ca6c7cfdfd49 = {
    name: 'software-incidents',
    path: '/jira/software/projects/:projectKey/incidents'
};

});


parcelRegister("6FBN4", function(module, exports) {

$parcel$export(module.exports, "softwareListClassicRouteEntry", () => $9d676290a188f14d$export$4e2a0a97feb715a5);

var $7NszV = parcelRequire("7NszV");

var $cf2qA = parcelRequire("cf2qA");

var $aPfsS = parcelRequire("aPfsS");

var $e7bC3 = parcelRequire("e7bC3");

var $g5RGc = parcelRequire("g5RGc");

var $lmyls = parcelRequire("lmyls");

var $9s3j1 = parcelRequire("9s3j1");

var $2J9Xf = parcelRequire("2J9Xf");

var $5f2bR = parcelRequire("5f2bR");

var $aFVvc = parcelRequire("aFVvc");

var $iNzEe = parcelRequire("iNzEe");

var $l2N2a = parcelRequire("l2N2a");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $g4ZHz = parcelRequire("g4ZHz");

var $fKmub = parcelRequire("fKmub");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");

var $7KruY = parcelRequire("7KruY");
const $9d676290a188f14d$export$4e2a0a97feb715a5 = (0, $7NszV.createEntry)((0, $2J9Xf.softwareListClassicRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $cf2qA.ListSkeleton),
        entryPoint () {
            return 0, $7KruY.softwareListRouteEntry;
        },
        layout: (0, $aPfsS.composeLayouts)((0, $e7bC3.classicSoftwareProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        // TODO: This is a copy of getProjectViewResources, but it has been copied in order to replace
        //  with .
        resources: [
            // the below 5 resources are copied from getBusinessProjectResources
            // they should be feature flagged and removed when it is safe to do so or
            // moved out of business packages
            // start getBusinessProjectResources
            (0, $aFVvc.projectCreatePermissionsResource),
            (0, $iNzEe.navigationResource),
            // eslint-disable-next-line camelcase
            (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource),
            // end getBusinessProjectResources
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $g4ZHz.fieldsResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingEnabled)(), (0, $9V5k0.projectThemeResource))
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        ufoName: 'classic-list',
        supportsPreviewPanel: true
    }));

});
parcelRegister("cf2qA", function(module, exports) {

$parcel$export(module.exports, "ListSkeleton", () => $6a76608e47ef62ca$export$cbc3335f7a517046);
$parcel$export(module.exports, "ListEmbedSkeleton", () => $6a76608e47ef62ca$export$2638f1c98fe91c13);

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $aZ2R7 = parcelRequire("aZ2R7");

var $9vURY = parcelRequire("9vURY");
const $6a76608e47ef62ca$export$cbc3335f7a517046 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aZ2R7)))
    });
const $6a76608e47ef62ca$export$2638f1c98fe91c13 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9vURY)))
    });

});
parcelRegister("aZ2R7", function(module, exports) {
module.exports = new URL("list-app-skeleton.tpl.82508714.svg", import.meta.url).toString();

});

parcelRegister("9vURY", function(module, exports) {
module.exports = new URL("list-embed-app-skeleton.tpl.de94c811.svg", import.meta.url).toString();

});


parcelRegister("2J9Xf", function(module, exports) {

$parcel$export(module.exports, "softwareListClassicRoute", () => $cb27ddbacbb22539$export$1bf758507ca6b2);
const $cb27ddbacbb22539$export$1bf758507ca6b2 = {
    name: 'software-list-classic',
    path: '/jira/software/c/projects/:projectKey/list'
};

});

parcelRegister("7KruY", function(module, exports) {

$parcel$export(module.exports, "softwareListRouteEntry", () => $2190319388c8e440$export$f30a66efa682bf2d);
$parcel$export(module.exports, "softwareListEmbedRouteEntry", () => $2190319388c8e440$export$1099e0e49394fa9a);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $cv6Sw = parcelRequire("cv6Sw");

var $fo6b8 = parcelRequire("fo6b8");

var $3FuB0 = parcelRequire("3FuB0");
const $2190319388c8e440$export$f30a66efa682bf2d = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $3FuB0.listEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $2190319388c8e440$export$1099e0e49394fa9a = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $cv6Sw.listEmbedEntryPoint)
});

});
parcelRegister("cv6Sw", function(module, exports) {

$parcel$export(module.exports, "listEmbedEntryPoint", () => $ac51f9a325b99a16$export$519bb55e1612f243);

var $EVQo4 = parcelRequire("EVQo4");

var $dMRP9 = parcelRequire("dMRP9");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");
const $ac51f9a325b99a16$var$FORMAT_RULES_FIRST = 20;

const $ac51f9a325b99a16$export$519bb55e1612f243 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("80Xm0")), {
        moduleId: "5ed7fb43",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                listEmbedQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $dMRP9.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                formattingRulesQuery: {
                    parameters: (0, $EVQo4.default),
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId,
                        first: $ac51f9a325b99a16$var$FORMAT_RULES_FIRST
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        };
    }
});

});
parcelRegister("dMRP9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b295f91ae484cb56$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<834fddde735677817bb414d426c4ffa7>>
 * @relayHash b1d5bddbd0778f4be3f4876e1525e6f4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 661dfc8e2a4d3163499a24e3bae8c13315e369090fa8e455d22560e15a9e00f4
const $b295f91ae484cb56$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "661dfc8e2a4d3163499a24e3bae8c13315e369090fa8e455d22560e15a9e00f4",
        "metadata": {},
        "name": "src_jiraSoftwareListEmbedQuery",
        "operationKind": "query",
        "text": null
    }
};
var $b295f91ae484cb56$export$2e2bcd8739ae039 = $b295f91ae484cb56$var$node;

});

parcelRegister("80Xm0", function(module, exports) {

let $5d5c5d4a9c48805a$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $5d5c5d4a9c48805a$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $5d5c5d4a9c48805a$var$load("k6g9p")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $5d5c5d4a9c48805a$var$load("cTJTG"),
            $5d5c5d4a9c48805a$var$load("l253H"),
            $5d5c5d4a9c48805a$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $5d5c5d4a9c48805a$var$load("4Qxp7")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $5d5c5d4a9c48805a$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $5d5c5d4a9c48805a$var$load("7B2gt")
        ]);
    }),
    $5d5c5d4a9c48805a$var$load("ffQaD"),
    $5d5c5d4a9c48805a$var$load("kvRbA"),
    $5d5c5d4a9c48805a$var$load("3EILy")
]).then(()=>parcelRequire('6xPmp'));

});


parcelRegister("3FuB0", function(module, exports) {

$parcel$export(module.exports, "listEntryPoint", () => $093e9fa498e2d713$export$6be4f10150ff6073);

var $EVQo4 = parcelRequire("EVQo4");

var $eV4yn = parcelRequire("eV4yn");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");
const $093e9fa498e2d713$var$FORMAT_RULES_FIRST = 20;

const $093e9fa498e2d713$export$6be4f10150ff6073 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("3zP12")), {
        moduleId: "a7ba8596",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                listQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $eV4yn.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                formattingRulesQuery: {
                    parameters: (0, $EVQo4.default),
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId,
                        first: $093e9fa498e2d713$var$FORMAT_RULES_FIRST
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        };
    }
});

});
parcelRegister("eV4yn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1285db29ce222e8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9589819072a0d79deedb3286a1ad0e09>>
 * @relayHash 7ca7a7e73175fabcafbcca8378817432
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e63ab64e310db9403bb03770e66a53a6920f135e0096a5f8f31a3ac88d170c0b
const $a1285db29ce222e8$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "e63ab64e310db9403bb03770e66a53a6920f135e0096a5f8f31a3ac88d170c0b",
        "metadata": {},
        "name": "src_jiraSoftwareListQuery",
        "operationKind": "query",
        "text": null
    }
};
var $a1285db29ce222e8$export$2e2bcd8739ae039 = $a1285db29ce222e8$var$node;

});

parcelRegister("3zP12", function(module, exports) {

let $29ac36a0302c41b4$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $29ac36a0302c41b4$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $29ac36a0302c41b4$var$load("k6g9p")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $29ac36a0302c41b4$var$load("cTJTG"),
            $29ac36a0302c41b4$var$load("l253H"),
            $29ac36a0302c41b4$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $29ac36a0302c41b4$var$load("4Qxp7")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $29ac36a0302c41b4$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $29ac36a0302c41b4$var$load("7B2gt")
        ]);
    }),
    $29ac36a0302c41b4$var$load("ffQaD"),
    $29ac36a0302c41b4$var$load("kvRbA"),
    $29ac36a0302c41b4$var$load("dbP3D")
]).then(()=>parcelRequire('ycm07'));

});




parcelRegister("bhft0", function(module, exports) {

$parcel$export(module.exports, "softwareListEmbedClassicRouteEntry", () => $c10c597b1bd946e9$export$bdb096e193b6e97b);

var $7NszV = parcelRequire("7NszV");

var $1SjdQ = parcelRequire("1SjdQ");

var $cf2qA = parcelRequire("cf2qA");

var $6e4Kt = parcelRequire("6e4Kt");

var $aFVvc = parcelRequire("aFVvc");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $g4ZHz = parcelRequire("g4ZHz");

var $fKmub = parcelRequire("fKmub");

var $iNzEe = parcelRequire("iNzEe");

var $l2N2a = parcelRequire("l2N2a");

var $7KruY = parcelRequire("7KruY");
const $c10c597b1bd946e9$export$bdb096e193b6e97b = (0, $7NszV.createEntry)((0, $1SjdQ.softwareListEmbedClassicRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $cf2qA.ListEmbedSkeleton),
        entryPoint () {
            return 0, $7KruY.softwareListEmbedRouteEntry;
        },
        layout: (0, $6e4Kt.chromelessLayout),
        // TODO: This is a copy of getProjectViewResources, but it has been copied in order to expand getNavigationSidebarProjectResource
        resources: [
            // the below 5 resources are copied from getBusinessProjectResources
            // they should be feature flagged and removed when it is safe to do so or
            // moved out of business packages
            // start getBusinessProjectResources
            (0, $aFVvc.projectCreatePermissionsResource),
            (0, $iNzEe.navigationResource),
            // eslint-disable-next-line camelcase
            (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource),
            // end getBusinessProjectResources
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $g4ZHz.fieldsResource)
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        ufoName: 'classic-list-embed'
    }));

});
parcelRegister("1SjdQ", function(module, exports) {

$parcel$export(module.exports, "softwareListEmbedClassicRoute", () => $6541879b6a0ea94d$export$de5fcecec40b3c98);
const $6541879b6a0ea94d$export$de5fcecec40b3c98 = {
    name: 'software-list-classic-embed',
    path: '/jira/software/c/projects/:projectKey/list/embed'
};

});


parcelRegister("8Yag1", function(module, exports) {

$parcel$export(module.exports, "softwareListEmbedRouteEntry", () => $6b0e66505ae13519$export$1099e0e49394fa9a);

var $6e4Kt = parcelRequire("6e4Kt");

var $lkFvK = parcelRequire("lkFvK");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $f85YZ = parcelRequire("f85YZ");

var $cf2qA = parcelRequire("cf2qA");

var $cv6Sw = parcelRequire("cv6Sw");

var $aGBe9 = parcelRequire("aGBe9");
const $6b0e66505ae13519$var$listEmbedPageEntrypoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $cv6Sw.listEmbedEntryPoint)
});
const $6b0e66505ae13519$export$1099e0e49394fa9a = (0, $7NszV.createEntry)((0, $f85YZ.softwareListEmbedRoute), ()=>({
        group: 'software',
        skeleton: (0, $cf2qA.ListEmbedSkeleton),
        entryPoint () {
            return $6b0e66505ae13519$var$listEmbedPageEntrypoint;
        },
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $aGBe9.getListProjectResources)()
        ],
        ufoName: 'next-gen-list-embed'
    }));

});
parcelRegister("f85YZ", function(module, exports) {

$parcel$export(module.exports, "softwareListEmbedRoute", () => $7b234b63625cf68c$export$70dd8df584442004);
const $7b234b63625cf68c$export$70dd8df584442004 = {
    name: 'software-list-embed',
    path: '/jira/software/projects/:projectKey/list/embed'
};

});

parcelRegister("aGBe9", function(module, exports) {

$parcel$export(module.exports, "getListProjectResources", () => $5ae376cbaf33854f$export$7bd00eef349a268a);

var $g4ZHz = parcelRequire("g4ZHz");

var $iNzEe = parcelRequire("iNzEe");

var $l2N2a = parcelRequire("l2N2a");

var $aFVvc = parcelRequire("aFVvc");
const $5ae376cbaf33854f$export$7bd00eef349a268a = ()=>[
        (0, $aFVvc.projectCreatePermissionsResource),
        (0, $iNzEe.navigationResource),
        // eslint-disable-next-line camelcase
        (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource),
        (0, $g4ZHz.fieldsResource)
    ];

});


parcelRegister("2toxI", function(module, exports) {

$parcel$export(module.exports, "softwareListRouteEntry", () => $47240db4975f79b0$export$f30a66efa682bf2d);

var $lkFvK = parcelRequire("lkFvK");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $6L6XQ = parcelRequire("6L6XQ");

var $cf2qA = parcelRequire("cf2qA");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $3FuB0 = parcelRequire("3FuB0");

var $fo6b8 = parcelRequire("fo6b8");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");

var $aGBe9 = parcelRequire("aGBe9");
const $47240db4975f79b0$var$listPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $3FuB0.listEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $47240db4975f79b0$export$f30a66efa682bf2d = (0, $7NszV.createEntry)((0, $6L6XQ.softwareListRoute), ()=>({
        group: 'software',
        skeleton: (0, $cf2qA.ListSkeleton),
        entryPoint () {
            return $47240db4975f79b0$var$listPageEntrypoint;
        },
        layout: (0, $aPfsS.composeLayouts)((0, $e7bC3.softwareProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $aGBe9.getListProjectResources)(),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingEnabled)(), (0, $9V5k0.projectThemeResource))
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        ufoName: 'next-gen-list',
        supportsPreviewPanel: true
    }));

});
parcelRegister("6L6XQ", function(module, exports) {

$parcel$export(module.exports, "softwareListRoute", () => $da08ebba917aac54$export$f3a5b1b732315e13);
const $da08ebba917aac54$export$f3a5b1b732315e13 = {
    name: 'software-list',
    path: '/jira/software/projects/:projectKey/list'
};

});


parcelRegister("dBV2a", function(module, exports) {

$parcel$export(module.exports, "softwareNextgenRedirectRouteEntry", () => $8e109be01fe8b384$export$e328d22412aeb5cf);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $i4mNf = parcelRequire("i4mNf");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $7tQej = parcelRequire("7tQej");

var $kxZPA = parcelRequire("kxZPA");

var $7yO8g = parcelRequire("7yO8g");

var $21yN6 = parcelRequire("21yN6");
const $8e109be01fe8b384$var$SoftwareNextgenRedirectComponent = ({ location: location })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: (0, $21yN6.pickNextGenView)(location)
    });

const $8e109be01fe8b384$var$LazyBoardPage = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("3gYTm"))), {
    moduleId: "./src/packages/spa-apps/next-gen-board/src/index.tsx"
});
const $8e109be01fe8b384$export$e328d22412aeb5cf = (0, $7NszV.createEntry)((0, $i4mNf.softwareNextgenRedirectRoute), ()=>({
        group: 'software',
        component: $8e109be01fe8b384$var$SoftwareNextgenRedirectComponent,
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $8e109be01fe8b384$var$LazyBoardPage
        ]
    }));

});
parcelRegister("i4mNf", function(module, exports) {

$parcel$export(module.exports, "softwareNextgenRedirectRoute", () => $ddb4f261ae7c214b$export$6072946fe7f2d45a);
const $ddb4f261ae7c214b$export$6072946fe7f2d45a = {
    name: 'software-nextgen-redirect',
    path: '/secure/NextGen.jspa'
};

});

parcelRegister("21yN6", function(module, exports) {

$parcel$export(module.exports, "pickNextGenView", () => $4ad36038fa160dbe$export$8c47088cd9b527ba);

var $ebyGx = parcelRequire("ebyGx");
const $4ad36038fa160dbe$var$PLAN = 'planning';
const $4ad36038fa160dbe$var$REPORTING = 'reporting';
const $4ad36038fa160dbe$var$REPORTS = 'reports';
const $4ad36038fa160dbe$var$constructUrlForView = (url, view, searchResult)=>{
    if (view.startsWith($4ad36038fa160dbe$var$PLAN)) return `${url}/backlog`;
    if (view.startsWith($4ad36038fa160dbe$var$REPORTING) || view.startsWith($4ad36038fa160dbe$var$REPORTS)) {
        if (searchResult.report) return `${url}/reports/${searchResult.report}`;
        return `${url}/reports`;
    }
    return url;
};
const $4ad36038fa160dbe$var$KNOWN_KEYS = [
    'rapidView',
    'projectKey',
    'view',
    'report'
];
const $4ad36038fa160dbe$var$forwardUnknownQueryParams = (url, queryParams)=>{
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(Object.entries(queryParams).filter(([k])=>!$4ad36038fa160dbe$var$KNOWN_KEYS.includes(k)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((result, [k, v])=>({
            [k]: v,
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result
        }), {}));
    if (query) return `${url}?${query}`;
    return url;
};
const $4ad36038fa160dbe$export$8c47088cd9b527ba = (location)=>{
    const searchResult = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(location.search);
    const url = `/jira/software/projects/${searchResult.projectKey}/boards/${searchResult.rapidView}`;
    if (searchResult.view) return $4ad36038fa160dbe$var$forwardUnknownQueryParams($4ad36038fa160dbe$var$constructUrlForView(url, searchResult.view, searchResult), searchResult);
    return $4ad36038fa160dbe$var$forwardUnknownQueryParams(url, searchResult);
};

});


parcelRegister("5xsFH", function(module, exports) {

$parcel$export(module.exports, "softwareOnboardingRouteEntry", () => $048906688afed449$export$bb72a943d2340466);

var $4R6GH = parcelRequire("4R6GH");

var $6e4Kt = parcelRequire("6e4Kt");

var $7NszV = parcelRequire("7NszV");

var $c4yut = parcelRequire("c4yut");

var $2Ql51 = parcelRequire("2Ql51");

var $5TcuB = parcelRequire("5TcuB");

var $aFVvc = parcelRequire("aFVvc");

var $gNStA = parcelRequire("gNStA");

var $h9FIc = parcelRequire("h9FIc");
const $048906688afed449$export$bb72a943d2340466 = (0, $7NszV.createEntry)((0, $5TcuB.softwareOnboardingRoute), ()=>({
        group: 'software',
        component: (0, $h9FIc.SoftwareOnboardingPage),
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            (0, $c4yut.jswOnboardingResource),
            (0, $2Ql51.themePreferenceResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('onboarding_get_create_project_permission'), (0, $aFVvc.projectCreatePermissionsResource))
        ],
        forPaint: [
            (0, $h9FIc.LazySoftwareOnboardingPage)
        ],
        canTransitionIn: ()=>false
    }));

});
parcelRegister("c4yut", function(module, exports) {

$parcel$export(module.exports, "jswOnboardingResource", () => $1ebe6dd05980f4f8$export$be21a2d8a350a80);
$parcel$export(module.exports, "useJswOnboardingResource", () => $1ebe6dd05980f4f8$export$83f546a45ad58d0a);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


const $1ebe6dd05980f4f8$export$be21a2d8a350a80 = (0, $2M1hQ.createResource)({
    type: (0, $156934826e437e4d$export$692203fca66f4d77),
    getKey: ()=>'jsw_onboarding',
    getDataLoader: ()=>(parcelRequire("jp7dw"))
});
const $1ebe6dd05980f4f8$export$83f546a45ad58d0a = ()=>(0, $2YP9W.useResource)($1ebe6dd05980f4f8$export$be21a2d8a350a80);

});
const $156934826e437e4d$export$692203fca66f4d77 = 'RESOURCE_TYPE_SOFTWARE_ONBOARDING';

parcelRegister("jp7dw", function(module, exports) {

let $e205f348c47e9213$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e205f348c47e9213$var$load("4y5P7").then(()=>parcelRequire('4W57j'));

});


parcelRegister("5TcuB", function(module, exports) {

$parcel$export(module.exports, "softwareOnboardingRoute", () => $38b80aa1ac78feb2$export$5e6c92d2f34c1e48);
const $38b80aa1ac78feb2$export$5e6c92d2f34c1e48 = {
    name: 'software-onboarding',
    path: '/welcome/software',
    exact: true
};

});

parcelRegister("h9FIc", function(module, exports) {

$parcel$export(module.exports, "LazySoftwareOnboardingPage", () => $9d1d716191d31716$export$31e9f06d3389e445);
$parcel$export(module.exports, "SoftwareOnboardingPage", () => $9d1d716191d31716$export$ee768d69c6e3a8bd);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $9d1d716191d31716$export$31e9f06d3389e445 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("04bhT"))), {
    moduleId: "./src/packages/spa-apps/software/onboarding/src/index.tsx"
});
const $9d1d716191d31716$export$ee768d69c6e3a8bd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $9d1d716191d31716$export$31e9f06d3389e445,
        pageId: "software-onboarding",
        shouldShowSpinner: false
    });

});
parcelRegister("04bhT", function(module, exports) {

let $00c9215854ae9d60$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $00c9215854ae9d60$var$load("ffQaD"),
    $00c9215854ae9d60$var$load("kvRbA"),
    $00c9215854ae9d60$var$load("76n7a"),
    $00c9215854ae9d60$var$load("l253H"),
    $00c9215854ae9d60$var$load("hCQAW")
]).then(()=>parcelRequire('iCmWy'));

});



parcelRegister("7Db7a", function(module, exports) {

$parcel$export(module.exports, "softwarePeriscopeClassicRouteEntry", () => $12f7aae3d37ddd7e$export$d7d49c1a51b3c0a9);

var $e4eHl = parcelRequire("e4eHl");

var $c04PQ = parcelRequire("c04PQ");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $ajKFd = parcelRequire("ajKFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $dOiL8 = parcelRequire("dOiL8");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $6LsQE = parcelRequire("6LsQE");

var $kkNtb = parcelRequire("kkNtb");

var $iXbZm = parcelRequire("iXbZm");
const $12f7aae3d37ddd7e$export$d7d49c1a51b3c0a9 = (0, $7NszV.createEntry)((0, $dOiL8.softwarePeriscopeClassicRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $ajKFd.Skeleton),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource),
            (0, $kkNtb.rovoEntitlementResource)
        ],
        layout: (0, $e7bC3.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        entryPoint: ()=>{
            return (0, $c04PQ.isFedRamp)() ? (0, $6LsQE.notFoundPageEntrypoint) : (0, $iXbZm.periscopeEntryPoint);
        },
        meta: {
            reporting: {
                id: 'software-periscope-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-periscope-classic'),
                teamName: 'nova'
            }
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("ajKFd", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $b9eb4b3f312b449f$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "InsightsSkeleton", () => $b9eb4b3f312b449f$export$dd0b74c715df3275);
$parcel$export(module.exports, "SuggestionsSkeleton", () => $b9eb4b3f312b449f$export$91f27b306afd627b);
$parcel$export(module.exports, "WorkItemsSkeleton", () => $b9eb4b3f312b449f$export$1660f3159b79b22b);
$parcel$export(module.exports, "WorkItemsVulnTabSkeleton", () => $b9eb4b3f312b449f$export$5aea7d4ed03d6ea6);
$parcel$export(module.exports, "WorkItemsDeploymentTabSkeleton", () => $b9eb4b3f312b449f$export$ff38ee81427877e9);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $gUTyu = parcelRequire("gUTyu");

var $29cNf = parcelRequire("29cNf");
const $b9eb4b3f312b449f$export$8f31e4c4a37b8e9c = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $b9eb4b3f312b449f$var$MainContainerStyles,
        "data-testId": "software-periscope-periscope-page.ui.loading",
        "aria-label": formatMessage((0, $29cNf.default).label),
        gap: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $b9eb4b3f312b449f$var$leftColumnStyles,
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $b9eb4b3f312b449f$var$InsightsContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gUTyu.PeriscopeInsightsSkeleton), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $b9eb4b3f312b449f$var$WorkItemsContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gUTyu.PeriscopeWorkItemsSkeleton), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $b9eb4b3f312b449f$var$rightColumnStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $b9eb4b3f312b449f$var$SuggestionsContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gUTyu.PeriscopeSuggestionsSkeleton), null))));
};
const $b9eb4b3f312b449f$export$dd0b74c715df3275 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $b9eb4b3f312b449f$var$InsightsContainerStyles,
        "data-testId": "software-periscope-periscope-page.insights-ui.loading",
        "aria-label": formatMessage((0, $29cNf.default).insightsLabel),
        paddingBlockEnd: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gUTyu.PeriscopeInsightsSkeleton), null));
};
const $b9eb4b3f312b449f$export$91f27b306afd627b = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $b9eb4b3f312b449f$var$SuggestionsContainerStyles,
        "data-testId": "software-periscope-periscope-page.suggestions-ui.loading",
        "aria-label": formatMessage((0, $29cNf.default).suggestionsLabel),
        paddingBlockEnd: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gUTyu.PeriscopeSuggestionsSkeleton), null));
};
const $b9eb4b3f312b449f$export$1660f3159b79b22b = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $b9eb4b3f312b449f$var$WorkItemsContainerStyles,
        "aria-label": formatMessage((0, $29cNf.default).workItemsLabel),
        paddingBlockEnd: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gUTyu.PeriscopeWorkItemsSkeleton), null));
};
const $b9eb4b3f312b449f$export$5aea7d4ed03d6ea6 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $b9eb4b3f312b449f$var$WorkItemsVulnTabContainerStyles,
        "aria-label": formatMessage((0, $29cNf.default).workItemsVulnTabLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gUTyu.DevelopmentPageWorkItemsVulnTabSkeleton), null));
};
const $b9eb4b3f312b449f$export$ff38ee81427877e9 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $b9eb4b3f312b449f$var$WorkItemsContainerStyles,
        "aria-label": formatMessage((0, $29cNf.default).workItemsDeploymentTabLabel),
        paddingBlockEnd: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gUTyu.DevelopmentPageWorkItemsDeploymentTabSkeleton), null));
};
const $b9eb4b3f312b449f$var$MainContainerStyles = (0, $8CUq3.xcss)({
    width: '100%',
    height: '100%',
    display: 'flex',
    boxSizing: 'border-box',
    overflow: 'hidden'
});
const $b9eb4b3f312b449f$var$leftColumnStyles = (0, $8CUq3.xcss)({
    flex: '2 1 0'
});
const $b9eb4b3f312b449f$var$rightColumnStyles = (0, $8CUq3.xcss)({
    flex: '1 1 0'
});
const $b9eb4b3f312b449f$var$SuggestionsContainerStyles = (0, $8CUq3.xcss)({
    width: '100%',
    overflow: 'hidden',
    height: '650px',
    boxSizing: 'border-box'
});
const $b9eb4b3f312b449f$var$InsightsContainerStyles = (0, $8CUq3.xcss)({
    overflow: 'hidden',
    width: '100%',
    height: '385px',
    boxSizing: 'border-box'
});
const $b9eb4b3f312b449f$var$WorkItemsContainerStyles = (0, $8CUq3.xcss)({
    width: '100%',
    height: '600px',
    boxSizing: 'border-box',
    overflow: 'hidden'
});
const $b9eb4b3f312b449f$var$WorkItemsVulnTabContainerStyles = (0, $8CUq3.xcss)({
    width: '100%',
    height: '420px',
    boxSizing: 'border-box',
    overflow: 'hidden'
});

});
parcelRegister("gUTyu", function(module, exports) {

$parcel$export(module.exports, "PeriscopeSuggestionsSkeleton", () => $c6fead338751845c$export$176dfe4c14771136);
$parcel$export(module.exports, "PeriscopeInsightsSkeleton", () => $c6fead338751845c$export$afb44f298901be44);
$parcel$export(module.exports, "PeriscopeWorkItemsSkeleton", () => $c6fead338751845c$export$298a6b6a251923c2);
$parcel$export(module.exports, "DevelopmentPageWorkItemsVulnTabSkeleton", () => $c6fead338751845c$export$8940e0b80e4066d6);
$parcel$export(module.exports, "DevelopmentPageWorkItemsDeploymentTabSkeleton", () => $c6fead338751845c$export$2f5ed71a7df2d4e6);
$parcel$export(module.exports, "DevelopmentPageCodeAgentsTabSkeleton", () => $c6fead338751845c$export$e3f7fac0f7e53296);
/* PeriscopeSuggestionsSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $gwNZG = parcelRequire("gwNZG");

var $2geDY = parcelRequire("2geDY");

var $iWMaH = parcelRequire("iWMaH");

var $4BkIC = parcelRequire("4BkIC");

var $7wKMl = parcelRequire("7wKMl");

var $eb9Zy = parcelRequire("eb9Zy");

var $fIBLw = parcelRequire("fIBLw");

var $kqIMZ = parcelRequire("kqIMZ");
const $c6fead338751845c$var$PeriscopePageSkeletonStyles = null;
const $c6fead338751845c$export$4aecc030c4d69f74 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "skeletons.ui.periscope-page.app-skeleton-image-periscope-page-new",
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4BkIC)))
    }));
const $c6fead338751845c$export$176dfe4c14771136 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "skeletons.ui.periscope-page.app-suggestions-skeleton",
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7wKMl)))
    }));
const $c6fead338751845c$export$afb44f298901be44 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "skeletons.ui.periscope-page.app-insights-skeleton",
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2geDY)))
    }));
const $c6fead338751845c$export$298a6b6a251923c2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fIBLw)))
    }));
const $c6fead338751845c$export$8940e0b80e4066d6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eb9Zy)))
    }));
const $c6fead338751845c$export$2f5ed71a7df2d4e6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gwNZG)))
    }));
const $c6fead338751845c$export$e70f5fa3451855e2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "skeletons.ui.periscope-page.app-on-call-panel-skeleton",
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iWMaH)))
    }));
const $c6fead338751845c$export$e3f7fac0f7e53296 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "skeletons.ui.periscope-page.code-agents-tab-skeleton",
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kqIMZ)))
    }));

});
parcelRegister("gwNZG", function(module, exports) {
module.exports = new URL("deployment-tab-skeleton.tpl.6442d1f9.svg", import.meta.url).toString();

});

parcelRegister("2geDY", function(module, exports) {
module.exports = new URL("insights.tpl.c29b665e.svg", import.meta.url).toString();

});

parcelRegister("iWMaH", function(module, exports) {
module.exports = new URL("on-call-panel-skeleton.tpl.d7139b03.svg", import.meta.url).toString();

});

parcelRegister("4BkIC", function(module, exports) {
module.exports = new URL("periscope-page-full-layout.tpl.762dcdba.svg", import.meta.url).toString();

});

parcelRegister("7wKMl", function(module, exports) {
module.exports = new URL("suggestions.tpl.52cb06d0.svg", import.meta.url).toString();

});

parcelRegister("eb9Zy", function(module, exports) {
module.exports = new URL("vuln-tab-skeleton.tpl.1a18ea24.svg", import.meta.url).toString();

});

parcelRegister("fIBLw", function(module, exports) {
module.exports = new URL("work-items.tpl.4ee9e4f3.svg", import.meta.url).toString();

});

parcelRegister("kqIMZ", function(module, exports) {
module.exports = new URL("code-agents-tab-skeleton.tpl.874ad579.svg", import.meta.url).toString();

});


parcelRegister("29cNf", function(module, exports) {

$parcel$export(module.exports, "default", () => $34a050fcfbf5d355$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $34a050fcfbf5d355$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "periscope.skeleton.label",
        "defaultMessage": "Loading"
    },
    suggestionsLabel: {
        "id": "periscope.suggestions-skeleton.label",
        "defaultMessage": "Suggestions loading"
    },
    insightsLabel: {
        "id": "periscope.insights-skeleton.label",
        "defaultMessage": "Developer insights loading"
    },
    workItemsLabel: {
        "id": "periscope.work-items-skeleton.work-items-label",
        "defaultMessage": "Work items loading"
    },
    workItemsVulnTabLabel: {
        "id": "periscope.work-items-skeleton.work-items-vuln-tab-label",
        "defaultMessage": "Work items vulnerability tab loading"
    },
    workItemsDeploymentTabLabel: {
        "id": "periscope.work-items-skeleton.work-items-deployment-tab-label",
        "defaultMessage": "Work items deployment tab loading"
    },
    onCallPanelLabel: {
        "id": "periscope.on-call-skeleton.label",
        "defaultMessage": "On call panel loading"
    }
});

});


parcelRegister("dOiL8", function(module, exports) {

$parcel$export(module.exports, "softwarePeriscopeClassicRoute", () => $6b68b587bba860e4$export$cb5cec74f302b3c6);
const $6b68b587bba860e4$export$cb5cec74f302b3c6 = {
    name: 'software-periscope-classic',
    path: '/jira/software/c/projects/:projectKey/development'
};

});

parcelRegister("iXbZm", function(module, exports) {

$parcel$export(module.exports, "periscopeEntryPoint", () => $db17fefaaacf4384$export$5a8cf468a1d46d4);

var $egcs2 = parcelRequire("egcs2");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $fo6b8 = parcelRequire("fo6b8");
const $db17fefaaacf4384$export$5a8cf468a1d46d4 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $egcs2.periscopeEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("egcs2", function(module, exports) {

$parcel$export(module.exports, "periscopeEntrypoint", () => $6795745322f5a74e$export$89ba9048c6fd23c6);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $6795745322f5a74e$export$89ba9048c6fd23c6 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("4KVXE")), {
        moduleId: "11456a6c",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4KVXE", function(module, exports) {

let $37686b31bf936db4$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $37686b31bf936db4$var$load("ffQaD"),
    $37686b31bf936db4$var$load("kvRbA"),
    $37686b31bf936db4$var$load("fliVL"),
    $37686b31bf936db4$var$load("9wX7U")
]).then(()=>parcelRequire('k9ngM'));

});




parcelRegister("eFYGV", function(module, exports) {

$parcel$export(module.exports, "softwarePeriscopeNextGenRouteEntry", () => $e85cebcb4685b0b3$export$7db4d910357a4d89);

var $e4eHl = parcelRequire("e4eHl");

var $c04PQ = parcelRequire("c04PQ");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $ajKFd = parcelRequire("ajKFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $8VZpl = parcelRequire("8VZpl");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $6LsQE = parcelRequire("6LsQE");

var $kkNtb = parcelRequire("kkNtb");

var $iXbZm = parcelRequire("iXbZm");
const $e85cebcb4685b0b3$export$7db4d910357a4d89 = (0, $7NszV.createEntry)((0, $8VZpl.softwarePeriscopeNextGenRoute), ()=>({
        group: 'software',
        skeleton: (0, $ajKFd.Skeleton),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource),
            (0, $kkNtb.rovoEntitlementResource)
        ],
        entryPoint: ()=>{
            return (0, $c04PQ.isFedRamp)() ? (0, $6LsQE.notFoundPageEntrypoint) : (0, $iXbZm.periscopeEntryPoint);
        },
        meta: {
            reporting: {
                id: 'software-periscope',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-periscope'),
                teamName: 'nova'
            }
        }
    }));

});
parcelRegister("8VZpl", function(module, exports) {

$parcel$export(module.exports, "softwarePeriscopeNextGenRoute", () => $4e58e490b9dd84b4$export$9d0f329211395c25);
const $4e58e490b9dd84b4$export$9d0f329211395c25 = {
    name: 'software-periscope',
    path: '/jira/software/projects/:projectKey/development'
};

});


parcelRegister("lGnoq", function(module, exports) {

$parcel$export(module.exports, "softwarePlanCalendarRouteEntry", () => $4711dd8590f23118$export$67c64fea9be584ed);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");


var $87OsA = parcelRequire("87OsA");

var $2BrOV = parcelRequire("2BrOV");

var $8iyFV = parcelRequire("8iyFV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $8JbXO = parcelRequire("8JbXO");

var $kZOse = parcelRequire("kZOse");

var $4R6GH = parcelRequire("4R6GH");

var $bscjm = parcelRequire("bscjm");
const $4711dd8590f23118$export$67c64fea9be584ed = (0, $7NszV.createEntry)((0, $8JbXO.softwarePlanCalendarRoute), ()=>({
        group: 'software',
        ufoName: 'software-advanced-roadmaps-calendar',
        skeleton: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZOse.CalendarSkeleton), null),
        entryPoint () {
            (0, $87OsA.setCapability)((0, $281cbd47ba46dd7d$export$f999749ac7a2cd1));
            return (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? (0, $bscjm.planCalendarPageEntryPoint) : (0, $bscjm.planCalendarPageEntryPointWithoutHorizontalNavigation);
        },
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource),
            (0, $c3WQb.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default),
            horizontal: (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? undefined : (0, $8iyFV.AsyncHorizontalNavPlans),
            onlyShowHorizontalOnNav4: true
        },
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$f999749ac7a2cd1)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("8JbXO", function(module, exports) {

$parcel$export(module.exports, "softwarePlanCalendarRoute", () => $56322e0cc9119168$export$ca4c39d60ec156a2);
const $56322e0cc9119168$export$ca4c39d60ec156a2 = {
    name: 'software-plan-calendar',
    path: '/jira/plans/:planId/scenarios/:scenarioId/calendar'
};

});

parcelRegister("bscjm", function(module, exports) {

$parcel$export(module.exports, "planCalendarPageEntryPoint", () => $49df381ba8f49311$export$6e8a1c5de1f63c61);
$parcel$export(module.exports, "planCalendarPageEntryPointWithoutHorizontalNavigation", () => $49df381ba8f49311$export$71d7feb91869903);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $02tNK = parcelRequire("02tNK");

var $57oLc = parcelRequire("57oLc");
const $49df381ba8f49311$export$6e8a1c5de1f63c61 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $02tNK.calendarEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS,
    horizontalNavigation: (0, $57oLc.plansHorizontalNavigationEntryPoint)
});
const $49df381ba8f49311$export$71d7feb91869903 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $02tNK.calendarEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS
});

});


parcelRegister("6cMQO", function(module, exports) {

$parcel$export(module.exports, "softwarePlanDependenciesRouteEntry", () => $35d5ce46f5d8e5a8$export$103062f08086fba0);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $8iyFV = parcelRequire("8iyFV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $4twOY = parcelRequire("4twOY");

var $4R6GH = parcelRequire("4R6GH");

var $fq8uf = parcelRequire("fq8uf");

var $4xae4 = parcelRequire("4xae4");
const $35d5ce46f5d8e5a8$export$103062f08086fba0 = (0, $7NszV.createEntry)((0, $4twOY.softwarePlanDependenciesRoute), ()=>({
        group: 'software',
        entryPoint: ()=>// eslint-disable-next-line no-nested-ternary
            (0, $4R6GH.fg)('migrate_plans_to_entrypoints') ? (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? (0, $4xae4.planDependenciesReportPageEntryPoint) : (0, $4xae4.planDependenciesReportPageEntryPointWithoutHorizontalNavigation) : undefined,
        component: (0, $fq8uf.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource),
            (0, $c3WQb.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default),
            horizontal: (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? undefined : (0, $8iyFV.AsyncHorizontalNavPlans),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $fq8uf.LazyPlanDependenciesReport)
        ]
    }));

});
parcelRegister("4twOY", function(module, exports) {

$parcel$export(module.exports, "softwarePlanDependenciesRoute", () => $a253d414fb5970e7$export$ad8296aa5394f696);
const $a253d414fb5970e7$export$ad8296aa5394f696 = {
    name: 'software-plan-dependencies',
    path: '/jira/plans/:planId/scenarios/:scenarioId/dependencies'
};

});

parcelRegister("fq8uf", function(module, exports) {

$parcel$export(module.exports, "LazyPlanDependenciesReport", () => $bba44615f3e187dc$export$d4669c7a2f17c261);
$parcel$export(module.exports, "default", () => $bba44615f3e187dc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $bba44615f3e187dc$export$d4669c7a2f17c261 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("iIlWE"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-dependencies-report/index-old.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bba44615f3e187dc$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $bba44615f3e187dc$export$d4669c7a2f17c261,
        pageId: "plan-dependencies-report",
        shouldShowSpinner: true
    });

});

parcelRegister("4xae4", function(module, exports) {

$parcel$export(module.exports, "planDependenciesReportPageEntryPoint", () => $49c9e6a9627b668c$export$1d873335adb647af);
$parcel$export(module.exports, "planDependenciesReportPageEntryPointWithoutHorizontalNavigation", () => $49c9e6a9627b668c$export$5d979b028f8d2115);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $1zjAp = parcelRequire("1zjAp");

var $57oLc = parcelRequire("57oLc");
const $49c9e6a9627b668c$export$1d873335adb647af = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1zjAp.planDependenciesReportEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS,
    horizontalNavigation: (0, $57oLc.plansHorizontalNavigationEntryPoint)
});
const $49c9e6a9627b668c$export$5d979b028f8d2115 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1zjAp.planDependenciesReportEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS
});

});


parcelRegister("lxXtu", function(module, exports) {

$parcel$export(module.exports, "softwarePlanReleasesRouteEntry", () => $4095f2c0ec8f50cf$export$b874fabd66f10ff4);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $8iyFV = parcelRequire("8iyFV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $4doUI = parcelRequire("4doUI");

var $4R6GH = parcelRequire("4R6GH");

var $gbVLg = parcelRequire("gbVLg");

var $iSVrv = parcelRequire("iSVrv");
const $4095f2c0ec8f50cf$export$b874fabd66f10ff4 = (0, $7NszV.createEntry)((0, $4doUI.softwarePlanReleasesRoute), ()=>({
        group: 'software',
        entryPoint: ()=>// eslint-disable-next-line no-nested-ternary
            (0, $4R6GH.fg)('migrate_plans_to_entrypoints') ? (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? (0, $iSVrv.planReleasesPageEntryPoint) : (0, $iSVrv.planReleasesPageEntryPointWithoutHorizontalNavigation) : undefined,
        component: (0, $gbVLg.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource),
            (0, $c3WQb.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default),
            horizontal: (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? undefined : (0, $8iyFV.AsyncHorizontalNavPlans),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gbVLg.LazyPlanReleases)
        ]
    }));

});
parcelRegister("4doUI", function(module, exports) {

$parcel$export(module.exports, "softwarePlanReleasesRoute", () => $f06c9277915d7c48$export$850236b64b0aa28b);
const $f06c9277915d7c48$export$850236b64b0aa28b = {
    name: 'software-plan-releases',
    path: '/jira/plans/:planId/scenarios/:scenarioId/releases'
};

});

parcelRegister("gbVLg", function(module, exports) {

$parcel$export(module.exports, "LazyPlanReleases", () => $17bd378321c97c37$export$749f5d2513e04ec0);
$parcel$export(module.exports, "default", () => $17bd378321c97c37$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $17bd378321c97c37$export$749f5d2513e04ec0 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("1ualb"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-releases/index-old.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$17bd378321c97c37$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $17bd378321c97c37$export$749f5d2513e04ec0,
        pageId: "plan-releases",
        shouldShowSpinner: true
    });

});
parcelRegister("1ualb", function(module, exports) {

let $11509d3b7501d8e2$var$load = (parcelRequire("28QjX"))(4);





module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $11509d3b7501d8e2$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $11509d3b7501d8e2$var$load("k6g9p")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $11509d3b7501d8e2$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $11509d3b7501d8e2$var$load("7B2gt")
        ]);
    }),
    $11509d3b7501d8e2$var$load("ffQaD"),
    $11509d3b7501d8e2$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("6FDky"), 4)),
    $11509d3b7501d8e2$var$load("76n7a"),
    $11509d3b7501d8e2$var$load("l253H"),
    $11509d3b7501d8e2$var$load("fliVL"),
    $11509d3b7501d8e2$var$load("bFT3g")
]).then(()=>parcelRequire('jRZ9A'));

});


parcelRegister("iSVrv", function(module, exports) {

$parcel$export(module.exports, "planReleasesPageEntryPoint", () => $dc2ebda85f38ad5d$export$accb0033190d648e);
$parcel$export(module.exports, "planReleasesPageEntryPointWithoutHorizontalNavigation", () => $dc2ebda85f38ad5d$export$10abe27e6c5044b);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $a3dKc = parcelRequire("a3dKc");

var $57oLc = parcelRequire("57oLc");
const $dc2ebda85f38ad5d$export$accb0033190d648e = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $a3dKc.planReleasesEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS,
    horizontalNavigation: (0, $57oLc.plansHorizontalNavigationEntryPoint)
});
const $dc2ebda85f38ad5d$export$10abe27e6c5044b = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $a3dKc.planReleasesEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS
});

});
parcelRegister("a3dKc", function(module, exports) {

$parcel$export(module.exports, "planReleasesEntryPoint", () => $68da7936f39bec4e$export$4e18896acd7f3236);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $68da7936f39bec4e$export$4e18896acd7f3236 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("llXYZ")), {
        moduleId: "e3e1145d",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("llXYZ", function(module, exports) {

let $f8ba16729dd32d9a$var$load = (parcelRequire("28QjX"))(4);





module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $f8ba16729dd32d9a$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $f8ba16729dd32d9a$var$load("k6g9p")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $f8ba16729dd32d9a$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $f8ba16729dd32d9a$var$load("7B2gt")
        ]);
    }),
    $f8ba16729dd32d9a$var$load("ffQaD"),
    $f8ba16729dd32d9a$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("dINId"), 4)),
    $f8ba16729dd32d9a$var$load("76n7a"),
    $f8ba16729dd32d9a$var$load("l253H"),
    $f8ba16729dd32d9a$var$load("fliVL"),
    $f8ba16729dd32d9a$var$load("8KTk8")
]).then(()=>parcelRequire('1rmO9'));

});




parcelRegister("2l6sh", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsAutoSchedulerRouteEntry", () => $78ac61c21ed5f382$export$fc7007717398c727);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $4AnBP = parcelRequire("4AnBP");

var $gicWA = parcelRequire("gicWA");
const $78ac61c21ed5f382$export$fc7007717398c727 = (0, $7NszV.createEntry)((0, $4AnBP.softwarePlanSettingsAutoSchedulerRoute), ()=>({
        group: 'software',
        component: (0, $gicWA.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gicWA.LazyPlanSettingsAutoScheduler)
        ]
    }));

});
parcelRegister("4AnBP", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsAutoSchedulerRoute", () => $4586083606b00135$export$e44088b2cc0206cf);
const $4586083606b00135$export$e44088b2cc0206cf = {
    name: 'plan-settings-auto-scheduler',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/auto-scheduler'
};

});

parcelRegister("gicWA", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsAutoScheduler", () => $632fd0e21b8de9c8$export$8bcf7155849993f5);
$parcel$export(module.exports, "default", () => $632fd0e21b8de9c8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $632fd0e21b8de9c8$export$8bcf7155849993f5 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("e6wJ7"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/auto-scheduler/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$632fd0e21b8de9c8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $632fd0e21b8de9c8$export$8bcf7155849993f5,
        pageId: "plan-settings-auto-scheduler",
        shouldShowSpinner: true
    });

});
parcelRegister("e6wJ7", function(module, exports) {

let $a44b030f9854c046$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("aoPiL"), 4)),
    $a44b030f9854c046$var$load("veUgl")
]).then(()=>parcelRequire('9U7wJ'));

});



parcelRegister("1C9Ha", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsCustomFieldsRouteEntry", () => $e3235a40cee1f9ea$export$89472d9db6946668);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $6UGjg = parcelRequire("6UGjg");

var $eNKly = parcelRequire("eNKly");
const $e3235a40cee1f9ea$export$89472d9db6946668 = (0, $7NszV.createEntry)((0, $6UGjg.softwarePlanSettingsCustomFieldsRoute), ()=>({
        group: 'software',
        component: (0, $eNKly.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $eNKly.LazyPlanSettingsCustomFields)
        ]
    }));

});
parcelRegister("6UGjg", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsCustomFieldsRoute", () => $8173736a5bf38da1$export$2634cd63c73f7a35);
const $8173736a5bf38da1$export$2634cd63c73f7a35 = {
    name: 'plan-settings-custom-fields',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/custom-fields'
};

});

parcelRegister("eNKly", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsCustomFields", () => $7a181f322c9e7d25$export$72bf44dbae2383e5);
$parcel$export(module.exports, "default", () => $7a181f322c9e7d25$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $7a181f322c9e7d25$export$72bf44dbae2383e5 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("ljZcC"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/custom-fields/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7a181f322c9e7d25$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $7a181f322c9e7d25$export$72bf44dbae2383e5,
        pageId: "plan-settings-custom-fields",
        shouldShowSpinner: true
    });

});
parcelRegister("ljZcC", function(module, exports) {

let $f85ad8d8ffc398ff$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $f85ad8d8ffc398ff$var$load("ffQaD"),
    $f85ad8d8ffc398ff$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("exBDB"), 4)),
    $f85ad8d8ffc398ff$var$load("62GDd")
]).then(()=>parcelRequire('j09X0'));

});



parcelRegister("cChHY", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsExclusionRulesRouteEntry", () => $8d454372873657bb$export$cd1b612d0c014154);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $47gJb = parcelRequire("47gJb");

var $e3mpc = parcelRequire("e3mpc");
const $8d454372873657bb$export$cd1b612d0c014154 = (0, $7NszV.createEntry)((0, $47gJb.softwarePlanSettingsExclusionRulesRoute), ()=>({
        group: 'software',
        component: (0, $e3mpc.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $e3mpc.LazyPlanSettingsExclusionRules)
        ]
    }));

});
parcelRegister("47gJb", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsExclusionRulesRoute", () => $520050550cd1f444$export$358b0ca69a4bd731);
const $520050550cd1f444$export$358b0ca69a4bd731 = {
    name: 'plan-settings-exclusion-rules',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/exclusion-rules'
};

});

parcelRegister("e3mpc", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsExclusionRules", () => $9ac014b7d5fdabc4$export$78f61b03c267e6d9);
$parcel$export(module.exports, "default", () => $9ac014b7d5fdabc4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $9ac014b7d5fdabc4$export$78f61b03c267e6d9 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("ETjZK"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/exclusion-rules/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9ac014b7d5fdabc4$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $9ac014b7d5fdabc4$export$78f61b03c267e6d9,
        pageId: "plan-settings-exclusion-rules",
        shouldShowSpinner: true
    });

});
parcelRegister("ETjZK", function(module, exports) {

let $07aea63d1f7c620e$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("l1Bcq"), 4)),
    $07aea63d1f7c620e$var$load("dAVXW")
]).then(()=>parcelRequire('8InOA'));

});



parcelRegister("1oew5", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsFeaturesRouteEntry", () => $4837f30fa1f1d2ac$export$591e778de9bccacd);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $6s1PB = parcelRequire("6s1PB");

var $5M6NY = parcelRequire("5M6NY");

var $YTuky = parcelRequire("YTuky");
const $4837f30fa1f1d2ac$export$591e778de9bccacd = (0, $7NszV.createEntry)((0, $5M6NY.softwarePlanSettingsFeaturesRoute), ()=>({
        group: 'software',
        entryPoint: ()=>(0, $6s1PB.expValEquals)('m1_features_page_experiment', 'cohort', 'variation') ? (0, $YTuky.planSettingsFeaturesRouteEntry) : undefined,
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("5M6NY", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsFeaturesRoute", () => $858c2043fb3d5ae0$export$2e79af7413eb4921);
const $858c2043fb3d5ae0$export$2e79af7413eb4921 = {
    name: 'plan-settings-features',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/features'
};

});

parcelRegister("YTuky", function(module, exports) {

$parcel$export(module.exports, "planSettingsFeaturesRouteEntry", () => $d035cdee6bee40d9$export$2cf26c8369ef29cd);

var $lkFvK = parcelRequire("lkFvK");

var $i91HP = parcelRequire("i91HP");

var $lmyls = parcelRequire("lmyls");
const $d035cdee6bee40d9$export$2cf26c8369ef29cd = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $i91HP.planSettingsFeaturesEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS
});

});
parcelRegister("i91HP", function(module, exports) {

$parcel$export(module.exports, "planSettingsFeaturesEntryPoint", () => $d303a29161d5fb6f$export$ae1839f07bffa153);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $gXbDA = parcelRequire("gXbDA");

const $d303a29161d5fb6f$export$ae1839f07bffa153 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("f3jAf")), {
        moduleId: "3d5245c7",
        priority: "userVisible"
    }),
    getPreloadProps: (entryPointParams)=>{
        return {
            entryPoints: {
                preLoadFeaturesEntryPoint: {
                    entryPoint: (0, $gXbDA.featuresEntryPoint),
                    entryPointParams: entryPointParams
                }
            }
        };
    }
});

});
parcelRegister("gXbDA", function(module, exports) {

$parcel$export(module.exports, "featuresEntryPoint", () => $fad526df981ee212$export$e283e7092d12783d);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $ep7p9 = parcelRequire("ep7p9");

var $4R6GH = parcelRequire("4R6GH");
const $fad526df981ee212$var$toPlanAri = ({ siteId: siteId, activationId: activationId, planId: planId })=>{
    return `ari:cloud:jira:${siteId}:plan/activation/${activationId}/${planId}`;
};

const $fad526df981ee212$export$e283e7092d12783d = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("7s8oM")), {
        moduleId: "2bffebe5",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: { match: match }, tenantContext: tenantContext })=>{
        return {
            queries: {
                plan: {
                    variables: {
                        planId: $fad526df981ee212$var$toPlanAri({
                            siteId: tenantContext.cloudId,
                            activationId: tenantContext.activationId,
                            planId: String(match.params.planId)
                        }),
                        releasesFeatureGateEnabled: (0, $4R6GH.fg)('simple-plans-m2-release-feature-toggle'),
                        planSettingRefreshEnabled: (0, $4R6GH.fg)('plan_settings_refresh')
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $ep7p9.default
                }
            }
        };
    }
});

});
parcelRegister("ep7p9", function(module, exports) {

$parcel$export(module.exports, "default", () => $32ff4e592db83849$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7ba327901bde6343f0f8977263495a61>>
 * @relayHash 3005ddf30678cbf39055c070ff7f15ef
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 44e5b4e28fbfa841edf74d46388681eb22eb60b2c617054dc398ec9b08607cea
const $32ff4e592db83849$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "44e5b4e28fbfa841edf74d46388681eb22eb60b2c617054dc398ec9b08607cea",
        "metadata": {},
        "name": "uiFeaturesPlansSettingsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $32ff4e592db83849$export$2e2bcd8739ae039 = $32ff4e592db83849$var$node;

});

parcelRegister("7s8oM", function(module, exports) {

let $56d1a9be3d1ec2ea$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("kjz94"), 4)),
    $56d1a9be3d1ec2ea$var$load("8mnby")
]).then(()=>parcelRequire('3CODU'));

});


parcelRegister("f3jAf", function(module, exports) {

let $af5653b7497b597d$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("16B2y"), 4)),
    $af5653b7497b597d$var$load("adOUk")
]).then(()=>parcelRequire('3DDDy'));

});




parcelRegister("d1sI7", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsFindYourIssueRouteEntry", () => $e49a66463b867d46$export$2f975c505121e139);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $7sttJ = parcelRequire("7sttJ");

var $4tFWF = parcelRequire("4tFWF");
const $e49a66463b867d46$export$2f975c505121e139 = (0, $7NszV.createEntry)((0, $7sttJ.softwarePlanSettingsFindYourIssueRoute), ()=>({
        group: 'software',
        component: (0, $4tFWF.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4tFWF.LazyPlanSettingsFindYourIssue)
        ]
    }));

});
parcelRegister("7sttJ", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsFindYourIssueRoute", () => $bcf3aac3d05c5191$export$ab61883f74eb27c2);
const $bcf3aac3d05c5191$export$ab61883f74eb27c2 = {
    name: 'plan-settings-find-your-issue',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/find-your-issue'
};

});

parcelRegister("4tFWF", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsFindYourIssue", () => $428ba58b4dd0959f$export$731998664b7d5e72);
$parcel$export(module.exports, "default", () => $428ba58b4dd0959f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $428ba58b4dd0959f$export$731998664b7d5e72 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("20Tq1"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/find-your-issue/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$428ba58b4dd0959f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $428ba58b4dd0959f$export$731998664b7d5e72,
        pageId: "plan-settings-find-your-issue",
        shouldShowSpinner: true
    });

});
parcelRegister("20Tq1", function(module, exports) {

let $177691e1cb78197a$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("bxHwH"), 4)),
    $177691e1cb78197a$var$load("ivbLk")
]).then(()=>parcelRequire('ZLjUl'));

});



parcelRegister("gksya", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsIssueSourcesRouteEntry", () => $c2b7559ef928e7c4$export$f0b7e9788ab79be0);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $ewGjs = parcelRequire("ewGjs");

var $f4F08 = parcelRequire("f4F08");
const $c2b7559ef928e7c4$export$f0b7e9788ab79be0 = (0, $7NszV.createEntry)((0, $ewGjs.softwarePlanSettingsIssueSourcesRoute), ()=>({
        group: 'software',
        component: (0, $f4F08.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $f4F08.LazyPlanSettingsIssueSources)
        ]
    }));

});
parcelRegister("ewGjs", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsIssueSourcesRoute", () => $da9ac2a12ec5cdcc$export$fa18324265e4400c);
const $da9ac2a12ec5cdcc$export$fa18324265e4400c = {
    name: 'plan-settings-issue-sources',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/issue-sources'
};

});

parcelRegister("f4F08", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsIssueSources", () => $b7fcbd3d5b96d4a9$export$7ba4b487efcedeb3);
$parcel$export(module.exports, "default", () => $b7fcbd3d5b96d4a9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $b7fcbd3d5b96d4a9$export$7ba4b487efcedeb3 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("7gYlB"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/issue-sources/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b7fcbd3d5b96d4a9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $b7fcbd3d5b96d4a9$export$7ba4b487efcedeb3,
        pageId: "plan-settings-issue-sources",
        shouldShowSpinner: !(0, $4R6GH.fg)('plan_settings_refresh')
    });

});
parcelRegister("7gYlB", function(module, exports) {

let $54b8d6c4b5bf2de1$var$load = (parcelRequire("28QjX"))(4);




module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $54b8d6c4b5bf2de1$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $54b8d6c4b5bf2de1$var$load("k6g9p")
        ]);
    }),
    $54b8d6c4b5bf2de1$var$load("ffQaD"),
    $54b8d6c4b5bf2de1$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("dsOKO"), 4)),
    $54b8d6c4b5bf2de1$var$load("eRlku")
]).then(()=>parcelRequire('1GCm8'));

});



parcelRegister("l0UsI", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsPermissionsRouteEntry", () => $d78d9c80df28a675$export$1afc7a9efa99340);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $gofRF = parcelRequire("gofRF");

var $9X2gP = parcelRequire("9X2gP");
const $d78d9c80df28a675$export$1afc7a9efa99340 = (0, $7NszV.createEntry)((0, $gofRF.softwarePlanSettingsPermissionsRoute), ()=>({
        group: 'software',
        component: (0, $9X2gP.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $9X2gP.LazyPlanSettingsPermissions)
        ]
    }));

});
parcelRegister("gofRF", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsPermissionsRoute", () => $c8e4ae667061a76b$export$6734c29372722a5e);
const $c8e4ae667061a76b$export$6734c29372722a5e = {
    name: 'plan-settings-permissions',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/permissions'
};

});

parcelRegister("9X2gP", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsPermissions", () => $8e8c7a9f7faf5b90$export$49f5b76ad5c06a42);
$parcel$export(module.exports, "default", () => $8e8c7a9f7faf5b90$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $8e8c7a9f7faf5b90$export$49f5b76ad5c06a42 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("4qz9P"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/permissions/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8e8c7a9f7faf5b90$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8e8c7a9f7faf5b90$export$49f5b76ad5c06a42,
        pageId: "plan-settings-permissions",
        shouldShowSpinner: true
    });

});
parcelRegister("4qz9P", function(module, exports) {

let $3394dcb581b6b5a0$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("EG3aS"), 4)),
    $3394dcb581b6b5a0$var$load("9Jw7b")
]).then(()=>parcelRequire('dx76p'));

});



parcelRegister("bdHl5", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsPlanInfoRouteEntry", () => $d7dc38a99726fee2$export$1d6300da0c837e02);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $91wHh = parcelRequire("91wHh");

var $l3vqO = parcelRequire("l3vqO");
const $d7dc38a99726fee2$export$1d6300da0c837e02 = (0, $7NszV.createEntry)((0, $91wHh.softwarePlanSettingsPlanInfoRoute), ()=>({
        group: 'software',
        component: (0, $l3vqO.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $l3vqO.LazyPlanSettingsPlanInfo)
        ]
    }));

});
parcelRegister("91wHh", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsPlanInfoRoute", () => $6fdc9140d3fd71a2$export$76e6bdc959f6fa97);
const $6fdc9140d3fd71a2$export$76e6bdc959f6fa97 = {
    name: 'plan-settings-plan-info',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/plan-info'
};

});

parcelRegister("l3vqO", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsPlanInfo", () => $891dc4fe265590fb$export$c1344fd7d24991b3);
$parcel$export(module.exports, "default", () => $891dc4fe265590fb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $4R6GH = parcelRequire("4R6GH");

const $891dc4fe265590fb$export$c1344fd7d24991b3 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("3N39D"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/plan-info/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$891dc4fe265590fb$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $891dc4fe265590fb$export$c1344fd7d24991b3,
        pageId: "plan-settings-plan-info",
        shouldShowSpinner: !(0, $4R6GH.fg)('plan_settings_refresh')
    });

});
parcelRegister("3N39D", function(module, exports) {

let $2c28651b85adb9e6$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("2snPh"), 4)),
    $2c28651b85adb9e6$var$load("k4CBp")
]).then(()=>parcelRequire('8aOgd'));

});



parcelRegister("5hvg3", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsProgramBoardsRouteEntry", () => $6183d6997fcdbcf0$export$be96222796ad98f0);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $4jvUD = parcelRequire("4jvUD");

var $jMgFt = parcelRequire("jMgFt");
const $6183d6997fcdbcf0$export$be96222796ad98f0 = (0, $7NszV.createEntry)((0, $4jvUD.softwarePlanSettingsProgramBoardsRoute), ()=>({
        group: 'software',
        component: (0, $jMgFt.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jMgFt.LazyPlanSettingsProgramBoards)
        ]
    }));

});
parcelRegister("4jvUD", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsProgramBoardsRoute", () => $8498ace38f0217d4$export$3d54c48a91a178c0);
const $8498ace38f0217d4$export$3d54c48a91a178c0 = {
    name: 'plan-settings-program-boards',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/program-boards'
};

});

parcelRegister("jMgFt", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsProgramBoards", () => $fc0346cc52c0eaa1$export$ffdec728a47c437c);
$parcel$export(module.exports, "default", () => $fc0346cc52c0eaa1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $fc0346cc52c0eaa1$export$ffdec728a47c437c = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hcBYn"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/program-boards/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fc0346cc52c0eaa1$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $fc0346cc52c0eaa1$export$ffdec728a47c437c,
        pageId: "plan-settings-program-boards",
        shouldShowSpinner: true
    });

});
parcelRegister("hcBYn", function(module, exports) {

let $c861034a11507f97$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("9J6CZ"), 4)),
    $c861034a11507f97$var$load("egdrc")
]).then(()=>parcelRequire('cckoo'));

});



parcelRegister("6oWts", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsRemovedIssuesRouteEntry", () => $304853a89d046ccf$export$53a9ea0e0b05ceb5);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $12t4Y = parcelRequire("12t4Y");

var $4a0AK = parcelRequire("4a0AK");
const $304853a89d046ccf$export$53a9ea0e0b05ceb5 = (0, $7NszV.createEntry)((0, $12t4Y.softwarePlanSettingsRemovedIssuesRoute), ()=>({
        group: 'software',
        component: (0, $4a0AK.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4a0AK.LazyPlanSettingsRemovedIssues)
        ]
    }));

});
parcelRegister("12t4Y", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsRemovedIssuesRoute", () => $1a8d996cecbe9939$export$8b77532ba9798e64);
const $1a8d996cecbe9939$export$8b77532ba9798e64 = {
    name: 'plan-settings-removed-issues',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/removed-issues'
};

});

parcelRegister("4a0AK", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsRemovedIssues", () => $1ba44a18046961e4$export$759df6301ec72119);
$parcel$export(module.exports, "default", () => $1ba44a18046961e4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $1ba44a18046961e4$export$759df6301ec72119 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("kXvOT"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/removed-issues/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1ba44a18046961e4$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $1ba44a18046961e4$export$759df6301ec72119,
        pageId: "plan-settings-removed-issues",
        shouldShowSpinner: true
    });

});
parcelRegister("kXvOT", function(module, exports) {

let $f422001ecf4c6569$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $f422001ecf4c6569$var$load("ffQaD"),
    $f422001ecf4c6569$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("5xzb8"), 4)),
    $f422001ecf4c6569$var$load("2zaD5")
]).then(()=>parcelRequire('mRA5P'));

});



parcelRegister("76RJj", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsSavedViewsRouteEntry", () => $cbe1aa5484552af9$export$64d5b46da2e58194);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $gEyvh = parcelRequire("gEyvh");

var $lY1iq = parcelRequire("lY1iq");
const $cbe1aa5484552af9$export$64d5b46da2e58194 = (0, $7NszV.createEntry)((0, $gEyvh.softwarePlanSettingsSavedViewsRoute), ()=>({
        group: 'software',
        component: (0, $lY1iq.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $lY1iq.LazyPlanSettingsSavedViews)
        ]
    }));

});
parcelRegister("gEyvh", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsSavedViewsRoute", () => $606c26c5c4fe38cc$export$a0fec30f475e8756);
const $606c26c5c4fe38cc$export$a0fec30f475e8756 = {
    name: 'plan-settings-saved-views',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/saved-views'
};

});

parcelRegister("lY1iq", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsSavedViews", () => $9469a9a95c6fd42f$export$a5398542699d356a);
$parcel$export(module.exports, "default", () => $9469a9a95c6fd42f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $4R6GH = parcelRequire("4R6GH");

const $9469a9a95c6fd42f$export$a5398542699d356a = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("97BGI"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/saved-views/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9469a9a95c6fd42f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $9469a9a95c6fd42f$export$a5398542699d356a,
        pageId: "plan-settings-saved-views",
        shouldShowSpinner: !(0, $4R6GH.fg)('plan_settings_refresh')
    });

});
parcelRegister("97BGI", function(module, exports) {

let $6a42009194573a6f$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $6a42009194573a6f$var$load("ffQaD"),
    $6a42009194573a6f$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("f4Oqf"), 4)),
    $6a42009194573a6f$var$load("j1a8y")
]).then(()=>parcelRequire('k5TsF'));

});



parcelRegister("ikfu9", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsScenariosRouteEntry", () => $9368211e7352bb42$export$9b6e6b5d471b90f);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $4a5PZ = parcelRequire("4a5PZ");

var $6o8sS = parcelRequire("6o8sS");
const $9368211e7352bb42$export$9b6e6b5d471b90f = (0, $7NszV.createEntry)((0, $4a5PZ.softwarePlanSettingsScenariosRoute), ()=>({
        group: 'software',
        component: (0, $6o8sS.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6o8sS.LazyPlanSettingsScenarios)
        ]
    }));

});
parcelRegister("4a5PZ", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsScenariosRoute", () => $56e039c24697690f$export$d32efeefb944c6b7);
const $56e039c24697690f$export$d32efeefb944c6b7 = {
    name: 'plan-settings-scenarios',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/scenarios'
};

});

parcelRegister("6o8sS", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsScenarios", () => $3744eed80f080771$export$94104fcc1a6f460f);
$parcel$export(module.exports, "default", () => $3744eed80f080771$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $3744eed80f080771$export$94104fcc1a6f460f = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("8ZV6c"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/scenarios/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3744eed80f080771$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3744eed80f080771$export$94104fcc1a6f460f,
        pageId: "plan-settings-scenarios",
        shouldShowSpinner: true
    });

});
parcelRegister("8ZV6c", function(module, exports) {

let $68d04fe3208557cf$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("flByN"), 4)),
    $68d04fe3208557cf$var$load("jZz7i")
]).then(()=>parcelRequire('iF2yt'));

});



parcelRegister("g7fao", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsSchedulingRouteEntry", () => $cf0e25b45377825b$export$c1319dec79812860);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $eLpuR = parcelRequire("eLpuR");

var $TAgAs = parcelRequire("TAgAs");
const $cf0e25b45377825b$export$c1319dec79812860 = (0, $7NszV.createEntry)((0, $eLpuR.softwarePlanSettingsSchedulingRoute), ()=>({
        group: 'software',
        component: (0, $TAgAs.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $TAgAs.LazyPlanSettingsScheduling)
        ]
    }));

});
parcelRegister("eLpuR", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsSchedulingRoute", () => $e1fdd34e8b323da3$export$a215ef374dd2a8a9);
const $e1fdd34e8b323da3$export$a215ef374dd2a8a9 = {
    name: 'plan-settings-scheduling',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/scheduling'
};

});

parcelRegister("TAgAs", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsScheduling", () => $5e451d261b446f20$export$3bf11db1bbeae73e);
$parcel$export(module.exports, "default", () => $5e451d261b446f20$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $4R6GH = parcelRequire("4R6GH");

var $kxZPA = parcelRequire("kxZPA");

const $5e451d261b446f20$export$3bf11db1bbeae73e = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("e5uJ4"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/scheduling/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5e451d261b446f20$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $5e451d261b446f20$export$3bf11db1bbeae73e,
        pageId: "plan-settings-scheduling",
        shouldShowSpinner: !(0, $4R6GH.fg)('plan_settings_refresh')
    });

});
parcelRegister("e5uJ4", function(module, exports) {

let $a4195dd36c08eab1$var$load = (parcelRequire("28QjX"))(4);





module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $a4195dd36c08eab1$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $a4195dd36c08eab1$var$load("k6g9p")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $a4195dd36c08eab1$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $a4195dd36c08eab1$var$load("7B2gt")
        ]);
    }),
    $a4195dd36c08eab1$var$load("ffQaD"),
    $a4195dd36c08eab1$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("flj7g"), 4)),
    $a4195dd36c08eab1$var$load("76n7a"),
    $a4195dd36c08eab1$var$load("l253H"),
    $a4195dd36c08eab1$var$load("fliVL"),
    $a4195dd36c08eab1$var$load("9AO6b")
]).then(()=>parcelRequire('j3U5Q'));

});



parcelRegister("8s6qp", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSummaryRouteEntry", () => $e2353036f7312b49$export$4bc10767887a84cc);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $8iyFV = parcelRequire("8iyFV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $lv9xW = parcelRequire("lv9xW");

var $3RJkv = parcelRequire("3RJkv");

var $jUoVn = parcelRequire("jUoVn");

var $4R6GH = parcelRequire("4R6GH");

var $35bOg = parcelRequire("35bOg");

var $3v1Zf = parcelRequire("3v1Zf");
const $e2353036f7312b49$export$4bc10767887a84cc = (0, $7NszV.createEntry)((0, $jUoVn.softwarePlanSummaryRoute), ()=>({
        group: 'software',
        entryPoint: ()=>// eslint-disable-next-line no-nested-ternary
            (0, $4R6GH.fg)('migrate_plans_to_entrypoints') ? (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? (0, $3v1Zf.planSummaryPageEntryPoint) : (0, $3v1Zf.planSummaryPageEntryPointWithoutHorizontalNavigation) : undefined,
        ufoName: 'software-advanced-roadmaps-summary',
        component: (0, $35bOg.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $lv9xW.advancedRoadmapsSummaryDataResource),
            (0, $c3WQb.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default),
            horizontal: (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? undefined : (0, $8iyFV.AsyncHorizontalNavPlans),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $35bOg.LazyPlanSummary)
        ]
    }));

});
parcelRegister("jUoVn", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSummaryRoute", () => $ad2d61946557db6b$export$25a8cf27557a612d);
const $ad2d61946557db6b$export$25a8cf27557a612d = {
    name: 'software-plan-summary',
    path: '/jira/plans/:planId/scenarios/:scenarioId/summary'
};

});

parcelRegister("35bOg", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSummary", () => $d70e7ef12abe6465$export$c717f0d9d7f11b49);
$parcel$export(module.exports, "default", () => $d70e7ef12abe6465$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $d70e7ef12abe6465$export$c717f0d9d7f11b49 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("irZA1"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-summary/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d70e7ef12abe6465$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d70e7ef12abe6465$export$c717f0d9d7f11b49,
        pageId: "plan-summary",
        shouldShowSpinner: true
    });

});

parcelRegister("3v1Zf", function(module, exports) {

$parcel$export(module.exports, "planSummaryPageEntryPoint", () => $2ab6a879960150e5$export$a3858cce1e973f19);
$parcel$export(module.exports, "planSummaryPageEntryPointWithoutHorizontalNavigation", () => $2ab6a879960150e5$export$581542c1c5ef42f8);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $739vE = parcelRequire("739vE");

var $57oLc = parcelRequire("57oLc");
const $2ab6a879960150e5$export$a3858cce1e973f19 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $739vE.planSummaryEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS,
    horizontalNavigation: (0, $57oLc.plansHorizontalNavigationEntryPoint)
});
const $2ab6a879960150e5$export$581542c1c5ef42f8 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $739vE.planSummaryEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS
});

});


parcelRegister("qruNQ", function(module, exports) {

$parcel$export(module.exports, "softwarePlanTeamsRouteEntry", () => $ed7f2a4db7ff0a01$export$cc5b7d3f8546a313);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $8iyFV = parcelRequire("8iyFV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $fFiNA = parcelRequire("fFiNA");

var $4R6GH = parcelRequire("4R6GH");

var $44giz = parcelRequire("44giz");

var $40ny3 = parcelRequire("40ny3");
const $ed7f2a4db7ff0a01$export$cc5b7d3f8546a313 = (0, $7NszV.createEntry)((0, $fFiNA.softwarePlanTeamsRoute), ()=>({
        group: 'software',
        entryPoint: ()=>// eslint-disable-next-line no-nested-ternary
            (0, $4R6GH.fg)('migrate_plans_to_entrypoints') ? (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? (0, $40ny3.planTeamsPageEntryPoint) : (0, $40ny3.planTeamsPageEntryPointWithoutHorizontalNavigation) : undefined,
        component: (0, $44giz.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default),
            horizontal: (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? undefined : (0, $8iyFV.AsyncHorizontalNavPlans),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $44giz.LazyPlanTeams)
        ]
    }));

});
parcelRegister("fFiNA", function(module, exports) {

$parcel$export(module.exports, "softwarePlanTeamsRoute", () => $132f449f27d99391$export$fc66f5c0de18ddc7);
const $132f449f27d99391$export$fc66f5c0de18ddc7 = {
    name: 'software-plan-teams',
    path: '/jira/plans/:planId/scenarios/:scenarioId/teams'
};

});

parcelRegister("44giz", function(module, exports) {

$parcel$export(module.exports, "LazyPlanTeams", () => $243c6380c0240648$export$f85952f98f28fed0);
$parcel$export(module.exports, "default", () => $243c6380c0240648$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $243c6380c0240648$export$f85952f98f28fed0 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("b3mLi"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-teams/index-old.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$243c6380c0240648$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $243c6380c0240648$export$f85952f98f28fed0,
        pageId: "plan-teams",
        shouldShowSpinner: true
    });

});
parcelRegister("b3mLi", function(module, exports) {

let $80c1a18e1dfac05f$var$load = (parcelRequire("28QjX"))(4);





module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $80c1a18e1dfac05f$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $80c1a18e1dfac05f$var$load("k6g9p")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $80c1a18e1dfac05f$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $80c1a18e1dfac05f$var$load("7B2gt")
        ]);
    }),
    $80c1a18e1dfac05f$var$load("ffQaD"),
    $80c1a18e1dfac05f$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("koUPy"), 4)),
    $80c1a18e1dfac05f$var$load("76n7a"),
    $80c1a18e1dfac05f$var$load("l253H"),
    $80c1a18e1dfac05f$var$load("fliVL"),
    $80c1a18e1dfac05f$var$load("5fkxK")
]).then(()=>parcelRequire('gEN7m'));

});


parcelRegister("40ny3", function(module, exports) {

$parcel$export(module.exports, "planTeamsPageEntryPoint", () => $7b0bfdd4f2079663$export$e75b3c6626974862);
$parcel$export(module.exports, "planTeamsPageEntryPointWithoutHorizontalNavigation", () => $7b0bfdd4f2079663$export$16a85e75293f1984);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $dhgMR = parcelRequire("dhgMR");

var $57oLc = parcelRequire("57oLc");
const $7b0bfdd4f2079663$export$e75b3c6626974862 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $dhgMR.planTeamsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS,
    horizontalNavigation: (0, $57oLc.plansHorizontalNavigationEntryPoint)
});
const $7b0bfdd4f2079663$export$16a85e75293f1984 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $dhgMR.planTeamsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS
});

});
parcelRegister("dhgMR", function(module, exports) {

$parcel$export(module.exports, "planTeamsEntryPoint", () => $1ae70864b1d134b4$export$afd1c95955e9abac);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $1ae70864b1d134b4$export$afd1c95955e9abac = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("6LJqB")), {
        moduleId: "8c4bf459",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("6LJqB", function(module, exports) {

let $4eda5eee28713dfd$var$load = (parcelRequire("28QjX"))(4);





module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $4eda5eee28713dfd$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $4eda5eee28713dfd$var$load("k6g9p")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $4eda5eee28713dfd$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $4eda5eee28713dfd$var$load("7B2gt")
        ]);
    }),
    $4eda5eee28713dfd$var$load("ffQaD"),
    $4eda5eee28713dfd$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("1ygtG"), 4)),
    $4eda5eee28713dfd$var$load("76n7a"),
    $4eda5eee28713dfd$var$load("l253H"),
    $4eda5eee28713dfd$var$load("fliVL"),
    $4eda5eee28713dfd$var$load("3dqFA")
]).then(()=>parcelRequire('j7IwW'));

});




parcelRegister("4chTT", function(module, exports) {

$parcel$export(module.exports, "softwarePlanTimelineRouteEntry", () => $970ae3ae6d33a9e3$export$c5b46ecd4d9a8abd);

var $ffza4 = parcelRequire("ffza4");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $8iyFV = parcelRequire("8iyFV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $2oTRI = parcelRequire("2oTRI");

var $g6wgl = parcelRequire("g6wgl");

var $cnLXu = parcelRequire("cnLXu");
const $970ae3ae6d33a9e3$export$c5b46ecd4d9a8abd = (0, $7NszV.createEntry)((0, $2oTRI.softwarePlanTimelineRoute), ()=>({
        group: 'software',
        entryPoint: ()=>// eslint-disable-next-line no-nested-ternary
            (0, $4R6GH.fg)('migrate_plans_to_entrypoints') ? (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? (0, $cnLXu.planTimelinePageEntryPoint) : (0, $cnLXu.planTimelinePageEntryPointWithoutHorizontalNavigation) : undefined,
        component: (0, $g6wgl.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource),
            (0, $c3WQb.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default),
            horizontal: (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? undefined : (0, $8iyFV.AsyncHorizontalNavPlans),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $g6wgl.LazyPlanTimeline)
        ]
    }));

});
parcelRegister("cnLXu", function(module, exports) {

$parcel$export(module.exports, "planTimelinePageEntryPoint", () => $1450d939edbc2ee3$export$7ee5b399f9530a72);
$parcel$export(module.exports, "planTimelinePageEntryPointWithoutHorizontalNavigation", () => $1450d939edbc2ee3$export$2476bbde953fbfc0);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $4Xa0b = parcelRequire("4Xa0b");

var $57oLc = parcelRequire("57oLc");
const $1450d939edbc2ee3$export$7ee5b399f9530a72 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $4Xa0b.planTimelineEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS,
    horizontalNavigation: (0, $57oLc.plansHorizontalNavigationEntryPoint)
});
const $1450d939edbc2ee3$export$2476bbde953fbfc0 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $4Xa0b.planTimelineEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS
});

});


parcelRegister("2LfmF", function(module, exports) {

$parcel$export(module.exports, "softwareProformaIssueFormsDirectEmbedRouteEntry", () => $035b18afb2a6d438$export$6df3cef5dab31b3b);

var $6e4Kt = parcelRequire("6e4Kt");

var $7NszV = parcelRequire("7NszV");

var $dxCvy = parcelRequire("dxCvy");

var $6WV7L = parcelRequire("6WV7L");

var $edJLT = parcelRequire("edJLT");
const $035b18afb2a6d438$export$6df3cef5dab31b3b = (0, $7NszV.createEntry)((0, $6WV7L.softwareProformaIssueFormsDirectEmbedRoute), ()=>({
        group: 'software',
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            (0, $dxCvy.projectContextResource)
        ],
        component: (0, $edJLT.default),
        forPaint: [
            (0, $edJLT.LazyProformaIssueFormsDirectEmbed)
        ],
        perfMetricKey: 'issue-forms-direct-embed'
    }));

});
parcelRegister("6WV7L", function(module, exports) {

$parcel$export(module.exports, "softwareProformaIssueFormsDirectEmbedRoute", () => $1f48b8cd07e58720$export$6d1b944aeb758fdb);
const $1f48b8cd07e58720$export$6d1b944aeb758fdb = {
    name: 'software-proforma-issue-forms-direct-embed',
    path: '/jira/software/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?/embed',
    exact: true
};

});


parcelRegister("gzdNI", function(module, exports) {

$parcel$export(module.exports, "softwareProformaIssueFormsDirectRouteEntry", () => $d039f624036d1510$export$552db754a91368f3);

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $dxCvy = parcelRequire("dxCvy");

var $cLf5Y = parcelRequire("cLf5Y");

var $e7bC3 = parcelRequire("e7bC3");

var $6VQ64 = parcelRequire("6VQ64");
const $d039f624036d1510$export$552db754a91368f3 = (0, $7NszV.createEntry)((0, $cLf5Y.softwareProformaIssueFormsDirectRoute), ()=>({
        group: 'software',
        layout: (0, $e7bC3.softwareProjectLayout),
        resources: [
            (0, $dxCvy.projectContextResource)
        ],
        entryPoint: ()=>(0, $6VQ64.proformaIssueFormsDirectPageEntryPoint),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        perfMetricKey: 'issue-forms-direct'
    }));

});
parcelRegister("cLf5Y", function(module, exports) {

$parcel$export(module.exports, "softwareProformaIssueFormsDirectRoute", () => $8a64da0a8be5ef24$export$69db7046ead228b9);
const $8a64da0a8be5ef24$export$69db7046ead228b9 = {
    name: 'software-proforma-issue-forms-direct',
    path: '/jira/software/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?',
    exact: true
};

});


parcelRegister("ghTLp", function(module, exports) {

$parcel$export(module.exports, "softwareReleaseNotesRouteEntry", () => $6dee187be32572f9$export$543aad2020051ecb);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $9URQe = parcelRequire("9URQe");

var $e7bC3 = parcelRequire("e7bC3");

var $9PHNK = parcelRequire("9PHNK");
const $6dee187be32572f9$export$543aad2020051ecb = (0, $7NszV.createEntry)((0, $9URQe.softwareReleaseNotesRoute), ()=>({
        group: 'project-settings-software',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $dxCvy.projectContextResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        component: (0, $9PHNK.SpaReleaseNoteRedirectToVersionDetails),
        layout: (0, $e7bC3.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("9URQe", function(module, exports) {

$parcel$export(module.exports, "softwareReleaseNotesRoute", () => $45e41e5c15f76352$export$a0223091962262d4);
const $45e41e5c15f76352$export$a0223091962262d4 = {
    name: 'software-release-notes',
    path: '/secure/ReleaseNote.jspa',
    query: [
        'projectId'
    ]
};

});


parcelRegister("ickyX", function(module, exports) {

$parcel$export(module.exports, "softwareReportsBurndownRouteEntry", () => $0b40776c7df01e72$export$c54d6c6781ad5beb);

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $89ZnT = parcelRequire("89ZnT");

var $e7bC3 = parcelRequire("e7bC3");

var $4GBKo = parcelRequire("4GBKo");

var $bekEk = parcelRequire("bekEk");
const $0b40776c7df01e72$export$c54d6c6781ad5beb = (0, $7NszV.createEntry)((0, $89ZnT.softwareReportsBurndownRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.burndown-chart',
        entryPoint: ()=>(0, $bekEk.BurnDownReportPageEntrypoint),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $4GBKo.getTMPReportsCommonResource)()
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("89ZnT", function(module, exports) {

$parcel$export(module.exports, "softwareReportsBurndownRoute", () => $07e07ef6a15f8aed$export$e0d8c26cb1430ae4);
const $07e07ef6a15f8aed$export$e0d8c26cb1430ae4 = {
    name: 'software-reports-burndown',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/burndown'
};

});

parcelRegister("4GBKo", function(module, exports) {

$parcel$export(module.exports, "getTMPReportsCommonResource", () => $e8677532a1aaea76$export$f234446c23dc22a);

var $48Ij3 = parcelRequire("48Ij3");

var $gcI3W = parcelRequire("gcI3W");

var $4Bwc0 = parcelRequire("4Bwc0");
const $e8677532a1aaea76$export$8cb713295e6b7204 = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $e8677532a1aaea76$export$f234446c23dc22a = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $48Ij3.staticSidebarJSWReportsResource)
    ];

});

parcelRegister("bekEk", function(module, exports) {

$parcel$export(module.exports, "BurnDownReportPageEntrypoint", () => $51e496184ed5259a$export$4cba13cb70183e0e);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $i9CHX = parcelRequire("i9CHX");
const $51e496184ed5259a$export$4cba13cb70183e0e = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $i9CHX.burnDownReportEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("i9CHX", function(module, exports) {

$parcel$export(module.exports, "burnDownReportEntrypoint", () => $851cca1e4d3acad5$export$ca10f29d444e87e0);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $851cca1e4d3acad5$export$ca10f29d444e87e0 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("9nVzW")), {
        moduleId: "24e2d8d6",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9nVzW", function(module, exports) {

let $6d52ecf47c61aafe$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6d52ecf47c61aafe$var$load("ffQaD"),
    $6d52ecf47c61aafe$var$load("kvRbA"),
    $6d52ecf47c61aafe$var$load("6PbDg")
]).then(()=>parcelRequire('68CUZ'));

});




parcelRegister("cQer4", function(module, exports) {

$parcel$export(module.exports, "softwareReportsBurnupRouteEntry", () => $5e67b01b927c6e1e$export$e53193d8a7e7d068);

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $hlvYO = parcelRequire("hlvYO");

var $e7bC3 = parcelRequire("e7bC3");

var $4GBKo = parcelRequire("4GBKo");

var $c3kjm = parcelRequire("c3kjm");
const $5e67b01b927c6e1e$export$e53193d8a7e7d068 = (0, $7NszV.createEntry)((0, $hlvYO.softwareReportsBurnupRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.burnup-chart',
        entryPoint: ()=>(0, $c3kjm.BurnUpReportPageEntrypoint),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $4GBKo.getTMPReportsCommonResource)()
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("hlvYO", function(module, exports) {

$parcel$export(module.exports, "softwareReportsBurnupRoute", () => $7e7ef0af528823d4$export$5b818a6914ca8376);
const $7e7ef0af528823d4$export$5b818a6914ca8376 = {
    name: 'software-reports-burnup',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/burnup'
};

});

parcelRegister("c3kjm", function(module, exports) {

$parcel$export(module.exports, "BurnUpReportPageEntrypoint", () => $2f0cf451fae61f8d$export$5901b46abc65034e);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $30BHv = parcelRequire("30BHv");
const $2f0cf451fae61f8d$export$5901b46abc65034e = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $30BHv.burnUpReportEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("30BHv", function(module, exports) {

$parcel$export(module.exports, "burnUpReportEntrypoint", () => $d72ad05161bd39f0$export$dfec2f14e71954f6);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $d72ad05161bd39f0$export$dfec2f14e71954f6 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("juvbk")), {
        moduleId: "a1ebcc2d",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("juvbk", function(module, exports) {

let $e30901b1ca931e6a$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e30901b1ca931e6a$var$load("ffQaD"),
    $e30901b1ca931e6a$var$load("kvRbA"),
    $e30901b1ca931e6a$var$load("do7nn")
]).then(()=>parcelRequire('e2Cll'));

});




parcelRegister("eL5iv", function(module, exports) {

$parcel$export(module.exports, "softwareReportsControlRouteEntry", () => $c03e5ec50f5b41d2$export$3cb9570ca242f2a2);

var $e4eHl = parcelRequire("e4eHl");

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $dL9sv = parcelRequire("dL9sv");

var $6LsQE = parcelRequire("6LsQE");

var $kfztd = parcelRequire("kfztd");

var $e7bC3 = parcelRequire("e7bC3");

var $4GBKo = parcelRequire("4GBKo");

var $9XjvH = parcelRequire("9XjvH");
const $c03e5ec50f5b41d2$export$3cb9570ca242f2a2 = (0, $7NszV.createEntry)((0, $dL9sv.softwareReportsControlRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.control-chart',
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $4GBKo.getTMPReportsCommonResource)()
        ],
        entryPoint: ()=>!(0, $4R6GH.fg)('jsw_enable_avp_control_chart') || (0, $kfztd.isDevopsFeatureDisabledInFedRamp)() ? (0, $6LsQE.notFoundPageEntrypoint) : (0, $9XjvH.softwareReportsControlPageEntrypoint),
        meta: {
            reporting: {
                id: 'software-reports-control',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-reports-control'),
                teamName: 'helios-reports'
            }
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("dL9sv", function(module, exports) {

$parcel$export(module.exports, "softwareReportsControlRoute", () => $5f561127b557eb0e$export$8c91815cd4b1c078);
const $5f561127b557eb0e$export$8c91815cd4b1c078 = {
    name: 'software-reports-control',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/control'
};

});

parcelRegister("9XjvH", function(module, exports) {

$parcel$export(module.exports, "softwareReportsControlPageEntrypoint", () => $a8fc70484e9dc624$export$a35d50a33df2f6d5);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $1UEHs = parcelRequire("1UEHs");
const $a8fc70484e9dc624$export$a35d50a33df2f6d5 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1UEHs.softwareReportsControlEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("1UEHs", function(module, exports) {

$parcel$export(module.exports, "softwareReportsControlEntrypoint", () => $0b50ae414867ca7f$export$240870c8f3915828);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $0b50ae414867ca7f$export$240870c8f3915828 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("3tgyR")), {
        moduleId: "00c05b16",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3tgyR", function(module, exports) {

let $2870ed44dfe26b89$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $2870ed44dfe26b89$var$load("kNFvF"),
    $2870ed44dfe26b89$var$load("ffQaD"),
    $2870ed44dfe26b89$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("jfbWR"), 4)),
    $2870ed44dfe26b89$var$load("fliVL"),
    $2870ed44dfe26b89$var$load("76n7a"),
    $2870ed44dfe26b89$var$load("l253H"),
    $2870ed44dfe26b89$var$load("44AFW")
]).then(()=>parcelRequire('fXW64'));

});




parcelRegister("7MlOX", function(module, exports) {

$parcel$export(module.exports, "softwareReportsCumulativeRouteEntry", () => $940a759ddc17038b$export$7ace4d0363d78b41);

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $7QybL = parcelRequire("7QybL");

var $e7bC3 = parcelRequire("e7bC3");

var $4GBKo = parcelRequire("4GBKo");

var $5v1XH = parcelRequire("5v1XH");
const $940a759ddc17038b$export$7ace4d0363d78b41 = (0, $7NszV.createEntry)((0, $7QybL.softwareReportsCumulativeRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.cumulative-flow-diagram',
        entryPoint: ()=>(0, $5v1XH.CumulativeReportPageEntrypoint),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $4GBKo.getTMPReportsCommonResource)()
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("7QybL", function(module, exports) {

$parcel$export(module.exports, "softwareReportsCumulativeRoute", () => $63045e7bbaab9903$export$3c48ddd40d00b0d2);
const $63045e7bbaab9903$export$3c48ddd40d00b0d2 = {
    name: 'software-reports-cumulative',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/cumulative'
};

});

parcelRegister("5v1XH", function(module, exports) {

$parcel$export(module.exports, "CumulativeReportPageEntrypoint", () => $d11158d5657ed65b$export$2f3ad380ae691fb5);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $7D9Jw = parcelRequire("7D9Jw");
const $d11158d5657ed65b$export$2f3ad380ae691fb5 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7D9Jw.cumulativeReportEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("7D9Jw", function(module, exports) {

$parcel$export(module.exports, "cumulativeReportEntrypoint", () => $d56a1e4bf358cfa4$export$f01a8d84f5a47478);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $d56a1e4bf358cfa4$export$f01a8d84f5a47478 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("6bltS")), {
        moduleId: "d640aef5",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("6bltS", function(module, exports) {

let $48046ecbdd5bac6c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $48046ecbdd5bac6c$var$load("ffQaD"),
    $48046ecbdd5bac6c$var$load("kvRbA"),
    $48046ecbdd5bac6c$var$load("kd1UR")
]).then(()=>parcelRequire('ejLY3'));

});




parcelRegister("lHzMh", function(module, exports) {

$parcel$export(module.exports, "softwareReportsCycleTimeClassicBoardRouteEntry", () => $5825ca5195a81fcb$export$9c40eb459ce6a0bc);

var $e4eHl = parcelRequire("e4eHl");

var $7NszV = parcelRequire("7NszV");

var $7AHcB = parcelRequire("7AHcB");

var $7XYc4 = parcelRequire("7XYc4");

var $kfztd = parcelRequire("kfztd");

var $5lsNZ = parcelRequire("5lsNZ");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $2GkDw = parcelRequire("2GkDw");

var $ffza4 = parcelRequire("ffza4");

var $c04PQ = parcelRequire("c04PQ");

var $4R6GH = parcelRequire("4R6GH");

var $6LsQE = parcelRequire("6LsQE");

var $gxiIi = parcelRequire("gxiIi");

var $yxwH0 = parcelRequire("yxwH0");

var $89cBA = parcelRequire("89cBA");
const $5825ca5195a81fcb$export$9c40eb459ce6a0bc = (0, $7NszV.createEntry)((0, $7AHcB.softwareReportsCycleTimeClassicBoardRoute), ()=>({
        group: 'classic-software',
        component: (0, $7XYc4.componentWithCondition)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $gxiIi.CycleTimeReportClassic)),
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('entrypoint_migration_reports_cycle_time_classic')) {
                if ((0, $c04PQ.isFedRamp)()) return 0, $6LsQE.notFoundPageEntrypoint;
                return 0, $89cBA.cycleTimeReportClassicPageEntrypoint;
            }
            return undefined;
        },
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $yxwH0.getReportsCommonResource)(),
            (0, $2GkDw.devOpsProviderResource)
        ],
        afterPaint: [
            (0, $gxiIi.LazyCycleTimeReport)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gxiIi.LazyCycleTimeReport)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            reporting: {
                id: 'software-reports-cycle-time-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-reports-cycle-time-classic'),
                teamName: 'fusion-solaris'
            }
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("7AHcB", function(module, exports) {

$parcel$export(module.exports, "softwareReportsCycleTimeClassicBoardRoute", () => $49ddf385f7fbe750$export$12423e360eb5fa9d);
const $49ddf385f7fbe750$export$12423e360eb5fa9d = {
    name: 'software-reports-cycle-time-classic-board',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/cycle-time',
    exact: true
};

});

parcelRegister("2GkDw", function(module, exports) {

$parcel$export(module.exports, "devOpsProviderResource", () => $3640b01f63c1fd17$export$19e58e21b24ae0d8);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


const $3640b01f63c1fd17$export$19e58e21b24ae0d8 = (0, $2M1hQ.createResource)({
    type: (0, $e9cf201ab81d4288$export$5f92e516f4b78544),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("5PDRl")),
    maxAge: 60000
});
const $3640b01f63c1fd17$export$b80f5852c41a5ca8 = ()=>(0, $2YP9W.useResource)($3640b01f63c1fd17$export$19e58e21b24ae0d8);

});
const $e9cf201ab81d4288$export$5f92e516f4b78544 = 'SOFTWARE_DEVOPS_PROVIDERS';
const $e9cf201ab81d4288$export$d7f081d6dd0e72fc = 'bitbucket';
const $e9cf201ab81d4288$export$832d1d859726f915 = 'kRiZ7boFApjBINFF1L7wPrCa4iF8O6R9';
const $e9cf201ab81d4288$export$5007979ef33118fc = 'cOwtZiBfejjJAryJH0WPb1otsa4HrI1N';

parcelRegister("5PDRl", function(module, exports) {

let $43f0a26567ddd7ef$var$load = (parcelRequire("28QjX"))(4);
module.exports = $43f0a26567ddd7ef$var$load("kPLWf").then(()=>parcelRequire('2MQ7j'));

});


parcelRegister("gxiIi", function(module, exports) {

$parcel$export(module.exports, "LazyCycleTimeReport", () => $670577022d2fb7b4$export$956f830ed027f1fb);
$parcel$export(module.exports, "CycleTimeReportClassic", () => $670577022d2fb7b4$export$237924ba64065cc3);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $670577022d2fb7b4$export$956f830ed027f1fb = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("bdsFD")), {
    moduleId: "./src/packages/spa-apps/cycle-time-report/src/ui/index-old.tsx"
});
const $670577022d2fb7b4$export$e16ce0656a74a015 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $670577022d2fb7b4$export$956f830ed027f1fb,
        pageId: "cycleTimeReportNextGen",
        shouldShowSpinner: true
    });
const $670577022d2fb7b4$export$237924ba64065cc3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $670577022d2fb7b4$export$956f830ed027f1fb,
        pageId: "cycleTimeReportClassic",
        shouldShowSpinner: true
    });

});
parcelRegister("bdsFD", function(module, exports) {

let $82a725ff3612589c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $82a725ff3612589c$var$load("ffQaD"),
    $82a725ff3612589c$var$load("kvRbA"),
    $82a725ff3612589c$var$load("lN50H")
]).then(()=>parcelRequire('2DLxB'));

});


parcelRegister("89cBA", function(module, exports) {

$parcel$export(module.exports, "cycleTimeReportClassicPageEntrypoint", () => $f19a24813079175a$export$2dba7a1bad1f01b2);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $4i2WV = parcelRequire("4i2WV");
const $f19a24813079175a$export$2dba7a1bad1f01b2 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $4i2WV.cycleTimeReportEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("4i2WV", function(module, exports) {

$parcel$export(module.exports, "cycleTimeReportEntrypoint", () => $922dd77a7bbacdbf$export$a4c2e42865ef5d9d);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $922dd77a7bbacdbf$export$a4c2e42865ef5d9d = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("7FlYI")), {
        moduleId: "4e89963f",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("7FlYI", function(module, exports) {

let $594d692e6e801339$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $594d692e6e801339$var$load("ffQaD"),
    $594d692e6e801339$var$load("kvRbA"),
    $594d692e6e801339$var$load("1VPQt")
]).then(()=>parcelRequire('5Y2tv'));

});




parcelRegister("kYzjv", function(module, exports) {

$parcel$export(module.exports, "softwareReportsCycleTimeClassicRouteEntry", () => $8d790787867c06bf$export$1bbbe71c256ed1d0);

var $e4eHl = parcelRequire("e4eHl");

var $7NszV = parcelRequire("7NszV");

var $3vbFU = parcelRequire("3vbFU");

var $7XYc4 = parcelRequire("7XYc4");

var $kfztd = parcelRequire("kfztd");

var $5lsNZ = parcelRequire("5lsNZ");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $2GkDw = parcelRequire("2GkDw");

var $ffza4 = parcelRequire("ffza4");

var $c04PQ = parcelRequire("c04PQ");

var $4R6GH = parcelRequire("4R6GH");

var $6LsQE = parcelRequire("6LsQE");

var $gxiIi = parcelRequire("gxiIi");

var $yxwH0 = parcelRequire("yxwH0");

var $89cBA = parcelRequire("89cBA");
const $8d790787867c06bf$export$1bbbe71c256ed1d0 = (0, $7NszV.createEntry)((0, $3vbFU.softwareReportsCycleTimeClassicRoute), ()=>({
        group: 'classic-software',
        component: (0, $7XYc4.componentWithCondition)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $gxiIi.CycleTimeReportClassic)),
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('entrypoint_migration_reports_cycle_time_classic')) {
                if ((0, $c04PQ.isFedRamp)()) return 0, $6LsQE.notFoundPageEntrypoint;
                return 0, $89cBA.cycleTimeReportClassicPageEntrypoint;
            }
            return undefined;
        },
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $yxwH0.getReportsCommonResource)(),
            (0, $2GkDw.devOpsProviderResource)
        ],
        afterPaint: [
            (0, $gxiIi.LazyCycleTimeReport)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gxiIi.LazyCycleTimeReport)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            reporting: {
                id: 'software-reports-cycle-time-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-reports-cycle-time-classic'),
                teamName: 'fusion-solaris'
            }
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("3vbFU", function(module, exports) {

$parcel$export(module.exports, "softwareReportsCycleTimeClassicRoute", () => $06112c4b48f06dba$export$1e5e610e11119ea7);
const $06112c4b48f06dba$export$1e5e610e11119ea7 = {
    name: 'software-reports-cycle-time-classic',
    path: '/jira/software/c/projects/:projectKey/reports/cycle-time',
    exact: true
};

});


parcelRegister("jK6bT", function(module, exports) {

$parcel$export(module.exports, "softwareReportsCycleTimeRouteEntry", () => $80a71bce0783e42d$export$8aee4b14556485d5);

var $e4eHl = parcelRequire("e4eHl");

var $lmyls = parcelRequire("lmyls");

var $6LsQE = parcelRequire("6LsQE");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $2GkDw = parcelRequire("2GkDw");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $iftoH = parcelRequire("iftoH");

var $kfztd = parcelRequire("kfztd");

var $e7bC3 = parcelRequire("e7bC3");

var $4GBKo = parcelRequire("4GBKo");

var $g0ZNl = parcelRequire("g0ZNl");
const $80a71bce0783e42d$export$8aee4b14556485d5 = (0, $7NszV.createEntry)((0, $iftoH.softwareReportsCycleTimeRoute), ()=>({
        group: 'software',
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $4GBKo.getTMPReportsCommonResource)(),
            (0, $2GkDw.devOpsProviderResource)
        ],
        entryPoint: ()=>{
            if ((0, $kfztd.isDevopsFeatureDisabledInFedRamp)()) return 0, $6LsQE.notFoundPageEntrypoint;
            return 0, $g0ZNl.cycleTimeReportPageEntrypoint;
        },
        meta: {
            reporting: {
                id: 'software-reports-cycle-time',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-reports-cycle-time'),
                teamName: 'fusion-solaris'
            }
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("iftoH", function(module, exports) {

$parcel$export(module.exports, "softwareReportsCycleTimeRoute", () => $36696e97e70723ad$export$c777bb8f2591081);
const $36696e97e70723ad$export$c777bb8f2591081 = {
    name: 'software-reports-cycle-time',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/cycle-time'
};

});

parcelRegister("g0ZNl", function(module, exports) {

$parcel$export(module.exports, "cycleTimeReportPageEntrypoint", () => $494bd3c8d60b6ff9$export$465717d84afb3d8f);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $4i2WV = parcelRequire("4i2WV");
const $494bd3c8d60b6ff9$export$465717d84afb3d8f = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $4i2WV.cycleTimeReportEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});


parcelRegister("jbAAG", function(module, exports) {

$parcel$export(module.exports, "softwareReportsDeploymentFrequencyClassicBoardRouteEntry", () => $c8c352b6ab54773f$export$e0c7b9ad9dd8b956);

var $e4eHl = parcelRequire("e4eHl");

var $7NszV = parcelRequire("7NszV");

var $7XYc4 = parcelRequire("7XYc4");

var $5lsNZ = parcelRequire("5lsNZ");

var $lmyls = parcelRequire("lmyls");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $ffza4 = parcelRequire("ffza4");

var $jc0kT = parcelRequire("jc0kT");

var $kfztd = parcelRequire("kfztd");

var $gyYxw = parcelRequire("gyYxw");

var $hBv66 = parcelRequire("hBv66");

var $2GkDw = parcelRequire("2GkDw");

var $4R6GH = parcelRequire("4R6GH");

var $c04PQ = parcelRequire("c04PQ");

var $6LsQE = parcelRequire("6LsQE");

var $9Ye18 = parcelRequire("9Ye18");

var $yxwH0 = parcelRequire("yxwH0");

var $3woHG = parcelRequire("3woHG");
const $c8c352b6ab54773f$export$e0c7b9ad9dd8b956 = (0, $7NszV.createEntry)((0, $jc0kT.softwareReportsDeploymentFrequencyClassicBoardRoute), ()=>({
        group: 'classic-software',
        component: (0, $7XYc4.componentWithCondition)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $9Ye18.DeploymentFrequencyReportClassic)),
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('entrypoint-reports-deployment-frequency-classic')) {
                if ((0, $c04PQ.isFedRamp)()) return 0, $6LsQE.notFoundPageEntrypoint;
                return 0, $3woHG.deploymentFrequencyReportPageEntrypoint;
            }
            return undefined;
        },
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $yxwH0.getReportsCommonResource)(),
            (0, $2GkDw.devOpsProviderResource)
        ],
        afterPaint: [
            (0, $9Ye18.LazyDeploymentFrequencyReport)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $9Ye18.LazyDeploymentFrequencyReport)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            reporting: {
                id: 'software-reports-deployment-frequency-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-reports-deployment-frequency-classic'),
                teamName: 'fusion-solaris'
            }
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("jc0kT", function(module, exports) {

$parcel$export(module.exports, "softwareReportsDeploymentFrequencyClassicBoardRoute", () => $a139294269da1f90$export$56d4754499615215);
const $a139294269da1f90$export$56d4754499615215 = {
    name: 'software-reports-deployment-frequency-classic-board',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/deployment-frequency',
    exact: true
};

});

parcelRegister("9Ye18", function(module, exports) {

$parcel$export(module.exports, "LazyDeploymentFrequencyReport", () => $e228059a3ddd4015$export$5113b2b19ec1fb53);
$parcel$export(module.exports, "DeploymentFrequencyReportClassic", () => $e228059a3ddd4015$export$655707e8ae1053d3);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $e228059a3ddd4015$export$5113b2b19ec1fb53 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("hCJmk")), {
    moduleId: "./src/packages/spa-apps/deployment-frequency-report/src/index.tsx"
});
const $e228059a3ddd4015$export$e2db9c7426cdb53 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e228059a3ddd4015$export$5113b2b19ec1fb53,
        pageId: "deploymentFrequencyReportNextGen",
        shouldShowSpinner: true
    });
const $e228059a3ddd4015$export$655707e8ae1053d3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e228059a3ddd4015$export$5113b2b19ec1fb53,
        pageId: "deploymentFrequencyReportClassic",
        shouldShowSpinner: true
    });

});
parcelRegister("hCJmk", function(module, exports) {

let $cd492bae4e126e45$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $cd492bae4e126e45$var$load("ffQaD"),
    $cd492bae4e126e45$var$load("kvRbA"),
    $cd492bae4e126e45$var$load("jzecC")
]).then(()=>parcelRequire('6pwND'));

});


parcelRegister("3woHG", function(module, exports) {

$parcel$export(module.exports, "deploymentFrequencyReportPageEntrypoint", () => $edf6d9a26482ed8b$export$2a837f21eaa534d9);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $1tqza = parcelRequire("1tqza");
const $edf6d9a26482ed8b$export$2a837f21eaa534d9 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1tqza.deploymentFrequencyReportEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("1tqza", function(module, exports) {

$parcel$export(module.exports, "deploymentFrequencyReportEntrypoint", () => $6dfbb47575bd8c68$export$7377438ce2792970);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $6dfbb47575bd8c68$export$7377438ce2792970 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("aQ265")), {
        moduleId: "1be0b680",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("aQ265", function(module, exports) {

let $7e4063293b45b766$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $7e4063293b45b766$var$load("ffQaD"),
    $7e4063293b45b766$var$load("kvRbA"),
    $7e4063293b45b766$var$load("7NpBF")
]).then(()=>parcelRequire('77FPb'));

});




parcelRegister("7dbQR", function(module, exports) {

$parcel$export(module.exports, "softwareReportsDeploymentFrequencyClassicRouteEntry", () => $ec1385d68692f12b$export$e5eaafb1fb588922);

var $e4eHl = parcelRequire("e4eHl");

var $7NszV = parcelRequire("7NszV");

var $7XYc4 = parcelRequire("7XYc4");

var $5lsNZ = parcelRequire("5lsNZ");

var $lmyls = parcelRequire("lmyls");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $ffza4 = parcelRequire("ffza4");

var $7OCOC = parcelRequire("7OCOC");

var $kfztd = parcelRequire("kfztd");

var $gyYxw = parcelRequire("gyYxw");

var $hBv66 = parcelRequire("hBv66");

var $2GkDw = parcelRequire("2GkDw");

var $4R6GH = parcelRequire("4R6GH");

var $c04PQ = parcelRequire("c04PQ");

var $6LsQE = parcelRequire("6LsQE");

var $9Ye18 = parcelRequire("9Ye18");

var $yxwH0 = parcelRequire("yxwH0");

var $3woHG = parcelRequire("3woHG");
const $ec1385d68692f12b$export$e5eaafb1fb588922 = (0, $7NszV.createEntry)((0, $7OCOC.softwareReportsDeploymentFrequencyClassicRoute), ()=>({
        group: 'classic-software',
        component: (0, $7XYc4.componentWithCondition)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $9Ye18.DeploymentFrequencyReportClassic)),
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('entrypoint-reports-deployment-frequency-classic')) {
                if ((0, $c04PQ.isFedRamp)()) return 0, $6LsQE.notFoundPageEntrypoint;
                return 0, $3woHG.deploymentFrequencyReportPageEntrypoint;
            }
            return undefined;
        },
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $yxwH0.getReportsCommonResource)(),
            (0, $2GkDw.devOpsProviderResource)
        ],
        afterPaint: [
            (0, $9Ye18.LazyDeploymentFrequencyReport)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $9Ye18.LazyDeploymentFrequencyReport)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            reporting: {
                id: 'software-reports-deployment-frequency-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-reports-deployment-frequency-classic'),
                teamName: 'fusion-solaris'
            }
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("7OCOC", function(module, exports) {

$parcel$export(module.exports, "softwareReportsDeploymentFrequencyClassicRoute", () => $8904c68da8a25316$export$312c410cb3b49afe);
const $8904c68da8a25316$export$312c410cb3b49afe = {
    name: 'software-reports-deployment-frequency-classic',
    path: '/jira/software/c/projects/:projectKey/reports/deployment-frequency',
    exact: true
};

});


parcelRegister("hvbE3", function(module, exports) {

$parcel$export(module.exports, "softwareReportsDeploymentFrequencyRouteEntry", () => $9fed6c189f0eedfa$export$c87b25c0997e584d);

var $e4eHl = parcelRequire("e4eHl");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $2GkDw = parcelRequire("2GkDw");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $avQc9 = parcelRequire("avQc9");

var $c04PQ = parcelRequire("c04PQ");

var $e7bC3 = parcelRequire("e7bC3");

var $6LsQE = parcelRequire("6LsQE");

var $4GBKo = parcelRequire("4GBKo");

var $eSx59 = parcelRequire("eSx59");
const $9fed6c189f0eedfa$export$c87b25c0997e584d = (0, $7NszV.createEntry)((0, $avQc9.softwareReportsDeploymentFrequencyRoute), ()=>({
        group: 'software',
        entryPoint: ()=>{
            if ((0, $c04PQ.isFedRamp)()) return 0, $6LsQE.notFoundPageEntrypoint;
            return 0, $eSx59.DeploymentFrequencyPageEntrypoint;
        },
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $4GBKo.getTMPReportsCommonResource)(),
            (0, $2GkDw.devOpsProviderResource)
        ],
        meta: {
            reporting: {
                id: 'software-reports-deployment-frequency',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-reports-deployment-frequency'),
                teamName: 'fusion-solaris'
            }
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("avQc9", function(module, exports) {

$parcel$export(module.exports, "softwareReportsDeploymentFrequencyRoute", () => $b876fc8448289e46$export$bbf45ab0423b990);
const $b876fc8448289e46$export$bbf45ab0423b990 = {
    name: 'software-reports-deployment-frequency',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/deployment-frequency'
};

});

parcelRegister("eSx59", function(module, exports) {

$parcel$export(module.exports, "DeploymentFrequencyPageEntrypoint", () => $2f62bb5293f966a6$export$76cc51683254a696);

var $lkFvK = parcelRequire("lkFvK");

var $1tqza = parcelRequire("1tqza");

var $lmyls = parcelRequire("lmyls");
const $2f62bb5293f966a6$export$76cc51683254a696 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1tqza.deploymentFrequencyReportEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});


parcelRegister("3Jvzv", function(module, exports) {

$parcel$export(module.exports, "softwareReportsOverviewBoardlessRouteEntry", () => $9c5660c793001eba$export$1341f3a3578e9e4);

var $7NszV = parcelRequire("7NszV");

var $lmyls = parcelRequire("lmyls");

var $4R6GH = parcelRequire("4R6GH");

var $9s3j1 = parcelRequire("9s3j1");

var $e5NqW = parcelRequire("e5NqW");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $5f2bR = parcelRequire("5f2bR");

var $lkFvK = parcelRequire("lkFvK");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $48Ij3 = parcelRequire("48Ij3");

var $e7bC3 = parcelRequire("e7bC3");

var $dxCvy = parcelRequire("dxCvy");

var $fh5Sl = parcelRequire("fh5Sl");

var $fo6b8 = parcelRequire("fo6b8");

var $38FLy = parcelRequire("38FLy");
const $9c5660c793001eba$var$reportsOverviewPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $fh5Sl.reportsOverviewPageEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $9c5660c793001eba$export$1341f3a3578e9e4 = (0, $7NszV.createEntry)((0, $e5NqW.softwareReportsOverviewBoardlessRoute), ()=>({
        group: 'software-reports-boardless',
        skeleton: (0, $38FLy.ReportsOverviewSkeleton),
        entryPoint () {
            return (0, $4R6GH.fg)('reports-overview-page-migration') ? $9c5660c793001eba$var$reportsOverviewPageEntryPoint : undefined;
        },
        layout: (0, $e7bC3.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $48Ij3.staticSidebarJSWReportsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        ufoName: 'reports-overview',
        supportsPreviewPanel: true
    }));

});
parcelRegister("e5NqW", function(module, exports) {

$parcel$export(module.exports, "softwareReportsOverviewBoardlessRoute", () => $ec5168f42eb9ffe8$export$e2f371bced79a0e4);
const $ec5168f42eb9ffe8$export$e2f371bced79a0e4 = {
    name: 'software-reports-boardless',
    path: '/jira/software/c/projects/:projectKey/reports',
    exact: true
};

});

parcelRegister("38FLy", function(module, exports) {

$parcel$export(module.exports, "ReportsOverviewSkeleton", () => $b7f1d5ad6a664668$export$c70e702bcad58c36);
/* ReportsOverviewSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $kkMO6 = parcelRequire("kkMO6");
const $b7f1d5ad6a664668$var$containerStyles = {
    maxWidth: '100%'
};
const $b7f1d5ad6a664668$var$customCssStyles = null;
const $b7f1d5ad6a664668$export$c70e702bcad58c36 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kkMO6))),
        containerStyles: $b7f1d5ad6a664668$var$containerStyles,
        className: (0, $bwpsq.default)([
            "_2zz1idpf"
        ])
    });

});
parcelRegister("kkMO6", function(module, exports) {
module.exports = new URL("report-categories-skeleton.tpl.5b53a8d3.svg", import.meta.url).toString();

});



parcelRegister("CY8KI", function(module, exports) {

$parcel$export(module.exports, "softwareReportsOverviewRouteEntry", () => $1f4532d2aef48985$export$705071d2eca06bf9);

var $7NszV = parcelRequire("7NszV");

var $lmyls = parcelRequire("lmyls");

var $4R6GH = parcelRequire("4R6GH");

var $9s3j1 = parcelRequire("9s3j1");

var $6rHGg = parcelRequire("6rHGg");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $5f2bR = parcelRequire("5f2bR");

var $lkFvK = parcelRequire("lkFvK");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $e7bC3 = parcelRequire("e7bC3");

var $dxCvy = parcelRequire("dxCvy");

var $fh5Sl = parcelRequire("fh5Sl");

var $fo6b8 = parcelRequire("fo6b8");

var $38FLy = parcelRequire("38FLy");
const $1f4532d2aef48985$var$reportsOverviewPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $fh5Sl.reportsOverviewPageEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $1f4532d2aef48985$export$705071d2eca06bf9 = (0, $7NszV.createEntry)((0, $6rHGg.softwareReportsOverviewRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $38FLy.ReportsOverviewSkeleton),
        entryPoint () {
            return (0, $4R6GH.fg)('reports-overview-page-migration') ? $1f4532d2aef48985$var$reportsOverviewPageEntryPoint : undefined;
        },
        layout: (0, $e7bC3.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        ufoName: 'reports-overview',
        supportsPreviewPanel: true
    }));

});
parcelRegister("6rHGg", function(module, exports) {

$parcel$export(module.exports, "softwareReportsOverviewRoute", () => $70946eef546cad35$export$f38928477442c9cf);
const $70946eef546cad35$export$f38928477442c9cf = {
    name: 'software-reports',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports'
};

});


parcelRegister("glwG4", function(module, exports) {

$parcel$export(module.exports, "softwareReportsRouteEntry", () => $e48b30544edfb83d$export$2eee2f4f773d5b1f);

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $gTLbY = parcelRequire("gTLbY");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $4GBKo = parcelRequire("4GBKo");

var $kgB1V = parcelRequire("kgB1V");
const $e48b30544edfb83d$export$2eee2f4f773d5b1f = (0, $7NszV.createEntry)((0, $gTLbY.softwareReportsRoute), ()=>({
        group: 'software',
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $4GBKo.getTMPReportsCommonResource)()
        ],
        entryPoint: ()=>(0, $kgB1V.reportsOverviewPageEntrypoint),
        ufoName: 'software-reports.overview',
        supportsPreviewPanel: true
    }));

});
parcelRegister("gTLbY", function(module, exports) {

$parcel$export(module.exports, "softwareReportsRoute", () => $ccee26b223b96f27$export$5bf75a5d8c554930);
const $ccee26b223b96f27$export$5bf75a5d8c554930 = {
    name: 'software-reports',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports'
};

});

parcelRegister("kgB1V", function(module, exports) {

$parcel$export(module.exports, "reportsOverviewPageEntrypoint", () => $5b9a94bde6be5ad0$export$d9a1db2306b376e2);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $fo6b8 = parcelRequire("fo6b8");

var $1oBct = parcelRequire("1oBct");
const $5b9a94bde6be5ad0$export$d9a1db2306b376e2 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1oBct.reportsOverviewEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("1oBct", function(module, exports) {

$parcel$export(module.exports, "reportsOverviewEntrypoint", () => $cc66006bf6e013de$export$bb9acba529741f89);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $cc66006bf6e013de$export$bb9acba529741f89 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("a1v2H")), {
        moduleId: "6be6e255",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("a1v2H", function(module, exports) {

let $74c213cb941470e8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $74c213cb941470e8$var$load("a9VRT").then(()=>parcelRequire('iZwfI'));

});




parcelRegister("lcFGc", function(module, exports) {

$parcel$export(module.exports, "softwareReportsVelocityRouteEntry", () => $c4602ac6f12b6703$export$7d814f4300d0e318);

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $hui9h = parcelRequire("hui9h");

var $e7bC3 = parcelRequire("e7bC3");

var $4GBKo = parcelRequire("4GBKo");

var $fzG6k = parcelRequire("fzG6k");
const $c4602ac6f12b6703$export$7d814f4300d0e318 = (0, $7NszV.createEntry)((0, $hui9h.softwareReportsVelocityRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.velocity-report',
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $4GBKo.getTMPReportsCommonResource)()
        ],
        entryPoint: ()=>(0, $fzG6k.velocityReportPageEntrypoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("hui9h", function(module, exports) {

$parcel$export(module.exports, "softwareReportsVelocityRoute", () => $e44f6dc6707a4fed$export$cde83a6497756848);
const $e44f6dc6707a4fed$export$cde83a6497756848 = {
    name: 'software-reports-velocity',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/velocity'
};

});


parcelRegister("03CAy", function(module, exports) {

$parcel$export(module.exports, "softwareRoadmapClassicRouteEntry", () => $12d0c514ddf21fe0$export$17cff822dd3757db);

var $7NszV = parcelRequire("7NszV");

var $i1Lhe = parcelRequire("i1Lhe");

var $8STJR = parcelRequire("8STJR");

var $aPfsS = parcelRequire("aPfsS");

var $e7bC3 = parcelRequire("e7bC3");

var $g5RGc = parcelRequire("g5RGc");

var $lmyls = parcelRequire("lmyls");

var $9s3j1 = parcelRequire("9s3j1");

var $5f2bR = parcelRequire("5f2bR");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $7uLIV = parcelRequire("7uLIV");

var $hJAri = parcelRequire("hJAri");

var $fKmub = parcelRequire("fKmub");

var $ffza4 = parcelRequire("ffza4");

var $4R6GH = parcelRequire("4R6GH");

var $c7uCQ = parcelRequire("c7uCQ");

var $j0EJB = parcelRequire("j0EJB");
const $12d0c514ddf21fe0$var$getConditionalResources = ()=>(0, $4R6GH.fg)('optimise_timeline_routes') ? [
        (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
        (0, $5bkvv.forgeProjectModuleResourceOnNav3Only),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only)
    ] : [
        (0, $7GnDe.incidentExperimentTraitResource),
        (0, $5bkvv.forgeProjectModuleResource),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
    ];
const $12d0c514ddf21fe0$export$17cff822dd3757db = (0, $7NszV.createEntry)((0, $i1Lhe.softwareRoadmapClassicRoute), ()=>({
        group: 'classic-software',
        component: (0, $c7uCQ.TimelineRedirect),
        skeleton: (0, $8STJR.RoadmapSkeleton),
        layout: (0, $aPfsS.composeLayouts)((0, $4R6GH.fg)('optimise_timeline_routes') ? (0, $e7bC3.softwareProjectLayoutCode) : (0, $e7bC3.classicSoftwareProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            ...$12d0c514ddf21fe0$var$getConditionalResources(),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $hJAri.classicRoadmapResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-roadmap-early-entry'
            ]
        },
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $j0EJB.LazyRoadmapViewClassic)
        ],
        ufoName: 'classic-roadmap',
        supportsPreviewPanel: true
    }));

});
parcelRegister("i1Lhe", function(module, exports) {

$parcel$export(module.exports, "softwareRoadmapClassicRoute", () => $6e5bb4d1423afb31$export$79089e2853f04197);
const $6e5bb4d1423afb31$export$79089e2853f04197 = {
    name: 'software-roadmap-classic',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/roadmap'
};

});

parcelRegister("8STJR", function(module, exports) {

$parcel$export(module.exports, "RoadmapSkeleton", () => $e0f5f5cb925a5d1c$export$66a1e8bb48359566);
/* RoadmapSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7XYc4 = parcelRequire("7XYc4");

var $3HwlS = parcelRequire("3HwlS");

var $dCm1o = parcelRequire("dCm1o");

var $hCy6k = parcelRequire("hCy6k");

var $j8gGL = parcelRequire("j8gGL");

var $5KBZJ = parcelRequire("5KBZJ");
const $e0f5f5cb925a5d1c$var$customCssStyles = null;
const $e0f5f5cb925a5d1c$export$66a1e8bb48359566 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e0f5f5cb925a5d1c$var$AppSkeletonImageContainer, null, (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($j8gGL))),
        className: (0, $bwpsq.default)([
            "_2zz1idpf"
        ])
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5KBZJ))),
        className: (0, $bwpsq.default)([
            "_2zz1idpf"
        ])
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $e0f5f5cb925a5d1c$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1bgi _1xpi1tcg _1sbz1tcg _1cpn1tcg _13xs1tcg",
            __cmplp.className
        ])
    });
});
const $e0f5f5cb925a5d1c$var$AppSkeletonImageContainer = (0, $7XYc4.componentWithCondition)(()=>(0, $dCm1o.isVisualRefreshEnabled)(), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e0f5f5cb925a5d1c$var$Wrapper, null, children), (0, $5uXOq.Fragment));

});
parcelRegister("j8gGL", function(module, exports) {
module.exports = new URL("roadmap-app-skeleton-nav-refresh.tpl.ce6eb42e.svg", import.meta.url).toString();

});

parcelRegister("5KBZJ", function(module, exports) {
module.exports = new URL("roadmap-app-skeleton.tpl.a54a882d.svg", import.meta.url).toString();

});


parcelRegister("hJAri", function(module, exports) {

$parcel$export(module.exports, "classicRoadmapResource", () => $b200b290d50f82d3$export$e755913caca1ab8e);

var $2M1hQ = parcelRequire("2M1hQ");


const $b200b290d50f82d3$export$e755913caca1ab8e = (0, $2M1hQ.createResource)({
    type: (0, $87d7efe6336d8b83$export$e3b1cd17bd82de3d),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>(parcelRequire("l3C4Q")),
    isBrowserOnly: true
});

});
parcelRegister("l3C4Q", function(module, exports) {

let $f5476a1747973580$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f5476a1747973580$var$load("jUUh4").then(()=>parcelRequire('g52eJ'));

});


parcelRegister("c7uCQ", function(module, exports) {

$parcel$export(module.exports, "TimelineRedirect", () => $02623e8fca40b314$export$c70b8d9ef0c891b2);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
var $doZTA = parcelRequire("doZTA");
const $02623e8fca40b314$export$c70b8d9ef0c891b2 = ()=>{
    const [{ query: query, match: match }] = (0, $doZTA.useRouter)();
    const queryParams = new URLSearchParams(query).toString();
    const { projectKey: projectKey, boardId: boardId } = match.params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: {
            pathname: `/jira/software/c/projects/${String(projectKey)}/boards/${String(boardId)}/timeline`,
            hash: '',
            search: queryParams
        }
    });
};

});

parcelRegister("j0EJB", function(module, exports) {

$parcel$export(module.exports, "LazyRoadmapViewClassic", () => $d9daa971618d7f64$export$84165bb08bf42eef);
$parcel$export(module.exports, "default", () => $d9daa971618d7f64$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $d9daa971618d7f64$export$84165bb08bf42eef = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("dkKhP"))), {
    moduleId: "./src/packages/spa-apps/roadmap/src/view/classic/index-old.tsx"
});
var /** @deprecated Use entrypoint roadmapViewClassicPageEntrypoint */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$d9daa971618d7f64$export$2e2bcd8739ae039 = ({ match: match })=>{
    const { boardId: boardId } = match.params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d9daa971618d7f64$export$84165bb08bf42eef,
        pageId: `classic-roadmap-${boardId || ''}`,
        shouldShowSpinner: false
    });
};

});
parcelRegister("dkKhP", function(module, exports) {

let $9b510c274701fe05$var$load = (parcelRequire("28QjX"))(4);

module.exports = Promise.all([
    (parcelRequire("avM1e"))('jirt-convert-class-to-functional-component', function() {
        return Promise.all([
            $9b510c274701fe05$var$load("1ls92")
        ]);
    }, function() {
        return Promise.all([
            $9b510c274701fe05$var$load("kLeYK")
        ]);
    }),
    $9b510c274701fe05$var$load("ffQaD"),
    $9b510c274701fe05$var$load("kvRbA"),
    $9b510c274701fe05$var$load("5VVGu")
]).then(()=>parcelRequire('cVHeR'));

});



parcelRegister("056cU", function(module, exports) {

$parcel$export(module.exports, "softwareRoadmapRedirectRouteEntry", () => $ea7885e348916216$export$4180bde2c4464aed);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $ffza4 = parcelRequire("ffza4");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $itBA5 = parcelRequire("itBA5");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $7tQej = parcelRequire("7tQej");

var $kotYl = parcelRequire("kotYl");
const $ea7885e348916216$var$SoftwareTimelineLegacyRedirect = ({ query: query })=>{
    const { projectKey: projectKey, rapidView: rapidView, ...restQuery } = query;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: {
            pathname: `/jira/software/projects/${projectKey}/boards/${rapidView}/timeline`,
            hash: '',
            search: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(restQuery)
        }
    });
};
const $ea7885e348916216$export$4180bde2c4464aed = (0, $7NszV.createEntry)((0, $itBA5.softwareRoadmapRedirectRoute), ()=>({
        group: 'software',
        component: $ea7885e348916216$var$SoftwareTimelineLegacyRedirect,
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kotYl.LazyNextGenRoadmap)
        ]
    }));

});
parcelRegister("itBA5", function(module, exports) {

$parcel$export(module.exports, "softwareRoadmapRedirectRoute", () => $e9307309e9fea835$export$866215abd09c0f4d);
const $e9307309e9fea835$export$866215abd09c0f4d = {
    name: 'software-roadmap-redirect',
    path: '/secure/Roadmap.jspa'
};

});

parcelRegister("kotYl", function(module, exports) {

$parcel$export(module.exports, "LazyNextGenRoadmap", () => $fadca415ac9d888e$export$1339c847cf4ab57);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $fadca415ac9d888e$export$1339c847cf4ab57 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("3PSc0"))), {
    moduleId: "./src/packages/spa-apps/roadmap/src/view/next-gen/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fadca415ac9d888e$export$2e2bcd8739ae039 = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $fadca415ac9d888e$export$1339c847cf4ab57,
        pageId: `next-gen-roadmap-${match.params.boardId || ''}`,
        shouldShowSpinner: false
    });

});
parcelRegister("3PSc0", function(module, exports) {

let $2cb02c115faff0b0$var$load = (parcelRequire("28QjX"))(4);

module.exports = Promise.all([
    (parcelRequire("avM1e"))('jirt-convert-class-to-functional-component', function() {
        return Promise.all([
            $2cb02c115faff0b0$var$load("1ls92")
        ]);
    }, function() {
        return Promise.all([
            $2cb02c115faff0b0$var$load("kLeYK")
        ]);
    }),
    $2cb02c115faff0b0$var$load("ffQaD"),
    $2cb02c115faff0b0$var$load("kvRbA"),
    $2cb02c115faff0b0$var$load("dwsGM")
]).then(()=>parcelRequire('9ImcE'));

});



parcelRegister("kxlGk", function(module, exports) {

$parcel$export(module.exports, "softwareRoadmapRouteEntry", () => $f92b7b046a2bd572$export$c1d875e34d537389);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $jsFU4 = parcelRequire("jsFU4");

var $7GnDe = parcelRequire("7GnDe");

var $gwIeN = parcelRequire("gwIeN");

var $8STJR = parcelRequire("8STJR");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $7tQej = parcelRequire("7tQej");

var $4R6GH = parcelRequire("4R6GH");

var $9SSv2 = parcelRequire("9SSv2");
const $f92b7b046a2bd572$var$getConditionalResources = ()=>(0, $4R6GH.fg)('optimise_timeline_routes') ? [
        (0, $5bkvv.forgeProjectModuleResourceOnNav3Only),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only)
    ] : [
        (0, $5bkvv.forgeProjectModuleResource),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
    ];
const $f92b7b046a2bd572$var$SoftwareTimelineRedirect = ({ match: { params: { projectKey: projectKey, boardId: boardId } }, query: query })=>{
    const queryParams = new URLSearchParams(query).toString();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: {
            pathname: `/jira/software/projects/${String(projectKey)}/boards/${String(boardId)}/timeline`,
            hash: '',
            search: queryParams
        }
    });
};
const $f92b7b046a2bd572$export$c1d875e34d537389 = (0, $7NszV.createEntry)((0, $gwIeN.softwareRoadmapRoute), ()=>({
        group: 'software',
        component: $f92b7b046a2bd572$var$SoftwareTimelineRedirect,
        skeleton: (0, $8STJR.RoadmapSkeleton),
        layout: (0, $aPfsS.composeLayouts)((0, $4R6GH.fg)('optimise_timeline_routes') ? (0, $e7bC3.softwareProjectLayoutCode) : (0, $e7bC3.softwareProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dxCvy.projectContextResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            ...$f92b7b046a2bd572$var$getConditionalResources(),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $jsFU4.nextGenRoadmapResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-roadmap-early-entry'
            ]
        },
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $9SSv2.LazyNextGenRoadmap)
        ],
        ufoName: 'next-gen-roadmap',
        supportsPreviewPanel: true
    }));

});
parcelRegister("jsFU4", function(module, exports) {

$parcel$export(module.exports, "nextGenRoadmapResource", () => $0b5ed5206b5a609e$export$2750f87d68dfb02a);

var $2M1hQ = parcelRequire("2M1hQ");


const $0b5ed5206b5a609e$export$2750f87d68dfb02a = (0, $2M1hQ.createResource)({
    type: (0, $87d7efe6336d8b83$export$75dfa03544a19422),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>(parcelRequire("9QR9m")),
    // SSR doesn't care about this and we can't check FFs here because its not in the render path
    maxAge: 3600000,
    isBrowserOnly: true
});

});
parcelRegister("9QR9m", function(module, exports) {

let $72c232e3722805ed$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $72c232e3722805ed$var$load("kVX56"),
    $72c232e3722805ed$var$load("hjzlf")
]).then(()=>parcelRequire('d0ZST'));

});


parcelRegister("gwIeN", function(module, exports) {

$parcel$export(module.exports, "softwareRoadmapRoute", () => $d2651e8c2584e2bd$export$a4a573c36fc75b30);
const $d2651e8c2584e2bd$export$a4a573c36fc75b30 = {
    name: 'software-roadmap',
    path: '/jira/software/projects/:projectKey/boards/:boardId/roadmap'
};

});

parcelRegister("9SSv2", function(module, exports) {

$parcel$export(module.exports, "LazyNextGenRoadmap", () => $fba9adf99f1ad42b$export$1339c847cf4ab57);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $fba9adf99f1ad42b$export$1339c847cf4ab57 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("3PSc0"))), {
    moduleId: "./src/packages/spa-apps/roadmap/src/view/next-gen/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fba9adf99f1ad42b$export$2e2bcd8739ae039 = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $fba9adf99f1ad42b$export$1339c847cf4ab57,
        pageId: `next-gen-roadmap-${match.params.boardId || ''}`,
        shouldShowSpinner: false
    });

});


parcelRegister("fMbaV", function(module, exports) {

$parcel$export(module.exports, "softwareSecurityClassicRouteEntry", () => $24f436c9befc4f10$export$8acfebad16c9d6f2);

var $e4eHl = parcelRequire("e4eHl");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $en8e6 = parcelRequire("en8e6");

var $g5C5j = parcelRequire("g5C5j");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $6LsQE = parcelRequire("6LsQE");

var $crK2h = parcelRequire("crK2h");

var $7AM4I = parcelRequire("7AM4I");
const $24f436c9befc4f10$export$8acfebad16c9d6f2 = (0, $7NszV.createEntry)((0, $g5C5j.softwareSecurityClassicRoute), ()=>({
        group: 'classic-software',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource),
            (0, $en8e6.securityPageResource)
        ],
        ufoName: 'software-security-combined',
        layout: (0, $e7bC3.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        meta: {
            reporting: {
                id: 'software-security-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-security-classic'),
                teamName: 'fusion-isotopes'
            }
        },
        entryPoint: ()=>(0, $crK2h.isSecurityPageEnabled)() ? (0, $7AM4I.securityPageEntrypoint) : (0, $6LsQE.notFoundPageEntrypoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("en8e6", function(module, exports) {

$parcel$export(module.exports, "securityPageResource", () => $ae0f760fa9a80a3f$export$2c5e3c161b8fe98);

var $dXq4S = parcelRequire("dXq4S");

var $ao2h1 = parcelRequire("ao2h1");

var $1UBcC = parcelRequire("1UBcC");

var $ac0bf = parcelRequire("ac0bf");

const $ae0f760fa9a80a3f$var$getNumberOfVulnerabilitiesToFetch = ()=>40;
const $ae0f760fa9a80a3f$var$getNumberOfSecurityContainersToFetch = ()=>100;
let $ae0f760fa9a80a3f$var$filters;
const $ae0f760fa9a80a3f$export$2c5e3c161b8fe98 = (0, $ao2h1.createRelayResource)({
    type: (0, $0a72320b8bc3a1aa$export$f24db22c3c834cb1),
    getQuery ({ match: { params: params }, query: query, route: { name: name } }, { tenantContext: { cloudId: cloudId, activationId: activationId } }) {
        const isSecRoute = name === 'software-security' || name === 'software-security-classic';
        // Set filters on initial call only and not on every query param change
        if (!$ae0f760fa9a80a3f$var$filters && isSecRoute) {
            const connectionAri = (0, $dXq4S.createAri)({
                resourceOwner: 'jira',
                resourceType: 'security-container',
                cloudId: cloudId,
                activationId: activationId,
                resourceId: ''
            });
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            $ae0f760fa9a80a3f$var$filters = (0, $ac0bf.getGqlFiltersFromQueryParams)(query, connectionAri);
        }
        // Reset filters when navigating away from the security page
        if (!isSecRoute) $ae0f760fa9a80a3f$var$filters = undefined;
        return {
            parameters: (0, $1UBcC.default),
            options: {
                fetchPolicy: 'store-and-network'
            },
            variables: {
                cloudAri: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira',
                    resourceType: 'site',
                    resourceId: cloudId
                }),
                cloudId: cloudId,
                projectKey: params.projectKey ?? '',
                numberOfVulnsToFetch: $ae0f760fa9a80a3f$var$getNumberOfVulnerabilitiesToFetch(),
                getContainers: false,
                numberOfContainersToFetch: $ae0f760fa9a80a3f$var$getNumberOfSecurityContainersToFetch(),
                filter: $ae0f760fa9a80a3f$var$filters
            }
        };
    }
});

});
parcelRegister("1UBcC", function(module, exports) {

$parcel$export(module.exports, "default", () => $511d4548ae93769f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<19ba314b5ea84907b5a40f68508fe69c>>
 * @relayHash f0a618cf7ed72db97753081c0b97da4a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5198f24476f61b6137708d014e1bf17fc048a7251fb5049c31fda1aacc83f1ab
const $511d4548ae93769f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "getContainers"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "numberOfContainersToFetch"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "numberOfVulnsToFetch"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v8 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v9 = {
        "kind": "ScalarField",
        "name": "totalLinkedSecurityContainerCount"
    }, v10 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "numberOfContainersToFetch"
        }
    ], v11 = {
        "kind": "ScalarField",
        "name": "providerId"
    }, v12 = [
        v11 /*: any*/ 
    ], v13 = {
        "kind": "InlineFragment",
        "selections": v12 /*: any*/ ,
        "type": "ThirdPartySecurityContainer"
    }, v14 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v15 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "numberOfVulnsToFetch"
    }, v16 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "and": {
                    "lastUpdated": {
                        "sort": {
                            "order": "ASC",
                            "priority": 1
                        }
                    }
                }
            }
        },
        v15 /*: any*/ 
    ], v17 = {
        "kind": "ScalarField",
        "name": "id"
    }, v18 = {
        "kind": "ScalarField",
        "name": "name"
    }, v19 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v20 = {
        "concreteType": "DevOps",
        "kind": "LinkedField",
        "name": "devOps",
        "plural": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "id",
                        "variableName": "cloudAri"
                    },
                    {
                        "kind": "Literal",
                        "name": "providerTypes",
                        "value": [
                            "SECURITY"
                        ]
                    }
                ],
                "concreteType": "DevOpsProviders",
                "kind": "LinkedField",
                "name": "providers",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "DevOpsSecurityProvider",
                        "kind": "LinkedField",
                        "name": "securityProviders",
                        "plural": true,
                        "selections": [
                            v17 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "appInstallationId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "logoUrl"
                            },
                            v18 /*: any*/ ,
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 100
                                    }
                                ],
                                "concreteType": "AriGraphRelationshipConnection",
                                "kind": "LinkedField",
                                "name": "linkedWorkspaces",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "AriGraphRelationship",
                                        "kind": "LinkedField",
                                        "name": "nodes",
                                        "plural": true,
                                        "selections": [
                                            v19 /*: any*/ 
                                        ]
                                    }
                                ],
                                "storageKey": "linkedWorkspaces(first:100)"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v21 = [
        v17 /*: any*/ 
    ], v22 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v23 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsFeatureFlag"
    }, v24 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsOperationsComponentDetails"
    }, v25 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsOperationsIncidentDetails"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsOperationsPostIncidentReviewDetails"
    }, v27 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsPullRequestDetails"
    }, v28 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsRepository"
    }, v29 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsSecurityVulnerabilityDetails"
    }, v30 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "JiraAutodevJob"
    }, v31 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "JiraConfluenceRemoteIssueLink"
    }, v32 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "JiraCustomRemoteIssueLink"
    }, v33 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "JiraIssueRemoteIssueLink"
    }, v34 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "JiraWebRemoteIssueLink"
    }, v35 = [
        v8 /*: any*/ ,
        v15 /*: any*/ 
    ], v36 = {
        "kind": "ScalarField",
        "name": "url"
    }, v37 = {
        "kind": "ScalarField",
        "name": "key"
    }, v38 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v39 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainSecurityInJiraQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v7 /*: any*/ ,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProjectByKey",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": [
                                            v8 /*: any*/ ,
                                            {
                                                "kind": "Variable",
                                                "name": "getContainers",
                                                "variableName": "getContainers"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "numberOfContainersToFetch",
                                                "variableName": "numberOfContainersToFetch"
                                            }
                                        ],
                                        "kind": "FragmentSpread",
                                        "name": "main_softwareSecurityPage_MainPage"
                                    },
                                    v9 /*: any*/ ,
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v10 /*: any*/ ,
                                            "concreteType": "AriGraphRelationshipConnection",
                                            "kind": "LinkedField",
                                            "name": "linkedSecurityContainers",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationshipEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AriGraphRelationship",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "AriGraphRelationshipNode",
                                                                    "kind": "LinkedField",
                                                                    "name": "to",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "condition": "getContainers",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "data",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v13 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v14 /*: any*/ 
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.jiraProjectByKey.linkedSecurityContainers"
                                    },
                                    {
                                        "alias": "linkedVulnsForAnalytics",
                                        "args": v16 /*: any*/ ,
                                        "concreteType": "GraphJiraVulnerabilityConnection",
                                        "kind": "LinkedField",
                                        "name": "linkedSecurityVulnerabilitiesByProject",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "GraphJiraVulnerabilityEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "GraphJiraVulnerability",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "condition": "getContainers",
                                                                "kind": "Condition",
                                                                "passingValue": true,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                                        "kind": "LinkedField",
                                                                        "name": "vulnerability",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "ThirdPartySecurityContainer",
                                                                                "kind": "LinkedField",
                                                                                "name": "securityContainer",
                                                                                "plural": false,
                                                                                "selections": v12 /*: any*/ 
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.jiraProjectByKey"
                        }
                    ]
                },
                v20 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v6 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainSecurityInJiraQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v17 /*: any*/ ,
                                {
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "AriGraphRelationshipConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedSecurityContainers",
                                    "plural": false,
                                    "selections": [
                                        v14 /*: any*/ ,
                                        {
                                            "concreteType": "AriGraphRelationshipEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationship",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AriGraphRelationshipNode",
                                                            "kind": "LinkedField",
                                                            "name": "to",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "condition": "getContainers",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "data",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v19 /*: any*/ ,
                                                                                v13 /*: any*/ ,
                                                                                v22 /*: any*/ ,
                                                                                v23 /*: any*/ ,
                                                                                v24 /*: any*/ ,
                                                                                v25 /*: any*/ ,
                                                                                v26 /*: any*/ ,
                                                                                v27 /*: any*/ ,
                                                                                v28 /*: any*/ ,
                                                                                v29 /*: any*/ ,
                                                                                v30 /*: any*/ ,
                                                                                v31 /*: any*/ ,
                                                                                v32 /*: any*/ ,
                                                                                v33 /*: any*/ ,
                                                                                v34 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v17 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": [
                                        v8 /*: any*/ 
                                    ],
                                    "kind": "ScalarField",
                                    "name": "totalLinkedSecurityVulnerabilityCount"
                                },
                                {
                                    "args": v35 /*: any*/ ,
                                    "concreteType": "GraphJiraVulnerabilityConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedSecurityVulnerabilitiesByProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphJiraVulnerabilityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphJiraVulnerability",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                            "kind": "LinkedField",
                                                            "name": "vulnerability",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "title"
                                                                },
                                                                {
                                                                    "condition": "getContainers",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ThirdPartySecurityContainer",
                                                                            "kind": "LinkedField",
                                                                            "name": "securityContainer",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v17 /*: any*/ ,
                                                                                v18 /*: any*/ ,
                                                                                v36 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "DevOpsSecurityVulnerabilityIdentifier",
                                                                    "kind": "LinkedField",
                                                                    "name": "identifiers",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "displayName"
                                                                        },
                                                                        v36 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "DevOpsSecurityVulnerabilityAdditionalInfo",
                                                                    "kind": "LinkedField",
                                                                    "name": "additionalInfo",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "content"
                                                                        },
                                                                        v36 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "status"
                                                                },
                                                                {
                                                                    "concreteType": "AriGraphRelationshipConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "linkedJiraIssues",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "AriGraphRelationship",
                                                                            "kind": "LinkedField",
                                                                            "name": "nodes",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "AriGraphRelationshipNode",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "to",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v17 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "data",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v19 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": [
                                                                                                                {
                                                                                                                    "kind": "Literal",
                                                                                                                    "name": "idsOrAliases",
                                                                                                                    "value": [
                                                                                                                        "summary",
                                                                                                                        "assignee",
                                                                                                                        "status",
                                                                                                                        "issuetype"
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldsByIdOrAlias",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                v19 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraStatus",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "status",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                v17 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "statusCategory",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v37 /*: any*/ ,
                                                                                                                                        v17 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraStatusField"
                                                                                                                },
                                                                                                                v17 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "fieldId"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "text"
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "user",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v19 /*: any*/ ,
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "picture"
                                                                                                                                },
                                                                                                                                v17 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueType",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraAvatar",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "avatar",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "small"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v17 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraIssueTypeField"
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "issueId"
                                                                                                        },
                                                                                                        v37 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "webUrl"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssue"
                                                                                                },
                                                                                                v22 /*: any*/ ,
                                                                                                v23 /*: any*/ ,
                                                                                                v24 /*: any*/ ,
                                                                                                v25 /*: any*/ ,
                                                                                                v26 /*: any*/ ,
                                                                                                v27 /*: any*/ ,
                                                                                                v28 /*: any*/ ,
                                                                                                v29 /*: any*/ ,
                                                                                                v30 /*: any*/ ,
                                                                                                v31 /*: any*/ ,
                                                                                                v32 /*: any*/ ,
                                                                                                v33 /*: any*/ ,
                                                                                                v34 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v14 /*: any*/ 
                                                                    ]
                                                                },
                                                                v17 /*: any*/ ,
                                                                v36 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "introducedDate"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "providerVulnerabilityId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "securityContainerId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "severity"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "description"
                                                                }
                                                            ]
                                                        },
                                                        v17 /*: any*/ ,
                                                        v19 /*: any*/ 
                                                    ]
                                                },
                                                v38 /*: any*/ 
                                            ]
                                        },
                                        v39 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v35 /*: any*/ ,
                                    "filters": [
                                        "filter"
                                    ],
                                    "handle": "connection",
                                    "key": "security__linkedSecurityVulnerabilitiesByProject",
                                    "kind": "LinkedHandle",
                                    "name": "linkedSecurityVulnerabilitiesByProject"
                                },
                                {
                                    "alias": "projectHaveVulnerabilityCheck",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1
                                        }
                                    ],
                                    "concreteType": "GraphJiraVulnerabilityConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedSecurityVulnerabilitiesByProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphJiraVulnerabilityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphJiraVulnerability",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                            "kind": "LinkedField",
                                                            "name": "vulnerability",
                                                            "plural": false,
                                                            "selections": [
                                                                v19 /*: any*/ ,
                                                                v17 /*: any*/ 
                                                            ]
                                                        },
                                                        v17 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "linkedSecurityVulnerabilitiesByProject(first:1)"
                                },
                                {
                                    "alias": "linkedVulnsForAnalytics",
                                    "args": v16 /*: any*/ ,
                                    "concreteType": "GraphJiraVulnerabilityConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedSecurityVulnerabilitiesByProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphJiraVulnerabilityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphJiraVulnerability",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "condition": "getContainers",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                                    "kind": "LinkedField",
                                                                    "name": "vulnerability",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ThirdPartySecurityContainer",
                                                                            "kind": "LinkedField",
                                                                            "name": "securityContainer",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v11 /*: any*/ ,
                                                                                v17 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v17 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v17 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "getContainers",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": v10 /*: any*/ ,
                                            "concreteType": "AriGraphRelationshipConnection",
                                            "kind": "LinkedField",
                                            "name": "linkedSecurityContainers",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationshipEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AriGraphRelationship",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "AriGraphRelationshipNode",
                                                                    "kind": "LinkedField",
                                                                    "name": "to",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "data",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v19 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v18 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "icon"
                                                                                        },
                                                                                        v36 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "providerName"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "lastUpdated"
                                                                                        },
                                                                                        v14 /*: any*/ ,
                                                                                        v17 /*: any*/ 
                                                                                    ],
                                                                                    "type": "ThirdPartySecurityContainer"
                                                                                },
                                                                                v22 /*: any*/ ,
                                                                                v23 /*: any*/ ,
                                                                                v24 /*: any*/ ,
                                                                                v25 /*: any*/ ,
                                                                                v26 /*: any*/ ,
                                                                                v27 /*: any*/ ,
                                                                                v28 /*: any*/ ,
                                                                                v29 /*: any*/ ,
                                                                                v30 /*: any*/ ,
                                                                                v31 /*: any*/ ,
                                                                                v32 /*: any*/ ,
                                                                                v33 /*: any*/ ,
                                                                                v34 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v19 /*: any*/ 
                                                            ]
                                                        },
                                                        v38 /*: any*/ 
                                                    ]
                                                },
                                                v39 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": v10 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "security__linkedSecurityContainers",
                                            "kind": "LinkedHandle",
                                            "name": "linkedSecurityContainers"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v20 /*: any*/ 
            ]
        },
        "params": {
            "id": "5198f24476f61b6137708d014e1bf17fc048a7251fb5049c31fda1aacc83f1ab",
            "metadata": {},
            "name": "mainSecurityInJiraQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$511d4548ae93769f$var$node.hash = "e0029e5d1d9e6e62c9b62d69cc3a9f72";
var $511d4548ae93769f$export$2e2bcd8739ae039 = $511d4548ae93769f$var$node;

});

parcelRegister("ac0bf", function(module, exports) {

$parcel$export(module.exports, "getGqlFiltersFromQueryParams", () => $526907709998fa0b$export$2af359d48d48e5f1);

var $5eeaw = parcelRequire("5eeaw");

var $3zFAD = parcelRequire("3zFAD");

var $3o4IF = parcelRequire("3o4IF");
const $526907709998fa0b$var$getFilterValue = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
values, fieldStortKey, sortKey = (0, $3zFAD.initialVulnerabilityTableOptions).sortKey, sortOrder = (0, $3zFAD.initialVulnerabilityTableOptions).sortOrder)=>({
        ...values.length > 0 ? {
            values: values
        } : {},
        ...sortKey === fieldStortKey && {
            sort: {
                priority: 2,
                order: (0, $3o4IF.parseSortDirection)(sortOrder, (0, $5eeaw.AriGraphSortOrderInput).DESC)
            }
        }
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $526907709998fa0b$var$getOrDefault = (input, defaultArray)=>input.length ? input : defaultArray;
const $526907709998fa0b$export$2af359d48d48e5f1 = (queryParams, connectionAri)=>{
    const containerValues = $526907709998fa0b$var$getOrDefault((0, $3o4IF.connectionQueryParamToFilter)(queryParams[0, $3zFAD.QUERY_PARAM_CONTAINER], connectionAri).filter(Boolean), (0, $3zFAD.initialVulnerabilityTableOptions).connectionFilter);
    const statusQueryParams = (0, $3o4IF.arrayQueryParamToFilter)(queryParams[0, $3zFAD.QUERY_PARAM_VULN_STATUS]);
    return {
        and: [
            {
                lastUpdated: {
                    sort: {
                        priority: 1,
                        order: (0, $5eeaw.AriGraphSortOrderInput).DESC
                    }
                },
                to_severity: $526907709998fa0b$var$getFilterValue($526907709998fa0b$var$getOrDefault((0, $3o4IF.arrayQueryParamToFilter)(queryParams[0, $3zFAD.QUERY_PARAM_SEVERITY]).map((0, $3o4IF.parseSeverity)).filter(Boolean), (0, $3zFAD.initialVulnerabilityTableOptions).severityFilter), 'severity', queryParams[0, $3zFAD.QUERY_PARAM_SORT_KEY], queryParams[0, $3zFAD.QUERY_PARAM_SORT_ORDER]),
                to_status: $526907709998fa0b$var$getFilterValue(statusQueryParams.includes((0, $3zFAD.NO_FILTER_VULN_STATUS)) ? [] : $526907709998fa0b$var$getOrDefault(statusQueryParams.map((0, $3o4IF.parseStatus)).filter(Boolean), (0, $3zFAD.initialVulnerabilityTableOptions).statusFilter), 'status', queryParams[0, $3zFAD.QUERY_PARAM_SORT_KEY], queryParams[0, $3zFAD.QUERY_PARAM_SORT_ORDER]),
                createdAt: {
                    ...queryParams[0, $3zFAD.QUERY_PARAM_SORT_KEY] === 'introduced' && {
                        sort: {
                            priority: 2,
                            order: (0, $3o4IF.parseSortDirection)(queryParams[0, $3zFAD.QUERY_PARAM_SORT_ORDER], (0, $5eeaw.AriGraphSortOrderInput).DESC)
                        }
                    }
                },
                to_container: {
                    containerAri: {
                        value: {
                            ...containerValues.length > 0 ? {
                                values: containerValues
                            } : {}
                        }
                    }
                }
            }
        ]
    };
};

});
parcelRegister("5eeaw", function(module, exports) {

$parcel$export(module.exports, "AriGraphSortOrderInput", () => $f98addb8b52ad07a$export$3b69903df4cd6048);
const $f98addb8b52ad07a$export$3b69903df4cd6048 = {
    ASC: 'ASC',
    DESC: 'DESC'
};

});

parcelRegister("3zFAD", function(module, exports) {

$parcel$export(module.exports, "QUERY_PARAM_SEARCH", () => $d1be2b44eb126533$export$a181206198b7f50c);
$parcel$export(module.exports, "QUERY_PARAM_CONTAINER", () => $d1be2b44eb126533$export$3873b20ffa21b004);
$parcel$export(module.exports, "QUERY_PARAM_SEVERITY", () => $d1be2b44eb126533$export$af01a3d59250f3d3);
$parcel$export(module.exports, "QUERY_PARAM_VULN_STATUS", () => $d1be2b44eb126533$export$c315695f017955dc);
$parcel$export(module.exports, "QUERY_PARAM_ISSUE_STATUS", () => $d1be2b44eb126533$export$2e69a24fe65d4109);
$parcel$export(module.exports, "QUERY_PARAM_SORT_KEY", () => $d1be2b44eb126533$export$6da773286c35ef41);
$parcel$export(module.exports, "QUERY_PARAM_SORT_ORDER", () => $d1be2b44eb126533$export$810a1f7ed2facfcb);
$parcel$export(module.exports, "NO_FILTER_VULN_STATUS", () => $d1be2b44eb126533$export$d8115099d465de4c);
$parcel$export(module.exports, "initialVulnerabilityTableOptions", () => $d1be2b44eb126533$export$e9b4ea84d666c490);
const $d1be2b44eb126533$export$a181206198b7f50c = 'search';
const $d1be2b44eb126533$export$3873b20ffa21b004 = 'container';
const $d1be2b44eb126533$export$af01a3d59250f3d3 = 'severity';
const $d1be2b44eb126533$export$c315695f017955dc = 'vulnerabilityStatus';
const $d1be2b44eb126533$export$2e69a24fe65d4109 = 'issueStatus';
const $d1be2b44eb126533$export$6da773286c35ef41 = 'sortKey';
const $d1be2b44eb126533$export$810a1f7ed2facfcb = 'sortOrder';
const $d1be2b44eb126533$export$d8115099d465de4c = 'NO-FILTERS';
const $d1be2b44eb126533$var$initialVulnerabilityTableFilters = {
    searchFilter: '',
    connectionFilter: [],
    severityFilter: [],
    statusFilter: [
        'OPEN'
    ],
    jiraIssueStatusFilter: []
};
const $d1be2b44eb126533$export$e9b4ea84d666c490 = {
    sortKey: 'severity',
    sortOrder: 'DESC',
    ...$d1be2b44eb126533$var$initialVulnerabilityTableFilters
};

});

parcelRegister("3o4IF", function(module, exports) {

$parcel$export(module.exports, "arrayQueryParamToFilter", () => $dbe4482e2428caff$export$7500862c6689a767);
$parcel$export(module.exports, "arrayFilterToQueryParam", () => $dbe4482e2428caff$export$b0dee3c5bfc7249e);
$parcel$export(module.exports, "connectionFilterToQueryParam", () => $dbe4482e2428caff$export$a6950ca4fdc8498f);
$parcel$export(module.exports, "connectionQueryParamToFilter", () => $dbe4482e2428caff$export$1040034504af5b41);
$parcel$export(module.exports, "parseSeverity", () => $dbe4482e2428caff$export$3551b8a2cbdb5162);
$parcel$export(module.exports, "parseStatus", () => $dbe4482e2428caff$export$2188844eb84f7f06);
$parcel$export(module.exports, "parseSortDirection", () => $dbe4482e2428caff$export$85cf5c73b48a482e);

var $chc6P = parcelRequire("chc6P");

var $80afZ = parcelRequire("80afZ");

var $5eeaw = parcelRequire("5eeaw");

var $i3r1A = parcelRequire("i3r1A");
const $dbe4482e2428caff$var$DELIMITER = ',';
const $dbe4482e2428caff$var$ENCODED_DELIMITER = encodeURIComponent($dbe4482e2428caff$var$DELIMITER);
// We encode the delimiter to protect the values from containing
// the same character that delimits the list.
// e.g.
// env names = ["prod,east", "prod,west"] -> "prod,east,prod,west"
const $dbe4482e2428caff$var$encodeDelimiter = (input)=>{
    const regex = new RegExp($dbe4482e2428caff$var$DELIMITER, 'g');
    return input.replace(regex, $dbe4482e2428caff$var$ENCODED_DELIMITER);
};
const $dbe4482e2428caff$var$decodeDelimiter = (input)=>{
    const regex = new RegExp($dbe4482e2428caff$var$ENCODED_DELIMITER, 'g');
    return input.replace(regex, $dbe4482e2428caff$var$DELIMITER);
};
const $dbe4482e2428caff$export$7500862c6689a767 = (queryParamString)=>queryParamString?.split($dbe4482e2428caff$var$DELIMITER)?.map($dbe4482e2428caff$var$decodeDelimiter) ?? [];
const $dbe4482e2428caff$export$b0dee3c5bfc7249e = (filterArray)=>{
    if (filterArray.length === 0) return undefined;
    return filterArray.map((entity)=>$dbe4482e2428caff$var$encodeDelimiter(entity)).join($dbe4482e2428caff$var$DELIMITER);
};
const $dbe4482e2428caff$export$a6950ca4fdc8498f = (connectionArray)=>{
    if (connectionArray.length === 0) return undefined;
    const groupedConnectionsByAppKey = connectionArray.reduce((acc, connection)=>{
        const [, , , , securityParts] = connection.split(':');
        const [, , , appKey, ...containerId] = securityParts.split('/');
        if (!acc[appKey]) acc[appKey] = [];
        acc[appKey].push(containerId.join('/'));
        return acc;
    }, {});
    return JSON.stringify(groupedConnectionsByAppKey);
};
const $dbe4482e2428caff$export$1040034504af5b41 = (queryParamString, connectionAri)=>{
    if (!queryParamString) return [];
    const groupedConnectionsByAppKey = JSON.parse(queryParamString);
    return (0, (/*@__PURE__*/$parcel$interopDefault($chc6P)))(groupedConnectionsByAppKey, (containerIds, appKey)=>(0, (/*@__PURE__*/$parcel$interopDefault($80afZ)))(containerIds, (containerId)=>`${connectionAri}${appKey}/${containerId}`));
};
const $dbe4482e2428caff$export$3551b8a2cbdb5162 = (maybeSeverity)=>{
    switch(maybeSeverity?.toUpperCase()){
        case (0, $i3r1A.VulnerabilitySeverityEnums).CRITICAL.toUpperCase():
            return (0, $i3r1A.VulnerabilitySeverityEnums).CRITICAL;
        case (0, $i3r1A.VulnerabilitySeverityEnums).HIGH.toUpperCase():
            return (0, $i3r1A.VulnerabilitySeverityEnums).HIGH;
        case (0, $i3r1A.VulnerabilitySeverityEnums).LOW.toUpperCase():
            return (0, $i3r1A.VulnerabilitySeverityEnums).LOW;
        case (0, $i3r1A.VulnerabilitySeverityEnums).MEDIUM.toUpperCase():
            return (0, $i3r1A.VulnerabilitySeverityEnums).MEDIUM;
        case (0, $i3r1A.VulnerabilitySeverityEnums).UNKNOWN.toUpperCase():
            return (0, $i3r1A.VulnerabilitySeverityEnums).UNKNOWN;
        default:
            return undefined;
    }
};
const $dbe4482e2428caff$export$2188844eb84f7f06 = (maybeStatus)=>{
    switch(maybeStatus?.toUpperCase()){
        case (0, $i3r1A.VulnerabilityStatusEnums).OPEN.toUpperCase():
            return (0, $i3r1A.VulnerabilityStatusEnums).OPEN;
        case (0, $i3r1A.VulnerabilityStatusEnums).UNKNOWN.toUpperCase():
            return (0, $i3r1A.VulnerabilityStatusEnums).UNKNOWN;
        case (0, $i3r1A.VulnerabilityStatusEnums).CLOSED.toUpperCase():
            return (0, $i3r1A.VulnerabilityStatusEnums).CLOSED;
        case (0, $i3r1A.VulnerabilityStatusEnums).IGNORED.toUpperCase():
            return (0, $i3r1A.VulnerabilityStatusEnums).IGNORED;
        default:
            return undefined;
    }
};
const $dbe4482e2428caff$export$85cf5c73b48a482e = (maybeDirection, defaultValue)=>{
    switch(maybeDirection?.toUpperCase()){
        case (0, $5eeaw.AriGraphSortOrderInput).ASC.toUpperCase():
            return (0, $5eeaw.AriGraphSortOrderInput).ASC;
        case (0, $5eeaw.AriGraphSortOrderInput).DESC.toUpperCase():
            return (0, $5eeaw.AriGraphSortOrderInput).DESC;
        default:
            return defaultValue;
    }
};

});
parcelRegister("chc6P", function(module, exports) {

var $ekcP3 = parcelRequire("ekcP3");

var $80afZ = parcelRequire("80afZ");
/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $8f007734a6a4d9ac$var$flatMap(collection, iteratee) {
    return $ekcP3($80afZ(collection, iteratee), 1);
}
module.exports = $8f007734a6a4d9ac$var$flatMap;

});
parcelRegister("80afZ", function(module, exports) {

var $1nIHN = parcelRequire("1nIHN");

var $bxDef = parcelRequire("bxDef");

var $jXnVG = parcelRequire("jXnVG");

var $8LQ84 = parcelRequire("8LQ84");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $5d3647a04b83e8d6$var$map(collection, iteratee) {
    var func = $8LQ84(collection) ? $1nIHN : $jXnVG;
    return func(collection, $bxDef(iteratee, 3));
}
module.exports = $5d3647a04b83e8d6$var$map;

});
parcelRegister("jXnVG", function(module, exports) {

var $e7pfQ = parcelRequire("e7pfQ");

var $hTJwX = parcelRequire("hTJwX");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $e87616de80329acf$var$baseMap(collection, iteratee) {
    var index = -1, result = $hTJwX(collection) ? Array(collection.length) : [];
    $e7pfQ(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = $e87616de80329acf$var$baseMap;

});



parcelRegister("i3r1A", function(module, exports) {

$parcel$export(module.exports, "VulnerabilitySeverityEnums", () => $e40f3ad586d15bb3$export$c1a102938d8dc10);
$parcel$export(module.exports, "VulnerabilityStatusEnums", () => $e40f3ad586d15bb3$export$2d6749bded378262);
const $e40f3ad586d15bb3$export$c1a102938d8dc10 = {
    CRITICAL: 'CRITICAL',
    HIGH: 'HIGH',
    LOW: 'LOW',
    MEDIUM: 'MEDIUM',
    UNKNOWN: 'UNKNOWN'
};
const $e40f3ad586d15bb3$export$2d6749bded378262 = {
    CLOSED: 'CLOSED',
    IGNORED: 'IGNORED',
    OPEN: 'OPEN',
    UNKNOWN: 'UNKNOWN'
};
const $e40f3ad586d15bb3$var$VulnerabilityTypeEnums = {
    DAST: 'DAST',
    SAST: 'SAST',
    SCA: 'SCA',
    UNKNOWN: 'UNKNOWN'
};

});



const $0a72320b8bc3a1aa$export$f24db22c3c834cb1 = 'SOFTWARE_SECURITY';


parcelRegister("g5C5j", function(module, exports) {

$parcel$export(module.exports, "softwareSecurityClassicRoute", () => $c527ab87b834a4bd$export$b7285748f1151353);
const $c527ab87b834a4bd$export$b7285748f1151353 = {
    name: 'software-security-classic',
    path: '/jira/software/c/projects/:projectKey/security'
};

});

parcelRegister("crK2h", function(module, exports) {

$parcel$export(module.exports, "isSecurityPageEnabled", () => $36196b3bd8f08294$export$f99b2868577ed515);

var $4R6GH = parcelRequire("4R6GH");

var $kfztd = parcelRequire("kfztd");
const $36196b3bd8f08294$export$f99b2868577ed515 = ()=>!(0, $kfztd.isDevopsFeatureDisabledInFedRamp)() && (0, $4R6GH.fg)('isotopes-security-page-in-jira-enabled-v2');

});

parcelRegister("7AM4I", function(module, exports) {

$parcel$export(module.exports, "securityPageEntrypoint", () => $3090928057015737$export$5f2f9dbf41e3e769);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $kyG7f = parcelRequire("kyG7f");

var $fo6b8 = parcelRequire("fo6b8");
const $3090928057015737$export$5f2f9dbf41e3e769 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $kyG7f.securityEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("kyG7f", function(module, exports) {

$parcel$export(module.exports, "securityEntrypoint", () => $9ed435daf1131762$export$63f7fc80f88b035a);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $9ed435daf1131762$export$63f7fc80f88b035a = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("hCQIy")), {
        moduleId: "c02ceeea",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("hCQIy", function(module, exports) {

let $cd4ee0eb0f4059bd$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $cd4ee0eb0f4059bd$var$load("ffQaD"),
    $cd4ee0eb0f4059bd$var$load("kvRbA"),
    $cd4ee0eb0f4059bd$var$load("5nKJ0")
]).then(()=>parcelRequire('9J8Ay'));

});




parcelRegister("cyZLC", function(module, exports) {

$parcel$export(module.exports, "softwareSecurityNextGenRouteEntry", () => $9f02076ad45b829a$export$a8dcfae475505e7a);

var $e4eHl = parcelRequire("e4eHl");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $en8e6 = parcelRequire("en8e6");

var $d1QwJ = parcelRequire("d1QwJ");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $6LsQE = parcelRequire("6LsQE");

var $crK2h = parcelRequire("crK2h");

var $7AM4I = parcelRequire("7AM4I");
const $9f02076ad45b829a$export$a8dcfae475505e7a = (0, $7NszV.createEntry)((0, $d1QwJ.softwareSecurityNextGenRoute), ()=>({
        group: 'software',
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        ufoName: 'software-security-combined',
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource),
            (0, $en8e6.securityPageResource)
        ],
        meta: {
            reporting: {
                id: 'software-security',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-security'),
                teamName: 'fusion-isotopes'
            }
        },
        entryPoint: ()=>(0, $crK2h.isSecurityPageEnabled)() ? (0, $7AM4I.securityPageEntrypoint) : (0, $6LsQE.notFoundPageEntrypoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("d1QwJ", function(module, exports) {

$parcel$export(module.exports, "softwareSecurityNextGenRoute", () => $38bba03addfade00$export$a2aed78ebacc3233);
const $38bba03addfade00$export$a2aed78ebacc3233 = {
    name: 'software-security',
    path: '/jira/software/projects/:projectKey/security'
};

});


parcelRegister("7PtTb", function(module, exports) {

$parcel$export(module.exports, "softwareStaffingRouteEntry", () => $12bd43395964fa40$export$71a3a4cc27cbe00a);

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $3RJkv = parcelRequire("3RJkv");

var $6LsQE = parcelRequire("6LsQE");

var $dxCvy = parcelRequire("dxCvy");

var $jsFU4 = parcelRequire("jsFU4");

var $7GnDe = parcelRequire("7GnDe");

var $3svbL = parcelRequire("3svbL");

var $8STJR = parcelRequire("8STJR");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $4R6GH = parcelRequire("4R6GH");

var $1fXOB = parcelRequire("1fXOB");
const $12bd43395964fa40$export$71a3a4cc27cbe00a = (0, $7NszV.createEntry)((0, $3svbL.softwareStaffingRoute), ()=>({
        group: 'software',
        skeleton: (0, $8STJR.RoadmapSkeleton),
        layout: (0, $aPfsS.composeLayouts)((0, $e7bC3.softwareProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $jsFU4.nextGenRoadmapResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-roadmap-early-entry'
            ]
        },
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        entryPoint: ()=>(0, $4R6GH.fg)('staffing') ? (0, $1fXOB.staffingRouteEntrypoint) : (0, $6LsQE.notFoundPageEntrypoint),
        ufoName: 'next-gen-roadmap',
        supportsPreviewPanel: true
    }));

});
parcelRegister("3svbL", function(module, exports) {

$parcel$export(module.exports, "softwareStaffingRoute", () => $9bf480f2b06baa65$export$aa817709e0cb3b6d);
const $9bf480f2b06baa65$export$aa817709e0cb3b6d = {
    name: 'software-staffing',
    path: '/jira/software/projects/:projectKey/boards/:boardId/staffing',
    query: [
        'issueKey?'
    ]
};

});

parcelRegister("1fXOB", function(module, exports) {

$parcel$export(module.exports, "staffingRouteEntrypoint", () => $d9c937c27ede0b49$export$3a16ef365bcb8560);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $fo6b8 = parcelRequire("fo6b8");

var $ewQz2 = parcelRequire("ewQz2");
const $d9c937c27ede0b49$export$3a16ef365bcb8560 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $ewQz2.staffingEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("ewQz2", function(module, exports) {

$parcel$export(module.exports, "staffingEntrypoint", () => $1f62c1dd3ab84c1d$export$94a659cc78d2756a);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $1f62c1dd3ab84c1d$export$94a659cc78d2756a = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("9DFVW")), {
        moduleId: "39c7d120",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9DFVW", function(module, exports) {

let $704848b68d03fd43$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $704848b68d03fd43$var$load("ffQaD"),
    $704848b68d03fd43$var$load("kvRbA"),
    $704848b68d03fd43$var$load("8Yg3F")
]).then(()=>parcelRequire('g02gC'));

});




parcelRegister("iwgxt", function(module, exports) {

$parcel$export(module.exports, "softwareSummaryClassicRouteEntry", () => $ab4cacd7ed3eca70$export$f81c7c178a9483e8);

var $7NszV = parcelRequire("7NszV");

var $lmyls = parcelRequire("lmyls");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $7uLIV = parcelRequire("7uLIV");

var $9s3j1 = parcelRequire("9s3j1");

var $5f2bR = parcelRequire("5f2bR");

var $4E1mJ = parcelRequire("4E1mJ");

var $7XYc4 = parcelRequire("7XYc4");

var $6s1PB = parcelRequire("6s1PB");

var $f3iuv = parcelRequire("f3iuv");

var $5lsNZ = parcelRequire("5lsNZ");

var $e7bC3 = parcelRequire("e7bC3");

var $ffza4 = parcelRequire("ffza4");

var $1wsDh = parcelRequire("1wsDh");

var $fo6b8 = parcelRequire("fo6b8");

var $4R6GH = parcelRequire("4R6GH");

var $lkFvK = parcelRequire("lkFvK");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");
const $ab4cacd7ed3eca70$var$summarySoftwarePageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1wsDh.summarySoftwareEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
/**
 * @deprecated delete when cleaning up project_summary_page_entry_point_migration
 */ const $ab4cacd7ed3eca70$var$getHorizontalNavResources = ()=>(0, $4R6GH.fg)('project_summary_page_entry_point_migration') ? [] : [
        (0, $7uLIV.horizontalNavJiraResource)
    ];
const $ab4cacd7ed3eca70$export$f81c7c178a9483e8 = (0, $7NszV.createEntry)((0, $4E1mJ.softwareSummaryClassicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-summary',
        component: (0, $7XYc4.componentWithCondition)(()=>(0, $6s1PB.expVal)('helios_summary_page_experiment', 'isEnabled', false), (0, $f3iuv.SummaryPage), (0, $5lsNZ.default)),
        layout: (0, $e7bC3.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // delete when cleaning up project_summary_page_entry_point_migration
            ...$ab4cacd7ed3eca70$var$getHorizontalNavResources(),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingEnabled)(), (0, $9V5k0.projectThemeResource))
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $f3iuv.LazySummaryView)
        ],
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('project_summary_page_entry_point_migration')) return $ab4cacd7ed3eca70$var$summarySoftwarePageEntrypoint;
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("4E1mJ", function(module, exports) {

$parcel$export(module.exports, "softwareSummaryClassicRoute", () => $b668e7dcab7792ea$export$b5046fccf399983f);
const $b668e7dcab7792ea$export$b5046fccf399983f = {
    name: 'software-summary-classic',
    path: '/jira/software/c/projects/:projectKey/summary'
};

});

parcelRegister("f3iuv", function(module, exports) {

$parcel$export(module.exports, "LazySummaryView", () => $d82700466a756427$export$68c09444cc6f2843);
$parcel$export(module.exports, "SummaryPage", () => $d82700466a756427$export$893608e1a22999b9);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $d82700466a756427$export$68c09444cc6f2843 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("hrhTc")), {
    moduleId: "./src/packages/spa-apps/software/summary/src/index.tsx"
});
const $d82700466a756427$export$893608e1a22999b9 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d82700466a756427$export$68c09444cc6f2843,
        pageId: "software-summary",
        shouldShowSpinner: true
    });
};

});
parcelRegister("hrhTc", function(module, exports) {

let $cb22d5b75657b987$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $cb22d5b75657b987$var$load("ffQaD"),
    $cb22d5b75657b987$var$load("kvRbA"),
    $cb22d5b75657b987$var$load("fliVL"),
    $cb22d5b75657b987$var$load("6kvkI")
]).then(()=>parcelRequire('iPGiI'));

});


parcelRegister("1wsDh", function(module, exports) {

$parcel$export(module.exports, "summarySoftwareEntrypoint", () => $be62f623caf39bbf$export$6c7cf31fcbd213b8);

var $6qQRa = parcelRequire("6qQRa");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $be62f623caf39bbf$export$6c7cf31fcbd213b8 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("9aXL6")), {
        moduleId: "078ea488",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                summaryQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $6qQRa.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("6qQRa", function(module, exports) {

$parcel$export(module.exports, "default", () => $84891a6ef49bdd23$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2c0776ec3e9f6a74e53887f11a831651>>
 * @relayHash 51efb3864f270fc508c3c4676be5d9f6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8b8af805c4172b0ed36c74fe68563d0a938d57e1cf91158c7fa6cbe92c6dc022
const $84891a6ef49bdd23$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "8b8af805c4172b0ed36c74fe68563d0a938d57e1cf91158c7fa6cbe92c6dc022",
        "metadata": {},
        "name": "src_jiraSummarySoftwareQuery",
        "operationKind": "query",
        "text": null
    }
};
var $84891a6ef49bdd23$export$2e2bcd8739ae039 = $84891a6ef49bdd23$var$node;

});

parcelRegister("9aXL6", function(module, exports) {

let $6ae3670e1f68a0b3$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6ae3670e1f68a0b3$var$load("ffQaD"),
    $6ae3670e1f68a0b3$var$load("kvRbA"),
    $6ae3670e1f68a0b3$var$load("fliVL"),
    $6ae3670e1f68a0b3$var$load("d8OKj")
]).then(()=>parcelRequire('l0bjd'));

});



parcelRegister("e99fJ", function(module, exports) {

$parcel$export(module.exports, "softwareSummaryEmbedClassicRouteEntry", () => $ee0193265f7cd493$export$1dc5e581d8ca39ac);

var $7NszV = parcelRequire("7NszV");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $8zMZd = parcelRequire("8zMZd");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $jEWyg = parcelRequire("jEWyg");

var $5lsNZ = parcelRequire("5lsNZ");

var $6e4Kt = parcelRequire("6e4Kt");

var $9Hxle = parcelRequire("9Hxle");

var $4R6GH = parcelRequire("4R6GH");

var $lkFvK = parcelRequire("lkFvK");
const $ee0193265f7cd493$var$summarySoftwareEmbedPageEntrypoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $9Hxle.summarySoftwareEmbedEntrypoint)
});
const $ee0193265f7cd493$export$1dc5e581d8ca39ac = (0, $7NszV.createEntry)((0, $8zMZd.softwareSummaryEmbedClassicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-summary',
        component: (0, $7XYc4.componentWithCondition)(()=>(0, $6s1PB.expVal)('jsw-summary-page-embed-smart-link-experiment', 'isEnabled', false), (0, $jEWyg.SummaryEmbedPage), (0, $5lsNZ.default)),
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource)
        ],
        forPaint: [
            (0, $jEWyg.LazySummaryEmbedView)
        ],
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('project_summary_page_entry_point_migration')) return $ee0193265f7cd493$var$summarySoftwareEmbedPageEntrypoint;
        }
    }));

});
parcelRegister("8zMZd", function(module, exports) {

$parcel$export(module.exports, "softwareSummaryEmbedClassicRoute", () => $f4e6d1316b36f71d$export$7fa3d3891ccec782);
const $f4e6d1316b36f71d$export$7fa3d3891ccec782 = {
    name: 'software-summary-classic-embed',
    path: '/jira/software/c/projects/:projectKey/summary/embed'
};

});

parcelRegister("jEWyg", function(module, exports) {

$parcel$export(module.exports, "LazySummaryEmbedView", () => $e2492c3e1d27fc60$export$f3f4cdbc1967d695);
$parcel$export(module.exports, "SummaryEmbedPage", () => $e2492c3e1d27fc60$export$f811b1e7f401bfca);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $e2492c3e1d27fc60$export$f3f4cdbc1967d695 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("dalNR")), {
    moduleId: "./src/packages/spa-apps/software/summary-embed/src/index.tsx"
});
const $e2492c3e1d27fc60$export$f811b1e7f401bfca = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e2492c3e1d27fc60$export$f3f4cdbc1967d695,
        pageId: "software-summary-embed",
        shouldShowSpinner: true
    });
};

});
parcelRegister("dalNR", function(module, exports) {

let $995d1f31532f42e3$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $995d1f31532f42e3$var$load("ffQaD"),
    $995d1f31532f42e3$var$load("kvRbA"),
    $995d1f31532f42e3$var$load("fliVL"),
    $995d1f31532f42e3$var$load("eDKGL")
]).then(()=>parcelRequire('ipup0'));

});


parcelRegister("9Hxle", function(module, exports) {

$parcel$export(module.exports, "summarySoftwareEmbedEntrypoint", () => $dceaf7b32f2cb59b$export$4eeb5d2e0e9b94b6);

var $31XuO = parcelRequire("31XuO");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $dceaf7b32f2cb59b$export$4eeb5d2e0e9b94b6 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("2bpCW")), {
        moduleId: "192c966d",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                summaryQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $31XuO.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("31XuO", function(module, exports) {

$parcel$export(module.exports, "default", () => $48d77923a7d779ad$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<28aa849ce641b8c8bef67b5f178b9188>>
 * @relayHash 886a8ebe0b7faaa17276f23a1313cc2e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ec953cd8f672124749ec67356940dfd48e2bc1b926c2f3ce46d963fbecdceed3
const $48d77923a7d779ad$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "ec953cd8f672124749ec67356940dfd48e2bc1b926c2f3ce46d963fbecdceed3",
        "metadata": {},
        "name": "src_jiraSummarySoftwareEmbedQuery",
        "operationKind": "query",
        "text": null
    }
};
var $48d77923a7d779ad$export$2e2bcd8739ae039 = $48d77923a7d779ad$var$node;

});

parcelRegister("2bpCW", function(module, exports) {

let $19707cd683232c05$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $19707cd683232c05$var$load("ffQaD"),
    $19707cd683232c05$var$load("kvRbA"),
    $19707cd683232c05$var$load("fliVL"),
    $19707cd683232c05$var$load("6DaVr")
]).then(()=>parcelRequire('3aj3b'));

});



parcelRegister("45nsl", function(module, exports) {

$parcel$export(module.exports, "softwareSummaryEmbedRouteEntry", () => $68cfbfd8adbf1577$export$d0dcb1130082d8e);

var $e4eHl = parcelRequire("e4eHl");

var $6e4Kt = parcelRequire("6e4Kt");

var $7NszV = parcelRequire("7NszV");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $5lsNZ = parcelRequire("5lsNZ");

var $czTBf = parcelRequire("czTBf");

var $5bkvv = parcelRequire("5bkvv");

var $dxCvy = parcelRequire("dxCvy");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $9Hxle = parcelRequire("9Hxle");

var $4R6GH = parcelRequire("4R6GH");

var $lkFvK = parcelRequire("lkFvK");

var $jEWyg = parcelRequire("jEWyg");
const $68cfbfd8adbf1577$var$summarySoftwareEmbedPageEntrypoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $9Hxle.summarySoftwareEmbedEntrypoint)
});
const $68cfbfd8adbf1577$export$d0dcb1130082d8e = (0, $7NszV.createEntry)((0, $czTBf.softwareSummaryEmbedRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-summary-embed',
        component: (0, $7XYc4.componentWithCondition)(()=>(0, $6s1PB.expVal)('jsw-summary-page-embed-smart-link-experiment', 'isEnabled', false), (0, $jEWyg.SummaryEmbedPage), (0, $5lsNZ.default)),
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource)
        ],
        forPaint: [
            (0, $jEWyg.LazySummaryEmbedView)
        ],
        meta: {
            reporting: {
                id: 'software-summary-embed',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-summary-embed'),
                teamName: 'Helios - Reports'
            }
        },
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('project_summary_page_entry_point_migration')) return $68cfbfd8adbf1577$var$summarySoftwareEmbedPageEntrypoint;
        }
    }));

});
parcelRegister("czTBf", function(module, exports) {

$parcel$export(module.exports, "softwareSummaryEmbedRoute", () => $47c531ece2da49b6$export$11863f01f5694529);
const $47c531ece2da49b6$export$11863f01f5694529 = {
    name: 'software-summary-embed',
    path: '/jira/software/projects/:projectKey/summary/embed'
};

});


parcelRegister("9EGBH", function(module, exports) {

$parcel$export(module.exports, "softwareSummaryRouteEntry", () => $68cc040c529fc630$export$a2560b0baf928c49);

var $e4eHl = parcelRequire("e4eHl");

var $ffza4 = parcelRequire("ffza4");

var $lkFvK = parcelRequire("lkFvK");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $5lsNZ = parcelRequire("5lsNZ");

var $7P9Hl = parcelRequire("7P9Hl");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $1wsDh = parcelRequire("1wsDh");

var $fo6b8 = parcelRequire("fo6b8");

var $4R6GH = parcelRequire("4R6GH");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");

var $f3iuv = parcelRequire("f3iuv");
/**
 * @deprecated delete when cleaning up project_summary_page_entry_point_migration
 */ const $68cc040c529fc630$var$getHorizontalNavResources = ()=>(0, $4R6GH.fg)('project_summary_page_entry_point_migration') ? [] : [
        (0, $7uLIV.horizontalNavJiraResource)
    ];
const $68cc040c529fc630$var$summarySoftwarePageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1wsDh.summarySoftwareEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $68cc040c529fc630$export$a2560b0baf928c49 = (0, $7NszV.createEntry)((0, $7P9Hl.softwareSummaryRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-summary',
        component: (0, $7XYc4.componentWithCondition)(()=>(0, $6s1PB.expVal)('helios_summary_page_experiment', 'isEnabled', false), (0, $f3iuv.SummaryPage), (0, $5lsNZ.default)),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            /// delete when cleaning up project_summary_page_entry_point_migration
            ...$68cc040c529fc630$var$getHorizontalNavResources(),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingEnabled)(), (0, $9V5k0.projectThemeResource))
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $f3iuv.LazySummaryView)
        ],
        meta: {
            reporting: {
                id: 'software-summary',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-summary'),
                teamName: 'Helios - Reports'
            }
        },
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('project_summary_page_entry_point_migration')) return $68cc040c529fc630$var$summarySoftwarePageEntrypoint;
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("7P9Hl", function(module, exports) {

$parcel$export(module.exports, "softwareSummaryRoute", () => $cff79d22061504ff$export$c6629202e90df62a);
const $cff79d22061504ff$export$c6629202e90df62a = {
    name: 'software-summary',
    path: '/jira/software/projects/:projectKey/summary'
};

});


parcelRegister("heIfC", function(module, exports) {

$parcel$export(module.exports, "softwareTimelineClassicRouteEntry", () => $bac13144920c2c2e$export$a822ee67d4c66296);

var $7NszV = parcelRequire("7NszV");

var $ie7vB = parcelRequire("ie7vB");

var $8STJR = parcelRequire("8STJR");

var $aPfsS = parcelRequire("aPfsS");

var $e7bC3 = parcelRequire("e7bC3");

var $g5RGc = parcelRequire("g5RGc");

var $lmyls = parcelRequire("lmyls");

var $9s3j1 = parcelRequire("9s3j1");

var $5f2bR = parcelRequire("5f2bR");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $7uLIV = parcelRequire("7uLIV");

var $hJAri = parcelRequire("hJAri");

var $fKmub = parcelRequire("fKmub");

var $ffza4 = parcelRequire("ffza4");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");

var $4R6GH = parcelRequire("4R6GH");

var $j0EJB = parcelRequire("j0EJB");

var $jK0PE = parcelRequire("jK0PE");
/** @deprecated remove when cleaning up 'jira-timeline-classic-route-entrypoint-migration' */ const $bac13144920c2c2e$var$getHorizontalNavResource = ()=>(0, $4R6GH.fg)('jira-timeline-classic-route-entrypoint-migration') ? [] : [
        (0, $7uLIV.horizontalNavJiraResource)
    ];
const $bac13144920c2c2e$var$getConditionalResources = ()=>(0, $4R6GH.fg)('optimise_timeline_routes') ? [
        (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
        (0, $5bkvv.forgeProjectModuleResourceOnNav3Only),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only)
    ] : [
        (0, $7GnDe.incidentExperimentTraitResource),
        (0, $5bkvv.forgeProjectModuleResource),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
    ];
const $bac13144920c2c2e$export$a822ee67d4c66296 = (0, $7NszV.createEntry)((0, $ie7vB.softwareTimelineClassicRoute), ()=>({
        group: 'classic-software',
        component: (0, $4R6GH.fg)('jira-timeline-classic-route-entrypoint-migration') ? undefined : (0, $j0EJB.default),
        skeleton: (0, $8STJR.RoadmapSkeleton),
        layout: (0, $aPfsS.composeLayouts)((0, $4R6GH.fg)('optimise_timeline_routes') ? (0, $e7bC3.softwareProjectLayoutCode) : (0, $e7bC3.classicSoftwareProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            ...$bac13144920c2c2e$var$getConditionalResources(),
            ...$bac13144920c2c2e$var$getHorizontalNavResource(),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $hJAri.classicRoadmapResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingEnabled)(), (0, $9V5k0.projectThemeResource))
        ],
        preloadOptions: {
            earlyChunks: [
                'software-roadmap-early-entry'
            ]
        },
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: (0, $4R6GH.fg)('jira-timeline-classic-route-entrypoint-migration') ? undefined : [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $j0EJB.LazyRoadmapViewClassic)
        ],
        ufoName: 'classic-roadmap',
        entryPoint: ()=>(0, $4R6GH.fg)('jira-timeline-classic-route-entrypoint-migration') ? (0, $jK0PE.roadmapViewClassicPageEntrypoint) : undefined,
        supportsPreviewPanel: true
    }));

});
parcelRegister("ie7vB", function(module, exports) {

$parcel$export(module.exports, "softwareTimelineClassicRoute", () => $9063b50694a4a155$export$ce5173f7e8fa932b);
const $9063b50694a4a155$export$ce5173f7e8fa932b = {
    name: 'software-timeline-classic',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/timeline'
};

});

parcelRegister("jK0PE", function(module, exports) {

$parcel$export(module.exports, "roadmapViewClassicPageEntrypoint", () => $636a0aa010a33fb5$export$af2674d32463682f);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $9uS0k = parcelRequire("9uS0k");

var $fo6b8 = parcelRequire("fo6b8");
const $636a0aa010a33fb5$export$af2674d32463682f = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $9uS0k.roadmapViewClassicEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("9uS0k", function(module, exports) {

$parcel$export(module.exports, "roadmapViewClassicEntrypoint", () => $ec06132eb53a85c8$export$583357f75b3be3a7);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $ec06132eb53a85c8$export$583357f75b3be3a7 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("9fltS")), {
        moduleId: "7a5c4192",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9fltS", function(module, exports) {

let $6bb62d678f3319c6$var$load = (parcelRequire("28QjX"))(4);

module.exports = Promise.all([
    (parcelRequire("avM1e"))('jirt-convert-class-to-functional-component', function() {
        return Promise.all([
            $6bb62d678f3319c6$var$load("1ls92")
        ]);
    }, function() {
        return Promise.all([
            $6bb62d678f3319c6$var$load("kLeYK")
        ]);
    }),
    $6bb62d678f3319c6$var$load("ffQaD"),
    $6bb62d678f3319c6$var$load("kvRbA"),
    $6bb62d678f3319c6$var$load("iMOIp")
]).then(()=>parcelRequire('9PBZj'));

});




parcelRegister("jejF3", function(module, exports) {

$parcel$export(module.exports, "softwareTimelineRouteEntry", () => $e9207ae3efc3becd$export$ace6a996c7e99f3);

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $jsFU4 = parcelRequire("jsFU4");

var $7GnDe = parcelRequire("7GnDe");

var $3gei1 = parcelRequire("3gei1");

var $8STJR = parcelRequire("8STJR");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");

var $4R6GH = parcelRequire("4R6GH");

var $fAhgR = parcelRequire("fAhgR");
const $e9207ae3efc3becd$var$getConditionalResources = ()=>(0, $4R6GH.fg)('optimise_timeline_routes') ? [
        (0, $5bkvv.forgeProjectModuleResourceOnNav3Only),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only)
    ] : [
        (0, $5bkvv.forgeProjectModuleResource),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
    ];
const $e9207ae3efc3becd$export$ace6a996c7e99f3 = (0, $7NszV.createEntry)((0, $3gei1.softwareTimelineRoute), ()=>({
        group: 'software',
        skeleton: (0, $8STJR.RoadmapSkeleton),
        layout: (0, $aPfsS.composeLayouts)((0, $4R6GH.fg)('optimise_timeline_routes') ? (0, $e7bC3.softwareProjectLayoutCode) : (0, $e7bC3.softwareProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dxCvy.projectContextResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            ...$e9207ae3efc3becd$var$getConditionalResources(),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $jsFU4.nextGenRoadmapResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingEnabled)(), (0, $9V5k0.projectThemeResource))
        ],
        preloadOptions: {
            earlyChunks: [
                'software-roadmap-early-entry'
            ]
        },
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        entryPoint: ()=>(0, $fAhgR.softwareTimelinePageEntrypoint),
        ufoName: 'next-gen-roadmap',
        supportsPreviewPanel: true
    }));

});
parcelRegister("3gei1", function(module, exports) {

$parcel$export(module.exports, "softwareTimelineRoute", () => $2ea9397ffa8c64ef$export$d25dafcda96d5af9);
const $2ea9397ffa8c64ef$export$d25dafcda96d5af9 = {
    name: 'software-timeline',
    path: '/jira/software/projects/:projectKey/boards/:boardId/timeline'
};

});

parcelRegister("fAhgR", function(module, exports) {

$parcel$export(module.exports, "softwareTimelinePageEntrypoint", () => $faefef5a329d510c$export$3315ee4fac32ee8);

var $lkFvK = parcelRequire("lkFvK");

var $fo6b8 = parcelRequire("fo6b8");

var $lmyls = parcelRequire("lmyls");

var $fT58V = parcelRequire("fT58V");

var $krpZe = parcelRequire("krpZe");

var $7lSbA = parcelRequire("7lSbA");
const $faefef5a329d510c$export$3315ee4fac32ee8 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7lSbA.softwareTimelineEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $fT58V.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $krpZe.nav4ProjectsContentEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("7lSbA", function(module, exports) {

$parcel$export(module.exports, "softwareTimelineEntrypoint", () => $db07900879e9590e$export$85a905c235ac34bb);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $db07900879e9590e$export$85a905c235ac34bb = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("3PSc0")), {
        moduleId: "7e6b0610",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});



parcelRegister("eKEYN", function(module, exports) {

$parcel$export(module.exports, "softwareVersionDetailEmbedRouteEntry", () => $f99c918791c41018$export$83102a6097008c79);

var $e4eHl = parcelRequire("e4eHl");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $kt0pG = parcelRequire("kt0pG");

var $4gudm = parcelRequire("4gudm");

var $bQc17 = parcelRequire("bQc17");

var $jchNA = parcelRequire("jchNA");
const $f99c918791c41018$export$83102a6097008c79 = (0, $7NszV.createEntry)((0, $4gudm.softwareVersionDetailEmbedRoute), ()=>({
        group: 'software',
        ufoName: 'software.version-details-page-embed',
        component: (0, $jchNA.VersionDetailPage),
        skeleton: (0, $bQc17.VersionDetailSkeleton),
        canTransitionIn: ()=>true,
        layout: (0, $aPfsS.createLayout)({
            isChromeless: true
        }),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $kt0pG.versionDetailsRelayResourceCustom),
            (0, $dxCvy.projectContextResource)
        ],
        forPaint: [
            (0, $jchNA.LazyVersionDetail)
        ],
        meta: {
            reporting: {
                id: 'software-version-detail-embed',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-version-detail-embed'),
                teamName: 'nova'
            }
        }
    }));

});
parcelRegister("kt0pG", function(module, exports) {

$parcel$export(module.exports, "versionDetailsRelayResourceCustom", () => $57dfad429d4f47cb$export$c56c5b19da4d0fd1);
/* eslint-disable jira/import-whitelist */ 
var $8Uumt = parcelRequire("8Uumt");

var $dXq4S = parcelRequire("dXq4S");

var $5yJb9 = parcelRequire("5yJb9");

var $kipqU = parcelRequire("kipqU");

var $ao2h1 = parcelRequire("ao2h1");

var $dvgjB = parcelRequire("dvgjB");

var $kfztd = parcelRequire("kfztd");

var $20fNh = parcelRequire("20fNh");

var $9NiTW = parcelRequire("9NiTW");

var $2M1hQ = parcelRequire("2M1hQ");

const $57dfad429d4f47cb$export$c56c5b19da4d0fd1 = (0, $2M1hQ.createResource)({
    type: `${(0, $ao2h1.RELAY_RESOURCE_TYPE)}_${(0, $afc34106ac722f11$export$9fe575a15a87a796)}`,
    // Deliberately returning the static key, not to rerun query by resource, as different key returns null queryReference shortly while the query is running, when filter query parameter is changed,
    // which is believed to be a bug in react-resource-router part, but we don't know the reason yet.
    // Context: https://atlassian.slack.com/archives/CFLN3FEF8/p1680495188086669
    // Due to the same bug, issue navigator team is doing the similar technique: src/packages/routes/src/ui/spa/issue-navigator/resources/index.tsx
    getKey: ({ match: match })=>{
        const { versionId: versionId } = match.params;
        const parsedVersionId = String(versionId ?? '').replace(/\D/g, '');
        return `jsw-releases-version-details-main-query-relay-${parsedVersionId}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { versionId: versionId } = match.params;
        const { filters: filters, sortBy: sortBy } = (0, $20fNh.toVersionIssuesGraphQLVariables)(query);
        const parsedVersionId = String(versionId ?? '').replace(/\D/g, '');
        const variables = {
            cloudAri: (0, $dXq4S.createAri)({
                resourceOwner: 'jira',
                resourceType: 'site',
                resourceId: tenantContext.cloudId
            }),
            versionAri: (0, $dXq4S.createAri)({
                resourceOwner: 'jira',
                cloudId: tenantContext.cloudId,
                resourceType: 'version/activation',
                resourceId: String(`${tenantContext.activationId}/${parsedVersionId}`)
            }),
            sortBy: sortBy,
            filters: filters,
            skip: !(0, $9NiTW.checkAuthentication)(tenantContext) || parsedVersionId.length === 0,
            isDevopsFeatureDisabledInFedRamp: (0, $kfztd.isDevopsFeatureDisabledInFedRamp)(),
            shouldIncludeDevOpsFieldsViaAgs: !(0, $kfztd.isDevopsFeatureDisabledInFedRamp)()
        };
        const queryReference = (0, $8Uumt.loadQuery)((0, $5yJb9.default)(), (0, $dvgjB.default), variables, {
            fetchPolicy: 'store-or-network'
        });
        if (false && queryReference.id != null) await (0, $kipqU.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});

});
parcelRegister("dvgjB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ecc7304dc73fa0e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bf23a345422fae2de0fc195dfee8d350>>
 * @relayHash 3c2963a896f9ac591f5fb2936c1ded83
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 351c38d4204be4347504920dc67489a9b231b37872183d43398f22a7a61e6236
const $8ecc7304dc73fa0e$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "351c38d4204be4347504920dc67489a9b231b37872183d43398f22a7a61e6236",
        "metadata": {},
        "name": "uiVersionDetailsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $8ecc7304dc73fa0e$export$2e2bcd8739ae039 = $8ecc7304dc73fa0e$var$node;

});

parcelRegister("20fNh", function(module, exports) {

$parcel$export(module.exports, "toVersionIssuesGraphQLVariables", () => $3e331943907e0f7c$export$72df1c7780b3e8e2);
$parcel$export(module.exports, "useVersionIssuesGraphQLVariables", () => $3e331943907e0f7c$export$3d12d3ffbce57135);

var $3hGWp = parcelRequire("3hGWp");


var $jPgXx = parcelRequire("jPgXx");

var $3dG8c = parcelRequire("3dG8c");
const $3e331943907e0f7c$var$accountIdToAriStr = (accountIds)=>{
    if (accountIds == null) return null;
    return accountIds.map((accountId)=>accountId === 'UNASSIGNED' ? null : `ari:cloud:identity::user/${accountId}`);
};
const $3e331943907e0f7c$export$72df1c7780b3e8e2 = (queryParams)=>{
    const parsedQueryParams = (0, $3dG8c.parseQueryParams)(queryParams);
    return {
        filters: {
            searchStr: parsedQueryParams[0, $5d187be87424268f$export$e39925d10cebc0b] ?? null,
            epicIds: parsedQueryParams[0, $5d187be87424268f$export$b98a7875ddbefaac] ?? null,
            statusCategories: parsedQueryParams[0, $5d187be87424268f$export$c307007520232013] != null ? parsedQueryParams[0, $5d187be87424268f$export$c307007520232013].filter((0, $jPgXx.isVersionStatusCategory)) : null,
            warningCategories: parsedQueryParams[0, $5d187be87424268f$export$2552faed9df6a2cd] ?? null,
            assigneeAccountIds: $3e331943907e0f7c$var$accountIdToAriStr(parsedQueryParams[0, $5d187be87424268f$export$f78d8c81fcad32a2])
        },
        sortBy: {
            sortByField: parsedQueryParams[0, $5d187be87424268f$export$13d5b2891ca65cd6] ?? 'CREATED',
            order: parsedQueryParams[0, $5d187be87424268f$export$810a1f7ed2facfcb] ?? 'ASC'
        }
    };
};
const $3e331943907e0f7c$export$3d12d3ffbce57135 = ()=>{
    const [queryParams] = (0, $3hGWp.useQueryParams)((0, $5d187be87424268f$export$e39925d10cebc0b), (0, $5d187be87424268f$export$b98a7875ddbefaac), (0, $5d187be87424268f$export$c307007520232013), (0, $5d187be87424268f$export$2552faed9df6a2cd), (0, $5d187be87424268f$export$f78d8c81fcad32a2), (0, $5d187be87424268f$export$13d5b2891ca65cd6), (0, $5d187be87424268f$export$810a1f7ed2facfcb));
    return $3e331943907e0f7c$export$72df1c7780b3e8e2(queryParams);
};

});
parcelRegister("3hGWp", function(module, exports) {

$parcel$export(module.exports, "useQueryParams", () => $afd0e0a12e1f2496$export$b37ee0d76c6d2fbc);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $hGgHi = parcelRequire("hGgHi");

var $9xWGk = parcelRequire("9xWGk");

var $ebyGx = parcelRequire("ebyGx");

var $4R6GH = parcelRequire("4R6GH");

var $cutA3 = parcelRequire("cutA3");

var $doZTA = parcelRequire("doZTA");
const $afd0e0a12e1f2496$export$b37ee0d76c6d2fbc = (...unstableQueryParamsToWatch)=>{
    const [{ location: { pathname: pathname }, query: query }, { push: push, replace: replace }] = (0, $doZTA.useRouter)();
    const queryParamsRef = (0, $5uXOq.useRef)({});
    // ensure queryParamsToWatch is not a new array on every invocation
    const queryParamsToWatch = (0, $cutA3.useShallowStableReference)(unstableQueryParamsToWatch, (0, $4R6GH.fg)('jfp_magma_issue-stability-phase1'));
    const parsedQueryParams = (0, $5uXOq.useMemo)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newQueryParams = queryParamsToWatch.reduce((accumulator, currentValue)=>{
            accumulator[currentValue] = query[currentValue] || undefined;
            return accumulator;
        }, {});
        // update cache only when one of requested params actually changed
        // otherwise return cached value to avoid changing return object reference
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(queryParamsRef.current, newQueryParams)) queryParamsRef.current = newQueryParams;
        return queryParamsRef.current;
    }, [
        query,
        queryParamsToWatch
    ]);
    const setQueryParams = (0, $5uXOq.useCallback)((newQueryParams, options)=>{
        const parsedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($9xWGk)))({
            ...query,
            ...newQueryParams
        }, (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value));
        const { updateType: updateType, ...stringifyOptions } = options ?? {};
        // @ts-expect-error - TS2559 - Type '{ sort?: false | ((a: string, b: string) => number) | undefined; }' has no properties in common with type 'StringifyOptions'.
        const strSearch = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(parsedSearch, stringifyOptions);
        const url = pathname + (strSearch !== '' ? `?${strSearch}` : '');
        updateType === 'replace' ? replace(url) : push(url);
    }, [
        pathname,
        push,
        replace,
        query
    ]);
    return [
        parsedQueryParams,
        setQueryParams
    ];
};

});

const $5d187be87424268f$export$e39925d10cebc0b = 'text';
const $5d187be87424268f$export$b98a7875ddbefaac = 'epics';
const $5d187be87424268f$export$c307007520232013 = 'statusCategory';
const $5d187be87424268f$export$2552faed9df6a2cd = 'warnings';
const $5d187be87424268f$export$f78d8c81fcad32a2 = 'assignee';
const $5d187be87424268f$export$13d5b2891ca65cd6 = 'sortBy';
const $5d187be87424268f$export$810a1f7ed2facfcb = 'sortOrder';

parcelRegister("jPgXx", function(module, exports) {

$parcel$export(module.exports, "isWarningsFilterValue", () => $1bd9df170beee33d$export$5c25bcf27380084);
$parcel$export(module.exports, "toWarningsFilterValue", () => $1bd9df170beee33d$export$ac3017cd78edb8a1);
$parcel$export(module.exports, "isVersionStatusCategory", () => $1bd9df170beee33d$export$3af93bbba0d4241a);
$parcel$export(module.exports, "isSortBy", () => $1bd9df170beee33d$export$472650e4cbd40b70);
$parcel$export(module.exports, "isSortOrder", () => $1bd9df170beee33d$export$dfece8cb679d32a3);

var $gULOk = parcelRequire("gULOk");
const $1bd9df170beee33d$export$5c25bcf27380084 = (val)=>val === 'OPEN_PULL_REQUEST' || val === 'UNREVIEWED_CODE' || val === 'FAILING_BUILD' || val === 'OPEN_REVIEW';
const $1bd9df170beee33d$export$ac3017cd78edb8a1 = (statusCategoryFromQueryParam)=>statusCategoryFromQueryParam.filter($1bd9df170beee33d$export$5c25bcf27380084);
const $1bd9df170beee33d$export$3af93bbba0d4241a = (val)=>val === (0, $gULOk.TODO) || val === (0, $gULOk.IN_PROGRESS) || val === (0, $gULOk.DONE);
const $1bd9df170beee33d$export$472650e4cbd40b70 = (val)=>val === 'ASSIGNEE' || val === 'CREATED' || val === 'KEY' || val === 'PRIORITY' || val === 'STATUS' || val === 'TYPE';
const $1bd9df170beee33d$export$dfece8cb679d32a3 = (val)=>val === 'ASC' || val === 'DESC';

});
parcelRegister("gULOk", function(module, exports) {

$parcel$export(module.exports, "UNDEFINED", () => $e77315bf13f8b83b$export$6db089fe7b26f5b6);
$parcel$export(module.exports, "TODO", () => $e77315bf13f8b83b$export$aa456a5030160740);
$parcel$export(module.exports, "IN_PROGRESS", () => $e77315bf13f8b83b$export$5a9ac66c2785cc13);
$parcel$export(module.exports, "DONE", () => $e77315bf13f8b83b$export$71efb3495f6084f2);
$parcel$export(module.exports, "STATUS_CATEGORIES", () => $e77315bf13f8b83b$export$d9119300f9d9a815);
$parcel$export(module.exports, "StatusCategoryTypes", () => $e77315bf13f8b83b$export$5d42a08d46cffe7);
$parcel$export(module.exports, "StatusCategoryIds", () => $e77315bf13f8b83b$export$3f42f49c284d5b58);
$parcel$export(module.exports, "statusCategoryKeys", () => $e77315bf13f8b83b$export$f3f919dc0f56d9eb);
$parcel$export(module.exports, "statusCategoryForId", () => $e77315bf13f8b83b$export$3e9e3002956ff4fb);
$parcel$export(module.exports, "categoryIdForStatusCategory", () => $e77315bf13f8b83b$export$7b16b0022aac2d46);
$parcel$export(module.exports, "isValidStatusCategoryKey", () => $e77315bf13f8b83b$export$d928f247c903643a);
const $e77315bf13f8b83b$export$6db089fe7b26f5b6 = 'UNDEFINED';
const $e77315bf13f8b83b$export$aa456a5030160740 = 'TODO';
const $e77315bf13f8b83b$export$5a9ac66c2785cc13 = 'IN_PROGRESS';
const $e77315bf13f8b83b$export$71efb3495f6084f2 = 'DONE';
const $e77315bf13f8b83b$export$d9119300f9d9a815 = [
    $e77315bf13f8b83b$export$6db089fe7b26f5b6,
    $e77315bf13f8b83b$export$aa456a5030160740,
    $e77315bf13f8b83b$export$5a9ac66c2785cc13,
    $e77315bf13f8b83b$export$71efb3495f6084f2
];
const $e77315bf13f8b83b$var$statusCategories = [
    {
        id: '1',
        statusCategory: $e77315bf13f8b83b$export$6db089fe7b26f5b6
    },
    {
        id: '2',
        statusCategory: $e77315bf13f8b83b$export$aa456a5030160740
    },
    {
        id: '4',
        statusCategory: $e77315bf13f8b83b$export$5a9ac66c2785cc13
    },
    {
        id: '3',
        statusCategory: $e77315bf13f8b83b$export$71efb3495f6084f2
    }
];
const $e77315bf13f8b83b$export$5d42a08d46cffe7 = Object.freeze({
    NEW: 'new',
    INDETERMINATE: 'indeterminate',
    DONE: 'done',
    UNDEFINED: 'undefined'
});
const $e77315bf13f8b83b$export$3f42f49c284d5b58 = Object.freeze({
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.UNDEFINED]: 1,
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.NEW]: 2,
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.DONE]: 3,
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.INDETERMINATE]: 4
});
const $e77315bf13f8b83b$export$f3f919dc0f56d9eb = Object.values($e77315bf13f8b83b$export$5d42a08d46cffe7);
const $e77315bf13f8b83b$export$3e9e3002956ff4fb = (statusCategoryId)=>{
    const value = $e77315bf13f8b83b$var$statusCategories.find((sc)=>sc.id === String(statusCategoryId));
    return value ? value.statusCategory : $e77315bf13f8b83b$export$6db089fe7b26f5b6;
};
const $e77315bf13f8b83b$export$7b16b0022aac2d46 = (statusCategory)=>{
    const value = $e77315bf13f8b83b$var$statusCategories.find((sc)=>sc.statusCategory === statusCategory);
    return Number(value ? value.id : '1');
};
const $e77315bf13f8b83b$export$d928f247c903643a = (key)=>$e77315bf13f8b83b$export$f3f919dc0f56d9eb.some((statusCategoryKey)=>statusCategoryKey === key);

});


parcelRegister("3dG8c", function(module, exports) {

$parcel$export(module.exports, "isAnyFilterApplied", () => $89761db99e7e0304$export$e6b3ec1d09429da8);
$parcel$export(module.exports, "parseQueryParams", () => $89761db99e7e0304$export$67c4cee80a3410cd);

var $g5X3G = parcelRequire("g5X3G");


var $jPgXx = parcelRequire("jPgXx");
const $89761db99e7e0304$export$e6b3ec1d09429da8 = (parsedQueryParams)=>parsedQueryParams[0, $5d187be87424268f$export$e39925d10cebc0b] != null && parsedQueryParams[0, $5d187be87424268f$export$e39925d10cebc0b].length > 0 || parsedQueryParams[0, $5d187be87424268f$export$b98a7875ddbefaac] != null && parsedQueryParams[0, $5d187be87424268f$export$b98a7875ddbefaac].length > 0 || parsedQueryParams[0, $5d187be87424268f$export$c307007520232013] != null && parsedQueryParams[0, $5d187be87424268f$export$c307007520232013].length > 0 || parsedQueryParams[0, $5d187be87424268f$export$2552faed9df6a2cd] != null && parsedQueryParams[0, $5d187be87424268f$export$2552faed9df6a2cd].length > 0 || parsedQueryParams[0, $5d187be87424268f$export$f78d8c81fcad32a2] != null && parsedQueryParams[0, $5d187be87424268f$export$f78d8c81fcad32a2].length > 0;
const $89761db99e7e0304$export$2a2e94972ab280d4 = (paramValue)=>paramValue == null ? undefined : paramValue.split(',').map((str)=>str.trim()).map((0, $g5X3G.toIssueId));
const $89761db99e7e0304$export$fb136b568c6d78b5 = (paramValue)=>paramValue == null ? undefined : paramValue.split(',').map((str)=>str.trim()).filter((0, $jPgXx.isVersionStatusCategory));
const $89761db99e7e0304$export$5cb324c621ca24e8 = (paramValue)=>paramValue == null ? undefined : (0, $jPgXx.toWarningsFilterValue)(paramValue.split(',').map((str)=>str.trim()));
const $89761db99e7e0304$export$6c8eda0352c7cf5 = (paramValue)=>paramValue == null ? undefined : paramValue.split(',').map((str)=>(0, $g5X3G.toAccountId)(str.trim()));
const $89761db99e7e0304$export$67c4cee80a3410cd = (paramsRaw)=>{
    const result = {};
    result[0, $5d187be87424268f$export$e39925d10cebc0b] = paramsRaw[0, $5d187be87424268f$export$e39925d10cebc0b];
    result[0, $5d187be87424268f$export$b98a7875ddbefaac] = $89761db99e7e0304$export$2a2e94972ab280d4(paramsRaw[0, $5d187be87424268f$export$b98a7875ddbefaac]);
    result[0, $5d187be87424268f$export$c307007520232013] = $89761db99e7e0304$export$fb136b568c6d78b5(paramsRaw[0, $5d187be87424268f$export$c307007520232013]);
    result[0, $5d187be87424268f$export$2552faed9df6a2cd] = $89761db99e7e0304$export$5cb324c621ca24e8(paramsRaw[0, $5d187be87424268f$export$2552faed9df6a2cd]);
    result[0, $5d187be87424268f$export$f78d8c81fcad32a2] = $89761db99e7e0304$export$6c8eda0352c7cf5(paramsRaw[0, $5d187be87424268f$export$f78d8c81fcad32a2]);
    result[0, $5d187be87424268f$export$13d5b2891ca65cd6] = paramsRaw[0, $5d187be87424268f$export$13d5b2891ca65cd6] && (0, $jPgXx.isSortBy)(paramsRaw[0, $5d187be87424268f$export$13d5b2891ca65cd6]) ? paramsRaw[0, $5d187be87424268f$export$13d5b2891ca65cd6] : 'CREATED';
    result[0, $5d187be87424268f$export$810a1f7ed2facfcb] = paramsRaw[0, $5d187be87424268f$export$810a1f7ed2facfcb] && (0, $jPgXx.isSortOrder)(paramsRaw[0, $5d187be87424268f$export$810a1f7ed2facfcb]) ? paramsRaw[0, $5d187be87424268f$export$810a1f7ed2facfcb] : 'ASC';
    return result;
};

});


const $afc34106ac722f11$export$9fe575a15a87a796 = 'PROJECTS_VERSION_DETAILS';


parcelRegister("4gudm", function(module, exports) {

$parcel$export(module.exports, "softwareVersionDetailEmbedRoute", () => $901ac67e36c3672e$export$78d11017d9c9ed74);
const $901ac67e36c3672e$export$78d11017d9c9ed74 = {
    name: 'software-version-detail-embed',
    path: '/projects/:projectKey/versions/:versionId/tab/:tab/embed',
    exact: true
};

});

parcelRegister("bQc17", function(module, exports) {

$parcel$export(module.exports, "VersionDetailSkeleton", () => $d1c9f0513946a9ed$export$b3661a594ba34350);

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $bFJAH = parcelRequire("bFJAH");
const $d1c9f0513946a9ed$export$b3661a594ba34350 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bFJAH)))
    });

});
parcelRegister("bFJAH", function(module, exports) {
module.exports = new URL("version-detail-skeleton.tpl.c4c4fc18.svg", import.meta.url).toString();

});


parcelRegister("jchNA", function(module, exports) {

$parcel$export(module.exports, "LazyVersionDetail", () => $5cbf8f752618c8e3$export$2d31f5f47e6584e0);
$parcel$export(module.exports, "VersionDetailPage", () => $5cbf8f752618c8e3$export$231cc5186b991031);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $5cbf8f752618c8e3$export$2d31f5f47e6584e0 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("enUYc"))), {
    moduleId: "./src/packages/spa-apps/version-detail/src/index.tsx"
});
const $5cbf8f752618c8e3$export$231cc5186b991031 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $5cbf8f752618c8e3$export$2d31f5f47e6584e0,
        pageId: "version-detail",
        shouldShowSpinner: false
    });

});
parcelRegister("enUYc", function(module, exports) {

let $a78f67bbab7b7150$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $a78f67bbab7b7150$var$load("ffQaD"),
    $a78f67bbab7b7150$var$load("kvRbA"),
    $a78f67bbab7b7150$var$load("gN4dl")
]).then(()=>parcelRequire('2WNCY'));

});



parcelRegister("fwjnc", function(module, exports) {

$parcel$export(module.exports, "softwareVersionDetailLegacyRedirectRouteEntry", () => $d779d838fb39524b$export$f29aafdff734071c);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $1ZoQ4 = parcelRequire("1ZoQ4");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $jchNA = parcelRequire("jchNA");

var $3eNdg = parcelRequire("3eNdg");
const $d779d838fb39524b$export$f29aafdff734071c = (0, $7NszV.createEntry)((0, $1ZoQ4.softwareVersionDetailLegacyRedirectRoute), ()=>({
        group: 'software',
        component: (0, $3eNdg.VersionDetailPageLegacyRedirect),
        canTransitionIn: ()=>true,
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: [
                (0, $koWFd.default),
                (0, $9s3j1.default)
            ],
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jchNA.LazyVersionDetail)
        ]
    }));

});
parcelRegister("1ZoQ4", function(module, exports) {

$parcel$export(module.exports, "softwareVersionDetailLegacyRedirectRoute", () => $29228b2ecd57a3f4$export$3fc8dbcec208bca0);
const $29228b2ecd57a3f4$export$3fc8dbcec208bca0 = {
    name: 'software-version-detail-legacy-redirect',
    path: '/browse/:projectKey/fixforversion/:versionId'
};

});

parcelRegister("3eNdg", function(module, exports) {

$parcel$export(module.exports, "VersionDetailPageLegacyRedirect", () => $b28890d7be7b5f20$export$8524eef1a0d9339);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
const $b28890d7be7b5f20$export$8524eef1a0d9339 = ({ match: { params: { projectKey: projectKey, versionId: versionId, tab: tab } } })=>{
    // This should never happen as if it wasn't matched, this won't be rendered unless someone re-used this component in a wrong route.
    if (projectKey == null || versionId == null) throw Error('projectKey or versionId not found in match object of RouteContext');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/projects/${projectKey}/versions/${versionId}/tab/${tab != null ? tab : 'release-report-all-issues'}`
    });
};

});


parcelRegister("1KC4N", function(module, exports) {

$parcel$export(module.exports, "softwareVersionDetailNoTabPathRedirectRouteEntry", () => $91cff4b09df91d45$export$28d16aae32969765);

var $ffza4 = parcelRequire("ffza4");

var $5f2bR = parcelRequire("5f2bR");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $aLgIl = parcelRequire("aLgIl");

var $e7bC3 = parcelRequire("e7bC3");

var $jchNA = parcelRequire("jchNA");

var $3eNdg = parcelRequire("3eNdg");
const $91cff4b09df91d45$export$28d16aae32969765 = (0, $7NszV.createEntry)((0, $aLgIl.softwareVersionDetailNoTabPathRedirectRoute), ()=>({
        group: 'software',
        component: (0, $3eNdg.VersionDetailPageLegacyRedirect),
        canTransitionIn: ()=>true,
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: [
                (0, $koWFd.default),
                (0, $9s3j1.default)
            ],
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jchNA.LazyVersionDetail)
        ]
    }));

});
parcelRegister("aLgIl", function(module, exports) {

$parcel$export(module.exports, "softwareVersionDetailNoTabPathRedirectRoute", () => $bfff597194375de5$export$f22288f2d2f1b9ea);
const $bfff597194375de5$export$f22288f2d2f1b9ea = {
    name: 'software-version-detail-no-tab-path',
    path: '/projects/:projectKey/versions/:versionId'
};

});


parcelRegister("7ApVe", function(module, exports) {

$parcel$export(module.exports, "softwareVersionDetailRouteEntry", () => $0034963e375ba907$export$c97dabcfe9d495fa);

var $e4eHl = parcelRequire("e4eHl");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $kt0pG = parcelRequire("kt0pG");

var $12flw = parcelRequire("12flw");

var $bQc17 = parcelRequire("bQc17");

var $e7bC3 = parcelRequire("e7bC3");

var $jchNA = parcelRequire("jchNA");
const $0034963e375ba907$export$c97dabcfe9d495fa = (0, $7NszV.createEntry)((0, $12flw.softwareVersionDetailRoute), ()=>({
        group: 'software',
        ufoName: 'software.version-details-page',
        component: (0, $jchNA.VersionDetailPage),
        skeleton: (0, $bQc17.VersionDetailSkeleton),
        canTransitionIn: ()=>true,
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: [
                (0, $koWFd.default),
                (0, $9s3j1.default)
            ]
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $kt0pG.versionDetailsRelayResourceCustom),
            (0, $dxCvy.projectContextResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jchNA.LazyVersionDetail)
        ],
        meta: {
            reporting: {
                id: 'software-version-detail',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-version-detail'),
                teamName: 'nova'
            }
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("12flw", function(module, exports) {

$parcel$export(module.exports, "softwareVersionDetailRoute", () => $da1ceb4f01a49a44$export$eb3633614d0521b0);
const $da1ceb4f01a49a44$export$eb3633614d0521b0 = {
    name: 'software-version-detail',
    path: '/projects/:projectKey/versions/:versionId/tab/:tab'
};

});


parcelRegister("41tjC", function(module, exports) {

$parcel$export(module.exports, "softwareViewNotFoundClassicRouteEntry", () => $96e70f692796dc17$export$191700cbad42b1f0);

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $lkW1m = parcelRequire("lkW1m");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $1g8oF = parcelRequire("1g8oF");
const $96e70f692796dc17$export$191700cbad42b1f0 = (0, $7NszV.createEntry)((0, $lkW1m.softwareViewNotFoundClassicRoute), ()=>({
        group: 'software',
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $1g8oF.projectViewNotFoundPageEntrypoint)
    }));

});
parcelRegister("lkW1m", function(module, exports) {

$parcel$export(module.exports, "softwareViewNotFoundClassicRoute", () => $6d8d781058e4749c$export$7d9d54603ab2405d);
const $6d8d781058e4749c$export$7d9d54603ab2405d = {
    name: 'software-view-not-found-classic',
    exact: true,
    path: '/jira/software/c/projects/:projectKey/not-found'
};

});


parcelRegister("3I1TD", function(module, exports) {

$parcel$export(module.exports, "softwareViewNotFoundRouteEntry", () => $4bb0af0452a6f272$export$7dab5fe9ccb76142);

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $l0Xu9 = parcelRequire("l0Xu9");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $1g8oF = parcelRequire("1g8oF");
const $4bb0af0452a6f272$export$7dab5fe9ccb76142 = (0, $7NszV.createEntry)((0, $l0Xu9.softwareViewNotFoundRoute), ()=>({
        group: 'software',
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $1g8oF.projectViewNotFoundPageEntrypoint)
    }));

});
parcelRegister("l0Xu9", function(module, exports) {

$parcel$export(module.exports, "softwareViewNotFoundRoute", () => $649408f22dcc013c$export$d72ea457f192511a);
const $649408f22dcc013c$export$d72ea457f192511a = {
    name: 'software-view-not-found',
    exact: true,
    path: '/jira/software/projects/:projectKey/not-found'
};

});


parcelRegister("h0ilo", function(module, exports) {

$parcel$export(module.exports, "systemConfigurationRedirectRouteEntry", () => $8e2136bf66ce50f4$export$7c2e1ea4fc4a192f);

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $dmx0y = parcelRequire("dmx0y");

var $4TSoB = parcelRequire("4TSoB");

var $j2LKP = parcelRequire("j2LKP");
const $8e2136bf66ce50f4$export$7c2e1ea4fc4a192f = (0, $7NszV.createEntry)((0, $4TSoB.systemConfigurationRedirectRoute), ()=>({
        group: 'global-settings',
        component: (0, $j2LKP.default),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $dmx0y.systemConfigurationGeneralResource)
        ]
    }));

});
parcelRegister("4TSoB", function(module, exports) {

$parcel$export(module.exports, "systemConfigurationRedirectRoute", () => $3fbd0d392c74d663$export$fe4807c49c838619);
const $3fbd0d392c74d663$export$fe4807c49c838619 = {
    name: 'system-configuration-general-redirect',
    path: '/secure/admin/ViewApplicationProperties.jspa',
    exact: true
};

});

parcelRegister("j2LKP", function(module, exports) {

$parcel$export(module.exports, "default", () => $71a705d1d999c26b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ds5qV = parcelRequire("ds5qV");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$71a705d1d999c26b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: "/jira/settings/system/general-configuration"
    });

});


parcelRegister("k1TyW", function(module, exports) {

$parcel$export(module.exports, "systemConfigurationRouteEntry", () => $1805c641c87a2931$export$360a82088f35f2f);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $dmx0y = parcelRequire("dmx0y");

var $99CoR = parcelRequire("99CoR");

var $5pSYQ = parcelRequire("5pSYQ");

var $k7R2k = parcelRequire("k7R2k");
const $1805c641c87a2931$export$360a82088f35f2f = (0, $7NszV.createEntry)((0, $99CoR.systemConfigurationRoute), ()=>({
        group: 'global-settings',
        component: (0, $k7R2k.default),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $dmx0y.systemConfigurationGeneralResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $k7R2k.LazySystemConfigurationGeneral)
        ]
    }));

});
parcelRegister("99CoR", function(module, exports) {

$parcel$export(module.exports, "systemConfigurationRoute", () => $6c77a2c05982af00$export$6823cb5626e61bc7);
const $6c77a2c05982af00$export$6823cb5626e61bc7 = {
    name: 'system-configuration-general',
    path: '/jira/settings/system/general-configuration',
    exact: true
};

});

parcelRegister("k7R2k", function(module, exports) {

$parcel$export(module.exports, "LazySystemConfigurationGeneral", () => $ece5afb522908971$export$c452a8c622781ccd);
$parcel$export(module.exports, "default", () => $ece5afb522908971$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $ece5afb522908971$export$c452a8c622781ccd = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("8IOnj"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/system-configuration-general/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ece5afb522908971$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ece5afb522908971$export$c452a8c622781ccd,
        pageId: "system-configuration-general",
        shouldShowSpinner: false
    });

});
parcelRegister("8IOnj", function(module, exports) {

let $6599823703e8bc99$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6599823703e8bc99$var$load("9dEqa").then(()=>parcelRequire('7S4i0'));

});



parcelRegister("3av4N", function(module, exports) {

$parcel$export(module.exports, "systemDashboardEditRouteEntry", () => $29daafdf917937bc$export$15f76f1b0d2d671);

var $ffza4 = parcelRequire("ffza4");

var $j6woB = parcelRequire("j6woB");

var $e2ctp = parcelRequire("e2ctp");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $gh1hi = parcelRequire("gh1hi");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $3Zw20 = parcelRequire("3Zw20");

var $ernoj = parcelRequire("ernoj");
const $29daafdf917937bc$export$15f76f1b0d2d671 = (0, $7NszV.createEntry)((0, $3Zw20.systemDashboardEditRoute), ()=>({
        group: 'dashboard',
        component: (0, $ernoj.SystemDashboardEditPage),
        layout: (0, $aPfsS.composeLayouts)((0, $ibkIl.globalSettingsLayout), (0, $j6woB.dashboardBackgroundScriptsLayout)),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            // IMPORTANT - SSR requires wrm resource must come first
            ...(0, $ernoj.dashboardResources)(),
            (0, $gh1hi.gadgetDirectoryResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ernoj.LazySystemDashboardEdit)
        ],
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("3Zw20", function(module, exports) {

$parcel$export(module.exports, "systemDashboardEditRoute", () => $81fa712f0fcff9b5$export$7367fb465296c7dd);
const $81fa712f0fcff9b5$export$7367fb465296c7dd = {
    name: 'system-dashboard-edit',
    path: '/secure/admin/EditDefaultDashboard(!default)?.jspa',
    query: [
        'maximized?'
    ]
};

});


parcelRegister("4BuRo", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationCreateRouteEntry", () => $46e74e6464e445dd$export$83aea99d18750f08);

var $g9g6m = parcelRequire("g9g6m");

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $lxIQB = parcelRequire("lxIQB");

var $jNNfq = parcelRequire("jNNfq");

var $2PI2S = parcelRequire("2PI2S");

var $kEMby = parcelRequire("kEMby");
const $46e74e6464e445dd$export$83aea99d18750f08 = (0, $7NszV.createEntry)((0, $lxIQB.teamIntegrationCreateRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/ops/teams',
        component: (0, $jNNfq.IntegrationAutomation),
        layout: (0, $h3Ix2.opsTeamLayout),
        slot: (0, $2PI2S.IntegrationCreate),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $2r8fH.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $g9g6m.resources).configuredIntegrationsResource,
            (0, $g9g6m.resources).integrationListResource,
            (0, $g9g6m.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("lxIQB", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationCreateRoute", () => $ae27079a91acfd42$export$a2ec7da6c43acbbf);
const $ae27079a91acfd42$export$a2ec7da6c43acbbf = {
    name: 'eoc-team-integration-create',
    path: '/jira/ops/teams/:teamId/integrations/create/:type',
    exact: true
};

});


parcelRegister("6SWMv", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationDetailRouteEntry", () => $cd5c132b5b5151e0$export$7e0b6b79953422c1);

var $g9g6m = parcelRequire("g9g6m");

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $8C1ee = parcelRequire("8C1ee");

var $jNNfq = parcelRequire("jNNfq");

var $7ifqF = parcelRequire("7ifqF");

var $kEMby = parcelRequire("kEMby");
const $cd5c132b5b5151e0$export$7e0b6b79953422c1 = (0, $7NszV.createEntry)((0, $8C1ee.teamIntegrationDetailRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/ops/teams',
        component: (0, $jNNfq.IntegrationAutomation),
        layout: (0, $h3Ix2.opsTeamLayout),
        slot: (0, $7ifqF.IntegrationDetail),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $2r8fH.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $g9g6m.resources).configuredIntegrationsResource,
            (0, $g9g6m.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("8C1ee", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationDetailRoute", () => $de1d1f48c94d5c8d$export$72169399df792b7c);
const $de1d1f48c94d5c8d$export$72169399df792b7c = {
    name: 'eoc-team-integration-detail',
    path: '/jira/ops/teams/:teamId/integrations/:type/:integrationId',
    exact: true
};

});


parcelRegister("jFY66", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationListRouteEntry", () => $d817aeb7fccbfd68$export$52ee366e7b51f38d);

var $g9g6m = parcelRequire("g9g6m");

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $2EBRZ = parcelRequire("2EBRZ");

var $jNNfq = parcelRequire("jNNfq");

var $3cv8c = parcelRequire("3cv8c");

var $kEMby = parcelRequire("kEMby");
const $d817aeb7fccbfd68$export$52ee366e7b51f38d = (0, $7NszV.createEntry)((0, $2EBRZ.teamIntegrationListRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/ops/teams',
        component: (0, $jNNfq.IntegrationAutomation),
        layout: (0, $h3Ix2.opsTeamLayout),
        slot: (0, $3cv8c.IntegrationList),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $2r8fH.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $g9g6m.resources).integrationListResource,
            (0, $g9g6m.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("2EBRZ", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationListRoute", () => $8e217314970bb735$export$b8218f375778e6d7);
const $8e217314970bb735$export$b8218f375778e6d7 = {
    name: 'eoc-team-integration-list',
    path: '/jira/ops/teams/:teamId/integrations/list',
    exact: true
};

});


parcelRegister("jPXYO", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationLogRouteEntry", () => $77c62c16bb189e65$export$d5e169223d2a5d1d);

var $c4Buu = parcelRequire("c4Buu");

var $g9g6m = parcelRequire("g9g6m");

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $80ouD = parcelRequire("80ouD");

var $jNNfq = parcelRequire("jNNfq");

var $5pZel = parcelRequire("5pZel");

var $kEMby = parcelRequire("kEMby");
const $77c62c16bb189e65$export$d5e169223d2a5d1d = (0, $7NszV.createEntry)((0, $80ouD.teamIntegrationLogRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/ops/teams',
        component: (0, $jNNfq.IntegrationAutomation),
        slot: (0, $5pZel.IntegrationLog),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $2r8fH.resources)(),
            ...(0, $c4Buu.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $g9g6m.resources).configuredIntegrationsResource,
            (0, $g9g6m.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("80ouD", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationLogRoute", () => $d7b8bbfd81270213$export$ca02d7b2c7df3d60);
const $d7b8bbfd81270213$export$ca02d7b2c7df3d60 = {
    name: 'eoc-team-integration-log',
    path: '/jira/ops/teams/:teamId/integrations/:type/:integrationId/logs',
    exact: true
};

});


parcelRegister("ktYro", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationsRouteEntry", () => $97fc56f25f58996b$export$ded9494f81dd2a4d);

var $g9g6m = parcelRequire("g9g6m");

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $1ZFOA = parcelRequire("1ZFOA");

var $jNNfq = parcelRequire("jNNfq");

var $kEMby = parcelRequire("kEMby");
const $97fc56f25f58996b$export$ded9494f81dd2a4d = (0, $7NszV.createEntry)((0, $1ZFOA.teamIntegrationsRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/ops/teams',
        component: (0, $jNNfq.IntegrationAutomation),
        layout: (0, $h3Ix2.opsTeamLayout),
        slot: null,
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $2r8fH.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $g9g6m.resources).configuredIntegrationsResource,
            (0, $g9g6m.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("1ZFOA", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationsRoute", () => $78efd1de67032a37$export$400ead354c81dee3);
const $78efd1de67032a37$export$400ead354c81dee3 = {
    name: 'eoc-team-integrations',
    path: '/jira/ops/teams/:teamId/integrations',
    exact: true
};

});


parcelRegister("7UDCM", function(module, exports) {

$parcel$export(module.exports, "trashedPlanDirectLinkRouteEntry", () => $5f2b7d10b2a973db$export$dbcd0bd16f12397d);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $3V9Zd = parcelRequire("3V9Zd");

var $7Knxu = parcelRequire("7Knxu");
const $5f2b7d10b2a973db$export$dbcd0bd16f12397d = (0, $7NszV.createEntry)((0, $3V9Zd.trashedPlanDirectLinkRoute), ()=>({
        group: 'software',
        component: (0, $7Knxu.TrashedPlanDirectLink),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7Knxu.LazyTrashedPlanDirectLink)
        ],
        ufoName: 'plan-trashed'
    }));

});
parcelRegister("3V9Zd", function(module, exports) {

$parcel$export(module.exports, "trashedPlanDirectLinkRoute", () => $378d003abbed757a$export$1a9edb72cd49ca79);
const $378d003abbed757a$export$1a9edb72cd49ca79 = {
    name: 'trashed-plan-direct-link',
    path: '/jira/plans/plan-trashed',
    exact: true
};

});

parcelRegister("7Knxu", function(module, exports) {

$parcel$export(module.exports, "LazyTrashedPlanDirectLink", () => $1e04fb6816f8b0a0$export$20a71ac28e6a3c8f);
$parcel$export(module.exports, "TrashedPlanDirectLink", () => $1e04fb6816f8b0a0$export$38f3a061bb1fceee);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $1e04fb6816f8b0a0$export$20a71ac28e6a3c8f = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hAIat"))), {
    moduleId: "./src/packages/portfolio-3/plan-trashed-direct-link/src/index.tsx"
});
const $1e04fb6816f8b0a0$export$38f3a061bb1fceee = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $1e04fb6816f8b0a0$export$20a71ac28e6a3c8f,
        pageId: "trashed-plan-direct-link",
        shouldShowSpinner: false
    });

});
parcelRegister("hAIat", function(module, exports) {

let $cce80f468b7d02e6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cce80f468b7d02e6$var$load("51g3z").then(()=>parcelRequire('kIqMQ'));

});



parcelRegister("hDCtq", function(module, exports) {

$parcel$export(module.exports, "trashPlansRouteEntry", () => $2d67b465f26d4e76$export$eabcbe4dd6fc9f1f);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $711SD = parcelRequire("711SD");

var $cm0sO = parcelRequire("cm0sO");
const $2d67b465f26d4e76$export$eabcbe4dd6fc9f1f = (0, $7NszV.createEntry)((0, $711SD.trashPlansRoute), ()=>({
        group: 'software',
        component: (0, $cm0sO.TrashedPlansDirectory),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cm0sO.LazyTrashedPlans)
        ]
    }));

});
parcelRegister("711SD", function(module, exports) {

$parcel$export(module.exports, "trashPlansRoute", () => $83fe99f2cd6e2d28$export$6f5b50c5dc090fd1);
const $83fe99f2cd6e2d28$export$6f5b50c5dc090fd1 = {
    name: 'trash-plans-directory',
    path: '/jira/plans/settings/trash',
    exact: true
};

});

parcelRegister("cm0sO", function(module, exports) {

$parcel$export(module.exports, "LazyTrashedPlans", () => $87393f1bbf5aac77$export$6ac18b311b7e51a1);
$parcel$export(module.exports, "TrashedPlansDirectory", () => $87393f1bbf5aac77$export$b145fa65818ff157);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $87393f1bbf5aac77$export$6ac18b311b7e51a1 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("kw1bf")).then((module)=>module.TrashedPlans)), {
    moduleId: "./src/packages/spa-apps/admin-pages/trashed-plans/src/index.tsx"
});
const $87393f1bbf5aac77$export$b145fa65818ff157 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $87393f1bbf5aac77$export$6ac18b311b7e51a1,
        pageId: "trashed-plans",
        shouldShowSpinner: true
    });

});
parcelRegister("kw1bf", function(module, exports) {

let $eef7b6332fe7069b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eef7b6332fe7069b$var$load("7JPyq").then(()=>parcelRequire('95BjK'));

});



parcelRegister("2vUs2", function(module, exports) {

$parcel$export(module.exports, "trashProjectsDirectoryRedirectRouteEntry", () => $c7ed25d526b7ed1b$export$8ea64bac0a832a5c);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $4jMkc = parcelRequire("4jMkc");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $71tTP = parcelRequire("71tTP");

var $aphUL = parcelRequire("aphUL");

var $8gSP9 = parcelRequire("8gSP9");
const $c7ed25d526b7ed1b$export$8ea64bac0a832a5c = (0, $7NszV.createEntry)((0, $71tTP.trashProjectsDirectoryRedirectRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.trashed-projects',
        component: (0, $aphUL.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $4jMkc.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8gSP9.LazyTrashedProjectsAdmin)
        ],
        isRedirect: true
    }));

});
parcelRegister("71tTP", function(module, exports) {

$parcel$export(module.exports, "trashProjectsDirectoryRedirectRoute", () => $99acde7d7c12a8d4$export$6eafffd4489b3d4);
const $99acde7d7c12a8d4$export$6eafffd4489b3d4 = {
    name: 'trash-projects-directory',
    path: '/secure/projects/trash',
    exact: true
};

});

parcelRegister("aphUL", function(module, exports) {

$parcel$export(module.exports, "default", () => $70186afa73ef93b4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $7tQej = parcelRequire("7tQej");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$70186afa73ef93b4$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "projectsTrashRedirect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: "/jira/settings/projects/trash"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null));

});

parcelRegister("8gSP9", function(module, exports) {

$parcel$export(module.exports, "LazyTrashedProjectsAdmin", () => $67a748fd05680154$export$dd65a8ee0a9ac24f);
$parcel$export(module.exports, "default", () => $67a748fd05680154$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $67a748fd05680154$export$dd65a8ee0a9ac24f = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("aOxV4"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/trashed-projects/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$67a748fd05680154$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $67a748fd05680154$export$dd65a8ee0a9ac24f,
        pageId: "trashed-projects",
        shouldShowSpinner: true
    });

});
parcelRegister("aOxV4", function(module, exports) {

let $7df8e29d423193d3$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $7df8e29d423193d3$var$load("fliVL"),
    $7df8e29d423193d3$var$load("kMQbY")
]).then(()=>parcelRequire('lYlbz'));

});



parcelRegister("bCHhM", function(module, exports) {

$parcel$export(module.exports, "trashProjectsDirectoryRouteEntry", () => $dc548005383aa0ca$export$27d1f352c2f7acae);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $4jMkc = parcelRequire("4jMkc");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $6K0J9 = parcelRequire("6K0J9");

var $8gSP9 = parcelRequire("8gSP9");
const $dc548005383aa0ca$export$27d1f352c2f7acae = (0, $7NszV.createEntry)((0, $6K0J9.trashProjectsDirectoryRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.trashed-projects',
        component: (0, $8gSP9.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $4jMkc.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8gSP9.LazyTrashedProjectsAdmin)
        ]
    }));

});
parcelRegister("6K0J9", function(module, exports) {

$parcel$export(module.exports, "trashProjectsDirectoryRoute", () => $78ccf5c0c15f3843$export$74ec9fecd42fa96e);
const $78ccf5c0c15f3843$export$74ec9fecd42fa96e = {
    name: 'trash-projects-directory',
    path: '/jira/settings/projects/trash',
    exact: true
};

});


parcelRegister("g6Mf9", function(module, exports) {

$parcel$export(module.exports, "unlockOperationsRouteEntry", () => $10f9f9ad449ec307$export$c058f4d1c0667ce1);

var $ffza4 = parcelRequire("ffza4");

var $iqZds = parcelRequire("iqZds");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $l1EdH = parcelRequire("l1EdH");

var $3RJkv = parcelRequire("3RJkv");

var $1Mqbh = parcelRequire("1Mqbh");

var $3E8Yw = parcelRequire("3E8Yw");
const $10f9f9ad449ec307$export$c058f4d1c0667ce1 = (0, $7NszV.createEntry)((0, $1Mqbh.unlockOperationsRoute), ()=>({
        group: 'eoc',
        layout: (0, $iqZds.eocChangeboardingLayout),
        component: (0, $3E8Yw.default),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $l1EdH.resources)()
        ],
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3E8Yw.LazyUnlockOperations)
        ]
    }));

});
parcelRegister("l1EdH", function(module, exports) {

$parcel$export(module.exports, "resources", () => $05907c872dfc2fcc$export$bc99aaabaf7b70a7);

var $ieJ0b = parcelRequire("ieJ0b");

const $05907c872dfc2fcc$export$bc99aaabaf7b70a7 = ()=>[
        (0, $ieJ0b.transitioningDetailsResource)
    ];

});
parcelRegister("ieJ0b", function(module, exports) {

$parcel$export(module.exports, "transitioningDetailsResource", () => $86a5b96e0cefda11$export$850d76e0c9ffbdeb);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");
const $86a5b96e0cefda11$export$7985153d37586c9a = (cloudId)=>(0, $eusud.performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/customers/transitioning-details`).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getTransitioningDetails',
                packageName: 'jiraRouterResourcesEocUnlockOperations',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
const $86a5b96e0cefda11$export$850d76e0c9ffbdeb = (0, $2M1hQ.createResource)({
    type: 'EOC_UNLOCK_OPERATIONS',
    getKey: ()=>'eoc-unlock-operations',
    getData: async (_, { tenantContext: { cloudId: cloudId } })=>$86a5b96e0cefda11$export$7985153d37586c9a(cloudId),
    maxAge: 0,
    isBrowserOnly: true
});

});


parcelRegister("1Mqbh", function(module, exports) {

$parcel$export(module.exports, "unlockOperationsRoute", () => $03066cf43774e262$export$30306de7e00bc5a2);
const $03066cf43774e262$export$30306de7e00bc5a2 = {
    name: 'eoc-unlock-operations',
    path: '/jira/settings/products/ops/unlock',
    exact: true
};

});

parcelRegister("3E8Yw", function(module, exports) {

$parcel$export(module.exports, "LazyUnlockOperations", () => $c4c082612871271f$export$55e4754d556d072);
$parcel$export(module.exports, "default", () => $c4c082612871271f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $c4c082612871271f$export$55e4754d556d072 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("jBT4K")), {
    moduleId: "./src/packages/eoc/unlock-operations/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c4c082612871271f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $c4c082612871271f$export$55e4754d556d072,
        pageId: "eoc-products-unlock-operations",
        shouldShowSpinner: false
    });

});
parcelRegister("jBT4K", function(module, exports) {

let $e46c31e2abf1d1a6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e46c31e2abf1d1a6$var$load("4gJkh").then(()=>parcelRequire('1lA3p'));

});



parcelRegister("dR9Nr", function(module, exports) {

$parcel$export(module.exports, "userBoardRouteEntry", () => $9a056980ad2b7a75$export$cde4dacc737dc0f1);

var $e2ctp = parcelRequire("e2ctp");

var $gyYxw = parcelRequire("gyYxw");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $lfnsv = parcelRequire("lfnsv");

var $lJ1FP = parcelRequire("lJ1FP");

var $f5kpo = parcelRequire("f5kpo");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $f7Y15 = parcelRequire("f7Y15");

var $gNStA = parcelRequire("gNStA");

var $lyCs2 = parcelRequire("lyCs2");

var $hWAe2 = parcelRequire("hWAe2");

var $5f2bR = parcelRequire("5f2bR");

var $49YhR = parcelRequire("49YhR");
const $9a056980ad2b7a75$export$cde4dacc737dc0f1 = (0, $7NszV.createEntry)((0, $lyCs2.userBoardRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $hWAe2.ClassicBoardSkeleton),
        layout: (0, $aPfsS.composeLayouts)((0, $gyYxw.genericProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue',
                    'view=detail'
                ]
            },
            {
                query: [
                    'selectedIssue',
                    'modal=detail'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            ...(0, $3RJkv.getUserBoardNavigationResources)(),
            (0, $gNStA.resourceWithCondition2)((0, $f5kpo.shouldLoadUIFBoardResources), (0, $f7Y15.uifBoardResource)),
            (0, $lJ1FP.getEditModelResource)(),
            (0, $lfnsv.getBoardDetailsResource)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-cmp-board-early-entry'
            ]
        },
        earlyAssets: (0, $e2ctp.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        entryPoint: ()=>(0, $49YhR.userBoardPageEntrypoint)
    }));

});
parcelRegister("lyCs2", function(module, exports) {

$parcel$export(module.exports, "userBoardRoute", () => $a9c2c98045690ca6$export$57a2a0fe739f16);
const $a9c2c98045690ca6$export$57a2a0fe739f16 = {
    name: 'rapidboard-user-board',
    path: '/jira/people/:accountId/boards/:boardId'
};

});

parcelRegister("49YhR", function(module, exports) {

$parcel$export(module.exports, "userBoardPageEntrypoint", () => $a86c946afa6dbbff$export$606f36f7912a11ef);

var $lkFvK = parcelRequire("lkFvK");

var $fo6b8 = parcelRequire("fo6b8");

var $7rNZV = parcelRequire("7rNZV");

var $lmyls = parcelRequire("lmyls");
const $a86c946afa6dbbff$export$606f36f7912a11ef = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7rNZV.nextGenBoardEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});


parcelRegister("goreX", function(module, exports) {

$parcel$export(module.exports, "userBoardSettingsRouteEntry", () => $00cdba91b5f0dbcb$export$f8e56ba3f544195d);

var $gyYxw = parcelRequire("gyYxw");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $7NszV = parcelRequire("7NszV");

var $lfnsv = parcelRequire("lfnsv");

var $lJ1FP = parcelRequire("lJ1FP");

var $f5kpo = parcelRequire("f5kpo");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $f7Y15 = parcelRequire("f7Y15");

var $gNStA = parcelRequire("gNStA");

var $2aqtf = parcelRequire("2aqtf");

var $hWAe2 = parcelRequire("hWAe2");

var $e3Qmo = parcelRequire("e3Qmo");

var $lmyls = parcelRequire("lmyls");

var $4R6GH = parcelRequire("4R6GH");

var $hBv66 = parcelRequire("hBv66");

var $7uLIV = parcelRequire("7uLIV");
const $00cdba91b5f0dbcb$export$f8e56ba3f544195d = (0, $7NszV.createEntry)((0, $2aqtf.userBoardSettingsRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-board',
        skeleton: (0, $hWAe2.ClassicBoardSkeleton),
        entryPoint: ()=>(0, $e3Qmo.boardSettingsPageEntryPoint),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars),
            sidebarId: (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route') ? (0, $lmyls.SIDEBAR_ID).BOARD_SETTINGS : undefined
        },
        layout: (0, $gyYxw.genericProjectLayout),
        // This list is based on the resources needed by ./userBoardRouteEntry.tsx
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            ...(0, $3RJkv.getUserBoardNavigationResources)(),
            (0, $gNStA.resourceWithCondition2)((0, $f5kpo.shouldLoadUIFBoardResources), (0, $f7Y15.uifBoardResource)),
            (0, $lJ1FP.getEditModelResource)(),
            (0, $lfnsv.getBoardDetailsResource)()
        ]
    }));

});
parcelRegister("2aqtf", function(module, exports) {

$parcel$export(module.exports, "userBoardSettingsRoute", () => $439048221d4c78c5$export$a6e04dfbb956c677);
const $439048221d4c78c5$export$a6e04dfbb956c677 = {
    name: 'rapidboard-user-board-settings',
    path: '/jira/people/:accountId/boards/:boardId/settings/:config',
    query: [
        'from-backlog?'
    ]
};

});


parcelRegister("jqbKy", function(module, exports) {

$parcel$export(module.exports, "userBoardVelocityRouteEntry", () => $7546dfa7baced42b$export$ba0f726701b9e407);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $gyYxw = parcelRequire("gyYxw");

var $9itNB = parcelRequire("9itNB");

var $jD7nj = parcelRequire("jD7nj");
const $7546dfa7baced42b$export$ba0f726701b9e407 = (0, $7NszV.createEntry)((0, $9itNB.userBoardVelocityRoute), ()=>({
        group: 'classic-software',
        ufoName: 'software-reports.velocity-report-cmp',
        component: (0, $jD7nj.default),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getUserBoardNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jD7nj.LazyNextGenVelocityReport)
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("9itNB", function(module, exports) {

$parcel$export(module.exports, "userBoardVelocityRoute", () => $75bc02f5d3dae3fa$export$57431a0e4f3a32e8);
const $75bc02f5d3dae3fa$export$57431a0e4f3a32e8 = {
    name: 'software-reports-velocity-user-board',
    path: '/jira/people/:accountId/boards/:boardId/reports/velocity'
};

});

parcelRegister("jD7nj", function(module, exports) {

$parcel$export(module.exports, "LazyNextGenVelocityReport", () => $e8c07d5c9da9c49a$export$a2ca519c668b2f72);
$parcel$export(module.exports, "default", () => $e8c07d5c9da9c49a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $bzM7d = parcelRequire("bzM7d");

const $e8c07d5c9da9c49a$export$a2ca519c668b2f72 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("dTtei"))), {
    moduleId: "./src/packages/spa-apps/next-gen-reports/velocity/src/index-old.tsx"
});
var /** @deprecated delete file after all usages have been migrated to use entry points */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$e8c07d5c9da9c49a$export$2e2bcd8739ae039 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e8c07d5c9da9c49a$export$a2ca519c668b2f72,
        pageId: `next-gen-reports-velocity-${(0, $bzM7d.getBoardId)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });

});
parcelRegister("dTtei", function(module, exports) {

let $a1d715d063dea9cf$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $a1d715d063dea9cf$var$load("ffQaD"),
    $a1d715d063dea9cf$var$load("kvRbA"),
    $a1d715d063dea9cf$var$load("kBBcG")
]).then(()=>parcelRequire('fRLfA'));

});



parcelRegister("3eN7Y", function(module, exports) {

$parcel$export(module.exports, "userBoardViewNotFoundRouteEntry", () => $6b06d90b3814210b$export$a2bfa34d08651f6d);

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $dxCvy = parcelRequire("dxCvy");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dnp0v = parcelRequire("dnp0v");

var $5f2bR = parcelRequire("5f2bR");

var $hhqrL = parcelRequire("hhqrL");
const $6b06d90b3814210b$export$a2bfa34d08651f6d = (0, $7NszV.createEntry)((0, $dnp0v.userBoardViewNotFoundRoute), ()=>({
        group: 'classic-software',
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $hhqrL.boardViewNotFoundPageEntrypoint)
    }));

});
parcelRegister("dnp0v", function(module, exports) {

$parcel$export(module.exports, "userBoardViewNotFoundRoute", () => $41341d667544a268$export$ad6b96e14e735ed7);
const $41341d667544a268$export$ad6b96e14e735ed7 = {
    name: 'rapidboard-user-board-view-not-found',
    path: '/jira/people/:accountId/boards/:boardId/not-found'
};

});


parcelRegister("hjvN4", function(module, exports) {

$parcel$export(module.exports, "userSegmentationRouteEntry", () => $929524b967f2ea63$export$2af76482b576a135);

var $6e4Kt = parcelRequire("6e4Kt");

var $7NszV = parcelRequire("7NszV");

var $gRaVl = parcelRequire("gRaVl");

var $1z26X = parcelRequire("1z26X");
const $929524b967f2ea63$export$2af76482b576a135 = (0, $7NszV.createEntry)((0, $gRaVl.userSegmentationRoute), ()=>({
        ufoName: 'user-segmentation',
        component: (0, $1z26X.UserSegmentation),
        layout: (0, $6e4Kt.chromelessLayout),
        forPaint: [
            (0, $1z26X.LazyUserSegmentation)
        ]
    }));

});
parcelRegister("gRaVl", function(module, exports) {

$parcel$export(module.exports, "userSegmentationRoute", () => $875097219108c022$export$b0b13170cadf6395);
const $875097219108c022$export$b0b13170cadf6395 = {
    name: 'user-segmentation',
    path: '/jira/get-started',
    exact: true
};

});

parcelRegister("1z26X", function(module, exports) {

$parcel$export(module.exports, "LazyUserSegmentation", () => $16f27a0ded4f6683$export$bf9c9e0729c919f5);
$parcel$export(module.exports, "UserSegmentation", () => $16f27a0ded4f6683$export$15f8c5ccbb9c7ec3);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $16f27a0ded4f6683$export$bf9c9e0729c919f5 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("dx6XQ"))), {
    moduleId: "./src/packages/user-segmentation/src/index.tsx"
});
const $16f27a0ded4f6683$export$15f8c5ccbb9c7ec3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $16f27a0ded4f6683$export$bf9c9e0729c919f5,
        pageId: "user-segmentation",
        shouldShowSpinner: true
    });

});
parcelRegister("dx6XQ", function(module, exports) {

let $9da3c25d8bbd13cc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9da3c25d8bbd13cc$var$load("9wrqo").then(()=>parcelRequire('jL0w0'));

});



parcelRegister("6fHM1", function(module, exports) {

$parcel$export(module.exports, "viewIntentRouteEntry", () => $29a776b5b5594505$export$e693459ab8454027);

var $c04PQ = parcelRequire("c04PQ");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $88KkK = parcelRequire("88KkK");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $l4VHA = parcelRequire("l4VHA");

var $lSSsm = parcelRequire("lSSsm");

var $lkFvK = parcelRequire("lkFvK");

var $k6R7C = parcelRequire("k6R7C");
const $29a776b5b5594505$var$viewIntentPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $lSSsm.viewIntentEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $29a776b5b5594505$export$e693459ab8454027 = (0, $7NszV.createEntry)((0, $88KkK.viewIntentRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $c04PQ.isFedRamp)()) return undefined;
            return $29a776b5b5594505$var$viewIntentPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $k6R7C.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $l4VHA.VirtualAgentViewIntentSkeleton),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_VIEW_INTENT,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_VIEW_INTENT),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }));

});
parcelRegister("88KkK", function(module, exports) {

$parcel$export(module.exports, "viewIntentRoute", () => $aecf60273505ed2c$export$bf8131fb060d0e73);
const $aecf60273505ed2c$export$bf8131fb060d0e73 = {
    name: 'project-settings-servicedesk-virtualagent-view-intent',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/intents/:intentId/:tab(flow|training|settings)?'
};

});

parcelRegister("l4VHA", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentViewIntentSkeleton", () => $3817d32b8c9a6704$export$72b20c10a0f18a2f);
/* VirtualAgentViewIntentSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $jJwsA = parcelRequire("jJwsA");
const $3817d32b8c9a6704$var$customCssStyles = null;
const $3817d32b8c9a6704$export$72b20c10a0f18a2f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jJwsA))),
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("jJwsA", function(module, exports) {
module.exports = new URL("virtual-agent-view-intent-app-skeleton.tpl.5dd31cbb.svg", import.meta.url).toString();

});


parcelRegister("lSSsm", function(module, exports) {

$parcel$export(module.exports, "viewIntentEntryPoint", () => $ac6810a67c998d50$export$f51df662bd71ce39);

var $iD8EQ = parcelRequire("iD8EQ");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $ac6810a67c998d50$export$f51df662bd71ce39 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("4rg7F")), {
        moduleId: "bc04de30",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $iD8EQ.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        intentId: context.match.params.intentId ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("iD8EQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $45ed8bfdfee83271$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dedde06316e2afe5acc862762a93f4dd>>
 * @relayHash cb914e8d2219b7f49741872ae7f6d037
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a770411d52534005c4d94e2f61c74a98ed117522669e7af7701400ccbf2323f3

var $7oHmH = parcelRequire("7oHmH");
const $45ed8bfdfee83271$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a770411d52534005c4d94e2f61c74a98ed117522669e7af7701400ccbf2323f3",
        "metadata": {},
        "name": "srcVirtualAgentViewIntentQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $7oHmH.default)
        }
    }
};
var $45ed8bfdfee83271$export$2e2bcd8739ae039 = $45ed8bfdfee83271$var$node;

});

parcelRegister("4rg7F", function(module, exports) {

let $33b630acf5d0cc15$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $33b630acf5d0cc15$var$load("ffQaD"),
    $33b630acf5d0cc15$var$load("kvRbA"),
    $33b630acf5d0cc15$var$load("lMMew")
]).then(()=>parcelRequire('01RYz'));

});



parcelRegister("1GAqb", function(module, exports) {

$parcel$export(module.exports, "viewStandardFlowRouteEntry", () => $af4aef3a07273742$export$84dc2dfc944b0434);

var $c04PQ = parcelRequire("c04PQ");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $iU5fA = parcelRequire("iU5fA");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $blYux = parcelRequire("blYux");

var $lkFvK = parcelRequire("lkFvK");

var $hFluH = parcelRequire("hFluH");

var $k6R7C = parcelRequire("k6R7C");
const $af4aef3a07273742$var$viewStandardFlowPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $hFluH.viewStandardFlowEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $af4aef3a07273742$export$84dc2dfc944b0434 = (0, $7NszV.createEntry)((0, $iU5fA.viewStandardFlowRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $c04PQ.isFedRamp)()) return undefined;
            return $af4aef3a07273742$var$viewStandardFlowPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $k6R7C.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $blYux.VirtualAgentViewStandardFlowSkeleton),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_VIEW_STANDARD_FLOW,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_VIEW_STANDARD_FLOW),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }));

});
parcelRegister("iU5fA", function(module, exports) {

$parcel$export(module.exports, "viewStandardFlowRoute", () => $f47ba2070dd83bf9$export$c74dca8be49046ea);
const $f47ba2070dd83bf9$export$c74dca8be49046ea = {
    name: 'project-settings-servicedesk-virtualagent-view-standard-flow',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/standard-flows/:flowId/:tab(flow|settings)?'
};

});

parcelRegister("blYux", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentViewStandardFlowSkeleton", () => $cedc5dbef30f009d$export$c6d3f04e6931e3f6);
/* VirtualAgentViewStandardFlowSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $aVKJK = parcelRequire("aVKJK");
const $cedc5dbef30f009d$var$customCssStyles = null;
const $cedc5dbef30f009d$export$c6d3f04e6931e3f6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aVKJK))),
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("aVKJK", function(module, exports) {
module.exports = new URL("virtual-agent-view-standard-flow-app-skeleton.tpl.ec3b149b.svg", import.meta.url).toString();

});


parcelRegister("hFluH", function(module, exports) {

$parcel$export(module.exports, "viewStandardFlowEntryPoint", () => $8d05ca45dd1a7906$export$4fd7bf09308d4abd);

var $3sOht = parcelRequire("3sOht");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $4R6GH = parcelRequire("4R6GH");

const $8d05ca45dd1a7906$export$4fd7bf09308d4abd = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("7SWG3")), {
        moduleId: "8e1cdfbd",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $3sOht.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        flowId: context.match.params.flowId ?? '',
                        offerEscalationEnabled: (0, $4R6GH.fg)('toggle_offer_escalation_standard_flow_feature') ?? false
                    }
                }
            }
        })
});

});
parcelRegister("3sOht", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bc956e6a804d466$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c672df7540026746c518fc6252bb9853>>
 * @relayHash 03d60ddb2ab7e66f9166484b433a6391
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID edf50ab9067bb9d2788c9b405debcf23a384aa2eb6e7a5692942760f437f397f

var $7oHmH = parcelRequire("7oHmH");
const $1bc956e6a804d466$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "edf50ab9067bb9d2788c9b405debcf23a384aa2eb6e7a5692942760f437f397f",
        "metadata": {},
        "name": "srcVirtualAgentViewStandardFlowQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $7oHmH.default)
        }
    }
};
var $1bc956e6a804d466$export$2e2bcd8739ae039 = $1bc956e6a804d466$var$node;

});

parcelRegister("7SWG3", function(module, exports) {

let $5bdb179eddb8ee92$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5bdb179eddb8ee92$var$load("gZKid").then(()=>parcelRequire('16gIP'));

});



parcelRegister("V3Ey7", function(module, exports) {

$parcel$export(module.exports, "whoIsOnCallRouteEntry", () => $b83a8bf24279056f$export$fee33ca9661e49dd);

var $vla3y = parcelRequire("vla3y");

var $ffza4 = parcelRequire("ffza4");

var $iqZds = parcelRequire("iqZds");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $9Nrj8 = parcelRequire("9Nrj8");

var $hAT18 = parcelRequire("hAT18");
const $b83a8bf24279056f$var$getWhoIsOnCallResources = ()=>(0, $vla3y.resources);
const $b83a8bf24279056f$export$fee33ca9661e49dd = (0, $7NszV.createEntry)((0, $9Nrj8.whoIsOnCallRoute), ()=>({
        group: 'eoc',
        layout: (0, $iqZds.eocChangeboardingLayout),
        component: (0, $hAT18.WhoIsOnCallComponent),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...$b83a8bf24279056f$var$getWhoIsOnCallResources()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hAT18.LazyWhoIsOnCall)
        ]
    }));

});
parcelRegister("9Nrj8", function(module, exports) {

$parcel$export(module.exports, "whoIsOnCallRoute", () => $44bb0c0960b12c42$export$26b06efd7311586b);
const $44bb0c0960b12c42$export$26b06efd7311586b = {
    name: 'eoc-who-is-on-call',
    path: '/jira/ops/who-is-on-call',
    exact: true
};

});

parcelRegister("hAT18", function(module, exports) {

$parcel$export(module.exports, "LazyWhoIsOnCall", () => $31a5e09bb5444d16$export$7b03e7437c5d4f77);
$parcel$export(module.exports, "WhoIsOnCallComponent", () => $31a5e09bb5444d16$export$51430a0cf6ef3c09);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $31a5e09bb5444d16$export$7b03e7437c5d4f77 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("dR5Iv")), {
    moduleId: "./src/packages/eoc/who-is-on-call/src/ui/index.tsx"
});
const $31a5e09bb5444d16$export$51430a0cf6ef3c09 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $31a5e09bb5444d16$export$7b03e7437c5d4f77,
        pageId: "async-jira-eoc-who-is-on-call",
        shouldShowSpinner: false
    });

});
parcelRegister("dR5Iv", function(module, exports) {

let $a164a8d892af66a7$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $a164a8d892af66a7$var$load("ffQaD"),
    $a164a8d892af66a7$var$load("kvRbA"),
    $a164a8d892af66a7$var$load("5fUB7")
]).then(()=>parcelRequire('eV5T9'));

});




parcelRegister("gGB8S", function(module, exports) {

$parcel$export(module.exports, "startJiraSpa", () => $2f70583cb46f9994$export$f71867a5b2484020);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $fr1K2 = parcelRequire("fr1K2");

var $3NMrl = parcelRequire("3NMrl");

var $kUr4d = parcelRequire("kUr4d");

var $fLxDC = parcelRequire("fLxDC");

var $kNF25 = parcelRequire("kNF25");

var $0z6W8 = parcelRequire("0z6W8");

var $1ciso = parcelRequire("1ciso");

var $a0hd6 = parcelRequire("a0hd6");

var $21pfT = parcelRequire("21pfT");

var $k4NnA = parcelRequire("k4NnA");

var $aTq2A = parcelRequire("aTq2A");


var $87OsA = parcelRequire("87OsA");
parcelRequire("2YzDH");

var $x9xyg = parcelRequire("x9xyg");

var $4Pf62 = parcelRequire("4Pf62");

var $frBVt = parcelRequire("frBVt");

var $7CMCs = parcelRequire("7CMCs");

var $6s1PB = parcelRequire("6s1PB");

var $7bkFJ = parcelRequire("7bkFJ");

var $4R6GH = parcelRequire("4R6GH");

var $hL7JE = parcelRequire("hL7JE");

var $kZBXc = parcelRequire("kZBXc");

var $cfDZ3 = parcelRequire("cfDZ3");

var $6jY6G = parcelRequire("6jY6G");

var $9F6Ii = parcelRequire("9F6Ii");

var $81ezV = parcelRequire("81ezV");

var $b7awD = parcelRequire("b7awD");

var $d1K1f = parcelRequire("d1K1f");

var $2SVPM = parcelRequire("2SVPM");

var $fGcGc = parcelRequire("fGcGc");

var $bShz7 = parcelRequire("bShz7");

var $lbyb6 = parcelRequire("lbyb6");

var $5HG6S = parcelRequire("5HG6S");

var $29g8C = parcelRequire("29g8C");

var $kKlrY = parcelRequire("kKlrY");

var $l8ruj = parcelRequire("l8ruj");

var $eOqwI = parcelRequire("eOqwI");

var $3qHVS = parcelRequire("3qHVS");

var $lGgkA = parcelRequire("lGgkA");
var $ddkdN = parcelRequire("ddkdN");

var $2Gs5h = parcelRequire("2Gs5h");
var $lVJAU = parcelRequire("lVJAU");

var $95Orn = parcelRequire("95Orn");

var $lODMY = parcelRequire("lODMY");

var $1AZST = parcelRequire("1AZST");

var $fg6X1 = parcelRequire("fg6X1");

var $c1haS = parcelRequire("c1haS");

var $2ChuC = parcelRequire("2ChuC");

var $dej7j = parcelRequire("dej7j");
parcelRequire("dsKbf");
// Set SPA global
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
window.__SPA__ = true;
const $2f70583cb46f9994$var$altBootstrapEnabled = // It is easier to make the check against window than it is to make typescript happy here.
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
!false && typeof window !== 'undefined' && window.__SPA_BOOTSTRAP_ALT;
// In the experiment scenario, I'm moving the side-effect from immediate execution to function execution.
if (!$2f70583cb46f9994$var$altBootstrapEnabled) (0, $lGgkA.LooselyLazy).init({
    mode: (()=>(0, $4R6GH.fg)('jfp_magma_jira-rll-hydrate'))() ? (0, $ddkdN.MODE).HYDRATE : (0, $ddkdN.MODE).RENDER,
    crossOrigin: 'anonymous',
    // hide fg access from eslint, we can do it on "pure client
    react18: (()=>(0, $4R6GH.fg)('jfp_magma_jira-rll-react-18-render'))(),
    usePostTaskPhases: (()=>(0, $4R6GH.fg)('jfp-jira-remove-rll-subscriptions'))(),
    trackDuplicateLazyIds: (()=>(0, $4R6GH.fg)('jfp-magma-rll-track-duplicated-lazy-ids'))(),
    htmlPlaceholders: (()=>(0, $4R6GH.fg)('jfp_magma_jira-rll-html-placeholder'))(),
    markedForPreload: (()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        (0, $4R6GH.fg)('jfp_magma_jira-rll-client-preload') ? window.SPA_STATE?.rll_preload : undefined)()
});

const $2f70583cb46f9994$var$getMessages = ()=>{
    (0, $x9xyg.setMark)('jira-spa/language-pack.start');
    const messages = (parcelRequire("hWnRN"));
    (0, $x9xyg.setMark)('jira-spa/language-pack.end');
    return messages;
};
const $2f70583cb46f9994$var$superbatchInit = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.DeferScripts = {
        deferState: 'done'
    };
    if ((0, $4R6GH.fg)('remove_deferred_class_remove')) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    {
        if (document.body?.classList.contains('deferred')) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.body?.classList.remove('deferred');
    } else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.body && document.body.classList.remove('deferred');
};
const $2f70583cb46f9994$var$globalSettingsArgs = {
    navigation: false,
    upflow: false
};
const $2f70583cb46f9994$var$InstallGlobalComponentsOnce = ()=>{
    (0, $5uXOq.useEffect)(()=>{
        (0, $2ChuC.default).installLowPriorityApps(// @ts-expect-error - TS2345 - Argument of type 'Partial<{ readonly navigation: false; readonly upflow: false; }>' is not assignable to parameter of type 'LowPriorityAppsArgs'.
        (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))($2f70583cb46f9994$var$globalSettingsArgs, [
            'flags',
            'navigation',
            'renderNavigation'
        ]));
        (0, $x9xyg.setMark)('JIRA_SPA_ENTRY_GLOBAL_INSTALL');
    }, []);
    return null;
};
const $2f70583cb46f9994$var$updateCapability = (capability)=>{
    (0, $87OsA.setCapability)(capability);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (capability === null && window.AJS?.$?.ajaxSettings?.headers?.[0, $281cbd47ba46dd7d$export$9a80695e72849f84]) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    delete window.AJS.$.ajaxSettings.headers[0, $281cbd47ba46dd7d$export$9a80695e72849f84];
    else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.AJS?.$?.ajaxSetup({
        headers: {
            [(0, $281cbd47ba46dd7d$export$9a80695e72849f84)]: capability
        }
    });
};
// @ts-expect-error - TS7031 - Binding element 'routes' implicitly has an 'any' type.
const $2f70583cb46f9994$var$CapabilityTrackerConnector = ({ routes: routes })=>{
    const { registerBlock: registerBlock } = (0, $lVJAU.useRouterActions)();
    registerBlock((nextLocation)=>{
        const nextMatchObject = (0, $2Gs5h.default)(routes, nextLocation.pathname, nextLocation.search, '');
        $2f70583cb46f9994$var$updateCapability(nextMatchObject?.route.meta?.capability || null);
        return true;
    });
    const route = (0, $6jY6G.useCurrentRoute)();
    $2f70583cb46f9994$var$updateCapability(route.meta?.capability || null);
    return null;
};
const $2f70583cb46f9994$var$main = async (getInitialRoutes, loadLazyRoutes)=>{
    (0, $kNF25.collectSSRPlaceholderDimensions)(document, window, (0, $4R6GH.fg)('enable_page_layout_placeholder'));
    (0, $kKlrY.default)();
    (0, $aTq2A.initBrowserMetrics3)();
    (0, $7bkFJ.initPlatformFeatureFlags)((0, $3qHVS.visualRefreshResolverOverride));
    (0, $fg6X1.initEntryPointConfig)();
    (0, $eOqwI.getClientReceiver)();
    (0, $fGcGc.addInitialPageLoadTimings)();
    (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/init', 'jira-spa.js:eval-start');
    (0, $x9xyg.setMark)('jira-spa/setup.start');
    const routes = (0, $2SVPM.measureInitialPageLoadTiming)('jira-spa/setup/routes', ()=>getInitialRoutes());
    const history = (0, $2SVPM.measureInitialPageLoadTiming)('jira-spa/setup/history', ()=>(0, $lbyb6.default)(routes));
    const initRoute = (0, $2SVPM.measureInitialPageLoadTiming)('jira-spa/setup/match-route', ()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const matchedRoute = (0, $2Gs5h.default)(routes, window.location.pathname, window.location.search);
        (0, $cfDZ3.setMatchedRoute)(matchedRoute?.route, matchedRoute?.match);
        return matchedRoute;
    });
    if (initRoute != null) {
        const ufoName = (0, $fLxDC.default)(initRoute.route);
        (0, $0z6W8.default)(ufoName, initRoute.route.name);
    }
    const BrowserMetricsConnector = ()=>{
        const route = (0, $6jY6G.useCurrentRoute)();
        (0, $21pfT.browserMetrics).setRoute(route.name);
        (0, $1ciso.useUFOTransitionCompleter)();
        (0, $1AZST.GlobalPageLoadExperience).setPageLoadId(route.perfMetricKey || 'UNKNOWN');
        return null;
    };
    (0, $1AZST.GlobalPageLoadExperience).startPageLoad('UNKNOWN', true);
    const messages = $2f70583cb46f9994$var$getMessages();
    const tenantContext = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const { locale: locale } = tenantContext;
    const routerProps = {
        history: history,
        routes: routes,
        basePath: '',
        initialRoute: initRoute?.route,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        resourceData: window.SPA_STATE,
        resourceContext: (0, $5HG6S.getSpaRouterContext)({
            tenantContext: tenantContext
        }),
        onPrefetch: ({ route: route, match: match })=>{
            (0, $bShz7.setPrefetchStartMark)(match);
            if (!route.forPaint) return;
            route.forPaint.map((component)=>component.preload && component.preload());
        },
        isLazyRoutes: typeof loadLazyRoutes === 'function'
    };
    let SpaClientRouter;
    if (typeof loadLazyRoutes === 'function') {
        const useRouterRoutes = (0, $lODMY.createRouterSelector)((state)=>state.routes);
        SpaClientRouter = ({ children: children })=>{
            const actions = (0, $lODMY.useRouterStoreActions)();
            const currentRoutes = useRouterRoutes();
            (0, $5uXOq.useEffect)(()=>{
                let isCancelled = false;
                const loadRoutes = async ()=>{
                    if (!isCancelled) {
                        const getLazyRoutes = await loadLazyRoutes();
                        await actions.setRoutes(getLazyRoutes());
                    }
                };
                loadRoutes();
                return ()=>{
                    isCancelled = true;
                };
            }, [
                actions
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b7awD.Router), routerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
                id: "spa-main.client-router",
                packageName: "jiraEntry",
                fallback: "unmount",
                teamName: "delorean-spa"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $95Orn.AtlaspackMetricsConnector), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BrowserMetricsConnector, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2f70583cb46f9994$var$CapabilityTrackerConnector, {
                routes: currentRoutes
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d1K1f.default), null)), children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hL7JE.NonCritical), {
                id: "spa-main.client-router.non-critical",
                teamName: "delorean-spa"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2f70583cb46f9994$var$InstallGlobalComponentsOnce, null)));
        };
    } else SpaClientRouter = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b7awD.Router), routerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
            id: "spa-main.client-router",
            packageName: "jiraEntry",
            fallback: "unmount",
            teamName: "delorean-spa"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $95Orn.AtlaspackMetricsConnector), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BrowserMetricsConnector, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2f70583cb46f9994$var$CapabilityTrackerConnector, {
            routes: routes
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d1K1f.default), null)), children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hL7JE.NonCritical), {
            id: "spa-main.client-router.non-critical",
            teamName: "delorean-spa"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2f70583cb46f9994$var$InstallGlobalComponentsOnce, null)));
    const App = ({ placeholders: placeholders })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9F6Ii.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
            name: "jira-spa"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $frBVt.EntryPointPlaceholderContext).Provider, {
            value: placeholders
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZBXc.Spa), {
            baseUrl: "",
            locale: locale,
            messages: messages,
            Router: SpaClientRouter,
            initRoute: initRoute,
            routes: routes,
            routerLinkComponent: (0, $81ezV.JiraRouterLinkConfiguration)
        }))));
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__NAV_VERSION__ = '3.0.0';
    (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/setup', 'jira-spa/setup.start', true);
    (0, $x9xyg.setMark)('_jira-spa/spa-shell.start');
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const container = document.getElementById('jira-frontend');
    if (container) {
        (0, $a0hd6.getVCObserver)().setSSRElement(container);
        (0, $a0hd6.getVCObserver)().setReactRootRenderStart();
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                (0, $a0hd6.getVCObserver)().setReactRootRenderStop();
            });
        });
        const placeholders = (0, $frBVt.getPlaceholdersFromHTML)();
        const isConcurrentEnabled = (0, $c1haS.getIsConcurrentEnabled)();
        const renderOldWithoutHydrateRoot = ()=>{
            // if the feature flag is false, do not opt into concurrent features
            // if the local env var is not set, or set to false, do not opt into concurrent features
            if (!isConcurrentEnabled) (0, $7nsd3.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(App, {
                placeholders: placeholders
            }), container);
            if (isConcurrentEnabled) {
                const root = (0, $kUr4d.createRoot)(container);
                root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(App, {
                    placeholders: placeholders
                }), (0, $4R6GH.fg)('concurrent-rendering-change-advisory') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $29g8C.ConcurrentAdvisory), {
                    consoleMessage: "This entire site is being rendered with React concurrent rendering go/r18"
                }) : null));
            }
        };
        // TODO after ff clean up - pull this out to a file so we don't have to save on duplication effort.
        const renderNewWithHydrateRoot = ()=>{
            const renderNonConcurrent = ()=>{
                (0, $7nsd3.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(App, {
                    placeholders: placeholders
                }), container);
            };
            const ConcurrentSpaApp = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(App, {
                    placeholders: placeholders
                }), (0, $4R6GH.fg)('concurrent-rendering-change-advisory') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $29g8C.ConcurrentAdvisory), {
                    consoleMessage: "This entire site is being rendered with React concurrent rendering go/r18"
                }) : null);
            const renderConcurrentWithoutHydration = ()=>{
                const root = (0, $kUr4d.createRoot)(container);
                root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ConcurrentSpaApp, null));
            };
            const renderWithHydrateConcurrent = ()=>{
                (0, $kUr4d.hydrateRoot)(container, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ConcurrentSpaApp, null));
            };
            if (initRoute?.route?.isHydrateRootEnabled) // Hydration also enables concurrent mode, if you enable hydration on your route. It's also assumed you want and understand concurrent mode.
            renderWithHydrateConcurrent();
            else if (isConcurrentEnabled) // If the route is not enabled for hydration but concurrent mode is enabled for this environment, render in concurrent mode
            renderConcurrentWithoutHydration();
            else // if the feature flag is false, do not opt into concurrent features
            // if the local env var is not set, or set to false, do not opt into concurrent features
            renderNonConcurrent();
        };
        if ((0, $4R6GH.fg)('jfp-magma-incremental-hydrate-root')) renderNewWithHydrateRoot();
        else renderOldWithoutHydrateRoot();
    }
    (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/spa-shell', '_jira-spa/spa-shell.start');
    (0, $x9xyg.setMark)('JIRA_SPA_ENTRY_REACT_DOM_RENDER');
    setTimeout(()=>{
        (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa', 'commons-entry.js:eval-stop', 'jira-spa.js:eval-stop');
    });
    if ((0, $6s1PB.expVal)('uip_preprod_slow', 'value', 0) > 0) {
        (0, $x9xyg.setMark)('slow-start');
        const end = performance.now() + (0, $6s1PB.expVal)('uip_preprod_slow', 'value', 0);
        while(performance.now() < end);
        (0, $x9xyg.setMark)('slow-stop');
    }
    (0, $2ChuC.default).installHighPriorityApps(// @ts-expect-error - TS2345 - Argument of type 'Partial<{ readonly navigation: false; readonly upflow: false; }>' is not assignable to parameter of type 'HighPriorityAppsArgs'.
    (0, (/*@__PURE__*/$parcel$interopDefault($3NMrl)))($2f70583cb46f9994$var$globalSettingsArgs, [
        'flags',
        'navigation',
        'renderNavigation'
    ]));
    $2f70583cb46f9994$var$superbatchInit();
    return null;
};
const $2f70583cb46f9994$export$f71867a5b2484020 = async (getInitialRoutes, loadLazyRoutes)=>{
    if ($2f70583cb46f9994$var$altBootstrapEnabled) (0, $lGgkA.LooselyLazy).init({
        mode: (0, $ddkdN.MODE).RENDER,
        crossOrigin: 'anonymous'
    });
    return $2f70583cb46f9994$var$main(getInitialRoutes, loadLazyRoutes).catch((reason)=>(0, $k4NnA.reportBootstrapError)(reason)).finally(()=>{
        (0, $dej7j.reportUnreportedStatsigInitialisationError)();
    });
};

});
parcelRegister("kUr4d", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $f38e08888af96a1f$export$882461b6382ed46c, (v) => $f38e08888af96a1f$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $f38e08888af96a1f$export$757ceba2d55c277e, (v) => $f38e08888af96a1f$export$757ceba2d55c277e = v);
var $f38e08888af96a1f$export$882461b6382ed46c;
var $f38e08888af96a1f$export$757ceba2d55c277e;
'use strict';

var $7nsd3 = parcelRequire("7nsd3");
var $f38e08888af96a1f$var$i;
$f38e08888af96a1f$export$882461b6382ed46c = $7nsd3.createRoot;
$f38e08888af96a1f$export$757ceba2d55c277e = $7nsd3.hydrateRoot;

});

parcelRegister("fLxDC", function(module, exports) {

$parcel$export(module.exports, "default", () => $96da41f3532a466b$export$2e2bcd8739ae039);
function $96da41f3532a466b$var$getUFORouteName(route) {
    if (route.ufoName != null) return route.ufoName;
    return route.name;
}
var $96da41f3532a466b$export$2e2bcd8739ae039 = $96da41f3532a466b$var$getUFORouteName;

});

parcelRegister("kNF25", function(module, exports) {

$parcel$export(module.exports, "collectSSRPlaceholderDimensions", () => $b76912b89d3451e2$export$aee7516e57289027);
// lightweight script to scan the SSR response and collect all elements with data-ssr-placeholder attribute
// and save their size/positions in a map __SSR_PLACEHOLDERS_DIMENSIONS__ on the Window object. Each placeholderId is
// unique and maps to its corresponding elements bounding client rectangle dimensions.
function $b76912b89d3451e2$export$aee7516e57289027(document, window, enablePageLayoutPlaceholder = false) {
    const ssrPlaceholders = document?.querySelectorAll('[data-ssr-placeholder]');
    ssrPlaceholders.forEach((elem)=>{
        const placeholderId = elem.getAttribute('data-ssr-placeholder');
        const boundingClient = elem.getBoundingClientRect();
        if (placeholderId) {
            window.__SSR_PLACEHOLDERS_DIMENSIONS__ = window.__SSR_PLACEHOLDERS_DIMENSIONS__ || {};
            window.__SSR_PLACEHOLDERS_DIMENSIONS__[placeholderId] = boundingClient;
        }
    });
    if (enablePageLayoutPlaceholder) {
        const pageLayoutRoot = document?.getElementById('unsafe-design-system-page-layout-root');
        if (pageLayoutRoot) {
            const boundingClient = pageLayoutRoot.getBoundingClientRect();
            window.__SSR_PLACEHOLDERS_DIMENSIONS__ = window.__SSR_PLACEHOLDERS_DIMENSIONS__ || {};
            window.__SSR_PLACEHOLDERS_DIMENSIONS__['page-layout.root'] = boundingClient;
        }
    }
}

});

parcelRegister("0z6W8", function(module, exports) {

$parcel$export(module.exports, "default", () => $af450dab6fb30b5f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "updatePageloadName", () => $af450dab6fb30b5f$export$d0f99433cd4f4028);

var $7Jxgt = parcelRequire("7Jxgt");

var $5gx4p = parcelRequire("5gx4p");

var $fe1wc = parcelRequire("fe1wc");

var $tcn7E = parcelRequire("tcn7E");

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $9AgLs = parcelRequire("9AgLs");
const $af450dab6fb30b5f$var$AWAITING_PAGELOAD_NAME = 'awaiting_pageload_name';
function $af450dab6fb30b5f$var$traceUFOPageLoad(ufoName, routeName = ufoName) {
    const activeInteraction = (0, $bFU4G.getActiveInteraction)();
    if (activeInteraction && !ufoName) return;
    (0, $9AgLs.default).current = routeName || null;
    const rate = ufoName ? (0, $fe1wc.getInteractionRate)(ufoName, 'page_load') : 1;
    const enabledBySamplingRate = (0, $5gx4p.default)(rate);
    if (enabledBySamplingRate && !activeInteraction) {
        const newId = (0, $7Jxgt.v4)();
        (0, $1u4q7.DefaultInteractionID).current = newId;
        (0, $bFU4G.addNewInteraction)(newId, ufoName || '', 'page_load', 0, rate, null, routeName, (0, $tcn7E.getActiveTrace)());
        if (!ufoName) // if no name is provided we add a hold to the interaction, it is removed if the name is provided while the interaction is holding
        (0, $bFU4G.addHoldByID)(newId, [], $af450dab6fb30b5f$var$AWAITING_PAGELOAD_NAME, $af450dab6fb30b5f$var$AWAITING_PAGELOAD_NAME, true);
    } else if (!enabledBySamplingRate && activeInteraction && activeInteraction.type === 'page_load') // if there is an active interaction it will be aborted without initialising a new one because the coinflip returned false
    (0, $bFU4G.abort)(activeInteraction.id, 'excluded_by_sampling');
    else if (ufoName && activeInteraction && !activeInteraction.ufoName && activeInteraction.type === 'page_load') {
        (0, $bFU4G.updatePageLoadInteractionName)(ufoName, routeName);
        (0, $bFU4G.removeHoldByID)(activeInteraction.id, $af450dab6fb30b5f$var$AWAITING_PAGELOAD_NAME);
    }
}
var $af450dab6fb30b5f$export$2e2bcd8739ae039 = $af450dab6fb30b5f$var$traceUFOPageLoad;
function $af450dab6fb30b5f$export$d0f99433cd4f4028(ufoName, routeName = ufoName) {
    const interaction = (0, $bFU4G.getActiveInteraction)();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    if (ufoName) {
        const rate = (0, $fe1wc.getInteractionRate)(ufoName, 'page_load');
        (0, $bFU4G.updatePageLoadInteractionName)(ufoName, routeName);
        if ((0, $5gx4p.default)(rate)) (0, $9AgLs.default).current = ufoName;
        else (0, $bFU4G.abort)(interaction.id, 'excluded_by_sampling');
    }
    (0, $bFU4G.removeHoldByID)(interaction.id, $af450dab6fb30b5f$var$AWAITING_PAGELOAD_NAME);
}

});

parcelRegister("k4NnA", function(module, exports) {

$parcel$export(module.exports, "reportBootstrapError", () => $6a69127f0604feb0$export$a5c16644a2d3c205);

var $kuiU5 = parcelRequire("kuiU5");

var $hh0bW = parcelRequire("hh0bW");

var $jpY8v = parcelRequire("jpY8v");

var $4Pf62 = parcelRequire("4Pf62");

var $jcw0u = parcelRequire("jcw0u");


var $8ApFP = parcelRequire("8ApFP");
const $6a69127f0604feb0$export$649804097de83b3b = [
    // https://jplat.jira.atlassian.cloud/browse/MAGMA-2440
    {
        browser: 'Chrome',
        browserVersion: '116.0.0',
        errorMessage: /Cannot read properties of undefined \(reading 'target'\)/
    }
];
const $6a69127f0604feb0$var$checkBrowserCondition = (error, filterCriteria)=>filterCriteria.browser != null ? (0, $jpY8v.getBrowser)().name === filterCriteria.browser : true;
const $6a69127f0604feb0$var$checkBrowserVersionCondition = (error, filterCriteria)=>filterCriteria.browserVersion != null ? (0, $jpY8v.getBrowser)().version === filterCriteria.browserVersion : true;
const $6a69127f0604feb0$var$checkErrorMessageCondition = (error, filterCriteria)=>filterCriteria.errorMessage != null ? error.message.match(filterCriteria.errorMessage) : true;
const $6a69127f0604feb0$export$a66ce4bea8340820 = (error, errorFilteringCriterias)=>{
    try {
        // condition checkers must return true if they don't apply, so an empty filterCriteria will match (and block) ALL errors
        const conditionCheckers = [
            $6a69127f0604feb0$var$checkBrowserCondition,
            $6a69127f0604feb0$var$checkBrowserVersionCondition,
            $6a69127f0604feb0$var$checkErrorMessageCondition
        ];
        // Should send analytics if no filtering conditions are met
        return !errorFilteringCriterias.some((filterCriteria)=>conditionCheckers.every((conditionChecker)=>conditionChecker(error, filterCriteria)));
    } catch (e) {
        // If any error occurs during filtering, experience analytics should still be sent
        return true;
    }
};
const $6a69127f0604feb0$export$a5c16644a2d3c205 = async (error)=>{
    const tenantContextData = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    // We probably already have analytics initialised but we could have failed earlier than it
    (0, $kuiU5.default)(tenantContextData);
    // Experience analytics should only be sent if it is not filtered
    if ($6a69127f0604feb0$export$a66ce4bea8340820(error, $6a69127f0604feb0$export$649804097de83b3b)) (0, $hh0bW.default)({
        analyticsSource: (0, $9ccbd88c704da1ef$export$c9e16a15d65437),
        experience: (0, $9ccbd88c704da1ef$export$b1534bc11f201efd),
        wasExperienceSuccesful: false,
        location: (0, $9ccbd88c704da1ef$export$7dfef0177e883b05),
        application: (0, $9ccbd88c704da1ef$export$aa6008fe0169b864),
        edition: (0, $9ccbd88c704da1ef$export$39418a21fbb51487),
        additionalAttributes: (0, $8ApFP.routeAnalyticsAttributes)
    });
    (0, $jcw0u.default)({
        meta: {
            packageName: 'jiraBootstrapSlaReporter',
            id: 'bootstrap-failure',
            teamName: 'magma'
        },
        error: error,
        attributes: (0, $8ApFP.routeAnalyticsAttributes)
    });
    throw error;
};

});
const $9ccbd88c704da1ef$export$c9e16a15d65437 = 'navigationNext';
const $9ccbd88c704da1ef$export$b1534bc11f201efd = 'jiraPageContainer';
const $9ccbd88c704da1ef$export$fa4bbc89fd1f1a7 = null;
const $9ccbd88c704da1ef$export$aa6008fe0169b864 = null;
const $9ccbd88c704da1ef$export$39418a21fbb51487 = null;
const $9ccbd88c704da1ef$export$7dfef0177e883b05 = 'entry.jira-spa';
const $9ccbd88c704da1ef$var$PAGE_CONTAINER_MARK = 'jira-spa/spa-shell/page-container';
const $9ccbd88c704da1ef$export$7114284ca03133ee = `_${$9ccbd88c704da1ef$var$PAGE_CONTAINER_MARK}.end`;
const $9ccbd88c704da1ef$export$21473105c510aacc = 'jira-spa/spa-shell/page-layout';
const $9ccbd88c704da1ef$export$898b6208220685b0 = 'jira-spa/spa-shell/global-containers';
const $9ccbd88c704da1ef$export$e2bc63118050de32 = `_${$9ccbd88c704da1ef$export$898b6208220685b0}.start`;
const $9ccbd88c704da1ef$export$59f83d43fe209319 = `_${$9ccbd88c704da1ef$export$898b6208220685b0}.end`;
const $9ccbd88c704da1ef$export$fb9876ab4228d985 = 'jira-spa/spa-shell/global-components';
const $9ccbd88c704da1ef$export$c20831be6f780cb5 = `_${$9ccbd88c704da1ef$export$fb9876ab4228d985}.start`;
const $9ccbd88c704da1ef$export$398df1bca49f9884 = `_${$9ccbd88c704da1ef$export$fb9876ab4228d985}.end`;
const $9ccbd88c704da1ef$export$7048c99f32c60b34 = 'jira-spa/spa-shell/global-containers/app-base';
const $9ccbd88c704da1ef$export$3c2d8af5c7577fe7 = `_${$9ccbd88c704da1ef$export$7048c99f32c60b34}.start`;
const $9ccbd88c704da1ef$export$aac77afee74c49d0 = `_${$9ccbd88c704da1ef$export$7048c99f32c60b34}.end`;
const $9ccbd88c704da1ef$export$4f341d86a3c214 = 'jira-spa/spa-shell/global-containers/router';
const $9ccbd88c704da1ef$export$16e7ead3a8b5c366 = `_${$9ccbd88c704da1ef$export$4f341d86a3c214}.start`;
const $9ccbd88c704da1ef$export$c389f0b50840d5ca = `_${$9ccbd88c704da1ef$export$4f341d86a3c214}.end`;

parcelRegister("8ApFP", function(module, exports) {

$parcel$export(module.exports, "routeAnalyticsAttributes", () => $a83c9e8eeb3d40c2$export$c71778b3a4356b04);

var $cfDZ3 = parcelRequire("cfDZ3");

var $hVf1M = parcelRequire("hVf1M");
const $a83c9e8eeb3d40c2$export$c71778b3a4356b04 = Object.defineProperties({}, {
    routeName: {
        enumerable: true,
        get: (0, $cfDZ3.getRouteName)
    },
    userLocation: {
        enumerable: true,
        get: (0, $cfDZ3.getUserLocation)
    },
    previousSubProduct: {
        enumerable: true,
        get: (0, $cfDZ3.getPreviousSubProduct)
    },
    isProjectAdmin: {
        enumerable: true,
        get: (0, $hVf1M.getIsProjectAdmin)
    }
});

});


parcelRegister("2YzDH", function(module, exports) {
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $jOqMN = parcelRequire("jOqMN");

if (!$parcel$global._IS_JIRA_GLOBAL_SIDE_EFFECT_INIT_) {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    (parcelRequire("3avtZ"));
    const isDevMode = false;
    (0, $jOqMN.default).devtools = isDevMode && (()=>({
            serialize: {
                // @ts-expect-error - TS7006 - Parameter 'key' implicitly has an 'any' type. | TS7006 - Parameter 'value' implicitly has an 'any' type.
                replacer: (key, value)=>value instanceof HTMLElement ? {
                        data: {
                            tagName: value.tagName,
                            className: value.className,
                            id: value.id,
                            __SANITIZED__: true
                        },
                        __serializedType__: 'HTMLElement'
                    } : value
            }
        }));
    (0, $jOqMN.default).batchUpdates = !false;
    Object.freeze((0, $jOqMN.default));
    $parcel$global._IS_JIRA_GLOBAL_SIDE_EFFECT_INIT_ = true;
}

});
parcelRegister("3avtZ", function(module, exports) {
const $24eaba0df287b1ab$var$style = document.createElement('style');
$24eaba0df287b1ab$var$style.textContent = `html,body,p,div,h1,h2,h3,h4,h5,h6,ul,ol,dl,img,pre,form,fieldset{margin:0;padding:0}img,fieldset{border:0}body,html{width:100%;height:100%}body{background-color:var(--ds-surface,#fff);color:var(--ds-text,#172b4d);font:var(--ds-font-body,normal 400 14px/1.42857 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);-ms-overflow-style:-ms-autohiding-scrollbar;text-decoration-skip-ink:auto}p,ul,ol,dl,h1,h2,h3,h4,h5,h6,blockquote,pre,form,table{margin:var(--ds-space-150,12px)0 0 0}a{color:var(--ds-link,#0052cc);text-decoration:none}a:hover{color:var(--ds-link,#0065ff);text-decoration:underline}a:active{color:var(--ds-link-pressed,#0747a6)}a:focus-visible{outline:var(--ds-border-width-outline,2px)solid var(--ds-border-focused,#2684ff);outline-offset:var(--ds-space-025,2px)}@supports not selector(*:focus-visible){a:focus{outline:var(--ds-border-width-outline,2px)solid var(--ds-border-focused,#4c9aff);outline-offset:var(--ds-space-025,2px)}}h1{font:var(--ds-font-heading-xlarge,600 2.07143em/1.10345 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-500)}h2{font:var(--ds-font-heading-large,500 1.71429em/1.16667 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-500)}h3{font:var(--ds-font-heading-medium,500 1.42857em/1.2 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:28px}h4{font:var(--ds-font-heading-small,600 1.14286em/1.25 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-300)}h5{font:var(--ds-font-heading-xsmall,600 1em/1.14286 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-200)}h6{font:var(--ds-font-heading-xxsmall,600 .857143em/1.33333 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-250);text-transform:uppercase}ul,ol,dl{padding-left:var(--ds-space-500,40px)}dd,dd+dt,li+li,ul ul:not(:first-child),ul style:first-child~*+ul,ol ul:not(:first-child),ol style:first-child~*+ul,ul ol:not(:first-child),ul style:first-child~*+ol,ol ol:not(:first-child),ol style:first-child~*+ol{margin-top:var(--ds-space-050,4px)}p:first-child,style:first-child+p,ul:first-child,style:first-child+ul,ol:first-child,style:first-child+ol,dl:first-child,style:first-child+dl,h1:first-child,style:first-child+h1,h2:first-child,style:first-child+h2,h3:first-child,style:first-child+h3,h4:first-child,style:first-child+h4,h5:first-child,style:first-child+h5,h6:first-child,style:first-child+h6,blockquote:first-child,style:first-child+blockquote,pre:first-child,style:first-child+pre,form:first-child,style:first-child+form,table:first-child,style:first-child+table{margin-top:0}blockquote,q{color:inherit}blockquote{padding-left:var(--ds-space-500,40px);border:none}[dir=rtl] blockquote{padding-left:0;padding-right:var(--ds-space-500,40px)}blockquote:before,q:before{content:"\u{201C}"}blockquote:after,q:after{content:"\u{201D}"}blockquote:before{float:left;text-align:right;width:1em;margin-left:-1em}[dir=rtl] blockquote:before{float:right;text-align:left;margin-right:-1em}blockquote>:last-child{display:inline-block}small{font:var(--ds-font-body-small,normal 400 11px/16px ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",Ubuntu,"Helvetica Neue",sans-serif)}code,kbd{font-family:var(--ds-font-family-code,ui-monospace,Menlo,"Segoe UI Mono","Ubuntu Mono",monospace)}var,address,dfn,cite{font-style:italic}abbr{border-bottom:1px var(--ds-border,#ccc)dotted;cursor:help}@supports (color-scheme:dark) and (color-scheme:light){[data-color-mode=light]{color-scheme:light}[data-color-mode=dark]{color-scheme:dark}}table{border-collapse:collapse;width:100%}thead,tbody,tfoot{border-bottom:2px solid var(--ds-border,#dfe1e6)}td,th{padding:var(--ds-space-050,4px)var(--ds-space-100,8px);text-align:left;border:none}th{vertical-align:top}td:first-child,style:first-child+td,th:first-child,style:first-child+th{padding-left:0}td:last-child,th:last-child{padding-right:0}caption{font:var(--ds-font-heading-medium,500 1.42857em/1.2 ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",Ubuntu,"Helvetica Neue",sans-serif);letter-spacing:-.008em;color:var(--ds-text);margin-top:28px;margin-bottom:var(--ds-space-100,8px);text-align:left}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section{display:block}@-moz-document url-prefix(){img{font-size:0}img:-moz-broken{font-size:inherit}}button{font-family:inherit}.assistive{clip:rect(1px,1px,1px,1px)!important;white-space:nowrap!important;border:0!important;width:1px!important;height:1px!important;padding:0!important;position:absolute!important;overflow:hidden!important}`;
document.querySelector('head').appendChild($24eaba0df287b1ab$var$style);

});


parcelRegister("7bkFJ", function(module, exports) {

$parcel$export(module.exports, "initPlatformFeatureFlags", () => $fef4d3d4b4c51b47$export$2d291317456ada16);

var $VSDnB = parcelRequire("VSDnB");

var $4R6GH = parcelRequire("4R6GH");

var $co1wz = parcelRequire("co1wz");
const $fef4d3d4b4c51b47$export$2d291317456ada16 = ([isOverride, resolver])=>{
    (0, $VSDnB.setBooleanFeatureFlagResolver)((flagKey)=>// disable existence check as platform feature >flags< might not be gates
        (0, $4R6GH.withoutFeatureExistenceCheck)(()=>isOverride(flagKey) ? resolver(flagKey) : (0, $4R6GH.fg)(flagKey) || (0, $co1wz.ff)(flagKey)));
};

});

parcelRegister("hL7JE", function(module, exports) {

$parcel$export(module.exports, "NonCritical", () => $c20017bf22691933$export$20fd89b1bf707b1a);
$parcel$export(module.exports, "default", () => $c20017bf22691933$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $6yXtV = parcelRequire("6yXtV");
const $c20017bf22691933$export$83d969795398ec56 = ({ children: children, timerThreshold: timerThreshold })=>{
    const [{ isReady: isReady }] = (0, $6yXtV.useSpaStatePageReady)();
    const [isFirstRun, setFirstRun] = (0, $5uXOq.useState)(true);
    const [hasThresholdTimerExpired, setHasThresholdTimerExpired] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (timerThreshold != null) setTimeout(()=>{
            setHasThresholdTimerExpired(true);
        }, timerThreshold);
    }, [
        timerThreshold
    ]);
    if (!isFirstRun || isReady || hasThresholdTimerExpired) {
        isFirstRun && setFirstRun(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    }
    return null;
};
const $c20017bf22691933$export$5b2f4b62d18632 = ({ id: id = 'non-critical-with-timer', teamName: teamName, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: id,
        teamName: teamName,
        packageName: "jiraPlatformNonCritical",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c20017bf22691933$export$83d969795398ec56, props));
/**
 * Delays rendering its children until the page is deemed ready, optimizing for a smoother initial load. Suitable for content that is not immediately necessary.
 */ const $c20017bf22691933$var$NonCriticalComponent = (props)=>{
    const [{ isReady: isReady }] = (0, $6yXtV.useSpaStatePageReady)();
    const [isFirstRun, setFirstRun] = (0, $5uXOq.useState)(true);
    if (!isFirstRun || isReady) {
        isFirstRun && setFirstRun(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children);
    }
    return null;
};
const $c20017bf22691933$export$20fd89b1bf707b1a = ({ id: id = 'non-critical', teamName: teamName, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: id,
        teamName: teamName,
        packageName: "jiraPlatformNonCritical",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c20017bf22691933$var$NonCriticalComponent, props));
var $c20017bf22691933$export$2e2bcd8739ae039 = $c20017bf22691933$var$NonCriticalComponent;

});
parcelRegister("6yXtV", function(module, exports) {

$parcel$export(module.exports, "useSpaStatePageReady", () => $44de65c7edb80809$export$ea2491906b753456);
$parcel$export(module.exports, "SpaStatePageReady", () => $44de65c7edb80809$export$c34439f945fccbdf);
$parcel$export(module.exports, "SpaStatePageReadyOnUpdate", () => $44de65c7edb80809$export$41e70078eeddaddc);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $3sQ5x = parcelRequire("3sQ5x");

var $4oDnX = parcelRequire("4oDnX");

var $7w9eZ = parcelRequire("7w9eZ");
const $44de65c7edb80809$export$e6897aa59ee7aee5 = ({ currentPage: currentPage })=>{
    const { apps: apps } = currentPage;
    const appIds = Object.keys(apps);
    return {
        isReady: appIds.length ? appIds.every((id)=>apps[id].endTime || apps[id].timeoutTime) : false
    };
};
const $44de65c7edb80809$export$ea2491906b753456 = (0, $3sQ5x.createHook)((0, $7w9eZ.default), {
    selector: $44de65c7edb80809$export$e6897aa59ee7aee5
});
const $44de65c7edb80809$export$c34439f945fccbdf = ()=>/* TODO - this should be using only the actions subscriber not state+actions subscriber */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4oDnX.SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
            op: setAppReady
        }));
const $44de65c7edb80809$export$41e70078eeddaddc = ({ comparer: comparer })=>/* TODO - this should be using only the actions subscriber not state+actions subscriber */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4oDnX.SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
            op: setAppReady,
            args: comparer
        }));

});


parcelRegister("kZBXc", function(module, exports) {

$parcel$export(module.exports, "Spa", () => $454974e68bcf078d$export$6d4069f4b64f7492);

var $5uXOq = parcelRequire("5uXOq");

var $gAeCk = parcelRequire("gAeCk");


var $2SVPM = parcelRequire("2SVPM");

var $4R6GH = parcelRequire("4R6GH");

var $jw1BZ = parcelRequire("jw1BZ");

var $erCTW = parcelRequire("erCTW");

var $erjJQ = parcelRequire("erjJQ");

var $j8O2d = parcelRequire("j8O2d");
const $454974e68bcf078d$var$FaviconService = ()=>{
    (0, $jw1BZ.useFaviconService)();
    return null;
};
const $454974e68bcf078d$export$6d4069f4b64f7492 = ({ baseUrl: baseUrl, locale: locale, messages: messages, isPrewarming: isPrewarming = false, Router: Router, routes: routes, routerLinkComponent: routerLinkComponent, initRoute: initRoute })=>{
    const pageContainerPerformanceTiming = (0, $5uXOq.useCallback)(()=>{
        (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)((0, $9ccbd88c704da1ef$export$21473105c510aacc), (0, $9ccbd88c704da1ef$export$59f83d43fe209319), (0, $9ccbd88c704da1ef$export$7114284ca03133ee), true, true);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $erCTW.PageContainer), {
        baseUrl: baseUrl,
        id: false ? 'jira.entry.ssr' : 'spa',
        locale: locale,
        messages: messages,
        Router: Router,
        routerLinkComponent: routerLinkComponent
    }, (0, $4R6GH.fg)('jira_frontend_memory_monitor') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8O2d.MemoryMonitor), null), (0, $4R6GH.fg)('blu-7193-new-jira-favicons') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($454974e68bcf078d$var$FaviconService, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: (0, $9ccbd88c704da1ef$export$7114284ca03133ee),
        onSet: pageContainerPerformanceTiming
    }), isPrewarming !== true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $erjJQ.Content), {
        initRoute: initRoute,
        routes: routes
    }));
};

});
parcelRegister("gAeCk", function(module, exports) {

$parcel$export(module.exports, "default", () => $5368db3a32c0eb20$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $x9xyg = parcelRequire("x9xyg");
const $5368db3a32c0eb20$var$PerformanceMark = ({ metricKey: metricKey, onSet: onSet })=>{
    const renderRef = (0, $5uXOq.useRef)(false);
    if (!renderRef.current) {
        renderRef.current = true;
        (0, $x9xyg.setMark)(metricKey);
        onSet && onSet();
    }
    return null;
};
var $5368db3a32c0eb20$export$2e2bcd8739ae039 = $5368db3a32c0eb20$var$PerformanceMark;

});

parcelRegister("jw1BZ", function(module, exports) {

$parcel$export(module.exports, "useFaviconService", () => $33c0fc45cd075240$export$c5544731c404c896);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $j8DrX = parcelRequire("j8DrX");

var $kJP8l = parcelRequire("kJP8l");

var $lpwtK = parcelRequire("lpwtK");

var $lODMY = parcelRequire("lODMY");

var $4mBQI = parcelRequire("4mBQI");

var $4Cuff = parcelRequire("4Cuff");

var $d2cna = parcelRequire("d2cna");

var $1nkes = parcelRequire("1nkes");

var $dyIVp = parcelRequire("dyIVp");
const $33c0fc45cd075240$export$f948ae143e35cfaf = 'ajs-fspage-favicon-prefixed';
const $33c0fc45cd075240$export$c9e8acb6bea47122 = 'ajs-fspage-favicon';
const $33c0fc45cd075240$export$7ef9895286e10387 = 'ajs-favicon-use-projecticon';
const $33c0fc45cd075240$var$useRouteGroup = (0, $lODMY.createRouterSelector)((state)=>state.route.group);
const $33c0fc45cd075240$var$getCustomFavicon = ()=>{
    // Some instances might not have the prefixed metadata key, so we fallback to the original key
    const faviconPath = (0, $4R6GH.fg)('hot-117083-blu-7193-custom-favicon-fix') ? (0, $j8DrX.default)($33c0fc45cd075240$export$f948ae143e35cfaf) || (0, $j8DrX.default)($33c0fc45cd075240$export$c9e8acb6bea47122) : (0, $j8DrX.default)($33c0fc45cd075240$export$f948ae143e35cfaf);
    // Check if favicon is default or custom by matching the image path with pattern "favicon.*.ico"
    if (faviconPath) {
        const imagePath = faviconPath.split('/').at(-1);
        const defaultFaviconPattern = /^favicon.*\.ico$/;
        if (imagePath && !defaultFaviconPattern.test(imagePath)) return faviconPath;
    }
    return null;
};
const $33c0fc45cd075240$export$c5544731c404c896 = false ? ()=>undefined : ()=>{
    const routeGroup = $33c0fc45cd075240$var$useRouteGroup();
    const { data: project } = (0, $lpwtK.useProject)();
    const isProjectFaviconEnabled = (0, $j8DrX.default)($33c0fc45cd075240$export$7ef9895286e10387) === 'true';
    const productName = (0, $kJP8l.useProductName)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const iconEle = document.querySelector("link[rel='shortcut icon']");
    // Keep a copy of the default favicon
    const defaultFavicon = (0, $5uXOq.useMemo)(()=>iconEle instanceof HTMLLinkElement ? iconEle.href : '', [
        iconEle
    ]);
    const customFavicon = $33c0fc45cd075240$var$getCustomFavicon();
    (0, $5uXOq.useEffect)(()=>{
        let faviconPath = defaultFavicon;
        if (routeGroup === 'assets' && (0, $4R6GH.fg)('assets_as_an_app_v2')) {
            // Assets is currently a specific set of routes, and doesn't exist as a separate "product" as per `productName`.
            // Assets is moving towards being a platform outside of Jira (rendering its own Bifrost app etc), so it doesn't
            // make sense to register it as a Jira sub-product.
            if (customFavicon && (0, $4R6GH.fg)('assets_nav_customisation_fix')) faviconPath = customFavicon;
            else faviconPath = (0, (/*@__PURE__*/$parcel$interopDefault($4mBQI)));
        } else if (isProjectFaviconEnabled && project) faviconPath = project.avatarUrl;
        else if (customFavicon) faviconPath = customFavicon;
        else if (productName === 'serviceDesk') faviconPath = (0, (/*@__PURE__*/$parcel$interopDefault($1nkes)));
        else if (productName === 'product-discovery') faviconPath = (0, (/*@__PURE__*/$parcel$interopDefault($d2cna)));
        else if (productName === 'customer-service') faviconPath = (0, (/*@__PURE__*/$parcel$interopDefault($dyIVp)));
        else if (productName === 'jira' || productName === 'core' || productName === 'software') faviconPath = (0, (/*@__PURE__*/$parcel$interopDefault($4Cuff)));
        if (iconEle instanceof HTMLLinkElement && (0, $4R6GH.fg)('blu-7193-new-jira-favicons')) iconEle.href = faviconPath;
        // Cleanup: Restore default favicon when component unmounts
        return ()=>{
            if (iconEle instanceof HTMLLinkElement && (0, $4R6GH.fg)('blu-7193-new-jira-favicons')) iconEle.href = defaultFavicon;
        };
    }, [
        routeGroup,
        productName,
        defaultFavicon,
        iconEle,
        customFavicon,
        isProjectFaviconEnabled,
        project
    ]);
};

});
parcelRegister("4mBQI", function(module, exports) {
module.exports = new URL("favicon-temp-assets.25c6fb39.png", import.meta.url).toString();

});

parcelRegister("4Cuff", function(module, exports) {
module.exports = new URL("favicon-temp-family.656d6159.png", import.meta.url).toString();

});

parcelRegister("d2cna", function(module, exports) {
module.exports = new URL("favicon-temp-jpd.0a166bf7.png", import.meta.url).toString();

});

parcelRegister("1nkes", function(module, exports) {
module.exports = new URL("favicon-temp-jsm.45cc4563.png", import.meta.url).toString();

});

parcelRegister("dyIVp", function(module, exports) {
module.exports = new URL("favicon-temp-csm.54dd99fd.png", import.meta.url).toString();

});


parcelRegister("erCTW", function(module, exports) {

$parcel$export(module.exports, "PageContainer", () => $a81b2dc7c8e9cabb$export$5f86df0ee0a255b5);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");

var $gAeCk = parcelRequire("gAeCk");

var $7CMCs = parcelRequire("7CMCs");

var $7XYc4 = parcelRequire("7XYc4");

var $14V0U = parcelRequire("14V0U");

var $g7crU = parcelRequire("g7crU");

var $jHXUj = parcelRequire("jHXUj");

var $aKiiD = parcelRequire("aKiiD");

var $cPiXk = parcelRequire("cPiXk");

var $3HwlS = parcelRequire("3HwlS");

var $dGkif = parcelRequire("dGkif");

var $iqLcb = parcelRequire("iqLcb");


var $16YKp = parcelRequire("16YKp");

var $gdvIN = parcelRequire("gdvIN");

var $gcFrw = parcelRequire("gcFrw");

var $cOwuh = parcelRequire("cOwuh");

var $iXVV6 = parcelRequire("iXVV6");

var $3Uek9 = parcelRequire("3Uek9");

var $ozeZW = parcelRequire("ozeZW");

var $2SVPM = parcelRequire("2SVPM");

var $4R6GH = parcelRequire("4R6GH");

var $cSD7y = parcelRequire("cSD7y");

var $lODMY = parcelRequire("lODMY");

var $17bH5 = parcelRequire("17bH5");

var $kQm4v = parcelRequire("kQm4v");

var $10qwl = parcelRequire("10qwl");

var $is3OJ = parcelRequire("is3OJ");

var $lmBAt = parcelRequire("lmBAt");

var $gmCnE = parcelRequire("gmCnE");

var $kc9FZ = parcelRequire("kc9FZ");

var $6DLIs = parcelRequire("6DLIs");

var $62C9r = parcelRequire("62C9r");

var $4s15Z = parcelRequire("4s15Z");

var $eF0qp = parcelRequire("eF0qp");

var $gxCm0 = parcelRequire("gxCm0");

var $jG2fI = parcelRequire("jG2fI");

var $lvpKt = parcelRequire("lvpKt");

var $cCEqp = parcelRequire("cCEqp");

var $jmzCL = parcelRequire("jmzCL");
const $a81b2dc7c8e9cabb$var$mainWrapperStyles = {
    root: "_4t3i1osq _1e0c1txw _2lx21bp4 _9beo1bgi",
    themedOld: "_11q7mmei _11q31r52",
    themed: "_11q7mmei _11q3ne5i"
};
/**
 * These test IDs are used in pollinator tests. Do not change lightly.
 */ const $a81b2dc7c8e9cabb$var$ROOT_TEST_ID = 'page-layout.root';
const $a81b2dc7c8e9cabb$var$MAIN_TEST_ID = 'page-layout.main';
/* IMPORTANT:
 * When making any changes to the Nav3 component, please ensure that you also make the same changes to the
 * Nav4 component. The feature flag used is part of the Navigation Refresh work and we need to ensure that
 * we do not introduce tech debt for the roll-out by only updating the current component that is due to be
 * removed.
 *
 * If you have any concerns or questions please reach out to the #jira-navigation channel. Thanks!
 */ const $a81b2dc7c8e9cabb$var$DefaultLayoutNav4Old = ({ children: children })=>{
    const [isChromeless] = (0, $14V0U.useIsChromeless)();
    const [isFullscreen] = (0, $g7crU.useIsFullscreen)();
    const { hasTheming: hasTheming } = (0, $3Uek9.useProjectTheme)();
    const { isEnabled: isJsmPackagingUpdatesEnabled } = (0, $16YKp.useBannerJsmPackagingUpdates)();
    const { isEnabled: isJsmGracePeriodBannerEnabled } = (0, $gdvIN.useJsmGracePeriodBanner)();
    const currentRoute = $a81b2dc7c8e9cabb$var$useRouterRoute();
    const isIssueOrSystemAdminPage = (0, $17bH5.isSystemNavPath)(currentRoute.path) || (0, $kQm4v.isIssuesNavPath)(currentRoute.path);
    const mainWrapper = (content)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.Main), {
            isFixed: true,
            testId: $a81b2dc7c8e9cabb$var$MAIN_TEST_ID
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $bwpsq.default)([
                $a81b2dc7c8e9cabb$var$mainWrapperStyles.root,
                hasTheming && !(0, $lmBAt.getIsSoftwareThemingM2Enabled)() && $a81b2dc7c8e9cabb$var$mainWrapperStyles.themedOld,
                hasTheming && (0, $lmBAt.getIsSoftwareThemingM2Enabled)() && $a81b2dc7c8e9cabb$var$mainWrapperStyles.themed
            ])
        }, isJsmGracePeriodBannerEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gcFrw.JSMGracePeriodBannerAsync), null), isJsmPackagingUpdatesEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOwuh.BannerJsmPackagingUpdateAsync), null), isIssueOrSystemAdminPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $10qwl.JiraTopBannerPlacement), null), content));
    const showBanner = !isChromeless && !isFullscreen;
    const showTopNav = !isChromeless && !isFullscreen;
    const showSidebar = !isChromeless && !isFullscreen;
    const showHorizontalNav = !isChromeless;
    const showRightSidebar = !isChromeless && !isFullscreen;
    const showLayoutRemoteStateUpdater = !isChromeless && !isFullscreen;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.PageLayout), {
        skipLinksLabel: "",
        testId: $a81b2dc7c8e9cabb$var$ROOT_TEST_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $is3OJ.IntegrationsWhichRequireNavigationRoot), null), !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dGkif.Nav4BenefitsModalTrigger), null), showBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "banner",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gmCnE.Banner), null)), showTopNav && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "top-nav",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gxCm0.TopNav), null)), showSidebar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "sidebar",
        packageName: "jiraPageContainerV2",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eF0qp.Sidebar), null)), mainWrapper(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, showHorizontalNav && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $62C9r.HorizontalNav), null), children)), showRightSidebar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "right-sidebar",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4s15Z.RightSidebar), null)), (0, $4R6GH.fg)('jira-glance-panel') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jG2fI.PreviewPanel), null), showLayoutRemoteStateUpdater && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: "jiraPageContainerV2",
        id: "layout-remote-state-updater",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jHXUj.LayoutRemoteStateUpdater), null)));
};
const $a81b2dc7c8e9cabb$var$DefaultLayoutNav4New = ({ children: children })=>{
    const [isChromeless] = (0, $14V0U.useIsChromeless)();
    const [isFullscreen] = (0, $g7crU.useIsFullscreen)();
    const showBanner = !isChromeless && !isFullscreen;
    const showTopNav = !isChromeless && !isFullscreen;
    const showSidebar = !isChromeless && !isFullscreen;
    const showHorizontalNav = !isChromeless;
    const showRightSidebar = !isChromeless && !isFullscreen;
    const showLayoutRemoteStateUpdater = !isChromeless && !isFullscreen;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.PageLayout), {
        skipLinksLabel: "",
        testId: $a81b2dc7c8e9cabb$var$ROOT_TEST_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $is3OJ.IntegrationsWhichRequireNavigationRoot), null), !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dGkif.Nav4BenefitsModalTrigger), null), showBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "banner",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gmCnE.Banner), null)), showTopNav && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "top-nav",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gxCm0.TopNav), null)), showSidebar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "sidebar",
        packageName: "jiraPageContainerV2",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eF0qp.Sidebar), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a81b2dc7c8e9cabb$var$MainWrapper, null, showHorizontalNav && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $62C9r.HorizontalNav), null), children), showRightSidebar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "right-sidebar",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4s15Z.RightSidebar), null)), (0, $4R6GH.fg)('jira-glance-panel') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jG2fI.PreviewPanel), null), showLayoutRemoteStateUpdater && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: "jiraPageContainerV2",
        id: "layout-remote-state-updater",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jHXUj.LayoutRemoteStateUpdater), null)));
};
function $a81b2dc7c8e9cabb$var$MainWrapper(props) {
    const { hasTheming: hasTheming } = (0, $3Uek9.useProjectTheme)();
    const { isEnabled: isJsmPackagingUpdatesEnabled } = (0, $16YKp.useBannerJsmPackagingUpdates)();
    const { isEnabled: isJsmGracePeriodBannerEnabled } = (0, $gdvIN.useJsmGracePeriodBanner)();
    const currentRoute = $a81b2dc7c8e9cabb$var$useRouterRoute();
    const isIssueOrSystemAdminPage = (0, $17bH5.isSystemNavPath)(currentRoute.path) || (0, $kQm4v.isIssuesNavPath)(currentRoute.path);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.Main), {
        isFixed: true,
        testId: $a81b2dc7c8e9cabb$var$MAIN_TEST_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $a81b2dc7c8e9cabb$var$mainWrapperStyles.root,
            hasTheming && !(0, $lmBAt.getIsSoftwareThemingM2Enabled)() && $a81b2dc7c8e9cabb$var$mainWrapperStyles.themedOld,
            hasTheming && (0, $lmBAt.getIsSoftwareThemingM2Enabled)() && $a81b2dc7c8e9cabb$var$mainWrapperStyles.themed
        ])
    }, isJsmGracePeriodBannerEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gcFrw.JSMGracePeriodBannerAsync), null), isJsmPackagingUpdatesEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOwuh.BannerJsmPackagingUpdateAsync), null), isIssueOrSystemAdminPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $10qwl.JiraTopBannerPlacement), null), props.children));
}
const $a81b2dc7c8e9cabb$var$DefaultLayoutNav4 = (0, $cSD7y.componentWithFG)('jgrose-stability-fixes-round-1', $a81b2dc7c8e9cabb$var$DefaultLayoutNav4New, $a81b2dc7c8e9cabb$var$DefaultLayoutNav4Old);
const $a81b2dc7c8e9cabb$var$DefaultLayoutNav3 = ({ children: children })=>{
    const HorizontalNavComponent = (0, $cPiXk.useHorizontalNavComponent)();
    const { isEnabled: isJsmPackagingUpdatesEnabled } = (0, $16YKp.useBannerJsmPackagingUpdates)();
    const { isEnabled: isJsmGracePeriodBannerEnabled } = (0, $gdvIN.useJsmGracePeriodBanner)();
    const currentRoute = $a81b2dc7c8e9cabb$var$useRouterRoute();
    const isIssueOrSystemAdminPage = (0, $17bH5.isSystemNavPath)(currentRoute.path) || (0, $kQm4v.isIssuesNavPath)(currentRoute.path);
    let contentChildren = isJsmPackagingUpdatesEnabled || isIssueOrSystemAdminPage || isJsmGracePeriodBannerEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), null, isJsmGracePeriodBannerEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gcFrw.JSMGracePeriodBannerAsync), null), isJsmPackagingUpdatesEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOwuh.BannerJsmPackagingUpdateAsync), null), isIssueOrSystemAdminPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $10qwl.JiraTopBannerPlacement), null), children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    if (HorizontalNavComponent != null) contentChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $62C9r.HorizontalNavWrapper), {
        navComponent: HorizontalNavComponent
    }, isJsmGracePeriodBannerEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gcFrw.JSMGracePeriodBannerAsync), null), isJsmPackagingUpdatesEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOwuh.BannerJsmPackagingUpdateAsync), null), isIssueOrSystemAdminPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $10qwl.JiraTopBannerPlacement), null), children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lvpKt.FullHeight), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.PageLayout), {
        skipLinksLabel: ""
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $is3OJ.IntegrationsWhichRequireNavigationRoot), null), !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dGkif.Nav4BenefitsModalTrigger), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "banner",
        packageName: "page-container",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gmCnE.Banner), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "top-nav",
        packageName: "page-container",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gxCm0.TopNav), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.LeftPanel), {
        width: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.Content), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "sidebar",
        packageName: "page-container",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eF0qp.Sidebar), null)), contentChildren, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "right-sidebar",
        packageName: "page-container",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4s15Z.RightSidebar), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: "page-container",
        id: "layout-remote-state-updater",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jHXUj.LayoutRemoteStateUpdater), null))));
};
const $a81b2dc7c8e9cabb$var$useRouterRoute = (0, $lODMY.createRouterSelector)((state)=>state.route);
const $a81b2dc7c8e9cabb$var$LayoutNav4 = (props)=>{
    const { LayoutOverrideComponent: LayoutOverrideComponent } = $a81b2dc7c8e9cabb$var$useRouterRoute();
    if (LayoutOverrideComponent !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LayoutOverrideComponent, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a81b2dc7c8e9cabb$var$DefaultLayoutNav4, props);
};
const $a81b2dc7c8e9cabb$var$LayoutNav3 = (props)=>{
    const { LayoutOverrideComponent: LayoutOverrideComponent } = $a81b2dc7c8e9cabb$var$useRouterRoute();
    if (LayoutOverrideComponent !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LayoutOverrideComponent, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a81b2dc7c8e9cabb$var$DefaultLayoutNav3, props);
};
const $a81b2dc7c8e9cabb$var$PageContainerNav4 = (props)=>{
    const { id: id, locale: locale, baseUrl: baseUrl, messages: messages, Router: Router, routerLinkComponent: routerLinkComponent } = props;
    const pageContainerPerformanceTiming = (0, $5uXOq.useCallback)(()=>{
        (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)((0, $9ccbd88c704da1ef$export$898b6208220685b0), (0, $9ccbd88c704da1ef$export$e2bc63118050de32), (0, $9ccbd88c704da1ef$export$59f83d43fe209319), true, false);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: (0, $9ccbd88c704da1ef$export$e2bc63118050de32)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6DLIs.GlobalContainers), {
        id: id,
        locale: locale,
        baseUrl: baseUrl,
        messages: messages,
        Router: Router,
        routerLinkComponent: routerLinkComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cCEqp.GlobalThemeSetter), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: (0, $9ccbd88c704da1ef$export$59f83d43fe209319),
        onSet: pageContainerPerformanceTiming
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "navigationNext"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jmzCL.ProjectThemeSetter), null), (0, $4R6GH.fg)('assets_as_an_app_kill_switch') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a81b2dc7c8e9cabb$var$DefaultLayoutNav4, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a81b2dc7c8e9cabb$var$LayoutNav4, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kc9FZ.GlobalComponents), {
        sharedGlobalComponents: (0, $ozeZW.sharedLayout).globalComponents
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aKiiD.GlobalBottomRightCornerContainer), null))));
};
/**
 * Serves as a comprehensive layout manager, orchestrating the assembly of global containers,
 * navigation components, and performance metrics into a cohesive page structure. It enhances user
 * interface by conditionally incorporating additional UI elements and ensures a uniform
 * appearance and behavior across pages through global styling. Moreover, it facilitates
 * performance optimization and analytics integration for improved user experience and
 * insights.
 */ const $a81b2dc7c8e9cabb$var$PageContainerNav3 = (props)=>{
    const { id: id, locale: locale, baseUrl: baseUrl, messages: messages, Router: Router, routerLinkComponent: routerLinkComponent } = props;
    const pageContainerPerformanceTiming = (0, $5uXOq.useCallback)(()=>{
        (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)((0, $9ccbd88c704da1ef$export$898b6208220685b0), (0, $9ccbd88c704da1ef$export$e2bc63118050de32), (0, $9ccbd88c704da1ef$export$59f83d43fe209319), true, false);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: (0, $9ccbd88c704da1ef$export$e2bc63118050de32)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6DLIs.GlobalContainers), {
        id: id,
        locale: locale,
        baseUrl: baseUrl,
        messages: messages,
        Router: Router,
        routerLinkComponent: routerLinkComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cCEqp.GlobalThemeSetter), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: (0, $9ccbd88c704da1ef$export$59f83d43fe209319),
        onSet: pageContainerPerformanceTiming
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "navigationNext"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jmzCL.ProjectThemeSetter), null), (0, $4R6GH.fg)('assets_as_an_app_kill_switch') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a81b2dc7c8e9cabb$var$DefaultLayoutNav3, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a81b2dc7c8e9cabb$var$LayoutNav3, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kc9FZ.GlobalComponents), {
        sharedGlobalComponents: (0, $ozeZW.sharedLayout).globalComponents
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aKiiD.GlobalBottomRightCornerContainer), null))));
};
const $a81b2dc7c8e9cabb$export$5f86df0ee0a255b5 = (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), $a81b2dc7c8e9cabb$var$PageContainerNav4, $a81b2dc7c8e9cabb$var$PageContainerNav3);

});
parcelRegister("14V0U", function(module, exports) {

$parcel$export(module.exports, "useIsChromeless", () => $96950c90e73fdad9$export$c88b74884f5222ba);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");

var $5e5zm = parcelRequire("5e5zm");
const $96950c90e73fdad9$export$c88b74884f5222ba = (0, $3sQ5x.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>state.isChromeless
});

});

parcelRegister("g7crU", function(module, exports) {

$parcel$export(module.exports, "useIsFullscreen", () => $aa937e51388f56fd$export$d397eccea5f37b0a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");

var $5e5zm = parcelRequire("5e5zm");
const $aa937e51388f56fd$export$d397eccea5f37b0a = (0, $3sQ5x.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>state.isFullscreen
});

});

parcelRegister("jHXUj", function(module, exports) {

$parcel$export(module.exports, "LayoutRemoteStateUpdater", () => $89937a782c6cb988$export$b9f3a70460995c32);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $7XYc4 = parcelRequire("7XYc4");

var $3HwlS = parcelRequire("3HwlS");

var $iqLcb = parcelRequire("iqLcb");


var $c34Wf = parcelRequire("c34Wf");

var $90yGq = parcelRequire("90yGq");

var $2YP9W = parcelRequire("2YP9W");

var $5e5zm = parcelRequire("5e5zm");

var $gPQRI = parcelRequire("gPQRI");

var $hsmeR = parcelRequire("hsmeR");

var $2TwSO = parcelRequire("2TwSO");
const $89937a782c6cb988$var$LayoutRemoteStateUpdaterOld = ()=>{
    // This prevents eccessive state updates on page loads
    const [initialLoad, setInitialLoad] = (0, $5uXOq.useState)(true);
    const [localLeftSidebarWidthState, setLocalLeftSidebarWidthState] = (0, $5uXOq.useState)();
    const [localLeftSidebarCollapsedState, setLocalLeftSidebarCollapsedState] = (0, $5uXOq.useState)();
    const [localRightSidebarState, setLocalRightSidebarState] = (0, $5uXOq.useState)();
    // left-sidebar
    const { leftSidebarState: leftSidebarState } = (0, $iqLcb.usePageLayoutResize)();
    const { isFlyoutOpen: isFlyoutOpen, isLeftSidebarCollapsed: isLeftSidebarCollapsed, leftSidebarWidth: leftSidebarWidth } = leftSidebarState;
    const resolvedLeftSidebarWidth = Math.max(leftSidebarWidth, (0, $5e5zm.DEFAULT_LEFT_SIDEBAR_WIDTH));
    const [, { setLeftSidebarState: setLeftSidebarState }] = (0, $5e5zm.useLayoutStoreActions)();
    const isCollapsed = leftSidebarState.isLeftSidebarCollapsed;
    // right-sidebar
    const rightSidebarState = (0, $hsmeR.useRightSidebarState)();
    const accountId = (0, $90yGq.useAccountId)();
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)((0, $c34Wf.navigationUiStateResource));
    const isLayoutStateReady = leftSidebarWidth !== 0 && leftSidebarState.lastLeftSidebarWidth !== 0;
    // compares local vs external state coming via chain of callbacks
    // to determine if we really need to send an update of layout state
    const sideBarChanged = (0, $5uXOq.useCallback)((externalLeftSidebarWidth, externalIsLeftSidebarCollapsed, externalRightSidebarState)=>{
        let changeDetected = false;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(externalLeftSidebarWidth, localLeftSidebarWidthState)) {
            setLocalLeftSidebarWidthState(externalLeftSidebarWidth);
            changeDetected = true;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(externalIsLeftSidebarCollapsed, localLeftSidebarCollapsedState)) {
            setLocalLeftSidebarCollapsedState(externalIsLeftSidebarCollapsed);
            changeDetected = true;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(externalRightSidebarState, localRightSidebarState)) {
            setLocalRightSidebarState(externalRightSidebarState);
            changeDetected = true;
        }
        return changeDetected;
    }, [
        localLeftSidebarCollapsedState,
        localLeftSidebarWidthState,
        localRightSidebarState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isLayoutStateReady) return;
        if (error) return;
        setLeftSidebarState({
            width: resolvedLeftSidebarWidth,
            isCollapsed: isCollapsed,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            isFlyoutOpen: isFlyoutOpen,
            isVisible: true
        });
    }, [
        error,
        isCollapsed,
        isFlyoutOpen,
        isLayoutStateReady,
        resolvedLeftSidebarWidth,
        setLeftSidebarState
    ]);
    const updateData = (0, $5uXOq.useCallback)(async ()=>{
        if (loading) return;
        if (error) return;
        if (!isLayoutStateReady) return;
        if (!sideBarChanged(resolvedLeftSidebarWidth, isLeftSidebarCollapsed, rightSidebarState)) return;
        const remoteData = {
            ...data,
            leftSidebar: {
                width: resolvedLeftSidebarWidth,
                isCollapsed: isLeftSidebarCollapsed
            },
            rightSidebar: rightSidebarState
        };
        if (accountId) try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8), JSON.stringify(remoteData));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $jcw0u.default)({
                error: e,
                meta: {
                    id: 'updateServerLayoutState',
                    packageName: 'jiraLayoutController',
                    teamName: 'magma'
                }
            });
        }
    }, [
        accountId,
        data,
        error,
        isLayoutStateReady,
        isLeftSidebarCollapsed,
        loading,
        resolvedLeftSidebarWidth,
        rightSidebarState,
        sideBarChanged
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (initialLoad) {
            setInitialLoad(false);
            setLocalLeftSidebarWidthState(resolvedLeftSidebarWidth);
            setLocalLeftSidebarCollapsedState(isLeftSidebarCollapsed);
            setLocalRightSidebarState(rightSidebarState);
        } else updateData();
    }, [
        isLeftSidebarCollapsed,
        resolvedLeftSidebarWidth,
        updateData,
        rightSidebarState,
        initialLoad
    ]);
    return null;
};
const $89937a782c6cb988$var$LayoutRemoteStateUpdaterNew = ()=>{
    const accountId = (0, $90yGq.useAccountId)();
    const leftSidebar = (0, $gPQRI.useLeftSidebarState)();
    const rightSidebar = (0, $hsmeR.useRightSidebarState)();
    const isLeftSidebarCollapsed = leftSidebar.isCollapsed;
    const leftSidebarWidth = leftSidebar.width;
    // This prevents eccessive state updates on page loads
    const [initialLoad, setInitialLoad] = (0, $5uXOq.useState)(true);
    const [localLeftSidebarWidthState, setLocalLeftSidebarWidthState] = (0, $5uXOq.useState)();
    const [localLeftSidebarCollapsedState, setLocalLeftSidebarCollapsedState] = (0, $5uXOq.useState)();
    const [localRightSidebarState, setLocalRightSidebarState] = (0, $5uXOq.useState)();
    // compares local vs external state coming via chain of callbacks
    // to determine if we really need to send an update of layout state
    const sideBarChanged = (0, $5uXOq.useCallback)((externalLeftSidebarWidth, externalIsLeftSidebarCollapsed, externalRightSidebarState)=>{
        let changeDetected = false;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(externalLeftSidebarWidth, localLeftSidebarWidthState)) {
            setLocalLeftSidebarWidthState(externalLeftSidebarWidth);
            changeDetected = true;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(externalIsLeftSidebarCollapsed, localLeftSidebarCollapsedState)) {
            setLocalLeftSidebarCollapsedState(externalIsLeftSidebarCollapsed);
            changeDetected = true;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(externalRightSidebarState, localRightSidebarState)) {
            setLocalRightSidebarState(externalRightSidebarState);
            changeDetected = true;
        }
        return changeDetected;
    }, [
        localLeftSidebarCollapsedState,
        localLeftSidebarWidthState,
        localRightSidebarState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!accountId) return;
        if (initialLoad) {
            setInitialLoad(false);
            setLocalLeftSidebarWidthState(leftSidebarWidth);
            setLocalLeftSidebarCollapsedState(isLeftSidebarCollapsed);
            setLocalRightSidebarState(rightSidebar);
            return;
        }
        if (!sideBarChanged(leftSidebarWidth, isLeftSidebarCollapsed, rightSidebar)) return;
        (0, $2TwSO.setRemoteLayoutState)({
            accountId: accountId,
            state: {
                rightSidebar: rightSidebar,
                leftSidebar: {
                    isCollapsed: isLeftSidebarCollapsed,
                    width: leftSidebarWidth
                }
            }
        });
    }, [
        accountId,
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        rightSidebar,
        initialLoad,
        sideBarChanged
    ]);
    return null;
};
const $89937a782c6cb988$export$b9f3a70460995c32 = (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), $89937a782c6cb988$var$LayoutRemoteStateUpdaterNew, $89937a782c6cb988$var$LayoutRemoteStateUpdaterOld);

});
parcelRegister("2TwSO", function(module, exports) {

$parcel$export(module.exports, "setRemoteLayoutState", () => $9d3e8b8a199ea341$export$ad53b565e6cd4261);

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

async function $9d3e8b8a199ea341$export$ad53b565e6cd4261({ accountId: accountId, state: state }) {
    try {
        await (0, $89SaW.setUserProperties)(accountId, (0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8), JSON.stringify(state));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $jcw0u.default)({
            error: e,
            meta: {
                id: 'updateServerLayoutState',
                packageName: 'jiraLayoutController',
                teamName: 'jfp-team'
            }
        });
    }
}

});


parcelRegister("aKiiD", function(module, exports) {

$parcel$export(module.exports, "GlobalBottomRightCornerContainer", () => $1ca472b9239dbdd7$export$715c8d5890c054bb);
$parcel$export(module.exports, "GlobalBottomRightCornerContainerProvider", () => $1ca472b9239dbdd7$export$1e86e3484191597c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $b71gk = parcelRequire("b71gk");

var $l8ruj = parcelRequire("l8ruj");

var $hxB2k = parcelRequire("hxB2k");

var $4R6GH = parcelRequire("4R6GH");

var $hvrWv = parcelRequire("hvrWv");

var $hsmeR = parcelRequire("hsmeR");

var $5e5zm = parcelRequire("5e5zm");
function $1ca472b9239dbdd7$export$e112b78171de7a6({ bottomOffset: bottomOffset, rightOffset: rightOffset }) {
    const [{ width: width }] = (0, $5e5zm.useDetailPanelWidth)();
    const rightSidebar = (0, $hsmeR.useActiveRightSidebarState)();
    const { registerBottomRightCornerContainer: registerBottomRightCornerContainer } = (0, $hvrWv.useBottomRightCornerActions)();
    const isSidebarOpen = rightSidebar && !rightSidebar.isCollapsed && !rightSidebar.isMinimised;
    const rightSidebarWidth = isSidebarOpen ? rightSidebar.width : 0;
    let rightSidebarOffset = 0;
    if (isSidebarOpen) rightSidebarOffset = rightSidebarWidth;
    /**
   * Preview panel also opens inside RightPanel and is resizable. And it has default width of 400px,
   * which is more than width of RightSidebar (386px)
   */ if ((0, $4R6GH.fg)('jira-glance-panel')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const panel = (0, $hxB2k.useCurrentPreviewPanel)();
        if (panel) rightSidebarOffset = panel.width;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1ca472b9239dbdd7$var$StyledContainer, {
        ref: registerBottomRightCornerContainer,
        "data-testid": "layout-controller.ui.bottom-right-corner.container.styled-container",
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            right: `calc(${width + rightOffset + rightSidebarOffset}px + ${"var(--ds-space-300, 24px)"})`,
            bottom: `calc(${"var(--ds-space-300, 24px)"} + ${bottomOffset}px)`
        }
    });
}
const $1ca472b9239dbdd7$export$715c8d5890c054bb = ({ bottomOffset: bottomOffset = 0, rightOffset: rightOffset = 0 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "bottom-right-corner-container",
        packageName: "jira-bottom-right-corner-controller"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1ca472b9239dbdd7$export$e112b78171de7a6, {
        bottomOffset: bottomOffset,
        rightOffset: rightOffset
    }));
const $1ca472b9239dbdd7$export$1e86e3484191597c = ({ children: children })=>{
    const container = (0, $hvrWv.useBottomRightCornerContainer)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "global-bottom-right-corner"
    }, container && children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1ca472b9239dbdd7$export$715c8d5890c054bb, null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1ca472b9239dbdd7$var$StyledContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reoewfl _18m9ewfl _kqsw1n9t _1e0c1txw _1pbyfjpv _4cvresu3 _lcxvglyw",
            __cmplp.className
        ])
    });
});
$1ca472b9239dbdd7$var$StyledContainer.displayName = 'StyledContainer';

});
parcelRegister("hxB2k", function(module, exports) {

$parcel$export(module.exports, "PreviewPanelsProvider", () => $4f5456be2093b82a$export$65ae37e9c61321f9);
$parcel$export(module.exports, "usePreviewPanelsActions", () => $4f5456be2093b82a$export$5f5debba1692bf40);
$parcel$export(module.exports, "useCurrentPreviewPanel", () => $4f5456be2093b82a$export$5351114e92b31bc6);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3akny = parcelRequire("3akny");
const $4f5456be2093b82a$var$noop = (props)=>{};
const $4f5456be2093b82a$export$f473d225913e225d = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $4f5456be2093b82a$var$previewPanelsReducer = (state, action)=>{
    switch(action.type){
        case 'SET_PANEL_WIDTH':
            return {
                ...state,
                width: action.width
            };
        case 'CLOSE':
            // Action explicitly called in order to close the active panel.
            action.onClose?.();
            return {
                ...(0, $3akny.initialState),
                width: state.width
            };
        case 'OPEN':
            // Action explicitly called in order to open a new panel.
            const { params: params } = action;
            // If the panel is already open, do nothing.
            if (state.panel?.id === params.panel.id) return state;
            // Close the active panel.
            state.onClose();
            // Open the new panel.
            params.onOpen?.();
            return {
                ...state,
                panel: params.panel,
                width: params.width ?? state.width,
                onOpen: params.onOpen || (0, $3akny.initialState).onOpen,
                onClose: params.onClose || (0, $3akny.initialState).onClose
            };
        default:
            return state;
    }
};
const $4f5456be2093b82a$export$65ae37e9c61321f9 = ({ onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, children: children })=>{
    const [state, dispatch] = (0, $5uXOq.useReducer)($4f5456be2093b82a$var$previewPanelsReducer, (0, $3akny.initialState));
    const setPanelWidth = (0, $5uXOq.useCallback)((width)=>{
        dispatch?.({
            type: 'SET_PANEL_WIDTH',
            width: width
        });
    }, [
        dispatch
    ]);
    const close = (0, $5uXOq.useCallback)((onClose)=>{
        dispatch?.({
            type: 'CLOSE',
            onClose: onClose
        });
        onPreviewPanelClose?.();
    }, [
        dispatch,
        onPreviewPanelClose
    ]);
    const open = (0, $5uXOq.useCallback)((params)=>{
        dispatch?.({
            type: 'OPEN',
            params: params
        });
        onPreviewPanelClose?.();
        onPreviewPanelOpen?.();
    }, [
        dispatch,
        onPreviewPanelClose,
        onPreviewPanelOpen
    ]);
    const context = (0, $5uXOq.useMemo)(()=>({
            state: state,
            open: open,
            close: close,
            setPanelWidth: setPanelWidth
        }), [
        state,
        open,
        close,
        setPanelWidth
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($4f5456be2093b82a$export$f473d225913e225d.Provider, {
        value: context,
        children: children
    });
};
const $4f5456be2093b82a$export$609db4be92d0fad8 = ()=>{
    const context = (0, $5uXOq.useContext)($4f5456be2093b82a$export$f473d225913e225d);
    return context;
};
const $4f5456be2093b82a$export$c68e55e6e77f3d5d = (panelId)=>{
    const context = $4f5456be2093b82a$export$609db4be92d0fad8();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
};
const $4f5456be2093b82a$export$5f5debba1692bf40 = ()=>{
    const context = $4f5456be2093b82a$export$609db4be92d0fad8();
    if (!context) return {
        open: $4f5456be2093b82a$var$noop,
        close: $4f5456be2093b82a$var$noop,
        setPanelWidth: $4f5456be2093b82a$var$noop
    };
    return {
        open: context.open,
        close: context.close,
        setPanelWidth: context.setPanelWidth
    };
};
const $4f5456be2093b82a$export$5351114e92b31bc6 = ()=>{
    const context = $4f5456be2093b82a$export$609db4be92d0fad8();
    if (context?.state.panel == null) return null;
    return {
        ...context.state.panel,
        width: context.state.width,
        setWidth: context.setPanelWidth
    };
};

});
parcelRegister("3akny", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $d56f0267b71817b6$export$d4c72bab9d6cc13a);
const $d56f0267b71817b6$export$d4c72bab9d6cc13a = {
    // Configured when opening a panel.
    panel: null,
    width: 400,
    onOpen: ()=>{},
    onClose: ()=>{}
};

});


parcelRegister("hvrWv", function(module, exports) {

$parcel$export(module.exports, "useBottomRightCornerContainer", () => $4dcd4c0b25ba3fd4$export$84542488b6b6c309);
$parcel$export(module.exports, "useBottomRightCornerActions", () => $4dcd4c0b25ba3fd4$export$de496fd0e0151c81);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");

var $5e5zm = parcelRequire("5e5zm");
const $4dcd4c0b25ba3fd4$export$84542488b6b6c309 = (0, $3sQ5x.createStateHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>state.bottomRightCorner.container
});
const $4dcd4c0b25ba3fd4$export$de496fd0e0151c81 = (0, $3sQ5x.createActionsHook)((0, $5e5zm.layoutStore));

});


parcelRegister("cPiXk", function(module, exports) {

$parcel$export(module.exports, "useHorizontalNavComponent", () => $2edc33969f533189$export$205771a0e64e4c7c);

var $5f2bR = parcelRequire("5f2bR");

var $2vSU6 = parcelRequire("2vSU6");

var $14V0U = parcelRequire("14V0U");

var $3HwlS = parcelRequire("3HwlS");

var $6jY6G = parcelRequire("6jY6G");

var $dAfqg = parcelRequire("dAfqg");

var $c1mlA = parcelRequire("c1mlA");

var $lODMY = parcelRequire("lODMY");

const $2edc33969f533189$export$965942f8308cd740 = (0, $lODMY.createRouterSelector)((state)=>(0, $c1mlA.BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES).has(state.query.config));
const $2edc33969f533189$export$205771a0e64e4c7c = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const { data: projectData } = (0, $dAfqg.useProjectContext)();
    const hasBoardSettingsPageQueryParam = $2edc33969f533189$export$965942f8308cd740();
    // chromeless mode is handled in page-container package with nav4
    if (!(0, $3HwlS.getWillShowNav4)()) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [isChromeless] = (0, $14V0U.useIsChromeless)();
        if (isChromeless) return null;
    }
    if (route.navigation?.horizontal == null) return null;
    // Shared horizontal navigation routes that currently live in business projects on prod
    // but we want to remove horizontal navigation on with the navigation redesign
    if (route.navigation.horizontal === (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba)) {
        if ((0, $3HwlS.getWillShowNav4)()) return null;
        switch(projectData?.projectType){
            case 0, $2vSU6.CORE_PROJECT:
                return 0, $5f2bR.AsyncHorizontalNavJira;
            default:
                return null;
        }
    }
    // Board settings pages should not show the horizontal nav.
    // This is a workaround due to the fact that the software CMP board/backlog pages share the same route name
    // as the board settings pages. This code should be removed once the board settings pages have
    // their own dedicated route names.
    if (route.group === 'classic-software' && hasBoardSettingsPageQueryParam && (0, $3HwlS.getWillShowNav4)()) return null;
    if (route.navigation.horizontal === (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)) switch(projectData?.projectType){
        case 0, $2vSU6.CORE_PROJECT:
            return 0, $5f2bR.AsyncHorizontalNavJira;
        case 0, $2vSU6.SOFTWARE_PROJECT:
            if ((0, $3HwlS.getWillShowNav4)()) return 0, $5f2bR.AsyncHorizontalNavJira;
            return null;
        default:
            return null;
    }
    // TODO: Remove this during jira_nav4 cleanup
    if ('onlyShowHorizontalOnNav4' in route.navigation && route.navigation.onlyShowHorizontalOnNav4) return (0, $3HwlS.getWillShowNav4)() ? route.navigation.horizontal : null;
    return route.navigation.horizontal;
};

});
parcelRegister("c1mlA", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_METRICS_HISTOGRAM", () => $4c8f71f257051803$export$128e24da52662cdd);
$parcel$export(module.exports, "BOARD_SETTINGS_ARTICLE_ID_CONFIG_DISABLE_SECTION", () => $4c8f71f257051803$export$efdecbe4c9f1cd2c);
$parcel$export(module.exports, "BOARD_SETTINGS_ARTICLE_SAC_URL_CONFIG_DISABLE_SECTION", () => $4c8f71f257051803$export$1154ed64d0d99951);
$parcel$export(module.exports, "BOARD_SETTINGS_ARTICLE_ID_CONFIG_DISABLE_SECTION_ANALYTICS_ID", () => $4c8f71f257051803$export$7cadd2a48a9ff918);
$parcel$export(module.exports, "DEFAULT_LEVEL_ONE_NAME", () => $4c8f71f257051803$export$a546b6d48878ce6f);
$parcel$export(module.exports, "BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES", () => $4c8f71f257051803$export$8cc83ae2b6885e0);
$parcel$export(module.exports, "boardSettingsQueryConfigParamValues", () => $4c8f71f257051803$export$a9ebdab56bd9c0c3);
$parcel$export(module.exports, "SETTINGS_CONFIG", () => $4c8f71f257051803$export$2a56ee2f9c41b5a7);
$parcel$export(module.exports, "EDIT_BOARD_CONFIG", () => $4c8f71f257051803$export$b893894941c14e43);
$parcel$export(module.exports, "ADMINISTER_PARENT_PROJECT", () => $4c8f71f257051803$export$d14d5a7c294329c5);
$parcel$export(module.exports, "USER_PICKER_PROJECT_PERMISSION_KEY", () => $4c8f71f257051803$export$1e63b013f0e45de0);
$parcel$export(module.exports, "ADMINISTER_PROJECT_PERMISSION_KEY", () => $4c8f71f257051803$export$68030ac1ea4abd4c);
$parcel$export(module.exports, "BACKLOG_FEATURE_KEY", () => $4c8f71f257051803$export$e1671d3447ddd5ad);
$parcel$export(module.exports, "SPRINTS_FEATURE_KEY", () => $4c8f71f257051803$export$46efc2c8d8106cff);
$parcel$export(module.exports, "FEATURE_ENABLED_STATUS", () => $4c8f71f257051803$export$a1046f102eae498);
const $4c8f71f257051803$export$128e24da52662cdd = '1000_1500_2000_2500_3000_4000';
const $4c8f71f257051803$export$efdecbe4c9f1cd2c = '2QE2xWf0TpDbYpk4oY9aQr';
const $4c8f71f257051803$export$1154ed64d0d99951 = 'https://support.atlassian.com/jira-software-cloud/docs/how-do-jira-permissions-work/';
const $4c8f71f257051803$export$7cadd2a48a9ff918 = `${$4c8f71f257051803$export$efdecbe4c9f1cd2c}.config-disabled-section.article.analytics`;
const $4c8f71f257051803$export$a546b6d48878ce6f = 'Epic';
const $4c8f71f257051803$var$INTERNAL_BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES = [
    'cardColors',
    'cardLayout',
    'columns',
    'default',
    'estimation',
    'filter',
    'swimlanes',
    'time',
    'timelineConfig',
    'quickFilters',
    'dateFields'
];
const $4c8f71f257051803$export$8cc83ae2b6885e0 = new Set($4c8f71f257051803$var$INTERNAL_BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES);
const $4c8f71f257051803$export$a9ebdab56bd9c0c3 = Object.fromEntries($4c8f71f257051803$var$INTERNAL_BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES.map((key)=>[
        key,
        key
    ]));
const $4c8f71f257051803$export$2a56ee2f9c41b5a7 = {
    default: {
        configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.filter,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isCalendarEnabled: isCalendarEnabled, isBoardEnabled: isBoardEnabled })=>isCalendarEnabled || isBoardEnabled,
        jswAllowed: true
    },
    filter: {
        configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.filter,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isCalendarEnabled: isCalendarEnabled, isBoardEnabled: isBoardEnabled })=>isCalendarEnabled || isBoardEnabled,
        jswAllowed: true
    },
    columns: {
        configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.columns,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isBoardEnabled: isBoardEnabled })=>isBoardEnabled,
        jswAllowed: true
    },
    swimlanes: {
        configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.swimlanes,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isBoardEnabled: isBoardEnabled })=>isBoardEnabled,
        jswAllowed: true
    },
    quickFilters: {
        configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.quickFilters,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isBoardEnabled: isBoardEnabled })=>isBoardEnabled,
        jswAllowed: true
    },
    cardColors: {
        configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.cardColors,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isBoardEnabled: isBoardEnabled })=>isBoardEnabled,
        jswAllowed: true
    },
    cardLayout: {
        configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.cardLayout,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isBoardEnabled: isBoardEnabled })=>isBoardEnabled,
        jswAllowed: true
    },
    estimation: {
        configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.estimation,
        userLocatedBoardAllowed: true,
        kanbanAllowed: false,
        isJsmFeatureVisible: ()=>false,
        jswAllowed: true
    },
    time: {
        configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.time,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ()=>false,
        jswAllowed: true
    },
    timelineConfig: {
        configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.timelineConfig,
        userLocatedBoardAllowed: false,
        kanbanAllowed: true,
        isJsmFeatureVisible: ()=>false,
        jswAllowed: true
    },
    dateFields: {
        configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.dateFields,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isCalendarEnabled: isCalendarEnabled })=>isCalendarEnabled,
        jswAllowed: false
    }
};
const $4c8f71f257051803$export$773ca4f5fb67778b = 60000;
const $4c8f71f257051803$export$b893894941c14e43 = 'EDIT_BOARD_CONFIG';
const $4c8f71f257051803$export$d14d5a7c294329c5 = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
'ADMINISTER_PARENT_PROJECT';
const $4c8f71f257051803$export$1e63b013f0e45de0 = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
'USER_PICKER';
const $4c8f71f257051803$export$68030ac1ea4abd4c = 'ADMINISTER';
const $4c8f71f257051803$export$e1671d3447ddd5ad = 'BACKLOG';
const $4c8f71f257051803$export$46efc2c8d8106cff = 'SPRINTS';
const $4c8f71f257051803$export$a1046f102eae498 = 'ENABLED';

});


parcelRegister("dGkif", function(module, exports) {

$parcel$export(module.exports, "Nav4BenefitsModalTrigger", () => $f0d6e2778aa5757f$export$b750743fcff63c29);

var $5uXOq = parcelRequire("5uXOq");

var $4mO32 = parcelRequire("4mO32");

var $7XluA = parcelRequire("7XluA");

var $cSD7y = parcelRequire("cSD7y");

var $5Mth6 = parcelRequire("5Mth6");

var $iL4aK = parcelRequire("iL4aK");
const $f0d6e2778aa5757f$export$b750743fcff63c29 = (0, $cSD7y.componentWithFG)('navx-481-jira-benefits-modal', $f0d6e2778aa5757f$var$Nav4BenefitsModalTriggerActual, (0, $5uXOq.Fragment));
function $f0d6e2778aa5757f$var$Nav4BenefitsModalTriggerActual({ testOverride: testOverride }) {
    const { shouldShowModal: shouldShowModal, setModalShown: setModalShown } = (0, $5Mth6.useBenefitsModal)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            onShow: ()=>setModalShown(true)
        }), [
        setModalShown
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $iL4aK.benefitsModalEntryPoint), entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        const shouldShow = shouldShowModal();
        // Determine if the modal should show
        if (testOverride || shouldShow) entryPointActions.load();
        else if (testOverride && !shouldShow) // Only unload during testing
        entryPointActions.unload();
    }, [
        testOverride,
        shouldShowModal,
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        // Required props for error JSErrorBoundary.
        id: "nav4-onboarding-benefits-modal-ep-container",
        entryPointReferenceSubject: entryPointReferenceSubject,
        // Props for the root component.
        runtimeProps: {},
        ...entryPointParams
    });
}

});
parcelRegister("5Mth6", function(module, exports) {

$parcel$export(module.exports, "useBenefitsModal", () => $1d5a09bc0eb77799$export$327bfa75bb9c0d3);

var $5uXOq = parcelRequire("5uXOq");

var $e0yJX = parcelRequire("e0yJX");

var $bSSG7 = parcelRequire("bSSG7");
const $1d5a09bc0eb77799$var$JIRA_NAV4_BENEFITS_MODAL_KEY = 'jiraNav4BenefitsModal';
const $1d5a09bc0eb77799$var$MODAL_DELAY = 171900000; // 47.75 hours
function $1d5a09bc0eb77799$export$327bfa75bb9c0d3(currentTime = Date.now()) {
    const [isModalShown, setModalShown] = (0, $5uXOq.useState)(false);
    const storage = (0, $bSSG7.createLocalStorageProvider)('jira-nav4-benefits-modal');
    const lastShown = Number(storage.get($1d5a09bc0eb77799$var$JIRA_NAV4_BENEFITS_MODAL_KEY) || 0);
    const shouldShowModal = (0, $5uXOq.useCallback)(()=>{
        const isModalDelayFinished = lastShown + $1d5a09bc0eb77799$var$MODAL_DELAY < currentTime;
        return (0, $e0yJX.getIsPhase1AdminStandardCohort)() && isModalDelayFinished;
    }, [
        currentTime,
        lastShown
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isModalShown) // Update the local storage
        storage.set($1d5a09bc0eb77799$var$JIRA_NAV4_BENEFITS_MODAL_KEY, Date.now());
    }, [
        isModalShown,
        storage
    ]);
    return {
        shouldShowModal: shouldShowModal,
        setModalShown: setModalShown
    };
}

});
parcelRegister("e0yJX", function(module, exports) {

$parcel$export(module.exports, "getIsPhase1AdminStandardCohort", () => $2a76068df7aa61e0$export$9faaaa89af778b63);

var $1i1R1 = parcelRequire("1i1R1");

var $4R6GH = parcelRequire("4R6GH");

var $hVa7e = parcelRequire("hVa7e");

var $8CVvd = parcelRequire("8CVvd");
function $2a76068df7aa61e0$export$9faaaa89af778b63() {
    return (0, $hVa7e.getWillShowNav4TenantOptIn)() && // This FG is only true for Admins
    (!(0, $1i1R1.getIsNav4TenantOptIn)() || (0, $8CVvd.getWillShowNav3)()) && (0, $4R6GH.fg)('jira_nav4_ga_phase-2-standard') // To be implemented
    ;
}

});
parcelRegister("hVa7e", function(module, exports) {

$parcel$export(module.exports, "getWillShowNav4TenantOptIn", () => $826ff2baf6864619$export$f0df1010850076cf);

var $4R6GH = parcelRequire("4R6GH");

var $1i1R1 = parcelRequire("1i1R1");

var $7ZQ0U = parcelRequire("7ZQ0U");
const $826ff2baf6864619$export$f0df1010850076cf = ()=>{
    if (!(0, $4R6GH.fg)('jira_nav4')) return false;
    // Previous stages were mutually exclusive. GA is not.
    // Therefore, we need to make sure the customer is not in another stage before showing tenant opt in.
    if ((0, $7ZQ0U.getIsInPreGaStage)()) return false;
    // Later GA phases eclipse earlier phases.
    if ((0, $4R6GH.fg)('jira_nav4_ga_phase-3') || (0, $4R6GH.fg)('jira_nav4_ga_phase-2') || (0, $4R6GH.fg)('jira_nav4_ga_phase-1-5')) return false;
    return (0, $4R6GH.fg)('jira_nav4_ga_phase-1') && (0, $1i1R1.getIsAdmin)();
};

});
parcelRegister("7ZQ0U", function(module, exports) {

$parcel$export(module.exports, "getIsInPreGaStage", () => $57f16b943396f007$export$a57a1aacc1a1fc6e);

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");
const $57f16b943396f007$export$a57a1aacc1a1fc6e = ()=>(0, $4R6GH.fg)('jira_nav4_dogfooding') || (0, $4R6GH.fg)('jira_nav4_eap') || (0, $4R6GH.fg)('jira_nav4_beta_existing-customers') || (0, $4R6GH.fg)('jira_nav4_beta_sandboxes') || (0, $6s1PB.expVal)('jira_nav4_beta_free-customers', 'willShowNav4', false) || (0, $6s1PB.expVal)('jira_nav4_beta_new-customers', 'willShowNav4', false) || (0, $6s1PB.expVal)('confluence_jira_nav4_new_customers', 'willShowNav4', false);

});




parcelRegister("iL4aK", function(module, exports) {

$parcel$export(module.exports, "benefitsModalEntryPoint", () => $acf75bec5910e72e$export$326866d1edcc87f5);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $acf75bec5910e72e$export$326866d1edcc87f5 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("4QGcR")).then(({ Nav4BenefitsModal: Nav4BenefitsModal })=>Nav4BenefitsModal), {
        moduleId: "104c29e0",
        moduleName: "Nav4BenefitsModal",
        priority: "interaction"
    }),
    getPreloadProps: ({ onShow: onShow })=>{
        return {
            extraProps: {
                onShow: onShow
            }
        };
    }
});

});
parcelRegister("4QGcR", function(module, exports) {

let $387cc210e77a16a7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $387cc210e77a16a7$var$load("fRURW").then(()=>parcelRequire('6AKc1'));

});



parcelRegister("16YKp", function(module, exports) {

$parcel$export(module.exports, "useBannerJsmPackagingUpdates", () => $32df9c26e8c82916$export$a0dde3f151a99607);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $6jY6G = parcelRequire("6jY6G");

var $dAfqg = parcelRequire("dAfqg");

var $gzrJT = parcelRequire("gzrJT");

var $90yGq = parcelRequire("90yGq");

var $l2Uy7 = parcelRequire("l2Uy7");
const $32df9c26e8c82916$export$a0dde3f151a99607 = ()=>{
    const currentRoute = (0, $6jY6G.useCurrentRoute)();
    const { data: project } = (0, $dAfqg.useProjectContext)();
    const accountId = (0, $90yGq.useAccountId)();
    const isServiceProject = project?.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);
    const isInJsmBoundary = (0, $5uXOq.useMemo)(()=>(0, $l2Uy7.isInJsmGlobalSettingsBoundary)(currentRoute.path) || isServiceProject, [
        isServiceProject,
        currentRoute.path
    ]);
    const { shouldShow: shouldShow, dismissAnnouncement: dismissAnnouncement } = (0, $gzrJT.useJsmRepackagingAnnouncementResource)(accountId);
    return (0, $5uXOq.useMemo)(()=>({
            isEnabled: isInJsmBoundary && shouldShow && (0, $4R6GH.fg)('jsm-packaging-pricing-changes-announcement'),
            dismissAnnouncement: dismissAnnouncement
        }), [
        dismissAnnouncement,
        isInJsmBoundary,
        shouldShow
    ]);
};

});
parcelRegister("gzrJT", function(module, exports) {

$parcel$export(module.exports, "useJsmRepackagingAnnouncementResource", () => $e073f4ec0b653e88$export$47d5fef12f2d184b);

var $5uXOq = parcelRequire("5uXOq");

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $hj0lE = parcelRequire("hj0lE");

const $e073f4ec0b653e88$var$getDataLoader = ()=>(parcelRequire("baAEr"));
const $e073f4ec0b653e88$export$750cb6ed3dfc6a3 = (0, $2M1hQ.createResource)({
    type: 'JSM_REPACKAGING_ANNOUNCEMENT',
    getKey: ()=>'JSM_REPACKAGING_ANNOUNCEMENT',
    getDataLoader: $e073f4ec0b653e88$var$getDataLoader,
    maxAge: Infinity
});
const $e073f4ec0b653e88$export$47d5fef12f2d184b = (accountId)=>{
    const { data: data, loading: loading, error: error, refresh: refresh, update: update } = (0, $2YP9W.useResource)($e073f4ec0b653e88$export$750cb6ed3dfc6a3);
    const loadingRef = (0, $5uXOq.useRef)(false);
    const errorRef = (0, $5uXOq.useRef)();
    const [userPropertiesError, setUserPropertiesError] = (0, $5uXOq.useState)();
    errorRef.current = userPropertiesError || error;
    const dismissAnnouncement = (0, $5uXOq.useCallback)(()=>{
        const announcementDismissState = {
            shouldShow: false
        };
        update(()=>({
                announcementDismissState: announcementDismissState
            }));
        if (accountId) {
            if (loadingRef.current) {
                const err = new Error('User properties is loading');
                (0, $jcw0u.default)({
                    meta: {
                        id: 'useOgConsolidationUserPreference-update',
                        packageName: 'jiraRouterResourcesJsmRepackagingAnnouncement',
                        teamName: '50cent'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
                setUserPropertiesError(err);
                return Promise.reject(err);
            }
            loadingRef.current = true;
            return (0, $89SaW.setUserProperties)(accountId, (0, $hj0lE.JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE_STORAGE_KEY), JSON.stringify(announcementDismissState)).catch((err)=>{
                setUserPropertiesError(new Error('Error occured while setting user properties'));
                (0, $jcw0u.default)({
                    meta: {
                        id: 'useOgConsolidationUserPreference-update',
                        packageName: 'jiraRouterResourcesJsmRepackagingAnnouncement',
                        teamName: '50cent'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }).finally(()=>{
                loadingRef.current = false;
            });
        }
    }, [
        accountId,
        update
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        refresh,
        error
    ]);
    return (0, $5uXOq.useMemo)(()=>{
        if (errorRef.current || loading || !data || !accountId) return {
            shouldShow: false,
            dismissAnnouncement: dismissAnnouncement
        };
        const { announcementDismissState: announcementDismissState } = data;
        if (!announcementDismissState) return {
            shouldShow: false,
            dismissAnnouncement: dismissAnnouncement
        };
        return {
            ...announcementDismissState,
            dismissAnnouncement: dismissAnnouncement
        };
    }, [
        loading,
        data,
        accountId,
        dismissAnnouncement
    ]);
};

});
parcelRegister("hj0lE", function(module, exports) {

$parcel$export(module.exports, "JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE_STORAGE_KEY", () => $4bad9f9efc7d29c0$export$d2137827dc00e559);
$parcel$export(module.exports, "DEFAULT_JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE", () => $4bad9f9efc7d29c0$export$341176bfdf8c92);
const $4bad9f9efc7d29c0$export$d2137827dc00e559 = 'jsm-repackaging-announcement-dismiss-state';
const $4bad9f9efc7d29c0$export$341176bfdf8c92 = {
    shouldShow: true
};

});

parcelRegister("baAEr", function(module, exports) {

let $821d0f117c8f3c9c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $821d0f117c8f3c9c$var$load("gwngz").then(()=>parcelRequire('lGYvJ'));

});


parcelRegister("l2Uy7", function(module, exports) {

$parcel$export(module.exports, "isInJsmGlobalSettingsBoundary", () => $257d172b6cc842a0$export$c28a66ae6d31a34b);
const $257d172b6cc842a0$var$jsmGlobalSettingsPages = [
    '/jira/settings/products/jira-service-management-configuration',
    '/jira/settings/products/jira-service-management-email-requests',
    '/jira/settings/products/servicedesk/customer-access',
    '/jira/settings/products/servicedesk/authentication',
    '/jira/settings/products/servicedesk/organizations',
    '/jira/settings/products/jira-service-management-incident-management-tools',
    '/jira/settings/products/jira-service-management-compliance',
    '/jira/settings/products/servicedesk/feature-usage'
];
const $257d172b6cc842a0$var$eocGlobalSettingsPages = [
    '/jira/settings/products/ops/roles',
    '/jira/settings/products/ops/role-assignment',
    '/jira/settings/products/ops/role-based-notifications',
    '/jira/settings/products/ops/jira-service-management-chatops-and-video-tools',
    '/jira/settings/products/ops/integrations',
    '/jira/settings/products/ops/heartbeats',
    '/jira/settings/products/ops/syncs',
    '/jira/settings/products/ops/policies',
    '/jira/settings/products/ops/maintenance',
    '/jira/settings/products/ops/escalation-policies',
    '/jira/settings/products/ops/incoming-call',
    '/jira/settings/products/ops/jira-service-management-audit-logs',
    '/jira/settings/products/ops/reports'
];
const $257d172b6cc842a0$var$isJsmGlobalSettingsPage = (route)=>$257d172b6cc842a0$var$jsmGlobalSettingsPages.includes(route);
const $257d172b6cc842a0$var$isEocGlobalSettingsPage = (route)=>$257d172b6cc842a0$var$eocGlobalSettingsPages.includes(route);
const $257d172b6cc842a0$export$c28a66ae6d31a34b = (route)=>$257d172b6cc842a0$var$isJsmGlobalSettingsPage(route) || $257d172b6cc842a0$var$isEocGlobalSettingsPage(route);

});


parcelRegister("gdvIN", function(module, exports) {

$parcel$export(module.exports, "useJsmGracePeriodBanner", () => $21b8da4492ff1311$export$cb2cdbdc1bcc9ace);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $6jY6G = parcelRequire("6jY6G");

var $dAfqg = parcelRequire("dAfqg");

var $l2Uy7 = parcelRequire("l2Uy7");
const $21b8da4492ff1311$export$cb2cdbdc1bcc9ace = ()=>{
    const currentRoute = (0, $6jY6G.useCurrentRoute)();
    const { data: project } = (0, $dAfqg.useProjectContext)();
    const isServiceProject = project?.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);
    const isInJsmBoundary = (0, $5uXOq.useMemo)(()=>(0, $l2Uy7.isInJsmGlobalSettingsBoundary)(currentRoute.path) || isServiceProject, [
        isServiceProject,
        currentRoute.path
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            isEnabled: isInJsmBoundary && (0, $4R6GH.fg)('jsm_gp_announcements_banner')
        }), [
        isInJsmBoundary
    ]);
};

});

parcelRegister("gcFrw", function(module, exports) {

$parcel$export(module.exports, "JSMGracePeriodBannerAsync", () => $83821a800456c1a1$export$5f656c66df6dad60);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $7CMCs = parcelRequire("7CMCs");

var $kxZPA = parcelRequire("kxZPA");

const $83821a800456c1a1$var$JSMGracePeriodBannerLazy = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("eF96H")).then((module)=>module.JSMGracePeriodBanner), {
    moduleId: "./src/packages/servicedesk/jsm-grace-period-banner/src/ui/index.tsx"
});
const $83821a800456c1a1$export$5f656c66df6dad60 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async.jsm-grace-period-banner",
        teamName: "Sequoia",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-jsm-grace-period-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($83821a800456c1a1$var$JSMGracePeriodBannerLazy, null)));
};

});
parcelRegister("eF96H", function(module, exports) {

let $aacbf57b09bd2a49$var$load = (parcelRequire("28QjX"))(4);
module.exports = $aacbf57b09bd2a49$var$load("6mLL6").then(()=>parcelRequire('5d8w6'));

});


parcelRegister("cOwuh", function(module, exports) {

$parcel$export(module.exports, "BannerJsmPackagingUpdateAsync", () => $5589b5a823eb55d2$export$76c6ab35aee49900);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $5589b5a823eb55d2$var$BannerTransition = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("ecsqi")).then((module)=>module.BannerJsmPackagingUpdate), {
    moduleId: "./src/packages/platform/ui/banners/jsm-packaging-updates/src/ui/banner/index.tsx"
});
const $5589b5a823eb55d2$export$76c6ab35aee49900 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-banner-jsm-packaging-updates",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5589b5a823eb55d2$var$BannerTransition, null));

});
parcelRegister("ecsqi", function(module, exports) {

let $a5683bee7bfeaf3b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a5683bee7bfeaf3b$var$load("kPH0z").then(()=>parcelRequire('kuFA7'));

});


parcelRegister("3Uek9", function(module, exports) {

$parcel$export(module.exports, "useProjectTheme", () => $241dc29db19bb69f$export$18084206b9430153);

var $5uXOq = parcelRequire("5uXOq");

var $lODMY = parcelRequire("lODMY");

var $l71WK = parcelRequire("l71WK");

var $5f2bR = parcelRequire("5f2bR");

var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");

var $8iyFV = parcelRequire("8iyFV");

var $cPiXk = parcelRequire("cPiXk");

var $3HwlS = parcelRequire("3HwlS");

var $a2e2Q = parcelRequire("a2e2Q");

var $lmBAt = parcelRequire("lmBAt");

var $e5wyW = parcelRequire("e5wyW");

var $11Wjp = parcelRequire("11Wjp");
const $241dc29db19bb69f$export$94f987aa4379ed89 = (0, $lODMY.createRouterSelector)((state)=>state.route.name);
const $241dc29db19bb69f$export$89f90ea8776fdb88 = (0, $lODMY.createRouterSelector)((state)=>state.route.group);
const $241dc29db19bb69f$export$4747cad4fc91185 = (0, $lODMY.createRouterSelector)((state)=>state.match.params);
const $241dc29db19bb69f$var$defaultProjectTheme = {
    hasTheming: false,
    hasProjectViewNavigation: false,
    isInset: false
};
const $241dc29db19bb69f$export$25cf5728a2514195 = ()=>{
    const routeName = $241dc29db19bb69f$export$94f987aa4379ed89();
    const routeGroup = $241dc29db19bb69f$export$89f90ea8776fdb88();
    const HorizontalNavComponent = (0, $cPiXk.useHorizontalNavComponent)();
    const { hasSoftwareTheming: hasSoftwareTheming, isSoftwareFullTheming: isSoftwareFullTheming, isSoftwareProject: isSoftwareProject } = (0, $lmBAt.getIsSoftwareThemingEnabled)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $a2e2Q.useSoftwareProjectTheming)() : {
        hasSoftwareTheming: false,
        isSoftwareFullTheming: false,
        isSoftwareProject: false
    };
    const isBusinessRouteGroup = routeGroup === 'classic-business';
    // eslint-disable-next-line no-nested-ternary
    const hasProjectViewNavigation = (0, $3HwlS.getWillShowNav4)() ? HorizontalNavComponent != null : (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? HorizontalNavComponent === (0, $5f2bR.AsyncHorizontalNavJira) || HorizontalNavComponent === (0, $l71WK.AsyncHorizontalOverviewNav) || HorizontalNavComponent === (0, $8iyFV.AsyncHorizontalNavPlans) : HorizontalNavComponent === (0, $5f2bR.AsyncHorizontalNavJira) || HorizontalNavComponent === (0, $l71WK.AsyncHorizontalOverviewNav);
    let hasTheming;
    if ((0, $3HwlS.getWillShowNav4)()) {
        const isSoftwareCalendarRoute = routeName === 'software-calendar' || routeName === 'software-calendar-classic';
        if (isSoftwareCalendarRoute && !(0, $lmBAt.getIsSoftwareThemingM2Enabled)()) // remove this condition completely on m2 exp cleanup
        hasTheming = false;
        else if (isSoftwareProject) hasTheming = hasSoftwareTheming;
        else hasTheming = HorizontalNavComponent === (0, $5f2bR.AsyncHorizontalNavJira) || HorizontalNavComponent === (0, $l71WK.AsyncHorizontalOverviewNav) || routeName === 'issue';
    } else hasTheming = hasProjectViewNavigation;
    // Routes showing a themed inset layout are:
    // - all routes with the business project view navigation
    // - select software routes with contoured theming
    // - except for the routes with business group (as they already cater for the theme)
    const isInset = hasTheming && !isBusinessRouteGroup && !isSoftwareFullTheming;
    return {
        isInset: isInset,
        hasTheming: hasTheming,
        hasProjectViewNavigation: hasProjectViewNavigation
    };
};
const $241dc29db19bb69f$var$useProjectThemeSimplified = ()=>{
    const routeName = $241dc29db19bb69f$export$94f987aa4379ed89();
    const routeGroup = $241dc29db19bb69f$export$89f90ea8776fdb88();
    const isBusinessProject = (0, $11Wjp.BUSINESS_PROJECT_THEMED_ROUTES).has(routeName);
    const { allThemedSoftwareProjectRoutes: allThemedSoftwareProjectRoutes } = (0, $a2e2Q.getSoftwareThemedRoutes)();
    const isSoftwareProject = allThemedSoftwareProjectRoutes.has(routeName);
    const isIssueView = routeName === 'issue';
    const isBusinessRouteGroup = routeGroup === 'classic-business';
    const { hasSoftwareTheming: hasSoftwareTheming, isSoftwareFullTheming: isSoftwareFullTheming } = (0, $lmBAt.getIsSoftwareThemingEnabled)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $a2e2Q.useSoftwareProjectTheming)() : {
        hasSoftwareTheming: false,
        isSoftwareFullTheming: false
    };
    return (0, $5uXOq.useMemo)(()=>{
        if (isIssueView) return {
            hasTheming: true,
            hasProjectViewNavigation: false,
            isInset: true
        };
        if (!isBusinessProject && !isSoftwareProject) return $241dc29db19bb69f$var$defaultProjectTheme;
        // Remove this if clause once when cleaning up getIsSoftwareThemingEnabled
        // Will would get contoured theming on project pages if we don't have this check
        if ((0, $11Wjp.SHARED_THEMED_ROUTES).has(routeName)) {
            if (routeName === 'project-pages') return {
                hasTheming: true,
                hasProjectViewNavigation: true,
                isInset: false
            };
            return {
                hasTheming: true,
                hasProjectViewNavigation: true,
                isInset: true
            };
        }
        if (isSoftwareProject) {
            if (!(0, $lmBAt.getIsSoftwareThemingEnabled)()) return $241dc29db19bb69f$var$defaultProjectTheme;
            const isSoftwareCalendarRoute = routeName === 'software-calendar' || routeName === 'software-calendar-classic';
            if (isSoftwareCalendarRoute && !(0, $lmBAt.getIsSoftwareThemingM2Enabled)()) return {
                hasTheming: false,
                hasProjectViewNavigation: true,
                isInset: false
            };
            return {
                hasTheming: hasSoftwareTheming,
                hasProjectViewNavigation: true,
                isInset: hasSoftwareTheming && !isSoftwareFullTheming
            };
        }
        if (isBusinessProject) {
            const hasProjectViewNavigation = (0, $11Wjp.BUSINESS_PROJECT_THEMED_ROUTES).has(routeName);
            const hasTheming = hasProjectViewNavigation;
            const isInset = hasTheming && !isBusinessRouteGroup;
            return {
                hasTheming: hasTheming,
                hasProjectViewNavigation: hasProjectViewNavigation,
                isInset: isInset
            };
        }
        return $241dc29db19bb69f$var$defaultProjectTheme;
    }, [
        isIssueView,
        isBusinessProject,
        isSoftwareProject,
        routeName,
        isBusinessRouteGroup,
        hasSoftwareTheming,
        isSoftwareFullTheming
    ]);
};
const $241dc29db19bb69f$export$18084206b9430153 = (0, $e5wyW.functionWithCondition)(()=>(0, $3HwlS.getWillShowNav4)() && (0, $6s1PB.expVal)('performance_improvement_in_use_project_theme', 'isEnabled', false), $241dc29db19bb69f$var$useProjectThemeSimplified, $241dc29db19bb69f$export$25cf5728a2514195);

});
parcelRegister("11Wjp", function(module, exports) {

$parcel$export(module.exports, "SHARED_THEMED_ROUTES", () => $e0a4c3985ab98b65$export$6e841237e4270ee5);
$parcel$export(module.exports, "BUSINESS_PROJECT_THEMED_ROUTES", () => $e0a4c3985ab98b65$export$92da73f6b515b9da);
const $e0a4c3985ab98b65$export$6e841237e4270ee5 = new Set([
    'project-components',
    'project-pages'
]);
const $e0a4c3985ab98b65$export$92da73f6b515b9da = new Set([
    'classic-business-approvals',
    'classic-business-overview-calendar',
    'classic-business-sample-onboarding',
    'classic-business-form-submit',
    'classic-business-reports-overview',
    'classic-business-overview-summary',
    'classic-business-view-not-found',
    'classic-business-form-submit-public',
    'classic-business-shortcut',
    'classic-business-form-builder',
    'classic-business-form',
    'classic-business-timeline',
    'classic-business-attachments',
    'classic-business-overview-redirect',
    'classic-business-redirect',
    'classic-business-list',
    'classic-business-board',
    'classic-business-calendar',
    'classic-business-overview-timeline',
    'classic-business-summary',
    'issue-navigator-core',
    'classic-business-archived-work-items',
    ...$e0a4c3985ab98b65$export$6e841237e4270ee5
]);

});


parcelRegister("ozeZW", function(module, exports) {

$parcel$export(module.exports, "sharedLayout", () => $1e4b0a2f1ef777fb$export$5f4dc7c98070d93e);

var $5uXOq = parcelRequire("5uXOq");

var $doxsH = parcelRequire("doxsH");

var $2vSU6 = parcelRequire("2vSU6");

var $gmGW3 = parcelRequire("gmGW3");

var $8NA5p = parcelRequire("8NA5p");

var $7kqCT = parcelRequire("7kqCT");

var $jjA6o = parcelRequire("jjA6o");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $7N30e = parcelRequire("7N30e");

var $6s1PB = parcelRequire("6s1PB");

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $hfZX4 = parcelRequire("hfZX4");

var $7Lkcv = parcelRequire("7Lkcv");

var $9YvQF = parcelRequire("9YvQF");

var $km1Z8 = parcelRequire("km1Z8");

var $lpwtK = parcelRequire("lpwtK");

var $jElqQ = parcelRequire("jElqQ");

var $kKa8l = parcelRequire("kKa8l");

var $bmetd = parcelRequire("bmetd");

var $izgL1 = parcelRequire("izgL1");

var $lyCmi = parcelRequire("lyCmi");

var $aPfsS = parcelRequire("aPfsS");

var $kgLzl = parcelRequire("kgLzl");

var $dYRe6 = parcelRequire("dYRe6");

var $koeKL = parcelRequire("koeKL");

var $9yehD = parcelRequire("9yehD");

var $dz0Q5 = parcelRequire("dz0Q5");

var $4p6rw = parcelRequire("4p6rw");

var $kxZPA = parcelRequire("kxZPA");

var $iB3m4 = parcelRequire("iB3m4");

var $6g75y = parcelRequire("6g75y");

var $9OXo1 = parcelRequire("9OXo1");

var $6xesd = parcelRequire("6xesd");

var $kkNtb = parcelRequire("kkNtb");

var $38EzX = parcelRequire("38EzX");

var $lDu2T = parcelRequire("lDu2T");

var $jnXgM = parcelRequire("jnXgM");

var $is3OJ = parcelRequire("is3OJ");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1e4b0a2f1ef777fb$var$Global = (0, $kxZPA.lazy)(()=>(parcelRequire("294jg")), {
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/global/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1e4b0a2f1ef777fb$var$Navigation = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("3dzqg")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/navigation/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1e4b0a2f1ef777fb$var$Trackers = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("50m1B")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/trackers/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1e4b0a2f1ef777fb$var$RemoteActions = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("a0TZk")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/remote-actions/index.tsx"
});

// No need for a whole chunk for a single component
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1e4b0a2f1ef777fb$var$AfterPaintIssuePreEval = (0, $kxZPA.lazyAfterPaint)(/* eslint-disable-next-line jira/import/webpack-magic-comment-entries */ ()=>(parcelRequire("emOTQ")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/after-paint-issue-preeval/AfterPaintIssuePreEval.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1e4b0a2f1ef777fb$var$AsyncBrowserStorageControlsInit = (0, $kxZPA.lazy)(()=>(parcelRequire("kS27v")).then(({ BrowserStorageControlsInit: BrowserStorageControlsInit })=>BrowserStorageControlsInit), {
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/browser-storage-controls-init/index.tsx"
});
const $1e4b0a2f1ef777fb$var$runtimeProps = {};
const $1e4b0a2f1ef777fb$var$entryPointParams = {};
const $1e4b0a2f1ef777fb$export$3859d35c5447350b = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $kgLzl.rovoVideoModalEntryPoint), $1e4b0a2f1ef777fb$var$entryPointParams);
    const { atlassianAccountId: atlassianAccountId, cloudId: cloudId, isAnonymous: isAnonymous } = (0, $9OXo1.useTenantContext)();
    const { loading: loadingProject, data: project } = (0, $lpwtK.useProject)();
    const projectType = (0, $2vSU6.toProjectType)(project?.type);
    const { start: messageStarted } = (0, $6xesd.useCoordinationClient)();
    const rovoEntitlement = (0, $kkNtb.useRovoEntitlementResource)();
    const isRovoLLMEnabled = !!rovoEntitlement?.data?.isRovoLLMEnabled;
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        const shouldShowRovoVideoModal = async ()=>{
            const hasSeenRovoOnboarding = await (0, $6g75y.getRovoVideoOnboardingHash)(atlassianAccountId);
            if (// eslint-disable-next-line jira/ff/no-preconditioning
            !loadingProject && (0, $iB3m4.isJiraSoftware)(projectType) && (0, $4R6GH.fg)('rovo_video_player_gate') && !hasSeenRovoOnboarding && !isAnonymous && isRovoLLMEnabled) {
                const hasMessageStarted = await messageStarted();
                if (hasMessageStarted) entryPointActions.load();
            }
        };
        shouldShowRovoVideoModal();
    }, [
        atlassianAccountId,
        cloudId,
        entryPointActions,
        isAnonymous,
        loadingProject,
        messageStarted,
        projectType,
        isRovoLLMEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "growth.rovoVideoPlayer",
        packageName: "rovo-video-modal",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: null,
        runtimeProps: $1e4b0a2f1ef777fb$var$runtimeProps
    });
};
const $1e4b0a2f1ef777fb$export$39abefd31dfea2bd = ()=>{
    const { data: project } = (0, $lpwtK.useProject)();
    const projectId = String(project?.id);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yehD.AsyncTrialSprintBoardModalEntryPoint), {
        currentProjectId: projectId
    });
};
const $1e4b0a2f1ef777fb$export$bb0d8fff645668ce = ()=>{
    const cloudID = (0, $koeKL.useCloudId)();
    const { data: project } = (0, $lpwtK.useProject)();
    const projectType = (0, $2vSU6.toProjectType)(project?.type) || null;
    const productKey = (0, $2vSU6.projectTypeToCanonicalId)(projectType);
    const deferEditionModalEntryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudID,
            productKey: productKey
        }), [
        cloudID,
        productKey
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $7kqCT.jiraDeferEditionModalEntryPoint), deferEditionModalEntryPointParams);
    const onComplete = (0, $5uXOq.useCallback)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8NA5p.AsyncDeferEditionEPCheckWrapper), {
        onComplete: onComplete
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "growth.jiraDeferEditionModal",
        packageName: "jira-defer-edition-modal",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: null,
        runtimeProps: $1e4b0a2f1ef777fb$var$runtimeProps
    }));
};
const $1e4b0a2f1ef777fb$var$EndOfTrialModalEntryPoint = ()=>{
    const hasLoaded = (0, $5uXOq.useRef)(false);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $jjA6o.endOfTrialExtensionEntryPoint), {});
    if (!hasLoaded.current) {
        hasLoaded.current = true;
        entryPointActions.load();
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "growth.endOfTrialExtension",
        packageName: "jira-end-of-trial-extension",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: null,
        runtimeProps: $1e4b0a2f1ef777fb$var$runtimeProps
    });
};
const $1e4b0a2f1ef777fb$var$DeferEditionModal = (0, $cSD7y.componentWithFG)('cross-flow-defer-edition-communication-gate', $1e4b0a2f1ef777fb$export$bb0d8fff645668ce, ()=>null);
const $1e4b0a2f1ef777fb$var$DeferRovoVideoModal = (0, $cSD7y.componentWithFG)('rovo_video_player_gate', $1e4b0a2f1ef777fb$export$3859d35c5447350b, ()=>null);
const $1e4b0a2f1ef777fb$var$DeferTrialSprintBoardModal = (0, $cSD7y.componentWithFG)('jsw-trial-sprint-board-modal-gate-v2', $1e4b0a2f1ef777fb$export$39abefd31dfea2bd, ()=>null);
const $1e4b0a2f1ef777fb$var$AsyncRecommendPremiumToStandardModal = (0, $cSD7y.componentWithFG)('recommend_standard_in_jira_eot_shared_layout_', (0, $lyCmi.AsyncRecommendPremiumToStandardModalWrapper), ()=>null);
const $1e4b0a2f1ef777fb$var$ConditionalEndOfTrialExtensionModal = (0, $cSD7y.componentWithFG)('end_of_trial_extension_kill_switch', $1e4b0a2f1ef777fb$var$EndOfTrialModalEntryPoint, ()=>null);
$1e4b0a2f1ef777fb$var$DeferEditionModal.displayName = 'DeferEditionModal';
$1e4b0a2f1ef777fb$var$DeferRovoVideoModal.displayName = 'DeferRovoVideoModal';
$1e4b0a2f1ef777fb$var$DeferTrialSprintBoardModal.displayName = 'DeferTrialSprintBoardModal';
$1e4b0a2f1ef777fb$var$AsyncRecommendPremiumToStandardModal.displayName = 'AsyncRecommendPremiumToStandardModal';
$1e4b0a2f1ef777fb$var$ConditionalEndOfTrialExtensionModal.displayName = 'ConditionalEndOfTrialExtensionModal';
const $1e4b0a2f1ef777fb$var$sharedGlobalComponents = [
    ...false ? [] : [
        (0, $kKa8l.MatchedRouteListener),
        (0, $bmetd.PreviousRouterStateListener),
        (0, $lDu2T.LoadingPhaseManager),
        (0, $hfZX4.LoadingBarUIController),
        (0, $doxsH.default),
        (0, $38EzX.BreadcrumbAdapter),
        (0, $izgL1.default),
        (0, $jElqQ.PageDwellAnalyticsListener),
        (0, $km1Z8.ImperativeAPI),
        (0, $jnXgM.TrackClicksBeforeTTI),
        (0, $dYRe6.default),
        (0, $dz0Q5.AsyncUpflowIframeComponent),
        (0, $4p6rw.JiraHeritageLoader),
        $1e4b0a2f1ef777fb$var$AsyncBrowserStorageControlsInit,
        (0, $7N30e.default),
        $1e4b0a2f1ef777fb$var$RemoteActions,
        $1e4b0a2f1ef777fb$var$DeferEditionModal,
        $1e4b0a2f1ef777fb$var$DeferRovoVideoModal,
        $1e4b0a2f1ef777fb$var$DeferTrialSprintBoardModal,
        $1e4b0a2f1ef777fb$var$AsyncRecommendPremiumToStandardModal,
        $1e4b0a2f1ef777fb$var$ConditionalEndOfTrialExtensionModal,
        // Integrations - Issue View Modal, Create Project Drawer & Create dashboard modal
        (0, $is3OJ.Integrations)
    ],
    $1e4b0a2f1ef777fb$var$Global,
    $1e4b0a2f1ef777fb$var$Navigation,
    $1e4b0a2f1ef777fb$var$Trackers,
    $1e4b0a2f1ef777fb$var$AfterPaintIssuePreEval
];
const $1e4b0a2f1ef777fb$var$SafeEmbeddedConfluencePanelWithExperiments = ()=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_issue_view_side_by_side_modeless_ep_exp');
    return expConfig.get('cohort', 'not-enrolled') === 'experiment' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9YvQF.SafeEmbeddedConfluencePanel), null) : null;
};
const $1e4b0a2f1ef777fb$export$5f4dc7c98070d93e = (0, $aPfsS.createLayout)({
    rightSidebars: [
        (0, $7Lkcv.SafeHelpPanel),
        (0, $gmGW3.SafeConversationAssistantPanel),
        $1e4b0a2f1ef777fb$var$SafeEmbeddedConfluencePanelWithExperiments
    ],
    globalComponents: $1e4b0a2f1ef777fb$var$sharedGlobalComponents
});

});
parcelRegister("doxsH", function(module, exports) {

$parcel$export(module.exports, "default", () => $899e926f09852ef7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $90yGq = parcelRequire("90yGq");

var $1NZBJ = parcelRequire("1NZBJ");
const $899e926f09852ef7$var$CacheRegistry = ()=>{
    const accountIdLoggedInUser = (0, $90yGq.useAccountId)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $1NZBJ.default).set(accountIdLoggedInUser ?? 'anonymous');
    }, [
        accountIdLoggedInUser
    ]);
    return null;
};
var $899e926f09852ef7$export$2e2bcd8739ae039 = $899e926f09852ef7$var$CacheRegistry;

});
parcelRegister("1NZBJ", function(module, exports) {

$parcel$export(module.exports, "CACHE_PREFIX", () => $e0fd77b45718946f$export$69ca515e4489d790);
$parcel$export(module.exports, "scopeGuard", () => $e0fd77b45718946f$export$653cd03438bb0386);
$parcel$export(module.exports, "default", () => $e0fd77b45718946f$export$2e2bcd8739ae039);

var $bSSG7 = parcelRequire("bSSG7");
let $e0fd77b45718946f$var$resolveCachePromise;
const $e0fd77b45718946f$var$cachePromise = new Promise((resolve)=>{
    $e0fd77b45718946f$var$resolveCachePromise = resolve;
});
const $e0fd77b45718946f$export$27be962d708928a = '__scope_key__';
const $e0fd77b45718946f$export$69ca515e4489d790 = 'cache_prefix';
const $e0fd77b45718946f$var$TIMEOUT = 10000;
const $e0fd77b45718946f$var$promiseWithMaxExecutionTime = (ms, promise)=>{
    let id;
    const timeout = new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (resolve, reject)=>{
        id = setTimeout(()=>{
            const storage = (0, $bSSG7.createLocalStorageProvider)($e0fd77b45718946f$export$69ca515e4489d790);
            storage.clearAll();
            reject(new Error(`Cache scope was not set within ${$e0fd77b45718946f$var$TIMEOUT}ms`));
        }, ms);
    });
    return Promise.race([
        promise,
        timeout
    ]).then((result)=>{
        clearTimeout(id);
        return result;
    });
};
const $e0fd77b45718946f$export$653cd03438bb0386 = ()=>$e0fd77b45718946f$var$promiseWithMaxExecutionTime($e0fd77b45718946f$var$TIMEOUT, $e0fd77b45718946f$var$cachePromise);
const $e0fd77b45718946f$var$config = {
    devTools: false,
    scopes: {
        prev: null,
        current: null
    },
    set (scopeKey) {
        const storage = (0, $bSSG7.createLocalStorageProvider)($e0fd77b45718946f$export$69ca515e4489d790);
        const scopeKeyInStorage = storage.get($e0fd77b45718946f$export$27be962d708928a);
        // init value
        if (this.scopes.prev === null && this.scopes.current === null) {
            if (scopeKeyInStorage) {
                // @ts-expect-error - TS2540 - Cannot assign to 'prev' because it is a read-only property.
                this.scopes.prev = scopeKeyInStorage;
                // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
                this.scopes.current = scopeKeyInStorage;
            }
        }
        // same account id
        if (this.scopes.current !== scopeKey) {
            // diffrent account id
            if (this.scopes.current !== null) // scope has changed during session
            storage.clearAll();
            // @ts-expect-error - TS2540 - Cannot assign to 'prev' because it is a read-only property.
            this.scopes.prev = this.scopes.current;
            // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
            this.scopes.current = scopeKey;
            storage.set($e0fd77b45718946f$export$27be962d708928a, scopeKey);
        }
        // @ts-expect-error - TS7005 - Variable 'resolveCachePromise' implicitly has an 'any' type.
        $e0fd77b45718946f$var$resolveCachePromise();
    },
    get () {
        return this.scopes.current;
    }
};
var $e0fd77b45718946f$export$2e2bcd8739ae039 = $e0fd77b45718946f$var$config;

});


parcelRegister("gmGW3", function(module, exports) {

$parcel$export(module.exports, "SafeConversationAssistantPanel", () => $836bcaaba692e6c5$export$453401d0b697d2db);

var $5uXOq = parcelRequire("5uXOq");

var $e8KHW = parcelRequire("e8KHW");

var $3AWiS = parcelRequire("3AWiS");


var $7CMCs = parcelRequire("7CMCs");

var $hsmeR = parcelRequire("hsmeR");

var $2NMNM = parcelRequire("2NMNM");

var $3HwlS = parcelRequire("3HwlS");

var $koVbs = parcelRequire("koVbs");

var $2vgok = parcelRequire("2vgok");

var $4iuvt = parcelRequire("4iuvt");
const $836bcaaba692e6c5$var$PanelInLayout = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const rightSidebarCurrentState = (0, $hsmeR.useActiveRightSidebarState)();
    const [localPanelId, setLocalPanelId] = (0, $5uXOq.useState)();
    const prevPanelIdRef = (0, $5uXOq.useRef)();
    const delayRef = (0, $5uXOq.useRef)(null);
    const { closeCurrentRightSidebar: closeCurrentRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const panelId = rightSidebarCurrentState?.panelId;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleResizeComplete = (0, $5uXOq.useCallback)(()=>{
        createAnalyticsEvent({
            action: 'resized',
            actionSubject: 'aiMatePanel',
            tags: [
                'atlaskit',
                'aiMate'
            ]
        }).fire((0, $e8KHW.FabricChannel).aiMate);
    }, [
        createAnalyticsEvent
    ]);
    /**
   * This use effect is used to add (when is necessary) a delay
   * in the panelId => localPanelId syncing
   */ (0, $5uXOq.useEffect)(()=>{
        // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(delayRef.current);
        if (prevPanelIdRef.current === (0, $1cb976721581e2e6$export$dffb4ed44e20ea9a)) {
            /**
       * The right-sidebar is showing the conversation assistant...
       */ if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) /**
         * and is open, not collapsed and we want to show a panel
         * with an ID !== CONVERSATION_ASSISTANT_CONTAINER_ID
         */ setLocalPanelId(panelId);
            else /**
         * and we want to close it
         */ delayRef.current = setTimeout(()=>{
                setLocalPanelId(panelId);
                createAnalyticsEvent({
                    action: 'closed',
                    actionSubject: 'aiMatePanel',
                    source: 'AIMate',
                    tags: [
                        'atlaskit',
                        'aiMate'
                    ]
                }).fire((0, $e8KHW.FabricChannel).aiMate);
            }, 310);
        } else /**
       * If the right sidebar is not showing the conversation assistant,
       * we just keep localPanelId in sync with panelId
       */ setLocalPanelId(panelId);
        prevPanelIdRef.current = panelId;
        // @ts-expect-error - TS2769 - No overload matches this call.
        return ()=>clearTimeout(delayRef.current);
    }, [
        createAnalyticsEvent,
        panelId,
        rightSidebarCurrentState
    ]);
    if (localPanelId !== (0, $1cb976721581e2e6$export$dffb4ed44e20ea9a)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $3HwlS.getWillShowNav4)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3AWiS.PanelSplitter), {
        label: formatMessage((0, $4iuvt.default).panelSplitter),
        onResizeEnd: handleResizeComplete
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2vgok.JiraConversationAssistant), {
        onClosePanel: closeCurrentRightSidebar
    }));
};
const $836bcaaba692e6c5$export$453401d0b697d2db = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-side-conversation-assistant-panel",
        packageName: "jiraConversationAssistant"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($836bcaaba692e6c5$var$PanelInLayout, null));

});
// Exported through entry point /src/utils.
/**
 * Used as the identifier for container on the consumer side.
 *
 * Example:
 * ```
 * <div id={CONVERSATION_ASSISTANT_CONTAINER_ID}>
 *  <ConversationAssistant />
 * </div>
 * ```
 */ const $1cb976721581e2e6$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $1cb976721581e2e6$export$64aee74ba59709e5 = 439; // px
const $1cb976721581e2e6$export$1c07393c5bb1bc27 = 439; // px
const $1cb976721581e2e6$export$aa3478deee7adbeb = 350; // px
const $1cb976721581e2e6$export$21e515a86cd1733b = 'Chat';

parcelRegister("2vgok", function(module, exports) {

$parcel$export(module.exports, "JiraConversationAssistant", () => $2321abcc17b38bef$export$da8473714271a41d);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $lIWNb = parcelRequire("lIWNb");
var $8Y08s = parcelRequire("8Y08s");


var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $j8DrX = parcelRequire("j8DrX");

var $hsmeR = parcelRequire("hsmeR");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $14XJw = parcelRequire("14XJw");

var $fY39E = parcelRequire("fY39E");

var $koeKL = parcelRequire("koeKL");

var $3HwlS = parcelRequire("3HwlS");
const $2321abcc17b38bef$var$SYNTHETIC_HEADER = 'x-issynthetic-traffic';
const $2321abcc17b38bef$export$da8473714271a41d = ({ onClosePanel: onClosePanel })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const cloudId = (0, $koeKL.useCloudId)();
    const activationId = (0, $fY39E.useActivationId)();
    const { openRightSidebar: openRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const isNav4Enabled = (0, $3HwlS.getWillShowNav4)();
    const isSyntheticTenant = (0, $j8DrX.default)('ajs-is-synthetic') === 'true' || (0, $4R6GH.fg)('is_synthetic_tenant');
    const urlPrefix = (0, $co1wz.ff)('jira.frontend.ai.mate.route.stargate.to.convo.ai') ? '/gateway/api/assist-kotlin' : '/gateway/api/assist';
    const config = (0, $5uXOq.useMemo)(()=>({
            displaySubmitFlag: true,
            siteId: cloudId,
            activationId: activationId,
            product: 'jira',
            orgId: orgId,
            experienceId: 'ai-mate',
            assistanceServiceConfig: {
                // TODO: type `AssistanceServiceConfig` should be decoupled from headers to prevent the need for other required keys which shouldn't need to be defined here (`product` and `experienceId`)
                headers: isSyntheticTenant ? {
                    [$2321abcc17b38bef$var$SYNTHETIC_HEADER]: String(isSyntheticTenant)
                } : {},
                // Rename to `urlPrefix` in the package  too
                baseUrl: urlPrefix
            }
        }), [
        cloudId,
        activationId,
        orgId,
        isSyntheticTenant,
        urlPrefix
    ]);
    const handleResizeComplete = (0, $5uXOq.useCallback)((width)=>{
        openRightSidebar((0, $1cb976721581e2e6$export$dffb4ed44e20ea9a), width);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'resized',
            actionSubject: 'aiMatePanel'
        }));
    }, [
        openRightSidebar,
        createAnalyticsEvent
    ]);
    // ROVOFE-76 - No resize wrapper for nav4 as it uses PanelSplitter now
    if (isNav4Enabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $2321abcc17b38bef$var$conversationAssistantWrapperNav4Styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lIWNb.default), {
        testId: "conversation-assistant.ui.conversation-assistant",
        onCloseChat: onClosePanel,
        config: config,
        isNav4Enabled: true
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Y08s.ResizeWrapper), {
        onResizeComplete: handleResizeComplete
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $2321abcc17b38bef$var$conversationAssistantWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lIWNb.default), {
        testId: "conversation-assistant.ui.conversation-assistant",
        onCloseChat: onClosePanel,
        config: config
    })));
};
const $2321abcc17b38bef$var$conversationAssistantWrapperStyles = (0, $8CUq3.xcss)({
    width: '100%'
});
const $2321abcc17b38bef$var$conversationAssistantWrapperNav4Styles = (0, $8CUq3.xcss)({
    width: '100%',
    height: '100%'
});

});
parcelRegister("lIWNb", function(module, exports) {

$parcel$export(module.exports, "default", () => $2511a7ad08348805$export$2e2bcd8739ae039);

var $4qBtX = parcelRequire("4qBtX");

var $2511a7ad08348805$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("gbF4n")),
    loading: ()=>null
});

});
parcelRegister("4qBtX", function(module, exports) {
"use strict";
var $3396aa4dae68f4b9$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $3396aa4dae68f4b9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3396aa4dae68f4b9$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $3396aa4dae68f4b9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $5uXOq = parcelRequire("5uXOq");

var $8rCP3 = parcelRequire("8rCP3");
var $3396aa4dae68f4b9$var$ALL_INITIALIZERS = [];
var $3396aa4dae68f4b9$var$READY_INITIALIZERS = [];
function $3396aa4dae68f4b9$var$isWebpackReady(getModuleIds) {
    if ((typeof __webpack_modules__ === "undefined" ? "undefined" : $3396aa4dae68f4b9$var$_typeof(__webpack_modules__)) !== "object") return false;
    return getModuleIds().every(function(moduleId) {
        return typeof moduleId !== "undefined" && typeof __webpack_modules__[moduleId] !== "undefined";
    });
}
function $3396aa4dae68f4b9$var$load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function $3396aa4dae68f4b9$var$loadMap(obj) {
    var state = {
        loading: false,
        loaded: {},
        error: null
    };
    var promises = [];
    try {
        Object.keys(obj).forEach(function(key) {
            var result = $3396aa4dae68f4b9$var$load(obj[key]);
            if (!result.loading) {
                state.loaded[key] = result.loaded;
                state.error = result.error;
            } else state.loading = true;
            promises.push(result.promise);
            result.promise.then(function(res) {
                state.loaded[key] = res;
            }).catch(function(err) {
                state.error = err;
            });
        });
    } catch (err) {
        state.error = err;
    }
    state.promise = Promise.all(promises).then(function(res) {
        state.loading = false;
        return res;
    }).catch(function(err) {
        state.loading = false;
        throw err;
    });
    return state;
}
function $3396aa4dae68f4b9$var$resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function $3396aa4dae68f4b9$var$render(loaded, props) {
    return $5uXOq.createElement($3396aa4dae68f4b9$var$resolve(loaded), props);
}
function $3396aa4dae68f4b9$var$createLoadableComponent(loadFn, options) {
    var _class, _temp;
    if (!options.loading) throw new Error("react-loadable requires a `loading` component");
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        render: $3396aa4dae68f4b9$var$render,
        webpack: null,
        modules: null
    }, options);
    var res = null;
    function init() {
        if (!res) res = loadFn(opts.loader);
        return res.promise;
    }
    $3396aa4dae68f4b9$var$ALL_INITIALIZERS.push(init);
    if (typeof opts.webpack === "function") $3396aa4dae68f4b9$var$READY_INITIALIZERS.push(function() {
        if ($3396aa4dae68f4b9$var$isWebpackReady(opts.webpack)) return init();
    });
    return _temp = _class = function(_React$Component) {
        $3396aa4dae68f4b9$var$_inherits(LoadableComponent, _React$Component);
        function LoadableComponent(props) {
            $3396aa4dae68f4b9$var$_classCallCheck(this, LoadableComponent);
            var _this = $3396aa4dae68f4b9$var$_possibleConstructorReturn(this, _React$Component.call(this, props));
            _this.retry = function() {
                _this.setState({
                    error: null,
                    loading: true,
                    timedOut: false
                });
                res = loadFn(opts.loader);
                _this._loadModule();
            };
            init();
            _this.state = {
                error: res.error,
                pastDelay: false,
                timedOut: false,
                loading: res.loading,
                loaded: res.loaded
            };
            return _this;
        }
        LoadableComponent.preload = function preload() {
            return init();
        };
        LoadableComponent.prototype.componentWillMount = function componentWillMount() {
            this._mounted = true;
            this._loadModule();
        };
        LoadableComponent.prototype._loadModule = function _loadModule() {
            var _this2 = this;
            if (this.context.loadable && Array.isArray(opts.modules)) opts.modules.forEach(function(moduleName) {
                _this2.context.loadable.report(moduleName);
            });
            if (!res.loading) return;
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) this.setState({
                    pastDelay: true
                });
                else this._delay = setTimeout(function() {
                    _this2.setState({
                        pastDelay: true
                    });
                }, opts.delay);
            }
            if (typeof opts.timeout === "number") this._timeout = setTimeout(function() {
                _this2.setState({
                    timedOut: true
                });
            }, opts.timeout);
            var update = function update() {
                if (!_this2._mounted) return;
                _this2.setState({
                    error: res.error,
                    loaded: res.loaded,
                    loading: res.loading
                });
                _this2._clearTimeouts();
            };
            res.promise.then(function() {
                update();
            }).catch(function(err) {
                update();
            });
        };
        LoadableComponent.prototype.componentWillUnmount = function componentWillUnmount() {
            this._mounted = false;
            this._clearTimeouts();
        };
        LoadableComponent.prototype._clearTimeouts = function _clearTimeouts() {
            clearTimeout(this._delay);
            clearTimeout(this._timeout);
        };
        LoadableComponent.prototype.render = function render() {
            if (this.state.loading || this.state.error) return $5uXOq.createElement(opts.loading, {
                isLoading: this.state.loading,
                pastDelay: this.state.pastDelay,
                timedOut: this.state.timedOut,
                error: this.state.error,
                retry: this.retry
            });
            else if (this.state.loaded) return opts.render(this.state.loaded, this.props);
            else return null;
        };
        return LoadableComponent;
    }($5uXOq.Component), _class.contextTypes = {
        loadable: $8rCP3.shape({
            report: $8rCP3.func.isRequired
        })
    }, _temp;
}
function $3396aa4dae68f4b9$var$Loadable(opts) {
    return $3396aa4dae68f4b9$var$createLoadableComponent($3396aa4dae68f4b9$var$load, opts);
}
function $3396aa4dae68f4b9$var$LoadableMap(opts) {
    if (typeof opts.render !== "function") throw new Error("LoadableMap requires a `render(loaded, props)` function");
    return $3396aa4dae68f4b9$var$createLoadableComponent($3396aa4dae68f4b9$var$loadMap, opts);
}
$3396aa4dae68f4b9$var$Loadable.Map = $3396aa4dae68f4b9$var$LoadableMap;
var $3396aa4dae68f4b9$var$Capture = function(_React$Component2) {
    $3396aa4dae68f4b9$var$_inherits(Capture, _React$Component2);
    function Capture() {
        $3396aa4dae68f4b9$var$_classCallCheck(this, Capture);
        return $3396aa4dae68f4b9$var$_possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
    }
    Capture.prototype.getChildContext = function getChildContext() {
        return {
            loadable: {
                report: this.props.report
            }
        };
    };
    Capture.prototype.render = function render() {
        return $5uXOq.Children.only(this.props.children);
    };
    return Capture;
}($5uXOq.Component);
$3396aa4dae68f4b9$var$Capture.propTypes = {
    report: $8rCP3.func.isRequired
};
$3396aa4dae68f4b9$var$Capture.childContextTypes = {
    loadable: $8rCP3.shape({
        report: $8rCP3.func.isRequired
    }).isRequired
};
$3396aa4dae68f4b9$var$Loadable.Capture = $3396aa4dae68f4b9$var$Capture;
function $3396aa4dae68f4b9$var$flushInitializers(initializers) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init());
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) return $3396aa4dae68f4b9$var$flushInitializers(initializers);
    });
}
$3396aa4dae68f4b9$var$Loadable.preloadAll = function() {
    return new Promise(function(resolve, reject) {
        $3396aa4dae68f4b9$var$flushInitializers($3396aa4dae68f4b9$var$ALL_INITIALIZERS).then(resolve, reject);
    });
};
$3396aa4dae68f4b9$var$Loadable.preloadReady = function() {
    return new Promise(function(resolve, reject) {
        // We always will resolve, errors should be handled within loading UIs.
        $3396aa4dae68f4b9$var$flushInitializers($3396aa4dae68f4b9$var$READY_INITIALIZERS).then(resolve, resolve);
    });
};
module.exports = $3396aa4dae68f4b9$var$Loadable;

});

parcelRegister("gbF4n", function(module, exports) {

let $bc8d87f968c348c0$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $bc8d87f968c348c0$var$load("kNFvF"),
    $bc8d87f968c348c0$var$load("fliVL"),
    $bc8d87f968c348c0$var$load("ffQaD"),
    $bc8d87f968c348c0$var$load("kvRbA"),
    $bc8d87f968c348c0$var$load("76n7a"),
    $bc8d87f968c348c0$var$load("l253H"),
    $bc8d87f968c348c0$var$load("2lK9A")
]).then(()=>parcelRequire('k2v4d'));

});


parcelRegister("8Y08s", function(module, exports) {

$parcel$export(module.exports, "ResizeWrapper", () => $6bea494971fb78d2$export$c7990a6594835e51);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cBeZP = parcelRequire("cBeZP");

const $6bea494971fb78d2$var$styles = {
    root: "_1xi2ze3t _1e0c1txw _kqsw1n9t _4t3i1i8v",
    handle: "_v564jkaz _1kl7j1ic _80omuf7j _uiztglyw _kqswstnw _154ipxbi _94n5ze3t _1ltvze3t _1bsb1tcg _13lipd34 _1jvv1bty",
    handleSpacer: "_1bsb1tcg _kqswstnw _1e0c1ule _1ltv2bgk _154ize3t _94n5ze3t"
};
const $6bea494971fb78d2$export$c7990a6594835e51 = ({ children: children, onResizeComplete: onResizeComplete, initialWidth: initialWidth = (0, $1cb976721581e2e6$export$64aee74ba59709e5), minWidth: minWidth = (0, $1cb976721581e2e6$export$64aee74ba59709e5), maxWidth: maxWidth = '50vw' })=>{
    const [width, setWidth] = (0, $5uXOq.useState)(initialWidth);
    const wrapperRef = (0, $5uXOq.useRef)(null);
    const isDraggingRef = (0, $5uXOq.useRef)(false);
    const initialMousePositionRef = (0, $5uXOq.useRef)(0);
    const prevDistanceMovedRef = (0, $5uXOq.useRef)(0);
    const rafRef = (0, $5uXOq.useRef)(null);
    const getWrapperWidth = ()=>{
        return wrapperRef.current?.getBoundingClientRect()?.width || 0;
    };
    const handleMouseMove = (0, $5uXOq.useCallback)((event)=>{
        if (!isDraggingRef.current) return;
        const distanceMoved = event.clientX - initialMousePositionRef.current;
        let updatedWidth;
        const currentWidth = getWrapperWidth();
        // Ignore events without change
        if (distanceMoved === prevDistanceMovedRef.current || distanceMoved === 0) return;
        // Acknowledge latest direction adjustment
        prevDistanceMovedRef.current = distanceMoved;
        // Clear queued animation frame
        if (rafRef.current !== null) cancelAnimationFrame(rafRef.current);
        rafRef.current = requestAnimationFrame(()=>{
            // Update widths with upper and lower limits respected when `minWidth` and `maxWidth` are `number`
            // When `string`, we'll respect this value on the styles of the wrapper for use-cases such as '100%', '70vw' etc.
            if (distanceMoved < 0) {
                updatedWidth = currentWidth + Math.abs(distanceMoved);
                if (typeof maxWidth === 'number' && !isNaN(maxWidth)) updatedWidth = Math.min(updatedWidth, maxWidth);
            } else {
                updatedWidth = currentWidth - distanceMoved;
                if (typeof minWidth === 'number' && !isNaN(minWidth)) updatedWidth = Math.max(updatedWidth, minWidth);
            }
            setWidth(updatedWidth);
            initialMousePositionRef.current = event.clientX;
        });
    }, [
        maxWidth,
        minWidth
    ]);
    const handleMouseDown = (0, $5uXOq.useCallback)((event)=>{
        // Indicate dragging
        isDraggingRef.current = true;
        // Indicate starting point
        initialMousePositionRef.current = event.clientX;
    }, []);
    const handleMouseUp = (0, $5uXOq.useCallback)(()=>{
        if (isDraggingRef.current && onResizeComplete) onResizeComplete(wrapperRef.current?.getBoundingClientRect().width || width);
        isDraggingRef.current = false;
    }, [
        onResizeComplete,
        width
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const mouseMoveHandler = (0, $cBeZP.bind)(window, {
            type: 'mousemove',
            listener: handleMouseMove
        });
        const mouseUpHandler = (0, $cBeZP.bind)(window, {
            type: 'mouseup',
            listener: handleMouseUp
        });
        return ()=>{
            mouseMoveHandler();
            mouseUpHandler();
            if (rafRef.current !== null) cancelAnimationFrame(rafRef.current);
        };
    }, [
        handleMouseMove,
        handleMouseUp
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        ref: wrapperRef,
        role: "presentation",
        "data-testid": "panel-resize-wrapper",
        style: {
            width: width,
            maxWidth: maxWidth,
            minWidth: minWidth
        },
        className: (0, $bwpsq.default)([
            $6bea494971fb78d2$var$styles.root
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                "data-testid": "panel-resize-handle",
                onMouseDown: handleMouseDown,
                className: (0, $bwpsq.default)([
                    $6bea494971fb78d2$var$styles.handle
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $6bea494971fb78d2$var$styles.handleSpacer
                    ])
                })
            }),
            children
        ]
    });
};

});


parcelRegister("4iuvt", function(module, exports) {

$parcel$export(module.exports, "default", () => $c74f41697e20fe6a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c74f41697e20fe6a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    panelSplitter: {
        "id": "platform-conversation-assistant.panelSplitter.label",
        "defaultMessage": "Resize panel"
    }
});

});


parcelRegister("8NA5p", function(module, exports) {

$parcel$export(module.exports, "AsyncDeferEditionEPCheckWrapper", () => $2684c9c6a6fb887b$export$4fa5b26bccc7e3df);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $7iJwP = parcelRequire("7iJwP");

var $kxZPA = parcelRequire("kxZPA");


// We are using an async here in addition to the jiraDeferEditionModalEntryPoint in ./entrypoint.tsx since
// we want to avoid unnecessarily preloading the expensive graphql query on each page load. Instead
// we load an async component that checks engagement-platform first if we are to show the modal or not.
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2684c9c6a6fb887b$var$AsyncDeferEditionEPCheck = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("jj1ID")).then(({ EPCheck: EPCheck })=>EPCheck), {
    ssr: false,
    moduleId: "./src/packages/growth/defer-edition-modal/src/EPCheck.tsx"
});
const $2684c9c6a6fb887b$export$4fa5b26bccc7e3df = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "defer-edition-ep-check-async",
        packageName: (0, $ac4f2a72f86d65c9$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        teamName: (0, $ac4f2a72f86d65c9$export$d57b6b390e78d90f),
        id: "defer-edition-ep-check-async",
        packageName: (0, $ac4f2a72f86d65c9$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2684c9c6a6fb887b$var$AsyncDeferEditionEPCheck, props)));

});
const $ac4f2a72f86d65c9$export$b8b9d90f9e5bd72b = 'DeferEditionModal';
const $ac4f2a72f86d65c9$export$d57b6b390e78d90f = 'transmuters-growth';
const $ac4f2a72f86d65c9$export$4b374f476a475bef = 'stg-defer-edition-crossflow-jpd';
const $ac4f2a72f86d65c9$export$3fc71bcf4d7deeea = 'stg-defer-edition-crossflow-jsw';
const $ac4f2a72f86d65c9$export$a0f8b0f73985911a = 'stg-defer-edition-crossflow-jwm';
const $ac4f2a72f86d65c9$export$bfaa609ebcf522b6 = 'stg-defer-edition-crossflow-jsm';
const $ac4f2a72f86d65c9$export$58003a8be3bebb14 = 'defer-edition-crossflow-jpd';
const $ac4f2a72f86d65c9$export$475f4ac16b63ff71 = 'defer-edition-crossflow-jsw';
const $ac4f2a72f86d65c9$export$f36bed87d45a98de = 'defer-edition-crossflow-jwm';
const $ac4f2a72f86d65c9$export$b302977ba64b0fa = 'defer-edition-crossflow-jsm';

parcelRegister("jj1ID", function(module, exports) {

let $e0e120034fe10c1f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e0e120034fe10c1f$var$load("fxSO8").then(()=>parcelRequire('1HKGQ'));

});


parcelRegister("7kqCT", function(module, exports) {

$parcel$export(module.exports, "jiraDeferEditionModalEntryPoint", () => $110a94ef04661997$export$51f384a783f47807);

var $fiH7W = parcelRequire("fiH7W");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $110a94ef04661997$export$51f384a783f47807 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(async ()=>(parcelRequire("gAjSJ")).then(({ DeferEditionModalComponent: DeferEditionModalComponent })=>DeferEditionModalComponent), {
        moduleId: "fe342c6b",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, productKey: productKey })=>({
            queries: {
                deferEditionModal: {
                    parameters: (0, $fiH7W.default),
                    variables: {
                        cloudId: cloudId,
                        productKey: productKey
                    }
                }
            }
        })
});

});
parcelRegister("fiH7W", function(module, exports) {

$parcel$export(module.exports, "default", () => $d18804309a0f9ffd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f7b7f568d65bb0013b875d9dc02c9ec8>>
 * @relayHash f383e862a6745bc8f6efe3f1d322accc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5db8f4ae8f0ff9144226f55dd10f2adcc53bceab974d658a4e9c23ea3e7709ce
const $d18804309a0f9ffd$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "5db8f4ae8f0ff9144226f55dd10f2adcc53bceab974d658a4e9c23ea3e7709ce",
        "metadata": {},
        "name": "src_DeferEditionModalQuery",
        "operationKind": "query",
        "text": null
    }
};
var $d18804309a0f9ffd$export$2e2bcd8739ae039 = $d18804309a0f9ffd$var$node;

});

parcelRegister("gAjSJ", function(module, exports) {

let $c12f6e3ff915bac9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c12f6e3ff915bac9$var$load("5YQIc").then(()=>parcelRequire('8IIKL'));

});


parcelRegister("jjA6o", function(module, exports) {

$parcel$export(module.exports, "endOfTrialExtensionEntryPoint", () => $cd06d7cec07212f7$export$dd41abc64eb3ea80);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $cd06d7cec07212f7$export$dd41abc64eb3ea80 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("kxMi6")), {
        moduleId: "13487943",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("kxMi6", function(module, exports) {

let $ef4c594cd196f8f8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ef4c594cd196f8f8$var$load("5r7W9").then(()=>parcelRequire('egyYq'));

});


parcelRegister("hfZX4", function(module, exports) {

$parcel$export(module.exports, "LoadingBarUIController", () => $b0b17218ec347926$export$39bdf67fc71ce8c8);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $2YZCu = parcelRequire("2YZCu");

var $d46Cs = parcelRequire("d46Cs");

var $lsa9q = parcelRequire("lsa9q");

var $bVDE5 = parcelRequire("bVDE5");

var $doZTA = parcelRequire("doZTA");

var $04unK = parcelRequire("04unK");

var $cYUbO = parcelRequire("cYUbO");
const $b0b17218ec347926$export$54128ad8de32b897 = ({ startLoading: startLoading, resetLoading: resetLoading, finishLoading: finishLoading })=>{
    const [loadedState] = (0, $lsa9q.default)();
    (0, $5uXOq.useEffect)(()=>{
        startLoading();
        return ()=>{
            resetLoading();
        };
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (loadedState.hasLoaded) finishLoading();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loadedState.hasLoaded
    ]);
    return null;
};
/**
 * Sets up the loading bar stylesheet and controller purely in the client
 * This is a fallback if SSR fails
 *
 */ const $b0b17218ec347926$var$LoadingBarUI = ({ shouldRender: shouldRender, routeIdentifier: routeIdentifier })=>{
    const [actions, setActions] = (0, $5uXOq.useState)({});
    const sheetRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'HTMLStyleElement | null'.
        const loadingBarActions = (0, $d46Cs.createLoadingBarActionController)(sheetRef.current);
        setActions(loadingBarActions || {});
    }, []);
    if ((0, $4R6GH.fg)('magma-3306_prevent_unnecessary_div_added')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", {
        // @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown>' is not assignable to type 'LegacyRef<HTMLStyleElement> | undefined'.
        ref: sheetRef,
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `
                    ${(0, $04unK.LOADER_STYLES_CSS_SELECTOR)} {
                        ${(0, $cYUbO.generateLoadingBarStyles)(0, (0, $04unK.getLoadingBarColor)())}
                    }
                `
        }
    }), shouldRender && actions.START && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b0b17218ec347926$export$54128ad8de32b897, {
        key: routeIdentifier,
        // @ts-expect-error - TS2339 - Property 'START' does not exist on type '{}'.
        startLoading: actions.START,
        // @ts-expect-error - TS2339 - Property 'RESET' does not exist on type '{}'.
        resetLoading: actions.RESET,
        // @ts-expect-error - TS2339 - Property 'FINISH' does not exist on type '{}'.
        finishLoading: actions.FINISH
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", {
        // @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown>' is not assignable to type 'LegacyRef<HTMLStyleElement> | undefined'.
        ref: sheetRef,
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `
                    ${(0, $04unK.LOADER_STYLES_CSS_SELECTOR)} {
                        ${(0, $cYUbO.generateLoadingBarStyles)(0, (0, $04unK.getLoadingBarColor)())}
                    }
                `
        }
    }), shouldRender && actions.START && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b0b17218ec347926$export$54128ad8de32b897, {
        key: routeIdentifier,
        // @ts-expect-error - TS2339 - Property 'START' does not exist on type '{}'.
        startLoading: actions.START,
        // @ts-expect-error - TS2339 - Property 'RESET' does not exist on type '{}'.
        resetLoading: actions.RESET,
        // @ts-expect-error - TS2339 - Property 'FINISH' does not exist on type '{}'.
        finishLoading: actions.FINISH
    }));
};
const $b0b17218ec347926$export$e068deb20d61b035 = ()=>{
    let currentTransitionsCount = 0;
    let currentRouteIdentifier = '';
    let currentRouteMatch = '';
    let hasTransitioned = false;
    let key = 0;
    return (transitionsCount, routeIdentifier, routeMatch)=>{
        if (transitionsCount !== currentTransitionsCount) {
            currentTransitionsCount = transitionsCount;
            hasTransitioned = true;
        }
        if (routeIdentifier !== null && routeIdentifier !== currentRouteIdentifier || routeIdentifier === currentRouteIdentifier && routeMatch !== currentRouteMatch) {
            currentRouteIdentifier = routeIdentifier;
            currentRouteMatch = routeMatch;
            if (hasTransitioned) {
                hasTransitioned = false;
                key = currentTransitionsCount;
            }
        }
        return key;
    };
};
const $b0b17218ec347926$var$getUniqueTransitionKey = $b0b17218ec347926$export$e068deb20d61b035();
/**
 * Determines if the <LoadingBarController> should render or re-render
 * Injects dependencies into <LoadingBarController />
 *
 */ const $b0b17218ec347926$export$39bdf67fc71ce8c8 = ()=>{
    const [routerState] = (0, $doZTA.useRouter)();
    const [{ transitionsCount: transitionsCount }] = (0, $bVDE5.useSpaStateTransition)();
    const currentRoute = routerState.route && routerState.route.name;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const loaderFailedInSSR = !window.JIRA_LOADING_BAR;
    const shouldRender = (0, $04unK.getAllowedRoutes)().includes(currentRoute);
    // we generate a unique route identifier each time a transition happens
    // we use this key to force re-render of the <LoadingBarController />
    const routeIdentifier = (0, $5uXOq.useMemo)(()=>$b0b17218ec347926$var$getUniqueTransitionKey(transitionsCount, currentRoute, JSON.stringify(routerState.match)), [
        transitionsCount,
        currentRoute,
        routerState.match
    ]);
    // We always expect the loading bar to be initialised in SSR for any route in ALLOWED_ROUTES
    // If this doesn't happen, it means SSR failed or the loading bar code in SSR failed
    (0, $5uXOq.useEffect)(()=>{
        if (shouldRender && loaderFailedInSSR) (0, $2YZCu.default).safeWarnWithoutCustomerData('global-loading-bar', 'Loading bar failed to initialise in SSR. This may be because SSR failed or a bug in the loading bar code.');
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loaderFailedInSSR
    ]);
    // If the loading bar fails to setup in SSR, we set up the action controller AND stylesheet in the client
    // We also do this if SSR renders a page that does not have the loading bar enabled (eg !shouldRender)
    if (loaderFailedInSSR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b0b17218ec347926$var$LoadingBarUI, {
        shouldRender: shouldRender,
        routeIdentifier: routeIdentifier
    });
    // if the loading bar is succesfully setup in SSR, all the client needs to do is dispatch loading actions
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (shouldRender && window.JIRA_LOADING_BAR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b0b17218ec347926$export$54128ad8de32b897, {
        key: routeIdentifier,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        startLoading: window.JIRA_LOADING_BAR.START,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        resetLoading: window.JIRA_LOADING_BAR.RESET,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        finishLoading: window.JIRA_LOADING_BAR.FINISH
    });
    return null;
};

});
parcelRegister("d46Cs", function(module, exports) {

$parcel$export(module.exports, "createLoadingBarActionController", () => $65545b2eb3978204$export$55d67d61d9d2ad3b);
// BE VERY CAREFUL IMPORTING ANY PACKAGES IN THIS FILE
// THIS CODE IS AN INLINE FRAGMENT AND RUNS BEFORE POLYFILLS AND MAY BREAK IE

var $61WP1 = parcelRequire("61WP1");
const $65545b2eb3978204$export$53d51cc6d57e44da = 'rgb(76, 154, 255)';
const $65545b2eb3978204$export$899393f3e23f724b = 15000;
const $65545b2eb3978204$export$7868b416d8929c55 = 40000;
const $65545b2eb3978204$var$LOADER_STYLES_CSS_SELECTOR = 'body::before';
const $65545b2eb3978204$var$EXIT_ANIMATION_SPEED = 300;
const $65545b2eb3978204$export$99d4e8974a739853 = ()=>(0, $61WP1.getMeta)('ajs-lf-navigation-highlightcolour') || $65545b2eb3978204$export$53d51cc6d57e44da;
const $65545b2eb3978204$export$4fb8742b05de9693 = (duration)=>`
    ${$65545b2eb3978204$var$LOADER_STYLES_CSS_SELECTOR} {
        transform: scaleX(0.99);
        transition-duration: ${duration}ms;
        transition-timing-function: cubic-bezier(0,1,0.5,1);
    }
`;
const $65545b2eb3978204$export$5a43e0f09174e553 = ()=>`
    ${$65545b2eb3978204$var$LOADER_STYLES_CSS_SELECTOR} {
        transform: scaleX(1);
        transition-duration: ${$65545b2eb3978204$var$EXIT_ANIMATION_SPEED}ms;
        animation: none;
        background-image: none;
    }
`;
const $65545b2eb3978204$export$6beef8c645a63156 = ()=>`
    ${$65545b2eb3978204$var$LOADER_STYLES_CSS_SELECTOR} {
        transform: scaleX(0);
        transition-duration: 0ms;
        animation: none;
        background-image: none;
    }
`;
const $65545b2eb3978204$export$610cb442736abf53 = ()=>`
    @keyframes shimmer {
        from {
            left: -80%;
            width: 80%;
        }

        to {
            left: 110%;
            width: 10%;
        }
    }
`;
const $65545b2eb3978204$export$959e9e99fba397f1 = (loadingBarColor)=>`
        ${$65545b2eb3978204$var$LOADER_STYLES_CSS_SELECTOR} {
            transform: scaleX(1);
            transition-duration: 0ms;
            background: ${loadingBarColor};
            animation: shimmer 2s infinite;
        }
    `;
const $65545b2eb3978204$var$browserFocusCheck = (action)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (document && document.hidden) action();
    else requestAnimationFrame(()=>{
        action();
    });
};
const $65545b2eb3978204$export$55d67d61d9d2ad3b = (stylesheet)=>{
    const { sheet: sheet } = stylesheet || {};
    if (!sheet) return undefined;
    let isRunning = false;
    let isDelayed = false;
    let exitAnimationTimer;
    let delayedAnimationTimer;
    let timeoutTimer;
    return {
        START: (duration = $65545b2eb3978204$export$899393f3e23f724b)=>{
            if (isRunning) return;
            isRunning = true;
            // requestAnimationFrame will not run until the browser tab is focused
            // if a user opens a new tab the start animation will not begin until the tab is focused
            // this can cause the loading bar css to be applied in the incorrect order
            // to solve this we remove requestAnimationFrame if the tab is not focused
            $65545b2eb3978204$var$browserFocusCheck(()=>{
                sheet.insertRule($65545b2eb3978204$export$4fb8742b05de9693(duration), sheet.cssRules.length);
            });
            // Set a new delayed animation if loader hasn't finished after `${duration}` ms
            delayedAnimationTimer = setTimeout(()=>{
                if (!isRunning) return;
                isDelayed = true;
                $65545b2eb3978204$var$browserFocusCheck(()=>{
                    sheet.insertRule($65545b2eb3978204$export$610cb442736abf53(), sheet.cssRules.length);
                    sheet.insertRule($65545b2eb3978204$export$959e9e99fba397f1($65545b2eb3978204$export$99d4e8974a739853()), sheet.cssRules.length);
                });
            }, $65545b2eb3978204$export$899393f3e23f724b);
            // Remove the loader if it hasn't finished after `${TIMEOUT_TIMER}` ms
            timeoutTimer = setTimeout(()=>{
                if (!isRunning) return;
                isRunning = false;
                isDelayed = false;
                $65545b2eb3978204$var$browserFocusCheck(()=>{
                    sheet.insertRule($65545b2eb3978204$export$6beef8c645a63156(), sheet.cssRules.length);
                });
                clearTimeout(exitAnimationTimer);
                clearTimeout(delayedAnimationTimer);
                clearTimeout(timeoutTimer);
            }, $65545b2eb3978204$export$7868b416d8929c55);
        },
        FINISH: ()=>{
            if (!isRunning) return;
            isRunning = false;
            if (isDelayed) {
                isDelayed = false;
                clearTimeout(exitAnimationTimer);
                clearTimeout(timeoutTimer);
                clearTimeout(delayedAnimationTimer);
                $65545b2eb3978204$var$browserFocusCheck(()=>{
                    sheet.insertRule($65545b2eb3978204$export$6beef8c645a63156(), sheet.cssRules.length);
                });
                return;
            }
            $65545b2eb3978204$var$browserFocusCheck(()=>{
                sheet.insertRule($65545b2eb3978204$export$5a43e0f09174e553(), sheet.cssRules.length);
            });
            exitAnimationTimer = setTimeout(()=>{
                clearTimeout(exitAnimationTimer);
                clearTimeout(timeoutTimer);
                clearTimeout(delayedAnimationTimer);
                $65545b2eb3978204$var$browserFocusCheck(()=>{
                    sheet.insertRule($65545b2eb3978204$export$6beef8c645a63156(), sheet.cssRules.length);
                });
            }, $65545b2eb3978204$var$EXIT_ANIMATION_SPEED + 500);
        },
        RESET: ()=>{
            isRunning = false;
            isDelayed = false;
            clearTimeout(exitAnimationTimer);
            clearTimeout(delayedAnimationTimer);
            clearTimeout(timeoutTimer);
            $65545b2eb3978204$var$browserFocusCheck(()=>{
                sheet.insertRule($65545b2eb3978204$export$6beef8c645a63156(), sheet.cssRules.length);
            });
        }
    };
};
const $65545b2eb3978204$var$setupLoadingBarActionController = ()=>{
    const LOADER_STYLESHEET_ID = 'loaderStylesheet';
    // @ts-expect-error - TS2322 - Type 'HTMLElement | null' is not assignable to type 'HTMLStyleElement | null'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const styleSheet = document.getElementById(LOADER_STYLESHEET_ID);
    // SSR will not attach the stylesheet for routes not included in ALLOWED_ROUTES
    if (!styleSheet || !styleSheet.sheet) return;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.JIRA_LOADING_BAR = $65545b2eb3978204$export$55d67d61d9d2ad3b(styleSheet);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.JIRA_LOADING_BAR && window.JIRA_LOADING_BAR.START) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.JIRA_LOADING_BAR.START();
};
$65545b2eb3978204$var$setupLoadingBarActionController();

});
parcelRegister("61WP1", function(module, exports) {

$parcel$export(module.exports, "getMeta", () => $22b3d998cd498e5f$export$c47913ca32a5c6f7);
const $22b3d998cd498e5f$export$c47913ca32a5c6f7 = (name)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const node = document.querySelector(`meta[name="${name}"]`);
    const metaValue = node && node.getAttribute('content');
    return metaValue !== undefined ? metaValue : null;
};

});


parcelRegister("04unK", function(module, exports) {

$parcel$export(module.exports, "LOADER_STYLES_CSS_SELECTOR", () => $ac75ec265428b4c8$export$2a3dd4ccb7b0a764);
$parcel$export(module.exports, "LOADER_STYLESHEET_ID", () => $ac75ec265428b4c8$export$79456f717d4431da);
$parcel$export(module.exports, "getAllowedRoutes", () => $ac75ec265428b4c8$export$c82eb262b97a76f1);
$parcel$export(module.exports, "getLoadingBarColor", () => $ac75ec265428b4c8$export$cf3a5ed89e041425);

var $8QpSo = parcelRequire("8QpSo");

var $j8DrX = parcelRequire("j8DrX");
const $ac75ec265428b4c8$var$FIRST_RELEASE_ROUTES = [
    'issue',
    'issue-embed',
    'rapidboard-backlog',
    'rapidboard-board',
    'rapidboard-report',
    'your-work',
    'projects-directory',
    'boards-directory',
    'filters-directory',
    'dashboards-directory',
    'dashboards-directory-secure',
    'project-components',
    'project-pages',
    'project-versions',
    'software-boards',
    'software-backlog',
    'software-timeline',
    'software-roadmap',
    'software-roadmap-classic',
    'software-timeline-classic',
    'software-reports',
    'software-reports-burnup',
    'software-reports-burndown',
    'software-reports-cumulative',
    'software-reports-velocity',
    'issue-navigator',
    'global-issue-navigator',
    'issue-navigator-classic',
    'issue-navigator-core',
    'software-issue-navigator',
    'system-dashboard-edit'
];
const $ac75ec265428b4c8$export$2a3dd4ccb7b0a764 = 'body::before';
const $ac75ec265428b4c8$export$79456f717d4431da = 'loaderStylesheet';
const $ac75ec265428b4c8$export$53d51cc6d57e44da = 'rgb(76, 154, 255)';
const $ac75ec265428b4c8$export$c82eb262b97a76f1 = (0, $8QpSo.default)(()=>{
    const ALLOWED_ROUTES = $ac75ec265428b4c8$var$FIRST_RELEASE_ROUTES;
    return ALLOWED_ROUTES;
});
const $ac75ec265428b4c8$export$cf3a5ed89e041425 = (0, $8QpSo.default)(()=>(0, $j8DrX.default)('ajs-lf-navigation-highlightcolour') || $ac75ec265428b4c8$export$53d51cc6d57e44da);

});

parcelRegister("cYUbO", function(module, exports) {

$parcel$export(module.exports, "generateLoadingBarStyles", () => $e5278a73a699aa95$export$3036104bc81246b1);

var $gwIPs = parcelRequire("gwIPs");

var $04unK = parcelRequire("04unK");
const $e5278a73a699aa95$export$3036104bc81246b1 = (initalProgressValue, loadingBarColor)=>`
    content: '';
    display: block;
    background: ${loadingBarColor};
    height: 3px;
    z-index: ${(0, $gwIPs.layers).navigation + 10};
    width: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    transform: scaleX(${initalProgressValue});
    transform-origin: 0 0;
    will-change: transform;
`;
const $e5278a73a699aa95$export$85e33a4b3d661500 = (initialProgressValue = 0.3)=>`
        <style id=${0, $04unK.LOADER_STYLESHEET_ID}>
            ${0, $04unK.LOADER_STYLES_CSS_SELECTOR} {${$e5278a73a699aa95$export$3036104bc81246b1(initialProgressValue, (0, $04unK.getLoadingBarColor)())}}
        </style>`;

});


parcelRegister("7Lkcv", function(module, exports) {

$parcel$export(module.exports, "SafeHelpPanel", () => $70a8cef9c47c5a71$export$cd2ada2fb14048fc);

var $5uXOq = parcelRequire("5uXOq");

var $89SaW = parcelRequire("89SaW");

var $7CMCs = parcelRequire("7CMCs");

var $6BNJk = parcelRequire("6BNJk");

var $kspz4 = parcelRequire("kspz4");


var $7dTw7 = parcelRequire("7dTw7");

var $1SVH7 = parcelRequire("1SVH7");

var $hsmeR = parcelRequire("hsmeR");

var $90yGq = parcelRequire("90yGq");
const $70a8cef9c47c5a71$var$HelpPanel = ()=>{
    const [{ navigationData: navigationData, releaseNotesNotifications: releaseNotesNotifications }, { setNavigationData: setNavigationData, setReleaseNotesNotifications: setReleaseNotesNotifications }] = (0, $kspz4.useHelpPanel)();
    const { closeRightSidebar: closeRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const rightSidebarCurrentState = (0, $hsmeR.useActiveRightSidebarState)();
    const accountId = (0, $90yGq.useAccountId)();
    (0, $5uXOq.useEffect)(()=>{
        const restoreReleaseNotesNotifications = async ()=>{
            if (accountId) try {
                // @ts-expect-error - Property 'helpPanel' does not exist on type 'unknown'.
                const { helpPanel: userPropertiesHelpPanelValue } = await (0, $89SaW.getUserProperty)(accountId, (0, $0971f751295a2324$export$783d7c02e3a0cbf));
                setReleaseNotesNotifications(userPropertiesHelpPanelValue.releaseNotesNotifications);
            } catch (err) {
                /* getUserProperty throws if not found */ setReleaseNotesNotifications(0);
            }
            else setReleaseNotesNotifications(0);
        };
        restoreReleaseNotesNotifications();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7dTw7.RemoteStateUpdater), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1SVH7.LazyHelpPanel), {
        isOpen: !rightSidebarCurrentState?.isCollapsed,
        navigationData: navigationData,
        releaseNotesNotifications: releaseNotesNotifications,
        setNavigationData: setNavigationData,
        releaseNotesNotificationsSetter: setReleaseNotesNotifications,
        hasBeenRendered: !rightSidebarCurrentState?.isCollapsed,
        onCloseHelpPanel: closeRightSidebar
    }));
};
const $70a8cef9c47c5a71$var$HelpPanelInLayout = ()=>{
    const rightSidebarCurrentState = (0, $hsmeR.useActiveRightSidebarState)();
    const [localPanelId, setLocalPanelId] = (0, $5uXOq.useState)();
    const prevPanelIdRef = (0, $5uXOq.useRef)();
    const delayRef = (0, $5uXOq.useRef)(null);
    const panelId = rightSidebarCurrentState?.panelId;
    /**
	 * This use effect is used to add (when is necessary) a delay
	 * in the panelId => localPanelId syncing
	 */ (0, $5uXOq.useEffect)(()=>{
        // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(delayRef.current);
        if (prevPanelIdRef.current === (0, $6BNJk.HELP_PANEL_ID)) {
            /**
			 * The right-sidebar is showing the help-panel...
			 */ if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) /**
				 * and is open, not collapsed and we want to show a panel
				 * with an ID !== HELP_PANEL_ID
				 */ setLocalPanelId(panelId);
            else /**
				 * and we want to close it
				 */ delayRef.current = setTimeout(()=>{
                setLocalPanelId(panelId);
            }, 310);
        } else /**
			 * If the right sidebar is not showing the help-panel,
			 * we just keep localPanelId in sync with panelId
			 */ setLocalPanelId(panelId);
        prevPanelIdRef.current = panelId;
        // @ts-expect-error - TS2769 - No overload matches this call.
        return ()=>clearTimeout(delayRef.current);
    }, [
        panelId,
        rightSidebarCurrentState
    ]);
    if (localPanelId !== (0, $6BNJk.HELP_PANEL_ID)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($70a8cef9c47c5a71$var$HelpPanel, null);
};
const $70a8cef9c47c5a71$export$cd2ada2fb14048fc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-side-help-panel",
        packageName: "@atlassian/jira-help-panel-right-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($70a8cef9c47c5a71$var$HelpPanelInLayout, null));

});
parcelRegister("6BNJk", function(module, exports) {

$parcel$export(module.exports, "HELP_PANEL_VERSION", () => $20386d7da4313ff0$export$c43c7444da662fa1);
$parcel$export(module.exports, "HELP_PANEL_ID", () => $20386d7da4313ff0$export$e99efa3985fa3c26);
$parcel$export(module.exports, "HELP_PANEL_WIDTH", () => $20386d7da4313ff0$export$23aa6670f346c214);

var $gwIPs = parcelRequire("gwIPs");
const $20386d7da4313ff0$export$c43c7444da662fa1 = '1';
const $20386d7da4313ff0$export$e99efa3985fa3c26 = 'helpPanel';
const $20386d7da4313ff0$export$23aa6670f346c214 = (0, $gwIPs.gridSize) * 46;

});

parcelRegister("kspz4", function(module, exports) {

$parcel$export(module.exports, "useHelpPanel", () => $aee6103177ce0723$export$3fe94d66377a53b8);
$parcel$export(module.exports, "useHelpPanelActions", () => $aee6103177ce0723$export$c61f56f4797e22db);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $51nlc = parcelRequire("51nlc");

var $jgGDm = parcelRequire("jgGDm");
const $aee6103177ce0723$export$3fe94d66377a53b8 = (0, $3sQ5x.createHook)((0, $jgGDm.default));
const $aee6103177ce0723$export$c61f56f4797e22db = (0, $3sQ5x.createHook)((0, $jgGDm.default), {
    selector: null
});
const $aee6103177ce0723$export$513717a84f55db1a = (0, $51nlc.createSubscriber)((0, $jgGDm.default), {
    displayName: 'HelpPanelSubscriber'
});
const $aee6103177ce0723$export$5f4de38bd79f4446 = (0, $51nlc.createSubscriber)((0, $jgGDm.default), {
    displayName: 'HelpPanelActionsSubscriber',
    selector: null
});

});
parcelRegister("jgGDm", function(module, exports) {

$parcel$export(module.exports, "default", () => $465615692863cce9$export$2e2bcd8739ae039);

var $eNf8a = parcelRequire("eNf8a");

var $iXqE5 = parcelRequire("iXqE5");

var $958ua = parcelRequire("958ua");
let $465615692863cce9$var$iphStorage;
const $465615692863cce9$var$createStorage = ()=>{
    if ($465615692863cce9$var$iphStorage) return $465615692863cce9$var$iphStorage;
    $465615692863cce9$var$iphStorage = (0, $eNf8a.createSessionStorageProvider)('iph');
    return $465615692863cce9$var$iphStorage;
};
const $465615692863cce9$var$initialState = {
    navigationData: {
        articleId: {
            id: '',
            type: 'HELP_ARTICLE'
        },
        // FIXME: initialState breaks SSR
        history: false ? [] : $465615692863cce9$var$createStorage().get('navigationData') || []
    },
    releaseNotesNotifications: 100
};
var $465615692863cce9$export$2e2bcd8739ae039 = (0, $iXqE5.createStore)({
    name: 'help-panel',
    initialState: $465615692863cce9$var$initialState,
    actions: $958ua
});

});
parcelRegister("958ua", function(module, exports) {

$parcel$export(module.exports, "setNavigationData", () => $177ac56c5a5bf49e$export$ab1b80f40ca898ed);
$parcel$export(module.exports, "setReleaseNotesNotifications", () => $177ac56c5a5bf49e$export$cdabe01d01a8da1e);

var $eNf8a = parcelRequire("eNf8a");
const $177ac56c5a5bf49e$var$iphStorage = (0, $eNf8a.createSessionStorageProvider)('iph');
const $177ac56c5a5bf49e$export$ab1b80f40ca898ed = (navigationData)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            navigationData: {
                articleId: navigationData.articleId ? navigationData.articleId : currentState.navigationData.articleId,
                history: navigationData.history ? navigationData.history : currentState.navigationData.history
            }
        });
        $177ac56c5a5bf49e$var$iphStorage.set('history', []);
    };
const $177ac56c5a5bf49e$export$cdabe01d01a8da1e = (releaseNotesNotifications)=>({ setState: setState })=>{
        setState({
            releaseNotesNotifications: releaseNotesNotifications
        });
    };

});



const $0971f751295a2324$export$783d7c02e3a0cbf = 'help_panel_ui_state';

parcelRegister("7dTw7", function(module, exports) {

$parcel$export(module.exports, "RemoteStateUpdater", () => $52205ad66fbf5dd9$export$3db011870dd4330f);

var $5uXOq = parcelRequire("5uXOq");

var $laWvb = parcelRequire("laWvb");

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $90yGq = parcelRequire("90yGq");

var $kspz4 = parcelRequire("kspz4");

const $52205ad66fbf5dd9$var$DEBOUNCE_TIME = 1000;
const $52205ad66fbf5dd9$export$3db011870dd4330f = ()=>{
    // right-sidebar
    const [{ releaseNotesNotifications: releaseNotesNotifications }] = (0, $kspz4.useHelpPanel)();
    const [releaseNotesNotificationsTemp, setReleaseNotesNotificationsTemp] = (0, $5uXOq.useState)(releaseNotesNotifications);
    const accountId = (0, $90yGq.useAccountId)();
    const [debouncedUpdateData] = (0, $laWvb.default)(async (newReleaseNotesNotifications)=>{
        const remoteData = {
            helpPanel: {
                releaseNotesNotifications: newReleaseNotesNotifications
            }
        };
        if (accountId) try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $0971f751295a2324$export$783d7c02e3a0cbf), JSON.stringify(remoteData));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $jcw0u.default)({
                error: e,
                meta: {
                    id: 'updateServerHelpPanelState',
                    packageName: 'jiraHelpPanelServices',
                    teamName: 'self-help-experiences'
                }
            });
        }
    }, $52205ad66fbf5dd9$var$DEBOUNCE_TIME);
    (0, $5uXOq.useEffect)(()=>{
        if (releaseNotesNotificationsTemp !== releaseNotesNotifications) {
            setReleaseNotesNotificationsTemp(releaseNotesNotifications);
            debouncedUpdateData(releaseNotesNotifications);
        }
    }, [
        debouncedUpdateData,
        releaseNotesNotifications,
        releaseNotesNotificationsTemp
    ]);
    return null;
};

});
parcelRegister("laWvb", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6a7e96a5e9b4bd2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $f6a7e96a5e9b4bd2$export$2e2bcd8739ae039(callback, delay, options) {
    if (options === void 0) options = {};
    var maxWait = options.maxWait;
    var maxWaitHandler = (0, $5uXOq.useRef)(null);
    var maxWaitArgs = (0, $5uXOq.useRef)([]);
    var leading = options.leading;
    var trailing = options.trailing === undefined ? true : options.trailing;
    var leadingCall = (0, $5uXOq.useRef)(false);
    var functionTimeoutHandler = (0, $5uXOq.useRef)(null);
    var isComponentUnmounted = (0, $5uXOq.useRef)(false);
    var debouncedFunction = (0, $5uXOq.useRef)(callback);
    debouncedFunction.current = callback;
    var cancelDebouncedCallback = (0, $5uXOq.useCallback)(function() {
        clearTimeout(functionTimeoutHandler.current);
        clearTimeout(maxWaitHandler.current);
        maxWaitHandler.current = null;
        maxWaitArgs.current = [];
        functionTimeoutHandler.current = null;
        leadingCall.current = false;
    }, []);
    (0, $5uXOq.useEffect)(function() {
        return function() {
            // we use flag, as we allow to call callPending outside the hook
            isComponentUnmounted.current = true;
        };
    }, []);
    var debouncedCallback = (0, $5uXOq.useCallback)(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        maxWaitArgs.current = args;
        clearTimeout(functionTimeoutHandler.current);
        if (leadingCall.current) leadingCall.current = false;
        if (!functionTimeoutHandler.current && leading && !leadingCall.current) {
            debouncedFunction.current.apply(debouncedFunction, args);
            leadingCall.current = true;
        }
        functionTimeoutHandler.current = setTimeout(function() {
            var shouldCallFunction = true;
            if (leading && leadingCall.current) shouldCallFunction = false;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current && trailing && shouldCallFunction) debouncedFunction.current.apply(debouncedFunction, args);
        }, delay);
        if (maxWait && !maxWaitHandler.current && trailing) maxWaitHandler.current = setTimeout(function() {
            var args = maxWaitArgs.current;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current) debouncedFunction.current.apply(null, args);
        }, maxWait);
    }, [
        maxWait,
        delay,
        cancelDebouncedCallback,
        leading,
        trailing
    ]);
    var callPending = (0, $5uXOq.useCallback)(function() {
        // Call pending callback only if we have anything in our queue
        if (!functionTimeoutHandler.current) return;
        debouncedFunction.current.apply(null, maxWaitArgs.current);
        cancelDebouncedCallback();
    }, [
        cancelDebouncedCallback
    ]);
    // At the moment, we use 3 args array so that we save backward compatibility
    return [
        debouncedCallback,
        cancelDebouncedCallback,
        callPending
    ];
}

});


parcelRegister("1SVH7", function(module, exports) {

$parcel$export(module.exports, "LazyHelpPanel", () => $311d1a0e95633292$export$51c79455aef7d178);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $7iJwP = parcelRequire("7iJwP");

var $6s1PB = parcelRequire("6s1PB");

var $lfTZh = parcelRequire("lfTZh");

var $cYlk7 = parcelRequire("cYlk7");

var $iXVV6 = parcelRequire("iXVV6");

var $6Lg6A = parcelRequire("6Lg6A");

var $jVpMq = parcelRequire("jVpMq");

var $7rrMi = parcelRequire("7rrMi");

var $4RupH = parcelRequire("4RupH");
const $311d1a0e95633292$export$51c79455aef7d178 = ({ navigationData: { articleId: articleId, history: history }, setNavigationData: setNavigationData, releaseNotesNotifications: releaseNotesNotifications, releaseNotesNotificationsSetter: releaseNotesNotificationsSetter, isOpen: isOpen, onCloseHelpPanel: onCloseHelpPanel, hasBeenRendered: hasBeenRendered, routeGroup: routeGroup, routeName: routeName })=>{
    const user = (0, $cYlk7.useCurrentUser)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "help-panel",
        packageName: "jiraHelpPanel",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jVpMq.default), {
                loadingArticle: articleId.id !== ''
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        id: "root",
        packageName: "jiraHelpPanel",
        teamName: "self-help-experiences"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7rrMi.SearchContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        tags: [
            'iph'
        ],
        sourceName: "jiraHelpPanel",
        sourceType: (0, $4d5e0871c06cee03$export$9d2de6eebf7462b5),
        attributes: {
            searchService: (0, $6s1PB.expVal)('20240422_self_help_iph_ms3_expt', 'iph_ms3_experience_display_flag', false) ? 'help-aggregator' : 'algolia',
            routeGroup: routeGroup,
            routeName: routeName,
            userId: user?.data?.user?.accountId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Lg6A.LazyWait), {
        until: hasBeenRendered
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-lazy-help-panel",
        fallback: isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jVpMq.default), {
            loadingArticle: articleId.id !== ''
        }) : null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4RupH.AsyncLazyHelpPanel), {
        navigationData: {
            articleId: articleId,
            history: history
        },
        releaseNotesNotificationsSetter: releaseNotesNotificationsSetter,
        releaseNotesNotifications: releaseNotesNotifications,
        setNavigationData: setNavigationData,
        isOpen: isOpen,
        onCloseHelpPanel: onCloseHelpPanel,
        routeGroup: routeGroup,
        routeName: routeName
    })))))));
};

});
parcelRegister("jVpMq", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8bb188482996cb7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5CrlE = parcelRequire("5CrlE");
const $b8bb188482996cb7$var$HelpPanelLoading = ({ loadingArticle: loadingArticle = false })=>loadingArticle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5CrlE.HelpPanelContainerV2), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$HeaderLoading, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        role: "img",
        "aria-label": "help panel loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-250, 20px)",
        marginTop: "var(--ds-space-0, 0px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "90%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "80%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "80%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "80%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "80%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "70%"
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5CrlE.HelpPanelContainerV2), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$HeaderLoading, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-500, 40px)",
        marginTop: "var(--ds-space-100, 8px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadignArticleList, {
        role: "img"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadignArticleListItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-150, 12px)",
        contentWidth: "var(--ds-space-800, 64px)",
        marginTop: "var(--ds-space-0, 0px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-150, 12px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadignArticleListItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-150, 12px)",
        contentWidth: "var(--ds-space-800, 64px)",
        marginTop: "var(--ds-space-0, 0px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-150, 12px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadignArticleListItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-150, 12px)",
        contentWidth: "var(--ds-space-800, 64px)",
        marginTop: "var(--ds-space-0, 0px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-150, 12px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    })))));
var $b8bb188482996cb7$export$2e2bcd8739ae039 = $b8bb188482996cb7$var$HelpPanelLoading;
/**
 * Header
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b8bb188482996cb7$var$LoadingContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $b8bb188482996cb7$var$HeaderLoading = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_n7zlnq84 _4t3ixncg _bfhkfg4m _1bah1yb4 _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $b8bb188482996cb7$var$shimmer = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b8bb188482996cb7$var$LoadingRectangle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { contentHeight: contentHeight, marginTop: marginTop, contentWidth: contentWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_l7mdyr": (0, $lD23V.default)(__cmplp.contentHeight),
            "--_1fj4wta": (0, $lD23V.default)(__cmplp.marginTop),
            "--_7n1eiw": (0, $lD23V.default)(__cmplp.contentWidth)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkov77o _kqswh2mm _5sag126j _1o51q7pw _tip812c5 _j7hq1en8 _1pglp3kn _bfhk1v33 _1itkaioo _12vemgnk",
            __cmplp.contentHeight != null ? "_4t3i6c59" : "_4t3ipxbi",
            __cmplp.marginTop != null ? "_19pkmye1" : "_19pku2gc",
            __cmplp.contentWidth != null ? "_1bsbwd3v" : "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $b8bb188482996cb7$var$LoadignArticleList = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _19pku2gc _2hwxidpf _otyridpf _18u0idpf _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _vchhusvi",
            __cmplp.className
        ])
    });
});
const $b8bb188482996cb7$var$LoadignArticleListItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _1bsb1osq _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _vchhusvi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5CrlE", function(module, exports) {

$parcel$export(module.exports, "HelpPanelContainer", () => $2dbd0534194918a8$export$37cd645d7678f7d4);
$parcel$export(module.exports, "HelpPanelContainerV2", () => $2dbd0534194918a8$export$1df7e3ebfc4c9b06);
$parcel$export(module.exports, "HelpPanelSectionMessageContainer", () => $2dbd0534194918a8$export$9f6251c714594f23);
$parcel$export(module.exports, "HelpPanelContentContainer", () => $2dbd0534194918a8$export$1cdb922eed7271d1);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");
const $2dbd0534194918a8$export$37cd645d7678f7d4 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _vchhusvi _2lx21bp4 _1bsb1feq _4t3i1osq _kqsw1n9t",
            !((0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('platform_design_system_nav4_panel_default_border')) && "_1kl7pu5c",
            __cmplp.className
        ])
    });
});
const $2dbd0534194918a8$export$1df7e3ebfc4c9b06 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $2dbd0534194918a8$export$37cd645d7678f7d4, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1i8v _bfhk1bhr",
            __cmplp.className
        ])
    });
});
const $2dbd0534194918a8$export$9f6251c714594f23 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _ca0qpxbi _u5f3pxbi _n3tdidpf _19bvpxbi _1bsb1osq _vchhusvi",
            __cmplp.className
        ])
    });
});
const $2dbd0534194918a8$export$1cdb922eed7271d1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1tkeidpf _kqswh2mm _18m91wug _1reo15vq _1e0c1txw _2lx21bp4 _1n261q9c _1bah1y6m _ae4v1fhb _4cvr1y6m",
            __cmplp.className
        ])
    });
});

});


parcelRegister("7rrMi", function(module, exports) {

$parcel$export(module.exports, "useSearchContext", () => $c0047fc735c61769$export$67b98b1b880a048b);
$parcel$export(module.exports, "SearchContextProvider", () => $c0047fc735c61769$export$6bd70292443463a4);

var $5uXOq = parcelRequire("5uXOq");

var $jFLAi = parcelRequire("jFLAi");
const [$c0047fc735c61769$export$67b98b1b880a048b, $c0047fc735c61769$export$70af50e847ce290a] = (0, $jFLAi.createCtx)();
const $c0047fc735c61769$export$6bd70292443463a4 = ({ children: children })=>{
    const [searchContext, setSearchContext] = (0, $5uXOq.useState)({});
    const addClickedArticleIds = (0, $5uXOq.useCallback)((query, clickedArticleId)=>{
        setSearchContext((prev)=>({
                ...prev,
                [query]: {
                    ...prev[query],
                    clickedArticleIds: prev[query]?.clickedArticleIds ? [
                        ...prev[query].clickedArticleIds,
                        clickedArticleId
                    ] : [
                        clickedArticleId
                    ]
                }
            }));
    }, []);
    const addFetchedArticleIds = (0, $5uXOq.useCallback)((query, fetchedArticles)=>{
        setSearchContext((prev)=>({
                ...prev,
                [query]: {
                    ...prev[query],
                    fetchedArticleIds: fetchedArticles
                }
            }));
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c0047fc735c61769$export$70af50e847ce290a, {
        value: {
            searchContext: searchContext,
            addClickedArticleIds: addClickedArticleIds,
            addFetchedArticleIds: addFetchedArticleIds
        }
    }, children);
};

});
parcelRegister("jFLAi", function(module, exports) {

$parcel$export(module.exports, "createCtx", () => $b612e461f4fc901f$export$d653a1a643c9a98c);

var $5uXOq = parcelRequire("5uXOq");
function $b612e461f4fc901f$export$d653a1a643c9a98c() {
    const ctx = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
    function useCtx() {
        const c = (0, $5uXOq.useContext)(ctx);
        if (!c) throw new Error('useCtx must be inside a Provider with a value');
        return c;
    }
    return [
        useCtx,
        ctx.Provider
    ];
}

});


parcelRegister("4RupH", function(module, exports) {

$parcel$export(module.exports, "AsyncLazyHelpPanel", () => $4ce54108d7c5ac07$export$7ff46d33d0f13518);

var $kxZPA = parcelRequire("kxZPA");

const $4ce54108d7c5ac07$export$7ff46d33d0f13518 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("bWxvo")).then(({ HelpPanel: HelpPanel })=>HelpPanel), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/help-panel/src/ui/index.tsx"
});

});
parcelRegister("bWxvo", function(module, exports) {

let $8b1f19f820f4776a$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $8b1f19f820f4776a$var$load("ffQaD"),
    $8b1f19f820f4776a$var$load("kvRbA"),
    $8b1f19f820f4776a$var$load("kNFvF"),
    $8b1f19f820f4776a$var$load("1sdCF")
]).then(()=>parcelRequire('jj3on'));

});




parcelRegister("9YvQF", function(module, exports) {

$parcel$export(module.exports, "SafeEmbeddedConfluencePanel", () => $3e89344d89118823$export$2d901a489872dd0d);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $9KYrx = parcelRequire("9KYrx");

var $gXSrH = parcelRequire("gXSrH");

var $7CMCs = parcelRequire("7CMCs");

var $hsmeR = parcelRequire("hsmeR");

var $9V9QO = parcelRequire("9V9QO");
const $3e89344d89118823$var$DELAY = 310;
const $3e89344d89118823$export$2db0a2e0275af8b8 = ()=>{
    const rightSidebarCurrentState = (0, $hsmeR.useActiveRightSidebarState)();
    const [{ panel: isOpen }] = (0, $gXSrH.useEmbeddedConfluenceSidePanel)();
    const [localPanelId, setLocalPanelId] = (0, $5uXOq.useState)();
    const prevPanelIdRef = (0, $5uXOq.useRef)();
    const delayRef = (0, $5uXOq.useRef)(null);
    const panelId = rightSidebarCurrentState?.panelId;
    const { entryPointActions: entryPointActions, entryPoint: entryPoint } = (0, $9V9QO.useEmbeddedPanelEntryPoint)();
    (0, $5uXOq.useEffect)(()=>{
        if (isOpen) entryPointActions?.load();
    }, [
        isOpen,
        entryPointActions,
        localPanelId
    ]);
    /**
	 * This use effect is used to add (when is necessary) a delay
	 * in the panelId => localPanelId syncing
	 */ (0, $5uXOq.useEffect)(()=>{
        // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(delayRef.current);
        if (prevPanelIdRef.current === (0, $9KYrx.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)) {
            /**
			 * The right-sidebar is showing the embedded confluence content...
			 */ if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) /**
				 * and is open, not collapsed and we want to show a panel
				 * with an ID !== EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID
				 */ setLocalPanelId(panelId);
            else /**
				 * and we want to close it
				 */ delayRef.current = setTimeout(()=>{
                setLocalPanelId(panelId);
            // TODO: trigger close analytics event
            }, $3e89344d89118823$var$DELAY);
        } else /**
			 * If the right sidebar is not showing the embedded confluence content,
			 * we just keep localPanelId in sync with panelId
			 */ setLocalPanelId(panelId);
        prevPanelIdRef.current = panelId;
        // @ts-expect-error - TS2769 - No overload matches this call.
        return ()=>clearTimeout(delayRef.current);
    }, [
        panelId,
        rightSidebarCurrentState
    ]);
    if (localPanelId !== (0, $9KYrx.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $3e89344d89118823$var$panelStyles
    }, entryPoint);
};
const $3e89344d89118823$export$2d901a489872dd0d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-side-embedded-confluence-panel",
        packageName: "jiraIssueCreateConfluenceContent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gXSrH.EmbeddedConfluenceSidepanelContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3e89344d89118823$export$2db0a2e0275af8b8, null)));
const $3e89344d89118823$var$panelStyles = (0, $8CUq3.xcss)({
    padding: 'space.100',
    height: 'calc(100vh - (var(--topNavigationHeight, 0px) + var(--bannerHeight, 0px)))'
});

});
parcelRegister("9KYrx", function(module, exports) {

$parcel$export(module.exports, "ConfluenceFeatureKeys", () => $e486b17128606747$export$746d4746bf07dd70);
$parcel$export(module.exports, "CONFLUENCE_CONTROLS_STORAGE_KEY", () => $e486b17128606747$export$6247c7e19b71f4e);
$parcel$export(module.exports, "CONFLUENCE_ACCESS_STORAGE_KEY", () => $e486b17128606747$export$e34c4c923d934e7a);
$parcel$export(module.exports, "CONFLUENCE_CONTROLS_STORAGE_PROVIDER_KEY", () => $e486b17128606747$export$ffe60197eb59ca73);
$parcel$export(module.exports, "CONFLUENCE_ACCESS_STORAGE_PROVIDER_KEY", () => $e486b17128606747$export$8d0c4a26241944b8);
$parcel$export(module.exports, "EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID", () => $e486b17128606747$export$a497288e64e9a343);
const $e486b17128606747$export$746d4746bf07dd70 = {
    ENABLE_CONFLUENCE_SIGNUP: 'jira.admin.confluence.enable-integrations',
    SPRINT_RETRO: 'jira.admin.confluence.enable-sprint-retros',
    CREATE_MENU_TOP_ACTIONS: 'jira.admin.confluence.enable-content-creation-issue-top-actions',
    CREATE_MENU_CONFLUENCE_CONTENT: 'jira.admin.confluence.enable-content-creation-issue-confluence-content'
};
const $e486b17128606747$export$6247c7e19b71f4e = 'confluence-integration-controls';
const $e486b17128606747$export$e34c4c923d934e7a = 'user-confluence-access';
const $e486b17128606747$export$ffe60197eb59ca73 = 'confluence-integration-controls-session-storage';
const $e486b17128606747$export$8d0c4a26241944b8 = 'confluence-permissions-session-storage';
const $e486b17128606747$export$a497288e64e9a343 = 'embedded-confluence-panel-container';

});

parcelRegister("gXSrH", function(module, exports) {

$parcel$export(module.exports, "EmbeddedConfluenceSidepanelContainer", () => $27a5db923b3bcebb$export$a5c1c168018f0f16);
$parcel$export(module.exports, "useEmbeddedConfluenceSidePanel", () => $27a5db923b3bcebb$export$518aeea31a00450e);

var $5uXOq = parcelRequire("5uXOq");

var $2gCtH = parcelRequire("2gCtH");

var $hsmeR = parcelRequire("hsmeR");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $9KYrx = parcelRequire("9KYrx");

var $aQLD7 = parcelRequire("aQLD7");

var $bvqNo = parcelRequire("bvqNo");

var $5labn = parcelRequire("5labn");
/**
 * Container for {@link useEmbeddedConfluenceSidePanel}. Any component that uses this hook
 * must be wrapped in this container.
 */ const $27a5db923b3bcebb$var$Container = (0, $gg7kZ.createContainer)();
const $27a5db923b3bcebb$var$DefaultStore = (0, $iXqE5.createStore)({
    actions: $aQLD7.actions,
    containedBy: $27a5db923b3bcebb$var$Container,
    initialState: $aQLD7.initialState,
    name: (0, $9KYrx.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)
});
const $27a5db923b3bcebb$export$a5c1c168018f0f16 = ({ children: children })=>{
    const issueKey = (0, $2gCtH.useIssueKey)();
    /*
	In order for each usage of the store to manage the same state irregardless of
	their location in the component tree, we need to wrap components in a container
	with the same scope value. This is why we use the issueKey in the scope value.
	see https://atlassian.github.io/react-sweet-state/#/advanced/container?id=scoped-data-sharing
	for more information about scoped data sharing.

	*/ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($27a5db923b3bcebb$var$Container, {
        scope: `embedded-confluence-sidepanel-${issueKey}`
    }, children);
};
const $27a5db923b3bcebb$var$defaultStoreHook = (0, $3sQ5x.createHook)($27a5db923b3bcebb$var$DefaultStore);
const $27a5db923b3bcebb$export$518aeea31a00450e = (embeddedConfluenceSource)=>{
    const [state, { closeSidePanel: closeSidePanelAction, openSidePanel: openSidePanelAction, setIsLoadingForDeferSpaceSelection: setIsLoadingForDeferSpaceSelection, setDeferredSpaceData: setDeferredSpaceData, toggleExpandedState: toggleExpandedState, setIsDraftState: setIsDraftState, setConfluenceData: setConfluenceData }] = $27a5db923b3bcebb$var$defaultStoreHook();
    const { closeRightSidebar: closeRightSidebar, openRightSidebar: openRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const openSidePanel = (0, $5uXOq.useCallback)(({ contentId: contentId, contentType: contentType, data: data, hostname: hostname, isDraft: isDraft, isLive: isLive, onLinkPage: onLinkPage, onPublish: onPublish, openInModal: openInModal, mode: mode, url: url, title: title })=>{
        const { initialWidth: initialWidth, displayType: displayType } = (0, $5labn.getDisplayInformation)();
        const shouldOpenPanel = displayType === (0, $bvqNo.DisplayTypes).PANEL;
        if (shouldOpenPanel) {
            openSidePanelAction({
                contentId: contentId,
                contentType: contentType,
                embeddedConfluenceSource: embeddedConfluenceSource,
                data: data,
                displayType: displayType,
                initialWidth: initialWidth,
                hostname: hostname,
                isDraft: isDraft,
                isLive: isLive,
                mode: mode,
                onLinkPage: onLinkPage,
                onPublish: onPublish,
                shouldOpenModal: !shouldOpenPanel,
                url: url,
                title: title
            });
            openRightSidebar((0, $9KYrx.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID), initialWidth, false, true);
        } else openInModal();
    }, [
        embeddedConfluenceSource,
        openRightSidebar,
        openSidePanelAction
    ]);
    const closeSidePanel = (0, $5uXOq.useCallback)(()=>{
        closeRightSidebar((0, $9KYrx.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID));
        closeSidePanelAction();
    }, [
        closeRightSidebar,
        closeSidePanelAction
    ]);
    return [
        state,
        {
            openSidePanel: openSidePanel,
            closeSidePanel: closeSidePanel,
            setDeferredSpaceData: setDeferredSpaceData,
            setIsLoadingForDeferSpaceSelection: setIsLoadingForDeferSpaceSelection,
            toggleExpandedState: toggleExpandedState,
            setIsDraftState: setIsDraftState,
            setConfluenceData: setConfluenceData
        }
    ];
};

});
parcelRegister("aQLD7", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $0ebe24e18a9cec5a$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "actions", () => $0ebe24e18a9cec5a$export$e324594224ef24da);

var $gVnoy = parcelRequire("gVnoy");
var $idTx8 = parcelRequire("idTx8");

var $bvqNo = parcelRequire("bvqNo");
const $0ebe24e18a9cec5a$export$d4c72bab9d6cc13a = {
    confluenceData: {
        contentId: '',
        contentUrl: '',
        contentData: null,
        mode: (0, $gVnoy.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
        isDraft: false,
        isLive: false
    },
    contentActions: {},
    contentType: (0, $bvqNo.ConfluenceContentTypes).PAGE,
    embeddedConfluenceSource: '',
    displayType: (0, $bvqNo.DisplayTypes).PANEL,
    panel: {
        initialWidth: 0,
        isOpen: false,
        isLoading: false,
        isExpanded: false
    },
    modal: {
        isOpen: false
    }
};
const $0ebe24e18a9cec5a$export$aa5d06fef96639ba = ({ contentId: contentId, contentType: contentType, embeddedConfluenceSource: embeddedConfluenceSource, data: data, displayType: displayType, initialWidth: initialWidth, hostname: hostname, isDraft: isDraft, isLive: isLive, isExpanded: isExpanded, mode: mode, onLinkPage: onLinkPage, onPublish: onPublish, shouldOpenModal: shouldOpenModal, url: url, title: title })=>({ setState: setState })=>{
        setState({
            confluenceData: {
                contentId: contentId,
                contentUrl: url,
                contentData: data,
                hostname: hostname,
                mode: mode,
                isDraft: isDraft,
                isLive: isLive,
                title: title,
                spaceKey: (0, $idTx8.parseUrl)(url)?.spaceKey
            },
            contentActions: {
                onLinkPage: onLinkPage,
                onPublish: onPublish
            },
            embeddedConfluenceSource: embeddedConfluenceSource,
            contentType: contentType,
            displayType: displayType,
            panel: {
                initialWidth: initialWidth,
                isOpen: !shouldOpenModal,
                isExpanded: isExpanded
            },
            modal: {
                isOpen: shouldOpenModal
            }
        });
    };
const $0ebe24e18a9cec5a$export$e81b26ab493ca52a = ()=>({ setState: setState })=>{
        setState($0ebe24e18a9cec5a$export$d4c72bab9d6cc13a);
    };
const $0ebe24e18a9cec5a$export$473e6cac57a0d506 = (deferredSpaceName, deferredSpaceKey)=>({ setState: setState, getState: getState })=>{
        const { confluenceData: confluenceData, ...prevState } = getState();
        setState({
            confluenceData: {
                ...confluenceData,
                deferredSpaceName: deferredSpaceName,
                spaceKey: deferredSpaceKey || confluenceData.spaceKey
            },
            ...prevState
        });
    };
const $0ebe24e18a9cec5a$export$db9852cd4946540a = ({ isLoading: isLoading, isDeferSpaceSelection: isDeferSpaceSelection })=>({ setState: setState, getState: getState })=>{
        const { panel: panel, ...prevState } = getState();
        setState({
            ...prevState,
            isDeferSpaceSelection: isDeferSpaceSelection,
            panel: {
                ...panel,
                isLoading: isLoading
            }
        });
    };
const $0ebe24e18a9cec5a$export$b29d56f843007f2b = ()=>({ setState: setState, getState: getState })=>{
        const { panel: panel, ...prevState } = getState();
        const isCurrentlyExpanded = panel.isExpanded;
        setState({
            panel: {
                ...panel,
                isExpanded: !isCurrentlyExpanded
            },
            ...prevState
        });
    };
const $0ebe24e18a9cec5a$export$5d0561abb73760f = ({ newIsDraftState: newIsDraftState })=>({ setState: setState, getState: getState })=>{
        const { confluenceData: confluenceData, ...prevState } = getState();
        setState({
            confluenceData: {
                ...confluenceData,
                isDraft: newIsDraftState
            },
            ...prevState
        });
    };
const $0ebe24e18a9cec5a$export$1a8782a287467f35 = (newData)=>({ setState: setState, getState: getState })=>{
        const { confluenceData: confluenceData, ...prevState } = getState();
        setState({
            confluenceData: {
                ...confluenceData,
                ...newData
            },
            ...prevState
        });
    };
const $0ebe24e18a9cec5a$export$e324594224ef24da = {
    closeSidePanel: $0ebe24e18a9cec5a$export$e81b26ab493ca52a,
    openSidePanel: $0ebe24e18a9cec5a$export$aa5d06fef96639ba,
    setDeferredSpaceData: $0ebe24e18a9cec5a$export$473e6cac57a0d506,
    setIsDraftState: $0ebe24e18a9cec5a$export$5d0561abb73760f,
    setIsLoadingForDeferSpaceSelection: $0ebe24e18a9cec5a$export$db9852cd4946540a,
    toggleExpandedState: $0ebe24e18a9cec5a$export$b29d56f843007f2b,
    setConfluenceData: $0ebe24e18a9cec5a$export$1a8782a287467f35
};

});
parcelRegister("gVnoy", function(module, exports) {

$parcel$export(module.exports, "EMBEDDED_CONFLUENCE_MODE", () => $7526d97b8e22777b$export$816ef638e478449a);
var $7526d97b8e22777b$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    return EMBEDDED_CONFLUENCE_MODE;
}({});

});

parcelRegister("idTx8", function(module, exports) {

$parcel$export(module.exports, "parsePageProps", () => $0293942286a77e0f$export$41eb0a358b69a9df);
$parcel$export(module.exports, "parseUrl", () => $0293942286a77e0f$export$7a5253c0f62e0150);
parcelRequire("02YCa");
var $7ziRZ = parcelRequire("7ziRZ");

var $imVhc = parcelRequire("imVhc");

var $39itI = parcelRequire("39itI");

var $gVnoy = parcelRequire("gVnoy");

var $jFSxp = parcelRequire("jFSxp");
function $0293942286a77e0f$export$41eb0a358b69a9df(props) {
    let { contentId: contentId = '', hostname: hostname, parentProduct: parentProduct = '', spaceKey: spaceKey, url: url, allowedFeatures: allowedFeatures, mode: mode, draftShareId: draftShareId, hash: hash, themeState: themeState, showFooter: showFooter, ...passThroughProps } = props;
    const parsedAllowedFeatures = $0293942286a77e0f$export$350c411f568eceb9(allowedFeatures);
    if (!url) return {
        contentId: contentId,
        hostname: hostname,
        parentProduct: parentProduct,
        spaceKey: spaceKey,
        protocol: 'https:',
        mode: mode ?? (0, $gVnoy.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
        allowedFeatures: parsedAllowedFeatures,
        draftShareId: draftShareId,
        hash: hash,
        themeState: themeState,
        showFooter: showFooter,
        ...passThroughProps
    };
    const parsedProps = $0293942286a77e0f$export$7a5253c0f62e0150(url);
    if (!parsedProps) return {
        hostname: hostname,
        contentId: contentId,
        spaceKey: spaceKey,
        parentProduct: parentProduct,
        mode: mode,
        protocol: 'https:',
        allowedFeatures: parsedAllowedFeatures,
        draftShareId: draftShareId,
        hash: hash,
        themeState: themeState,
        showFooter: showFooter,
        ...passThroughProps
    };
    const themeStateParsedObject = parsedProps.themeState ? (0, $imVhc.themeStringToObject)(decodeURIComponent(parsedProps.themeState)) : undefined;
    // Override with URL-extracted props
    contentId = contentId || parsedProps.contentId;
    parentProduct = parentProduct || parsedProps.parentProduct || '';
    hostname = hostname || parsedProps.hostname || window.location.hostname;
    spaceKey = spaceKey || parsedProps.spaceKey;
    draftShareId = draftShareId || parsedProps.draftShareId;
    hash = hash || parsedProps.hash;
    themeState = themeState || themeStateParsedObject;
    let modeFromUrl;
    switch(parsedProps.route){
        case (0, $jFSxp.VIEW_PAGE).name:
        case (0, $jFSxp.VIEW_BLOG).name:
        case (0, $jFSxp.VIEW_BLOG_DATE_LEGACY).name:
            modeFromUrl = (0, $gVnoy.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE;
            break;
        case (0, $jFSxp.EDIT_PAGE_EMBED).name:
        case (0, $jFSxp.EDIT_PAGE_V2).name:
            modeFromUrl = (0, $gVnoy.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE;
            break;
        case (0, $jFSxp.WHITEBOARD).name:
    }
    const contentSlug = parsedProps.route === (0, $jFSxp.VIEW_BLOG_DATE_LEGACY).name ? undefined : parsedProps.contentSlug;
    return {
        allowedFeatures: parsedAllowedFeatures,
        contentId: contentId,
        draftShareId: draftShareId,
        hash: hash,
        hostname: hostname,
        mode: mode || modeFromUrl,
        parentProduct: parentProduct,
        protocol: parsedProps.protocol,
        spaceKey: spaceKey,
        themeState: themeState,
        contentSlug: contentSlug,
        showFooter: showFooter,
        ...passThroughProps
    };
}
function $0293942286a77e0f$export$7a5253c0f62e0150(url) {
    if (!url) return null;
    const matchedRoute = $0293942286a77e0f$var$findAndMatchRoute((0, $jFSxp.namedRoutes), url);
    if (!matchedRoute) return null;
    const { routeName: routeName, ...match } = matchedRoute;
    const { year: year, month: month, day: day, contentId: contentId } = match.params;
    // Validate date parameters
    const isValidYear = /^\d+$/.test(year || '');
    const isValidMonth = /^\d+$/.test(month || '');
    const isValidDay = /^\d+$/.test(day || '');
    const isValidContentId = /^\d+$/.test(contentId || '');
    // If route requires validation, and any parameter is invalid, return null
    if (routeName === (0, $jFSxp.VIEW_BLOG_DATE_LEGACY).name && (!isValidYear || !isValidMonth || !isValidDay || !isValidContentId)) return null;
    return {
        route: routeName,
        hostname: match.host,
        protocol: match.protocol,
        contentId: contentId || '',
        spaceKey: match.params.spaceKey || '',
        hash: match.hash || '',
        // EP currently supports only 1 parent product, no more than 1 parent product should be passed in
        parentProduct: Array.isArray(match.query.parentProduct) ? match.query.parentProduct[0] : match.query.parentProduct || '',
        draftShareId: Array.isArray(match.query.draftShareId) ? match.query.draftShareId[0] : match.query.draftShareId,
        themeState: match.query.themeState,
        contentSlug: match.params.contentSlug || undefined,
        query: match.query
    };
}
function $0293942286a77e0f$var$findAndMatchRoute(routes, url) {
    for (const routeKey of Object.keys(routes)){
        const route = routes[routeKey];
        const match = $0293942286a77e0f$var$matchUrl(route.pattern, url);
        if (match) return {
            routeName: route.name,
            ...match
        };
    }
    return null;
}
function $0293942286a77e0f$var$isValidURL(url) {
    try {
        new URL(url, window.location.origin);
        return true;
    } catch  {
        return false;
    }
}
function $0293942286a77e0f$var$matchUrl(pattern, url) {
    if (!$0293942286a77e0f$var$isValidURL(url)) return null;
    const parsed = new URL(url, window.location.origin);
    const pathname = parsed.pathname || '';
    const search = parsed.search || '';
    let match = (0, $7ziRZ.matchPath)({
        path: pattern,
        end: true
    }, pathname);
    // If initial match fails and the route requires query parameters, attempt to match including search
    // some of our routes need query params to match
    if (!match && search) match = (0, $7ziRZ.matchPath)({
        path: pattern,
        end: true
    }, `${pathname}${search}`);
    if (!match) return null;
    // URI decode params
    const decodedParams = {};
    if (match.params) {
        for (const [key, value] of Object.entries(match.params))if (value !== undefined) decodedParams[key] = value;
    }
    return {
        url: url,
        protocol: parsed.protocol,
        host: parsed.host,
        pathname: pathname,
        search: parsed.search,
        hash: parsed.hash,
        pattern: pattern,
        params: decodedParams,
        query: Object.fromEntries(parsed.searchParams.entries())
    };
}
function $0293942286a77e0f$export$350c411f568eceb9(allowedFeatures) {
    let parsedAllowedFeatures = {
        view: allowedFeatures?.view,
        edit: allowedFeatures?.edit
    };
    if (!allowedFeatures?.view) parsedAllowedFeatures.view = [
        ...(0, $39itI.DEFAULT_ALLOWED_FEATURES).view,
        'edit'
    ];
    else if (Array.isArray(allowedFeatures.view)) parsedAllowedFeatures.view = [
        ...allowedFeatures.view,
        'edit'
    ];
    return parsedAllowedFeatures;
}

});
parcelRegister("02YCa", function(module, exports) {

$parcel$export(module.exports, "matchPath", () => (parcelRequire("7ziRZ")).matchPath);
/**
 * React Router v6.28.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $7ziRZ = parcelRequire("7ziRZ");
function $008f34d502bbfdeb$var$_extends() {
    $008f34d502bbfdeb$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $008f34d502bbfdeb$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $008f34d502bbfdeb$export$3add0d5dce533e2e = /*#__PURE__*/ $5uXOq.createContext(null);
const $008f34d502bbfdeb$export$145dfa71566a64dc = /*#__PURE__*/ $5uXOq.createContext(null);
const $008f34d502bbfdeb$var$AwaitContext = /*#__PURE__*/ $5uXOq.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $008f34d502bbfdeb$export$26749e8557646306 = /*#__PURE__*/ $5uXOq.createContext(null);
const $008f34d502bbfdeb$export$c7914228fb69b0f5 = /*#__PURE__*/ $5uXOq.createContext(null);
const $008f34d502bbfdeb$export$9072aa6dd1f93057 = /*#__PURE__*/ $5uXOq.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $008f34d502bbfdeb$var$RouteErrorContext = /*#__PURE__*/ $5uXOq.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $008f34d502bbfdeb$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$008f34d502bbfdeb$export$9c954a9d03d32f4a() && (0, $7ziRZ.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $5uXOq.useContext($008f34d502bbfdeb$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $008f34d502bbfdeb$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $7ziRZ.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $008f34d502bbfdeb$export$9c954a9d03d32f4a() {
    return $5uXOq.useContext($008f34d502bbfdeb$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $008f34d502bbfdeb$export$45d76561a5302f2b() {
    !$008f34d502bbfdeb$export$9c954a9d03d32f4a() && (0, $7ziRZ.UNSAFE_invariant)(false);
    return $5uXOq.useContext($008f34d502bbfdeb$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $008f34d502bbfdeb$export$1b3f31771c5d07c() {
    return $5uXOq.useContext($008f34d502bbfdeb$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $008f34d502bbfdeb$export$6c330e8992e8a295(pattern) {
    !$008f34d502bbfdeb$export$9c954a9d03d32f4a() && (0, $7ziRZ.UNSAFE_invariant)(false);
    let { pathname: pathname } = $008f34d502bbfdeb$export$45d76561a5302f2b();
    return $5uXOq.useMemo(()=>(0, $7ziRZ.matchPath)(pattern, (0, $7ziRZ.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $008f34d502bbfdeb$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $008f34d502bbfdeb$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $5uXOq.useContext($008f34d502bbfdeb$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $5uXOq.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $008f34d502bbfdeb$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $5uXOq.useContext($008f34d502bbfdeb$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $008f34d502bbfdeb$var$useNavigateStable() : $008f34d502bbfdeb$var$useNavigateUnstable();
}
function $008f34d502bbfdeb$var$useNavigateUnstable() {
    !$008f34d502bbfdeb$export$9c954a9d03d32f4a() && (0, $7ziRZ.UNSAFE_invariant)(false);
    let dataRouterContext = $5uXOq.useContext($008f34d502bbfdeb$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $5uXOq.useContext($008f34d502bbfdeb$export$26749e8557646306);
    let { matches: matches } = $5uXOq.useContext($008f34d502bbfdeb$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $008f34d502bbfdeb$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $7ziRZ.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $5uXOq.useRef(false);
    $008f34d502bbfdeb$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $5uXOq.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $7ziRZ.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $7ziRZ.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $008f34d502bbfdeb$var$OutletContext = /*#__PURE__*/ $5uXOq.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $008f34d502bbfdeb$export$4138103a3ae699cc() {
    return $5uXOq.useContext($008f34d502bbfdeb$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $008f34d502bbfdeb$export$a3be3530d8e40d0b(context) {
    let outlet = $5uXOq.useContext($008f34d502bbfdeb$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $5uXOq.createElement($008f34d502bbfdeb$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $008f34d502bbfdeb$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $5uXOq.useContext($008f34d502bbfdeb$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $008f34d502bbfdeb$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $5uXOq.useContext($008f34d502bbfdeb$export$26749e8557646306);
    let { matches: matches } = $5uXOq.useContext($008f34d502bbfdeb$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $008f34d502bbfdeb$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $7ziRZ.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $5uXOq.useMemo(()=>(0, $7ziRZ.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $008f34d502bbfdeb$export$5d3fca4a98652595(routes, locationArg) {
    return $008f34d502bbfdeb$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $008f34d502bbfdeb$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$008f34d502bbfdeb$export$9c954a9d03d32f4a() && (0, $7ziRZ.UNSAFE_invariant)(false);
    let { navigator: navigator } = $5uXOq.useContext($008f34d502bbfdeb$export$26749e8557646306);
    let { matches: parentMatches } = $5uXOq.useContext($008f34d502bbfdeb$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $008f34d502bbfdeb$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $7ziRZ.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $7ziRZ.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $7ziRZ.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $008f34d502bbfdeb$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $7ziRZ.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $7ziRZ.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $5uXOq.createElement($008f34d502bbfdeb$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $008f34d502bbfdeb$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $7ziRZ.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $008f34d502bbfdeb$var$DefaultErrorComponent() {
    let error = $008f34d502bbfdeb$export$ed527bf60f6e05f2();
    let message = (0, $7ziRZ.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $5uXOq.createElement($5uXOq.Fragment, null, /*#__PURE__*/ $5uXOq.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $5uXOq.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $5uXOq.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $008f34d502bbfdeb$var$defaultErrorElement = /*#__PURE__*/ $5uXOq.createElement($008f34d502bbfdeb$var$DefaultErrorComponent, null);
class $008f34d502bbfdeb$var$RenderErrorBoundary extends $5uXOq.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $5uXOq.createElement($008f34d502bbfdeb$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $5uXOq.createElement($008f34d502bbfdeb$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $008f34d502bbfdeb$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $5uXOq.useContext($008f34d502bbfdeb$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $5uXOq.createElement($008f34d502bbfdeb$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $008f34d502bbfdeb$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $7ziRZ.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $008f34d502bbfdeb$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $008f34d502bbfdeb$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $5uXOq.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $5uXOq.createElement($008f34d502bbfdeb$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $5uXOq.createElement($008f34d502bbfdeb$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $008f34d502bbfdeb$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($008f34d502bbfdeb$var$DataRouterHook || {});
var $008f34d502bbfdeb$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($008f34d502bbfdeb$var$DataRouterStateHook || {});
function $008f34d502bbfdeb$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $008f34d502bbfdeb$var$useDataRouterContext(hookName) {
    let ctx = $5uXOq.useContext($008f34d502bbfdeb$export$3add0d5dce533e2e);
    !ctx && (0, $7ziRZ.UNSAFE_invariant)(false);
    return ctx;
}
function $008f34d502bbfdeb$var$useDataRouterState(hookName) {
    let state = $5uXOq.useContext($008f34d502bbfdeb$export$145dfa71566a64dc);
    !state && (0, $7ziRZ.UNSAFE_invariant)(false);
    return state;
}
function $008f34d502bbfdeb$var$useRouteContext(hookName) {
    let route = $5uXOq.useContext($008f34d502bbfdeb$export$9072aa6dd1f93057);
    !route && (0, $7ziRZ.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $008f34d502bbfdeb$var$useCurrentRouteId(hookName) {
    let route = $008f34d502bbfdeb$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $7ziRZ.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $008f34d502bbfdeb$export$5fc8298006ad9e58() {
    return $008f34d502bbfdeb$var$useCurrentRouteId($008f34d502bbfdeb$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $008f34d502bbfdeb$export$d0fd4b7106de2769() {
    let state = $008f34d502bbfdeb$var$useDataRouterState($008f34d502bbfdeb$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $008f34d502bbfdeb$export$600dc272ed516c15() {
    let dataRouterContext = $008f34d502bbfdeb$var$useDataRouterContext($008f34d502bbfdeb$var$DataRouterHook.UseRevalidator);
    let state = $008f34d502bbfdeb$var$useDataRouterState($008f34d502bbfdeb$var$DataRouterStateHook.UseRevalidator);
    return $5uXOq.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $008f34d502bbfdeb$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $008f34d502bbfdeb$var$useDataRouterState($008f34d502bbfdeb$var$DataRouterStateHook.UseMatches);
    return $5uXOq.useMemo(()=>matches.map((m)=>(0, $7ziRZ.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $008f34d502bbfdeb$export$1448a5050d252c4d() {
    let state = $008f34d502bbfdeb$var$useDataRouterState($008f34d502bbfdeb$var$DataRouterStateHook.UseLoaderData);
    let routeId = $008f34d502bbfdeb$var$useCurrentRouteId($008f34d502bbfdeb$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $008f34d502bbfdeb$export$fd5d37484eab868d(routeId) {
    let state = $008f34d502bbfdeb$var$useDataRouterState($008f34d502bbfdeb$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $008f34d502bbfdeb$export$fdc00f3f26066d5e() {
    let state = $008f34d502bbfdeb$var$useDataRouterState($008f34d502bbfdeb$var$DataRouterStateHook.UseActionData);
    let routeId = $008f34d502bbfdeb$var$useCurrentRouteId($008f34d502bbfdeb$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $008f34d502bbfdeb$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $5uXOq.useContext($008f34d502bbfdeb$var$RouteErrorContext);
    let state = $008f34d502bbfdeb$var$useDataRouterState($008f34d502bbfdeb$var$DataRouterStateHook.UseRouteError);
    let routeId = $008f34d502bbfdeb$var$useCurrentRouteId($008f34d502bbfdeb$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $008f34d502bbfdeb$export$78a72ddb39bdd145() {
    let value = $5uXOq.useContext($008f34d502bbfdeb$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $008f34d502bbfdeb$export$17f53340677d5831() {
    let value = $5uXOq.useContext($008f34d502bbfdeb$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $008f34d502bbfdeb$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $008f34d502bbfdeb$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $008f34d502bbfdeb$var$useDataRouterContext($008f34d502bbfdeb$var$DataRouterHook.UseBlocker);
    let state = $008f34d502bbfdeb$var$useDataRouterState($008f34d502bbfdeb$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $5uXOq.useState("");
    let blockerFunction = $5uXOq.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $008f34d502bbfdeb$var$_extends({}, currentLocation, {
                pathname: (0, $7ziRZ.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $008f34d502bbfdeb$var$_extends({}, nextLocation, {
                pathname: (0, $7ziRZ.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $5uXOq.useEffect(()=>{
        let key = String(++$008f34d502bbfdeb$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $5uXOq.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $7ziRZ.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $008f34d502bbfdeb$var$useNavigateStable() {
    let { router: router } = $008f34d502bbfdeb$var$useDataRouterContext($008f34d502bbfdeb$var$DataRouterHook.UseNavigateStable);
    let id = $008f34d502bbfdeb$var$useCurrentRouteId($008f34d502bbfdeb$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $5uXOq.useRef(false);
    $008f34d502bbfdeb$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $5uXOq.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $008f34d502bbfdeb$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $008f34d502bbfdeb$var$alreadyWarned$1 = {};
function $008f34d502bbfdeb$var$warningOnce(key, cond, message) {
    if (!cond && !$008f34d502bbfdeb$var$alreadyWarned$1[key]) $008f34d502bbfdeb$var$alreadyWarned$1[key] = true;
}
const $008f34d502bbfdeb$var$alreadyWarned = {};
function $008f34d502bbfdeb$var$warnOnce(key, message) {
    if (!$008f34d502bbfdeb$var$alreadyWarned[message]) {
        $008f34d502bbfdeb$var$alreadyWarned[message] = true;
        console.warn(message);
    }
}
const $008f34d502bbfdeb$var$logDeprecation = (flag, msg, link)=>$008f34d502bbfdeb$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $008f34d502bbfdeb$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if (!(renderFuture != null && renderFuture.v7_startTransition)) $008f34d502bbfdeb$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if (!(renderFuture != null && renderFuture.v7_relativeSplatPath) && (!routerFuture || !routerFuture.v7_relativeSplatPath)) $008f34d502bbfdeb$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (!routerFuture.v7_fetcherPersist) $008f34d502bbfdeb$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (!routerFuture.v7_normalizeFormMethod) $008f34d502bbfdeb$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (!routerFuture.v7_partialHydration) $008f34d502bbfdeb$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (!routerFuture.v7_skipActionErrorRevalidation) $008f34d502bbfdeb$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $008f34d502bbfdeb$var$START_TRANSITION = "startTransition";
const $008f34d502bbfdeb$var$startTransitionImpl = $5uXOq[$008f34d502bbfdeb$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $008f34d502bbfdeb$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $5uXOq.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $5uXOq.useCallback((newState)=>{
        if (v7_startTransition && $008f34d502bbfdeb$var$startTransitionImpl) $008f34d502bbfdeb$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $5uXOq.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $5uXOq.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $5uXOq.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $5uXOq.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $5uXOq.useEffect(()=>$008f34d502bbfdeb$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $5uXOq.createElement($5uXOq.Fragment, null, /*#__PURE__*/ $5uXOq.createElement($008f34d502bbfdeb$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $5uXOq.createElement($008f34d502bbfdeb$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $5uXOq.createElement($008f34d502bbfdeb$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $5uXOq.createElement($008f34d502bbfdeb$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $008f34d502bbfdeb$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $008f34d502bbfdeb$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $008f34d502bbfdeb$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $5uXOq.useRef();
    if (historyRef.current == null) historyRef.current = (0, $7ziRZ.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $5uXOq.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $5uXOq.useCallback((newState)=>{
        v7_startTransition && $008f34d502bbfdeb$var$startTransitionImpl ? $008f34d502bbfdeb$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $5uXOq.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $5uXOq.useEffect(()=>$008f34d502bbfdeb$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $5uXOq.createElement($008f34d502bbfdeb$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $008f34d502bbfdeb$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$008f34d502bbfdeb$export$9c954a9d03d32f4a() && (0, $7ziRZ.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $5uXOq.useContext($008f34d502bbfdeb$export$26749e8557646306);
    let { matches: matches } = $5uXOq.useContext($008f34d502bbfdeb$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $008f34d502bbfdeb$export$45d76561a5302f2b();
    let navigate = $008f34d502bbfdeb$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $7ziRZ.resolveTo)(to, (0, $7ziRZ.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $5uXOq.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $008f34d502bbfdeb$export$910ae8079b2c2852(props) {
    return $008f34d502bbfdeb$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $008f34d502bbfdeb$export$e7b0ac011bb776c6(_props) {
    (0, $7ziRZ.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $008f34d502bbfdeb$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $7ziRZ.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$008f34d502bbfdeb$export$9c954a9d03d32f4a() && (0, $7ziRZ.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $5uXOq.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $008f34d502bbfdeb$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $7ziRZ.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $5uXOq.useMemo(()=>{
        let trailingPathname = (0, $7ziRZ.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $5uXOq.createElement($008f34d502bbfdeb$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $5uXOq.createElement($008f34d502bbfdeb$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $008f34d502bbfdeb$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $008f34d502bbfdeb$export$5d3fca4a98652595($008f34d502bbfdeb$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $008f34d502bbfdeb$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $5uXOq.createElement($008f34d502bbfdeb$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $5uXOq.createElement($008f34d502bbfdeb$var$ResolveAwait, null, children));
}
var $008f34d502bbfdeb$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($008f34d502bbfdeb$var$AwaitRenderStatus || {});
const $008f34d502bbfdeb$var$neverSettledPromise = new Promise(()=>{});
class $008f34d502bbfdeb$var$AwaitErrorBoundary extends $5uXOq.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $008f34d502bbfdeb$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $008f34d502bbfdeb$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $008f34d502bbfdeb$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $008f34d502bbfdeb$var$AwaitRenderStatus.error : "_data" in promise ? $008f34d502bbfdeb$var$AwaitRenderStatus.success : $008f34d502bbfdeb$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $008f34d502bbfdeb$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $008f34d502bbfdeb$var$AwaitRenderStatus.error && promise._error instanceof (0, $7ziRZ.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $008f34d502bbfdeb$var$neverSettledPromise;
        if (status === $008f34d502bbfdeb$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $008f34d502bbfdeb$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $5uXOq.createElement($008f34d502bbfdeb$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $008f34d502bbfdeb$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $5uXOq.createElement($008f34d502bbfdeb$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $008f34d502bbfdeb$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $008f34d502bbfdeb$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $5uXOq.createElement($5uXOq.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $008f34d502bbfdeb$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $5uXOq.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $5uXOq.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $5uXOq.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $008f34d502bbfdeb$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $008f34d502bbfdeb$export$e7b0ac011bb776c6) && (0, $7ziRZ.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $7ziRZ.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $008f34d502bbfdeb$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $008f34d502bbfdeb$export$daf73786167a7f72(matches) {
    return $008f34d502bbfdeb$var$_renderMatches(matches);
}
function $008f34d502bbfdeb$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $5uXOq.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $5uXOq.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $5uXOq.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $008f34d502bbfdeb$export$f30f7e456d254e83(routes, opts) {
    return (0, $7ziRZ.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $008f34d502bbfdeb$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $7ziRZ.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $008f34d502bbfdeb$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

});
parcelRegister("7ziRZ", function(module, exports) {

$parcel$export(module.exports, "Action", () => $582a7073b9f425dc$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "createMemoryHistory", () => $582a7073b9f425dc$export$2b76ad033c6e6d08);
$parcel$export(module.exports, "createPath", () => $582a7073b9f425dc$export$fe53371bee54353d);
$parcel$export(module.exports, "parsePath", () => $582a7073b9f425dc$export$8ccf933b0513f8d0);
$parcel$export(module.exports, "UNSAFE_invariant", () => $582a7073b9f425dc$export$3e9cee6b33872309);
$parcel$export(module.exports, "matchRoutes", () => $582a7073b9f425dc$export$2708184779ceb39d);
$parcel$export(module.exports, "stripBasename", () => $582a7073b9f425dc$export$b69e3301ce081aa3);
$parcel$export(module.exports, "UNSAFE_decodePath", () => $582a7073b9f425dc$export$30d21fd6d7295f52);
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", () => $582a7073b9f425dc$export$b3fac024fad9e8ff);
$parcel$export(module.exports, "joinPaths", () => $582a7073b9f425dc$export$86d9a7913e44197e);
$parcel$export(module.exports, "matchPath", () => $582a7073b9f425dc$export$81336c211d5ff295);
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", () => $582a7073b9f425dc$export$a5784978eca585fa);
$parcel$export(module.exports, "resolveTo", () => $582a7073b9f425dc$export$cae722b0cc860f13);
$parcel$export(module.exports, "AbortedDeferredError", () => $582a7073b9f425dc$export$42a99a7a4bc0e76a);
$parcel$export(module.exports, "isRouteErrorResponse", () => $582a7073b9f425dc$export$972111febbeef05b);
$parcel$export(module.exports, "IDLE_BLOCKER", () => $582a7073b9f425dc$export$386d57f03f0b2883);
$parcel$export(module.exports, "createRouter", () => $582a7073b9f425dc$export$baddd0131ee8c05b);
/**
 * @remix-run/router v1.21.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $582a7073b9f425dc$var$_extends() {
    $582a7073b9f425dc$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $582a7073b9f425dc$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $582a7073b9f425dc$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($582a7073b9f425dc$export$e19cd5f9376f8cee || ($582a7073b9f425dc$export$e19cd5f9376f8cee = {}));
const $582a7073b9f425dc$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $582a7073b9f425dc$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $582a7073b9f425dc$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $582a7073b9f425dc$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $582a7073b9f425dc$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $582a7073b9f425dc$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $582a7073b9f425dc$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $582a7073b9f425dc$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $582a7073b9f425dc$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $582a7073b9f425dc$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $582a7073b9f425dc$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $582a7073b9f425dc$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $582a7073b9f425dc$export$fe53371bee54353d(to);
    }
    return $582a7073b9f425dc$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $582a7073b9f425dc$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $582a7073b9f425dc$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $582a7073b9f425dc$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $582a7073b9f425dc$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $582a7073b9f425dc$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $582a7073b9f425dc$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $582a7073b9f425dc$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $582a7073b9f425dc$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $582a7073b9f425dc$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $582a7073b9f425dc$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $582a7073b9f425dc$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $582a7073b9f425dc$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $582a7073b9f425dc$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $582a7073b9f425dc$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $582a7073b9f425dc$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $582a7073b9f425dc$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $582a7073b9f425dc$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $582a7073b9f425dc$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($582a7073b9f425dc$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $582a7073b9f425dc$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $582a7073b9f425dc$export$e19cd5f9376f8cee.Push;
        let location = $582a7073b9f425dc$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $582a7073b9f425dc$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $582a7073b9f425dc$export$e19cd5f9376f8cee.Replace;
        let location = $582a7073b9f425dc$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $582a7073b9f425dc$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $582a7073b9f425dc$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $582a7073b9f425dc$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($582a7073b9f425dc$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($582a7073b9f425dc$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $582a7073b9f425dc$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($582a7073b9f425dc$var$ResultType || ($582a7073b9f425dc$var$ResultType = {}));
const $582a7073b9f425dc$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $582a7073b9f425dc$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $582a7073b9f425dc$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $582a7073b9f425dc$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $582a7073b9f425dc$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($582a7073b9f425dc$var$isIndexRoute(route)) {
            let indexRoute = $582a7073b9f425dc$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $582a7073b9f425dc$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $582a7073b9f425dc$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $582a7073b9f425dc$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $582a7073b9f425dc$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $582a7073b9f425dc$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $582a7073b9f425dc$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $582a7073b9f425dc$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $582a7073b9f425dc$var$flattenRoutes(routes);
    $582a7073b9f425dc$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $582a7073b9f425dc$export$30d21fd6d7295f52(pathname);
        matches = $582a7073b9f425dc$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $582a7073b9f425dc$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $582a7073b9f425dc$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $582a7073b9f425dc$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $582a7073b9f425dc$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $582a7073b9f425dc$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $582a7073b9f425dc$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $582a7073b9f425dc$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $582a7073b9f425dc$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $582a7073b9f425dc$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $582a7073b9f425dc$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $582a7073b9f425dc$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $582a7073b9f425dc$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $582a7073b9f425dc$var$paramRe = /^:[\w-]+$/;
const $582a7073b9f425dc$var$dynamicSegmentValue = 3;
const $582a7073b9f425dc$var$indexRouteValue = 2;
const $582a7073b9f425dc$var$emptySegmentValue = 1;
const $582a7073b9f425dc$var$staticSegmentValue = 10;
const $582a7073b9f425dc$var$splatPenalty = -2;
const $582a7073b9f425dc$var$isSplat = (s)=>s === "*";
function $582a7073b9f425dc$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($582a7073b9f425dc$var$isSplat)) initialScore += $582a7073b9f425dc$var$splatPenalty;
    if (index) initialScore += $582a7073b9f425dc$var$indexRouteValue;
    return segments.filter((s)=>!$582a7073b9f425dc$var$isSplat(s)).reduce((score, segment)=>score + ($582a7073b9f425dc$var$paramRe.test(segment) ? $582a7073b9f425dc$var$dynamicSegmentValue : segment === "" ? $582a7073b9f425dc$var$emptySegmentValue : $582a7073b9f425dc$var$staticSegmentValue), initialScore);
}
function $582a7073b9f425dc$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $582a7073b9f425dc$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $582a7073b9f425dc$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $582a7073b9f425dc$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $582a7073b9f425dc$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $582a7073b9f425dc$export$a5c6d149b50c1d86($582a7073b9f425dc$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $582a7073b9f425dc$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $582a7073b9f425dc$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $582a7073b9f425dc$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $582a7073b9f425dc$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $582a7073b9f425dc$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $582a7073b9f425dc$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $582a7073b9f425dc$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $582a7073b9f425dc$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $582a7073b9f425dc$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $582a7073b9f425dc$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $582a7073b9f425dc$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $582a7073b9f425dc$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $582a7073b9f425dc$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $582a7073b9f425dc$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $582a7073b9f425dc$var$normalizeSearch(search),
        hash: $582a7073b9f425dc$var$normalizeHash(hash)
    };
}
function $582a7073b9f425dc$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $582a7073b9f425dc$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $582a7073b9f425dc$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $582a7073b9f425dc$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $582a7073b9f425dc$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $582a7073b9f425dc$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $582a7073b9f425dc$export$8ccf933b0513f8d0(toArg);
    else {
        to = $582a7073b9f425dc$var$_extends({}, toArg);
        $582a7073b9f425dc$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $582a7073b9f425dc$var$getInvalidPathError("?", "pathname", "search", to));
        $582a7073b9f425dc$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $582a7073b9f425dc$var$getInvalidPathError("#", "pathname", "hash", to));
        $582a7073b9f425dc$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $582a7073b9f425dc$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $582a7073b9f425dc$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $582a7073b9f425dc$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $582a7073b9f425dc$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $582a7073b9f425dc$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $582a7073b9f425dc$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $582a7073b9f425dc$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $582a7073b9f425dc$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $582a7073b9f425dc$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $582a7073b9f425dc$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $582a7073b9f425dc$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $582a7073b9f425dc$export$4051a07651545597(data, init) {
    return new $582a7073b9f425dc$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $582a7073b9f425dc$export$42a99a7a4bc0e76a extends Error {
}
class $582a7073b9f425dc$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $582a7073b9f425dc$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $582a7073b9f425dc$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $582a7073b9f425dc$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $582a7073b9f425dc$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $582a7073b9f425dc$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $582a7073b9f425dc$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $582a7073b9f425dc$var$unwrapTrackedPromise(value) {
    if (!$582a7073b9f425dc$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $582a7073b9f425dc$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $582a7073b9f425dc$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $582a7073b9f425dc$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $582a7073b9f425dc$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $582a7073b9f425dc$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $582a7073b9f425dc$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $582a7073b9f425dc$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $582a7073b9f425dc$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $582a7073b9f425dc$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $582a7073b9f425dc$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $582a7073b9f425dc$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $582a7073b9f425dc$var$validMutationMethods = new Set($582a7073b9f425dc$var$validMutationMethodsArr);
const $582a7073b9f425dc$var$validRequestMethodsArr = [
    "get",
    ...$582a7073b9f425dc$var$validMutationMethodsArr
];
const $582a7073b9f425dc$var$validRequestMethods = new Set($582a7073b9f425dc$var$validRequestMethodsArr);
const $582a7073b9f425dc$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $582a7073b9f425dc$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $582a7073b9f425dc$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $582a7073b9f425dc$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $582a7073b9f425dc$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $582a7073b9f425dc$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $582a7073b9f425dc$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $582a7073b9f425dc$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $582a7073b9f425dc$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $582a7073b9f425dc$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $582a7073b9f425dc$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $582a7073b9f425dc$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $582a7073b9f425dc$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $582a7073b9f425dc$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $582a7073b9f425dc$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $582a7073b9f425dc$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $582a7073b9f425dc$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$582a7073b9f425dc$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$582a7073b9f425dc$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $582a7073b9f425dc$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $582a7073b9f425dc$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $582a7073b9f425dc$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $582a7073b9f425dc$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $582a7073b9f425dc$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$582a7073b9f425dc$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($582a7073b9f425dc$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $582a7073b9f425dc$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $582a7073b9f425dc$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $582a7073b9f425dc$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $582a7073b9f425dc$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $582a7073b9f425dc$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $582a7073b9f425dc$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $582a7073b9f425dc$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $582a7073b9f425dc$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $582a7073b9f425dc$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($582a7073b9f425dc$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $582a7073b9f425dc$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $582a7073b9f425dc$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $582a7073b9f425dc$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $582a7073b9f425dc$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $582a7073b9f425dc$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $582a7073b9f425dc$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $582a7073b9f425dc$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $582a7073b9f425dc$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $582a7073b9f425dc$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $582a7073b9f425dc$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $582a7073b9f425dc$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $582a7073b9f425dc$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $582a7073b9f425dc$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $582a7073b9f425dc$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $582a7073b9f425dc$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $582a7073b9f425dc$var$findNearestBoundary(matches).route.id,
            {
                type: $582a7073b9f425dc$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $582a7073b9f425dc$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($582a7073b9f425dc$var$isErrorResult(result) && $582a7073b9f425dc$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $582a7073b9f425dc$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $582a7073b9f425dc$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $582a7073b9f425dc$var$_extends({
            matches: updatedMatches || matches
        }, $582a7073b9f425dc$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $582a7073b9f425dc$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $582a7073b9f425dc$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $582a7073b9f425dc$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $582a7073b9f425dc$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $582a7073b9f425dc$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $582a7073b9f425dc$var$ResultType.error,
            error: $582a7073b9f425dc$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($582a7073b9f425dc$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $582a7073b9f425dc$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($582a7073b9f425dc$var$isDeferredResult(result)) throw $582a7073b9f425dc$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($582a7073b9f425dc$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $582a7073b9f425dc$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $582a7073b9f425dc$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $582a7073b9f425dc$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $582a7073b9f425dc$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($582a7073b9f425dc$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $582a7073b9f425dc$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $582a7073b9f425dc$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $582a7073b9f425dc$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $582a7073b9f425dc$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $582a7073b9f425dc$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $582a7073b9f425dc$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $582a7073b9f425dc$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $582a7073b9f425dc$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $582a7073b9f425dc$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $582a7073b9f425dc$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$582a7073b9f425dc$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $582a7073b9f425dc$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $582a7073b9f425dc$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $582a7073b9f425dc$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $582a7073b9f425dc$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $582a7073b9f425dc$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $582a7073b9f425dc$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $582a7073b9f425dc$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $582a7073b9f425dc$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $582a7073b9f425dc$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $582a7073b9f425dc$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $582a7073b9f425dc$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $582a7073b9f425dc$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($582a7073b9f425dc$var$isRedirectResult(actionResult) || $582a7073b9f425dc$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $582a7073b9f425dc$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($582a7073b9f425dc$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $582a7073b9f425dc$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $582a7073b9f425dc$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($582a7073b9f425dc$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($582a7073b9f425dc$var$isDeferredResult(actionResult)) throw $582a7073b9f425dc$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $582a7073b9f425dc$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $582a7073b9f425dc$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $582a7073b9f425dc$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $582a7073b9f425dc$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $582a7073b9f425dc$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $582a7073b9f425dc$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $582a7073b9f425dc$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $582a7073b9f425dc$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $582a7073b9f425dc$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $582a7073b9f425dc$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $582a7073b9f425dc$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $582a7073b9f425dc$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $582a7073b9f425dc$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $582a7073b9f425dc$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $582a7073b9f425dc$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $582a7073b9f425dc$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($582a7073b9f425dc$var$isDeferredResult(result)) result = await $582a7073b9f425dc$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $582a7073b9f425dc$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($582a7073b9f425dc$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $582a7073b9f425dc$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($582a7073b9f425dc$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $582a7073b9f425dc$export$3e9cee6b33872309(!$582a7073b9f425dc$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $582a7073b9f425dc$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $582a7073b9f425dc$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $582a7073b9f425dc$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $582a7073b9f425dc$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($582a7073b9f425dc$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $582a7073b9f425dc$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $582a7073b9f425dc$export$e19cd5f9376f8cee.Replace : $582a7073b9f425dc$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $582a7073b9f425dc$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($582a7073b9f425dc$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $582a7073b9f425dc$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $582a7073b9f425dc$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $582a7073b9f425dc$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $582a7073b9f425dc$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $582a7073b9f425dc$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($582a7073b9f425dc$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $582a7073b9f425dc$var$ResultType.redirect,
                response: $582a7073b9f425dc$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $582a7073b9f425dc$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $582a7073b9f425dc$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $582a7073b9f425dc$var$ResultType.error,
                    error: $582a7073b9f425dc$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $582a7073b9f425dc$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $582a7073b9f425dc$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $582a7073b9f425dc$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $582a7073b9f425dc$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $582a7073b9f425dc$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $582a7073b9f425dc$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $582a7073b9f425dc$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $582a7073b9f425dc$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $582a7073b9f425dc$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $582a7073b9f425dc$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $582a7073b9f425dc$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $582a7073b9f425dc$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $582a7073b9f425dc$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $582a7073b9f425dc$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$582a7073b9f425dc$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $582a7073b9f425dc$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $582a7073b9f425dc$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    path: pathname,
                    matches: partialMatches,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $582a7073b9f425dc$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $582a7073b9f425dc$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $582a7073b9f425dc$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $582a7073b9f425dc$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $582a7073b9f425dc$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $582a7073b9f425dc$export$4d0306f8f6a4585b = Symbol("deferred");
function $582a7073b9f425dc$export$3336b097a6fbc59a(routes, opts) {
    $582a7073b9f425dc$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $582a7073b9f425dc$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $582a7073b9f425dc$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $582a7073b9f425dc$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $582a7073b9f425dc$var$createLocation("", $582a7073b9f425dc$export$fe53371bee54353d(url), null, "default");
        let matches = $582a7073b9f425dc$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$582a7073b9f425dc$var$isValidMethod(method) && method !== "HEAD") {
            let error = $582a7073b9f425dc$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $582a7073b9f425dc$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $582a7073b9f425dc$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $582a7073b9f425dc$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($582a7073b9f425dc$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $582a7073b9f425dc$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $582a7073b9f425dc$var$createLocation("", $582a7073b9f425dc$export$fe53371bee54353d(url), null, "default");
        let matches = $582a7073b9f425dc$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$582a7073b9f425dc$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $582a7073b9f425dc$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $582a7073b9f425dc$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $582a7073b9f425dc$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $582a7073b9f425dc$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $582a7073b9f425dc$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($582a7073b9f425dc$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$582a7073b9f425dc$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $582a7073b9f425dc$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($582a7073b9f425dc$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $582a7073b9f425dc$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $582a7073b9f425dc$var$isResponse(result) ? result : $582a7073b9f425dc$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($582a7073b9f425dc$var$isDataStrategyResult(e) && $582a7073b9f425dc$var$isResponse(e.result)) {
                if (e.type === $582a7073b9f425dc$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($582a7073b9f425dc$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $582a7073b9f425dc$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $582a7073b9f425dc$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $582a7073b9f425dc$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($582a7073b9f425dc$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($582a7073b9f425dc$var$isDeferredResult(result)) {
            let error = $582a7073b9f425dc$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $582a7073b9f425dc$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($582a7073b9f425dc$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($582a7073b9f425dc$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $582a7073b9f425dc$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $582a7073b9f425dc$var$_extends({}, context, {
                statusCode: $582a7073b9f425dc$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $582a7073b9f425dc$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $582a7073b9f425dc$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $582a7073b9f425dc$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $582a7073b9f425dc$var$isErrorResult(pendingActionResult[1]) ? $582a7073b9f425dc$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $582a7073b9f425dc$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $582a7073b9f425dc$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $582a7073b9f425dc$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $582a7073b9f425dc$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $582a7073b9f425dc$var$callDataStrategyImpl(dataStrategy || $582a7073b9f425dc$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($582a7073b9f425dc$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $582a7073b9f425dc$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($582a7073b9f425dc$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $582a7073b9f425dc$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $582a7073b9f425dc$export$fec11da027c70692(routes, context, error) {
    let newContext = $582a7073b9f425dc$var$_extends({}, context, {
        statusCode: $582a7073b9f425dc$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $582a7073b9f425dc$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $582a7073b9f425dc$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $582a7073b9f425dc$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $582a7073b9f425dc$export$cae722b0cc860f13(to ? to : ".", $582a7073b9f425dc$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $582a7073b9f425dc$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $582a7073b9f425dc$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $582a7073b9f425dc$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $582a7073b9f425dc$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $582a7073b9f425dc$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$582a7073b9f425dc$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$582a7073b9f425dc$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $582a7073b9f425dc$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $582a7073b9f425dc$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $582a7073b9f425dc$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$582a7073b9f425dc$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$582a7073b9f425dc$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $582a7073b9f425dc$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $582a7073b9f425dc$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $582a7073b9f425dc$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $582a7073b9f425dc$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $582a7073b9f425dc$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($582a7073b9f425dc$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $582a7073b9f425dc$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $582a7073b9f425dc$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $582a7073b9f425dc$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $582a7073b9f425dc$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $582a7073b9f425dc$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $582a7073b9f425dc$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $582a7073b9f425dc$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $582a7073b9f425dc$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $582a7073b9f425dc$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $582a7073b9f425dc$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($582a7073b9f425dc$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $582a7073b9f425dc$var$shouldRevalidateLoader(match, $582a7073b9f425dc$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $582a7073b9f425dc$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $582a7073b9f425dc$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $582a7073b9f425dc$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $582a7073b9f425dc$var$shouldRevalidateLoader(fetcherMatch, $582a7073b9f425dc$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $582a7073b9f425dc$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $582a7073b9f425dc$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $582a7073b9f425dc$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $582a7073b9f425dc$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $582a7073b9f425dc$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $582a7073b9f425dc$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$582a7073b9f425dc$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $582a7073b9f425dc$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $582a7073b9f425dc$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$582a7073b9f425dc$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $582a7073b9f425dc$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $582a7073b9f425dc$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $582a7073b9f425dc$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$582a7073b9f425dc$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $582a7073b9f425dc$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $582a7073b9f425dc$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $582a7073b9f425dc$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $582a7073b9f425dc$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $582a7073b9f425dc$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $582a7073b9f425dc$var$ResultType.data,
                result: undefined
            });
        };
        return $582a7073b9f425dc$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $582a7073b9f425dc$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $582a7073b9f425dc$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $582a7073b9f425dc$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $582a7073b9f425dc$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $582a7073b9f425dc$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $582a7073b9f425dc$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $582a7073b9f425dc$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($582a7073b9f425dc$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $582a7073b9f425dc$var$ResultType.error,
                error: e
            };
        }
        if (type === $582a7073b9f425dc$var$ResultType.error) return {
            type: $582a7073b9f425dc$var$ResultType.error,
            error: new $582a7073b9f425dc$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $582a7073b9f425dc$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $582a7073b9f425dc$var$ResultType.error) {
        if ($582a7073b9f425dc$export$e0163cfdf7bc9cfa(result)) {
            var _result$init2;
            if (result.data instanceof Error) {
                var _result$init;
                return {
                    type: $582a7073b9f425dc$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                };
            }
            // Convert thrown data() to ErrorResponse instances
            result = new $582a7073b9f425dc$export$6c6580e81da25755(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
        }
        return {
            type: $582a7073b9f425dc$var$ResultType.error,
            error: result,
            statusCode: $582a7073b9f425dc$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($582a7073b9f425dc$export$fbcedacb60443473(result)) {
        var _result$init3, _result$init4;
        return {
            type: $582a7073b9f425dc$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
            headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
        };
    }
    if ($582a7073b9f425dc$export$e0163cfdf7bc9cfa(result)) {
        var _result$init5, _result$init6;
        return {
            type: $582a7073b9f425dc$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $582a7073b9f425dc$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $582a7073b9f425dc$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $582a7073b9f425dc$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$582a7073b9f425dc$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $582a7073b9f425dc$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $582a7073b9f425dc$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($582a7073b9f425dc$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $582a7073b9f425dc$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $582a7073b9f425dc$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($582a7073b9f425dc$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $582a7073b9f425dc$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $582a7073b9f425dc$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $582a7073b9f425dc$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $582a7073b9f425dc$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $582a7073b9f425dc$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $582a7073b9f425dc$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $582a7073b9f425dc$export$3e9cee6b33872309(!$582a7073b9f425dc$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($582a7073b9f425dc$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $582a7073b9f425dc$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $582a7073b9f425dc$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($582a7073b9f425dc$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $582a7073b9f425dc$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $582a7073b9f425dc$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $582a7073b9f425dc$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($582a7073b9f425dc$var$isErrorResult(result)) {
            let boundaryMatch = $582a7073b9f425dc$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $582a7073b9f425dc$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($582a7073b9f425dc$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $582a7073b9f425dc$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($582a7073b9f425dc$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $582a7073b9f425dc$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $582a7073b9f425dc$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $582a7073b9f425dc$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $582a7073b9f425dc$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $582a7073b9f425dc$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $582a7073b9f425dc$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $582a7073b9f425dc$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $582a7073b9f425dc$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $582a7073b9f425dc$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $582a7073b9f425dc$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $582a7073b9f425dc$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($582a7073b9f425dc$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $582a7073b9f425dc$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $582a7073b9f425dc$export$8ccf933b0513f8d0(path) : path;
    return $582a7073b9f425dc$export$fe53371bee54353d($582a7073b9f425dc$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $582a7073b9f425dc$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $582a7073b9f425dc$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $582a7073b9f425dc$var$ResultType.data || result.type === $582a7073b9f425dc$var$ResultType.error);
}
function $582a7073b9f425dc$var$isRedirectDataStrategyResultResult(result) {
    return $582a7073b9f425dc$var$isResponse(result.result) && $582a7073b9f425dc$var$redirectStatusCodes.has(result.result.status);
}
function $582a7073b9f425dc$var$isDeferredResult(result) {
    return result.type === $582a7073b9f425dc$var$ResultType.deferred;
}
function $582a7073b9f425dc$var$isErrorResult(result) {
    return result.type === $582a7073b9f425dc$var$ResultType.error;
}
function $582a7073b9f425dc$var$isRedirectResult(result) {
    return (result && result.type) === $582a7073b9f425dc$var$ResultType.redirect;
}
function $582a7073b9f425dc$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $582a7073b9f425dc$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $582a7073b9f425dc$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $582a7073b9f425dc$var$isRedirectResponse(result) {
    if (!$582a7073b9f425dc$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $582a7073b9f425dc$var$isValidMethod(method) {
    return $582a7073b9f425dc$var$validRequestMethods.has(method.toLowerCase());
}
function $582a7073b9f425dc$var$isMutationMethod(method) {
    return $582a7073b9f425dc$var$validMutationMethods.has(method.toLowerCase());
}
async function $582a7073b9f425dc$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$582a7073b9f425dc$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($582a7073b9f425dc$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $582a7073b9f425dc$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $582a7073b9f425dc$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($582a7073b9f425dc$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $582a7073b9f425dc$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $582a7073b9f425dc$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $582a7073b9f425dc$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $582a7073b9f425dc$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $582a7073b9f425dc$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $582a7073b9f425dc$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $582a7073b9f425dc$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $582a7073b9f425dc$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $582a7073b9f425dc$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $582a7073b9f425dc$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $582a7073b9f425dc$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $582a7073b9f425dc$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $582a7073b9f425dc$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $582a7073b9f425dc$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $582a7073b9f425dc$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $582a7073b9f425dc$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $582a7073b9f425dc$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $582a7073b9f425dc$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($582a7073b9f425dc$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $582a7073b9f425dc$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($582a7073b9f425dc$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $582a7073b9f425dc$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});


parcelRegister("39itI", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ALLOWED_FEATURES", () => $1f1e6a2159ff566d$export$a33327ada3a6ee4a);
$parcel$export(module.exports, "getAllowedFeatures", () => $1f1e6a2159ff566d$export$3207c60940c4a9b0);

var $6BeA7 = parcelRequire("6BeA7");
var $gVnoy = parcelRequire("gVnoy");
var $1f1e6a2159ff566d$export$241b9888a4d565c9 = /*#__PURE__*/ function(ALLOWED_FEATURES_TYPE) {
    ALLOWED_FEATURES_TYPE["VIEW"] = "view";
    ALLOWED_FEATURES_TYPE["EDIT"] = "edit";
    ALLOWED_FEATURES_TYPE["WHITEBOARD"] = "whiteboard";
    return ALLOWED_FEATURES_TYPE;
}({});
const $1f1e6a2159ff566d$export$a3fda3dcee62e1cc = {
    // Since view and edit is a public API already, changing this would break parent products
    // hence we could update it separately as a breaking change later. With more content types which could
    // have edit, view, the suggested patter to follow: <contentType>-<mode> e.g., database-view
    view: [
        'byline-contributors',
        'byline-extensions',
        'delete',
        'edit',
        'inline-comments',
        'page-comments',
        'page-reactions',
        'sticky-header',
        'disable-login-flow',
        'disable-share',
        'non-licensed-share',
        'enable-redirection'
    ],
    edit: [
        'delete-draft',
        'disable-login-flow',
        'template-browser',
        'inline-comments'
    ],
    whiteboard: [
        'disable-login-flow',
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $1f1e6a2159ff566d$export$a33327ada3a6ee4a = {
    view: [
        'byline-contributors',
        'byline-extensions',
        'page-comments',
        'page-reactions',
        'inline-comments'
    ],
    edit: [
        'inline-comments'
    ],
    whiteboard: [
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $1f1e6a2159ff566d$var$pageAllowedFeatures = {
    [(0, $gVnoy.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $1f1e6a2159ff566d$export$a3fda3dcee62e1cc.edit,
    [(0, $gVnoy.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $1f1e6a2159ff566d$export$a3fda3dcee62e1cc.view
};
const $1f1e6a2159ff566d$var$blogPostAllowedFeatures = {
    [(0, $gVnoy.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $1f1e6a2159ff566d$export$a3fda3dcee62e1cc.edit,
    [(0, $gVnoy.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $1f1e6a2159ff566d$export$a3fda3dcee62e1cc.view
};
const $1f1e6a2159ff566d$var$whiteboardAllowedFeatures = {
    [(0, $gVnoy.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $1f1e6a2159ff566d$export$a3fda3dcee62e1cc.whiteboard,
    [(0, $gVnoy.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $1f1e6a2159ff566d$export$a3fda3dcee62e1cc.whiteboard
};
const $1f1e6a2159ff566d$var$contentTypeAllowedFeatures = {
    [(0, $6BeA7.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: $1f1e6a2159ff566d$var$pageAllowedFeatures,
    [(0, $6BeA7.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: $1f1e6a2159ff566d$var$blogPostAllowedFeatures,
    [(0, $6BeA7.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: $1f1e6a2159ff566d$var$whiteboardAllowedFeatures
};
const $1f1e6a2159ff566d$export$3207c60940c4a9b0 = ({ contentType: contentType, mode: mode = (0, $gVnoy.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE })=>$1f1e6a2159ff566d$var$contentTypeAllowedFeatures[contentType]?.[mode] ?? [];

});
parcelRegister("6BeA7", function(module, exports) {

$parcel$export(module.exports, "EMBEDDED_CONFLUENCE_CONTENT_TYPE", () => $c56abe420938ba9a$export$942a5fac9b8c9dc2);
var $c56abe420938ba9a$export$942a5fac9b8c9dc2 = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_CONTENT_TYPE) {
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["PAGE"] = "page";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["BLOGPOST"] = "blogpost";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["WHITEBOARD"] = "whiteboard";
    return EMBEDDED_CONFLUENCE_CONTENT_TYPE;
}({});

});


parcelRegister("jFSxp", function(module, exports) {

$parcel$export(module.exports, "EDIT_PAGE_EMBED", () => $6edcdb1ec5605c32$export$e63a462ee45b57cf);
$parcel$export(module.exports, "EDIT_PAGE_V2", () => $6edcdb1ec5605c32$export$7b1285e36c635f1f);
$parcel$export(module.exports, "VIEW_PAGE", () => $6edcdb1ec5605c32$export$9257b5b55c8e2555);
$parcel$export(module.exports, "VIEW_BLOG", () => $6edcdb1ec5605c32$export$91f49e7b30a9d34);
$parcel$export(module.exports, "VIEW_BLOG_DATE_LEGACY", () => $6edcdb1ec5605c32$export$bd2c9bb170b3681d);
$parcel$export(module.exports, "WHITEBOARD", () => $6edcdb1ec5605c32$export$fbefbcc1445e8d74);
$parcel$export(module.exports, "namedRoutes", () => $6edcdb1ec5605c32$export$d4971375353d0454);
$parcel$export(module.exports, "EMBEDDED_PARENT_PRODUCTS", () => $6edcdb1ec5605c32$export$5c59aa0922e65f1a);
const $6edcdb1ec5605c32$export$e63a462ee45b57cf = {
    name: 'EDIT_PAGE_EMBED',
    pattern: '/wiki/spaces/:spaceKey/pages/edit-embed/:contentId/:contentSlug?'
};
const $6edcdb1ec5605c32$export$7b1285e36c635f1f = {
    name: 'EDIT_PAGE_V2',
    pattern: '/wiki/spaces/:spaceKey/pages/edit-v2/:contentId/:contentSlug?'
};
const $6edcdb1ec5605c32$export$65b723bb995d4fb6 = {
    name: 'SPACE_OVERVIEW',
    pattern: '/wiki/spaces/:spaceKey/overview'
};
const $6edcdb1ec5605c32$export$9257b5b55c8e2555 = {
    name: 'VIEW_PAGE',
    pattern: '/wiki/spaces/:spaceKey/pages/:contentId/:contentSlug?'
};
const $6edcdb1ec5605c32$export$91f49e7b30a9d34 = {
    name: 'VIEW_BLOG',
    pattern: '/wiki/spaces/:spaceKey/blog/:contentId/:contentSlug?'
};
const $6edcdb1ec5605c32$export$bd2c9bb170b3681d = {
    name: 'VIEW_BLOG_DATE_LEGACY',
    pattern: '/wiki/spaces/:spaceKey/blog/:year/:month/:day/:contentId/:contentSlug?'
};
const $6edcdb1ec5605c32$export$fbefbcc1445e8d74 = {
    name: 'WHITEBOARD',
    pattern: '/wiki/spaces/:spaceKey/whiteboard/:contentId/:contentSlug?'
};
const $6edcdb1ec5605c32$export$d4971375353d0454 = {
    EDIT_PAGE_EMBED: $6edcdb1ec5605c32$export$e63a462ee45b57cf,
    EDIT_PAGE_V2: $6edcdb1ec5605c32$export$7b1285e36c635f1f,
    SPACE_OVERVIEW: $6edcdb1ec5605c32$export$65b723bb995d4fb6,
    VIEW_PAGE: $6edcdb1ec5605c32$export$9257b5b55c8e2555,
    VIEW_BLOG: $6edcdb1ec5605c32$export$91f49e7b30a9d34,
    VIEW_BLOG_DATE_LEGACY: $6edcdb1ec5605c32$export$bd2c9bb170b3681d,
    WHITEBOARD: $6edcdb1ec5605c32$export$fbefbcc1445e8d74
};
const $6edcdb1ec5605c32$export$5c59aa0922e65f1a = {
    JSM_PORTAL: 'JSM-Portal',
    JSM: 'JSM',
    JSW: 'JSW',
    JWM: 'JWM'
};

});


parcelRegister("bvqNo", function(module, exports) {

$parcel$export(module.exports, "ConfluenceContentTypes", () => $ea031aa9e3d5ef89$export$b39616d00ee96d40);
$parcel$export(module.exports, "DisplayTypes", () => $ea031aa9e3d5ef89$export$c294d3f3727c1a0);
const $ea031aa9e3d5ef89$export$b39616d00ee96d40 = {
    WHITEBOARD: 'whiteboard',
    PAGE: 'page'
};
const $ea031aa9e3d5ef89$export$c294d3f3727c1a0 = {
    MODAL: 'modal',
    PANEL: 'panel'
};

});


parcelRegister("5labn", function(module, exports) {

$parcel$export(module.exports, "getDisplayInformation", () => $e7deee7a3cbc4953$export$ee79869f97207574);
$parcel$export(module.exports, "convertUrlByContentState", () => $e7deee7a3cbc4953$export$d41c9cdfa202e9a7);

var $gVnoy = parcelRequire("gVnoy");

var $bvqNo = parcelRequire("bvqNo");
const $e7deee7a3cbc4953$export$37e31995727dc8d7 = 0.5;
const $e7deee7a3cbc4953$export$ee79869f97207574 = ()=>{
    /*
	We set the screen width to 50% of the screen width if the screen
	width is larger than 1024px because we want the Embedded Confluence in the side panel to
	take up half the screen width. The max of the side panel is 50% of the screen width and
	we are not able to set it wider. Jira Issue details panel will be forced down around 1875px
	screen width.
	If the screen width is less than 1024px, we'll set the panel width to 0 because we will be
	opening the EmbeddedContentModal instead and set displayType to Modal.
	This also assumes that we are currently on the full page version of a Jira Issue.
	*/ // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const screenWidth = window.innerWidth;
    if (screenWidth >= 1024) return {
        initialWidth: screenWidth * $e7deee7a3cbc4953$export$37e31995727dc8d7,
        displayType: (0, $bvqNo.DisplayTypes).PANEL
    };
    return {
        initialWidth: 0,
        displayType: (0, $bvqNo.DisplayTypes).MODAL
    };
};
const $e7deee7a3cbc4953$export$d41c9cdfa202e9a7 = ({ mode: mode, isDraft: isDraft, contentUrl: contentUrl, spaceKey: spaceKey })=>{
    // update spaceKey
    let newUrl = contentUrl.replace(/\/spaces\/.*?\/pages\//, `/spaces/${spaceKey}/pages/`);
    if (!isDraft) {
        // remove `draftShareId={id}` and the preceding `&` if it exists
        newUrl = newUrl.replace(/[&]*draftShareId=[^&]*/, '');
        if (mode === (0, $gVnoy.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE) {
            if (!newUrl.includes('edit-embed')) newUrl = newUrl.replace('/pages/', '/pages/edit-embed/');
        } else if (mode === (0, $gVnoy.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE) // Replaces /pages/edit-v2/ or /pages/edit-embed/ with /pages/
        newUrl = newUrl.replace(/\/pages\/edit[^/]*\//, '/pages/');
    }
    return newUrl;
};

});


parcelRegister("9V9QO", function(module, exports) {

$parcel$export(module.exports, "useEmbeddedPanelEntryPoint", () => $a6b6d10e82ec149e$export$75ef2f025ecbf1de);

var $5uXOq = parcelRequire("5uXOq");

var $hxoiH = parcelRequire("hxoiH");

var $gVnoy = parcelRequire("gVnoy");
var $idTx8 = parcelRequire("idTx8");

var $gXSrH = parcelRequire("gXSrH");

var $5labn = parcelRequire("5labn");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $BVLE8 = parcelRequire("BVLE8");

var $f3TN2 = parcelRequire("f3TN2");

var $dELl0 = parcelRequire("dELl0");

var $2POIy = parcelRequire("2POIy");

var $iwjqc = parcelRequire("iwjqc");

var $iXWB9 = parcelRequire("iXWB9");

var $4TSh0 = parcelRequire("4TSh0");

var $fvjUj = parcelRequire("fvjUj");

var $15U5v = parcelRequire("15U5v");
const $a6b6d10e82ec149e$var$entryPointParams = {};
const $a6b6d10e82ec149e$export$12346a674644c156 = 'operational';
const $a6b6d10e82ec149e$export$b81d6f4511cb89a5 = (action, eventName, params)=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent, setConfluenceData: setConfluenceData, contentUrl: contentUrl, embeddedConfluenceSourceForPanel: embeddedConfluenceSourceForPanel, isOpen: isOpen, mode: mode } = params;
    fireAnalyticsEvent({
        action: action,
        eventName: eventName,
        embeddedConfluenceSource: embeddedConfluenceSourceForPanel,
        eventType: $a6b6d10e82ec149e$export$12346a674644c156
    });
    if (isOpen) {
        if (eventName === 'edit-page/close') setConfluenceData({
            contentUrl: contentUrl,
            mode: (0, $gVnoy.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE
        });
        if (eventName === 'edit-page/load' && action === 'taskSuccess') {
            if (mode === (0, $gVnoy.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE) setConfluenceData({
                contentUrl: contentUrl,
                mode: (0, $gVnoy.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE
            });
        }
        if (eventName === 'edit-page/publish' && action === 'taskSuccess') {
            if (mode === (0, $gVnoy.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE) setConfluenceData({
                isDraft: false,
                contentUrl: contentUrl,
                mode: (0, $gVnoy.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE
            });
        }
    }
};
const $a6b6d10e82ec149e$export$75ef2f025ecbf1de = ()=>{
    const { locale: locale } = (0, $koVbs.default)();
    const [state, actions] = (0, $gXSrH.useEmbeddedConfluenceSidePanel)();
    const { contentType: contentType, confluenceData: { contentId: contentId, contentUrl: contentUrl, hostname: hostname, isLive: isLive, isDraft: isDraft, title: title, mode: mode }, isDeferSpaceSelection: isDeferSpaceSelection, contentActions: { onLinkPage: onLinkPage }, panel: { isOpen: isOpen, isExpanded: isExpanded }, embeddedConfluenceSource: embeddedConfluenceSource } = state;
    const isPageDraft = isDraft && contentType === (0, $f3TN2.CONTENT_TYPE).PAGE;
    const parentProduct = (0, $fvjUj.useParentProduct)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $2POIy.embeddedPanelEntrypoint), $a6b6d10e82ec149e$var$entryPointParams);
    const embeddedConfluenceSourceForPanel = `${embeddedConfluenceSource}Panel`;
    const fireAnalyticsEvent = (0, $4TSh0.useEmbeddedPageTracking)();
    const themeState = (0, $hxoiH.default)();
    /*
  	If the user is on a custom domain, we need to update the
  	hostname to reflect the parentProduct's hostname. By providing the hostname
  	prop we will force EP to use the parentProduct's hostname instead of the content's hostname
  	when on a custom domain (see EP code here https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/platform/packages/confluence/embedded-confluence-common/src/page/parsePageProps.ts#75).
  */ const contentHostname = (0, $iwjqc.setHostnameForContent)(contentUrl, hostname);
    const onContentAction = (0, $5uXOq.useCallback)((action, eventName)=>{
        $a6b6d10e82ec149e$export$b81d6f4511cb89a5(action, eventName, {
            fireAnalyticsEvent: fireAnalyticsEvent,
            setConfluenceData: actions.setConfluenceData,
            contentUrl: contentUrl,
            embeddedConfluenceSourceForPanel: embeddedConfluenceSourceForPanel,
            isOpen: isOpen,
            mode: mode
        });
    }, [
        actions,
        contentUrl,
        fireAnalyticsEvent,
        embeddedConfluenceSourceForPanel,
        isOpen,
        mode
    ]);
    const onClose = (0, $5uXOq.useCallback)(()=>{
        fireAnalyticsEvent({
            action: 'clicked',
            eventName: 'closeEmbeddedConfluencePanel',
            embeddedConfluenceSource: embeddedConfluenceSourceForPanel
        });
        entryPointActions.unload();
        actions.closeSidePanel();
    }, [
        actions,
        fireAnalyticsEvent,
        entryPointActions,
        embeddedConfluenceSourceForPanel
    ]);
    const editAllowedFeatures = (0, $5uXOq.useMemo)(()=>[
            ...isDeferSpaceSelection ? [
                'publish-modal'
            ] : [],
            'template-browser'
        ], [
        isDeferSpaceSelection
    ]);
    const shouldApplyEditFeatures = editAllowedFeatures.length > 0 && isDraft;
    const shouldOpenPanel = isOpen && contentUrl;
    const { entryPointActions: epDraftModalActions, entryPointReferenceSubject: epDraftModalSubject } = (0, $4mO32.useEntryPoint)((0, $dELl0.draftEmbeddedPageModalEntrypoint), {});
    const { entryPointActions: epModalActions, entryPointReferenceSubject: epModalSubject } = (0, $4mO32.useEntryPoint)((0, $BVLE8.embeddedConfluencePageModalEntrypoint), {});
    const { entryPointActions: whiteboardModalActions, entryPointReferenceSubject: whiteboardModalSubject } = (0, $4mO32.useEntryPoint)((0, $15U5v.embeddedWhiteboardModalEntrypoint), {});
    const { openContinueDraftModal: openContinueDraftModal, handleEmbeddedContentAction: handleDraftContentAction, epMode: epMode } = (0, $iXWB9.useEmbeddedPageDraft)({
        url: contentUrl,
        isLive: isLive,
        embeddedConfluenceSource: embeddedConfluenceSource,
        onEmbeddedContentAction: onContentAction,
        onClose: onClose,
        linkConfluencePage: onLinkPage
    });
    const handleOnModalClose = (0, $5uXOq.useCallback)(()=>{
        actions.closeSidePanel();
        if (contentType === 'whiteboard' && (0, $4R6GH.fg)('jira_issue_view_modeless_whiteboard')) whiteboardModalActions.unload();
        else if (contentType === 'page') isPageDraft ? epDraftModalActions.unload() : epModalActions.unload();
    }, [
        actions,
        isPageDraft,
        epDraftModalActions,
        epModalActions,
        whiteboardModalActions,
        contentType
    ]);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            locale: locale,
            hasFooterLogo: false,
            isDraft: isDraft,
            isLive: isLive,
            hostname: contentHostname,
            panelTitle: title,
            navigationPolicy: undefined,
            onClose: onClose,
            onContentAction: onContentAction,
            parentProduct: parentProduct,
            spaceKey: (0, $idTx8.parseUrl)(contentUrl)?.spaceKey,
            themeState: themeState,
            url: (0, $5labn.convertUrlByContentState)({
                mode: mode,
                isDraft: isDraft,
                contentUrl: contentUrl,
                spaceKey: (0, $idTx8.parseUrl)(contentUrl)?.spaceKey
            }),
            mode: isPageDraft ? epMode : mode,
            embeddedConfluenceSource: embeddedConfluenceSourceForPanel,
            contentId: contentId,
            contentType: contentType,
            onPublish: actions.setDeferredSpaceData,
            allowedFeatures: {
                view: [
                    'byline-contributors',
                    'byline-extensions',
                    'page-comments',
                    'page-reactions',
                    'inline-comments',
                    'non-licensed-share'
                ],
                ...shouldApplyEditFeatures && {
                    edit: editAllowedFeatures
                }
            },
            linkConfluencePage: onLinkPage
        }), [
        actions.setDeferredSpaceData,
        contentId,
        contentUrl,
        editAllowedFeatures,
        embeddedConfluenceSourceForPanel,
        contentHostname,
        isDraft,
        isLive,
        locale,
        title,
        mode,
        epMode,
        onClose,
        onContentAction,
        onLinkPage,
        parentProduct,
        themeState,
        shouldApplyEditFeatures,
        isPageDraft,
        contentType
    ]);
    const whiteboardModalRuntimeProps = (0, $5uXOq.useMemo)(()=>({
            isOpen: true,
            locale: locale,
            hasFooterLogo: false,
            hostname: contentHostname,
            panelTitle: title,
            navigationPolicy: undefined,
            enableContract: true,
            onClose: onClose,
            onEmbeddedContentAction: onContentAction,
            onContract: actions.toggleExpandedState,
            parentProduct: parentProduct,
            spaceKey: (0, $idTx8.parseUrl)(contentUrl)?.spaceKey,
            themeState: themeState,
            url: contentUrl,
            embeddedConfluenceSource: embeddedConfluenceSourceForPanel,
            contentId: contentId || (0, $idTx8.parseUrl)(contentUrl)?.contentId || '',
            contentType: contentType
        }), [
        contentId,
        contentType,
        contentUrl,
        embeddedConfluenceSourceForPanel,
        contentHostname,
        locale,
        title,
        onClose,
        onContentAction,
        parentProduct,
        themeState,
        actions.toggleExpandedState
    ]);
    const epModalRuntimeProps = (0, $5uXOq.useMemo)(()=>({
            locale: locale,
            hasFooterLogo: false,
            isDraft: isDraft,
            isOpen: true,
            enableContract: true,
            onClose: ()=>{
                isPageDraft ? openContinueDraftModal() : handleOnModalClose();
            },
            onContract: actions.toggleExpandedState,
            parentProduct: parentProduct,
            url: (0, $5labn.convertUrlByContentState)({
                mode: mode,
                isDraft: isDraft,
                contentUrl: contentUrl,
                spaceKey: (0, $idTx8.parseUrl)(contentUrl)?.spaceKey
            }),
            mode: isPageDraft ? epMode : mode,
            isLive: isLive,
            embeddedConfluenceSource: embeddedConfluenceSource,
            spaceKey: (0, $idTx8.parseUrl)(contentUrl)?.spaceKey,
            contentId: (0, $idTx8.parseUrl)(contentUrl)?.contentId,
            onPublish: actions.setDeferredSpaceData,
            allowedFeatures: {
                view: [
                    'byline-contributors',
                    'byline-extensions',
                    'page-comments',
                    'page-reactions',
                    'inline-comments',
                    'non-licensed-share'
                ],
                ...shouldApplyEditFeatures && {
                    edit: editAllowedFeatures
                }
            },
            linkConfluencePage: onLinkPage,
            themeState: themeState,
            onPageAction: isPageDraft ? handleDraftContentAction : onContentAction,
            navigationPolicy: undefined,
            hostname: contentHostname,
            isFullScreenEmbedView: true
        }), [
        locale,
        isDraft,
        actions.toggleExpandedState,
        actions.setDeferredSpaceData,
        parentProduct,
        isPageDraft,
        mode,
        epMode,
        contentUrl,
        isLive,
        embeddedConfluenceSource,
        themeState,
        handleDraftContentAction,
        onContentAction,
        contentHostname,
        openContinueDraftModal,
        handleOnModalClose,
        onLinkPage,
        editAllowedFeatures,
        shouldApplyEditFeatures
    ]);
    const setEntrypointActions = ()=>{
        if (!isExpanded) return entryPointActions;
        if (contentType === 'whiteboard' && (0, $4R6GH.fg)('jira_issue_view_modeless_whiteboard')) return whiteboardModalActions;
        if (contentType === 'page' && (0, $4R6GH.fg)('jira_issue_view_modeless_whiteboard')) return isDraft ? epDraftModalActions : epModalActions;
        // TODO remove this when cleaning up jira_issue_view_modeless_whiteboard
        return isDraft ? epDraftModalActions : epModalActions;
    };
    const setExpandedEntryPointData = ()=>{
        if (contentType === 'page') {
            if (isDraft) return {
                id: 'epDraftModalEntrypointContainer',
                entryPointReferenceSubject: epDraftModalSubject,
                runtimeProps: epModalRuntimeProps
            };
            return {
                id: 'epModalEntrypointContainer',
                entryPointReferenceSubject: epModalSubject,
                runtimeProps: epModalRuntimeProps
            };
        }
        if (contentType === 'whiteboard') return {
            id: 'embeddedWhiteboardModalEntrypointContainer',
            entryPointReferenceSubject: whiteboardModalSubject,
            runtimeProps: whiteboardModalRuntimeProps
        };
    };
    const entryPointData = setExpandedEntryPointData();
    // TODO remove this when cleaning up fg('jira_issue_view_modeless_whiteboard')
    const entryPointIdOld = isPageDraft ? 'epDraftModalEntrypointContainer' : 'epModalEntrypointContainer';
    // TODO remove this when cleaning up fg('jira_issue_view_modeless_whiteboard')
    const entryPointSubjectOld = isPageDraft ? epDraftModalSubject : epModalSubject;
    const expandedEntryPointContainer = ()=>{
        if ((0, $4R6GH.fg)('jira_issue_view_modeless_whiteboard')) {
            if (contentType === 'page') {
                if (isDraft) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
                    entryPointReferenceSubject: epDraftModalSubject,
                    id: "epDraftModalEntrypointContainer",
                    packageName: "@atlassian/jira-issue-create-confluence-content",
                    teamName: "confluence-better-together",
                    runtimeProps: epModalRuntimeProps
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
                    entryPointReferenceSubject: epModalSubject,
                    id: "epModalEntrypointContainer",
                    packageName: "@atlassian/jira-issue-create-confluence-content",
                    teamName: "confluence-better-together",
                    runtimeProps: epModalRuntimeProps
                });
            }
            if (contentType === 'whiteboard') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
                entryPointReferenceSubject: whiteboardModalSubject,
                id: "embeddedWhiteboardModalEntrypointContainer",
                packageName: "@atlassian/jira-issue-create-confluence-content",
                teamName: "confluence-better-together",
                runtimeProps: whiteboardModalRuntimeProps
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointSubjectOld,
            id: entryPointIdOld,
            packageName: "@atlassian/jira-issue-create-confluence-content",
            teamName: "confluence-better-together",
            runtimeProps: epModalRuntimeProps
        });
    };
    return shouldOpenPanel && entryPointData ? {
        entryPointActions: setEntrypointActions(),
        entryPoint: isExpanded ? expandedEntryPointContainer() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "epPanelEntrypointContainer",
            packageName: "@atlassian/jira-issue-create-confluence-content",
            teamName: "confluence-better-together",
            runtimeProps: runtimeProps
        })
    } : {
        ref: undefined,
        entryPoint: null
    };
};

});
parcelRegister("BVLE8", function(module, exports) {

$parcel$export(module.exports, "embeddedConfluencePageModalEntrypoint", () => $0287eee493e1b44f$export$2798102ac94287d0);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $0287eee493e1b44f$export$2798102ac94287d0 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("7ZORV")), {
        moduleId: "73170883",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("7ZORV", function(module, exports) {

let $5d25b05f1c884fa8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5d25b05f1c884fa8$var$load("kdIFG").then(()=>parcelRequire('dhviw'));

});


parcelRegister("f3TN2", function(module, exports) {

$parcel$export(module.exports, "LINK_CREATE_DRAFT_STATUS", () => $8629cdb22def106f$export$b86d51ea0323efca);
$parcel$export(module.exports, "CONTENT_TYPE", () => $8629cdb22def106f$export$a982aaff75f1c348);
$parcel$export(module.exports, "CONTENT_TYPE_TO_ENTITY_KEYS", () => $8629cdb22def106f$export$de75e0e058bd457c);

var $95kgE = parcelRequire("95kgE");
const $8629cdb22def106f$export$b86d51ea0323efca = 'draft';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $8629cdb22def106f$var$LINK_CREATE_PUBLISH_STATUS = 'current';
const $8629cdb22def106f$export$a982aaff75f1c348 = {
    PAGE: 'page',
    WHITEBOARD: 'whiteboard'
};
const $8629cdb22def106f$export$de75e0e058bd457c = {
    [$8629cdb22def106f$export$a982aaff75f1c348.PAGE]: (0, $95kgE.entityKeys).confluencePage,
    [$8629cdb22def106f$export$a982aaff75f1c348.WHITEBOARD]: (0, $95kgE.entityKeys).confluenceWhiteboard
};

});
parcelRegister("95kgE", function(module, exports) {

$parcel$export(module.exports, "entityKeys", () => $f7dd7d9983f5ca18$export$be0551febfd6121e);
$parcel$export(module.exports, "ContentTypes", () => $f7dd7d9983f5ca18$export$b9e669a853ca2f38);
$parcel$export(module.exports, "Fields", () => $f7dd7d9983f5ca18$export$833b3e5a19fb8939);
$parcel$export(module.exports, "testIds", () => $f7dd7d9983f5ca18$export$800daf5fbbe96aff);
$parcel$export(module.exports, "CONFLUENCE_EVENT_NAME", () => $f7dd7d9983f5ca18$export$c312550dc4e28902);
const $f7dd7d9983f5ca18$export$be0551febfd6121e = {
    confluencePage: 'confluence-page',
    confluenceWhiteboard: 'confluence-whiteboard'
};
const $f7dd7d9983f5ca18$export$b9e669a853ca2f38 = {
    PAGE: 'page',
    WHITEBOARD: 'whiteboard'
};
var $f7dd7d9983f5ca18$export$833b3e5a19fb8939 = /*#__PURE__*/ function(Fields) {
    Fields["Title"] = "title";
    Fields["Site"] = "site";
    Fields["SpacePage"] = "space_or_page";
    return Fields;
}({});
const $f7dd7d9983f5ca18$export$800daf5fbbe96aff = {
    form: 'link-create-confluence-form',
    title: 'link-create-confluence-title',
    site: 'link-create-confluence-site-picker',
    space: 'link-create-confluence-space-picker',
    error: 'link-create-confluence-form-error'
};
const $f7dd7d9983f5ca18$export$c312550dc4e28902 = {
    EDIT_PAGE: 'edit-page',
    EDIT_PAGE_LOAD: 'edit-page/load',
    EDIT_PAGE_PUBLISH: 'edit-page/publish',
    EDIT_PAGE_CLOSE: 'edit-page/close'
};

});


parcelRegister("dELl0", function(module, exports) {

$parcel$export(module.exports, "draftEmbeddedPageModalEntrypoint", () => $e5609c25f3baa9a1$export$11fd8fc5a8657f8);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $e5609c25f3baa9a1$export$11fd8fc5a8657f8 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("fsCJ1")), {
        moduleId: "a0941f4e",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("fsCJ1", function(module, exports) {

let $b417828b577cd7e3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b417828b577cd7e3$var$load("7rQZA").then(()=>parcelRequire('61q45'));

});


parcelRegister("2POIy", function(module, exports) {

$parcel$export(module.exports, "embeddedPanelEntrypoint", () => $ae604dc9c27c8401$export$32561f984de7bece);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $ae604dc9c27c8401$export$32561f984de7bece = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("bgzqZ")), {
        moduleId: "293c24d0",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("bgzqZ", function(module, exports) {

let $833cacd8ebfa64f3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $833cacd8ebfa64f3$var$load("lmiER").then(()=>parcelRequire('k1Lui'));

});


parcelRegister("iwjqc", function(module, exports) {

$parcel$export(module.exports, "createActivePageUrl", () => $5538d20fe7287eae$export$83c6318baef117fe);
$parcel$export(module.exports, "getURLFromConfluencePageResponse", () => $5538d20fe7287eae$export$e87b28852220b5cd);
$parcel$export(module.exports, "setHostnameForContent", () => $5538d20fe7287eae$export$8ccd4cc378896990);
$parcel$export(module.exports, "constructUrlIfCustomDomain", () => $5538d20fe7287eae$export$a63ef4c6a1286e2a);
$parcel$export(module.exports, "createLinkCreatePayload", () => $5538d20fe7287eae$export$af98278c506da0f4);

var $gKZoD = parcelRequire("gKZoD");

var $Geeam = parcelRequire("Geeam");

var $jg9TU = parcelRequire("jg9TU");
const $5538d20fe7287eae$export$f31b9480a5e4fdcf = (uri)=>{
    if (!uri || uri === '') return '';
    const matches = uri.match(/draftShareId=([^&])*/g);
    return matches ? matches[0].split('=')[1] : '';
};
const $5538d20fe7287eae$export$be3b1ed3560ef0e6 = ({ url: url, spaceId: spaceId, spaceKey: spaceKey })=>{
    if (!(url && spaceId && spaceKey)) return '';
    return url.replace(`spaces/${spaceId}`, `spaces/${spaceKey}`);
};
const $5538d20fe7287eae$export$83c6318baef117fe = (createPayload)=>{
    const { data: data, url: url } = createPayload;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const links = data?.links;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const spaceKey = data?.spaceKey;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const spaceId = data?.spaceId;
    const linkableUrl = $5538d20fe7287eae$export$be3b1ed3560ef0e6({
        url: url,
        spaceId: spaceId,
        spaceKey: spaceKey
    });
    if (data?.subType === 'live') return `${linkableUrl}`;
    return `${linkableUrl}?draftShareId=${$5538d20fe7287eae$export$f31b9480a5e4fdcf(links?.editui)}`;
};
const $5538d20fe7287eae$export$e87b28852220b5cd = ({ id: id, spaceKey: spaceKey, hostname: hostname })=>`${hostname}/wiki/spaces/${spaceKey}/pages/edit-v2/${id}/`;
const $5538d20fe7287eae$var$isUrlCustomDomain = (parentHost, url)=>{
    const hostname = (0, $Geeam.getHostnameFromUrl)(url);
    return (0, $jg9TU.isCustomDomain)(parentHost) || hostname && (0, $jg9TU.isCustomDomain)(hostname);
};
const $5538d20fe7287eae$export$8ccd4cc378896990 = (url, hostname)=>{
    (0, $gKZoD.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const parentHost = window?.location?.origin || '';
    const contentHost = hostname ?? (0, $Geeam.getHostnameFromUrl)(url);
    return $5538d20fe7287eae$var$isUrlCustomDomain(parentHost, url) ? (0, $Geeam.getHostnameFromUrl)(parentHost) : contentHost;
};
const $5538d20fe7287eae$export$a63ef4c6a1286e2a = ({ id: id, originalDomain: originalDomain, originalUrl: originalUrl, spaceKey: spaceKey, systemConfluenceAppLinkUrl: systemConfluenceAppLinkUrl })=>{
    (0, $gKZoD.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const currentHostname = window?.location?.origin || '';
    const hostnameFromUrl = (0, $Geeam.getHostnameFromUrl)(originalDomain);
    const systemHostName = (0, $Geeam.getHostnameFromUrl)(systemConfluenceAppLinkUrl);
    /*
		If content is not on the same tenant, and custom domain is enabled, we need to update the hostname
		to reflect the parentProduct's hostname
	*/ if (systemHostName !== hostnameFromUrl && $5538d20fe7287eae$var$isUrlCustomDomain(currentHostname, originalDomain)) return $5538d20fe7287eae$export$e87b28852220b5cd({
        id: id,
        spaceKey: spaceKey,
        hostname: currentHostname
    });
    return originalUrl;
};
const $5538d20fe7287eae$export$af98278c506da0f4 = (createResponse, url, space, cloudId)=>({
        url: url,
        ari: `ari:cloud:confluence:${cloudId}:page/${createResponse.id}`,
        objectId: createResponse.id,
        objectType: 'page',
        data: {
            spaceId: space.spaceId,
            spaceKey: space.spaceKey,
            spaceName: space.spaceName,
            status: createResponse.status,
            subType: createResponse.subtype,
            links: createResponse._links
        }
    });

});
parcelRegister("Geeam", function(module, exports) {

$parcel$export(module.exports, "getHostnameFromUrl", () => $43eec760bfcb2d7e$export$280e79c794cf814e);

var $cN3DC = parcelRequire("cN3DC");
const $43eec760bfcb2d7e$export$280e79c794cf814e = (url)=>(0, $cN3DC.isValidUrl)(url) ? new URL(url)?.hostname : '';

});
parcelRegister("cN3DC", function(module, exports) {

$parcel$export(module.exports, "isValidUrl", () => $8759602a30c2f837$export$bef94a5618bf18bf);
const $8759602a30c2f837$export$bef94a5618bf18bf = (urlString)=>{
    if (typeof urlString !== 'string') return false;
    try {
        return Boolean(new URL(urlString));
    } catch (e) {
        return false;
    }
};

});


parcelRegister("jg9TU", function(module, exports) {

$parcel$export(module.exports, "isCustomDomain", () => $cbdd6bc245553e48$export$97f4c254b641e719);
const $cbdd6bc245553e48$var$atlassianDomains = [
    '.atlassian.com',
    '.atlassian.net',
    '.jira-dev.com',
    '.jira.com',
    '.atlassian-stg-fedm.net',
    '.atlassian-us-gov-mod.net',
    '.atlassian-us-gov-mod.com'
];
const $cbdd6bc245553e48$export$97f4c254b641e719 = (hostname)=>!$cbdd6bc245553e48$var$atlassianDomains.some((domain)=>hostname.endsWith(domain));

});


parcelRegister("iXWB9", function(module, exports) {

$parcel$export(module.exports, "useEmbeddedPageDraft", () => $b6835e7ecd7c9a8c$export$8df6d110f6d46988);

var $5uXOq = parcelRequire("5uXOq");

var $gVnoy = parcelRequire("gVnoy");

var $gXSrH = parcelRequire("gXSrH");

var $jcw0u = parcelRequire("jcw0u");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");


var $agXTJ = parcelRequire("agXTJ");

var $4TSh0 = parcelRequire("4TSh0");

var $kHHi5 = parcelRequire("kHHi5");
const $b6835e7ecd7c9a8c$export$f0ebd8c41d592251 = 'success';
const $b6835e7ecd7c9a8c$export$12346a674644c156 = 'operational';
const $b6835e7ecd7c9a8c$export$8df6d110f6d46988 = ({ isLive: isLive, embeddedConfluenceSource: embeddedConfluenceSource, onClose: onClose, url: url, onEmbeddedContentAction: onEmbeddedContentAction, linkConfluencePage: linkConfluencePage })=>{
    const [{ panel: { isOpen: isOpen } }, actions] = (0, $gXSrH.useEmbeddedConfluenceSidePanel)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isContinueDraftOpen, setIsContinueDraftOpen] = (0, $5uXOq.useState)(false);
    const [isPublished, setIsPublished] = (0, $5uXOq.useState)(false);
    const [epMode, setEpMode] = (0, $5uXOq.useState)(isLive ? (0, $gVnoy.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE : (0, $gVnoy.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const fireAnalyticsEvent = (0, $4TSh0.useEmbeddedPageTracking)();
    const deferSpaceToast = (0, $co1wz.ff)('toast_defer_space_ntufi');
    const [{ confluenceData: { deferredSpaceName: deferredSpaceName } }] = (0, $gXSrH.useEmbeddedConfluenceSidePanel)();
    const handledLiveDocUrls = (0, $5uXOq.useRef)(new Set());
    (0, $5uXOq.useEffect)(()=>{
        if (deferSpaceToast && deferredSpaceName && isPublished) showFlag({
            key: (0, $7HGHK.toFlagId)((0, $a63f58192733759b$export$7f116601c876d82a)),
            type: 'success',
            title: formatMessage((0, $kHHi5.default).publishPageSuccessTitle),
            description: formatMessage((0, $kHHi5.default).deferSpacePublishPageSuccessDescription, {
                spaceName: deferredSpaceName
            }),
            messageId: 'issue-create-confluence-content.controllers.use-embedded-page-draft.show-flag.success.defer-space-publish-draft-success-flag',
            messageType: 'transactional'
        });
    }, [
        formatMessage,
        isPublished,
        deferSpaceToast,
        deferredSpaceName,
        showFlag
    ]);
    const openContinueDraftModal = (0, $5uXOq.useCallback)(()=>{
        if (!isPublished) {
            setIsContinueDraftOpen(true);
            fireAnalyticsEvent({
                action: 'clicked',
                eventName: isLive ? 'closeLiveDoc' : 'closeUnpublishedDraft',
                embeddedConfluenceSource: embeddedConfluenceSource
            });
        } else onClose && onClose();
    }, [
        embeddedConfluenceSource,
        fireAnalyticsEvent,
        isLive,
        isPublished,
        onClose
    ]);
    const closeContinueDraftModal = ()=>{
        setIsContinueDraftOpen(false);
    };
    const closeAll = ()=>{
        closeContinueDraftModal();
        onClose && onClose();
    };
    const handleEmbeddedContentAction = (0, $5uXOq.useCallback)((action, name)=>{
        const linkingSuccessDescriptionMessage = ()=>{
            if ((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3')) return isLive ? (0, $kHHi5.default).linkLiveDocSuccessDescriptionIssueTermRefresh : (0, $kHHi5.default).publishAndLinkPageSuccessDescriptionIssueTermRefresh;
            return isLive ? (0, $kHHi5.default).linkLiveDocSuccessDescription : (0, $kHHi5.default).publishAndLinkPageSuccessDescription;
        };
        if (name === 'edit-page/close') {
            if (isPublished) {
                setEpMode((0, $gVnoy.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE);
                if (isOpen) actions.setConfluenceData({
                    contentUrl: url,
                    mode: (0, $gVnoy.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE
                });
            } else openContinueDraftModal();
        }
        if (name === 'edit-page/load' && action === 'taskSuccess') {
            if (epMode === (0, $gVnoy.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE) {
                setEpMode((0, $gVnoy.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE);
                if (isOpen) actions.setConfluenceData({
                    contentUrl: url,
                    mode: (0, $gVnoy.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE
                });
            }
        }
        if (name === 'edit-page/publish' && action === 'taskSuccess') {
            if (isOpen) actions.setConfluenceData({
                contentUrl: url,
                isDraft: false,
                mode: (0, $gVnoy.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE
            });
            fireAnalyticsEvent({
                action: $b6835e7ecd7c9a8c$export$f0ebd8c41d592251,
                eventName: isLive ? 'createLiveDoc' : 'publishDraftPage',
                embeddedConfluenceSource: embeddedConfluenceSource,
                eventType: $b6835e7ecd7c9a8c$export$12346a674644c156
            });
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            if (isPublished && !isLive) showFlag({
                key: (0, $7HGHK.toFlagId)((0, $a63f58192733759b$export$e80a06e24863c775)),
                type: 'success',
                title: formatMessage((0, $kHHi5.default).publishPageSuccessTitle),
                description: formatMessage((0, $kHHi5.default).publishPageSuccessDescription),
                messageId: 'issue-create-confluence-content.controllers.use-embedded-page-draft.show-flag.success.publish-draft-success-flag',
                messageType: 'transactional'
            });
            else {
                setIsPublished(true);
                if (isOpen) actions.setConfluenceData({
                    contentUrl: url,
                    isDraft: false
                });
                // TODO this is a temporary solution, remove when https://hello.atlassian.net/jira/software/projects/CBT/boards/4465?selectedIssue=CBT-2895 is complete
                setTimeout(()=>{
                    try {
                        if (linkConfluencePage) {
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            linkConfluencePage((0, $agXTJ.convertToViewPageUrl)(url), analyticsEvent);
                            fireAnalyticsEvent({
                                action: $b6835e7ecd7c9a8c$export$f0ebd8c41d592251,
                                eventName: isLive ? 'linkConfluenceLiveDoc' : 'linkConfluencePage',
                                embeddedConfluenceSource: embeddedConfluenceSource,
                                eventType: $b6835e7ecd7c9a8c$export$12346a674644c156
                            });
                            if (!deferSpaceToast) showFlag({
                                key: (0, $7HGHK.toFlagId)((0, $a63f58192733759b$export$26c0043b48580bae)),
                                type: 'success',
                                title: formatMessage(isLive ? (0, $kHHi5.default).linkLiveDocSuccessTitle : (0, $kHHi5.default).publishAndLinkPageSuccessTitle),
                                description: formatMessage(linkingSuccessDescriptionMessage()),
                                messageId: 'issue-create-confluence-content.controllers.use-embedded-page-draft.show-flag.success.link-page-success-flag',
                                messageType: 'transactional'
                            });
                        }
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (error) {
                        (0, $jcw0u.default)({
                            meta: {
                                id: isLive ? 'linkConfluenceLiveDoc' : 'linkConfluencePage',
                                teamName: 'confluence-better-together'
                            },
                            attributes: {
                                embeddedConfluenceSource: embeddedConfluenceSource
                            },
                            error: error
                        });
                        showFlag({
                            key: (0, $7HGHK.toFlagId)((0, $a63f58192733759b$export$4164631cfaaf3681)),
                            type: 'error',
                            title: formatMessage((0, $kHHi5.default).linkPageFailedTitle),
                            description: formatMessage((0, $kHHi5.default).linkPageFailedDescription),
                            messageId: 'issue-create-confluence-content.controllers.use-embedded-page-draft.show-flag.error.link-page-failed-flag',
                            messageType: 'transactional'
                        });
                    }
                }, 3500);
            }
        }
        if (name === 'edit-page/publish' && action === 'taskFail') (0, $jcw0u.default)({
            meta: {
                id: isLive ? 'createLiveDoc' : 'publishDraftPage',
                teamName: 'confluence-better-together'
            },
            attributes: {
                embeddedConfluenceSource: embeddedConfluenceSource
            },
            error: new Error(`Error publishing draft page: {name: ${name}, action: ${action}}`)
        });
        onEmbeddedContentAction && onEmbeddedContentAction(action, name);
    }, [
        createAnalyticsEvent,
        embeddedConfluenceSource,
        epMode,
        fireAnalyticsEvent,
        formatMessage,
        isPublished,
        deferSpaceToast,
        linkConfluencePage,
        onEmbeddedContentAction,
        openContinueDraftModal,
        showFlag,
        url,
        actions,
        isOpen,
        isLive
    ]);
    // This is a little weird, but to avoid duplicating the code above, if the page is live and state local state is !isPublished,
    // we simulate the action of publishing from inside the ep modal. This in turn displays the view page, link the page to the issue
    // and show the flag about the page being published and linked.
    (0, $5uXOq.useEffect)(()=>{
        if (isLive && embeddedConfluenceSource?.endsWith('Panel') && !handledLiveDocUrls.current.has(url)) {
            handledLiveDocUrls.current.add(url);
            if (handledLiveDocUrls.current.has(url)) handleEmbeddedContentAction('taskSuccess', 'edit-page/publish');
            else handleEmbeddedContentAction('taskFail', 'edit-page/publish');
        }
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLive,
        url
    ]);
    // in the case that the user creates a live doc and then wants to create a page, we must ensure we open the draft for the page in edit mode
    (0, $5uXOq.useEffect)(()=>{
        setEpMode(isLive ? (0, $gVnoy.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE : (0, $gVnoy.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE);
    }, [
        isLive
    ]);
    return {
        isContinueDraftOpen: isContinueDraftOpen,
        openContinueDraftModal: openContinueDraftModal,
        closeContinueDraftModal: closeContinueDraftModal,
        closeAll: closeAll,
        handleEmbeddedContentAction: handleEmbeddedContentAction,
        fireAnalyticsEvent: fireAnalyticsEvent,
        epMode: epMode
    };
};

});
const $a63f58192733759b$export$e80a06e24863c775 = 'publishDraftSuccess';
const $a63f58192733759b$export$7f116601c876d82a = 'deferSpacePublishDraftSuccess';
const $a63f58192733759b$export$26c0043b48580bae = 'linkPageSuccess';
const $a63f58192733759b$export$7600137866a0229f = 'publishDraftFailed';
const $a63f58192733759b$export$4164631cfaaf3681 = 'linkPageFailed';

parcelRegister("agXTJ", function(module, exports) {

$parcel$export(module.exports, "convertToViewPageUrl", () => $eade785ed1bc7542$export$fbd50b21ccd324a6);
const $eade785ed1bc7542$export$fbd50b21ccd324a6 = (url)=>// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    url.split('/').filter((part)=>part !== 'edit-v2').join('/');

});

parcelRegister("4TSh0", function(module, exports) {

$parcel$export(module.exports, "useEmbeddedPageTracking", () => $391c3839ff18e3b3$export$9fcd107e4ed1de75);

var $5uXOq = parcelRequire("5uXOq");

var $2gCtH = parcelRequire("2gCtH");

var $2NMNM = parcelRequire("2NMNM");

var $9OXo1 = parcelRequire("9OXo1");

var $kEkg3 = parcelRequire("kEkg3");

var $gFmVN = parcelRequire("gFmVN");
const $391c3839ff18e3b3$export$9fcd107e4ed1de75 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const source = (0, $2gCtH.useAnalyticsSource)();
    const trackEmbeddedConfluence = (0, $5uXOq.useCallback)(({ eventName: eventName, action: action, actionSubject: actionSubject, contentType: contentType, projectType: projectType, embeddedConfluenceSource: embeddedConfluenceSource = 'jiraIssueView', eventType: eventType = 'ui', flow: flow, userHasConfluenceAccess: userHasConfluenceAccess, tenantHasConfluence: tenantHasConfluence, crossJoinStatus: crossJoinStatus, originProduct: originProduct, requestedProduct: requestedProduct, isLivePage: isLivePage, linkObjectType: linkObjectType, confluenceContentId: confluenceContentId })=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject ?? `${eventName}`
        });
        const attributes = {
            parentProduct: (0, $gFmVN.getParentProduct)(projectType),
            tenantEditions: tenantContext?.appEditions,
            productEntitlementDetails: tenantContext?.productEntitlementDetails,
            embeddedConfluenceSource: embeddedConfluenceSource,
            flow: flow,
            jiraIssueSurfaceArea: source,
            userHasConfluenceAccess: userHasConfluenceAccess,
            tenantHasConfluence: tenantHasConfluence,
            crossJoinStatus: crossJoinStatus,
            originProduct: originProduct,
            requestedProduct: requestedProduct,
            isLivePage: isLivePage,
            isSiteAdmin: tenantContext?.isSiteAdmin,
            linkObjectType: linkObjectType,
            confluenceContentId: confluenceContentId,
            contentType: contentType
        };
        (0, $kEkg3.fireEmbeddedConfluenceAnalytics)({
            analyticsEvent: analyticsEvent,
            attributes: attributes,
            eventType: eventType,
            eventName: `${actionSubject ?? eventName} ${action}`
        });
    }, [
        source,
        tenantContext,
        createAnalyticsEvent
    ]);
    return trackEmbeddedConfluence;
};

});
parcelRegister("kEkg3", function(module, exports) {

$parcel$export(module.exports, "fireEmbeddedConfluenceAnalytics", () => $502082c06cc8bb17$export$864bc2da9014e8e9);

var $8zOmE = parcelRequire("8zOmE");
const $502082c06cc8bb17$export$864bc2da9014e8e9 = ({ analyticsEvent: analyticsEvent, attributes: attributes, eventType: eventType, eventName: eventName })=>{
    switch(eventType){
        case 'ui':
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, attributes);
            break;
        case 'operational':
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, `${eventName}`, attributes);
            break;
        case 'track':
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, `${eventName}`, attributes);
            break;
        default:
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, attributes);
            break;
    }
};

});

parcelRegister("gFmVN", function(module, exports) {

$parcel$export(module.exports, "ACCESS_REQUEST_CAPABILITIES", () => $e40b1af8ddf646ed$export$b4e6d6efc113ca5);
$parcel$export(module.exports, "VALID_DIRECT_ACCESS_STATUS", () => $e40b1af8ddf646ed$export$bf1e31028b579014);
$parcel$export(module.exports, "ACCESS_DENIED_STATUSES", () => $e40b1af8ddf646ed$export$2fe5bb2d968b01fc);
$parcel$export(module.exports, "LICENCE_EXCEEDED_STATUS", () => $e40b1af8ddf646ed$export$56360b096b4b4439);
$parcel$export(module.exports, "getParentProduct", () => $e40b1af8ddf646ed$export$e873edb2560a07ef);

var $2vSU6 = parcelRequire("2vSU6");




const $e40b1af8ddf646ed$export$b4e6d6efc113ca5 = {
    ACCESS_GRANTED: 'ACCESS_GRANTED',
    ACCESS_EXISTS: 'ACCESS_EXISTS',
    DENIED_REQUEST_EXISTS: 'DENIED_REQUEST_EXISTS',
    DIRECT_ACCESS: 'DIRECT_ACCESS',
    FORBIDDEN: 'FORBIDDEN',
    PENDING_REQUEST_EXISTS: 'PENDING_REQUEST_EXISTS',
    REQUEST_ACCESS: 'REQUEST_ACCESS'
};
const $e40b1af8ddf646ed$export$bf1e31028b579014 = [
    $e40b1af8ddf646ed$export$b4e6d6efc113ca5.ACCESS_EXISTS,
    $e40b1af8ddf646ed$export$b4e6d6efc113ca5.ACCESS_GRANTED,
    $e40b1af8ddf646ed$export$b4e6d6efc113ca5.PENDING_REQUEST_EXISTS
];
const $e40b1af8ddf646ed$export$2fe5bb2d968b01fc = [
    $e40b1af8ddf646ed$export$b4e6d6efc113ca5.FORBIDDEN,
    $e40b1af8ddf646ed$export$b4e6d6efc113ca5.DENIED_REQUEST_EXISTS
];
const $e40b1af8ddf646ed$export$56360b096b4b4439 = 'licence-exceeded';
const $e40b1af8ddf646ed$export$e873edb2560a07ef = (projectType)=>{
    switch(projectType){
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return 'JSM';
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return 'JSW';
        case 0, $2vSU6.CORE_PROJECT:
            return 'JWM';
        default:
            return 'JSW';
    }
};

});


parcelRegister("kHHi5", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d6ce0ae8e5209ef$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7d6ce0ae8e5209ef$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    publishPageSuccessTitle: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.publish-page-success-title",
        "defaultMessage": "Published!"
    },
    publishPageSuccessDescription: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.publish-page-success-description",
        "defaultMessage": "Successfully published page"
    },
    deferSpacePublishPageSuccessDescription: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.defer-space-publish-page-success-description",
        "defaultMessage": "Your page was successfully published in the {spaceName} space"
    },
    publishPageFailedTitle: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.publish-page-failed-title",
        "defaultMessage": "Something went wrong"
    },
    publishPageFailedDescription: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.publish-page-failed-description",
        "defaultMessage": "We are unable to publish your page at this time"
    },
    linkPageFailedTitle: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.link-page-failed-title",
        "defaultMessage": "Something went wrong."
    },
    linkPageFailedDescription: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.link-page-failed-description",
        "defaultMessage": "We are unable to link your page at this time"
    },
    publishAndLinkPageSuccessTitle: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.publish-and-link-page-success-title",
        "defaultMessage": "Published!"
    },
    publishAndLinkPageSuccessDescription: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.publish-and-link-page-success-description",
        "defaultMessage": "Your page has been published and linked to your Jira issue."
    },
    publishAndLinkPageSuccessDescriptionIssueTermRefresh: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.publish-and-link-page-success-description-issue-term-refresh",
        "defaultMessage": "Your page has been published and linked to your Jira work item."
    },
    linkLiveDocSuccessTitle: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.link-live-doc-success-title",
        "defaultMessage": "Live doc created"
    },
    linkLiveDocSuccessDescription: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.link-live-doc-success-description",
        "defaultMessage": "A live doc was created and linked to your Jira issue."
    },
    linkLiveDocSuccessDescriptionIssueTermRefresh: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.link-live-doc-success-description-issue-term-refresh",
        "defaultMessage": "A live doc was created and linked to your Jira work item."
    }
});

});


parcelRegister("fvjUj", function(module, exports) {

$parcel$export(module.exports, "useParentProduct", () => $af9df26010027d57$export$1b09c6e3737c8eb7);

var $dAfqg = parcelRequire("dAfqg");

var $gFmVN = parcelRequire("gFmVN");
const $af9df26010027d57$export$1b09c6e3737c8eb7 = ()=>{
    const { data: data } = (0, $dAfqg.useProjectContext)();
    const projectType = data?.projectType;
    return (0, $gFmVN.getParentProduct)(projectType);
};

});

parcelRegister("15U5v", function(module, exports) {

$parcel$export(module.exports, "embeddedWhiteboardModalEntrypoint", () => $d98ca876c86f40a2$export$652b3f11839af9e6);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $d98ca876c86f40a2$export$652b3f11839af9e6 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("iVbxx")), {
        moduleId: "d273fc0f",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("iVbxx", function(module, exports) {

let $dc6680736e38e861$var$load = (parcelRequire("28QjX"))(4);
module.exports = $dc6680736e38e861$var$load("ilxRm").then(()=>parcelRequire('9yvvI'));

});




parcelRegister("km1Z8", function(module, exports) {

$parcel$export(module.exports, "ImperativeAPI", () => $b3ed488811f6683d$export$e2ad0ff52e7f8c84);

var $5uXOq = parcelRequire("5uXOq");

var $axSKo = parcelRequire("axSKo");

var $jH6yN = parcelRequire("jH6yN");
const $b3ed488811f6683d$export$e2ad0ff52e7f8c84 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $axSKo.Consumer), null, ({ getManager: getManager })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jH6yN.ImperativeAPI), {
            getItemManager: getManager
        }));

});
parcelRegister("axSKo", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $da7a6c3542bd9710$export$2881499e37b75b9a);
$parcel$export(module.exports, "Consumer", () => $da7a6c3542bd9710$export$b3bffd4bb7da6b8f);

var $5uXOq = parcelRequire("5uXOq");

var $fr1K2 = parcelRequire("fr1K2");

var $itvk3 = parcelRequire("itvk3");

var $7KTvf = parcelRequire("7KTvf");
const $da7a6c3542bd9710$var$Context = (0, $itvk3.default)('ItemManagers');
const $da7a6c3542bd9710$export$275138de3066e8b3 = 30000;
class $da7a6c3542bd9710$export$2881499e37b75b9a extends (0, $5uXOq.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da7a6c3542bd9710$var$Context.Provider, {
            value: this.manager
        }, this.props.children);
    }
    constructor(...args){
        super(...args), this.state = {
            managers: {}
        }, this.getManager = (managerKey)=>{
            const { managers: managers } = this.state;
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
            const manager = managers[managerKey];
            if (manager) return manager;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return new Promise((resolve, reject)=>{
                const message = `Timeout. "${(0, $7KTvf.fromManagerKey)(managerKey)}" wasn't registered after ${$da7a6c3542bd9710$export$275138de3066e8b3}ms`;
                const rejectTimeoutId = setTimeout(()=>reject(new Error(message)), $da7a6c3542bd9710$export$275138de3066e8b3);
                const { pendingManagers: pendingManagers } = this;
                pendingManagers[managerKey] || (pendingManagers[managerKey] = []);
                pendingManagers[managerKey].push((methods)=>{
                    clearTimeout(rejectTimeoutId);
                    resolve(methods);
                });
            });
        }, this.registerManager = (managerKey, methods)=>{
            this.setState((previousState)=>{
                if (methods == null) return {
                    managers: (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(previousState.managers, managerKey)
                };
                const managerResolvers = this.pendingManagers[managerKey];
                if (managerResolvers && managerResolvers.length) {
                    managerResolvers.forEach((resolve)=>resolve(methods));
                    managerResolvers.length = 0;
                }
                return {
                    managers: {
                        ...previousState.managers,
                        [managerKey]: Promise.resolve(methods)
                    }
                };
            });
        }, this.pendingManagers = {}, this.manager = {
            getManager: this.getManager,
            registerManager: this.registerManager
        };
    }
}
const { Consumer: $da7a6c3542bd9710$export$b3bffd4bb7da6b8f } = $da7a6c3542bd9710$var$Context;

});
parcelRegister("itvk3", function(module, exports) {

$parcel$export(module.exports, "default", () => $00b840b80ca03789$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$00b840b80ca03789$export$2e2bcd8739ae039 = (name)=>{
    const contextObjName = name || '';
    const defaultGetter = ()=>{
        throw new Error(`The Consumer for ${contextObjName} Context Object does not have a correct value. Maybe, it needs to be wrapped in its corresponding Provider`);
    };
    const Context = /*#__PURE__*/ (0, $5uXOq.createContext)(defaultGetter);
    const ContextConsumer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Context.Consumer, null, (getValue)=>{
            const value = getValue();
            return props.children(value);
        });
    const ContextProvider = ({ value: value, children: children })=>{
        const getValue = ()=>value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Context.Provider, {
            value: getValue
        }, children);
    };
    ContextProvider.displayName = `${contextObjName}SafeProvider`;
    ContextConsumer.displayName = `${contextObjName}SafeConsumer`;
    // @ts-expect-error - TS2741 - Property '$$typeof' is missing in type '{ ({ value, children }: ProviderProps<T>): JSX.Element; displayName: string; }' but required in type 'ProviderExoticComponent<ProviderProps<T>>'. | TS2741 - Property '$$typeof' is missing in type '{ (props: Props<T>): JSX.Element; displayName: string; }' but required in type 'ExoticComponent<ConsumerProps<T>>'.
    return {
        Provider: ContextProvider,
        Consumer: ContextConsumer
    };
};

});

parcelRegister("7KTvf", function(module, exports) {

$parcel$export(module.exports, "fromManagerKey", () => $067bae373d6cebdd$export$fef172a673b3ef47);
const $067bae373d6cebdd$export$e6ee4c5f89b06a38 = (managerKey)=>managerKey;
const $067bae373d6cebdd$export$fef172a673b3ef47 = (managerKey)=>String(managerKey);

});


parcelRegister("jH6yN", function(module, exports) {

$parcel$export(module.exports, "ImperativeAPI", () => $5d8d26c2e79a214b$export$e2ad0ff52e7f8c84);

var $5uXOq = parcelRequire("5uXOq");

var $9B86Q = parcelRequire("9B86Q");

var $2YZCu = parcelRequire("2YZCu");

var $7oGEb = parcelRequire("7oGEb");

var $1ADgn = parcelRequire("1ADgn");

var $gPQRI = parcelRequire("gPQRI");

var $1J3t1 = parcelRequire("1J3t1");

var $jRCeJ = parcelRequire("jRCeJ");

var $7KTvf = parcelRequire("7KTvf");

var $lVJAU = parcelRequire("lVJAU");

var $fTkzd = parcelRequire("fTkzd");
const $5d8d26c2e79a214b$var$ERROR_LOCATION = 'legacy.imperative-api';
const $5d8d26c2e79a214b$export$e2ad0ff52e7f8c84 = ({ getItemManager: getItemManager })=>{
    const { collapseLeftSidebar: collapseLeftSidebar, expandLeftSidebar: expandLeftSidebar } = (0, $gPQRI.useLeftSidebarController)();
    const { refresh: refresh } = (0, $1J3t1.useProjectSidebarNavigation)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const sidebarState = (0, $gPQRI.useLeftSidebarState)();
    const sidebarRef = (0, $5uXOq.useRef)(sidebarState);
    const refreshSidebarRef = (0, $5uXOq.useRef)(refresh);
    const imperativeAPIRef = (0, $5uXOq.useRef)({
        viewIds: $fTkzd.viewIds,
        itemIds: $fTkzd.itemIds,
        expand: expandLeftSidebar,
        collapse: collapseLeftSidebar,
        isCollapsed: ()=>sidebarRef.current.isCollapsed,
        onCollapse: ()=>undefined,
        onCollapseStart: ()=>undefined,
        onCollapseEnd: ()=>undefined,
        onExpand: ()=>undefined,
        onExpandStart: ()=>undefined,
        onExpandEnd: ()=>undefined,
        onItemClick: ()=>undefined,
        setView: ()=>undefined,
        updateActiveView: ()=>undefined,
        setProjectRootView: ()=>undefined,
        getActiveViewItems: ()=>[],
        isInProjectContext: ()=>false,
        updateContext: ()=>undefined,
        updateData: ()=>{
            refreshSidebarRef.current();
        },
        getItemManager: (itemManagerKey)=>getItemManager(itemManagerKey).catch((e)=>{
                (0, $2YZCu.default).safeErrorWithoutCustomerData($5d8d26c2e79a214b$var$ERROR_LOCATION, `There was a problem getting "${(0, $7KTvf.fromManagerKey)(itemManagerKey)}" item manager`, e);
                throw e;
            }),
        createBoard: ()=>{
            (0, $1ADgn.default)();
        },
        modalOpen: ()=>undefined,
        modalClose: ()=>undefined,
        navigate: (url)=>push(url)
    });
    sidebarRef.current = sidebarState;
    refreshSidebarRef.current = refresh;
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $9B86Q.loadBridgeWeak)({
            name: 'jira/navigation/bridge'
        }).then((bridge)=>{
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            bridge(imperativeAPIRef.current);
        });
        (0, $7oGEb.provideNavigationApi)({
            navigate: push
        });
    }, [
        push
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jRCeJ.NavigationUIContainer), {
        isGlobal: true
    });
};

});
parcelRegister("7oGEb", function(module, exports) {

$parcel$export(module.exports, "provideNavigationApi", () => $6e1dad164f29ee43$export$26d28e8849b2805f);
$parcel$export(module.exports, "isInIframe", () => $6e1dad164f29ee43$export$9f140ed41af5108c);
$parcel$export(module.exports, "canSpaTransition", () => $6e1dad164f29ee43$export$59e771495885068f);
$parcel$export(module.exports, "getContainerApi", () => $6e1dad164f29ee43$export$91ed870fd8df2bcb);
$parcel$export(module.exports, "getNavigationApi", () => $6e1dad164f29ee43$export$da4e5a44286a0dd0);
// Old AMD key: `ac/spa-context`
// TODO: we will improve the type later when we know the code better.
let $6e1dad164f29ee43$var$containerApi = null;
let $6e1dad164f29ee43$var$navigationApi = null;
const $6e1dad164f29ee43$export$3927fb5df700a968 = (api)=>{
    $6e1dad164f29ee43$var$containerApi = api;
};
const $6e1dad164f29ee43$export$26d28e8849b2805f = (api)=>{
    $6e1dad164f29ee43$var$navigationApi = api;
};
const $6e1dad164f29ee43$export$9f140ed41af5108c = ()=>$6e1dad164f29ee43$var$containerApi !== null;
const $6e1dad164f29ee43$export$59e771495885068f = ()=>$6e1dad164f29ee43$var$navigationApi !== null;
const $6e1dad164f29ee43$export$91ed870fd8df2bcb = ()=>$6e1dad164f29ee43$var$containerApi;
const $6e1dad164f29ee43$export$da4e5a44286a0dd0 = ()=>$6e1dad164f29ee43$var$navigationApi;
const $6e1dad164f29ee43$export$6ba42130b045ede1 = ()=>{
    $6e1dad164f29ee43$var$containerApi = null;
    $6e1dad164f29ee43$var$navigationApi = null;
};

});

parcelRegister("1ADgn", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a5ce13af6407cab$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $7T84i = parcelRequire("7T84i");
const $7a5ce13af6407cab$var$amdModuleName = 'jira-agile/sidebar/create-board-adg3';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7a5ce13af6407cab$export$2e2bcd8739ae039 = async ()=>{
    // eslint-disable-next-line jira/wrm/no-load-bridge
    const module = await (0, $7T84i.loadBridgeStrict)({
        name: $7a5ce13af6407cab$var$amdModuleName,
        wrmKeys: [
            'wrc!com.pyxis.greenhopper.jira:gh-create-board'
        ]
    });
    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    return module.openCreateBoardModal();
};

});

parcelRegister("jRCeJ", function(module, exports) {

$parcel$export(module.exports, "NavigationUISubscriber", () => $54656242ba3a5025$export$d3dc1c18cfde5ddd);
$parcel$export(module.exports, "NavigationUIContainer", () => $54656242ba3a5025$export$339ec9ca159ad81f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $51nlc = parcelRequire("51nlc");

var $3h4uJ = parcelRequire("3h4uJ");
const $54656242ba3a5025$export$d3dc1c18cfde5ddd = (0, $51nlc.createSubscriber)((0, $3h4uJ.default), {
    displayName: 'NavigationUISubscriber',
    selector: null
});
const $54656242ba3a5025$export$339ec9ca159ad81f = (0, $gg7kZ.createContainer)((0, $3h4uJ.default));

});
parcelRegister("3h4uJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ca73b0c81372577$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iXqE5 = parcelRequire("iXqE5");

var $8pFbi = parcelRequire("8pFbi");
const $8ca73b0c81372577$var$initialState = {
    collapseStart: new Set(),
    collapseEnd: new Set(),
    expandStart: new Set(),
    expandEnd: new Set()
};
var $8ca73b0c81372577$export$2e2bcd8739ae039 = (0, $iXqE5.createStore)({
    name: 'navigation-ui',
    initialState: $8ca73b0c81372577$var$initialState,
    actions: $8pFbi.default
});

});
parcelRegister("8pFbi", function(module, exports) {

$parcel$export(module.exports, "default", () => $c96738f03994c2c6$export$2e2bcd8739ae039);

var $cIPJW = parcelRequire("cIPJW");
var $aUW0i = parcelRequire("aUW0i");
var $44KUn = parcelRequire("44KUn");
var $5UAf7 = parcelRequire("5UAf7");
const $c96738f03994c2c6$var$actions = {
    collapseStartAdd: (cb)=>({ dispatch: dispatch })=>dispatch($cIPJW.default('collapseStart', cb)),
    collapseStartRemove: (cb)=>({ dispatch: dispatch })=>dispatch($44KUn.default('collapseStart', cb)),
    collapseStartClear: ()=>({ dispatch: dispatch })=>dispatch($aUW0i.default('collapseStart')),
    collapseStartRun: ()=>({ dispatch: dispatch })=>dispatch($5UAf7.default('collapseStart')),
    collapseEndAdd: (cb)=>({ dispatch: dispatch })=>dispatch($cIPJW.default('collapseEnd', cb)),
    collapseEndRemove: (cb)=>({ dispatch: dispatch })=>dispatch($44KUn.default('collapseEnd', cb)),
    collapseEndClear: ()=>({ dispatch: dispatch })=>dispatch($aUW0i.default('collapseEnd')),
    // @ts-expect-error - TS2322 - Type '(cb: any) => ({ dispatch }: { dispatch: any; }) => any' is not assignable to type 'ActionRun'.
    collapseEndRun: // @ts-expect-error - TS7006 - Parameter 'cb' implicitly has an 'any' type.
    (cb)=>// @ts-expect-error - TS7031 - Binding element 'dispatch' implicitly has an 'any' type.
        ({ dispatch: dispatch })=>dispatch($5UAf7.default('collapseEnd', cb)),
    expandStartAdd: (cb)=>({ dispatch: dispatch })=>dispatch($cIPJW.default('expandStart', cb)),
    expandStartRemove: (cb)=>({ dispatch: dispatch })=>dispatch($44KUn.default('expandStart', cb)),
    expandStartClear: ()=>({ dispatch: dispatch })=>dispatch($aUW0i.default('expandStart')),
    // @ts-expect-error - TS2322 - Type '(cb: any) => ({ dispatch }: { dispatch: any; }) => any' is not assignable to type 'ActionRun'.
    expandStartRun: // @ts-expect-error - TS7006 - Parameter 'cb' implicitly has an 'any' type.
    (cb)=>// @ts-expect-error - TS7031 - Binding element 'dispatch' implicitly has an 'any' type.
        ({ dispatch: dispatch })=>dispatch($5UAf7.default('expandStart', cb)),
    expandEndAdd: (cb)=>({ dispatch: dispatch })=>dispatch($cIPJW.default('expandEnd', cb)),
    expandEndRemove: (cb)=>({ dispatch: dispatch })=>dispatch($44KUn.default('expandEnd', cb)),
    expandEndClear: ()=>({ dispatch: dispatch })=>dispatch($aUW0i.default('expandEnd')),
    // @ts-expect-error - TS2322 - Type '(cb: any) => ({ dispatch }: { dispatch: any; }) => any' is not assignable to type 'ActionRun'.
    expandEndRun: // @ts-expect-error - TS7006 - Parameter 'cb' implicitly has an 'any' type.
    (cb)=>// @ts-expect-error - TS7031 - Binding element 'dispatch' implicitly has an 'any' type.
        ({ dispatch: dispatch })=>dispatch($5UAf7.default('expandEnd', cb)),
    clearAll: ()=>({ dispatch: dispatch })=>{
            dispatch($c96738f03994c2c6$var$actions.collapseStartClear());
            dispatch($c96738f03994c2c6$var$actions.collapseEndClear());
            dispatch($c96738f03994c2c6$var$actions.expandStartClear());
            dispatch($c96738f03994c2c6$var$actions.expandEndClear());
        }
};
var $c96738f03994c2c6$export$2e2bcd8739ae039 = $c96738f03994c2c6$var$actions;

});
parcelRegister("cIPJW", function(module, exports) {

$parcel$export(module.exports, "default", () => $98a193bdf9026fb7$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $44KUn = parcelRequire("44KUn");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$98a193bdf9026fb7$export$2e2bcd8739ae039 = (key, callback)=>// @ts-expect-error - TS2322 - Type '({ setState, getState, dispatch }: StoreActionApi<T>) => () => void' is not assignable to type 'Action<T, void, void | Promise<void>>'.
    ({ setState: setState, getState: getState, dispatch: dispatch })=>{
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Set<unknown>; }' is not assignable to parameter of type 'Partial<T>'.
        setState({
            [key]: new Set(getState()[key]).add(callback)
        });
        return ()=>dispatch((0, $44KUn.default)(key, callback));
    };

});
parcelRegister("44KUn", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cd1dd9b883bc2d4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4cd1dd9b883bc2d4$export$2e2bcd8739ae039 = (key, callback)=>({ setState: setState, getState: getState })=>{
        if (!getState()[key]) return;
        const slice = new Set(getState()[key]);
        slice.delete(callback);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Set<unknown>; }' is not assignable to parameter of type 'Partial<T>'.
        setState({
            [key]: slice
        });
    };

});


parcelRegister("aUW0i", function(module, exports) {

$parcel$export(module.exports, "default", () => $0765ad08a31511d2$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0765ad08a31511d2$export$2e2bcd8739ae039 = (key)=>({ setState: setState })=>// @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Set<unknown>; }' is not assignable to parameter of type 'Partial<T>'.
        setState({
            [key]: new Set()
        });

});

parcelRegister("5UAf7", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc474c9b594a3d77$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$dc474c9b594a3d77$export$2e2bcd8739ae039 = (key, ...args)=>({ getState: getState })=>// @ts-expect-error - TS2339 - Property 'forEach' does not exist on type 'Set<unknown> | T[string]'. | TS7006 - Parameter 'cb' implicitly has an 'any' type.
        (getState()[key] || new Set()).forEach((cb)=>cb(...args));

});




parcelRegister("fTkzd", function(module, exports) {

$parcel$export(module.exports, "itemIds", () => $e0d97c8d376b70de$export$443ec49e59de3663);
$parcel$export(module.exports, "viewIds", () => $e0d97c8d376b70de$export$8ee2fd038785d9dc);

var $16J3A = parcelRequire("16J3A");
const $e0d97c8d376b70de$var$ROOT = 'root/index';
const $e0d97c8d376b70de$var$ISSUES = 'root/issues';
const $e0d97c8d376b70de$var$DASHBOARDS = 'root/dashboards';
const $e0d97c8d376b70de$var$PORTFOLIO = 'root/portfolio';
const $e0d97c8d376b70de$var$WORK_SCRUM = 'work-scrum';
const $e0d97c8d376b70de$var$PLAN_SCRUM = 'plan-scrum';
const $e0d97c8d376b70de$var$WORK_KANBAN = 'work-kanban';
const $e0d97c8d376b70de$var$PLAN_KANBAN = 'plan-kanban';
const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES = 'pin-filter-myopenissues';
const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES = 'pin-filter-reportedbyme';
const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES = 'pin-filter-allissues';
const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES = 'pin-filter-allopenissues';
const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES = 'pin-filter-doneissues';
const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES = 'pin-filter-recentlyviewed';
const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES = 'pin-filter-addedrecently';
const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES = 'pin-filter-resolvedrecently';
const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES = 'pin-filter-updatedrecently';
const $e0d97c8d376b70de$var$AGILITY = 'project/agility/index';
const $e0d97c8d376b70de$var$BUSINESS = 'project/business/index';
const $e0d97c8d376b70de$var$OPS = 'project/ops/index';
const $e0d97c8d376b70de$var$SOFTWARE = 'project/software/index';
const $e0d97c8d376b70de$var$SOFTWARE_ISSUES = 'project/software/issues';
const $e0d97c8d376b70de$var$SOFTWARE_REPORTS = 'project/software/reports';
const $e0d97c8d376b70de$var$USER = 'user/index';
const $e0d97c8d376b70de$var$USER_REPORTS = 'user/reports';
const $e0d97c8d376b70de$var$rootProjectViewIds = {
    AGILITY: $e0d97c8d376b70de$var$AGILITY,
    SERVICE_DESK: $16J3A.SERVICE_DESK,
    OPS: $e0d97c8d376b70de$var$OPS,
    BUSINESS: $e0d97c8d376b70de$var$BUSINESS,
    SOFTWARE: $e0d97c8d376b70de$var$SOFTWARE
};
const $e0d97c8d376b70de$var$rootViewIds = {
    ROOT: $e0d97c8d376b70de$var$ROOT,
    ISSUES: $e0d97c8d376b70de$var$ISSUES,
    DASHBOARDS: $e0d97c8d376b70de$var$DASHBOARDS,
    PORTFOLIO: $e0d97c8d376b70de$var$PORTFOLIO
};
const $e0d97c8d376b70de$export$443ec49e59de3663 = {
    WORK_SCRUM: $e0d97c8d376b70de$var$WORK_SCRUM,
    PLAN_SCRUM: $e0d97c8d376b70de$var$PLAN_SCRUM,
    WORK_KANBAN: $e0d97c8d376b70de$var$WORK_KANBAN,
    PLAN_KANBAN: $e0d97c8d376b70de$var$PLAN_KANBAN,
    PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES,
    ...(0, $16J3A.SERVICE_DESK_ITEMS)
};
const $e0d97c8d376b70de$export$8ee2fd038785d9dc = {
    ...$e0d97c8d376b70de$var$rootViewIds,
    ...$e0d97c8d376b70de$var$rootProjectViewIds,
    SOFTWARE_ISSUES: $e0d97c8d376b70de$var$SOFTWARE_ISSUES,
    SOFTWARE_REPORTS: $e0d97c8d376b70de$var$SOFTWARE_REPORTS,
    SERVICE_DESK_ISSUES: $16J3A.SERVICE_DESK_ISSUES,
    SERVICE_DESK_QUEUES: $16J3A.SERVICE_DESK_QUEUES,
    SERVICE_DESK_REPORTS: $16J3A.SERVICE_DESK_REPORTS,
    SERVICE_DESK_SETTINGS: $16J3A.SERVICE_DESK_SETTINGS,
    SERVICE_DESK_LANGUAGES: $16J3A.SERVICE_DESK_LANGUAGES,
    SERVICE_DESK_LEGACY_TICKET_TYPES: $16J3A.SERVICE_DESK_LEGACY_TICKET_TYPES,
    SERVICE_DESK_TRANSLATIONS: $16J3A.SERVICE_DESK_TRANSLATIONS,
    SERVICE_DESK_AUTOMATION_SUB_NAV: $16J3A.SERVICE_DESK_AUTOMATION_SUB_NAV,
    SERVICE_DESK_KNOWLEDGE_HUB: $16J3A.SERVICE_DESK_KNOWLEDGE_HUB,
    USER: $e0d97c8d376b70de$var$USER,
    USER_REPORTS: $e0d97c8d376b70de$var$USER_REPORTS
};

});
parcelRegister("16J3A", function(module, exports) {

$parcel$export(module.exports, "REPORTS_IDS", () => $6fb2b1c825061655$export$1f70a76cb421b107);
$parcel$export(module.exports, "HOME_ITEMS_IDS", () => $6fb2b1c825061655$export$9afbea2cbd37e16d);
$parcel$export(module.exports, "PRACTICES_IDS", () => $6fb2b1c825061655$export$a37f4f7add086a3);
$parcel$export(module.exports, "SERVICE_DESK_ITEMS", () => $6fb2b1c825061655$export$2108a7f32cd0bb12);
$parcel$export(module.exports, "REQUEST_TYPE_PRACTICE_NAV_ONBOARDING", () => $6fb2b1c825061655$export$712b4b205a2bcf1e);
$parcel$export(module.exports, "STARRED_QUEUE_SPOTLIGHT", () => $6fb2b1c825061655$export$e2d46b728fe0a15a);
$parcel$export(module.exports, "SERVICE_DESK", () => $6fb2b1c825061655$export$c8c1c8c3f8ddba61);
$parcel$export(module.exports, "SERVICE_DESK_ISSUES", () => $6fb2b1c825061655$export$51fa1147c138a6ed);
$parcel$export(module.exports, "SERVICE_DESK_QUEUES", () => $6fb2b1c825061655$export$456b3cfbf5e37bd8);
$parcel$export(module.exports, "SERVICE_DESK_KNOWLEDGE_HUB", () => $6fb2b1c825061655$export$9ccc8d85b210b219);
$parcel$export(module.exports, "SERVICE_DESK_REPORTS", () => $6fb2b1c825061655$export$707771f2f7e60575);
$parcel$export(module.exports, "SERVICE_DESK_SETTINGS", () => $6fb2b1c825061655$export$a87fc635598d2d50);
$parcel$export(module.exports, "SERVICE_DESK_LEGACY_TICKET_TYPES", () => $6fb2b1c825061655$export$b6bda26b77269209);
$parcel$export(module.exports, "SERVICE_DESK_LANGUAGES", () => $6fb2b1c825061655$export$776199f9e99c88e2);
$parcel$export(module.exports, "SERVICE_DESK_TRANSLATIONS", () => $6fb2b1c825061655$export$d70ba5c124463035);
$parcel$export(module.exports, "SERVICE_DESK_AUTOMATION_SUB_NAV", () => $6fb2b1c825061655$export$9a6deaa9c1af559f);
const $6fb2b1c825061655$var$HOME_QUEUES = 'queues';
const $6fb2b1c825061655$var$HOME_ALL_ITSM_QUEUES_SPOTLIGHT = 'all-itsm-queues-spotlight';
const $6fb2b1c825061655$var$HOME_ALL_TICKETS_SPOTLIGHT = 'all-tickets-spotlight';
const $6fb2b1c825061655$var$HOME_TICKET_CATEGORIES_SPOTLIGHT = 'ticket-categories-spotlight';
const $6fb2b1c825061655$var$HOME_SERVICE_REQUESTS = 'service-requests';
const $6fb2b1c825061655$var$HOME_INCIDENTS = 'incidents';
const $6fb2b1c825061655$var$HOME_CHANGES = 'changes';
const $6fb2b1c825061655$var$HOME_PROBLEMS = 'problems';
const $6fb2b1c825061655$var$HOME_POST_INCIDENT_REVIEWS = 'post-incident-reviews';
const $6fb2b1c825061655$var$HOME_CUSTOMERS = 'customers';
const $6fb2b1c825061655$var$HOME_REPORTS = 'reports';
const $6fb2b1c825061655$var$HOME_RAISE_REQUEST = 'raise-request';
const $6fb2b1c825061655$var$HOME_ISSUES = 'issues';
const $6fb2b1c825061655$var$HOME_CUSTOMER_CHANNELS = 'customer-channels';
const $6fb2b1c825061655$var$HOME_CUSTOMER_CHANNELS_SPOTLIGHT = 'customer-channels-spotlight';
const $6fb2b1c825061655$var$HOME_JSD_CHANNELS_DIALOG = 'jsd-channels-dialog';
const $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE = 'knowledge-base';
const $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE_HUB = 'knowledge-hub';
const $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE_HUB_NESTED = 'knowledge-hub-nested';
const $6fb2b1c825061655$var$HOME_INVITE_TEAM = 'invite-team';
const $6fb2b1c825061655$var$HOME_GIVE_FEEDBACK = 'give-feedback';
const $6fb2b1c825061655$var$HOME_SERVICES = 'services';
const $6fb2b1c825061655$var$HOME_SERVICES_SPOTLIGHT = 'services-spotlight';
const $6fb2b1c825061655$var$HOME_ALERTS_AND_ON_CALL_SPOTLIGHT = 'alerts-and-on-call-spotlight';
const $6fb2b1c825061655$var$HOME_CHANGE_CALENDAR_SPOTLIGHT = 'change-calendar-spotlight';
const $6fb2b1c825061655$export$1f70a76cb421b107 = {
    REPORTS_CUSTOM: 'sd-reports-custom',
    REPORTS_ADDONS: 'sd-reports-addons',
    REPORTS_NAV_CUSTOM_ACTIONS: 'sd-reports-nav-custom-actions',
    REPORTS_NAV_TEAM: 'sd-reports-nav-team',
    REPORTS_NAV_KB: 'sd-reports-nav-kb'
};
const $6fb2b1c825061655$export$9afbea2cbd37e16d = {
    QUEUES: $6fb2b1c825061655$var$HOME_QUEUES,
    ALL_ITSM_QUEUES_SPOTLIGHT: $6fb2b1c825061655$var$HOME_ALL_ITSM_QUEUES_SPOTLIGHT,
    ALL_TICKETS_SPOTLIGHT: $6fb2b1c825061655$var$HOME_ALL_TICKETS_SPOTLIGHT,
    TICKET_CATEGORIES_SPOTLIGHT: $6fb2b1c825061655$var$HOME_TICKET_CATEGORIES_SPOTLIGHT,
    SERVICE_REQUEST: $6fb2b1c825061655$var$HOME_SERVICE_REQUESTS,
    INCIDENTS: $6fb2b1c825061655$var$HOME_INCIDENTS,
    CHANGES: $6fb2b1c825061655$var$HOME_CHANGES,
    PROBLEMS: $6fb2b1c825061655$var$HOME_PROBLEMS,
    CUSTOMERS: $6fb2b1c825061655$var$HOME_CUSTOMERS,
    POST_INCIDENT_REVIEWS: $6fb2b1c825061655$var$HOME_POST_INCIDENT_REVIEWS,
    REPORTS: $6fb2b1c825061655$var$HOME_REPORTS,
    RAISE_REQUEST: $6fb2b1c825061655$var$HOME_RAISE_REQUEST,
    ISSUES: $6fb2b1c825061655$var$HOME_ISSUES,
    CUSTOMER_CHANNELS: $6fb2b1c825061655$var$HOME_CUSTOMER_CHANNELS,
    CUSTOMER_CHANNELS_SPOTLIGHT: $6fb2b1c825061655$var$HOME_CUSTOMER_CHANNELS_SPOTLIGHT,
    JSD_CHANNELS_DIALOG: $6fb2b1c825061655$var$HOME_JSD_CHANNELS_DIALOG,
    KNOWLEDGE_BASE: $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE,
    KNOWLEDGE_BASE_HUB: $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE_HUB,
    KNOWLEDGE_BASE_HUB_NESTED: $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE_HUB_NESTED,
    INVITE_TEAM: $6fb2b1c825061655$var$HOME_INVITE_TEAM,
    GIVE_FEEDBACK: $6fb2b1c825061655$var$HOME_GIVE_FEEDBACK,
    SERVICES: $6fb2b1c825061655$var$HOME_SERVICES,
    SERVICES_SPOTLIGHT: $6fb2b1c825061655$var$HOME_SERVICES_SPOTLIGHT,
    ALERTS_AND_ON_CALL_SPOTLIGHT: $6fb2b1c825061655$var$HOME_ALERTS_AND_ON_CALL_SPOTLIGHT,
    CHANGE_CALENDAR_SPOTLIGHT: $6fb2b1c825061655$var$HOME_CHANGE_CALENDAR_SPOTLIGHT
};
const $6fb2b1c825061655$var$KNOWLEDGE_BASE_IDS = {
    TOP_ACTIONS: 'knowledge-hub-top-actions',
    ALL_ARTICLES: 'knowledge-hub-all-articles',
    CATEGORIES: 'knowledge-hub-categories',
    CATEGORIES_CONTEXT: 'knowledge-hub-categories-context',
    BOTTOM_ACTIONS: 'knowledge-hub-bottom-actions',
    ADD_CATEGORY: 'knowledge-hub-new-category',
    LEAVE_FEEDBACK: 'knowledge-hub-leave-feedback'
};
const $6fb2b1c825061655$var$SETTINGS_IDS = {
    DETAILS: 'details',
    PEOPLE: 'people',
    ITSM_FEATURES: 'itsm-features',
    SUMMARY: 'summary',
    DELETE_PROJECT: 'delete-project',
    ISSUE_TYPES: 'issue-types',
    FEATURES: 'features',
    REQUEST_TYPES: 'sd-request-types',
    TICKET_TYPES: 'sd-ticket-types',
    CUSTOMER_PERMISSIONS: 'sd-customer-permissions',
    LANGUAGE_SUPPORT: 'sd-language-support',
    PORTAL_SETTINGS: 'sd-portal-settings',
    EMAIL_REQUESTS: 'sd-email-requests',
    CUSTOMER_NOTIFICATIONS: 'sd-customer-notifications',
    PROJECT_WIDGET_ADDON: 'sd-project-widget-addon',
    PROJECT_WIDGET_ADDON_INSTALLER: 'sd-project-widget-addon-installer',
    PROJECT_ASSETS_AD: 'sd-project-assets-ad',
    SATISFACTION_SETTINGS: 'sd-satisfaction-settings',
    KNOWLEDGE_BASE: 'sd-knowledge-base',
    SLAS: 'sd-slas',
    AUTOMATION: 'sd-automation',
    PLAYBOOKS: 'playbooks',
    JIRA_AUTOMATION: 'jira-automation',
    AUTOMATION_SUB_NAV: 'sd-automation-sub-nav',
    JSD_APP_DISCOVERY: 'sd-app-discovery',
    JSD_INCIDENT_MANAGEMENT: 'sd-incident-management',
    JSD_CHANGE_MANAGEMENT: 'sd-change-management',
    WORKFLOWS: 'workflows',
    SCREENS: 'screens',
    FIELDS: 'fields',
    VERSIONS: 'versions',
    COMPONENTS: 'components',
    PERMISSIONS: 'permissions',
    ISSUE_SECURITY: 'issue-security',
    NOTIFICATIONS: 'notifications',
    HIPCHAT: 'hipchat',
    ISSUE_COLLECTORS: 'issue-collectors'
};
const $6fb2b1c825061655$var$QUEUES_IDS = {
    QUEUE_NEW: 'queue-new',
    QUEUE_MANAGE: 'queue-manage',
    QUEUES_ADDONS: 'sd-queues-addons',
    QUEUES_CUSTOM_ACTIONS: 'sd-queues-custom-actions',
    SD_QUEUES_CUSTOM: 'sd-queues-custom'
};
const $6fb2b1c825061655$export$a37f4f7add086a3 = {
    ADDITIONAL_ITEMS: 'sd-practices-additional-items',
    CHANGES_QUEUE_TITLE_SPOTLIGHT: 'sd-practices-changes-queue-title-spotlight',
    CHANGES_QUEUE_ITEMS_SPOTLIGHT: 'sd-practices-changes-queue-items-spotlight',
    INCIDENTS_QUEUE_TITLE_SPOTLIGHT: 'sd-practices-incidents-queue-title-spotlight',
    INCIDENTS_QUEUE_ITEMS_SPOTLIGHT: 'sd-practices-incidents-queue-items-spotlight'
};
const $6fb2b1c825061655$export$2108a7f32cd0bb12 = {
    SERVICE_DESK: {
        HOME: $6fb2b1c825061655$export$9afbea2cbd37e16d,
        KNOWLEDGE_BASE: $6fb2b1c825061655$var$KNOWLEDGE_BASE_IDS,
        SETTINGS: $6fb2b1c825061655$var$SETTINGS_IDS,
        QUEUES: $6fb2b1c825061655$var$QUEUES_IDS,
        REPORTS: $6fb2b1c825061655$export$1f70a76cb421b107
    }
};
const $6fb2b1c825061655$export$712b4b205a2bcf1e = {
    PRACTICE_NAV_SPOTLIGHT: 'request-type-practice-nav-spotlight',
    UNASSIGNED_NAV_SPOTLIGHT: 'request-type-unassgined-nav-spotlight'
};
const $6fb2b1c825061655$export$e2d46b728fe0a15a = 'jsm-team-starred-onboarding';
const $6fb2b1c825061655$export$c8c1c8c3f8ddba61 = 'project/service-desk/index';
const $6fb2b1c825061655$export$51fa1147c138a6ed = 'project/service-desk/issues';
const $6fb2b1c825061655$export$456b3cfbf5e37bd8 = 'project/service-desk/queues';
const $6fb2b1c825061655$export$9ccc8d85b210b219 = 'project/service-desk/knowledge-hub';
const $6fb2b1c825061655$export$707771f2f7e60575 = 'project/service-desk/reports';
const $6fb2b1c825061655$export$a87fc635598d2d50 = 'project/service-desk/settings';
const $6fb2b1c825061655$export$b6bda26b77269209 = 'project/service-desk/legacy-ticket-types';
const $6fb2b1c825061655$export$776199f9e99c88e2 = 'project/service-desk/languages';
const $6fb2b1c825061655$export$d70ba5c124463035 = 'project/service-desk/translations';
const $6fb2b1c825061655$export$9a6deaa9c1af559f = 'project/service-desk/settings/automation-sub-nav';

});




parcelRegister("jElqQ", function(module, exports) {

$parcel$export(module.exports, "PageDwellAnalyticsListener", () => $e847f78ebf17acd8$export$6cf89f098b551dad);

var $5uXOq = parcelRequire("5uXOq");

var $gPQRI = parcelRequire("gPQRI");

var $6jY6G = parcelRequire("6jY6G");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dAfqg = parcelRequire("dAfqg");

var $6yXtV = parcelRequire("6yXtV");

var $hMvRp = parcelRequire("hMvRp");
const $e847f78ebf17acd8$var$WAIT_DURATION = 5000;
/**
 * Dispatches AnalyticsEvent for when a user stays on a page for a set period of time
 */ const $e847f78ebf17acd8$export$6cf89f098b551dad = ()=>{
    const [hasFired, setHasFired] = (0, $5uXOq.useState)(false);
    const route = (0, $6jY6G.useCurrentRoute)();
    const routeName = route.name;
    const [{ isReady: isReady }] = (0, $6yXtV.useSpaStatePageReady)();
    const isVisible = (0, $hMvRp.usePageVisibility)();
    const interval = (0, $5uXOq.useRef)(null);
    const { data: projectData } = (0, $dAfqg.useProjectContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { isCollapsed: isLeftSidebarCollapsed } = (0, $gPQRI.useLeftSidebarState)();
    (0, $5uXOq.useEffect)(()=>{
        setHasFired(false);
    }, [
        routeName
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isReady) {
            interval.current = null;
            return;
        }
        // If the page is visible, set the analytics event to run after the specified duration
        if (isVisible && !hasFired) interval.current = setTimeout(()=>{
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'page dwelled', routeName, {
                containerId: projectData?.projectId,
                containerType: projectData?.projectType,
                isLeftSidebarCollapsed: isLeftSidebarCollapsed
            });
            setHasFired(true);
        }, $e847f78ebf17acd8$var$WAIT_DURATION);
        return ()=>{
            // @ts-expect-error - TS2769 - No overload matches this call.
            interval.current = clearTimeout(interval.current);
        };
    }, [
        createAnalyticsEvent,
        hasFired,
        isReady,
        isVisible,
        routeName,
        projectData?.projectId,
        projectData?.projectType,
        isLeftSidebarCollapsed
    ]);
    return null;
};

});
parcelRegister("hMvRp", function(module, exports) {

$parcel$export(module.exports, "usePageVisibility", () => $124c6a08c4f63b4e$export$6c98eb2f12f4ec61);

var $5uXOq = parcelRequire("5uXOq");

var $laTox = parcelRequire("laTox");
const $124c6a08c4f63b4e$export$6c98eb2f12f4ec61 = ()=>{
    const [isVisible, setIsVisible] = (0, $5uXOq.useState)((0, $laTox.isPageVisible)());
    (0, $5uXOq.useEffect)(()=>{
        const onVisibilityChange = ()=>setIsVisible((0, $laTox.isPageVisible)());
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('visibilitychange', onVisibilityChange);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('visibilitychange', onVisibilityChange);
        };
    }, []);
    return isVisible;
};

});
parcelRegister("laTox", function(module, exports) {

$parcel$export(module.exports, "supportedVisiblityEvent", () => $845c75a1dcb2afb9$export$f7132cb36c80dad);
$parcel$export(module.exports, "isPageVisible", () => $845c75a1dcb2afb9$export$ae4f9b990bc70f70);
const $845c75a1dcb2afb9$var$visibilityMap = {
    // document property: event name
    hidden: 'visibilitychange',
    mozHidden: 'mozvisibilitychange',
    msHidden: 'msvisibilitychange',
    webkitHidden: 'webkitvisibilitychange'
};
const $845c75a1dcb2afb9$var$supportedHiddenKey = Object.keys($845c75a1dcb2afb9$var$visibilityMap).find(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Document'.
(key)=>typeof document !== 'undefined' && typeof document[key] !== 'undefined');
const $845c75a1dcb2afb9$export$f7132cb36c80dad = $845c75a1dcb2afb9$var$visibilityMap[$845c75a1dcb2afb9$var$supportedHiddenKey];
const $845c75a1dcb2afb9$export$ae4f9b990bc70f70 = ()=>typeof document !== 'undefined' && !document[$845c75a1dcb2afb9$var$supportedHiddenKey];

});



parcelRegister("kKa8l", function(module, exports) {

$parcel$export(module.exports, "MatchedRouteListener", () => $6e59b41cd017c405$export$c6d9204abc182c3b);

var $5uXOq = parcelRequire("5uXOq");

var $cfDZ3 = parcelRequire("cfDZ3");

var $doZTA = parcelRequire("doZTA");
const $6e59b41cd017c405$export$c6d9204abc182c3b = ()=>{
    const [{ route: route, match: match }] = (0, $doZTA.useRouter)();
    (0, $5uXOq.useMemo)(()=>(0, $cfDZ3.setMatchedRoute)(route, match), [
        route,
        match
    ]);
    return null;
};

});

parcelRegister("bmetd", function(module, exports) {

$parcel$export(module.exports, "PreviousRouterStateListener", () => $0b73f894404a9cc2$export$49e28489f2124002);

var $5uXOq = parcelRequire("5uXOq");

var $1XJ20 = parcelRequire("1XJ20");

var $cfDZ3 = parcelRequire("cfDZ3");

var $jDDFr = parcelRequire("jDDFr");
const $0b73f894404a9cc2$export$3fd5ddd6b8e9a200 = ({ routerState: routerState })=>{
    const previousRouterState = (0, $1XJ20.usePrevious)(routerState);
    (0, $5uXOq.useEffect)(()=>{
        (0, $cfDZ3.setPreviousRouterState)(previousRouterState ?? null);
    }, [
        previousRouterState
    ]);
    return null;
};
const $0b73f894404a9cc2$export$49e28489f2124002 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDDFr.RouterSubscriber), null, (routerState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0b73f894404a9cc2$export$3fd5ddd6b8e9a200, {
            routerState: routerState
        })));
$0b73f894404a9cc2$export$49e28489f2124002.displayName = 'PreviousRouterStateListener';

});

parcelRegister("izgL1", function(module, exports) {

$parcel$export(module.exports, "default", () => $33c092f8fb0732f9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $01Rn4 = parcelRequire("01Rn4");

var $7nE2n = parcelRequire("7nE2n");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $5y0F0 = parcelRequire("5y0F0");
var $jDDFr = parcelRequire("jDDFr");

var $gKKyW = parcelRequire("gKKyW");
/**
 * Defines the component for the `querystring-notifier` module.
 */ const $33c092f8fb0732f9$var$QueryStringNotifier = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
        sourceName: "querystringNotifications"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7nE2n.default), null, (flagService)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDDFr.RouterSubscriber), null, ({ location: { search: search } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5y0F0.RouterActions), null, ({ replace: replace })=>{
                const { showFlag: showFlag, ...query } = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(search);
                if (!showFlag) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $gKKyW.default)[showFlag] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
                    eventName: "querystringNotification shown",
                    componentName: "flag",
                    attributes: {
                        showFlag: showFlag
                    }
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
                    eventName: "querystringNotification notFound",
                    componentName: "flag",
                    attributes: {
                        showFlag: showFlag
                    }
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
                    op: ()=>{
                        if ((0, $gKKyW.default)[showFlag]) flagService.showFlag((0, $gKKyW.default)[showFlag]);
                        replace(`?${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(query)}`);
                    }
                }));
            }))));
var $33c092f8fb0732f9$export$2e2bcd8739ae039 = $33c092f8fb0732f9$var$QueryStringNotifier;

});
parcelRegister("01Rn4", function(module, exports) {

$parcel$export(module.exports, "default", () => $32b7c410527eddaf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
// eslint-disable-next-line jira/react/no-class-components
class $32b7c410527eddaf$var$OpTrigger extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            args: []
        };
    }
    componentDidMount() {
        this.props.op(...this.props.args);
    }
    render() {
        return null;
    }
}
var $32b7c410527eddaf$export$2e2bcd8739ae039 = $32b7c410527eddaf$var$OpTrigger;

});

parcelRegister("7nE2n", function(module, exports) {

$parcel$export(module.exports, "default", () => $4855eee5a10070a5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");
const $4855eee5a10070a5$var$FlagServiceSubscriber = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children((0, $pa9q9.flagService)));
var $4855eee5a10070a5$export$2e2bcd8739ae039 = $4855eee5a10070a5$var$FlagServiceSubscriber;

});

parcelRegister("gKKyW", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fdf0672c10209bc$export$2e2bcd8739ae039);

var $7HGHK = parcelRequire("7HGHK");

var $lVqGY = parcelRequire("lVqGY");
const $2fdf0672c10209bc$var$notificationMessages = {
    'jsw.board-not-found': {
        id: (0, $7HGHK.toFlagId)('jsw.board-not-found'),
        type: 'error',
        title: (0, $lVqGY.default).boardNotFound,
        description: (0, $lVqGY.default).boardNotFoundDescription,
        messageId: 'query-string-notifier.common.flag.error.error.jsw.board-not-found',
        messageType: 'transactional'
    },
    'jsw.project-not-found': {
        id: (0, $7HGHK.toFlagId)('jsw.project-not-found'),
        type: 'error',
        title: (0, $lVqGY.default).projectNotFound,
        description: (0, $lVqGY.default).projectNotFoundDescription,
        messageId: 'query-string-notifier.common.flag.error.error.jsw.project-not-found',
        messageType: 'transactional'
    }
};
var $2fdf0672c10209bc$export$2e2bcd8739ae039 = $2fdf0672c10209bc$var$notificationMessages;

});
parcelRegister("lVqGY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a629f5c887c4955a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
// Don't confuse Intl messages with `Flag`s
const $a629f5c887c4955a$var$messages = (0, $7VHMR.defineMessages)({
    boardNotFound: {
        "id": "query-string-notifier.common.board-not-found",
        "defaultMessage": "Board not found"
    },
    boardNotFoundDescription: {
        "id": "query-string-notifier.common.board-not-found-description",
        "defaultMessage": "You tried to access a board that doesn't exist or that you don't have permission to see."
    },
    projectNotFound: {
        "id": "query-string-notifier.common.project-not-found",
        "defaultMessage": "Project not found"
    },
    projectNotFoundDescription: {
        "id": "query-string-notifier.common.project-not-found-description",
        "defaultMessage": "You tried to access a project that doesn't exist or that you don't have permission to see."
    }
});
var $a629f5c887c4955a$export$2e2bcd8739ae039 = $a629f5c887c4955a$var$messages;

});



parcelRegister("lyCmi", function(module, exports) {

$parcel$export(module.exports, "AsyncRecommendPremiumToStandardModalWrapper", () => $881dabfa53ffbc01$export$2a43717c77dd3a56);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $7iJwP = parcelRequire("7iJwP");

var $kxZPA = parcelRequire("kxZPA");

var $gnleF = parcelRequire("gnleF");

const $881dabfa53ffbc01$var$AsyncRecommendPremiumToStandardModalComponent = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("iNVDw")).then(({ RecommendPremiumToStandardModalComponent: RecommendPremiumToStandardModalComponent })=>RecommendPremiumToStandardModalComponent), {
    moduleId: "./src/packages/growth/recommend-premium-to-standard-modal/src/index.tsx"
});
const $881dabfa53ffbc01$export$2a43717c77dd3a56 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "recommend-premium-to-standard-modal-async",
        packageName: (0, $gnleF.PACKAGE_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        teamName: (0, $gnleF.TEAM_NAME),
        id: "recommend-premium-to-standard-modal-async",
        packageName: (0, $gnleF.PACKAGE_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($881dabfa53ffbc01$var$AsyncRecommendPremiumToStandardModalComponent, null)));
};

});
parcelRegister("gnleF", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $3413b320036771c2$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $3413b320036771c2$export$d57b6b390e78d90f);
$parcel$export(module.exports, "ANALYTICS_SOURCE_NAME", () => $3413b320036771c2$export$48e1d3fa57b0a2d5);
$parcel$export(module.exports, "STARGATE_URL", () => $3413b320036771c2$export$c7e6a6b283196232);
$parcel$export(module.exports, "RECC_STANDARD_MESSAGE_ID", () => $3413b320036771c2$export$de9f5b160db96e26);
const $3413b320036771c2$export$b8b9d90f9e5bd72b = '@atlassian/jira-recommend-premium-to-standard-modal';
const $3413b320036771c2$export$d57b6b390e78d90f = 'growth-tako';
const $3413b320036771c2$export$48e1d3fa57b0a2d5 = 'recommendPremiumToStandard';
const $3413b320036771c2$export$c7e6a6b283196232 = '/gateway/api';
const $3413b320036771c2$export$de9f5b160db96e26 = new Map([
    [
        5,
        'prj-grace-period-recc-standard-msg-1'
    ],
    [
        3,
        'prj-grace-period-recc-standard-msg-2'
    ],
    [
        1,
        'prj-grace-period-recc-standard-msg-3'
    ]
]);

});

parcelRegister("iNVDw", function(module, exports) {

let $db0982faf56606df$var$load = (parcelRequire("28QjX"))(4);
module.exports = $db0982faf56606df$var$load("j1khH").then(()=>parcelRequire('hxssF'));

});


parcelRegister("kgLzl", function(module, exports) {

$parcel$export(module.exports, "rovoVideoModalEntryPoint", () => $1c7272db9b45cdb2$export$2f67fedc6d5555a5);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $1c7272db9b45cdb2$export$2f67fedc6d5555a5 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(async ()=>(parcelRequire("fzLFk")).then(({ RovoVideoModal: RovoVideoModal })=>RovoVideoModal), {
        moduleId: "3a307b00",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("fzLFk", function(module, exports) {

let $b56f19465eb77bda$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b56f19465eb77bda$var$load("OHoOf").then(()=>parcelRequire('14875'));

});


parcelRegister("dYRe6", function(module, exports) {

$parcel$export(module.exports, "default", () => $05aa88b82a329166$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $aZsz6 = parcelRequire("aZsz6");

var $5oFIy = parcelRequire("5oFIy");

var $dxCvy = parcelRequire("dxCvy");

var $7tQej = parcelRequire("7tQej");
var $2YP9W = parcelRequire("2YP9W");
var $doZTA = parcelRequire("doZTA");
/**
 * Ensures users are redirected to the correct project URL when there's a mismatch in the project key.
 * It preserves query parameters during redirection and logs the event for analytics.
 */ const $05aa88b82a329166$var$ProjectKeyRedirect = ({ FireOperationalAnalytics: FireOperationalAnalytics = (0, $5oFIy.FireOperationalAnalytics), Redirect: Redirect = (0, $7tQej.Redirect), useResource: // eslint-disable-next-line react-hooks/react-compiler
useResource = (0, $2YP9W.useResource), useRouter: // eslint-disable-next-line react-hooks/react-compiler
useRouter = (0, $doZTA.useRouter) })=>{
    const [{ location: location, match: { params: params, url: url }, query: query }] = useRouter();
    const projectKey = params.projectKey ?? query.projectKey;
    // eslint-disable-next-line react-hooks/react-compiler
    const { data: projectContext } = useResource((0, $dxCvy.projectContextResource));
    if (!projectKey || !projectContext?.projectKey) return null;
    if (projectKey === projectContext.projectKey) return null;
    const search = {
        ...query,
        ...query.projectKey ? {
            projectKey: projectContext.projectKey
        } : {}
    };
    // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
    const queryString = (0, $aZsz6.qs).stringify(search, Object.entries(search).length > 0);
    // Just a slight risk mitigation - only do the string replace if the match param is there
    const path = params.projectKey != null ? url.replace(projectKey, projectContext.projectKey) : url;
    const to = `${path}${queryString}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FireOperationalAnalytics, {
        eventName: "ProjectKeyRedirect loaded",
        componentName: "ProjectKeyRedirect",
        attributes: {
            location: location,
            projectContext: projectContext
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Redirect, {
        to: to
    }));
};
var $05aa88b82a329166$export$2e2bcd8739ae039 = $05aa88b82a329166$var$ProjectKeyRedirect;

});

parcelRegister("9yehD", function(module, exports) {

$parcel$export(module.exports, "AsyncTrialSprintBoardModalEntryPoint", () => $03eb281d6ff9bb59$export$ba04f28d78ea7267);

var $5uXOq = parcelRequire("5uXOq");

var $ioD1B = parcelRequire("ioD1B");

var $eGLgs = parcelRequire("eGLgs");

var $ivDCs = parcelRequire("ivDCs");

var $4mO32 = parcelRequire("4mO32");

var $b71gk = parcelRequire("b71gk");

var $7iJwP = parcelRequire("7iJwP");

var $koeKL = parcelRequire("koeKL");

var $14XJw = parcelRequire("14XJw");

var $lpwtK = parcelRequire("lpwtK");

var $2vSU6 = parcelRequire("2vSU6");

var $5oBMG = parcelRequire("5oBMG");

var $k9JTq = parcelRequire("k9JTq");

var $ldyPw = parcelRequire("ldyPw");

var $jPg2q = parcelRequire("jPg2q");


var $60gvu = parcelRequire("60gvu");

var $9mxBe = parcelRequire("9mxBe");

var $j9wkq = parcelRequire("j9wkq");

var $24MMC = parcelRequire("24MMC");
const $03eb281d6ff9bb59$export$5f395c9784fafd48 = ({ ctaLink: ctaLink })=>{
    /**
	 * Makes the final checks before calling EP
	 * - Site must be in their 10/11th, 12/13th or 14th+ day in trial
	 */ const cloudId = (0, $koeKL.useCloudId)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const { data: project } = (0, $lpwtK.useProject)();
    const projectType = (0, $2vSU6.toProjectType)(project?.type);
    const productEntitlementDetails = (0, $5oBMG.useProductEntitlementDetails)();
    const productKey = projectType && (0, $2vSU6.projectTypeToCanonicalId)(projectType);
    const entitlementDetails = productKey && productEntitlementDetails?.[productKey];
    const daysLeft = (0, $5uXOq.useMemo)(()=>(0, $jPg2q.getTrialDaysLeftFromTrialEndTime)(entitlementDetails?.trialEndTime) ?? 0, [
        entitlementDetails?.trialEndTime
    ]);
    // Show the modal three times 10/11, 12/13 and 14+ days after site creation
    const eligibleForFirstModal = daysLeft === 20 || daysLeft === 19;
    const eligibleForSecondModal = daysLeft === 18 || daysLeft === 17;
    const eligibleForThirdModal = daysLeft <= 16;
    const eligibleDaysLeft = eligibleForFirstModal || eligibleForSecondModal || eligibleForThirdModal;
    const messageId = (0, $24MMC.getMessageId)(daysLeft);
    const coordinationClient = (0, $5uXOq.useMemo)(()=>new (0, $eGLgs.CoordinationClient)(cloudId, (0, $90b4560f34ff7aba$export$c7e6a6b283196232), false, orgId, 'engagement'), [
        cloudId,
        orgId
    ]);
    const onClose = (0, $5uXOq.useCallback)(()=>{
        if (messageId) coordinationClient.stop(messageId);
    }, [
        coordinationClient,
        messageId
    ]);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            ctaLink: ctaLink,
            onClose: onClose,
            messageId: messageId ?? '',
            coordinationClient: coordinationClient
        }), [
        coordinationClient,
        ctaLink,
        messageId,
        onClose
    ]);
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({}), []);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $j9wkq.trialSprintBoardModalEntryPoint), entryPointParams);
    const isEligible = eligibleDaysLeft && messageId;
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (isEligible) {
            const conditionallyLoadEntryPoint = async ()=>{
                const started = await coordinationClient.start(messageId);
                if (started) entryPointActions.load();
            };
            conditionallyLoadEntryPoint();
        }
    }, [
        coordinationClient,
        entryPointActions,
        daysLeft,
        messageId,
        isEligible
    ]);
    return isEligible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ioD1B.ChoreographerContextProvider), {
        isChoreographed: coordinationClient.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivDCs.ModalEntryPointContainer), {
        id: (0, $90b4560f34ff7aba$export$48e1d3fa57b0a2d5),
        packageName: (0, $90b4560f34ff7aba$export$b8b9d90f9e5bd72b),
        teamName: (0, $90b4560f34ff7aba$export$d57b6b390e78d90f),
        errorFallback: "unmount",
        runtimeProps: runtimeProps,
        entryPointActions: entryPointActions,
        entryPointReferenceSubject: entryPointReferenceSubject
    }));
};
const $03eb281d6ff9bb59$export$34d6cccb83207ca5 = ({ currentProjectId: currentProjectId })=>{
    /**
	 * Makes the follow up dynamic eligibility checks for the Trial Sprint Board modal
	 * - Current project is NOT the trial sprint board (via comparison of projectId against TSB projectId stored in traits)
	 * - CTA Link has been generated correctly (via GraphQL query - only works for JSW TMP projects)
	 * - Modal must not have been dismissed forever by user (value stored in local storage)
	 */ const isNotTrialSprintBoardProject = (0, $60gvu.useIsNotTrialSprintBoardProject)(currentProjectId);
    const ctaLink = (0, $60gvu.useTrialSprintBoardCtaLink)();
    const hasModalBeenDismissed = (0, $9mxBe.getIsTrialSprintBoardModalDismissed)() === true;
    const isEligible = isNotTrialSprintBoardProject && Boolean(ctaLink) && !hasModalBeenDismissed;
    return isEligible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($03eb281d6ff9bb59$export$5f395c9784fafd48, {
        ctaLink: ctaLink
    });
};
const $03eb281d6ff9bb59$export$738784b961d0b111 = (props)=>{
    /**
	 * Makes the initial static eligibility checks for the Trial Sprint Board modal
	 * - Must currently be on a JSW Project
	 * - Must be on Premium Edition of JSW
	 */ const appEditions = (0, $k9JTq.useAppEditions)();
    const { data: project } = (0, $lpwtK.useProject)();
    const projectType = (0, $2vSU6.toProjectType)(project?.type);
    const isJswProject = projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    const isOnPremiumJsw = appEditions.software === (0, $ldyPw.PREMIUM_EDITION);
    const isEligible = isJswProject && isOnPremiumJsw;
    return isEligible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($03eb281d6ff9bb59$export$34d6cccb83207ca5, props);
};
const $03eb281d6ff9bb59$export$ba04f28d78ea7267 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: `async-${(0, $90b4560f34ff7aba$export$48e1d3fa57b0a2d5)}`,
        packageName: (0, $90b4560f34ff7aba$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        teamName: (0, $90b4560f34ff7aba$export$d57b6b390e78d90f),
        id: `async-${(0, $90b4560f34ff7aba$export$48e1d3fa57b0a2d5)}`,
        packageName: (0, $90b4560f34ff7aba$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($03eb281d6ff9bb59$export$738784b961d0b111, props)));
};

});
parcelRegister("eGLgs", function(module, exports) {

$parcel$export(module.exports, "CoordinationClient", () => $754c27d37ccd1133$export$580a2294c917898c);
$parcel$export(module.exports, "default", () => $754c27d37ccd1133$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iZhen = parcelRequire("iZhen");

var $jcYbC = parcelRequire("jcYbC");
var $8Mq6c = parcelRequire("8Mq6c");

var $TTRxY = parcelRequire("TTRxY");

var $ioD1B = parcelRequire("ioD1B");

var $10xFf = parcelRequire("10xFf");

var $4Pf62 = parcelRequire("4Pf62");

var $4R6GH = parcelRequire("4R6GH");

var $j8DrX = parcelRequire("j8DrX");

var $14XJw = parcelRequire("14XJw");

var $7qPn9 = parcelRequire("7qPn9");
const $754c27d37ccd1133$var$isSyntheticTenant = ()=>(0, $j8DrX.default)('ajs-is-synthetic') === 'true';
class $754c27d37ccd1133$export$580a2294c917898c extends (0, $8Mq6c.default) {
    constructor(cloudId, stargateUrl, shouldAllowOnSynthetic = false, orgId = '', messageType = 'transactional', onMessageDisposition, isAlreadyChoreographedAtAncestor = false){
        const environment = (0, $7qPn9.toEnvironment)((0, $j8DrX.default)('ajs-environment'));
        const getEnvironmentType = (env)=>{
            if (env === 'prod') return (0, $iZhen.envType).PROD;
            if (env === 'staging') return (0, $iZhen.envType).STAGING;
            return (0, $iZhen.envType).DEV;
        };
        // If a ancestor (e.g. CoordinationClient wraps CoordinationClient) is already choreographed,
        // we should not re-choreograph this CoordinationClient
        const enableChoreographer = (0, $10xFf.shouldBeChoreographed)({
            messageType: messageType
        }) && !isAlreadyChoreographedAtAncestor;
        const coordinationOptions = {
            enableChoreographer: enableChoreographer,
            envType: getEnvironmentType(environment),
            additionalData: {
                sourceProductId: (0, $TTRxY.ProductIds).JIRA
            }
        };
        super({
            cloudId: cloudId,
            stargateUrl: stargateUrl,
            orgId: orgId,
            isFedRAMPEnvironment: false,
            coordinationOptions: coordinationOptions
        });
        this.shouldUseMockClient = $754c27d37ccd1133$var$isSyntheticTenant() && !shouldAllowOnSynthetic;
        this.enableChoreographer = enableChoreographer;
        this.onMessageDisposition = onMessageDisposition;
        // // This is a permanant flag: go/jira-ep-debugging
        this.isDebugModeEnabled = (0, $4R6GH.fg)('ep-external-message-debug-mode');
    }
    async start(messageId) {
        if (this.isDebugModeEnabled) {
            const serverResponse = await super.start(messageId);
            if (this.enableChoreographer) this.onMessageDisposition?.(serverResponse ? (0, $TTRxY.MessageDeliveryStatus).STARTED : (0, $TTRxY.MessageDeliveryStatus).BLOCKED);
            // eslint-disable-next-line no-alert, no-restricted-globals
            const shouldShowMessage = confirm(`\u{1F41E} \u{1D5D8}\u{1D5E3} \u{1D5D8}\u{1D605}\u{1D601}\u{1D5F2}\u{1D5FF}\u{1D5FB}\u{1D5EE}\u{1D5F9} \u{1D5E0}\u{1D5F2}\u{1D600}\u{1D600}\u{1D5EE}\u{1D5F4}\u{1D5F2} \u{1D5D7}\u{1D5F2}\u{1D5EF}\u{1D602}\u{1D5F4}\u{1D5F4}\u{1D5F2}\u{1D5FF}

Message ID: ${messageId}
Start call server response: ${serverResponse}

Do you want to display the message?`);
            if (!shouldShowMessage) {
                const didStop = await super.stop(messageId);
                if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, $TTRxY.MessageDeliveryStatus).STOPPED : (0, $TTRxY.MessageDeliveryStatus).BLOCKED);
            }
            return shouldShowMessage;
        }
        return this.shouldUseMockClient ? false // never allow messages to start
         : super.start(messageId).then((didStart)=>{
            if (this.enableChoreographer) this.onMessageDisposition?.(didStart ? (0, $TTRxY.MessageDeliveryStatus).STARTED : (0, $TTRxY.MessageDeliveryStatus).BLOCKED);
            return didStart;
        });
    }
    async stop(messageId) {
        return this.shouldUseMockClient ? true // always allow messages to stop
         : super.stop(messageId).then((didStop)=>{
            if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, $TTRxY.MessageDeliveryStatus).STOPPED : (0, $TTRxY.MessageDeliveryStatus).BLOCKED);
            return didStop;
        });
    }
}
function $754c27d37ccd1133$export$2e2bcd8739ae039(props) {
    const { cloudId: cloudId } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const stargateUrl = '/gateway/api';
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $ioD1B.useChoreographedStatusContext)();
    const client = new $754c27d37ccd1133$export$580a2294c917898c(cloudId, stargateUrl, props.shouldAllowOnSynthetic, orgId, props.messageType, props.onMessageDisposition, isAlreadyChoreographedAtAncestor);
    const { fallback: fallback, messageId: messageId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ioD1B.ChoreographerContextProvider), {
        isChoreographed: client.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jcYbC.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        client: client,
        fallback: fallback,
        messageId: messageId
    }, props.children));
}

});

const $90b4560f34ff7aba$export$b8b9d90f9e5bd72b = '@atlassian/jira-trial-sprint-board';
const $90b4560f34ff7aba$export$d57b6b390e78d90f = 'growth-tako';
const $90b4560f34ff7aba$export$48e1d3fa57b0a2d5 = 'trialSprintBoard';
const $90b4560f34ff7aba$export$cf8de4fabae858f0 = 'jira_premium_sample_project_id';
const $90b4560f34ff7aba$export$c7e6a6b283196232 = '/gateway/api';
const $90b4560f34ff7aba$export$e663120dbb5b4d95 = 'prj-trial-sprint-board-v2-msg-1';
const $90b4560f34ff7aba$export$a248637601302a6b = 'prj-trial-sprint-board-v2-msg-2';
const $90b4560f34ff7aba$export$389fc29b60f6a76b = 'prj-trial-sprint-board-v2-msg-3';
const $90b4560f34ff7aba$export$87b7067777cb7156 = 'trial-sprint-board';
const $90b4560f34ff7aba$export$a8c0b3da0abca1ac = 'trial-sprint-board-dismissed';

parcelRegister("60gvu", function(module, exports) {

$parcel$export(module.exports, "useCreateTrialSprintBoard", () => $bdbe1b0b24b673c2$export$22329068885bcc27);
$parcel$export(module.exports, "useIsNotTrialSprintBoardProject", () => $bdbe1b0b24b673c2$export$8b329ff03fe43c53);
$parcel$export(module.exports, "useTrialSprintBoardCtaLink", () => $bdbe1b0b24b673c2$export$a731bac57ab8049d);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $kV9ss = parcelRequire("kV9ss");

var $jX0pr = parcelRequire("jX0pr");

var $koeKL = parcelRequire("koeKL");

var $2NMNM = parcelRequire("2NMNM");

var $jcw0u = parcelRequire("jcw0u");


var $giJBv = parcelRequire("giJBv");

var $9mxBe = parcelRequire("9mxBe");
function $bdbe1b0b24b673c2$export$22329068885bcc27() {
    const isEligibleForExperiment = (0, $giJBv.useIsEligibleForTrialSprintBoard)();
    return ()=>{
        if (isEligibleForExperiment) (0, $9mxBe.createTrialSprintBoard)();
    };
}
const $bdbe1b0b24b673c2$export$dca4afd9682f517e = async (cloudId)=>{
    const siteTraits = await (0, $jX0pr.memoizedFetchSitePersonalization)({
        cloudId: cloudId
    });
    const trialSprintBoardTrait = siteTraits.find((traits)=>traits.name === (0, $90b4560f34ff7aba$export$cf8de4fabae858f0));
    if (typeof trialSprintBoardTrait?.value !== 'string') return undefined;
    return trialSprintBoardTrait.value;
};
const $bdbe1b0b24b673c2$export$5efe839f0f2e520e = async (cloudId, projectId)=>{
    const trialSprintBoardId = await $bdbe1b0b24b673c2$export$dca4afd9682f517e(cloudId);
    return trialSprintBoardId === projectId;
};
const $bdbe1b0b24b673c2$export$3b897619e437256e = async (cloudId, relayEnvironment, createAnalyticsEvent)=>{
    const trialSprintBoardId = await $bdbe1b0b24b673c2$export$dca4afd9682f517e(cloudId);
    if (trialSprintBoardId === undefined) return false;
    const projectAri = (0, $kV9ss.JiraProjectAri).create({
        siteId: cloudId,
        projectId: trialSprintBoardId
    }).toString();
    const { isProjectActive: isProjectActive, projectCreated: projectCreated } = await (0, $9mxBe.getTrialSprintBoardProjectData)(projectAri, relayEnvironment, createAnalyticsEvent);
    const millisDay = 86400000;
    const daysLeft = projectCreated ? Math.ceil((projectCreated + 30 * millisDay - Date.now()) / millisDay) : -1;
    return isProjectActive && daysLeft > 0;
};
const $bdbe1b0b24b673c2$export$d5193e0cb6586d5 = async (cloudId, relayEnvironment, createAnalyticsEvent)=>{
    const trialSprintBoardId = await $bdbe1b0b24b673c2$export$dca4afd9682f517e(cloudId);
    if (trialSprintBoardId === undefined) return undefined;
    const projectAri = (0, $kV9ss.JiraProjectAri).create({
        siteId: cloudId,
        projectId: trialSprintBoardId
    }).toString();
    const { projectKey: projectKey, boardId: boardId } = await (0, $9mxBe.getTrialSprintBoardProjectData)(projectAri, relayEnvironment, createAnalyticsEvent);
    if (projectKey === null || boardId === null) return undefined;
    const projectBoardWithIssueSelectedPath = `/jira/software/projects/${projectKey}/boards/${boardId}?selectedIssue=LEARNJIRA-1`;
    return projectBoardWithIssueSelectedPath;
};
const $bdbe1b0b24b673c2$export$8b329ff03fe43c53 = (currentProjectId)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const [isNotTsbProject, setIsNotTsbProject] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        $bdbe1b0b24b673c2$export$5efe839f0f2e520e(cloudId, currentProjectId).then((isTsbProject)=>setIsNotTsbProject(!isTsbProject));
    }, [
        cloudId,
        currentProjectId
    ]);
    return isNotTsbProject;
};
const $bdbe1b0b24b673c2$export$a731bac57ab8049d = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const relayEnvironment = (0, $8Uumt.useRelayEnvironment)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [ctaLink, setCtaLink] = (0, $5uXOq.useState)('');
    (0, $5uXOq.useEffect)(()=>{
        const getCtaLink = async ()=>{
            const isProjectAvailable = await $bdbe1b0b24b673c2$export$3b897619e437256e(cloudId, relayEnvironment, createAnalyticsEvent);
            if (isProjectAvailable) {
                const tsbIssuePath = await $bdbe1b0b24b673c2$export$d5193e0cb6586d5(cloudId, relayEnvironment, createAnalyticsEvent);
                if (tsbIssuePath !== undefined) setCtaLink(tsbIssuePath);
            }
        };
        getCtaLink().catch((e)=>{
            (0, $jcw0u.default)({
                error: e,
                meta: {
                    id: 'getTrialSprintBoardProjectData',
                    packageName: (0, $90b4560f34ff7aba$export$b8b9d90f9e5bd72b),
                    teamName: (0, $90b4560f34ff7aba$export$d57b6b390e78d90f)
                }
            });
        });
    }, [
        cloudId,
        createAnalyticsEvent,
        relayEnvironment
    ]);
    return ctaLink;
};

});
parcelRegister("giJBv", function(module, exports) {

$parcel$export(module.exports, "useIsEligibleForTrialSprintBoard", () => $47804f028d4aa8cc$export$e6f5647df30a55f2);

var $5uXOq = parcelRequire("5uXOq");


var $ldyPw = parcelRequire("ldyPw");

var $ef5Xn = parcelRequire("ef5Xn");

var $k9JTq = parcelRequire("k9JTq");

var $7trqb = parcelRequire("7trqb");

var $hqBSi = parcelRequire("hqBSi");

var $5oBMG = parcelRequire("5oBMG");

var $jPg2q = parcelRequire("jPg2q");
function $47804f028d4aa8cc$export$e6f5647df30a55f2() {
    const appEditions = (0, $k9JTq.useAppEditions)();
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    const licenseStates = (0, $7trqb.useLicenseStates)();
    const productEntitlementDetails = (0, $5oBMG.useProductEntitlementDetails)();
    const jswAppEdition = appEditions.software;
    // Only has JSW in licenses, assumed to be active given we are in onboarding flow
    const hasActiveJswLicense = licensedProducts[0, $c06e1abca7c13910$export$1346c9aa3cbb477d] && licenseStates.software === (0, $ef5Xn.LICENSE_STATE_ACTIVE) && Object.keys(licensedProducts).length === 1;
    // JSW Premium
    const isOnPremiumJsw = jswAppEdition === (0, $ldyPw.PREMIUM_EDITION);
    // On a trial
    const entitlementDetails = productEntitlementDetails?.[0, $c06e1abca7c13910$export$1346c9aa3cbb477d];
    const trialDaysLeft = (0, $5uXOq.useMemo)(()=>(0, $jPg2q.getTrialDaysLeftFromTrialEndTime)(entitlementDetails?.trialEndTime) ?? 0, [
        entitlementDetails?.trialEndTime
    ]);
    const isOnTrial = trialDaysLeft >= 0;
    return hasActiveJswLicense && isOnPremiumJsw && isOnTrial;
}

});

parcelRegister("9mxBe", function(module, exports) {

$parcel$export(module.exports, "createTrialSprintBoard", () => $a543aaf7c0a4dacb$export$37cea344fdf9b6ed);
$parcel$export(module.exports, "getTrialSprintBoardProjectData", () => $a543aaf7c0a4dacb$export$83e8cdb22fb8892d);
$parcel$export(module.exports, "getIsTrialSprintBoardModalDismissed", () => $a543aaf7c0a4dacb$export$2e4dd8ccc94e5fa);
$parcel$export(module.exports, "setIsTrialSprintBoardModalDismissed", () => $a543aaf7c0a4dacb$export$ad35b736c85ccec3);

var $530x5 = parcelRequire("530x5");

var $eiowN = parcelRequire("eiowN");

var $2vSU6 = parcelRequire("2vSU6");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $8zOmE = parcelRequire("8zOmE");

var $bSSG7 = parcelRequire("bSSG7");

function $a543aaf7c0a4dacb$export$37cea344fdf9b6ed() {
    (0, $eusud.performPostRequest)('/rest/trial-project/v1/create').catch((error)=>{
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'createTrialSprintBoard',
                packageName: (0, $90b4560f34ff7aba$export$b8b9d90f9e5bd72b),
                teamName: (0, $90b4560f34ff7aba$export$d57b6b390e78d90f)
            }
        });
    });
}
const $a543aaf7c0a4dacb$export$83e8cdb22fb8892d = async (projectAri, relayEnvironment, createAnalyticsEvent)=>{
    const data = await (0, $eiowN.fetchQuery)(relayEnvironment, (0, $530x5.default), {
        projectAri: projectAri
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    const project = data?.jira?.jiraProject;
    const isProjectActive = project?.status === (0, $2vSU6.JIRA_PROJECT_STATUS_ACTIVE);
    const projectKey = project?.key;
    const boardId = project?.tmpBoardId;
    const projectCreated = project?.created ? new Date(project.created).getTime() : null;
    if (!project) (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'trialSprintBoardProject notFound', {});
    else if (!projectKey || !boardId || !project.status || !projectCreated) (0, $jcw0u.default)({
        error: new Error('Could not retrieve all trial sprint board project data'),
        meta: {
            id: 'getTrialSprintBoardProjectData',
            packageName: (0, $90b4560f34ff7aba$export$b8b9d90f9e5bd72b),
            teamName: (0, $90b4560f34ff7aba$export$d57b6b390e78d90f)
        },
        attributes: {
            isProjectActive: isProjectActive,
            activeStatusIsPresent: !!project?.status,
            projectKeyIsPresent: !!projectKey,
            boardId: boardId ?? null,
            projectCreated: projectCreated
        }
    });
    return {
        isProjectActive: isProjectActive,
        projectKey: projectKey ?? null,
        boardId: boardId ?? null,
        projectCreated: projectCreated
    };
};
const $a543aaf7c0a4dacb$var$tsbLocalStorage = (0, $bSSG7.createLocalStorageProvider)((0, $90b4560f34ff7aba$export$87b7067777cb7156));
const $a543aaf7c0a4dacb$export$2e4dd8ccc94e5fa = ()=>{
    return $a543aaf7c0a4dacb$var$tsbLocalStorage.get((0, $90b4560f34ff7aba$export$a8c0b3da0abca1ac)) === true;
};
const $a543aaf7c0a4dacb$export$ad35b736c85ccec3 = ()=>{
    $a543aaf7c0a4dacb$var$tsbLocalStorage.set((0, $90b4560f34ff7aba$export$a8c0b3da0abca1ac), true);
};

});
parcelRegister("530x5", function(module, exports) {

$parcel$export(module.exports, "default", () => $56400afcfc79b920$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6e9ff8558faf875cd1fb3efe32191034>>
 * @relayHash d60edddcce9abded6e473e7b00b820b1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 77530e950080d1180f6d423652afe470e45507cf93cfa991dff87c19978f3b49
const $56400afcfc79b920$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "projectAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "status"
    }, v3 = {
        "kind": "ScalarField",
        "name": "key"
    }, v4 = {
        "kind": "ScalarField",
        "name": "created"
    }, v5 = {
        "kind": "ScalarField",
        "name": "tmpBoardId"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "servicesTrialSprintBoardProjectDataQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProject",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "servicesTrialSprintBoardProjectDataQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProject",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "77530e950080d1180f6d423652afe470e45507cf93cfa991dff87c19978f3b49",
            "metadata": {},
            "name": "servicesTrialSprintBoardProjectDataQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$56400afcfc79b920$var$node.hash = "0bff8aa9317d4caac17388ad150c17cb";
var $56400afcfc79b920$export$2e2bcd8739ae039 = $56400afcfc79b920$var$node;

});



parcelRegister("j9wkq", function(module, exports) {

$parcel$export(module.exports, "trialSprintBoardModalEntryPoint", () => $3261cdbb80ebb186$export$ee8e5ecce2602f9);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $3261cdbb80ebb186$export$ee8e5ecce2602f9 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("3KRD3")).then(({ TrialSprintBoardModalEntryPoint: TrialSprintBoardModalEntryPoint })=>TrialSprintBoardModalEntryPoint), {
        moduleId: "d60f0bc1",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3KRD3", function(module, exports) {

let $2bbf448d1ddc8c63$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2bbf448d1ddc8c63$var$load("2DfsY").then(()=>parcelRequire('ejP4E'));

});


parcelRegister("24MMC", function(module, exports) {

$parcel$export(module.exports, "getMessageId", () => $9ca37ce08ed605de$export$7a6ec380c1221521);

const $9ca37ce08ed605de$export$7a6ec380c1221521 = (daysLeft)=>{
    if (daysLeft === 20 || daysLeft === 19) return 0, $90b4560f34ff7aba$export$e663120dbb5b4d95;
    if (daysLeft === 18 || daysLeft === 17) return 0, $90b4560f34ff7aba$export$a248637601302a6b;
    if (daysLeft <= 16) return 0, $90b4560f34ff7aba$export$389fc29b60f6a76b;
};

});


parcelRegister("dz0Q5", function(module, exports) {

$parcel$export(module.exports, "AsyncUpflowIframeComponent", () => $aab5ccb109290e76$export$7f34679273a30171);

var $5uXOq = parcelRequire("5uXOq");

var $kxZPA = parcelRequire("kxZPA");

var $cSD7y = parcelRequire("cSD7y");

var $4mO32 = parcelRequire("4mO32");

var $7XluA = parcelRequire("7XluA");

var $73aMY = parcelRequire("73aMY");

var $cMquZ = parcelRequire("cMquZ");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $aab5ccb109290e76$var$AsyncUpflowIframeComponentOld = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("1WyXQ")).then((exportedModule)=>exportedModule.UpflowIframeComponent), {
    ssr: false,
    moduleId: "./src/packages/growth/up-flow/upflow-iframe-plugin/src/main.tsx"
});
const $aab5ccb109290e76$var$entryPointParams = {};
const $aab5ccb109290e76$var$props = {};
const $aab5ccb109290e76$var$AsyncUpflowIframeComponentNew = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $73aMY.upflowIframeComponentEntrypoint), $aab5ccb109290e76$var$entryPointParams);
    const [{ renderUpflowModal: renderUpflowModal }] = (0, $cMquZ.useUpflowModal)();
    // Violating react-entrypoint/no-load-in-hooks so we can experiment faster: https://hello.atlassian.net/wiki/spaces/JIE/pages/4772823699/LDR+Entrypoint+Load+Via+Hooks+For+Faster+Experimentation
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (renderUpflowModal) entryPointActions.load();
    }, [
        entryPointActions,
        renderUpflowModal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "issue-onboarding-modal-lazy",
        packageName: "AsyncUpflowIframeComponent",
        placeholderName: "async-upflow-iframe-modal",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: null,
        runtimeProps: $aab5ccb109290e76$var$props
    });
};
const $aab5ccb109290e76$export$7f34679273a30171 = (0, $cSD7y.componentWithFG)('upflow_iframe_iv_llc_unnecessary_bundles', $aab5ccb109290e76$var$AsyncUpflowIframeComponentNew, $aab5ccb109290e76$var$AsyncUpflowIframeComponentOld);

});
parcelRegister("73aMY", function(module, exports) {

$parcel$export(module.exports, "upflowIframeComponentEntrypoint", () => $1376512f73b86888$export$92c53bb1afc6d332);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $1376512f73b86888$export$92c53bb1afc6d332 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("1WyXQ")).then(({ UpflowIframeComponent: UpflowIframeComponent })=>UpflowIframeComponent), {
        moduleId: "caf60ffd",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("1WyXQ", function(module, exports) {

let $16a6546729da2e5d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $16a6546729da2e5d$var$load("2HA9A").then(()=>parcelRequire('f7aUi'));

});


parcelRegister("cMquZ", function(module, exports) {

$parcel$export(module.exports, "useUpflowModal", () => $85614d266b32fe16$export$7025cc2729b71e44);

var $ldyPw = parcelRequire("ldyPw");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

const $85614d266b32fe16$var$initialState = {
    renderUpflowModal: false,
    product: 'jira-software',
    touchpointId: '',
    flow: 'learn-more',
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onClose: ()=>{},
    targetEdition: (0, $ldyPw.FREE_EDITION)
};
const $85614d266b32fe16$var$actions = {
    mountUpflowModal: ({ targetEdition: targetEdition, product: product, flow: flow, touchpointId: touchpointId, subRoute: subRoute, onClose: onClose, onOpen: onOpen })=>({ setState: setState })=>{
            setState({
                targetEdition: targetEdition,
                product: product,
                flow: flow,
                touchpointId: touchpointId,
                subRoute: subRoute,
                onClose: onClose,
                onOpen: onOpen,
                renderUpflowModal: true
            });
        },
    unMountUpflowModal: ()=>({ setState: setState })=>{
            setState({
                renderUpflowModal: false
            });
        }
};
const $85614d266b32fe16$var$Store = (0, $iXqE5.createStore)({
    name: (0, $3a066fc4381e3c91$export$675a4427bf3750a2),
    initialState: $85614d266b32fe16$var$initialState,
    actions: $85614d266b32fe16$var$actions
});
const $85614d266b32fe16$export$6d73384be122c2dd = (0, $51nlc.createSubscriber)($85614d266b32fe16$var$Store);
const $85614d266b32fe16$export$e672be732bd57171 = (0, $gg7kZ.createContainer)($85614d266b32fe16$var$Store);
const $85614d266b32fe16$export$7025cc2729b71e44 = (0, $3sQ5x.createHook)($85614d266b32fe16$var$Store);

});
const $3a066fc4381e3c91$export$675a4427bf3750a2 = 'upflow-modal-store';



parcelRegister("4p6rw", function(module, exports) {

$parcel$export(module.exports, "JiraHeritageLoader", () => $da151c89e6acf066$export$9499deca9933db5b);

var $5uXOq = parcelRequire("5uXOq");

var $cQZXC = parcelRequire("cQZXC");

var $1r4rO = parcelRequire("1r4rO");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $6jY6G = parcelRequire("6jY6G");

var $6yXtV = parcelRequire("6yXtV");

var $4su49 = parcelRequire("4su49");

var $kiABc = parcelRequire("kiABc");

var $8Z3n8 = parcelRequire("8Z3n8");
const $da151c89e6acf066$var$JiraHeritageLoaderOld = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const [{ isReady: isReady }] = (0, $6yXtV.useSpaStatePageReady)();
    const [hasHeritageDownloaded, setHasHeritageDownloaded] = (0, $5uXOq.useState)(false);
    (0, $8Z3n8.useWrmStatsEffects)();
    /* eslint-disable jira/wrm/no-load-bridge */ const loadJiraHeritageDependencies = (0, $5uXOq.useCallback)(()=>{
        setHasHeritageDownloaded(true);
        (0, $4su49.asyncWrmRequire)([
            ...(0, $1r4rO.jiraSuperBatchDependencies),
            ...(0, $kiABc.getJiraHeritageDependencies)()
        ]).then(()=>(0, $cQZXC.waitForHeritage)()?.resolve?.());
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (isReady && !hasHeritageDownloaded) loadJiraHeritageDependencies();
    }, [
        hasHeritageDownloaded,
        isReady,
        loadJiraHeritageDependencies,
        route
    ]);
    return null;
};
const $da151c89e6acf066$var$JiraHeritageLoaderNew = (0, $5uXOq.Fragment);
const $da151c89e6acf066$export$9499deca9933db5b = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('no-wrm-heritage-loader'), $da151c89e6acf066$var$JiraHeritageLoaderNew, $da151c89e6acf066$var$JiraHeritageLoaderOld);
$da151c89e6acf066$export$9499deca9933db5b.displayName = 'JiraHeritageLoader';

});
parcelRegister("kiABc", function(module, exports) {

$parcel$export(module.exports, "getJiraHeritageDependencies", () => $0d81a9889d6c3d74$export$e8f6d7acd5817fa2);
const $0d81a9889d6c3d74$export$e8f6d7acd5817fa2 = ()=>[
        // superbatch resources
        // analytics
        'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
        // dependencies from HeaderFooterRendering
        'wrc!jira.webresources:key-commands',
        'wrc!jira.webresources:header',
        // . dialog
        'wrc!com.atlassian.administration.atlassian-admin-quicksearch-jira:admin-quicksearch-webresources',
        // overrides for AUI, styles and bridge apis
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
        'wrc!jira.webresources:global-static',
        // browser metrics
        'wrc!com.atlassian.jira.plugins.jira-browser-metrics:contrib',
        'wrc!com.atlassian.plugins.browser.metrics.browser-metrics-plugin:impl',
        'wrc!com.atlassian.plugins.browser.metrics.browser-metrics-plugin:api',
        // repository shortcuts from navigation
        'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:repository-shortcuts-navigation-next',
        // issue view resources
        'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf-resources-init',
        // create board dialog
        'wrc!com.pyxis.greenhopper.jira:gh-create-board-adg3-no-condition',
        // old analytics library
        'wrc!com.atlassian.analytics.analytics-client:js-events',
        // frontend cache
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:global-cache',
        // impersonation flag (logged as someone)
        'wrc!com.atlassian.crowd.user-provisioning-vertigo-plugin:impersonation-resources',
        // flag displayed when there are too many emails on the instance
        'wrc!jira.webresources:spam-protection-flags',
        // in-product announcements (displayed e.g. if there is an incident)
        'wrc!com.atlassian.pas:pas-everypage-static',
        // Bento resources
        'wrc!com.atlassian.jira.jira-fileviewer-plugin:fileviewer',
        'wrc!com.atlassian.auiplugin:dialog2',
        'wrc!com.atlassian.jira.jira-fileviewer-plugin:atlassian-fileviewer',
        'wrc!com.atlassian.jira.jira-issue-nav-plugin:stylesheets'
    ];

});

parcelRegister("8Z3n8", function(module, exports) {

$parcel$export(module.exports, "useWrmStatsEffects", () => $b2fe1e724cbc12ec$export$7ff53723d9d2886d);

var $5uXOq = parcelRequire("5uXOq");

var $6yXtV = parcelRequire("6yXtV");

var $bVDE5 = parcelRequire("bVDE5");
const $b2fe1e724cbc12ec$export$7ff53723d9d2886d = ()=>{
    const [{ isReady: isReady }] = (0, $6yXtV.useSpaStatePageReady)();
    const [{ transitionsCount: transitionsCount }] = (0, $bVDE5.useSpaStateTransition)();
    (0, $5uXOq.useEffect)(()=>{
        if (isReady && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WRM_INTERNAL_STATS__ && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        !window.__WRM_INTERNAL_STATS__.isPageInteractive) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WRM_INTERNAL_STATS__.isPageInteractive = true;
    }, [
        isReady
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (transitionsCount > 0) // clear stats on transition
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WRM_INTERNAL_STATS__ = {};
    }, [
        transitionsCount
    ]);
};

});


parcelRegister("iB3m4", function(module, exports) {

$parcel$export(module.exports, "isJiraSoftware", () => $56ae562978846669$export$1810b10f6a208e90);

var $2vSU6 = parcelRequire("2vSU6");
const $56ae562978846669$export$1810b10f6a208e90 = (projectType)=>projectType && projectType === (0, $2vSU6.SOFTWARE_PROJECT);

});

parcelRegister("6g75y", function(module, exports) {

$parcel$export(module.exports, "getRovoVideoOnboardingHash", () => $4bced0a0fc8ba960$export$7ed5123ac12331e6);
$parcel$export(module.exports, "setRovoVideoOnboardingSeen", () => $4bced0a0fc8ba960$export$88c0db0edebd3404);

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");
const $4bced0a0fc8ba960$export$9e35978d27ff337f = 'rovoVideoPlayerSeen';
const $4bced0a0fc8ba960$export$7ed5123ac12331e6 = async (accountId)=>{
    try {
        return accountId != null ? (await (0, $89SaW.getUserProperty)(accountId, $4bced0a0fc8ba960$export$9e35978d27ff337f)).hashId : null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 404 - property has not been previously set
        if (error.statusCode === 404) return null;
        (0, $jcw0u.trackFetchErrors)({
            error: error,
            id: 'rovoUserDismissGet',
            packageName: 'jiraRovoVideoModal'
        });
        throw error;
    }
};
const $4bced0a0fc8ba960$export$88c0db0edebd3404 = async (accountId, hashId)=>{
    try {
        if (accountId != null) return await (0, $89SaW.setUserProperties)(accountId, $4bced0a0fc8ba960$export$9e35978d27ff337f, JSON.stringify({
            hashId: hashId
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.trackFetchErrors)({
            error: error,
            id: 'rovoUserDismissSet',
            packageName: 'jiraRovoVideoModal'
        });
        throw error;
    }
};

});

parcelRegister("6xesd", function(module, exports) {

$parcel$export(module.exports, "useCoordinationClient", () => $67e2f11848116912$export$ddc368dc94a41e62);

var $5uXOq = parcelRequire("5uXOq");

var $eGLgs = parcelRequire("eGLgs");

var $14XJw = parcelRequire("14XJw");

var $9OXo1 = parcelRequire("9OXo1");
const $67e2f11848116912$export$ddc368dc94a41e62 = ()=>{
    const epMessageId = 'jira_rovo_video_modal_ga';
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const coordinationClient = (0, $5uXOq.useMemo)(()=>new (0, $eGLgs.CoordinationClient)(cloudId, '/gateway/api', false, orgId, 'engagement'), [
        cloudId,
        orgId
    ]);
    const start = (0, $5uXOq.useCallback)(async ()=>{
        if (!epMessageId) return false;
        return coordinationClient.start(epMessageId);
    }, [
        epMessageId,
        coordinationClient
    ]);
    const stop = (0, $5uXOq.useCallback)(()=>{
        if (!epMessageId) return false;
        return coordinationClient.stop(epMessageId);
    }, [
        epMessageId,
        coordinationClient
    ]);
    return {
        coordinationClient: coordinationClient,
        start: start,
        stop: stop
    };
};

});

parcelRegister("38EzX", function(module, exports) {

$parcel$export(module.exports, "BreadcrumbAdapter", () => $3ee15d0681681178$export$2255367d5c9162b3);

var $5uXOq = parcelRequire("5uXOq");

var $67Adx = parcelRequire("67Adx");
const $3ee15d0681681178$export$2255367d5c9162b3 = ()=>{
    // @ts-expect-error - TS2322 - Type '{ baseUrl: string; }' is not assignable to type 'IntrinsicAttributes & Omit<PropsWithDefault, "baseUrl" | keyof InjectedProps>'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $67Adx.default), {
        baseUrl: ""
    });
};

});
parcelRegister("67Adx", function(module, exports) {

$parcel$export(module.exports, "default", () => $fce4053be7c0ea3f$export$2e2bcd8739ae039);

var $9sGI6 = parcelRequire("9sGI6");

var $aYHuU = parcelRequire("aYHuU");

var $7GR7x = parcelRequire("7GR7x");

var $bQtVL = parcelRequire("bQtVL");

var $3XHss = parcelRequire("3XHss");

var $1DFxi = parcelRequire("1DFxi");
var $fce4053be7c0ea3f$export$2e2bcd8739ae039 = (0, $9sGI6.default)((0, $aYHuU.default), {
    LegacyApiBridge: // @ts-expect-error - Type 'FunctionComponent<Omit<PropsWithDefault, keyof AnalyticsEvents>>' is not assignable to type 'ComponentType<Props> | undefined'.
    $7GR7x.default,
    LegacyBreadcrumbConnector: $bQtVL.default,
    LegacyBreadcrumbState: // @ts-expect-error - TS2322 - Type 'typeof LegacyBreadcrumbState' is not assignable to type 'ComponentType<LegacyBreadcrumbStateProviderProps> | undefined'.
    $1DFxi.default,
    LegacyBreadcrumbRenderer: $3XHss.default
});

});
parcelRegister("aYHuU", function(module, exports) {

$parcel$export(module.exports, "default", () => $2640273d477c5ef9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jzjy1 = parcelRequire("jzjy1");

var $b71gk = parcelRequire("b71gk");

const $2640273d477c5ef9$var$LegacyBreadcrumbAdapter = ({ LegacyBreadcrumbRenderer: LegacyBreadcrumbRenderer, LegacyBreadcrumbState: LegacyBreadcrumbState, LegacyApiBridge: LegacyApiBridge, LegacyBreadcrumbConnector: LegacyBreadcrumbConnector })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LegacyBreadcrumbState, null, ({ api: api, state: state })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LegacyApiBridge, {
            onInsertItem: api.insertItem,
            onRemoveItem: api.removeItem,
            onSetRenderTarget: api.setTargetElement
        }), // Only activate the breadcrumb connector if there is a breadcrumb render target
        state.targetElement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
            id: "legacy-breadcrumb-adapter"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LegacyBreadcrumbConnector, {
            legacyTrail: state.trail
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LegacyBreadcrumbRenderer, {
            targetElement: state.targetElement
        }))));
var $2640273d477c5ef9$export$2e2bcd8739ae039 = (0, $jzjy1.AnalyticsSource)('legacyBreadcrumbs', (0, $4d5e0871c06cee03$export$f636b5b56f1d624a))($2640273d477c5ef9$var$LegacyBreadcrumbAdapter);

});

parcelRegister("7GR7x", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1c2002ff619891e$export$2e2bcd8739ae039);

var $1bJTy = parcelRequire("1bJTy");

var $9sGI6 = parcelRequire("9sGI6");

var $hciGg = parcelRequire("hciGg");
const $e1c2002ff619891e$var$analyticsEvents = {
    onInsertItemFired: (analyticsEvent)=>(0, $1bJTy.fireOperationalAnalytics)(analyticsEvent, {
            attributes: {
                method: 'insertItem'
            }
        }),
    onRemoveItemFired: (analyticsEvent)=>(0, $1bJTy.fireOperationalAnalytics)(analyticsEvent, {
            attributes: {
                method: 'removeItem'
            }
        }),
    onSetRenderTargetFired: (analyticsEvent)=>(0, $1bJTy.fireOperationalAnalytics)(analyticsEvent, {
            attributes: {
                method: 'render'
            }
        }),
    onOnBreadCrumbsUpdateFired: (analyticsEvent)=>(0, $1bJTy.fireOperationalAnalytics)(analyticsEvent, {
            attributes: {
                method: 'onBreadCrumbsUpdate'
            }
        })
};
var $e1c2002ff619891e$export$2e2bcd8739ae039 = (0, $9sGI6.default)((0, $hciGg.default), $e1c2002ff619891e$var$analyticsEvents);

});
parcelRegister("1bJTy", function(module, exports) {

$parcel$export(module.exports, "fireOperationalAnalytics", () => $065c8ba87a790756$export$79f423cc3fd39762);

var $4f8Oj = parcelRequire("4f8Oj");

var $jcw0u = parcelRequire("jcw0u");

var $gvRPW = parcelRequire("gvRPW");

var $i4iBk = parcelRequire("i4iBk");
// @ts-expect-error - TS7006 - Parameter 'a' implicitly has an 'any' type.
const $065c8ba87a790756$var$isNotUndefined = (a)=>a !== undefined;
const $065c8ba87a790756$var$mapPayload = (payload)=>{
    const context = (0, $i4iBk.default)(payload);
    const { name: name } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($4f8Oj)))({
        ...context,
        ...context.attributes,
        attributes: undefined,
        name: name
    }, $065c8ba87a790756$var$isNotUndefined);
};
const $065c8ba87a790756$export$79f423cc3fd39762 = (event, payload)=>{
    // Causes issues with mounting the src/packages/confluence/project-pages/src/view/examples.js component in storybook tests.
    // This is due to node_modules/@atlassiansox/analytics-web-client/dist/analytics-web-client.with-deps.js producing a reference error with the normalize function
    // This is possibly due to some scope hoisting issue with jest that is not present in the browser
    try {
        event.update({
            ...$065c8ba87a790756$var$mapPayload(payload),
            analyticsType: (0, $gvRPW.OPERATIONAL_EVENT_TYPE)
        }).fire();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $jcw0u.default)({
            event: event,
            error: e,
            meta: {
                id: 'fireOperationalAnalytics',
                packageName: 'jiraAnalyticsWebReact',
                teamName: 'legacy-jfp-team-do-not-use'
            }
        });
    }
};

});
parcelRegister("i4iBk", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a364fe632bf506b$export$2e2bcd8739ae039);

var $cjFoH = parcelRequire("cjFoH");

var $9xWGk = parcelRequire("9xWGk");
var // AnalyticsDataPayload is cast to inexact type so that it can also accept subtypes
// eslint-disable-next-line jira/import/no-anonymous-default-export
$8a364fe632bf506b$export$2e2bcd8739ae039 = (payload)=>{
    const { tags: tags, containerId: containerId, containers: containers, containerType: containerType, objectId: objectId, objectType: objectType, attributes: attributes } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9xWGk)))({
        tags: tags,
        containerId: containerId,
        containers: containers,
        containerType: containerType,
        objectId: objectId,
        objectType: objectType,
        attributes: attributes
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cjFoH))));
};

});


parcelRegister("hciGg", function(module, exports) {

$parcel$export(module.exports, "default", () => $060d1d7061b6e3c1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");

var $8oe80 = parcelRequire("8oe80");

var $c1YJb = parcelRequire("c1YJb");
// eslint-disable-next-line jira/react/no-class-components
class $060d1d7061b6e3c1$var$LegacyApiBridge extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { onInsertItem: onInsertItem, onRemoveItem: onRemoveItem, onSetRenderTarget: onSetRenderTarget, onBreadCrumbsUpdate: onBreadCrumbsUpdate } = this;
        (0, $c1YJb.default)({
            insertItem: onInsertItem,
            removeItem: onRemoveItem,
            render: onSetRenderTarget,
            onBreadCrumbsUpdate: onBreadCrumbsUpdate
        });
    }
    /* eslint-enable jira/react-no-unneeded-arrow-function-properties */ render() {
        return null;
    }
    constructor(...args){
        super(...args), /* eslint-disable jira/react-no-unneeded-arrow-function-properties */ this.onInsertItem = (item)=>{
            const { onInsertItem: onInsertItem, onInsertItemFired: onInsertItemFired } = this.props;
            onInsertItemFired();
            onInsertItem(item);
        }, this.onRemoveItem = (itemId)=>{
            const { onRemoveItem: onRemoveItem, onRemoveItemFired: onRemoveItemFired } = this.props;
            onRemoveItemFired();
            onRemoveItem(itemId);
        }, this.onSetRenderTarget = (element)=>{
            const { onSetRenderTarget: onSetRenderTarget, onSetRenderTargetFired: onSetRenderTargetFired } = this.props;
            onSetRenderTargetFired();
            onSetRenderTarget(element);
        }, this.onBreadCrumbsUpdate = ()=>{
            const { onOnBreadCrumbsUpdateFired: onOnBreadCrumbsUpdateFired } = this.props;
            onOnBreadCrumbsUpdateFired();
            return (0, $kVLXA.Observable).empty();
        };
    }
}
var $060d1d7061b6e3c1$export$2e2bcd8739ae039 = (0, $8oe80.default)('legacyApiBridge', {
    onInsertItemFired: 'apiMethodCalled',
    onRemoveItemFired: 'apiMethodCalled',
    onSetRenderTargetFired: 'apiMethodCalled',
    onOnBreadCrumbsUpdateFired: 'apiMethodCalled'
})($060d1d7061b6e3c1$var$LegacyApiBridge);

});
parcelRegister("c1YJb", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8c3f644565eaafc$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");

var $2YZCu = parcelRequire("2YZCu");

var $4R6GH = parcelRequire("4R6GH");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a8c3f644565eaafc$export$2e2bcd8739ae039 = (legacyAPI)=>{
    if ((0, $4R6GH.fg)('firefox_issue_view_memory_leak_v1')) // eslint-disable-next-line jira/wrm/no-load-bridge
    return (0, $cQZXC.waitForHeritage)()?.then(()=>// eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $7T84i.loadBridgeStrict)({
            name: 'jira/globalnavigator/breadcrumbs/bridge',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-atlaskit-plugin:breadcrumbs'
            ]
        }).then((bridge)=>{
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            bridge(legacyAPI);
        }).catch((err)=>(0, $2YZCu.default).safeErrorWithoutCustomerData('breadcrumbs.v2.bridge', err.toString())));
    // eslint-disable-next-line jira/wrm/no-load-bridge
    return (0, $9B86Q.loadBridgeWeak)({
        name: 'jira/globalnavigator/breadcrumbs/bridge'
    }).then((bridge)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        bridge(legacyAPI);
    }).catch((err)=>(0, $2YZCu.default).safeErrorWithoutCustomerData('breadcrumbs.v2.bridge', err.toString()));
};

});



parcelRegister("bQtVL", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c34ce41a7e16e82$export$2e2bcd8739ae039);

var $9sGI6 = parcelRequire("9sGI6");

var $c2D8L = parcelRequire("c2D8L");

var $btYLD = parcelRequire("btYLD");

var $gEFwt = parcelRequire("gEFwt");

var $75PvK = parcelRequire("75PvK");

var $7OPFF = parcelRequire("7OPFF");

var $5fGpW = parcelRequire("5fGpW");
var $2c34ce41a7e16e82$export$2e2bcd8739ae039 = (0, $9sGI6.default)((0, $7OPFF.default), {
    Breadcrumb: $c2D8L.default,
    ProjectBreadcrumb: $gEFwt.default,
    BoardBreadcrumb: // @ts-expect-error - TS2322 - Type '{ ({  children, boardId, boardName, isSimplifiedProject, projectId, }: BoardBreadcrumbProps): JSX.Element; defaultProps: { children: null; isSimplifiedProject: boolean; projectId: undefined; }; }' is not assignable to type 'ComponentType<Partial<BoardBreadcrumbProps>> | undefined'.
    $btYLD.default,
    UserBreadcrumb: $75PvK.default,
    ContextProvider: $5fGpW.default
});

});
parcelRegister("c2D8L", function(module, exports) {

$parcel$export(module.exports, "default", () => $904f5413e35195e5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $7Jxgt = parcelRequire("7Jxgt");

var $aIVNN = parcelRequire("aIVNN");
// eslint-disable-next-line jira/react/no-class-components
class $904f5413e35195e5$var$BreadcrumbOps extends (0, $5uXOq.Component) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(props){
        super(props), this.id = '';
        this.id = (0, $7Jxgt.v4)();
        if (false) this.onPushBreadcrumb();
    }
    componentDidMount() {
        this.onPushBreadcrumb();
    }
    componentDidUpdate(prevProps) {
        const { breadcrumb: prevBreadcrumb } = prevProps;
        const { api: api, breadcrumb: breadcrumb } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(prevBreadcrumb, breadcrumb)) api.updateBreadcrumb({
            id: this.id,
            ...breadcrumb
        });
    }
    componentWillUnmount() {
        const { api: api } = this.props;
        api.popBreadcrumb();
    }
    onPushBreadcrumb() {
        const { api: api, breadcrumb: breadcrumb } = this.props;
        api.pushBreadcrumb({
            id: this.id,
            ...breadcrumb
        });
    }
    render() {
        return null;
    }
}
const $904f5413e35195e5$var$Breadcrumb = ({ breadcrumb: breadcrumb, children: children })=>// @ts-expect-error - TS2745 - This JSX tag's 'children' prop expects type 'never' which requires multiple children, but only a single child was provided.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aIVNN.BreadcrumbActions), null, (__, actions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($904f5413e35195e5$var$BreadcrumbOps, {
            api: actions,
            breadcrumb: breadcrumb
        }), children));
$904f5413e35195e5$var$Breadcrumb.defaultProps = {
    children: null
};
var $904f5413e35195e5$export$2e2bcd8739ae039 = $904f5413e35195e5$var$Breadcrumb;

});
parcelRegister("aIVNN", function(module, exports) {

$parcel$export(module.exports, "useBreadcrumbs", () => $446946e3e8bfa528$export$8cefe241bd876ca0);
$parcel$export(module.exports, "BreadcrumbActions", () => $446946e3e8bfa528$export$9862c338ec0a6884);
$parcel$export(module.exports, "BreadcrumbContainer", () => $446946e3e8bfa528$export$c7432936d9c50db7);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
const $446946e3e8bfa528$var$initialState = {
    trail: []
};
const $446946e3e8bfa528$export$e324594224ef24da = {
    pushBreadcrumb: (breadcrumb)=>// @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'getState' implicitly has an 'any' type.
        ({ setState: setState, getState: getState })=>{
            setState({
                trail: [
                    ...getState().trail,
                    breadcrumb
                ]
            });
        },
    popBreadcrumb: ()=>// @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'getState' implicitly has an 'any' type.
        ({ setState: setState, getState: getState })=>{
            setState({
                trail: getState().trail.slice(0, -1)
            });
        },
    updateBreadcrumb: (breadcrumb)=>// @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'getState' implicitly has an 'any' type.
        ({ setState: setState, getState: getState })=>{
            // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
            const newTrail = getState().trail.map((item)=>item.id === breadcrumb.id ? breadcrumb : item);
            setState({
                trail: newTrail
            });
        }
};
const $446946e3e8bfa528$var$Store = (0, $iXqE5.createStore)({
    initialState: $446946e3e8bfa528$var$initialState,
    actions: $446946e3e8bfa528$export$e324594224ef24da,
    name: 'BreadcrumbSweetState'
});
const $446946e3e8bfa528$var$_BreadcrumbSubscriber = (0, $51nlc.createSubscriber)($446946e3e8bfa528$var$Store);
const $446946e3e8bfa528$export$8cefe241bd876ca0 = (0, $3sQ5x.createHook)($446946e3e8bfa528$var$Store);
const $446946e3e8bfa528$export$9862c338ec0a6884 = (0, $51nlc.createSubscriber)($446946e3e8bfa528$var$Store, {
    selector: null
});
const $446946e3e8bfa528$export$c7432936d9c50db7 = (0, $gg7kZ.createContainer)($446946e3e8bfa528$var$Store);

});


parcelRegister("btYLD", function(module, exports) {

$parcel$export(module.exports, "default", () => $97548d5fa76ccc5f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $c2D8L = parcelRequire("c2D8L");

var $81ps3 = parcelRequire("81ps3");
const $97548d5fa76ccc5f$var$BoardBreadcrumb = ({ children: children, boardId: boardId, boardName: boardName, isSimplifiedProject: isSimplifiedProject, projectId: projectId })=>{
    const breadcrumb = {
        href: (0, $81ps3.createBoardUrl)(boardId),
        text: boardName,
        type: 'boardName',
        analyticsAttributes: {
            nextGenProject: isSimplifiedProject,
            projectConfig: isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic'
        },
        analyticsFields: {
            name: 'navigateToSubProject',
            containerId: projectId,
            containerType: 'project'
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: breadcrumb
    }, children);
};
$97548d5fa76ccc5f$var$BoardBreadcrumb.defaultProps = {
    children: null,
    isSimplifiedProject: false,
    projectId: undefined
};
var $97548d5fa76ccc5f$export$2e2bcd8739ae039 = $97548d5fa76ccc5f$var$BoardBreadcrumb;

});
parcelRegister("81ps3", function(module, exports) {

$parcel$export(module.exports, "createProjectUrl", () => $e04610b9d6540e69$export$1bdb1f038c5a2a90);
$parcel$export(module.exports, "createProjectSettingsUrl", () => $e04610b9d6540e69$export$c435fcb42a65af32);
$parcel$export(module.exports, "createBoardUrl", () => $e04610b9d6540e69$export$7037e05c8c7af6dc);

var $02Psx = parcelRequire("02Psx");
const $e04610b9d6540e69$export$1bdb1f038c5a2a90 = (projectKey)=>`/browse/${encodeURIComponent(projectKey)}`;
const $e04610b9d6540e69$export$c435fcb42a65af32 = (projectKey, projectType, isSimplified)=>{
    if (isSimplified) return (0, $02Psx.getNextgenSettingsUrl)(projectType, projectKey);
    return `/projects/${projectKey}/settings`;
};
const $e04610b9d6540e69$export$7037e05c8c7af6dc = (boardId)=>`/secure/RapidBoard.jspa?rapidView=${boardId}`;

});


parcelRegister("gEFwt", function(module, exports) {

$parcel$export(module.exports, "default", () => $b024406020849893$export$2e2bcd8739ae039);

var $az4zD = parcelRequire("az4zD");

var $4V6Dv = parcelRequire("4V6Dv");
var $b024406020849893$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)((0, $4V6Dv.default));

});
parcelRegister("4V6Dv", function(module, exports) {

$parcel$export(module.exports, "default", () => $83ca195db24613ad$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $c2D8L = parcelRequire("c2D8L");

var $81ps3 = parcelRequire("81ps3");

var $bnbo9 = parcelRequire("bnbo9");
const $83ca195db24613ad$var$ProjectBreadcrumb = ({ isSimplifiedProject: isSimplifiedProject, children: children, projectKey: projectKey, projectName: projectName, projectId: projectId, intl: { formatMessage: formatMessage } })=>{
    const ProjectsBreadcrumb = {
        href: '/jira/projects',
        text: formatMessage((0, $bnbo9.default).projectsTitle),
        type: 'projectsDirectory',
        analyticsAttributes: {
            nextGenProject: isSimplifiedProject,
            projectConfig: isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic'
        },
        analyticsFields: {
            name: 'navigateToProjectsList'
        }
    };
    if (projectKey != null && projectName != null) {
        const breadcrumb = {
            href: (0, $81ps3.createProjectUrl)(projectKey),
            text: projectName,
            type: 'projectName',
            analyticsAttributes: {
                nextGenProject: isSimplifiedProject,
                projectConfig: isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic'
            },
            analyticsFields: {
                name: 'navigateToProject',
                containerId: projectId,
                containerType: 'project'
            }
        };
        const ProjectNameBreadcrumb = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
            breadcrumb: breadcrumb
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
            breadcrumb: ProjectsBreadcrumb
        }, ProjectNameBreadcrumb);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: ProjectsBreadcrumb
    }, children);
};
$83ca195db24613ad$var$ProjectBreadcrumb.defaultProps = {
    children: null,
    isSimplifiedProject: false,
    projectId: undefined,
    projectKey: undefined,
    projectName: undefined
};
var $83ca195db24613ad$export$2e2bcd8739ae039 = $83ca195db24613ad$var$ProjectBreadcrumb;

});
parcelRegister("bnbo9", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b60cdda05341e39$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1b60cdda05341e39$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    projectsTitle: {
        "id": "platform.ui.breadcrumbs.common-breadcrumbs.project.projects-title",
        "defaultMessage": "Projects"
    }
});

});



parcelRegister("75PvK", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc6b338da4258947$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $c2D8L = parcelRequire("c2D8L");
const $fc6b338da4258947$var$UserBreadcrumb = ({ children: children, name: name, profileUrl: profileUrl })=>{
    const breadcrumb = {
        href: profileUrl,
        text: name,
        type: 'userName'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: breadcrumb
    }, children);
};
var $fc6b338da4258947$export$2e2bcd8739ae039 = $fc6b338da4258947$var$UserBreadcrumb;

});

parcelRegister("7OPFF", function(module, exports) {

$parcel$export(module.exports, "default", () => $760c31310830da08$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $760c31310830da08$var$toBreadcrumbData = ({ id: id, index: index, ...legacyCrumb })=>({
        ...legacyCrumb,
        legacyId: id,
        type: 'legacy'
    });
const $760c31310830da08$var$ContextBreadcrumbs = ({ ContextProvider: ContextProvider, ProjectBreadcrumb: ProjectBreadcrumb, BoardBreadcrumb: BoardBreadcrumb, UserBreadcrumb: UserBreadcrumb, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ContextProvider, null, ({ data: data })=>{
        if (!data) return children;
        const boardBreadcrumb = data.scope ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BoardBreadcrumb, {
            boardId: data.scope.id,
            boardName: data.scope.name || 'Board'
        }, children) : children;
        return data.contextType === 'user' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(UserBreadcrumb, {
            profileUrl: data.user.profileUrl,
            name: data.user.name
        }, boardBreadcrumb) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ProjectBreadcrumb, {
            projectKey: data.project.key,
            projectName: data.project.name,
            projectId: data.project.id,
            isSimplifiedProject: data.project.isSimplified
        }, boardBreadcrumb);
    });
const $760c31310830da08$var$LegacyBreadcrumbConnector = ({ legacyTrail: legacyTrail, Breadcrumb: Breadcrumb, BoardBreadcrumb: BoardBreadcrumb, UserBreadcrumb: UserBreadcrumb, ProjectBreadcrumb: ProjectBreadcrumb, ContextProvider: ContextProvider })=>{
    const accumulateBreadcrumb = (accumulatedCrumbs, currentCrumb)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Breadcrumb, {
            breadcrumb: currentCrumb
        }, accumulatedCrumbs);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($760c31310830da08$var$ContextBreadcrumbs, {
        BoardBreadcrumb: BoardBreadcrumb,
        ProjectBreadcrumb: ProjectBreadcrumb,
        UserBreadcrumb: UserBreadcrumb,
        ContextProvider: ContextProvider
    }, legacyTrail.map($760c31310830da08$var$toBreadcrumbData).reverse().reduce(accumulateBreadcrumb, null));
};
var $760c31310830da08$export$2e2bcd8739ae039 = $760c31310830da08$var$LegacyBreadcrumbConnector;

});

parcelRegister("5fGpW", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cc7aa08354ae9ed$export$2e2bcd8739ae039);

var $fr1K2 = parcelRequire("fr1K2");

var $4DPZY = parcelRequire("4DPZY");

var $bmKPg = parcelRequire("bmKPg");
var $ieDtd = parcelRequire("ieDtd");
const $2cc7aa08354ae9ed$export$9f27bc3417b4524d = ({ children: children })=>{
    const [boardId] = (0, $bmKPg.usePathParam)('boardId');
    const [rapidView] = (0, $ieDtd.useQueryParam)('rapidView');
    const [{ data: ctxData, loading: loading, error: error }] = (0, $4DPZY.useContainerContext)();
    /* Don't provide scope data if boardId does not exist in the URL as
	 * we don't want to show the board breadcrumb in this case since it
	 * indicates that we aren't in a scope context even though one may
	 * exist. */ const data = ctxData == null || boardId != null || rapidView != null ? ctxData : (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(ctxData, 'scope');
    // @ts-expect-error - TS2322 - Type 'Pick<ProjectContext | UserContext, "contextType"> | null' is not assignable to type 'ContainerContext | null'. | TS2322 - Type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to type 'Error | null'.
    return children({
        data: data,
        loading: loading,
        error: error
    });
};
var $2cc7aa08354ae9ed$export$2e2bcd8739ae039 = $2cc7aa08354ae9ed$export$9f27bc3417b4524d;

});


parcelRegister("3XHss", function(module, exports) {

$parcel$export(module.exports, "default", () => $65b3956e27a1612f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $2YZCu = parcelRequire("2YZCu");

var $jS4lj = parcelRequire("jS4lj");
const $65b3956e27a1612f$var$LOCATION = 'breadcrumbs.legacy-adapter.legacy-renderer';
class $65b3956e27a1612f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    componentDidCatch(error) {
        /*
            This error boundary is added to adapt to a runtime error caused by createPortal method in IE 11
        */ const { targetElement: targetElement } = this.props;
        const targetId = targetElement ? targetElement.id : 'not-found';
        (0, $2YZCu.default).safeErrorWithoutCustomerData($65b3956e27a1612f$var$LOCATION, `Failed to createPortal on ${targetId}`, error);
    }
    render() {
        const { targetElement: targetElement } = this.props;
        return /*#__PURE__*/ (0, $7nsd3.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jS4lj.default), null), targetElement);
    }
}

});
parcelRegister("jS4lj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c6eafb2b612d104$export$2e2bcd8739ae039);

var $1bJTy = parcelRequire("1bJTy");

var $9sGI6 = parcelRequire("9sGI6");

var $9OXo1 = parcelRequire("9OXo1");

var $0SW74 = parcelRequire("0SW74");
const $8c6eafb2b612d104$var$fireAnalytics = (analyticsEvent)=>(0, $1bJTy.fireOperationalAnalytics)(analyticsEvent, {
        name: 'breadcrumbRendererMounted'
    });
var $8c6eafb2b612d104$export$2e2bcd8739ae039 = (0, $9sGI6.default)((0, $0SW74.default), {
    onMount: $8c6eafb2b612d104$var$fireAnalytics,
    TenantContextSubscriber: $9OXo1.TenantContextSubscriber
});

});
parcelRegister("0SW74", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa2b8169c8c69f79$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8oe80 = parcelRequire("8oe80");

var $6lcpk = parcelRequire("6lcpk");

var $aIVNN = parcelRequire("aIVNN");
// Adapt to prop type from breadcrumbs app
const $fa2b8169c8c69f79$var$mapTrailToBreadcrumbItems = (trail)=>trail.map((crumb)=>({
            ...crumb,
            target: crumb.target || '_self'
        }));
const $fa2b8169c8c69f79$var$BreadcrumbRenderer = ({ onMount: onMount })=>{
    const [{ trail: trail }] = (0, $aIVNN.useBreadcrumbs)();
    const items = (0, $5uXOq.useMemo)(()=>$fa2b8169c8c69f79$var$mapTrailToBreadcrumbItems(trail), [
        trail
    ]);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $5uXOq.useEffect)(onMount, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1tke1tcg"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6lcpk.default), {
        isVisible: true,
        items: items
    }));
};
var $fa2b8169c8c69f79$export$2e2bcd8739ae039 = (0, $8oe80.default)('breadcrumbsRenderer', {
    onMount: 'mounted'
})($fa2b8169c8c69f79$var$BreadcrumbRenderer);
const $fa2b8169c8c69f79$var$breadcrumbsWrapperStyles = null;

});
parcelRegister("6lcpk", function(module, exports) {

$parcel$export(module.exports, "default", () => $741d99934750459a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jD5no = parcelRequire("jD5no");

var $j6iTu = parcelRequire("j6iTu");
function $741d99934750459a$export$2e2bcd8739ae039(props) {
    const { isVisible: isVisible, items: items } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j6iTu.default), {
        isVisible: isVisible,
        items: items
    }));
}

});
parcelRegister("j6iTu", function(module, exports) {

$parcel$export(module.exports, "default", () => $5be1ac78992edda2$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $gccSB = parcelRequire("gccSB");

var $8Rkzz = parcelRequire("8Rkzz");

var $fuUnn = parcelRequire("fuUnn");
var $jbeEq = parcelRequire("jbeEq");

var $koVbs = parcelRequire("koVbs");

var $hjSul = parcelRequire("hjSul");

var $92r9l = parcelRequire("92r9l");

var $2UzOj = parcelRequire("2UzOj");
const $5be1ac78992edda2$export$67abef37aa2929b0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
        ...props,
        ref: ref,
        type: "a"
    }));
function $5be1ac78992edda2$export$2e2bcd8739ae039(props) {
    const { isVisible: isVisible, items: items } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const totalItems = items.length;
    return isVisible ? // onExpand is required prop in atlaskit's breadcrumbitem component
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jbeEq.default), {
        onExpand: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    }, (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(items) ? // This is needed in order to render an empty breadcrumb for SSR, to avoid visual jumping when javascript kicks in.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fuUnn.default), {
        text: "",
        "aria-label": formatMessage((0, $2UzOj.default).breadcrumbsLabel)
    }) : items.map((breadcrumb, index)=>{
        const breadcrumbItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92r9l.default), {
            key: index,
            index: index,
            ariaCurrent: index + 1 === totalItems ? 'page' : undefined,
            hasSeparator: true,
            text: breadcrumb.text,
            target: __SPA__ ? undefined : breadcrumb.target,
            href: breadcrumb.href,
            component: __SPA__ ? $5be1ac78992edda2$export$67abef37aa2929b0 : undefined,
            legacyId: breadcrumb.legacyId,
            type: breadcrumb.type,
            analyticsAttributes: breadcrumb.analyticsAttributes,
            analyticsFields: breadcrumb.analyticsFields
        });
        return breadcrumbItem;
    }))) : null;
}

});
parcelRegister("fuUnn", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fa85d0f49630632$export$2e2bcd8739ae039);
/* breadcrumbs-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");

var $hVWqN = parcelRequire("hVWqN");

var $6hWJD = parcelRequire("6hWJD");
const $8fa85d0f49630632$var$itemWrapperStyles = null;
const $8fa85d0f49630632$var$VAR_STEP_TRUNCATION_WIDTH = '--max-width';
const $8fa85d0f49630632$var$ICON_WIDTH_ESTIMATE = 24;
const $8fa85d0f49630632$var$staticItemStyles = null;
const $8fa85d0f49630632$var$staticItemWithTruncationStyles = null;
const $8fa85d0f49630632$var$staticItemWithoutTruncationStyles = null;
const $8fa85d0f49630632$var$BreadcrumbsItem = /*#__PURE__*/ (0, $5uXOq.memo)(({ analyticsContext: analyticsContext, component: component, href: // `createAnalyticsEvent` should be here, but throws errors on render since
// it ends up being spread on a DOM element at the very end
href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClick, onTooltipShown: onTooltipShown, ref: // This is overridden by the `buttonRef` below
ref, target: target, testId: testId, text: text, truncationWidth: truncationWidth, // I believe there is only `createAnalyticsEvent` left on here, but leaving
// it here to allow this to be a patch and not a major
...rest })=>{
    const buttonRef = (0, $5uXOq.useRef)(null);
    // If icons are provided we include their width in the truncation calculation to ensure we're as accurate as possible.
    // Note: this assumes icons are 24px wide which should be almost always.
    // Not really an issue if the icons are smaller, just that truncation occurs slightly earlier than you may want.
    let iconWidthAllowance = 0;
    if (iconBefore) iconWidthAllowance += $8fa85d0f49630632$var$ICON_WIDTH_ESTIMATE;
    if (iconAfter) iconWidthAllowance += $8fa85d0f49630632$var$ICON_WIDTH_ESTIMATE;
    const [hasOverflow, showTooltip] = (0, $6hWJD.default)(truncationWidth, buttonRef.current, iconWidthAllowance);
    // This should be a part of staticItemStyles but it requires the !important flag to prevent the padding from being overridden by the button styles
    // compiled treats `${token(xxx)} !important` differently when concat !important in es2019 and esm built files
    // the padding and font weight were not sourced correctly in the esm build
    const buttonOverrideStyles = {
        paddingBlock: "var(--ds-space-025, 2px)",
        fontWeight: "var(--ds-font-weight-regular, 400)"
    };
    // Note: cast to `any` is required to type verification - see https://github.com/frenic/csstype#what-should-i-do-when-i-get-type-errors
    const dynamicItemStyles = {
        [$8fa85d0f49630632$var$VAR_STEP_TRUNCATION_WIDTH]: typeof truncationWidth !== 'undefined' && `${truncationWidth}px`
    };
    const step = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hVWqN.default), {
        ...rest,
        analyticsContext: analyticsContext,
        component: component,
        hasOverflow: hasOverflow,
        href: href,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        onClick: onClick,
        ref: buttonRef,
        target: target,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: truncationWidth ? {
            ...dynamicItemStyles,
            ...buttonOverrideStyles
        } : buttonOverrideStyles,
        className: (0, $bwpsq.default)([
            "_vwz41txs",
            truncationWidth ? "_p12f8zc4" : "_1ul9grf3 _1o9zzg3v"
        ]),
        children: text
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("li", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4t3iubh0 _2lx2vrvc _ect41gqc _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _5nddv77o _1j1pu2gc _1dsoftgi _toskidpf _15621n76 _191d1h6o"
        ]),
        children: showTooltip ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
            content: text,
            position: "bottom",
            onShow: onTooltipShown,
            children: step
        }) : step
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8fa85d0f49630632$export$2e2bcd8739ae039 = $8fa85d0f49630632$var$BreadcrumbsItem;

});
parcelRegister("hVWqN", function(module, exports) {

$parcel$export(module.exports, "default", () => $a95af0809bc014a8$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $fVnbM = parcelRequire("fVnbM");

var $eGmKJ = parcelRequire("eGmKJ");
const $a95af0809bc014a8$var$analyticsAttributes = {
    componentName: 'breadcrumbsItem',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $a95af0809bc014a8$var$noop = (0, $eGmKJ.default);
/**
 * __Step__
 *
 * A button that represents a single step in a breadcrumbs component.
 */ const $a95af0809bc014a8$var$Step = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ analyticsContext: analyticsContext, component: component, hasOverflow: hasOverflow = true, href: href = '#', iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClickProvided = $a95af0809bc014a8$var$noop, target: target, testId: testId, // Button does not take `createAnalyticsEvent`, but it is spread on anyway
...props }, ref)=>{
    const handleClicked = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onClickProvided,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$a95af0809bc014a8$var$analyticsAttributes
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
        ...props,
        appearance: "subtle-link",
        component: component,
        href: href,
        iconAfter: hasOverflow ? undefined : iconAfter,
        iconBefore: hasOverflow ? undefined : iconBefore,
        onClick: handleClicked,
        ref: ref,
        spacing: "none",
        target: target,
        testId: testId
    });
});
var $a95af0809bc014a8$export$2e2bcd8739ae039 = $a95af0809bc014a8$var$Step;

});

parcelRegister("6hWJD", function(module, exports) {

$parcel$export(module.exports, "default", () => $39e9e81e9bc6c25a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
function $39e9e81e9bc6c25a$export$2e2bcd8739ae039(truncationWidth, buttonRefCurrent, iconWidthAllowance) {
    const shouldCheckWidth = truncationWidth && buttonRefCurrent;
    // Default to true to match hasOverflow = true default in Step component.
    // This should ensure the icon never appears and then quickly disappears
    const [hasOverflow, setOverflow] = (0, $5uXOq.useState)((0, $VSDnB.fg)('platform_fix_unnessesary_re-renders_in_breadcrumbs') ? Boolean(shouldCheckWidth) : true);
    const [showTooltip, setShowTooltip] = (0, $5uXOq.useState)(false);
    // Need to recalculate on every render cycle as text/icons/width changing will change the outcome
    (0, $5uXOq.useEffect)(()=>{
        if (shouldCheckWidth) {
            // Calculate if the button width will be larger than the truncation width after allowing for icon widths.
            // The button having a width greater than the truncationWidth, with icons, indicates the icons should be hidden to avoid going over the width limit
            const shouldOverflow = buttonRefCurrent.clientWidth + iconWidthAllowance > truncationWidth;
            // The button width can already be equal to the truncationWidth which is an indicator that truncation is occurring and a tooltip should be displayed
            const shouldShowTooltip = buttonRefCurrent.clientWidth + iconWidthAllowance >= truncationWidth;
            setOverflow(shouldOverflow);
            setShowTooltip(shouldShowTooltip);
        } else {
            setOverflow(false);
            setShowTooltip(false);
        }
    }, [
        truncationWidth,
        buttonRefCurrent,
        iconWidthAllowance,
        shouldCheckWidth
    ]);
    return [
        hasOverflow,
        showTooltip
    ];
}

});


parcelRegister("jbeEq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f33b456747f6edef$export$2e2bcd8739ae039);
/* breadcrumbs.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $5JjdN = parcelRequire("5JjdN");

var $eGmKJ = parcelRequire("eGmKJ");

var $iidvu = parcelRequire("iidvu");

var $5djWe = parcelRequire("5djWe");
const $f33b456747f6edef$var$defaultMaxItems = 8;
const $f33b456747f6edef$var$defaultBreadcrumbsLabel = 'Breadcrumbs';
const $f33b456747f6edef$var$defaultEllipsisLabel = 'Show more breadcrumbs';
const { toArray: $f33b456747f6edef$var$toArray } = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children;
const $f33b456747f6edef$var$analyticsAttributes = {
    componentName: 'breadcrumbs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $f33b456747f6edef$var$noop = (0, $eGmKJ.default);
const $f33b456747f6edef$var$interactiveElementSelector = 'a, button, [tabindex]:not([tabindex="-1"])';
const $f33b456747f6edef$var$breadcrumbStyles = null;
const $f33b456747f6edef$var$InnerBreadcrumbs = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { defaultExpanded: defaultExpanded = false, isExpanded: isExpanded, maxItems: maxItems = $f33b456747f6edef$var$defaultMaxItems, itemsBeforeCollapse: itemsBeforeCollapse = 1, itemsAfterCollapse: itemsAfterCollapse = 1, children: children = [], testId: testId, onExpand: providedExpanse = $f33b456747f6edef$var$noop, analyticsContext: analyticsContext, label: label = $f33b456747f6edef$var$defaultBreadcrumbsLabel, ellipsisLabel: ellipsisLabel = $f33b456747f6edef$var$defaultEllipsisLabel } = props;
    const [expanded, setExpanse] = (0, $5uXOq.useState)(defaultExpanded);
    const [isClickedBySpace, setExpansionTrigger] = (0, $5uXOq.useState)(false);
    const wrapperRef = (0, $5uXOq.useRef)(null);
    const isControlled = typeof isExpanded !== 'undefined';
    const isExpansionHandled = providedExpanse !== $f33b456747f6edef$var$noop;
    const shouldExpand = isControlled ? isExpanded : expanded;
    const focusFirstRevealed = ()=>{
        if (wrapperRef.current) {
            const listItems = Array.from(wrapperRef.current.querySelectorAll('li'));
            const interactiveElements = listItems.map((li)=>li.querySelector($f33b456747f6edef$var$interactiveElementSelector));
            const elementToFocus = interactiveElements[itemsBeforeCollapse];
            const firstInteractiveElement = interactiveElements[0];
            if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
            else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
            else wrapperRef.current.focus();
        }
        setExpansionTrigger(false);
    };
    (0, $5djWe.useOnRevealed)(focusFirstRevealed, {
        isExpanded: shouldExpand,
        isDisabled: !isClickedBySpace
    });
    const handleExpansion = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isControlled) setExpanse((expanded)=>!expanded);
            if (isExpansionHandled && isControlled || !isControlled) setExpansionTrigger(event.target === document.activeElement);
            return providedExpanse(event, analyticsEvent);
        },
        action: 'expanded',
        analyticsData: analyticsContext,
        ...$f33b456747f6edef$var$analyticsAttributes
    });
    const childrenArray = $f33b456747f6edef$var$toArray(children);
    const breadcrumbsArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(childrenArray, (child, index)=>{
        //To avoid error if child is a string
        if (typeof child === 'string') return child;
        return childrenArray.length - 1 === index ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
            'aria-current': 'page'
        }) : child;
    });
    const renderItemsWithEllipsis = ()=>{
        const allItems = breadcrumbsArray; // This defends against someone passing weird data, to ensure that if all
        // items would be shown anyway, we just show all items without the EllipsisItem
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        const beforeItems = allItems.slice(0, itemsBeforeCollapse);
        const afterItems = allItems.slice(allItems.length - itemsAfterCollapse, allItems.length);
        return [
            ...beforeItems,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iidvu.default), {
                testId: testId && `${testId}--breadcrumb-ellipsis`,
                onClick: handleExpansion,
                label: ellipsisLabel
            }, "ellipsis"),
            ...afterItems
        ];
    };
    const shouldDisplayItems = shouldExpand || maxItems && breadcrumbsArray.length <= maxItems;
    const breadcrumbsItems = shouldDisplayItems ? breadcrumbsArray : renderItemsWithEllipsis();
    return /*#__PURE__*/ (0, $2OMIu.jsx)("nav", {
        "aria-label": label,
        ref: (0, $5JjdN.default)([
            ref,
            wrapperRef
        ]),
        tabIndex: -1,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("ol", {
            "data-testid": testId,
            className: (0, $bwpsq.default)([
                "_1e0c1txw _1n261g80 _syaz1wmz _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t"
            ]),
            children: breadcrumbsItems
        })
    });
});
const $f33b456747f6edef$var$Breadcrumbs = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ analyticsContext: analyticsContext, children: children, createAnalyticsEvent: createAnalyticsEvent, defaultExpanded: defaultExpanded, ellipsisLabel: ellipsisLabel, isExpanded: isExpanded, itemsAfterCollapse: itemsAfterCollapse, itemsBeforeCollapse: itemsBeforeCollapse, label: label, maxItems: maxItems, onExpand: onExpand, testId: testId, ...props }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)($f33b456747f6edef$var$InnerBreadcrumbs, {
        ...props,
        analyticsContext: analyticsContext,
        children: children,
        createAnalyticsEvent: createAnalyticsEvent,
        defaultExpanded: defaultExpanded,
        ellipsisLabel: ellipsisLabel,
        isExpanded: isExpanded,
        itemsAfterCollapse: itemsAfterCollapse,
        itemsBeforeCollapse: itemsBeforeCollapse,
        label: label,
        maxItems: maxItems,
        onExpand: onExpand,
        ref: ref,
        testId: testId
    }))); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $f33b456747f6edef$export$2e2bcd8739ae039 = $f33b456747f6edef$var$Breadcrumbs;

});
parcelRegister("iidvu", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3f2526167b8235c$export$2e2bcd8739ae039);
/* ellipsis-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $eGmKJ = parcelRequire("eGmKJ");
const $b3f2526167b8235c$var$noop = (0, $eGmKJ.default);
const $b3f2526167b8235c$var$itemWrapperStyles = null;
const $b3f2526167b8235c$var$staticItemStyles = null;
const $b3f2526167b8235c$var$EllipsisItem = /*#__PURE__*/ (0, $5uXOq.memo)(({ label: label, onClick: onClick = $b3f2526167b8235c$var$noop, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("li", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4t3iubh0 _2lx2vrvc _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _5nddv77o _1j1pu2gc _1dsou2gc _toskidpf _15621n76 _191d1h6o"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
            appearance: "subtle-link",
            "aria-label": label,
            onClick: onClick,
            spacing: "none",
            testId: testId,
            className: (0, $bwpsq.default)([
                "_1rjc1tvq _k48p1hhk _vwz41txs"
            ]),
            children: "\u2026"
        })
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b3f2526167b8235c$export$2e2bcd8739ae039 = $b3f2526167b8235c$var$EllipsisItem;

});

parcelRegister("5djWe", function(module, exports) {

$parcel$export(module.exports, "useOnRevealed", () => $16bf9036c9802d42$export$e9c4922b2ecf808a);

var $5uXOq = parcelRequire("5uXOq");

var $lp9re = parcelRequire("lp9re");
function $16bf9036c9802d42$export$e9c4922b2ecf808a(callback, { isExpanded: isExpanded, isDisabled: isDisabled }) {
    const prevExtended = (0, $lp9re.default)(isExpanded);
    (0, $5uXOq.useEffect)(()=>{
        const hasBeenRevealed = !prevExtended && isExpanded;
        if (!isDisabled && hasBeenRevealed) callback();
    }, [
        isExpanded,
        isDisabled,
        callback,
        prevExtended
    ]);
}

});


parcelRegister("92r9l", function(module, exports) {

$parcel$export(module.exports, "default", () => $77e0cddbf99d95bf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fuUnn = parcelRequire("fuUnn");

var $dOvpK = parcelRequire("dOvpK");
class $77e0cddbf99d95bf$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            href: undefined,
            legacyId: undefined,
            type: 'unspecified',
            analyticsAttributes: {},
            analyticsFields: {},
            ariaCurrent: undefined
        };
    }
    render() {
        const { index: index, text: text, target: target, href: href, component: component, ariaCurrent: ariaCurrent } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fuUnn.default), {
            key: index,
            text: text,
            // @ts-expect-error - TS2322 - Type '(event: Event, analyticsEvent: UIAnalyticsEventInterface) => void' is not assignable to type '(event: MouseEvent<Element, MouseEvent>) => void'.
            onClick: this.onBreadCrumbClick,
            target: target,
            href: href,
            component: component,
            "aria-current": ariaCurrent
        });
    }
    constructor(...args){
        super(...args), this.onBreadCrumbClick = (event, analyticsEvent)=>{
            const { legacyId: legacyId, index: index, type: type, analyticsAttributes: analyticsAttributes, analyticsFields: analyticsFields } = this.props;
            (0, $dOvpK.fireUiAnalytics)(analyticsEvent, {
                name: '',
                attributes: {
                    legacyId: legacyId,
                    // change this depth value to be zero based, once Jira home crumb is added
                    depth: index + 1,
                    type: type,
                    ...analyticsAttributes
                },
                ...analyticsFields
            });
        };
    }
}

});
parcelRegister("dOvpK", function(module, exports) {

$parcel$export(module.exports, "fireUiAnalytics", () => $8c2abcc805e894f7$export$4909253b5bf1eed7);

var $4f8Oj = parcelRequire("4f8Oj");

var $gvRPW = parcelRequire("gvRPW");

var $i4iBk = parcelRequire("i4iBk");
// @ts-expect-error - TS7006 - Parameter 'a' implicitly has an 'any' type.
const $8c2abcc805e894f7$var$isNotUndefined = (a)=>a !== undefined;
const $8c2abcc805e894f7$var$mapPayload = (payload)=>{
    const context = (0, $i4iBk.default)(payload);
    const { name: name } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($4f8Oj)))({
        ...context,
        ...context.attributes,
        attributes: undefined,
        name: name
    }, $8c2abcc805e894f7$var$isNotUndefined);
};
const $8c2abcc805e894f7$export$4909253b5bf1eed7 = (event, payload)=>{
    event.update({
        ...$8c2abcc805e894f7$var$mapPayload(payload),
        analyticsType: (0, $gvRPW.UI_EVENT_TYPE)
    }).fire();
};

});


parcelRegister("2UzOj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e3ad53695e8cbba$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8e3ad53695e8cbba$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    breadcrumbsLabel: {
        "id": "navigation-apps.breadcrumbs.aria-label",
        "defaultMessage": "Empty Breadcrumbs item"
    }
});

});






parcelRegister("1DFxi", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b3b01c7b039743c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $9b3b01c7b039743c$var$compareBreadcrumbs = (a, b)=>a.index - b.index;
const $9b3b01c7b039743c$var$defaultInitialState = {
    trail: [],
    targetElement: null
};
class $9b3b01c7b039743c$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            initialState: $9b3b01c7b039743c$var$defaultInitialState
        };
    }
    constructor(props){
        super(props), this.onInsertItem = (item)=>{
            this.setState((state)=>({
                    trail: [
                        ...state.trail,
                        item
                    ].sort($9b3b01c7b039743c$var$compareBreadcrumbs)
                }));
        }, this.onRemoveItem = (id)=>{
            this.setState((state)=>({
                    trail: state.trail.filter((b)=>b.id !== id)
                }));
        }, /* eslint-disable react/no-unused-state */ this.onTargetSet = (targetElement)=>{
            this.setState({
                targetElement: targetElement
            });
        }, /* eslint-enable react/no-unused-state */ this.api = {
            setTargetElement: this.onTargetSet,
            insertItem: this.onInsertItem,
            removeItem: this.onRemoveItem
        };
        this.state = props.initialState;
    }
    render() {
        const { children: children } = this.props;
        return children({
            state: this.state,
            api: this.api
        });
    }
}

});



parcelRegister("lDu2T", function(module, exports) {

$parcel$export(module.exports, "LoadingPhaseManager", () => $c284a07391432f3b$export$6e4bfef9e80c7eb0);

var $5uXOq = parcelRequire("5uXOq");

var $lsa9q = parcelRequire("lsa9q");

var $j7rCb = parcelRequire("j7rCb");

var $6s1PB = parcelRequire("6s1PB");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c284a07391432f3b$export$6e4bfef9e80c7eb0 = ()=>{
    const [{ hasLoaded: hasLoaded }] = (0, $lsa9q.default)();
    const { resetPhase: resetPhase, startNextPhase: startNextPhase } = (0, $j7rCb.useLazyPhase)();
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $6s1PB.expValEquals)('rll_after_paint_phase_on_page_load', 'cohort', 'experiment')) {
            performance.mark('rll-after-paint-phase');
            startNextPhase();
        } else if (hasLoaded) {
            performance.mark('rll-after-paint-phase');
            startNextPhase();
        } else resetPhase();
    }, [
        hasLoaded,
        resetPhase,
        startNextPhase
    ]);
    return null;
};

});

parcelRegister("jnXgM", function(module, exports) {

$parcel$export(module.exports, "TrackClicksBeforeTTI", () => $0e1519f86dabd57c$export$2846c12b8c092470);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $6yXtV = parcelRequire("6yXtV");

var $eNf8a = parcelRequire("eNf8a");

var $4R6GH = parcelRequire("4R6GH");
const $0e1519f86dabd57c$var$cleanUrl = (pathname)=>{
    let url = pathname.replace(/\/$/, '');
    // /browse redirects or sw classic redirects
    if (/\/browse\/\w+$/.test(url)) url = 'browse';
    // replaces any occurrence of two or more capital letters,
    // or one capital letter followed by a number and also
    // two or more capital letters followed by a dash and any amount of numbers
    // (should catch all project and issue keys)
    if (/[A-Z][A-Z0-9]+(-[\d]+)*/g.test(url)) url = url.replace(/[A-Z][A-Z0-9]+(-[\d]+)*/g, 'XX');
    return url;
};
const $0e1519f86dabd57c$var$sessionStorageProvider = (0, $eNf8a.createSessionStorageProvider)('', false);
/**
 * Handles the collection and processing of user interactions that occur before the page becomes fully interactive. This enhances the understanding of user behavior during the initial loading phase.
 */ const $0e1519f86dabd57c$export$2846c12b8c092470 = ()=>{
    const [{ isReady: isReady }] = (0, $6yXtV.useSpaStatePageReady)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (!isReady) return;
        try {
            const sessionStorageItems = (0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $0e1519f86dabd57c$var$sessionStorageProvider.get('clicks-before-tti') : sessionStorage.getItem('clicks-before-tti');
            if (sessionStorageItems == null || sessionStorageItems === '') return;
            const items = JSON.parse(sessionStorageItems);
            items.forEach((item)=>{
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                let extras = {
                    elementId: item.dataId,
                    currentUrl: $0e1519f86dabd57c$var$cleanUrl(item.currentUrl),
                    bundleId: item.bundleId,
                    time: item.time
                };
                if (item.redirectUrl !== '') extras = {
                    ...extras,
                    redirectUrl: $0e1519f86dabd57c$var$cleanUrl(item.redirectUrl)
                };
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({
                    action: 'clicked'
                }), 'nonInteractiveElement clicked', '', extras);
            });
            (0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $0e1519f86dabd57c$var$sessionStorageProvider.remove('clicks-before-tti') : sessionStorage.removeItem('clicks-before-tti');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
        }
    }, [
        createAnalyticsEvent,
        isReady
    ]);
    return null;
};

});

parcelRegister("is3OJ", function(module, exports) {

$parcel$export(module.exports, "Integrations", () => $34fdc156b16a8047$export$99d02219d259eb94);
$parcel$export(module.exports, "IntegrationsWhichRequireNavigationRoot", () => $34fdc156b16a8047$export$26605c981d761e9d);

var $5uXOq = parcelRequire("5uXOq");

var $aDtmv = parcelRequire("aDtmv");

var $hJqhj = parcelRequire("hJqhj");

var $8jZFG = parcelRequire("8jZFG");

var $1oIjm = parcelRequire("1oIjm");
function $34fdc156b16a8047$export$99d02219d259eb94() {
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hJqhj.IssueViewModal), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1oIjm.Projects), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aDtmv.Dashboards), null));
    return null;
}
$34fdc156b16a8047$export$99d02219d259eb94.displayName = 'Integrations'; // This is needed to pass the test.tsx's uniqueness-test. Without it, the component appears as 'ComponentWithCondition[]', which already exists in the list.
function $34fdc156b16a8047$export$26605c981d761e9d() {
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8jZFG.KeyboardShortcuts), null);
    return null;
}

});
parcelRegister("aDtmv", function(module, exports) {

$parcel$export(module.exports, "Dashboards", () => $34586a0fe61ff38f$export$dd47e695f88fad71);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $jgE05 = parcelRequire("jgE05");

var $6jY6G = parcelRequire("6jY6G");

var $e9QkH = parcelRequire("e9QkH");

var $cZpsT = parcelRequire("cZpsT");

var $9VXkC = parcelRequire("9VXkC");
var $lVJAU = parcelRequire("lVJAU");

var $Mp6qH = parcelRequire("Mp6qH");
const $34586a0fe61ff38f$var$styles = (0, $8CUq3.xcss)({
    position: 'absolute'
});
const $34586a0fe61ff38f$export$dd47e695f88fad71 = ()=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const [isOpen, { off: modalClose }] = (0, $e9QkH.useSwitchModals)((0, $Mp6qH.MODAL_ID).DASHBOARD_CREATE);
    const { path: path } = (0, $6jY6G.useRouteByName)('dashboard-edit') ?? {};
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const onSuccess = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type. | TS7031 - Binding element 'id' implicitly has an 'any' type.
    (_, { id: id })=>{
        path && push((0, $9VXkC.generatePath)(path, {
            dashboardId: id
        }));
        modalClose();
    }, [
        modalClose,
        path,
        push
    ]);
    if (isAnonymous) return null;
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $34586a0fe61ff38f$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgE05.default), {
        onSuccess: onSuccess,
        onCancel: modalClose
    })) : null;
};

});

parcelRegister("hJqhj", function(module, exports) {

$parcel$export(module.exports, "IssueViewModal", () => $7d5d4e113f958543$export$e6a284da53c503a6);

var $5uXOq = parcelRequire("5uXOq");

var $gjEtj = parcelRequire("gjEtj");

var $ecB7Y = parcelRequire("ecB7Y");

var $lfTZh = parcelRequire("lfTZh");

var $g5X3G = parcelRequire("g5X3G");

var $kxZPA = parcelRequire("kxZPA");

const $7d5d4e113f958543$export$b61e79ae300e872f = (0, $kxZPA.lazy)(()=>(parcelRequire("eM5k0")), {
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/modal-issue-app.tsx"
});
const $7d5d4e113f958543$export$e6a284da53c503a6 = ()=>{
    const [{ isModalOpen: isModalOpen, issueKey: issueKey, onClose: onClose, packageName: packageName, analyticsSource: analyticsSource }] = (0, $ecB7Y.useTriggerIssueViewModal)();
    return isModalOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjEtj.ModalBoundary), {
        packageName: packageName,
        id: "issue-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "modal-issue-app",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7d5d4e113f958543$export$b61e79ae300e872f, {
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'AnalyticsSource'.
        analyticsSource: analyticsSource,
        issueKey: (0, $g5X3G.toIssueKey)(issueKey),
        onClose: onClose
    }))) : null;
};

});
parcelRegister("gjEtj", function(module, exports) {

$parcel$export(module.exports, "ModalBoundary", () => $c322f875acea1654$export$c3f500e812fb1bb3);

var $5uXOq = parcelRequire("5uXOq");

var $gAeCk = parcelRequire("gAeCk");

var $i2Rm5 = parcelRequire("i2Rm5");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");
const $c322f875acea1654$export$c3f500e812fb1bb3 = ({ children: children, id: id, metricKey: metricKey, packageName: packageName, onError: onError })=>{
    const ErrorState = (0, $5uXOq.useCallback)((args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorFlagRenderer), {
            id: id,
            error: args.error
        }), [
        id
    ]);
    const fallback = typeof metricKey === 'string' && metricKey.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: metricKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: id,
        packageName: packageName,
        render: ErrorState,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: id,
        fallback: fallback
    }, children));
};

});

parcelRegister("ecB7Y", function(module, exports) {

$parcel$export(module.exports, "useTriggerIssueViewModal", () => $164e67a198897250$export$fb8fdfbeb70f910c);

var $8Rkzz = parcelRequire("8Rkzz");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $164e67a198897250$export$d4c72bab9d6cc13a = {
    isModalOpen: false,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    issueKey: '',
    packageName: '',
    analyticsSource: '',
    issueCreateSessionId: undefined
};
const $164e67a198897250$export$e324594224ef24da = {
    openIssueViewModal: (nextState)=>({ setState: setState })=>{
            setState({
                ...$164e67a198897250$export$d4c72bab9d6cc13a,
                ...nextState,
                isModalOpen: true
            });
        },
    closeIssueViewModal: ()=>({ setState: setState })=>{
            setState({
                ...$164e67a198897250$export$d4c72bab9d6cc13a,
                isModalOpen: false
            });
        },
    setIssueCreateSessionId: (issueCreateSessionId)=>({ setState: setState })=>{
            setState({
                issueCreateSessionId: issueCreateSessionId
            });
        }
};
const $164e67a198897250$var$store = (0, $iXqE5.createStore)({
    name: 'issue-view.controllers.open-issue-view-modal',
    initialState: $164e67a198897250$export$d4c72bab9d6cc13a,
    actions: $164e67a198897250$export$e324594224ef24da
});
const $164e67a198897250$export$fb8fdfbeb70f910c = (0, $3sQ5x.createHook)($164e67a198897250$var$store);

});


parcelRegister("8jZFG", function(module, exports) {

$parcel$export(module.exports, "KeyboardShortcuts", () => $5e97b0340433365d$export$5176144edf2bef2b);

var $5uXOq = parcelRequire("5uXOq");

var $2YZCu = parcelRequire("2YZCu");

var $7kxNZ = parcelRequire("7kxNZ");

var $jp0tf = parcelRequire("jp0tf");


var $7CMCs = parcelRequire("7CMCs");

var $4R6GH = parcelRequire("4R6GH");

var $6BNJk = parcelRequire("6BNJk");

var $3tKCZ = parcelRequire("3tKCZ");

var $hsmeR = parcelRequire("hsmeR");

var $lmyls = parcelRequire("lmyls");

var $2Ui4E = parcelRequire("2Ui4E");

var $hULKg = parcelRequire("hULKg");

var $5rzqz = parcelRequire("5rzqz");

var $lfTZh = parcelRequire("lfTZh");

var $f5nIZ = parcelRequire("f5nIZ");

var $2YP9W = parcelRequire("2YP9W");
// Retaining the old name to avoid breaking any dashboards that may break due to this refactor
const $5e97b0340433365d$var$PACKAGE_NAME = '@atlassian/jira-atlassian-navigation';
const $5e97b0340433365d$export$5176144edf2bef2b = ()=>{
    const [, { on: on }] = (0, $2Ui4E.useTopMenus)((0, $lmyls.MENU_ID).SEARCH);
    const [, { off: closeAllMenus }] = (0, $2Ui4E.useTopMenus)();
    const { openRightSidebar: openRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const rightSidebarState = (0, $hsmeR.useActiveRightSidebarState)();
    const [{ isInitialLoad: isInitialLoad }, actions] = (0, $7kxNZ.useIsInitialLoadLegacyIssueCreate)();
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $5rzqz.useTriggerIssueCreateModal)();
    const isInitialLoadRef = (0, $5uXOq.useRef)(false);
    isInitialLoadRef.current = isInitialLoad;
    const openSearch = (0, $5uXOq.useCallback)(()=>requestAnimationFrame(()=>{
            on();
        }), [
        on
    ]);
    let currentIssueCreateVisibility = null;
    if ((0, $4R6GH.fg)('render_modern_global_issue_create_modal_experience')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { data: data } = (0, $2YP9W.useResource)((0, $f5nIZ.gicOptInStatusResources));
        currentIssueCreateVisibility = data && data?.gicOptInStatus;
    }
    const openIssueCreate = (0, $5uXOq.useCallback)(()=>{
        if ((0, $4R6GH.fg)('render_modern_global_issue_create_modal_experience')) {
            if (currentIssueCreateVisibility !== null) {
                if (currentIssueCreateVisibility.isEnabled) openIssueCreateModal({
                    triggerPointKey: (0, $hULKg.GENERIC_KEYBOARD_SHORTCUT)
                });
                else {
                    (0, $jp0tf.default)({
                        isInitialLoad: isInitialLoadRef.current,
                        triggerSource: (0, $de7681b8672bb382$export$7e22286cafe320a7)
                    });
                    if (isInitialLoadRef.current) actions.clearInitialLoaded();
                }
            } else (0, $2YZCu.default).safeErrorWithoutCustomerData('global-issue-create', 'visibility data is still getting downloaded');
        } else {
            (0, $jp0tf.default)({
                isInitialLoad: isInitialLoadRef.current,
                triggerSource: (0, $de7681b8672bb382$export$7e22286cafe320a7)
            });
            if (isInitialLoadRef.current) actions.clearInitialLoaded();
        }
    }, [
        actions,
        currentIssueCreateVisibility,
        openIssueCreateModal
    ]);
    const toggleHelpPanel = (0, $5uXOq.useCallback)(()=>{
        closeAllMenus();
        if (!rightSidebarState?.isCollapsed && rightSidebarState?.panelId === (0, $6BNJk.HELP_PANEL_ID)) closeCurrentRightSidebar();
        else openRightSidebar((0, $6BNJk.HELP_PANEL_ID), (0, $6BNJk.HELP_PANEL_WIDTH));
    }, [
        closeAllMenus,
        closeCurrentRightSidebar,
        openRightSidebar,
        rightSidebarState?.isCollapsed,
        rightSidebarState?.panelId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "integrations.keyboard-shortcuts",
        packageName: $5e97b0340433365d$var$PACKAGE_NAME,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "lazy-shortcuts",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3tKCZ.KeyboardShortcuts), {
        showIssueCreate: openIssueCreate,
        showSearch: openSearch,
        toggleHelpPanel: toggleHelpPanel,
        shouldUseHelpShortcut: true
    })));
};

});
parcelRegister("7kxNZ", function(module, exports) {

$parcel$export(module.exports, "useIsInitialLoadLegacyIssueCreate", () => $c1839ac195702930$export$8a73e89ffc4b9342);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $c1839ac195702930$var$initialState = {
    isInitialLoad: true
};
const $c1839ac195702930$export$e324594224ef24da = {
    clearInitialLoaded: ()=>({ setState: setState, getState: getState })=>{
            if (getState().isInitialLoad) setState({
                isInitialLoad: false
            });
        }
};
const $c1839ac195702930$var$store = (0, $iXqE5.createStore)({
    name: 'is-initial-load-create-issue-legacy',
    initialState: $c1839ac195702930$var$initialState,
    actions: $c1839ac195702930$export$e324594224ef24da
});
const $c1839ac195702930$export$8a73e89ffc4b9342 = (0, $3sQ5x.createHook)($c1839ac195702930$var$store);

});

parcelRegister("jp0tf", function(module, exports) {

$parcel$export(module.exports, "default", () => $16da541e59a26adc$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $6BZYo = parcelRequire("6BZYo");

var $4R6GH = parcelRequire("4R6GH");

var $iKCxj = parcelRequire("iKCxj");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$16da541e59a26adc$export$2e2bcd8739ae039 = ({ timeout: timeout, tentatives: tentatives, isInitialLoad: // isInitialLoad tracks the initial render of global issue create dialog through this entry point (presently called from navigation create button and keyboard shortcut)
isInitialLoad, triggerSource: triggerSource, showModern: showModern } = {})=>{
    (0, $iKCxj.sendStartMarkForLegacyIssueCreate)({
        isInitialLoad: isInitialLoad,
        triggerSource: triggerSource
    });
    // eslint-disable-next-line jira/wrm/no-load-bridge
    return (0, $6BZYo.loadBridge)({
        name: 'quick-edit/init/create-dialogs',
        wrmKeys: [
            'wrc!com.atlassian.jira.jira-quick-edit-plugin:quick-create-issue-bootstrap',
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs'
        ],
        timeout: timeout,
        tentatives: tentatives
    }).then((api)=>{
        if ((0, $4R6GH.fg)('render_modern_global_issue_create_modal_experience')) {
            if (showModern === true) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            api.hideLoadingIndicator(false);
            else // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            api.showCreateDialog({
                showModern: showModern
            });
        } else // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        api.showCreateDialog({});
        (0, $iKCxj.sendEndMarkForLegacyIssueCreate)({
            isInitialLoad: isInitialLoad
        });
    });
};

});
parcelRegister("iKCxj", function(module, exports) {

$parcel$export(module.exports, "sendStartMarkForLegacyIssueCreate", () => $d3fc7ef6ccbf5390$export$7dbcbf47a4e0e00f);
$parcel$export(module.exports, "sendEndMarkForLegacyIssueCreate", () => $d3fc7ef6ccbf5390$export$b5c5d408bb7fd104);

var $dvqhI = parcelRequire("dvqhI");

var $ccNll = parcelRequire("ccNll");
const $d3fc7ef6ccbf5390$export$7dbcbf47a4e0e00f = ({ isInitialLoad: isInitialLoad, triggerSource: triggerSource })=>{
    if (typeof isInitialLoad === 'boolean' && triggerSource !== undefined) {
        if (isInitialLoad) (0, $ccNll.legacyIssueCreateInitialRenderInteraction).start();
        else (0, $ccNll.legacyIssueCreateTransitionInteraction).start();
        (0, $ccNll.legacyIssueCreateCombinedInteraction).start();
    }
};
const $d3fc7ef6ccbf5390$export$b5c5d408bb7fd104 = async ({ isInitialLoad: isInitialLoad, triggerSource: triggerSource })=>{
    const Events = await (0, $dvqhI.apiReady)();
    const onCreateIssueDialogRendered = ()=>{
        if (typeof isInitialLoad === 'boolean') {
            if (isInitialLoad) (0, $ccNll.legacyIssueCreateInitialRenderInteraction).stop({
                customData: {
                    triggerSource: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'CustomValue'.
                    triggerSource,
                    isGICPrefetchEnabled: true
                }
            });
            else (0, $ccNll.legacyIssueCreateTransitionInteraction).stop({
                customData: {
                    triggerSource: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'CustomValue'.
                    triggerSource,
                    isGICPrefetchEnabled: true
                }
            });
            (0, $ccNll.legacyIssueCreateCombinedInteraction).stop({
                customData: {
                    triggerSource: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'CustomValue'.
                    triggerSource,
                    isGICPrefetchEnabled: true
                }
            });
        }
        Events.unbind('createIssueDialogRendered', onCreateIssueDialogRendered);
    };
    Events.bind('createIssueDialogRendered', onCreateIssueDialogRendered);
};

});
parcelRegister("dvqhI", function(module, exports) {

$parcel$export(module.exports, "apiReady", () => $548c078b9ef136c5$export$330fb1a04c974aad);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $6BZYo = parcelRequire("6BZYo");
let $548c078b9ef136c5$var$currentBridge;
const $548c078b9ef136c5$export$330fb1a04c974aad = async ()=>{
    if ($548c078b9ef136c5$var$currentBridge) return $548c078b9ef136c5$var$currentBridge;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/wrm/no-load-bridge
    const Events = await (0, $6BZYo.loadBridge)({
        name: 'jira/util/events',
        wrmKeys: 'wrc!jira.webresources:jira-events'
    });
    $548c078b9ef136c5$var$currentBridge = Events;
    return Events;
};

});

parcelRegister("ccNll", function(module, exports) {

$parcel$export(module.exports, "legacyIssueCreateInitialRenderInteraction", () => $d1196bb7209b7b8b$export$2bc24132dfd54487);
$parcel$export(module.exports, "legacyIssueCreateTransitionInteraction", () => $d1196bb7209b7b8b$export$ba0054dee3105c90);
$parcel$export(module.exports, "legacyIssueCreateCombinedInteraction", () => $d1196bb7209b7b8b$export$52353a8848646ccd);

var $dGrdR = parcelRequire("dGrdR");
const $d1196bb7209b7b8b$export$2bc24132dfd54487 = (0, $dGrdR.metrics).interaction({
    key: 'legacy-issue-create.initial-render'
});
const $d1196bb7209b7b8b$export$ba0054dee3105c90 = (0, $dGrdR.metrics).interaction({
    key: 'legacy-issue-create.transition'
});
const $d1196bb7209b7b8b$export$52353a8848646ccd = (0, $dGrdR.metrics).interaction({
    key: 'legacy-issue-create.combined'
});

});



const $de7681b8672bb382$export$d983e94cf86f65d = 'global-create-button';
const $de7681b8672bb382$export$7e22286cafe320a7 = 'keyboard-shortcut';

parcelRegister("3tKCZ", function(module, exports) {

$parcel$export(module.exports, "KeyboardShortcuts", () => $fcab74eed8b53dd6$export$5176144edf2bef2b);

var $kxZPA = parcelRequire("kxZPA");

const $fcab74eed8b53dd6$export$5176144edf2bef2b = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("2rRiI")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/keyboard-shortcuts/src/view/index.tsx"
});

});
parcelRegister("2rRiI", function(module, exports) {

let $1c8772d93bee4b33$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $1c8772d93bee4b33$var$load("ffQaD"),
    $1c8772d93bee4b33$var$load("kvRbA"),
    $1c8772d93bee4b33$var$load("bRwdq")
]).then(()=>parcelRequire('d6vlx'));

});


parcelRegister("2Ui4E", function(module, exports) {

$parcel$export(module.exports, "useTopMenus", () => $77ef209ff15299e4$export$6591d6b6c4546423);

var $5uXOq = parcelRequire("5uXOq");

var $d8lE2 = parcelRequire("d8lE2");

var $2qauD = parcelRequire("2qauD");
const { SwitchContainer: $77ef209ff15299e4$var$SwitchContainer, useSwitch: $77ef209ff15299e4$var$useSwitch } = (0, $2qauD.createSwitchController)('atlassian-navigation-top-menus');
const $77ef209ff15299e4$export$45ccf7b2695bac19 = $77ef209ff15299e4$var$SwitchContainer;
const $77ef209ff15299e4$var$useTopMenusBase = $77ef209ff15299e4$var$useSwitch;
const $77ef209ff15299e4$export$6591d6b6c4546423 = (props)=>{
    const switcher = $77ef209ff15299e4$var$useTopMenusBase(props);
    const [{ isOpen: isCommandPaletteOpen }] = (0, $d8lE2.useCommandPaletteIsOpen)();
    const [isSwitchOpen, { off: off }] = switcher;
    (0, $5uXOq.useEffect)(()=>{
        if (isSwitchOpen && isCommandPaletteOpen) off();
    }, [
        isCommandPaletteOpen,
        isSwitchOpen,
        off
    ]);
    return switcher;
};

});
parcelRegister("d8lE2", function(module, exports) {

$parcel$export(module.exports, "useCommandPalette", () => $f75514d959bfcca8$export$6b58f9610017fbb7);
$parcel$export(module.exports, "useActionsCommandPalette", () => $f75514d959bfcca8$export$72aa7bc7c6a83c36);
$parcel$export(module.exports, "useCommandPaletteAnalyticsAttributes", () => $f75514d959bfcca8$export$1f90c8f89f98110e);
$parcel$export(module.exports, "useCommandPaletteIsOpen", () => $f75514d959bfcca8$export$cc979be9b69236df);
$parcel$export(module.exports, "useCommandPaletteHasChildPopup", () => $f75514d959bfcca8$export$a18633b655403b12);
$parcel$export(module.exports, "useCommandPaletteIsLoaded", () => $f75514d959bfcca8$export$af8fd8cd4b048315);
$parcel$export(module.exports, "useCommandPaletteSessionId", () => $f75514d959bfcca8$export$7422170a403e909);
$parcel$export(module.exports, "useCommandPaletteExpandedCommand", () => $f75514d959bfcca8$export$282aa48e4a3afada);
$parcel$export(module.exports, "useCommandPaletteSearch", () => $f75514d959bfcca8$export$96819dfb22ad05d3);
$parcel$export(module.exports, "useCommandPaletteRegistryCurrentAttribution", () => $f75514d959bfcca8$export$f893891deedab3c6);
$parcel$export(module.exports, "useCommandPaletteUsePerformModeState", () => $f75514d959bfcca8$export$bbc05723eb144e03);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $6dDSs = parcelRequire("6dDSs");
var $iXqE5 = parcelRequire("iXqE5");

var $gM5ou = parcelRequire("gM5ou");

var $2sRNe = parcelRequire("2sRNe");
const $f75514d959bfcca8$var$initialState = {
    commandPaletteSessionId: '',
    isOpen: false,
    isLoaded: false,
    search: '',
    activeIndex: 0,
    isSearchFieldFocused: false,
    commands: [],
    parentCommand: [],
    sections: [],
    isDisabled: false,
    registry: {},
    activeRegistry: {
        commandRegistry: {},
        registryIds: []
    },
    onClosePendingCommandAction: undefined,
    isLoadChildrenError: false
};
const $f75514d959bfcca8$var$store = (0, $iXqE5.createStore)({
    initialState: $f75514d959bfcca8$var$initialState,
    actions: $2sRNe.actions,
    name: 'commandPalette'
});
const $f75514d959bfcca8$export$6b58f9610017fbb7 = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store);
const $f75514d959bfcca8$export$72aa7bc7c6a83c36 = (0, $3sQ5x.createActionsHook)($f75514d959bfcca8$var$store);
const $f75514d959bfcca8$export$e144a44b650635f4 = (ComponentToRender)=>(props)=>{
        const commandPalette = $f75514d959bfcca8$export$6b58f9610017fbb7();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ComponentToRender, {
            ...props,
            commandPalette: commandPalette
        });
    };
const $f75514d959bfcca8$export$56f06313122d0aac = ({ search: search, commandPaletteSessionId: commandPaletteSessionId, expandedCommand: expandedCommand, registry: registry, activeRegistry: activeRegistry })=>({
        wordCount: (0, $gM5ou.getWordCount)(search),
        queryLength: search.length,
        queryHash: (0, $gM5ou.getQueryHash)(search),
        commandPaletteSessionId: commandPaletteSessionId,
        cpMenu: expandedCommand?.id || 'rootMenu',
        ...(0, $gM5ou.getExpandedCommandRegistryAnalytics)(registry, activeRegistry, expandedCommand?.id) || {},
        activeRegistryIds: activeRegistry.registryIds,
        activeRegistryIdsLength: activeRegistry.registryIds.length,
        activeRegistryCommandsLength: Object.keys(activeRegistry.commandRegistry).length,
        relevancyModel: 'v2-string-similarity'
    });
const $f75514d959bfcca8$export$1f90c8f89f98110e = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: $f75514d959bfcca8$export$56f06313122d0aac
});
const $f75514d959bfcca8$export$cc979be9b69236df = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ isOpen: isOpen })=>({
            isOpen: isOpen
        })
});
const $f75514d959bfcca8$export$a18633b655403b12 = (0, $3sQ5x.createStateHook)($f75514d959bfcca8$var$store, {
    selector: (state)=>state.hasPopupOverlay
});
const $f75514d959bfcca8$export$af8fd8cd4b048315 = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ isLoaded: isLoaded })=>({
            isLoaded: isLoaded
        })
});
const $f75514d959bfcca8$export$4372697329bd9cbe = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ isDisabled: isDisabled })=>({
            isDisabled: isDisabled
        })
});
const $f75514d959bfcca8$export$7422170a403e909 = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ commandPaletteSessionId: commandPaletteSessionId })=>({
            commandPaletteSessionId: commandPaletteSessionId
        })
});
const $f75514d959bfcca8$export$282aa48e4a3afada = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ expandedCommand: expandedCommand, isOpen: isOpen })=>({
            expandedCommand: expandedCommand,
            isOpen: isOpen
        })
});
const $f75514d959bfcca8$export$96819dfb22ad05d3 = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ search: search })=>({
            search: search
        })
});
const $f75514d959bfcca8$export$a40e8ae3e53feab0 = (0, $6dDSs.createSelector)(({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>({
        registry: registry,
        activeRegistry: activeRegistry,
        expandedCommand: expandedCommand
    }), ()=>undefined, ({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>{
    if (!expandedCommand) return undefined;
    const registryData = (0, $gM5ou.getRegistryData)(registry, activeRegistry, expandedCommand.id);
    return {
        registryData: registryData,
        analyticsAttributes: registryData
    };
});
const $f75514d959bfcca8$export$f893891deedab3c6 = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: $f75514d959bfcca8$export$a40e8ae3e53feab0
});
const $f75514d959bfcca8$export$bbc05723eb144e03 = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ commands: commands, search: search, expandedCommand: expandedCommand, childResult: childResult, registry: registry, activeRegistry: activeRegistry })=>({
            commands: commands,
            search: search,
            expandedCommand: expandedCommand,
            childResult: childResult,
            registry: registry,
            activeRegistry: activeRegistry
        })
});

});
parcelRegister("gM5ou", function(module, exports) {

$parcel$export(module.exports, "getRegistryData", () => $cf289af0c139712c$export$6a1ed481c04a3ae6);
$parcel$export(module.exports, "getExpandedCommandRegistryAnalytics", () => $cf289af0c139712c$export$eb055284806da6e5);
$parcel$export(module.exports, "getShortcutSpecialCharacters", () => $cf289af0c139712c$export$e6994b845b967732);
$parcel$export(module.exports, "removeShortcutSpecialCharacters", () => $cf289af0c139712c$export$cd2a5827eae5f4cf);
$parcel$export(module.exports, "mergeSections", () => $cf289af0c139712c$export$389b0273703d5c48);
$parcel$export(module.exports, "mergeChildResults", () => $cf289af0c139712c$export$60a91e1b94ab4fef);
$parcel$export(module.exports, "getAnalyticsAttributesFromState", () => $cf289af0c139712c$export$4023cd53e5e5fcb8);
$parcel$export(module.exports, "isSecondaryTrigger", () => $cf289af0c139712c$export$daa5beabdf8d9fc3);
$parcel$export(module.exports, "hasChildren", () => $cf289af0c139712c$export$bd5ff50f0e53d41c);
$parcel$export(module.exports, "getAnalyticsAttributesFromResult", () => $cf289af0c139712c$export$bc9cd28438b3ea4b);
$parcel$export(module.exports, "getQueryHash", () => $cf289af0c139712c$export$fa1c95a5ffa92036);
$parcel$export(module.exports, "getWordCount", () => $cf289af0c139712c$export$dba3e2bcdbd49da4);
$parcel$export(module.exports, "getCommandAction", () => $cf289af0c139712c$export$fb6dafa07e60c21a);
$parcel$export(module.exports, "hasAction", () => $cf289af0c139712c$export$e217e69099d082f5);
$parcel$export(module.exports, "useSetTimeoutAutoClear", () => $cf289af0c139712c$export$c3d20e8c1e93a572);

var $5uXOq = parcelRequire("5uXOq");

var $bdDiz = parcelRequire("bdDiz");

var $2f2jJ = parcelRequire("2f2jJ");

var $bcTvL = parcelRequire("bcTvL");

var $jh7L9 = parcelRequire("jh7L9");
const $cf289af0c139712c$export$6a1ed481c04a3ae6 = (registry, activeRegistry, commandId)=>{
    if (!commandId) return undefined;
    const activeCommandRegistryData = activeRegistry?.commandRegistry?.[commandId];
    const registryData = activeCommandRegistryData?.registryId ? registry[activeCommandRegistryData?.registryId] : undefined;
    return registryData;
};
const $cf289af0c139712c$export$eb055284806da6e5 = (registry, activeRegistry, commandId)=>$cf289af0c139712c$export$6a1ed481c04a3ae6(registry, activeRegistry, commandId);
const $cf289af0c139712c$export$8af60a6897157f84 = (registry, activeRegistry, parentCommands)=>{
    const parentCommandIds = parentCommands?.map((command)=>command.id);
    while(parentCommandIds?.length){
        const nextParentCommandId = parentCommandIds?.pop();
        const registryData = $cf289af0c139712c$export$6a1ed481c04a3ae6(registry, activeRegistry, nextParentCommandId);
        if (registryData) return registryData;
    }
    return undefined;
};
const $cf289af0c139712c$export$e6994b845b967732 = ()=>[
        {
            char: ' ',
            replacement: (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).THEN
        },
        {
            char: '+',
            replacement: (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).PLUS
        },
        {
            char: '|',
            replacement: (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).OR
        }
    ];
const $cf289af0c139712c$export$cd2a5827eae5f4cf = (shortcut)=>{
    const specialChars = $cf289af0c139712c$export$e6994b845b967732();
    let strippedShortcut = shortcut;
    specialChars.forEach(({ char: char })=>{
        strippedShortcut = strippedShortcut.split(char).join('');
    });
    return strippedShortcut.toLowerCase();
};
const $cf289af0c139712c$export$389b0273703d5c48 = (sections)=>sections.reduce((acc, curr)=>{
        Object.entries(curr).forEach(([key, entry])=>{
            acc[key] = entry;
        });
        return acc;
    }, {});
const $cf289af0c139712c$export$60a91e1b94ab4fef = (childResults)=>{
    const commands = [];
    const sections = [];
    childResults.forEach((childResult)=>{
        commands.push(...childResult.commands);
        if (childResult.sections) sections.push(childResult.sections);
    });
    return {
        commands: commands,
        sections: $cf289af0c139712c$export$389b0273703d5c48(sections)
    };
};
const $cf289af0c139712c$export$ae8f55d2b67cb8d6 = (text, commonWordsToBeRemoved)=>{
    const commonWords = commonWordsToBeRemoved.toLowerCase().replace(/\s{2,}/g, ' ').trim().split(' ');
    const regexString = commonWords.map((word)=>`\\b${word}\\b`).join('|');
    const regex = new RegExp(regexString, 'g');
    return text.replace(/[.,]/g, '') // remove dot and comma
    .replace(regex, '') // remove common words
    .replace(/\s{2,}/g, ' ') // remove double spaces
    .trim();
};
const $cf289af0c139712c$export$4023cd53e5e5fcb8 = (state, command, method = 'undefined', wasSecondaryTriggered, attributes)=>{
    const analyticsAttributes = {
        commandPaletteId: command.id,
        commandPaletteSessionId: state.commandPaletteSessionId,
        searchTaken: !!state.search,
        method: method,
        cpMenu: 'rootMenu',
        action: command.id,
        actionCategory: 'none',
        wasSecondaryTriggered: wasSecondaryTriggered,
        ...$cf289af0c139712c$export$8af60a6897157f84(state.registry, state.activeRegistry, command.parentCommands) || {},
        ...$cf289af0c139712c$export$6a1ed481c04a3ae6(state.registry, state.activeRegistry, command.id) || {},
        ...$cf289af0c139712c$export$eb055284806da6e5(state.registry, state.activeRegistry, state.expandedCommand?.id) || {},
        ...attributes,
        ...!!command.analytics && command.analytics
    };
    if (state.expandedCommand?.analytics) analyticsAttributes.cpMenu = state.expandedCommand.analytics.action;
    else if (state.expandedCommand?.id) analyticsAttributes.cpMenu = state.expandedCommand.id;
    const sections = state.expandedCommand && state.childResult?.sections ? $cf289af0c139712c$export$389b0273703d5c48([
        ...state.sections,
        state.childResult?.sections
    ]) : $cf289af0c139712c$export$389b0273703d5c48(state.sections);
    const rootCommand = state.parentCommand?.[0] || state.expandedCommand || command;
    const rootSection = rootCommand.section ? sections?.[rootCommand.section] : undefined;
    analyticsAttributes.actionCategory = rootSection?.actionCategory || rootCommand?.section || rootCommand?.analytics?.actionCategory || // Fallback to the original command section
    (command?.section ? sections?.[command?.section]?.actionCategory || command?.section : undefined) || analyticsAttributes.actionCategory;
    return analyticsAttributes;
};
const $cf289af0c139712c$export$daa5beabdf8d9fc3 = (event)=>(0, $2f2jJ.isMacOs)() ? event.metaKey : event.ctrlKey;
const $cf289af0c139712c$export$bd5ff50f0e53d41c = (command)=>{
    if (command?.wasSecondaryTriggered) {
        if (command?.secondaryAction?.type) {
            const hasSecondaryChildren = (0, $jh7L9.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.secondaryAction?.type);
            return hasSecondaryChildren;
        }
        // secondary action not defined - fallback to primary
        return (0, $jh7L9.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
    }
    return (0, $jh7L9.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
};
const $cf289af0c139712c$export$bc9cd28438b3ea4b = (result)=>{
    if (result) return {
        globalIndex: result.index,
        sectionIndex: result.sectionIndex,
        indexWithinSection: result.indexWithinSection,
        sectionId: result.sectionId
    };
    return {};
};
const $cf289af0c139712c$export$fa1c95a5ffa92036 = (str)=>(0, $bdDiz.createHash)().update(str).digest('hex');
const $cf289af0c139712c$export$dba3e2bcdbd49da4 = (str)=>str.length > 0 ? str.split(/\s+/).length : 0;
const $cf289af0c139712c$export$fb6dafa07e60c21a = (command, wasSecondaryTriggered)=>{
    if (!command) return null;
    const { secondaryAction: secondaryAction, primaryAction: primaryAction } = command;
    if (!primaryAction) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const commandAction = wasSecondaryTriggered && secondaryAction ? secondaryAction : primaryAction;
    return {
        ...commandAction
    };
};
const $cf289af0c139712c$export$e217e69099d082f5 = (command)=>Boolean(command.primaryAction || command.secondaryAction);
const $cf289af0c139712c$export$c3d20e8c1e93a572 = ()=>{
    const timeoutRef = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }, []);
    const setTimeoutAutoClear = (...args)=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(...args);
    };
    return {
        setTimeoutAutoClear: setTimeoutAutoClear
    };
};

});
parcelRegister("2f2jJ", function(module, exports) {

$parcel$export(module.exports, "isMacOs", () => $6846128323867ebd$export$c5e71f489eb3970b);
$parcel$export(module.exports, "getShortcutModifierKey", () => $6846128323867ebd$export$fe66dae91c68619b);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $6846128323867ebd$export$c5e71f489eb3970b = ()=>/Mac/i.test(window?.navigator?.platform);
const $6846128323867ebd$export$fe66dae91c68619b = ()=>$6846128323867ebd$export$c5e71f489eb3970b() ? 'meta' : 'ctrl';

});

parcelRegister("bcTvL", function(module, exports) {

$parcel$export(module.exports, "UI_EVENT_TYPE", () => $3996a4302dca83b1$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $3996a4302dca83b1$export$947dac6c72b26f81);
$parcel$export(module.exports, "SHORTCUT_ELEMENT_TYPES", () => $3996a4302dca83b1$export$1ee9d153576afd13);
$parcel$export(module.exports, "COMMAND_PALETTE_DEBOUNCE_DEFAULT", () => $3996a4302dca83b1$export$894e19fc96687503);
// EVENT TYPES
const $3996a4302dca83b1$export$a1562d08625f5d7e = 'UI';
const $3996a4302dca83b1$export$947dac6c72b26f81 = 'TRACK';
const $3996a4302dca83b1$export$f1d537d508d2945a = 'SCREEN';
const $3996a4302dca83b1$export$12346a674644c156 = 'OPERATIONAL';
var $3996a4302dca83b1$export$1ee9d153576afd13 = /*#__PURE__*/ function(SHORTCUT_ELEMENT_TYPES) {
    SHORTCUT_ELEMENT_TYPES["THEN"] = "then";
    SHORTCUT_ELEMENT_TYPES["OR"] = "or";
    SHORTCUT_ELEMENT_TYPES["PLUS"] = "plus";
    SHORTCUT_ELEMENT_TYPES["KEY"] = "key";
    return SHORTCUT_ELEMENT_TYPES;
}({});
const $3996a4302dca83b1$export$894e19fc96687503 = 250;

});

parcelRegister("jh7L9", function(module, exports) {

$parcel$export(module.exports, "CommandActionType", () => $b1e48ebd4c8d5e4e$export$f041b1b117ab382f);
$parcel$export(module.exports, "COMMAND_WITH_CHILDREN", () => $b1e48ebd4c8d5e4e$export$904b2a0e38a1bef3);
var $b1e48ebd4c8d5e4e$export$f041b1b117ab382f = /*#__PURE__*/ function(CommandActionType) {
    /** Performs action when user clicks or presses Enter in the command. Command Palette closes while performing the action */ CommandActionType["PERFORM"] = "perform";
    /** Loads a sub list of commands  */ CommandActionType["COMMAND_LIST"] = "command-list";
    return CommandActionType;
}({});
const $b1e48ebd4c8d5e4e$export$3e448fd53031e13c = Object.values($b1e48ebd4c8d5e4e$export$f041b1b117ab382f);
const $b1e48ebd4c8d5e4e$export$904b2a0e38a1bef3 = [
    "command-list"
];

});


parcelRegister("2sRNe", function(module, exports) {

$parcel$export(module.exports, "actions", () => $4f4c9e92d50d4f24$export$e324594224ef24da);

var $kGsr8 = parcelRequire("kGsr8");

var $7Jxgt = parcelRequire("7Jxgt");

var $e7WVN = parcelRequire("e7WVN");

var $eTXmK = parcelRequire("eTXmK");

var $2f2jJ = parcelRequire("2f2jJ");

var $jcw0u = parcelRequire("jcw0u");

var $bcTvL = parcelRequire("bcTvL");

var $jh7L9 = parcelRequire("jh7L9");

var $gM5ou = parcelRequire("gM5ou");

var $4DwnT = parcelRequire("4DwnT");

var $h3eZO = parcelRequire("h3eZO");

var $feUec = parcelRequire("feUec");
const $4f4c9e92d50d4f24$var$rootCommands = {
    parentCommand: [],
    expandedCommand: undefined,
    childCommands: undefined,
    childResult: undefined
};
const $4f4c9e92d50d4f24$var$open = ()=>({ setState: setState, getState: getState })=>{
        if (getState().isDisabled) return;
        if (!getState().isOpen) (0, $eTXmK.default)('command-palette-opened');
        setState({
            commandPaletteSessionId: (0, $7Jxgt.v4)(),
            isOpen: true,
            activeIndex: 0,
            search: ''
        });
    };
const $4f4c9e92d50d4f24$var$close = ()=>({ setState: setState })=>{
        setState({
            isOpen: false,
            commandPaletteSessionId: '',
            search: '',
            ...$4f4c9e92d50d4f24$var$rootCommands
        });
    };
const $4f4c9e92d50d4f24$var$toggle = ()=>({ setState: setState, getState: getState })=>{
        const isOpen = !getState().isOpen;
        setState({
            isOpen: isOpen,
            activeIndex: 0,
            search: '',
            commandPaletteSessionId: isOpen ? (0, $7Jxgt.v4)() : '',
            ...!isOpen ? $4f4c9e92d50d4f24$var$rootCommands : {}
        });
    };
const $4f4c9e92d50d4f24$var$addCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newCommands = currentState.commands.concat(commands);
        const newState = {
            commands: newCommands
        };
        if (currentState.expandedCommand) {
            const matchedExpandedCommand = commands.filter((command)=>command.id === currentState.expandedCommand?.id);
            if (matchedExpandedCommand.length === 1) {
                const [updatedExpandedCommand] = matchedExpandedCommand;
                newState.expandedCommand = updatedExpandedCommand;
            }
        }
        setState(newState);
    };
const $4f4c9e92d50d4f24$var$removeCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commands.includes(command));
        setState({
            commands: newCommands
        });
    };
const $4f4c9e92d50d4f24$var$removeCommandsById = (commandIds)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commandIds.includes(command.id));
        setState({
            commands: newCommands
        });
    };
const $4f4c9e92d50d4f24$var$handleSearch = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            activeIndex: 0
        });
    };
const $4f4c9e92d50d4f24$var$forceSearchValue = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            shouldForceSearchValue: true
        });
    };
const $4f4c9e92d50d4f24$var$resetShouldForceSearchValue = ()=>({ setState: setState })=>{
        setState({
            shouldForceSearchValue: false
        });
    };
const $4f4c9e92d50d4f24$var$goBackLevel = (goToRoot, analytics)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!currentState.expandedCommand) return;
        const newState = {
            search: '',
            activeIndex: 0,
            childResult: undefined,
            forceSearchFocus: true
        };
        if (currentState.parentCommand.length && !goToRoot) {
            newState.expandedCommand = currentState.parentCommand[currentState.parentCommand.length - 1];
            newState.parentCommand = currentState.parentCommand.slice(0, currentState.parentCommand.length - 1);
            if (newState.expandedCommand?.primaryAction?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST && newState.expandedCommand?.primaryAction?.commands) newState.childResult = {
                commands: newState.expandedCommand?.primaryAction?.commands,
                sections: newState.expandedCommand?.primaryAction?.sections
            };
        } else {
            newState.loadingList = false;
            newState.parentCommand = [];
            newState.expandedCommand = undefined;
            newState.childResult = undefined;
        }
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) currentState.onAnalytics(analytics.createAnalyticsEvent({
            action: 'navigation',
            actionSubject: 'commandPalette'
        }), (0, $bcTvL.TRACK_EVENT_TYPE), {
            attributes: {
                cpMenu: currentState.expandedCommand?.id || 'rootMenu',
                searchSessionId: currentState.commandPaletteSessionId,
                action: goToRoot ? 'backToRoot' : 'backToParent',
                actionCategory: 'back',
                method: analytics?.method
            }
        });
        setState(newState);
    };
// Once search input is focused, forceSearchFocus can go back to false
const $4f4c9e92d50d4f24$var$forceFocusSearch = (forceSearchFocus = false)=>({ setState: setState })=>{
        setState({
            forceSearchFocus: forceSearchFocus
        });
    };
const $4f4c9e92d50d4f24$var$setActiveIndex = (index)=>({ setState: setState, getState: getState })=>{
        const { isSearchFieldFocused: isSearchFieldFocused } = getState();
        setState({
            activeIndex: index,
            ...!isSearchFieldFocused ? {
                forceSearchFocus: true
            } : {}
        });
    };
const $4f4c9e92d50d4f24$var$getAnalyticsAttributes = (command, method, wasSecondaryTriggered = false, attributes = {})=>({ getState: getState })=>(0, $gM5ou.getAnalyticsAttributesFromState)(getState(), command, method, wasSecondaryTriggered, attributes);
const $4f4c9e92d50d4f24$var$performDialogCloseCommand = ()=>({ setState: setState, getState: getState })=>{
        // Timeout applied to ensure that this happens after react-focus-lock is shut down
        // react-focus-lock also has a timeout before it stops listening for focus events
        // tl;dr If you don't add this timeout, cypress gets sad (and probably some actual users too but I've never repro'd it manually)
        setTimeout(()=>{
            const { onClosePendingCommandAction: onClosePendingCommandAction, onAnalytics: onAnalytics } = getState();
            if (onClosePendingCommandAction !== undefined) {
                try {
                    (0, $eTXmK.default)('command-palette-executed');
                    onClosePendingCommandAction.perform();
                    if (onAnalytics && onClosePendingCommandAction?.createAnalyticsEvent) {
                        const performAnalyticsEvent = onClosePendingCommandAction?.createAnalyticsEvent({
                            action: 'taskSucceeded',
                            actionSubject: 'commandPalette'
                        });
                        onAnalytics(performAnalyticsEvent, (0, $bcTvL.TRACK_EVENT_TYPE), {
                            attributes: onClosePendingCommandAction?.analyticsArgs
                        });
                    }
                } catch (err) {
                    const error = err instanceof Error ? err : new Error('Command palette perform error');
                    (0, $jcw0u.default)({
                        error: error,
                        meta: {
                            id: 'compal.performDialogCloseCommand',
                            packageName: 'jiraCommandPalette',
                            teamName: typeof onClosePendingCommandAction?.analyticsArgs?.teamName === 'string' ? onClosePendingCommandAction?.analyticsArgs.teamName : 'deliveroo'
                        },
                        attributes: onClosePendingCommandAction.analyticsArgs
                    });
                    (0, $e7WVN.setInteractionError)('command-palette-executed', {
                        errorMessage: error.message,
                        name: 'performDialogCloseCommandPerformError'
                    });
                }
                setState({
                    onClosePendingCommandAction: undefined
                });
            }
        }, 0);
    };
const $4f4c9e92d50d4f24$var$executeCommand = (command, analytics, wasSecondaryTriggered = false)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newState = {
            ...!(0, $4DwnT.getActiveCommandList)(command, wasSecondaryTriggered)?.keepSearch && {
                search: ''
            },
            activeIndex: 0
        };
        const analyticsAttributes = (0, $gM5ou.getAnalyticsAttributesFromState)(currentState, command, analytics?.method || 'undefined', wasSecondaryTriggered, analytics?.attributes);
        (0, $feUec.setEventAttribute)(analyticsAttributes);
        const currentCommandAction = (0, $gM5ou.getCommandAction)(command, wasSecondaryTriggered);
        if (!currentCommandAction) return;
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) {
            const analyticsEvent = analytics.createAnalyticsEvent({
                action: 'navigation',
                actionSubject: 'commandPalette'
            });
            currentState.onAnalytics(analyticsEvent, (0, $bcTvL.TRACK_EVENT_TYPE), {
                attributes: analyticsAttributes
            });
        }
        const shouldLoadChildren = (0, $gM5ou.hasChildren)({
            ...command,
            wasSecondaryTriggered: wasSecondaryTriggered
        });
        const shouldExecutePerform = currentCommandAction?.type === (0, $jh7L9.CommandActionType).PERFORM;
        if (command.mode) newState.shouldForceSearchValue = true;
        if (shouldLoadChildren) {
            (0, $eTXmK.default)('command-palette-load-child-command-list');
            if (currentState.expandedCommand) newState.parentCommand = [
                ...currentState.parentCommand,
                currentState.expandedCommand
            ];
            newState.expandedCommand = {
                ...command,
                wasSecondaryTriggered: wasSecondaryTriggered
            };
            newState.childResult = undefined;
            newState.forceSearchFocus = true;
            if ((0, $h3eZO.isSearchableChildrenAction)(currentCommandAction)) {
                newState.childResult = {
                    commands: currentCommandAction.commands,
                    sections: currentCommandAction.sections
                };
                if (command.parentCommands?.length) newState.parentCommand = [
                    ...newState.parentCommand || [],
                    ...command.parentCommands
                ];
            } else newState.childResult = undefined;
            setState(newState);
            if (currentCommandAction.type === (0, $jh7L9.CommandActionType).COMMAND_LIST && currentCommandAction.onClick) currentCommandAction.onClick();
        } else if (shouldExecutePerform) {
            if (!currentCommandAction.preventModalClose) {
                newState.commandPaletteSessionId = '';
                newState.isOpen = false;
                newState.expandedCommand = undefined;
                newState.parentCommand = [];
                newState.childResult = undefined;
                setState(newState);
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'closed',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(closeAnalyticsEvent, (0, $bcTvL.UI_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            }
            if (wasSecondaryTriggered && currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                    action: 'secondaryAction',
                    actionSubject: 'commandPalette'
                });
                currentState.onAnalytics(closeAnalyticsEvent, (0, $bcTvL.TRACK_EVENT_TYPE), {
                    attributes: {
                        ...analyticsAttributes,
                        keyPressed: (0, $2f2jJ.isMacOs)() ? 'cmdEnter' : 'ctrlEnter',
                        ...currentCommandAction.analyticsArgs
                    }
                });
            }
            // If not closing dialog, execute immediately, otherwise cue for after dialog is closed
            if (currentCommandAction.preventModalClose) try {
                (0, $eTXmK.default)('command-palette-executed');
                currentCommandAction.perform();
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const performAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'taskSucceeded',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(performAnalyticsEvent, (0, $bcTvL.TRACK_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            } catch (err) {
                const error = err instanceof Error ? err : new Error('Command palette perform error');
                (0, $jcw0u.default)({
                    error: error,
                    meta: {
                        id: 'compal.executeCommand',
                        packageName: 'jiraCommandPalette',
                        teamName: typeof analytics?.attributes?.teamName === 'string' ? analytics?.attributes.teamName : 'deliveroo'
                    },
                    attributes: analytics?.attributes
                });
                (0, $e7WVN.setInteractionError)('command-palette-executed', {
                    errorMessage: error.message,
                    name: 'executeCommandPerformError'
                });
            }
            else setState({
                onClosePendingCommandAction: {
                    ...currentCommandAction,
                    analyticsArgs: analyticsAttributes,
                    createAnalyticsEvent: analytics?.createAnalyticsEvent
                }
            });
        }
    };
const $4f4c9e92d50d4f24$var$setChildCommands = (childResult)=>({ setState: setState })=>{
        setState({
            childResult: childResult
        });
    };
const $4f4c9e92d50d4f24$var$setLoadingList = (loadingList)=>({ setState: setState })=>{
        setState({
            loadingList: loadingList
        });
    };
const $4f4c9e92d50d4f24$var$setFocusInput = (isSearchFieldFocused)=>({ setState: setState })=>setState({
            isSearchFieldFocused: isSearchFieldFocused
        });
const $4f4c9e92d50d4f24$var$registerSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.slice(0);
        sections.push(newSections);
        setState({
            sections: sections
        });
    };
const $4f4c9e92d50d4f24$var$unregisterSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.filter((section)=>section !== newSections);
        setState({
            sections: sections
        });
    };
const $4f4c9e92d50d4f24$var$markAsLoaded = ()=>({ setState: setState })=>{
        setState({
            isLoaded: true
        });
    };
const $4f4c9e92d50d4f24$var$setIsDisabled = (isDisabled)=>({ setState: setState })=>{
        setState({
            isDisabled: isDisabled,
            ...isDisabled ? {
                isOpen: false
            } : {}
        });
    };
const $4f4c9e92d50d4f24$var$setRegistry = (registry)=>({ setState: setState })=>{
        setState({
            registry: registry
        });
    };
const $4f4c9e92d50d4f24$var$updateActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const activeRegistry = {
            commandRegistry: {
                ...currentActiveRegistry.commandRegistry,
                ...commands.reduce((acc, command)=>{
                    acc[command.id] = {
                        registryId: registryId
                    };
                    return acc;
                }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {})
            },
            registryIds: (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))([
                ...currentActiveRegistry.registryIds,
                registryId
            ])
        };
        setState({
            activeRegistry: activeRegistry
        });
    };
const $4f4c9e92d50d4f24$var$removeFromActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const commandRegistry = {
            ...currentActiveRegistry.commandRegistry
        };
        commands.forEach((command)=>{
            delete commandRegistry[command.id];
        });
        setState({
            activeRegistry: {
                commandRegistry: commandRegistry,
                registryIds: currentActiveRegistry.registryIds.filter((id)=>id !== registryId)
            }
        });
    };
const $4f4c9e92d50d4f24$var$setAnalytics = (onAnalytics, onErrorAnalytics)=>({ setState: setState })=>{
        setState({
            onAnalytics: onAnalytics,
            onErrorAnalytics: onErrorAnalytics
        });
    };
const $4f4c9e92d50d4f24$var$setFallbackOverride = (fallbackOverride)=>({ setState: setState })=>{
        setState({
            fallbackOverride: fallbackOverride
        });
    };
const $4f4c9e92d50d4f24$var$setHasPopupOverlay = (hasPopupOverlay)=>({ setState: setState })=>{
        setState({
            hasPopupOverlay: hasPopupOverlay
        });
    };
const $4f4c9e92d50d4f24$export$e324594224ef24da = {
    open: $4f4c9e92d50d4f24$var$open,
    toggle: $4f4c9e92d50d4f24$var$toggle,
    close: $4f4c9e92d50d4f24$var$close,
    addCommands: $4f4c9e92d50d4f24$var$addCommands,
    removeCommands: $4f4c9e92d50d4f24$var$removeCommands,
    handleSearch: $4f4c9e92d50d4f24$var$handleSearch,
    forceFocusSearch: $4f4c9e92d50d4f24$var$forceFocusSearch,
    setActiveIndex: $4f4c9e92d50d4f24$var$setActiveIndex,
    executeCommand: $4f4c9e92d50d4f24$var$executeCommand,
    goBackLevel: $4f4c9e92d50d4f24$var$goBackLevel,
    setChildCommands: $4f4c9e92d50d4f24$var$setChildCommands,
    setLoadingList: $4f4c9e92d50d4f24$var$setLoadingList,
    setFocusInput: $4f4c9e92d50d4f24$var$setFocusInput,
    registerSections: $4f4c9e92d50d4f24$var$registerSections,
    unregisterSections: $4f4c9e92d50d4f24$var$unregisterSections,
    markAsLoaded: $4f4c9e92d50d4f24$var$markAsLoaded,
    getAnalyticsAttributes: $4f4c9e92d50d4f24$var$getAnalyticsAttributes,
    setIsDisabled: $4f4c9e92d50d4f24$var$setIsDisabled,
    setRegistry: $4f4c9e92d50d4f24$var$setRegistry,
    updateActiveRegistry: $4f4c9e92d50d4f24$var$updateActiveRegistry,
    removeCommandsById: $4f4c9e92d50d4f24$var$removeCommandsById,
    removeFromActiveRegistry: $4f4c9e92d50d4f24$var$removeFromActiveRegistry,
    performDialogCloseCommand: $4f4c9e92d50d4f24$var$performDialogCloseCommand,
    setAnalytics: $4f4c9e92d50d4f24$var$setAnalytics,
    setFallbackOverride: $4f4c9e92d50d4f24$var$setFallbackOverride,
    setHasPopupOverlay: $4f4c9e92d50d4f24$var$setHasPopupOverlay,
    forceSearchValue: $4f4c9e92d50d4f24$var$forceSearchValue,
    resetShouldForceSearchValue: $4f4c9e92d50d4f24$var$resetShouldForceSearchValue
};

});
parcelRegister("4DwnT", function(module, exports) {

$parcel$export(module.exports, "getActiveCommandList", () => $b4088022dc3f5c54$export$639b7f41b0b47a01);

var $jh7L9 = parcelRequire("jh7L9");
const $b4088022dc3f5c54$export$639b7f41b0b47a01 = (expandedCommand, wasSecondaryTriggered)=>{
    if (wasSecondaryTriggered && expandedCommand?.secondaryAction?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST) return expandedCommand.secondaryAction;
    if (!wasSecondaryTriggered && expandedCommand?.primaryAction?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST) return expandedCommand.primaryAction;
    return null;
};

});

parcelRegister("h3eZO", function(module, exports) {

$parcel$export(module.exports, "isSearchableChildrenAction", () => $dd5db8363c7eeda7$export$d75616d77443fe4e);

var $jh7L9 = parcelRequire("jh7L9");
const $dd5db8363c7eeda7$export$d75616d77443fe4e = (action)=>action?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST && action.commands !== undefined;

});

parcelRegister("feUec", function(module, exports) {

$parcel$export(module.exports, "setEventAttribute", () => $dd73b01c41e7185b$export$7c0a9f4caaf7cfce);

var $5fc53 = parcelRequire("5fc53");

var $ctrpc = parcelRequire("ctrpc");
const $dd73b01c41e7185b$var$ACTIONS_TO_WATCH = [
    'unassign',
    'assignToMe'
];
const $dd73b01c41e7185b$export$7c0a9f4caaf7cfce = (attributes)=>{
    if (attributes.actionCategory === 'issueActions' && typeof attributes.action === 'string' && $dd73b01c41e7185b$var$ACTIONS_TO_WATCH.includes(attributes.action)) (0, $ctrpc.getUpdateAnalyticsFlowHelper)().setAttributes((0, $5fc53.ASSIGNEE_TYPE), {
        isCommandPaletteEditing: true
    });
};

});
parcelRegister("ctrpc", function(module, exports) {

$parcel$export(module.exports, "eventFlowManager", () => $a32e213c0a4381f7$export$87846400a9b428fc);
$parcel$export(module.exports, "getUpdateAnalyticsFlowHelper", () => $a32e213c0a4381f7$export$f3b2b77402b2631f);

var $7Jxgt = parcelRequire("7Jxgt");

var $2YZCu = parcelRequire("2YZCu");

var $8zOmE = parcelRequire("8zOmE");

var $8ikZj = parcelRequire("8ikZj");

var $bximr = parcelRequire("bximr");
/**
 * A singleton class to provide a sessionId to track update of fields
 */ class $a32e213c0a4381f7$var$EventFlowManager {
    reset() {
        this.ids.clear();
        this.extraAttributes.clear();
    }
    push(key) {
        const id = (0, $7Jxgt.v4)();
        this.ids.set(key, id);
        return id;
    }
    pull(key, shouldDelete = true) {
        const value = this.ids.get(key);
        if (shouldDelete) this.ids.delete(key);
        return value;
    }
    constructor(){
        this.ids = new Map();
        this.extraAttributes = new Map();
    }
}
const $a32e213c0a4381f7$export$87846400a9b428fc = new $a32e213c0a4381f7$var$EventFlowManager();
/**
 * Concatenates updateSessionId, default attributes and the attributes sent through
 *  the event and/or setAttributes
 */ const $a32e213c0a4381f7$var$concatAttributes = (fieldKey, updateSessionId, attributes)=>{
    let fieldTypeValue = attributes.fieldType;
    const extraAttributes = $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.get(fieldKey);
    fieldTypeValue = extraAttributes?.fieldType ?? fieldTypeValue;
    const fieldType = fieldTypeValue && (0, $8ikZj.FIELD_TYPE_MAP)[fieldTypeValue] ? (0, $8ikZj.FIELD_TYPE_MAP)[fieldTypeValue] : fieldTypeValue;
    return {
        updateSessionId: updateSessionId,
        ...(0, $8ikZj.DEFAULT_ATTRIBUTES),
        ...attributes,
        ...extraAttributes,
        fieldKey: fieldKey,
        fieldType: fieldType
    };
};
const $a32e213c0a4381f7$var$hasError = (e)=>e instanceof Error;
/**
 * Provides three events START {@link fireAnalyticsStart},
 * END {@link fireAnalyticsEnd} to track the user flow when updating
 * a field and setAttributes{@link setAttributes} to set specific
 * fields attributes
 */ const $a32e213c0a4381f7$var$updateAnalyticsFlowHelper = {
    fireAnalyticsStart (fieldKey, params) {
        try {
            const { assigneeId: assigneeId, product: product } = (0, $bximr.getContextAssigneeIdAndProduct)(params.analytics.context);
            if (product === 'serviceDesk') return;
            $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.set(fieldKey, {
                ...params.attributes,
                assigneeId: assigneeId
            });
            const sessionid = $a32e213c0a4381f7$export$87846400a9b428fc.push(fieldKey);
            const attributes = $a32e213c0a4381f7$var$concatAttributes(fieldKey, sessionid, params.attributes);
            attributes.isIssueViewEditing = !attributes.isCommandPaletteEditing && !attributes.isContextMenuEditing && !attributes.isDragEditing && !attributes.isInlineEditing;
            (0, $8zOmE.fireUIAnalytics)(params.analytics, `${(0, $8ikZj.START_ACTION_SUBJECT)} ${(0, $8ikZj.START_ACTION)}`, (0, $8ikZj.START_ACTION_SUBJECT_ID), attributes);
        } catch (e) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.analytics.services.update-issue-field.fireAnalyticsStart', $a32e213c0a4381f7$var$hasError(e) ? e.toString() : 'unknown error');
        }
    },
    fireAnalyticsEnd (fieldKey, params, isEndOfSession = true) {
        try {
            if ((0, $bximr.getContextProduct)(params.analytics.context) === 'serviceDesk') return;
            const sessionid = $a32e213c0a4381f7$export$87846400a9b428fc.pull(fieldKey, isEndOfSession);
            const isFieldKeyUnknown = (0, $8ikZj.UNKNOWN_FIELD_IDS).includes(fieldKey);
            const actualFieldKey = isFieldKeyUnknown && params.attributes.fieldKey && typeof params.attributes.fieldKey === 'string' ? params.attributes.fieldKey : fieldKey;
            const attributes = $a32e213c0a4381f7$var$concatAttributes(actualFieldKey, sessionid, params.attributes);
            if (isEndOfSession) {
                if (isFieldKeyUnknown) $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.delete(fieldKey);
                $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.delete(actualFieldKey);
            }
            attributes.isIssueViewEditing = !attributes.isCommandPaletteEditing && !attributes.isContextMenuEditing && !attributes.isDragEditing && !attributes.isInlineEditing;
            (0, $8zOmE.fireTrackAnalytics)(params.analytics, `${(0, $8ikZj.END_ACTION_SUBJECT)} ${(0, $8ikZj.END_ACTION)}`, (0, $8ikZj.END_ACTION_SUBJECT_ID), {
                ...attributes,
                is_new_1event: true
            });
        } catch (e) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.analytics.services.update-issue-field.fireAnalyticsEnd', $a32e213c0a4381f7$var$hasError(e) ? e.toString() : 'unknown error');
        }
    },
    setAttributes (fieldKey, attributes) {
        const currentAttributes = $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.get(fieldKey);
        $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.set(fieldKey, {
            ...currentAttributes,
            ...attributes
        });
    },
    setActionTakenAttributes (fieldKey, oldValId, newValId) {
        if (oldValId !== newValId) this.setAttributes(fieldKey, {
            oldValId: oldValId,
            newValId: newValId,
            actionTaken: (0, $bximr.getActionTaken)(oldValId, newValId)
        });
    },
    // Use this to clean up session without firing analytics event. This happens for entity fields when
    // multiple end events can be fired after a start event
    endSession (fieldKey) {
        $a32e213c0a4381f7$export$87846400a9b428fc.pull(fieldKey);
        $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.delete(fieldKey);
    },
    reset () {
        $a32e213c0a4381f7$export$87846400a9b428fc.reset();
    }
};
const $a32e213c0a4381f7$export$f3b2b77402b2631f = ()=>$a32e213c0a4381f7$var$updateAnalyticsFlowHelper;

});
parcelRegister("8ikZj", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ATTRIBUTES", () => $ba1d12fd09beb370$export$69665899d8392309);
$parcel$export(module.exports, "START_ACTION", () => $ba1d12fd09beb370$export$c0a4673e0c78e972);
$parcel$export(module.exports, "START_ACTION_SUBJECT", () => $ba1d12fd09beb370$export$34a5ae354a38cc7e);
$parcel$export(module.exports, "START_ACTION_SUBJECT_ID", () => $ba1d12fd09beb370$export$bc373f59492dc6e2);
$parcel$export(module.exports, "END_ACTION", () => $ba1d12fd09beb370$export$b19686c1fe99f85a);
$parcel$export(module.exports, "END_ACTION_SUBJECT", () => $ba1d12fd09beb370$export$4ce67e80878d47ed);
$parcel$export(module.exports, "END_ACTION_SUBJECT_ID", () => $ba1d12fd09beb370$export$e3d957ccc2d46469);
$parcel$export(module.exports, "ACTION_TAKEN_ADD", () => $ba1d12fd09beb370$export$3b3e3ac6d7f6e219);
$parcel$export(module.exports, "ACTION_TAKEN_REMOVE", () => $ba1d12fd09beb370$export$6137e1b2fcde2333);
$parcel$export(module.exports, "DRAG_DROP_UNKNOWN_FIELD_ID", () => $ba1d12fd09beb370$export$6d8c364f9d389764);
$parcel$export(module.exports, "UNKNOWN_FIELD_IDS", () => $ba1d12fd09beb370$export$7d1d20ff891eeb26);
$parcel$export(module.exports, "FIELD_TYPE_MAP", () => $ba1d12fd09beb370$export$d8ccf495ccc97a69);
$parcel$export(module.exports, "ENTITY_FIELD_KEYS", () => $ba1d12fd09beb370$export$7d9dd31e187cb2db);

var $5fc53 = parcelRequire("5fc53");
const $ba1d12fd09beb370$export$69665899d8392309 = {
    isInlineEditing: false,
    isCommandPaletteEditing: false,
    isDragEditing: false,
    isContextMenuEditing: false,
    isIssueViewEditing: false
};
const $ba1d12fd09beb370$export$c0a4673e0c78e972 = 'clicked';
const $ba1d12fd09beb370$export$34a5ae354a38cc7e = 'item';
const $ba1d12fd09beb370$export$bc373f59492dc6e2 = 'issue';
const $ba1d12fd09beb370$export$b19686c1fe99f85a = 'updated';
const $ba1d12fd09beb370$export$4ce67e80878d47ed = 'issue';
const $ba1d12fd09beb370$export$e3d957ccc2d46469 = 'ended';
const $ba1d12fd09beb370$export$3b3e3ac6d7f6e219 = 'add';
const $ba1d12fd09beb370$export$6137e1b2fcde2333 = 'remove';
const $ba1d12fd09beb370$export$6d8c364f9d389764 = 'unknown';
const $ba1d12fd09beb370$export$7d1d20ff891eeb26 = [
    $ba1d12fd09beb370$export$6d8c364f9d389764
];
const $ba1d12fd09beb370$export$403ea87111529de = {
    [(0, $5fc53.ASSIGNEE_TYPE)]: 'singleUserPicker',
    [(0, $5fc53.FIX_VERSIONS_TYPE)]: 'versions',
    [(0, $5fc53.VERSION_CF_TYPE)]: 'versions',
    [(0, $5fc53.ORGANIZATIONS_CF_TYPE)]: 'organizations',
    [(0, $5fc53.SPRINT_TYPE)]: 'link',
    [(0, $5fc53.MULTI_VERSION_CF_TYPE)]: 'multiVersion',
    [(0, $5fc53.TEXT_AREA_CF_TYPE)]: 'richText',
    [(0, $5fc53.TEXT_CF_TYPE)]: 'singleLineText',
    [(0, $5fc53.SELECT_CF_TYPE)]: 'singleSelect',
    [(0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)]: 'checkbox',
    [(0, $5fc53.MULTI_SELECT_CF_TYPE)]: 'multiSelect',
    [(0, $5fc53.USER_CF_TYPE)]: 'singleUser',
    [(0, $5fc53.PEOPLE_CF_TYPE)]: 'multiUser',
    [(0, $5fc53.RADIO_BUTTONS_CF_TYPE)]: 'radio',
    [(0, $5fc53.URL_CF_TYPE)]: 'url',
    [(0, $5fc53.GROUP_CF_TYPE)]: 'singleGroup',
    [(0, $5fc53.MULTI_GROUP_CF_TYPE)]: 'multiGroup'
};
const $ba1d12fd09beb370$export$d8ccf495ccc97a69 = {
    [(0, $5fc53.AFFECTS_VERSIONS_TYPE)]: 'affectsVersions',
    [(0, $5fc53.ASSIGNEE_TYPE)]: 'singleUserPicker',
    [(0, $5fc53.ATTACHMENT_TYPE)]: 'attachment',
    [(0, $5fc53.CASCADING_SELECT_CF_TYPE)]: 'cascadingSelect',
    [(0, $5fc53.COMPONENTS_TYPE)]: 'components',
    [(0, $5fc53.DATE_CF_TYPE)]: 'date',
    [(0, $5fc53.DATETIME_CF_TYPE)]: 'dateTime',
    [(0, $5fc53.DESCRIPTION_TYPE)]: 'richText',
    [(0, $5fc53.DUE_DATE_TYPE)]: 'date',
    [(0, $5fc53.FIX_VERSIONS_TYPE)]: 'fixVersions',
    [(0, $5fc53.FLAGGED_CF_TYPE)]: 'flag',
    [(0, $5fc53.GOALS_CF_TYPE)]: 'goals',
    [(0, $5fc53.GROUP_CF_TYPE)]: 'singleGroup',
    [(0, $5fc53.ISSUE_TYPE)]: 'issuetype',
    [(0, $5fc53.LABELS_CF_TYPE)]: 'labels',
    [(0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)]: 'checkbox',
    [(0, $5fc53.MULTI_GROUP_CF_TYPE)]: 'multiGroup',
    [(0, $5fc53.MULTI_SELECT_CF_TYPE)]: 'multiSelect',
    [(0, $5fc53.MULTI_USER_CF_TYPE)]: 'multiUser',
    [(0, $5fc53.MULTI_VERSION_CF_TYPE)]: 'multiVersion',
    [(0, $5fc53.NUMBER_CF_TYPE)]: 'float',
    [(0, $5fc53.ORGANIZATIONS_CF_TYPE)]: 'organizations',
    [(0, $5fc53.PARENT_TYPE)]: 'parent',
    [(0, $5fc53.PEOPLE_CF_TYPE)]: 'multiUser',
    [(0, $5fc53.PRIORITY_TYPE)]: 'priority',
    [(0, $5fc53.PROJECT_PICKER_CF_TYPE)]: 'project',
    [(0, $5fc53.RADIO_BUTTONS_CF_TYPE)]: 'radio',
    [(0, $5fc53.RANK_CF_TYPE)]: 'rank',
    [(0, $5fc53.START_DATE_TYPE)]: 'date',
    [(0, $5fc53.SELECT_CF_TYPE)]: 'singleSelect',
    [(0, $5fc53.SPRINT_TYPE)]: 'sprint',
    [(0, $5fc53.STATUS_TYPE)]: 'status',
    [(0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE)]: 'storyPointEstimate',
    [(0, $5fc53.STORY_POINTS_TYPE)]: 'storyPointEstimate',
    [(0, $5fc53.SUMMARY_TYPE)]: 'singleLineText',
    [(0, $5fc53.TEAMS_PLATFORM_CF_TYPE)]: 'team',
    [(0, $5fc53.TEXT_AREA_CF_TYPE)]: 'richText',
    [(0, $5fc53.TEXT_CF_TYPE)]: 'singleLineText',
    [(0, $5fc53.TIME_ESTIMATE_TYPE)]: 'originalTimeEstimate',
    [(0, $5fc53.TIME_TRACKING_TYPE)]: 'timeTracking',
    [(0, $5fc53.URL_CF_TYPE)]: 'url',
    [(0, $5fc53.USER_CF_TYPE)]: 'singleUser',
    [(0, $5fc53.VERSION_CF_TYPE)]: 'version',
    [(0, $5fc53.VOTES_TYPE)]: 'votes',
    [(0, $5fc53.WATCHES_TYPE)]: 'watchers'
};
const $ba1d12fd09beb370$export$7d9dd31e187cb2db = {
    WEB_LINK: 'weblink',
    ATTACHMENT: 'attachment',
    ISSUE_LINKS: 'linkIssue',
    PARENT: 'parent'
};

});

parcelRegister("bximr", function(module, exports) {

$parcel$export(module.exports, "getActionTaken", () => $440267fcdb63291a$export$9d814e3464362b48);
$parcel$export(module.exports, "getContextAssigneeIdAndProduct", () => $440267fcdb63291a$export$e6dd41ec8f1794f6);
$parcel$export(module.exports, "getContextProduct", () => $440267fcdb63291a$export$4cb0aa9574634a48);

var $8ikZj = parcelRequire("8ikZj");
const $440267fcdb63291a$export$9d814e3464362b48 = (oldValId, newValId)=>{
    if (oldValId !== newValId) {
        if (newValId === null) return 0, $8ikZj.ACTION_TAKEN_REMOVE;
        if (oldValId === null || oldValId === undefined) return 0, $8ikZj.ACTION_TAKEN_ADD;
    }
    return undefined;
};
const $440267fcdb63291a$export$e6dd41ec8f1794f6 = (context)=>{
    let assigneeId;
    let product;
    for (const item of context){
        if (item?.attributes?.assigneeId) assigneeId = item.attributes.assigneeId;
        if (item?.attributes?.previousSubProduct) product = item.attributes.previousSubProduct;
        if (assigneeId && product) break;
    }
    return {
        assigneeId: assigneeId,
        product: product
    };
};
const $440267fcdb63291a$export$4cb0aa9574634a48 = (context)=>{
    for (const item of context){
        if (item?.attributes?.previousSubProduct) return item.attributes.previousSubProduct;
    }
};

});






parcelRegister("hULKg", function(module, exports) {

$parcel$export(module.exports, "GENERIC_FORGE_USE_PRODUCT_MODALS", () => $62659eb193cd5c9c$export$a05673a22505d5ee);
$parcel$export(module.exports, "GENERIC_GLOBAL_CREATE_BUTTON", () => $62659eb193cd5c9c$export$c78d329777576aa0);
$parcel$export(module.exports, "MOBILE_GLOBAL_CREATE_BUTTON", () => $62659eb193cd5c9c$export$992ab052fd10f8e8);
$parcel$export(module.exports, "GENERIC_KEYBOARD_SHORTCUT", () => $62659eb193cd5c9c$export$affdc3af7a9a4677);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_ISSUE_IN_EPIC", () => $62659eb193cd5c9c$export$7e9cfd1f59e60910);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_SUBTASK", () => $62659eb193cd5c9c$export$708499dcd016e5e9);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_CHILD_ISSUE", () => $62659eb193cd5c9c$export$e1c8789144c4c810);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_SUBTASK", () => $62659eb193cd5c9c$export$c5afabb7a17e802);
$parcel$export(module.exports, "JSW_RELEASES_CREATE_ISSUE", () => $62659eb193cd5c9c$export$2086a63173b79b56);
$parcel$export(module.exports, "JSW_ROADMAP_CREATE_ISSUE", () => $62659eb193cd5c9c$export$fe1e5e4597147709);
$parcel$export(module.exports, "JSW_SECURITY_CREATE_ISSUE", () => $62659eb193cd5c9c$export$9bc326812a93707);
$parcel$export(module.exports, "JSM_CALENDAR_CREATE_CHANGE_REQUEST", () => $62659eb193cd5c9c$export$f352934e06f44599);
$parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_DETAIL", () => $62659eb193cd5c9c$export$6ae07c77acc64360);
$parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_LIST", () => $62659eb193cd5c9c$export$b41d0684e4b6ab1);
$parcel$export(module.exports, "JSM_CREATE_PROBLEM_FROM_INCIDENT_AI", () => $62659eb193cd5c9c$export$1110454816343634);
$parcel$export(module.exports, "JSM_EMPTY_QUEUE_CREATE_REQUEST", () => $62659eb193cd5c9c$export$be9b2b1329ff7ec9);
$parcel$export(module.exports, "JSM_PROJECT_SUMMARY_CREATE_REQUEST", () => $62659eb193cd5c9c$export$bc365eb0775af583);
$parcel$export(module.exports, "JSW_CREATE_ISSUE_DIALOG", () => $62659eb193cd5c9c$export$aa348159181703a0);
$parcel$export(module.exports, "ISSUE_VIEW_CREATE_LINKED_ISSUE", () => $62659eb193cd5c9c$export$f90eec3841adf619);
$parcel$export(module.exports, "COMMAND_PALETTE_CREATE_LINKED_ISSUE", () => $62659eb193cd5c9c$export$718822a309bffada);
$parcel$export(module.exports, "SERVICE_DESK_LINKED_ISSUE_TRIGEER", () => $62659eb193cd5c9c$export$2753dafac81e805c);
$parcel$export(module.exports, "JSW_INCIDENTS_CREATE_JSM_PIR_TRIGGER", () => $62659eb193cd5c9c$export$7c4d5cc5711d9294);
$parcel$export(module.exports, "JPO_DIALOGS_CREATE_ISSUE_TRIGGER", () => $62659eb193cd5c9c$export$998dfc72404b9e14);
$parcel$export(module.exports, "JSW_ADAPTED_GLOBAL_ISSUE_CREATE", () => $62659eb193cd5c9c$export$fc180a4b5785d2f4);
$parcel$export(module.exports, "JSW_CREATE_EPIC_ISSUE", () => $62659eb193cd5c9c$export$946ec0b21cb84fd0);
$parcel$export(module.exports, "CREATE_ISSUE_ACTIVE_SPRINT_EMPTY_VIEW", () => $62659eb193cd5c9c$export$5b97e2844e620e54);
$parcel$export(module.exports, "CREATE_SUBTASK_NIN_TRIGGER", () => $62659eb193cd5c9c$export$b99842c2cf46f6be);
$parcel$export(module.exports, "TRIGGER_POINT_KEY_NOT_DEFINED", () => $62659eb193cd5c9c$export$8d987f6e80b74000);
$parcel$export(module.exports, "ISSUE_PARENT_SWITCHER_FIELD_CREATE_ISSUE", () => $62659eb193cd5c9c$export$8de9fa43731c4b5b);
$parcel$export(module.exports, "POLARIS_CREATE_DELIVERY_ISSUE", () => $62659eb193cd5c9c$export$87249ccbfd10fb78);
$parcel$export(module.exports, "HOME_PAGE_DEFAULT_OPEN_GIC", () => $62659eb193cd5c9c$export$c0eeeb31d264de76);
$parcel$export(module.exports, "ISSUE_CREATE_EMBEDDABLE_TRIGGER", () => $62659eb193cd5c9c$export$f546e18e46478c84);
$parcel$export(module.exports, "DEVELOPER_ESCALATIONS_ISSUE_CREATE_TRIGGER", () => $62659eb193cd5c9c$export$1784e634ba79f1f9);
$parcel$export(module.exports, "JWM_INLINE_CREATE", () => $62659eb193cd5c9c$export$145eb8935a34e85e);
$parcel$export(module.exports, "POLARIS_GLOBAL_SUBMIT_IDEA_SWITCH_PROJECTS_TRIGGER", () => $62659eb193cd5c9c$export$32648b574a536c8b);
$parcel$export(module.exports, "JIRA_ISSUE_COMMENT", () => $62659eb193cd5c9c$export$220cd7b39e0b57a);
$parcel$export(module.exports, "JIRA_INBOX_CREATE_WORK_ITEM", () => $62659eb193cd5c9c$export$ab926dced0f69c1e);
$parcel$export(module.exports, "ALLOWED_EXTERNAL_CONTROLS", () => $62659eb193cd5c9c$export$c0e2ab74dfaa67cc);
$parcel$export(module.exports, "LIST_OF_CHILD_ISSUES_TRIGGER_POINTS", () => $62659eb193cd5c9c$export$7a8328e1f8bd992b);
const $62659eb193cd5c9c$export$a05673a22505d5ee = 'forge-open-issue-create';
const $62659eb193cd5c9c$export$c78d329777576aa0 = 'global-create-button';
const $62659eb193cd5c9c$export$992ab052fd10f8e8 = 'mobile-global-create-button';
const $62659eb193cd5c9c$export$affdc3af7a9a4677 = 'keyboard-shortcut';
const $62659eb193cd5c9c$export$7e9cfd1f59e60910 = 'jsw-issue-view-create-issue-in-epic';
const $62659eb193cd5c9c$export$708499dcd016e5e9 = 'jsw-issue-view-create-subtask';
const $62659eb193cd5c9c$export$e1c8789144c4c810 = 'jsw-issue-view-ai-breakdown-child-issue';
const $62659eb193cd5c9c$export$c5afabb7a17e802 = 'jsw-issue-view-ai-breakdown-subtask';
const $62659eb193cd5c9c$export$2086a63173b79b56 = 'jsw-releases-create-issue';
const $62659eb193cd5c9c$export$fe1e5e4597147709 = 'jsw-roadmap-create-issue';
const $62659eb193cd5c9c$export$9bc326812a93707 = 'jsw-security-create-issue';
const $62659eb193cd5c9c$export$f352934e06f44599 = 'jsm-calendar-create-change-request';
const $62659eb193cd5c9c$export$6ae07c77acc64360 = 'jsm-create-incident-from-alert-detail';
const $62659eb193cd5c9c$export$b41d0684e4b6ab1 = 'jsm-create-incident-from-alert-list';
const $62659eb193cd5c9c$export$1110454816343634 = 'jsm-create-problem-from-incident-ai';
const $62659eb193cd5c9c$export$be9b2b1329ff7ec9 = 'jsm-empty-queue-create-request';
const $62659eb193cd5c9c$export$bc365eb0775af583 = 'jsm-project-summary-create-request';
const $62659eb193cd5c9c$export$235b856f54db8916 = 'jwm-board-create-issue';
const $62659eb193cd5c9c$export$ebbb81a0a3406bcb = 'jwm-calendar-create-issue';
const $62659eb193cd5c9c$export$8e135b62470e5f9a = 'jwm-list-create-issue';
const $62659eb193cd5c9c$export$21ea58e7361c33ba = 'jwm-list-create-subtask';
const $62659eb193cd5c9c$export$d2cf44b8c67cca33 = 'jwm-timeline-create-issue';
const $62659eb193cd5c9c$export$894285d6d13375fd = 'jwm-timeline-create-subtask';
const $62659eb193cd5c9c$export$aa348159181703a0 = 'software-create-issue-dialog';
const $62659eb193cd5c9c$export$f90eec3841adf619 = 'create-linked-issue-issue-view';
const $62659eb193cd5c9c$export$718822a309bffada = 'create-linked-issue-command-palette';
const $62659eb193cd5c9c$export$2753dafac81e805c = 'service-desk-linked-issue-trigger';
const $62659eb193cd5c9c$export$7c4d5cc5711d9294 = 'jsw-incidents-create-jsm-pir-trigger';
const $62659eb193cd5c9c$export$6eb7318fea2f8ce0 = 'jsw-incidents-create-issue-trigger';
const $62659eb193cd5c9c$export$998dfc72404b9e14 = 'jpo-dialogs-jira-create-issue';
const $62659eb193cd5c9c$export$fc180a4b5785d2f4 = 'jsw-adapted-global-issue-create-trigger';
const $62659eb193cd5c9c$export$946ec0b21cb84fd0 = 'jsw-create-epic-issue';
const $62659eb193cd5c9c$export$dba86c91ec4fdbf0 = 'create-issue-backlog-trigger';
const $62659eb193cd5c9c$export$b5cdfd7f3bb79a7 = 'create-epic-issue-backlog-trigger';
const $62659eb193cd5c9c$export$a8199da3cfab0e8 = 'create-issue-in-epic-backlog-trigger';
const $62659eb193cd5c9c$export$5b97e2844e620e54 = 'create-issue-active-sprint-empty-view-trigger';
const $62659eb193cd5c9c$export$569f5ff8afa08896 = 'create-linked-issue-issue-navigator-trigger';
const $62659eb193cd5c9c$export$bafd52474e9ff4e = 'jwm-summary-create-first-issue-trigger';
const $62659eb193cd5c9c$export$87f86192eaf0fdf = 'create-subtask-issue-navigator-trigger';
const $62659eb193cd5c9c$export$b99842c2cf46f6be = 'create-subtask-new-issue-navigator-trigger';
const $62659eb193cd5c9c$export$1e467d0a3f53a410 = 'jwm-board-embed-issue-create';
const $62659eb193cd5c9c$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $62659eb193cd5c9c$export$867e9a641a3c1457 = 'jwm-list-embed-issue-create';
const $62659eb193cd5c9c$export$8de9fa43731c4b5b = 'issue-parent-switcher-field-create-issue';
const $62659eb193cd5c9c$export$87249ccbfd10fb78 = 'polaris-create-delivery-issue';
const $62659eb193cd5c9c$export$c0eeeb31d264de76 = 'home-page-default-open-gic';
const $62659eb193cd5c9c$export$f546e18e46478c84 = 'issue-create-embed-trigger';
const $62659eb193cd5c9c$export$1784e634ba79f1f9 = 'developer-escalations-issue-create-trigger';
const $62659eb193cd5c9c$export$145eb8935a34e85e = 'jwm-inline-create';
const $62659eb193cd5c9c$export$32648b574a536c8b = 'polaris-global-submit-idea-switch-project-trigger';
const $62659eb193cd5c9c$export$818f24c6c32e18a = 'jira-calendar-create-issue';
const $62659eb193cd5c9c$export$220cd7b39e0b57a = 'jira-issue-comment';
const $62659eb193cd5c9c$export$ab926dced0f69c1e = 'jira-inbox-create-work-item';
const $62659eb193cd5c9c$export$c0e2ab74dfaa67cc = {
    FIELD_IDS: [
        'description'
    ],
    TRIGGER_POINTS: [
        'service-desk-gen-ai-pir'
    ]
};
const $62659eb193cd5c9c$export$7a8328e1f8bd992b = [
    $62659eb193cd5c9c$export$7e9cfd1f59e60910,
    $62659eb193cd5c9c$export$708499dcd016e5e9,
    $62659eb193cd5c9c$export$e1c8789144c4c810,
    $62659eb193cd5c9c$export$c5afabb7a17e802
];

});

parcelRegister("5rzqz", function(module, exports) {

$parcel$export(module.exports, "useTriggerIssueCreateModal", () => $0a31d64d52b4b5e9$export$71e0eb7b8a91a156);
$parcel$export(module.exports, "useOpenIssueCreateModal", () => $0a31d64d52b4b5e9$export$47cf258b1046080b);
$parcel$export(module.exports, "withNewGICProvider", () => $0a31d64d52b4b5e9$export$558a195c5bfe3787);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $1Nspv = parcelRequire("1Nspv");

var $bGrWH = parcelRequire("bGrWH");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $f5nIZ = parcelRequire("f5nIZ");

var $2YP9W = parcelRequire("2YP9W");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

var $4R6GH = parcelRequire("4R6GH");

var $hULKg = parcelRequire("hULKg");

var $cKWWX = parcelRequire("cKWWX");

var $6k7U1 = parcelRequire("6k7U1");
const $0a31d64d52b4b5e9$export$d4c72bab9d6cc13a = {
    inProgressIssueID: undefined,
    isModalOpen: false,
    isSubsequentLoad: false,
    // isSubTaskCreationOpen is used for creating subtasks with new GIC
    isSubTaskCreationOpen: false,
    // isCreateLinkedIssue is used for creating linked issues with new GIC
    isCreateLinkedIssue: false,
    wasStateRestored: false,
    // payload can be used to control the initial values displayed in the GIC Modal
    payload: null,
    // id for the GIC Modal component
    id: 'create-issue-dialog',
    // title for the GIC modal
    title: null,
    // sectionMessage is used to show an info banner at the top of the GIC modal
    sectionMessage: null,
    // submitErrorMessage is used to show an error banner at the top of the GIC modal
    submitErrorMessage: undefined,
    // globalEventNamespaces is the list of event namespaces to which data of created issues will be published
    globalEventNamespaces: [
        (0, $bGrWH.GLOBAL_EVENT_NAMESPACE)
    ],
    // fieldsToAddInPublishedData: list of additioanl fields that should be appended in the data published for
    // created issues. By default we publish summary, status, assignee, duedate, project, issuetype & priority
    fieldsToAddInPublishedData: [],
    // Used on Create Incident from Alerts functionality. Only relevant for Opsgenie alert pages
    alertsToBeLinked: undefined,
    // if onIssueCreate is passed for every issue created in the session onIssueCreate is called with
    // the data of each issue created
    onIssueCreate: null,
    onClose: null,
    // onSiteSelection is called when a site is selected in the site picker
    onSiteSelection: null,
    // onProjectSelection is called when a project is selected in the project picker
    onProjectSelection: null,
    // only show required fields
    displayOnlyRequiredFields: false,
    // disables the success flag
    disableCreationSuccessFlag: false,
    // toggle the 'create another issue' checkbox
    displayCreateAnotherIssueToggle: true,
    // toggle display of site picker field.
    displaySitePicker: false,
    // do not allow user to change issue project
    disableProjectDropdown: false,
    // do not allow user to change issue type
    disableIssueTypeDropdown: false,
    // triggerPoinKey can be used to identify specific trigger point of new GIC
    triggerPointKey: (0, $hULKg.TRIGGER_POINT_KEY_NOT_DEFINED),
    // context can be used to pass data like rank/board data which will be used as payload for issue creation
    context: undefined,
    // the view state for the minimizable modal
    minimizableModalView: 'modal',
    // the modal view maybe persistent depending on conditions, if this value is present, it may override the `minimizableModalView` during `openIssueCreateModal`.
    persistentModalView: undefined,
    // whether we should display mini modal by default for the first time. If this is true, it will override the view state to `mini` during `openIssueCreateModal`.
    shouldPushMiniModalDiscoverability: undefined,
    // whether we should display mini modal spotlight for the first time.
    shouldShowMiniModalSpotlight: undefined,
    // modal was attempted to be opened when already opened
    wasModalRetriggered: false,
    // if there is an existing gic open - we only apply the next state if they discard their current issue
    openIssueCreateModalNextState: {},
    // when an issue is discarded we will reinitialise the gic modal
    shouldInitFetchConfig: false,
    interactedWithModalChangerButtons: false,
    // open modal for the jql board trigger point
    isModalLoadInContext: false,
    // opt-out of the minimizable GIC modal
    disableMinimizableModal: false,
    // switch to control the hide and display of minimizable buttons
    displayMinimizableButtons: true,
    // switch to control the hide and display of header action container
    displayHeaderActionContainer: true,
    // do not override "use request type fields" toggle state
    overrideUseRequestTypeFieldsToggleState: undefined,
    /**
	 * this is for applying the container styles on the GIC containers except modal view
	 */ containerStyle: {},
    // this flag is for enable the minidesign for a trigger point without being in mini view
    isMiniDesignEnabled: false,
    // this flag is for the GIC multiple layout experiment by Makkuro
    isEnrolledAndTargetedForGicMultipleLayouts: false,
    // optional sessionId used for the current issue creation session
    sessionId: undefined,
    // optional component - when supplied, this wraps every field as children within the GIC modal
    FieldWrapperComponent: undefined,
    // optional component - Renders external component above form fields
    ExternalControls: undefined,
    // Analytics property for board with custom filter and icc enabled
    isCustomBoardWithIcc: false,
    // optional ID of the jql swimlane we are creating issues in
    jqlSwimlaneId: undefined,
    // Analytics property for board with swimlane enabled
    swimlaneMode: undefined,
    // prefilled custom Fields if any
    prefilledCustomFields: {},
    // callback for ecosystem API to execute
    ecosystemCallback: undefined,
    // product where issue create anywhere modal is used
    product: undefined,
    // what's the consumer of the issue create anywhere modal in a product
    actionSource: undefined,
    // Field IDs that will remain visible even when the smart fields feature recommends them to be hidden.
    optOutSmartFieldIds: undefined,
    // refrence of the button from where GIC modal is triggered
    triggerButtonRef: null
};
const $0a31d64d52b4b5e9$export$e324594224ef24da = {
    restoreState: (stateToRestore)=>({ setState: setState, getState: getState })=>{
            const { isSubsequentLoad: isSubsequentLoad, isModalOpen: isModalOpen } = getState();
            if (!isModalOpen && stateToRestore.isModalOpen) (0, $6k7U1.startGlobalIssueCreateMetrics)(isSubsequentLoad);
            setState(stateToRestore);
        },
    openIssueCreateModal: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isModalOpen) /* If there is an existing gic open then we will defer the state change to prevent
                       clashing with the issue in creation. */ setState({
                wasModalRetriggered: true,
                openIssueCreateModalNextState: nextState
            });
            else {
                (0, $6k7U1.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
                const isDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $6k7U1.isPartOfDiscoverabilityTriggers)(nextState?.triggerPointKey);
                const nextModalView = isDiscoverabilityPushEnabled ? (0, $6k7U1.getNextModalView)(isDiscoPushTriggerPoint, currentState.persistentModalView, $0a31d64d52b4b5e9$export$d4c72bab9d6cc13a.minimizableModalView) : 'modal';
                if ((0, $4R6GH.fg)('fix-gryf-a11y-issues')) {
                    /*
					 * This is done to always focus the Issue Create Modal trigger button whenever it's clicked
					 * so that we can store the reference of this
					 * and use that to re-focus the button whenever the modal is closed
					 */ let triggerButton;
                    const handleButtonClick = (event)=>{
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        const triggerButtonTarget = event.target;
                        triggerButton = triggerButtonTarget?.closest('button');
                        triggerButton?.focus();
                    };
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    document.addEventListener('click', handleButtonClick);
                    setTimeout(()=>{
                        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                        document.removeEventListener('click', handleButtonClick);
                    }, 0);
                    setTimeout(()=>{
                        setState({
                            ...$0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
                            ...isDiscoverabilityPushEnabled && {
                                minimizableModalView: nextModalView,
                                persistentModalView: currentState.persistentModalView,
                                ...(0, $6k7U1.discoverabilityPushModalViewOverride)(currentState.shouldPushMiniModalDiscoverability, isDiscoPushTriggerPoint, nextModalView)
                            },
                            inProgressIssueID: (0, $7Jxgt.v4)(),
                            isSubsequentLoad: currentState.isSubsequentLoad,
                            isModalOpen: true,
                            wasModalRetriggered: currentState.isModalOpen,
                            ...(0, $4R6GH.fg)('quick_actions_with_hotkeys_ga') ? {
                                triggeredViaHotKey: !!nextState?.triggeredViaHotKey
                            } : {},
                            ...nextState,
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
                            triggerButtonRef: triggerButton || document.activeElement
                        });
                    }, 0);
                } else setState({
                    ...$0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
                    ...isDiscoverabilityPushEnabled && {
                        minimizableModalView: nextModalView,
                        persistentModalView: currentState.persistentModalView,
                        ...(0, $6k7U1.discoverabilityPushModalViewOverride)(currentState.shouldPushMiniModalDiscoverability, isDiscoPushTriggerPoint, nextModalView)
                    },
                    inProgressIssueID: (0, $7Jxgt.v4)(),
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: currentState.isModalOpen,
                    ...(0, $4R6GH.fg)('quick_actions_with_hotkeys_ga') ? {
                        triggeredViaHotKey: !!nextState?.triggeredViaHotKey
                    } : {},
                    ...nextState
                });
            }
        },
    closeIssueCreateModal: (hasIssueCreated)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
            const isValidDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $6k7U1.isPartOfDiscoverabilityTriggers)(currentState.triggerPointKey);
            const shouldUpdatePersistentModalView = isDiscoverabilityPushEnabled && hasIssueCreated && isValidDiscoPushTriggerPoint;
            const shouldPersistDiscoverabilityState = isDiscoverabilityPushEnabled && currentState.shouldPushMiniModalDiscoverability && !isValidDiscoPushTriggerPoint;
            setState({
                ...$0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
                callbackPayload: undefined,
                ...shouldPersistDiscoverabilityState && {
                    shouldPushMiniModalDiscoverability: true
                },
                ...isDiscoverabilityPushEnabled && {
                    persistentModalView: currentState.persistentModalView
                },
                ...shouldUpdatePersistentModalView && {
                    persistentModalView: currentState.minimizableModalView === 'mini' ? 'mini' : 'modal'
                },
                isModalOpen: false,
                isSubsequentLoad: true
            });
            (0, $1Nspv.CreateIssueUFOExperience).abort({
                metadata: {
                    wasStateRestored: getState().wasStateRestored
                }
            });
        },
    clearSectionMessage: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                sectionMessage: null
            });
        },
    setDisplayOnlyRequiredFields: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                displayOnlyRequiredFields: nextState
            });
        },
    setMinimizableModalView: (minimizableModalView)=>({ setState: setState })=>{
            setState({
                minimizableModalView: minimizableModalView,
                interactedWithModalChangerButtons: true
            });
        },
    resetWasModalRetriggered: (applyNextState = false)=>({ setState: setState, getState: getState })=>{
            if (applyNextState) {
                const currentState = getState();
                (0, $6k7U1.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...$0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
                    ...!currentState.isEnrolledAndTargetedForGicMultipleLayouts && {
                        persistentModalView: currentState.persistentModalView
                    },
                    inProgressIssueID: currentState.inProgressIssueID,
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: false,
                    minimizableModalView: 'modal',
                    openIssueCreateModalNextState: {},
                    shouldInitFetchConfig: true,
                    ...currentState.openIssueCreateModalNextState
                });
            } else setState({
                minimizableModalView: 'modal',
                wasModalRetriggered: false,
                openIssueCreateModalNextState: {}
            });
        },
    resetShouldInitFetchConfig: ()=>({ setState: setState })=>{
            setState({
                shouldInitFetchConfig: false
            });
        },
    setCallbackPayload: (callbackPayload)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                callbackPayload: {
                    id: currentState.callbackPayload?.id ?? '',
                    data: callbackPayload
                }
            });
        },
    setShouldPushMiniModalDiscoverability: (shouldPushMiniModalDiscoverability)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldPushMiniModalDiscoverability: shouldPushMiniModalDiscoverability
            });
        },
    dismissModalSpotlight: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldShowMiniModalSpotlight: false
            });
        },
    setPersistentModalView: (persistentModalView)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                persistentModalView: persistentModalView
            });
        },
    removeAlertFromAlertsToBeLinked: (alertId)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const alertsToBeLinked = currentState.alertsToBeLinked?.filter((entry)=>entry !== alertId);
            setState({
                alertsToBeLinked: alertsToBeLinked
            });
        },
    setSessionId: (sessionId)=>({ setState: setState })=>{
            setState({
                sessionId: sessionId
            });
        }
};
const $0a31d64d52b4b5e9$var$store = (0, $iXqE5.createStore)({
    name: 'issue-create.issue-create-form.use-trigger-issue-create-modal',
    initialState: $0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
    actions: $0a31d64d52b4b5e9$export$e324594224ef24da
});
const $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalState = (0, $3sQ5x.createStateHook)($0a31d64d52b4b5e9$var$store);
const $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalActions = (0, $3sQ5x.createActionsHook)($0a31d64d52b4b5e9$var$store);
const $0a31d64d52b4b5e9$export$71e0eb7b8a91a156 = ()=>{
    const createState = $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalState();
    const createActions = $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { openIssueCreateModal: openIssueCreateModal, ...otherActions } = createActions;
    const openIssueCreateModalWithAnalytics = (0, $5uXOq.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey,
            ...nextState?.product ? {
                product: nextState.product
            } : {},
            ...nextState?.actionSource ? {
                actionSource: nextState.actionSource
            } : {}
        };
        (0, $8zOmE.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal
    ]);
    return [
        createState,
        {
            ...otherActions,
            openIssueCreateModal: openIssueCreateModalWithAnalytics
        }
    ];
};
const $0a31d64d52b4b5e9$export$47cf258b1046080b = ()=>{
    const { openIssueCreateModal: openIssueCreateModal } = $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [, { setSitePickerState: setSitePickerState }] = (0, $cKWWX.useSitePickerContext)();
    return (0, $5uXOq.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey,
            ...nextState?.product ? {
                product: nextState.product
            } : {},
            ...nextState?.actionSource ? {
                actionSource: nextState.actionSource
            } : {}
        };
        (0, $8zOmE.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        // overrideCloudId only used for embedded GIC
        if (nextState?.payload?.overrideCloudId) // set cloudId inside the state if there's an override
        setSitePickerState({
            selectedCloudId: nextState?.payload?.overrideCloudId
        });
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal,
        setSitePickerState
    ]);
};
const $0a31d64d52b4b5e9$export$4c674fe824b8f278 = (0, $51nlc.createSubscriber)($0a31d64d52b4b5e9$var$store);
function $0a31d64d52b4b5e9$export$558a195c5bfe3787(WrappedComponent) {
    return (props)=>{
        const [, { openIssueCreateModal: openIssueCreateModal, closeIssueCreateModal: closeIssueCreateModal }] = $0a31d64d52b4b5e9$export$71e0eb7b8a91a156();
        const { data: data } = (0, $2YP9W.useResource)((0, $f5nIZ.gicOptInStatusResources));
        const currentIssueCreateVisibility = data && data?.gicOptInStatus;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            openIssueCreateModal: openIssueCreateModal,
            closeIssueCreateModal: closeIssueCreateModal,
            currentIssueCreateVisibility: currentIssueCreateVisibility?.isEnabled || false,
            ...props
        });
    };
}

});
parcelRegister("1Nspv", function(module, exports) {

$parcel$export(module.exports, "CreateIssueUFOExperience", () => $ff7fb599b8d98642$export$cd75c112ac11a83b);
$parcel$export(module.exports, "EditIssueTypeUFOExperience", () => $ff7fb599b8d98642$export$7d25d25bed94d6e2);
$parcel$export(module.exports, "CreateIssueTypeUFOExperience", () => $ff7fb599b8d98642$export$fda88e8e14acb615);
$parcel$export(module.exports, "StatusFieldLoad", () => $ff7fb599b8d98642$export$e890e797a25e655c);
$parcel$export(module.exports, "GlobalIssueCreateModalSubmitUFOExperience", () => $ff7fb599b8d98642$export$70208657c8d471a7);
$parcel$export(module.exports, "EcosystemAPIPrefillingUFOExperience", () => $ff7fb599b8d98642$export$b2d8f8edec75f571);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
const $ff7fb599b8d98642$export$cd75c112ac11a83b = new (0, $duUGa.UFOExperience)('global-issue-create.create-issue', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
    category: 'global-issue-create.create-issue'
});
const $ff7fb599b8d98642$export$7d25d25bed94d6e2 = new (0, $duUGa.UFOExperience)('global-issue-create.create-issue.issue-type-field.edit-issue-type', {
    type: (0, $atdLB.ExperienceTypes).Operation,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom
});
const $ff7fb599b8d98642$export$fda88e8e14acb615 = new (0, $duUGa.UFOExperience)('global-issue-create.create-issue.issue-type-field.create-issue-type', {
    type: (0, $atdLB.ExperienceTypes).Operation,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom
});
const $ff7fb599b8d98642$export$e890e797a25e655c = new (0, $duUGa.UFOExperience)('global-issue-create.create-issue.status-field', {
    type: (0, $atdLB.ExperienceTypes).Load,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad
});
const $ff7fb599b8d98642$export$70208657c8d471a7 = new (0, $duUGa.UFOExperience)('modern-global-issue-create.modal.issue-submit', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
    category: 'modern-global-issue-create.modal.issue-submit'
});
const $ff7fb599b8d98642$export$b2d8f8edec75f571 = new (0, $duUGa.UFOExperience)('ecosystem-api-new-gic-prefilling', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
    category: 'ecosystem-api-new-gic-prefilling'
});

});

parcelRegister("bGrWH", function(module, exports) {

$parcel$export(module.exports, "REQUIRED", () => $4aabf2a0e09eb856$export$b1c05b34d317c074);
$parcel$export(module.exports, "FORM_DROPZONE_CONTAINER_ID", () => $4aabf2a0e09eb856$export$1a020bd73f33e5a);
$parcel$export(module.exports, "MINIMISED_DROPZONE_CONTAINER_ID", () => $4aabf2a0e09eb856$export$9eadc594a5383580);
$parcel$export(module.exports, "LOG_WORK_TIME_SPENT_ERROR_KEY", () => $4aabf2a0e09eb856$export$a1a7caa1e4a73c9f);
$parcel$export(module.exports, "LOG_WORK_TIME_REMAINING_ERROR_KEY", () => $4aabf2a0e09eb856$export$cf70f9220e6a2f50);
$parcel$export(module.exports, "LOG_WORK_DATE_ERROR_KEY", () => $4aabf2a0e09eb856$export$aac4661200ba4104);
$parcel$export(module.exports, "LOG_WORK_DESCRIPTION_ERROR_KEY", () => $4aabf2a0e09eb856$export$a23c32d5cf54cba0);
$parcel$export(module.exports, "COMMON_LOG_WORK_ERROR_KEYS", () => $4aabf2a0e09eb856$export$74ab3898ae683660);
$parcel$export(module.exports, "MULTI_INPUT_FIELDS_ERROR_KEYS", () => $4aabf2a0e09eb856$export$983715bb9b0f9b2c);
$parcel$export(module.exports, "DEFAULT_SCROLL_OPTIONS", () => $4aabf2a0e09eb856$export$40f6793dd75f4e52);
$parcel$export(module.exports, "UNSUPPORTED_FIELD_TYPES_IN_GIC", () => $4aabf2a0e09eb856$export$3bf5bce483cc2c30);
$parcel$export(module.exports, "ISSUE_CREATE_TYPE", () => $4aabf2a0e09eb856$export$30cc1fd33e7c7258);
$parcel$export(module.exports, "GLOBAL_EVENT_NAMESPACE", () => $4aabf2a0e09eb856$export$8170252f0ea43511);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

const $4aabf2a0e09eb856$export$17bcab948893a9ba = 'worklog';
const $4aabf2a0e09eb856$export$b1c05b34d317c074 = 'REQUIRED';
const $4aabf2a0e09eb856$export$f10b32dfda12e96e = 'unknown';
const $4aabf2a0e09eb856$export$e5e4b8c32e68dd0b = 'networkError';
const $4aabf2a0e09eb856$export$2d06efb8146cd043 = 'graphQLError';
const $4aabf2a0e09eb856$export$1a020bd73f33e5a = 'issue-create-modal-dropzone-container';
const $4aabf2a0e09eb856$export$9eadc594a5383580 = 'minimised-issue-create-dropzone-container';
const $4aabf2a0e09eb856$export$a1a7caa1e4a73c9f = 'worklog_timeLogged';
const $4aabf2a0e09eb856$export$cf70f9220e6a2f50 = 'worklog_newEstimate';
const $4aabf2a0e09eb856$export$aac4661200ba4104 = 'worklog_startDate';
const $4aabf2a0e09eb856$export$a23c32d5cf54cba0 = 'worklog_description';
const $4aabf2a0e09eb856$export$74ab3898ae683660 = [
    'worklog_adjustmentAmount',
    'worklog_adjustEstimate',
    'worklog_activate'
];
const $4aabf2a0e09eb856$export$63fd567c1d0aca19 = [
    ...$4aabf2a0e09eb856$export$74ab3898ae683660,
    $4aabf2a0e09eb856$export$a1a7caa1e4a73c9f,
    $4aabf2a0e09eb856$export$cf70f9220e6a2f50,
    $4aabf2a0e09eb856$export$aac4661200ba4104,
    $4aabf2a0e09eb856$export$a23c32d5cf54cba0
];
const $4aabf2a0e09eb856$export$983715bb9b0f9b2c = {
    [$4aabf2a0e09eb856$export$17bcab948893a9ba]: $4aabf2a0e09eb856$export$63fd567c1d0aca19
};
const $4aabf2a0e09eb856$export$40f6793dd75f4e52 = {
    behavior: 'auto',
    scrollMode: 'if-needed',
    block: 'start'
};
const $4aabf2a0e09eb856$export$3bf5bce483cc2c30 = [
    'com.atlassian.servicedesk:sd-request-participants'
];
const $4aabf2a0e09eb856$export$30cc1fd33e7c7258 = {
    linkedIssue: 'LINKED_ISSUE_CREATE',
    standard: 'STANDARD'
};
const $4aabf2a0e09eb856$export$8170252f0ea43511 = 'QuickCreateIssue';

});

parcelRegister("cKWWX", function(module, exports) {

$parcel$export(module.exports, "useSitePickerContext", () => $c8055d212e869a3c$export$f8b5aae013e4cf77);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $c8055d212e869a3c$export$d4c72bab9d6cc13a = {
    selectedCloudId: '',
    siteDomain: ''
};
const $c8055d212e869a3c$export$e324594224ef24da = {
    setSitePickerState: ({ selectedCloudId: selectedCloudId, siteDomain: siteDomain })=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                selectedCloudId: selectedCloudId || '',
                siteDomain: siteDomain || ''
            });
        }
};
const $c8055d212e869a3c$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'issue.fields.site-picker',
    initialState: $c8055d212e869a3c$export$d4c72bab9d6cc13a,
    actions: $c8055d212e869a3c$export$e324594224ef24da
});
const $c8055d212e869a3c$export$f8b5aae013e4cf77 = (0, $3sQ5x.createHook)($c8055d212e869a3c$export$6f57813fe9f31bf9);

});

parcelRegister("6k7U1", function(module, exports) {

$parcel$export(module.exports, "startGlobalIssueCreateMetrics", () => $8a2e4df39a48d5af$export$550b19803bc962ec);
$parcel$export(module.exports, "isPartOfDiscoverabilityTriggers", () => $8a2e4df39a48d5af$export$f6bc17a4d9120156);
$parcel$export(module.exports, "discoverabilityPushModalViewOverride", () => $8a2e4df39a48d5af$export$8d246e5e04f0b424);
$parcel$export(module.exports, "getNextModalView", () => $8a2e4df39a48d5af$export$720579602bb055a2);

var $eTXmK = parcelRequire("eTXmK");

var $1Nspv = parcelRequire("1Nspv");

var $gEaAu = parcelRequire("gEaAu");

var $huY3x = parcelRequire("huY3x");
const $8a2e4df39a48d5af$export$550b19803bc962ec = (isSubsequentLoad)=>{
    (0, $1Nspv.CreateIssueUFOExperience).start();
    const globalIssueCreateModalLoadMetric = isSubsequentLoad ? (0, $gEaAu.globalIssueCreateModalLoadSubsequent) : (0, $gEaAu.globalIssueCreateModalLoad);
    if (isSubsequentLoad) (0, $eTXmK.default)('global-issue.create-modal-subsequent');
    else (0, $eTXmK.default)('global-issue.create-modal');
    globalIssueCreateModalLoadMetric.start();
    (0, $huY3x.startGlobalIssueCreateTTIWithAdjustments)();
};
const $8a2e4df39a48d5af$export$f6bc17a4d9120156 = (triggerPoint)=>{
    if (!triggerPoint) return false;
    const acceptedTriggerPoints = [
        'global-create-button',
        'keyboard-shortcut'
    ];
    return acceptedTriggerPoints.includes(triggerPoint);
};
const $8a2e4df39a48d5af$export$8d246e5e04f0b424 = (shouldPushDiscoverability, isTriggerAccepted, defaultView = 'modal')=>{
    if (!shouldPushDiscoverability) return undefined;
    return {
        minimizableModalView: isTriggerAccepted ? 'mini' : defaultView,
        shouldPushMiniModalDiscoverability: true,
        shouldShowMiniModalSpotlight: isTriggerAccepted
    };
};
const $8a2e4df39a48d5af$export$720579602bb055a2 = (isTriggerAccepted, persistentView, defaultView = 'modal')=>{
    if (isTriggerAccepted) return persistentView || defaultView;
    return defaultView;
};

});
parcelRegister("gEaAu", function(module, exports) {

$parcel$export(module.exports, "globalIssueCreateModalLoad", () => $ee246606338fc99e$export$5a01a7fa84b239c8);
$parcel$export(module.exports, "globalIssueCreateModalLoadSubsequent", () => $ee246606338fc99e$export$c50ad3c31b6fcfc6);
$parcel$export(module.exports, "successFlagDisplay", () => $ee246606338fc99e$export$4b2382574525bb0f);
$parcel$export(module.exports, "successFlagAddToSprintAction", () => $ee246606338fc99e$export$7839bdaa2f6a2385);
$parcel$export(module.exports, "successFlagClearFiltersAction", () => $ee246606338fc99e$export$c1592e4d8d98963e);

var $dGrdR = parcelRequire("dGrdR");
const $ee246606338fc99e$export$5a01a7fa84b239c8 = (0, $dGrdR.metrics).interaction({
    key: 'global-issue-create-modal'
});
const $ee246606338fc99e$export$c50ad3c31b6fcfc6 = (0, $dGrdR.metrics).interaction({
    key: 'global-issue-create-modal-subsequent'
});
const $ee246606338fc99e$export$4b2382574525bb0f = (0, $dGrdR.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-display'
});
const $ee246606338fc99e$export$7839bdaa2f6a2385 = (0, $dGrdR.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-add-to-sprint-action'
});
const $ee246606338fc99e$export$c1592e4d8d98963e = (0, $dGrdR.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-clear-filters-action'
});

});

parcelRegister("huY3x", function(module, exports) {

$parcel$export(module.exports, "globalIssueCreateTTIWithAdjustments", () => $06c7e44c59602f0c$export$9f3d6f17e1da7874);
$parcel$export(module.exports, "startGlobalIssueCreateTTIWithAdjustments", () => $06c7e44c59602f0c$export$457c9fb71ad5b3a9);
$parcel$export(module.exports, "markGicTti", () => $06c7e44c59602f0c$export$ef664dac649a716c);
$parcel$export(module.exports, "stopTTI", () => $06c7e44c59602f0c$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $06c7e44c59602f0c$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $06c7e44c59602f0c$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $06c7e44c59602f0c$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $06c7e44c59602f0c$export$d86f4868694f2aa7);
/**
 * For issue view, we moved similar constants to view-specific packages.
 * However, for GIC, such a move causes a circular dependency with @atlassian/jira-packages-controllers-use-trigger-issue-create-modal package,
 * since view-specific/gic imports trigger points constants from @atlassian/jira-packages-controllers-use-trigger-issue-create-modal.
 * Therefore, for now, let's keep it here.
 */ 
var $dGrdR = parcelRequire("dGrdR");
const $06c7e44c59602f0c$export$9f3d6f17e1da7874 = (0, $dGrdR.metrics).interaction({
    key: 'global-issue-create-tti-with-adjustments',
    timings: [
        {
            key: 'gic-tti-delta',
            startMark: 'gic-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        },
        {
            key: 'gic-all-fields-tti',
            endMark: 'gic-all-fields-loaded'
        }
    ]
});
const $06c7e44c59602f0c$export$457c9fb71ad5b3a9 = ()=>{
    $06c7e44c59602f0c$export$9f3d6f17e1da7874.start();
};
const $06c7e44c59602f0c$export$ef664dac649a716c = ()=>$06c7e44c59602f0c$export$9f3d6f17e1da7874.mark('gic-tti');
const $06c7e44c59602f0c$export$30ca4c461fab486c = (customData)=>{
    $06c7e44c59602f0c$export$9f3d6f17e1da7874.stop({
        customData: customData
    });
};
const $06c7e44c59602f0c$export$27f2445288b528c = ()=>{
    $06c7e44c59602f0c$export$9f3d6f17e1da7874.cancel();
};
const $06c7e44c59602f0c$export$7a2709fc1e33401a = ()=>{
    $06c7e44c59602f0c$export$9f3d6f17e1da7874.mark('iframe-load');
};
const $06c7e44c59602f0c$export$cf3893335c93e33b = ()=>{
    $06c7e44c59602f0c$export$9f3d6f17e1da7874.mark('fields-registered');
};
const $06c7e44c59602f0c$export$d86f4868694f2aa7 = ()=>{
    $06c7e44c59602f0c$export$9f3d6f17e1da7874.mark('oninit-resolved');
};

});




parcelRegister("1oIjm", function(module, exports) {

$parcel$export(module.exports, "Projects", () => $2e85fb8a2f8503d3$export$ca6fbb51b35e375c);

var $5uXOq = parcelRequire("5uXOq");

var $d40Fj = parcelRequire("d40Fj");

var $bKCrm = parcelRequire("bKCrm");

var $e9QkH = parcelRequire("e9QkH");

var $Mp6qH = parcelRequire("Mp6qH");
const $2e85fb8a2f8503d3$export$90cfe4f15bb50f58 = ({ open: open, close: close, setOnCloseCallback: setOnCloseCallback })=>{
    const [{ canCreateClassicProject: canCreateClassicProject }] = (0, $d40Fj.useCreateProjectPermission)();
    (0, $5uXOq.useEffect)(()=>{
        open && open({
            source: 'navigationNext',
            isNextGen: !canCreateClassicProject
        });
        setOnCloseCallback && setOnCloseCallback(close);
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    return null;
};
const $2e85fb8a2f8503d3$export$ca6fbb51b35e375c = ()=>{
    const [isProjectCreateDrawerOpen, { off: closeProjectCreateDrawer }] = (0, $e9QkH.useSwitchModals)((0, $Mp6qH.MODAL_ID).PROJECT_CREATE);
    if (!isProjectCreateDrawerOpen) return null;
    // ProjectCreateDrawerProvider is in page container/navigaiton
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bKCrm.ProjectCreateDrawerConsumer), null, ({ methods: { open: open, setOnCloseCallback: setOnCloseCallback } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2e85fb8a2f8503d3$export$90cfe4f15bb50f58, {
            open: open,
            close: closeProjectCreateDrawer,
            setOnCloseCallback: setOnCloseCallback
        }));
};

});
parcelRegister("d40Fj", function(module, exports) {

$parcel$export(module.exports, "useCreateProjectPermission", () => $2e786b3606f3b4dc$export$c92733e8f8c1640f);
$parcel$export(module.exports, "useCreateProjectPermissionActions", () => $2e786b3606f3b4dc$export$d2b8d6f60fe99e2a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $kEnf8 = parcelRequire("kEnf8");
const $2e786b3606f3b4dc$var$Store = (0, $iXqE5.createStore)({
    name: 'create-project-permissions',
    initialState: {
        canCreateProject: false,
        canCreateClassicProject: false,
        canCreateNextGenProject: false,
        isFetching: false,
        fetchError: null,
        promise: null,
        hasFetchedOnce: false,
        hasSuccessOnce: false
    },
    actions: $kEnf8.actions
});
const $2e786b3606f3b4dc$export$5a47fbae725b8f2 = (0, $gg7kZ.createContainer)($2e786b3606f3b4dc$var$Store);
const $2e786b3606f3b4dc$export$c92733e8f8c1640f = (0, $3sQ5x.createHook)($2e786b3606f3b4dc$var$Store);
const $2e786b3606f3b4dc$export$d2b8d6f60fe99e2a = (0, $3sQ5x.createHook)($2e786b3606f3b4dc$var$Store, {
    selector: null
});

});
parcelRegister("kEnf8", function(module, exports) {

$parcel$export(module.exports, "actions", () => $005c9d409c181858$export$e324594224ef24da);

var $7f4tk = parcelRequire("7f4tk");
const $005c9d409c181858$export$963556ef97965f0b = async ()=>{
    const url = '/rest/internal/2/projectpermissions';
    const result = await (0, $7f4tk.default)(url);
    return result;
};
const $005c9d409c181858$var$handleFetch = ()=>// @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'getState' implicitly has an 'any' type.
    async ({ setState: setState, getState: getState })=>{
        const { isFetching: isFetching } = getState();
        if (!isFetching) try {
            const result = await $005c9d409c181858$export$963556ef97965f0b();
            setState({
                ...result,
                isFetching: false,
                fetchError: null,
                hasFetchedOnce: true,
                hasSuccessOnce: true
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                canCreateProject: false,
                canCreateClassicProject: false,
                canCreateNextGenProject: false,
                isFetching: false,
                fetchError: error,
                hasFetchedOnce: true
            });
        }
    };
const $005c9d409c181858$export$e324594224ef24da = {
    fetchCreateProjectPermission: ()=>async ({ setState: setState, dispatch: dispatch })=>{
            const promise = dispatch($005c9d409c181858$var$handleFetch());
            setState({
                isFetching: true,
                promise: // @ts-expect-error - TS2322 - Type 'Promise<void>' is not assignable to type 'Promise<undefined>'.
                promise
            });
        }
};

});


parcelRegister("bKCrm", function(module, exports) {

$parcel$export(module.exports, "ProjectCreateDrawerProvider", () => $645a52f2fa143509$export$9a1c5dbd93c42bca);
$parcel$export(module.exports, "ProjectCreateDrawerConsumer", () => $645a52f2fa143509$export$9a8662cd60931de1);
$parcel$export(module.exports, "useProjectCreateDrawer", () => $645a52f2fa143509$export$8172ff4ed0f75a1e);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $58GFP = parcelRequire("58GFP");

var $8YEE2 = parcelRequire("8YEE2");

var $lVJAU = parcelRequire("lVJAU");

var $gL2cg = parcelRequire("gL2cg");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $645a52f2fa143509$var$Context = /*#__PURE__*/ (0, $5uXOq.createContext)({
    data: {
        shouldRenderDrawer: false,
        isOpen: false,
        isNextGen: false,
        showExperienceSelection: true,
        recommendedTemplate: undefined,
        defaultSelectedTemplateKey: '',
        source: '',
        isTemplatePickerOpenInitially: false,
        isImportProjectOpenInitially: false,
        selectedProjectType: null,
        recommendationSessionId: undefined
    },
    methods: {
        open: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        close: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onCreateStarted: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        setOnCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        clearOnCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    }
});
const $645a52f2fa143509$export$839a70d8fbc9d356 = class ProjectCreateDrawerProvider extends (0, $5uXOq.Component) {
    render() {
        const { children: children } = this.props;
        const { isOpen: isOpen, isNextGen: isNextGen, source: source, showExperienceSelection: showExperienceSelection, shouldRenderDrawer: shouldRenderDrawer, recommendedTemplate: recommendedTemplate, defaultSelectedTemplateKey: defaultSelectedTemplateKey, isTemplatePickerOpenInitially: isTemplatePickerOpenInitially, isImportProjectOpenInitially: isImportProjectOpenInitially, selectedProjectType: selectedProjectType, recommendationSessionId: recommendationSessionId } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($645a52f2fa143509$var$Context.Provider, {
            value: {
                data: {
                    isOpen: isOpen,
                    isNextGen: isNextGen,
                    source: source,
                    showExperienceSelection: showExperienceSelection,
                    shouldRenderDrawer: shouldRenderDrawer,
                    recommendedTemplate: recommendedTemplate,
                    defaultSelectedTemplateKey: defaultSelectedTemplateKey,
                    isTemplatePickerOpenInitially: isTemplatePickerOpenInitially,
                    isImportProjectOpenInitially: isImportProjectOpenInitially,
                    selectedProjectType: selectedProjectType,
                    recommendationSessionId: recommendationSessionId
                },
                methods: {
                    open: this.open,
                    close: this.close,
                    onSuccess: this.onSuccess,
                    onCreateStarted: this.onCreateStarted,
                    setOnCloseCallback: this.setOnCloseCallback,
                    clearOnCloseCallback: this.clearOnCloseCallback
                }
            }
        }, children);
    }
    constructor(...args){
        super(...args), this.state = {
            isOpen: false,
            shouldRenderDrawer: false,
            isNextGen: false,
            showExperienceSelection: true,
            recommendedTemplate: undefined,
            defaultSelectedTemplateKey: '',
            source: '',
            isTemplatePickerOpenInitially: false,
            isImportProjectOpenInitially: false,
            selectedProjectType: null,
            recommendationSessionId: undefined,
            onCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onSuccess = (projectKey)=>{
            if (projectKey) {
                this.props.setLocation(projectKey.returnUrl);
                this.close(true);
            } else this.close(false);
        }, // Callback that is called once when the drawer is closed.
        this.setOnCloseCallback = (callback)=>{
            this.setState({
                onCloseCallback: callback
            });
        }, this.clearOnCloseCallback = ()=>{
            this.setState({
                onCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
            });
        }, this.open = (attributes = {})=>{
            // @ts-expect-error - TS2345 - Argument of type '{ isNextGen?: boolean | undefined; showExperienceSelection?: boolean | undefined; recommendedTemplate?: { templateKey: string; isSimplified: boolean; } | undefined; defaultSelectedTemplateKey?: string | undefined; ... 4 more ...; shouldRenderDrawer: true; }' is not assignable to parameter of type 'State | ((prevState: Readonly<State>, props: Readonly<Props>) => State | Pick<State, "source" | "isOpen" | "isNextGen" | ... 5 more ... | "isTemplatePickerOpenInitially"> | null) | Pick<...> | null'.
            this.setState({
                isOpen: true,
                shouldRenderDrawer: true,
                ...attributes
            });
        }, this.close = (projectCreated)=>{
            const callOnCloseCallBack = this.state.source === 'navigationNext' || !projectCreated;
            this.setState({
                isOpen: false,
                isNextGen: false,
                showExperienceSelection: true,
                recommendedTemplate: undefined,
                defaultSelectedTemplateKey: '',
                source: '',
                isTemplatePickerOpenInitially: false,
                isImportProjectOpenInitially: false,
                selectedProjectType: null,
                recommendationSessionId: undefined
            });
            if (callOnCloseCallBack) // Call the added callback
            this.state.onCloseCallback();
        }, this.closeOld = ()=>{
            this.setState({
                isOpen: false,
                isNextGen: false,
                showExperienceSelection: true,
                recommendedTemplate: undefined,
                defaultSelectedTemplateKey: '',
                source: '',
                isTemplatePickerOpenInitially: false,
                selectedProjectType: null,
                recommendationSessionId: undefined
            });
            this.state.onCloseCallback();
        }, this.onCreateStarted = (projectKey, templateKey)=>{
            if ((0, $58GFP.getIsJsmBlankProjectTemplate)(templateKey)) (0, $8YEE2.LazyComponent).preload();
            (0, $gL2cg.clearResourcesAssociatedWithProjectKey)(projectKey);
        };
    }
};
const $645a52f2fa143509$export$9a1c5dbd93c42bca = (props)=>{
    const { push: push } = (0, $lVJAU.useRouterActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($645a52f2fa143509$export$839a70d8fbc9d356, {
        ...props,
        setLocation: push
    });
};
const { Consumer: $645a52f2fa143509$export$9a8662cd60931de1 } = $645a52f2fa143509$var$Context;
$645a52f2fa143509$var$Context.displayName = 'ProjectCreateDrawerConsumer';
const $645a52f2fa143509$export$8172ff4ed0f75a1e = ()=>{
    const projectCreateDrawer = (0, $5uXOq.useContext)($645a52f2fa143509$var$Context);
    if (!projectCreateDrawer) throw new Error('useProjectCreateDrawer must be used within a ProjectCreateDrawerProvider');
    return projectCreateDrawer;
};

});
parcelRegister("8YEE2", function(module, exports) {

$parcel$export(module.exports, "LazyComponent", () => $300188a98a9fded7$export$31f1740ae531af94);
$parcel$export(module.exports, "AsyncProjectBuilderDrawer", () => $300188a98a9fded7$export$54a4eade9eae9473);
$parcel$export(module.exports, "canUseProjectBuilder", () => $300188a98a9fded7$export$ff317c5d87147a19);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $9noxX = parcelRequire("9noxX");

var $kxZPA = parcelRequire("kxZPA");

const $300188a98a9fded7$export$31f1740ae531af94 = (0, $kxZPA.lazy)(()=>(parcelRequire("dvgmP")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/project-builder/src/ui/index.tsx"
});
const $300188a98a9fded7$export$54a4eade9eae9473 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "bundle-async-project-builder",
        packageName: "jira-servicedesk-project-builder",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        fallback: null,
        name: "jsm-project-builder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9noxX.ServiceDeskAnalyticsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($300188a98a9fded7$export$31f1740ae531af94, {
        isOpenInitial: !!props.isOpenInitial,
        ...props
    }))));
const $300188a98a9fded7$export$ff317c5d87147a19 = (isAdmin)=>isAdmin;

});
parcelRegister("9noxX", function(module, exports) {

$parcel$export(module.exports, "ServiceDeskAnalyticsContext", () => $12b9024f66e7ef57$export$ac31f8f3368d6881);

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");

var $4DPZY = parcelRequire("4DPZY");

var $8H3A4 = parcelRequire("8H3A4");
const $12b9024f66e7ef57$export$ac31f8f3368d6881 = ({ useContainerContext: useContainerContext, useServiceDeskAnalyticsContext: useServiceDeskAnalyticsContext, children: children, forceRenderWhileLoading: forceRenderWhileLoading })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const [{ data: containerContextData, loading: containerContextLoading }] = useContainerContext();
    const { data: analyticsContextAttributes, error: analyticsContextError, loading: analyticsContextLoading } = useServiceDeskAnalyticsContext();
    if ((0, $5uXOq.Children).count(children) > 0) {
        const loading = containerContextLoading || analyticsContextLoading;
        const shouldRenderChildren = !loading || loading && forceRenderWhileLoading || !!analyticsContextError;
        if (!shouldRenderChildren) return null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const context = {};
        // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
        if (containerContextData && containerContextData.project) {
            // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
            const { id: id, type: type } = containerContextData.project;
            // containerType and containerId are obsolete - See https://developer.atlassian.com/platform/analytics-pipeline/getting-started/event-types/#glossary-of-terms
            // Also these dont work with screen events. See sendScreenEvent in: https://bitbucket.org/atlassian/analytics-web-client/src/master/src/analyticsWebClient.js
            // However they are kept here to not break any existing usages.
            context.containerType = 'project';
            context.containerId = `${id}`;
            // This is the preferred way to send container data for analytics
            context.containers = {
                project: {
                    id: `${id}`,
                    type: type
                }
            };
            if (analyticsContextAttributes && !analyticsContextError) context.attributes = analyticsContextAttributes;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), context, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
$12b9024f66e7ef57$export$ac31f8f3368d6881.defaultProps = {
    forceRenderWhileLoading: false,
    useServiceDeskAnalyticsContext: (0, $8H3A4.useServiceDeskAnalyticsContext),
    useContainerContext: (0, $4DPZY.useContainerContext)
};

});

parcelRegister("dvgmP", function(module, exports) {

let $9d4addd117970a46$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9d4addd117970a46$var$load("5BNUw"),
    $9d4addd117970a46$var$load("kGAgW"),
    $9d4addd117970a46$var$load("kVX56"),
    $9d4addd117970a46$var$load("ffQaD"),
    $9d4addd117970a46$var$load("kvRbA"),
    $9d4addd117970a46$var$load("kNFvF"),
    $9d4addd117970a46$var$load("3yAl4"),
    $9d4addd117970a46$var$load("76n7a"),
    $9d4addd117970a46$var$load("l253H"),
    $9d4addd117970a46$var$load("jbxE1"),
    $9d4addd117970a46$var$load("7imUH"),
    $9d4addd117970a46$var$load("14MdE")
]).then(()=>parcelRequire('c9lEE'));

});


parcelRegister("gL2cg", function(module, exports) {

$parcel$export(module.exports, "clearResourcesAssociatedWithProjectKey", () => $e1d0138bae1db723$export$c0c81c1828c7638c);

var $jcw0u = parcelRequire("jcw0u");

var $8fYaK = parcelRequire("8fYaK");
const $e1d0138bae1db723$export$c0c81c1828c7638c = (projectKey)=>{
    try {
        const { storeState: storeState } = (0, $8fYaK.getResourceStore)();
        const prevState = storeState.getState();
        storeState.setState({
            ...prevState,
            data: Object.fromEntries(Object.entries(prevState?.data).map(([resourceType, value])=>{
                // This will not clear resources that are keyed with project key as a subset of the key,
                // e.g. `projectKey-${projectKey}` or similar, so those resources may still have stale data.
                const { [projectKey]: _, ...rest } = value;
                return [
                    resourceType,
                    rest
                ];
            }))
        });
    } catch (e) {
        (0, $jcw0u.default)({
            meta: {
                id: 'clearResourcesAssociatedWithProjectKey',
                packageName: 'jiraProjectCreateDrawerContext',
                teamName: 'helix'
            },
            sendToPrivacyUnsafeSplunk: true,
            error: e instanceof Error ? e : new Error('Error occured in clearResourcesAssociatedWithProjectKey')
        });
    }
};

});




parcelRegister("294jg", function(module, exports) {

let $18ffc3dea1a0b4b3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $18ffc3dea1a0b4b3$var$load("9TyqT").then(()=>parcelRequire('6kz4R'));

});

parcelRegister("3dzqg", function(module, exports) {

let $257e103560b6fca4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $257e103560b6fca4$var$load("6nrPD").then(()=>parcelRequire('a8CW2'));

});

parcelRegister("50m1B", function(module, exports) {

let $3a4e09857dc1166e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3a4e09857dc1166e$var$load("jRRNv").then(()=>parcelRequire('7l6f4'));

});

parcelRegister("a0TZk", function(module, exports) {

let $74a55589004a0bf6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $74a55589004a0bf6$var$load("7u7rT").then(()=>parcelRequire('hfEgP'));

});

parcelRegister("emOTQ", function(module, exports) {

let $a75a9a5eab53e108$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a75a9a5eab53e108$var$load("l0ti8").then(()=>parcelRequire('1GckT'));

});

parcelRegister("kS27v", function(module, exports) {

let $f31a7ec9793b15da$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f31a7ec9793b15da$var$load("fMQRw").then(()=>parcelRequire('aUZKu'));

});


parcelRegister("kQm4v", function(module, exports) {

$parcel$export(module.exports, "getIssuesNavigationPaths", () => $85bbb82518fd8ed6$export$a33a4d7b083ee85);
$parcel$export(module.exports, "isIssuesNavPath", () => $85bbb82518fd8ed6$export$f38c22a081278057);
const $85bbb82518fd8ed6$export$a33a4d7b083ee85 = ()=>({
        // Features
        newIssueSearchTransition: '/jira/settings/issues/new-issue-search-transition',
        timeTrackingItem: '/secure/admin/TimeTrackingAdmin.jspa',
        issueLinkingItem: '/secure/admin/ViewLinkTypes!default.jspa',
        // IssueTypes
        issueTypesHierarchyItem: '/jira/settings/issues/issue-hierarchy',
        issueTypesItem: '/jira/settings/issues/issue-types',
        issueTypeSchemesItem: '/jira/settings/issues/issue-type-schemes',
        issueTypesSubTasksItem: '/secure/admin/subtasks/ManageSubTasks.jspa',
        // Workflows
        workflowsItem: '/jira/settings/issues/workflows',
        workflowSchemesItem: '/secure/admin/ViewWorkflowSchemes.jspa',
        // Screens
        screensItem: '/jira/settings/issues/screens',
        screenSchemesItem: '/jira/settings/issues/screen-schemes',
        screensIssueTypeScreenSchemesMenu: '/jira/settings/issues/issue-type-screen-schemes',
        // Fields
        fieldsManagement: '/jira/settings/issues/fields',
        customFieldsItem: '/secure/admin/ViewCustomFields.jspa',
        fieldConfigurationsItem: '/secure/admin/ViewFieldLayouts.jspa',
        fieldConfigurationSchemes: '/secure/admin/ViewFieldLayoutSchemes.jspa',
        // Priorities
        prioritiesItem: '/jira/settings/issues/priorities',
        prioritySchemesItem: '/jira/settings/issues/priority-schemes',
        // Forms
        dataConnectionsItem: '/jira/settings/forms/data-connections',
        // IssueAttributes
        statusesItem: '/secure/admin/ViewStatuses.jspa',
        resolutionsItem: '/secure/admin/ViewResolutions.jspa',
        issueSecuritySchemesItem: '/secure/admin/ViewIssueSecuritySchemes.jspa',
        notificationSchemesItem: '/secure/admin/ViewNotificationSchemes.jspa',
        permissionSchemesItem: '/secure/admin/ViewPermissionSchemes.jspa'
    });
const $85bbb82518fd8ed6$var$getIssuesNavPaths = ()=>{
    return [
        '/jira/settings/issues/new-issue-search-transition',
        '/secure/admin/TimeTrackingAdmin',
        '/secure/admin/ViewLinkTypes',
        '/jira/settings/issues/issue-hierarchy',
        '/jira/settings/issues/issue-types',
        '/jira/settings/issues/issue-type-schemes',
        '/secure/admin/subtasks/ManageSubTasks',
        '/jira/settings/issues/workflows',
        '/secure/admin/ViewWorkflowSchemes',
        '/jira/settings/issues/screens',
        '/jira/settings/issues/screen-schemes',
        '/jira/settings/issues/issue-type-screen-schemes',
        '/jira/settings/issues/fields',
        '/secure/admin/ViewCustomFields',
        '/secure/admin/ViewFieldLayouts',
        '/secure/admin/ViewFieldLayoutSchemes',
        '/jira/settings/issues/priorities',
        '/jira/settings/issues/priority-schemes',
        '/secure/admin/ViewStatuses',
        '/secure/admin/ViewResolutions',
        '/secure/admin/ViewIssueSecuritySchemes',
        '/secure/admin/ViewNotificationSchemes',
        '/secure/admin/ViewPermissionSchemes'
    ];
};
const $85bbb82518fd8ed6$export$f38c22a081278057 = (path)=>{
    const paths = $85bbb82518fd8ed6$var$getIssuesNavPaths();
    return path && paths.some((p)=>path.includes(p));
};

});

parcelRegister("10qwl", function(module, exports) {

$parcel$export(module.exports, "JiraTopBannerPlacement", () => $736f603676959336$export$2a9156f5c2a2410e);

var $5uXOq = parcelRequire("5uXOq");

var $gZ8TJ = parcelRequire("gZ8TJ");

var $7CMCs = parcelRequire("7CMCs");

var $4R6GH = parcelRequire("4R6GH");

var $4yEIl = parcelRequire("4yEIl");

var $j2nvL = parcelRequire("j2nvL");

var $jp5kW = parcelRequire("jp5kW");

var $5pSYQ = parcelRequire("5pSYQ");

var $SfWIb = parcelRequire("SfWIb");
const $736f603676959336$var$PLACEMENT_ID = 'jira-top-banner';
const $736f603676959336$var$TopBannerPlacement = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "topBannerPlacement",
        packageName: "top-banner-placement",
        teamName: "post-office",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4yEIl.PostOfficeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "top-banner-placement.jira-top-banner-placement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j2nvL.PlacementFetchProvider), {
        resource: (0, $5pSYQ.postOfficeJiraTopBannerResource)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $SfWIb.default), {
        placementId: $736f603676959336$var$PLACEMENT_ID,
        // Post Office and Jira uses different versions of react-error-boundary - https://atlassian.slack.com/archives/CL6HC337Z/p1741218999095929
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - Type 'ComponentType<Partial<ErrorBoundaryPropsWithRender>> is not assignable to type 'PlacementComponent<LocalPlacementProps>'
        PlacementComponent: (0, $gZ8TJ.default)
    })))));
};
const $736f603676959336$export$2a9156f5c2a2410e = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    if (!(0, $jp5kW.default)('killswitch_post_office_in_jira') && (0, $4R6GH.fg)('jira-issue-term-refresh-banner')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($736f603676959336$var$TopBannerPlacement, null);
    return null;
});

});
parcelRegister("gZ8TJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b47c3a797e2767d8$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $hWRix = parcelRequire("hWRix");

var $iXSVm = parcelRequire("iXSVm");
var $20Ijf = parcelRequire("20Ijf");

var $5uXOq = parcelRequire("5uXOq");

var $gm9ab = parcelRequire("gm9ab");


var $7Qn1B = parcelRequire("7Qn1B");
const $b47c3a797e2767d8$export$a4ee24848b29490b = (0, $7Qn1B.withJiraTopBannerIntlProvider)((0, $iXSVm.createPlacementComponent)((0, $f34ff9e8ab1c2d91$export$a5cfae247d8360ef), ({ initialData: initialData })=>{
    const { data: data, isLoading: isLoading } = (0, $20Ijf.useInitialData)(initialData);
    const [{ message: message, status: status }, setMessageState] = (0, $5uXOq.useState)({
        message: undefined,
        status: 'loading'
    });
    const { onMessageDismiss: onMessageDismiss, onMessageClicked: onMessageClicked, onMessageSnooze: onMessageSnooze } = (0, $hWRix.useMessagePlacementHooks)();
    const handleDismiss = (0, $5uXOq.useCallback)(()=>{
        setMessageState({
            message: undefined,
            status: 'done'
        });
    }, []);
    (0, $5uXOq.useEffect)(()=>onMessageDismiss(handleDismiss), [
        onMessageDismiss,
        handleDismiss
    ]);
    (0, $5uXOq.useEffect)(()=>onMessageClicked(handleDismiss), [
        onMessageClicked,
        handleDismiss
    ]);
    (0, $5uXOq.useEffect)(()=>onMessageSnooze(handleDismiss), [
        onMessageSnooze,
        handleDismiss
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isLoading) {
            const newMessage = data?.messages[0];
            setMessageState({
                message: newMessage,
                status: 'done'
            });
        }
    }, [
        data,
        isLoading
    ]);
    if (isLoading || status === 'loading') return null;
    return message && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gm9ab.MessageRenderer), {
        ...message,
        messageInstanceId: message.messageInstanceId
    });
}, {
    choreographer: {
        isDefaultEnabled: false
    }
}));
var $b47c3a797e2767d8$export$2e2bcd8739ae039 = $b47c3a797e2767d8$export$a4ee24848b29490b;

});
parcelRegister("hWRix", function(module, exports) {

$parcel$export(module.exports, "createMessagePlacementValues", () => $bb15f099f95e68b6$export$a28a0c048b24fc5a);
$parcel$export(module.exports, "MessagePlacementProvider", () => $bb15f099f95e68b6$export$c7535f8ebc5b75a9);
$parcel$export(module.exports, "useMessagePlacementHooks", () => $bb15f099f95e68b6$export$89f8e1f623d8f5ac);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
/**
 * Creates a Publish-Subscribe pattern for managing callbacks.
 * @returns {Array<Subscribe, Publish>} An array containing a Subscribe function and a Publish function.
 */ const $bb15f099f95e68b6$var$createPubSub = ()=>{
    const subscribers = new Map();
    /**
	 * Subscribes a callback function to the pub-sub system.
	 * @param {Callback} subscriber - The callback function to subscribe.
	 * @returns A function to unsubscribe the callback.
	 */ const subscribe = (subscriber)=>{
        subscribers.set(subscriber, subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    /**
	 * Publishes the payload to all subscribed callbacks.
	 * @param {Callback} payload - The payload to publish to the subscribers.
	 */ const publish = (payload)=>{
        subscribers.forEach((cb)=>cb(payload));
    };
    return [
        subscribe,
        publish
    ];
};
const $bb15f099f95e68b6$export$a28a0c048b24fc5a = ()=>{
    const [onMessageSnooze, snoozeMessageFromPlacement] = $bb15f099f95e68b6$var$createPubSub();
    const [onMessageDismiss, dismissMessageFromPlacement] = $bb15f099f95e68b6$var$createPubSub();
    const [onMessageRead, markReadFromPlacement] = $bb15f099f95e68b6$var$createPubSub();
    const [onMessageViewed, markViewedFromPlacement] = $bb15f099f95e68b6$var$createPubSub();
    const [onMessageClicked, markClickedFromPlacement] = $bb15f099f95e68b6$var$createPubSub();
    return {
        onMessageSnooze: onMessageSnooze,
        snoozeMessageFromPlacement: snoozeMessageFromPlacement,
        onMessageDismiss: onMessageDismiss,
        dismissMessageFromPlacement: dismissMessageFromPlacement,
        onMessageRead: onMessageRead,
        markReadFromPlacement: markReadFromPlacement,
        onMessageViewed: onMessageViewed,
        markViewedFromPlacement: markViewedFromPlacement,
        onMessageClicked: onMessageClicked,
        markClickedFromPlacement: markClickedFromPlacement
    };
};
const $bb15f099f95e68b6$export$ea58328f3ceee4d4 = /*#__PURE__*/ (0, $5uXOq.createContext)($bb15f099f95e68b6$export$a28a0c048b24fc5a());
const $bb15f099f95e68b6$export$c7535f8ebc5b75a9 = $bb15f099f95e68b6$export$ea58328f3ceee4d4.Provider;
const $bb15f099f95e68b6$export$c4b5cec0911af177 = ()=>({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)($bb15f099f95e68b6$export$c7535f8ebc5b75a9, {
            value: $bb15f099f95e68b6$export$a28a0c048b24fc5a(),
            children: children
        });
const $bb15f099f95e68b6$export$89f8e1f623d8f5ac = ()=>(0, $5uXOq.useContext)($bb15f099f95e68b6$export$ea58328f3ceee4d4);

});

parcelRegister("iXSVm", function(module, exports) {

$parcel$export(module.exports, "createPlacementComponent", () => $6b6a90a3d180f695$export$8a57effc6307f916);

var $7QkCr = parcelRequire("7QkCr");
const $6b6a90a3d180f695$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>(0, $7QkCr.createPlacementComponent)(placementId, Component, placementConfigurationOptions);

});
parcelRegister("7QkCr", function(module, exports) {

$parcel$export(module.exports, "createPlacementComponent", () => $e2c1ea575e6e51c0$export$8a57effc6307f916);

var $2OMIu = parcelRequire("2OMIu");

var $dmvPD = parcelRequire("dmvPD");

var $3HURv = parcelRequire("3HURv");

var $29JCF = parcelRequire("29JCF");

var $dwb5s = parcelRequire("dwb5s");
var $fzSdV = parcelRequire("fzSdV");

var $2B3Lu = parcelRequire("2B3Lu");
const $e2c1ea575e6e51c0$export$eaeb39efb2b24b52 = (placementId, Component, placementConfigurationOptions)=>(0, $2B3Lu.withErrorBoundary)((props)=>{
        const { context: contextWithRoute, onEvent: onEvent, initialData: initialData, ...componentProps } = props;
        const { postOfficeRoute: route, ...context } = contextWithRoute;
        const stableContext = (0, $dmvPD.useStableObject)(context);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dwb5s.PerformanceTracking), {
            initialData: initialData,
            onEvent: onEvent,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fzSdV.StableProviders), {
                route: route,
                context: stableContext,
                placement: {
                    placementId: placementId
                },
                choreographer: placementConfigurationOptions?.choreographer,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                    context: stableContext,
                    initialData: initialData,
                    ...componentProps
                })
            })
        });
    });
const $e2c1ea575e6e51c0$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>{
    const placement = $e2c1ea575e6e51c0$export$eaeb39efb2b24b52(placementId, Component, placementConfigurationOptions);
    return (props)=>{
        const { onError: onError, fallbackRender: fallbackRender } = (0, $29JCF.useComponentErrorHandling)(props);
        return placement({
            ...props,
            errorBoundaryLocation: (0, $3HURv.ERROR_BOUNDARY_LOCATION),
            onError: onError,
            fallbackRender: fallbackRender
        });
    };
};

});
parcelRegister("dmvPD", function(module, exports) {

$parcel$export(module.exports, "useStableObject", () => $2b1cba80f5ba3788$export$ed02d4adf2068b08);

var $5uXOq = parcelRequire("5uXOq");
function $2b1cba80f5ba3788$export$cdf98ded28406f69(obj) {
    return Object.entries(obj).sort().flatMap((v)=>v);
}
function $2b1cba80f5ba3788$export$ed02d4adf2068b08(obj) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $5uXOq.useMemo)(()=>obj, $2b1cba80f5ba3788$export$cdf98ded28406f69(obj));
}

});

parcelRegister("3HURv", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CONTEXT", () => $bd825837585887b1$export$9c542858adf7dcd0);
$parcel$export(module.exports, "ERROR_BOUNDARY_LOCATION", () => $bd825837585887b1$export$71ff7382870ef1b0);
const $bd825837585887b1$export$9c542858adf7dcd0 = {
    isSiteAdmin: undefined,
    locale: undefined,
    product: undefined,
    subproduct: undefined,
    tenantId: undefined,
    workspaceAri: 'no-workspace-ari-available',
    workspaceId: undefined,
    orgId: undefined,
    productEdition: undefined
};
const $bd825837585887b1$export$71ff7382870ef1b0 = 'create-placement-component';

});

parcelRegister("29JCF", function(module, exports) {

$parcel$export(module.exports, "useComponentErrorHandling", () => $6c54d748a6255778$export$3d127465d22fe4e5);

var $5uXOq = parcelRequire("5uXOq");
const $6c54d748a6255778$export$3d127465d22fe4e5 = ({ onEvent: onEvent, onError: onError, fallbackRender: fallbackRender, errorFallback: errorFallback })=>{
    const internalOnError = (0, $5uXOq.useCallback)((error, info)=>{
        onEvent?.({
            type: 'component-error',
            error: error
        });
        onError?.(error, info);
    }, [
        onEvent,
        onError
    ]);
    // This is here to facade for a extra prop that overwrote the original error boundary api, consituting a breaking change.
    // This makes sure that the original api is still valid.
    const internalFallbackRender = fallbackRender ?? errorFallback;
    return {
        onError: internalOnError,
        fallbackRender: internalFallbackRender
    };
};

});

parcelRegister("dwb5s", function(module, exports) {

$parcel$export(module.exports, "PerformanceTracking", () => $bd6ecb1e8671c70c$export$9a335a42ce02bdb8);

var $2OMIu = parcelRequire("2OMIu");

var $iEN9D = parcelRequire("iEN9D");

var $cFk7t = parcelRequire("cFk7t");

var $duiP6 = parcelRequire("duiP6");

var $jUNoI = parcelRequire("jUNoI");
const $bd6ecb1e8671c70c$export$9a335a42ce02bdb8 = ({ children: children, ...props })=>{
    const isUFOEnabled = (0, $iEN9D.default).checkGate('enable_ufo_tracking_in_post_office');
    const { isLoading: isLoading, onMount: onMount } = (0, $jUNoI.usePerformanceTracking)(props);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cFk7t.UFOv2).UFOSegment, {
        name: (0, $cFk7t.UFOv2).SegmentNames.PLACEMENT,
        children: [
            isUFOEnabled && isLoading && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cFk7t.UFOv2).UFOLoadHold, {
                name: (0, $cFk7t.UFOv2).HoldNames.PLACEMENT
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $duiP6.TrackMount), {
                onMount: onMount,
                children: children
            })
        ]
    });
};

});
parcelRegister("cFk7t", function(module, exports) {

$parcel$export(module.exports, "UFOv2", () => $03c857dcbcb3b663$export$c91b09caa8ecbab1);

var $fNobW = parcelRequire("fNobW");

var $8Ec39 = parcelRequire("8Ec39");
const $03c857dcbcb3b663$export$c91b09caa8ecbab1 = {
    /** Names for UFOv2 segments for Post Office */ SegmentNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
        PLACEMENT: 'post-office-placement',
        MESSAGE: 'post-office-message'
    },
    /** Names for UFOv2 holds for Post Office */ HoldNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement-loading',
        PLACEMENT: 'post-office-placement-loading',
        MESSAGE: 'post-office-message-loading'
    },
    UFOLoadHold: $fNobW.default,
    UFOSegment: $8Ec39.default
};

});

parcelRegister("duiP6", function(module, exports) {

$parcel$export(module.exports, "TrackMount", () => $668f044931d9e46d$export$21b400a8c8ebc91a);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $668f044931d9e46d$export$21b400a8c8ebc91a = ({ onMount: onMount, children: children })=>{
    (0, $5uXOq.useEffect)(()=>{
        const onUnmount = onMount();
        return onUnmount;
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};

});

parcelRegister("jUNoI", function(module, exports) {

$parcel$export(module.exports, "usePerformanceTracking", () => $4617faced3327fb7$export$317d52099614f316);

var $5uXOq = parcelRequire("5uXOq");
const $4617faced3327fb7$export$317d52099614f316 = ({ onEvent: onEvent, initialData: initialData })=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(true);
    const onMount = (0, $5uXOq.useCallback)(()=>{
        return ()=>onEvent?.({
                type: 'unmount'
            });
    }, [
        onEvent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (initialData) initialData.then(()=>{
            onEvent?.({
                type: 'initial-data-complete'
            });
        }).catch((error)=>{
            onEvent?.({
                type: 'initial-data-error',
                error: error
            });
        }).finally(()=>{
            setIsLoading(false);
        });
        else setIsLoading(false);
    }, [
        initialData,
        onEvent
    ]);
    const onComponentError = (0, $5uXOq.useCallback)((error)=>{
        onEvent?.({
            type: 'component-error',
            error: error
        });
    }, [
        onEvent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isLoading === false) onEvent?.({
            type: 'component-ready'
        });
    }, [
        isLoading
    ]);
    return {
        onMount: onMount,
        isLoading: isLoading,
        onComponentError: onComponentError
    };
};

});


parcelRegister("fzSdV", function(module, exports) {

$parcel$export(module.exports, "StableProviders", () => $a512d30c5700ff41$export$2b6596bcb1383a71);

var $2OMIu = parcelRequire("2OMIu");

var $k40lt = parcelRequire("k40lt");

var $c9xzY = parcelRequire("c9xzY");

var $eoudd = parcelRequire("eoudd");

var $56hJU = parcelRequire("56hJU");

var $fp8RZ = parcelRequire("fp8RZ");

var $4b1Vx = parcelRequire("4b1Vx");

var $dwb5s = parcelRequire("dwb5s");
const $a512d30c5700ff41$export$2b6596bcb1383a71 = ({ children: children, context: context, placement: placement, route: route, choreographer: choreographer })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $56hJU.StableContextProvider), {
        context: context,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fp8RZ.StablePlacementProvider), {
            placement: placement,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4b1Vx.StableRouteProvider), {
                route: route,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c9xzY.StableAnaltyicsProvider), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eoudd.StableChoreographerProvider), {
                        choreographer: choreographer,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k40lt.RenderTrackerProvider), {
                            placementId: placement.placementId,
                            children: children
                        })
                    })
                })
            })
        })
    });

});
parcelRegister("k40lt", function(module, exports) {

$parcel$export(module.exports, "RenderTrackerProvider", () => $0993cefe088563bc$export$2d84fd9af6c9e378);

var $2OMIu = parcelRequire("2OMIu");

var $h3mjV = parcelRequire("h3mjV");

var $5uXOq = parcelRequire("5uXOq");
/**
 * List of Placements we do not want to track placement (rendered) for, due to cost reasons, until we have a better solution.
 */ const $0993cefe088563bc$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS = [
    'screen-space-flags'
];
const $0993cefe088563bc$export$2d84fd9af6c9e378 = ({ children: children, placementId: placementId })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $h3mjV.useFirePostOfficeAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if ($0993cefe088563bc$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS.includes(placementId)) return;
        fireAnalyticsEvent({
            eventType: 'track',
            action: 'rendered',
            actionSubject: 'placement'
        });
    }, [
        fireAnalyticsEvent,
        placementId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};

});
parcelRegister("h3mjV", function(module, exports) {

$parcel$export(module.exports, "useFirePostOfficeAnalyticsEvents", () => $5bc838ac8c037623$export$57d19d18d6e255a5);

var $2NMNM = parcelRequire("2NMNM");

var $5uXOq = parcelRequire("5uXOq");
const $5bc838ac8c037623$export$85183a312807388d = 'postOffice';
const $5bc838ac8c037623$export$57d19d18d6e255a5 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $5uXOq.useCallback)((eventPayload, attributes)=>{
        createAnalyticsEvent({
            ...eventPayload,
            side: 'client',
            attributes: {
                ...eventPayload.attributes,
                ...attributes
            }
        }).fire($5bc838ac8c037623$export$85183a312807388d);
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireAnalyticsEvent: fireAnalyticsEvent
    };
};

});


parcelRegister("c9xzY", function(module, exports) {

$parcel$export(module.exports, "StableAnaltyicsProvider", () => $192f81ded39f62f4$export$5a66cdc9893b43e);

var $2OMIu = parcelRequire("2OMIu");

var $1PVpv = parcelRequire("1PVpv");
const $192f81ded39f62f4$var$postOfficeAnalyticsContextData = {
    attributes: {
        build: {
            c: undefined,
            b: undefined,
            t: undefined
        }
    }
};
const $192f81ded39f62f4$export$5a66cdc9893b43e = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1PVpv.PostOfficeAnalyticsContext), {
        data: $192f81ded39f62f4$var$postOfficeAnalyticsContextData,
        children: children
    });
};

});

parcelRegister("eoudd", function(module, exports) {

$parcel$export(module.exports, "StableChoreographerProvider", () => $9b7edb218bbb7d90$export$e68b2c75bfb5682a);
$parcel$export(module.exports, "useChoreographerContext", () => $9b7edb218bbb7d90$export$cab5a8adbabcee23);

var $2OMIu = parcelRequire("2OMIu");

var $gHZ4O = parcelRequire("gHZ4O");
var $5MYiV = parcelRequire("5MYiV");

var $5uXOq = parcelRequire("5uXOq");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
const $9b7edb218bbb7d90$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;
const $9b7edb218bbb7d90$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED = true;
const $9b7edb218bbb7d90$var$defaultContext = {
    choreographerEnabled: $9b7edb218bbb7d90$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED,
    setChoreographerEnabled: ()=>{},
    factory: undefined
};
const $9b7edb218bbb7d90$var$ChoreographerContext = /*#__PURE__*/ (0, $5uXOq.createContext)($9b7edb218bbb7d90$var$defaultContext);

const $9b7edb218bbb7d90$export$e68b2c75bfb5682a = ({ children: children, choreographer: choreographer })=>{
    const [choreographerFactory, setChoreographerFactory] = (0, $5uXOq.useState)(undefined);
    const [choreographerEnabled, setChoreographerEnabled] = (0, $5uXOq.useState)(choreographer?.isDefaultEnabled ?? $9b7edb218bbb7d90$var$defaultContext.choreographerEnabled);
    const environmentContext = (0, $5MYiV.usePostOfficeEnvironment)();
    const context = (0, $gHZ4O.usePostOfficeContext)();
    (0, $5uXOq.useEffect)(()=>{
        if (choreographerEnabled) (parcelRequire("hzSwz")).then((m)=>{
            const module = $9b7edb218bbb7d90$var$importHelper(m);
            setChoreographerFactory(new module.ChoreographerRegistry(context.product, environmentContext.currentEnv).getPostOfficeChoreographerFactory());
        }).catch(()=>{
            setChoreographerEnabled(false);
        });
    }, [
        choreographerEnabled,
        context.product,
        environmentContext.currentEnv
    ]);
    const stableChoreographerContext = (0, $5uXOq.useMemo)(()=>({
            factory: choreographerFactory,
            choreographerEnabled: choreographerEnabled,
            setChoreographerEnabled: setChoreographerEnabled
        }), [
        choreographerFactory,
        choreographerEnabled,
        setChoreographerEnabled
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($9b7edb218bbb7d90$var$ChoreographerContext.Provider, {
        value: stableChoreographerContext,
        children: children
    });
};
const $9b7edb218bbb7d90$export$cab5a8adbabcee23 = ()=>(0, $5uXOq.useContext)($9b7edb218bbb7d90$var$ChoreographerContext);

});
parcelRegister("gHZ4O", function(module, exports) {

$parcel$export(module.exports, "defaultPostOfficeContextValue", () => $5998490173f4f5b3$export$da5dc9062cba6715);
$parcel$export(module.exports, "InternalPostOfficeContextProvider", () => $5998490173f4f5b3$export$3a10495c2cd2db0c);
$parcel$export(module.exports, "PostOfficeContextProvider", () => $5998490173f4f5b3$export$b77983be89bb0a4e);
$parcel$export(module.exports, "usePostOfficeContext", () => $5998490173f4f5b3$export$5bd9099e0ae94a43);

var $5uXOq = parcelRequire("5uXOq");
const $5998490173f4f5b3$export$da5dc9062cba6715 = {
    product: undefined,
    subproduct: undefined,
    locale: undefined,
    isSiteAdmin: undefined,
    tenantId: undefined,
    workspaceAri: 'no-workspace-ari-available',
    workspaceId: undefined,
    orgId: undefined,
    productEdition: undefined
};
const $5998490173f4f5b3$export$a228be81fcb77b42 = (0, $5uXOq.createContext)($5998490173f4f5b3$export$da5dc9062cba6715);
const $5998490173f4f5b3$export$3a10495c2cd2db0c = $5998490173f4f5b3$export$a228be81fcb77b42.Provider;
const $5998490173f4f5b3$export$b77983be89bb0a4e = $5998490173f4f5b3$export$3a10495c2cd2db0c;
const $5998490173f4f5b3$export$5bd9099e0ae94a43 = ()=>(0, $5uXOq.useContext)($5998490173f4f5b3$export$a228be81fcb77b42);

});

parcelRegister("hzSwz", function(module, exports) {

let $ccbffff70c9567fb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ccbffff70c9567fb$var$load("aLMAy").then(()=>parcelRequire('glx9n'));

});


parcelRegister("56hJU", function(module, exports) {

$parcel$export(module.exports, "StableContextProvider", () => $fd21bf74367ba18a$export$d4982c0a28b18f63);

var $2OMIu = parcelRequire("2OMIu");

var $gHZ4O = parcelRequire("gHZ4O");
var $dmvPD = parcelRequire("dmvPD");

var $3HURv = parcelRequire("3HURv");
const $fd21bf74367ba18a$export$d4982c0a28b18f63 = ({ context: context, children: children })=>{
    const stableContext = (0, $dmvPD.useStableObject)({
        ...(0, $3HURv.DEFAULT_CONTEXT),
        ...context
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gHZ4O.PostOfficeContextProvider), {
        value: stableContext,
        children: children
    });
};

});

parcelRegister("fp8RZ", function(module, exports) {

$parcel$export(module.exports, "StablePlacementProvider", () => $9b09578da0295441$export$e9fd288527498af6);

var $2OMIu = parcelRequire("2OMIu");

var $dmvPD = parcelRequire("dmvPD");

var $9uYQQ = parcelRequire("9uYQQ");
const $9b09578da0295441$export$e9fd288527498af6 = ({ children: children, placement: placement })=>{
    const stableValue = (0, $dmvPD.useStableObject)(placement);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9uYQQ.PlacementProvider), {
        value: stableValue,
        children: children
    });
};

});
parcelRegister("9uYQQ", function(module, exports) {

$parcel$export(module.exports, "PlacementProvider", () => $9a7fffcf8781b15b$export$6272e220478c7f1d);
$parcel$export(module.exports, "usePlacementContext", () => $9a7fffcf8781b15b$export$4fc0446ee742ad80);

var $2OMIu = parcelRequire("2OMIu");

var $1PVpv = parcelRequire("1PVpv");

var $iTZyv = parcelRequire("iTZyv");

var $5uXOq = parcelRequire("5uXOq");
const $9a7fffcf8781b15b$export$6394bf86db095a8 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    placementId: undefined
});
const $9a7fffcf8781b15b$export$6272e220478c7f1d = ({ value: value, children: children })=>{
    const memoizedValue = (0, $5uXOq.useMemo)(()=>({
            placementId: value.placementId
        }), [
        value.placementId
    ]);
    (0, $iTZyv.usePostOfficeScreenPlacement)(memoizedValue);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($9a7fffcf8781b15b$export$6394bf86db095a8.Provider, {
        value: memoizedValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1PVpv.PostOfficeAnalyticsContext), {
            data: memoizedValue,
            children: children
        })
    });
};
const $9a7fffcf8781b15b$export$4fc0446ee742ad80 = ()=>(0, $5uXOq.useContext)($9a7fffcf8781b15b$export$6394bf86db095a8);

});
parcelRegister("iTZyv", function(module, exports) {

$parcel$export(module.exports, "PostOfficeScreenContextProvider", () => $83b0ce9f1ffe475b$export$ca77a8cbe94108fe);
$parcel$export(module.exports, "usePostOfficeScreenPlacement", () => $83b0ce9f1ffe475b$export$f51d04a086368016);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1HWkH = parcelRequire("1HWkH");
const $83b0ce9f1ffe475b$var$initialPlacementState = {
    currentlyMounted: [],
    hasMounted: []
};
const $83b0ce9f1ffe475b$var$PostOfficeScreenContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    placements: $83b0ce9f1ffe475b$var$initialPlacementState
});
const $83b0ce9f1ffe475b$export$70e19226ddeaf957 = ()=>(0, $5uXOq.useContext)($83b0ce9f1ffe475b$var$PostOfficeScreenContext);
const $83b0ce9f1ffe475b$var$PostOfficeScreenUpdateContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    placementMount: ()=>{},
    placementUnmount: ()=>{}
});
const $83b0ce9f1ffe475b$export$5d27c0ee02be2a23 = ()=>(0, $5uXOq.useContext)($83b0ce9f1ffe475b$var$PostOfficeScreenUpdateContext);
const $83b0ce9f1ffe475b$export$ca77a8cbe94108fe = ({ children: children })=>{
    const [placements, setPlacements] = (0, $5uXOq.useState)($83b0ce9f1ffe475b$var$initialPlacementState);
    const placementMount = (0, $5uXOq.useCallback)(({ placementId: placementId })=>setPlacements((state)=>state.currentlyMounted.includes(placementId) ? state : {
                ...state,
                currentlyMounted: (0, $1HWkH.uniqueArray)([
                    ...state.currentlyMounted,
                    placementId
                ]),
                hasMounted: (0, $1HWkH.uniqueArray)([
                    ...state.hasMounted,
                    placementId
                ])
            }), []);
    const placementUnmount = (0, $5uXOq.useCallback)(({ placementId: placementId })=>setPlacements((state)=>!state.currentlyMounted.includes(placementId) ? state : {
                ...state,
                currentlyMounted: state.currentlyMounted.filter((e)=>e !== placementId)
            }), []);
    const postOfficeScreenUpdateContext = (0, $5uXOq.useMemo)(()=>({
            placementMount: placementMount,
            placementUnmount: placementUnmount
        }), [
        placementMount,
        placementUnmount
    ]);
    const postOfficeScreenContext = (0, $5uXOq.useMemo)(()=>({
            placements: placements
        }), [
        placements
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($83b0ce9f1ffe475b$var$PostOfficeScreenUpdateContext.Provider, {
        value: postOfficeScreenUpdateContext,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($83b0ce9f1ffe475b$var$PostOfficeScreenContext.Provider, {
            value: postOfficeScreenContext,
            children: children
        })
    });
};
const $83b0ce9f1ffe475b$export$f51d04a086368016 = ({ placementId: placementId })=>{
    const { placementMount: placementMount, placementUnmount: placementUnmount } = $83b0ce9f1ffe475b$export$5d27c0ee02be2a23();
    (0, $5uXOq.useEffect)(()=>{
        if (!placementId) return;
        placementMount({
            placementId: placementId
        });
        return ()=>{
            placementUnmount({
                placementId: placementId
            });
        };
    }, [
        placementId,
        placementMount,
        placementUnmount
    ]);
};

});
parcelRegister("1HWkH", function(module, exports) {

$parcel$export(module.exports, "uniqueArray", () => $1e088c20e501b022$export$bbd17ecb0679edd7);
const $1e088c20e501b022$export$bbd17ecb0679edd7 = (input)=>Array.from(new Set(input).values());

});




parcelRegister("4b1Vx", function(module, exports) {

$parcel$export(module.exports, "StableRouteProvider", () => $d4c1202f201a906c$export$ce13d00e696dfc96);

var $2OMIu = parcelRequire("2OMIu");

var $lwdce = parcelRequire("lwdce");
var $dmvPD = parcelRequire("dmvPD");

var $68YnD = parcelRequire("68YnD");
const $d4c1202f201a906c$export$ce13d00e696dfc96 = ({ route: route, children: children })=>{
    const href = (0, $68YnD.useLocationHref)();
    const stableRoute = (0, $dmvPD.useStableObject)(route ?? {
        previous: href,
        current: href
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lwdce.PostOfficeRouteContext).Provider, {
        value: stableRoute,
        children: children
    });
};

});
parcelRegister("lwdce", function(module, exports) {

$parcel$export(module.exports, "PostOfficeRouteContext", () => $de7edbbcb1faf7cf$export$f7f47a74e8b47b1f);
$parcel$export(module.exports, "PostOfficeRouteProvider", () => $de7edbbcb1faf7cf$export$89eadc6b3e5f4e9e);
$parcel$export(module.exports, "usePostOfficeRoute", () => $de7edbbcb1faf7cf$export$79301b66f7808cd8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8tyNL = parcelRequire("8tyNL");

var $dmvPD = parcelRequire("dmvPD");
const $de7edbbcb1faf7cf$export$98c77e1bd702ed15 = ({ routeSubscriber: routeSubscriber, initialUrl: initialUrl })=>{
    let state = $de7edbbcb1faf7cf$var$initializeState({
        initialUrl: initialUrl
    });
    const handleUpdate = (routeChange)=>{
        const next = routeChange.next?.toString();
        if (next === state.current && state.searchParams === routeChange.next?.searchParams) return;
        state = {
            previous: state.current,
            current: next,
            searchParams: routeChange.next?.searchParams
        };
    };
    const subscribe = (next)=>routeSubscriber((routeChange)=>{
            handleUpdate(routeChange);
            next();
        });
    const getSnapshot = ()=>{
        return state;
    };
    return {
        subscribe: subscribe,
        getSnapshot: getSnapshot
    };
};
const $de7edbbcb1faf7cf$var$usePostOfficeRouteStore = ({ subscribe: subscribe, getSnapshot: getSnapshot })=>{
    const route = (0, $8tyNL.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    return (0, $dmvPD.useStableObject)(route);
};
const $de7edbbcb1faf7cf$var$initialState = {
    previous: undefined,
    current: undefined,
    searchParams: undefined
};
const $de7edbbcb1faf7cf$var$initializeState = ({ initialUrl: initialUrl })=>({
        ...$de7edbbcb1faf7cf$var$initialState,
        current: initialUrl ? initialUrl?.toString() : undefined,
        searchParams: initialUrl?.searchParams
    });
const $de7edbbcb1faf7cf$export$f7f47a74e8b47b1f = /*#__PURE__*/ (0, $5uXOq.createContext)($de7edbbcb1faf7cf$var$initialState);
const $de7edbbcb1faf7cf$export$89eadc6b3e5f4e9e = ({ children: children, ...props })=>{
    const ref = (0, $5uXOq.useRef)();
    if (!ref.current) ref.current = $de7edbbcb1faf7cf$export$98c77e1bd702ed15(props);
    const route = $de7edbbcb1faf7cf$var$usePostOfficeRouteStore(ref.current);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($de7edbbcb1faf7cf$export$f7f47a74e8b47b1f.Provider, {
        value: route,
        children: children
    });
};
const $de7edbbcb1faf7cf$export$79301b66f7808cd8 = ()=>(0, $5uXOq.useContext)($de7edbbcb1faf7cf$export$f7f47a74e8b47b1f); //Route listener

});

parcelRegister("68YnD", function(module, exports) {

$parcel$export(module.exports, "useLocationHref", () => $c4900915c3b8f04b$export$49fc3f3d8c7f99);
const $c4900915c3b8f04b$var$isLocationAvailable = ()=>typeof globalThis !== 'undefined' && typeof globalThis.location !== 'undefined';
const $c4900915c3b8f04b$export$49fc3f3d8c7f99 = ()=>{
    return $c4900915c3b8f04b$var$isLocationAvailable() ? globalThis.location.href : undefined;
};

});



parcelRegister("2B3Lu", function(module, exports) {

$parcel$export(module.exports, "withErrorBoundary", () => $43b10d4962b2f957$export$f0c7a449e0cfaec7);

var $2OMIu = parcelRequire("2OMIu");


var $h3mjV = parcelRequire("h3mjV");

var $ki9Mk = parcelRequire("ki9Mk");
const $43b10d4962b2f957$export$f0c7a449e0cfaec7 = (Component)=>({ errorBoundaryLocation: errorBoundaryLocation, fallbackRender: fallbackRender, onError: onError, ...data })=>{
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $h3mjV.useFirePostOfficeAnalyticsEvents)();
        const internalOnError = (additionalAnalytics, onError)=>(error, info)=>{
                if (onError) onError(error, info);
                fireAnalyticsEvent({
                    eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
                    action: 'caughtError',
                    actionSubject: 'PostOfficeErrorBoundary',
                    actionSubjectId: additionalAnalytics.errorBoundaryLocation
                }, {
                    error: error,
                    info: info
                });
            };
        const internalFallbackRender = (FallbackRender)=>(props)=>{
                if (FallbackRender) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore - Confluence Local Consumption - 'FallbackRender' cannot be used as a JSX component. Its return type 'ReactNode' is not a valid JSX element. Type 'undefined' is not assignable to type 'Element | null'.
                return /*#__PURE__*/ (0, $2OMIu.jsx)(FallbackRender, {
                    ...props
                });
                return null;
            };
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ki9Mk.ErrorBoundary), {
            fallbackRender: internalFallbackRender(fallbackRender),
            onError: internalOnError({
                errorBoundaryLocation: errorBoundaryLocation
            }, onError),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                ...data
            })
        });
    };

});
parcelRegister("ki9Mk", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $ec5d12de053bc93a$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");
'use client';
const $ec5d12de053bc93a$export$b16d9fb1a22de840 = (0, $5uXOq.createContext)(null);
const $ec5d12de053bc93a$var$initialState = {
    didCatch: false,
    error: null
};
class $ec5d12de053bc93a$export$e926676385687eaf extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $ec5d12de053bc93a$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($ec5d12de053bc93a$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $ec5d12de053bc93a$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($ec5d12de053bc93a$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $5uXOq.createElement)(FallbackComponent, props);
            else if (fallback === null || (0, $5uXOq.isValidElement)(fallback)) childToRender = fallback;
            else throw error;
        }
        return (0, $5uXOq.createElement)($ec5d12de053bc93a$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $ec5d12de053bc93a$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $ec5d12de053bc93a$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $ec5d12de053bc93a$export$c052f6604b7d51fe() {
    const context = (0, $5uXOq.useContext)($ec5d12de053bc93a$export$b16d9fb1a22de840);
    $ec5d12de053bc93a$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $5uXOq.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $5uXOq.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $ec5d12de053bc93a$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $5uXOq.forwardRef)((props, ref)=>(0, $5uXOq.createElement)($ec5d12de053bc93a$export$e926676385687eaf, errorBoundaryProps, (0, $5uXOq.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}

});




parcelRegister("20Ijf", function(module, exports) {

$parcel$export(module.exports, "useInitialData", () => $55a4b331b0d51151$export$5523c5f3222291d0);

var $5uXOq = parcelRequire("5uXOq");

var $lpImZ = parcelRequire("lpImZ");
const $55a4b331b0d51151$export$5523c5f3222291d0 = (initialData)=>{
    const initialDataCallback = (0, $5uXOq.useMemo)(()=>{
        if (typeof initialData === 'undefined') return undefined;
        return ()=>initialData;
    }, [
        initialData
    ]);
    return (0, $lpImZ.useData)(initialDataCallback, {
        analytics: {
            name: 'initialData'
        }
    });
};

});
parcelRegister("lpImZ", function(module, exports) {

$parcel$export(module.exports, "AlreadyRunningError", () => $14b90fbc4a11c9d5$export$8c5224d3af2f3c8b);
$parcel$export(module.exports, "useData", () => $14b90fbc4a11c9d5$export$c1cf1cf4c5d51937);

var $h3mjV = parcelRequire("h3mjV");

var $lzG7s = parcelRequire("lzG7s");

var $5uXOq = parcelRequire("5uXOq");

var $ZpIVt = parcelRequire("ZpIVt");
class $14b90fbc4a11c9d5$export$8c5224d3af2f3c8b extends Error {
    constructor(){
        super('Request is already running.');
        this.name = 'AlreadyRunningError';
    }
}
const $14b90fbc4a11c9d5$export$c1cf1cf4c5d51937 = (promiseToResolve, options)=>{
    const [state, setState] = (0, $5uXOq.useState)((0, $ZpIVt.toLoading)());
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $h3mjV.useFirePostOfficeAnalyticsEvents)();
    const { name: analyticsSubjectId, ...analyticsAttributes } = options?.analytics ?? {
        name: 'unknown'
    };
    (0, $5uXOq.useEffect)(()=>{
        if (typeof promiseToResolve !== 'function') return;
        const abortController = new AbortController();
        const { signal: signal } = abortController;
        promiseToResolve({
            signal: signal
        })?.then((0, $ZpIVt.assertResponseIsOk)).then((res)=>res.json()).then((data)=>{
            setState((0, $ZpIVt.toData)(data));
            fireAnalyticsEvent({
                action: 'resolved',
                actionSubject: 'dataPromise',
                actionSubjectId: (0, $lzG7s.camelCase)(analyticsSubjectId) + 'DataPromise',
                eventType: 'operational',
                attributes: {
                    ...analyticsAttributes
                }
            });
        }).catch((err)=>{
            if (err instanceof $14b90fbc4a11c9d5$export$8c5224d3af2f3c8b || signal.aborted) return;
            const errorState = (0, $ZpIVt.toError)(err);
            fireAnalyticsEvent({
                action: 'rejected',
                actionSubject: 'dataPromise',
                actionSubjectId: (0, $lzG7s.camelCase)(analyticsSubjectId) + 'DataPromise',
                eventType: 'operational',
                attributes: {
                    ...analyticsAttributes,
                    errorName: errorState.error.name ?? 'unknown',
                    errorMessage: errorState.error.message ?? 'unknown'
                }
            });
            setState(errorState);
        });
        return ()=>{
            abortController.abort();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        promiseToResolve
    ]);
    return state;
};

});
parcelRegister("lzG7s", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("ZpIVt", function(module, exports) {

$parcel$export(module.exports, "assertResponseIsOk", () => $d551235bedb8451d$export$b3732c8ff6f9c463);
$parcel$export(module.exports, "toLoading", () => $d551235bedb8451d$export$f9a5bd0ffba29ffc);
$parcel$export(module.exports, "toError", () => $d551235bedb8451d$export$cc3b967c039ed3e7);
$parcel$export(module.exports, "toData", () => $d551235bedb8451d$export$24a6b176bdc41ce5);
const $d551235bedb8451d$export$18a0019e5439b209 = ({ status: status, statusText: statusText })=>JSON.stringify({
        status: status,
        statusText: statusText
    });
const $d551235bedb8451d$export$b3732c8ff6f9c463 = (res)=>{
    if (res.ok) return res;
    throw new Error($d551235bedb8451d$export$18a0019e5439b209(res));
};
const $d551235bedb8451d$export$f9a5bd0ffba29ffc = ()=>({
        isLoading: true,
        data: undefined,
        error: undefined
    });
const $d551235bedb8451d$export$cc3b967c039ed3e7 = (error)=>({
        isLoading: false,
        error: error instanceof Error ? error : Error(String(error)),
        data: undefined
    });
const $d551235bedb8451d$export$24a6b176bdc41ce5 = (data)=>({
        isLoading: false,
        error: undefined,
        data: data
    });

});



parcelRegister("gm9ab", function(module, exports) {

$parcel$export(module.exports, "MessageRenderer", () => $9bfd0c04eb796cf4$export$2df1250b8f917a59);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for client side use only
#
# Generate source: local/cli/src/commands/placements/generate-placement-files.ts
*/ 
var $jOeT9 = parcelRequire("jOeT9");

var $1C9Eu = parcelRequire("1C9Eu");

var $bzbRq = parcelRequire("bzbRq");
const $9bfd0c04eb796cf4$export$e30378e28ad3e6ab = {
    ...(0, $1C9Eu.default),
    ...(0, $bzbRq.default)
};
const { initializeMessageRenderer: $9bfd0c04eb796cf4$export$bce4e5106d86e473, MessageRenderer: $9bfd0c04eb796cf4$export$2df1250b8f917a59 } = (0, $jOeT9.asMessageRenderer)($9bfd0c04eb796cf4$export$e30378e28ad3e6ab);

});
parcelRegister("jOeT9", function(module, exports) {

$parcel$export(module.exports, "MaybeSuspenseBoundary", () => $aac06bc7b75bd846$export$9750eb54d7c7e789);
$parcel$export(module.exports, "asMessageRenderer", () => $aac06bc7b75bd846$export$7b7e5a348ef9a7c1);
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ /* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-unsafe-member-access */ 
var $2OMIu = parcelRequire("2OMIu");

var $iEN9D = parcelRequire("iEN9D");

var $dmvPD = parcelRequire("dmvPD");

var $cM1px = parcelRequire("cM1px");
var $cFk7t = parcelRequire("cFk7t");

var $7ldM3 = parcelRequire("7ldM3");

var $11KUO = parcelRequire("11KUO");

var $boCjr = parcelRequire("boCjr");
var $howih = parcelRequire("howih");
var $ieDcK = parcelRequire("ieDcK");
var $duiP6 = parcelRequire("duiP6");
var $2B3Lu = parcelRequire("2B3Lu");

var $eyw2y = parcelRequire("eyw2y");

var $5uXOq = parcelRequire("5uXOq");

var $g0Qxc = parcelRequire("g0Qxc");
const $aac06bc7b75bd846$var$STABLE_EMPTY_OBJECT = {};
const $aac06bc7b75bd846$export$9750eb54d7c7e789 = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        ...props,
        children: children
    });
};
const $aac06bc7b75bd846$export$7b7e5a348ef9a7c1 = (messageComponents, messageValidator)=>{
    const initializeMessageRenderer = ()=>{
        // Return renderer component
        return /*#__PURE__*/ (0, $5uXOq.memo)(({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, recommendationSession: recommendationSession, fallbackRender: fallbackRender, loadingFallback: loadingFallback, onError: onError, messageCategory: messageCategory, postOffice: postOffice, triggerId: triggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, SuspenseBoundary: SuspenseBoundary = (0, $5uXOq.Suspense), ...data })=>{
            const isUFOEnabled = (0, $iEN9D.default).checkGate('enable_ufo_tracking_in_post_office');
            const recommendationSessionStable = (0, $dmvPD.useStableObject)(recommendationSession ?? $aac06bc7b75bd846$var$STABLE_EMPTY_OBJECT);
            const postOfficeStable = (0, $dmvPD.useStableObject)(postOffice ?? $aac06bc7b75bd846$var$STABLE_EMPTY_OBJECT);
            const { markMessageFailed: markMessageFailed, markMessageUnmounted: markMessageUnmounted, messageSuccessComponent: messageSuccessComponent } = (0, $5uXOq.useMemo)(()=>{
                const messagePerformanceTracker = isUFOEnabled ? new (0, $cM1px.UFOv1).MessagePerformanceTracker(messageTemplateId) : undefined;
                const onMessageSuccess = ()=>{
                    messagePerformanceTracker?.markSuccess();
                };
                const markMessageFailed = (onError)=>(error, info)=>{
                        messagePerformanceTracker?.markFailure(error);
                        onError && onError(error, info);
                    };
                return {
                    /** To be called when the message is unmounted  */ markMessageUnmounted: messagePerformanceTracker?.abort,
                    /** To be called when the message fails to render */ markMessageFailed: markMessageFailed,
                    /** To be rendered when the message is successfully loaded */ messageSuccessComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $duiP6.TrackMount), {
                        onMount: onMessageSuccess
                    })
                };
            }, [
                messageTemplateId
            ]);
            (0, $5uXOq.useEffect)(()=>{
                return ()=>{
                    markMessageUnmounted?.();
                };
            }, [
                markMessageUnmounted
            ]);
            const Core = ()=>{
                const Component = messageComponents?.[messageTemplateId];
                // This should not happen but things can happen at runtime;
                if (!Component) // Throw to error boundary
                throw new (0, $7ldM3.InvalidMessageTemplateIdError)(JSON.stringify({
                    messageTemplateId: messageTemplateId,
                    messageInstanceId: messageInstanceId
                }));
                let validatedMessage;
                if (messageValidator) {
                    // The messageValidator should also throw an error if the validation failed,
                    // which will again be thrown here and should be caught by the ErrorBoundary
                    validatedMessage = messageValidator(data);
                    if (!validatedMessage) throw new (0, $7ldM3.MessageRendererEmptyValidationResponseError)();
                }
                const loadingComponent = (0, $5uXOq.useMemo)(()=>isUFOEnabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cFk7t.UFOv2).UFOLoadHold, {
                        name: (0, $cFk7t.UFOv2).HoldNames.MESSAGE,
                        children: loadingFallback ?? null
                    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                        children: loadingFallback ?? null
                    }), [
                    loadingFallback,
                    isUFOEnabled
                ]);
                // This any should be factored out as part of validation work
                const componentProps = messageValidator ? validatedMessage : data;
                const componentPropsStable = (0, $dmvPD.useStableObject)(componentProps);
                // messageTemplateId exists in the API but component is empty (should not happen)
                if (!Component) return null;
                return (0, $iEN9D.default).checkGate('po-refactor-message-renderer-provider') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ieDcK.MessageRendererProvider), {
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory,
                    recommendationSession: recommendationSessionStable === $aac06bc7b75bd846$var$STABLE_EMPTY_OBJECT ? undefined : recommendationSessionStable,
                    messageSuccessComponent: messageSuccessComponent,
                    componentProps: componentPropsStable,
                    loadingFallback: loadingFallback,
                    triggerId: triggerId,
                    messageCreationType: messageCreationType,
                    postOffice: postOfficeStable,
                    isUFOEnabled: isUFOEnabled,
                    SuspenseBoundary: SuspenseBoundary,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                        onError: onError,
                        ...componentProps
                    })
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g0Qxc.ChoreographerWrapper), {
                    messageId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $boCjr.FeatureFlaggedUfoWrapper), {
                        messageTemplateId: messageTemplateId,
                        isEnabled: isUFOEnabled,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $11KUO.MessageContextProvider), {
                            value: {
                                messageInstanceId: messageInstanceId,
                                messageTemplateId: messageTemplateId,
                                triggerId: triggerId,
                                messageCreationType: messageCreationType,
                                transactionAccountId: componentProps.transactionAccountId,
                                analyticsDetails: postOffice?.analyticsDetails,
                                journeyId: journeyId,
                                journeyTriggerId: journeyTriggerId
                            },
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eyw2y.RecommendationProvider), {
                                value: recommendationSession ?? {},
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)(SuspenseBoundary, {
                                    fallback: loadingComponent,
                                    children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $howih.MessageAnalyticsContextProvider), {
                                        children: [
                                            messageSuccessComponent,
                                            /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                                                onError: onError,
                                                ...componentProps
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                });
            };
            return (0, $2B3Lu.withErrorBoundary)(Core)({
                errorBoundaryLocation: 'placement-message-renderer-component',
                fallbackRender: fallbackRender,
                onError: markMessageFailed(onError)
            });
        });
    };
    return {
        initializeMessageRenderer: initializeMessageRenderer,
        MessageRenderer: initializeMessageRenderer()
    };
};

});
parcelRegister("cM1px", function(module, exports) {

$parcel$export(module.exports, "UFOv1", () => $a25b59aa270b3147$export$96236906ebaa7f87);

var $iK7JQ = parcelRequire("iK7JQ");

var $fHou0 = parcelRequire("fHou0");
const $a25b59aa270b3147$export$96236906ebaa7f87 = {
    MessagePerformanceTracker: $iK7JQ.MessagePerformanceTracker,
    PlacementPerformanceTracker: $fHou0.PlacementPerformanceTracker
};

});
parcelRegister("iK7JQ", function(module, exports) {

$parcel$export(module.exports, "MessagePerformanceTracker", () => $5f39a8bc167b998d$export$ae5c73c7c4f454e6);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");

var $kIW4G = parcelRequire("kIW4G");
class $5f39a8bc167b998d$export$ae5c73c7c4f454e6 {
    constructor(messageTemplateId){
        this.metadata = {};
        this.markSuccess = ()=>{
            for (const experience of this.experiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFailure = (error)=>{
            for (const experience of this.experiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    error: JSON.stringify(error)
                }
            });
        };
        this.abort = ()=>{
            for (const experience of this.experiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $duUGa.UFOExperience)((0, $kIW4G.UFOExperienceNames).MESSAGE, {
            performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $atdLB.ExperienceTypes).Load,
            platform: {
                component: (0, $kIW4G.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.messageSpecificExperience = new (0, $duUGa.UFOExperience)(`${(0, $kIW4G.UFOExperienceNames).MESSAGE}.${messageTemplateId}`, {
            performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $atdLB.ExperienceTypes).Load,
            platform: {
                component: (0, $kIW4G.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.experiences = [
            this.aggregatedExperience,
            this.messageSpecificExperience
        ];
        this.experiences.forEach((experience)=>experience.start());
        this.metadata = {
            messageTemplateId: messageTemplateId
        };
    }
}

});
parcelRegister("kIW4G", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceNames", () => $eff6c8569059a0cf$export$cc7ddf8ca628f6f1);
$parcel$export(module.exports, "POST_OFFICE_PLATFORM_NAME", () => $eff6c8569059a0cf$export$6d482cfa20c9d220);
const $eff6c8569059a0cf$export$cc7ddf8ca628f6f1 = {
    REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
    PLACEMENT: 'post-office-placement',
    MESSAGE: 'post-office-message'
};
const $eff6c8569059a0cf$export$6d482cfa20c9d220 = 'post-office';

});


parcelRegister("fHou0", function(module, exports) {

$parcel$export(module.exports, "PlacementPerformanceTracker", () => $00145acb9984f605$export$8b48c2105ba0b35a);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");

var $kIW4G = parcelRequire("kIW4G");
const $00145acb9984f605$var$STEPS = {
    RML_FETCH: 'rml-fetch',
    RML_RENDER: 'rml-render',
    INITIAL_DATA: 'initial-data-load',
    COMPONENT_READY: 'component-ready'
};
const $00145acb9984f605$var$UFO_EXPERIENCE_CONFIG = {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad,
    type: (0, $atdLB.ExperienceTypes).Load,
    platform: {
        component: (0, $kIW4G.POST_OFFICE_PLATFORM_NAME)
    },
    timings: [
        {
            key: `${$00145acb9984f605$var$STEPS.RML_FETCH}-complete`,
            endMark: `${$00145acb9984f605$var$STEPS.RML_FETCH}-complete`
        },
        {
            key: `${$00145acb9984f605$var$STEPS.RML_RENDER}-complete`,
            endMark: `${$00145acb9984f605$var$STEPS.RML_RENDER}-complete`
        },
        {
            key: `${$00145acb9984f605$var$STEPS.INITIAL_DATA}-complete`,
            endMark: `${$00145acb9984f605$var$STEPS.INITIAL_DATA}-complete`
        },
        {
            key: `${$00145acb9984f605$var$STEPS.INITIAL_DATA}-error`,
            endMark: `${$00145acb9984f605$var$STEPS.INITIAL_DATA}-error`
        }
    ]
};
class $00145acb9984f605$export$8b48c2105ba0b35a {
    constructor(placementId, consumptionType = 'remote'){
        this.placementExperiences = [];
        this.metadata = {};
        this.markFetchComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$00145acb9984f605$var$STEPS.RML_FETCH}-complete`);
        };
        this.markRenderComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$00145acb9984f605$var$STEPS.RML_RENDER}-complete`);
        };
        this.markInitialDataComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$00145acb9984f605$var$STEPS.INITIAL_DATA}-complete`);
        };
        this.markComponentReady = ()=>{
            for (const experience of this.placementExperiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFetchFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $00145acb9984f605$var$STEPS.RML_FETCH,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markRenderFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $00145acb9984f605$var$STEPS.RML_RENDER,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markInitialDataFailure = (_)=>{
            for (const experience of this.placementExperiences)experience.mark(`${$00145acb9984f605$var$STEPS.INITIAL_DATA}-error`);
        };
        this.markComponentFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $00145acb9984f605$var$STEPS.COMPONENT_READY,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markComponentAborted = ()=>{
            for (const experience of this.placementExperiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $duUGa.UFOExperience)((0, $kIW4G.UFOExperienceNames).PLACEMENT, $00145acb9984f605$var$UFO_EXPERIENCE_CONFIG);
        this.placementSpecificExperience = new (0, $duUGa.UFOExperience)(`${(0, $kIW4G.UFOExperienceNames).PLACEMENT}.${placementId}`, $00145acb9984f605$var$UFO_EXPERIENCE_CONFIG);
        this.placementExperiences = [
            this.aggregatedExperience,
            this.placementSpecificExperience
        ];
        for (const experience of this.placementExperiences)experience.start();
        this.metadata = {
            placementId: placementId,
            consumptionType: consumptionType
        };
    }
}

});


parcelRegister("7ldM3", function(module, exports) {

$parcel$export(module.exports, "InvalidMessageTemplateIdError", () => $f5a4f751215d8970$export$19cb89dd679394cb);
$parcel$export(module.exports, "MessageRendererEmptyValidationResponseError", () => $f5a4f751215d8970$export$3dfc27a8d3942f4d);
var $f5a4f751215d8970$export$b9722560029694e7 = /*#__PURE__*/ function(PostOfficeErrorCodes) {
    PostOfficeErrorCodes["MessageTemplatePlacementError"] = "MessageTemplatePlacementError";
    PostOfficeErrorCodes["NotAbleToProcessRecipientExpansionInputError"] = "NotAbleToProcessRecipientExpansionInputError";
    PostOfficeErrorCodes["NotAbleToProcessEmailTemplateError"] = "NotAbleToProcessEmailTemplateError";
    PostOfficeErrorCodes["RecipientExpansionManagerError"] = "RecipientExpansionManagerError";
    PostOfficeErrorCodes["RecipientExpansionProcessingError"] = "RecipientExpansionProcessingError";
    PostOfficeErrorCodes["RecipientExpansionMethodInvocationError"] = "RecipientExpansionMethodInvocationError";
    PostOfficeErrorCodes["MessageConsumptionFailure"] = "MessageConsumptionFailure";
    PostOfficeErrorCodes["ReceiverInputValidationError"] = "ReceiverInputValidationError";
    PostOfficeErrorCodes["InvalidMessageTemplateIdError"] = "InvalidMessageTemplateIdError";
    PostOfficeErrorCodes["MessageTemplateNotFoundError"] = "MessageTemplateNotFoundError";
    PostOfficeErrorCodes["JourneyNotFoundError"] = "JourneyNotFoundError";
    PostOfficeErrorCodes["MessageTemplateNotEnabledError"] = "MessageTemplateNotEnabledError";
    PostOfficeErrorCodes["MessageTemplateActionValidationError"] = "MessageTemplateActionValidationError";
    PostOfficeErrorCodes["MessageTemplateActionHandlerTimeoutError"] = "MessageTemplateActionHandlerTimeoutError";
    PostOfficeErrorCodes["MessageRendererEmptyValidationResponseError"] = "MessageRendererEmptyValidationResponseError";
    PostOfficeErrorCodes["IngestionHandlerFailedSendError"] = "IngestionHandlerFailedSendError";
    PostOfficeErrorCodes["OrchestrationHandlerFailedSendError"] = "OrchestrationHandlerFailedSendError";
    PostOfficeErrorCodes["DigestEngineFailedSendError"] = "DigestEngineFailedSendError";
    PostOfficeErrorCodes["UnableToGetUserDetailsError"] = "UnableToGetUserDetailsError";
    PostOfficeErrorCodes["InvalidPayloadError"] = "InvalidPayloadError";
    PostOfficeErrorCodes["UnsupportedAttachmentTypeError"] = "UnsupportedAttachmentType";
    PostOfficeErrorCodes["InvalidEmailRequestHeader"] = "InvalidEmailRequestHeader";
    PostOfficeErrorCodes["NonProdEmailDomainError"] = "NonProdEmailDomainError";
    PostOfficeErrorCodes["UnsupportedMessageAtPlacementError"] = "UnsupportedMessageAtPlacementError";
    PostOfficeErrorCodes["HydrationFailureAtPlacementError"] = "HydrationFailureAtPlacementError";
    PostOfficeErrorCodes["AllMessagesFailureHydrationAtPlacementError"] = "AllMessagesFailureHydrationAtPlacementError";
    PostOfficeErrorCodes["UnusedValidateError"] = "UnusedValidateError";
    PostOfficeErrorCodes["RecipientExpanderMapRetrievalError"] = "RecipientExpanderMapRetrievalError";
    PostOfficeErrorCodes["GrowthRecRecommendationsError"] = "GrowthRecRecommendationsError";
    PostOfficeErrorCodes["RichRecipientError"] = "RichRecipientError";
    PostOfficeErrorCodes["PlacementNotFoundError"] = "PlacementNotFoundError";
    PostOfficeErrorCodes["UnexpectedMobileNotificationsError"] = "UnexpectedMobileNotificationsError";
    PostOfficeErrorCodes["MobilePushPlacementError"] = "MobilePushPlacementError";
    PostOfficeErrorCodes["MissingIngestionSourceError"] = "MissingIngestionSourceError";
    PostOfficeErrorCodes["RenderRedactedNotFoundError"] = "RenderRedactedNotFoundError";
    PostOfficeErrorCodes["UnexpectedAtlassianMailError"] = "UnexpectedAtlassianMailError";
    PostOfficeErrorCodes["MessageEventServiceError"] = "MessageEventServiceError";
    PostOfficeErrorCodes["HydrationDeliveryNoDataFoundError"] = "HydrationDeliveryNoDataFoundError";
    PostOfficeErrorCodes["PlacementMessageError"] = "PlacementMessageError";
    PostOfficeErrorCodes["PlacementError"] = "PlacementError";
    PostOfficeErrorCodes["PlacementSystemError"] = "PlacementSystemError";
    PostOfficeErrorCodes["PlacementRuntimeError"] = "PlacementRuntimeError";
    PostOfficeErrorCodes["PlacementMiddlewareError"] = "PlacementMiddlewareError";
    PostOfficeErrorCodes["SendOutNotFoundError"] = "SendOutNotFoundError";
    PostOfficeErrorCodes["SendOutUpdateForbiddenError"] = "SendOutUpdateForbiddenError";
    PostOfficeErrorCodes["SendOutUserStatusTransitionForbiddenError"] = "SendOutUserStatusTransitionForbiddenError";
    PostOfficeErrorCodes["SendOutValidationError"] = "SendOutValidationError";
    PostOfficeErrorCodes["SendOutFailedToInitiateApprovalRequest"] = "SendOutFailedToInitiateApprovalRequest";
    PostOfficeErrorCodes["MessageTemplateError"] = "MessageTemplateError";
    return PostOfficeErrorCodes;
}({});
class $f5a4f751215d8970$export$46f86d28cd0a5d38 extends Error {
}
class $f5a4f751215d8970$export$627bc00a5ef5f6ae extends Error {
}
class $f5a4f751215d8970$export$d145ea5319863172 extends Error {
    constructor(message, code, cause){
        super(message, {
            cause: cause
        }), this.code = code;
    }
}
function $f5a4f751215d8970$export$4cb1ea6034a33155(error) {
    return typeof error === 'object' && !!error && 'status' in error && typeof error.status === 'number';
}
function $f5a4f751215d8970$export$aed524b0009b5631(error) {
    return typeof error === 'object' && !!error && 'logLevel' in error && typeof error.logLevel === 'string';
}
class $f5a4f751215d8970$export$ed601cd0dc1a1be7 extends $f5a4f751215d8970$export$d145ea5319863172 {
    constructor(args){
        /**
		 * It is expected that this error message can be not deterministic.
		 * This error message can be displayed in the "Failures" and "Preview It" tabs for message makers.
		 * Showing the error cause helps them understand what was the problem with their payload.
		 *
		 * On Post Office (platform) side, we use "instanceof MessageTemplateError" check
		 * to distinguish between message makers code errors and platform errors,
		 * but we don't rely on the error message itself.
		 */ const errMessage = args.cause instanceof Error ? args.cause.message : 'Error in message template code';
        super(errMessage, "MessageTemplateError", args.cause);
        this.name = this.constructor.name;
        this.messageTemplateId = args.messageTemplateId;
        this.triggerId = args.triggerId;
        this.function = args.function;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f5a4f751215d8970$export$8d39b103586e9fd4 extends $f5a4f751215d8970$export$d145ea5319863172 {
    constructor(message, cause){
        super(message, "NotAbleToProcessEmailTemplateError", cause);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f5a4f751215d8970$export$f649da38897d27f7 extends $f5a4f751215d8970$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f5a4f751215d8970$export$c2852c1c4d9aba3e extends $f5a4f751215d8970$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionProcessingError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f5a4f751215d8970$export$4b7b4e09547e4bb3 extends $f5a4f751215d8970$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionMethodInvocationError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f5a4f751215d8970$export$360a094a97597d87 extends $f5a4f751215d8970$export$d145ea5319863172 {
    constructor(message){
        super(message, "RecipientExpansionManagerError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f5a4f751215d8970$export$4d068b43eb55165b extends $f5a4f751215d8970$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f5a4f751215d8970$export$ac007ee150add337 extends $f5a4f751215d8970$export$d145ea5319863172 {
    constructor(message){
        super(message, "ReceiverInputValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f5a4f751215d8970$export$19cb89dd679394cb extends $f5a4f751215d8970$export$d145ea5319863172 {
    constructor(message){
        super(message, "InvalidMessageTemplateIdError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f5a4f751215d8970$export$78651662ad470cc5 extends $f5a4f751215d8970$export$d145ea5319863172 {
    constructor(){
        super('Message Template not found', "MessageTemplateNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f5a4f751215d8970$export$8a5041670cdd8db2 extends $f5a4f751215d8970$export$d145ea5319863172 {
    constructor(){
        super('Journey not found', "JourneyNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f5a4f751215d8970$export$1240ddc25cf964e6 extends $f5a4f751215d8970$export$d145ea5319863172 {
    constructor(){
        super('Message Template action handler validation error', "MessageTemplateActionValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f5a4f751215d8970$export$3c4884b7ae7fe517 extends $f5a4f751215d8970$export$d145ea5319863172 {
    constructor(timeoutInSeconds = 5){
        super(`Message Template action handler timed out after ${timeoutInSeconds} seconds`, "MessageTemplateActionHandlerTimeoutError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f5a4f751215d8970$export$913b8e68dc7ae8fe extends $f5a4f751215d8970$export$d145ea5319863172 {
    constructor(){
        super('Placement not found', "PlacementNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f5a4f751215d8970$export$3dfc27a8d3942f4d extends $f5a4f751215d8970$export$d145ea5319863172 {
    constructor(){
        super('Message Renderer received empty response from validator', "MessageRendererEmptyValidationResponseError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f5a4f751215d8970$export$e5ccdf8bbfead7a2 extends $f5a4f751215d8970$export$d145ea5319863172 {
    constructor(){
        super('Failed to send some events', "IngestionHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f5a4f751215d8970$export$823733742d803ae6 extends $f5a4f751215d8970$export$d145ea5319863172 {
    constructor(){
        super('Failed to send some events', "OrchestrationHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f5a4f751215d8970$export$1caa32527f23acd2 extends $f5a4f751215d8970$export$d145ea5319863172 {
    constructor(errorCause){
        super('Failed to send digest event to orchestration queue', "DigestEngineFailedSendError");
        this.name = this.constructor.name;
        this.errorCause = errorCause;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f5a4f751215d8970$export$a6f2aad8fa094b39 extends $f5a4f751215d8970$export$d145ea5319863172 {
    constructor(accountId, customErrorMessage){
        super(customErrorMessage ?? 'Unable to get user details for the given account ID', "UnableToGetUserDetailsError"), this.accountId = accountId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f5a4f751215d8970$export$2f1e27130c2bf271 extends $f5a4f751215d8970$export$d145ea5319863172 {
    constructor(message, payloadSize){
        super(message, "InvalidPayloadError");
        this.name = this.constructor.name;
        this.payloadSize = payloadSize;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f5a4f751215d8970$export$d0dc094613469f2b extends $f5a4f751215d8970$export$46f86d28cd0a5d38 {
    constructor(message, workspaceId){
        super(message);
        this.name = this.constructor.name;
        this.workspaceId = workspaceId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f5a4f751215d8970$export$5603eab37ce562f5 extends $f5a4f751215d8970$export$d145ea5319863172 {
    constructor(fileType){
        super('The attachment file is not supported', "UnsupportedAttachmentType");
        this.name = this.constructor.name;
        this.fileType = fileType;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f5a4f751215d8970$export$e0e9aa0e9c6b37ff extends $f5a4f751215d8970$export$d145ea5319863172 {
    constructor(message, error){
        super(message, "InvalidEmailRequestHeader");
        this.name = this.constructor.name;
        this.error = error;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f5a4f751215d8970$export$3ad818f64601e141 extends $f5a4f751215d8970$export$d145ea5319863172 {
    constructor(message){
        super(message, "NonProdEmailDomainError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f5a4f751215d8970$export$25470bb6cba4fba0 extends $f5a4f751215d8970$export$d145ea5319863172 {
    constructor({ messageTemplateId: messageTemplateId, placementId: placementId }){
        super('messageTemplateId not supported by placement', "UnsupportedMessageAtPlacementError");
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f5a4f751215d8970$export$ce14d445679448b6 extends $f5a4f751215d8970$export$d145ea5319863172 {
    constructor(error, { messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, placementId: placementId }){
        super(error?.message ?? 'unknown error', "HydrationFailureAtPlacementError");
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.messageInstanceId = messageInstanceId;
        this.placementId = placementId;
        this.stack = error?.stack;
    }
}
class $f5a4f751215d8970$export$c9a26a17db1045c8 extends $f5a4f751215d8970$export$d145ea5319863172 {
    constructor({ placementId: placementId }){
        super('All messages failed at placement', "AllMessagesFailureHydrationAtPlacementError");
        this.name = this.constructor.name;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f5a4f751215d8970$export$8ab4fb362168b928 extends $f5a4f751215d8970$export$d145ea5319863172 {
    constructor(){
        super('Unexpected invocation of validate() function for push delivery channel', "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f5a4f751215d8970$export$2afd69f57fe5285f extends $f5a4f751215d8970$export$d145ea5319863172 {
    constructor(){
        super('Recipient expander not found for mapper', "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f5a4f751215d8970$export$7635d2b1a281d626 extends $f5a4f751215d8970$export$d145ea5319863172 {
    constructor(message, errors){
        super(message, "GrowthRecRecommendationsError");
        this.errors = errors;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f5a4f751215d8970$export$9e1c6d00e675bc86 extends $f5a4f751215d8970$export$d145ea5319863172 {
    constructor(message, recipient){
        super(message, "RichRecipientError");
        this.name = this.constructor.name;
        this.recipient = recipient;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f5a4f751215d8970$export$90bef7fa95eca3fa extends Error {
    constructor(status){
        super('Posting Mobile Notifications message failed'), this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f5a4f751215d8970$export$6d1a4929f6ff1a32 extends $f5a4f751215d8970$export$46f86d28cd0a5d38 {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f5a4f751215d8970$export$c19fc5e8aa4e064d extends Error {
    constructor(){
        super('Ingestion source is required when custom profile is specified');
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f5a4f751215d8970$export$2d3a68dab93b8cc4 extends Error {
    constructor(){
        super('A renderRedacted function is required when redactionLevel is set to a non-null value');
        this.name = this.constructor.name;
    }
}
class $f5a4f751215d8970$export$175c1dbb0d7c238a extends Error {
    constructor(status){
        super('Enqueueing email failed'), this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f5a4f751215d8970$export$23fab744b3076342 extends Error {
    constructor(message, status){
        super(message), this.message = message, this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $f5a4f751215d8970$export$194adecfa0265ea1 extends Error {
    constructor(msg, messageInstanceId, error){
        super(msg);
        this.msg = msg;
        this.messageInstanceId = messageInstanceId;
        if (error instanceof Error) this.stack = error.stack;
        else Error.captureStackTrace(this, this.constructor);
        this.name = this.constructor.name;
    }
}
class $f5a4f751215d8970$export$c504492f06c975b5 extends $f5a4f751215d8970$export$d145ea5319863172 {
    constructor({ ipmNumber: ipmNumber, variantFromStatsig: variantFromStatsig, contentfulLocale: contentfulLocale }){
        super('hydrate delivery marketing-screen-space-flag-contentful-usecase No data found for the user', "HydrationDeliveryNoDataFoundError");
        this.name = this.constructor.name;
        this.ipmNumber = ipmNumber;
        this.variantFromStatsig = variantFromStatsig;
        this.contentfulLocale = contentfulLocale;
        Error.captureStackTrace(this, this.constructor);
    }
}

});

parcelRegister("11KUO", function(module, exports) {

$parcel$export(module.exports, "MessageContextProvider", () => $2682dcdca1a24b7e$export$42de33f7652dc3de);
$parcel$export(module.exports, "useMessageContext", () => $2682dcdca1a24b7e$export$a5b6d14a2e25725a);

var $5uXOq = parcelRequire("5uXOq");
const $2682dcdca1a24b7e$var$initialValue = {};
const $2682dcdca1a24b7e$export$b060d577040138d8 = (0, $5uXOq.createContext)($2682dcdca1a24b7e$var$initialValue);
const $2682dcdca1a24b7e$export$42de33f7652dc3de = $2682dcdca1a24b7e$export$b060d577040138d8.Provider;
const $2682dcdca1a24b7e$export$a5b6d14a2e25725a = ()=>(0, $5uXOq.useContext)($2682dcdca1a24b7e$export$b060d577040138d8);

});

parcelRegister("boCjr", function(module, exports) {

$parcel$export(module.exports, "FeatureFlaggedUfoWrapper", () => $8a785bf92438f05e$export$8e6fb7035018b3e4);

var $2OMIu = parcelRequire("2OMIu");

var $cFk7t = parcelRequire("cFk7t");
const $8a785bf92438f05e$export$8e6fb7035018b3e4 = ({ isEnabled: isEnabled, messageTemplateId: messageTemplateId, children: children })=>{
    if (isEnabled) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cFk7t.UFOv2).UFOSegment, {
        name: (0, $cFk7t.UFOv2).SegmentNames.MESSAGE,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cFk7t.UFOv2).UFOSegment, {
            name: `${(0, $cFk7t.UFOv2).SegmentNames.MESSAGE}.${messageTemplateId}`,
            children: children
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};

});

parcelRegister("howih", function(module, exports) {

$parcel$export(module.exports, "MessageAnalyticsContextProvider", () => $d800bb73d259797a$export$1737ab199e83455e);
$parcel$export(module.exports, "useMessageAnalyticsContext", () => $d800bb73d259797a$export$bb426ba114b64992);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $d800bb73d259797a$var$defaultMessageAnalyticsContextValue = {
    fireMessageViewedInMessageComponent: null,
    setFireMessageViewedInMessageComponent: ()=>{}
};
const $d800bb73d259797a$export$c81717973c6c4a90 = /*#__PURE__*/ (0, $5uXOq.createContext)($d800bb73d259797a$var$defaultMessageAnalyticsContextValue);
const $d800bb73d259797a$export$1737ab199e83455e = ({ children: children })=>{
    const fireMessageViewedInMessageComponent = (0, $5uXOq.useRef)(false);
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent,
            setFireMessageViewedInMessageComponent: (value)=>{
                fireMessageViewedInMessageComponent.current = value;
            }
        }), [
        fireMessageViewedInMessageComponent
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($d800bb73d259797a$export$c81717973c6c4a90.Provider, {
        value: contextValue,
        children: children
    });
};
const $d800bb73d259797a$export$bb426ba114b64992 = ()=>(0, $5uXOq.useContext)($d800bb73d259797a$export$c81717973c6c4a90);

});

parcelRegister("ieDcK", function(module, exports) {

$parcel$export(module.exports, "MessageRendererProvider", () => $c7b9b1eb96903778$export$5fe06fe68913d493);

var $2OMIu = parcelRequire("2OMIu");

var $cFk7t = parcelRequire("cFk7t");

var $11KUO = parcelRequire("11KUO");

var $eyw2y = parcelRequire("eyw2y");

var $5uXOq = parcelRequire("5uXOq");

var $9wYgm = parcelRequire("9wYgm");

var $boCjr = parcelRequire("boCjr");

var $howih = parcelRequire("howih");
const $c7b9b1eb96903778$var$DEFAULT_RECOMMENDATION_SESSION = {};
const $c7b9b1eb96903778$export$5fe06fe68913d493 = ({ messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, recommendationSession: recommendationSession, messageSuccessComponent: messageSuccessComponent, componentProps: componentProps, loadingFallback: loadingFallback, triggerId: triggerId, messageCreationType: messageCreationType, postOffice: postOffice, isUFOEnabled: isUFOEnabled, children: children, SuspenseBoundary: SuspenseBoundary = (0, $5uXOq.Suspense) })=>{
    const loadingComponent = (0, $5uXOq.useMemo)(()=>isUFOEnabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cFk7t.UFOv2).UFOLoadHold, {
            name: (0, $cFk7t.UFOv2).HoldNames.MESSAGE,
            children: loadingFallback ?? null
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: loadingFallback ?? null
        }), [
        loadingFallback,
        isUFOEnabled
    ]);
    const messageContextMemo = (0, $5uXOq.useMemo)(()=>({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            triggerId: triggerId,
            messageCreationType: messageCreationType,
            componentProps: componentProps,
            postOffice: postOffice
        }), [
        messageInstanceId,
        messageTemplateId,
        triggerId,
        messageCreationType,
        componentProps,
        postOffice
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9wYgm.ChoreographerWrapper), {
        messageId: messageInstanceId,
        messageTemplateId: messageTemplateId,
        messageCategory: messageCategory,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $boCjr.FeatureFlaggedUfoWrapper), {
            messageTemplateId: messageTemplateId,
            isEnabled: isUFOEnabled,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $11KUO.MessageContextProvider), {
                value: messageContextMemo,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eyw2y.RecommendationProvider), {
                    value: recommendationSession ?? $c7b9b1eb96903778$var$DEFAULT_RECOMMENDATION_SESSION,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(SuspenseBoundary, {
                        fallback: loadingComponent,
                        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $howih.MessageAnalyticsContextProvider), {
                            children: [
                                messageSuccessComponent,
                                children
                            ]
                        })
                    })
                })
            })
        })
    });
};

});
parcelRegister("eyw2y", function(module, exports) {

$parcel$export(module.exports, "RecommendationProvider", () => $52375d85c83d9b1b$export$f60e87d7b5f59562);
$parcel$export(module.exports, "useRecommendationContext", () => $52375d85c83d9b1b$export$3321c0b02f750bcc);

var $2OMIu = parcelRequire("2OMIu");

var $daJ0i = parcelRequire("daJ0i");

var $5uXOq = parcelRequire("5uXOq");
const $52375d85c83d9b1b$export$ba2f44035effd9c1 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    sessionId: undefined,
    entityId: undefined
});
const $52375d85c83d9b1b$export$f60e87d7b5f59562 = ({ value: value, children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($52375d85c83d9b1b$export$ba2f44035effd9c1.Provider, {
        value: value,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
            data: value,
            children: children
        })
    });
};
const $52375d85c83d9b1b$export$3321c0b02f750bcc = ()=>(0, $5uXOq.useContext)($52375d85c83d9b1b$export$ba2f44035effd9c1);

});

parcelRegister("9wYgm", function(module, exports) {

$parcel$export(module.exports, "ChoreographerWrapper", () => $fafd418b8da35935$export$8db7ba034addcd65);

var $2OMIu = parcelRequire("2OMIu");

var $iEN9D = parcelRequire("iEN9D");

var $h3mjV = parcelRequire("h3mjV");

var $5uXOq = parcelRequire("5uXOq");

var $eoudd = parcelRequire("eoudd");
const $fafd418b8da35935$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory })=>{
    const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
    const shouldRender = useChoreographedRender({
        messageId: messageId
    });
    if (shouldRender) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
    return null;
};
const $fafd418b8da35935$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
    const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $eoudd.useChoreographerContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $h3mjV.useFirePostOfficeAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        const isTrackingChoreographedPostOfficeMessagesEnabled = (0, $iEN9D.default).checkGate('enable_tracking_choreographed_post_office_messages');
        if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'maybeChoreographed',
            actionSubject: 'postOfficeMessage'
        }, {
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
    }, [
        fireAnalyticsEvent
    ]);
    const isChoreographedPostOfficeMessagesEnabled = (0, $iEN9D.default).checkGate('enable_choreographed_post_office_messages');
    if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        if (!factory) return null;
        const { shouldBeChoreographed: shouldBeChoreographed } = factory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) return /*#__PURE__*/ (0, $2OMIu.jsx)($fafd418b8da35935$var$ChoreographedComponent, {
            choreographerFactory: factory,
            messageId: messageId,
            children: children
        });
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};

});


parcelRegister("g0Qxc", function(module, exports) {

$parcel$export(module.exports, "ChoreographerWrapper", () => $cfeb2bccb040087b$export$8db7ba034addcd65);

var $2OMIu = parcelRequire("2OMIu");

var $iEN9D = parcelRequire("iEN9D");

var $h3mjV = parcelRequire("h3mjV");

var $eoudd = parcelRequire("eoudd");

var $5uXOq = parcelRequire("5uXOq");
const $cfeb2bccb040087b$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory })=>{
    const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
    const shouldRender = useChoreographedRender({
        messageId: messageId
    });
    if (shouldRender) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
    return null;
};
const $cfeb2bccb040087b$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
    const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $eoudd.useChoreographerContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $h3mjV.useFirePostOfficeAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        const isTrackingChoreographedPostOfficeMessagesEnabled = (0, $iEN9D.default).checkGate('enable_tracking_choreographed_post_office_messages');
        if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'maybeChoreographed',
            actionSubject: 'postOfficeMessage'
        }, {
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
    }, [
        fireAnalyticsEvent
    ]);
    const isChoreographedPostOfficeMessagesEnabled = (0, $iEN9D.default).checkGate('enable_choreographed_post_office_messages');
    if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        if (!factory) return null;
        const { shouldBeChoreographed: shouldBeChoreographed } = factory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) return /*#__PURE__*/ (0, $2OMIu.jsx)($cfeb2bccb040087b$var$ChoreographedComponent, {
            choreographerFactory: factory,
            messageId: messageId,
            children: children
        });
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};

});


parcelRegister("1C9Eu", function(module, exports) {

$parcel$export(module.exports, "default", () => $49a05bd821ad1c7c$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $k3epk = parcelRequire("k3epk");
var $49a05bd821ad1c7c$export$2e2bcd8739ae039 = {
    'jira-ipm-issue-to-work-top-banner': (0, $k3epk.default)
};

});
parcelRegister("k3epk", function(module, exports) {

$parcel$export(module.exports, "default", () => $2792309c182a4f2f$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $8krEN = parcelRequire("8krEN");

var $dTWVS = parcelRequire("dTWVS");
const $2792309c182a4f2f$export$b3890eb0ae9dca99 = (0, $dTWVS.createRender)(()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $8krEN.TopBannerMessage), {}));
var $2792309c182a4f2f$export$2e2bcd8739ae039 = $2792309c182a4f2f$export$b3890eb0ae9dca99;

});
parcelRegister("8krEN", function(module, exports) {

$parcel$export(module.exports, "TopBannerMessage", () => $87e26214f521059a$export$71f678cc6412ce95);

var $2OMIu = parcelRequire("2OMIu");

var $i28qQ = parcelRequire("i28qQ");

var $jhmo0 = parcelRequire("jhmo0");
var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $5ILhZ = parcelRequire("5ILhZ");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $bMrPe = parcelRequire("bMrPe");

var $fSNBK = parcelRequire("fSNBK");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
const $87e26214f521059a$var$pressableStyles = (0, $8CUq3.xcss)({
    color: 'color.text.inverse',
    cursor: 'pointer',
    textDecoration: 'underline',
    ':hover': {
        color: 'color.text.inverse',
        textDecoration: 'underline'
    },
    ':active': {
        textDecoration: 'none'
    }
});
const $87e26214f521059a$var$ComingSoonMessage = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        id: "post-office.placement.jira-top-banner.primary-message",
        description: "Coming soon message for the Jira top banner",
        defaultMessage: "As we roll out 'work' as the new term for items tracked in Jira, you may still see 'issue' in some areas."
    });
const $87e26214f521059a$var$ReadMoreLink = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $jhmo0.default), {
        href: "https://community.atlassian.com/t5/Jira-articles/It-s-here-Work-is-the-new-collective-term-for-all-items-you/ba-p/2954892",
        rel: "noopener noreferrer",
        target: "_blank",
        xcss: $87e26214f521059a$var$pressableStyles,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            id: "st-office.placement.jira-top-banner.primary-cta-text",
            description: "Read more link for the Jira top banner",
            defaultMessage: "Read about this terminology change"
        })
    });
const $87e26214f521059a$export$71f678cc6412ce95 = ()=>{
    const { messageDismissed: messageDismissed } = (0, $fSNBK.useMessageEvent)();
    const { messageInstanceClicked: messageInstanceClicked } = (0, $bMrPe.useMessageInstanceEvent)();
    const onClickDismiss = (0, $5uXOq.useCallback)(()=>{
        messageDismissed();
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'dismiss',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: {}
        });
    }, [
        messageDismissed,
        messageInstanceClicked
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        backgroundColor: "color.background.neutral.bold",
        padding: "space.200",
        testId: "jira-top-banner",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $f5TWP.default), {
            spread: "space-between",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cgL5K.default), {
                    color: "color.text.inverse",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)($87e26214f521059a$var$ComingSoonMessage, {}),
                        "\xa0",
                        /*#__PURE__*/ (0, $2OMIu.jsx)($87e26214f521059a$var$ReadMoreLink, {})
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5ILhZ.default), {
                    backgroundColor: "color.background.neutral.bold",
                    onClick: onClickDismiss,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i28qQ))), {
                        color: "var(--ds-text-inverse, #FFFFFF)",
                        label: "Dismiss"
                    })
                })
            ]
        })
    });
};

});
parcelRegister("bMrPe", function(module, exports) {

$parcel$export(module.exports, "useMessageInstanceEvent", () => $47685f166ea19efd$export$39b0f5626e96f41e);

var $gHZ4O = parcelRequire("gHZ4O");

var $11KUO = parcelRequire("11KUO");

var $9uYQQ = parcelRequire("9uYQQ");

var $eyw2y = parcelRequire("eyw2y");

var $5uXOq = parcelRequire("5uXOq");

var $aRo2o = parcelRequire("aRo2o");

var $bO4yC = parcelRequire("bO4yC");
const $47685f166ea19efd$export$39b0f5626e96f41e = ()=>{
    if (!globalThis.window.postOfficeMessageInstanceEventClient) globalThis.window.postOfficeMessageInstanceEventClient = new (0, $bO4yC.MessageInstanceEventClient)();
    const client = globalThis.window.postOfficeMessageInstanceEventClient;
    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, transactionAccountId: transactionAccountId, triggerId: messageTriggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId } = (0, $11KUO.useMessageContext)();
    const { placementId: placementId } = (0, $9uYQQ.usePlacementContext)();
    const browserContext = (0, $gHZ4O.usePostOfficeContext)();
    const recommendationContext = (0, $eyw2y.useRecommendationContext)();
    const messageInstanceDeliveredSuccessfully = (0, $5uXOq.useCallback)(async (additionalMetadataFromFrontend)=>{
        if (!messageInstanceId || !messageTemplateId || !placementId || !messageCreationType || !messageTriggerId) {
            // eslint-disable-next-line no-console
            console.error(new (0, $aRo2o.MessageInstanceEventContextError)());
            return;
        }
        const event = {
            messageEventType: 'deliverySuccessful',
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: {
                ...browserContext,
                source: placementId,
                recommendation: {
                    recommendationSessionId: recommendationContext.sessionId ?? '',
                    recommendationEntityId: recommendationContext.entityId ?? ''
                }
            },
            additionalMetadataFromFrontend: transactionAccountId ? {
                ...additionalMetadataFromFrontend,
                transactionAccountId: transactionAccountId
            } : additionalMetadataFromFrontend,
            messageTriggerId: messageTriggerId,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            messageCreationType: messageCreationType,
            timestamp: Date.now()
        };
        await client.sendMessageInstanceEvent(event);
    }, [
        client,
        browserContext,
        messageInstanceId,
        messageTemplateId,
        placementId,
        messageCreationType,
        messageTriggerId,
        transactionAccountId,
        recommendationContext.entityId,
        recommendationContext.sessionId,
        journeyId,
        journeyTriggerId
    ]);
    const messageInstanceViewed = (0, $5uXOq.useCallback)(async (additionalMetadataFromFrontend)=>{
        if (!messageInstanceId || !messageTemplateId || !placementId || !messageCreationType || !messageTriggerId) {
            // eslint-disable-next-line no-console
            console.error(new (0, $aRo2o.MessageInstanceEventContextError)());
            return;
        }
        const event = {
            messageEventType: 'viewed',
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: {
                ...browserContext,
                source: placementId,
                recommendation: {
                    recommendationSessionId: recommendationContext.sessionId ?? '',
                    recommendationEntityId: recommendationContext.entityId ?? ''
                }
            },
            additionalMetadataFromFrontend: transactionAccountId ? {
                ...additionalMetadataFromFrontend,
                transactionAccountId: transactionAccountId
            } : additionalMetadataFromFrontend,
            messageTriggerId: messageTriggerId,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            messageCreationType: messageCreationType,
            timestamp: Date.now()
        };
        await client.sendMessageInstanceEvent(event);
    }, [
        client,
        browserContext,
        messageInstanceId,
        messageTemplateId,
        placementId,
        messageCreationType,
        messageTriggerId,
        transactionAccountId,
        recommendationContext.entityId,
        recommendationContext.sessionId,
        journeyId,
        journeyTriggerId
    ]);
    const messageInstanceClicked = (0, $5uXOq.useCallback)(async (params)=>{
        if (!messageInstanceId && !params.messageInstanceId || !messageTemplateId && !params.messageTemplateId || !placementId || !messageCreationType && !params.messageCreationType || !messageTriggerId) {
            // eslint-disable-next-line no-console
            console.error(new (0, $aRo2o.MessageInstanceEventContextError)());
            return;
        }
        const clickEventPayload = {
            messageInstanceId: params.messageInstanceId ?? messageInstanceId,
            messageTemplateId: params.messageTemplateId ?? messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: {
                ...browserContext,
                source: placementId,
                recommendation: {
                    recommendationSessionId: recommendationContext.sessionId ?? '',
                    recommendationEntityId: recommendationContext.entityId ?? ''
                }
            },
            messageCreationType: params.messageCreationType ?? messageCreationType,
            messageTriggerId: messageTriggerId,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            ...params,
            additionalMetadataFromFrontend: transactionAccountId ? {
                ...params.additionalMetadataFromFrontend,
                transactionAccountId: transactionAccountId
            } : params.additionalMetadataFromFrontend,
            timestamp: Date.now()
        };
        await client.sendMessageInstanceEvent(clickEventPayload);
    }, [
        client,
        browserContext,
        messageInstanceId,
        messageTemplateId,
        placementId,
        messageCreationType,
        messageTriggerId,
        transactionAccountId,
        recommendationContext.entityId,
        recommendationContext.sessionId,
        journeyId,
        journeyTriggerId
    ]);
    return {
        messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully,
        messageInstanceViewed: messageInstanceViewed,
        messageInstanceClicked: messageInstanceClicked
    };
};

});
parcelRegister("aRo2o", function(module, exports) {

$parcel$export(module.exports, "MessageInstanceEventContextError", () => $9be75f5daa70b254$export$9ffc53d3edc152da);
class $9be75f5daa70b254$export$9ffc53d3edc152da extends Error {
    constructor(){
        super('useMessageInstanceEvent must be used inside a Message template render component.');
    }
}
class $9be75f5daa70b254$export$6c3423e1c9ff4d5b extends Error {
    constructor(){
        super('Unknown action type');
    }
}

});

parcelRegister("bO4yC", function(module, exports) {

$parcel$export(module.exports, "MessageInstanceEventClient", () => $2487317fb26c4823$export$4564cfc2de39be55);
const $2487317fb26c4823$var$DEFAULT_PATH = `/gateway/api/post-office/api/v1/message-instance-event/bulk`;
const $2487317fb26c4823$var$FLUSH_BATCH_EVENTS_TIMEOUT = 1000;
const $2487317fb26c4823$var$MESSAGE_EVENTS_BATCH_SIZE = 30;

if (typeof fetch === 'undefined') // If fetch is not supported, load the polyfill.
(parcelRequire("fS9d8"));
class $2487317fb26c4823$export$4564cfc2de39be55 {
    async sendMessageInstanceEvent(event) {
        this.batchEvents.push(event);
        if (this.scheduledTimeout === null) this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $2487317fb26c4823$var$FLUSH_BATCH_EVENTS_TIMEOUT);
    }
    async sendEventsToBackend(events) {
        const url = `${this.endpointUrl}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(events)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send event to analytics endpoint: ${response.statusText}`);
    }
    async flushBatchEvents() {
        if (this.batchEvents.length === 0) return;
        if (this.batchEvents.length > $2487317fb26c4823$var$MESSAGE_EVENTS_BATCH_SIZE) {
            const batch = this.batchEvents.slice(0, $2487317fb26c4823$var$MESSAGE_EVENTS_BATCH_SIZE);
            await this.sendEventsToBackend(batch);
            if (this.scheduledTimeout !== null) globalThis.window.clearTimeout(this.scheduledTimeout);
            this.batchEvents = this.batchEvents.slice($2487317fb26c4823$var$MESSAGE_EVENTS_BATCH_SIZE, this.batchEvents.length);
            this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $2487317fb26c4823$var$FLUSH_BATCH_EVENTS_TIMEOUT);
            return;
        }
        await this.sendEventsToBackend(this.batchEvents);
        this.batchEvents = [];
        if (this.scheduledTimeout !== null) {
            globalThis.window.clearTimeout(this.scheduledTimeout);
            this.scheduledTimeout = null;
        }
    }
    constructor(){
        this.endpointUrl = $2487317fb26c4823$var$DEFAULT_PATH;
        this.scheduledTimeout = null;
        this.batchEvents = [];
    }
}

});
parcelRegister("fS9d8", function(module, exports) {

$parcel$export(module.exports, "Headers", () => $b8e30b448f738d08$export$79b704688b15c0f4);
$parcel$export(module.exports, "Request", () => $b8e30b448f738d08$export$7fa6c5b6f8193917);
$parcel$export(module.exports, "Response", () => $b8e30b448f738d08$export$9f633d56d7ec90d3);
$parcel$export(module.exports, "DOMException", () => $b8e30b448f738d08$export$fe58bcf938607f6a);
$parcel$export(module.exports, "fetch", () => $b8e30b448f738d08$export$e7aa7bc5c1b3cfb3);
/* eslint-disable no-prototype-builtins */ var $b8e30b448f738d08$var$g = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || // eslint-disable-next-line no-undef
typeof $parcel$global !== 'undefined' && $parcel$global || {};
var $b8e30b448f738d08$var$support = {
    searchParams: 'URLSearchParams' in $b8e30b448f738d08$var$g,
    iterable: 'Symbol' in $b8e30b448f738d08$var$g && 'iterator' in Symbol,
    blob: 'FileReader' in $b8e30b448f738d08$var$g && 'Blob' in $b8e30b448f738d08$var$g && function() {
        try {
            new Blob();
            return true;
        } catch (e) {
            return false;
        }
    }(),
    formData: 'FormData' in $b8e30b448f738d08$var$g,
    arrayBuffer: 'ArrayBuffer' in $b8e30b448f738d08$var$g
};
function $b8e30b448f738d08$var$isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj);
}
if ($b8e30b448f738d08$var$support.arrayBuffer) {
    var $b8e30b448f738d08$var$viewClasses = [
        '[object Int8Array]',
        '[object Uint8Array]',
        '[object Uint8ClampedArray]',
        '[object Int16Array]',
        '[object Uint16Array]',
        '[object Int32Array]',
        '[object Uint32Array]',
        '[object Float32Array]',
        '[object Float64Array]'
    ];
    var $b8e30b448f738d08$var$isArrayBufferView = ArrayBuffer.isView || function(obj) {
        return obj && $b8e30b448f738d08$var$viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
    };
}
function $b8e30b448f738d08$var$normalizeName(name) {
    if (typeof name !== 'string') name = String(name);
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
    return name.toLowerCase();
}
function $b8e30b448f738d08$var$normalizeValue(value) {
    if (typeof value !== 'string') value = String(value);
    return value;
}
// Build a destructive iterator for the value list
function $b8e30b448f738d08$var$iteratorFor(items) {
    var iterator = {
        next: function() {
            var value = items.shift();
            return {
                done: value === undefined,
                value: value
            };
        }
    };
    if ($b8e30b448f738d08$var$support.iterable) iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function $b8e30b448f738d08$export$79b704688b15c0f4(headers) {
    this.map = {};
    if (headers instanceof $b8e30b448f738d08$export$79b704688b15c0f4) headers.forEach(function(value, name) {
        this.append(name, value);
    }, this);
    else if (Array.isArray(headers)) headers.forEach(function(header) {
        if (header.length != 2) throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length);
        this.append(header[0], header[1]);
    }, this);
    else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
    }, this);
}
$b8e30b448f738d08$export$79b704688b15c0f4.prototype.append = function(name, value) {
    name = $b8e30b448f738d08$var$normalizeName(name);
    value = $b8e30b448f738d08$var$normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
};
$b8e30b448f738d08$export$79b704688b15c0f4.prototype['delete'] = function(name) {
    delete this.map[$b8e30b448f738d08$var$normalizeName(name)];
};
$b8e30b448f738d08$export$79b704688b15c0f4.prototype.get = function(name) {
    name = $b8e30b448f738d08$var$normalizeName(name);
    return this.has(name) ? this.map[name] : null;
};
$b8e30b448f738d08$export$79b704688b15c0f4.prototype.has = function(name) {
    return this.map.hasOwnProperty($b8e30b448f738d08$var$normalizeName(name));
};
$b8e30b448f738d08$export$79b704688b15c0f4.prototype.set = function(name, value) {
    this.map[$b8e30b448f738d08$var$normalizeName(name)] = $b8e30b448f738d08$var$normalizeValue(value);
};
$b8e30b448f738d08$export$79b704688b15c0f4.prototype.forEach = function(callback, thisArg) {
    for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
};
$b8e30b448f738d08$export$79b704688b15c0f4.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push(name);
    });
    return $b8e30b448f738d08$var$iteratorFor(items);
};
$b8e30b448f738d08$export$79b704688b15c0f4.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
        items.push(value);
    });
    return $b8e30b448f738d08$var$iteratorFor(items);
};
$b8e30b448f738d08$export$79b704688b15c0f4.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push([
            name,
            value
        ]);
    });
    return $b8e30b448f738d08$var$iteratorFor(items);
};
if ($b8e30b448f738d08$var$support.iterable) $b8e30b448f738d08$export$79b704688b15c0f4.prototype[Symbol.iterator] = $b8e30b448f738d08$export$79b704688b15c0f4.prototype.entries;
function $b8e30b448f738d08$var$consumed(body) {
    if (body._noBody) return;
    if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
    body.bodyUsed = true;
}
function $b8e30b448f738d08$var$fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
        reader.onload = function() {
            resolve(reader.result);
        };
        reader.onerror = function() {
            reject(reader.error);
        };
    });
}
function $b8e30b448f738d08$var$readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = $b8e30b448f738d08$var$fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
}
function $b8e30b448f738d08$var$readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = $b8e30b448f738d08$var$fileReaderReady(reader);
    var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
    var encoding = match ? match[1] : 'utf-8';
    reader.readAsText(blob, encoding);
    return promise;
}
function $b8e30b448f738d08$var$readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);
    for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
    return chars.join('');
}
function $b8e30b448f738d08$var$bufferClone(buf) {
    if (buf.slice) return buf.slice(0);
    else {
        var view = new Uint8Array(buf.byteLength);
        view.set(new Uint8Array(buf));
        return view.buffer;
    }
}
function $b8e30b448f738d08$var$Body() {
    this.bodyUsed = false;
    this._initBody = function(body) {
        /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */ // eslint-disable-next-line no-self-assign
        this.bodyUsed = this.bodyUsed;
        this._bodyInit = body;
        if (!body) {
            this._noBody = true;
            this._bodyText = '';
        } else if (typeof body === 'string') this._bodyText = body;
        else if ($b8e30b448f738d08$var$support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
        else if ($b8e30b448f738d08$var$support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
        else if ($b8e30b448f738d08$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
        else if ($b8e30b448f738d08$var$support.arrayBuffer && $b8e30b448f738d08$var$support.blob && $b8e30b448f738d08$var$isDataView(body)) {
            this._bodyArrayBuffer = $b8e30b448f738d08$var$bufferClone(body.buffer);
            // IE 10-11 can't handle a DataView body.
            this._bodyInit = new Blob([
                this._bodyArrayBuffer
            ]);
        } else if ($b8e30b448f738d08$var$support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || $b8e30b448f738d08$var$isArrayBufferView(body))) this._bodyArrayBuffer = $b8e30b448f738d08$var$bufferClone(body);
        else this._bodyText = body = Object.prototype.toString.call(body);
        if (!this.headers.get('content-type')) {
            if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
            else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
            else if ($b8e30b448f738d08$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
    };
    if ($b8e30b448f738d08$var$support.blob) this.blob = function() {
        var rejected = $b8e30b448f738d08$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
            this._bodyArrayBuffer
        ]));
        else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
        else return Promise.resolve(new Blob([
            this._bodyText
        ]));
    };
    this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
            var isConsumed = $b8e30b448f738d08$var$consumed(this);
            if (isConsumed) return isConsumed;
            else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
            else return Promise.resolve(this._bodyArrayBuffer);
        } else if ($b8e30b448f738d08$var$support.blob) return this.blob().then($b8e30b448f738d08$var$readBlobAsArrayBuffer);
        else throw new Error('could not read as ArrayBuffer');
    };
    this.text = function() {
        var rejected = $b8e30b448f738d08$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return $b8e30b448f738d08$var$readBlobAsText(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve($b8e30b448f738d08$var$readArrayBufferAsText(this._bodyArrayBuffer));
        else if (this._bodyFormData) throw new Error('could not read FormData body as text');
        else return Promise.resolve(this._bodyText);
    };
    if ($b8e30b448f738d08$var$support.formData) this.formData = function() {
        return this.text().then($b8e30b448f738d08$var$decode);
    };
    this.json = function() {
        return this.text().then(JSON.parse);
    };
    return this;
}
// HTTP methods whose capitalization should be normalized
var $b8e30b448f738d08$var$methods = [
    'CONNECT',
    'DELETE',
    'GET',
    'HEAD',
    'OPTIONS',
    'PATCH',
    'POST',
    'PUT',
    'TRACE'
];
function $b8e30b448f738d08$var$normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return $b8e30b448f738d08$var$methods.indexOf(upcased) > -1 ? upcased : method;
}
function $b8e30b448f738d08$export$7fa6c5b6f8193917(input, options) {
    if (!(this instanceof $b8e30b448f738d08$export$7fa6c5b6f8193917)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    options = options || {};
    var body = options.body;
    if (input instanceof $b8e30b448f738d08$export$7fa6c5b6f8193917) {
        if (input.bodyUsed) throw new TypeError('Already read');
        this.url = input.url;
        this.credentials = input.credentials;
        if (!options.headers) this.headers = new $b8e30b448f738d08$export$79b704688b15c0f4(input.headers);
        this.method = input.method;
        this.mode = input.mode;
        this.signal = input.signal;
        if (!body && input._bodyInit != null) {
            body = input._bodyInit;
            input.bodyUsed = true;
        }
    } else this.url = String(input);
    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) this.headers = new $b8e30b448f738d08$export$79b704688b15c0f4(options.headers);
    this.method = $b8e30b448f738d08$var$normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal || function() {
        if ('AbortController' in $b8e30b448f738d08$var$g) {
            var ctrl = new AbortController();
            return ctrl.signal;
        }
    }();
    this.referrer = null;
    if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
    this._initBody(body);
    if (this.method === 'GET' || this.method === 'HEAD') {
        if (options.cache === 'no-store' || options.cache === 'no-cache') {
            // Search for a '_' parameter in the query string
            var reParamSearch = /([?&])_=[^&]*/;
            if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
            this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
            else {
                // Otherwise add a new '_' parameter to the end with the current time
                var reQueryString = /\?/;
                this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
            }
        }
    }
}
$b8e30b448f738d08$export$7fa6c5b6f8193917.prototype.clone = function() {
    return new $b8e30b448f738d08$export$7fa6c5b6f8193917(this, {
        body: this._bodyInit
    });
};
function $b8e30b448f738d08$var$decode(body) {
    var form = new FormData();
    body.trim().split('&').forEach(function(bytes) {
        if (bytes) {
            var split = bytes.split('=');
            var name = split.shift().replace(/\+/g, ' ');
            var value = split.join('=').replace(/\+/g, ' ');
            form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
    });
    return form;
}
function $b8e30b448f738d08$var$parseHeaders(rawHeaders) {
    var headers = new $b8e30b448f738d08$export$79b704688b15c0f4();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders.split('\r').map(function(header) {
        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
    }).forEach(function(line) {
        var parts = line.split(':');
        var key = parts.shift().trim();
        if (key) {
            var value = parts.join(':').trim();
            try {
                headers.append(key, value);
            } catch (error) {
                console.warn('Response ' + error.message);
            }
        }
    });
    return headers;
}
$b8e30b448f738d08$var$Body.call($b8e30b448f738d08$export$7fa6c5b6f8193917.prototype);
function $b8e30b448f738d08$export$9f633d56d7ec90d3(bodyInit, options) {
    if (!(this instanceof $b8e30b448f738d08$export$9f633d56d7ec90d3)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    if (!options) options = {};
    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
    this.headers = new $b8e30b448f738d08$export$79b704688b15c0f4(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
}
$b8e30b448f738d08$var$Body.call($b8e30b448f738d08$export$9f633d56d7ec90d3.prototype);
$b8e30b448f738d08$export$9f633d56d7ec90d3.prototype.clone = function() {
    return new $b8e30b448f738d08$export$9f633d56d7ec90d3(this._bodyInit, {
        status: this.status,
        statusText: this.statusText,
        headers: new $b8e30b448f738d08$export$79b704688b15c0f4(this.headers),
        url: this.url
    });
};
$b8e30b448f738d08$export$9f633d56d7ec90d3.error = function() {
    var response = new $b8e30b448f738d08$export$9f633d56d7ec90d3(null, {
        status: 200,
        statusText: ''
    });
    response.ok = false;
    response.status = 0;
    response.type = 'error';
    return response;
};
var $b8e30b448f738d08$var$redirectStatuses = [
    301,
    302,
    303,
    307,
    308
];
$b8e30b448f738d08$export$9f633d56d7ec90d3.redirect = function(url, status) {
    if ($b8e30b448f738d08$var$redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
    return new $b8e30b448f738d08$export$9f633d56d7ec90d3(null, {
        status: status,
        headers: {
            location: url
        }
    });
};
var $b8e30b448f738d08$export$fe58bcf938607f6a = $b8e30b448f738d08$var$g.DOMException;
try {
    new $b8e30b448f738d08$export$fe58bcf938607f6a();
} catch (err) {
    $b8e30b448f738d08$export$fe58bcf938607f6a = function(message, name) {
        this.message = message;
        this.name = name;
        var error = Error(message);
        this.stack = error.stack;
    };
    $b8e30b448f738d08$export$fe58bcf938607f6a.prototype = Object.create(Error.prototype);
    $b8e30b448f738d08$export$fe58bcf938607f6a.prototype.constructor = $b8e30b448f738d08$export$fe58bcf938607f6a;
}
function $b8e30b448f738d08$export$e7aa7bc5c1b3cfb3(input, init) {
    return new Promise(function(resolve, reject) {
        var request = new $b8e30b448f738d08$export$7fa6c5b6f8193917(input, init);
        if (request.signal && request.signal.aborted) return reject(new $b8e30b448f738d08$export$fe58bcf938607f6a('Aborted', 'AbortError'));
        var xhr = new XMLHttpRequest();
        function abortXhr() {
            xhr.abort();
        }
        xhr.onload = function() {
            var options = {
                statusText: xhr.statusText,
                headers: $b8e30b448f738d08$var$parseHeaders(xhr.getAllResponseHeaders() || '')
            };
            // This check if specifically for when a user fetches a file locally from the file system
            // Only if the status is out of a normal range
            if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
            else options.status = xhr.status;
            options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
            var body = 'response' in xhr ? xhr.response : xhr.responseText;
            setTimeout(function() {
                resolve(new $b8e30b448f738d08$export$9f633d56d7ec90d3(body, options));
            }, 0);
        };
        xhr.onerror = function() {
            setTimeout(function() {
                reject(new TypeError('Network request failed'));
            }, 0);
        };
        xhr.ontimeout = function() {
            setTimeout(function() {
                reject(new TypeError('Network request timed out'));
            }, 0);
        };
        xhr.onabort = function() {
            setTimeout(function() {
                reject(new $b8e30b448f738d08$export$fe58bcf938607f6a('Aborted', 'AbortError'));
            }, 0);
        };
        function fixUrl(url) {
            try {
                return url === '' && $b8e30b448f738d08$var$g.location.href ? $b8e30b448f738d08$var$g.location.href : url;
            } catch (e) {
                return url;
            }
        }
        xhr.open(request.method, fixUrl(request.url), true);
        if (request.credentials === 'include') xhr.withCredentials = true;
        else if (request.credentials === 'omit') xhr.withCredentials = false;
        if ('responseType' in xhr) {
            if ($b8e30b448f738d08$var$support.blob) xhr.responseType = 'blob';
            else if ($b8e30b448f738d08$var$support.arrayBuffer) xhr.responseType = 'arraybuffer';
        }
        if (init && typeof init.headers === 'object' && !(init.headers instanceof $b8e30b448f738d08$export$79b704688b15c0f4 || $b8e30b448f738d08$var$g.Headers && init.headers instanceof $b8e30b448f738d08$var$g.Headers)) {
            var names = [];
            Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                names.push($b8e30b448f738d08$var$normalizeName(name));
                xhr.setRequestHeader(name, $b8e30b448f738d08$var$normalizeValue(init.headers[name]));
            });
            request.headers.forEach(function(value, name) {
                if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
            });
        } else request.headers.forEach(function(value, name) {
            xhr.setRequestHeader(name, value);
        });
        if (request.signal) {
            request.signal.addEventListener('abort', abortXhr);
            xhr.onreadystatechange = function() {
                // DONE (success or failure)
                if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
            };
        }
        xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    });
}
$b8e30b448f738d08$export$e7aa7bc5c1b3cfb3.polyfill = true;
if (!$b8e30b448f738d08$var$g.fetch) {
    $b8e30b448f738d08$var$g.fetch = $b8e30b448f738d08$export$e7aa7bc5c1b3cfb3;
    $b8e30b448f738d08$var$g.Headers = $b8e30b448f738d08$export$79b704688b15c0f4;
    $b8e30b448f738d08$var$g.Request = $b8e30b448f738d08$export$7fa6c5b6f8193917;
    $b8e30b448f738d08$var$g.Response = $b8e30b448f738d08$export$9f633d56d7ec90d3;
}

});



parcelRegister("fSNBK", function(module, exports) {

$parcel$export(module.exports, "useMessageEvent", () => $270b6426b92107fa$export$3cbbf1e81e2ecb39);

var $hWRix = parcelRequire("hWRix");
var $gHZ4O = parcelRequire("gHZ4O");

var $11KUO = parcelRequire("11KUO");

var $9uYQQ = parcelRequire("9uYQQ");

var $eyw2y = parcelRequire("eyw2y");

var $5uXOq = parcelRequire("5uXOq");

var $cEPXa = parcelRequire("cEPXa");

var $lFhz5 = parcelRequire("lFhz5");

var $kS28O = parcelRequire("kS28O");
const $270b6426b92107fa$export$3cbbf1e81e2ecb39 = ()=>{
    if (!globalThis.window.postOfficeMessageEventClient) globalThis.window.postOfficeMessageEventClient = new (0, $lFhz5.MessageEventClient)();
    const client = globalThis.window.postOfficeMessageEventClient;
    const { dismissMessageFromPlacement: dismissMessageFromPlacement, markReadFromPlacement: markReadFromPlacement, markClickedFromPlacement: markClickedFromPlacement, markViewedFromPlacement: markViewedFromPlacement, snoozeMessageFromPlacement: snoozeMessageFromPlacement } = (0, $hWRix.useMessagePlacementHooks)();
    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, transactionAccountId: transactionAccountId, analyticsDetails: analyticsDetails } = (0, $11KUO.useMessageContext)();
    const { placementId: placementId } = (0, $9uYQQ.usePlacementContext)();
    const browserContext = (0, $gHZ4O.usePostOfficeContext)();
    const recommendationContext = (0, $eyw2y.useRecommendationContext)();
    const context = {
        browser: browserContext,
        recommendation: recommendationContext
    };
    /**
	 * Marks all messages as read. Calls markAllAsReadEvent() as the API call
	 */ const markAllAsRead = (0, $5uXOq.useCallback)(async (messages)=>{
        const messagesEventPostPayload = messages.map((message)=>{
            const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId } = message;
            if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $cEPXa.MessageLifecycleContextError)();
            return {
                messageInstanceId: message['messageInstanceId'],
                messageTemplateId: message['messageTemplateId'],
                type: (0, $kS28O.InAppMessageEventType).Read,
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            };
        });
        try {
            await client.markAllAsReadEvent(messagesEventPostPayload);
        } catch (error) {
            throw new (0, $cEPXa.MessageLifecycleClientError)();
        }
    }, [
        client,
        placementId,
        analyticsDetails,
        context
    ]);
    /**
	 * Marks a message as read. Calls sendEvent() as the API call
	 * has to happen immediately.
	 */ const messageRead = (0, $5uXOq.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $cEPXa.MessageLifecycleContextError)();
        markReadFromPlacement({
            messageInstanceId: messageInstanceId
        });
        try {
            await client.sendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                type: (0, $kS28O.InAppMessageEventType).Read,
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            });
        } catch (error) {
            throw new (0, $cEPXa.MessageLifecycleClientError)();
        }
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        markReadFromPlacement
    ]);
    /**
	 * Marks a message as unread. Calls sendEvent() as the API call
	 * has to happen immediately.
	 */ const messageUnread = (0, $5uXOq.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $cEPXa.MessageLifecycleContextError)();
        try {
            await client.sendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                type: (0, $kS28O.InAppMessageEventType).Unread,
                placement: placementId,
                createdAt: Date.now(),
                context: context,
                analyticsDetails: analyticsDetails
            });
        } catch (error) {
            throw new (0, $cEPXa.MessageLifecycleClientError)();
        }
    }, [
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context
    ]);
    /**
	 * Marks a message as viewed. This event is fired automatically and should not need to be fired manually in the message component.
	 */ const messageViewed = (0, $5uXOq.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $cEPXa.MessageLifecycleContextError)();
        markViewedFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $kS28O.InAppMessageEventType).Viewed,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        markViewedFromPlacement
    ]);
    /**
	 * Marks a message as clicked.
	 * This event is used as a positive reward to train the Post Office Defacto Bandit ML Model.
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 */ const messageClicked = (0, $5uXOq.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $cEPXa.MessageLifecycleContextError)();
        markClickedFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $kS28O.InAppMessageEventType).Clicked,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        markClickedFromPlacement
    ]);
    /**
	 * Marks a message as clicked.
	 * This event is used as a positive reward to train the Post Office Defacto Bandit ML Model.
	 * Lower value than messageClicked (use for options like: "Learn More"), not to be used as a dismiss
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 */ const messageClickedSecondary = (0, $5uXOq.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $cEPXa.MessageLifecycleContextError)();
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $kS28O.InAppMessageEventType).ClickedSecondary,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId
    ]);
    /**
	 * Marks a message as acknowledged
	 */ const messageAcknowledged = (0, $5uXOq.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $cEPXa.MessageLifecycleContextError)();
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $kS28O.InAppMessageEventType).Acknowledged,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId
    ]);
    /**
	 * Marks a message as dismissed.
	 * This event is used as a negative reward to train the Post Office Defacto Bandit ML Model.
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 */ const messageDismissed = (0, $5uXOq.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $cEPXa.MessageLifecycleContextError)();
        dismissMessageFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $kS28O.InAppMessageEventType).Dismissed,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        dismissMessageFromPlacement
    ]);
    /**
	 * Marks a message as snoozed.
	 * This event is not used to train the Post Office Defacto Bandit ML Model.
	 */ const messageSnoozed = (0, $5uXOq.useCallback)(async (snoozeDays)=>{
        const MILLIS_IN_A_DAY = 86400000;
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $cEPXa.MessageLifecycleContextError)();
        snoozeMessageFromPlacement({
            messageInstanceId: messageInstanceId
        });
        const statusExpiryTime = Date.now() + snoozeDays * MILLIS_IN_A_DAY;
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $kS28O.InAppMessageEventType).Snoozed,
            placement: placementId,
            createdAt: Date.now(),
            statusExpiryTime: statusExpiryTime,
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        snoozeMessageFromPlacement
    ]);
    return {
        markAllAsRead: markAllAsRead,
        messageRead: messageRead,
        messageUnread: messageUnread,
        messageViewed: messageViewed,
        messageClicked: messageClicked,
        messageClickedSecondary: messageClickedSecondary,
        messageAcknowledged: messageAcknowledged,
        messageDismissed: messageDismissed,
        messageSnoozed: messageSnoozed
    };
};

});
parcelRegister("cEPXa", function(module, exports) {

$parcel$export(module.exports, "MessageLifecycleContextError", () => $42af47fd4a7ac700$export$12bb62b204112f55);
$parcel$export(module.exports, "MessageLifecycleClientError", () => $42af47fd4a7ac700$export$44f397e2afeb89e0);
class $42af47fd4a7ac700$export$12bb62b204112f55 extends Error {
    constructor(){
        super('useMessageLifecycle must be used inside a Message template render component.');
    }
}
class $42af47fd4a7ac700$export$44f397e2afeb89e0 extends Error {
    constructor(){
        super('API call to /messages failed due to an error');
    }
}

});

parcelRegister("lFhz5", function(module, exports) {

$parcel$export(module.exports, "MessageEventClient", () => $fb9d10d91fecaeaf$export$ae86a6dabe385178);
const $fb9d10d91fecaeaf$var$DEFAULT_PATH = `/gateway/api/post-office/api/v1/messages/lifecycle`;
const $fb9d10d91fecaeaf$var$FLUSH_BATCH_EVENTS_TIMEOUT = 1000;
const $fb9d10d91fecaeaf$var$MESSAGE_EVENTS_BATCH_SIZE = 250;

if (typeof fetch === 'undefined') // If fetch is not supported, load the polyfill.
(parcelRequire("fS9d8"));
class $fb9d10d91fecaeaf$export$ae86a6dabe385178 {
    async sendEvent(event) {
        const url = `${this.endpointUrl}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(event)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send event to analytics endpoint: ${response.statusText}`);
    }
    batchSendEvent(event) {
        this.batchEvents.push(event);
        if (this.scheduledTimeout === null) this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $fb9d10d91fecaeaf$var$FLUSH_BATCH_EVENTS_TIMEOUT);
    }
    async markAllAsReadEvent(messages) {
        this.batchEvents.push(...messages);
        await this.flushBatchEvents();
    }
    async sendMessageEvents(events) {
        const url = `${this.endpointUrl}/bulk`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(events)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send batch events to analytics endpoint: ${response.statusText}`);
    }
    async flushBatchEvents() {
        if (this.batchEvents.length === 0) return;
        if (this.batchEvents.length > $fb9d10d91fecaeaf$var$MESSAGE_EVENTS_BATCH_SIZE) {
            const batch = this.batchEvents.slice(0, $fb9d10d91fecaeaf$var$MESSAGE_EVENTS_BATCH_SIZE);
            await this.sendMessageEvents(batch);
            if (this.scheduledTimeout !== null) globalThis.window.clearTimeout(this.scheduledTimeout);
            this.batchEvents = this.batchEvents.slice($fb9d10d91fecaeaf$var$MESSAGE_EVENTS_BATCH_SIZE, this.batchEvents.length);
            this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $fb9d10d91fecaeaf$var$FLUSH_BATCH_EVENTS_TIMEOUT);
            return;
        }
        await this.sendMessageEvents(this.batchEvents);
        this.batchEvents = [];
        if (this.scheduledTimeout !== null) {
            globalThis.window.clearTimeout(this.scheduledTimeout);
            this.scheduledTimeout = null;
        }
    }
    constructor(){
        this.endpointUrl = $fb9d10d91fecaeaf$var$DEFAULT_PATH;
        this.scheduledTimeout = null;
        this.batchEvents = [];
    }
}

});

parcelRegister("kS28O", function(module, exports) {

$parcel$export(module.exports, "InAppMessageEventType", () => $dcec6730a4b87bfc$export$b31ffc6f7c85f1b);
var $dcec6730a4b87bfc$export$b31ffc6f7c85f1b = /*#__PURE__*/ function(InAppMessageEventType) {
    InAppMessageEventType["Viewed"] = "viewed";
    InAppMessageEventType["Acknowledged"] = "acknowledged";
    InAppMessageEventType["Clicked"] = "clicked";
    InAppMessageEventType["ClickedSecondary"] = "clickedSecondary";
    InAppMessageEventType["Dismissed"] = "dismissed";
    InAppMessageEventType["Snoozed"] = "snoozed";
    InAppMessageEventType["Read"] = "read";
    InAppMessageEventType["Unread"] = "unread";
    return InAppMessageEventType;
}({});

});



parcelRegister("dTWVS", function(module, exports) {

$parcel$export(module.exports, "createRender", () => $7751f509bdc25228$export$78c758434c34d601);

var $favav = parcelRequire("favav");
const { createRender: $7751f509bdc25228$export$78c758434c34d601, createValidate: $7751f509bdc25228$export$2859a83e4d6da57d } = (0, $favav.createClientPipeline)();
const { createHydrate: $7751f509bdc25228$export$c905bc718befd59b, createHydrateExample: $7751f509bdc25228$export$1f41223e5b0a6622, createTransformMetadata: $7751f509bdc25228$export$88fe13b4d13f8423 } = (0, $favav.createServerPipeline)();

});
parcelRegister("favav", function(module, exports) {

$parcel$export(module.exports, "createServerPipeline", () => $fbda18cad6dafa25$export$b8fedcd4634de5cd);
$parcel$export(module.exports, "createClientPipeline", () => $fbda18cad6dafa25$export$7d57dbe7f7617174);

var $2OMIu = parcelRequire("2OMIu");

var $lfabi = parcelRequire("lfabi");
const $fbda18cad6dafa25$export$7693b71d48f1bf7e = ()=>(render)=>(renderProps)=>{
            const rendered = render(renderProps);
            if (rendered === null) return null;
            return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lfabi.MessageViewed), {}),
                    rendered
                ]
            });
        };
const $fbda18cad6dafa25$export$b4a84c754a962eee = ()=>(transformMetadata)=>(params)=>transformMetadata(params);
const $fbda18cad6dafa25$export$62864968b8b09cdf = ()=>(hydrate)=>(requestContext, placementContext, messageContext)=>hydrate(requestContext, placementContext, messageContext);
const $fbda18cad6dafa25$var$exampleHydrator = (hydrateExample, config)=>(_requestContext, placementContext, messageContext)=>{
        const _config = config;
        return {
            ...hydrateExample({
                ..._config?.requestContext ?? {}
            }, placementContext, messageContext),
            ..._config?.additionalRenderProps ?? {}
        };
    };
const $fbda18cad6dafa25$export$803c53721d530406 = ()=>(hydrateExample, config)=>$fbda18cad6dafa25$var$exampleHydrator(hydrateExample, config);
const $fbda18cad6dafa25$var$initializeValidate = ()=>(validate)=>(apiResponse)=>{
            try {
                validate(apiResponse);
            } catch (error) {
                throw error instanceof Error ? error : new Error(typeof error === 'string' ? error : 'Unknown validation error');
            }
            return apiResponse;
        };
const $fbda18cad6dafa25$export$b8fedcd4634de5cd = ()=>({
        createHydrate: $fbda18cad6dafa25$export$62864968b8b09cdf(),
        createHydrateExample: $fbda18cad6dafa25$export$803c53721d530406(),
        createTransformMetadata: $fbda18cad6dafa25$export$b4a84c754a962eee()
    });
const $fbda18cad6dafa25$export$7d57dbe7f7617174 = ()=>({
        createValidate: $fbda18cad6dafa25$var$initializeValidate(),
        createRender: $fbda18cad6dafa25$export$7693b71d48f1bf7e()
    });

});
parcelRegister("lfabi", function(module, exports) {

$parcel$export(module.exports, "ManualMessageViewedEvent", () => $164074931767d675$export$de534803cb07dfcc);
$parcel$export(module.exports, "MessageViewed", () => $164074931767d675$export$14fe1fc3395b6e3f);

var $2OMIu = parcelRequire("2OMIu");

var $bMrPe = parcelRequire("bMrPe");

var $fSNBK = parcelRequire("fSNBK");

var $5uXOq = parcelRequire("5uXOq");

var $huaDn = parcelRequire("huaDn");

var $howih = parcelRequire("howih");

var $duiP6 = parcelRequire("duiP6");
const $164074931767d675$export$de534803cb07dfcc = ({ children: children })=>{
    const { fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent, setFireMessageViewedInMessageComponent: setFireMessageViewedInMessageComponent } = (0, $howih.useMessageAnalyticsContext)();
    if (fireMessageViewedInMessageComponent) setFireMessageViewedInMessageComponent(true);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};
const $164074931767d675$export$14fe1fc3395b6e3f = ()=>{
    const { fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent } = (0, $howih.useMessageAnalyticsContext)();
    const { messageViewed: messageViewed } = (0, $fSNBK.useMessageEvent)();
    const { messageInstanceViewed: messageInstanceViewed, messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully } = (0, $bMrPe.useMessageInstanceEvent)();
    const hasDeliveredSuccessfullyBeenFired = (0, $5uXOq.useRef)(false);
    // Only fire the delivery successful event once.
    (0, $5uXOq.useEffect)(()=>{
        if (!hasDeliveredSuccessfullyBeenFired.current) {
            hasDeliveredSuccessfullyBeenFired.current = true;
            messageInstanceDeliveredSuccessfully();
        }
    }, [
        messageInstanceDeliveredSuccessfully
    ]);
    // messageViewed returns a promise of void, which is incompatible with the TrackMount onMount prop
    const messageViewedVoidFunction = (0, $5uXOq.useCallback)(()=>{
        // Only fire the message viewed event if the message viewed event is not fired in the message component.
        if (fireMessageViewedInMessageComponent && !fireMessageViewedInMessageComponent.current) {
            messageViewed();
            messageInstanceViewed();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $duiP6.TrackMount), {
        onMount: messageViewedVoidFunction
    });
};
const $164074931767d675$export$4c73c6f545b966b7 = ({ children: children })=>{
    const messageRef = (0, $5uXOq.useRef)(null);
    const { messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully } = (0, $bMrPe.useMessageInstanceEvent)();
    const { inViewport: inViewport, enterCount: enterCount } = (0, $huaDn.useInViewport)(messageRef, {});
    const hasDeliveredSuccessfullyBeenFired = (0, $5uXOq.useRef)(false);
    // Only fire the delivery successful event once.
    (0, $5uXOq.useEffect)(()=>{
        if (!hasDeliveredSuccessfullyBeenFired.current) {
            hasDeliveredSuccessfullyBeenFired.current = true;
            messageInstanceDeliveredSuccessfully();
        }
    }, [
        messageInstanceDeliveredSuccessfully
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("section", {
        ref: messageRef,
        children: [
            inViewport && enterCount >= 1 ? /*#__PURE__*/ (0, $2OMIu.jsx)($164074931767d675$export$14fe1fc3395b6e3f, {}) : null,
            children
        ]
    });
};

});
parcelRegister("huaDn", function(module, exports) {

$parcel$export(module.exports, "useInViewport", () => $cbad7cb89a03ebf8$export$6215040b989f9b0f, (v) => $cbad7cb89a03ebf8$export$6215040b989f9b0f = v);
var $cbad7cb89a03ebf8$export$1e511d4a378977f5;
var $cbad7cb89a03ebf8$export$6215040b989f9b0f;
var $cbad7cb89a03ebf8$export$436b63fa4855237f;
var $cbad7cb89a03ebf8$export$2e2bcd8739ae039;
var $cbad7cb89a03ebf8$export$95cef81be5ddcfd4;
"use strict";
$cbad7cb89a03ebf8$export$1e511d4a378977f5 = true;
$cbad7cb89a03ebf8$export$6215040b989f9b0f = $cbad7cb89a03ebf8$export$436b63fa4855237f = $cbad7cb89a03ebf8$export$2e2bcd8739ae039 = $cbad7cb89a03ebf8$export$95cef81be5ddcfd4 = void 0;

var $cbad7cb89a03ebf8$var$_handleViewport = $cbad7cb89a03ebf8$var$_interopRequireDefault((parcelRequire("T3qHg")));
$cbad7cb89a03ebf8$export$436b63fa4855237f = $cbad7cb89a03ebf8$var$_handleViewport.default;

var $cbad7cb89a03ebf8$var$_useInViewport = $cbad7cb89a03ebf8$var$_interopRequireDefault((parcelRequire("3FJrj")));
$cbad7cb89a03ebf8$export$6215040b989f9b0f = $cbad7cb89a03ebf8$var$_useInViewport.default;
function $cbad7cb89a03ebf8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var $cbad7cb89a03ebf8$var$customProps = $cbad7cb89a03ebf8$export$95cef81be5ddcfd4 = [
    'inViewport',
    'enterCount',
    'leaveCount'
];
var $cbad7cb89a03ebf8$var$_default = $cbad7cb89a03ebf8$export$2e2bcd8739ae039 = $cbad7cb89a03ebf8$var$_handleViewport.default;

});
parcelRegister("T3qHg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $0a57cc36f8cb8118$export$1e511d4a378977f5, (v) => $0a57cc36f8cb8118$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $0a57cc36f8cb8118$export$2e2bcd8739ae039, (v) => $0a57cc36f8cb8118$export$2e2bcd8739ae039 = v);
var $0a57cc36f8cb8118$export$1e511d4a378977f5;
var $0a57cc36f8cb8118$export$2e2bcd8739ae039;
"use strict";
$0a57cc36f8cb8118$export$1e511d4a378977f5 = true;
$0a57cc36f8cb8118$export$2e2bcd8739ae039 = void 0;

var $5uXOq = parcelRequire("5uXOq");

var $0a57cc36f8cb8118$var$_hoistNonReactStatics = $0a57cc36f8cb8118$var$_interopRequireDefault((parcelRequire("dY8Js")));

var $0a57cc36f8cb8118$var$_useInViewport = $0a57cc36f8cb8118$var$_interopRequireDefault((parcelRequire("3FJrj")));

var $1aHjR = parcelRequire("1aHjR");

var $2OMIu = parcelRequire("2OMIu");
var $0a57cc36f8cb8118$var$_excluded = [
    "onEnterViewport",
    "onLeaveViewport"
];
function $0a57cc36f8cb8118$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $0a57cc36f8cb8118$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $0a57cc36f8cb8118$var$_extends() {
    return $0a57cc36f8cb8118$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0a57cc36f8cb8118$var$_extends.apply(null, arguments);
}
function $0a57cc36f8cb8118$var$handleViewport(TargetComponent, options, config) {
    if (options === void 0) options = $1aHjR.defaultOptions;
    if (config === void 0) config = $1aHjR.defaultConfig;
    var ForwardedRefComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
        var refProps = {
            forwardedRef: ref
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)(TargetComponent, $0a57cc36f8cb8118$var$_extends({}, props, refProps));
    });
    var InViewport = (_ref)=>{
        var { onEnterViewport: onEnterViewport = $1aHjR.noop, onLeaveViewport: onLeaveViewport = $1aHjR.noop } = _ref, restProps = $0a57cc36f8cb8118$var$_objectWithoutPropertiesLoose(_ref, $0a57cc36f8cb8118$var$_excluded);
        var node = (0, $5uXOq.useRef)(null);
        var { inViewport: inViewport, enterCount: enterCount, leaveCount: leaveCount } = (0, $0a57cc36f8cb8118$var$_useInViewport.default)(node, options, config, {
            onEnterViewport: onEnterViewport,
            onLeaveViewport: onLeaveViewport
        });
        var props = $0a57cc36f8cb8118$var$_extends({}, restProps, {
            inViewport: inViewport,
            enterCount: enterCount,
            leaveCount: leaveCount
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)(ForwardedRefComponent, $0a57cc36f8cb8118$var$_extends({}, props, {
            ref: node
        }));
    };
    var name = TargetComponent.displayName || TargetComponent.name || 'Component';
    InViewport.displayName = "handleViewport(" + name + ")";
    return (0, $0a57cc36f8cb8118$var$_hoistNonReactStatics.default)(InViewport, ForwardedRefComponent);
}
var $0a57cc36f8cb8118$var$_default = $0a57cc36f8cb8118$export$2e2bcd8739ae039 = $0a57cc36f8cb8118$var$handleViewport;

});
parcelRegister("3FJrj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $2ac872c90dc0d9fc$export$1e511d4a378977f5, (v) => $2ac872c90dc0d9fc$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $2ac872c90dc0d9fc$export$2e2bcd8739ae039, (v) => $2ac872c90dc0d9fc$export$2e2bcd8739ae039 = v);
var $2ac872c90dc0d9fc$export$1e511d4a378977f5;
var $2ac872c90dc0d9fc$export$2e2bcd8739ae039;
"use strict";
$2ac872c90dc0d9fc$export$1e511d4a378977f5 = true;
$2ac872c90dc0d9fc$export$2e2bcd8739ae039 = void 0;

var $5uXOq = parcelRequire("5uXOq");

var $1aHjR = parcelRequire("1aHjR");
var $2ac872c90dc0d9fc$var$defaultMutationObserverOption = {
    attributes: true,
    childList: true,
    subtree: true
};
var $2ac872c90dc0d9fc$var$useInViewport = function useInViewport(target, options, config, props) {
    if (options === void 0) options = $1aHjR.defaultOptions;
    if (config === void 0) config = $1aHjR.defaultConfig;
    if (props === void 0) props = $1aHjR.defaultProps;
    var { onEnterViewport: onEnterViewport, onLeaveViewport: onLeaveViewport } = props;
    var [, forceUpdate] = (0, $5uXOq.useState)();
    var observer = (0, $5uXOq.useRef)();
    var inViewportRef = (0, $5uXOq.useRef)(false);
    var intersected = (0, $5uXOq.useRef)(false);
    var enterCountRef = (0, $5uXOq.useRef)(0);
    var leaveCountRef = (0, $5uXOq.useRef)(0);
    // State to track when target is available
    var [isTargetReady, setIsTargetReady] = (0, $5uXOq.useState)(Boolean(target.current));
    function startObserver(_ref) {
        var { observerRef: observerRef } = _ref;
        var targetRef = target.current;
        if (targetRef) {
            var node = targetRef;
            if (node) observerRef == null || observerRef.observe(node);
        }
    }
    function stopObserver(_ref2) {
        var { observerRef: observerRef } = _ref2;
        var targetRef = target.current;
        if (targetRef) {
            var node = targetRef;
            if (node) observerRef == null || observerRef.unobserve(node);
        }
        observerRef == null || observerRef.disconnect();
        observer.current = null;
    }
    var handleIntersection = (entries)=>{
        var entry = entries[0] || {};
        var { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = entry;
        var isInViewport = typeof isIntersecting !== 'undefined' ? isIntersecting : intersectionRatio > 0;
        // enter
        if (!intersected.current && isInViewport) {
            intersected.current = true;
            onEnterViewport == null || onEnterViewport();
            enterCountRef.current += 1;
            inViewportRef.current = isInViewport;
            forceUpdate(isInViewport);
            return;
        }
        // leave
        if (intersected.current && !isInViewport) {
            intersected.current = false;
            onLeaveViewport == null || onLeaveViewport();
            if (config.disconnectOnLeave && observer.current) // disconnect observer on leave
            observer.current.disconnect();
            leaveCountRef.current += 1;
            inViewportRef.current = isInViewport;
            forceUpdate(isInViewport);
        }
    };
    function initIntersectionObserver(_ref3) {
        var { observerRef: observerRef } = _ref3;
        if (!observerRef) {
            observer.current = new IntersectionObserver(handleIntersection, options);
            return observer.current;
        }
        return observerRef;
    }
    (0, $5uXOq.useEffect)(()=>{
        var observerRef = observer.current;
        // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
        observerRef = initIntersectionObserver({
            observerRef: observerRef
        });
        startObserver({
            observerRef: observerRef
        });
        return ()=>{
            stopObserver({
                observerRef: observerRef
            });
        };
    }, [
        target.current,
        options,
        config,
        onEnterViewport,
        onLeaveViewport
    ]);
    // Use MutationObserver to detect when `target.current` becomes non-null
    // only at start up
    (0, $5uXOq.useEffect)(()=>{
        var currentElement = target.current;
        var mutationObserver = null;
        // MutationObserver callback to check when the target ref is assigned
        var handleOnChange = ()=>{
            if (target.current && !isTargetReady) {
                setIsTargetReady(true);
                if (mutationObserver) mutationObserver.disconnect();
            }
        };
        if (currentElement) setIsTargetReady(true); // If target is already available, mark it ready
        else {
            // Observe changes to detect when `target.current` becomes non-null
            mutationObserver = new MutationObserver(handleOnChange);
            mutationObserver.observe(document.body, $2ac872c90dc0d9fc$var$defaultMutationObserverOption);
        }
        // Cleanup function to stop observing when the component unmounts
        return ()=>{
            if (mutationObserver) mutationObserver.disconnect();
        };
    }, [
        target.current
    ]);
    return {
        inViewport: inViewportRef.current,
        enterCount: enterCountRef.current,
        leaveCount: leaveCountRef.current
    };
};
var $2ac872c90dc0d9fc$var$_default = $2ac872c90dc0d9fc$export$2e2bcd8739ae039 = $2ac872c90dc0d9fc$var$useInViewport;

});
parcelRegister("1aHjR", function(module, exports) {

$parcel$export(module.exports, "noop", () => $0da853e95098c517$export$8793edee2d425525, (v) => $0da853e95098c517$export$8793edee2d425525 = v);
$parcel$export(module.exports, "defaultProps", () => $0da853e95098c517$export$9c21a3269931e1e6, (v) => $0da853e95098c517$export$9c21a3269931e1e6 = v);
$parcel$export(module.exports, "defaultOptions", () => $0da853e95098c517$export$ba43bf67f3d48107, (v) => $0da853e95098c517$export$ba43bf67f3d48107 = v);
$parcel$export(module.exports, "defaultConfig", () => $0da853e95098c517$export$f84bd70098573c5c, (v) => $0da853e95098c517$export$f84bd70098573c5c = v);
var $0da853e95098c517$export$1e511d4a378977f5;
var $0da853e95098c517$export$8793edee2d425525;
var $0da853e95098c517$export$9c21a3269931e1e6;
var $0da853e95098c517$export$ba43bf67f3d48107;
var $0da853e95098c517$export$f84bd70098573c5c;
"use strict";
$0da853e95098c517$export$1e511d4a378977f5 = true;
$0da853e95098c517$export$8793edee2d425525 = $0da853e95098c517$export$9c21a3269931e1e6 = $0da853e95098c517$export$ba43bf67f3d48107 = $0da853e95098c517$export$f84bd70098573c5c = void 0;
var $0da853e95098c517$var$defaultOptions = $0da853e95098c517$export$ba43bf67f3d48107 = {};
var $0da853e95098c517$var$defaultConfig = $0da853e95098c517$export$f84bd70098573c5c = {
    disconnectOnLeave: false
};
var $0da853e95098c517$var$noop = ()=>{};
$0da853e95098c517$export$8793edee2d425525 = $0da853e95098c517$var$noop;
var $0da853e95098c517$var$defaultProps = $0da853e95098c517$export$9c21a3269931e1e6 = {
    onEnterViewport: $0da853e95098c517$var$noop,
    onLeaveViewport: $0da853e95098c517$var$noop
};

});









parcelRegister("bzbRq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6b8c9d818ef4c67$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $4G4pA = parcelRequire("4G4pA");
var $f6b8c9d818ef4c67$export$2e2bcd8739ae039 = {
    'message-template-template': (0, $4G4pA.default)
};

});
parcelRegister("4G4pA", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c15219be231779c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $8krEN = parcelRequire("8krEN");
parcelRequire("5uXOq");

var $43q8q = parcelRequire("43q8q");
const $8c15219be231779c$export$b3890eb0ae9dca99 = (0, $43q8q.createRender)(()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $8krEN.TopBannerMessage), {}));
var $8c15219be231779c$export$2e2bcd8739ae039 = $8c15219be231779c$export$b3890eb0ae9dca99;

});
parcelRegister("43q8q", function(module, exports) {

$parcel$export(module.exports, "createRender", () => $68675eaf30dbe82e$export$78c758434c34d601);

var $favav = parcelRequire("favav");
const { createRender: $68675eaf30dbe82e$export$78c758434c34d601, createValidate: $68675eaf30dbe82e$export$2859a83e4d6da57d } = (0, $favav.createClientPipeline)();
const { createHydrate: $68675eaf30dbe82e$export$c905bc718befd59b, createHydrateExample: $68675eaf30dbe82e$export$1f41223e5b0a6622, createTransformMetadata: $68675eaf30dbe82e$export$88fe13b4d13f8423 } = (0, $favav.createServerPipeline)();

});




/* GeneratedContentHash: 90a7d45c313eaf24d28f3e71b65ecf55df9e4f5806226e92484289f49713e5bf */ /*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for server side use only
*/ const $f34ff9e8ab1c2d91$export$a5cfae247d8360ef = 'jira-top-banner';

parcelRegister("7Qn1B", function(module, exports) {

$parcel$export(module.exports, "withJiraTopBannerIntlProvider", () => $217bef3fffee95e7$export$2a49ebed7015cea4);
/**
 * This file was automatically generated using "yarn generate:all" command.
 * Please do not edit it manually.
 * 
 * Generate source: local/cli/src/commands/placements/generate-intl-provider.ts
 **/ 
var $frIzT = parcelRequire("frIzT");

var $6PV9e = parcelRequire("6PV9e");

var $gWg7c = parcelRequire("gWg7c");
const $217bef3fffee95e7$export$d5a462ce7bd04520 = async (locale)=>{
    return Promise.allSettled([
        (0, $6PV9e.messagesLoader)(locale),
        (0, $gWg7c.messagesLoader)(locale)
    ]).then((results)=>{
        return results.reduce((acc, result)=>{
            if (result.status === 'fulfilled') return {
                messages: {
                    ...acc.messages,
                    ...result.value
                },
                errors: [
                    ...acc.errors
                ]
            };
            else if (result.status === 'rejected') return {
                messages: {
                    ...acc.messages
                },
                errors: [
                    ...acc.errors,
                    `Failed to load translations with ${result.reason}`
                ]
            };
            return acc;
        }, {
            messages: {},
            errors: []
        });
    });
};
const $217bef3fffee95e7$export$2a49ebed7015cea4 = (Component)=>{
    return (0, $frIzT.withIntlProvider)({
        messagesLoader: $217bef3fffee95e7$export$d5a462ce7bd04520
    }, Component);
};

});
parcelRegister("frIzT", function(module, exports) {

$parcel$export(module.exports, "withIntlProvider", () => $f0cadb819e07df5c$export$a5d940130f33be3f);

var $2OMIu = parcelRequire("2OMIu");

var $40p0X = parcelRequire("40p0X");
const $f0cadb819e07df5c$export$a5d940130f33be3f = (intlProviderProps, Component)=>({ preloadedMessages: preloadedMessages, ...props })=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $40p0X.IntlProvider), {
            ...intlProviderProps,
            messages: preloadedMessages,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                ...props
            })
        });
    };

});
parcelRegister("40p0X", function(module, exports) {

$parcel$export(module.exports, "IntlProvider", () => $4be13a51c2aca6d2$export$480518999dfc4151);

var $2OMIu = parcelRequire("2OMIu");

var $h3mjV = parcelRequire("h3mjV");

var $i5FdW = parcelRequire("i5FdW");
var $koVbs = parcelRequire("koVbs");

var $dIXs2 = parcelRequire("dIXs2");
function $4be13a51c2aca6d2$var$useFetchLocale() {
    let locale = 'en';
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $h3mjV.useFirePostOfficeAnalyticsEvents)();
    try {
        const { locale: intlLocale } = (0, $koVbs.default)();
        locale = intlLocale;
    } catch (err) {
        fireAnalyticsEvent({
            action: 'errored',
            actionSubject: 'intlProvider',
            eventType: 'operational',
            attributes: {
                errorMessage: err
            }
        });
    }
    return {
        locale: locale
    };
}
function $4be13a51c2aca6d2$export$480518999dfc4151(props) {
    const { locale: locale } = $4be13a51c2aca6d2$var$useFetchLocale();
    const messages = (0, $dIXs2.useIntlMessages)(locale, props.messagesLoader, props.messages);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        locale: locale,
        messages: messages,
        children: props.children
    });
}

});
parcelRegister("dIXs2", function(module, exports) {

$parcel$export(module.exports, "useIntlMessages", () => $9d5e70382fded586$export$2641ec9a2025a81f);

var $h3mjV = parcelRequire("h3mjV");

var $5uXOq = parcelRequire("5uXOq");
const $9d5e70382fded586$export$2641ec9a2025a81f = (locale, messageLoader, initialMessages)=>{
    const [messages, setMessages] = (0, $5uXOq.useState)(initialMessages);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $h3mjV.useFirePostOfficeAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (initialMessages) return;
        messageLoader(locale).then((loadedMessages)=>{
            if (loadedMessages && loadedMessages.messages) setMessages(loadedMessages.messages);
            if (loadedMessages?.errors?.length > 0) fireAnalyticsEvent({
                action: 'errored',
                actionSubject: 'intlMessagesLoader',
                eventType: 'operational',
                attributes: {
                    locale: locale,
                    errorMessage: loadedMessages.errors
                }
            });
        })// eslint-disable-next-line no-console
        .catch(console.error);
    }, [
        locale,
        initialMessages
    ]);
    return messages;
};

});



parcelRegister("6PV9e", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $618d1695d5f399bf$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $faZ3K = parcelRequire("faZ3K");

var $euiLX = parcelRequire("euiLX");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $618d1695d5f399bf$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;






























const $618d1695d5f399bf$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $euiLX.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $618d1695d5f399bf$var$importHelper(await (parcelRequire("iUwUU")));
        case 'da':
            return $618d1695d5f399bf$var$importHelper(await (parcelRequire("gl8l3")));
        case 'de':
            return $618d1695d5f399bf$var$importHelper(await (parcelRequire("8eO2U")));
        case 'en-GB':
            return $618d1695d5f399bf$var$importHelper(await (parcelRequire("9MpRJ")));
        case 'en-US':
            return $618d1695d5f399bf$var$importHelper(await (parcelRequire("hQHOo")));
        case 'en-XA':
            return $618d1695d5f399bf$var$importHelper(await (parcelRequire("jLY9a")));
        case 'en-XB':
            return $618d1695d5f399bf$var$importHelper(await (parcelRequire("fm8Dq")));
        case 'en-ZZ':
            return $618d1695d5f399bf$var$importHelper(await (parcelRequire("bAOW8")));
        case 'en':
            return $618d1695d5f399bf$var$importHelper(await Promise.resolve((parcelRequire("faZ3K"))));
        case 'es':
            return $618d1695d5f399bf$var$importHelper(await (parcelRequire("8iuTo")));
        case 'et':
            return $618d1695d5f399bf$var$importHelper(await (parcelRequire("8cHVl")));
        case 'fi':
            return $618d1695d5f399bf$var$importHelper(await (parcelRequire("ggwfL")));
        case 'fr':
            return $618d1695d5f399bf$var$importHelper(await (parcelRequire("PUQQB")));
        case 'hu':
            return $618d1695d5f399bf$var$importHelper(await (parcelRequire("fZRSZ")));
        case 'it':
            return $618d1695d5f399bf$var$importHelper(await (parcelRequire("7kGaD")));
        case 'ja':
            return $618d1695d5f399bf$var$importHelper(await (parcelRequire("49A3z")));
        case 'ko':
            return $618d1695d5f399bf$var$importHelper(await (parcelRequire("aCpfm")));
        case 'nb':
            return $618d1695d5f399bf$var$importHelper(await (parcelRequire("aTLiW")));
        case 'nl':
            return $618d1695d5f399bf$var$importHelper(await (parcelRequire("hQVPe")));
        case 'pl':
            return $618d1695d5f399bf$var$importHelper(await (parcelRequire("hGf0K")));
        case 'pt-BR':
            return $618d1695d5f399bf$var$importHelper(await (parcelRequire("9X48C")));
        case 'ro':
            return $618d1695d5f399bf$var$importHelper(await (parcelRequire("fUB1R")));
        case 'ru':
            return $618d1695d5f399bf$var$importHelper(await (parcelRequire("c5iuR")));
        case 'sv':
            return $618d1695d5f399bf$var$importHelper(await (parcelRequire("fdN58")));
        case 'th':
            return $618d1695d5f399bf$var$importHelper(await (parcelRequire("kpOFa")));
        case 'tr':
            return $618d1695d5f399bf$var$importHelper(await (parcelRequire("5zeMt")));
        case 'uk':
            return $618d1695d5f399bf$var$importHelper(await (parcelRequire("fCnub")));
        case 'vi':
            return $618d1695d5f399bf$var$importHelper(await (parcelRequire("h54cR")));
        case 'zh-CN':
            return $618d1695d5f399bf$var$importHelper(await (parcelRequire("3x6L7")));
        case 'zh-TW':
            return $618d1695d5f399bf$var$importHelper(await (parcelRequire("6N9aD")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($faZ3K));
    }
};

});
parcelRegister("faZ3K", function(module, exports) {
module.exports = JSON.parse('{"jira-issueview-quickactions.src.ui.index.recommended-for-you":[{"type":0,"value":"Recommended for you"}],"jira-pulsar.common.components.cross-flow.dismiss":[{"type":0,"value":"Dismiss"}],"jira-pulsar.common.components.issue-view-description-ad.close":[{"type":0,"value":"Close"}],"jira-pulsar.jira-common.celebration-icon.body_image_alt":[{"type":0,"value":"Celebration icon"}],"jira-pulsar.jira-common.exclamation-icon.body_image_alt":[{"type":0,"value":"Exclamation icon"}],"jira-pulsar.jira-common.message-template.text.body.display.old.field.value":[{"type":0,"value":"was: "},{"type":1,"value":"oldFieldValue"}],"jira-pulsar.jira-common.right-arrow-icon.no-translate":[{"type":0,"value":"&#x2192;"}],"jira-pulsar.jira-contact-admin.message-template.email.body.from.contact.admin":[{"type":0,"value":"From:"}],"jira-pulsar.jira-contact-admin.message-template.email.body.new.message.from.contact.admin":[{"type":0,"value":"New message from Contact Administrators page"}],"jira-pulsar.jira-contact-admin.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"header"}],"jira-pulsar.jira-issue-approval-decided.right.arrow.image.alt.no-translate":[{"type":0,"value":"->"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.assigned.to":[{"type":0,"value":"Assigned to: "},{"type":1,"value":"assignee"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.event.approvers":[{"type":0,"value":"Approvers: "}],"jira-pulsar.jira-issue-approval.message-template.email.approval.event.approvers.plus.no-translate":[{"type":0,"value":"+"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.issue.approved.by.user.subject":[{"type":1,"value":"user"},{"type":0,"value":" has approved "},{"type":1,"value":"issueLabel"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.issue.approved.subject":[{"type":1,"value":"issueLabel"},{"type":0,"value":" has been approved"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.issue.declined.by.user.subject":[{"type":1,"value":"user"},{"type":0,"value":" has declined "},{"type":1,"value":"issueLabel"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.required":[{"type":1,"value":"issueLink"},{"type":0,"value":" requires your approval"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.required.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"issueLabel"}],"jira-pulsar.jira-issue-approval.message-template.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"jira-pulsar.jira-issue-approval.message-template.email.unassigned":[{"type":0,"value":"Unassigned"}],"jira-pulsar.jira-issue-archived.message-template.redacted.email.subject":[{"type":0,"value":"("},{"type":1,"value":"issueKey"},{"type":0,"value":") work item was archived"}],"jira-pulsar.jira-issue-assign.message-template-template.email.body.heading":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"assigned"}],"type":8,"value":"b"},{"type":0,"value":" this work item to you"}],"jira-pulsar.jira-issue-assign.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" assigned "},{"type":1,"value":"issueKey"},{"type":0,"value":" to you"}],"jira-pulsar.jira-issue-assigned.email.body.assignee":[{"type":0,"value":"Assignee"}],"jira-pulsar.jira-issue-assigned.email.body.unassigned":[{"type":0,"value":"Unassigned"}],"jira-pulsar.jira-issue-comment-delete.email.body.deleted":[{"type":0,"value":"Deleted"}],"jira-pulsar.jira-issue-comment-delete.message-template.hipppa.view.update":[{"type":0,"value":"Comment: "},{"children":[{"type":0,"value":"View update"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-comment-delete.message-template.redacted.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-comment-update.email.body.added":[{"type":0,"value":"Added"}],"jira-pulsar.jira-issue-comment-update.email.body.deleted":[{"type":0,"value":"Deleted"}],"jira-pulsar.jira-issue-comment-update.email.body.edited":[{"type":0,"value":"Edited"}],"jira-pulsar.jira-issue-comment-update.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") "},{"type":1,"value":"summary"}],"jira-pulsar.jira-issue-comment-update.message-template.redacted.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-comment.body_image_alt":[{"type":0,"value":"Icon for comment on a Jira issue"}],"jira-pulsar.jira-issue-comment.email.body.add-comment":[{"type":0,"value":"Add comment"}],"jira-pulsar.jira-issue-comment.email.body.view-comment":[{"type":0,"value":"View comment"}],"jira-pulsar.jira-issue-comment.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"type":1,"value":"issuekey"}],"jira-pulsar.jira-issue-create.email.body.unassigned":[{"type":0,"value":"Unassigned"}],"jira-pulsar.jira-issue-moved.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" moved "},{"type":1,"value":"issuekey"}],"jira-pulsar.jira-issue-moved.message-template.redacted.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"issueKey"},{"type":0,"value":" Work item was updated"}],"jira-pulsar.jira-issue-reopen.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"jira-pulsar.jira-issue-reopen.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"jira-pulsar.jira-issue-reopen.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"jira-pulsar.jira-issue-reopen.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"jira-pulsar.jira-issue-reopened.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-update.email.body.slash.no-translate":[{"type":0,"value":" \u2192 "}],"jira-pulsar.jira-issue-update.message-template.changeby":[{"type":0,"value":"Change by: "},{"children":[{"type":1,"value":"actioner"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-update.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" updated "},{"type":1,"value":"issuekey"}],"jira-pulsar.jira-issue-update.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" updated "},{"type":1,"value":"issuekey"}],"jira-pulsar.jira-issue-update.message-template.hipppa.view.update":[{"children":[{"type":0,"value":"View update"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-work-started.message-template.email.body.started":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"started work on this work item"}],"type":8,"value":"color"}],"jira-pulsar.jira-issue-work-started.message-template.email.redacted.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-work-stopped.message-template.email.body.stopped":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"stopped work on this work item"}],"type":8,"value":"color"}],"jira-pulsar.jira-issue-work-stopped.message-template.email.redacted.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-worklog-delete.email.body.deleted":[{"type":0,"value":"Deleted"}],"jira-pulsar.jira-issue-worklog-delete.email.body.work.log.deleted":[{"type":0,"value":"Deleted"}],"jira-pulsar.jira-issue-worklog-update.email.body.edited":[{"type":0,"value":"Edited"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.add.worklog.title":[{"children":[{"type":1,"value":"actioner"}],"type":8,"value":"a"},{"type":0,"value":" "},{"children":[{"type":0,"value":"added a worklog"}],"type":8,"value":"strong"},{"type":0,"value":" on "},{"children":[{"type":1,"value":"issueKey"}],"type":8,"value":"b"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.change.by":[{"children":[{"type":1,"value":"actioner"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.worklog.add.comment":[{"children":[{"type":0,"value":"Add Comment"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.worklog.description":[{"children":[{"type":0,"value":"View work description"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.worklog.entry.logged.by":[{"type":1,"value":"entry"},{"type":0,"value":" logged by "},{"children":[{"type":1,"value":"actioner"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-worklogged.body_image_alt":[{"type":0,"value":"Product logo"}],"jira-xflow-confluence.placements.in-app.jira-issueview-comment.confluence":[{"type":0,"value":"Confluence"}],"jira-xflow-confluence.placements.in-app.jira-issueview-comment.ctaMessageForIssueComment":[{"type":0,"value":"Try"}],"jira-xflow-confluence.placements.in-app.jira-issueview-comment.descriptionForIssuecomment":[{"type":0,"value":"Put the details in a page to keep the description short"}],"jira-xflow-confluence.placements.in-app.jira-issueview-comment.titleForIssueComment":[{"type":0,"value":"Create a page"}],"jira-xflow-confluence.placements.in-app.jira-issueview-description-template.confluence":[{"type":0,"value":"Confluence"}],"jira-xflow-confluence.placements.in-app.jira-issueview-description-template.ctaMessageForIssueDescription":[{"type":0,"value":"Try"}],"jira-xflow-confluence.placements.in-app.jira-issueview-description-template.descriptionForIssueDescription":[{"type":0,"value":"Put the details in a page to keep the description short"}],"jira-xflow-confluence.placements.in-app.jira-issueview-description-template.titleForIssueDescription":[{"type":0,"value":"Create a page"}],"jira-xflow-confluence.placements.in-app.jira-issueview-quickactions.add":[{"type":0,"value":"Add"}],"jira-xflow-confluence.placements.in-app.jira-issueview-quickactions.confluence":[{"type":0,"value":"Confluence"}],"jira-xflow-confluence.placements.in-app.jira-issueview-quickactions.page":[{"type":0,"value":"Page"}],"jira-xflow-jpd.placements.in-app.jira-issueview-quickactions.add":[{"type":0,"value":"Add"}],"jira-xflow-jpd.placements.in-app.jira-issueview-quickactions.idea":[{"type":0,"value":"Idea"}],"jira-xflow-jpd.placements.in-app.jira-issueview-quickactions.jpd":[{"type":0,"value":"Jira Product Discovery"}],"jira-xflow-loom.placements.in-app.jira-issueview-comment.ctaMessageForIssueComment":[{"type":0,"value":"Try"}],"jira-xflow-loom.placements.in-app.jira-issueview-comment.descriptionForIssuecomment":[{"type":0,"value":"Record a comment"}],"jira-xflow-loom.placements.in-app.jira-issueview-comment.loom":[{"type":0,"value":"Loom"}],"jira-xflow-loom.placements.in-app.jira-issueview-description.ctaMessageForIssueDescription":[{"type":0,"value":"Try"}],"jira-xflow-loom.placements.in-app.jira-issueview-description.descriptionForIssueDescription":[{"type":0,"value":"Use video to explain the work"}],"jira-xflow-loom.placements.in-app.jira-issueview-description.loom":[{"type":0,"value":"Loom"}],"jira-xflow-loom.placements.in-app.jira-issueview-description.titleForIssueDescription":[{"type":0,"value":"Record your screen"}],"jira-xflow-loom.placements.in-app.jira-issueview-quickactions.add":[{"type":0,"value":"Add"}],"jira-xflow-loom.placements.in-app.jira-issueview-quickactions.loom":[{"type":0,"value":"Loom"}],"jira-xflow-loom.placements.in-app.jira-issueview-quickactions.video":[{"type":0,"value":"Video"}],"jira.default.subject":[{"type":0,"value":"[JIRA] Project Update: "},{"type":1,"value":"projectName"},{"type":0,"value":" ("},{"type":1,"value":"projectKey"},{"type":0,"value":")"}],"jira.jira-bulk.message-template.email.header":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"sent you"}],"type":8,"value":"strong"},{"type":0,"value":" a message."}],"jira.jira-bulk.message-template.email.subject.user.provided.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"subject"}],"jira.jira-bulk.message-template.text.message":[{"type":1,"value":"user"},{"type":0,"value":" sent you a message"}],"jira.jira-common.email.footer.get.apps":[{"type":0,"value":"Get Jira notifications on your phone! Download the Jira Cloud app for "}],"jira.jira-common.email.footer.give.feedback":[{"type":0,"value":"Give feedback"}],"jira.jira-common.email.footer.manage.notifications":[{"type":0,"value":"Manage Notifications"}],"jira.jira-common.email.footer.open.attachment":[{"type":0,"value":"Open the work item to view attachments over 100 KB"}],"jira.jira-common.email.footer.privacy.policy":[{"type":0,"value":"Privacy Policy"}],"jira.jira-common.email.footer.sent.by":[{"type":0,"value":"This message was sent by Atlassian Jira"}],"jira.jira-common.email.slash.no-translate":[{"type":0,"value":"\\/"}],"jira.jira-common.message-template.text.body.assignee.label":[{"type":0,"value":"Assignee:"}],"jira.jira-common.message-template.text.body.attachments.label":[{"type":0,"value":"Attachments:"}],"jira.jira-common.message-template.text.body.key.label":[{"type":0,"value":"Key:"}],"jira.jira-common.message-template.text.body.manage.notifications":[{"type":0,"value":"Manage Notifications"}],"jira.jira-common.message-template.text.body.priority.label":[{"type":0,"value":"Priority:"}],"jira.jira-common.message-template.text.body.project.label":[{"type":0,"value":"Project:"}],"jira.jira-common.message-template.text.body.reporter.heading":[{"type":0,"value":"Reporter: "}],"jira.jira-common.message-template.text.body.reporter.label":[{"type":0,"value":"Reporter:"}],"jira.jira-common.message-template.text.body.sent.by":[{"type":0,"value":"This message was sent by Atlassian Jira"}],"jira.jira-common.message-template.text.body.work.type.label":[{"type":0,"value":"Work type:"}],"jira.jira-filter-subscription.message-template.email.table.filter-label":[{"type":0,"value":"Filter: "}],"jira.jira-filter-subscription.message-template.email.table.header":[{"type":0,"value":"Work Item Subscription"}],"jira.jira-filter-subscription.message-template.email.table.subscriber-label":[{"type":0,"value":"Subscriber:"}],"jira.jira-issue-approval-decided.message-template.approval.by.user":[{"type":1,"value":"user"},{"type":0,"value":" has approved "},{"type":1,"value":"issueLink"}],"jira.jira-issue-approval-decided.message-template.approval.event.allapproved.transition":[{"type":1,"value":"issueTypeName"},{"type":0,"value":" has moved from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" "},{"type":1,"value":"arrowIcon"},{"type":0,"value":" "},{"type":1,"value":"newStatus"}],"jira.jira-issue-approval-decided.message-template.approval.event.approved.transition.plural":[{"type":1,"value":"remainingApprovals"},{"type":0,"value":" more approvals required to move this "},{"type":1,"value":"issueTypeName"},{"type":0,"value":" from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" "},{"type":1,"value":"arrowIcon"},{"type":0,"value":" "},{"type":1,"value":"newStatus"}],"jira.jira-issue-approval-decided.message-template.approval.event.approved.transition.singular":[{"type":0,"value":"1 more approval required to move this "},{"type":1,"value":"issueTypeName"},{"type":0,"value":" from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" "},{"type":1,"value":"arrowIcon"},{"type":0,"value":" "},{"type":1,"value":"newStatus"}],"jira.jira-issue-approval-decided.message-template.approval.event.declined.transition":[{"type":1,"value":"issueTypeName"},{"type":0,"value":" has moved from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" "},{"type":1,"value":"arrowIcon"},{"type":0,"value":" "},{"type":1,"value":"newStatus"}],"jira.jira-issue-approval-decided.message-template.declined.by.user":[{"type":1,"value":"user"},{"type":0,"value":" has declined "},{"type":1,"value":"issueLink"}],"jira.jira-issue-approval.message-template.approval.required.title":[{"type":1,"value":"issueLabel"},{"type":0,"value":" requires your approval"}],"jira.jira-issue-approval.message-template.approval.title.all-approved":[{"type":1,"value":"issueLink"},{"type":0,"value":" has been approved!"}],"jira.jira-issue-approval.message-template.email.approval.approved":[{"type":0,"value":"Approved"}],"jira.jira-issue-approval.message-template.email.approval.approvers.remaining":[{"type":1,"value":"remainingApprovers"},{"type":0,"value":" more approvals required to move this "},{"type":1,"value":"issueType"},{"type":0,"value":" from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" to "},{"type":1,"value":"approvedStatus"}],"jira.jira-issue-approval.message-template.email.approval.assigned.to":[{"type":0,"value":"Assigned to: "},{"type":1,"value":"assignee"}],"jira.jira-issue-approval.message-template.email.approval.declined":[{"type":0,"value":"Declined"}],"jira.jira-issue-approval.message-template.email.approval.declined.transition":[{"type":1,"value":"issueType"},{"type":0,"value":" has moved from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" to "},{"type":1,"value":"declinedStatus"}],"jira.jira-issue-approval.message-template.email.approval.event.approvers":[{"type":0,"value":"Approvers: "}],"jira.jira-issue-approval.message-template.email.approval.one.approver.remaining":[{"type":0,"value":"1 more approval required to move this "},{"type":1,"value":"issueType"},{"type":0,"value":" from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" to "},{"type":1,"value":"approvedStatus"}],"jira.jira-issue-approval.message-template.email.approval.view.work.item":[{"type":0,"value":"View "},{"type":1,"value":"issueType"}],"jira.jira-issue-approval.message-template.email.approved.by":[{"type":1,"value":"deciderName"},{"type":0,"value":" has approved "},{"type":1,"value":"issueLabel"}],"jira.jira-issue-approval.message-template.email.declined.by":[{"type":1,"value":"deciderName"},{"type":0,"value":" has declined "},{"type":1,"value":"issueLabel"}],"jira.jira-issue-approval.message-template.email.footer.contact.us":[{"type":0,"value":"Contact Us"}],"jira.jira-issue-approval.message-template.email.footer.location":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia."}],"jira.jira-issue-approval.message-template.email.footer.privacy.policy":[{"type":0,"value":"Privacy Policy"}],"jira.jira-issue-approval.message-template.email.issue.approved":[{"type":1,"value":"issueLabel"},{"type":0,"value":" has been approved!"}],"jira.jira-issue-approval.message-template.email.issue.has.moved.from":[{"type":1,"value":"issueType"},{"type":0,"value":" has moved from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" to "},{"type":1,"value":"approvedStatus"}],"jira.jira-issue-archived.message-template.email.subject":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"archived a work item."}],"type":8,"value":"strong"}],"jira.jira-issue-archived.message-template.redacted.email.subject":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"archived a work item."}],"type":8,"value":"strong"}],"jira.jira-issue-archived.message-template.text.archived.work.item":[{"type":1,"value":"user"},{"type":0,"value":" archived "},{"type":1,"value":"workItemKey"},{"type":0,"value":":"}],"jira.jira-issue-assign.text.body.assigned":[{"type":0,"value":" "},{"type":1,"value":"user"},{"type":0,"value":" reassigned "},{"type":1,"value":"issueKey"}],"jira.jira-issue-assign.text.body.assignee.update":[{"type":0,"value":"Assignee: "},{"type":1,"value":"assigneeName"},{"type":0,"value":" was: ("},{"type":1,"value":"oldAssigneeName"},{"type":0,"value":")"}],"jira.jira-issue-assign.text.body.sentby":[{"type":0,"value":"This message was sent by Atlassian Jira"}],"jira.jira-issue-batch.email.body.issue.comments.heading":[{"type":0,"value":"Comments"}],"jira.jira-issue-batch.email.body.issue.created.heading":[{"type":0,"value":"Work item created"}],"jira.jira-issue-batch.email.body.issue.updates.heading":[{"type":0,"value":"Updates"}],"jira.jira-issue-batch.email.body.issue.worklog.heading":[{"type":0,"value":"Work log"}],"jira.jira-issue-batch.email.body.summary.issue.comment.created.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" added a new comment"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" new comments"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.comment.created.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" new comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.created.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" new comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.deleted.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" deleted a comment"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.comment.deleted.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.deleted.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.updated.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" updated a comment"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.comment.updated.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.updated.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.created.heading":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"created a work item"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.deleted.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" deleted a work item"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" work items"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.dot":[{"type":0,"value":". "}],"jira.jira-issue-batch.email.body.summary.issue.fallback.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.fallback.more.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.fallback.two.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.separator.comma":[{"type":0,"value":", "}],"jira.jira-issue-batch.email.body.summary.issue.updates.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"type":1,"value":"count"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.updates.multiple.users.heading":[{"type":1,"value":"user"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.updates.two.users.heading":[{"type":1,"value":"user"},{"type":0,"value":" and "},{"type":1,"value":"user1"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.added.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" added a worklog"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.added.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.added.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.deleted.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" deleted a worklog"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.deleted.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.deleted.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.started.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" started a worklog"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  started "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.started.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  started "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.started.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  started "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.updated.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" updated a worklog"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.updated.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.updated.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.unredacted.body.summary.issue.fallback.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.unredacted.body.summary.issue.fallback.more.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.unredacted.body.summary.issue.fallback.two.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issueId"},{"type":0,"value":") "},{"type":1,"value":"summary"}],"jira.jira-issue-batch.message-template.redacted.email.subject":[{"type":0,"value":"[JIRA] Updates for "},{"type":1,"value":"issueId"}],"jira.jira-issue-closed.message-template.email.body.closed":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"closed a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-closed.message-template.text.email.body":[{"type":1,"value":"user"},{"type":0,"value":" closed "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-comment-delete.message-template.email.body.commented":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"deleted a comment on a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-comment-delete.message-template.text.comment.was.deleted":[{"type":0,"value":"Comment: was deleted"}],"jira.jira-issue-comment-delete.message-template.text.updated.work.item":[{"type":1,"value":"user"},{"type":0,"value":" updated "},{"type":1,"value":"workItemKey"},{"type":0,"value":":"}],"jira.jira-issue-comment-update.message-template.email.body.commented":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"edited a comment on a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-comment-update.message-template.text.body.comment.was":[{"type":0,"value":"was (Author: "},{"type":1,"value":"authorName"},{"type":0,"value":"):"}],"jira.jira-issue-comment-update.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" edited a comment on "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-comment.message-template.email.body.commented":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"added a comment on a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-comment.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"type":1,"value":"workItemKey"},{"type":0,"value":":"}],"jira.jira-issue-common.message-template.text.body.common.author":[{"type":0,"value":"Author:"}],"jira.jira-issue-common.message-template.text.body.common.issue.author":[{"type":0,"value":"Author:"}],"jira.jira-issue-create.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"created a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-create.email.body.view.attachments":[{"type":0,"value":"View Attachments"}],"jira.jira-issue-create.email.body.view.components":[{"type":0,"value":"View Components"}],"jira.jira-issue-create.email.body.view.description":[{"type":0,"value":"View description"}],"jira.jira-issue-create.email.body.view.environment":[{"type":0,"value":"View environment"}],"jira.jira-issue-create.email.body.view.labels":[{"type":0,"value":"View labels"}],"jira.jira-issue-create.email.body.view.work.type":[{"type":0,"value":"View Work Type"}],"jira.jira-issue-create.message-template.email.original.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issueKey"},{"type":0,"value":") "},{"type":1,"value":"summary"}],"jira.jira-issue-create.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" created "},{"type":1,"value":"issueKey"}],"jira.jira-issue-create.message-template.text.body.common.issue.key":[{"type":0,"value":"Key"}],"jira.jira-issue-create.message-template.text.body.common.summary":[{"type":0,"value":"Summary"}],"jira.jira-issue-create.message-template.text.email.body.created":[{"type":1,"value":"user"},{"type":0,"value":" created a work item"}],"jira.jira-issue-create.text.body.common.assignee":[{"type":0,"value":"Assignee"}],"jira.jira-issue-create.text.body.common.attachments":[{"type":0,"value":"Attachments"}],"jira.jira-issue-create.text.body.common.created":[{"type":0,"value":"Created"}],"jira.jira-issue-create.text.body.common.description":[{"type":0,"value":"Description"}],"jira.jira-issue-create.text.body.common.priority":[{"type":0,"value":"Priority"}],"jira.jira-issue-create.text.body.common.reporter":[{"type":0,"value":"Reporter"}],"jira.jira-issue-create.text.body.common.status":[{"type":0,"value":"Status"}],"jira.jira-issue-create.text.body.common.work.type":[{"type":0,"value":"Work type"}],"jira.jira-issue-delete.message-template.email.body.workitem.deleted":[{"type":1,"value":"actioner"},{"type":0,"value":" deleted this work item at "},{"type":1,"value":"timestamp"}],"jira.jira-issue-delete.message-template.redacted.email.body.workitem.deleted":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"deleted"}],"type":8,"value":"strong"},{"type":0,"value":" a work item"}],"jira.jira-issue-delete.message-template.text.deleted.work.item":[{"type":1,"value":"user"},{"type":0,"value":" deleted "},{"type":1,"value":"workItemKey"},{"type":0,"value":":"}],"jira.jira-issue-filter-subscription.message-template.email.subject":[{"type":0,"value":"[JIRA] Subscription: "},{"type":1,"value":"filterName"}],"jira.jira-issue-filter-subscription.message-template.text.email.body.header":[{"type":0,"value":"Work Item Subscription"}],"jira.jira-issue-filter-subscription.message-template.text.email.body.header.filter-name":[{"type":0,"value":"Filter: "},{"type":1,"value":"filterName"},{"type":1,"value":"count"}],"jira.jira-issue-filter-subscription.message-template.text.email.body.header.subscriber-info":[{"type":0,"value":"Subscriber: "},{"type":1,"value":"subscriberName"}],"jira.jira-issue-mention.email.body.colon.no-translate":[{"type":0,"value":": "}],"jira.jira-issue-mention.email.body.mentioned.you":[{"type":0,"value":" mentioned you "}],"jira.jira-issue-mention.email.body.onWorkItem.you":[{"type":0,"value":" on a work item "}],"jira.jira-issue-mention.email.body.spaces.no-translate":[{"type":0,"value":"&nbsp;&nbsp;"}],"jira.jira-issue-mention.email.body.view.work.item":[{"type":0,"value":" View work item "}],"jira.jira-issue-mention.email.subject.mention":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on "},{"type":1,"value":"issueKey"}],"jira.jira-issue-mention.push.mentioned.you":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on "},{"type":1,"value":"summary"}],"jira.jira-issue-mention.push.mentioned.you.redacted":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on this work item"}],"jira.jira-issue-mention.text.body.addComment":[{"type":0,"value":" Add Comment: "}],"jira.jira-issue-mention.text.body.manage.notifications":[{"type":0,"value":"Manage Notifications"}],"jira.jira-issue-mention.text.body.mention.hint":[{"type":0,"value":" Hint: You can mention someone in a work item description or comment by typing  \\"@\\" in front of their username."}],"jira.jira-issue-mention.text.body.mentioned":[{"type":0,"value":" mentioned you on "}],"jira.jira-issue-mention.text.body.sentby":[{"type":0,"value":"This message was sent by Atlassian Jira"}],"jira.jira-issue-mention.text.body.unassigned":[{"type":0,"value":"Unassigned"}],"jira.jira-issue-mention.text.body.viewOnline":[{"type":0,"value":" View Online: "}],"jira.jira-issue-moved.message-template.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"moved a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-moved.message-template.text.email.body":[{"type":1,"value":"user"},{"type":0,"value":" moved "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-notify.email.body.heading":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"shared"}],"type":8,"value":"b"},{"type":0,"value":" a work item with you"}],"jira.jira-issue-notify.email.subject.notify":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" shared \\""},{"type":1,"value":"issueKey"},{"type":0,"value":" "},{"type":1,"value":"summary"},{"type":0,"value":"\\" with you"}],"jira.jira-issue-reopened.message-template.email.body.reopened":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"reopened a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-reopened.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" reopened "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-resolved.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" resolved "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-search.message-template.email.subject.filter.results":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" shared the filter \\""},{"type":1,"value":"filterName"},{"type":0,"value":"\\" with you"}],"jira.jira-issue-search.message-template.email.subject.search.results":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" shared a search result with you"}],"jira.jira-issue-share.message-template.email.header.filter":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"shared"}],"type":8,"value":"strong"},{"type":0,"value":" a filter with you."}],"jira.jira-issue-share.message-template.email.header.results":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"shared"}],"type":8,"value":"strong"},{"type":0,"value":" a search result with you."}],"jira.jira-issue-share.message-template.email.shared-with":[{"type":0,"value":" Also shared with "}],"jira.jira-issue-share.message-template.email.view.results":[{"type":0,"value":"View search results"}],"jira.jira-issue-share.message-template.text.shared.filter.heading":[{"type":1,"value":"user"},{"type":0,"value":" shared a filter with you"}],"jira.jira-issue-share.message-template.text.shared.results.heading":[{"type":1,"value":"user"},{"type":0,"value":" shared a search result with you"}],"jira.jira-issue-share.message-template.text.shared.with.others":[{"type":0,"value":"Also shared with"}],"jira.jira-issue-test.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] test template "},{"type":1,"value":"issueKey"}],"jira.jira-issue-update.message-template.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"updated a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-update.message-template.email.body.worklog.change.by":[{"type":0,"value":"Change by: "}],"jira.jira-issue-update.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" updated "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-work-started.message-template.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"made "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" update"}]},"other":{"value":[{"type":7},{"type":0,"value":" updates"}]}},"pluralType":"cardinal","type":6,"value":"numberOfUpdates"}],"type":8,"value":"strong"}],"jira.jira-issue-work-started.message-template.text.header":[{"type":0,"value":"Work on "},{"type":1,"value":"workItemKey"},{"type":0,"value":" started by "},{"type":1,"value":"user"}],"jira.jira-issue-work-stopped.message-template.text.header":[{"type":0,"value":"Work on "},{"type":1,"value":"workItemKey"},{"type":0,"value":" stopped by "},{"type":1,"value":"user"}],"jira.jira-issue-worklog-delete.message-template.email.redacted.body.title":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"deleted a worklog"}],"type":8,"value":"b"},{"type":0,"value":" on a work item"}],"jira.jira-issue-worklog-deleted.message-template.text.email.body.deleted.worklog":[{"type":0,"value":"The following worklog was deleted:"}],"jira.jira-issue-worklog-update.message-template.email.body.title":[{"children":[{"type":0,"value":" made 2 updates"}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"edited 1 work log"}],"type":8,"value":"b"},{"type":0,"value":"."}],"jira.jira-issue-worklog-update.message-template.email.redacted.body.title":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"updated a worklog"}],"type":8,"value":"b"},{"type":0,"value":" on a work item"}],"jira.jira-issue-worklog-updated.message-template.email.body.description":[{"type":0,"value":"Description"}],"jira.jira-issue-worklog-updated.message-template.email.body.timeLogged":[{"type":0,"value":"Time logged"}],"jira.jira-issue-worklogged.message-template.email.body.description":[{"type":0,"value":"Description: "}],"jira.jira-issue-worklogged.message-template.email.body.logTitle":[{"type":0,"value":"Work log"}],"jira.jira-issue-worklogged.message-template.email.body.timelogged":[{"type":0,"value":"Time logged: "}],"jira.jira-issue-worklogged.message-template.email.body.title":[{"children":[{"type":0,"value":" made 2 updates"}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"added 1 work log"}],"type":8,"value":"b"},{"type":0,"value":"."}],"jira.jira-issue-worklogged.message-template.email.body.updateTitle":[{"type":0,"value":"Updates"}],"jira.jira-issue-worklogged.message-template.email.body.worklog.change.by":[{"type":0,"value":"Change by: "}],"jira.jira-issue-worklogged.message-template.email.body.worklog.entry":[{"type":0,"value":"Worklog entry:"}],"jira.jira-issue-worklogged.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" logged work on "},{"type":1,"value":"issueKey"}],"jira.jira-issue-worklogged.message-template.text.body.common.change.by":[{"type":0,"value":"Change by"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.created.on":[{"type":0,"value":"Created on:"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.edited.by":[{"type":0,"value":"Edited by:"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.edited.on":[{"type":0,"value":"Edited on:"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.key":[{"type":0,"value":"Key:"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.worklog.entry.label":[{"type":0,"value":"Worklog entry"}],"jira.jira-issue-worklogged.message-template.text.body.common.project":[{"type":0,"value":"Project:"}],"jira.jira-issue-worklogged.message-template.text.body.common.start.date":[{"type":0,"value":"Start Date:"}],"jira.jira-issue-worklogged.message-template.text.body.common.time.spent":[{"type":0,"value":"Time Spent:"}],"jira.jira-issue-worklogged.message-template.text.body.common.url":[{"type":0,"value":"URL:"}],"jira.jira-issue-worklogged.message-template.text.body.common.view.work.description":[{"type":0,"value":"View work description"}],"jira.jira-issue-worklogged.message-template.text.body.common.work.type":[{"type":0,"value":"Work type:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.body":[{"type":0,"value":"Work Description:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.description":[{"type":0,"value":"Worklog Description:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.description.was":[{"type":0,"value":"Worklog Description was:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.id":[{"type":0,"value":"Worklog Id:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.time.estimated":[{"type":0,"value":"Remaining Estimate:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.time.spent":[{"type":0,"value":"Worklog Time Spent:"}],"jira.jira-issue-worklogged.message-template.text.body.redacted.logged.by":[{"type":1,"value":"worklogEntry"},{"type":0,"value":" logged by "},{"type":1,"value":"actioner"}],"jira.jira-issue-worklogged.message-template.text.email.body.created":[{"type":1,"value":"user"},{"type":0,"value":" logged work on "},{"type":1,"value":"issueKey"}],"jira.jira-issue-worklogged.message-template.text.email.body.tracking":[{"type":0,"value":"Issue time Tracking"}],"jira.jira-project-deletion-reminder.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"header"},{"type":0,"value":" "}],"jira.jira-project-event-archived-restore.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Project restored from archive "}],"jira.jira-project-event-archived.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Project archived"}],"jira.jira-project-event-delete-failed.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Could not permanently delete the project "}],"jira.jira-project-event-deleted-restore.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Project restored from trash"}],"jira.jira-project-event-deleted.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Project moved to trash"}],"jira.jira-project-event-user-invited.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"userName"},{"type":0,"value":") invited you to ("},{"type":1,"value":"projectName"},{"type":0,"value":")  "}],"jira.user.premium-plan.requested.email.explaination":[{"type":0,"value":"You can try Jira Premium for free with no commitment. This trial period includes access\\n\\t\\t\\t\\tto our advanced planning features plus other great functionalities that unlock new ways\\n\\t\\t\\t\\tof working for your teams."}],"jira.user.premium-plan.requested.email.greeting":[{"type":0,"value":"Hi,"}],"jira.user.premium-plan.requested.email.learn-more":[{"type":0,"value":"Learn more about Jira Premium."}],"jira.user.premium-plan.requested.email.start-trial":[{"type":0,"value":"Start your Jira Premium trial"}],"jira.user.premium-plan.requested.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" has requested a free trial of Jira Premium"}],"jira.user.premium-plan.requested.email.text":[{"type":1,"value":"user"},{"type":0,"value":" has requested a free trial of Jira Premium."}],"note.added.by.user":[{"type":1,"value":"userName"},{"type":0,"value":" added this note"}],"post-office.jira-pulsar.jira-issue-approval.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-archived.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-closed.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-comment-delete.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-comment-update.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-delete.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-generic.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-moved.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-resolved.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-update.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.placement.jira-top-banner.primary-message":[{"type":0,"value":"As we roll out \'work\' as the new term for items tracked in Jira, you may still see \'issue\' in some areas."}],"postoffice.jira.issue.common.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.issue.common.visibility-level":[{"type":0,"value":"Restricted to "},{"children":[{"type":1,"value":"name"}],"type":8,"value":"b"},{"type":0,"value":" "},{"type":1,"value":"type"}],"postoffice.jira.issue.metioned.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.issue.metioned.get-android.no-translate":[{"type":0,"value":" Android "}],"postoffice.jira.issue.metioned.get-ios.no-translate":[{"type":0,"value":" iOS. "}],"postoffice.jira.issue.metioned.get-or.no-translate":[{"type":0,"value":" or"}],"postoffice.jira.issue.share-search.shared-with.no-translate":[{"type":0,"value":"sharedWithUser"}],"postoffice.jira.issue.work.started.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.issue.work.stopped.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.issue.worklogged.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.project.event.avatar.no-translate":[{"type":0,"value":"avatar"}],"postoffice.jira.project.event.blueprint.no-translate":[{"type":0,"value":"blueprintLogo"}],"postoffice.jira.project.event.globe.no-translate":[{"type":0,"value":"globeLogo"}],"postoffice.jira.project.event.logo.no-translate":[{"type":0,"value":"logo"}],"postoffice.jira.project.event.write.no-translate":[{"type":0,"value":"writeLogo"}],"push.mobile.issue.approval.requested.description":[{"type":0,"value":"on "},{"type":1,"value":"summary"}],"push.mobile.issue.approval.requested.title":[{"type":0,"value":"Approval requested"}],"push.mobile.issue.assignment.description.assigned.others":[{"type":1,"value":"user"},{"type":0,"value":" assigned "},{"type":1,"value":"summary"},{"type":0,"value":" to "},{"type":1,"value":"assignee"}],"push.mobile.issue.assignment.description.assigned.you":[{"type":1,"value":"user"},{"type":0,"value":" assigned you to "},{"type":1,"value":"summary"}],"push.mobile.issue.assignment.description.unassigned.others":[{"type":1,"value":"user"},{"type":0,"value":" unassigned "},{"type":1,"value":"oldAssignee"},{"type":0,"value":" from "},{"type":1,"value":"summary"}],"push.mobile.issue.assignment.description.unassigned.you":[{"type":1,"value":"user"},{"type":0,"value":" unassigned you from "},{"type":1,"value":"summary"}],"push.mobile.issue.attachment.added.description":[{"type":1,"value":"user"},{"type":0,"value":" added an attachment to "},{"type":1,"value":"summary"}],"push.mobile.issue.attachment.added.description.redacted":[{"type":1,"value":"user"},{"type":0,"value":" added an attachment"}],"push.mobile.issue.comment.added.android.description":[{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.added.ios.body.redacted":[{"type":0,"value":"commented on this work item"}],"push.mobile.issue.comment.added.ios.subtitle":[{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.mention.android.description":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.mention.android.description.redacted":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you in a comment on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.mention.ios.subtitle":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.mention.ios.subtitle.redacted":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you in a comment on this work item"}],"push.mobile.issue.create.android.description":[{"type":1,"value":"user"},{"type":0,"value":" created a work item"}],"push.mobile.issue.create.android.title":[{"type":0,"value":"Work item Created"}],"push.mobile.issue.create.ios.body.redacted":[{"type":0,"value":"Open to view work item details"}],"push.mobile.issue.create.ios.subtitle":[{"type":1,"value":"user"},{"type":0,"value":" created a work item"}],"push.mobile.issue.transition.description.resolved":[{"type":0,"value":"\u2714 "},{"type":1,"value":"user"},{"type":0,"value":" resolved "},{"type":1,"value":"summary"}],"push.mobile.issue.transition.description.resolved.redacted":[{"type":0,"value":"\u2714 "},{"type":1,"value":"user"},{"type":0,"value":" resolved this work item"}],"push.mobile.issue.transition.ios.description":[{"type":1,"value":"user"},{"type":0,"value":" moved "},{"type":1,"value":"summary"},{"type":0,"value":" to "},{"type":1,"value":"status"}],"push.mobile.issue.transition.ios.description.redacted":[{"type":1,"value":"user"},{"type":0,"value":" moved "},{"type":1,"value":"summary"},{"type":0,"value":" to "},{"type":1,"value":"status"}],"st-office.placement.jira-top-banner.primary-cta-text":[{"type":0,"value":"Read about this terminology change"}],"template..project-deletion-reminder.restore-link.multiple-project":[{"type":0,"value":" Restore"}],"template..project-deletion-reminder.restore-link.single-project":[{"type":0,"value":" Restore"}],"template..project-deletion-reminder.trash-link.multiple-project":[{"type":0,"value":" Trash"}],"template.project-deletion-reminder.generic-message.mutiple-projects":[{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" project"}]},"other":{"value":[{"type":7},{"type":0,"value":" projects"}]}},"pluralType":"cardinal","type":6,"value":"projectCount"},{"type":0,"value":" will be permanently deleted in 7 days "}],"template.project-deletion-reminder.generic-message.single-project":[{"type":0,"value":"The project will be permanently deleted in 7 days "}],"template.project-deletion-reminder.view-more-projects-message":[{"type":0,"value":"+ "},{"type":1,"value":"remainingProjectCount"},{"type":0,"value":" other projects currently in "}],"template.project-event-user-invited.invited-message":[{"type":1,"value":"userName"},{"type":0,"value":"  invited you to "},{"children":[{"type":0,"value":" "},{"type":1,"value":"projectName"},{"type":0,"value":" "}],"type":8,"value":"b"}],"template.project.archived.event.admins.permission.message":[{"type":0,"value":"Only Jira admins can restore the project."}],"template.project.deleted.event.admins.permission.message":[{"type":0,"value":"Only Jira admins can restore the project."}],"template.project.event.project.archive.restore.body.template":[{"type":0,"value":" "},{"type":1,"value":"userName"},{"type":0,"value":" restored this project from archive on "},{"type":1,"value":"eventTime"}],"template.project.event.project.archived.body.template":[{"type":1,"value":"userName"},{"type":0,"value":" archived this project on "},{"type":1,"value":"eventTime"}],"template.project.event.project.archived.body.template.generic.message":[{"type":0,"value":"This project and its issues, components, attachments, and versions will be available in the "},{"children":[{"type":0,"value":" archive "}],"type":8,"value":"a"},{"type":0,"value":" forever"}],"template.project.event.project.deleted.body.template":[{"type":1,"value":"userName"},{"type":0,"value":" moved this project to trash on "},{"type":1,"value":"eventTime"}],"template.project.event.project.deleted.body.template.generic.message":[{"type":0,"value":"The project, including all its issues, components, attachments, and versions will be available in the "},{"children":[{"type":0,"value":" trash "}],"type":8,"value":"a"},{"type":0,"value":" for 60 days after which it will be permanently deleted."}],"template.project.event.project.deleted.failure.body.template.generic.message":[{"type":0,"value":"It\'s probably a temporary problem. "},{"children":[{"type":0,"value":" Go to trash "}],"type":8,"value":"a"},{"type":0,"value":" and try again. If it persists, please contact support."}],"template.project.event.project.deleted.restore.body.template":[{"type":0,"value":" "},{"type":1,"value":"userName"},{"type":0,"value":" restored this project from trash on "},{"type":1,"value":"eventTime"}],"template.project.event.project.deletion.failure.body.template":[{"type":0,"value":"We couldn\'t delete this project"}],"template.project.event.project.privacy.contactus.template":[{"type":0,"value":"Contact us"}],"template.project.event.project.privacy.copyright.template":[{"type":0,"value":"Copyright 2025 Atlassian Pty Ltd. All rights reserved."}],"template.project.event.project.privacy.location.template":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia."}],"template.project.event.project.privacy.policy.template":[{"type":0,"value":"Privacy policy"}],"template.project.event.project.privacy.policy.template.dot":[{"type":0,"value":"."}],"template.project.event.project.user.invited.collborate.message":[{"type":0,"value":"Collaborate, align, and deliver work, all in "},{"children":[{"type":0,"value":" one place "}],"type":8,"value":"b"}],"template.project.event.project.user.invited.collect.message":[{"type":0,"value":"Collect and send work to other teams or stakeholders using "},{"children":[{"type":0,"value":" forms "}],"type":8,"value":"b"}],"template.project.event.project.user.invited.join.link":[{"type":0,"value":"Join the Project"}],"template.project.event.project.user.invited.learn.more.message":[{"type":0,"value":"Learn more about Jira "}],"template.project.event.project.user.invited.use.jira.generic.message":[{"type":0,"value":"Use Jira to..."}],"template.project.event.project.user.invited.view.work.message":[{"type":0,"value":"View work your way using the "},{"children":[{"type":0,"value":" list, board, calendar "}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":" timeline "}],"type":8,"value":"b"},{"type":0,"value":" views"}],"template.subscription.filter.count.issue-term-refresh":[{"type":0,"value":" ("},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" work item"}]},"other":{"value":[{"type":7},{"type":0,"value":" work items"}]}},"pluralType":"cardinal","type":6,"value":"total"},{"type":0,"value":")"}],"template.subscription.filter.html.subset.issue-term-refresh":[{"type":0,"value":"Displaying "},{"type":1,"value":"actual"},{"type":0,"value":" of "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" matched work item"}]},"other":{"value":[{"type":7},{"type":0,"value":" matched work items"}]}},"pluralType":"cardinal","type":6,"value":"total"},{"type":0,"value":". "}],"template.subscription.filter.html.view.filter.work-items":[{"type":0,"value":"View all of them"}],"template.subscription.filter.redacted.html.edit":[{"type":0,"value":"You may edit this subscription "},{"children":[{"type":0,"value":" here "}],"type":8,"value":"a"},{"type":0,"value":" "}],"template.subscription.filter.redacted.html.view.filter":[{"type":0,"value":"Details are hidden to protect sensitive data. "},{"children":[{"type":0,"value":" View the filter "}],"type":8,"value":"a"},{"type":0,"value":" in Jira"}],"template.subscription.filter.subcount.issue-term-refresh":[{"type":0,"value":"  ("},{"type":1,"value":"actual"},{"type":0,"value":" of "},{"type":1,"value":"total"},{"type":0,"value":" work items)"}],"template.subscription.filter.text.count.issue-term-refresh":[{"type":0,"value":" ("},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" work item"}]},"other":{"value":[{"type":7},{"type":0,"value":" work items"}]}},"pluralType":"cardinal","type":6,"value":"total"},{"type":0,"value":")"}],"template.subscription.filter.text.subcount.issue-term-refresh":[{"type":0,"value":" ("},{"type":1,"value":"actual"},{"type":0,"value":" of "},{"type":1,"value":"total"},{"type":0,"value":" work items)"}],"user.avatar.alt":[{"type":0,"value":"User avatar"}]}');

});

parcelRegister("iUwUU", function(module, exports) {

let $dc46fd9459398a37$var$load = (parcelRequire("28QjX"))(4);
module.exports = $dc46fd9459398a37$var$load("6MiVv").then(()=>parcelRequire('lo4cW'));

});

parcelRegister("gl8l3", function(module, exports) {

let $be55135d137f2756$var$load = (parcelRequire("28QjX"))(4);
module.exports = $be55135d137f2756$var$load("eidsh").then(()=>parcelRequire('1eGK0'));

});

parcelRegister("8eO2U", function(module, exports) {

let $5ff6739ca7cec1e3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5ff6739ca7cec1e3$var$load("kyveB").then(()=>parcelRequire('726mc'));

});

parcelRegister("9MpRJ", function(module, exports) {

let $71eca91d0c4e8035$var$load = (parcelRequire("28QjX"))(4);
module.exports = $71eca91d0c4e8035$var$load("9k700").then(()=>parcelRequire('9Ekqu'));

});

parcelRegister("hQHOo", function(module, exports) {

let $cfe9471fcda1d8f3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cfe9471fcda1d8f3$var$load("kpwgp").then(()=>parcelRequire('gGgEG'));

});

parcelRegister("jLY9a", function(module, exports) {

let $03b6fc2107327683$var$load = (parcelRequire("28QjX"))(4);
module.exports = $03b6fc2107327683$var$load("aWOSV").then(()=>parcelRequire('7Wrkb'));

});

parcelRegister("fm8Dq", function(module, exports) {

let $b2df9bc7a156e2b7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b2df9bc7a156e2b7$var$load("brdUw").then(()=>parcelRequire('h32d2'));

});

parcelRegister("bAOW8", function(module, exports) {

let $870a917934038aad$var$load = (parcelRequire("28QjX"))(4);
module.exports = $870a917934038aad$var$load("ccyGR").then(()=>parcelRequire('g3ED8'));

});

parcelRegister("8iuTo", function(module, exports) {

let $60a7f7c8734bc23b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $60a7f7c8734bc23b$var$load("1bPTt").then(()=>parcelRequire('72S2k'));

});

parcelRegister("8cHVl", function(module, exports) {

let $5f918416a587dd65$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5f918416a587dd65$var$load("lNhhu").then(()=>parcelRequire('lYm65'));

});

parcelRegister("ggwfL", function(module, exports) {

let $bd7728cf50ea56a5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bd7728cf50ea56a5$var$load("MG9xA").then(()=>parcelRequire('4QiA1'));

});

parcelRegister("PUQQB", function(module, exports) {

let $09c0dd08cf03bfbe$var$load = (parcelRequire("28QjX"))(4);
module.exports = $09c0dd08cf03bfbe$var$load("44gSr").then(()=>parcelRequire('a7zys'));

});

parcelRegister("fZRSZ", function(module, exports) {

let $ba565a1ee7c7a28a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ba565a1ee7c7a28a$var$load("l9Y1q").then(()=>parcelRequire('aIRk9'));

});

parcelRegister("7kGaD", function(module, exports) {

let $556b1cd43a057d2b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $556b1cd43a057d2b$var$load("2zLwu").then(()=>parcelRequire('3kY9c'));

});

parcelRegister("49A3z", function(module, exports) {

let $3063f8c01f34e66b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3063f8c01f34e66b$var$load("gOCj9").then(()=>parcelRequire('iIBGA'));

});

parcelRegister("aCpfm", function(module, exports) {

let $7bb10974a63f422b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7bb10974a63f422b$var$load("jR6AZ").then(()=>parcelRequire('crVy2'));

});

parcelRegister("aTLiW", function(module, exports) {

let $7ef3bc1afb5e93dc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7ef3bc1afb5e93dc$var$load("aeXiI").then(()=>parcelRequire('chc7G'));

});

parcelRegister("hQVPe", function(module, exports) {

let $cff425eb0af26700$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cff425eb0af26700$var$load("8cbTQ").then(()=>parcelRequire('9hohk'));

});

parcelRegister("hGf0K", function(module, exports) {

let $cdf200d129b8159e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cdf200d129b8159e$var$load("clAYE").then(()=>parcelRequire('a4wtg'));

});

parcelRegister("9X48C", function(module, exports) {

let $73ecd572f7cca65b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $73ecd572f7cca65b$var$load("994Gp").then(()=>parcelRequire('kMxK3'));

});

parcelRegister("fUB1R", function(module, exports) {

let $b958cf25c638fac6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b958cf25c638fac6$var$load("4BJSo").then(()=>parcelRequire('dmRPN'));

});

parcelRegister("c5iuR", function(module, exports) {

let $8cc44cb8ea14ef78$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8cc44cb8ea14ef78$var$load("cbUc0").then(()=>parcelRequire('3AFrq'));

});

parcelRegister("fdN58", function(module, exports) {

let $b14e248688ebc3fb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b14e248688ebc3fb$var$load("dT5iy").then(()=>parcelRequire('9paZH'));

});

parcelRegister("kpOFa", function(module, exports) {

let $edcd7111f8d1aa70$var$load = (parcelRequire("28QjX"))(4);
module.exports = $edcd7111f8d1aa70$var$load("iV956").then(()=>parcelRequire('koqy5'));

});

parcelRegister("5zeMt", function(module, exports) {

let $40dbafcd37e87828$var$load = (parcelRequire("28QjX"))(4);
module.exports = $40dbafcd37e87828$var$load("4dnqU").then(()=>parcelRequire('5FwM5'));

});

parcelRegister("fCnub", function(module, exports) {

let $b5ec9f71468a98b4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b5ec9f71468a98b4$var$load("7GK7Y").then(()=>parcelRequire('gRvSr'));

});

parcelRegister("h54cR", function(module, exports) {

let $c6f62a9d040a27c5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c6f62a9d040a27c5$var$load("iX8MT").then(()=>parcelRequire('hIvJW'));

});

parcelRegister("3x6L7", function(module, exports) {

let $2929b257132ece18$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2929b257132ece18$var$load("8aJvm").then(()=>parcelRequire('b3AyE'));

});

parcelRegister("6N9aD", function(module, exports) {

let $4f1e6ec3843d1e47$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4f1e6ec3843d1e47$var$load("cDV1p").then(()=>parcelRequire('bOnIM'));

});


parcelRegister("gWg7c", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $d13eb097e99fa984$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $jTlyZ = parcelRequire("jTlyZ");

var $euiLX = parcelRequire("euiLX");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d13eb097e99fa984$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;






























const $d13eb097e99fa984$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $euiLX.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $d13eb097e99fa984$var$importHelper(await (parcelRequire("dYTOz")));
        case 'da':
            return $d13eb097e99fa984$var$importHelper(await (parcelRequire("4izls")));
        case 'de':
            return $d13eb097e99fa984$var$importHelper(await (parcelRequire("b8qFW")));
        case 'en-GB':
            return $d13eb097e99fa984$var$importHelper(await (parcelRequire("4eod8")));
        case 'en-US':
            return $d13eb097e99fa984$var$importHelper(await (parcelRequire("e8z6p")));
        case 'en-XA':
            return $d13eb097e99fa984$var$importHelper(await (parcelRequire("lvS8g")));
        case 'en-XB':
            return $d13eb097e99fa984$var$importHelper(await (parcelRequire("1Y527")));
        case 'en-ZZ':
            return $d13eb097e99fa984$var$importHelper(await (parcelRequire("4ZvJI")));
        case 'en':
            return $d13eb097e99fa984$var$importHelper(await Promise.resolve((parcelRequire("jTlyZ"))));
        case 'es':
            return $d13eb097e99fa984$var$importHelper(await (parcelRequire("6gbwe")));
        case 'et':
            return $d13eb097e99fa984$var$importHelper(await (parcelRequire("1orJN")));
        case 'fi':
            return $d13eb097e99fa984$var$importHelper(await (parcelRequire("7hTbq")));
        case 'fr':
            return $d13eb097e99fa984$var$importHelper(await (parcelRequire("cC1L4")));
        case 'hu':
            return $d13eb097e99fa984$var$importHelper(await (parcelRequire("ixqR0")));
        case 'it':
            return $d13eb097e99fa984$var$importHelper(await (parcelRequire("gOwsO")));
        case 'ja':
            return $d13eb097e99fa984$var$importHelper(await (parcelRequire("hYyjg")));
        case 'ko':
            return $d13eb097e99fa984$var$importHelper(await (parcelRequire("97MHQ")));
        case 'nb':
            return $d13eb097e99fa984$var$importHelper(await (parcelRequire("8pARF")));
        case 'nl':
            return $d13eb097e99fa984$var$importHelper(await (parcelRequire("2dqFs")));
        case 'pl':
            return $d13eb097e99fa984$var$importHelper(await (parcelRequire("8Ts78")));
        case 'pt-BR':
            return $d13eb097e99fa984$var$importHelper(await (parcelRequire("lOLw4")));
        case 'ro':
            return $d13eb097e99fa984$var$importHelper(await (parcelRequire("2aXRb")));
        case 'ru':
            return $d13eb097e99fa984$var$importHelper(await (parcelRequire("eIq87")));
        case 'sv':
            return $d13eb097e99fa984$var$importHelper(await (parcelRequire("4nx4B")));
        case 'th':
            return $d13eb097e99fa984$var$importHelper(await (parcelRequire("eDawu")));
        case 'tr':
            return $d13eb097e99fa984$var$importHelper(await (parcelRequire("gGrLz")));
        case 'uk':
            return $d13eb097e99fa984$var$importHelper(await (parcelRequire("kruP4")));
        case 'vi':
            return $d13eb097e99fa984$var$importHelper(await (parcelRequire("7yVqA")));
        case 'zh-CN':
            return $d13eb097e99fa984$var$importHelper(await (parcelRequire("gljEE")));
        case 'zh-TW':
            return $d13eb097e99fa984$var$importHelper(await (parcelRequire("7qkPR")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($jTlyZ));
    }
};

});
parcelRegister("jTlyZ", function(module, exports) {
module.exports = JSON.parse("{\"jira-xflow-loom.placements.in-app.jira-issueview-comment-template.ctaMessageForIssueComment\":[{\"type\":0,\"value\":\"Try\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-comment-template.descriptionForIssuecomment\":[{\"type\":0,\"value\":\"Use video to explain the work\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-comment-template.loom\":[{\"type\":0,\"value\":\"Loom\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-comment-template.titleForIssueComment\":[{\"type\":0,\"value\":\"Record your screen\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-description-template.ctaMessageForIssueDescription\":[{\"type\":0,\"value\":\"Try\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-description-template.descriptionForIssueDescription\":[{\"type\":0,\"value\":\"Use video to explain the work\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-description-template.loom\":[{\"type\":0,\"value\":\"Loom\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-description-template.titleForIssueDescription\":[{\"type\":0,\"value\":\"Record your screen\"}],\"post-office-template.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"post-office-template.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"post-office-template.message-template.microsoft-teams.hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office-template.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"post-office-template.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"post-office-template.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"post-office-template.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"post-office-template.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"post-office.components.{component-name}.{location-name}.{message-name}\":[{\"type\":0,\"value\":\"Example\"}],\"post-office.post-office-template.sample-hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office.post-office-template.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}]}");

});

parcelRegister("dYTOz", function(module, exports) {

let $a2dc2c97333cb4d4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a2dc2c97333cb4d4$var$load("dU3Pm").then(()=>parcelRequire('cOdtX'));

});

parcelRegister("4izls", function(module, exports) {

let $321442aad0e9f77b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $321442aad0e9f77b$var$load("45L5W").then(()=>parcelRequire('ehn1w'));

});

parcelRegister("b8qFW", function(module, exports) {

let $81b52247b865315e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $81b52247b865315e$var$load("60P47").then(()=>parcelRequire('gUTAT'));

});

parcelRegister("4eod8", function(module, exports) {

let $314b400080785c94$var$load = (parcelRequire("28QjX"))(4);
module.exports = $314b400080785c94$var$load("cTyco").then(()=>parcelRequire('j51AU'));

});

parcelRegister("e8z6p", function(module, exports) {

let $a4ad0aa86a293d7f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a4ad0aa86a293d7f$var$load("jNAgs").then(()=>parcelRequire('gAvT5'));

});

parcelRegister("lvS8g", function(module, exports) {

let $fa967bc4dd00b26d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fa967bc4dd00b26d$var$load("ReQi1").then(()=>parcelRequire('3UXio'));

});

parcelRegister("1Y527", function(module, exports) {

let $16ef4c820bd85c92$var$load = (parcelRequire("28QjX"))(4);
module.exports = $16ef4c820bd85c92$var$load("cdvKS").then(()=>parcelRequire('7swxR'));

});

parcelRegister("4ZvJI", function(module, exports) {

let $3a257a1dd53349c8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3a257a1dd53349c8$var$load("kiGQf").then(()=>parcelRequire('530uH'));

});

parcelRegister("6gbwe", function(module, exports) {

let $48ed2c2194ec47bd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $48ed2c2194ec47bd$var$load("gtTCO").then(()=>parcelRequire('lHvSd'));

});

parcelRegister("1orJN", function(module, exports) {

let $103d8c70983accbf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $103d8c70983accbf$var$load("9ROYz").then(()=>parcelRequire('jF3vn'));

});

parcelRegister("7hTbq", function(module, exports) {

let $54e4ed319a1ba807$var$load = (parcelRequire("28QjX"))(4);
module.exports = $54e4ed319a1ba807$var$load("9hQos").then(()=>parcelRequire('5RTMG'));

});

parcelRegister("cC1L4", function(module, exports) {

let $92ea65cefdfb72dd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $92ea65cefdfb72dd$var$load("lvyQN").then(()=>parcelRequire('lFs8E'));

});

parcelRegister("ixqR0", function(module, exports) {

let $d7f023b5a779e4ea$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d7f023b5a779e4ea$var$load("80srp").then(()=>parcelRequire('229rK'));

});

parcelRegister("gOwsO", function(module, exports) {

let $c3da7f7aa8fdc3fb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c3da7f7aa8fdc3fb$var$load("4lkmf").then(()=>parcelRequire('dQCwG'));

});

parcelRegister("hYyjg", function(module, exports) {

let $d162a77bedb6fee2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d162a77bedb6fee2$var$load("gP5Wy").then(()=>parcelRequire('glbrO'));

});

parcelRegister("97MHQ", function(module, exports) {

let $6a4a8c8d73d69351$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6a4a8c8d73d69351$var$load("3btXp").then(()=>parcelRequire('4Z6cs'));

});

parcelRegister("8pARF", function(module, exports) {

let $61fd411639992a42$var$load = (parcelRequire("28QjX"))(4);
module.exports = $61fd411639992a42$var$load("cTw4k").then(()=>parcelRequire('2KZY1'));

});

parcelRegister("2dqFs", function(module, exports) {

let $19d17b4f584fc409$var$load = (parcelRequire("28QjX"))(4);
module.exports = $19d17b4f584fc409$var$load("5RCod").then(()=>parcelRequire('6ZLBK'));

});

parcelRegister("8Ts78", function(module, exports) {

let $679944a662efcdb1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $679944a662efcdb1$var$load("iRLvi").then(()=>parcelRequire('etrJu'));

});

parcelRegister("lOLw4", function(module, exports) {

let $fe2320357e78a5f7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fe2320357e78a5f7$var$load("bQuOY").then(()=>parcelRequire('6QWjO'));

});

parcelRegister("2aXRb", function(module, exports) {

let $195af23df022cdbc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $195af23df022cdbc$var$load("dP0e2").then(()=>parcelRequire('4uHll'));

});

parcelRegister("eIq87", function(module, exports) {

let $ab697196a1112ea5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ab697196a1112ea5$var$load("adUnw").then(()=>parcelRequire('2S1ZA'));

});

parcelRegister("4nx4B", function(module, exports) {

let $3302f70a852af8cf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3302f70a852af8cf$var$load("4ABkd").then(()=>parcelRequire('1mvAC'));

});

parcelRegister("eDawu", function(module, exports) {

let $aa6cdedd9c2d866d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $aa6cdedd9c2d866d$var$load("1sxE9").then(()=>parcelRequire('4oHMI'));

});

parcelRegister("gGrLz", function(module, exports) {

let $c2561b66d4948552$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c2561b66d4948552$var$load("4K9UI").then(()=>parcelRequire('2KsIL'));

});

parcelRegister("kruP4", function(module, exports) {

let $ee1e3d09e0158040$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ee1e3d09e0158040$var$load("4yHNB").then(()=>parcelRequire('gNWij'));

});

parcelRegister("7yVqA", function(module, exports) {

let $5818415d96f37dfe$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5818415d96f37dfe$var$load("8VlgC").then(()=>parcelRequire('5MBk8'));

});

parcelRegister("gljEE", function(module, exports) {

let $be5dda7f02c0ce7a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $be5dda7f02c0ce7a$var$load("2q4Ne").then(()=>parcelRequire('5jMKL'));

});

parcelRegister("7qkPR", function(module, exports) {

let $567b1f977a40829c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $567b1f977a40829c$var$load("fjvDn").then(()=>parcelRequire('4Kji8'));

});




parcelRegister("4yEIl", function(module, exports) {

$parcel$export(module.exports, "PostOfficeProvider", () => $21214568f856c41e$export$fb465b6e855c1e85);
$parcel$export(module.exports, "PostOfficeRouterListener", () => $21214568f856c41e$export$9f8d3084fd3d5fc0);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $4R6GH = parcelRequire("4R6GH");

var $jp5kW = parcelRequire("jp5kW");

var $lpwtK = parcelRequire("lpwtK");

var $14XJw = parcelRequire("14XJw");

var $fY39E = parcelRequire("fY39E");

var $k9JTq = parcelRequire("k9JTq");

var $koeKL = parcelRequire("koeKL");

var $2tT7R = parcelRequire("2tT7R");

var $cNd4s = parcelRequire("cNd4s");

var $DVljb = parcelRequire("DVljb");

var $kyUrs = parcelRequire("kyUrs");
var $gsnWm = parcelRequire("gsnWm");

var $doZTA = parcelRequire("doZTA");

var $itmJb = parcelRequire("itmJb");

var $adncp = parcelRequire("adncp");

var $f1acU = parcelRequire("f1acU");
const $21214568f856c41e$var$JiraPostOfficeProvider = ({ children: children })=>{
    const { data: data } = (0, $lpwtK.useProject)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const cloudId = (0, $koeKL.useCloudId)();
    const activationId = (0, $fY39E.useActivationId)();
    const locale = (0, $DVljb.useLocale)();
    const environment = (0, $2tT7R.useEnvironment)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const editions = (0, $k9JTq.useAppEditions)();
    const subproduct = data?.type;
    const edition = (0, $adncp.subproductToEdition)(subproduct, editions);
    const additionalContext = (0, $5uXOq.useContext)((0, $f1acU.CrossFlowPostOfficeContext));
    const context = (0, $5uXOq.useMemo)(()=>{
        return {
            current: {
                ...(0, $adncp.tenantToPostOfficeContext)({
                    activationId: activationId,
                    cloudId: cloudId,
                    isAdmin: isAdmin,
                    isSiteAdmin: isSiteAdmin,
                    locale: locale
                }),
                orgId: orgId,
                productEdition: edition || undefined,
                subproduct: subproduct,
                ...(0, $4R6GH.fg)('jira_xflow_quick_actions') ? additionalContext : {}
            }
        };
    }, [
        cloudId,
        orgId,
        activationId,
        subproduct,
        isSiteAdmin,
        isAdmin,
        locale,
        edition,
        additionalContext
    ]);
    const env = (0, $5uXOq.useMemo)(()=>({
            env: (0, $adncp.transformJiraEnvToPostOfficeEnvironment)(environment)
        }), [
        environment
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kyUrs.PostOfficeProvider), {
        context: context,
        environment: env
    }, children);
};
const $21214568f856c41e$export$fb465b6e855c1e85 = ({ children: children })=>{
    // Using the Feature Gate used for the placement app-switcher-discovery-section because PostOfficeProvider is always needed when the app-switcher-discovery-section is enabled
    const isPostOfficeEnabled = !(0, $jp5kW.default)('killswitch_post_office_in_jira');
    return isPostOfficeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "postOfficeJiraProvider",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($21214568f856c41e$var$JiraPostOfficeProvider, null, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $21214568f856c41e$var$ReactResourceRouterListener = ({ children: children })=>{
    const [route] = (0, $doZTA.useRouter)();
    (0, $gsnWm.usePostOfficeRouteUpdate)([
        route.basePath,
        route.location.pathname
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $21214568f856c41e$export$9f8d3084fd3d5fc0 = ({ children: children })=>{
    const isPostOfficeEnabled = !(0, $jp5kW.default)('killswitch_post_office_in_jira');
    return isPostOfficeEnabled && (0, $4R6GH.fg)('post-office-screen-space-overlay-jfe') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($21214568f856c41e$var$ReactResourceRouterListener, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};

});
parcelRegister("kyUrs", function(module, exports) {

$parcel$export(module.exports, "PostOfficeProvider", () => $55d824ce17788461$export$fb465b6e855c1e85);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gHZ4O = parcelRequire("gHZ4O");

var $5MYiV = parcelRequire("5MYiV");

var $gsnWm = parcelRequire("gsnWm");

var $iTZyv = parcelRequire("iTZyv");

var $8uFbT = parcelRequire("8uFbT");

var $dmvPD = parcelRequire("dmvPD");

var $hWRix = parcelRequire("hWRix");

var $6I1Fy = parcelRequire("6I1Fy");
const $55d824ce17788461$export$fb465b6e855c1e85 = ({ environment: envWithOverrides, context: context, children: children })=>{
    const stableEnvironment = (0, $dmvPD.useStableObject)((0, $6I1Fy.generateEnvironmentConfigWithOverrides)((0, $5MYiV.defaultEnvironmentValues), envWithOverrides));
    const stableContext = (0, $dmvPD.useStableObject)($55d824ce17788461$var$composeConfig((0, $gHZ4O.defaultPostOfficeContextValue), context.current));
    const memoizedMessagePlacementValues = (0, $5uXOq.useMemo)(()=>(0, $hWRix.createMessagePlacementValues)(), []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5MYiV.PostOfficeEnvironmentProvider), {
        value: stableEnvironment,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gHZ4O.InternalPostOfficeContextProvider), {
            value: stableContext,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iTZyv.PostOfficeScreenContextProvider), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hWRix.MessagePlacementProvider), {
                    value: memoizedMessagePlacementValues,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gsnWm.RouteListenerProvider), {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8uFbT.TriggerContextProvider), {
                            children: children
                        })
                    })
                })
            })
        })
    });
};
const $55d824ce17788461$var$composeConfig = (base, ...rest)=>rest.reduce((acc, v)=>{
        // Bring logic inline with lodash merge
        // Iterator (right) properties that resolve to undefined are skipped if an Accumulator (left) value already exists
        for(const key in v)if (typeof v[key] === 'undefined') delete v[key];
        return {
            ...acc,
            ...v
        };
    }, {
        ...base
    });

});
parcelRegister("gsnWm", function(module, exports) {

$parcel$export(module.exports, "usePostOfficeRouteUpdate", () => $05165220c9da3f7b$export$bb606326acdd1a64);
$parcel$export(module.exports, "RouteListenerProvider", () => $05165220c9da3f7b$export$31986273b686f5ea);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dM8xS = parcelRequire("dM8xS");

var $lwdce = parcelRequire("lwdce");
const $05165220c9da3f7b$var$noop = ()=>{};
const $05165220c9da3f7b$var$RouteListenerContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    update: $05165220c9da3f7b$var$noop
});
const $05165220c9da3f7b$export$7a2084f4baac29a7 = ()=>(0, $dM8xS.createSimplePubSub)();
const $05165220c9da3f7b$export$72fd8977abf03d60 = ()=>(0, $5uXOq.useContext)($05165220c9da3f7b$var$RouteListenerContext);
const $05165220c9da3f7b$export$755edb1665399d41 = ()=>{
    const ref = (0, $5uXOq.useRef)();
    if (!ref.current) ref.current = $05165220c9da3f7b$export$7a2084f4baac29a7();
    const [routeSubscriber, updateRoute] = ref.current;
    const routeConfig = (0, $5uXOq.useMemo)(()=>({
            initialUrl: new URL(window.location.href),
            routeSubscriber: routeSubscriber
        }), [
        routeSubscriber
    ]);
    const routeUpdater = (0, $5uXOq.useMemo)(()=>({
            update: updateRoute
        }), [
        updateRoute
    ]);
    return [
        routeConfig,
        routeUpdater
    ];
};
const $05165220c9da3f7b$export$bb606326acdd1a64 = (deps)=>{
    const { update: update } = $05165220c9da3f7b$export$72fd8977abf03d60();
    (0, $5uXOq.useEffect)(()=>{
        if (typeof window === 'undefined') return;
        update({
            next: new URL(window.location.href)
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
const $05165220c9da3f7b$export$31986273b686f5ea = ({ children: children })=>{
    const [route, routeUpdater] = $05165220c9da3f7b$export$755edb1665399d41();
    return /*#__PURE__*/ (0, $2OMIu.jsx)($05165220c9da3f7b$var$RouteListenerContext.Provider, {
        value: routeUpdater,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lwdce.PostOfficeRouteProvider), {
            ...route,
            children: children
        })
    });
};

});
parcelRegister("dM8xS", function(module, exports) {

$parcel$export(module.exports, "createSimplePubSub", () => $8de249bc8411112f$export$92469b55607f005b);
const $8de249bc8411112f$export$92469b55607f005b = ()=>{
    const subscribers = new Map();
    const subscribe = (subscriber)=>{
        subscribers.set(subscriber, subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    const publish = (payload)=>{
        subscribers.forEach((callback)=>callback(payload));
    };
    return [
        subscribe,
        publish
    ];
};

});


parcelRegister("8uFbT", function(module, exports) {

$parcel$export(module.exports, "TriggerContextProvider", () => $30c451df5a2e0ecd$export$e80a5720bb4c8fe3);
$parcel$export(module.exports, "useTrigger", () => $30c451df5a2e0ecd$export$3b196fe93a948c18);
$parcel$export(module.exports, "useFirePostOfficeTrigger", () => $30c451df5a2e0ecd$export$83b33e5fe4cce64);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $30c451df5a2e0ecd$var$initialActiveTriggerState = {
    activeTriggerState: {
        activeTriggerId: undefined
    }
};
const $30c451df5a2e0ecd$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $30c451df5a2e0ecd$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext($30c451df5a2e0ecd$var$initialActiveTriggerState);
const $30c451df5a2e0ecd$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext($30c451df5a2e0ecd$var$initialTriggerDispatchState);
const $30c451df5a2e0ecd$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    const [activeTriggerState, setActiveTriggerState] = (0, $5uXOq.useState)($30c451df5a2e0ecd$var$initialActiveTriggerState.activeTriggerState);
    const setTriggerState = (0, $5uXOq.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        setActiveTriggerState((current)=>{
            const hasStateChanged = current.activeTriggerId !== triggerId || current.activeTriggerId === triggerId && isActive === false;
            if (!hasStateChanged) return current;
            if (isActive) return {
                activeTriggerId: triggerId
            };
            return {
                activeTriggerId: undefined
            };
        });
    }, []);
    const triggerContextValue = (0, $5uXOq.useMemo)(()=>({
            activeTriggerState: activeTriggerState
        }), [
        activeTriggerState
    ]);
    const triggerContexDispatchValue = (0, $5uXOq.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($30c451df5a2e0ecd$var$TriggerContext.Provider, {
        value: triggerContextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($30c451df5a2e0ecd$var$TriggerDispatchContext.Provider, {
            value: triggerContexDispatchValue,
            children: children
        })
    });
};
const $30c451df5a2e0ecd$export$454c1d7c35958f5e = ()=>(0, $5uXOq.useContext)($30c451df5a2e0ecd$var$TriggerContext);
const $30c451df5a2e0ecd$export$23cbf084e08bdb93 = ()=>(0, $5uXOq.useContext)($30c451df5a2e0ecd$var$TriggerDispatchContext);
const $30c451df5a2e0ecd$export$3b196fe93a948c18 = (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $30c451df5a2e0ecd$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: activeTriggerState.activeTriggerId === triggerId
    } : {
        isActive: undefined
    };
};
const $30c451df5a2e0ecd$export$83b33e5fe4cce64 = ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $30c451df5a2e0ecd$export$23cbf084e08bdb93();
    const fireTrigger = (0, $5uXOq.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};

});

parcelRegister("6I1Fy", function(module, exports) {

$parcel$export(module.exports, "generateEnvironmentConfigWithOverrides", () => $f0574f278f9639f1$export$ae3dab16eb1fc2cc);
const $f0574f278f9639f1$export$ae3dab16eb1fc2cc = (defaultEnvironmentValues, environmentWithOverrides)=>{
    const { env: env, overrides: overrides } = environmentWithOverrides;
    return {
        currentEnv: env,
        envConfigs: {
            ...defaultEnvironmentValues.envConfigs,
            [env]: {
                remoteModule: {
                    origin: overrides?.remoteModule?.origin ?? defaultEnvironmentValues.envConfigs[env].remoteModule.origin,
                    pathname: overrides?.remoteModule?.pathname ?? defaultEnvironmentValues.envConfigs[env].remoteModule.pathname,
                    searchParams: overrides?.remoteModule?.searchParams ?? defaultEnvironmentValues.envConfigs[env].remoteModule.searchParams
                },
                api: {
                    origin: overrides?.api?.origin ?? defaultEnvironmentValues.envConfigs[env].api.origin,
                    pathname: overrides?.api?.pathname ?? defaultEnvironmentValues.envConfigs[env].api.pathname,
                    searchParams: overrides?.api?.searchParams ?? defaultEnvironmentValues.envConfigs[env].api.searchParams
                }
            }
        }
    };
};

});


parcelRegister("f1acU", function(module, exports) {

$parcel$export(module.exports, "CrossFlowPostOfficeContext", () => $bf141b13125317fd$export$2e4aec418d6136f);
$parcel$export(module.exports, "CrossFlowPostOfficeProvider", () => $bf141b13125317fd$export$de3f510d70d6c70c);

var $5uXOq = parcelRequire("5uXOq");

var $itmJb = parcelRequire("itmJb");

var $eXrJi = parcelRequire("eXrJi");

var $a1ky2 = parcelRequire("a1ky2");

var $kVVL1 = parcelRequire("kVVL1");

var $1XJ20 = parcelRequire("1XJ20");

var $hqBSi = parcelRequire("hqBSi");

var $5flRJ = parcelRequire("5flRJ");

var $cNd4s = parcelRequire("cNd4s");

var $kagli = parcelRequire("kagli");
const $bf141b13125317fd$export$2e4aec418d6136f = /*#__PURE__*/ (0, $5uXOq.createContext)({
    loomTouchpointVariant: null,
    isAdmin: null,
    isOrgAdmin: null,
    hasActiveJpdLicense: null,
    tenantHasConfluence: null,
    canProvisionConfluenceEndUser: null,
    areProductSuggestionsEnabled: null,
    isAiEligibleAndTriggered: null
});
const $bf141b13125317fd$export$de3f510d70d6c70c = ({ children: children, loomTouchpointVariant: loomTouchpointVariant, isAiEligibleAndTriggered: isAiEligibleAndTriggered })=>{
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    const tenantHasConfluence = licensedProducts?.confluence === true;
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const { canProvisionConfluenceEndUser: canProvisionConfluenceEndUser } = (0, $5flRJ.useUserHasAddProductPermissions)({
        skip: isSiteAdmin || tenantHasConfluence
    });
    const areProductSuggestionsEnabled = (0, $kagli.useAreProductSuggestionsEnabled)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const hasActiveJpdLicense = (0, $kVVL1.useSelector)((0, $a1ky2.tenantHasActiveProductDiscoveryLicenseSelector));
    // isOrgAdmin is fetched from an api call and the initial value of loading is false
    // so it changes from false to true and then back to false
    // we need to wait for the loading to be true and then false again before we can render the children
    // this is to avoid re render of post office placement
    // to achieve this, we use usePrevious hook to check the previous value of isOrgAdminLoading
    // and only render the children when the previous value is true and the current value is false
    const { isOrgAdmin: isOrgAdmin, loading: isOrgAdminLoading } = (0, $eXrJi.useIsOrgAdmin)();
    const previousIsOrgAdminLoading = (0, $1XJ20.usePreviousPersistent)(isOrgAdminLoading);
    const context = (0, $5uXOq.useMemo)(()=>{
        return {
            loomTouchpointVariant: loomTouchpointVariant,
            isAdmin: isAdmin,
            isOrgAdmin: isOrgAdmin,
            hasActiveJpdLicense: hasActiveJpdLicense,
            tenantHasConfluence: tenantHasConfluence,
            canProvisionConfluenceEndUser: canProvisionConfluenceEndUser,
            areProductSuggestionsEnabled: areProductSuggestionsEnabled,
            isAiEligibleAndTriggered: !!isAiEligibleAndTriggered
        };
    }, [
        loomTouchpointVariant,
        isAdmin,
        isOrgAdmin,
        hasActiveJpdLicense,
        tenantHasConfluence,
        canProvisionConfluenceEndUser,
        areProductSuggestionsEnabled,
        isAiEligibleAndTriggered
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bf141b13125317fd$export$2e4aec418d6136f.Provider, {
        value: context
    }, previousIsOrgAdminLoading && !isOrgAdminLoading && children);
};

});
parcelRegister("a1ky2", function(module, exports) {

$parcel$export(module.exports, "contextSelector", () => $df15ab6efcbffe76$export$c420c9f40402ab6d);
$parcel$export(module.exports, "accountIdloggedInUserSelector", () => $df15ab6efcbffe76$export$cb29341089829e17);
$parcel$export(module.exports, "orgIdSelector", () => $df15ab6efcbffe76$export$24984a39db14d8);
$parcel$export(module.exports, "baseUrlSelector", () => $df15ab6efcbffe76$export$1ca9a92a5f28e233);
$parcel$export(module.exports, "loginRedirectUrlSelector", () => $df15ab6efcbffe76$export$767583fcce1653ec);
$parcel$export(module.exports, "issueKeySelector", () => $df15ab6efcbffe76$export$d22bc6271070f453);
$parcel$export(module.exports, "issueIdSelector", () => $df15ab6efcbffe76$export$31efbca30077ec1e);
$parcel$export(module.exports, "projectKeySelector", () => $df15ab6efcbffe76$export$404de5ac601b84bc);
$parcel$export(module.exports, "analyticsSourceSelector", () => $df15ab6efcbffe76$export$85a9d212d56669b4);
$parcel$export(module.exports, "cloudIdSelector", () => $df15ab6efcbffe76$export$b5a643cfff945455);
$parcel$export(module.exports, "issueAriSelector", () => $df15ab6efcbffe76$export$a2cdbba2136e72d3);
$parcel$export(module.exports, "commentAriSelector", () => $df15ab6efcbffe76$export$b600fd41c88f35c8);
$parcel$export(module.exports, "isAnonymousSelector", () => $df15ab6efcbffe76$export$a165ec261432d0b8);
$parcel$export(module.exports, "localeSelector", () => $df15ab6efcbffe76$export$f7b7935883444b11);
$parcel$export(module.exports, "issueActionsSelector", () => $df15ab6efcbffe76$export$b62cb5286b153905);
$parcel$export(module.exports, "applicationKeySelector", () => $df15ab6efcbffe76$export$6c7d07328f197de7);
$parcel$export(module.exports, "isMobileSelector", () => $df15ab6efcbffe76$export$4cbb8c74e98876a5);
$parcel$export(module.exports, "isBitbucketSelector", () => $df15ab6efcbffe76$export$245e5ba54167b84a);
$parcel$export(module.exports, "isServiceDeskSelector", () => $df15ab6efcbffe76$export$43d733e4b7e8c7d0);
$parcel$export(module.exports, "isEcosystemEnabledSelector", () => $df15ab6efcbffe76$export$9bffc1987c753bd9);
$parcel$export(module.exports, "rapidViewIdSelector", () => $df15ab6efcbffe76$export$718e830000b27a0e);
$parcel$export(module.exports, "boardTypeSelector", () => $df15ab6efcbffe76$export$5af08fd769c0f0);
$parcel$export(module.exports, "boardIdSelector", () => $df15ab6efcbffe76$export$955e7dbf76b61f80);
$parcel$export(module.exports, "siteAdminStatusSelector", () => $df15ab6efcbffe76$export$93badd2a066af8bd);
$parcel$export(module.exports, "appPermissionsSelector", () => $df15ab6efcbffe76$export$5b71e1eb43056b6c);
$parcel$export(module.exports, "isModalSelector", () => $df15ab6efcbffe76$export$5fa593caa6a15917);
$parcel$export(module.exports, "shouldRenderHeaderSelector", () => $df15ab6efcbffe76$export$631793d49dec78de);
$parcel$export(module.exports, "viewModeSelector", () => $df15ab6efcbffe76$export$1f11fe78e4f22d45);
$parcel$export(module.exports, "appEditionsSelector", () => $df15ab6efcbffe76$export$28ca74e18c8f4529);
$parcel$export(module.exports, "tenantHasActiveServiceDeskLicenseSelector", () => $df15ab6efcbffe76$export$96c87532aec3474a);
$parcel$export(module.exports, "tenantHasActiveProductDiscoveryLicenseSelector", () => $df15ab6efcbffe76$export$f049ad7141428191);
$parcel$export(module.exports, "hasActivatedConfluenceWithinFourteenDaysSelector", () => $df15ab6efcbffe76$export$2b8e6729c89e24f5);
$parcel$export(module.exports, "hasActivatedConfluenceWithinSixtythreeDaysSelector", () => $df15ab6efcbffe76$export$a7671b4425572dc1);
$parcel$export(module.exports, "hasActivatedConfluenceWithinThirtyDaysSelector", () => $df15ab6efcbffe76$export$2321d15582b8ce8a);

var $dGvGJ = parcelRequire("dGvGJ");

var $70Rr2 = parcelRequire("70Rr2");
var $lb7qa = parcelRequire("lb7qa");
var $eZDAP = parcelRequire("eZDAP");
var $it1wb = parcelRequire("it1wb");
var $pyK8a = parcelRequire("pyK8a");


var $4Pf62 = parcelRequire("4Pf62");

var $k3PbQ = parcelRequire("k3PbQ");

var $fOGZN = parcelRequire("fOGZN");

var $g5X3G = parcelRequire("g5X3G");

var $ef5Xn = parcelRequire("ef5Xn");

var $dXq4S = parcelRequire("dXq4S");
const $df15ab6efcbffe76$export$c420c9f40402ab6d = (state)=>state.context;
const $df15ab6efcbffe76$export$cb29341089829e17 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.atlassianAccountId);
const $df15ab6efcbffe76$export$24984a39db14d8 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context?.orgId || null);
const $df15ab6efcbffe76$export$1ca9a92a5f28e233 = (_)=>'';
const $df15ab6efcbffe76$export$767583fcce1653ec = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.loginRedirectUrl);
const $df15ab6efcbffe76$export$d22bc6271070f453 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>(0, $g5X3G.toIssueKey)(context.issueKey));
const $df15ab6efcbffe76$export$31efbca30077ec1e = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.issueId);
const $df15ab6efcbffe76$export$404de5ac601b84bc = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$d22bc6271070f453, (issueKey)=>(0, $k3PbQ.extractProjectKey)(issueKey));
const $df15ab6efcbffe76$export$85a9d212d56669b4 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.analyticsSource !== undefined ? context.analyticsSource : undefined);
const $df15ab6efcbffe76$export$b5a643cfff945455 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.cloudId || (0, $g5X3G.toCloudId)(''));
const $df15ab6efcbffe76$export$a2cdbba2136e72d3 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$b5a643cfff945455, $df15ab6efcbffe76$export$31efbca30077ec1e, (cloudId, issueId)=>(0, $dXq4S.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issue',
        resourceId: issueId ?? ''
    }));
const $df15ab6efcbffe76$export$b600fd41c88f35c8 = (commentId)=>(0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$b5a643cfff945455, $df15ab6efcbffe76$export$31efbca30077ec1e, (cloudId, issueId)=>`ari:cloud:jira:${cloudId}:issue-comment/${issueId ?? ''}/${commentId}`);
const $df15ab6efcbffe76$export$2335b963a9875096 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.activationId || (0, $g5X3G.toActivationId)(''));
const $df15ab6efcbffe76$export$a165ec261432d0b8 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.isAnonymous);
const $df15ab6efcbffe76$export$f7b7935883444b11 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.locale);
const $df15ab6efcbffe76$export$b62cb5286b153905 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.issueActions || []);
const $df15ab6efcbffe76$export$6c7d07328f197de7 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.applicationKey);
const $df15ab6efcbffe76$export$4cbb8c74e98876a5 = (0, $dGvGJ.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$df15ab6efcbffe76$export$85a9d212d56669b4, (analyticsSource)=>analyticsSource === (0, $fcf97b7a09088940$export$ce88447986394f2d));
const $df15ab6efcbffe76$export$6fbe1dbaf5b67cc5 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$6c7d07328f197de7, (applicationKey)=>applicationKey === (0, $fOGZN.simpleSoftwareBoardConfiguration)().applicationKey || applicationKey === (0, $fOGZN.standardRoadmapConfiguration)().applicationKey);
const $df15ab6efcbffe76$export$7479ef2453efd3b4 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$6c7d07328f197de7, (applicationKey)=>applicationKey === (0, $fOGZN.softwareConfiguration)().applicationKey);
const $df15ab6efcbffe76$export$245e5ba54167b84a = (0, $dGvGJ.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$df15ab6efcbffe76$export$85a9d212d56669b4, (analyticsSource)=>analyticsSource === (0, $fcf97b7a09088940$export$7552fe2669628499));
const $df15ab6efcbffe76$export$43d733e4b7e8c7d0 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$6c7d07328f197de7, (applicationKey)=>applicationKey === (0, $fOGZN.serviceDeskConfiguration)().applicationKey);
const $df15ab6efcbffe76$export$9bffc1987c753bd9 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>!!context.ecosystemEnabled);
const $df15ab6efcbffe76$export$718e830000b27a0e = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.rapidViewId);
const $df15ab6efcbffe76$export$8065de5fbcf23af5 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.estimationStatistic || null);
const $df15ab6efcbffe76$export$5af08fd769c0f0 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.boardType);
const $df15ab6efcbffe76$export$955e7dbf76b61f80 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.boardId);
const $df15ab6efcbffe76$export$93badd2a066af8bd = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.siteAdminStatus);
const $df15ab6efcbffe76$export$b468116a08f9183e = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.productCrossSellConfig);
const $df15ab6efcbffe76$export$f29192b357e6beca = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.licensedProducts);
const $df15ab6efcbffe76$export$5b71e1eb43056b6c = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.appPermissions);
const $df15ab6efcbffe76$export$5fa593caa6a15917 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.isModal);
const $df15ab6efcbffe76$export$631793d49dec78de = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$5fa593caa6a15917, $df15ab6efcbffe76$export$4cbb8c74e98876a5, (isModal, isMobile)=>!isModal && !isMobile);
const $df15ab6efcbffe76$export$1f11fe78e4f22d45 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.viewMode);
const $df15ab6efcbffe76$export$28ca74e18c8f4529 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.appEditions);
const $df15ab6efcbffe76$export$beea798086c18f0a = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.licenseStates);
const $df15ab6efcbffe76$export$40487a15195e570e = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$beea798086c18f0a, (licenseStates)=>licenseStates && licenseStates.serviceDesk === (0, $ef5Xn.LICENSE_STATE_ACTIVE));
const $df15ab6efcbffe76$export$96c87532aec3474a = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$f29192b357e6beca, $df15ab6efcbffe76$export$40487a15195e570e, (licensedProducts, isServiceDeskLicenseActive)=>licensedProducts && licensedProducts[(0, $4Pf62.LICENSED_PRODUCTS).JIRA_SERVICEDESK] && isServiceDeskLicenseActive);
const $df15ab6efcbffe76$export$2fa17c0746682b0b = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$beea798086c18f0a, (licenseStates)=>licenseStates && licenseStates.productDiscovery === (0, $ef5Xn.LICENSE_STATE_ACTIVE));
const $df15ab6efcbffe76$export$f049ad7141428191 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$f29192b357e6beca, $df15ab6efcbffe76$export$2fa17c0746682b0b, (licensedProducts, isProductDiscoveryLicenseActive)=>Boolean(licensedProducts && licensedProducts[(0, $4Pf62.LICENSED_PRODUCTS).JIRA_PRODUCT_DISCOVERY] && isProductDiscoveryLicenseActive));
const $df15ab6efcbffe76$export$747a61878b414bda = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$c420c9f40402ab6d, (context)=>context.confluenceActivationDate);
const $df15ab6efcbffe76$export$2b8e6729c89e24f5 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$747a61878b414bda, (confluenceActivationDate)=>{
    try {
        if (!confluenceActivationDate) return false;
        const today = (0, $70Rr2.default)(new Date());
        const fourteenDaysAgo = (0, $it1wb.default)((0, $pyK8a.default)(today, 14));
        const dateToCheck = (0, $eZDAP.default)(confluenceActivationDate);
        return (0, $lb7qa.default)(dateToCheck, {
            start: fourteenDaysAgo,
            end: today
        });
    } catch (error) {
        return false;
    }
});
const $df15ab6efcbffe76$export$a7671b4425572dc1 = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$747a61878b414bda, (confluenceActivationDate)=>{
    if (!confluenceActivationDate) return false;
    const today = (0, $70Rr2.default)(new Date());
    const sixtythreeDaysAgo = (0, $it1wb.default)((0, $pyK8a.default)(today, 63));
    const dateToCheck = (0, $eZDAP.default)(confluenceActivationDate);
    return (0, $lb7qa.default)(dateToCheck, {
        start: sixtythreeDaysAgo,
        end: today
    });
});
const $df15ab6efcbffe76$export$2321d15582b8ce8a = (0, $dGvGJ.createSelector)($df15ab6efcbffe76$export$747a61878b414bda, (confluenceActivationDate)=>{
    try {
        if (!confluenceActivationDate) return false;
        const today = (0, $70Rr2.default)(new Date());
        const thirtyDaysAgo = (0, $it1wb.default)((0, $pyK8a.default)(today, 31)); // 31 days to account for the 30 day trial
        const dateToCheck = (0, $eZDAP.default)(confluenceActivationDate);
        return (0, $lb7qa.default)(dateToCheck, {
            start: thirtyDaysAgo,
            end: today
        });
    } catch (error) {
        return false;
    }
});

});
parcelRegister("fOGZN", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPE", () => $1df76d38eb6e3f90$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_SUMMARY", () => $1df76d38eb6e3f90$export$a464614f8f5fe986);
$parcel$export(module.exports, "SUBTASK_PARENT", () => $1df76d38eb6e3f90$export$a311a3c9b207604e);
$parcel$export(module.exports, "WATCHES", () => $1df76d38eb6e3f90$export$289917d9a7031e1d);
$parcel$export(module.exports, "VOTES", () => $1df76d38eb6e3f90$export$81614f6dc3be5b00);
$parcel$export(module.exports, "SECURITY", () => $1df76d38eb6e3f90$export$72a5630aa398d6b4);
$parcel$export(module.exports, "ISSUE_RESTRICTION", () => $1df76d38eb6e3f90$export$caf1ff54fbdf44bf);
$parcel$export(module.exports, "ASSIGNEE", () => $1df76d38eb6e3f90$export$f8f7545d2bb78afb);
$parcel$export(module.exports, "REPORTER", () => $1df76d38eb6e3f90$export$6d7021166edc895c);
$parcel$export(module.exports, "DUE_DATE", () => $1df76d38eb6e3f90$export$cf7e173386d30cdd);
$parcel$export(module.exports, "PRIORITY", () => $1df76d38eb6e3f90$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "LABELS", () => $1df76d38eb6e3f90$export$79b91d4669dcadcb);
$parcel$export(module.exports, "EPIC", () => $1df76d38eb6e3f90$export$3cb4a99a332e4186);
$parcel$export(module.exports, "FIX_VERSIONS", () => $1df76d38eb6e3f90$export$d7e18f5730074533);
$parcel$export(module.exports, "AFFECTS_VERSIONS", () => $1df76d38eb6e3f90$export$c435f0000304e508);
$parcel$export(module.exports, "TIME_TRACKING", () => $1df76d38eb6e3f90$export$ee99ef6ee562a446);
$parcel$export(module.exports, "TIME_ESTIMATE", () => $1df76d38eb6e3f90$export$a6a74b4bc927d39f);
$parcel$export(module.exports, "STATUS", () => $1df76d38eb6e3f90$export$e50006273435e7d4);
$parcel$export(module.exports, "CREATED", () => $1df76d38eb6e3f90$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $1df76d38eb6e3f90$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "SUMMARY", () => $1df76d38eb6e3f90$export$913055729e1380b2);
$parcel$export(module.exports, "DESCRIPTION", () => $1df76d38eb6e3f90$export$d44826c816b5619b);
$parcel$export(module.exports, "COMMENT", () => $1df76d38eb6e3f90$export$a29989082612d0d9);
$parcel$export(module.exports, "EPIC_ISSUES", () => $1df76d38eb6e3f90$export$8fe3d5be8cb17459);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $1df76d38eb6e3f90$export$3b3d0889022c85b3);
$parcel$export(module.exports, "ENVIRONMENT", () => $1df76d38eb6e3f90$export$be46596bc6608f3b);
$parcel$export(module.exports, "SUBTASKS", () => $1df76d38eb6e3f90$export$f528fadbfdb3c25e);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $1df76d38eb6e3f90$export$f10e53e8928b61bd);
$parcel$export(module.exports, "PARENT", () => $1df76d38eb6e3f90$export$e0dfb65d1047c53c);
$parcel$export(module.exports, "PORTFOLIO_CHILD_ISSUES", () => $1df76d38eb6e3f90$export$aba22e09a66f6826);
$parcel$export(module.exports, "SELECT_CUSTOM_FIELD_TYPE", () => $1df76d38eb6e3f90$export$826d657005bbe54c);
$parcel$export(module.exports, "FLAG_ACTIONS", () => $1df76d38eb6e3f90$export$cdbd1eb3b05729e0);
$parcel$export(module.exports, "CARD_COVER_ACTIONS", () => $1df76d38eb6e3f90$export$c161a774ec2e7e56);
$parcel$export(module.exports, "specialFields", () => $1df76d38eb6e3f90$export$89e5c40c0f5c7561);
$parcel$export(module.exports, "ecosystemCustomFields", () => $1df76d38eb6e3f90$export$87934b3672715c91);
$parcel$export(module.exports, "customFieldsToDisplay", () => $1df76d38eb6e3f90$export$efd443bccc4c01ed);
$parcel$export(module.exports, "itemDocumentationUrls", () => $1df76d38eb6e3f90$export$a18b3a656ee9c709);
$parcel$export(module.exports, "emptyConfiguration", () => $1df76d38eb6e3f90$export$a52507e68e7aeeb);
$parcel$export(module.exports, "softwareConfiguration", () => $1df76d38eb6e3f90$export$27e0678365e5dcff);
$parcel$export(module.exports, "simpleSoftwareBoardConfiguration", () => $1df76d38eb6e3f90$export$aebf676dfa727a1c);
$parcel$export(module.exports, "standardRoadmapConfiguration", () => $1df76d38eb6e3f90$export$1afca4d3eb6b218b);
$parcel$export(module.exports, "bitbucketConfiguration", () => $1df76d38eb6e3f90$export$8a060ed6f66c43b0);
$parcel$export(module.exports, "mobileConfiguration", () => $1df76d38eb6e3f90$export$78a2cb921e46f5eb);
$parcel$export(module.exports, "serviceDeskConfiguration", () => $1df76d38eb6e3f90$export$db1115186532f6d5);
$parcel$export(module.exports, "connectConfiguration", () => $1df76d38eb6e3f90$export$557d5094ec5cf234);
$parcel$export(module.exports, "getIssueConfiguration", () => $1df76d38eb6e3f90$export$902f6c5cc939598a);

var $65mz3 = parcelRequire("65mz3");

var $2vSU6 = parcelRequire("2vSU6");

var $5fc53 = parcelRequire("5fc53");
const $1df76d38eb6e3f90$export$ebb48b08205007c5 = 'issuetype';
const $1df76d38eb6e3f90$export$a464614f8f5fe986 = 'summary';
const $1df76d38eb6e3f90$export$a311a3c9b207604e = 'parent';
const $1df76d38eb6e3f90$export$2a4f270075a033de = 'parent-issue';
const $1df76d38eb6e3f90$export$4561a4960baf1b2b = 'parent'; // new Hierarchy unification parent field
const $1df76d38eb6e3f90$export$289917d9a7031e1d = 'watches';
const $1df76d38eb6e3f90$export$81614f6dc3be5b00 = 'votes';
const $1df76d38eb6e3f90$export$72a5630aa398d6b4 = 'security';
const $1df76d38eb6e3f90$export$caf1ff54fbdf44bf = 'issuerestriction';
const $1df76d38eb6e3f90$export$f8f7545d2bb78afb = 'assignee';
const $1df76d38eb6e3f90$export$6d7021166edc895c = 'reporter';
const $1df76d38eb6e3f90$export$cf7e173386d30cdd = 'duedate';
const $1df76d38eb6e3f90$export$bb34f3538ba26c7e = 'priority';
const $1df76d38eb6e3f90$export$79b91d4669dcadcb = 'labels';
const $1df76d38eb6e3f90$export$cbedbfe2cd0caec7 = 'components';
const $1df76d38eb6e3f90$export$950d47e775e208ee = 'devSummary';
const $1df76d38eb6e3f90$export$f91d2bb4cc99fa5e = 'releases';
const $1df76d38eb6e3f90$export$a316570a0dbfd2b0 = 'sprint';
const $1df76d38eb6e3f90$export$405b6d72f2d243a9 = 'storyPointsField';
const $1df76d38eb6e3f90$export$3cb4a99a332e4186 = 'epic';
const $1df76d38eb6e3f90$export$d7e18f5730074533 = 'fixVersions';
const $1df76d38eb6e3f90$export$c435f0000304e508 = 'versions';
const $1df76d38eb6e3f90$export$ee99ef6ee562a446 = 'timetracking';
const $1df76d38eb6e3f90$export$a6a74b4bc927d39f = 'timeoriginalestimate';
const $1df76d38eb6e3f90$export$e50006273435e7d4 = 'status';
const $1df76d38eb6e3f90$export$f1a6ce22cbb7eb32 = 'resolution';
const $1df76d38eb6e3f90$export$ff39ebd4bb12b718 = 'created';
const $1df76d38eb6e3f90$export$cd8e68094cb5c3cb = 'updated';
const $1df76d38eb6e3f90$export$1d0e0bb6a21b800b = 'SLA_PANEL';
const $1df76d38eb6e3f90$export$340fac260c3e3637 = 'LINKED_ALERTS';
const $1df76d38eb6e3f90$export$24ec4dcc8e5b08ef = 'CHAT_CHANNEL';
const $1df76d38eb6e3f90$export$8631065e0909313 = 'MSTEAMS_CHANNEL';
const $1df76d38eb6e3f90$export$3c4dccba7d7e0acb = 'ZOOM_MEETING';
const $1df76d38eb6e3f90$export$cd5e9246357daec3 = 'CONFERENCE_CALL';
const $1df76d38eb6e3f90$export$9c83bd19c3ffd90d = 'SENTIMENT';
const $1df76d38eb6e3f90$export$c5c04443c6097d6e = 'ASSET_ONBOARDING';
const $1df76d38eb6e3f90$export$26d855f4cd7e5fe9 = 'MANAGE_STAKEHOLDERS';
const $1df76d38eb6e3f90$export$913055729e1380b2 = 'summary';
const $1df76d38eb6e3f90$export$d44826c816b5619b = 'description';
const $1df76d38eb6e3f90$export$a29989082612d0d9 = 'comment';
const $1df76d38eb6e3f90$export$8fe3d5be8cb17459 = 'epic-issues'; // this field is only served in classic projects
const $1df76d38eb6e3f90$export$3b3d0889022c85b3 = 'children-issues';
const $1df76d38eb6e3f90$export$be46596bc6608f3b = 'environment';
const $1df76d38eb6e3f90$export$f528fadbfdb3c25e = 'subtasks';
const $1df76d38eb6e3f90$export$f10e53e8928b61bd = 'dataclassification';
const $1df76d38eb6e3f90$export$e0dfb65d1047c53c = (0, $5fc53.PARENT_CF_TYPE);
const $1df76d38eb6e3f90$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $1df76d38eb6e3f90$export$826d657005bbe54c = (0, $5fc53.SELECT_CF_TYPE);
const $1df76d38eb6e3f90$export$cdbd1eb3b05729e0 = 'flagActions';
const $1df76d38eb6e3f90$export$c161a774ec2e7e56 = 'cardCoverActions';
const $1df76d38eb6e3f90$export$89e5c40c0f5c7561 = ()=>{
    const fields = {
        [$1df76d38eb6e3f90$export$3cb4a99a332e4186]: 'com.pyxis.greenhopper.jira:gh-epic-link',
        [$1df76d38eb6e3f90$export$a316570a0dbfd2b0]: 'com.pyxis.greenhopper.jira:gh-sprint',
        [$1df76d38eb6e3f90$export$405b6d72f2d243a9]: 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint',
        [(0, $5fc53.TEAM_CF_TYPE)]: (0, $5fc53.TEAM_CF_TYPE),
        [(0, $5fc53.PARENT_CF_TYPE)]: (0, $5fc53.PARENT_CF_TYPE),
        [(0, $5fc53.BASELINE_START_CF_TYPE)]: (0, $5fc53.BASELINE_START_CF_TYPE),
        [(0, $5fc53.BASELINE_END_CF_TYPE)]: (0, $5fc53.BASELINE_END_CF_TYPE),
        [(0, $5fc53.COLOR_CF_TYPE)]: (0, $5fc53.COLOR_CF_TYPE),
        [(0, $5fc53.EPIC_COLOR_TYPE)]: (0, $5fc53.EPIC_COLOR_TYPE),
        [(0, $5fc53.EPIC_NAME_TYPE)]: (0, $5fc53.EPIC_NAME_TYPE)
    };
    return fields;
};
const $1df76d38eb6e3f90$export$87934b3672715c91 = [
    (0, $5fc53.ISSUE_FIELD_NUMBER_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_DATETIME_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
];
const $1df76d38eb6e3f90$var$serviceDeskCustomFields = [
    (0, $5fc53.REQUEST_PARTICIPANTS_CF_TYPE),
    (0, $5fc53.ORGANIZATIONS_CF_TYPE),
    (0, $5fc53.REQUEST_LANGUAGE_CF_TYPE),
    (0, $5fc53.REQUEST_FEEDBACK_CF_TYPE),
    (0, $5fc53.APPROVALS_CF_TYPE),
    (0, $5fc53.APPROVERS_LIST_CF_TYPE),
    (0, $5fc53.REQUEST_TYPE_CF_TYPE),
    (0, $5fc53.CMDB_OBJECT_CF_TYPE),
    (0, $5fc53.RESPONDERS_CF_TYPE),
    (0, $5fc53.MAJOR_INCIDENT_CF_TYPE),
    (0, $5fc53.ENTITLEMENT_CF_TYPE),
    (0, $5fc53.SENTIMENT_CF_TYPE),
    (0, $5fc53.ORGANIZATION_CF_TYPE)
];
const $1df76d38eb6e3f90$export$efd443bccc4c01ed = ()=>[
        (0, $5fc53.LABELS_CF_TYPE),
        (0, $5fc53.TEXT_CF_TYPE),
        (0, $5fc53.MULTI_USER_CF_TYPE),
        (0, $5fc53.PARTICIPANTS_CF_TYPE),
        (0, $5fc53.URL_CF_TYPE),
        (0, $5fc53.NUMBER_CF_TYPE),
        (0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE),
        (0, $5fc53.SELECT_CF_TYPE),
        (0, $5fc53.MULTI_SELECT_CF_TYPE),
        (0, $5fc53.VERSION_CF_TYPE),
        (0, $5fc53.TEXT_AREA_CF_TYPE),
        (0, $5fc53.MULTI_VERSION_CF_TYPE),
        (0, $5fc53.DATE_CF_TYPE),
        (0, $5fc53.GROUP_CF_TYPE),
        (0, $5fc53.MULTI_GROUP_CF_TYPE),
        (0, $5fc53.USER_CF_TYPE),
        (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE),
        (0, $5fc53.RADIO_BUTTONS_CF_TYPE),
        (0, $5fc53.DATETIME_CF_TYPE),
        (0, $5fc53.ASSETS_CF_TYPE),
        (0, $5fc53.SERVICE_ENTITY_CF_TYPE),
        (0, $5fc53.PEOPLE_CF_TYPE),
        (0, $5fc53.CASCADING_SELECT_CF_TYPE),
        (0, $5fc53.PROJECT_PICKER_CF_TYPE),
        (0, $5fc53.TEAMS_PLATFORM_CF_TYPE),
        (0, $5fc53.READ_ONLY_CF_TYPE),
        (0, $5fc53.EPIC_STATUS_TYPE),
        (0, $5fc53.MESSAGE_VIEW_CF_TYPE),
        (0, $5fc53.MESSAGE_EDIT_CF_TYPE),
        (0, $5fc53.CATEGORY_TYPE),
        (0, $5fc53.GOALS_CF_TYPE),
        ...$1df76d38eb6e3f90$export$87934b3672715c91,
        ...$1df76d38eb6e3f90$var$serviceDeskCustomFields
    ];
const $1df76d38eb6e3f90$export$a18b3a656ee9c709 = {
    [(0, $2vSU6.SOFTWARE_PROJECT)]: 'https://confluence.atlassian.com/jirasoftwarecloud/configure-field-layout-in-the-issue-view-961798059.html',
    [(0, $2vSU6.CORE_PROJECT)]: 'https://confluence.atlassian.com/jiracorecloud/configure-field-layout-in-the-issue-view-961798123.html',
    [(0, $2vSU6.SERVICE_DESK_PROJECT)]: 'https://support.atlassian.com/jira-service-desk-cloud/docs/what-are-the-different-sections-in-the-issue-view/'
};
const $1df76d38eb6e3f90$export$a52507e68e7aeeb = ()=>({
        issueActions: []
    });
const $1df76d38eb6e3f90$export$381ce08838c53afa = ()=>({
        applicationKey: (0, $65mz3.default).CORE_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$27e0678365e5dcff = ()=>({
        applicationKey: (0, $65mz3.default).SOFTWARE_ISSUE,
        issueActions: [
            $1df76d38eb6e3f90$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$aebf676dfa727a1c = ()=>({
        applicationKey: (0, $65mz3.default).SIMPLE_SOFTWARE_BOARD,
        issueActions: [
            $1df76d38eb6e3f90$export$cdbd1eb3b05729e0,
            $1df76d38eb6e3f90$export$c161a774ec2e7e56
        ],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$1afca4d3eb6b218b = ()=>({
        applicationKey: (0, $65mz3.default).STANDARD_ROADMAP_ISSUE,
        issueActions: [
            $1df76d38eb6e3f90$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$8a060ed6f66c43b0 = ()=>({
        applicationKey: (0, $65mz3.default).BITBUCKET_ISSUE,
        issueActions: []
    });
const $1df76d38eb6e3f90$export$78a2cb921e46f5eb = ()=>({
        applicationKey: (0, $65mz3.default).MOBILE_ISSUE,
        issueActions: []
    });
const $1df76d38eb6e3f90$export$db1115186532f6d5 = ()=>({
        applicationKey: (0, $65mz3.default).SERVICE_DESK,
        issueActions: [],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$557d5094ec5cf234 = ()=>({
        applicationKey: (0, $65mz3.default).CONNECT_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$902f6c5cc939598a = (config)=>{
    if (config) switch(config.projectType){
        case 0, $2vSU6.SOFTWARE_PROJECT:
            if (config.isSimplified) return $1df76d38eb6e3f90$export$aebf676dfa727a1c();
            return $1df76d38eb6e3f90$export$27e0678365e5dcff();
        case 0, $2vSU6.CORE_PROJECT:
            return $1df76d38eb6e3f90$export$381ce08838c53afa();
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return $1df76d38eb6e3f90$export$db1115186532f6d5();
        default:
            // fallback to sofware config
            return $1df76d38eb6e3f90$export$27e0678365e5dcff();
    }
    return $1df76d38eb6e3f90$export$27e0678365e5dcff();
};

});


parcelRegister("5flRJ", function(module, exports) {

$parcel$export(module.exports, "useUserHasAddProductPermissions", () => $02b119ed2b44a564$export$d223ceb381c5cc91);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $koeKL = parcelRequire("koeKL");

var $5oBMG = parcelRequire("5oBMG");


var $bSSG7 = parcelRequire("bSSG7");

var $4R6GH = parcelRequire("4R6GH");

var $k9JTq = parcelRequire("k9JTq");

var $ldyPw = parcelRequire("ldyPw");

var $eNR5n = parcelRequire("eNR5n");
const $02b119ed2b44a564$var$CONFLUENCE_ADD_PRODUCT_PERMISSION_STORAGE_KEY = 'confluence-add-product-permission';
const $02b119ed2b44a564$export$8e35886de8a54f45 = ()=>{
    const localStorageProvider = (0, $bSSG7.createLocalExpirableStorageProvider)('placeholderTemplateAddProductPermissionStorage');
    const getLocalStorage = ()=>localStorageProvider.get($02b119ed2b44a564$var$CONFLUENCE_ADD_PRODUCT_PERMISSION_STORAGE_KEY);
    const LOCAL_STORAGE_EXPIRY_MS = 86400000; // one day
    const setLocalStorage = (value)=>localStorageProvider.set($02b119ed2b44a564$var$CONFLUENCE_ADD_PRODUCT_PERMISSION_STORAGE_KEY, value, Date.now() + LOCAL_STORAGE_EXPIRY_MS);
    return {
        getLocalStorage: getLocalStorage,
        setLocalStorage: setLocalStorage
    };
};
const $02b119ed2b44a564$export$d223ceb381c5cc91 = ({ skip: skip = false })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const appEditions = (0, $k9JTq.useAppEditions)();
    const productEntitlementDetails = (0, $5oBMG.useProductEntitlementDetails)();
    const isBillingSystemCcp = productEntitlementDetails?.[0, $c06e1abca7c13910$export$1346c9aa3cbb477d]?.billingSourceSystem === 'CCP';
    const { getLocalStorage: getLocalStorage, setLocalStorage: setLocalStorage } = (0, $5uXOq.useMemo)(()=>$02b119ed2b44a564$export$8e35886de8a54f45(), []);
    const cachedStatus = getLocalStorage();
    const initialStatus = cachedStatus || {
        canProvisionConfluenceEndUser: false,
        fetchStatus: 'pending'
    };
    const [status, setStatus] = (0, $5uXOq.useState)(initialStatus);
    const handleFetchPermissions = (0, $5uXOq.useCallback)(async ()=>{
        try {
            let newStatus;
            if ((0, $4R6GH.fg)('end_user_activate_eligibility_check')) {
                const endUserResponse = await (0, $eNR5n.fetchEndUserAddProductPermissions)(cloudId, isBillingSystemCcp);
                newStatus = {
                    canProvisionConfluenceEndUser: endUserResponse?.eligible,
                    fetchStatus: 'resolved'
                };
            } else // If the feature flag is not enabled, set default status
            newStatus = {
                canProvisionConfluenceEndUser: appEditions.software === (0, $ldyPw.FREE_EDITION),
                fetchStatus: 'resolved'
            };
            setStatus(newStatus);
            setLocalStorage(newStatus);
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: $02b119ed2b44a564$var$CONFLUENCE_ADD_PRODUCT_PERMISSION_STORAGE_KEY,
                    packageName: 'jiraIssueViewBase',
                    teamName: 'starburst'
                },
                error: new Error(`Failed to get ${$02b119ed2b44a564$var$CONFLUENCE_ADD_PRODUCT_PERMISSION_STORAGE_KEY} status: ${error}`)
            });
            const errorStatus = {
                canProvisionConfluenceEndUser: false,
                fetchStatus: 'failed'
            };
            setStatus(errorStatus);
            setLocalStorage(errorStatus);
        }
    }, [
        cloudId,
        isBillingSystemCcp,
        appEditions.software,
        setLocalStorage
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!skip && cloudId && !cachedStatus) handleFetchPermissions();
    }, [
        cloudId,
        skip,
        cachedStatus,
        handleFetchPermissions
    ]);
    return status;
};

});
parcelRegister("eNR5n", function(module, exports) {

$parcel$export(module.exports, "fetchEndUserAddProductPermissions", () => $127af63ffc4c56b3$export$e9573be2f5180789);

var $7f4tk = parcelRequire("7f4tk");
const $127af63ffc4c56b3$var$CONFLUENCE_FREE_OFFERING_KEY = '7547cfd6-a804-4e42-8bed-e656d49ea09e';
const $127af63ffc4c56b3$export$e9573be2f5180789 = async (cloudId, isBillingSystemCcp)=>{
    const response = await (0, $7f4tk.default)('/gateway/api/bxp/signup/product/end-user-activate-eligible-check', {
        method: 'POST',
        body: JSON.stringify({
            cloudId: cloudId,
            isCCP: isBillingSystemCcp,
            offerings: [
                {
                    offeringId: $127af63ffc4c56b3$var$CONFLUENCE_FREE_OFFERING_KEY,
                    chargeElement: 'user',
                    pricingType: 'FREE'
                }
            ]
        })
    });
    return response;
};

});


parcelRegister("kagli", function(module, exports) {

$parcel$export(module.exports, "useAreProductSuggestionsEnabled", () => $e55c87028f55caec$export$3fb3b8b7f13e1089);

var $9OXo1 = parcelRequire("9OXo1");
const $e55c87028f55caec$export$3fb3b8b7f13e1089 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.areProductSuggestionsEnabled || false;
};

});



parcelRegister("j2nvL", function(module, exports) {

$parcel$export(module.exports, "PlacementFetchProvider", () => $d1dd0ebdae4a4c66$export$9be10e5cc29463c9);

var $5uXOq = parcelRequire("5uXOq");

var $gJHNN = parcelRequire("gJHNN");

var $fyLzM = parcelRequire("fyLzM");
const $d1dd0ebdae4a4c66$export$9be10e5cc29463c9 = ({ children: children, resource: resource })=>{
    const fetch = (0, $fyLzM.usePlacementSSRFetch)(resource);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gJHNN.PlacementFetchingProvider), {
        fetch: fetch
    }, children);
};

});
parcelRegister("gJHNN", function(module, exports) {

$parcel$export(module.exports, "usePlacementFetchingContext", () => $a48bd9eae05c0bd5$export$e1e2cdb0425a9fa8);
$parcel$export(module.exports, "PlacementFetchingProvider", () => $a48bd9eae05c0bd5$export$5f25a6ddf0324fa8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $a48bd9eae05c0bd5$export$afec669dc416ee7e = /*#__PURE__*/ (0, $5uXOq.createContext)({
    fetch: (...args)=>globalThis.fetch(...args)
});
const $a48bd9eae05c0bd5$export$e1e2cdb0425a9fa8 = ()=>(0, $5uXOq.useContext)($a48bd9eae05c0bd5$export$afec669dc416ee7e);
const $a48bd9eae05c0bd5$export$5f25a6ddf0324fa8 = ({ fetch: fetch, children: children })=>{
    const value = (0, $5uXOq.useMemo)(()=>({
            fetch: fetch
        }), [
        fetch
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($a48bd9eae05c0bd5$export$afec669dc416ee7e.Provider, {
        value: value,
        children: children
    });
};

});


parcelRegister("SfWIb", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb8d031c7e1e7737$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $dmvPD = parcelRequire("dmvPD");

var $hSlVD = parcelRequire("hSlVD");

var $iXSVm = parcelRequire("iXSVm");

var $5uXOq = parcelRequire("5uXOq");

var $cPceA = parcelRequire("cPceA");

const $fb8d031c7e1e7737$var$STABLE_OBJECT = {};
const $fb8d031c7e1e7737$var$Placement = ({ placementId: placementId, placementProps: placementProps, children: children, ErrorFallback: ErrorFallback, PlacementComponent: PlacementComponent, disableInitialData: disableInitialData = false, onEvent: onEvent })=>{
    const MemoizedPlacement = (0, $5uXOq.useMemo)(()=>(0, $iXSVm.createPlacementComponent)(placementId, PlacementComponent), [
        placementId,
        PlacementComponent
    ]);
    const stableLocalPlacementProps = (0, $dmvPD.useStableObject)(placementProps ?? $fb8d031c7e1e7737$var$STABLE_OBJECT);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hSlVD.default), {
        placementId: placementId,
        consumptionType: "local",
        onEvent: onEvent,
        disableInitialData: disableInitialData,
        children: ({ initialData: initialData, context: context, onEvent: sharedOnEvent })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $cPceA.default), {
                analyticsChannel: (0, $78e0a2ec69f009c2$export$85183a312807388d),
                placementId: placementId,
                onError: sharedOnEvent,
                fallback: ErrorFallback,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(MemoizedPlacement, {
                    initialData: initialData,
                    context: context,
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore - Confluence Local Consumption
                    errorFallback: ErrorFallback,
                    ...stableLocalPlacementProps,
                    children: children
                })
            })
    });
};
var $fb8d031c7e1e7737$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($fb8d031c7e1e7737$var$Placement);

});
parcelRegister("hSlVD", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e0442339d567e11$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $1PVpv = parcelRequire("1PVpv");

var $gHZ4O = parcelRequire("gHZ4O");
var $lwdce = parcelRequire("lwdce");
var $dmvPD = parcelRequire("dmvPD");

var $cM1px = parcelRequire("cM1px");
var $cFk7t = parcelRequire("cFk7t");

var $gJHNN = parcelRequire("gJHNN");

var $5uXOq = parcelRequire("5uXOq");


var $i3PqM = parcelRequire("i3PqM");

var $fCqPa = parcelRequire("fCqPa");
const $6e0442339d567e11$var$useInitialDataIfEnabled = (placementId, context, baseUrl, path, disableInitialData)=>{
    const fetcher = (0, $gJHNN.usePlacementFetchingContext)();
    return (0, $5uXOq.useMemo)(()=>disableInitialData ? undefined : (0, $i3PqM.requestInitialData)(placementId, context, fetcher.fetch, {
            baseUrl: baseUrl,
            path: path
        }), [
        disableInitialData,
        baseUrl,
        path,
        placementId,
        context,
        fetcher.fetch
    ]);
};
const $6e0442339d567e11$var$Placement = ({ placementId: placementId, consumptionType: consumptionType, onEvent: placementOnEvent, disableInitialData: disableInitialData = false, children: children })=>{
    const isUFOEnabled = true;
    const postOfficeRoute = (0, $lwdce.usePostOfficeRoute)();
    const context = (0, $gHZ4O.usePostOfficeContext)();
    const { baseUrl: baseUrl, path: path } = (0, $fCqPa.useBuildBasePath)();
    const stableContextWithRoute = (0, $dmvPD.useStableObject)({
        ...context,
        postOfficeRoute: postOfficeRoute
    });
    const ufoV1PlacementTracker = (0, $5uXOq.useMemo)(()=>isUFOEnabled ? new (0, $cM1px.UFOv1).PlacementPerformanceTracker(placementId, consumptionType) : undefined, [
        isUFOEnabled,
        placementId,
        consumptionType
    ]);
    // Callback function to listen to the different stages of the remote component and track its performance
    const remoteComponentOnEvent = (0, $5uXOq.useCallback)(({ type: type, error: error })=>{
        placementOnEvent?.({
            type: type,
            error: error
        });
        switch(type){
            case 'fetch-complete':
                ufoV1PlacementTracker?.markFetchComplete();
                break;
            case 'fetch-error':
                ufoV1PlacementTracker?.markFetchFailure(error);
                break;
            case 'render-complete':
                ufoV1PlacementTracker?.markRenderComplete();
                break;
            case 'render-error':
                ufoV1PlacementTracker?.markRenderFailure(error);
                break;
            case 'initial-data-complete':
                ufoV1PlacementTracker?.markInitialDataComplete();
                break;
            case 'initial-data-error':
                ufoV1PlacementTracker?.markInitialDataFailure(error);
                break;
            case 'component-error':
                ufoV1PlacementTracker?.markComponentFailure(error);
                break;
            case 'component-ready':
                ufoV1PlacementTracker?.markComponentReady();
                break;
            case 'unmount':
                ufoV1PlacementTracker?.markComponentAborted();
                break;
        }
    }, [
        placementOnEvent,
        ufoV1PlacementTracker
    ]);
    const initialData = $6e0442339d567e11$var$useInitialDataIfEnabled(placementId, context, baseUrl, path, disableInitialData);
    const placementAnalyticsContext = (0, $5uXOq.useMemo)(()=>({
            source: (0, $4a3047497e43ac2c$export$f7109619a5e9e0d6),
            componentName: `Placement`,
            attributes: {
                placementId: placementId,
                channel: 'in-app'
            }
        }), [
        placementId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($6e0442339d567e11$var$FeatureFlaggedUfoWrapper, {
        placementId: placementId,
        isEnabled: isUFOEnabled,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1PVpv.PostOfficeAnalyticsContext), {
            data: placementAnalyticsContext,
            children: children({
                initialData: initialData,
                context: stableContextWithRoute,
                onEvent: remoteComponentOnEvent
            })
        })
    });
};
var $6e0442339d567e11$export$2e2bcd8739ae039 = $6e0442339d567e11$var$Placement;
const $6e0442339d567e11$var$FeatureFlaggedUfoWrapper = ({ isEnabled: isEnabled, placementId: placementId, children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cFk7t.UFOv2).UFOSegment, {
        name: (0, $cFk7t.UFOv2).SegmentNames.PLACEMENT,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cFk7t.UFOv2).UFOSegment, {
            name: `${(0, $cFk7t.UFOv2).SegmentNames.PLACEMENT}.${placementId}`,
            children: children
        })
    });
};

});
const $4a3047497e43ac2c$export$85183a312807388d = 'postOffice';
const $4a3047497e43ac2c$export$f7109619a5e9e0d6 = 'post-office-frontend';

parcelRegister("fCqPa", function(module, exports) {

$parcel$export(module.exports, "useBuildBasePath", () => $20e92ff975054175$export$83d6c58b7ab7ae67);

var $87o4H = parcelRequire("87o4H");
var $5MYiV = parcelRequire("5MYiV");

var $5uXOq = parcelRequire("5uXOq");
const $20e92ff975054175$export$83d6c58b7ab7ae67 = ()=>{
    const postOfficeEnvironment = (0, $5MYiV.usePostOfficeEnvironment)();
    return (0, $5uXOq.useMemo)(()=>(0, $87o4H.buildBasePath)(postOfficeEnvironment.currentEnv, postOfficeEnvironment.envConfigs), [
        postOfficeEnvironment.currentEnv,
        postOfficeEnvironment.envConfigs
    ]);
};

});


parcelRegister("cPceA", function(module, exports) {

$parcel$export(module.exports, "default", () => $53bcb23f511c4129$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $cb25w = parcelRequire("cb25w");

var $5uXOq = parcelRequire("5uXOq");
class $53bcb23f511c4129$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    componentDidCatch(error, errorInfo) {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'handled',
            actionSubject: 'error',
            actionSubjectId: 'postOfficePlacementErrorBoundary',
            attributes: {
                error: error?.message,
                errorInfo: errorInfo,
                placementId: this.props.placementId
            }
        });
        analyticsEvent.fire(this.props.analyticsChannel);
        this.props.onError({
            error: error,
            type: 'render-error'
        });
        this.setState({
            hasError: true
        });
    }
    render() {
        if (this.state.hasError) return this.props.fallback ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: this.props.fallback
        }) : null;
        return this.props.children;
    }
}
var $53bcb23f511c4129$export$2e2bcd8739ae039 = (0, $cb25w.default)()($53bcb23f511c4129$var$ErrorBoundary);

});

const $78e0a2ec69f009c2$export$85183a312807388d = 'postOffice';



parcelRegister("gmCnE", function(module, exports) {

$parcel$export(module.exports, "Banner", () => $08223c6bc94e2fa4$export$3b4e64e77073e307);

var $fS15W = parcelRequire("fS15W");
const $08223c6bc94e2fa4$export$3b4e64e77073e307 = (0, $fS15W.Banner);

});
parcelRegister("fS15W", function(module, exports) {

$parcel$export(module.exports, "Banner", () => $b1ce89655e6eb483$export$3b4e64e77073e307);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $gwIPs = parcelRequire("gwIPs");


var $2Upgn = parcelRequire("2Upgn");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $asgRx = parcelRequire("asgRx");

var $6ohPr = parcelRequire("6ohPr");

var $3HwlS = parcelRequire("3HwlS");

var $iqLcb = parcelRequire("iqLcb");

var $9L6Zg = parcelRequire("9L6Zg");

var $gk4cG = parcelRequire("gk4cG");

var $adRnT = parcelRequire("adRnT");

var $iaN8D = parcelRequire("iaN8D");

var $14pJv = parcelRequire("14pJv");

var $921us = parcelRequire("921us");

var $9Cdg4 = parcelRequire("9Cdg4");

var $aAExw = parcelRequire("aAExw");

var $9ylrc = parcelRequire("9ylrc");

var $l8ruj = parcelRequire("l8ruj");


var $WhXfc = parcelRequire("WhXfc");

var $dm0Uk = parcelRequire("dm0Uk");
/**
 * This ID is used in pollinator tests and by JPD. Do not change lightly.
 */ const $b1ce89655e6eb483$var$BANNER_ID = 'page-layout.banner';
const $b1ce89655e6eb483$export$496ffd8dda3bf451 = ()=>{
    const banner = (0, $9L6Zg.useBanner)();
    return banner.isEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.Banner), {
        height: banner.height,
        testId: $b1ce89655e6eb483$var$BANNER_ID,
        id: $b1ce89655e6eb483$var$BANNER_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b1ce89655e6eb483$var$BannerContent, {
        bannerName: banner.name
    }))) : null;
};
const $b1ce89655e6eb483$export$b5cfff585ada92ce = ()=>{
    const banner = (0, $9L6Zg.useBanner)();
    return banner.isEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dm0Uk.ZIndexWrapper), {
        zIndex: (0, $gwIPs.layers).banner
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.Banner), {
        height: banner.height,
        id: $b1ce89655e6eb483$var$BANNER_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b1ce89655e6eb483$var$BannerContent, {
        bannerName: banner.name
    })))) : null;
};
const $b1ce89655e6eb483$var$BannerContent = ({ bannerName: bannerName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, bannerName === (0, $gk4cG.NAME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $adRnT.BannerAnnouncementAsync), null), bannerName === (0, $asgRx.BANNER_NAME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6ohPr.IPBlocklistingBannerAsync), null), bannerName === (0, $aAExw.BANNER_NAME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9ylrc.ReturnToMobileBanner), null), bannerName === (0, $91be75e714d10b24$export$41956b146268af93) && (0, $4R6GH.fg)('jfp-magma-cookie-controls-banner-show') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Upgn.CookieConsentBannerAsync), null), bannerName === (0, $iaN8D.BANNER_NAME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $14pJv.BannerTransitionAsync), null), bannerName === (0, $921us.BANNER_NAME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Cdg4.MailExpiryBannerAsync), null), bannerName === (0, $081c66d1b8c3065c$export$41956b146268af93) && (0, $4R6GH.fg)('polaris_pol-15006_premium_onboarding_banner') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WhXfc.AsyncJpdPremiumOnboardingBanner), null));
const $b1ce89655e6eb483$export$3b4e64e77073e307 = (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), $b1ce89655e6eb483$export$496ffd8dda3bf451, $b1ce89655e6eb483$export$b5cfff585ada92ce);

});
const $91be75e714d10b24$export$41956b146268af93 = 'COOKIE_CONSENT_BANNER';
const $91be75e714d10b24$export$ed7cc0d417ee89e = 74;
const $91be75e714d10b24$export$ff6e18f7d82b549c = 320;

parcelRegister("2Upgn", function(module, exports) {

$parcel$export(module.exports, "CookieConsentBannerAsync", () => $8357736d9e1344aa$export$f110a9cbbbd3fa3a);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $8357736d9e1344aa$var$LazyCookieConsentBanner = (0, $kxZPA.lazy)(()=>// chunk name is async-ccb to avoid scripts with cookie/banner keywords getting blocked
    (parcelRequire("vdODO")).then(({ CookieConsentBanner: CookieConsentBanner })=>CookieConsentBanner), {
    moduleId: "./src/packages/platform/ui/banners/cookie-consent/src/ui/banner/CookieConsentBanner.tsx"
});
const $8357736d9e1344aa$export$f110a9cbbbd3fa3a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8357736d9e1344aa$var$boxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async-cookie-consent-banner",
        packageName: "jiraCookieConsentBanner",
        teamName: "Magma"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-cookie-consent-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8357736d9e1344aa$var$LazyCookieConsentBanner, null))));
const $8357736d9e1344aa$var$boxStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'elevation.surface.sunken',
    height: '100%'
});

});
parcelRegister("vdODO", function(module, exports) {

let $05dd9ce4d6f647bb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $05dd9ce4d6f647bb$var$load("gvkTQ").then(()=>parcelRequire('vtgYF'));

});


parcelRegister("asgRx", function(module, exports) {

$parcel$export(module.exports, "bannerHeight", () => $692526aac37c19f2$export$86047f02632f9f5b);
$parcel$export(module.exports, "BANNER_NAME", () => $692526aac37c19f2$export$41956b146268af93);

var $gwIPs = parcelRequire("gwIPs");
const $692526aac37c19f2$export$86047f02632f9f5b = (0, $gwIPs.gridSize) * 7;
const $692526aac37c19f2$export$41956b146268af93 = 'IP_BLOCK_LISTING_BANNER';

});

parcelRegister("6ohPr", function(module, exports) {

$parcel$export(module.exports, "IPBlocklistingBannerAsync", () => $f9467d6df1e451da$export$fafc306b802ab39d);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f9467d6df1e451da$var$IPBlocklistingBannerComp = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("2ULSV")).then((m)=>m.IPBlocklistingBanner), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/ip-block-listing-banner/src/main.tsx"
});
const $f9467d6df1e451da$export$fafc306b802ab39d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-ip-block-listing-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f9467d6df1e451da$var$IPBlocklistingBannerComp, null));

});
parcelRegister("2ULSV", function(module, exports) {

let $21f5f4b25ccb069e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $21f5f4b25ccb069e$var$load("5yE6E").then(()=>parcelRequire('h9o9V'));

});


parcelRegister("9L6Zg", function(module, exports) {

$parcel$export(module.exports, "useBanner", () => $83eb9a3cdcaec997$export$de40f69ba30f2376);

var $5uXOq = parcelRequire("5uXOq");

var $iPh5B = parcelRequire("iPh5B");

var $4R6GH = parcelRequire("4R6GH");

var $iMzQW = parcelRequire("iMzQW");

var $14V0U = parcelRequire("14V0U");

var $6RMJw = parcelRequire("6RMJw");

var $hESBP = parcelRequire("hESBP");

var $2jAre = parcelRequire("2jAre");

var $lrZro = parcelRequire("lrZro");

var $dQYuq = parcelRequire("dQYuq");
const $83eb9a3cdcaec997$var$noBanner = {
    name: null,
    height: 0,
    isEnabled: false
};
const $83eb9a3cdcaec997$export$de40f69ba30f2376 = ({ ignoreChromeless: ignoreChromeless = false } = {})=>{
    const [isChromeless] = (0, $14V0U.useIsChromeless)();
    const announcement = (0, $6RMJw.useBannerAnnouncement)();
    const transition = (0, $hESBP.useBannerEocTransition)();
    const returnToMobile = (0, $lrZro.useBannerReturnToMobile)();
    const IPBlocklisting = (0, $iMzQW.useBannerIPBlocklisting)();
    // eslint-disable-next-line react-hooks/react-compiler
    const cookieConsent = (0, $4R6GH.fg)('jfp-magma-cookie-controls-banner-show') // eslint-disable-next-line react-hooks/rules-of-hooks
     ? (0, $iPh5B.useBannerCookieConsent)() : undefined;
    const mailExpiry = (0, $2jAre.useBannerMailExpiry)();
    const jpdPremiumOnboarding = (0, $dQYuq.useBannerJpdPremiumOnboarding)();
    // we have added this check to return banner data for assets routes as all the routes in assets are chromeless
    // but we want to show the announcement banner in assets routes
    const isChromelessCheck = ignoreChromeless && (0, $4R6GH.fg)('show_announcement_banner_in_assets') ? false : isChromeless;
    return (0, $5uXOq.useMemo)(()=>{
        // cookie consent banner has the highest priority
        if (cookieConsent?.isEnabled) return cookieConsent;
        if (isChromelessCheck) return $83eb9a3cdcaec997$var$noBanner;
        if (IPBlocklisting.isEnabled) return IPBlocklisting;
        if (returnToMobile.isEnabled) return returnToMobile;
        if (announcement.isEnabled) return announcement;
        if (transition?.isEnabled) return transition;
        if (mailExpiry?.isEnabled) return mailExpiry;
        if (jpdPremiumOnboarding.isEnabled) return jpdPremiumOnboarding;
        return $83eb9a3cdcaec997$var$noBanner;
    }, [
        cookieConsent,
        isChromelessCheck,
        IPBlocklisting,
        returnToMobile,
        announcement,
        transition,
        mailExpiry,
        jpdPremiumOnboarding
    ]);
};

});
parcelRegister("iPh5B", function(module, exports) {

$parcel$export(module.exports, "useBannerCookieConsent", () => $e552544bdd302edb$export$c7a51b5ee06f5794);

var $5uXOq = parcelRequire("5uXOq");

var $aqpLW = parcelRequire("aqpLW");

var $2eyDn = parcelRequire("2eyDn");


var $gubdC = parcelRequire("gubdC");
const $e552544bdd302edb$export$5503c67b1001ec45 = (data)=>{
    try {
        return data && (0, $aqpLW.shouldRenderBannerPrefetched)(data);
    } catch (e) {
        return true;
    }
};
const $e552544bdd302edb$export$c7a51b5ee06f5794 = ()=>{
    const [{ isDismissed: isDismissed, height: height }, { onShow: onShow }] = (0, $gubdC.useCookieConsentBannerSettings)();
    const { data: data } = (0, $2eyDn.useConsentBannerUserPreferencesResource)();
    (0, $5uXOq.useEffect)(()=>{
        const shouldRender = $e552544bdd302edb$export$5503c67b1001ec45(data);
        // only show banner if banner should be shown and not in iframe
        if (shouldRender && !(0, $gubdC.isInIframe)()) // the initial state of banner is "Dismissed" so we need to show it if we "think" it should be shown
        // in case we are making a mistake and CookieBanner will not display
        // it will inform us via `onConsentBannerBailOut` and we will dismiss the banner again.
        onShow();
    }, [
        data,
        onShow
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            isEnabled: !isDismissed,
            name: (0, $91be75e714d10b24$export$41956b146268af93),
            height: height
        }), [
        isDismissed,
        height
    ]);
};

});
parcelRegister("aqpLW", function(module, exports) {

$parcel$export(module.exports, "shouldRenderBannerPrefetched", () => $a183f8f7d6fe637a$export$6406464aa126433e);

var $VSDnB = parcelRequire("VSDnB");

var $jhSue = parcelRequire("jhSue");

var $gHrGQ = parcelRequire("gHrGQ");

var $bKAlw = parcelRequire("bKAlw");
const $a183f8f7d6fe637a$export$6406464aa126433e = (prefetchedPreferencesData)=>{
    if ((0, $VSDnB.fg)('platform_moonjelly_bsc_ssr_killswitch')) // If the bsc ssr killswitch is enabled, we should not show the banner
    // in SSR context
    return false;
    if (!prefetchedPreferencesData) // If prefetched prefs are missing (presumably SSR prefetching failed), but are still trying to compute
    // banner state, we have no info to calculate from so, we need to show the banner to be compliant
    return true;
    if ('consentToken' in prefetchedPreferencesData) {
        // We've been given cached cookie data, validate it before use.
        // If invalid, we can't determine anything, show the banner for compliance sake
        const { isValid: isValid } = (0, $gHrGQ.checkTokenVersionValidity)(prefetchedPreferencesData.consentToken);
        return isValid ? (0, $bKAlw.getBannerVisibility)(prefetchedPreferencesData) : true;
    }
    // We've been given ConsentHub response data, format it appropriately
    const consentPrefsData = (0, $jhSue.buildConsentPreferences)(prefetchedPreferencesData);
    return (0, $bKAlw.getBannerVisibility)(consentPrefsData);
};

});

parcelRegister("gubdC", function(module, exports) {

$parcel$export(module.exports, "isInIframe", () => $53f6acf0285fde21$export$9f140ed41af5108c);
$parcel$export(module.exports, "useCookieConsentBannerSettings", () => $53f6acf0285fde21$export$ae97931560f092a4);
$parcel$export(module.exports, "useCookieConsentBannerSettingsActions", () => $53f6acf0285fde21$export$ecbab4dc5f9ad844);

var $gKZoD = parcelRequire("gKZoD");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $4R6GH = parcelRequire("4R6GH");
const $53f6acf0285fde21$export$9f140ed41af5108c = ()=>{
    (0, $gKZoD.di)(window);
    if (false) return false;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window !== window.top;
};
const $53f6acf0285fde21$export$aa1483cc2e197f6e = ()=>{
    if (false) return false;
    return true;
};
const $53f6acf0285fde21$export$d4c72bab9d6cc13a = {
    get isDismissed () {
        return (0, $4R6GH.fg)('magma-3429_banners_in_modern_ssr') ? true : $53f6acf0285fde21$export$aa1483cc2e197f6e();
    },
    height: 0
};
const $53f6acf0285fde21$export$e324594224ef24da = {
    onShow: ()=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                isDismissed: false
            });
        },
    onDismiss: ()=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                isDismissed: true
            });
        },
    setHeight: (height)=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                height: height
            });
        }
};
const $53f6acf0285fde21$var$Store = (0, $iXqE5.createStore)({
    name: 'cookie-consent-banner',
    initialState: $53f6acf0285fde21$export$d4c72bab9d6cc13a,
    actions: $53f6acf0285fde21$export$e324594224ef24da
});
const $53f6acf0285fde21$export$ae97931560f092a4 = (0, $3sQ5x.createHook)($53f6acf0285fde21$var$Store);
const $53f6acf0285fde21$export$ecbab4dc5f9ad844 = (0, $3sQ5x.createActionsHook)($53f6acf0285fde21$var$Store);

});


parcelRegister("iMzQW", function(module, exports) {

$parcel$export(module.exports, "useBannerIPBlocklisting", () => $014906e38669dbae$export$564412c1d9cd4ccc);

var $5uXOq = parcelRequire("5uXOq");

var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");

var $4R6GH = parcelRequire("4R6GH");

var $asgRx = parcelRequire("asgRx");
const $014906e38669dbae$export$564412c1d9cd4ccc = ()=>{
    const [shouldShowBanner, setBannerState] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $4R6GH.fg)('firefox_issue_view_memory_leak_v1')) // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $cQZXC.waitForHeritage)()?.then(()=>// eslint-disable-next-line jira/wrm/no-load-bridge
            (0, $7T84i.loadBridgeStrict)({
                wrmKeys: [
                    'wrc!com.atlassian.jira.jira-atlaskit-plugin:ipblocklisting'
                ],
                name: 'jira/global-components/ipblocklisting/bridge'
            }).then((bridge)=>{
                // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                bridge({
                    showIPBlocklistBanner: ()=>setBannerState(true),
                    hideIPBlocklistBanner: ()=>setBannerState(false)
                });
            }));
        else // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $9B86Q.loadBridgeWeak)({
            name: 'jira/global-components/ipblocklisting/bridge'
        }).then((bridge)=>{
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            bridge({
                showIPBlocklistBanner: ()=>setBannerState(true),
                hideIPBlocklistBanner: ()=>setBannerState(false)
            });
        });
    }, []);
    return (0, $5uXOq.useMemo)(()=>({
            isEnabled: shouldShowBanner,
            name: (0, $asgRx.BANNER_NAME),
            height: (0, $asgRx.bannerHeight)
        }), [
        shouldShowBanner
    ]);
};

});

parcelRegister("6RMJw", function(module, exports) {

$parcel$export(module.exports, "useBannerAnnouncement", () => $6710252c02f204b2$export$1e775b1ab04f2888);

var $5uXOq = parcelRequire("5uXOq");

var $5kYzp = parcelRequire("5kYzp");

var $cZpsT = parcelRequire("cZpsT");

var $gk4cG = parcelRequire("gk4cG");
const $6710252c02f204b2$export$1e775b1ab04f2888 = ()=>{
    const { data: data } = (0, $5kYzp.useAnnouncementBannerSettingsV4Resource)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    return (0, $5uXOq.useMemo)(()=>({
            isEnabled: Boolean(data?.isEnabled) && !data?.isDismissed && (data?.visibility === 'private' && !isAnonymous || data?.visibility === 'public'),
            name: (0, $gk4cG.NAME),
            height: (0, $gk4cG.HEIGHT)
        }), [
        data?.isDismissed,
        data?.isEnabled,
        data?.visibility,
        isAnonymous
    ]);
};

});
parcelRegister("gk4cG", function(module, exports) {

$parcel$export(module.exports, "HEIGHT", () => $8ea828cd42179fda$export$809d2b099693a9a8);
$parcel$export(module.exports, "NAME", () => $8ea828cd42179fda$export$3c5e605ca7ade9f2);

var $gwIPs = parcelRequire("gwIPs");
const $8ea828cd42179fda$export$809d2b099693a9a8 = (0, $gwIPs.gridSize) * 8;
const $8ea828cd42179fda$export$3c5e605ca7ade9f2 = 'ANNOUNCEMENT';

});


parcelRegister("hESBP", function(module, exports) {

$parcel$export(module.exports, "useBannerEocTransition", () => $304370119e420b48$export$b6539a8209f95b48);

var $5uXOq = parcelRequire("5uXOq");

var $ez5GD = parcelRequire("ez5GD");

var $201IG = parcelRequire("201IG");

var $8J6rn = parcelRequire("8J6rn");

var $itmJb = parcelRequire("itmJb");

var $cNd4s = parcelRequire("cNd4s");

var $iaN8D = parcelRequire("iaN8D");
const $304370119e420b48$export$b6539a8209f95b48 = ()=>{
    const { data: data, error: error } = (0, $ez5GD.useOgConsolidationUserState)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const { isTransitionEligible: isTransitionEligible, error: tenantInfoError } = (0, $8J6rn.useOgTenantInfo)();
    const isEnabled = Boolean((isAdmin || isSiteAdmin) && // Tenant info
    !tenantInfoError && isTransitionEligible && // User state
    !error && data && (!data.isTransitionBannerDismissed || (0, $201IG.shouldRenderBenefitModal)({
        bannerDismissedAt: data.transitionBannerDismissedAt,
        isDismissed: data.isBenefitModalDismissed
    })));
    return (0, $5uXOq.useMemo)(()=>({
            isEnabled: isEnabled,
            name: (0, $iaN8D.BANNER_NAME),
            height: data && (0, $201IG.shouldRenderBenefitModal)({
                bannerDismissedAt: data.transitionBannerDismissedAt
            }) ? 0 : (0, $iaN8D.HEIGHT)
        }), [
        data,
        isEnabled
    ]);
};

});
parcelRegister("ez5GD", function(module, exports) {

$parcel$export(module.exports, "useOgConsolidationUserState", () => $e71f39314801737b$export$c35632c02599163f);

var $5uXOq = parcelRequire("5uXOq");

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $iXaZ3 = parcelRequire("iXaZ3");

var $kMiZJ = parcelRequire("kMiZJ");

var $9OXo1 = parcelRequire("9OXo1");

var $2YP9W = parcelRequire("2YP9W");

var $fLIp1 = parcelRequire("fLIp1");
const $e71f39314801737b$export$c35632c02599163f = ()=>{
    const errorRef = (0, $5uXOq.useRef)();
    const loadingRef = (0, $5uXOq.useRef)(false);
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { data: data, update: updateTransitionResource, error: transitionResourceError } = (0, $2YP9W.useResource)((0, $kMiZJ.consolidationUserStateResource));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [userPropertiesError, setUserPropertiesError] = (0, $5uXOq.useState)();
    errorRef.current = userPropertiesError || transitionResourceError;
    const { atlassianAccountId: accountId } = (0, $9OXo1.useTenantContext)();
    const update = (0, $5uXOq.useCallback)((newState)=>{
        if (errorRef.current) // If there is an error on resource or update, we don't want to update the state
        return Promise.reject(errorRef.current);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        let updatedData = {};
        updateTransitionResource((oldState)=>{
            updatedData = {
                ...oldState,
                ...newState
            };
            return updatedData;
        });
        if (accountId) {
            if (loadingRef.current) {
                const err = new Error('User properties is loading');
                (0, $jcw0u.default)({
                    meta: {
                        id: 'useOgConsolidationUserPreference-update',
                        packageName: 'jiraEocChangeboarding',
                        teamName: 'alexstrasza'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
                setUserPropertiesError(err);
                return Promise.reject(err);
            }
            loadingRef.current = true;
            return (0, $89SaW.setUserProperties)(accountId, (0, $iXaZ3.OG_CONSOLIDATION_USER_STATE_STORAGE_KEY), JSON.stringify(updatedData)).catch((err)=>{
                setUserPropertiesError(new Error('Error occured while setting user properties'));
                showFlag({
                    type: 'error',
                    isAutoDismiss: true,
                    title: formatMessage((0, $fLIp1.default).errorFlagTitle),
                    messageId: 'eoc-changeboarding.controllers.use-og-consolidation-user-state.show-flag.error.jira-modal',
                    messageType: 'transactional'
                });
                (0, $jcw0u.default)({
                    meta: {
                        id: 'useOgConsolidationUserPreference-update',
                        packageName: 'jiraEocChangeboarding',
                        teamName: 'alexstrasza'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }).finally(()=>{
                loadingRef.current = false;
            });
        }
        return Promise.resolve();
    }, [
        updateTransitionResource,
        accountId,
        formatMessage,
        showFlag
    ]);
    const reopenTransitionLozenge = (0, $5uXOq.useCallback)(()=>{
        update({
            isTransitionHomeHidden: false
        });
    }, [
        update
    ]);
    return {
        data: data,
        update: update,
        error: errorRef.current,
        reopenTransitionLozenge: reopenTransitionLozenge
    };
};

});
parcelRegister("fLIp1", function(module, exports) {

$parcel$export(module.exports, "default", () => $19c9811268c2fa85$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $19c9811268c2fa85$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorFlagTitle: {
        "id": "eoc-changeboarding.controllers.use-og-consolidation-user-state.error-flag-title",
        "defaultMessage": "Something went wrong while updating user properties."
    }
});

});


parcelRegister("201IG", function(module, exports) {

$parcel$export(module.exports, "shouldRenderBenefitModal", () => $f068b5042603902f$export$25a52eb2dc74e2f9);
const $f068b5042603902f$export$25a52eb2dc74e2f9 = ({ isDismissed: isDismissed, bannerDismissedAt: bannerDismissedAt })=>{
    if (!bannerDismissedAt || isDismissed) return false;
    return Math.ceil((new Date().getTime() - bannerDismissedAt) / 1000 / 60 / 60 / 24) >= 14;
};

});

parcelRegister("iaN8D", function(module, exports) {

$parcel$export(module.exports, "HEIGHT", () => $d45809d2691157ce$export$809d2b099693a9a8);
$parcel$export(module.exports, "BANNER_NAME", () => $d45809d2691157ce$export$41956b146268af93);

var $gwIPs = parcelRequire("gwIPs");
const $d45809d2691157ce$export$809d2b099693a9a8 = (0, $gwIPs.gridSize) * 6;
const $d45809d2691157ce$export$41956b146268af93 = 'EOC_TRANSITION';

});


parcelRegister("2jAre", function(module, exports) {

$parcel$export(module.exports, "useBannerMailExpiry", () => $85ae441f6f576caa$export$3906461ac9b87d2);

var $5uXOq = parcelRequire("5uXOq");

var $hZhhj = parcelRequire("hZhhj");

var $921us = parcelRequire("921us");

var $1cxlJ = parcelRequire("1cxlJ");
const $85ae441f6f576caa$export$3906461ac9b87d2 = ()=>{
    const { responseStatus: responseStatus, state: state } = (0, $hZhhj.useIncomingMailExpiryStatus)();
    const { onStateFetch: onStateFetch } = (0, $1cxlJ.useBannerActions)();
    const { isBannerShown: isBannerShown } = (0, $1cxlJ.useBannerState)();
    (0, $5uXOq.useEffect)(()=>{
        if (responseStatus === 'error') {
            onStateFetch((0, $hZhhj.DEFAULT_RESPONSE));
            return;
        }
        if (responseStatus === 'success') onStateFetch(state);
    }, [
        onStateFetch,
        responseStatus,
        state
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            isEnabled: isBannerShown,
            name: (0, $921us.BANNER_NAME),
            height: (0, $921us.HEIGHT)
        }), [
        isBannerShown
    ]);
};

});
parcelRegister("921us", function(module, exports) {

$parcel$export(module.exports, "HEIGHT", () => $c8abb4ba3ebc926f$export$809d2b099693a9a8);
$parcel$export(module.exports, "BANNER_NAME", () => $c8abb4ba3ebc926f$export$41956b146268af93);

var $gwIPs = parcelRequire("gwIPs");
const $c8abb4ba3ebc926f$export$809d2b099693a9a8 = (0, $gwIPs.gridSize) * 6;
const $c8abb4ba3ebc926f$export$41956b146268af93 = 'MAIL_EXPIRY_REMINDER';

});

parcelRegister("1cxlJ", function(module, exports) {

$parcel$export(module.exports, "useBannerActions", () => $b47a5e6c2ea18541$export$664f3e2467f0f5af);
$parcel$export(module.exports, "useBannerState", () => $b47a5e6c2ea18541$export$fa4ffa872ee90bd0);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $b47a5e6c2ea18541$export$d4c72bab9d6cc13a = {
    isBannerShown: false,
    isAdmin: false,
    OauthTypes: [
        'GMAIL_OAUTH'
    ]
};
const $b47a5e6c2ea18541$export$e324594224ef24da = {
    onDismiss: ()=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                isBannerShown: false
            });
        },
    onStateFetch: ({ showBanner: showBanner, isAdmin: isAdmin, OauthTypes: OauthTypes = [
        'GMAIL_OAUTH'
    ] })=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                isBannerShown: showBanner && isAdmin,
                isAdmin: isAdmin,
                OauthTypes: OauthTypes
            });
        }
};
const $b47a5e6c2ea18541$var$Store = (0, $iXqE5.createStore)({
    name: 'mail-expiry-banner',
    initialState: $b47a5e6c2ea18541$export$d4c72bab9d6cc13a,
    actions: $b47a5e6c2ea18541$export$e324594224ef24da
});
const $b47a5e6c2ea18541$export$664f3e2467f0f5af = (0, $3sQ5x.createActionsHook)($b47a5e6c2ea18541$var$Store);
const $b47a5e6c2ea18541$export$fa4ffa872ee90bd0 = (0, $3sQ5x.createStateHook)($b47a5e6c2ea18541$var$Store);

});


parcelRegister("lrZro", function(module, exports) {

$parcel$export(module.exports, "useBannerReturnToMobileState", () => $2d8151e19ddaa4d5$export$571311559507e90);
$parcel$export(module.exports, "useBannerReturnToMobile", () => $2d8151e19ddaa4d5$export$a898dd7b7ec9917a);

var $5uXOq = parcelRequire("5uXOq");

var $bCdIp = parcelRequire("bCdIp");

var $c0dQj = parcelRequire("c0dQj");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $aAExw = parcelRequire("aAExw");
const $2d8151e19ddaa4d5$var$initialState = ()=>({
        // reads FG early
        isEnabled: (0, $bCdIp.shouldShowReturnToMobileBanner)()
    });
const $2d8151e19ddaa4d5$var$actions = {
    disable: ()=>({ setState: setState })=>{
            setState({
                isEnabled: false
            });
        }
};
const $2d8151e19ddaa4d5$var$store = (0, $iXqE5.createStore)({
    initialState: $2d8151e19ddaa4d5$var$initialState,
    actions: $2d8151e19ddaa4d5$var$actions
});
const $2d8151e19ddaa4d5$export$571311559507e90 = (0, $3sQ5x.createHook)($2d8151e19ddaa4d5$var$store);
const $2d8151e19ddaa4d5$export$a898dd7b7ec9917a = ()=>{
    const [{ isEnabled: isEnabledOriginal }] = $2d8151e19ddaa4d5$export$571311559507e90();
    const isEnabled = (0, $c0dQj.isMobileAndInMvpOrExistingUsersExperiment)() ? isEnabledOriginal && (0, $bCdIp.shouldShowReturnToMobileBannerMobileMvp)() : isEnabledOriginal;
    return (0, $5uXOq.useMemo)(()=>({
            isEnabled: isEnabled,
            name: (0, $aAExw.BANNER_NAME),
            height: (0, $aAExw.mobileBannerHeight)
        }), [
        isEnabled
    ]);
};

});
parcelRegister("aAExw", function(module, exports) {

$parcel$export(module.exports, "mobileBannerHeight", () => $61da032f64bef3a5$export$aa875602f5712b77);
$parcel$export(module.exports, "BANNER_NAME", () => $61da032f64bef3a5$export$41956b146268af93);
$parcel$export(module.exports, "ENCODED_APPLE_APP_STORE_URL", () => $61da032f64bef3a5$export$698c82a2c8445300);

var $gwIPs = parcelRequire("gwIPs");
const $61da032f64bef3a5$export$aa875602f5712b77 = (0, $gwIPs.gridSize) * 6;
const $61da032f64bef3a5$export$41956b146268af93 = 'RETURN_TO_MOBILE_BANNER';
const $61da032f64bef3a5$export$698c82a2c8445300 = encodeURIComponent('https://itunes.apple.com/app/apple-store/id1006972087');

});


parcelRegister("dQYuq", function(module, exports) {

$parcel$export(module.exports, "useBannerJpdPremiumOnboarding", () => $78ea6b135b2afd7a$export$433a8becd2c7b601);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $dAfqg = parcelRequire("dAfqg");

var $90yGq = parcelRequire("90yGq");


var $2F1i7 = parcelRequire("2F1i7");

var $ej33n = parcelRequire("ej33n");
const $78ea6b135b2afd7a$export$433a8becd2c7b601 = ()=>{
    const hasPolarisInPath = (0, $ej33n.useHasPolarisInPath)();
    const { data: project } = (0, $dAfqg.useProjectContext)();
    const accountId = (0, $90yGq.useAccountId)();
    const { isDismissed: isDismissed, height: height, shouldShow: shouldShow, isLoading: isLoading } = (0, $2F1i7.useJpdPremiumOnboardingBannerState)();
    const { fetchBannerVisibility: fetchBannerVisibility } = (0, $2F1i7.useJpdPremiumOnboardingBannerActions)();
    const isDiscoveryProject = project?.projectType === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT);
    const isInJpdBoundary = (0, $5uXOq.useMemo)(()=>hasPolarisInPath || isDiscoveryProject, [
        isDiscoveryProject,
        hasPolarisInPath
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!accountId || !(0, $4R6GH.fg)('polaris_pol-15006_premium_onboarding_banner') || !(0, $4R6GH.fg)('polaris_eap_customers')) return;
        fetchBannerVisibility(accountId);
    }, [
        accountId,
        fetchBannerVisibility
    ]);
    // use `polaris_eap_customers` to check if the customer is in the EAP
    // use `polaris_pol-15006_premium_onboarding_banner` as a kill switch
    // If I'll use `polaris_eap_customers` only, we won't have a quick way to disable the banner
    return (0, $5uXOq.useMemo)(()=>({
            isEnabled: // eslint-disable-next-line jira/ff/no-preconditioning
            isInJpdBoundary && shouldShow && !isDismissed && !isLoading && (0, $4R6GH.fg)('polaris_eap_customers') && (0, $4R6GH.fg)('polaris_pol-15006_premium_onboarding_banner'),
            name: (0, $081c66d1b8c3065c$export$41956b146268af93),
            height: height
        }), [
        isInJpdBoundary,
        shouldShow,
        isDismissed,
        height,
        isLoading
    ]);
};

});
const $081c66d1b8c3065c$export$41956b146268af93 = 'JPD_PREMIUM_ONBOARDING_BANNER';
const $081c66d1b8c3065c$export$ed7cc0d417ee89e = 40;
const $081c66d1b8c3065c$export$ff6e18f7d82b549c = 320;
const $081c66d1b8c3065c$export$a07dab5608229ea3 = 'jira.polaris.premium-onboarding-banner';
const $081c66d1b8c3065c$export$b8b9d90f9e5bd72b = 'jiraPolarisComponentPremiumOnboardingBanner';

parcelRegister("2F1i7", function(module, exports) {

$parcel$export(module.exports, "useJpdPremiumOnboardingBannerState", () => $54666b079e83cd52$export$7241553ec2c3a71a);
$parcel$export(module.exports, "useJpdPremiumOnboardingBannerActions", () => $54666b079e83cd52$export$b0b24f21e4ac85cd);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $1As78 = parcelRequire("1As78");

var $fZneA = parcelRequire("fZneA");

var $jJZqs = parcelRequire("jJZqs");

const $54666b079e83cd52$export$d4c72bab9d6cc13a = {
    isDismissed: false,
    height: (0, $081c66d1b8c3065c$export$ed7cc0d417ee89e),
    shouldShow: true,
    isLoading: true
};
const $54666b079e83cd52$export$e324594224ef24da = {
    onDismiss: (accountId)=>async ({ setState: setState })=>{
            if (!accountId) return;
            try {
                await (0, $89SaW.setUserProperties)(accountId, (0, $081c66d1b8c3065c$export$41956b146268af93), 'false');
                setState({
                    isDismissed: true
                });
            } catch (error) {
                setState({
                    isDismissed: true
                });
                (0, $jcw0u.default)((0, $1As78.createErrorAnalytics)('polaris.jpd-premium-onboarding.banner-dismissed', error instanceof Error ? error : new Error('Unknown error')));
            }
        },
    fetchBannerVisibility: (accountId)=>async ({ setState: setState })=>{
            if (!accountId) return;
            try {
                const value = await (0, $89SaW.getUserProperty)(accountId, (0, $081c66d1b8c3065c$export$41956b146268af93));
                setState({
                    shouldShow: value,
                    isLoading: false
                });
            } catch (error) {
                setState({
                    isLoading: false
                });
                if (error instanceof (0, $jJZqs.default) && error.statusCode === 404 || (0, $fZneA.isClientFetchError)(error)) return;
                (0, $jcw0u.default)((0, $1As78.createErrorAnalytics)('polaris.jpd-premium-onboarding.banner-dismissed', error instanceof Error ? error : new Error('Unknown error')));
            }
        }
};
const $54666b079e83cd52$var$Store = (0, $iXqE5.createStore)({
    name: 'PolarisPremiumOnboardingBanner',
    initialState: $54666b079e83cd52$export$d4c72bab9d6cc13a,
    actions: $54666b079e83cd52$export$e324594224ef24da
});
const $54666b079e83cd52$export$7241553ec2c3a71a = (0, $3sQ5x.createStateHook)($54666b079e83cd52$var$Store);
const $54666b079e83cd52$export$b0b24f21e4ac85cd = (0, $3sQ5x.createActionsHook)($54666b079e83cd52$var$Store);

});

parcelRegister("ej33n", function(module, exports) {

$parcel$export(module.exports, "useHasPolarisInPath", () => $0211b1daa2742c10$export$b9f1d0d4eba42cdb);

var $lODMY = parcelRequire("lODMY");
const $0211b1daa2742c10$export$b9f1d0d4eba42cdb = (0, $lODMY.createRouterSelector)(({ location: location })=>{
    return location.pathname.includes('/jira/polaris');
});

});



parcelRegister("adRnT", function(module, exports) {

$parcel$export(module.exports, "BannerAnnouncementAsync", () => $30e1d77986915234$export$aa03f7909e0828ec);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $30e1d77986915234$var$BannerAnnouncement = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("1ZjVk")).then((module)=>module.BannerAnnouncement), {
    ssr: true,
    moduleId: "./src/packages/platform/ui/banners/announcement/src/ui/banner-v2/BannerAnnouncement.tsx"
});
const $30e1d77986915234$export$aa03f7909e0828ec = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-platform-ui-banners-announcement",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($30e1d77986915234$var$BannerAnnouncement, null));

});
parcelRegister("1ZjVk", function(module, exports) {

let $172af1632041fa5d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $172af1632041fa5d$var$load("e7a2r").then(()=>parcelRequire('dqid6'));

});


parcelRegister("14pJv", function(module, exports) {

$parcel$export(module.exports, "BannerTransitionAsync", () => $710b388646922007$export$8bf182764b9d2eb8);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $710b388646922007$var$BannerTransition = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("bWlrE")).then((module)=>module.BannerTransition), {
    moduleId: "./src/packages/platform/ui/banners/eoc-transition/src/ui/banner/index.tsx"
});
const $710b388646922007$export$8bf182764b9d2eb8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-banner-eoc-transition",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($710b388646922007$var$BannerTransition, null));

});
parcelRegister("bWlrE", function(module, exports) {

let $8b15bf00cb7e17a2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8b15bf00cb7e17a2$var$load("k5dDK").then(()=>parcelRequire('iGIQS'));

});


parcelRegister("9Cdg4", function(module, exports) {

$parcel$export(module.exports, "MailExpiryBannerAsync", () => $9a323272de0aa4c0$export$11a26ffa2d1b48ed);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $9a323272de0aa4c0$var$LazyMailExpiryBanner = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("frfVM")).then(({ MailExpiryReminder: MailExpiryReminder })=>MailExpiryReminder), {
    moduleId: "./src/packages/platform/ui/banners/mail-expiry-reminder/src/ui/view.tsx"
});
const $9a323272de0aa4c0$export$11a26ffa2d1b48ed = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async-mail-expiry-banner",
        packageName: "jiraPlatformUiMailExpiryReminder",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-mail-expiry-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9a323272de0aa4c0$var$LazyMailExpiryBanner, null)));

});
parcelRegister("frfVM", function(module, exports) {

let $b3d5bc2dc2a97eb1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b3d5bc2dc2a97eb1$var$load("7MGCi").then(()=>parcelRequire('4tHNi'));

});


parcelRegister("9ylrc", function(module, exports) {

$parcel$export(module.exports, "ReturnToMobileBanner", () => $369ea7a3ed2830c2$export$81c4f1e869d5a87);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $369ea7a3ed2830c2$var$LazyReturnToMobileBanner = (0, $kxZPA.lazy)(()=>(parcelRequire("ez2mi")).then(({ ReturnToMobileBanner: ReturnToMobileBanner })=>ReturnToMobileBanner), {
    moduleId: "./src/packages/platform/ui/return-to-mobile-banner/src/ReturnToMobileBanner.tsx"
});
const $369ea7a3ed2830c2$export$81c4f1e869d5a87 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-return-to-mobile-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($369ea7a3ed2830c2$var$LazyReturnToMobileBanner, null));

});
parcelRegister("ez2mi", function(module, exports) {

let $a9a629ed9fe8c328$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a9a629ed9fe8c328$var$load("7v9gj").then(()=>parcelRequire('cqWnC'));

});


parcelRegister("WhXfc", function(module, exports) {

$parcel$export(module.exports, "AsyncJpdPremiumOnboardingBanner", () => $f63c32ce1ef6ff05$export$bd441b93ed6c70f2);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $1rJUM = parcelRequire("1rJUM");

const $f63c32ce1ef6ff05$var$useEntrypoint = ()=>{
    const entryPointParams = (0, $5uXOq.useMemo)(()=>{
        return {};
    }, []);
    const hasLoadedEntrypoint = (0, $5uXOq.useRef)(false);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $1rJUM.jpdPremiumOnboardingBannerEntryPoint), entryPointParams);
    if (!hasLoadedEntrypoint.current) {
        entryPointActions.load();
        hasLoadedEntrypoint.current = true;
    }
    return {
        entryPointReferenceSubject: entryPointReferenceSubject
    };
};
const $f63c32ce1ef6ff05$export$bd441b93ed6c70f2 = ()=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject } = $f63c32ce1ef6ff05$var$useEntrypoint();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: (0, $081c66d1b8c3065c$export$a07dab5608229ea3),
        packageName: (0, $081c66d1b8c3065c$export$b8b9d90f9e5bd72b),
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: {}
    });
};

});
parcelRegister("1rJUM", function(module, exports) {

$parcel$export(module.exports, "jpdPremiumOnboardingBannerEntryPoint", () => $96e67cff84be4e61$export$6bace03c2b9f4126);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $96e67cff84be4e61$export$6bace03c2b9f4126 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("kvwz4")), {
        moduleId: "24b76c7f",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("kvwz4", function(module, exports) {

let $eedff68ed3d689d4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eedff68ed3d689d4$var$load("5UJe9").then(()=>parcelRequire('dh9Op'));

});



parcelRegister("dm0Uk", function(module, exports) {

$parcel$export(module.exports, "ZIndexWrapper", () => $1be350c372161cad$export$6bdda512681a5774);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $1be350c372161cad$export$6bdda512681a5774 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { zIndex: zIndex, top: top, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_w6mvmh": (0, $lD23V.default)(__cmplp.zIndex),
            "--_1vj9tq": (0, $lD23V.default)(__cmplp.top)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1pby1fcb _kqswh2mm _154i1ter",
            __cmplp.className
        ])
    });
});

});



parcelRegister("kc9FZ", function(module, exports) {

$parcel$export(module.exports, "GlobalComponents", () => $87d424e5b411dd1e$export$461c2ed3163c74ff);

var $5uXOq = parcelRequire("5uXOq");

var $gAeCk = parcelRequire("gAeCk");

var $7CMCs = parcelRequire("7CMCs");


var $6jY6G = parcelRequire("6jY6G");

var $aPfsS = parcelRequire("aPfsS");

var $2SVPM = parcelRequire("2SVPM");

var $imS60 = parcelRequire("imS60");
const $87d424e5b411dd1e$var$routeComponents = [];
const $87d424e5b411dd1e$var$RouteGlobalComponents = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $aPfsS.renderGlobalComponents)(route.layout?.globalComponents || $87d424e5b411dd1e$var$routeComponents));
};
// This component is necessary to ensure that the error boundary picks up errors in the renderGlobalComponents function
const $87d424e5b411dd1e$var$SharedGlobalComponents = ({ sharedGlobalComponents: sharedGlobalComponents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $aPfsS.renderGlobalComponents)(sharedGlobalComponents));
const $87d424e5b411dd1e$export$461c2ed3163c74ff = ({ sharedGlobalComponents: sharedGlobalComponents })=>{
    const globalComponentsPerformanceTiming = (0, $5uXOq.useCallback)(()=>{
        (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)((0, $9ccbd88c704da1ef$export$fb9876ab4228d985), (0, $9ccbd88c704da1ef$export$c20831be6f780cb5), (0, $9ccbd88c704da1ef$export$398df1bca49f9884), true, true);
    }, []);
    /**
	 * !!! DO NOT ADD INDIVIDUAL COMPONENTS TO THIS FILE !!!
	 *
	 * They should be defined as part of the `sharedGlobalComponents` constant, or defined on the route
	 * definition `layout` key.
	 *
	 * @see https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/jira/src/packages/platform/ui/layouts/jira-shared-layout/README.md
	 * @see https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/jira/src/packages/platform/ui/layouts/README.md
	 */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: (0, $9ccbd88c704da1ef$export$c20831be6f780cb5)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        id: "shared-global-components",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imS60.default), {
        name: "shared-global-components"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($87d424e5b411dd1e$var$SharedGlobalComponents, {
        sharedGlobalComponents: sharedGlobalComponents
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        id: "route-global-components",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imS60.default), {
        name: "route-global-components"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($87d424e5b411dd1e$var$RouteGlobalComponents, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: (0, $9ccbd88c704da1ef$export$398df1bca49f9884),
        onSet: globalComponentsPerformanceTiming
    }));
};

});
parcelRegister("imS60", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6b7686623a2955e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $1tcYS = parcelRequire("1tcYS");

var $3aXpE = parcelRequire("3aXpE");

var $cEm1b = parcelRequire("cEm1b");
const $b6b7686623a2955e$var$newContextWithUfoContext = (context, interactionContext)=>context && interactionContext && {
        ...context,
        getInteractionContext: ()=>interactionContext
    };
const $b6b7686623a2955e$var$flowRight = (functionList)=>(arg)=>functionList.reduceRight((acc, fn)=>fn(acc), arg);
const $b6b7686623a2955e$var$renderContextProviderIfNonNull = (Context, contextValue)=>(node)=>contextValue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Context.Provider, {
            value: contextValue
        }, node) : node;
function $b6b7686623a2955e$var$JiraUFOLabelWrapper({ children: children }) {
    const context = (0, $1tcYS.useInteractionContext)();
    const rllProfilerContext = (0, $5uXOq.useContext)((0, $cEm1b.ProfilerContext));
    const relayProfilerContext = (0, $5uXOq.useContext)((0, $8Uumt.ProfilerContext));
    const newRllProfilerContext = (0, $5uXOq.useMemo)(()=>({
            current: $b6b7686623a2955e$var$newContextWithUfoContext(rllProfilerContext?.current, context)
        }), [
        context,
        rllProfilerContext
    ]);
    const newRelayProfilerContext = (0, $5uXOq.useMemo)(()=>$b6b7686623a2955e$var$newContextWithUfoContext(relayProfilerContext, context), [
        context,
        relayProfilerContext
    ]);
    // Produces the following but only renders a provider if its context is not null
    // <RelayProfilerContext.Provider ...>
    //   <RLLProfilerContext.Provider ...>
    //     {children}
    //   </...etc
    return $b6b7686623a2955e$var$flowRight([
        $b6b7686623a2955e$var$renderContextProviderIfNonNull((0, $8Uumt.ProfilerContext), newRelayProfilerContext),
        $b6b7686623a2955e$var$renderContextProviderIfNonNull((0, $cEm1b.ProfilerContext), newRllProfilerContext)
    ])(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children));
}
function $b6b7686623a2955e$export$2e2bcd8739ae039({ name: name, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3aXpE.default), {
        name: name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b6b7686623a2955e$var$JiraUFOLabelWrapper, null, children));
}

});
parcelRegister("3aXpE", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa69217d65efc8ae$export$2e2bcd8739ae039);

var $jnjS3 = parcelRequire("jnjS3");
var $fa69217d65efc8ae$export$2e2bcd8739ae039 = (0, $jnjS3.default);

});
parcelRegister("jnjS3", function(module, exports) {

$parcel$export(module.exports, "default", () => $095a4d1378115b65$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");
function $095a4d1378115b65$export$2e2bcd8739ae039({ name: name, children: children }) {
    const context = (0, $1tcYS.useInteractionContext)();
    const newContext = (0, $5uXOq.useMemo)(()=>{
        if (context) return {
            ...context,
            labelStack: context.labelStack == null ? [
                {
                    name: name
                }
            ] : [
                ...context.labelStack,
                {
                    name: name
                }
            ]
        };
        else return context;
    }, [
        context,
        name
    ]);
    return context ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1tcYS.default).Provider, {
        value: newContext,
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
}

});




parcelRegister("6DLIs", function(module, exports) {

$parcel$export(module.exports, "GlobalContainers", () => $1f7483f6f5b15b02$export$3b677a7048d7ae0);

var $5uXOq = parcelRequire("5uXOq");

var $bKfXN = parcelRequire("bKfXN");

var $irJ4w = parcelRequire("irJ4w");

var $jD5no = parcelRequire("jD5no");

var $2i4sA = parcelRequire("2i4sA");

var $gAeCk = parcelRequire("gAeCk");

var $5tsrJ = parcelRequire("5tsrJ");

var $j8DrX = parcelRequire("j8DrX");

var $lJ5jf = parcelRequire("lJ5jf");

var $3HwlS = parcelRequire("3HwlS");


var $8ApFP = parcelRequire("8ApFP");

var $4yEIl = parcelRequire("4yEIl");

var $iPMn1 = parcelRequire("iPMn1");

var $fiv1r = parcelRequire("fiv1r");

var $14XJw = parcelRequire("14XJw");

var $2SVPM = parcelRequire("2SVPM");

var $9OXo1 = parcelRequire("9OXo1");

var $hbQoJ = parcelRequire("hbQoJ");

var $cSD7y = parcelRequire("cSD7y");

var $eKtC8 = parcelRequire("eKtC8");

var $bAjl9 = parcelRequire("bAjl9");

var $lvG9V = parcelRequire("lvG9V");

var $gPTB6 = parcelRequire("gPTB6");

var $9kep9 = parcelRequire("9kep9");

var $eSznd = parcelRequire("eSznd");

var $ivvwC = parcelRequire("ivvwC");

var $dSF0Y = parcelRequire("dSF0Y");
const $1f7483f6f5b15b02$var$MaybePreviewPanelsProvider = (0, $cSD7y.componentWithFG)('jira-glance-panel', (0, $hbQoJ.PreviewPanelsProvider), (0, $5uXOq.Fragment));
const $1f7483f6f5b15b02$export$3b677a7048d7ae0 = ({ id: id, children: children, baseUrl: baseUrl, locale: locale, messages: messages, Router: Router, routerLinkComponent: routerLinkComponent })=>{
    const globalContainersPerformanceTiming = (0, $5uXOq.useCallback)(()=>{
        (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)((0, $9ccbd88c704da1ef$export$4f341d86a3c214), (0, $9ccbd88c704da1ef$export$16e7ead3a8b5c366), (0, $9ccbd88c704da1ef$export$c389f0b50840d5ca), true, true);
        (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)((0, $9ccbd88c704da1ef$export$7048c99f32c60b34), (0, $9ccbd88c704da1ef$export$3c2d8af5c7577fe7), (0, $9ccbd88c704da1ef$export$aac77afee74c49d0), true, true);
    }, []);
    const { data: orgId } = (0, $14XJw.useOrgId)();
    // Unstable components cause bugs and performance problems - please fix this! go/unstable-components
    // eslint-disable-next-line react/no-unstable-nested-components
    const MonolithStyleOverride = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", {
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: {
                __html: `
                        body#jira {
                            overflow-x: hidden;
                            overflow-y: auto;
                        }

                        #jira-frontend {
                            background: ${"var(--ds-surface, #FFFFFF)"};
                        }

                        #jira_request_timing_info {
                            margin: 0;
                        }
                    `
            }
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bAjl9.IntlProviders), {
        messages: messages,
        locale: locale
    }, __SPA__ && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MonolithStyleOverride, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextContainer), {
        isGlobal: true,
        getMeta: (0, $j8DrX.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $irJ4w.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5tsrJ.default), {
        orgId: orgId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2i4sA.ViewExperienceTrackingProvider), {
        analyticsSource: (0, $9ccbd88c704da1ef$export$c9e16a15d65437),
        experience: (0, $9ccbd88c704da1ef$export$b1534bc11f201efd),
        experienceId: (0, $9ccbd88c704da1ef$export$fa4bbc89fd1f1a7),
        application: (0, $9ccbd88c704da1ef$export$aa6008fe0169b864),
        edition: (0, $9ccbd88c704da1ef$export$39418a21fbb51487),
        additionalAttributes: (0, $8ApFP.routeAnalyticsAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eKtC8.ErrorBoundary), {
        id: id,
        withExperienceTracker: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: (0, $9ccbd88c704da1ef$export$16e7ead3a8b5c366)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Router, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bKfXN.default), {
        UNSAFE_isThemingDisabled: true,
        routerLinkComponent: routerLinkComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: (0, $9ccbd88c704da1ef$export$c389f0b50840d5ca)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9kep9.PageConfigContainers), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lvG9V.MetricsContainers), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fiv1r.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gPTB6.NavigationContainers), {
        baseUrl: baseUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivvwC.UserContainers), {
        baseUrl: baseUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eSznd.UiManagers), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: (0, $9ccbd88c704da1ef$export$3c2d8af5c7577fe7)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4yEIl.PostOfficeRouterListener), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1f7483f6f5b15b02$var$MaybePreviewPanelsProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dSF0Y.LinkingProviders), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
        id: "page-container-v2.nav-v3.app-base",
        hasErrorBoundary: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: (0, $9ccbd88c704da1ef$export$aac77afee74c49d0),
        onSet: globalContainersPerformanceTiming
    }), (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lJ5jf.SidebarNav4ControllerProvider), null, children) : children)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iPMn1.ScreenSpaceFlagsPlacement), null)))))))))))))));
};

});
parcelRegister("bKfXN", function(module, exports) {

$parcel$export(module.exports, "default", () => $c63904d4fd249f91$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $grjRA = parcelRequire("grjRA");

var $4NS88 = parcelRequire("4NS88");
const $c63904d4fd249f91$var$InsideAppProviderContext = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
/**
 * __App provider__
 *
 * An app provider provides app level configuration such as global theming.
 *
 * Place it at the root of your application.
 */ function $c63904d4fd249f91$var$AppProvider({ children: children, defaultColorMode: defaultColorMode = 'light', defaultTheme: defaultTheme, routerLinkComponent: routerLinkComponent, UNSAFE_isThemingDisabled: UNSAFE_isThemingDisabled }) {
    const isInsideAppProvider = (0, $5uXOq.useContext)($c63904d4fd249f91$var$InsideAppProviderContext);
    if (isInsideAppProvider) throw new Error('App provider should not be nested within another app provider.');
    const routerLinkProvider = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $grjRA.default), {
        routerLinkComponent: routerLinkComponent,
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($c63904d4fd249f91$var$InsideAppProviderContext.Provider, {
        value: true,
        children: UNSAFE_isThemingDisabled ? routerLinkProvider : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4NS88.default), {
            defaultColorMode: defaultColorMode,
            defaultTheme: defaultTheme,
            children: routerLinkProvider
        })
    });
}
var $c63904d4fd249f91$export$2e2bcd8739ae039 = $c63904d4fd249f91$var$AppProvider;

});

parcelRegister("2i4sA", function(module, exports) {

$parcel$export(module.exports, "ViewExperienceTrackingProvider", () => $c08cc6207a190361$export$a5efa46877be148f);
$parcel$export(module.exports, "SubExperienceTrackingProvider", () => $c08cc6207a190361$export$e0241c84ce5db240);

var $5uXOq = parcelRequire("5uXOq");

var $2YZCu = parcelRequire("2YZCu");

var $jNwWT = parcelRequire("jNwWT");

var $aD4Nm = parcelRequire("aD4Nm");

var $ehKaJ = parcelRequire("ehKaJ");
const $c08cc6207a190361$export$a5efa46877be148f = ({ isExperienceReady: isExperienceReady, experience: experience, experienceId: experienceId, analyticsSource: analyticsSource, application: application, edition: edition, additionalAttributes: additionalAttributes, children: children })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehKaJ.default), {
        isExperienceReady: isExperienceReady,
        experience: experience,
        experienceId: experienceId,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        additionalAttributes: additionalAttributes
    }, children);
$c08cc6207a190361$export$a5efa46877be148f.defaultProps = {
    isExperienceReady: true,
    experienceId: null,
    additionalAttributes: {}
};
var $c08cc6207a190361$export$2e2bcd8739ae039 = $c08cc6207a190361$export$a5efa46877be148f;
const $c08cc6207a190361$export$e0241c84ce5db240 = ({ children: children, location: location, parentProviders: parentProviders })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : // DO NOT use `useContext` or `static contextType = ...` to consume this context
    // as the tree walker used in SSR does not support hooks
    // and SSR does not support `static contextType` setting
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jNwWT.default).Consumer, null, (context)=>{
        if (context == null) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('experience-sub-provider.missing-provider', 'Experience sub-provider rendered without a parent provider');
            return children;
        }
        const { experienceId: experienceId } = context;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aD4Nm.ExperienceTracker), {
            location: location,
            parentProviders: parentProviders
        }, (trackerCallbacks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehKaJ.default), {
                parentTrackerCallbacks: trackerCallbacks,
                experience: location,
                experienceId: experienceId,
                analyticsSource: null,
                application: null,
                edition: null,
                isExperienceReady: true
            }, children));
    });
$c08cc6207a190361$export$e0241c84ce5db240.defaultProps = {
    parentProviders: null
};

});
parcelRegister("ehKaJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a267f2f54170b1c1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hh0bW = parcelRequire("hh0bW");


var $jNwWT = parcelRequire("jNwWT");
class $a267f2f54170b1c1$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            parentTrackerCallbacks: null,
            additionalAttributes: {}
        };
    }
    constructor(props){
        super(props), this.onPending = ()=>{
            this.pendingCount += 1;
            this.shouldTrackExperience = true;
            this.checkAndStartTimer();
        }, this.onSuccess = ()=>{
            this.pendingCount -= 1;
            this.checkAndStartTimer();
        }, this.onFailure = (location, additionalAttributes)=>{
            // We need to track failure *immediately*, otherwise this component may
            // be unmounted and we'd miss our chance.
            this.trackExperience({
                wasExperienceSuccesful: false,
                location: location,
                additionalAttributes: additionalAttributes
            });
        }, this.onAbort = (location, additionalAttributes)=>{
            this.trackExperience({
                wasExperienceSuccesful: false,
                action: (0, $c0ec49ac5a1e4009$export$aeeb00d0845d24d8),
                location: location,
                additionalAttributes: additionalAttributes
            });
        };
        this.resetExperience();
    }
    componentDidMount() {
        this.checkAndStartTimer();
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.isExperienceReady && this.props.isExperienceReady) this.checkAndStartTimer();
    }
    componentDidCatch(error) {
        // This catches any errors that bubble up to the Provider that
        // may not be caught by any ExperienceTrackers
        this.trackExperience({
            wasExperienceSuccesful: false,
            location: 'error-reached-provider',
            additionalAttributes: {
                errorMessage: error.message,
                errorName: error.name,
                ...this.props?.additionalAttributes
            }
        });
        // We're deliberately rethrowing the error here because we don't want to interfere with
        // any error handling the container app may have in place.
        throw error;
    }
    componentWillUnmount() {
        clearTimeout(this.timerId);
    }
    checkAndStartTimer() {
        if (this.shouldTrackExperience && this.props.isExperienceReady) this.startTimer();
    }
    startTimer() {
        clearTimeout(this.timerId);
        this.timerId = setTimeout(()=>{
            if (this.pendingCount === 0) this.trackExperience({
                wasExperienceSuccesful: true
            });
        }, 1000);
    }
    // Resetting must not call setState since this can be executed in the render phase
    resetExperience() {
        clearTimeout(this.timerId);
        this.timerId = undefined;
        this.shouldTrackExperience = false;
        this.hasTrackedExperience = false;
        this.pendingCount = 0;
        this.memoizedContext = {
            consumerCallbacks: {
                onPending: this.onPending,
                onSuccess: this.onSuccess,
                onFailure: this.onFailure,
                onAbort: this.onAbort
            },
            experienceId: this.props.experienceId,
            experience: this.props.experience
        };
    }
    trackExperience({ wasExperienceSuccesful: wasExperienceSuccesful, action: action, location: location, additionalAttributes: additionalAttributes }) {
        if (this.hasTrackedExperience) // We only ever want to send a single success/failure event for an experience
        return;
        this.hasTrackedExperience = true;
        const { parentTrackerCallbacks: parentTrackerCallbacks, additionalAttributes: additionalAttributesFromProps } = this.props;
        if (parentTrackerCallbacks) {
            if (wasExperienceSuccesful) parentTrackerCallbacks.onExperienceSuccess();
            else parentTrackerCallbacks.onExperienceFailure(location, {
                ...additionalAttributesFromProps,
                ...additionalAttributes
            });
        } else {
            const { experience: experience } = this.memoizedContext;
            const { analyticsSource: analyticsSource, application: application, edition: edition } = this.props;
            analyticsSource && (0, $hh0bW.default)({
                experience: experience,
                action: action,
                wasExperienceSuccesful: wasExperienceSuccesful,
                location: location,
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                additionalAttributes: {
                    ...additionalAttributesFromProps,
                    ...additionalAttributes
                }
            });
        }
    }
    // Check every render to reset the experience state instance variables
    checkExperienceIdForExperienceReset() {
        if (this.memoizedContext.experienceId !== this.props.experienceId) this.resetExperience();
    }
    render() {
        this.checkExperienceIdForExperienceReset();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jNwWT.default).Provider, {
            value: this.memoizedContext
        }, this.props.children);
    }
}

});
const $c0ec49ac5a1e4009$export$627ef4c1ed2d7a9a = 'taskSuccess';
const $c0ec49ac5a1e4009$export$b48b3d1872522384 = 'taskFail';
const $c0ec49ac5a1e4009$export$aeeb00d0845d24d8 = 'taskAbort';



parcelRegister("iPMn1", function(module, exports) {

$parcel$export(module.exports, "ScreenSpaceFlagsPlacement", () => $3ba8955bb8ac2826$export$f6564e60882bdf90);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $jgefF = parcelRequire("jgefF");

var $4R6GH = parcelRequire("4R6GH");

var $pa9q9 = parcelRequire("pa9q9");

var $jp5kW = parcelRequire("jp5kW");

var $SfWIb = parcelRequire("SfWIb");

var $7sr84 = parcelRequire("7sr84");

const $3ba8955bb8ac2826$var$PLACEMENT_ID = 'screen-space-flags';
const $3ba8955bb8ac2826$export$f6564e60882bdf90 = ()=>{
    const flagsService = (0, $4R6GH.fg)('inject_jira_feature_flags_service_into_post_office') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $pa9q9.useFlagsService)() : {
        dismissFlag: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        hasFlag: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        showFlag: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    };
    const stablePlacementProps = (0, $5uXOq.useMemo)(()=>({
            jiraFlagsService: {
                dismissFlag: flagsService.dismissFlag,
                hasFlag: flagsService.hasFlag,
                showFlag: flagsService.showFlag
            }
        }), [
        flagsService?.dismissFlag,
        flagsService?.hasFlag,
        flagsService?.showFlag
    ]);
    return !false && !(0, $jp5kW.default)((0, $d0ca21152325de6b$export$37d4bb5bc0e315db)) && (0, $4R6GH.fg)('post-office-screen-space-overlay-jfe') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7sr84.ScreenSpaceFlagPlacementPreviewSwitcher), {
        // https://switcheroo.atlassian.com/ui/gates/8fe500fb-6c32-48c7-be3f-caf511e97a8e/key/post-office_enable_screen-space-preview_jfe
        isEnabled: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $SfWIb.default), {
        placementId: $3ba8955bb8ac2826$var$PLACEMENT_ID,
        PlacementComponent: (0, $jgefF.default),
        disableInitialData: true,
        ...(0, $4R6GH.fg)('inject_jira_feature_flags_service_into_post_office') ? {
            placementProps: stablePlacementProps
        } : undefined
    })) : null;
};

});
parcelRegister("jgefF", function(module, exports) {

$parcel$export(module.exports, "ScreenSpaceFlagsPlacementComponent", () => $bde3999cf210ffea$export$c60b43809441c5b0);
$parcel$export(module.exports, "default", () => $bde3999cf210ffea$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $iEN9D = parcelRequire("iEN9D");

var $eFjrB = parcelRequire("eFjrB");
var $hWRix = parcelRequire("hWRix");

var $h3mjV = parcelRequire("h3mjV");

var $iXSVm = parcelRequire("iXSVm");
var $jOeT9 = parcelRequire("jOeT9");
var $20Ijf = parcelRequire("20Ijf");

var $7PgHB = parcelRequire("7PgHB");

var $92Slv = parcelRequire("92Slv");

var $4rq6q = parcelRequire("4rq6q");


var $3p8Nq = parcelRequire("3p8Nq");
const $bde3999cf210ffea$export$c32237a999261c49 = (input)=>(0, $eFjrB.createMatchScopes)({
        scopes: $92Slv.scopes
    })(input);
const $bde3999cf210ffea$export$c60b43809441c5b0 = (0, $3p8Nq.withScreenSpaceFlagsIntlProvider)((0, $iXSVm.createPlacementComponent)((0, $f6721478b0b83c9a$export$a5cfae247d8360ef), /*#__PURE__*/ (0, $5uXOq.memo)(({ initialData: initialData, preloadedInitialData: preloadedInitialData, setPreloadedInitialData: setPreloadedInitialData, jiraFlagsService: jiraFlagsService, reportExpectedError: reportExpectedError, reportUnexpectedError: reportUnexpectedError })=>{
    const [localMessageState, setLocalMessageState] = (0, $5uXOq.useState)(()=>{
        if (preloadedInitialData) return preloadedInitialData?.messages?.length > 0 ? preloadedInitialData?.messages : undefined;
        return undefined;
    });
    (0, $20Ijf.useInitialData)(initialData);
    const { onMessageDismiss: onMessageDismiss, onMessageClicked: onMessageClicked, onMessageSnooze: onMessageSnooze } = (0, $hWRix.useMessagePlacementHooks)();
    const handleDismiss = (0, $5uXOq.useCallback)(({ messageInstanceId: messageInstanceId })=>{
        setLocalMessageState((current)=>{
            if (current) {
                const newState = current.filter((e)=>e.messageInstanceId !== messageInstanceId);
                if (typeof setPreloadedInitialData === 'function') setPreloadedInitialData({
                    messages: newState
                });
                return newState;
            }
            return undefined;
        });
    }, [
        setPreloadedInitialData
    ]);
    const onDismissed = (0, $5uXOq.useCallback)(()=>{
        setLocalMessageState([]);
        if (typeof setPreloadedInitialData === 'function') setPreloadedInitialData({
            messages: []
        });
    }, [
        setPreloadedInitialData
    ]);
    (0, $5uXOq.useEffect)(()=>onMessageDismiss(handleDismiss), [
        onMessageDismiss
    ]);
    (0, $5uXOq.useEffect)(()=>onMessageClicked(handleDismiss), [
        onMessageClicked
    ]);
    (0, $5uXOq.useEffect)(()=>onMessageSnooze(handleDismiss), [
        onMessageSnooze
    ]);
    const activeScopes = (0, $eFjrB.usePostOfficeContextScope)({
        scopes: $92Slv.scopes
    });
    const messagesState = (0, $7PgHB.usePlacementApi)('/update-messages', {
        queryParams: {
            updateKey: activeScopes.updateKey ?? ''
        },
        requestOptions: {
            method: 'POST',
            body: JSON.stringify(activeScopes)
        },
        throttleTime: 100,
        autoRefetch: {
            isEnabled: !!activeScopes.updateKey && typeof localMessageState === 'undefined',
            updateKey: activeScopes.updateKey ?? ''
        }
    });
    (0, $5uXOq.useEffect)(()=>{
        if (messagesState?.data?.messages?.length) setLocalMessageState(messagesState.data.messages);
    }, [
        messagesState.data
    ]);
    return (0, $iEN9D.default).checkGate('post-office-screen-space-flags-shadow') ? /*#__PURE__*/ (0, $2OMIu.jsx)($bde3999cf210ffea$var$SuppressIfModalIsPresent, {
        children: localMessageState?.slice(0, 1).map(({ messageInstanceId: messageInstanceId, ...props })=>// Adding @ts-ingore to suppress the error in confluence typecheck and below error is not thrown in post-office typecheck
            // This error exists because confluence is using react 16 and post-office is using react 18
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore - 'ReactNode | ReactElement<any, any>' is not a valid JSX element.
            /*#__PURE__*/ (0, $5uXOq.createElement)((0, $4rq6q.MessageRenderer), {
                ...props,
                key: messageInstanceId,
                id: messageInstanceId,
                messageInstanceId: messageInstanceId,
                onDismissed: onDismissed,
                SuspenseBoundary: (0, $jOeT9.MaybeSuspenseBoundary),
                jiraFlagsService: jiraFlagsService,
                onError: reportUnexpectedError,
                reportExpectedError: reportExpectedError
            }))
    }) : null;
}), {
    choreographer: {
        isDefaultEnabled: true
    }
}));
var $bde3999cf210ffea$export$2e2bcd8739ae039 = $bde3999cf210ffea$export$c60b43809441c5b0;
const $bde3999cf210ffea$var$SuppressIfModalIsPresent = ({ children: children })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $h3mjV.useFirePostOfficeAnalyticsEvents)();
    const [isVisible, setIsVisible] = (0, $5uXOq.useState)(true);
    const handleVisibilityChange = (0, $5uXOq.useCallback)((modalOnScreen)=>{
        const shouldShow = !modalOnScreen;
        if (!shouldShow) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'suppressed',
            actionSubject: 'screenSpaceFlags'
        });
        setIsVisible(shouldShow);
    }, [
        fireAnalyticsEvent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const modalOnScreen = !!globalThis.document.querySelector('.atlaskit-portal-container .atlaskit-portal [role=dialog]');
        handleVisibilityChange(modalOnScreen);
    }, [
        handleVisibilityChange
    ]);
    return (0, $iEN9D.default).checkGate('post-office-screen-space-flags-modal-detector') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: isVisible && children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};

});
parcelRegister("eFjrB", function(module, exports) {

$parcel$export(module.exports, "usePostOfficeContextScope", () => $3fdf392448c70ebb$export$daf66a67c26dc848);
$parcel$export(module.exports, "createMatchScopes", () => $3fdf392448c70ebb$export$ec890b48cae4cc1c);

var $5uXOq = parcelRequire("5uXOq");

var $kye0Q = parcelRequire("kye0Q");

var $gHZ4O = parcelRequire("gHZ4O");

var $lwdce = parcelRequire("lwdce");

var $dM8xS = parcelRequire("dM8xS");
const $3fdf392448c70ebb$export$daf66a67c26dc848 = (config)=>{
    const scopeNames = $3fdf392448c70ebb$var$scopesNamesAsString(config.scopes);
    const matchScopes = (0, $5uXOq.useCallback)((input)=>$3fdf392448c70ebb$export$ec890b48cae4cc1c(config)(input), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        scopeNames
    ]);
    const [state, setState] = (0, $5uXOq.useState)($3fdf392448c70ebb$var$initialState);
    const route = (0, $lwdce.usePostOfficeRoute)();
    const context = (0, $gHZ4O.usePostOfficeContext)();
    const next = matchScopes({
        route: route,
        context: context
    });
    $3fdf392448c70ebb$var$usePostOfficeScopeSpy(state, config);
    (0, $5uXOq.useEffect)(()=>{
        if ($3fdf392448c70ebb$export$fcc046cb16c47539({
            next: next,
            state: state
        })) setState(({ current: current })=>({
                updateKey: Math.random().toString(36).substring(2),
                current: next,
                previous: current
            }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        $3fdf392448c70ebb$var$scopesNamesAsString(next)
    ]);
    return state;
};
const $3fdf392448c70ebb$var$scopesNamesAsString = (scopes = [])=>scopes.map((e)=>e.name).sort().join(',');
const $3fdf392448c70ebb$var$initialState = {
    updateKey: undefined,
    current: [],
    previous: []
};
const $3fdf392448c70ebb$var$createMatchScope = ({ route: route, context: context })=>(input)=>{
        const contextMatch = route ? 'pathname' in route ? {
            route: route,
            context: context
        } : route.current ? {
            route: $3fdf392448c70ebb$var$extractRelevantUrlFields(route.current),
            context: context
        } : {
            route: undefined,
            context: context
        } : {
            route: undefined,
            context: context
        };
        const inputMatch = input.when;
        return $3fdf392448c70ebb$export$5c1cef6f5f213829({
            contextMatch: contextMatch,
            inputMatch: inputMatch
        });
    };
const $3fdf392448c70ebb$var$extractRelevantUrlFields = (route)=>{
    const { hostname: hostname, pathname: pathname } = new URL(route);
    return {
        hostname: hostname,
        pathname: pathname
    };
};
const $3fdf392448c70ebb$export$5c1cef6f5f213829 = ({ contextMatch: contextMatch, inputMatch: inputMatch })=>(0, (/*@__PURE__*/$parcel$interopDefault($kye0Q)))(contextMatch, inputMatch, (contextValue, inputValue)=>$3fdf392448c70ebb$var$isValueMatchDeep({
            contextValue: contextValue,
            inputValue: inputValue
        }));
const $3fdf392448c70ebb$var$isValueMatch = ({ contextValue: contextValue, inputValue: inputValue })=>{
    if (!contextValue || !inputValue) return false;
    if (typeof inputValue === 'string') return contextValue === inputValue;
    if (inputValue?.equals) return contextValue === inputValue.equals;
    if (!inputValue?.matches) return false;
    if (typeof inputValue.matches !== 'string' || typeof contextValue !== 'string') return false;
    return new RegExp(inputValue.matches).test(contextValue);
};
const $3fdf392448c70ebb$var$isValueMatchDeep = ({ contextValue: contextValue, inputValue: inputValue })=>typeof inputValue === 'object' && typeof contextValue === 'object' ? $3fdf392448c70ebb$export$5c1cef6f5f213829({
        contextMatch: contextValue,
        inputMatch: inputValue
    }) : $3fdf392448c70ebb$var$isValueMatch({
        contextValue: contextValue,
        inputValue: inputValue
    });
const $3fdf392448c70ebb$export$ec890b48cae4cc1c = ({ scopes: scopes })=>(input)=>scopes.filter($3fdf392448c70ebb$var$createMatchScope(input)).map((scope)=>({
                name: scope.name
            }));
const $3fdf392448c70ebb$export$fcc046cb16c47539 = ({ next: next, state: state })=>{
    const currentSet = Array.from(new Set(state.current.map((e)=>e.name)));
    const nextSet = Array.from(new Set(next.map((e)=>e.name)));
    if (nextSet.length !== currentSet.length) return true;
    return !nextSet.every((e)=>currentSet.includes(e));
};
// Scope Spy
const $3fdf392448c70ebb$var$usePostOfficeScopeSpy = (state, config)=>{
    if (config?.consoleSpy && typeof window !== 'undefined' && !window?.postOffice?.scopes) {
        const [listen, update] = (0, $dM8xS.createSimplePubSub)();
        window.postOffice = {
            ...window.postOffice,
            scopes: {
                [config?.consoleSpy.name]: {
                    listen: listen,
                    update: update,
                    list: config.scopes
                }
            }
        };
    }
    (0, $5uXOq.useEffect)(()=>{
        if (!config?.consoleSpy) return;
        if (!window.postOffice?.scopes) return;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        window.postOffice?.scopes?.[config?.consoleSpy.name]?.update?.(state);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        $3fdf392448c70ebb$var$scopesNamesAsString(state.current)
    ]);
};

});
parcelRegister("kye0Q", function(module, exports) {

var $b1bUS = parcelRequire("b1bUS");

var $2TGin = parcelRequire("2TGin");
/**
 * This method is like `_.isMatch` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with five
 * arguments: (objValue, srcValue, index|key, object, source).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, srcValue) {
 *   if (isGreeting(objValue) && isGreeting(srcValue)) {
 *     return true;
 *   }
 * }
 *
 * var object = { 'greeting': 'hello' };
 * var source = { 'greeting': 'hi' };
 *
 * _.isMatchWith(object, source, customizer);
 * // => true
 */ function $ef61da41fa345164$var$isMatchWith(object, source, customizer) {
    customizer = typeof customizer == 'function' ? customizer : undefined;
    return $b1bUS(object, source, $2TGin(source), customizer);
}
module.exports = $ef61da41fa345164$var$isMatchWith;

});


parcelRegister("7PgHB", function(module, exports) {

$parcel$export(module.exports, "usePlacementApi", () => $5453278665841f55$export$201bbce8187a6e3c);

var $gHZ4O = parcelRequire("gHZ4O");

var $gJHNN = parcelRequire("gJHNN");

var $ebgAV = parcelRequire("ebgAV");

var $9uYQQ = parcelRequire("9uYQQ");

var $5uXOq = parcelRequire("5uXOq");
const $5453278665841f55$export$201bbce8187a6e3c = (path, config)=>{
    const { placementId: placementId } = (0, $9uYQQ.usePlacementContext)();
    const context = (0, $gHZ4O.usePostOfficeContext)();
    const fetcher = (0, $gJHNN.usePlacementFetchingContext)();
    const placementApi = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        if (!placementId) return ()=>({
                isLoading: false,
                data: undefined,
                error: new Error('No placementId found, make this is used as a child of PlacementProvider')
            });
        return (0, $ebgAV.createUsePlacement)(placementId, fetcher);
    }, [
        placementId,
        fetcher
    ]);
    const { queryParams: queryParams = {} } = config ?? {};
    const placementParams = {
        ...context,
        ...queryParams
    };
    return placementApi(path, placementParams, config?.requestOptions, {
        throttleTime: config?.throttleTime,
        isEnabled: config?.autoRefetch?.isEnabled,
        deps: [
            config?.autoRefetch?.updateKey
        ]
    });
};

});
parcelRegister("ebgAV", function(module, exports) {

$parcel$export(module.exports, "createUsePlacement", () => $040d7fd3864b847d$export$ee1d67e435d25cb5);

var $barKi = parcelRequire("barKi");

var $5uXOq = parcelRequire("5uXOq");

var $lpImZ = parcelRequire("lpImZ");
const $040d7fd3864b847d$var$depsIsValid = (deps)=>Array.isArray(deps);
const $040d7fd3864b847d$export$ee1d67e435d25cb5 = (placementId, fetcher = {
    fetch: (...args)=>globalThis.fetch(...args)
})=>{
    if (!fetcher.fetch) throw new Error('No fetcher found. If you are using usePlacement outside or a browser you must supply a fetcher yourself');
    return (path, context, requestOptions, config)=>{
        const dependencyList = $040d7fd3864b847d$var$depsIsValid(config?.deps) ? [
            ...config.deps,
            config?.isEnabled
        ] : [
            path,
            config?.isEnabled
        ];
        const timerRef = (0, $5uXOq.useRef)();
        const isRunningPromise = (0, $5uXOq.useRef)(false);
        (0, $5uXOq.useEffect)(()=>{
            return ()=>{
                if (timerRef.current) clearTimeout(timerRef.current);
            };
        }, []);
        const promiseToResolve = (0, $5uXOq.useMemo)(()=>{
            if (config?.isEnabled === false) return undefined;
            return ({ signal: signal })=>{
                if (isRunningPromise.current) return Promise.reject(new (0, $lpImZ.AlreadyRunningError)());
                isRunningPromise.current = true;
                timerRef.current = setTimeout(()=>{
                    isRunningPromise.current = false;
                }, config?.throttleTime ?? 0);
                return (0, $barKi.fetchPlacementData)(placementId, path, context, fetcher, {
                    ...requestOptions,
                    signal: signal
                });
            };
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        dependencyList);
        return (0, $lpImZ.useData)(promiseToResolve, {
            analytics: {
                name: placementId,
                path: path
            }
        });
    };
};

});
parcelRegister("barKi", function(module, exports) {

$parcel$export(module.exports, "fetchPlacementData", () => $532dc389c1086ba4$export$ce743d02f83ee521);
const $532dc389c1086ba4$export$2e74004b635d08aa = `/gateway/api/post-office/api/v1/placements/`;
const $532dc389c1086ba4$var$isNotEmpty = (input)=>!(typeof input === 'undefined' || input === null);
const $532dc389c1086ba4$var$stringifyObjectValues = (input)=>{
    const entries = Object.entries(input);
    const stringifiedEntries = entries.filter(([, value])=>$532dc389c1086ba4$var$isNotEmpty(value)).map(([key, value])=>[
            key,
            String(value)
        ]);
    return Object.fromEntries(stringifiedEntries);
};
const $532dc389c1086ba4$export$ce743d02f83ee521 = (placementId, path, context, fetcher, requestOptions)=>{
    const defaultHeaders = {
        credentials: 'include',
        mode: 'cors',
        'Content-Type': 'application/json'
    };
    const normalizedPath = path === '/' ? '' : `/${path.charAt(0) === '/' ? path.substring(1) : path}`;
    const contextAsSearchParams = new URLSearchParams($532dc389c1086ba4$var$stringifyObjectValues(context)).toString();
    const formattedSearchParams = contextAsSearchParams ? `?${contextAsSearchParams}` : contextAsSearchParams;
    const url = encodeURI(`${$532dc389c1086ba4$export$2e74004b635d08aa}${placementId}${normalizedPath}${formattedSearchParams}`);
    return fetcher.fetch(url, {
        ...requestOptions,
        headers: {
            ...defaultHeaders,
            ...requestOptions?.headers
        }
    });
};

});



parcelRegister("92Slv", function(module, exports) {

$parcel$export(module.exports, "scopes", () => $55067e880e752544$export$54a06e3f4a159ad8);
const $55067e880e752544$export$54a06e3f4a159ad8 = [
    {
        name: 'all',
        when: {
            route: {
                pathname: {
                    matches: '.*'
                }
            }
        }
    },
    {
        name: 'admin/all',
        when: {
            context: {
                product: 'admin'
            }
        }
    },
    {
        name: 'admin/products',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'products'
                }
            }
        }
    },
    {
        name: 'admin/discovered-products',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'discovered-products'
                }
            }
        }
    },
    {
        name: 'admin/domains',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'domains'
                }
            }
        }
    },
    {
        name: 'admin/user-access-settings',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'user-access-settings'
                }
            }
        }
    },
    {
        name: 'admin/authentication-policies',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'authentication-policies'
                }
            }
        }
    },
    {
        name: 'admin/users',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'users'
                }
            }
        }
    },
    {
        name: 'admin/audit-log',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'audit-log'
                }
            }
        }
    },
    {
        name: 'admin/billing-preview',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'billing-preview'
                }
            }
        }
    },
    {
        name: 'admin/data-security-policies',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'data-security-policies'
                }
            }
        }
    },
    {
        name: 'jira/all',
        when: {
            context: {
                product: 'jira'
            }
        }
    },
    {
        name: 'jira/kanban',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'board'
                }
            }
        }
    },
    {
        name: 'confluence/all',
        when: {
            context: {
                product: 'confluence'
            }
        }
    },
    {
        name: 'confluence/wiki-home',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/home'
                }
            }
        }
    },
    {
        name: 'confluence/pages-without-edit',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*?/pages/(?!edit-v2/).*'
                }
            }
        }
    },
    {
        name: 'confluence/blogs-without-edit',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*?/blog/(?!edit-v2/).*'
                }
            }
        }
    },
    {
        name: 'pop3/all',
        when: {
            context: {
                product: 'pop3'
            }
        }
    },
    {
        name: 'pop3/send-it',
        when: {
            context: {
                product: 'pop3'
            },
            route: {
                pathname: {
                    matches: 'send-it'
                }
            }
        }
    },
    {
        name: 'trello/all',
        when: {
            context: {
                product: 'trello'
            }
        }
    },
    {
        name: 'jira/queue',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'queue'
                }
            }
        }
    },
    {
        name: 'jira/browse',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'browse'
                }
            }
        }
    },
    {
        name: 'jira/issues',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'issues'
                }
            }
        }
    },
    {
        name: 'jira/software',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software'
                }
            }
        }
    },
    {
        name: 'jira/polaris',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/polaris'
                }
            }
        }
    },
    {
        name: 'jira/backlog',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'backlog'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk'
                }
            }
        }
    },
    {
        name: 'jira/project',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: '.*(?=.*project)(?=.*setting).*'
                }
            }
        }
    },
    {
        name: 'jira/your-work',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'your-work'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk/settings',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*/settings(/.*)?'
                }
            }
        }
    },
    {
        name: 'jira/business/forms/form-directory',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/form'
                }
            }
        }
    },
    {
        name: 'jira/business/board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/board'
                }
            }
        }
    },
    {
        name: 'jira/software/forms/form-directory',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/form'
                }
            }
        }
    },
    {
        name: 'jira/software/cmp/board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/c/projects/.*?/boards/[^/]*?$'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/boards/[^/]*?$'
                }
            }
        }
    },
    {
        name: 'jira/software/cmp/backlog',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/c/projects/.*?/boards/.*?/backlog'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/backlog',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/boards/.*?/backlog'
                }
            }
        }
    },
    {
        name: 'jira/software/list',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/list'
                }
            }
        }
    },
    {
        name: 'jira/business/list',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/list'
                }
            }
        }
    },
    {
        // Handles both CMP Software and Business
        name: 'jira/cmp/project-settings/people',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'plugins/servlet/project-config/.*?/people'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/project-settings/access',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/settings/access'
                }
            }
        }
    },
    {
        name: 'jira/business/tmp/project-settings/access',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/settings/access'
                }
            }
        }
    }
];

});

parcelRegister("4rq6q", function(module, exports) {

$parcel$export(module.exports, "MessageRenderer", () => $41d16ae43af486d7$export$2df1250b8f917a59);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for client side use only
#
# Generate source: local/cli/src/commands/placements/generate-placement-files.ts
*/ 
var $jOeT9 = parcelRequire("jOeT9");

var $5SN26 = parcelRequire("5SN26");

var $aL7an = parcelRequire("aL7an");

var $1RXYi = parcelRequire("1RXYi");

var $jxB0o = parcelRequire("jxB0o");

var $3Feda = parcelRequire("3Feda");

var $dEv4p = parcelRequire("dEv4p");

var $bvvyV = parcelRequire("bvvyV");

var $6N5v8 = parcelRequire("6N5v8");

var $6ZwtG = parcelRequire("6ZwtG");

var $afxIx = parcelRequire("afxIx");

var $5o9nW = parcelRequire("5o9nW");
const $41d16ae43af486d7$export$e30378e28ad3e6ab = {
    ...(0, $5SN26.default),
    ...(0, $aL7an.default),
    ...(0, $1RXYi.default),
    ...(0, $jxB0o.default),
    ...(0, $3Feda.default),
    ...(0, $dEv4p.default),
    ...(0, $bvvyV.default),
    ...(0, $6N5v8.default),
    ...(0, $6ZwtG.default),
    ...(0, $afxIx.default),
    ...(0, $5o9nW.default)
};
const { initializeMessageRenderer: $41d16ae43af486d7$export$bce4e5106d86e473, MessageRenderer: $41d16ae43af486d7$export$2df1250b8f917a59 } = (0, $jOeT9.asMessageRenderer)($41d16ae43af486d7$export$e30378e28ad3e6ab);

});
parcelRegister("5SN26", function(module, exports) {

$parcel$export(module.exports, "default", () => $de17feb7cb1dd9b2$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $5uXOq = parcelRequire("5uXOq");

var $de17feb7cb1dd9b2$export$2e2bcd8739ae039 = {
    'confluence-lovability-survey': /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("iOEn3")))
};

});
parcelRegister("iOEn3", function(module, exports) {

let $db2c3655de513f50$var$load = (parcelRequire("28QjX"))(4);
module.exports = $db2c3655de513f50$var$load("j0jxb").then(()=>parcelRequire('dNg0F'));

});


parcelRegister("aL7an", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6c9bfffd0a2b000$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $5uXOq = parcelRequire("5uXOq");





var $b6c9bfffd0a2b000$export$2e2bcd8739ae039 = {
    'confluence-commented-on-page-nudge': /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("3RN4o"))),
    'confluence-continue-reading-nudge': /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("9Qkcq"))),
    'confluence-inline-reactions-nudge': /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("hPykU"))),
    'confluence-mentioned-in-comment-nudge': /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("iAHRy"))),
    'confluence-mentioned-on-page-nudge': /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("lgdde")))
};

});
parcelRegister("3RN4o", function(module, exports) {

let $2d0c629b8a825431$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $2d0c629b8a825431$var$load("ffQaD"),
    $2d0c629b8a825431$var$load("kvRbA"),
    $2d0c629b8a825431$var$load("ekjKB")
]).then(()=>parcelRequire('glBba'));

});

parcelRegister("9Qkcq", function(module, exports) {

let $72a8a38cd4082dbc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $72a8a38cd4082dbc$var$load("kt5YM").then(()=>parcelRequire('5nAqP'));

});

parcelRegister("hPykU", function(module, exports) {

let $cfb1d59352ee5023$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $cfb1d59352ee5023$var$load("ffQaD"),
    $cfb1d59352ee5023$var$load("kvRbA"),
    $cfb1d59352ee5023$var$load("c9SVX")
]).then(()=>parcelRequire('7K0Q5'));

});

parcelRegister("iAHRy", function(module, exports) {

let $d88d9d03482e9905$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d88d9d03482e9905$var$load("ffQaD"),
    $d88d9d03482e9905$var$load("kvRbA"),
    $d88d9d03482e9905$var$load("jPcda")
]).then(()=>parcelRequire('1G2Km'));

});

parcelRegister("lgdde", function(module, exports) {

let $f7a55754c85ce726$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f7a55754c85ce726$var$load("ffQaD"),
    $f7a55754c85ce726$var$load("kvRbA"),
    $f7a55754c85ce726$var$load("ffdFA")
]).then(()=>parcelRequire('fgPuH'));

});


parcelRegister("1RXYi", function(module, exports) {

$parcel$export(module.exports, "default", () => $30308c4e3546f2a7$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $5uXOq = parcelRequire("5uXOq");

var $30308c4e3546f2a7$export$2e2bcd8739ae039 = {
    'jira-access-page-contact-sales-nudge': /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("lgNZL")))
};

});
parcelRegister("lgNZL", function(module, exports) {

let $f7c1df9a60d9bffb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f7c1df9a60d9bffb$var$load("gPaVZ").then(()=>parcelRequire('4O72a'));

});


parcelRegister("jxB0o", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5310f5e8357ce15$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $5uXOq = parcelRequire("5uXOq");



var $f5310f5e8357ce15$export$2e2bcd8739ae039 = {
    'jira-forms-conditional-fields-changeboarding': /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("dLiMT"))),
    'jira-forms-public-forms-changeboarding': /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("6PaOK"))),
    'jira-forms-public-forms-changeboarding-flag': /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("3mNRS")))
};

});
parcelRegister("dLiMT", function(module, exports) {

let $a04e3cf56b4bf850$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a04e3cf56b4bf850$var$load("bignV").then(()=>parcelRequire('cv8Zh'));

});

parcelRegister("6PaOK", function(module, exports) {

let $4f7fe5a3603e59b8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4f7fe5a3603e59b8$var$load("2CL1b").then(()=>parcelRequire('4G8MP'));

});

parcelRegister("3mNRS", function(module, exports) {

let $273a1beebd803961$var$load = (parcelRequire("28QjX"))(4);
module.exports = $273a1beebd803961$var$load("9IQk0").then(()=>parcelRequire('geoU0'));

});


parcelRegister("3Feda", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fb5dd2f155fe321$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $5uXOq = parcelRequire("5uXOq");

var $5fb5dd2f155fe321$export$2e2bcd8739ae039 = {
    'jira-issueview-layouts': /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("6jOok")))
};

});
parcelRegister("6jOok", function(module, exports) {

let $499b9b1ae61c7e2a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $499b9b1ae61c7e2a$var$load("aUXmR").then(()=>parcelRequire('4QPW5'));

});


parcelRegister("dEv4p", function(module, exports) {

$parcel$export(module.exports, "default", () => $1928860e82ae4db6$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $5uXOq = parcelRequire("5uXOq");

var $1928860e82ae4db6$export$2e2bcd8739ae039 = {
    'marketing-screen-space-flag-contentful-usecase': /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("ktuGr")))
};

});
parcelRegister("ktuGr", function(module, exports) {

let $ee7e51349727730b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ee7e51349727730b$var$load("2Yn3Z").then(()=>parcelRequire('e8Z1Y'));

});


parcelRegister("bvvyV", function(module, exports) {

$parcel$export(module.exports, "default", () => $14a36ca52bbd33ee$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $5uXOq = parcelRequire("5uXOq");

var $14a36ca52bbd33ee$export$2e2bcd8739ae039 = {
    'mercury-edit-hierarchy-spotlight': /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("2AcqA")))
};

});
parcelRegister("2AcqA", function(module, exports) {

let $1e1895719c9809ae$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1e1895719c9809ae$var$load("iU4ZK").then(()=>parcelRequire('guD2W'));

});


parcelRegister("6N5v8", function(module, exports) {

$parcel$export(module.exports, "default", () => $506ff5bfe8eed3eb$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $5uXOq = parcelRequire("5uXOq");

var $506ff5bfe8eed3eb$export$2e2bcd8739ae039 = {
    'end-of-trial-extension': /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("kEoK4")))
};

});
parcelRegister("kEoK4", function(module, exports) {

let $f08abc55809ddb4c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f08abc55809ddb4c$var$load("e9f9y").then(()=>parcelRequire('bTxkC'));

});


parcelRegister("6ZwtG", function(module, exports) {

$parcel$export(module.exports, "default", () => $786b0fc34489c838$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $5uXOq = parcelRequire("5uXOq");

var $786b0fc34489c838$export$2e2bcd8739ae039 = {
    'jira-messaging-research-recruitment': /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("Cmhgw")))
};

});
parcelRegister("Cmhgw", function(module, exports) {

let $0734d49126aeff7f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0734d49126aeff7f$var$load("hYQgp").then(()=>parcelRequire('kb90x'));

});


parcelRegister("afxIx", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa7dbabece5cd8be$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $5uXOq = parcelRequire("5uXOq");

var $aa7dbabece5cd8be$export$2e2bcd8739ae039 = {
    'message-template-template': /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("lRVCP")))
};

});
parcelRegister("lRVCP", function(module, exports) {

let $febb3f624c46d51f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $febb3f624c46d51f$var$load("enPRx").then(()=>parcelRequire('ilWOk'));

});


parcelRegister("5o9nW", function(module, exports) {

$parcel$export(module.exports, "default", () => $919ec0634b70ec5a$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $5uXOq = parcelRequire("5uXOq");



var $919ec0634b70ec5a$export$2e2bcd8739ae039 = {
    'test-message-inapp': /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("bC5z9"))),
    'test-message-inapp-implicit-pendo': /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("luOMc"))),
    'test-message-tap-ingestion-trigger-subscription': /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("fJwFS")))
};

});
parcelRegister("bC5z9", function(module, exports) {

let $87478f97d7090b63$var$load = (parcelRequire("28QjX"))(4);
module.exports = $87478f97d7090b63$var$load("9jN8K").then(()=>parcelRequire('kM8wR'));

});

parcelRegister("luOMc", function(module, exports) {

let $fa63c9728babb334$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fa63c9728babb334$var$load("1R1T9").then(()=>parcelRequire('chIH8'));

});

parcelRegister("fJwFS", function(module, exports) {

let $b7446777ae58d87e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b7446777ae58d87e$var$load("kWvsT").then(()=>parcelRequire('6fuMV'));

});



/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for server side use only
*/ const $f6721478b0b83c9a$export$a5cfae247d8360ef = 'screen-space-flags';

parcelRegister("3p8Nq", function(module, exports) {

$parcel$export(module.exports, "withScreenSpaceFlagsIntlProvider", () => $12221ebf84dcb54e$export$b0eee5de066b2bf5);
/**
 * This file was automatically generated using "yarn generate:all" command.
 * Please do not edit it manually.
 * 
 * Generate source: local/cli/src/commands/placements/generate-intl-provider.ts
 **/ 
var $frIzT = parcelRequire("frIzT");

var $9gjZC = parcelRequire("9gjZC");

var $5pE3Q = parcelRequire("5pE3Q");

var $6KIzx = parcelRequire("6KIzx");

var $2bHCu = parcelRequire("2bHCu");

var $6ZXw3 = parcelRequire("6ZXw3");

var $a0X9c = parcelRequire("a0X9c");

var $bzVGB = parcelRequire("bzVGB");

var $ccMmr = parcelRequire("ccMmr");

var $fX5Co = parcelRequire("fX5Co");

var $gWg7c = parcelRequire("gWg7c");

var $cENg4 = parcelRequire("cENg4");
const $12221ebf84dcb54e$export$d5a462ce7bd04520 = async (locale)=>{
    return Promise.allSettled([
        (0, $9gjZC.messagesLoader)(locale),
        (0, $5pE3Q.messagesLoader)(locale),
        (0, $6KIzx.messagesLoader)(locale),
        (0, $2bHCu.messagesLoader)(locale),
        (0, $6ZXw3.messagesLoader)(locale),
        (0, $a0X9c.messagesLoader)(locale),
        (0, $bzVGB.messagesLoader)(locale),
        (0, $ccMmr.messagesLoader)(locale),
        (0, $fX5Co.messagesLoader)(locale),
        (0, $gWg7c.messagesLoader)(locale),
        (0, $cENg4.messagesLoader)(locale)
    ]).then((results)=>{
        return results.reduce((acc, result)=>{
            if (result.status === 'fulfilled') return {
                messages: {
                    ...acc.messages,
                    ...result.value
                },
                errors: [
                    ...acc.errors
                ]
            };
            else if (result.status === 'rejected') return {
                messages: {
                    ...acc.messages
                },
                errors: [
                    ...acc.errors,
                    `Failed to load translations with ${result.reason}`
                ]
            };
            return acc;
        }, {
            messages: {},
            errors: []
        });
    });
};
const $12221ebf84dcb54e$export$b0eee5de066b2bf5 = (Component)=>{
    return (0, $frIzT.withIntlProvider)({
        messagesLoader: $12221ebf84dcb54e$export$d5a462ce7bd04520
    }, Component);
};

});
parcelRegister("9gjZC", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $58e53f268526ca6e$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $2WgLQ = parcelRequire("2WgLQ");

var $euiLX = parcelRequire("euiLX");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58e53f268526ca6e$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;






























const $58e53f268526ca6e$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $euiLX.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $58e53f268526ca6e$var$importHelper(await (parcelRequire("dAruQ")));
        case 'da':
            return $58e53f268526ca6e$var$importHelper(await (parcelRequire("bKxwc")));
        case 'de':
            return $58e53f268526ca6e$var$importHelper(await (parcelRequire("fl87Q")));
        case 'en-GB':
            return $58e53f268526ca6e$var$importHelper(await (parcelRequire("ehQ0e")));
        case 'en-US':
            return $58e53f268526ca6e$var$importHelper(await (parcelRequire("dLCX9")));
        case 'en-XA':
            return $58e53f268526ca6e$var$importHelper(await (parcelRequire("asdng")));
        case 'en-XB':
            return $58e53f268526ca6e$var$importHelper(await (parcelRequire("lsVpF")));
        case 'en-ZZ':
            return $58e53f268526ca6e$var$importHelper(await (parcelRequire("5Ismj")));
        case 'en':
            return $58e53f268526ca6e$var$importHelper(await Promise.resolve((parcelRequire("2WgLQ"))));
        case 'es':
            return $58e53f268526ca6e$var$importHelper(await (parcelRequire("bOGT2")));
        case 'et':
            return $58e53f268526ca6e$var$importHelper(await (parcelRequire("aFLLJ")));
        case 'fi':
            return $58e53f268526ca6e$var$importHelper(await (parcelRequire("gMEQ8")));
        case 'fr':
            return $58e53f268526ca6e$var$importHelper(await (parcelRequire("g70wY")));
        case 'hu':
            return $58e53f268526ca6e$var$importHelper(await (parcelRequire("716sl")));
        case 'it':
            return $58e53f268526ca6e$var$importHelper(await (parcelRequire("3Phay")));
        case 'ja':
            return $58e53f268526ca6e$var$importHelper(await (parcelRequire("hqops")));
        case 'ko':
            return $58e53f268526ca6e$var$importHelper(await (parcelRequire("8jLyW")));
        case 'nb':
            return $58e53f268526ca6e$var$importHelper(await (parcelRequire("4MUqM")));
        case 'nl':
            return $58e53f268526ca6e$var$importHelper(await (parcelRequire("bkCYZ")));
        case 'pl':
            return $58e53f268526ca6e$var$importHelper(await (parcelRequire("aRfCx")));
        case 'pt-BR':
            return $58e53f268526ca6e$var$importHelper(await (parcelRequire("fQbEO")));
        case 'ro':
            return $58e53f268526ca6e$var$importHelper(await (parcelRequire("2fRXY")));
        case 'ru':
            return $58e53f268526ca6e$var$importHelper(await (parcelRequire("6Gz0f")));
        case 'sv':
            return $58e53f268526ca6e$var$importHelper(await (parcelRequire("cp5BZ")));
        case 'th':
            return $58e53f268526ca6e$var$importHelper(await (parcelRequire("1DQKd")));
        case 'tr':
            return $58e53f268526ca6e$var$importHelper(await (parcelRequire("aqE8P")));
        case 'uk':
            return $58e53f268526ca6e$var$importHelper(await (parcelRequire("c5qc4")));
        case 'vi':
            return $58e53f268526ca6e$var$importHelper(await (parcelRequire("8MlsF")));
        case 'zh-CN':
            return $58e53f268526ca6e$var$importHelper(await (parcelRequire("jXY6R")));
        case 'zh-TW':
            return $58e53f268526ca6e$var$importHelper(await (parcelRequire("aoXXt")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($2WgLQ));
    }
};

});
parcelRegister("2WgLQ", function(module, exports) {
module.exports = JSON.parse("{\"confluence.lovability.survey.question\":[{\"type\":0,\"value\":\"To what extent do you agree or disagree with the following statement?\"}],\"confluence.lovability.survey.statement\":[{\"type\":0,\"value\":\"Confluence is a product I love using.\"}]}");

});

parcelRegister("dAruQ", function(module, exports) {

let $9e43f75e5e7e297e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9e43f75e5e7e297e$var$load("9vCDJ").then(()=>parcelRequire('fgakW'));

});

parcelRegister("bKxwc", function(module, exports) {

let $88ddfda08a5fc665$var$load = (parcelRequire("28QjX"))(4);
module.exports = $88ddfda08a5fc665$var$load("gUnRt").then(()=>parcelRequire('c4im9'));

});

parcelRegister("fl87Q", function(module, exports) {

let $b2af1ec1b1413612$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b2af1ec1b1413612$var$load("82hg3").then(()=>parcelRequire('1JiUs'));

});

parcelRegister("ehQ0e", function(module, exports) {

let $a66afde3ecb3d706$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a66afde3ecb3d706$var$load("hIpoO").then(()=>parcelRequire('eGCFr'));

});

parcelRegister("dLCX9", function(module, exports) {

let $a05de1671d0037b8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a05de1671d0037b8$var$load("abwCP").then(()=>parcelRequire('kpzlJ'));

});

parcelRegister("asdng", function(module, exports) {

let $79c6e4c6b51ce807$var$load = (parcelRequire("28QjX"))(4);
module.exports = $79c6e4c6b51ce807$var$load("lGWqS").then(()=>parcelRequire('iAEsq'));

});

parcelRegister("lsVpF", function(module, exports) {

let $fa08bf86b06b2b6d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fa08bf86b06b2b6d$var$load("jGfYW").then(()=>parcelRequire('6BtpO'));

});

parcelRegister("5Ismj", function(module, exports) {

let $42970f513eeb5353$var$load = (parcelRequire("28QjX"))(4);
module.exports = $42970f513eeb5353$var$load("1B4Kc").then(()=>parcelRequire('lHZIj'));

});

parcelRegister("bOGT2", function(module, exports) {

let $89a5a19e24f237f5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $89a5a19e24f237f5$var$load("eYMQP").then(()=>parcelRequire('dx1U6'));

});

parcelRegister("aFLLJ", function(module, exports) {

let $7c52c99a9e7e21e4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7c52c99a9e7e21e4$var$load("grTt5").then(()=>parcelRequire('g9KH3'));

});

parcelRegister("gMEQ8", function(module, exports) {

let $c380cef82dee45b3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c380cef82dee45b3$var$load("lrul5").then(()=>parcelRequire('d8l6O'));

});

parcelRegister("g70wY", function(module, exports) {

let $bbadb635175896b2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bbadb635175896b2$var$load("b11VO").then(()=>parcelRequire('dbnvv'));

});

parcelRegister("716sl", function(module, exports) {

let $51bda27a5951a772$var$load = (parcelRequire("28QjX"))(4);
module.exports = $51bda27a5951a772$var$load("eqJnw").then(()=>parcelRequire('gr3Pn'));

});

parcelRegister("3Phay", function(module, exports) {

let $2c9373f653b247e3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2c9373f653b247e3$var$load("hzTZl").then(()=>parcelRequire('j7VC3'));

});

parcelRegister("hqops", function(module, exports) {

let $caf7cc97600b7ff0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $caf7cc97600b7ff0$var$load("aWTKM").then(()=>parcelRequire('8S7YZ'));

});

parcelRegister("8jLyW", function(module, exports) {

let $60e4fe0163c98d64$var$load = (parcelRequire("28QjX"))(4);
module.exports = $60e4fe0163c98d64$var$load("eyDcc").then(()=>parcelRequire('9iw4I'));

});

parcelRegister("4MUqM", function(module, exports) {

let $37c76b1d2c321f2a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $37c76b1d2c321f2a$var$load("8GjPY").then(()=>parcelRequire('dX2Kz'));

});

parcelRegister("bkCYZ", function(module, exports) {

let $83ffcd229df941ce$var$load = (parcelRequire("28QjX"))(4);
module.exports = $83ffcd229df941ce$var$load("g3gOG").then(()=>parcelRequire('6I16N'));

});

parcelRegister("aRfCx", function(module, exports) {

let $7e7af88e9015cc15$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7e7af88e9015cc15$var$load("kznsK").then(()=>parcelRequire('8VlAg'));

});

parcelRegister("fQbEO", function(module, exports) {

let $b884c139299d5203$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b884c139299d5203$var$load("2egmP").then(()=>parcelRequire('bhdgQ'));

});

parcelRegister("2fRXY", function(module, exports) {

let $1a46d8101385f61c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1a46d8101385f61c$var$load("dteyq").then(()=>parcelRequire('hFmEI'));

});

parcelRegister("6Gz0f", function(module, exports) {

let $4de1d12d1af64d73$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4de1d12d1af64d73$var$load("lTWNK").then(()=>parcelRequire('1ybgY'));

});

parcelRegister("cp5BZ", function(module, exports) {

let $907c2c3ae509ecb6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $907c2c3ae509ecb6$var$load("cAC7C").then(()=>parcelRequire('ix2bE'));

});

parcelRegister("1DQKd", function(module, exports) {

let $132258e8ef0fccd2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $132258e8ef0fccd2$var$load("7AyS4").then(()=>parcelRequire('fUlQb'));

});

parcelRegister("aqE8P", function(module, exports) {

let $797b7850be3471c1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $797b7850be3471c1$var$load("facII").then(()=>parcelRequire('lLWEn'));

});

parcelRegister("c5qc4", function(module, exports) {

let $8cca453285c3b260$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8cca453285c3b260$var$load("c7zLV").then(()=>parcelRequire('1WDy5'));

});

parcelRegister("8MlsF", function(module, exports) {

let $664374371afb8d81$var$load = (parcelRequire("28QjX"))(4);
module.exports = $664374371afb8d81$var$load("fqgt6").then(()=>parcelRequire('ik6DH'));

});

parcelRegister("jXY6R", function(module, exports) {

let $e892278d9933c4b5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e892278d9933c4b5$var$load("cym6o").then(()=>parcelRequire('bq5MD'));

});

parcelRegister("aoXXt", function(module, exports) {

let $792aa7baa4dda2a3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $792aa7baa4dda2a3$var$load("3OT1S").then(()=>parcelRequire('jLwH2'));

});


parcelRegister("5pE3Q", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $5b6413338d529e97$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $fyI8s = parcelRequire("fyI8s");

var $euiLX = parcelRequire("euiLX");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5b6413338d529e97$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;































const $5b6413338d529e97$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $euiLX.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $5b6413338d529e97$var$importHelper(await (parcelRequire("dMQrk")));
        case 'da':
            return $5b6413338d529e97$var$importHelper(await (parcelRequire("aw25I")));
        case 'de':
            return $5b6413338d529e97$var$importHelper(await (parcelRequire("equad")));
        case 'en-GB':
            return $5b6413338d529e97$var$importHelper(await (parcelRequire("85KZ9")));
        case 'en-US':
            return $5b6413338d529e97$var$importHelper(await (parcelRequire("IGBNx")));
        case 'en-XA':
            return $5b6413338d529e97$var$importHelper(await (parcelRequire("9VEFw")));
        case 'en-XB':
            return $5b6413338d529e97$var$importHelper(await (parcelRequire("hmn0E")));
        case 'en-ZZ':
            return $5b6413338d529e97$var$importHelper(await (parcelRequire("fpS1F")));
        case 'en':
            return $5b6413338d529e97$var$importHelper(await Promise.resolve((parcelRequire("fyI8s"))));
        case 'es':
            return $5b6413338d529e97$var$importHelper(await (parcelRequire("yfvZC")));
        case 'et':
            return $5b6413338d529e97$var$importHelper(await (parcelRequire("lrx0K")));
        case 'fi':
            return $5b6413338d529e97$var$importHelper(await (parcelRequire("6KBfX")));
        case 'fr':
            return $5b6413338d529e97$var$importHelper(await (parcelRequire("k7ZlU")));
        case 'hu':
            return $5b6413338d529e97$var$importHelper(await (parcelRequire("iEsOL")));
        case 'it':
            return $5b6413338d529e97$var$importHelper(await (parcelRequire("kjqtW")));
        case 'ja':
            return $5b6413338d529e97$var$importHelper(await (parcelRequire("9oPzP")));
        case 'ko':
            return $5b6413338d529e97$var$importHelper(await (parcelRequire("2ebKE")));
        case 'nb':
            return $5b6413338d529e97$var$importHelper(await (parcelRequire("i9dea")));
        case 'nl':
            return $5b6413338d529e97$var$importHelper(await (parcelRequire("iDszE")));
        case 'pl':
            return $5b6413338d529e97$var$importHelper(await (parcelRequire("6HwHP")));
        case 'pt-BR':
            return $5b6413338d529e97$var$importHelper(await (parcelRequire("j6dDg")));
        case 'ro':
            return $5b6413338d529e97$var$importHelper(await (parcelRequire("goCJ5")));
        case 'ru':
            return $5b6413338d529e97$var$importHelper(await (parcelRequire("aaGLN")));
        case 'sv':
            return $5b6413338d529e97$var$importHelper(await (parcelRequire("93ylz")));
        case 'th':
            return $5b6413338d529e97$var$importHelper(await (parcelRequire("433gh")));
        case 'tr':
            return $5b6413338d529e97$var$importHelper(await (parcelRequire("1qWYh")));
        case 'uk':
            return $5b6413338d529e97$var$importHelper(await (parcelRequire("14u7u")));
        case 'vi':
            return $5b6413338d529e97$var$importHelper(await (parcelRequire("3ij2v")));
        case 'zh-CN':
            return $5b6413338d529e97$var$importHelper(await (parcelRequire("9gOPH")));
        case 'zh-TW':
            return $5b6413338d529e97$var$importHelper(await (parcelRequire("8R8kO")));
        case 'zh':
            return $5b6413338d529e97$var$importHelper(await (parcelRequire("9gOPH")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($fyI8s));
    }
};

});
parcelRegister("fyI8s", function(module, exports) {
module.exports = JSON.parse('{"app-switcher-discovery-section.discover-more-products":[{"type":0,"value":"Discover more apps"}],"app-switcher-discovery-section.more-atlassian-products":[{"type":0,"value":"More Atlassian apps"}],"app-switcher-discovery-section.recommended-for-your-team":[{"type":0,"value":"Recommended for your team"}],"confluence.continue.reading.body":[{"children":[{"type":0,"value":"Related reading from "},{"type":1,"value":"pageOwnerName"}],"type":8,"value":"text"}],"confluence.continue.reading.read-now":[{"type":0,"value":"Read now"}],"continue-reading.ai-footer.content-quality":[{"children":[{"type":0,"value":"Content quality may vary"}],"type":8,"value":"text"}],"continue-reading.ai-footer.powered-by-ai":[{"children":[{"type":0,"value":"Powered by AI"}],"type":8,"value":"text"}],"cross-flow-product-request-pending.jpd.title":[{"type":0,"value":"Product roadmap"}],"cross-flow-product-request-pending.jsm.title":[{"type":0,"value":"Work requests"}],"first-party-recommendation.reason-1":[{"type":0,"value":"the size of your team"}],"first-party-recommendation.reason-2":[{"type":0,"value":"your existing Atlassian products"}],"growth.admin-hub-recommendation.actions-heading":[{"type":0,"value":"Actions"}],"growth.admin-hub-recommendation.free-plan":[{"type":0,"value":"Free, cancel anytime"}],"growth.admin-hub-recommendation.heading":[{"type":0,"value":"Recommended based on your existing products"}],"growth.admin-hub-recommendation.plan-heading":[{"type":0,"value":"Plan"}],"growth.admin-hub-recommendation.try-it-now":[{"type":0,"value":"Try it now"}],"growth.app-switcher-discovery-section.flag.description":[{"type":0,"value":"You won\u2019t see this here as often."}],"growth.app-switcher-discovery-section.flag.title":[{"type":0,"value":"Got it, thanks for letting us know"}],"growth.app-switcher-discovery-section.wac-toast.close.aria-label":[{"type":0,"value":"Dismiss toast"}],"growth.confluenceNudgeFlag.flagHeadline.commentedOnPage.text":[{"children":[{"type":1,"value":"name"},{"type":0,"value":" commented on your page"}],"type":8,"value":"h"}],"growth.confluenceNudgeFlag.flagHeadline.mentionedInComment.text":[{"children":[{"type":1,"value":"name"},{"type":0,"value":" mentioned you in a comment"}],"type":8,"value":"h"}],"growth.confluenceNudgeFlag.flagHeadline.mentionedInPage.text":[{"children":[{"type":1,"value":"name"},{"type":0,"value":" mentioned you on a page"}],"type":8,"value":"h"}],"growth.confluenceNudgeFlag.repliedSuccessFlagTitle.text":[{"type":0,"value":"Reply sent to "},{"type":1,"value":"mentionerName"}],"growth.confluenceNudgeFlag.reply-cancel-button":[{"type":0,"value":"Cancel"}],"growth.confluenceNudgeFlag.reply-confirm-button":[{"type":0,"value":"Reply"}],"growth.confluenceNudgeFlag.reply-on-page-confirm-button.text":[{"children":[{"type":0,"value":"Reply on page"}],"type":8,"value":"a"}],"growth.confluenceNudgeFlag.replyFieldGenericError":[{"type":0,"value":"Failed to send comment. Please try again later."}],"growth.confluenceNudgeFlag.see-page-confirm-button":[{"children":[{"type":0,"value":"See page"}],"type":8,"value":"a"}],"growth.confluenceNudgeFlag.see-page-confirm-button.success.flag":[{"children":[{"type":0,"value":"See page"}],"type":8,"value":"a"}],"growth.confluenceNudgeFlag.viewReactionsError":[{"type":0,"value":"Reactions failed to load"}],"growth.recommendation-atlas.value-proposition":[{"type":0,"value":"Your company\'s teamwork directory"}],"growth.recommendation-confluence.cta.label":[{"type":0,"value":"Try Confluence"}],"growth.recommendation-confluence.jira-your-work.description":[{"type":0,"value":"Create a centralized space to organize requirements, release notes, goals, and more."}],"growth.recommendation-confluence.jira-your-work.header":[{"type":0,"value":"Get everyone on the same page"}],"growth.recommendation-confluence.jira-your-work.header-image-alt-text":[{"type":0,"value":"Multiple people collaborating and commenting on the same page at the same time"}],"growth.recommendation-confluence.jira-your-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"confluence"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-confluence.product-alt-text":[{"type":0,"value":"A document titled quarterly planning. The document has details like mission, scope and a monthly plan."}],"growth.recommendation-confluence.product-heading":[{"type":0,"value":"Create one source of truth, for all"}],"growth.recommendation-confluence.product-name.header":[{"type":0,"value":"Collaborate on pages in real-time"}],"growth.recommendation-confluence.product-subheading":[{"type":0,"value":"Create and link documents like release notes, product requirements, and roadmaps from a single place."}],"growth.recommendation-confluence.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"confluence"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-confluence.value-proposition":[{"type":0,"value":"Document collaboration"}],"growth.recommendation-jira.product-alt-text":[{"type":0,"value":"A board view to move tasks from to do, to in progress to done"}],"growth.recommendation-jira.product-heading":[{"type":0,"value":"Plan and track work across teams"}],"growth.recommendation-jira.product-subheading":[{"type":0,"value":"Break big ideas down into achievable steps. Organize work, create milestones, map dependencies, and get visibility across all teams."}],"growth.recommendation-jpd-product-roadmap.value-proposition":[{"type":0,"value":"Align everyone with custom roadmaps"}],"growth.recommendation-jpd.admin-hub-recommendation-value-proposition":[{"type":0,"value":"Plan and deliver all on the same platform"}],"growth.recommendation-jpd.cta.label":[{"type":0,"value":"Try Jira Product Discovery"}],"growth.recommendation-jpd.jira-your-work.description":[{"type":0,"value":"Prioritize your ideas then easily move them into delivery, without losing any details on the way."}],"growth.recommendation-jpd.jira-your-work.header":[{"type":0,"value":"Build right features, the right way"}],"growth.recommendation-jpd.jira-your-work.header-image-alt-text":[{"type":0,"value":"An idea in Jira Product Discovery automatically turning into an Epic in Jira"}],"growth.recommendation-jpd.jira-your-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jpd"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jpd.product-alt-text":[{"type":0,"value":"Five ideas are all organized into now, next and later groups, with a goal, score and effort ranking connected to each idea."}],"growth.recommendation-jpd.product-heading":[{"type":0,"value":"Build the right features, the right way"}],"growth.recommendation-jpd.product-name.header":[{"type":0,"value":"Transform insights into action plans"}],"growth.recommendation-jpd.product-subheading":[{"type":0,"value":"Capture and prioritize your ideas, then easily move them into delivery, without losing any details on the way."}],"growth.recommendation-jpd.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jpd"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jpd.value-proposition":[{"type":0,"value":"Prioritize, collaborate, and deliver new ideas"}],"growth.recommendation-jsm-work-request.value-proposition":[{"type":0,"value":"Create one place to manage requests"}],"growth.recommendation-jsm.admin-hub-recommendation-value-prop":[{"type":0,"value":"Bring your developers, IT, and operations onto the same platform."}],"growth.recommendation-jsm.cta.label":[{"type":0,"value":"Try Jira Service Management"}],"growth.recommendation-jsm.jira-your-work.description":[{"type":0,"value":"Connect support teams with development teams to get the full picture, from request to resolution."}],"growth.recommendation-jsm.jira-your-work.header":[{"type":0,"value":"Link your teams, make work visible"}],"growth.recommendation-jsm.jira-your-work.header-image-alt-text":[{"type":0,"value":"Requests from Slack, Teams and email turning into a Jira Service Management request automatically"}],"growth.recommendation-jsm.jira-your-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jsm"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jsm.product-alt-text":[{"type":0,"value":"Seven requests are all organized in one place, with a status and project connected to each request."}],"growth.recommendation-jsm.product-heading":[{"type":0,"value":"Make your work more visible"}],"growth.recommendation-jsm.product-name.header":[{"type":0,"value":"Automate workflows for faster resolutions"}],"growth.recommendation-jsm.product-subheading":[{"type":0,"value":"Connect Dev and Ops teams on a single platform to collaborate and connect the whole picture, from request to resolution."}],"growth.recommendation-jsm.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jsm"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jsm.value-proposition":[{"type":0,"value":"Collaborative IT service management"}],"growth.recommendation-jsw-dynamic-description.value-proposition":[{"type":0,"value":"Plan, track, and organize any project"}],"growth.recommendation-jsw-visualize-work.cta.label":[{"type":0,"value":"Try Jira"}],"growth.recommendation-jsw-visualize-work.product-name.header":[{"type":0,"value":"Visualize your projects in lists, boards, and more"}],"growth.recommendation-jsw-visualize-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"product"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jsw.recommendations.dropdown-menu-trigger.aria-label":[{"type":1,"value":"productName"},{"type":0,"value":" options"}],"growth.recommendation-jsw.value-proposition":[{"type":0,"value":"Project and issue tracking"}],"growth.recommendation-jwm.value-proposition":[{"type":0,"value":"ITSM that unlocks high-velocity teams"}],"growth.recommendation-loom.cta.label":[{"type":0,"value":"Try Loom"}],"growth.recommendation-loom.product-name-for-use-case":[{"type":0,"value":"Screen recorder"}],"growth.recommendation-loom.product-name.header":[{"type":0,"value":"Record and share videos easily"}],"growth.recommendation-loom.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"product"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-loom.value-proposition":[{"type":0,"value":"Record and share videos easily"}],"growth.recommendation-loom.value-proposition-for-use-case":[{"type":0,"value":"Record and share with an instant link"}],"growth.recommendation-opsgenie.value-proposition":[{"type":0,"value":"Modern incident management"}],"growth.recommendation-product-store.learn-cta-button-text":[{"type":0,"value":"Learn more"}],"growth.recommendation-product-store.try-cta-button-text":[{"type":0,"value":"Try it now"}],"growth.team-25-ipm.jira-your-work.call-to-action.watch-now.text":[{"type":0,"value":"Watch now"}],"growth.team-25-ipm.jira-your-work.description":[{"type":0,"value":"See how Rovo can improve the way you work with AI search, chat, and agents."}],"growth.team-25-ipm.jira-your-work.header-image-alt-text":[{"type":0,"value":"See the Rovo announcement!"}],"growth.team-25-ipm.jira-your-work.reasons-modal.message":[{"type":0,"value":"Atlassian recently shared multiple announcements at Team \'25, and we wanted to make sure you know about our new capabilities."}],"growth.team-25-ipm.jira-your-work.title":[{"type":0,"value":"Work better with Rovo"}],"jpd.customRoadmapsPlacementHeader":[{"type":0,"value":"Custom roadmaps"}],"jpd.customRoadmapsPlacementTagLine":[{"type":0,"value":"Create and share high-level plans"}],"jpd.deliveryProgressPlacementHeader":[{"type":0,"value":"Delivery progress"}],"jpd.deliveryProgressPlacementTagLine":[{"type":0,"value":"Connect ideas to delivery status"}],"jpd.ideasAndPrioritiesPlacementHeader":[{"type":0,"value":"Ideas and priorities"}],"jpd.ideasAndPrioritiesPlacementTagLine":[{"type":0,"value":"Use RICE and data to prioritize ideas"}],"jpd.insightsAndIdeasPlacementHeader":[{"type":0,"value":"Insights and ideas"}],"jpd.insightsAndIdeasPlacementTagLine":[{"type":0,"value":"See ideas and feedback in one place"}],"jsm.assetsPlacementHeader":[{"type":0,"value":"Assets"}],"jsm.assetsPlacementTagLine":[{"type":0,"value":"Bring your enterprise assets together"}],"jsm.bugTrackingPlacementHeader":[{"type":0,"value":"Bug tracking"}],"jsm.bugTrackingPlacementTagLine":[{"type":0,"value":"Gather and resolve bugs in one place"}],"jsm.changeManagementPlacementHeader":[{"type":0,"value":"Change management"}],"jsm.changeManagementPlacementTagLine":[{"type":0,"value":"Create one place to manage changes"}],"jsm.customerServicePlacementHeader":[{"type":0,"value":"Customer service"}],"jsm.customerServicePlacementTagLine":[{"type":0,"value":"Help people get service and support"}],"jsm.helpDeskPlacementHeader":[{"type":0,"value":"Help desk"}],"jsm.helpDeskPlacementTagLine":[{"type":0,"value":"Receive requests and provide support"}],"jsm.issueManagementPlacementHeader":[{"type":0,"value":"Issue management"}],"jsm.issueManagementPlacementTagLine":[{"type":0,"value":"Capture and resolve issues"}],"jsm.onCallSchedulesPlacementHeader":[{"type":0,"value":"On-call schedules"}],"jsm.onCallSchedulesPlacementTagLine":[{"type":0,"value":"Create schedules, rotations, and more"}],"jsm.workRequestsPlacementHeader":[{"type":0,"value":"Work requests"}],"jsm.workRequestsPlacementTagLine":[{"type":0,"value":"Create one place to manage requests"}],"post-office.ad-controls.confluence-continue-reading-nudge.reason.activity-in-product":[{"type":0,"value":"Your activity in Confluence"}],"post-office.ad-controls.confluence-continue-reading-nudge.reason.suggested-next-steps":[{"type":0,"value":"Suggested next steps to help you get more value out of Atlassian"}],"post-office.ad-controls.confluence-continue-reading-nudge.why-am-i-seeing-this.message":[{"type":0,"value":"You\'re seeing a personalized recommendation based on:"}],"post-office.ad-controls.confluence-continue-reading-nudge.why-am-i-seeing-this.title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.confluence-mcu-nudge-flag-message.recommendation-basis":[{"type":0,"value":"You\u2019re seeing a personalized recommendation based on:"}],"post-office.ad-controls.confluence-mcu-nudge-flag-reason.activity-in-product":[{"type":0,"value":"Your activity in Confluence"}],"post-office.ad-controls.confluence-mcu-nudge-flag-title.why-am-i-seeing-this":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.confluence-mcu-nudge-flag.suggestions":[{"type":0,"value":"Suggested next steps to help you get more value out of Atlassian"}],"post-office.ad-controls.custom-reason.existing-products.no-translate":[{"type":0,"value":"the second reason for displaying the message to the customer"}],"post-office.ad-controls.custom-reason.team-size.no-translate":[{"type":0,"value":"the first reason for displaying the message to the customer"}],"post-office.ad-controls.default-reason.existing-products":[{"type":0,"value":"your existing Atlassian products"}],"post-office.ad-controls.default-reason.team-size":[{"type":0,"value":"the size of your team"}],"post-office.ad-controls.dismiss-flag.not-interested.subtitle":[{"type":0,"value":"You won\u2019t see this here as often."}],"post-office.ad-controls.dismiss-flag.not-interested.title":[{"type":0,"value":"Got it, thanks for letting us know"}],"post-office.ad-controls.dropdown-item.not-interested.label":[{"type":0,"value":"Not interested"}],"post-office.ad-controls.dropdown-item.remind-me-later.label":[{"type":0,"value":"Remind me later"}],"post-office.ad-controls.dropdown-item.why-am-i-seeing-this.label":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.dropdown-menu-trigger.aria-label":[{"type":1,"value":"messageInstanceId"},{"type":0,"value":" options menu"}],"post-office.ad-controls.dropdown-menu-trigger.tooltip":[{"type":0,"value":"More actions"}],"post-office.ad-controls.next-best-action-message.recommendation-basis":[{"type":0,"value":"This recommendation is based on:"}],"post-office.ad-controls.next-best-action-reason.actions-done-so-far":[{"type":0,"value":"What you\u2019ve done so far in the product"}],"post-office.ad-controls.next-best-action-reason.suggestions":[{"type":0,"value":"What we suggest to help you get the most value from Atlassian"}],"post-office.ad-controls.next-best-action-title.why-am-i-seeing-this":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.reasons-modal.accept-button.label-ok":[{"type":0,"value":"OK"}],"post-office.ad-controls.reasons-modal.body":[{"type":0,"value":"We think you\'d find this relevant. This is based on:"}],"post-office.ad-controls.reasons-modal.privacy-policy-link.text":[{"type":0,"value":"Learn more about your data privacy with Atlassian"}],"post-office.ad-controls.reasons-modal.title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.close-button.tooltip":[{"type":0,"value":"Close"}],"post-office.confluence-banner-first-party-recommendation.try-it-now":[{"type":0,"value":"Try it now"}],"post-office.confluence-side-nav.next-best-action.craete-space-header":[{"type":0,"value":"Centralize your team\'s projects, and docs."}],"post-office.confluence-side-nav.next-best-action.create-page-cta-message":[{"type":0,"value":"Create page"}],"post-office.confluence-side-nav.next-best-action.create-page-header":[{"type":0,"value":"Plan projects, take notes, and track tasks."}],"post-office.confluence-side-nav.next-best-action.create-space-cta-message":[{"type":0,"value":"Create space"}],"post-office.confluence-side-nav.next-best-action.create-whiteboard-cta-message":[{"type":0,"value":"Create whiteboard"}],"post-office.confluence-side-nav.next-best-action.create-whiteboard-header":[{"type":0,"value":"Dream up new ideas, and visualize your work."}],"post-office.example-message-template.example-placement.cta-button.no-translate":[{"type":0,"value":"Try now"}],"post-office.example-placement-advanced.learn-more-modal.done-button-text.no-translate":[{"type":0,"value":"Done"}],"post-office.growth.jira-assigned-nudge.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.growth.recommendation-jpd.confluence-home-banner.description":[{"type":0,"value":"Make sure your team is building the right things with Jira Product Discovery."}],"post-office.growth.recommendation-jpd.confluence-home-banner.header":[{"type":0,"value":"Capture your ideas and customer feedback all in one place"}],"post-office.growth.recommendation-jpd.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Discovery Product Logo"}],"post-office.growth.recommendation-jsm.confluence-home-banner.description":[{"type":0,"value":"Automatically turn Slack, Teams, and email requests into tickets."}],"post-office.growth.recommendation-jsm.confluence-home-banner.header":[{"type":0,"value":"See the whole picture, from request to resolution"}],"post-office.growth.recommendation-jsm.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Service Management Product Logo"}],"post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.description":[{"type":0,"value":"See analytics and insights about what your team is working on at any moment"}],"post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.header":[{"type":0,"value":"Sync real-time data from Jira to any document in Confluence"}],"post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Logo"}],"post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.description":[{"type":0,"value":"76% customers shipped projects faster after adding Confluence and Jira."}],"post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.header":[{"type":0,"value":"Build world-class products, fast"}],"post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Logo"}],"post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.description":[{"type":0,"value":"Jira lets you view your project and tasks in a way that works for you and your team."}],"post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.header":[{"type":0,"value":"Visualize any project in a list, board, backlog, and more"}],"post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Logo"}],"post-office.jira-side-nav-first-party-recommendation.try-product":[{"type":0,"value":"Try Product"}],"post-office.jira-your-work-first-party-recommendation.learn-more":[{"type":0,"value":"Learn more"}],"post-office.jira-your-work-first-party-recommendation.learn-more.alt-text":[{"type":0,"value":"Discover more about "},{"type":1,"value":"product"}],"post-office.jira-your-work-first-party-recommendation.try-it-now":[{"type":0,"value":"Try it now"}],"post-office.jira-your-work-first-party-recommendation.try-product":[{"type":0,"value":"Try Product"}],"post-office.nav-4-requested-item.cta-button-dimissal":[{"type":0,"value":"Dismiss"}],"post-office.nav-4-requested-item.cta-button-lozenge-pending":[{"type":0,"value":"Pending"}],"post-office.nav-4-requested-item.product-roadmap-icon-alt-text":[{"type":0,"value":"Icon for product roadmap"}],"post-office.nav-4-requested-item.work-requests-icon-alt-text":[{"type":0,"value":"Icon for work requests"}],"post-office.placement-v2-nav-4-section.requested-main-heading":[{"type":0,"value":"Requested"}],"post-office.test-placement.main-heading.no-translate":[{"type":0,"value":"Welcome to Placements v2"}],"post-office.test-placement.test-message.dismiss-button.no-translate":[{"type":0,"value":"Dismiss"}],"post-office.test-placement.test-message.learn-more-button.no-translate":[{"type":0,"value":"Learn more"}],"recommendation-controls.existing-products":[{"type":0,"value":"your existing Atlassian products"}],"recommendation-controls.team-size":[{"type":0,"value":"the size of your team"}],"recommendations.ad-controls.dismiss-flag.not-interested.subtitle":[{"type":0,"value":"You won\u2019t see this here as often."}],"recommendations.ad-controls.dismiss-flag.not-interested.title":[{"type":0,"value":"Got it, thanks for letting us know"}],"recommendations.ad-controls.reasons-modal.accept-button.label":[{"type":0,"value":"Ok"}],"recommendations.ad-controls.reasons-modal.accept-button.label-ok":[{"type":0,"value":"OK"}],"recommendations.ad-controls.reasons-modal.body":[{"type":0,"value":"We think that "},{"type":1,"value":"productName"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"recommendations.ad-controls.reasons-modal.privacy-policy-link.text":[{"type":0,"value":"Learn more about your data privacy with Atlassian"}],"recommendations.ad-controls.reasons-modal.title":[{"type":0,"value":"Why am I seeing this?"}],"switcher.ad-controls.dropdown-item.not-interested.label":[{"type":0,"value":"Not interested"}],"switcher.ad-controls.dropdown-item.why-am-i-seeing-this.label":[{"type":0,"value":"Why am I seeing this?"}],"test":[{"type":0,"value":"default message"}]}');

});

parcelRegister("dMQrk", function(module, exports) {

let $a0986f84b9e789b1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a0986f84b9e789b1$var$load("34TIh").then(()=>parcelRequire('edSOR'));

});

parcelRegister("aw25I", function(module, exports) {

let $7a7e83c9f0b5a843$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7a7e83c9f0b5a843$var$load("kLSaZ").then(()=>parcelRequire('bBpFA'));

});

parcelRegister("equad", function(module, exports) {

let $a80ae44cb71255b9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a80ae44cb71255b9$var$load("fS2Ur").then(()=>parcelRequire('fStAt'));

});

parcelRegister("85KZ9", function(module, exports) {

let $5e433ca7de47ebed$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5e433ca7de47ebed$var$load("jO26g").then(()=>parcelRequire('fbpU5'));

});

parcelRegister("IGBNx", function(module, exports) {

let $0865295d755f8d5e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0865295d755f8d5e$var$load("29Pi2").then(()=>parcelRequire('2EfPo'));

});

parcelRegister("9VEFw", function(module, exports) {

let $73a8fbe549b98388$var$load = (parcelRequire("28QjX"))(4);
module.exports = $73a8fbe549b98388$var$load("ebxWA").then(()=>parcelRequire('qqQuh'));

});

parcelRegister("hmn0E", function(module, exports) {

let $ca3656f19bc8d58d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ca3656f19bc8d58d$var$load("abjlg").then(()=>parcelRequire('od8Zx'));

});

parcelRegister("fpS1F", function(module, exports) {

let $b39319365c3c4b2b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b39319365c3c4b2b$var$load("7EmV4").then(()=>parcelRequire('02f8q'));

});

parcelRegister("yfvZC", function(module, exports) {

let $066f360ca8aabd6c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $066f360ca8aabd6c$var$load("emImu").then(()=>parcelRequire('6TlUF'));

});

parcelRegister("lrx0K", function(module, exports) {

let $f9c5b9e39ca913d4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f9c5b9e39ca913d4$var$load("hEx03").then(()=>parcelRequire('3nJod'));

});

parcelRegister("6KBfX", function(module, exports) {

let $4ea3f0469b770fc6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4ea3f0469b770fc6$var$load("llATb").then(()=>parcelRequire('63C9h'));

});

parcelRegister("k7ZlU", function(module, exports) {

let $ea740d62f15fd8ff$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ea740d62f15fd8ff$var$load("a6Gnx").then(()=>parcelRequire('8SgbI'));

});

parcelRegister("iEsOL", function(module, exports) {

let $d942510df58daab2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d942510df58daab2$var$load("dOuOH").then(()=>parcelRequire('9npFn'));

});

parcelRegister("kjqtW", function(module, exports) {

let $ec9a1fc30aad8fc4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ec9a1fc30aad8fc4$var$load("2uvit").then(()=>parcelRequire('2OYvI'));

});

parcelRegister("9oPzP", function(module, exports) {

let $6d7e5d0e9f389224$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6d7e5d0e9f389224$var$load("iSpDy").then(()=>parcelRequire('5PWKA'));

});

parcelRegister("2ebKE", function(module, exports) {

let $19f6012e77e1a26a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $19f6012e77e1a26a$var$load("3rIhC").then(()=>parcelRequire('doXEX'));

});

parcelRegister("i9dea", function(module, exports) {

let $d36353f2ed17eb63$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d36353f2ed17eb63$var$load("2C6Lx").then(()=>parcelRequire('foJBn'));

});

parcelRegister("iDszE", function(module, exports) {

let $d91208bdbb764775$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d91208bdbb764775$var$load("b9TzU").then(()=>parcelRequire('enPQi'));

});

parcelRegister("6HwHP", function(module, exports) {

let $4e1020eff17ae2da$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4e1020eff17ae2da$var$load("alPsR").then(()=>parcelRequire('aYriA'));

});

parcelRegister("j6dDg", function(module, exports) {

let $de7926f879343b7e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $de7926f879343b7e$var$load("dDH4y").then(()=>parcelRequire('bx3ZD'));

});

parcelRegister("goCJ5", function(module, exports) {

let $befced6dbe963cd8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $befced6dbe963cd8$var$load("7qwwo").then(()=>parcelRequire('25HEx'));

});

parcelRegister("aaGLN", function(module, exports) {

let $767c03c7ee15056b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $767c03c7ee15056b$var$load("AJZU5").then(()=>parcelRequire('a7My1'));

});

parcelRegister("93ylz", function(module, exports) {

let $697f0971dee12b6a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $697f0971dee12b6a$var$load("dVY78").then(()=>parcelRequire('3L8eJ'));

});

parcelRegister("433gh", function(module, exports) {

let $2f29f8ec2d0e517e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2f29f8ec2d0e517e$var$load("gQdaz").then(()=>parcelRequire('hImPI'));

});

parcelRegister("1qWYh", function(module, exports) {

let $10b5f69ce116e7cd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $10b5f69ce116e7cd$var$load("kkvNl").then(()=>parcelRequire('1gsTt'));

});

parcelRegister("14u7u", function(module, exports) {

let $0c7d8759eca2ad85$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0c7d8759eca2ad85$var$load("iitCC").then(()=>parcelRequire('zBqMp'));

});

parcelRegister("3ij2v", function(module, exports) {

let $2661d2588dadaa8e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2661d2588dadaa8e$var$load("1q3vO").then(()=>parcelRequire('didpm'));

});

parcelRegister("9gOPH", function(module, exports) {

let $6bfd0a0ad571a85b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6bfd0a0ad571a85b$var$load("dwAxe").then(()=>parcelRequire('9Cwwc'));

});

parcelRegister("8R8kO", function(module, exports) {

let $6729bd1320447f81$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6729bd1320447f81$var$load("eyVU5").then(()=>parcelRequire('4f2zd'));

});


parcelRegister("6KIzx", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $f3d75bb9215867eb$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $cqnEE = parcelRequire("cqnEE");

var $euiLX = parcelRequire("euiLX");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f3d75bb9215867eb$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;






























const $f3d75bb9215867eb$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $euiLX.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $f3d75bb9215867eb$var$importHelper(await (parcelRequire("fOd2i")));
        case 'da':
            return $f3d75bb9215867eb$var$importHelper(await (parcelRequire("8Nueg")));
        case 'de':
            return $f3d75bb9215867eb$var$importHelper(await (parcelRequire("kvnZc")));
        case 'en-GB':
            return $f3d75bb9215867eb$var$importHelper(await (parcelRequire("dj6bg")));
        case 'en-US':
            return $f3d75bb9215867eb$var$importHelper(await (parcelRequire("lGYJ2")));
        case 'en-XA':
            return $f3d75bb9215867eb$var$importHelper(await (parcelRequire("lECr7")));
        case 'en-XB':
            return $f3d75bb9215867eb$var$importHelper(await (parcelRequire("bWkmm")));
        case 'en-ZZ':
            return $f3d75bb9215867eb$var$importHelper(await (parcelRequire("4uice")));
        case 'en':
            return $f3d75bb9215867eb$var$importHelper(await Promise.resolve((parcelRequire("cqnEE"))));
        case 'es':
            return $f3d75bb9215867eb$var$importHelper(await (parcelRequire("5sF6K")));
        case 'et':
            return $f3d75bb9215867eb$var$importHelper(await (parcelRequire("3um9J")));
        case 'fi':
            return $f3d75bb9215867eb$var$importHelper(await (parcelRequire("gvNsc")));
        case 'fr':
            return $f3d75bb9215867eb$var$importHelper(await (parcelRequire("1UzOT")));
        case 'hu':
            return $f3d75bb9215867eb$var$importHelper(await (parcelRequire("3oj1J")));
        case 'it':
            return $f3d75bb9215867eb$var$importHelper(await (parcelRequire("1nw5P")));
        case 'ja':
            return $f3d75bb9215867eb$var$importHelper(await (parcelRequire("7RDV8")));
        case 'ko':
            return $f3d75bb9215867eb$var$importHelper(await (parcelRequire("nlff2")));
        case 'nb':
            return $f3d75bb9215867eb$var$importHelper(await (parcelRequire("2xxzw")));
        case 'nl':
            return $f3d75bb9215867eb$var$importHelper(await (parcelRequire("l0qHE")));
        case 'pl':
            return $f3d75bb9215867eb$var$importHelper(await (parcelRequire("2fVsI")));
        case 'pt-BR':
            return $f3d75bb9215867eb$var$importHelper(await (parcelRequire("bSDCh")));
        case 'ro':
            return $f3d75bb9215867eb$var$importHelper(await (parcelRequire("eqnF0")));
        case 'ru':
            return $f3d75bb9215867eb$var$importHelper(await (parcelRequire("jUuuV")));
        case 'sv':
            return $f3d75bb9215867eb$var$importHelper(await (parcelRequire("k0Ars")));
        case 'th':
            return $f3d75bb9215867eb$var$importHelper(await (parcelRequire("fK2e3")));
        case 'tr':
            return $f3d75bb9215867eb$var$importHelper(await (parcelRequire("cKJtu")));
        case 'uk':
            return $f3d75bb9215867eb$var$importHelper(await (parcelRequire("bePPX")));
        case 'vi':
            return $f3d75bb9215867eb$var$importHelper(await (parcelRequire("3WIlS")));
        case 'zh-CN':
            return $f3d75bb9215867eb$var$importHelper(await (parcelRequire("hrfKd")));
        case 'zh-TW':
            return $f3d75bb9215867eb$var$importHelper(await (parcelRequire("cekwZ")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($cqnEE));
    }
};

});
parcelRegister("cqnEE", function(module, exports) {
module.exports = JSON.parse("{\"jira.jira-notify-reaction.message-template.text.single-reaction-with-name\":[{\"type\":0,\"value\":\":bell: *\"},{\"type\":1,\"value\":\"userName\"},{\"type\":0,\"value\":\" reacted to your comment*\"}],\"jira.jira-notify-reaction.message-template.text.view-comment\":[{\"type\":0,\"value\":\"View comment\"}]}");

});

parcelRegister("fOd2i", function(module, exports) {

let $b825a3372d0dcc04$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b825a3372d0dcc04$var$load("aI38C").then(()=>parcelRequire('fZLoE'));

});

parcelRegister("8Nueg", function(module, exports) {

let $667a5931b0dceffa$var$load = (parcelRequire("28QjX"))(4);
module.exports = $667a5931b0dceffa$var$load("8IRQB").then(()=>parcelRequire('5PoQ4'));

});

parcelRegister("kvnZc", function(module, exports) {

let $eed94f08e0981ac9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eed94f08e0981ac9$var$load("dpBH6").then(()=>parcelRequire('7Prkm'));

});

parcelRegister("dj6bg", function(module, exports) {

let $9b01d80a9bc8239f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9b01d80a9bc8239f$var$load("eBUrF").then(()=>parcelRequire('iDOvT'));

});

parcelRegister("lGYJ2", function(module, exports) {

let $fcaca005002aad18$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fcaca005002aad18$var$load("5KlIz").then(()=>parcelRequire('koTZX'));

});

parcelRegister("lECr7", function(module, exports) {

let $fc3b2617e8e9438a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fc3b2617e8e9438a$var$load("2aNnf").then(()=>parcelRequire('9orCB'));

});

parcelRegister("bWkmm", function(module, exports) {

let $8b14e77876fb525c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8b14e77876fb525c$var$load("bDgdd").then(()=>parcelRequire('ih9mF'));

});

parcelRegister("4uice", function(module, exports) {

let $3448142d35bacb83$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3448142d35bacb83$var$load("4uuAu").then(()=>parcelRequire('5ge8P'));

});

parcelRegister("5sF6K", function(module, exports) {

let $3f9f746d0f3adb37$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3f9f746d0f3adb37$var$load("kx9Rt").then(()=>parcelRequire('dgNyv'));

});

parcelRegister("3um9J", function(module, exports) {

let $28a55c2a6a0c0d3a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $28a55c2a6a0c0d3a$var$load("iF3UX").then(()=>parcelRequire('cT4vo'));

});

parcelRegister("gvNsc", function(module, exports) {

let $c055e711a5917895$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c055e711a5917895$var$load("iGMIo").then(()=>parcelRequire('lWmpn'));

});

parcelRegister("1UzOT", function(module, exports) {

let $1646ce798d181bc7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1646ce798d181bc7$var$load("7VNs6").then(()=>parcelRequire('g2g56'));

});

parcelRegister("3oj1J", function(module, exports) {

let $27825f51c49648ac$var$load = (parcelRequire("28QjX"))(4);
module.exports = $27825f51c49648ac$var$load("lq077").then(()=>parcelRequire('23teI'));

});

parcelRegister("1nw5P", function(module, exports) {

let $1010d56f0ee9b748$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1010d56f0ee9b748$var$load("hKiCe").then(()=>parcelRequire('8ROwp'));

});

parcelRegister("7RDV8", function(module, exports) {

let $5b9c73048628ae4b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5b9c73048628ae4b$var$load("9VOMZ").then(()=>parcelRequire('ATk3l'));

});

parcelRegister("nlff2", function(module, exports) {

let $0462a0e0e95f0692$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0462a0e0e95f0692$var$load("kfmI5").then(()=>parcelRequire('JDJjp'));

});

parcelRegister("2xxzw", function(module, exports) {

let $1d98b48c3d0d0da7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1d98b48c3d0d0da7$var$load("bkshx").then(()=>parcelRequire('lkBcu'));

});

parcelRegister("l0qHE", function(module, exports) {

let $f4ae4fbfd6f0cd96$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f4ae4fbfd6f0cd96$var$load("7iEUL").then(()=>parcelRequire('6rW2v'));

});

parcelRegister("2fVsI", function(module, exports) {

let $1a498e4bf3cf9e90$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1a498e4bf3cf9e90$var$load("2BAVc").then(()=>parcelRequire('9iqDz'));

});

parcelRegister("bSDCh", function(module, exports) {

let $8a6377de6bfcdc27$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8a6377de6bfcdc27$var$load("5e0T7").then(()=>parcelRequire('kbT1g'));

});

parcelRegister("eqnF0", function(module, exports) {

let $a805d8dd967ec39f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a805d8dd967ec39f$var$load("gbiaj").then(()=>parcelRequire('hotyx'));

});

parcelRegister("jUuuV", function(module, exports) {

let $e7eae77e38e1013e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e7eae77e38e1013e$var$load("5fh6S").then(()=>parcelRequire('ap1B6'));

});

parcelRegister("k0Ars", function(module, exports) {

let $e9101350e78a67f7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e9101350e78a67f7$var$load("khJNX").then(()=>parcelRequire('4dvXu'));

});

parcelRegister("fK2e3", function(module, exports) {

let $b75ce0ded2d7dbbf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b75ce0ded2d7dbbf$var$load("2n614").then(()=>parcelRequire('pVRR4'));

});

parcelRegister("cKJtu", function(module, exports) {

let $948d0e38d17ec1b5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $948d0e38d17ec1b5$var$load("hgjyi").then(()=>parcelRequire('bFPu9'));

});

parcelRegister("bePPX", function(module, exports) {

let $82e9364abf46da61$var$load = (parcelRequire("28QjX"))(4);
module.exports = $82e9364abf46da61$var$load("1TuRF").then(()=>parcelRequire('e1ZeM'));

});

parcelRegister("3WIlS", function(module, exports) {

let $2df931386bdae6e0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2df931386bdae6e0$var$load("kW1RJ").then(()=>parcelRequire('bUero'));

});

parcelRegister("hrfKd", function(module, exports) {

let $cb212bc7b06127dc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cb212bc7b06127dc$var$load("3ck1H").then(()=>parcelRequire('2qMIc'));

});

parcelRegister("cekwZ", function(module, exports) {

let $8e76b7e920819efe$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8e76b7e920819efe$var$load("9eaLU").then(()=>parcelRequire('i31p0'));

});


parcelRegister("2bHCu", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $a924e54f6f6996f5$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $eJ9qB = parcelRequire("eJ9qB");

var $euiLX = parcelRequire("euiLX");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a924e54f6f6996f5$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;






























const $a924e54f6f6996f5$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $euiLX.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $a924e54f6f6996f5$var$importHelper(await (parcelRequire("g5lFU")));
        case 'da':
            return $a924e54f6f6996f5$var$importHelper(await (parcelRequire("9WfmJ")));
        case 'de':
            return $a924e54f6f6996f5$var$importHelper(await (parcelRequire("5Q2Xl")));
        case 'en-GB':
            return $a924e54f6f6996f5$var$importHelper(await (parcelRequire("cPsns")));
        case 'en-US':
            return $a924e54f6f6996f5$var$importHelper(await (parcelRequire("9tdZj")));
        case 'en-XA':
            return $a924e54f6f6996f5$var$importHelper(await (parcelRequire("fUhlz")));
        case 'en-XB':
            return $a924e54f6f6996f5$var$importHelper(await (parcelRequire("b6vNe")));
        case 'en-ZZ':
            return $a924e54f6f6996f5$var$importHelper(await (parcelRequire("8Stqb")));
        case 'en':
            return $a924e54f6f6996f5$var$importHelper(await Promise.resolve((parcelRequire("eJ9qB"))));
        case 'es':
            return $a924e54f6f6996f5$var$importHelper(await (parcelRequire("590B7")));
        case 'et':
            return $a924e54f6f6996f5$var$importHelper(await (parcelRequire("3Wmcg")));
        case 'fi':
            return $a924e54f6f6996f5$var$importHelper(await (parcelRequire("gBO5C")));
        case 'fr':
            return $a924e54f6f6996f5$var$importHelper(await (parcelRequire("hmmPT")));
        case 'hu':
            return $a924e54f6f6996f5$var$importHelper(await (parcelRequire("42YJT")));
        case 'it':
            return $a924e54f6f6996f5$var$importHelper(await (parcelRequire("exMja")));
        case 'ja':
            return $a924e54f6f6996f5$var$importHelper(await (parcelRequire("7Vs6x")));
        case 'ko':
            return $a924e54f6f6996f5$var$importHelper(await (parcelRequire("6U0rf")));
        case 'nb':
            return $a924e54f6f6996f5$var$importHelper(await (parcelRequire("8ehBs")));
        case 'nl':
            return $a924e54f6f6996f5$var$importHelper(await (parcelRequire("iHl1H")));
        case 'pl':
            return $a924e54f6f6996f5$var$importHelper(await (parcelRequire("bI26M")));
        case 'pt-BR':
            return $a924e54f6f6996f5$var$importHelper(await (parcelRequire("6H7md")));
        case 'ro':
            return $a924e54f6f6996f5$var$importHelper(await (parcelRequire("cqT8B")));
        case 'ru':
            return $a924e54f6f6996f5$var$importHelper(await (parcelRequire("e3und")));
        case 'sv':
            return $a924e54f6f6996f5$var$importHelper(await (parcelRequire("cfJ5i")));
        case 'th':
            return $a924e54f6f6996f5$var$importHelper(await (parcelRequire("gHOO8")));
        case 'tr':
            return $a924e54f6f6996f5$var$importHelper(await (parcelRequire("fizo2")));
        case 'uk':
            return $a924e54f6f6996f5$var$importHelper(await (parcelRequire("71jxM")));
        case 'vi':
            return $a924e54f6f6996f5$var$importHelper(await (parcelRequire("eieOU")));
        case 'zh-CN':
            return $a924e54f6f6996f5$var$importHelper(await (parcelRequire("7hIIv")));
        case 'zh-TW':
            return $a924e54f6f6996f5$var$importHelper(await (parcelRequire("ksFNU")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($eJ9qB));
    }
};

});
parcelRegister("eJ9qB", function(module, exports) {
module.exports = JSON.parse("{}");

});

parcelRegister("g5lFU", function(module, exports) {

let $bb5ded265877db7d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bb5ded265877db7d$var$load("2NMpb").then(()=>parcelRequire('3cpwh'));

});

parcelRegister("9WfmJ", function(module, exports) {

let $73c5731ecc5b12fe$var$load = (parcelRequire("28QjX"))(4);
module.exports = $73c5731ecc5b12fe$var$load("5B6AA").then(()=>parcelRequire('fEvSm'));

});

parcelRegister("5Q2Xl", function(module, exports) {

let $44041a1db9e343cc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $44041a1db9e343cc$var$load("5oOMH").then(()=>parcelRequire('90UwY'));

});

parcelRegister("cPsns", function(module, exports) {

let $957042967d4eddaa$var$load = (parcelRequire("28QjX"))(4);
module.exports = $957042967d4eddaa$var$load("iEdui").then(()=>parcelRequire('iG3Tp'));

});

parcelRegister("9tdZj", function(module, exports) {

let $6e51ac2f5bfef7bb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6e51ac2f5bfef7bb$var$load("lLNaz").then(()=>parcelRequire('bWZqd'));

});

parcelRegister("fUhlz", function(module, exports) {

let $b9498ab43b004bfb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b9498ab43b004bfb$var$load("hf003").then(()=>parcelRequire('97DO0'));

});

parcelRegister("b6vNe", function(module, exports) {

let $8158eaab446beca1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8158eaab446beca1$var$load("55DIU").then(()=>parcelRequire('9BixH'));

});

parcelRegister("8Stqb", function(module, exports) {

let $676a30541ba42081$var$load = (parcelRequire("28QjX"))(4);
module.exports = $676a30541ba42081$var$load("1h7l1").then(()=>parcelRequire('cyKAC'));

});

parcelRegister("590B7", function(module, exports) {

let $3bee41b2414348e2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3bee41b2414348e2$var$load("5TbGT").then(()=>parcelRequire('64ofJ'));

});

parcelRegister("3Wmcg", function(module, exports) {

let $2de801b10bd9e293$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2de801b10bd9e293$var$load("gAZMZ").then(()=>parcelRequire('8C9Mf'));

});

parcelRegister("gBO5C", function(module, exports) {

let $c176f4caecdbb787$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c176f4caecdbb787$var$load("7Ny9U").then(()=>parcelRequire('7XkPG'));

});

parcelRegister("hmmPT", function(module, exports) {

let $ca3634795057081e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ca3634795057081e$var$load("bPAXi").then(()=>parcelRequire('92BXr'));

});

parcelRegister("42YJT", function(module, exports) {

let $2f2676dfa07b0c2d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2f2676dfa07b0c2d$var$load("iSZk4").then(()=>parcelRequire('83P6O'));

});

parcelRegister("exMja", function(module, exports) {

let $a9699ebf89636932$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a9699ebf89636932$var$load("1pcos").then(()=>parcelRequire('djs86'));

});

parcelRegister("7Vs6x", function(module, exports) {

let $5c53a838b9a204e7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5c53a838b9a204e7$var$load("jngyW").then(()=>parcelRequire('881ZW'));

});

parcelRegister("6U0rf", function(module, exports) {

let $5068501c3d58c3b7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5068501c3d58c3b7$var$load("kf2cy").then(()=>parcelRequire('fnQQ1'));

});

parcelRegister("8ehBs", function(module, exports) {

let $5fdd49233e3aff7c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5fdd49233e3aff7c$var$load("4w11H").then(()=>parcelRequire('764y5'));

});

parcelRegister("iHl1H", function(module, exports) {

let $d9cc8d8fd6b0f834$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d9cc8d8fd6b0f834$var$load("63nsF").then(()=>parcelRequire('2ap6D'));

});

parcelRegister("bI26M", function(module, exports) {

let $8865706de91b43b0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8865706de91b43b0$var$load("c1m3a").then(()=>parcelRequire('l4qlp'));

});

parcelRegister("6H7md", function(module, exports) {

let $4dfc7736c2ca7266$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4dfc7736c2ca7266$var$load("Gz3J2").then(()=>parcelRequire('gDFQl'));

});

parcelRegister("cqT8B", function(module, exports) {

let $90d2aef676593536$var$load = (parcelRequire("28QjX"))(4);
module.exports = $90d2aef676593536$var$load("dF0It").then(()=>parcelRequire('4oW6C'));

});

parcelRegister("e3und", function(module, exports) {

let $a3b8e80516f77b27$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a3b8e80516f77b27$var$load("hRYcd").then(()=>parcelRequire('cYAHC'));

});

parcelRegister("cfJ5i", function(module, exports) {

let $8eb9db98bf52fbf3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8eb9db98bf52fbf3$var$load("6ZBqo").then(()=>parcelRequire('hYySq'));

});

parcelRegister("gHOO8", function(module, exports) {

let $c29812d9776f5cf6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c29812d9776f5cf6$var$load("56hWd").then(()=>parcelRequire('bFYxG'));

});

parcelRegister("fizo2", function(module, exports) {

let $b233fc812295e725$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b233fc812295e725$var$load("23cKa").then(()=>parcelRequire('1PAe7'));

});

parcelRegister("71jxM", function(module, exports) {

let $51c7c963eea59945$var$load = (parcelRequire("28QjX"))(4);
module.exports = $51c7c963eea59945$var$load("e2aED").then(()=>parcelRequire('8h9io'));

});

parcelRegister("eieOU", function(module, exports) {

let $a67e3e138e47197f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a67e3e138e47197f$var$load("4xuT8").then(()=>parcelRequire('jNrCN'));

});

parcelRegister("7hIIv", function(module, exports) {

let $54dccec1264c3149$var$load = (parcelRequire("28QjX"))(4);
module.exports = $54dccec1264c3149$var$load("l9k0q").then(()=>parcelRequire('3H9aq'));

});

parcelRegister("ksFNU", function(module, exports) {

let $ee56d9942fb254ef$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ee56d9942fb254ef$var$load("dPEVo").then(()=>parcelRequire('lHVhC'));

});


parcelRegister("6ZXw3", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $db6dd95e6dfa2646$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $GbZYK = parcelRequire("GbZYK");

var $euiLX = parcelRequire("euiLX");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $db6dd95e6dfa2646$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;






























const $db6dd95e6dfa2646$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $euiLX.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $db6dd95e6dfa2646$var$importHelper(await (parcelRequire("d9ucL")));
        case 'da':
            return $db6dd95e6dfa2646$var$importHelper(await (parcelRequire("3ErTd")));
        case 'de':
            return $db6dd95e6dfa2646$var$importHelper(await (parcelRequire("bTKVU")));
        case 'en-GB':
            return $db6dd95e6dfa2646$var$importHelper(await (parcelRequire("1gayH")));
        case 'en-US':
            return $db6dd95e6dfa2646$var$importHelper(await (parcelRequire("l2Qc7")));
        case 'en-XA':
            return $db6dd95e6dfa2646$var$importHelper(await (parcelRequire("5AhoA")));
        case 'en-XB':
            return $db6dd95e6dfa2646$var$importHelper(await (parcelRequire("dl7x4")));
        case 'en-ZZ':
            return $db6dd95e6dfa2646$var$importHelper(await (parcelRequire("5Dj6w")));
        case 'en':
            return $db6dd95e6dfa2646$var$importHelper(await Promise.resolve((parcelRequire("GbZYK"))));
        case 'es':
            return $db6dd95e6dfa2646$var$importHelper(await (parcelRequire("cXnTz")));
        case 'et':
            return $db6dd95e6dfa2646$var$importHelper(await (parcelRequire("2wwF1")));
        case 'fi':
            return $db6dd95e6dfa2646$var$importHelper(await (parcelRequire("5Z5p4")));
        case 'fr':
            return $db6dd95e6dfa2646$var$importHelper(await (parcelRequire("4KAD4")));
        case 'hu':
            return $db6dd95e6dfa2646$var$importHelper(await (parcelRequire("78r0R")));
        case 'it':
            return $db6dd95e6dfa2646$var$importHelper(await (parcelRequire("4Vydu")));
        case 'ja':
            return $db6dd95e6dfa2646$var$importHelper(await (parcelRequire("gSLar")));
        case 'ko':
            return $db6dd95e6dfa2646$var$importHelper(await (parcelRequire("f5PpQ")));
        case 'nb':
            return $db6dd95e6dfa2646$var$importHelper(await (parcelRequire("bSLYR")));
        case 'nl':
            return $db6dd95e6dfa2646$var$importHelper(await (parcelRequire("7p4ki")));
        case 'pl':
            return $db6dd95e6dfa2646$var$importHelper(await (parcelRequire("1h7XV")));
        case 'pt-BR':
            return $db6dd95e6dfa2646$var$importHelper(await (parcelRequire("h2CZ2")));
        case 'ro':
            return $db6dd95e6dfa2646$var$importHelper(await (parcelRequire("6dsdF")));
        case 'ru':
            return $db6dd95e6dfa2646$var$importHelper(await (parcelRequire("57ryt")));
        case 'sv':
            return $db6dd95e6dfa2646$var$importHelper(await (parcelRequire("b7xj2")));
        case 'th':
            return $db6dd95e6dfa2646$var$importHelper(await (parcelRequire("cJiRC")));
        case 'tr':
            return $db6dd95e6dfa2646$var$importHelper(await (parcelRequire("imA3a")));
        case 'uk':
            return $db6dd95e6dfa2646$var$importHelper(await (parcelRequire("4hl0b")));
        case 'vi':
            return $db6dd95e6dfa2646$var$importHelper(await (parcelRequire("70URh")));
        case 'zh-CN':
            return $db6dd95e6dfa2646$var$importHelper(await (parcelRequire("7hRVq")));
        case 'zh-TW':
            return $db6dd95e6dfa2646$var$importHelper(await (parcelRequire("aovGA")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($GbZYK));
    }
};

});
parcelRegister("GbZYK", function(module, exports) {
module.exports = JSON.parse('{"jira-issueview-layouts.issue-view-layout-picker-changeboarding-body":[{"type":0,"value":"Choose a layout that works best for you."}],"jira-issueview-layouts.issue-view-layout-picker-changeboarding-heading":[{"type":0,"value":"Customise your view"}],"jira-thor.jira-notifications-project-recap.issue-row.work-item-key":[{"type":1,"value":"workItemKey"}],"jira-thor.jira-notifications-project-recap.issue-row.work-item-summary":[{"type":1,"value":"workItemSummary"}],"jira-thor.jira-notifications-project-recap.message-template-template.email.body":[{"type":0,"value":"Don\'t let this work slip under the radar. Keep an eye on these unassigned work items by watching them, or assign them to yourself."}],"jira-thor.jira-notifications-project-recap.message-template-template.email.heading":[{"type":0,"value":"This work hasn\'t been assigned to anyone"}],"jira-thor.jira-notifications-project-recap.message-template-template.email.manage-notifications":[{"type":0,"value":"Manage notifications"}],"jira-thor.jira-notifications-project-recap.message-template-template.email.privacy-policy":[{"type":0,"value":"Privacy policy"}],"jira-thor.jira-notifications-project-recap.message-template-template.email.separator-dot":[{"type":0,"value":"\u2022"}],"jira-thor.jira-notifications-project-recap.message-template-template.issue.assign.action":[{"type":0,"value":"Assign to me"}],"jira-thor.jira-notifications-project-recap.message-template-template.issue.watch.action":[{"type":0,"value":"Watch"}],"jira-thor.jira-notifications-project-recap.message-template-template.project.remaining.items":[{"type":0,"value":"+"},{"type":1,"value":"remaining"},{"type":0,"value":" more..."}],"jira-thor.jira-notifications-project-recap.message-template-template.project.total.unassigned.items":[{"type":0,"value":"Unassigned work items ("},{"type":1,"value":"totalCount"},{"type":0,"value":")"}],"jira-thor.jira-notifications-project-recap.message-template-template.project.view.all":[{"type":0,"value":"View all in Jira"}],"jira-thor.jira-notifications-project-recap.message-template.email.subject.no-translate":[{"type":1,"value":"name"},{"type":0,"value":", don\'t miss this week\'s unassigned work items"}],"jira.jira-notifications-project-recap.message-template-template.email.contact-us":[{"type":0,"value":"Contact us"}],"jira.jira-notifications-project-recap.message-template-template.email.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"jira.jira-notifications-project-recap.message-template-template.email.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"ok":[{"type":0,"value":"Ok"}]}');

});

parcelRegister("d9ucL", function(module, exports) {

let $99338baf720c631d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $99338baf720c631d$var$load("ceFJG").then(()=>parcelRequire('hGdJB'));

});

parcelRegister("3ErTd", function(module, exports) {

let $2a8abdd5ce718bb8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2a8abdd5ce718bb8$var$load("gWoS8").then(()=>parcelRequire('k7ycj'));

});

parcelRegister("bTKVU", function(module, exports) {

let $8a993cb0c7921ad9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8a993cb0c7921ad9$var$load("028DY").then(()=>parcelRequire('d13LS'));

});

parcelRegister("1gayH", function(module, exports) {

let $0eaf79c8220ebd14$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0eaf79c8220ebd14$var$load("9AwZN").then(()=>parcelRequire('3MYNr'));

});

parcelRegister("l2Qc7", function(module, exports) {

let $f522459c3f842e5c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f522459c3f842e5c$var$load("aIIfK").then(()=>parcelRequire('0SEC4'));

});

parcelRegister("5AhoA", function(module, exports) {

let $410dceef3e02cf4e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $410dceef3e02cf4e$var$load("2mCh0").then(()=>parcelRequire('6x3qp'));

});

parcelRegister("dl7x4", function(module, exports) {

let $9b63144c8d977daa$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9b63144c8d977daa$var$load("gRxLC").then(()=>parcelRequire('ikEep'));

});

parcelRegister("5Dj6w", function(module, exports) {

let $419f69f5b9db9671$var$load = (parcelRequire("28QjX"))(4);
module.exports = $419f69f5b9db9671$var$load("aLPaU").then(()=>parcelRequire('dWCbM'));

});

parcelRegister("cXnTz", function(module, exports) {

let $96ed87d0b5161e25$var$load = (parcelRequire("28QjX"))(4);
module.exports = $96ed87d0b5161e25$var$load("2ZXSE").then(()=>parcelRequire('78Ixk'));

});

parcelRegister("2wwF1", function(module, exports) {

let $1d67e7a45bb81a0a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1d67e7a45bb81a0a$var$load("lxVIs").then(()=>parcelRequire('lqMyv'));

});

parcelRegister("5Z5p4", function(module, exports) {

let $45b6d73b8ca8211b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $45b6d73b8ca8211b$var$load("fAXAS").then(()=>parcelRequire('fOWVz'));

});

parcelRegister("4KAD4", function(module, exports) {

let $3757df1b6e5e6d0a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3757df1b6e5e6d0a$var$load("4EGeh").then(()=>parcelRequire('kJ0ub'));

});

parcelRegister("78r0R", function(module, exports) {

let $531e3bf7d3792320$var$load = (parcelRequire("28QjX"))(4);
module.exports = $531e3bf7d3792320$var$load("9QLe6").then(()=>parcelRequire('81D1R'));

});

parcelRegister("4Vydu", function(module, exports) {

let $39670701a278cdde$var$load = (parcelRequire("28QjX"))(4);
module.exports = $39670701a278cdde$var$load("4Q9TT").then(()=>parcelRequire('b1Ktt'));

});

parcelRegister("gSLar", function(module, exports) {

let $c4a646ef2e52ca0e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c4a646ef2e52ca0e$var$load("22ysp").then(()=>parcelRequire('i2ZZH'));

});

parcelRegister("f5PpQ", function(module, exports) {

let $afcf34c04a06d28b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $afcf34c04a06d28b$var$load("elIsG").then(()=>parcelRequire('L1jsC'));

});

parcelRegister("bSLYR", function(module, exports) {

let $8a69f4c9cd0b51a5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8a69f4c9cd0b51a5$var$load("2E4ld").then(()=>parcelRequire('1oLcf'));

});

parcelRegister("7p4ki", function(module, exports) {

let $563e3958c706e954$var$load = (parcelRequire("28QjX"))(4);
module.exports = $563e3958c706e954$var$load("2Zzfw").then(()=>parcelRequire('logiG'));

});

parcelRegister("1h7XV", function(module, exports) {

let $0edd8ebdd8c007e9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0edd8ebdd8c007e9$var$load("8o247").then(()=>parcelRequire('testz'));

});

parcelRegister("h2CZ2", function(module, exports) {

let $c680dcde44edffb0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c680dcde44edffb0$var$load("6hrDj").then(()=>parcelRequire('cpIwi'));

});

parcelRegister("6dsdF", function(module, exports) {

let $4869d8c54ace3602$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4869d8c54ace3602$var$load("izKEg").then(()=>parcelRequire('lhTOm'));

});

parcelRegister("57ryt", function(module, exports) {

let $3ba2fb11e3ed0933$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3ba2fb11e3ed0933$var$load("9RrrU").then(()=>parcelRequire('3W0Gc'));

});

parcelRegister("b7xj2", function(module, exports) {

let $818a2f07c87190a3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $818a2f07c87190a3$var$load("Qa2rE").then(()=>parcelRequire('04635'));

});

parcelRegister("cJiRC", function(module, exports) {

let $944851fdaa74d560$var$load = (parcelRequire("28QjX"))(4);
module.exports = $944851fdaa74d560$var$load("3EROv").then(()=>parcelRequire('8JP8k'));

});

parcelRegister("imA3a", function(module, exports) {

let $d5e63ed85ec56b61$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d5e63ed85ec56b61$var$load("7PAJc").then(()=>parcelRequire('aszuD'));

});

parcelRegister("4hl0b", function(module, exports) {

let $31d90a87c19786ef$var$load = (parcelRequire("28QjX"))(4);
module.exports = $31d90a87c19786ef$var$load("cG6Ty").then(()=>parcelRequire('9EZ4t'));

});

parcelRegister("70URh", function(module, exports) {

let $51b4a360d43a5802$var$load = (parcelRequire("28QjX"))(4);
module.exports = $51b4a360d43a5802$var$load("e1yw0").then(()=>parcelRequire('kDk0L'));

});

parcelRegister("7hRVq", function(module, exports) {

let $54e3f35bb442e2dc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $54e3f35bb442e2dc$var$load("ayiuS").then(()=>parcelRequire('eCSUq'));

});

parcelRegister("aovGA", function(module, exports) {

let $7914b96fe2c7e205$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7914b96fe2c7e205$var$load("bFXwq").then(()=>parcelRequire('4gKfo'));

});


parcelRegister("a0X9c", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $6a9ce369e7a17aa9$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $bVbzx = parcelRequire("bVbzx");

var $euiLX = parcelRequire("euiLX");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6a9ce369e7a17aa9$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;






























const $6a9ce369e7a17aa9$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $euiLX.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("l2Cdx")));
        case 'da':
            return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("iaZ2W")));
        case 'de':
            return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("jxoKF")));
        case 'en-GB':
            return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("cACE4")));
        case 'en-US':
            return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("60Fwu")));
        case 'en-XA':
            return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("hyhkl")));
        case 'en-XB':
            return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("5LkDm")));
        case 'en-ZZ':
            return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("9iq0Y")));
        case 'en':
            return $6a9ce369e7a17aa9$var$importHelper(await Promise.resolve((parcelRequire("bVbzx"))));
        case 'es':
            return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("8RK77")));
        case 'et':
            return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("ga1mh")));
        case 'fi':
            return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("35oY5")));
        case 'fr':
            return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("218Yb")));
        case 'hu':
            return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("3igRj")));
        case 'it':
            return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("ghWqO")));
        case 'ja':
            return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("9aODp")));
        case 'ko':
            return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("5HKoC")));
        case 'nb':
            return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("5ya2p")));
        case 'nl':
            return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("1iSGp")));
        case 'pl':
            return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("64RJa")));
        case 'pt-BR':
            return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("7Cbur")));
        case 'ro':
            return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("5UzVW")));
        case 'ru':
            return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("b8e7y")));
        case 'sv':
            return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("cLTCi")));
        case 'th':
            return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("bPrk8")));
        case 'tr':
            return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("aT0RF")));
        case 'uk':
            return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("awfjq")));
        case 'vi':
            return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("SNm6B")));
        case 'zh-CN':
            return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("cam0a")));
        case 'zh-TW':
            return $6a9ce369e7a17aa9$var$importHelper(await (parcelRequire("gHdMV")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($bVbzx));
    }
};

});
parcelRegister("bVbzx", function(module, exports) {
module.exports = JSON.parse("{}");

});

parcelRegister("l2Cdx", function(module, exports) {

let $f5176e0e3089588f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f5176e0e3089588f$var$load("k2lsy").then(()=>parcelRequire('8mqjG'));

});

parcelRegister("iaZ2W", function(module, exports) {

let $d3b883b173f5ae21$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d3b883b173f5ae21$var$load("2rakl").then(()=>parcelRequire('jMhDj'));

});

parcelRegister("jxoKF", function(module, exports) {

let $e3944c936d4ed9de$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e3944c936d4ed9de$var$load("tr1BO").then(()=>parcelRequire('37saP'));

});

parcelRegister("cACE4", function(module, exports) {

let $92a6d2f6ab637bf2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $92a6d2f6ab637bf2$var$load("hYF3d").then(()=>parcelRequire('ih0Zd'));

});

parcelRegister("60Fwu", function(module, exports) {

let $4602f3c0541b9cad$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4602f3c0541b9cad$var$load("4LtLU").then(()=>parcelRequire('7glfV'));

});

parcelRegister("hyhkl", function(module, exports) {

let $cc730d75febc69d9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cc730d75febc69d9$var$load("78EgZ").then(()=>parcelRequire('7vTP9'));

});

parcelRegister("5LkDm", function(module, exports) {

let $432158f9a65ad028$var$load = (parcelRequire("28QjX"))(4);
module.exports = $432158f9a65ad028$var$load("gmQK3").then(()=>parcelRequire('6TjtY'));

});

parcelRegister("9iq0Y", function(module, exports) {

let $6c49f978bddf65d1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6c49f978bddf65d1$var$load("2LfJa").then(()=>parcelRequire('4oNEQ'));

});

parcelRegister("8RK77", function(module, exports) {

let $67470b3848f52292$var$load = (parcelRequire("28QjX"))(4);
module.exports = $67470b3848f52292$var$load("li9ds").then(()=>parcelRequire('kyM33'));

});

parcelRegister("ga1mh", function(module, exports) {

let $bc3ea23d72da26a3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bc3ea23d72da26a3$var$load("lPLGF").then(()=>parcelRequire('6bkWH'));

});

parcelRegister("35oY5", function(module, exports) {

let $23f534e5dfeec4ef$var$load = (parcelRequire("28QjX"))(4);
module.exports = $23f534e5dfeec4ef$var$load("4g7Zk").then(()=>parcelRequire('aoAHS'));

});

parcelRegister("218Yb", function(module, exports) {

let $1782a1f607aef127$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1782a1f607aef127$var$load("f7nNi").then(()=>parcelRequire('3MBkB'));

});

parcelRegister("3igRj", function(module, exports) {

let $2660216114d65425$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2660216114d65425$var$load("5cAsx").then(()=>parcelRequire('5pE8G'));

});

parcelRegister("ghWqO", function(module, exports) {

let $bdbb8f20c6ba3d1d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bdbb8f20c6ba3d1d$var$load("f2lZA").then(()=>parcelRequire('as6ve'));

});

parcelRegister("9aODp", function(module, exports) {

let $6adc5337376e61a5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6adc5337376e61a5$var$load("aCNiO").then(()=>parcelRequire('fPj8Q'));

});

parcelRegister("5HKoC", function(module, exports) {

let $4274f535330b907d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4274f535330b907d$var$load("eyC2i").then(()=>parcelRequire('3wJyD'));

});

parcelRegister("5ya2p", function(module, exports) {

let $40a7ea0e871dc9bb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $40a7ea0e871dc9bb$var$load("31UEQ").then(()=>parcelRequire('ephQP'));

});

parcelRegister("1iSGp", function(module, exports) {

let $0f31e3ced690cb2f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0f31e3ced690cb2f$var$load("hlDVC").then(()=>parcelRequire('lsvvG'));

});

parcelRegister("64RJa", function(module, exports) {

let $46cccaf9ba02dc20$var$load = (parcelRequire("28QjX"))(4);
module.exports = $46cccaf9ba02dc20$var$load("6eaQM").then(()=>parcelRequire('eX12q'));

});

parcelRegister("7Cbur", function(module, exports) {

let $58b4feb2eb1e70f5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $58b4feb2eb1e70f5$var$load("hTS6V").then(()=>parcelRequire('dFIAI'));

});

parcelRegister("5UzVW", function(module, exports) {

let $44de0e57079efa0f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $44de0e57079efa0f$var$load("2xmjH").then(()=>parcelRequire('jZfiR'));

});

parcelRegister("b8e7y", function(module, exports) {

let $81ab652b73a150ae$var$load = (parcelRequire("28QjX"))(4);
module.exports = $81ab652b73a150ae$var$load("lmTTI").then(()=>parcelRequire('9afPo'));

});

parcelRegister("cLTCi", function(module, exports) {

let $94c5041f1067bc93$var$load = (parcelRequire("28QjX"))(4);
module.exports = $94c5041f1067bc93$var$load("ambg9").then(()=>parcelRequire('daUsC'));

});

parcelRegister("bPrk8", function(module, exports) {

let $89c9a70bbdff6c8f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $89c9a70bbdff6c8f$var$load("054RK").then(()=>parcelRequire('ei7L7'));

});

parcelRegister("aT0RF", function(module, exports) {

let $7ecfb620e20e4bfc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7ecfb620e20e4bfc$var$load("31JZC").then(()=>parcelRequire('ahyTy'));

});

parcelRegister("awfjq", function(module, exports) {

let $7a88c543fe106972$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7a88c543fe106972$var$load("6MqYI").then(()=>parcelRequire('c14L5'));

});

parcelRegister("SNm6B", function(module, exports) {

let $0a4b543e02241d98$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0a4b543e02241d98$var$load("8NkP2").then(()=>parcelRequire('7zIUv'));

});

parcelRegister("cam0a", function(module, exports) {

let $8db77c4ed8a75718$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8db77c4ed8a75718$var$load("iaT2M").then(()=>parcelRequire('aw2dk'));

});

parcelRegister("gHdMV", function(module, exports) {

let $c27b5b8b9d8e6a65$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c27b5b8b9d8e6a65$var$load("9bNeM").then(()=>parcelRequire('iy5Tj'));

});


parcelRegister("bzVGB", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $6d83e89f7c1b674c$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $hHLNC = parcelRequire("hHLNC");

var $euiLX = parcelRequire("euiLX");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6d83e89f7c1b674c$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;






























const $6d83e89f7c1b674c$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $euiLX.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $6d83e89f7c1b674c$var$importHelper(await (parcelRequire("dtaRT")));
        case 'da':
            return $6d83e89f7c1b674c$var$importHelper(await (parcelRequire("juRQo")));
        case 'de':
            return $6d83e89f7c1b674c$var$importHelper(await (parcelRequire("lwVKI")));
        case 'en-GB':
            return $6d83e89f7c1b674c$var$importHelper(await (parcelRequire("6NMzh")));
        case 'en-US':
            return $6d83e89f7c1b674c$var$importHelper(await (parcelRequire("auS4f")));
        case 'en-XA':
            return $6d83e89f7c1b674c$var$importHelper(await (parcelRequire("a4dZB")));
        case 'en-XB':
            return $6d83e89f7c1b674c$var$importHelper(await (parcelRequire("bbahk")));
        case 'en-ZZ':
            return $6d83e89f7c1b674c$var$importHelper(await (parcelRequire("iESsE")));
        case 'en':
            return $6d83e89f7c1b674c$var$importHelper(await Promise.resolve((parcelRequire("hHLNC"))));
        case 'es':
            return $6d83e89f7c1b674c$var$importHelper(await (parcelRequire("hu3gS")));
        case 'et':
            return $6d83e89f7c1b674c$var$importHelper(await (parcelRequire("b0aP5")));
        case 'fi':
            return $6d83e89f7c1b674c$var$importHelper(await (parcelRequire("1cQDk")));
        case 'fr':
            return $6d83e89f7c1b674c$var$importHelper(await (parcelRequire("5T1rE")));
        case 'hu':
            return $6d83e89f7c1b674c$var$importHelper(await (parcelRequire("4UT4h")));
        case 'it':
            return $6d83e89f7c1b674c$var$importHelper(await (parcelRequire("6rP8Z")));
        case 'ja':
            return $6d83e89f7c1b674c$var$importHelper(await (parcelRequire("f6afI")));
        case 'ko':
            return $6d83e89f7c1b674c$var$importHelper(await (parcelRequire("iMkvY")));
        case 'nb':
            return $6d83e89f7c1b674c$var$importHelper(await (parcelRequire("cWZ46")));
        case 'nl':
            return $6d83e89f7c1b674c$var$importHelper(await (parcelRequire("kDp26")));
        case 'pl':
            return $6d83e89f7c1b674c$var$importHelper(await (parcelRequire("iEwwJ")));
        case 'pt-BR':
            return $6d83e89f7c1b674c$var$importHelper(await (parcelRequire("d7ssH")));
        case 'ro':
            return $6d83e89f7c1b674c$var$importHelper(await (parcelRequire("kwnpv")));
        case 'ru':
            return $6d83e89f7c1b674c$var$importHelper(await (parcelRequire("dAJvA")));
        case 'sv':
            return $6d83e89f7c1b674c$var$importHelper(await (parcelRequire("d3nty")));
        case 'th':
            return $6d83e89f7c1b674c$var$importHelper(await (parcelRequire("hGYXL")));
        case 'tr':
            return $6d83e89f7c1b674c$var$importHelper(await (parcelRequire("52kEb")));
        case 'uk':
            return $6d83e89f7c1b674c$var$importHelper(await (parcelRequire("6hoMk")));
        case 'vi':
            return $6d83e89f7c1b674c$var$importHelper(await (parcelRequire("j106G")));
        case 'zh-CN':
            return $6d83e89f7c1b674c$var$importHelper(await (parcelRequire("9Bn29")));
        case 'zh-TW':
            return $6d83e89f7c1b674c$var$importHelper(await (parcelRequire("kR2gF")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($hHLNC));
    }
};

});
parcelRegister("hHLNC", function(module, exports) {
module.exports = JSON.parse("{\"got-it\":[{\"type\":0,\"value\":\"Got it\"}],\"mercury.email.footer.sent-by\":[{\"type\":0,\"value\":\"This message was sent to you by Atlassian Focus\"}],\"mercury.email.footer.unsubscribe\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"mercury.focus-areas.arrow-icon.alt\":[{\"type\":0,\"value\":\"arrow-icon\"}],\"mercury.focus-areas.arrow-right-icon.alt\":[{\"type\":0,\"value\":\"arrow-right-icon\"}],\"mercury.focus-areas.calendar-icon.alt\":[{\"type\":0,\"value\":\"calendar-icon\"}],\"mercury.focus-areas.date-changed\":[{\"type\":0,\"value\":\"Date Changed\"}],\"mercury.focus-areas.focus-area.alt\":[{\"type\":0,\"value\":\"focus-area-icon\"}],\"mercury.focus-areas.focus-footer.alt\":[{\"type\":0,\"value\":\"Atlassian footer\"}],\"mercury.focus-areas.focus-icon.alt\":[{\"type\":0,\"value\":\"Focus area icon\"}],\"mercury.focus-areas.for\":[{\"type\":0,\"value\":\"for\"}],\"mercury.focus-areas.heading\":[{\"type\":0,\"value\":\"You're following \"},{\"type\":1,\"value\":\"total\"},{\"type\":0,\"value\":\" active focus areas, here's the breakdown.\"}],\"mercury.focus-areas.no-target-date.alt\":[{\"type\":0,\"value\":\"No target date set\"}],\"mercury.focus-areas.status-changed\":[{\"type\":0,\"value\":\"Status changed\"}],\"mercury.focus-areas.view-area\":[{\"type\":0,\"value\":\"View Focus Area\"}],\"mercury.focus.catch.up.link\":[{\"type\":0,\"value\":\"Jump into Atlassian Focus\"}],\"mercury.focus.catch.up.text\":[{\"type\":0,\"value\":\"Want to catch up on previous updates? \"},{\"type\":1,\"value\":\"link\"}],\"mercury.mercury-monthly-digest.message-template.email.subject.no-translate\":[{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\", here are your monthly focus area updates\"}],\"mercury.message-templates.edit-focus-area-heirarchy-spotlight-body\":[{\"type\":0,\"value\":\"Whenever you need to make changes to your hierarchy you can do so from settings.\"}],\"mercury.message-templates.edit-focus-area-heirarchy-spotlight-heading\":[{\"type\":0,\"value\":\"Edit your focus area hierarchy\"}]}");

});

parcelRegister("dtaRT", function(module, exports) {

let $9ce66a0510ac0e00$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9ce66a0510ac0e00$var$load("eycNO").then(()=>parcelRequire('3qZK6'));

});

parcelRegister("juRQo", function(module, exports) {

let $e31a95fa6f991d15$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e31a95fa6f991d15$var$load("2rSfW").then(()=>parcelRequire('93A4c'));

});

parcelRegister("lwVKI", function(module, exports) {

let $fac96294bcc6924d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fac96294bcc6924d$var$load("cvrnG").then(()=>parcelRequire('hOG2X'));

});

parcelRegister("6NMzh", function(module, exports) {

let $4f3cfe4c94d26767$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4f3cfe4c94d26767$var$load("iDv2L").then(()=>parcelRequire('euapc'));

});

parcelRegister("auS4f", function(module, exports) {

let $01f8e1a2a840313d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $01f8e1a2a840313d$var$load("dYNme").then(()=>parcelRequire('k1b6w'));

});

parcelRegister("a4dZB", function(module, exports) {

let $754521bbed4ae1f2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $754521bbed4ae1f2$var$load("1VyfL").then(()=>parcelRequire('2P8K7'));

});

parcelRegister("bbahk", function(module, exports) {

let $8238b1e0c95a9c4a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8238b1e0c95a9c4a$var$load("eNrOy").then(()=>parcelRequire('eGg7H'));

});

parcelRegister("iESsE", function(module, exports) {

let $038163f4c6cfc682$var$load = (parcelRequire("28QjX"))(4);
module.exports = $038163f4c6cfc682$var$load("izW66").then(()=>parcelRequire('kcxr2'));

});

parcelRegister("hu3gS", function(module, exports) {

let $cba7c69bcc3e5393$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cba7c69bcc3e5393$var$load("qQ47x").then(()=>parcelRequire('laHIt'));

});

parcelRegister("b0aP5", function(module, exports) {

let $80281704b51223ad$var$load = (parcelRequire("28QjX"))(4);
module.exports = $80281704b51223ad$var$load("5sNZk").then(()=>parcelRequire('cAzBm'));

});

parcelRegister("1cQDk", function(module, exports) {

let $0e0fbd53b39d4064$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0e0fbd53b39d4064$var$load("jqTTu").then(()=>parcelRequire('g8hh0'));

});

parcelRegister("5T1rE", function(module, exports) {

let $449335b9d46afdd3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $449335b9d46afdd3$var$load("dQZmS").then(()=>parcelRequire('jSVtg'));

});

parcelRegister("4UT4h", function(module, exports) {

let $39471bbc07571fb6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $39471bbc07571fb6$var$load("blBkC").then(()=>parcelRequire('5BFfD'));

});

parcelRegister("6rP8Z", function(module, exports) {

let $4b1cefd558020c84$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4b1cefd558020c84$var$load("dwkwk").then(()=>parcelRequire('1mfCA'));

});

parcelRegister("f6afI", function(module, exports) {

let $afdf5e79b72005f9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $afdf5e79b72005f9$var$load("ajByh").then(()=>parcelRequire('kz89i'));

});

parcelRegister("iMkvY", function(module, exports) {

let $dabc9f7ec9e13032$var$load = (parcelRequire("28QjX"))(4);
module.exports = $dabc9f7ec9e13032$var$load("8V6dt").then(()=>parcelRequire('4C3cU'));

});

parcelRegister("cWZ46", function(module, exports) {

let $96da4519963f0acf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $96da4519963f0acf$var$load("jFdMn").then(()=>parcelRequire('ev6yZ'));

});

parcelRegister("kDp26", function(module, exports) {

let $03e06ef0373780c6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $03e06ef0373780c6$var$load("g7vuZ").then(()=>parcelRequire('j9knx'));

});

parcelRegister("iEwwJ", function(module, exports) {

let $d94531980382b32e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d94531980382b32e$var$load("aIi7n").then(()=>parcelRequire('03Ycj'));

});

parcelRegister("d7ssH", function(module, exports) {

let $98d201bce4868735$var$load = (parcelRequire("28QjX"))(4);
module.exports = $98d201bce4868735$var$load("hhmED").then(()=>parcelRequire('vszuE'));

});

parcelRegister("kwnpv", function(module, exports) {

let $ef08f49f8bf5bed6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ef08f49f8bf5bed6$var$load("jEfvs").then(()=>parcelRequire('e4KAb'));

});

parcelRegister("dAJvA", function(module, exports) {

let $9e51f03684955d08$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9e51f03684955d08$var$load("kt0sJ").then(()=>parcelRequire('lRQj5'));

});

parcelRegister("d3nty", function(module, exports) {

let $980dc3eecefd1e5a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $980dc3eecefd1e5a$var$load("aqVlS").then(()=>parcelRequire('efnA2'));

});

parcelRegister("hGYXL", function(module, exports) {

let $ce15a5e2017ea6df$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ce15a5e2017ea6df$var$load("6Wpyb").then(()=>parcelRequire('jDOYo'));

});

parcelRegister("52kEb", function(module, exports) {

let $3aad27ba9674c4a1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3aad27ba9674c4a1$var$load("eafRu").then(()=>parcelRequire('2xlV5'));

});

parcelRegister("6hoMk", function(module, exports) {

let $49278d1ad3c9d932$var$load = (parcelRequire("28QjX"))(4);
module.exports = $49278d1ad3c9d932$var$load("dj01M").then(()=>parcelRequire('9uPIH'));

});

parcelRegister("j106G", function(module, exports) {

let $dd7e318122ca7b61$var$load = (parcelRequire("28QjX"))(4);
module.exports = $dd7e318122ca7b61$var$load("evtN0").then(()=>parcelRequire('iVOG8'));

});

parcelRegister("9Bn29", function(module, exports) {

let $6fd96fc677cb3f95$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6fd96fc677cb3f95$var$load("3W0F3").then(()=>parcelRequire('eITgL'));

});

parcelRegister("kR2gF", function(module, exports) {

let $f2ea843c8d38e40e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f2ea843c8d38e40e$var$load("ly7Bv").then(()=>parcelRequire('6owjL'));

});


parcelRegister("ccMmr", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $0e1b7175a65b8346$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $btrK6 = parcelRequire("btrK6");

var $euiLX = parcelRequire("euiLX");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0e1b7175a65b8346$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;






























const $0e1b7175a65b8346$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $euiLX.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("1oYBf")));
        case 'da':
            return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("8sbNB")));
        case 'de':
            return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("4sThg")));
        case 'en-GB':
            return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("10x60")));
        case 'en-US':
            return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("7Mkg2")));
        case 'en-XA':
            return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("dNzRF")));
        case 'en-XB':
            return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("clPzz")));
        case 'en-ZZ':
            return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("i1vpX")));
        case 'en':
            return $0e1b7175a65b8346$var$importHelper(await Promise.resolve((parcelRequire("btrK6"))));
        case 'es':
            return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("04S2Q")));
        case 'et':
            return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("hj7Pi")));
        case 'fi':
            return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("1beAq")));
        case 'fr':
            return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("4xsHf")));
        case 'hu':
            return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("7F4Eh")));
        case 'it':
            return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("5uxYW")));
        case 'ja':
            return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("lv7s6")));
        case 'ko':
            return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("itqWg")));
        case 'nb':
            return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("iFSqm")));
        case 'nl':
            return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("erdOc")));
        case 'pl':
            return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("4AEtK")));
        case 'pt-BR':
            return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("llFkm")));
        case 'ro':
            return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("c5UKz")));
        case 'ru':
            return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("052qn")));
        case 'sv':
            return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("jlnGg")));
        case 'th':
            return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("NVmwo")));
        case 'tr':
            return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("b7lRT")));
        case 'uk':
            return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("kV1Nv")));
        case 'vi':
            return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("cyqaW")));
        case 'zh-CN':
            return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("avNxc")));
        case 'zh-TW':
            return $0e1b7175a65b8346$var$importHelper(await (parcelRequire("464Jj")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($btrK6));
    }
};

});
parcelRegister("btrK6", function(module, exports) {
module.exports = JSON.parse('{"app.accept":[{"type":0,"value":"Accept"}],"app.reject":[{"type":0,"value":"Reject"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.message-template-template.email.body.img.alt":[{"type":0,"value":"Description of image"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"ecosystem-forge-apps.ecosystem-forge-apps-in-app.hello-world":[{"type":0,"value":"Hello "},{"type":1,"value":"propA"},{"type":0,"value":". Is is a lovely "},{"type":1,"value":"propB"}],"jira.jira-project-pages-gdrive-deprecation.message-template.email.subject":[{"type":0,"value":"Google Drive will no longer be supported in Jira Project Pages"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-1":[{"type":0,"value":"We\'re reaching out to notify you that from April 23rd 2024, syncing Google Drive shared drives will no longer be supported in Project Pages for the users in your site. Users will no longer be able to access their shared drives Jira as we are removing the feature, but they will still be able to sync Confluence spaces to Jira."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-2":[{"type":0,"value":"Please note that we are not deleting any data within Google Drive itself. The change only affects the ability to sync, link, and access Google Shared Drives from Jira."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-3":[{"type":0,"value":"This is part of our ongoing efforts to streamline our services and ensure the highest quality experience for our users."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-4":[{"type":0,"value":"Next steps:"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-5":[{"type":0,"value":"We are committed to providing you with the best possible experience, and appreciate your understanding as we make these necessary improvements. Thank you for your continued support."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body.list-1":[{"type":0,"value":"No immediate action is required from your end regarding this deprecation. However, we understand that this change may impact your workflow, and we are here to support you through this transition."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body.list-3":[{"type":0,"value":"For any feedback, or further questions and assistance with change management, please contact jnguyen2@atlassian.com"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.greeting":[{"type":0,"value":"Dear Admin,"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.title":[{"type":0,"value":"Google Drive will no longer be supported in Jira Project Pages"}],"jira.jira-weekly-digest.message-template.email.subject":[{"type":0,"value":"Your weekly digest for Jira project: "},{"type":1,"value":"projectName"}],"jira.jira-weekly-digest.test-message.email.body.lastSevenDaysIssuesCompletion":[{"type":0,"value":"issues completed in the past week"}],"jira.jira-weekly-digest.test-message.email.body.lastSevenDaysIssuesCreated":[{"type":0,"value":"issues created in the past week"}],"jira.jira-weekly-digest.test-message.email.body.lastSevenDaysIssuesUpdated":[{"type":0,"value":"issues updated in the past week"}],"jira.jira-weekly-digest.test-message.email.body.plusSign":[{"type":0,"value":"+"}],"jira.jira-weekly-digest.test-message.email.header":[{"type":0,"value":"Here\'s your weekly digest for Jira ("},{"type":1,"value":"projectName"},{"type":0,"value":") over the past week"}],"jira.jira-weekly-digest.test-message.email.headerDescription":[{"type":0,"value":"You\u2019re receiving this email because you have opted in to receive weekly updates for this project in Jira."}],"jira.jira-weekly-digest.test-message.email.playbookBodyText":[{"type":0,"value":"Atlassian Playbook"}],"jira.jira-weekly-digest.test-message.email.playbookHeader":[{"type":0,"value":"Has your team conducted a retrospective recently?"}],"jira.jira-weekly-digest.test-message.email.playbookSubheader":[{"type":0,"value":"A retrospective gives you an opportunity to review your latest project progress and make improvements for the future. Find out more at "},{"type":1,"value":"link"},{"type":0,"value":"."}],"jira.jira-weekly-digest.test-message.email.tableHeader":[{"type":0,"value":"Weekly Summary"}],"jira.suppression-email-notification-email.contact-us":[{"type":0,"value":"contact us"}],"jira.suppression-email-notification-email.email.body":[{"type":0,"value":"This is an automatated message to notify you that the jira "},{"type":1,"value":"emailType"},{"type":0,"value":" email \\n\\t\\t\\t\\t\\t\\tto "},{"type":1,"value":"affectedUserEmail"},{"type":0,"value":" has been suppressed. Please visit this "},{"type":1,"value":"unsuppressApiLink"},{"type":0,"value":" to unsuppress the user\'s email."}],"jira.suppression-email-notification-email.email.body.goodbye":[{"type":0,"value":"Please "},{"type":1,"value":"contactUsLink"},{"type":0,"value":" if the issue persists, we\'re always happy to help."}],"jira.suppression-email-notification-email.email.body.regards":[{"type":0,"value":"Jira Notifications Team"}],"jira.suppression-email-notification-email.email.body.signoff":[{"type":0,"value":"Regards,"}],"jira.suppression-email-notification-email.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"jira.suppression-email-notification-email.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"jira.suppression-email-notification-email.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"playground.playground-local-execution-message.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"playground.playground-local-execution-message.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"playground.playground-local-execution-message.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hello, fellow child "},{"type":1,"value":"name"},{"type":0,"value":","}],"playground.playground-local-execution-message.test-message.email.body.no-translate":[{"type":0,"value":"We are currently trying to locally execute this message!"}],"playground.playground-local-execution-message.test-message.email.body.regards.no-translate":[{"type":0,"value":"Playground Team"}],"playground.playground-local-execution-message.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"playground.playground-local-execution-message.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"post-office.commerce-common.unsuppress-email-link":[{"type":0,"value":"link"}],"post-office.jira-email.contact-us":[{"type":0,"value":"contact us"}],"post-office.playground.go-faster-techops-rollup-notifier.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.playground.test-playground-message.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"sharc.sharc-tenant-migration-brazil-unpinned.message-template-template.email.body.img.alt":[{"type":0,"value":"Description of image"}],"sharc.sharc-tenant-migration-brazil-unpinned.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}]}');

});

parcelRegister("1oYBf", function(module, exports) {

let $10570a2dd9d658ea$var$load = (parcelRequire("28QjX"))(4);
module.exports = $10570a2dd9d658ea$var$load("kujjl").then(()=>parcelRequire('jSybN'));

});

parcelRegister("8sbNB", function(module, exports) {

let $627a1747aa0a867a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $627a1747aa0a867a$var$load("hNevr").then(()=>parcelRequire('iRglU'));

});

parcelRegister("4sThg", function(module, exports) {

let $3404a7e3d54e14d1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3404a7e3d54e14d1$var$load("bUjWo").then(()=>parcelRequire('4DMt9'));

});

parcelRegister("10x60", function(module, exports) {

let $0bbf76ade878a69b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0bbf76ade878a69b$var$load("8Zfnl").then(()=>parcelRequire('4Ntcv'));

});

parcelRegister("7Mkg2", function(module, exports) {

let $5a9cbadbfdc74ad0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5a9cbadbfdc74ad0$var$load("1Q0fy").then(()=>parcelRequire('liA2E'));

});

parcelRegister("dNzRF", function(module, exports) {

let $a0bbabea963b3de6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a0bbabea963b3de6$var$load("kpJbM").then(()=>parcelRequire('cJsXX'));

});

parcelRegister("clPzz", function(module, exports) {

let $8fdf737e6308c4d0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8fdf737e6308c4d0$var$load("gZpYg").then(()=>parcelRequire('1pDJK'));

});

parcelRegister("i1vpX", function(module, exports) {

let $d1f0b0e3f0339e7f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d1f0b0e3f0339e7f$var$load("iWZHk").then(()=>parcelRequire('tSzJa'));

});

parcelRegister("04S2Q", function(module, exports) {

let $00ea4c078561b3d9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $00ea4c078561b3d9$var$load("29nzt").then(()=>parcelRequire('8Nmv9'));

});

parcelRegister("hj7Pi", function(module, exports) {

let $c99a4830d18e29ff$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c99a4830d18e29ff$var$load("WSq13").then(()=>parcelRequire('jffUe'));

});

parcelRegister("1beAq", function(module, exports) {

let $0dc2221eb044d3ec$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0dc2221eb044d3ec$var$load("l7QKb").then(()=>parcelRequire('lxOjW'));

});

parcelRegister("4xsHf", function(module, exports) {

let $34e08107861f892e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $34e08107861f892e$var$load("bZpxK").then(()=>parcelRequire('83SWF'));

});

parcelRegister("7F4Eh", function(module, exports) {

let $593ff7ddd81dc6b3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $593ff7ddd81dc6b3$var$load("ltctz").then(()=>parcelRequire('feXvC'));

});

parcelRegister("5uxYW", function(module, exports) {

let $3ffa1d2e106ad344$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3ffa1d2e106ad344$var$load("4Ek79").then(()=>parcelRequire('43hwo'));

});

parcelRegister("lv7s6", function(module, exports) {

let $fa724611347c4d42$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fa724611347c4d42$var$load("kvlvl").then(()=>parcelRequire('1sa5w'));

});

parcelRegister("itqWg", function(module, exports) {

let $d72fd4e477141e96$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d72fd4e477141e96$var$load("aKc3I").then(()=>parcelRequire('5vxzP'));

});

parcelRegister("iFSqm", function(module, exports) {

let $d98645d8cfd33f80$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d98645d8cfd33f80$var$load("hTSlI").then(()=>parcelRequire('9NngE'));

});

parcelRegister("erdOc", function(module, exports) {

let $a82e4c65268c1fe5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a82e4c65268c1fe5$var$load("kz9AV").then(()=>parcelRequire('lR9rA'));

});

parcelRegister("4AEtK", function(module, exports) {

let $3579ec7c9a6c3f1d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3579ec7c9a6c3f1d$var$load("g3NNd").then(()=>parcelRequire('2iXPf'));

});

parcelRegister("llFkm", function(module, exports) {

let $f8ab9de7aa8da078$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f8ab9de7aa8da078$var$load("jGERU").then(()=>parcelRequire('7VK3g'));

});

parcelRegister("c5UKz", function(module, exports) {

let $8ce1f90a384e5770$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8ce1f90a384e5770$var$load("5wnOQ").then(()=>parcelRequire('dacr9'));

});

parcelRegister("052qn", function(module, exports) {

let $00f2593668ffe5ea$var$load = (parcelRequire("28QjX"))(4);
module.exports = $00f2593668ffe5ea$var$load("dD4CQ").then(()=>parcelRequire('2PKid'));

});

parcelRegister("jlnGg", function(module, exports) {

let $e15258fc3906f130$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e15258fc3906f130$var$load("lwHqN").then(()=>parcelRequire('g30Fn'));

});

parcelRegister("NVmwo", function(module, exports) {

let $096112aa82eea58c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $096112aa82eea58c$var$load("Jcfps").then(()=>parcelRequire('2kNNC'));

});

parcelRegister("b7lRT", function(module, exports) {

let $81814fc00f0c897c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $81814fc00f0c897c$var$load("kst5l").then(()=>parcelRequire('jI51z'));

});

parcelRegister("kV1Nv", function(module, exports) {

let $f3aa867872366bda$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f3aa867872366bda$var$load("23Unp").then(()=>parcelRequire('kaBqe'));

});

parcelRegister("cyqaW", function(module, exports) {

let $923cf6e4bf09cb01$var$load = (parcelRequire("28QjX"))(4);
module.exports = $923cf6e4bf09cb01$var$load("bnvf0").then(()=>parcelRequire('8bn0J'));

});

parcelRegister("avNxc", function(module, exports) {

let $7a733926040a6c04$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7a733926040a6c04$var$load("9VtXW").then(()=>parcelRequire('5vCyS'));

});

parcelRegister("464Jj", function(module, exports) {

let $2fbb643b3910bdc5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2fbb643b3910bdc5$var$load("8df9C").then(()=>parcelRequire('iRkAG'));

});


parcelRegister("fX5Co", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $c1641b7700c86788$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $jiIpQ = parcelRequire("jiIpQ");

var $euiLX = parcelRequire("euiLX");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c1641b7700c86788$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;






























const $c1641b7700c86788$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $euiLX.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $c1641b7700c86788$var$importHelper(await (parcelRequire("l3kWz")));
        case 'da':
            return $c1641b7700c86788$var$importHelper(await (parcelRequire("f5aG4")));
        case 'de':
            return $c1641b7700c86788$var$importHelper(await (parcelRequire("2ybtD")));
        case 'en-GB':
            return $c1641b7700c86788$var$importHelper(await (parcelRequire("7rl0P")));
        case 'en-US':
            return $c1641b7700c86788$var$importHelper(await (parcelRequire("81EVB")));
        case 'en-XA':
            return $c1641b7700c86788$var$importHelper(await (parcelRequire("fWw6w")));
        case 'en-XB':
            return $c1641b7700c86788$var$importHelper(await (parcelRequire("bCcrQ")));
        case 'en-ZZ':
            return $c1641b7700c86788$var$importHelper(await (parcelRequire("1stz6")));
        case 'en':
            return $c1641b7700c86788$var$importHelper(await Promise.resolve((parcelRequire("jiIpQ"))));
        case 'es':
            return $c1641b7700c86788$var$importHelper(await (parcelRequire("eiyGo")));
        case 'et':
            return $c1641b7700c86788$var$importHelper(await (parcelRequire("dwEdb")));
        case 'fi':
            return $c1641b7700c86788$var$importHelper(await (parcelRequire("81Xg4")));
        case 'fr':
            return $c1641b7700c86788$var$importHelper(await (parcelRequire("fEHyt")));
        case 'hu':
            return $c1641b7700c86788$var$importHelper(await (parcelRequire("c3oji")));
        case 'it':
            return $c1641b7700c86788$var$importHelper(await (parcelRequire("g4pkP")));
        case 'ja':
            return $c1641b7700c86788$var$importHelper(await (parcelRequire("gtxVN")));
        case 'ko':
            return $c1641b7700c86788$var$importHelper(await (parcelRequire("Jq5Y3")));
        case 'nb':
            return $c1641b7700c86788$var$importHelper(await (parcelRequire("5Mvxv")));
        case 'nl':
            return $c1641b7700c86788$var$importHelper(await (parcelRequire("cl6QV")));
        case 'pl':
            return $c1641b7700c86788$var$importHelper(await (parcelRequire("7jxH6")));
        case 'pt-BR':
            return $c1641b7700c86788$var$importHelper(await (parcelRequire("4ctjV")));
        case 'ro':
            return $c1641b7700c86788$var$importHelper(await (parcelRequire("czjwi")));
        case 'ru':
            return $c1641b7700c86788$var$importHelper(await (parcelRequire("fj4jm")));
        case 'sv':
            return $c1641b7700c86788$var$importHelper(await (parcelRequire("jQNTn")));
        case 'th':
            return $c1641b7700c86788$var$importHelper(await (parcelRequire("lxFrZ")));
        case 'tr':
            return $c1641b7700c86788$var$importHelper(await (parcelRequire("k60Ko")));
        case 'uk':
            return $c1641b7700c86788$var$importHelper(await (parcelRequire("dFgAQ")));
        case 'vi':
            return $c1641b7700c86788$var$importHelper(await (parcelRequire("g2kvA")));
        case 'zh-CN':
            return $c1641b7700c86788$var$importHelper(await (parcelRequire("jtBAb")));
        case 'zh-TW':
            return $c1641b7700c86788$var$importHelper(await (parcelRequire("c6LKL")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($jiIpQ));
    }
};

});
parcelRegister("jiIpQ", function(module, exports) {
module.exports = JSON.parse('{"feedback-collector.can-be-enrolled-label.text":[{"type":0,"value":"Atlassian can contact me about this feedback. See our"},{"type":1,"value":"nbsp"},{"children":[{"type":0,"value":"privacy policy"}],"type":8,"value":"privacyPolicyLink"}],"feedback-collector.enroll-in-research-label.text":[{"type":0,"value":"I\'d like to help improve Atlassian products by joining the"},{"type":1,"value":"nbsp"},{"type":1,"value":"n"},{"type":1,"value":"t"},{"type":1,"value":"t"},{"children":[{"type":0,"value":"Atlassian Research Group"}],"type":8,"value":"enrollLink"}],"feedback-collector.feedback-title-details.component":[{"type":0,"value":"For help with billing or other issues, visit our"},{"type":1,"value":"nbsp"},{"children":[{"type":0,"value":"documentation"}],"type":8,"value":"documentationLink"},{"type":1,"value":"nbsp"},{"type":0,"value":"or contact"},{"type":1,"value":"nbsp"},{"children":[{"type":0,"value":"support"}],"type":8,"value":"supportLink"}],"no-notifications-fallback.learn-more-link.text":[{"type":0,"value":"Learn more about this feature"}],"no-notifications-fallback.no-notifications.text":[{"type":0,"value":"Check back soon. No notifications yet."}],"notifications.error-fallback-error-reason.text":[{"type":0,"value":"We\'re unable to load notifications"}],"notifications.error-fallback-proposed-solution.text":[{"type":0,"value":"Refresh the page or try again later"}],"post-office-team.confluence-recommended-following-feed.add-comment-button":[{"type":0,"value":"Comment"}],"post-office-team.confluence-recommended-following-feed.add-emoji-button-alt-text":[{"type":0,"value":"Add Emoji"}],"post-office-team.confluence-recommended-following-feed.atlassian-logo":[{"type":0,"value":"Atlassian Logo"}],"post-office-team.confluence-recommended-following-feed.blog-icon":[{"type":0,"value":"Blog icon"}],"post-office-team.confluence-recommended-following-feed.clap-button-alt-text":[{"type":0,"value":"Clap"}],"post-office-team.confluence-recommended-following-feed.database-icon":[{"type":0,"value":"Database icon"}],"post-office-team.confluence-recommended-following-feed.email-unsubscribe-text":[{"children":[{"type":0,"value":"Update your email settings"}],"type":8,"value":"trackedLink"},{"type":0,"value":" to customize or stop receiving this email."}],"post-office-team.confluence-recommended-following-feed.email.body.hello":[{"type":0,"value":"G\'day "},{"type":1,"value":"name"},{"type":0,"value":","}],"post-office-team.confluence-recommended-following-feed.email.body.summary":[{"type":0,"value":"Here are pages your team is reading, don\'t miss out on the conversation."}],"post-office-team.confluence-recommended-following-feed.email.ios-android-text":[{"type":0,"value":"Download the Confluence mobile app on "},{"children":[{"type":0,"value":"iOS"}],"type":8,"value":"iosLink"},{"type":0,"value":" or "},{"children":[{"type":0,"value":"Android"}],"type":8,"value":"androidLink"},{"type":0,"value":" to read notifications and comment on the go."}],"post-office-team.confluence-recommended-following-feed.email.privacy-policy-text":[{"type":0,"value":"This email was sent by Atlassian Confluence  \u2022  "},{"children":[{"type":0,"value":"Privacy policy"}],"type":8,"value":"privacyPolicyLink"}],"post-office-team.confluence-recommended-following-feed.email.subject":[{"type":1,"value":"name"},{"type":0,"value":", your team is working on these pages -- join the conversation"}],"post-office-team.confluence-recommended-following-feed.email.subject.variant-a":[{"type":1,"value":"name"},{"type":0,"value":", "},{"type":1,"value":"pageTitle"},{"type":0,"value":" plus more pages your team is working on"}],"post-office-team.confluence-recommended-following-feed.header.confluence-icon.alt-text":[{"type":0,"value":"Confluence Icon"}],"post-office-team.confluence-recommended-following-feed.name-user-reacted":[{"children":[{"type":1,"value":"firstUser"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}],"post-office-team.confluence-recommended-following-feed.name-user-reacted-and-number-of-others":[{"offset":0,"options":{"one":{"value":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":" and "},{"type":1,"value":"calculatedReactionCount"},{"type":0,"value":" other"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]},"other":{"value":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":" and "},{"type":1,"value":"calculatedReactionCount"},{"type":0,"value":" others"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]}},"pluralType":"cardinal","type":6,"value":"calculatedReactionCount"}],"post-office-team.confluence-recommended-following-feed.name-users-reacted":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":" and "},{"type":1,"value":"secondUser"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}],"post-office-team.confluence-recommended-following-feed.name-users-reacted-and-number-of-others":[{"offset":0,"options":{"one":{"value":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":", "},{"type":1,"value":"secondUser"},{"type":0,"value":", and "},{"type":1,"value":"calculatedReactionCount"},{"type":0,"value":" other"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]},"other":{"value":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":", "},{"type":1,"value":"secondUser"},{"type":0,"value":", and "},{"type":1,"value":"calculatedReactionCount"},{"type":0,"value":" others"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]}},"pluralType":"cardinal","type":6,"value":"calculatedReactionCount"}],"post-office-team.confluence-recommended-following-feed.no-comments":[{"type":0,"value":"Be the first to comment"}],"post-office-team.confluence-recommended-following-feed.no-reactions-text":[{"type":0,"value":"Be the first to react"}],"post-office-team.confluence-recommended-following-feed.number-of-comments":[{"offset":0,"options":{"one":{"value":[{"children":[{"type":7}],"type":8,"value":"strong"},{"type":0,"value":" comment"}]},"other":{"value":[{"children":[{"type":7}],"type":8,"value":"strong"},{"type":0,"value":" comments"}]}},"pluralType":"cardinal","type":6,"value":"commentCount"}],"post-office-team.confluence-recommended-following-feed.number-of-users-reacted":[{"offset":0,"options":{"one":{"value":[{"children":[{"type":1,"value":"reactionCount"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]},"other":{"value":[{"children":[{"type":1,"value":"reactionCount"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]}},"pluralType":"cardinal","type":6,"value":"reactionCount"}],"post-office-team.confluence-recommended-following-feed.owned-by":[{"type":0,"value":"Owned by "},{"type":1,"value":"ownerName"}],"post-office-team.confluence-recommended-following-feed.party-popper-button-alt-text":[{"type":0,"value":"Party Popper"}],"post-office-team.confluence-recommended-following-feed.read-more-link":[{"type":0,"value":"Read more"}],"post-office-team.confluence-recommended-following-feed.thumbs-up-button-alt-text":[{"type":0,"value":"Thumbs up"}],"post-office-team.confluence-recommended-following-feed.user-profile-picture-alt-text":[{"type":1,"value":"name"},{"type":0,"value":"\'s profile picture"}],"post-office-team.confluence-recommended-following-feed.whiteboard-icon":[{"type":0,"value":"Whiteboard icon"}],"post-office.admin-hub.end-of-notifications.description":[{"type":0,"value":"That\'s all your notifications from the last 90 days"}],"post-office.post-office-team-components.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"post-office.post-office-team-components.email.footer.office-address":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia"}],"post-office.post-office-team-components.email.footer.why-am-i-receiving-this-email":[{"type":0,"value":"You are receiving this email because this is an important message regarding your account and products you are using. You are not allowed to unsubscribe from this type of message."}],"post-office.post-office-team.jira-messaging-research-recruitment.screen-space-flags.cta-link":[{"type":0,"value":"Get started"}],"post-office.post-office-team.jira-messaging-research-recruitment.screen-space-flags.description":[{"type":0,"value":"Help us improve messaging for Atlassian Admins! Answer a few short questions, and our\\n\\t\\t\\t\\t\\tResearch team will contact you for a 60-minute Zoom session if you qualify."}],"post-office.post-office-team.jira-messaging-research-recruitment.screen-space-flags.header":[{"type":0,"value":"Share your experience for $120 USD"}]}');

});

parcelRegister("l3kWz", function(module, exports) {

let $f53a1fc7346ceb1f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f53a1fc7346ceb1f$var$load("ipEfh").then(()=>parcelRequire('bBKSm'));

});

parcelRegister("f5aG4", function(module, exports) {

let $afaf9af73f7a12d4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $afaf9af73f7a12d4$var$load("6ZeYO").then(()=>parcelRequire('4l5Ww'));

});

parcelRegister("2ybtD", function(module, exports) {

let $1db7a8d56f9c0350$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1db7a8d56f9c0350$var$load("7P2dc").then(()=>parcelRequire('7RTW6'));

});

parcelRegister("7rl0P", function(module, exports) {

let $56ab5aa54c9cc74f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $56ab5aa54c9cc74f$var$load("qi4NO").then(()=>parcelRequire('kX0us'));

});

parcelRegister("81EVB", function(module, exports) {

let $5d7e2a2d7df838a2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5d7e2a2d7df838a2$var$load("1Kqgf").then(()=>parcelRequire('hVDjG'));

});

parcelRegister("fWw6w", function(module, exports) {

let $b9b52d05e747fe9b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b9b52d05e747fe9b$var$load("aAxB4").then(()=>parcelRequire('aHCWR'));

});

parcelRegister("bCcrQ", function(module, exports) {

let $874ce6409b34a09e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $874ce6409b34a09e$var$load("5XOhk").then(()=>parcelRequire('6zMq5'));

});

parcelRegister("1stz6", function(module, exports) {

let $10ff56f8fad44eac$var$load = (parcelRequire("28QjX"))(4);
module.exports = $10ff56f8fad44eac$var$load("c9112").then(()=>parcelRequire('d6jO2'));

});

parcelRegister("eiyGo", function(module, exports) {

let $a68da66d6d58715b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a68da66d6d58715b$var$load("lcfuw").then(()=>parcelRequire('1acXz'));

});

parcelRegister("dwEdb", function(module, exports) {

let $9d8d74b46ed1c1e3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9d8d74b46ed1c1e3$var$load("lRcNv").then(()=>parcelRequire('kS8nn'));

});

parcelRegister("81Xg4", function(module, exports) {

let $5d8c622fd93d3d89$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5d8c622fd93d3d89$var$load("czqtB").then(()=>parcelRequire('6vgyh'));

});

parcelRegister("fEHyt", function(module, exports) {

let $b65c6089b548fc00$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b65c6089b548fc00$var$load("e8xIh").then(()=>parcelRequire('40nKs'));

});

parcelRegister("c3oji", function(module, exports) {

let $8c689f550e547d53$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8c689f550e547d53$var$load("eDAjF").then(()=>parcelRequire('gBVrk'));

});

parcelRegister("g4pkP", function(module, exports) {

let $bb30ac083ae90aea$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bb30ac083ae90aea$var$load("knP5B").then(()=>parcelRequire('kxIkE'));

});

parcelRegister("gtxVN", function(module, exports) {

let $bfe9acd1589216bf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bfe9acd1589216bf$var$load("9YzUr").then(()=>parcelRequire('1giAQ'));

});

parcelRegister("Jq5Y3", function(module, exports) {

let $0888720eb5c8b9d6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0888720eb5c8b9d6$var$load("97Y1C").then(()=>parcelRequire('iEK1O'));

});

parcelRegister("5Mvxv", function(module, exports) {

let $4359e6878234d8f5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4359e6878234d8f5$var$load("hffl9").then(()=>parcelRequire('eBOuu'));

});

parcelRegister("cl6QV", function(module, exports) {

let $8fbcc303c50e62da$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8fbcc303c50e62da$var$load("bocK9").then(()=>parcelRequire('jXZsN'));

});

parcelRegister("7jxH6", function(module, exports) {

let $553471bb1c3318be$var$load = (parcelRequire("28QjX"))(4);
module.exports = $553471bb1c3318be$var$load("jZQZD").then(()=>parcelRequire('dW522'));

});

parcelRegister("4ctjV", function(module, exports) {

let $30ef06cff5502222$var$load = (parcelRequire("28QjX"))(4);
module.exports = $30ef06cff5502222$var$load("d38PD").then(()=>parcelRequire('bP8Kf'));

});

parcelRegister("czjwi", function(module, exports) {

let $9267e52d03772f72$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9267e52d03772f72$var$load("cbFPj").then(()=>parcelRequire('6ETqg'));

});

parcelRegister("fj4jm", function(module, exports) {

let $b24bf97c4cd2fd23$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b24bf97c4cd2fd23$var$load("2KgES").then(()=>parcelRequire('kJIEh'));

});

parcelRegister("jQNTn", function(module, exports) {

let $e7399337e6a9f5ed$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e7399337e6a9f5ed$var$load("9fF3I").then(()=>parcelRequire('d9jiN'));

});

parcelRegister("lxFrZ", function(module, exports) {

let $faecd53a488b3aff$var$load = (parcelRequire("28QjX"))(4);
module.exports = $faecd53a488b3aff$var$load("8eKQI").then(()=>parcelRequire('brcIJ'));

});

parcelRegister("k60Ko", function(module, exports) {

let $ea14f296ef470fe9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ea14f296ef470fe9$var$load("fhNTQ").then(()=>parcelRequire('jsXJr'));

});

parcelRegister("dFgAQ", function(module, exports) {

let $9f2bf9caffe0f06f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9f2bf9caffe0f06f$var$load("b5UZH").then(()=>parcelRequire('6Bhs5'));

});

parcelRegister("g2kvA", function(module, exports) {

let $baccbdcb4be7d972$var$load = (parcelRequire("28QjX"))(4);
module.exports = $baccbdcb4be7d972$var$load("eeN8y").then(()=>parcelRequire('9DLCE'));

});

parcelRegister("jtBAb", function(module, exports) {

let $03a8bd6ee9911064$var$load = (parcelRequire("28QjX"))(4);
module.exports = $03a8bd6ee9911064$var$load("60cjb").then(()=>parcelRequire('k0E9x'));

});

parcelRegister("c6LKL", function(module, exports) {

let $8d0b1661e7f449a0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8d0b1661e7f449a0$var$load("5gwtQ").then(()=>parcelRequire('1X9yr'));

});


parcelRegister("cENg4", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $177b5a84586da530$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $cGnQ2 = parcelRequire("cGnQ2");

var $euiLX = parcelRequire("euiLX");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $177b5a84586da530$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;






























const $177b5a84586da530$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $euiLX.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $177b5a84586da530$var$importHelper(await (parcelRequire("hFYNL")));
        case 'da':
            return $177b5a84586da530$var$importHelper(await (parcelRequire("iviWK")));
        case 'de':
            return $177b5a84586da530$var$importHelper(await (parcelRequire("clw6H")));
        case 'en-GB':
            return $177b5a84586da530$var$importHelper(await (parcelRequire("i8u9M")));
        case 'en-US':
            return $177b5a84586da530$var$importHelper(await (parcelRequire("6ru9e")));
        case 'en-XA':
            return $177b5a84586da530$var$importHelper(await (parcelRequire("5HLLB")));
        case 'en-XB':
            return $177b5a84586da530$var$importHelper(await (parcelRequire("azoGo")));
        case 'en-ZZ':
            return $177b5a84586da530$var$importHelper(await (parcelRequire("RKWIH")));
        case 'en':
            return $177b5a84586da530$var$importHelper(await Promise.resolve((parcelRequire("cGnQ2"))));
        case 'es':
            return $177b5a84586da530$var$importHelper(await (parcelRequire("61uPS")));
        case 'et':
            return $177b5a84586da530$var$importHelper(await (parcelRequire("9ArJE")));
        case 'fi':
            return $177b5a84586da530$var$importHelper(await (parcelRequire("4xu4E")));
        case 'fr':
            return $177b5a84586da530$var$importHelper(await (parcelRequire("fKyjC")));
        case 'hu':
            return $177b5a84586da530$var$importHelper(await (parcelRequire("5WJtI")));
        case 'it':
            return $177b5a84586da530$var$importHelper(await (parcelRequire("f54Sx")));
        case 'ja':
            return $177b5a84586da530$var$importHelper(await (parcelRequire("73ZGB")));
        case 'ko':
            return $177b5a84586da530$var$importHelper(await (parcelRequire("l9WCo")));
        case 'nb':
            return $177b5a84586da530$var$importHelper(await (parcelRequire("b1xyc")));
        case 'nl':
            return $177b5a84586da530$var$importHelper(await (parcelRequire("j2VS9")));
        case 'pl':
            return $177b5a84586da530$var$importHelper(await (parcelRequire("c0T07")));
        case 'pt-BR':
            return $177b5a84586da530$var$importHelper(await (parcelRequire("dSN1t")));
        case 'ro':
            return $177b5a84586da530$var$importHelper(await (parcelRequire("dDzOv")));
        case 'ru':
            return $177b5a84586da530$var$importHelper(await (parcelRequire("cF8cC")));
        case 'sv':
            return $177b5a84586da530$var$importHelper(await (parcelRequire("eeKBP")));
        case 'th':
            return $177b5a84586da530$var$importHelper(await (parcelRequire("l5SSa")));
        case 'tr':
            return $177b5a84586da530$var$importHelper(await (parcelRequire("gBkFW")));
        case 'uk':
            return $177b5a84586da530$var$importHelper(await (parcelRequire("jjbIM")));
        case 'vi':
            return $177b5a84586da530$var$importHelper(await (parcelRequire("5xoTy")));
        case 'zh-CN':
            return $177b5a84586da530$var$importHelper(await (parcelRequire("81F46")));
        case 'zh-TW':
            return $177b5a84586da530$var$importHelper(await (parcelRequire("hdVG5")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($cGnQ2));
    }
};

});
parcelRegister("cGnQ2", function(module, exports) {
module.exports = JSON.parse("{\"admin-hub.ci-test.message-template-template-hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"ci-generation.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"ci-generation.email.body.hello\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"ci-generation.email.body.img.alt\":[{\"type\":0,\"value\":\"This is the alt text for the image\"}],\"ci-generation.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"ci-generation.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"ci-generation.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"ci-generation.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"post-office.test-message-digest-email-template.test-message.email.body.digest-title\":[{\"type\":0,\"value\":\"You have \"},{\"type\":1,\"value\":\"numberOfMsg\"},{\"type\":0,\"value\":\" new messages!\"}],\"post-office.test-message-digest-email-template.test-message.email.body.message-body\":[{\"type\":1,\"value\":\"defaultMessage\"}],\"post-office.test-message-microsoft-teams.sample-hello-message\":[{\"type\":0,\"value\":\"Hello, this is test message from Post Office: \"},{\"type\":1,\"value\":\"text\"}],\"post-office.test-message.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\".\"}],\"post-office.test-messages.test-message-load-test-push-flow-email-mobile-push.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}],\"post-office.test-messages.test-message-mobile-push-jira-ugc.redacted.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a redacted test mobile push notification from post office.\"}],\"post-office.test-messages.test-message-mobile-push-jira-ugc.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}],\"post-office.test-messages.test-message-mobile-push.greeting.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}],\"post-office.test-messages.test-message-mobile-push.redacted.greeting.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a redacted mobile push notification test from post office.\"}],\"post-office.test-messages.test-message-transform-metadata.sample-hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office.test-slack-notification.sample-hello-message\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"product-store-personal-use-case.hello-world\":[{\"type\":0,\"value\":\"Hello. Is is a lovely\"}],\"test-messages.app-switcher-discovery-section.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"test-messages.app-switcher-discovery-section.test-content\":[{\"type\":0,\"value\":\"This is a test message.\"}],\"test-messages.app-switcher-upgrade-section.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"test-messages.app-switcher-upgrade-section.test-content\":[{\"type\":0,\"value\":\"This is a test message.\"}],\"test-messages.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.in-app-example.hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"test-messages.jira-navigation-topbar-edition-awareness.hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"test-messages.redacted-email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.team-message-email-ugc.message-template.email.redacted.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Redacted Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-digest-email.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-digest-email.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-digest-email.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hey \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-digest-email.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment. Here is your daily digest (rick) rollup for the \"},{\"type\":1,\"value\":\"site\"},{\"type\":0,\"value\":\" workspace\"}],\"test-messages.test-message-digest-email.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-digest-email.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-digest-email.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-email-cdn.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-cdn.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-cdn.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-cdn.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-cdn.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-cdn.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-cdn.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-email-high-priority.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-high-priority.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-high-priority.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-high-priority.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-high-priority.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-high-priority.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-high-priority.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-email-mfc.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-mfc.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-mfc.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-mfc.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-mfc.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-mfc.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-mfc.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-email-ugc.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-ugc.message-template-template.email.redacted.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-ugc.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-ugc.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-ugc.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-ugc.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-ugc.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-ugc.test-message.email.redacted.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-ugc.test-message.email.redacted.body.no-translate\":[{\"type\":0,\"value\":\"This is a redacted test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-ugc.test-message.email.redacted.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-ugc.test-message.email.redacted.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-ugc.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-grouped-recipients.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-grouped-recipients.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hello\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-grouped-recipients.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-inapp-engagement.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-inapp-engagement.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-inapp-engagement.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-marketing.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-marketing.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-marketing.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-marketing.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-marketing.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-marketing.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-marketing.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-message-failures.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-message-failures.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-message-failures.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-message-failures.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-message-failures.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-message-failures.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-message-failures.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-persona-email.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-persona-email.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-persona-email.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-persona-email.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-persona-email.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-persona-email.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-raw-recipients.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-raw-recipients.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.greeting.no-translate\":[{\"type\":1,\"value\":\"greeting\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.hello.name.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi,\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-raw-recipients.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-transform-metadata.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-transform-metadata.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-transform-metadata.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-transform-metadata.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-transform-metadata.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-transform-metadata.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-transform-metadata.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message.app.img.alt.large\":[{\"type\":0,\"value\":\"test image 2\"}],\"test-messages.test-message.app.img.alt.plant\":[{\"type\":0,\"value\":\"test image 1\"}],\"test-messages.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment. \"},{\"type\":1,\"value\":\"additionalBody\"}],\"test-messages.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hi Atlassian,\"}],\"test-messages.test-message.email.body.img.alt\":[{\"type\":0,\"value\":\"this is the alt for the test-message-email message template\"}],\"test-messages.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message.redacted-email.body\":[{\"type\":0,\"value\":\"This is the redacted version of the test email message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment. \"},{\"type\":1,\"value\":\"additionalBody\"}],\"test-messages.test-message.redacted-email.body.hello\":[{\"type\":0,\"value\":\"Hi Atlassian,\"}],\"test-messages.test-message.redacted-email.body.img.alt\":[{\"type\":0,\"value\":\"this is the alt for the test-message-email message template\"}],\"test-messages.test-message.redacted-email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message.redacted-email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"wac-global-nav-product-recommendation.hello-world\":[{\"type\":0,\"value\":\"Hello. Is is a lovely\"}]}");

});

parcelRegister("hFYNL", function(module, exports) {

let $cde56df21d9736d6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cde56df21d9736d6$var$load("7plkH").then(()=>parcelRequire('k8z39'));

});

parcelRegister("iviWK", function(module, exports) {

let $d789d19ff4d428fc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d789d19ff4d428fc$var$load("bZXwp").then(()=>parcelRequire('6UrsO'));

});

parcelRegister("clw6H", function(module, exports) {

let $8fd05a034ba9fd7a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8fd05a034ba9fd7a$var$load("4eYRm").then(()=>parcelRequire('8bqsn'));

});

parcelRegister("i8u9M", function(module, exports) {

let $d3405ddce9b4b891$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d3405ddce9b4b891$var$load("bpX6Y").then(()=>parcelRequire('hJmwv'));

});

parcelRegister("6ru9e", function(module, exports) {

let $4b0ca672dc9042be$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4b0ca672dc9042be$var$load("4SAm0").then(()=>parcelRequire('2uiq7'));

});

parcelRegister("5HLLB", function(module, exports) {

let $42760566004192f8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $42760566004192f8$var$load("8JKPM").then(()=>parcelRequire('iHpg4'));

});

parcelRegister("azoGo", function(module, exports) {

let $7b2051c5cd6c34d3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7b2051c5cd6c34d3$var$load("fV9R1").then(()=>parcelRequire('fI8tg'));

});

parcelRegister("RKWIH", function(module, exports) {

let $0a195dde490bcd0e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0a195dde490bcd0e$var$load("6nUuR").then(()=>parcelRequire('kozgB'));

});

parcelRegister("61uPS", function(module, exports) {

let $462ac16df91b1371$var$load = (parcelRequire("28QjX"))(4);
module.exports = $462ac16df91b1371$var$load("aGMGI").then(()=>parcelRequire('4wp5m'));

});

parcelRegister("9ArJE", function(module, exports) {

let $6facfd7efc6c04a4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6facfd7efc6c04a4$var$load("a5QUI").then(()=>parcelRequire('lExpK'));

});

parcelRegister("4xu4E", function(module, exports) {

let $34e1928d276da730$var$load = (parcelRequire("28QjX"))(4);
module.exports = $34e1928d276da730$var$load("g6nHD").then(()=>parcelRequire('i0vin'));

});

parcelRegister("fKyjC", function(module, exports) {

let $b775c5328324f912$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b775c5328324f912$var$load("4Ehm2").then(()=>parcelRequire('hAKNc'));

});

parcelRegister("5WJtI", function(module, exports) {

let $4545a594e8d4739f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4545a594e8d4739f$var$load("3WAnL").then(()=>parcelRequire('6RGe9'));

});

parcelRegister("f54Sx", function(module, exports) {

let $afab1b6b98d90072$var$load = (parcelRequire("28QjX"))(4);
module.exports = $afab1b6b98d90072$var$load("7C2m7").then(()=>parcelRequire('eUDxL'));

});

parcelRegister("73ZGB", function(module, exports) {

let $5248a9c9563199ec$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5248a9c9563199ec$var$load("6H16x").then(()=>parcelRequire('5Tyyo'));

});

parcelRegister("l9WCo", function(module, exports) {

let $f677e8996f3d184a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f677e8996f3d184a$var$load("2fjGn").then(()=>parcelRequire('gEKqD'));

});

parcelRegister("b1xyc", function(module, exports) {

let $8069d02b58f93944$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8069d02b58f93944$var$load("4f7k3").then(()=>parcelRequire('8h3N4'));

});

parcelRegister("j2VS9", function(module, exports) {

let $dddb187c7d93dccc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $dddb187c7d93dccc$var$load("cV1Em").then(()=>parcelRequire('baBoX'));

});

parcelRegister("c0T07", function(module, exports) {

let $8bf0262399d8b11b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8bf0262399d8b11b$var$load("9Ht4b").then(()=>parcelRequire('kuE02'));

});

parcelRegister("dSN1t", function(module, exports) {

let $a1b6586d78eba3fb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a1b6586d78eba3fb$var$load("d0LZb").then(()=>parcelRequire('gSSyD'));

});

parcelRegister("dDzOv", function(module, exports) {

let $9edab2b1d3cb85da$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9edab2b1d3cb85da$var$load("eg5tA").then(()=>parcelRequire('8PFu0'));

});

parcelRegister("cF8cC", function(module, exports) {

let $937fad350e862b9a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $937fad350e862b9a$var$load("j4nUA").then(()=>parcelRequire('f9UJM'));

});

parcelRegister("eeKBP", function(module, exports) {

let $a5d6871ebd55efd2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a5d6871ebd55efd2$var$load("fsSg2").then(()=>parcelRequire('l5ru8'));

});

parcelRegister("l5SSa", function(module, exports) {

let $f5b4a12f9e177071$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f5b4a12f9e177071$var$load("8v1Xn").then(()=>parcelRequire('36syK'));

});

parcelRegister("gBkFW", function(module, exports) {

let $c16023c78bdfc4ac$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c16023c78bdfc4ac$var$load("juKZk").then(()=>parcelRequire('hO7cZ'));

});

parcelRegister("jjbIM", function(module, exports) {

let $e0e8e24013353c4c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e0e8e24013353c4c$var$load("lqiDs").then(()=>parcelRequire('9DvXk'));

});

parcelRegister("5xoTy", function(module, exports) {

let $4083586e8a4a1ec4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4083586e8a4a1ec4$var$load("iuNY9").then(()=>parcelRequire('lRZWr'));

});

parcelRegister("81F46", function(module, exports) {

let $5d7e456baf644355$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5d7e456baf644355$var$load("6SDRc").then(()=>parcelRequire('3Qt72'));

});

parcelRegister("hdVG5", function(module, exports) {

let $c8a0642dbf79860b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c8a0642dbf79860b$var$load("jvZ3l").then(()=>parcelRequire('2LYB4'));

});




parcelRegister("7sr84", function(module, exports) {

$parcel$export(module.exports, "ScreenSpaceFlagPlacementPreviewSwitcher", () => $f67b989a93e4f4dd$export$46db7cd62b063064);

var $2OMIu = parcelRequire("2OMIu");

var $lwdce = parcelRequire("lwdce");

var $5vZ80 = parcelRequire("5vZ80");

var $jgefF = parcelRequire("jgefF");

var $8igoP = parcelRequire("8igoP");

var $SfWIb = parcelRequire("SfWIb");
const $f67b989a93e4f4dd$export$16e97e6603eadea = ({ PlacementComponent: PlacementComponent, placementId: placementId, eligibleMessages: eligibleMessages, errorFallback: errorFallback = null, onError: onError, returnOverride: returnOverride, disableInitialData: disableInitialData })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $8igoP.ErrorBoundary), {
        fallback: errorFallback,
        onError: onError,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5vZ80.PlacementPreviewProvider), {
            eligibleMessages: eligibleMessages,
            returnOverride: returnOverride,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $SfWIb.default), {
                PlacementComponent: PlacementComponent,
                placementId: placementId,
                disableInitialData: disableInitialData
            })
        })
    });
const $f67b989a93e4f4dd$export$46db7cd62b063064 = ({ isEnabled: isEnabled, children: children })=>{
    const { searchParams: searchParams } = (0, $lwdce.usePostOfficeRoute)();
    const previewId = searchParams?.get('contentfulPreviewId');
    const hasPreviewType = Boolean(searchParams?.get('contentfulPreviewId'));
    const eligibleMessage = [
        {
            messageInstanceId: 'messageInstanceId',
            messageTemplateId: 'marketing-screen-space-flag-contentful-usecase',
            messageCategory: 'Engagement',
            context: {
                id: previewId
            },
            createdAt: new Date().toString(),
            eventTime: new Date().toString(),
            triggerId: 'triggerId',
            messageCreationType: 'explicit'
        }
    ];
    if (isEnabled && hasPreviewType) return /*#__PURE__*/ (0, $2OMIu.jsx)($f67b989a93e4f4dd$export$16e97e6603eadea, {
        placementId: "screen-space-flags",
        PlacementComponent: (0, $jgefF.ScreenSpaceFlagsPlacementComponent),
        eligibleMessages: eligibleMessage
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};

});
parcelRegister("5vZ80", function(module, exports) {

$parcel$export(module.exports, "PlacementPreviewProvider", () => $a6dbbce22e4d11ac$export$52e362b70e115c68);

var $2OMIu = parcelRequire("2OMIu");

var $gJHNN = parcelRequire("gJHNN");

var $5uXOq = parcelRequire("5uXOq");
const $a6dbbce22e4d11ac$export$e5ffd38dcf6e5c53 = `/gateway/api/post-office/api/v1/placements/`;
const $a6dbbce22e4d11ac$export$85c4756977e87c75 = `/gateway/api/post-office/api/v1/placement-preview/`;
const $a6dbbce22e4d11ac$export$52e362b70e115c68 = ({ returnOverride: returnOverride, eligibleMessages: eligibleMessages, children: children })=>{
    const fetch = (0, $5uXOq.useMemo)(()=>{
        if (returnOverride) return $a6dbbce22e4d11ac$export$fb5156757134712c({
            returnOverride: returnOverride
        });
        return $a6dbbce22e4d11ac$export$c05392ff95b4319d({
            eligibleMessages: eligibleMessages
        });
    }, [
        eligibleMessages,
        returnOverride
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gJHNN.PlacementFetchingProvider), {
        fetch: fetch,
        children: children
    });
};
const $a6dbbce22e4d11ac$export$fb5156757134712c = ({ returnOverride: returnOverride })=>async ()=>{
        return new Response(JSON.stringify(returnOverride), {
            status: 200,
            statusText: 'ok'
        });
    };
const $a6dbbce22e4d11ac$export$c05392ff95b4319d = ({ eligibleMessages: eligibleMessages })=>(url, options)=>{
        const finalUrl = url.replace($a6dbbce22e4d11ac$export$e5ffd38dcf6e5c53, $a6dbbce22e4d11ac$export$85c4756977e87c75);
        const payload = {
            originalMethod: options?.method || 'GET',
            originalBody: $a6dbbce22e4d11ac$var$parseBody(options?.body),
            eligibleMessages: eligibleMessages
        };
        return globalThis.fetch(finalUrl, {
            ...options,
            method: 'POST',
            headers: {
                ...options?.headers || {}
            },
            body: $a6dbbce22e4d11ac$var$stringifyPayload(payload)
        });
    };
const $a6dbbce22e4d11ac$var$objectHasKeys = (input)=>!!Object.keys(input).length;
const $a6dbbce22e4d11ac$var$parseBody = (body)=>{
    if (typeof body === 'undefined' || body === null) return undefined;
    try {
        const parsedBody = JSON.parse(body);
        if ($a6dbbce22e4d11ac$var$objectHasKeys(parsedBody)) return parsedBody;
        throw new Error();
    } catch  {
        throw new Error('Unable to parse preview body. Is it a valid object?');
    }
};
const $a6dbbce22e4d11ac$var$stringifyPayload = (payload)=>{
    try {
        return JSON.stringify(payload);
    } catch  {
        throw new Error('Unable to parse preview body. Is it a valid object?');
    }
};

});

parcelRegister("8igoP", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $609cb9bed692cc37$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");
'use client';
const $609cb9bed692cc37$export$b16d9fb1a22de840 = (0, $5uXOq.createContext)(null);
const $609cb9bed692cc37$var$initialState = {
    didCatch: false,
    error: null
};
class $609cb9bed692cc37$export$e926676385687eaf extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $609cb9bed692cc37$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($609cb9bed692cc37$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $609cb9bed692cc37$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($609cb9bed692cc37$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $5uXOq.createElement)(FallbackComponent, props);
            else if (fallback === null || (0, $5uXOq.isValidElement)(fallback)) childToRender = fallback;
            else throw error;
        }
        return (0, $5uXOq.createElement)($609cb9bed692cc37$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $609cb9bed692cc37$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $609cb9bed692cc37$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $609cb9bed692cc37$export$c052f6604b7d51fe() {
    const context = (0, $5uXOq.useContext)($609cb9bed692cc37$export$b16d9fb1a22de840);
    $609cb9bed692cc37$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $5uXOq.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $5uXOq.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $609cb9bed692cc37$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $5uXOq.forwardRef)((props, ref)=>(0, $5uXOq.createElement)($609cb9bed692cc37$export$e926676385687eaf, errorBoundaryProps, (0, $5uXOq.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}

});


const $d0ca21152325de6b$export$37d4bb5bc0e315db = 'killswitch_post_office_in_jira';


parcelRegister("hbQoJ", function(module, exports) {

$parcel$export(module.exports, "PreviewPanelsProvider", () => $c494ce9129d35914$export$65ae37e9c61321f9);
$parcel$export(module.exports, "useGlobalObjectPreviewPanels", () => $c494ce9129d35914$export$70bcacea0b970dee);
$parcel$export(module.exports, "usePreviewPanelStateChanged", () => $c494ce9129d35914$export$5e98dc0fae8a152c);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $lODMY = parcelRequire("lODMY");

var $4R6GH = parcelRequire("4R6GH");

var $d3Tts = parcelRequire("d3Tts");
var $1xxeI = parcelRequire("1xxeI");

var $hxB2k = parcelRequire("hxB2k");
const $c494ce9129d35914$var$SUPPORT_PANEL_TYPES_MILESTONE_ONE = [
    'identity-team',
    'confluence-page',
    'confluence-whiteboard',
    'townsquare-goal',
    'townsquare-project'
];
const $c494ce9129d35914$var$JiraPreviewPanelsContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $c494ce9129d35914$export$eed91152c097781f = (0, $lODMY.createRouterSelector)(({ route: route, location: location })=>route.supportsPreviewPanel ? `${route.name}:${location.pathname}` : null);
const $c494ce9129d35914$var$JiraPreviewPanelsProvider = ({ children: children, subscribe: subscribe })=>{
    (0, $gKZoD.di)(window);
    const { close: close } = (0, $hxB2k.usePreviewPanelsActions)();
    const enabledRoute = $c494ce9129d35914$export$eed91152c097781f();
    const isIssueEmbed = enabledRoute?.split(':')[0] === 'issue-embed';
    let supportedObjects = (0, $4R6GH.fg)('jira-glance-issue-panel') ? undefined : $c494ce9129d35914$var$SUPPORT_PANEL_TYPES_MILESTONE_ONE;
    // If the route is an issue embed, we can get the supported objects from the URL search params.
    // This allows us to support custom objects in the preview panel for the host application.
    if (isIssueEmbed && typeof window !== 'undefined') {
        const urlSearchParams = new URLSearchParams(window.location.search);
        supportedObjects = urlSearchParams.get('previewPanels')?.split(',')?.map((0, $d3Tts.asGlobalObjectType));
    }
    const { isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $1xxeI.useGlobalObjectPreviewPanels)('jira', {
        supportedObjects: supportedObjects,
        enabled: enabledRoute !== null
    });
    (0, $1xxeI.usePreviewPanelIFrameCommunication)(openPreviewPanel);
    (0, $5uXOq.useEffect)(()=>()=>{
            // automatically close the preview panel when the route changes
            close();
        }, [
        enabledRoute,
        close
    ]);
    const value = (0, $5uXOq.useMemo)(()=>({
            subscribe: subscribe,
            openPreviewPanel: openPreviewPanel,
            isPreviewPanelAvailable: isPreviewPanelAvailable
        }), [
        subscribe,
        openPreviewPanel,
        isPreviewPanelAvailable
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c494ce9129d35914$var$JiraPreviewPanelsContext.Provider, {
        value: value
    }, children);
};
const $c494ce9129d35914$export$65ae37e9c61321f9 = ({ children: children })=>{
    const subscribers = (0, $5uXOq.useRef)(new Set());
    const notifySubscribers = (0, $5uXOq.useCallback)((event)=>{
        subscribers.current.forEach((callback)=>callback(event));
    }, []);
    const handlePreviewPanelOpen = (0, $5uXOq.useCallback)(()=>notifySubscribers('open'), [
        notifySubscribers
    ]);
    const handlePreviewPanelClose = (0, $5uXOq.useCallback)(()=>notifySubscribers('close'), [
        notifySubscribers
    ]);
    const subscribe = (0, $5uXOq.useCallback)((callback)=>{
        subscribers.current.add(callback);
        return ()=>{
            subscribers.current.delete(callback);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hxB2k.PreviewPanelsProvider), {
        onPreviewPanelOpen: handlePreviewPanelOpen,
        onPreviewPanelClose: handlePreviewPanelClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c494ce9129d35914$var$JiraPreviewPanelsProvider, {
        subscribe: subscribe
    }, children));
};
const $c494ce9129d35914$export$70bcacea0b970dee = ()=>{
    const context = (0, $5uXOq.useContext)($c494ce9129d35914$var$JiraPreviewPanelsContext);
    if (!context) throw new Error('useGlobalObjectPreviewPanels must be used within a PreviewPanelsProvider');
    const { openPreviewPanel: openPreviewPanel, isPreviewPanelAvailable: isPreviewPanelAvailable } = context;
    return {
        openPreviewPanel: openPreviewPanel,
        isPreviewPanelAvailable: isPreviewPanelAvailable
    };
};
const $c494ce9129d35914$export$5e98dc0fae8a152c = (callback)=>{
    const { subscribe: subscribe } = (0, $5uXOq.useContext)($c494ce9129d35914$var$JiraPreviewPanelsContext) ?? {};
    (0, $5uXOq.useEffect)(()=>{
        if (!subscribe) return;
        const unsubscribe = subscribe(callback);
        return ()=>unsubscribe();
    }, [
        subscribe,
        callback
    ]);
};

});
parcelRegister("d3Tts", function(module, exports) {

$parcel$export(module.exports, "isInIframe", () => $46c61ab523d426a4$export$9f140ed41af5108c);
$parcel$export(module.exports, "asGlobalObjectType", () => $46c61ab523d426a4$export$5b60458e6ab1ba54);

var $hguuj = parcelRequire("hguuj");
const $46c61ab523d426a4$export$9f140ed41af5108c = ()=>{
    try {
        return window !== window.top;
    } catch  {
        // If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
        return true;
    }
};
const $46c61ab523d426a4$export$5b60458e6ab1ba54 = (value)=>{
    if (!(0, $hguuj.ALL_SUPPORTED_OBJECTS).includes(value)) throw new Error(`Unsupported global object type: ${value}`);
    return value;
};

});
parcelRegister("hguuj", function(module, exports) {

$parcel$export(module.exports, "ALL_SUPPORTED_OBJECTS", () => $8b5c88e715f532f0$export$cec6f7cb9c99f251);
const $8b5c88e715f532f0$export$cec6f7cb9c99f251 = [
    'jira-issue',
    'confluence-page',
    'confluence-whiteboard',
    'identity-team',
    'townsquare-goal',
    'townsquare-project'
];

});


parcelRegister("1xxeI", function(module, exports) {

$parcel$export(module.exports, "useGlobalObjectPreviewPanels", () => $9024d828feea9cdc$export$70bcacea0b970dee);
$parcel$export(module.exports, "usePreviewPanelIFrameCommunication", () => $9024d828feea9cdc$export$3cfc2fe60a8f0a1c);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $8Uumt = parcelRequire("8Uumt");

var $4iV1e = parcelRequire("4iV1e");

var $kdfZa = parcelRequire("kdfZa");

var $dXQDI = parcelRequire("dXQDI");

var $c781K = parcelRequire("c781K");

var $h5fUN = parcelRequire("h5fUN");

var $lhPtH = parcelRequire("lhPtH");

var $h29WZ = parcelRequire("h29WZ");

var $4XPRu = parcelRequire("4XPRu");

var $6KlsW = parcelRequire("6KlsW");

var $hxB2k = parcelRequire("hxB2k");

var $8UQyq = parcelRequire("8UQyq");

var $e2pRJ = parcelRequire("e2pRJ");

var $hguuj = parcelRequire("hguuj");

var $1hEhi = parcelRequire("1hEhi");

var $lL5Hz = parcelRequire("lL5Hz");

var $i3Di3 = parcelRequire("i3Di3");

var $idHPb = parcelRequire("idHPb");

var $9RgPS = parcelRequire("9RgPS");

var $d3Tts = parcelRequire("d3Tts");
const $9024d828feea9cdc$var$getGlobalObjectType = (ari)=>{
    const parsedAri = (0, $h29WZ.AnyAri).parse(ari);
    return `${parsedAri.resourceOwner}-${parsedAri.resourceType}`;
};
const $9024d828feea9cdc$export$70bcacea0b970dee = (product, options)=>{
    const { enabled: enabled = true, supportedObjects: supportedObjects = (0, $hguuj.ALL_SUPPORTED_OBJECTS) } = options ?? {};
    const environmentProvider = (0, $e2pRJ.useRelayEnvironmentProvider)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { open: open } = (0, $hxB2k.usePreviewPanelsActions)();
    const isPreviewPanelAvailable = (0, $5uXOq.useCallback)(({ ari: ari })=>enabled && supportedObjects.includes($9024d828feea9cdc$var$getGlobalObjectType(ari)), [
        enabled,
        supportedObjects
    ]);
    const openPreviewPanel = (0, $5uXOq.useCallback)(({ url: url, ari: ari, name: name })=>{
        const globalObjectType = $9024d828feea9cdc$var$getGlobalObjectType(ari);
        if (!isPreviewPanelAvailable({
            ari: ari
        })) throw new Error(`Preview panel for ${globalObjectType} with ARI ${ari} is not supported.`);
        // Check if we're in an iframe (not the top-most frame)
        if ((0, $d3Tts.isInIframe)()) {
            // Post message to parent frame to open the panel
            window.parent.postMessage({
                type: 'OPEN_PREVIEW_PANEL',
                payload: {
                    url: url,
                    ari: ari,
                    name: name
                }
            }, '*');
            return;
        }
        let panelContent;
        switch(globalObjectType){
            case 'jira-issue':
                panelContent = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9RgPS.IFramePreviewPanel), {
                    name: formatMessage((0, $1hEhi.default).workItem),
                    url: url,
                    iframeUrl: `${url}/embed?previewPanels=${encodeURIComponent(supportedObjects.join(','))}`,
                    icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lhPtH))), {
                        label: ""
                    })
                });
                break;
            case 'identity-team':
                panelContent = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lL5Hz.DummyPreviewPanel), {
                    name: formatMessage((0, $1hEhi.default).team),
                    url: url,
                    icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c781K))), {
                        label: ""
                    })
                });
                break;
            case 'townsquare-goal':
                const entryPointReference = (0, $8Uumt.loadEntryPoint)(environmentProvider, (0, $6KlsW.default), {
                    ari: ari
                });
                panelContent = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i3Di3.EntryPointPreviewPanel), {
                    entryPoint: (0, $6KlsW.default),
                    preloadedEntryPointReference: entryPointReference,
                    runtimeProps: {
                        url: url
                    },
                    fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $idHPb.FallbackPreviewPanel), {
                        name: formatMessage((0, $1hEhi.default).goal),
                        url: url,
                        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4iV1e))), {
                            label: ""
                        })
                    })
                });
                break;
            case 'townsquare-project':
                {
                    const entryPointReference = (0, $8Uumt.loadEntryPoint)(environmentProvider, (0, $8UQyq.default), {
                        ari: ari
                    });
                    panelContent = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i3Di3.EntryPointPreviewPanel), {
                        entryPoint: (0, $8UQyq.default),
                        preloadedEntryPointReference: entryPointReference,
                        runtimeProps: {
                            url: url
                        },
                        fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $idHPb.FallbackPreviewPanel), {
                            name: formatMessage((0, $1hEhi.default).project),
                            url: url,
                            icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dXQDI))), {
                                label: ""
                            })
                        })
                    });
                    break;
                }
            case 'confluence-page':
                {
                    const entryPointReference = (0, $8Uumt.loadEntryPoint)(environmentProvider, (0, $4XPRu.confluencePagePreviewPanelEntryPoint), {});
                    panelContent = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i3Di3.EntryPointPreviewPanel), {
                        entryPoint: (0, $4XPRu.confluencePagePreviewPanelEntryPoint),
                        preloadedEntryPointReference: entryPointReference,
                        runtimeProps: {
                            title: name,
                            url: url,
                            parentProduct: product
                        },
                        fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $idHPb.FallbackPreviewPanel), {
                            name: formatMessage((0, $1hEhi.default).page),
                            url: url,
                            icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kdfZa))), {
                                label: ""
                            })
                        })
                    });
                    break;
                }
            case 'confluence-whiteboard':
                {
                    const entryPointReference = (0, $8Uumt.loadEntryPoint)(environmentProvider, (0, $4XPRu.confluencePagePreviewPanelEntryPoint), {});
                    panelContent = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i3Di3.EntryPointPreviewPanel), {
                        entryPoint: (0, $4XPRu.confluencePagePreviewPanelEntryPoint),
                        preloadedEntryPointReference: entryPointReference,
                        runtimeProps: {
                            title: name,
                            url: url,
                            parentProduct: product
                        },
                        fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $idHPb.FallbackPreviewPanel), {
                            name: formatMessage((0, $1hEhi.default).whiteboard),
                            url: url,
                            icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($h5fUN))), {
                                label: ""
                            })
                        })
                    });
                    break;
                }
            default:
                throw new Error(`Unsupported global object type: ${globalObjectType}`);
        }
        open({
            panel: {
                id: ari,
                type: globalObjectType,
                content: ()=>panelContent
            }
        });
    }, [
        isPreviewPanelAvailable,
        open,
        formatMessage,
        supportedObjects,
        environmentProvider,
        product
    ]);
    return {
        isPreviewPanelAvailable: isPreviewPanelAvailable,
        openPreviewPanel: openPreviewPanel
    };
};
const $9024d828feea9cdc$export$3cfc2fe60a8f0a1c = (openPreviewPanel)=>{
    // Listen for messages from iframes to open panels
    (0, $5uXOq.useEffect)(()=>{
        const handleMessage = (event)=>{
            // Only handle messages with the expected type
            if (event.data?.type !== 'OPEN_PREVIEW_PANEL') return;
            const { payload: payload } = event.data;
            if (payload?.url && payload?.ari && payload?.name) openPreviewPanel({
                url: payload.url,
                ari: payload.ari,
                name: payload.name
            });
        };
        window.addEventListener('message', handleMessage);
        return ()=>{
            window.removeEventListener('message', handleMessage);
        };
    }, [
        openPreviewPanel
    ]);
};

});
parcelRegister("h5fUN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e4cad5a4ce9de3d8f027113d1b7910c8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6ff3fae3688d83c$var$_react = $c6ff3fae3688d83c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c6ff3fae3688d83c$var$_baseNew = $c6ff3fae3688d83c$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $c6ff3fae3688d83c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Whiteboard".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for whiteboards in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c6ff3fae3688d83c$var$WhiteboardIcon = (props)=>/*#__PURE__*/ $c6ff3fae3688d83c$var$_react.default.createElement($c6ff3fae3688d83c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.162 2.178c-.714.282-1.28.816-1.449 1.338l-1.426-.463C6.637 1.97 7.633 1.169 8.61.783c.943-.373 2.248-.49 3.09.374.346.356.536.778.548 1.237.011.436-.14.827-.323 1.144-.228.393-.557.76-.876 1.074 1.466-.137 2.717.238 3.421 1.133.827 1.05.644 2.464-.256 3.698l-1.212-.885c.66-.905.556-1.547.29-1.885-.305-.387-1.095-.756-2.524-.512-.521.09-.935.139-1.236.13a1.4 1.4 0 0 1-.537-.109.9.9 0 0 1-.345-.278.85.85 0 0 1-.164-.496 1.02 1.02 0 0 1 .197-.586c.077-.112.171-.215.256-.3.14-.143.323-.306.499-.464l.101-.09c.453-.407.87-.806 1.087-1.18.102-.179.124-.292.123-.355-.002-.04-.01-.112-.124-.23-.2-.204-.716-.32-1.464-.025M3.75 5.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M0 7.75a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0m10.25.75a.75.75 0 0 1 .643.364l3 5A.75.75 0 0 1 13.25 15h-6a.75.75 0 0 1-.643-1.136l3-5a.75.75 0 0 1 .643-.364m-1.675 5h3.35l-1.675-2.792z" clip-rule="evenodd"/>`
    }, props));
$c6ff3fae3688d83c$var$WhiteboardIcon.displayName = 'WhiteboardIcon';
var $c6ff3fae3688d83c$var$_default = module.exports.default = $c6ff3fae3688d83c$var$WhiteboardIcon;

});

parcelRegister("lhPtH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::16b1a013266ea85d8875a6b5e1d2412a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7f31df16698d05e$var$_react = $f7f31df16698d05e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f7f31df16698d05e$var$_baseNew = $f7f31df16698d05e$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $f7f31df16698d05e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f7f31df16698d05e$var$WorkItemIcon = (props)=>/*#__PURE__*/ $f7f31df16698d05e$var$_react.default.createElement($f7f31df16698d05e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 4a.5.5 0 0 0-.4-.49L14 3.5H2a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zm-2.927 1.983-4 4.75a.75.75 0 0 1-1.146 0l-2-2.375 1.146-.966L7 9.085l3.427-4.068zM16 12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12l.204.01A2 2 0 0 1 16 4z"/>`
    }, props));
$f7f31df16698d05e$var$WorkItemIcon.displayName = 'WorkItemIcon';
var $f7f31df16698d05e$var$_default = module.exports.default = $f7f31df16698d05e$var$WorkItemIcon;

});

parcelRegister("4XPRu", function(module, exports) {

$parcel$export(module.exports, "confluencePagePreviewPanelEntryPoint", () => $27bb19e601ef5446$export$a50c261b4b52f403);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $27bb19e601ef5446$export$a50c261b4b52f403 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("agSlE")), {
        moduleId: "d73b44f1",
        priority: "interaction",
        moduleId: 'confluence-preview-panel-entrypoint'
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("agSlE", function(module, exports) {

let $77a58e703d8c0073$var$load = (parcelRequire("28QjX"))(4);
module.exports = $77a58e703d8c0073$var$load("5Yt8e").then(()=>parcelRequire('2uXhd'));

});


parcelRegister("6KlsW", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d68d632539d28c0$export$2e2bcd8739ae039);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $dKAVX = parcelRequire("dKAVX");
const $3d68d632539d28c0$var$fetchPolicy = 'network-only';

const $3d68d632539d28c0$var$atlasGoalEntryPoint = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("fpIli")).then((mod)=>mod.GoalPanel), {
        moduleId: "ba76ccc1",
        moduleName: "GoalPanel",
        priority: "interaction",
        moduleId: 'atlas-goal-entrypoint'
    }),
    getPreloadProps: ({ ari: ari })=>({
            queries: {
                queryReference: {
                    parameters: $dKAVX.default,
                    variables: {
                        ari: ari
                    },
                    options: {
                        fetchPolicy: $3d68d632539d28c0$var$fetchPolicy
                    }
                }
            }
        })
});
var $3d68d632539d28c0$export$2e2bcd8739ae039 = $3d68d632539d28c0$var$atlasGoalEntryPoint;

});
parcelRegister("dKAVX", function(module, exports) {

$parcel$export(module.exports, "default", () => $970b2746b36e72d7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3cd10a3623b0ce4aaa28c0b495b7dcbc>>
 * @relayHash 49e9f05b036817e1102a414db03d271b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d8c454d6d4ea9d2ffbd92ebe2427f6726c8f1cd95d77be7dde95838ef7a3557d
const $970b2746b36e72d7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ari"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "ari",
            "variableName": "ari"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "key"
    }, v5 = {
        "kind": "ScalarField",
        "name": "value"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "GoalPanelQuery",
            "selections": [
                {
                    "concreteType": "TownsquareQueryApi",
                    "kind": "LinkedField",
                    "name": "townsquare",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "TownsquareGoal",
                            "kind": "LinkedField",
                            "name": "goal",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "FragmentSpread",
                                    "name": "GoalPanelTitleField"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "GoalStatus"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "GoalType"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "GoalOwner"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "GoalTargetDate"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "GoalPanelQuery",
            "selections": [
                {
                    "concreteType": "TownsquareQueryApi",
                    "kind": "LinkedField",
                    "name": "townsquare",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "TownsquareGoal",
                            "kind": "LinkedField",
                            "name": "goal",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareGoalIcon",
                                    "kind": "LinkedField",
                                    "name": "icon",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "appearance"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "TownsquareStatus",
                                    "kind": "LinkedField",
                                    "name": "status",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "score"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "TownsquareGoalType",
                                    "kind": "LinkedField",
                                    "name": "goalType",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareGoalTypeIcon",
                                            "kind": "LinkedField",
                                            "name": "icon",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "name",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ 
                                                    ],
                                                    "type": "TownsquareGoalTypeCustomName"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "defaultValue"
                                                        }
                                                    ],
                                                    "type": "TownsquareLocalizationField"
                                                }
                                            ]
                                        },
                                        v2 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "owner",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "picture"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "TownsquareTargetDate",
                                    "kind": "LinkedField",
                                    "name": "targetDate",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareTargetDateRange",
                                            "kind": "LinkedField",
                                            "name": "dateRange",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "start"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "end"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d8c454d6d4ea9d2ffbd92ebe2427f6726c8f1cd95d77be7dde95838ef7a3557d",
            "metadata": {},
            "name": "GoalPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$970b2746b36e72d7$var$node.hash = "7d3212a534dd55b9261f866e846dc8cc";
var $970b2746b36e72d7$export$2e2bcd8739ae039 = $970b2746b36e72d7$var$node;

});

parcelRegister("fpIli", function(module, exports) {

let $b38b965212246e3c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b38b965212246e3c$var$load("66FYX").then(()=>parcelRequire('4G4l6'));

});


parcelRegister("8UQyq", function(module, exports) {

$parcel$export(module.exports, "default", () => $39d4b08018cd78c1$export$2e2bcd8739ae039);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $lTVU5 = parcelRequire("lTVU5");
const $39d4b08018cd78c1$var$fetchPolicy = 'network-only';

const $39d4b08018cd78c1$var$atlasProjectEntryPoint = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("ldr4S")).then((mod)=>mod.ProjectPanel), {
        moduleId: "db5db9ea",
        moduleName: "ProjectPanel",
        priority: "interaction",
        moduleId: 'atlas-project-entrypoint'
    }),
    getPreloadProps: ({ ari: ari })=>({
            queries: {
                queryReference: {
                    parameters: $lTVU5.default,
                    variables: {
                        ari: ari
                    },
                    options: {
                        fetchPolicy: $39d4b08018cd78c1$var$fetchPolicy
                    }
                }
            }
        })
});
var $39d4b08018cd78c1$export$2e2bcd8739ae039 = $39d4b08018cd78c1$var$atlasProjectEntryPoint;

});
parcelRegister("lTVU5", function(module, exports) {

$parcel$export(module.exports, "default", () => $c33b1ddd0e1aff7c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<93636e0a9d6a38440e104f27edebad23>>
 * @relayHash af385297d074541397a638adda466b13
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9ede461daef26804b41c57ed0da7b652a844f9ef52bccb77ba525204371454f3
const $c33b1ddd0e1aff7c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ari"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "ari",
            "variableName": "ari"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = [
        {
            "concreteType": "TownsquareLinkEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "TownsquareLink",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        },
                        v3 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ProjectPanelQuery",
            "selections": [
                {
                    "concreteType": "TownsquareQueryApi",
                    "kind": "LinkedField",
                    "name": "townsquare",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "TownsquareProject",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "FragmentSpread",
                                    "name": "ProjectPanelHeader"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "ProjectTags"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "ProjectTargetDate"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "ProjectStatus"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "ProjectOwner"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "ProjectLinks"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "ProjectWorkTracked"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "ProjectStartDate"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ProjectPanelQuery",
            "selections": [
                {
                    "concreteType": "TownsquareQueryApi",
                    "kind": "LinkedField",
                    "name": "townsquare",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "TownsquareProject",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareIconURIs",
                                    "kind": "LinkedField",
                                    "name": "iconUrl",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareThemeURIs",
                                            "kind": "LinkedField",
                                            "name": "roundedSquare",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "dark"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "light"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "TownsquareTagConnection",
                                    "kind": "LinkedField",
                                    "name": "tags",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareTagEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "TownsquareTag",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "TownsquareTargetDate",
                                    "kind": "LinkedField",
                                    "name": "dueDate",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareTargetDateRange",
                                            "kind": "LinkedField",
                                            "name": "dateRange",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "start"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "end"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "TownsquareProjectState",
                                    "kind": "LinkedField",
                                    "name": "state",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "label"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "owner",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "picture"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "TownsquareLinkConnection",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": v4 /*: any*/ 
                                },
                                {
                                    "alias": "workTrackingLinks",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "WORK_TRACKING"
                                        }
                                    ],
                                    "concreteType": "TownsquareLinkConnection",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": v4 /*: any*/ ,
                                    "storageKey": "links(first:1,type:\"WORK_TRACKING\")"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "startDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9ede461daef26804b41c57ed0da7b652a844f9ef52bccb77ba525204371454f3",
            "metadata": {},
            "name": "ProjectPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c33b1ddd0e1aff7c$var$node.hash = "376bc2cc9c8f9d18584371b92d230d0e";
var $c33b1ddd0e1aff7c$export$2e2bcd8739ae039 = $c33b1ddd0e1aff7c$var$node;

});

parcelRegister("ldr4S", function(module, exports) {

let $f71fd0eca2cda927$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f71fd0eca2cda927$var$load("fliVL"),
    $f71fd0eca2cda927$var$load("ffQaD"),
    $f71fd0eca2cda927$var$load("kvRbA"),
    $f71fd0eca2cda927$var$load("kNFvF"),
    $f71fd0eca2cda927$var$load("bfxOR")
]).then(()=>parcelRequire('3V5be'));

});


parcelRegister("1hEhi", function(module, exports) {

$parcel$export(module.exports, "default", () => $aff06be6b4a2a62f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $aff06be6b4a2a62f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    workItem: {
        id: 'navigation.preview-panel-global-objects.workItem',
        defaultMessage: 'Work item',
        description: 'Title for the work item preview panel'
    },
    project: {
        id: 'navigation.preview-panel-global-objects.project',
        defaultMessage: 'Project',
        description: 'Title for the project preview panel'
    },
    goal: {
        id: 'navigation.preview-panel-global-objects.goal',
        defaultMessage: 'Goal',
        description: 'Title for the goal preview panel'
    },
    team: {
        id: 'navigation.preview-panel-global-objects.team',
        defaultMessage: 'Team',
        description: 'Title for the team preview panel'
    },
    page: {
        id: 'navigation.preview-panel-global-objects.page',
        defaultMessage: 'Page',
        description: 'Title for the Confluence page preview panel'
    },
    whiteboard: {
        id: 'navigation.preview-panel-global-objects.whiteboard',
        defaultMessage: 'Whiteboard',
        description: 'Title for the Confluence whiteboard preview panel'
    }
});

});

parcelRegister("lL5Hz", function(module, exports) {

$parcel$export(module.exports, "DummyPreviewPanel", () => $32debaa0fa6f4d1f$export$c1d31fd2a4660dfa);
/* DummyPreviewPanel.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $4dsIq = parcelRequire("4dsIq");
var $5QlTr = parcelRequire("5QlTr");
var $4pvVb = parcelRequire("4pvVb");
var $8Ynii = parcelRequire("8Ynii");

var $hxB2k = parcelRequire("hxB2k");
const $32debaa0fa6f4d1f$var$styles = {
    body: "_1e0c1txw _16jlkb7n _18m91wug _bozg1ejb _y4ti1ejb _1q51pxbi _85i5pxbi"
};
const $32debaa0fa6f4d1f$export$c1d31fd2a4660dfa = /*#__PURE__*/ (0, $5uXOq.memo)(({ name: name, url: url, icon: icon })=>{
    const { close: close } = (0, $hxB2k.usePreviewPanelsActions)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $4dsIq.PreviewPanel), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4pvVb.PreviewPanelHeader), {
                onClose: close,
                url: url,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Ynii.PreviewPanelTitle), {
                    title: name,
                    icon: icon
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5QlTr.PreviewPanelBody), {
                styles: $32debaa0fa6f4d1f$var$styles.body,
                children: "This is a dummy preview panel. It can be used to test the layout and functionality of the preview panel without needing a real content source."
            })
        ]
    });
});

});
parcelRegister("4dsIq", function(module, exports) {

$parcel$export(module.exports, "PreviewPanel", () => $3d8e9008e3af3cbb$export$9520f072db304aa0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $414Wj = parcelRequire("414Wj");
const $3d8e9008e3af3cbb$var$styles = {
    wrapper: "_1h6dmuej _ngwonqa1 _tml8e4h9 _4t3i1osq _bfhkvuon"
};
const $3d8e9008e3af3cbb$export$9520f072db304aa0 = ({ children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $414Wj.default), {
        xcss: $3d8e9008e3af3cbb$var$styles.wrapper,
        testId: testId,
        children: children
    });
};

});

parcelRegister("5QlTr", function(module, exports) {

$parcel$export(module.exports, "PreviewPanelBody", () => $e058fb487b75f516$export$cda5e69749e7aeee);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $MHKc7 = parcelRequire("MHKc7");
const $e058fb487b75f516$export$cda5e69749e7aeee = ({ children: children, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, styles: styles })=>{
    (0, $5uXOq.useEffect)(()=>{
        if (analyticsClient) analyticsClient.sendTrackEvent({
            action: 'viewed',
            actionSubject: 'preview-panel',
            actionSubjectId: 'preview-panel-view',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
    }, [
        analyticsClient,
        parentProduct,
        panelType
    ]);
    // ignoring the rule as we have so many consumers of this that we need to be able to pass in styles
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)(!!styles && styles),
        children: children
    });
};

});

parcelRegister("4pvVb", function(module, exports) {

$parcel$export(module.exports, "PreviewPanelHeader", () => $0118f91ec99a66a7$export$426d4171de44bac0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $42CjB = parcelRequire("42CjB");

var $i28qQ = parcelRequire("i28qQ");

var $ggICg = parcelRequire("ggICg");

var $bUmQV = parcelRequire("bUmQV");
var $c0aEF = parcelRequire("c0aEF");

var $hDLoU = parcelRequire("hDLoU");
const $0118f91ec99a66a7$var$styles = {
    header: "_1h6dmuej _bozg1ejb _y4ti1ejb _1q51pxbi _85i5pxbi _12ornqa1 _1r62e4h9 _4t3i8vuz",
    childWrapper: "_16jlkb7n"
};
const $0118f91ec99a66a7$export$426d4171de44bac0 = ({ children: children, onClose: onClose, testId: testId, url: url, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onPanelClose = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'preview-panel-close',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        onClose();
    };
    const onOpenInNewWindow = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'preview-panel-open-in-new-window',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        window.open(url);
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
        xcss: $0118f91ec99a66a7$var$styles.header,
        testId: testId,
        alignBlock: "center",
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                xcss: $0118f91ec99a66a7$var$styles.childWrapper,
                spread: "space-between",
                alignBlock: "center",
                space: "space.100",
                children: children
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bUmQV.default), {
                gap: "space.100",
                children: [
                    url && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ggICg))),
                        appearance: "subtle",
                        label: formatMessage((0, $hDLoU.default).previewPanelOpenInNewWindowLabel),
                        onClick: onOpenInNewWindow,
                        testId: testId && `${testId}.open-in-new-window-button`
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                        icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i28qQ))), {
                                ...iconProps,
                                size: "small"
                            }),
                        label: formatMessage((0, $hDLoU.default).previewPanelCloseButtonLabel),
                        onClick: onPanelClose,
                        testId: testId && `${testId}.close-button`
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("hDLoU", function(module, exports) {

$parcel$export(module.exports, "default", () => $420c1308c796a354$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $420c1308c796a354$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    previewPanelCloseButtonLabel: {
        id: 'navigation.preview-panel.preview-panel-header.close-button-label',
        defaultMessage: 'Close',
        description: 'Label for the close button in the preview panel'
    },
    previewPanelExpandActionLabel: {
        id: 'navigation.preview-panel.preview-panel-action-variants.preview-panel-expand.expand-action-label',
        defaultMessage: 'Expand',
        description: 'Label for the expand action in the preview panel'
    },
    previewPanelNewTabActionLabel: {
        id: 'navigation.preview-panel.preview-panel-action-variants.preview-panel-new-tab.new-tab-action-label',
        defaultMessage: 'Open in new tab',
        description: 'Label for the open in new tab action in the preview panel'
    },
    previewPanelMoreDropdownActionLabel: {
        id: 'navigation.preview-panel.preview-panel-action-variants.preview-panel-more-dropdown.more-dropdown-action-label',
        defaultMessage: 'More',
        description: 'Label for the more dropdown action in the preview panel'
    },
    previewPanelOpenInNewWindowLabel: {
        id: 'navigation.preview-panel.preview-panel-header.open-in-new-window-label',
        defaultMessage: 'Open in new window',
        description: 'Label for the open in new window button in the preview panel header'
    }
});

});


parcelRegister("8Ynii", function(module, exports) {

$parcel$export(module.exports, "PreviewPanelTitle", () => $352a6f39bfbb0288$export$92a58681483f4529);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c0aEF = parcelRequire("c0aEF");
var $dS3PR = parcelRequire("dS3PR");
const $352a6f39bfbb0288$export$92a58681483f4529 = ({ title: title, icon: icon })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
        space: "space.100",
        alignBlock: "center",
        children: [
            icon,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                weight: "bold",
                maxLines: 1,
                children: title
            })
        ]
    });
};

});


parcelRegister("i3Di3", function(module, exports) {

$parcel$export(module.exports, "EntryPointPreviewPanel", () => $f5dfa589c443c883$export$2ace74dd551e05c1);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $kKgGa = parcelRequire("kKgGa");
const $f5dfa589c443c883$var$emptyEntryPointProps = {};
const $f5dfa589c443c883$export$2ace74dd551e05c1 = ({ entryPoint: entryPoint, preloadedEntryPointReference: preloadedEntryPointReference, runtimeProps: runtimeProps = $f5dfa589c443c883$var$emptyEntryPointProps, fallback: fallback, errorFallback: errorFallback })=>{
    const id = (0, $5uXOq.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kKgGa.InternalEntryPointContainer), {
        id: id,
        entryPointReference: preloadedEntryPointReference,
        fallback: fallback,
        errorFallback: errorFallback,
        runtimeProps: runtimeProps
    });
};

});

parcelRegister("idHPb", function(module, exports) {

$parcel$export(module.exports, "FallbackPreviewPanel", () => $2bd1be22af9ec5c2$export$97ea7ee86eec0667);
/* FallbackPreviewPanel.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4dsIq = parcelRequire("4dsIq");
var $5QlTr = parcelRequire("5QlTr");
var $4pvVb = parcelRequire("4pvVb");
var $8Ynii = parcelRequire("8Ynii");

var $hxB2k = parcelRequire("hxB2k");
const $2bd1be22af9ec5c2$var$styles = {
    body: "_zulppxbi _1e0c1txw _2lx21bp4 _16jlkb7n _18m91wug _bozg1ejb _y4ti1ejb _1q51pxbi _85i5pxbi",
    skeleton: "_2rkoiti9 _1e0c1txw _bfhkn82g _4t3igktf",
    skeletonRow1: "_1bsb1osq",
    skeletonRow2: "_1bsb1nrf",
    skeletonRow3: "_1bsb1w8u",
    skeletonRow4: "_1bsbhwvj"
};
const $2bd1be22af9ec5c2$export$97ea7ee86eec0667 = /*#__PURE__*/ (0, $5uXOq.memo)(({ url: url, name: name, icon: icon })=>{
    const { close: close } = (0, $hxB2k.usePreviewPanelsActions)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $4dsIq.PreviewPanel), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4pvVb.PreviewPanelHeader), {
                onClose: close,
                url: url,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Ynii.PreviewPanelTitle), {
                    title: name,
                    icon: icon
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5QlTr.PreviewPanelBody), {
                styles: $2bd1be22af9ec5c2$var$styles.body,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            $2bd1be22af9ec5c2$var$styles.skeleton,
                            $2bd1be22af9ec5c2$var$styles.skeletonRow1
                        ])
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            $2bd1be22af9ec5c2$var$styles.skeleton,
                            $2bd1be22af9ec5c2$var$styles.skeletonRow2
                        ])
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            $2bd1be22af9ec5c2$var$styles.skeleton,
                            $2bd1be22af9ec5c2$var$styles.skeletonRow3
                        ])
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            $2bd1be22af9ec5c2$var$styles.skeleton,
                            $2bd1be22af9ec5c2$var$styles.skeletonRow4
                        ])
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            $2bd1be22af9ec5c2$var$styles.skeleton,
                            $2bd1be22af9ec5c2$var$styles.skeletonRow1
                        ])
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            $2bd1be22af9ec5c2$var$styles.skeleton,
                            $2bd1be22af9ec5c2$var$styles.skeletonRow2
                        ])
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            $2bd1be22af9ec5c2$var$styles.skeleton,
                            $2bd1be22af9ec5c2$var$styles.skeletonRow3
                        ])
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            $2bd1be22af9ec5c2$var$styles.skeleton,
                            $2bd1be22af9ec5c2$var$styles.skeletonRow4
                        ])
                    })
                ]
            })
        ]
    });
});

});

parcelRegister("9RgPS", function(module, exports) {

$parcel$export(module.exports, "IFramePreviewPanel", () => $698eafcc68a6d423$export$83f0623b6f97b032);
/* IFramePreviewPanel.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4dsIq = parcelRequire("4dsIq");
var $5QlTr = parcelRequire("5QlTr");
var $4pvVb = parcelRequire("4pvVb");
var $8Ynii = parcelRequire("8Ynii");

var $hxB2k = parcelRequire("hxB2k");
const $698eafcc68a6d423$var$styles = {
    iframe: "_19itglyw _1bsb1osq _4t3i1osq",
    body: "_1e0c1txw _16jlkb7n _18m91wug"
};
const $698eafcc68a6d423$export$83f0623b6f97b032 = /*#__PURE__*/ (0, $5uXOq.memo)(({ url: url, iframeUrl: iframeUrl, name: name, icon: icon })=>{
    const { close: close } = (0, $hxB2k.usePreviewPanelsActions)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $4dsIq.PreviewPanel), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4pvVb.PreviewPanelHeader), {
                onClose: close,
                url: url,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Ynii.PreviewPanelTitle), {
                    title: name,
                    icon: icon
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5QlTr.PreviewPanelBody), {
                styles: $698eafcc68a6d423$var$styles.body,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("iframe", {
                    src: iframeUrl,
                    title: name,
                    className: (0, $bwpsq.default)([
                        $698eafcc68a6d423$var$styles.iframe
                    ])
                })
            })
        ]
    });
});

});



parcelRegister("eKtC8", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $31b7f947593face8$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $b71gk = parcelRequire("b71gk");
const $31b7f947593face8$export$e926676385687eaf = ({ children: children, id: id, withExperienceTracker: withExperienceTracker })=>{
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: id
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: id,
        packageName: "jiraEntry",
        fallback: "page",
        withExperienceTracker: withExperienceTracker
    }, children);
};

});

parcelRegister("bAjl9", function(module, exports) {

$parcel$export(module.exports, "IntlProviders", () => $fad1cef37914a278$export$c9d8cd4516cc55a8);

var $5uXOq = parcelRequire("5uXOq");

var $lzeFL = parcelRequire("lzeFL");

var $1nUas = parcelRequire("1nUas");
const $fad1cef37914a278$export$c9d8cd4516cc55a8 = ({ children: children, locale: locale, messages: messages })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1nUas.IntlProvider), {
        messages: messages,
        locale: (0, $lzeFL.standardizeLocale)(locale)
    }, children);

});
parcelRegister("1nUas", function(module, exports) {

$parcel$export(module.exports, "IntlProvider", () => $0264700d4de7e638$export$480518999dfc4151);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
const $0264700d4de7e638$export$480518999dfc4151 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i5FdW.default), {
        ...props,
        defaultLocale: props.locale
    }, children);

});


parcelRegister("lvG9V", function(module, exports) {

$parcel$export(module.exports, "MetricsContainers", () => $2bc2dec1250f1cf8$export$2d1617bc0040e5d9);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $1OjhZ = parcelRequire("1OjhZ");

var $8ApFP = parcelRequire("8ApFP");

var $iXVV6 = parcelRequire("iXVV6");

var $kDdFQ = parcelRequire("kDdFQ");
const $2bc2dec1250f1cf8$export$2d1617bc0040e5d9 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: (0, $8ApFP.routeAnalyticsAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1OjhZ.ExperienceTrackerProvider), null, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        id: "metrics-containers-subproduct-updater",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kDdFQ.SubProductForAnalyticsUpdater), null)), children));

});
parcelRegister("1OjhZ", function(module, exports) {

$parcel$export(module.exports, "ExperienceTrackerProvider", () => $5cef917adb45d092$export$6f49c95a810d59fa);

var $5uXOq = parcelRequire("5uXOq");

var $ha42n = parcelRequire("ha42n");
var $bSOOm = parcelRequire("bSOOm");

var $9sAyK = parcelRequire("9sAyK");
const $5cef917adb45d092$var$useUnmount = (callback)=>(0, $5uXOq.useEffect)(()=>callback, [
        callback
    ]);
const $5cef917adb45d092$export$6f49c95a810d59fa = ({ children: children })=>{
    const [experienceTracker] = (0, $5uXOq.useState)(new (0, $ha42n.ExperienceTracker)());
    const [cleanupSliSub] = (0, $5uXOq.useState)(()=>experienceTracker.subscribe((0, $9sAyK.sliSubscriber)));
    const cleanup = (0, $5uXOq.useCallback)(()=>{
        cleanupSliSub();
    }, [
        cleanupSliSub
    ]);
    $5cef917adb45d092$var$useUnmount(cleanup);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bSOOm.ExperienceTrackerContext).Provider, {
        value: experienceTracker
    }, children);
};

});
parcelRegister("ha42n", function(module, exports) {

$parcel$export(module.exports, "ExperienceTracker", () => $19380a56c83c3ed5$export$12b6b072930fd68f);

var $82vfp = parcelRequire("82vfp");
class $19380a56c83c3ed5$export$12b6b072930fd68f {
    constructor(options){
        this.experiences = {};
        this.subscribers = [];
        this.isNetworkOfflineError = options && options.isNetworkOfflineError || (()=>false);
    }
    start({ name: name, id: id, timeout: timeout, startTime: startTime, attributes: attributes, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort, collect: collect }) {
        const current = this.experiences[name];
        if (current && !current.hasStopped && current.id === id) return;
        // Before replacing a current experience, abort it to ensure
        // it is cleaned up.
        if (current) current.abort({
            reason: 'Aborted because the same experience was started with a new id'
        });
        const experience = new (0, $82vfp.Experience)({
            name: name,
            id: id,
            timeout: timeout,
            startTime: startTime,
            attributes: attributes,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onAbort: onAbort,
            onStart: (startEvent)=>{
                this.emit(startEvent);
                let disposeCollectSubscription = ()=>{};
                if (collect) {
                    const events = [];
                    disposeCollectSubscription = this.subscribe((event)=>{
                        // Ignore already running experiences that started before this
                        // experience started
                        if (event.action === 'taskStart' || events.some((previousEvent)=>previousEvent.name === event.name && previousEvent.action === 'taskStart')) {
                            events.push(event);
                            collect(events, experience);
                        }
                    });
                }
                return (stopEvent)=>{
                    disposeCollectSubscription();
                    this.emit(stopEvent);
                };
            }
        });
        this.experiences[name] = experience;
    }
    succeed({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.succeed(attributes);
    }
    fail({ name: name, error: error, attributes: attributes }) {
        Object.values(this.experiences).forEach((current)=>{
            if (name != null && current.name !== name) return;
            current.fail({
                error: error,
                attributes: attributes
            });
        });
    }
    abort({ name: name, reason: reason, attributes: attributes, checkForTimeout: checkForTimeout }) {
        function abort(experience) {
            if (name != null && experience.name !== name) return;
            experience.abort({
                reason: reason,
                checkForTimeout: checkForTimeout,
                attributes: attributes
            });
        }
        const experiencesWithTimeouts = Object.values(this.experiences).filter((experience)=>experience.timeout);
        const experiencesWithoutTimeouts = Object.values(this.experiences).filter((experience)=>!experience.timeout);
        // We need to abort all experiences with timeouts first in order to properly
        // capture compound experiences composed of sub-experiences which have timeouts
        experiencesWithTimeouts.forEach(abort);
        experiencesWithoutTimeouts.forEach(abort);
    }
    subscribe(subscriber) {
        if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
        this.subscribers.push(subscriber);
        return ()=>{
            this.subscribers = this.subscribers.filter((x)=>x !== subscriber);
        };
    }
    stopOnError({ name: name, error: error, attributes: attributes }) {
        if (this.isNetworkOfflineError(error)) {
            this.abort({
                name: name,
                reason: `Aborted ${name} because of network error: ${error.toString()}`,
                checkForTimeout: false,
                attributes: attributes
            });
            return;
        }
        return this.fail({
            name: name,
            error: error,
            attributes: attributes
        });
    }
    emit(event) {
        this.subscribers.forEach((subscriber)=>{
            try {
                subscriber(event);
            } catch (e) {}
        });
    }
}

});
parcelRegister("82vfp", function(module, exports) {

$parcel$export(module.exports, "Experience", () => $abf5733617623630$export$c90b54e658fc4d7c);

var $j0xjM = parcelRequire("j0xjM");
function $abf5733617623630$var$mergeAttributes(first, last) {
    if (first === undefined) return last;
    if (last === undefined) return first;
    return {
        ...first,
        ...last
    };
}
class $abf5733617623630$export$c90b54e658fc4d7c {
    constructor({ name: name, id: id, timeout: timeout, startTime: startTime = window.performance.now(), attributes: attributes, onStart: onStart, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }){
        this._hasStopped = false;
        this.name = name;
        this.id = id;
        this.timeout = timeout;
        this.startTime = startTime;
        this.attributes = attributes;
        this.onSuccess = onSuccess;
        this.onFailure = onFailure;
        this.onAbort = onAbort;
        const startEvent = {
            action: 'taskStart',
            name: name,
            id: id,
            startTime: startTime,
            timeout: timeout,
            attributes: attributes
        };
        if (onStart) this.onStop = onStart(startEvent);
    }
    get hasStopped() {
        return this._hasStopped;
    }
    succeed(attributes) {
        if (this._hasStopped) return;
        this.onSuccess && this.onSuccess();
        this.stop({
            action: 'taskSuccess',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            attributes: $abf5733617623630$var$mergeAttributes(this.attributes, attributes)
        });
    }
    fail({ error: error, attributes: attributes }) {
        if (this._hasStopped) return;
        this.onFailure && this.onFailure();
        this.stop({
            action: 'taskFail',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            error: error,
            attributes: $abf5733617623630$var$mergeAttributes(this.attributes, attributes)
        });
    }
    abort({ reason: reason, attributes: attributes, checkForTimeout: checkForTimeout = true }) {
        if (this._hasStopped) return;
        // Check if the experience should have failed due to timeout
        if (checkForTimeout && this.timeout != null && this.getDuration() >= this.timeout) {
            this.fail({
                attributes: attributes,
                error: new (0, $j0xjM.ExperienceTimeoutError)(`${this.name} failed to complete in ${this.timeout}ms`)
            });
            return;
        }
        this.onAbort && this.onAbort();
        this.stop({
            action: 'taskAbort',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            reason: reason,
            checkForTimeout: checkForTimeout,
            attributes: $abf5733617623630$var$mergeAttributes(this.attributes, attributes)
        });
    }
    stopOn(event) {
        if (!event) return;
        if (event.action === 'taskSuccess') this.succeed();
        else if (event.action === 'taskAbort') this.abort({
            reason: event.reason,
            checkForTimeout: event.checkForTimeout
        });
        else if (event.action === 'taskFail') this.fail({
            error: event.error
        });
    }
    stop(event) {
        this._hasStopped = true;
        if (this.onStop) this.onStop(event);
    }
    getDuration() {
        return Math.round(window.performance.now() - this.startTime);
    }
}

});
parcelRegister("j0xjM", function(module, exports) {

$parcel$export(module.exports, "ExperienceTimeoutError", () => $f8ffb4638fa466dd$export$d27a2b6293f7631c);
class $f8ffb4638fa466dd$export$d27a2b6293f7631c extends Error {
    constructor(message){
        super(message);
        this.name = 'ExperienceTimeoutError';
    }
}

});



parcelRegister("9sAyK", function(module, exports) {

$parcel$export(module.exports, "sliSubscriber", () => $6b2f2360dd11edee$export$db0b99fe17114899);

var $fjcgS = parcelRequire("fjcgS");

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");

const $6b2f2360dd11edee$var$transformApplication = (application)=>{
    switch(application){
        case 0, $efvDm.JIRA_SOFTWARE:
            return 'jira-software';
        case 0, $efvDm.JIRA_PRODUCT_DISCOVERY:
            return 'jira-product-discovery';
        case 0, $efvDm.JIRA_CORE:
            return 'jira-core';
        case 0, $efvDm.JIRA_SERVICE_DESK:
            return 'jira-servicedesk';
        case 0, $efvDm.JIRA_PORTFOLIO:
            return 'jira-portfolio';
        default:
            return 'unknown';
    }
};
const $6b2f2360dd11edee$var$transformEdition = (edition)=>{
    switch(edition){
        case 0, $ldyPw.FREE_EDITION:
            return 'jedi';
        case 0, $ldyPw.STANDARD_EDITION:
            return 'standard';
        case 0, $ldyPw.PREMIUM_EDITION:
            return 'premium';
        case 0, $ldyPw.UNLICENSED:
            return 'unlicensed';
        default:
            return 'unknown';
    }
};
const $6b2f2360dd11edee$var$createAnalyticsEvent = ({ experience: experience, action: action, location: location, analyticsSource: analyticsSource, application: application, edition: edition, errorMessage: errorMessage, additionalAttributes: additionalAttributes })=>({
        source: 'ui',
        action: action,
        actionSubject: 'ui',
        attributes: {
            ...additionalAttributes,
            // any attribute on top of this is overridable by any tracker
            task: experience,
            reason: location,
            analyticsSource: analyticsSource,
            application: $6b2f2360dd11edee$var$transformApplication(application),
            edition: $6b2f2360dd11edee$var$transformEdition(edition),
            ...errorMessage && {
                errorMessage: errorMessage
            }
        }
    });
const $6b2f2360dd11edee$var$reportSli = (experienceDescription)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        const event = $6b2f2360dd11edee$var$createAnalyticsEvent(experienceDescription);
        const clientInstance = client.getInstance();
        clientInstance.sendOperationalEvent(event);
    });
};
const $6b2f2360dd11edee$export$db0b99fe17114899 = (event)=>{
    const { name: name, action: action } = event;
    // @ts-expect-error - TS2339 - Property 'disableSli' does not exist on type '{}'. | TS2339 - Property 'analyticsSource' does not exist on type '{}'. | TS2339 - Property 'application' does not exist on type '{}'. | TS2339 - Property 'edition' does not exist on type '{}'. | TS2339 - Property 'location' does not exist on type '{}'.
    const { disableSli: disableSli, analyticsSource: analyticsSource, application: application, edition: edition, location: location, ...additionalAttributes } = event.attributes || {};
    if (disableSli) return;
    switch(action){
        case 0, $c0ec49ac5a1e4009$export$627ef4c1ed2d7a9a:
            $6b2f2360dd11edee$var$reportSli({
                experience: name,
                action: (0, $c0ec49ac5a1e4009$export$627ef4c1ed2d7a9a),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                additionalAttributes: additionalAttributes
            });
            break;
        case 0, $c0ec49ac5a1e4009$export$b48b3d1872522384:
            $6b2f2360dd11edee$var$reportSli({
                experience: name,
                action: (0, $c0ec49ac5a1e4009$export$b48b3d1872522384),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                location: location,
                ...event.error && {
                    errorMessage: String(event.error)
                },
                additionalAttributes: additionalAttributes
            });
            break;
        case 0, $c0ec49ac5a1e4009$export$aeeb00d0845d24d8:
            $6b2f2360dd11edee$var$reportSli({
                experience: name,
                action: (0, $c0ec49ac5a1e4009$export$aeeb00d0845d24d8),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                location: location,
                additionalAttributes: additionalAttributes
            });
            break;
        default:
    }
};

});


parcelRegister("kDdFQ", function(module, exports) {

$parcel$export(module.exports, "SubProductForAnalyticsUpdater", () => $5dc03f10b4b74566$export$2f8fd5150032da73);

var $5uXOq = parcelRequire("5uXOq");

var $cfDZ3 = parcelRequire("cfDZ3");

var $16v4H = parcelRequire("16v4H");

var $4R6GH = parcelRequire("4R6GH");
const $5dc03f10b4b74566$var$SubProductUpdaterOld = ()=>{
    const subProduct = (0, $16v4H.useSubProduct)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $cfDZ3.setSubProduct)(subProduct);
    }, [
        subProduct
    ]);
    return null;
};
const $5dc03f10b4b74566$export$2f8fd5150032da73 = ()=>{
    if ((0, $4R6GH.fg)('jpd_accurate_subproduct_for_discovery_projects')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5dc03f10b4b74566$var$SubProductUpdaterNew, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5dc03f10b4b74566$var$SubProductUpdaterOld, null);
};
const $5dc03f10b4b74566$var$SubProductUpdaterNew = ()=>{
    const subProduct = (0, $16v4H.useSubProductForAnalytics)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $cfDZ3.setSubProduct)(subProduct);
    }, [
        subProduct
    ]);
    return null;
};

});


parcelRegister("gPTB6", function(module, exports) {

$parcel$export(module.exports, "NavigationContainers", () => $1720b620f5483501$export$36f9ed697cae18ae);
/* eslint-disable jira/react-magnetic-di/no-unneeded */ 
var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $8ploF = parcelRequire("8ploF");
let $1720b620f5483501$var$Containers = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
if (!false) $1720b620f5483501$var$Containers = (0, $8ploF.ClientOnlyNavigationContainers);
const $1720b620f5483501$export$36f9ed697cae18ae = ({ baseUrl: baseUrl, children: children })=>{
    (0, $gKZoD.di)($1720b620f5483501$var$Containers);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1720b620f5483501$var$Containers, {
        baseUrl: baseUrl
    }, children);
};

});
parcelRegister("8ploF", function(module, exports) {

$parcel$export(module.exports, "ClientOnlyNavigationContainers", () => $f5cf024286957bf6$export$68d7c1e44acfd599);

var $5uXOq = parcelRequire("5uXOq");

var $axSKo = parcelRequire("axSKo");
const $f5cf024286957bf6$export$68d7c1e44acfd599 = ({ children: children })=>{
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $axSKo.Provider), null, children);
    return null;
};

});


parcelRegister("9kep9", function(module, exports) {

$parcel$export(module.exports, "PageConfigContainers", () => $83e79f36d4d977db$export$9c661932489b4130);

var $5uXOq = parcelRequire("5uXOq");

var $9MAC1 = parcelRequire("9MAC1");

var $j8DrX = parcelRequire("j8DrX");

var $lODMY = parcelRequire("lODMY");

var $4CAXd = parcelRequire("4CAXd");

var $aX7Cy = parcelRequire("aX7Cy");
const $83e79f36d4d977db$var$useRouterRoute = (0, $lODMY.createRouterSelector)((state)=>state.route);
const $83e79f36d4d977db$export$9c661932489b4130 = ({ children: children })=>{
    const { PageConfigContainerOverride: PageConfigContainerOverride } = $83e79f36d4d977db$var$useRouterRoute();
    if (PageConfigContainerOverride !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(PageConfigContainerOverride, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9MAC1.ThemeContainer), {
        isGlobal: true,
        getMeta: (0, $j8DrX.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CAXd.DocumentTitleContainer), {
        titleSuffix: (0, $aX7Cy.ripTitleTemplateFromMeta)((0, $j8DrX.default))
    }, children));
};

});
parcelRegister("9MAC1", function(module, exports) {

$parcel$export(module.exports, "useTheme", () => $a1f770a9d49220c1$export$93d4e7f90805808f);
$parcel$export(module.exports, "ThemeContainer", () => $a1f770a9d49220c1$export$11eb671888ed6e7d);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

var $LtWMd = parcelRequire("LtWMd");
const $a1f770a9d49220c1$var$initialState = {
    navigationTheme: {
        shouldShowTitle: false,
        logoUrl: '',
        usesCustomColours: false,
        backgroundColor: '',
        highlightColor: ''
    }
};
const $a1f770a9d49220c1$var$Store = (0, $iXqE5.createStore)({
    name: 'theme',
    initialState: $a1f770a9d49220c1$var$initialState,
    actions: $LtWMd
});
const $a1f770a9d49220c1$export$74e6aa5aeff5e82e = (0, $51nlc.createSubscriber)($a1f770a9d49220c1$var$Store);
const $a1f770a9d49220c1$export$93d4e7f90805808f = (0, $3sQ5x.createHook)($a1f770a9d49220c1$var$Store);
const $a1f770a9d49220c1$export$11eb671888ed6e7d = (0, $gg7kZ.createContainer)($a1f770a9d49220c1$var$Store, {
    onInit: $LtWMd.bootstrap
});

});
parcelRegister("LtWMd", function(module, exports) {

$parcel$export(module.exports, "bootstrap", () => $9594f0aa641d3463$export$36aff1fbb4f5dfc6);
$parcel$export(module.exports, "update", () => $9594f0aa641d3463$export$722fbec263ad908a);

const $9594f0aa641d3463$export$36aff1fbb4f5dfc6 = ()=>({ setState: setState }, { getMeta: getMeta })=>{
        const ajsBackgroundColor = getMeta('ajs-lf-navigation-bgcolour');
        const ajsHighlightColor = getMeta('ajs-lf-navigation-highlightcolour');
        // we need to use color code directly here to compare it with hex code in meta tags
        const hasNavv3CustomColors = ajsBackgroundColor != null && ajsHighlightColor != null && (ajsBackgroundColor !== (0, $829f609a65d26a98$exports).N0 || ajsHighlightColor !== (0, $829f609a65d26a98$exports).B400);
        const navigationTheme = {
            shouldShowTitle: getMeta('ajs-lf-top-adg3-shouldshowtitle') === 'true',
            logoUrl: getMeta('ajs-lf-top-adg3-logourl') || '',
            usesCustomColours: getMeta('ajs-lf-top-adg3-hascustomcolours') === 'true',
            backgroundColor: ajsBackgroundColor || "var(--ds-background-inverse-subtle, #00000029)",
            highlightColor: ajsHighlightColor || "var(--ds-text-brand, #0C66E4)"
        };
        if (hasNavv3CustomColors) navigationTheme.usesCustomColours = true;
        setState({
            navigationTheme: navigationTheme
        });
    };
const $9594f0aa641d3463$export$722fbec263ad908a = (item)=>({ setState: setState, getState: getState })=>{
        const navigationTheme = {
            ...getState().navigationTheme,
            ...item
        };
        setState({
            navigationTheme: navigationTheme
        });
    };

});


parcelRegister("4CAXd", function(module, exports) {

$parcel$export(module.exports, "useDocumentTitleActions", () => $5f36a4118f941187$export$57c0fda036e12d67);
$parcel$export(module.exports, "DocumentTitleContainer", () => $5f36a4118f941187$export$1aad43993172f16f);
$parcel$export(module.exports, "DocumentTitleSubscriber", () => $5f36a4118f941187$export$b88d5abf3e0bec8c);
$parcel$export(module.exports, "DocumentTitleHelper", () => $5f36a4118f941187$export$573bf8d2ae7d60dc);
$parcel$export(module.exports, "DocumentTitleHelperOld", () => $5f36a4118f941187$export$1b644a069f382802);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

var $3Nww0 = parcelRequire("3Nww0");

var $aX7Cy = parcelRequire("aX7Cy");
const $5f36a4118f941187$var$initialState = {
    title: '',
    defaultTitle: '',
    contextArray: []
};
const $5f36a4118f941187$var$Store = (0, $iXqE5.createStore)({
    name: 'document-title',
    initialState: $5f36a4118f941187$var$initialState,
    actions: $3Nww0.actions
});
const $5f36a4118f941187$export$57c0fda036e12d67 = (0, $3sQ5x.createActionsHook)($5f36a4118f941187$var$Store);
const $5f36a4118f941187$export$4b208edda918084f = (0, $3sQ5x.createHook)($5f36a4118f941187$var$Store);
const $5f36a4118f941187$export$1aad43993172f16f = (0, $gg7kZ.createContainer)($5f36a4118f941187$var$Store, {
    displayName: 'DocumentTitleContainer'
});
const $5f36a4118f941187$export$b88d5abf3e0bec8c = (0, $51nlc.createSubscriber)($5f36a4118f941187$var$Store, {
    displayName: 'DocumentTitleSubscriber'
});
const $5f36a4118f941187$export$573bf8d2ae7d60dc = ({ title: title })=>{
    const { addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle, updateTitle: updateTitle } = $5f36a4118f941187$export$57c0fda036e12d67();
    const identifierRef = (0, $5uXOq.useRef)(Symbol(title));
    const onUpdate = (0, $5uXOq.useCallback)(()=>{
        updateTitle(title, identifierRef.current);
    }, [
        updateTitle,
        title
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const titleRef = identifierRef.current;
        addDocumentTitle(titleRef, title);
        return ()=>{
            removeDocumentTitle(titleRef);
            onUpdate();
        };
    }, [
        addDocumentTitle,
        onUpdate,
        removeDocumentTitle,
        title
    ]);
    (0, $5uXOq.useEffect)(()=>{
        onUpdate();
    }, [
        onUpdate
    ]);
    return null;
};
class $5f36a4118f941187$export$1b644a069f382802 extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
        this.myself = Symbol('document title identifier');
        this.props.addDocumentTitle(this.myself);
    }
    componentDidMount() {
        this.updateTitle();
    }
    componentDidUpdate() {
        this.updateTitle();
    }
    componentWillUnmount() {
        this.props.removeDocumentTitle(this.myself);
        this.updateTitle();
    }
    updateTitle() {
        if ((0, $aX7Cy.checkDocumentTitle)(this.myself, this.props.contextArray)) this.props.setTitle(this.props.title);
    }
    render() {
        return null;
    }
}

});
parcelRegister("3Nww0", function(module, exports) {

$parcel$export(module.exports, "actions", () => $ba5e66d563aca941$export$e324594224ef24da);

var $9vNeL = parcelRequire("9vNeL");

var $5Oj7f = parcelRequire("5Oj7f");

var $gJBAO = parcelRequire("gJBAO");

var $8DEaw = parcelRequire("8DEaw");
const $ba5e66d563aca941$export$e324594224ef24da = {
    setTitle: $9vNeL.setTitle,
    addDocumentTitle: $5Oj7f.addDocumentTitle,
    removeDocumentTitle: $gJBAO.removeDocumentTitle,
    updateTitle: $8DEaw.updateTitle
};

});
parcelRegister("9vNeL", function(module, exports) {

$parcel$export(module.exports, "setTitle", () => $aa0c91bbbd212a23$export$420a7f2fd9cad6f6);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $aX7Cy = parcelRequire("aX7Cy");
const $aa0c91bbbd212a23$export$420a7f2fd9cad6f6 = (title)=>({ setState: setState, getState: getState }, { titleSuffix: titleSuffix })=>{
        const state = getState();
        const titleTemplate = titleSuffix ? `%s - ${titleSuffix}` : '%s - Jira';
        const newTitle = (0, $aX7Cy.createTitleFromTemplate)(title, titleTemplate);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.title = newTitle;
        setState({
            ...state,
            title: newTitle
        });
    };

});
parcelRegister("aX7Cy", function(module, exports) {

$parcel$export(module.exports, "createTitleFromTemplate", () => $45855f8363268b1b$export$3795256dd54a9c9d);
$parcel$export(module.exports, "ripTitleTemplateFromMeta", () => $45855f8363268b1b$export$b7d18105f80195c);
$parcel$export(module.exports, "checkDocumentTitle", () => $45855f8363268b1b$export$7f8be70a0bed1bae);

var $4R6GH = parcelRequire("4R6GH");
const $45855f8363268b1b$export$3795256dd54a9c9d = (title, template)=>template.replace(/%s/, title);
const $45855f8363268b1b$export$b7d18105f80195c = (getMeta)=>getMeta('ajs-app-title');
const $45855f8363268b1b$export$7f8be70a0bed1bae = (symbol, contextArray)=>{
    const lastDocumentTitle = contextArray[contextArray.length - 1];
    if ((0, $4R6GH.fg)('jira-concurrent-document-title')) {
        if (typeof lastDocumentTitle === 'object' && lastDocumentTitle.symbol === symbol) return true;
        return false;
    }
    if (lastDocumentTitle === symbol) return true;
    return false;
};

});


parcelRegister("5Oj7f", function(module, exports) {

$parcel$export(module.exports, "addDocumentTitle", () => $53f35561ab86eb34$export$a0c188c0ea474bb8);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4R6GH = parcelRequire("4R6GH");
const $53f35561ab86eb34$export$a0c188c0ea474bb8 = (symbol, title)=>({ setState: setState, getState: getState })=>{
        const { contextArray: contextArray } = getState();
        title && (0, $4R6GH.fg)('jira-concurrent-document-title') ? contextArray.push({
            title: title,
            symbol: symbol
        }) : contextArray.push(symbol);
        setState({
            contextArray: contextArray
        });
    };

});

parcelRegister("gJBAO", function(module, exports) {

$parcel$export(module.exports, "removeDocumentTitle", () => $bcdbd43154f62b45$export$e844009b77f80a72);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4R6GH = parcelRequire("4R6GH");
const $bcdbd43154f62b45$export$e844009b77f80a72 = (titleSymbol)=>({ setState: setState, getState: getState })=>{
        const { contextArray: contextArray } = getState();
        setState({
            contextArray: (0, $4R6GH.fg)('jira-concurrent-document-title') ? contextArray.filter((titleContext)=>typeof titleContext === 'object' && titleContext.symbol !== titleSymbol) : contextArray.filter((symbol)=>symbol !== titleSymbol)
        });
    };

});

parcelRegister("8DEaw", function(module, exports) {

$parcel$export(module.exports, "updateTitle", () => $a1d3af230daa7254$export$bf6f7165e46e2479);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4R6GH = parcelRequire("4R6GH");

var $aX7Cy = parcelRequire("aX7Cy");
const $a1d3af230daa7254$var$generateTitle = (title, titleSuffix)=>{
    const titleTemplate = titleSuffix ? `%s - ${titleSuffix}` : '%s - Jira';
    const newTitle = (0, $aX7Cy.createTitleFromTemplate)(title, titleTemplate);
    return newTitle;
};
const $a1d3af230daa7254$export$bf6f7165e46e2479 = (title, context)=>({ setState: setState, getState: getState }, { titleSuffix: titleSuffix })=>{
        const state = getState();
        const contextItem = state.contextArray.find((item)=>{
            if (typeof item === 'object') return item.symbol === context;
            return false;
        });
        // If there is no contextItem, it means that the component has been unmounted
        // And we'll just use the last used title from the contextArray
        if (!contextItem && state.contextArray.length && (0, $4R6GH.fg)('jira-concurrent-document-title')) {
            const lastContextItem = state.contextArray[state.contextArray.length - 1];
            let newTitle = '';
            // This will always be an object but we have to check it to make TS happy
            if (typeof lastContextItem === 'object') newTitle = $a1d3af230daa7254$var$generateTitle(lastContextItem.title, titleSuffix);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.title = newTitle;
            setState({
                title: newTitle
            });
            return;
        }
        if ((0, $aX7Cy.checkDocumentTitle)(context, state.contextArray)) {
            const newTitle = $a1d3af230daa7254$var$generateTitle(title, titleSuffix);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.title = newTitle;
            setState({
                title: newTitle
            });
        }
    };

});




parcelRegister("eSznd", function(module, exports) {

$parcel$export(module.exports, "UiManagers", () => $ca023ab667a452ba$export$41286c339a88ca24);
/* eslint-disable jira/react-magnetic-di/no-unneeded */ 
var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $e0Brz = parcelRequire("e0Brz");

var $5zgk6 = parcelRequire("5zgk6");

var $9rAvm = parcelRequire("9rAvm");
let $ca023ab667a452ba$var$ClientUiManagers = (0, $5uXOq.Fragment);
if (!false) // @ts-expect-error - TS2741 - Property '$$typeof' is missing in type '({ children }: ClientUiManagersProps) => JSX.Element' but required in type 'ExoticComponent<{ children?: ReactNode; }>'.
$ca023ab667a452ba$var$ClientUiManagers = (0, $9rAvm.ClientUiManagers);
const $ca023ab667a452ba$export$41286c339a88ca24 = ({ children: children })=>{
    (0, $gKZoD.di)($ca023ab667a452ba$var$ClientUiManagers);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5zgk6.LayoutManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0Brz.BreadcrumbManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ca023ab667a452ba$var$ClientUiManagers, null, children)));
};

});
parcelRegister("e0Brz", function(module, exports) {

$parcel$export(module.exports, "BreadcrumbManager", () => $e20dc5e8426041f9$export$cd5073909dd92c28);

var $5uXOq = parcelRequire("5uXOq");

var $aIVNN = parcelRequire("aIVNN");
const $e20dc5e8426041f9$export$cd5073909dd92c28 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aIVNN.BreadcrumbContainer), null, children);

});

parcelRegister("5zgk6", function(module, exports) {

$parcel$export(module.exports, "LayoutManager", () => $20f0b1159f4863ef$export$4a04ad01c410b415);

var $5uXOq = parcelRequire("5uXOq");

var $c34Wf = parcelRequire("c34Wf");

var $lODMY = parcelRequire("lODMY");
var $2YP9W = parcelRequire("2YP9W");

var $gg7kZ = parcelRequire("gg7kZ");

var $8CM3x = parcelRequire("8CM3x");

var $5e5zm = parcelRequire("5e5zm");
const $20f0b1159f4863ef$var$LayoutContainer = (0, $gg7kZ.createContainer)((0, $5e5zm.layoutStore), {
    displayName: 'JiraLayoutContainer',
    onInit: ()=>({ dispatch: dispatch }, { leftSidebar: leftSidebar, rightSidebar: rightSidebar, isChromeless: isChromeless })=>{
            dispatch((0, $8CM3x.actions).setIsChromeless(isChromeless));
            dispatch((0, $8CM3x.actions).setLeftSidebarState(leftSidebar));
            dispatch((0, $8CM3x.actions).setRightSidebarState(rightSidebar));
        },
    onUpdate: ()=>({ dispatch: dispatch }, { isChromeless: isChromeless })=>{
            dispatch((0, $8CM3x.actions).setIsChromeless(isChromeless));
        }
});
const $20f0b1159f4863ef$var$DEFFAULT_RIGHT_SIDEBAR_STATE = {
    stackState: []
};
const $20f0b1159f4863ef$var$useIsChromeless = (0, $lODMY.createRouterSelector)((state)=>state.route.layout?.isChromeless === true || state.route.entryPoint?.()?.toString() === 'ChromelessEntryPoint');
const $20f0b1159f4863ef$export$4a04ad01c410b415 = ({ children: children })=>{
    const { data: data } = (0, $2YP9W.useResource)((0, $c34Wf.navigationUiStateResource));
    const isChromeless = $20f0b1159f4863ef$var$useIsChromeless();
    const isLeftSidebarCollapsed = data?.leftSidebar?.isCollapsed ?? false;
    const leftSidebarWidth = data?.leftSidebar?.width ?? (0, $5e5zm.DEFAULT_LEFT_SIDEBAR_WIDTH);
    const leftSidebar = (0, $5uXOq.useMemo)(()=>({
            isVisible: true,
            isCollapsed: isLeftSidebarCollapsed,
            width: leftSidebarWidth,
            isFlyoutOpen: false
        }), [
        isLeftSidebarCollapsed,
        leftSidebarWidth
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($20f0b1159f4863ef$var$LayoutContainer, {
        isGlobal: true,
        isChromeless: isChromeless,
        leftSidebar: leftSidebar,
        rightSidebar: $20f0b1159f4863ef$var$DEFFAULT_RIGHT_SIDEBAR_STATE
    }, children);
};

});

parcelRegister("9rAvm", function(module, exports) {

$parcel$export(module.exports, "ClientUiManagers", () => $2b5f3846e82b020b$export$d1db6ae5bf84e489);

var $5uXOq = parcelRequire("5uXOq");

var $imZsD = parcelRequire("imZsD");

var $6pvrS = parcelRequire("6pvrS");

var $4041n = parcelRequire("4041n");

var $pa9q9 = parcelRequire("pa9q9");

var $2HbP2 = parcelRequire("2HbP2");

var $6mahi = parcelRequire("6mahi");

var $4yEIl = parcelRequire("4yEIl");

var $bKCrm = parcelRequire("bKCrm");
const $2b5f3846e82b020b$export$d1db6ae5bf84e489 = ({ children: children })=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2HbP2.ModalContextProvider), null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6pvrS.CrossFlowProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4yEIl.PostOfficeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bKCrm.ProjectCreateDrawerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4041n.FavoriteChangeProvider), {
        onShowFlag: showFlag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6mahi.ModalContextProvider), null, content))))));
};

});
parcelRegister("6pvrS", function(module, exports) {

$parcel$export(module.exports, "CrossFlowProvider", () => $2cd77fddb456dca8$export$d900e4062895cd7c);

var $5uXOq = parcelRequire("5uXOq");

var $882vQ = parcelRequire("882vQ");

var $fjcgS = parcelRequire("fjcgS");

var $koeKL = parcelRequire("koeKL");

var $DVljb = parcelRequire("DVljb");

var $eIGIx = parcelRequire("eIGIx");

var $4R6GH = parcelRequire("4R6GH");

var $g2XuF = parcelRequire("g2XuF");

var $5emZd = parcelRequire("5emZd");
// DELOR-412 Remove explicit mock once we make analytics a no-op in SSR
const $2cd77fddb456dca8$var$getAnalyticsInstance = ()=>false ? Promise.resolve({
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        sendUIEvent: ()=>{},
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        sendOperationalEvent: ()=>{},
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        sendTrackEvent: ()=>{},
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        sendScreenEvent: ()=>{}
    }) : (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>client.getInstance());
const $2cd77fddb456dca8$export$d900e4062895cd7c = ({ children: children })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const locale = (0, $DVljb.useLocale)();
    const analyticsClient = (0, $eIGIx.useMemoWithCondition)(()=>$2cd77fddb456dca8$var$getAnalyticsInstance(), [], ()=>(0, $4R6GH.fg)('jfp_magma_issue-stability-phase1'));
    const plugins = (0, $eIGIx.useMemoWithCondition)(()=>[
            (0, $g2XuF.getContainersPlugin),
            (0, $5emZd.getUsersPlugin)
        ], [], ()=>(0, $4R6GH.fg)('jfp_magma_issue-stability-phase1'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $882vQ.default), {
        cloudId: cloudId,
        // @ts-expect-error - TS2322 - Type 'Promise<typeof AnalyticsWebClient> | Promise<{ sendUIEvent: () => void; sendOperationalEvent: () => void; sendTrackEvent: () => void; sendScreenEvent: () => void; }>' is not assignable to type 'MaybePromise<AnalyticsWebClientInterface>'.
        analyticsClient: analyticsClient,
        locale: locale,
        plugins: plugins
    }, children);
};

});
parcelRegister("882vQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $25c23a8ec43eecca$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dao3I = parcelRequire("dao3I");

const $25c23a8ec43eecca$var$JiraProvider = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dao3I.CrossFlowProvider), {
        ...props,
        originProduct: "jira"
    });
};
var $25c23a8ec43eecca$export$2e2bcd8739ae039 = $25c23a8ec43eecca$var$JiraProvider;

});
parcelRegister("dao3I", function(module, exports) {

$parcel$export(module.exports, "CrossFlowProvider", () => $1615837ea7cb5623$export$d900e4062895cd7c);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bHpB9 = parcelRequire("bHpB9");

var $cSyk1 = parcelRequire("cSyk1");

var $82zEM = parcelRequire("82zEM");

var $3lpON = parcelRequire("3lpON");

var $3OuEq = parcelRequire("3OuEq");

var $iVEiS = parcelRequire("iVEiS");

var $5cLUX = parcelRequire("5cLUX");

var $7TqdN = parcelRequire("7TqdN");

var $h2lEj = parcelRequire("h2lEj");

const $1615837ea7cb5623$var$IntegrationView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("lldDc")));
const $1615837ea7cb5623$export$79d79d8dd8574306 = (IntegrationView)=>(props)=>{
        const { children: children, analyticsClient: analyticsClient, originProduct: originProduct, redirectToWac: redirectToWac, env: env, plugins: plugins = [], globalExperimentalOptions: globalExperimentalOptions, onError: onError, ...baseProviderProps } = props;
        const onCloseResolver = (0, $5uXOq.useRef)();
        const [firstHandshakeReceived, setFirstHandshakeReceived] = (0, $5uXOq.useState)(false);
        const fireEvent = (0, $5uXOq.useMemo)(()=>(0, $82zEM.analyticsWrapper)(analyticsClient), [
            analyticsClient
        ]);
        const [requestOptions, setRequestOptions] = (0, $5uXOq.useState)();
        const onAnalyticsEvent = (0, $5uXOq.useCallback)((payload)=>{
            const gasV3Event = (0, $3lpON.transformEvent)(payload);
            if (gasV3Event) {
                const enrichedEvent = (0, $7TqdN.enrichWithRequestOptions)((0, $5cLUX.enrichWithPackageDetails)(gasV3Event), requestOptions);
                fireEvent(enrichedEvent);
            }
        }, [
            fireEvent,
            requestOptions
        ]);
        const onHandShake = (0, $5uXOq.useCallback)((appName)=>{
            if (!firstHandshakeReceived) {
                onAnalyticsEvent({
                    payload: {
                        eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
                        action: (0, $h2lEj.uiInitialized),
                        actionSubject: (0, $h2lEj.crossFlowActionSubject),
                        attributes: {
                            appName: appName
                        }
                    },
                    context: [
                        {
                            source: $h2lEj.source
                        }
                    ]
                });
                setFirstHandshakeReceived(true);
            }
        }, [
            firstHandshakeReceived,
            onAnalyticsEvent
        ]);
        const onOpen = (0, $5uXOq.useCallback)((options)=>{
            /**
     * Reset first handshake state to ensure 1:1 value of open invoked and handshake received
     * Caveat that if open api is invoked while cross flow support UI is already mounted there will be mismatch of openInvoked events to uiInitialized events
     */ setFirstHandshakeReceived(false);
            const analyticsEvent = {
                // setRequestOptions does not update the state right away (updates on the next render) so for the openInvoked event we need to manually append the sourceComponent and sourceContext
                payload: (0, $7TqdN.enrichWithRequestOptions)({
                    eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
                    action: (0, $h2lEj.openInvoked),
                    actionSubject: (0, $h2lEj.crossFlowActionSubject)
                }, options),
                context: [
                    {
                        source: $h2lEj.source
                    }
                ]
            };
            onAnalyticsEvent(analyticsEvent);
            // Short circuit requestOptions for WAC expansions
            if (options.journey === (0, $bHpB9.Journeys).GET_STARTED && redirectToWac) {
                (0, $3OuEq.setProductSignUpLocation)(options.targetProduct, env, options.sourceComponent, options.sourceContext);
                const completionStatus = {};
                return Promise.resolve(completionStatus);
            }
            const updatedExperimentalOptions = {
                ...globalExperimentalOptions || {},
                // "globalExperimentalOptions" will be injected to EVERY crossFlow invoke
                ...options.experimentalOptions || {} // "options.experimentalOptions" takes care of passing experimentalOptions to ONE specific crossFlow invoke
            };
            options.experimentalOptions = updatedExperimentalOptions;
            setRequestOptions(options);
            return new Promise((resolve)=>{
                onCloseResolver.current = resolve;
            });
        }, [
            onAnalyticsEvent,
            env,
            redirectToWac,
            globalExperimentalOptions
        ]);
        const onClose = (0, $5uXOq.useCallback)((completionStatus)=>{
            setFirstHandshakeReceived(false);
            setRequestOptions(undefined);
            onCloseResolver.current && onCloseResolver.current(completionStatus);
        }, []);
        const { colorMode: colorMode } = (0, $cSyk1.default)();
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bHpB9.BaseCrossFlowApiProvider), {
            onOpen: onOpen,
            children: [
                children,
                requestOptions && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iVEiS.ErrorBoundary), {
                    onAnalyticsEvent: onAnalyticsEvent,
                    onError: onError,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                        fallback: null,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)(IntegrationView, {
                            ...baseProviderProps,
                            ...requestOptions,
                            onAnalyticsEvent: onAnalyticsEvent,
                            originProduct: originProduct,
                            theme: colorMode,
                            onClose: onClose,
                            onHandShake: onHandShake,
                            plugins: plugins,
                            env: env,
                            redirectToWac: redirectToWac,
                            zIndex: requestOptions.zIndex ?? 1000
                        })
                    })
                })
            ]
        });
    };
const $1615837ea7cb5623$export$d900e4062895cd7c = $1615837ea7cb5623$export$79d79d8dd8574306($1615837ea7cb5623$var$IntegrationView);

});
parcelRegister("82zEM", function(module, exports) {

$parcel$export(module.exports, "analyticsWrapper", () => $b24c5aab06626f3f$export$91b4dd3bfc301325);

const $b24c5aab06626f3f$export$91b4dd3bfc301325 = (analyticsClient)=>{
    return (event)=>{
        return Promise.resolve(analyticsClient).then((client)=>{
            switch(event.eventType){
                case 0, $676c5e519aa5ba55$export$a1562d08625f5d7e:
                    client.sendUIEvent(event);
                    break;
                case 0, $676c5e519aa5ba55$export$947dac6c72b26f81:
                    client.sendTrackEvent(event);
                    break;
                case 0, $676c5e519aa5ba55$export$12346a674644c156:
                    client.sendOperationalEvent(event);
                    break;
                case 0, $676c5e519aa5ba55$export$f1d537d508d2945a:
                    client.sendScreenEvent(event);
                    break;
            }
        });
    };
};

});

parcelRegister("3lpON", function(module, exports) {

$parcel$export(module.exports, "transformEvent", () => $3b1dc20af714f949$export$3f40e8c44448be30);
// Copied from xflow-ui. We post raw analytics events (context and payload only) from xflow-ui to consumer (CFE), transform on consumer and post to gasv3.

const $3b1dc20af714f949$var$GROWTH_TAG = 'growth';
const $3b1dc20af714f949$var$extractFromEventContext = (propertyNames, context)=>context.reduce((acc, contextItem)=>{
        propertyNames.forEach((propertyName)=>{
            const navContextProp = contextItem ? contextItem[propertyName] : null;
            acc.push(navContextProp || contextItem[propertyName]);
        });
        return acc;
    }, []).filter(Boolean);
const $3b1dc20af714f949$var$getSources = (context)=>$3b1dc20af714f949$var$extractFromEventContext([
        'source'
    ], context);
const $3b1dc20af714f949$var$getExtraAttributes = (context)=>context.reduce((ans, { attributes: attributes, ...contextProps })=>{
        const newAttributes = {
            ...ans,
            ...contextProps
        };
        return attributes ? {
            ...newAttributes,
            ...attributes
        } : newAttributes;
    }, {});
const $3b1dc20af714f949$var$getPackageInfo = (context)=>context.map((contextItem)=>({
            packageName: contextItem.packageName,
            packageVersion: contextItem.packageVersion
        })).filter((p)=>p.packageName);
const $3b1dc20af714f949$var$last = (values)=>values[values.length - 1];
const $3b1dc20af714f949$export$3f40e8c44448be30 = (event)=>{
    const { context: context, payload: payload } = event;
    if (!payload) return null;
    const sources = $3b1dc20af714f949$var$getSources(context);
    const source = $3b1dc20af714f949$var$last(sources) || (0, $676c5e519aa5ba55$export$b055de0e665cb20c);
    const extraAttributes = $3b1dc20af714f949$var$getExtraAttributes(context);
    const { packageName: packageName, packageVersion: packageVersion } = $3b1dc20af714f949$var$last($3b1dc20af714f949$var$getPackageInfo(context)) || {};
    const { eventType: eventType = (0, $676c5e519aa5ba55$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = payload;
    const attributes = {
        packageName: packageName,
        packageVersion: packageVersion,
        ...extraAttributes,
        ...payloadAttributes
    };
    const tags = payload.tags || [];
    tags.push($3b1dc20af714f949$var$GROWTH_TAG);
    switch(eventType){
        case 0, $676c5e519aa5ba55$export$a1562d08625f5d7e:
        case 0, $676c5e519aa5ba55$export$12346a674644c156:
        case 0, $676c5e519aa5ba55$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: tags.slice(0)
            };
        case 0, $676c5e519aa5ba55$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                source: source,
                tags: tags.slice(0)
            };
        default:
            break;
    }
    return null;
};

});

parcelRegister("3OuEq", function(module, exports) {

$parcel$export(module.exports, "setProductSignUpLocation", () => $67a1e1e75aba157c$export$2827e2473cb9a346);

var $jWY5k = parcelRequire("jWY5k");


var $ADfeX = parcelRequire("ADfeX");
const $67a1e1e75aba157c$var$utmCampaignMap = {
    'atlassian-switcher': (0, $ADfeX.UtmCampaign)['atlassian-switcher']
};
const $67a1e1e75aba157c$var$isBundledProduct = (productKey)=>{
    return [
        (0, $jWY5k.Targets).JIRA_SOFTWARE,
        (0, $jWY5k.Targets).JIRA_SERVICE_DESK,
        (0, $jWY5k.Targets).JIRA_CORE,
        (0, $jWY5k.Targets).CONFLUENCE
    ].includes(productKey);
};
const $67a1e1e75aba157c$var$getBundleSignUpParams = (productKey)=>{
    const bundles = {
        [(0, $jWY5k.Targets).JIRA_SOFTWARE]: 'jira-software',
        [(0, $jWY5k.Targets).JIRA_SERVICE_DESK]: 'jira-service-desk',
        [(0, $jWY5k.Targets).JIRA_CORE]: 'jira-core',
        [(0, $jWY5k.Targets).CONFLUENCE]: 'confluence'
    };
    // Bundles default to free
    return `bundle=${bundles[productKey]}&edition=free`;
};
const $67a1e1e75aba157c$var$isProductWithCustomSignUpPath = (productKey)=>{
    return [
        (0, $jWY5k.Targets).OPSGENIE
    ].includes(productKey);
};
const $67a1e1e75aba157c$var$getProductCustomSignUpPath = (productKey)=>{
    // Only Opsgenie. Trello, Bitbucket and Statuspage are handled by Product Store directly.
    const links = {
        [(0, $jWY5k.Targets).OPSGENIE]: (0, $e3b3c434f6296013$export$fb1e43fdafe12e9b)
    };
    return links[productKey];
};
const $67a1e1e75aba157c$var$isSourceComponentWithUtmParams = (sourceComponent)=>{
    return Boolean($67a1e1e75aba157c$var$utmCampaignMap[sourceComponent]);
};
const $67a1e1e75aba157c$var$getUtmParams = (sourceComponent, sourceContext)=>{
    let utmParams = '';
    if (sourceComponent && $67a1e1e75aba157c$var$isSourceComponentWithUtmParams(sourceComponent)) {
        utmParams = utmParams + `utm_campaign=${$67a1e1e75aba157c$var$utmCampaignMap[sourceComponent]}&utm_medium=in_product_ad`;
        if (sourceContext) utmParams = utmParams + `&utm_source=${sourceContext}`;
    }
    return utmParams;
};
const $67a1e1e75aba157c$export$39eab502fc96327d = (productKey, env, sourceComponent, sourceContext)=>{
    const wacUrl = env === 'staging' ? (0, $e3b3c434f6296013$export$c37558e5c67d2b01) : (0, $e3b3c434f6296013$export$f199baf8dfc7621e);
    const utmParams = $67a1e1e75aba157c$var$getUtmParams(sourceComponent, sourceContext);
    let queryParams = '';
    let bundleParams = '';
    let path = (0, $e3b3c434f6296013$export$2a45a00073911255);
    if ($67a1e1e75aba157c$var$isBundledProduct(productKey)) {
        path = (0, $e3b3c434f6296013$export$e6c04a1dd86d1c14);
        bundleParams = $67a1e1e75aba157c$var$getBundleSignUpParams(productKey);
    } else if ($67a1e1e75aba157c$var$isProductWithCustomSignUpPath(productKey)) path = $67a1e1e75aba157c$var$getProductCustomSignUpPath(productKey);
    if (!!bundleParams) queryParams = queryParams + `?${bundleParams}`;
    if (!!utmParams) queryParams = queryParams + (!!queryParams ? '&' : '?') + utmParams;
    return wacUrl + path + queryParams;
};
const $67a1e1e75aba157c$export$2827e2473cb9a346 = (productKey, env = 'production', sourceComponent, sourceContext)=>{
    const url = $67a1e1e75aba157c$export$39eab502fc96327d(productKey, env, sourceComponent, sourceContext);
    window.open(url, '_blank');
};

});
const $e3b3c434f6296013$export$c37558e5c67d2b01 = 'https://qa-wac.internal.atlassian.com';
const $e3b3c434f6296013$export$f199baf8dfc7621e = 'https://www.atlassian.com';
const $e3b3c434f6296013$export$fb1e43fdafe12e9b = '/software/opsgenie/try';
const $e3b3c434f6296013$export$e6c04a1dd86d1c14 = '/try/cloud/signup';
const $e3b3c434f6296013$export$2a45a00073911255 = '/software';

parcelRegister("ADfeX", function(module, exports) {

$parcel$export(module.exports, "UtmCampaign", () => $640d6f0c65fd4030$export$fc604aa353a97e10);
var $640d6f0c65fd4030$export$fc604aa353a97e10 = /*#__PURE__*/ function(UtmCampaign) {
    UtmCampaign["atlassian-switcher"] = "atlassian_switcher";
    return UtmCampaign;
}({});

});


parcelRegister("iVEiS", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $d3d63fce8596c929$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");

var $h2lEj = parcelRequire("h2lEj");
const $d3d63fce8596c929$var$name = "platform-pkg";
const $d3d63fce8596c929$var$version = "0.0.0-use.local";
const $d3d63fce8596c929$var$payload = {
    eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
    action: (0, $h2lEj.errorBoundaryAction),
    actionSubject: (0, $h2lEj.errorBoundaryActionSubject)
};
const $d3d63fce8596c929$var$context = [
    {
        source: $h2lEj.source
    },
    {
        packageName: $d3d63fce8596c929$var$name,
        packageVersion: $d3d63fce8596c929$var$version
    }
];
class $d3d63fce8596c929$export$e926676385687eaf extends (0, $5uXOq.Component) {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch(error) {
        this.props.onAnalyticsEvent({
            payload: $d3d63fce8596c929$var$payload,
            context: $d3d63fce8596c929$var$context
        });
        if (this.props.onError) this.props.onError(error);
    }
    render() {
        if (this.state.hasError) return null;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            hasError: false
        };
    }
}

});
parcelRegister("h2lEj", function(module, exports) {

$parcel$export(module.exports, "source", () => $9517cbf005e80ab1$export$b4d5da5f34fb77ad);
$parcel$export(module.exports, "errorBoundaryAction", () => $9517cbf005e80ab1$export$9d8252a268f4fa72);
$parcel$export(module.exports, "errorBoundaryActionSubject", () => $9517cbf005e80ab1$export$1045419caf49b395);
$parcel$export(module.exports, "crossFlowActionSubject", () => $9517cbf005e80ab1$export$d54c183f56e39aa5);
$parcel$export(module.exports, "uiInitialized", () => $9517cbf005e80ab1$export$e5c2c058fa8068a6);
$parcel$export(module.exports, "openInvoked", () => $9517cbf005e80ab1$export$e67cdcb8867a3bd0);

const $9517cbf005e80ab1$export$b4d5da5f34fb77ad = 'crossFlowProvider';
const $9517cbf005e80ab1$export$9d8252a268f4fa72 = 'errorCaught';
const $9517cbf005e80ab1$export$1045419caf49b395 = 'errorBoundary';
const $9517cbf005e80ab1$export$d54c183f56e39aa5 = 'crossFlowSupport';
const $9517cbf005e80ab1$export$e5c2c058fa8068a6 = 'uiInitialized';
const $9517cbf005e80ab1$export$e67cdcb8867a3bd0 = 'openInvoked';

});


parcelRegister("5cLUX", function(module, exports) {

$parcel$export(module.exports, "enrichWithPackageDetails", () => $20ff5e7e37c2b429$export$59518efab336a8b5);
const $20ff5e7e37c2b429$var$version = "0.0.0-use.local";
const $20ff5e7e37c2b429$export$84f9cf7ef89d4c26 = {
    version: $20ff5e7e37c2b429$var$version
};
const $20ff5e7e37c2b429$export$59518efab336a8b5 = (event)=>{
    const attributes = {
        ...event.attributes || {},
        crossFlowSupport: $20ff5e7e37c2b429$export$84f9cf7ef89d4c26
    };
    return {
        ...event,
        attributes: attributes
    };
};

});

parcelRegister("7TqdN", function(module, exports) {

$parcel$export(module.exports, "enrichWithRequestOptions", () => $f9ac334198e2c83e$export$a5a156dc5df42f0);
const $f9ac334198e2c83e$export$a5a156dc5df42f0 = (event, requestOptions)=>{
    if (!requestOptions) return event;
    const attributes = {
        // Spread the extra analytics attributes first, because we don't want consumers to override any event attributes below
        ...requestOptions.extraAnalyticsAttributes || {},
        ...event.attributes || {},
        sourceComponent: requestOptions.sourceComponent,
        sourceContext: requestOptions.sourceContext
    };
    return {
        ...event,
        attributes: attributes
    };
};

});

parcelRegister("lldDc", function(module, exports) {

let $f896220282de9989$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f896220282de9989$var$load("76n7a"),
    $f896220282de9989$var$load("l253H"),
    $f896220282de9989$var$load("ffQaD"),
    $f896220282de9989$var$load("kvRbA"),
    $f896220282de9989$var$load("8Gs9e")
]).then(()=>parcelRequire('an4UX'));

});



parcelRegister("g2XuF", function(module, exports) {

$parcel$export(module.exports, "getContainersPlugin", () => $014cd965663d7125$export$81d1d40061d190bc);
parcelRequire("eZVkU");
var $3DVw8 = parcelRequire("3DVw8");
var $eZVkU = parcelRequire("eZVkU");

var $4Pf62 = parcelRequire("4Pf62");
const $014cd965663d7125$var$getCloudId = async ()=>{
    const { cloudName: cloudName, cloudId: cloudId } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const containers = [
        {
            id: cloudId,
            displayName: cloudName,
            type: (0, $3DVw8.ContainerTypes).ATLASSIAN_CLOUD_ID
        }
    ];
    return {
        type: (0, $3DVw8.ContainerTypes).ATLASSIAN_CLOUD_ID,
        containers: containers
    };
};
const $014cd965663d7125$export$81d1d40061d190bc = (0, $eZVkU.createGetContainersPlugin)($014cd965663d7125$var$getCloudId);

});
parcelRegister("eZVkU", function(module, exports) {

$parcel$export(module.exports, "createGetContainersPlugin", () => $b5c1d3bea11e821b$export$76378b0f825c024c);
$parcel$export(module.exports, "createGetUsersPlugin", () => $b5c1d3bea11e821b$export$8feb7eae83cf8cd5);
$parcel$export(module.exports, "ContainerTypes", () => (parcelRequire("3DVw8")).ContainerTypes);
$parcel$export(module.exports, "UserIdTypes", () => (parcelRequire("3DVw8")).UserIdTypes);

var $3DVw8 = parcelRequire("3DVw8");
const $b5c1d3bea11e821b$export$76378b0f825c024c = (fetch)=>{
    return [
        (0, $3DVw8.PluginTypes).GetContainers,
        fetch
    ];
};
const $b5c1d3bea11e821b$export$8feb7eae83cf8cd5 = (fetch)=>{
    return [
        (0, $3DVw8.PluginTypes).GetUsers,
        fetch
    ];
};
const $b5c1d3bea11e821b$export$21d120847be2aff4 = (fetch)=>{
    return [
        (0, $3DVw8.PluginTypes).GetSuggestedSiteNames,
        fetch
    ];
};
const $b5c1d3bea11e821b$export$d7c1699c6a2ca18a = (fetch)=>{
    return [
        (0, $3DVw8.PluginTypes).GetAvailableSites,
        fetch
    ];
};

});
parcelRegister("3DVw8", function(module, exports) {

$parcel$export(module.exports, "PluginTypes", () => $f763104318ce258c$export$a235a73f7b906dce);
$parcel$export(module.exports, "ContainerTypes", () => $f763104318ce258c$export$6e383182a26455ff);
$parcel$export(module.exports, "UserIdTypes", () => $f763104318ce258c$export$e391bab95adb8396);
// Data Plugin definition and utility types
const $f763104318ce258c$export$a235a73f7b906dce = {
    GetContainers: 'GetContainers',
    GetUsers: 'GetUsers',
    GetSuggestedSiteNames: 'GetSuggestedSiteNames',
    GetAvailableSites: 'GetAvailableSites'
};
const $f763104318ce258c$export$6e383182a26455ff = {
    BITBUCKET_WORKSPACE: 'bitbucket-workspace',
    ATLASSIAN_CLOUD_ID: 'ATLASSIAN_CLOUD_ID',
    JIRA_SOFTWARE_PROJECT: 'JIRA_SOFTWARE_PROJECT'
};
const $f763104318ce258c$export$e391bab95adb8396 = {
    ATLASSIAN_ACCOUNT_ID: 'ATLASSIAN_ACCOUNT_ID',
    TRELLO_ID: 'TRELLO_ID'
};
const $f763104318ce258c$export$4f378ba35c571906 = {
    JIRA_BUSINESS: 'JIRA_BUSINESS',
    JIRA_SERVICE_DESK: 'JIRA_SERVICE_DESK',
    JIRA_SOFTWARE: 'JIRA_SOFTWARE',
    CONFLUENCE: 'CONFLUENCE',
    OPSGENIE: 'OPSGENIE',
    BITBUCKET: 'BITBUCKET',
    STATUSPAGE: 'STATUSPAGE',
    TRELLO: 'TRELLO',
    COMPASS: 'COMPASS'
};

});



parcelRegister("5emZd", function(module, exports) {

$parcel$export(module.exports, "getUsersPlugin", () => $83dd2c216cba0381$export$7c44908d2777db01);

var $eZVkU = parcelRequire("eZVkU");
var $3DVw8 = parcelRequire("3DVw8");
const $83dd2c216cba0381$var$getUsers = async (containerId)=>{
    const getUsersUrl = `/gateway/api/xflow/${containerId}/fetch-instance-users`;
    try {
        const response = await fetch(getUsersUrl, {
            credentials: 'same-origin'
        });
        if (response.ok) {
            const data = await response.json();
            return data.map((value)=>({
                    id: value.id,
                    idType: (0, $3DVw8.UserIdTypes).ATLASSIAN_ACCOUNT_ID,
                    displayName: value.displayName
                }));
        }
        throw new Error(`Unexpected response from ${getUsersUrl} ${response.status} ${response.statusText}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw new Error(`Unable to fetch ${getUsersUrl} ${error.message}`);
    }
};
const $83dd2c216cba0381$export$7c44908d2777db01 = (0, $eZVkU.createGetUsersPlugin)($83dd2c216cba0381$var$getUsers);

});


parcelRegister("2HbP2", function(module, exports) {

$parcel$export(module.exports, "ModalContextProvider", () => $d012230882eb31a4$export$7c9538f5f3c365e9);

var $5uXOq = parcelRequire("5uXOq");

var $i8Qvm = parcelRequire("i8Qvm");

var $gJdig = parcelRequire("gJdig");
const $d012230882eb31a4$var$RenderModal = ({ modal: modal })=>{
    const [shouldCloseOnOverlayClick, setShouldCloseOnOverlayClick] = (0, $5uXOq.useState)();
    const [shouldCloseOnEscapePress, setShouldCloseOnEscapePress] = (0, $5uXOq.useState)();
    const Component = modal.component;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
        onClose: modal.close,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
        setShouldCloseOnEscapePress: setShouldCloseOnEscapePress
    });
};
function $d012230882eb31a4$export$7c9538f5f3c365e9({ children: children }) {
    const id = (0, $5uXOq.useRef)(1);
    const [modals, setModals] = (0, $5uXOq.useState)([]);
    const modalContext = (0, $5uXOq.useMemo)(()=>({
            openModal: (component)=>{
                const key = String(id.current++);
                const close = ()=>{
                    setModals((mdls)=>mdls.filter((d)=>d.key !== key));
                };
                setModals((mdls)=>[
                        ...mdls,
                        {
                            close: close,
                            component: component,
                            key: key
                        }
                    ]);
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gJdig.ModalContext).Provider, {
        value: modalContext
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, modals.map((modal)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d012230882eb31a4$var$RenderModal, {
            key: modal.key,
            modal: modal
        });
    })));
}

});



parcelRegister("ivvwC", function(module, exports) {

$parcel$export(module.exports, "UserContainers", () => $0fd080febb09e205$export$c1b371eec908681a);

var $5uXOq = parcelRequire("5uXOq");

var $d9VAQ = parcelRequire("d9VAQ");

var $leRCk = parcelRequire("leRCk");
const $0fd080febb09e205$export$c1b371eec908681a = ({ baseUrl: baseUrl, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $leRCk.UserContainer), {
        isGlobal: true,
        baseUrl: baseUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9VAQ.UserPreferencesContainer), {
        isGlobal: true
    }, children));

});
parcelRegister("d9VAQ", function(module, exports) {

$parcel$export(module.exports, "UserPreferencesContainer", () => $3038471ea054300f$export$aa278641ded1adf);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $51nlc = parcelRequire("51nlc");

var $eYegl = parcelRequire("eYegl");
const $3038471ea054300f$export$be74e04eaea4530 = (0, $51nlc.createSubscriber)((0, $eYegl.default), {
    displayName: 'UserPreferencesSubscriber'
});
const $3038471ea054300f$export$aa278641ded1adf = (0, $gg7kZ.createContainer)((0, $eYegl.default));

});
parcelRegister("eYegl", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc414d73e667f785$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iXqE5 = parcelRequire("iXqE5");

var $7AJyg = parcelRequire("7AJyg");
const $bc414d73e667f785$var$initialState = {
    'issue-view-experiment': {
        data: {
            value: false
        },
        loading: false,
        error: null
    }
};
var // @ts-expect-error - TS2344 - Type 'typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/services/user-preferences/src/actions/index")' does not satisfy the constraint 'Record<string, ActionThunk<State, typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/services/user-preferences/src/actions/index")>>'.
$bc414d73e667f785$export$2e2bcd8739ae039 = (0, $iXqE5.createStore)({
    name: 'user-preference',
    initialState: $bc414d73e667f785$var$initialState,
    actions: $7AJyg
});

});
parcelRegister("7AJyg", function(module, exports) {

$parcel$export(module.exports, "fetch", () => (parcelRequire("g6Vt5")).default);
$parcel$export(module.exports, "fetchIssueCreate", () => (parcelRequire("ePV4l")).default);
$parcel$export(module.exports, "updateExperiment", () => (parcelRequire("8Lrq8")).default);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $g6Vt5 = parcelRequire("g6Vt5");

var $ePV4l = parcelRequire("ePV4l");

var $8Lrq8 = parcelRequire("8Lrq8");

});
parcelRegister("g6Vt5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a561c8a03710a3f2$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $goEOn = parcelRequire("goEOn");
var /**
 * Initiates data retrieval for a user preference, ensuring no duplicate requests are made.
 * Updates the application state with retrieved data or an error, accordingly.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$a561c8a03710a3f2$export$2e2bcd8739ae039 = (preferenceKey)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState();
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Readonly<State>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Readonly<State>'.
        if (currentState[preferenceKey] && currentState[preferenceKey].loading) return;
        setState({
            [preferenceKey]: {
                data: currentState.data,
                loading: true,
                error: null
            }
        });
        try {
            const data = await (0, $goEOn.default)({
                preferenceKey: preferenceKey
            });
            setState({
                [preferenceKey]: {
                    data: data,
                    loading: false,
                    error: null
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                [preferenceKey]: {
                    data: getState().data,
                    loading: false,
                    error: err
                }
            });
        }
    };

});
parcelRegister("goEOn", function(module, exports) {

$parcel$export(module.exports, "default", () => $0be3c96b3fac1b7f$export$2e2bcd8739ae039);

var $4Lzq2 = parcelRequire("4Lzq2");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0be3c96b3fac1b7f$export$2e2bcd8739ae039 = async ({ preferenceKey: preferenceKey })=>{
    try {
        const result = await (0, $4Lzq2.default)('', preferenceKey);
        return {
            value: result
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        if (e.statusCode === 404) return {
            value: undefined
        };
        throw e;
    }
};

});
parcelRegister("4Lzq2", function(module, exports) {

$parcel$export(module.exports, "default", () => $efdd8b3604a0d493$export$2e2bcd8739ae039);

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$efdd8b3604a0d493$export$2e2bcd8739ae039 = (baseUrl, key)=>{
    const requestUrl = `/rest/api/3/mypreferences?key=${key}`;
    return (0, $eusud.performGetRequest)(requestUrl);
};

});



parcelRegister("ePV4l", function(module, exports) {

$parcel$export(module.exports, "default", () => $01fcb0eb90bce4cf$export$2e2bcd8739ae039);

var $g6Vt5 = parcelRequire("g6Vt5");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$01fcb0eb90bce4cf$export$2e2bcd8739ae039 = ()=>(0, $g6Vt5.default)('issue-create');

});

parcelRegister("8Lrq8", function(module, exports) {

$parcel$export(module.exports, "default", () => $aea442a302ef98b1$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$aea442a302ef98b1$export$2e2bcd8739ae039 = (experimentKey, value)=>({ setState: setState })=>{
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: { data: { value: boolean; }; loading: false; error: null; }; }' is not assignable to parameter of type 'Partial<State>'.
        setState({
            [experimentKey]: {
                data: {
                    value: value
                },
                loading: false,
                error: null
            }
        });
    };

});





parcelRegister("dSF0Y", function(module, exports) {

$parcel$export(module.exports, "LinkingProviders", () => $f16da4c8bfe8fdca$export$a7964d2bf9ff001);

var $5uXOq = parcelRequire("5uXOq");

var $8dO33 = parcelRequire("8dO33");

var $dAfqg = parcelRequire("dAfqg");

var $4R6GH = parcelRequire("4R6GH");

var $hbQoJ = parcelRequire("hbQoJ");
const $f16da4c8bfe8fdca$export$a7964d2bf9ff001 = ({ children: children })=>{
    const { data: data } = (0, $dAfqg.useProjectContext)();
    const product = $f16da4c8bfe8fdca$var$getProductForSmartCardProvider(data);
    if ((0, $4R6GH.fg)('jira-glance-panel')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const smartCardProviderProps = (0, $hbQoJ.useGlobalObjectPreviewPanels)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8dO33.SmartCardProvider), {
            ...smartCardProviderProps,
            product: product,
            isAdminHubAIEnabled: data?.isAIEnabled ?? false
        }, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8dO33.SmartCardProvider), {
        product: product,
        isAdminHubAIEnabled: data?.isAIEnabled ?? false
    }, children);
};
const $f16da4c8bfe8fdca$var$getProductForSmartCardProvider = (project)=>{
    switch(project?.projectType){
        case 'software':
            return 'JSW';
        case 'business':
            return 'JWM';
        case 'service_desk':
            return 'JSM';
        case 'product_discovery':
            return 'JPD';
        default:
            return undefined;
    }
};

});
parcelRegister("8dO33", function(module, exports) {

$parcel$export(module.exports, "SmartCardProvider", () => $08b794feb02c83c1$export$497ecb0280204df4);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3f2cs = parcelRequire("3f2cs");

var $1UikQ = parcelRequire("1UikQ");

var $cCcdH = parcelRequire("cCcdH");

var $VSDnB = parcelRequire("VSDnB");

var $k9B19 = parcelRequire("k9B19");
var $dhQ1x = parcelRequire("dhQ1x");

var $8b7fu = parcelRequire("8b7fu");

var $051X7 = parcelRequire("051X7");

var $7cFR3 = parcelRequire("7cFR3");
function $08b794feb02c83c1$export$497ecb0280204df4({ storeOptions: storeOptions, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product, shouldControlDataExport: shouldControlDataExport, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel }) {
    const parentContext = (0, $5uXOq.useContext)((0, $051X7.SmartCardContext));
    const defaultInitialState = (0, $5uXOq.useMemo)(()=>{
        return {};
    }, []);
    const { initialState: initialState } = storeOptions || {
        initialState: defaultInitialState
    };
    const store = (0, $5uXOq.useMemo)(()=>{
        return (0, $3f2cs.createStore)((0, $8b7fu.cardReducer), initialState);
    }, [
        initialState
    ]);
    const providerValue = (0, $5uXOq.useMemo)(()=>{
        const client = customClient || new (0, $7cFR3.default)();
        // If product is passed into provider, set it on the client if setProduct is supported
        if (product && client.setProduct) client.setProduct(product);
        const authFlow = customAuthFlow || 'oauth2';
        const getPreview = (url, // @deprecated The support for platform will be removed and default to `web`
        platform)=>{
            const cardState = (0, $cCcdH.getUrl)(store, url);
            return cardState.details ? (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkEmbed)(cardState.details) : (0, $k9B19.extractPreview)(cardState.details.data, platform) : undefined;
        };
        return {
            renderers: renderers,
            store: store,
            prefetchStore: {},
            connections: {
                client: client
            },
            config: {
                authFlow: authFlow
            },
            extractors: {
                getPreview: getPreview
            },
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            product: product,
            shouldControlDataExport: shouldControlDataExport,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        };
    }, [
        customAuthFlow,
        customClient,
        isAdminHubAIEnabled,
        isPreviewPanelAvailable,
        openPreviewPanel,
        product,
        renderers,
        shouldControlDataExport,
        store
    ]);
    const value = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, parentContext || providerValue, {
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        }), [
        parentContext,
        providerValue,
        isPreviewPanelAvailable,
        openPreviewPanel
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $051X7.SmartCardContext).Provider, {
        value: (0, $VSDnB.fg)('gryf-5548_smart_card_provider_merge_props') ? value : parentContext || providerValue,
        children: children
    });
}
var $08b794feb02c83c1$export$2e2bcd8739ae039 = $08b794feb02c83c1$export$497ecb0280204df4;

});
parcelRegister("cCcdH", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $ca3b29c0c8dd3593$export$94df0e59ebebf4a7);
const $ca3b29c0c8dd3593$export$94df0e59ebebf4a7 = (store, url)=>{
    return store.getState()[url] || {
        status: 'pending'
    };
};

});

parcelRegister("k9B19", function(module, exports) {

$parcel$export(module.exports, "extractPreview", () => $596309a7bcc79771$export$4b0d98b1b7f6d115);

var $TFljV = parcelRequire("TFljV");

var $7OmtM = parcelRequire("7OmtM");
const $596309a7bcc79771$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd?.preview;
    const isSupported = (0, $TFljV.extractPlatformIsSupported)(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: (0, $7OmtM.extractUrlFromLinkJsonLd)(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: (0, $7OmtM.extractUrlFromLinkJsonLd)(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
};

});
parcelRegister("TFljV", function(module, exports) {

$parcel$export(module.exports, "extractPlatformIsSupported", () => $f8cdc1e628cbc347$export$3e8ad908070b68b2);
const $f8cdc1e628cbc347$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};

});

parcelRegister("7OmtM", function(module, exports) {

$parcel$export(module.exports, "extractUrlFromLinkJsonLd", () => $0784379594099aa0$export$396ba4ef2e37dc65);
const $0784379594099aa0$export$396ba4ef2e37dc65 = (link)=>{
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $0784379594099aa0$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
};

});


parcelRegister("dhQ1x", function(module, exports) {

$parcel$export(module.exports, "extractSmartLinkTitle", () => $084be06af531b246$export$3eda18658b66108);
$parcel$export(module.exports, "extractSmartLinkUrl", () => $084be06af531b246$export$7ba9b12c6a1b73de);
$parcel$export(module.exports, "extractSmartLinkAri", () => $084be06af531b246$export$16b02be3e2bb31ad);
$parcel$export(module.exports, "extractSmartLinkEmbed", () => $084be06af531b246$export$864b719baf5d744d);
$parcel$export(module.exports, "extractSmartLinkProvider", () => $084be06af531b246$export$ff753ed519e96e9e);
$parcel$export(module.exports, "extractSmartLinkCreatedOn", () => $084be06af531b246$export$7a685df468cbf38f);
$parcel$export(module.exports, "extractSmartLinkModifiedOn", () => $084be06af531b246$export$75047940e157fd1f);
$parcel$export(module.exports, "extractSmartLinkCreatedBy", () => $084be06af531b246$export$242875b46118beb2);
$parcel$export(module.exports, "extractSmartLinkAuthorGroup", () => $084be06af531b246$export$41fc716e1bc2dc90);
$parcel$export(module.exports, "extractSmartLinkModifiedBy", () => $084be06af531b246$export$7f099a839071a190);
$parcel$export(module.exports, "extractSmartLinkDownloadUrl", () => $084be06af531b246$export$96ed4c1b14ac210a);

var $VSDnB = parcelRequire("VSDnB");

var $hWyvy = parcelRequire("hWyvy");
var $8Tcl1 = parcelRequire("8Tcl1");
var $ccpJ1 = parcelRequire("ccpJ1");
var $8UXrm = parcelRequire("8UXrm");
var $4MmCl = parcelRequire("4MmCl");
var $g9Blp = parcelRequire("g9Blp");
var $f24gj = parcelRequire("f24gj");
var $iPUv2 = parcelRequire("iPUv2");

var $k9B19 = parcelRequire("k9B19");

var $kYwnb = parcelRequire("kYwnb");
const $084be06af531b246$export$3eda18658b66108 = (response, removeTextHighlightingFromTitle)=>{
    if ((0, $VSDnB.fg)('smart_links_noun_support')) {
        if ((0, $kYwnb.isEntityPresent)(response)) return (0, $kYwnb.extractEntity)(response)?.displayName;
    }
    return (0, $iPUv2.extractTitle)(response?.data, removeTextHighlightingFromTitle);
};
const $084be06af531b246$export$7ba9b12c6a1b73de = (response)=>{
    if ((0, $VSDnB.fg)('smart_links_noun_support')) {
        if ((0, $kYwnb.isEntityPresent)(response)) return (0, $kYwnb.extractEntity)(response)?.url;
    }
    return (0, $8UXrm.extractLink)(response?.data);
};
const $084be06af531b246$export$16b02be3e2bb31ad = (response)=>{
    if ((0, $VSDnB.fg)('smart_links_noun_support')) {
        if ((0, $kYwnb.isEntityPresent)(response)) return (0, $kYwnb.extractEntity)(response)?.ari || (0, $kYwnb.extractEntity)(response)?.thirdPartyAri;
    }
    const data = response?.data;
    return (0, $hWyvy.extractAri)(data);
};
const $084be06af531b246$export$864b719baf5d744d = (response, iframeUrlType)=>{
    if ((0, $VSDnB.fg)('smart_links_noun_support')) {
        if ((0, $kYwnb.isEntityPresent)(response)) {
            // TODO: Missing iframeUrlType
            const embedUrl = (0, $kYwnb.extractEntityEmbedUrl)(response);
            return embedUrl ? {
                src: embedUrl
            } : undefined;
        }
    }
    return (0, $k9B19.extractPreview)(response?.data, 'web', iframeUrlType);
};
const $084be06af531b246$export$ff753ed519e96e9e = (response)=>{
    if ((0, $VSDnB.fg)('smart_links_noun_support')) {
        if ((0, $kYwnb.isEntityPresent)(response)) return (0, $kYwnb.extractEntityProvider)(response);
    }
    return response?.data && (0, $f24gj.extractProvider)(response?.data);
};
const $084be06af531b246$export$7a685df468cbf38f = (response)=>{
    if ((0, $VSDnB.fg)('smart_links_noun_support')) {
        if ((0, $kYwnb.isEntityPresent)(response)) return (0, $kYwnb.extractEntity)(response)?.createdAt;
    }
    return response?.data && (0, $8Tcl1.extractDateCreated)(response.data);
};
const $084be06af531b246$export$75047940e157fd1f = (response)=>{
    if ((0, $VSDnB.fg)('smart_links_noun_support')) {
        if ((0, $kYwnb.isEntityPresent)(response)) return (0, $kYwnb.extractEntity)(response)?.lastUpdatedAt;
    }
    return response?.data && (0, $ccpJ1.extractDateUpdated)(response.data);
};
const $084be06af531b246$export$242875b46118beb2 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $VSDnB.fg)('smart_links_noun_support')) {
        if ((0, $kYwnb.isEntityPresent)(response)) return (0, $kYwnb.extractEntity)(response)?.createdBy?.displayName;
    }
    const persons = (0, $4MmCl.extractPersonCreatedBy)(response.data);
    return !!persons?.length ? persons[0].name : undefined;
};
const $084be06af531b246$export$41fc716e1bc2dc90 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $VSDnB.fg)('smart_links_noun_support')) {
        if ((0, $kYwnb.isEntityPresent)(response)) {
            const entity = (0, $kYwnb.extractEntity)(response);
            const owners = entity?.owners;
            if (owners) return owners.map((owner)=>({
                    name: owner.displayName,
                    src: owner.picture
                })).filter((item)=>!!item);
        }
    }
    return (0, $4MmCl.extractPersonCreatedBy)(response.data);
};
const $084be06af531b246$export$7f099a839071a190 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $VSDnB.fg)('smart_links_noun_support')) {
        if ((0, $kYwnb.isEntityPresent)(response)) return (0, $kYwnb.extractEntity)(response)?.lastUpdatedBy?.displayName;
    }
    const person = (0, $g9Blp.extractPersonUpdatedBy)(response.data);
    return person ? person.name : undefined;
};
const $084be06af531b246$export$96ed4c1b14ac210a = (response)=>{
    if ((0, $VSDnB.fg)('smart_links_noun_support')) {
        if ((0, $kYwnb.isEntityPresent)(response)) {
            const entity = (0, $kYwnb.extractEntity)(response);
            return entity && 'exportLinks' in entity && Array.isArray(entity.exportLinks) && entity.exportLinks.length > 0 ? entity?.exportLinks?.[0].url : undefined;
        }
    }
    return response?.data?.['atlassian:downloadUrl'];
};

});
parcelRegister("hWyvy", function(module, exports) {

$parcel$export(module.exports, "extractAri", () => $e72cc95d6d37b739$export$be18a6294fd426ec);
const $e72cc95d6d37b739$export$be18a6294fd426ec = (jsonLd)=>{
    if (jsonLd['atlassian:ari']) return jsonLd['atlassian:ari'];
};

});

parcelRegister("8Tcl1", function(module, exports) {

$parcel$export(module.exports, "extractDateCreated", () => $ff639713cdfddc0e$export$e1226a5e0bbbf862);
const $ff639713cdfddc0e$export$e1226a5e0bbbf862 = (jsonLd)=>{
    if (jsonLd['schema:dateCreated']) return jsonLd['schema:dateCreated'];
};

});

parcelRegister("ccpJ1", function(module, exports) {

$parcel$export(module.exports, "extractDateUpdated", () => $2985c9016975498b$export$7fc2f5e6f9d22ae7);
const $2985c9016975498b$export$7fc2f5e6f9d22ae7 = (jsonLd)=>{
    if (jsonLd.updated) return jsonLd.updated;
};

});

parcelRegister("8UXrm", function(module, exports) {

$parcel$export(module.exports, "extractLink", () => $c7ac01b191c63203$export$63f54cf4c5883620);

var $7OmtM = parcelRequire("7OmtM");
const $c7ac01b191c63203$export$63f54cf4c5883620 = (jsonLd)=>{
    const url = jsonLd?.url;
    if (url) {
        if (typeof url === 'string') return url;
        else return (0, $7OmtM.extractUrlFromLinkJsonLd)(url);
    }
};

});

parcelRegister("4MmCl", function(module, exports) {

$parcel$export(module.exports, "extractPersonCreatedBy", () => $b5a77ee228b8b40a$export$a66235cba0c9d11a);

var $aj6Xc = parcelRequire("aj6Xc");
const $b5a77ee228b8b40a$export$a66235cba0c9d11a = (jsonLd)=>{
    const attributedTo = jsonLd.attributedTo;
    if (attributedTo) {
        if (Array.isArray(attributedTo)) return attributedTo.map((0, $aj6Xc.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $aj6Xc.extractPersonFromJsonLd)(attributedTo);
            if (item) return [
                item
            ];
        }
    }
};

});
parcelRegister("aj6Xc", function(module, exports) {

$parcel$export(module.exports, "extractPersonFromJsonLd", () => $39e0e436026dd560$export$c471ae5fddcf1392);

var $cuw1y = parcelRequire("cuw1y");
const $39e0e436026dd560$export$c471ae5fddcf1392 = (person)=>{
    if (typeof person === 'string') throw Error('Link.person needs to be an object.');
    else if (person['@type'] === 'Link') {
        if (person.name) return {
            name: person.name
        };
    } else {
        if (person.name) return {
            name: person.name,
            src: person.icon && (0, $cuw1y.extractUrlFromIconJsonLd)(person.icon)
        };
    }
};

});
parcelRegister("cuw1y", function(module, exports) {

$parcel$export(module.exports, "extractUrlFromIconJsonLd", () => $17919ed1c60776d3$export$67f3d92c824fd850);

var $7OmtM = parcelRequire("7OmtM");
const $17919ed1c60776d3$export$67f3d92c824fd850 = (icon)=>{
    if (typeof icon === 'string') return icon;
    else if (icon['@type'] === 'Link') return (0, $7OmtM.extractUrlFromLinkJsonLd)(icon);
    else {
        if (icon.url) return (0, $7OmtM.extractUrlFromLinkJsonLd)(icon.url);
    }
};

});



parcelRegister("g9Blp", function(module, exports) {

$parcel$export(module.exports, "extractPersonUpdatedBy", () => $e35651e7203a8f3a$export$8a2d1ed7e6f336f0);

var $aj6Xc = parcelRequire("aj6Xc");
const $e35651e7203a8f3a$export$8a2d1ed7e6f336f0 = (jsonLd)=>{
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) return (0, $aj6Xc.extractPersonFromJsonLd)(updatedBy);
};

});

parcelRegister("f24gj", function(module, exports) {

$parcel$export(module.exports, "extractProvider", () => $e8bec3b6f1f5b80a$export$a832871718466647);
$parcel$export(module.exports, "extractProviderIcon", () => $e8bec3b6f1f5b80a$export$6fb636a2ac885215);
$parcel$export(module.exports, "isConfluenceGenerator", () => $e8bec3b6f1f5b80a$export$38df542ff03a4183);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $letJZ = parcelRequire("letJZ");

var $letJZ = parcelRequire("letJZ");


var $cuw1y = parcelRequire("cuw1y");
var $7OmtM = parcelRequire("7OmtM");
const $e8bec3b6f1f5b80a$export$a832871718466647 = (jsonLd)=>{
    const generator = jsonLd.generator;
    if (generator) {
        if (typeof generator === 'string') throw Error('Link.generator requires a name and icon.');
        else if (generator['@type'] === 'Link') {
            if (generator.name) return {
                text: generator.name
            };
        } else if (generator.name) {
            const id = generator['@id'];
            return {
                text: generator.name,
                icon: $e8bec3b6f1f5b80a$export$6fb636a2ac885215(generator.icon, id),
                id: id,
                image: $e8bec3b6f1f5b80a$var$extractProviderImage(generator.image)
            };
        }
    }
};
const $e8bec3b6f1f5b80a$export$6fb636a2ac885215 = (icon, id)=>{
    if (id) {
        if (id === (0, $0b0a34f2504ca78c$export$cee224b5de4d6d66)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $letJZ.ConfluenceIcon), {
            appearance: "brand",
            size: "xxsmall"
        });
        else if (id === (0, $0b0a34f2504ca78c$export$f654d825189934a7)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $letJZ.JiraIcon), {
            appearance: "brand",
            size: "xxsmall"
        });
    }
    if (icon) return (0, $cuw1y.extractUrlFromIconJsonLd)(icon);
};
const $e8bec3b6f1f5b80a$var$extractProviderImage = (image)=>{
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $7OmtM.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $7OmtM.extractUrlFromLinkJsonLd)(image.url);
        }
    }
};
const $e8bec3b6f1f5b80a$export$38df542ff03a4183 = (id)=>{
    return id === (0, $0b0a34f2504ca78c$export$cee224b5de4d6d66);
};

});
const $0b0a34f2504ca78c$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $0b0a34f2504ca78c$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $0b0a34f2504ca78c$export$84a73a0383f58180 = 'JiraTask';
const $0b0a34f2504ca78c$export$c6c83963a9378a67 = 'JiraSubTask';
const $0b0a34f2504ca78c$export$58af3c426c111a6d = 'JiraStory';
const $0b0a34f2504ca78c$export$ac9898a63417219e = 'JiraBug';
const $0b0a34f2504ca78c$export$54db5e3fb12e39cd = 'JiraEpic';
const $0b0a34f2504ca78c$export$2f54a5a217202c85 = 'JiraIncident';
const $0b0a34f2504ca78c$export$d097371052bfc411 = 'JiraServiceRequest';
const $0b0a34f2504ca78c$export$efd9452ad16c6676 = 'JiraChange';
const $0b0a34f2504ca78c$export$2e7e70abb5d81f67 = 'JiraProblem';
const $0b0a34f2504ca78c$export$ce25cfc40b280dbc = 'JiraCustomTaskType';


parcelRegister("iPUv2", function(module, exports) {

$parcel$export(module.exports, "extractTitle", () => $3d37e098183ec9ac$export$b05803156e5015b6);

var $a8kxN = parcelRequire("a8kxN");

var $FcDCF = parcelRequire("FcDCF");
const $3d37e098183ec9ac$export$b05803156e5015b6 = (jsonLd, removeTextHighlightingFromTitle)=>{
    if (!jsonLd) return undefined;
    const name = jsonLd.name?.replace(/[\r\n]+/g, '');
    const id = jsonLd['@id'] || '';
    // Check if this is a reference to something _inside_ a Repository.
    // We format these titles to represent more metadata.
    const context = (0, $a8kxN.extractContext)(jsonLd);
    const type = (0, $FcDCF.extractType)(jsonLd);
    const hasContextType = context && context.type;
    const hasContextRepo = hasContextType && context.type.includes('atlassian:SourceCodeRepository');
    if (hasContextRepo && type) {
        const contextName = context.name && `${context.name}: ` || '';
        // COMMIT: `repo-name: abf137c title of commit message`
        if (type.includes('atlassian:SourceCodeCommit')) {
            const [, hashContent] = id.split(':');
            const hash = hashContent && `${hashContent.substring(0, 8)} `;
            return contextName + (hash || '') + name;
        }
        // PR: `repo-name: #42 title of pull request`
        if (type.includes('atlassian:SourceCodePullRequest')) {
            const pullRequest = jsonLd;
            const internalId = pullRequest['atlassian:internalId'];
            const internalIdRef = internalId && `#${internalId} `;
            return contextName + (internalIdRef || '') + name;
        }
        // BRANCH: `repo-name/branch-name`
        if (type.includes('atlassian:SourceCodeReference')) return contextName + name;
        // FILE: `repo-name: filepath`
        if (type.includes('schema:DigitalDocument')) return contextName + name;
    }
    if (removeTextHighlightingFromTitle) {
        const textFragmentRegex = new RegExp(' \\| :~:text=.*', 'g');
        const truncated = name?.replace(textFragmentRegex, '');
        return truncated;
    }
    return name;
};

});
parcelRegister("a8kxN", function(module, exports) {

$parcel$export(module.exports, "extractContext", () => $1d582ee88fc2111b$export$efdbd45f3e77a161);

var $FcDCF = parcelRequire("FcDCF");

var $cuw1y = parcelRequire("cuw1y");
const $1d582ee88fc2111b$export$efdbd45f3e77a161 = (jsonLd)=>{
    const context = jsonLd.context;
    if (context) {
        if (typeof context === 'string') return {
            name: context
        };
        else if (context['@type'] === 'Link') {
            if (context.name) return {
                name: context.name
            };
        } else {
            if (context.name) return {
                name: context.name,
                icon: context.icon && (0, $cuw1y.extractUrlFromIconJsonLd)(context.icon),
                type: (0, $FcDCF.extractType)(context)
            };
        }
    }
};

});
parcelRegister("FcDCF", function(module, exports) {

$parcel$export(module.exports, "extractType", () => $c2480e088a98b125$export$2e9ae379995d99e3);
const $c2480e088a98b125$export$2e9ae379995d99e3 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (type) {
        if (Array.isArray(jsonLd['@type'])) return type;
        else return [
            type
        ];
    }
};

});



parcelRegister("kYwnb", function(module, exports) {

$parcel$export(module.exports, "extractEntity", () => $d95897e8ea09702f$export$8beff7405d020ddf);
$parcel$export(module.exports, "isEntityPresent", () => $d95897e8ea09702f$export$c7168210b81d9383);
$parcel$export(module.exports, "extractEntityEmbedUrl", () => $d95897e8ea09702f$export$f97663ee76ac5b24);
$parcel$export(module.exports, "extractEntityProvider", () => $d95897e8ea09702f$export$ad879f2c9d5100a0);
$parcel$export(module.exports, "extractEntityIcon", () => $d95897e8ea09702f$export$19346520e937a99f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $letJZ = parcelRequire("letJZ");

var $letJZ = parcelRequire("letJZ");

var $VSDnB = parcelRequire("VSDnB");

const $d95897e8ea09702f$export$8beff7405d020ddf = (response)=>(0, $VSDnB.fg)('smart_links_noun_support') ? response?.entityData : undefined;
const $d95897e8ea09702f$export$c7168210b81d9383 = (response)=>Boolean($d95897e8ea09702f$export$8beff7405d020ddf(response));
const $d95897e8ea09702f$export$f97663ee76ac5b24 = (response)=>{
    const entity = $d95897e8ea09702f$export$8beff7405d020ddf(response);
    return entity && 'liveEmbedUrl' in entity && typeof entity?.liveEmbedUrl === 'string' ? entity?.liveEmbedUrl : undefined;
};
const $d95897e8ea09702f$export$ad879f2c9d5100a0 = (response)=>{
    if (!response?.meta?.generator) return undefined;
    const { icon: icon, id: id, image: image, name: name } = response.meta.generator;
    if (!name || !icon) throw Error('Link.generator requires a name and icon.');
    let providerIcon;
    switch(id){
        case 0, $0b0a34f2504ca78c$export$cee224b5de4d6d66:
            providerIcon = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $letJZ.ConfluenceIcon), {
                appearance: "brand",
                size: "xxsmall"
            });
            break;
        case 0, $0b0a34f2504ca78c$export$f654d825189934a7:
            providerIcon = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $letJZ.JiraIcon), {
                appearance: "brand",
                size: "xxsmall"
            });
            break;
        default:
            providerIcon = icon.url;
    }
    return {
        text: name,
        icon: providerIcon,
        id: id,
        image: image ? image : icon.url
    };
};
const $d95897e8ea09702f$export$19346520e937a99f = (response)=>{
    const entity = $d95897e8ea09702f$export$8beff7405d020ddf(response);
    let url;
    if (entity) url = 'iconUrl' in entity && typeof entity?.iconUrl === 'string' ? entity.iconUrl : (0, $VSDnB.fg)('smart_links_noun_support') ? response?.meta.generator?.icon?.url : undefined;
    return {
        url: url,
        label: entity?.displayName
    };
};

});


parcelRegister("8b7fu", function(module, exports) {

$parcel$export(module.exports, "cardReducer", () => $92a815d7e26b35c0$export$3c7c3113a97b6492);

var $2yPrN = parcelRequire("2yPrN");
var $fiKQs = parcelRequire("fiKQs");
const $92a815d7e26b35c0$var$isCardAction = (action)=>{
    return [
        (0, $2yPrN.ACTION_PENDING),
        (0, $2yPrN.ACTION_RESOLVING),
        (0, $2yPrN.ACTION_RESOLVED),
        (0, $2yPrN.ACTION_RELOADING),
        (0, $2yPrN.ACTION_ERROR),
        (0, $2yPrN.ACTION_ERROR_FALLBACK),
        (0, $2yPrN.ACTION_UPDATE_METADATA_STATUS)
    ].includes(action.type);
};
function $92a815d7e26b35c0$var$persistPayloadToState(payload, state, type) {
    const nextDetails = payload;
    const nextState = {
        ...state
    };
    if (nextDetails) {
        nextState.status = (0, $fiKQs.getStatus)(nextDetails);
        nextState.details = nextDetails;
    } else // Keep the pre-existing data in the store. If there
    // is no data, the UI should handle this gracefully.
    nextState.status = type;
    return nextState;
}
function $92a815d7e26b35c0$var$reduceToNextState(state, action) {
    switch(action.type){
        case 0, $2yPrN.ACTION_PENDING:
            return {
                status: action.type
            };
        case 0, $2yPrN.ACTION_RESOLVING:
            return {
                ...state,
                status: action.type
            };
        case 0, $2yPrN.ACTION_RESOLVED:
            return $92a815d7e26b35c0$var$persistPayloadToState(action.payload, state, action.type);
        case 0, $2yPrN.ACTION_RELOADING:
            return $92a815d7e26b35c0$var$persistPayloadToState(action.payload, state, 'resolved');
        case 0, $2yPrN.ACTION_ERROR:
            return {
                ...state,
                status: action.type,
                error: action.error
            };
        case 0, $2yPrN.ACTION_ERROR_FALLBACK:
            return {
                ...state,
                status: action.type,
                error: action.error,
                details: action.payload
            };
        case 0, $2yPrN.ACTION_UPDATE_METADATA_STATUS:
            return {
                ...state,
                metadataStatus: action.metadataStatus
            };
    }
}
const $92a815d7e26b35c0$export$3c7c3113a97b6492 = (state, action)=>{
    if (!$92a815d7e26b35c0$var$isCardAction(action)) return state;
    const cardState = state[action.url];
    // Card may have reached the same state on account of multiple of the same
    // URL being present in an editor session. E.g. page with N links to one resource.
    const hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
    if (hasSameStatus) return state;
    else {
        const nextState = $92a815d7e26b35c0$var$reduceToNextState(cardState, action);
        return {
            ...state,
            [action.url]: nextState
        };
    }
};

});
parcelRegister("2yPrN", function(module, exports) {

$parcel$export(module.exports, "ACTION_PENDING", () => $23a1ee9f12bb755d$export$6e470aad5ba8952e);
$parcel$export(module.exports, "ACTION_RESOLVING", () => $23a1ee9f12bb755d$export$9a6a932a0a39498e);
$parcel$export(module.exports, "ACTION_RESOLVED", () => $23a1ee9f12bb755d$export$63ec8bc7a8a75482);
$parcel$export(module.exports, "ACTION_RELOADING", () => $23a1ee9f12bb755d$export$b8cfaa842c9ab487);
$parcel$export(module.exports, "ACTION_ERROR", () => $23a1ee9f12bb755d$export$6d8ed3f9433dd372);
$parcel$export(module.exports, "ACTION_ERROR_FALLBACK", () => $23a1ee9f12bb755d$export$cfbbb7126bc8a0c6);
$parcel$export(module.exports, "ACTION_UPDATE_METADATA_STATUS", () => $23a1ee9f12bb755d$export$2c5edb971b673330);
$parcel$export(module.exports, "cardAction", () => $23a1ee9f12bb755d$export$a884a52152489cc3);
// TODO: eventually move this file to @atlaskit/link-actions
const $23a1ee9f12bb755d$export$6e470aad5ba8952e = 'pending';
const $23a1ee9f12bb755d$export$9a6a932a0a39498e = 'resolving';
const $23a1ee9f12bb755d$export$63ec8bc7a8a75482 = 'resolved';
const $23a1ee9f12bb755d$export$b8cfaa842c9ab487 = 'reloading';
const $23a1ee9f12bb755d$export$6d8ed3f9433dd372 = 'errored';
const $23a1ee9f12bb755d$export$cfbbb7126bc8a0c6 = 'fallback';
const $23a1ee9f12bb755d$export$76b5c1aca20759c6 = 'preload';
const $23a1ee9f12bb755d$export$2c5edb971b673330 = 'metadata';
const $23a1ee9f12bb755d$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
        type: type,
        url: url,
        payload: payload,
        error: error,
        metadataStatus: metadataStatus,
        ignoreStatusCheck: ignoreStatusCheck
    });

});

parcelRegister("fiKQs", function(module, exports) {

$parcel$export(module.exports, "getStatus", () => $5c2f531cb20db568$export$b70265791d2079d4);
const $5c2f531cb20db568$var$getStatusForNotFoundVisibility = (meta)=>{
    const accessType = meta.requestAccess?.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $5c2f531cb20db568$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $5c2f531cb20db568$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};

});


parcelRegister("051X7", function(module, exports) {

$parcel$export(module.exports, "SmartCardContext", () => $b8de051ddcb2808f$export$156b523e63b4f63a);
$parcel$export(module.exports, "useSmartLinkContext", () => $b8de051ddcb2808f$export$e1d190b530cf0ee9);
$parcel$export(module.exports, "useSmartCardContext", () => $b8de051ddcb2808f$export$10e9cca30e50f657);
$parcel$export(module.exports, "EditorSmartCardProviderValueGuard", () => $b8de051ddcb2808f$export$797e3658f090919c);
$parcel$export(module.exports, "EditorSmartCardProvider", () => $b8de051ddcb2808f$export$2a29ca11e08dc129);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

const $b8de051ddcb2808f$export$156b523e63b4f63a = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
function $b8de051ddcb2808f$export$e1d190b530cf0ee9() {
    const context = (0, $5uXOq.useContext)($b8de051ddcb2808f$export$156b523e63b4f63a);
    if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
    return context;
}
const $b8de051ddcb2808f$export$10e9cca30e50f657 = ()=>$b8de051ddcb2808f$var$useContextMemoized($b8de051ddcb2808f$export$156b523e63b4f63a);
const $b8de051ddcb2808f$export$797e3658f090919c = ({ children: children })=>{
    const cardContext = $b8de051ddcb2808f$export$10e9cca30e50f657();
    if (!cardContext?.value) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};
function $b8de051ddcb2808f$var$useContextMemoized(reactContext) {
    const value = (0, $5uXOq.useContext)(reactContext);
    const context = (0, $5uXOq.useMemo)(()=>({
            Provider: reactContext.Provider,
            Consumer: reactContext.Consumer,
            value: value
        }), [
        value,
        reactContext
    ]);
    return context;
}
const $b8de051ddcb2808f$export$2a29ca11e08dc129 = ({ children: children })=>{
    const cardContext = $b8de051ddcb2808f$export$10e9cca30e50f657();
    const Provider = cardContext.Provider;
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Provider, {
        value: cardContext.value,
        children: children
    });
};
var $b8de051ddcb2808f$export$2e2bcd8739ae039 = $b8de051ddcb2808f$export$156b523e63b4f63a;

});

parcelRegister("7cFR3", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d96ed473518bd99$export$2e2bcd8739ae039);

var $hhZW9 = parcelRequire("hhZW9");

var $hj8yn = parcelRequire("hj8yn");

var $hLXaJ = parcelRequire("hLXaJ");

var $kDZ6Z = parcelRequire("kDZ6Z");
var $itO4f = parcelRequire("itO4f");
var $fiKQs = parcelRequire("fiKQs");
var $dV0Jy = parcelRequire("dV0Jy");

var $4Bkrp = parcelRequire("4Bkrp");

var $iwKVT = parcelRequire("iwKVT");
const $8d96ed473518bd99$var$MAX_BATCH_SIZE = 50;
const $8d96ed473518bd99$var$MIN_TIME_BETWEEN_BATCHES = 250;
const $8d96ed473518bd99$var$URL_RESPONSE_CACHE_SIZE = 100;
const $8d96ed473518bd99$export$d6a66073b5d79eb3 = new (0, $iwKVT.LRUMap)($8d96ed473518bd99$var$URL_RESPONSE_CACHE_SIZE);
class $8d96ed473518bd99$export$2e2bcd8739ae039 {
    constructor(envKey, baseUrlOverride){
        this.postBatchResolve = async (resources, resourceType = 'URL')=>{
            // De-duplicate requested URLs (see `this.createLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = [
                ...new Set(resources)
            ];
            let resolvedResources = [];
            const headers = {
                /**
			 * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
			 * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
			 */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $dV0Jy.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                        resourceUrl: resourceUrl
                    })), headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $dV0Jy.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                        ari: ari
                    })), headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $4Bkrp.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[resource] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[originalResource]);
        };
        // Endpoint for batch resolve url
        this.batchResolve = async (urls)=>{
            return this.postBatchResolve(urls, 'URL');
        };
        // Endpoint for batch resolve ari
        this.batchResolveAris = async (aris)=>{
            return this.postBatchResolve(aris, 'ARI');
        };
        this.resolverUrl = (0, $itO4f.getResolverUrl)(envKey, baseUrlOverride);
        this.loadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
    setProduct(product) {
        this.product = product;
    }
    createLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($hLXaJ)))({
            limit: 1,
            interval: $8d96ed473518bd99$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolve);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($hhZW9)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $8d96ed473518bd99$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolve`.
            cache: false
        });
    }
    getLoader(hostname) {
        if (!this.loadersByDomain[hostname]) this.loadersByDomain[hostname] = this.createLoader();
        return this.loadersByDomain[hostname];
    }
    async resolveUrl(url, force = false) {
        const hostname = new URL(url).hostname;
        const loader = this.getLoader(hostname);
        let responsePromise;
        responsePromise = $8d96ed473518bd99$export$d6a66073b5d79eb3.get(url);
        if (!responsePromise || force) {
            responsePromise = loader.load(url);
            $8d96ed473518bd99$export$d6a66073b5d79eb3.set(url, responsePromise);
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $8d96ed473518bd99$export$d6a66073b5d79eb3.delete(url);
            throw e;
        }
        const isUnresolvedLink = !(0, $4Bkrp.isSuccessfulResponse)(response) || (0, $fiKQs.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $8d96ed473518bd99$export$d6a66073b5d79eb3.delete(url);
        return response;
    }
    async prefetchData(url) {
        // 1. Queue the URL as part of a dataloader batch.
        const response = await this.resolveUrl(url, false);
        if ((0, $4Bkrp.isSuccessfulResponse)(response)) // 2. If the URL resolves, send it back.
        return response.body;
        else try {
            // 3. If the URL does not resolve, retry it with exponential backoff.
            // This is done so that we avoid the scenario where users are unable to
            // see a resolved Smart Link, when their expectation is to be able to.
            const retriedResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($hj8yn)))(async ()=>{
                // We check if the link has resolved in the cache and stop trying if so.
                // We do this by triggering an error that the link has already been resolved.
                // This cascades <retryCount> times after which it is handled like a normal
                // 'error', returning `undefined`.
                if (!this.resolvedCache[url]) {
                    const response = await this.resolveUrl(url, false);
                    if ((0, $4Bkrp.isSuccessfulResponse)(response)) return response;
                    else throw new Error('Retry for URL failed');
                } else // Short-circuit each of the retries, as described above.
                throw new Error('Retry unneeded - link has been resolved.');
            }, this.retryConfig);
            // Trigger callback after successful backoff.
            return retriedResponse.body;
        } catch (err) {
            // Do nothing in the case of an error - prefetching
            // failures should be silent. Once a link is visible,
            // it will be re-fetched anyhow, in which case a
            // user-facing error is required.
            return undefined;
        }
    }
    isRateLimitError(response) {
        return (0, $4Bkrp.isErrorResponse)(response) && response.error.status === 429;
    }
    // Fetch data from URL
    async fetchData(url, force) {
        let response = await this.resolveUrl(url, force);
        if (this.isRateLimitError(response)) response = await (0, (/*@__PURE__*/$parcel$interopDefault($hj8yn)))(async ()=>{
            const retryResponse = await this.resolveUrl(url, false);
            if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
            return retryResponse;
        }, this.retryConfig);
        if (!(0, $4Bkrp.isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
        // Set a flag in the `resolvedCache` for this URL. The intent of this is
        // to ensure that the exponential backoff method in `prefetchData` does
        // not continue to retry fetching for this URL, especially if it was previously
        // in a failed state. Note: this scenario only occurs on initial page load, if the
        // user scrolls through the page very fast. Once the URL is visible, prefetching
        // no longer takes place.
        this.resolvedCache[url] = true;
        // Return the JSON-LD response back up!
        return response.body;
    }
    /**
	 * Fetch data for multiple ARIs (batch) in one operation
	 * @param aris Array of ARIs to fetch data for
	 */ async fetchDataAris(aris) {
        return await this.batchResolveAris(aris);
    }
    async postData(data) {
        const requestData = {
            key: data.key,
            action: data.action,
            context: data.context
        };
        return await (0, $dV0Jy.request)('post', `${this.resolverUrl}/invoke`, requestData);
    }
    /**
	 * Make request to the Search endpoint See `InvocationRequest` in ORS openapi.yaml for backend
	 * spec.
	 * @param data Payload including the search provider key and query. An empty search query string
	 * results in recent results being returned (pre-query).
	 * @returns JsonLd collection of search results.
	 */ async search(data) {
        const { key: key, action: action } = data;
        // Note: context in action is different to context in data, see types.
        const { query: query, context: context } = action;
        const requestData = {
            key: key,
            search: {
                query: query,
                context: context
            }
        };
        const response = await (0, $dV0Jy.request)('post', `${this.resolverUrl}/invoke/search`, requestData);
        if ((0, $4Bkrp.isErrorResponse)(response)) // There is no hostname/it is not known. Hostname is not logged anyway as it's considered PII.
        throw this.mapErrorResponse(response);
        return response;
    }
    async fetchAvailableSearchProviders() {
        const response = await (0, $dV0Jy.request)('post', `${this.resolverUrl}/providers`, {
            type: 'search'
        });
        return response.providers;
    }
    mapErrorResponse(response, hostname = '') {
        // Catch non-200 server responses to fallback or return useful information.
        if (response?.error) {
            const errorType = response.error.type;
            const errorMessage = response.error.message;
            const extensionKey = response.error.extensionKey;
            // this means there was a network error and we fallback to blue link
            // without impacting SLO's
            if (response.error instanceof (0, $dV0Jy.NetworkError)) return new (0, $kDZ6Z.APIError)('fallback', hostname, errorMessage, errorType);
            switch(errorType){
                // BadRequestError - indicative of an API error, render
                // a blue link to mitigate customer impact.
                case 'ResolveBadRequestError':
                case 'SearchBadRequestError':
                case 'BadRequestError':
                    return new (0, $kDZ6Z.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                // AuthError - if the user logs in, we may be able
                // to recover. Render an unauthorized card.
                case 'ResolveAuthError':
                case 'SearchAuthError':
                case 'AuthError':
                    return new (0, $kDZ6Z.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                // UnsupportedError - we do not know how to render this URL.
                // Bail out and ask the Editor to render as a blue link.
                case 'ResolveUnsupportedError':
                case 'SearchUnsupportedError':
                case 'UnsupportedError':
                    return new (0, $kDZ6Z.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'ResolveFailedError':
                case 'SearchFailedError':
                case 'ResolveTimeoutError':
                case 'SearchTimeoutError':
                case 'SearchRateLimitError':
                case 'ResolveRateLimitError':
                case 'InternalServerError':
                case 'TimeoutError':
                case 'RateLimitError':
                    return new (0, $kDZ6Z.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
        }
        // Catch all: we don't know this error, bail out.
        const { error: error, ...rest } = response || {};
        return new (0, $kDZ6Z.APIError)('fatal', hostname, // reason we stringify the error differently is because
        // JSON.stringify will return "{}" if it is an instance of Error
        // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
        // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
        // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
        // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
        // we assume 'rest'  to "serializable" meaning all its properties are enumerable
        response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
    }
    /**
	 * This method will strigify both enumerable and  non enumerable properties of an object
	 * @param err
	 * @returns object serialized to JSON with both enumerable and non enumerable objects
	 */ stringifyError(err) {
        /**
		 * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
		 * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
		 * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
		 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
		 */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
        typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
    }
}

});
parcelRegister("hhZW9", function(module, exports) {

var $6cAn5 = parcelRequire("6cAn5");
"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $c964119340a5ebe3$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $c964119340a5ebe3$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $c964119340a5ebe3$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $c964119340a5ebe3$var$getValidCacheKeyFn(options);
        this._cacheMap = $c964119340a5ebe3$var$getValidCacheMap(options);
        this._batch = null;
        this.name = $c964119340a5ebe3$var$getValidName(options);
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
        var batch = $c964119340a5ebe3$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey = this._cacheKeyFn(key); // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    } /**
   * Loads multiple keys, promising an array of values:
   *
   *     var [ a, b ] = await myLoader.loadMany([ 'a', 'b' ]);
   *
   * This is similar to the more verbose:
   *
   *     var [ a, b ] = await Promise.all([
   *       myLoader.load('a'),
   *       myLoader.load('b')
   *     ]);
   *
   * However it is different in the case where any load fails. Where
   * Promise.all() would reject, loadMany() always resolves, however each result
   * is either a value or an Error instance.
   *
   *     var [ a, b, c ] = await myLoader.loadMany([ 'a', 'b', 'badkey' ]);
   *     // c instanceof Error
   *
   */ ;
    _proto.loadMany = function loadMany(keys) {
        if (!$c964119340a5ebe3$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    } /**
   * Clears the value at `key` from the cache, if it exists. Returns itself for
   * method chaining.
   */ ;
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    } /**
   * Clears the entire cache. To be used when some event results in unknown
   * invalidations across this particular `DataLoader`. Returns itself for
   * method chaining.
   */ ;
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    } /**
   * Adds the provided key and value to the cache. If the key already
   * exists, no change is made. Returns itself for method chaining.
   *
   * To prime the cache with an error at a key, provide an Error instance.
   */ ;
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    } /**
   * The name given to this `DataLoader` instance. Useful for APM tools.
   *
   * Is `null` if not set in the constructor.
   */ ;
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $c964119340a5ebe3$var$enqueuePostPromiseJob = typeof $6cAn5 === 'object' && typeof $6cAn5.nextTick === 'function' ? function(fn) {
    if (!$c964119340a5ebe3$var$resolvedPromise) $c964119340a5ebe3$var$resolvedPromise = Promise.resolve();
    $c964119340a5ebe3$var$resolvedPromise.then(function() {
        $6cAn5.nextTick(fn);
    });
} : typeof setImmediate === 'function' ? function(fn) {
    setImmediate(fn);
} : function(fn) {
    setTimeout(fn);
}; // Private: cached resolved Promise instance
var $c964119340a5ebe3$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $c964119340a5ebe3$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        $c964119340a5ebe3$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $c964119340a5ebe3$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $c964119340a5ebe3$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise;
    try {
        batchPromise = loader._batchLoadFn(batch.keys);
    } catch (e) {
        return $c964119340a5ebe3$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
    } // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $c964119340a5ebe3$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$c964119340a5ebe3$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $c964119340a5ebe3$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var value = values[i];
            if (value instanceof Error) batch.callbacks[i].reject(value);
            else batch.callbacks[i].resolve(value);
        }
    })["catch"](function(error) {
        $c964119340a5ebe3$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $c964119340a5ebe3$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $c964119340a5ebe3$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $c964119340a5ebe3$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $c964119340a5ebe3$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $c964119340a5ebe3$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $c964119340a5ebe3$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $c964119340a5ebe3$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $c964119340a5ebe3$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
}
function $c964119340a5ebe3$var$getValidName(options) {
    if (options && options.name) return options.name;
    return null;
} // Private
function $c964119340a5ebe3$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $c964119340a5ebe3$var$DataLoader;

});

parcelRegister("hj8yn", function(module, exports) {
// Packages

var $8DmlG = parcelRequire("8DmlG");
function $c99ad890679d3578$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        var op;
        // Default `randomize` to true
        if (!('randomize' in options)) options.randomize = true;
        op = $8DmlG.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error('Aborted'));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $c99ad890679d3578$var$retry;

});
parcelRegister("8DmlG", function(module, exports) {

module.exports = (parcelRequire("j1SyJ"));

});
parcelRegister("j1SyJ", function(module, exports) {

var $gRLb1 = parcelRequire("gRLb1");
exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $gRLb1(timeouts, {
        forever: options && (options.forever || options.retries === Infinity),
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});
parcelRegister("gRLb1", function(module, exports) {
function $c47630e585ca345b$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    this._timer = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $c47630e585ca345b$var$RetryOperation;
$c47630e585ca345b$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts.slice(0);
};
$c47630e585ca345b$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    if (this._timer) clearTimeout(this._timer);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$c47630e585ca345b$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.push(err);
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(0, this._errors.length - 1);
            timeout = this._cachedTimeouts.slice(-1);
        } else return false;
    }
    var self = this;
    this._timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) this._timer.unref();
    return true;
};
$c47630e585ca345b$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$c47630e585ca345b$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$c47630e585ca345b$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$c47630e585ca345b$var$RetryOperation.prototype.start = $c47630e585ca345b$var$RetryOperation.prototype.try;
$c47630e585ca345b$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$c47630e585ca345b$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$c47630e585ca345b$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});




parcelRegister("hLXaJ", function(module, exports) {
'use strict';
class $cf04b9d0ddc5d8fc$var$AbortError extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
const $cf04b9d0ddc5d8fc$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $cf04b9d0ddc5d8fc$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
module.exports = $cf04b9d0ddc5d8fc$var$pThrottle;
module.exports.AbortError = $cf04b9d0ddc5d8fc$var$AbortError;

});

parcelRegister("kDZ6Z", function(module, exports) {

$parcel$export(module.exports, "APIError", () => $8c263ecf028a2c14$export$3e5b797e39668f84);
class $8c263ecf028a2c14$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`), this.kind = kind, this.hostname = hostname, this.message = message, this.type = type, this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}

});

parcelRegister("itO4f", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $21a0efece812cd9a$export$f654b28f82155665);
$parcel$export(module.exports, "getResolverUrl", () => $21a0efece812cd9a$export$dc37652c1696f231);
const $21a0efece812cd9a$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $21a0efece812cd9a$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $21a0efece812cd9a$var$prodBaseUrl = 'https://api-private.atlassian.com';
const $21a0efece812cd9a$export$e2b040f052407032 = {
    dev: $21a0efece812cd9a$var$devBaseUrl,
    development: $21a0efece812cd9a$var$devBaseUrl,
    stg: $21a0efece812cd9a$var$stgBaseUrl,
    staging: $21a0efece812cd9a$var$stgBaseUrl,
    prd: $21a0efece812cd9a$var$prodBaseUrl,
    prod: $21a0efece812cd9a$var$prodBaseUrl,
    production: $21a0efece812cd9a$var$prodBaseUrl
};
const $21a0efece812cd9a$export$f654b28f82155665 = (envKey)=>{
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in $21a0efece812cd9a$export$e2b040f052407032 ? $21a0efece812cd9a$export$e2b040f052407032[envKey] : $21a0efece812cd9a$var$prodBaseUrl;
    // Otherwise, use the current origin of the page.
    return typeof window.location !== 'undefined' ? window.location.origin : '';
};
const $21a0efece812cd9a$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || $21a0efece812cd9a$export$f654b28f82155665(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
var $21a0efece812cd9a$export$2e2bcd8739ae039 = $21a0efece812cd9a$export$e2b040f052407032;

});

parcelRegister("dV0Jy", function(module, exports) {

$parcel$export(module.exports, "NetworkError", () => $5576d4e9d0a3858d$export$bae979e68e4dc802);
$parcel$export(module.exports, "request", () => $5576d4e9d0a3858d$export$b5fe3f66a567bec0);
const $5576d4e9d0a3858d$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $5576d4e9d0a3858d$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}
async function $5576d4e9d0a3858d$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $5576d4e9d0a3858d$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses?.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $5576d4e9d0a3858d$export$bae979e68e4dc802(error);
        throw error;
    }
}

});

parcelRegister("4Bkrp", function(module, exports) {

$parcel$export(module.exports, "isSuccessfulResponse", () => $1e00e4fd9b26eb0f$export$1b59fe731a28a49d);
$parcel$export(module.exports, "isErrorResponse", () => $1e00e4fd9b26eb0f$export$bea7bee8a87e7c52);
const $1e00e4fd9b26eb0f$export$1b59fe731a28a49d = (response)=>{
    if (!response) return false;
    const hasSuccessfulStatus = response.status === 200;
    const hasSuccessBody = 'body' in response;
    return hasSuccessfulStatus && hasSuccessBody;
};
const $1e00e4fd9b26eb0f$export$bea7bee8a87e7c52 = (response)=>{
    if (!response) return false;
    const hasStatus = 'status' in response && response.status >= 200;
    const hasErrorBody = 'error' in response;
    return hasStatus && hasErrorBody;
};

});

parcelRegister("iwKVT", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});





parcelRegister("62C9r", function(module, exports) {

$parcel$export(module.exports, "HorizontalNav", () => $df8ca37c4f42ad24$export$3821fe730064297d);
$parcel$export(module.exports, "HorizontalNavWrapper", () => $df8ca37c4f42ad24$export$8798384053a023ae);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $cPiXk = parcelRequire("cPiXk");

var $5HBvJ = parcelRequire("5HBvJ");

var $2Ioew = parcelRequire("2Ioew");


var $l8ruj = parcelRequire("l8ruj");

var $7CMCs = parcelRequire("7CMCs");

var $frBVt = parcelRequire("frBVt");

var $5NiYd = parcelRequire("5NiYd");

var $3HwlS = parcelRequire("3HwlS");

var $erBFB = parcelRequire("erBFB");
const $df8ca37c4f42ad24$var$NavErrorBoundaryFallback = ()=>// null = equivalent of "unmount"
    // We should do more graceful degradation.
    // Let's review this after dogfooding:
    // Tracked https://hello.jira.atlassian.cloud/browse/SEA-3059
    null;
const $df8ca37c4f42ad24$var$entrypointContainerProps = {};
const $df8ca37c4f42ad24$export$3821fe730064297d = ()=>{
    const HorizontalNavComponent = (0, $cPiXk.useHorizontalNavComponent)();
    // Consume the horizontal nav entry point if defined, otherwise fallback to the old horizontal nav component
    const horizontalNavEntryPointReference = (0, $2Ioew.usePageLayoutEntryPoint)((0, $6d6ccf8a2b2c5b3c$export$948d4d345566aed3));
    const horizontalNavFallback = horizontalNavEntryPointReference?.extraProps?.fallback || (0, $5NiYd.HorizontalNavSkeleton);
    if (horizontalNavEntryPointReference && (0, $3HwlS.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5HBvJ.NavErrorBoundary), {
        packageName: "page-container",
        id: "projectNavigationSkipLink",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $erBFB.ProjectViewNavigationSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "horizontal-nav-through-entry-point"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        id: "horizontal-nav-through-entry-point",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $frBVt.EntryPointReferencePlaceholder), {
        name: "horizontal-nav-through-entry-point",
        fallback: horizontalNavFallback(),
        entryPointReference: horizontalNavEntryPointReference
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
        entryPointReference: horizontalNavEntryPointReference,
        props: $df8ca37c4f42ad24$var$entrypointContainerProps
    })))));
    return HorizontalNavComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5HBvJ.NavErrorBoundary), {
        packageName: "page-container",
        id: "spa-horizontal-nav",
        fallback: $df8ca37c4f42ad24$var$NavErrorBoundaryFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5HBvJ.NavErrorBoundary), {
        packageName: "page-container",
        id: "projectNavigationSkipLink",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $erBFB.ProjectViewNavigationSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HorizontalNavComponent, null));
};
const $df8ca37c4f42ad24$export$8798384053a023ae = ({ children: children, navComponent: HorizontalNavComponent })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($df8ca37c4f42ad24$var$ThemedContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5HBvJ.NavErrorBoundary), {
        packageName: "page-container",
        id: "spa-horizontal-nav",
        fallback: $df8ca37c4f42ad24$var$NavErrorBoundaryFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5HBvJ.NavErrorBoundary), {
        packageName: "page-container",
        id: "projectNavigationSkipLink",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $erBFB.ProjectViewNavigationSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HorizontalNavComponent, null)), children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df8ca37c4f42ad24$var$ThemedContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q7mmei _1reo15vq _18m915vq _11q31r52",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5HBvJ", function(module, exports) {

$parcel$export(module.exports, "NavErrorBoundary", () => $4c38307f7d6b54b7$export$afc779e659fd533f);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $jcw0u = parcelRequire("jcw0u");

var $7XYc4 = parcelRequire("7XYc4");

var $3HwlS = parcelRequire("3HwlS");
const $4c38307f7d6b54b7$export$1d1321d2b374d697 = ()=>{
    if (typeof window !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+)$/.test(window?.BUILD_KEY);
    if (typeof globalThis !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+)$/.test(globalThis.BUILD_KEY);
    return false;
};
function $4c38307f7d6b54b7$var$inferNavRevision() {
    // This is brittle since we have several FFs https://hello.atlassian.net/wiki/spaces/SEA/pages/3841892327/Jira+Nav+v4+Feature+Flags
    // if possible, try to pass the revision explicitly as a prop
    return (0, $3HwlS.getWillShowNav4)() ? 'v4' : 'v3';
}
function $4c38307f7d6b54b7$var$getExtraAttributes(_error) {
    const attributes = {
        rev: $4c38307f7d6b54b7$var$inferNavRevision()
    };
    return attributes;
}
function $4c38307f7d6b54b7$var$getAnalyticsPayload(error, meta, navRevision) {
    const payload = {
        error: error,
        meta: {
            // intentionally fixed metas
            // so that we generate a unique event signature
            // so that we can register it in the analytics portal: https://data-portal.internal.atlassian.com/analytics/registry/67955
            // so that we get the attributes to show up in Splunk: https://splunk.paas-inf.net/en-GB/app/search/2024_sea2744_jira_nav_v4_container_navigation
            id: 'logic',
            packageName: 'JiraNav'
        },
        attributes: {
            ...$4c38307f7d6b54b7$var$getExtraAttributes(error),
            // forward the original meta as attributes to identify the location
            pkg: meta.packageName,
            id: meta.id,
            // if explicitly passed, override the rev
            ...navRevision && {
                rev: navRevision
            }
        },
        skipSentry: true
    };
    return payload;
}
const $4c38307f7d6b54b7$export$5ac21f1e947e70d6 = (props)=>{
    const { id: id, packageName: packageName, navRevision: navRevision } = props;
    const onError = (0, $5uXOq.useMemo)(()=>{
        const meta = {
            id: id,
            packageName: packageName
        };
        const _onError = (...args)=>{
            if ($4c38307f7d6b54b7$export$1d1321d2b374d697()) // this is a local test environment, don't send anything
            return;
            const [_, error] = args;
            (0, $jcw0u.default)($4c38307f7d6b54b7$var$getAnalyticsPayload(error, meta, navRevision));
        };
        return _onError;
    }, [
        id,
        packageName,
        navRevision
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        ...props,
        onError: onError
    });
};
const $4c38307f7d6b54b7$export$afc779e659fd533f = (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4c38307f7d6b54b7$export$5ac21f1e947e70d6, props), (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), props));

});

parcelRegister("erBFB", function(module, exports) {

$parcel$export(module.exports, "TopNavigationSkipLink", () => $cd61d83e2e343ff1$export$47de2191d46337b7);
$parcel$export(module.exports, "LeftSidebarSkipLink", () => $cd61d83e2e343ff1$export$46697df0d7c5e8be);
$parcel$export(module.exports, "ProjectViewNavigationSkipLink", () => $cd61d83e2e343ff1$export$2e2fc9c237996c06);
$parcel$export(module.exports, "MainContentSkipLink", () => $cd61d83e2e343ff1$export$b1498dd122ea3284);

var $koVbs = parcelRequire("koVbs");

var $iqLcb = parcelRequire("iqLcb");

var $lOt1w = parcelRequire("lOt1w");
const $cd61d83e2e343ff1$export$47de2191d46337b7 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    (0, $iqLcb.useCustomSkipLink)('ak-jira-navigation', formatMessage((0, $lOt1w.default).skipToJiraNavigation), 0);
    return null;
};
const $cd61d83e2e343ff1$export$46697df0d7c5e8be = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    (0, $iqLcb.useCustomSkipLink)('ak-side-navigation', formatMessage((0, $lOt1w.default).skipToSideNavigation), 1);
    return null;
};
const $cd61d83e2e343ff1$export$2e2fc9c237996c06 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    (0, $iqLcb.useCustomSkipLink)('ak-project-view-navigation', formatMessage((0, $lOt1w.default).skipToProjectViewNavigation), 2);
    return null;
};
const $cd61d83e2e343ff1$export$b1498dd122ea3284 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    (0, $iqLcb.useCustomSkipLink)('ak-main-content', formatMessage((0, $lOt1w.default).skipToMainContent), 3);
    return null;
};

});
parcelRegister("lOt1w", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d368a0de790f751$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2d368a0de790f751$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    skipToJiraNavigation: {
        "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-jira-navigation",
        "defaultMessage": "Skip to Jira Navigation"
    },
    skipToSideNavigation: {
        "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-side-navigation",
        "defaultMessage": "Skip to Side Navigation"
    },
    skipToProjectViewNavigation: {
        "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-project-view-navigation",
        "defaultMessage": "Skip to View Navigation"
    },
    skipToMainContent: {
        "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-main-content",
        "defaultMessage": "Skip to Main Content"
    }
});

});



parcelRegister("4s15Z", function(module, exports) {

$parcel$export(module.exports, "RightSidebar", () => $ac6bd493ba1cffad$export$84d58c19c21f637f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");


var $2Ioew = parcelRequire("2Ioew");

var $frBVt = parcelRequire("frBVt");

var $7CMCs = parcelRequire("7CMCs");

var $7XYc4 = parcelRequire("7XYc4");

var $hsmeR = parcelRequire("hsmeR");

var $3HwlS = parcelRequire("3HwlS");

var $iqLcb = parcelRequire("iqLcb");

var $6jY6G = parcelRequire("6jY6G");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $aPfsS = parcelRequire("aPfsS");

var $ozeZW = parcelRequire("ozeZW");

var $l8ruj = parcelRequire("l8ruj");
/**
 * This test ID is used in pollinator tests. Do not change lightly.
 * It's only added once the component is rendered client-side.
 */ const $ac6bd493ba1cffad$var$TEST_ID = 'page-layout.aside';
/* IMPORTANT:
 * When making any changes to the OLD component, please ensure that you also make the same changes to the
 * NEW component. The feature flag used is part of the Navigation Refresh work and we need to ensure that
 * we do not introduce tech debt for the roll-out by only updating the current component that is due to be
 * removed.
 *
 * If you have any concerns or questions please reach out to the #jira-navigation channel. Thanks!
 */ const $ac6bd493ba1cffad$var$routeComponents = [];
const $ac6bd493ba1cffad$var$SharedRightSidebars = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $aPfsS.renderGlobalComponents)((0, $ozeZW.sharedLayout).rightSidebars));
const $ac6bd493ba1cffad$var$RightSidebarRouteComponents = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $aPfsS.renderGlobalComponents)(route.layout?.rightSidebars || $ac6bd493ba1cffad$var$routeComponents));
};
const $ac6bd493ba1cffad$export$fb85bbdbfb3e6869 = ()=>null;
const $ac6bd493ba1cffad$var$RightSidebarThroughEntrypoint = ()=>{
    const rightSideBarEntryPointReference = (0, $2Ioew.usePageLayoutEntryPoint)((0, $6d6ccf8a2b2c5b3c$export$7bf43119a6b49ddb));
    if (!rightSideBarEntryPointReference) return null;
    const rightSideBarFallback = rightSideBarEntryPointReference?.extraProps?.fallback || $ac6bd493ba1cffad$export$fb85bbdbfb3e6869;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "right-sidebar-through-entrypoint"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-sidebar-through-entrypoint",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $frBVt.EntryPointReferencePlaceholder), {
        name: "right-sidebar-through-entrypoint",
        fallback: rightSideBarFallback(),
        entryPointReference: rightSideBarEntryPointReference
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
        entryPointReference: rightSideBarEntryPointReference,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props: {}
    }))));
};
const $ac6bd493ba1cffad$var$NewRightSidebar = ()=>{
    const lastPanelIdRef = (0, $5uXOq.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const rightSidebarCurrentState = (0, $hsmeR.useActiveRightSidebarState)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'rightSidebar change', {
            panelId: rightSidebarCurrentState?.panelId || lastPanelIdRef.current,
            isClosed: rightSidebarCurrentState?.panelId == null,
            isMinimised: !!rightSidebarCurrentState?.isMinimised,
            isCollapsed: !!rightSidebarCurrentState?.isCollapsed
        });
        lastPanelIdRef.current = rightSidebarCurrentState?.panelId;
    }, [
        createAnalyticsEvent,
        rightSidebarCurrentState?.panelId,
        rightSidebarCurrentState?.isMinimised,
        rightSidebarCurrentState?.isCollapsed
    ]);
    if (rightSidebarCurrentState && !rightSidebarCurrentState.shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "right-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.RightPanel), {
        width: rightSidebarCurrentState && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised ? rightSidebarCurrentState.width : 0,
        testId: $ac6bd493ba1cffad$var$TEST_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        id: "shared-right-sidebars",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$SharedRightSidebars, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-sidebar-route-components",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$RightSidebarRouteComponents, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$RightSidebarThroughEntrypoint, null))));
};
/**
 * Manages visibility and behavior of the right sidebar in the user interface, adapting to user interactions and system events. It enhances user experience by providing dynamic control over the sidebar's presentation, including features for collapsing and minimizing, alongside tracking user interactions for analytical purposes.
 */ const $ac6bd493ba1cffad$var$OldRightSidebar = ()=>{
    const lastPanelIdRef = (0, $5uXOq.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const rightSidebarCurrentState = (0, $hsmeR.useActiveRightSidebarState)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'rightSidebar change', {
            panelId: rightSidebarCurrentState?.panelId || lastPanelIdRef.current,
            isClosed: rightSidebarCurrentState?.panelId == null,
            isMinimised: !!rightSidebarCurrentState?.isMinimised,
            isCollapsed: !!rightSidebarCurrentState?.isCollapsed
        });
        lastPanelIdRef.current = rightSidebarCurrentState?.panelId;
    }, [
        createAnalyticsEvent,
        rightSidebarCurrentState?.panelId,
        rightSidebarCurrentState?.isMinimised,
        rightSidebarCurrentState?.isCollapsed
    ]);
    if (rightSidebarCurrentState && !rightSidebarCurrentState.shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "right-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$RightSidebarPanelWrapper, {
        id: "right-sidebar-panel-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.RightSidebar), {
        width: rightSidebarCurrentState && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised ? rightSidebarCurrentState.width : 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        id: "shared-right-sidebars",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$SharedRightSidebars, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-sidebar-route-components",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$RightSidebarRouteComponents, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$RightSidebarThroughEntrypoint, null)))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ac6bd493ba1cffad$var$RightSidebarPanelWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1bgi _iu1g1fl4 _1ej2b4wl",
            __cmplp.className
        ])
    });
});
const $ac6bd493ba1cffad$export$84d58c19c21f637f = (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), $ac6bd493ba1cffad$var$NewRightSidebar, $ac6bd493ba1cffad$var$OldRightSidebar);

});

parcelRegister("eF0qp", function(module, exports) {

$parcel$export(module.exports, "Sidebar", () => $803f61b5dea1399f$export$1ba59dacbcbf90fe);

var $fZBia = parcelRequire("fZBia");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $ajpes = parcelRequire("ajpes");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $3AWiS = parcelRequire("3AWiS");
var $kTus1 = parcelRequire("kTus1");
var $lsO24 = parcelRequire("lsO24");

var $5YdvQ = parcelRequire("5YdvQ");

var $gwIPs = parcelRequire("gwIPs");

var $7CMCs = parcelRequire("7CMCs");

var $7XYc4 = parcelRequire("7XYc4");

var $cSD7y = parcelRequire("cSD7y");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $pa9q9 = parcelRequire("pa9q9");

var $aWse0 = parcelRequire("aWse0");

var $gPQRI = parcelRequire("gPQRI");

var $5e5zm = parcelRequire("5e5zm");

var $2fwuR = parcelRequire("2fwuR");

var $acDan = parcelRequire("acDan");

var $c6x3L = parcelRequire("c6x3L");

var $3HwlS = parcelRequire("3HwlS");

var $4DrQd = parcelRequire("4DrQd");

var $eGkew = parcelRequire("eGkew");

var $iqLcb = parcelRequire("iqLcb");

var $lfTZh = parcelRequire("lfTZh");

var $6jY6G = parcelRequire("6jY6G");

var $ao2h1 = parcelRequire("ao2h1");

var $5M3R9 = parcelRequire("5M3R9");

var $4V52L = parcelRequire("4V52L");

var $16v4H = parcelRequire("16v4H");

var $cZpsT = parcelRequire("cZpsT");

var $DVljb = parcelRequire("DVljb");

var $l8ruj = parcelRequire("l8ruj");

var $ht71P = parcelRequire("ht71P");

var $kBsG9 = parcelRequire("kBsG9");

var $5gylp = parcelRequire("5gylp");

var $aImhn = parcelRequire("aImhn");

var $5ELA2 = parcelRequire("5ELA2");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $erBFB = parcelRequire("erBFB");

var $gxq4u = parcelRequire("gxq4u");

var $7x18A = parcelRequire("7x18A");
const $803f61b5dea1399f$var$footerStyles = {
    root: "_bfhkhp5a"
}; /**
    * This test ID is used in pollinator tests. Do not change lightly.
    */ 
const $803f61b5dea1399f$var$TEST_ID = 'page-layout.sidebar'; // TODO: use importCond() here
const $803f61b5dea1399f$var$SidebarNew = (0, $cSD7y.componentWithFG)('navx-global-side-nav', (0, $5ELA2.NavPlatformSidebar), $803f61b5dea1399f$var$SidebarNav4);
const $803f61b5dea1399f$export$1ba59dacbcbf90fe = (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), $803f61b5dea1399f$var$SidebarNew, $803f61b5dea1399f$var$SidebarOld);
function $803f61b5dea1399f$var$SidebarNav4() {
    const isAnonymous = (0, $cZpsT.useIsAnonymous)(); // TODO: Ask Matt why we use the Relay resource here, instead of inside SidebarInternal.
    const { queryReference: queryReference } = (0, $ao2h1.useRelayResource)((0, $2fwuR.sidebarNav4UiStateResource));
    if (isAnonymous) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "sidebar.anonymous"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.PlaceholderNew), {
        name: "nav4-ignore.sidebar.anonymous"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($803f61b5dea1399f$var$SidebarInternalAnonymous, null)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4.sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.PlaceholderNew), {
        name: "nav4-ignore.sidebar"
    }, queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($803f61b5dea1399f$var$SidebarInternal, {
        queryReference: queryReference
    }) : null));
}
function $803f61b5dea1399f$var$SidebarInternalAnonymous() {
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const defaultCollapsed = false;
    const defaultWidth = 340;
    const [, { setLeftSidebarState: setLeftSidebarState }] = (0, $5e5zm.useLayoutStoreActions)();
    const onExpand = (0, $5uXOq.useCallback)(({ screen: screen })=>{
        if (screen === 'desktop') setLeftSidebarState({
            isCollapsed: false
        });
    }, [
        setLeftSidebarState
    ]);
    const onCollapse = (0, $5uXOq.useCallback)(({ screen: screen })=>{
        if (screen === 'desktop') setLeftSidebarState({
            isCollapsed: true
        });
    }, [
        setLeftSidebarState
    ]);
    const onResizeEnd = (0, $5uXOq.useCallback)(({ finalWidth: finalWidth })=>{
        setLeftSidebarState({
            width: finalWidth
        });
    }, [
        setLeftSidebarState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c6x3L.SidebarNav4ContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kTus1.SideNav), {
        testId: $803f61b5dea1399f$var$TEST_ID,
        defaultCollapsed: defaultCollapsed,
        defaultWidth: defaultWidth,
        onExpand: onExpand,
        onCollapse: onCollapse
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5gylp.SidebarEntryPointSelector), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3AWiS.PanelSplitter), {
        label: formatMessage((0, $gxq4u.messages).sideBarPanelSplitterLabel),
        onResizeEnd: onResizeEnd,
        testId: "page-container-v2.common.ui.sidebar.panel-splitter"
    })));
}
function $803f61b5dea1399f$var$SidebarInternal({ queryReference: queryReference }) {
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const subProduct = (0, $16v4H.useSubProduct)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const data = (0, $8Uumt.usePreloadedQuery)((0, $fZBia.default), queryReference); /*
                                                                                               	Backend may respond with an error with the reason as Navigation UI state user property does not exist
                                                                                               	under a scenario where a new user joins an existing Jira site.
                                                                                               	When this happens, UI would not have data coming through from sidebarSelectorQuery.
                                                                                               	So, default values are used in such a case.
                                                                                               */ 
    const defaultCollapsed = data?.jira?.navigationUIState?.isLeftSidebarCollapsed ?? (0, $4DrQd.IS_LEFT_SIDEBAR_COLLAPSED_DEFAULT);
    const defaultWidth = data?.jira?.navigationUIState?.leftSidebarWidth ?? (0, $4DrQd.LEFT_SIDEBAR_EXPANDED_MIN_WIDTH);
    const [, { setLeftSidebarState: setLeftSidebarState }] = (0, $5e5zm.useLayoutStoreActions)();
    const onExpand = (0, $5uXOq.useCallback)(({ screen: screen })=>{
        if (screen === 'desktop') setLeftSidebarState({
            isCollapsed: false
        });
    }, [
        setLeftSidebarState
    ]);
    const onCollapse = (0, $5uXOq.useCallback)(({ screen: screen })=>{
        if (screen === 'desktop') setLeftSidebarState({
            isCollapsed: true
        });
    }, [
        setLeftSidebarState
    ]);
    const onResizeEnd = (0, $5uXOq.useCallback)(({ initialWidth: initialWidth, finalWidth: finalWidth })=>{
        setLeftSidebarState({
            width: finalWidth
        });
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'resized',
            actionSubject: 'sidebar'
        }), {
            initialWidth: initialWidth,
            finalWidth: finalWidth
        });
    }, [
        createAnalyticsEvent,
        setLeftSidebarState
    ]);
    const locale = (0, $DVljb.useLocale)();
    const showPersistentInvite = // Ensure that we can turn off the locale check with a feature gate if needed
    // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4R6GH.fg)('navx_persistent_invite_jira_new_non_free') && // Do not trigger an exposure on the experiment for non-English locales
    (locale?.toLowerCase().startsWith('en') ?? false) && (0, $6s1PB.expVal)('navx_persistent_invite_jira_new_non_free_exp', 'global_invite_enabled', false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c6x3L.SidebarNav4ContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kTus1.SideNav), {
        testId: $803f61b5dea1399f$var$TEST_ID,
        defaultCollapsed: defaultCollapsed,
        defaultWidth: defaultWidth,
        onExpand: onExpand,
        onCollapse: onCollapse
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5gylp.SidebarEntryPointSelector), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lsO24.SideNavFooter), {
        xcss: $803f61b5dea1399f$var$footerStyles.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aImhn.Nav4JiraSideNavRecommendation), null), showPersistentInvite ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $803f61b5dea1399f$var$globalInviteButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5YdvQ.GlobalInvite), {
        testId: "page-container-v2.common.ui.sidebar.global-invite",
        product: "jira",
        subProduct: subProduct ?? undefined,
        showFlag: showFlag
    }, formatMessage((0, $gxq4u.messages).globalInviteButtonLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4V52L.SidebarFeedbackButton), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4V52L.SidebarFeedbackButton), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3AWiS.PanelSplitter), {
        label: formatMessage((0, $gxq4u.messages).sideBarPanelSplitterLabel),
        onResizeEnd: onResizeEnd,
        testId: "page-container-v2.common.ui.sidebar.panel-splitter"
    }), (0, $4R6GH.fg)('cc-onboarding-nudge-confluence-bundled-users-gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ht71P.AsyncNudgeBundledUsersFlagContainer), null), (0, $4R6GH.fg)('jira-nudge-confluence-inactive-users-eligible') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kBsG9.AsyncNudgeInactiveConfluenceUserFlagContainer), null)));
}
const $803f61b5dea1399f$var$SIDEBAR_TEST_ID = 'ContextualNavigation';
const $803f61b5dea1399f$var$SIDEBAR_TRACE_KEY = 'sidebar';
const $803f61b5dea1399f$var$sidebarOverrides = {
    ResizeButton: {
        render: (Component, props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
                id: "sidebar-resize-tooltip",
                packageName: "page-container",
                fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, props)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
                name: "side_bar_button",
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, props)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7x18A.AsyncResizeButtonTooltip), {
                isLeftSidebarCollapsed: props.isLeftSidebarCollapsed
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, props))))
    }
};
function $803f61b5dea1399f$var$SidebarInternalOld({ sidebar: sidebar }) {
    const { width: width, isCollapsed: isCollapsed } = (0, $gPQRI.useLeftSidebarState)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const intl = (0, $aWse0.useIntlV2)();
    const shouldNotRenderSidebarInServerSide = false && isCollapsed;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "left-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($803f61b5dea1399f$var$SidebarStyleOverrides, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "leftSidebarSkipLink",
        packageName: "jiraPageContainer",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $erBFB.LeftSidebarSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.LeftSidebar), {
        isFixed: true,
        width: width,
        testId: $803f61b5dea1399f$var$SIDEBAR_TEST_ID,
        resizeButtonLabel: intl.formatMessage((0, $gxq4u.messages).sidebarNavigation),
        collapsedState: isCollapsed ? 'collapsed' : 'expanded',
        overrides: $803f61b5dea1399f$var$sidebarOverrides,
        id: "ak-side-navigation"
    }, !shouldNotRenderSidebarInServerSide && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, route !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $acDan.SidebarStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5M3R9.RenderTracerMark), {
        type: "start",
        traceKey: $803f61b5dea1399f$var$SIDEBAR_TRACE_KEY
    })), sidebar, route !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5M3R9.RenderTracerMark), {
        type: "end",
        traceKey: $803f61b5dea1399f$var$SIDEBAR_TRACE_KEY
    })))), (0, $4R6GH.fg)('cc-onboarding-nudge-confluence-bundled-users-gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ht71P.AsyncNudgeBundledUsersFlagContainer), null), (0, $4R6GH.fg)('jira-nudge-confluence-inactive-users-eligible') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kBsG9.AsyncNudgeInactiveConfluenceUserFlagContainer), null)));
}
const $803f61b5dea1399f$var$SidebarInternalOldMemo = /*#__PURE__*/ (0, $5uXOq.memo)($803f61b5dea1399f$var$SidebarInternalOld, (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))); // moved children as function outside the `Sidebar` so that the function is not re-created every time `Sidebar` is re-rendered.
const $803f61b5dea1399f$var$renderChildren = (sidebar)=>sidebar !== null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($803f61b5dea1399f$var$SidebarInternalOldMemo, {
        sidebar: sidebar
    }) : null;
function $803f61b5dea1399f$var$SidebarOld() {
    const { shouldRender: shouldRender } = (0, $gPQRI.useLeftSidebarState)();
    const route = (0, $6jY6G.useCurrentRoute)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGkew.SidebarSelectorProvider), {
        sidebar: route.navigation?.sidebar ?? null
    }, $803f61b5dea1399f$var$renderChildren);
} /**
   * In the @atlaskit/page-layout, resize control uses button for
   * the grab area. At the same time, legacy batch.css reset all
   * the button to have a box-shadow when focused. So when user
   * resizing the sidebar, they will see two blue lines around
   * the grab area.
   */ 
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $803f61b5dea1399f$var$SidebarStyleOverrides = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1d7w7yr": (0, $lD23V.default)((0, $gwIPs.layers).leftSidebar)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1pbyg9ti _14c1glyw",
            __cmplp.className
        ])
    });
});
const $803f61b5dea1399f$var$globalInviteButtonStyles = (0, $8CUq3.xcss)({
    flexGrow: 1
});

});
parcelRegister("lsO24", function(module, exports) {

$parcel$export(module.exports, "SideNavFooter", () => $c6642da0d03c35b7$export$b773c4c9cf740fbe);
/* side-nav-footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $c6642da0d03c35b7$var$styles = {
    root: "_ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _7myae4h9 _1sw7nqa1 _qgnumuej"
};
const $c6642da0d03c35b7$export$b773c4c9cf740fbe = ({ children: /**
   * The content of the layout area.
   */ children, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            $c6642da0d03c35b7$var$styles.root,
            xcss
        ]),
        children: children
    });
};

});

parcelRegister("5YdvQ", function(module, exports) {

$parcel$export(module.exports, "GlobalInvite", () => $8db6209b69a4dd79$export$93cb436db3d27b7e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $96nTn = parcelRequire("96nTn");

var $VSDnB = parcelRequire("VSDnB");

var $i3JXV = parcelRequire("i3JXV");

var $dZo39 = parcelRequire("dZo39");

var $4pmnu = parcelRequire("4pmnu");

var $g9BbE = parcelRequire("g9BbE");

var $d04El = parcelRequire("d04El");

const $8db6209b69a4dd79$var$LazyGlobalInviteModalDialogContent = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("fRHjk")).then((module)=>({
            default: module.ModalDialogContent
        })));
function $8db6209b69a4dd79$var$AsyncGlobalInviteModalDialogContent(props) {
    const modalContent = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4pmnu.ErrorState), {}),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
            fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g9BbE.LoadingState), {}),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($8db6209b69a4dd79$var$LazyGlobalInviteModalDialogContent, {
                ...props
            })
        })
    });
    return (0, $VSDnB.fg)('global_invite_uses_intl_provider') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $96nTn.default), {
        defaultMessages: (0, $dZo39.default),
        loaderFn: (0, $i3JXV.fetchMessages),
        children: modalContent
    }) : modalContent;
}
const $8db6209b69a4dd79$export$93cb436db3d27b7e = (0, $d04El.withModalDialog)($8db6209b69a4dd79$var$AsyncGlobalInviteModalDialogContent);

});
parcelRegister("i3JXV", function(module, exports) {

$parcel$export(module.exports, "fetchMessages", () => $375ff511b805029d$export$e4882a930a0d91f2);

var $dZo39 = parcelRequire("dZo39");

var $c5A0D = parcelRequire("c5A0D");
const $375ff511b805029d$export$e4882a930a0d91f2 = async (locale)=>{
    try {
        // Fallback to the generic locale if specified one is not found
        const languageLocale = locale in (0, $c5A0D.asyncLanguages) ? locale : locale.replace(/-/g, '_') in (0, $c5A0D.asyncLanguages) ? locale.replace(/-/g, '_') : locale.split(/[-_]/)[0] || '';
        // Dynamic import of the locale file
        const localeMessages = await (0, $c5A0D.asyncLanguages)[languageLocale]?.();
        return localeMessages?.default ?? (0, $dZo39.default);
    } catch (e) {
    // ignore
    }
    return 0, $dZo39.default;
};

});
parcelRegister("dZo39", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $12a8bb7265eb034b$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $12a8bb7265eb034b$export$2e2bcd8739ae039 = {
    'navigation.global-invite.error-state-description': 'Try refreshing the page or contact us if the problem persists.',
    'navigation.global-invite.error-state-heading': "We can't load the invite list right now",
    'navigation.global-invite.loading-visually-hidden-label': 'Loading',
    'navigation.global-invite.modal-dialog-label': 'Invite people'
};

});

parcelRegister("c5A0D", function(module, exports) {

$parcel$export(module.exports, "asyncLanguages", () => $2dac4c58db501351$export$3770c7a7737d463c);
// https://parceljs.org/features/dependency-resolution/#glob-specifiers

























const $2dac4c58db501351$export$3770c7a7737d463c = {
    cs: ()=>(parcelRequire("i6o3a")),
    da: ()=>(parcelRequire("iOGdx")),
    de: ()=>(parcelRequire("emkiC")),
    'en-GB': ()=>(parcelRequire("j7Sdb")),
    'en-ZZ': ()=>(parcelRequire("2JetZ")),
    en: ()=>Promise.resolve((parcelRequire("dZo39"))),
    es: ()=>(parcelRequire("2wwXz")),
    fi: ()=>(parcelRequire("fZ72g")),
    fr: ()=>(parcelRequire("5L4gr")),
    hu: ()=>(parcelRequire("2wAsA")),
    it: ()=>(parcelRequire("1BvuU")),
    ja: ()=>(parcelRequire("555Tz")),
    ko: ()=>(parcelRequire("3yRBk")),
    nb: ()=>(parcelRequire("5xMVi")),
    nl: ()=>(parcelRequire("lhPQz")),
    pl: ()=>(parcelRequire("7Dnxh")),
    'pt-BR': ()=>(parcelRequire("lTlLz")),
    ru: ()=>(parcelRequire("kmZpz")),
    sv: ()=>(parcelRequire("6xijW")),
    th: ()=>(parcelRequire("51xrC")),
    tr: ()=>(parcelRequire("dUJgb")),
    uk: ()=>(parcelRequire("d7yYP")),
    vi: ()=>(parcelRequire("6pF87")),
    zh_TW: ()=>(parcelRequire("jqg9y")),
    zh: ()=>(parcelRequire("50083"))
};

});
parcelRegister("i6o3a", function(module, exports) {

let $d2db7162fb3105b7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d2db7162fb3105b7$var$load("52lcO").then(()=>parcelRequire('2ub4R'));

});

parcelRegister("iOGdx", function(module, exports) {

let $db2da50311364396$var$load = (parcelRequire("28QjX"))(4);
module.exports = $db2da50311364396$var$load("bSOF1").then(()=>parcelRequire('aRZbX'));

});

parcelRegister("emkiC", function(module, exports) {

let $a742ddcd56ccdf8d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a742ddcd56ccdf8d$var$load("gyANk").then(()=>parcelRequire('7eho6'));

});

parcelRegister("j7Sdb", function(module, exports) {

let $dec8b91711a95b0c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $dec8b91711a95b0c$var$load("dQICm").then(()=>parcelRequire('djM79'));

});

parcelRegister("2JetZ", function(module, exports) {

let $1fcb04ae3f593a7a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1fcb04ae3f593a7a$var$load("7hjT7").then(()=>parcelRequire('bQ0Uy'));

});

parcelRegister("2wwXz", function(module, exports) {

let $1d6823110cee075c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1d6823110cee075c$var$load("3Gwzy").then(()=>parcelRequire('9ZuI1'));

});

parcelRegister("fZ72g", function(module, exports) {

let $ba32029b7133bc6b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ba32029b7133bc6b$var$load("4jJvk").then(()=>parcelRequire('4NtTH'));

});

parcelRegister("5L4gr", function(module, exports) {

let $4314a64cc3c82a71$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4314a64cc3c82a71$var$load("8GD7m").then(()=>parcelRequire('8R0uH'));

});

parcelRegister("2wAsA", function(module, exports) {

let $1d6ada2768a7c9bb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1d6ada2768a7c9bb$var$load("dgniR").then(()=>parcelRequire('4VHvp'));

});

parcelRegister("1BvuU", function(module, exports) {

let $12b1adea4e756d77$var$load = (parcelRequire("28QjX"))(4);
module.exports = $12b1adea4e756d77$var$load("kBnxw").then(()=>parcelRequire('3510C'));

});

parcelRegister("555Tz", function(module, exports) {

let $3b31fe0dcea493ca$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3b31fe0dcea493ca$var$load("3tr0N").then(()=>parcelRequire('68YeM'));

});

parcelRegister("3yRBk", function(module, exports) {

let $297e20215c54f704$var$load = (parcelRequire("28QjX"))(4);
module.exports = $297e20215c54f704$var$load("89hhV").then(()=>parcelRequire('gKIUw'));

});

parcelRegister("5xMVi", function(module, exports) {

let $4095fbe916391bd9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4095fbe916391bd9$var$load("jXt4a").then(()=>parcelRequire('eaL12'));

});

parcelRegister("lhPQz", function(module, exports) {

let $f7f3673626f7e4dc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f7f3673626f7e4dc$var$load("2DUmT").then(()=>parcelRequire('eVEy3'));

});

parcelRegister("7Dnxh", function(module, exports) {

let $58ee6ea64af789a3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $58ee6ea64af789a3$var$load("kDCGJ").then(()=>parcelRequire('kRswE'));

});

parcelRegister("lTlLz", function(module, exports) {

let $feff9e56b31cbd65$var$load = (parcelRequire("28QjX"))(4);
module.exports = $feff9e56b31cbd65$var$load("253rR").then(()=>parcelRequire('4niNQ'));

});

parcelRegister("kmZpz", function(module, exports) {

let $ed457fbcb60edf55$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ed457fbcb60edf55$var$load("6bTOh").then(()=>parcelRequire('iDRDs'));

});

parcelRegister("6xijW", function(module, exports) {

let $4c240942b1d1381d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4c240942b1d1381d$var$load("g9GJr").then(()=>parcelRequire('krHNh'));

});

parcelRegister("51xrC", function(module, exports) {

let $3a86fd1e47986c81$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3a86fd1e47986c81$var$load("fhSab").then(()=>parcelRequire('kaBj2'));

});

parcelRegister("dUJgb", function(module, exports) {

let $a2139d08893ff9cd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a2139d08893ff9cd$var$load("8NTru").then(()=>parcelRequire('at0xM'));

});

parcelRegister("d7yYP", function(module, exports) {

let $98d7101b8d556abe$var$load = (parcelRequire("28QjX"))(4);
module.exports = $98d7101b8d556abe$var$load("idCNe").then(()=>parcelRequire('cClbL'));

});

parcelRegister("6pF87", function(module, exports) {

let $4ab4fb734d4618e0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4ab4fb734d4618e0$var$load("ia9tz").then(()=>parcelRequire('d32ti'));

});

parcelRegister("jqg9y", function(module, exports) {

let $e23cf9af52f4a348$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e23cf9af52f4a348$var$load("drPzE").then(()=>parcelRequire('5yFT8'));

});

parcelRegister("50083", function(module, exports) {

let $3a3d0d69988b5e0c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3a3d0d69988b5e0c$var$load("1YwAi").then(()=>parcelRequire('1dJjd'));

});



parcelRegister("4pmnu", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $12ac31c3f5776fed$export$c1ed4f415b9e7023);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $l1N8i = parcelRequire("l1N8i");

var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $cWIaC = parcelRequire("cWIaC");
const $12ac31c3f5776fed$var$styles = (0, $8CUq3.xcss)({
    paddingBlock: 'space.1000',
    paddingInline: 'space.100',
    textAlign: 'center'
});
function $12ac31c3f5776fed$export$c1ed4f415b9e7023() {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
        space: "space.050",
        testId: "global-invite--error-state",
        xcss: $12ac31c3f5776fed$var$styles,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                size: "xsmall",
                children: formatMessage((0, $cWIaC.messages).errorStateHeading)
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgL5K.default), {
                size: "small",
                color: "color.text.subtle",
                children: formatMessage((0, $cWIaC.messages).errorStateDescription)
            })
        ]
    });
}

});
parcelRegister("cWIaC", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ab5f16cf436290aa$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $ab5f16cf436290aa$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    errorStateHeading: {
        id: 'navigation.global-invite.error-state-heading',
        description: "Heading of the error state UI indicating we couldn't load the invite people widget.",
        defaultMessage: "We can't load the invite list right now"
    },
    errorStateDescription: {
        id: 'navigation.global-invite.error-state-description',
        description: "Description of the error state UI indicating we couldn't load the invite people widget.",
        defaultMessage: 'Try refreshing the page or contact us if the problem persists.'
    }
});

});


parcelRegister("g9BbE", function(module, exports) {

$parcel$export(module.exports, "LoadingState", () => $de01f18621face07$export$62aa48085237e36f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $1DVhQ = parcelRequire("1DVhQ");

var $jldZL = parcelRequire("jldZL");

var $esr9c = parcelRequire("esr9c");
const $de01f18621face07$var$styles = (0, $8CUq3.xcss)({
    paddingBlock: 'space.500',
    paddingInline: 'space.300'
});
function $de01f18621face07$export$62aa48085237e36f() {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const items = Array.from({
        length: 5
    }, (_, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1DVhQ.default), {
            isShimmering: true,
            width: "100%",
            height: "var(--ds-space-200, 16px)",
            testId: "skeleton-shimmering"
        }, index));
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dC5iT.default), {
        xcss: $de01f18621face07$var$styles,
        testId: "global-invite--loading-state",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jldZL.default), {
                children: formatMessage((0, $esr9c.messages).loadingLabel)
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $luBm6.default), {
                space: "space.100",
                testId: "skeleton-group",
                children: items
            })
        ]
    });
}

});
parcelRegister("esr9c", function(module, exports) {

$parcel$export(module.exports, "messages", () => $bf903bffddf301c6$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $bf903bffddf301c6$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    loadingLabel: {
        id: 'navigation.global-invite.loading-visually-hidden-label',
        description: 'Visually hidden text to indicate the invite people UI is loading.',
        defaultMessage: 'Loading'
    }
});

});


parcelRegister("d04El", function(module, exports) {

$parcel$export(module.exports, "withModalDialog", () => $961b14944ab8338e$export$2d7d84d397d9a585);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");


var $2NMNM = parcelRequire("2NMNM");

var $eCeGD = parcelRequire("eCeGD");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $i8Qvm = parcelRequire("i8Qvm");

var $VSDnB = parcelRequire("VSDnB");


var $94ca3 = parcelRequire("94ca3");

var $kMruu = parcelRequire("kMruu");
function $961b14944ab8338e$export$2d7d84d397d9a585(Content) {
    return function ModalDialog({ testId: testId = (0, $2c256bebcfc296e4$export$bb76aeb9f599715c), triggerElement: TriggerElement, children: children, ...props }) {
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
        const { formatMessage: formatMessage } = (0, $koVbs.default)();
        const [isModalDialogOpen, setIsModalDialogOpen] = (0, $5uXOq.useState)(false);
        const [adminHasNavigatedAway, setAdminHasNavigatedAway] = (0, $5uXOq.useState)(false);
        const openModalDialog = (0, $5uXOq.useCallback)(()=>{
            if ((0, $VSDnB.fg)('platform_global-invite-analytics')) createAnalyticsEvent({
                eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'globalInviteButton',
                attributes: {
                    componentName: 'globalInvite',
                    product: props.product
                }
            }).fire((0, $2c256bebcfc296e4$export$85183a312807388d));
            setIsModalDialogOpen(true);
        }, [
            createAnalyticsEvent,
            props.product
        ]);
        const onAdminMenuItemClick = (0, $5uXOq.useCallback)((event)=>{
            // See packages/people-and-teams/invite-people/src/components/DropdownMenu/AdminMenuGroup.tsx for where these items are created.
            // Handle the click event happening on a link directly, or on an inner <span> or similar
            const isLink = event?.target?.tagName === 'A';
            const link = isLink ? event?.target : event?.target?.closest('a');
            if (link && (link?.getAttribute('target') === 'new' || link?.getAttribute('target') === '_blank')) setAdminHasNavigatedAway(true);
        }, []);
        const onCancel = (0, $5uXOq.useCallback)(()=>{
            if ((0, $VSDnB.fg)('platform_global-invite-analytics')) createAnalyticsEvent({
                eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
                action: adminHasNavigatedAway ? 'closed' : 'cancelled',
                actionSubject: 'modalDialog',
                actionSubjectId: 'globalInviteModal',
                attributes: {
                    componentName: 'globalInvite',
                    product: props.product
                }
            }).fire((0, $2c256bebcfc296e4$export$85183a312807388d));
            setIsModalDialogOpen(false);
        }, [
            createAnalyticsEvent,
            props.product,
            adminHasNavigatedAway
        ]);
        const onInviteCompleted = (0, $5uXOq.useCallback)(()=>{
            createAnalyticsEvent({
                eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
                action: 'completed',
                actionSubject: 'modalDialog',
                actionSubjectId: 'globalInviteModal',
                attributes: {
                    componentName: 'globalInvite',
                    product: props.product
                }
            }).fire((0, $2c256bebcfc296e4$export$85183a312807388d));
            setIsModalDialogOpen(false);
        }, [
            createAnalyticsEvent,
            props.product
        ]);
        const focusDialog = (0, $5uXOq.useCallback)((node)=>{
            // Focus the dialog's container when it finishes opening
            node.focus();
        }, []);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $94ca3.AnalyticsContextWrapper), {
            product: props.product,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                "data-testid": testId,
                children: [
                    TriggerElement ? /*#__PURE__*/ (0, $2OMIu.jsx)(TriggerElement, {
                        onClick: openModalDialog
                    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                        shouldFitContainer: true,
                        onClick: openModalDialog,
                        testId: `${testId}--${(0, $2c256bebcfc296e4$export$1dab7caa4b20a4cc)}`,
                        children: children
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i8Qvm.default), {
                        children: isModalDialogOpen ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1R1Ge.default), {
                            width: "small",
                            shouldScrollInViewport: true,
                            shouldReturnFocus: true,
                            onClose: onCancel,
                            onOpenComplete: focusDialog,
                            label: formatMessage((0, $kMruu.messages).modalDialogLabel),
                            testId: `${testId}--${(0, $2c256bebcfc296e4$export$7622d28bacf170d1)}`,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7QSqG.default), {
                                children: (0, $VSDnB.fg)('platform_global-invite-analytics-admin-nav') ? /*#__PURE__*/ (0, $2OMIu.jsx)(Content, {
                                    onAdminMenuItemClick: onAdminMenuItemClick,
                                    onCancel: onCancel,
                                    onInviteCompleted: onInviteCompleted,
                                    ...props
                                }) : /*#__PURE__*/ (0, $2OMIu.jsx)(Content, {
                                    onCancel: onCancel,
                                    onInviteCompleted: onInviteCompleted,
                                    ...props
                                })
                            })
                        }) : null
                    })
                ]
            })
        });
    };
}

});
const $2c256bebcfc296e4$export$bb76aeb9f599715c = 'global-invite';
const $2c256bebcfc296e4$export$7622d28bacf170d1 = 'modal-dialog';
const $2c256bebcfc296e4$export$1dab7caa4b20a4cc = 'trigger-element';
const $2c256bebcfc296e4$export$85183a312807388d = 'navigation';

parcelRegister("94ca3", function(module, exports) {

$parcel$export(module.exports, "AnalyticsContextWrapper", () => $68ec86e5ebb411d6$export$804bcbe0913c6ba3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $1PVpv = parcelRequire("1PVpv");

var $VSDnB = parcelRequire("VSDnB");
function $68ec86e5ebb411d6$export$804bcbe0913c6ba3({ product: product, children: children }) {
    if ((0, $VSDnB.fg)('platform_global-invite-analytics')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1PVpv.NavigationAnalyticsContext), {
        data: {
            componentName: 'globalInvite',
            source: 'globalInviteButton',
            product: product
        },
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
}

});

parcelRegister("kMruu", function(module, exports) {

$parcel$export(module.exports, "messages", () => $58ea59d0f979843d$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $58ea59d0f979843d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    modalDialogLabel: {
        id: 'navigation.global-invite.modal-dialog-label',
        description: 'Accessible label of the modal dialog for assistive technologies users.',
        defaultMessage: 'Invite people'
    }
});

});


parcelRegister("fRHjk", function(module, exports) {

let $b8cd66d7ab1e14a4$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $b8cd66d7ab1e14a4$var$load("76n7a"),
    $b8cd66d7ab1e14a4$var$load("l253H"),
    $b8cd66d7ab1e14a4$var$load("8320Y")
]).then(()=>parcelRequire('iDk8M'));

});


parcelRegister("aWse0", function(module, exports) {

$parcel$export(module.exports, "useIntlV2", () => $6b28e3c9e1c89fbd$export$d82607073b68786);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");
const $6b28e3c9e1c89fbd$export$d82607073b68786 = ()=>{
    const { messages: messages, locale: locale, formats: formats, formatDate: formatDate, formatMessage: formatMessage, formatNumber: formatNumber, formatPlural: formatPlural, formatTime: formatTime } = (0, $koVbs.default)();
    // Only recreate intl object if reference to originral intl changes.
    const memoisedIntl = (0, $5uXOq.useMemo)(()=>{
        const modifiedIntl = {
            messages: // @ts-expect-error - TS2322 - Type 'Record<string, string> | Record<string, MessageFormatElement[]>' is not assignable to type '{ [id: string]: string; }'.
            messages,
            locale: locale,
            formats: formats,
            formatDate: formatDate,
            formatMessage: formatMessage,
            formatNumber: formatNumber,
            formatPlural: formatPlural,
            formatTime: formatTime
        };
        return modifiedIntl;
    }, [
        formatDate,
        formatMessage,
        formatPlural,
        formatTime,
        formatNumber,
        formats,
        locale,
        messages
    ]);
    return memoisedIntl;
};

});

parcelRegister("eGkew", function(module, exports) {

$parcel$export(module.exports, "SidebarSelectorProvider", () => $8451f19a8196b45e$export$6af584355cfb32c6);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $2vSU6 = parcelRequire("2vSU6");

var $lpwtK = parcelRequire("lpwtK");

var $lGo7j = parcelRequire("lGo7j");

var $cin8p = parcelRequire("cin8p");

var $awp39 = parcelRequire("awp39");

var $b69Lc = parcelRequire("b69Lc");

var $dlYil = parcelRequire("dlYil");

var $jjzbO = parcelRequire("jjzbO");

var $hWtQt = parcelRequire("hWtQt");

var $jfqNX = parcelRequire("jfqNX");

var $gZbSF = parcelRequire("gZbSF");

var $dmKXV = parcelRequire("dmKXV");

var $iFaFr = parcelRequire("iFaFr");

var $4IWRY = parcelRequire("4IWRY");

var $hBv66 = parcelRequire("hBv66");

var $iHiHz = parcelRequire("iHiHz");

var $cOg46 = parcelRequire("cOg46");

var $7AyKX = parcelRequire("7AyKX");

var $koWFd = parcelRequire("koWFd");

var $937TY = parcelRequire("937TY");

var $lgSL3 = parcelRequire("lgSL3");

var $h0bZU = parcelRequire("h0bZU");

var $9s3j1 = parcelRequire("9s3j1");

var $2IHt2 = parcelRequire("2IHt2");

var $hz6Yb = parcelRequire("hz6Yb");

var $2YP9W = parcelRequire("2YP9W");
const $8451f19a8196b45e$var$renderProjectSidebar = ({ data: project, loading: loading })=>{
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lGo7j.Skeleton), {
        isFull: true
    });
    if (!project) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2IHt2.default), null);
    switch(project.type){
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
        case 0, $2vSU6.CUSTOMER_SERVICE_PROJECT:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h0bZU.default), null);
        case 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lgSL3.default), null);
        case 0, $2vSU6.SOFTWARE_PROJECT:
            if (project.isSimplified) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $koWFd.default), null);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9s3j1.default), null);
        // delete when cleaning up getWillShowNav4
        case 0, $2vSU6.CORE_PROJECT:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dmKXV.default), null);
        default:
            // TODO: render error
            return null;
    }
};
// Since argument of `renderProjectSidebar` is similar to `props` object of a React component
// so we can convert normal function to functional component
const $8451f19a8196b45e$var$ProjectSidebar = /*#__PURE__*/ (0, $5uXOq.memo)($8451f19a8196b45e$var$renderProjectSidebar, (0, (/*@__PURE__*/$parcel$interopDefault($ajpes))));
const $8451f19a8196b45e$export$6af584355cfb32c6 = ({ sidebar: sidebar, children: children })=>{
    const projectState = (0, $lpwtK.useProject)();
    const isInsightMenuSelected = (0, $jjzbO.useInsight)();
    const shouldRenderInsightObjectSchemaSidebar = (0, $jjzbO.useInsightObjectSchemaSidebar)();
    const { selected: pSelected, loading: pLoading } = (0, $gZbSF.useProjectConnectItems)();
    const { selected: prSelected, loading: prLoading } = (0, $hWtQt.useProjectReportsConnectItems)();
    const { selected: psSelected, loading: psLoading } = (0, $jfqNX.useProjectSettingsConnectItems)();
    const { selected: gSelected, loading: gLoading } = (0, $dlYil.useGlobalConnectItems)();
    const { selected: gsSelected, loading: gsLoading } = (0, $b69Lc.useGlobalSettingsConnectItems)();
    const { selected: gssSelected, loading: gssLoading } = (0, $awp39.useGlobalSettingsSystemConnectItems)();
    const { data: gresData, loading: gresLoading } = (0, $2YP9W.useResource)((0, $hz6Yb.connectGeneralResources));
    const { sections: fgSections, loading: fgLoading } = (0, $4IWRY.useForgeGlobalPageItems)();
    // CHOOK-247 - move to 'servicedesk-cmdb-object-schema' route in packages/routes/src/ui/spa/servicedesk/cmdb/index.js
    // once new page is rolled out. Hard-coded here since it isn't possible to have the Route navigation.sidebar
    // property change dynamically at runtime.
    if (shouldRenderInsightObjectSchemaSidebar) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7AyKX.default), null));
    if (isInsightMenuSelected) // fullscreen connect with no sidebar
    return null;
    if (sidebar === (0, $937TY.default)) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $937TY.default), null));
    if (sidebar === (0, $iFaFr.default)) {
        if (fgLoading) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lGo7j.Skeleton), {
            isFull: true
        }));
        if (fgSections?.length) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iFaFr.default), null));
        return children(null);
    }
    if (!Array.isArray(sidebar)) {
        const Sidebar = sidebar;
        return children(Sidebar != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Sidebar, null) : null);
    }
    if (sidebar === (0, $hBv66.genericConnectSidebars)) {
        const foundInProject = pSelected || prSelected || psSelected || [
            'jiraProjectAdminTabPanels'
        ].includes(gresData?.moduleType);
        const foundSomewhere = foundInProject || gSelected || gsSelected || gssSelected;
        const stillLoading = pLoading || prLoading || psLoading || gLoading || gsLoading || gssLoading || gresLoading;
        if (stillLoading && !foundSomewhere) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lGo7j.Skeleton), {
            isFull: true
        }));
        if (foundInProject) {
            const projectSidebar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8451f19a8196b45e$var$ProjectSidebar, projectState);
            return children(projectSidebar);
        }
        if (gSelected) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cin8p.default), null));
        if (gsSelected || [
            'configurePage',
            'postInstallPage'
        ].includes(gresData?.moduleType)) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iHiHz.default), null));
        if (gssSelected || [
            'adminPages'
        ].includes(gresData?.moduleType)) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOg46.default), null));
        // not found, assume fullscreen connect with no sidebar
        return children(null);
    }
    const projectSidebar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8451f19a8196b45e$var$ProjectSidebar, projectState);
    return children(projectSidebar);
};

});
parcelRegister("b69Lc", function(module, exports) {

$parcel$export(module.exports, "useGlobalSettingsConnectItems", () => $ba4edc5b901e34a6$export$f0785b98c99d344c);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $aUDLa = parcelRequire("aUDLa");

var $doZTA = parcelRequire("doZTA");

var $7tsV0 = parcelRequire("7tsV0");

var $4gymV = parcelRequire("4gymV");

var $5W6pd = parcelRequire("5W6pd");
// use memoised functions per hook to avoid re-computation between same hooks
const $ba4edc5b901e34a6$var$getItemsMemo = (0, $8QpSo.default)((d)=>(0, $4gymV.getLinks)(d, [
        'admin_plugins_menu'
    ], {
        skipFilter: true
    })// remove sections also statically defined
    .filter((v)=>![
            'upm_section',
            'jpo-ws-admin'
        ].includes(v.id)).map((0, $5W6pd.transformLink)).filter(Boolean));
const $ba4edc5b901e34a6$var$findItemAndStackMemo = (0, $8QpSo.default)((0, $7tsV0.findItemAndStack));
const $ba4edc5b901e34a6$export$f0785b98c99d344c = ()=>{
    const [{ route: route, location: location }] = (0, $doZTA.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $aUDLa.useNavigationGlobalResource)();
    const items = (0, $5uXOq.useMemo)(()=>data && $ba4edc5b901e34a6$var$getItemsMemo(data), [
        data
    ]);
    const found = (0, $5uXOq.useMemo)(()=>route && items && $ba4edc5b901e34a6$var$findItemAndStackMemo(items, route.name, location), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        loading: loading,
        error: error,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});

parcelRegister("dlYil", function(module, exports) {

$parcel$export(module.exports, "useGlobalConnectItems", () => $17cad8174f7acae6$export$ee355b2e42d6462b);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $aUDLa = parcelRequire("aUDLa");

var $doZTA = parcelRequire("doZTA");

var $7tsV0 = parcelRequire("7tsV0");

var $4gymV = parcelRequire("4gymV");

var $5W6pd = parcelRequire("5W6pd");
// use memoised functions per hook to avoid re-computation between same hooks
const $17cad8174f7acae6$var$getItemsMemo = (0, $8QpSo.default)((d)=>(0, $4gymV.getLinks)(d, [
        'global-navigation-product'
    ]).map((0, $5W6pd.transformLink)).filter((item)=>item != null && item.items));
const $17cad8174f7acae6$var$findItemAndStackMemo = (0, $8QpSo.default)((0, $7tsV0.findItemAndStack));
const $17cad8174f7acae6$export$ee355b2e42d6462b = ()=>{
    const [{ route: route, location: location }] = (0, $doZTA.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $aUDLa.useNavigationGlobalResource)();
    const sidebars = (0, $5uXOq.useMemo)(()=>data && $17cad8174f7acae6$var$getItemsMemo(data), [
        data
    ]);
    const searchResult = (0, $5uXOq.useMemo)(()=>{
        let result = {
            stack: [],
            selected: null,
            title: null,
            data: null
        };
        if (sidebars != null) sidebars.some((sidebar)=>{
            const { items: items } = sidebar || {};
            if (!sidebar || !route || items == null) return false;
            const found = $17cad8174f7acae6$var$findItemAndStackMemo(items, route.name, location);
            if (found) {
                // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'null'. | TS2322 - Type 'ConnectDataItem[]' is not assignable to type 'null'.
                result = {
                    ...found,
                    title: sidebar.name,
                    data: items
                };
                return true;
            }
            return false;
        });
        return result;
    }, [
        sidebars,
        route,
        location
    ]);
    return {
        ...searchResult,
        loading: loading,
        error: error
    };
};

});

parcelRegister("jjzbO", function(module, exports) {

$parcel$export(module.exports, "useInsight", () => $25e0b1dc21125803$export$e24dad0705701755);
$parcel$export(module.exports, "useInsightObjectSchemaSidebar", () => $25e0b1dc21125803$export$1f0bd21403710fc);

var $3HwlS = parcelRequire("3HwlS");

var $6jY6G = parcelRequire("6jY6G");
const $25e0b1dc21125803$export$e24dad0705701755 = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    if (route.navigation) return route.navigation.menuId === 'INSIGHT';
    return false;
};
const $25e0b1dc21125803$export$1f0bd21403710fc = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    if ((0, $3HwlS.getWillShowNav4)()) return false;
    return route.name === 'servicedesk-cmdb-object-schema';
};

});

parcelRegister("hWtQt", function(module, exports) {

$parcel$export(module.exports, "useProjectReportsConnectItems", () => $a740427f233367ba$export$a1c75c386c088992);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $1J3t1 = parcelRequire("1J3t1");

var $doZTA = parcelRequire("doZTA");

var $7tsV0 = parcelRequire("7tsV0");

var $5W6pd = parcelRequire("5W6pd");
const $a740427f233367ba$var$findItemAndStackMemo = (0, $8QpSo.default)((0, $7tsV0.findItemAndStack));
const $a740427f233367ba$export$a1c75c386c088992 = ()=>{
    const [{ route: route, location: location }] = (0, $doZTA.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useProjectReportsSidebarConnectNavigation)();
    const items = (0, $5uXOq.useMemo)(()=>data != null ? data.map((0, $5W6pd.transformLinkV4)).filter(Boolean) : [], [
        data
    ]);
    const found = (0, $5uXOq.useMemo)(()=>route && items && $a740427f233367ba$var$findItemAndStackMemo(items, route.name, location, [
            'reports'
        ]), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        error: error,
        loading: loading,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});

parcelRegister("jfqNX", function(module, exports) {

$parcel$export(module.exports, "useProjectSettingsConnectItems", () => $662340ab1e9d2787$export$41a50100db18b578);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $1J3t1 = parcelRequire("1J3t1");

var $doZTA = parcelRequire("doZTA");

var $7tsV0 = parcelRequire("7tsV0");

var $5W6pd = parcelRequire("5W6pd");
// use memoised functions per hook to avoid re-computation between same hooks
const $662340ab1e9d2787$var$findItemAndStackMemo = (0, $8QpSo.default)((0, $7tsV0.findItemAndStack));
const $662340ab1e9d2787$export$41a50100db18b578 = ()=>{
    const [{ route: route, location: location }] = (0, $doZTA.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useProjectSettingsSidebarConnectNavigation)();
    const items = (0, $5uXOq.useMemo)(()=>data && data.map((0, $5W6pd.transformLinkV4)).filter(Boolean), [
        data
    ]);
    const found = (0, $5uXOq.useMemo)(()=>route && items && $662340ab1e9d2787$var$findItemAndStackMemo(items, route.name, location, [
            'settings'
        ]), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        loading: loading,
        error: error,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});

parcelRegister("gZbSF", function(module, exports) {

$parcel$export(module.exports, "useProjectConnectItems", () => $fcf7bc53994ae8f3$export$f23d0c24c77d7608);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $1J3t1 = parcelRequire("1J3t1");

var $doZTA = parcelRequire("doZTA");

var $7tsV0 = parcelRequire("7tsV0");

var $5W6pd = parcelRequire("5W6pd");
const $fcf7bc53994ae8f3$var$findItemAndStackMemo = (0, $8QpSo.default)((0, $7tsV0.findItemAndStack));
const $fcf7bc53994ae8f3$export$f23d0c24c77d7608 = ()=>{
    const [{ route: route, location: location }] = (0, $doZTA.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useProjectSidebarConnectNavigation)();
    const items = (0, $5uXOq.useMemo)(()=>data && data.map((0, $5W6pd.transformLinkV4)).filter(Boolean), [
        data
    ]);
    const found = (0, $5uXOq.useMemo)(()=>route && items && $fcf7bc53994ae8f3$var$findItemAndStackMemo(items, route.name, location), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        loading: loading,
        error: error,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});

parcelRegister("4IWRY", function(module, exports) {

$parcel$export(module.exports, "useForgeGlobalPageItems", () => $e660bc01a5db5a53$export$ff333fd2f0bf5254);

var $5uXOq = parcelRequire("5uXOq");

var $4NrfJ = parcelRequire("4NrfJ");

var $7Tlti = parcelRequire("7Tlti");

var $c70gQ = parcelRequire("c70gQ");

var $doZTA = parcelRequire("doZTA");
const $e660bc01a5db5a53$export$ff333fd2f0bf5254 = ()=>{
    const [{ match: match }] = (0, $doZTA.useRouter)();
    const { data: modules, loading: loading, error: error } = (0, $4NrfJ.useGlobalForgeApps)();
    const extension = (0, $c70gQ.useMatchedExtension)({
        modules: modules,
        match: match
    });
    const sections = (0, $5uXOq.useMemo)(()=>extension && (0, $7Tlti.toSections)(extension), [
        extension
    ]);
    return {
        extension: extension,
        sections: sections,
        loading: loading,
        error: error
    };
};

});
parcelRegister("4NrfJ", function(module, exports) {

$parcel$export(module.exports, "getItemHref", () => $7a76aaaa3a23f02a$export$ed6342e0e28465a6);
$parcel$export(module.exports, "useGlobalForgeApps", () => $7a76aaaa3a23f02a$export$f834c14187f80532);

var $5uXOq = parcelRequire("5uXOq");

var $e0AC8 = parcelRequire("e0AC8");

var $5cmSg = parcelRequire("5cmSg");

var $5bkvv = parcelRequire("5bkvv");

var $2YP9W = parcelRequire("2YP9W");
const $7a76aaaa3a23f02a$export$ed6342e0e28465a6 = (extension)=>{
    const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
    return `/jira/apps/${appId}/${envId}`;
};
const $7a76aaaa3a23f02a$export$f834c14187f80532 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)((0, $5bkvv.forgeGlobalModuleResource));
    return (0, $5uXOq.useMemo)(()=>({
            data: data ? data.filter((0, $5cmSg.isExtensionVisible)) : null,
            loading: loading,
            error: error
        }), [
        data,
        loading,
        error
    ]);
};

});

parcelRegister("7Tlti", function(module, exports) {

$parcel$export(module.exports, "toSections", () => $25b31557e9750c03$export$29678d1e04c0e8c4);

var $8QpSo = parcelRequire("8QpSo");
/**
 * Just in case someone passes a broken object we don't want to blow up the sidebar
 */ const $25b31557e9750c03$var$normalizeSection = (section)=>({
        header: section?.header,
        pages: Array.isArray(section?.pages) ? section.pages.map((page)=>({
                icon: page?.icon,
                route: page?.route,
                title: page?.title
            })) : []
    });
const $25b31557e9750c03$export$29678d1e04c0e8c4 = (0, $8QpSo.default)((extension)=>{
    const { properties: properties } = extension;
    // Only Custom UI supports subpages
    if (typeof properties.resource !== 'string') return [];
    // @ts-expect-error - TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'. | TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    if (typeof properties.pages !== 'undefined' && properties.pages?.length) // @ts-expect-error - TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    return [
        {
            pages: properties.pages
        }
    ].map($25b31557e9750c03$var$normalizeSection);
    // @ts-expect-error - TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'. | TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    if (typeof properties.sections !== 'undefined' && properties.sections?.length) // @ts-expect-error - TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    return properties.sections.map($25b31557e9750c03$var$normalizeSection);
    return [];
});

});

parcelRegister("c70gQ", function(module, exports) {

$parcel$export(module.exports, "useMatchedExtension", () => $b661f1f04cec9385$export$13375c0abccaf6f6);
$parcel$export(module.exports, "useExtensionBasePath", () => $b661f1f04cec9385$export$25abed85383f0fbb);

var $5uXOq = parcelRequire("5uXOq");

var $e0AC8 = parcelRequire("e0AC8");
const $b661f1f04cec9385$export$13375c0abccaf6f6 = ({ modules: modules, match: match })=>(0, $5uXOq.useMemo)(()=>(modules || []).find((app)=>{
            const parsedExtensionId = (0, $e0AC8.parseExtensionId)(app.id);
            return parsedExtensionId.appId === match.params.appId && parsedExtensionId.envId === match.params.envId;
        }), [
        modules,
        match.params.appId,
        match.params.envId
    ]);
const $b661f1f04cec9385$export$25abed85383f0fbb = (baseUrl, route)=>route !== undefined ? baseUrl.replace(/\/?$/, '').slice(0, -route.length - 1) : baseUrl.replace(/\/?$/, '');

});


parcelRegister("7AyKX", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cf06d255b5e49f4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

const $6cf06d255b5e49f4$var$LazyInsightObjectSchemaSidebar = (0, $kxZPA.lazyForPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("5j7D4")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/insight-object-schema/src/index.tsx"
});
const $6cf06d255b5e49f4$var$InsightObjectSchemaSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "insight-object-schema-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6cf06d255b5e49f4$var$LazyInsightObjectSchemaSidebar, null)));
$6cf06d255b5e49f4$var$InsightObjectSchemaSidebar.displayName = 'InsightObjectSchemaSidebar';
var $6cf06d255b5e49f4$export$2e2bcd8739ae039 = $6cf06d255b5e49f4$var$InsightObjectSchemaSidebar;

});
parcelRegister("5j7D4", function(module, exports) {

let $3dd4a514ff7d76bf$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $3dd4a514ff7d76bf$var$load("kNFvF"),
    $3dd4a514ff7d76bf$var$load("76n7a"),
    $3dd4a514ff7d76bf$var$load("l253H"),
    $3dd4a514ff7d76bf$var$load("jbxE1"),
    $3dd4a514ff7d76bf$var$load("7imUH"),
    $3dd4a514ff7d76bf$var$load("jOESs")
]).then(()=>parcelRequire('48ZOK'));

});


parcelRegister("lgSL3", function(module, exports) {

$parcel$export(module.exports, "default", () => $756fa7b51ff3cfd4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

const $756fa7b51ff3cfd4$var$LazyPolarisProjectSidebar = (0, $kxZPA.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("aYk9h")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/polaris/src/index.tsx"
});
const $756fa7b51ff3cfd4$var$PolarisProjectSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "polarisProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($756fa7b51ff3cfd4$var$LazyPolarisProjectSidebar, null)));
$756fa7b51ff3cfd4$var$PolarisProjectSidebar.displayName = 'PolarisProjectSidebar';
var $756fa7b51ff3cfd4$export$2e2bcd8739ae039 = $756fa7b51ff3cfd4$var$PolarisProjectSidebar;

});
parcelRegister("aYk9h", function(module, exports) {

let $7fcf23122547c742$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $7fcf23122547c742$var$load("ffQaD"),
    $7fcf23122547c742$var$load("kvRbA"),
    $7fcf23122547c742$var$load("2GkCU")
]).then(()=>parcelRequire('aSh9m'));

});



parcelRegister("4V52L", function(module, exports) {

$parcel$export(module.exports, "SidebarFeedbackButton", () => $ea1c2dd9a94de02f$export$b270ed097d20c023);

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");
var $42CjB = parcelRequire("42CjB");

var $jpaiZ = parcelRequire("jpaiZ");

var $e4yMr = parcelRequire("e4yMr");

var $3bDjY = parcelRequire("3bDjY");

var $dS3PR = parcelRequire("dS3PR");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $7iULw = parcelRequire("7iULw");

var $dseDh = parcelRequire("dseDh");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $4DrQd = parcelRequire("4DrQd");

var $bw7Gm = parcelRequire("bw7Gm");

var $koeKL = parcelRequire("koeKL");

var $2tT7R = parcelRequire("2tT7R");

var $DVljb = parcelRequire("DVljb");

var $83YFz = parcelRequire("83YFz");
function $ea1c2dd9a94de02f$export$b270ed097d20c023() {
    const environment = (0, $2tT7R.useEnvironment)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { openFeedbackCollector: openFeedbackCollector, closeFeedbackCollector: closeFeedbackCollector } = (0, $dseDh.useFeedbackCollectorActions)();
    const formattedMessageNode = (0, $5uXOq.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
            as: "p"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $83YFz.default).feedbackTitleDetailsNoLink)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
            href: "https://support.atlassian.com/jira-software-cloud/docs/what-is-the-new-navigation-in-jira/",
            onClick: closeFeedbackCollector,
            target: "_blank"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $83YFz.default).feedbackTitleLearnMoreLinkText)));
    }, [
        closeFeedbackCollector
    ]);
    const onClickHandler = (0, $5uXOq.useCallback)(()=>{
        openFeedbackCollector({
            entrypointId: (0, $7iULw.ENTRYPOINT_ID_NAVIGATION_REFRESH),
            feedbackContext: [
                {
                    id: 'environment',
                    value: environment
                },
                {
                    id: 'cloud-id',
                    value: cloudId
                },
                {
                    id: 'location',
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    value: (0, $bw7Gm.default)(window?.location?.href ?? '')
                }
            ],
            feedbackGroupId: (0, $4DrQd.NAV4_GENERAL_FEEDBACK_GROUP_ID),
            feedbackTitle: formatMessage((0, $83YFz.default).feedbackTitle),
            feedbackTitleDetails: formattedMessageNode
        });
    }, [
        cloudId,
        environment,
        formatMessage,
        formattedMessageNode,
        openFeedbackCollector
    ]);
    const locale = (0, $DVljb.useLocale)();
    const showPersistentInvite = // Ensure that we can turn off the locale check with a feature gate if needed
    // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4R6GH.fg)('navx_persistent_invite_jira_new_non_free') && // Do not trigger an exposure on the experiment for non-English locales
    (locale?.toLowerCase().startsWith('en') ?? false) && (0, $6s1PB.expVal)('navx_persistent_invite_jira_new_non_free_exp', 'global_invite_enabled', false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $83YFz.default).sidebarFeedbackButtonLabel),
        position: "top"
    }, showPersistentInvite ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jpaiZ))),
        onClick: onClickHandler,
        label: formatMessage((0, $83YFz.default).sidebarFeedbackButtonLabel)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($jpaiZ))),
        appearance: "subtle",
        onClick: onClickHandler
    }, formatMessage((0, $83YFz.default).sidebarFeedbackButtonLabel)));
}

});
parcelRegister("jpaiZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c12e14f5c33454d538618fce8415497d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e208588d898f6af2$var$_react = $e208588d898f6af2$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e208588d898f6af2$var$_baseNew = $e208588d898f6af2$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e208588d898f6af2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Megaphone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: feedback in products.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e208588d898f6af2$var$MegaphoneIcon = (props)=>/*#__PURE__*/ $e208588d898f6af2$var$_react.default.createElement($e208588d898f6af2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.5 3.096a.5.5 0 0 0-.686-.464L7.5 4.758v4.734l5.314 2.126a.5.5 0 0 0 .686-.464zm-6 8.012 4.757 1.903A2 2 0 0 0 15 11.154V3.096a2 2 0 0 0-2.743-1.857L6.606 3.5H3a2 2 0 0 0-2 2v3.25a2 2 0 0 0 2 2h.5V13a2 2 0 0 0 2 2h1.25a.75.75 0 0 0 .75-.75zM6 9.25H3a.5.5 0 0 1-.5-.5V5.5A.5.5 0 0 1 3 5h3zm0 1.5v2.75h-.5A.5.5 0 0 1 5 13v-2.25z" clip-rule="evenodd"/>`
    }, props));
$e208588d898f6af2$var$MegaphoneIcon.displayName = 'MegaphoneIcon';
var $e208588d898f6af2$var$_default = module.exports.default = $e208588d898f6af2$var$MegaphoneIcon;

});

parcelRegister("7iULw", function(module, exports) {

$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PLATFORM", () => $384a8a865c8f714d$export$baea5c8192e79adc);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT", () => $384a8a865c8f714d$export$4eda1e3a4a311d13);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PRODUCT_DISCOVERY", () => $384a8a865c8f714d$export$5fb38521eb7ad63c);
$parcel$export(module.exports, "ENTRYPOINT_ID_THEME_JSM_INSIGHT_CMDB", () => $384a8a865c8f714d$export$345c45dd28f28a32);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_COMMAND_PALETTE", () => $384a8a865c8f714d$export$8962f2e618411469);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_VIEW", () => $384a8a865c8f714d$export$7d7f2319141db3c5);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_NAVIGATOR", () => $384a8a865c8f714d$export$4725635e6fe1907a);
$parcel$export(module.exports, "ENTRY_POINT_ID_GENERATIVE_AI", () => $384a8a865c8f714d$export$3a50f2efd6cfd6f3);
$parcel$export(module.exports, "ENTRY_POINT_ID_AIOPS", () => $384a8a865c8f714d$export$5bd148c13bb23f7a);
$parcel$export(module.exports, "ENTRY_POINT_ID_COMPASS", () => $384a8a865c8f714d$export$b4de0744c1fd450d);
$parcel$export(module.exports, "ENTRY_POINT_ID_JSM_ASSETS_REPORTING", () => $384a8a865c8f714d$export$1a7c42187130faf9);
$parcel$export(module.exports, "ENTRY_POINT_ID_JSM_VIRTUAL_AGENT", () => $384a8a865c8f714d$export$e84c34a7e1dbcf78);
$parcel$export(module.exports, "ENTRYPOINT_ID_NAVIGATION_REFRESH", () => $384a8a865c8f714d$export$23f6d7b16d2210c1);
$parcel$export(module.exports, "ENTRY_POINT_ID_AUTODEV", () => $384a8a865c8f714d$export$1b65c2053cba0686);
$parcel$export(module.exports, "ENTRY_POINT_ID_REQUEST_TYPES_PAGE", () => $384a8a865c8f714d$export$86e0eeb08f5b7ea6);
$parcel$export(module.exports, "ENTRYPOINT_ID_PROJECT_BACKGROUNDS", () => $384a8a865c8f714d$export$9a234699f0515bf);
$parcel$export(module.exports, "ENTRY_POINT_ID_JOURNEY_BUILDER", () => $384a8a865c8f714d$export$f24169c529e6c9b5);
$parcel$export(module.exports, "EntryKeys", () => $384a8a865c8f714d$export$12d01b6c311a909a);
// Jira platform project feedback JSD widget configuration
// https://customerfeedback.atlassian.net/jira/servicedesk/projects/JGF/queues/custom/448
const $384a8a865c8f714d$export$baea5c8192e79adc = '1ff0a150-1d4f-4225-8e7b-3577fb9d9764';
const $384a8a865c8f714d$export$4eda1e3a4a311d13 = 'f60db8bd-1904-4af4-a0ef-f140598ebada';
const $384a8a865c8f714d$export$5fb38521eb7ad63c = '3508b77a-0aa1-4ad5-a397-621bd308c828';
const $384a8a865c8f714d$export$345c45dd28f28a32 = 'cdb5199a-4c4e-4692-b006-4e2628ed4771';
const $384a8a865c8f714d$export$8962f2e618411469 = '3d204590-d14a-419f-a042-f0b1a92e005b';
const $384a8a865c8f714d$export$7d7f2319141db3c5 = 'af9ace2f-61a9-45ac-8e67-b54f74246b94';
const $384a8a865c8f714d$export$4725635e6fe1907a = 'cd375e0e-ae56-4a2f-bad8-6114c617bf2f';
const $384a8a865c8f714d$export$3a50f2efd6cfd6f3 = '73cf1eae-42a3-418a-a7ac-976ba0b5735d';
const $384a8a865c8f714d$export$5bd148c13bb23f7a = 'b6a8ea1d-9ec0-4bb6-9e22-01fd310c0591';
const $384a8a865c8f714d$export$b4de0744c1fd450d = 'e6321572-aa72-47b3-b261-e142b81ad4b2';
const $384a8a865c8f714d$export$1a7c42187130faf9 = 'b4ac51f3-c235-4f9e-97d0-d450e76aa13a';
const $384a8a865c8f714d$export$e84c34a7e1dbcf78 = '1b1c9a31-ebef-44b4-9eaa-4ee884672259';
const $384a8a865c8f714d$export$23f6d7b16d2210c1 = '5002b4f2-9df8-4bb2-8798-56005ef6cbfc';
const $384a8a865c8f714d$export$1b65c2053cba0686 = '88d39839-ba5c-4704-bfd6-7fe57ed8016b';
const $384a8a865c8f714d$export$86e0eeb08f5b7ea6 = 'ee8a71e7-85aa-4121-b455-e6316922e894';
const $384a8a865c8f714d$export$9a234699f0515bf = 'd0f0863a-fe78-4d40-b4f0-451c268594cc';
const $384a8a865c8f714d$export$f24169c529e6c9b5 = 'd5f62dde-d505-413b-a417-c2dd6979cac2';
const $384a8a865c8f714d$export$12d01b6c311a909a = Object.freeze({
    CLOUD_ID: 'cloud-id',
    OPT_OUT: 'Opt-out',
    REASON: 'reason',
    FEELING: 'feeling',
    IS_ADMIN: 'is-admin',
    IS_SITE_ADMIN: 'is-site-admin',
    IS_PROJECT_SETTINGS: 'is-project-settings',
    INLINE_FEEDBACK_ID: 'inlineFeedbackId',
    IS_JSD_EVALUATOR: 'is-jsd-evaluator',
    IS_SIMPLIFIED_PROJECT: 'is-simplified-project',
    SUPPORTED_PROJECT_TYPES: 'supported-project-types',
    FEEDBACK_COLLECTOR_LOCATION: 'feedback-collector-location',
    FEEDBACK_COLLECTOR_ID: 'feedback-collector-id',
    FEEDBACK_EMBEDDABLE_KEY: 'feedback-embeddable-key',
    LOCATION: 'Location',
    PROJECT_TYPE: 'project-type',
    BOARD_TYPE: 'board-type',
    REFERER: 'Referer',
    ROUTE_GROUP: 'route-group',
    ROUTE_NAME: 'route-name',
    USER_AGENT: 'User-Agent',
    SCREEN_RESOLUTION: 'Screen Resolution',
    SOURCE: 'Source',
    SUB_PRODUCT: 'Sub-product',
    JSM_REQUEST_TYPE_CHANGE_WORKFLOW: 'jsm-request-type-change-workflow',
    JSD_REQUEST_TYPE_REDESIGN: 'jsd-request-type-redesign',
    DEPLOYMENT_PROVIDERS: 'deployment-providers',
    JSM_QUEUES_SIDE_BAR: 'jsm-queue-side-bar',
    VERSION_CONTROL_PROVIDERS: 'version-control-providers',
    DEV_DETAILS_DIALOG_TAB: 'dev-details-dialog-tab',
    CODE_IN_JIRA_PROVIDERS: 'code-in-jira-providers',
    SECURITY_IN_JIRA_PROVIDERS: 'security-in-jira-providers',
    INCIDENTS_IN_JIRA_PROVIDERS: 'incidents-in-jira-providers',
    IS_ATLASKIT_FEEDBACK_COMPONENT: 'is-atlaskit-feedback-component',
    FEEDBACK_GROUP_ID: 'feedback-group-id',
    EDITION: 'edition',
    ENV: 'environment',
    SMART_REPLIES: 'smart-replies',
    COLLABORATIVE_SPRINTS: 'collaborative-sprints',
    PROJECT_RECAP_FEEDBACK_GROUP_ID: 'jira-notifications-project-recap'
});

});

parcelRegister("dseDh", function(module, exports) {

$parcel$export(module.exports, "useFeedbackCollector", () => $c996142feb877ddb$export$4be696be8a3bff13);
$parcel$export(module.exports, "useFeedbackCollectorActions", () => $c996142feb877ddb$export$dfb2ee2d9e73fa48);
$parcel$export(module.exports, "FeedbackActionsSubscriber", () => $c996142feb877ddb$export$c35dbf16ebe9df04);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
const $c996142feb877ddb$export$d4c72bab9d6cc13a = {
    isFeedbackCollectorOpen: false,
    entrypointId: undefined,
    email: undefined,
    additionalFields: undefined,
    feedbackTitle: undefined,
    feedbackContext: undefined,
    feedbackCollectorId: undefined,
    // default value of this prop is true so making sure inititally it is true
    showTypeField: true,
    submitButtonLabel: undefined,
    canBeContactedLabel: undefined,
    summaryPlaceholder: undefined,
    feedbackGroupLabels: undefined,
    onClose: undefined,
    feedbackTitleDetails: undefined,
    triggerRef: undefined,
    renderCustomContent: undefined,
    customFeedbackOptions: []
};
const $c996142feb877ddb$export$e324594224ef24da = {
    openFeedbackCollector: (feedbackCollectorProps)=>({ setState: setState, dispatch: dispatch })=>{
            // Reset to initial state to clear any leftover state
            dispatch($c996142feb877ddb$export$e324594224ef24da.resetFeedbackCollectorState());
            setState({
                ...feedbackCollectorProps,
                isFeedbackCollectorOpen: true
            });
        },
    closeFeedbackCollector: ()=>({ getState: getState, setState: setState })=>{
            const { triggerRef: triggerRef } = getState();
            if (triggerRef) // Unfortunately we need a setTimeout here to delay the execution cycle because modal is yet to be closed
            setTimeout(()=>triggerRef.current?.focus(), 50);
            setState({
                isFeedbackCollectorOpen: false,
                triggerRef: undefined
            });
        },
    resetFeedbackCollectorState: ()=>({ setState: setState })=>{
            setState({
                ...$c996142feb877ddb$export$d4c72bab9d6cc13a
            });
        },
    updateCustomRenderComponent: (updatedCustomRenderContent)=>({ setState: setState })=>{
            setState({
                renderCustomContent: updatedCustomRenderContent
            });
        },
    updateAdditionalFields: (updatedAdditionalFields)=>({ setState: setState })=>{
            setState({
                additionalFields: updatedAdditionalFields
            });
        }
};
const $c996142feb877ddb$var$Store = (0, $iXqE5.createStore)({
    name: 'feedback-collector',
    initialState: $c996142feb877ddb$export$d4c72bab9d6cc13a,
    actions: $c996142feb877ddb$export$e324594224ef24da
});
const $c996142feb877ddb$export$4be696be8a3bff13 = (0, $3sQ5x.createHook)($c996142feb877ddb$var$Store);
const $c996142feb877ddb$export$dfb2ee2d9e73fa48 = (0, $3sQ5x.createActionsHook)($c996142feb877ddb$var$Store);
const $c996142feb877ddb$export$c35dbf16ebe9df04 = (0, $51nlc.createSubscriber)($c996142feb877ddb$var$Store, {
    selector: null
});

});

parcelRegister("83YFz", function(module, exports) {

$parcel$export(module.exports, "default", () => $583ab6a643d91da5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $583ab6a643d91da5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    sidebarFeedbackButtonLabel: {
        "id": "sidebar-nav4-feedback-button.sidebar-feedback-button-label",
        "defaultMessage": "Give feedback on the new navigation"
    },
    feedbackTitle: {
        "id": "sidebar-nav4-feedback-button.utils.use-nav4-feedback-collector.feedback-title",
        "defaultMessage": "Help us improve the new navigation"
    },
    feedbackTitleDetailsWithLink: {
        "id": "sidebar-nav4-feedback-button.feedback-title-details",
        "defaultMessage": "We\u2019d love to hear about your experience with the new navigation. If needed, <a>you can switch back to the old navigation</a>."
    },
    feedbackTitleDetailsNoLink: {
        "id": "sidebar-nav4-feedback-button.feedback-title-details-no-link",
        "defaultMessage": "We\u2019d love to hear about your experience with the new navigation."
    },
    feedbackTitleLearnMoreLinkText: {
        "id": "sidebar-nav4-feedback-button.feedback-title-learn-more-link-text",
        "defaultMessage": "Learn more about the new navigation"
    }
});

});


parcelRegister("ht71P", function(module, exports) {

$parcel$export(module.exports, "AsyncNudgeBundledUsersFlagContainer", () => $7676eec527946b59$export$30d9dff000fbaa2d);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7676eec527946b59$var$NudgeBundledUsersFlagContainer = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("hyqra")).then((module)=>module.NudgeBundledUsersXflow), {
    ssr: false,
    moduleId: "./src/packages/growth/nudge-bundled-users-to-join-connie/src/ui/index.tsx"
});
const $7676eec527946b59$export$30d9dff000fbaa2d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "nudgeBundledUserFlag",
        packageName: "nudgeBundledUsersToJoinConnie",
        fallback: "unmount",
        teamName: "confluenceOnboarding"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nudge-bundled-users-flag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7676eec527946b59$var$NudgeBundledUsersFlagContainer, null)));

});
parcelRegister("hyqra", function(module, exports) {

let $cc7a1e7e3e7dc9b1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cc7a1e7e3e7dc9b1$var$load("kZMTi").then(()=>parcelRequire('6vucW'));

});


parcelRegister("kBsG9", function(module, exports) {

$parcel$export(module.exports, "AsyncNudgeInactiveConfluenceUserFlagContainer", () => $3354d3e662d787d2$export$ab9e9eb42f22ca03);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $iXVV6 = parcelRequire("iXVV6");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3354d3e662d787d2$var$NudgeInactiveConfluenceUserFlagContainer = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("dhfhy")).then((module)=>module.NudgeInactiveConfluenceUser), {
    ssr: false,
    moduleId: "./src/packages/growth/nudge-inactive-confluence-user/src/ui/index.tsx"
});
const $3354d3e662d787d2$export$ab9e9eb42f22ca03 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "nudgeInactiveConfluenceUserFlag",
        packageName: "nudgeInactiveConfluenceUser",
        fallback: "unmount",
        teamName: "cc-flywheel-adoption"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nudge-inactive-confluence-user-flag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "nudgeInactiveConfluenceUserFlag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3354d3e662d787d2$var$NudgeInactiveConfluenceUserFlagContainer, null))));

});
parcelRegister("dhfhy", function(module, exports) {

let $9aa8b797d12dd50f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9aa8b797d12dd50f$var$load("5cNsZ").then(()=>parcelRequire('4qWqy'));

});


parcelRegister("5gylp", function(module, exports) {

$parcel$export(module.exports, "SidebarEntryPointSelector", () => $d6305ce20becbb27$export$7b792d211e60bd1d);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $2Ioew = parcelRequire("2Ioew");


var $frBVt = parcelRequire("frBVt");

var $7CMCs = parcelRequire("7CMCs");

var $cSD7y = parcelRequire("cSD7y");

var $7VBev = parcelRequire("7VBev");

var $l8ruj = parcelRequire("l8ruj");

var $6jY6G = parcelRequire("6jY6G");

var $jKa0E = parcelRequire("jKa0E");




var $3F9p6 = parcelRequire("3F9p6");

var $iXVV6 = parcelRequire("iXVV6");

var $23Lmh = parcelRequire("23Lmh");

var $fwGlt = parcelRequire("fwGlt");
const $d6305ce20becbb27$export$7b792d211e60bd1d = (0, $cSD7y.componentWithFG)('blu-5799-jira-software-board-entrypoint-route', $d6305ce20becbb27$var$Nav4SidebarEntryPointContainer, (0, $23Lmh.SidebarSelector));
function $d6305ce20becbb27$var$Nav4SidebarEntryPointContainer() {
    const currentRoute = (0, $6jY6G.useCurrentRoute)();
    const paramsForGetNav4SidebarId = (0, $fwGlt.useGetParamsForGetNav4SidebarId)();
    const currentSidebarId = (0, $fwGlt.getNav4SidebarId)(paramsForGetNav4SidebarId);
    const currentEntryPointRef = (0, $2Ioew.usePageLayoutEntryPoint)((0, $6d6ccf8a2b2c5b3c$export$50ea883ba6f28ff5));
    const [sidebarConfig, setSidebarConfig] = (0, $5uXOq.useState)(()=>{
        // We want to avoid switching between the SidebarSelector and the sidebar entryPoint as we navigate through the SPA.
        // To do that, we need to keep using the __initial__ sidebar entryPoint if we haven't changed sidebars.
        // When we do switch sidebars, keep using SidebarSelector from that point onwards (for now).
        // When all of the sidebars are using entryPoints, we can deprecate the SidebarSelector.
        const attributes = {
            navigationLayer: (0, $ce9c0831aed9ffb3$export$17ff3f7e02c6ac22),
            navigationContainer: (0, $68cb678dc917978e$export$2ee9e5a3556c1e43),
            navState: (0, $1520d876660a71bd$export$2bd315ece9f68967),
            stage: (0, $3F9p6.getNav4Rollout)().stage
        };
        return {
            Component: ()=>currentEntryPointRef && currentRoute.navigation?.sidebarId === currentSidebarId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
                    name: "nav4-sidebar-entrypoint"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
                    fallback: "flag",
                    id: "nav4-sidebar-entrypoint",
                    packageName: "jira-page-container-v2"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jKa0E.NavigateBackProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
                    attributes: attributes
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $frBVt.EntryPointReferencePlaceholder), {
                    name: "nav4-sidebar-entrypoint-placeholder",
                    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VBev.Skeleton), null),
                    entryPointReference: currentEntryPointRef
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
                    entryPointReference: currentEntryPointRef,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    props: {}
                })))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $23Lmh.SidebarSelector), null),
            sidebarId: currentSidebarId
        };
    });
    (0, $5uXOq.useEffect)(()=>{
        if (sidebarConfig.sidebarId !== currentSidebarId) setSidebarConfig({
            Component: (0, $23Lmh.SidebarSelector),
            sidebarId: currentSidebarId
        });
    }, [
        currentSidebarId,
        sidebarConfig.sidebarId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(sidebarConfig.Component, null);
}

});
parcelRegister("3F9p6", function(module, exports) {

$parcel$export(module.exports, "getNav4Rollout", () => $826ce4e4d6cfd68d$export$84a05d3b37ec5d2);

var $9glig = parcelRequire("9glig");

var $cxSdl = parcelRequire("cxSdl");

var $hMlwW = parcelRequire("hMlwW");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $7qZOo = parcelRequire("7qZOo");

var $hUCm2 = parcelRequire("hUCm2");

var $8O1QZ = parcelRequire("8O1QZ");

var $32Frn = parcelRequire("32Frn");

var $laQnH = parcelRequire("laQnH");
const $826ce4e4d6cfd68d$export$84a05d3b37ec5d2 = (0, (/*@__PURE__*/$parcel$interopDefault($9glig)))([
    [
        ()=>!(0, $4R6GH.fg)('jira_nav4'),
        (0, (/*@__PURE__*/$parcel$interopDefault($cxSdl)))((0, $7qZOo.NAV4_ROLLOUT_NONE))
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_dogfooding'),
        (0, $8O1QZ.getNav4RolloutForDogfooding)
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_eap'),
        (0, $32Frn.getNav4RolloutForEap)
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_beta_existing-customers'),
        (0, $hUCm2.getNav4RolloutForBetaCohort)('existing-customers')
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_beta_sandboxes'),
        (0, $hUCm2.getNav4RolloutForBetaCohort)('sandboxes')
    ],
    [
        ()=>(0, $6s1PB.expVal)('jira_nav4_beta_free-customers', 'willShowNav4', false),
        (0, $hUCm2.getNav4RolloutForBetaCohort)('free-customers')
    ],
    [
        ()=>(0, $6s1PB.expVal)('jira_nav4_beta_new-customers', 'willShowNav4', false),
        (0, $hUCm2.getNav4RolloutForBetaCohort)('new-customers')
    ],
    [
        ()=>(0, $6s1PB.expVal)('confluence_jira_nav4_new_customers', 'willShowNav4', false),
        (0, $hUCm2.getNav4RolloutForBetaCohort)('new-customers-x')
    ],
    // Break up cond for easier testing.
    [
        (0, (/*@__PURE__*/$parcel$interopDefault($hMlwW))),
        (0, $laQnH.getNav4RolloutForGaAndBeyond)
    ]
]);

});
parcelRegister("7qZOo", function(module, exports) {

$parcel$export(module.exports, "NAV4_ROLLOUT_NONE", () => $92928f70e02753a5$export$3b602cac1f385c06);
$parcel$export(module.exports, "NAV4_ROLLOUT_MOBILE", () => $92928f70e02753a5$export$e748a16828d2f61f);
const $92928f70e02753a5$export$3b602cac1f385c06 = {
    stage: 'none'
};
const $92928f70e02753a5$export$e748a16828d2f61f = {
    stage: 'mobile'
};

});

parcelRegister("hUCm2", function(module, exports) {

$parcel$export(module.exports, "getNav4RolloutForBetaCohort", () => $8194d49fe31934aa$export$d0b7d7e3a8d0a0c9);

var $1i1R1 = parcelRequire("1i1R1");
const $8194d49fe31934aa$export$d0b7d7e3a8d0a0c9 = (cohort)=>()=>cohort !== 'existing-customers' ? {
            stage: 'beta',
            cohort: cohort
        } : {
            stage: 'beta',
            cohort: cohort,
            isUserOptOut: (0, $1i1R1.getIsNav4UserOptOut)()
        };

});

parcelRegister("8O1QZ", function(module, exports) {

$parcel$export(module.exports, "getNav4RolloutForDogfooding", () => $48ac6742e168ff29$export$f1e751a9a9d68fb5);

var $9glig = parcelRequire("9glig");

var $hMlwW = parcelRequire("hMlwW");

var $4R6GH = parcelRequire("4R6GH");

var $1i1R1 = parcelRequire("1i1R1");
const $48ac6742e168ff29$var$dogfoodingPhase = (phase)=>()=>phase !== 3 ? {
            stage: 'dogfooding',
            phase: phase,
            isUserOptOut: (0, $1i1R1.getIsNav4UserOptOut)()
        } : {
            stage: 'dogfooding',
            phase: phase
        };
const $48ac6742e168ff29$export$f1e751a9a9d68fb5 = (0, (/*@__PURE__*/$parcel$interopDefault($9glig)))([
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_dogfooding_phase-2'),
        $48ac6742e168ff29$var$dogfoodingPhase(2)
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_dogfooding_phase-1'),
        $48ac6742e168ff29$var$dogfoodingPhase(1)
    ],
    [
        (0, (/*@__PURE__*/$parcel$interopDefault($hMlwW))),
        $48ac6742e168ff29$var$dogfoodingPhase(3)
    ]
]);

});

parcelRegister("32Frn", function(module, exports) {

$parcel$export(module.exports, "getNav4RolloutForEap", () => $d3197687d5551826$export$42dd8c002a342b8);

var $1i1R1 = parcelRequire("1i1R1");
const $d3197687d5551826$export$42dd8c002a342b8 = ()=>({
        stage: 'eap',
        isUserOptOut: (0, $1i1R1.getIsNav4UserOptOut)()
    });

});

parcelRegister("laQnH", function(module, exports) {

$parcel$export(module.exports, "getNav4RolloutForGaAndBeyond", () => $8c7cc40a2449f7a7$export$99bed161b1040362);

var $9glig = parcelRequire("9glig");

var $cxSdl = parcelRequire("cxSdl");

var $hMlwW = parcelRequire("hMlwW");

var $4R6GH = parcelRequire("4R6GH");

var $c0dQj = parcelRequire("c0dQj");

var $1i1R1 = parcelRequire("1i1R1");

var $7qZOo = parcelRequire("7qZOo");
const $8c7cc40a2449f7a7$export$99bed161b1040362 = (0, (/*@__PURE__*/$parcel$interopDefault($9glig)))([
    // Later GA phases eclipse earlier phases.
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_ga_phase-3'),
        ()=>({
                stage: 'ga',
                phase: 3
            })
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_ga_phase-2'),
        ()=>({
                stage: 'ga',
                phase: 2,
                isUserOptOut: (0, $1i1R1.getIsNav4UserOptOut)()
            })
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_ga_phase-1-5'),
        ()=>({
                stage: 'ga',
                phase: 1.5,
                isAdmin: (0, $1i1R1.getIsAdmin)(),
                isTenantOptOut: (0, $1i1R1.getIsNav4TenantOptOut)(),
                isUserOptOut: (0, $1i1R1.getIsNav4UserOptOut)()
            })
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_ga_phase-1'),
        ()=>({
                stage: 'ga',
                phase: 1,
                isAdmin: (0, $1i1R1.getIsAdmin)(),
                isTenantOptIn: (0, $1i1R1.getIsNav4TenantOptIn)(),
                isUserOptIn: (0, $1i1R1.getIsNav4UserOptIn)(),
                isUserOptOut: (0, $1i1R1.getIsNav4UserOptOut)()
            })
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_ga_sandboxes'),
        ()=>({
                stage: 'ga',
                cohort: 'sandboxes',
                isUserOptIn: (0, $1i1R1.getIsNav4UserOptIn)()
            })
    ],
    [
        ()=>(0, $c0dQj.isMobileAndInMvpOrExistingUsersExperiment)(),
        (0, (/*@__PURE__*/$parcel$interopDefault($cxSdl)))((0, $7qZOo.NAV4_ROLLOUT_MOBILE))
    ],
    [
        (0, (/*@__PURE__*/$parcel$interopDefault($hMlwW))),
        (0, (/*@__PURE__*/$parcel$interopDefault($cxSdl)))((0, $7qZOo.NAV4_ROLLOUT_NONE))
    ]
]);

});


parcelRegister("23Lmh", function(module, exports) {

$parcel$export(module.exports, "SidebarSelector", () => $fdebb2e5052d145f$export$7937e2d32a777fcb);

var $5uXOq = parcelRequire("5uXOq");

var $3TY9o = parcelRequire("3TY9o");

var $2vSU6 = parcelRequire("2vSU6");

var $8J6rn = parcelRequire("8J6rn");

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");




var $3F9p6 = parcelRequire("3F9p6");

var $jKa0E = parcelRequire("jKa0E");

var $gyZtn = parcelRequire("gyZtn");

var $dOB7H = parcelRequire("dOB7H");

var $dEbXe = parcelRequire("dEbXe");

var $Tdcaw = parcelRequire("Tdcaw");

var $fbami = parcelRequire("fbami");

var $bCaZu = parcelRequire("bCaZu");

var $gYSoA = parcelRequire("gYSoA");

var $ieEgo = parcelRequire("ieEgo");

var $7s8Fa = parcelRequire("7s8Fa");

var $kNJsg = parcelRequire("kNJsg");

var $aWnEG = parcelRequire("aWnEG");

var $2KXa8 = parcelRequire("2KXa8");

var $hrRcW = parcelRequire("hrRcW");

var $lF3VU = parcelRequire("lF3VU");

var $bJJms = parcelRequire("bJJms");

var $6ZLHo = parcelRequire("6ZLHo");

var $7VBev = parcelRequire("7VBev");

var $YiTdm = parcelRequire("YiTdm");

var $kqEpF = parcelRequire("kqEpF");

var $1G9rm = parcelRequire("1G9rm");

var $drQWa = parcelRequire("drQWa");

var $5XLFZ = parcelRequire("5XLFZ");

var $2DtJE = parcelRequire("2DtJE");

var $cnyf1 = parcelRequire("cnyf1");

var $iXVV6 = parcelRequire("iXVV6");

var $dAfqg = parcelRequire("dAfqg");

var $c1mlA = parcelRequire("c1mlA");

var $lODMY = parcelRequire("lODMY");

var $lODMY = parcelRequire("lODMY");

var $jnN73 = parcelRequire("jnN73");
const $fdebb2e5052d145f$var$entitySettingsSidebarAnalyticsAttributes = {
    navigationLayer: (0, $ce9c0831aed9ffb3$export$33d8c916a600c5e9)
};
const $fdebb2e5052d145f$var$ProjectSettingsSidebarSelector = ()=>{
    const { data: project, loading: loading, error: error } = (0, $dAfqg.useProjectContext)();
    let sidebar = null;
    if (loading) sidebar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VBev.Skeleton), null);
    if (error) throw error;
    if (project?.projectType === (0, $2vSU6.CORE_PROJECT)) sidebar = project.simplified ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6ZLHo.default), {
        project: project
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bJJms.default), {
        project: project
    });
    if (project?.projectType === (0, $2vSU6.SOFTWARE_PROJECT)) sidebar = project.simplified ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cnyf1.default), {
        project: project
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2DtJE.default), {
        project: project
    });
    if (project?.projectType === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)) sidebar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kqEpF.default), {
        project: project
    });
    if (project?.projectType === (0, $2vSU6.CUSTOMER_SERVICE_PROJECT) && (0, $4R6GH.fg)('jcs_project_type_m3')) sidebar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5XLFZ.AsyncJcsProjectSettingsSidebar), {
        project: project
    });
    if (project?.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) || project?.projectType === (0, $2vSU6.CUSTOMER_SERVICE_PROJECT) && !(0, $4R6GH.fg)('jcs_project_type_m3')) sidebar = project.simplified ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $drQWa.AsyncJsmTmpProjectSettingsSidebar), {
        project: project
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1G9rm.AsyncJsmCmpProjectSettingsSidebar), {
        project: project
    });
    if (!sidebar) throw new Error(`No project settings sidebar found for the project type: ${project?.projectType}`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        containerId: project ? String(project.projectId) : undefined,
        containerType: "project",
        attributes: $fdebb2e5052d145f$var$entitySettingsSidebarAnalyticsAttributes
    }, sidebar);
};
const $fdebb2e5052d145f$var$ConnectAppSidebarSelector = ()=>{
    const { isActive: isProjectSettingsConnectAppActive } = (0, $YiTdm.useIsConnectAppActive)();
    return isProjectSettingsConnectAppActive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fdebb2e5052d145f$var$ProjectSettingsSidebarSelector, null) : null;
};
const $fdebb2e5052d145f$var$BoardSettingsSidebar = ()=>{
    const { data: project, loading: loading, error: error } = (0, $dAfqg.useProjectContext)();
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dEbXe.Skeleton), null);
    if (error) throw error;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        containerId: project ? String(project.projectId) : undefined,
        containerType: "project",
        attributes: $fdebb2e5052d145f$var$entitySettingsSidebarAnalyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dOB7H.default), null));
};
const $fdebb2e5052d145f$var$REDIRECT_ROUTES_NAMES = new Set([
    'browse-project-redirect',
    'servicedesk-redirect'
]);
const $fdebb2e5052d145f$var$getSidebarForRoute = (state, { configParam: configParam, shouldUseJSM: shouldUseJSM, isGlobalAppsSettingsConnectItemActive: isGlobalAppsSettingsConnectItemActive, isGlobalSystemSettingsConnectItemActive: isGlobalSystemSettingsConnectItemActive, isProjectSettingsConnectAppActive: isProjectSettingsConnectAppActive })=>{
    const sidebarId = state.route.navigation?.sidebarId;
    const pathname = state.location.pathname;
    switch(sidebarId){
        case (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lF3VU.default), null);
        case (0, $lmyls.SIDEBAR_ID).GLOBAL_APPS_SETTINGS:
            if (!pathname.includes('/discover')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fbami.default), null);
            break;
        case (0, $lmyls.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ieEgo.default), null);
        case (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bCaZu.default), null);
        case (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS:
            if (pathname.includes('/jira-service-management-chatops-and-video-tools') && shouldUseJSM) break;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gYSoA.default), null);
        case (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aWnEG.default), null);
        case (0, $lmyls.SIDEBAR_ID).PERSONAL_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hrRcW.default), null);
        case (0, $lmyls.SIDEBAR_ID).HELP_CENTER_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KXa8.default), null);
        case (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fdebb2e5052d145f$var$ProjectSettingsSidebarSelector, null);
        case (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7s8Fa.default), null);
        default:
            break;
    }
    if (state.route.name === 'polaris-ideas' && state.match.params.section === 'settings') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fdebb2e5052d145f$var$ProjectSettingsSidebarSelector, null);
    if (isProjectSettingsConnectAppActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fdebb2e5052d145f$var$ConnectAppSidebarSelector, null);
    if (state.route.group === 'classic-software' && (0, $c1mlA.BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES).has(configParam)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fdebb2e5052d145f$var$BoardSettingsSidebar, null);
    if (isGlobalAppsSettingsConnectItemActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fbami.default), null);
    if (isGlobalSystemSettingsConnectItemActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aWnEG.default), null);
};
const $fdebb2e5052d145f$export$ac727539f28734c4 = (state)=>{
    return !$fdebb2e5052d145f$var$REDIRECT_ROUTES_NAMES.has(state.route.name);
};
const $fdebb2e5052d145f$export$7ea19f35e3a0b199 = (0, $lODMY.createRouterSelector)($fdebb2e5052d145f$export$ac727539f28734c4);
const $fdebb2e5052d145f$export$b1253b9403840da1 = ()=>{
    const { saveCurrentRoute: saveCurrentRoute } = (0, $jKa0E.useNavigateBack)();
    const { isActive: isGlobalAppsSettingsConnectItemActive } = (0, $Tdcaw.useGlobalAppsSettingsConnectItemActive)();
    const { isActive: isGlobalSystemSettingsConnectItemActive } = (0, $kNJsg.useGlobalSystemSettingsConnectItemActive)();
    const { isActive: isProjectSettingsConnectAppActive } = (0, $YiTdm.useIsConnectAppActive)();
    const { shouldUseJSM: shouldUseJSM } = (0, $8J6rn.useOgTenantInfo)();
    const isNonRedirectRoute = $fdebb2e5052d145f$export$7ea19f35e3a0b199();
    const configParam = (0, $jnN73.useMaybeConfigParam)() || '';
    const location = (0, $3TY9o.useLocation)();
    const [sidebar, setSidebar] = (0, $5uXOq.useState)($fdebb2e5052d145f$var$getSidebarForRoute((0, $lODMY.getRouterState)(), {
        configParam: configParam,
        shouldUseJSM: shouldUseJSM,
        isGlobalAppsSettingsConnectItemActive: isGlobalAppsSettingsConnectItemActive,
        isGlobalSystemSettingsConnectItemActive: isGlobalSystemSettingsConnectItemActive,
        isProjectSettingsConnectAppActive: isProjectSettingsConnectAppActive
    }));
    (0, $5uXOq.useEffect)(()=>{
        return (0, $lODMY.addRouteListener)((state)=>{
            setSidebar($fdebb2e5052d145f$var$getSidebarForRoute(state, {
                configParam: state.query.config || state.match.params.config || '',
                isGlobalAppsSettingsConnectItemActive: isGlobalAppsSettingsConnectItemActive,
                isGlobalSystemSettingsConnectItemActive: isGlobalSystemSettingsConnectItemActive,
                isProjectSettingsConnectAppActive: isProjectSettingsConnectAppActive,
                shouldUseJSM: shouldUseJSM
            }));
        });
    }, [
        isGlobalAppsSettingsConnectItemActive,
        isGlobalSystemSettingsConnectItemActive,
        isProjectSettingsConnectAppActive,
        shouldUseJSM
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!sidebar && isNonRedirectRoute) {
            const url = `${location.pathname}${location.search}${location.hash}`;
            saveCurrentRoute(url);
        }
        if (!sidebar && isProjectSettingsConnectAppActive) setSidebar(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fdebb2e5052d145f$var$ConnectAppSidebarSelector, null));
    }, [
        isNonRedirectRoute,
        isProjectSettingsConnectAppActive,
        location,
        saveCurrentRoute,
        sidebar
    ]);
    if (sidebar) return sidebar;
    // Main nav (with "Your work", Starred, Recent items etc.)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gyZtn.SidebarContent), null);
};
const $fdebb2e5052d145f$export$7937e2d32a777fcb = ()=>{
    const attributes = (0, $5uXOq.useMemo)(()=>({
            navigationLayer: (0, $ce9c0831aed9ffb3$export$17ff3f7e02c6ac22),
            navigationContainer: (0, $68cb678dc917978e$export$2ee9e5a3556c1e43),
            navState: (0, $1520d876660a71bd$export$2bd315ece9f68967),
            stage: (0, $3F9p6.getNav4Rollout)().stage
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jKa0E.NavigateBackProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fdebb2e5052d145f$export$b1253b9403840da1, null)));
};

});
parcelRegister("dOB7H", function(module, exports) {

$parcel$export(module.exports, "default", () => $358df587d3e80a76$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $dEbXe = parcelRequire("dEbXe");

const $358df587d3e80a76$var$LazySidebarContent = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("frghh")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/board/src/ui/main.tsx"
});
const $358df587d3e80a76$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.board-settings",
        packageName: "jiraNavigationAppsSidebarNav4BoardSettings",
        ufoName: "nav4.sidebar.board-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.board-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dEbXe.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($358df587d3e80a76$var$LazySidebarContent, null)));
var $358df587d3e80a76$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($358df587d3e80a76$var$AsyncSidebar);

});
parcelRegister("dEbXe", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $ff13cb96c7f2cede$export$8f31e4c4a37b8e9c);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");
const $ff13cb96c7f2cede$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $ff13cb96c7f2cede$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $ff13cb96c7f2cede$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $ff13cb96c7f2cede$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $ff13cb96c7f2cede$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $ff13cb96c7f2cede$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $ff13cb96c7f2cede$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $ff13cb96c7f2cede$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $ff13cb96c7f2cede$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $ff13cb96c7f2cede$var$menuItem
    })));
const $ff13cb96c7f2cede$var$containerStyles = (0, $8CUq3.xcss)({
    paddingBlock: 'space.200',
    paddingInline: 'space.200'
});
const $ff13cb96c7f2cede$var$backButton = (0, $8CUq3.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100'
});
const $ff13cb96c7f2cede$var$headingSkeleton = (0, $8CUq3.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100',
    flex: 1
});
const $ff13cb96c7f2cede$var$menuItem = (0, $8CUq3.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});

});


parcelRegister("Tdcaw", function(module, exports) {

$parcel$export(module.exports, "useGlobalSettingsConnectItems", () => $a54a68c44d0262b5$export$f0785b98c99d344c);
$parcel$export(module.exports, "useIsAppsSettingsConnectAppModule", () => $a54a68c44d0262b5$export$8dd86b1eb9fdf786);
$parcel$export(module.exports, "useGlobalAppsSettingsConnectItemActive", () => $a54a68c44d0262b5$export$83008eebb9fccef3);

var $5uXOq = parcelRequire("5uXOq");

var $8maDO = parcelRequire("8maDO");

var $hWBtO = parcelRequire("hWBtO");

var $efOLn = parcelRequire("efOLn");

var $bYoAQ = parcelRequire("bYoAQ");

var $hz6Yb = parcelRequire("hz6Yb");

var $3TY9o = parcelRequire("3TY9o");

var $8j0rr = parcelRequire("8j0rr");
const $a54a68c44d0262b5$var$getItems = (d)=>(0, $hWBtO.getLinks)(d, [
        'admin_plugins_menu'
    ], {
        skipFilter: true
    }).filter((v)=>![
            'upm_section',
            'jpo-ws-admin'
        ].includes(v.id)) // remove sections also statically defined
    .map((0, $efOLn.transformLink)) // Apply transformation to each link
    .filter(Boolean); // Remove falsy values
const $a54a68c44d0262b5$export$f0785b98c99d344c = ()=>{
    const { data: data, loading: loading, error: error } = (0, $bYoAQ.useNavigationGlobalResource)();
    const items = (0, $5uXOq.useMemo)(()=>data && $a54a68c44d0262b5$var$getItems(data), [
        data
    ]);
    return {
        data: items,
        loading: loading,
        error: error
    };
};
const $a54a68c44d0262b5$export$ae997bf97ec22b71 = new Set([
    'configurePage',
    'postInstallPage'
]);
const $a54a68c44d0262b5$export$8dd86b1eb9fdf786 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $hz6Yb.useConnectGeneralResource)();
    return {
        isActive: $a54a68c44d0262b5$export$ae997bf97ec22b71.has(data?.moduleType),
        loading: loading,
        error: error
    };
};
const $a54a68c44d0262b5$export$83008eebb9fccef3 = ()=>{
    const location = (0, $3TY9o.useLocation)();
    const route = (0, $8j0rr.useRoute)();
    const { data: data, loading: loading, error: error } = $a54a68c44d0262b5$export$f0785b98c99d344c();
    const { isActive: isAppsSettingsConnectAppModuleActive, loading: isAppsSettingsConnectAppModuleLoading, error: isAppsSettingsConnectAppModuleError } = $a54a68c44d0262b5$export$8dd86b1eb9fdf786();
    const isActive = (0, $5uXOq.useMemo)(()=>Boolean(route && data && (0, $8maDO.findItemAndStack)(data, route.name, location)?.selected), [
        data,
        route,
        location
    ]);
    return {
        isActive: isActive || isAppsSettingsConnectAppModuleActive,
        loading: loading || isAppsSettingsConnectAppModuleLoading,
        error: error || isAppsSettingsConnectAppModuleError
    };
};

});
parcelRegister("8maDO", function(module, exports) {

$parcel$export(module.exports, "findItemAndStack", () => $c4af9df81f308e02$export$751e2e6237002565);

var $ajpes = parcelRequire("ajpes");

var $k0iPT = parcelRequire("k0iPT");
// JSPA-1062 remove qs items that might not always be there
const $c4af9df81f308e02$var$splitRelevantQs = (s)=>s.replace('?', '').split('&').filter((v)=>v && !/^(ac\.|project|board|user|servicedesk)/.test(v));
// match query strings, but allow case where query param "s" is present in the menu item, but not the window url
const $c4af9df81f308e02$var$isSameQuery = (locationQuery, itemQuery)=>(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(locationQuery, itemQuery) || !locationQuery.some((q)=>q.startsWith('s=')) && (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(itemQuery.filter((q)=>!q.startsWith('s=')), locationQuery);
const $c4af9df81f308e02$export$751e2e6237002565 = (items, routeName, location, parentStack = [])=>{
    let found = null;
    if (!(0, $k0iPT.CONNECT_ROUTES_SET).has(routeName)) return found;
    const locationQuery = $c4af9df81f308e02$var$splitRelevantQs(location.search);
    items.some((item)=>{
        const [itemPath, itemQs = ''] = (item.url || '').split('#')[0].split('?');
        const itemQuery = $c4af9df81f308e02$var$splitRelevantQs(itemQs);
        const sameQuery = $c4af9df81f308e02$var$isSameQuery(locationQuery, itemQuery);
        if (item.section !== true && itemPath === location.pathname && sameQuery) {
            found = {
                stack: parentStack,
                selected: item
            };
            return true;
        }
        if (item.items) {
            const stack = item.section === true ? parentStack : parentStack.concat(item.id);
            found = $c4af9df81f308e02$export$751e2e6237002565(item.items, routeName, location, stack);
        }
        return Boolean(found);
    });
    return found;
};

});

parcelRegister("hWBtO", function(module, exports) {

$parcel$export(module.exports, "getLinks", () => $90a1a565c575dc5b$export$8054dcb2b42da45c);

var $9KzPc = parcelRequire("9KzPc");
const $90a1a565c575dc5b$var$findChildLinks = (arrayOfLinks, legacyId)=>arrayOfLinks && arrayOfLinks.map((item)=>{
        if (item.id === legacyId) return item.links;
        return item.links && $90a1a565c575dc5b$var$findChildLinks(item.links, legacyId);
    }).find(Boolean);
const $90a1a565c575dc5b$var$getLinksFromSidebar = (sidebarConfig, legacyId)=>{
    const links = legacyId != null ? $90a1a565c575dc5b$var$findChildLinks(sidebarConfig.product && sidebarConfig.product.links, legacyId) : sidebarConfig.product && sidebarConfig.product.links;
    return links || [];
};
const $90a1a565c575dc5b$export$8054dcb2b42da45c = (sidebarConfig, locations, { skipFilter: skipFilter, omitSections: omitSections } = {})=>{
    const acc = [];
    locations.forEach((location)=>{
        const links = $90a1a565c575dc5b$var$getLinksFromSidebar(sidebarConfig, location);
        if (omitSections === true) {
            // merge 2 arrays in good performance way
            Array.prototype.push.apply(acc, links.flatMap((item)=>item && item.section === true ? item.links || [] : item));
            return;
        }
        // merge 2 arrays in good performance way
        Array.prototype.push.apply(acc, links);
    });
    return acc.filter((item)=>{
        if (!item) return false;
        if (skipFilter === true) return true;
        const hasConnectPrefix = item.id && item.id.includes((0, $9KzPc.connectPrefix));
        if (hasConnectPrefix) return true;
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"sd-reports-addons" | "sd-queues-addons" | "com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent"'.
        const isConnectSection = (0, $9KzPc.connectSections).includes(item.id);
        if (isConnectSection) return true;
        const isJsdConnectSection = item.id && item.id.includes((0, $9KzPc.jsdConnectPrefix));
        if (isJsdConnectSection) return true;
        return false;
    });
};

});
parcelRegister("9KzPc", function(module, exports) {

$parcel$export(module.exports, "connectPrefix", () => $f13744297e4a8bc9$export$196d83ebd873fb40);
$parcel$export(module.exports, "jsdConnectPrefix", () => $f13744297e4a8bc9$export$7fac8f726f52d70);
$parcel$export(module.exports, "connectSections", () => $f13744297e4a8bc9$export$b1c2c1fc5d10280);

var $16J3A = parcelRequire("16J3A");
const $f13744297e4a8bc9$export$196d83ebd873fb40 = 'com.atlassian.plugins.atlassian-connect-plugin:';
const $f13744297e4a8bc9$export$7fac8f726f52d70 = 'com.atlassian.servicedesk.connect';
const $f13744297e4a8bc9$var$legacyAddonPanelLinkId = 'com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent';
const $f13744297e4a8bc9$var$jsdQueuesConnectSection = 'sd-queues-addons';
const $f13744297e4a8bc9$export$b1c2c1fc5d10280 = [
    $f13744297e4a8bc9$var$legacyAddonPanelLinkId,
    (0, $16J3A.REPORTS_IDS).REPORTS_ADDONS,
    $f13744297e4a8bc9$var$jsdQueuesConnectSection
];

});


parcelRegister("efOLn", function(module, exports) {

$parcel$export(module.exports, "transformLink", () => $179f73798c754e8b$export$5a32dc366b1d641f);
$parcel$export(module.exports, "transformLinkV4", () => $179f73798c754e8b$export$27267b6b6650eaa5);
const $179f73798c754e8b$export$5a32dc366b1d641f = (link)=>{
    const items = link.links && link.links.length ? link.links.map($179f73798c754e8b$export$5a32dc366b1d641f).filter(Boolean) : undefined;
    // section item
    if (link.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(link.name)
        };
        return {
            id: link.id,
            name: String(link.name),
            section: !!link.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: link.id,
        name: String(link.name),
        url: link.url,
        iconUrl: link.iconUrl || '',
        styleClass: link.styleClass || '',
        items: items
    };
};
const $179f73798c754e8b$export$27267b6b6650eaa5 = (data)=>{
    const items = data.links && data.links.length ? data.links.map($179f73798c754e8b$export$27267b6b6650eaa5).filter(Boolean) : undefined;
    // section item
    if (data.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(data.name)
        };
        return {
            id: data.id,
            name: String(data.name),
            section: !!data.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: data.id,
        name: String(data.name),
        url: data.url,
        iconUrl: data.iconUrl || '',
        styleClass: data.styleClass || '',
        items: items
    };
};

});

parcelRegister("bYoAQ", function(module, exports) {

$parcel$export(module.exports, "useNavigationGlobalResource", () => $37852a2b10dca6fc$export$1e1c317ed5b99faa);

var $atU1t = parcelRequire("atU1t");

var $2YP9W = parcelRequire("2YP9W");
const $37852a2b10dca6fc$export$1e1c317ed5b99faa = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)((0, $atU1t.navigationSidebarGlobalResource));
    return {
        data: data && data.response,
        loading: loading,
        error: error
    };
};

});


parcelRegister("fbami", function(module, exports) {

$parcel$export(module.exports, "default", () => $f82a04fb3eb62635$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $cnlm7 = parcelRequire("cnlm7");

var $i8077 = parcelRequire("i8077");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $f82a04fb3eb62635$var$LazySidebarContent = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("dUIj9")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/apps/src/ui/main.tsx"
});
const $f82a04fb3eb62635$var$AsyncSidebar = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.apps-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsAppsSettings",
        ufoName: "nav4.sidebar.global-settings.apps-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cnlm7.SidebarContent), {
        currentPageName: "apps",
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-apps.ui.sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.global-settings.apps-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8077.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f82a04fb3eb62635$var$LazySidebarContent, null))));
};
var $f82a04fb3eb62635$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($f82a04fb3eb62635$var$AsyncSidebar);

});
parcelRegister("dUIj9", function(module, exports) {

let $a212dff7c2da982b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a212dff7c2da982b$var$load("iIxxE").then(()=>parcelRequire('6JIAx'));

});


parcelRegister("bCaZu", function(module, exports) {

$parcel$export(module.exports, "default", () => $58b39e5bf0fb90a0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $cnlm7 = parcelRequire("cnlm7");

var $i8077 = parcelRequire("i8077");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $58b39e5bf0fb90a0$var$LazySidebarContent = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("bC6TQ")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/issues/src/ui/main.tsx"
});
const $58b39e5bf0fb90a0$var$AsyncSidebar = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.issues-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsIssuesSettings",
        ufoName: "nav4.sidebar.global-settings.issues-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cnlm7.SidebarContent), {
        currentPageName: "issues",
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-issues.ui.sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.global-settings.issues-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8077.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($58b39e5bf0fb90a0$var$LazySidebarContent, null))));
};
var $58b39e5bf0fb90a0$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($58b39e5bf0fb90a0$var$AsyncSidebar);

});
parcelRegister("bC6TQ", function(module, exports) {

let $87489875c64082c2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $87489875c64082c2$var$load("kPToF").then(()=>parcelRequire('fUdDx'));

});


parcelRegister("gYSoA", function(module, exports) {

$parcel$export(module.exports, "default", () => $425ce2b571ab3ef5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $cnlm7 = parcelRequire("cnlm7");

var $i8077 = parcelRequire("i8077");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $425ce2b571ab3ef5$var$LazySidebarContent = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("81R5Y")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/products/src/ui/main.tsx"
});
const $425ce2b571ab3ef5$var$AsyncSidebar = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.products-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsProductsSettings",
        ufoName: "nav4.sidebar.global-settings.products-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cnlm7.SidebarContent), {
        currentPageName: "products",
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.ui.sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.global-settings.products-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8077.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($425ce2b571ab3ef5$var$LazySidebarContent, null))));
};
var $425ce2b571ab3ef5$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($425ce2b571ab3ef5$var$AsyncSidebar);

});
parcelRegister("81R5Y", function(module, exports) {

let $5d879a60142b5b8b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5d879a60142b5b8b$var$load("e2KSr").then(()=>parcelRequire('864s3'));

});


parcelRegister("ieEgo", function(module, exports) {

$parcel$export(module.exports, "default", () => $b88bb6161ed4902f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $cnlm7 = parcelRequire("cnlm7");

var $i8077 = parcelRequire("i8077");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $b88bb6161ed4902f$var$LazySidebarContent = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("l2pKz")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/projects/src/ui/main.tsx"
});
const $b88bb6161ed4902f$var$AsyncSidebar = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.projects-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsProjectsSettings",
        ufoName: "nav4.sidebar.global-settings.projects-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cnlm7.SidebarContent), {
        currentPageName: "projects",
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-projects.ui.sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.global-settings.projects-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8077.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b88bb6161ed4902f$var$LazySidebarContent, null))));
};
var $b88bb6161ed4902f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($b88bb6161ed4902f$var$AsyncSidebar);

});
parcelRegister("l2pKz", function(module, exports) {

let $f50dc24ed578f4d1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f50dc24ed578f4d1$var$load("5Hj8w").then(()=>parcelRequire('fbdwm'));

});


parcelRegister("kNJsg", function(module, exports) {

$parcel$export(module.exports, "useGlobalSystemSettingsConnectItems", () => $90305fd4b8d90c67$export$68950d4e14439158);
$parcel$export(module.exports, "useGlobalSystemSettingsConnectItemActive", () => $90305fd4b8d90c67$export$5efb701a2106707a);

var $5uXOq = parcelRequire("5uXOq");

var $8maDO = parcelRequire("8maDO");

var $hWBtO = parcelRequire("hWBtO");

var $efOLn = parcelRequire("efOLn");

var $fgeiD = parcelRequire("fgeiD");

var $bYoAQ = parcelRequire("bYoAQ");

var $hz6Yb = parcelRequire("hz6Yb");

var $3TY9o = parcelRequire("3TY9o");

var $8j0rr = parcelRequire("8j0rr");
const $90305fd4b8d90c67$var$getItems = (d)=>(0, $hWBtO.getLinks)(d, [
        'admin_system_menu'
    ], {
        skipFilter: true
    }).map((0, $efOLn.transformLink)) // Apply transformation to each link
    .filter(Boolean); // Remove falsy values
const $90305fd4b8d90c67$export$68950d4e14439158 = (0, $fgeiD.withThrowOnError)(()=>{
    const { data: data, loading: loading, error: error } = (0, $bYoAQ.useNavigationGlobalResource)();
    const items = (0, $5uXOq.useMemo)(()=>data && $90305fd4b8d90c67$var$getItems(data), [
        data
    ]);
    return {
        data: items,
        loading: loading,
        error: error
    };
});
const $90305fd4b8d90c67$export$5efb701a2106707a = ()=>{
    const location = (0, $3TY9o.useLocation)();
    const route = (0, $8j0rr.useRoute)();
    const { data: data, loading: loading, error: error } = $90305fd4b8d90c67$export$68950d4e14439158();
    const { data: connectGeneralData, loading: connectGeneralResourceLoading, error: connectGeneralResourceError } = (0, $hz6Yb.useConnectGeneralResource)();
    const isActive = (0, $5uXOq.useMemo)(()=>Boolean(route && data && (0, $8maDO.findItemAndStack)(data, route.name, location)?.selected), [
        data,
        route,
        location
    ]);
    return {
        isActive: isActive || connectGeneralData?.moduleType === 'adminPages',
        loading: loading || connectGeneralResourceLoading,
        error: error || connectGeneralResourceError
    };
};

});
parcelRegister("fgeiD", function(module, exports) {

$parcel$export(module.exports, "withThrowOnError", () => $f9ce174aaa2e063b$export$a018832f2ec4dc91);
/* eslint-disable jira/react-magnetic-di/no-unneeded */ 
var $gKZoD = parcelRequire("gKZoD");
const $f9ce174aaa2e063b$var$isDataEmpty = (data)=>data == null;
function $f9ce174aaa2e063b$export$a018832f2ec4dc91(theHook) {
    return (...args)=>{
        // tests like src/packages/navigation-apps/horizontal-nav/tabs/board-scoped-tab/src/test.tsx do not work without this line
        (0, $gKZoD.di)(theHook);
        const result = theHook(...args);
        // escalate .error if condition is met (by throwing a runtime exception from it; to be caught and logged by the nearest ErrorBoundary for example).
        if (!false && $f9ce174aaa2e063b$var$isDataEmpty(result.data) && !result.loading && result.error) throw result.error;
        return result;
    };
}

});


parcelRegister("aWnEG", function(module, exports) {

$parcel$export(module.exports, "default", () => $59776b430a24875d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $cnlm7 = parcelRequire("cnlm7");

var $i8077 = parcelRequire("i8077");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $59776b430a24875d$var$LazySidebarContent = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("6K6Rz")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/system/src/ui/main.tsx"
});
const $59776b430a24875d$var$AsyncSidebar = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.system-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsSystemSettings",
        ufoName: "nav4.sidebar.global-settings.system-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cnlm7.SidebarContent), {
        currentPageName: "system",
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-system.ui.sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.global-settings.system-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8077.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59776b430a24875d$var$LazySidebarContent, null))));
};
var $59776b430a24875d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($59776b430a24875d$var$AsyncSidebar);

});
parcelRegister("6K6Rz", function(module, exports) {

let $4e8c5cd072284142$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4e8c5cd072284142$var$load("9fPii").then(()=>parcelRequire('rQUQs'));

});


parcelRegister("2KXa8", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5d93ac4546abf11$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $aUxXz = parcelRequire("aUxXz");

const $b5d93ac4546abf11$var$LazySidebarContent = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("9MMzb")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/help-center/src/ui/main.tsx"
});
const $b5d93ac4546abf11$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.help-center-settings",
        packageName: "jiraNavigationAppsSidebarNav4HelpCenterSettings",
        ufoName: "nav4.sidebar.help-center-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.help-center-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aUxXz.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b5d93ac4546abf11$var$LazySidebarContent, null)));
var $b5d93ac4546abf11$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($b5d93ac4546abf11$var$AsyncSidebar);

});
parcelRegister("aUxXz", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $c42d7c14b1508227$export$8f31e4c4a37b8e9c);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");
const $c42d7c14b1508227$var$ItemSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c42d7c14b1508227$var$iconSkeleton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c42d7c14b1508227$var$itemSkeleton
    }));
const $c42d7c14b1508227$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.300",
        xcss: $c42d7c14b1508227$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c42d7c14b1508227$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c42d7c14b1508227$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c42d7c14b1508227$var$iconSkeleton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c42d7c14b1508227$var$titleSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c42d7c14b1508227$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c42d7c14b1508227$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c42d7c14b1508227$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c42d7c14b1508227$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c42d7c14b1508227$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c42d7c14b1508227$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c42d7c14b1508227$var$ItemSkeleton, null)));
const $c42d7c14b1508227$var$containerStyles = (0, $8CUq3.xcss)({
    paddingBlock: 'space.200',
    paddingInline: 'space.200'
});
const $c42d7c14b1508227$var$backButton = (0, $8CUq3.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-200, 16px)",
    height: "var(--ds-space-200, 16px)",
    borderRadius: 'border.radius.100'
});
const $c42d7c14b1508227$var$iconSkeleton = (0, $8CUq3.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100'
});
const $c42d7c14b1508227$var$titleSkeleton = (0, $8CUq3.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-300, 24px)",
    width: '50%',
    borderRadius: 'border.radius.100'
});
const $c42d7c14b1508227$var$headingSkeleton = (0, $8CUq3.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-200, 16px)",
    width: "var(--ds-space-1000, 80px)",
    borderRadius: 'border.radius.100'
});
const $c42d7c14b1508227$var$itemSkeleton = (0, $8CUq3.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-200, 16px)",
    borderRadius: 'border.radius.100',
    flex: 1
});

});

parcelRegister("9MMzb", function(module, exports) {

let $71fe45070e4b8059$var$load = (parcelRequire("28QjX"))(4);
module.exports = $71fe45070e4b8059$var$load("aUU4w").then(()=>parcelRequire('22iKv'));

});


parcelRegister("hrRcW", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e7cdaae12475462$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $jUfLV = parcelRequire("jUfLV");

const $8e7cdaae12475462$var$LazySidebarContent = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("jvFqq")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/personal/src/ui/main.tsx"
});
const $8e7cdaae12475462$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.personal-settings",
        packageName: "jiraNavigationAppsSidebarNav4PersonalSettings",
        ufoName: "nav4.sidebar.personal-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.personal-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jUfLV.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8e7cdaae12475462$var$LazySidebarContent, null)));
var $8e7cdaae12475462$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($8e7cdaae12475462$var$AsyncSidebar);

});
parcelRegister("jUfLV", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $1cdf070fb698d8d2$export$8f31e4c4a37b8e9c);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");
const $1cdf070fb698d8d2$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1cdf070fb698d8d2$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1cdf070fb698d8d2$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1cdf070fb698d8d2$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1cdf070fb698d8d2$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1cdf070fb698d8d2$var$menuItem
    })));
const $1cdf070fb698d8d2$var$containerStyles = (0, $8CUq3.xcss)({
    paddingBlock: 'space.200',
    paddingInline: 'space.200'
});
const $1cdf070fb698d8d2$var$backButton = (0, $8CUq3.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100'
});
const $1cdf070fb698d8d2$var$headingSkeleton = (0, $8CUq3.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100',
    flex: 1
});
const $1cdf070fb698d8d2$var$menuItem = (0, $8CUq3.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});

});

parcelRegister("jvFqq", function(module, exports) {

let $e3410bbd551cd22d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e3410bbd551cd22d$var$load("kM9x8").then(()=>parcelRequire('hox2O'));

});


parcelRegister("lF3VU", function(module, exports) {

$parcel$export(module.exports, "default", () => $442721cda4044790$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $bhcrK = parcelRequire("bhcrK");

const $442721cda4044790$var$LazyPlanSettingsSidebar = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("iyl3s")).then(({ PlanSettingsSidebar: PlanSettingsSidebar })=>PlanSettingsSidebar), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/plan/src/ui/main.tsx"
});
const $442721cda4044790$var$AsyncSidebar = ({ store: store })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "asyncSidebarPlanSettings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bhcrK.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($442721cda4044790$var$LazyPlanSettingsSidebar, {
        store: store
    }));
var $442721cda4044790$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($442721cda4044790$var$AsyncSidebar);

});
parcelRegister("bhcrK", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $d204c752b5086975$export$8f31e4c4a37b8e9c);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");
const $d204c752b5086975$export$8f31e4c4a37b8e9c = ()=>{
    return (0, $6s1PB.expValEquals)('m1_features_page_experiment', 'cohort', 'variation') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        padding: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d204c752b5086975$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d204c752b5086975$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d204c752b5086975$var$titleSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d204c752b5086975$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d204c752b5086975$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d204c752b5086975$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d204c752b5086975$var$menuItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d204c752b5086975$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d204c752b5086975$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d204c752b5086975$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d204c752b5086975$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d204c752b5086975$var$menuItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d204c752b5086975$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d204c752b5086975$var$menuItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d204c752b5086975$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d204c752b5086975$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d204c752b5086975$var$menuItem
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d204c752b5086975$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d204c752b5086975$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d204c752b5086975$var$titleSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d204c752b5086975$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d204c752b5086975$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d204c752b5086975$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d204c752b5086975$var$menuItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d204c752b5086975$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d204c752b5086975$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d204c752b5086975$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d204c752b5086975$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d204c752b5086975$var$menuItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d204c752b5086975$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d204c752b5086975$var$menuItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d204c752b5086975$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d204c752b5086975$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d204c752b5086975$var$menuItem
    })));
};
const $d204c752b5086975$var$titleSkeleton = (0, $8CUq3.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-800, 64px)",
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});
const $d204c752b5086975$var$backButton = (0, $8CUq3.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-400, 32px)",
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});
const $d204c752b5086975$var$headingSkeleton = (0, $8CUq3.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100',
    flex: 1
});
const $d204c752b5086975$var$menuItem = (0, $8CUq3.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100'
});
const $d204c752b5086975$var$subtitleItem = (0, $8CUq3.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-200, 16px)",
    width: "var(--ds-space-1000, 80px)",
    borderRadius: 'border.radius.100'
});

});

parcelRegister("iyl3s", function(module, exports) {

let $d81bbc008071270a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d81bbc008071270a$var$load("3VZ1q").then(()=>parcelRequire('7UsxD'));

});


parcelRegister("bJJms", function(module, exports) {

$parcel$export(module.exports, "default", () => $cce9becc602ac5ad$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $7VBev = parcelRequire("7VBev");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $cce9becc602ac5ad$var$LazySidebarContent = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("1G7Us")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/business/company-managed/src/ui/main.tsx"
});
const $cce9becc602ac5ad$var$AsyncSidebar = ({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.project-settings.business.company-managed",
        packageName: "jiraNavigationAppsSidebarNav4BusinessCompanyManagedProjectSettings",
        ufoName: "nav4.sidebar.project-settings.business.company-managed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.project-settings.business.company-managed",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VBev.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cce9becc602ac5ad$var$LazySidebarContent, {
        project: project
    })));
var $cce9becc602ac5ad$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($cce9becc602ac5ad$var$AsyncSidebar);

});
parcelRegister("1G7Us", function(module, exports) {

let $138fd95b65cdba43$var$load = (parcelRequire("28QjX"))(4);
module.exports = $138fd95b65cdba43$var$load("8RJxx").then(()=>parcelRequire('kaECc'));

});


parcelRegister("6ZLHo", function(module, exports) {

$parcel$export(module.exports, "default", () => $b222bb97daacff3e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $7VBev = parcelRequire("7VBev");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $b222bb97daacff3e$var$LazySidebarContent = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("2uHZc")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/business/team-managed/src/ui/main.tsx"
});
const $b222bb97daacff3e$var$AsyncSidebar = ({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.project-settings.business.team-managed",
        packageName: "jiraNavigationAppsSidebarNav4BusinessTeamManagedProjectSettings",
        ufoName: "nav4.sidebar.project-settings.business.team-managed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.project-settings.business.team-managed",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VBev.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b222bb97daacff3e$var$LazySidebarContent, {
        project: project
    })));
var $b222bb97daacff3e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($b222bb97daacff3e$var$AsyncSidebar);

});
parcelRegister("2uHZc", function(module, exports) {

let $1d1080d9adf2d322$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1d1080d9adf2d322$var$load("jtSGU").then(()=>parcelRequire('v17He'));

});


parcelRegister("YiTdm", function(module, exports) {

$parcel$export(module.exports, "useIsConnectAppActive", () => $c92d349d32b0fe9a$export$249b2e8512031cae);

var $5uXOq = parcelRequire("5uXOq");

var $8maDO = parcelRequire("8maDO");

var $3TY9o = parcelRequire("3TY9o");

var $8j0rr = parcelRequire("8j0rr");

var $eNZur = parcelRequire("eNZur");
const $c92d349d32b0fe9a$export$249b2e8512031cae = ()=>{
    const location = (0, $3TY9o.useLocation)();
    const route = (0, $8j0rr.useRoute)();
    const { data: connectApps, error: error, loading: loading } = (0, $eNZur.useConnectApps)();
    const isActive = (0, $5uXOq.useMemo)(()=>Boolean((0, $8maDO.findItemAndStack)(connectApps, route.name, location)?.selected), [
        connectApps,
        location,
        route.name
    ]);
    return {
        isActive: isActive,
        loading: loading,
        error: error
    };
};

});
parcelRegister("eNZur", function(module, exports) {

$parcel$export(module.exports, "useConnectApps", () => $5ce3bcf534d9d0ea$export$4864478dcab77643);

var $5uXOq = parcelRequire("5uXOq");

var $loy04 = parcelRequire("loy04");

var $efOLn = parcelRequire("efOLn");

var $9MFH3 = parcelRequire("9MFH3");
const $5ce3bcf534d9d0ea$export$4864478dcab77643 = ()=>{
    const { data: connectResourceItems, error: error, loading: loading } = (0, $loy04.useProjectSettingsSidebarConnectAddonsNavigationResource)();
    const connectApps = (0, $5uXOq.useMemo)(()=>{
        if (connectResourceItems == null) return [];
        const transformedConnectApps = [];
        for (const item of connectResourceItems){
            const transformedItem = (0, $efOLn.transformLinkV4)(item);
            if (transformedItem && !(0, $9MFH3.LEGACY_CONNECT_ITEM_IDS).has(transformedItem.id)) transformedConnectApps.push(transformedItem);
        }
        return transformedConnectApps;
    }, [
        connectResourceItems
    ]);
    return {
        data: connectApps,
        loading: loading,
        error: error
    };
};

});
parcelRegister("9MFH3", function(module, exports) {

$parcel$export(module.exports, "LEGACY_CONNECT_ITEM_IDS", () => $b25e3cd9691dd3ed$export$911a3d81a5d162b6);
// This is a list of known legacy connect item IDs that is used to filter out unecessary connect items
// from being rendered in the connect sections
const $b25e3cd9691dd3ed$export$911a3d81a5d162b6 = new Set([
    // Global Settings Static Legacy IDs
    'general_configuration',
    'dark_features',
    'troubleshooting_and_support',
    'view_auditing',
    'pluginViewer',
    'pluginViewer',
    'system_info',
    'integrity_checker',
    'logging_profiling',
    'scheduler_details',
    'security_section',
    'project_role_browser',
    'global_permissions',
    'collectors',
    'user_interface',
    'user_defaults',
    'edit_default_dashboard',
    'lookandfeel',
    'com.atlassian.pas:pas-admin-link-jira',
    'import_export_section',
    'vertigo_export',
    'external_import',
    'vertigo_import',
    'vertigo_import_jira_cloud',
    'vertigo_import_jira_server',
    'mail_section',
    'global_mail_settings',
    'outgoing_mail',
    'incoming_mail',
    'send_email',
    'admin-helper-admin-section',
    'permissionhelper-admin-page',
    'notificationhelper-admin-page',
    'shared_section',
    'shared_filters',
    'shared_dashboards',
    'advanced_section',
    'attachments',
    'eventtypes',
    'webhooks-admin',
    'services',
    'manage_dashboards',
    'manage_filters',
    'greenhopper-lexorank-manage',
    // Project Settings Static Legacy IDs
    'jira.webfragments.view.project.operations:edit_project',
    'com.atlassian.jira.jira-project-config-plugin:users-and-roles',
    'com.atlassian.jira.jira-project-config-plugin:view_project_summary',
    'com.atlassian.jira.jira-project-config-plugin:view_delete_project',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuetypes',
    'com.atlassian.jira.jira-project-config-plugin:view_project_workflows',
    'com.atlassian.jira.jira-project-config-plugin:view_project_screens',
    'com.atlassian.jira.jira-project-config-plugin:view_project_fields',
    'com.atlassian.jira.jira-projects-plugin:administer_project_versions',
    'com.atlassian.jira.jira-projects-plugin:administer_project_components',
    'com.atlassian.jira.jira-project-config-plugin:view_project_permissions',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuesecurity',
    'com.atlassian.jira.jira-project-config-plugin:view_project_notifications',
    'com.atlassian.jira.jira-project-config-plugin:project-opsgenie-association',
    'com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:view_issue_collectors',
    'com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-admin-page-link',
    'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation__cb-automation-project-config',
    'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation.moderate__cb-automation-project-config',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuelayout',
    'com.atlassian.jira.jira-projects-plugin:administer_project_code',
    'com.atlassian.jira.jira-projects-plugin:administer_project_deployments',
    'com.atlassian.servicedesk.project-ui:sd-project-change-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-request-types-item',
    'com.atlassian.servicedesk.project-ui:sd-project-customer-permissions-item',
    'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-project-language-support-settings-item-adg3',
    'com.atlassian.servicedesk.project-ui:sd-project-portal-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-email-settings-item',
    'com.atlassian.servicedesk.servicedesk-notifications-plugin:sd-project-outgoing-email-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-widget-addon-installer-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded__settings',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded-dev__settings',
    'com.atlassian.servicedesk.project-ui:sd-project-assets-ad-item',
    'com.atlassian.servicedesk.project-ui:sd-project-feedback-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-confluence-kb-item',
    'com.atlassian.servicedesk.project-ui:sd-project-sla-item',
    'com.atlassian.servicedesk.project-ui:sd-project-automation-item',
    'com.atlassian.servicedesk.project-ui:sd-project-app-discovery-item',
    'com.atlassian.servicedesk.project-ui:sd-project-incident-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-itsm-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-external-links-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.atlas.jira__goals-project-page',
    // Automation connect item
    'com.codebarrel.addons.automation__cb-automation',
    'com.codebarrel.addons.automation.moderate__cb-automation'
]);

});



parcelRegister("kqEpF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2c80e831fc4dee6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $7VBev = parcelRequire("7VBev");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $c2c80e831fc4dee6$var$LazySidebarContent = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("cvNVp")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/product-discovery/src/ui/main.tsx"
});
const $c2c80e831fc4dee6$var$AsyncSidebar = ({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.project-settings.jpd-settings",
        packageName: "jiraNavigationAppsSidebarNav4ProjectSettingsJpdSettings",
        ufoName: "nav4.sidebar.project-settings.jpd-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.project-settings.jpd-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VBev.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c2c80e831fc4dee6$var$LazySidebarContent, {
        project: project
    })));
var $c2c80e831fc4dee6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($c2c80e831fc4dee6$var$AsyncSidebar);

});
parcelRegister("cvNVp", function(module, exports) {

let $91bf1b5938cea118$var$load = (parcelRequire("28QjX"))(4);
module.exports = $91bf1b5938cea118$var$load("4AjKx").then(()=>parcelRequire('aDwWR'));

});


parcelRegister("1G9rm", function(module, exports) {

$parcel$export(module.exports, "AsyncJsmCmpProjectSettingsSidebar", () => $5b1e7bac8593a90d$export$2ce6ad449436c545);

var $5uXOq = parcelRequire("5uXOq");

var $juTur = parcelRequire("juTur");

var $cljJ9 = parcelRequire("cljJ9");

var $7VBev = parcelRequire("7VBev");

var $84dyl = parcelRequire("84dyl");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $5b1e7bac8593a90d$var$LazySidebarContent = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("9vBIE")).then(({ JSMCmpProjectSettingsSidebar: JSMCmpProjectSettingsSidebar })=>JSMCmpProjectSettingsSidebar), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/service-desk/company-managed/src/main.tsx"
});
const $5b1e7bac8593a90d$var$analyticsAttributes = {
    projectStyle: 'cmp',
    // reset '3' being sent from outside-of-nav4 Context. navState is used instead.
    // @deprecated cleanup this attribute on jira_nav4 FG / Nav3 cleanup. navState is used instead
    navVersion: undefined
};
const $5b1e7bac8593a90d$export$2ce6ad449436c545 = /*#__PURE__*/ (0, $5uXOq.memo)(({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.jsm-cmp-project-settings",
        packageName: "jiraNavigationAppsSidebarNav4JsmCmpProjectSettings",
        teamName: "jsm-getting-started",
        ufoName: "nav4.sidebar.jsm-cmp-project-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juTur.ContextualAnalyticsData), {
        menuId: (0, $84dyl.MENU_ID_JSM_SETTINGS),
        attributes: $5b1e7bac8593a90d$var$analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.jsm-cmp-project-settings.loading-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VBev.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5b1e7bac8593a90d$var$LazySidebarContent, {
        project: project
    })))));

});
parcelRegister("84dyl", function(module, exports) {

$parcel$export(module.exports, "MENU_ID_JSM_SETTINGS", () => $8fdaf51231934b8c$export$4c5fa21d31710030);
$parcel$export(module.exports, "PROJECT_SETTINGS_COMMON_ANALYTICS_ATTRIBUTES", () => $8fdaf51231934b8c$export$8092325c2fa271de);


const $8fdaf51231934b8c$export$4c5fa21d31710030 = 'project/service-desk/settings';
const $8fdaf51231934b8c$var$COMMON_ANALYTICS_ATTRIBUTES = {
    componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
    level: 1
};
const $8fdaf51231934b8c$export$8092325c2fa271de = {
    ...$8fdaf51231934b8c$var$COMMON_ANALYTICS_ATTRIBUTES,
    actionSubjectId: (0, $d59b407ab907bf7b$export$13171e509c859bbf)
};

});

parcelRegister("9vBIE", function(module, exports) {

let $6ec4448704a1ab38$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6ec4448704a1ab38$var$load("lWYcK").then(()=>parcelRequire('58Da3'));

});


parcelRegister("drQWa", function(module, exports) {

$parcel$export(module.exports, "AsyncJsmTmpProjectSettingsSidebar", () => $723c8db5701ca405$export$dadf0f8c840cb26d);

var $5uXOq = parcelRequire("5uXOq");

var $juTur = parcelRequire("juTur");

var $cljJ9 = parcelRequire("cljJ9");

var $7VBev = parcelRequire("7VBev");

var $84dyl = parcelRequire("84dyl");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $723c8db5701ca405$var$LazySidebarContent = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("apslt")).then(({ JSMTmpProjectSettingsSidebar: JSMTmpProjectSettingsSidebar })=>JSMTmpProjectSettingsSidebar), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/service-desk/team-managed/src/main.tsx"
});
const $723c8db5701ca405$var$analyticsAttributes = {
    projectStyle: 'tmp',
    // reset '3' being sent from outside-of-nav4 Context. navState is used instead.
    // @deprecated cleanup this attribute on jira_nav4 FG / Nav3 cleanup. navState is used instead
    navVersion: undefined
};
const $723c8db5701ca405$export$dadf0f8c840cb26d = /*#__PURE__*/ (0, $5uXOq.memo)(({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.jsm-tmp-project-settings",
        packageName: "jiraNavigationAppsSidebarNav4JsmTmpProjectSettings",
        teamName: "jsm-getting-started",
        ufoName: "nav4.sidebar.jsm-tmp-project-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juTur.ContextualAnalyticsData), {
        menuId: (0, $84dyl.MENU_ID_JSM_SETTINGS),
        attributes: $723c8db5701ca405$var$analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.jsm-tmp-project-settings.loading-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VBev.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($723c8db5701ca405$var$LazySidebarContent, {
        project: project
    })))));

});
parcelRegister("apslt", function(module, exports) {

let $794239ff5ece339b$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $794239ff5ece339b$var$load("ffQaD"),
    $794239ff5ece339b$var$load("kvRbA"),
    $794239ff5ece339b$var$load("cPNev")
]).then(()=>parcelRequire('dJT47'));

});


parcelRegister("5XLFZ", function(module, exports) {

$parcel$export(module.exports, "AsyncJcsProjectSettingsSidebar", () => $81b56f1e8067cd32$export$e82f1de9c94b7cd9);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $7VBev = parcelRequire("7VBev");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $81b56f1e8067cd32$var$LazySidebarContent = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("1OxT1")).then(({ JcsProjectSettingsSidebar: JcsProjectSettingsSidebar })=>JcsProjectSettingsSidebar), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/customer-service/src/main.tsx"
});
const $81b56f1e8067cd32$export$e82f1de9c94b7cd9 = /*#__PURE__*/ (0, $5uXOq.memo)(({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.jcs-project-settings",
        packageName: "jiraNavigationAppsSidebarNav4JCSProjectSettings",
        teamName: "Boysenberry",
        ufoName: "nav4.sidebar.jcs-project-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.jcs-project-settings.loading-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VBev.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($81b56f1e8067cd32$var$LazySidebarContent, {
        project: project
    }))));

});
parcelRegister("1OxT1", function(module, exports) {

let $1524bf14046c6690$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1524bf14046c6690$var$load("fEnfV").then(()=>parcelRequire('4Cs4A'));

});


parcelRegister("2DtJE", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd62495e40b7984d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $7VBev = parcelRequire("7VBev");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $fd62495e40b7984d$var$LazySidebarContent = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("7jZ4p")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/software/company-managed/src/ui/main.tsx"
});
const $fd62495e40b7984d$var$AsyncSidebar = ({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.project-settings.software.company-managed",
        packageName: "jiraNavigationAppsSidebarNav4SoftwareCompanyManagedProjectSettings",
        ufoName: "nav4.sidebar.project-settings.software.company-managed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.project-settings.software.company-managed",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VBev.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fd62495e40b7984d$var$LazySidebarContent, {
        project: project
    })));
var $fd62495e40b7984d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($fd62495e40b7984d$var$AsyncSidebar);

});
parcelRegister("7jZ4p", function(module, exports) {

let $5549ae06a3a19ca2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5549ae06a3a19ca2$var$load("9TMpK").then(()=>parcelRequire('cLlaG'));

});


parcelRegister("cnyf1", function(module, exports) {

$parcel$export(module.exports, "default", () => $713dabe47adbee45$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $7VBev = parcelRequire("7VBev");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $713dabe47adbee45$var$LazySidebarContent = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("313hm")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/software/team-managed/src/ui/main.tsx"
});
const $713dabe47adbee45$var$AsyncSidebar = ({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.project-settings.software.team-managed",
        packageName: "jiraNavigationAppsSidebarNav4SoftwareTeamManagedProjectSettings",
        ufoName: "nav4.sidebar.project-settings.software.team-managed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.project-settings.software.team-managed",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VBev.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($713dabe47adbee45$var$LazySidebarContent, {
        project: project
    })));
var $713dabe47adbee45$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($713dabe47adbee45$var$AsyncSidebar);

});
parcelRegister("313hm", function(module, exports) {

let $2324023cfe318c10$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2324023cfe318c10$var$load("4vd8Z").then(()=>parcelRequire('4yoHz'));

});


parcelRegister("jnN73", function(module, exports) {

$parcel$export(module.exports, "useConfigParam", () => $bf62a20c6a76ddbe$export$b8842df7174e4acb);
$parcel$export(module.exports, "useMaybeConfigParam", () => $bf62a20c6a76ddbe$export$2135334620af5209);

var $4R6GH = parcelRequire("4R6GH");

var $bmKPg = parcelRequire("bmKPg");
var $ieDtd = parcelRequire("ieDtd");

var $e5wyW = parcelRequire("e5wyW");

var $3HwlS = parcelRequire("3HwlS");

var $c1mlA = parcelRequire("c1mlA");
const $bf62a20c6a76ddbe$export$b8842df7174e4acb = (0, $e5wyW.functionWithCondition)(()=>((0, $4R6GH.fg)('blu-7261-change-blu-5799-to-support-nav3') || (0, $3HwlS.getWillShowNav4)()) && // Delete line when cleaning up blu-7261
    (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route'), $bf62a20c6a76ddbe$var$useConfigParamNew, $bf62a20c6a76ddbe$var$useConfigQueryOld);
function $bf62a20c6a76ddbe$var$useConfigQueryOld() {
    const [configQuery] = (0, $ieDtd.useQueryParam)('config');
    if (!configQuery) throw new Error('No config param found');
    const result = $bf62a20c6a76ddbe$var$isConfigQuery(configQuery) ? configQuery : null;
    return result;
}
function $bf62a20c6a76ddbe$var$useConfigParamNew() {
    const configParam = $bf62a20c6a76ddbe$export$2135334620af5209();
    if (!configParam) throw new Error('No config param found');
    const result = $bf62a20c6a76ddbe$var$isConfigQuery(configParam) ? configParam : null;
    return result;
}
function $bf62a20c6a76ddbe$export$2135334620af5209() {
    const [configPath] = (0, $bmKPg.usePathParam)('config');
    const [configQuery] = (0, $ieDtd.useQueryParam)('config');
    return configPath || configQuery;
}
const $bf62a20c6a76ddbe$var$isConfigQuery = (configQuery)=>(0, $c1mlA.BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES).has(configQuery);

});


parcelRegister("fwGlt", function(module, exports) {

$parcel$export(module.exports, "getNav4SidebarId", () => $2dc081c673538ce6$export$8cea2a93fc3986aa);
$parcel$export(module.exports, "useGetParamsForGetNav4SidebarId", () => $2dc081c673538ce6$export$e102a5137dc15645);

var $5uXOq = parcelRequire("5uXOq");

var $lmyls = parcelRequire("lmyls");

var $c1mlA = parcelRequire("c1mlA");

var $Tdcaw = parcelRequire("Tdcaw");

var $kNJsg = parcelRequire("kNJsg");

var $YiTdm = parcelRequire("YiTdm");

var $8J6rn = parcelRequire("8J6rn");

var $lODMY = parcelRequire("lODMY");

var $jnN73 = parcelRequire("jnN73");
function $2dc081c673538ce6$export$8cea2a93fc3986aa(params) {
    const { configParam: configParam, isProjectSettingsConnectAppActive: isProjectSettingsConnectAppActive, isGlobalAppsSettingsConnectItemActive: isGlobalAppsSettingsConnectItemActive, isGlobalSystemSettingsConnectItemActive: isGlobalSystemSettingsConnectItemActive, routerState: routerState, shouldUseJSM: shouldUseJSM } = params;
    const sidebarId = routerState.route.navigation?.sidebarId;
    const pathname = routerState.location.pathname;
    // Deal with the exceptions...
    if (sidebarId === (0, $lmyls.SIDEBAR_ID).GLOBAL_APPS_SETTINGS && !pathname.includes('/discover')) return sidebarId;
    if (sidebarId === (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS) {
        if (pathname.includes('/jira-service-management-chatops-and-video-tools') && shouldUseJSM) return (0, $lmyls.SIDEBAR_ID).CONTENT;
        return sidebarId;
    }
    // Project settings sidebars
    if (routerState.route.name === 'polaris-ideas' && routerState.match.params.section === 'settings' || isProjectSettingsConnectAppActive) return (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS;
    // Board settings sidebar
    if (routerState.route.group === 'classic-software' && (0, $c1mlA.BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES).has(configParam)) return (0, $lmyls.SIDEBAR_ID).BOARD_SETTINGS;
    if (isGlobalAppsSettingsConnectItemActive) return (0, $lmyls.SIDEBAR_ID).GLOBAL_APPS_SETTINGS;
    if (isGlobalSystemSettingsConnectItemActive) return (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS;
    return sidebarId || (0, $lmyls.SIDEBAR_ID).CONTENT;
}
function $2dc081c673538ce6$export$e102a5137dc15645(params = {}) {
    const { routerState: routerState = (0, $lODMY.getRouterState)() } = params;
    const { isActive: isGlobalAppsSettingsConnectItemActive } = (0, $Tdcaw.useGlobalAppsSettingsConnectItemActive)();
    const { isActive: isGlobalSystemSettingsConnectItemActive } = (0, $kNJsg.useGlobalSystemSettingsConnectItemActive)();
    const { isActive: isProjectSettingsConnectAppActive } = (0, $YiTdm.useIsConnectAppActive)();
    const { shouldUseJSM: shouldUseJSM } = (0, $8J6rn.useOgTenantInfo)();
    const configParam = (0, $jnN73.useMaybeConfigParam)() || '';
    const data = (0, $5uXOq.useMemo)(()=>({
            configParam: configParam,
            isGlobalAppsSettingsConnectItemActive: isGlobalAppsSettingsConnectItemActive,
            isGlobalSystemSettingsConnectItemActive: isGlobalSystemSettingsConnectItemActive,
            isProjectSettingsConnectAppActive: isProjectSettingsConnectAppActive,
            routerState: routerState,
            shouldUseJSM: shouldUseJSM
        }), [
        configParam,
        isGlobalAppsSettingsConnectItemActive,
        isGlobalSystemSettingsConnectItemActive,
        isProjectSettingsConnectAppActive,
        routerState,
        shouldUseJSM
    ]);
    return data;
}

});


parcelRegister("aImhn", function(module, exports) {

$parcel$export(module.exports, "Nav4JiraSideNavRecommendation", () => $4dca3eecced50738$export$ecec3671e31d76fc);
$parcel$export(module.exports, "JswSideNavRecommendation", () => $4dca3eecced50738$export$6bbd8731fa84c19f);
$parcel$export(module.exports, "JpdSideNavRecommendation", () => $4dca3eecced50738$export$877c99dfed6b8c0b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $5LPh0 = parcelRequire("5LPh0");

var $7CMCs = parcelRequire("7CMCs");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $4yEIl = parcelRequire("4yEIl");

var $j2nvL = parcelRequire("j2nvL");

var $jp5kW = parcelRequire("jp5kW");

var $5pSYQ = parcelRequire("5pSYQ");

var $SfWIb = parcelRequire("SfWIb");
const $4dca3eecced50738$var$PLACEMENT_ID = 'jira-side-nav';
const $4dca3eecced50738$var$SideNavPlacement = ({ onHasMessageChanged: onHasMessageChanged })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $SfWIb.default), {
        placementId: $4dca3eecced50738$var$PLACEMENT_ID,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - Type 'ComponentType<Partial<ErrorBoundaryPropsWithRender>> is not assignable to type 'PlacementComponent<LocalPlacementProps>'
        PlacementComponent: (0, $5LPh0.default),
        placementProps: {
            onHasMessageChanged: onHasMessageChanged
        }
    });
const $4dca3eecced50738$var$SideNavRecommendation = ({ onHasMessageChanged: onHasMessageChanged })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "sideNavRecommendation",
        packageName: "side-nav-recommendation",
        teamName: "post-office",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4yEIl.PostOfficeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "side-nav-recommendation.jira-side-nav"
    }, (0, $4R6GH.fg)('post_office_ssr_jira_side_nav_enabled') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j2nvL.PlacementFetchProvider), {
        resource: (0, $5pSYQ.postOfficeJiraSideNavResource)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4dca3eecced50738$var$SideNavPlacement, {
        onHasMessageChanged: onHasMessageChanged
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4dca3eecced50738$var$SideNavPlacement, {
        onHasMessageChanged: onHasMessageChanged
    }))));
};
const $4dca3eecced50738$export$ecec3671e31d76fc = /*#__PURE__*/ (0, $5uXOq.memo)(({ onHasMessageChanged: onHasMessageChanged })=>{
    if (!(0, $jp5kW.default)('killswitch_post_office_in_jira') && (0, $4R6GH.fg)('post-office-jira-side-nav-in-nav4')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4dca3eecced50738$var$SideNavRecommendation, {
        onHasMessageChanged: onHasMessageChanged
    });
    return null;
});
const $4dca3eecced50738$export$6bbd8731fa84c19f = /*#__PURE__*/ (0, $5uXOq.memo)(({ onHasMessageChanged: onHasMessageChanged })=>{
    if (// eslint-disable-next-line jira/ff/no-preconditioning
    !(0, $jp5kW.default)('killswitch_post_office_in_jira') && (0, $4R6GH.fg)('post-office_enable_jira_sidenav_rec_msr_experiment') && (0, $6s1PB.expVal)('post_office_jira_side_nav_exp_msr_vs_no_rec', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4dca3eecced50738$var$SideNavRecommendation, {
        onHasMessageChanged: onHasMessageChanged
    });
    return null;
});
const $4dca3eecced50738$export$877c99dfed6b8c0b = /*#__PURE__*/ (0, $5uXOq.memo)(({ onHasMessageChanged: onHasMessageChanged })=>{
    if (// eslint-disable-next-line jira/ff/no-preconditioning
    !(0, $jp5kW.default)('killswitch_post_office_in_jira') && (0, $4R6GH.fg)('post-office_enable_jpd_side_nav_experiment') && (0, $6s1PB.expVal)('post_office_jpd_side_nav_experiment', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4dca3eecced50738$var$SideNavRecommendation, {
        onHasMessageChanged: onHasMessageChanged
    });
    return null;
});

});
parcelRegister("5LPh0", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3580307cf0a7b9d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $hWRix = parcelRequire("hWRix");

var $iXSVm = parcelRequire("iXSVm");
var $20Ijf = parcelRequire("20Ijf");

var $5uXOq = parcelRequire("5uXOq");

var $43fxS = parcelRequire("43fxS");


var $eH8Ru = parcelRequire("eH8Ru");
const $c3580307cf0a7b9d$var$excludedMessages = new Set([
    'test-message-inapp',
    'message-template-template'
]);
const $c3580307cf0a7b9d$export$5f4d7e99d8732fe7 = (0, $eH8Ru.withJiraSideNavIntlProvider)((0, $iXSVm.createPlacementComponent)((0, $8d3aa60fe9a77226$export$a5cfae247d8360ef), ({ initialData: initialData, onHasMessageChanged: onHasMessageChanged })=>{
    const { data: data, isLoading: isLoading } = (0, $20Ijf.useInitialData)(initialData);
    const [{ message: message, status: status }, setMessageState] = (0, $5uXOq.useState)({
        message: undefined,
        status: 'loading'
    });
    const handleOnDismissed = (0, $5uXOq.useCallback)(()=>{
        setMessageState({
            message: undefined,
            status: 'done'
        });
        onHasMessageChanged?.(false);
    }, []);
    const { onMessageDismiss: onMessageDismiss, onMessageClicked: onMessageClicked, onMessageSnooze: onMessageSnooze } = (0, $hWRix.useMessagePlacementHooks)();
    (0, $5uXOq.useEffect)(()=>onMessageDismiss(handleOnDismissed), [
        onMessageDismiss,
        handleOnDismissed
    ]);
    (0, $5uXOq.useEffect)(()=>onMessageClicked(handleOnDismissed), [
        onMessageClicked,
        handleOnDismissed
    ]);
    (0, $5uXOq.useEffect)(()=>onMessageSnooze(handleOnDismissed), [
        onMessageSnooze,
        handleOnDismissed
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isLoading) {
            const newMessage = (data?.messages || []).filter((dataMessage)=>!$c3580307cf0a7b9d$var$excludedMessages.has(dataMessage.messageTemplateId))[0];
            setMessageState({
                message: newMessage,
                status: 'done'
            });
            onHasMessageChanged?.(newMessage !== undefined);
        }
    }, [
        data,
        isLoading
    ]);
    if (isLoading || status === 'loading') return null;
    return message && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $43fxS.MessageRenderer), {
        ...message,
        id: message.messageInstanceId,
        onDismissed: handleOnDismissed
    });
}, {
    choreographer: {
        isDefaultEnabled: false
    }
}));
var $c3580307cf0a7b9d$export$2e2bcd8739ae039 = $c3580307cf0a7b9d$export$5f4d7e99d8732fe7;

});
parcelRegister("43fxS", function(module, exports) {

$parcel$export(module.exports, "MessageRenderer", () => $d4dce86573ae6ccf$export$2df1250b8f917a59);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for client side use only
#
# Generate source: local/cli/src/commands/placements/generate-placement-files.ts
*/ 
var $jOeT9 = parcelRequire("jOeT9");

var $d0rCa = parcelRequire("d0rCa");

var $9Qq7C = parcelRequire("9Qq7C");

var $iBcC2 = parcelRequire("iBcC2");

var $9josU = parcelRequire("9josU");
const $d4dce86573ae6ccf$export$e30378e28ad3e6ab = {
    ...(0, $d0rCa.default),
    ...(0, $9Qq7C.default),
    ...(0, $iBcC2.default),
    ...(0, $9josU.default)
};
const { initializeMessageRenderer: $d4dce86573ae6ccf$export$bce4e5106d86e473, MessageRenderer: $d4dce86573ae6ccf$export$2df1250b8f917a59 } = (0, $jOeT9.asMessageRenderer)($d4dce86573ae6ccf$export$e30378e28ad3e6ab);

});
parcelRegister("d0rCa", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d12e6523e4651f6$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $cuWh9 = parcelRequire("cuWh9");

var $ija61 = parcelRequire("ija61");

var $a8SJ6 = parcelRequire("a8SJ6");

var $74GxC = parcelRequire("74GxC");

var $4q3sn = parcelRequire("4q3sn");
var $0d12e6523e4651f6$export$2e2bcd8739ae039 = {
    'recommendation-confluence': (0, $cuWh9.default),
    'recommendation-jpd': (0, $ija61.default),
    'recommendation-jsm': (0, $a8SJ6.default),
    'recommendation-jsw-visualize-work': (0, $74GxC.default),
    'recommendation-loom': (0, $4q3sn.default)
};

});
parcelRegister("cuWh9", function(module, exports) {

$parcel$export(module.exports, "default", () => $1056eec9670d296e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $letJZ = parcelRequire("letJZ");

var $87Vie = parcelRequire("87Vie");

var $3hGLl = parcelRequire("3hGLl");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $4cXEe = parcelRequire("4cXEe");
const $1056eec9670d296e$var$CCP_PRODUCT_ID = '6aab3f4e-cc71-474d-8d28-abef8b057808';
const $1056eec9670d296e$var$HAMS_PRODUCT_ID = 'confluence.ondemand';
const $1056eec9670d296e$var$PRODUCT_NAME = 'Confluence';
const $1056eec9670d296e$var$whyAmISeeingThisModalContent = {
    message: /*#__PURE__*/ (0, $2OMIu.jsx)("p", {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            id: "growth.recommendation-confluence.reasons-modal.message",
            defaultMessage: "We think {confluence} will improve your team's productivity. The recommendation is based on:",
            description: "Explanation of why we think the Confluence recommendation will be relevant to the customer.",
            values: {
                confluence: /*#__PURE__*/ (0, $2OMIu.jsx)("strong", {
                    children: $1056eec9670d296e$var$PRODUCT_NAME
                })
            }
        })
    }),
    reasons: (0, $87Vie.whyAmISeeingThisRecommendationMessageDefaultReason)
};
const $1056eec9670d296e$export$b3890eb0ae9dca99 = (0, $4cXEe.createRender)(({ onDismissed: onDismissed })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3hGLl.JiraSideNavFirstPartyRecommendation), {
        app: {
            hamsIdentifier: $1056eec9670d296e$var$HAMS_PRODUCT_ID,
            ccpProductId: $1056eec9670d296e$var$CCP_PRODUCT_ID,
            logo: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $letJZ.ConfluenceIcon), {
                appearance: "brand"
            }),
            header: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                id: "growth.recommendation-confluence.product-name.header",
                description: "Header for Confluence recommendation message in Jira Side Nav",
                defaultMessage: "Collaborate on pages in real-time"
            }),
            ctaMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                id: "growth.recommendation-confluence.cta.label",
                description: "CTA text for Confluence recommendation message in Jira Side Nav",
                defaultMessage: "Try Confluence"
            })
        },
        onDismissed: onDismissed,
        whyAmISeeingThisModalContent: $1056eec9670d296e$var$whyAmISeeingThisModalContent
    }));
var $1056eec9670d296e$export$2e2bcd8739ae039 = $1056eec9670d296e$export$b3890eb0ae9dca99;

});
parcelRegister("87Vie", function(module, exports) {

$parcel$export(module.exports, "whyAmISeeingThisRecommendationMessageDefaultReason", () => $a47dcd82364416ef$export$5a12ae0dd15a31ed);

var $2OMIu = parcelRequire("2OMIu");

var $ousew = parcelRequire("ousew");
const $a47dcd82364416ef$export$5a12ae0dd15a31ed = [
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        id: "post-office.ad-controls.default-reason.team-size",
        description: "the first reason for displaying the message to the customer: the size of the customer's team",
        defaultMessage: "the size of your team"
    }),
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        id: "post-office.ad-controls.default-reason.existing-products",
        description: "the second reason for displaying the message to the customer: the customer's existing Atlassian products",
        defaultMessage: "your existing Atlassian products"
    })
];

});

parcelRegister("3hGLl", function(module, exports) {

$parcel$export(module.exports, "JiraSideNavFirstPartyRecommendation", () => $7c3c355acc5999b3$export$35f6f23f7684ff6);

var $2OMIu = parcelRequire("2OMIu");

var $l1N8i = parcelRequire("l1N8i");

var $luBm6 = parcelRequire("luBm6");

var $aytRY = parcelRequire("aytRY");

var $11KUO = parcelRequire("11KUO");

var $h6VGu = parcelRequire("h6VGu");
const $7c3c355acc5999b3$var$BodyContent = ({ app: app })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                children: app.logo
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                size: "xsmall",
                children: app.header
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h6VGu.CTAButton), {
                app: app
            })
        ]
    });
};
const $7c3c355acc5999b3$export$35f6f23f7684ff6 = ({ app: app, onDismissed: onDismissed, whyAmISeeingThisModalContent: whyAmISeeingThisModalContent })=>{
    const { messageInstanceId: messageInstanceId } = (0, $11KUO.useMessageContext)();
    if (!messageInstanceId) throw new Error('messageInstanceId is required');
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aytRY.JiraSideNavMessage), {
        onDismissed: onDismissed,
        whyAmISeeingThisModalContent: whyAmISeeingThisModalContent,
        bodyContent: /*#__PURE__*/ (0, $2OMIu.jsx)($7c3c355acc5999b3$var$BodyContent, {
            app: app
        })
    });
};

});
parcelRegister("aytRY", function(module, exports) {

$parcel$export(module.exports, "JiraSideNavMessage", () => $05fef376ac33e98d$export$ee97a7edb31193a8);
/* message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $11KUO = parcelRequire("11KUO");

var $3aqJy = parcelRequire("3aqJy");
const $05fef376ac33e98d$var$jiraSideNavMessageStyle = null;
const $05fef376ac33e98d$export$ee97a7edb31193a8 = ({ onDismissed: onDismissed, whyAmISeeingThisModalContent: whyAmISeeingThisModalContent, bodyContent: bodyContent, showRemindMeLater: showRemindMeLater, showWhyAmISeeingThis: showWhyAmISeeingThis })=>{
    const { messageInstanceId: messageInstanceId } = (0, $11KUO.useMessageContext)();
    if (!messageInstanceId) throw new Error('messageInstanceId is required');
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": "jira-side-nav-message",
        className: (0, $bwpsq.default)([
            "_2rkoop52 _18zrpxbi _1rjcutpp _kqswh2mm _1e0c1txw _bfhk1hdx _otyru2gc _1pbyidpf"
        ]),
        children: [
            bodyContent,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3aqJy.Actions), {
                whyAmISeeingThisModalContent: whyAmISeeingThisModalContent,
                onDismissed: ()=>onDismissed?.(messageInstanceId),
                showRemindMeLater: showRemindMeLater,
                showWhyAmISeeingThis: showWhyAmISeeingThis
            })
        ]
    });
};

});
parcelRegister("3aqJy", function(module, exports) {

$parcel$export(module.exports, "Actions", () => $7910e0b765996eab$export$b52183d5cfb26dc9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aWKuZ = parcelRequire("aWKuZ");
const $7910e0b765996eab$var$actionsStyles = null;
const $7910e0b765996eab$export$b52183d5cfb26dc9 = ({ onDismissed: onDismissed, whyAmISeeingThisModalContent: whyAmISeeingThisModalContent, showRemindMeLater: showRemindMeLater, showWhyAmISeeingThis: showWhyAmISeeingThis })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1yt4u2gc _kqswstnw _1e0c1txw _154iidpf _1xi2idpf"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aWKuZ.AdControls), {
            iconSize: "small",
            onDismissed: onDismissed,
            showWhyAmISeeingThis: showWhyAmISeeingThis ?? true,
            whyAmISeeingThisModalContent: whyAmISeeingThisModalContent,
            showRemindMeLater: showRemindMeLater
        })
    });
};

});
parcelRegister("aWKuZ", function(module, exports) {

$parcel$export(module.exports, "AdControls", () => $8c20b26f7c81e53b$export$c25b8b7217045de9);

var $2OMIu = parcelRequire("2OMIu");

var $42CjB = parcelRequire("42CjB");

var $BLPHT = parcelRequire("BLPHT");

var $3oUqw = parcelRequire("3oUqw");

var $3bDjY = parcelRequire("3bDjY");

var $h3mjV = parcelRequire("h3mjV");

var $11KUO = parcelRequire("11KUO");

var $bMrPe = parcelRequire("bMrPe");

var $fSNBK = parcelRequire("fSNBK");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $bB0Z7 = parcelRequire("bB0Z7");

var $9Aft6 = parcelRequire("9Aft6");

var $j427r = parcelRequire("j427r");
const $8c20b26f7c81e53b$var$DropdownTrigger = ({ triggerRef: triggerRef, name: name, iconSize: iconSize = 'small', iconColor: iconColor, spacing: spacing = 'default', ...triggerProps })=>{
    const intl = (0, $koVbs.default)();
    const ariaLabel = intl.formatMessage({
        id: 'post-office.ad-controls.dropdown-menu-trigger.aria-label',
        defaultMessage: '{messageInstanceId} options menu',
        description: 'Options menu ad controls'
    }, {
        messageInstanceId: name
    });
    const tooltip = intl.formatMessage({
        id: 'post-office.ad-controls.dropdown-menu-trigger.tooltip',
        defaultMessage: 'More actions',
        description: 'Tooltip for ad-controls dropdown'
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: tooltip,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
            ...triggerProps,
            label: ariaLabel,
            appearance: "subtle",
            ref: triggerRef,
            spacing: spacing,
            icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3oUqw))), {
                    ...iconProps,
                    primaryColor: iconColor,
                    size: iconSize
                })
        })
    });
};
const $8c20b26f7c81e53b$export$c25b8b7217045de9 = ({ onDismissed: onDismissed, iconSize: iconSize, iconColor: iconColor, whyAmISeeingThisModalContent: whyAmISeeingThisModalContent, showWhyAmISeeingThis: showWhyAmISeeingThis, showRemindMeLater: showRemindMeLater, additionalAnalyticsAttributes: additionalAnalyticsAttributes = {}, zIndex: zIndex, spacing: spacing = 'default' })=>{
    const [isWhyAmISeeingThisModelOpened, setIsWhyAmISeeingThisModelOpened] = (0, $5uXOq.useState)(false);
    const { messageDismissed: messageDismissed, messageAcknowledged: messageAcknowledged } = (0, $fSNBK.useMessageEvent)();
    const { messageInstanceClicked: messageInstanceClicked } = (0, $bMrPe.useMessageInstanceEvent)();
    const { messageInstanceId: messageInstanceId } = (0, $11KUO.useMessageContext)();
    const [currIconColor, setCurrIconColor] = (0, $5uXOq.useState)(iconColor);
    if (!messageInstanceId) throw new Error('messageInstanceId is required');
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $h3mjV.useFirePostOfficeAnalyticsEvents)();
    const [showDismissedFlag, setShowDismissedFlag] = (0, $5uXOq.useState)(false);
    const { messageSnoozed: messageSnoozed } = (0, $fSNBK.useMessageEvent)();
    const handleRemindMeLater = async ()=>{
        // https://developer.atlassian.com/platform/post-office/working-with-post-office/technical-deep-dives/pre-defined-filters/#snooze-check-filter
        messageSnoozed(1); // DEPRECATED, but used alongside the messageInstanceClicked function just in case. See above page for documentation
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'remindMeLater',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'snooze',
                snoozeDuration: 1 // Snooze message for 1 day
            },
            additionalMetadataFromFrontend: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'remindMeLater'
        }, {
            ...additionalAnalyticsAttributes
        });
        setShowDismissedFlag(true);
    };
    const handleNotInterested = async ()=>{
        await messageDismissed();
        await messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'notInterested',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'notInterested'
        }, {
            ...additionalAnalyticsAttributes
        });
        if (messageInstanceId && typeof onDismissed === 'function') // integrating with useMessagePlacementHooks removes the need to pass this callback
        onDismissed(messageInstanceId);
        setShowDismissedFlag(true);
    };
    const handleWhyAmISeeingThis = async ()=>{
        setIsWhyAmISeeingThisModelOpened(true);
        await messageAcknowledged();
        await messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'adControlsReasons',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'acknowledge'
            },
            additionalMetadataFromFrontend: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'adControlsReasons'
        }, {
            ...additionalAnalyticsAttributes
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $BLPHT.default), {
                testId: "post-office-ad-controls-dropdown",
                trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, $2OMIu.jsx)($8c20b26f7c81e53b$var$DropdownTrigger, {
                        name: messageInstanceId,
                        triggerRef: triggerRef,
                        iconSize: iconSize,
                        iconColor: currIconColor,
                        spacing: spacing,
                        ...triggerProps
                    }),
                ...zIndex && {
                    zIndex: zIndex
                },
                onOpenChange: (args)=>{
                    if (args.isOpen) {
                        fireAnalyticsEvent({
                            eventType: 'ui',
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'adControlsDropdown'
                        });
                        setCurrIconColor("var(--ds-icon-selected, #0C66E4)");
                    } else setCurrIconColor(iconColor);
                },
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Aft6.AdControlsDropdown), {
                    onNotInterested: handleNotInterested,
                    onWhyAmISeeingThis: handleWhyAmISeeingThis,
                    onRemindMeLater: handleRemindMeLater,
                    showWhyAmISeeingThis: showWhyAmISeeingThis,
                    showRemindMeLater: showRemindMeLater ? true : false
                })
            }),
            showWhyAmISeeingThis && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j427r.WhyAmISeeingThisModal), {
                content: whyAmISeeingThisModalContent,
                isOpen: isWhyAmISeeingThisModelOpened,
                additionalAnalyticsAttributes: additionalAnalyticsAttributes,
                onClose: ()=>{
                    setIsWhyAmISeeingThisModelOpened(false);
                    fireAnalyticsEvent({
                        eventType: 'ui',
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'adControlsReasonsClose'
                    }, {
                        ...additionalAnalyticsAttributes
                    });
                }
            }),
            showDismissedFlag && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bB0Z7.AdControlsFlag), {
                messageInstanceId: messageInstanceId,
                onCloseFlag: ()=>setShowDismissedFlag(false)
            })
        ]
    });
};

});
parcelRegister("bB0Z7", function(module, exports) {

$parcel$export(module.exports, "AdControlsFlag", () => $3fe7d20fbbdb79db$export$6eb98925a948bca3);
/* dismissalFlag.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $fWXJB = parcelRequire("fWXJB");
var $6ARj7 = parcelRequire("6ARj7");

var $btivG = parcelRequire("btivG");

var $MHKc7 = parcelRequire("MHKc7");


var $ousew = parcelRequire("ousew");

var $h3EZb = parcelRequire("h3EZb");
const $3fe7d20fbbdb79db$var$POST_OFFICE_AD_CONTROLS_FLAG_WRAPPER = 'post-office-ad-controls-flag-wrapper';
/**-Title--**/ const $3fe7d20fbbdb79db$var$titleContainerStyles = {
    font: "_11c8140y"
};
const $3fe7d20fbbdb79db$var$Title = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $3fe7d20fbbdb79db$var$titleContainerStyles.font,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            id: "post-office.ad-controls.dismiss-flag.not-interested.title",
            defaultMessage: "Got it, thanks for letting us know",
            description: "The title for a flag which is displayed when the Not Interested button is pressed. https://hello.atlassian.net/l/cp/ssoqm2Fq"
        })
    });
/**--Description--**/ const $3fe7d20fbbdb79db$var$Description = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        id: "post-office.ad-controls.dismiss-flag.not-interested.subtitle",
        defaultMessage: "You won\u2019t see this here as often.",
        description: "The subtitle for a flag which is displayed when the Not Interested button is pressed. https://hello.atlassian.net/l/cp/ssoqm2Fq"
    });
/**--Confirm Icon--*/ const $3fe7d20fbbdb79db$var$ConfirmIcon = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($btivG))), {
        label: "Success",
        primaryColor: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$940e1f69e873f202)})`
    });
const $3fe7d20fbbdb79db$export$6eb98925a948bca3 = ({ messageInstanceId: messageInstanceId, onCloseFlag: onCloseFlag })=>{
    (0, $h3EZb.portalZIndexFix)($3fe7d20fbbdb79db$var$POST_OFFICE_AD_CONTROLS_FLAG_WRAPPER);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6ARj7.default), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            id: $3fe7d20fbbdb79db$var$POST_OFFICE_AD_CONTROLS_FLAG_WRAPPER,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fWXJB.default), {
                icon: /*#__PURE__*/ (0, $2OMIu.jsx)($3fe7d20fbbdb79db$var$ConfirmIcon, {}),
                title: /*#__PURE__*/ (0, $2OMIu.jsx)($3fe7d20fbbdb79db$var$Title, {}),
                description: /*#__PURE__*/ (0, $2OMIu.jsx)($3fe7d20fbbdb79db$var$Description, {}),
                id: messageInstanceId,
                onDismissed: ()=>onCloseFlag()
            }, messageInstanceId)
        })
    });
};

});
parcelRegister("h3EZb", function(module, exports) {

$parcel$export(module.exports, "portalZIndexFix", () => $4657f066e75cbf59$export$cef2f5415067aeab);
const $4657f066e75cbf59$var$collectionHas = (all, curr)=>{
    for(let i = 0, len = all.length; i < len; i++){
        if (all[i] === curr) return true;
    }
    return false;
};
const $4657f066e75cbf59$var$findParentBySelector = (elm, selector)=>{
    const all = globalThis.document.querySelectorAll(selector);
    let cur = elm?.parentNode;
    while(cur && !$4657f066e75cbf59$var$collectionHas(all, cur))cur = cur.parentNode;
    return cur;
};
const $4657f066e75cbf59$export$cef2f5415067aeab = (wrapperId)=>{
    // DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
    setTimeout(()=>{
        if (globalThis.document) {
            const modalContent = globalThis.document.getElementById(wrapperId);
            const portalSelector = '.atlaskit-portal';
            const parentPortal = $4657f066e75cbf59$var$findParentBySelector(modalContent, portalSelector);
            if (parentPortal) parentPortal.setAttribute('style', 'z-index:900;');
        }
    });
// DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
};

});


parcelRegister("9Aft6", function(module, exports) {

$parcel$export(module.exports, "AdControlsDropdown", () => $98ded34b8ee5d4d3$export$ba7539b3ac68f9f1);

var $2OMIu = parcelRequire("2OMIu");

var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $ousew = parcelRequire("ousew");
const $98ded34b8ee5d4d3$export$99f2c116e7ad8950 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            id: "post-office.ad-controls.dropdown-item.why-am-i-seeing-this.label",
            defaultMessage: "Why am I seeing this?",
            description: "The text for the button which opens a modal showing the reasons a message has been displayed."
        })
    });
const $98ded34b8ee5d4d3$export$80eb3e3679dfe382 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            id: "post-office.ad-controls.dropdown-item.not-interested.label",
            defaultMessage: "Not interested",
            description: "The text for the button which removes a message from a placement."
        })
    });
const $98ded34b8ee5d4d3$export$c3a3ff4a62111967 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            id: "post-office.ad-controls.dropdown-item.remind-me-later.label",
            defaultMessage: "Remind me later",
            description: "The text for the button which removes a message from a placement and makes it reappear at a later date."
        })
    });
const $98ded34b8ee5d4d3$export$ba7539b3ac68f9f1 = ({ onWhyAmISeeingThis: onWhyAmISeeingThis, onNotInterested: onNotInterested, onRemindMeLater: onRemindMeLater, showWhyAmISeeingThis: showWhyAmISeeingThis = true, showRemindMeLater: showRemindMeLater })=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $aRoVz.default), {
        children: [
            showRemindMeLater && /*#__PURE__*/ (0, $2OMIu.jsx)($98ded34b8ee5d4d3$export$c3a3ff4a62111967, {
                testId: "ad-controls-dropdown-remind-me-later",
                onClick: onRemindMeLater
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)($98ded34b8ee5d4d3$export$80eb3e3679dfe382, {
                testId: "ad-controls-dropdown-not-interested",
                onClick: onNotInterested
            }),
            showWhyAmISeeingThis && /*#__PURE__*/ (0, $2OMIu.jsx)($98ded34b8ee5d4d3$export$99f2c116e7ad8950, {
                testId: "ad-controls-dropdown-why-am-I-seeing-this",
                onClick: onWhyAmISeeingThis
            })
        ]
    });

});

parcelRegister("j427r", function(module, exports) {

$parcel$export(module.exports, "WhyAmISeeingThisModal", () => $5dfd2d7e6fcb9cd6$export$b29014abf8076d54);
/* modal.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $e4yMr = parcelRequire("e4yMr");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");
var $i8Qvm = parcelRequire("i8Qvm");

var $MHKc7 = parcelRequire("MHKc7");

var $h3mjV = parcelRequire("h3mjV");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $h3EZb = parcelRequire("h3EZb");
const $5dfd2d7e6fcb9cd6$var$WHY_AM_I_SEEING_THIS_MODAL_CONTENT = 'why-am-i-seeing-this-modal-content';
const $5dfd2d7e6fcb9cd6$export$2b77a92f1a5ad772 = ({ children: children, isOpen: isOpen, onClose: onClose })=>{
    (0, $h3EZb.portalZIndexFix)($5dfd2d7e6fcb9cd6$var$WHY_AM_I_SEEING_THIS_MODAL_CONTENT);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i8Qvm.default), {
        children: isOpen && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1R1Ge.default), {
            shouldCloseOnEscapePress: true,
            onClose: onClose,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                id: $5dfd2d7e6fcb9cd6$var$WHY_AM_I_SEEING_THIS_MODAL_CONTENT,
                children: children
            })
        })
    });
};
const $5dfd2d7e6fcb9cd6$var$AcceptButton = ({ onClick: onClick })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
        appearance: "primary",
        onClick: onClick,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            id: "post-office.ad-controls.reasons-modal.accept-button.label-ok",
            defaultMessage: "OK",
            description: "The text on the button that dismisses a modal which provides reasons a message has been displayed"
        })
    });
/*--Title--*/ const $5dfd2d7e6fcb9cd6$var$titleContainerStyles = {
    font: "_11c8lodh"
};
const $5dfd2d7e6fcb9cd6$var$Title = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $5dfd2d7e6fcb9cd6$var$titleContainerStyles.font,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            id: "post-office.ad-controls.reasons-modal.title",
            defaultMessage: "Why am I seeing this?",
            description: "The title for a modal that displays the reasons a message was displayed."
        })
    });
/*--Body--*/ const $5dfd2d7e6fcb9cd6$var$DefaultBody = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("p", {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            id: "post-office.ad-controls.reasons-modal.body",
            defaultMessage: "We think you'd find this relevant. This is based on:",
            description: "Explanation of why we think the message will be releavant to the customer."
        })
    });
const $5dfd2d7e6fcb9cd6$var$reasonsListStyles = null;
const $5dfd2d7e6fcb9cd6$var$ReasonsList = ({ reasons: reasons })=>/*#__PURE__*/ (0, $2OMIu.jsx)("ul", {
        className: (0, $bwpsq.default)([
            "_2mzu1wth _19bvv47k _19pkutpp"
        ]),
        children: reasons.map((reason, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)("li", {
                children: reason
            }, index))
    });
const $5dfd2d7e6fcb9cd6$var$privacyPolicyLinkWrapperStyles = null;
const $5dfd2d7e6fcb9cd6$export$fdd773f48aebb8ab = ({ onClick: onClick })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_19pkutpp"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e4yMr.default), {
            href: 'https://www.atlassian.com/legal/privacy-policy',
            target: "_blank",
            onClick: onClick,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                id: "post-office.ad-controls.reasons-modal.privacy-policy-link.text",
                defaultMessage: "Learn more about your data privacy with Atlassian",
                description: "The text linking to Atlassian's privacy policy. https://hello.atlassian.net/l/cp/ssoqm2Fq"
            })
        })
    });
const $5dfd2d7e6fcb9cd6$var$ReasonsModalDefaultBody = ({ onClose: onClose, content: content, additionalAnalyticsAttributes: additionalAnalyticsAttributes })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $h3mjV.useFirePostOfficeAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        fireAnalyticsEvent({
            eventType: 'screen',
            name: 'adControlsReasonsModal'
        }, {
            ...additionalAnalyticsAttributes
        });
    }, [
        fireAnalyticsEvent,
        additionalAnalyticsAttributes
    ]);
    const handleOnPrivacyPolicy = ()=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'adControlsPrivacyPolicy'
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jgVsb.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gofOI.default), {
                    children: content?.title || /*#__PURE__*/ (0, $2OMIu.jsx)($5dfd2d7e6fcb9cd6$var$Title, {})
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7QSqG.default), {
                children: content?.body || /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                    children: [
                        content?.message || /*#__PURE__*/ (0, $2OMIu.jsx)($5dfd2d7e6fcb9cd6$var$DefaultBody, {}),
                        content?.reasons && /*#__PURE__*/ (0, $2OMIu.jsx)($5dfd2d7e6fcb9cd6$var$ReasonsList, {
                            reasons: content.reasons
                        }),
                        content?.privacyPolicy || /*#__PURE__*/ (0, $2OMIu.jsx)($5dfd2d7e6fcb9cd6$export$fdd773f48aebb8ab, {
                            onClick: ()=>handleOnPrivacyPolicy()
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $juxqI.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($5dfd2d7e6fcb9cd6$var$AcceptButton, {
                    onClick: onClose
                })
            })
        ]
    });
};
const $5dfd2d7e6fcb9cd6$export$b29014abf8076d54 = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($5dfd2d7e6fcb9cd6$export$2b77a92f1a5ad772, {
        isOpen: props.isOpen,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($5dfd2d7e6fcb9cd6$var$ReasonsModalDefaultBody, {
            ...props
        })
    });
};

});




parcelRegister("h6VGu", function(module, exports) {

$parcel$export(module.exports, "CTAButton", () => $9801453d83801c9a$export$bd36621ef7814117);

var $2OMIu = parcelRequire("2OMIu");

var $8CUq3 = parcelRequire("8CUq3");

var $ftXMN = parcelRequire("ftXMN");
const $9801453d83801c9a$var$JOURNEY = 'get-started';
const $9801453d83801c9a$var$SOURCE_COMPONENT = 'jira-side-nav';
const $9801453d83801c9a$var$SOURCE_CONTEXT = 'tryItNow';
const $9801453d83801c9a$var$ctaButtonStyles = (0, $8CUq3.xcss)({
    color: 'color.link',
    backgroundColor: 'color.background.accent.blue.subtlest',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'start',
    paddingLeft: '0'
});
const $9801453d83801c9a$export$bd36621ef7814117 = ({ app: app })=>{
    const crossflowOptions = {
        targetProduct: app.hamsIdentifier,
        journey: $9801453d83801c9a$var$JOURNEY,
        sourceComponent: $9801453d83801c9a$var$SOURCE_COMPONENT,
        sourceContext: $9801453d83801c9a$var$SOURCE_CONTEXT
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ftXMN.CrossflowCtaPrimaryPressable), {
        crossflowOptions: crossflowOptions,
        ctaText: app.ctaMessage,
        pressableStyle: $9801453d83801c9a$var$ctaButtonStyles
    });
};

});
parcelRegister("ftXMN", function(module, exports) {

$parcel$export(module.exports, "CrossflowCtaPrimaryLinkButton", () => $18d745c34dd7b12a$export$55d6f395fee83ac9);
$parcel$export(module.exports, "CrossflowCtaPrimaryPressable", () => $18d745c34dd7b12a$export$585a4ef79f2a8b77);
$parcel$export(module.exports, "CrossflowCtaSecondaryPressable", () => $18d745c34dd7b12a$export$ba0dce35a480e0b4);

var $2OMIu = parcelRequire("2OMIu");

var $eCeGD = parcelRequire("eCeGD");

var $5ILhZ = parcelRequire("5ILhZ");

var $huqJ3 = parcelRequire("huqJ3");
const $18d745c34dd7b12a$var$PRIMARY_LINK_CLICKED_ELEMENT = {
    clickIdentifier: 'cta',
    clickedElement: 'button',
    buttonType: 'primary'
};
const $18d745c34dd7b12a$export$55d6f395fee83ac9 = ({ crossflowOptions: crossflowOptions, ctaText: ctaText, appearance: appearance, alt: alt })=>{
    const { handleClick: handleClick } = (0, $huqJ3.useCrossflowMessageClicked)(crossflowOptions, $18d745c34dd7b12a$var$PRIMARY_LINK_CLICKED_ELEMENT);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
        onClick: handleClick,
        appearance: appearance,
        "aria-label": alt,
        children: ctaText
    });
};
const $18d745c34dd7b12a$var$PRIMARY_BUTTON_CLICKED_ELEMENT = {
    clickIdentifier: 'cta',
    clickedElement: 'button',
    buttonType: 'primary'
};
const $18d745c34dd7b12a$export$585a4ef79f2a8b77 = ({ crossflowOptions: crossflowOptions, ctaText: ctaText, pressableStyle: pressableStyle, alt: alt })=>{
    const { handleClick: handleClick } = (0, $huqJ3.useCrossflowMessageClicked)(crossflowOptions, $18d745c34dd7b12a$var$PRIMARY_BUTTON_CLICKED_ELEMENT);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5ILhZ.default), {
        onClick: handleClick,
        xcss: pressableStyle,
        "aria-label": alt,
        children: ctaText
    });
};
const $18d745c34dd7b12a$var$SECONDARY_BUTTON_CLICKED_ELEMENT = {
    clickIdentifier: 'cta',
    clickedElement: 'button',
    buttonType: 'secondary'
};
const $18d745c34dd7b12a$export$ba0dce35a480e0b4 = ({ crossflowOptions: crossflowOptions, ctaText: ctaText, pressableStyle: pressableStyle, alt: alt })=>{
    const { handleClick: handleClick } = (0, $huqJ3.useCrossflowMessageClicked)(crossflowOptions, $18d745c34dd7b12a$var$SECONDARY_BUTTON_CLICKED_ELEMENT);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5ILhZ.default), {
        onClick: handleClick,
        xcss: pressableStyle,
        "aria-label": alt,
        children: ctaText
    });
};

});
parcelRegister("huqJ3", function(module, exports) {

$parcel$export(module.exports, "useCrossflowMessageClicked", () => $bb2aa7a6f87a3902$export$1c3f82bc53516a2a);

var $bHpB9 = parcelRequire("bHpB9");

var $bMrPe = parcelRequire("bMrPe");

var $fSNBK = parcelRequire("fSNBK");

var $5uXOq = parcelRequire("5uXOq");
const $bb2aa7a6f87a3902$export$1c3f82bc53516a2a = (crossflowOptions, clickedElement)=>{
    const crossflow = (0, $bHpB9.useCrossFlow)();
    const { messageClicked: messageClicked } = (0, $fSNBK.useMessageEvent)();
    const { messageInstanceClicked: messageInstanceClicked } = (0, $bMrPe.useMessageInstanceEvent)();
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        messageClicked().catch(()=>{});
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: clickedElement,
            action: {
                actionType: 'acknowledge'
            },
            additionalMetadataFromFrontend: {}
        }).catch(()=>{});
        if (crossflow.isEnabled) crossflow.api.open(crossflowOptions).catch(()=>{});
    }, [
        crossflow,
        crossflowOptions,
        clickedElement,
        messageClicked,
        messageInstanceClicked
    ]);
    return {
        handleClick: handleClick
    };
};

});




parcelRegister("4cXEe", function(module, exports) {

$parcel$export(module.exports, "createRender", () => $ffef8ec72db513d9$export$78c758434c34d601);

var $favav = parcelRequire("favav");
const { createRender: $ffef8ec72db513d9$export$78c758434c34d601, createValidate: $ffef8ec72db513d9$export$2859a83e4d6da57d } = (0, $favav.createClientPipeline)();
const { createHydrate: $ffef8ec72db513d9$export$c905bc718befd59b, createHydrateExample: $ffef8ec72db513d9$export$1f41223e5b0a6622, createTransformMetadata: $ffef8ec72db513d9$export$88fe13b4d13f8423 } = (0, $favav.createServerPipeline)();

});


parcelRegister("ija61", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcf11cc3adcd0c5a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $letJZ = parcelRequire("letJZ");

var $87Vie = parcelRequire("87Vie");

var $3hGLl = parcelRequire("3hGLl");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $f3z2E = parcelRequire("f3z2E");
const $fcf11cc3adcd0c5a$var$CCP_PRODUCT_ID = 'a6f908c8-709c-45f4-9e2d-eca25b93b94a';
const $fcf11cc3adcd0c5a$var$HAMS_PRODUCT_ID = 'jira-product-discovery';
const $fcf11cc3adcd0c5a$var$PRODUCT_NAME = 'Jira Product Discovery';
const $fcf11cc3adcd0c5a$var$whyAmISeeingThisModalContent = {
    message: /*#__PURE__*/ (0, $2OMIu.jsx)("p", {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            id: "growth.recommendation-jpd.reasons-modal.message",
            defaultMessage: "We think {jpd} will improve your team's productivity. The recommendation is based on:",
            description: "Explanation of why we think the JPD recommendation will be relevant to the customer.",
            values: {
                jpd: /*#__PURE__*/ (0, $2OMIu.jsx)("strong", {
                    children: $fcf11cc3adcd0c5a$var$PRODUCT_NAME
                })
            }
        })
    }),
    reasons: (0, $87Vie.whyAmISeeingThisRecommendationMessageDefaultReason)
};
const $fcf11cc3adcd0c5a$export$b3890eb0ae9dca99 = (0, $f3z2E.createRender)(({ onDismissed: onDismissed })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3hGLl.JiraSideNavFirstPartyRecommendation), {
        app: {
            hamsIdentifier: $fcf11cc3adcd0c5a$var$HAMS_PRODUCT_ID,
            ccpProductId: $fcf11cc3adcd0c5a$var$CCP_PRODUCT_ID,
            logo: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $letJZ.JiraProductDiscoveryIcon), {
                appearance: "brand"
            }),
            header: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                id: "growth.recommendation-jpd.product-name.header",
                description: "Header for Jira Product Discovery recommendation message in Jira Side Nav",
                defaultMessage: "Transform insights into action plans"
            }),
            ctaMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                id: "growth.recommendation-jpd.cta.label",
                description: "CTA text for Jira Product Discovery recommendation message in Jira Side Nav",
                defaultMessage: "Try Jira Product Discovery"
            })
        },
        onDismissed: onDismissed,
        whyAmISeeingThisModalContent: $fcf11cc3adcd0c5a$var$whyAmISeeingThisModalContent
    }));
var $fcf11cc3adcd0c5a$export$2e2bcd8739ae039 = $fcf11cc3adcd0c5a$export$b3890eb0ae9dca99;

});
parcelRegister("f3z2E", function(module, exports) {

$parcel$export(module.exports, "createRender", () => $3d976451defb5e0e$export$78c758434c34d601);

var $favav = parcelRequire("favav");
const { createRender: $3d976451defb5e0e$export$78c758434c34d601, createValidate: $3d976451defb5e0e$export$2859a83e4d6da57d } = (0, $favav.createClientPipeline)();
const { createHydrate: $3d976451defb5e0e$export$c905bc718befd59b, createHydrateExample: $3d976451defb5e0e$export$1f41223e5b0a6622, createTransformMetadata: $3d976451defb5e0e$export$88fe13b4d13f8423 } = (0, $favav.createServerPipeline)();

});


parcelRegister("a8SJ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $07f473868d5ab922$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $letJZ = parcelRequire("letJZ");

var $87Vie = parcelRequire("87Vie");

var $3hGLl = parcelRequire("3hGLl");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $4iOiM = parcelRequire("4iOiM");
const $07f473868d5ab922$export$3678c6c473f30928 = 'de63a248-1f93-46ed-b6ea-ab8e38af1c88';
const $07f473868d5ab922$export$5fca8a2477be63d = 'jira-servicedesk.ondemand';
const $07f473868d5ab922$var$PRODUCT_NAME = 'Jira Service Management';
const $07f473868d5ab922$var$whyAmISeeingThisModalContent = {
    message: /*#__PURE__*/ (0, $2OMIu.jsx)("p", {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            id: "growth.recommendation-jsm.reasons-modal.message",
            defaultMessage: "We think {jsm} will improve your team's productivity. The recommendation is based on:",
            description: "Explanation of why we think the JSM recommendation will be relevant to the customer.",
            values: {
                jsm: /*#__PURE__*/ (0, $2OMIu.jsx)("strong", {
                    children: $07f473868d5ab922$var$PRODUCT_NAME
                })
            }
        })
    }),
    reasons: (0, $87Vie.whyAmISeeingThisRecommendationMessageDefaultReason)
};
const $07f473868d5ab922$export$b3890eb0ae9dca99 = (0, $4iOiM.createRender)(({ onDismissed: onDismissed })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3hGLl.JiraSideNavFirstPartyRecommendation), {
        app: {
            hamsIdentifier: $07f473868d5ab922$export$5fca8a2477be63d,
            ccpProductId: $07f473868d5ab922$export$3678c6c473f30928,
            logo: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $letJZ.JiraServiceManagementIcon), {
                appearance: "brand"
            }),
            header: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                id: "growth.recommendation-jsm.product-name.header",
                description: "Header for Jira Service Management recommendation message in Jira Side Nav",
                defaultMessage: "Automate workflows for faster resolutions"
            }),
            ctaMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                id: "growth.recommendation-jsm.cta.label",
                description: "CTA text for Jira Service Management recommendation message in Jira Side Nav",
                defaultMessage: "Try Jira Service Management"
            })
        },
        onDismissed: onDismissed,
        whyAmISeeingThisModalContent: $07f473868d5ab922$var$whyAmISeeingThisModalContent
    }));
var $07f473868d5ab922$export$2e2bcd8739ae039 = $07f473868d5ab922$export$b3890eb0ae9dca99;

});
parcelRegister("4iOiM", function(module, exports) {

$parcel$export(module.exports, "createRender", () => $0eb19ad3ce396f7a$export$78c758434c34d601);

var $favav = parcelRequire("favav");
const { createRender: $0eb19ad3ce396f7a$export$78c758434c34d601, createValidate: $0eb19ad3ce396f7a$export$2859a83e4d6da57d } = (0, $favav.createClientPipeline)();
const { createHydrate: $0eb19ad3ce396f7a$export$c905bc718befd59b, createHydrateExample: $0eb19ad3ce396f7a$export$1f41223e5b0a6622, createTransformMetadata: $0eb19ad3ce396f7a$export$88fe13b4d13f8423 } = (0, $favav.createServerPipeline)();

});


parcelRegister("74GxC", function(module, exports) {

$parcel$export(module.exports, "default", () => $429ab5bd8143b6f0$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $letJZ = parcelRequire("letJZ");

var $87Vie = parcelRequire("87Vie");

var $3hGLl = parcelRequire("3hGLl");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $8M90l = parcelRequire("8M90l");

const $429ab5bd8143b6f0$var$whyAmISeeingThisModalContent = {
    message: /*#__PURE__*/ (0, $2OMIu.jsx)("p", {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            id: "growth.recommendation-jsw-visualize-work.reasons-modal.message",
            defaultMessage: "We think {product} will improve your team's productivity. The recommendation is based on:",
            description: "Explanation of why we think the Jira recommendation will be relevant to the customer.",
            values: {
                product: /*#__PURE__*/ (0, $2OMIu.jsx)("strong", {
                    children: (0, $1a520542f66ebd98$export$a75e537c279a265a)
                })
            }
        })
    }),
    reasons: (0, $87Vie.whyAmISeeingThisRecommendationMessageDefaultReason)
};
const $429ab5bd8143b6f0$export$b3890eb0ae9dca99 = (0, $8M90l.createRender)(({ onDismissed: onDismissed })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3hGLl.JiraSideNavFirstPartyRecommendation), {
        app: {
            hamsIdentifier: (0, $1a520542f66ebd98$export$5fca8a2477be63d),
            ccpProductId: (0, $1a520542f66ebd98$export$3678c6c473f30928),
            logo: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $letJZ.JiraIcon), {
                appearance: "brand"
            }),
            header: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                id: "growth.recommendation-jsw-visualize-work.product-name.header",
                description: "Header for Jira recommendation message in Jira Side Nav",
                defaultMessage: "Visualize your projects in lists, boards, and more"
            }),
            ctaMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                id: "growth.recommendation-jsw-visualize-work.cta.label",
                description: "CTA text for Jira recommendation message in Jira Side Nav",
                defaultMessage: "Try Jira"
            })
        },
        onDismissed: onDismissed,
        whyAmISeeingThisModalContent: $429ab5bd8143b6f0$var$whyAmISeeingThisModalContent
    }));
var $429ab5bd8143b6f0$export$2e2bcd8739ae039 = $429ab5bd8143b6f0$export$b3890eb0ae9dca99;

});
parcelRegister("8M90l", function(module, exports) {

$parcel$export(module.exports, "createRender", () => $56c6797b83f0702a$export$78c758434c34d601);

var $favav = parcelRequire("favav");
const { createRender: $56c6797b83f0702a$export$78c758434c34d601, createValidate: $56c6797b83f0702a$export$2859a83e4d6da57d } = (0, $favav.createClientPipeline)();
const { createHydrate: $56c6797b83f0702a$export$c905bc718befd59b, createHydrateExample: $56c6797b83f0702a$export$1f41223e5b0a6622, createTransformMetadata: $56c6797b83f0702a$export$88fe13b4d13f8423 } = (0, $favav.createServerPipeline)();

});

const $1a520542f66ebd98$export$3678c6c473f30928 = 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f';
const $1a520542f66ebd98$export$5fca8a2477be63d = 'jira-software.ondemand';
const $1a520542f66ebd98$export$a75e537c279a265a = 'Jira';


parcelRegister("4q3sn", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ab7860be2c2893f$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $letJZ = parcelRequire("letJZ");

var $87Vie = parcelRequire("87Vie");

var $3hGLl = parcelRequire("3hGLl");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $kzgQh = parcelRequire("kzgQh");

const $4ab7860be2c2893f$var$whyAmISeeingThisModalContent = {
    message: /*#__PURE__*/ (0, $2OMIu.jsx)("p", {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            id: "growth.recommendation-loom.reasons-modal.message",
            defaultMessage: "We think {product} will improve your team's productivity. The recommendation is based on:",
            description: "Explanation of why we think the Loom recommendation will be relevant to the customer.",
            values: {
                product: /*#__PURE__*/ (0, $2OMIu.jsx)("strong", {
                    children: (0, $7677cdc8da35bc29$export$a75e537c279a265a)
                })
            }
        })
    }),
    reasons: (0, $87Vie.whyAmISeeingThisRecommendationMessageDefaultReason)
};
const $4ab7860be2c2893f$export$b3890eb0ae9dca99 = (0, $kzgQh.createRender)(({ onDismissed: onDismissed })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3hGLl.JiraSideNavFirstPartyRecommendation), {
        app: {
            hamsIdentifier: (0, $7677cdc8da35bc29$export$5fca8a2477be63d),
            ccpProductId: (0, $7677cdc8da35bc29$export$3678c6c473f30928),
            logo: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $letJZ.LoomIcon), {
                appearance: "brand"
            }),
            header: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                id: "growth.recommendation-loom.product-name.header",
                description: "Header for Loom recommendation message in Jira Side Nav",
                defaultMessage: "Record and share videos easily"
            }),
            ctaMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                id: "growth.recommendation-loom.cta.label",
                description: "CTA text for Loom recommendation message in Jira Side Nav",
                defaultMessage: "Try Loom"
            })
        },
        onDismissed: onDismissed,
        whyAmISeeingThisModalContent: $4ab7860be2c2893f$var$whyAmISeeingThisModalContent
    }));
var $4ab7860be2c2893f$export$2e2bcd8739ae039 = $4ab7860be2c2893f$export$b3890eb0ae9dca99;

});
parcelRegister("kzgQh", function(module, exports) {

$parcel$export(module.exports, "createRender", () => $d2e75e1125d9231c$export$78c758434c34d601);

var $favav = parcelRequire("favav");
const { createRender: $d2e75e1125d9231c$export$78c758434c34d601, createValidate: $d2e75e1125d9231c$export$2859a83e4d6da57d } = (0, $favav.createClientPipeline)();
const { createHydrate: $d2e75e1125d9231c$export$c905bc718befd59b, createHydrateExample: $d2e75e1125d9231c$export$1f41223e5b0a6622, createTransformMetadata: $d2e75e1125d9231c$export$88fe13b4d13f8423 } = (0, $favav.createServerPipeline)();

});

const $7677cdc8da35bc29$export$ea76e6b040284832 = 'loom';
const $7677cdc8da35bc29$export$5fca8a2477be63d = 'loom';
const $7677cdc8da35bc29$export$a75e537c279a265a = 'Loom';
const $7677cdc8da35bc29$export$3678c6c473f30928 = '7683a73e-423d-41a1-b43f-d497656f8b5d';



parcelRegister("9Qq7C", function(module, exports) {

$parcel$export(module.exports, "default", () => $a06fe604d55a2d77$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $cmMVn = parcelRequire("cmMVn");

var $ea7mL = parcelRequire("ea7mL");
var $a06fe604d55a2d77$export$2e2bcd8739ae039 = {
    'onboarding-import-nudge': (0, $cmMVn.default),
    'onboarding-invite-nudge': (0, $ea7mL.default)
};

});
parcelRegister("cmMVn", function(module, exports) {

$parcel$export(module.exports, "default", () => $db776e424ba793b1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $iEN9D = parcelRequire("iEN9D");

var $l1N8i = parcelRequire("l1N8i");

var $jhmo0 = parcelRequire("jhmo0");
var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $h3mjV = parcelRequire("h3mjV");

var $aytRY = parcelRequire("aytRY");

var $bMrPe = parcelRequire("bMrPe");

var $fSNBK = parcelRequire("fSNBK");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $Xsjat = parcelRequire("Xsjat");

var $4vC5V = parcelRequire("4vC5V");
const $db776e424ba793b1$var$anchorStyles = (0, $8CUq3.xcss)({
    textDecoration: 'none'
});
const $db776e424ba793b1$var$boxStyles = (0, $8CUq3.xcss)({
    marginRight: 'space.200'
});
const $db776e424ba793b1$var$BodyContent = ()=>{
    const intl = (0, $koVbs.default)();
    const altText = intl.formatMessage({
        id: 'jira.side.nav.onboarding.import.nudge.icon.alt',
        defaultMessage: 'Lightbulb icon indicating an import tooltip',
        description: 'Alt text for the lightbulb icon in the import work nudge'
    });
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $h3mjV.useFirePostOfficeAnalyticsEvents)();
    const { messageClicked: messageClicked } = (0, $fSNBK.useMessageEvent)();
    const { messageInstanceClicked: messageInstanceClicked } = (0, $bMrPe.useMessageInstanceEvent)();
    const handleClick = ()=>{
        messageClicked(); // DEPRECATED: https://developer.atlassian.com/platform/post-office/working-with-post-office/technical-deep-dives/pre-defined-filters/#snooze-check-filter
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'importWork',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'open',
                destinationUrl: '/jira/settings/system/external-import'
            },
            additionalMetadataFromFrontend: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'importWork'
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($Xsjat))),
                alt: altText,
                height: "40px",
                width: "40px"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                        xcss: $db776e424ba793b1$var$boxStyles,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                            size: "xsmall",
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                id: "jira.side.nav.onboarding.import.nudge.heading",
                                defaultMessage: "Import work from another tool or CSV file to get started faster.",
                                description: "Text for the onboarding invite nudge, encouraging them to import work into Jira"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jhmo0.default), {
                        href: "/jira/settings/system/external-import",
                        target: "_blank",
                        xcss: $db776e424ba793b1$var$anchorStyles,
                        onClick: handleClick,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            id: "jira.side.nav.onboarding.import.nudge.link",
                            defaultMessage: "Import work",
                            description: "CTA for the onboarding invite nudge, that redirects the user to the import work screen in Jira"
                        })
                    })
                ]
            })
        ]
    });
};
const $db776e424ba793b1$export$b3890eb0ae9dca99 = (0, $4vC5V.createRender)(()=>{
    if ((0, $iEN9D.default).getExperimentValue('jira_sidebar_import_nudge', 'isEnabled', false)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aytRY.JiraSideNavMessage), {
        bodyContent: /*#__PURE__*/ (0, $2OMIu.jsx)($db776e424ba793b1$var$BodyContent, {}),
        showRemindMeLater: true,
        showWhyAmISeeingThis: false
    });
    return null;
});
var $db776e424ba793b1$export$2e2bcd8739ae039 = $db776e424ba793b1$export$b3890eb0ae9dca99;

});
parcelRegister("Xsjat", function(module, exports) {
module.exports = new URL("Lightbulb.72a6137f.svg", import.meta.url).toString();

});

parcelRegister("4vC5V", function(module, exports) {

$parcel$export(module.exports, "createRender", () => $d158d68adcbb4ead$export$78c758434c34d601);

var $favav = parcelRequire("favav");
const { createRender: $d158d68adcbb4ead$export$78c758434c34d601, createValidate: $d158d68adcbb4ead$export$2859a83e4d6da57d } = (0, $favav.createClientPipeline)();
const { createHydrate: $d158d68adcbb4ead$export$c905bc718befd59b, createHydrateExample: $d158d68adcbb4ead$export$1f41223e5b0a6622, createTransformMetadata: $d158d68adcbb4ead$export$88fe13b4d13f8423 } = (0, $favav.createServerPipeline)();

});


parcelRegister("ea7mL", function(module, exports) {

$parcel$export(module.exports, "default", () => $398ab7f323cb9905$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $aytRY = parcelRequire("aytRY");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $8ljsN = parcelRequire("8ljsN");

var $bZSJt = parcelRequire("bZSJt");
const $398ab7f323cb9905$var$boxStyles = (0, $8CUq3.xcss)({
    marginRight: 'space.200'
});
const $398ab7f323cb9905$var$BodyContent = ()=>{
    const intl = (0, $koVbs.default)();
    const inviteIconAltText = intl.formatMessage({
        id: 'jira.side.nav.onboarding.invite.nudge.icon.alt',
        defaultMessage: 'Invite icon indicating an invite tooltip',
        description: 'Alt text for the lightbulb icon in the invite work nudge'
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                xcss: $398ab7f323cb9905$var$boxStyles,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($8ljsN))),
                    alt: inviteIconAltText,
                    height: "40px",
                    width: "40px"
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                        size: "xsmall",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            id: "jira.side.nav.onboarding.invite.nudge.heading",
                            defaultMessage: "Invite your team to collaborate on work together.",
                            description: "Text for the onboarding invite nudge, encouraging them to invite other teammates to Jira"
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            id: "jira.side.nav.onboarding.invite.nudge.link",
                            defaultMessage: "Invite your team",
                            description: "CTA for the onboarding invite nudge, which opens the invite modal"
                        })
                    })
                ]
            })
        ]
    });
};
const $398ab7f323cb9905$export$b3890eb0ae9dca99 = (0, $bZSJt.createRender)(()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $aytRY.JiraSideNavMessage), {
        bodyContent: /*#__PURE__*/ (0, $2OMIu.jsx)($398ab7f323cb9905$var$BodyContent, {})
    }));
var $398ab7f323cb9905$export$2e2bcd8739ae039 = $398ab7f323cb9905$export$b3890eb0ae9dca99;

});
parcelRegister("8ljsN", function(module, exports) {
module.exports = new URL("Invite.20f05c87.svg", import.meta.url).toString();

});

parcelRegister("bZSJt", function(module, exports) {

$parcel$export(module.exports, "createRender", () => $8b005aa80efccc07$export$78c758434c34d601);

var $favav = parcelRequire("favav");
const { createRender: $8b005aa80efccc07$export$78c758434c34d601, createValidate: $8b005aa80efccc07$export$2859a83e4d6da57d } = (0, $favav.createClientPipeline)();
const { createHydrate: $8b005aa80efccc07$export$c905bc718befd59b, createHydrateExample: $8b005aa80efccc07$export$1f41223e5b0a6622, createTransformMetadata: $8b005aa80efccc07$export$88fe13b4d13f8423 } = (0, $favav.createServerPipeline)();

});



parcelRegister("iBcC2", function(module, exports) {

$parcel$export(module.exports, "default", () => $10a02dab00528fab$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $5wEo8 = parcelRequire("5wEo8");
var $10a02dab00528fab$export$2e2bcd8739ae039 = {
    'message-template-template': (0, $5wEo8.default)
};

});
parcelRegister("5wEo8", function(module, exports) {

$parcel$export(module.exports, "default", () => $117502977389e16b$export$2e2bcd8739ae039);
/* eslint-disable formatjs/no-literal-string-in-jsx */ 
var $2OMIu = parcelRequire("2OMIu");

var $jQd95 = parcelRequire("jQd95");
const $117502977389e16b$export$b3890eb0ae9dca99 = (0, $jQd95.createRender)(()=>/*#__PURE__*/ (0, $2OMIu.jsx)("button", {
        children: `Hello world!`
    }));
var $117502977389e16b$export$2e2bcd8739ae039 = $117502977389e16b$export$b3890eb0ae9dca99;

});
parcelRegister("jQd95", function(module, exports) {

$parcel$export(module.exports, "createRender", () => $465acaa361cf2257$export$78c758434c34d601);

var $favav = parcelRequire("favav");
const { createRender: $465acaa361cf2257$export$78c758434c34d601, createValidate: $465acaa361cf2257$export$2859a83e4d6da57d } = (0, $favav.createClientPipeline)();
const { createHydrate: $465acaa361cf2257$export$c905bc718befd59b, createHydrateExample: $465acaa361cf2257$export$1f41223e5b0a6622, createTransformMetadata: $465acaa361cf2257$export$88fe13b4d13f8423 } = (0, $favav.createServerPipeline)();

});



parcelRegister("9josU", function(module, exports) {

$parcel$export(module.exports, "default", () => $2055b5b282abba0a$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $dvt9l = parcelRequire("dvt9l");
var $2055b5b282abba0a$export$2e2bcd8739ae039 = {
    'test-message-inapp': (0, $dvt9l.default)
};

});
parcelRegister("dvt9l", function(module, exports) {

$parcel$export(module.exports, "default", () => $71f6b8f9a640e714$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $iYIKg = parcelRequire("iYIKg");
const $71f6b8f9a640e714$export$b3890eb0ae9dca99 = (0, $iYIKg.createRender)(()=>/*#__PURE__*/ (0, $2OMIu.jsx)("button", {
        children: "This is an example test button"
    }));
var $71f6b8f9a640e714$export$2e2bcd8739ae039 = $71f6b8f9a640e714$export$b3890eb0ae9dca99;

});
parcelRegister("iYIKg", function(module, exports) {

$parcel$export(module.exports, "createRender", () => $81cbf33620d5c49c$export$78c758434c34d601);

var $favav = parcelRequire("favav");
const { createRender: $81cbf33620d5c49c$export$78c758434c34d601, createValidate: $81cbf33620d5c49c$export$2859a83e4d6da57d } = (0, $favav.createClientPipeline)();
const { createHydrate: $81cbf33620d5c49c$export$c905bc718befd59b, createHydrateExample: $81cbf33620d5c49c$export$1f41223e5b0a6622, createTransformMetadata: $81cbf33620d5c49c$export$88fe13b4d13f8423 } = (0, $favav.createServerPipeline)();

});




/* GeneratedContentHash: 9c47655ae0da7c4a10425612f1be5cf9c57ec22e23c4d4b1e4a2589c469dc001 */ /*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for server side use only
*/ const $8d3aa60fe9a77226$export$a5cfae247d8360ef = 'jira-side-nav';

parcelRegister("eH8Ru", function(module, exports) {

$parcel$export(module.exports, "withJiraSideNavIntlProvider", () => $6cd5e23ce325d19b$export$6844f5e0cf66d318);
/**
 * This file was automatically generated using "yarn generate:all" command.
 * Please do not edit it manually.
 * 
 * Generate source: local/cli/src/commands/placements/generate-intl-provider.ts
 **/ 
var $frIzT = parcelRequire("frIzT");

var $5pE3Q = parcelRequire("5pE3Q");

var $2iRPD = parcelRequire("2iRPD");

var $gWg7c = parcelRequire("gWg7c");

var $cENg4 = parcelRequire("cENg4");
const $6cd5e23ce325d19b$export$d5a462ce7bd04520 = async (locale)=>{
    return Promise.allSettled([
        (0, $5pE3Q.messagesLoader)(locale),
        (0, $2iRPD.messagesLoader)(locale),
        (0, $gWg7c.messagesLoader)(locale),
        (0, $cENg4.messagesLoader)(locale)
    ]).then((results)=>{
        return results.reduce((acc, result)=>{
            if (result.status === 'fulfilled') return {
                messages: {
                    ...acc.messages,
                    ...result.value
                },
                errors: [
                    ...acc.errors
                ]
            };
            else if (result.status === 'rejected') return {
                messages: {
                    ...acc.messages
                },
                errors: [
                    ...acc.errors,
                    `Failed to load translations with ${result.reason}`
                ]
            };
            return acc;
        }, {
            messages: {},
            errors: []
        });
    });
};
const $6cd5e23ce325d19b$export$6844f5e0cf66d318 = (Component)=>{
    return (0, $frIzT.withIntlProvider)({
        messagesLoader: $6cd5e23ce325d19b$export$d5a462ce7bd04520
    }, Component);
};

});
parcelRegister("2iRPD", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $ad27982a80c67dc2$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $bN39Y = parcelRequire("bN39Y");

var $euiLX = parcelRequire("euiLX");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ad27982a80c67dc2$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;






























const $ad27982a80c67dc2$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $euiLX.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $ad27982a80c67dc2$var$importHelper(await (parcelRequire("7oETv")));
        case 'da':
            return $ad27982a80c67dc2$var$importHelper(await (parcelRequire("7xa4W")));
        case 'de':
            return $ad27982a80c67dc2$var$importHelper(await (parcelRequire("16uvJ")));
        case 'en-GB':
            return $ad27982a80c67dc2$var$importHelper(await (parcelRequire("bolVR")));
        case 'en-US':
            return $ad27982a80c67dc2$var$importHelper(await (parcelRequire("3qf4i")));
        case 'en-XA':
            return $ad27982a80c67dc2$var$importHelper(await (parcelRequire("bxcwU")));
        case 'en-XB':
            return $ad27982a80c67dc2$var$importHelper(await (parcelRequire("4x11E")));
        case 'en-ZZ':
            return $ad27982a80c67dc2$var$importHelper(await (parcelRequire("h8W2F")));
        case 'en':
            return $ad27982a80c67dc2$var$importHelper(await Promise.resolve((parcelRequire("bN39Y"))));
        case 'es':
            return $ad27982a80c67dc2$var$importHelper(await (parcelRequire("l6TzU")));
        case 'et':
            return $ad27982a80c67dc2$var$importHelper(await (parcelRequire("41AI2")));
        case 'fi':
            return $ad27982a80c67dc2$var$importHelper(await (parcelRequire("bgntE")));
        case 'fr':
            return $ad27982a80c67dc2$var$importHelper(await (parcelRequire("9pmLI")));
        case 'hu':
            return $ad27982a80c67dc2$var$importHelper(await (parcelRequire("ftt4N")));
        case 'it':
            return $ad27982a80c67dc2$var$importHelper(await (parcelRequire("cchKv")));
        case 'ja':
            return $ad27982a80c67dc2$var$importHelper(await (parcelRequire("jKVsR")));
        case 'ko':
            return $ad27982a80c67dc2$var$importHelper(await (parcelRequire("fBuQQ")));
        case 'nb':
            return $ad27982a80c67dc2$var$importHelper(await (parcelRequire("8FGxi")));
        case 'nl':
            return $ad27982a80c67dc2$var$importHelper(await (parcelRequire("6JGpN")));
        case 'pl':
            return $ad27982a80c67dc2$var$importHelper(await (parcelRequire("hRBYc")));
        case 'pt-BR':
            return $ad27982a80c67dc2$var$importHelper(await (parcelRequire("cscdB")));
        case 'ro':
            return $ad27982a80c67dc2$var$importHelper(await (parcelRequire("fC6xY")));
        case 'ru':
            return $ad27982a80c67dc2$var$importHelper(await (parcelRequire("2ogsK")));
        case 'sv':
            return $ad27982a80c67dc2$var$importHelper(await (parcelRequire("lEJ8v")));
        case 'th':
            return $ad27982a80c67dc2$var$importHelper(await (parcelRequire("jALQ4")));
        case 'tr':
            return $ad27982a80c67dc2$var$importHelper(await (parcelRequire("jNWM8")));
        case 'uk':
            return $ad27982a80c67dc2$var$importHelper(await (parcelRequire("iSIfd")));
        case 'vi':
            return $ad27982a80c67dc2$var$importHelper(await (parcelRequire("jmtCA")));
        case 'zh-CN':
            return $ad27982a80c67dc2$var$importHelper(await (parcelRequire("e8xb2")));
        case 'zh-TW':
            return $ad27982a80c67dc2$var$importHelper(await (parcelRequire("5IxlY")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($bN39Y));
    }
};

});
parcelRegister("bN39Y", function(module, exports) {
module.exports = JSON.parse("{\"jira.side.nav.onboarding.import.nudge.heading\":[{\"type\":0,\"value\":\"Import work from another tool or CSV file to get started faster.\"}],\"jira.side.nav.onboarding.import.nudge.icon.alt\":[{\"type\":0,\"value\":\"Lightbulb icon indicating an import tooltip\"}],\"jira.side.nav.onboarding.import.nudge.link\":[{\"type\":0,\"value\":\"Import work\"}],\"jira.side.nav.onboarding.invite.nudge.heading\":[{\"type\":0,\"value\":\"Invite your team to collaborate on work together.\"}],\"jira.side.nav.onboarding.invite.nudge.icon.alt\":[{\"type\":0,\"value\":\"Invite icon indicating an invite tooltip\"}],\"jira.side.nav.onboarding.invite.nudge.link\":[{\"type\":0,\"value\":\"Invite your team\"}]}");

});

parcelRegister("7oETv", function(module, exports) {

let $562a7f045d38849a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $562a7f045d38849a$var$load("ghhWM").then(()=>parcelRequire('f4XfF'));

});

parcelRegister("7xa4W", function(module, exports) {

let $57c36ee9e7a51cda$var$load = (parcelRequire("28QjX"))(4);
module.exports = $57c36ee9e7a51cda$var$load("6WJaS").then(()=>parcelRequire('hx6LA'));

});

parcelRegister("16uvJ", function(module, exports) {

let $0cde04c6c1179287$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0cde04c6c1179287$var$load("033A0").then(()=>parcelRequire('2GmUQ'));

});

parcelRegister("bolVR", function(module, exports) {

let $84b2f2e697ef0c91$var$load = (parcelRequire("28QjX"))(4);
module.exports = $84b2f2e697ef0c91$var$load("bgja4").then(()=>parcelRequire('hpjZ8'));

});

parcelRegister("3qf4i", function(module, exports) {

let $27df7d13b155b187$var$load = (parcelRequire("28QjX"))(4);
module.exports = $27df7d13b155b187$var$load("fW7Gt").then(()=>parcelRequire('iE4r7'));

});

parcelRegister("bxcwU", function(module, exports) {

let $865c7ef38f8e3796$var$load = (parcelRequire("28QjX"))(4);
module.exports = $865c7ef38f8e3796$var$load("gOC9l").then(()=>parcelRequire('96s91'));

});

parcelRegister("4x11E", function(module, exports) {

let $34cb0a25c7660e4f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $34cb0a25c7660e4f$var$load("6Ubel").then(()=>parcelRequire('lkbOh'));

});

parcelRegister("h8W2F", function(module, exports) {

let $c7b034f8b3b12430$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c7b034f8b3b12430$var$load("IlyWH").then(()=>parcelRequire('5JVEf'));

});

parcelRegister("l6TzU", function(module, exports) {

let $f5e54532c7578ce8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f5e54532c7578ce8$var$load("1EqDq").then(()=>parcelRequire('10zD8'));

});

parcelRegister("41AI2", function(module, exports) {

let $2ee3bb1eedead4c4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2ee3bb1eedead4c4$var$load("foWHg").then(()=>parcelRequire('fijhu'));

});

parcelRegister("bgntE", function(module, exports) {

let $83336668a864ff73$var$load = (parcelRequire("28QjX"))(4);
module.exports = $83336668a864ff73$var$load("jMhdy").then(()=>parcelRequire('6ElUV'));

});

parcelRegister("9pmLI", function(module, exports) {

let $6d981c3a518975e5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6d981c3a518975e5$var$load("ib2WH").then(()=>parcelRequire('8OhI4'));

});

parcelRegister("ftt4N", function(module, exports) {

let $b4401e63f5d8b71d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b4401e63f5d8b71d$var$load("aYt2K").then(()=>parcelRequire('jIHto'));

});

parcelRegister("cchKv", function(module, exports) {

let $8e145fa5568d5678$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8e145fa5568d5678$var$load("7BxzV").then(()=>parcelRequire('5OZjA'));

});

parcelRegister("jKVsR", function(module, exports) {

let $e61ee376c698d6c9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e61ee376c698d6c9$var$load("lfZ13").then(()=>parcelRequire('kIaEk'));

});

parcelRegister("fBuQQ", function(module, exports) {

let $b5c23e2128c24aa5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b5c23e2128c24aa5$var$load("lBg7Z").then(()=>parcelRequire('lO2Ki'));

});

parcelRegister("8FGxi", function(module, exports) {

let $650325d097bfb4a2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $650325d097bfb4a2$var$load("8hsGx").then(()=>parcelRequire('7Lp0f'));

});

parcelRegister("6JGpN", function(module, exports) {

let $4e77d8c9005a2966$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4e77d8c9005a2966$var$load("gUmln").then(()=>parcelRequire('71dfF'));

});

parcelRegister("hRBYc", function(module, exports) {

let $d014d6ec74d73ecb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d014d6ec74d73ecb$var$load("5E4Uu").then(()=>parcelRequire('gRbva'));

});

parcelRegister("cscdB", function(module, exports) {

let $911193db9a3f4e0d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $911193db9a3f4e0d$var$load("4o1HB").then(()=>parcelRequire('16Suj'));

});

parcelRegister("fC6xY", function(module, exports) {

let $b5df7bb50cd30ad0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b5df7bb50cd30ad0$var$load("fgDbI").then(()=>parcelRequire('3GKz4'));

});

parcelRegister("2ogsK", function(module, exports) {

let $1bda97d00578078b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1bda97d00578078b$var$load("7Dd5y").then(()=>parcelRequire('eURxr'));

});

parcelRegister("lEJ8v", function(module, exports) {

let $fc40587c14199188$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fc40587c14199188$var$load("8hEP7").then(()=>parcelRequire('8jgcY'));

});

parcelRegister("jALQ4", function(module, exports) {

let $e4367ce3b95ae2de$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e4367ce3b95ae2de$var$load("heq7g").then(()=>parcelRequire('aGrdT'));

});

parcelRegister("jNWM8", function(module, exports) {

let $e6b02f785ef31960$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e6b02f785ef31960$var$load("7bS21").then(()=>parcelRequire('kBotE'));

});

parcelRegister("iSIfd", function(module, exports) {

let $dbef972ccf080b76$var$load = (parcelRequire("28QjX"))(4);
module.exports = $dbef972ccf080b76$var$load("1Ep7K").then(()=>parcelRequire('9GP0d'));

});

parcelRegister("jmtCA", function(module, exports) {

let $e1870c8ee91c2dac$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e1870c8ee91c2dac$var$load("3ZTIv").then(()=>parcelRequire('9tE8O'));

});

parcelRegister("e8xb2", function(module, exports) {

let $a4ab8c4bf143b409$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a4ab8c4bf143b409$var$load("8ZxYb").then(()=>parcelRequire('jP6KQ'));

});

parcelRegister("5IxlY", function(module, exports) {

let $429aef20f73ef2f4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $429aef20f73ef2f4$var$load("9sS55").then(()=>parcelRequire('6fQXa'));

});





parcelRegister("5ELA2", function(module, exports) {

$parcel$export(module.exports, "NavPlatformSidebar", () => $1f6f44f0adfa4e2d$export$7d687ab114dcac8a);

var $5uXOq = parcelRequire("5uXOq");

var $fwGlt = parcelRequire("fwGlt");

var $fVcrn = parcelRequire("fVcrn");

var $jNrrt = parcelRequire("jNrrt");
function $1f6f44f0adfa4e2d$export$7d687ab114dcac8a() {
    /*
		1. Add UFOSegment
		2. Determine which sidebar to show
		  a. If NOT content sidebar,
		    1. render other sidebars within `postMainElement`
			2. disable customisation
			3. Return GSN component
		  b. Otherwise,
		    1. Get items-config (default config), using custom components


	*/ /*
		Use same sidebar-selector logic as in navigation-apps/sidebar-nav4/sidebar-selector/src/ui/entrypoint/index.tsx
	*/ const paramsForGetNav4SidebarId = (0, $fwGlt.useGetParamsForGetNav4SidebarId)();
    const currentSidebarId = (0, $fwGlt.getNav4SidebarId)(paramsForGetNav4SidebarId);
    if (currentSidebarId === 'CONTENT') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVcrn.GSNForContentSidebar), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jNrrt.GSNForOtherSidebars), {
        sidebarId: currentSidebarId
    });
}

});
parcelRegister("fVcrn", function(module, exports) {

$parcel$export(module.exports, "GSNForContentSidebar", () => $1e6871cbc6bce663$export$a507175eae481438);

var $iWisO = parcelRequire("iWisO");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $6HuKm = parcelRequire("6HuKm");

var $ao2h1 = parcelRequire("ao2h1");

var $c6x3L = parcelRequire("c6x3L");

var $blbXb = parcelRequire("blbXb");

var $46Cti = parcelRequire("46Cti");

var $3iY1w = parcelRequire("3iY1w");

var $67KAW = parcelRequire("67KAW");

var $kcT7A = parcelRequire("kcT7A");

var $aXxBX = parcelRequire("aXxBX");

var $kcmzD = parcelRequire("kcmzD");

var $VyuC0 = parcelRequire("VyuC0");

var $iWRQ3 = parcelRequire("iWRQ3");

var $lz3si = parcelRequire("lz3si");

var $1YUDD = parcelRequire("1YUDD");

var $3nmOf = parcelRequire("3nmOf");

var $abrAF = parcelRequire("abrAF");

var $3J4Wg = parcelRequire("3J4Wg");

var $cq1bX = parcelRequire("cq1bX");

var $96poX = parcelRequire("96poX");

var $4R6GH = parcelRequire("4R6GH");

var $iKHgp = parcelRequire("iKHgp");

var $cam2y = parcelRequire("cam2y");

var $1zjdl = parcelRequire("1zjdl");

var $3cFRo = parcelRequire("3cFRo");

var $gEccW = parcelRequire("gEccW");

var $koeKL = parcelRequire("koeKL");

var $fY39E = parcelRequire("fY39E");

var $90yGq = parcelRequire("90yGq");

var $95KxO = parcelRequire("95KxO");

var $81zXP = parcelRequire("81zXP");

var $bZAdI = parcelRequire("bZAdI");
const $1e6871cbc6bce663$var$forYouConfig = (0, $bZAdI.getForYouConfig)();
function $1e6871cbc6bce663$export$a507175eae481438() {
    /*
  	TODO: Add support for entryPoint routes
  	*/ // This is the non-EP solution for loading the data
    const { queryReference: queryReference } = (0, $ao2h1.useRelayResource)((0, $gEccW.navPlatformSidebarResource));
    const queryReferenceRef = (0, $5uXOq.useRef)(null);
    // We don't want to use nullable query references. So only remember the non-null ones,
    // and pass the non-null query reference to the children.
    // From Slack: https://atlassian.slack.com/archives/C01E2MPPLE4/p1654736794416059?thread_ts=1654051102.548519&cid=C01E2MPPLE4
    if (queryReference) queryReferenceRef.current = queryReference;
    else if (!queryReferenceRef.current) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1e6871cbc6bce663$var$GSNForContentSidebarInner, {
        queryReference: queryReferenceRef.current
    });
}
function $1e6871cbc6bce663$var$GSNForContentSidebarInner(props) {
    const { queryReference: queryReference } = props;
    const queryRef = (0, $8Uumt.usePreloadedQuery)(/* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */ (0, $iWisO.default), queryReference);
    const shouldRenderOverviews = (0, $iKHgp.useShouldRenderOverviews)();
    const cloudId = (0, $koeKL.useCloudId)();
    const activationId = (0, $fY39E.useActivationId)();
    const ownerId = (0, $90yGq.useAccountId)();
    const navItems = (0, $cam2y.useFilterL1MenuItemsByEditionAndLicense)((0, $1zjdl.USER_NAVIGATION_CONFIGURATION_DEFAULT).navItems);
    const items = (0, $5uXOq.useMemo)(()=>{
        return $1e6871cbc6bce663$var$buildItemConfig({
            navItems: navItems,
            shouldRenderOverviews: shouldRenderOverviews,
            componentProps: {
                queryRef: queryRef,
                isExpanded: false
            }
        });
    }, [
        navItems,
        shouldRenderOverviews,
        queryRef
    ]);
    const networkStorageParams = (0, $5uXOq.useMemo)(()=>{
        const entityAri = (0, $81zXP.JiraWorkspaceAri).create({
            siteId: cloudId,
            activationId: activationId
        }).toString();
        const ownerAri = ownerId && (0, $95KxO.IdentityUserAri).create({
            userId: ownerId
        }).toString() || '';
        return {
            entityAri: entityAri,
            ownerAri: ownerAri,
            queryRef: queryRef
        };
    }, [
        cloudId,
        activationId,
        ownerId,
        queryRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c6x3L.SidebarNav4ContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6HuKm.GlobalSideNavigation), {
        app: "jira",
        customizationStore: "network",
        forYou: $1e6871cbc6bce663$var$forYouConfig,
        items: items,
        networkStorageParams: networkStorageParams,
        testId: "nav-platform-integration-sidebar.ui.global-side-navigation"
    }));
}
function $1e6871cbc6bce663$var$buildItemConfig(params) {
    const { navItems: navItems, componentProps: componentProps, shouldRenderOverviews: shouldRenderOverviews } = params;
    const components = navItems.map(({ menuId: menuId })=>{
        switch(menuId){
            case (0, $46Cti.L1_MENU_ID).APPS:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iY1w.Nav4Apps), componentProps);
            case (0, $46Cti.L1_MENU_ID).ASSETS:
                /* remove this case on
         * blu-6313_sidebar_global_app_shortcuts cleanup &&
         * assets_as_an_app_v2 cleanup &&
         * blu-6576_migrate_to_platform_customisation cleanup
         */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $67KAW.Nav4Assets), {
                    isExpanded: componentProps.isExpanded
                });
            case (0, $46Cti.L1_MENU_ID).DASHBOARDS:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kcmzD.Nav4Dashboards), {
                    isExpanded: componentProps.isExpanded
                });
            case (0, $46Cti.L1_MENU_ID).FILTERS:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $blbXb.Nav4Filters), componentProps);
            case (0, $46Cti.L1_MENU_ID).GOALS:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3cFRo.Stub), {
                    menuId: (0, $46Cti.L1_MENU_ID).GOALS,
                    href: (0, $1zjdl.USER_NAVIGATION_ITEM_LINKS)[(0, $46Cti.L1_MENU_ID).GOALS]
                });
            case (0, $46Cti.L1_MENU_ID).OPERATIONS:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $VyuC0.Nav4Operations), componentProps);
            case (0, $46Cti.L1_MENU_ID).COMMUNICATION:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iWRQ3.Nav4Communications), {
                    isExpanded: componentProps.isExpanded
                });
            case (0, $46Cti.L1_MENU_ID).PLANS:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1YUDD.Nav4Plans), componentProps);
            case (0, $46Cti.L1_MENU_ID).OVERVIEWS:
                return shouldRenderOverviews && (0, $4R6GH.fg)('blu-2858-sidebar-menu-overviews') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lz3si.Nav4Overviews), componentProps) : null;
            case (0, $46Cti.L1_MENU_ID).PROJECTS:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3nmOf.Nav4Projects), componentProps);
            case (0, $46Cti.L1_MENU_ID).RECENT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $abrAF.Recent), null);
            case (0, $46Cti.L1_MENU_ID).ROADMAPS:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3J4Wg.Nav4Roadmaps), {
                    isExpanded: componentProps.isExpanded
                });
            case (0, $46Cti.L1_MENU_ID).STARRED:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cq1bX.Starred), null);
            case (0, $46Cti.L1_MENU_ID).TEAMS:
                return !(0, $4R6GH.fg)('nav4_gas_include_teams') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96poX.Teams), null) : null;
            case (0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE:
                return (0, $4R6GH.fg)('jcs_master_flag') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aXxBX.CustomerService), null) : null;
            case (0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS:
                return (0, $4R6GH.fg)('jcs-analytics-page') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kcT7A.CustomerServiceAnalytics), null) : null;
            default:
                return null;
        }
    });
    return navItems.reduce((acc, navItem, index)=>{
        acc[navItem.menuId] = {
            type: 'custom',
            Component: ()=>components[index]
        };
        return acc;
    }, {});
}

});
parcelRegister("6HuKm", function(module, exports) {

$parcel$export(module.exports, "GlobalSideNavigation", () => $91d9b754b95dda54$export$e3822b656235cd34);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gPYSU = parcelRequire("gPYSU");

var $9wNZa = parcelRequire("9wNZa");
function $91d9b754b95dda54$export$e3822b656235cd34(props) {
    const { customizationStore: customizationStore = 'local', ...innerProps } = props;
    const SideNav = (0, $5uXOq.useMemo)(()=>{
        return customizationStore === 'local' ? (0, $gPYSU.GlobalSideNavigationWithLocalStore) : (0, $9wNZa.GlobalSideNavigationWithNetworkStore);
    }, [
        customizationStore
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(SideNav, {
        ...innerProps
    });
}

});
parcelRegister("gPYSU", function(module, exports) {

$parcel$export(module.exports, "GlobalSideNavigationWithLocalStore", () => $fb7ba24a055ed71e$export$5d528a9833af3dd4);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $1NlKt = parcelRequire("1NlKt");

var $6ch0y = parcelRequire("6ch0y");

var $k8kcY = parcelRequire("k8kcY");
function $fb7ba24a055ed71e$export$5d528a9833af3dd4(props) {
    const { app: app } = props;
    // This is user data for the menu and the sidebar
    const userStoreProps = (0, $1NlKt.useLocalSideNavUserData)({
        app: app
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8kcY.GlobalSideNavWrapper), {
        ...userStoreProps,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6ch0y.GlobalSideNavContent), {
            ...props
        })
    });
}

});
parcelRegister("1NlKt", function(module, exports) {

$parcel$export(module.exports, "useLocalSideNavUserData", () => $53220fcaf9ac4458$export$4714a0d7e8941053);

var $5uXOq = parcelRequire("5uXOq");

const $53220fcaf9ac4458$var$nullState = {
    userSideNavData: {
        defaultWidth: undefined,
        defaultCollapsed: undefined
    },
    userMenuData: []
};
// Allow the key to be extended (by adding a prefix or suffix)
let $53220fcaf9ac4458$var$LS_KEY = (0, $0ca1b1da8db82735$export$42cf6fc952b8bebd);
function $53220fcaf9ac4458$export$4714a0d7e8941053({ app: app }) {
    $53220fcaf9ac4458$var$setLocalStorageKey(app);
    const [sideNavState, setSideNavState] = (0, $5uXOq.useReducer)($53220fcaf9ac4458$var$reducer, $53220fcaf9ac4458$var$getInitialState());
    const setUserMenuData = (0, $5uXOq.useCallback)(async (userMenuData)=>{
        setSideNavState({
            userMenuData: userMenuData
        });
    }, []);
    const setUserSideNavData = (0, $5uXOq.useCallback)(async (userSideNavData)=>{
        setSideNavState({
            userSideNavData: {
                ...sideNavState.userSideNavData,
                ...userSideNavData
            }
        });
    }, [
        sideNavState
    ]);
    return {
        ...sideNavState,
        setUserMenuData: setUserMenuData,
        setUserSideNavData: setUserSideNavData
    };
}
function $53220fcaf9ac4458$var$setLocalStorageKey(suffix) {
    $53220fcaf9ac4458$var$LS_KEY = [
        (0, $0ca1b1da8db82735$export$42cf6fc952b8bebd),
        suffix
    ].join('-');
}
function $53220fcaf9ac4458$var$getInitialState() {
    const storedState = $53220fcaf9ac4458$var$parseLocalStorageState(localStorage.getItem($53220fcaf9ac4458$var$LS_KEY));
    if (storedState) return storedState;
    $53220fcaf9ac4458$var$setLocalStorageState($53220fcaf9ac4458$var$nullState);
    return $53220fcaf9ac4458$var$nullState;
}
function $53220fcaf9ac4458$var$reducer(state, payload) {
    const newState = {
        ...state,
        ...payload
    };
    // Update localStorage with the new state
    $53220fcaf9ac4458$var$setLocalStorageState(newState);
    return newState;
}
function $53220fcaf9ac4458$var$setLocalStorageState(state) {
    localStorage.setItem($53220fcaf9ac4458$var$LS_KEY, JSON.stringify(state));
}
function $53220fcaf9ac4458$var$parseLocalStorageState(state) {
    if (!state) return;
    try {
        const parsedState = JSON.parse(state);
        // This check should return true for the nullState
        if (parsedState?.userSideNavData && Array.isArray(parsedState.userMenuData) && typeof parsedState.userSideNavData === 'object') return parsedState;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
    // something went wrong with parsing, return undefined
    }
}

});
const $0ca1b1da8db82735$export$85183a312807388d = 'navigation';
const $0ca1b1da8db82735$export$42cf6fc952b8bebd = 'nav-platform-sidebar-state';


parcelRegister("6ch0y", function(module, exports) {

$parcel$export(module.exports, "GlobalSideNavContent", () => $1fa456fe42cd15a9$export$8c46791627cc3bc0);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $gSZmd = parcelRequire("gSZmd");

var $dC5iT = parcelRequire("dC5iT");

var $luBm6 = parcelRequire("luBm6");

var $3SCPg = parcelRequire("3SCPg");
var $8c2TE = parcelRequire("8c2TE");

var $jRSFr = parcelRequire("jRSFr");

var $hMtBm = parcelRequire("hMtBm");

var $5LkU5 = parcelRequire("5LkU5");

var $5eaCi = parcelRequire("5eaCi");


var $7ofg2 = parcelRequire("7ofg2");

var $cbMlQ = parcelRequire("cbMlQ");

var $epGyj = parcelRequire("epGyj");

var $jklcM = parcelRequire("jklcM");

var $klQWJ = parcelRequire("klQWJ");

var $9Wcev = parcelRequire("9Wcev");
function $1fa456fe42cd15a9$export$8c46791627cc3bc0(props) {
    const { app: app, bottomElem: bottomElem, cloudId: cloudId, disableItemCustomization: disableItemCustomization = false, items: items, isShortcutsStatic: isShortcutsStatic, forYou: forYou, orgId: orgId, postItemsElem: postItemsElem, postMainElem: postMainElem, shortcuts: shortcuts, topElem: topElem } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { userMenuData: userMenuData, setUserMenuData: setUserMenuData } = (0, $5eaCi.useUserMenuData)();
    // Prepare global items
    const globalItems = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        const items = new Map();
        if (!forYou.hideForYou) items.set(forYou.forYouMenuItemId ?? 'global.sidebar.forYou', (0, $7ofg2.default)({
            href: forYou.forYouUrl,
            isSelected: forYou.forYouIsSelected,
            onClick: forYou.forYouOnClick
        }));
        if (!forYou.hideRecents) items.set(forYou.recentsMenuItemId ?? 'global.sidebar.recent', (0, $klQWJ.default)({
            useRecentItems: forYou.useRecentItems,
            searchPlaceholder: formatMessage((0, $epGyj.messages).recentsSearchPlaceholder),
            searchable: forYou.recentsIsSearchable,
            filters: forYou.recentsFilters,
            viewAllHref: forYou.viewAllRecentsUrl,
            viewAllOnClick: forYou.viewAllRecentsOnClick
        }));
        if (!forYou.hideStarred) items.set(forYou.starredMenuItemId ?? 'global.sidebar.starred', (0, $9Wcev.default)({
            useStarredItems: forYou.useStarredItems,
            searchPlaceholder: formatMessage((0, $epGyj.messages).starredSearchPlaceholder),
            searchable: forYou.starredIsSearchable,
            filters: forYou.starredFilters,
            viewAllHref: forYou.viewAllStarredUrl,
            viewAllOnClick: forYou.viewAllStarredOnClick
        }));
        return items;
    }, [
        forYou,
        formatMessage
    ]);
    const allNavItems = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>({
            ...Object.fromEntries(globalItems),
            ...items
        }), [
        globalItems,
        items
    ]);
    const renderNavItem = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((id)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $jRSFr.default), {
            item: allNavItems[id]
        }, id), [
        allNavItems
    ]);
    // todo: Move this to the outer context for customization data. We only need one.
    const sideNavMenuData = (0, $5uXOq.useMemo)(()=>{
        const navData = (0, $hMtBm.buildCustomizationDataShapes)(Object.keys(allNavItems), shortcuts ? Object.keys(shortcuts) : [], // All menu items are visible when there is no customization data
        disableItemCustomization ? [] : userMenuData);
        return {
            ...navData,
            setUserMenuData: setUserMenuData
        };
    }, [
        allNavItems,
        disableItemCustomization,
        setUserMenuData,
        shortcuts,
        userMenuData
    ]);
    const hydratedShortcuts = (0, $8c2TE.useGlobalShortcutsData)({
        shortcutsConfig: shortcuts,
        cloudId: cloudId,
        orgId: orgId,
        isShortcutsStatic: isShortcutsStatic
    });
    const shortcutItems = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        return sideNavMenuData.visibleShortcutMenuIds.reduce((acc, id)=>{
            const shortcut = hydratedShortcuts?.[id];
            if (shortcut) acc.push(shortcut);
            return acc;
        }, []);
    }, [
        hydratedShortcuts,
        sideNavMenuData.visibleShortcutMenuIds
    ]);
    const [peekedItemId, setPeekedItemId] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState(null);
    const postMain = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
        space: "space.100",
        children: [
            postItemsElem,
            shortcutItems.length ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3SCPg.default), {
                shortcutItems: shortcutItems,
                cloudId: cloudId,
                orgId: orgId,
                product: app,
                promoteSite: true,
                testId: (0, $26f817a0a0a7080d$export$ee2a9579670b9420),
                forceStatic: true
            }) : null,
            peekedItemId && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.Box), {
                testId: (0, $26f817a0a0a7080d$export$88dd4a9e4ffa4ec2),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jRSFr.default), {
                    item: allNavItems[peekedItemId],
                    peek: true
                }, peekedItemId)
            }),
            !disableItemCustomization && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jklcM.default), {
                items: allNavItems,
                shortcutItems: shortcuts,
                itemIds: sideNavMenuData.hiddenItemMenuIds,
                shortcutItemIds: sideNavMenuData.hiddenShortcutMenuIds,
                peekedItemId: peekedItemId,
                onPeek: setPeekedItemId
            }),
            postMainElem
        ]
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LkU5.SideNavDataProvider), {
        value: sideNavMenuData,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cbMlQ.SideNavigationLayout), {
            testId: props.testId ?? (0, $26f817a0a0a7080d$export$5678faf50a8e9276),
            preMainElem: topElem,
            postMainElem: postMain,
            bottomElem: bottomElem,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gSZmd.MenuList), {
                children: sideNavMenuData.visibleItemMenuIds.map(renderNavItem)
            })
        })
    });
}

});
parcelRegister("8c2TE", function(module, exports) {

$parcel$export(module.exports, "useGlobalShortcutsData", () => $2392801959cb1a19$export$bc8645ef40313f94);

var $5uXOq = parcelRequire("5uXOq");

var $gccSB = parcelRequire("gccSB");

var $8WHRG = parcelRequire("8WHRG");
var $ldxWh = parcelRequire("ldxWh");

var $aCYtG = parcelRequire("aCYtG");
const $2392801959cb1a19$export$bc8645ef40313f94 = ({ shortcutsConfig: shortcutsConfig, cloudId: cloudId, orgId: orgId, isShortcutsStatic: isShortcutsStatic })=>{
    const { buildURLAndFetchData: buildURLAndFetchData, status: status, productLinks: productLinks } = (0, $ldxWh.useBFFDataProvider)({
        request: {},
        cloudId: cloudId,
        orgId: orgId,
        forceStatic: isShortcutsStatic
    });
    // fetch the data from the bff if required
    (0, $5uXOq.useEffect)(()=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(shortcutsConfig) || isShortcutsStatic) return;
        const apsKeys = Object.values(shortcutsConfig).map((item)=>item.apsKey || '').filter((item)=>!!item);
        buildURLAndFetchData(apsKeys);
    }, [
        buildURLAndFetchData,
        shortcutsConfig,
        isShortcutsStatic
    ]);
    // associate shortcuts with the returned bff data
    const hydratedAppShortcuts = (0, $5uXOq.useMemo)(()=>{
        if (status === (0, $8WHRG.RequestStatus).COMPLETE && Object.keys(productLinks).length) {
            const entries = Object.entries(shortcutsConfig || {});
            return entries.reduce((acc, [key, value])=>{
                // if config does not need a data reference, just return the value
                if (!value.apsKey) {
                    acc[key] = value;
                    return acc;
                }
                // if config requires the bff to determine the data reference
                const productLink = productLinks[value.apsKey];
                if (productLink) {
                    const filteredProductLink = cloudId ? productLink.filter((0, $aCYtG.productLinksWorkspaceCloudIdFilter)(cloudId))[0] : productLink[0];
                    acc[key] = {
                        ...value,
                        url: filteredProductLink.url
                    };
                    return acc;
                }
                return acc;
            }, {});
        }
        return shortcutsConfig;
    }, [
        productLinks,
        status,
        shortcutsConfig,
        cloudId
    ]);
    return hydratedAppShortcuts;
};

});

parcelRegister("jRSFr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a9505478b0521d7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $jpyeI = parcelRequire("jpyeI");
var $cJFfS = parcelRequire("cJFfS");
var $1qQhw = parcelRequire("1qQhw");

var $mwgEH = parcelRequire("mwgEH");
var $lnznH = parcelRequire("lnznH");
var $cZa9B = parcelRequire("cZa9B");

var $jUDIz = parcelRequire("jUDIz");
var $17aWz = parcelRequire("17aWz");
var $lBNLs = parcelRequire("lBNLs");

var $8Skt9 = parcelRequire("8Skt9");
function $0a9505478b0521d7$export$2e2bcd8739ae039({ item: item, peek: peek = false }) {
    if (item.type === 'custom') // If the item is a custom item, render it directly
    // TODO: Add customizationHandlers prop when ready
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1qQhw.MenuListItem), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(item.Component, {
            isInMoreMenu: false,
            isPeeked: peek
        })
    });
    if (item.type === 'object-list-flyout') {
        const { type: type, isDefaultOpen: isDefaultOpen, ...objectListFlyoutProps } = item;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Skt9.ObjectListFlyout), {
            isDefaultOpen: peek || isDefaultOpen,
            ...objectListFlyoutProps
        });
    }
    const { children: children, testId: testId, type: type, ...rest } = item;
    switch(type){
        case 'link':
            // Typescript does not properly narrow the `rest` type here, so we need to use the `as` clause to cast it
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cJFfS.LinkMenuItem), {
                ...rest,
                testId: testId,
                children: children
            });
        case 'button':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jpyeI.ButtonMenuItem), {
                ...rest,
                testId: testId,
                children: children
            });
        case 'expand':
            {
                const { isDefaultExpanded: isDefaultExpanded, isExpanded: isExpanded, onExpansionToggle: onExpansionToggle, triggerLabel: triggerLabel, children: children, ...triggerProps } = item;
                return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $mwgEH.ExpandableMenuItem), {
                    isDefaultExpanded: peek || isDefaultExpanded,
                    isExpanded: isExpanded,
                    onExpansionToggle: onExpansionToggle,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cZa9B.ExpandableMenuItemTrigger), {
                            ...triggerProps,
                            testId: testId,
                            children: triggerLabel
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lnznH.ExpandableMenuItemContent), {
                            children: children
                        })
                    ]
                });
            }
        case 'flyout':
            {
                const { isDefaultOpen: isDefaultOpen, isOpen: isOpen, onOpenChange: onOpenChange, triggerLabel: triggerLabel, children: children, ...triggerProps } = item;
                return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $jUDIz.FlyoutMenuItem), {
                    isDefaultOpen: peek || isDefaultOpen,
                    isOpen: isOpen,
                    onOpenChange: onOpenChange,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lBNLs.FlyoutMenuItemTrigger), {
                            ...triggerProps,
                            testId: testId,
                            children: triggerLabel
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $17aWz.FlyoutMenuItemContent), {
                            children: children
                        })
                    ]
                });
            }
        default:
            return null;
    }
}

});
parcelRegister("8Skt9", function(module, exports) {

$parcel$export(module.exports, "ObjectListFlyout", () => $a3444d39cf7ff779$export$8c8993cce765101e);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");


var $2NMNM = parcelRequire("2NMNM");

var $jUDIz = parcelRequire("jUDIz");
var $17aWz = parcelRequire("17aWz");
var $lBNLs = parcelRequire("lBNLs");


var $cu69R = parcelRequire("cu69R");
function $a3444d39cf7ff779$export$8c8993cce765101e({ label: label, icon: icon, analyticsName: analyticsName, triggerRef: triggerRef, isDefaultOpen: isDefaultOpen, isOpen: isOpen, onOpenChange: onOpenChange, isSearchable: isSearchable = true, searchPlaceholder: searchPlaceholder, searchNoResultsElem: searchNoResultsElem, emptyElem: emptyElem, loadingElem: loadingElem, filterConfig: filterConfig, useItems: useItems, ItemComponent: ItemComponent, actions: actions, testId: testId }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isFlyoutOpen, setIsFlyoutOpen] = (0, $5uXOq.useState)(isDefaultOpen ?? false);
    (0, $5uXOq.useEffect)(()=>{
        if (isOpen !== undefined) setIsFlyoutOpen(isOpen);
    }, [
        isOpen
    ]);
    (0, $5uXOq.useEffect)(()=>{
        onOpenChange?.(isFlyoutOpen);
    }, [
        isFlyoutOpen,
        onOpenChange
    ]);
    const closeFlyout = (0, $5uXOq.useCallback)(()=>setIsFlyoutOpen(false), []);
    const toggleFlyout = (0, $5uXOq.useCallback)(()=>{
        createAnalyticsEvent({
            eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
            action: 'clicked',
            actionSubject: 'globalNavigation',
            actionSubjectId: 'objectListFlyoutTrigger',
            attributes: {
                name: analyticsName,
                isExpanding: !isOpen,
                component: 'ObjectListFlyout'
            }
        }).fire((0, $0ca1b1da8db82735$export$85183a312807388d));
        setIsFlyoutOpen((prev)=>!prev);
    }, [
        createAnalyticsEvent,
        analyticsName,
        isOpen
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $jUDIz.FlyoutMenuItem), {
        isOpen: isFlyoutOpen,
        onOpenChange: setIsFlyoutOpen,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lBNLs.FlyoutMenuItemTrigger), {
                ref: triggerRef,
                elemBefore: icon,
                onClick: toggleFlyout,
                testId: testId,
                children: label
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $17aWz.FlyoutMenuItemContent), {
                onClose: closeFlyout,
                containerTestId: testId && `${testId}-popup`,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cu69R.FlyoutContent), {
                    label: label,
                    isSearchable: isSearchable,
                    searchPlaceholder: searchPlaceholder,
                    searchNoResultsElem: searchNoResultsElem,
                    emptyElem: emptyElem,
                    loadingElem: loadingElem,
                    filterConfig: filterConfig,
                    useItems: useItems,
                    ItemComponent: ItemComponent,
                    actions: actions
                })
            })
        ]
    });
}

});
parcelRegister("cu69R", function(module, exports) {

$parcel$export(module.exports, "FlyoutContent", () => $c7b10bd18d1bbb81$export$46d57b20d2b1faa4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $l1N8i = parcelRequire("l1N8i");

var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $aAbfD = parcelRequire("aAbfD");
var $gSZmd = parcelRequire("gSZmd");
var $1FdfO = parcelRequire("1FdfO");
var $2CQvU = parcelRequire("2CQvU");

var $MHKc7 = parcelRequire("MHKc7");

var $grcga = parcelRequire("grcga");

var $kWg4e = parcelRequire("kWg4e");

var $9Qwl1 = parcelRequire("9Qwl1");

var $6NaMx = parcelRequire("6NaMx");

var $9hNll = parcelRequire("9hNll");

var $h72Gj = parcelRequire("h72Gj");

var $epXPG = parcelRequire("epXPG");

var $apuVo = parcelRequire("apuVo");
function $c7b10bd18d1bbb81$export$46d57b20d2b1faa4({ label: label, isSearchable: isSearchable = true, searchPlaceholder: searchPlaceholder, searchNoResultsElem: searchNoResultsElem, emptyElem: emptyElem, loadingElem: loadingElem, filterConfig: filterConfig, useItems: useItems, ItemComponent: ItemComponent, actions: actions }) {
    const [searchText, setSearchText] = (0, $5uXOq.useState)('');
    const [selectedFilters, setSelectedFilters] = (0, $5uXOq.useState)(filterConfig?.defaultSelected ?? []);
    const { sections: sections, hasMore: hasMore, loadMore: loadMore, isLoading: isLoading, error: error } = useItems(searchText, selectedFilters);
    const hasData = (0, $5uXOq.useMemo)(()=>!!sections?.length && sections.some(({ items: items })=>!!items.length), [
        sections
    ]);
    const isSearchingOrFiltering = searchText || selectedFilters.length;
    // show empty state if it does not have any data & it is not searching or filtering
    const isEmptyState = !hasData && !isSearchingOrFiltering;
    const showSearchAndFilterBar = isSearchable && !isLoading && !isEmptyState;
    const headerLabel = label && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($c7b10bd18d1bbb81$var$styles.heading),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
            size: "xsmall",
            as: "h2",
            children: label
        })
    });
    if (error) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            headerLabel,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6NaMx.ObjectListFlyoutErrorState), {
                errorDescription: error?.message
            })
        ]
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            headerLabel,
            showSearchAndFilterBar && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $apuVo.SearchAndFilterBar), {
                filterConfig: filterConfig,
                placeholder: searchPlaceholder,
                searchText: searchText,
                onSearchChange: setSearchText,
                selectedFilters: selectedFilters,
                onFilterChange: setSelectedFilters
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eZUJu.default), {
                maxHeight: 440,
                children: [
                    isLoading ? loadingElem ?? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9hNll.ObjectListFlyoutLoadingState), {}) : /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                        children: [
                            !hasData && (isSearchingOrFiltering ? searchNoResultsElem ?? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $epXPG.ObjectListFlyoutNoResultsState), {}) : emptyElem ?? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Qwl1.ObjectListFlyoutEmptyState), {})),
                            hasData && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9UCCQ.default), {
                                isScrollable: true,
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $grcga.InfiniteScrollView), {
                                    hasMore: hasMore,
                                    loadMore: loadMore,
                                    loader: loadingElem ?? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9hNll.ObjectListFlyoutLoadingState), {}),
                                    children: sections?.map((section, index)=>!!section?.items?.length && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $1FdfO.MenuSection), {
                                            children: [
                                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2CQvU.MenuSectionHeading), {
                                                    children: section.header
                                                }),
                                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gSZmd.MenuList), {
                                                    children: section?.items?.map((item, itemIndex)=>ItemComponent ? /*#__PURE__*/ (0, $2OMIu.jsx)(ItemComponent, {
                                                            ...item
                                                        }, `flyout-list-section-${index}-custom-item-${itemIndex}`) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h72Gj.MenuItem), {
                                                            ...item
                                                        }, `flyout-list-section-${index}-menu-item-${itemIndex}`))
                                                })
                                            ]
                                        }, index))
                                })
                            })
                        ]
                    }),
                    !!actions?.length && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aAbfD.Divider), {}),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kWg4e.ActionsList), {
                                items: actions
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
const $c7b10bd18d1bbb81$var$styles = {
    heading: "_1rjcu2gc _19bv12x7 _k48pmoej _1e0c1txw _4cvr1h6o"
};

});
parcelRegister("grcga", function(module, exports) {

$parcel$export(module.exports, "InfiniteScrollView", () => $33fb8919da90dd6c$export$cf3938cbf75fae22);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $33fb8919da90dd6c$export$cf3938cbf75fae22({ hasMore: hasMore, children: children, loader: loader, loadMore: loadMore }) {
    const loadMoreRef = (0, $5uXOq.useRef)(null);
    const fetchMoreCallback = (0, $5uXOq.useCallback)(([loadMoreEntry])=>{
        // Automatically load more data when our invisible "load more" div is within the viewport
        if (loadMoreEntry.isIntersecting && hasMore) loadMore?.();
    }, [
        loadMore,
        hasMore
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const intersectionObserver = new IntersectionObserver(fetchMoreCallback);
        if (loadMoreRef.current) intersectionObserver.observe(loadMoreRef.current);
        return ()=>{
            intersectionObserver.disconnect();
        };
    }, [
        loadMoreRef,
        fetchMoreCallback
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            children,
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                ref: loadMoreRef,
                "data-testid": "infinite-scroll-ref"
            }),
            hasMore && loader
        ]
    });
}

});

parcelRegister("kWg4e", function(module, exports) {

$parcel$export(module.exports, "ActionsList", () => $baf7b1c9d8e18f50$export$5a3594759df1bd02);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $jpyeI = parcelRequire("jpyeI");
var $cJFfS = parcelRequire("cJFfS");
var $gSZmd = parcelRequire("gSZmd");
function $baf7b1c9d8e18f50$export$5a3594759df1bd02({ items: items }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gSZmd.MenuList), {
        children: items.map(({ elemBefore: elemBefore, label: label, href: href, target: target, onClick: onClick }, index)=>href ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cJFfS.LinkMenuItem), {
                target: target,
                elemBefore: elemBefore,
                href: href,
                children: label
            }, `action-link-${index}`) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jpyeI.ButtonMenuItem), {
                elemBefore: elemBefore,
                onClick: onClick,
                children: label
            }, `action-button-${index}`))
    });
}

});

parcelRegister("9Qwl1", function(module, exports) {

$parcel$export(module.exports, "ObjectListFlyoutEmptyState", () => $832e3e24425d1d24$export$e3acd504d9f9ab4c);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $5qRwM = parcelRequire("5qRwM");

var $937xa = parcelRequire("937xa");

var $90xGW = parcelRequire("90xGW");

var $caAdz = parcelRequire("caAdz");
function $832e3e24425d1d24$export$e3acd504d9f9ab4c() {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $937xa.GlobalSideNavigationNoContent), {
        testId: "object-list-flyout--empty-state",
        renderImage: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5qRwM.default), {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($90xGW))),
                width: 96,
                alt: ""
            }),
        heading: formatMessage((0, $caAdz.default).emptyStateHeader),
        description: formatMessage((0, $caAdz.default).emptyStateDescription)
    });
}

});
parcelRegister("937xa", function(module, exports) {

$parcel$export(module.exports, "GlobalSideNavigationNoContent", () => $2756616b137a23fa$export$df7d386b8cf1e3c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hTEpF = parcelRequire("hTEpF");

var $5qRwM = parcelRequire("5qRwM");

var $cgL5K = parcelRequire("cgL5K");

var $dVNi0 = parcelRequire("dVNi0");

var $b4tI4 = parcelRequire("b4tI4");
const $2756616b137a23fa$var$styles = {
    textWrapper: "_195g1wug _p12fo8uj"
};
function $2756616b137a23fa$export$df7d386b8cf1e3c({ testId: testId = 'global-side-navigation--no-content', renderImage: renderImage = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5qRwM.default), {
        testId: "global-side-navigation--no-content-default-image",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($b4tI4))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($dVNi0))),
        width: 96,
        alt: ""
    }), heading: heading, description: description }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hTEpF.default), {
        testId: testId,
        renderImage: renderImage,
        header: heading,
        headingLevel: 3,
        headingSize: "xsmall",
        description: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $bwpsq.default)([
                $2756616b137a23fa$var$styles.textWrapper
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgL5K.default), {
                size: "small",
                color: "color.text.subtle",
                children: description
            })
        })
    });
}

});
parcelRegister("dVNi0", function(module, exports) {
module.exports = new URL("no-results-dark.5b9fe043.svg", import.meta.url).toString();

});

parcelRegister("b4tI4", function(module, exports) {
module.exports = new URL("no-results-light.aa2e1109.svg", import.meta.url).toString();

});


parcelRegister("90xGW", function(module, exports) {
module.exports = new URL("empty.bc8457e3.svg", import.meta.url).toString();

});

parcelRegister("caAdz", function(module, exports) {

$parcel$export(module.exports, "default", () => $0269d2caf4ab6b4e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $0269d2caf4ab6b4e$var$messages = (0, $7VHMR.defineMessages)({
    emptyStateHeader: {
        id: 'navigation-global-side-navigation.object-list-flyout.empty-state.header',
        defaultMessage: 'Nothing to see here!',
        description: 'Message for the header of the default empty state in the object list flyout'
    },
    emptyStateDescription: {
        id: 'navigation-global-side-navigation.object-list-flyout.empty-state.description',
        defaultMessage: "Once you visit, edit, or create projects, issues, boards, filters, and dashboards, they\u2019ll show up here.",
        description: 'Message for the description of the default empty state in the object list flyout'
    }
});
var $0269d2caf4ab6b4e$export$2e2bcd8739ae039 = $0269d2caf4ab6b4e$var$messages;

});


parcelRegister("6NaMx", function(module, exports) {

$parcel$export(module.exports, "ObjectListFlyoutErrorState", () => $e2596a8fa0dcc9a2$export$14c0b96b771b6c92);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $5qRwM = parcelRequire("5qRwM");

var $937xa = parcelRequire("937xa");

var $bkHof = parcelRequire("bkHof");

var $eWMFU = parcelRequire("eWMFU");

var $k777E = parcelRequire("k777E");
function $e2596a8fa0dcc9a2$export$14c0b96b771b6c92({ errorDescription: errorDescription }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $937xa.GlobalSideNavigationNoContent), {
        testId: "object-list-flyout--error-state",
        renderImage: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5qRwM.default), {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($eWMFU))),
                srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($bkHof))),
                width: 96,
                alt: ""
            }),
        heading: formatMessage((0, $k777E.default).errorStateHeader),
        description: errorDescription ?? formatMessage((0, $k777E.default).errorStateDescription)
    });
}

});
parcelRegister("bkHof", function(module, exports) {
module.exports = new URL("error-state-dark.6e485691.svg", import.meta.url).toString();

});

parcelRegister("eWMFU", function(module, exports) {
module.exports = new URL("error-state-light.84cd22a3.svg", import.meta.url).toString();

});

parcelRegister("k777E", function(module, exports) {

$parcel$export(module.exports, "default", () => $36406231ed4561f7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $36406231ed4561f7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorStateHeader: {
        id: 'navigation-global-side-navigation.object-list-flyout.error-state.header',
        defaultMessage: "We couldn't fetch your items",
        description: 'Default heading for an error state in the object list flyout'
    },
    errorStateDescription: {
        id: 'navigation-global-side-navigation.object-list-flyout.error-state.description',
        defaultMessage: 'Refresh the page and try again.',
        description: 'Default description for an error state in the object list flyout; shown if an error reason is not provided'
    }
});

});


parcelRegister("9hNll", function(module, exports) {

$parcel$export(module.exports, "ObjectListFlyoutLoadingState", () => $26cc4e90cba9a4ec$export$965970fdddf57f67);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $1DVhQ = parcelRequire("1DVhQ");

var $jldZL = parcelRequire("jldZL");

var $jfvje = parcelRequire("jfvje");
function $26cc4e90cba9a4ec$export$965970fdddf57f67() {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": "object-list-flyout--loading-state",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                role: "status",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jldZL.default), {
                    children: formatMessage((0, $jfvje.default).loadingStateAccessibleName)
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                className: (0, $bwpsq.default)([
                    $26cc4e90cba9a4ec$var$loadingStateStyles.wrapper
                ]),
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1DVhQ.default), {
                        width: "100%",
                        height: 8
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1DVhQ.default), {
                        width: "100%",
                        height: 8
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1DVhQ.default), {
                        width: "100%",
                        height: 8
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1DVhQ.default), {
                        width: "100%",
                        height: 8
                    })
                ]
            })
        ]
    });
}
const $26cc4e90cba9a4ec$var$loadingStateStyles = {
    wrapper: "_zulpxy5q _1rjcxy5q _18zr1b66 _1e0c1txw _2lx21bp4 _6rthu2gc"
};

});
parcelRegister("jfvje", function(module, exports) {

$parcel$export(module.exports, "default", () => $395ad62c3c69e3d3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $395ad62c3c69e3d3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    loadingStateAccessibleName: {
        id: 'navigation-global-side-navigation.object-list-flyout.loading-state.accessible-name',
        defaultMessage: 'Content is loading',
        description: 'Accessible name for the loading state in the object list flyout'
    }
});

});


parcelRegister("h72Gj", function(module, exports) {

$parcel$export(module.exports, "MenuItem", () => $fe1966b0e4fb2492$export$2ce376c2cc3355c8);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");


var $c543i = parcelRequire("c543i");

var $jpyeI = parcelRequire("jpyeI");
var $cJFfS = parcelRequire("cJFfS");

function $fe1966b0e4fb2492$export$2ce376c2cc3355c8({ href: href, target: target, onClick: onClick, elemBefore: elemBefore, elemAfter: elemAfter, primaryLabel: primaryLabel, secondaryLabel: secondaryLabel, tertiaryLabel: tertiaryLabel }) {
    const description = secondaryLabel ? `${secondaryLabel}${tertiaryLabel ? ` \u{2022} ${tertiaryLabel}` : ''}` : undefined;
    const commonProps = {
        elemBefore: elemBefore,
        elemAfter: elemAfter,
        description: description
    };
    const onButtonClick = (0, $c543i.useCallbackWithAnalytics)((event)=>onClick?.(event), {
        eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'globalNavigation'
    }, (0, $0ca1b1da8db82735$export$85183a312807388d));
    const onLinkClick = (0, $c543i.useCallbackWithAnalytics)((event)=>onClick?.(event), {
        eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
        action: 'clicked',
        actionSubject: 'link',
        actionSubjectId: 'globalNavigation'
    }, (0, $0ca1b1da8db82735$export$85183a312807388d));
    if (href) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cJFfS.LinkMenuItem), {
        ...commonProps,
        href: href,
        target: target,
        onClick: onLinkClick,
        children: primaryLabel
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jpyeI.ButtonMenuItem), {
        ...commonProps,
        onClick: onButtonClick,
        children: primaryLabel
    });
}

});

parcelRegister("epXPG", function(module, exports) {

$parcel$export(module.exports, "ObjectListFlyoutNoResultsState", () => $aa90bf0fbe89afb4$export$2843d1b07a542752);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $5qRwM = parcelRequire("5qRwM");

var $937xa = parcelRequire("937xa");

var $grXkU = parcelRequire("grXkU");

var $f3PAG = parcelRequire("f3PAG");

var $ydeMc = parcelRequire("ydeMc");
function $aa90bf0fbe89afb4$export$2843d1b07a542752() {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $937xa.GlobalSideNavigationNoContent), {
        testId: "object-list-flyout--no-results-state",
        renderImage: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5qRwM.default), {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($f3PAG))),
                srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($grXkU))),
                width: 96,
                alt: ""
            }),
        heading: formatMessage((0, $ydeMc.default).noResultsStateHeader),
        description: formatMessage((0, $ydeMc.default).noResultsStateDescription)
    });
}

});
parcelRegister("grXkU", function(module, exports) {
module.exports = new URL("no-results-dark.5b9fe043.svg", import.meta.url).toString();

});

parcelRegister("f3PAG", function(module, exports) {
module.exports = new URL("no-results-light.aa2e1109.svg", import.meta.url).toString();

});

parcelRegister("ydeMc", function(module, exports) {

$parcel$export(module.exports, "default", () => $45a2262dce90c297$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $45a2262dce90c297$var$messages = (0, $7VHMR.defineMessages)({
    noResultsStateHeader: {
        id: 'navigation-global-side-navigation.object-list-flyout.empty-state.header',
        defaultMessage: 'No results',
        description: 'Message for the header of the default no search results state in the object list flyout.'
    },
    noResultsStateDescription: {
        id: 'navigation-global-side-navigation.object-list-flyout.empty-state.description',
        defaultMessage: "We couldn\u2019t find what you\u2019re looking for.",
        description: 'Message for the description of the default no search results state in the object list flyout.'
    }
});
var $45a2262dce90c297$export$2e2bcd8739ae039 = $45a2262dce90c297$var$messages;

});


parcelRegister("apuVo", function(module, exports) {

$parcel$export(module.exports, "SearchAndFilterBar", () => $b7c9ee1378ecbcfa$export$4ca90ad9372e272b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $42CjB = parcelRequire("42CjB");

var $i28qQ = parcelRequire("i28qQ");

var $jX361 = parcelRequire("jX361");

var $hyOJh = parcelRequire("hyOJh");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
var $414Wj = parcelRequire("414Wj");

var $kY99m = parcelRequire("kY99m");

var $5vQtb = parcelRequire("5vQtb");

var $iQC28 = parcelRequire("iQC28");

var $c3pG9 = parcelRequire("c3pG9");

var $a9XYw = parcelRequire("a9XYw");
function $b7c9ee1378ecbcfa$export$4ca90ad9372e272b({ filterConfig: filterConfig, placeholder: placeholder, searchText: searchText, selectedFilters: selectedFilters, onSearchChange: onSearchChange, onFilterChange: onFilterChange, testId: testId }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const showFilters = !!filterConfig?.filters?.length;
    const showSelectedFilters = showFilters && !!selectedFilters?.length;
    const entryPointProps = (0, $5uXOq.useMemo)(()=>showFilters && {
            filterConfig: filterConfig,
            selectedFilters: selectedFilters,
            onFilterChange: onFilterChange
        }, [
        showFilters,
        filterConfig,
        selectedFilters,
        onFilterChange
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
        xcss: $b7c9ee1378ecbcfa$var$styles.searchBox,
        space: "space.075",
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kY99m.default), {
                        isCompact: true,
                        placeholder: placeholder ?? formatMessage((0, $c3pG9.messages).searchPlaceholder),
                        value: searchText,
                        onChange: (e)=>onSearchChange(e.currentTarget.value),
                        elemBeforeInput: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            xcss: $b7c9ee1378ecbcfa$var$styles.searchIcon,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hyOJh))), {
                                label: ""
                            })
                        }),
                        elemAfterInput: searchText && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            xcss: $b7c9ee1378ecbcfa$var$styles.searchCancelIcon,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                                label: formatMessage((0, $c3pG9.messages).clearSearchIconLabel),
                                icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i28qQ))), {
                                        ...iconProps,
                                        size: "small"
                                    }),
                                onClick: ()=>onSearchChange(''),
                                spacing: "compact"
                            })
                        })
                    }),
                    !!entryPointProps && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5vQtb.DropdownTrigger), {
                        entryPoint: (0, $iQC28.filtersDropdownEntryPoint),
                        entryPointProps: entryPointProps,
                        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                                ...props,
                                label: formatMessage((0, $c3pG9.messages).filterIconLabel),
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($jX361))),
                                isDisabled: filterConfig?.isDisabled,
                                ref: triggerRef
                            }),
                        placement: "right-start",
                        strategy: "absolute"
                    })
                ]
            }),
            showSelectedFilters && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a9XYw.SelectedFiltersRow), {
                filterConfig: filterConfig,
                selectedFilters: selectedFilters,
                onFilterChange: onFilterChange
            })
        ]
    });
}
const $b7c9ee1378ecbcfa$var$styles = {
    searchBox: "_18zr1b66 _1rjc12x7",
    searchIcon: "_bozg12x7 _y4tiv77o _85i5v77o _1e0c1txw _4cvr1h6o",
    searchCancelIcon: "_y4ti1b66"
};

});
parcelRegister("5vQtb", function(module, exports) {

$parcel$export(module.exports, "DropdownTrigger", () => $30587adcb3b7dd0a$export$e7eb525bc415b4b4);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $bWn3s = parcelRequire("bWn3s");

var $eCeGD = parcelRequire("eCeGD");

var $BLPHT = parcelRequire("BLPHT");

var $kEVMo = parcelRequire("kEVMo");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $7F2yO = parcelRequire("7F2yO");

var $kKgGa = parcelRequire("kKgGa");

var $e2pRJ = parcelRequire("e2pRJ");
const $30587adcb3b7dd0a$var$emptyEntryPointParams = {};
const $30587adcb3b7dd0a$var$emptyEntryPointProps = {};
function $30587adcb3b7dd0a$export$e7eb525bc415b4b4({ trigger: trigger, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, fallback: fallback, errorFallback: errorFallback, onError: onError, ...dropdownProps }) {
    const environmentProvider = (0, $e2pRJ.useRelayEnvironmentProvider)();
    const id = (0, $5uXOq.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const [children, setChildren] = (0, $5uXOq.useState)(null);
    const handleOpenChange = (0, $5uXOq.useCallback)(({ isOpen: isOpen })=>{
        setIsOpen(isOpen);
    }, []);
    const load = (0, $5uXOq.useCallback)(()=>(0, $8Uumt.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $30587adcb3b7dd0a$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $5uXOq.useCallback)(({ reference: entryPointReference })=>{
        // avoid re-loading entry-point when closing popup
        if (isOpen) return;
        setChildren(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kKgGa.InternalEntryPointContainer), {
            id: id,
            entryPointReference: entryPointReference,
            fallback: fallback || /*#__PURE__*/ (0, $2OMIu.jsx)($30587adcb3b7dd0a$var$LoadingState, {}),
            errorFallback: errorFallback,
            runtimeProps: entryPointProps || $30587adcb3b7dd0a$var$emptyEntryPointProps,
            onError: onError
        }));
    }, [
        setChildren,
        id,
        isOpen,
        entryPointProps,
        fallback,
        errorFallback,
        onError
    ]);
    const triggerRef = (0, $7F2yO.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad
    });
    const popupTrigger = (0, $5uXOq.useCallback)((triggerProps)=>{
        const mergedRef = (0, $bWn3s.mergeRefs)([
            triggerRef,
            triggerProps.triggerRef
        ]);
        if (typeof trigger === 'string') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
            ...triggerProps,
            ref: mergedRef,
            isSelected: isOpen,
            iconAfter: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kEVMo))), {
                    ...iconProps,
                    size: "small"
                }),
            testId: dropdownProps.testId && `${dropdownProps.testId}--trigger`,
            "aria-label": dropdownProps.label,
            children: trigger
        });
        return trigger({
            ...triggerProps,
            ref: mergedRef,
            triggerRef: mergedRef
        });
    }, [
        trigger,
        triggerRef,
        isOpen,
        dropdownProps.label,
        dropdownProps.testId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $BLPHT.default), {
        ...dropdownProps,
        onOpenChange: handleOpenChange,
        trigger: popupTrigger,
        shouldFitContainer: (0, $VSDnB.fg)('should-render-to-parent-should-be-true-uip-applica') ? false : undefined,
        shouldRenderToParent: (0, $VSDnB.fg)('should-render-to-parent-should-be-true-uip-applica'),
        children: children
    });
}
const $30587adcb3b7dd0a$var$spinnerContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
function $30587adcb3b7dd0a$var$LoadingState() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        xcss: $30587adcb3b7dd0a$var$spinnerContainerStyles,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
            size: "small"
        })
    });
}

});

parcelRegister("iQC28", function(module, exports) {

$parcel$export(module.exports, "filtersDropdownEntryPoint", () => $17df5a6800fdce3d$export$f08e79701452c6d0);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $17df5a6800fdce3d$export$f08e79701452c6d0 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(// eslint-disable-next-line import/dynamic-import-chunkname
    ()=>(parcelRequire("64db6")), {
        moduleId: "da94d1b1",
        priority: "interaction",
        moduleId: 'filtersDropdownEntryPoint'
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("64db6", function(module, exports) {

let $46ad56aa06b8c79d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $46ad56aa06b8c79d$var$load("hHP7V").then(()=>parcelRequire('hia73'));

});


parcelRegister("c3pG9", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e33a580aca78107a$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $e33a580aca78107a$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    searchPlaceholder: {
        id: 'navigation.global-side-navigation.object-list-flyout.searchPlaceholder',
        defaultMessage: 'Search...',
        description: 'Default placeholder text for the search input'
    },
    clearSearchIconLabel: {
        id: 'navigation.global-side-navigation.object-list-flyout.clearSearchIconLabel',
        defaultMessage: 'Clear search',
        description: 'Label for clear icon in search input'
    },
    filterIconLabel: {
        id: 'navigation.global-side-navigation.object-list-flyout.filterIconLabel',
        defaultMessage: 'Filters',
        description: 'Label for filters icon in search bar'
    },
    selectedFiltersVisualLabel: {
        id: 'navigation.global-side-navigation.object-list-flyout.selectedFilters',
        defaultMessage: 'Selected: ',
        description: 'Visual label for the selected filters. Shown before an interactive tag list component that shows a tag for each selected filter.'
    },
    selectedFiltersAccessibleLabel: {
        id: 'navigation.global-side-navigation.object-list-flyout.selectedFilters',
        defaultMessage: 'Selected filters',
        description: 'Label for the selected filters group, used for assistive technologies'
    },
    removeFilterIconLabel: {
        id: 'navigation.global-side-navigation.object-list-flyout.removeFilterIconLabel',
        defaultMessage: 'Remove',
        description: 'Label for remove icon in selected filter tag'
    }
});

});

parcelRegister("a9XYw", function(module, exports) {

$parcel$export(module.exports, "SelectedFiltersRow", () => $c2d44bf67ffbc7f7$export$3fa2ab8d6c4cc7db);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $c0aEF = parcelRequire("c0aEF");
var $dS3PR = parcelRequire("dS3PR");

var $9laXL = parcelRequire("9laXL");

var $6UXEc = parcelRequire("6UXEc");

var $c3pG9 = parcelRequire("c3pG9");
function $c2d44bf67ffbc7f7$export$3fa2ab8d6c4cc7db({ filterConfig: filterConfig, selectedFilters: selectedFilters, onFilterChange: onFilterChange }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { filters: filters } = filterConfig;
    const removeFilter = (0, $5uXOq.useCallback)((key)=>{
        const newFilters = selectedFilters.filter((filter)=>filter !== key);
        onFilterChange(newFilters);
        // return truthy value to remove tag
        return true;
    }, [
        onFilterChange,
        selectedFilters
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
        space: "space.050",
        alignBlock: "center",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                    xcss: $c2d44bf67ffbc7f7$var$styles.filterSelectedLabel,
                    children: formatMessage((0, $c3pG9.messages).selectedFiltersVisualLabel)
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6UXEc.default), {
                label: formatMessage((0, $c3pG9.messages).selectedFiltersAccessibleLabel),
                children: selectedFilters.map((filterKey)=>{
                    const filterLabel = filters?.find((filterItem)=>filterItem.key === filterKey)?.label;
                    return filterLabel ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9laXL.default), {
                        text: filterLabel,
                        removeButtonLabel: formatMessage((0, $c3pG9.messages).removeFilterIconLabel),
                        onBeforeRemoveAction: ()=>removeFilter(filterKey)
                    }, filterKey) : null;
                })
            })
        ]
    });
}
const $c2d44bf67ffbc7f7$var$styles = {
    filterSelectedLabel: "_1i4q4jg8"
};

});
parcelRegister("9laXL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d63a49f20b6f0a05$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $c543i = parcelRequire("c543i");

var $5JjdN = parcelRequire("5JjdN");

var $eGmKJ = parcelRequire("eGmKJ");

var $35XSW = parcelRequire("35XSW");
var $lM16U = parcelRequire("lM16U");

var $VSDnB = parcelRequire("VSDnB");

var $2hnSR = parcelRequire("2hnSR");

var $5oSQr = parcelRequire("5oSQr");

var $aXLIT = parcelRequire("aXLIT");

var $eYXIO = parcelRequire("eYXIO");

var $frUcV = parcelRequire("frUcV");
const $d63a49f20b6f0a05$var$textLinkCssVar = '--ds-ctl';
const $d63a49f20b6f0a05$var$textDefaultCssVar = '--ds-ct';
const $d63a49f20b6f0a05$var$textActiveCssVar = '--ds-ctp';
const $d63a49f20b6f0a05$var$backgroundHoverCssVar = '--ds-cbh';
const $d63a49f20b6f0a05$var$backgroundActiveCssVar = '--ds-cba';
var $d63a49f20b6f0a05$var$TagStatus = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}($d63a49f20b6f0a05$var$TagStatus || {});
const $d63a49f20b6f0a05$var$packageName = "platform-pkg";
const $d63a49f20b6f0a05$var$packageVersion = "0.0.0-use.local";
const $d63a49f20b6f0a05$var$defaultBeforeRemoveAction = ()=>true; /**
                                               * These hide the focus ring for the tag when its remove button is focused,
                                               * preventing a double focus ring.
                                               */ 
const $d63a49f20b6f0a05$var$removingStyles = null;
const $d63a49f20b6f0a05$var$RemovableTagComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, removeButtonLabel: removeButtonLabel, testId: testId, onBeforeRemoveAction: onBeforeRemoveAction = $d63a49f20b6f0a05$var$defaultBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction = (0, $eGmKJ.default), linkComponent: linkComponent }, ref)=>{
    const [status, setStatus] = (0, $5uXOq.useState)("showing");
    const [isHoverCloseButton, setIsHoverCloseButton] = (0, $5uXOq.useState)(false);
    const onAfterRemoveActionWithAnalytics = (0, $c543i.useCallbackWithAnalytics)(onAfterRemoveAction, {
        action: 'removed',
        actionSubject: 'tag',
        attributes: {
            componentName: 'tag',
            packageName: $d63a49f20b6f0a05$var$packageName,
            packageVersion: $d63a49f20b6f0a05$var$packageVersion
        }
    }, 'atlaskit');
    const handleRemoveComplete = (0, $5uXOq.useCallback)(()=>{
        onAfterRemoveActionWithAnalytics(text);
        setStatus("removed");
    }, [
        onAfterRemoveActionWithAnalytics,
        text
    ]);
    const handleRemoveRequest = (0, $5uXOq.useCallback)(()=>{
        if (onBeforeRemoveAction && onBeforeRemoveAction()) handleRemoveComplete();
    }, [
        handleRemoveComplete,
        onBeforeRemoveAction
    ]);
    const onKeyPress = (0, $5uXOq.useCallback)((e)=>{
        const spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    const removingTag = (0, $5uXOq.useCallback)(()=>setStatus("removing"), []);
    const showingTag = (0, $5uXOq.useCallback)(()=>setStatus("showing"), []);
    const handleMouseOver = (0, $5uXOq.useCallback)(()=>setIsHoverCloseButton(true), []);
    const handleMouseOut = (0, $5uXOq.useCallback)(()=>setIsHoverCloseButton(false), []);
    const removeButton = isRemovable ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $frUcV.default), {
        "aria-label": `${removeButtonLabel || 'Remove'} ${text}`,
        onClick: handleRemoveRequest,
        onFocus: removingTag,
        onBlur: showingTag,
        onKeyPress: onKeyPress,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        testId: `close-button-${testId}`
    }) : undefined;
    const content = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eYXIO.default), {
        elemBefore: elemBefore,
        isRemovable: isRemovable,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    const hoverCloseButtonColors = {
        backgroundColor: (0, $VSDnB.fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle, #00000000)" : undefined,
        // Tag background color on hover
        [$d63a49f20b6f0a05$var$backgroundHoverCssVar]: (0, $VSDnB.fg)('platform-component-visual-refresh') ? undefined : (0, $2hnSR.removalHoverBackgroundColors),
        // Tag background color on press
        [$d63a49f20b6f0a05$var$backgroundActiveCssVar]: (0, $VSDnB.fg)('platform-component-visual-refresh') ? undefined : (0, $2hnSR.removalActiveBackgroundColors),
        // The tag text on hover of remove button
        [$d63a49f20b6f0a05$var$textDefaultCssVar]: (0, $VSDnB.fg)('platform-component-visual-refresh') ? undefined : (0, $2hnSR.removalTextColors),
        // 'elemBefore' text on press of remove button
        [$d63a49f20b6f0a05$var$textActiveCssVar]: (0, $VSDnB.fg)('platform-component-visual-refresh') ? undefined : (0, $2hnSR.removalTextColors),
        // The tag link text on hover of remove button
        [$d63a49f20b6f0a05$var$textLinkCssVar]: (0, $VSDnB.fg)('platform-component-visual-refresh') ? undefined : (0, $2hnSR.removalTextColors)
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $35XSW.default), {
        children: !(status === "removed") && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lM16U.default), {
            children: (motion)=>{
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5oSQr.default), {
                    ref: (0, $5JjdN.default)([
                        motion.ref,
                        ref
                    ]),
                    appearance: appearance,
                    color: color,
                    testId: testId,
                    style: isHoverCloseButton ? hoverCloseButtonColors : undefined,
                    "data-removable": true,
                    "data-removing": status === "removing",
                    "data-ishoverclosebutton": isHoverCloseButton,
                    href: href,
                    before: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aXLIT.default), {
                        elemBefore: elemBefore
                    }),
                    contentElement: content,
                    after: removeButton,
                    className: (0, $bwpsq.default)([
                        status === "removing" && "_z30c1r31 _twwiglyw _1pka1o36 _bqht1nip"
                    ])
                });
            }
        })
    });
});
/**
 * __Removable tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * Once a tag has been removed, it cannot be re-rendered. Removable tags are visible in "edit" mode or in multi-select controls.
 *
 */ const $d63a49f20b6f0a05$var$RemovableTag = /*#__PURE__*/ (0, $5uXOq.memo)($d63a49f20b6f0a05$var$RemovableTagComponent);
var $d63a49f20b6f0a05$export$2e2bcd8739ae039 = $d63a49f20b6f0a05$var$RemovableTag;

});
parcelRegister("lM16U", function(module, exports) {

$parcel$export(module.exports, "default", () => $c624c149830103aa$export$2e2bcd8739ae039);

var $lObw7 = parcelRequire("lObw7");

var $bh8Xz = parcelRequire("bh8Xz");

var $3GP8X = parcelRequire("3GP8X");

var $fsENI = parcelRequire("fsENI");

var $35XSW = parcelRequire("35XSW");
/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $c624c149830103aa$var$ShrinkOut = ({ children: children, duration: duration = 'small', onFinish: onFinish })=>{
    const [element, setElementRef] = (0, $3GP8X.useElementRef)();
    const exiting = (0, $35XSW.useExitingPersistence)();
    const requestAnimationFrame = (0, $bh8Xz.useRequestAnimationFrame)();
    const setTimeout = (0, $bh8Xz.useSetTimeout)();
    const direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $fsENI.useLayoutEffect)(()=>{
        if (exiting.isExiting && element) {
            const newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: `${element.offsetWidth}px`,
                height: `${element.offsetHeight}px`,
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    const newStyles = {
                        width: '0px',
                        margin: '0px',
                        transitionTimingFunction: 'cubic-bezier(0.8,0,0,0.8)',
                        transitionDuration: (0, $lObw7.durations)[duration] + 'ms',
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(()=>{
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, (0, $lObw7.durations)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $c624c149830103aa$export$2e2bcd8739ae039 = $c624c149830103aa$var$ShrinkOut;

});
parcelRegister("3GP8X", function(module, exports) {

$parcel$export(module.exports, "useElementRef", () => $19cc13cbd0e78f53$export$ff879f35a69d56b7);

var $5uXOq = parcelRequire("5uXOq");
const $19cc13cbd0e78f53$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $5uXOq.useRef)(null);
    const setRef = (0, $5uXOq.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

});


parcelRegister("2hnSR", function(module, exports) {

$parcel$export(module.exports, "textColors", () => $5b444d8505b9cc3c$export$daa0ace263cb20d2);
$parcel$export(module.exports, "borderColors", () => $5b444d8505b9cc3c$export$1c1b571cf296eca7);
$parcel$export(module.exports, "textHoverColors", () => $5b444d8505b9cc3c$export$7c7104a5f052cab7);
$parcel$export(module.exports, "textActiveColors", () => $5b444d8505b9cc3c$export$382469baad253eb7);
$parcel$export(module.exports, "backgroundColors", () => $5b444d8505b9cc3c$export$b9d7c59a579c23c6);
$parcel$export(module.exports, "linkHoverBackgroundColors", () => $5b444d8505b9cc3c$export$4410079763249c74);
$parcel$export(module.exports, "linkActiveBackgroundColors", () => $5b444d8505b9cc3c$export$76be99c5e13e3566);
$parcel$export(module.exports, "focusRingColors", () => $5b444d8505b9cc3c$export$2a31dbe82788f940);
$parcel$export(module.exports, "removalHoverBackgroundColors", () => $5b444d8505b9cc3c$export$1202b7eb21da7b58);
$parcel$export(module.exports, "removalActiveBackgroundColors", () => $5b444d8505b9cc3c$export$62ace793ebb16bda);
$parcel$export(module.exports, "removalTextColors", () => $5b444d8505b9cc3c$export$17d206ccea111bbb);
$parcel$export(module.exports, "removeButtonColors", () => $5b444d8505b9cc3c$export$f64c7641cbc22da7);
$parcel$export(module.exports, "removeButtonHoverColors", () => $5b444d8505b9cc3c$export$b03fbc2a369c563e);
// Text colors
const $5b444d8505b9cc3c$export$daa0ace263cb20d2 = {
    standard: "var(--ds-text, #253858)",
    standardLink: "var(--ds-link, #0052CC)",
    blue: "var(--ds-text-accent-blue-bolder, #172B4D)",
    red: "var(--ds-text-accent-red-bolder, #172B4D)",
    yellow: "var(--ds-text-accent-yellow-bolder, #172B4D)",
    green: "var(--ds-text-accent-green-bolder, #172B4D)",
    teal: "var(--ds-text-accent-teal-bolder, #172B4D)",
    purple: "var(--ds-text-accent-purple-bolder, #172B4D)",
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: "var(--ds-text-accent-gray-bolder, #FFFFFF)",
    blueLight: "var(--ds-text-accent-blue, #0747A6)",
    redLight: "var(--ds-text-accent-red, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow, #42526E)",
    greenLight: "var(--ds-text-accent-green, #006644)",
    tealLight: "var(--ds-text-accent-teal, #42526E)",
    purpleLight: "var(--ds-text-accent-purple, #403294)",
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: "var(--ds-text-accent-gray, #42526E)"
};
const $5b444d8505b9cc3c$export$1c1b571cf296eca7 = {
    standard: '#B7B9BE',
    blue: '#669DF1',
    red: '#F87168',
    yellow: '#DDB30E',
    green: '#4BCE97',
    teal: '#6CC3E0',
    purple: '#C97CF4',
    lime: '#94C748',
    magenta: '#E774BB',
    orange: '#FCA700',
    grey: '#B7B9BE',
    standardLink: '#B7B9BE',
    blueLight: '#669DF1',
    redLight: '#F87168',
    yellowLight: '#DDB30E',
    greenLight: '#4BCE97',
    tealLight: '#6CC3E0',
    purpleLight: '#C97CF4',
    limeLight: '#94C748',
    magentaLight: '#E774BB',
    orangeLight: '#FCA700',
    greyLight: '#B7B9BE'
};
const $5b444d8505b9cc3c$export$7c7104a5f052cab7 = {
    standard: "var(--ds-link, #0065FF)",
    blue: "var(--ds-text-accent-blue-bolder, #172B4D)",
    red: "var(--ds-text-accent-red-bolder, #172B4D)",
    yellow: "var(--ds-text-accent-yellow-bolder, #172B4D)",
    green: "var(--ds-text-accent-green-bolder, #172B4D)",
    teal: "var(--ds-text-accent-teal-bolder, #172B4D)",
    purple: "var(--ds-text-accent-purple-bolder, #172B4D)",
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: "var(--ds-text-accent-gray-bolder, #FFFFFF)",
    blueLight: "var(--ds-text-accent-blue, #0747A6)",
    redLight: "var(--ds-text-accent-red, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow, #42526E)",
    greenLight: "var(--ds-text-accent-green, #006644)",
    tealLight: "var(--ds-text-accent-teal, #42526E)",
    purpleLight: "var(--ds-text-accent-purple, #403294)",
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: "var(--ds-text-accent-gray, #42526E)"
};
const $5b444d8505b9cc3c$export$382469baad253eb7 = {
    standard: "var(--ds-link-pressed, #0065FF)",
    blue: "var(--ds-text-accent-blue, #172B4D)",
    red: "var(--ds-text-accent-red, #172B4D)",
    yellow: "var(--ds-text-accent-yellow, #172B4D)",
    green: "var(--ds-text-accent-green, #172B4D)",
    teal: "var(--ds-text-accent-teal, #172B4D)",
    purple: "var(--ds-text-accent-purple, #172B4D)",
    lime: "var(--ds-text-accent-lime, #4C6B1F)",
    magenta: "var(--ds-text-accent-magenta, #943D73)",
    orange: "var(--ds-text-accent-orange, #974F0C)",
    grey: "var(--ds-text-accent-gray, #FFFFFF)",
    blueLight: "var(--ds-text-accent-blue-bolder, #0747A6)",
    redLight: "var(--ds-text-accent-red-bolder, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow-bolder, #42526E)",
    greenLight: "var(--ds-text-accent-green-bolder, #006644)",
    tealLight: "var(--ds-text-accent-teal-bolder, #42526E)",
    purpleLight: "var(--ds-text-accent-purple-bolder, #403294)",
    limeLight: "var(--ds-text-accent-lime-bolder, #37471F)",
    magentaLight: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orangeLight: "var(--ds-text-accent-orange-bolder, #5F3811)",
    greyLight: "var(--ds-text-accent-gray-bolder, #42526E)"
};
const $5b444d8505b9cc3c$export$b9d7c59a579c23c6 = {
    standard: "var(--ds-background-neutral, #F4F5F7)",
    blue: "var(--ds-background-accent-blue-subtle, #4C9AFF)",
    red: "var(--ds-background-accent-red-subtle, #FF8F73)",
    yellow: "var(--ds-background-accent-yellow-subtle, #FFC400)",
    green: "var(--ds-background-accent-green-subtle, #57D9A3)",
    teal: "var(--ds-background-accent-teal-subtle, #00C7E6)",
    purple: "var(--ds-background-accent-purple-subtle, #998DD9)",
    lime: "var(--ds-background-accent-lime-subtle, #94C748)",
    magenta: "var(--ds-background-accent-magenta-subtle, #E774BB)",
    orange: "var(--ds-background-accent-orange-subtle, #FAA53D)",
    grey: "var(--ds-background-accent-gray-subtle, #42526E)",
    blueLight: "var(--ds-background-accent-blue-subtler, #B3D4FF)",
    redLight: "var(--ds-background-accent-red-subtler, #FFBDAD)",
    yellowLight: "var(--ds-background-accent-yellow-subtler, #FFE380)",
    greenLight: "var(--ds-background-accent-green-subtler, #79F2C0)",
    tealLight: "var(--ds-background-accent-teal-subtler, #79E2F2)",
    purpleLight: "var(--ds-background-accent-purple-subtler, #C0B6F2)",
    limeLight: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    magentaLight: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    orangeLight: "var(--ds-background-accent-orange-subtler, #FFE2BD)",
    greyLight: "var(--ds-background-accent-gray-subtler, #EBECF0)"
};
const $5b444d8505b9cc3c$export$4410079763249c74 = {
    standard: "var(--ds-background-neutral-hovered, #EBECF0)",
    blue: "var(--ds-background-accent-blue-subtle-hovered, #B3D4FF)",
    red: "var(--ds-background-accent-red-subtle-hovered, #FFBDAD)",
    yellow: "var(--ds-background-accent-yellow-subtle-hovered, #FFE380)",
    green: "var(--ds-background-accent-green-subtle-hovered, #79F2C0)",
    teal: "var(--ds-background-accent-teal-subtle-hovered, #79E2F2)",
    purple: "var(--ds-background-accent-purple-subtle-hovered, #C0B6F2)",
    lime: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    magenta: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    orange: "var(--ds-background-accent-orange-subtle-hovered, #FEC57B)",
    grey: "var(--ds-background-accent-gray-subtle-hovered, #505F79)",
    blueLight: "var(--ds-background-accent-blue-subtler-hovered, #DEEBFF)",
    redLight: "var(--ds-background-accent-red-subtler-hovered, #FFEBE6)",
    yellowLight: "var(--ds-background-accent-yellow-subtler-hovered, #FFF0B3)",
    greenLight: "var(--ds-background-accent-green-subtler-hovered, #ABF5D1)",
    tealLight: "var(--ds-background-accent-teal-subtler-hovered, #B3F5FF)",
    purpleLight: "var(--ds-background-accent-purple-subtler-hovered, #EAE6FF)",
    limeLight: "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    orangeLight: "var(--ds-background-accent-orange-subtler-hovered, #FEC57B)",
    greyLight: "var(--ds-background-accent-gray-subtler-hovered, #DFE1E6)"
};
const $5b444d8505b9cc3c$export$76be99c5e13e3566 = {
    standard: "var(--ds-background-neutral-pressed, #EBECF0)",
    blue: "var(--ds-background-accent-blue-subtle-pressed, #DEEBFF)",
    red: "var(--ds-background-accent-red-subtle-pressed, #FFEBE6)",
    yellow: "var(--ds-background-accent-yellow-subtle-pressed, #FFF0B3)",
    green: "var(--ds-background-accent-green-subtle-pressed, #ABF5D1)",
    teal: "var(--ds-background-accent-teal-subtle-pressed, #B3F5FF)",
    purple: "var(--ds-background-accent-purple-subtle-pressed, #EAE6FF)",
    grey: "var(--ds-background-accent-gray-subtle-pressed, #5E6C84)",
    lime: "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    magenta: "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    orange: "var(--ds-background-accent-orange-subtle-pressed, #FFE2BD)",
    blueLight: "var(--ds-background-accent-blue-subtler-pressed, #4C9AFF)",
    redLight: "var(--ds-background-accent-red-subtler-pressed, #FF8F73)",
    yellowLight: "var(--ds-background-accent-yellow-subtler-pressed, #FFC400)",
    greenLight: "var(--ds-background-accent-green-subtler-pressed, #57D9A3)",
    tealLight: "var(--ds-background-accent-teal-subtler-pressed, #00C7E6)",
    purpleLight: "var(--ds-background-accent-purple-subtler-pressed, #998DD9)",
    limeLight: "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    orangeLight: "var(--ds-background-accent-orange-subtler-pressed, #FAA53D)",
    greyLight: "var(--ds-background-accent-gray-subtler-pressed, #C1C7D0)"
};
const $5b444d8505b9cc3c$export$2a31dbe82788f940 = "var(--ds-border-focused, #4C9AFF)";
const $5b444d8505b9cc3c$export$1202b7eb21da7b58 = "var(--ds-background-danger, #FFEBE6)";
const $5b444d8505b9cc3c$export$62ace793ebb16bda = "var(--ds-background-danger-hovered, #FFEBE6)";
const $5b444d8505b9cc3c$export$17d206ccea111bbb = "var(--ds-text-danger, #BF2600)";
const $5b444d8505b9cc3c$export$f64c7641cbc22da7 = {
    standard: "var(--ds-text, #42526E)",
    blue: "var(--ds-text-accent-blue-bolder, #42526E)",
    red: "var(--ds-text-accent-red-bolder, #42526E)",
    yellow: "var(--ds-text-accent-yellow-bolder, #42526E)",
    green: "var(--ds-text-accent-green-bolder, #42526E)",
    teal: "var(--ds-text-accent-teal-bolder, #42526E)",
    purple: "var(--ds-text-accent-purple-bolder, #42526E)",
    lime: "var(--ds-text-accent-lime-bolder, #42526E)",
    magenta: "var(--ds-text-accent-magenta-bolder, #42526E)",
    orange: "var(--ds-text-accent-orange-bolder, #42526E)",
    grey: "var(--ds-text-accent-gray-bolder, #42526E)",
    blueLight: "var(--ds-text-accent-blue, #42526E)",
    redLight: "var(--ds-text-accent-red, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow, #42526E)",
    greenLight: "var(--ds-text-accent-green, #42526E)",
    tealLight: "var(--ds-text-accent-teal, #42526E)",
    purpleLight: "var(--ds-text-accent-purple, #42526E)",
    limeLight: "var(--ds-text-accent-lime, #42526E)",
    magentaLight: "var(--ds-text-accent-magenta, #42526E)",
    orangeLight: "var(--ds-text-accent-orange, #42526E)",
    greyLight: "var(--ds-text-accent-gray, #42526E)"
};
const $5b444d8505b9cc3c$export$b03fbc2a369c563e = {
    standard: "var(--ds-text-danger, #253858)",
    standardLink: "var(--ds-text-danger, #0052CC)",
    blue: "var(--ds-text-danger, #172B4D)",
    red: "var(--ds-text-danger, #172B4D)",
    yellow: "var(--ds-text-danger, #172B4D)",
    green: "var(--ds-text-danger, #172B4D)",
    teal: "var(--ds-text-danger, #172B4D)",
    purple: "var(--ds-text-danger, #172B4D)",
    lime: "var(--ds-text-danger, #172B4D)",
    magenta: "var(--ds-text-danger, #172B4D)",
    orange: "var(--ds-text-danger, #172B4D)",
    grey: "var(--ds-text-danger, #FFFFFF)",
    blueLight: "var(--ds-text-danger, #0747A6)",
    redLight: "var(--ds-text-danger, #42526E)",
    yellowLight: "var(--ds-text-danger, #42526E)",
    greenLight: "var(--ds-text-danger, #006644)",
    tealLight: "var(--ds-text-danger, #42526E)",
    purpleLight: "var(--ds-text-danger, #403294)",
    limeLight: "var(--ds-text-danger, #403294)",
    magentaLight: "var(--ds-text-danger, #403294)",
    orangeLight: "var(--ds-text-danger, #403294)",
    greyLight: "var(--ds-text-danger, #42526E)"
};

});

parcelRegister("5oSQr", function(module, exports) {

$parcel$export(module.exports, "default", () => $db35d9df42c66ff0$export$2e2bcd8739ae039);
/* base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $2hnSR = parcelRequire("2hnSR");
const $db35d9df42c66ff0$var$borderColorCssVar = '--ds-bc';
const $db35d9df42c66ff0$var$focusRingCssVar = '--ds-cfr';
const $db35d9df42c66ff0$var$textLinkCssVar = '--ds-ctl';
const $db35d9df42c66ff0$var$textDefaultCssVar = '--ds-ct';
const $db35d9df42c66ff0$var$textHoverCssVar = '--ds-cth';
const $db35d9df42c66ff0$var$textActiveCssVar = '--ds-ctp';
const $db35d9df42c66ff0$var$backgroundDefaultCssVar = '--ds-cb';
const $db35d9df42c66ff0$var$backgroundHoverCssVar = '--ds-cbh';
const $db35d9df42c66ff0$var$backgroundActiveCssVar = '--ds-cba';
const $db35d9df42c66ff0$var$removeButtonDefaultCssVar = '--ds-rb';
const $db35d9df42c66ff0$var$removeButtonHoverCssVar = '--ds-rbh';
const $db35d9df42c66ff0$var$borderRadiusCssVar = '--ds-br';
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$baseStylesOld = null;
const $db35d9df42c66ff0$var$baseStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$interactiveStylesOld = null;
const $db35d9df42c66ff0$var$interactiveStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$focusRingStylesOld = null;
const $db35d9df42c66ff0$var$focusRingStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$nonStandardLinkStyles = null;
const $db35d9df42c66ff0$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, appearance: appearance = 'default', style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    const isStandardLink = isLink && color === 'standard';
    // Change link text color if  the tag is standard color
    const textLinkColors = isStandardLink ? (0, $2hnSR.textColors)['standardLink'] : (0, $2hnSR.textColors)[color];
    const backgroundHoverColors = isRemovable && !isLink ? (0, $2hnSR.backgroundColors)[color] : (0, $2hnSR.linkHoverBackgroundColors)[color];
    const backgroundActiveColors = isRemovable && !isLink ? (0, $2hnSR.backgroundColors)[color] : (0, $2hnSR.linkActiveBackgroundColors)[color];
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
        ...other,
        ref: ref,
        style: {
            // NOTE: The vast majority of these styles have zero purpose to be runtime computed
            // This can all be migrated to statically distributed atomic CSS with Compiled in the future
            // The main reason for not touching this is there is to avoid excessive changes in the same PR on non-visual-refresh code
            /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ [$db35d9df42c66ff0$var$borderColorCssVar]: (0, $2hnSR.borderColors)[color],
            [$db35d9df42c66ff0$var$textDefaultCssVar]: (0, $2hnSR.textColors)[color],
            [$db35d9df42c66ff0$var$textHoverCssVar]: (0, $2hnSR.textHoverColors)[color],
            [$db35d9df42c66ff0$var$textActiveCssVar]: (0, $2hnSR.textActiveColors)[color],
            [$db35d9df42c66ff0$var$textLinkCssVar]: textLinkColors,
            [$db35d9df42c66ff0$var$backgroundDefaultCssVar]: (0, $2hnSR.backgroundColors)[color],
            [$db35d9df42c66ff0$var$backgroundHoverCssVar]: backgroundHoverColors,
            [$db35d9df42c66ff0$var$backgroundActiveCssVar]: backgroundActiveColors,
            [$db35d9df42c66ff0$var$focusRingCssVar]: (0, $2hnSR.focusRingColors),
            [$db35d9df42c66ff0$var$removeButtonDefaultCssVar]: (0, $2hnSR.removeButtonColors)[color],
            [$db35d9df42c66ff0$var$removeButtonHoverCssVar]: (0, $2hnSR.removeButtonHoverColors)[color],
            [$db35d9df42c66ff0$var$borderRadiusCssVar]: appearance === 'rounded' ? '10px' : '3px',
            /* eslint-enable @atlaskit/ui-styling-standard/enforce-style-prop */ /* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_zulp1b66 _2rko1sit _1h6d2fso _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _18zr1b66 _1e0c116y _vchhusvi _1ul9idpf _4t3iv47k _kqswh2mm _4cvr1h6o _bfhk1w7a _syaz1fxt _80om73ad" : "_2rko1l5z _1mou1b66 _195g1b66 _1rjcze3t _18zrze3t _1e0c116y _1ul9idpf _4t3iv47k _kqswh2mm _bfhklsll _syaz148y _80om73ad",
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_1e38ugt7 _7glxv77o" : "_1guj1r31 _pbhaglyw _11ow1o36 _1u6lnr64",
            isLink && (0, $VSDnB.fg)('platform-component-visual-refresh') && "_irr3166n _1di61dty",
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && isLink && !isStandardLink && "_9h8h1348",
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && isInteractive && "_irr31lyj _1di6oo20",
            className
        ]),
        "data-testid": testId,
        children: [
            before,
            contentElement,
            after
        ]
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$db35d9df42c66ff0$export$2e2bcd8739ae039 = $db35d9df42c66ff0$var$BaseTag;

});

parcelRegister("aXLIT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b11e671062d0fc5$export$2e2bcd8739ae039);
/* before.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");
const $4b11e671062d0fc5$var$beforeElementStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $4b11e671062d0fc5$var$beforeElementStylesOld = null;
const $4b11e671062d0fc5$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_1e0c1txw _4t3i7vkz _4cvr1h6o _1bah1h6o _152tze3t" : "_2rko1l5z _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _152tze3t"
        ]),
        children: elemBefore
    }) : null;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4b11e671062d0fc5$export$2e2bcd8739ae039 = $4b11e671062d0fc5$var$Before;

});

parcelRegister("eYXIO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c46b06918fbe54e8$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");
// To be removed with platform-component-visual-refresh (BLU-2992)
const $c46b06918fbe54e8$var$baseStylesOld = null;
const $c46b06918fbe54e8$var$baseStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $c46b06918fbe54e8$var$linkStylesOld = null;
const $c46b06918fbe54e8$var$linkStyles = null;
const $c46b06918fbe54e8$var$hasAfterStylesOld = null;
const $c46b06918fbe54e8$var$hasAfterStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $c46b06918fbe54e8$var$hasBeforeStyles = null;
const $c46b06918fbe54e8$var$Content = ({ elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent })=>{
    const Link = linkComponent ?? 'a';
    if (href) return /*#__PURE__*/ (0, $2OMIu.jsx)(Link, {
        href: href,
        "data-color": color,
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_11c82smr _1reo15vq _18m915vq _p12fmgvx _1bto1l2s _o5721q9c" : "_11c82smr _1reo15vq _18m915vq _p12fmgvx _y4ti1b66 _bozg1b66 _1bto1l2s _o5721q9c",
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_4bfu18uv _1hmsglyw _ajmmnqa1 _syaz1fxt _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik18uv _1bnx8stv _jf4cnqa1 _30l31fxt _1nrm18uv _c2wa8stv _1iohnqa1 _9h8h1fxt" : "_4bfu18uv _1hmsglyw _ajmmnqa1 _syazs5nr _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik18uv _1bnx8stv _jf4cnqa1 _30l3117u _1nrm18uv _c2wa8stv _1iohnqa1 _9h8h1348",
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && elemBefore && "_ahbqv47k",
            isRemovable && (0, $VSDnB.fg)('platform-component-visual-refresh') && "_p12f1lit",
            isRemovable && !(0, $VSDnB.fg)('platform-component-visual-refresh') && "_p12f1lit _y4tipxbi"
        ]),
        children: text
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_11c82smr _1reo15vq _18m915vq _p12fmgvx _1bto1l2s _o5721q9c" : "_11c82smr _1reo15vq _18m915vq _p12fmgvx _y4ti1b66 _bozg1b66 _1bto1l2s _o5721q9c",
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && elemBefore && "_ahbqv47k",
            isRemovable && (0, $VSDnB.fg)('platform-component-visual-refresh') && "_p12f1lit",
            isRemovable && !(0, $VSDnB.fg)('platform-component-visual-refresh') && "_p12f1lit _y4tipxbi"
        ]),
        children: text
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c46b06918fbe54e8$export$2e2bcd8739ae039 = $c46b06918fbe54e8$var$Content;

});

parcelRegister("frUcV", function(module, exports) {

$parcel$export(module.exports, "default", () => $625906158e0f3c21$export$2e2bcd8739ae039);
/* remove-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $2jwCH = parcelRequire("2jwCH");

var $VSDnB = parcelRequire("VSDnB");

var $3Lty3 = parcelRequire("3Lty3");
const $625906158e0f3c21$var$removeButtonStyles = {
    root: "_19itglyw _2rkogqwt _195gze3t _1mouze3t _18zrze3t _1rjcze3t _1e0c1txw _4t3i7vkz _1bsb7vkz _rjxpze3t _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhk1w7a _syaz1fxt _80omtlke _lcxv1wug _ahbq1i6y _12l21i6y _1ah31i6y _irr3166n _1di61dty"
};
// To be removed with platform-component-visual-refresh (BLU-2992)
const $625906158e0f3c21$var$removeButtonStylesOld = {
    root: "_19itglyw _2rko1l5z _18zrze3t _1rjcze3t _1e0c1txw _4t3i7vkz _ahbqze3t _12l2ze3t _1pfhze3t _6rthze3t _kqswstnw _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhk1w7a _syaz1bah _80omtlke _lcxv1wug _1ah3ze3t _30l31eu2"
};
const $625906158e0f3c21$var$removeButtonStylesOldIcon = {
    root: "_rjxpze3t"
};
const $625906158e0f3c21$var$removeButtonStylesNewIcon = {
    root: "_rjxpv77o"
};
const $625906158e0f3c21$var$RemoveButton = ({ 'aria-label': ariaLabel, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onKeyPress: onKeyPress, onMouseOver: onMouseOver, onMouseOut: onMouseOut, testId: testId })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
        xcss: (0, $3JT92.cx)(// TODO: When cleaning up all these feature gates, they should just be converged into a single `styles` object.
        (0, $VSDnB.fg)('platform-component-visual-refresh') && $625906158e0f3c21$var$removeButtonStyles.root, !(0, $VSDnB.fg)('platform-component-visual-refresh') && $625906158e0f3c21$var$removeButtonStylesOld.root, $625906158e0f3c21$var$removeButtonStylesOldIcon.root, (0, $VSDnB.fg)('platform-visual-refresh-icons') && $625906158e0f3c21$var$removeButtonStylesNewIcon.root),
        "aria-label": ariaLabel,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        testId: testId,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2jwCH))), {
            color: "currentColor",
            label: "",
            LEGACY_size: "small",
            size: "small"
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$625906158e0f3c21$export$2e2bcd8739ae039 = $625906158e0f3c21$var$RemoveButton;

});
parcelRegister("2jwCH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a8221850e05ac929fb26618da6db4acc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1af6a969f6ce5e7d$var$_react = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1af6a969f6ce5e7d$var$_close = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("i28qQ")));

var $1af6a969f6ce5e7d$var$_close2 = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("2C7j9")));
function $1af6a969f6ce5e7d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CloseIcon.
 * This component is CloseIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1af6a969f6ce5e7d$var$CloseIcon = (props)=>/*#__PURE__*/ $1af6a969f6ce5e7d$var$_react.default.createElement($1af6a969f6ce5e7d$var$_close.default, Object.assign({
        LEGACY_fallbackIcon: $1af6a969f6ce5e7d$var$_close2.default
    }, props));
$1af6a969f6ce5e7d$var$CloseIcon.Name = 'CloseIconMigration';
var $1af6a969f6ce5e7d$var$_default = module.exports.default = $1af6a969f6ce5e7d$var$CloseIcon;

});
parcelRegister("2C7j9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1e74cc92a54dd799$var$_react = $1e74cc92a54dd799$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $1e74cc92a54dd799$var$_cross = $1e74cc92a54dd799$var$_interopRequireDefault((parcelRequire("1EekA")));
function $1e74cc92a54dd799$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1e74cc92a54dd799$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $1e74cc92a54dd799$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props, {
        newIcon: $1e74cc92a54dd799$var$_cross.default
    }));
$1e74cc92a54dd799$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $1e74cc92a54dd799$var$_default = module.exports.default = $1e74cc92a54dd799$var$EditorCloseIcon;

});




parcelRegister("6UXEc", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c2d1dcb54418fac$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $2c2d1dcb54418fac$var$baseStyles = null;
const $2c2d1dcb54418fac$var$justifyStartStyles = null;
const $2c2d1dcb54418fac$var$justifyEndStyles = null;
/**
 * __Tag group__
 *
 * A tag group controls the layout and alignment for a collection of tags.
 *
 * - [Examples](https://atlassian.design/components/tag-group/examples)
 * - [Code](https://atlassian.design/components/tag-group/code)
 * - [Usage](https://atlassian.design/components/tag-group/usage)
 */ const $2c2d1dcb54418fac$var$TagGroup = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ alignment: alignment = 'start', titleId: titleId, label: label, children: children }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "group",
        ref: ref,
        "aria-label": label,
        "aria-labelledby": titleId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bsb1osq _1n261g80",
            alignment === 'start' && "_1bah1y6m",
            alignment === 'end' && "_1bahesu3"
        ]),
        children: children
    });
});
var $2c2d1dcb54418fac$export$2e2bcd8739ae039 = $2c2d1dcb54418fac$var$TagGroup;

});






parcelRegister("hMtBm", function(module, exports) {

$parcel$export(module.exports, "buildCustomizationDataShapes", () => $367f790a965b855e$export$8c9c2865d610ab5f);

var $k8IPx = parcelRequire("k8IPx");

var $7bBf1 = parcelRequire("7bBf1");

var $lXrF9 = parcelRequire("lXrF9");

var $gdOSe = parcelRequire("gdOSe");
const $367f790a965b855e$export$8c9c2865d610ab5f = (defaultItemMenuIds, defaultShortcutMenuIds, rawCustomizationData)=>{
    const repairedDefaultItemMenuIds = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(defaultItemMenuIds, defaultShortcutMenuIds);
    const itemCustomizationData = $367f790a965b855e$var$repair(rawCustomizationData, repairedDefaultItemMenuIds);
    const shortcutCustomizationData = $367f790a965b855e$var$repair(rawCustomizationData, defaultShortcutMenuIds);
    const customizationData = itemCustomizationData.concat(shortcutCustomizationData);
    const [visibleItemMenuIds, hiddenItemMenuIds] = (0, $lXrF9.getMenuIdsByVisible)(itemCustomizationData);
    const [visibleShortcutMenuIds, hiddenShortcutMenuIds] = (0, $lXrF9.getMenuIdsByVisible)(shortcutCustomizationData);
    const visibleMenuIds = visibleItemMenuIds.concat(visibleShortcutMenuIds);
    const hiddenMenuIds = hiddenItemMenuIds.concat(hiddenShortcutMenuIds);
    return {
        customizationData: customizationData,
        visibleMenuIds: visibleMenuIds,
        hiddenMenuIds: hiddenMenuIds,
        itemCustomizationData: itemCustomizationData,
        visibleItemMenuIds: visibleItemMenuIds,
        hiddenItemMenuIds: hiddenItemMenuIds,
        shortcutCustomizationData: shortcutCustomizationData,
        visibleShortcutMenuIds: visibleShortcutMenuIds,
        hiddenShortcutMenuIds: hiddenShortcutMenuIds
    };
};
const $367f790a965b855e$var$repair = (rawCustomizationData, defaultMenuIds)=>(0, $gdOSe.repairItems)(rawCustomizationData ?? [], (0, $7bBf1.createDefaultCustomizationItems)(defaultMenuIds));

});
parcelRegister("7bBf1", function(module, exports) {

$parcel$export(module.exports, "createDefaultCustomizationItems", () => $4c83813a0fb8b0d2$export$cb9a19d9328f4a2f);
const $4c83813a0fb8b0d2$export$cb9a19d9328f4a2f = (menuIds)=>menuIds.map((menuId)=>({
            menuId: menuId,
            visible: true
        }));

});

parcelRegister("lXrF9", function(module, exports) {

$parcel$export(module.exports, "getMenuIdsByVisible", () => $e8e0d9761e31c4d5$export$ac81be4e21f7c439);

var $ekG8A = parcelRequire("ekG8A");

var $la66g = parcelRequire("la66g");
const $e8e0d9761e31c4d5$export$ac81be4e21f7c439 = (items)=>(0, $la66g.partitionByVisible)(items).map((0, $ekG8A.getMenuIds));

});
parcelRegister("ekG8A", function(module, exports) {

$parcel$export(module.exports, "getMenuIds", () => $79e9fca43ec4885b$export$df4a614c56950314);
const $79e9fca43ec4885b$export$df4a614c56950314 = (items)=>items.map((item)=>item.menuId);

});

parcelRegister("la66g", function(module, exports) {

$parcel$export(module.exports, "partitionByVisible", () => $aeb7cc4afbf42417$export$98e5c4110cac6c24);

var $ifg6x = parcelRequire("ifg6x");
const $aeb7cc4afbf42417$export$98e5c4110cac6c24 = (items)=>(0, (/*@__PURE__*/$parcel$interopDefault($ifg6x)))(items, (item)=>item.visible);

});


parcelRegister("gdOSe", function(module, exports) {

$parcel$export(module.exports, "repairItems", () => $6a4e1b1aecd39113$export$ce0466efa278e488);

var $cYhG6 = parcelRequire("cYhG6");
const $6a4e1b1aecd39113$export$ce0466efa278e488 = (items, defaultItems)=>(0, (/*@__PURE__*/$parcel$interopDefault($cYhG6)))(items.concat(defaultItems), defaultItems, (item)=>item.menuId);

});
parcelRegister("cYhG6", function(module, exports) {

var $1nIHN = parcelRequire("1nIHN");

var $9dThv = parcelRequire("9dThv");

var $bxDef = parcelRequire("bxDef");

var $g7i7g = parcelRequire("g7i7g");

var $d9Hx6 = parcelRequire("d9Hx6");

var $hYfgW = parcelRequire("hYfgW");
/**
 * This method is like `_.intersection` except that it accepts `iteratee`
 * which is invoked for each element of each `arrays` to generate the criterion
 * by which they're compared. The order and references of result values are
 * determined by the first array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [2.1]
 *
 * // The `_.property` iteratee shorthand.
 * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }]
 */ var $026fe246c8ca749e$var$intersectionBy = $g7i7g(function(arrays) {
    var iteratee = $hYfgW(arrays), mapped = $1nIHN(arrays, $d9Hx6);
    if (iteratee === $hYfgW(mapped)) iteratee = undefined;
    else mapped.pop();
    return mapped.length && mapped[0] === arrays[0] ? $9dThv(mapped, $bxDef(iteratee, 2)) : [];
});
module.exports = $026fe246c8ca749e$var$intersectionBy;

});
parcelRegister("9dThv", function(module, exports) {

var $ijRUK = parcelRequire("ijRUK");

var $fUP98 = parcelRequire("fUP98");

var $dA3tP = parcelRequire("dA3tP");

var $1nIHN = parcelRequire("1nIHN");

var $cW28x = parcelRequire("cW28x");

var $40I25 = parcelRequire("40I25");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6b7035a795ecd274$var$nativeMin = Math.min;
/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */ function $6b7035a795ecd274$var$baseIntersection(arrays, iteratee, comparator) {
    var includes = comparator ? $dA3tP : $fUP98, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
    while(othIndex--){
        var array = arrays[othIndex];
        if (othIndex && iteratee) array = $1nIHN(array, $cW28x(iteratee));
        maxLength = $6b7035a795ecd274$var$nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new $ijRUK(othIndex && array) : undefined;
    }
    array = arrays[0];
    var index = -1, seen = caches[0];
    outer: while(++index < length && result.length < maxLength){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (!(seen ? $40I25(seen, computed) : includes(result, computed, comparator))) {
            othIndex = othLength;
            while(--othIndex){
                var cache = caches[othIndex];
                if (!(cache ? $40I25(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
            }
            if (seen) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $6b7035a795ecd274$var$baseIntersection;

});

parcelRegister("d9Hx6", function(module, exports) {

var $f3SOL = parcelRequire("f3SOL");
/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */ function $993de25d5a02863a$var$castArrayLikeObject(value) {
    return $f3SOL(value) ? value : [];
}
module.exports = $993de25d5a02863a$var$castArrayLikeObject;

});




parcelRegister("5LkU5", function(module, exports) {

$parcel$export(module.exports, "SideNavDataProvider", () => $8776a5f45fcecbd8$export$e8cf6894e0873d93);
$parcel$export(module.exports, "useSideNavData", () => $8776a5f45fcecbd8$export$89056b79b690b438);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");
const $8776a5f45fcecbd8$export$33f9eded602e3caf = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
function $8776a5f45fcecbd8$export$e8cf6894e0873d93({ children: children, value: value }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($8776a5f45fcecbd8$export$33f9eded602e3caf.Provider, {
        value: value,
        children: children
    });
}
const $8776a5f45fcecbd8$export$89056b79b690b438 = ()=>{
    const customizationDataShapes = (0, $5uXOq.useContext)($8776a5f45fcecbd8$export$33f9eded602e3caf);
    (0, $3joPi.default)(customizationDataShapes, 'useSideNavData must be used inside an initialized SideNavDataProvider');
    return customizationDataShapes;
};

});

parcelRegister("5eaCi", function(module, exports) {

$parcel$export(module.exports, "UserMenuDataProvider", () => $7abaed81f0c16b7e$export$8192e39428f09c3a);
$parcel$export(module.exports, "useUserMenuData", () => $7abaed81f0c16b7e$export$f881c7978b5fc9af);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");
const $7abaed81f0c16b7e$export$f9cc2a90ebfc5ef4 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
function $7abaed81f0c16b7e$export$8192e39428f09c3a({ children: children, value: value }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($7abaed81f0c16b7e$export$f9cc2a90ebfc5ef4.Provider, {
        value: value,
        children: children
    });
}
function $7abaed81f0c16b7e$export$f881c7978b5fc9af() {
    const context = (0, $5uXOq.useContext)($7abaed81f0c16b7e$export$f9cc2a90ebfc5ef4);
    (0, $3joPi.default)(context, 'useUserMenuData must be used inside an initialized UserMenuDataProvider');
    return context;
}

});

const $26f817a0a0a7080d$export$5678faf50a8e9276 = 'global-side-nav-test-id';
const $26f817a0a0a7080d$export$88dd4a9e4ffa4ec2 = 'gsn-peek';
const $26f817a0a0a7080d$export$ee2a9579670b9420 = 'gsn-global-shortcuts';

parcelRegister("7ofg2", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfe1ee6515847bb4$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $bdVbi = parcelRequire("bdVbi");


var $7dU2i = parcelRequire("7dU2i");
function $dfe1ee6515847bb4$export$2e2bcd8739ae039({ href: href, isSelected: isSelected, onClick: onClick }) {
    const icon = /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bdVbi))), {
        label: ""
    });
    const common = {
        // todo: Make i18n compatible
        name: (0, $7dU2i.messages).forYouLabel.defaultMessage,
        icon: icon,
        testId: (0, $aa94bb5d6afb6d86$export$f47cf802fb7ac2e6),
        isSelected: isSelected,
        elemBefore: icon,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7dU2i.messages).forYouLabel
        })
    };
    return href ? {
        type: 'link',
        href: href,
        onClick: onClick,
        ...common
    } : {
        type: 'button',
        onClick: onClick,
        ...common
    };
}

});
const $aa94bb5d6afb6d86$export$f47cf802fb7ac2e6 = 'gsn-for-you';

parcelRegister("7dU2i", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f7b5577c58045712$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f7b5577c58045712$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    forYouLabel: {
        id: 'navigation.global-side-navigation.for-you.label',
        description: 'Label on For You button in the side navigation. Typically takes users to an app-specific page showing user content',
        defaultMessage: 'For you'
    }
});

});


parcelRegister("cbMlQ", function(module, exports) {

$parcel$export(module.exports, "SideNavigationLayout", () => $84284fdbd608f1a6$export$610d5f09b69fac71);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $3AWiS = parcelRequire("3AWiS");
var $kTus1 = parcelRequire("kTus1");
var $3yxBH = parcelRequire("3yxBH");
var $lsO24 = parcelRequire("lsO24");
var $6DDUb = parcelRequire("6DDUb");
var $cZH0T = parcelRequire("cZH0T");

var $a593i = parcelRequire("a593i");

var $8Kaml = parcelRequire("8Kaml");

var $27eCs = parcelRequire("27eCs");

var $8TqJI = parcelRequire("8TqJI");
function $84284fdbd608f1a6$export$610d5f09b69fac71(props) {
    const { setUserSideNavData: setUserSideNavData } = (0, $8Kaml.useUserSideNavData)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a593i.AsyncIntlProvider), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $27eCs.SideNavVisibilityProvider), {
            setUserSideNavData: setUserSideNavData,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($84284fdbd608f1a6$var$SideNavigationLayoutComponent, {
                ...props
            })
        })
    });
}
function $84284fdbd608f1a6$var$SideNavigationLayoutComponent({ preMainElem: preMainElem, postMainElem: postMainElem, bottomElem: bottomElem, children: children, testId: testId }) {
    const intl = (0, $koVbs.default)();
    const { userSideNavData: userSideNavData } = (0, $8Kaml.useUserSideNavData)();
    const { onCollapse: onCollapse, onExpand: onExpand, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd } = (0, $27eCs.useSideNavVisibility)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $kTus1.SideNav), {
        testId: testId,
        onExpand: onExpand,
        onCollapse: onCollapse,
        defaultWidth: userSideNavData.defaultWidth,
        defaultCollapsed: userSideNavData.defaultCollapsed,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6DDUb.SideNavHeader), {
                children: preMainElem
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3yxBH.SideNavContent), {
                children: [
                    children,
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cZH0T.TopLevelSpacer), {}),
                    postMainElem
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3AWiS.PanelSplitter), {
                onResizeEnd: onResizeEnd,
                onResizeStart: onResizeStart,
                label: intl.formatMessage((0, $8TqJI.messages).panelSplitterLabel)
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lsO24.SideNavFooter), {
                children: bottomElem
            })
        ]
    });
}

});
parcelRegister("a593i", function(module, exports) {

$parcel$export(module.exports, "AsyncIntlProvider", () => $53bb2fe6f50cb893$export$2f688dfcc031530a);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $96nTn = parcelRequire("96nTn");

var $7lsTQ = parcelRequire("7lsTQ");

var $2eJiE = parcelRequire("2eJiE");
const $53bb2fe6f50cb893$var$fetchMessagesForLocale = async (locale)=>{
    try {
        // Fallback to the generic locale if specified one is not found
        const languageLocale = locale in (0, $2eJiE.asyncLanguages) ? locale : locale.split(/[-_]/)[0] || '';
        // Dynamic import of the locale file
        const localeMessages = await (0, $2eJiE.asyncLanguages)[languageLocale]?.();
        return localeMessages?.default ?? (0, $7lsTQ.default);
    } catch (e) {
    // ignore
    }
    return 0, $7lsTQ.default;
};
const $53bb2fe6f50cb893$export$2f688dfcc031530a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $96nTn.default), {
        defaultMessages: (0, $7lsTQ.default),
        loaderFn: $53bb2fe6f50cb893$var$fetchMessagesForLocale,
        children: children
    });
};

});
parcelRegister("7lsTQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $50985b3769b06789$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $50985b3769b06789$export$2e2bcd8739ae039 = {
    'navigation.global-side-navigation.customize-sidebar.label': 'Customize sidebar',
    'navigation.global-side-navigation.for-you.label': 'For you',
    'navigation.global-side-navigation.more-menu.label': 'More',
    'navigation.global-side-navigation.onboarding-menu.give-feedback': 'Give feedback',
    'navigation.global-side-navigation.onboarding-menu.guided-tour': 'Take a guided tour',
    'navigation.global-side-navigation.onboarding-menu.navigation-docs': 'Read about the new navigation',
    'navigation.global-side-navigation.panel-splitter.label': 'Resize panel',
    'navigation.global-side-navigation.recents.label': 'Recent',
    'navigation.global-side-navigation.starred.label': 'Starred'
};

});

parcelRegister("2eJiE", function(module, exports) {

$parcel$export(module.exports, "asyncLanguages", () => $38c84edee37af6f3$export$3770c7a7737d463c);
// https://parceljs.org/features/dependency-resolution/#glob-specifiers

const $38c84edee37af6f3$export$3770c7a7737d463c = {
    en: ()=>Promise.resolve((parcelRequire("7lsTQ")))
};

});


parcelRegister("8Kaml", function(module, exports) {

$parcel$export(module.exports, "UserSideNavDataProvider", () => $0691aaa6a09c011a$export$3a3991a402cbd83e);
$parcel$export(module.exports, "useUserSideNavData", () => $0691aaa6a09c011a$export$bc6989c74d1be5d);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");
const $0691aaa6a09c011a$export$19e418f3273659ff = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
function $0691aaa6a09c011a$export$3a3991a402cbd83e({ children: children, value: value }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($0691aaa6a09c011a$export$19e418f3273659ff.Provider, {
        value: value,
        children: children
    });
}
function $0691aaa6a09c011a$export$bc6989c74d1be5d() {
    const context = (0, $5uXOq.useContext)($0691aaa6a09c011a$export$19e418f3273659ff);
    (0, $3joPi.default)(context, 'useUserSideNavData must be used inside a UserSideNavDataProvider');
    return context;
}

});

parcelRegister("27eCs", function(module, exports) {

$parcel$export(module.exports, "useSideNavVisibility", () => $fe7687494ba4f6cf$export$4a602ad7e09bdb2c);
$parcel$export(module.exports, "SideNavVisibilityProvider", () => $fe7687494ba4f6cf$export$aac8e996360f6ad9);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");


var $2NMNM = parcelRequire("2NMNM");

const $fe7687494ba4f6cf$export$afc6d5ca319092bd = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $fe7687494ba4f6cf$export$4a602ad7e09bdb2c = ()=>{
    const context = (0, $5uXOq.useContext)($fe7687494ba4f6cf$export$afc6d5ca319092bd);
    (0, $3joPi.default)(context, 'useSideNavVisibility must be used within an SideNavVisibilityProvider');
    return context;
};
function $fe7687494ba4f6cf$export$aac8e996360f6ad9({ children: children, onCollapse: onCollapse, onExpand: onExpand, onResizeEnd: onResizeEnd, onResizeStart: onResizeStart, setUserSideNavData: setUserSideNavData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onCollapseHandler = (0, $5uXOq.useCallback)((args)=>{
        createAnalyticsEvent({
            eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
            action: 'collapsed',
            actionSubject: 'sideNavigation',
            attributes: {}
        }).fire((0, $0ca1b1da8db82735$export$85183a312807388d));
        setUserSideNavData({
            defaultCollapsed: true
        });
        onCollapse?.(args);
    }, [
        createAnalyticsEvent,
        onCollapse,
        setUserSideNavData
    ]);
    const onExpandHandler = (0, $5uXOq.useCallback)((args)=>{
        createAnalyticsEvent({
            eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
            action: 'expanded',
            actionSubject: 'sideNavigation',
            attributes: {}
        }).fire((0, $0ca1b1da8db82735$export$85183a312807388d));
        setUserSideNavData({
            defaultCollapsed: false
        });
        onExpand?.(args);
    }, [
        createAnalyticsEvent,
        onExpand,
        setUserSideNavData
    ]);
    const onResizeStartHandler = (0, $5uXOq.useCallback)((args)=>{
        createAnalyticsEvent({
            eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
            action: 'resizeStart',
            actionSubject: 'sideNavigation',
            attributes: {}
        }).fire((0, $0ca1b1da8db82735$export$85183a312807388d));
        onResizeStart?.(args);
    }, [
        onResizeStart,
        createAnalyticsEvent
    ]);
    const onResizeEndHandler = (0, $5uXOq.useCallback)((args)=>{
        createAnalyticsEvent({
            eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
            action: 'resizeEnd',
            actionSubject: 'sideNavigation',
            attributes: {}
        }).fire((0, $0ca1b1da8db82735$export$85183a312807388d));
        setUserSideNavData({
            defaultWidth: args.finalWidth
        });
        onResizeEnd?.(args);
    }, [
        createAnalyticsEvent,
        onResizeEnd,
        setUserSideNavData
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($fe7687494ba4f6cf$export$afc6d5ca319092bd.Provider, {
        value: {
            onExpand: onExpandHandler,
            onCollapse: onCollapseHandler,
            onResizeEnd: onResizeEndHandler,
            onResizeStart: onResizeStartHandler
        },
        children: children
    });
}

});

parcelRegister("8TqJI", function(module, exports) {

$parcel$export(module.exports, "messages", () => $80f7ad7c224d6fa0$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $80f7ad7c224d6fa0$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    panelSplitterLabel: {
        id: 'navigation.global-side-navigation.panel-splitter.label',
        description: 'The accessible label for the panel splitter. Visually hidden but read by screen readers.',
        defaultMessage: 'Resize panel'
    }
});

});


parcelRegister("epGyj", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a999de9b3b978c5a$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $a999de9b3b978c5a$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    recentsSearchPlaceholder: {
        id: 'navigation.global-side-navigation.recentsSearchPlaceholder',
        description: 'Placeholder for the search input in the recents flyout list.',
        defaultMessage: 'Search recent items'
    },
    starredSearchPlaceholder: {
        id: 'navigation.global-side-navigation.starredSearchPlaceholder',
        description: 'Placeholder for the search input in the starred flyout list.',
        defaultMessage: 'Search starred items'
    }
});

});

parcelRegister("jklcM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b91210f9bc5423d3$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $gSZmd = parcelRequire("gSZmd");

var $3SaXS = parcelRequire("3SaXS");


var $2tarv = parcelRequire("2tarv");

var $gYmA2 = parcelRequire("gYmA2");

var $k4oyr = parcelRequire("k4oyr");
function $b91210f9bc5423d3$export$2e2bcd8739ae039({ items: items, shortcutItems: shortcutItems = {}, itemIds: itemIds, shortcutItemIds: shortcutItemIds, peekedItemId: peekedItemId, onPeek: onPeek }) {
    const intl = (0, $koVbs.default)();
    const menuItemComponent = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(({ closeMenu: closeMenu, menuId: menuId })=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k4oyr.default), {
            id: menuId,
            items: items,
            shortcutItems: shortcutItems,
            onClick: closeMenu,
            onPeek: onPeek
        }, menuId);
    }, [
        items,
        onPeek,
        shortcutItems
    ]);
    const productItemsData = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        return itemIds.map((menuId)=>({
                menuId: menuId,
                visible: false
            }));
    }, [
        itemIds
    ]);
    const appItemsData = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        return shortcutItemIds.map((menuId)=>({
                menuId: menuId,
                visible: false
            }));
    }, [
        shortcutItemIds
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gSZmd.MenuList), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3SaXS.GlobalMoreMenu), {
            productItemsData: productItemsData,
            appItemsData: appItemsData,
            menuItemComponent: menuItemComponent,
            customizeSidebarMenuItem: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2tarv.CustomizeSidebarMenuItem), {
                items: items,
                shortcuts: shortcutItems,
                testId: (0, $8dcde79c6ef0f41b$export$60e3e06657245ab)
            }),
            moreMenuItemLabel: intl.formatMessage((0, $gYmA2.messages).moreMenuLabel),
            peekingMenuIds: peekedItemId ? [
                peekedItemId
            ] : undefined,
            testId: (0, $8dcde79c6ef0f41b$export$9536180777e6913e)
        })
    });
}

});
const $8dcde79c6ef0f41b$export$60e3e06657245ab = 'gsn-customize-sidebar';
const $8dcde79c6ef0f41b$export$9536180777e6913e = 'gsn-more-menu';

parcelRegister("2tarv", function(module, exports) {

$parcel$export(module.exports, "CustomizeSidebarMenuItem", () => $a21992c8b7d0f117$export$b7fa0daee00ba08b);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $4QAwn = parcelRequire("4QAwn");

var $jpyeI = parcelRequire("jpyeI");

var $2xaXo = parcelRequire("2xaXo");

var $5LkU5 = parcelRequire("5LkU5");

var $jO4aB = parcelRequire("jO4aB");

var $gJzhV = parcelRequire("gJzhV");

var $hLlKE = parcelRequire("hLlKE");

var $1CDEb = parcelRequire("1CDEb");
const $a21992c8b7d0f117$export$b7fa0daee00ba08b = ({ items: items, shortcuts: shortcuts, testId: testId })=>{
    const getMenuNameAndIcon = (0, $hLlKE.useGetMenuNameAndIcon)(items, shortcuts);
    const { itemCustomizationData: itemCustomizationData, shortcutCustomizationData: shortcutCustomizationData } = (0, $5LkU5.useSideNavData)();
    const onSave = (0, $1CDEb.useOnSave)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2xaXo.ModalTrigger), {
        entryPoint: (0, $jO4aB.customizationModalEntryPoint),
        entryPointProps: {
            getMenuNameAndIcon: getMenuNameAndIcon,
            itemCustomizationData: itemCustomizationData,
            shortcutCustomizationData: shortcutCustomizationData,
            onSave: onSave
        },
        children: ({ ref: ref })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $jpyeI.ButtonMenuItem), {
                elemBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4QAwn))), {
                    label: ""
                }),
                ref: ref,
                testId: testId,
                children: formatMessage((0, $gJzhV.messages).customizeSidebarMenuItemLabel)
            })
    });
};

});
parcelRegister("jO4aB", function(module, exports) {

$parcel$export(module.exports, "customizationModalEntryPoint", () => $7a7c83c516d5783a$export$ce0411fdea635705);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $7a7c83c516d5783a$export$ce0411fdea635705 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>// eslint-disable-next-line import/dynamic-import-chunkname
        (parcelRequire("b5na4")).then(({ CustomizationModal: CustomizationModal })=>CustomizationModal), {
        moduleId: "b2e7e7c1",
        priority: "interaction",
        moduleId: 'navigation.global-side-navigation.customization-modal'
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("b5na4", function(module, exports) {

let $812220b241f2a8fe$var$load = (parcelRequire("28QjX"))(4);
module.exports = $812220b241f2a8fe$var$load("izQ9I").then(()=>parcelRequire('cPnHb'));

});


parcelRegister("gJzhV", function(module, exports) {

$parcel$export(module.exports, "messages", () => $cb6110af4e03dd31$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $cb6110af4e03dd31$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    customizeSidebarMenuItemLabel: {
        id: 'navigation.global-side-navigation.customize-sidebar-menu-item.label',
        description: 'Label on Customize button in the side navigation. Shows a modal with options to customize the sidebar.',
        defaultMessage: 'Customize sidebar'
    }
});

});

parcelRegister("hLlKE", function(module, exports) {

$parcel$export(module.exports, "useGetMenuNameAndIcon", () => $f742ccd4218ef276$export$96b5a664911df1e);

var $5uXOq = parcelRequire("5uXOq");

var $7LKuJ = parcelRequire("7LKuJ");
const $f742ccd4218ef276$export$96b5a664911df1e = (items, shortcuts)=>(0, $5uXOq.useCallback)((menuId)=>(0, $7LKuJ.getMenuNameAndIcon)(items, shortcuts)(menuId), [
        items,
        shortcuts
    ]);

});
parcelRegister("7LKuJ", function(module, exports) {

$parcel$export(module.exports, "getMenuNameAndIcon", () => $90632fa15c8601d2$export$f7f14d607e7d3877);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8nk07 = parcelRequire("8nk07");
const $90632fa15c8601d2$export$f7f14d607e7d3877 = (items, shortcuts)=>(menuId)=>{
        const item = items[menuId];
        if (item) {
            // Temporary until name and icon can be made required
            const name = item.name ?? 'unknown';
            const icon = item.icon ?? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8nk07))), {
                label: ""
            });
            return {
                name: name,
                icon: icon
            };
        }
        const shortcut = shortcuts[menuId];
        if (shortcut) {
            // Temporary until name can be made required
            const name = shortcut.name ?? 'unknown';
            return {
                name: name,
                icon: shortcut.icon
            };
        }
        throw Error(`Menu id ${menuId} not found in either items or shortcuts`);
    };

});


parcelRegister("1CDEb", function(module, exports) {

$parcel$export(module.exports, "useOnSave", () => $e38242b01856559c$export$ecbfe7cad2f40363);

var $5uXOq = parcelRequire("5uXOq");

var $5eaCi = parcelRequire("5eaCi");
const $e38242b01856559c$export$ecbfe7cad2f40363 = ()=>{
    const { setUserMenuData: setUserMenuData } = (0, $5eaCi.useUserMenuData)();
    return (0, $5uXOq.useCallback)((updatedItemCustomizationData, updatedShortcutCustomizationData)=>setUserMenuData(updatedItemCustomizationData.concat(updatedShortcutCustomizationData)), [
        setUserMenuData
    ]);
};

});


parcelRegister("gYmA2", function(module, exports) {

$parcel$export(module.exports, "messages", () => $72eaeae4ad984bf6$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $72eaeae4ad984bf6$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    moreMenuLabel: {
        id: 'navigation.global-side-navigation.more-menu.label',
        description: 'Label on More menu button in the side navigation. Shows a popout with items that are hidden from the main navigation.',
        defaultMessage: 'More'
    }
});

});

parcelRegister("k4oyr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee2a75a620ad0753$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $jpyeI = parcelRequire("jpyeI");

var $jRSFr = parcelRequire("jRSFr");
function $ee2a75a620ad0753$export$2e2bcd8739ae039({ id: id, items: items, shortcutItems: shortcutItems, onClick: onClick, onPeek: onPeek }) {
    const shortcutItem = shortcutItems?.[id];
    if (shortcutItem) return(// TODO: Should the global-shortcuts package handle rendering a more-menu version of the shortcut item?
    // Or should we handle that here?
    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $jpyeI.ButtonMenuItem), {
        children: [
            "Shortcut item ",
            id
        ]
    }));
    // Check if the item is in the items map
    const item = items[id];
    if (!item) throw new Error(`NavItem: No item found for id "${id}". Ensure the item is defined in appItems or globalItems.`);
    if (item.type === 'custom') // If the item is a custom item, render it directly
    return /*#__PURE__*/ (0, $2OMIu.jsx)(item.Component, {
        onPeek: ()=>onPeek?.(id),
        isInMoreMenu: true,
        onClick: onClick
    });
    const moreItem = $ee2a75a620ad0753$var$getPropsForItem({
        id: id,
        item: item,
        onClick: onClick,
        onPeek: onPeek
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jRSFr.default), {
        item: moreItem
    });
}
function $ee2a75a620ad0753$var$getPropsForItem({ id: id, item: item, onClick: onClick, onPeek: onPeek }) {
    if (item.type === 'expand' || item.type === 'flyout') return $ee2a75a620ad0753$var$getMorePropsForExpandFlyout({
        id: id,
        item: item,
        onClick: onClick,
        onPeek: onPeek
    });
    else if (item.type === 'button') return $ee2a75a620ad0753$var$getMorePropsForButton({
        item: item,
        onClick: onClick
    });
    else if (item.type === 'link') return $ee2a75a620ad0753$var$getMorePropsForLink({
        item: item,
        onClick: onClick
    });
    // If the item is not a button, link, expandable, or flyout, return as is
    return item;
}
function $ee2a75a620ad0753$var$getMorePropsForExpandFlyout({ id: id, item: item, onClick: onClick, onPeek: onPeek }) {
    const { type: type, children: children, ...rest } = item;
    const originalProps = item;
    const moreRest = {
        elemBefore: rest.elemBefore,
        onClick: (...args)=>{
            originalProps.onClick?.(...args);
            onClick?.();
            onPeek?.(id);
        }
    };
    // triggerLabel is available on both flyout and expandable items
    const moreChildren = item.triggerLabel;
    return {
        ...moreRest,
        // If the item is in the more menu and is an expandable or flyout item, render as a button with peek
        type: 'button',
        children: moreChildren
    };
}
function $ee2a75a620ad0753$var$getMorePropsForButton({ item: item, onClick: onClick }) {
    const { onClick: itemOnClick, ...rest } = item;
    // Remove props that are not appropriate for the more menu
    const moreRest = {
        actions: undefined,
        actionsOnHover: undefined,
        elemAfter: undefined,
        onClick: (...args)=>{
            itemOnClick?.(...args);
            onClick?.();
        }
    };
    return {
        ...rest,
        ...moreRest
    };
}
function $ee2a75a620ad0753$var$getMorePropsForLink({ item: item, onClick: onClick }) {
    const { onClick: itemOnClick, ...rest } = item;
    // Remove props that are not appropriate for the more menu
    const moreRest = {
        actions: undefined,
        actionsOnHover: undefined,
        elemAfter: undefined,
        onClick: (...args)=>{
            itemOnClick?.(...args);
            onClick?.();
        }
    };
    return {
        ...rest,
        ...moreRest
    };
}

});


parcelRegister("klQWJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c0a4825f8ea3361$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $6L0PY = parcelRequire("6L0PY");

var $hyKRO = parcelRequire("hyKRO");


var $3jzfH = parcelRequire("3jzfH");
function $3c0a4825f8ea3361$export$2e2bcd8739ae039({ useRecentItems: useRecentItems, searchable: searchable = true, searchPlaceholder: searchPlaceholder, filters: filters, viewAllHref: viewAllHref, viewAllOnClick: viewAllOnClick, peek: peek = false }) {
    const icon = /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hyKRO))), {
        label: ""
    });
    const label = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...(0, $3jzfH.messages).recentLabel
    });
    const filterConfig = filters ? {
        filters: filters
    } : undefined;
    const viewAllRecentLabels = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...(0, $3jzfH.messages).viewAllRecentsLabel
    });
    const actions = viewAllHref ? [
        {
            elemBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6L0PY))), {
                label: ''
            }),
            label: viewAllRecentLabels,
            href: viewAllHref,
            onClick: viewAllOnClick
        }
    ] : viewAllOnClick && [
        {
            elemBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6L0PY))), {
                label: ''
            }),
            label: viewAllRecentLabels,
            onClick: viewAllOnClick
        }
    ];
    return {
        // todo: Make i18n compatible
        name: (0, $3jzfH.messages).recentLabel.defaultMessage,
        icon: icon,
        type: 'object-list-flyout',
        testId: (0, $9bfc27aa5e32cb92$export$cfead128731b1701),
        label: label,
        searchPlaceholder: searchPlaceholder,
        filterConfig: filterConfig,
        actions: actions,
        isDefaultOpen: peek,
        isSearchable: searchable,
        useItems: useRecentItems
    };
}

});
const $9bfc27aa5e32cb92$export$cfead128731b1701 = 'gsn-recent';

parcelRegister("3jzfH", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b9c6010fdbdbb512$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $b9c6010fdbdbb512$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    recentLabel: {
        id: 'navigation.global-side-navigation.recents.label',
        description: 'Label on Recent button in the side navigation. Shows a flyout with recent items.',
        defaultMessage: 'Recent'
    },
    viewAllRecentsLabel: {
        id: 'navigation.global-side-navigation.recents.viewAllRecentsLabel',
        description: 'Label on View all recent items button in the recents flyout list.',
        defaultMessage: 'View all recent items'
    }
});

});


parcelRegister("9Wcev", function(module, exports) {

$parcel$export(module.exports, "default", () => $1251fcb248d59602$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $6L0PY = parcelRequire("6L0PY");

var $dAf5R = parcelRequire("dAf5R");


var $d40aL = parcelRequire("d40aL");
function $1251fcb248d59602$export$2e2bcd8739ae039({ useStarredItems: useStarredItems, searchPlaceholder: searchPlaceholder, searchable: searchable = true, filters: filters, viewAllHref: viewAllHref, viewAllOnClick: viewAllOnClick, peek: peek = false }) {
    const icon = /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dAf5R))), {
        label: ""
    });
    const label = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...(0, $d40aL.messages).starredLabel
    });
    const filterConfig = filters ? {
        filters: filters
    } : undefined;
    const viewAllStarredLabels = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...(0, $d40aL.messages).viewAllStarredLabel
    });
    const actions = viewAllHref ? [
        {
            elemBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6L0PY))), {
                label: ''
            }),
            label: viewAllStarredLabels,
            href: viewAllHref,
            onClick: viewAllOnClick
        }
    ] : viewAllOnClick && [
        {
            elemBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6L0PY))), {
                label: ''
            }),
            label: viewAllStarredLabels,
            onClick: viewAllOnClick
        }
    ];
    return {
        // todo: Make i18n compatible
        name: (0, $d40aL.messages).starredLabel.defaultMessage,
        icon: icon,
        type: 'object-list-flyout',
        testId: (0, $3418a81c24b7dba1$export$d8547b5f8547ae9a),
        label: label,
        searchPlaceholder: searchPlaceholder,
        filterConfig: filterConfig,
        actions: actions,
        isDefaultOpen: peek,
        isSearchable: searchable,
        useItems: useStarredItems
    };
}

});
const $3418a81c24b7dba1$export$d8547b5f8547ae9a = 'gsn-starred';
const $3418a81c24b7dba1$export$838ebd0369d69280 = 'gsn-starred-hidden';

parcelRegister("d40aL", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b512577ce53d6926$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $b512577ce53d6926$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    starredLabel: {
        id: 'navigation.global-side-navigation.starred.label',
        description: 'Label on Starred button in the side navigation. Shows a flyout with starred items.',
        defaultMessage: 'Starred'
    },
    viewAllStarredLabel: {
        id: 'navigation.global-side-navigation.starred.viewAllStarredLabel',
        description: 'Label on View all starred items button in the starred flyout list.',
        defaultMessage: 'View all starred items'
    }
});

});



parcelRegister("k8kcY", function(module, exports) {

$parcel$export(module.exports, "GlobalSideNavWrapper", () => $afa5f515cd622ccb$export$3f49897b3c92d5bd);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8WHRG = parcelRequire("8WHRG");
var $6l5pC = parcelRequire("6l5pC");

var $5eaCi = parcelRequire("5eaCi");

var $8Kaml = parcelRequire("8Kaml");
function $afa5f515cd622ccb$export$3f49897b3c92d5bd(props) {
    const { children: children, userMenuData: userMenuData, userSideNavData: userSideNavData, setUserMenuData: setUserMenuData, setUserSideNavData: setUserSideNavData } = props;
    // Split the data into two separate contexts, as they are edited at 2 different times.
    // (but we must always send an update with both data-sets inside)
    const userMenuValue = (0, $5uXOq.useMemo)(()=>({
            userMenuData: userMenuData,
            setUserMenuData: setUserMenuData
        }), [
        userMenuData,
        setUserMenuData
    ]);
    const userSideNavValue = (0, $5uXOq.useMemo)(()=>({
            userSideNavData: userSideNavData,
            setUserSideNavData: setUserSideNavData
        }), [
        userSideNavData,
        setUserSideNavData
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6l5pC.BFFProvider), {
        consumer: (0, $8WHRG.BFFConsumerEnum).GLOBAL_SIDE_NAVIGATION,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5eaCi.UserMenuDataProvider), {
            value: userMenuValue,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Kaml.UserSideNavDataProvider), {
                value: userSideNavValue,
                children: children
            })
        })
    });
}

});


parcelRegister("9wNZa", function(module, exports) {

$parcel$export(module.exports, "GlobalSideNavigationWithNetworkStore", () => $1bf25fbade2d8821$export$efce37544cc0e9d5);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");

var $75ltZ = parcelRequire("75ltZ");

var $6ch0y = parcelRequire("6ch0y");

var $k8kcY = parcelRequire("k8kcY");
function $1bf25fbade2d8821$export$efce37544cc0e9d5(props) {
    const { networkStorageParams: networkStorageParams, ...innerProps } = props;
    (0, $3joPi.default)(networkStorageParams?.entityAri && networkStorageParams?.ownerAri && networkStorageParams?.queryRef, 'Please provide networkStorageParams when using customization');
    // This is user data for the menu and the sidebar
    const userStoreProps = (0, $75ltZ.useNetworkSideNavUserData)(networkStorageParams);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8kcY.GlobalSideNavWrapper), {
        ...userStoreProps,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6ch0y.GlobalSideNavContent), {
            ...innerProps
        })
    });
}

});
parcelRegister("75ltZ", function(module, exports) {

$parcel$export(module.exports, "useNetworkSideNavUserData", () => $1df00165ef98020d$export$caed0b91aaed2955);

var $5Tc72 = parcelRequire("5Tc72");

var $NCGYA = parcelRequire("NCGYA");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");
const $1df00165ef98020d$var$DEFAULT_COLLAPSED_KEY = 'defaultCollapsed';
const $1df00165ef98020d$var$DEFAULT_WIDTH_KEY = 'defaultWidth';
function $1df00165ef98020d$export$caed0b91aaed2955(params) {
    const { entityAri: entityAri, ownerAri: ownerAri, queryRef: queryRef } = params;
    const queryData = $1df00165ef98020d$var$useLocalFragment(queryRef);
    const mutation = $1df00165ef98020d$var$useLocalMutation();
    // We store the state of the properties & customizationItems, as the sidebar state can change without any
    // new calls to the local queryRef (to read the value back). So we persist it in this component.
    const [sideNavProperties, setSideNavProperties] = (0, $5uXOq.useState)({
        defaultWidth: (queryData?.userSideNavSettings?.properties?.nodes ?? [
            {
                key: $1df00165ef98020d$var$DEFAULT_WIDTH_KEY,
                value: undefined
            }
        ]).find((item)=>item?.key === $1df00165ef98020d$var$DEFAULT_WIDTH_KEY)?.value ?? '',
        defaultCollapsed: (queryData?.userSideNavSettings?.properties?.nodes ?? [
            {
                key: $1df00165ef98020d$var$DEFAULT_COLLAPSED_KEY,
                value: undefined
            }
        ]).find((item)=>item?.key === $1df00165ef98020d$var$DEFAULT_COLLAPSED_KEY)?.value ?? ''
    });
    const [customizationItems, setCustomizationItems] = (0, $5uXOq.useState)($1df00165ef98020d$var$repairCustomizationItems(queryData?.userSideNavSettings?.sidebar?.nodes || []));
    // Create two callback functions - one for each user data-prop.
    // Not sure how performant this is, but it simplifies updates (because the caller doesn't need to know about the other half of the data)
    const setUserMenuData = (0, $5uXOq.useCallback)(async (userMenuData)=>{
        const sidebar = userMenuData;
        setCustomizationItems(sidebar);
        const properties = [
            {
                key: $1df00165ef98020d$var$DEFAULT_WIDTH_KEY,
                value: sideNavProperties.defaultWidth
            },
            {
                key: $1df00165ef98020d$var$DEFAULT_COLLAPSED_KEY,
                value: sideNavProperties.defaultCollapsed
            }
        ];
        return $1df00165ef98020d$var$executeMutation({
            mutation: mutation,
            variables: {
                entityAri: entityAri,
                ownerAri: ownerAri,
                properties: properties,
                sidebar: sidebar
            }
        });
    }, [
        entityAri,
        mutation,
        ownerAri,
        sideNavProperties
    ]);
    const setUserSideNavData = (0, $5uXOq.useCallback)(async (userSideNavData)=>{
        const sidebar = customizationItems;
        const newState = {
            defaultWidth: String(userSideNavData.defaultWidth ?? sideNavProperties.defaultWidth) || '',
            defaultCollapsed: String(userSideNavData.defaultCollapsed ?? sideNavProperties.defaultCollapsed) || 'false'
        };
        setSideNavProperties(newState);
        const properties = [
            {
                key: $1df00165ef98020d$var$DEFAULT_WIDTH_KEY,
                value: newState.defaultWidth
            },
            {
                key: $1df00165ef98020d$var$DEFAULT_COLLAPSED_KEY,
                value: newState.defaultCollapsed
            }
        ];
        return $1df00165ef98020d$var$executeMutation({
            mutation: mutation,
            variables: {
                entityAri: entityAri,
                ownerAri: ownerAri,
                properties: properties,
                sidebar: sidebar
            }
        });
    }, [
        entityAri,
        mutation,
        ownerAri,
        customizationItems,
        sideNavProperties
    ]);
    // Create a nicer shape for the data.
    // For the userSideNavData, it is ok for the values to be undefined,
    // as the ADS component will know what to do.
    const niceUserData = {
        userMenuData: customizationItems,
        userSideNavData: {
            defaultWidth: sideNavProperties.defaultWidth === '' ? undefined : Number(sideNavProperties.defaultWidth),
            defaultCollapsed: sideNavProperties.defaultCollapsed === '' ? undefined : sideNavProperties.defaultCollapsed === 'true'
        }
    };
    return {
        ...niceUserData,
        setUserMenuData: setUserMenuData,
        setUserSideNavData: setUserSideNavData
    };
}
/**
 * Make the Relay data look "normal" to the outside world.
 */ function $1df00165ef98020d$var$repairCustomizationItems(value) {
    return value;
}
function $1df00165ef98020d$var$useLocalFragment(queryRef) {
    /* eslint-disable @atlassian/relay/no-wrapping-hooks */ /* eslint-disable @atlassian/relay/unused-fields */ /* eslint-disable @atlassian/relay/graphql-naming */ return (0, $8Uumt.useFragment)((0, $NCGYA.default), queryRef);
/* eslint-enable @atlassian/relay/unused-fields */ }
function $1df00165ef98020d$var$useLocalMutation() {
    return (0, $8Uumt.useMutation)((0, $5Tc72.default))[0];
}
function $1df00165ef98020d$var$executeMutation({ mutation: mutation, variables: variables }) {
    try {
        return mutation({
            variables: variables,
            onCompleted: ()=>{
            // TODO: fire analytic event for success after NAVX-490 is merged
            },
            onError: ()=>{
            // TODO: fire analytic event for success after NAVX-490 is merged
            }
        });
    } catch (error) {}
}

});
parcelRegister("5Tc72", function(module, exports) {

$parcel$export(module.exports, "default", () => $0974f2ab5c1fc34e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1d0457520107accd0b712e336a38545f>>
 * @relayHash 84329df47f1d11ef5ea22b051cd3cb10
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bf42e7ddc009675a1a3a9d923a4bd3521ec33bd4d30cc6125170cdf92f31cb44
const $0974f2ab5c1fc34e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ownerAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "properties"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sidebar"
    }, v4 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "entityAri",
                    "variableName": "entityAri"
                },
                {
                    "kind": "Variable",
                    "name": "ownerAri",
                    "variableName": "ownerAri"
                },
                {
                    "kind": "Variable",
                    "name": "properties",
                    "variableName": "properties"
                },
                {
                    "kind": "Variable",
                    "name": "sidebar",
                    "variableName": "sidebar"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v5 = {
        "concreteType": "SettingsMenuItemConnection",
        "kind": "LinkedField",
        "name": "sidebar",
        "plural": false,
        "selections": [
            {
                "concreteType": "SettingsMenuItem",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "menuId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "visible"
                    }
                ]
            }
        ]
    }, v6 = {
        "concreteType": "SettingsDisplayPropertyConnection",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "SettingsDisplayProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useNetworkSideNavUserDataMutation",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "SettingsNavigationCustomisation",
                    "kind": "LinkedField",
                    "name": "settings_updateNavigationCustomisation",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useNetworkSideNavUserDataMutation",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "SettingsNavigationCustomisation",
                    "kind": "LinkedField",
                    "name": "settings_updateNavigationCustomisation",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "bf42e7ddc009675a1a3a9d923a4bd3521ec33bd4d30cc6125170cdf92f31cb44",
            "metadata": {},
            "name": "useNetworkSideNavUserDataMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$0974f2ab5c1fc34e$var$node.hash = "166e48d711d0b7e49b146e7ff8ab2745";
var $0974f2ab5c1fc34e$export$2e2bcd8739ae039 = $0974f2ab5c1fc34e$var$node;

});

parcelRegister("NCGYA", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d953aebad29db95$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cea65a1be7471930ba24878928a0bb2a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2d953aebad29db95$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "entityAriUserSideNavSettings"
        },
        {
            "kind": "RootArgument",
            "name": "ownerAri"
        }
    ],
    "kind": "Fragment",
    "name": "useNetworkSideNavUserData",
    "selections": [
        {
            "alias": "userSideNavSettings",
            "args": [
                {
                    "kind": "Variable",
                    "name": "entityAri",
                    "variableName": "entityAriUserSideNavSettings"
                },
                {
                    "kind": "Variable",
                    "name": "ownerAri",
                    "variableName": "ownerAri"
                }
            ],
            "concreteType": "SettingsNavigationCustomisation",
            "kind": "LinkedField",
            "name": "settings_navigationCustomisation",
            "plural": false,
            "selections": [
                {
                    "concreteType": "SettingsMenuItemConnection",
                    "kind": "LinkedField",
                    "name": "sidebar",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SettingsMenuItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "menuId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "visible"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "SettingsDisplayPropertyConnection",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SettingsDisplayProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$2d953aebad29db95$var$node.hash = "48a417a1d2876624970df89dfa84bb10";
var $2d953aebad29db95$export$2e2bcd8739ae039 = $2d953aebad29db95$var$node;

});




parcelRegister("bZAdI", function(module, exports) {

$parcel$export(module.exports, "getForYouConfig", () => $fd712c663b921e16$export$7929fceb464f62e7);
function $fd712c663b921e16$export$7929fceb464f62e7() {
    return {
        hideForYou: true,
        hideRecents: true,
        hideStarred: true
    };
}

});


parcelRegister("jNrrt", function(module, exports) {

$parcel$export(module.exports, "GSNForOtherSidebars", () => $bd297027abbf2b35$export$8c6d29ef23f67ed7);

var $5uXOq = parcelRequire("5uXOq");

var $6HuKm = parcelRequire("6HuKm");

var $bZAdI = parcelRequire("bZAdI");
const $bd297027abbf2b35$var$forYouConfig = (0, $bZAdI.getForYouConfig)();
function $bd297027abbf2b35$export$8c6d29ef23f67ed7({ sidebarId: sidebarId }) {
    /*
	  TODO:
		    1. render other sidebars within `postMainElement`
			2. disable customisation
			3. Return GSN component
	*/ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6HuKm.GlobalSideNavigation), {
        app: "jira",
        customizationStore: "local",
        forYou: $bd297027abbf2b35$var$forYouConfig,
        items: {},
        testId: "nav-platform-integration-sidebar.ui.jira-other-sidebars"
    });
}

});


parcelRegister("gxq4u", function(module, exports) {

$parcel$export(module.exports, "messages", () => $17a71abc75e8d96c$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $17a71abc75e8d96c$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    sidebarNavigation: {
        "id": "page-container-v2.common.sidebar.sidebar-navigation",
        "defaultMessage": "Sidebar navigation"
    },
    sideBarPanelSplitterLabel: {
        "id": "page-container-v2.common.sidebar.side-bar-panel-splitter-label",
        "defaultMessage": "Resize side navigation panel"
    },
    globalInviteButtonLabel: {
        "id": "page-container-v2.common.sidebar.global-invite-button-label",
        "defaultMessage": "Invite people"
    }
});

});

parcelRegister("7x18A", function(module, exports) {

$parcel$export(module.exports, "AsyncResizeButtonTooltip", () => $15587b8ab3be3aba$export$e12f5b3a390577de);

var $kxZPA = parcelRequire("kxZPA");

const $15587b8ab3be3aba$export$e12f5b3a390577de = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("e6Hbc")), {
    ssr: false,
    moduleId: "./src/packages/page-container-v2/src/common/ui/sidebar/resize-button-tooltip/main.tsx"
});

});
parcelRegister("e6Hbc", function(module, exports) {

let $a4531ed02cff00fc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a4531ed02cff00fc$var$load("e0yJk").then(()=>parcelRequire('iIrS6'));

});



parcelRegister("gxCm0", function(module, exports) {

$parcel$export(module.exports, "TopNav", () => $5815562a2673ba2a$export$41d0d88a6b0e456f);

var $5uXOq = parcelRequire("5uXOq");

var $5e7oM = parcelRequire("5e7oM");

var $azzrO = parcelRequire("azzrO");

var $Mp6qH = parcelRequire("Mp6qH");

var $ghgbB = parcelRequire("ghgbB");

var $eoNiZ = parcelRequire("eoNiZ");

var $e6AHy = parcelRequire("e6AHy");


var $gwIPs = parcelRequire("gwIPs");

var $7CMCs = parcelRequire("7CMCs");

var $93jKl = parcelRequire("93jKl");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $3bl6P = parcelRequire("3bl6P");

var $9aaiB = parcelRequire("9aaiB");

var $5X3WH = parcelRequire("5X3WH");

var $3HwlS = parcelRequire("3HwlS");

var $iqLcb = parcelRequire("iqLcb");

var $lfTZh = parcelRequire("lfTZh");

var $5M3R9 = parcelRequire("5M3R9");

var $l8ruj = parcelRequire("l8ruj");

var $erBFB = parcelRequire("erBFB");

var $dm0Uk = parcelRequire("dm0Uk");

var $iIpJ6 = parcelRequire("iIpJ6");
/* IMPORTANT:
 * When making any changes to the OLD component, please ensure that you also make the same changes to the
 * NEW component. The feature flag used is part of the Navigation Refresh work and we need to ensure that
 * we do not introduce tech debt for the roll-out by only updating the current component that is due to be
 * removed.
 *
 * If you have any concerns or questions please reach out to the #jira-navigation channel. Thanks!
 */ const $5815562a2673ba2a$var$APP_NAVIGATION_TRACE_KEY = 'app_navigation';
const $5815562a2673ba2a$var$LegacyPageNavigationStyles = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `
                    #page-body { width: 100vw; max-width: 100%; }
                    #cloneissueprogressform { margin-top: ${(0, $gwIPs.gridSize) * 3}px; }
                    [data-testid="Content"] {margin-top: calc(${(0, $81918a2ef6db1f93$export$d60454526e2281af)})!important;}
                    #view-projects-content { margin-top: calc(-1 * ${(0, $81918a2ef6db1f93$export$d60454526e2281af)}); } /* admin project dir hack */
                `
        }
    });
/**
 * This test ID is used in pollinator tests. Do not change lightly.
 * It's only added once the component is rendered client-side.
 */ const $5815562a2673ba2a$var$TEST_ID = 'page-layout.top-nav';
function $5815562a2673ba2a$var$NewTopNav() {
    const { shouldRender: shouldRender } = (0, $9aaiB.useTopNavState)();
    const theme = (0, $eoNiZ.useNav4Theme)();
    // Signal that Nav4 has been seen. Memoized, so it's safe to use it like this.
    if ((0, $4R6GH.fg)('jira_nav_version_exposure')) (0, $5X3WH.sendNavExposure)({
        componentName: 'nav4'
    });
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4.topNav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "topNavigationSkipLink",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $erBFB.TopNavigationSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5815562a2673ba2a$var$LegacyPageNavigationStyles, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.TopNavigation), {
        isFixed: true,
        testId: $5815562a2673ba2a$var$TEST_ID,
        theme: theme
    }, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ghgbB.AtlassianNavigationStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "navigation.atlassian-navigation",
        packageName: "jiraPageContainerV2",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.PlaceholderNew), {
        name: "top_navigation_skeleton",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e6AHy.JiraAtlassianNavigationSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iIpJ6.AsyncAtlassianNavigation), null)))));
}
/**
 * This has been inlined from `@atlassian/jira-common-constants/src/page-layout`
 * because it isn't used anywhere else, and to prevent new usage.
 */ const $5815562a2673ba2a$var$HORIZONTAL_GLOBAL_NAV_HEIGHT = 56;
/**
 * Implements a responsive top navigation bar that adjusts for fullscreen view and renders
 * based on application state. It ensures seamless navigation experience across different
 * sections of the application while handling errors gracefully and tracking performance.
 */ function $5815562a2673ba2a$var$OldTopNav() {
    const fullscreenRef = (0, $5uXOq.useRef)(null);
    const { isFullscreen: isFullscreen } = (0, $3bl6P.useIsFullscreen)(fullscreenRef.current);
    const { shouldRender: shouldRender } = (0, $9aaiB.useTopNavState)();
    const onFail = (0, $93jKl.useExperienceFail)({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MAIN)
    });
    if ((0, $4R6GH.fg)('jira_nav_version_exposure')) (0, $5X3WH.sendNavExposure)({
        componentName: 'nav3'
    });
    const height = isFullscreen ? 0 : $5815562a2673ba2a$var$HORIZONTAL_GLOBAL_NAV_HEIGHT;
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "top-navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "topNavigationSkipLink",
        packageName: "jiraPageContainer",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $erBFB.TopNavigationSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5815562a2673ba2a$var$LegacyPageNavigationStyles, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dm0Uk.ZIndexWrapper), {
        zIndex: (0, $gwIPs.layers).navigation,
        // @ts-expect-error - TS2322 - Type '{ children: Element; zIndex: 200; top: string; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<Component<ThemedOuterStyledProps<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, any>, any, any>> & Readonly<...> & Readonly<...>'.
        top: (0, $iqLcb.UNSAFE_DO_NOT_USE_BANNER_HEIGHT),
        "data-fullscreen-id": "fullscreen.page-container-v2.topnav",
        ref: fullscreenRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.TopNavigation), {
        isFixed: true,
        height: height,
        id: "ak-jira-navigation"
    }, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ghgbB.AtlassianNavigationStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "navigation.atlassian-navigation",
        packageName: "jiraPageContainer",
        fallback: "flag",
        onError: onFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "top_navigation_skeleton",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e6AHy.JiraAtlassianNavigationSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavTopPerformanceMark), {
        metricKey: (0, $5e7oM.NAVIGATION_TOP_MARKS).bundleLoadStart
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5M3R9.RenderTracerMark), {
        type: "start",
        traceKey: $5815562a2673ba2a$var$APP_NAVIGATION_TRACE_KEY
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iIpJ6.AsyncAtlassianNavigation), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5M3R9.RenderTracerMark), {
        type: "end",
        traceKey: $5815562a2673ba2a$var$APP_NAVIGATION_TRACE_KEY
    }))))));
}
const $5815562a2673ba2a$export$41d0d88a6b0e456f = (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), $5815562a2673ba2a$var$NewTopNav, $5815562a2673ba2a$var$OldTopNav);

});
parcelRegister("ghgbB", function(module, exports) {

$parcel$export(module.exports, "AtlassianNavigationStart", () => $d610646e169deef8$export$831e6a6e875b5ef8);

var $5uXOq = parcelRequire("5uXOq");

var $kaHBi = parcelRequire("kaHBi");

var $8CVvd = parcelRequire("8CVvd");


var $4oDnX = parcelRequire("4oDnX");

var $6IzHB = parcelRequire("6IzHB");

var $doZTA = parcelRequire("doZTA");

var $Mp6qH = parcelRequire("Mp6qH");
const $d610646e169deef8$export$831e6a6e875b5ef8 = ()=>{
    const [{ location: location }] = (0, $doZTA.useRouter)();
    const [, { setAppStartWithAppId: setAppStartWithAppId }] = (0, $4oDnX.useSpaStateActions)();
    const pageId = (0, $6IzHB.usePageId)();
    const startRef = (0, $5uXOq.useRef)({
        location: location,
        startTime: Date.now()
    });
    (0, $5uXOq.useMemo)(()=>{
        if (location !== startRef.current.location) startRef.current = {
            location: location,
            startTime: Date.now()
        };
    }, [
        location
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        setAppStartWithAppId((0, $146ecce9d079a34d$export$3a54edb6ba4daa82), startRef.current.startTime);
    }, [
        location,
        setAppStartWithAppId
    ]);
    return (0, $8CVvd.getWillShowNav3)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kaHBi.ExperienceStart), {
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MAIN),
        analyticsSource: "atlassian-navigation",
        experienceId: pageId
    });
};

});

parcelRegister("eoNiZ", function(module, exports) {

$parcel$export(module.exports, "useTheme", () => $96d5309c36bfdfee$export$93d4e7f90805808f);
$parcel$export(module.exports, "useNav4Theme", () => $96d5309c36bfdfee$export$b761e7abf0bdf352);

var $5uXOq = parcelRequire("5uXOq");

var $4sCvx = parcelRequire("4sCvx");

var $kTHGn = parcelRequire("kTHGn");
var $hxoiH = parcelRequire("hxoiH");

var $9MAC1 = parcelRequire("9MAC1");

var $2Ql51 = parcelRequire("2Ql51");

var $bt2pf = parcelRequire("bt2pf");

var $ihBhD = parcelRequire("ihBhD");
const $96d5309c36bfdfee$var$caseInsensitiveEquals = (one, two)=>one.toLowerCase() === two.toLowerCase();
const $96d5309c36bfdfee$var$calculateBackground = (backgroundColor, isDarkMode)=>{
    // White is a proxy for 'default' when setting accent colours, we really want to default to 'elevation.surface'
    if ($96d5309c36bfdfee$var$caseInsensitiveEquals(backgroundColor, '#ffffff')) {
        // getTokenValue doesn't work in SSR thus hardcode, fix in: https://product-fabric.atlassian.net/browse/DSP-9781
        const fallback = isDarkMode ? '#1d2125' : '#ffffff';
        // Can't be getToken() as AK Nav needs a hex string. It parses it to determine the correct text color
        return (0, $kTHGn.default)('elevation.surface', fallback);
    }
    return isDarkMode ? (0, $ihBhD.capLightness)(backgroundColor, 35) : backgroundColor;
};
const $96d5309c36bfdfee$var$useIsDarkThemeResolver = ()=>{
    // The best source of theme info. But doesn't work in SSR, fix in: https://product-fabric.atlassian.net/browse/DSP-9781
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    // This works in SSR, but we need the browser to resolve 'auto', so we are wrong in SSR if 'auto' resolves to 'dark'
    const { theme: preference } = (0, $2Ql51.useThemePreference)();
    return false ? preference === 'dark' : colorMode === 'dark';
};
const $96d5309c36bfdfee$export$93d4e7f90805808f = ()=>{
    const [{ navigationTheme: { usesCustomColours: usesCustomColours, backgroundColor: backgroundColor, highlightColor: highlightColor } }] = (0, $9MAC1.useTheme)();
    const isDarkMode = $96d5309c36bfdfee$var$useIsDarkThemeResolver();
    const bg = (0, $5uXOq.useMemo)(()=>$96d5309c36bfdfee$var$calculateBackground(backgroundColor, isDarkMode), [
        backgroundColor,
        isDarkMode
    ]);
    (0, $5uXOq.useEffect)(()=>{
        (0, $bt2pf.addThemeColor)(bg);
    }, [
        bg
    ]);
    if (!usesCustomColours) return undefined;
    return (0, $4sCvx.generateTheme)({
        name: 'jira',
        backgroundColor: bg,
        highlightColor: highlightColor
    });
};
const $96d5309c36bfdfee$export$b761e7abf0bdf352 = ()=>{
    /**
   * The colors chosen by the site admin in the site settings
   */ const [{ navigationTheme: { usesCustomColours: usesCustomColours, backgroundColor: backgroundColor, highlightColor: highlightColor } }] = (0, $9MAC1.useTheme)();
    /**
   * Whether the user is currently using dark mode,
   * or their configured preference if this is SSR.
   */ const isDarkMode = $96d5309c36bfdfee$var$useIsDarkThemeResolver();
    /**
   * The adjusted background color.
   *
   * When the user is in dark mode, the lightness of the background color is capped.
   */ const bg = (0, $5uXOq.useMemo)(()=>$96d5309c36bfdfee$var$calculateBackground(backgroundColor, isDarkMode), [
        backgroundColor,
        isDarkMode
    ]);
    /**
   * Creates / updates a theme-color meta tag:
   * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/meta/name/theme-color
   *
   * Some browsers will use this to change the color of their UI.
   */ (0, $5uXOq.useEffect)(()=>{
        (0, $bt2pf.addThemeColor)(bg);
    }, [
        bg
    ]);
    if (!usesCustomColours) return undefined;
    return {
        backgroundColor: bg,
        highlightColor: highlightColor
    };
};

});
parcelRegister("bt2pf", function(module, exports) {

$parcel$export(module.exports, "addThemeColor", () => $274a73c0f1d6297a$export$7b20d133831b2b0f);
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/jira-ssr/no-unchecked-globals-usage
const $274a73c0f1d6297a$var$getMetaNode = (name)=>document.querySelector(`meta[name="${name}"]`);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $274a73c0f1d6297a$var$getHead = ()=>document.head || document.querySelector('head');
const $274a73c0f1d6297a$export$7b20d133831b2b0f = (content)=>{
    if (!content || typeof document === 'undefined' || false) return;
    const existingMeta = $274a73c0f1d6297a$var$getMetaNode('theme-color');
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const meta = document.createElement('meta');
    meta.name = 'theme-color';
    meta.content = content;
    if (existingMeta) existingMeta.replaceWith?.(meta);
    else {
        const head = $274a73c0f1d6297a$var$getHead();
        if (head) head.appendChild?.(meta);
    }
};

});

parcelRegister("ihBhD", function(module, exports) {

$parcel$export(module.exports, "capLightness", () => $dbd7508aaed6851f$export$8b5544bab97b10dd);
const $dbd7508aaed6851f$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
const $dbd7508aaed6851f$var$expandShorthandHex = (input)=>input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b)=>r + r + g + g + b + b);
const $dbd7508aaed6851f$var$rgbFromHex = (input)=>{
    const fullHex = $dbd7508aaed6851f$var$expandShorthandHex(input);
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
const $dbd7508aaed6851f$var$rgbToHex = ({ r: r, g: g, b: b })=>{
    const convertComponent = (c)=>{
        const cBase16 = c.toString(16);
        return cBase16.length === 1 ? `0${cBase16}` : cBase16;
    };
    return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
};
const $dbd7508aaed6851f$var$rgbToXyz = (rgb)=>{
    const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    const r = convertRgbComponent(rgb.r / 255);
    const g = convertRgbComponent(rgb.g / 255);
    const b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
const $dbd7508aaed6851f$var$xyzToLab = ({ x: x, y: y, z: z })=>({
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    });
const $dbd7508aaed6851f$var$labToLch = ({ l: l, a: a, b: b })=>{
    let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
const $dbd7508aaed6851f$var$lchToLab = ({ l: l, c: c, h: h })=>{
    const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
const $dbd7508aaed6851f$var$labToXyz = ({ l: l, a: a, b: b })=>{
    const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    const y = (l + 16) / 116;
    const x = a / 500 + y;
    const z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
const $dbd7508aaed6851f$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
    const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    return {
        r: $dbd7508aaed6851f$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $dbd7508aaed6851f$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $dbd7508aaed6851f$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
const $dbd7508aaed6851f$var$rgbToLch = (rgb)=>$dbd7508aaed6851f$var$labToLch($dbd7508aaed6851f$var$xyzToLab($dbd7508aaed6851f$var$rgbToXyz(rgb)));
const $dbd7508aaed6851f$var$lchToRgb = (lch)=>$dbd7508aaed6851f$var$xyzToRgb($dbd7508aaed6851f$var$labToXyz($dbd7508aaed6851f$var$lchToLab(lch)));
const $dbd7508aaed6851f$export$8b5544bab97b10dd = (color, capPercent)=>{
    const rgb = $dbd7508aaed6851f$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $dbd7508aaed6851f$var$rgbToLch(rgb);
    if (lch.l > capPercent) lch.l = $dbd7508aaed6851f$var$clamp(capPercent, 0, 100);
    return $dbd7508aaed6851f$var$rgbToHex($dbd7508aaed6851f$var$lchToRgb(lch));
};

});


parcelRegister("e6AHy", function(module, exports) {

$parcel$export(module.exports, "JiraAtlassianNavigationSkeleton", () => $33751c6bf425b3ee$export$38e532bc6b824200);

var $5uXOq = parcelRequire("5uXOq");

var $f76p2 = parcelRequire("f76p2");

var $fNobW = parcelRequire("fNobW");

var $eoNiZ = parcelRequire("eoNiZ");
const $33751c6bf425b3ee$export$38e532bc6b824200 = ()=>{
    const theme = (0, $eoNiZ.useTheme)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "top-navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f76p2.NavigationSkeleton), {
        theme: theme
    }));
};

});

parcelRegister("3bl6P", function(module, exports) {

$parcel$export(module.exports, "useIsFullscreen", () => $0124d1f81a2437a4$export$d397eccea5f37b0a);

var $5uXOq = parcelRequire("5uXOq");
const $0124d1f81a2437a4$var$fullscreenClassnameExists = (target)=>target?.classList.contains('fullscreen') ?? false;
const $0124d1f81a2437a4$export$d397eccea5f37b0a = (target)=>{
    const [isFullscreen, setIsFullscreen] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        const handleFullscreen = ()=>{
            setIsFullscreen($0124d1f81a2437a4$var$fullscreenClassnameExists(target));
        };
        const mutationObserver = new MutationObserver(handleFullscreen);
        if (target) mutationObserver.observe(target, {
            attributes: true
        });
        return ()=>mutationObserver.disconnect();
    }, [
        target
    ]);
    return {
        isFullscreen: isFullscreen
    };
};

});

parcelRegister("9aaiB", function(module, exports) {

$parcel$export(module.exports, "useTopNavState", () => $dd484d7e2bde5991$export$bccbd45ab793bd09);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");

var $5e5zm = parcelRequire("5e5zm");
const $dd484d7e2bde5991$var$useTopNav = (0, $3sQ5x.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>({
            ...state.topNavigation,
            shouldRender: !state.isChromeless
        })
});
const $dd484d7e2bde5991$export$bccbd45ab793bd09 = ()=>{
    const [state] = $dd484d7e2bde5991$var$useTopNav();
    return state;
};

});

parcelRegister("5X3WH", function(module, exports) {

$parcel$export(module.exports, "sendNavExposure", () => $f4ce7b379b641f97$export$4d75b96ec704d87d);

var $gJBT6 = parcelRequire("gJBT6");

var $4R6GH = parcelRequire("4R6GH");

var $3F9p6 = parcelRequire("3F9p6");

var $fjcgS = parcelRequire("fjcgS");
const $f4ce7b379b641f97$export$4d75b96ec704d87d = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))($f4ce7b379b641f97$var$_sendNavExposure, (p)=>p.componentName);
/**
 * Note: The componentName is being used as the actionSubject.
 *       When a new navigation-version is released, it will require registering
 *       a new GASv3 event and a new trait. THIS IS BY DESIGN, as the creation
 *       of new navigation systems is infrequent (every 2-3 years).
 */ function $f4ce7b379b641f97$var$_sendNavExposure(params) {
    const { componentName: componentName } = params;
    if ((0, $4R6GH.fg)('jira_mobile_opt_out_nav4_trait')) {
        const nav4RolloutStage = (0, $3F9p6.getNav4Rollout)().stage;
        /**
		 * Prevent mobile nav4 views from registering the trait as having seen Nav4
		 * This is because mobile users have only seen a small subset of Nav4
		 */ if (nav4RolloutStage === 'mobile') // Return the component name to help memoize do it's job
        return componentName;
    }
    // This analytics event updates it's corresponding TAP trait,
    // once the GAS event is registered, and then the TAP trait is registered.
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        client.getInstance().sendTrackEvent({
            actionSubject: componentName,
            action: 'viewed',
            source: 'navExposure',
            attributes: {}
        });
    });
    // Return the component name to help memoize do it's job
    return componentName;
}

});

parcelRegister("iIpJ6", function(module, exports) {

$parcel$export(module.exports, "AsyncAtlassianNavigation", () => $8c4a7263d22ebdbf$export$932edb7b1b20d079);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $adY3A = parcelRequire("adY3A");

var $9DfkH = parcelRequire("9DfkH");

var $e6AHy = parcelRequire("e6AHy");

var $fDtbf = parcelRequire("fDtbf");


var $2Ioew = parcelRequire("2Ioew");

var $frBVt = parcelRequire("frBVt");

var $2SVPM = parcelRequire("2SVPM");
const $8c4a7263d22ebdbf$export$932edb7b1b20d079 = ()=>{
    const topNavEntryPointReference = (0, $2Ioew.usePageLayoutEntryPoint)((0, $6d6ccf8a2b2c5b3c$export$bec6dca2e63de4ae));
    (0, $5uXOq.useState)(()=>{
        if (!false && topNavEntryPointReference) /* @ts-expect-error - TS2339 - We're using JSResourceReference from @atlassian/react-async. */ (0, $adY3A.topNavigationEntryPoint).root.onComplete(()=>{
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.bundle-ready', 'jira-spa.js:eval-stop');
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const resources = performance.getEntriesByType('mark');
            for(let i = resources.length - 1; i >= 0; i -= 1)if ((resources[i].name.startsWith('async-navigation') || resources[i].name.startsWith('async-atlassian-navigation')) && resources[i].name.endsWith((0, $fDtbf.JS_EVAL_START))) {
                (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.eval', resources[i].name);
                break;
            }
        });
        return undefined;
    });
    return topNavEntryPointReference ? // There is already a Placeholder in parent
    // remove this one when EntryPointPlaceholder merges with Placeholder
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $frBVt.EntryPointReferencePlaceholder), {
        name: "top_navigation_skeleton",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e6AHy.JiraAtlassianNavigationSkeleton), null),
        entryPointReference: topNavEntryPointReference
    }, topNavEntryPointReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
        entryPointReference: topNavEntryPointReference,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props: {}
    }) : null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9DfkH.AtlassianNavigation), null);
};

});
parcelRegister("9DfkH", function(module, exports) {

$parcel$export(module.exports, "AtlassianNavigation", () => $daeb815c48fa02e2$export$f66ccb39f60980e5);

var $5uXOq = parcelRequire("5uXOq");

var $giIZN = parcelRequire("giIZN");

var $5e7oM = parcelRequire("5e7oM");

var $azzrO = parcelRequire("azzrO");

var $13iNl = parcelRequire("13iNl");

var $4keKa = parcelRequire("4keKa");

var $9WcgH = parcelRequire("9WcgH");

var $bcn6L = parcelRequire("bcn6L");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $jp5kW = parcelRequire("jp5kW");

var $c0dQj = parcelRequire("c0dQj");

var $bBulW = parcelRequire("bBulW");

var $jzLyJ = parcelRequire("jzLyJ");

var $3HwlS = parcelRequire("3HwlS");

var $6jY6G = parcelRequire("6jY6G");

var $dAfqg = parcelRequire("dAfqg");

var $apeap = parcelRequire("apeap");

var $daoB1 = parcelRequire("daoB1");

var $koeKL = parcelRequire("koeKL");

var $cZpsT = parcelRequire("cZpsT");

var $cNd4s = parcelRequire("cNd4s");

var $7XYc4 = parcelRequire("7XYc4");

var $lfTZh = parcelRequire("lfTZh");

var $e6AHy = parcelRequire("e6AHy");

var $l0cYe = parcelRequire("l0cYe");

var $eoNiZ = parcelRequire("eoNiZ");

var $bWmoi = parcelRequire("bWmoi");

var $jUhOq = parcelRequire("jUhOq");

var $96WTB = parcelRequire("96WTB");

var $crC7i = parcelRequire("crC7i");

var $MBTxm = parcelRequire("MBTxm");

var $jyW1v = parcelRequire("jyW1v");

var $inFGE = parcelRequire("inFGE");

var $klog1 = parcelRequire("klog1");

var $7bwNu = parcelRequire("7bwNu");

var $0396H = parcelRequire("0396H");

var $fwJYI = parcelRequire("fwJYI");

var $ag3PC = parcelRequire("ag3PC");

var $2YzXO = parcelRequire("2YzXO");

var $2E6jA = parcelRequire("2E6jA");


const $daeb815c48fa02e2$var$Nav4AppSwitcherMaybe = (parcelRequire("hyppP")).default;
const $daeb815c48fa02e2$var$isSPA = ()=>{
    if (false) return false;
    if (typeof window !== 'undefined') return window.__SPA__;
    return false;
};
const $daeb815c48fa02e2$var$TopNavComponent = (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), $daeb815c48fa02e2$var$Nav4TopNav, $daeb815c48fa02e2$var$Nav3TopNav);
function $daeb815c48fa02e2$export$f66ccb39f60980e5() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($daeb815c48fa02e2$var$TopNavComponent, null), (0, $4R6GH.fg)('jira_nav4') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jzLyJ.default), null), (0, $4R6GH.fg)('jira_mobile_web_mvp_2_feature_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0dQj.MobileWebExperimentExposure), null), (0, $4R6GH.fg)('jira_mobile_web_mvp_view_panel_kill_switch') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0dQj.MobileWebExperimentViewPanelNewTenantsExposure), null), (0, $4R6GH.fg)('jira_mobile_web_mvp_view_panel_kill_switch') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0dQj.MobileWebExperimentViewPanelExistingUserExposure), null));
}
function $daeb815c48fa02e2$var$Nav4TopNav() {
    const theme = (0, $eoNiZ.useTheme)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isMobileExperience = (0, $c0dQj.isMobileAndInMvpOrExistingUsersExperiment)();
    const nav4NavigationProps = (0, $5uXOq.useMemo)(()=>isMobileExperience ? {
            hideSideNavToggleButton: true,
            renderSearch: (0, $c0dQj.isMobileAndInViewPanelIterationExperiment)() ? (0, $fwJYI.Search) : undefined,
            renderNotifications: (0, $c0dQj.isMobileAndInViewPanelIterationExperiment)() ? (0, $inFGE.Notifications) : undefined
        } : {
            renderAppSwitcher: $daeb815c48fa02e2$var$Nav4AppSwitcherMaybe,
            renderSearch: (0, $fwJYI.Search),
            renderEditionAwareness: (0, $bBulW.EditionAwareness),
            renderHelp: (0, $crC7i.Help),
            renderNotifications: (0, $inFGE.Notifications),
            renderConversationAssistant: (0, $jUhOq.ConversationAssistant),
            renderSettings: (0, $ag3PC.Settings),
            renderProfile: (0, $7bwNu.Profile),
            renderSignIn: (0, $2YzXO.SignIn)
        }, [
        isMobileExperience
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $giIZN.TopNav4), {
        renderProductHome: (0, $klog1.ProductHome),
        renderCreate: (0, $96WTB.Create),
        renderNav4Notifications: (0, $2E6jA.Nav4NotificationsData),
        ...nav4NavigationProps,
        theme: theme,
        label: formatMessage((0, $jyW1v.default).topNav)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0396H.NavigationRouterListener), null), isSiteAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9WcgH.default), null));
}
function $daeb815c48fa02e2$var$Nav3TopNav() {
    const topNavSegment = (0, $azzrO.useNavPerformanceMetrics)();
    topNavSegment.mark((0, $5e7oM.NAVIGATION_TOP_MARKS).renderStart);
    const cloudId = (0, $koeKL.useCloudId)();
    const applicationPermissions = (0, $daoB1.useApplicationPermissions)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const renderNavigation = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $4R6GH.fg)('jfp-magma-concurrent-fix-entrypoint-placeholder') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "atlassian-navigation-top-nav-3-placeholder",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e6AHy.JiraAtlassianNavigationSkeleton), null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWmoi.TopNav3Async), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWmoi.TopNav3Async), null), !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !isAnonymous && !(0, $jp5kW.default)('navigation.disable.prefetched.data.for.dropdowns') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MBTxm.InitialDataLoader), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4keKa.RecommendationLoader), {
            recommendations: (0, $13iNl.recommendations)
        })))), [
        isAnonymous
    ]);
    const routeName = route.name ?? route.group ?? 'UNKNOWN';
    const projectContext = (0, $dAfqg.useProjectContext)();
    const customData = (0, $5uXOq.useMemo)(()=>{
        return {
            route: routeName,
            projectType: projectContext?.data?.projectType ?? 'UNKNOWN',
            isSPA: $daeb815c48fa02e2$var$isSPA()
        };
    }, [
        routeName,
        projectContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l0cYe.NavigationSuccessTrackerForNav3), null, isAnonymous ? renderNavigation() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $apeap.RecentsContainer), {
        isGlobal: true,
        cloudId: cloudId,
        applicationPermissions: applicationPermissions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bcn6L.FavoritesContainer), {
        isGlobal: true,
        applicationPermissions: applicationPermissions
    }, renderNavigation()))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0396H.NavigationRouterListener), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavTopPerformanceMark), {
        metricKey: (0, $5e7oM.NAVIGATION_TOP_MARKS).renderEnd
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavTopPerformanceReport), {
        customData: customData
    }), isSiteAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9WcgH.default), null));
}

});
parcelRegister("giIZN", function(module, exports) {

$parcel$export(module.exports, "TopNav4", () => $f3f38d07fe974d70$export$76799253f2c58923);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $l8ruj = parcelRequire("l8ruj");

var $7CMCs = parcelRequire("7CMCs");


var $7XYc4 = parcelRequire("7XYc4");

var $j8DrX = parcelRequire("j8DrX");

var $aJJ7X = parcelRequire("aJJ7X");

var $1hrBl = parcelRequire("1hrBl");
// TODO: Remove all AtlaskitAtlassianNavigationNav4 when cleaning up blu-7584-replace-nav4-profile-query
const $f3f38d07fe974d70$var$TopNavComponent = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('blu-7584-replace-nav4-profile-query'), (0, $aJJ7X.AtlassianNavigationNav4), (0, $1hrBl.AtlaskitAtlassianNavigationNav4));
function $f3f38d07fe974d70$export$76799253f2c58923(props) {
    // This is defensive code to prevent making a request for data that will never be returned.
    // Only Customer Accounts have customer service access. These are non-Atlassian accounts considered
    // second-party party customers and should only have access to the JSM Help Center. They should
    // never have access to the regular Jira UI so should never see this top navigation. If we detect
    // that this is a customer account request we will not render the top navigation at all.
    // See https://jplat.atlassian.net/browse/BLU-7341 for context.
    if ((0, $4R6GH.fg)('blu-7341-fix_top_nav_query_for_unauthorized_users')) {
        if ((0, $j8DrX.default)('ajs-account-type') === 'customer') return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "atlaskit-atlassian-navigation-nav4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "AtlaskitAtlassianNavigationNav4",
        packageName: (0, $acc1306b50923620$export$b8b9d90f9e5bd72b),
        teamName: (0, $acc1306b50923620$export$d57b6b390e78d90f),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f3f38d07fe974d70$var$TopNavComponent, props)));
}

});
const $acc1306b50923620$export$b8b9d90f9e5bd72b = 'jiraAtlassianNavigationNav4';
const $acc1306b50923620$export$d57b6b390e78d90f = 'jira-cosmos';
const $acc1306b50923620$export$69cbedccc0df48 = 'viewAtlassianNavigationMenu';

parcelRegister("aJJ7X", function(module, exports) {

$parcel$export(module.exports, "AtlassianNavigationNav4", () => $4b99dec112a4da20$export$40fab2fde5132498);

var $dBV7w = parcelRequire("dBV7w");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $6yyGB = parcelRequire("6yyGB");
var $hNNQM = parcelRequire("hNNQM");
var $58vAb = parcelRequire("58vAb");
var $kpxAO = parcelRequire("kpxAO");

var $j3oGS = parcelRequire("j3oGS");

var $5NM6P = parcelRequire("5NM6P");

var $6Lyip = parcelRequire("6Lyip");

var $koVbs = parcelRequire("koVbs");

var $fwzEJ = parcelRequire("fwzEJ");




var $ivGSs = parcelRequire("ivGSs");

var $3F9p6 = parcelRequire("3F9p6");

var $4DrQd = parcelRequire("4DrQd");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");

var $ao2h1 = parcelRequire("ao2h1");

var $cZpsT = parcelRequire("cZpsT");

var $6s1PB = parcelRequire("6s1PB");

var $5NqEU = parcelRequire("5NqEU");

var $1pdD9 = parcelRequire("1pdD9");

var $hpMM8 = parcelRequire("hpMM8");
function $4b99dec112a4da20$export$40fab2fde5132498(props) {
    const { queryReference: queryReference } = (0, $ao2h1.useRelayResource)((0, $fwzEJ.topNav4UIStateResourceNew)); // This intermediate step is to avoid using a null queryReference.
    // Maybe this should be a skeleton? Or is that taken care of by the page-container-v2?
    return queryReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4b99dec112a4da20$var$TopNavContent, {
        queryReference: queryReference,
        ...props
    });
}
function $4b99dec112a4da20$var$TopNavContent({ hideSideNavToggleButton: hideSideNavToggleButton, queryReference: queryReference, renderCreate: Create, renderHelp: Help, renderAppSwitcher: AppSwitcher, renderNotifications: Notifications, renderNav4Notifications: Nav4NotificationsData, renderConversationAssistant: ConversationAssistant, renderProductHome: ProductHome, renderSettings: Settings, renderSearch: Search, renderEditionAwareness: EditionAwareness }) {
    const data = (0, $8Uumt.usePreloadedQuery)((0, $dBV7w.default), queryReference);
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const siteTitleData = (0, $hpMM8.useSiteTitle)();
    const siteTitle = siteTitleData.shouldShow && siteTitleData.value || undefined;
    const attributes = (0, $5uXOq.useMemo)(()=>({
            navigationLayer: (0, $ce9c0831aed9ffb3$export$17ff3f7e02c6ac22),
            navigationContainer: (0, $68cb678dc917978e$export$793ed84f5e13fedc),
            navState: (0, $1520d876660a71bd$export$2bd315ece9f68967),
            stage: (0, $3F9p6.getNav4Rollout)().stage
        }), []);
    const onClickSideNavToggleButton = (0, $5uXOq.useCallback)((_, analyticsEvent, _attributes)=>{
        const payload = (0, $ivGSs.getSideNavToggleButtonAnalyticEventPayload)(_attributes?.isSideNavVisible, (0, $3F9p6.getNav4Rollout)().stage);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, payload);
    }, []);
    const renderNotificationsForNavVersion = (0, $5uXOq.useCallback)(()=>{
        if (Notifications !== undefined) {
            if (Nav4NotificationsData && (0, $6s1PB.expVal)('blu-6229-nav4-top-nav-notifications-perf', 'cohort', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Nav4NotificationsData, {
                queryReference: data
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Notifications, null);
        }
        return null;
    }, [
        Nav4NotificationsData,
        Notifications,
        data
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kpxAO.TopNavStart), null, hideSideNavToggleButton ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Lyip.OnboardingSpotlightMaybe), {
        spotlight: (0, $5NM6P.Nav4OnboardingComponentNames).JIRA_SIDEBAR_TOGGLE_SPOTLIGHT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6yyGB.SideNavToggleButton), {
        defaultCollapsed: data?.jira?.navigationUIState?.isLeftSidebarCollapsed ?? (0, $4DrQd.IS_LEFT_SIDEBAR_COLLAPSED_DEFAULT),
        onClick: onClickSideNavToggleButton,
        collapseLabel: formatMessage((0, $5NqEU.messages).sideNavToggleButtonCollapseLabel),
        expandLabel: formatMessage((0, $5NqEU.messages).sideNavToggleButtonExpandLabel)
    })), AppSwitcher && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AppSwitcher, null), ProductHome && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ProductHome, null), siteTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j3oGS.CustomTitle), null, siteTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $58vAb.TopNavMiddle), null, Search && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Search, null), Create && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Create, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hNNQM.TopNavEnd), null, EditionAwareness && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(EditionAwareness, null), !isAnonymous && ConversationAssistant && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ConversationAssistant, null), !isAnonymous && renderNotificationsForNavVersion(), Help && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Help, null), Settings && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Settings, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1pdD9.Nav4ProfileNew), {
        queryReference: data
    })));
}

});
parcelRegister("5NqEU", function(module, exports) {

$parcel$export(module.exports, "messages", () => $39e259161da53b07$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $39e259161da53b07$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    sideNavToggleButtonCollapseLabel: {
        "id": "atlassian-navigation-nav4.atlaskit-atlassian-navigation-nav4.side-nav-toggle-button-collapse-label",
        "defaultMessage": "Collapse sidebar ["
    },
    sideNavToggleButtonExpandLabel: {
        "id": "atlassian-navigation-nav4.atlaskit-atlassian-navigation-nav4.side-nav-toggle-button-expand-label",
        "defaultMessage": "Expand sidebar ["
    }
});

});

parcelRegister("1pdD9", function(module, exports) {

$parcel$export(module.exports, "Nav4ProfileNew", () => $85f4edf317c04c27$export$57b54e8e22aa73e3);

var $bnJPP = parcelRequire("bnJPP");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $1PVpv = parcelRequire("1PVpv");

var $I5fLT = parcelRequire("I5fLT");

var $cZpsT = parcelRequire("cZpsT");

var $6cNb0 = parcelRequire("6cNb0");

var $57H0d = parcelRequire("57H0d");

var $2tT7R = parcelRequire("2tT7R");

var $8NZjk = parcelRequire("8NZjk");
var $7pImm = parcelRequire("7pImm");
var $kHCo7 = parcelRequire("kHCo7");

var $k1PyF = parcelRequire("k1PyF");
function $85f4edf317c04c27$export$57b54e8e22aa73e3({ queryReference: queryReference }) {
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1PVpv.NavigationAnalyticsContext), {
        data: (0, $kHCo7.ANALYTICS_CONTEXT)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8NZjk.AccountMenuIntlProvider), null, isAnonymous ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($85f4edf317c04c27$var$Nav4ProfileAnonymous, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($85f4edf317c04c27$var$Nav4ProfileLoggedIn, {
        queryReference: queryReference
    })));
}
function $85f4edf317c04c27$var$Nav4ProfileLoggedIn({ queryReference: queryReference }) {
    const data = (0, $8Uumt.useFragment)((0, $bnJPP.default), queryReference);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k1PyF.Nav4AccountMenu), {
        testId: (0, $6cNb0.testIdGenerate)('secondary-actions', 'profile'),
        picture: data?.user?.picture,
        email: data?.user?.email ?? ''
    });
}
function $85f4edf317c04c27$var$Nav4ProfileAnonymous() {
    const environment = (0, $2tT7R.useEnvironment)();
    const identityEnv = (0, $57H0d.getIdentityEnv)(environment);
    const currentWindow = (0, $57H0d.getWindow)();
    const siteUrl = (0, $57H0d.getSiteUrl)(currentWindow);
    const links = (0, $I5fLT.useAccountLinks)({
        email: '',
        identityEnvironment: identityEnv,
        application: 'jira',
        continueUrl: siteUrl,
        isLoggedOut: true
    });
    return links?.logInLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7pImm.AccountMenuLoggedOutStateNav3), {
        testId: (0, $6cNb0.testIdGenerate)('secondary-actions', 'profile'),
        logInLink: links.logInLink
    });
}

});
parcelRegister("bnJPP", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a199cdcfc891769$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8014d6a05835bf0d0e3900984a6503d6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3a199cdcfc891769$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "atlassianAccountId"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4ProfileNew",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accountId",
                    "variableName": "atlassianAccountId"
                }
            ],
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "picture"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "email"
                        }
                    ],
                    "type": "AtlassianAccountUser"
                }
            ]
        }
    ],
    "type": "Query"
};
$3a199cdcfc891769$var$node.hash = "99761b04f3cd20bc2c9f267f5127e730";
var $3a199cdcfc891769$export$2e2bcd8739ae039 = $3a199cdcfc891769$var$node;

});

parcelRegister("6cNb0", function(module, exports) {

$parcel$export(module.exports, "testIdConcat", () => $c1f136d19203abbc$export$794609946480f79c);
$parcel$export(module.exports, "testIdGenerate", () => $c1f136d19203abbc$export$3b86b974ae586844);
const $c1f136d19203abbc$var$PREFIX = 'atlassian-navigation-';
const $c1f136d19203abbc$var$SEPARATOR = '--';
const $c1f136d19203abbc$var$isValid = (value)=>value != null && value !== '';
const $c1f136d19203abbc$export$794609946480f79c = (id, ...items)=>[
        id,
        ...items
    ].filter(Boolean).join($c1f136d19203abbc$var$SEPARATOR).toLowerCase();
const $c1f136d19203abbc$export$3b86b974ae586844 = (first, ...rest)=>// @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string | undefined'.
    $c1f136d19203abbc$export$794609946480f79c($c1f136d19203abbc$var$PREFIX + ($c1f136d19203abbc$var$isValid(first) ? `-${first}` : ''), ...rest);

});

parcelRegister("57H0d", function(module, exports) {

$parcel$export(module.exports, "getWindow", () => $323b60151b6ebcfa$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getSiteUrl", () => $323b60151b6ebcfa$export$63fdf20f02fdbaf2);
$parcel$export(module.exports, "getIdentityEnv", () => $323b60151b6ebcfa$export$b3f2b8c6cd294d68);
const $323b60151b6ebcfa$export$38b2d434cce3ea22 = ()=>false ? null : window;
const $323b60151b6ebcfa$export$63fdf20f02fdbaf2 = (currentWindow)=>{
    if (currentWindow && !currentWindow.false) return `${currentWindow.location.protocol}//${currentWindow.location.host}`;
    return '';
};
const $323b60151b6ebcfa$export$b3f2b8c6cd294d68 = (env)=>{
    switch(env){
        case 'local':
            return 'staging';
        case 'dev':
            return 'staging';
        case 'staging':
            return 'staging';
        case 'prod':
            return 'prod';
        default:
            return 'prod';
    }
};

});

parcelRegister("k1PyF", function(module, exports) {

$parcel$export(module.exports, "Nav4AccountMenu", () => $a2f2a752f3b97865$export$793e3aab7101233f);

var $5uXOq = parcelRequire("5uXOq");

var $1I7E8 = parcelRequire("1I7E8");

var $eZJjh = parcelRequire("eZJjh");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $eUECn = parcelRequire("eUECn");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $47gW9 = parcelRequire("47gW9");

var $cLIpE = parcelRequire("cLIpE");

var $4R6GH = parcelRequire("4R6GH");

var $LmW5e = parcelRequire("LmW5e");

var $90yGq = parcelRequire("90yGq");
const $a2f2a752f3b97865$export$793e3aab7101233f = (0, $LmW5e.memoWithCondition)(()=>(0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-2'), ({ testId: testId, picture: picture, email: email })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const atlassianAccountId = (0, $90yGq.useAccountId)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $cLIpE.Nav4ProfileMenuEntryPoint), {
        atlassianAccountId: atlassianAccountId ?? ''
    });
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            onClosePopup: ()=>{
                setIsOpen(false);
            },
            testId: testId
        }), [
        testId
    ]);
    const TriggerInternal = (0, $5uXOq.useCallback)((triggerProps)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2f2a752f3b97865$var$Trigger, {
            triggerRef: triggerRef,
            setIsOpen: setIsOpen,
            testId: testId,
            picture: picture,
            email: email,
            isOpen: isOpen,
            triggerProps: triggerProps
        });
    }, [
        triggerRef,
        setIsOpen,
        testId,
        picture,
        email,
        isOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
        isOpen: isOpen,
        onClose: (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-2') ? (0, $5uXOq.useCallback)(()=>{
            setIsOpen(false);
        }, []) : ()=>{
            setIsOpen(false);
        },
        testId: testId,
        placement: "bottom",
        trigger: (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-2') ? TriggerInternal : (triggerProps)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
                name: "profile-spotlight"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eUECn.AccountMenuTriggerNav3), {
                ref: (element)=>{
                    triggerRef(element);
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    triggerProps.ref(element);
                },
                onClick: ()=>{
                    setIsOpen((open)=>!open);
                },
                testId: testId && `${testId}--trigger`,
                picture: picture,
                trustPicture: true,
                email: email,
                "aria-expanded": isOpen,
                "aria-haspopup": true,
                "aria-controls": testId && `${testId}--content`,
                "data-ds--level": triggerProps['data-ds--level']
            }));
        },
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "atlassian-navigation-profile-menu",
                packageName: "atlassian-navigation-profile-menu",
                errorFallback: "flag",
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    xcss: $a2f2a752f3b97865$var$Nav4AccountMenuContentSkeletonStyles,
                    padding: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), null)),
                runtimeProps: runtimeProps
            })
    });
});
function $a2f2a752f3b97865$var$Trigger({ triggerRef: triggerRef, setIsOpen: setIsOpen, testId: testId, picture: picture, email: email, isOpen: isOpen, triggerProps: triggerProps }) {
    const ref = (0, $5uXOq.useCallback)((element)=>{
        triggerRef(element);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        triggerProps.ref(element);
    }, [
        triggerRef,
        triggerProps.ref
    ]);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        setIsOpen((open)=>!open);
    }, [
        setIsOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "profile-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eUECn.AccountMenuTriggerNav3), {
        ref: ref,
        onClick: onClick,
        testId: testId && `${testId}--trigger`,
        picture: picture,
        trustPicture: true,
        email: email,
        "aria-expanded": isOpen,
        "aria-haspopup": true,
        "aria-controls": testId && `${testId}--content`,
        "data-ds--level": triggerProps['data-ds--level']
    }));
}
// These styles are defined to ensure that the initial popup for the AccountMenu content is the same width when
// displaying the skeleton loader as when displaying the actual content.
const $a2f2a752f3b97865$var$Nav4AccountMenuContentSkeletonStyles = (0, $8CUq3.xcss)({
    width: '304px',
    height: '307px'
});

});
parcelRegister("cLIpE", function(module, exports) {

$parcel$export(module.exports, "Nav4ProfileMenuEntryPoint", () => $876c2695d1976e10$export$e30a856958207b6);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $bVJxC = parcelRequire("bVJxC");

var $4R6GH = parcelRequire("4R6GH");

const $876c2695d1976e10$export$e30a856958207b6 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("kIrbt")), {
        moduleId: "18b1d8bb",
        priority: "interaction"
    }),
    getPreloadProps: ({ atlassianAccountId: atlassianAccountId })=>({
            queries: {
                profileMenuQuery: {
                    parameters: $bVJxC.default,
                    variables: {
                        atlassianAccountId: atlassianAccountId ?? '',
                        newNav4ProfileQueryEnabled: (0, $4R6GH.fg)('blu-7584-replace-nav4-profile-query')
                    }
                }
            }
        })
});

});
parcelRegister("bVJxC", function(module, exports) {

$parcel$export(module.exports, "default", () => $5925de38e3f3e959$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<89063032561369508d96aea0af5ff8e1>>
 * @relayHash 9659ce97ef8ff267228c6339bb685d14
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6d8b9d4ddb68ba2ed58fcfd8525e3fb368eff05bcbfadfcb924ba07588a969a6
const $5925de38e3f3e959$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "6d8b9d4ddb68ba2ed58fcfd8525e3fb368eff05bcbfadfcb924ba07588a969a6",
        "metadata": {},
        "name": "profileMenuQuery",
        "operationKind": "query",
        "text": null
    }
};
var $5925de38e3f3e959$export$2e2bcd8739ae039 = $5925de38e3f3e959$var$node;

});

parcelRegister("kIrbt", function(module, exports) {

let $f14d00e8a7b8457d$var$load = (parcelRequire("28QjX"))(4);

module.exports = Promise.all([
    (parcelRequire("avM1e"))('edition_awareness_upsell_jira_ab_fg', function() {
        return Promise.all([
            $f14d00e8a7b8457d$var$load("dN2wc")
        ]);
    }, function() {
        return Promise.all([
            $f14d00e8a7b8457d$var$load("elkip")
        ]);
    }),
    $f14d00e8a7b8457d$var$load("luixE")
]).then(()=>parcelRequire('eWrtG'));

});




parcelRegister("hpMM8", function(module, exports) {

$parcel$export(module.exports, "useSiteTitle", () => $fbb1b06ad47434f5$export$3e157e0d79928990);

var $5uXOq = parcelRequire("5uXOq");

var $j8DrX = parcelRequire("j8DrX");
const $fbb1b06ad47434f5$export$3e157e0d79928990 = ()=>(0, $5uXOq.useMemo)(()=>({
            shouldShow: (0, $j8DrX.default)('ajs-lf-top-adg3-shouldshowtitle') === 'true',
            value: (0, $j8DrX.default)('ajs-app-title')
        }), []);

});


parcelRegister("1hrBl", function(module, exports) {

$parcel$export(module.exports, "AtlaskitAtlassianNavigationNav4", () => $95ae6691967260e6$export$c1591611a45b21ea);

var $iae3b = parcelRequire("iae3b");

var $9ZLcT = parcelRequire("9ZLcT");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $6yyGB = parcelRequire("6yyGB");
var $hNNQM = parcelRequire("hNNQM");
var $58vAb = parcelRequire("58vAb");
var $kpxAO = parcelRequire("kpxAO");

var $j3oGS = parcelRequire("j3oGS");

var $5NM6P = parcelRequire("5NM6P");

var $6Lyip = parcelRequire("6Lyip");

var $koVbs = parcelRequire("koVbs");

var $fwzEJ = parcelRequire("fwzEJ");




var $ivGSs = parcelRequire("ivGSs");

var $3F9p6 = parcelRequire("3F9p6");

var $4DrQd = parcelRequire("4DrQd");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");

var $ao2h1 = parcelRequire("ao2h1");

var $cZpsT = parcelRequire("cZpsT");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $5NqEU = parcelRequire("5NqEU");

var $hpMM8 = parcelRequire("hpMM8");

var $k9kxe = parcelRequire("k9kxe");
function $95ae6691967260e6$export$c1591611a45b21ea(props) {
    const isAnonymous = (0, $cZpsT.useIsAnonymous)(); // delete <TopNavNoUserPrefers /> and AtlaskitAtlassianNavigationNav4Query when cleaning up blu-7788-simplify-top-nav-query-v2
    if (isAnonymous && !(0, $4R6GH.fg)('blu-7788-simplify-top-nav-query-v2')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($95ae6691967260e6$var$TopNavNoUserPrefs, props);
     // This intermediate step is to avoid fetching a user-preference-resource for an anonymous user.
    // Because hooks cannot be conditionally called, we create a new component.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($95ae6691967260e6$var$TopNavNewUserPrefs, props);
}
function $95ae6691967260e6$var$TopNavNewUserPrefs(props) {
    const { queryReference: queryReference } = (0, $ao2h1.useRelayResource)((0, $fwzEJ.topNav4UIStateResource)); // This intermediate step is to avoid using a null queryReference.
    // Maybe this should be a skeleton? Or is that taken care of by the page-container-v2?
    return queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($95ae6691967260e6$export$64502ebb7f02a28b, {
        queryReference: queryReference,
        ...props
    }) : null;
}
function $95ae6691967260e6$export$64502ebb7f02a28b(props) {
    const { queryReference: queryReference } = props;
    const data = (0, $8Uumt.usePreloadedQuery)((0, $9ZLcT.default), queryReference);
    const defaultCollapsed = data?.jira?.navigationUIState?.isLeftSidebarCollapsed ?? (0, $4DrQd.IS_LEFT_SIDEBAR_COLLAPSED_DEFAULT);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($95ae6691967260e6$var$TopNavCommon, {
        ...props,
        defaultCollapsed: defaultCollapsed,
        queryReference: data
    });
}
function $95ae6691967260e6$var$TopNavNoUserPrefs(props) {
    const data = (0, $8Uumt.useLazyLoadQuery)((0, $iae3b.default), {});
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($95ae6691967260e6$var$TopNavCommon, {
        ...props,
        queryReference: data
    });
}
function $95ae6691967260e6$var$TopNavCommon(props) {
    const { defaultCollapsed: defaultCollapsed = false, hideSideNavToggleButton: hideSideNavToggleButton, queryReference: queryReference, renderCreate: Create, renderHelp: Help, renderAppSwitcher: AppSwitcher, renderNotifications: Notifications, renderNav4Notifications: Nav4NotificationsData, renderConversationAssistant: ConversationAssistant, renderProductHome: ProductHome, renderSettings: Settings, renderSearch: Search, renderEditionAwareness: EditionAwareness } = props;
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const siteTitleData = (0, $hpMM8.useSiteTitle)();
    const siteTitle = siteTitleData.shouldShow && siteTitleData.value || undefined;
    const attributes = (0, $5uXOq.useMemo)(()=>({
            navigationLayer: (0, $ce9c0831aed9ffb3$export$17ff3f7e02c6ac22),
            navigationContainer: (0, $68cb678dc917978e$export$793ed84f5e13fedc),
            navState: (0, $1520d876660a71bd$export$2bd315ece9f68967),
            stage: (0, $3F9p6.getNav4Rollout)().stage
        }), []);
    const onClickSideNavToggleButton = (0, $5uXOq.useCallback)((_, analyticsEvent, _attributes)=>{
        const payload = (0, $ivGSs.getSideNavToggleButtonAnalyticEventPayload)(_attributes?.isSideNavVisible, (0, $3F9p6.getNav4Rollout)().stage);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, payload);
    }, []);
    const renderNotificationsForNavVersion = (0, $5uXOq.useCallback)(()=>{
        if (Notifications !== undefined) {
            if (Nav4NotificationsData && (0, $6s1PB.expVal)('blu-6229-nav4-top-nav-notifications-perf', 'cohort', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Nav4NotificationsData, {
                queryReference: queryReference
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Notifications, null);
        }
        return null;
    }, [
        Nav4NotificationsData,
        Notifications,
        queryReference
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kpxAO.TopNavStart), null, hideSideNavToggleButton ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Lyip.OnboardingSpotlightMaybe), {
        spotlight: (0, $5NM6P.Nav4OnboardingComponentNames).JIRA_SIDEBAR_TOGGLE_SPOTLIGHT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6yyGB.SideNavToggleButton), {
        defaultCollapsed: defaultCollapsed,
        onClick: onClickSideNavToggleButton,
        collapseLabel: formatMessage((0, $5NqEU.messages).sideNavToggleButtonCollapseLabel),
        expandLabel: formatMessage((0, $5NqEU.messages).sideNavToggleButtonExpandLabel)
    })), AppSwitcher && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AppSwitcher, null), ProductHome && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ProductHome, null), siteTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j3oGS.CustomTitle), null, siteTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $58vAb.TopNavMiddle), null, Search && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Search, null), Create && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Create, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hNNQM.TopNavEnd), null, EditionAwareness && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(EditionAwareness, null), !isAnonymous && ConversationAssistant && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ConversationAssistant, null), !isAnonymous && renderNotificationsForNavVersion(), Help && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Help, null), Settings && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Settings, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k9kxe.Nav4Profile), {
        queryReference: queryReference
    })));
}

});
parcelRegister("iae3b", function(module, exports) {

$parcel$export(module.exports, "default", () => $303bb8e80a52e9e7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d557b0d879f5cd21fba925f349470307>>
 * @relayHash f6c5d5ff2079a55a0b1db15579eee8da
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5a3248326d2e2f9b8a01e4fb3c9f7737a8132eec6cd51408c63f2b026da11ccd
const $303bb8e80a52e9e7$var$node = {
    "fragment": {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "AtlaskitAtlassianNavigationNav4Query",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "Nav4Profile"
            }
        ],
        "type": "Query"
    },
    "kind": "Request",
    "operation": {
        "argumentDefinitions": [],
        "kind": "Operation",
        "name": "AtlaskitAtlassianNavigationNav4Query",
        "selections": [
            {
                "concreteType": "AuthenticationContext",
                "kind": "LinkedField",
                "name": "me",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "__typename"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "picture"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "email"
                                    }
                                ],
                                "type": "AtlassianAccountUser"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "id"
                            }
                        ]
                    }
                ]
            }
        ]
    },
    "params": {
        "id": "5a3248326d2e2f9b8a01e4fb3c9f7737a8132eec6cd51408c63f2b026da11ccd",
        "metadata": {},
        "name": "AtlaskitAtlassianNavigationNav4Query",
        "operationKind": "query",
        "text": null
    }
};
$303bb8e80a52e9e7$var$node.hash = "117383646be1f212dbc165252eccb286";
var $303bb8e80a52e9e7$export$2e2bcd8739ae039 = $303bb8e80a52e9e7$var$node;

});

parcelRegister("k9kxe", function(module, exports) {

$parcel$export(module.exports, "Nav4Profile", () => $a99665d29fdf5a2b$export$c928b6dc7cf1e4c6);

var $3QjWU = parcelRequire("3QjWU");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $1PVpv = parcelRequire("1PVpv");

var $1I7E8 = parcelRequire("1I7E8");

var $eZJjh = parcelRequire("eZJjh");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $I5fLT = parcelRequire("I5fLT");

var $cYlk7 = parcelRequire("cYlk7");

var $cZpsT = parcelRequire("cZpsT");

var $9OXo1 = parcelRequire("9OXo1");

var $6cNb0 = parcelRequire("6cNb0");

var $57H0d = parcelRequire("57H0d");

var $8NZjk = parcelRequire("8NZjk");
var $7pImm = parcelRequire("7pImm");
var $eUECn = parcelRequire("eUECn");
var $kHCo7 = parcelRequire("kHCo7");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $47gW9 = parcelRequire("47gW9");

var $cLIpE = parcelRequire("cLIpE");

var $4R6GH = parcelRequire("4R6GH");

var $LmW5e = parcelRequire("LmW5e");

var $90yGq = parcelRequire("90yGq");
const $a99665d29fdf5a2b$export$c928b6dc7cf1e4c6 = ({ queryReference: queryReference })=>{
    const data = (0, $8Uumt.useFragment)((0, $3QjWU.default), queryReference);
    const { data: { user: user } } = (0, $cYlk7.useCurrentUser)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const { environment: environment } = (0, $9OXo1.useTenantContext)();
    const identityEnv = (0, $57H0d.getIdentityEnv)(environment);
    const currentWindow = (0, $57H0d.getWindow)();
    const siteUrl = (0, $57H0d.getSiteUrl)(currentWindow);
    const isUserType = (maybeUser)=>'emailAddress' in maybeUser;
    const emailAddress = isUserType(user) && user.emailAddress ? user.emailAddress : '';
    const links = (0, $I5fLT.useAccountLinks)({
        email: emailAddress,
        identityEnvironment: identityEnv,
        application: 'jira',
        continueUrl: siteUrl,
        isLoggedOut: isAnonymous
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a99665d29fdf5a2b$export$793e3aab7101233f, {
        testId: (0, $6cNb0.testIdGenerate)('secondary-actions', 'profile'),
        picture: data?.me?.user?.picture,
        email: emailAddress || '',
        logInLink: links.logInLink
    });
};
const $a99665d29fdf5a2b$var$Trigger = ({ triggerRef: triggerRef, setIsOpen: setIsOpen, testId: testId, picture: picture, email: email, isOpen: isOpen, triggerProps: triggerProps })=>{
    const ref = (0, $5uXOq.useCallback)((element)=>{
        triggerRef(element);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        triggerProps.ref(element);
    }, [
        triggerRef,
        triggerProps.ref
    ]);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        setIsOpen((open)=>!open);
    }, [
        setIsOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "profile-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eUECn.AccountMenuTriggerNav3), {
        ref: ref,
        onClick: onClick,
        testId: testId && `${testId}--trigger`,
        picture: picture,
        trustPicture: true,
        email: email,
        "aria-expanded": isOpen,
        "aria-haspopup": true,
        "aria-controls": testId && `${testId}--content`,
        "data-ds--level": triggerProps['data-ds--level']
    }));
};
const $a99665d29fdf5a2b$export$793e3aab7101233f = (0, $LmW5e.memoWithCondition)(()=>(0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-2'), ({ testId: testId, picture: picture, email: email, logInLink: logInLink })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const atlassianAccountId = (0, $90yGq.useAccountId)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $cLIpE.Nav4ProfileMenuEntryPoint), {
        atlassianAccountId: atlassianAccountId ?? ''
    });
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            onClosePopup: ()=>{
                setIsOpen(false);
            },
            testId: testId
        }), [
        testId
    ]);
    const TriggerInternal = (0, $5uXOq.useCallback)((triggerProps)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a99665d29fdf5a2b$var$Trigger, {
            triggerRef: triggerRef,
            setIsOpen: setIsOpen,
            testId: testId,
            picture: picture,
            email: email,
            isOpen: isOpen,
            triggerProps: triggerProps
        });
    }, [
        triggerRef,
        setIsOpen,
        testId,
        picture,
        email,
        isOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1PVpv.NavigationAnalyticsContext), {
        data: (0, $kHCo7.ANALYTICS_CONTEXT)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8NZjk.AccountMenuIntlProvider), null, logInLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7pImm.AccountMenuLoggedOutStateNav3), {
        testId: testId && `${testId}--logged-out-state`,
        logInLink: logInLink
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
        isOpen: isOpen,
        onClose: (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-2') ? (0, $5uXOq.useCallback)(()=>{
            setIsOpen(false);
        }, []) : ()=>{
            setIsOpen(false);
        },
        testId: testId,
        placement: "bottom",
        trigger: (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-2') ? TriggerInternal : (triggerProps)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
                name: "profile-spotlight"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eUECn.AccountMenuTriggerNav3), {
                ref: (element)=>{
                    triggerRef(element);
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    triggerProps.ref(element);
                },
                onClick: ()=>{
                    setIsOpen((open)=>!open);
                },
                testId: testId && `${testId}--trigger`,
                picture: picture,
                trustPicture: true,
                email: email,
                "aria-expanded": isOpen,
                "aria-haspopup": true,
                "aria-controls": testId && `${testId}--content`,
                "data-ds--level": triggerProps['data-ds--level']
            }));
        },
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "atlassian-navigation-profile-menu",
                packageName: "atlassian-navigation-profile-menu",
                errorFallback: "flag",
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    xcss: $a99665d29fdf5a2b$var$Nav4AccountMenuContentSkeletonStyles,
                    padding: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), null)),
                runtimeProps: runtimeProps
            })
    })));
});
// These styles are defined to ensure that the initial popup for the AccountMenu content is the same width when
// displaying the skeleton loader as when displaying the actual content.
const $a99665d29fdf5a2b$var$Nav4AccountMenuContentSkeletonStyles = (0, $8CUq3.xcss)({
    width: '304px',
    height: '307px'
});

});
parcelRegister("3QjWU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5287ccf2951923b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6f409232dfe70b49086ed75c82bb4b01>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f5287ccf2951923b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4Profile",
    "selections": [
        {
            "concreteType": "AuthenticationContext",
            "kind": "LinkedField",
            "name": "me",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "picture"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "email"
                                }
                            ],
                            "type": "AtlassianAccountUser"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$f5287ccf2951923b$var$node.hash = "b587d618b47ab2faaf585a782a74ec40";
var $f5287ccf2951923b$export$2e2bcd8739ae039 = $f5287ccf2951923b$var$node;

});




parcelRegister("13iNl", function(module, exports) {

$parcel$export(module.exports, "recommendations", () => $56dde49bc4054ac6$export$b7e5cef71fa42514);

var $a334R = parcelRequire("a334R");


const $56dde49bc4054ac6$var$createRecommendationsList = ()=>{
    const recommendationsList = [];
    recommendationsList.push((0, $a334R.default));
    // Add your own templates
    return recommendationsList;
};
const $56dde49bc4054ac6$export$b7e5cef71fa42514 = $56dde49bc4054ac6$var$createRecommendationsList();

});
parcelRegister("a334R", function(module, exports) {

$parcel$export(module.exports, "default", () => $fccc347b1e897d64$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jFnH8 = parcelRequire("jFnH8");

var $bHpB9 = parcelRequire("bHpB9");
var $jWY5k = parcelRequire("jWY5k");

var $fVnbM = parcelRequire("fVnbM");

var $aYAc3 = parcelRequire("aYAc3");

var $dS3PR = parcelRequire("dS3PR");

var $6WDs0 = parcelRequire("6WDs0");

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $90yGq = parcelRequire("90yGq");

var $2tT7R = parcelRequire("2tT7R");

var $cmVQ7 = parcelRequire("cmVQ7");

var $4R6GH = parcelRequire("4R6GH");

var $fZneA = parcelRequire("fZneA");

var $iKwST = parcelRequire("iKwST");

var $5ZJgM = parcelRequire("5ZJgM");

var $9SPvU = parcelRequire("9SPvU");

var $kwgZt = parcelRequire("kwgZt");

var $cmzJ2 = parcelRequire("cmzJ2");

var $kklBj = parcelRequire("kklBj");

var $66CIA = parcelRequire("66CIA");

var $77N15 = parcelRequire("77N15");

var $hb557 = parcelRequire("hb557");

var $5RxQU = parcelRequire("5RxQU");

var $7Y8xQ = parcelRequire("7Y8xQ");
const $fccc347b1e897d64$export$da956fe610b96f73 = ()=>{
    const [moreInformationModal, setMoreInformationModal] = (0, $5uXOq.useState)(false);
    const { fireViewedUIEvent: fireViewedUIEvent, fireInteractedUIEvent: fireInteractedUIEvent } = (0, $cmVQ7.useFireCrossFlowAnalyticsEvents)();
    const [, { setRecommendationDismissal: setRecommendationDismissal }] = (0, $cmzJ2.useProjectMenuRecommendations)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const accountId = (0, $90yGq.useAccountId)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const crossFlow = (0, $bHpB9.useCrossFlow)();
    const environment = (0, $2tT7R.useEnvironment)();
    const jpdCloudCCPProductID = (0, $hb557.getProductTypeCcpReferenceIdMapForEnv)(environment).PRODUCT_DISCOVERY;
    (0, $5uXOq.useEffect)(()=>{
        if (crossFlow.isEnabled) fireViewedUIEvent({
            action: 'viewed',
            actionSubject: 'section',
            actionSubjectId: 'projectsMenu'
        }, {
            recommendedProductIds: [
                jpdCloudCCPProductID
            ],
            source: 'projectsMenuSection'
        }, {
            navigationVersion: 'v3'
        });
        else (0, $jcw0u.default)({
            error: new Error(crossFlow.reason),
            meta: {
                id: crossFlow.reason,
                packageName: 'jiraAtlassianNavigationRecommendations'
            }
        });
    }, [
        createAnalyticsEvent,
        crossFlow,
        fireViewedUIEvent,
        jpdCloudCCPProductID
    ]);
    const openCrossFlow = (0, $5uXOq.useCallback)(async (templateId)=>{
        const extensions = (0, $jFnH8.createProvisioningPageExtensions)({
            actions: {
                primary: {
                    behaviour: (0, $jFnH8.Behaviours).LAND,
                    prompt: (0, $jFnH8.Prompts).NEXT,
                    options: {
                        targetTab: (0, $jFnH8.TargetTabs).SAME,
                        urlParams: {
                            templateId: templateId
                        }
                    }
                }
            }
        });
        if (crossFlow.isEnabled) crossFlow.apiV1.open({
            journey: (0, $bHpB9.Journeys).GET_STARTED,
            targetProduct: (0, $jWY5k.Targets).JIRA_PRODUCT_DISCOVERY,
            sourceComponent: 'projectsMenu',
            sourceContext: 'tryThisRecommendation',
            extensions: extensions,
            v1: true
        });
    }, [
        crossFlow
    ]);
    const onRecommendationClicked = (0, $5uXOq.useCallback)(()=>{
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'tryThisRecommendation'
        }, {
            source: 'projectsMenuSection',
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        }, {
            navigationVersion: 'v3'
        });
        openCrossFlow((0, $hb557.JPD_ROADMAP_KEY));
    }, [
        fireInteractedUIEvent,
        jpdCloudCCPProductID,
        openCrossFlow
    ]);
    const onLearnMoreClicked = (0, $5uXOq.useCallback)(()=>{
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'learnMore'
        }, {
            source: 'projectsMenuSection',
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        }, {
            navigationVersion: 'v3'
        });
        setMoreInformationModal(true);
    }, [
        fireInteractedUIEvent,
        jpdCloudCCPProductID
    ]);
    const onLearnMoreClosed = (0, $5uXOq.useCallback)(()=>{
        setMoreInformationModal(false);
    }, []);
    const onDismissClicked = (0, $5uXOq.useCallback)(()=>{
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'dismissRecommendation'
        }, {
            source: 'projectsMenuSection',
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        }, {
            navigationVersion: 'v3'
        });
        setRecommendationDismissal();
        if (accountId) (0, $89SaW.setUserProperties)(accountId, (0, $hb557.JPD_RECOMMENDATION_DISMISS_USER_PROPERTY), 'true').catch((error)=>(0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'dismissJpdRecommendation',
                    packageName: 'jiraAtlassianNavigationRecommendations',
                    teamName: 'navigation'
                }
            }));
    }, [
        accountId,
        fireInteractedUIEvent,
        jpdCloudCCPProductID,
        setRecommendationDismissal
    ]);
    const onClickPrivacyPolicy = (0, $5uXOq.useCallback)(()=>{
        const clickedLinkBaseEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        (0, $8zOmE.fireUIAnalytics)(clickedLinkBaseEvent, 'adControlsPrivacyPolicy');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iKwST.RecommendationContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ZJgM.RecommendationHeader), {
        title: formatMessage((0, $5RxQU.default).recommendedText),
        onDismissClicked: onDismissClicked,
        onLearnMoreClicked: onLearnMoreClicked
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9SPvU.RecommendationMenuItem), {
        title: formatMessage((0, $5RxQU.default).projectTitleProductRoadmap),
        description: formatMessage((0, $5RxQU.default).projectDescriptionProductRoadmap),
        onClick: onRecommendationClicked,
        lozenge: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
            appearance: "new",
            isBold: false
        }, formatMessage((0, $5RxQU.default).lozengeText)),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $77N15.default), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kwgZt.RecommendationModal), {
        isOpen: moreInformationModal,
        onClose: onLearnMoreClosed,
        title: formatMessage((0, $5RxQU.default).reasonsModalTitle),
        body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $5RxQU.default).reasonsModalExplanation, {
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
                    as: "strong"
                }, chunks)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("ul", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", null, formatMessage((0, $5RxQU.default).reasonsModalBulletOneSpork)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", null, formatMessage((0, $5RxQU.default).reasonsModalBulletTwo))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "link",
            spacing: "none",
            href: (0, $hb557.DATA_PRIVACY_LINK),
            target: "_blank",
            onClick: onClickPrivacyPolicy
        }, formatMessage((0, $5RxQU.default).privacyPolicy))),
        primaryCta: formatMessage((0, $5RxQU.default).reasonsModalButtonOk)
    }));
};
const $fccc347b1e897d64$var$checkEligibility = async (recommendationContext, analyticsEvent)=>{
    const { areProductSuggestionsEnabled: areProductSuggestionsEnabled, licensedProducts: licensedProducts, canCreateProject: canCreateProject, accountId: accountId, cloudId: cloudId, environment: environment, isInFedRamp: isInFedRamp } = recommendationContext;
    if ((0, $4R6GH.fg)('optout_all_messages_grw-1467')) {
        const { optoutStatus: optoutStatus } = await (0, $6WDs0.isOptoutAllMessages)('grw-1467-jpd-recommendation-nav3', cloudId, accountId, analyticsEvent);
        switch(optoutStatus){
            case 'error':
                return {
                    isEligible: false,
                    reason: 'Failed to check if opted out of all messages'
                };
            case 'is-opted-out':
                return {
                    isEligible: false,
                    reason: 'Opted out of all messages'
                };
            default:
                break;
        }
    }
    if ((0, $4R6GH.fg)('grw-1467_jpd_reco_eligibility_override_gate')) return {
        isEligible: true,
        reason: 'Eligibility override gate is enabled'
    };
    if (!areProductSuggestionsEnabled) return {
        isEligible: false,
        reason: 'Product suggestions are disabled'
    };
    if ((0, $7Y8xQ.hasJpdLicense)(licensedProducts)) return {
        isEligible: false,
        reason: 'Instance has JPD license'
    };
    if (!canCreateProject) return {
        isEligible: false,
        reason: 'User cannot create projects'
    };
    if (isInFedRamp) return {
        isEligible: false,
        reason: 'User is in FedRamp'
    };
    const [dismissed, appRecommendations] = await Promise.all([
        (0, $89SaW.getUserProperty)(accountId, (0, $hb557.JPD_RECOMMENDATION_DISMISS_USER_PROPERTY)).catch((error)=>{
            // If not found, then the user hasn't dismissed the ad.
            // 404 - user property not found,
            if (error.statusCode === 404) return false;
            const expectedErrors = [
                429,
                // rate limit exceeded
                401,
                // unauthorised
                403,
                // forbidden
                null,
                // client error
                undefined // client error
            ];
            // 50x - network errors
            // We shouldn't see the recommendation
            if (expectedErrors.includes(error.statusCode) || error.statusCode >= 500 || (0, $fZneA.isClientFetchError)(error)) return true;
            throw Error(`${error.statusCode}, JPD recommendation dismissal failed. ${error.name}: ${error.message}`, error);
        }),
        (0, $66CIA.fetchAppRecommendations)(cloudId, environment, analyticsEvent)
    ]);
    if (dismissed) return {
        isEligible: false,
        reason: 'JPD recommendation dismissed'
    };
    if (!appRecommendations?.some((recommendation)=>recommendation?.entityId === (0, $hb557.JPD_ENTITY_ID))) return {
        isEligible: false,
        reason: 'JPD was not in the recommend apps'
    };
    return {
        isEligible: true,
        reason: 'Pass all checks'
    };
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fccc347b1e897d64$export$2e2bcd8739ae039 = {
    key: (0, $hb557.JPD_RECOMMENDATION_KEY),
    shouldRender: async (recommendationContext, analyticsEvent)=>{
        (0, $kklBj.projectsMenuDropdownLoadJpdRecommendation).start();
        const { isEligible: isEligible, reason: reason } = await $fccc347b1e897d64$var$checkEligibility(recommendationContext, analyticsEvent);
        if ((0, $4R6GH.fg)('pm_jpd_reco_operational_event_activated')) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'jiraAtlassianNavigation.loadJpdRecommendation succeeded', {
            reason: reason,
            isEligible: isEligible
        });
        (0, $kklBj.projectsMenuDropdownLoadJpdRecommendation).success();
        return isEligible;
    },
    onLoadError: (error)=>{
        (0, $kklBj.projectsMenuDropdownLoadJpdRecommendation).failure();
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'loadJpdRecommendation',
                packageName: 'jiraAtlassianNavigationRecommendations',
                teamName: 'navigation'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    },
    Component: $fccc347b1e897d64$export$da956fe610b96f73
};

});
parcelRegister("iKwST", function(module, exports) {

$parcel$export(module.exports, "RecommendationContainer", () => $3f1017feb0eddea7$export$97f31f44c68c1d5);

var $5uXOq = parcelRequire("5uXOq");

var $9UCCQ = parcelRequire("9UCCQ");

var $iXVV6 = parcelRequire("iXVV6");
const $3f1017feb0eddea7$export$97f31f44c68c1d5 = ({ children: children, attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        hasSeparator: true
    }, children));

});

parcelRegister("5ZJgM", function(module, exports) {

$parcel$export(module.exports, "RecommendationHeader", () => $04eaa3b92b265d65$export$3beeaceb068c75b1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $bJeNF = parcelRequire("bJeNF");

var $kJpBP = parcelRequire("kJpBP");
var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $jgJNO = parcelRequire("jgJNO");

var $9xvcL = parcelRequire("9xvcL");
const $04eaa3b92b265d65$export$3beeaceb068c75b1 = ({ title: title, onDismissClicked: onDismissClicked, onLearnMoreClicked: onLearnMoreClicked })=>{
    const [isActionsMenuOpen, setIsActionsMenuOpen] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $04eaa3b92b265d65$var$HeadingItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xxsmall",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $04eaa3b92b265d65$var$TitleItemStyles
    }, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isActionsMenuOpen,
        placement: "bottom-start",
        messageId: "atlassian-navigation-recommendations.common.ui.recommendation-section.recommendation-header.popup",
        messageType: "transactional",
        onClose: ()=>setIsActionsMenuOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), {
                onClick: (e)=>e.stopPropagation()
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
                onClick: onDismissClicked
            }, formatMessage((0, $9xvcL.default).dismissButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
                onClick: onLearnMoreClicked
            }, formatMessage((0, $9xvcL.default).learnMoreButtonText)))),
        shouldUseCaptureOnOutsideClick: true,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04eaa3b92b265d65$var$MeatballMenuTrigger, {
                ...triggerProps,
                appearance: "subtle",
                onClick: ()=>setIsActionsMenuOpen(()=>!isActionsMenuOpen),
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))), {
                    LEGACY_size: "medium",
                    spacing: "spacious",
                    label: formatMessage((0, $9xvcL.default).moreButtonLabel, {
                        title: title
                    })
                })
            }),
        shouldRenderToParent: true
    }));
};
const $04eaa3b92b265d65$var$HeadingItemStyles = (0, $8CUq3.xcss)({
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: 'space.200',
    paddingRight: 'space.200',
    marginTop: 'space.050'
});
const $04eaa3b92b265d65$var$TitleItemStyles = (0, $8CUq3.xcss)({
    color: 'color.text.accent.gray'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $04eaa3b92b265d65$var$MeatballMenuTrigger = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbzwfg _4t3izwfg _1di6fg4m",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9xvcL", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa08673ea438366b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $aa08673ea438366b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    learnMoreButtonText: {
        "id": "atlassian-navigation-recommendations.common.recommendation-section.recommendation-header.learn-more-button-text",
        "defaultMessage": "Why am I seeing this?"
    },
    dismissButtonText: {
        "id": "atlassian-navigation-recommendations.common.recommendation-section.recommendation-header.dismiss-button-text",
        "defaultMessage": "Not interested"
    },
    dismissConfirmationText: {
        "id": "atlassian-navigation-recommendations.common.recommendation-section.recommendation-header.dismiss-confirmation-text",
        "defaultMessage": "You won't be seeing this here anymore"
    },
    moreButtonLabel: {
        "id": "atlassian-navigation-recommendations.common.recommendation-section.recommendation-header.more-button-label",
        "defaultMessage": "More options for {title} section"
    }
});

});


parcelRegister("9SPvU", function(module, exports) {

$parcel$export(module.exports, "RecommendationMenuItem", () => $56fe10413c20ceb0$export$aab9ce3de285230c);

var $5uXOq = parcelRequire("5uXOq");

var $3Z96c = parcelRequire("3Z96c");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
const $56fe10413c20ceb0$export$aab9ce3de285230c = ({ iconBefore: iconBefore, onClick: onClick, title: title, lozenge: lozenge = null, description: description })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Z96c.default), {
        iconBefore: iconBefore,
        onClick: onClick,
        description: description,
        href: "#"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        space: "space.100"
    }, title, lozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), null, lozenge)));

});

parcelRegister("kwgZt", function(module, exports) {

$parcel$export(module.exports, "RecommendationModal", () => $6e7f095537455847$export$d5c06ba24e862b67);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");
var $i8Qvm = parcelRequire("i8Qvm");

var $dS3PR = parcelRequire("dS3PR");

var $7NYq5 = parcelRequire("7NYq5");
const $6e7f095537455847$export$d5c06ba24e862b67 = ({ isOpen: isOpen, onClose: onClose, title: title, body: body, primaryCta: primaryCta })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        messageId: "atlassian-navigation-recommendations.common.ui.recommendation-section.recommendation-modal.modal",
        messageType: "transactional",
        shouldCloseOnEscapePress: true,
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), null, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        as: "p"
    }, body)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "primary",
        onClick: onClose
    }, primaryCta))));

});

parcelRegister("cmzJ2", function(module, exports) {

$parcel$export(module.exports, "useProjectMenuRecommendations", () => $5442a73b6e3e578d$export$d4048a5b8ab1acff);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $5hXPP = parcelRequire("5hXPP");
const $5442a73b6e3e578d$var$initialState = {
    status: 'idle'
};
const $5442a73b6e3e578d$var$store = (0, $iXqE5.createStore)({
    actions: $5hXPP.actions,
    initialState: $5442a73b6e3e578d$var$initialState,
    name: 'atlassian-navigation-recommendation'
});
const $5442a73b6e3e578d$export$d4048a5b8ab1acff = (0, $3sQ5x.createHook)($5442a73b6e3e578d$var$store);

});
parcelRegister("5hXPP", function(module, exports) {

$parcel$export(module.exports, "actions", () => $5033aa90e3adb7fd$export$e324594224ef24da);

var $s7Ri8 = parcelRequire("s7Ri8");
const $5033aa90e3adb7fd$export$e95368803793838f = (recommendations, recommendationContext, analyticsEvent)=>async ({ getState: getState, setState: setState })=>{
        const { status: status } = getState();
        if (status !== 'idle') return;
        setState({
            status: 'loading'
        });
        const shuffledRecommendations = (0, (/*@__PURE__*/$parcel$interopDefault($s7Ri8)))(recommendations);
        try {
            const recommendationStatus = await Promise.all(shuffledRecommendations.map(async (recommendation)=>{
                let isEnabled = false;
                try {
                    isEnabled = await recommendation.shouldRender(recommendationContext, analyticsEvent);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    recommendation.onLoadError(error);
                }
                return {
                    key: recommendation.key,
                    isEnabled: isEnabled
                };
            }));
            const selectedRecommendation = recommendationStatus.find((result)=>result.isEnabled);
            setState({
                status: 'success',
                recommendationKey: selectedRecommendation?.key || null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                status: 'error',
                error: error
            });
        }
    };
const $5033aa90e3adb7fd$var$setRecommendationDismissal = ()=>({ setState: setState })=>{
        setState({
            recommendationKey: null
        });
    };
const $5033aa90e3adb7fd$export$e324594224ef24da = {
    loadRecommendations: $5033aa90e3adb7fd$export$e95368803793838f,
    setRecommendationDismissal: $5033aa90e3adb7fd$var$setRecommendationDismissal
};

});


parcelRegister("kklBj", function(module, exports) {

$parcel$export(module.exports, "projectsMenuDropdownRecommendationSelector", () => $4c06b486be8bb39b$export$2b83859c1548ffb5);
$parcel$export(module.exports, "projectsMenuDropdownLoadJpdRecommendation", () => $4c06b486be8bb39b$export$a784c5bbb21ea554);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
const $4c06b486be8bb39b$export$2b83859c1548ffb5 = new (0, $duUGa.UFOExperience)('projects-menu-dropdown.recommendation-selector', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult
});
const $4c06b486be8bb39b$export$a784c5bbb21ea554 = new (0, $duUGa.UFOExperience)('projects-menu-dropdown.load-jpd-recommendation', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("66CIA", function(module, exports) {

$parcel$export(module.exports, "fetchAppRecommendations", () => $78725ead7cfc4b7c$export$8665956217263d00);

var $5rZL1 = parcelRequire("5rZL1");

var $8Uumt = parcelRequire("8Uumt");

var $8zOmE = parcelRequire("8zOmE");

var $fZneA = parcelRequire("fZneA");


var $6FSDe = parcelRequire("6FSDe");
const $78725ead7cfc4b7c$export$f2d50cdc12f57d0b = (0, $5rZL1.default);
const $78725ead7cfc4b7c$export$8665956217263d00 = async (cloudId, environment, analyticsEvent)=>{
    const appRecommendationState = (0, $6FSDe.getCachedAppRecommendationState)();
    if (appRecommendationState !== null && Date.now() - appRecommendationState.fetchRecommendationTimeStamp < (0, $3202ab0bf207425f$export$424ba99fce04562)) return appRecommendationState.appRecommendations ?? [];
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const data = await (0, $8Uumt.fetchQuery)(environment, $78725ead7cfc4b7c$export$f2d50cdc12f57d0b, {
        cloudId: cloudId
    }).toPromise().catch((err)=>{
        const expectedErrors = [
            401,
            // Unauthorised
            403,
            // Forbidden
            null,
            // Client error
            undefined // Client error
        ];
        if (expectedErrors.includes(err.statusCode) || (0, $fZneA.isClientFetchError)(err)) return {};
        throw Error(`App recommendation ${err.name} error: ${err.message}`, {
            cause: err
        });
    });
    const appRecommendations = data?.growthRecommendations?.recommendations?.data;
    if (!appRecommendations) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'jiraAtlassianNavigation.fetchAppRecommendations empty', {
        response: `${JSON.stringify(data)}`
    });
    (0, $6FSDe.setCachedAppRecommendationState)({
        appRecommendations: appRecommendations,
        fetchRecommendationTimeStamp: Date.now()
    });
    return appRecommendations ?? [];
};

});
parcelRegister("5rZL1", function(module, exports) {

$parcel$export(module.exports, "default", () => $739e1bf50f170603$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<63d29fc2e4b7b13b5431ad6d77aafb97>>
 * @relayHash e631e61cba47acbda6811ed1a287d9f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 620b7134d06fa893e7db6526963c4d8afbe3dc9c5b0428d93f35a2c73fa2ea86
const $739e1bf50f170603$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "fields": [
                {
                    "kind": "Literal",
                    "name": "product",
                    "value": "jira"
                },
                {
                    "kind": "Variable",
                    "name": "tenantId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Literal",
                    "name": "useCase",
                    "value": "jiraProjectMenuRecommendations"
                }
            ],
            "kind": "ObjectValue",
            "name": "context"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 2
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "entityId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "fetchAppRecommendationsV2Query",
            "selections": [
                {
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v2 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "growthRecommendations.recommendations.data.entityId"
                                                        }
                                                    ],
                                                    "type": "GrowthRecJiraTemplateRecommendation"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "GrowthRecRecommendations"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "fetchAppRecommendationsV2Query",
            "selections": [
                {
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v2 /*: any*/ 
                                                    ],
                                                    "type": "GrowthRecJiraTemplateRecommendation"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "GrowthRecRecommendations"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "620b7134d06fa893e7db6526963c4d8afbe3dc9c5b0428d93f35a2c73fa2ea86",
            "metadata": {},
            "name": "fetchAppRecommendationsV2Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$739e1bf50f170603$var$node.hash = "eaaab66d3f41b01ce8e8a969a422ff60";
var $739e1bf50f170603$export$2e2bcd8739ae039 = $739e1bf50f170603$var$node;

});

const $3202ab0bf207425f$export$424ba99fce04562 = 600000;

parcelRegister("6FSDe", function(module, exports) {

$parcel$export(module.exports, "setCachedAppRecommendationState", () => $69d5e6aa5b3a01d0$export$4bb2da71ae03947f);
$parcel$export(module.exports, "getCachedAppRecommendationState", () => $69d5e6aa5b3a01d0$export$951c5f8396f4dcb);

var $bSSG7 = parcelRequire("bSSG7");
const $69d5e6aa5b3a01d0$var$store = (0, $bSSG7.createLocalStorageProvider)('projects-menu-jpd-recommendation');
const $69d5e6aa5b3a01d0$var$APP_RECOMMENDATION_STATE = 'app-recommendation-state';
function $69d5e6aa5b3a01d0$export$4bb2da71ae03947f(appRecommendationState) {
    $69d5e6aa5b3a01d0$var$store.set($69d5e6aa5b3a01d0$var$APP_RECOMMENDATION_STATE, JSON.stringify(appRecommendationState));
}
function $69d5e6aa5b3a01d0$export$951c5f8396f4dcb() {
    const state = $69d5e6aa5b3a01d0$var$store.get($69d5e6aa5b3a01d0$var$APP_RECOMMENDATION_STATE);
    return state ? JSON.parse(state) : null;
}
function $69d5e6aa5b3a01d0$export$a73955031198b1b8() {
    $69d5e6aa5b3a01d0$var$store.remove($69d5e6aa5b3a01d0$var$APP_RECOMMENDATION_STATE);
}

});


parcelRegister("77N15", function(module, exports) {

$parcel$export(module.exports, "default", () => $29218c4ee11cd071$export$2e2bcd8739ae039);
/* product-roadmap-project-avatar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");

var $hau69 = parcelRequire("hau69");
const $29218c4ee11cd071$var$ProductRoadmapProjectAvatar = ()=>{
    return /*#__PURE__*/ $5uXOq.createElement((0, $ujWmd.default), {
        appearance: "square",
        borderColor: "transparent",
        size: "small",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hau69))),
        name: "Jira Product Discovery Roadmap Template"
    });
};
var $29218c4ee11cd071$export$2e2bcd8739ae039 = $29218c4ee11cd071$var$ProductRoadmapProjectAvatar;

});
parcelRegister("hau69", function(module, exports) {
module.exports = new URL("product-roadmap-project-icon.7eb40fb0.svg", import.meta.url).toString();

});


parcelRegister("hb557", function(module, exports) {

$parcel$export(module.exports, "JPD_RECOMMENDATION_KEY", () => $aa2162acaf3862c0$export$3e6ff24c4f517c4f);
$parcel$export(module.exports, "JPD_ROADMAP_KEY", () => $aa2162acaf3862c0$export$c11145b8eb60b18b);
$parcel$export(module.exports, "JPD_RECOMMENDATION_DISMISS_USER_PROPERTY", () => $aa2162acaf3862c0$export$52b9dedc0088f8);
$parcel$export(module.exports, "DATA_PRIVACY_LINK", () => $aa2162acaf3862c0$export$aefe1c8741b24a28);
$parcel$export(module.exports, "JPD_ENTITY_ID", () => $aa2162acaf3862c0$export$909712ccf16883d);
$parcel$export(module.exports, "getProductTypeCcpReferenceIdMapForEnv", () => $aa2162acaf3862c0$export$29629758934356a6);

var $iDfVE = parcelRequire("iDfVE");
const $aa2162acaf3862c0$export$3e6ff24c4f517c4f = 'jpd-recommendation';
const $aa2162acaf3862c0$export$a9c4e38d8a74acd2 = 'jpd.product-discovery';
const $aa2162acaf3862c0$export$c11145b8eb60b18b = 'jpd.product-roadmap';
const $aa2162acaf3862c0$export$52b9dedc0088f8 = 'JpdRecommendationDismissed';
const $aa2162acaf3862c0$export$aefe1c8741b24a28 = 'https://www.atlassian.com/legal/privacy-policy';
const $aa2162acaf3862c0$export$909712ccf16883d = 'jira.polaris:discovery';
const $aa2162acaf3862c0$export$29629758934356a6 = (environment)=>{
    const env = environment === 'prod' ? 'prod' : 'staging';
    return {
        BUSINESS: (0, $iDfVE.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_work_management_cloud,
        SOFTWARE: (0, $iDfVE.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_software_cloud,
        SERVICE_DESK: (0, $iDfVE.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_service_management_cloud,
        PRODUCT_DISCOVERY: (0, $iDfVE.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_product_discovery
    };
};

});

parcelRegister("5RxQU", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f55eacc0b9ee9dc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3f55eacc0b9ee9dc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    learnMoreButtonText: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.learn-more-button-text",
        "defaultMessage": "Why am I seeing this?"
    },
    projectDescription: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.project-description",
        "defaultMessage": "Capture ideas with Jira Product Discovery"
    },
    projectDescriptionProductRoadmap: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.project-description-roadmap",
        "defaultMessage": "Jira Product Discovery project"
    },
    lozengeText: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.lozenge-text",
        "defaultMessage": "try"
    },
    dismissButtonText: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.dismiss-button-text",
        "defaultMessage": "Not interested"
    },
    recommendedText: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.recommended-text",
        "defaultMessage": "Recommended"
    },
    dismissConfirmationTitle: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.dismiss-confirmation-title",
        "defaultMessage": "Got it, thanks for letting us know"
    },
    dismissConfirmationText: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.dismiss-confirmation-text",
        "defaultMessage": "You won't be seeing this here anymore"
    },
    projectTitle: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.project-title",
        "defaultMessage": "New discovery project"
    },
    projectTitleProductRoadmap: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.project-title-product-roadmap",
        "defaultMessage": "Create a roadmap"
    },
    reasonsModalTitle: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-title",
        "defaultMessage": "Why am I seeing this?"
    },
    reasonsModalExplanation: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-explanation",
        "defaultMessage": "We think <strong>Jira Product Discovery</strong> will improve your team's productivity. The recommendation is based on:"
    },
    reasonsModalBulletOneSpork: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-one-spork",
        "defaultMessage": "the tools you use (Jira)"
    },
    reasonsModalBulletTwo: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-two",
        "defaultMessage": "the way you use your existing tools and products"
    },
    privacyPolicy: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.privacy-policy",
        "defaultMessage": "Learn more about your data privacy with Atlassian"
    },
    reasonsModalButtonOk: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-button-ok",
        "defaultMessage": "Ok"
    },
    reasonsModalButtonOkCapitalised: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-button-ok-capitalised",
        "defaultMessage": "OK"
    }
});

});

parcelRegister("7Y8xQ", function(module, exports) {

$parcel$export(module.exports, "hasJpdLicense", () => $b21ff31ac89e5c24$export$2ea69a0925803655);
const $b21ff31ac89e5c24$export$2ea69a0925803655 = (licensedProducts)=>licensedProducts['jira-product-discovery'] === true;

});



parcelRegister("4keKa", function(module, exports) {

$parcel$export(module.exports, "RecommendationLoader", () => $f62159ce20629294$export$f17bc1d33db805f2);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $2NMNM = parcelRequire("2NMNM");

var $d40Fj = parcelRequire("d40Fj");

var $90yGq = parcelRequire("90yGq");

var $k9JTq = parcelRequire("k9JTq");

var $koeKL = parcelRequire("koeKL");

var $dkqym = parcelRequire("dkqym");

var $hqBSi = parcelRequire("hqBSi");

var $DVljb = parcelRequire("DVljb");

var $9OXo1 = parcelRequire("9OXo1");

var $c04PQ = parcelRequire("c04PQ");

var $cmzJ2 = parcelRequire("cmzJ2");
const $f62159ce20629294$export$f17bc1d33db805f2 = ({ recommendations: recommendations })=>{
    const [, { loadRecommendations: loadRecommendations }] = (0, $cmzJ2.useProjectMenuRecommendations)();
    const accountId = (0, $90yGq.useAccountId)();
    const locale = (0, $DVljb.useLocale)();
    const cloudId = (0, $koeKL.useCloudId)();
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    const firstActivationDateMs = (0, $dkqym.useFirstActivationDateMs)();
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const { software: edition } = (0, $k9JTq.useAppEditions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ hasSuccessOnce: hasSuccessOnce, canCreateProject: canCreateProject }] = (0, $d40Fj.useCreateProjectPermission)();
    const { areProductSuggestionsEnabled: areProductSuggestionsEnabled } = (0, $9OXo1.useTenantContext)();
    const isInFedRamp = (0, $c04PQ.isFedRamp)();
    (0, $5uXOq.useEffect)(()=>{
        if (hasSuccessOnce && accountId) loadRecommendations(recommendations, {
            locale: locale,
            accountId: accountId,
            cloudId: cloudId,
            licensedProducts: licensedProducts,
            firstActivationDateMs: firstActivationDateMs,
            areProductSuggestionsEnabled: areProductSuggestionsEnabled,
            edition: edition,
            environment: environment,
            canCreateProject: canCreateProject,
            isInFedRamp: isInFedRamp
        }, createAnalyticsEvent({}));
    }, [
        hasSuccessOnce,
        canCreateProject,
        accountId,
        loadRecommendations,
        createAnalyticsEvent,
        locale,
        cloudId,
        licensedProducts,
        firstActivationDateMs,
        areProductSuggestionsEnabled,
        edition,
        environment,
        recommendations,
        isInFedRamp
    ]);
    return null;
};

});

parcelRegister("9WcgH", function(module, exports) {

$parcel$export(module.exports, "default", () => $430f11f9411f5e73$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $430f11f9411f5e73$var$LazyCustomThemeAdminFlag = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("fNGR4")), {
    ssr: false,
    moduleId: "./src/packages/theme/custom-theme-admin-flag/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$430f11f9411f5e73$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async.jira.custom-theme-admin-flag",
        packageName: "customThemeAdminFlag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "custom-theme-admin-flag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($430f11f9411f5e73$var$LazyCustomThemeAdminFlag, null)));

});
parcelRegister("fNGR4", function(module, exports) {

let $b80cacbedfd636d3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b80cacbedfd636d3$var$load("3ppBr").then(()=>parcelRequire('jWgLY'));

});


parcelRegister("bcn6L", function(module, exports) {

$parcel$export(module.exports, "useFavoriteActions", () => $23bcf74af5f22e12$export$e17993c41bc4dc38);
$parcel$export(module.exports, "useFavoriteBoards", () => $23bcf74af5f22e12$export$896ce0ae2b68d03a);
$parcel$export(module.exports, "useFavoriteDashboards", () => $23bcf74af5f22e12$export$7f929adce53e9217);
$parcel$export(module.exports, "useFavoriteProjects", () => $23bcf74af5f22e12$export$e92f6fc9e0c6d135);
$parcel$export(module.exports, "useFavoriteFilters", () => $23bcf74af5f22e12$export$49e6afd92506d2b4);
$parcel$export(module.exports, "useFavoriteQueues", () => $23bcf74af5f22e12$export$b09f7ee747d8bc9);
$parcel$export(module.exports, "useFavoritePlans", () => $23bcf74af5f22e12$export$56f40dc3d5e1af94);
$parcel$export(module.exports, "FavoritesContainer", () => $23bcf74af5f22e12$export$878515009e0790e0);


var $20jWj = parcelRequire("20jWj");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

const $23bcf74af5f22e12$var$emptyItemState = {
    items: null,
    isFetching: false,
    fetchError: null,
    promise: null,
    hasFetchedOnce: false,
    hasSuccessOnce: false
};
const $23bcf74af5f22e12$export$d4c72bab9d6cc13a = {
    [(0, $49a076eb01652100$export$f95f1a684a17f189)]: {
        ...$23bcf74af5f22e12$var$emptyItemState
    },
    [(0, $49a076eb01652100$export$6e58b6b0aa48a271)]: {
        ...$23bcf74af5f22e12$var$emptyItemState
    },
    [(0, $49a076eb01652100$export$6737b9227f60f39d)]: {
        ...$23bcf74af5f22e12$var$emptyItemState
    },
    [(0, $49a076eb01652100$export$91a9dba2d38d9a6f)]: {
        ...$23bcf74af5f22e12$var$emptyItemState
    },
    [(0, $49a076eb01652100$export$20f1031cc9fdf29e)]: {
        ...$23bcf74af5f22e12$var$emptyItemState
    },
    [(0, $49a076eb01652100$export$eebccb886b064713)]: {
        ...$23bcf74af5f22e12$var$emptyItemState
    }
};
const $23bcf74af5f22e12$var$transformItems = (items)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    items.reduce((acc, itemResponse)=>{
        if (itemResponse.id === 'favourite-boards') acc[0, $49a076eb01652100$export$f95f1a684a17f189] = itemResponse.items;
        if (itemResponse.id === 'favourite-filters') acc[0, $49a076eb01652100$export$6737b9227f60f39d] = itemResponse.items;
        if (itemResponse.id === 'favourite-dashboards') acc[0, $49a076eb01652100$export$6e58b6b0aa48a271] = itemResponse.items;
        if (itemResponse.id === 'favourite-projects') acc[0, $49a076eb01652100$export$91a9dba2d38d9a6f] = itemResponse.items;
        if (itemResponse.id === 'favourite-queues') acc[0, $49a076eb01652100$export$20f1031cc9fdf29e] = itemResponse.items;
        if (itemResponse.id === 'favourite-plans') acc[0, $49a076eb01652100$export$eebccb886b064713] = itemResponse.items;
        return acc;
    }, {});
const $23bcf74af5f22e12$var$loadFavoriteItems = (amount = (0, $7a1562bd0ca086b0$export$ea341e6cc435ed40), types)=>async ({ setState: setState, getState: getState })=>{
        const typesToFetch = types.filter((type)=>!getState()[type].isFetching);
        if (typesToFetch.length) try {
            const promise = (0, $20jWj.fetchFavoriteItems)({
                count: amount,
                types: typesToFetch
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const loadingState = typesToFetch.reduce((acc, type)=>{
                acc[type] = {
                    ...getState()[type],
                    isFetching: true,
                    fetchError: null,
                    promise: promise
                };
                return acc;
            }, {});
            setState(loadingState);
            const itemResponse = await promise;
            const transformed = $23bcf74af5f22e12$var$transformItems(itemResponse);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const responseState = typesToFetch.reduce((acc, type)=>{
                acc[type] = {
                    items: transformed[type],
                    isFetching: false,
                    promise: null,
                    fetchError: null,
                    hasFetchedOnce: true,
                    hasSuccessOnce: true
                };
                return acc;
            }, {});
            setState(responseState);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const errorState = typesToFetch.reduce((acc, type)=>{
                acc[type] = {
                    ...getState()[type],
                    isFetching: false,
                    promise: null,
                    fetchError: fetchError,
                    hasFetchedOnce: true
                };
                return acc;
            }, {});
            setState(errorState);
        }
    };
const $23bcf74af5f22e12$export$e324594224ef24da = {
    loadFavoriteAll: (amount)=>async (actions2, props)=>{
            $23bcf74af5f22e12$var$loadFavoriteItems(amount, [
                props.applicationPermissions.hasSoftwareAccess ? (0, $49a076eb01652100$export$f95f1a684a17f189) : undefined,
                (0, $49a076eb01652100$export$6e58b6b0aa48a271),
                (0, $49a076eb01652100$export$91a9dba2d38d9a6f),
                (0, $49a076eb01652100$export$6737b9227f60f39d),
                props.applicationPermissions.hasServiceDeskAccess ? (0, $49a076eb01652100$export$20f1031cc9fdf29e) : undefined,
                props.applicationPermissions.hasSoftwareAccess ? (0, $49a076eb01652100$export$eebccb886b064713) : undefined
            ].filter(Boolean))(actions2);
        },
    loadFavouriteBoards: (amount)=>$23bcf74af5f22e12$var$loadFavoriteItems(amount, [
            (0, $49a076eb01652100$export$f95f1a684a17f189)
        ]),
    loadFavoriteProjects: (amount)=>$23bcf74af5f22e12$var$loadFavoriteItems(amount, [
            (0, $49a076eb01652100$export$91a9dba2d38d9a6f)
        ]),
    loadFavoriteDashboards: (amount)=>$23bcf74af5f22e12$var$loadFavoriteItems(amount, [
            (0, $49a076eb01652100$export$6e58b6b0aa48a271)
        ]),
    loadFavoriteFilters: (amount)=>$23bcf74af5f22e12$var$loadFavoriteItems(amount, [
            (0, $49a076eb01652100$export$6737b9227f60f39d)
        ]),
    loadFavouriteQueues: (amount)=>$23bcf74af5f22e12$var$loadFavoriteItems(amount, [
            (0, $49a076eb01652100$export$20f1031cc9fdf29e)
        ]),
    loadFavoritePlans: (amount)=>$23bcf74af5f22e12$var$loadFavoriteItems(amount, [
            (0, $49a076eb01652100$export$eebccb886b064713)
        ])
};
const $23bcf74af5f22e12$var$store = (0, $iXqE5.createStore)({
    name: (0, $7a1562bd0ca086b0$export$7a3d0824e907e616),
    actions: $23bcf74af5f22e12$export$e324594224ef24da,
    initialState: $23bcf74af5f22e12$export$d4c72bab9d6cc13a
});
const $23bcf74af5f22e12$export$e17993c41bc4dc38 = (0, $3sQ5x.createHook)($23bcf74af5f22e12$var$store, {
    selector: null
});
const $23bcf74af5f22e12$export$896ce0ae2b68d03a = (0, $3sQ5x.createHook)($23bcf74af5f22e12$var$store, {
    selector: (state)=>state[0, $49a076eb01652100$export$f95f1a684a17f189]
});
const $23bcf74af5f22e12$export$7f929adce53e9217 = (0, $3sQ5x.createHook)($23bcf74af5f22e12$var$store, {
    selector: (state)=>state[0, $49a076eb01652100$export$6e58b6b0aa48a271]
});
const $23bcf74af5f22e12$export$e92f6fc9e0c6d135 = (0, $3sQ5x.createHook)($23bcf74af5f22e12$var$store, {
    selector: (state)=>state[0, $49a076eb01652100$export$91a9dba2d38d9a6f]
});
const $23bcf74af5f22e12$export$49e6afd92506d2b4 = (0, $3sQ5x.createHook)($23bcf74af5f22e12$var$store, {
    selector: (state)=>state[0, $49a076eb01652100$export$6737b9227f60f39d]
});
const $23bcf74af5f22e12$export$b09f7ee747d8bc9 = (0, $3sQ5x.createHook)($23bcf74af5f22e12$var$store, {
    selector: (state)=>state[0, $49a076eb01652100$export$20f1031cc9fdf29e]
});
const $23bcf74af5f22e12$export$56f40dc3d5e1af94 = (0, $3sQ5x.createHook)($23bcf74af5f22e12$var$store, {
    selector: (state)=>state[0, $49a076eb01652100$export$eebccb886b064713]
});
const $23bcf74af5f22e12$export$878515009e0790e0 = (0, $gg7kZ.createContainer)($23bcf74af5f22e12$var$store);

});
const $49a076eb01652100$export$91a9dba2d38d9a6f = 'projects';
const $49a076eb01652100$export$ebb48b08205007c5 = 'issues';
const $49a076eb01652100$export$6737b9227f60f39d = 'filters';
const $49a076eb01652100$export$6e58b6b0aa48a271 = 'dashboards';
const $49a076eb01652100$export$20f1031cc9fdf29e = 'queues';
const $49a076eb01652100$export$f95f1a684a17f189 = 'boards';
const $49a076eb01652100$export$3c11110d46d67e8c = 'jwmBoards';
const $49a076eb01652100$export$5e2cc09b58170ca2 = 'addons';
const $49a076eb01652100$export$eebccb886b064713 = 'plans';
const $49a076eb01652100$export$1c2ea36059c73937 = 'alerts';

parcelRegister("20jWj", function(module, exports) {

$parcel$export(module.exports, "fetchFavoriteItems", () => $7a715a28552f71dc$export$ba7e2966560509a6);

var $6eBRn = parcelRequire("6eBRn");

var $ebyGx = parcelRequire("ebyGx");

var $5HnTq = parcelRequire("5HnTq");

var $fPruT = parcelRequire("fPruT");

const $7a715a28552f71dc$var$handleError = (error)=>{
    throw error;
};
// This is horrible but the API is wrong: the type returned is singular while
// everywhere else (even in add/remove) is plural
// @ts-expect-error - TS7031 - Binding element 'items' implicitly has an 'any' type.
const $7a715a28552f71dc$var$convertTypeToPlural = ({ items: items, ...rest })=>({
        ...rest,
        // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
        items: items.filter(Boolean).map((item)=>({
                ...item,
                type: `${item.type}s`
            }))
    });
const $7a715a28552f71dc$export$ba7e2966560509a6 = async ({ count: count, types: types = [
    (0, $49a076eb01652100$export$91a9dba2d38d9a6f),
    (0, $49a076eb01652100$export$6e58b6b0aa48a271),
    (0, $49a076eb01652100$export$6737b9227f60f39d),
    (0, $49a076eb01652100$export$eebccb886b064713)
] })=>{
    const query = (0, $ebyGx.stringify)((0, (/*@__PURE__*/$parcel$interopDefault($6eBRn)))(types.map((type)=>[
            type,
            count
        ])));
    const url = `/rest/internal/2/favourites?${query}`;
    try {
        const response = await fetch(url, (0, $5HnTq.getDefaultOptions)(url));
        if (!response.ok) {
            const errorCode = response.status;
            if (errorCode === 401) return $7a715a28552f71dc$var$handleError(new (0, $fPruT.AuthenticationError)(`${errorCode}`));
            // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string | undefined'.
            return $7a715a28552f71dc$var$handleError(new Error(errorCode));
        }
        const resp = await response.json();
        return resp.map($7a715a28552f71dc$var$convertTypeToPlural);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $7a715a28552f71dc$var$handleError(error);
    }
};
const $7a715a28552f71dc$export$77fc2acdef452939 = async (item)=>{
    const url = '/rest/internal/2/favourites';
    try {
        const response = await fetch(url, {
            ...(0, $5HnTq.getDefaultOptions)(url),
            method: 'POST',
            body: JSON.stringify({
                entity: {
                    id: item.id,
                    type: item.type
                },
                beforeEntityPosition: null
            })
        });
        if (!response.ok) {
            const errorCode = response.status;
            // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string | undefined'.
            return $7a715a28552f71dc$var$handleError(new Error(errorCode));
        }
        const result = await response.json();
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $7a715a28552f71dc$var$handleError(error);
    }
};
const $7a715a28552f71dc$export$acbe6ca9570854bd = async (item)=>{
    const url = `/rest/internal/2/favourites/${item.type}/${item.id}`;
    try {
        const response = await fetch(url, {
            ...(0, $5HnTq.getDefaultOptions)(url),
            method: 'DELETE'
        });
        if (!response.ok) {
            const errorCode = response.status;
            // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string | undefined'.
            return $7a715a28552f71dc$var$handleError(new Error(errorCode));
        }
        const result = await response.json();
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $7a715a28552f71dc$var$handleError(error);
    }
};

});
parcelRegister("fPruT", function(module, exports) {

$parcel$export(module.exports, "AuthenticationError", () => $95af1b43dc18895e$export$cf0c46b07324e9c5);
class $95af1b43dc18895e$export$cf0c46b07324e9c5 extends Error {
    constructor(message){
        super(message);
        this.name = 'AuthenticationError';
        this.skipSentry = true;
        this.statusCode = 401;
    }
}

});


const $7a1562bd0ca086b0$export$ea341e6cc435ed40 = 15;
const $7a1562bd0ca086b0$export$7a3d0824e907e616 = 'navigation-favourite-store';


parcelRegister("bBulW", function(module, exports) {

$parcel$export(module.exports, "EditionAwareness", () => $60ceaac5e0b6e842$export$a55b02efe3d62583);

var $5uXOq = parcelRequire("5uXOq");

var $9uGVy = parcelRequire("9uGVy");

var $ca1G2 = parcelRequire("ca1G2");

var $7CMCs = parcelRequire("7CMCs");

var $iXVV6 = parcelRequire("iXVV6");
var $2NMNM = parcelRequire("2NMNM");

var $cNd4s = parcelRequire("cNd4s");

var $itmJb = parcelRequire("itmJb");

var $l8ruj = parcelRequire("l8ruj");

var $1w9F2 = parcelRequire("1w9F2");

var $ksvM4 = parcelRequire("ksvM4");

var $koeKL = parcelRequire("koeKL");

var $jX0pr = parcelRequire("jX0pr");

var $jcw0u = parcelRequire("jcw0u");

var $90yGq = parcelRequire("90yGq");

var $2tT7R = parcelRequire("2tT7R");

var $4R6GH = parcelRequire("4R6GH");

var $bQaTP = parcelRequire("bQaTP");

var $dof5Y = parcelRequire("dof5Y");
const $60ceaac5e0b6e842$var$EditionAwarenessPlatformInnerWithRTCheck = (props)=>{
    const { isReady: isReady, isInReverseTrial: isInReverseTrial, onOpenOnboardingMenu: onOpenOnboardingMenu } = (0, $dof5Y.useReverseTrials)();
    // We need to wait for the reverse trial check to be complete before rendering the button
    const canRender = props.canRender && isReady;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1w9F2.EditionAwareness), {
        ...props,
        isInReverseTrial: isInReverseTrial,
        onOpenOnboardingMenu: onOpenOnboardingMenu,
        canRender: canRender
    });
};
const $60ceaac5e0b6e842$var$EditionAwarenessPlatformInner = (props)=>{
    const { isDismissed: isDismissed, handleDismiss: handleDismiss } = (0, $9uGVy.useIsEditionAwarenessPillDismissed)();
    const { isEligibleForUpsellEa: isEligibleForUpsellEa } = (0, $ca1G2.useIsEligibleForUpsellEa)({
        product: props.product,
        edition: props.edition,
        isSiteAdmin: Boolean(props.userRoles?.includes('SITE_ADMIN'))
    });
    return isEligibleForUpsellEa ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ksvM4.EditionAwarenessUpsell), (({ product: product, cloudId: cloudId, edition: edition, userRoles: userRoles })=>({
            product: product,
            cloudId: cloudId,
            edition: edition,
            userRoles: userRoles,
            hasDismissedButton: isDismissed,
            onDismissButton: handleDismiss
        }))(props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1w9F2.EditionAwareness), props);
};
const $60ceaac5e0b6e842$var$EditionAwarenessPlatform = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const accountId = (0, $90yGq.useAccountId)();
    const environment = (0, $2tT7R.useEnvironment)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isJiraAdmin = (0, $itmJb.useIsAdmin)();
    const { product: product, edition: edition } = (0, $bQaTP.useProductAndEdition)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const userRoles = (0, $5uXOq.useMemo)(()=>{
        const roles = [];
        if (isSiteAdmin) roles.push('SITE_ADMIN');
        if (isJiraAdmin) roles.push('JIRA_ADMIN');
        return roles;
    }, [
        isSiteAdmin,
        isJiraAdmin
    ]);
    // Calculate which editions need to fetch traits
    const [siteTraits, setSiteTraits] = (0, $5uXOq.useState)(()=>{
        if (edition === 'standard' && product === 'jira' && (0, $4R6GH.fg)('ea_traits_for_jira_standard')) return undefined;
        return edition === 'free' ? undefined : [];
    });
    (0, $5uXOq.useEffect)(()=>{
        if (siteTraits === undefined) (0, $jX0pr.memoizedFetchSitePersonalization)({
            cloudId: cloudId
        }).then((traits)=>{
            setSiteTraits(traits);
        }).catch((e)=>{
            setSiteTraits([]);
            const event = createAnalyticsEvent({});
            (0, $jcw0u.default)({
                event: event,
                meta: {
                    id: 'editionAwarenessGrowthCohortTrait',
                    packageName: 'edition-awareness',
                    teamName: 'growth-tako'
                },
                error: e,
                sendToPrivacyUnsafeSplunk: true
            });
        });
    }, [
        cloudId,
        createAnalyticsEvent,
        edition,
        siteTraits
    ]);
    // We need to wait for the siteType to be set before rendering the button
    const canRender = siteTraits !== undefined;
    // eslint-disable-next-line no-nested-ternary
    const editionAwarenessProps = (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-2') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useMemo)(()=>{
        if (!product || !edition) return null;
        if (!accountId && (0, $4R6GH.fg)('edition_awareness_account_id_required')) // We don't render when the customer is not logged in
        return null;
        return {
            edition: edition,
            cloudId: cloudId,
            product: product,
            accountId: accountId,
            environment: environment,
            userRoles: userRoles,
            siteTraits: siteTraits,
            canRender: canRender
        };
    }, [
        accountId,
        canRender,
        cloudId,
        edition,
        environment,
        userRoles,
        product,
        siteTraits
    ]) : !product || !edition || !accountId && (0, $4R6GH.fg)('edition_awareness_account_id_required') ? null : {
        edition: edition,
        cloudId: cloudId,
        product: product,
        accountId: accountId,
        environment: environment,
        userRoles: userRoles,
        siteTraits: siteTraits,
        canRender: canRender
    };
    if (!(0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-2')) {
        // we are now doing these check within the editionAwarenessProps memo, and if editionAwarenessProps is null we return null later
        if (!product || !edition) return null;
        if (!accountId && (0, $4R6GH.fg)('edition_awareness_account_id_required')) // We don't render when the customer is not logged in
        return null;
    }
    if (!editionAwarenessProps) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            isSiteAdmin: isSiteAdmin,
            product: product,
            edition: edition
        }
    }, edition === 'premium' && product === 'jira' ? // We need to call a few hooks to check RT, could be cleaned up in the future
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($60ceaac5e0b6e842$var$EditionAwarenessPlatformInnerWithRTCheck, editionAwarenessProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($60ceaac5e0b6e842$var$EditionAwarenessPlatformInner, editionAwarenessProps));
};
const $60ceaac5e0b6e842$export$a55b02efe3d62583 = ()=>{
    // This component is not rendered on the server, we don't have enough information to determine if it will be renderer or not
    // Don't remove because it may cause the SSR to fail, at this point it because the EditonAwarenessButton is using useLazyLoadQuery
    if (false) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "EditionAwareness",
        packageName: "jiraNavigationAppsSidebarEditionAwareness",
        fallback: "unmount",
        teamName: "growth-tako"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "edition-awareness"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($60ceaac5e0b6e842$var$EditionAwarenessPlatform, null)));
};

});
parcelRegister("9uGVy", function(module, exports) {

$parcel$export(module.exports, "useIsEditionAwarenessPillDismissed", () => $16a1e29b9123e8d1$export$7cb865d6d91f9a4d);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $jPvhy = parcelRequire("jPvhy");
const $16a1e29b9123e8d1$export$7cb865d6d91f9a4d = ()=>{
    const [hasFetched, setHasFetched] = (0, $5uXOq.useState)(false);
    const [isDismissed, setIsDismissed] = (0, $5uXOq.useState)(true);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $4R6GH.fg)('edition_awareness_upsell_jira_ab_fg')) (0, $jPvhy.fetchEditionAwarenessPillDismissed)().then((result)=>{
            // if result is undefined, it means the call failed and we can't be certain if the user dismissed the pill or not
            if (result !== undefined) {
                setIsDismissed(!!result);
                setHasFetched(true);
            }
        });
    }, []);
    const handleDismiss = (0, $5uXOq.useCallback)(()=>{
        if ((0, $4R6GH.fg)('edition_awareness_upsell_jira_ab_fg')) {
            setIsDismissed(true);
            (0, $jPvhy.setEditionAwarenessPillDismissed)(true);
        }
    }, []);
    return {
        hasFetched: hasFetched,
        isDismissed: isDismissed,
        handleDismiss: handleDismiss
    };
};

});
parcelRegister("jPvhy", function(module, exports) {

$parcel$export(module.exports, "setEditionAwarenessPillDismissed", () => $439f9424d8ca41fa$export$b0b754c480c139ac);
$parcel$export(module.exports, "fetchEditionAwarenessPillDismissed", () => $439f9424d8ca41fa$export$1eb6cd4dd0048115);

var $aHuqL = parcelRequire("aHuqL");

var $jcw0u = parcelRequire("jcw0u");

const $439f9424d8ca41fa$var$ProductKeyToHAMSMap = {
    jira: 'jira-software',
    'jira-product-discovery': 'jira-product-discovery',
    'jira-service-management': 'jira-servicedesk'
};
const $439f9424d8ca41fa$export$291d012eb0744b34 = (product)=>{
    return $439f9424d8ca41fa$var$ProductKeyToHAMSMap[product];
};
const $439f9424d8ca41fa$export$b0b754c480c139ac = async (value)=>{
    try {
        await (0, $aHuqL.userPreferenceAPI).set((0, $27f794e239d3d8c4$export$83e119fb36bc846a), value);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $jcw0u.default)({
            error: err,
            meta: {
                id: 'setEditionAwarenessPillDismissed',
                packageName: (0, $27f794e239d3d8c4$export$52483b87432059f1)
            }
        });
    }
};
const $439f9424d8ca41fa$export$1eb6cd4dd0048115 = async ()=>{
    try {
        return await (0, $aHuqL.userPreferenceAPI).get((0, $27f794e239d3d8c4$export$83e119fb36bc846a));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        // 404 is acceptable as it means user hasn't dismissed it yet
        if (err.statusCode === 404) return null;
        (0, $jcw0u.default)({
            error: err,
            meta: {
                id: 'fetchEditionAwarenessPillDismissed',
                packageName: (0, $27f794e239d3d8c4$export$52483b87432059f1)
            }
        });
        return undefined;
    }
};

});
const $27f794e239d3d8c4$export$52483b87432059f1 = 'jiraEditionAwarenessForStandardToPremium';
const $27f794e239d3d8c4$export$83e119fb36bc846a = 'jira.user.theme.standard-to-premium-ea-pill.dismissed';



parcelRegister("ca1G2", function(module, exports) {

$parcel$export(module.exports, "useIsEligibleForUpsellEa", () => $19c1cd17daaf5951$export$d937ac4841c15ef7);
/* eslint-disable jira/ff/unsafe-no-exposure */ /* eslint-disable jira/deprecations/ban-identifiers */ 

var $1laI5 = parcelRequire("1laI5");

var $5oBMG = parcelRequire("5oBMG");

var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");
const $19c1cd17daaf5951$export$d937ac4841c15ef7 = ({ product: product, edition: edition, isSiteAdmin: isSiteAdmin })=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('edition_awareness_upsell_jira_ab');
    const productEntitlementDetails = (0, $5oBMG.useProductEntitlementDetails)();
    // Enrollment logic
    const cohort = expConfig.get('cohort', 'not-enrolled');
    const enrolled = cohort !== 'not-enrolled';
    // Trial State logic
    let productKey;
    switch(product){
        case 'jira':
            productKey = (0, $c06e1abca7c13910$export$1346c9aa3cbb477d);
            break;
        case 'jira-service-management':
            productKey = (0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61);
            break;
        default:
    }
    const entitlementDetails = productKey && productEntitlementDetails?.[productKey];
    const trialEndTime = entitlementDetails?.trialEndTime;
    const trialDaysLeft = (0, $1laI5.getTrialDaysLeft)(trialEndTime);
    const isInTrial = !entitlementDetails ? undefined : !!trialDaysLeft && trialDaysLeft > 0;
    const isEligibleForUpsellEa = edition === 'standard' && enrolled && isInTrial === false && isSiteAdmin && (0, $4R6GH.fg)('edition_awareness_upsell_jira_ab_fg');
    return {
        isEligibleForUpsellEa: isEligibleForUpsellEa,
        cohort: cohort
    };
};

});

parcelRegister("bQaTP", function(module, exports) {

$parcel$export(module.exports, "useProductAndEdition", () => $f3ac7751023fca6b$export$b0f1c0403c557678);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $lpwtK = parcelRequire("lpwtK");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $4SswE = parcelRequire("4SswE");
const $f3ac7751023fca6b$export$8aab08255f8e5ef0 = {
    FREE_EDITION: 'free',
    STANDARD_EDITION: 'standard',
    PREMIUM_EDITION: 'premium'
};
const $f3ac7751023fca6b$export$7e5a22794fbe56f2 = {
    [(0, $2vSU6.SOFTWARE_PROJECT)]: 'jira',
    [(0, $2vSU6.CORE_PROJECT)]: 'jira',
    [(0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)]: 'jira-product-discovery',
    [(0, $2vSU6.SERVICE_DESK_PROJECT)]: 'jira-service-management'
};
const $f3ac7751023fca6b$export$b0f1c0403c557678 = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const { loading: loading, data: project } = (0, $lpwtK.useProject)();
    const siteHasOnlyJira = (0, $4SswE.useSiteHasOnlyJira)();
    // Show premium pill button for JSM premium trial experiment
    const projectType = (0, $5uXOq.useMemo)(()=>{
        if (loading) return;
        const type = (0, $2vSU6.toProjectType)(project?.type);
        if (type) return type;
        if (siteHasOnlyJira) return 0, $2vSU6.SOFTWARE_PROJECT;
    }, [
        loading,
        project?.type,
        siteHasOnlyJira
    ]);
    const applicationEdition = (0, $5uXOq.useMemo)(()=>{
        if (!projectType) return;
        if (siteHasOnlyJira) return (0, $ldyPw.getEditionForProject)((0, $2vSU6.SOFTWARE_PROJECT), appEditions);
        return (0, $ldyPw.getEditionForProject)(projectType, appEditions);
    }, [
        appEditions,
        projectType,
        siteHasOnlyJira
    ]);
    const { product: product, edition: edition } = (0, $5uXOq.useMemo)(()=>{
        if (!projectType || !applicationEdition) // We don't have a product or edition, so return nothing
        return {};
        if (projectType === (0, $2vSU6.CORE_PROJECT) && !siteHasOnlyJira) // We are supporting only JWM implicit licensing when the parent license is JSW
        // Do not show on core products if site does not have only Jira
        return {};
        return {
            product: $f3ac7751023fca6b$export$7e5a22794fbe56f2[projectType],
            edition: $f3ac7751023fca6b$export$8aab08255f8e5ef0[applicationEdition]
        };
    }, [
        applicationEdition,
        projectType,
        siteHasOnlyJira
    ]);
    return {
        product: product,
        edition: edition
    };
};

});
parcelRegister("4SswE", function(module, exports) {

$parcel$export(module.exports, "useSiteHasOnlyJira", () => $b6d886096eb5e5b4$export$8ce0db5ac54a6136);

var $cVzoY = parcelRequire("cVzoY");


var $9OXo1 = parcelRequire("9OXo1");
function $b6d886096eb5e5b4$export$8ce0db5ac54a6136() {
    const tenantContext = (0, $9OXo1.useTenantContext)();
    try {
        const [firstExplicitlyLicensedProduct, ...rest] = (0, $cVzoY.default)(tenantContext);
        return rest.length === 0 && firstExplicitlyLicensedProduct === (0, $c06e1abca7c13910$export$1346c9aa3cbb477d);
    } catch  {
        return false;
    }
}

});


parcelRegister("dof5Y", function(module, exports) {

$parcel$export(module.exports, "useReverseTrials", () => $2f6c07d56684e27e$export$8f6d4c7745b1e143);

var $5uXOq = parcelRequire("5uXOq");

var $eYvmm = parcelRequire("eYvmm");

var $8Bc5A = parcelRequire("8Bc5A");

var $cE2Qr = parcelRequire("cE2Qr");

var $4i99S = parcelRequire("4i99S");

var $jOXuX = parcelRequire("jOXuX");
const $2f6c07d56684e27e$export$8f6d4c7745b1e143 = ()=>{
    const openChecklist = (0, $4i99S.useOpenChecklist)();
    const [{ currentTaskGroupParent: currentTaskGroupParent }, { changeTaskGroupParent: changeTaskGroupParent, nextOpenTask: nextOpenTask }] = (0, $cE2Qr.useJswOnboarding)();
    const { isInReverseTrial: isInReverseTrial, isReady: isRTReady } = (0, $eYvmm.useInReverseTrial)();
    const { isReady: isTOReady, isTailoredOnboardingM3EnabledAndEligible: isTailoredOnboardingM3EnabledAndEligible, isTailoredOnboardingScrumAndSoftwareKanbanEnabled: isTailoredOnboardingScrumAndSoftwareKanbanEnabled } = (0, $jOXuX.useIsTailoredOnboardingEnabledAndEligible)();
    const onOpenOnboardingMenu = (0, $5uXOq.useCallback)(()=>{
        const taskGroupToEnter = (0, $8Bc5A.PREMIUM_REVERSE_TRIAL_TASK);
        if (currentTaskGroupParent !== taskGroupToEnter) changeTaskGroupParent(taskGroupToEnter);
        openChecklist({
            trigger: 'ReverseTrialPopup'
        });
        nextOpenTask((0, $8Bc5A.ADVANCED_ROADMAPS_TASK), {
            closeNudge: true
        });
    }, [
        currentTaskGroupParent,
        openChecklist,
        nextOpenTask,
        changeTaskGroupParent
    ]);
    if (!isRTReady || !isTOReady) return {
        isReady: false,
        isInReverseTrial: undefined,
        onOpenOnboardingMenu: undefined
    };
    // The check for `jira_rt_quickstart_m1` experiment is performed on platform
    const hidePremiumFeatureItem = isTailoredOnboardingM3EnabledAndEligible || isTailoredOnboardingScrumAndSoftwareKanbanEnabled;
    return {
        isReady: true,
        isInReverseTrial: isInReverseTrial,
        onOpenOnboardingMenu: hidePremiumFeatureItem ? undefined : onOpenOnboardingMenu
    };
};

});
parcelRegister("eYvmm", function(module, exports) {

$parcel$export(module.exports, "useInReverseTrial", () => $8a55417384eda66a$export$76f7829aa123c9c4);

var $dkqym = parcelRequire("dkqym");

var $4R6GH = parcelRequire("4R6GH");

var $70Wxp = parcelRequire("70Wxp");
/**
 * This hook is used to check if the user is signed up in a reverse trial
 * and also user is within the attribution window
 * which identify the user is currently in the 'first' reverse trial
 */ const $8a55417384eda66a$var$ATTRIBUTION_WINDOW = 45; // days
const $8a55417384eda66a$var$MILLISECONDS_IN_DAY = 8640000000;
const $8a55417384eda66a$export$76f7829aa123c9c4 = ()=>{
    const firstActivationDate = (0, $dkqym.useFirstActivationDateMs)();
    const { premiumTrialOnSignup: premiumTrialOnSignup, isReady: isReady } = (0, $70Wxp.useFetchOnboardingReverseTrial)();
    if (isReady) return {
        isInReverseTrial: (0, $4R6GH.fg)('is_current_in_reverse_trial_feature_gate') ? premiumTrialOnSignup && !!firstActivationDate && Date.now() - firstActivationDate <= $8a55417384eda66a$var$ATTRIBUTION_WINDOW * $8a55417384eda66a$var$MILLISECONDS_IN_DAY : premiumTrialOnSignup,
        isReady: isReady
    };
    return {
        isInReverseTrial: undefined,
        isReady: isReady
    };
};

});
parcelRegister("70Wxp", function(module, exports) {

$parcel$export(module.exports, "useFetchOnboardingReverseTrial", () => $5ec4a2aef6f6d0e2$export$349fbee95cd03b58);

var $5uXOq = parcelRequire("5uXOq");

var $AK64q = parcelRequire("AK64q");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $gh567 = parcelRequire("gh567");

var $7aHUB = parcelRequire("7aHUB");
const $5ec4a2aef6f6d0e2$var$store = (0, $iXqE5.createStore)({
    name: 'jsw-onboarding-reverse-trial',
    initialState: (0, $AK64q.initialCachedEndpointState),
    actions: $7aHUB.actions
});
const $5ec4a2aef6f6d0e2$export$6758b294795e1644 = (0, $3sQ5x.createHook)($5ec4a2aef6f6d0e2$var$store);
const $5ec4a2aef6f6d0e2$export$349fbee95cd03b58 = ()=>{
    const isTargetedForReverseTrials = (0, $gh567.useIsTargetedForReverseTrials)();
    const [{ fetchedOnce: fetchedOnce, isFetching: isFetching, data: data }, { getPremiumTrialOnSignup: getPremiumTrialOnSignup }] = $5ec4a2aef6f6d0e2$export$6758b294795e1644();
    (0, $5uXOq.useEffect)(()=>{
        if (isTargetedForReverseTrials && !fetchedOnce && !isFetching && data === undefined) // @ts-expect-error Arguments for the rest parameter 'args' were not provided.
        getPremiumTrialOnSignup();
    }, [
        data,
        fetchedOnce,
        getPremiumTrialOnSignup,
        isFetching,
        isTargetedForReverseTrials
    ]);
    if (!isTargetedForReverseTrials) // If not targeted, no fetching is done. Data is ready to be read
    return {
        premiumTrialOnSignup: undefined,
        reverseTrialCohort: data?.reverseTrialCohort,
        isReady: true
    };
    return {
        premiumTrialOnSignup: data?.premiumTrialOnSignup,
        reverseTrialCohort: data?.reverseTrialCohort,
        isReady: fetchedOnce && !isFetching
    };
};

});
parcelRegister("AK64q", function(module, exports) {

$parcel$export(module.exports, "initialCachedEndpointState", () => $e18633c22e50182e$export$aaed2d023c5dc2c);
const $e18633c22e50182e$export$aaed2d023c5dc2c = {
    isFetching: false,
    wasFetched: false,
    fetchedOnce: false,
    fetchError: null
};

});

parcelRegister("gh567", function(module, exports) {

$parcel$export(module.exports, "useIsTargetedForReverseTrials", () => $b8cd58920d764600$export$897219a3ca9649b9);

var $2vSU6 = parcelRequire("2vSU6");

var $dAfqg = parcelRequire("dAfqg");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");
const $b8cd58920d764600$export$897219a3ca9649b9 = ()=>{
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const jswEdition = (0, $k9JTq.useAppEditions)().software;
    const isCurrentProjectJSW = projectContextData?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    if (jswEdition === (0, $ldyPw.PREMIUM_EDITION) && isCurrentProjectJSW) return true;
    return false;
};

});

parcelRegister("7aHUB", function(module, exports) {

$parcel$export(module.exports, "actions", () => $9bc9ce12e98e96a1$export$e324594224ef24da);

var $7bRcT = parcelRequire("7bRcT");

var $bfWlw = parcelRequire("bfWlw");
const $9bc9ce12e98e96a1$var$getPremiumTrialOnSignup = (0, $7bRcT.cachedEndpointCall)((0, $bfWlw.getOnboardingPremiumTrialWithRethrow));
const $9bc9ce12e98e96a1$export$e324594224ef24da = {
    getPremiumTrialOnSignup: $9bc9ce12e98e96a1$var$getPremiumTrialOnSignup
};

});
parcelRegister("7bRcT", function(module, exports) {

$parcel$export(module.exports, "cachedEndpointCall", () => $69bbbca5d7164078$export$9ab04ab45a9b99da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $69bbbca5d7164078$export$9ab04ab45a9b99da = (call)=>(params)=>async ({ getState: getState, setState: setState })=>{
            const { isFetching: isFetching, wasFetched: wasFetched, fetchedOnce: fetchedOnce } = getState();
            if (isFetching || wasFetched) return;
            setState({
                isFetching: true
            });
            try {
                const data = await call(params);
                if (data !== null) setState({
                    data: data,
                    wasFetched: true
                });
                else setState({
                    wasFetched: fetchedOnce
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    fetchError: error
                });
            } finally{
                setState({
                    isFetching: false,
                    fetchedOnce: true
                });
            }
        };

});




parcelRegister("4i99S", function(module, exports) {

$parcel$export(module.exports, "useOpenChecklist", () => $5c528ffca81c6bae$export$318fa8576ad8aa73);

var $2NMNM = parcelRequire("2NMNM");

var $hsmeR = parcelRequire("hsmeR");

var $94Uc1 = parcelRequire("94Uc1");

var $8Bc5A = parcelRequire("8Bc5A");

var $cE2Qr = parcelRequire("cE2Qr");

var $52Vcw = parcelRequire("52Vcw");
const $5c528ffca81c6bae$export$318fa8576ad8aa73 = ()=>{
    const [{ openTask: currentOpenTask }, { nextSetChecklistIsOpen: nextSetChecklistIsOpen, nextSetChecklistIsDismissed: nextSetChecklistIsDismissed, nextOpenTask: nextOpenTask }] = (0, $cE2Qr.useJswOnboarding)();
    const { openRightSidebar: openRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [quickstartStatus] = (0, $cE2Qr.useQuickstartUiStatus)();
    const currentRightSidebarState = (0, $hsmeR.useActiveRightSidebarState)();
    const currentPanelId = currentRightSidebarState?.panelId;
    const openChecklist = ({ trigger: trigger, openTask: openTask })=>{
        if (openTask && openTask !== currentOpenTask) nextOpenTask(openTask);
        openRightSidebar((0, $94Uc1.PANEL_ID), (0, $94Uc1.PANEL_WIDTH), false, true);
        (0, $52Vcw.fireAnalyticsOnOpenRightHandSidebar)(createAnalyticsEvent, {
            quickstartStatus: quickstartStatus,
            currentRightSidebarPanelId: currentPanelId || '',
            openRightSidebarToTop: true,
            trigger: trigger
        });
        if (quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED) nextSetChecklistIsDismissed(false);
        else nextSetChecklistIsOpen(true);
    };
    return openChecklist;
};

});
parcelRegister("94Uc1", function(module, exports) {

$parcel$export(module.exports, "PANEL_ID", () => $5bee65240229f284$export$e1d562d81d0e502d);
$parcel$export(module.exports, "PANEL_WIDTH", () => $5bee65240229f284$export$e05cfff20e9274e6);
$parcel$export(module.exports, "PERFORMANCE_METRIC_PREFIX", () => $5bee65240229f284$export$495d0560d6ea05d0);
$parcel$export(module.exports, "PERFORMANCE_MARK", () => $5bee65240229f284$export$5da8d06749e84d86);
const $5bee65240229f284$export$e1d562d81d0e502d = 'jsw-nux-onboarding-checklist';
const $5bee65240229f284$export$e05cfff20e9274e6 = 360;
const $5bee65240229f284$export$495d0560d6ea05d0 = 'onboarding-quickstart';
const $5bee65240229f284$export$5da8d06749e84d86 = {
    BUNDLE_LOAD_START: 'bundleLoaded',
    BUNDLE_LOAD_END: 'bundleLoadedEnd'
};

});




parcelRegister("jzLyJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6a4f4791eb95a6a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $f6a4f4791eb95a6a$var$LazyNav4RolloutAnalytics = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("2FMAW")).then(({ Nav4RolloutAnalytics: Nav4RolloutAnalytics })=>Nav4RolloutAnalytics), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/rollout/analytics/src/index.tsx"
});
const $f6a4f4791eb95a6a$var$AsyncNav4RolloutAnalytics = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async-nav4-rollout-analytics",
        fallback: "unmount",
        packageName: "jiraNavigationAppsSidebarNav4RolloutAnalytics",
        teamName: "jira-cosmos"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "lazy-nav4-rollout-analytics"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f6a4f4791eb95a6a$var$LazyNav4RolloutAnalytics, null)));
$f6a4f4791eb95a6a$var$AsyncNav4RolloutAnalytics.displayName = 'AsyncNav4RolloutAnalytics';
var $f6a4f4791eb95a6a$export$2e2bcd8739ae039 = $f6a4f4791eb95a6a$var$AsyncNav4RolloutAnalytics;

});
parcelRegister("2FMAW", function(module, exports) {

let $1f251b0228263d84$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1f251b0228263d84$var$load("khxy3").then(()=>parcelRequire('1O92x'));

});


parcelRegister("apeap", function(module, exports) {

$parcel$export(module.exports, "useRecentActions", () => $c11b2121dbe8e38b$export$5c0647984dfa7d27);
$parcel$export(module.exports, "useRecentAllSingleList", () => $c11b2121dbe8e38b$export$9a54f46f5b7734c);
$parcel$export(module.exports, "useWorkedOnAllSingleList", () => $c11b2121dbe8e38b$export$e8278a7bcff1ec98);
$parcel$export(module.exports, "useRecentBoards", () => $c11b2121dbe8e38b$export$3731bd023be4f71);
$parcel$export(module.exports, "useRecentDashboards", () => $c11b2121dbe8e38b$export$81cb5beef51d43ca);
$parcel$export(module.exports, "useRecentProjects", () => $c11b2121dbe8e38b$export$f6b9a13c4ec08b45);
$parcel$export(module.exports, "useRecentFilters", () => $c11b2121dbe8e38b$export$8d2bfb6d3657bae2);
$parcel$export(module.exports, "useRecentQueues", () => $c11b2121dbe8e38b$export$8756abb0bb90a56e);
$parcel$export(module.exports, "RecentsContainer", () => $c11b2121dbe8e38b$export$5de14a1c1400859e);


var $165Uv = parcelRequire("165Uv");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

const $c11b2121dbe8e38b$var$emptyItemState = {
    items: null,
    isFetching: false,
    fetchError: null,
    promise: null,
    hasFetchedOnce: false,
    hasSuccessOnce: false
};
const $c11b2121dbe8e38b$export$d4c72bab9d6cc13a = {
    [(0, $49a076eb01652100$export$f95f1a684a17f189)]: {
        ...$c11b2121dbe8e38b$var$emptyItemState
    },
    [(0, $49a076eb01652100$export$6e58b6b0aa48a271)]: {
        ...$c11b2121dbe8e38b$var$emptyItemState
    },
    [(0, $49a076eb01652100$export$6737b9227f60f39d)]: {
        ...$c11b2121dbe8e38b$var$emptyItemState
    },
    [(0, $49a076eb01652100$export$91a9dba2d38d9a6f)]: {
        ...$c11b2121dbe8e38b$var$emptyItemState
    },
    [(0, $49a076eb01652100$export$20f1031cc9fdf29e)]: {
        ...$c11b2121dbe8e38b$var$emptyItemState
    },
    workedOn: {
        ...$c11b2121dbe8e38b$var$emptyItemState
    },
    all: {
        ...$c11b2121dbe8e38b$var$emptyItemState
    }
};
const $c11b2121dbe8e38b$var$transformItems = (items)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    items.reduce((acc, itemResponse)=>{
        if (itemResponse.id === 'quick-search-boards') acc[0, $49a076eb01652100$export$f95f1a684a17f189] = itemResponse.items;
        if (itemResponse.id === 'quick-search-filters') acc[0, $49a076eb01652100$export$6737b9227f60f39d] = itemResponse.items;
        if (itemResponse.id === 'quick-search-dashboards') acc[0, $49a076eb01652100$export$6e58b6b0aa48a271] = itemResponse.items;
        if (itemResponse.id === 'quick-search-projects') acc[0, $49a076eb01652100$export$91a9dba2d38d9a6f] = itemResponse.items;
        if (itemResponse.id === 'quick-search-queues') acc[0, $49a076eb01652100$export$20f1031cc9fdf29e] = itemResponse.items;
        return acc;
    }, {});
const $c11b2121dbe8e38b$var$transformWorkedOnItems = (response)=>// select the right data and rename it
    response.data.activities.myActivities.workedOn.nodes.map(({ object: { id: id, localResourceId: localResourceId, name: name, extension: extension, iconUrl: iconUrl, url: url, containers: containers, type: type } })=>({
            id: id,
            localResourceId: localResourceId,
            title: name,
            metadata: extension.issueKey,
            avatarUrl: iconUrl,
            url: url,
            attributes: {
                containerName: containers.find((container)=>container.type === 'PROJECT')?.name
            },
            type: `${type.toLowerCase()}s`
        }));
const $c11b2121dbe8e38b$var$getQueryConfig = (amount, types)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    types.reduce((acc, type)=>{
        acc[type] = amount;
        return acc;
    }, {});
const $c11b2121dbe8e38b$var$loadRecentItems = (amount = (0, $e706d38cada11fb1$export$22ea57e66775a6b2), types)=>async ({ setState: setState, getState: getState })=>{
        const typesToFetch = types.filter((type)=>!getState()[type].isFetching);
        if (typesToFetch.length) try {
            const promise = (0, $165Uv.fetchRecentItems)({
                counts: $c11b2121dbe8e38b$var$getQueryConfig(amount, typesToFetch)
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const loadingState = typesToFetch.reduce((acc, type)=>{
                acc[type] = {
                    ...getState()[type],
                    isFetching: true,
                    fetchError: null,
                    promise: promise
                };
                return acc;
            }, {});
            setState(loadingState);
            const itemResponse = await promise;
            const transformed = $c11b2121dbe8e38b$var$transformItems(itemResponse || []);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const responseState = typesToFetch.reduce((acc, type)=>{
                acc[type] = {
                    items: transformed[type],
                    isFetching: false,
                    promise: null,
                    fetchError: null,
                    hasFetchedOnce: true,
                    hasSuccessOnce: true
                };
                return acc;
            }, {});
            setState(responseState);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const errorState = typesToFetch.reduce((acc, type)=>{
                acc[type] = {
                    ...getState()[type],
                    isFetching: false,
                    promise: null,
                    fetchError: fetchError,
                    hasFetchedOnce: true
                };
                return acc;
            }, {});
            setState(errorState);
        }
    };
const $c11b2121dbe8e38b$var$loadRecentItemsSingleList = (amount = (0, $e706d38cada11fb1$export$5f1b6c5e9d257e5e), types)=>async ({ setState: setState, getState: getState })=>{
        if (types.length) try {
            const promise = (0, $165Uv.fetchRecentItemsSingleList)({
                types: types,
                limit: amount
            });
            const loadingState = {
                all: {
                    ...getState().all,
                    isFetching: true,
                    fetchError: null,
                    promise: promise
                }
            };
            setState(loadingState);
            const itemResponse = await promise;
            const responseState = {
                all: {
                    items: itemResponse != null ? itemResponse[0].items : [],
                    isFetching: false,
                    promise: null,
                    fetchError: null,
                    hasFetchedOnce: true,
                    hasSuccessOnce: true
                }
            };
            setState(responseState);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            const errorState = {
                all: {
                    ...getState().all,
                    isFetching: false,
                    promise: null,
                    fetchError: fetchError,
                    hasFetchedOnce: true
                }
            };
            setState(errorState);
        }
    };
const $c11b2121dbe8e38b$var$loadWorkedOnItems = (amount = (0, $e706d38cada11fb1$export$8666f31c8873bff))=>async ({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        try {
            const promise = (0, $165Uv.fetchWorkedOnItems)({
                cloudId: cloudId,
                amount: amount
            });
            const loadingState = {
                workedOn: {
                    ...getState().workedOn,
                    isFetching: true,
                    fetchError: null,
                    promise: promise
                }
            };
            setState(loadingState);
            const itemResponse = await promise;
            const transformedItems = $c11b2121dbe8e38b$var$transformWorkedOnItems(itemResponse);
            const responseState = {
                workedOn: {
                    items: transformedItems,
                    isFetching: false,
                    promise: null,
                    fetchError: null,
                    hasFetchedOnce: true,
                    hasSuccessOnce: true
                }
            };
            // @ts-expect-error - TS2345 - Argument of type '{ workedOn: { items: { id: string | number; localResourceId: string; title: string; metadata: string; avatarUrl: string; url: string; attributes: { containerName: string | null | undefined; }; type: string; }[]; ... 4 more ...; hasSuccessOnce: boolean; }; }' is not assignable to parameter of type 'Partial<State>'.
            setState(responseState);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            const errorState = {
                workedOn: {
                    ...getState().workedOn,
                    isFetching: false,
                    promise: null,
                    fetchError: fetchError,
                    hasFetchedOnce: true
                }
            };
            setState(errorState);
        }
    };
const $c11b2121dbe8e38b$export$e324594224ef24da = {
    loadRecentAll: (amount)=>async (actions2, props)=>{
            $c11b2121dbe8e38b$var$loadRecentItems(amount, [
                props.applicationPermissions.hasSoftwareAccess ? (0, $49a076eb01652100$export$f95f1a684a17f189) : undefined,
                (0, $49a076eb01652100$export$6e58b6b0aa48a271),
                (0, $49a076eb01652100$export$91a9dba2d38d9a6f),
                (0, $49a076eb01652100$export$6737b9227f60f39d),
                props.applicationPermissions.hasServiceDeskAccess ? (0, $49a076eb01652100$export$20f1031cc9fdf29e) : undefined
            ].filter(Boolean))(actions2);
        },
    loadRecentAllSingleList: (amount)=>async (actions2, props)=>{
            $c11b2121dbe8e38b$var$loadRecentItemsSingleList(amount, [
                props.applicationPermissions.hasSoftwareAccess ? (0, $49a076eb01652100$export$f95f1a684a17f189) : undefined,
                (0, $49a076eb01652100$export$6e58b6b0aa48a271),
                (0, $49a076eb01652100$export$91a9dba2d38d9a6f),
                (0, $49a076eb01652100$export$6737b9227f60f39d),
                (0, $49a076eb01652100$export$ebb48b08205007c5),
                props.applicationPermissions.hasServiceDeskAccess ? (0, $49a076eb01652100$export$20f1031cc9fdf29e) : undefined
            ].filter(Boolean))(actions2);
        },
    loadWorkedOnAllSingleList: $c11b2121dbe8e38b$var$loadWorkedOnItems,
    loadRecentBoards: (amount)=>$c11b2121dbe8e38b$var$loadRecentItems(amount, [
            (0, $49a076eb01652100$export$f95f1a684a17f189)
        ]),
    loadRecentProjects: (amount)=>$c11b2121dbe8e38b$var$loadRecentItems(amount, [
            (0, $49a076eb01652100$export$91a9dba2d38d9a6f)
        ]),
    loadRecentDashboards: (amount)=>$c11b2121dbe8e38b$var$loadRecentItems(amount, [
            (0, $49a076eb01652100$export$6e58b6b0aa48a271)
        ]),
    loadRecentFilters: (amount)=>$c11b2121dbe8e38b$var$loadRecentItems(amount, [
            (0, $49a076eb01652100$export$6737b9227f60f39d)
        ]),
    loadRecentQueues: (amount)=>$c11b2121dbe8e38b$var$loadRecentItems(amount, [
            (0, $49a076eb01652100$export$20f1031cc9fdf29e)
        ])
};
const $c11b2121dbe8e38b$var$store = (0, $iXqE5.createStore)({
    name: (0, $e706d38cada11fb1$export$eb2b39783d051b9),
    actions: $c11b2121dbe8e38b$export$e324594224ef24da,
    initialState: $c11b2121dbe8e38b$export$d4c72bab9d6cc13a
});
const $c11b2121dbe8e38b$export$5c0647984dfa7d27 = (0, $3sQ5x.createHook)($c11b2121dbe8e38b$var$store, {
    selector: null
});
const $c11b2121dbe8e38b$export$9a54f46f5b7734c = (0, $3sQ5x.createHook)($c11b2121dbe8e38b$var$store, {
    selector: (state)=>state.all
});
const $c11b2121dbe8e38b$export$e8278a7bcff1ec98 = (0, $3sQ5x.createHook)($c11b2121dbe8e38b$var$store, {
    selector: (state)=>state.workedOn
});
const $c11b2121dbe8e38b$export$3731bd023be4f71 = (0, $3sQ5x.createHook)($c11b2121dbe8e38b$var$store, {
    selector: (state)=>state[0, $49a076eb01652100$export$f95f1a684a17f189]
});
const $c11b2121dbe8e38b$export$81cb5beef51d43ca = (0, $3sQ5x.createHook)($c11b2121dbe8e38b$var$store, {
    selector: (state)=>state[0, $49a076eb01652100$export$6e58b6b0aa48a271]
});
const $c11b2121dbe8e38b$export$f6b9a13c4ec08b45 = (0, $3sQ5x.createHook)($c11b2121dbe8e38b$var$store, {
    selector: (state)=>state[0, $49a076eb01652100$export$91a9dba2d38d9a6f]
});
const $c11b2121dbe8e38b$export$8d2bfb6d3657bae2 = (0, $3sQ5x.createHook)($c11b2121dbe8e38b$var$store, {
    selector: (state)=>state[0, $49a076eb01652100$export$6737b9227f60f39d]
});
const $c11b2121dbe8e38b$export$8756abb0bb90a56e = (0, $3sQ5x.createHook)($c11b2121dbe8e38b$var$store, {
    selector: (state)=>state[0, $49a076eb01652100$export$20f1031cc9fdf29e]
});
const $c11b2121dbe8e38b$export$5de14a1c1400859e = (0, $gg7kZ.createContainer)($c11b2121dbe8e38b$var$store);

});
parcelRegister("165Uv", function(module, exports) {

$parcel$export(module.exports, "fetchRecentItems", () => $892c454fe92da960$export$20d49db97b653a7b);
$parcel$export(module.exports, "fetchRecentItemsSingleList", () => $892c454fe92da960$export$a00963dad78984b8);
$parcel$export(module.exports, "fetchWorkedOnItems", () => $892c454fe92da960$export$f3763cb0ecc90572);

var $ebyGx = parcelRequire("ebyGx");


var $5HnTq = parcelRequire("5HnTq");

var $fPruT = parcelRequire("fPruT");

const $892c454fe92da960$var$PATH_BUCKETED = '/rest/internal/2/productsearch/search';
const $892c454fe92da960$var$PATH_SINGLE_LIST = '/rest/internal/2/productsearch/singleRecentList';
// dummy handle error
const $892c454fe92da960$var$handleError = (error)=>{
    throw error;
};
const $892c454fe92da960$var$toQuery = ({ counts: counts })=>// @ts-expect-error - TS2769 - No overload matches this call.
    Object.keys(counts) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((result, itemType)=>{
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<ItemType, number>>'.
        result.push(`${itemType}=${counts[itemType]}`);
        return result;
    }, []).join(',');
const $892c454fe92da960$export$20d49db97b653a7b = async ({ counts: counts })=>{
    const url = `${$892c454fe92da960$var$PATH_BUCKETED}?${(0, $ebyGx.stringify)({
        counts: $892c454fe92da960$var$toQuery({
            counts: counts
        }),
        type: Object.keys(counts).join(',')
    })}`;
    try {
        const response = await fetch(url, (0, $5HnTq.getDefaultOptions)(url));
        const { status: status } = response;
        if (!response.ok) {
            if (status === (0, $3cd8a0ece36fbae5$export$67d19e9a991baa07)) return $892c454fe92da960$var$handleError(new (0, $fPruT.AuthenticationError)(`${status}`));
            // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string | undefined'.
            return $892c454fe92da960$var$handleError(new Error(status));
        }
        if (status === (0, $3cd8a0ece36fbae5$export$3288b14b6745c572)) return null;
        return response.json();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $892c454fe92da960$var$handleError(error);
    }
};
const $892c454fe92da960$export$a00963dad78984b8 = async ({ types: types, limit: limit })=>{
    const url = $892c454fe92da960$var$PATH_SINGLE_LIST;
    try {
        const response = await fetch(url, {
            ...(0, $5HnTq.getDefaultOptions)(url),
            method: 'POST',
            body: JSON.stringify({
                groups: [
                    {
                        types: types,
                        limit: limit
                    }
                ]
            })
        });
        const { status: status } = response;
        if (!response.ok) {
            if (status === (0, $3cd8a0ece36fbae5$export$67d19e9a991baa07)) return $892c454fe92da960$var$handleError(new (0, $fPruT.AuthenticationError)(`${status}`));
            // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string | undefined'.
            return $892c454fe92da960$var$handleError(new Error(status));
        }
        if (status === (0, $3cd8a0ece36fbae5$export$3288b14b6745c572)) return null;
        return response.json();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $892c454fe92da960$var$handleError(error);
    }
};
const $892c454fe92da960$export$f3763cb0ecc90572 = async ({ cloudId: cloudId, amount: amount })=>{
    try {
        const response = await fetch('/gateway/api/graphql', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                operationName: 'jira_NavigationActivity',
                query: (0, $ec61554fda4e6d64$export$2b91517d6d5b4365),
                variables: {
                    first: amount,
                    cloudID: cloudId
                }
            })
        });
        const { status: status } = response;
        if (!response.ok) {
            if (status === (0, $3cd8a0ece36fbae5$export$67d19e9a991baa07)) return $892c454fe92da960$var$handleError(new (0, $fPruT.AuthenticationError)(`${status}`));
            // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string | undefined'.
            return $892c454fe92da960$var$handleError(new Error(status));
        }
        return response.json();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $892c454fe92da960$var$handleError(error);
    }
};

});
const $ec61554fda4e6d64$export$2b91517d6d5b4365 = `
fragment NavigationActivityItem on ActivitiesItem {
  id
  timestamp
  object {
    id
    name
    localResourceId
    type
    url
    iconUrl
    containers {
      name
      type
    }
    extension {
      ... on ActivitiesJiraIssue {
        issueKey
      }
    }
  }
}

query jira_NavigationActivity($first: Int, $cloudID: ID!) {
  activities {
    myActivities {
      workedOn(
        first: $first,
        filters: [
          {
            type: AND,
            arguments: {
              cloudIds: [$cloudID],
              products: [JIRA, JIRA_BUSINESS, JIRA_SOFTWARE, JIRA_OPS, JIRA_SERVICE_DESK]
            }
          }
        ]
      ) {
        nodes {
          ...NavigationActivityItem
        }
      }
    }
  }
}

`;


const $e706d38cada11fb1$export$eb2b39783d051b9 = 'navigation-recents-store';
const $e706d38cada11fb1$export$22ea57e66775a6b2 = 5;
const $e706d38cada11fb1$export$8666f31c8873bff = 10;
const $e706d38cada11fb1$export$5f1b6c5e9d257e5e = 20;


parcelRegister("l0cYe", function(module, exports) {

$parcel$export(module.exports, "NavigationSuccessTrackerForNav3", () => $35aca48cac64f980$export$9013eebe7301dfe1);

var $5uXOq = parcelRequire("5uXOq");

var $g0Gtc = parcelRequire("g0Gtc");

var $3bQtK = parcelRequire("3bQtK");

var $7XYc4 = parcelRequire("7XYc4");

var $8CVvd = parcelRequire("8CVvd");

var $6jY6G = parcelRequire("6jY6G");

var $Mp6qH = parcelRequire("Mp6qH");
const $35aca48cac64f980$var$EmptyFragment = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
const $35aca48cac64f980$var$NavigationSuccessTracker = ({ children: children })=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const ViewExperienceSuccessTrackerComponent = route.isRedirect === true ? $35aca48cac64f980$var$EmptyFragment : (0, $g0Gtc.ExperienceSuccessTracker);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ViewExperienceSuccessTrackerComponent, {
        location: "atlassian-navigation-main",
        parentProviders: null,
        failureEventAttributes: null
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bQtK.ExperienceSuccess), {
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MAIN)
    }));
};
const $35aca48cac64f980$export$9013eebe7301dfe1 = (0, $7XYc4.componentWithCondition)((0, $8CVvd.getWillShowNav3), $35aca48cac64f980$var$NavigationSuccessTracker, (0, $5uXOq.Fragment));

});

parcelRegister("bWmoi", function(module, exports) {

$parcel$export(module.exports, "TopNav3Async", () => $ab2ac48f46df03ff$export$1aaa7ad7dec6338c);

var $fDtbf = parcelRequire("fDtbf");

var $2SVPM = parcelRequire("2SVPM");

var $kxZPA = parcelRequire("kxZPA");

const $ab2ac48f46df03ff$export$1aaa7ad7dec6338c = (0, $kxZPA.lazyForPaint)(()=>{
    const bundleReady = (parcelRequire("cDmx3")).then(({ TopNav3Sync: TopNav3Sync })=>TopNav3Sync);
    if (!false) bundleReady.then(()=>{
        (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.bundle-ready', 'jira-spa.js:eval-stop');
        const resources = performance.getEntriesByType('mark');
        for(let i = resources.length - 1; i >= 0; i -= 1)if ((resources[i].name.startsWith('async-navigation') || resources[i].name.startsWith('async-atlassian-navigation')) && resources[i].name.endsWith((0, $fDtbf.JS_EVAL_START))) {
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.eval', resources[i].name);
            break;
        }
    });
    return bundleReady;
}, {
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/top-nav/TopNav3Sync.tsx"
});

});
parcelRegister("cDmx3", function(module, exports) {

let $932a9af1d81e8845$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $932a9af1d81e8845$var$load("7mIf9"),
    $932a9af1d81e8845$var$load("jXweD"),
    $932a9af1d81e8845$var$load("76n7a"),
    $932a9af1d81e8845$var$load("l253H"),
    $932a9af1d81e8845$var$load("kNFvF"),
    $932a9af1d81e8845$var$load("ffQaD"),
    $932a9af1d81e8845$var$load("kvRbA"),
    $932a9af1d81e8845$var$load("igeJx")
]).then(()=>parcelRequire('j6nm6'));

});


parcelRegister("jUhOq", function(module, exports) {

$parcel$export(module.exports, "ConversationAssistant", () => $a6baf802cdb95631$export$9777b121d71c4de1);

var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");

var $5i4cN = parcelRequire("5i4cN");

var $h4rOi = parcelRequire("h4rOi");

var $4QAPb = parcelRequire("4QAPb");

var $hlVrS = parcelRequire("hlVrS");


var $7XYc4 = parcelRequire("7XYc4");

var $hsmeR = parcelRequire("hsmeR");

var $2Ui4E = parcelRequire("2Ui4E");

var $3HwlS = parcelRequire("3HwlS");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $kkNtb = parcelRequire("kkNtb");

var $koeKL = parcelRequire("koeKL");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");
const $a6baf802cdb95631$var$AssistantButton = (0, $7XYc4.componentWithCondition)(()=>(0, $3HwlS.getWillShowNav4)(), (0, $hlVrS.ConversationAssistantButtonNav4), (0, $hlVrS.ConversationAssistantButton));
const $a6baf802cdb95631$var$ConversationAssistantButton = ()=>{
    const [_topMenusValue, { off: closeAllMenus }] = (0, $2Ui4E.useTopMenus)();
    const { openRightSidebar: openRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const { panelId: panelId, isCollapsed: isCollapsed } = (0, $hsmeR.useActiveRightSidebarState)() || {};
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const cloudId = (0, $koeKL.useCloudId)();
    const isActive = panelId === (0, $1cb976721581e2e6$export$dffb4ed44e20ea9a) && !isCollapsed;
    const onButtonClickOld = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        }), 'aiMate', {
            opened: isCollapsed,
            isActive: isActive
        });
        if (isActive) closeCurrentRightSidebar();
        else openRightSidebar((0, $1cb976721581e2e6$export$dffb4ed44e20ea9a), (0, $1cb976721581e2e6$export$64aee74ba59709e5), false, true);
        closeAllMenus();
    }, [
        closeAllMenus,
        closeCurrentRightSidebar,
        createAnalyticsEvent,
        isActive,
        isCollapsed,
        openRightSidebar
    ]);
    const onButtonClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        }), 'aiMate', {
            opened: !isActive,
            isActive: isActive
        });
        isActive ? closeCurrentRightSidebar() : openRightSidebar((0, $1cb976721581e2e6$export$dffb4ed44e20ea9a), (0, $1cb976721581e2e6$export$64aee74ba59709e5), false, true);
        closeAllMenus();
    }, [
        isActive,
        closeAllMenus,
        closeCurrentRightSidebar,
        openRightSidebar,
        createAnalyticsEvent
    ]);
    const buttonRender = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        as: "span",
        paddingInlineStart: (0, $3HwlS.getWillShowNav4)() ? undefined : 'space.050',
        testId: "atlassian-navigation.ui.conversation-assistant.app-navigation-ai-mate",
        role: // This element is a direct descendant of the top nav actions list, so needs the listitem role.
        // While the button is internally wrapped in a listitem, screen readers do not pick this up due to multiple wrapper elements.
        (0, $3HwlS.getWillShowNav4)() ? 'listitem' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a6baf802cdb95631$var$AssistantButton, {
        onClick: (0, $3HwlS.getWillShowNav4)() ? onButtonClick : onButtonClickOld,
        isActive: isActive,
        siteId: cloudId,
        productKey: "jira"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, buttonRender, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4QAPb.ChatContextSubscriber), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5i4cN.ChatOpenerSubscriber), {
        onTriggerOpeningChat: ()=>{
            if (!isActive) openRightSidebar((0, $1cb976721581e2e6$export$dffb4ed44e20ea9a), (0, $1cb976721581e2e6$export$64aee74ba59709e5), false, true);
        }
    }));
};
const $a6baf802cdb95631$export$9777b121d71c4de1 = ()=>{
    const { data: data } = (0, $kkNtb.useRovoEntitlementResource)();
    const shouldShowConversationAssistantButton = data?.isRovoLLMEnabled ?? false;
    const buttonRender = shouldShowConversationAssistantButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a6baf802cdb95631$var$ConversationAssistantButton, null) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $Mp6qH.NAVIGATION_ITEM_ID).CONVERSATION_ASSISTANT
    }, buttonRender, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h4rOi.RovoEntitlementSetter), {
        isRovoEnabled: shouldShowConversationAssistantButton
    }));
};

});
parcelRegister("4uXxK", function(module, exports) {

$parcel$export(module.exports, "TopLevelErrorBoundary", () => $7f8668208bdb1964$export$b70f1d8bd509b358);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $Mp6qH = parcelRequire("Mp6qH");
const $7f8668208bdb1964$export$b70f1d8bd509b358 = ({ id: id, children: children })=>{
    const EVENT_DATA = (0, $5uXOq.useMemo)(()=>({
            id: id
        }), [
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: `${(0, $Mp6qH.TOP_LEVEL_ERROR_BOUNDARY_ID)}.${id}`,
        packageName: (0, $Mp6qH.PACKAGE_NAME),
        extraEventData: EVENT_DATA,
        fallback: "unmount"
    }, children);
};

});


parcelRegister("96WTB", function(module, exports) {

$parcel$export(module.exports, "Create", () => $c8d9a30d843c92d0$export$8ade6fcbf3a7de5d);

var $5uXOq = parcelRequire("5uXOq");

var $2YZCu = parcelRequire("2YZCu");

var $7kxNZ = parcelRequire("7kxNZ");

var $jp0tf = parcelRequire("jp0tf");


var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $9YT0J = parcelRequire("9YT0J");

var $c0dQj = parcelRequire("c0dQj");

var $6cNb0 = parcelRequire("6cNb0");

var $hULKg = parcelRequire("hULKg");

var $5rzqz = parcelRequire("5rzqz");

var $f5nIZ = parcelRequire("f5nIZ");

var $kxEY7 = parcelRequire("kxEY7");

var $cZpsT = parcelRequire("cZpsT");

var $2YP9W = parcelRequire("2YP9W");

var $Mp6qH = parcelRequire("Mp6qH");

var $3S5gG = parcelRequire("3S5gG");

var $4uXxK = parcelRequire("4uXxK");

var $iPj86 = parcelRequire("iPj86");

var $ktmuI = parcelRequire("ktmuI");

var $8fSk0 = parcelRequire("8fSk0");

var $twalS = parcelRequire("twalS");
const $c8d9a30d843c92d0$var$noop = ()=>undefined;
const $c8d9a30d843c92d0$var$Create = ({ AkCreate: AkCreate = (0, $3S5gG.Create), NudgeTooltip: NudgeTooltip = (0, $kxEY7.NavigationCreateIssueButtonWrapperNudgeAsync), onCreateClick: onCreateClick = (0, $jp0tf.default), useNavigationItemAnalytics: useNavigationItemAnalytics = (0, $iPj86.useNavigationItemAnalytics), useIsInitialLoadLegacyIssueCreate: // @ts-expect-error - TS2339 - Property 'useIsInitialLoadLegacyIssueCreate' does not exist on type 'CreateProps'.
useIsInitialLoadLegacyIssueCreate = (0, $7kxNZ.useIsInitialLoadLegacyIssueCreate) })=>{
    const testId = (0, $6cNb0.testIdGenerate)('create');
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $5rzqz.useTriggerIssueCreateModal)();
    (0, $9YT0J.useInitializePersistentIssueCreateModalView)();
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).CREATE
    });
    const [{ isInitialLoad: isInitialLoad }, actions] = useIsInitialLoadLegacyIssueCreate();
    let currentIssueCreateVisibility = null;
    const gicOptInStateOverridden = (0, $5uXOq.useRef)(false);
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const isMobileExperienceEnabled = (0, $c0dQj.isMobileAndInMvpOrExistingUsersExperiment)();
    if ((0, $4R6GH.fg)('render_modern_global_issue_create_modal_experience')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { data: data, update: update } = (0, $2YP9W.useResource)((0, $f5nIZ.gicOptInStatusResources));
        if (isAnonymous && !gicOptInStateOverridden.current) {
            update(()=>({
                    gicOptInStatus: {
                        isEnabled: true
                    }
                }));
            gicOptInStateOverridden.current = true;
        }
        currentIssueCreateVisibility = data && data?.gicOptInStatus;
    }
    const onClick = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
    (e)=>{
        if ((0, $4R6GH.fg)('render_modern_global_issue_create_modal_experience')) {
            if (currentIssueCreateVisibility !== null) {
                if (currentIssueCreateVisibility.isEnabled) {
                    (0, $ktmuI.GlobalIssueCreateFromTopNav).abort({
                        force: true
                    });
                    (0, $ktmuI.GlobalIssueCreateFromTopNav).start();
                    (0, $ktmuI.GlobalIssueCreateFromTopNav).addMetadata({
                        inputDelay: Math.round(performance.now() - e.timeStamp)
                    });
                    const nextState = {
                        disableCreationSuccessFlag: (0, $twalS.shouldDisableGICFlagCreation)(),
                        triggerPointKey: (0, $hULKg.GENERIC_GLOBAL_CREATE_BUTTON),
                        ...isMobileExperienceEnabled ? {
                            displayMinimizableButtons: false,
                            displayCreateAnotherIssueToggle: false,
                            triggerPointKey: (0, $hULKg.MOBILE_GLOBAL_CREATE_BUTTON)
                        } : {}
                    };
                    openIssueCreateModal(nextState);
                } else {
                    onCreateClick({
                        isInitialLoad: isInitialLoad,
                        triggerSource: (0, $de7681b8672bb382$export$d983e94cf86f65d)
                    });
                    if (isInitialLoad) actions.clearInitialLoaded();
                }
            } else (0, $2YZCu.default).safeErrorWithoutCustomerData('global-issue-create', 'visibility data is still getting downloaded');
        } else {
            onCreateClick({
                isInitialLoad: isInitialLoad,
                triggerSource: (0, $de7681b8672bb382$export$d983e94cf86f65d)
            });
            if (isInitialLoad) actions.clearInitialLoaded();
        }
        triggerAnalytics();
    }, [
        actions,
        currentIssueCreateVisibility,
        isInitialLoad,
        isMobileExperienceEnabled,
        onCreateClick,
        openIssueCreateModal,
        triggerAnalytics
    ]);
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(NudgeTooltip, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AkCreate, {
        onClick: onClick,
        text: formatMessage((0, $8fSk0.default).create),
        testId: testId,
        label: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $8fSk0.default).createButtonAriaLabelIssueTermRefresh : (0, $8fSk0.default).createButtonAriaLabel)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AkCreate, {
        onClick: $c8d9a30d843c92d0$var$noop,
        text: formatMessage((0, $8fSk0.default).create),
        testId: testId,
        label: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $8fSk0.default).createButtonAriaLabelIssueTermRefresh : (0, $8fSk0.default).createButtonAriaLabel)
    });
};
const $c8d9a30d843c92d0$export$8ade6fcbf3a7de5d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $Mp6qH.NAVIGATION_ITEM_ID).CREATE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c8d9a30d843c92d0$var$Create, props));

});
parcelRegister("9YT0J", function(module, exports) {

$parcel$export(module.exports, "useInitializePersistentIssueCreateModalView", () => $d36676d86816c70e$export$9086117e14a55509);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $c0dQj = parcelRequire("c0dQj");

var $5rzqz = parcelRequire("5rzqz");

var $dAfqg = parcelRequire("dAfqg");

var $cn7wb = parcelRequire("cn7wb");
const $d36676d86816c70e$export$9086117e14a55509 = ()=>{
    const [{ shouldShowMiniModalSpotlight: shouldShowMiniModalSpotlight }, { setShouldPushMiniModalDiscoverability: setShouldPushMiniModalDiscoverability, setPersistentModalView: setPersistentModalView }] = (0, $5rzqz.useTriggerIssueCreateModal)();
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const hasUserSeenMiniModal = (0, $5uXOq.useRef)(false);
    const isJSM = projectContext?.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);
    const { data: resource } = (0, $cn7wb.usePersistentIssueCreateModalViewResource)();
    const isMobileExperienceEnabled = (0, $c0dQj.isMobileAndInMvpOrExistingUsersExperiment)();
    /**
	 * It only handles the initialization part as after the modal is opened the persistentModalView
	 * would be handled by the `actions` of `useTriggerIssueCreateModal`.
	 */ (0, $5uXOq.useEffect)(()=>{
        setPersistentModalView(resource?.view || 'modal');
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
	 * JSM has opted out so we update the `shouldPushMiniModalDiscoverability` on every project change
	 * until the discoverability push has been done, meaning that the user has seen the mini modal being
	 * shown as the default modal.
	 *
	 * Mobile is also opting out of having any mini modal discoverability and not interacting with any of the discoverability state
	 * for if the user returns to desktop.
	 *
	 * If the user has seen the mini modal from discoverability push (hasUserSeenMiniModal) or
	 * dismiss its nudge (isDiscoPushComplete), shouldPushMiniModalDiscoverability should never be true again.
	 */ (0, $5uXOq.useEffect)(()=>{
        if (resource?.isDiscoPushComplete || hasUserSeenMiniModal.current) setShouldPushMiniModalDiscoverability(false);
        else setShouldPushMiniModalDiscoverability(!isJSM && !isMobileExperienceEnabled);
    }, [
        resource?.isDiscoPushComplete,
        setShouldPushMiniModalDiscoverability,
        isJSM,
        isMobileExperienceEnabled
    ]);
    /**
	 * `shouldShowMiniModalSpotlight` can be used to determine if user has seen the mini modal
	 * as it is only set `onModalOpen`, which means, if it is true, the modal is opened with mini view
	 * and the user will see it.
	 */ (0, $5uXOq.useEffect)(()=>{
        if (shouldShowMiniModalSpotlight && !hasUserSeenMiniModal.current) hasUserSeenMiniModal.current = true;
    }, [
        shouldShowMiniModalSpotlight
    ]);
    return null;
};

});
parcelRegister("cn7wb", function(module, exports) {

$parcel$export(module.exports, "usePersistentIssueCreateModalViewResource", () => $c55164aa1e8f5a83$export$20dbed3226e737bc);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $aHuqL = parcelRequire("aHuqL");

var $2YP9W = parcelRequire("2YP9W");


var $3X1Xr = parcelRequire("3X1Xr");
const $c55164aa1e8f5a83$export$20dbed3226e737bc = ()=>{
    const { data: data, update: update } = (0, $2YP9W.useResource)((0, $3X1Xr.persistentIssueCreateModalViewResource));
    const updateView = (0, $5uXOq.useCallback)(async (view)=>{
        try {
            await (0, $aHuqL.userPreferenceAPI).set((0, $fa76c7a777da2375$export$15187a597cef02df), view);
            update((state)=>({
                    ...state,
                    view: view
                }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'persistentIssueCreateModalViewState',
                    packageName: 'jiraRouterResourcesPersistentIssueCreateModalView',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        update
    ]);
    const updateIsDiscoPushComplete = (0, $5uXOq.useCallback)(async (isDiscoPushComplete = true)=>{
        try {
            await (0, $aHuqL.userPreferenceAPI).set((0, $fa76c7a777da2375$export$8977f91a75d8d265), isDiscoPushComplete);
            update((state)=>({
                    ...state,
                    isDiscoPushComplete: isDiscoPushComplete
                }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'miniModalDiscoverabilityPushState',
                    packageName: 'jiraRouterResourcesPersistentIssueCreateModalView',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        update
    ]);
    return {
        data: data,
        updateView: updateView,
        updateIsDiscoPushComplete: updateIsDiscoPushComplete
    };
};

});


parcelRegister("kxEY7", function(module, exports) {

$parcel$export(module.exports, "NavigationCreateIssueButtonWrapperNudgeAsync", () => $6b9c90b8c1e1a472$export$fc0840474cb1fce9);

var $5uXOq = parcelRequire("5uXOq");


var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $dsvCp = parcelRequire("dsvCp");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6b9c90b8c1e1a472$var$NavigationCreateIssueButtonLazy = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("k3Cbo")).then((exportedModule)=>exportedModule.NavigationCreateIssueButtonWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/navigation-create-issue/index.tsx"
});
const $6b9c90b8c1e1a472$export$fc0840474cb1fce9 = ({ children: children })=>{
    const shouldShowNudge = (0, $dsvCp.useCanShowQuickstartNudge)();
    if (!shouldShowNudge) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $6784cbc7d62e5d7c$export$aba87e019f5ccb8d),
        fallback: children,
        attributes: {
            nudgeId: (0, $6784cbc7d62e5d7c$export$aba87e019f5ccb8d)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-onboarding-navigation-create-issue-nudge",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6b9c90b8c1e1a472$var$NavigationCreateIssueButtonLazy, {
        nudgeId: (0, $6784cbc7d62e5d7c$export$aba87e019f5ccb8d)
    }, children)));
};

});
parcelRegister("dsvCp", function(module, exports) {

$parcel$export(module.exports, "useCanShowQuickstartNudge", () => $6331d14932d8e8e2$export$b687eb4905cdc15a);

var $heI7y = parcelRequire("heI7y");
const $6331d14932d8e8e2$export$b687eb4905cdc15a = ()=>{
    const [{ hasOpened: hasOpened }] = (0, $heI7y.useHasOpened)();
    return hasOpened;
};

});

parcelRegister("k3Cbo", function(module, exports) {

let $e9a1b4bf6ac6d222$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e9a1b4bf6ac6d222$var$load("e6Ahe").then(()=>parcelRequire('9NAtJ'));

});


parcelRegister("3S5gG", function(module, exports) {

$parcel$export(module.exports, "Create", () => $321e94af7b02d9cb$export$8ade6fcbf3a7de5d);

var $5uXOq = parcelRequire("5uXOq");

var $g6jiF = parcelRequire("g6jiF");

var $83yN3 = parcelRequire("83yN3");

var $eCeGD = parcelRequire("eCeGD");

var $dZbEw = parcelRequire("dZbEw");

var $MHKc7 = parcelRequire("MHKc7");

var $45tDR = parcelRequire("45tDR");

var $4R6GH = parcelRequire("4R6GH");

var $kvHKs = parcelRequire("kvHKs");

var $2gP8z = parcelRequire("2gP8z");

var $3HwlS = parcelRequire("3HwlS");
// This id is required to ensure pollinator tests work between Nav3 and Nav4
const $321e94af7b02d9cb$var$TEST_ID_NAV_4 = 'atlassian-navigation--create-button';
const $321e94af7b02d9cb$export$8ade6fcbf3a7de5d = (props)=>{
    if (false) {
        if ((0, $3HwlS.getWillShowNav4)()) {
            if ((0, $4R6GH.fg)('jira_nav4_beta_drop_2')) // TODO: when cleaning up we can probably remove the Nav 4 server branch
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $45tDR.CreateButton), {
                testId: $321e94af7b02d9cb$var$TEST_ID_NAV_4
            }, props.text);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
                appearance: "primary",
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))),
                testId: props.testId
            }, props.text);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $83yN3.SkeletonCreateButton), {
            text: props.text,
            testId: props.testId
        });
    }
    if ((0, $3HwlS.getWillShowNav4)()) {
        const { onClick: onClick, text: text } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2gP8z.SpotlightTarget), {
            name: (0, $kvHKs.GLOBAL_NAV_CREATE_BUTTON_SPOTLIGHT_ID)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $45tDR.CreateButton), {
            onClick: onClick,
            testId: $321e94af7b02d9cb$var$TEST_ID_NAV_4
        }, text)));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g6jiF.Create), props);
};

});
parcelRegister("2gP8z", function(module, exports) {

$parcel$export(module.exports, "SpotlightTarget", () => $bac5b90628bba66f$export$e29577842f211e22);

var $5uXOq = parcelRequire("5uXOq");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $axUP7 = parcelRequire("axUP7");
const $bac5b90628bba66f$var$SpotlightTargetWrapper = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-test-id": `ak-spotlight-target-${props.name}`
    }, children));
const $bac5b90628bba66f$export$e29577842f211e22 = (0, $axUP7.withNestingOptimisation)($bac5b90628bba66f$var$SpotlightTargetWrapper);

});


parcelRegister("iPj86", function(module, exports) {

$parcel$export(module.exports, "useNavigationItemAnalytics", () => $e639936782444614$export$444d136efe970fd3);

var $5uXOq = parcelRequire("5uXOq");

var $2bzBV = parcelRequire("2bzBV");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $e639936782444614$export$444d136efe970fd3 = ({ navigationItemId: navigationItemId })=>{
    const { isVisible: isVisible } = (0, $2bzBV.useOverflowStatus)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)((attributes = {})=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, navigationItemId, {
            // @ts-expect-error - TS2698 - Spread types may only be created from object types.
            ...attributes,
            isInMore: !isVisible,
            navigationLayer: 'global'
        });
    }, [
        createAnalyticsEvent,
        isVisible,
        navigationItemId
    ]);
};

});

parcelRegister("ktmuI", function(module, exports) {

$parcel$export(module.exports, "GlobalIssueCreateFromTopNav", () => $903a8c36bcdb4b23$export$177dc7755a3f80f2);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
var $gjd6t = parcelRequire("gjd6t");
const $903a8c36bcdb4b23$export$177dc7755a3f80f2 = new (0, $duUGa.UFOExperience)('global-issue-create-from-top-nav', {
    type: (0, $atdLB.ExperienceTypes).Operation,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
    until: (0, $gjd6t.untilAll)([
        {
            category: 'global-issue-create.create-issue'
        }
    ])
});
const $903a8c36bcdb4b23$export$2b83859c1548ffb5 = new (0, $duUGa.UFOExperience)('projects-menu-dropdown.recommendation-selector', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult
});
const $903a8c36bcdb4b23$export$a784c5bbb21ea554 = new (0, $duUGa.UFOExperience)('projects-menu-dropdown.load-jpd-recommendation', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("8fSk0", function(module, exports) {

$parcel$export(module.exports, "default", () => $d702f6d77050354f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d702f6d77050354f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    create: {
        "id": "atlassian-navigation.create.create",
        "defaultMessage": "Create"
    },
    createButtonAriaLabel: {
        "id": "atlassian-navigation.create.create-button-aria-label",
        "defaultMessage": "Create issue"
    },
    createButtonAriaLabelIssueTermRefresh: {
        "id": "atlassian-navigation.create.create-button-aria-label-issue-term-refresh",
        "defaultMessage": "Create"
    }
});

});

parcelRegister("twalS", function(module, exports) {

$parcel$export(module.exports, "shouldDisableGICFlagCreation", () => $ea9b0b430c82f5e1$export$fc4d210bb6a1528a);

var $gKZoD = parcelRequire("gKZoD");

var $Mp6qH = parcelRequire("Mp6qH");
const $ea9b0b430c82f5e1$export$fc4d210bb6a1528a = ()=>{
    (0, $gKZoD.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return (0, $Mp6qH.JSW_TMP_BACKLOG_BOARD_REGEXP).test(window.location.pathname);
};

});


parcelRegister("crC7i", function(module, exports) {

$parcel$export(module.exports, "Help", () => $2e020bcbc529c0ab$export$1be7516c0280bee8);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");


const $2e020bcbc529c0ab$var$HelpComponent = (parcelRequire("edq0W")).default;
const $2e020bcbc529c0ab$var$MemoizedHelpWithErrorBoundary = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $Mp6qH.NAVIGATION_ITEM_ID).HELP
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2e020bcbc529c0ab$var$HelpComponent, null)));
const $2e020bcbc529c0ab$var$HelpWithErrorBoundaryOld = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $Mp6qH.NAVIGATION_ITEM_ID).HELP
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2e020bcbc529c0ab$var$HelpComponent, null));
const $2e020bcbc529c0ab$export$1be7516c0280bee8 = (0, $cSD7y.componentWithFG)('nav_help_icon_vc90_top_offender_improvements', $2e020bcbc529c0ab$var$MemoizedHelpWithErrorBoundary, $2e020bcbc529c0ab$var$HelpWithErrorBoundaryOld);

});
parcelRegister("edq0W", function(module, exports) {

module.exports = (parcelRequire("avM1e"))('nav_help_icon_vc90_top_offender_improvements', function() {
    return parcelRequire('2uWC5');
}, function() {
    return parcelRequire('i5dTd');
});

});


parcelRegister("MBTxm", function(module, exports) {

$parcel$export(module.exports, "InitialDataLoader", () => $0c63bc4f7fc4fb59$export$867ec025b81eadf3);

var $5uXOq = parcelRequire("5uXOq");

var $kJH82 = parcelRequire("kJH82");


var $bcn6L = parcelRequire("bcn6L");

var $eKYL7 = parcelRequire("eKYL7");

var $7uSIc = parcelRequire("7uSIc");

var $d40Fj = parcelRequire("d40Fj");

var $apeap = parcelRequire("apeap");

var $lsa9q = parcelRequire("lsa9q");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");

var $cZpsT = parcelRequire("cZpsT");
const $0c63bc4f7fc4fb59$export$867ec025b81eadf3 = ()=>{
    const [, { loadRecentAll: loadRecentAll }] = (0, $apeap.useRecentActions)();
    const [, { loadFavoriteAll: loadFavoriteAll }] = (0, $bcn6L.useFavoriteActions)();
    const [, { fetchCreateProjectPermission: fetchCreateProjectPermission }] = (0, $d40Fj.useCreateProjectPermissionActions)();
    const [, { load: loadForgeGlobalItem }] = (0, $eKYL7.useForgeGlobalItems)();
    const [, { load: loadForgePersonalSettingsItem }] = (0, $7uSIc.useForgePersonalSettingsItems)();
    const [, { load: loadAddons }] = (0, $kJH82.useAddon)();
    const hasFetchedAll = (0, $5uXOq.useRef)(false);
    const [{ hasLoaded: hasLoaded }] = (0, $lsa9q.default)();
    const [hasTimedOut, setHasTimedOut] = (0, $5uXOq.useState)(false);
    const accountId = (0, $90yGq.useAccountId)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const cloudId = (0, $koeKL.useCloudId)();
    (0, $5uXOq.useEffect)(()=>{
        if ((hasLoaded || hasTimedOut) && !hasFetchedAll.current) {
            loadRecentAll();
            loadFavoriteAll((0, $7a1562bd0ca086b0$export$ea341e6cc435ed40));
            loadForgeGlobalItem({
                cloudId: cloudId,
                isAnonymous: isAnonymous
            });
            loadForgePersonalSettingsItem({
                cloudId: cloudId,
                isAnonymous: isAnonymous
            });
            fetchCreateProjectPermission();
            loadAddons();
            hasFetchedAll.current = true;
        }
    }, [
        hasLoaded,
        hasTimedOut,
        hasFetchedAll,
        loadRecentAll,
        loadFavoriteAll,
        fetchCreateProjectPermission,
        loadForgeGlobalItem,
        loadForgePersonalSettingsItem,
        loadAddons,
        accountId,
        cloudId,
        isAnonymous
    ]);
    // given not all pages use SpaStateReady yet, we fallback to timeout
    // so we preload nav items anyway after some time
    (0, $5uXOq.useEffect)(()=>{
        let t;
        if (!hasLoaded) t = setTimeout(()=>setHasTimedOut(true), 10000);
        return ()=>clearTimeout(t);
    }, [
        hasLoaded,
        setHasTimedOut
    ]);
    return null;
};

});
parcelRegister("kJH82", function(module, exports) {

$parcel$export(module.exports, "useAddon", () => $0672771da90f2be9$export$550c6d89b9b85724);

var $6Rmr1 = parcelRequire("6Rmr1");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
const $0672771da90f2be9$var$handleFetch = ()=>async ({ setState: setState, getState: getState })=>{
        const { fetchAddons: fetchAddons, fetchAddonContext: fetchAddonContext, isFetching: isFetching } = getState();
        if (!isFetching) try {
            const promise = fetchAddons(fetchAddonContext);
            setState({
                isFetching: true,
                fetchError: null,
                promise: promise
            });
            const items = await promise;
            setState({
                items: items,
                hasFetchedOnce: true,
                hasSuccessOnce: true,
                isFetching: false,
                fetchError: null,
                promise: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            setState({
                ...getState(),
                fetchError: fetchError,
                hasFetchedOnce: true,
                isFetching: false,
                promise: null
            });
        }
    };
const $0672771da90f2be9$var$actions = {
    load: ()=>async ({ dispatch: dispatch })=>{
            const promise = dispatch($0672771da90f2be9$var$handleFetch());
            await promise;
        },
    setFavourite: (item, isAddon)=>async ({ setState: setState, getState: getState })=>{
            const { items: items, addToFavorite: addToFavorite, removeFromFavorite: removeFromFavorite } = getState();
            const newItemData = {
                ...item,
                favourite: true
            };
            if (isAddon) {
                setState({
                    items: [
                        newItemData,
                        ...items
                    ]
                });
                await addToFavorite(newItemData);
            } else {
                setState({
                    items: items.filter((theItem)=>theItem.id !== item.id)
                });
                await removeFromFavorite(item);
            }
        },
    setContext: (context)=>({ setState: setState })=>{
            setState({
                fetchAddonContext: context
            });
        }
};
const $0672771da90f2be9$export$f350d6bef9972cd3 = (defaults)=>{
    const initialState = {
        fetchAddons: defaults.fetchAddons,
        fetchAddonContext: {},
        addToFavorite: defaults.addToFavorite,
        removeFromFavorite: defaults.removeFromFavorite,
        hasFetchedOnce: false,
        hasSuccessOnce: false,
        items: [],
        fetchError: null,
        promise: null,
        isFetching: false
    };
    const Store = (0, $iXqE5.createStore)({
        name: 'addon-store',
        actions: $0672771da90f2be9$var$actions,
        initialState: initialState
    });
    const AddonContainer = (0, $gg7kZ.createContainer)(Store, {
        onInit: ()=>(api, props)=>{
                api.setState({
                    fetchAddons: props.fetchAddons,
                    addToFavorite: props.addToFavorite,
                    removeFromFavorite: props.removeFromFavorite
                });
            }
    });
    const AddonTestContainer = (0, $gg7kZ.createContainer)(Store, {
        onInit: ()=>(api, props)=>{
                api.setState(props);
            }
    });
    const selector = ({ items: items, hasFetchedOnce: hasFetchedOnce, fetchError: fetchError, promise: promise, hasSuccessOnce: hasSuccessOnce, isFetching: isFetching })=>({
            items: items,
            hasFetchedOnce: hasFetchedOnce,
            hasSuccessOnce: hasSuccessOnce,
            fetchError: fetchError,
            promise: promise,
            isFetching: isFetching
        });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const AddonSubscriber = (0, $51nlc.createSubscriber)(Store, {
        displayName: 'AddonSubscriber',
        selector: selector
    }); // Bug with createSubscriber type means that React children end up "never"
    // Deprecated: to be removed
    const useAddonActions = (0, $3sQ5x.createHook)(Store, {
        selector: selector
    });
    const useAddon = (0, $3sQ5x.createHook)(Store, {
        selector: selector
    });
    return {
        AddonSubscriber: AddonSubscriber,
        useAddonActions: useAddonActions,
        useAddon: useAddon,
        AddonTestContainer: AddonTestContainer,
        AddonContainer: AddonContainer
    };
};
const $0672771da90f2be9$var$defaultAddToFavorite = ()=>// TODO: to be implemented when api is ready
    new Promise(()=>null);
const $0672771da90f2be9$var$defaultRemoveFromFavorite = ()=>// TODO: to be implemented when api is ready
    new Promise(()=>null);
const { useAddon: $0672771da90f2be9$export$550c6d89b9b85724 } = $0672771da90f2be9$export$f350d6bef9972cd3({
    fetchAddons: (0, $6Rmr1.fetchAddonItems),
    addToFavorite: $0672771da90f2be9$var$defaultAddToFavorite,
    removeFromFavorite: $0672771da90f2be9$var$defaultRemoveFromFavorite
});

});
parcelRegister("6Rmr1", function(module, exports) {

$parcel$export(module.exports, "fetchAddonItems", () => $c9dd134b6cc78152$export$fe5ef9b24322d3c1);

var $jJZqs = parcelRequire("jJZqs");

var $5HnTq = parcelRequire("5HnTq");

var $fPruT = parcelRequire("fPruT");

const $c9dd134b6cc78152$var$handleError = (error)=>{
    // Temp
    throw error;
};
const $c9dd134b6cc78152$export$fe5ef9b24322d3c1 = async (context)=>{
    const params = $c9dd134b6cc78152$var$getContextParams(context);
    const url = `/rest/navigation/3/global/addons${params ? `?${params}` : ''}`;
    try {
        const response = await fetch(url, (0, $5HnTq.getDefaultOptions)(url));
        if (!response.ok) {
            const errorCode = response.status;
            if (errorCode === 401) return $c9dd134b6cc78152$var$handleError(new (0, $fPruT.AuthenticationError)(`${errorCode}`));
            return $c9dd134b6cc78152$var$handleError(new (0, $jJZqs.default)(errorCode, response.statusText));
        }
        const addonsItems = await response.json();
        // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
        return addonsItems.map((item)=>({
                id: item.id,
                title: item.name,
                avatarUrl: item.iconUrl,
                type: (0, $49a076eb01652100$export$5e2cc09b58170ca2),
                url: item.url,
                className: item.styleClass
            }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // network issue
        return $c9dd134b6cc78152$var$handleError(error);
    }
};
function $c9dd134b6cc78152$var$getContextParams(context) {
    const filteredParams = Object.fromEntries(Object.entries(context || {}).filter(([, value])=>!!value));
    return new URLSearchParams(filteredParams).toString();
}

});


parcelRegister("eKYL7", function(module, exports) {

$parcel$export(module.exports, "useForgeGlobalItems", () => $b1e0d26740806b04$export$fa6081acdcc112a0);

var $k2DRb = parcelRequire("k2DRb");

var $e0AC8 = parcelRequire("e0AC8");

var $5cmSg = parcelRequire("5cmSg");

var $iVaKa = parcelRequire("iVaKa");

var $3HwlS = parcelRequire("3HwlS");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
const $b1e0d26740806b04$var$getItemHref = (extension)=>{
    const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
    return `/jira/apps/${appId}/${envId}`;
};
const $b1e0d26740806b04$var$transformTitle = (title, environmentType, environmentKey)=>{
    if (environmentType === (0, $k2DRb.DEVELOPMENT_ENVIRONMENT) && environmentKey !== (0, $k2DRb.DEFAULT_ENVIRONMENT_KEY)) return `${title} - ${environmentKey}`;
    return title;
};
const $b1e0d26740806b04$var$handleFetch = ({ cloudId: cloudId, isAnonymous: isAnonymous })=>// @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'getState' implicitly has an 'any' type.
    async ({ setState: setState, getState: getState })=>{
        const { isFetching: isFetching } = getState();
        if (!isFetching) try {
            // If Nav4 is enabled, we don't need to fetch global items since they are implemented elsewhere.
            if ((0, $3HwlS.getWillShowNav4)()) return;
            const promise = (0, $iVaKa.fetchModules)({
                cloudId: cloudId,
                isAnonymous: isAnonymous,
                context: {},
                includeHidden: true,
                types: [
                    (0, $k2DRb.GLOBAL_PAGE_MODULE)
                ],
                source: (0, $k2DRb.SOURCE_NAVIGATION)
            });
            setState({
                isFetching: true,
                fetchError: null,
                promise: promise
            });
            const data = await promise;
            const globalPageData = data ? data[0, $k2DRb.GLOBAL_PAGE_MODULE] : [];
            const items = globalPageData.filter((0, $5cmSg.isExtensionVisible)).map((extension)=>({
                    id: extension.id,
                    title: $b1e0d26740806b04$var$transformTitle(extension.properties.title, extension.environmentType, extension.environmentKey),
                    avatarUrl: extension.properties.icon,
                    url: $b1e0d26740806b04$var$getItemHref(extension),
                    environmentType: extension.environmentType,
                    module: (0, $k2DRb.GLOBAL_PAGE_MODULE)
                }));
            setState({
                items: items,
                hasFetchedOnce: true,
                hasSuccessOnce: true,
                isFetching: false,
                fetchError: null,
                promise: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            setState({
                ...getState(),
                fetchError: fetchError,
                hasFetchedOnce: true,
                isFetching: false,
                promise: null
            });
        }
    };
const $b1e0d26740806b04$var$actions = {
    load: ({ cloudId: cloudId, isAnonymous: isAnonymous })=>async ({ dispatch: dispatch })=>{
            const promise = dispatch($b1e0d26740806b04$var$handleFetch({
                cloudId: cloudId,
                isAnonymous: isAnonymous
            }));
            await promise;
        }
};
const $b1e0d26740806b04$export$a87c2a3d589b7efd = ()=>{
    const initialState = {
        hasFetchedOnce: false,
        hasSuccessOnce: false,
        items: [],
        promise: null,
        fetchError: null,
        isFetching: false
    };
    const Store = (0, $iXqE5.createStore)({
        name: 'forge-global-items-store',
        actions: // @ts-expect-error - TS2322 - Type '{ readonly load: (cloudId: string) => ({ dispatch }: StoreActionApi<GenericState<ForgeGlobalMenuItem>>) => Promise<void>; }' is not assignable to type 'Record<string, ActionThunk<{ fetchForgeModule: (arg1: { cloudId: string; moduleName: FullPageModule; }) => Promise<FullPage[] | null>; hasFetchedOnce: boolean; ... 4 more ...; isFetching: boolean; }, { ...; }>>'.
        $b1e0d26740806b04$var$actions,
        initialState: initialState
    });
    // @ts-expect-error - TS2344 - Type '{ readonly load: (cloudId: string) => ({ dispatch }: StoreActionApi<GenericState<ForgeGlobalMenuItem>>) => Promise<void>; }' does not satisfy the constraint 'Record<string, ActionThunk<GenericState<I>, { readonly load: (cloudId: string) => ({ dispatch }: StoreActionApi<GenericState<ForgeGlobalMenuItem>>) => Promise<...>; }>>'.
    const ForgeGlobalItemsTestContainer = (0, $gg7kZ.createContainer)(Store, {
        onInit: ()=>(api, props)=>{
                api.setState(props);
            }
    });
    const selector = ({ items: // @ts-expect-error - TS7031 - Binding element 'items' implicitly has an 'any' type.
    items, hasFetchedOnce: // @ts-expect-error - TS7031 - Binding element 'hasFetchedOnce' implicitly has an 'any' type.
    hasFetchedOnce, fetchError: // @ts-expect-error - TS7031 - Binding element 'fetchError' implicitly has an 'any' type.
    fetchError, promise: // @ts-expect-error - TS7031 - Binding element 'promise' implicitly has an 'any' type.
    promise, hasSuccessOnce: // @ts-expect-error - TS7031 - Binding element 'hasSuccessOnce' implicitly has an 'any' type.
    hasSuccessOnce, isFetching: // @ts-expect-error - TS7031 - Binding element 'isFetching' implicitly has an 'any' type.
    isFetching })=>({
            items: items,
            hasFetchedOnce: hasFetchedOnce,
            fetchError: fetchError,
            promise: promise,
            hasSuccessOnce: hasSuccessOnce,
            isFetching: isFetching
        });
    // @ts-expect-error - TS2344 - Type '{ readonly load: (cloudId: string) => ({ dispatch }: StoreActionApi<GenericState<ForgeGlobalMenuItem>>) => Promise<void>; }' does not satisfy the constraint 'Record<string, ActionThunk<GenericState<I>, { readonly load: (cloudId: string) => ({ dispatch }: StoreActionApi<GenericState<ForgeGlobalMenuItem>>) => Promise<...>; }>>'.
    const ForgeGlobalItemsSubscriber = (0, $51nlc.createSubscriber)(Store, {
        displayName: 'ForgeGlobalItemsSubscriber',
        selector: selector
    });
    const useForgeGlobalItems = (0, $3sQ5x.createHook)(Store, {
        selector: selector
    });
    // @ts-expect-error - TS2322 - Type 'HookFunction<{ items: any; hasFetchedOnce: any; fetchError: any; promise: any; hasSuccessOnce: any; isFetching: any; }, BoundActions<{ fetchForgeModule: (arg1: { cloudId: string; moduleName: FullPageModule; }) => Promise<...>; ... 5 more ...; isFetching: boolean; }, Record<...>>, void>' is not assignable to type '() => HookReturnValue<GenericPublicState<I>, { readonly load: (cloudId: string) => ({ dispatch }: StoreActionApi<GenericState<ForgeGlobalMenuItem>>) => Promise<...>; }>'.
    return {
        ForgeGlobalItemsSubscriber: ForgeGlobalItemsSubscriber,
        useForgeGlobalItems: useForgeGlobalItems,
        ForgeGlobalItemsTestContainer: ForgeGlobalItemsTestContainer
    };
};
const { useForgeGlobalItems: $b1e0d26740806b04$export$fa6081acdcc112a0 } = $b1e0d26740806b04$export$a87c2a3d589b7efd();

});

parcelRegister("7uSIc", function(module, exports) {

$parcel$export(module.exports, "useForgePersonalSettingsItems", () => $bf0aca3f9b0d9b8d$export$455fadc65ea0bef0);

var $9XE6b = parcelRequire("9XE6b");

var $k2DRb = parcelRequire("k2DRb");

var $e0AC8 = parcelRequire("e0AC8");

var $iVaKa = parcelRequire("iVaKa");

var $3HwlS = parcelRequire("3HwlS");

var $1C2yb = parcelRequire("1C2yb");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
const $bf0aca3f9b0d9b8d$var$getItemHref = (extension)=>{
    const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
    return `${(0, $1C2yb.getAppsPersonalSettingsPath)()}/${appId}/${envId}`;
};
const $bf0aca3f9b0d9b8d$var$handleFetch = ({ cloudId: cloudId, isAnonymous: isAnonymous })=>async ({ setState: setState, getState: getState })=>{
        const { fetchForgeModule: fetchForgeModule, isFetching: isFetching } = getState();
        if (!isFetching) try {
            // If Nav4 is enabled, we don't need to fetch personalSettings items since they are implemented elsewhere.
            if ((0, $3HwlS.getWillShowNav4)()) return;
            const promise = fetchForgeModule({
                cloudId: cloudId,
                isAnonymous: isAnonymous,
                context: {},
                includeHidden: false,
                types: [
                    (0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE)
                ],
                source: (0, $k2DRb.SOURCE_NAVIGATION)
            });
            setState({
                isFetching: true,
                fetchError: null,
                promise: promise
            });
            const data = await promise;
            const personalSettingsPageData = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(data, (0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE)) || [];
            const items = personalSettingsPageData.map((extension)=>({
                    id: extension.id,
                    title: extension.properties.title,
                    avatarUrl: extension.properties.icon,
                    url: $bf0aca3f9b0d9b8d$var$getItemHref(extension),
                    environmentType: extension.environmentType,
                    environmentKey: extension.environmentKey,
                    module: (0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE)
                }));
            setState({
                items: items,
                isFetching: false,
                fetchError: null,
                promise: null
            });
        } catch (fetchError) {
            setState({
                ...getState(),
                fetchError: fetchError instanceof Error ? fetchError : null,
                promise: null
            });
        }
    };
const $bf0aca3f9b0d9b8d$var$actions = {
    load: ({ cloudId: cloudId, isAnonymous: isAnonymous })=>async ({ dispatch: dispatch })=>{
            await dispatch($bf0aca3f9b0d9b8d$var$handleFetch({
                cloudId: cloudId,
                isAnonymous: isAnonymous
            }));
        }
};
const $bf0aca3f9b0d9b8d$export$a51e606fadb150f6 = (defaults)=>{
    const initialState = {
        fetchForgeModule: defaults.fetchForgeModule,
        items: [],
        promise: null,
        fetchError: null,
        isFetching: false
    };
    const Store = (0, $iXqE5.createStore)({
        name: 'forge-personal-settings-items-store',
        actions: $bf0aca3f9b0d9b8d$var$actions,
        initialState: initialState
    });
    const ForgePersonalSettingsItemsTestContainer = (0, $gg7kZ.createContainer)(Store, {
        onInit: ()=>(api, props)=>{
                api.setState(props);
            }
    });
    const selector = ({ items: items, fetchError: fetchError, promise: promise, isFetching: isFetching })=>({
            items: items,
            fetchError: fetchError,
            promise: promise,
            isFetching: isFetching
        });
    const ForgePersonalSettingsItemsSubscriber = (0, $51nlc.createSubscriber)(Store, {
        displayName: 'ForgePersonalSettingsItemsSubscriber',
        selector: selector
    });
    const useForgePersonalSettingsItems = (0, $3sQ5x.createHook)(Store, {
        selector: selector
    });
    return {
        ForgePersonalSettingsItemsSubscriber: ForgePersonalSettingsItemsSubscriber,
        useForgePersonalSettingsItems: useForgePersonalSettingsItems,
        ForgePersonalSettingsItemsTestContainer: ForgePersonalSettingsItemsTestContainer
    };
};
const { useForgePersonalSettingsItems: $bf0aca3f9b0d9b8d$export$455fadc65ea0bef0 } = $bf0aca3f9b0d9b8d$export$a51e606fadb150f6({
    fetchForgeModule: (0, $iVaKa.fetchModules)
});

});


parcelRegister("jyW1v", function(module, exports) {

$parcel$export(module.exports, "default", () => $8abfadba6a4f23da$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8abfadba6a4f23da$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    topNav: {
        "id": "atlassian-navigation.top-nav",
        "defaultMessage": "Primary"
    },
    more: {
        "id": "atlassian-navigation.more",
        "defaultMessage": "More"
    }
});

});

parcelRegister("inFGE", function(module, exports) {

$parcel$export(module.exports, "Notifications", () => $611a60e3341e79e1$export$36ba2f559d49a8f6);
$parcel$export(module.exports, "NotificationsContentWrapper", () => $611a60e3341e79e1$export$34c02505a1643f00);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1I7E8 = parcelRequire("1I7E8");

var $dwE2v = parcelRequire("dwE2v");

var $7CMCs = parcelRequire("7CMCs");

var $kaHBi = parcelRequire("kaHBi");

var $aWse0 = parcelRequire("aWse0");

var $lmyls = parcelRequire("lmyls");

var $2Ui4E = parcelRequire("2Ui4E");

var $6cNb0 = parcelRequire("6cNb0");

var $c0dQj = parcelRequire("c0dQj");

var $lfTZh = parcelRequire("lfTZh");

var $cZpsT = parcelRequire("cZpsT");

var $kxZPA = parcelRequire("kxZPA");

var $7XYc4 = parcelRequire("7XYc4");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $keCgG = parcelRequire("keCgG");

var $iPj86 = parcelRequire("iPj86");

var $5vuhU = parcelRequire("5vuhU");


var $b7Ryd = parcelRequire("b7Ryd");

const $611a60e3341e79e1$var$BadgeDI = (0, $kxZPA.lazy)(()=>(parcelRequire("bxI9Q")).then(({ Badge: Badge })=>Badge), {
    ssr: false,
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/notifications/badge/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $611a60e3341e79e1$var$MenuDI = (0, $kxZPA.lazy)(()=>(parcelRequire("b7gz4")).then(({ Menu: Menu })=>Menu), {
    ssr: false,
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/notifications/menu/index.tsx"
});
const $611a60e3341e79e1$var$Notifications = ({ Badge: Badge = $611a60e3341e79e1$var$BadgeDI, ErrorBoundary: ErrorBoundary = (0, $7CMCs.JSErrorBoundary), Icon: Icon = (0, $keCgG.Notification), Menu: Menu = $611a60e3341e79e1$var$MenuDI, NotificationContentFrame: NotificationContentFrame = $611a60e3341e79e1$var$NotificationContentFrameDI, Popup: Popup = (0, $1I7E8.default), useExperienceStart: useExperienceStart = (0, $kaHBi.useExperienceStart), useIntl: useIntl = (0, $aWse0.useIntlV2), useIsAnonymous: useIsAnonymous = (0, $cZpsT.useIsAnonymous), useNavigationItemAnalytics: useNavigationItemAnalytics = (0, $iPj86.useNavigationItemAnalytics), useTopMenus: useTopMenus = (0, $2Ui4E.useTopMenus) })=>{
    const testIdPrefix = (0, $6cNb0.testIdGenerate)('secondary-actions', 'notifications');
    const { formatMessage: formatMessage } = useIntl();
    const isAnonymous = useIsAnonymous();
    const [isNotificationCleared, setIsNotificationCleared] = (0, $5uXOq.useState)(false);
    const [notificationCount, setNotificationCount] = (0, $5uXOq.useState)(0);
    const handleCountUpdate = (0, $5uXOq.useCallback)((newCount)=>{
        setNotificationCount(newCount);
    }, []);
    const [isMenuOpen, { toggle: toggleMenu, off: closeMenu, on: openMenu }] = useTopMenus((0, $lmyls.MENU_ID).NOTIFICATIONS);
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).NOTIFICATIONS
    });
    const onStart = useExperienceStart({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $Mp6qH.NAVIGATION_ITEM_ID).NOTIFICATIONS,
        analyticsSource: 'atlassian-navigation'
    });
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (isMenuOpen) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        performance.clearMarks('notification.list.render.start');
        else performance.mark('notification.list.render.start');
        onStart();
        toggleMenu();
        triggerAnalytics();
        setIsNotificationCleared(true);
    }, [
        isMenuOpen,
        onStart,
        toggleMenu,
        triggerAnalytics
    ]);
    const handleNotificationIconHover = ()=>{
        $611a60e3341e79e1$var$MenuDI.preload();
    };
    (0, $5vuhU.useRegisterNotificationsInCommandPalette)(onClick);
    const content = (0, $5uXOq.useCallback)(({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(NotificationContentFrame, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ErrorBoundary, {
            id: "notifications.list.async",
            packageName: "AtlassianNavigation",
            teamName: "navigation"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "notification-menu-native",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Menu, {
            scheduleUpdate: update,
            testIdPrefix: testIdPrefix
        })))), // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        testIdPrefix
    ]);
    const badge = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ErrorBoundary, {
            id: "notifications.badge.async",
            packageName: "AtlassianNavigation",
            teamName: "navigation",
            fallback: "unmount"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "badge",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Badge, {
            isNotificationCleared: isNotificationCleared,
            setIsNotificationCleared: setIsNotificationCleared,
            isNotificationDrawerOpen: isMenuOpen,
            onNotificationCountChange: handleCountUpdate
        }))), // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isNotificationCleared,
        isMenuOpen
    ]);
    const badgeEmpty = (0, $5uXOq.useCallback)(()=>null, []);
    const notificationsLabel = notificationCount < (0, $3c41b45407aae96c$export$14c62ba6f49b806f) ? formatMessage((0, $b7Ryd.default).label, {
        count: notificationCount
    }) : formatMessage((0, $b7Ryd.default).overNineNotifications);
    const trigger = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'triggerProps' implicitly has an 'any' type.
    (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": (0, $6cNb0.testIdConcat)(testIdPrefix, 'menu-trigger'),
            "data-vc": `atlassian-navigation-notifications${false ? '-ssr' : ''}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
            ...triggerProps,
            badge: badge,
            isSelected: isMenuOpen,
            onClick: onClick,
            onMouseEnter: handleNotificationIconHover,
            tooltip: formatMessage((0, $b7Ryd.default).tooltip),
            label: notificationsLabel,
            onViewRequests: openMenu
        })), // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        badge,
        isMenuOpen,
        onClick,
        formatMessage,
        testIdPrefix,
        notificationCount
    ]);
    if (isAnonymous) return null;
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
        badge: badgeEmpty,
        tooltip: formatMessage((0, $b7Ryd.default).tooltip)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Popup, {
        content: content,
        isOpen: isMenuOpen,
        onClose: closeMenu,
        placement: "bottom-end",
        trigger: trigger,
        shouldRenderToParent: true,
        shouldFitViewport: (0, $c0dQj.isMobileAndInViewPanelIterationExperiment)() ? true : undefined
    });
};
const $611a60e3341e79e1$export$36ba2f559d49a8f6 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $Mp6qH.NAVIGATION_ITEM_ID).NOTIFICATIONS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dwE2v.UsingNotificationsToImproveAdminApprovalProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($611a60e3341e79e1$var$Notifications, props)));
const $611a60e3341e79e1$var$NotificationContentFrameDIOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1w2c _4t3i54ef _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $611a60e3341e79e1$var$notificationContentFrameStyles = null;
const $611a60e3341e79e1$var$NotificationContentFrameDIWithResponsiveWidth = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1bsb1xd4 _4t3i54ef _1e0c1txw _g7111w2c"
        ])
    }, children); // TODO: When the cleanup is done, remove the exported wrapper component below please (see NotificationsContentWrapper)
//       Add fix the import in the Nav4Notifications componponent (which is colocated)
const $611a60e3341e79e1$var$NotificationContentFrameDI = (0, $7XYc4.componentWithCondition)(()=>(0, $c0dQj.isMobileAndInViewPanelIterationExperiment)(), $611a60e3341e79e1$var$NotificationContentFrameDIWithResponsiveWidth, $611a60e3341e79e1$var$NotificationContentFrameDIOld); // This has been created to circumvent a ratcheting rule and avoid an ESLint suppression
const $611a60e3341e79e1$export$34c02505a1643f00 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($611a60e3341e79e1$var$NotificationContentFrameDI, null, children);
};

});
parcelRegister("dwE2v", function(module, exports) {

$parcel$export(module.exports, "CoordinationStopProvider", () => $108b0001dbc2c488$export$83d026e3dd5706d);
$parcel$export(module.exports, "UsingNotificationsToImproveAdminApprovalProvider", () => $108b0001dbc2c488$export$a5554f3421878be1);
$parcel$export(module.exports, "useUsingNotificationsToImproveAdminApprovalContext", () => $108b0001dbc2c488$export$3e450d633150d6ca);

var $5uXOq = parcelRequire("5uXOq");

var $bSSG7 = parcelRequire("bSSG7");

var $9OXo1 = parcelRequire("9OXo1");

const $108b0001dbc2c488$var$TouchpointContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    hasSpotlightBeenShown: true,
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    markSpotlightAsShown: ()=>{}
});
const $108b0001dbc2c488$var$localStorage = (0, $bSSG7.createLocalStorageProvider)((0, $95839ee75937f648$export$67a034c701fa7ff6));
const $108b0001dbc2c488$export$83d026e3dd5706d = ({ stop: stop, children: children })=>children(stop);
const $108b0001dbc2c488$export$a5554f3421878be1 = ({ children: children })=>{
    const { cloudId: cloudId, atlassianAccountId: atlassianAccountId } = (0, $9OXo1.useTenantContext)();
    const [hasSpotlightBeenShown, setHasSpotlightBeenShown] = (0, $5uXOq.useState)(true);
    const spotlightLocalStorageKey = `${(0, $95839ee75937f648$export$7a86d77850136bf4)}_${cloudId}_${atlassianAccountId}`;
    (0, $5uXOq.useEffect)(()=>{
        setHasSpotlightBeenShown($108b0001dbc2c488$var$localStorage.get(spotlightLocalStorageKey) || false);
    }, [
        spotlightLocalStorageKey
    ]);
    const markSpotlightAsShown = (0, $5uXOq.useCallback)(()=>{
        $108b0001dbc2c488$var$localStorage.set(spotlightLocalStorageKey, true);
        setHasSpotlightBeenShown(true);
    }, [
        setHasSpotlightBeenShown,
        spotlightLocalStorageKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($108b0001dbc2c488$var$TouchpointContext.Provider, {
        value: {
            hasSpotlightBeenShown: hasSpotlightBeenShown,
            markSpotlightAsShown: markSpotlightAsShown
        }
    }, children);
};
const $108b0001dbc2c488$export$3e450d633150d6ca = ()=>(0, $5uXOq.useContext)($108b0001dbc2c488$var$TouchpointContext);

});
const $95839ee75937f648$export$67a034c701fa7ff6 = 'uniapa';
const $95839ee75937f648$export$7a86d77850136bf4 = 'has-spotlight-been-shown';
const $95839ee75937f648$export$d2ea4f931a71a509 = 'jira-admin-product-request-spotlight';


parcelRegister("keCgG", function(module, exports) {

$parcel$export(module.exports, "Notification", () => $5d149cd838a80129$export$14834abbfce3b8cd);

var $5uXOq = parcelRequire("5uXOq");

var $cqOtB = parcelRequire("cqOtB");

var $9Ugep = parcelRequire("9Ugep");

var $imZsD = parcelRequire("imZsD");
var $5Fk4Z = parcelRequire("5Fk4Z");
var $1QiBP = parcelRequire("1QiBP");

var $iZN2c = parcelRequire("iZN2c");


var $dwE2v = parcelRequire("dwE2v");

var $lglOU = parcelRequire("lglOU");

var $eGLgs = parcelRequire("eGLgs");

var $3HwlS = parcelRequire("3HwlS");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $9OXo1 = parcelRequire("9OXo1");

var $6s1PB = parcelRequire("6s1PB");
// Should this live in the migration layer (@atlassian/jira-navigation-system) instead?
const $5d149cd838a80129$var$renderNotifications = (props, ref)=>{
    const { onViewRequests: onViewRequests, ...notificationProps } = props;
    if ((0, $3HwlS.getWillShowNav4)()) {
        const { badge: badge, onClick: onClick, isSelected: isSelected, label: label } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iZN2c.Notifications), {
            badge: badge,
            label: label,
            onClick: onClick,
            isSelected: isSelected,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- PLEASE FIX - ENABLING FLAT LINT CONFIG
            ref: ref
        });
    }
    const buttonProps = {
        ...notificationProps,
        ref: ref
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cqOtB.Notifications), buttonProps);
};
const $5d149cd838a80129$export$14834abbfce3b8cd = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { markSpotlightAsShown: markSpotlightAsShown, hasSpotlightBeenShown: hasSpotlightBeenShown } = (0, $dwE2v.useUsingNotificationsToImproveAdminApprovalContext)();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $5uXOq.useState)(true);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { isSiteAdmin: isSiteAdmin } = (0, $9OXo1.useTenantContext)();
    // As an experiment we will bypass the SSR route for notifications so that instead of rendering
    // a skeleton component that will be replaced by the real component, we will render the real component.
    // This means that TTVC should increase because there will be less work to do on the client side.
    if ((0, $3HwlS.getWillShowNav4)()) {
        if (!(0, $6s1PB.expVal)('blu-6229-nav4-top-nav-notifications-perf', 'cohort', false) && false) // @ts-expect-error - Type 'ReactNode' is not assignable to type 'string'.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Ugep.Nav4SkeletonNotificationButton), {
            label: props.tooltip
        });
    } else if (false) // @ts-expect-error - Type 'ReactNode' is not assignable to type 'string'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Ugep.SkeletonNotificationButton), {
        label: props.tooltip
    });
    const { onViewRequests: onViewRequests, ...notificationProps } = props;
    /**
	 * Send analytics event when user clicks "Close" or "View requests" button on the request spotlight
	 * Event registry - https://data-portal.internal.atlassian.com/analytics/registry/52348
	 * @param {"close"|"viewRequests"} buttonType
	 */ const handleSendAnalyticsEventForClickRequestSpotlightButton = (buttonType)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'requestSpotlightButton', {
            buttonType: buttonType,
            isSiteAdmin: isSiteAdmin
        });
    };
    const shouldShowRequestsSpotlight = isSiteAdmin && !hasSpotlightBeenShown;
    if (!shouldShowRequestsSpotlight) return $5d149cd838a80129$var$renderNotifications(notificationProps, ref);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "admin-request-spotlight"
    }, $5d149cd838a80129$var$renderNotifications(notificationProps, ref)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, isSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGLgs.default), {
        messageId: (0, $95839ee75937f648$export$d2ea4f931a71a509),
        messageType: "engagement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dwE2v.CoordinationStopProvider), null, (stop)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lglOU.UsingNotificationsToImproveAdminApprovalSpotlight), {
            onViewRequests: ()=>{
                setIsSpotlightActive(false);
                markSpotlightAsShown();
                onViewRequests && onViewRequests();
                handleSendAnalyticsEventForClickRequestSpotlightButton('viewRequests');
                stop && stop();
            },
            onClose: ()=>{
                setIsSpotlightActive(false);
                markSpotlightAsShown();
                handleSendAnalyticsEventForClickRequestSpotlightButton('close');
                stop && stop();
            }
        })))));
});

});
parcelRegister("lglOU", function(module, exports) {

$parcel$export(module.exports, "UsingNotificationsToImproveAdminApprovalSpotlight", () => $76067028c6c9ade1$export$aa9f9fc1c08b114f);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $ehdJY = parcelRequire("ehdJY");

var $9OXo1 = parcelRequire("9OXo1");

var $a2BKa = parcelRequire("a2BKa");
const $76067028c6c9ade1$export$aa9f9fc1c08b114f = ({ onViewRequests: onViewRequests, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isSiteAdmin: isSiteAdmin } = (0, $9OXo1.useTenantContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$cae2783c9279926),
        sourceName: "requestSpotlight",
        attributes: {
            isSiteAdmin: isSiteAdmin
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        actions: [
            {
                onClick: onViewRequests,
                text: formatMessage((0, $a2BKa.default).uniapaSpotlightViewRequestsButtonText)
            },
            {
                onClick: onClose,
                text: formatMessage((0, $a2BKa.default).uniapaSpotlightCloseButtonText),
                appearance: 'subtle'
            }
        ],
        target: "admin-request-spotlight",
        key: "admin-request-spotlight",
        targetRadius: 100,
        dialogPlacement: "bottom right",
        dialogWidth: 275,
        targetBgColor: "var(--ds-icon-inverse, #FFFFFF)",
        messageId: "cross-flow-using-notifications-to-improve-admin-approval.ui.jira-spotlight.admin-request-spotlight",
        messageType: "engagement"
    }, formatMessage((0, $a2BKa.default).uniapaSpotlightNotificationText))));
};

});
parcelRegister("a2BKa", function(module, exports) {

$parcel$export(module.exports, "default", () => $801cdcf6d45d9579$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $801cdcf6d45d9579$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    uniapaSpotlightNotificationText: {
        "id": "cross-flow-using-notifications-to-improve-admin-approval.uniapa-spotlight-notification-text",
        "defaultMessage": "When someone in your team requests a new product you'll get a notification here now."
    },
    uniapaSpotlightCloseButtonText: {
        "id": "cross-flow-using-notifications-to-improve-admin-approval.uniapa-spotlight-close-button-text",
        "defaultMessage": "Close"
    },
    uniapaSpotlightViewRequestsButtonText: {
        "id": "cross-flow-using-notifications-to-improve-admin-approval.uniapa-spotlight-view-requests-button-text",
        "defaultMessage": "View requests"
    }
});

});



parcelRegister("5vuhU", function(module, exports) {

$parcel$export(module.exports, "useRegisterNotificationsInCommandPalette", () => $179b48f3297e7dbc$export$1859b18f10ade54c);

var $5uXOq = parcelRequire("5uXOq");

var $oZ7y4 = parcelRequire("oZ7y4");

var $5p1kJ = parcelRequire("5p1kJ");

var $5rVQI = parcelRequire("5rVQI");

var $eG9rp = parcelRequire("eG9rp");

var $1Kt4o = parcelRequire("1Kt4o");

var $5zCdk = parcelRequire("5zCdk");

var $jh7L9 = parcelRequire("jh7L9");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");


var $2ju1i = parcelRequire("2ju1i");
const $179b48f3297e7dbc$export$1859b18f10ade54c = (onClick)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { getKeywords: getKeywords } = (0, $eG9rp.useCommandKeywords)();
    const commands = (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-2') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useMemo)(()=>[
            {
                id: (0, $309f32bbf2afff80$export$e0226a83abddbd07),
                name: formatMessage((0, $2ju1i.messages).checkNotifications),
                primaryAction: {
                    type: (0, $jh7L9.CommandActionType).PERFORM,
                    perform: onClick
                },
                keywords: getKeywords('checkNotificationsSynonyms'),
                section: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS).quickActions,
                priority: (0, $5rVQI.COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).checkNotifications,
                components: {
                    LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($oZ7y4))), {
                            spacing: "spacious",
                            label: formatMessage((0, $2ju1i.messages).checkNotifications)
                        })
                },
                analytics: {
                    action: 'checkNotifications'
                }
            }
        ], [
        formatMessage,
        getKeywords,
        onClick
    ]) : [
        {
            id: (0, $309f32bbf2afff80$export$e0226a83abddbd07),
            name: formatMessage((0, $2ju1i.messages).checkNotifications),
            primaryAction: {
                type: (0, $jh7L9.CommandActionType).PERFORM,
                perform: onClick
            },
            keywords: getKeywords('checkNotificationsSynonyms'),
            section: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS).quickActions,
            priority: (0, $5rVQI.COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).checkNotifications,
            components: {
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($oZ7y4))), {
                        spacing: "spacious",
                        label: formatMessage((0, $2ju1i.messages).checkNotifications)
                    })
            },
            analytics: {
                action: 'checkNotifications'
            }
        }
    ];
    (0, $5zCdk.useRegisterCommands)((0, $1Kt4o.COMMAND_PALETTE_REGISTRY_IDS).CHECK_NOTIFICATIONS, commands);
};

});
parcelRegister("5p1kJ", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS", () => $7691773a5eed3db6$export$16b06d29ef8f802b);
$parcel$export(module.exports, "COMMAND_PALETTE_ISSUE_ACTIONS", () => $7691773a5eed3db6$export$156ebd2354e25466);
$parcel$export(module.exports, "COMMAND_PALETTE_PRESSED_ANALYTICS", () => $7691773a5eed3db6$export$7fe859528e87e623);
$parcel$export(module.exports, "COMMAND_PALETTE_ID", () => $7691773a5eed3db6$export$9f646ab88e1d2b14);
$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS_PRIORITY", () => $7691773a5eed3db6$export$abf26cc5daebd2c8);
$parcel$export(module.exports, "COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY", () => $7691773a5eed3db6$export$12514ca8899b0521);
$parcel$export(module.exports, "COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY", () => $7691773a5eed3db6$export$5fa0bcf59f933c21);
$parcel$export(module.exports, "COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY", () => $7691773a5eed3db6$export$7d9743be0b7d862f);
$parcel$export(module.exports, "COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY", () => $7691773a5eed3db6$export$b4e1633c86db2b70);
$parcel$export(module.exports, "COMMAND_PALETTE_HELP_PRIORITY", () => $7691773a5eed3db6$export$5e5a87aac5d9771f);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $7691773a5eed3db6$export$16b06d29ef8f802b = /*#__PURE__*/ function(COMMAND_PALETTE_SECTIONS) {
    COMMAND_PALETTE_SECTIONS["quickSearch"] = "quick-search";
    COMMAND_PALETTE_SECTIONS["containerNavigation"] = "container-navigation";
    COMMAND_PALETTE_SECTIONS["siteNavigation"] = "site-navigation";
    COMMAND_PALETTE_SECTIONS["help"] = "help";
    COMMAND_PALETTE_SECTIONS["quickActions"] = "quick-actions";
    COMMAND_PALETTE_SECTIONS["personalSettings"] = "personal-settings";
    COMMAND_PALETTE_SECTIONS["jiraSettings"] = "jira-settings";
    COMMAND_PALETTE_SECTIONS["atlassianAdmin"] = "atlassian-admin";
    COMMAND_PALETTE_SECTIONS["forge"] = "forge";
    return COMMAND_PALETTE_SECTIONS;
}({});
const $7691773a5eed3db6$export$156ebd2354e25466 = 'issueActions';
const $7691773a5eed3db6$export$7fe859528e87e623 = {
    action: 'pressed',
    actionSubject: 'commandPaletteKeyboardShortcut'
};
const $7691773a5eed3db6$export$9f646ab88e1d2b14 = 'commandPalette';
var $7691773a5eed3db6$export$abf26cc5daebd2c8 = /*#__PURE__*/ function(COMMAND_PALETTE_SECTIONS_PRIORITY) {
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickSearch"] = 0] = "quickSearch";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["issueActions"] = 1] = "issueActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["containerNavigation"] = 2] = "containerNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickActions"] = 3] = "quickActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["siteNavigation"] = 4] = "siteNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["atlassianAdmin"] = 5] = "atlassianAdmin";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["jiraSettings"] = 6] = "jiraSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["personalSettings"] = 7] = "personalSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["help"] = 8] = "help";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["forge"] = 9] = "forge";
    return COMMAND_PALETTE_SECTIONS_PRIORITY;
}({});
var $7691773a5eed3db6$export$12514ca8899b0521 = /*#__PURE__*/ function(COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBacklog"] = 0] = "goToBacklog";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBoard"] = 1] = "goToBoard";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToReports"] = 2] = "goToReports";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToTimeline"] = 3] = "goToTimeline";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToIssues"] = 4] = "goToIssues";
    return COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY;
}({});
var $7691773a5eed3db6$export$5fa0bcf59f933c21 = /*#__PURE__*/ function(COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY) {
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["userManagement"] = 0] = "userManagement";
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["billing"] = 1] = "billing";
    return COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY;
}({});
var $7691773a5eed3db6$export$7d9743be0b7d862f = /*#__PURE__*/ function(COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY) {
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToDarkTheme"] = 0] = "switchToDarkTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToLightTheme"] = 1] = "switchToLightTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToSystemTheme"] = 2] = "switchToSystemTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToPersonalSettings"] = 3] = "goToPersonalSettings";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToAccountSettings"] = 4] = "goToAccountSettings";
    return COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY;
}({});
var $7691773a5eed3db6$export$b4e1633c86db2b70 = /*#__PURE__*/ function(COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["viewAllIssues"] = 0] = "viewAllIssues";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToProjects"] = 1] = "goToProjects";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToBoards"] = 2] = "goToBoards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToFilters"] = 3] = "goToFilters";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToDashboards"] = 4] = "goToDashboards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToPlans"] = 5] = "goToPlans";
    return COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY;
}({});
var $7691773a5eed3db6$export$5e5a87aac5d9771f = /*#__PURE__*/ function(COMMAND_PALETTE_HELP_PRIORITY) {
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["getHelp"] = 0] = "getHelp";
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["viewKeyboardShortcuts"] = 1] = "viewKeyboardShortcuts";
    return COMMAND_PALETTE_HELP_PRIORITY;
}({});

});

parcelRegister("5rVQI", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY", () => $c7aab549acec9d6e$export$5ea2dca0a260365d);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $c7aab549acec9d6e$export$5ea2dca0a260365d = /*#__PURE__*/ function(COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY) {
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["createIssue"] = 0] = "createIssue";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["searchOnCurrentPage"] = 1] = "searchOnCurrentPage";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["openQuickSearch"] = 2] = "openQuickSearch";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["copyUrl"] = 3] = "copyUrl";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["checkNotifications"] = 4] = "checkNotifications";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["openFilterPopup"] = 5] = "openFilterPopup";
    return COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY;
}({});

});

parcelRegister("eG9rp", function(module, exports) {

$parcel$export(module.exports, "useCommandKeywords", () => $61ebfb9239c4f8e5$export$4d8fe3ef6385358);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $dYWZb = parcelRequire("dYWZb");
const $61ebfb9239c4f8e5$export$4d8fe3ef6385358 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const getKeywords = (0, $5uXOq.useCallback)((keywordGroup)=>(0, $dYWZb.messages)[keywordGroup] ? formatMessage((0, $dYWZb.messages)[keywordGroup]) : undefined, [
        formatMessage
    ]);
    return {
        getKeywords: getKeywords
    };
};

});
parcelRegister("dYWZb", function(module, exports) {

$parcel$export(module.exports, "messages", () => $df7d7dd7b88156b7$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $df7d7dd7b88156b7$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    searchYourIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.search-your-issues-synonyms",
        "defaultMessage": "Find my ideas tickets requests tasks work"
    },
    changeStatusSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.change-status-synonyms",
        "defaultMessage": "Move through workflow  Progress Done Complete transition"
    },
    assignToMeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.assign-to-me-synonyms",
        "defaultMessage": "self"
    },
    assignIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.assign-issue-synonyms",
        "defaultMessage": "Choose person Give work Pick assignee Select ticket idea"
    },
    startWatchingIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.start-watching-issue-synonyms",
        "defaultMessage": "Follow work Track Unwatch Unfollow"
    },
    backlogSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.backlog-synonyms",
        "defaultMessage": "Inventory Go"
    },
    boardSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.board-synonyms",
        "defaultMessage": "Boards Sprint Kanban Swimlanes Do Go"
    },
    reportsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.reports-synonyms",
        "defaultMessage": "Summary Insights Burndown Go"
    },
    timelineSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.timeline-synonyms",
        "defaultMessage": "Plan Work calendar Schedule Overview Delivery Go Roadmap"
    },
    // TODO cleanup isCommandPaletteQuickSearchEnabled
    quickSearchSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.quick-search-synonyms",
        "defaultMessage": "Search products across Atlassian Go to"
    },
    pageSearchSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.page-search-synonyms",
        "defaultMessage": "Control f Command cmd cntrl Go find ctrl"
    },
    createIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.create-issue-synonyms",
        "defaultMessage": "work Start idea New ticket task"
    },
    switchDarkThemeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.switch-dark-theme-synonyms",
        "defaultMessage": "light Darkmode lightmode Change Appearance Colours colors nightmode daymode"
    },
    matchSystemThemeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.match-system-theme-synonyms",
        "defaultMessage": "Sync settings Darkmode lightmode Change Appearance Colours colors nightmode daymode"
    },
    copyCurrentPageUrlSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.copy-current-page-url-synonyms",
        "defaultMessage": "link website address"
    },
    getHelpSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.get-help-synonyms",
        "defaultMessage": "In-product Support Documentation Questions Answers"
    },
    viewKeyboardShortcutsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-keyboard-shortcuts-synonyms",
        "defaultMessage": "Hotkeys Show See"
    },
    editDescriptionSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.edit-description-synonyms",
        "defaultMessage": "Completion criteria Info Information Details Add Write"
    },
    addAttachmentSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-attachment-synonyms",
        "defaultMessage": "Attach Upload Document Media"
    },
    addCommentSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-comment-synonyms",
        "defaultMessage": "Write Message"
    },
    logWorkSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.log-work-synonyms",
        "defaultMessage": "Track Record hours Time spent"
    },
    addRemoveFlagSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-remove-flag-synonyms",
        "defaultMessage": "Unflag Mark Unmark Star Unstar"
    },
    cloneIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.clone-issue-synonyms",
        "defaultMessage": "Copy Duplicate Task Idea Request"
    },
    linkConfluencePageSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.link-confluence-page-synonyms",
        "defaultMessage": "Relate Add Connect"
    },
    addAUrlSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-a-url-synonyms",
        "defaultMessage": "Connect Weblink Link Website Domain"
    },
    goToIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-issues-synonyms",
        "defaultMessage": "Advanced issue search Project Filter JQL search list View all"
    },
    goToPersonalSettingsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-personal-settings-synonyms",
        "defaultMessage": "Preferences Notifications Theme Jira labs"
    },
    goToAccountSettingsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-account-settings-synonyms",
        "defaultMessage": "Preferences Privacy Profile Your details Personal information"
    },
    viewAllIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-issues-synonyms",
        "defaultMessage": "Site issues JQL View all"
    },
    viewAllProjectsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-projects-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllPlansSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-plans-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllBoardsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-boards-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllFiltersSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-filters-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllDashboardsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-dashboards-synonyms",
        "defaultMessage": "List Go"
    },
    checkNotificationsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.check-notifications-synonyms",
        "defaultMessage": "window See Updates"
    },
    goToUserManagementSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-user-management-synonyms",
        "defaultMessage": "Permissions"
    },
    goToIssuesSynonymsIssueTermRefresh: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-issues-synonyms-issue-term-refresh",
        "defaultMessage": "Advanced work item search Project Filter JQL search list View all"
    },
    viewAllIssuesSynonymsIssueTermRefresh: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-issues-synonyms-issue-term-refresh",
        "defaultMessage": "Site work items JQL View all"
    }
});

});


parcelRegister("1Kt4o", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY_IDS", () => $3add01bee0e3b846$export$689de18177335e39);
$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY", () => $3add01bee0e3b846$export$96f61eb1261e42c3);
// Documentation for contributing to command palette: go/compal
const $3add01bee0e3b846$export$689de18177335e39 = {
    ADD_CHILD_ISSUE: 'ADD_CHILD_ISSUE',
    ADMIN_NAVIGATION: 'ADMIN_NAVIGATION',
    CHECK_NOTIFICATIONS: 'CHECK_NOTIFICATIONS',
    COPY_URL: 'COPY_URL',
    DESCRIPTION: 'DESCRIPTION',
    ISSUE_ACTIONS: 'ISSUE_ACTIONS',
    ISSUE_FIELD_ASSIGN: 'ISSUE_FIELD_ASSIGN',
    ISSUE_HEADER_ACTIONS: 'ISSUE_HEADER_ACTIONS',
    ISSUE_SUB_HEADER_ACTIONS: 'ISSUE_SUB_HEADER_ACTIONS',
    LOG_WORK: 'LOG_WORK',
    NAVIGATION_COMMANDS: 'NAVIGATION_COMMANDS',
    PARENT: 'PARENT',
    PROJECT_NAVIGATION: 'PROJECT_NAVIGATION',
    QUICK_ADD: 'QUICK_ADD',
    QUICK_SEARCH: 'QUICK_SEARCH',
    SHORTCUTS: 'SHORTCUTS',
    STATUS: 'STATUS',
    STORY_POINTS: 'STORY_POINTS',
    TEST: 'TEST',
    THEME_MODE: 'THEME_MODE',
    FORGE: 'FORGE'
};
// Alphabetical order please
// Update the teamName enum to include your team in the following:
// https://data-portal.internal.atlassian.com/analytics/registry/49626?tabIndex=Attributes
// https://data-portal.internal.atlassian.com/analytics/registry/49627?tabIndex=Attributes
const $3add01bee0e3b846$var$teams = {
    Deliveroo: 'Deliveroo'
};
const $3add01bee0e3b846$export$96f61eb1261e42c3 = {
    ADMIN_NAVIGATION: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ADMIN_NAVIGATION,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    CHECK_NOTIFICATIONS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.CHECK_NOTIFICATIONS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    COPY_URL: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.COPY_URL,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    DESCRIPTION: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.DESCRIPTION,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    ISSUE_ACTIONS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_ACTIONS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    ISSUE_FIELD_ASSIGN: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_FIELD_ASSIGN,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    ISSUE_HEADER_ACTIONS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_HEADER_ACTIONS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    ISSUE_SUB_HEADER_ACTIONS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_SUB_HEADER_ACTIONS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    LOG_WORK: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.LOG_WORK,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    NAVIGATION_COMMANDS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.NAVIGATION_COMMANDS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    PARENT: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.PARENT,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    PROJECT_NAVIGATION: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.PROJECT_NAVIGATION,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    QUICK_ADD: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.QUICK_ADD,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    QUICK_SEARCH: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.QUICK_SEARCH,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    SHORTCUTS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.SHORTCUTS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    STATUS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.STATUS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    STORY_POINTS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.STORY_POINTS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    THEME_MODE: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.THEME_MODE,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    }
};

});

parcelRegister("5zCdk", function(module, exports) {

$parcel$export(module.exports, "useRegisterCommands", () => $c2fc115f119fcec7$export$3f626f8a5dbc29e4);

var $6QoIp = parcelRequire("6QoIp");
const $c2fc115f119fcec7$export$3f626f8a5dbc29e4 = (0, $6QoIp.useRegisterCommandsWithRegistry);

});
parcelRegister("6QoIp", function(module, exports) {

$parcel$export(module.exports, "useRegisterCommandsWithRegistry", () => $9d04f6fb396fa7c9$export$8a824ae164ff968d);

var $5uXOq = parcelRequire("5uXOq");

var $fIZf0 = parcelRequire("fIZf0");
function $9d04f6fb396fa7c9$export$8a824ae164ff968d(registrationId, commands, dependencies = []) {
    const subscribe = (0, $fIZf0.useSubscribeCommandsWithRegistry)();
    const commandCache = (0, $5uXOq.useRef)(commands);
    (0, $5uXOq.useEffect)(()=>{
        commandCache.current = commands;
    }, [
        commands
    ]);
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $5uXOq.useEffect)(()=>subscribe(registrationId, commandCache.current), [
        ...dependencies,
        subscribe
    ]);
}

});
parcelRegister("fIZf0", function(module, exports) {

$parcel$export(module.exports, "useSubscribeCommandsWithRegistry", () => $72118e9f2599bc72$export$880fc01e31710b27);

var $5uXOq = parcelRequire("5uXOq");

var $d8lE2 = parcelRequire("d8lE2");
function $72118e9f2599bc72$export$880fc01e31710b27() {
    const { addCommands: addCommands, removeCommands: removeCommands, updateActiveRegistry: updateActiveRegistry, removeFromActiveRegistry: removeFromActiveRegistry } = (0, $d8lE2.useActionsCommandPalette)();
    const subscribe = (0, $5uXOq.useCallback)((registrationId, commands)=>{
        updateActiveRegistry(registrationId, commands);
        addCommands(commands);
        return ()=>{
            removeCommands(commands);
            removeFromActiveRegistry(registrationId, commands);
        };
    }, [
        addCommands,
        removeCommands,
        removeFromActiveRegistry,
        updateActiveRegistry
    ]);
    return subscribe;
}

});



const $309f32bbf2afff80$export$e0226a83abddbd07 = 'check-notifications';

parcelRegister("2ju1i", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0cb403ddbf46e2b7$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $0cb403ddbf46e2b7$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    checkNotifications: {
        "id": "atlassian-navigation.notifications.command-palette.check-notifications",
        "defaultMessage": "Check notifications"
    }
});

});


const $3c41b45407aae96c$export$14c62ba6f49b806f = 9;

parcelRegister("b7Ryd", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4d3829bacc3127c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a4d3829bacc3127c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltip: {
        "id": "atlassian-navigation.notifications.tooltip",
        "defaultMessage": "Notifications"
    },
    oldLabel: {
        "id": "atlassian-navigation.notifications.old-label",
        "defaultMessage": "Notifications"
    },
    label: {
        "id": "atlassian-navigation.notifications.label",
        "defaultMessage": "{count, plural, =0{ Notifications} one{{count, number} Notification} other{{count, number} Notifications}}"
    },
    overNineNotifications: {
        "id": "atlassian-navigation.notifications.over-nine-notifications",
        "defaultMessage": "Over 9 Notifications"
    }
});

});

parcelRegister("bxI9Q", function(module, exports) {

let $8675079853f909cf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8675079853f909cf$var$load("boRE1").then(()=>parcelRequire('6z8GT'));

});

parcelRegister("b7gz4", function(module, exports) {

let $817d328eb20c9063$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $817d328eb20c9063$var$load("ffQaD"),
    $817d328eb20c9063$var$load("kvRbA"),
    $817d328eb20c9063$var$load("kNFvF"),
    $817d328eb20c9063$var$load("3Yswd")
]).then(()=>parcelRequire('hJbTL'));

});


parcelRegister("klog1", function(module, exports) {

$parcel$export(module.exports, "ProductHome", () => $0ec9a9378b2b1a20$export$32d61f70e04b6020);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $68lE4 = parcelRequire("68lE4");
var $esSwC = parcelRequire("esSwC");

var $coEKR = parcelRequire("coEKR");
var $bYVfR = parcelRequire("bYVfR");
var $letJZ = parcelRequire("letJZ");

var $kaR8K = parcelRequire("kaR8K");
var $e2ecT = parcelRequire("e2ecT");

var $goJA6 = parcelRequire("goJA6");
var $in1mr = parcelRequire("in1mr");

var $gTrd0 = parcelRequire("gTrd0");
var $37H9V = parcelRequire("37H9V");

var $2HThS = parcelRequire("2HThS");
var $8QdPr = parcelRequire("8QdPr");

var $MHKc7 = parcelRequire("MHKc7");

var $4xv02 = parcelRequire("4xv02");

var $4R6GH = parcelRequire("4R6GH");

var $7XYc4 = parcelRequire("7XYc4");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $3HwlS = parcelRequire("3HwlS");

var $kJP8l = parcelRequire("kJP8l");

var $lVJAU = parcelRequire("lVJAU");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $52wwV = parcelRequire("52wwV");

var $iPj86 = parcelRequire("iPj86");

var $b2u1Z = parcelRequire("b2u1Z");

var $l6mLM = parcelRequire("l6mLM");
const $0ec9a9378b2b1a20$export$6d49a893c897b0cc = {
    jira: {
        icon: (0, $letJZ.JiraIcon),
        logo: (0, $letJZ.JiraLogo)
    },
    serviceDesk: {
        icon: (0, $letJZ.JiraServiceManagementIcon),
        logo: (0, $letJZ.JiraServiceManagementLogo)
    },
    'product-discovery': {
        icon: (0, $letJZ.JiraProductDiscoveryIcon),
        logo: (0, $letJZ.JiraProductDiscoveryLogo)
    },
    'customer-service': {
        icon: (0, $coEKR.AtlassianIcon),
        logo: (0, $bYVfR.AtlassianLogo)
    }
};
const $0ec9a9378b2b1a20$export$c133be38c8dacddb = {
    jira: {
        icon: (0, $kaR8K.JiraIcon),
        logo: (0, $e2ecT.JiraLogo)
    },
    serviceDesk: {
        icon: (0, $goJA6.JiraServiceManagementIcon),
        logo: (0, $in1mr.JiraServiceManagementLogo)
    },
    'product-discovery': {
        icon: (0, $gTrd0.JiraProductDiscoveryIcon),
        logo: (0, $37H9V.JiraProductDiscoveryLogo)
    },
    'customer-service': {
        icon: (0, $2HThS.CustomerServiceManagementIcon),
        logo: (0, $8QdPr.CustomerServiceManagementLogo)
    }
};
const $0ec9a9378b2b1a20$var$ProductHome = (0, $7XYc4.componentWithCondition)(()=>(0, $3HwlS.getWillShowNav4)(), $0ec9a9378b2b1a20$var$ProductHomeNew, $0ec9a9378b2b1a20$var$ProductHomeOld);
const $0ec9a9378b2b1a20$export$32d61f70e04b6020 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $Mp6qH.NAVIGATION_ITEM_ID).HOME
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ec9a9378b2b1a20$var$ProductHome, props));
function $0ec9a9378b2b1a20$var$ProductHomeOld({ AkCustomProductHome: AkCustomProductHome = (0, $68lE4.default), AkProductHome: AkProductHome = (0, $esSwC.default), useCustomLogo: useCustomLogo = (0, $52wwV.useCustomLogo), useNavigationItemAnalytics: useNavigationItemAnalytics = (0, $iPj86.useNavigationItemAnalytics), useProductName: useProductName = (0, $kJP8l.useProductName), useRouterActions: useRouterActions = (0, $lVJAU.useRouterActions), useSiteTitle: useSiteTitle = (0, $b2u1Z.useSiteTitle) }) {
    const testIdPrefix = (0, $6cNb0.testIdGenerate)('product-home-');
    const logoUrl = useCustomLogo();
    const productName = useProductName();
    const siteTitleData = useSiteTitle();
    const siteTitle = siteTitleData.shouldShow && siteTitleData.value || undefined;
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).LOGO
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { push: push } = useRouterActions();
    const homeUrl = '/jira';
    const navigateToHome = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'ev' implicitly has an 'any' type.
    (ev)=>{
        triggerAnalytics();
        if (ev.ctrlKey || ev.metaKey) return;
        ev.preventDefault();
        push(homeUrl);
    }, [
        triggerAnalytics,
        push,
        homeUrl
    ]);
    if (logoUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AkCustomProductHome, {
        iconUrl: logoUrl,
        logoUrl: logoUrl,
        logoAlt: formatMessage((0, $l6mLM.default).customLogoAltText),
        iconAlt: formatMessage((0, $l6mLM.default).customIconAltText),
        href: homeUrl,
        onClick: navigateToHome,
        siteTitle: siteTitle,
        testId: testIdPrefix
    });
    const label = $0ec9a9378b2b1a20$var$getLogoLabel(formatMessage, productName);
    const { icon: Icon, logo: Logo } = (0, $4R6GH.fg)('jiv-20710-fix-nav-rerender') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useMemo)(()=>$0ec9a9378b2b1a20$var$getProductIconAndLogo(productName, undefined, label), [
        productName,
        label
    ]) : $0ec9a9378b2b1a20$var$getProductIconAndLogo(productName, undefined, label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AkProductHome, {
        icon: Icon,
        logo: Logo,
        href: homeUrl,
        onClick: navigateToHome,
        siteTitle: siteTitle,
        testId: testIdPrefix
    });
}
function $0ec9a9378b2b1a20$var$ProductHomeNew({ useCustomLogo: useCustomLogo = (0, $52wwV.useCustomLogo), useCustomIcon: useCustomIcon = (0, $52wwV.useCustomIcon), useNavigationItemAnalytics: useNavigationItemAnalytics = (0, $iPj86.useNavigationItemAnalytics), useProductName: useProductName = (0, $kJP8l.useProductName), useRouterActions: useRouterActions = (0, $lVJAU.useRouterActions) }) {
    const testIdPrefix = (0, $6cNb0.testIdGenerate)('product-home-');
    const logoUrl = useCustomLogo();
    const iconUrl = useCustomIcon();
    const productName = useProductName();
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).LOGO
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { push: push } = useRouterActions();
    const homeUrl = '/jira';
    const navigateToHome = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'ev' implicitly has an 'any' type.
    (ev)=>{
        triggerAnalytics();
        if (ev.ctrlKey || ev.metaKey) return;
        ev.preventDefault();
        push(homeUrl);
    }, [
        triggerAnalytics,
        push,
        homeUrl
    ]);
    const { icon: ProductIcon, logo: ProductLogo } = (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') || (0, $4R6GH.fg)('jiv-20710-fix-nav-rerender') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useMemo)(()=>$0ec9a9378b2b1a20$var$getProductIconAndLogo(productName, testIdPrefix), [
        productName,
        testIdPrefix
    ]) : $0ec9a9378b2b1a20$var$getProductIconAndLogo(productName, testIdPrefix);
    const Logo = (0, $5uXOq.useMemo)(()=>logoUrl ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ec9a9378b2b1a20$var$CustomImgNav4, {
                alt: formatMessage((0, $l6mLM.default).customLogoAltText),
                src: logoUrl,
                testId: `${testIdPrefix}-logo`
            }) : ProductLogo, [
        logoUrl,
        ProductLogo,
        formatMessage,
        testIdPrefix
    ]);
    const Icon = (0, $5uXOq.useMemo)(()=>logoUrl && iconUrl ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ec9a9378b2b1a20$var$CustomImgNav4, {
                alt: formatMessage((0, $l6mLM.default).customIconAltText),
                src: iconUrl,
                testId: `${testIdPrefix}-icon`
            }) : ProductIcon, [
        logoUrl,
        iconUrl,
        ProductIcon,
        testIdPrefix,
        formatMessage
    ]);
    const label = $0ec9a9378b2b1a20$var$getLogoLabel(formatMessage, productName);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        testId: `${testIdPrefix}-container`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4xv02.NavLogo), {
        label: label,
        icon: Icon,
        logo: Logo,
        href: homeUrl,
        onClick: navigateToHome
    }));
} // formatMessage is intentionally an any type due to absence of easily importable type, and because actual
// type definition contains any as well!
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $0ec9a9378b2b1a20$var$getLogoLabel(formatMessage, productName) {
    let label = '';
    if (productName === 'serviceDesk') label = formatMessage((0, $l6mLM.default).jsmLogoLabel);
    else if (productName === 'product-discovery') label = formatMessage((0, $l6mLM.default).jpdLogoLabel);
    else if (productName === 'customer-service') label = formatMessage((0, $l6mLM.default).jcsLogoLabel);
    else label = formatMessage((0, $l6mLM.default).jiraLogoLabel);
    return label;
} /**
   * Due to typescript limitations (props type clashes), we need to handle the icon and logo components differently for the
   * new and old navigation apps. This function returns the appropriate components based on the product name.
   */ 
function $0ec9a9378b2b1a20$var$getProductIconAndLogo(productName, testIdPrefix, label) {
    const productKey = productName === 'core' || productName === 'software' ? 'jira' : productName;
    const { icon: OldIconComponent, logo: OldLogoComponent } = $0ec9a9378b2b1a20$export$6d49a893c897b0cc[productKey];
    const { icon: NewIconComponent, logo: NewLogoComponent } = $0ec9a9378b2b1a20$export$c133be38c8dacddb[productKey];
    const createComponent = (Component, type)=>(props)=>{
            const additionalProps = {}; // Nav v3 sets a testId, Nav v4 sets a label
            if (testIdPrefix) additionalProps.testId = `${testIdPrefix}-${type}`;
            if (label) additionalProps.label = label;
             // Casting required due to complexities of the different component prop types
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
                ...props,
                ...additionalProps
            });
        };
    const oldIcon = createComponent(OldIconComponent, 'icon');
    const oldLogo = createComponent(OldLogoComponent, 'logo');
    const newIcon = createComponent(NewIconComponent, 'icon');
    const newLogo = createComponent(NewLogoComponent, 'logo');
    return (0, $4R6GH.fg)('platform-team25-app-icon-tiles') ? {
        icon: newIcon,
        logo: newLogo
    } : {
        icon: oldIcon,
        logo: oldLogo
    };
}
function $0ec9a9378b2b1a20$var$CustomImgNav4({ alt: alt, src: src, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: src,
        alt: alt,
        "data-testid": testId
    });
}

});
parcelRegister("52wwV", function(module, exports) {

$parcel$export(module.exports, "useCustomLogo", () => $aa86f48989803edf$export$9891fb86d6b41647);
$parcel$export(module.exports, "useCustomIcon", () => $aa86f48989803edf$export$9e69c21df0138642);

var $5uXOq = parcelRequire("5uXOq");

var $j8DrX = parcelRequire("j8DrX");
const $aa86f48989803edf$export$9891fb86d6b41647 = ()=>(0, $5uXOq.useMemo)(()=>(0, $j8DrX.default)('ajs-lf-top-adg3-logourl'), []);
const $aa86f48989803edf$export$9e69c21df0138642 = ()=>(0, $5uXOq.useMemo)(()=>(0, $j8DrX.default)('ajs-fspage-favicon'), []);

});

parcelRegister("b2u1Z", function(module, exports) {

$parcel$export(module.exports, "useSiteTitle", () => $fc4a3f770cbe7bdc$export$3e157e0d79928990);

var $5uXOq = parcelRequire("5uXOq");

var $j8DrX = parcelRequire("j8DrX");
const $fc4a3f770cbe7bdc$export$3e157e0d79928990 = ()=>(0, $5uXOq.useMemo)(()=>({
            shouldShow: (0, $j8DrX.default)('ajs-lf-top-adg3-shouldshowtitle') === 'true',
            value: (0, $j8DrX.default)('ajs-app-title')
        }), []);

});

parcelRegister("l6mLM", function(module, exports) {

$parcel$export(module.exports, "default", () => $874346879bf58ddf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $874346879bf58ddf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    customLogoAltText: {
        "id": "atlassian-navigation.product-home.custom-logo-alt-text",
        "defaultMessage": "Jira homepage"
    },
    customIconAltText: {
        "id": "atlassian-navigation.product-home.custom-icon-alt-text",
        "defaultMessage": "Custom Jira icon"
    },
    jiraLogoLabel: {
        "id": "atlassian-navigation.product-home.jira-logo-label",
        "defaultMessage": "Go to your Jira homepage"
    },
    jsmLogoLabel: {
        "id": "atlassian-navigation.product-home.jsm-logo-label",
        "defaultMessage": "Go to your Jira Service Management homepage"
    },
    jpdLogoLabel: {
        "id": "atlassian-navigation.product-home.jpd-logo-label",
        "defaultMessage": "Go to your Jira Product Discovery homepage"
    },
    jcsLogoLabel: {
        "id": "atlassian-navigation.product-home.jcs-logo-label",
        "defaultMessage": "Go to your Jira Customer Service homepage"
    }
});

});


parcelRegister("7bwNu", function(module, exports) {

$parcel$export(module.exports, "Profile", () => $4d6ab55be4705ca2$export$5120f2d0b8d4cab8);

var $5uXOq = parcelRequire("5uXOq");

var $jZ4fr = parcelRequire("jZ4fr");

var $8Pko5 = parcelRequire("8Pko5");

var $ujWmd = parcelRequire("ujWmd");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $1I7E8 = parcelRequire("1I7E8");

var $921sX = parcelRequire("921sX");

var $ixNeq = parcelRequire("ixNeq");

var $kaHBi = parcelRequire("kaHBi");

var $4R6GH = parcelRequire("4R6GH");

var $aWse0 = parcelRequire("aWse0");

var $lmyls = parcelRequire("lmyls");

var $2Ui4E = parcelRequire("2Ui4E");

var $2EqxS = parcelRequire("2EqxS");

var $6cNb0 = parcelRequire("6cNb0");

var $3HwlS = parcelRequire("3HwlS");


var $cE2Qr = parcelRequire("cE2Qr");

var $cYlk7 = parcelRequire("cYlk7");

var $2Ql51 = parcelRequire("2Ql51");

var $3t5QD = parcelRequire("3t5QD");

var $9yzc5 = parcelRequire("9yzc5");

var $4QigF = parcelRequire("4QigF");

var $7uSIc = parcelRequire("7uSIc");

var $koeKL = parcelRequire("koeKL");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $iPj86 = parcelRequire("iPj86");

var $1yM7R = parcelRequire("1yM7R");

var $k7xP2 = parcelRequire("k7xP2");

var $ebznH = parcelRequire("ebznH");

var $ixpv2 = parcelRequire("ixpv2");
const $4d6ab55be4705ca2$var$SpotlightTargetDI = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-test-id": `ak-spotlight-target-${props.name}`
    }, children));
const $4d6ab55be4705ca2$var$handleMouseEnter = ()=>{
    (0, $4QigF.LazyOpenMenuItem).preload();
    (0, $9yzc5.NavigationProfileNavItemWrapperNudgeLazy).preload();
};
const $4d6ab55be4705ca2$var$Nav3Profile = ({ AkProfile: AkProfile = (0, $8Pko5.Profile), Avatar: Avatar = (0, $ujWmd.default), Menu: Menu = (0, $ebznH.Menu), Popup: Popup = (0, $1I7E8.default), SpotlightTarget: SpotlightTarget = $4d6ab55be4705ca2$var$SpotlightTargetDI, useCurrentUser: useCurrentUser = (0, $cYlk7.useCurrentUser), useExperienceStart: useExperienceStart = (0, $kaHBi.useExperienceStart), useIntl: useIntl = (0, $aWse0.useIntlV2), useNavigationItemAnalytics: useNavigationItemAnalytics = (0, $iPj86.useNavigationItemAnalytics), useTopMenus: useTopMenus = (0, $2Ui4E.useTopMenus), useUserBoardId: useUserBoardId = (0, $1yM7R.useUserBoardId) })=>{
    const { formatMessage: formatMessage } = useIntl();
    const [isMenuOpen, { toggle: toggleMenu, off: closeMenu }] = useTopMenus((0, $lmyls.MENU_ID).PROFILE);
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).PROFILE
    });
    const { data: { user: user } } = useCurrentUser();
    const onStart = useExperienceStart({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $Mp6qH.NAVIGATION_ITEM_ID).PROFILE,
        analyticsSource: 'atlassian-navigation'
    });
    const [nudgeStep] = (0, $cE2Qr.useNudgeStep)();
    const [hasNudgeActive] = (0, $cE2Qr.useHasNudgeActive)();
    const [userBoardId, userBoardOwnerAccountId] = useUserBoardId(isMenuOpen);
    const testIdPrefix = (0, $6cNb0.testIdGenerate)('secondary-actions', 'profile');
    const [userTraits, { setUserTraits: setUserTraits }] = (0, $ixNeq.useUserTraits)();
    const fetchUserTraits = (0, $ixNeq.useFetchUserTraitsOld)();
    const [, { load: loadForgePersonalSettingsItem }] = (0, $7uSIc.useForgePersonalSettingsItems)();
    const cloudId = (0, $koeKL.useCloudId)();
    const setUserTraitsIfNotAvailable = (0, $5uXOq.useCallback)(async ()=>{
        if (user.isAnonymous) return;
        if (!userTraits?.attributes?.length && userTraits?.attributes !== null) {
            const newTraits = await fetchUserTraits();
            // We must explicitly check for false because fetchUserTraits returns "false" when pending, and "null" when traits are empty.
            if (newTraits !== false) setUserTraits(newTraits);
        }
    }, [
        user.isAnonymous,
        userTraits?.attributes,
        fetchUserTraits,
        setUserTraits
    ]);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        onStart();
        loadForgePersonalSettingsItem({
            cloudId: cloudId,
            isAnonymous: user.isAnonymous
        });
        toggleMenu();
        triggerAnalytics();
    }, [
        onStart,
        toggleMenu,
        triggerAnalytics,
        loadForgePersonalSettingsItem,
        cloudId,
        user.isAnonymous
    ]);
    const content = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Menu, {
            userBoardId: userBoardId,
            userBoardOwnerAccountId: userBoardOwnerAccountId,
            testIdPrefix: testIdPrefix
        }), // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        userBoardId,
        userBoardOwnerAccountId,
        testIdPrefix
    ]);
    const Trigger = (0, $5uXOq.useCallback)((triggerProps)=>// eslint-disable-next-line jsx-a11y/no-static-element-interactions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": (0, $6cNb0.testIdConcat)(testIdPrefix, 'menu-trigger'),
            onMouseOver: setUserTraitsIfNotAvailable,
            onFocus: setUserTraitsIfNotAvailable
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
            conditionsToApplyWrapper: (0, $6784cbc7d62e5d7c$export$7aa8bceae32c7862) === nudgeStep && hasNudgeActive,
            Wrapper: (0, $9yzc5.NavigationProfileNavItemWrapperNudgeAsync)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AkProfile, {
            ...triggerProps,
            icon: // NOTE: This SpotlightTarget can be used throughout Jira not just within
            // the current package. They're often used for onboarding or changeboarding
            // experiences and allow an Atlaskit spotlight to be attached to page elements.
            // If you need to change this, make sure you check where the target ID is being used
            // and contact the relevant team as necessary. This Sourcegraph link should help :)
            // http://go/src/PROFILE_SPOTLIGHT_KEY
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SpotlightTarget, {
                name: (0, $Mp6qH.PROFILE_SPOTLIGHT_KEY)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Avatar, {
                // @ts-expect-error - TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
                src: user.avatarUrls ? user.avatarUrls['48x48'] : undefined,
                size: "small",
                borderColor: "transparent"
            })),
            isSelected: isMenuOpen,
            onClick: onClick,
            tooltip: formatMessage((0, $ixpv2.default).tooltip),
            onMouseEnter: $4d6ab55be4705ca2$var$handleMouseEnter,
            "aria-label": formatMessage((0, $ixpv2.default).tooltip),
            id: "atlassian-navigation.ui.profile.icon"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZ4fr.EngagementSpotlight), {
            engagementId: (0, $Mp6qH.PROFILE_SPOTLIGHT_KEY)
        })), // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        formatMessage,
        isMenuOpen,
        onClick,
        testIdPrefix,
        user,
        nudgeStep,
        hasNudgeActive
    ]);
    if (user.isAnonymous) return null;
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Trigger, {
        "aria-expanded": false,
        "aria-haspopup": true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Popup, {
        content: content,
        isOpen: isMenuOpen,
        onClose: closeMenu,
        placement: "bottom-end",
        shouldRenderToParent: true,
        trigger: Trigger,
        label: formatMessage((0, $ixpv2.default).tooltip),
        role: "menu"
    });
};
const $4d6ab55be4705ca2$var$Nav4Profile = ({ AccountMenu: AccountMenu = (0, $921sX.AccountMenuNav3), AkProfile: AkProfile = (0, $8Pko5.Profile), Avatar: Avatar = (0, $ujWmd.default), MenuNav4: MenuNav4 = (0, $k7xP2.MenuNav4), useCurrentUser: // eslint-disable-next-line react-hooks/react-compiler
useCurrentUser = (0, $cYlk7.useCurrentUser), useIntl: // eslint-disable-next-line react-hooks/react-compiler
useIntl = (0, $aWse0.useIntlV2), useUserBoardId: // eslint-disable-next-line react-hooks/react-compiler
useUserBoardId = (0, $1yM7R.useUserBoardId) })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const { formatMessage: formatMessage } = useIntl();
    const { theme: theme, setTheme: setTheme } = (0, $2Ql51.useThemePreference)();
    const { data: { user: user } } = useCurrentUser();
    // @ts-expect-error - TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & User)'.
    const emailAddress = user.emailAddress || '';
    const atlassianSettingsLink = (0, $2EqxS.useAtlassianPersonalSettingsLink)(emailAddress);
    const switchAccountLink = (0, $2EqxS.useSwitchAccountLink)();
    const profileLink = (0, $2EqxS.useProfileLink)();
    // eslint-disable-next-line react-hooks/react-compiler
    const [userBoardId, userBoardOwnerAccountId] = useUserBoardId(false);
    const testIdPrefix = (0, $6cNb0.testIdGenerate)('secondary-actions', 'profile');
    if (user.isAnonymous) return null;
    if (false && !(0, $4R6GH.fg)('jira_nav4_beta_drop_2')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AkProfile, {
        "aria-haspopup": true,
        "aria-expanded": false,
        testId: (0, $6cNb0.testIdConcat)(testIdPrefix, 'trigger'),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Avatar, {
            size: "small",
            borderColor: "transparent"
        }),
        tooltip: formatMessage((0, $ixpv2.default).tooltip),
        "aria-label": formatMessage((0, $ixpv2.default).tooltip),
        id: "atlassian-navigation.ui.profile.icon"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AccountMenu, {
        testId: testIdPrefix,
        // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'DataBasic | (DataBasic & User)'.
        name: user.displayName,
        // @ts-expect-error - TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & User)'.
        picture: user.avatarUrls ? user.avatarUrls['48x48'] : undefined,
        email: emailAddress,
        viewProfileLink: profileLink,
        manageProfileLink: atlassianSettingsLink,
        switchAccountLink: switchAccountLink,
        logOutLink: "/logout",
        onThemeChange: setTheme,
        currentTheme: theme,
        extraMenuItems: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuNav4, {
            userBoardId: userBoardId,
            userBoardOwnerAccountId: userBoardOwnerAccountId,
            testIdPrefix: testIdPrefix
        })
    });
};
const $4d6ab55be4705ca2$var$Profile = (props)=>(0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4d6ab55be4705ca2$var$Nav4Profile, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4d6ab55be4705ca2$var$Nav3Profile, props);
const $4d6ab55be4705ca2$export$5120f2d0b8d4cab8 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $Mp6qH.NAVIGATION_ITEM_ID).PROFILE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4d6ab55be4705ca2$var$Profile, props));

});
parcelRegister("ixNeq", function(module, exports) {

$parcel$export(module.exports, "useFetchUserTraitsOld", () => $5e172a254cf471a7$export$d5a27009aa54a078);
$parcel$export(module.exports, "useUserTraits", () => $5e172a254cf471a7$export$49363c8b904e0dc7);

var $5uXOq = parcelRequire("5uXOq");

var $eusud = parcelRequire("eusud");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $5e172a254cf471a7$var$setUserTraits = (newTraits)=>({ getState: getState, setState: setState })=>{
        const currentUserTraits = getState();
        setState({
            ...currentUserTraits,
            attributes: newTraits
        });
    };
const $5e172a254cf471a7$var$addUserTrait = (trait)=>({ getState: getState, setState: setState })=>{
        const currentUserTraits = getState();
        if (currentUserTraits.attributes?.some((t)=>t.name === trait.name)) return;
        setState({
            attributes: currentUserTraits.attributes?.concat(trait) ?? [
                trait
            ]
        });
    };
const $5e172a254cf471a7$var$fetchUserTraits = (cloudId, accountId)=>async ({ getState: getState, setState: setState })=>{
        if (!accountId) return null;
        const state = getState();
        if (state.attributes !== null) return;
        const getUserTraits = async ()=>{
            try {
                const userTraitsData = await (0, $eusud.performGetRequest)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${accountId}`);
                return userTraitsData?.attributes ?? [];
            } catch  {
                return null;
            }
        };
        const userTraits = await getUserTraits();
        setState({
            attributes: userTraits
        });
    };
const $5e172a254cf471a7$var$actions = {
    setUserTraits: $5e172a254cf471a7$var$setUserTraits,
    fetchUserTraits: $5e172a254cf471a7$var$fetchUserTraits,
    addUserTrait: $5e172a254cf471a7$var$addUserTrait
};
const $5e172a254cf471a7$var$initialState = {
    attributes: null
};
const $5e172a254cf471a7$export$d5a27009aa54a078 = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const accountId = (0, $90yGq.useAccountId)();
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    return (0, $5uXOq.useCallback)(async ()=>{
        if (!accountId) return null;
        const url = `/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${accountId}`;
        const getUserTraits = async ()=>{
            try {
                setLoading(true);
                const userTraitsData = await (0, $eusud.performGetRequest)(url);
                // If a user has no attributes on their account, return null so we know
                // not to keep trying to fetch data.
                return !userTraitsData?.attributes?.length ? null : userTraitsData?.attributes;
            } catch  {
                return null;
            } finally{
                setLoading(false);
            }
        };
        if (!loading) {
            const userTraits = await getUserTraits();
            return userTraits;
        }
        return false;
    }, [
        accountId,
        cloudId,
        loading
    ]);
};
const $5e172a254cf471a7$export$6e688ed53ae076d5 = (0, $iXqE5.createStore)({
    initialState: $5e172a254cf471a7$var$initialState,
    actions: $5e172a254cf471a7$var$actions,
    name: 'UserTraits'
});
const $5e172a254cf471a7$export$49363c8b904e0dc7 = (0, $3sQ5x.createHook)($5e172a254cf471a7$export$6e688ed53ae076d5);
const $5e172a254cf471a7$export$4f249a943026a90b = (0, $3sQ5x.createActionsHook)($5e172a254cf471a7$export$6e688ed53ae076d5);

});

parcelRegister("2EqxS", function(module, exports) {

$parcel$export(module.exports, "useAtlassianPersonalSettingsLink", () => $58d844745b0a5554$export$8ac70acdad00754b);
$parcel$export(module.exports, "useSwitchAccountLink", () => $58d844745b0a5554$export$dce6af3168fb6ced);
$parcel$export(module.exports, "useProfileLink", () => $58d844745b0a5554$export$b8f25e615dd30d7b);
$parcel$export(module.exports, "getBeforeEntity", () => $58d844745b0a5554$export$5b8580d0254a9349);
$parcel$export(module.exports, "getBoardLink", () => $58d844745b0a5554$export$ff5c49b7852aca68);
$parcel$export(module.exports, "getLinkFromProject", () => $58d844745b0a5554$export$dd9458ee44edd0c6);
$parcel$export(module.exports, "getQueueLink", () => $58d844745b0a5554$export$b44363840d1b683e);
$parcel$export(module.exports, "getIsClassicSoftwareProject", () => $58d844745b0a5554$export$286ea82aef1c76e9);
$parcel$export(module.exports, "getUsersApps", () => $58d844745b0a5554$export$ad0fd737fbd4a083);

var $ebyGx = parcelRequire("ebyGx");

var $5euJh = parcelRequire("5euJh");

var $j0xEB = parcelRequire("j0xEB");

var $iN5FK = parcelRequire("iN5FK");

var $hqguB = parcelRequire("hqguB");

var $kk6FJ = parcelRequire("kk6FJ");

var $ludxj = parcelRequire("ludxj");

var $urQ6o = parcelRequire("urQ6o");

var $7M8Tn = parcelRequire("7M8Tn");

var $7wTzh = parcelRequire("7wTzh");

var $lB6pS = parcelRequire("lB6pS");

var $lyCs2 = parcelRequire("lyCs2");

var $ee0rS = parcelRequire("ee0rS");

var $90yGq = parcelRequire("90yGq");

var $lmyls = parcelRequire("lmyls");

var $6cNb0 = parcelRequire("6cNb0");
const $58d844745b0a5554$export$ab902790e443b0ec = ()=>`${(0, $5euJh.getATLContextUrl)('id')}/login`;
const $58d844745b0a5554$export$8ac70acdad00754b = (destinationAccountEmail)=>{
    const loginLink = $58d844745b0a5554$export$ab902790e443b0ec();
    const destinationUrl = `${(0, $5euJh.getATLContextUrl)('id')}/manage-profile/profile-and-visibility`;
    return destinationAccountEmail ? `${loginLink}?${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
        application: 'jira',
        continue: destinationUrl,
        login_hint: destinationAccountEmail,
        prompt: 'none'
    })}` : destinationUrl;
};
const $58d844745b0a5554$export$dce6af3168fb6ced = ()=>{
    const loginLink = $58d844745b0a5554$export$ab902790e443b0ec();
    const { href: href } = (0, $j0xEB.default)() || {};
    return `${loginLink}?${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
        application: 'jira',
        continue: href,
        prompt: 'select_account'
    })}`;
};
const $58d844745b0a5554$export$b8f25e615dd30d7b = ()=>{
    const accountId = (0, $90yGq.useAccountId)();
    return `/jira/people/${accountId || ''}`;
};
const $58d844745b0a5554$export$5b8580d0254a9349 = (favoriteItems)=>favoriteItems && favoriteItems.length > 0 ? {
        id: String(favoriteItems[0].id),
        type: favoriteItems[0].type
    } : {
        id: undefined,
        type: undefined
    };
const $58d844745b0a5554$export$ff5c49b7852aca68 = (item)=>{
    const { attributes: attributes, attributes: { parentType: parentType }, id: id } = item;
    const boardId = String(id);
    if (parentType === 'project') {
        // @ts-expect-error - TS2339 - Property 'nextgen' does not exist on type 'ProjectBoardItemAttributes | UserBoardItemAttributes'. | TS2339 - Property 'projectKey' does not exist on type 'ProjectBoardItemAttributes | UserBoardItemAttributes'. | TS2339 - Property 'projectType' does not exist on type 'ProjectBoardItemAttributes | UserBoardItemAttributes'.
        const { nextgen: nextgen, projectKey: projectKey, projectType: projectType } = attributes;
        if (projectType === 'business') return {
            params: {
                projectKey: projectKey
            },
            query: {},
            route: (0, $hqguB.jiraBusinessProjectRedirectRoute)
        };
        if (projectType === 'service_desk') return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $kk6FJ.jsmBoardRoute)
        };
        if (nextgen === 'true') return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $7wTzh.softwareBoardRoute)
        };
        return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $lB6pS.classicSoftwareBoardRoute)
        };
    }
    if (parentType === 'user') {
        // @ts-expect-error - TS2339 - Property 'userAccountId' does not exist on type 'ProjectBoardItemAttributes | UserBoardItemAttributes'.
        const { userAccountId: accountId } = attributes;
        return {
            params: {
                boardId: boardId,
                accountId: accountId
            },
            query: {},
            route: (0, $lyCs2.userBoardRoute)
        };
    }
    return {
        params: undefined,
        query: undefined,
        route: undefined
    };
};
const $58d844745b0a5554$export$dd9458ee44edd0c6 = (item)=>{
    const { attributes: { projectType: projectType, boardId: boardId, nextgen: nextgen, projectKey: projectKey } } = item;
    if (projectType === 'business') return {
        params: {
            projectKey: projectKey
        },
        query: {},
        route: (0, $hqguB.jiraBusinessProjectRedirectRoute)
    };
    if (boardId !== undefined) {
        if (nextgen === 'true') return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $7wTzh.softwareBoardRoute)
        };
        return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $lB6pS.classicSoftwareBoardRoute)
        };
    }
    if (projectType === 'service_desk') return {
        params: {
            projectKey: projectKey
        },
        query: {},
        route: (0, $ludxj.projectServiceDeskRoute)
    };
    return {
        params: {
            projectKey: projectKey
        },
        query: {},
        route: (0, $iN5FK.browseProjectRedirectRoute)
    };
};
const $58d844745b0a5554$export$b44363840d1b683e = (item)=>{
    const { attributes: { projectKey: projectKey, queuesCategory: queuesCategory }, id: id } = item;
    return {
        params: {
            projectKey: projectKey,
            ...queuesCategory != null && queuesCategory !== '' ? {
                practiceType: (0, $ee0rS.toShortFormItsmPractice)(queuesCategory)
            } : {},
            queueId: String(id)
        },
        route: queuesCategory != null && queuesCategory !== '' ? (0, $urQ6o.customPracticeQueueRoute) : (0, $7M8Tn.customQueueRoute)
    };
};
const $58d844745b0a5554$export$286ea82aef1c76e9 = (attributes)=>attributes.parentType === 'user' || attributes.parentType === 'project' && attributes.projectType === 'software' && attributes.nextgen === 'false';
const $58d844745b0a5554$export$ad0fd737fbd4a083 = (items)=>items.filter((item)=>item.id !== (0, $lmyls.ADDON_ID).DISCOVER);

});
parcelRegister("j0xEB", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b1198aeec732ce1$export$2e2bcd8739ae039);
/**
 * Wrap window.location so that it's testable.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
var $9b1198aeec732ce1$export$2e2bcd8739ae039 = ()=>{
    if (typeof window !== 'undefined') return window.location;
    return undefined;
};

});

parcelRegister("ee0rS", function(module, exports) {

$parcel$export(module.exports, "toShortFormItsmPractice", () => $3a8490f36704bba6$export$db58a56259f511a2);

var $oCMSG = parcelRequire("oCMSG");
const $3a8490f36704bba6$var$longToShortConversionMap = {
    [(0, $oCMSG.CHANGES)]: (0, $oCMSG.SHORT_FORM_CHANGES),
    [(0, $oCMSG.INCIDENTS)]: (0, $oCMSG.SHORT_FORM_INCIDENTS),
    [(0, $oCMSG.PROBLEMS)]: (0, $oCMSG.SHORT_FORM_PROBLEMS),
    [(0, $oCMSG.SERVICE_REQUEST)]: (0, $oCMSG.SHORT_FORM_SERVICE_REQUEST),
    [(0, $oCMSG.POST_INCIDENT_REVIEWS)]: (0, $oCMSG.SHORT_FORM_POST_INCIDENT_REVIEWS),
    [(0, $oCMSG.DEVELOPER_ESCALATION)]: (0, $oCMSG.SHORT_FORM_DEVELOPER_ESCALATION)
};
function $3a8490f36704bba6$var$isLongForm(workCategoryKey) {
    return !!workCategoryKey && workCategoryKey in $3a8490f36704bba6$var$longToShortConversionMap;
}
const $3a8490f36704bba6$export$db58a56259f511a2 = (workCategoryKey)=>{
    if ($3a8490f36704bba6$var$isLongForm(workCategoryKey)) return $3a8490f36704bba6$var$longToShortConversionMap[workCategoryKey];
    return null;
};

});


parcelRegister("3t5QD", function(module, exports) {

$parcel$export(module.exports, "ConditionalNudgeWrapper", () => $44a5067dcee1bfd9$export$56d544c4f479b7fb);

var $5uXOq = parcelRequire("5uXOq");
const $44a5067dcee1bfd9$export$56d544c4f479b7fb = ({ children: children, Wrapper: Wrapper, conditionsToApplyWrapper: conditionsToApplyWrapper, ...restProps })=>{
    if (conditionsToApplyWrapper && !false && children !== null && children !== false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Wrapper, restProps, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};

});

parcelRegister("9yzc5", function(module, exports) {

$parcel$export(module.exports, "NavigationProfileNavItemWrapperNudgeLazy", () => $e1b30bf1670573e8$export$3651b15d92c1c280);
$parcel$export(module.exports, "NavigationProfileNavItemWrapperNudgeAsync", () => $e1b30bf1670573e8$export$deb2cae843941204);

var $5uXOq = parcelRequire("5uXOq");


var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $e1b30bf1670573e8$export$3651b15d92c1c280 = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("1jUm9")).then((exportedModule)=>exportedModule.NavigationProfileNavItemWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/navigation-profile/index.tsx"
});
const $e1b30bf1670573e8$export$deb2cae843941204 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: "asyncProfileNudge",
        fallback: children,
        attributes: {
            NAVIGATION_APPS_PROFILE_ITEM_NUDGE_ID: $6784cbc7d62e5d7c$export$7aa8bceae32c7862
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "navigation-profile-nav-item-wrapper-nudge-lazy",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e1b30bf1670573e8$export$3651b15d92c1c280, {
        nudgeId: (0, $6784cbc7d62e5d7c$export$7aa8bceae32c7862)
    }, children)));
$e1b30bf1670573e8$export$deb2cae843941204.displayName = 'NavigationProfileNavItemWrapperNudgeAsync';

});
parcelRegister("1jUm9", function(module, exports) {

let $0f6347f6e0a5ebd8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0f6347f6e0a5ebd8$var$load("fQ94l").then(()=>parcelRequire('doFig'));

});


parcelRegister("4QigF", function(module, exports) {

$parcel$export(module.exports, "JswOnboardingChecklist", () => $a3ce66216f7840ff$export$aea93106aaeec3fc);
$parcel$export(module.exports, "JswOnboardingButton", () => $a3ce66216f7840ff$export$c0cbc1198da400db);
$parcel$export(module.exports, "LazyOpenMenuItem", () => $a3ce66216f7840ff$export$e6a8d3e2a6acc946);
$parcel$export(module.exports, "OpenMenuItem", () => $a3ce66216f7840ff$export$67c4b22563f33286);

var $5uXOq = parcelRequire("5uXOq");

var $hYRTO = parcelRequire("hYRTO");

var $7CMCs = parcelRequire("7CMCs");

var $94Uc1 = parcelRequire("94Uc1");

var $353uQ = parcelRequire("353uQ");

var $30rnQ = parcelRequire("30rnQ");

var $iuzc0 = parcelRequire("iuzc0");

var $l8ruj = parcelRequire("l8ruj");

var $kxZPA = parcelRequire("kxZPA");

var $5Nzrp = parcelRequire("5Nzrp");

var $eIh4F = parcelRequire("eIh4F");
const $a3ce66216f7840ff$var$FallbackChecklist = ()=>{
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $353uQ.qsChecklistAutoLoadTime).start();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};
const $a3ce66216f7840ff$export$aea93106aaeec3fc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "quickstart"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "asyncChecklistComponent",
        packageName: "jiraSoftwareOnboardingQuickstart",
        teamName: "jlove-makkuro",
        fallback: "unmount",
        attributes: (0, $30rnQ.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hYRTO.default), {
        name: "software-onboarding-checklist-new",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3ce66216f7840ff$var$FallbackChecklist, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Nzrp.JswOnboardingChecklistNext), null))));
const $a3ce66216f7840ff$var$FallbackButton = ()=>{
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $353uQ.qsButtonAutoLoadTime).start();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};
const $a3ce66216f7840ff$export$c0cbc1198da400db = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "asyncChecklistButtonComponent",
        packageName: "jiraSoftwareOnboardingQuickstart",
        teamName: "jlove-makkuro",
        fallback: "unmount",
        attributes: (0, $30rnQ.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hYRTO.default), {
        name: "software-onboarding-checklist-button-new",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3ce66216f7840ff$var$FallbackButton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iuzc0.QuickstartPillVisibilityContainer), {
        scope: "ListPageQuickstartPill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eIh4F.JswOnboardingButtonNext), null))));

const $a3ce66216f7840ff$export$e6a8d3e2a6acc946 = (0, $kxZPA.lazy)(()=>(parcelRequire("4x4NO")).then(({ OpenMenuItem: OpenMenuItem })=>{
        (0, $353uQ.openMenuItemLoadTime).mark((0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_END);
        return OpenMenuItem;
    }), {
    moduleId: "./src/packages/software/onboarding-quickstart/src/ui/open-menu-item/index.tsx"
});
const $a3ce66216f7840ff$var$SubmitOpenMenuItemLoadStart = ()=>{
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $353uQ.openMenuItemLoadTime).start();
        (0, $353uQ.openMenuItemLoadTime).mark((0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_START);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};
const $a3ce66216f7840ff$export$67c4b22563f33286 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "asyncOpenMenuItemComponent",
        packageName: "jiraSoftwareOnboardingQuickstart",
        teamName: "jlove-makkuro",
        fallback: "unmount",
        attributes: (0, $30rnQ.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hYRTO.default), {
        name: "software-onboarding-checklist-open-menu-item",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3ce66216f7840ff$var$SubmitOpenMenuItemLoadStart, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3ce66216f7840ff$export$e6a8d3e2a6acc946, props)));

});
parcelRegister("353uQ", function(module, exports) {

$parcel$export(module.exports, "isMetricRunning", () => $56fd78ac33bc6df4$export$5c2d3e87043198cf);
$parcel$export(module.exports, "openMenuItemLoadTime", () => $56fd78ac33bc6df4$export$9aef270bc11ae96b);
$parcel$export(module.exports, "qsButtonAutoLoadTime", () => $56fd78ac33bc6df4$export$844f48c93ed69757);
$parcel$export(module.exports, "qsChecklistAutoLoadTime", () => $56fd78ac33bc6df4$export$c501d2dfab0e9e45);
$parcel$export(module.exports, "qsChecklistMinimiseInteraction", () => $56fd78ac33bc6df4$export$ac78fba7425e64da);
$parcel$export(module.exports, "qsChecklistDismissInteraction", () => $56fd78ac33bc6df4$export$494d4094aaa2bc4d);
$parcel$export(module.exports, "qsButtonOpenInteraction", () => $56fd78ac33bc6df4$export$da7d38041ee220c8);
$parcel$export(module.exports, "qsButtonDismissInteraction", () => $56fd78ac33bc6df4$export$ce2841e9d619cdfd);
// @ts-expect-error - TS2305 - Module '"@atlassian/browser-metrics"' has no exported member 'BaseMetric'.

var $dGrdR = parcelRequire("dGrdR");

var $94Uc1 = parcelRequire("94Uc1");
const $56fd78ac33bc6df4$export$5c2d3e87043198cf = (metric)=>metric?.state === 'started';
const $56fd78ac33bc6df4$export$9aef270bc11ae96b = (0, $dGrdR.metrics).custom({
    key: `${(0, $94Uc1.PERFORMANCE_METRIC_PREFIX)}.open.menu-item.load`,
    timings: [
        {
            key: (0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_START,
            endMark: (0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_END
        }
    ]
});
const $56fd78ac33bc6df4$export$844f48c93ed69757 = (0, $dGrdR.metrics).custom({
    key: `${(0, $94Uc1.PERFORMANCE_METRIC_PREFIX)}.button.load`,
    timings: [
        {
            key: (0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_START,
            endMark: (0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_END
        }
    ]
});
const $56fd78ac33bc6df4$export$c501d2dfab0e9e45 = (0, $dGrdR.metrics).custom({
    key: `${(0, $94Uc1.PERFORMANCE_METRIC_PREFIX)}.checklist.load`,
    timings: [
        {
            key: (0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_START,
            endMark: (0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_END
        }
    ]
});
const $56fd78ac33bc6df4$export$ac78fba7425e64da = (0, $dGrdR.metrics).interaction({
    key: `${(0, $94Uc1.PERFORMANCE_METRIC_PREFIX)}.checklist.minimize`
});
const $56fd78ac33bc6df4$export$494d4094aaa2bc4d = (0, $dGrdR.metrics).interaction({
    key: `${(0, $94Uc1.PERFORMANCE_METRIC_PREFIX)}.checklist.dismiss`
});
const $56fd78ac33bc6df4$export$da7d38041ee220c8 = (0, $dGrdR.metrics).interaction({
    key: `${(0, $94Uc1.PERFORMANCE_METRIC_PREFIX)}.button.open`
});
const $56fd78ac33bc6df4$export$ce2841e9d619cdfd = (0, $dGrdR.metrics).interaction({
    key: `${(0, $94Uc1.PERFORMANCE_METRIC_PREFIX)}.button.dismiss`
});

});

parcelRegister("iuzc0", function(module, exports) {

$parcel$export(module.exports, "QuickstartPillVisibilityContainer", () => $eb306ed6e1ecf691$export$1a5202e8ea7b76ab);
$parcel$export(module.exports, "useQuickstartPillVisibilityStore", () => $eb306ed6e1ecf691$export$70dc54081d2075ff);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $eb306ed6e1ecf691$var$actions = {
    toggleShowQuickstart: ({ showQuickstartPill: showQuickstartPill })=>({ setState: setState })=>{
            setState({
                showQuickstartPill: showQuickstartPill
            });
        }
};
const $eb306ed6e1ecf691$var$initialState = {
    showQuickstartPill: null
};
const $eb306ed6e1ecf691$var$Store = (0, $iXqE5.createStore)({
    initialState: $eb306ed6e1ecf691$var$initialState,
    actions: $eb306ed6e1ecf691$var$actions,
    name: 'JiraQuickstartPillVisibility'
});
const $eb306ed6e1ecf691$export$1a5202e8ea7b76ab = (0, $gg7kZ.createContainer)($eb306ed6e1ecf691$var$Store, {
    onInit: ()=>({ setState: setState })=>{
            setState({
                ...$eb306ed6e1ecf691$var$initialState
            });
        }
});
const $eb306ed6e1ecf691$export$70dc54081d2075ff = (0, $3sQ5x.createHook)($eb306ed6e1ecf691$var$Store);

});

parcelRegister("5Nzrp", function(module, exports) {

$parcel$export(module.exports, "JswOnboardingChecklistNext", () => $c4258442d9598a49$export$bbc4e97e9a15a84b);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $fNobW = parcelRequire("fNobW");

var $hYRTO = parcelRequire("hYRTO");

var $7CMCs = parcelRequire("7CMCs");

var $hsmeR = parcelRequire("hsmeR");

var $30rnQ = parcelRequire("30rnQ");

var $8Bc5A = parcelRequire("8Bc5A");

var $cE2Qr = parcelRequire("cE2Qr");

var $52Vcw = parcelRequire("52Vcw");

var $94Uc1 = parcelRequire("94Uc1");

var $353uQ = parcelRequire("353uQ");

var $9TQ3l = parcelRequire("9TQ3l");
const $c4258442d9598a49$export$bbc4e97e9a15a84b = ()=>{
    const [quickstartStatus] = (0, $cE2Qr.useQuickstartUiStatus)();
    const { openRightSidebar: openRightSidebar, closeRightSidebar: closeRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const currentRightSidebarState = (0, $hsmeR.useActiveRightSidebarState)();
    const currentRightSidebarPanelId = currentRightSidebarState?.panelId;
    const isRightSidePanelMinimised = currentRightSidebarState?.isMinimised ?? false;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>()=>{
            closeRightSidebar((0, $94Uc1.PANEL_ID));
            (0, $52Vcw.fireAnalyticsOnCloseRightHandSidebar)(createAnalyticsEvent, {
                quickstartStatus: quickstartStatus,
                isRightSidePanelCollapsed: isRightSidePanelMinimised,
                isRightSidePanelMinimised: isRightSidePanelMinimised,
                currentRightSidebarPanelId: currentRightSidebarPanelId || '',
                trigger: 'JswOnboardingChecklistNext'
            });
        }, // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    (0, $5uXOq.useEffect)(()=>{
        if ((quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED || quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED) && (0, $353uQ.isMetricRunning)((0, $353uQ.qsChecklistAutoLoadTime))) // QS Checklist loading cancelled for page load action
        (0, $353uQ.qsChecklistAutoLoadTime).cancel();
        if (quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED && (0, $353uQ.isMetricRunning)((0, $353uQ.qsChecklistDismissInteraction))) // User interaction completed for QS Checklist dismiss action
        (0, $353uQ.qsChecklistDismissInteraction).stop();
        if (quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED && currentRightSidebarPanelId === (0, $94Uc1.PANEL_ID)) {
            closeRightSidebar((0, $94Uc1.PANEL_ID));
            (0, $52Vcw.fireAnalyticsOnCloseRightHandSidebar)(createAnalyticsEvent, {
                quickstartStatus: quickstartStatus,
                isRightSidePanelCollapsed: isRightSidePanelMinimised,
                isRightSidePanelMinimised: isRightSidePanelMinimised,
                currentRightSidebarPanelId: currentRightSidebarPanelId || '',
                trigger: 'JswOnboardingChecklistNext'
            });
            return;
        }
        if (quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN && currentRightSidebarPanelId !== (0, $94Uc1.PANEL_ID)) {
            openRightSidebar((0, $94Uc1.PANEL_ID), (0, $94Uc1.PANEL_WIDTH));
            (0, $52Vcw.fireAnalyticsOnOpenRightHandSidebar)(createAnalyticsEvent, {
                quickstartStatus: quickstartStatus,
                isRightSidePanelCollapsed: isRightSidePanelMinimised,
                isRightSidePanelMinimised: isRightSidePanelMinimised,
                currentRightSidebarPanelId: currentRightSidebarPanelId || '',
                openRightSidebarAsMinimised: false,
                openRightSidebarToTop: false,
                trigger: 'JswOnboardingChecklistNext'
            });
        }
    }, [
        currentRightSidebarPanelId,
        openRightSidebar,
        closeRightSidebar,
        quickstartStatus,
        createAnalyticsEvent,
        isRightSidePanelMinimised
    ]);
    if (quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).NOT_LOADED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "quickstart-fetching-data"
    });
    if (quickstartStatus !== (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "internalChecklistComponent",
        packageName: "jiraSoftwareOnboardingQuickstart",
        sendToPrivacyUnsafeSplunk: true,
        teamName: "jlove-makkuro",
        fallback: "unmount",
        attributes: (0, $30rnQ.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hYRTO.default), {
        name: "software-onboarding-checklist-next",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9TQ3l.AsyncJswOnboardingChecklistInternal), null)));
};

});
parcelRegister("9TQ3l", function(module, exports) {

$parcel$export(module.exports, "AsyncJswOnboardingChecklistInternal", () => $9a33006f56b5e7d2$export$9f3262905af42485);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $94Uc1 = parcelRequire("94Uc1");

var $353uQ = parcelRequire("353uQ");

// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/deprecations/no-rll-client-async-experiences
const $9a33006f56b5e7d2$var$Checklist = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("hffkV")).then(({ JswOnboardingChecklistFinal: JswOnboardingChecklistFinal })=>{
        (0, $353uQ.qsChecklistAutoLoadTime).mark((0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_END);
        return JswOnboardingChecklistFinal;
    }), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/onboarding/onboarding-checklist-next/src/ui/onboarding-checklist/checklist/index.tsx"
});
const $9a33006f56b5e7d2$var$ChecklistInternalLoadStart = ()=>{
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $353uQ.qsChecklistAutoLoadTime).mark((0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_START);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};
const $9a33006f56b5e7d2$export$9f3262905af42485 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-onboarding-checklist-view-internal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9a33006f56b5e7d2$var$ChecklistInternalLoadStart, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9a33006f56b5e7d2$var$Checklist, null));

});
parcelRegister("hffkV", function(module, exports) {

let $c8dfbbe404e6b325$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c8dfbbe404e6b325$var$load("ffQaD"),
    $c8dfbbe404e6b325$var$load("kvRbA"),
    $c8dfbbe404e6b325$var$load("kVX56"),
    $c8dfbbe404e6b325$var$load("76n7a"),
    $c8dfbbe404e6b325$var$load("l253H"),
    $c8dfbbe404e6b325$var$load("aP74E")
]).then(()=>parcelRequire('2wwLq'));

});



parcelRegister("eIh4F", function(module, exports) {

$parcel$export(module.exports, "JswOnboardingButtonNext", () => $51c1715fc5801c45$export$bc3535037a418fa9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2NMNM = parcelRequire("2NMNM");

var $7CMCs = parcelRequire("7CMCs");

var $hsmeR = parcelRequire("hsmeR");

var $ACELo = parcelRequire("ACELo");

var $94Uc1 = parcelRequire("94Uc1");

var $353uQ = parcelRequire("353uQ");

var $30rnQ = parcelRequire("30rnQ");

var $8Bc5A = parcelRequire("8Bc5A");

var $1ffS1 = parcelRequire("1ffS1");

var $cE2Qr = parcelRequire("cE2Qr");

var $52Vcw = parcelRequire("52Vcw");

var $6jY6G = parcelRequire("6jY6G");

var $iuzc0 = parcelRequire("iuzc0");

var $ieDtd = parcelRequire("ieDtd");

var $lysGg = parcelRequire("lysGg");
const $51c1715fc5801c45$export$7127386abbb0f79c = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const [selectedIssueValue] = (0, $ieDtd.useQueryParam)('selectedIssue');
    const [viewValue] = (0, $ieDtd.useQueryParam)('view');
    const isInRoadMapRoute = (0, $1ffS1.isRoadmapRoute)(route?.name);
    const isInBacklogRoute = route?.name === 'software-backlog';
    const isInBoardRoute = route?.name === 'software-boards';
    const isInRapidBoardBacklogRoute = route?.name === 'rapidboard-backlog';
    const isInRapidBoardBoardRoute = route?.name === 'rapidboard-board';
    // CMP & TMP Roadmap, and TMP backlog & board use selectedIssue query param
    if ((isInRoadMapRoute || isInBacklogRoute || isInBoardRoute) && Boolean(selectedIssueValue)) return true;
    // CMP backlog use view="detail" query param
    // (detail view can be triggered from the meatball menu on the issue modal)
    if (isInRapidBoardBacklogRoute) return viewValue === 'detail';
    // CMP Active Sprints and Kanban board uses view=detail query param
    // (detail view can be triggered from the meatball menu on the issue modal)
    if (isInRapidBoardBoardRoute && viewValue === 'detail') return true;
    return false;
};
const $51c1715fc5801c45$export$bc3535037a418fa9 = ()=>{
    const [quickstartStatus] = (0, $cE2Qr.useQuickstartUiStatus)();
    const isIssueViewOpened = $51c1715fc5801c45$export$7127386abbb0f79c();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { openRightSidebar: openRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const currentRightSidebarState = (0, $hsmeR.useActiveRightSidebarState)();
    const isRightSidePanelMinimised = currentRightSidebarState?.isMinimised ?? false;
    const currentRightSidebarPanelId = currentRightSidebarState?.panelId;
    const [{ showQuickstartPill: showQuickstartPill }] = (0, $iuzc0.useQuickstartPillVisibilityStore)();
    (0, $5uXOq.useEffect)(()=>{
        if ((quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED || quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN) && (0, $353uQ.isMetricRunning)((0, $353uQ.qsButtonAutoLoadTime))) // QS Button loading cancelled for page load action
        (0, $353uQ.qsButtonAutoLoadTime).cancel();
        if (quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED && (0, $353uQ.isMetricRunning)((0, $353uQ.qsButtonDismissInteraction))) // User interaction completed for QS Button dismiss action
        (0, $353uQ.qsButtonDismissInteraction).stop();
        if (quickstartStatus !== (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED) return;
        // check if quickstart panel is already shown in minimised state in right-hand sidebar
        if (currentRightSidebarPanelId === (0, $94Uc1.PANEL_ID) && isRightSidePanelMinimised === true) return;
        openRightSidebar((0, $94Uc1.PANEL_ID), (0, $94Uc1.PANEL_WIDTH), true);
        (0, $52Vcw.fireAnalyticsOnOpenRightHandSidebar)(createAnalyticsEvent, {
            quickstartStatus: quickstartStatus,
            isRightSidePanelCollapsed: isRightSidePanelMinimised,
            isRightSidePanelMinimised: isRightSidePanelMinimised,
            currentRightSidebarPanelId: currentRightSidebarPanelId || '',
            openRightSidebarAsMinimised: true,
            openRightSidebarToTop: false,
            trigger: 'JswOnboardingButtonNext'
        });
    }, [
        isRightSidePanelMinimised,
        openRightSidebar,
        currentRightSidebarPanelId,
        quickstartStatus,
        createAnalyticsEvent
    ]);
    if (quickstartStatus !== (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED || showQuickstartPill !== null && !showQuickstartPill && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.pathname.endsWith('/list')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "internalChecklistButtonComponent",
        packageName: "jiraSoftwareOnboardingQuickstart",
        sendToPrivacyUnsafeSplunk: true,
        teamName: "jlove-makkuro",
        fallback: "unmount",
        attributes: (0, $30rnQ.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ACELo.JiraBottomRightCornerOutlet), {
        orderFromRight: 1,
        id: "software-onboarding-quickstart-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($51c1715fc5801c45$var$QuickstartButtonContainer, {
        isIssueViewOpened: isIssueViewOpened,
        "data-testid": "software-onboarding-quickstart.ui.onboarding-button.onboarding-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lysGg.JswOnboardingChecklistButton), null))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $51c1715fc5801c45$var$QuickstartButtonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isIssueViewOpened: isIssueViewOpened, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isIssueViewOpened ? "_1e0cglyw" : "_1e0c1kw7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ACELo", function(module, exports) {

$parcel$export(module.exports, "JiraBottomRightCornerOutlet", () => $8d24666022201b4c$export$ee54e6ed235df65e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7nsd3 = parcelRequire("7nsd3");

var $b71gk = parcelRequire("b71gk");

var $hvrWv = parcelRequire("hvrWv");
const $8d24666022201b4c$var$OutletWithPortal = ({ orderFromRight: orderFromRight, children: children, id: id })=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const portalWrapper = (0, $5uXOq.useRef)(document.createElement('div'));
    const container = (0, $hvrWv.useBottomRightCornerContainer)();
    if (!container) throw new Error('GlobalBottomRightContainer could not be found. Please ensure that this container was rendered on the page.');
    const { insertBottomRightCornerPortal: insertBottomRightCornerPortal, removeBottomRightCornerPortal: removeBottomRightCornerPortal } = (0, $hvrWv.useBottomRightCornerActions)();
    (0, $5uXOq.useEffect)(()=>{
        if (container) {
            const indexToRender = insertBottomRightCornerPortal({
                orderFromRight: orderFromRight,
                id: id
            });
            // @ts-expect-error - TS2538 - Type 'Promise<void>' cannot be used as an index type. | TS2538 - Type 'void' cannot be used as an index type.
            container.insertBefore(portalWrapper.current, container.children[indexToRender]);
        }
        // required as eslint complains about the ref in cleanup function
        const portalCurrent = portalWrapper.current;
        return ()=>{
            container?.removeChild(portalCurrent);
            removeBottomRightCornerPortal(id);
        };
    }, [
        container,
        id,
        orderFromRight,
        insertBottomRightCornerPortal,
        removeBottomRightCornerPortal
    ]);
    return /*#__PURE__*/ (0, $7nsd3.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8d24666022201b4c$var$StyledOutlet, null, children), portalWrapper.current);
};
const $8d24666022201b4c$export$ee54e6ed235df65e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "bottom-right-corner-outlet",
        packageName: "jira-bottom-right-corner-controller",
        extraEventData: {
            portalId: props.id
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8d24666022201b4c$var$OutletWithPortal, props));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8d24666022201b4c$var$StyledOutlet = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1vgl1wug _1ko9pxbi",
            __cmplp.className
        ])
    });
});

});

parcelRegister("lysGg", function(module, exports) {

$parcel$export(module.exports, "JswOnboardingChecklistButton", () => $abb3d5d8a2c0e8b0$export$235000cc42ca709a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1RztZ = parcelRequire("1RztZ");

var $2NMNM = parcelRequire("2NMNM");

var $hsmeR = parcelRequire("hsmeR");

var $94Uc1 = parcelRequire("94Uc1");

var $353uQ = parcelRequire("353uQ");


var $8Bc5A = parcelRequire("8Bc5A");

var $izv86 = parcelRequire("izv86");

var $cE2Qr = parcelRequire("cE2Qr");

var $4R6GH = parcelRequire("4R6GH");

var $52Vcw = parcelRequire("52Vcw");

var $2OMDV = parcelRequire("2OMDV");
var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");


var $4i99S = parcelRequire("4i99S");
const $abb3d5d8a2c0e8b0$var$ChecklistButtonAnaylticsWrapper = (0, $2OMDV.AnalyticsEventToProps)('button', {
    onClick: 'clicked'
})((0, $1RztZ.default));
const $abb3d5d8a2c0e8b0$export$235000cc42ca709a = ()=>{
    const currentRightSidebarState = (0, $hsmeR.useActiveRightSidebarState)();
    const [, { nextSetChecklistIsDismissed: nextSetChecklistIsDismissed, setNudgeStep: setNudgeStep, setHasNudgeActive: setHasNudgeActive }] = (0, $cE2Qr.useQuickstartActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const openChecklist = (0, $4i99S.useOpenChecklist)();
    const [quickstartStatus] = (0, $cE2Qr.useQuickstartUiStatus)();
    const [remoteStateFromHook] = (0, $cE2Qr.useJswOnboarding)();
    const currentRightSidebarPanelId = currentRightSidebarState?.panelId;
    const onDismiss = (0, $5uXOq.useCallback)((e)=>{
        e.preventDefault();
        (0, $353uQ.qsButtonDismissInteraction).start();
        nextSetChecklistIsDismissed(true);
        setNudgeStep((0, $6784cbc7d62e5d7c$export$7aa8bceae32c7862));
        setHasNudgeActive(true);
        const analyticsEvent = createAnalyticsEvent({});
        (0, $52Vcw.fireAnalyticsOnQuickstartDismiss)(analyticsEvent, {
            projectId: remoteStateFromHook.projectState?.projectId,
            productType: (0, $izv86.getProductType)(remoteStateFromHook.projectState?.projectType)
        }, 'button');
    }, [
        createAnalyticsEvent,
        nextSetChecklistIsDismissed,
        setNudgeStep,
        setHasNudgeActive,
        remoteStateFromHook
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if ((0, $353uQ.isMetricRunning)((0, $353uQ.qsButtonAutoLoadTime))) // QS Button loading completed on page load action
        (0, $353uQ.qsButtonAutoLoadTime).stop();
        if ((0, $353uQ.isMetricRunning)((0, $353uQ.qsChecklistMinimiseInteraction))) // User interaction completed for QS Checklist minimise action
        (0, $353uQ.qsChecklistMinimiseInteraction).stop();
    }, []);
    const projectKey = remoteStateFromHook.projectState?.projectKey;
    if (projectKey && (0, $8Bc5A.SAMPLE_DATA_PROJECT_KEYS_TO_HIDE_ON).includes(projectKey) && (0, $4R6GH.fg)('jfind-mature-example-project-gate')) return;
    if (currentRightSidebarPanelId !== (0, $94Uc1.PANEL_ID)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abb3d5d8a2c0e8b0$var$TriggerWrapper, {
        reposition: quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$9d2de6eebf7462b5),
        sourceName: (0, $8e02302c3f52a3b4$export$75cc63c8ac8ae533)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            projectId: remoteStateFromHook.projectState?.projectId,
            productType: (0, $izv86.getProductType)(remoteStateFromHook.projectState?.projectType)
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abb3d5d8a2c0e8b0$var$ChecklistButtonAnaylticsWrapper, {
        isOpen: quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED,
        title: "Quickstart",
        onClick: (event, analyticsEvent)=>{
            (0, $353uQ.qsButtonOpenInteraction).start();
            openChecklist({
                trigger: 'JswOnboardingChecklistButton'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, (0, $8e02302c3f52a3b4$export$75cc63c8ac8ae533), {
                projectId: remoteStateFromHook.projectState?.projectId,
                productType: (0, $izv86.getProductType)(remoteStateFromHook.projectState?.projectType)
            });
        },
        onDismiss: onDismiss
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $abb3d5d8a2c0e8b0$var$TriggerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { reposition: reposition, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v564vccv _syaz1gjq _80omtlke",
            __cmplp.reposition ? "_otyr8vuz" : "_otyridpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2OMDV", function(module, exports) {

$parcel$export(module.exports, "AnalyticsEventToProps", () => $28422a5dfa4a4065$export$3e9ef96ba97ea9dc);

var $cb25w = parcelRequire("cb25w");
const $28422a5dfa4a4065$export$871de8747c9eaa88 = (props, componentName)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [key]: {
                action: props[key],
                actionSubject: componentName
            }
        }), {});
const $28422a5dfa4a4065$export$3e9ef96ba97ea9dc = (componentName, eventActions)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (WrappedComponent)=>(0, $cb25w.default)($28422a5dfa4a4065$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);

});

// Used for analytics event context for secondary (floating button) view
const $8e02302c3f52a3b4$export$75cc63c8ac8ae533 = 'nuxOnboardingQuickstartButton';



parcelRegister("4x4NO", function(module, exports) {

let $34cdf82c7fb01ce6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $34cdf82c7fb01ce6$var$load("gUkrx").then(()=>parcelRequire('jVPxT'));

});


parcelRegister("1yM7R", function(module, exports) {

$parcel$export(module.exports, "useUserBoardId", () => $c7748d5d5fa92b7a$export$e6e895063f36c814);

var $5uXOq = parcelRequire("5uXOq");

var $eusud = parcelRequire("eusud");

var $6yXtV = parcelRequire("6yXtV");
const $c7748d5d5fa92b7a$export$e6e895063f36c814 = (shouldRun)=>{
    const [{ isReady: isReady }] = (0, $6yXtV.useSpaStatePageReady)();
    const [userBoard, setUserBoard] = (0, $5uXOq.useState)(null);
    const shouldFetch = shouldRun || isReady;
    (0, $5uXOq.useEffect)(()=>{
        if (!shouldFetch || userBoard) return;
        setUserBoard(null);
        const requestUrl = '/rest/greenhopper/1.0/rapidviews/recent?maxResults=1&userBoard=true';
        (0, $eusud.performGetRequest)(requestUrl).then((result)=>{
            const [board] = result.views;
            if (board) setUserBoard(board);
        }).catch(()=>{
        // user board fetch failed, ignore
        });
    }, [
        shouldFetch,
        userBoard,
        setUserBoard
    ]);
    return userBoard && userBoard.location ? [
        userBoard.id,
        userBoard.location.accountId
    ] : [
        null,
        null
    ];
};

});

parcelRegister("k7xP2", function(module, exports) {

$parcel$export(module.exports, "MenuNav4", () => $b62ef795f8dd8307$export$60113ca6a29c7a92);
/* main-nav4.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $4mNf3 = parcelRequire("4mNf3");
var $9UCCQ = parcelRequire("9UCCQ");

var $2vSU6 = parcelRequire("2vSU6");

var $3bQtK = parcelRequire("3bQtK");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $dAfqg = parcelRequire("dAfqg");

var $lyCs2 = parcelRequire("lyCs2");


var $jrUuh = parcelRequire("jrUuh");

var $4QigF = parcelRequire("4QigF");

var $Mp6qH = parcelRequire("Mp6qH");

var $d4B4Y = parcelRequire("d4B4Y");

var $7ilb8 = parcelRequire("7ilb8");

var $dgPkW = parcelRequire("dgPkW");

var $cEIWv = parcelRequire("cEIWv");


const $b62ef795f8dd8307$var$StandardToPremiumPubTouchpoint = (parcelRequire("jEtPS")).default;
const $b62ef795f8dd8307$export$60113ca6a29c7a92 = ({ testIdPrefix: testIdPrefix, userBoardId: userBoardId, userBoardOwnerAccountId: userBoardOwnerAccountId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    (0, $5uXOq.useEffect)(()=>{
        onSuccess();
    }, [
        onSuccess
    ]);
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'menu-popup');
    const testIdContent = (0, $6cNb0.testIdConcat)(testId, 'content');
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const [{ data: jsmOnboardingData }, { fetchOnboardingType: fetchOnboardingType }] = (0, $jrUuh.useJsmOnboardingType)();
    (0, $5uXOq.useEffect)(()=>{
        fetchOnboardingType(projectContextData?.projectId, projectContextData?.projectType);
    }, [
        fetchOnboardingType,
        projectContextData?.projectId,
        projectContextData?.projectType
    ]);
    const showInJwmProjects = projectContextData?.projectType === (0, $2vSU6.CORE_PROJECT);
    const showInSoftwareProjects = projectContextData?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    const showInJsmProjects = projectContextData?.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) && jsmOnboardingData?.onboardingType === (0, $e7830161eb8674f1$export$6f454e69bce3a691);
    let yourBoardsRoute;
    let yourBoardsParams;
    let yourBoardsQuery;
    if (userBoardId != null) {
        yourBoardsRoute = (0, $lyCs2.userBoardRoute);
        yourBoardsParams = {
            accountId: userBoardOwnerAccountId,
            boardId: String(userBoardId)
        };
    }
    const boardOffset = userBoardId == null ? -1 : 0;
    const showQuickstartOpenMenuItem = showInJwmProjects || showInSoftwareProjects || showInJsmProjects;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuList), null, showQuickstartOpenMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4QigF.OpenMenuItem), {
        MenuItem: (0, $d4B4Y.MenuItem)
    }), userBoardId !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        hasSeparator: true,
        testId: testIdContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": (0, $6cNb0.testIdConcat)(testIdContent, 'jira')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4mNf3.default), {
        testId: (0, $6cNb0.testIdConcat)(testIdContent, 'jira', 'heading')
    }, formatMessage((0, $cEIWv.default).jira)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
        ariaLabel: formatMessage((0, $cEIWv.default).jira)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: 'your-boards',
            menuItemType: 'jira',
            position: 1
        },
        href: `/jira/people/${String(userBoardOwnerAccountId)}/boards/${userBoardId}`,
        params: yourBoardsParams,
        query: yourBoardsQuery,
        testId: (0, $6cNb0.testIdConcat)(testIdContent, 'jira', 'item-your-boards'),
        to: yourBoardsRoute
    }, formatMessage((0, $cEIWv.default).yourBoards))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b62ef795f8dd8307$var$StandardToPremiumPubTouchpoint, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dgPkW.ExtraItemsNav4), {
        startPosition: 5 + boardOffset,
        testIdPrefix: testIdContent,
        itemAriaLabel: formatMessage((0, $cEIWv.default).jira)
    }));
};

});
const $e7830161eb8674f1$export$6f454e69bce3a691 = 'business';
const $e7830161eb8674f1$export$e6952b12ade67489 = 'default';

parcelRegister("jrUuh", function(module, exports) {

$parcel$export(module.exports, "useJsmOnboardingType", () => $664311160f9d0bff$export$5daaa68c3a578af9);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $gcnn5 = parcelRequire("gcnn5");
const $664311160f9d0bff$export$d4c72bab9d6cc13a = {
    projectId: undefined,
    data: undefined,
    error: undefined,
    isLoading: false
};
const $664311160f9d0bff$var$Store = (0, $iXqE5.createStore)({
    initialState: $664311160f9d0bff$export$d4c72bab9d6cc13a,
    actions: $gcnn5.actions,
    name: 'JSMOnboardingType'
});
const $664311160f9d0bff$export$5daaa68c3a578af9 = (0, $3sQ5x.createHook)($664311160f9d0bff$var$Store);

});
parcelRegister("gcnn5", function(module, exports) {

$parcel$export(module.exports, "actions", () => $efcda9e0ca78f7c5$export$e324594224ef24da);

var $5R3PH = parcelRequire("5R3PH");
const $efcda9e0ca78f7c5$export$e324594224ef24da = {
    fetchOnboardingType: $5R3PH.fetchOnboardingType
};

});
parcelRegister("5R3PH", function(module, exports) {

$parcel$export(module.exports, "fetchOnboardingType", () => $a0d1630df8d288ca$export$ea62467635172b55);

var $2vSU6 = parcelRequire("2vSU6");

var $7f4tk = parcelRequire("7f4tk");
const $a0d1630df8d288ca$var$getOnboardingTypeUrl = (projectId)=>`/rest/servicedesk/onboarding/1/onboarding-type/project/${projectId}`;
const $a0d1630df8d288ca$export$ea62467635172b55 = (projectId, projectType)=>async ({ getState: getState, setState: setState })=>{
        if (!projectId || projectType !== (0, $2vSU6.SERVICE_DESK_PROJECT)) return;
        const { data: data, isLoading: isLoading, projectId: oldProjectId } = getState();
        if (projectId !== oldProjectId) setState({
            data: undefined,
            projectId: undefined
        });
        if (data || isLoading) return;
        setState({
            projectId: projectId,
            isLoading: true,
            error: undefined
        });
        try {
            const onboardingTypeResponse = await (0, $7f4tk.default)($a0d1630df8d288ca$var$getOnboardingTypeUrl(String(projectId)));
            setState({
                isLoading: false,
                data: onboardingTypeResponse
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                isLoading: false,
                error: error
            });
        }
    };

});



parcelRegister("d4B4Y", function(module, exports) {

$parcel$export(module.exports, "MenuItem", () => $ac79b65b740c9d18$export$2ce376c2cc3355c8);

var $5uXOq = parcelRequire("5uXOq");

var $kJpBP = parcelRequire("kJpBP");

var $jngLf = parcelRequire("jngLf");

var $9YfZr = parcelRequire("9YfZr");

var $6oGXD = parcelRequire("6oGXD");
const $ac79b65b740c9d18$export$2ce376c2cc3355c8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ analytics: analytics, href: href, onClick: onClick, params: params, query: query, replace: replace, target: target, to: to, type: type, ...rest }, ref)=>{
    const onClickHandler = (0, $6oGXD.useOnClick)({
        onClick: onClick,
        analytics: analytics
    });
    if (to != null && __SPA__) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9YfZr.RouteLinkItem), {
        ref: ref,
        onClick: onClickHandler,
        params: params,
        query: query,
        replace: replace,
        target: target,
        to: to,
        type: type,
        ...rest
    });
    return href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jngLf.LinkItem), {
        ref: ref,
        href: href,
        target: target,
        onClick: onClickHandler,
        ...rest
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        ref: ref,
        onClick: onClickHandler,
        ...rest
    });
});

});
parcelRegister("jngLf", function(module, exports) {

$parcel$export(module.exports, "LinkItem", () => $3ef5556c5063294d$export$532cb6865ebe8946);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $1aogK = parcelRequire("1aogK");
var $3Z96c = parcelRequire("3Z96c");

var $4R6GH = parcelRequire("4R6GH");

var $iMorU = parcelRequire("iMorU");

var $gRLNg = parcelRequire("gRLNg");
const $3ef5556c5063294d$var$AkLinkWithUnwrappedInteractiveChildren = (0, $iMorU.WithUnwrappedInteractiveChildren)((0, $3Z96c.default));
const $3ef5556c5063294d$export$532cb6865ebe8946 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ href: href, target: target, onClick: onClick, ...rest }, ref)=>{
    const Item = (0, $4R6GH.fg)('jfp-a11y-team_interactive-elements-nesting') ? (0, $1aogK.default) : $3ef5556c5063294d$export$8c0773eab230d49e;
    const navigate = (0, $gRLNg.useNavigate)({
        href: href,
        onClick: onClick,
        target: target
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Item, {
        ...(0, $4R6GH.fg)('jfp-a11y-team_interactive-elements-nesting') && {
            component: $3ef5556c5063294d$var$AkLinkWithUnwrappedInteractiveChildren
        },
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : '',
        onClick: navigate,
        ref: ref,
        ...rest
    });
});
const $3ef5556c5063294d$export$8c0773eab230d49e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $3Z96c.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1nrm18uv _1a3b18uv _9oik18uv _c2wa1kw7 _4fpr1kw7 _1bnx1kw7 _1iohnqa1 _5goinqa1 _jf4cnqa1 _9h8h1kw7 _f8pj1kw7 _30l31kw7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iMorU", function(module, exports) {

$parcel$export(module.exports, "WithUnwrappedInteractiveChildren", () => $92ab6ba4ea3c960d$export$aecb71b5768388c7);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
const $92ab6ba4ea3c960d$var$MenuItemCss = null;
const $92ab6ba4ea3c960d$var$StretchedBlanketCss = null;
// This blank space is needed to enforce React Router to render the empty anchor tag
const $92ab6ba4ea3c960d$var$BLANKET_CONTENT = ' ';
const $92ab6ba4ea3c960d$export$aecb71b5768388c7 = (InteractiveBlanket)=>/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, className: className, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            className: (0, $bwpsq.default)([
                "_kqswh2mm",
                className
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(InteractiveBlanket, {
            ref: ref,
            ...props,
            className: (0, $bwpsq.default)([
                "_kqswstnw _1bsb1osq _4t3i1osq _154ize3t _1ltvze3t _1cwg1i6y _13ro1i6y _1bg41i6y _1ah31i6y"
            ])
        }, $92ab6ba4ea3c960d$var$BLANKET_CONTENT), children));

});

parcelRegister("gRLNg", function(module, exports) {

$parcel$export(module.exports, "useNavigate", () => $f019fb7f0ef5833c$export$9770f232ac06a008);

var $5uXOq = parcelRequire("5uXOq");

var $lVJAU = parcelRequire("lVJAU");
const $f019fb7f0ef5833c$export$9770f232ac06a008 = ({ href: href, target: target, onClick: onClick, useRouterActions: // eslint-disable-next-line react-hooks/react-compiler
useRouterActions = (0, $lVJAU.useRouterActions), useCallback: // eslint-disable-next-line react-hooks/react-compiler
useCallback = (0, $5uXOq.useCallback) })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const { push: push } = useRouterActions();
    // eslint-disable-next-line react-hooks/react-compiler
    return useCallback((event)=>{
        onClick && onClick(event);
        if (event.ctrlKey || event.metaKey || event.defaultPrevented || target === '_blank') return;
        event.preventDefault();
        push(href);
    }, [
        push,
        href,
        target,
        onClick
    ]);
};

});


parcelRegister("9YfZr", function(module, exports) {

$parcel$export(module.exports, "RouteLinkItem", () => $3031a27cd367c26b$export$5885e1e37551a766);

var $5uXOq = parcelRequire("5uXOq");

var $1aogK = parcelRequire("1aogK");

var $4R6GH = parcelRequire("4R6GH");

var $hjSul = parcelRequire("hjSul");

var $iMorU = parcelRequire("iMorU");
const $3031a27cd367c26b$var$LinkWithUnwrappedInteractiveChildren = (0, $iMorU.WithUnwrappedInteractiveChildren)((0, $hjSul.Link));
const $3031a27cd367c26b$export$5885e1e37551a766 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ rel: rel, target: target, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1aogK.default), {
        component: (0, $4R6GH.fg)('jfp-a11y-team_interactive-elements-nesting') ? $3031a27cd367c26b$var$LinkWithUnwrappedInteractiveChildren : (0, $hjSul.Link),
        rel: rel ?? (target === '_blank' ? 'noopener noreferrer' : ''),
        target: target,
        prefetch: "hover",
        ref: ref,
        ...props
    }));

});

parcelRegister("6oGXD", function(module, exports) {

$parcel$export(module.exports, "useOnClick", () => $a8a7ed1bfe9b49e0$export$a81c45382e7253ac);

var $2bzBV = parcelRequire("2bzBV");

var $2Ui4E = parcelRequire("2Ui4E");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $a8a7ed1bfe9b49e0$export$a81c45382e7253ac = ({ analytics: analytics, fireUIAnalytics: fireUIAnalytics = (0, $8zOmE.fireUIAnalytics), onClick: onClick, useAnalyticsEvents: // eslint-disable-next-line react-hooks/react-compiler
useAnalyticsEvents = (0, $2NMNM.useAnalyticsEvents), useOverflowStatus: // eslint-disable-next-line react-hooks/react-compiler
useOverflowStatus = (0, $2bzBV.useOverflowStatus), useTopMenus: // eslint-disable-next-line react-hooks/react-compiler
useTopMenus = (0, $2Ui4E.useTopMenus) } = {})=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const [, { off: closeMenu }] = useTopMenus();
    // eslint-disable-next-line react-hooks/react-compiler
    const { isVisible: isVisible, closeOverflowMenu: closeOverflowMenu } = useOverflowStatus();
    // eslint-disable-next-line react-hooks/react-compiler
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const { actionSubjectId: actionSubjectId, ...analyticsRest } = analytics;
    return (event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationMenuItem'
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        fireUIAnalytics(analyticsEvent, actionSubjectId, {
            ...analyticsRest,
            isInMore: !isVisible
        });
        onClick && onClick(event);
        if (event.ctrlKey || event.metaKey) return;
        closeMenu();
        closeOverflowMenu();
    };
};

});


parcelRegister("7ilb8", function(module, exports) {

$parcel$export(module.exports, "MenuList", () => $44f127900c12f92a$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "MenuListItem", () => $44f127900c12f92a$export$6c2f3257abc4825b);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $44f127900c12f92a$export$d4c4e98c5044dc8 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "ul",
        xcss: $44f127900c12f92a$var$removeDefaultListStyles
    }, children);
const $44f127900c12f92a$export$6c2f3257abc4825b = ({ children: children, ariaLabel: ariaLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "li",
        xcss: $44f127900c12f92a$var$removeDefaultListStyles,
        "aria-label": ariaLabel
    }, children);
const $44f127900c12f92a$var$removeDefaultListStyles = (0, $8CUq3.xcss)({
    padding: 'space.0',
    margin: 'space.0'
});

});

parcelRegister("dgPkW", function(module, exports) {

$parcel$export(module.exports, "ExtraItems", () => $78c0b34ec312aabb$export$56021421a935c353);
$parcel$export(module.exports, "ExtraItemsNav4", () => $78c0b34ec312aabb$export$ee2972db91c46b97);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $9UCCQ = parcelRequire("9UCCQ");

var $hrlU6 = parcelRequire("hrlU6");

var $6cNb0 = parcelRequire("6cNb0");

var $atU1t = parcelRequire("atU1t");

var $2YP9W = parcelRequire("2YP9W");

var $d4B4Y = parcelRequire("d4B4Y");

var $7ilb8 = parcelRequire("7ilb8");
const $78c0b34ec312aabb$var$useConnectItems = ()=>{
    const { data: resourceData, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)((0, $atU1t.navigationSidebarGlobalResource));
    const data = resourceData?.response;
    (0, $5uXOq.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        error,
        loading,
        refresh
    ]);
    return data ? (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(data, 'global.profile.items', []).filter((item)=>![
            'view_profile',
            'log_out'
        ].includes(item.id)) : [];
};
const $78c0b34ec312aabb$var$Item = ({ url: url, name: name, id: id, styleClass: styleClass, itemAriaLabel: itemAriaLabel, position: position, testId: testId })=>{
    const webItemRef = (0, $5uXOq.useRef)(null);
    const isDialog = styleClass && (0, $hrlU6.isConnectDialogWebItem)(styleClass);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (isDialog) (0, $hrlU6.withConnectHost)((connectHost)=>{
            if (styleClass && webItemRef.current) connectHost.triggerWebItem(webItemRef.current, styleClass, url);
        });
    }, [
        isDialog,
        styleClass,
        url
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
        key: url,
        ariaLabel: itemAriaLabel || ''
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        ref: webItemRef,
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: id,
            menuItemType: 'jira',
            position: position
        },
        href: isDialog ? undefined : url,
        onClick: isDialog ? onClick : undefined,
        testId: testId
    }, name));
};
const $78c0b34ec312aabb$export$56021421a935c353 = ({ startPosition: startPosition, testIdPrefix: testIdPrefix, itemAriaLabel: itemAriaLabel })=>{
    const connectItems = $78c0b34ec312aabb$var$useConnectItems();
    if (!connectItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, connectItems.map(({ id: id, name: name, url: url, styleClass: styleClass }, idx)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($78c0b34ec312aabb$var$Item, {
            key: url,
            url: url,
            name: name,
            id: id,
            styleClass: styleClass,
            itemAriaLabel: itemAriaLabel,
            position: startPosition + idx,
            testId: (0, $6cNb0.testIdConcat)(testIdPrefix, `item-addon-${idx}`)
        });
    }));
};
const $78c0b34ec312aabb$export$ee2972db91c46b97 = ({ startPosition: startPosition, testIdPrefix: testIdPrefix, itemAriaLabel: itemAriaLabel })=>{
    const connectItems = $78c0b34ec312aabb$var$useConnectItems();
    if (!connectItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        hasSeparator: true
    }, connectItems.map(({ id: id, name: name, url: url, styleClass: styleClass }, idx)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($78c0b34ec312aabb$var$Item, {
            key: url,
            url: url,
            name: name,
            id: id,
            styleClass: styleClass,
            itemAriaLabel: itemAriaLabel,
            position: startPosition + idx,
            testId: (0, $6cNb0.testIdConcat)(testIdPrefix, `item-addon-${idx}`)
        });
    }));
};

});

parcelRegister("cEIWv", function(module, exports) {

$parcel$export(module.exports, "default", () => $521f3eedcdcca1a6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $521f3eedcdcca1a6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    giveFeedback: {
        "id": "atlassian-navigation.profile.menu.give-feedback",
        "defaultMessage": "Give us feedback"
    },
    yourBoards: {
        "id": "atlassian-navigation.profile.menu.your-boards",
        "defaultMessage": "Your boards"
    },
    new: {
        "id": "atlassian-navigation.profile.menu.new",
        "defaultMessage": "new"
    },
    personalSettings: {
        "id": "atlassian-navigation.profile.menu.personal-settings",
        "defaultMessage": "Personal settings"
    },
    logout: {
        "id": "atlassian-navigation.profile.menu.logout",
        "defaultMessage": "Log out"
    },
    jira: {
        "id": "atlassian-navigation.profile.menu.jira",
        "defaultMessage": "Jira"
    },
    account: {
        "id": "atlassian-navigation.profile.menu.account",
        "defaultMessage": "Account"
    },
    profile: {
        "id": "atlassian-navigation.profile.menu.profile",
        "defaultMessage": "Profile"
    },
    notifications: {
        "id": "atlassian-navigation.profile.menu.notifications",
        "defaultMessage": "Notifications"
    }
});

});

parcelRegister("jEtPS", function(module, exports) {

module.exports = (parcelRequire("avM1e"))('edition_awareness_upsell_jira_ab_fg', function() {
    return parcelRequire('lwZRC');
}, function() {
    return parcelRequire('973dN');
});

});


parcelRegister("ebznH", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $32d3ea680525e18b$export$d9b273488cd8ce6f);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $jZ4fr = parcelRequire("jZ4fr");

var $aYAc3 = parcelRequire("aYAc3");

var $4mNf3 = parcelRequire("4mNf3");
var $9UCCQ = parcelRequire("9UCCQ");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $ixNeq = parcelRequire("ixNeq");

var $2vSU6 = parcelRequire("2vSU6");

var $3bQtK = parcelRequire("3bQtK");

var $koVbs = parcelRequire("koVbs");

var $2EqxS = parcelRequire("2EqxS");

var $6cNb0 = parcelRequire("6cNb0");

var $1C2yb = parcelRequire("1C2yb");

var $cYlk7 = parcelRequire("cYlk7");

var $dAfqg = parcelRequire("dAfqg");

var $fDWVs = parcelRequire("fDWVs");

var $7ziML = parcelRequire("7ziML");

var $d1xZH = parcelRequire("d1xZH");

var $lyCs2 = parcelRequire("lyCs2");


var $jrUuh = parcelRequire("jrUuh");

var $4QigF = parcelRequire("4QigF");

var $90yGq = parcelRequire("90yGq");

var $Mp6qH = parcelRequire("Mp6qH");

var $d4B4Y = parcelRequire("d4B4Y");

var $ag3sS = parcelRequire("ag3sS");

var $7ilb8 = parcelRequire("7ilb8");

var $5DUZ0 = parcelRequire("5DUZ0");

var $dgPkW = parcelRequire("dgPkW");

var $4WZuY = parcelRequire("4WZuY");

var $cEIWv = parcelRequire("cEIWv");

var $fUv6Z = parcelRequire("fUv6Z");


const $32d3ea680525e18b$var$UpgradeEditionMenuItem = (parcelRequire("d7AIY")).default;


const $32d3ea680525e18b$var$StandardToPremiumPubTouchpoint = (parcelRequire("jEtPS")).default;
const $32d3ea680525e18b$export$d9b273488cd8ce6f = ({ testIdPrefix: testIdPrefix, userBoardId: userBoardId, userBoardOwnerAccountId: userBoardOwnerAccountId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: { user: user } } = (0, $cYlk7.useCurrentUser)();
    const accountId = (0, $90yGq.useAccountId)();
    const profileLink = (0, $2EqxS.useProfileLink)();
    const onSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    (0, $5uXOq.useEffect)(()=>{
        onSuccess();
    }, [
        onSuccess
    ]);
    const profileParams = {
        subPath: accountId
    };
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'menu-popup');
    const testIdContent = (0, $6cNb0.testIdConcat)(testId, 'content');
    const testIdFooter = (0, $6cNb0.testIdConcat)(testId, 'footer');
    const [upgradeEditionMenuShown, setUpgradeEditionMenuShown] = (0, $5uXOq.useState)(false);
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const [{ data: jsmOnboardingData }, { fetchOnboardingType: fetchOnboardingType }] = (0, $jrUuh.useJsmOnboardingType)();
    (0, $5uXOq.useEffect)(()=>{
        fetchOnboardingType(projectContextData?.projectId, projectContextData?.projectType);
    }, [
        fetchOnboardingType,
        projectContextData?.projectId,
        projectContextData?.projectType
    ]);
    const showInJwmProjects = projectContextData?.projectType === (0, $2vSU6.CORE_PROJECT);
    const showInSoftwareProjects = projectContextData?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    const showInJsmProjects = projectContextData?.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) && jsmOnboardingData?.onboardingType === (0, $e7830161eb8674f1$export$6f454e69bce3a691);
    let yourBoardsRoute;
    let yourBoardsParams;
    let yourBoardsQuery;
    if (userBoardId != null) {
        yourBoardsRoute = (0, $lyCs2.userBoardRoute);
        yourBoardsParams = {
            accountId: userBoardOwnerAccountId,
            boardId: String(userBoardId)
        };
    }
    const boardOffset = userBoardId == null ? -1 : 0;
    const [userTraits] = (0, $ixNeq.useUserTraits)();
    const showNotificationsNewLozenge = (0, $5uXOq.useMemo)(()=>{
        const accountCreationDate = userTraits?.attributes?.find((trait)=>trait?.name === 'jira_first_active')?.value;
        const aWeekAgo = new Date(Date.now() - 604800000);
        let isNewUser = false;
        if (accountCreationDate && typeof accountCreationDate === 'string') isNewUser = new Date(accountCreationDate) > aWeekAgo;
        return !isNewUser;
    }, [
        userTraits
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // The Spotlight components listen to the resize event to
        // update their positioning. This will fix Spotlights pulse overlap
        // that are shown on Menu items. Without this the pulse are located
        /// at incorrect position.
        setTimeout(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.dispatchEvent(new Event('resize'));
        }, 0);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId,
        role: "dialog",
        "aria-labelledby": "atlassian-navigation-account-dialog-heading",
        className: (0, $bwpsq.default)([
            "_syaz1fxt"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ag3sS.MenuLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        "data-testid": (0, $6cNb0.testIdConcat)(testIdContent, 'account')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4mNf3.default), {
        id: "atlassian-navigation-account-dialog-heading",
        testId: (0, $6cNb0.testIdConcat)(testIdContent, 'account', 'heading')
    }, formatMessage((0, $cEIWv.default).account)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5DUZ0.AccountDetails // @ts-expect-error - TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
    ), {
        email: user.emailAddress || '',
        userFullname: user.userFullname,
        avatarSrc: user.avatarUrls ? user.avatarUrls['32x32'] : undefined,
        testId: (0, $6cNb0.testIdConcat)(testIdContent, 'account')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($32d3ea680525e18b$var$StandardToPremiumPubTouchpoint, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        hasSeparator: upgradeEditionMenuShown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($32d3ea680525e18b$var$UpgradeEditionMenuItem, {
        setUpgradeEditionMenuShown: setUpgradeEditionMenuShown
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        hasSeparator: upgradeEditionMenuShown || !upgradeEditionMenuShown,
        testId: testIdContent
    }, (showInJwmProjects || showInSoftwareProjects || showInJsmProjects) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4QigF.OpenMenuItem), {
        MenuItem: (0, $d4B4Y.MenuItem)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": (0, $6cNb0.testIdConcat)(testIdContent, 'jira')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4mNf3.default), {
        testId: (0, $6cNb0.testIdConcat)(testIdContent, 'jira', 'heading')
    }, formatMessage((0, $cEIWv.default).jira)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
        ariaLabel: formatMessage((0, $cEIWv.default).jira)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: 'profile',
            menuItemType: 'jira',
            position: 0
        },
        href: profileLink,
        params: profileParams,
        testId: (0, $6cNb0.testIdConcat)(testIdContent, 'jira', 'item-profile'),
        to: (0, $fDWVs.peopleProfilesRoute)
    }, formatMessage((0, $cEIWv.default).profile))), userBoardId !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
        ariaLabel: formatMessage((0, $cEIWv.default).jira)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: 'your-boards',
            menuItemType: 'jira',
            position: 1
        },
        href: `/jira/people/${String(userBoardOwnerAccountId)}/boards/${userBoardId}`,
        params: yourBoardsParams,
        query: yourBoardsQuery,
        testId: (0, $6cNb0.testIdConcat)(testIdContent, 'jira', 'item-your-boards'),
        to: yourBoardsRoute
    }, formatMessage((0, $cEIWv.default).yourBoards))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
        ariaLabel: formatMessage((0, $cEIWv.default).jira)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: 'personal-settings',
            menuItemType: 'jira',
            position: 2 + boardOffset
        },
        href: (0, $1C2yb.getGeneralPersonalSettingsPath)(),
        testId: (0, $6cNb0.testIdConcat)(testIdContent, 'jira', 'item-personal-settings'),
        to: (0, $7ziML.generalPersonalSettingsRoute)
    }, formatMessage((0, $cEIWv.default).personalSettings))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
        ariaLabel: formatMessage((0, $cEIWv.default).jira)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "notifications-menu-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: 'notifications',
            menuItemType: 'jira',
            position: 3 + boardOffset
        },
        href: (0, $1C2yb.getNotificationsPersonalSettingsPath)(),
        testId: (0, $6cNb0.testIdConcat)(testIdContent, 'jira', 'item-notifications'),
        to: (0, $d1xZH.notificationsPersonalSettingsRoute),
        iconAfter: showNotificationsNewLozenge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
            appearance: "new"
        }, formatMessage((0, $cEIWv.default).new)) : null
    }, formatMessage((0, $cEIWv.default).notifications)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZ4fr.EngagementSpotlight), {
        engagementId: "notifications-menu-spotlight"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
        ariaLabel: formatMessage((0, $cEIWv.default).jira)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fUv6Z.default), {
        testId: (0, $6cNb0.testIdConcat)(testIdContent, 'jira', 'item-theme'),
        itemPosition: 4 + boardOffset
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dgPkW.ExtraItems), {
        startPosition: 5 + boardOffset,
        testIdPrefix: testIdContent,
        itemAriaLabel: formatMessage((0, $cEIWv.default).jira)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4WZuY.ForgeItems), {
        startPosition: 6 + boardOffset,
        testIdPrefix: testIdContent,
        itemAriaLabel: formatMessage((0, $cEIWv.default).jira)
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        hasSeparator: true,
        testId: testIdFooter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": (0, $6cNb0.testIdConcat)(testIdFooter, 'items')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: 'logout',
            menuItemType: 'action',
            position: 0
        },
        href: "/logout",
        testId: (0, $6cNb0.testIdConcat)(testIdFooter, 'items', 'item-log-out')
    }, formatMessage((0, $cEIWv.default).logout))))));
};
const $32d3ea680525e18b$var$styles = null;

});
parcelRegister("ag3sS", function(module, exports) {

$parcel$export(module.exports, "MenuLayout", () => $a3bb5b7f7abc0b96$export$dc2a07138b27c65b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $eZUJu = parcelRequire("eZUJu");

var $gwIPs = parcelRequire("gwIPs");
const $a3bb5b7f7abc0b96$export$dc2a07138b27c65b = ({ children: children, isWide: isWide = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3bb5b7f7abc0b96$var$Wrapper, {
        isWide: isWide
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), {
        maxHeight: $a3bb5b7f7abc0b96$var$maxHeight
    }, children));
const $a3bb5b7f7abc0b96$var$starStyles = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3bb5b7f7abc0b96$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isWide: isWide, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1d8u6ab": (0, $lD23V.default)(__cmplp.isWide ? `${(0, $gwIPs.gridSize) * 40}px` : `${(0, $gwIPs.gridSize) * 29.25}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ul911kg _p12f1c3h _107nidpf _js70kb7n _nqzgkb7n _ziy7kb7n",
            __cmplp.className
        ])
    });
});
const $a3bb5b7f7abc0b96$var$maxHeight = `calc(100vh - ${(0, $gwIPs.gridSize) * 25}px)`;

});

parcelRegister("5DUZ0", function(module, exports) {

$parcel$export(module.exports, "AccountDetails", () => $a1d7ada73782364f$export$66e04d0aacdb3b2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");

var $7paD5 = parcelRequire("7paD5");

var $3Z96c = parcelRequire("3Z96c");

var $koVbs = parcelRequire("koVbs");

var $2EqxS = parcelRequire("2EqxS");

var $6cNb0 = parcelRequire("6cNb0");

var $d4B4Y = parcelRequire("d4B4Y");

var $7ilb8 = parcelRequire("7ilb8");

var $8ZSbf = parcelRequire("8ZSbf");
const $a1d7ada73782364f$export$66e04d0aacdb3b2 = ({ email: email, userFullname: userFullname, avatarSrc: avatarSrc, testId: testId })=>{
    const atlassianSettingsLink = (0, $2EqxS.useAtlassianPersonalSettingsLink)(email);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a1d7ada73782364f$export$8f1912fff52a55aa, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a1d7ada73782364f$export$33e9904f45a9e453, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a1d7ada73782364f$export$f7513421c53ce141, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        appearance: "circle",
        size: "medium",
        src: avatarSrc
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a1d7ada73782364f$export$e0d971bef63c8b8f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a1d7ada73782364f$export$101fbca3a406e1fd, null, userFullname), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("small", null, email)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: 'manage-account',
            menuItemType: 'account',
            position: 1
        },
        href: atlassianSettingsLink,
        testId: (0, $6cNb0.testIdConcat)(testId, 'manage-account'),
        target: "_blank",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
            LEGACY_size: "small",
            color: "var(--ds-icon-subtle, #626F86)",
            label: ""
        })
    }, formatMessage((0, $8ZSbf.default).manageAccount)))));
};
const $a1d7ada73782364f$export$8f1912fff52a55aa = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $3Z96c.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_lcxvglyw",
            __cmplp.className
        ])
    });
});
const $a1d7ada73782364f$export$33e9904f45a9e453 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc",
            __cmplp.className
        ])
    });
});
const $a1d7ada73782364f$export$f7513421c53ce141 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $a1d7ada73782364f$export$101fbca3a406e1fd = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_vwz4gktf",
            __cmplp.className
        ])
    });
});
const $a1d7ada73782364f$export$e0d971bef63c8b8f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2lx29ee3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8ZSbf", function(module, exports) {

$parcel$export(module.exports, "default", () => $818e6cdec46716cd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $818e6cdec46716cd$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    manageAccount: {
        "id": "atlassian-navigation.profile.menu.account-details.manage-account",
        "defaultMessage": "Manage account"
    }
});

});


parcelRegister("4WZuY", function(module, exports) {

$parcel$export(module.exports, "ForgeItems", () => $46180a8b75e73408$export$ee772b0fa73d37fd);

var $5uXOq = parcelRequire("5uXOq");

var $7uSIc = parcelRequire("7uSIc");

var $1rTGO = parcelRequire("1rTGO");

var $lLB03 = parcelRequire("lLB03");

var $k2DRb = parcelRequire("k2DRb");

var $l1LNZ = parcelRequire("l1LNZ");

var $h0JHu = parcelRequire("h0JHu");

var $e0AC8 = parcelRequire("e0AC8");

var $6cNb0 = parcelRequire("6cNb0");

var $1C2yb = parcelRequire("1C2yb");

var $d4B4Y = parcelRequire("d4B4Y");

var $7ilb8 = parcelRequire("7ilb8");
const $46180a8b75e73408$var$BaseForgeItems = ({ startPosition: startPosition, testIdPrefix: testIdPrefix, itemAriaLabel: itemAriaLabel })=>{
    const [{ items: forgeStoreItems }] = (0, $7uSIc.useForgePersonalSettingsItems)();
    const shouldTriggerForgeScreenEvent = forgeStoreItems && forgeStoreItems.length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (forgeStoreItems || []).map((item, idx)=>{
        const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(item.id);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
            key: item.id,
            ariaLabel: itemAriaLabel || ''
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
            analytics: {
                actionSubjectId: 'profileNavigationMenuItem',
                menuItemId: item.id,
                menuItemType: 'jira',
                position: startPosition + idx
            },
            href: `${(0, $1C2yb.getAppsPersonalSettingsPath)()}/${appId}/${envId}`,
            testId: (0, $6cNb0.testIdConcat)(testIdPrefix, `item-addon-${idx}`),
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1LNZ.ForgeIcon), {
                url: item.avatarUrl
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h0JHu.ExtensionTitle), {
            extensionEnvType: item.environmentType,
            extensionEnvKey: item.environmentKey,
            extensionName: item.title,
            autoTruncate: true
        })));
    }), shouldTriggerForgeScreenEvent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE)
        }
    }));
};
const $46180a8b75e73408$export$ee772b0fa73d37fd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLB03.TriggerAnalyticsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($46180a8b75e73408$var$BaseForgeItems, props));

});
parcelRegister("lLB03", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $8f6f5ad08b6537de$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $8f6f5ad08b6537de$export$e1a79e3d472c925a);

var $5uXOq = parcelRequire("5uXOq");

var $k2DRb = parcelRequire("k2DRb");

var $1rTGO = parcelRequire("1rTGO");

var $hBuqR = parcelRequire("hBuqR");
const $8f6f5ad08b6537de$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $8f6f5ad08b6537de$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE),
        ...props,
        moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER)
    });

});

parcelRegister("l1LNZ", function(module, exports) {

$parcel$export(module.exports, "ForgeIcon", () => $59ad601e153227ad$export$fe0464db4dc93ab4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $8vDvO = parcelRequire("8vDvO");

var $k4j3t = parcelRequire("k4j3t");
const $59ad601e153227ad$export$fe0464db4dc93ab4 = ({ url: url })=>{
    return url && String(url).trim().length > 0 ? /*#__PURE__*/ $5uXOq.createElement((0, $k4j3t.IconCustom), {
        shouldChangeFillColor: false,
        url: url
    }) : /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($8vDvO))), {
        color: "var(--ds-icon, #44546F)",
        spacing: "spacious",
        LEGACY_primaryColor: "var(--ds-icon, #44546F)",
        label: ""
    });
};

});

parcelRegister("h0JHu", function(module, exports) {

$parcel$export(module.exports, "ExtensionTitle", () => $8acb929a7e4cf7fc$export$3aa4a75e461c581c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $k2DRb = parcelRequire("k2DRb");

var $fl3Yy = parcelRequire("fl3Yy");
const $8acb929a7e4cf7fc$var$shouldShowEnv = (extensionEnvType)=>[
        (0, $k2DRb.STAGING_ENVIRONMENT),
        (0, $k2DRb.DEVELOPMENT_ENVIRONMENT)
    ].includes(extensionEnvType);
const $8acb929a7e4cf7fc$var$ExtensionTitleText = /*#__PURE__*/ (0, $5uXOq.memo)(({ text: text, autoTruncate: autoTruncate })=>{
    if (!autoTruncate) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, text, " ");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8acb929a7e4cf7fc$var$extensionTitleTextWrapperStyles
    }, text);
});
const $8acb929a7e4cf7fc$export$3aa4a75e461c581c = ({ extensionEnvType: extensionEnvType, extensionEnvKey: extensionEnvKey, extensionName: extensionName, autoTruncate: autoTruncate })=>{
    if (!$8acb929a7e4cf7fc$var$shouldShowEnv(extensionEnvType)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, extensionName);
    const Wrapper = autoTruncate ? $8acb929a7e4cf7fc$var$TruncatableExtensionTitleWrapper : $8acb929a7e4cf7fc$var$ExtensionTitleWrapper;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8acb929a7e4cf7fc$var$ExtensionTitleText, {
        text: (0, $fl3Yy.nameWithCustomEnvironment)(extensionName, extensionEnvType, extensionEnvKey),
        autoTruncate: !!autoTruncate
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fl3Yy.EnvironmentLozenge), {
        environmentType: extensionEnvType
    }));
};
const $8acb929a7e4cf7fc$var$extensionTitleTextWrapperStyles = (0, $8CUq3.xcss)({
    paddingRight: 'space.050',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    flexGrow: 1
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8acb929a7e4cf7fc$var$ExtensionTitleWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1q9y _13aiidpf",
            __cmplp.className
        ])
    });
});
const $8acb929a7e4cf7fc$var$TruncatableExtensionTitleWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1q9y _13aiidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fl3Yy", function(module, exports) {

$parcel$export(module.exports, "EnvironmentLozenge", () => $730173a4987fa3e4$export$278f8e01799d0418);
$parcel$export(module.exports, "nameWithCustomEnvironment", () => $730173a4987fa3e4$export$f9338c21ba7c7334);

var $5uXOq = parcelRequire("5uXOq");

var $aYAc3 = parcelRequire("aYAc3");

var $k2DRb = parcelRequire("k2DRb");

var $ousew = parcelRequire("ousew");

var $8Je4V = parcelRequire("8Je4V");
const $730173a4987fa3e4$export$50589a87e4fb3dae = (environmentType)=>{
    switch(environmentType){
        case 0, $k2DRb.DEVELOPMENT_ENVIRONMENT:
            return (0, $8Je4V.messages).developmentEnvironmentLozenge;
        case 0, $k2DRb.STAGING_ENVIRONMENT:
            return (0, $8Je4V.messages).stagingEnvironmentLozenge;
        default:
            return null;
    }
};
const $730173a4987fa3e4$export$278f8e01799d0418 = (props)=>{
    const { environmentType: environmentType } = props;
    const labelKey = $730173a4987fa3e4$export$50589a87e4fb3dae(environmentType);
    return labelKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
        testId: "forge-ui-extension-title.ui.environment-lozenge.lozenge",
        appearance: environmentType === (0, $k2DRb.DEVELOPMENT_ENVIRONMENT) ? 'default' : 'moved'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), labelKey)) : null;
};
const $730173a4987fa3e4$export$f9338c21ba7c7334 = (name, environmentType, environmentKey)=>{
    if (environmentType === (0, $k2DRb.DEVELOPMENT_ENVIRONMENT) && environmentKey && environmentKey !== (0, $k2DRb.DEFAULT_ENVIRONMENT_KEY)) return `${name} - ${environmentKey}`;
    return name;
};

});
parcelRegister("8Je4V", function(module, exports) {

$parcel$export(module.exports, "messages", () => $838ac71f7259b5ef$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $838ac71f7259b5ef$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    developmentEnvironmentLozenge: {
        "id": "forge-ui-extension-title.environment-lozenge.development-environment-lozenge",
        "defaultMessage": "DEV"
    },
    stagingEnvironmentLozenge: {
        "id": "forge-ui-extension-title.environment-lozenge.staging-environment-lozenge",
        "defaultMessage": "STG"
    }
});

});




parcelRegister("fUv6Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $f86718ba415abca4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $e2wv7 = parcelRequire("e2wv7");

const $f86718ba415abca4$export$31f1740ae531af94 = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("eEYWN")), {
    moduleId: "./src/packages/navigation-apps/theme-switcher-menu/src/index.tsx"
});
const $f86718ba415abca4$var$AsyncThemeSwitcherItem = ({ testId: testId, itemPosition: itemPosition })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav-theme-options-list-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e2wv7.default), {
            testId: testId,
            itemPosition: itemPosition,
            isDisabled: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f86718ba415abca4$export$31f1740ae531af94, {
        renderTriggerButton: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e2wv7.default), {
                testId: testId,
                itemPosition: itemPosition,
                ...props
            })
    }));
var $f86718ba415abca4$export$2e2bcd8739ae039 = $f86718ba415abca4$var$AsyncThemeSwitcherItem;

});
parcelRegister("e2wv7", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fbe3dba557d8dae$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $3uzfU = parcelRequire("3uzfU");

var $kJpBP = parcelRequire("kJpBP");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $1lFrC = parcelRequire("1lFrC");
const $0fbe3dba557d8dae$var$TriggerButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ testId: testId, itemPosition: itemPosition, ...rest }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        ...rest,
        ref: ref,
        onClick: (e)=>{
            e.stopPropagation();
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'navigationMenuItem'
            });
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'profileNavigationMenuItem', {
                menuItemId: 'theme',
                menuItemType: 'jira',
                position: itemPosition
            });
        },
        testId: testId,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3uzfU))), {
            spacing: "spacious",
            color: "var(--ds-icon-subtle, #626F86)",
            label: "",
            size: "small"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0fbe3dba557d8dae$var$Text, null, formatMessage((0, $1lFrC.default).text)));
});
var $0fbe3dba557d8dae$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $0fbe3dba557d8dae$var$TriggerButton;
const $0fbe3dba557d8dae$var$Text = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1lFrC", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe8ea74039b76a2c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fe8ea74039b76a2c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    text: {
        "id": "atlassian-navigation.profile.menu.theme-switcher-item.trigger-button.text",
        "defaultMessage": "Theme"
    }
});

});


parcelRegister("eEYWN", function(module, exports) {

let $aac413fadf5dfc50$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $aac413fadf5dfc50$var$load("kNFvF"),
    $aac413fadf5dfc50$var$load("eNZuu")
]).then(()=>parcelRequire('dFrEV'));

});


parcelRegister("d7AIY", function(module, exports) {

module.exports = (parcelRequire("avM1e"))('jira-concurrent-update-while-rendering', function() {
    return parcelRequire('9mCYe');
}, function() {
    return parcelRequire('8G24r');
});

});


parcelRegister("ixpv2", function(module, exports) {

$parcel$export(module.exports, "default", () => $2baac40d089a40ee$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2baac40d089a40ee$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltip: {
        "id": "atlassian-navigation.profile.tooltip",
        "defaultMessage": "Your profile and settings"
    }
});

});


parcelRegister("0396H", function(module, exports) {

$parcel$export(module.exports, "NavigationRouterListener", () => $fe5862efafb61dce$export$85575e1c48f0a517);

var $5uXOq = parcelRequire("5uXOq");

var $doZTA = parcelRequire("doZTA");

var $hUGiV = parcelRequire("hUGiV");
const $fe5862efafb61dce$export$85575e1c48f0a517 = ()=>{
    const [{ route: route, location: location, match: match }] = (0, $doZTA.useRouter)();
    const onEnd = (0, $hUGiV.useAtlassianNavigationEnd)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        onEnd();
    }, [
        route,
        match,
        location,
        onEnd
    ]);
    return null;
};

});
parcelRegister("hUGiV", function(module, exports) {

$parcel$export(module.exports, "useAtlassianNavigationEnd", () => $c2d6674a75325f63$export$4b9602c0fdb8b1bb);

var $5uXOq = parcelRequire("5uXOq");


var $4oDnX = parcelRequire("4oDnX");
const $c2d6674a75325f63$export$4b9602c0fdb8b1bb = ()=>{
    const [, { setAppReadyWithAppId: setAppReadyWithAppId }] = (0, $4oDnX.useSpaStateActions)();
    return (0, $5uXOq.useCallback)(()=>{
        setAppReadyWithAppId((0, $146ecce9d079a34d$export$3a54edb6ba4daa82));
    }, [
        setAppReadyWithAppId
    ]);
};

});


parcelRegister("fwJYI", function(module, exports) {

$parcel$export(module.exports, "Search", () => $e3b17dd8db2850a9$export$4b85d3515bd863a5);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $koVbs = parcelRequire("koVbs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $2Ui4E = parcelRequire("2Ui4E");

var $lmyls = parcelRequire("lmyls");

var $3HwlS = parcelRequire("3HwlS");

var $7XYc4 = parcelRequire("7XYc4");

var $6s1PB = parcelRequire("6s1PB");

var $l8ruj = parcelRequire("l8ruj");

var $Mp6qH = parcelRequire("Mp6qH");

var $gIk9n = parcelRequire("gIk9n");

var $crtj2 = parcelRequire("crtj2");

var $gIJdF = parcelRequire("gIJdF");

var $hkZaI = parcelRequire("hkZaI");

var $6xaTd = parcelRequire("6xaTd");
const $e3b17dd8db2850a9$var$LoadingSkeleton = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gIJdF.Skeleton), {
        placeholder: formatMessage((0, $gIk9n.default).interactiveSearchSkeletonPlaceholder),
        ariaLabel: formatMessage((0, $gIk9n.default).interactiveSearchSkeletonAriaLabel)
    });
};
const $e3b17dd8db2850a9$var$LoadingSkeletonInteractive = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hkZaI.SkeletonInteractive), {
        placeholder: formatMessage((0, $gIk9n.default).interactiveSearchSkeletonPlaceholder),
        ariaLabel: formatMessage((0, $gIk9n.default).interactiveSearchSkeletonAriaLabel)
    });
};
const $e3b17dd8db2850a9$var$SearchDialogMetricStart = ()=>{
    (0, $5uXOq.useEffect)(()=>{
        (0, $crtj2.searchDialogMetric).startFromPageLoad();
        (0, $crtj2.searchDialogMetric).mark((0, $crtj2.SEARCH_DIALOG_DOWNLOAD_START_MARK));
    }, []);
    return null;
};
const $e3b17dd8db2850a9$var$SearchDialogMetricEnd = ()=>{
    (0, $5uXOq.useEffect)(()=>{
        (0, $crtj2.searchDialogMetric).mark((0, $crtj2.SEARCH_DIALOG_DOWNLOAD_END_MARK));
    }, []);
    return null;
};

const $e3b17dd8db2850a9$export$964f3f99df662c38 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("3qb07")).then((m)=>m.Search), {
    ssr: false,
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/search/main.tsx"
});
const $e3b17dd8db2850a9$export$d8beef0361e69378 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "search",
        packageName: (0, $Mp6qH.PACKAGE_NAME),
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e3b17dd8db2850a9$var$SearchDialogMetricStart, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "lazy-search",
        fallback: (0, $6s1PB.expVal)('jfp-magma-concurrent-load-search-on-intent-exp', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e3b17dd8db2850a9$export$e455d67f280c301f, {
            useTopMenus: props.useTopMenus
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e3b17dd8db2850a9$var$LoadingSkeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e3b17dd8db2850a9$export$964f3f99df662c38, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e3b17dd8db2850a9$var$SearchDialogMetricEnd, null), (0, $6s1PB.expVal)('jfp-magma-concurrent-load-search-on-intent-exp', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6xaTd.SearchLoadOnIntentMetricEnd), null)));
const $e3b17dd8db2850a9$var$loadingSkeletonExpandableWrapperStyle = {
    width: '100%'
}; // only for nav4
const $e3b17dd8db2850a9$export$e455d67f280c301f = ({ setShowRealExperience: setShowRealExperience, useTopMenus: // eslint-disable-next-line react-hooks/react-compiler
useTopMenus = (0, $2Ui4E.useTopMenus) })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const [_, { on: openMenu }] = useTopMenus((0, $lmyls.MENU_ID).SEARCH);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        (0, $6xaTd.searchLoadOnIntentMetricStartFromSkeleton)();
        setShowRealExperience?.(true);
        openMenu();
    }, [
        setShowRealExperience,
        openMenu
    ]);
    const onMouseOver = (0, $5uXOq.useCallback)(()=>{
        setShowRealExperience?.(true);
    }, [
        setShowRealExperience
    ]);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "atlassian-navigation.ui.search.loading-skeleton-expandable",
        onClick: onClick,
        onKeyDown: onClick,
        onMouseOver: onMouseOver,
        onFocus: onClick,
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
        style: (0, $3HwlS.getWillShowNav4)() ? $e3b17dd8db2850a9$var$loadingSkeletonExpandableWrapperStyle : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e3b17dd8db2850a9$var$LoadingSkeletonInteractive, null)));
};
const $e3b17dd8db2850a9$export$49f3879f38fced1b = (props)=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const { useTopMenus: useTopMenus = (0, $2Ui4E.useTopMenus) } = props;
    // eslint-disable-next-line react-hooks/react-compiler
    const [isSearchMenuOpen] = useTopMenus((0, $lmyls.MENU_ID).SEARCH);
    const [showRealExperience, setShowRealExperience] = (0, $5uXOq.useState)(isSearchMenuOpen);
    (0, $5uXOq.useEffect)(()=>{
        if (isSearchMenuOpen) setShowRealExperience(true);
    }, [
        isSearchMenuOpen,
        setShowRealExperience
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "atlassian-navigation-search"
    }, showRealExperience ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "atlassian-navigation-search-experience"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e3b17dd8db2850a9$export$d8beef0361e69378, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "atlassian-navigation-search-loading-skeleton-expandable"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e3b17dd8db2850a9$export$e455d67f280c301f, {
        // eslint-disable-next-line react-hooks/react-compiler
        useTopMenus: useTopMenus,
        setShowRealExperience: setShowRealExperience
    })));
};
const $e3b17dd8db2850a9$export$4b85d3515bd863a5 = (0, $7XYc4.componentWithCondition)(()=>(0, $6s1PB.expVal)('jfp-magma-concurrent-load-search-on-intent-exp', 'isEnabled', false), $e3b17dd8db2850a9$export$49f3879f38fced1b, $e3b17dd8db2850a9$export$d8beef0361e69378);

});
parcelRegister("gIk9n", function(module, exports) {

$parcel$export(module.exports, "default", () => $b88bffd5106f4b78$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b88bffd5106f4b78$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    updated: {
        "id": "atlassian-navigation.search.updated",
        "defaultMessage": "Updated"
    },
    interactiveSearchSkeletonPlaceholder: {
        "id": "atlassian-navigation.search.interactive-search-skeleton-placeholder",
        "defaultMessage": "Search"
    },
    interactiveSearchSkeletonAriaLabel: {
        "id": "atlassian-navigation.search.interactive-search-skeleton-aria-label",
        "defaultMessage": "Search"
    }
});

});

parcelRegister("crtj2", function(module, exports) {

$parcel$export(module.exports, "SEARCH_DIALOG_DOWNLOAD_START_MARK", () => $f04658be14f95c1c$export$8cd6a987249a6f33);
$parcel$export(module.exports, "SEARCH_DIALOG_DOWNLOAD_END_MARK", () => $f04658be14f95c1c$export$80ab6637ae730993);
$parcel$export(module.exports, "searchDialogMetric", () => $f04658be14f95c1c$export$46d64d80a1040e9b);

var $dGrdR = parcelRequire("dGrdR");
const $f04658be14f95c1c$var$SEARCH_DIALOG_METRIC_KEY = 'search-dialog';
const $f04658be14f95c1c$export$8cd6a987249a6f33 = 'download-start';
const $f04658be14f95c1c$export$80ab6637ae730993 = 'download-end';
const $f04658be14f95c1c$export$46d64d80a1040e9b = (0, $dGrdR.metrics).pageSegmentLoad({
    key: $f04658be14f95c1c$var$SEARCH_DIALOG_METRIC_KEY,
    timings: [
        {
            key: 'download',
            startMark: $f04658be14f95c1c$export$8cd6a987249a6f33,
            endMark: $f04658be14f95c1c$export$80ab6637ae730993
        }
    ]
});

});

parcelRegister("gIJdF", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $315a2135ffa56c8b$export$8f31e4c4a37b8e9c);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $es68b = parcelRequire("es68b");

var $3HwlS = parcelRequire("3HwlS");

var $bPysz = parcelRequire("bPysz");

var $4R6GH = parcelRequire("4R6GH");

var $eoNiZ = parcelRequire("eoNiZ");
const $315a2135ffa56c8b$export$8f31e4c4a37b8e9c = ({ ProductSearchInputSkeleton: ProductSearchInputSkeleton = (0, $bPysz.ProductSearchInputSkeleton), useTheme: // eslint-disable-next-line react-hooks/react-compiler
useTheme = (0, $eoNiZ.useTheme), placeholder: placeholder, ariaLabel: ariaLabel })=>{
    /**
	 * The nav3 custom theme object
	 */ // eslint-disable-next-line react-hooks/react-compiler
    const theme = useTheme();
    /**
	 * A nav4 search theme that works with the nav3 theming API
	 */ const newTheme = (0, $es68b.useLegacySearchTheme)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ProductSearchInputSkeleton, {
        shouldFillContainer: (0, $3HwlS.getWillShowNav4)(),
        theme: (0, $3HwlS.getWillShowNav4)() ? newTheme : theme && theme.mode && theme.mode.search,
        placeholder: placeholder,
        ariaLabel: ariaLabel,
        dataSsrPlaceholder: (0, $4R6GH.fg)('qs-7058-remove-experiment-call-search-dialog') ? 'nav4-search-bar' : undefined
    });
};

});

parcelRegister("hkZaI", function(module, exports) {

$parcel$export(module.exports, "SkeletonInteractive", () => $62f14eb9ba168d84$export$f6cad695c873cb36);

var $5uXOq = parcelRequire("5uXOq");

var $es68b = parcelRequire("es68b");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");

var $bPysz = parcelRequire("bPysz");
var $ghYvR = parcelRequire("ghYvR");

var $eoNiZ = parcelRequire("eoNiZ");
const $62f14eb9ba168d84$export$f6cad695c873cb36 = ({ useTheme: useTheme = (0, $eoNiZ.useTheme), placeholder: placeholder, ariaLabel: ariaLabel })=>{
    /**
	 * The nav3 custom theme object
	 */ // eslint-disable-next-line react-hooks/react-compiler
    const theme = useTheme();
    /**
	 * A nav4 search theme that works with the nav3 theming API
	 */ const newTheme = (0, $es68b.useLegacySearchTheme)();
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bPysz.ProductSearchInputSkeleton), {
        shouldFillContainer: (0, $3HwlS.getWillShowNav4)(),
        theme: (0, $3HwlS.getWillShowNav4)() ? newTheme : theme && theme.mode && theme.mode.search,
        placeholder: placeholder,
        ariaLabel: ariaLabel,
        dataSsrPlaceholder: (0, $4R6GH.fg)('qs-7058-remove-experiment-call-search-dialog') ? 'nav4-search-bar' : undefined
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ghYvR.ProductSearchInputSkeletonInteractive), {
        shouldFillContainer: (0, $3HwlS.getWillShowNav4)(),
        theme: (0, $3HwlS.getWillShowNav4)() ? newTheme : theme && theme.mode && theme.mode.search,
        placeholder: placeholder || '',
        stickySearchEnabled: true
    });
};

});

parcelRegister("6xaTd", function(module, exports) {

$parcel$export(module.exports, "searchLoadOnIntentMetricStartFromSkeleton", () => $ac1329759e3763fa$export$a9b73ef5805d7ce);
$parcel$export(module.exports, "SearchLoadOnIntentMetricEnd", () => $ac1329759e3763fa$export$c802bd101ecfea1);
$parcel$export(module.exports, "searchLoadOnIntentMetricFromSearchFire", () => $ac1329759e3763fa$export$5c176f125966323d);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
// eslint-disable-next-line no-restricted-properties, jira/jira-ssr/no-unchecked-globals-usage
const $ac1329759e3763fa$var$getNow = ()=>window?.performance?.now?.();
class $ac1329759e3763fa$var$SearchLoadOnIntentMetric {
    start(isStartFromSkeleton, startTime = $ac1329759e3763fa$var$getNow()) {
        if (this.startTime !== null) return;
        this.isStartFromSkeleton = isStartFromSkeleton;
        this.startTime = startTime;
    }
    stop(analyticsEvent, endTime = $ac1329759e3763fa$var$getNow()) {
        if (this.startTime === null || this.stopTime !== null || this.hasFired) return;
        this.stopTime = endTime;
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'searchDialog firstOpen', {
            startTime: Math.round(this.startTime),
            duration: Math.round((this.stopTime || 0) - (this.startTime || 0)),
            isStartFromSkeleton: this.isStartFromSkeleton
        });
        this.hasFired = true;
    }
    constructor(){
        this.hasFired = false;
        this.startTime = null;
        this.stopTime = null;
        this.isStartFromSkeleton = false;
    }
}
let $ac1329759e3763fa$var$searchLoadOnIntentMetric = new $ac1329759e3763fa$var$SearchLoadOnIntentMetric();
const $ac1329759e3763fa$export$b2204437a87141a9 = ()=>$ac1329759e3763fa$var$searchLoadOnIntentMetric;
const $ac1329759e3763fa$export$69e5d67124dcdbcb = ()=>{
    $ac1329759e3763fa$var$searchLoadOnIntentMetric = new $ac1329759e3763fa$var$SearchLoadOnIntentMetric();
};
const $ac1329759e3763fa$export$a9b73ef5805d7ce = (startTime)=>{
    $ac1329759e3763fa$var$searchLoadOnIntentMetric.start(true, startTime);
};
const $ac1329759e3763fa$export$c802bd101ecfea1 = ({ endTime: endTime })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        $ac1329759e3763fa$var$searchLoadOnIntentMetric.stop(createAnalyticsEvent({}), endTime);
    }, [
        createAnalyticsEvent,
        endTime
    ]);
    return null;
};
const $ac1329759e3763fa$export$5c176f125966323d = (analyticsEvent, now = $ac1329759e3763fa$var$getNow())=>{
    if ($ac1329759e3763fa$var$searchLoadOnIntentMetric.hasFired || $ac1329759e3763fa$var$searchLoadOnIntentMetric.startTime !== null) return;
    $ac1329759e3763fa$var$searchLoadOnIntentMetric.start(false, now);
    $ac1329759e3763fa$var$searchLoadOnIntentMetric.stop(analyticsEvent, now);
};

});

parcelRegister("3qb07", function(module, exports) {

let $27dc555b905922b0$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $27dc555b905922b0$var$load("kNFvF"),
    $27dc555b905922b0$var$load("fliVL"),
    $27dc555b905922b0$var$load("ffQaD"),
    $27dc555b905922b0$var$load("kvRbA"),
    $27dc555b905922b0$var$load("dAq7W")
]).then(()=>parcelRequire('1jMgA'));

});


parcelRegister("ag3PC", function(module, exports) {

$parcel$export(module.exports, "Settings", () => $f891c4e4f71955d4$export$c72f6eaae7b9adff);

var $5uXOq = parcelRequire("5uXOq");

var $22Gxp = parcelRequire("22Gxp");

var $9UCCQ = parcelRequire("9UCCQ");

var $4kmos = parcelRequire("4kmos");

var $kaHBi = parcelRequire("kaHBi");

var $4R6GH = parcelRequire("4R6GH");

var $itmJb = parcelRequire("itmJb");

var $koVbs = parcelRequire("koVbs");

var $lmyls = parcelRequire("lmyls");

var $2Ui4E = parcelRequire("2Ui4E");

var $6cNb0 = parcelRequire("6cNb0");

var $3HwlS = parcelRequire("3HwlS");

var $jgJNO = parcelRequire("jgJNO");

var $cZpsT = parcelRequire("cZpsT");

var $4mO32 = parcelRequire("4mO32");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $cSD7y = parcelRequire("cSD7y");

var $Mp6qH = parcelRequire("Mp6qH");

var $amOJR = parcelRequire("amOJR");

var $iPj86 = parcelRequire("iPj86");

var $ag3sS = parcelRequire("ag3sS");

var $9TMfX = parcelRequire("9TMfX");

var $6WLja = parcelRequire("6WLja");

var $4uXxK = parcelRequire("4uXxK");

var $hrU50 = parcelRequire("hrU50");

var $3Ug2v = parcelRequire("3Ug2v");

var $asDBE = parcelRequire("asDBE");
const $f891c4e4f71955d4$export$c72f6eaae7b9adff = (0, $cSD7y.componentWithFG)('settings-icon-perf-vc90-improvements', /*#__PURE__*/ (0, $5uXOq.memo)($f891c4e4f71955d4$var$SettingsNoMemo), $f891c4e4f71955d4$var$SettingsNoMemo);
const $f891c4e4f71955d4$var$SettingsMenu = (0, $cSD7y.componentWithFG)('blu-3339-nav4-topnav-settings-entrypoint', $f891c4e4f71955d4$var$SettingsContainer, $f891c4e4f71955d4$var$SettingsInner);
function $f891c4e4f71955d4$var$SettingsNoMemo() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $Mp6qH.NAVIGATION_ITEM_ID).SETTINGS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f891c4e4f71955d4$var$SettingsMenu, null));
}
function $f891c4e4f71955d4$var$SettingsContainer() {
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    if (isAnonymous) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f891c4e4f71955d4$var$SettingsInner, null);
}
const $f891c4e4f71955d4$var$EMPTY_OBJECT = {};
function $f891c4e4f71955d4$var$SettingsInner() {
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    // remove when cleaning up fg: blu-3339-nav4-topnav-settings-entrypoint
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const [isOpen, { toggle: toggleMenu, off: closeMenu }] = (0, $2Ui4E.useTopMenus)((0, $lmyls.MENU_ID).SETTINGS);
    const triggerAnalytics = (0, $iPj86.useNavigationItemAnalytics)({
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).SETTINGS
    });
    const onStart = (0, $kaHBi.useExperienceStart)({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $Mp6qH.NAVIGATION_ITEM_ID).SETTINGS,
        analyticsSource: 'atlassian-navigation'
    });
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (!(0, $3HwlS.getWillShowNav4)()) onStart();
        toggleMenu();
        triggerAnalytics({
            shownCommandPalettePrompt: isAdmin
        });
    }, [
        isAdmin,
        onStart,
        toggleMenu,
        triggerAnalytics
    ]);
    const testIdPrefix = (0, $6cNb0.testIdGenerate)('secondary-actions', 'settings');
    // replace this with useId from react 18 when stable
    const id = (0, $22Gxp.useUID)();
    const titleId = `top-navigation-settings-header-${id}-title`;
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $3Ug2v.settingsMenuEntryPoint), (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-2') ? $f891c4e4f71955d4$var$EMPTY_OBJECT : {});
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    const Trigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": (0, $6cNb0.testIdConcat)(testIdPrefix, 'menu-trigger'),
            "data-vc": `atlassian-navigation-settings${false ? '-ssr' : ''}`
        }, (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4kmos.Settings), {
            ...triggerProps,
            ref: (element)=>{
                if ((0, $4R6GH.fg)('blu-3339-nav4-topnav-settings-entrypoint')) triggerRef(element);
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                triggerProps.ref?.(element);
            },
            onClick: onClick,
            isSelected: isOpen,
            interactionName: "nav4-topNav-settings",
            label: formatMessage((0, $asDBE.default).settings)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $amOJR.Settings), {
            ...triggerProps,
            ref: (element)=>{
                if ((0, $4R6GH.fg)('blu-3339-nav4-topnav-settings-entrypoint')) triggerRef(element);
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                triggerProps.ref?.(element);
            },
            onClick: onClick,
            tooltip: formatMessage((0, $asDBE.default).settings),
            isSelected: isOpen
        })), [
        formatMessage,
        isOpen,
        onClick,
        testIdPrefix,
        triggerRef
    ]);
    const content = (0, $5uXOq.useCallback)(()=>(0, $4R6GH.fg)('blu-3339-nav4-topnav-settings-entrypoint') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            id: "nav4-topNav-settings",
            entryPointReferenceSubject: entryPointReferenceSubject,
            packageName: (0, $Mp6qH.PACKAGE_NAME),
            errorFallback: "flag",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ag3sS.MenuLayout), {
                isWide: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
                isScrollable: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9TMfX.MenuSkeletonContent), {
                testIdPrefix: testIdPrefix
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
                hasSeparator: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6WLja.MenuSkeletonFooter), {
                testIdPrefix: testIdPrefix
            }))),
            runtimeProps: {
                testIdPrefix: testIdPrefix,
                titleId: titleId
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hrU50.Menu), {
            testIdPrefix: testIdPrefix,
            titleId: titleId
        }), [
        entryPointReferenceSubject,
        testIdPrefix,
        titleId
    ]);
    // remove when cleaning up fg: blu-3339-nav4-topnav-settings-entrypoint
    if (isAnonymous) return null;
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Trigger, {
        "aria-expanded": false,
        "aria-haspopup": true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        titleId: titleId,
        isOpen: isOpen,
        content: content,
        onClose: closeMenu,
        placement: "bottom-end",
        messageId: "atlassian-navigation.ui.settings.popup",
        messageType: "transactional",
        trigger: Trigger,
        label: formatMessage((0, $asDBE.default).settings),
        shouldRenderToParent: true
    });
}

});
parcelRegister("amOJR", function(module, exports) {

$parcel$export(module.exports, "Settings", () => $70f9abb464fd04b1$export$c72f6eaae7b9adff);

var $5uXOq = parcelRequire("5uXOq");

var $3rGy0 = parcelRequire("3rGy0");

var $cmbsU = parcelRequire("cmbsU");

var $3HwlS = parcelRequire("3HwlS");
const $70f9abb464fd04b1$export$c72f6eaae7b9adff = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    if (false) {
        if ((0, $3HwlS.getWillShowNav4)()) // @ts-expect-error - Type 'ReactNode' is not assignable to type 'string'.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cmbsU.Nav4SkeletonSettingsButton), {
            label: props.tooltip
        });
        // @ts-expect-error - Type 'ReactNode' is not assignable to type 'string'.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cmbsU.SkeletonSettingsButton), {
            label: props.tooltip
        });
    }
    const buttonProps = {
        ...props,
        ref: ref
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3rGy0.Settings), buttonProps);
});

});

parcelRegister("9TMfX", function(module, exports) {

$parcel$export(module.exports, "MenuSkeletonContent", () => $4a37f7ab6d486120$export$8db7a6d33c26b25f);

var $5uXOq = parcelRequire("5uXOq");

var $eaGfl = parcelRequire("eaGfl");
var $iwwXK = parcelRequire("iwwXK");

var $6cNb0 = parcelRequire("6cNb0");
const $4a37f7ab6d486120$export$8db7a6d33c26b25f = ({ testIdPrefix: testIdPrefix })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": (0, $6cNb0.testIdConcat)(testIdPrefix, 'skeleton')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaGfl.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        hasIcon: true,
        width: "62.5%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        hasIcon: true,
        width: "50%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        hasIcon: true,
        width: "62.5%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        hasIcon: true,
        width: "50%"
    }));

});

parcelRegister("6WLja", function(module, exports) {

$parcel$export(module.exports, "MenuSkeletonFooter", () => $a62f60b9f9c94621$export$efa6bae06cf20a1);

var $5uXOq = parcelRequire("5uXOq");

var $iwwXK = parcelRequire("iwwXK");

var $6cNb0 = parcelRequire("6cNb0");
const $a62f60b9f9c94621$export$efa6bae06cf20a1 = ({ testIdPrefix: testIdPrefix, numItems: numItems = 2 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": (0, $6cNb0.testIdConcat)(testIdPrefix, 'skeleton')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        width: "50%"
    }), numItems >= 2 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        width: "50%"
    }));

});

parcelRegister("hrU50", function(module, exports) {

$parcel$export(module.exports, "MenuWithEntryPoint", () => $c4588c969d854f97$export$677b98f370fe145);
$parcel$export(module.exports, "Menu", () => $c4588c969d854f97$export$d9b273488cd8ce6f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9UCCQ = parcelRequire("9UCCQ");
var $eaGfl = parcelRequire("eaGfl");
var $iwwXK = parcelRequire("iwwXK");

var $bUmQV = parcelRequire("bUmQV");

var $5U49F = parcelRequire("5U49F");

var $8J6rn = parcelRequire("8J6rn");

var $7CMCs = parcelRequire("7CMCs");

var $3bQtK = parcelRequire("3bQtK");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $lmyls = parcelRequire("lmyls");

var $6cNb0 = parcelRequire("6cNb0");

var $3HwlS = parcelRequire("3HwlS");

var $daoB1 = parcelRequire("daoB1");

var $itmJb = parcelRequire("itmJb");

var $cNd4s = parcelRequire("cNd4s");

var $l8ruj = parcelRequire("l8ruj");

var $104vk = parcelRequire("104vk");

var $6s1PB = parcelRequire("6s1PB");

var $bQaTP = parcelRequire("bQaTP");

var $Mp6qH = parcelRequire("Mp6qH");

var $ag3sS = parcelRequire("ag3sS");

var $jNHMi = parcelRequire("jNHMi");

var $ao1KY = parcelRequire("ao1KY");

var $e57bL = parcelRequire("e57bL");

var $asDBE = parcelRequire("asDBE");

var $6svfi = parcelRequire("6svfi");

var $b59xm = parcelRequire("b59xm");
function $c4588c969d854f97$export$677b98f370fe145({ props: { testIdPrefix: testIdPrefix, titleId: titleId } }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c4588c969d854f97$export$d9b273488cd8ce6f, {
        testIdPrefix: testIdPrefix,
        titleId: titleId
    });
}
const $c4588c969d854f97$export$d9b273488cd8ce6f = ({ testIdPrefix: testIdPrefix, titleId: titleId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const appPermissions = (0, $daoB1.useApplicationPermissions)();
    const manageUsersPermission = (0, $jNHMi.useManageUsersPermission)();
    const { product: product } = (0, $bQaTP.useProductAndEdition)();
    const { isOpsAdmin: isOpsAdmin, loading: isOgTenantInfoLoading } = (0, $8J6rn.useOgTenantInfo)();
    const willShowNav4 = (0, $3HwlS.getWillShowNav4)();
    const settingsNavigationItems = (0, $5uXOq.useMemo)(()=>(0, $5U49F.getGlobalSettingsAdminItems)(formatMessage, appPermissions, {
            isAdmin: isAdmin,
            isSiteAdmin: isSiteAdmin,
            manageUsersPermission: manageUsersPermission,
            isOpsAdmin: isOpsAdmin
        }, willShowNav4), [
        formatMessage,
        appPermissions,
        isAdmin,
        isSiteAdmin,
        manageUsersPermission,
        willShowNav4,
        isOpsAdmin
    ]);
    const onSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    (0, $5uXOq.useEffect)(()=>{
        if (!willShowNav4) onSuccess();
    }, [
        onSuccess,
        willShowNav4
    ]);
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'menu-popup');
    const testIdHeader = (0, $6cNb0.testIdConcat)(testId, 'header');
    const shouldShowPremiumLandingPageTriggerBanner = isSiteAdmin && product === 'jira-service-management' && (0, $4R6GH.fg)('jsm_plp_trigger_in_global_settings');
    if (willShowNav4) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4-topNav-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: (0, $lmyls.MENU_ID).SETTINGS,
        packageName: (0, $Mp6qH.PACKAGE_NAME),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ag3sS.MenuLayout), {
        isWide: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6svfi.Personal), {
        testIdPrefix: testId
    }), settingsNavigationItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e57bL.Home), {
        settingsDrawerItems: settingsNavigationItems,
        testIdPrefix: testId
    }), manageUsersPermission.loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaGfl.default), {
        testId: `${testId}--loading-skeleton--heading`,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        testId: `${testId}--loading-skeleton--item`,
        isShimmering: true,
        hasIcon: true
    })) : settingsNavigationItems.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b59xm.Warning), {
        testIdPrefix: testId
    })), shouldShowPremiumLandingPageTriggerBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $104vk.PremiumLandingPageTriggerBanner), {
        origin: "GLOBAL_SETTINGS",
        testId: `${testId}--premium-landing-page-trigger-banner`
    })))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ag3sS.MenuLayout), {
        isWide: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c4588c969d854f97$var$SettingsTitle, {
        ...testIdHeader != null ? {
            'data-testid': testIdHeader
        } : {},
        id: titleId
    }, isAdmin && (0, $6s1PB.expVal)('improve_visibility_of_command_palette_for_admins', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
        justifyContent: "space-between",
        alignItems: "center"
    }, formatMessage((0, $asDBE.default).settings), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ao1KY.CommandPaletteSearchButton), null)) : formatMessage((0, $asDBE.default).settings)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6svfi.Personal), {
        testIdPrefix: testId
    }), settingsNavigationItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e57bL.Home), {
        settingsDrawerItems: settingsNavigationItems,
        testIdPrefix: testId
    }), manageUsersPermission.loading || isOgTenantInfoLoading && (0, $4R6GH.fg)('operations-tenant-info-endpoint-update') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaGfl.default), {
        testId: `${testId}--loading-skeleton--heading`,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        testId: `${testId}--loading-skeleton--item`,
        isShimmering: true,
        hasIcon: true
    })) : settingsNavigationItems.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b59xm.Warning), {
        testIdPrefix: testId
    })), shouldShowPremiumLandingPageTriggerBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $104vk.PremiumLandingPageTriggerBanner), {
        origin: "GLOBAL_SETTINGS",
        testId: `${testId}--premium-landing-page-trigger-banner`
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c4588c969d854f97$var$SettingsTitle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8lodh _ca0q1ejb _u5f3pxbi _n3tdu2gc _19bvv47k",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5U49F", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $a2085cc62fde1196$export$be58b4326e23250f);
$parcel$export(module.exports, "getGlobalSettingsAdminItems", () => $a2085cc62fde1196$export$d637bf5a394b4534);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $3fDjf = parcelRequire("3fDjf");

var $1ZDWg = parcelRequire("1ZDWg");

var $yJt0Y = parcelRequire("yJt0Y");

var $jAy2o = parcelRequire("jAy2o");

var $1Wiru = parcelRequire("1Wiru");

var $8vDvO = parcelRequire("8vDvO");

var $5DSin = parcelRequire("5DSin");

var $fwpGE = parcelRequire("fwpGE");

var $lfDf7 = parcelRequire("lfDf7");

var $ckyDP = parcelRequire("ckyDP");

var $dZ2wS = parcelRequire("dZ2wS");

var $7paD5 = parcelRequire("7paD5");

var $ggICg = parcelRequire("ggICg");

var $dXQDI = parcelRequire("dXQDI");

var $9fIhE = parcelRequire("9fIhE");

var $c781K = parcelRequire("c781K");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $6awYZ = parcelRequire("6awYZ");

var $c04PQ = parcelRequire("c04PQ");

var $2f2jJ = parcelRequire("2f2jJ");

var $8K9T4 = parcelRequire("8K9T4");

var $dzeHJ = parcelRequire("dzeHJ");

var $6lwNs = parcelRequire("6lwNs");

var $3JGmH = parcelRequire("3JGmH");
const $a2085cc62fde1196$var$getApplicationsMenuLink = (appPermissions)=>{
    if (appPermissions.hasSoftwareAccess) return '/jira/settings/products/jira-software-configuration';
    if (appPermissions.hasServiceDeskAccess) return '/jira/settings/products/jira-service-management-configuration';
    return '/plugins/servlet/applinks/listApplicationLinks';
};
const $a2085cc62fde1196$export$f3a5db2467c22913 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2085cc62fde1196$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZ2wS))), {
        label: "",
        LEGACY_size: "small",
        color: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $a2085cc62fde1196$export$3055c15ea575d46c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2085cc62fde1196$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Wiru))), {
        label: "",
        LEGACY_size: "small",
        color: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $a2085cc62fde1196$export$43db94b81c32328a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2085cc62fde1196$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fwpGE))), {
        label: "",
        LEGACY_size: "small",
        color: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $a2085cc62fde1196$export$583f26efcd800ae2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2085cc62fde1196$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lfDf7))), {
        label: "",
        LEGACY_size: "small",
        color: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $a2085cc62fde1196$export$627b4c7b9568cd5d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2085cc62fde1196$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8vDvO))), {
        label: "",
        LEGACY_size: "small",
        color: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $a2085cc62fde1196$export$4464648b9631e67f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2085cc62fde1196$export$be58b4326e23250f, {
        dark: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ckyDP))), {
        label: "",
        LEGACY_size: "small",
        color: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $a2085cc62fde1196$export$7b659dc9c22493b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2085cc62fde1196$export$be58b4326e23250f, {
        dark: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($yJt0Y))), {
        label: "",
        LEGACY_size: "small",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($5DSin))),
        color: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $a2085cc62fde1196$var$getAdminSectionOld = (formatMessage, appPermissions)=>({
        id: (0, $3JGmH.JIRA_SETTINGS_SECTION_IDS).SYSTEM_ADMIN,
        type: 'Group',
        hasSeparator: true,
        ...(0, $6s1PB.expVal)('improve_visibility_of_command_palette_for_admins', 'isEnabled', false) ? {} : {
            sideHeading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2085cc62fde1196$export$b79014a8ad5d31bf, {
                    "aria-label": formatMessage((0, $2f2jJ.isMacOs)() ? (0, $6lwNs.default).jiraSettingsCommandPaletteMacScreenReader : (0, $6lwNs.default).jiraSettingsCommandPaletteOtherScreenReader)
                }, formatMessage((0, $2f2jJ.isMacOs)() ? (0, $6lwNs.default).jiraSettingsCommandPaletteMac : (0, $6lwNs.default).jiraSettingsCommandPaletteOther, {
                    strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                            as: "strong",
                            size: "small",
                            color: "inherit"
                        }, chunks),
                    wrapper: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2085cc62fde1196$var$CommandPaletteShortcutsContainer, null, chunks),
                    key: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2085cc62fde1196$var$KeyboardShortcut, null, chunks),
                    command: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2085cc62fde1196$var$KeyboardShortcut, {
                            isMeta: true
                        }, chunks)
                }))
        },
        items: [
            {
                goTo: 'root/global-settings/system',
                // sets active navigation 2nd level menu and an active item in navigation menu, via `navApi.setView(goTo)`
                id: (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).SYSTEM,
                legacyId: 'admin_system_menu',
                href: '/jira/settings/system/general-configuration',
                text: formatMessage((0, $6lwNs.default).system),
                type: 'Item',
                before: $a2085cc62fde1196$export$f3a5db2467c22913
            },
            {
                goTo: 'root/global-settings/applications',
                id: (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).APPLICATIONS,
                legacyId: 'admin_applications_menu',
                href: $a2085cc62fde1196$var$getApplicationsMenuLink(appPermissions),
                text: formatMessage((0, $6lwNs.default).applications),
                type: 'Item',
                before: $a2085cc62fde1196$export$3055c15ea575d46c
            },
            {
                goTo: 'root/global-settings/projects',
                id: (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).MANAGE_PROJECTS,
                legacyId: 'admin_project_menu',
                href: '/jira/settings/projects/manage',
                text: formatMessage((0, $6lwNs.default).projects),
                type: 'Item',
                before: $a2085cc62fde1196$export$43db94b81c32328a
            },
            {
                goTo: 'root/global-settings/issues',
                id: (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).WORK : (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).ISSUES,
                legacyId: 'admin_issues_menu',
                href: '/jira/settings/issues/issue-types',
                text: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $6lwNs.default).issuesIssueTermRefresh : (0, $6lwNs.default).issues),
                type: 'Item',
                before: $a2085cc62fde1196$export$583f26efcd800ae2
            },
            {
                goTo: 'root/global-settings/addons',
                id: (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).PLUGINS,
                legacyId: 'admin_plugins_menu',
                href: (0, $6awYZ.getEmceeDiscoverLink)({
                    source: 'side_nav_find_new_addons'
                }),
                text: formatMessage((0, $6lwNs.default).addons),
                type: 'Item',
                before: $a2085cc62fde1196$export$627b4c7b9568cd5d
            }
        ]
    });
const $a2085cc62fde1196$var$getAdminSectionNew = (formatMessage, appPermissions)=>({
        id: (0, $3JGmH.JIRA_SETTINGS_SECTION_IDS).SYSTEM_ADMIN,
        type: 'Group',
        hasSeparator: true,
        heading: formatMessage((0, $6lwNs.default).jiraAdminSettings),
        items: [
            {
                goTo: 'root/global-settings/system',
                // sets active navigation 2nd level menu and an active item in navigation menu, via `navApi.setView(goTo)`
                id: (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).SYSTEM,
                legacyId: 'admin_system_menu',
                href: '/jira/settings/system/general-configuration',
                text: formatMessage((0, $6lwNs.default).system),
                type: 'Item',
                before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9fIhE))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }),
                description: formatMessage((0, $6lwNs.default).systemDescription)
            },
            {
                goTo: 'root/global-settings/applications',
                id: (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).APPLICATIONS,
                legacyId: 'admin_applications_menu',
                href: $a2085cc62fde1196$var$getApplicationsMenuLink(appPermissions),
                text: formatMessage((0, $6lwNs.default).applications),
                type: 'Item',
                before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fDjf))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }),
                description: formatMessage((0, $6lwNs.default).productsDescription)
            },
            {
                goTo: 'root/global-settings/projects',
                id: (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).MANAGE_PROJECTS,
                legacyId: 'admin_project_menu',
                href: '/jira/settings/projects/manage',
                text: formatMessage((0, $6lwNs.default).projects),
                type: 'Item',
                before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dXQDI))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }),
                description: formatMessage((0, $6lwNs.default).projectsDescription)
            },
            {
                goTo: 'root/global-settings/issues',
                id: (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).WORK : (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).ISSUES,
                legacyId: 'admin_issues_menu',
                href: '/jira/settings/issues/issue-types',
                text: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $6lwNs.default).issuesIssueTermRefresh : (0, $6lwNs.default).issues),
                type: 'Item',
                before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jAy2o))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }),
                description: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $6lwNs.default).issuesDescriptionIssueTermRefresh : (0, $6lwNs.default).issuesDescription)
            },
            {
                goTo: 'root/global-settings/addons',
                id: (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).PLUGINS,
                legacyId: 'admin_plugins_menu',
                href: (0, $8K9T4.manageAppsRoute).path,
                text: formatMessage((0, $6lwNs.default).addons),
                type: 'Item',
                before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1ZDWg))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }),
                description: formatMessage((0, $6lwNs.default).appsDescription)
            },
            {
                id: 'keyboad-shortcut-tip',
                type: 'Content',
                content: (0, $6s1PB.expVal)('improve_visibility_of_command_palette_for_admins', 'isEnabled', false) ? undefined : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                        as: "li",
                        xcss: $a2085cc62fde1196$var$jiraCommandPalletteTipContainerStyles,
                        "aria-label": formatMessage((0, $2f2jJ.isMacOs)() ? (0, $6lwNs.default).jiraSettingsCommandPaletteMacScreenReader : (0, $6lwNs.default).jiraSettingsCommandPaletteOtherScreenReader)
                    }, formatMessage((0, $2f2jJ.isMacOs)() ? (0, $6lwNs.default).jiraSettingsCommandPaletteMac : (0, $6lwNs.default).jiraSettingsCommandPaletteOther, {
                        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                                size: "small"
                            }, chunks),
                        wrapper: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                                xcss: $a2085cc62fde1196$var$commandPalleteShortcutStyles
                            }, chunks),
                        key: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
                                alignItems: "center",
                                justifyContent: "center",
                                xcss: $a2085cc62fde1196$var$keyboardShortcutStyles
                            }, chunks),
                        command: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
                                alignItems: "center",
                                justifyContent: "center",
                                xcss: $a2085cc62fde1196$var$keyboardShortcutStyles
                            }, chunks)
                    }))
            }
        ]
    });
const $a2085cc62fde1196$export$8c65af5cbebd63ff = (formatMessage, isSiteAdmin, canManageUsers)=>({
        id: (0, $3JGmH.JIRA_SETTINGS_SECTION_IDS).SITE_ADMIN,
        heading: formatMessage((0, $6lwNs.default).atlassianAdminSettings),
        type: 'Group',
        hasSeparator: false,
        items: [
            ...canManageUsers || isSiteAdmin ? [
                {
                    id: (0, $3JGmH.SITE_ADMIN_SETTINGS_ITEM_IDS).USER_MANAGEMENT,
                    legacyId: 'user_management_section',
                    href: (0, $3JGmH.SITE_ADMIN_SETTINGS_ITEM_HREFS).USER_MANAGEMENT,
                    text: formatMessage((0, $6lwNs.default).userManagement),
                    type: 'Item',
                    before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c781K))), {
                            label: "",
                            color: "var(--ds-icon, #44546F)"
                        }),
                    after: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ggICg))), {
                            label: "",
                            color: "var(--ds-icon, #44546F)"
                        }),
                    target: '_blank',
                    description: formatMessage((0, $6lwNs.default).userManagementDescription)
                }
            ] : [],
            ...isSiteAdmin && !(0, $c04PQ.isFedRamp)() ? [
                {
                    id: (0, $3JGmH.SITE_ADMIN_SETTINGS_ITEM_IDS).BILLING,
                    legacyId: 'admin_billing_section',
                    href: (0, $3JGmH.SITE_ADMIN_SETTINGS_ITEM_HREFS).BILLING,
                    text: formatMessage((0, $6lwNs.default).billing),
                    type: 'Item',
                    before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($yJt0Y))), {
                            label: "",
                            color: "var(--ds-icon, #44546F)"
                        }),
                    after: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ggICg))), {
                            label: "",
                            color: "var(--ds-icon, #44546F)"
                        }),
                    target: '_blank',
                    description: formatMessage((0, $6lwNs.default).billingDescription)
                }
            ] : []
        ]
    });
const $a2085cc62fde1196$export$ed6905715e0eb76 = (formatMessage, isSiteAdmin, canManageUsers)=>({
        id: (0, $3JGmH.JIRA_SETTINGS_SECTION_IDS).SITE_ADMIN,
        type: 'Group',
        hasSeparator: false,
        items: [
            ...canManageUsers || isSiteAdmin ? [
                {
                    id: (0, $3JGmH.SITE_ADMIN_SETTINGS_ITEM_IDS).USER_MANAGEMENT,
                    legacyId: 'user_management_section',
                    href: (0, $3JGmH.SITE_ADMIN_SETTINGS_ITEM_HREFS).USER_MANAGEMENT,
                    text: formatMessage((0, $6lwNs.default).userManagement),
                    type: 'Item',
                    before: $a2085cc62fde1196$export$4464648b9631e67f,
                    // @ts-expect-error - TS2769 - No overload matches this call.
                    after: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
                            LEGACY_size: "small"
                        }),
                    target: '_blank'
                }
            ] : [],
            ...isSiteAdmin && !(0, $c04PQ.isFedRamp)() ? [
                {
                    id: (0, $3JGmH.SITE_ADMIN_SETTINGS_ITEM_IDS).BILLING,
                    legacyId: 'admin_billing_section',
                    href: (0, $3JGmH.SITE_ADMIN_SETTINGS_ITEM_HREFS).BILLING,
                    text: formatMessage((0, $6lwNs.default).billing),
                    type: 'Item',
                    before: $a2085cc62fde1196$export$7b659dc9c22493b,
                    // @ts-expect-error - TS2769 - No overload matches this call.
                    after: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
                            LEGACY_size: "small"
                        }),
                    target: '_blank'
                }
            ] : []
        ]
    });
const $a2085cc62fde1196$export$b77c692c620409dc = (formatMessage)=>({
        id: (0, $3JGmH.JIRA_SETTINGS_SECTION_IDS).OPS_ADMIN,
        type: 'Group',
        hasSeparator: false,
        items: [
            {
                goTo: 'root/global-settings/applications',
                id: (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).APPLICATIONS,
                legacyId: 'admin_applications_menu',
                href: '/jira/settings/products/ops/role-assignment',
                text: formatMessage((0, $6lwNs.default).applications),
                type: 'Item',
                before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fDjf))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }),
                description: formatMessage((0, $6lwNs.default).productsDescription)
            }
        ]
    });
const $a2085cc62fde1196$export$d637bf5a394b4534 = (formatMessage, appPermissions, userRoles, willShowNav4)=>{
    const { isAdmin: isAdmin, isSiteAdmin: isSiteAdmin, manageUsersPermission: manageUsersPermission } = userRoles;
    const result = [];
    if (isAdmin) {
        const getAdminSection = willShowNav4 ? $a2085cc62fde1196$var$getAdminSectionNew : $a2085cc62fde1196$var$getAdminSectionOld;
        result.push(getAdminSection(formatMessage, appPermissions));
    }
    // Adding these items to the end because `manageUsersPermission` may change after the initial
    // render because it is determined by an async API call. It will need to be the responsibility
    // of the consumer to show a loading state if needed.
    if (isSiteAdmin || manageUsersPermission.loading === false && manageUsersPermission.canManageUsers) {
        const getSiteAdminSection = willShowNav4 ? $a2085cc62fde1196$export$8c65af5cbebd63ff : $a2085cc62fde1196$export$ed6905715e0eb76;
        result.push(getSiteAdminSection(formatMessage, userRoles.isSiteAdmin, manageUsersPermission.canManageUsers));
    }
    if (!willShowNav4 && !userRoles.isAdmin && userRoles.isOpsAdmin && (0, $4R6GH.fg)('operations-tenant-info-endpoint-update')) result.push($a2085cc62fde1196$export$b77c692c620409dc(formatMessage));
    return result;
};
const $a2085cc62fde1196$export$be58b4326e23250f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { dark: dark, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _1e0c116y _4cvr1h6o _1bah1h6o _4t3i1tcg _1bsb1tcg",
            __cmplp.dark ? "_11q7cdhy" : "_11q7b29m",
            __cmplp.className
        ])
    });
});
const $a2085cc62fde1196$var$CommandPaletteShortcutsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpv77o _1e0c116y",
            __cmplp.className
        ])
    });
});
const $a2085cc62fde1196$var$KeyboardShortcut = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $dzeHJ.FilledLozenge), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _1bsb1wug _1ul9dlk8 _4t3idlk8 _16jlidpf _vwz4wk7l _y3gn1h6o _ca0qidpf _u5f3v77o _n3tdidpf _19bvv77o _vchhusvi _1p1dglyw",
            __cmplp.isMeta ? "_1wyb1bt6" : "_1wybc4v4",
            __cmplp.className
        ])
    });
});
const $a2085cc62fde1196$export$b79014a8ad5d31bf = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _k48pi7a9 _syaz1dyx _1p1dglyw",
            __cmplp.className
        ])
    });
});
const $a2085cc62fde1196$var$commandPalleteShortcutStyles = (0, $8CUq3.xcss)({
    display: 'inline-flex',
    gap: 'space.025'
});
const $a2085cc62fde1196$var$jiraCommandPalletteTipContainerStyles = (0, $8CUq3.xcss)({
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    marginInlineStart: 'space.200',
    marginBlock: 'space.200',
    color: 'color.text.subtle',
    listStyleType: 'none'
});
const $a2085cc62fde1196$var$keyboardShortcutStyles = (0, $8CUq3.xcss)({
    minWidth: '14px',
    height: '14px',
    backgroundColor: 'color.background.accent.blue.subtlest',
    color: 'color.text.subtle',
    padding: 'space.025',
    borderRadius: 'border.radius',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});

});
parcelRegister("8K9T4", function(module, exports) {

$parcel$export(module.exports, "manageAppsRoute", () => $796c64c2599268cb$export$d5409be3b4016aab);
const $796c64c2599268cb$export$d5409be3b4016aab = {
    name: 'global-settings-addons-upm',
    path: '/plugins/servlet/upm'
};

});

parcelRegister("dzeHJ", function(module, exports) {

$parcel$export(module.exports, "OutlinedLozenge", () => $0f9445e21ac061f1$export$224f9ad7f31e0de6);
$parcel$export(module.exports, "FilledLozenge", () => $0f9445e21ac061f1$export$586a428fe10f5ae0);
$parcel$export(module.exports, "SearchLozenge", () => $0f9445e21ac061f1$export$2ccc7861eeb7b337);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $0f9445e21ac061f1$var$Lozenge = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _11c8dcr7 _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _4t3igktf _1bsbgktf _vwz41crf _syaz1gjq",
            __cmplp.className
        ])
    });
});
const $0f9445e21ac061f1$export$224f9ad7f31e0de6 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $0f9445e21ac061f1$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81u0j _19it3ju0 _k48p1pd9 _1p1dangw _bfhk1j9a _syaz131l _vchhusvi",
            __cmplp.className
        ])
    });
});
const $0f9445e21ac061f1$export$586a428fe10f5ae0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $0f9445e21ac061f1$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81u0j _kqswh2mm _1p1dangw _1pbykb7n _1s6krwve _rfx31l7b _1cs8stnw _1kt9b3bt _154psxj9 _1aukidpf _19woidpf _oounidpf _qnecidpf _1g0v1mrw",
            __cmplp.className
        ])
    });
});
const $0f9445e21ac061f1$export$2ccc7861eeb7b337 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $0f9445e21ac061f1$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _1bsb1ris _bfhkm7j4",
            __cmplp.className
        ])
    });
});

});

parcelRegister("6lwNs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f568e348dc45627$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9f568e348dc45627$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    settings: {
        "id": "navigation-next.navigation-views.root.common.settings",
        "defaultMessage": "Jira settings"
    },
    system: {
        "id": "navigation-next.navigation-views.root.global-settings.home.system",
        "defaultMessage": "System"
    },
    applications: {
        "id": "navigation-next.navigation-views.root.global-settings.home.applications",
        "defaultMessage": "Products"
    },
    projects: {
        "id": "navigation-next.navigation-views.root.global-settings.home.projects",
        "defaultMessage": "Projects"
    },
    issues: {
        "id": "navigation-next.navigation-views.root.global-settings.home.issues",
        "defaultMessage": "Issues"
    },
    addons: {
        "id": "navigation-next.navigation-views.root.global-settings.home.addons",
        "defaultMessage": "Apps"
    },
    recommendations: {
        "id": "navigation-next.navigation-views.root.global-settings.home.recommendations",
        "defaultMessage": "Recommendations"
    },
    userManagement: {
        "id": "navigation-next.navigation-views.root.global-settings.home.user-management",
        "defaultMessage": "User management"
    },
    billing: {
        "id": "navigation-next.navigation-views.root.global-settings.home.billing",
        "defaultMessage": "Billing"
    },
    discoverApplications: {
        "id": "navigation-next.navigation-views.root.global-settings.home.discover-applications",
        "defaultMessage": "Discover applications"
    },
    jiraSettingsCommandPaletteMac: {
        "id": "navigation-next.navigation-views.root.global-settings.home.jira-settings-command-palette-mac",
        "defaultMessage": "<strong>Tip:</strong> Try <wrapper><command>\u2318</command><key>K</key></wrapper> to search Jira settings"
    },
    jiraSettingsCommandPaletteOther: {
        "id": "navigation-next.navigation-views.root.global-settings.home.jira-settings-command-palette-other",
        "defaultMessage": "<strong>Tip:</strong> Try <wrapper><key>Ctrl</key><key>K</key></wrapper> to search Jira settings"
    },
    jiraSettingsCommandPaletteMacScreenReader: {
        "id": "navigation-next.navigation-views.root.global-settings.home.jira-settings-command-palette-mac-screen-reader",
        "defaultMessage": "Tip: Try command K to search Jira settings"
    },
    jiraSettingsCommandPaletteOtherScreenReader: {
        "id": "navigation-next.navigation-views.root.global-settings.home.jira-settings-command-palette-other-screen-reader",
        "defaultMessage": "Tip: Try control K to search Jira settings"
    },
    'site-admin': {
        "id": "navigation-apps.settings-drawer.section.site-admin",
        "defaultMessage": "Atlassian admin"
    },
    'system-admin': {
        "id": "navigation-apps.settings-drawer.section.system-admin",
        "defaultMessage": "Jira settings"
    },
    'ops-admin': {
        "id": "navigation-apps.settings-drawer.section.ops-admin",
        "defaultMessage": "Jira settings"
    },
    'trusted-user': {
        "id": "navigation-apps.settings-drawer.section.trusted-user",
        "defaultMessage": "Atlassian admin"
    },
    'personal-settings': {
        "id": "navigation-apps.settings-drawer.section.personal-settings",
        "defaultMessage": "Personal settings"
    },
    'admin-system-menu': {
        "id": "navigation-apps.settings-drawer.section.item.admin-system-menu",
        "defaultMessage": "Manage your general configuration, global permissions, look and feel and more."
    },
    'admin-applications-menu': {
        "id": "navigation-apps.settings-drawer.section.item.admin-applications-menu",
        "defaultMessage": "Manage your Jira products' settings and integrations."
    },
    'admin-manage-project-menu': {
        "id": "navigation-apps.settings-drawer.section.item.admin-manage-project-menu",
        "defaultMessage": "Manage your project settings, categories, and more."
    },
    'admin-issues-menu': {
        "id": "navigation-apps.settings-drawer.section.item.admin-issues-menu",
        "defaultMessage": "Configure your issue types, workflows, screens, custom fields and more."
    },
    'admin-issues-menu-issue-term-refresh': {
        "id": "navigation-apps.settings-drawer.section.item.admin-issues-menu-issue-term-refresh",
        "defaultMessage": "Configure your work types, workflows, screens, custom fields and more."
    },
    'admin-plugins-menu': {
        "id": "navigation-apps.settings-drawer.section.item.admin-plugins-menu",
        "defaultMessage": "Add and manage Jira Marketplace apps."
    },
    'user-management-section': {
        "id": "navigation-apps.settings-drawer.section.item.user-management-section",
        "defaultMessage": "Add users, groups, and manage access requests."
    },
    'admin-billing-section': {
        "id": "navigation-apps.settings-drawer.section.item.admin-billing-section",
        "defaultMessage": "Update your billing details, manage your subscriptions and more."
    },
    'trusted-admin-user-management-section': {
        "id": "navigation-apps.settings-drawer.section.item.trusted-admin-user-management-section",
        "defaultMessage": "Invite users to your site."
    },
    'discover-applications-section': {
        "id": "navigation-apps.settings-drawer.section.item.discover-applications-section",
        "defaultMessage": "Try more Atlassian products."
    },
    // NAV4 Messages
    personalJiraSettings: {
        "id": "atlassian-navigation-nav4.common.settings-content.personal-jira-settings",
        "defaultMessage": "Personal Jira settings"
    },
    jiraAdminSettings: {
        "id": "atlassian-navigation-nav4.common.settings-content.jira-admin-settings",
        "defaultMessage": "Jira admin settings"
    },
    systemDescription: {
        "id": "atlassian-navigation-nav4.common.settings-content.system-description",
        "defaultMessage": "Manage general configuration, security, automation, user interface, and more"
    },
    productsDescription: {
        "id": "atlassian-navigation-nav4.common.settings-content.products-description",
        "defaultMessage": "Manage Jira products' access, settings, and integrations"
    },
    projectsDescription: {
        "id": "atlassian-navigation-nav4.common.settings-content.projects-description",
        "defaultMessage": "Manage project settings, categories, and more"
    },
    issuesDescription: {
        "id": "atlassian-navigation-nav4.common.settings-content.issues-description",
        "defaultMessage": "Configure issue types, workflows, screens, fields, and more"
    },
    appsDescription: {
        "id": "atlassian-navigation-nav4.common.settings-content.apps-description",
        "defaultMessage": "Add and manage Jira Marketplace apps and integrations"
    },
    atlassianAdminSettings: {
        "id": "atlassian-navigation-nav4.common.settings-content.atlassian-admin-settings",
        "defaultMessage": "Atlassian admin settings"
    },
    userManagementDescription: {
        "id": "atlassian-navigation-nav4.common.settings-content.user-management-description",
        "defaultMessage": "Manage users, groups, and access requests"
    },
    billingDescription: {
        "id": "atlassian-navigation-nav4.common.settings-content.billing-description",
        "defaultMessage": "Update your billing details, manage subscriptions, and more"
    },
    issuesIssueTermRefresh: {
        "id": "navigation-next.navigation-views.root.global-settings.home.issues-issue-term-refresh",
        "defaultMessage": "Work items"
    },
    issuesDescriptionIssueTermRefresh: {
        "id": "atlassian-navigation-nav4.common.settings-content.issues-description-issue-term-refresh",
        "defaultMessage": "Configure work types, workflows, screens, fields, and more"
    }
});

});

parcelRegister("3JGmH", function(module, exports) {

$parcel$export(module.exports, "JIRA_SETTINGS_SECTION_IDS", () => $421ed2d9886b9bc8$export$7266225366740ba0);
$parcel$export(module.exports, "ADMIN_SETTINGS_ITEM_IDS", () => $421ed2d9886b9bc8$export$4718c8ac53a477e1);
$parcel$export(module.exports, "SITE_ADMIN_SETTINGS_ITEM_IDS", () => $421ed2d9886b9bc8$export$b23679adb37958a8);
$parcel$export(module.exports, "SITE_ADMIN_SETTINGS_ITEM_HREFS", () => $421ed2d9886b9bc8$export$9cc74e3c0b8831f9);
const $421ed2d9886b9bc8$export$7266225366740ba0 = {
    SETTINGS_TITLE: 'settings-title',
    SITE_ADMIN: 'site-admin',
    SYSTEM_ADMIN: 'system-admin',
    OPS_ADMIN: 'ops-admin',
    TRUSTED_USER: 'trusted-user',
    PERSONAL: 'personal-settings'
};
const $421ed2d9886b9bc8$export$4718c8ac53a477e1 = {
    SYSTEM: 'admin-system-menu',
    APPLICATIONS: 'admin-applications-menu',
    ISSUES: 'admin-issues-menu',
    WORK: 'admin-issues-menu-issue-term-refresh',
    PLUGINS: 'admin-plugins-menu',
    RECOMMENDATIONS: 'admin-recommendations',
    MANAGE_PROJECTS: 'admin-manage-project-menu'
};
const $421ed2d9886b9bc8$export$b23679adb37958a8 = {
    USER_MANAGEMENT: 'user-management-section',
    BILLING: 'admin-billing-section'
};
const $421ed2d9886b9bc8$export$9cc74e3c0b8831f9 = {
    USER_MANAGEMENT: '/admin/users?referrerName=JIRA',
    BILLING: '/admin/billing-preview?referrerName=JIRA'
};

});


parcelRegister("104vk", function(module, exports) {

$parcel$export(module.exports, "PremiumLandingPageTriggerBanner", () => $41438f45c681c8d4$export$4a2d68d56880396e);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $goJA6 = parcelRequire("goJA6");

var $l1N8i = parcelRequire("l1N8i");

var $9UCCQ = parcelRequire("9UCCQ");

var $1DVhQ = parcelRequire("1DVhQ");

var $erKnX = parcelRequire("erKnX");

var $koVbs = parcelRequire("koVbs");

var $7v6hw = parcelRequire("7v6hw");

var $7CMCs = parcelRequire("7CMCs");

var $7bpds = parcelRequire("7bpds");

var $dpRJ4 = parcelRequire("dpRJ4");
const $41438f45c681c8d4$export$4a2d68d56880396e = ({ origin: origin, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { gpEndDate: gpEndDate, loading: loading } = (0, $7bpds.useDisplayGpEndDate)();
    let subtitleLabel;
    if (loading) subtitleLabel = formatMessage((0, $dpRJ4.messages).subtitleLabelLoading, {
        loadingSkeleton: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $41438f45c681c8d4$var$subtitleSkeletonStyle,
            testId: "servicedesk-premium-landing-page-trigger-banner.ui.premium-landing-page-trigger-banner-title-skeleton"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
            width: "120px",
            height: "16px"
        }))
    });
    else if (gpEndDate) subtitleLabel = formatMessage((0, $dpRJ4.messages).subtitleLabelGpEndDate, {
        gpEndDate: gpEndDate
    });
    else // Also catches the case when the gpEndDate fetch had an error
    subtitleLabel = formatMessage((0, $dpRJ4.messages).subtitleLabelDefault);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "jsmPremiumLandingPageTriggerBanner",
        packageName: "jiraServiceDeskPremiumLandingPageTriggerBanner",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        hasSeparator: true,
        "data-testid": testId || 'servicedesk-premium-landing-page-trigger-banner.ui.premium-landing-page-trigger-banner'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $41438f45c681c8d4$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        alignBlock: "start",
        alignInline: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $goJA6.JiraServiceManagementIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.075",
        xcss: $41438f45c681c8d4$var$contentWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $41438f45c681c8d4$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "xsmall"
    }, subtitleLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        justifyContent: "start",
        gap: "space.100",
        xcss: $41438f45c681c8d4$var$buttonsWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7v6hw.UpsellButton), {
        analyticsOrigin: origin,
        buttonLabel: (0, $dpRJ4.messages).tryItFreeButtonLabel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $erKnX.PremiumLandingPageEntryPointButtonWithDrawer), {
        origin: origin
    })))))));
};
const $41438f45c681c8d4$var$subtitleSkeletonStyle = (0, $8CUq3.xcss)({
    display: 'inline-block',
    verticalAlign: 'middle'
});
const $41438f45c681c8d4$var$containerStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    padding: 'space.200',
    maxWidth: '496px'
});
const $41438f45c681c8d4$var$contentWrapperStyles = (0, $8CUq3.xcss)({
    width: '100%',
    alignItems: 'flex-start'
});
const $41438f45c681c8d4$var$buttonsWrapperStyles = (0, $8CUq3.xcss)({
    width: '100%'
});
const $41438f45c681c8d4$var$headingStyles = (0, $8CUq3.xcss)({
    alignItems: 'flex-start',
    textAlign: 'left',
    width: '100%'
});

});
parcelRegister("erKnX", function(module, exports) {

$parcel$export(module.exports, "PremiumLandingPageEntryPointButtonWithDrawer", () => $210b4a21521d7afe$export$e88d9b457e2df65b);

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $docuX = parcelRequire("docuX");

var $67hPg = parcelRequire("67hPg");
var $kNJSJ = parcelRequire("kNJSJ");

var $8zOmE = parcelRequire("8zOmE");

var $4R6GH = parcelRequire("4R6GH");

var $9VlWH = parcelRequire("9VlWH");

var $6Nxw9 = parcelRequire("6Nxw9");
const $210b4a21521d7afe$export$e88d9b457e2df65b = ({ origin: origin, buttonLabel: buttonLabel })=>{
    const [isModalOpen, setIsModalOpen] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    (0, $9VlWH.useUrlManager)('jsmPremiumBenefitsOpen', 'true', isModalOpen);
    const onEntryPointButtonClick = (analyticsEvent)=>{
        setIsModalOpen(true);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'premiumLandingPageEntryPointButton', {
            entryPointOrigin: origin
        });
    };
    const { Panel: Panel, trigger: trigger } = (0, $kNJSJ.usePanel)();
    return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        onClick: (event)=>event.stopPropagation()
    }, (0, $4R6GH.fg)('jsm_premium_landing_page_post_mvp') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $210b4a21521d7afe$var$panelBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Panel, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $67hPg.Trigger), {
        trigger: trigger,
        entryPoint: (0, $docuX.premiumLandingPageEntryPoint),
        entryPointProps: {
            origin: origin,
            onClose: ()=>{
                setIsModalOpen(false);
                trigger.setPanel(null);
            }
        }
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            appearance: "subtle",
            onClick: (_, analyticsEvent)=>onEntryPointButtonClick(analyticsEvent),
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref: ref
        }, formatMessage(buttonLabel ?? (0, $6Nxw9.default).defaultMessage))), !(0, $4R6GH.fg)('jsm_premium_landing_page_post_mvp') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Panel, null)));
};
const $210b4a21521d7afe$var$panelBoxStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    top: '0',
    left: '0',
    width: '1px',
    height: '1px'
});

});
parcelRegister("docuX", function(module, exports) {

$parcel$export(module.exports, "premiumLandingPageEntryPoint", () => $1c57a8a376fea8c5$export$eeb372f43c6f209);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $1c57a8a376fea8c5$export$eeb372f43c6f209 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("aZDID")), {
        moduleId: "3167f693",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("aZDID", function(module, exports) {

let $800e693aaaab60b9$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $800e693aaaab60b9$var$load("76n7a"),
    $800e693aaaab60b9$var$load("l253H"),
    $800e693aaaab60b9$var$load("ffQaD"),
    $800e693aaaab60b9$var$load("kvRbA"),
    $800e693aaaab60b9$var$load("dtHQ6")
]).then(()=>parcelRequire('aBLDN'));

});


parcelRegister("9VlWH", function(module, exports) {

$parcel$export(module.exports, "useUrlManager", () => $02c2b4b4544ba6bb$export$f049313207fbd7eb);

var $5uXOq = parcelRequire("5uXOq");

var $ieDtd = parcelRequire("ieDtd");
const $02c2b4b4544ba6bb$export$f049313207fbd7eb = (paramName, paramValue, isOpen)=>{
    const [_, setQueryParam] = (0, $ieDtd.useQueryParam)(paramName);
    (0, $5uXOq.useEffect)(()=>{
        if (isOpen) setQueryParam(paramValue);
        else setQueryParam(undefined);
        // Cleanup function to remove the query parameter when component unmounts
        return ()=>{
            setQueryParam(undefined);
        };
    }, [
        setQueryParam,
        paramValue,
        isOpen
    ]);
};

});

parcelRegister("6Nxw9", function(module, exports) {

$parcel$export(module.exports, "default", () => $44a62e5055a42672$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $44a62e5055a42672$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    defaultMessage: {
        "id": "service-desk-premium-landing-page-buttons.learn-more",
        "defaultMessage": "Learn more"
    }
});

});


parcelRegister("7v6hw", function(module, exports) {

$parcel$export(module.exports, "UpsellButton", () => $8239ba20adac9b6b$export$6004cbc93073305d);

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");
var $1GGwS = parcelRequire("1GGwS");

var $bOVbW = parcelRequire("bOVbW");

var $koVbs = parcelRequire("koVbs");

var $etK3X = parcelRequire("etK3X");

var $pa9q9 = parcelRequire("pa9q9");

var $8zOmE = parcelRequire("8zOmE");

var $9LLLf = parcelRequire("9LLLf");
const $8239ba20adac9b6b$export$6004cbc93073305d = ({ analyticsOrigin: analyticsOrigin, buttonLabel: buttonLabel })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const { data: { billingPageUrl: billingPageUrl }, error: error } = (0, $etK3X.useGetJsmPremiumBillingUrl)();
    (0, $5uXOq.useEffect)(()=>{
        if (!error) return;
        showFlag({
            type: 'error',
            isAutoDismiss: true,
            appearance: 'error',
            title: formatMessage((0, $9LLLf.messages).errorFlagTitle),
            description: formatMessage((0, $9LLLf.messages).errorFlagDescription),
            messageId: 'servicedesk-premium-landing-page.ui.upsell-button.show-flag.error.try-it-free-button.show-flag.error',
            messageType: 'transactional'
        });
    }, [
        error,
        formatMessage,
        showFlag
    ]);
    const handleOnClick = (_, analyticsEvent)=>{
        if (analyticsOrigin) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'premiumLandingPageUpsellButton', {
            landingPageOrigin: analyticsOrigin
        });
    };
    if (!billingPageUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        isLoading: true,
        testId: "servicedesk-premium-landing-page.ui.upsell-button.try-it-free-button-loading"
    }, formatMessage((0, $9LLLf.messages).tryItFreeButtonLabel));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1GGwS.default), {
        appearance: "discovery",
        onClick: handleOnClick,
        href: billingPageUrl,
        target: "_blank",
        testId: "servicedesk-premium-landing-page.ui.upsell-button.try-it-free-button",
        interactionName: "servicedesk-premium-landing-page.ui.upsell-button.try-it-free-button",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($bOVbW)))
    }, formatMessage(buttonLabel ?? (0, $9LLLf.messages).tryItFreeButtonLabel));
};

});
parcelRegister("etK3X", function(module, exports) {

$parcel$export(module.exports, "useGetJsmPremiumBillingUrl", () => $5f45d9114b927fa1$export$38408ed6d44a5d58);

var $5uXOq = parcelRequire("5uXOq");

var $14XJw = parcelRequire("14XJw");


var $2tT7R = parcelRequire("2tT7R");

var $koeKL = parcelRequire("koeKL");

var $5oBMG = parcelRequire("5oBMG");

var $4R6GH = parcelRequire("4R6GH");

var $jcw0u = parcelRequire("jcw0u");


var $eSiyx = parcelRequire("eSiyx");

var $jTym7 = parcelRequire("jTym7");
// Module-level cache for the billing URL - only used when feature gate is enabled
let $5f45d9114b927fa1$var$billingUrlCache;
const $5f45d9114b927fa1$var$getCcpTransactionAccountId = async (entitlementId)=>{
    const entitlementDetails = await (0, $eSiyx.fetchEntitlementDetails)(entitlementId);
    if (!entitlementDetails?.transactionAccountId) throw Error('Could not get transactionAccountId');
    return (entitlementDetails ?? {}).transactionAccountId;
};
const $5f45d9114b927fa1$export$3b7c11697c604f10 = ()=>{
    // Cancel any ongoing request when clearing cache
    if ($5f45d9114b927fa1$var$billingUrlCache?.abortController) $5f45d9114b927fa1$var$billingUrlCache.abortController.abort();
    $5f45d9114b927fa1$var$billingUrlCache = undefined;
};
const $5f45d9114b927fa1$export$38408ed6d44a5d58 = (skipTrial = false)=>{
    const [billingPageUrl, setBillingPageUrl] = (0, $5uXOq.useState)();
    const [loading, setLoading] = (0, $5uXOq.useState)(true);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const productEntitlementDetails = (0, $5oBMG.useProductEntitlementDetails)();
    const cloudId = (0, $koeKL.useCloudId)();
    const environment = (0, $2tT7R.useEnvironment)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const subscriberRef = (0, $5uXOq.useRef)(null);
    const isMountedRef = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useEffect)(()=>{
        isMountedRef.current = true;
        if ((0, $4R6GH.fg)('jsm-sequoia-cache-billing-url')) {
            // CACHED VERSION - New behavior with caching
            // Create subscriber function for this hook instance
            const subscriber = (result)=>{
                // Only update state if component is still mounted
                if (isMountedRef.current) {
                    setBillingPageUrl(result.billingPageUrl);
                    setLoading(result.loading);
                    setError(result.error);
                }
            };
            subscriberRef.current = subscriber;
            // If we have cached data, use it immediately
            if ($5f45d9114b927fa1$var$billingUrlCache) {
                subscriber({
                    billingPageUrl: $5f45d9114b927fa1$var$billingUrlCache.data.billingPageUrl,
                    loading: $5f45d9114b927fa1$var$billingUrlCache.loading,
                    error: $5f45d9114b927fa1$var$billingUrlCache.error
                });
                // Add this subscriber to the set
                $5f45d9114b927fa1$var$billingUrlCache.subscribers.add(subscriber);
                return ()=>{
                    isMountedRef.current = false;
                    // Clean up subscriber on unmount
                    if ($5f45d9114b927fa1$var$billingUrlCache) $5f45d9114b927fa1$var$billingUrlCache.subscribers.delete(subscriber);
                };
            }
            // Initialize cache and start the request
            const abortController = new AbortController();
            $5f45d9114b927fa1$var$billingUrlCache = {
                data: {
                    billingPageUrl: undefined
                },
                loading: true,
                error: null,
                subscribers: new Set([
                    subscriber
                ]),
                abortController: abortController
            };
            const loadBillingInfo = async ()=>{
                try {
                    // Check if request was aborted before proceeding
                    if (abortController.signal.aborted) return;
                    const productKey = (0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61);
                    const isUsingCcp = productEntitlementDetails?.[productKey]?.billingSourceSystem === 'CCP';
                    const referrerKey = 'jsm';
                    const commerceProductKey = `${productKey}.ondemand`;
                    const entitlementId = productEntitlementDetails?.[productKey]?.entitlementId;
                    const edition = (0, $jTym7.EDITION_KEY).PREMIUM_EDITION;
                    const adminHubBaseUrl = (0, $jTym7.ADMIN_HUB_URL)[environment];
                    let resultUrl;
                    if (isUsingCcp) {
                        // CCP Billing System
                        if (!entitlementId) throw new Error('Empty entitlement ID');
                        // Check abort before async operation
                        if (abortController.signal.aborted) return;
                        const ccpTransactionAccountId = await $5f45d9114b927fa1$var$getCcpTransactionAccountId(entitlementId);
                        // Check abort after async operation
                        if (abortController.signal.aborted) return;
                        const ccpBaseUrl = (0, $4R6GH.fg)('benifits_modal_billing_page_url_change') ? `${adminHubBaseUrl}/billing/${ccpTransactionAccountId}/entitlement/${entitlementId}/change-plan?referrer=${referrerKey}` : `${adminHubBaseUrl}/billing/o/${orgId}/${ccpTransactionAccountId}/entitlement/${entitlementId}/change-plan?referrer=${referrerKey}`;
                        resultUrl = `${ccpBaseUrl}&offeringName=${edition}${skipTrial && (0, $4R6GH.fg)('jsm_gp_announcements_banner') ? '&skipTrial=true' : ''}`;
                    } else {
                        // HAMS Billing System
                        if (skipTrial && (0, $4R6GH.fg)('jsm_gp_announcements_banner')) throw new Error('Skip trial is not supported for HAMS billing system');
                        resultUrl = `${adminHubBaseUrl}/s/${cloudId}/billing/applications/change-edition/${commerceProductKey}/${edition}`;
                    }
                    // Update cache and notify all subscribers
                    if ($5f45d9114b927fa1$var$billingUrlCache && !abortController.signal.aborted) {
                        $5f45d9114b927fa1$var$billingUrlCache.data.billingPageUrl = resultUrl;
                        $5f45d9114b927fa1$var$billingUrlCache.loading = false;
                        $5f45d9114b927fa1$var$billingUrlCache.error = null;
                        // Only notify subscribers that are still mounted
                        $5f45d9114b927fa1$var$billingUrlCache.subscribers.forEach((sub)=>{
                            sub({
                                billingPageUrl: resultUrl,
                                loading: false,
                                error: null
                            });
                        });
                    }
                } catch (e) {
                    // Update cache with error and notify all subscribers
                    if ($5f45d9114b927fa1$var$billingUrlCache && !abortController.signal.aborted) {
                        $5f45d9114b927fa1$var$billingUrlCache.data.billingPageUrl = undefined;
                        $5f45d9114b927fa1$var$billingUrlCache.loading = false;
                        $5f45d9114b927fa1$var$billingUrlCache.error = e;
                        $5f45d9114b927fa1$var$billingUrlCache.subscribers.forEach((sub)=>{
                            sub({
                                billingPageUrl: undefined,
                                loading: false,
                                error: e
                            });
                        });
                    }
                    (0, $jcw0u.default)({
                        meta: {
                            id: 'useGetJsmPremiumBillingUrl',
                            packageName: (0, $1d21bc43afc62b3b$export$b8b9d90f9e5bd72b),
                            teamName: (0, $1d21bc43afc62b3b$export$d57b6b390e78d90f)
                        },
                        error: e instanceof Error ? e : new Error(String(e)),
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            };
            loadBillingInfo();
            return ()=>{
                isMountedRef.current = false;
                // Cancel the request if it's still ongoing
                abortController.abort();
                // Clean up subscriber on unmount
                if ($5f45d9114b927fa1$var$billingUrlCache && subscriberRef.current) $5f45d9114b927fa1$var$billingUrlCache.subscribers.delete(subscriberRef.current);
            };
        }
        // ORIGINAL VERSION - Legacy behavior without caching
        const loadBillingInfo = async ()=>{
            try {
                const productKey = (0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61);
                const isUsingCcp = productEntitlementDetails?.[productKey]?.billingSourceSystem === 'CCP';
                const referrerKey = 'jsm';
                const commerceProductKey = `${productKey}.ondemand`;
                const entitlementId = productEntitlementDetails?.[productKey]?.entitlementId;
                const edition = (0, $jTym7.EDITION_KEY).PREMIUM_EDITION;
                const adminHubBaseUrl = (0, $jTym7.ADMIN_HUB_URL)[environment];
                if (isUsingCcp) {
                    // CCP Billing System
                    if (!entitlementId) throw new Error('Empty entitlement ID');
                    const ccpTransactionAccountId = await $5f45d9114b927fa1$var$getCcpTransactionAccountId(entitlementId);
                    const ccpBaseUrl = (0, $4R6GH.fg)('benifits_modal_billing_page_url_change') ? `${adminHubBaseUrl}/billing/${ccpTransactionAccountId}/entitlement/${entitlementId}/change-plan?referrer=${referrerKey}` : `${adminHubBaseUrl}/billing/o/${orgId}/${ccpTransactionAccountId}/entitlement/${entitlementId}/change-plan?referrer=${referrerKey}`;
                    setBillingPageUrl(`${ccpBaseUrl}&offeringName=${edition}${skipTrial && (0, $4R6GH.fg)('jsm_gp_announcements_banner') ? '&skipTrial=true' : ''}`);
                } else {
                    // HAMS Billing System
                    if (skipTrial && (0, $4R6GH.fg)('jsm_gp_announcements_banner')) throw new Error('Skip trial is not supported for HAMS billing system');
                    setBillingPageUrl(`${adminHubBaseUrl}/s/${cloudId}/billing/applications/change-edition/${commerceProductKey}/${edition}`);
                }
            } catch (e) {
                setError(e);
                (0, $jcw0u.default)({
                    meta: {
                        id: 'useGetJsmPremiumBillingUrl',
                        packageName: (0, $1d21bc43afc62b3b$export$b8b9d90f9e5bd72b),
                        teamName: (0, $1d21bc43afc62b3b$export$d57b6b390e78d90f)
                    },
                    error: e instanceof Error ? e : new Error(String(e)),
                    sendToPrivacyUnsafeSplunk: true
                });
            } finally{
                setLoading(false);
            }
        };
        loadBillingInfo();
    }, [
        environment,
        orgId,
        skipTrial,
        productEntitlementDetails,
        cloudId
    ]);
    return {
        data: {
            billingPageUrl: billingPageUrl
        },
        loading: loading,
        error: error
    };
};

});
const $1d21bc43afc62b3b$export$b8b9d90f9e5bd72b = 'jiraServicedeskStandardToPremiumModal';
const $1d21bc43afc62b3b$export$d57b6b390e78d90f = 'Sequoia';
const $1d21bc43afc62b3b$export$2a2c8ede6cfecb61 = '/gateway/api/graphql';

parcelRegister("eSiyx", function(module, exports) {

$parcel$export(module.exports, "fetchEntitlementDetails", () => $3ee63ee0a4241e21$export$c37c3206d7762a15);
$parcel$export(module.exports, "fetchHamsPremiumEstimate", () => $3ee63ee0a4241e21$export$16a69469a3e8e116);
$parcel$export(module.exports, "fetchHamsEntitlementDetails", () => $3ee63ee0a4241e21$export$d028394d9ed389b9);

var $7f4tk = parcelRequire("7f4tk");
const $3ee63ee0a4241e21$export$c37c3206d7762a15 = async (entitlementId)=>(0, $7f4tk.default)(`/gateway/api/ccp/api/v1/entitlements/${entitlementId}/details`);
const $3ee63ee0a4241e21$export$16a69469a3e8e116 = async (cloudId, entitlementId)=>(0, $7f4tk.default)(`/gateway/api/billing-ux/cloud/${cloudId}/billing/entitlements/${entitlementId}/edition/premium/estimate`);
const $3ee63ee0a4241e21$export$d028394d9ed389b9 = async (cloudId)=>(0, $7f4tk.default)(`/gateway/api/billing-ux/cloud/${cloudId}/billing/entitlement-group`);

});

parcelRegister("jTym7", function(module, exports) {

$parcel$export(module.exports, "EDITION_KEY", () => $9d1d3e74ff372b3d$export$d73720c31c622c1f);
$parcel$export(module.exports, "ADMIN_HUB_URL", () => $9d1d3e74ff372b3d$export$d891c31466b6cb8d);

var $ldyPw = parcelRequire("ldyPw");
const $9d1d3e74ff372b3d$export$d73720c31c622c1f = {
    STANDARD_EDITION: (0, $ldyPw.STANDARD_EDITION_KEY),
    PREMIUM_EDITION: (0, $ldyPw.PREMIUM_EDITION_KEY)
};
const $9d1d3e74ff372b3d$export$d891c31466b6cb8d = {
    prod: 'https://admin.atlassian.com',
    dev: 'https://admin.stg.atlassian.com',
    local: 'https://admin.stg.atlassian.com',
    staging: 'https://admin.stg.atlassian.com'
};

});


parcelRegister("9LLLf", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1483dd712dc5fb94$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $1483dd712dc5fb94$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    tryItFreeButtonLabel: {
        "id": "servicedesk-premium-landing-page.try-it-free-button-label",
        "defaultMessage": "Try Premium for free"
    },
    errorFlagTitle: {
        "id": "servicedesk-premium-landing-page.error-flag-title",
        "defaultMessage": "We're not sure what went wrong"
    },
    errorFlagDescription: {
        "id": "servicedesk-premium-landing-page.error-flag-description",
        "defaultMessage": "Try refreshing the page. If this keeps happening, contact support."
    }
});

});


parcelRegister("7bpds", function(module, exports) {

$parcel$export(module.exports, "useDisplayGpEndDate", () => $c2f4e259f817fd61$export$af0fe502eef6073e);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $DVljb = parcelRequire("DVljb");


var $9OXo1 = parcelRequire("9OXo1");

var $4Msa3 = parcelRequire("4Msa3");
// Module-level cache for the GP end date
let $c2f4e259f817fd61$var$gpEndDateCache;
const $c2f4e259f817fd61$export$69ac7413df65c7b6 = ()=>{
    // Cancel any ongoing request when clearing cache
    if ($c2f4e259f817fd61$var$gpEndDateCache?.abortController) $c2f4e259f817fd61$var$gpEndDateCache.abortController.abort();
    $c2f4e259f817fd61$var$gpEndDateCache = undefined;
};
const $c2f4e259f817fd61$export$af0fe502eef6073e = ()=>{
    const [loading, setLoading] = (0, $5uXOq.useState)(true);
    const [gpEndDate, setGpEndDate] = (0, $5uXOq.useState)(undefined);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const { isAdmin: isAdmin, productEntitlementDetails: productEntitlementDetails } = (0, $9OXo1.useTenantContext)();
    const entitlementId = productEntitlementDetails?.[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61]?.entitlementId;
    const locale = (0, $DVljb.useLocale)();
    const subscriberRef = (0, $5uXOq.useRef)(null);
    const isMountedRef = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useEffect)(()=>{
        isMountedRef.current = true;
        // Create subscriber function for this hook instance
        const subscriber = (result)=>{
            // Only update state if component is still mounted
            if (isMountedRef.current) {
                setGpEndDate(result.gpEndDate);
                setLoading(result.loading);
                setError(result.error);
            }
        };
        subscriberRef.current = subscriber;
        // If we have cached data, use it immediately
        if ($c2f4e259f817fd61$var$gpEndDateCache) {
            subscriber({
                gpEndDate: $c2f4e259f817fd61$var$gpEndDateCache.data.gpEndDate,
                loading: $c2f4e259f817fd61$var$gpEndDateCache.loading,
                error: $c2f4e259f817fd61$var$gpEndDateCache.error
            });
            // Add this subscriber to the set
            $c2f4e259f817fd61$var$gpEndDateCache.subscribers.add(subscriber);
            return ()=>{
                isMountedRef.current = false;
                // Clean up subscriber on unmount
                if ($c2f4e259f817fd61$var$gpEndDateCache) $c2f4e259f817fd61$var$gpEndDateCache.subscribers.delete(subscriber);
            };
        }
        // Initialize cache and start the request
        const abortController = new AbortController();
        $c2f4e259f817fd61$var$gpEndDateCache = {
            data: {
                gpEndDate: undefined
            },
            loading: true,
            error: null,
            subscribers: new Set([
                subscriber
            ]),
            abortController: abortController
        };
        const loadGpEndDate = async ()=>{
            try {
                // Check if request was aborted before proceeding
                if (abortController.signal.aborted) return;
                const gpEndDateDetails = await (0, $4Msa3.getGpEndDateDetails)(isAdmin, entitlementId);
                // Check abort after async operation
                if (abortController.signal.aborted) return;
                const calculatedGpEndDateValue = (0, $4Msa3.calculateGpEndDate)(gpEndDateDetails.maintenanceEndDate, gpEndDateDetails.billingPeriod, locale);
                // Update cache and notify all subscribers
                if ($c2f4e259f817fd61$var$gpEndDateCache && !abortController.signal.aborted) {
                    $c2f4e259f817fd61$var$gpEndDateCache.data.gpEndDate = calculatedGpEndDateValue;
                    $c2f4e259f817fd61$var$gpEndDateCache.loading = false;
                    $c2f4e259f817fd61$var$gpEndDateCache.error = null;
                    // Only notify subscribers that are still mounted
                    $c2f4e259f817fd61$var$gpEndDateCache.subscribers.forEach((sub)=>{
                        sub({
                            gpEndDate: calculatedGpEndDateValue,
                            loading: false,
                            error: null
                        });
                    });
                }
            } catch (e) {
                // Update cache with error and notify all subscribers
                if ($c2f4e259f817fd61$var$gpEndDateCache && !abortController.signal.aborted) {
                    $c2f4e259f817fd61$var$gpEndDateCache.data.gpEndDate = undefined;
                    $c2f4e259f817fd61$var$gpEndDateCache.loading = false;
                    $c2f4e259f817fd61$var$gpEndDateCache.error = e;
                    $c2f4e259f817fd61$var$gpEndDateCache.subscribers.forEach((sub)=>{
                        sub({
                            gpEndDate: undefined,
                            loading: false,
                            error: e
                        });
                    });
                }
                (0, $jcw0u.default)({
                    meta: {
                        id: 'jiraServicedeskJsmContextResource',
                        packageName: 'premiumLandingPage',
                        teamName: 'Sequoia'
                    },
                    error: e instanceof Error ? e : new Error(String(e))
                });
            }
        };
        loadGpEndDate();
        return ()=>{
            isMountedRef.current = false;
            // Cancel the request if it's still ongoing
            abortController.abort();
            // Clean up subscriber on unmount
            if ($c2f4e259f817fd61$var$gpEndDateCache && subscriberRef.current) $c2f4e259f817fd61$var$gpEndDateCache.subscribers.delete(subscriberRef.current);
        };
    }, [
        locale,
        entitlementId,
        isAdmin
    ]);
    return {
        loading: loading,
        gpEndDate: gpEndDate
    };
};

});
parcelRegister("4Msa3", function(module, exports) {

$parcel$export(module.exports, "getGpEndDateDetails", () => $3bc43e7d58dfbe57$export$eabf75da11894c5c);
$parcel$export(module.exports, "calculateGpEndDate", () => $3bc43e7d58dfbe57$export$cb353b4a113623c);
$parcel$export(module.exports, "calculateGpEndDateWithoutFormat", () => $3bc43e7d58dfbe57$export$b7b68457e67df636);

var $jovBr = parcelRequire("jovBr");
var $2753q = parcelRequire("2753q");

var $eusud = parcelRequire("eusud");

var $1p96B = parcelRequire("1p96B");
const $3bc43e7d58dfbe57$var$JSM_CONTEXT_URL = '/rest/servicedesk/latest/jsmcontext';
const $3bc43e7d58dfbe57$var$getSubscriptionsUrl = (entitlementId)=>`/gateway/api/ccp/api/v2/entitlements/${entitlementId}/details`;
// The Packaging GP enforcement date is October 16, 2025.
const $3bc43e7d58dfbe57$var$PACKAGING_GP_ENFORCEMENT_DATE = new Date('2025-10-16');
const $3bc43e7d58dfbe57$var$dateHasExpectedFormat = (date)=>{
    const dateFormat = 'yyyy-MM-dd';
    const parsedDate = (0, $2753q.default)(date, dateFormat, new Date());
    return (0, $jovBr.default)(parsedDate);
};
const $3bc43e7d58dfbe57$var$getSubscriptionsDateDetails = async (entitlementId)=>{
    const data = await (0, $eusud.performGetRequest)($3bc43e7d58dfbe57$var$getSubscriptionsUrl(entitlementId));
    return data.subscriptionv2.endTimestamp;
};
const $3bc43e7d58dfbe57$var$getJsmContextDateDetails = async ()=>{
    const data = await (0, $eusud.performGetRequest)($3bc43e7d58dfbe57$var$JSM_CONTEXT_URL);
    if (data.maintenanceEndDate && !$3bc43e7d58dfbe57$var$dateHasExpectedFormat(data.maintenanceEndDate)) throw new Error(`Invalid maintenance end date, received: ${data.maintenanceEndDate}`);
    if (data.billingPeriod !== 'MONTHLY' && data.billingPeriod !== 'ANNUAL') throw new Error(`Invalid billing period, received: ${data.billingPeriod}`);
    return {
        // Users with termed subscriptions before Aug 2024 will have no maintenance end date in the JSM context.
        maintenanceEndDate: data.maintenanceEndDate ? new Date(data.maintenanceEndDate) : undefined,
        billingPeriod: data.billingPeriod
    };
};
const $3bc43e7d58dfbe57$export$eabf75da11894c5c = async (isAdmin, entitlementId)=>{
    if (!isAdmin) throw new Error('Insufficient permissions to access GP end date');
    // Try the primary method first
    const jsmContextDateDetails = await $3bc43e7d58dfbe57$var$getJsmContextDateDetails();
    if (jsmContextDateDetails.maintenanceEndDate) return {
        maintenanceEndDate: jsmContextDateDetails.maintenanceEndDate,
        billingPeriod: jsmContextDateDetails.billingPeriod
    };
    if (!entitlementId) throw new Error('Insufficient data to access GP end date');
    // If primary method fails, try the fallback. This is for users with termed subscriptions before Aug 2024.
    const endTimestamp = await $3bc43e7d58dfbe57$var$getSubscriptionsDateDetails(entitlementId);
    if (!endTimestamp || !Number.isInteger(endTimestamp)) throw new Error(`Invalid end timestamp from subscriptions, received: ${endTimestamp}`);
    return {
        // Convert from seconds to milliseconds. endTimestamp is a UNIX timestamp.
        maintenanceEndDate: new Date(endTimestamp * 1000),
        billingPeriod: jsmContextDateDetails.billingPeriod
    };
};
const $3bc43e7d58dfbe57$var$getMonthlyBillingGPEndDate = (date)=>{
    const currentBillingDate = date;
    while(currentBillingDate < $3bc43e7d58dfbe57$var$PACKAGING_GP_ENFORCEMENT_DATE)currentBillingDate.setMonth(currentBillingDate.getMonth() + 1);
    return currentBillingDate;
};
const $3bc43e7d58dfbe57$var$getAnnualBillingGPEndDate = (date)=>{
    const currentBillingDate = date;
    while(currentBillingDate < $3bc43e7d58dfbe57$var$PACKAGING_GP_ENFORCEMENT_DATE)currentBillingDate.setFullYear(currentBillingDate.getFullYear() + 1);
    return currentBillingDate;
};
const $3bc43e7d58dfbe57$export$cb353b4a113623c = (maintenanceEndDate, billingPeriod, locale)=>{
    const gpEndDate = $3bc43e7d58dfbe57$export$b7b68457e67df636(maintenanceEndDate, billingPeriod);
    return gpEndDate ? (0, $1p96B.formatWithLocale)(gpEndDate, 'MMM dd, yyyy', locale) : undefined;
};
const $3bc43e7d58dfbe57$export$b7b68457e67df636 = (maintenanceEndDate, billingPeriod)=>{
    if (billingPeriod === 'MONTHLY') return $3bc43e7d58dfbe57$var$getMonthlyBillingGPEndDate(maintenanceEndDate);
    if (billingPeriod === 'ANNUAL') return $3bc43e7d58dfbe57$var$getAnnualBillingGPEndDate(maintenanceEndDate);
};

});


parcelRegister("dpRJ4", function(module, exports) {

$parcel$export(module.exports, "messages", () => $711e3cbd28b014f1$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $711e3cbd28b014f1$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    titleLabel: {
        "id": "servicedesk-premium-landing-page-trigger-banner.title-label",
        "defaultMessage": "Jira Service Management"
    },
    subtitleLabelDefault: {
        "id": "servicedesk-premium-landing-page-trigger-banner.subtitle-label-default",
        "defaultMessage": "Some Jira Service Management Operations features will be moving to Premium."
    },
    subtitleLabelLoading: {
        "id": "servicedesk-premium-landing-page-trigger-banner.subtitle-label-loading",
        "defaultMessage": "Some Jira Service Management Operations features will be moving to Premium {loadingSkeleton}"
    },
    subtitleLabelGpEndDate: {
        "id": "servicedesk-premium-landing-page-trigger-banner.subtitle-label-gp-end-date",
        "defaultMessage": "Some Jira Service Management Operations features will be moving to Premium on {gpEndDate}"
    },
    tryItFreeButtonLabel: {
        "id": "servicedesk-premium-landing-page-trigger-banner.ui.try-it-free-button-label",
        "defaultMessage": "Try Premium for free"
    }
});

});


parcelRegister("jNHMi", function(module, exports) {

$parcel$export(module.exports, "useManageUsersPermission", () => $723fd3490632416b$export$d156f64dc61f3ce9);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $14XJw = parcelRequire("14XJw");

var $90yGq = parcelRequire("90yGq");

var $cNd4s = parcelRequire("cNd4s");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $723fd3490632416b$var$initialState = {
    loading: true,
    canManageUsers: undefined
};
const $723fd3490632416b$var$Store = (0, $iXqE5.createStore)({
    initialState: $723fd3490632416b$var$initialState,
    actions: {
        fetch: ({ orgId: orgId, accountId: accountId, isSiteAdmin: isSiteAdmin })=>async ({ setState: setState, getState: getState })=>{
                if (getState().canManageUsers !== undefined) // Shortcut - Don't fetch again if we already have the data
                return;
                if (accountId == null || orgId == null) {
                    // Shortcut - Anonymous users cannot manage users, and orgId is required
                    setState({
                        loading: false,
                        canManageUsers: false
                    });
                    return;
                }
                if (isSiteAdmin) {
                    // Shortcut - Site admins can manage users
                    setState({
                        loading: false,
                        canManageUsers: true
                    });
                    return;
                }
                setState({
                    loading: true
                });
                try {
                    const { permitted: permitted } = await (0, $eusud.performPostRequest)('/gateway/api/permissions/permitted', {
                        body: JSON.stringify({
                            resourceId: `ari:cloud:platform::org/${orgId}`,
                            principalId: `ari:cloud:identity::user/${accountId}`,
                            permissionId: 'manage-users'
                        })
                    });
                    setState({
                        loading: false,
                        canManageUsers: permitted
                    });
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    // Fail safe - if we can't fetch the data, assume the user can't manage users
                    setState({
                        loading: false,
                        canManageUsers: false
                    });
                    (0, $jcw0u.default)({
                        meta: {
                            id: 'fetchManageUsersPermission',
                            packageName: 'jiraAtlassianNavigation',
                            teamName: 'navigation'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            }
    },
    name: 'ManageUsersPermissionInternal'
});
const $723fd3490632416b$var$useManageUsersPermissionInternal = (0, $3sQ5x.createHook)($723fd3490632416b$var$Store);
const $723fd3490632416b$export$d156f64dc61f3ce9 = ()=>{
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const accountId = (0, $90yGq.useAccountId)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const [state, { fetch: fetch }] = $723fd3490632416b$var$useManageUsersPermissionInternal();
    (0, $5uXOq.useEffect)(()=>{
        fetch({
            accountId: accountId,
            orgId: orgId,
            isSiteAdmin: isSiteAdmin
        });
    }, [
        fetch,
        accountId,
        orgId,
        isSiteAdmin
    ]);
    return state;
};

});

parcelRegister("ao1KY", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteSearchButton", () => $8a78f76ed584489e$export$7e33f7fa882fd644);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $MHKc7 = parcelRequire("MHKc7");
var $bUmQV = parcelRequire("bUmQV");
var $c0aEF = parcelRequire("c0aEF");

var $d8lE2 = parcelRequire("d8lE2");

var $2f2jJ = parcelRequire("2f2jJ");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $lyV4m = parcelRequire("lyV4m");
const $8a78f76ed584489e$export$7e33f7fa882fd644 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { open: open } = (0, $d8lE2.useActionsCommandPalette)();
    const handleSearchButtonClick = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        event.preventDefault();
        open();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'globalSettingsCommandPaletteSearchButton');
    }, [
        open
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        "aria-label": formatMessage((0, $2f2jJ.isMacOs)() ? (0, $lyV4m.default).labelForMacScreenReader : (0, $lyV4m.default).labelForOtherScreenReader),
        onClick: handleSearchButtonClick
    }, formatMessage((0, $2f2jJ.isMacOs)() ? (0, $lyV4m.default).labelForMac : (0, $lyV4m.default).labelForOther, {
        wrapper: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
                xcss: $8a78f76ed584489e$var$styles.commandPalleteShortcutStyles,
                space: "space.100"
            }, chunks),
        key: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
                alignItems: "center",
                justifyContent: "center",
                xcss: $8a78f76ed584489e$var$styles.keyboardShortcutStyles
            }, chunks),
        command: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
                alignItems: "center",
                justifyContent: "center",
                xcss: $8a78f76ed584489e$var$styles.keyboardShortcutStyles
            }, chunks)
    })));
};
const $8a78f76ed584489e$var$styles = {
    commandPalleteShortcutStyles: "_1e0c116y _4cvr1h6o",
    keyboardShortcutStyles: "_2rkoglpi _11c81o8v _1ul9dlk8 _4t3idlk8 _bfhkavxe _syaz1gjq _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o"
};

});
parcelRegister("lyV4m", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbc0badb716bf557$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $dbc0badb716bf557$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    labelForMac: {
        "id": "atlassian-navigation.settings.command-palette-search-button.label-for-mac",
        "defaultMessage": "Search ( <wrapper><command>\u2318</command> + <key>K</key></wrapper> )"
    },
    labelForOther: {
        "id": "atlassian-navigation.settings.command-palette-search-button.label-for-other",
        "defaultMessage": "Search ( <wrapper><command>Ctrl</command> + <key>K</key></wrapper> )"
    },
    labelForMacScreenReader: {
        "id": "atlassian-navigation.settings.command-palette-search-button.label-for-mac-screen-reader",
        "defaultMessage": "Search ( command plus K ) to search Jira settings"
    },
    labelForOtherScreenReader: {
        "id": "atlassian-navigation.settings.command-palette-search-button.label-for-other-screen-reader",
        "defaultMessage": "Search ( control plus K ) to search Jira settings"
    }
});

});


parcelRegister("e57bL", function(module, exports) {

$parcel$export(module.exports, "Home", () => $f8508cd3b3bbf491$export$b94310965bed44e6);

var $5uXOq = parcelRequire("5uXOq");

var $9UCCQ = parcelRequire("9UCCQ");

var $6lwNs = parcelRequire("6lwNs");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $3HwlS = parcelRequire("3HwlS");

var $d4B4Y = parcelRequire("d4B4Y");

var $7ilb8 = parcelRequire("7ilb8");

var $4drrb = parcelRequire("4drrb");
const $f8508cd3b3bbf491$export$b94310965bed44e6 = ({ messages: messages = (0, $6lwNs.default), settingsDrawerItems: settingsDrawerItems, testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if ((0, $3HwlS.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, settingsDrawerItems.map((group)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
            key: group.id,
            testId: (0, $6cNb0.testIdConcat)(testIdPrefix, group.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4drrb.HomeHeading), {
            group: group,
            messages: messages,
            testIdPrefix: testIdPrefix
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuList), null, group.items && group.items.map((item, idx)=>{
            if (item.type === 'Content' && item.content) {
                const content = item.content({
                    update: ()=>Promise.resolve(null),
                    isOpen: false,
                    setInitialFocusRef: ()=>null
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                    key: item.id
                }, content);
            }
            if (item.href === null || item.href === undefined) return null;
            if (item.text === null || item.text === undefined) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
                key: item.id,
                ariaLabel: formatMessage(messages[group.id])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
                analytics: {
                    actionSubjectId: 'settingsNavigationMenuItem',
                    menuItemId: item.id,
                    menuItemType: group.id === 'site-admin' ? 'adminSettings' : 'jiraSettings',
                    position: idx
                },
                iconBefore: item.before ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(item.before, null) : null,
                iconAfter: item.after ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(item.after, {
                    isHover: true
                }) : null,
                href: item.href,
                // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type '(("_self" | "_blank" | "_parent" | "_top") & HTMLAttributeAnchorTarget) | undefined'.
                target: item.target,
                testId: (0, $6cNb0.testIdConcat)(testIdPrefix, group.id, `item-${item.id}`),
                description: item.description || ''
            }, item.text || ''));
        })))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, settingsDrawerItems.map((group)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
            key: group.id,
            testId: (0, $6cNb0.testIdConcat)(testIdPrefix, group.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4drrb.HomeHeading), {
            group: group,
            messages: messages,
            testIdPrefix: testIdPrefix
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuList), null, group.items && group.items.map((item, idx)=>{
            if (item.href === null || item.href === undefined) return null;
            if (item.text === null || item.text === undefined) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
                key: item.id,
                ariaLabel: formatMessage(messages[group.id])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
                analytics: {
                    actionSubjectId: 'settingsNavigationMenuItem',
                    menuItemId: item.id,
                    menuItemType: group.id === 'site-admin' ? 'adminSettings' : 'jiraSettings',
                    position: idx
                },
                iconBefore: item.before ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(item.before, null) : null,
                iconAfter: item.after ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(item.after, {
                    isHover: true
                }) : null,
                href: item.href,
                // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type '(("_self" | "_blank" | "_parent" | "_top") & HTMLAttributeAnchorTarget) | undefined'.
                target: item.target,
                testId: (0, $6cNb0.testIdConcat)(testIdPrefix, group.id, `item-${item.id}`),
                description: messages[item.id] ? formatMessage(messages[item.id]) : undefined
            }, item.text || ''));
        })))));
};

});
parcelRegister("4drrb", function(module, exports) {

$parcel$export(module.exports, "HomeHeading", () => $fd56d3368a0677f4$export$e2344e30272a44c1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4mNf3 = parcelRequire("4mNf3");

var $l1N8i = parcelRequire("l1N8i");

var $MHKc7 = parcelRequire("MHKc7");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $3HwlS = parcelRequire("3HwlS");

const $fd56d3368a0677f4$export$e2344e30272a44c1 = ({ group: group, messages: messages, testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const headingMessage = (0, $5uXOq.useMemo)(()=>formatMessage(messages[group.id]), [
        formatMessage,
        group.id,
        messages
    ]);
    if ((0, $3HwlS.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        paddingInline: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        testId: (0, $6cNb0.testIdConcat)(testIdPrefix, group.id, 'heading'),
        size: "xxsmall"
    }, group.heading || ''));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4mNf3.default), {
        headingLevel: 3,
        testId: (0, $6cNb0.testIdConcat)(testIdPrefix, group.id, 'heading')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fd56d3368a0677f4$var$HeadingContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, headingMessage), !!group.sideHeading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": (0, $f524727bc2d3810c$export$f707547fc95f31c2)
    }, group.sideHeading())));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fd56d3368a0677f4$var$HeadingContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4",
            __cmplp.className
        ])
    });
});

});
const $f524727bc2d3810c$export$f707547fc95f31c2 = 'atlassian-navigation.ui.settings.menu.home.heading.side-heading';



parcelRegister("asDBE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e49dd60f5b63059$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6e49dd60f5b63059$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    settings: {
        "id": "atlassian-navigation.settings.menu.settings",
        "defaultMessage": "Settings"
    }
});

});

parcelRegister("6svfi", function(module, exports) {

$parcel$export(module.exports, "Personal", () => $3dfa9666dd9cff1a$export$3965927bf7a81700);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $jDorM = parcelRequire("jDorM");

var $1bKdn = parcelRequire("1bKdn");

var $MHKc7 = parcelRequire("MHKc7");
var $bUmQV = parcelRequire("bUmQV");

var $23aI7 = parcelRequire("23aI7");

var $6Lc8h = parcelRequire("6Lc8h");

var $7paD5 = parcelRequire("7paD5");

var $4mNf3 = parcelRequire("4mNf3");
var $9UCCQ = parcelRequire("9UCCQ");

var $l1N8i = parcelRequire("l1N8i");

var $itmJb = parcelRequire("itmJb");

var $6s1PB = parcelRequire("6s1PB");

var $3JGmH = parcelRequire("3JGmH");

var $5U49F = parcelRequire("5U49F");

var $6lwNs = parcelRequire("6lwNs");

var $koVbs = parcelRequire("koVbs");

var $2EqxS = parcelRequire("2EqxS");

var $6cNb0 = parcelRequire("6cNb0");

var $3HwlS = parcelRequire("3HwlS");

var $1C2yb = parcelRequire("1C2yb");

var $cYlk7 = parcelRequire("cYlk7");

var $7ziML = parcelRequire("7ziML");

var $7ilb8 = parcelRequire("7ilb8");

var $d4B4Y = parcelRequire("d4B4Y");

var $ao1KY = parcelRequire("ao1KY");

var $6zdS6 = parcelRequire("6zdS6");
const $3dfa9666dd9cff1a$export$3965927bf7a81700 = ({ testIdPrefix: testIdPrefix })=>{
    const { data: data } = (0, $cYlk7.useCurrentUser)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    // @ts-expect-error - TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
    const email = data.user?.emailAddress;
    const atlassianPersonalSettingsLink = (0, $2EqxS.useAtlassianPersonalSettingsLink)(email);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'personal-settings');
    if ((0, $3HwlS.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        testId: testId
    }, isAdmin && (0, $6s1PB.expVal)('improve_visibility_of_command_palette_for_admins', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
        justifyContent: "space-between",
        alignItems: "center",
        xcss: $3dfa9666dd9cff1a$var$styles.nav4HeaderContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3dfa9666dd9cff1a$var$HeadingComponent, {
        heading: formatMessage((0, $6lwNs.default).personalJiraSettings),
        testId: (0, $6cNb0.testIdConcat)(testId, 'heading')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ao1KY.CommandPaletteSearchButton), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3dfa9666dd9cff1a$var$HeadingComponent, {
        heading: formatMessage((0, $6lwNs.default).personalJiraSettings),
        testId: (0, $6cNb0.testIdConcat)(testId, 'heading')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
        ariaLabel: formatMessage((0, $6lwNs.default).personalJiraSettings)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'settingsNavigationMenuItem',
            menuItemId: 'personal-jira-settings',
            menuItemType: 'personalSettings',
            position: 0
        },
        description: formatMessage((0, $6zdS6.default).generalSettingsDescription),
        href: (0, $1C2yb.getGeneralPersonalSettingsPath)(),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bKdn))), {
            label: "",
            color: "var(--ds-icon, #44546F)"
        }),
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-personal-jira-settings'),
        to: (0, $7ziML.generalPersonalSettingsRoute)
    }, formatMessage((0, $6zdS6.default).generalSettingsLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
        ariaLabel: formatMessage((0, $6lwNs.default).personalJiraSettings)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'settingsNavigationMenuItem',
            menuItemId: 'account-settings',
            menuItemType: 'personalSettings',
            position: 1
        },
        description: formatMessage((0, $6zdS6.default).notificationSettingsDescription),
        href: "/jira/settings/personal/notifications",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jDorM))), {
            label: "",
            color: "var(--ds-icon, #44546F)"
        }),
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-account-settings')
    }, formatMessage((0, $6zdS6.default).notificationSettingsLabel)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4mNf3.default), {
        headingLevel: 3,
        testId: (0, $6cNb0.testIdConcat)(testId, 'heading')
    }, formatMessage((0, $6lwNs.default)[(0, $3JGmH.JIRA_SETTINGS_SECTION_IDS).PERSONAL])), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
        ariaLabel: formatMessage((0, $6lwNs.default)[(0, $3JGmH.JIRA_SETTINGS_SECTION_IDS).PERSONAL])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'settingsNavigationMenuItem',
            menuItemId: 'account-settings',
            menuItemType: 'personalSettings',
            position: 0
        },
        description: formatMessage((0, $6zdS6.default).accountSettingsDescription),
        href: atlassianPersonalSettingsLink,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5U49F.IconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23aI7))), {
            size: "small",
            primaryColor: "var(--ds-icon-inverse, #FFFFFF)",
            label: ""
        })),
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
            LEGACY_size: "small",
            label: ""
        }),
        target: "_blank",
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-account-settings')
    }, formatMessage((0, $6zdS6.default).accountSettings))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
        ariaLabel: formatMessage((0, $6lwNs.default)[(0, $3JGmH.JIRA_SETTINGS_SECTION_IDS).PERSONAL])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'settingsNavigationMenuItem',
            menuItemId: 'personal-jira-settings',
            menuItemType: 'personalSettings',
            position: 1
        },
        description: formatMessage((0, $6zdS6.default).personalJiraSettingsDescription),
        href: (0, $1C2yb.getGeneralPersonalSettingsPath)(),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5U49F.IconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Lc8h))), {
            LEGACY_size: "small",
            color: "var(--ds-icon-inverse, #FFFFFF)",
            label: ""
        })),
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-personal-jira-settings'),
        to: (0, $7ziML.generalPersonalSettingsRoute)
    }, formatMessage((0, $6zdS6.default).personalJiraSettings)))));
};
const $3dfa9666dd9cff1a$var$HeadingComponent = (props)=>{
    const { heading: heading, testId: testId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        paddingInline: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        testId: testId,
        size: "xxsmall"
    }, heading));
};
const $3dfa9666dd9cff1a$var$styles = {
    nav4HeaderContainerStyles: "_u5f3pxbi"
};

});
parcelRegister("6zdS6", function(module, exports) {

$parcel$export(module.exports, "default", () => $73a9428fb9b2a405$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $73a9428fb9b2a405$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    accountSettings: {
        "id": "atlassian-navigation.settings.menu.personal.account-settings",
        "defaultMessage": "Atlassian account settings"
    },
    accountSettingsDescription: {
        "id": "atlassian-navigation.settings.menu.personal.account-settings-description",
        "defaultMessage": "Manage your language, time zone, and other profile information."
    },
    personalJiraSettings: {
        "id": "atlassian-navigation.settings.menu.personal.personal-jira-settings",
        "defaultMessage": "Personal Jira settings"
    },
    personalJiraSettingsDescription: {
        "id": "atlassian-navigation.settings.menu.personal.personal-jira-settings-description",
        "defaultMessage": "Manage your email notifications and other Jira settings."
    },
    commandPaletteSearchButtonLabelMac: {
        "id": "atlassian-navigation.settings.menu.personal.command-palette-search-button-label-mac",
        "defaultMessage": "Search ( <wrapper><command>\u2318</command> + <key>K</key></wrapper> )"
    },
    commandPaletteSearchButtonLabelOther: {
        "id": "atlassian-navigation.settings.menu.personal.command-palette-search-button-label-other",
        "defaultMessage": "Search ( <wrapper><command>Ctrl</command> + <key>K</key></wrapper> )"
    },
    // Nav4 Messages
    generalSettingsLabel: {
        "id": "atlassian-navigation.settings.menu.personal.general-settings-label",
        "defaultMessage": "General settings"
    },
    generalSettingsDescription: {
        "id": "atlassian-navigation.settings.menu.personal.general-settings-description",
        "defaultMessage": "Manage language, time zone, and other personal preferences"
    },
    notificationSettingsLabel: {
        "id": "atlassian-navigation.settings.menu.personal.notification-settings-label",
        "defaultMessage": "Notification settings"
    },
    notificationSettingsDescription: {
        "id": "atlassian-navigation.settings.menu.personal.notification-settings-description",
        "defaultMessage": "Manage email and in-product notifications from Jira"
    }
});

});


parcelRegister("b59xm", function(module, exports) {

$parcel$export(module.exports, "Warning", () => $d53d46adbad8e7db$export$c688898c4e3580ee);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $e4yMr = parcelRequire("e4yMr");

var $9UCCQ = parcelRequire("9UCCQ");

var $ousew = parcelRequire("ousew");

var $aWse0 = parcelRequire("aWse0");

var $6cNb0 = parcelRequire("6cNb0");

var $8Vm26 = parcelRequire("8Vm26");
const $d53d46adbad8e7db$export$c688898c4e3580ee = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'warning');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d53d46adbad8e7db$export$e6dfd72ab29f8598, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $8Vm26.default).noAdminPermissionMessage,
        values: {
            contact: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                href: "/secure/ContactAdministrators!default.jspa"
            }, formatMessage((0, $8Vm26.default).noAdminPermissionMessageContact))
        }
    })));
};
const $d53d46adbad8e7db$export$e6dfd72ab29f8598 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d53d46adbad8e7db$var$Outer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d53d46adbad8e7db$var$Inner, null, children));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d53d46adbad8e7db$var$Outer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qu2gc _u5f3v47k _n3tdutpp _19bvv47k",
            __cmplp.className
        ])
    });
});
const $d53d46adbad8e7db$var$Inner = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _p12f1kdj _bfhk1tzq _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8Vm26", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed016ce81d29e02d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ed016ce81d29e02d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noAdminPermissionMessage: {
        "id": "atlassian-navigation.settings.menu.warning.no-admin-permission-message",
        "defaultMessage": "You do not have access to Jira settings or Atlassian admin, {contact} to grant you access."
    },
    noAdminPermissionMessageContact: {
        "id": "atlassian-navigation.settings.menu.warning.no-admin-permission-message-contact",
        "defaultMessage": "contact your Jira admin"
    }
});

});



parcelRegister("3Ug2v", function(module, exports) {

$parcel$export(module.exports, "settingsMenuEntryPoint", () => $2f15e587ee559e13$export$61e5d93bdc8bc226);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $2f15e587ee559e13$export$61e5d93bdc8bc226 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("hrU50"))).then(({ MenuWithEntryPoint: MenuWithEntryPoint })=>MenuWithEntryPoint), {
        moduleId: "c918b04e",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});


parcelRegister("2YzXO", function(module, exports) {

$parcel$export(module.exports, "SignIn", () => $ecced68b9b5eee26$export$b64708c6f1b3ed96);

var $5uXOq = parcelRequire("5uXOq");

var $krXdA = parcelRequire("krXdA");

var $pkYLA = parcelRequire("pkYLA");

var $aWse0 = parcelRequire("aWse0");

var $3HwlS = parcelRequire("3HwlS");

var $cZpsT = parcelRequire("cZpsT");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $iPj86 = parcelRequire("iPj86");

var $avqpn = parcelRequire("avqpn");

var $jZF14 = parcelRequire("jZF14");
const $ecced68b9b5eee26$var$SignIn = ({ useDestinationParam: // eslint-disable-next-line react-hooks/react-compiler
useDestinationParam = (0, $jZF14.useDestinationParam), useIntl: // eslint-disable-next-line react-hooks/react-compiler
useIntl = (0, $aWse0.useIntlV2), useNavigationItemAnalytics: // eslint-disable-next-line react-hooks/react-compiler
useNavigationItemAnalytics = (0, $iPj86.useNavigationItemAnalytics), useIsAnonymous: // eslint-disable-next-line react-hooks/react-compiler
useIsAnonymous = (0, $cZpsT.useIsAnonymous) })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const destinationParam = useDestinationParam();
    // eslint-disable-next-line react-hooks/react-compiler
    const isAnonymous = useIsAnonymous();
    // eslint-disable-next-line react-hooks/react-compiler
    const { formatMessage: formatMessage } = useIntl();
    // eslint-disable-next-line react-hooks/react-compiler
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).SIGN_IN
    });
    if (!isAnonymous) return null;
    if ((0, $3HwlS.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $krXdA.default), {
        href: `/login.jsp?${destinationParam}`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($pkYLA))),
        label: formatMessage((0, $avqpn.default).signIn),
        isTooltipDisabled: false,
        appearance: "subtle",
        // @ts-expect-error - TS2769 - No overload matches this call.
        onClick: triggerAnalytics
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $krXdA.default), {
        href: `/login.jsp?${destinationParam}`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($pkYLA))),
        label: formatMessage((0, $avqpn.default).signIn),
        isTooltipDisabled: false,
        appearance: "subtle",
        // @ts-expect-error - TS2769 - No overload matches this call.
        onClick: triggerAnalytics
    }));
};
const $ecced68b9b5eee26$export$b64708c6f1b3ed96 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $Mp6qH.NAVIGATION_ITEM_ID).SIGN_IN
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ecced68b9b5eee26$var$SignIn, props));

});
parcelRegister("avqpn", function(module, exports) {

$parcel$export(module.exports, "default", () => $04389e942ceaefeb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $04389e942ceaefeb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    signIn: {
        "id": "atlassian-navigation.sign-in.sign-in",
        "defaultMessage": "Sign in"
    }
});

});

parcelRegister("jZF14", function(module, exports) {

$parcel$export(module.exports, "useDestinationParam", () => $80954d3accb3f049$export$c9c176e0725165cc);

var $j0xEB = parcelRequire("j0xEB");
const $80954d3accb3f049$export$c9c176e0725165cc = ()=>{
    const { href: href = null } = (0, $j0xEB.default)() || {};
    if (href && !href.includes('login.jsp')) {
        const encodedRedirectUrl = encodeURIComponent(href);
        return `os_destination=${encodedRedirectUrl}`;
    }
    return '';
};

});


parcelRegister("2E6jA", function(module, exports) {

$parcel$export(module.exports, "Nav4NotificationsData", () => $61e3aa9159c11335$export$4be76e93f368ccd9);

var $4P1ax = parcelRequire("4P1ax");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7CMCs = parcelRequire("7CMCs");

var $Mp6qH = parcelRequire("Mp6qH");

var $dFNPB = parcelRequire("dFNPB");
const $61e3aa9159c11335$export$4be76e93f368ccd9 = (props)=>{
    const { queryReference: queryReference } = props;
    const fragmentData = (0, $8Uumt.useFragment)((0, $4P1ax.default), queryReference);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "nav4-notifications-error-boundary",
        packageName: (0, $Mp6qH.PACKAGE_NAME),
        teamName: (0, $Mp6qH.TEAM_NAME),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dFNPB.Nav4Notifications), {
        fragmentData: fragmentData
    }));
};

});
parcelRegister("4P1ax", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c394e155eea9691$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ab5a4efb2e4c302f6507731481aad167>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2c394e155eea9691$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4NotificationsData",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Nav4Notifications"
        }
    ],
    "type": "Query"
};
$2c394e155eea9691$var$node.hash = "359a3dc4bc79536755e5a1c2e1775462";
var $2c394e155eea9691$export$2e2bcd8739ae039 = $2c394e155eea9691$var$node;

});

parcelRegister("dFNPB", function(module, exports) {

$parcel$export(module.exports, "Nav4Notifications", () => $aa3a9f45bb52149a$export$c50c32b171c62438);

var $aH68m = parcelRequire("aH68m");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $1I7E8 = parcelRequire("1I7E8");

var $ggewM = parcelRequire("ggewM");

var $6cNb0 = parcelRequire("6cNb0");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $2Ui4E = parcelRequire("2Ui4E");

var $lmyls = parcelRequire("lmyls");

var $kaHBi = parcelRequire("kaHBi");

var $koVbs = parcelRequire("koVbs");

var $kxZPA = parcelRequire("kxZPA");

var $c0dQj = parcelRequire("c0dQj");

var $jbk4C = parcelRequire("jbk4C");

var $2YZCu = parcelRequire("2YZCu");

var $4R6GH = parcelRequire("4R6GH");

var $Mp6qH = parcelRequire("Mp6qH");

var $iPj86 = parcelRequire("iPj86");

var $keCgG = parcelRequire("keCgG");

var $6v03K = parcelRequire("6v03K");

var $inFGE = parcelRequire("inFGE");

var $8s8Nt = parcelRequire("8s8Nt");


var $b7Ryd = parcelRequire("b7Ryd");

var $5vuhU = parcelRequire("5vuhU");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $aa3a9f45bb52149a$var$LazyMenu = (0, $kxZPA.lazy)(()=>(parcelRequire("b7gz4")).then(({ Menu: Menu })=>Menu), {
    ssr: false,
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/notifications/menu/index.tsx"
});
const $aa3a9f45bb52149a$export$c50c32b171c62438 = (props)=>{
    const { fragmentData: fragmentData } = props;
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const [_queryRef, loadQuery] = (0, $8Uumt.useQueryLoader)((0, $jbk4C.default));
    const [data] = (0, $8Uumt.useRefetchableFragment)((0, $aH68m.default), fragmentData);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    // Check for new notifications every 5 minutes. This is currently done through polling because
    // Relay subscriptions are not yet supported server side. This polling will need to be replaced with
    // a subscription in the future (when notifications are migrated to Post Office).
    (0, $6v03K.usePolling)((0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-2') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useCallback)(()=>{
        if ((0, $4R6GH.fg)('blu-7858-only-poll-notifications-active-tabs')) {
            if ((0, $ggewM.getDocument)()?.hidden) return;
        }
        (0, $8Uumt.fetchQuery)(environment, (0, $jbk4C.default), {}).subscribe({
            complete: ()=>{
                loadQuery({}, {
                    fetchPolicy: 'store-and-network'
                });
            },
            error: (error)=>{
                (0, $2YZCu.default).safeErrorWithoutCustomerData(`${(0, $Mp6qH.PACKAGE_NAME)}.Nav4Notifications`, 'Error fetching notification', error);
            }
        });
    }, [
        environment,
        loadQuery
    ]) : ()=>{
        if ((0, $4R6GH.fg)('blu-7858-only-poll-notifications-active-tabs')) {
            if ((0, $ggewM.getDocument)()?.hidden) return;
        }
        (0, $8Uumt.fetchQuery)(environment, (0, $jbk4C.default), {}).subscribe({
            complete: ()=>{
                loadQuery({}, {
                    fetchPolicy: 'store-and-network'
                });
            },
            error: (error)=>{
                (0, $2YZCu.default).safeErrorWithoutCustomerData(`${(0, $Mp6qH.PACKAGE_NAME)}.Nav4Notifications`, 'Error fetching notification', error);
            }
        });
    }, 300000);
    const fetchedNotificationsCount = data.notifications?.unseenNotificationCount ?? 0;
    // Initialise the state to false on page load, but use an effect to update it if the unseen notification
    // count changes (i.e. as a result of polling) to ensure the badge is shown when there are new notifications.
    const [isNotificationCleared, setIsNotificationCleared] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (fetchedNotificationsCount > 0) setIsNotificationCleared(false);
    }, [
        fetchedNotificationsCount
    ]);
    // If notifications have been cleared, force the badge to be 0. This crudely addresses a race condition where
    // opening the menu (which resets the unseen notification count) does not complete before a refetch completes.
    const notificationsCount = isNotificationCleared ? 0 : fetchedNotificationsCount;
    const testIdPrefix = (0, $6cNb0.testIdGenerate)('secondary-actions', 'notifications');
    const [isMenuOpen, { toggle: toggleMenu, off: closeMenu, on: openMenu }] = (0, $2Ui4E.useTopMenus)((0, $lmyls.MENU_ID).NOTIFICATIONS);
    const content = (0, $5uXOq.useCallback)(({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $inFGE.NotificationsContentWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
            id: "notifications.list.async",
            packageName: "AtlassianNavigation",
            teamName: "navigation"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "notification-menu-native",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aa3a9f45bb52149a$var$LazyMenu, {
            scheduleUpdate: update,
            testIdPrefix: testIdPrefix
        })))), [
        testIdPrefix
    ]);
    const triggerAnalytics = (0, $iPj86.useNavigationItemAnalytics)({
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).NOTIFICATIONS
    });
    const onStart = (0, $kaHBi.useExperienceStart)({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $Mp6qH.NAVIGATION_ITEM_ID).NOTIFICATIONS,
        analyticsSource: 'atlassian-navigation'
    });
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (isMenuOpen) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        performance.clearMarks('notification.list.render.start');
        else performance.mark('notification.list.render.start');
        onStart();
        toggleMenu();
        triggerAnalytics();
        // Always set isNotificationCleared to true when the menu trigger is clicked
        // that there are no unseen notifications).
        setIsNotificationCleared(true);
    // PLEASE NOTE: Refetching the notifications does not occur here because for some reason
    // it blocks the popup from being closed.
    }, [
        isMenuOpen,
        onStart,
        toggleMenu,
        triggerAnalytics
    ]);
    (0, $5vuhU.useRegisterNotificationsInCommandPalette)(onClick);
    const badge = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8s8Nt.Nav4NotificationsBadge), {
            count: notificationsCount
        }), [
        notificationsCount
    ]);
    const notificationsLabel = notificationsCount < (0, $3c41b45407aae96c$export$14c62ba6f49b806f) ? formatMessage((0, $b7Ryd.default).label, {
        count: notificationsCount
    }) : formatMessage((0, $b7Ryd.default).overNineNotifications);
    const trigger = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'triggerProps' implicitly has an 'any' type.
    (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": (0, $6cNb0.testIdConcat)(testIdPrefix, 'menu-trigger'),
            "data-vc": `atlassian-navigation-notifications${false ? '-ssr' : ''}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $keCgG.Notification), {
            ...triggerProps,
            badge: badge,
            isSelected: isMenuOpen,
            onClick: onClick,
            tooltip: formatMessage((0, $b7Ryd.default).tooltip),
            label: notificationsLabel,
            onViewRequests: openMenu
        })), [
        badge,
        formatMessage,
        isMenuOpen,
        notificationsLabel,
        onClick,
        openMenu,
        testIdPrefix
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
        content: content,
        isOpen: isMenuOpen,
        onClose: closeMenu,
        placement: "bottom-end",
        trigger: trigger,
        shouldRenderToParent: true,
        shouldFitViewport: (0, $c0dQj.isMobileAndInViewPanelIterationExperiment)() ? true : undefined
    });
};

});
parcelRegister("aH68m", function(module, exports) {

$parcel$export(module.exports, "default", () => $66a2c8d85b91b234$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<39ea3d6e0f88481971cec9a363b97835>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $jbk4C = parcelRequire("jbk4C");
const $66a2c8d85b91b234$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "refetch": {
            "fragmentPathInResult": [],
            "operation": (0, $jbk4C.default)
        }
    },
    "name": "Nav4Notifications",
    "selections": [
        {
            "concreteType": "InfluentsNotificationQuery",
            "kind": "LinkedField",
            "name": "notifications",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "unseenNotificationCount"
                }
            ]
        }
    ],
    "type": "Query"
};
$66a2c8d85b91b234$var$node.hash = "9fa4e72bf771cce7bab0cd69ec168049";
var $66a2c8d85b91b234$export$2e2bcd8739ae039 = $66a2c8d85b91b234$var$node;

});
parcelRegister("jbk4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbc9d5ac7020c75c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0e946028ffc3086f1d9efb784e3dbaa5>>
 * @relayHash b27ca3910e82a09b8cdc053e9a61ed19
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f56bec76aa8f8c1f4592fbdd8e4dc7b3b3e88310f264e6c19fece22372dba44e
const $fbc9d5ac7020c75c$var$node = {
    "fragment": {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "Nav4NotificationsRefetchableQuery",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "Nav4Notifications"
            }
        ],
        "type": "Query"
    },
    "kind": "Request",
    "operation": {
        "argumentDefinitions": [],
        "kind": "Operation",
        "name": "Nav4NotificationsRefetchableQuery",
        "selections": [
            {
                "concreteType": "InfluentsNotificationQuery",
                "kind": "LinkedField",
                "name": "notifications",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "unseenNotificationCount"
                    }
                ]
            }
        ]
    },
    "params": {
        "id": "f56bec76aa8f8c1f4592fbdd8e4dc7b3b3e88310f264e6c19fece22372dba44e",
        "metadata": {},
        "name": "Nav4NotificationsRefetchableQuery",
        "operationKind": "query",
        "text": null
    }
};
$fbc9d5ac7020c75c$var$node.hash = "9fa4e72bf771cce7bab0cd69ec168049";
var $fbc9d5ac7020c75c$export$2e2bcd8739ae039 = $fbc9d5ac7020c75c$var$node;

});


parcelRegister("6v03K", function(module, exports) {

$parcel$export(module.exports, "usePolling", () => $05a8008a7f962bd5$export$a11f73e3adecd502);

var $5uXOq = parcelRequire("5uXOq");
const $05a8008a7f962bd5$export$a11f73e3adecd502 = (callback, delay)=>{
    const callbackRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        callbackRef.current = callback;
    }, [
        callback
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const tick = ()=>{
            if (callbackRef.current) callbackRef.current();
        };
        if (delay !== null) {
            const id = setInterval(tick, delay);
            return ()=>clearInterval(id);
        }
    }, [
        delay
    ]);
};

});

parcelRegister("8s8Nt", function(module, exports) {

$parcel$export(module.exports, "Nav4NotificationsBadge", () => $f526d936b34d800d$export$c4129d57a4559409);

var $5uXOq = parcelRequire("5uXOq");

var $jd94h = parcelRequire("jd94h");
const $f526d936b34d800d$export$c4129d57a4559409 = (props)=>{
    const { count: count } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jd94h.Nav4NotificationsIndicator), {
        count: count
    });
};

});
parcelRegister("jd94h", function(module, exports) {

$parcel$export(module.exports, "Nav4NotificationsIndicator", () => $e95bd3f66906bc5b$export$6891e3964002ac9);

var $5uXOq = parcelRequire("5uXOq");

var $16T6Y = parcelRequire("16T6Y");
const $e95bd3f66906bc5b$var$MAX_NOTIFICATIONS_COUNT = 9;
const $e95bd3f66906bc5b$export$6891e3964002ac9 = (props)=>{
    const { appearance: appearance = 'important', count: count, max: max = $e95bd3f66906bc5b$var$MAX_NOTIFICATIONS_COUNT } = props;
    return count ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-test-selector": "NotificationIndicator"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), {
        testId: "atlassian-navigation.ui.notifications.notification-indicator-badge",
        max: max,
        appearance: appearance
    }, count)) : null;
};

});




parcelRegister("hyppP", function(module, exports) {

module.exports = (parcelRequire("avM1e"))('blu-6347-app-switcher-ep', function() {
    return parcelRequire('hwY9o');
}, function() {
    return parcelRequire('6RKvu');
});

});




parcelRegister("jG2fI", function(module, exports) {

$parcel$export(module.exports, "PreviewPanel", () => $c27e7e0414f27fd5$export$9520f072db304aa0);

var $5uXOq = parcelRequire("5uXOq");

var $3AWiS = parcelRequire("3AWiS");

var $7CMCs = parcelRequire("7CMCs");

var $iqLcb = parcelRequire("iqLcb");

var $hxB2k = parcelRequire("hxB2k");

var $aWse0 = parcelRequire("aWse0");

var $1SnzR = parcelRequire("1SnzR");
const $c27e7e0414f27fd5$export$9520f072db304aa0 = ()=>{
    const panel = (0, $hxB2k.useCurrentPreviewPanel)();
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const onResizeEnd = (0, $5uXOq.useCallback)(({ finalWidth: finalWidth })=>{
        panel?.setWidth?.(finalWidth);
    }, [
        panel
    ]);
    if (panel === null) return null;
    const { content: PanelContent, width: width } = panel;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.RightPanel), {
        width: width,
        testId: "page-container-v2.common.ui.preview-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        id: "preview-panel-route-components",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(PanelContent, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3AWiS.PanelSplitter), {
        label: formatMessage((0, $1SnzR.messages).previewPanelSplitterLabel),
        onResizeEnd: onResizeEnd,
        testId: "page-container-v2.common.ui.preview-panel.panel-splitter"
    })));
};

});
parcelRegister("1SnzR", function(module, exports) {

$parcel$export(module.exports, "messages", () => $dc9bd6dbea5cfb90$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $dc9bd6dbea5cfb90$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    previewPanelSplitterLabel: {
        "id": "page-container-v2.common.preview-panel.preview-panel-splitter-label",
        "defaultMessage": "Resize preview panel"
    }
});

});


parcelRegister("lvpKt", function(module, exports) {

$parcel$export(module.exports, "FullHeight", () => $c63a700e8bea75a2$export$33e617ec5e4e4f76);

var $5uXOq = parcelRequire("5uXOq");
const $c63a700e8bea75a2$var$styleFullHeight = {
    height: '100vh'
};
const $c63a700e8bea75a2$export$33e617ec5e4e4f76 = ({ children: children })=>// eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        style: $c63a700e8bea75a2$var$styleFullHeight
    }, children);

});

parcelRegister("cCEqp", function(module, exports) {

$parcel$export(module.exports, "GlobalThemeSetter", () => $6a2746c2dee00552$export$c8947eb2c95eab56);

var $5uXOq = parcelRequire("5uXOq");

var $7TUFF = parcelRequire("7TUFF");
var $hxoiH = parcelRequire("hxoiH");

var $fjcgS = parcelRequire("fjcgS");

var $2Ql51 = parcelRequire("2Ql51");

var $2YP9W = parcelRequire("2YP9W");
const $6a2746c2dee00552$var$darkThemeMediaMatchQuery = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)');

const $6a2746c2dee00552$export$c8947eb2c95eab56 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)((0, $2Ql51.themePreferenceResource));
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    const [isThemeStylesInHead, setIsThemeStylesInHead] = (0, $5uXOq.useState)(false);
    const setThemeWithToken = (0, $5uXOq.useCallback)(async (theme)=>{
        if (theme !== colorMode) {
            const { loadThemeTokens: loadThemeTokens } = await (parcelRequire("bEZpS"));
            loadThemeTokens(theme);
        }
    }, [
        colorMode
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (loading || error || !data) return undefined;
        // Combine the themes 'dark', 'light' and 'auto' after @atlaskit/tokens@1.0.0
        // https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/27634
        if (data?.theme === 'auto') {
            setThemeWithToken($6a2746c2dee00552$var$darkThemeMediaMatchQuery?.matches ? 'dark' : 'light');
            const handler = (e)=>{
                setThemeWithToken(e.matches ? 'dark' : 'light');
            };
            $6a2746c2dee00552$var$darkThemeMediaMatchQuery?.addEventListener('change', handler);
            return ()=>{
                $6a2746c2dee00552$var$darkThemeMediaMatchQuery?.removeEventListener('change', handler);
            };
        }
        if (data?.theme === 'dark' || data?.theme === 'light') setThemeWithToken(data?.theme);
        if (!data?.theme) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.documentElement.removeAttribute('data-theme');
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.documentElement.removeAttribute('data-color-mode');
        }
        return undefined;
    }, [
        data,
        loading,
        error,
        setThemeWithToken
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (loading || error || !data) return;
        (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            if (data?.theme) client.setUIViewedAttributes({
                theme: data.theme
            });
            else client.removeUIViewedAttribute('theme');
        });
    }, [
        data,
        loading,
        error
    ]);
    (0, $5uXOq.useEffect)(()=>{
        (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            client.setUIViewedAttributes({
                OStheme: $6a2746c2dee00552$var$darkThemeMediaMatchQuery?.matches ? 'dark' : 'light'
            });
        });
    }, []);
    // @atlaskit/tokens expects the theme styles to be in the <head /> but they're
    // initally rendered in the "jira-ssr" container in the <body /> and then moved to the
    // <head />. The following prevents the styles from being re-rendered in the <body />.
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.head.querySelector('style[data-theme]')) setIsThemeStylesInHead(true);
    }, []);
    if (!data?.theme || !data?.attrs || !data?.styles) return null;
    const ssrAutoScript = (0, $7TUFF.default)(data.theme);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !isThemeStylesInHead ? data.styles.map((theme)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", {
            key: theme.id,
            ...theme.attrs,
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: {
                __html: theme.css
            }
        })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("script", {
        "data-defer-skip": true,
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: data.styles.map((theme)=>`document.head.appendChild(document.body.querySelector('style[data-theme="${theme.id}"]'));`).join('\n')
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("script", {
        "data-defer-skip": true,
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: Object.entries(data.attrs).map(([key, val])=>{
                if (key === 'data-color-mode' && ssrAutoScript) return '';
                return `document.documentElement.setAttribute("${key}", "${val}");`;
            }).join('\n')
        }
    }), ssrAutoScript ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("script", {
        "data-defer-skip": true,
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: ssrAutoScript
        }
    }) : null);
};

});
parcelRegister("bEZpS", function(module, exports) {

let $87d31228309ffe0e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $87d31228309ffe0e$var$load("8rhZ2").then(()=>parcelRequire('gEdc8'));

});


parcelRegister("jmzCL", function(module, exports) {

$parcel$export(module.exports, "ProjectThemeSetter", () => $1f748255f8976437$export$fd1b0084c5bb04a9);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $ao2h1 = parcelRequire("ao2h1");

var $dZJHS = parcelRequire("dZJHS");

var $9V5k0 = parcelRequire("9V5k0");

var $6s1PB = parcelRequire("6s1PB");

var $dC4s3 = parcelRequire("dC4s3");

var $3Uek9 = parcelRequire("3Uek9");
const $1f748255f8976437$export$fd1b0084c5bb04a9 = ()=>{
    const { queryReference: queryReference } = (0, $ao2h1.useRelayResource)((0, $9V5k0.projectThemeResource));
    const { hasTheming: hasTheming } = (0, $6s1PB.expVal)('performance_improvement_in_use_project_theme', 'isEnabled', false) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3Uek9.useProjectTheme)() : {
        hasTheming: false
    };
    if (!queryReference || !hasTheming && (0, $6s1PB.expVal)('performance_improvement_in_use_project_theme', 'isEnabled', false)) /* The resource is available only for routes enabled for theming.
		We still need to set the default token color by using ThemeTokenSetter for all other routes.
		This can be removed once theming is enabled for all pages. */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC4s3.ThemeTokensSetter), {
        themeSetting: null
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "projectThemeSetter",
        packageName: "jiraPageContainerV2",
        teamName: "deliveroo"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "project-theme-setter-placeholder",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZJHS.ThemeSetter), {
        queryReference: queryReference
    })));
};

});
parcelRegister("dZJHS", function(module, exports) {

$parcel$export(module.exports, "ThemeSetter", () => $724d37049e8e9e6c$export$ce1303eaa27a0d3a);

var $ekkrg = parcelRequire("ekkrg");

var $cEpZ8 = parcelRequire("cEpZ8");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7eveN = parcelRequire("7eveN");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $3HwlS = parcelRequire("3HwlS");

var $6jY6G = parcelRequire("6jY6G");

var $dC4s3 = parcelRequire("dC4s3");

var $1MaBz = parcelRequire("1MaBz");

var $a2e2Q = parcelRequire("a2e2Q");

var $lmBAt = parcelRequire("lmBAt");

var $6s1PB = parcelRequire("6s1PB");

var $6cG4N = parcelRequire("6cG4N");
const $724d37049e8e9e6c$export$28580a1170c06a39 = {
    type: 'color',
    value: (0, $6cG4N.NO_BACKGROUND_CONFIG).name
};
const $724d37049e8e9e6c$export$ce1303eaa27a0d3a = ({ queryReference: queryReference })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const data = (0, $8Uumt.usePreloadedQuery)((0, $cEpZ8.default), queryReference);
    const backgroundData = (0, $8Uumt.useFragment)((0, $ekkrg.default), data.jira_projectByIdOrKey?.background ?? null);
    const { hasSoftwareTheming: hasSoftwareTheming, isSoftwareProject: isSoftwareProjectFromHook } = (0, $lmBAt.getIsSoftwareThemingEnabled)() ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $a2e2Q.useSoftwareProjectTheming)() : {
        hasSoftwareTheming: false,
        isSoftwareProject: false
    };
    const isSoftwareProjectFromQuery = data.jira_projectByIdOrKey?.projectType === 'SOFTWARE';
    const isSoftwareProject = (0, $6s1PB.expVal)('performance_improvement_in_use_project_theme', 'isEnabled', false) ? isSoftwareProjectFromQuery : isSoftwareProjectFromHook;
    const media = (0, $5uXOq.useMemo)(()=>{
        return data.jira.mediaClientId && data.jira.mediaExternalEndpointUrl ? {
            clientId: data.jira.mediaClientId,
            externalEndpointUrl: data.jira.mediaExternalEndpointUrl
        } : null;
    }, [
        data.jira.mediaClientId,
        data.jira.mediaExternalEndpointUrl
    ]);
    const isColorOnly = isSoftwareProject && !(0, $lmBAt.getIsSoftwareThemingM2Enabled)();
    const projectTheme = (0, $5uXOq.useMemo)(()=>{
        let themeSetting = null;
        if (!backgroundData) return null;
        switch(backgroundData.__typename){
            case 'JiraColorBackground':
                themeSetting = {
                    type: 'color',
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    value: backgroundData.colorValue
                };
                break;
            case 'JiraGradientBackground':
                themeSetting = isColorOnly ? $724d37049e8e9e6c$export$28580a1170c06a39 : {
                    type: 'color',
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    value: backgroundData.gradientValue
                };
                break;
            case 'JiraMediaBackground':
                if (isColorOnly) themeSetting = $724d37049e8e9e6c$export$28580a1170c06a39;
                else if (backgroundData.customBackground != null) {
                    const { id: id, mediaApiFileId: mediaApiFileId, mediaReadToken: mediaReadToken, sourceType: sourceType, sourceIdentifier: sourceIdentifier, altText: altText, dominantColor: dominantColor, brightness: brightness } = backgroundData.customBackground;
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    themeSetting = {
                        type: 'image',
                        value: 'image',
                        id: id,
                        mediaApiFileId: mediaApiFileId,
                        mediaReadToken: mediaReadToken,
                        sourceType: sourceType,
                        sourceIdentifier: sourceIdentifier,
                        altText: altText,
                        ...(0, $lmBAt.getIsSoftwareThemingM2Enabled)() && {
                            dominantColor: dominantColor,
                            brightness: brightness
                        }
                    };
                }
                break;
            default:
                themeSetting = null;
        }
        return themeSetting ? {
            themeSetting: themeSetting,
            entityId: `project/${data.jira_projectByIdOrKey?.projectId}`
        } : null;
    }, [
        backgroundData,
        data.jira_projectByIdOrKey?.projectId,
        isColorOnly
    ]);
    const overviewTheme = (0, $7eveN.useOverviewTheme)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const entityTheme = (0, $5uXOq.useMemo)(()=>{
        let result = projectTheme ?? overviewTheme;
        if (result != null) {
            const isFormSubmitView = route.name === 'classic-business-form-submit' || route.name === 'classic-business-form-submit-embed';
            // the form submit view doesn't use the project theme colors
            // since it is accessed externally to the project
            // remove themeSetting for pages in software projects that don't support theming yet
            if (isFormSubmitView || isSoftwareProject && !hasSoftwareTheming) result = {
                ...result,
                themeSetting: null
            };
        }
        return result;
    }, [
        projectTheme,
        overviewTheme,
        route.name,
        isSoftwareProject,
        hasSoftwareTheming
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const projectId = data.jira_projectByIdOrKey?.projectId;
        if (projectId) {
            if (data.jira_projectByIdOrKey?.projectType === 'BUSINESS' || data.jira_projectByIdOrKey?.projectType === 'SOFTWARE' && (0, $lmBAt.getIsSoftwareThemingEnabled)()) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'theme evaluated', {
                theme: entityTheme?.themeSetting?.value,
                projectId: projectId
            });
        }
    }, [
        entityTheme?.themeSetting?.value,
        data.jira_projectByIdOrKey?.projectId,
        data.jira_projectByIdOrKey?.projectType,
        createAnalyticsEvent
    ]);
    if ((0, $3HwlS.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC4s3.ThemeTokensSetter), {
        media: media,
        themeSetting: entityTheme?.themeSetting || null,
        projectType: data.jira_projectByIdOrKey?.projectType
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, entityTheme != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1MaBz.ThemeContainerOld), {
        isGlobal: true,
        ...entityTheme
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC4s3.ThemeTokensSetter), {
        media: media,
        themeSetting: entityTheme?.themeSetting || null,
        projectType: data.jira_projectByIdOrKey?.projectType
    }));
};

});
parcelRegister("ekkrg", function(module, exports) {

$parcel$export(module.exports, "default", () => $db9c998655de9ba4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<374b66672720180e9e36deb3d82661fe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $db9c998655de9ba4$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ThemeSetterBackground",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "colorValue"
                }
            ],
            "type": "JiraColorBackground"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "gradientValue"
                }
            ],
            "type": "JiraGradientBackground"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraCustomBackground",
                    "kind": "LinkedField",
                    "name": "customBackground",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "mediaApiFileId"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "durationInSeconds",
                                    "value": 900
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "mediaReadToken",
                            "storageKey": "mediaReadToken(durationInSeconds:900)"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "sourceType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "sourceIdentifier"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "altText"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "dominantColor"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "brightness"
                        }
                    ]
                }
            ],
            "type": "JiraMediaBackground"
        }
    ],
    "type": "JiraActiveBackgroundDetailsResult",
    "abstractKey": "__isJiraActiveBackgroundDetailsResult"
};
$db9c998655de9ba4$var$node.hash = "3c41e5a508924f980b8234232721902b";
var $db9c998655de9ba4$export$2e2bcd8739ae039 = $db9c998655de9ba4$var$node;

});

parcelRegister("7eveN", function(module, exports) {

$parcel$export(module.exports, "useOverviewTheme", () => $c0a2b1dfc34915dc$export$a55763fd17eab357);

var $6cG4N = parcelRequire("6cG4N");

var $jrO9m = parcelRequire("jrO9m");
const $c0a2b1dfc34915dc$export$a55763fd17eab357 = ()=>{
    const { data: data } = (0, $jrO9m.useOverview)();
    if (data != null) return {
        themeSetting: {
            type: 'color',
            value: data.theme ?? (0, $6cG4N.DEFAULT_BACKGROUND_CONFIG).name
        },
        entityId: `overview/${data.id}`
    };
    return null;
};

});

parcelRegister("dC4s3", function(module, exports) {

$parcel$export(module.exports, "ThemeTokensSetter", () => $5026069bddf1adf4$export$41f41c7ff10d45cd);

var $5uXOq = parcelRequire("5uXOq");

var $1UikQ = parcelRequire("1UikQ");

var $gwIPs = parcelRequire("gwIPs");

var $2vSU6 = parcelRequire("2vSU6");

var $6cG4N = parcelRequire("6cG4N");

var $fHEdP = parcelRequire("fHEdP");

var $3HwlS = parcelRequire("3HwlS");


var $lmBAt = parcelRequire("lmBAt");

var $4rtoO = parcelRequire("4rtoO");

var $1r9V3 = parcelRequire("1r9V3");
/**
 * Will merge multiple themes together, with the last theme taking precedence.
 * The first argument is the base theme, and the rest are partial themes that
 * will be merged into the base theme.
 */ function $5026069bddf1adf4$var$mergeThemes(theme, ...partialThemes) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, theme, ...partialThemes);
}
const $5026069bddf1adf4$var$buildHorizontalNavVariables = ({ theme: theme })=>{
    if ((0, $3HwlS.getWillShowNav4)()) return `${0, $5b25b2eb4e8be764$export$539c074adec2188a}: ${theme['color.link']};
${0, $5b25b2eb4e8be764$export$1cfe9795423425c}: ${theme['color.background.neutral.hovered']};
${0, $5b25b2eb4e8be764$export$6f76912df5477959}: ${theme['color.link.pressed']};
${0, $5b25b2eb4e8be764$export$fac615ceaa871e35}: ${theme['color.text.subtle']};
${0, $5b25b2eb4e8be764$export$7748fdcd335afdc0}: ${theme['color.text']};
${0, $5b25b2eb4e8be764$export$88e550ed188132a7}: ${theme['color.elevation.surface']};
${0, $5b25b2eb4e8be764$export$e2e8fadb946a45d2}: ${theme['color.border.selected']};
${0, $5b25b2eb4e8be764$export$4cd72d361867c565}: ${theme['color.border']};
${0, $5b25b2eb4e8be764$export$be4d7e23cb48401e}:  ${theme['color.background.neutral']};`;
    return '';
};
const $5026069bddf1adf4$var$buildThemeVariables = (config, backgroundImageUrl, isDarkMode, isSoftwareProject, themeSetting)=>{
    const applicationColorMode = isDarkMode ? 'dark' : 'light';
    const brightnessOverrides = config.brightness === 'high' && !isDarkMode ? (0, $6cG4N.HIGH_BRIGHTNESS_THEME) : (0, $6cG4N.LOW_BRIGHTNESS_THEME);
    const isImageConfig = config.name === 'image';
    const isGradientConfig = (0, $fHEdP.themeManager).isGradientTheme(config.name);
    /**
   * The base theme and the custom theme get merged here, with the custom theme taking precedence.
   * If you want to override configurations globally, then you should make modifications to the
   * BASE_THEME, while if you want to customize a specific theme, then you should make modifications
   * in the theme's themselves.
   */ const theme = $5026069bddf1adf4$var$mergeThemes(// the base theme for the application
    (0, $6cG4N.BASE_THEME), // the brightness overrides
    isImageConfig && !(isSoftwareProject && (0, $lmBAt.getIsSoftwareThemingM2Enabled)()) ? {} : brightnessOverrides, // gradient specific overrides
    isGradientConfig ? (0, $6cG4N.GRADIENT_THEME) : {}, // The custom background configuration
    config.theme[applicationColorMode]);
    let elevationSurface = theme['elevation.surface'] ?? theme['color.elevation.surface'];
    let colorElevationSurface = theme['color.elevation.surface'];
    if (backgroundImageUrl) {
        if (isSoftwareProject && themeSetting?.type === 'image' && !!themeSetting.dominantColor && (0, $lmBAt.getIsSoftwareThemingM2Enabled)()) {
            const adjustedColor = (0, $1r9V3.getAdjustedColor)({
                dominantColor: themeSetting.dominantColor,
                isDarkMode: isDarkMode
            });
            if (adjustedColor) {
                elevationSurface = `linear-gradient(hsl(${adjustedColor} / 0.9) 0px, hsl(${adjustedColor} / 0.85) 130px, hsl(${adjustedColor} / 0.7) 230px, hsl(${adjustedColor} / 0.5) 310px, hsl(${adjustedColor} / 0.3) 380px, hsl(${adjustedColor} / 0.15) 440px, hsl(${adjustedColor} / 0) 500px), url(${backgroundImageUrl}) center center / cover no-repeat${isDarkMode ? ' #0000004d' : ''}`;
                colorElevationSurface = `hsl(${adjustedColor} / 1)`;
            }
        } else // in dark mode, the image will be darkened by blending with a black transparent background
        elevationSurface = `url(${backgroundImageUrl}) center center / cover no-repeat${isDarkMode ? ' #0000004d' : ''}`;
    } else if (applicationColorMode === 'dark') {
        if ((0, $6cG4N.NO_BACKGROUND_CONFIG).name !== config.name && !isGradientConfig && !(0, $lmBAt.getIsSoftwareThemingEnabled)() || (0, $6cG4N.NO_BACKGROUND_CONFIG).name !== config.name && !isGradientConfig && (0, $lmBAt.getIsSoftwareThemingEnabled)() && !isSoftwareProject) /**
       * Add a gradient to the elevation surface for any themes in dark mode. This could be done in the
       * meta configuration but it's easier to do bulk edits here.
       */ elevationSurface = `linear-gradient(180deg, ${theme['color.elevation.surface']} 0%, ${"var(--ds-surface, #FFFFFF)"} 400px)`;
    }
    // Wrapper configuration
    const withWrapper = config.name !== (0, $6cG4N.DEFAULT_BACKGROUND_CONFIG).name;
    const wrapperBackground = withWrapper ? "var(--ds-surface, #FFFFFF)" : 'unset';
    const wrapperBorderRadius = withWrapper ? `${0, $gwIPs.gridSize}px` : '0';
    const isNav4 = (0, $3HwlS.getWillShowNav4)();
    const businessWrapperWithBackgroundHeight = isNav4 ? (0, $6cG4N.NAV4_BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT) : (0, $6cG4N.BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT);
    const businessWrapperHeight = isNav4 ? (0, $6cG4N.NAV4_BUSINESS_WRAPPER_HEIGHT) : (0, $6cG4N.BUSINESS_WRAPPER_HEIGHT);
    const wrapperHeight = withWrapper ? businessWrapperWithBackgroundHeight : businessWrapperHeight;
    const wrapperPadding = withWrapper ? `${0, $6cG4N.BUSINESS_WRAPPER_PADDING}px` : '0';
    const wrapperWidth = withWrapper ? (0, $6cG4N.BUSINESS_WRAPPER_WITH_BACKGROUND_WIDTH) : (0, $6cG4N.BUSINESS_WRAPPER_WIDTH);
    return `
${(0, $6cG4N.Variables).BACKDROP_FILTER}: ${isImageConfig && !(isSoftwareProject && (0, $lmBAt.getIsSoftwareThemingM2Enabled)()) ? 'blur(8px)' : 'none'};
${(0, $6cG4N.Variables).COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED_CONTRAST}: ${theme['color.background.neutral.subtle.hovered.contrast']};
${(0, $6cG4N.Variables).COLOR_BACKGROUND_ACCENT_SELECTED}: ${theme['color.background.accent.selected']};
${(0, $6cG4N.Variables).COLOR_BACKGROUND_BRAND_BOLD}: ${theme['color.background.brand.bold']};
${(0, $6cG4N.Variables).COLOR_BACKGROUND_BRAND_BOLD_HOVERED}: ${theme['color.background.brand.bold.hovered']};
${(0, $6cG4N.Variables).COLOR_BACKGROUND_BRAND_BOLD_PRESSED}: ${theme['color.background.brand.bold.pressed']};
${(0, $6cG4N.Variables).COLOR_BACKGROUND_DISABLED}: ${theme['color.background.disabled']};
${(0, $6cG4N.Variables).COLOR_BACKGROUND_INPUT}: ${theme['color.background.input']};
${(0, $6cG4N.Variables).COLOR_BACKGROUND_NEUTRAL}: ${theme['color.background.neutral']};
${(0, $6cG4N.Variables).COLOR_BACKGROUND_NEUTRAL_HOVERED}: ${theme['color.background.neutral.hovered']};
${(0, $6cG4N.Variables).COLOR_BACKGROUND_NEUTRAL_PRESSED}: ${theme['color.background.neutral.pressed']};
${(0, $6cG4N.Variables).COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED}: ${theme['color.background.neutral.subtle.hovered']};
${(0, $6cG4N.Variables).COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED}: ${theme['color.background.neutral.subtle.pressed']};
${(0, $6cG4N.Variables).COLOR_BACKGROUND_SELECTED}: ${theme['color.background.selected']};
${(0, $6cG4N.Variables).COLOR_BORDER}: ${theme['color.border']};
${(0, $6cG4N.Variables).COLOR_BORDER_INPUT}: ${theme['color.border.input']};
${(0, $6cG4N.Variables).COLOR_BORDER_INVERSE}: ${theme['color.border.inverse']};
${(0, $6cG4N.Variables).COLOR_BORDER_SELECTED}: ${theme['color.border.selected']};
${(0, $6cG4N.Variables).COLOR_ELEVATION_SURFACE}: ${colorElevationSurface};
${(0, $6cG4N.Variables).COLOR_ELEVATION_SURFACE_SUNKEN}: ${theme['color.elevation.surface.sunken']};
${(0, $6cG4N.Variables).COLOR_ICON_DANGER}: ${theme['color.icon.danger']};
${(0, $6cG4N.Variables).COLOR_ICON_INFORMATION}: ${theme['color.icon.information']};
${(0, $6cG4N.Variables).COLOR_ICON_SUCCESS}: ${theme['color.icon.success']};
${(0, $6cG4N.Variables).COLOR_ICON_WARNING}: ${theme['color.icon.warning']};
${(0, $6cG4N.Variables).COLOR_LINK}: ${theme['color.link']};
${(0, $6cG4N.Variables).COLOR_LINK_PRESSED}: ${theme['color.link.pressed']};
${(0, $6cG4N.Variables).COLOR_SKELETON}: ${theme['color.skeleton']};
${(0, $6cG4N.Variables).COLOR_TEXT}: ${theme['color.text']};
${(0, $6cG4N.Variables).COLOR_TEXT_ACCENT_SELECTED}: ${theme['color.text.accent.selected']};
${(0, $6cG4N.Variables).COLOR_TEXT_DISABLED}: ${theme['color.text.disabled']};
${(0, $6cG4N.Variables).COLOR_TEXT_INVERSE}: ${theme['color.text.inverse']};
${(0, $6cG4N.Variables).COLOR_TEXT_SELECTED}: ${theme['color.text.selected']};
${(0, $6cG4N.Variables).COLOR_TEXT_SUBTLE}: ${theme['color.text.subtle']};
${(0, $6cG4N.Variables).COLOR_TEXT_SUBTLEST}: ${theme['color.text.subtlest']};
${(0, $6cG4N.Variables).CONTENT_HEIGHT}: ${businessWrapperHeight};
${(0, $6cG4N.Variables).CONTENT_WIDTH}: ${0, $6cG4N.BUSINESS_WRAPPER_WIDTH};
${(0, $6cG4N.Variables).ELEVATION_SURFACE}: ${elevationSurface};
${(0, $6cG4N.Variables).ELEVATION_SURFACE_CONTRAST}: ${theme['elevation.surface.contrast']};
${(0, $6cG4N.Variables).ELEVATION_SURFACE_CONTRAST_BOLDER}: ${theme['elevation.surface.contrast.bolder']};
${(0, $6cG4N.Variables).ELEVATION_SURFACE_BLEND_MODE}: ${theme['elevation.surface.blend.mode']};
${(0, $6cG4N.Variables).WRAPPER_BACKGROUND}: ${wrapperBackground};
${(0, $6cG4N.Variables).WRAPPER_BORDER_RADIUS}: ${wrapperBorderRadius};
${(0, $6cG4N.Variables).WRAPPER_HEIGHT}: ${wrapperHeight};
${(0, $6cG4N.Variables).WRAPPER_PADDING}: ${wrapperPadding};
${(0, $6cG4N.Variables).WRAPPER_WIDTH}: ${wrapperWidth};
${$5026069bddf1adf4$var$buildHorizontalNavVariables({
        theme: theme
    })}`;
};
const $5026069bddf1adf4$export$41f41c7ff10d45cd = /*#__PURE__*/ (0, $5uXOq.memo)(({ themeSetting: themeSetting, media: media, projectType: projectType = null })=>{
    const isSoftwareProject = (projectType || '').toUpperCase() === (0, $2vSU6.SOFTWARE_PROJECT).toUpperCase();
    const backgroundConfig = (0, $fHEdP.themeManager).get({
        themeSetting: themeSetting,
        enableImages: true,
        isSoftwareProject: (0, $lmBAt.getIsSoftwareThemingM2Enabled)() && isSoftwareProject
    });
    const backgroundImageUrl = (0, $4rtoO.useBackgroundImageUrl)(themeSetting, media);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `:root{ ${$5026069bddf1adf4$var$buildThemeVariables(backgroundConfig, backgroundImageUrl, false, isSoftwareProject, (0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? themeSetting : undefined)} }
        [data-color-mode=dark]{ ${$5026069bddf1adf4$var$buildThemeVariables(backgroundConfig, backgroundImageUrl, true, isSoftwareProject, (0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? themeSetting : undefined)} }`
        }
    }));
});

});
parcelRegister("fHEdP", function(module, exports) {

$parcel$export(module.exports, "themeManager", () => $a34e148e1f33a06a$export$aba92a7f3273f617);
$parcel$export(module.exports, "generateMediaImageUrl", () => $a34e148e1f33a06a$export$fe2402bbc6ac3125);
$parcel$export(module.exports, "getBackgroundConfigs", () => $a34e148e1f33a06a$export$224c78c119a97f91);

var $6cG4N = parcelRequire("6cG4N");
const $a34e148e1f33a06a$var$ALL_COLOR_BACKGROUND_CONFIGS = [
    ...(0, $6cG4N.FIXED_COLOR_BACKGROUND_CONFIGS),
    ...(0, $6cG4N.ADAPTIVE_COLOR_BACKGROUND_CONFIGS),
    (0, $6cG4N.NO_BACKGROUND_CONFIG)
];
const $a34e148e1f33a06a$var$ALL_GRADIENT_BACKGROUND_CONFIGS = [
    ...(0, $6cG4N.GRADIENT_BACKGROUND_CONFIGS),
    ...(0, $6cG4N.ADAPTIVE_GRADIENT_BACKGROUND_CONFIGS)
];
/**
 * This is a temporary class that will be used to transition between the old
 * and new theme systems. Once the old theme system is removed, this class
 * will be removed as well.
 */ class $a34e148e1f33a06a$var$ThemeManager {
    init() {
        $a34e148e1f33a06a$var$ALL_GRADIENT_BACKGROUND_CONFIGS.forEach((theme)=>{
            this.gradients.set(theme.name, theme);
            this.gradientNames.add(theme.name);
        });
        $a34e148e1f33a06a$var$ALL_COLOR_BACKGROUND_CONFIGS.forEach((theme)=>{
            this.colors.set(theme.name, theme);
            this.colorNames.add(theme.name);
        });
        (0, $6cG4N.BACKGROUND_CONFIGS_OLD).forEach((theme)=>{
            this.oldColorNames.add(theme.name);
        });
    }
    isColorTheme(themeName) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return this.colorNames.has(themeName);
    }
    isOldColorTheme(themeName) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return this.oldColorNames.has(themeName);
    }
    isGradientTheme(themeName) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return this.gradientNames.has(themeName);
    }
    isImageTheme(themeSetting) {
        return themeSetting.type === 'image';
    }
    getGradient(themeName) {
        return this.gradients.get(themeName);
    }
    getColor(themeName) {
        return this.colors.get(themeName);
    }
    /**
	 * Gets the theme meta for the given theme setting and version.
	 * This is used because we want to handle cases where users get flag
	 * variations during rollout that change what background is allowed.
	 * For example, if you have a new background color, but the flag is off,
	 * we want to revert back to the default background color instead.
	 * @param themeSetting the name setting with its type and value.
	 * @param enableImages determines if image backgrounds are enabled.
	 * @returns the meta information for the theme.
	 */ get({ themeSetting: themeSetting, enableImages: enableImages, isSoftwareProject: isSoftwareProject }) {
        if (!themeSetting) return 0, $6cG4N.DEFAULT_BACKGROUND_CONFIG;
        if (enableImages && themeSetting.type === 'image') return isSoftwareProject ? (0, $6cG4N.ADAPTIVE_IMAGE_BACKGROUND_CONFIG) : (0, $6cG4N.IMAGE_BACKGROUND_CONFIG);
        if (this.isGradientTheme(themeSetting.value)) return this.getGradient(themeSetting.value) ?? (0, $6cG4N.DEFAULT_BACKGROUND_CONFIG);
        if (this.isColorTheme(themeSetting.value)) return this.getColor(themeSetting.value) ?? (0, $6cG4N.DEFAULT_BACKGROUND_CONFIG);
        // we have an old color on the image version
        return(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $6cG4N.OLD_TO_NEW_BACKGROUND_CONFIG_MAP)[themeSetting.value] ?? (0, $6cG4N.DEFAULT_BACKGROUND_CONFIG));
    }
    constructor(){
        this.gradients = new Map();
        this.gradientNames = new Set();
        this.colors = new Map();
        this.colorNames = new Set();
        this.oldColorNames = new Set();
        this.isValidTheme = (themeSetting)=>this.isColorTheme(themeSetting.value) || this.isOldColorTheme(themeSetting.value) || this.isGradientTheme(themeSetting.value) || this.isImageTheme(themeSetting);
    }
}
const $a34e148e1f33a06a$export$aba92a7f3273f617 = new $a34e148e1f33a06a$var$ThemeManager();
$a34e148e1f33a06a$export$aba92a7f3273f617.init();
function $a34e148e1f33a06a$export$fe2402bbc6ac3125({ mediaApiFileId: mediaApiFileId, mediaClientId: mediaClientId, mediaExternalEndpointUrl: mediaExternalEndpointUrl, mediaEndpoint: mediaEndpoint, ...queryParams }) {
    const url = new URL(`${mediaExternalEndpointUrl}/file/${mediaApiFileId}/${mediaEndpoint}`);
    url.searchParams.append('client', mediaClientId);
    Object.entries(queryParams).forEach(([param, value])=>url.searchParams.append(param, String(value)));
    return url.toString();
}
function $a34e148e1f33a06a$export$224c78c119a97f91(withAdaptiveColorTheme) {
    return withAdaptiveColorTheme ? {
        backgroundColorConfigs: (0, $6cG4N.ADAPTIVE_COLOR_BACKGROUND_CONFIGS),
        gradientBackgroundConfigs: (0, $6cG4N.ADAPTIVE_GRADIENT_BACKGROUND_CONFIGS)
    } : {
        backgroundColorConfigs: (0, $6cG4N.FIXED_COLOR_BACKGROUND_CONFIGS),
        gradientBackgroundConfigs: (0, $6cG4N.GRADIENT_BACKGROUND_CONFIGS)
    };
}

});

const $5b25b2eb4e8be764$export$d1b9ea3245b6a5de = 3;
const $5b25b2eb4e8be764$export$d07bba395c9390f1 = 32;
const $5b25b2eb4e8be764$export$29911ec08ab2ca2d = 5;
const $5b25b2eb4e8be764$export$b61e6f89a9db76de = 4;
const $5b25b2eb4e8be764$export$7fd2e391116c6ef5 = 9;
const $5b25b2eb4e8be764$export$e1633e494d305bfb = 'MORE';
const $5b25b2eb4e8be764$export$1cfe9795423425c = '--horizontal-navigation-color-background-neutral-hovered';
const $5b25b2eb4e8be764$export$539c074adec2188a = '--horizontal-navigation-color-link';
const $5b25b2eb4e8be764$export$6f76912df5477959 = '--horizontal-navigation-color-link-pressed';
const $5b25b2eb4e8be764$export$fac615ceaa871e35 = '--horizontal-navigation-color-text-subtle';
const $5b25b2eb4e8be764$export$7748fdcd335afdc0 = '--horizontal-navigation-color-text';
const $5b25b2eb4e8be764$export$88e550ed188132a7 = '--horizontal-navigation-color-elevation-surface';
const $5b25b2eb4e8be764$export$e2e8fadb946a45d2 = '--horizontal-navigation-color-border-selected';
const $5b25b2eb4e8be764$export$4cd72d361867c565 = '--horizontal-navigation-color-border';
const $5b25b2eb4e8be764$export$be4d7e23cb48401e = '--horizontal-navigation-color-background-neutral';
const $5b25b2eb4e8be764$export$8dd437f6d09d567 = '--horizontal-navigation-color-background-neutral-selected';
const $5b25b2eb4e8be764$export$cf26c31143daa350 = '--hn-yjlbv';

parcelRegister("4rtoO", function(module, exports) {

$parcel$export(module.exports, "useBackgroundImageUrl", () => $71f1c3b940e0c2ec$export$16f28a2a10ece447);

var $5uXOq = parcelRequire("5uXOq");

var $fHEdP = parcelRequire("fHEdP");

var $jcw0u = parcelRequire("jcw0u");

var $fZneA = parcelRequire("fZneA");

var $azoug = parcelRequire("azoug");
const $71f1c3b940e0c2ec$export$16f28a2a10ece447 = (themeSetting, media)=>{
    const lowResUrl = (0, $5uXOq.useMemo)(()=>media && themeSetting?.type === 'image' ? (0, $fHEdP.generateMediaImageUrl)({
            mediaClientId: media.clientId,
            mediaExternalEndpointUrl: media.externalEndpointUrl,
            mediaApiFileId: themeSetting.mediaApiFileId,
            token: themeSetting.mediaReadToken,
            mediaEndpoint: 'image',
            width: 1000,
            'max-age': Number.MAX_SAFE_INTEGER
        }) : null, [
        media,
        themeSetting
    ]);
    const [imageUrl, setImageUrl] = (0, $5uXOq.useState)(lowResUrl);
    const previousThemeId = (0, $5uXOq.useRef)(null);
    const abortControllerRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (themeSetting?.type !== 'image') {
            previousThemeId.current = null;
            setImageUrl(null);
            return;
        }
        if (previousThemeId.current !== themeSetting.id && media) {
            if (abortControllerRef.current) abortControllerRef.current.abort();
            abortControllerRef.current = new AbortController();
            previousThemeId.current = themeSetting.id;
            setImageUrl(lowResUrl);
            // build a new URL to the /binary path
            const binaryUrl = (0, $fHEdP.generateMediaImageUrl)({
                mediaClientId: media.clientId,
                mediaExternalEndpointUrl: media.externalEndpointUrl,
                mediaApiFileId: themeSetting.mediaApiFileId,
                mediaEndpoint: 'binary',
                'max-age': Number.MAX_SAFE_INTEGER
            });
            // send a request to fetch the image with the binary URL with bearer token authentication
            fetch(binaryUrl.toString(), {
                headers: {
                    Authorization: `Bearer ${themeSetting.mediaReadToken}`
                },
                signal: abortControllerRef.current?.signal
            }).then((response)=>response.blob()).then((blob)=>{
                const objectUrl = URL.createObjectURL(blob);
                setImageUrl(objectUrl);
                // send viewing analytics to Unsplash for Unsplash images
                if (themeSetting.sourceType === 'UNSPLASH' && themeSetting.sourceIdentifier) (0, $azoug.unsplashTracker).trackImage(themeSetting.sourceIdentifier);
            }).catch((error)=>{
                if (error.name === 'AbortError') return;
                // only fire error analytics if the error is not a client fetch error (e.g. network error, aborted)
                if (!(0, $fZneA.isClientFetchError)(error)) (0, $jcw0u.default)({
                    meta: {
                        id: 'fetchBinaryBackgroundImage',
                        packageName: 'jiraProjectThemeComponents',
                        teamName: 'work-management-frontier'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            });
        }
        return ()=>{
            if (abortControllerRef.current) abortControllerRef.current.abort();
        };
    }, [
        themeSetting,
        media,
        lowResUrl
    ]);
    return imageUrl;
};

});
parcelRegister("azoug", function(module, exports) {

$parcel$export(module.exports, "unsplashTracker", () => $959ca91ba94e3a4e$export$1869e04dbed4c16c);

var $azYnG = parcelRequire("azYnG");

var $lFKmC = parcelRequire("lFKmC");
const $959ca91ba94e3a4e$var$APP_ID = '7066';
const $959ca91ba94e3a4e$export$ca6dda5263526f75 = `https://views.unsplash.com/v?app_id=${$959ca91ba94e3a4e$var$APP_ID}`;
const $959ca91ba94e3a4e$var$MAX_URL_LENGTH = 2083; // the maximum length of a URL in most browsers
const $959ca91ba94e3a4e$var$ID_LENGTH = 12; // the length of an unsplash image id
const $959ca91ba94e3a4e$export$28219189b23a0628 = Math.floor($959ca91ba94e3a4e$var$MAX_URL_LENGTH / $959ca91ba94e3a4e$var$ID_LENGTH);
/**
 * This class is responsible for tracking unsplash images that are displayed in the app.
 * This is needed for legal reasons to comply with the Unsplash API terms of service.
 * It will track the image when it is displayed and then track it again every 10 minutes.
 */ class $959ca91ba94e3a4e$var$UnsplashTracker {
    /**
	 * Send a request to the Unsplash API to track the image views.
	 * This will send a request for all the images in the queue.
	 * If the request fails, the images will be added back to the queue.
	 */ send() {
        if (this.queue.size === 0) return;
        const imageIds = Array.from(this.queue);
        this.queue.clear();
        (0, (/*@__PURE__*/$parcel$interopDefault($azYnG)))(imageIds, $959ca91ba94e3a4e$export$28219189b23a0628).forEach((chunkIds)=>{
            const url = `${$959ca91ba94e3a4e$export$ca6dda5263526f75}&photoId=${chunkIds.join(',')}`;
            const now = new Date();
            imageIds.forEach((imageId)=>{
                this.trackedImages.set(imageId, now);
            });
            const handleFailure = ()=>{
                // if the request fails, add the image ids back to the queue
                imageIds.forEach((imageId)=>{
                    this.queue.add(imageId);
                    this.trackedImages.delete(imageId);
                });
            };
            fetch(url).then((response)=>{
                if (!response.ok) handleFailure();
            }).catch(()=>handleFailure());
        });
    }
    /**
	 * Track an image view. This will add the image to the queue to be tracked.
	 * If the image was tracked less than 10 minutes ago, it will not be added to the queue.
	 * @param sourceIdentifier The Unsplash photo id to track. Usually formatted as `photo-<something>-<id>`
	 * @returns void
	 */ trackImage(sourceIdentifier) {
        const imageId = sourceIdentifier.split('-').pop(); // photo-1696144706485-ff7825ec8481 -> ff7825ec8481
        if (!imageId) return;
        const lastTracked = this.trackedImages.get(imageId);
        if (lastTracked && Date.now() - lastTracked.getTime() < this.trackingInterval) return;
        this.queue.add(imageId);
        this.sendDebounced();
    }
    /**
	 * Track an image view while it is in the viewport. This will track the image when it is displayed
	 * and then track it again every 10 minutes.
	 * @param element The element that contains the image
	 * @param sourceIdentifier The Unsplash photo id to track. Usually formatted as `photo-<something>-<id>`
	 * @returns A function to stop tracking the image
	 */ trackWhileInViewport(element, sourceIdentifier) {
        let trackIntervalId = null;
        const observer = new IntersectionObserver((entry)=>{
            if (entry[0].isIntersecting && !trackIntervalId) {
                $959ca91ba94e3a4e$export$1869e04dbed4c16c.trackImage(sourceIdentifier);
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                trackIntervalId = window.setInterval(()=>{
                    $959ca91ba94e3a4e$export$1869e04dbed4c16c.trackImage(sourceIdentifier);
                }, this.trackingInterval + 10); // extra 10ms to ensure the interval is always greater than 10 minutes
            } else if (trackIntervalId) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.clearInterval(trackIntervalId);
        }, {
            rootMargin: '0px',
            threshold: 1.0
        });
        observer.observe(element);
        return ()=>{
            observer.disconnect();
            if (trackIntervalId) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.clearInterval(trackIntervalId);
        };
    }
    static getInstance() {
        if (!$959ca91ba94e3a4e$var$UnsplashTracker.instance) $959ca91ba94e3a4e$var$UnsplashTracker.instance = new $959ca91ba94e3a4e$var$UnsplashTracker();
        return $959ca91ba94e3a4e$var$UnsplashTracker.instance;
    }
    constructor(){
        this.trackedImages = new Map();
        this.trackingInterval = 600000 // 10 minutes
        ;
        this.queue = new Set();
        this.sendDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(this.send, 1000);
    }
}
const $959ca91ba94e3a4e$export$1869e04dbed4c16c = $959ca91ba94e3a4e$var$UnsplashTracker.getInstance();

});
parcelRegister("azYnG", function(module, exports) {

var $dM3Z8 = parcelRequire("dM3Z8");

var $4rDUz = parcelRequire("4rDUz");

var $kPZpS = parcelRequire("kPZpS");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7b3c02adf390bcc6$var$nativeCeil = Math.ceil, $7b3c02adf390bcc6$var$nativeMax = Math.max;
/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */ function $7b3c02adf390bcc6$var$chunk(array, size, guard) {
    if (guard ? $4rDUz(array, size, guard) : size === undefined) size = 1;
    else size = $7b3c02adf390bcc6$var$nativeMax($kPZpS(size), 0);
    var length = array == null ? 0 : array.length;
    if (!length || size < 1) return [];
    var index = 0, resIndex = 0, result = Array($7b3c02adf390bcc6$var$nativeCeil(length / size));
    while(index < length)result[resIndex++] = $dM3Z8(array, index, index += size);
    return result;
}
module.exports = $7b3c02adf390bcc6$var$chunk;

});



parcelRegister("1r9V3", function(module, exports) {

$parcel$export(module.exports, "getAdjustedColor", () => $e9bd8754684007f4$export$e7544aa016cb7a22);
/**
 * Converts a hex color string to HSL (Hue, Saturation, Lightness) values
 * Reference: W3C CSS Color Module Level 4
 * https://www.w3.org/TR/css-color-4/#rgb-to-hsl
 *
 * The conversion process:
 * 1. Convert hex to RGB (base 16 to decimal, normalized to [0,1])
 * 2. Find the minimum and maximum RGB values to determine lightness
 * 3. Calculate saturation based on lightness
 * 4. Calculate hue based on which RGB component is the maximum
 */ function $e9bd8754684007f4$var$hexToHSL(hexProp) {
    let hex = hexProp.replace(/^#/, '');
    if (hex.length === 3) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    const r = parseInt(hex.slice(0, 2), 16) / 255;
    const g = parseInt(hex.slice(2, 4), 16) / 255;
    const b = parseInt(hex.slice(4, 6), 16) / 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h;
    let s;
    const l = (max + min) / 2;
    if (max === min) {
        h = 0;
        s = 0;
    } else {
        const d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
            default:
                h = (r - g) / d + 4;
                break;
        }
        h *= 60;
    }
    return {
        h: Math.round(h),
        s: Math.round(s * 100),
        l: Math.round(l * 100)
    };
}
function $e9bd8754684007f4$export$e7544aa016cb7a22({ dominantColor: dominantColor, isDarkMode: isDarkMode }) {
    // Convert the hex to HSL
    const { h: h, s: s, l: l } = $e9bd8754684007f4$var$hexToHSL(dominantColor);
    if (isDarkMode) // Dont need much adjustment for dark mode - just darken it
    return `${h} ${s}% ${Math.min(l, 26)}%`;
    const LIGHTNESS_TARGET = 75;
    const HIGH_LIGHTNESS_THRESHOLD = 70;
    if (l > HIGH_LIGHTNESS_THRESHOLD || l > 53 && s > 60) // Text already readable
    return `${h} ${s}% ${Math.max(l, 64)}%`;
    let saturation = s;
    // Cap over-saturated blues
    if (h >= 200 && h <= 220 && s > 65) saturation = 65;
    return `${h} ${saturation}% ${LIGHTNESS_TARGET}%`;
}

});


parcelRegister("1MaBz", function(module, exports) {

$parcel$export(module.exports, "ThemeContainerOld", () => $5ffb1b62a0c37aa6$export$c6e50a832af54243);
// Delete file when cleaning up getWillShowNav4

var $ajpes = parcelRequire("ajpes");

var $fHEdP = parcelRequire("fHEdP");

var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
const $5ffb1b62a0c37aa6$var$setTheme = (newTheme)=>({ getState: getState, setState: setState })=>{
        const { entityId: entityId, themeSetting: themeSetting, selectedThemeSetting: selectedThemeSetting } = getState();
        if ((0, $fHEdP.themeManager).isValidTheme(newTheme) && !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(themeSetting?.value, newTheme?.value)) setState({
            entityId: entityId,
            selectedThemeSetting: selectedThemeSetting,
            themeSetting: newTheme
        });
    };
const $5ffb1b62a0c37aa6$var$setSelectedThemeSetting = (newTheme)=>({ getState: getState, setState: setState })=>{
        const { entityId: entityId, themeSetting: themeSetting, selectedThemeSetting: selectedThemeSetting } = getState();
        if (newTheme === null || (0, $fHEdP.themeManager).isValidTheme(newTheme) && !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(selectedThemeSetting?.type === 'image' ? selectedThemeSetting?.id : selectedThemeSetting?.value, newTheme?.type === 'image' ? newTheme?.id : newTheme?.value)) setState({
            entityId: entityId,
            themeSetting: themeSetting,
            selectedThemeSetting: newTheme
        });
    };
const $5ffb1b62a0c37aa6$var$actions = {
    setTheme: $5ffb1b62a0c37aa6$var$setTheme,
    setSelectedThemeSetting: $5ffb1b62a0c37aa6$var$setSelectedThemeSetting
};
const $5ffb1b62a0c37aa6$var$initialState = {
    themeSetting: null,
    selectedThemeSetting: null,
    entityId: ''
};
const $5ffb1b62a0c37aa6$var$Store = (0, $iXqE5.createStore)({
    initialState: $5ffb1b62a0c37aa6$var$initialState,
    actions: $5ffb1b62a0c37aa6$var$actions,
    name: 'ProjectTheme'
});
const $5ffb1b62a0c37aa6$export$c6e50a832af54243 = (0, $gg7kZ.createContainer)($5ffb1b62a0c37aa6$var$Store, {
    onInit: ()=>({ setState: setState }, entityTheme)=>setState(entityTheme),
    onUpdate: ()=>({ setState: setState }, entityTheme)=>setState(entityTheme)
});

});




parcelRegister("erjJQ", function(module, exports) {

$parcel$export(module.exports, "Content", () => $780b11bdb912365c$export$7c6e2c02157bb7d2);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $cSD7y = parcelRequire("cSD7y");

var $7XYc4 = parcelRequire("7XYc4");

var $5jPIk = parcelRequire("5jPIk");

var $3HwlS = parcelRequire("3HwlS");

var $iqLcb = parcelRequire("iqLcb");

var $3Uek9 = parcelRequire("3Uek9");

var $gk293 = parcelRequire("gk293");

var $5M3R9 = parcelRequire("5M3R9");

var $enQ8X = parcelRequire("enQ8X");

var $lODMY = parcelRequire("lODMY");

var $erBFB = parcelRequire("erBFB");

var $h0PjI = parcelRequire("h0PjI");
/* IMPORTANT:
 * When making any changes to the Nav3 component, please ensure that you also make the same changes to the
 * Nav4 component. The feature flag used is part of the Navigation Refresh work and we need to ensure that
 * we do not introduce tech debt for the roll-out by only updating the current component that is due to be
 * removed.
 *
 * If you have any concerns or questions please reach out to the #jira-navigation channel. Thanks!
 */ const $780b11bdb912365c$var$SPA_TRACE_KEY = 'spa';
const $780b11bdb912365c$var$DefaultLayoutContentNav4 = (props)=>{
    const { isInset: isInset, hasTheming: hasTheming } = (0, $3Uek9.useProjectTheme)();
    const renderContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "mainContentSkipLink",
        packageName: "jiraPageContainer",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $erBFB.MainContentSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5M3R9.RenderTracerMark), {
        traceKey: $780b11bdb912365c$var$SPA_TRACE_KEY,
        type: "start"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $enQ8X.default), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5M3R9.RenderTracerMark), {
        traceKey: $780b11bdb912365c$var$SPA_TRACE_KEY,
        type: "end"
    }));
    if (hasTheming) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gk293.ThemedContentLayout), {
        appearance: isInset ? 'inset' : 'default'
    }, renderContent);
    return renderContent;
};
const $780b11bdb912365c$var$DefaultLayoutContentNav3 = (props)=>{
    const { isInset: isInset, hasProjectViewNavigation: hasProjectViewNavigation } = (0, $3Uek9.useProjectTheme)();
    const renderContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5jPIk.MainHeightFixCss), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "mainContentSkipLink",
        packageName: "jiraPageContainer",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $erBFB.MainContentSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.Main), {
        id: "ak-main-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5M3R9.RenderTracerMark), {
        traceKey: $780b11bdb912365c$var$SPA_TRACE_KEY,
        type: "start"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $enQ8X.default), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5M3R9.RenderTracerMark), {
        traceKey: $780b11bdb912365c$var$SPA_TRACE_KEY,
        type: "end"
    })));
    if (hasProjectViewNavigation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gk293.ProjectThemeWrapper), {
        withWhiteBackground: isInset
    }, renderContent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h0PjI.LayoutMainWrapper), null, renderContent);
};
const $780b11bdb912365c$var$DefaultLayoutContent = (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), $780b11bdb912365c$var$DefaultLayoutContentNav4, $780b11bdb912365c$var$DefaultLayoutContentNav3);
const $780b11bdb912365c$var$useRouterRoute = (0, $lODMY.createRouterSelector)((state)=>state.route);
const $780b11bdb912365c$var$ContentNew = (props)=>{
    const { LayoutOverrideComponent: LayoutOverrideComponent } = $780b11bdb912365c$var$useRouterRoute();
    if (LayoutOverrideComponent !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5M3R9.RenderTracerMark), {
        traceKey: $780b11bdb912365c$var$SPA_TRACE_KEY,
        type: "start"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $enQ8X.default), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5M3R9.RenderTracerMark), {
        traceKey: $780b11bdb912365c$var$SPA_TRACE_KEY,
        type: "end"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($780b11bdb912365c$var$DefaultLayoutContent, props);
};
const $780b11bdb912365c$export$7c6e2c02157bb7d2 = (0, $cSD7y.componentWithFG)(// Note: this is a kill-switch so true=old component, false=new component
'assets_as_an_app_kill_switch', $780b11bdb912365c$var$DefaultLayoutContent, $780b11bdb912365c$var$ContentNew);

});
parcelRegister("5jPIk", function(module, exports) {

$parcel$export(module.exports, "MainHeightFixCss", () => $cf8c915f080efbd8$export$2fcd4100c556a49e);

var $5uXOq = parcelRequire("5uXOq");

const $cf8c915f080efbd8$export$2fcd4100c556a49e = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `[data-ds--page-layout--slot="main"] { height: calc(100vh - ${(0, $81918a2ef6db1f93$export$d60454526e2281af)}) }`
        }
    });

});

parcelRegister("gk293", function(module, exports) {

$parcel$export(module.exports, "ThemedContentLayout", () => $24fd52a828227843$export$c2c3c7c0b13a1f9d);
$parcel$export(module.exports, "ProjectThemeWrapper", () => $24fd52a828227843$export$65c56727ada4372d);
/* ProjectThemeWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3HwlS = parcelRequire("3HwlS");

var $jtC5b = parcelRequire("jtC5b");
const $24fd52a828227843$var$styles = {
    rootOld: "_kqswh2mm",
    root: "_kqswh2mm",
    fullHeight: "_1tkeidpf _4t3i1osq",
    insetRoot: "_1yt4y9h4",
    insetContainer: "_2rko1gnp _bfhkp043"
};
const $24fd52a828227843$export$c2c3c7c0b13a1f9d = ({ children: children, appearance: appearance })=>/*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            (0, $3HwlS.getWillShowNav4)() && $24fd52a828227843$var$styles.root,
            !(0, $3HwlS.getWillShowNav4)() && $24fd52a828227843$var$styles.rootOld,
            $24fd52a828227843$var$styles.fullHeight,
            appearance === 'inset' && $24fd52a828227843$var$styles.insetRoot
        ])
    }, /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            $24fd52a828227843$var$styles.fullHeight,
            appearance === 'inset' && $24fd52a828227843$var$styles.insetContainer
        ])
    }, children));
const $24fd52a828227843$export$65c56727ada4372d = ({ withWhiteBackground: withWhiteBackground, children: children })=>{
    if (withWhiteBackground) return /*#__PURE__*/ $5uXOq.createElement((0, $jtC5b.OuterWrapperWithBackground), null, /*#__PURE__*/ $5uXOq.createElement((0, $jtC5b.InnerWrapperWithBackground), null, children));
    return /*#__PURE__*/ $5uXOq.createElement((0, $jtC5b.OuterWrapper), null, /*#__PURE__*/ $5uXOq.createElement((0, $jtC5b.InnerWrapper), null, children));
};

});
parcelRegister("jtC5b", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $c37919f3b01a53ae$export$edaaad985a878983);
$parcel$export(module.exports, "OuterWrapperWithBackground", () => $c37919f3b01a53ae$export$69c6ec128d3729c9);
$parcel$export(module.exports, "InnerWrapper", () => $c37919f3b01a53ae$export$f185744748c379a7);
$parcel$export(module.exports, "InnerWrapperWithBackground", () => $c37919f3b01a53ae$export$2e149d12a18af14b);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7XYc4 = parcelRequire("7XYc4");

var $3HwlS = parcelRequire("3HwlS");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $c37919f3b01a53ae$var$Nav3OuterWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _154i14em",
            __cmplp.className
        ])
    });
});
const $c37919f3b01a53ae$var$Nav4OuterWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _154i1l8a",
            __cmplp.className
        ])
    });
});
const $c37919f3b01a53ae$export$edaaad985a878983 = (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), $c37919f3b01a53ae$var$Nav4OuterWrapper, $c37919f3b01a53ae$var$Nav3OuterWrapper);
const $c37919f3b01a53ae$export$69c6ec128d3729c9 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $c37919f3b01a53ae$export$edaaad985a878983, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt4y9h4",
            __cmplp.className
        ])
    });
});
const $c37919f3b01a53ae$export$f185744748c379a7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_iu1g1fl4 _fok81wug _q7c11wug _2d3f3q3i _japi1o48",
            __cmplp.className
        ])
    });
});
const $c37919f3b01a53ae$export$2e149d12a18af14b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $c37919f3b01a53ae$export$f185744748c379a7, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1gnp _bfhkp043 _2d3f15y4 _japizntk",
            __cmplp.className
        ])
    });
});

});


parcelRegister("enQ8X", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f1817a083d388c8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jD5no = parcelRequire("jD5no");

var $gAeCk = parcelRequire("gAeCk");

var $2SVPM = parcelRequire("2SVPM");

var $gEwZr = parcelRequire("gEwZr");
const $1f1817a083d388c8$var$onSpaShellReady = ()=>{
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa/spa-shell/core', '_jira-spa/spa-shell.start', 'JIRA_SPA_SHELL_READY');
};
const $1f1817a083d388c8$var$Spa = ({ initRoute: initRoute = null, routes: routes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
        hasErrorBoundary: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: "JIRA_SPA_SHELL_READY",
        onSet: $1f1817a083d388c8$var$onSpaShellReady
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEwZr.default), {
        initRoute: initRoute,
        routes: routes
    }));
var $1f1817a083d388c8$export$2e2bcd8739ae039 = $1f1817a083d388c8$var$Spa;

});
parcelRegister("gEwZr", function(module, exports) {

$parcel$export(module.exports, "default", () => $308f7fd68513e9ff$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fq71H = parcelRequire("fq71H");

var $8Orxo = parcelRequire("8Orxo");

var $fLxDC = parcelRequire("fLxDC");

var $drfhg = parcelRequire("drfhg");

var $kb4zh = parcelRequire("kb4zh");

var $x9xyg = parcelRequire("x9xyg");

var $2YZCu = parcelRequire("2YZCu");

var $7CMCs = parcelRequire("7CMCs");

var $4R6GH = parcelRequire("4R6GH");

var $lfTZh = parcelRequire("lfTZh");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $2SVPM = parcelRequire("2SVPM");

var $4oDnX = parcelRequire("4oDnX");

var $6IjvB = parcelRequire("6IjvB");

var $imS60 = parcelRequire("imS60");

var $lODMY = parcelRequire("lODMY");
var $2Gs5h = parcelRequire("2Gs5h");
var $lVJAU = parcelRequire("lVJAU");

var $fjVTF = parcelRequire("fjVTF");

var $1AZST = parcelRequire("1AZST");

var $cSD7y = parcelRequire("cSD7y");

var $l9F59 = parcelRequire("l9F59");

var $i6dHx = parcelRequire("i6dHx");

var $Smjim = parcelRequire("Smjim");
const $308f7fd68513e9ff$var$REMOTE_ACTIONS_OFF = 'OFF';
const $308f7fd68513e9ff$var$REMOTE_ACTIONS_PERFORM = 'PERFORM';
const $308f7fd68513e9ff$var$useRouterLocation = (0, $lODMY.createRouterSelector)((state)=>state.location);
const $308f7fd68513e9ff$var$useRouterAction = (0, $lODMY.createRouterSelector)((state)=>state.action);
const $308f7fd68513e9ff$var$useRouterQuery = (0, $lODMY.createRouterSelector)((state)=>state.query);
const $308f7fd68513e9ff$var$useRouterRoute = (0, $lODMY.createRouterSelector)((state)=>state.route);
const $308f7fd68513e9ff$var$useRouterMatch = (0, $lODMY.createRouterSelector)((state)=>state.match);
const $308f7fd68513e9ff$var$useRouterRoutes = (0, $lODMY.createRouterSelector)((state)=>state.routes);
const $308f7fd68513e9ff$var$useIsLazyRoutes = (0, $lODMY.createRouterSelector)((state)=>state.isLazyRoutes);
let $308f7fd68513e9ff$var$hasPendingForceReloadAction = false;
const $308f7fd68513e9ff$var$getRemoteActionsRolloutStage = ()=>(0, $4R6GH.fg)('remote_actions_-_killswitch_-_temporary') ? $308f7fd68513e9ff$var$REMOTE_ACTIONS_PERFORM : $308f7fd68513e9ff$var$REMOTE_ACTIONS_OFF;
const $308f7fd68513e9ff$export$88fe66870dd8f843 = (value)=>{
    $308f7fd68513e9ff$var$hasPendingForceReloadAction = value;
};
const $308f7fd68513e9ff$export$39e8f9fc07dd3395 = ()=>$308f7fd68513e9ff$var$hasPendingForceReloadAction;
const $308f7fd68513e9ff$var$fireRemoteActionAnalytics = (analyticsEvent, eventAction, remoteAction, currentRoute, targetRoute, attempts, lastAttemptedAt)=>(0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, `remoteAction ${eventAction}`, {
        source: 'transitionBlocker',
        actionId: remoteAction != null && remoteAction.id != null ? String(remoteAction.id) : '',
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        frontendVersion: window.BUILD_KEY,
        currentRouteName: currentRoute?.route.name || '',
        targetRouteName: targetRoute?.route.name || '',
        remoteActionsRolloutStage: $308f7fd68513e9ff$var$getRemoteActionsRolloutStage(),
        attempts: attempts,
        lastAttemptedAt: lastAttemptedAt
    });
const $308f7fd68513e9ff$var$updateSentryBreadcrumb = (route, nextRoute)=>{
    const from = route.path + (route.query ? `?${route.query.join('&')}` : '');
    const to = nextRoute?.path + (nextRoute?.query ? `?${nextRoute.query.join('&')}` : '');
    (0, $fq71H.addBreadcrumb)({
        type: 'navigation',
        data: {
            from: from,
            to: to
        }
    });
};
const $308f7fd68513e9ff$export$ef0074adc0f6b96d = (search)=>{
    const searchParams = new URLSearchParams(search);
    if (!searchParams.has('ignoreStickyVersion')) searchParams.append('ignoreStickyVersion', 'true');
    return `?${searchParams}`;
};
/**
 * Manages the routing, analytics, and remote actions within a single-page application (SPA).
 * This component sets up initial routes, enables analytics tracking, and handles SPA transitions.
 * It incorporates custom logic for page reloading or redirection under certain conditions
 * and ensures safe rendering of route components within an error boundary context.
 */ const $308f7fd68513e9ff$var$SpaOld = ({ routes: routes, initRoute: initRoute = null })=>{
    (0, $5uXOq.useMemo)(()=>{
        (0, $x9xyg.setMark)('jira-spa/view.start');
    }, []);
    const checkShouldResetPage = (0, $5uXOq.useMemo)(()=>(0, $6IjvB.createCheckShouldResetPage)(), []);
    const currentMatchObjectRef = (0, $5uXOq.useRef)(initRoute);
    (0, $5uXOq.useEffect)(()=>{
        (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/view', 'jira-spa/view.start', true);
    }, []);
    const { registerBlock: registerBlock } = (0, $lVJAU.useRouterActions)();
    const location = $308f7fd68513e9ff$var$useRouterLocation();
    const action = $308f7fd68513e9ff$var$useRouterAction();
    const query = $308f7fd68513e9ff$var$useRouterQuery();
    const route = $308f7fd68513e9ff$var$useRouterRoute();
    const match = $308f7fd68513e9ff$var$useRouterMatch();
    const isLazyRoutes = $308f7fd68513e9ff$var$useIsLazyRoutes();
    const routerRoutes = $308f7fd68513e9ff$var$useRouterRoutes();
    // If the Lazy Route Map experiment is enabled, we want to use the routes from
    // the router, not from props as they will be changing dynamically during page lifetime
    if (isLazyRoutes) // eslint-disable-next-line no-param-reassign
    routes = routerRoutes;
    const { shouldPerformAction: shouldPerformAction, performAction: performAction } = (0, $fjVTF.useShouldPerformAction)({
        actionName: 'forceReload'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    /* We update currentMatch only if it's not a redirect. So in canTransitionIn we can compare
	 * actual routes instead of comparing against the redirect one */ if (route.isRedirect !== true) currentMatchObjectRef.current = {
        route: route,
        match: match
    };
    const [, { resetCurrentPage: resetCurrentPage }] = (0, $4oDnX.useSpaStateActions)();
    /* We regiser the blocker on every render to be sure that it gets added as first item
	 * even when the route changes (so it gets called last). It will be added only once anyway.
	 * This is our custom block() API that accepts promises.
	 * This code allows us to disable an SPA transition and trigger a full page reload
	 * in case the route we are moving out (or in) needs it. */ const transitionBlocker = (0, $5uXOq.useCallback)((nextLocation, nextAction)=>{
        const nextMatch = (0, $2Gs5h.default)(routes, nextLocation.pathname, nextLocation.search);
        const canDo = (0, $l9F59.default)(currentMatchObjectRef.current, nextMatch);
        // Checking how many routes is a proxy for determining whether the lazy routes have been loaded
        // canDo might still be true if this is a transition from an issue to an issue
        if (isLazyRoutes && !canDo && routes.length <= 3) (0, $2YZCu.default).safeInfoWithoutCustomerData('lazy_routes.transition', 'failure', {
            route: nextMatch?.route.name
        });
        if (!canDo) {
            const windowAction = nextAction === 'REPLACE' ? 'replace' : 'assign';
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.location[windowAction]((0, $8Orxo.createPath)(nextLocation));
        }
        const remoteActionsRolloutStage = $308f7fd68513e9ff$var$getRemoteActionsRolloutStage();
        if (remoteActionsRolloutStage !== $308f7fd68513e9ff$var$REMOTE_ACTIONS_OFF && createAnalyticsEvent !== null) {
            const currentMatch = currentMatchObjectRef.current;
            if (canDo && currentMatch?.route.name !== nextMatch?.route.name && shouldPerformAction && $308f7fd68513e9ff$var$hasPendingForceReloadAction === false) {
                $308f7fd68513e9ff$var$hasPendingForceReloadAction = true;
                const windowAction = nextAction === 'REPLACE' ? 'replace' : 'assign';
                performAction((remoteAction, { attempts: attempts, lastAttemptedAt: lastAttemptedAt })=>{
                    $308f7fd68513e9ff$var$fireRemoteActionAnalytics(createAnalyticsEvent({}), 'performed', remoteAction, currentMatch, nextMatch, attempts, lastAttemptedAt);
                    if ((0, $4R6GH.fg)('remote_actions_-_no_sticky_version_query_param')) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    window.location[windowAction]((0, $8Orxo.createPath)({
                        ...nextLocation,
                        search: $308f7fd68513e9ff$export$ef0074adc0f6b96d(nextLocation.search)
                    }));
                    else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    window.location[windowAction]((0, $8Orxo.createPath)(nextLocation));
                }, (remoteAction, { attempts: attempts, lastAttemptedAt: lastAttemptedAt })=>{
                    $308f7fd68513e9ff$var$fireRemoteActionAnalytics(createAnalyticsEvent({}), 'cancelled', remoteAction, currentMatch, nextMatch, attempts, lastAttemptedAt);
                });
            }
        }
        return canDo;
    }, [
        performAction,
        routes,
        shouldPerformAction,
        createAnalyticsEvent,
        isLazyRoutes
    ]);
    const resetCurrentPageBeforeRouteChangeBlocker = (0, $5uXOq.useCallback)((nextLocation, nextAction)=>{
        const nextMatchObject = (0, $2Gs5h.default)(routes, nextLocation.pathname, nextLocation.search);
        if (nextMatchObject && match && route) {
            const { match: nextMatch, route: nextRoute } = nextMatchObject;
            const shouldReset = checkShouldResetPage({
                nextMatch: nextMatch,
                nextRoute: nextRoute,
                currentMatch: match,
                currentRoute: route,
                action: nextAction
            });
            const nextRouteUfoName = (0, $fLxDC.default)(nextRoute);
            if (shouldReset) {
                resetCurrentPage(nextRouteUfoName, nextRoute.name);
                (0, $1AZST.GlobalPageLoadExperience).setPageLoadId(nextRoute.perfMetricKey || 'UNKNOWN');
            }
            const isCurrentRouteRedirecting = route.isRedirect === true;
            if (isCurrentRouteRedirecting) {
                const currentRouteName = (0, $fLxDC.default)(route);
                (0, $drfhg.default)(currentRouteName, nextRouteUfoName, nextRoute.name, performance.now());
            }
        }
        $308f7fd68513e9ff$var$updateSentryBreadcrumb(route, nextMatchObject?.route);
        return true;
    }, [
        checkShouldResetPage,
        match,
        resetCurrentPage,
        route,
        routes
    ]);
    registerBlock(transitionBlocker);
    registerBlock(resetCurrentPageBeforeRouteChangeBlocker);
    const renderRouteComponent = (0, $5uXOq.useCallback)(()=>{
        const { component: RouteComponent, shouldOptOutConcurrentMode: shouldOptOutConcurrentMode, isStrictModeEnabled: isStrictModeEnabled, skeleton: skeleton } = route;
        const Skeleton = skeleton || (0, $kb4zh.default);
        if ((0, $4R6GH.fg)('jira-concurrent-incremental')) {
            if (!shouldOptOutConcurrentMode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.PlaceholderWithNativeSuspense), {
                name: "concurrent-root",
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Skeleton, null)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i6dHx.ConcurrentRootComponent), null));
        }
        if (RouteComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($308f7fd68513e9ff$var$ConditionalStrictMode, {
            isEnabled: isStrictModeEnabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.PlaceholderWithNativeSuspense), {
            name: "route-component",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Skeleton, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(RouteComponent, {
            location: location,
            route: route,
            match: match,
            action: action,
            query: query
        })));
    }, [
        action,
        location,
        match,
        query,
        route
    ]);
    if (!(route && match)) return null;
    const { meta: meta, skeleton: skeleton } = route;
    const Skeleton = skeleton || (0, $kb4zh.default);
    const entryPoint = route.entryPoint?.();
    const { reporting: reporting } = meta || {};
    const renderRouteEntryPointContainer = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.PlaceholderWithNativeSuspense), {
            name: "route-entry-point-container",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Skeleton, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Smjim.RouteEntryPointContainer), {
            location: location,
            route: route,
            match: match,
            action: action,
            query: query
        }));
    };
    /* Render a <Route> component instead of the page directly so the match prop can be
	 * propagated down to components wrapped with the withRouter HOC. Unfortunately, this
	 * means we forfeit the right to access query params via match is provided by <Route>
	 * rather than our custom matchRoute function. */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imS60.default), {
        name: "route-component"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        // explicitly coerce undefined to string to make flow happy
        id: `routeApp.${String(route.name)}`,
        packageName: "jiraSpa",
        extraEventData: {
            routeGroup: route.group ?? '',
            isSSR: false
        },
        fallback: "page",
        sendToPrivacyUnsafeSplunk: Boolean(reporting),
        ...reporting
    }, entryPoint ? renderRouteEntryPointContainer() : renderRouteComponent()));
};
const $308f7fd68513e9ff$var$RegisterRouterBlocks = ({ routes: routesOriginal, initRoute: initRoute, route: route, match: match })=>{
    const isLazyRoutes = $308f7fd68513e9ff$var$useIsLazyRoutes();
    const routerRoutes = $308f7fd68513e9ff$var$useRouterRoutes();
    const routes = (0, $5uXOq.useMemo)(()=>{
        return isLazyRoutes ? routerRoutes : routesOriginal;
    }, [
        isLazyRoutes,
        routerRoutes,
        routesOriginal
    ]);
    const checkShouldResetPage = (0, $5uXOq.useMemo)(()=>(0, $6IjvB.createCheckShouldResetPage)(), []);
    const currentMatchObjectRef = (0, $5uXOq.useRef)(initRoute);
    const { registerBlock: registerBlock } = (0, $lVJAU.useRouterActions)();
    const { shouldPerformAction: shouldPerformAction, performAction: performAction } = (0, $fjVTF.useShouldPerformAction)({
        actionName: 'forceReload'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        /* We update currentMatch only if it's not a redirect. So in canTransitionIn we can compare
		 * actual routes instead of comparing against the redirect one */ if (route.isRedirect !== true) currentMatchObjectRef.current = {
            route: route,
            match: match
        };
    }, [
        match,
        route
    ]);
    const [, { resetCurrentPage: resetCurrentPage }] = (0, $4oDnX.useSpaStateActions)();
    /* We regiser the blocker on every render to be sure that it gets added as first item
	 * even when the route changes (so it gets called last). It will be added only once anyway.
	 * This is our custom block() API that accepts promises.
	 * This code allows us to disable an SPA transition and trigger a full page reload
	 * in case the route we are moving out (or in) needs it. */ const transitionBlocker = (0, $5uXOq.useCallback)((nextLocation, nextAction)=>{
        const nextMatch = (0, $2Gs5h.default)(routes, nextLocation.pathname, nextLocation.search);
        const canDo = (0, $l9F59.default)(currentMatchObjectRef.current, nextMatch);
        // Checking how many routes is a proxy for determining whether the lazy routes have been loaded
        // canDo might still be true if this is a transition from an issue to an issue
        if (isLazyRoutes && !canDo && routes.length <= 3) (0, $2YZCu.default).safeInfoWithoutCustomerData('lazy_routes.transition', 'failure', {
            route: nextMatch?.route.name
        });
        if (!canDo) {
            const windowAction = nextAction === 'REPLACE' ? 'replace' : 'assign';
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.location[windowAction]((0, $8Orxo.createPath)(nextLocation));
        }
        const remoteActionsRolloutStage = $308f7fd68513e9ff$var$getRemoteActionsRolloutStage();
        if (remoteActionsRolloutStage !== $308f7fd68513e9ff$var$REMOTE_ACTIONS_OFF && createAnalyticsEvent !== null) {
            const currentMatch = currentMatchObjectRef.current;
            if (canDo && currentMatch?.route.name !== nextMatch?.route.name && shouldPerformAction && $308f7fd68513e9ff$var$hasPendingForceReloadAction === false) {
                // eslint-disable-next-line react-hooks/react-compiler
                $308f7fd68513e9ff$var$hasPendingForceReloadAction = true;
                const windowAction = nextAction === 'REPLACE' ? 'replace' : 'assign';
                performAction((remoteAction, { attempts: attempts, lastAttemptedAt: lastAttemptedAt })=>{
                    $308f7fd68513e9ff$var$fireRemoteActionAnalytics(createAnalyticsEvent({}), 'performed', remoteAction, currentMatch, nextMatch, attempts, lastAttemptedAt);
                    if ((0, $4R6GH.fg)('remote_actions_-_no_sticky_version_query_param')) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    window.location[windowAction]((0, $8Orxo.createPath)({
                        ...nextLocation,
                        search: $308f7fd68513e9ff$export$ef0074adc0f6b96d(nextLocation.search)
                    }));
                    else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    window.location[windowAction]((0, $8Orxo.createPath)(nextLocation));
                }, (remoteAction, { attempts: attempts, lastAttemptedAt: lastAttemptedAt })=>{
                    $308f7fd68513e9ff$var$fireRemoteActionAnalytics(createAnalyticsEvent({}), 'cancelled', remoteAction, currentMatch, nextMatch, attempts, lastAttemptedAt);
                });
            }
        }
        return canDo;
    }, [
        performAction,
        routes,
        shouldPerformAction,
        createAnalyticsEvent,
        isLazyRoutes
    ]);
    const resetCurrentPageBeforeRouteChangeBlocker = (0, $5uXOq.useCallback)((nextLocation, nextAction)=>{
        const nextMatchObject = (0, $2Gs5h.default)(routes, nextLocation.pathname, nextLocation.search);
        if (nextMatchObject && match && route) {
            const { match: nextMatch, route: nextRoute } = nextMatchObject;
            const shouldReset = checkShouldResetPage({
                nextMatch: nextMatch,
                nextRoute: nextRoute,
                currentMatch: match,
                currentRoute: route,
                action: nextAction
            });
            const nextRouteUfoName = (0, $fLxDC.default)(nextRoute);
            if (shouldReset) {
                resetCurrentPage(nextRouteUfoName, nextRoute.name);
                (0, $1AZST.GlobalPageLoadExperience).setPageLoadId(nextRoute.perfMetricKey || 'UNKNOWN');
            }
            const isCurrentRouteRedirecting = route.isRedirect === true;
            if (isCurrentRouteRedirecting) {
                const currentRouteName = (0, $fLxDC.default)(route);
                (0, $drfhg.default)(currentRouteName, nextRouteUfoName, nextRoute.name, performance.now());
            }
        }
        $308f7fd68513e9ff$var$updateSentryBreadcrumb(route, nextMatchObject?.route);
        return true;
    }, [
        checkShouldResetPage,
        match,
        resetCurrentPage,
        route,
        routes
    ]);
    registerBlock(transitionBlocker);
    registerBlock(resetCurrentPageBeforeRouteChangeBlocker);
    return null;
};
const $308f7fd68513e9ff$var$SpaRouteComponent = ({ location: location, action: action, query: query, route: route, match: match })=>{
    const { component: RouteComponent, shouldOptOutConcurrentMode: shouldOptOutConcurrentMode, isStrictModeEnabled: isStrictModeEnabled, skeleton: skeleton } = route;
    const Skeleton = skeleton || (0, $kb4zh.default);
    if ((0, $4R6GH.fg)('jira-concurrent-incremental')) {
        if (!shouldOptOutConcurrentMode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.PlaceholderWithNativeSuspense), {
            name: "concurrent-root",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Skeleton, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i6dHx.ConcurrentRootComponent), null));
    }
    if (RouteComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($308f7fd68513e9ff$var$ConditionalStrictMode, {
        isEnabled: isStrictModeEnabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.PlaceholderWithNativeSuspense), {
        name: "route-component",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Skeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(RouteComponent, {
        location: location,
        route: route,
        match: match,
        action: action,
        query: query
    })));
};
const $308f7fd68513e9ff$var$SpaRouteEntryPointContainer = /*#__PURE__*/ (0, $5uXOq.memo)(({ location: location, action: action, query: query, route: route, match: match })=>{
    const Skeleton = route.skeleton || (0, $kb4zh.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.PlaceholderWithNativeSuspense), {
        name: "route-entry-point-container",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Skeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Smjim.RouteEntryPointContainer), {
        location: location,
        route: route,
        match: match,
        action: action,
        query: query
    }));
});
const $308f7fd68513e9ff$var$SpaChild = ({ location: location, action: action, query: query, route: route, match: match })=>{
    const reporting = route.meta?.reporting;
    const entryPoint = (0, $5uXOq.useMemo)(()=>route.entryPoint?.(), [
        route
    ]);
    /* Render a <Route> component instead of the page directly so the match prop can be
	 * propagated down to components wrapped with the withRouter HOC. Unfortunately, this
	 * means we forfeit the right to access query params via match is provided by <Route>
	 * rather than our custom matchRoute function. */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imS60.default), {
        name: "route-component"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        // explicitly coerce undefined to string to make flow happy
        id: `routeApp.${String(route.name)}`,
        packageName: "jiraSpa",
        extraEventData: (0, $5uXOq.useMemo)(()=>({
                routeGroup: route.group ?? '',
                isSSR: false
            }), [
            route.group
        ]),
        fallback: "page",
        sendToPrivacyUnsafeSplunk: Boolean(reporting),
        ...reporting
    }, entryPoint ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($308f7fd68513e9ff$var$SpaRouteEntryPointContainer, {
        location: location,
        action: action,
        query: query,
        route: route,
        match: match
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($308f7fd68513e9ff$var$SpaRouteComponent, {
        location: location,
        action: action,
        query: query,
        route: route,
        match: match
    })));
};
/**
 * Manages the routing, analytics, and remote actions within a single-page application (SPA).
 * This component sets up initial routes, enables analytics tracking, and handles SPA transitions.
 * It incorporates custom logic for page reloading or redirection under certain conditions
 * and ensures safe rendering of route components within an error boundary context.
 */ const $308f7fd68513e9ff$var$SpaNew = ({ routes: routes, initRoute: initRoute = null })=>{
    (0, $5uXOq.useMemo)(()=>{
        (0, $x9xyg.setMark)('jira-spa/view.start');
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/view', 'jira-spa/view.start', true);
    }, []);
    const location = $308f7fd68513e9ff$var$useRouterLocation();
    const action = $308f7fd68513e9ff$var$useRouterAction();
    const query = $308f7fd68513e9ff$var$useRouterQuery();
    const route = $308f7fd68513e9ff$var$useRouterRoute();
    const match = $308f7fd68513e9ff$var$useRouterMatch();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($308f7fd68513e9ff$var$RegisterRouterBlocks, {
        routes: routes,
        initRoute: initRoute,
        route: route,
        match: match
    }), !(route && match) ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($308f7fd68513e9ff$var$SpaChild, {
        location: location,
        action: action,
        query: query,
        route: route,
        match: match
    }));
};
function $308f7fd68513e9ff$var$ConditionalStrictMode(props) {
    // Default to true
    const { isEnabled: isEnabled = true, children: children } = props;
    // This flag just gives us a kill switch
    if (isEnabled && (0, $4R6GH.fg)('jfp-jira-incremental-strict-mode')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.StrictMode), null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
}
const $308f7fd68513e9ff$var$Spa = (0, $cSD7y.componentWithFG)('jfp-magma-concurrent-entrypoint-route-stability', $308f7fd68513e9ff$var$SpaNew, $308f7fd68513e9ff$var$SpaOld);
var $308f7fd68513e9ff$export$2e2bcd8739ae039 = $308f7fd68513e9ff$var$Spa;

});
parcelRegister("8Orxo", function(module, exports) {

$parcel$export(module.exports, "addLeadingSlash", () => $66a85aa0db68ca7e$export$5b4913142e03bca8, (v) => $66a85aa0db68ca7e$export$5b4913142e03bca8 = v);
$parcel$export(module.exports, "hasBasename", () => $66a85aa0db68ca7e$export$10497c7ce66fcb84, (v) => $66a85aa0db68ca7e$export$10497c7ce66fcb84 = v);
$parcel$export(module.exports, "stripBasename", () => $66a85aa0db68ca7e$export$b69e3301ce081aa3, (v) => $66a85aa0db68ca7e$export$b69e3301ce081aa3 = v);
$parcel$export(module.exports, "stripTrailingSlash", () => $66a85aa0db68ca7e$export$d95b4586d238a081, (v) => $66a85aa0db68ca7e$export$d95b4586d238a081 = v);
$parcel$export(module.exports, "parsePath", () => $66a85aa0db68ca7e$export$8ccf933b0513f8d0, (v) => $66a85aa0db68ca7e$export$8ccf933b0513f8d0 = v);
$parcel$export(module.exports, "createPath", () => $66a85aa0db68ca7e$export$fe53371bee54353d, (v) => $66a85aa0db68ca7e$export$fe53371bee54353d = v);
var $66a85aa0db68ca7e$export$1e511d4a378977f5;
var $66a85aa0db68ca7e$export$5b4913142e03bca8;
var $66a85aa0db68ca7e$export$79c5b1569e3be9e6;
var $66a85aa0db68ca7e$export$10497c7ce66fcb84;
var $66a85aa0db68ca7e$export$b69e3301ce081aa3;
var $66a85aa0db68ca7e$export$d95b4586d238a081;
var $66a85aa0db68ca7e$export$8ccf933b0513f8d0;
var $66a85aa0db68ca7e$export$fe53371bee54353d;
'use strict';
$66a85aa0db68ca7e$export$1e511d4a378977f5 = true;
var $66a85aa0db68ca7e$var$addLeadingSlash = $66a85aa0db68ca7e$export$5b4913142e03bca8 = function addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
};
var $66a85aa0db68ca7e$var$stripLeadingSlash = $66a85aa0db68ca7e$export$79c5b1569e3be9e6 = function stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
};
var $66a85aa0db68ca7e$var$hasBasename = $66a85aa0db68ca7e$export$10497c7ce66fcb84 = function hasBasename(path, prefix) {
    return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};
var $66a85aa0db68ca7e$var$stripBasename = $66a85aa0db68ca7e$export$b69e3301ce081aa3 = function stripBasename(path, prefix) {
    return $66a85aa0db68ca7e$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};
var $66a85aa0db68ca7e$var$stripTrailingSlash = $66a85aa0db68ca7e$export$d95b4586d238a081 = function stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};
var $66a85aa0db68ca7e$var$parsePath = $66a85aa0db68ca7e$export$8ccf933b0513f8d0 = function parsePath(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
};
var $66a85aa0db68ca7e$var$createPath = $66a85aa0db68ca7e$export$fe53371bee54353d = function createPath(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
    return path;
};

});

parcelRegister("drfhg", function(module, exports) {

$parcel$export(module.exports, "default", () => $11585d48f7363869$export$2e2bcd8739ae039);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $9AgLs = parcelRequire("9AgLs");
function $11585d48f7363869$var$traceUFORedirect(fromUfoName, nextUfoName, nextRouteName, time) {
    (0, $9AgLs.default).current = nextUfoName;
    const interactionId = (0, $1u4q7.DefaultInteractionID).current;
    if (interactionId) (0, $bFU4G.addRedirect)(interactionId, fromUfoName, nextUfoName, nextRouteName, time);
}
var $11585d48f7363869$export$2e2bcd8739ae039 = $11585d48f7363869$var$traceUFORedirect;

});

parcelRegister("6IjvB", function(module, exports) {

$parcel$export(module.exports, "createCheckShouldResetPage", () => $f43999df472d4d05$export$ffb8c03de895ae3);

var $ajpes = parcelRequire("ajpes");

var $4R6GH = parcelRequire("4R6GH");

var $vrkiK = parcelRequire("vrkiK");
const $f43999df472d4d05$var$isReplaceActionAndPIN = (action, route)=>action === 'REPLACE' && route.group === 'issue-navigator';
const $f43999df472d4d05$var$isReplaceActionAndJPD = (action, route)=>action === 'REPLACE' && route.name === 'polaris-ideas' && (0, $4R6GH.fg)('jpd-ignore-page-reset-on-route-replacing');
const $f43999df472d4d05$export$ffb8c03de895ae3 = ()=>{
    let rapidBoardPaths = [];
    return ({ currentMatch: currentMatch, currentRoute: currentRoute, nextMatch: nextMatch, nextRoute: nextRoute, action: action })=>{
        let shouldReset = true;
        if ($f43999df472d4d05$var$isReplaceActionAndPIN(action, nextRoute) || $f43999df472d4d05$var$isReplaceActionAndJPD(action, nextRoute) || currentRoute.isRedirect === true) shouldReset = false;
        else {
            const cleanMatch = (0, $vrkiK.getApdexMatchObject)(currentMatch, currentRoute);
            const cleanNextMatch = (0, $vrkiK.getApdexMatchObject)(nextMatch, nextRoute);
            shouldReset = !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(cleanMatch, cleanNextMatch) && shouldReset;
            if (shouldReset) {
                // RapidboardPaths is being persisted here.
                // resetDone boolean is calculated in the util function.
                const [paths, resetBoolean] = (0, $vrkiK.calcRapidBoardResetStateV2)(rapidBoardPaths, nextRoute.name, !!nextMatch.query.useStoredSettings);
                rapidBoardPaths = paths;
                if ((0, $vrkiK.isValidRoute)(nextRoute) || nextRoute.group === 'classic-software') shouldReset = !resetBoolean;
            }
        }
        return shouldReset;
    };
};

});
parcelRegister("vrkiK", function(module, exports) {

$parcel$export(module.exports, "calcRapidBoardResetState", () => $fd0af9cf1691807e$export$2350ed3ff6c1a082);
$parcel$export(module.exports, "getApdexMatchObject", () => $fd0af9cf1691807e$export$47e434f08768932b);
$parcel$export(module.exports, "calcRapidBoardResetStateV2", () => $fd0af9cf1691807e$export$dbd9185166d0d04c);
$parcel$export(module.exports, "isValidRoute", () => $fd0af9cf1691807e$export$9f3e656a7f6a3adc);
const $fd0af9cf1691807e$export$2350ed3ff6c1a082 = (boardPaths, routeName, useStoredSettings)=>{
    let rapidBoardPaths = [
        ...boardPaths
    ];
    let resetDone = false;
    switch(routeName){
        case 'browse-project-redirect':
            rapidBoardPaths = [
                'browse-project-redirect'
            ];
            resetDone = true;
            break;
        case 'rapidboard-board':
        case 'rapidboard-board-embed':
        case 'rapidboard-backlog':
        case 'rapidboard-report':
            if (useStoredSettings) {
                rapidBoardPaths = [
                    ...rapidBoardPaths,
                    'useStoredSettings'
                ];
                resetDone = false;
                break;
            }
            if (!useStoredSettings && rapidBoardPaths.indexOf('browse-project-redirect') > -1 && rapidBoardPaths.indexOf('useStoredSettings') > -1 || rapidBoardPaths.indexOf('useStoredSettings') > -1) resetDone = true;
            rapidBoardPaths = [];
            break;
        default:
            resetDone = false;
    }
    return [
        rapidBoardPaths,
        resetDone
    ];
};
const $fd0af9cf1691807e$export$47e434f08768932b = (match, route)=>{
    let cleanMatch = {
        ...match,
        params: {
            ...match.params
        },
        query: {
            ...match.query
        }
    };
    if (route.apdexIgnoreParams && route.apdexIgnoreParams.length > 0) route.apdexIgnoreParams.forEach((apdexIgnoreParam)=>{
        const { params: params, query: query } = match;
        const paramKeys = params && Object.keys(params);
        const queryKeys = query && Object.keys(query);
        const isIgnoreInParams = paramKeys && paramKeys.length > 0 && paramKeys.indexOf(apdexIgnoreParam) >= 0;
        const isIgnoreInQuery = queryKeys && queryKeys.length > 0 && queryKeys.indexOf(apdexIgnoreParam) >= 0;
        if (isIgnoreInParams) cleanMatch.params[apdexIgnoreParam] = apdexIgnoreParam;
        if (isIgnoreInQuery) cleanMatch.query[apdexIgnoreParam] = apdexIgnoreParam;
    });
    if (match.query && match.query.view && match.query.view === 'detail') // @ts-expect-error - TS2322 - Type 'undefined' is not assignable to type 'string'.
    cleanMatch.query.view = undefined;
    if (match.query && match.query.view && match.query.view === 'planning.nodetail') cleanMatch.query.view = 'planning';
    cleanMatch = {
        ...cleanMatch,
        url: ''
    };
    return cleanMatch;
};
const $fd0af9cf1691807e$export$dbd9185166d0d04c = (boardPaths, routeName, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
useStoredSettings)=>{
    let rapidBoardPaths = [
        ...boardPaths
    ];
    let resetDone = false;
    switch(routeName){
        case 'browse-project-redirect':
            rapidBoardPaths = [];
            resetDone = true;
            break;
        case 'rapidboard-backlog':
        case 'rapidboard-board':
        case 'rapidboard-report':
            // use search to navigate to board
            if (rapidBoardPaths.includes('browse-project-redirect') || rapidBoardPaths.includes('useStoredSettings')) {
                resetDone = true;
                rapidBoardPaths = [];
                break;
            } else if (useStoredSettings) {
                rapidBoardPaths = [
                    ...rapidBoardPaths,
                    'useStoredSettings'
                ];
                break;
            } else {
                rapidBoardPaths = [];
                break;
            }
        default:
            if (rapidBoardPaths.includes('browse-project-redirect')) {
                resetDone = true;
                rapidBoardPaths = [];
            }
    }
    return [
        rapidBoardPaths,
        resetDone
    ];
};
const $fd0af9cf1691807e$export$d5eae90e177f1bdd = (appId, state, searchDepth = 0)=>{
    if (state) {
        const { currentPage: currentPage, visitedPages: visitedPages } = state;
        const visitedPageLength = visitedPages.length;
        if (currentPage && currentPage.apps[appId]) return true;
        if (visitedPageLength === 0 || searchDepth <= 0) return false;
        for(let i = 1; i <= Math.min(searchDepth, visitedPageLength); i += 1){
            if (visitedPages[visitedPageLength - i].apps[appId]) return true;
        }
    }
    return false;
};
const $fd0af9cf1691807e$export$9f3e656a7f6a3adc = (routeToCheck)=>{
    switch(routeToCheck.name){
        case 'issue':
        case 'issue-embed':
        case 'issue-navigator':
        case 'issue-navigator-classic':
        case 'issue-navigator-core':
        case 'servicedesk-issues':
            return true;
        default:
            return false;
    }
};

});


parcelRegister("fjVTF", function(module, exports) {

$parcel$export(module.exports, "useShouldPerformAction", () => $16f1e09eb0055102$export$1bfa74483a8ca772);

var $5uXOq = parcelRequire("5uXOq");

var $5dFS4 = parcelRequire("5dFS4");

var $jjlDZ = parcelRequire("jjlDZ");
const $16f1e09eb0055102$export$1bfa74483a8ca772 = ({ actionName: actionName })=>{
    const metas = (0, $5dFS4.useMeta)();
    const remoteActions = (0, $5dFS4.useRemoteActionsData)();
    const { saveActionPerformedAttempt: saveActionPerformedAttempt } = (0, $5dFS4.useRemoteActionsStoreActions)();
    const [actionToPerform, setActionToPerform] = (0, $5uXOq.useState)();
    const [shouldPerformAction, setShouldPerformAction] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        // Check whether or not the action (actionName) should be performed:
        // - when the remote actions available list changes
        // - when the metas for the actions change
        const matchedAction = Object.values(remoteActions).find((action)=>{
            if (action.name !== actionName) return false;
            return true;
        });
        if (!matchedAction) return;
        setActionToPerform(matchedAction);
        setShouldPerformAction((0, $jjlDZ.computeShouldPerformAction)(matchedAction, metas));
    }, [
        actionName,
        remoteActions,
        metas
    ]);
    const performAction = (onSuccess, onCancel)=>{
        if (!actionToPerform) // just in case someone calls the function and don't check if they should before
        // maybe throw an error?
        return;
        const metaForAnalytics = {
            attempts: metas[actionToPerform.id]?.attemptCounts ?? 0,
            lastAttemptedAt: metas[actionToPerform.id]?.lastPerformAttemptedAt
        };
        if (shouldPerformAction) // For now, the onSuccess will handle:
        // * create analytics event
        // * fire the event
        onSuccess(actionToPerform, metaForAnalytics);
        else // For now, the onCancel will handle:
        // * create analytics event
        // * fire the event
        onCancel(actionToPerform, metaForAnalytics);
        saveActionPerformedAttempt(actionToPerform.id);
        // We just attempted to perfom the action, reset.
        setShouldPerformAction(false);
    };
    return {
        shouldPerformAction: shouldPerformAction,
        performAction: performAction
    };
};

});
parcelRegister("5dFS4", function(module, exports) {

$parcel$export(module.exports, "RemoteActionsContainer", () => $1e0d24cbb091f7c4$export$28c2e4c663a86266);
$parcel$export(module.exports, "useRemoteActions", () => $1e0d24cbb091f7c4$export$333357b3de3e67a0);
$parcel$export(module.exports, "useRemoteActionsData", () => $1e0d24cbb091f7c4$export$3cc006661ae2a759);
$parcel$export(module.exports, "useMeta", () => $1e0d24cbb091f7c4$export$3fb9275d3845bd5a);
$parcel$export(module.exports, "useRemoteActionLastUpdatedAt", () => $1e0d24cbb091f7c4$export$1d013261a2e6e0f9);
$parcel$export(module.exports, "useRemoteActionsStoreActions", () => $1e0d24cbb091f7c4$export$3fd21eaf97df4718);

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
var $jOqMN = parcelRequire("jOqMN");

var $4zmoY = parcelRequire("4zmoY");
// jira freezes the global defaults object
if (!Object.isFrozen((0, $jOqMN.default))) (0, $jOqMN.default).devtools = false;
const $1e0d24cbb091f7c4$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        meta: {},
        remoteActions: {},
        lastUpdatedAt: 0,
        isLoaded: false,
        product: undefined
    },
    actions: $4zmoY.actions,
    name: 'remoteActionsStore'
});
const $1e0d24cbb091f7c4$export$28c2e4c663a86266 = (0, $gg7kZ.createContainer)($1e0d24cbb091f7c4$var$Store, {
    onInit: ()=>({ dispatch: dispatch })=>{
            dispatch((0, $4zmoY.actions).initStore());
        }
});
const $1e0d24cbb091f7c4$export$333357b3de3e67a0 = (selector)=>(0, $3sQ5x.createHook)($1e0d24cbb091f7c4$var$Store, {
        selector: selector
    })();
const $1e0d24cbb091f7c4$export$3cc006661ae2a759 = (0, $3sQ5x.createStateHook)($1e0d24cbb091f7c4$var$Store, {
    selector: (state)=>state.remoteActions
});
const $1e0d24cbb091f7c4$export$3fb9275d3845bd5a = (0, $3sQ5x.createStateHook)($1e0d24cbb091f7c4$var$Store, {
    selector: (state)=>state.meta
});
const $1e0d24cbb091f7c4$export$1d013261a2e6e0f9 = (0, $3sQ5x.createStateHook)($1e0d24cbb091f7c4$var$Store, {
    selector: (state)=>state.lastUpdatedAt
});
const $1e0d24cbb091f7c4$export$3fd21eaf97df4718 = (0, $3sQ5x.createActionsHook)($1e0d24cbb091f7c4$var$Store);

});
parcelRegister("4zmoY", function(module, exports) {

$parcel$export(module.exports, "actions", () => $aaea61f326c14d61$export$e324594224ef24da);

var $iVuAh = parcelRequire("iVuAh");

var $18IDi = parcelRequire("18IDi");

var $9sXhr = parcelRequire("9sXhr");

var $5wOe3 = parcelRequire("5wOe3");
const $aaea61f326c14d61$export$e324594224ef24da = {
    processRemoteActions: $9sXhr.processRemoteActions,
    saveActionPerformedAttempt: $5wOe3.saveActionPerformedAttempt,
    initStore: $18IDi.initStore,
    clearActionId: $iVuAh.clearActionId
};

});
parcelRegister("iVuAh", function(module, exports) {

$parcel$export(module.exports, "clearActionId", () => $713396201de9d9dc$export$8d8b492eefa9efba);

var $jbSVM = parcelRequire("jbSVM");
const $713396201de9d9dc$export$8d8b492eefa9efba = (actionId)=>({ getState: getState, setState: setState }, { product: product })=>{
        const { meta: meta } = getState();
        const newMeta = {
            ...meta
        };
        delete newMeta[actionId];
        setState({
            meta: newMeta
        });
        (0, $jbSVM.writeRemoteActionsMetasToLocalStorage)(product, meta);
    };

});
parcelRegister("jbSVM", function(module, exports) {

$parcel$export(module.exports, "readRemoteActionsMetasFromLocalStorage", () => $c376cbc81521c9c0$export$a221266a05084986);
$parcel$export(module.exports, "writeRemoteActionsMetasToLocalStorage", () => $c376cbc81521c9c0$export$7228aaade919a8b6);
const $c376cbc81521c9c0$export$b9e25d3c75cffd71 = 'atlassian-remote-actions';
const $c376cbc81521c9c0$export$a221266a05084986 = (product)=>{
    try {
        return JSON.parse(localStorage.getItem(`${$c376cbc81521c9c0$export$b9e25d3c75cffd71}.${product}`) || '{}');
    } catch (e) {
        console.warn('Could not load from localStorage', e);
        return {};
    }
};
const $c376cbc81521c9c0$export$7228aaade919a8b6 = (product, remoteActionsMetas)=>{
    try {
        localStorage.setItem(`${$c376cbc81521c9c0$export$b9e25d3c75cffd71}.${product}`, JSON.stringify(remoteActionsMetas));
    } catch (e) {
        console.warn('Could not load from localStorage', e);
    }
};

});


parcelRegister("18IDi", function(module, exports) {

$parcel$export(module.exports, "initStore", () => $46b900e2f6990234$export$41f27b3823a442c6);

var $jbSVM = parcelRequire("jbSVM");
const $46b900e2f6990234$export$41f27b3823a442c6 = ()=>({ setState: setState }, { product: product })=>{
        // TODO Async read from Localstorage.
        setState({
            meta: (0, $jbSVM.readRemoteActionsMetasFromLocalStorage)(product),
            isLoaded: true,
            product: product
        });
    };

});

parcelRegister("9sXhr", function(module, exports) {

$parcel$export(module.exports, "processRemoteActions", () => $12ae2589bf32577c$export$15e69d1dd38ccaa3);

var $hDuWL = parcelRequire("hDuWL");
const $12ae2589bf32577c$export$15e69d1dd38ccaa3 = (productData, remoteActionsResponse)=>({ getState: getState, setState: setState })=>{
        const { lastUpdatedAt: lastUpdatedAt, meta: meta } = getState();
        if (remoteActionsResponse.lastUpdatedAt <= lastUpdatedAt) // data has not been updated, nothing to do
        return;
        const remoteActions = remoteActionsResponse.remoteActions.reduce((updatedRemoteActions, remoteAction)=>{
            if ((0, $hDuWL.shouldProcessRemoteAction)(remoteAction)) {
                const shouldAddAction = remoteAction.conditions.every((condition)=>(0, $hDuWL.isActionConditionSatisfied)(productData, condition));
                if (shouldAddAction) updatedRemoteActions[remoteAction.id] = remoteAction;
            }
            // no updates
            return updatedRemoteActions;
        }, {});
        setState({
            // only keep the meta for the remote actions that are still present. This is to avoid
            // keeping stale meta which would otherwise grow indefinitely.
            meta: Object.keys(remoteActions).reduce((newMeta, id)=>{
                newMeta[id] = meta[id];
                return newMeta;
            }, {}),
            remoteActions: remoteActions,
            lastUpdatedAt: remoteActionsResponse.lastUpdatedAt
        });
    };

});
parcelRegister("hDuWL", function(module, exports) {

$parcel$export(module.exports, "isActionConditionSatisfied", () => $5301c54ab422cac2$export$9262d8191a70c677);
$parcel$export(module.exports, "shouldProcessRemoteAction", () => $5301c54ab422cac2$export$c7cc93192d09a3d7);

var $7DUy3 = parcelRequire("7DUy3");
const $5301c54ab422cac2$var$isFeatureFlagConditionSatisfied = (getFeatureFlagValue, condition)=>condition.affectedFeatureFlagValue === getFeatureFlagValue(condition.featureFlagKey);
const $5301c54ab422cac2$var$isFeatureGateConditionSatisfied = (getFeatureGateValue, condition)=>getFeatureGateValue && condition.affectedFeatureGateValue === getFeatureGateValue(condition.featureGateKey);
const $5301c54ab422cac2$var$isBuildInAffectedRangeV2 = (getBuildKey, getBuildInfoFromKey, condition)=>{
    try {
        const { buildNumber: currentBuildNumber, buildType: currentBuildType } = getBuildInfoFromKey(getBuildKey());
        const { buildNumber: firstAffectedBuildNumber, buildType: firstAffectedBuildType } = getBuildInfoFromKey(condition.buildRange[0]);
        const { buildNumber: lastAffectedBuildNumber, buildType: lastAffectedBuildType } = getBuildInfoFromKey(condition.buildRange[1]);
        if (firstAffectedBuildType !== currentBuildType || lastAffectedBuildType !== currentBuildType) return false;
        if (firstAffectedBuildNumber <= currentBuildNumber && currentBuildNumber <= lastAffectedBuildNumber) return true;
    } catch (error) {
        console.warn('error while parsing a build key', error);
    }
    return false;
};
const $5301c54ab422cac2$export$9262d8191a70c677 = (productData, condition)=>{
    switch(condition.type){
        case (0, $7DUy3.ConditionType).buildRange:
            return $5301c54ab422cac2$var$isBuildInAffectedRangeV2(productData.getBuildKey, productData.getBuildInfoFromKey, condition);
        case (0, $7DUy3.ConditionType).featureFlag:
            return $5301c54ab422cac2$var$isFeatureFlagConditionSatisfied(productData.getFeatureFlagValue, condition);
        case (0, $7DUy3.ConditionType).featureGate:
            return $5301c54ab422cac2$var$isFeatureGateConditionSatisfied(productData.getFeatureGateValue, condition);
        default:
            return false;
    }
};
const $5301c54ab422cac2$export$c7cc93192d09a3d7 = (remoteAction)=>remoteAction.enabled;

});
parcelRegister("7DUy3", function(module, exports) {

$parcel$export(module.exports, "ConditionType", () => $8113f7b7a082b7e1$export$748d1c753cdf4bfd);
var $8113f7b7a082b7e1$export$748d1c753cdf4bfd = /*#__PURE__*/ function(ConditionType) {
    ConditionType["featureFlag"] = "featureFlag";
    ConditionType["featureGate"] = "featureGate";
    ConditionType["buildRange"] = "buildRange";
    return ConditionType;
}({});

});



parcelRegister("5wOe3", function(module, exports) {

$parcel$export(module.exports, "saveActionPerformedAttempt", () => $a54dff5e62ba5c12$export$e3144a2e886e0e77);

var $jbSVM = parcelRequire("jbSVM");
const $a54dff5e62ba5c12$export$e3144a2e886e0e77 = (actionId)=>({ getState: getState, setState: setState })=>{
        const { meta: meta, product: product } = getState();
        const currentAttemptCount = meta[actionId]?.attemptCounts || 0;
        const updatedMetas = {
            ...meta,
            [actionId]: {
                lastPerformAttemptedAt: Date.now(),
                attemptCounts: currentAttemptCount + 1
            }
        };
        setState({
            meta: updatedMetas
        });
        // Can not happen.
        if (!product) throw new Error('Product is not defined.');
        (0, $jbSVM.writeRemoteActionsMetasToLocalStorage)(product, updatedMetas);
    };

});



parcelRegister("jjlDZ", function(module, exports) {

$parcel$export(module.exports, "computeShouldPerformAction", () => $e970b58804722f10$export$6e0db227c9674096);

const $e970b58804722f10$export$50dbcb44bba3aa5c = 60;
const $e970b58804722f10$export$b21f5a6e7051e2c2 = (actionMetas)=>{
    const now = Date.now();
    const timeDiff = now - actionMetas.lastPerformAttemptedAt;
    return timeDiff > $e970b58804722f10$export$50dbcb44bba3aa5c * 1000;
};
const $e970b58804722f10$export$6c7cf2cb7d75fad3 = (actionMetas)=>actionMetas.attemptCounts < (0, $ff247fc2f5e84e0a$export$f2c0b74311ada874);
const $e970b58804722f10$export$6e0db227c9674096 = (action, metas)=>{
    const actionMetas = metas[action.id];
    if (!actionMetas) // No meta, we have not attempted to perform this action yet.
    return true;
    if (!$e970b58804722f10$export$6c7cf2cb7d75fad3(actionMetas)) // TODO: send a "cancelled analytics event ?"
    return false;
    if (!$e970b58804722f10$export$b21f5a6e7051e2c2(actionMetas)) return false;
    // All the conditions are satisfied, we can perform the action.
    return true;
};

});
const $ff247fc2f5e84e0a$export$f2b2f5ef0b498d26 = 5000;
const $ff247fc2f5e84e0a$export$f2c0b74311ada874 = 3;
const $ff247fc2f5e84e0a$export$af2ff676951003fe = 60000;
const $ff247fc2f5e84e0a$export$388bd7a7ebb11e7 = 'atlassian-remote-actions-v1';



parcelRegister("l9F59", function(module, exports) {

$parcel$export(module.exports, "default", () => $c27c60eec62bb2f2$export$2e2bcd8739ae039);

var $ajpes = parcelRequire("ajpes");
/**
 * Determines the feasibility of transitioning between routes in a SPA, considering initial loads,
 * user agent constraints, and predefined route conditions. Ensures seamless navigation by
 * evaluating route matches and permissions.
 */ const $c27c60eec62bb2f2$var$transitionValidator = (currentMatch, nextMatch)=>{
    // if we load SPA on a redirect route, we transition immediately skipping the checks
    if (!currentMatch) return true;
    // if next route missing (should not happen as we have a catch all route) or mobile, trigger reload
    if (!nextMatch) return false;
    // If we are still on same route and same match params, skip transition checks
    const isSameRoute = currentMatch.route === nextMatch.route;
    const isSameMatch = (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(currentMatch.match, nextMatch.match);
    if (isSameRoute && isSameMatch) return true;
    // check we can transition into next route
    // @ts-expect-error - TS2339 - Property 'canTransitionIn' does not exist on type 'Route'.
    const canDoNext = nextMatch.route.canTransitionIn?.(currentMatch, nextMatch) ?? true;
    if (canDoNext) return true;
    return false;
};
var $c27c60eec62bb2f2$export$2e2bcd8739ae039 = $c27c60eec62bb2f2$var$transitionValidator;

});

parcelRegister("i6dHx", function(module, exports) {

$parcel$export(module.exports, "ConcurrentRootComponent", () => $1fd1d5f168f244bb$export$3224d596e9b1971);

var $5uXOq = parcelRequire("5uXOq");

var $kUr4d = parcelRequire("kUr4d");

var $jsLXn = parcelRequire("jsLXn");

var $4R6GH = parcelRequire("4R6GH");

var $lODMY = parcelRequire("lODMY");

var $29g8C = parcelRequire("29g8C");
const $1fd1d5f168f244bb$var$useRouterLocation = (0, $lODMY.createRouterSelector)((state)=>state.location);
const $1fd1d5f168f244bb$var$useRouterAction = (0, $lODMY.createRouterSelector)((state)=>state.action);
const $1fd1d5f168f244bb$var$useRouterQuery = (0, $lODMY.createRouterSelector)((state)=>state.query);
const $1fd1d5f168f244bb$var$useRouterRoute = (0, $lODMY.createRouterSelector)((state)=>state.route);
const $1fd1d5f168f244bb$var$useRouterMatch = (0, $lODMY.createRouterSelector)((state)=>state.match);
const $1fd1d5f168f244bb$var$RouteComponentWithRouterProps = ()=>{
    const location = $1fd1d5f168f244bb$var$useRouterLocation();
    const action = $1fd1d5f168f244bb$var$useRouterAction();
    const query = $1fd1d5f168f244bb$var$useRouterQuery();
    const route = $1fd1d5f168f244bb$var$useRouterRoute();
    const match = $1fd1d5f168f244bb$var$useRouterMatch();
    const { component: RouteComponent } = route;
    return RouteComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(RouteComponent, {
        location: location,
        route: route,
        match: match,
        action: action,
        query: query
    });
};
function $1fd1d5f168f244bb$export$3224d596e9b1971() {
    const containerRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (!containerRef.current) // this is actually "impossible"
        throw new Error('ref is not set');
        const root = (0, $kUr4d.createRoot)(containerRef.current);
        root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jsLXn.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1fd1d5f168f244bb$var$RouteComponentWithRouterProps, null), (0, $4R6GH.fg)('concurrent-rendering-change-advisory') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $29g8C.ConcurrentAdvisory), null) : null));
        return ()=>{
            // We need the setTimeout to avoid this error:
            // `Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition.`
            setTimeout(()=>{
                root.unmount();
            });
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        id: "concurrent-route-component",
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            display: 'contents'
        },
        ref: containerRef
    });
}

});
parcelRegister("jsLXn", function(module, exports) {

$parcel$export(module.exports, "JiraContextContainer", () => $88b19a22a09480ac$export$6f7845cc5e693f16);

var $5uXOq = parcelRequire("5uXOq");

var $irJ4w = parcelRequire("irJ4w");

var $lzeFL = parcelRequire("lzeFL");

var $5tsrJ = parcelRequire("5tsrJ");

var $1OjhZ = parcelRequire("1OjhZ");

var $j8DrX = parcelRequire("j8DrX");

var $1nUas = parcelRequire("1nUas");

var $2HbP2 = parcelRequire("2HbP2");

var $8ApFP = parcelRequire("8ApFP");

var $iXVV6 = parcelRequire("iXVV6");

var $fiv1r = parcelRequire("fiv1r");

var $14XJw = parcelRequire("14XJw");

var $9OXo1 = parcelRequire("9OXo1");

var $a83ud = parcelRequire("a83ud");
const $88b19a22a09480ac$var$ContextualAnalyticsDataFeatureFlagged = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: (0, $8ApFP.routeAnalyticsAttributes)
    }, children);

const $88b19a22a09480ac$export$6f7845cc5e693f16 = (props)=>{
    const state = {
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        messages: (parcelRequire("hWnRN"))
    };
    const { data: orgId } = (0, $14XJw.useOrgId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($88b19a22a09480ac$var$ContextualAnalyticsDataFeatureFlagged, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextContainer), {
        isGlobal: true,
        getMeta: (0, $j8DrX.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1nUas.IntlProvider), {
            messages: state.messages,
            locale: (0, $lzeFL.standardizeLocale)(tenantContext.locale)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $irJ4w.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5tsrJ.default), {
            orgId: orgId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1OjhZ.ExperienceTrackerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fiv1r.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2HbP2.ModalContextProvider), null, props.children)))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a83ud.LoadingPhaseManager), null));
};

});
parcelRegister("a83ud", function(module, exports) {

$parcel$export(module.exports, "LoadingPhaseManager", () => $852e6ed10ffe3afe$export$6e4bfef9e80c7eb0);

var $5uXOq = parcelRequire("5uXOq");

var $j7rCb = parcelRequire("j7rCb");
const $852e6ed10ffe3afe$export$6e4bfef9e80c7eb0 = ()=>{
    const { startNextPhase: startNextPhase } = (0, $j7rCb.useLazyPhase)();
    (0, $5uXOq.useEffect)(()=>{
        /**
     * Only start next phase if we are not in the SPA, because there is a second
     * LoadingPhaseManager specifically for the SPA, and we want it to transition at the correct time.
     * If we start this here inside the SPA, we will start RLL next phase and get lazyAfterPaint
     * bundles too early.
     */ if (__SPA__) return;
        /* Outside the SPA, we don't currently have a good proxy for page loads.
     * So for now we start the "after paint" phase a few seconds after mounting.
     */ setTimeout(()=>{
            performance.mark('rll-after-paint-phase');
            startNextPhase();
        }, 2000);
    }, [
        startNextPhase
    ]);
    return null;
};

});

parcelRegister("hWnRN", function(module, exports) {
module.exports = __LANG;

});


parcelRegister("29g8C", function(module, exports) {

$parcel$export(module.exports, "ConcurrentAdvisory", () => $3f6cbe094065dc4a$export$e7a8408a6ddec2cb);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable jira/react/no-style-attribute */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $5uXOq = parcelRequire("5uXOq");
function $3f6cbe094065dc4a$export$e7a8408a6ddec2cb(props) {
    const { consoleMessage: consoleMessage = 'This route is being rendered with React concurrent rendering go/r18' } = props;
    const [isAdvisoryVisible, setIsAdvisoryVisible] = (0, $5uXOq.useState)(true);
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line no-console
        console.log(`%c\u{203C}\u{FE0F} ${consoleMessage} \u{203C}\u{FE0F}
If you encounter any problems, report them to https://atlassian.enterprise.slack.com/archives/C06176WU6PQ`, 'color: white; background: darkred; font-size: 16px; padding: 4px');
        const timer = setTimeout(()=>{
            setIsAdvisoryVisible(false);
        }, 5000);
        return ()=>{
            clearTimeout(timer);
        };
    }, [
        consoleMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        style: {
            position: 'absolute',
            left: 8,
            top: 12,
            display: 'flex',
            alignItems: 'center',
            // By giving this element a height of 0 and no pointer events, we ensure that it doesn't interfere with the page.
            // To make is visible again, we then set the overflow to "visible".
            height: 0,
            overflow: 'visible',
            pointerEvents: 'none',
            zIndex: 99999999
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        style: {
            backgroundColor: isAdvisoryVisible ? 'white' : 'red',
            borderRadius: '50%',
            width: 8,
            height: 8,
            zIndex: 20
        }
    }), isAdvisoryVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        style: {
            backgroundColor: 'red',
            color: 'white',
            height: '1.5em',
            marginLeft: -12,
            paddingLeft: 16,
            paddingRight: 8,
            borderRadius: 4,
            zIndex: 10
        }
    }, "Rendered in React concurrent mode go/r18"));
}

});


parcelRegister("Smjim", function(module, exports) {

$parcel$export(module.exports, "RouteEntryPointContainer", () => $813341ccf863a0ac$export$3e4cdfb894377bc9);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $2YZCu = parcelRequire("2YZCu");


var $2Ioew = parcelRequire("2Ioew");

var $frBVt = parcelRequire("frBVt");

var $7LpuY = parcelRequire("7LpuY");

var $egPYN = parcelRequire("egPYN");

var $dZw8H = parcelRequire("dZw8H");

var $eIGIx = parcelRequire("eIGIx");
const $813341ccf863a0ac$var$LOCATION = 'route-entry-point-container';
const $813341ccf863a0ac$export$fb85bbdbfb3e6869 = ()=>null;
const $813341ccf863a0ac$var$EMPTY_OBJECT = {};
const $813341ccf863a0ac$export$3e4cdfb894377bc9 = ({ location: location, route: route, match: match, action: action, query: query })=>{
    const entryPointReference = (0, $2Ioew.usePageLayoutEntryPoint)((0, $6d6ccf8a2b2c5b3c$export$900ddb492c628f48));
    // in order to show a spinner while page loading -> `route.skeleton=Spinner`
    const Skeleton = (0, $eIGIx.useMemoWithCondition)(()=>route.skeleton || $813341ccf863a0ac$export$fb85bbdbfb3e6869, [
        route.skeleton
    ], ()=>(0, $4R6GH.fg)('jfp-magma-concurrent-entrypoint-route-stability'));
    (0, $5uXOq.useEffect)(()=>{
        if (route.isRedirect) (0, $2YZCu.default).safeWarnWithoutCustomerData($813341ccf863a0ac$var$LOCATION, `EntryPoint was used inside a redirect component: ${route.name}`);
    }, [
        route.isRedirect,
        route.name
    ]);
    const pageId = (0, $eIGIx.useMemoWithCondition)(()=>{
        let _pageId = route.name;
        if (route.pageId) {
            if (typeof route.pageId === 'function') _pageId = route.pageId({
                route: route,
                action: action,
                location: location,
                match: match,
                query: query
            });
            else _pageId = route.pageId;
        }
        return _pageId;
    }, [
        action,
        location,
        match,
        query,
        route
    ], ()=>(0, $4R6GH.fg)('jfp-magma-concurrent-entrypoint-route-stability'));
    if (!entryPointReference) return null;
    const fallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Skeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $egPYN.ReportSSRFailOnUse), {
        pageId: pageId
    }));
    const page = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $egPYN.DisableSSRFailDetection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
        entryPointReference: entryPointReference,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props: (0, $4R6GH.fg)('jfp-magma-concurrent-entrypoint-route-stability') ? $813341ccf863a0ac$var$EMPTY_OBJECT : {}
    }));
    return route.isRedirect ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $frBVt.EntryPointReferencePlaceholder), {
        entryPointReference: entryPointReference,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Skeleton, null),
        name: "route_entry_point_redirect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
        entryPointReference: entryPointReference,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props: (0, $4R6GH.fg)('jfp-magma-concurrent-entrypoint-route-stability') ? $813341ccf863a0ac$var$EMPTY_OBJECT : {}
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7LpuY.default), {
        pageId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStateContainer), {
        isGlobal: true,
        appId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStateAppStartWithMatchCheck), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $frBVt.EntryPointReferencePlaceholder), {
        entryPointReference: entryPointReference,
        fallback: fallback,
        name: "route_entry_point"
    }, page)));
};

});



parcelRegister("h0PjI", function(module, exports) {

$parcel$export(module.exports, "LayoutMainWrapper", () => $571ff4fe4ca2a221$export$712225703044cda);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $571ff4fe4ca2a221$export$712225703044cda = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1bgi _iu1g1fl4 _2d3f16n6",
            __cmplp.className
        ])
    });
});

});


parcelRegister("j8O2d", function(module, exports) {

$parcel$export(module.exports, "MemoryMonitor", () => $2d2c90c8e7cd028c$export$afbeaf57d30e8397);
// Based on confluence/packages/confluence-frontend-server/src/memory-monitor.js

var $5uXOq = parcelRequire("5uXOq");

var $fjcgS = parcelRequire("fjcgS");

var $lODMY = parcelRequire("lODMY");

var $c1haS = parcelRequire("c1haS");
const $2d2c90c8e7cd028c$export$ac4cd9f30299a490 = 0.8;
const $2d2c90c8e7cd028c$export$632c6346c3a8c3e2 = 10000; // 10 seconds
const $2d2c90c8e7cd028c$export$de8f032132af9697 = 4000; // issue view has ~2.5k event listeners
let $2d2c90c8e7cd028c$var$routeName = 'unknown';
let $2d2c90c8e7cd028c$var$analyticsClient = null;
let $2d2c90c8e7cd028c$var$memoryMonitorInterval = null;
let $2d2c90c8e7cd028c$var$_eventListenerCount = 0;
let $2d2c90c8e7cd028c$var$initializedEventListeners = false;
function $2d2c90c8e7cd028c$var$bytesToMB(bytes) {
    const MB = 1048576;
    return bytes / MB;
}
const $2d2c90c8e7cd028c$export$3b9e9fb6812d2b4e = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage, no-restricted-properties, @typescript-eslint/consistent-type-assertions
    const performance = window?.performance;
    return performance?.memory;
};
const $2d2c90c8e7cd028c$export$20e022b37d61b084 = ()=>$2d2c90c8e7cd028c$var$_eventListenerCount; // for testing
function $2d2c90c8e7cd028c$export$5ed8144ed56e505a(client) {
    if (client) $2d2c90c8e7cd028c$var$analyticsClient = client;
    if (!$2d2c90c8e7cd028c$var$analyticsClient) return false;
    const isConcurrentEnabled = (0, $c1haS.getIsConcurrentEnabled)();
    const memory = $2d2c90c8e7cd028c$export$3b9e9fb6812d2b4e();
    if (memory) {
        const { jsHeapSizeLimit: jsHeapSizeLimit, usedJSHeapSize: usedJSHeapSize } = memory;
        const heapThreshold = jsHeapSizeLimit * $2d2c90c8e7cd028c$export$ac4cd9f30299a490;
        if (usedJSHeapSize > heapThreshold) $2d2c90c8e7cd028c$var$analyticsClient.sendOperationalEvent({
            source: 'jira-memory-monitor',
            action: 'measured',
            actionSubject: 'highHeapUsage',
            attributes: {
                heapUsagePercent: Math.floor(usedJSHeapSize / jsHeapSizeLimit * 100),
                heapUsageMB: Math.floor($2d2c90c8e7cd028c$var$bytesToMB(usedJSHeapSize)),
                maxHeapSizeMB: Math.floor($2d2c90c8e7cd028c$var$bytesToMB(jsHeapSizeLimit)),
                route: $2d2c90c8e7cd028c$var$routeName,
                isConcurrentEnabled: isConcurrentEnabled
            }
        });
    }
    if ($2d2c90c8e7cd028c$var$initializedEventListeners && $2d2c90c8e7cd028c$export$20e022b37d61b084() > $2d2c90c8e7cd028c$export$de8f032132af9697) $2d2c90c8e7cd028c$var$analyticsClient.sendOperationalEvent({
        source: 'jira-memory-monitor',
        action: 'measured',
        actionSubject: 'highEventListenerCount',
        attributes: {
            eventListenerCount: $2d2c90c8e7cd028c$export$20e022b37d61b084(),
            route: $2d2c90c8e7cd028c$var$routeName,
            isConcurrentEnabled: isConcurrentEnabled
        }
    });
    return true;
}
function $2d2c90c8e7cd028c$export$337817b784baf528() {
    const originalAddEventListener = EventTarget.prototype.addEventListener;
    const originalRemoveEventListener = EventTarget.prototype.removeEventListener;
    if (!$2d2c90c8e7cd028c$var$initializedEventListeners) {
        EventTarget.prototype.addEventListener = function addEventListenerWithCounter(type, listener, options) {
            $2d2c90c8e7cd028c$var$_eventListenerCount++;
            originalAddEventListener.call(this, type, listener, options);
        };
        EventTarget.prototype.removeEventListener = function removeEventListenerWithCounter(type, listener, options) {
            $2d2c90c8e7cd028c$var$_eventListenerCount--;
            originalRemoveEventListener.call(this, type, listener, options);
        };
        $2d2c90c8e7cd028c$var$initializedEventListeners = true;
    }
}
function $2d2c90c8e7cd028c$export$76f12cc80b7fd2f3(client) {
    $2d2c90c8e7cd028c$var$analyticsClient = client;
    $2d2c90c8e7cd028c$export$337817b784baf528();
    if (!$2d2c90c8e7cd028c$var$memoryMonitorInterval) $2d2c90c8e7cd028c$var$memoryMonitorInterval = setInterval($2d2c90c8e7cd028c$export$5ed8144ed56e505a, $2d2c90c8e7cd028c$export$632c6346c3a8c3e2);
    return true;
}
function $2d2c90c8e7cd028c$export$d0c8b02fd4ae0022(name) {
    $2d2c90c8e7cd028c$var$routeName = name;
}
function $2d2c90c8e7cd028c$export$b35196bdb32e40c9() {
    if ($2d2c90c8e7cd028c$var$memoryMonitorInterval) {
        clearInterval($2d2c90c8e7cd028c$var$memoryMonitorInterval);
        $2d2c90c8e7cd028c$var$memoryMonitorInterval = null;
    }
}
const $2d2c90c8e7cd028c$var$MemoryMonitorClient = ()=>{
    const hasInit = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (hasInit.current) return;
        hasInit.current = true;
        (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            const instance = client?.getInstance();
            if (instance) {
                $2d2c90c8e7cd028c$var$analyticsClient = instance;
                $2d2c90c8e7cd028c$export$76f12cc80b7fd2f3(instance);
            }
        });
        return $2d2c90c8e7cd028c$export$b35196bdb32e40c9;
    });
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = (0, $lODMY.addRouteListener)((state)=>{
            $2d2c90c8e7cd028c$export$d0c8b02fd4ae0022(state?.route?.name ?? 'unknown');
        });
        return unsubscribe;
    }, []);
    return null;
};
const $2d2c90c8e7cd028c$export$afbeaf57d30e8397 = ()=>{
    if (false) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2d2c90c8e7cd028c$var$MemoryMonitorClient, null);
};

});


parcelRegister("9F6Ii", function(module, exports) {

$parcel$export(module.exports, "StrictMode", () => $02febe252cc7980c$export$5f8d39834fd61797);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");
const $02febe252cc7980c$export$5f8d39834fd61797 = ({ children: children })=>{
    // allow developers to disable strict mode for local development
    const isStrictModeDisabled = !(0, $4R6GH.fg)('jira-enable-strict-mode');
    if (isStrictModeDisabled) return children;
    // React.StrictMode usage is enabled by default
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).StrictMode, null, children);
};

});

parcelRegister("81ezV", function(module, exports) {

$parcel$export(module.exports, "JiraRouterLinkConfiguration", () => $33ea5bfeb747665b$export$a580704a2f3cfca);

var $5uXOq = parcelRequire("5uXOq");

var $hjSul = parcelRequire("hjSul");

var $2e4p8 = parcelRequire("2e4p8");

var $4R6GH = parcelRequire("4R6GH");
const $33ea5bfeb747665b$export$a580704a2f3cfca = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ href: href, children: children, ...rest }, ref)=>{
    const isEmbedMode = (0, $2e4p8.useIsEmbedMode)() && (0, $4R6GH.fg)('jira_nin_smart_link');
    if (// Links can be initially rendered with `href` not defined in some cases
    !href || typeof href === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
        ref: ref,
        href: href || '#',
        ...rest,
        ...isEmbedMode && {
            target: '_blank',
            rel: 'noopener'
        }
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
        ref: ref,
        href: href.href,
        to: href.to,
        replace: href.replace,
        params: href.params,
        query: href.query,
        prefetch: href.prefetch,
        ...rest,
        ...isEmbedMode && {
            target: '_blank',
            rel: 'noopener'
        }
    }, children);
});

});
parcelRegister("2e4p8", function(module, exports) {

$parcel$export(module.exports, "useIsEmbedMode", () => $f2340f168be8a214$export$1b3c1ba6ee047da9);

var $5uXOq = parcelRequire("5uXOq");

var $7DqiA = parcelRequire("7DqiA");

var $7DqiA = parcelRequire("7DqiA");
const $f2340f168be8a214$export$1b3c1ba6ee047da9 = ()=>(0, $5uXOq.useContext)((0, $7DqiA.EmbedModeContext));

});


parcelRegister("b7awD", function(module, exports) {

$parcel$export(module.exports, "Router", () => $87aa2fd82c8be71a$export$55185c17a0fcbe46);

var $5uXOq = parcelRequire("5uXOq");

var $15Xx4 = parcelRequire("15Xx4");

var $d8orV = parcelRequire("d8orV");
const $87aa2fd82c8be71a$export$55185c17a0fcbe46 = ({ children: children, ...props })=>{
    const pluginsWithOverride = (0, $d8orV.usePlugins)({
        resourceContext: props.resourceContext,
        resourceData: props.resourceData
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $15Xx4.Router), {
        plugins: pluginsWithOverride,
        ...props
    }, children);
};

});
parcelRegister("d8orV", function(module, exports) {

$parcel$export(module.exports, "usePlugins", () => $0614c9d3afc2dd7f$export$c41e96fd89bc6106);

var $5uXOq = parcelRequire("5uXOq");

var $a2g00 = parcelRequire("a2g00");

var $5yJb9 = parcelRequire("5yJb9");

var $9OXo1 = parcelRequire("9OXo1");

var $8Y8sk = parcelRequire("8Y8sk");
const $0614c9d3afc2dd7f$export$c41e96fd89bc6106 = ({ resourceContext: resourceContext, resourceData: resourceData })=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    // make sure "plugins" are created only once, ignore prop change/rerender
    const [pluginsWithOverride] = (0, $5uXOq.useState)(()=>{
        const jiraPlugins = [];
        const resourcesPlugin = (0, $8Y8sk.createResourcesPlugin)({
            context: resourceContext,
            resourceData: resourceData
        });
        jiraPlugins.push(resourcesPlugin);
        jiraPlugins.push((0, $a2g00.createEntryPointsPlugin)({
            environment: (0, $5yJb9.default)(),
            entryPointParams: {
                tenantContext: tenantContext
            }
        }));
        return jiraPlugins;
    });
    return pluginsWithOverride;
};

});
parcelRegister("a2g00", function(module, exports) {

$parcel$export(module.exports, "createEntryPointsPlugin", () => $e3cbf02360bc6f96$export$33586718f82f356f);

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $3gC8D = parcelRequire("3gC8D");

var $3I4nj = parcelRequire("3I4nj");

var $ktB2C = parcelRequire("ktB2C");

var $9dbn9 = parcelRequire("9dbn9");

var $gH2st = parcelRequire("gH2st");
const $e3cbf02360bc6f96$export$33586718f82f356f = ({ environment: environment, entryPointParams: entryPointParams })=>({
        id: 'entry-points-plugin',
        routeLoad: ({ context: context })=>{
            const entryPoint = context.route.entryPoint?.();
            const prefetchingRoute = (0, $3I4nj.getPrefetchingRoute)();
            let entryPointReference = null;
            if (entryPoint) {
                // check if route EntryPoint is already prefetched right before being loaded
                if (prefetchingRoute && (0, $3gC8D.isSameRouteMatch)({
                    prevContextMatch: prefetchingRoute.routerContext.match,
                    nextContextMatch: context.match
                }) && !(0, $3gC8D.isExpired)(prefetchingRoute.expiresAt)) entryPointReference = prefetchingRoute.entryPointReference;
                else {
                    const entryPointParamsWithContext = {
                        context: context,
                        ...entryPointParams
                    };
                    const loadEntryPointsWithContext = ()=>(0, $8Uumt.loadEntryPoint)({
                            getEnvironment: ()=>environment
                        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                        entryPoint, entryPointParamsWithContext);
                    entryPointReference = false && (0, $4R6GH.fg)('jira-ssr-prevent-prewarming-entrypoint-in-prefetch') ? (0, $gH2st.default)(entryPoint, entryPointParamsWithContext, loadEntryPointsWithContext) : loadEntryPointsWithContext();
                }
            }
            // saving entryPointReference helps to prevent cases when same EntryPoint is fetched multiple times
            // important when fetchPolicy=network-only is used
            (0, $3I4nj.getEntryPointsStore)().actions.setLastLoadedRoute({
                route: context.route,
                entryPointReference: entryPointReference
            });
            return {
                entryPoint: entryPointReference
            };
        },
        routePrefetch: ({ nextContext: nextContext })=>{
            const entryPoint = nextContext.route.entryPoint?.();
            if (entryPoint) {
                const prevPrefetchingRoute = (0, $3I4nj.getPrefetchingRoute)();
                // check if EntryPoint is already prefetched and not expired
                if (prevPrefetchingRoute && (0, $3gC8D.isSameRouteMatch)({
                    prevContextMatch: prevPrefetchingRoute.routerContext.match,
                    nextContextMatch: nextContext.match
                }) && !(0, $3gC8D.isExpired)(prevPrefetchingRoute.expiresAt)) return;
                const entryPointReference = (0, $8Uumt.loadEntryPoint)({
                    getEnvironment: ()=>environment
                }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                entryPoint, {
                    context: nextContext,
                    ...entryPointParams
                });
                (0, $3I4nj.getEntryPointsStore)().actions.setPrefetchingRoute({
                    routerContext: nextContext,
                    expiresAt: (0, $3gC8D.getExpiresAt)(),
                    entryPointReference: entryPointReference
                });
            } else (0, $3I4nj.getEntryPointsStore)().actions.setPrefetchingRoute({
                routerContext: nextContext,
                expiresAt: 0,
                entryPointReference: null
            });
        },
        waitForEntryPoint: ()=>{
            const lastLoadedRoute = (0, $3I4nj.getLastLoadedRoute)();
            const entryPointReference = lastLoadedRoute?.entryPointReference ?? null;
            if (entryPointReference) return (0, $ktB2C.waitForEntryPoint)(entryPointReference);
            return Promise.resolve();
        },
        getStats: async ()=>{
            const lastLoadedRoute = (0, $3I4nj.getLastLoadedRoute)();
            const entryPointReference = lastLoadedRoute?.entryPointReference ?? null;
            if (entryPointReference) return (0, $9dbn9.getEntryPointStats)(entryPointReference);
            return [];
        }
    });

});
parcelRegister("3gC8D", function(module, exports) {

$parcel$export(module.exports, "getExpiresAt", () => $f48ce76f20803aec$export$b65d7ba7fbf150f1);
$parcel$export(module.exports, "isExpired", () => $f48ce76f20803aec$export$57947cfd429801a2);
$parcel$export(module.exports, "isSameRouteMatch", () => $f48ce76f20803aec$export$5997e70fc4543270);
const $f48ce76f20803aec$export$37d3126be6549b13 = 10000;
const $f48ce76f20803aec$export$b65d7ba7fbf150f1 = ()=>$f48ce76f20803aec$export$37d3126be6549b13 + Date.now();
const $f48ce76f20803aec$export$57947cfd429801a2 = (expiresAt)=>expiresAt < Date.now();
const $f48ce76f20803aec$var$isShallowEqual = (o1, o2)=>{
    const objKeys1 = Object.keys(o1);
    const objKeys2 = Object.keys(o2);
    if (objKeys1.length !== objKeys2.length) return false;
    return objKeys1.every((key)=>o1[key] === o2[key]);
};
const $f48ce76f20803aec$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $f48ce76f20803aec$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $f48ce76f20803aec$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);

});

parcelRegister("ktB2C", function(module, exports) {

$parcel$export(module.exports, "waitForEntryPoint", () => $67d2b262678828c6$export$944f853f194e5dd5);

var $kipqU = parcelRequire("kipqU");
const $67d2b262678828c6$export$944f853f194e5dd5 = (entryPointConfig)=>{
    const promises = [];
    try {
        entryPointConfig.getComponent();
    } catch (err) {
        if (err instanceof Promise) promises.push(err);
        else throw err;
    }
    const { queries: queries, entryPoints: entryPoints } = entryPointConfig;
    if (queries) Object.keys(queries).forEach((key)=>{
        if (queries[key].id) {
            const queryPromise = (0, $kipqU.QueryPromisesMap).get(String(queries[key].id));
            if (queryPromise) promises.push(queryPromise);
        }
    });
    if (entryPoints) Object.keys(entryPoints).forEach((key)=>{
        const nestedEntryPointPromise = $67d2b262678828c6$export$944f853f194e5dd5(entryPoints[key]);
        promises.push(nestedEntryPointPromise);
    });
    return Promise.allSettled(promises);
};

});

parcelRegister("9dbn9", function(module, exports) {

$parcel$export(module.exports, "getEntryPointStats", () => $61c2db9f130d2efd$export$ee016802bdebb378);

var $kipqU = parcelRequire("kipqU");
const $61c2db9f130d2efd$export$14ba46fa7bd4c0a9 = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
const $61c2db9f130d2efd$export$982a0a12103fb99f = async (promise)=>{
    if (!promise) return 'resolved';
    try {
        if (await Promise.race([
            promise,
            Promise.resolve('timeout')
        ]) === 'timeout') return 'pending';
        return 'resolved';
    } catch (e) {
        return 'rejected';
    }
};
const $61c2db9f130d2efd$var$getEntrypointQueryState = async (queryId)=>{
    const queryPromise = (0, $kipqU.QueryPromisesMap).get(queryId);
    return {
        queryId: queryId,
        status: await $61c2db9f130d2efd$export$982a0a12103fb99f(queryPromise)
    };
};
const $61c2db9f130d2efd$export$ee016802bdebb378 = (entryPointConfig)=>{
    const result = [];
    const analyseEntrypoint = ({ queries: queries, entryPoints: entryPoints })=>{
        if (queries) Object.keys(queries).forEach((key)=>{
            if (queries[key].id) result.push($61c2db9f130d2efd$var$getEntrypointQueryState(String(queries[key].id)));
        });
        if (entryPoints) Object.entries(entryPoints).forEach(([, entryPoint])=>{
            analyseEntrypoint(entryPoint);
        });
    };
    analyseEntrypoint(entryPointConfig);
    return Promise.all(result);
};

});

parcelRegister("gH2st", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d282350af6c97c4$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $4R6GH = parcelRequire("4R6GH");

var $2OZhN = parcelRequire("2OZhN");

var $6jQmc = parcelRequire("6jQmc");

var $klZ80 = parcelRequire("klZ80");

// eslint-disable-next-line jira/jira-ssr/wrong-entrypoint-usage
const $7d282350af6c97c4$var$DummyAsyncModule = (0, $2OZhN.JSResourceForUserVisible)(()=>Promise.resolve((parcelRequire("klZ80"))), {
    moduleId: "7d80bb6f",
    moduleName: "ReactFragment",
    priority: "userVisible"
} // using a real async import to make the js-resource transformers/babel-plugins happy
);
$7d282350af6c97c4$var$DummyAsyncModule.getModuleIfRequired = ()=>(0, $klZ80.default); // prevent attempts to fetch the module async at all

/**
 * Run a given loadEntryPoint function without loading the entrypoint modules, then load them right afterwards.
 *
 * This is to prevent triggering the loading of entrypoints modules inline with the data fetching.
 * When JS modules are inline-required (such as in SSR when async modules are converted to inline-requires)
 * this leads to inline-evaluating all dependencies for large component modules before kicking off the data for them.
 * This causes a measurable performance hit (~20-80ms in many cases) before we even kick off critical data fetches.
 *
 * Deferring the module loading until after the data fetching allows the module execution to occur in the less critical
 * idle time while waiting for data fetches to return.
 */ function $7d282350af6c97c4$var$loadEntryPointDataThenModules(entryPoint, entryPointParams, loadEntryPointCallback) {
    const originalModulesByEntrypointRef = new Map();
    (0, $6jQmc.default)(entryPoint, entryPointParams, (loopingEntryPoint)=>{
        originalModulesByEntrypointRef.set(loopingEntryPoint, loopingEntryPoint.root);
        // eslint-disable-next-line no-param-reassign
        loopingEntryPoint.root = $7d282350af6c97c4$var$DummyAsyncModule;
    });
    try {
        return loadEntryPointCallback();
    } finally{
        (0, $6jQmc.default)(entryPoint, entryPointParams, (loopingEntryPoint)=>{
            const originalModule = originalModulesByEntrypointRef.get(loopingEntryPoint);
            if (!originalModule) throw new Error('Original module not found for entrypoint');
            // eslint-disable-next-line no-param-reassign
            loopingEntryPoint.root = originalModule;
        });
        // Kicks off the loading of the original modules as they would have, but after the data fetches have been started
        // Without this, entrypoints may have trouble rendering
        // Wrap it in a promise to prevent it from affecting timers that start synchronously after this function
        Promise.resolve().then(function() {
            return Promise.resolve((parcelRequire("klZ80")));
        }).then((res)=>originalModulesByEntrypointRef.forEach((entryPointModule)=>{
                // Essentially we've updated the JSResourceReference in react-async to have the right types
                // but react-entrypoint takes the types from @types/react-relay which lacks the new methods
                // So instead of adjusting it for everyone, manually casting it here reduces the blast radius significantly
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const typedEntryPointModule = entryPointModule;
                if (typedEntryPointModule.getPriority() !== 'userVisible' && (0, $4R6GH.fg)('jfp-magma-remove-non-uservisible-content-runtime')) // console logging so we can track it in SSR as fireErrorAnalytics is not available
                // eslint-disable-next-line no-console
                console.log(JSON.stringify({
                    message: 'Wrong entrypoint priority has been used',
                    path: typedEntryPointModule.getModulePath(),
                    priority: typedEntryPointModule.getPriority()
                }));
                const jsModule = entryPointModule.getModuleIfRequired();
                if (jsModule != null) return;
                entryPointModule.load();
            }));
    }
}
var $7d282350af6c97c4$export$2e2bcd8739ae039 = $7d282350af6c97c4$var$loadEntryPointDataThenModules;

});
parcelRegister("6jQmc", function(module, exports) {

$parcel$export(module.exports, "default", () => $692ea781fc4c525f$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Recursively run through all nested entrypoints with a given callback
 */ function $692ea781fc4c525f$var$forAllEntryPoints(entryPoint, entryPointParams, callback) {
    callback(entryPoint);
    const preloadProps = entryPoint.getPreloadProps(entryPointParams);
    const entryPoints = preloadProps.entryPoints;
    if (!entryPoints) return;
    Object.values(entryPoints).forEach(({ entryPoint: nestedEntryPoint, entryPointParams: nestedParams })=>{
        if (nestedEntryPoint) $692ea781fc4c525f$var$forAllEntryPoints(nestedEntryPoint, nestedParams, callback);
    });
}
var $692ea781fc4c525f$export$2e2bcd8739ae039 = $692ea781fc4c525f$var$forAllEntryPoints;

});

parcelRegister("klZ80", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $73d7313e0b755887$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $73d7313e0b755887$var$ReactFragment = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
var $73d7313e0b755887$export$2e2bcd8739ae039 = $73d7313e0b755887$var$ReactFragment;

});



parcelRegister("8Y8sk", function(module, exports) {

$parcel$export(module.exports, "createResourcesPlugin", () => $d3b2f44f58ee61bb$export$23ed892c481a96fe);

var $8fYaK = parcelRequire("8fYaK");

var $4CEu1 = parcelRequire("4CEu1");
const $d3b2f44f58ee61bb$export$a9bc0bb87abc2c4c = 'resources-plugin';
const $d3b2f44f58ee61bb$var$loadOnUrlChange = (context, prevContext)=>{
    const { requestResources: requestResources, getContext: getResourceStoreContext } = (0, $8fYaK.getResourceStore)().actions;
    const nextResources = (0, $4CEu1.getResourcesForNextLocation)(prevContext, context, getResourceStoreContext());
    return Promise.all(requestResources(nextResources, context, {}));
};
const $d3b2f44f58ee61bb$var$beforeLoad = ({ context: context, nextContext: nextContext })=>{
    const { cleanExpiredResources: cleanExpiredResources, getContext: getResourceStoreContext } = (0, $8fYaK.getResourceStore)().actions;
    const nextResources = (0, $4CEu1.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
    cleanExpiredResources(nextResources, nextContext);
};
const $d3b2f44f58ee61bb$export$23ed892c481a96fe = ({ context: initialResourceContext, resourceData: initialResourceData, timeout: timeout })=>{
    let latestLoadedResources = Promise.resolve([]);
    (0, $8fYaK.getResourceStore)().actions.hydrate({
        resourceContext: initialResourceContext,
        resourceData: initialResourceData
    });
    return {
        id: $d3b2f44f58ee61bb$export$a9bc0bb87abc2c4c,
        beforeRouteLoad: $d3b2f44f58ee61bb$var$beforeLoad,
        routeLoad: ({ context: context, prevContext: prevContext })=>{
            const { route: route, match: match, query: query } = context;
            // TODO: in next refactoring add `if (route.resources)` check
            // For now requesting resources for every route even if `resources` prop is missing on Route
            if (prevContext) latestLoadedResources = $d3b2f44f58ee61bb$var$loadOnUrlChange(context, prevContext);
            else latestLoadedResources = (0, $8fYaK.getResourceStore)().actions.requestAllResources({
                route: route,
                match: match,
                query: query
            }, {
                timeout: timeout
            });
        },
        routePrefetch: ({ context: context, nextContext: nextContext })=>{
            const { prefetchResources: prefetchResources, getContext: getResourceStoreContext } = (0, $8fYaK.getResourceStore)().actions;
            const nextResources = (0, $4CEu1.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
            return {
                resources: prefetchResources(nextResources, nextContext, {})
            };
        },
        getLatestResources: ()=>latestLoadedResources,
        getSerializedResources: async ()=>{
            await latestLoadedResources;
            return (0, $8fYaK.getResourceStore)().actions.getSafeData();
        }
    };
};

});
parcelRegister("4CEu1", function(module, exports) {

$parcel$export(module.exports, "getResourcesForNextLocation", () => $448a0fea894dd469$export$7cbbc763e2f3d65d);

var $9KbzN = parcelRequire("9KbzN");

var $dj41J = parcelRequire("dj41J");
const $448a0fea894dd469$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
    const { route: prevRoute } = prevRouterStoreContext;
    const { resources: prevResources = [] } = prevRoute || {};
    const { route: nextRoute } = nextRouterStoreContext;
    const { resources: nextResources = [] } = nextRoute || {};
    if (!(0, $dj41J.routeHasResources)(nextRoute)) return [];
    if ((0, $dj41J.routeHasChanged)(prevRoute, nextRoute)) return nextResources;
    const prevResourceIdentifiers = (0, $9KbzN.getResourceIdentifiers)(prevResources, prevRouterStoreContext, resourceStoreContext);
    return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, $9KbzN.getResourceIdentifier)(resource, nextRouterStoreContext, resourceStoreContext)));
};

});
parcelRegister("9KbzN", function(module, exports) {

$parcel$export(module.exports, "getResourceIdentifier", () => $82cfa1d66d41fab5$export$c616b176adf9ad4a);
$parcel$export(module.exports, "getResourceIdentifiers", () => $82cfa1d66d41fab5$export$cd7fbe7e979df558);
const $82cfa1d66d41fab5$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
    const { type: type, getKey: getKey } = resource;
    const key = getKey(routerStoreContext, resourceStoreContext);
    return `${type}/${key}`;
};
const $82cfa1d66d41fab5$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$82cfa1d66d41fab5$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));

});

parcelRegister("dj41J", function(module, exports) {

$parcel$export(module.exports, "routeHasResources", () => $9c8422e0259b24f6$export$740886389191c640);
$parcel$export(module.exports, "routeHasChanged", () => $9c8422e0259b24f6$export$221027ff1aa38f82);
const $9c8422e0259b24f6$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
const $9c8422e0259b24f6$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;

});





parcelRegister("d1K1f", function(module, exports) {

$parcel$export(module.exports, "default", () => $fffa056866f763fb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $6vAaw = parcelRequire("6vAaw");

var $gccSB = parcelRequire("gccSB");

var $6YRTH = parcelRequire("6YRTH");

var $j8DrX = parcelRequire("j8DrX");

var $1bQGJ = parcelRequire("1bQGJ");

var $TtQEC = parcelRequire("TtQEC");

var $7IBED = parcelRequire("7IBED");

var $5Jsi2 = parcelRequire("5Jsi2");
const $fffa056866f763fb$var$sessionQueryParams = [
    'searchSessionId',
    'searchObjectId',
    'searchContainerId',
    'searchContentType'
];
const $fffa056866f763fb$var$sessionMeta = [
    'ajs-search-session-id',
    'ajs-search-object-id',
    'ajs-search-container-id',
    'ajs-search-content-type'
];
const $fffa056866f763fb$var$removeDwellComponent = (placeholderId)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const element = document.getElementById(placeholderId);
    if (placeholderId && element) (0, $7nsd3.unmountComponentAtNode)(element);
};
const $fffa056866f763fb$var$removeSessionMeta = ()=>$fffa056866f763fb$var$sessionMeta.forEach((0, $7IBED.removeMetaTag));
// @ts-expect-error - TS7031 - Binding element 'sessionId' implicitly has an 'any' type. | TS7031 - Binding element 'objectId' implicitly has an 'any' type. | TS7031 - Binding element 'containerId' implicitly has an 'any' type. | TS7031 - Binding element 'objectType' implicitly has an 'any' type.
const $fffa056866f763fb$var$addSessionMeta = ({ sessionId: sessionId, objectId: objectId, containerId: containerId, objectType: objectType })=>{
    const newMeta = {
        'ajs-search-session-id': sessionId,
        'ajs-search-object-id': objectId,
        'ajs-search-container-id': containerId,
        'ajs-search-content-type': objectType
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(newMeta).forEach(([name, content])=>(0, $7IBED.addMetaTag)(name, content));
};
const $fffa056866f763fb$var$getPreviousSessionId = ()=>(0, $j8DrX.default)('ajs-search-session-id');
class $fffa056866f763fb$export$f1e582dddb502dd6 extends (0, $5uXOq.Component) {
    constructor(props){
        super(props), this.onClearSessionEvent = ()=>{
            if (this.state.shouldRemoveSessionBeIgnored) this.setState({
                shouldRemoveSessionBeIgnored: false
            });
        }, this.onHistoryChange = (location)=>{
            $fffa056866f763fb$var$removeDwellComponent('search-dwell-time');
            const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($6vAaw))).parse(location.pathname + location.search, true);
            const queryString = parsedUrl.query || {};
            const { searchSessionId: searchSessionId, searchObjectId: searchObjectId, searchContainerId: searchContainerId, searchContentType: searchContentType } = queryString;
            const { path: path } = parsedUrl;
            const previousSessionId = $fffa056866f763fb$var$getPreviousSessionId();
            const { shouldRemoveSessionBeIgnored: shouldRemoveSessionBeIgnored } = this.state;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(previousSessionId) && !shouldRemoveSessionBeIgnored) $fffa056866f763fb$var$removeSessionMeta();
            if (searchSessionId) {
                (0, $6YRTH.default)($fffa056866f763fb$var$sessionQueryParams);
                const newState = {
                    sessionId: searchSessionId,
                    objectId: searchObjectId,
                    objectType: searchContentType,
                    containerId: searchContainerId,
                    previousSessionId: $fffa056866f763fb$var$getPreviousSessionId()
                };
                $fffa056866f763fb$var$addSessionMeta(newState);
                const shouldRemoveSession = !!(0, $5Jsi2.skipClearSessionURLs).find((skipUrlRegex)=>!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(path) ? skipUrlRegex.test(path) : false);
                // @ts-expect-error - TS2345 - Argument of type '{ shouldRemoveSessionBeIgnored: boolean; sessionId: string | string[]; objectId: string | string[] | undefined; objectType: string | string[] | undefined; containerId: string | string[] | undefined; previousSessionId: string | null; }' is not assignable to parameter of type 'State | ((prevState: Readonly<State>, props: Readonly<Props>) => State | Pick<State, "containerId" | "objectType" | "objectId" | "sessionId" | "previousSessionId" | "shouldRemoveSessionBeIgnored"> | null) | Pick<...> | null'.
                this.setState({
                    ...newState,
                    shouldRemoveSessionBeIgnored: shouldRemoveSession
                });
            }
        };
        this.props.history.listen(this.onHistoryChange);
        this.state = {
            shouldRemoveSessionBeIgnored: false,
            sessionId: ''
        };
    }
    componentDidMount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener((0, $5Jsi2.CLEAR_SEARCH_SESSION), this.onClearSessionEvent);
    }
    componentWillUnmount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener((0, $5Jsi2.CLEAR_SEARCH_SESSION), this.onClearSessionEvent);
    }
    render() {
        if (this.state && this.state.sessionId) {
            const { objectId: objectId, containerId: containerId, objectType: objectType, sessionId: sessionId, previousSessionId: previousSessionId } = this.state;
            const data = {
                objectId: objectId,
                containerId: containerId,
                objectType: objectType,
                source: objectType,
                actionSubject: objectType,
                attributes: {
                    previousSessionId: previousSessionId
                }
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $TtQEC.default), {
                sessionId: sessionId,
                data: data
            });
        }
        return null;
    }
}
var $fffa056866f763fb$export$2e2bcd8739ae039 = (0, $1bQGJ.withRouter)($fffa056866f763fb$export$f1e582dddb502dd6);

});
parcelRegister("6YRTH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3bd6eeaf3add142$export$2e2bcd8739ae039);

var $6vAaw = parcelRequire("6vAaw");

var $fr1K2 = parcelRequire("fr1K2");
var /**
 * Use to remove query params from url without reload or change history
 * One use case is to remove any tracking id from the url to avoid problems in copy & paste urls or sharing links between users
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$e3bd6eeaf3add142$export$2e2bcd8739ae039 = (paramsToStrip)=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($6vAaw))).parse(window.location.href, true);
        const strippedQuery = (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(parsedUrl.query || {}, paramsToStrip);
        let strippedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($6vAaw))).format({
            ...parsedUrl,
            search: undefined,
            query: strippedQuery
        });
        // we don't want to encode : to %3A in connect project pages
        const isConnect = /\?|&selectedItem=com.atlassian.plugins.atlassian-connect-plugin:/.test(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.search);
        if (isConnect) strippedUrl = strippedUrl.replace(/selectedItem=com.atlassian.plugins.atlassian-connect-plugin%3A/g, (match)=>match.replace(/%3A/i, ':'));
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.history.replaceState({}, '', strippedUrl);
    } catch (e) {
    /* uri might be malformed */ }
};

});

parcelRegister("TtQEC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8ee37fd26b4ccf1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $jzjy1 = parcelRequire("jzjy1");

var $jD5no = parcelRequire("jD5no");


var $l7nSX = parcelRequire("l7nSX");
const $c8ee37fd26b4ccf1$var$defaultSource = 'dwellComponent';
const $c8ee37fd26b4ccf1$var$defaultActionSubject = 'dwellComponent';
const $c8ee37fd26b4ccf1$var$getDwellComponent = (source, actionSubject)=>(0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $jzjy1.AnalyticsSubject)(actionSubject || $c8ee37fd26b4ccf1$var$defaultActionSubject), (0, $jzjy1.AnalyticsSource)(source || $c8ee37fd26b4ccf1$var$defaultSource, (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)))((0, $l7nSX.default));
class $c8ee37fd26b4ccf1$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static getDerivedStateFromProps(props) {
        const { data: data } = props;
        return {
            DwellTimeComponent: $c8ee37fd26b4ccf1$var$getDwellComponent(data.source, data.actionSubject)
        };
    }
    constructor(props){
        super(props);
        this.state = {
            DwellTimeComponent: null
        };
    }
    render() {
        const { sessionId: sessionId, data: data } = this.props;
        const { DwellTimeComponent: DwellTimeComponent } = this.state;
        const enrichedData = {
            ...data,
            source: data && data.source || $c8ee37fd26b4ccf1$var$defaultSource,
            actionSubject: data && data.actionSubject || $c8ee37fd26b4ccf1$var$defaultActionSubject
        };
        if (sessionId && DwellTimeComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DwellTimeComponent, {
            sessionId: sessionId,
            data: enrichedData
        }));
        return null;
    }
}

});
parcelRegister("l7nSX", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c5cee06f4a100e3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9E7Uh = parcelRequire("9E7Uh");

var $8oe80 = parcelRequire("8oe80");

var $hhweD = parcelRequire("hhweD");
class $8c5cee06f4a100e3$export$1c7ccff61c195c75 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { data: data, sessionId: sessionId } = this.props;
        // @ts-expect-error - TS2741 - Property 'prototype' is missing in type 'DwellTimeHelper' but required in type 'typeof DwellTimeHelper'.
        this.dwellHelper = new (0, $9E7Uh.default)(this.sendDwellEvent, data, sessionId);
        // @ts-expect-error - TS2339 - Property 'start' does not exist on type 'typeof DwellTimeHelper'.
        this.dwellHelper.start();
    }
    componentDidUpdate(oldProps) {
        if (oldProps.sessionId !== this.props.sessionId && this.dwellHelper !== null) // @ts-expect-error - TS2339 - Property 'newPage' does not exist on type 'typeof DwellTimeHelper'.
        this.dwellHelper.newPage(this.props.data, this.props.sessionId);
    }
    componentWillUnmount() {
        if (this.dwellHelper) {
            // @ts-expect-error - TS2339 - Property 'stop' does not exist on type 'typeof DwellTimeHelper'.
            this.dwellHelper.stop();
            // @ts-expect-error - TS2339 - Property 'destroy' does not exist on type 'typeof DwellTimeHelper'.
            this.dwellHelper.destroy();
        }
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, this.props.children);
    }
    constructor(...args){
        super(...args), this.sendDwellEvent = (payload)=>(0, $hhweD.fireTrackAnalytics)(this.props.createAnalyticsEvent(), payload);
    }
}
var $8c5cee06f4a100e3$export$2e2bcd8739ae039 = (0, $8oe80.default)('dwellTime', {
    onDwell: 'dwelled'
})($8c5cee06f4a100e3$export$1c7ccff61c195c75);

});
parcelRegister("hhweD", function(module, exports) {

$parcel$export(module.exports, "fireTrackAnalytics", () => $a4297ed46523d116$export$13990ad4625571ed);

var $4f8Oj = parcelRequire("4f8Oj");

var $gvRPW = parcelRequire("gvRPW");

var $i4iBk = parcelRequire("i4iBk");
const $a4297ed46523d116$var$isNotUndefined = (a)=>a !== undefined;
const $a4297ed46523d116$var$mapPayload = (payload)=>{
    const context = (0, $i4iBk.default)(payload);
    const { action: action, actionSubjectId: actionSubjectId } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($4f8Oj)))({
        ...context,
        ...context.attributes,
        attributes: undefined,
        action: action,
        actionSubjectId: actionSubjectId
    }, $a4297ed46523d116$var$isNotUndefined);
};
const $a4297ed46523d116$export$13990ad4625571ed = (event, payload)=>{
    event.update({
        ...$a4297ed46523d116$var$mapPayload(payload),
        analyticsType: (0, $gvRPW.TRACK_EVENT_TYPE)
    }).fire();
};

});



parcelRegister("7IBED", function(module, exports) {

$parcel$export(module.exports, "addMetaTag", () => $751334a79f9a31ee$export$c79fd820617d7f);
$parcel$export(module.exports, "removeMetaTag", () => $751334a79f9a31ee$export$4267657a25105d9d);
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/jira-ssr/no-unchecked-globals-usage
const $751334a79f9a31ee$export$c9d44c736471c518 = (name)=>document.querySelector(`meta[name="${name}"]`);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $751334a79f9a31ee$var$getHead = ()=>document.head || document.querySelector('head');
const $751334a79f9a31ee$export$c79fd820617d7f = (name, content)=>{
    if (!name || !content) return;
    const existingMeta = $751334a79f9a31ee$export$c9d44c736471c518(name);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const meta = document.createElement('meta');
    meta.name = name;
    meta.content = content;
    if (existingMeta) existingMeta.parentNode?.replaceChild(meta, existingMeta);
    else {
        const head = $751334a79f9a31ee$var$getHead();
        if (head) head.appendChild(meta);
    }
};
const $751334a79f9a31ee$export$4267657a25105d9d = (name)=>{
    const meta = $751334a79f9a31ee$export$c9d44c736471c518(name);
    if (meta) meta.parentNode?.removeChild(meta);
};

});

parcelRegister("5Jsi2", function(module, exports) {

$parcel$export(module.exports, "CLEAR_SEARCH_SESSION", () => $65e6525a854bf206$export$b669eaa3e4786d5c);
$parcel$export(module.exports, "skipClearSessionURLs", () => $65e6525a854bf206$export$c092460ed33e0e35);
const $65e6525a854bf206$export$b669eaa3e4786d5c = 'CLEAR_SEARCH_SESSION';
const $65e6525a854bf206$export$c092460ed33e0e35 = [
    /.*RapidBoard.jspa.*/,
    /\/jira\/software\/c\/projects\/[^/]*\/boards\/.*/,
    /\/jira\/people\/.*\/boards\/.*/
];

});


parcelRegister("fGcGc", function(module, exports) {

$parcel$export(module.exports, "addInitialPageLoadTimings", () => $e9a0ff6532e2be2e$export$ce440b3d0fa0d5ed);

var $4R6GH = parcelRequire("4R6GH");

var $2SVPM = parcelRequire("2SVPM");

var $6oVP0 = parcelRequire("6oVP0");
const $e9a0ff6532e2be2e$export$ce440b3d0fa0d5ed = ()=>{
    if (false) return;
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('early-flush', 'ssr.spa.early-common-flush:start', 'ssr.spa.early-route-flush:end');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/metatags', 'ssr.spa.metatags:start', 'ssr.spa.metatags:end');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/statsig', 'ssr.spa.statsig:start', 'ssr.spa.statsig:end');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/statsig', 'ssr.spa.statsig-gate-values:start', 'ssr.spa.statsig-gate-values:end');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/statsig-parse', 'statsig-parse:start', 'statsig-parse:end');
    // In legacy SSR, parsing happens inline with processing the flush. In modern SSR or static fallback scenarios for legacy SSR, the parse will be timed seperately.
    // What we want to avoid is confusing people with a "parse timer" in legacy SSR breakdown charts that doesn't overlap with the "statsig" timer (without this timer entry that would happen and it would have a very low volume, but it would distract people during perf-investigations)
    // This will make the statsig-parse timer fully overlap with "statsig" when the parsing happens inline, and will start at a different time otherwise
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/statsig-parse', 'ssr.spa.statsig:start', 'ssr.spa.statsig:start');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/inline-scripts-common', 'ssr.spa.inline-assets:start', 'ssr.spa.inline-assets:end');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/inline-scripts-route', 'ssr.spa.async-inline-assets:start', 'ssr.spa.async-inline-assets:end');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/css-assets', 'ssr.spa.css-assets:start', 'ssr.spa.css-assets:end');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/feature-flags', 'ssr.spa.feature-flags:start', 'ssr.spa.feature-flags:end');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/route-preload', 'ssr.spa.early-route-flush:start', 'ssr.spa.early-route-flush:end');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output', 'ssr.spa.start', 'ssr.spa.state');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/styles', 'ssr.spa.start', 'ssr.spa.styles');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/html', 'ssr.spa.styles', 'ssr.spa.html');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/state', 'ssr.spa.html', 'ssr.spa.state');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa/language-pack', 'jira-spa/language-pack.start', 'jira-spa/language-pack.end', true, true);
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    (0, $4R6GH.fg)('add-loading-bundles-span-initial-load') && (0, $6oVP0.observePreloadedBundlesProgress)();
};

});
parcelRegister("6oVP0", function(module, exports) {

$parcel$export(module.exports, "observePreloadedBundlesProgress", () => $953aaa0a85a87020$export$2169bfe6cd4f4439);

var $jI6pi = parcelRequire("jI6pi");
let $953aaa0a85a87020$var$po = null;
let $953aaa0a85a87020$var$timeout = null;
let $953aaa0a85a87020$var$started = false;
const $953aaa0a85a87020$export$2169bfe6cd4f4439 = ()=>{
    if (false || $953aaa0a85a87020$var$started || !globalThis.PerformanceObserver) return;
    $953aaa0a85a87020$var$started = true;
    const expectedEntries = new Set(Array.from(globalThis.document?.querySelectorAll?.('link[rel=modulepreload]') || []).map((el)=>el.getAttribute('href')).filter((url)=>url?.includes('jira-frontend-bifrost')));
    /* eslint-disable @typescript-eslint/consistent-type-assertions */ const loadedResources = Array.from(globalThis.performance?.getEntriesByType('resource')).filter(({ name: name })=>{
        if (expectedEntries.has(name)) {
            expectedEntries.delete(name);
            return true;
        }
        return false;
    });
    if (expectedEntries.size > 0) {
        $953aaa0a85a87020$var$timeout = setTimeout(()=>{
            $953aaa0a85a87020$var$po?.disconnect();
        }, 30000);
        $953aaa0a85a87020$var$po = new PerformanceObserver((entry)=>{
            entry.getEntries().forEach((e)=>{
                if (expectedEntries.has(e.name)) {
                    expectedEntries.delete(e.name);
                    loadedResources.push(e);
                }
                if (expectedEntries.size === 0) {
                    $953aaa0a85a87020$var$timeout !== null && clearTimeout($953aaa0a85a87020$var$timeout);
                    $953aaa0a85a87020$var$po?.disconnect();
                    $953aaa0a85a87020$var$processCapturedData(loadedResources);
                }
            });
        });
    } else $953aaa0a85a87020$var$processCapturedData(loadedResources);
/* eslint-enable @typescript-eslint/consistent-type-assertions */ };
const $953aaa0a85a87020$var$determineMinAndMax = (agg, entry)=>{
    if (agg.min === null || entry.startTime < agg.min) // eslint-disable-next-line no-param-reassign
    agg.min = entry.startTime;
    if (agg.max === null || entry.responseEnd > agg.max) // eslint-disable-next-line no-param-reassign
    agg.max = entry.responseEnd;
};
const $953aaa0a85a87020$var$processCapturedData = (loadedResources)=>{
    const { all: all, common: common, route: route } = loadedResources.reduce((agg, entry)=>{
        $953aaa0a85a87020$var$determineMinAndMax(agg.all, entry);
        if ($953aaa0a85a87020$var$isCommon(entry)) $953aaa0a85a87020$var$determineMinAndMax(agg.common, entry);
        else $953aaa0a85a87020$var$determineMinAndMax(agg.route, entry);
        return agg;
    }, {
        all: {
            max: null,
            min: null
        },
        common: {
            max: null,
            min: null
        },
        route: {
            max: null,
            min: null
        }
    });
    if (all.max === null || all.min === null) return;
    $953aaa0a85a87020$var$setTimings('preloading-bundles', all);
    $953aaa0a85a87020$var$setTimings('preloading-bundles/common', common);
    $953aaa0a85a87020$var$setTimings('preloading-bundles/route', route);
};
const $953aaa0a85a87020$var$isCommon = (entry)=>{
    const url = entry.name;
    const hasJiraSpa = url.includes('jira-spa');
    const isSharedWithoutNav = url.includes('/shared') && !url.includes('atlassian-navigation');
    const isNavWithVendor = url.includes('atlassian-navigation') && url.includes('vendor');
    return (hasJiraSpa || isSharedWithoutNav || isNavWithVendor) && url.endsWith('.js');
};
const $953aaa0a85a87020$var$setTimings = (label, { min: min, max: max })=>{
    if (max === null || min === null) return;
    const startMark = `${label}-start`;
    const stopMark = `${label}-end`;
    performance.mark(startMark, {
        startTime: min
    });
    performance.mark(stopMark, {
        startTime: max
    });
    (0, $jI6pi.addTimingFromPerformanceMark)(label, startMark, stopMark, true, true);
};

});


parcelRegister("bShz7", function(module, exports) {

$parcel$export(module.exports, "setPrefetchStartMark", () => $fd73e472799b8227$export$405fde3eab8e39f6);
$parcel$export(module.exports, "getPrefetchStartMark", () => $fd73e472799b8227$export$cbaceb7ffa84279);
$parcel$export(module.exports, "clearPrefetchStartMarks", () => $fd73e472799b8227$export$d6b0928f07bafe57);
const $fd73e472799b8227$var$prefetchTiming = new Map();
const $fd73e472799b8227$export$405fde3eab8e39f6 = (match)=>{
    const currentMatch = JSON.stringify(match);
    if (!$fd73e472799b8227$var$prefetchTiming.has(currentMatch)) $fd73e472799b8227$var$prefetchTiming.set(currentMatch, {
        startPrefetchTime: Date.now()
    });
};
const $fd73e472799b8227$export$cbaceb7ffa84279 = (match)=>{
    const currentMatch = JSON.stringify(match);
    const { startPrefetchTime: startPrefetchTime } = $fd73e472799b8227$var$prefetchTiming.get(currentMatch) || {
        startPrefetchTime: null
    };
    return startPrefetchTime;
};
const $fd73e472799b8227$export$d6b0928f07bafe57 = (match)=>{
    if (!$fd73e472799b8227$var$prefetchTiming || !$fd73e472799b8227$var$prefetchTiming.keys) return;
    const currentMatch = JSON.stringify(match);
    const keys = Array.from($fd73e472799b8227$var$prefetchTiming.keys());
    keys.forEach((mark)=>{
        if (mark !== currentMatch && $fd73e472799b8227$var$prefetchTiming.has(mark)) $fd73e472799b8227$var$prefetchTiming.delete(mark);
    });
};

});

parcelRegister("lbyb6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab2f047cd976509c$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");

var $7bpAK = parcelRequire("7bpAK");
var $2Gs5h = parcelRequire("2Gs5h");
const $ab2f047cd976509c$var$LOCATION = 'spa.create-spa-history';
const $ab2f047cd976509c$var$createCustomHistoryBlock = (routeBlockFns, currentRoutes, history)=>(blockFn)=>{
        const matchedRoute = (0, $2Gs5h.default)(currentRoutes, history.location.pathname, history.location.search);
        // This should never be the case as in SPA we have a default route
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        if (!matchedRoute) return ()=>{};
        if (!routeBlockFns.includes(blockFn)) routeBlockFns.push(blockFn);
        // returns an "unregister" block
        return ()=>{
            const idx = routeBlockFns.indexOf(blockFn);
            if (idx !== -1) routeBlockFns.splice(idx, 1);
        };
    };
const $ab2f047cd976509c$var$createSpaHistory = (initialRoutes)=>{
    const routeBlockFns = [];
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    let blockArgs = [];
    let nextMatchedRoute;
    const currentRoutes = initialRoutes;
    const history = (0, $7bpAK.createBrowserHistory)({
        /* We abuse this api to allow us to run as many blockers as we want, allowing the transition
		 * to resume only when all return true or bail out as soon as the first one returns false */ getUserConfirmation: (__, done)=>{
            const matchedRoute = (0, $2Gs5h.default)(currentRoutes, history.location.pathname, history.location.search);
            // This should never be the case as in SPA we have a default route
            if (!matchedRoute || !nextMatchedRoute) return done(true);
            // we execute the blockers in reverse order, so the last registered is the first to run
            // They are executed synchronously until one returns false or a promise
            // If a promise is returned we execute all remaining blockers as chained promises
            let sync = true;
            for(let i = routeBlockFns.length - 1; i >= 0; i -= 1){
                const result = routeBlockFns[i](...blockArgs);
                if (result instanceof Promise) {
                    sync = false;
                    routeBlockFns.slice(0, i + 1).reverse().reduce(// eslint-disable-next-line @typescript-eslint/no-loop-func
                    (promise, blocker)=>promise.then((res)=>res === false ? Promise.resolve(false) : blocker(...blockArgs)), Promise.resolve(result)).then((res)=>{
                        routeBlockFns.length = 0;
                        done(res);
                    }).catch((err)=>{
                        (0, $2YZCu.default).safeErrorWithoutCustomerData($ab2f047cd976509c$var$LOCATION, 'Error with getUserConfirmation', err);
                        done(true);
                    });
                    break;
                }
                if (result === false) {
                    done(false);
                    return;
                }
            }
            if (sync) {
                routeBlockFns.length = 0;
                done(true);
            }
        }
    });
    // For lazy loaded route maps we need to keep track of the current routes here
    // as they will be changing. When we "match" for the route blocking code we need
    // to ensure we match against the current routes, not the routes at the time the function
    // was created.
    history.refreshRoutes = (newRoutes)=>{
        // Replace currentRoutes in place as it's captured in a closure above..
        currentRoutes.length = 0;
        currentRoutes.push(...newRoutes);
    };
    /* We set the main "blocker", that is also used enable next location access in getUserConfirmation
	 * (going around getUserConfirmation API limitations) */ history.block((location, action)=>{
        blockArgs = [
            location,
            action
        ];
        nextMatchedRoute = (0, $2Gs5h.default)(currentRoutes, location.pathname, location.search);
        // Must return a string or getUserConfirmation is not called
        return '';
    });
    // @ts-expect-error - we're using a custom blocker
    history.block = $ab2f047cd976509c$var$createCustomHistoryBlock(routeBlockFns, currentRoutes, history);
    return history;
};
var /**
 * Monkey patches the push/replace methods of the react router history object to
 * perform a full page refresh instead of history push/replace when a route is not valid
 * (i.e. legacy pages). This is required to fix the browser back button not working correctly
 * after redirecting to a legacy page.
 * JSPA-900
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$ab2f047cd976509c$export$2e2bcd8739ae039 = (routes)=>$ab2f047cd976509c$var$createSpaHistory(routes);

});

parcelRegister("5HG6S", function(module, exports) {

$parcel$export(module.exports, "getSpaRouterContext", () => $804f5602998bd8a4$export$1f61c5e3f6410afa);
const $804f5602998bd8a4$export$1f61c5e3f6410afa = ({ tenantContext: tenantContext })=>({
        tenantContext: tenantContext
    });

});

parcelRegister("kKlrY", function(module, exports) {

$parcel$export(module.exports, "default", () => $71f44f620ca2fe28$export$2e2bcd8739ae039);

var $lANdF = parcelRequire("lANdF");

var $bFU4G = parcelRequire("bFU4G");

var $auAY8 = parcelRequire("auAY8");

var $3vLAR = parcelRequire("3vLAR");
var $ievYU = parcelRequire("ievYU");

var $cPbc1 = parcelRequire("cPbc1");

var $4R6GH = parcelRequire("4R6GH");

var $j8DrX = parcelRequire("j8DrX");

var $aZWa4 = parcelRequire("aZWa4");

var $3dQJA = parcelRequire("3dQJA");

var $cEm1b = parcelRequire("cEm1b");

var $6s1PB = parcelRequire("6s1PB");

var $fJbQ9 = parcelRequire("fJbQ9");

var $itoGf = parcelRequire("itoGf");

var $dQKfU = parcelRequire("dQKfU");
// TODO: AFO-2949: Remove fallback once we have a stable config in Statsig when deprecating the FF 'ufo-use-statsig-config-jira'
const $71f44f620ca2fe28$var$FALLBACK_UFO_CONFIG = {
    autoGeneratedRate: 1000,
    enabled: true,
    removeUFOPrefixList: [
        'project-versions',
        'filters-directory'
    ],
    removePageSegmentsUFOPrefixes: true,
    doNotAbortActivePressInteractionOnTransition: [
        'jsm-create-cmp-request-type-from-template',
        'jsm-create-tmp-request-type-from-template'
    ],
    killswitch: [
        'jira.fe.load.UNKNOWN'
    ],
    awaitForSegments: {
        'global-issue.create-modal': [
            'issue-view-details'
        ],
        'global-issue.create-modal-subsequent': [
            'issue-view-details'
        ]
    },
    removeAllUFOPrefix: true,
    rates: {
        'issue-view-activity-button-worklog': 1,
        'issue-view-activity-button-history': 1,
        'issue-view-activity-button-comments': 1,
        'arj-toggle-view-mode': 1,
        'global-issue.create-modal-subsequent': 5,
        unknown: 1000,
        'issue-view-activity-button-forge-app': 1,
        'view-mode': 1,
        'backlog.issue-view-opened': 5,
        'create-web-link-inline-field-type-tracing': 1000,
        'issue-view-activity-button-connect-app': 1,
        'single-line-text-field-type-tracing': 100,
        'issue-view-activity-button-all': 1,
        'backlog.card-hover': 1,
        'child-issue-inline-create-type-tracing': 100,
        'show-insights-button': 100,
        'board.issue-view-opened': 5,
        'issue-view-activity-button-jsd-comments': 1,
        'backlog.card-list-toggle': 5,
        'global-issue.create-modal': 5,
        'issue-view-activity-button-approvals': 1
    },
    kind: {
        generic: 0,
        hover: 0,
        legacy: 1,
        page_load: 1,
        press: 1,
        transition: 1,
        typing: 0
    },
    awaitBM3TTI: [
        'jwm_project_pages',
        'software-plan-dependencies',
        'advanced-roadmaps.page-plan.dependencies-tab.load-time',
        'servicedesk-cmdb-object-type-configuration',
        'service-management.insight-cmdb-object-type-configuration',
        'project-components-view',
        'project-components',
        'project-settings-components',
        'people-index',
        'people-profiles',
        'rapidboard-report',
        'classic-report',
        'project-settings-servicedesk-ticket-type-fields',
        'project-settings.issue-type.jsm-cmp-customer-view',
        'project-settings.issue-type.jsm-cmp-agent-view',
        'archived-project-direct-link',
        'project-archived',
        'servicedesk-queues-new',
        'service-management.queues.new',
        'project-settings-software-boards-insights',
        'board-settings-apps.insights-settings-page.page.load',
        'admin-oauth-credentials',
        'admin.oauth-credentials',
        'polaris-ideas',
        'project-settings-software-boards-csm',
        'jira.fe.page-load.software.next-gen.boards.column-status-mapping.page.load',
        'project-settings-servicedesk-language',
        'service-management.languages',
        'project-settings-servicedesk-language-key',
        'service-management.translations',
        'project-settings-servicedesk-classic-apps',
        'service-management.app-discovery',
        'marketplace-index',
        'embedded-marketplace',
        'project-settings-servicedesk-portal-settings',
        'service-management.portal-settings',
        'service-management.portal-settings.portal-groups',
        'project-settings-servicedesk-automation-create',
        'service-management.automation.create-rule',
        'servicedesk-customers-v2',
        'jsm-customers-component-load',
        'archived-project-direct-link',
        'project-archived',
        'project-settings-software-boards-csm',
        'software.next-gen.boards.column-status-mapping.page.load',
        'jira-connect',
        'knowledge-hub-category',
        'service-management.knowledge.category',
        'servicedesk-queues-landing',
        'servicedesk-practice-landing',
        'servicedesk-practice-custom-and-issue',
        'servicedesk-practice-custom-issue',
        'servicedesk-practice-custom-view',
        'servicedesk-queues-custom-and-issue',
        'servicedesk-queues-custom-issue',
        'servicedesk-queues-custom-view'
    ],
    rules: [],
    capability: {
        feature_flag_access: 1,
        react_profiler: 1
    },
    typingMethod: 'timeout',
    removeInteractionsUFOPrefixes: true,
    doNotAbortActivePressInteraction: [
        'global-issue.create-modal',
        'global-issue.create-modal-subsequent'
    ],
    ufoNameOverrides: {
        'global-issue-navigator': {
            'global-issue-navigator': 'global-issue-navigator-jfe',
            'new-issue-navigator': 'global-new-issue-navigator'
        },
        'global-issue-navigator-jfe': {
            'global-issue-navigator-jfe': 'global-issue-navigator-jfe',
            'new-issue-navigator': 'global-new-issue-navigator'
        },
        'global-settings-migrations-focus-page': {
            'admin.c2c-migrations.choose-destination': 'admin.c2c-migrations.choose-destination',
            'admin.c2c-migrations.choose-projects': 'admin.c2c-migrations.choose-projects',
            'admin.c2c-migrations.preflight-checks': 'admin.c2c-migrations.preflight-checks',
            'admin.c2c-migrations.review': 'admin.c2c-migrations.review'
        },
        'polaris-ideas': {
            'project-settings.details': 'project-settings-details-polaris-ideas'
        },
        'project-settings-servicedesk-portal-settings': {
            'service-management.portal-settings': 'service-management.portal-settings',
            'service-management.portal-settings.portal-groups': 'service-management.portal-settings.portal-groups'
        },
        'project-settings-servicedesk-ticket-type-fields': {
            'project-settings.issue-type.jsm-cmp-agent-view': 'project-settings.issue-type.jsm-cmp-agent-view',
            'project-settings.issue-type.jsm-cmp-customer-view': 'project-settings.issue-type.jsm-cmp-customer-view'
        },
        'servicedesk-practice-custom-and-issue': {
            'service-management.queues.issue': 'servicedesk-practice-custom-issue',
            'service-management.queues.view': 'servicedesk-practice-custom-view'
        },
        'servicedesk-queues-custom-and-issue': {
            'service-management.queues.issue': 'servicedesk-queues-custom-issue',
            'service-management.queues.view': 'servicedesk-queues-custom-view'
        }
    },
    enableCompleteUsingDoubleRAF: true
};
const $71f44f620ca2fe28$var$STRINGIFIED_FALLBACK_UFO_CONFIG = JSON.stringify($71f44f620ca2fe28$var$FALLBACK_UFO_CONFIG);
const $71f44f620ca2fe28$var$getUFOConfigFromStatsig = ()=>{
    try {
        // eslint-disable-next-line jira/ff/inline-expVal-params
        return JSON.parse((0, $6s1PB.expVal)('ufo_config', 'value', $71f44f620ca2fe28$var$STRINGIFIED_FALLBACK_UFO_CONFIG));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to get UFO config from Statsig dynamic config:', error);
        // TODO: AFO-2949: Change the fallback to be `{}` once we have a stable config in Statsig when deprecating the FF 'ufo-use-statsig-config-jira'
        return $71f44f620ca2fe28$var$FALLBACK_UFO_CONFIG;
    }
};
function $71f44f620ca2fe28$var$getAdditionalJiraFields(interaction) {
    try {
        return {
            jira: (0, $3dQJA.getJiraCustomData)(interaction)
        };
    } catch (error) {
        return {};
    }
}

function $71f44f620ca2fe28$var$loadJiraAnalyticsWebClient() {
    return Promise.resolve((parcelRequire("fjcgS")));
}
function $71f44f620ca2fe28$export$2e2bcd8739ae039() {
    const ufoConfigFromFF = (0, $4R6GH.fg)('ufo-use-statsig-config-jira') ? $71f44f620ca2fe28$var$getUFOConfigFromStatsig() : $71f44f620ca2fe28$var$FALLBACK_UFO_CONFIG;
    (0, $aZWa4.retrieveAndSetPageLoadTrace)((0, $j8DrX.default));
    (0, $3vLAR.configure)((0, $itoGf.jiraResourceTimingsConfig));
    (0, $ievYU.startResourceTimingBuffer)();
    if (!(0, $4R6GH.fg)('jira-disable-ufo-bundle-eval-timings')) (0, $lANdF.configure)((0, $fJbQ9.jiraBundleEvalTimingsConfig));
    (0, $cPbc1.configure)((0, $dQKfU.jiraSsrConfig));
    (0, $cEm1b.GlobalReactLooselyLazyProfiler).current = (0, $bFU4G.ModuleLoadingProfiler);
    const perfPushFY25ExperienceRates = {
        'issue-view': 1,
        'issue-view-embed': 1,
        'new-issue-navigator': 1,
        'classic-board': 1,
        'classic-backlog': 1,
        'next-gen-board': 1,
        'next-gen-backlog': 1,
        'jwm.list-view': 1,
        'jwm.summary-view': 1,
        dashboard: 1,
        'software-issue-navigator': 1,
        'global-new-issue-navigator': 1,
        'global-issue-navigator-jfe': 1,
        'issue-navigator': 1,
        'issue-navigator-classic': 1,
        'issue-navigator-core': 1,
        'servicedesk-issues': 1,
        'jwm.jwm-board-base': 1,
        'jwm.jwm-board-with-filters': 1,
        'jwm.jwm-board-with-issue-view': 1,
        'servicedesk-queues-landing': 1,
        'servicedesk-practice-landing': 1,
        'servicedesk-practice-custom-issue': 1,
        'servicedesk-practice-custom-view': 1,
        'servicedesk-queues-custom-issue': 1,
        'servicedesk-queues-custom-view': 1
    };
    const ssrWhitelist = [
        'software-issue-navigator',
        'global-new-issue-navigator',
        'issue-navigator-classic',
        'issue-navigator-core',
        'servicedesk-issues',
        'issue-view',
        'issue-view-embed',
        'classic-board',
        'classic-backlog',
        'next-gen-backlog'
    ];
    let assetsConfig = {};
    if ((0, $4R6GH.fg)('new_chr_classification')) assetsConfig = {
        classification: {
            all: true,
            allAtlassian: ({ entry: entry })=>{
                const isAtlassian = entry.name.includes('atl-paas.net/') || entry.name.includes('cloudfront') && entry.name.includes('batch.js');
                return isAtlassian;
            },
            preloaded: ({ entry: entry, SSRDoneTime: SSRDoneTime })=>{
                return SSRDoneTime && entry.startTime <= SSRDoneTime;
            }
        }
    };
    (0, $auAY8.init)($71f44f620ca2fe28$var$loadJiraAnalyticsWebClient(), {
        ...ufoConfigFromFF,
        enableSegmentHighlighting: (0, $4R6GH.fg)('ufo_enable_segment_highlighting_jira'),
        enableAdditionalPerformanceMarks: (0, $4R6GH.fg)('ufo_enable_segment_highlighting_jira'),
        product: 'jira',
        region: (0, $j8DrX.default)('ajs-region') || 'unknown',
        additionalPayloadData: $71f44f620ca2fe28$var$getAdditionalJiraFields,
        postInteractionLog: {
            enabled: (0, $4R6GH.fg)('ufo_capture_late_rerenders_jira'),
            rates: perfPushFY25ExperienceRates
        },
        experimentalInteractionMetrics: {
            enabled: (0, $4R6GH.fg)('ufo-enable-experimental-holds-jira'),
            rates: perfPushFY25ExperienceRates
        },
        manuallyTrackReactProfilerMounts: (0, $4R6GH.fg)('ufo-manually-track-segment-mount-phase-jira'),
        vc: {
            enabled: true,
            heatmapSize: 200,
            oldDomUpdates: false,
            devToolsEnabled: (0, $4R6GH.fg)('uip_vc_devtools'),
            selectorConfig: {
                id: true,
                role: !(0, $4R6GH.fg)('uip_disable_vc_role_selector'),
                className: true,
                testId: false // Cannot be enabled due to some testid attributes containing UGC. Use data-vc instead.
            },
            ssr: (0, $4R6GH.fg)('uip_vc_ssr'),
            ssrWhitelist: ssrWhitelist,
            ssrEnablePageLayoutPlaceholder: (0, $4R6GH.fg)('enable_page_layout_placeholder'),
            disableSizeAndPositionCheck: {
                v: (0, $4R6GH.fg)('ssr_placeholders_disable_size_and_position_check_v'),
                h: (0, $4R6GH.fg)('ssr_placeholders_disable_size_and_position_check_h')
            },
            stopVCAtInteractionFinish: (0, $4R6GH.fg)('stop_vc_at_interaction_finish'),
            includeSSRInV3: (0, $4R6GH.fg)('jira_include_ssr_in_vc_v3'),
            includeSSRRatio: (0, $4R6GH.fg)('enable_ssr_ratio'),
            enabledVCRevisions: {
                all: [
                    'fy25.02',
                    'fy25.03'
                ]
            }
        },
        enableBetterPageVisibilityApi: true,
        assetsConfig: assetsConfig
    });
}

});
parcelRegister("lANdF", function(module, exports) {

$parcel$export(module.exports, "configure", () => $62d1dc5c906adae4$export$8d21e34596265fa2);
$parcel$export(module.exports, "getBundleEvalTimings", () => $62d1dc5c906adae4$export$2eda1519e91a4386);

var $bdDDw = parcelRequire("bdDDw");
let $62d1dc5c906adae4$var$config = null;
function $62d1dc5c906adae4$export$8d21e34596265fa2(bundleEvalTimingConfiguration) {
    $62d1dc5c906adae4$var$config = bundleEvalTimingConfiguration;
}
function $62d1dc5c906adae4$var$getPerformanceObject() {
    return (window ?? {}).performance;
}
function $62d1dc5c906adae4$export$2eda1519e91a4386(interactionStartTime) {
    if ($62d1dc5c906adae4$var$config == null) return {};
    const started = {};
    const timings = {};
    const cachedConfig = $62d1dc5c906adae4$var$config;
    const performance = $62d1dc5c906adae4$var$getPerformanceObject();
    performance?.getEntriesByType('mark').forEach((mark)=>{
        const result = cachedConfig.mapPerformanceMark(mark.name);
        if (!result) return;
        const { type: type, name: name } = result;
        if (type === 'start' && mark.startTime >= interactionStartTime) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: (0, $bdDDw.roundEpsilon)(started[name].startTime - interactionStartTime),
                duration: (0, $bdDDw.roundEpsilon)(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (Object.keys(timings).length === 0) return {};
    return timings;
}

});
parcelRegister("bdDDw", function(module, exports) {

$parcel$export(module.exports, "roundEpsilon", () => $f25e0154c492e45e$export$56014375de40214b);
function $f25e0154c492e45e$export$56014375de40214b(num, places = 3) {
    const factor = Math.pow(10, places);
    return Math.round((num + Number.EPSILON) * factor) / factor;
}

});


parcelRegister("auAY8", function(module, exports) {

$parcel$export(module.exports, "init", () => $78c94c158b70469a$export$2cd8252107eb640b);

var $VSDnB = parcelRequire("VSDnB");

var $5DPhz = parcelRequire("5DPhz");

var $fe1wc = parcelRequire("fe1wc");

var $f38ba = parcelRequire("f38ba");

var $37gc9 = parcelRequire("37gc9");

var $bFU4G = parcelRequire("bFU4G");

var $3GMbH = parcelRequire("3GMbH");

var $7p8yR = parcelRequire("7p8yR");

var $a0hd6 = parcelRequire("a0hd6");

var $kbK8z = parcelRequire("kbK8z");
let $78c94c158b70469a$var$initialized = false;
function $78c94c158b70469a$var$sinkInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createPayloads(interactionId, interaction).then((payloads)=>{
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads?.forEach((payload)=>{
                    if (typeof devToolObserver === 'function') devToolObserver?.(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch((error)=>{
                throw error;
            });
        }
        (0, $kbK8z.default)(onIdle);
    }
    (0, $bFU4G.sinkInteractionHandler)(sinkFn);
}
function $78c94c158b70469a$var$sinkExperimentalInteractionMetrics(instance, payloadPackage) {
    function experimentalMetricsSinkFn(interactionId, interaction) {
        function experimentalMetricsOnIdle() {
            const payloadPromise = payloadPackage.createExperimentalMetricsPayload(interactionId, interaction);
            payloadPromise.then((payload)=>{
                if (payload) {
                    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                    if ((0, $VSDnB.fg)('enable_ufo_devtools_api_for_extra_events')) {
                        // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                        const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                        if (typeof devToolObserver === 'function') devToolObserver?.(payload);
                    }
                    instance.sendOperationalEvent(payload);
                }
            });
        }
        (0, $kbK8z.default)(experimentalMetricsOnIdle);
    }
    (0, $f38ba.sinkExperimentalHandler)(experimentalMetricsSinkFn);
}
function $78c94c158b70469a$var$sinkPostInteractionLog(instance, createPostInteractionLogPayload) {
    (0, $bFU4G.sinkPostInteractionLogHandler)((logOutput)=>{
        (0, $kbK8z.default)(()=>{
            const payload = createPostInteractionLogPayload(logOutput);
            if (payload) {
                // NOTE: This API is used by the UFO DevTool Chrome Extension and also by Criterion
                // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                if ((0, $VSDnB.fg)('enable_ufo_devtools_api_for_extra_events')) {
                    const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                    if (typeof devToolObserver === 'function') devToolObserver?.(payload);
                }
                instance.sendOperationalEvent(payload);
            }
        });
    });
}


function $78c94c158b70469a$export$2cd8252107eb640b(analyticsWebClientAsync, config) {
    if ($78c94c158b70469a$var$initialized) return;
    if ((0, $VSDnB.fg)('platform_ufo_report_cpu_usage')) (0, $7p8yR.initialisePressureObserver)();
    if ((0, $VSDnB.fg)('platform_ufo_report_memory_usage')) (0, $7p8yR.initialiseMemoryObserver)();
    (0, $fe1wc.setUFOConfig)(config);
    if (config.vc?.enabled) {
        const vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            selectorConfig: config.vc.selectorConfig,
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder,
            disableSizeAndPositionCheck: config.vc.disableSizeAndPositionCheck
        };
        (0, $a0hd6.getVCObserver)(vcOptions).start({
            startTime: 0
        });
        (0, $bFU4G.postInteractionLog).initializeVCObserver(vcOptions);
        (0, $bFU4G.postInteractionLog).startVCObserver({
            startTime: 0
        });
        if (config?.experimentalInteractionMetrics?.enabled) (0, $f38ba.experimentalVC).initialize(vcOptions).start({
            startTime: 0
        });
    }
    (0, $37gc9.setupHiddenTimingCapture)();
    (0, $5DPhz.startLighthouseObserver)();
    $78c94c158b70469a$var$initialized = true;
    if ((0, $VSDnB.fg)('platform_ufo_enable_events_observer') || (0, $VSDnB.fg)('platform_ufo_enable_interactivity_jsm')) {
        if (typeof PerformanceObserver !== 'undefined') {
            const observer = (0, $3GMbH.getPerformanceObserver)();
            observer.observe({
                type: 'event',
                buffered: true,
                durationThreshold: 16
            });
        }
    }
    Promise.all([
        analyticsWebClientAsync,
        (parcelRequire("jBHcJ")),
        (parcelRequire("jVMkq"))
    ]).then(([awc, payloadPackage, createPostInteractionLogPayloadPackage])=>{
        if (awc.getAnalyticsWebClientPromise) awc.getAnalyticsWebClientPromise().then((client)=>{
            const instance = client.getInstance();
            $78c94c158b70469a$var$sinkInteraction(instance, payloadPackage);
            if (config?.experimentalInteractionMetrics?.enabled) $78c94c158b70469a$var$sinkExperimentalInteractionMetrics(instance, payloadPackage);
            if (config.postInteractionLog?.enabled) $78c94c158b70469a$var$sinkPostInteractionLog(instance, createPostInteractionLogPayloadPackage.default);
        });
        else if (awc.sendOperationalEvent) {
            $78c94c158b70469a$var$sinkInteraction(awc, payloadPackage);
            if (config?.experimentalInteractionMetrics?.enabled) $78c94c158b70469a$var$sinkExperimentalInteractionMetrics(awc, payloadPackage);
            if (config.postInteractionLog?.enabled) $78c94c158b70469a$var$sinkPostInteractionLog(awc, createPostInteractionLogPayloadPackage.default);
        }
    });
}

});
parcelRegister("5DPhz", function(module, exports) {

$parcel$export(module.exports, "startLighthouseObserver", () => $0fa54be9bd80e4ab$export$5ecf2aafafee3e0);
$parcel$export(module.exports, "getLighthouseMetrics", () => $0fa54be9bd80e4ab$export$b46cecdf698e4bb5);

var $92xAz = parcelRequire("92xAz");

var $jKaCJ = parcelRequire("jKaCJ");

var $l7wnP = parcelRequire("l7wnP");

var $k0uhA = parcelRequire("k0uhA");

var $7cMne = parcelRequire("7cMne");
function $0fa54be9bd80e4ab$export$5ecf2aafafee3e0() {
    (0, $7cMne.startLSObserver)();
    (0, $7cMne.startLTObserver)();
}
function $0fa54be9bd80e4ab$export$b46cecdf698e4bb5({ start: start, stop: stop }) {
    const tbt = (0, $l7wnP.getTBT)(start, stop, (0, $k0uhA.EntriesBuffer)[(0, $jKaCJ.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, $92xAz.getCLS)(start, stop, (0, $k0uhA.EntriesBuffer)[(0, $jKaCJ.PerformanceObserverEntryTypes).LayoutShift]);
    return {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls
    };
}

});
parcelRegister("92xAz", function(module, exports) {

$parcel$export(module.exports, "getCLS", () => $cb361e890ff4f9d8$export$fc6227831ee7c7);
function $cb361e890ff4f9d8$export$fc6227831ee7c7(start, stop, buffer) {
    const layoutShifts = buffer.getAll().filter((entry)=>entry.startTime >= start && entry.startTime <= stop);
    const sessionWindows = [];
    let currentWindow = null;
    // Group layout shifts into session windows
    for (const shift of layoutShifts){
        const { startTime: startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime: startTime,
                endTime: endTime,
                score: score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
}

});

parcelRegister("jKaCJ", function(module, exports) {

$parcel$export(module.exports, "PerformanceObserverEntryTypes", () => $c867e70954b5231d$export$a4def92db6fc8e17);
const $c867e70954b5231d$export$a4def92db6fc8e17 = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};

});

parcelRegister("l7wnP", function(module, exports) {

$parcel$export(module.exports, "getTBT", () => $db26c18e70d86e5d$export$2d6e933b35bd3407);
const $db26c18e70d86e5d$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
function $db26c18e70d86e5d$export$2d6e933b35bd3407(start, stop, buffer) {
    return buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $db26c18e70d86e5d$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + $db26c18e70d86e5d$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $db26c18e70d86e5d$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });
}

});

parcelRegister("k0uhA", function(module, exports) {

$parcel$export(module.exports, "EntriesBuffer", () => $74df48ec3def97f8$export$f7dc16cbd16f7bbe);

var $jKaCJ = parcelRequire("jKaCJ");
class $74df48ec3def97f8$export$2c6e86519c9e8188 {
    constructor(maxLength = 1000){
        this.buffer = [];
        this.full = false;
        this.maxLength = maxLength;
    }
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
}
const $74df48ec3def97f8$export$f7dc16cbd16f7bbe = {
    [(0, $jKaCJ.PerformanceObserverEntryTypes).LongTask]: new $74df48ec3def97f8$export$2c6e86519c9e8188(),
    [(0, $jKaCJ.PerformanceObserverEntryTypes).LayoutShift]: new $74df48ec3def97f8$export$2c6e86519c9e8188()
};

});

parcelRegister("7cMne", function(module, exports) {

$parcel$export(module.exports, "startLSObserver", () => $1e6ef4fbf892be45$export$768ccc3ab7bac3ea);
$parcel$export(module.exports, "startLTObserver", () => $1e6ef4fbf892be45$export$54fb8b6aaf70ec9c);

var $jKaCJ = parcelRequire("jKaCJ");

var $k0uhA = parcelRequire("k0uhA");
let $1e6ef4fbf892be45$var$pe = null;
function $1e6ef4fbf892be45$var$getObserver() {
    if (typeof PerformanceObserver !== 'function') // Only instantiate the IntersectionObserver if it's supported
    return null;
    if ($1e6ef4fbf892be45$var$pe !== null) return $1e6ef4fbf892be45$var$pe;
    const performanceObserverCallback = (list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $jKaCJ.PerformanceObserverEntryTypes).LayoutShift) (0, $k0uhA.EntriesBuffer)[(0, $jKaCJ.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $jKaCJ.PerformanceObserverEntryTypes).LongTask) (0, $k0uhA.EntriesBuffer)[(0, $jKaCJ.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    };
    $1e6ef4fbf892be45$var$pe = new PerformanceObserver(performanceObserverCallback);
    return $1e6ef4fbf892be45$var$pe;
}
function $1e6ef4fbf892be45$export$768ccc3ab7bac3ea() {
    $1e6ef4fbf892be45$var$getObserver()?.observe({
        type: (0, $jKaCJ.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
}
function $1e6ef4fbf892be45$export$54fb8b6aaf70ec9c() {
    $1e6ef4fbf892be45$var$getObserver()?.observe({
        type: (0, $jKaCJ.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
}

});


parcelRegister("3GMbH", function(module, exports) {

$parcel$export(module.exports, "getPerformanceObserver", () => $6092aa2f324152d8$export$17afbba0f16b4b19);

var $VSDnB = parcelRequire("VSDnB");

var $bFU4G = parcelRequire("bFU4G");

var $7pGku = parcelRequire("7pGku");
let $6092aa2f324152d8$var$performanceEventObserver;
const $6092aa2f324152d8$var$selectorConfig = {
    id: true,
    testId: true,
    role: true,
    className: true
};
function $6092aa2f324152d8$var$getTestIdName(memoizedProps) {
    if (memoizedProps['data-testid']) return `[data-testid=${memoizedProps['data-testid']}]`;
    else if (memoizedProps['data-test-id']) return `[data-test-id=${memoizedProps['data-testid']}]`;
    return null;
}
function $6092aa2f324152d8$var$getReactComponentHierarchy(element) {
    const componentHierarchy = [];
    // Function to traverse up the fiber tree
    function traverseFiber(fiber) {
        let currentFiber = fiber;
        while(currentFiber){
            if (currentFiber.type) {
                // Check if there's a display name or a function name
                const componentName = currentFiber.type.displayName || currentFiber.type.name;
                // checking when component name is bigger than the minimized name produced by react
                if (componentName && componentName.length > 2 && !componentName.includes('Listener') && !componentName.includes('Provider')) componentHierarchy.push(componentName);
                if (componentName === 'UFOSegment') break;
            }
            if (currentFiber.memoizedProps) {
                const dataIdInfo = $6092aa2f324152d8$var$getTestIdName(currentFiber.memoizedProps);
                if (dataIdInfo) {
                    componentHierarchy.push(dataIdInfo);
                    currentFiber = null;
                    continue;
                }
            }
            currentFiber = currentFiber.return;
        }
    }
    // Access the reactFiber node from the HTML element
    const reactFiberKey = Object.keys(element).find((key)=>key.startsWith('__reactFiber$'));
    if (reactFiberKey) {
        const fiber = element[reactFiberKey];
        traverseFiber(fiber);
    }
    return componentHierarchy.reverse().join(' > ');
}
const $6092aa2f324152d8$export$17afbba0f16b4b19 = ()=>{
    $6092aa2f324152d8$var$performanceEventObserver = $6092aa2f324152d8$var$performanceEventObserver || new PerformanceObserver((entries)=>{
        const list = entries.getEntries();
        for (let entry of list)if (entry.name === 'click') $6092aa2f324152d8$export$e6be05b411ce21a6(entry);
    });
    return $6092aa2f324152d8$var$performanceEventObserver;
};
const $6092aa2f324152d8$export$e6be05b411ce21a6 = (entry)=>{
    const interaction = (0, $bFU4G.getActiveInteraction)();
    if (interaction?.type === 'press') {
        // if happens there is another event interaction that has started after
        // the initial one, we don't want to replace the values if they have already been set up
        interaction.responsiveness = {
            ...interaction.responsiveness,
            experimentalInputToNextPaint: interaction.responsiveness?.experimentalInputToNextPaint || entry.duration,
            inputDelay: interaction.responsiveness?.inputDelay || entry.processingStart - entry.startTime
        };
        // if the entry start time is lower than the one in the interaction
        // it means the interaction start time is not accurate, we assign
        // this value which will match the timestamp in the event
        interaction.start = Math.min(interaction.start, entry.startTime);
        if (interaction.ufoName === 'unknown' && (0, $VSDnB.fg)('platform_ufo_enable_unknown_interactions_elements')) {
            if (entry.target) {
                const componentHierarchy = $6092aa2f324152d8$var$getReactComponentHierarchy(entry.target);
                interaction.unknownElementHierarchy = componentHierarchy;
            }
            interaction.unknownElementName = (0, $7pGku.default)($6092aa2f324152d8$var$selectorConfig, entry.target);
        }
    }
};

});
parcelRegister("7pGku", function(module, exports) {

$parcel$export(module.exports, "default", () => $787525feb480f9f5$export$2e2bcd8739ae039);
const $787525feb480f9f5$var$nameCache = new WeakMap();
function $787525feb480f9f5$var$getAttributeSelector(element, attributeName) {
    const attrValue = element.getAttribute(attributeName);
    if (!attrValue) return '';
    return `[${attributeName}="${attrValue}"]`;
}
function $787525feb480f9f5$var$isValidSelector(selector) {
    try {
        document.querySelector(selector);
        return true;
    } catch (err) {
        return false;
    }
}
function $787525feb480f9f5$var$isSelectorUnique(selector) {
    return document.querySelectorAll(selector).length === 1;
}
function $787525feb480f9f5$var$getUniqueSelector(selectorConfig, element) {
    let currentElement = element;
    const parts = [];
    const MAX_DEPTH = 3;
    let currentDepth = 0;
    while(currentElement && currentElement.localName !== 'body' && currentDepth <= MAX_DEPTH){
        const tagName = currentElement.localName;
        let selectorPart = tagName;
        if (selectorConfig.id && currentElement.id && $787525feb480f9f5$var$isValidSelector(`#${currentElement.id}`)) selectorPart += `#${currentElement.id}`;
        else if (selectorConfig.dataVC) selectorPart += $787525feb480f9f5$var$getAttributeSelector(currentElement, 'data-vc');
        else if (selectorConfig.testId) selectorPart += $787525feb480f9f5$var$getAttributeSelector(currentElement, 'data-testid') || $787525feb480f9f5$var$getAttributeSelector(currentElement, 'data-test-id');
        else if (selectorConfig.role) selectorPart += $787525feb480f9f5$var$getAttributeSelector(currentElement, 'role');
        else if (selectorConfig.className && currentElement.className) {
            const classNames = Array.from(currentElement.classList).join('.');
            if (classNames) {
                if ($787525feb480f9f5$var$isValidSelector(`.${classNames}`)) selectorPart += `.${classNames}`;
            }
        }
        parts.unshift(selectorPart);
        const potentialSelector = parts.join(' > ').trim();
        if (potentialSelector && $787525feb480f9f5$var$isSelectorUnique(potentialSelector)) return potentialSelector;
        currentElement = currentElement.parentElement;
        currentDepth++;
    }
    const potentialSelector = parts.join(' > ').trim();
    if (!potentialSelector) return 'unknown';
    else if (!$787525feb480f9f5$var$isSelectorUnique(potentialSelector)) {
        const parentElement = element.parentElement;
        if (parentElement) return `${potentialSelector}:nth-child`; // NOTE: invalid DOM selector, but enough information for VC
    }
    return potentialSelector;
}
function $787525feb480f9f5$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) return 'error';
    const cachedName = $787525feb480f9f5$var$nameCache.get(element);
    if (cachedName) return cachedName;
    const uniqueSelector = $787525feb480f9f5$var$getUniqueSelector(selectorConfig, element);
    $787525feb480f9f5$var$nameCache.set(element, uniqueSelector);
    return uniqueSelector;
}
var $787525feb480f9f5$export$2e2bcd8739ae039 = $787525feb480f9f5$var$getElementName;

});


parcelRegister("7p8yR", function(module, exports) {

$parcel$export(module.exports, "createPressureStateReport", () => $7bda1bc18107fc97$export$1f0ff35da084986e);
$parcel$export(module.exports, "createMemoryStateReport", () => $7bda1bc18107fc97$export$3b47ebb9832b4e24);
$parcel$export(module.exports, "initialisePressureObserver", () => $7bda1bc18107fc97$export$117ebc554c6e9f2f);
$parcel$export(module.exports, "initialiseMemoryObserver", () => $7bda1bc18107fc97$export$a3271f53e91faab7);
const $7bda1bc18107fc97$var$BUFFER_MAX_LENGTH = 1000; // ensure we don't blow up this buffer
let $7bda1bc18107fc97$var$pressureRecordBuffer = [];
let $7bda1bc18107fc97$var$pressureObserver = null;
let $7bda1bc18107fc97$var$memoryRecordBuffer = [];
let $7bda1bc18107fc97$var$memoryInterval;
function $7bda1bc18107fc97$export$6c1060bed5fea050() {
    $7bda1bc18107fc97$var$pressureRecordBuffer.length = 0;
}
function $7bda1bc18107fc97$export$aa672c7221b183b0() {
    $7bda1bc18107fc97$var$memoryRecordBuffer.length = 0;
}
function $7bda1bc18107fc97$export$ec86686c1d2e65bc(filter) {
    $7bda1bc18107fc97$var$pressureRecordBuffer = $7bda1bc18107fc97$var$pressureRecordBuffer.filter(({ time: time })=>time > filter);
}
function $7bda1bc18107fc97$export$c0142ac82f5d0c28(filter) {
    $7bda1bc18107fc97$var$memoryRecordBuffer = $7bda1bc18107fc97$var$memoryRecordBuffer.filter(({ time: time })=>time > filter);
}
function $7bda1bc18107fc97$export$1f0ff35da084986e(start, end) {
    try {
        // To differentiate between the API not available, vs no PressureRecords added
        if (!('PressureObserver' in globalThis)) return null;
        const pressureStateCount = $7bda1bc18107fc97$var$pressureRecordBuffer.reduce((pressureReport, { time: time, state: state })=>{
            if (time >= start && time <= end) pressureReport[state] += 1;
            return pressureReport;
        }, {
            nominal: 0,
            fair: 0,
            serious: 0,
            critical: 0
        });
        const pressureStateTotal = Object.values(pressureStateCount).reduce((total, count)=>total + count) || 1;
        $7bda1bc18107fc97$export$ec86686c1d2e65bc(end);
        return {
            count: pressureStateCount,
            percentage: {
                nominal: Math.round(pressureStateCount.nominal / pressureStateTotal * 100),
                fair: Math.round(pressureStateCount.fair / pressureStateTotal * 100),
                serious: Math.round(pressureStateCount.serious / pressureStateTotal * 100),
                critical: Math.round(pressureStateCount.critical / pressureStateTotal * 100)
            }
        };
    } catch  {
        return null;
    }
}
function $7bda1bc18107fc97$var$convertBytesToMegabytes(bytes) {
    return Math.round(Math.round(bytes / 1048576 * 100) / 100);
}
function $7bda1bc18107fc97$export$3b47ebb9832b4e24(start, end) {
    try {
        if (!('memory' in performance)) return null;
        const accumulatedMemoryUsage = $7bda1bc18107fc97$var$memoryRecordBuffer.reduce((acc, snapshot)=>{
            if (snapshot.time >= start && snapshot.time <= end) {
                acc.totalJSHeapSize += snapshot.totalJSHeapSize;
                acc.usedJSHeapSize += snapshot.usedJSHeapSize;
                acc.snapshotCount += 1;
            }
            return acc;
        }, {
            totalJSHeapSize: 0,
            usedJSHeapSize: 0,
            snapshotCount: 0
        });
        const memoryStateReport = {
            jsHeapSizeLimitInMB: $7bda1bc18107fc97$var$convertBytesToMegabytes($7bda1bc18107fc97$var$memoryRecordBuffer[0].jsHeapSizeLimit),
            avgTotalJSHeapSizeInMB: $7bda1bc18107fc97$var$convertBytesToMegabytes(accumulatedMemoryUsage.totalJSHeapSize / accumulatedMemoryUsage.snapshotCount),
            avgUsedJSHeapSizeInMB: $7bda1bc18107fc97$var$convertBytesToMegabytes(accumulatedMemoryUsage.usedJSHeapSize / accumulatedMemoryUsage.snapshotCount)
        };
        $7bda1bc18107fc97$export$c0142ac82f5d0c28(end);
        return memoryStateReport;
    } catch  {
        return null;
    }
}
function $7bda1bc18107fc97$export$117ebc554c6e9f2f() {
    try {
        if ('PressureObserver' in globalThis) {
            $7bda1bc18107fc97$var$pressureObserver = new PressureObserver((records)=>{
                if ($7bda1bc18107fc97$var$pressureRecordBuffer.length + records.length <= $7bda1bc18107fc97$var$BUFFER_MAX_LENGTH) $7bda1bc18107fc97$var$pressureRecordBuffer.push(...records);
            });
            $7bda1bc18107fc97$var$pressureObserver.observe('cpu', {
                sampleInterval: 100
            }).catch();
        }
    } catch (err) {
    /* do nothing, this is a best efforts metric */ }
}
function $7bda1bc18107fc97$export$a3271f53e91faab7() {
    try {
        // only set up the interval if `performance.memory` is available in the browser
        if ('memory' in performance) $7bda1bc18107fc97$var$memoryInterval = setInterval(()=>{
            // another check of `performance.memory` availability to satisfy typescript
            if ('memory' in performance) {
                const memory = performance.memory;
                if ($7bda1bc18107fc97$var$memoryRecordBuffer.length <= $7bda1bc18107fc97$var$BUFFER_MAX_LENGTH) $7bda1bc18107fc97$var$memoryRecordBuffer.push({
                    time: performance.now(),
                    jsHeapSizeLimit: memory.jsHeapSizeLimit,
                    totalJSHeapSize: memory.totalJSHeapSize,
                    usedJSHeapSize: memory.usedJSHeapSize
                });
            }
        }, 100);
    } catch  {
    /* do nothing, this is a best efforts metric */ }
}
function $7bda1bc18107fc97$export$10899ada382f2ae3() {
    clearInterval($7bda1bc18107fc97$var$memoryInterval);
}
function $7bda1bc18107fc97$export$b9fdd785f0fc1d40() {
    $7bda1bc18107fc97$var$pressureObserver?.disconnect();
}

});

parcelRegister("kbK8z", function(module, exports) {

$parcel$export(module.exports, "default", () => $8538a5ab0e6a47d0$export$2e2bcd8739ae039);

var $gg6CF = parcelRequire("gg6CF");

var $VSDnB = parcelRequire("VSDnB");
function $8538a5ab0e6a47d0$var$scheduleIdleCallback(work) {
    if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function' && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $VSDnB.fg)('ufo_payload_use_idle_callback')) window.requestIdleCallback(work);
    else (0, $gg6CF.unstable_scheduleCallback)((0, $gg6CF.unstable_IdlePriority), work);
}
var $8538a5ab0e6a47d0$export$2e2bcd8739ae039 = $8538a5ab0e6a47d0$var$scheduleIdleCallback;

});

parcelRegister("jBHcJ", function(module, exports) {

let $e462fc837141ce52$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e462fc837141ce52$var$load("76n7a"),
    $e462fc837141ce52$var$load("l253H"),
    $e462fc837141ce52$var$load("cQeWv")
]).then(()=>parcelRequire('42zNJ'));

});

parcelRegister("jVMkq", function(module, exports) {

let $e828d430907cb733$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e828d430907cb733$var$load("6oc96").then(()=>parcelRequire('8OVem'));

});


parcelRegister("3vLAR", function(module, exports) {

$parcel$export(module.exports, "configure", () => $0b58edb89023fc57$export$8d21e34596265fa2);
$parcel$export(module.exports, "getConfig", () => $0b58edb89023fc57$export$44487a86467333c3);

var $fe1wc = parcelRequire("fe1wc");
const $0b58edb89023fc57$var$defaultAllowedParams = [
    'operationName',
    'operation',
    'q'
];
function $0b58edb89023fc57$var$getAllowedParams() {
    const config = (0, $fe1wc.getConfig)();
    return config?.allowedResourcesParams || $0b58edb89023fc57$var$defaultAllowedParams;
}
function $0b58edb89023fc57$var$handleQueryParams(urlString) {
    try {
        if (typeof urlString !== 'string') return urlString;
        const url = new URL(urlString);
        const params = new URLSearchParams(url.search);
        const allowedParams = $0b58edb89023fc57$var$getAllowedParams();
        for (const [key] of params)if (!allowedParams.includes(key)) url.searchParams.delete(key);
        return url.toString();
    } catch (e) {
        return urlString;
    }
}
let $0b58edb89023fc57$var$config = {
    mapResources: (url)=>url,
    sanitiseEndpoints: (url)=>{
        return $0b58edb89023fc57$var$handleQueryParams(url);
    }
};
function $0b58edb89023fc57$export$8d21e34596265fa2(resourceTimingConfig) {
    const newConfig = {
        mapResources: resourceTimingConfig.mapResources,
        sanitiseEndpoints: (url)=>{
            const sanitised = resourceTimingConfig.sanitiseEndpoints(url);
            if (sanitised) return $0b58edb89023fc57$var$handleQueryParams(sanitised);
            return sanitised;
        }
    };
    $0b58edb89023fc57$var$config = newConfig;
}
function $0b58edb89023fc57$export$44487a86467333c3() {
    return $0b58edb89023fc57$var$config;
}

});

parcelRegister("ievYU", function(module, exports) {

$parcel$export(module.exports, "startResourceTimingBuffer", () => $3ebfc8234e313f10$export$a311cb1baa7d2d62);

var $8aEFN = parcelRequire("8aEFN");
function $3ebfc8234e313f10$export$a311cb1baa7d2d62() {
    (0, $8aEFN.resourceTimingBuffer).start();
}

});
parcelRegister("8aEFN", function(module, exports) {

$parcel$export(module.exports, "resourceTimingBuffer", () => $33f750350a029cdd$export$bea963256235a63e);
$parcel$export(module.exports, "filterResourceTimings", () => $33f750350a029cdd$export$4138a729ef1db028);

var $bdDDw = parcelRequire("bdDDw");
const $33f750350a029cdd$var$getPerformanceObject = ()=>(window ?? {}).performance;
const $33f750350a029cdd$var$getPerformanceObserverObject = ()=>(window ?? {}).PerformanceObserver;
const $33f750350a029cdd$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource (entry) {
        const duration = (0, $bdDDw.roundEpsilon)(entry.duration);
        // prioritising atl-edge
        const totalBackendTimeEntry = entry.serverTiming?.find((timing)=>timing.name === 'atl-edge') || entry.serverTiming?.find(// timing name should come from per-product config in the future
        (timing)=>timing.name === 'total' || timing.name === 'filter-request-papi');
        const serverTime = totalBackendTimeEntry ? (0, $bdDDw.roundEpsilon)(totalBackendTimeEntry.duration) : undefined;
        const networkTime = serverTime ? duration - serverTime : undefined;
        return {
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: (0, $bdDDw.roundEpsilon)(entry.startTime),
            duration: (0, $bdDDw.roundEpsilon)(entry.duration),
            fetchStart: (0, $bdDDw.roundEpsilon)(entry.fetchStart || 0),
            workerStart: (0, $bdDDw.roundEpsilon)(entry.workerStart || 0),
            responseStart: (0, $bdDDw.roundEpsilon)(entry.responseStart || 0),
            requestStart: (0, $bdDDw.roundEpsilon)(entry.requestStart || 0),
            serverTime: serverTime,
            networkTime: networkTime,
            encodedSize: (0, $bdDDw.roundEpsilon)(entry.encodedBodySize),
            decodedSize: (0, $bdDDw.roundEpsilon)(entry.decodedBodySize)
        };
    },
    start () {
        const performance = $33f750350a029cdd$var$getPerformanceObject();
        const PerformanceObserver = $33f750350a029cdd$var$getPerformanceObserverObject();
        if (!PerformanceObserver || !performance || typeof PerformanceObserver === 'undefined') return;
        if ($33f750350a029cdd$export$bea963256235a63e.observer) return;
        const resources = performance.getEntriesByType?.('resource');
        if (resources) $33f750350a029cdd$export$bea963256235a63e.timings = resources.map((resource)=>$33f750350a029cdd$export$bea963256235a63e.transformResource(resource));
        $33f750350a029cdd$export$bea963256235a63e.observer = new PerformanceObserver($33f750350a029cdd$export$bea963256235a63e.addTimings);
        $33f750350a029cdd$export$bea963256235a63e.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop () {
        if ($33f750350a029cdd$export$bea963256235a63e.observer) {
            $33f750350a029cdd$export$bea963256235a63e.observer.disconnect();
            $33f750350a029cdd$export$bea963256235a63e.observer = null;
        }
        $33f750350a029cdd$export$bea963256235a63e.timings = [];
    },
    addTimings (list) {
        const entries = list.getEntries().map((entry)=>$33f750350a029cdd$export$bea963256235a63e.transformResource(entry));
        const overflow = $33f750350a029cdd$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $33f750350a029cdd$export$bea963256235a63e.maxSize) {
            const fieldsToRemove = overflow - $33f750350a029cdd$export$bea963256235a63e.maxSize;
            $33f750350a029cdd$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        $33f750350a029cdd$export$bea963256235a63e.timings.push(...entries);
    }
};
function $33f750350a029cdd$var$isValidTiming(timing, startTime, endTime) {
    return timing.startTime >= startTime && timing.startTime + timing.duration <= endTime;
}
function $33f750350a029cdd$export$4138a729ef1db028(startTime, endTime) {
    const performance = $33f750350a029cdd$var$getPerformanceObject();
    const PerformanceObserver = $33f750350a029cdd$var$getPerformanceObserverObject();
    if (!PerformanceObserver || !$33f750350a029cdd$export$bea963256235a63e.observer) {
        const resources = performance?.getEntriesByType('resource');
        if (resources) return resources.filter((timing)=>$33f750350a029cdd$var$isValidTiming(timing, startTime, endTime));
        return null;
    }
    return $33f750350a029cdd$export$bea963256235a63e.timings.filter((timing)=>$33f750350a029cdd$var$isValidTiming(timing, startTime, endTime));
}

});


parcelRegister("cPbc1", function(module, exports) {

$parcel$export(module.exports, "configure", () => $b6a66b7de4cc2962$export$8d21e34596265fa2);
$parcel$export(module.exports, "getSSRTimings", () => $b6a66b7de4cc2962$export$bf7408e83532dcd0);
$parcel$export(module.exports, "getSSRSuccess", () => $b6a66b7de4cc2962$export$c7ad864055e75537);
$parcel$export(module.exports, "getSSRPhaseSuccess", () => $b6a66b7de4cc2962$export$5eade9354185583d);
$parcel$export(module.exports, "getSSRDoneTime", () => $b6a66b7de4cc2962$export$3def7672244bab0c);
$parcel$export(module.exports, "getSSRFeatureFlags", () => $b6a66b7de4cc2962$export$1c4a9b5e6e22393d);

var $VSDnB = parcelRequire("VSDnB");
const $b6a66b7de4cc2962$var$NESTED_METRIC_SEPARATOR = '/';
function $b6a66b7de4cc2962$var$filterEntry(entry) {
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
}
function $b6a66b7de4cc2962$var$mapEntry(entry) {
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration),
        ...entry.size && (0, $VSDnB.fg)('platform_ufo_ssr_size_field') ? {
            size: Math.round(entry.size)
        } : {}
    };
}
const $b6a66b7de4cc2962$var$SSR_PREFIX = 'ssr';
function $b6a66b7de4cc2962$var$mapKey(key) {
    if (key === 'total') return $b6a66b7de4cc2962$var$SSR_PREFIX;
    return `${$b6a66b7de4cc2962$var$SSR_PREFIX}${$b6a66b7de4cc2962$var$NESTED_METRIC_SEPARATOR}${key}`;
}
let $b6a66b7de4cc2962$var$config;
function $b6a66b7de4cc2962$export$8d21e34596265fa2(ssrConfig) {
    $b6a66b7de4cc2962$var$config = ssrConfig;
}
function $b6a66b7de4cc2962$export$bf7408e83532dcd0() {
    if (!$b6a66b7de4cc2962$var$config?.getTimings) return {};
    const timings = $b6a66b7de4cc2962$var$config.getTimings();
    if (!timings) return {};
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($b6a66b7de4cc2962$var$filterEntry(entry[1])) acc[$b6a66b7de4cc2962$var$mapKey(entry[0])] = $b6a66b7de4cc2962$var$mapEntry(entry[1]);
        return acc;
    }, {});
    return ssrTimings;
}
function $b6a66b7de4cc2962$export$c7ad864055e75537() {
    return !!$b6a66b7de4cc2962$var$config?.getDoneMark();
}
function $b6a66b7de4cc2962$export$5eade9354185583d() {
    return $b6a66b7de4cc2962$var$config?.getSsrPhaseSuccess?.();
}
function $b6a66b7de4cc2962$export$3def7672244bab0c() {
    return $b6a66b7de4cc2962$var$config?.getDoneMark() ?? undefined;
}
function $b6a66b7de4cc2962$export$1c4a9b5e6e22393d() {
    if (!$b6a66b7de4cc2962$var$config?.getFeatureFlags) return undefined;
    try {
        return $b6a66b7de4cc2962$var$config.getFeatureFlags() ?? undefined;
    // eslint-disable-next-line no-empty
    } catch (e) {}
    return undefined;
}

});

parcelRegister("aZWa4", function(module, exports) {

$parcel$export(module.exports, "retrieveAndSetPageLoadTrace", () => $b515f2bc55199ff5$export$1a71d2bbe236de99);

var $tcn7E = parcelRequire("tcn7E");
let $b515f2bc55199ff5$var$alreadySet = false;
const $b515f2bc55199ff5$export$1a71d2bbe236de99 = (getMeta)=>{
    if (false || $b515f2bc55199ff5$var$alreadySet) return;
    const traceId = getMeta('X-B3-TraceId') || '';
    const spanId = traceId?.substring(traceId.length - 16) || ''; // set root span ID by convention
    $b515f2bc55199ff5$var$alreadySet = true;
    (0, $tcn7E.setActiveTrace)(traceId, spanId, 'page_load');
};

});

parcelRegister("3dQJA", function(module, exports) {

$parcel$export(module.exports, "getJiraCustomData", () => $f5569bfee184b069$export$abf5e20822fa925);

var $5uXOq = parcelRequire("5uXOq");

var $j8DrX = parcelRequire("j8DrX");

var $3HwlS = parcelRequire("3HwlS");

var $5aM2o = parcelRequire("5aM2o");

var $4R6GH = parcelRequire("4R6GH");

var $sUexw = parcelRequire("sUexw");

var $5YDBW = parcelRequire("5YDBW");

var $5uZVJ = parcelRequire("5uZVJ");

var $eV38z = parcelRequire("eV38z");

var $jgkaQ = parcelRequire("jgkaQ");

var $9NJeU = parcelRequire("9NJeU");

var $3Itig = parcelRequire("3Itig");

var $6R03U = parcelRequire("6R03U");

var $bo7zb = parcelRequire("bo7zb");

var $ax2PR = parcelRequire("ax2PR");

var $4xsv9 = parcelRequire("4xsv9");

function $f5569bfee184b069$export$abf5e20822fa925(interaction) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let customData = {};
    const shard = (0, $j8DrX.default)('ajs-shard');
    if (shard !== null && shard !== '') customData.shard = shard;
    if ((0, $4R6GH.fg)('add_editions_to_bm3_splunk_events')) customData['jira:productEditions'] = (0, $5aM2o.getProductEditions)();
    customData['network:assetEncoding'] = (0, $sUexw.getAssetEncoding)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const buildVariant = window.BUILD_VARIANT;
    if (buildVariant) customData['app:buildVariant'] = buildVariant;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const bundlerVersion = window.BUNDLER_VERSION;
    if (bundlerVersion) customData['app:bundlerVersion'] = bundlerVersion;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const useBifrostGateway = window.USE_BIFROST_GATEWAY;
    if (useBifrostGateway) customData['app:useBifrostGateway'] = useBifrostGateway;
    customData.navType = (0, $3HwlS.getWillShowNav4)() ? 'nav4' : 'nav3';
    customData.httpProtocol = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    performance.getEntriesByType('resource')// @ts-expect-error - TS2339  - Property 'nextHopProtocol' does not exist on type 'PerformanceEntry'. | TS2339 - Property 'nextHopProtocol' does not exist on type 'PerformanceEntry'.
    .find(({ nextHopProtocol: nextHopProtocol })=>!!nextHopProtocol)?.nextHopProtocol ?? 'unknown';
    const { start: start, end: end, apdex: apdex } = interaction;
    const stop = apdex?.[0]?.stopTime ?? end;
    customData.memory = (0, $9NJeU.getMemoryUsageReport)({
        start: start,
        stop: stop
    });
    const lightHouseMetrics = (0, $eV38z.getLighthouseMetrics)({
        start: start,
        stop: stop
    });
    customData = {
        ...customData,
        ...lightHouseMetrics
    };
    if (interaction.type === 'page_load') customData = {
        ...customData,
        ...(0, $jgkaQ.getMarks)({
            start: start
        }),
        ...(0, $3Itig.getPageSizeMetrics)(),
        ...(0, $3Itig.getExtraNavigationTimings)(),
        ...(0, $bo7zb.getServerDurationMetrics)(),
        ...(0, $6R03U.getRouterResourceMetrics)(),
        ...(0, $4xsv9.getWRMStats)(),
        ...(0, $3Itig.getPageSizeInfo)({
            start: start,
            stop: stop
        }),
        ...(0, $5YDBW.getCacheHitRatio)({
            start: start
        }),
        ...(0, $5uZVJ.getCHRInfo)({
            start: start
        }),
        ...(0, $ax2PR.getSSRStateInformation)(),
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        'app:version:web': window.BUILD_KEY,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        'app:version:ssr': window.SSR_BUILD_KEY,
        'app:framework:name': 'react',
        'app:framework:version': (0, $5uXOq.version)
    };
    return customData;
}

});
parcelRegister("sUexw", function(module, exports) {

$parcel$export(module.exports, "getAssetEncoding", () => $7cf3b2ddfe1abab1$export$fd12d8f45e126585);
function $7cf3b2ddfe1abab1$export$fd12d8f45e126585() {
    const assetEncodings = Array.prototype.map// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    .call(document.querySelectorAll('script[data-encoding], link[data-encoding]'), (i)=>i.getAttribute('data-encoding')) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((acc, i)=>{
        // @ts-expect-error - TS2538 - Type 'unknown' cannot be used as an index type.
        acc[i] = true;
        return acc;
    }, {});
    const uniqueEncodings = Object.keys(assetEncodings).sort();
    let result = 'unknown';
    if (uniqueEncodings.length === 1) [result] = uniqueEncodings;
    if (uniqueEncodings.length > 1) result = `mixed: ${uniqueEncodings.toString()}`;
    return result;
}

});

parcelRegister("5YDBW", function(module, exports) {

$parcel$export(module.exports, "getCacheHitRatio", () => $62c0824bd7614469$export$e8a9322c3d9da8a6);

var $6RCeq = parcelRequire("6RCeq");
/* Borrowed from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/performance/browser-metrics/src/plugins/timings/resource.ts */ const $62c0824bd7614469$var$cacheableTypes = [
    'script',
    'link'
];
const $62c0824bd7614469$var$CACHE_NETWORK = 'network';
const $62c0824bd7614469$var$CACHE_MEMORY = 'memory';
const $62c0824bd7614469$var$CACHE_DISK = 'disk';
const $62c0824bd7614469$var$calculateTransferType = (type, duration, size)=>{
    if (!$62c0824bd7614469$var$cacheableTypes.includes(type)) return $62c0824bd7614469$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $62c0824bd7614469$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $62c0824bd7614469$var$CACHE_DISK;
    if (size === undefined) return null;
    return $62c0824bd7614469$var$CACHE_NETWORK;
};
const $62c0824bd7614469$export$e8a9322c3d9da8a6 = ({ start: start })=>{
    let fromCache = 0;
    let preloadFromCache = 0;
    let total = 0;
    let totalPreload = 0;
    // initial load only
    if (start !== 0) return {};
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        for (const entry of (0, $6RCeq.default).getEntriesByType('resource')){
            // The BM3 resource timing collector checks for whether the timing information is available,
            // but we can make the assumption that it is for this Jira specific collector.
            const transferType = $62c0824bd7614469$var$calculateTransferType(entry.initiatorType, entry.duration, entry.transferSize);
            const isPreload = entry.initiatorType === 'link';
            if (transferType === 'disk' || transferType === 'memory') {
                fromCache += 1;
                if (isPreload) preloadFromCache += 1;
            }
            if (transferType !== null) {
                total += 1;
                if (isPreload) totalPreload += 1;
            }
        }
        const result = {};
        if (total > 0) result.cacheHitRatio = fromCache / total;
        if (totalPreload > 0) result.preloadCacheHitRatio = preloadFromCache / totalPreload;
        return result;
    } catch (e) {
        return {};
    }
};

});

parcelRegister("5uZVJ", function(module, exports) {

$parcel$export(module.exports, "getCHRInfo", () => $e76f22784dfe18ae$export$9e005e111be93521);

var $x9xyg = parcelRequire("x9xyg");

var $6RCeq = parcelRequire("6RCeq");

var $d1SfZ = parcelRequire("d1SfZ");
const $e76f22784dfe18ae$var$SPA_SSR_RENDERED = 'ssr.spa.rendered';
const $e76f22784dfe18ae$export$1faf7d001841a41c = ()=>(0, $x9xyg.getMark)($e76f22784dfe18ae$var$SPA_SSR_RENDERED)?.startTime || null;
const $e76f22784dfe18ae$export$9e005e111be93521 = ({ start: start })=>{
    // initial load only
    if (start !== 0) return {};
    const ssrMark = $e76f22784dfe18ae$export$1faf7d001841a41c();
    const reporter = new (0, $d1SfZ.CHRReporter)(ssrMark);
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        for (const entry of (0, $6RCeq.default).getEntriesByType('resource'))reporter.add(entry);
        const chr = reporter.get();
        return chr === null ? {} : {
            chr: chr
        };
    } catch (e) {
        return {};
    }
};

});
parcelRegister("d1SfZ", function(module, exports) {

$parcel$export(module.exports, "CHRReporter", () => $850475b27a81c50e$export$7d0d4cfb6455ffa5);

var $4R6GH = parcelRequire("4R6GH");

var $d1r8j = parcelRequire("d1r8j");
class $850475b27a81c50e$export$7d0d4cfb6455ffa5 {
    constructor(ssrMark){
        this.preloaded = new (0, $d1r8j.CHRSummary)();
        this.all = new (0, $d1r8j.CHRSummary)();
        this.ssrMark = null;
        this.ssrMark = ssrMark;
    }
    isPreloaded(item) {
        const isPreloadedByLink = item.initiatorType === 'link';
        const isPreloadedByPreloadModule = item.initiatorType === 'other' && item.name?.endsWith('.js') && (0, $4R6GH.fg)('ufo_support_other_resource_type_js');
        const isBeforeSSR = this.ssrMark === null || item.startTime < this.ssrMark;
        return (isPreloadedByLink || isPreloadedByPreloadModule) && isBeforeSSR;
    }
    add(item) {
        if (item.encodedBodySize === 0) return;
        if (this.isPreloaded(item)) this.preloaded.add(item);
        this.all.add(item);
    }
    static round(n) {
        return Math.round(n * 10000) / 10000;
    }
    makePayload(summary) {
        const bundlesLoadType = {
            mem: $850475b27a81c50e$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $d1r8j.CHRSummary).MEMORY_KEY] / summary.bundlesCount),
            disk: $850475b27a81c50e$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $d1r8j.CHRSummary).DISK_KEY] / summary.bundlesCount),
            net: $850475b27a81c50e$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $d1r8j.CHRSummary).NETWORK_KEY] / summary.bundlesCount)
        };
        const bundlesRatio = $850475b27a81c50e$export$7d0d4cfb6455ffa5.round((summary.bundles[(0, $d1r8j.CHRSummary).MEMORY_KEY] + summary.bundles[(0, $d1r8j.CHRSummary).DISK_KEY]) / summary.bundlesCount);
        const sizeLoadType = {
            mem: $850475b27a81c50e$export$7d0d4cfb6455ffa5.round(summary.size[(0, $d1r8j.CHRSummary).MEMORY_KEY] / summary.sizeTotal),
            disk: $850475b27a81c50e$export$7d0d4cfb6455ffa5.round(summary.size[(0, $d1r8j.CHRSummary).DISK_KEY] / summary.sizeTotal),
            net: $850475b27a81c50e$export$7d0d4cfb6455ffa5.round(summary.size[(0, $d1r8j.CHRSummary).NETWORK_KEY] / summary.sizeTotal)
        };
        const sizeRatio = $850475b27a81c50e$export$7d0d4cfb6455ffa5.round((summary.size[(0, $d1r8j.CHRSummary).MEMORY_KEY] + summary.size[(0, $d1r8j.CHRSummary).DISK_KEY]) / summary.sizeTotal);
        return {
            bundles: {
                ratio: bundlesRatio,
                count: summary.bundlesCount,
                loadType: bundlesLoadType
            },
            size: {
                ratio: sizeRatio,
                total: summary.sizeTotal,
                loadType: sizeLoadType
            }
        };
    }
    get() {
        if (this.all.bundlesCount === 0) return null;
        return {
            preloaded: this.makePayload(this.preloaded),
            all: this.makePayload(this.all)
        };
    }
}

});
parcelRegister("d1r8j", function(module, exports) {

$parcel$export(module.exports, "CHRSummary", () => $d000becd84478ee1$export$783d6618ee601ba);

var $4R6GH = parcelRequire("4R6GH");

var $80WiQ = parcelRequire("80WiQ");
const $d000becd84478ee1$var$calculateTransferType = (name, type, duration, size)=>{
    if ((0, $4R6GH.fg)('ufo_support_other_resource_type_js')) {
        if (!(0, $80WiQ.cacheableTypes).includes(type) && !(type === 'other' && name.includes('.js'))) return null;
    } else if (!(0, $80WiQ.cacheableTypes).includes(type)) return null;
    if ((size === undefined || size === 0) && duration === 0) return $d000becd84478ee1$export$783d6618ee601ba.MEMORY_KEY;
    if (size === 0 && duration > 0) return $d000becd84478ee1$export$783d6618ee601ba.DISK_KEY;
    if (size === undefined) return null;
    return $d000becd84478ee1$export$783d6618ee601ba.NETWORK_KEY;
};
class $d000becd84478ee1$export$783d6618ee601ba {
    static{
        this.MEMORY_KEY = 'mem';
    }
    static{
        this.DISK_KEY = 'disk';
    }
    static{
        this.NETWORK_KEY = 'net';
    }
    add(item) {
        const type = $d000becd84478ee1$var$calculateTransferType(item.name, item.initiatorType, item.duration, item.transferSize);
        if (type === null) return;
        this.bundles[type] += 1;
        this.bundlesCount += 1;
        this.size[type] += item.encodedBodySize;
        this.sizeTotal += item.encodedBodySize;
    }
    constructor(){
        this.bundles = {
            [$d000becd84478ee1$export$783d6618ee601ba.MEMORY_KEY]: 0,
            [$d000becd84478ee1$export$783d6618ee601ba.DISK_KEY]: 0,
            [$d000becd84478ee1$export$783d6618ee601ba.NETWORK_KEY]: 0
        };
        this.bundlesCount = 0;
        this.size = {
            [$d000becd84478ee1$export$783d6618ee601ba.MEMORY_KEY]: 0,
            [$d000becd84478ee1$export$783d6618ee601ba.DISK_KEY]: 0,
            [$d000becd84478ee1$export$783d6618ee601ba.NETWORK_KEY]: 0
        };
        this.sizeTotal = 0;
    }
}

});
parcelRegister("80WiQ", function(module, exports) {

$parcel$export(module.exports, "cacheableTypes", () => $0b57baf495baebc5$export$5e1aa91d6932ddaa);
/* Borrowed from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/performance/browser-metrics/src/plugins/timings/resource.ts */ const $0b57baf495baebc5$export$5e1aa91d6932ddaa = [
    'script',
    'link'
];

});




parcelRegister("eV38z", function(module, exports) {

$parcel$export(module.exports, "getLighthouseMetrics", () => $45336243ca9d66b9$export$b46cecdf698e4bb5);

var $akIBh = parcelRequire("akIBh");

var $5HXkx = parcelRequire("5HXkx");

var $7hESW = parcelRequire("7hESW");

var $aOwtG = parcelRequire("aOwtG");

var $8YqT3 = parcelRequire("8YqT3");
function $45336243ca9d66b9$export$5ecf2aafafee3e0() {
    (0, $8YqT3.startLSObserver)();
    (0, $8YqT3.startLTObserver)();
}
const $45336243ca9d66b9$export$b46cecdf698e4bb5 = ({ start: start, stop: stop })=>{
    const tbt = (0, $7hESW.getTBT)(start, stop, (0, $aOwtG.EntriesBuffer)[(0, $5HXkx.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, $akIBh.getCLS)(start, stop, (0, $aOwtG.EntriesBuffer)[(0, $5HXkx.PerformanceObserverEntryTypes).LayoutShift]);
    return {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls
    };
};

});
parcelRegister("akIBh", function(module, exports) {

$parcel$export(module.exports, "getCLS", () => $b182c515ac203eb1$export$fc6227831ee7c7);
const $b182c515ac203eb1$export$fc6227831ee7c7 = (start, stop, buffer)=>{
    const layoutShifts = buffer.getAll().filter((entry)=>entry.startTime >= start && entry.startTime <= stop);
    const sessionWindows = [];
    let currentWindow = null;
    // Group layout shifts into session windows
    for (const shift of layoutShifts){
        const { startTime: startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime: startTime,
                endTime: endTime,
                score: score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
};

});

parcelRegister("5HXkx", function(module, exports) {

$parcel$export(module.exports, "PerformanceObserverEntryTypes", () => $b2a196da23758bb0$export$a4def92db6fc8e17);
const $b2a196da23758bb0$export$a4def92db6fc8e17 = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};

});

parcelRegister("7hESW", function(module, exports) {

$parcel$export(module.exports, "getTBT", () => $e79996724decdf66$export$2d6e933b35bd3407);
const $e79996724decdf66$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
const $e79996724decdf66$export$2d6e933b35bd3407 = (start, stop, buffer)=>buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $e79996724decdf66$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + $e79996724decdf66$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $e79996724decdf66$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });

});

parcelRegister("aOwtG", function(module, exports) {

$parcel$export(module.exports, "EntriesBuffer", () => $14dd3fd4391f2796$export$f7dc16cbd16f7bbe);

var $5HXkx = parcelRequire("5HXkx");
class $14dd3fd4391f2796$export$2c6e86519c9e8188 {
    constructor(maxLength = 1000){
        this.buffer = [];
        this.full = false;
        this.maxLength = maxLength;
    }
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
}
const $14dd3fd4391f2796$export$f7dc16cbd16f7bbe = {
    [(0, $5HXkx.PerformanceObserverEntryTypes).LongTask]: new $14dd3fd4391f2796$export$2c6e86519c9e8188(),
    [(0, $5HXkx.PerformanceObserverEntryTypes).LayoutShift]: new $14dd3fd4391f2796$export$2c6e86519c9e8188()
};

});

parcelRegister("8YqT3", function(module, exports) {

$parcel$export(module.exports, "startLSObserver", () => $f3198686c7919898$export$768ccc3ab7bac3ea);
$parcel$export(module.exports, "startLTObserver", () => $f3198686c7919898$export$54fb8b6aaf70ec9c);

var $5HXkx = parcelRequire("5HXkx");

var $aOwtG = parcelRequire("aOwtG");
let $f3198686c7919898$var$pe = null;
const $f3198686c7919898$var$getObserver = ()=>{
    if ($f3198686c7919898$var$pe !== null) return $f3198686c7919898$var$pe;
    $f3198686c7919898$var$pe = new PerformanceObserver((list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $5HXkx.PerformanceObserverEntryTypes).LayoutShift) (0, $aOwtG.EntriesBuffer)[(0, $5HXkx.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $5HXkx.PerformanceObserverEntryTypes).LongTask) (0, $aOwtG.EntriesBuffer)[(0, $5HXkx.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    });
    return $f3198686c7919898$var$pe;
};
const $f3198686c7919898$export$768ccc3ab7bac3ea = ()=>{
    $f3198686c7919898$var$getObserver().observe({
        type: (0, $5HXkx.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
};
const $f3198686c7919898$export$54fb8b6aaf70ec9c = ()=>{
    $f3198686c7919898$var$getObserver().observe({
        type: (0, $5HXkx.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
};

});


parcelRegister("jgkaQ", function(module, exports) {

$parcel$export(module.exports, "getMarks", () => $0fe8913ad7f2f853$export$9d952633c9c2237b);

var $bobSR = parcelRequire("bobSR");

var $fDtbf = parcelRequire("fDtbf");
const $0fe8913ad7f2f853$export$9d952633c9c2237b = (data)=>{
    const userTiming = (0, $bobSR.getUserTiming)();
    if (userTiming === null) return null;
    const sanitizeName = (name)=>name.replace(/[\W_]+/g, '_');
    // @ts-expect-error - TS7031 - Binding element 'baseName' implicitly has an 'any' type. | TS7031 - Binding element 'collection' implicitly has an 'any' type.
    const getNextAvailableName = ({ baseName: baseName, collection: collection })=>{
        let candidateName = baseName;
        // If <name> is taken, we'll try <name>_2 and increment from there
        let counter = 2;
        let validName;
        while(!validName)if (candidateName in collection) {
            candidateName = `${baseName}_${counter}`;
            counter += 1;
        } else validName = candidateName;
        return validName;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const marks = {};
    // Excludes mark starting with '_'. This allows marks to opt-out from the report.
    userTiming.filter(// @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
    (item)=>item.type === 'mark' && !item.name.startsWith('_') && !item.name.endsWith((0, $fDtbf.JS_EVAL_START)) && !item.name.endsWith((0, $fDtbf.JS_EVAL_STOP)) && item.startTime >= data.start)// @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
    .forEach((item)=>{
        const name = getNextAvailableName({
            baseName: `mark__${sanitizeName(item.name)}`,
            collection: marks
        });
        marks[name] = Math.round(item.startTime - data.start);
    });
    return marks;
};

});

parcelRegister("9NJeU", function(module, exports) {

$parcel$export(module.exports, "getMemoryUsageReport", () => $8fa3790b95082ce5$export$e5bd2d61c7c80651);
/**
 * Memory usage report.
 *
 * In the future may be extended to contain `performance.measureUserAgentSpecificMemory` if Jira
 * front-end uses cross-origin isolation.
 */ const $8fa3790b95082ce5$export$e5bd2d61c7c80651 = ({ start: start, stop: stop })=>{
    // @ts-expect-error - TS2339 - Property 'memory' does not exist on type 'Performance'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (typeof performance === 'undefined' || performance?.memory == null) return null;
    const sessionTime = Math.round(stop - start);
    // @ts-expect-error - TS2339 - Property 'memory' does not exist on type 'Performance'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = performance.memory;
    return {
        sessionTime: sessionTime,
        performanceMemoryEntry: {
            jsHeapSizeLimit: jsHeapSizeLimit,
            totalJSHeapSize: totalJSHeapSize,
            usedJSHeapSize: usedJSHeapSize
        }
    };
};

});

parcelRegister("3Itig", function(module, exports) {

$parcel$export(module.exports, "getPageSizeMetrics", () => $d593ead38e6ee650$export$84e3d676f1564c75);
$parcel$export(module.exports, "getExtraNavigationTimings", () => $d593ead38e6ee650$export$b37a70af06e58097);
$parcel$export(module.exports, "getPageSizeInfo", () => $d593ead38e6ee650$export$b72e035af6568be7);

var $6RCeq = parcelRequire("6RCeq");
const $d593ead38e6ee650$export$84e3d676f1564c75 = ()=>{
    let maxDepth = -1;
    let maxWidth = -1;
    let numElements = 0;
    // As described in the lighthouse DOM audit - https://web.dev/dom-size/
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const calculateDOMsizeAndDepth = (el = document.body, depth = 1)=>{
        if (!el) return;
        if (depth > maxDepth) maxDepth = depth;
        if (el.children.length > maxWidth) maxWidth = el.children.length;
        let child = el.firstElementChild;
        while(child){
            // @ts-expect-error - TS2345 - Argument of type 'Element' is not assignable to parameter of type 'HTMLElement'.
            calculateDOMsizeAndDepth(child, depth + 1);
            // If element has shadow dom, traverse into that tree.
            if (child.shadowRoot) // @ts-expect-error - TS2345 - Argument of type 'ShadowRoot' is not assignable to parameter of type 'HTMLElement'.
            calculateDOMsizeAndDepth(child.shadowRoot, depth + 1);
            child = child.nextElementSibling;
            numElements += 1;
        }
    };
    calculateDOMsizeAndDepth();
    return {
        totalBodyElements: numElements,
        maxNestedLevels: maxDepth,
        maxChildElements: maxWidth
    };
};
const $d593ead38e6ee650$export$b37a70af06e58097 = ()=>{
    if (!(0, $6RCeq.default)) return {};
    const navigation = (0, $6RCeq.default).getEntriesByType('navigation')[0];
    if (!navigation) return {};
    return {
        // From https://www.w3.org/TR/navigation-timing-2/
        // @ts-expect-error - TS2339 - Property 'decodedBodySize' does not exist on type 'PerformanceEntry'.
        decodedBodySize: navigation.decodedBodySize,
        // @ts-expect-error - TS2339 - Property 'encodedBodySize' does not exist on type 'PerformanceEntry'.
        encodedBodySize: navigation.encodedBodySize,
        // @ts-expect-error - TS2339 - Property 'transferSize' does not exist on type 'PerformanceEntry'.
        transferSize: navigation.transferSize
    };
};
const $d593ead38e6ee650$var$assetsTypes = [
    'script',
    'link'
];
const $d593ead38e6ee650$export$b72e035af6568be7 = ({ start: start, stop: stop })=>{
    const pageSize = $d593ead38e6ee650$export$b37a70af06e58097();
    if (!pageSize || Object.keys(pageSize).length === 0 || pageSize.decodedBodySize === 0 || start > 0) return {};
    const decoded = {
        total: pageSize.decodedBodySize,
        pageSize: pageSize.decodedBodySize,
        assets: 0,
        endpoints: 0
    };
    const encoded = {
        total: pageSize.encodedBodySize,
        pageSize: pageSize.encodedBodySize,
        assets: 0,
        endpoints: 0
    };
    const net = {
        total: pageSize.transferSize,
        assets: 0,
        endpoints: 0
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    for (const entry of (0, $6RCeq.default).getEntriesByType('resource')){
        if (entry.startTime > stop) continue;
        if ($d593ead38e6ee650$var$assetsTypes.includes(entry.initiatorType)) {
            decoded.total += entry.decodedBodySize;
            decoded.assets += entry.decodedBodySize;
            encoded.total += entry.encodedBodySize;
            encoded.assets += entry.encodedBodySize;
            net.total += entry.transferSize;
            net.assets += entry.transferSize;
        } else {
            decoded.total += entry.decodedBodySize;
            decoded.endpoints += entry.decodedBodySize;
            encoded.total += entry.encodedBodySize;
            encoded.endpoints += entry.encodedBodySize;
            net.total += entry.transferSize;
            net.endpoints += entry.transferSize;
        }
    }
    const returnValue = {};
    Object.keys(decoded).forEach((key)=>{
        returnValue[`size:decoded:${key}`] = decoded[key];
    });
    Object.keys(encoded).forEach((key)=>{
        returnValue[`size:encoded:${key}`] = encoded[key];
    });
    Object.keys(net).forEach((key)=>{
        returnValue[`size:net:${key}`] = net[key];
    });
    return returnValue;
};

});

parcelRegister("6R03U", function(module, exports) {

$parcel$export(module.exports, "getRouterResourceMetrics", () => $7077665729c4125c$export$e703af446a67c7f4);
const $7077665729c4125c$export$e703af446a67c7f4 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const ssrRouterResourceTimeouts = window.SPA_STATE ? Object.keys(window.SPA_STATE).filter((key)=>{
        if (key !== key.toUpperCase()) return false;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const resource = window.SPA_STATE[key];
        if (typeof resource !== 'object') return false;
        const resourceResponse = resource[Object.keys(resource)[0]];
        return resourceResponse?.error?.name === 'TimeoutError';
    }) : [];
    return {
        ssrRouterResourceTimeouts: ssrRouterResourceTimeouts
    };
};

});

parcelRegister("bo7zb", function(module, exports) {

$parcel$export(module.exports, "getServerDurationMetrics", () => $c797c35a7f1d14f1$export$efd8b60b870e5282);
const $c797c35a7f1d14f1$export$efd8b60b870e5282 = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const metrics = {};
    try {
        // server duration metric is buried in a hidden form near end of </body>
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverDurationElem = document.querySelector('#jira_request_timing_info [title="jira.request.server.time"]');
        if (serverDurationElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverDuration = Number(serverDurationElem.value);
            if (serverDuration > 0) metrics.serverDuration = Math.round(serverDuration);
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverTraceIdElem = document.querySelector('#jira_request_timing_info [title="jira.request.trace.id"]');
        if (serverTraceIdElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverRequestTraceId = serverTraceIdElem.value;
            metrics.serverRequestTraceId = serverRequestTraceId;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverTraceSampledElem = document.querySelector('#jira_request_timing_info [title="jira.request.sampled"]');
        if (serverTraceSampledElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverRequestTraceSampled = serverTraceSampledElem.value;
            switch(serverRequestTraceSampled){
                case 'true':
                    metrics.serverRequestTraceSampled = true;
                    break;
                case 'false':
                    metrics.serverRequestTraceSampled = false;
                    break;
                default:
                    metrics.serverRequestTraceSampled = null;
                    break;
            }
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const concurrentRequestsElem = document.querySelector('#jira_request_timing_info [name="jira.request.concurrent.requests"]');
        if (concurrentRequestsElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const concurrentRequests = concurrentRequestsElem.value;
            metrics.concurrentRequests = concurrentRequests;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverRequestStartTimeElem = document.querySelector('#jira_request_timing_info [name="jira.request.start.millis"]');
        if (serverRequestStartTimeElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverRequestStartTime = serverRequestStartTimeElem.value;
            metrics.serverRequestStartTime = serverRequestStartTime;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const frontendFlushStartTimeElem = document.querySelector('#jira_request_timing_info [name="jira.request.frontend.flush.start"]');
        if (frontendFlushStartTimeElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const frontendFlushStartTime = frontendFlushStartTimeElem.value;
            metrics.frontendFlushStartTime = frontendFlushStartTime;
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (ignored) {
    /* noop */ }
    return metrics;
};

});

parcelRegister("ax2PR", function(module, exports) {

$parcel$export(module.exports, "getSSRStateInformation", () => $cefad605288b959d$export$9a46186893ad76bd);

var $x9xyg = parcelRequire("x9xyg");
const $cefad605288b959d$var$getState = ()=>{
    if ((0, $x9xyg.getMark)('ssr.spa.state')?.startTime) return 'success';
    if ((0, $x9xyg.getMark)('ssr.spa.early-common-flush:end')?.startTime) return 'spa-render-failure';
    return 'static-fallback';
};
const $cefad605288b959d$export$9a46186893ad76bd = ()=>{
    return {
        'ssr:state': $cefad605288b959d$var$getState()
    };
};

});

parcelRegister("4xsv9", function(module, exports) {

$parcel$export(module.exports, "getWRMStats", () => $a91d766509875677$export$d2d916ddd03b82bc);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a91d766509875677$export$d2d916ddd03b82bc = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const wrmStats = window.__WRM_INTERNAL_STATS__ ?? {};
    return {
        wrmStats: wrmStats
    };
};

});


parcelRegister("fJbQ9", function(module, exports) {

$parcel$export(module.exports, "jiraBundleEvalTimingsConfig", () => $f9b1cc066b55fe02$export$791b8c0cbd574ea9);

var $fDtbf = parcelRequire("fDtbf");
const $f9b1cc066b55fe02$export$791b8c0cbd574ea9 = {
    mapPerformanceMark: (mark)=>{
        if (mark.endsWith((0, $fDtbf.JS_EVAL_START))) return {
            name: mark.substring(0, mark.indexOf((0, $fDtbf.JS_EVAL_START))),
            type: 'start'
        };
        if (mark.endsWith((0, $fDtbf.JS_EVAL_STOP))) return {
            name: mark.substring(0, mark.indexOf((0, $fDtbf.JS_EVAL_STOP))),
            type: 'end'
        };
        return null;
    }
};

});

parcelRegister("itoGf", function(module, exports) {

$parcel$export(module.exports, "jiraResourceTimingsConfig", () => $be8f5f0d3efbf58f$export$8fa71550bcdc2104);

var $aZsz6 = parcelRequire("aZsz6");

var $6pIol = parcelRequire("6pIol");
const $be8f5f0d3efbf58f$var$isWRMResource = (url)=>url.includes('/batch.js') || url.includes('/batch.css');
const $be8f5f0d3efbf58f$var$getWRMAssetName = (url)=>{
    const [, resources] = /\/([\w.\-,:]*?)(?:,-|\/batch\.)/.exec(url) || [];
    const assetName = (0, $6pIol.sanitiseAssetName)(false)(url);
    if (!resources) return assetName;
    return `wrm/${resources}/${assetName}`;
};
const $be8f5f0d3efbf58f$var$getFileName = (url)=>$be8f5f0d3efbf58f$var$isWRMResource(url) ? $be8f5f0d3efbf58f$var$getWRMAssetName(url) : (0, $6pIol.sanitiseAssetName)(false)(url);
const $be8f5f0d3efbf58f$var$sanitiseEndpoints = (url)=>{
    const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($aZsz6)))(url, true);
    /**
	 * For endpoints with operation or operationName queryParam we will shorten the url
	 * as ufo pipeline will only get the `operation` query param for aggregation
	 */ const { operation: operation, operationName: operationName } = parsedUrl.query;
    const operationNameOverride = operation ?? operationName;
    if (operationNameOverride) return `/${operation}?operation=${operation}`;
    const fileName = parsedUrl.pathname.replace(/\/(project|agent)(-config|s)?\/([A-Z0-9]+)/g, '/$1$2/<project-key>').replace(/\/(servicedesk)(-data)?\/([A-Z0-9]+)/g, '/$1$2/<project-key>').replace(/\/(browse|automation|pagination|permissions|async|dialog|itsm)\/([A-Z0-9]+)/g, '/$1/<project-key>').replace(/\/(board)(s)?\/([0-9]+)/g, '/$1$2/<board-id>').replace(/\/(\w+)-(\d+)\//i, '/<issue-key>/').replace(/\/pq\/[a-fA-F0-9]+/i, '/pq/<id>') // persisted queries
    .replace(/\/user\/[a-fA-F0-9\-:]+/i, '/user/<user-id>') // engage targeting
    .replace(/[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}/i, '<uuid>').replace(/\/\d+$/i, '/<id>');
    return fileName;
};
const $be8f5f0d3efbf58f$export$8fa71550bcdc2104 = {
    sanitiseEndpoints: $be8f5f0d3efbf58f$var$sanitiseEndpoints,
    mapResources: $be8f5f0d3efbf58f$var$getFileName,
    hasTimingHeaders: (url)=>url.includes('jira-frontend-static') || url.includes('jira-frontend-branch') || url.includes('jira-frontend-bifrost') || $be8f5f0d3efbf58f$var$isWRMResource(url),
    // @ts-expect-error - TS7006 - Parameter 'url' implicitly has an 'any' type.
    xhrFilter: (url)=>url.includes('/rest/greenhopper/')
};

});

parcelRegister("dQKfU", function(module, exports) {

$parcel$export(module.exports, "jiraSsrConfig", () => $ba8cdb329bff9946$export$7bcf91e323db67dd);

var $LpImS = parcelRequire("LpImS");

var $x9xyg = parcelRequire("x9xyg");

var $6RCeq = parcelRequire("6RCeq");

var $4R6GH = parcelRequire("4R6GH");

var $j8DrX = parcelRequire("j8DrX");

/** given a timings object, add a timer that starts at the earliest start time and ends at the latest end time */ function $ba8cdb329bff9946$var$insertTotalTiming(/**
	 * key of the total timing that will be inserted to the given timings object
	 */ key, timings) {
    const timingValues = timings && Object.values(timings);
    if (!timingValues || !timingValues.length) return timings;
    const startTime = Math.min(...timingValues.map(({ startTime: startTime })=>startTime));
    const endTime = timingValues.reduce((max, { startTime: startTime, duration: duration })=>Math.max(max, startTime + duration), 0);
    const duration = endTime - startTime;
    // eslint-disable-next-line no-param-reassign
    timings[key] = {
        startTime: startTime,
        duration: duration
    };
    return timings;
}
/**
 * Apply key and startTimOffset overrides to a timings object
 */ function $ba8cdb329bff9946$var$applyTimingOverrides(timings, { startTimeOffsetMs: startTimeOffsetMs = 0, prefix: prefix = '' } = {}) {
    return timings && Object.fromEntries(Object.entries(timings).map(([key, value])=>{
        const startTime = value.startTime + startTimeOffsetMs;
        return [
            [
                prefix,
                key
            ].filter(Boolean).join('/'),
            {
                ...value,
                startTime: startTime
            }
        ];
    }));
}
function $ba8cdb329bff9946$var$getTesseractTimings() {
    if (!globalThis.SPA_STATE) return null;
    const detailRenderTrace = globalThis.SPA_STATE['ssr/detail_render_trace'];
    const detailRelayFetch = globalThis.SPA_STATE['ssr/relay_fetch'];
    const detailRequestTrace = globalThis.SPA_STATE['ssr/detail_request_trace'];
    const highLevelMetrics = globalThis.SPA_STATE['ssr/metrics'];
    const timings = (0, (/*@__PURE__*/$parcel$interopDefault($LpImS)))(detailRenderTrace?.data?.traces) || {};
    if (highLevelMetrics?.data) {
        if ('ssrTotal' in highLevelMetrics.data) {
            // empty string to represent the total time for these timings, applyTimingOverrides will add the relevant namespace later
            const totalKey = '';
            timings[totalKey] = {
                startTime: 0,
                duration: highLevelMetrics.data.ssrTotal
            };
        }
        if ('ssrGetStyle' in highLevelMetrics.data) timings.styles = {
            startTime: highLevelMetrics.data.ssrGetStyle - highLevelMetrics.data.ssrGetStyle,
            duration: highLevelMetrics.data.ssrGetStyle
        };
        if ('ssrPrefetch' in highLevelMetrics.data) {
            const prefetchStartTime = Object.values(detailRequestTrace?.data || {}).reduce((min, { startTime: startTime })=>min === -1 || min > startTime ? startTime : min, -1);
            timings.prefetch = {
                startTime: prefetchStartTime,
                duration: highLevelMetrics.data.ssrPrefetch
            };
        }
    }
    if (detailRequestTrace?.data) Object.entries(detailRequestTrace.data).forEach(([key, value])=>{
        timings[`prefetch/${key}`] = value;
    });
    if (detailRelayFetch) {
        const relayFetchTimings = Object.fromEntries(Object.entries(detailRelayFetch ?? {}).map(([key, value])=>[
                `relay/${key}`,
                value
            ]));
        $ba8cdb329bff9946$var$insertTotalTiming('relay', relayFetchTimings);
        Object.assign(timings, relayFetchTimings);
    }
    let timingsWithContext = timings;
    if ((0, $4R6GH.fg)('jira-ufo-align-edge-client-ttfb')) {
        // If there's a server-timing for tesseract, that represents the pre-work before script execution starts, referred to as contextGlobalsSetup
        const serverTimingsByName = $ba8cdb329bff9946$var$getServerTimingsByName();
        // This will become available when EDGE-8510 is complete
        const contextGlobalsSetup = serverTimingsByName.tesseract?.duration;
        if (contextGlobalsSetup != null) {
            timingsWithContext = $ba8cdb329bff9946$var$applyTimingOverrides(timings, {
                startTimeOffsetMs: contextGlobalsSetup
            });
            timingsWithContext && Object.assign(timingsWithContext, {
                contextGlobalsSetup: {
                    startTime: 0,
                    duration: contextGlobalsSetup
                }
            });
        }
    }
    return $ba8cdb329bff9946$var$insertTotalTiming('', timingsWithContext); // while there is already a 'ssrTotal', it seems to exclude some timings, so we'll take the end to end as the actual total time
}
// add early-flush/ prefix to timing keys which are early flush timings
const $ba8cdb329bff9946$var$jiraFeGatewayEarlyFlushKeys = new Set([
    'metatags',
    'feature-flags',
    'statsig',
    'inline-assets',
    'async-inline-assets',
    'css-assets',
    'priority-assets',
    'early-route-flush'
]);
// and filter out these keys since they are not UFO visualisation friendly
const $ba8cdb329bff9946$var$jiraFeGatewayFilteredKeys = [
    'early-common-flush',
    'prerender-total',
    'resolve-assets'
];
function $ba8cdb329bff9946$var$getJiraFeGatewayTimings() {
    const rawTimings = globalThis._JFGTimings;
    if (!rawTimings) return null;
    const jiraFeGatewayTimings = Object.fromEntries(rawTimings.filter(({ name: name })=>!$ba8cdb329bff9946$var$jiraFeGatewayFilteredKeys.includes(name)).map(({ startTime: startTime, duration: duration, name: name })=>[
            $ba8cdb329bff9946$var$jiraFeGatewayEarlyFlushKeys.has(name) ? `early-flush/${name}` : name,
            {
                startTime: startTime,
                duration: duration
            }
        ]));
    return $ba8cdb329bff9946$var$insertTotalTiming(// there's no end to end timer so we calculate one
    '', jiraFeGatewayTimings);
}
function $ba8cdb329bff9946$var$getLegacyMonolithTimingDuration(timingMetricKey) {
    /* eslint-disable-next-line @typescript-eslint/consistent-type-assertions */ const inputElementWithTimingValue = globalThis.document?.querySelector(`#jira_request_timing_info [title="${timingMetricKey}"]`);
    return Number(inputElementWithTimingValue?.value ?? 0);
}
function $ba8cdb329bff9946$var$getLegacyJiraMonolithTimings() {
    const duration = $ba8cdb329bff9946$var$getLegacyMonolithTimingDuration('jira.request.server.time');
    if (!duration) // if we don't have this, fallback to no jira timings, we might be going through bifrost instead
    return null;
    const timings = {
        // empty string to represent the total time for these timings, applyTimingOverrides will add the relevant namespace later
        '': {
            startTime: 0,
            duration: duration
        },
        'flush-head': {
            startTime: 0,
            duration: $ba8cdb329bff9946$var$getLegacyMonolithTimingDuration('jira.request.server.head.time')
        }
    };
    return timings;
}
const $ba8cdb329bff9946$var$monolithTimerRenames = {
    'jira-request-server-time': ''
};
function $ba8cdb329bff9946$var$getJiraMonolithTimings() {
    if (!globalThis._monolithTimings) return $ba8cdb329bff9946$var$getLegacyJiraMonolithTimings();
    return Object.fromEntries(Object.entries(globalThis._monolithTimings).map(([name, { start: startTime, duration: duration }])=>[
            $ba8cdb329bff9946$var$monolithTimerRenames[name] ?? name,
            {
                startTime: startTime,
                duration: duration
            }
        ]));
}
function $ba8cdb329bff9946$var$getBifrostGatewayTimings(jiraBeTimings, tesseractTimings) {
    if (jiraBeTimings || !tesseractTimings) return null;
    if ((0, $4R6GH.fg)('jira-ufo-align-edge-client-ttfb')) {
        const serverTimingsByName = $ba8cdb329bff9946$var$getServerTimingsByName();
        // This will become available when EDGE-8510 is complete
        const bifrostInternal = serverTimingsByName.bifrost;
        const bifrostInternalDuration = bifrostInternal?.duration ?? 0;
        const timings = {
            ...bifrostInternal && {
                internal: {
                    startTime: 0,
                    duration: bifrostInternalDuration
                }
            },
            tesseract: {
                startTime: bifrostInternalDuration,
                duration: tesseractTimings[''].duration
            }
        };
        return $ba8cdb329bff9946$var$insertTotalTiming('', timings);
    } else {
        // this is a placeholder function, we don't get any real bifrost timings yet
        // in the meantime, let's set a placeholder only if we have no monolith timings and some tesseract timings
        const timings = {
            // empty string to represent the total time for these timings, applyTimingOverrides will add the relevant namespace later
            '': {
                startTime: 0,
                duration: tesseractTimings[''].duration
            }
        };
        return timings;
    }
}
/**
 * Get the offset required to align the ending of the timerToShift with the ending of the referenceTimer
 * But if the referenceTimer is smaller than the timerToShift (it shouldn't be, this is for timerToShifts that in practice are triggered within the reference timer)
 * then at least align the start times
 */ function $ba8cdb329bff9946$var$getOffsetToAlignTimers(referenceTimer, timerToShift) {
    if (!referenceTimer || !timerToShift) return null;
    if (referenceTimer.duration >= timerToShift.duration) return referenceTimer.startTime + referenceTimer.duration - (timerToShift.startTime + timerToShift.duration);
    else return referenceTimer.startTime - timerToShift.startTime;
}
function $ba8cdb329bff9946$var$getJfgOffset({ jiraFeGatewayTimings: jiraFeGatewayTimings, jiraBeTimings: jiraBeTimings }) {
    // Push back the start of jfg so it's ending aligns with either the full monolith time or if we have the more specific timer for fetching jfg, use that
    const jiraBeTiming = jiraBeTimings?.['jira-monolith/feGateway'] ?? jiraBeTimings?.['jira-monolith'];
    return $ba8cdb329bff9946$var$getOffsetToAlignTimers(jiraBeTiming, jiraFeGatewayTimings?.['']) ?? 0;
}
/**
 * Get the offset required to align the ending of the tesseract timer with either
 * the ending of the jira-fe-gateway/fetch-tesseract timer or the bifrost-gateway timer
 */ function $ba8cdb329bff9946$var$getTesseractOffset({ tesseractTimings: tesseractTimings, jiraFeGatewayTimings: jiraFeGatewayTimings, bifrostGatewayTimings: bifrostGatewayTimings }) {
    const jiraFeGatewayTiming = jiraFeGatewayTimings?.['jira-fe-gateway/fetch-tesseract'];
    const jiraBeTesseractOffest = $ba8cdb329bff9946$var$getOffsetToAlignTimers(jiraFeGatewayTiming, tesseractTimings?.['']);
    const bifrostGatewayTiming = bifrostGatewayTimings?.['bifrost-gateway'];
    const bifrostOffset = $ba8cdb329bff9946$var$getOffsetToAlignTimers(bifrostGatewayTiming, tesseractTimings?.['']);
    return bifrostOffset ?? jiraBeTesseractOffest ?? 0;
}
function $ba8cdb329bff9946$var$getEdgeTime() {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const navigatonPerfTimingEntry = (0, $6RCeq.default)?.getEntriesByType('navigation')?.[0];
    return navigatonPerfTimingEntry?.serverTiming?.find(({ name: name })=>name === 'atl-edge-internal')?.duration ?? 0;
}
function $ba8cdb329bff9946$var$getPerformanceNavigationTiming() {
    // getEntriesByType doesn't change the returned type based on the given type key
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $6RCeq.default).getEntriesByType('navigation')?.[0];
}
function $ba8cdb329bff9946$var$getServerTimingsByName() {
    const serverTimingsByName = Object.fromEntries($ba8cdb329bff9946$var$getPerformanceNavigationTiming()?.serverTiming?.map((timing)=>[
            timing.name,
            timing
        ]) ?? []);
    return serverTimingsByName;
}
function $ba8cdb329bff9946$var$getEdgeTimings() {
    const serverTimingsByName = $ba8cdb329bff9946$var$getServerTimingsByName();
    const edgeDurations = {
        'edge/internal': serverTimingsByName['atl-edge-internal']?.duration,
        'edge/ttfb': serverTimingsByName['atl-edge']?.duration
    };
    const edgeOffset = $ba8cdb329bff9946$var$getEdgeOffset(edgeDurations['edge/ttfb']);
    // Object.fromEntries doesn't generically type keys properly, so TS can't infer a fully typed object from known keys
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    let edgeTimings = Object.fromEntries(Object.entries(edgeDurations).filter(([_, duration])=>duration != null).map(([key, duration])=>[
            key,
            {
                startTime: edgeOffset,
                duration: duration
            }
        ]));
    edgeTimings = $ba8cdb329bff9946$var$insertTotalTiming('edge', edgeTimings);
    // we need a timer here to prevent UFO pipeline from shifting SSR timers to start at 0
    edgeTimings?.edge && edgeOffset && Object.assign(edgeTimings, {
        'client-network': {
            startTime: 0,
            duration: edgeOffset
        }
    });
    return edgeTimings;
}
/**
 * If we have the edge's view of ttfb and the clients view as well, then we should take the gap between them as
 * the offset to use foe edge start time.
 * This will simulate the network delays between the client and the edge as an edge startTime increase
 */ function $ba8cdb329bff9946$var$getEdgeOffset(edgeTtfb) {
    const clientTtfb = $ba8cdb329bff9946$var$getPerformanceNavigationTiming()?.responseStart;
    if (edgeTtfb == null || clientTtfb == null) return 0;
    return clientTtfb - edgeTtfb;
}
function $ba8cdb329bff9946$export$6d488733a547304() {
    const jiraBeTimings = $ba8cdb329bff9946$var$getJiraMonolithTimings();
    const jiraFeGatewayTimings = $ba8cdb329bff9946$var$getJiraFeGatewayTimings();
    const tesseractTimings = $ba8cdb329bff9946$var$getTesseractTimings();
    const bifrostGatewayTimings = $ba8cdb329bff9946$var$getBifrostGatewayTimings(jiraBeTimings, tesseractTimings);
    let edgeTime;
    let edgeTimings;
    if ((0, $4R6GH.fg)('jira-ufo-align-edge-client-ttfb')) {
        edgeTimings = $ba8cdb329bff9946$var$getEdgeTimings();
        edgeTime = (edgeTimings?.['edge/internal']?.duration ?? 0) + (edgeTimings?.['edge/internal']?.startTime ?? 0);
    } else {
        edgeTime = $ba8cdb329bff9946$var$getEdgeTime();
        edgeTimings = edgeTime ? {
            edge: {
                startTime: 0,
                duration: edgeTime
            }
        } : null;
    }
    const finalJiraBeTimings = $ba8cdb329bff9946$var$applyTimingOverrides(jiraBeTimings, {
        startTimeOffsetMs: edgeTime,
        prefix: 'jira-monolith'
    });
    const finalBifrostGatewayTimings = $ba8cdb329bff9946$var$applyTimingOverrides(bifrostGatewayTimings, {
        startTimeOffsetMs: edgeTime,
        prefix: 'bifrost-gateway'
    });
    const jfgOffset = $ba8cdb329bff9946$var$getJfgOffset({
        jiraFeGatewayTimings: jiraFeGatewayTimings,
        jiraBeTimings: finalJiraBeTimings
    });
    const finalJfgTimings = $ba8cdb329bff9946$var$applyTimingOverrides(jiraFeGatewayTimings, {
        startTimeOffsetMs: jfgOffset,
        prefix: 'jira-fe-gateway'
    });
    const tesseractOffset = $ba8cdb329bff9946$var$getTesseractOffset({
        tesseractTimings: tesseractTimings,
        jiraFeGatewayTimings: finalJfgTimings,
        bifrostGatewayTimings: finalBifrostGatewayTimings
    });
    const finalTesseractTimings = $ba8cdb329bff9946$var$applyTimingOverrides(tesseractTimings, {
        startTimeOffsetMs: tesseractOffset,
        prefix: 'tesseract'
    });
    const timings = {
        ...edgeTimings,
        ...finalJiraBeTimings,
        ...finalJfgTimings,
        ...finalBifrostGatewayTimings,
        ...finalTesseractTimings
    };
    $ba8cdb329bff9946$var$insertTotalTiming('total', timings); // UFO treats 'total' as a special key for ssr timings that translates to 'ssr'
    return Object.keys(timings).length ? timings : null;
}
const $ba8cdb329bff9946$var$SSR_FF_META_TAG = 'spa-service-flags';
let $ba8cdb329bff9946$var$ffCache;
let $ba8cdb329bff9946$var$ffCacheInitialiser = ()=>{
    try {
        const metaTagValue = (0, $j8DrX.default)($ba8cdb329bff9946$var$SSR_FF_META_TAG);
        if (metaTagValue === null) return null;
        $ba8cdb329bff9946$var$ffCache = JSON.parse(metaTagValue) || null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        $ba8cdb329bff9946$var$ffCache = null;
    }
    $ba8cdb329bff9946$var$ffCacheInitialiser = null;
};
function $ba8cdb329bff9946$var$getFeatureFlags() {
    if ($ba8cdb329bff9946$var$ffCacheInitialiser != null) $ba8cdb329bff9946$var$ffCacheInitialiser();
    return $ba8cdb329bff9946$var$ffCache;
}
function $ba8cdb329bff9946$var$isAnyRouteResourceFetchErrors() {
    return Object.values(globalThis.SPA_STATE?.['ssr/detail_request_trace']?.data ?? {}).some((timing)=>timing?.failureReason);
}
function $ba8cdb329bff9946$var$isAnyReactRenderErrors() {
    return !!globalThis.SPA_STATE?.['ssr/render_errors']?.count;
}
function $ba8cdb329bff9946$var$isAnyEntryPointFetchErrors() {
    return !!globalThis.SPA_STATE?.['ssr/entry_point_status']?.match(/error|timeout/);
}
function $ba8cdb329bff9946$var$isEarlyFlushSuccessful() {
    return !!(0, $6RCeq.default)?.getEntriesByName('ssr.spa.early-common-flush:end');
}
const $ba8cdb329bff9946$export$7bcf91e323db67dd = {
    getDoneMark: ()=>{
        if ($ba8cdb329bff9946$var$isAnyEntryPointFetchErrors() || (0, $4R6GH.fg)('jira-ufo-ssr-success-coverage-improvement') ? $ba8cdb329bff9946$var$isAnyRouteResourceFetchErrors() || $ba8cdb329bff9946$var$isAnyReactRenderErrors() : false) return null;
        if ((0, $4R6GH.fg)('ssr_success_when_spa_success')) {
            const SPASSRRenderedMark = (0, $x9xyg.getMark)((0, $ce556f125dee8174$export$135c96ab5afee429))?.startTime;
            if (SPASSRRenderedMark && (0, $x9xyg.getMark)('ssr.spa.state')?.startTime) return SPASSRRenderedMark;
            return null;
        }
        return (0, $x9xyg.getMark)((0, $ce556f125dee8174$export$135c96ab5afee429))?.startTime || null;
    },
    getSsrPhaseSuccess: ()=>{
        const prefetch = !!globalThis.SPA_STATE && !$ba8cdb329bff9946$var$isAnyEntryPointFetchErrors() && !$ba8cdb329bff9946$var$isAnyRouteResourceFetchErrors();
        const earlyFlush = $ba8cdb329bff9946$var$isEarlyFlushSuccessful();
        return {
            prefetch: prefetch,
            earlyFlush: earlyFlush
        };
    },
    getTimings: $ba8cdb329bff9946$export$6d488733a547304,
    getFeatureFlags: $ba8cdb329bff9946$var$getFeatureFlags
};

});


parcelRegister("eOqwI", function(module, exports) {

$parcel$export(module.exports, "getClientReceiver", () => $c0100a15e6ae9bd4$export$60624ad9eb1ec31a);

var $gNb1N = parcelRequire("gNb1N");



var $305w3 = parcelRequire("305w3");
let $c0100a15e6ae9bd4$var$receiver;
function $c0100a15e6ae9bd4$export$60624ad9eb1ec31a() {
    // special-case: if server, bail early and do nothing
    if (false || !globalThis.document) return;
    if (!$c0100a15e6ae9bd4$var$receiver) {
        const dispatcher = (0, $gNb1N.getClientDispatcher)();
        const sink = dispatcher.ingest.bind(dispatcher);
        $c0100a15e6ae9bd4$var$receiver = new (0, $305w3.ClientReceiver)(globalThis.document, sink);
        $c0100a15e6ae9bd4$var$receiver.fulfilled().then(()=>{
            sink({
                id: (0, $f5236820edf41c5d$export$eb5d9c90d65c7fea),
                name: '_abort',
                args: [
                    {
                        reason: (0, $24fe7cbcd824ca4a$export$7adffed1e707770c)
                    }
                ]
            });
        });
    }
    return $c0100a15e6ae9bd4$var$receiver;
}

});
const $24fe7cbcd824ca4a$export$7adffed1e707770c = 'SERVER_HTTP_RESPONSE_ENDED';

parcelRegister("305w3", function(module, exports) {

$parcel$export(module.exports, "ClientReceiver", () => $8e78140f5c2ff274$export$c5eb37f83f5ef9db);
const $8e78140f5c2ff274$var$ELEMENT_SELECTOR = 'script[data-clientjs]';
/**
 * We need to wait for slightly longer than 0ms. Waiting 4ms is enough
 * to guarantee the browser has processed any pending layout operations
 * that may yield further DOM content.
 */ const $8e78140f5c2ff274$var$DOM_RENDER_MS = 4;
class $8e78140f5c2ff274$export$c5eb37f83f5ef9db {
    #doc;
    #fulfilled;
    #onEvent;
    constructor(doc, onEvent){
        this.#doc = doc;
        this.#onEvent = onEvent;
        // consume any instructions that arrived before we initialised
        this.#doc.querySelectorAll($8e78140f5c2ff274$var$ELEMENT_SELECTOR).forEach((el)=>this.#handleServerToClientElement(el));
        // Bail early if DOM is already ready, otherwise observe for new instructions until it is.
        this.#fulfilled = this.#doc.readyState === 'complete' ? Promise.resolve() : new Promise((resolve)=>{
            this.#observe(resolve);
        });
    }
    #observe(resolve) {
        // observe the document for changes
        const observer = new MutationObserver((mutations)=>this.#handleMutation(mutations));
        observer.observe(this.#doc.body, {
            attributes: false,
            childList: true,
            subtree: false
        });
        // only keep trying until DOM ready, then give up.
        this.#doc.addEventListener('DOMContentLoaded', ()=>{
            setTimeout(()=>{
                observer.disconnect();
                resolve();
            }, $8e78140f5c2ff274$var$DOM_RENDER_MS + 1);
        }, {
            once: true
        });
    }
    #handleMutation(mutations) {
        for (const mutation of mutations){
            if (mutation.type === 'childList') for (const node of mutation.addedNodes){
                if (node.nodeType === Node.ELEMENT_NODE && node instanceof HTMLElement) {
                    if (node.matches($8e78140f5c2ff274$var$ELEMENT_SELECTOR)) setTimeout(()=>this.#handleServerToClientElement(node), $8e78140f5c2ff274$var$DOM_RENDER_MS);
                }
            }
        }
    }
    #handleServerToClientElement(el) {
        const events = el.textContent?.trim().split('\n');
        if (!events) return;
        for (const event of events){
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const payload = JSON.parse(event);
            this.#onEvent(payload);
        }
    }
    fulfilled() {
        return this.#fulfilled;
    }
}

});


parcelRegister("3qHVS", function(module, exports) {

$parcel$export(module.exports, "visualRefreshResolverOverride", () => $56907fa85239d7b0$export$73a94df81a7c0f2c);

var $dCm1o = parcelRequire("dCm1o");
const $56907fa85239d7b0$var$visualRefreshPlatformFlags = [
    'platform-component-visual-refresh',
    'platform-visual-refresh-icons-legacy-facade',
    'platform-visual-refresh-icons'
];
const $56907fa85239d7b0$export$73a94df81a7c0f2c = [
    (flagKey)=>$56907fa85239d7b0$var$visualRefreshPlatformFlags.includes(flagKey),
    (0, $dCm1o.isVisualRefreshEnabled)
];

});

parcelRegister("95Orn", function(module, exports) {

$parcel$export(module.exports, "AtlaspackMetricsConnector", () => $b6ff4b948a92fab7$export$a0da2371f93e56de);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $fjcgS = parcelRequire("fjcgS");

var $7CMCs = parcelRequire("7CMCs");

var $g6GsR = parcelRequire("g6GsR");
function $b6ff4b948a92fab7$export$2e97bdb0a62c1cbf() {
    if (!(0, $4R6GH.fg)('atlaspack_runtime_metrics')) return ()=>{
    /**/ };
    const fn = async (event)=>{
        try {
            if (event.detail === undefined || !event.detail.action) return;
            const { action: action, attributes: attributes = {} } = event.detail;
            // Get client or wait for it to initialize
            const analyticsWebClient = await (0, $fjcgS.getAnalyticsWebClientPromise)();
            const analyticsClient = analyticsWebClient.getInstance();
            // Fire event
            analyticsClient.sendOperationalEvent({
                source: 'devinfra-app-framework',
                actionSubject: 'atlaspack',
                action: action,
                attributes: {
                    ...attributes,
                    ...(0, $g6GsR.pageContext)()
                }
            });
        } catch (error) {
        // Suppress
        }
    };
    globalThis.addEventListener('atlaspack:analytics', fn);
    return ()=>globalThis.removeEventListener('atlaspack:analytics', fn);
}
function $b6ff4b948a92fab7$var$AtlaspackMetricsConnectorInner() {
    (0, $5uXOq.useEffect)($b6ff4b948a92fab7$export$2e97bdb0a62c1cbf, [
        globalThis
    ]);
    return null;
}
function $b6ff4b948a92fab7$export$a0da2371f93e56de() {
    if (!(0, $4R6GH.fg)('atlaspack_runtime_metrics')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "atlaspack_runtime_metrics",
        packageName: "@atlassian/jira-atlaspack-global-metrics",
        fallback: "unmount",
        teamName: "devinfra-app-framework"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b6ff4b948a92fab7$var$AtlaspackMetricsConnectorInner, null));
}

});
parcelRegister("g6GsR", function(module, exports) {

$parcel$export(module.exports, "pageContext", () => $4ed3945fbf79d82f$export$bb8fabbb9eed884a);

var $cfDZ3 = parcelRequire("cfDZ3");
function $4ed3945fbf79d82f$export$bb8fabbb9eed884a() {
    return {
        routeName: $4ed3945fbf79d82f$var$getSafe(()=>(0, $cfDZ3.getUserLocation)()),
        userLocation: $4ed3945fbf79d82f$var$getSafe(()=>(0, $cfDZ3.getRouteName)()),
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        bundlerVersion: $4ed3945fbf79d82f$var$getSafe(()=>globalThis.BUNDLER_VERSION),
        buildVariant: $4ed3945fbf79d82f$var$getSafe(()=>globalThis.BUILD_VARIANT)
    };
}
function $4ed3945fbf79d82f$var$getSafe(fn) {
    try {
        return fn();
    } catch (error) {
        return 'unknown';
    }
}

});


parcelRegister("fg6X1", function(module, exports) {

$parcel$export(module.exports, "initEntryPointConfig", () => $a2d25b84ef5ddd7e$export$93a6801f9db838c4);

var $5uXOq = parcelRequire("5uXOq");

var $l8ruj = parcelRequire("l8ruj");

var $lfTZh = parcelRequire("lfTZh");

var $f1OUK = parcelRequire("f1OUK");

var $i2Rm5 = parcelRequire("i2Rm5");
const $a2d25b84ef5ddd7e$var$ModalErrorFallback = ({ error: error })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorFlagRenderer), {
        id: "",
        error: error
    });
};
function $a2d25b84ef5ddd7e$export$93a6801f9db838c4() {
    (0, $f1OUK.initEntryPointConfig)({
        PlaceholderComponent: ({ name: name, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
                name: name || '',
                ...props
            }),
        UFOSegmentComponent: (0, $l8ruj.default),
        ModalErrorFallback: $a2d25b84ef5ddd7e$var$ModalErrorFallback
    });
}

});

parcelRegister("2ChuC", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe3490a17e762431$export$2e2bcd8739ae039);

var $fr1K2 = parcelRequire("fr1K2");

var $6YRTH = parcelRequire("6YRTH");

var $j8DrX = parcelRequire("j8DrX");

var $7AZuS = parcelRequire("7AZuS");

var $7o9iL = parcelRequire("7o9iL");

const $fe3490a17e762431$var$renderEngagementMessages = ()=>{
    (parcelRequire("eiP3N"));
};

const $fe3490a17e762431$var$renderProfileCardNextLegacy = ()=>{
    (parcelRequire("7G8B8"));
};

const $fe3490a17e762431$var$renderHeartbeat = ()=>{
    (parcelRequire("5lRfW"));
};

const $fe3490a17e762431$var$loadUpFlowAPI = ()=>(parcelRequire("fmIai"));

const $fe3490a17e762431$var$installConnectModules = ()=>(parcelRequire("l1bfn"));
const $fe3490a17e762431$var$markSafeForAnalytics = (str)=>str || null;
const $fe3490a17e762431$var$renderSearchDwellTimeComponent = ()=>{
    const searchSessionId = (0, $j8DrX.default)('ajs-search-session-id');
    const containerId = (0, $j8DrX.default)('ajs-search-container-id');
    const objectId = (0, $j8DrX.default)('ajs-search-object-id');
    const objectType = (0, $j8DrX.default)('ajs-search-content-type');
    (0, $6YRTH.default)([
        'searchSessionId',
        'searchObjectId',
        'searchContainerId',
        'searchContentType'
    ]);
    (0, $7o9iL.default)('search-dwell-time', $fe3490a17e762431$var$markSafeForAnalytics(searchSessionId), {
        containerId: $fe3490a17e762431$var$markSafeForAnalytics(containerId),
        objectId: $fe3490a17e762431$var$markSafeForAnalytics(objectId),
        objectType: $fe3490a17e762431$var$markSafeForAnalytics(objectType),
        actionSubject: $fe3490a17e762431$var$markSafeForAnalytics(objectType),
        source: $fe3490a17e762431$var$markSafeForAnalytics(objectType)
    });
};
const $fe3490a17e762431$var$installHighPriorityApps = (args)=>{
    // @ts-expect-error - TS2304 - Cannot find name 'JiraContextContainer'.
    const priorityApps = [];
    if (args.flags) priorityApps.push((0, $7AZuS.renderFlags)());
    if (args.navigation) priorityApps.push(args.renderNavigation());
    return priorityApps;
};
const $fe3490a17e762431$var$installLowPriorityApps = (args)=>{
    if (args.upflow) $fe3490a17e762431$var$loadUpFlowAPI();
    if (args.profileCardNextLegacy) $fe3490a17e762431$var$renderProfileCardNextLegacy();
    if (args.connectModules) $fe3490a17e762431$var$installConnectModules();
    if (args.engagementMessages) $fe3490a17e762431$var$renderEngagementMessages();
    if (args.heartbeat) $fe3490a17e762431$var$renderHeartbeat();
    if (args.searchDwellTimeComponent) $fe3490a17e762431$var$renderSearchDwellTimeComponent();
};
const $fe3490a17e762431$var$installAppsWithPriorityOrder = async (args)=>{
    await Promise.all($fe3490a17e762431$var$installHighPriorityApps({
        flags: args.flags,
        navigation: args.navigation,
        renderNavigation: args.renderNavigation
    }));
    $fe3490a17e762431$var$installLowPriorityApps((0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(args, [
        'flags',
        'navigation',
        'renderNavigation'
    ]));
};
const $fe3490a17e762431$var$defaultArgs = {
    flags: true,
    navigation: true,
    upflow: true,
    profileCardNextLegacy: true,
    heartbeat: true,
    connectModules: true,
    engagementMessages: true,
    searchDwellTimeComponent: true,
    renderNavigation: ()=>null
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fe3490a17e762431$export$2e2bcd8739ae039 = {
    install: (args)=>{
        const argsWithDefaults = {
            ...$fe3490a17e762431$var$defaultArgs,
            ...args
        };
        // @ts-expect-error - TS2345 - Argument of type '{ flags: boolean; navigation: boolean; renderNavigation: (() => any) | (() => null); upflow: boolean; heartbeat: boolean; profileCardNextLegacy: boolean; connectModules: boolean; originTracing?: boolean | undefined; engagementMessages: boolean; searchDwellTimeComponent: boolean; }' is not assignable to parameter of type 'GlobalArgs'.
        $fe3490a17e762431$var$installAppsWithPriorityOrder(argsWithDefaults);
    },
    installHighPriorityApps: (args)=>{
        const { flags: flags, navigation: navigation, renderNavigation: renderNavigation } = {
            ...$fe3490a17e762431$var$defaultArgs,
            ...args
        };
        $fe3490a17e762431$var$installHighPriorityApps({
            flags: flags,
            navigation: navigation,
            renderNavigation: renderNavigation
        });
    },
    installLowPriorityApps: (args)=>{
        const installArgs = (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))({
            ...$fe3490a17e762431$var$defaultArgs,
            ...args
        }, [
            'flags',
            'navigation',
            'renderNavigation'
        ]);
        $fe3490a17e762431$var$installLowPriorityApps(installArgs);
    }
};

});
parcelRegister("7AZuS", function(module, exports) {

$parcel$export(module.exports, "renderFlags", () => $271711a34feab2aa$export$b6228dc14c5adf51);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $2YZCu = parcelRequire("2YZCu");

var $jsLXn = parcelRequire("jsLXn");

var $iNWLk = parcelRequire("iNWLk");

var $9F6Ii = parcelRequire("9F6Ii");

var $kxZPA = parcelRequire("kxZPA");
const $271711a34feab2aa$var$throwError = (message)=>{
    const error = new Error(message);
    (0, $2YZCu.default).safeErrorWithoutCustomerData('flags.entry', message, error);
    throw error;
};
const $271711a34feab2aa$var$getContainer = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    let container = document.getElementById('flags');
    if (container == null) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        container = document.createElement('div');
        container.id = 'flags';
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.body) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.body.appendChild(container);
        else $271711a34feab2aa$var$throwError('document.body was not found whilst trying to create the flags container');
    }
    return container;
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $271711a34feab2aa$var$Flags = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("5yFNi")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flag-app/src/main.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $271711a34feab2aa$var$AfterPaintFlags = (0, $kxZPA.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("5yFNi")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flag-app/src/main.tsx"
});
const $271711a34feab2aa$export$b6228dc14c5adf51 = ()=>(0, $7nsd3.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9F6Ii.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jsLXn.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: "flags-entry"
    }, __SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($271711a34feab2aa$var$AfterPaintFlags, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($271711a34feab2aa$var$Flags, null)))), $271711a34feab2aa$var$getContainer());

});
parcelRegister("5yFNi", function(module, exports) {

let $40c08c25e8e1a120$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $40c08c25e8e1a120$var$load("kNFvF"),
    $40c08c25e8e1a120$var$load("76n7a"),
    $40c08c25e8e1a120$var$load("l253H"),
    $40c08c25e8e1a120$var$load("ir5eQ")
]).then(()=>parcelRequire('3jTq3'));

});


parcelRegister("7o9iL", function(module, exports) {

$parcel$export(module.exports, "default", () => $87698987077682aa$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $9F6Ii = parcelRequire("9F6Ii");

var $TtQEC = parcelRequire("TtQEC");
const $87698987077682aa$var$getPlaceholder = (placeholderId)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const existingPlaceholder = document.getElementById(placeholderId);
    if (existingPlaceholder) return existingPlaceholder;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const div = document.createElement('div');
    div.id = placeholderId;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (document.body) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.body.appendChild(div);
    else throw new Error('document.body was not found whilst trying to create the dwell component placeholder.');
    return div;
};
const $87698987077682aa$var$renderDwellTimeComponent = (placeholder, sessionId, data = {})=>{
    if (placeholder && sessionId) (0, $7nsd3.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9F6Ii.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $TtQEC.default), {
        sessionId: sessionId,
        data: data
    })), $87698987077682aa$var$getPlaceholder(placeholder));
};
var $87698987077682aa$export$2e2bcd8739ae039 = $87698987077682aa$var$renderDwellTimeComponent;

});

parcelRegister("eiP3N", function(module, exports) {

let $a69a5aa44df15c8f$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $a69a5aa44df15c8f$var$load("ffQaD"),
    $a69a5aa44df15c8f$var$load("kvRbA"),
    $a69a5aa44df15c8f$var$load("76n7a"),
    $a69a5aa44df15c8f$var$load("l253H"),
    $a69a5aa44df15c8f$var$load("bhqkW")
]).then(()=>parcelRequire('2Q8el'));

});

parcelRegister("7G8B8", function(module, exports) {

let $597320059fde842d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $597320059fde842d$var$load("76n7a"),
    $597320059fde842d$var$load("l253H"),
    $597320059fde842d$var$load("ffQaD"),
    $597320059fde842d$var$load("kvRbA"),
    $597320059fde842d$var$load("kVX56"),
    $597320059fde842d$var$load("kNFvF"),
    $597320059fde842d$var$load("5p75f")
]).then(()=>parcelRequire('forzB'));

});

parcelRegister("5lRfW", function(module, exports) {

let $3e58397bdbe62c9a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3e58397bdbe62c9a$var$load("23xSi").then(()=>parcelRequire('8ymsB'));

});

parcelRegister("fmIai", function(module, exports) {

let $b2fb2b5ec4b4e0dd$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $b2fb2b5ec4b4e0dd$var$load("laA9U"),
    $b2fb2b5ec4b4e0dd$var$load("ffQaD"),
    $b2fb2b5ec4b4e0dd$var$load("kvRbA"),
    $b2fb2b5ec4b4e0dd$var$load("76n7a"),
    $b2fb2b5ec4b4e0dd$var$load("l253H"),
    $b2fb2b5ec4b4e0dd$var$load("3yAl4"),
    $b2fb2b5ec4b4e0dd$var$load("jbxE1"),
    $b2fb2b5ec4b4e0dd$var$load("7imUH"),
    $b2fb2b5ec4b4e0dd$var$load("5BNUw"),
    $b2fb2b5ec4b4e0dd$var$load("kGAgW"),
    $b2fb2b5ec4b4e0dd$var$load("kNFvF"),
    $b2fb2b5ec4b4e0dd$var$load("fliVL"),
    $b2fb2b5ec4b4e0dd$var$load("7mIf9"),
    $b2fb2b5ec4b4e0dd$var$load("jXweD"),
    $b2fb2b5ec4b4e0dd$var$load("kVX56"),
    $b2fb2b5ec4b4e0dd$var$load("ekY8E")
]).then(()=>parcelRequire('faPQm'));

});

parcelRegister("l1bfn", function(module, exports) {

let $f4d26a67013090c4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f4d26a67013090c4$var$load("5Ue7J").then(()=>parcelRequire('jEc6C'));

});


parcelRegister("dej7j", function(module, exports) {

$parcel$export(module.exports, "reportUnreportedStatsigInitialisationError", () => $26df27ecaeb1b244$export$3e2ed5f27f1cf2f1);

var $jcw0u = parcelRequire("jcw0u");

var $8ApFP = parcelRequire("8ApFP");

var $ouJAE = parcelRequire("ouJAE");
const $26df27ecaeb1b244$export$3e2ed5f27f1cf2f1 = ()=>{
    if (// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    globalThis.statsigInitialisationFixesPir24496Enabled === true && (0, $ouJAE.unreportedStatsigInitialisationError)) (0, $jcw0u.default)({
        error: (0, $ouJAE.unreportedStatsigInitialisationError),
        meta: {
            id: 'statsig-init-failure',
            teamName: 'uip-app-framework'
        },
        attributes: (0, $8ApFP.routeAnalyticsAttributes),
        skipSentry: false
    });
};

});

parcelRegister("dsKbf", function(module, exports) {

});


parcelRegister("594zW", function(module, exports) {

$parcel$export(module.exports, "startJiraSpa", () => $345aa43775a5b794$export$f71867a5b2484020);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $fr1K2 = parcelRequire("fr1K2");

var $3NMrl = parcelRequire("3NMrl");

var $kUr4d = parcelRequire("kUr4d");

var $fLxDC = parcelRequire("fLxDC");

var $kNF25 = parcelRequire("kNF25");

var $0z6W8 = parcelRequire("0z6W8");

var $1ciso = parcelRequire("1ciso");

var $a0hd6 = parcelRequire("a0hd6");

var $21pfT = parcelRequire("21pfT");

var $k4NnA = parcelRequire("k4NnA");

var $aTq2A = parcelRequire("aTq2A");


var $87OsA = parcelRequire("87OsA");
parcelRequire("2YzDH");

var $x9xyg = parcelRequire("x9xyg");

var $dn0m5 = parcelRequire("dn0m5");

var $4Pf62 = parcelRequire("4Pf62");

var $frBVt = parcelRequire("frBVt");

var $7CMCs = parcelRequire("7CMCs");

var $6s1PB = parcelRequire("6s1PB");

var $7bkFJ = parcelRequire("7bkFJ");

var $4R6GH = parcelRequire("4R6GH");

var $hL7JE = parcelRequire("hL7JE");

var $kZBXc = parcelRequire("kZBXc");

var $cfDZ3 = parcelRequire("cfDZ3");

var $6jY6G = parcelRequire("6jY6G");

var $9F6Ii = parcelRequire("9F6Ii");

var $81ezV = parcelRequire("81ezV");

var $b7awD = parcelRequire("b7awD");

var $d1K1f = parcelRequire("d1K1f");

var $2SVPM = parcelRequire("2SVPM");

var $fGcGc = parcelRequire("fGcGc");

var $bShz7 = parcelRequire("bShz7");

var $lbyb6 = parcelRequire("lbyb6");

var $5HG6S = parcelRequire("5HG6S");

var $29g8C = parcelRequire("29g8C");

var $kKlrY = parcelRequire("kKlrY");

var $l8ruj = parcelRequire("l8ruj");

var $3qHVS = parcelRequire("3qHVS");

var $lGgkA = parcelRequire("lGgkA");
var $ddkdN = parcelRequire("ddkdN");

var $2Gs5h = parcelRequire("2Gs5h");
var $lVJAU = parcelRequire("lVJAU");

var $lODMY = parcelRequire("lODMY");

var $1AZST = parcelRequire("1AZST");

var $95Orn = parcelRequire("95Orn");

var $fg6X1 = parcelRequire("fg6X1");

var $c1haS = parcelRequire("c1haS");

var $eOqwI = parcelRequire("eOqwI");

var $2ChuC = parcelRequire("2ChuC");

var $dej7j = parcelRequire("dej7j");
parcelRequire("dsKbf");
// Set SPA global
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
window.__SPA__ = true;

const $345aa43775a5b794$var$getMessages = ()=>{
    (0, $x9xyg.setMark)('jira-spa/language-pack.start');
    const messages = (parcelRequire("hWnRN"));
    (0, $x9xyg.setMark)('jira-spa/language-pack.end');
    return messages;
};
const $345aa43775a5b794$var$superbatchInit = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.DeferScripts = {
        deferState: 'done'
    };
    if ((0, $4R6GH.fg)('remove_deferred_class_remove')) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    {
        if (document.body?.classList.contains('deferred')) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.body?.classList.remove('deferred');
    } else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.body?.classList.remove('deferred');
};
const $345aa43775a5b794$var$globalSettingsArgs = {
    navigation: false,
    upflow: false
};
const $345aa43775a5b794$var$InstallGlobalComponentsOnce = ()=>{
    (0, $5uXOq.useEffect)(()=>{
        (0, $2ChuC.default).installLowPriorityApps(// @ts-expect-error - TS2345 - Argument of type 'Partial<{ readonly navigation: false; readonly upflow: false; }>' is not assignable to parameter of type 'LowPriorityAppsArgs'.
        (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))($345aa43775a5b794$var$globalSettingsArgs, [
            'flags',
            'navigation',
            'renderNavigation'
        ]));
        (0, $x9xyg.setMark)('JIRA_SPA_ENTRY_GLOBAL_INSTALL');
    }, []);
    return null;
};
const $345aa43775a5b794$var$updateCapability = (capability)=>{
    (0, $87OsA.setCapability)(capability);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (capability === null && window.AJS?.$?.ajaxSettings?.headers?.[0, $281cbd47ba46dd7d$export$9a80695e72849f84]) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    delete window.AJS.$.ajaxSettings.headers[0, $281cbd47ba46dd7d$export$9a80695e72849f84];
    else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.AJS?.$?.ajaxSetup({
        headers: {
            [(0, $281cbd47ba46dd7d$export$9a80695e72849f84)]: capability
        }
    });
};
// @ts-expect-error - TS7031 - Binding element 'routes' implicitly has an 'any' type.
const $345aa43775a5b794$var$CapabilityTrackerConnector = ({ routes: routes })=>{
    const { registerBlock: registerBlock } = (0, $lVJAU.useRouterActions)();
    registerBlock((nextLocation)=>{
        const nextMatchObject = (0, $2Gs5h.default)(routes, nextLocation.pathname, nextLocation.search, '');
        $345aa43775a5b794$var$updateCapability(nextMatchObject?.route.meta?.capability || null);
        return true;
    });
    const route = (0, $6jY6G.useCurrentRoute)();
    $345aa43775a5b794$var$updateCapability(route.meta?.capability || null);
    return null;
};
const $345aa43775a5b794$var$main = async (getInitialRoutes, loadLazyRoutes)=>{
    (0, $x9xyg.setMark)('_jira-spa/main-start');
    const deps = new (0, $dn0m5.SpaBootstrapDependencies)(window);
    // This guarantees we can wait until our dependencies arrive.
    // It's not ideal, because we're blocking immediately upon starting up the SPA.
    // From here the game is to move these promises as far down in to the control flow as possible.
    (0, $x9xyg.setMark)('_jira-spa/main-before-early-deps');
    await Promise.allSettled([
        deps.statsigValues(),
        deps.launchDarklyValues(),
        deps.tenantContext()
    ]);
    (0, $x9xyg.setMark)('_jira-spa/main-after-early-deps');
    (0, $kKlrY.default)();
    (0, $aTq2A.initBrowserMetrics3)();
    (0, $7bkFJ.initPlatformFeatureFlags)((0, $3qHVS.visualRefreshResolverOverride));
    (0, $fg6X1.initEntryPointConfig)();
    (0, $fGcGc.addInitialPageLoadTimings)();
    (0, $eOqwI.getClientReceiver)();
    (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/init', 'jira-spa.js:eval-start');
    (0, $x9xyg.setMark)('jira-spa/setup.start');
    const routes = (0, $2SVPM.measureInitialPageLoadTiming)('jira-spa/setup/routes', ()=>getInitialRoutes());
    const history = (0, $2SVPM.measureInitialPageLoadTiming)('jira-spa/setup/history', ()=>(0, $lbyb6.default)(routes));
    const initRoute = (0, $2SVPM.measureInitialPageLoadTiming)('jira-spa/setup/match-route', ()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const matchedRoute = (0, $2Gs5h.default)(routes, window.location.pathname, window.location.search);
        (0, $cfDZ3.setMatchedRoute)(matchedRoute?.route, matchedRoute?.match);
        return matchedRoute;
    });
    if (initRoute != null) {
        const ufoName = (0, $fLxDC.default)(initRoute.route);
        (0, $0z6W8.default)(ufoName, initRoute.route.name);
    }
    const BrowserMetricsConnector = ()=>{
        const route = (0, $6jY6G.useCurrentRoute)();
        (0, $21pfT.browserMetrics).setRoute(route.name);
        (0, $1ciso.useUFOTransitionCompleter)();
        (0, $1AZST.GlobalPageLoadExperience).setPageLoadId(route.perfMetricKey || 'UNKNOWN');
        return null;
    };
    const messages = $345aa43775a5b794$var$getMessages();
    const tenantContext = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const { locale: locale } = tenantContext;
    let routerProps;
    const getRouterProps = (resourceData)=>{
        return {
            history: history,
            routes: routes,
            basePath: '',
            initialRoute: initRoute?.route,
            resourceData: resourceData,
            resourceContext: (0, $5HG6S.getSpaRouterContext)({
                tenantContext: tenantContext
            }),
            onPrefetch: ({ route: route, match: match })=>{
                (0, $bShz7.setPrefetchStartMark)(match);
                if (!route.forPaint) return;
                route.forPaint.map((component)=>component.preload?.());
            },
            isLazyRoutes: typeof loadLazyRoutes === 'function'
        };
    };
    let SpaClientRouter;
    if (typeof loadLazyRoutes === 'function') {
        const useRouterRoutes = (0, $lODMY.createRouterSelector)((state)=>state.routes);
        SpaClientRouter = ({ children: children })=>{
            const actions = (0, $lODMY.useRouterStoreActions)();
            const currentRoutes = useRouterRoutes();
            (0, $5uXOq.useEffect)(()=>{
                let isCancelled = false;
                const loadRoutes = async ()=>{
                    if (!isCancelled) {
                        const getLazyRoutes = await loadLazyRoutes();
                        await actions.setRoutes(getLazyRoutes());
                    }
                };
                loadRoutes();
                return ()=>{
                    isCancelled = true;
                };
            }, [
                actions
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b7awD.Router), routerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
                id: "spa-main.client-router",
                packageName: "jiraEntry",
                fallback: "unmount",
                teamName: "delorean-spa"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $95Orn.AtlaspackMetricsConnector), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BrowserMetricsConnector, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($345aa43775a5b794$var$CapabilityTrackerConnector, {
                routes: currentRoutes
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d1K1f.default), null)), children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hL7JE.NonCritical), {
                id: "spa-main.client-router.non-critical",
                teamName: "delorean-spa"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($345aa43775a5b794$var$InstallGlobalComponentsOnce, null)));
        };
    } else SpaClientRouter = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b7awD.Router), routerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
            id: "spa-main.client-router",
            packageName: "jiraEntry",
            fallback: "unmount",
            teamName: "delorean-spa"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $95Orn.AtlaspackMetricsConnector), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BrowserMetricsConnector, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($345aa43775a5b794$var$CapabilityTrackerConnector, {
            routes: routes
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d1K1f.default), null)), children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hL7JE.NonCritical), {
            id: "spa-main.client-router.non-critical",
            teamName: "delorean-spa"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($345aa43775a5b794$var$InstallGlobalComponentsOnce, null)));
    const App = ({ placeholders: placeholders })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9F6Ii.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
            name: "jira-spa"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $frBVt.EntryPointPlaceholderContext).Provider, {
            value: placeholders
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZBXc.Spa), {
            baseUrl: "",
            locale: locale,
            messages: messages,
            Router: SpaClientRouter,
            initRoute: initRoute,
            routes: routes,
            routerLinkComponent: (0, $81ezV.JiraRouterLinkConfiguration)
        }))));
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__NAV_VERSION__ = '3.0.0';
    (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/setup', 'jira-spa/setup.start', true);
    (0, $x9xyg.setMark)('_jira-spa/spa-shell.start');
    // This function is normally run as soon as the SSR service flushes the DOM element containing the server-rendered HTML.
    // There some conditions in which it could or should be re-run...
    // (1) The SSR service reports a hard failure,
    // (2) The SSR response is taking too long to flush (a soft failure), or
    // (3) Something goes wrong during running the function itself.
    // In any of these cases, the client can choose to run this function again to attempt a recovery.
    const renderSpa = ({ didSsrRenderSpa: didSsrRenderSpa, container: container, spaState: spaState })=>{
        (0, $x9xyg.setMark)('_jira-spa/render-spa-fn-start');
        // Notify whether there was a complete SSR success or if there were render problems.
        (0, $1AZST.GlobalPageLoadExperience).addMetadata({
            didSsrRenderSpa: didSsrRenderSpa
        });
        // SPA_STATE is untyped, but we have passed it in to Router like this for ages and nobody complained.
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        routerProps = getRouterProps(spaState);
        (0, $a0hd6.getVCObserver)().setSSRElement(container);
        (0, $a0hd6.getVCObserver)().setReactRootRenderStart();
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                (0, $a0hd6.getVCObserver)().setReactRootRenderStop();
            });
        });
        if ((0, $4R6GH.fg)('jira-spa-bootstrap-changes-2025-03-05')) (0, $lGgkA.LooselyLazy).init({
            mode: (0, $4R6GH.fg)('jfp_magma_jira-rll-hydrate') ? (0, $ddkdN.MODE).HYDRATE : (0, $ddkdN.MODE).RENDER,
            crossOrigin: 'anonymous',
            react18: (0, $4R6GH.fg)('jfp_magma_jira-rll-react-18-render'),
            usePostTaskPhases: (0, $4R6GH.fg)('jfp-jira-remove-rll-subscriptions'),
            trackDuplicateLazyIds: (0, $4R6GH.fg)('jfp-magma-rll-track-duplicated-lazy-ids'),
            htmlPlaceholders: (0, $4R6GH.fg)('jfp_magma_jira-rll-html-placeholder'),
            markedForPreload: (0, $4R6GH.fg)('jfp_magma_jira-rll-client-preload') ? // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.SPA_STATE?.rll_preload : undefined
        });
        const placeholders = (0, $frBVt.getPlaceholdersFromHTML)();
        (0, $kNF25.collectSSRPlaceholderDimensions)(document, window, (0, $4R6GH.fg)('enable_page_layout_placeholder'));
        const isConcurrentEnabled = (0, $c1haS.getIsConcurrentEnabled)();
        const renderOldWithoutHydrateRoot = ()=>{
            // if the feature flag is false, do not opt into concurrent features
            // if the local env var is not set, or set to false, do not opt into concurrent features
            if (!isConcurrentEnabled) (0, $7nsd3.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(App, {
                placeholders: placeholders
            }), container);
            if (isConcurrentEnabled) {
                const root = (0, $kUr4d.createRoot)(container);
                root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(App, {
                    placeholders: placeholders
                }), (0, $4R6GH.fg)('concurrent-rendering-change-advisory') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $29g8C.ConcurrentAdvisory), {
                    consoleMessage: "This entire site is being rendered with React concurrent rendering go/r18"
                }) : null));
            }
        };
        // TODO after ff clean up - pull this out to a file so we don't have to save on duplication effort.
        const renderNewWithHydrateRoot = ()=>{
            const renderNonConcurrent = ()=>{
                (0, $7nsd3.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(App, {
                    placeholders: placeholders
                }), container);
            };
            const ConcurrentSpaApp = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(App, {
                    placeholders: placeholders
                }), (0, $4R6GH.fg)('concurrent-rendering-change-advisory') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $29g8C.ConcurrentAdvisory), {
                    consoleMessage: "This entire site is being rendered with React concurrent rendering go/r18"
                }) : null);
            const renderConcurrentWithoutHydration = ()=>{
                const root = (0, $kUr4d.createRoot)(container);
                root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ConcurrentSpaApp, null));
            };
            const renderWithHydrateConcurrent = ()=>{
                (0, $kUr4d.hydrateRoot)(container, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ConcurrentSpaApp, null));
            };
            if (initRoute?.route?.isHydrateRootEnabled) // hydratRoot also enables concurrent mode, if you enable hydration on your route. It's also assumed you want and understand concurrent mode.
            renderWithHydrateConcurrent();
            else if (isConcurrentEnabled) // If the route is not enabled for hydration but concurrent mode is enabled for this environment, render in concurrent mode
            renderConcurrentWithoutHydration();
            else // if the feature flag is false, do not opt into concurrent features
            // if the local env var is not set, or set to false, do not opt into concurrent features
            renderNonConcurrent();
        };
        if ((0, $4R6GH.fg)('jfp-magma-incremental-hydrate-root')) renderNewWithHydrateRoot();
        else renderOldWithoutHydrateRoot();
        (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/spa-shell', '_jira-spa/spa-shell.start');
        (0, $x9xyg.setMark)('JIRA_SPA_ENTRY_REACT_DOM_RENDER');
        if ((0, $6s1PB.expVal)('uip_preprod_slow', 'value', 0) > 0) {
            (0, $x9xyg.setMark)('slow-start');
            const end = performance.now() + (0, $6s1PB.expVal)('uip_preprod_slow', 'value', 0);
            while(performance.now() < end);
            (0, $x9xyg.setMark)('slow-stop');
        }
        (0, $2ChuC.default).installHighPriorityApps(// @ts-expect-error - TS2345 - Argument of type 'Partial<{ readonly navigation: false; readonly upflow: false; }>' is not assignable to parameter of type 'HighPriorityAppsArgs'.
        (0, (/*@__PURE__*/$parcel$interopDefault($3NMrl)))($345aa43775a5b794$var$globalSettingsArgs, [
            'flags',
            'navigation',
            'renderNavigation'
        ]));
        $345aa43775a5b794$var$superbatchInit();
        // Post-initialisation, post-render timings
        setTimeout(()=>{
            (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa', 'commons-entry.js:eval-stop', 'jira-spa.js:eval-stop');
            (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa/early-deps-delay', '_jira-spa/main-before-early-deps', '_jira-spa/main-after-early-deps');
            (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa/dom-deps-delay', '_jira-spa/main-before-dom-deps', '_jira-spa/main-after-dom-deps');
            (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa/render-spa-fn', '_jira-spa/render-spa-fn-start', '_jira-spa/render-spa-fn-stop');
        });
        (0, $x9xyg.setMark)('_jira-spa/render-spa-fn-stop');
    };
    // This is where we actually begin the rendering process by awaiting our dependencies.
    (0, $x9xyg.setMark)('_jira-spa/main-before-dom-deps');
    return Promise.all([
        deps.didSsrRenderSpa(),
        deps.domElement(),
        deps.spaState()
    ]).then(([didSsrRenderSpa, container, spaState])=>{
        (0, $x9xyg.setMark)('_jira-spa/main-after-dom-deps');
        renderSpa({
            didSsrRenderSpa: didSsrRenderSpa,
            container: container,
            spaState: spaState
        });
    }, (error)=>{
        (0, $x9xyg.setMark)('jira-spa/main-dom-deps-error');
        (0, $1AZST.GlobalPageLoadExperience).addMetadata({
            initialRenderError: error
        });
        // Attempt a graceful recovery on the client side by rendering the whole app ourselves.
        // If we're on the server, bail immediately.
        if (false) throw error;
        /* eslint-disable jira/jira-ssr/no-unchecked-globals-usage */ let el = document.getElementById('jira-frontend');
        if (!el) {
            // Hide the server-provided `jira-frontend` element. The server + network might be slow, so
            // it may still arrive from the server... but by that time we will be rendering ourselves,
            // so we want to avoid the browser rendering anything inside it.
            const style = document.createElement('style');
            style.textContent = '#jira-frontend ~ #jira-frontend { display:none !important; }';
            document.body.appendChild(style);
            // Create a new fallback container to render the app inside.
            el = document.createElement('div');
            el.setAttribute('id', 'jira-frontend');
            el.setAttribute('data-spa-element', 'client');
            document.body.appendChild(el);
        } else el.setAttribute('data-spa-element', 'server');
        el.setAttribute('data-spa-retry', '');
        // Render the app.
        renderSpa({
            didSsrRenderSpa: false,
            container: el,
            spaState: undefined
        });
    /* eslint-enable jira/jira-ssr/no-unchecked-globals-usage */ });
};
const $345aa43775a5b794$export$f71867a5b2484020 = async (getInitialRoutes, loadLazyRoutes)=>{
    if (!(0, $4R6GH.fg)('jira-spa-bootstrap-changes-2025-03-05')) (0, $lGgkA.LooselyLazy).init({
        mode: (0, $4R6GH.fg)('jfp_magma_jira-rll-hydrate') ? (0, $ddkdN.MODE).HYDRATE : (0, $ddkdN.MODE).RENDER,
        crossOrigin: 'anonymous',
        react18: (0, $4R6GH.fg)('jfp_magma_jira-rll-react-18-render'),
        usePostTaskPhases: (0, $4R6GH.fg)('jfp-jira-remove-rll-subscriptions'),
        trackDuplicateLazyIds: (0, $4R6GH.fg)('jfp-magma-rll-track-duplicated-lazy-ids'),
        htmlPlaceholders: (0, $4R6GH.fg)('jfp_magma_jira-rll-html-placeholder'),
        markedForPreload: (0, $4R6GH.fg)('jfp_magma_jira-rll-client-preload') ? // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.SPA_STATE?.rll_preload : undefined
    });
    (0, $1AZST.GlobalPageLoadExperience).startPageLoad('UNKNOWN', true);
    return $345aa43775a5b794$var$main(getInitialRoutes, loadLazyRoutes).catch((reason)=>{
        (0, $1AZST.GlobalPageLoadExperience).failure();
        return (0, $k4NnA.reportBootstrapError)(reason);
    }).finally(()=>{
        (0, $dej7j.reportUnreportedStatsigInitialisationError)();
    });
};

});
parcelRegister("dn0m5", function(module, exports) {

$parcel$export(module.exports, "SpaBootstrapDependencies", () => $f0440b069d03fdc9$export$a6c58ffe0a3c3ff3);

var $4Pf62 = parcelRequire("4Pf62");

var $y7eb2 = parcelRequire("y7eb2");

var $1zAKS = parcelRequire("1zAKS");
const $f0440b069d03fdc9$var$POLLING_INTERVAL_MS = 30;
async function $f0440b069d03fdc9$var$testForThingWithTimeout(testFn, timeoutMs = 5000) {
    const startTime = Date.now();
    let result;
    return new Promise((resolve, reject)=>{
        try {
            result = testFn();
        } catch (e) {
            reject(e);
        }
        if (result) return resolve(result);
        const interval = setInterval(()=>{
            if (Date.now() - startTime >= timeoutMs) {
                clearInterval(interval);
                return reject();
            }
            try {
                result = testFn();
            } catch (e) {
                reject(e);
            }
            if (result) {
                clearInterval(interval);
                resolve(result);
            }
        }, $f0440b069d03fdc9$var$POLLING_INTERVAL_MS);
    });
}
class $f0440b069d03fdc9$export$a6c58ffe0a3c3ff3 {
    #windowObject;
    #timeoutMs;
    constructor(window, timeoutMs = 5000){
        this.window = window;
        this.timeoutMs = timeoutMs;
        this.#windowObject = window;
        this.#timeoutMs = timeoutMs;
    }
    domElement(timeoutMs = 15000) {
        return $f0440b069d03fdc9$var$testForThingWithTimeout(()=>{
            if (this.#windowObject.document.readyState === 'complete') throw new Error('Element will not arrive from server');
            return this.#windowObject.document.getElementById('jira-frontend');
        }, timeoutMs || this.#timeoutMs).catch(()=>{
            throw Error('Could not locate jira-frontend element');
        });
    }
    didSsrRenderSpa() {
        return $f0440b069d03fdc9$var$testForThingWithTimeout(()=>'__SSR_FALLBACK__' in this.#windowObject || this.#windowObject.SSR_DETAILS && 'spa_state_written' in this.#windowObject.SSR_DETAILS || 'SPA_STATE' in this.#windowObject).then(()=>Boolean(this.#windowObject.SPA_STATE) || Boolean(this.#windowObject.SSR_DETAILS?.spa_state_written) || false).catch(()=>false);
    }
    spaState() {
        return this.didSsrRenderSpa().then(()=>this.#windowObject.SPA_STATE).catch(()=>undefined);
    }
    statsigValues() {
        return $f0440b069d03fdc9$var$testForThingWithTimeout((0, $1zAKS._haveValuesArrived), this.#timeoutMs).catch(()=>{
            throw Error('Could not locate Statsig values');
        });
    }
    launchDarklyValues() {
        return $f0440b069d03fdc9$var$testForThingWithTimeout((0, $y7eb2._haveValuesArrived), this.#timeoutMs).catch(()=>{
            throw Error('Could not locate LaunchDarkly values');
        });
    }
    /** @deprecated using tenant context and meta tags is a bad data access pattern that we want to see disappear. */ tenantContext() {
        return $f0440b069d03fdc9$var$testForThingWithTimeout((0, $4Pf62._haveValuesArrived), this.#timeoutMs).catch(()=>{
            throw Error('Could not locate tenant context values');
        });
    }
}

});


$parcel$global.rwr("f2CmZ", () => { parcelRequire("lRSO6");
parcelRequire("8oLfs");

var $x9xyg = parcelRequire("x9xyg");

var $VVnlL = parcelRequire("VVnlL");

var $gGB8S = parcelRequire("gGB8S");

var $594zW = parcelRequire("594zW");
(0, $x9xyg.setMark)('JIRA_SPA_ENTRY_LOADED');
// It is easier to make the check against window than it is to make typescript happy here.
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
if (!false && typeof window !== 'undefined' && window.__SPA_BOOTSTRAP_ALT) (0, $594zW.startJiraSpa)((0, $VVnlL.getSpaRoutes));
else (0, $gGB8S.startJiraSpa)((0, $VVnlL.getSpaRoutes));
 }, ["kVX56","jXweD","7mIf9","fliVL","kNFvF","kGAgW","5BNUw","7imUH","jbxE1","3yAl4","kvRbA","ffQaD","l253H","76n7a","hij3B"].concat([...(globalThis.__MCOND && globalThis.__MCOND('blu-6347-app-switcher-ep') ? ["wGeTa","kNFvF"] : ["aAL7s","kNFvF","kvRbA","ffQaD"]),...(globalThis.__MCOND && globalThis.__MCOND('nav_help_icon_vc90_top_offender_improvements') ? ["go51F"] : ["h9Yss"]),...(globalThis.__MCOND && globalThis.__MCOND('edition_awareness_upsell_jira_ab_fg') ? ["dN2wc","dN2wc"] : ["elkip","elkip"]),...(globalThis.__MCOND && globalThis.__MCOND('jira-concurrent-update-while-rendering') ? ["2bWif"] : ["5qGhd"])]));
// error types
const $4cff3ad70ea80f75$export$6c8cb487d6ffc522 = 'QueryError';
const $4cff3ad70ea80f75$export$b171488d52070cb3 = 'JiraIssueFieldUnsupportedErrorExtension';
const $4cff3ad70ea80f75$export$14b50ab9fbf2d370 = 'JiraIssueFieldValueValidationErrorExtension';
const $4cff3ad70ea80f75$export$3d1cda9bd50505e8 = 'SERVICE_REQUEST';
const $4cff3ad70ea80f75$export$48c144830383423 = 'INCIDENT_MANAGEMENT';
const $4cff3ad70ea80f75$export$1ea6ead7bcee4494 = 'PROBLEM_MANAGEMENT';
const $4cff3ad70ea80f75$export$b92ccb6dc3cdb548 = 'CHANGE_MANAGEMENT';
const $4cff3ad70ea80f75$export$a4a741b969f6509c = 'POST_INCIDENT_REVIEW';
const $4cff3ad70ea80f75$export$81e62964cc725098 = 'DEVELOPER_ESCALATION';
const $4cff3ad70ea80f75$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $4cff3ad70ea80f75$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $4cff3ad70ea80f75$export$c835df30ebbd529d = 'UNASSIGNED_REQUEST_TYPE';


$parcel$global.rlb("f2CmZ")
//# sourceMappingURL=jira-spa.c3e1ca76.js.map
